
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("2D4FF", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $0b1b6a0f62a5c073$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
parcelRequire("9nlEk");

var $kedeO = parcelRequire("kedeO");

var $7QscL = parcelRequire("7QscL");

var $7DEW6 = parcelRequire("7DEW6");
var $iEgm6 = parcelRequire("iEgm6");

var $fWkFY = parcelRequire("fWkFY");

var $0cdA8 = parcelRequire("0cdA8");

var $jMP2a = parcelRequire("jMP2a");
var $jzkzF = parcelRequire("jzkzF");

var $jD3pk = parcelRequire("jD3pk");

var $atRHQ = parcelRequire("atRHQ");

var $51ACp = parcelRequire("51ACp");

var $dxcfv = parcelRequire("dxcfv");

var $4rWQe = parcelRequire("4rWQe");

var $dWLk9 = parcelRequire("dWLk9");

var $3e9vj = parcelRequire("3e9vj");

var $jK1pm = parcelRequire("jK1pm");

var $lB25E = parcelRequire("lB25E");

var $5J8ej = parcelRequire("5J8ej");

var $eAV6h = parcelRequire("eAV6h");
const $0b1b6a0f62a5c073$var$onExternalSentryEvent = (callback)=>(0, $kedeO.addGlobalEventProcessor)((event)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        callback(event);
        return event;
    });
const $0b1b6a0f62a5c073$var$EMCEE_BASE_PATHNAME = '/jira/marketplace';
const $0b1b6a0f62a5c073$var$onRouteTransitionEnd = ()=>{
    (0, $eAV6h.emceePageLoad).stop();
    (0, $5J8ej.addApdexToAll)({
        key: (0, $eAV6h.emceePageLoad).key,
        stopTime: performance.now()
    });
};
const $0b1b6a0f62a5c073$var$EmbeddedMarketplaceApp = ({ history: history })=>{
    const cloudId = (0, $dWLk9.useCloudId)();
    const environment = (0, $3e9vj.useEnvironment)();
    const { data: orgId } = (0, $jD3pk.useOrgId)();
    const activationId = (0, $4rWQe.useActivationId)();
    const applicationConfig = (0, $iEgm6.getApplicationConfigForEnv)(environment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7DEW6.default), {
        spi: (0, $7QscL.default)({
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            baseUrl: window.location.origin,
            product: 'jira',
            cloudId: cloudId,
            environment: environment,
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            gqlGatewayUrl: `${window.location.origin}/gateway/api/graphql`,
            activationId: activationId,
            orgId: orgId
        }),
        history: history,
        applicationConfig: applicationConfig,
        productVersion: window.BUILD_KEY,
        mountPath: $0b1b6a0f62a5c073$var$EMCEE_BASE_PATHNAME,
        onRouteTransitionEnd: $0b1b6a0f62a5c073$var$onRouteTransitionEnd,
        onExternalSentryEvent: $0b1b6a0f62a5c073$var$onExternalSentryEvent
    });
};
const $0b1b6a0f62a5c073$var$MarketplaceShell = ()=>{
    const loggedInUserAccountId = (0, $dxcfv.useAccountId)();
    const [{ location: location }] = (0, $lB25E.useRouter)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jzkzF.useAnalyticsEvents)();
    if (!loggedInUserAccountId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fWkFY.default), null);
     // Append hash fragment to the existing pathname for the new emcee native URL
    if (location.hash && location.hash.includes('#!')) {
        const newPath = location.pathname + location.hash.split('#!')[1];
        const redirectAttributes = {
            previousPath: location.pathname + location.search + location.hash,
            newPath: newPath
        };
        (0, $jMP2a.fireUIAnalytics)(createAnalyticsEvent({
            action: 'redirected',
            actionSubject: 'emcee-route',
            actionSubjectId: 'MarketplaceShell'
        }), redirectAttributes);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atRHQ.ScreenRedirect), {
            to: newPath,
            persistSearchParams: false
        });
    }
    (0, $eAV6h.emceePageLoad).start();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jK1pm.default), {
        name: "embedded-marketplace"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b1b6a0f62a5c073$var$MarketplaceContainer, {
        id: "emcee"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $0cdA8.JSErrorBoundary), {
        id: "embeddedMarketplace",
        packageName: "jiraSpaAppsMarketplace",
        teamName: "marketplace"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $51ACp.HistoryAdapter), null, (history)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($0b1b6a0f62a5c073$var$EmbeddedMarketplaceApp, {
            history: history
        })))));
};
var $0b1b6a0f62a5c073$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $0b1b6a0f62a5c073$var$MarketplaceShell;
const $0b1b6a0f62a5c073$var$MarketplaceContainer = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7QscL", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b63449f55e56987$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bwnaU = parcelRequire("bwnaU");

var $7jpYj = parcelRequire("7jpYj");

var $d1veh = parcelRequire("d1veh");

var $7tJ3W = parcelRequire("7tJ3W");

var $4J2mT = parcelRequire("4J2mT");

var $lpNoO = parcelRequire("lpNoO");
function $5b63449f55e56987$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5b63449f55e56987$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5b63449f55e56987$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5b63449f55e56987$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $5b63449f55e56987$export$2e2bcd8739ae039 = (config)=>$5b63449f55e56987$var$_objectSpread($5b63449f55e56987$var$_objectSpread($5b63449f55e56987$var$_objectSpread($5b63449f55e56987$var$_objectSpread($5b63449f55e56987$var$_objectSpread($5b63449f55e56987$var$_objectSpread({}, (0, $bwnaU.default)(config)), (0, $d1veh.default)(config)), (0, $7jpYj.default)(config)), (0, $7tJ3W.default)(config)), (0, $4J2mT.default)(config)), (0, $lpNoO.default)(config));

});
parcelRegister("bwnaU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8634a8e970498002$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $je2Cw = parcelRequire("je2Cw");

var $lLYAL = parcelRequire("lLYAL");

var $9z6QH = parcelRequire("9z6QH");

var $1w7m1 = parcelRequire("1w7m1");

var $cVLrH = parcelRequire("cVLrH");
var $i0EDR = parcelRequire("i0EDR");

var $bTrQR = parcelRequire("bTrQR");

var $gQV53 = parcelRequire("gQV53");

var $axFWr = parcelRequire("axFWr");

var $6poH2 = parcelRequire("6poH2");

var $QaRKt = parcelRequire("QaRKt");

var $dDuCy = parcelRequire("dDuCy");

var $c0juV = parcelRequire("c0juV");

var $56eyA = parcelRequire("56eyA");
var $8634a8e970498002$var$_class;
const $8634a8e970498002$var$isInstallable = (upmAvailableApp)=>upmAvailableApp.remoteInstallable || upmAvailableApp.preinstalled;
async function $8634a8e970498002$var$_getInstalledAddonInternal(addonId, environment, upmBaseUrl, gqlGatewayUrl, getInstalledAddonFlags) {
    const shouldRetryForLicenseDetails = getInstalledAddonFlags === null || getInstalledAddonFlags === void 0 ? void 0 : getInstalledAddonFlags.retryForLicenseDetails;
    const [marketplaceApp, upmInstalledApp, installedMarketplacePlugin] = await Promise.all([
        (0, $QaRKt.getRawCloudMarketplaceAppByKey)((0, $c0juV.makeAppKey)(addonId.key), gqlGatewayUrl),
        (0, $56eyA.getInstalledAppFromUpm)(upmBaseUrl, addonId.key),
        (0, $56eyA.getInstalledMarketplacePluginFromUpm)(upmBaseUrl, addonId.key, shouldRetryForLicenseDetails)
    ]);
    return (0, $gQV53.toInstalledAddon)(marketplaceApp, upmInstalledApp, installedMarketplacePlugin, environment).fold((l)=>Promise.reject(l), (installedAddon)=>installedAddon);
}
function $8634a8e970498002$var$getAllInstalledAppsFromMarketplace(upmBaseUrl, upmInstalledApps, gqlGatewayUrl) {
    return upmInstalledApps.map((upmInstalledApp)=>(0, $QaRKt.getRawCloudMarketplaceAppByKey)(upmInstalledApp.key, gqlGatewayUrl).catch((error)=>error));
}
async function $8634a8e970498002$var$getAllInstalledAddonsInternal(environment, upmBaseUrl, gqlGatewayUrl) {
    const [upmInstalledApps, installedMarketplaceResponse] = await Promise.all([
        (0, $56eyA.getAllInstalledAppsFromUpm)(upmBaseUrl),
        (0, $56eyA.getInstalledMarketplaceFromUpm)(upmBaseUrl)
    ]);
    const marketplaceApps = await Promise.all($8634a8e970498002$var$getAllInstalledAppsFromMarketplace(upmBaseUrl, upmInstalledApps, gqlGatewayUrl));
    const installedMarketplacePlugins = (0, $gQV53.arrayToMap)(installedMarketplaceResponse.plugins, (app)=>app.key);
    const marketplaceAppsMap = (0, $gQV53.arrayToMap)(marketplaceApps, (app)=>app.appKey);
    const installedAddons = upmInstalledApps.reduce((acc, upmInstalledApp)=>{
        const installedMarketplacePlugin = installedMarketplacePlugins[upmInstalledApp.key];
        const marketplaceApp = marketplaceAppsMap[upmInstalledApp.key];
        if (marketplaceApp && installedMarketplacePlugin) return [
            ...acc,
            ...(0, $gQV53.toInstalledAddon)(marketplaceApp, upmInstalledApp, installedMarketplacePlugin, environment).map((ia)=>[
                    ia
                ]).getOrElse([])
        ];
        else {
            console.error("Marketplace API or Installed Marketplace API didn't return a response for ".concat(upmInstalledApp.key));
            return acc;
        }
    }, []);
    return installedAddons;
}
let $8634a8e970498002$var$Addons = ($8634a8e970498002$var$_class = class Addons {
    constructor(config){
        (0, $5zQU9.default)(this, "config", void 0);
        (0, $5zQU9.default)(this, "upmBaseUrl", void 0);
        this.config = config;
        this.upmBaseUrl = this.config.baseUrl;
    }
    async getInstalledAddons(_options) {
        const environment = (0, $6poH2.default)(this.config);
        const allInstalledAddonsInternalPromise = $8634a8e970498002$var$getAllInstalledAddonsInternal(environment, this.upmBaseUrl, this.config.gqlGatewayUrl);
        const allInstalledEcosystemCloudAppsPromise = (0, $QaRKt.fetchAllInstalledEcosystemCloudApps)(this.config, _options.flags);
        return Promise.allSettled([
            allInstalledAddonsInternalPromise,
            allInstalledEcosystemCloudAppsPromise
        ]).then((_ref)=>{
            let [allInstalledAddonsInternalResponse, allInstalledEcosystemCloudAppsResponse] = _ref;
            const allInstalledAddonsInternal = allInstalledAddonsInternalResponse.status === 'fulfilled' ? allInstalledAddonsInternalResponse.value : [];
            const allInstalledEcosystemCloudApps = allInstalledEcosystemCloudAppsResponse.status === 'fulfilled' ? allInstalledEcosystemCloudAppsResponse.value : [];
            const installedApps = [
                ...allInstalledAddonsInternal,
                ...allInstalledEcosystemCloudApps
            ];
            return {
                values: installedApps,
                totalCount: installedApps.length,
                pageSize: installedApps.length
            };
        });
    }
    uninstallAddon(_options) {
        return Promise.reject();
    }
    // eslint-disable-next-line max-lines-per-function
    async installAddon(addon, installationTargetInfo, installAddonOptions) {
        const { billing: billing } = installationTargetInfo;
        const isAddonPaid = addon.paymentModel !== 'free';
        const billingSystemIsCCP = billing.system === (0, $cVLrH.BillingSystem).CCP;
        const useStoreBffForInstallation = billingSystemIsCCP && (isAddonPaid || installationTargetInfo.productName === (0, $i0EDR.CompatibleProductId).COMPASS);
        const provisionAppViaCCP = billingSystemIsCCP && isAddonPaid;
        const tasks = {
            requestAppProvisioning: async (appKey)=>{
                try {
                    return await (0, $9z6QH.requestAppProvisioning)({
                        cloudId: (0, $lLYAL.parse)(installationTargetInfo.contextId).cloudId,
                        appKey: appKey,
                        productName: installationTargetInfo.productName
                    });
                } catch (error) {
                    let errorJson = {};
                    if (typeof error.error === 'string') errorJson.error = error.error;
                    else try {
                        errorJson = await error.error.json();
                    } catch (e) {
                        (0, $bTrQR.default).error('install-app-parse-error', "requestAppProvisioning Failed to parse error", {
                            error: error
                        });
                    }
                    let code = 'AppProvisioningError';
                    if (errorJson.error === 'APP_REACTIVATION_NOT_SUPPORTED') code = 'APP_REACTIVATION_NOT_SUPPORTED';
                    throw new (0, $1w7m1.AppInstallError)({
                        addon: addon.identifier,
                        code: code,
                        message: "Provisioning of app failed for ".concat(addon.identifier.toString()),
                        source: error
                    });
                }
            },
            getTokenFromUPM: async ()=>{
                try {
                    return await (0, $gQV53.getTokenFromUPM)(this.upmBaseUrl);
                } catch (error) {
                    throw new (0, $1w7m1.AppInstallError)({
                        addon: addon.identifier,
                        code: 'UPMTokenFetchError',
                        message: "Fetching token from UPM failed for ".concat(addon.identifier.toString()),
                        source: error
                    });
                }
            },
            postInstallToUPM: async (token, key, provisioningRequestId, cmtEligible)=>{
                try {
                    return await (0, $gQV53.postInstallToUPM)(this.upmBaseUrl, token, key, provisioningRequestId, cmtEligible);
                } catch (error) {
                    let errorJson = {};
                    if (typeof error.error === 'string') errorJson.errorMessage = error.error;
                    else try {
                        errorJson = await error.error.json();
                    } catch (e) {
                        (0, $bTrQR.default).error('install-app-parse-error', "postInstallToUPM Failed to parse error", {
                            error: error
                        });
                    }
                    throw new (0, $1w7m1.AppInstallError)({
                        addon: addon.identifier,
                        code: errorJson.subCode || errorJson.contentType || 'UnknownUPMInstallSubscribeError',
                        message: errorJson.errorMessage,
                        source: error
                    });
                }
            },
            waitForPendingUPMTask: async (taskResponse)=>{
                try {
                    return await (0, $gQV53.waitForPendingUPMTask)(this.upmBaseUrl, taskResponse.links.self, 2000);
                } catch (error) {
                    throw new (0, $1w7m1.AppInstallError)({
                        addon: addon.identifier,
                        code: error.subCode || 'UPMInstallPostError',
                        message: error.errorMessage || "Failed while polling for app installation status for ".concat(addon.identifier.toString()),
                        source: error
                    });
                }
            },
            getInstalledAddonInternal: async (keyIdentifier)=>{
                try {
                    const environment = (0, $6poH2.default)(this.config);
                    const getInstalledAddonFlags = {
                        retryForLicenseDetails: isAddonPaid && (installAddonOptions === null || installAddonOptions === void 0 ? void 0 : installAddonOptions.retryForLicenseDetails)
                    };
                    return await $8634a8e970498002$var$_getInstalledAddonInternal(keyIdentifier, environment, this.upmBaseUrl, this.config.gqlGatewayUrl, getInstalledAddonFlags);
                } catch (error) {
                    throw new (0, $1w7m1.AppInstallError)({
                        addon: addon.identifier,
                        code: 'FetchAddonInternalError',
                        message: "Failed while constructing a app object post installation success for ".concat(addon.identifier.toString()),
                        source: error
                    });
                }
            },
            provisionAndInstallAddonByARIViaCCP: async (ariIdentifier, installConfig, enableDeprecatedInstallationsGQL)=>{
                try {
                    var _cloudAppData$data$ex, _cloudAppData$data$ex2, _cloudAppData$data, _cloudAppData$data$ec, _cloudAppData$data$ec2;
                    const provisionRequestId = await tasks.requestAppProvisioning(ariIdentifier.appKey);
                    const cloudAppData = await (0, $QaRKt.getInstalledEcosystemCloudAppFromCaaS)(ariIdentifier, installConfig, enableDeprecatedInstallationsGQL);
                    const appInstallationNode = enableDeprecatedInstallationsGQL ? (_cloudAppData$data$ex = cloudAppData.data.extensionContexts) === null || _cloudAppData$data$ex === void 0 ? void 0 : (_cloudAppData$data$ex2 = _cloudAppData$data$ex[0].installations.nodes) === null || _cloudAppData$data$ex2 === void 0 ? void 0 : _cloudAppData$data$ex2[0] : (_cloudAppData$data = cloudAppData.data) === null || _cloudAppData$data === void 0 ? void 0 : (_cloudAppData$data$ec = _cloudAppData$data.ecosystem) === null || _cloudAppData$data$ec === void 0 ? void 0 : (_cloudAppData$data$ec2 = _cloudAppData$data$ec.appInstallationsByContext.nodes) === null || _cloudAppData$data$ec2 === void 0 ? void 0 : _cloudAppData$data$ec2[0];
                    if (appInstallationNode) {
                        var _cloudAppData$data$ex3;
                        await (0, $9z6QH.pollCloudAppProvisioningStatus)(provisionRequestId);
                        const extensionContext = (_cloudAppData$data$ex3 = cloudAppData.data.extensionContexts) === null || _cloudAppData$data$ex3 === void 0 ? void 0 : _cloudAppData$data$ex3[0];
                        const productExtensions = installConfig.product === (0, $i0EDR.CompatibleProductId).Jira ? extensionContext.adminPageExtensions : extensionContext.globalSettingsExtensions;
                        return (0, $axFWr.toInstalledEcosystemCloudAddon)(installConfig.product, installConfig.baseUrl, appInstallationNode, productExtensions.filter((extension)=>extension.installationId === appInstallationNode.id));
                    } else return (0, $QaRKt.handleInstallAddonByARI)(ariIdentifier, this.config, {
                        addon: addon.identifier,
                        contextId: installationTargetInfo.contextId,
                        relayState: installationTargetInfo.relayState,
                        enableDeprecatedInstallationsGQL: enableDeprecatedInstallationsGQL
                    }, provisionRequestId);
                } catch (error) {
                    throw new (0, $1w7m1.AppInstallError)({
                        addon: addon.identifier,
                        code: (error === null || error === void 0 ? void 0 : error.code) || 'AppProvisioningError',
                        message: "Provisioning of app failed for ".concat(ariIdentifier.appKey),
                        source: error
                    });
                }
            }
        };
        const installAddonByKey = async (keyIdentifier)=>{
            const { key: appKey } = keyIdentifier;
            const legacyProvisionAndInstallByKey = async ()=>{
                const provisioningRequestId = provisionAppViaCCP ? await tasks.requestAppProvisioning(appKey) : undefined;
                const token = await tasks.getTokenFromUPM();
                const pir = await tasks.postInstallToUPM(token, appKey, provisioningRequestId, installationTargetInfo.cmtEligible);
                await tasks.waitForPendingUPMTask(pir);
            };
            if (useStoreBffForInstallation) await (0, $dDuCy.installAddonViaStoreBFF)({
                appKey: appKey,
                installationTargetInfo: installationTargetInfo
            }, {
                gqlGatewayUrl: this.config.gqlGatewayUrl
            });
            else await legacyProvisionAndInstallByKey();
            return tasks.getInstalledAddonInternal(keyIdentifier);
        };
        async function installAddonByUrl(_) {
            throw new (0, $1w7m1.AppInstallError)({
                message: 'Marketplace SPI function [InstallAddon with InstallByUrl] not implemented',
                addon: addon.identifier,
                code: 'MethodNotImplementedError'
            });
        }
        const installAddonByARI = async (ariIdentifier)=>{
            const ecosystemInstallAddonOptions = {
                addon: addon.identifier,
                contextId: installationTargetInfo.contextId,
                relayState: installationTargetInfo.relayState,
                enableReactivateForgeAppFromEmcee: installAddonOptions === null || installAddonOptions === void 0 ? void 0 : installAddonOptions.enableReactivateForgeAppFromEmcee,
                enableDeprecatedInstallationsGQL: installAddonOptions === null || installAddonOptions === void 0 ? void 0 : installAddonOptions.enableDeprecatedInstallationsGQL
            };
            const legacyProvisionAndInstallByARI = async ()=>{
                if (provisionAppViaCCP) return tasks.provisionAndInstallAddonByARIViaCCP(ariIdentifier, this.config, installAddonOptions === null || installAddonOptions === void 0 ? void 0 : installAddonOptions.enableDeprecatedInstallationsGQL);
                return (0, $QaRKt.handleInstallAddonByARI)(ariIdentifier, this.config, ecosystemInstallAddonOptions);
            };
            if (useStoreBffForInstallation) {
                await (0, $dDuCy.installAddonViaStoreBFF)({
                    appKey: ariIdentifier.appKey,
                    installationTargetInfo: installationTargetInfo
                }, {
                    gqlGatewayUrl: this.config.gqlGatewayUrl
                });
                return (0, $QaRKt.getInstalledEcosystemCloudAppOrThrowInstallError)(ariIdentifier, this.config, ecosystemInstallAddonOptions);
            }
            return legacyProvisionAndInstallByARI();
        };
        return (0, $gQV53.foldInstallableAddonIdentifier)(addon.identifier)(installAddonByKey, installAddonByUrl, installAddonByARI);
    }
    upgradeAddon(_options) {
        return Promise.reject();
    }
    uninstallAddonFromSite(_options) {
        return Promise.reject();
    }
    createContainerToken(_options) {
        return Promise.reject();
    }
    getInstalledAddon(options) {
        const environment = (0, $6poH2.default)(this.config);
        const { gqlGatewayUrl: gqlGatewayUrl } = this.config;
        return (0, $gQV53.foldInstallableAddonIdentifier)(options.addon)(async (keyIdentifier)=>$8634a8e970498002$var$_getInstalledAddonInternal(keyIdentifier, environment, this.upmBaseUrl, gqlGatewayUrl, options.flags).catch((error)=>{
                if (error.source.status === 404) return {
                    status: 'NOT_FOUND',
                    error: error
                };
                throw error;
            }), (_)=>Promise.reject('Marketplace SPI function [getInstalledAddon with InstallByUrl] not implemented'), async (ariIdentifier)=>{
            try {
                return await (0, $QaRKt.getInstalledEcosystemCloudApp)(ariIdentifier, this.config, options.flags);
            } catch (_unused) {
                return {
                    status: 'NOT_FOUND',
                    error: {
                        meta: {
                            appKey: ariIdentifier.appKey
                        }
                    }
                };
            }
        });
    }
    getInstallableAddon(options) {
        const { hostCmtEnabled: hostCmtEnabled = false } = options;
        return (0, $gQV53.foldInstallableAddonIdentifier)(options.addon)(async (keyIdentifier)=>{
            const upmAvailableApp = await (0, $56eyA.getAvailableAppFromUpm)(this.upmBaseUrl, keyIdentifier.key, hostCmtEnabled);
            return $8634a8e970498002$var$isInstallable(upmAvailableApp) ? (0, $gQV53.toInstallableAddonFromUpmAvailableApp)(upmAvailableApp) : // Pass raw upmAvailableApp in case app can't be installed, allowing consumer to decide how to handle it
            Promise.reject({
                upmAvailableApp: upmAvailableApp,
                message: 'Requested add-on is not installable'
            });
        }, (_)=>Promise.reject('Marketplace SPI function [getInstallableAddon with InstallByUrl] not implemented'), async (ariIdentifier)=>{
            const marketplaceApp = await (0, $QaRKt.getRawCloudMarketplaceAppByKey)((0, $c0juV.makeAppKey)(ariIdentifier.appKey), this.config.gqlGatewayUrl);
            return (0, $axFWr.toEcosystemCloudInstallableAddon)(marketplaceApp);
        });
    }
    rotateContainerToken(_options) {
        return Promise.reject();
    }
}, (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "getInstalledAddons", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "getInstalledAddons"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "uninstallAddon", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "uninstallAddon"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "installAddon", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.throwsAppError)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "installAddon"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "upgradeAddon", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "upgradeAddon"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "uninstallAddonFromSite", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "uninstallAddonFromSite"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "createContainerToken", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "createContainerToken"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "getInstalledAddon", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "getInstalledAddon"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "getInstallableAddon", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "getInstallableAddon"), $8634a8e970498002$var$_class.prototype), (0, $je2Cw.default)($8634a8e970498002$var$_class.prototype, "rotateContainerToken", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($8634a8e970498002$var$_class.prototype, "rotateContainerToken"), $8634a8e970498002$var$_class.prototype), $8634a8e970498002$var$_class);
var $8634a8e970498002$export$2e2bcd8739ae039 = (config)=>(0, $gQV53.instanceToModule)(new $8634a8e970498002$var$Addons(config));

});
parcelRegister("je2Cw", function(module, exports) {

$parcel$export(module.exports, "default", () => $dff15b7171da0eff$export$2e2bcd8739ae039);
function $dff15b7171da0eff$export$2e2bcd8739ae039(i, e, r, n, l) {
    var a = {};
    return Object.keys(n).forEach(function(i) {
        a[i] = n[i];
    }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function(r, n) {
        return n(i, e, r) || r;
    }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a;
}

});

parcelRegister("lLYAL", function(module, exports) {
"use strict";
var $fd9cfd0bb813c6d0$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $fd9cfd0bb813c6d0$var$__exportStar = module.exports && module.exports.__exportStar || function(m, exports1) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports1, p)) $fd9cfd0bb813c6d0$var$__createBinding(exports1, m, p);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.parseEncoded = module.exports.parse = void 0;


$fd9cfd0bb813c6d0$var$__exportStar((parcelRequire("83g6W")), module.exports);

$fd9cfd0bb813c6d0$var$__exportStar((parcelRequire("h8Lnt")), module.exports);

$fd9cfd0bb813c6d0$var$__exportStar((parcelRequire("oXPmI")), module.exports);
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $fd9cfd0bb813c6d0$var$parse(ariString) {
    return (parcelRequire("oXPmI")).ResourceIdentifier.parse(ariString);
}
module.exports.parse = $fd9cfd0bb813c6d0$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $fd9cfd0bb813c6d0$var$parseEncoded(encodedAriString) {
    return (parcelRequire("oXPmI")).ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $fd9cfd0bb813c6d0$var$parseEncoded;

});
parcelRegister("oXPmI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ResourceIdentifier = module.exports.InvalidAriError = void 0;

var $cTNF8 = parcelRequire("cTNF8");
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $04b0a67ef92fd3ed$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $04b0a67ef92fd3ed$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $04b0a67ef92fd3ed$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $04b0a67ef92fd3ed$var$InvalidAriError;
function $04b0a67ef92fd3ed$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $04b0a67ef92fd3ed$var$basicCharConstraint = (0, $cTNF8.pattern)(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $04b0a67ef92fd3ed$var$resourceTypeCharConstraints = (0, $cTNF8.pattern)(/^[a-z][a-z.-]*$/i);
const $04b0a67ef92fd3ed$var$resourceOwnerConstraints = [
    (0, $cTNF8.lengthBetween)(3, 255),
    $04b0a67ef92fd3ed$var$basicCharConstraint
];
const $04b0a67ef92fd3ed$var$resourceTypeConstraints = [
    (0, $cTNF8.lengthBetween)(3, 255),
    $04b0a67ef92fd3ed$var$resourceTypeCharConstraints
];
const $04b0a67ef92fd3ed$var$cloudIdConstraints = [
    (0, $cTNF8.lengthBetween)(3, 255)
];
const $04b0a67ef92fd3ed$var$siteResourceType = 'site';
const $04b0a67ef92fd3ed$var$resourceIdChars = /[\w-._~:@#]/.source;
const $04b0a67ef92fd3ed$var$resourceIdConstraints = [
    (0, $cTNF8.pattern)(new RegExp(`^${$04b0a67ef92fd3ed$var$resourceIdChars}+(/${$04b0a67ef92fd3ed$var$resourceIdChars}*)*(;v=${$04b0a67ef92fd3ed$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $04b0a67ef92fd3ed$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $04b0a67ef92fd3ed$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $04b0a67ef92fd3ed$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $04b0a67ef92fd3ed$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $04b0a67ef92fd3ed$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
     * Parse a string as an Ari
     *
     * @param {string} ariString - the string to parse
     * @returns {Ari} the parsed ari
     * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
     */ static parse(ariString) {
        if (!ariString) throw new $04b0a67ef92fd3ed$var$InvalidAriError(ariString);
        const match = new RegExp(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/).exec(ariString);
        if (!match || match.length !== 5) throw new $04b0a67ef92fd3ed$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $04b0a67ef92fd3ed$var$InvalidAriError(ariString);
        return new $04b0a67ef92fd3ed$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $04b0a67ef92fd3ed$var$ResourceIdentifier.parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $04b0a67ef92fd3ed$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $04b0a67ef92fd3ed$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $04b0a67ef92fd3ed$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $04b0a67ef92fd3ed$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $04b0a67ef92fd3ed$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $04b0a67ef92fd3ed$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $04b0a67ef92fd3ed$var$siteResourceType && !!other.resourceType || $04b0a67ef92fd3ed$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $04b0a67ef92fd3ed$var$siteResourceType && !!other.resourceType || $04b0a67ef92fd3ed$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $04b0a67ef92fd3ed$var$siteResourceType && !cloudId) return new $cTNF8.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            (0, $cTNF8.validateField)(this, 'resourceOwner', $04b0a67ef92fd3ed$var$resourceOwnerConstraints),
            (0, $cTNF8.validateField)(this, 'resourceType', $04b0a67ef92fd3ed$var$resourceTypeConstraints),
            (0, $cTNF8.validateField)(this, 'resourceId', $04b0a67ef92fd3ed$var$resourceIdConstraints),
            (0, $cTNF8.validateField)(this, 'cloudId', $04b0a67ef92fd3ed$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $04b0a67ef92fd3ed$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $04b0a67ef92fd3ed$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $04b0a67ef92fd3ed$var$ResourceIdentifier;

});
parcelRegister("cTNF8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateField = module.exports.pattern = module.exports.lengthBetween = module.exports.ConstraintViolation = module.exports.GeneralValidationError = module.exports.RegexConstraint = module.exports.LengthConstraint = void 0;

var $M3rLj = parcelRequire("M3rLj");
class $9641250ab9e6873a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $9641250ab9e6873a$var$LengthConstraint;
class $9641250ab9e6873a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $9641250ab9e6873a$var$RegexConstraint;
class $9641250ab9e6873a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $9641250ab9e6873a$var$GeneralValidationError;
class $9641250ab9e6873a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $9641250ab9e6873a$var$ConstraintViolation;
function $9641250ab9e6873a$var$lengthBetween(min, max) {
    return new $9641250ab9e6873a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $9641250ab9e6873a$var$lengthBetween;
function $9641250ab9e6873a$var$pattern(regex) {
    return new $9641250ab9e6873a$var$RegexConstraint(regex);
}
module.exports.pattern = $9641250ab9e6873a$var$pattern;
function $9641250ab9e6873a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($M3rLj.isDefined);
    return violatedConstraints.length > 0 ? new $9641250ab9e6873a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $9641250ab9e6873a$var$validateField;

});
parcelRegister("M3rLj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $0907284485cca5f4$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $0907284485cca5f4$var$isPresent;
function $0907284485cca5f4$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $0907284485cca5f4$var$isDefined;
function $0907284485cca5f4$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $0907284485cca5f4$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $0907284485cca5f4$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $0907284485cca5f4$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $0907284485cca5f4$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $0907284485cca5f4$var$hasValueAtKey;

});



parcelRegister("83g6W", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.NotExpectedAppFamilyAriTypeError = module.exports.NotAppFamilyAriError = module.exports.AppFamilyAriError = void 0;
class $5dcb19db99e9de10$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $5dcb19db99e9de10$var$AppFamilyAriError;
class $5dcb19db99e9de10$var$NotAppFamilyAriError extends $5dcb19db99e9de10$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $5dcb19db99e9de10$var$NotAppFamilyAriError;
class $5dcb19db99e9de10$var$NotExpectedAppFamilyAriTypeError extends $5dcb19db99e9de10$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $5dcb19db99e9de10$var$NotExpectedAppFamilyAriTypeError;

});

parcelRegister("h8Lnt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createAppAri = module.exports.parseAppAri = void 0;

var $h05ek = parcelRequire("h05ek");
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $c7a7ef3503da1acb$var$parseAppAri(ari) {
    return $h05ek.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $c7a7ef3503da1acb$var$parseAppAri;
function $c7a7ef3503da1acb$var$createAppAri(json) {
    return new $h05ek.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $c7a7ef3503da1acb$var$createAppAri;

});
parcelRegister("h05ek", function(module, exports) {
"use strict";
var $c6067e522af1a0ae$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $c6067e522af1a0ae$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $c6067e522af1a0ae$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $c6067e522af1a0ae$var$__createBinding(result, mod, k);
    }
    $c6067e522af1a0ae$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppFamilyAriImpl = void 0;

const $c6067e522af1a0ae$var$AppFamilyAriModule = $c6067e522af1a0ae$var$__importStar((parcelRequire("kmdLH")));

var $83g6W = parcelRequire("83g6W");

var $cTNF8 = parcelRequire("cTNF8");

var $oXPmI = parcelRequire("oXPmI");
const $c6067e522af1a0ae$var$versionPrefix = ';v=';
const $c6067e522af1a0ae$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $c6067e522af1a0ae$var$uuidConstraints = [
    (0, $cTNF8.pattern)(new RegExp(`^${$c6067e522af1a0ae$var$uuidRegExpString}$`, 'i'))
];
const $c6067e522af1a0ae$var$extensionGroupIdConstraints = [
    (0, $cTNF8.pattern)(new RegExp(`^(${$c6067e522af1a0ae$var$uuidRegExpString}|static)$`, 'i'))
];
function $c6067e522af1a0ae$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}
class $c6067e522af1a0ae$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get versionId() {
        return this.json.versionId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    /* eslint-disable complexity */ static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $c6067e522af1a0ae$var$AppFamilyAriModule.resourceOwner) throw new $83g6W.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$c6067e522af1a0ae$var$AppFamilyAriModule.resourceOwner}`);
        if (!resourceType || !$c6067e522af1a0ae$var$AppFamilyAriModule.isAppFamilyResourceType(resourceType)) throw new $83g6W.NotAppFamilyAriError(ari, `resourceType must be one of ${$c6067e522af1a0ae$var$AppFamilyAriModule.appFamilyResourceTypes}`);
        if (!resourceId) throw new $83g6W.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($c6067e522af1a0ae$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($c6067e522af1a0ae$var$versionPrefix) > versionIndex) throw new $83g6W.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($c6067e522af1a0ae$var$versionPrefix);
        const segments = mainResourceId.split('/').map($c6067e522af1a0ae$var$stripToUndefined);
        if (segments.length > 4) throw new $83g6W.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        const versionId = resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.appEnvironmentVersionResourceType ? providedExtensionGroupId : undefined;
        if (!appId) throw new $83g6W.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.extensionGroupResourceType || resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.extensionResourceType ? 'static' : undefined);
        if (resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $83g6W.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$c6067e522af1a0ae$var$AppFamilyAriModule.extensionResourceType}`);
        else if (resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $83g6W.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$c6067e522af1a0ae$var$AppFamilyAriModule.extensionGroupResourceType}`);
        else if (resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $83g6W.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$c6067e522af1a0ae$var$AppFamilyAriModule.environmentResourceType}`);
        else if (resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.appEnvironmentVersionResourceType && (!environmentId || !versionId || extensionKey)) throw new $83g6W.NotAppFamilyAriError(ari, `environmentId and versionID must be provided for resourceType ${$c6067e522af1a0ae$var$AppFamilyAriModule.appEnvironmentVersionResourceType}`);
        else if (resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $83g6W.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$c6067e522af1a0ae$var$AppFamilyAriModule.environmentResourceType}`);
        if (resourceType === $c6067e522af1a0ae$var$AppFamilyAriModule.appEnvironmentVersionResourceType) return new $c6067e522af1a0ae$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            versionId: versionId
        });
        return new $c6067e522af1a0ae$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            versionId: versionId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    /* eslint-enable complexity */ asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asAppEnvironmentVersionAri() {
        return this.returnIf(()=>this.isAppEnvironmentVersionAri(), 'app-environment-version');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isAppEnvironmentVersionAri() {
        return this.isAtLeastAppEnvironmentVersionAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $83g6W.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastAppEnvironmentVersionAri() {
        return this.versionId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            (0, $cTNF8.validateField)(this, 'environmentId', $c6067e522af1a0ae$var$uuidConstraints),
            (0, $cTNF8.validateField)(this, 'appId', $c6067e522af1a0ae$var$uuidConstraints),
            (0, $cTNF8.validateField)(this, 'extensionGroupId', $c6067e522af1a0ae$var$extensionGroupIdConstraints),
            (0, $cTNF8.validateField)(this, 'versionId', $c6067e522af1a0ae$var$uuidConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $oXPmI.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $c6067e522af1a0ae$var$AppFamilyAriModule.resourceOwner;
        const { versionId: versionId } = this.toJSON();
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$c6067e522af1a0ae$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $oXPmI.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $c6067e522af1a0ae$var$AppFamilyAriModule.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $oXPmI.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $c6067e522af1a0ae$var$AppFamilyAriModule.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentVersionAri()) return new $oXPmI.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $c6067e522af1a0ae$var$AppFamilyAriModule.appEnvironmentVersionResourceType,
            resourceId: [
                appId,
                environmentId,
                versionId
            ].join('/')
        });
        else if (this.isAppEnvironmentAri()) return new $oXPmI.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $c6067e522af1a0ae$var$AppFamilyAriModule.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $oXPmI.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $c6067e522af1a0ae$var$AppFamilyAriModule.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $c6067e522af1a0ae$var$AppFamilyAriImpl;

});
parcelRegister("kmdLH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.appFamilyResourceTypes = module.exports.isAppFamilyResourceType = module.exports.extensionResourceType = module.exports.extensionGroupResourceType = module.exports.appEnvironmentVersionResourceType = module.exports.environmentResourceType = module.exports.appResourceType = module.exports.resourceOwner = void 0;
module.exports.resourceOwner = 'ecosystem';
module.exports.appResourceType = 'app';
module.exports.environmentResourceType = 'environment';
module.exports.appEnvironmentVersionResourceType = 'app-environment-version';
module.exports.extensionGroupResourceType = 'extension-group';
module.exports.extensionResourceType = 'extension';
const $ed208ad414f2be3e$var$isAppFamilyResourceType = function(type) {
    switch(type){
        case module.exports.resourceOwner:
        case module.exports.appResourceType:
        case module.exports.environmentResourceType:
        case module.exports.appEnvironmentVersionResourceType:
        case module.exports.extensionGroupResourceType:
        case module.exports.extensionResourceType:
            return true;
    }
    return false;
};
module.exports.isAppFamilyResourceType = $ed208ad414f2be3e$var$isAppFamilyResourceType;
module.exports.appFamilyResourceTypes = [
    module.exports.appResourceType,
    module.exports.environmentResourceType,
    module.exports.appEnvironmentVersionResourceType,
    module.exports.extensionGroupResourceType,
    module.exports.extensionResourceType
];

});




parcelRegister("9z6QH", function(module, exports) {

$parcel$export(module.exports, "requestAppProvisioning", () => $6f6cb203a1121d19$export$cf54dee9c9b16e76);
$parcel$export(module.exports, "pollCloudAppProvisioningStatus", () => $6f6cb203a1121d19$export$d9c3f5e94f8e1adc);

var $dO8LH = parcelRequire("dO8LH");

var $eE56D = parcelRequire("eE56D");
const $6f6cb203a1121d19$export$cf54dee9c9b16e76 = (appProvisioningRequest)=>(0, $dO8LH.fetchOk)("/gateway/api/marketplace/internal/demand/app-provision", {
        method: 'POST',
        body: JSON.stringify(appProvisioningRequest),
        headers: {
            'Content-Type': 'application/json'
        }
    }).then((response)=>response.json()).then((response)=>response.provisioningRequestId);
const $6f6cb203a1121d19$export$b47ba6e8d4012f84 = (maximumDurationInMinutes, pollAfter)=>maximumDurationInMinutes * 60000 / pollAfter;
async function $6f6cb203a1121d19$export$d9c3f5e94f8e1adc(provisioningRequestId) {
    const pollAfter = 5000;
    const options = {
        retries: $6f6cb203a1121d19$export$b47ba6e8d4012f84(4, pollAfter),
        retryDelay: pollAfter,
        accept: (response)=>response.json().then((bodyJSON)=>{
                var _bodyJSON$payload$dat;
                const appProvisioningStatus = (_bodyJSON$payload$dat = bodyJSON.payload.data.resourcePackages) === null || _bodyJSON$payload$dat === void 0 ? void 0 : _bodyJSON$payload$dat[0].action.status;
                return appProvisioningStatus === (0, $eE56D.AppProvisionStatus).IN_PROGRESS ? Promise.reject(new Error('Request pending')) : Promise.resolve();
            })
    };
    const response = await (0, $dO8LH.fetchOk)("/gateway/api/marketplace/internal/demand/app-provision/status/".concat(provisioningRequestId), options);
    const responseJSON = await response.json();
    const appProvisioningStatus = responseJSON.payload.data.resourcePackages[0].action.status;
    if (appProvisioningStatus === (0, $eE56D.AppProvisionStatus).SUCCESS) return Promise.resolve((0, $eE56D.AppProvisionStatus).SUCCESS);
    else throw new Error("Polling for app provision status failed for provisioningRequestId: ".concat(provisioningRequestId));
}

});
parcelRegister("dO8LH", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $a0d6bf0ff7a4b6b0$export$e7aa7bc5c1b3cfb3);
$parcel$export(module.exports, "fetchOk", () => $a0d6bf0ff7a4b6b0$export$3783294069ccd537);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");
const $a0d6bf0ff7a4b6b0$var$_excluded = [
    "retries",
    "accept",
    "retryDelay"
];
function $a0d6bf0ff7a4b6b0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a0d6bf0ff7a4b6b0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a0d6bf0ff7a4b6b0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a0d6bf0ff7a4b6b0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 *
 * Code taken from : https://github.com/jonbern/fetch-retry
 *
 * This is a wrapper for isomorphic-fetch with retry and accept
 *
 * Updated the code to have a accept param :
 * this is to retry when the response returned is not acceptable and we want to retry,
 * even if the response was 2XX, or 4XX or 5XX
 *
 * @param url
 * @param options
 *      retry: Int
 *      retryDelay: Int : milliseconds
 *      accept: (response) => Promise<void> : Will retry if the Promise is rejected
 * @return {Promise}
 */ function $a0d6bf0ff7a4b6b0$export$e7aa7bc5c1b3cfb3(url) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const defaultAccept = ()=>Promise.resolve();
    const { retries: retries = 0, accept: accept = defaultAccept, retryDelay: retryDelay = 0 } = options, fetchOptions = (0, $bwPfh.default)(options, $a0d6bf0ff7a4b6b0$var$_excluded);
    return new Promise((resolve, reject)=>{
        const wrappedFetch = function wrappedFetch(n) {
            fetch(url, fetchOptions).then((r)=>accept(r.clone()).then((_)=>resolve(r))).catch((error)=>{
                if (n > 0) setTimeout(()=>{
                    wrappedFetch(--n);
                }, retryDelay);
                else reject({
                    url: url,
                    error: error,
                    status: error.status || 'unknown'
                });
            });
        };
        wrappedFetch(retries);
    });
}
/**
 * Function for accept param in fetch(), that only resolves when the response is ok and rejects in any other response
 */ const $a0d6bf0ff7a4b6b0$export$df53d19c6ff4368d = (resp)=>resp.ok === true ? Promise.resolve() : Promise.reject(resp);
function $a0d6bf0ff7a4b6b0$export$3783294069ccd537(url) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $a0d6bf0ff7a4b6b0$export$e7aa7bc5c1b3cfb3(url, $a0d6bf0ff7a4b6b0$var$_objectSpread($a0d6bf0ff7a4b6b0$var$_objectSpread({}, options), {}, {
        accept: (resp)=>$a0d6bf0ff7a4b6b0$export$df53d19c6ff4368d(resp).then(()=>{
                const accept = options.accept;
                return (accept ? accept : ()=>Promise.resolve())(resp);
            })
    })).catch((error)=>Promise.reject(error));
}

});
parcelRegister("bwPfh", function(module, exports) {

$parcel$export(module.exports, "default", () => $864a6f28f9285041$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
function $864a6f28f9285041$export$2e2bcd8739ae039(e, t) {
    if (null == e) return {};
    var o, r, i = (0, $6XgOP.default)(e, t);
    if (Object.getOwnPropertySymbols) {
        var s = Object.getOwnPropertySymbols(e);
        for(r = 0; r < s.length; r++)o = s[r], t.includes(o) || ({}).propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
    }
    return i;
}

});


parcelRegister("eE56D", function(module, exports) {

$parcel$export(module.exports, "AppProvisionStatus", () => $aa98c316006568ae$export$f4aeb6fbad2e1f13);
const $aa98c316006568ae$export$f4aeb6fbad2e1f13 = Object.freeze({
    SUCCESS: 'SUCCESS',
    IN_PROGRESS: 'IN_PROGRESS'
});

});


parcelRegister("1w7m1", function(module, exports) {

$parcel$export(module.exports, "AppInstallError", () => $11ae7bf9df1a9c3d$export$8682a08cd10649cb);
$parcel$export(module.exports, "makeAppFetchError", () => $11ae7bf9df1a9c3d$export$fda0731393a9b06c);

var $h1LeU = parcelRequire("h1LeU");
const $11ae7bf9df1a9c3d$export$8682a08cd10649cb = (0, $h1LeU.default)('AppInstallError', (_ref)=>{
    let { code: code, message: message, addon: addon, source: source, requestId: requestId } = _ref;
    return {
        code: code,
        message: message,
        source: source,
        meta: {
            addon: addon,
            requestId: requestId
        }
    };
});
const $11ae7bf9df1a9c3d$export$fda0731393a9b06c = (name)=>{
    return (0, $h1LeU.default)(name, (_ref2)=>{
        let { source: source, appKey: appKey, requestId: requestId } = _ref2;
        return {
            code: 'FetchError',
            message: "Failed to fetch app details for ".concat(appKey),
            source: source,
            meta: {
                appKey: appKey,
                requestId: requestId
            }
        };
    });
};

});
parcelRegister("h1LeU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6572c6c8af98ca4$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $3pDAB = parcelRequire("3pDAB");
const $c6572c6c8af98ca4$var$_excluded = [
    "code",
    "message",
    "meta",
    "source"
];
function $c6572c6c8af98ca4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c6572c6c8af98ca4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c6572c6c8af98ca4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c6572c6c8af98ca4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Wraps a passed function after dynamically
 * setting the function name. The function name
 * is minification-proof.
 */ function $c6572c6c8af98ca4$var$withName(name, fn) {
    function wrappedFunction() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return fn.apply(this, args);
    }
    Object.defineProperty(wrappedFunction, 'name', {
        value: name
    });
    return wrappedFunction;
}
// If a transform function is specified, the fields passed
// to the error constructor should match fields passed to the
// transform function. Else they should match standard `ErrorFields`
/**
 * Factory function for creating new error types.
 * Takes an optional transform function that is expected
 * to return standard ErrorFields.
 *
 * @example
 * const SimpleError = createErrorType('SimpleError')
 * throw new SimpleError({ code: 'code', message: 'something went wrong'})
 * ----
 * type BuiltErrorFields = { foo: string }
 * const BuiltError =  createErrorType<BuiltErrorFields>('BuiltError', ({ foo }) => ({ code: foo, message: 'bar' }))
 * throw new BuiltError({ foo: 'baz'})
 */ const $c6572c6c8af98ca4$var$createErrorType = (type, transform)=>{
    // MC-2850 To-do fix the typing for "this"
    const CustomError = $c6572c6c8af98ca4$var$withName(type, function(params) {
        const finalParams = transform ? transform(params) : params;
        const { code: code, message: message, meta: meta, source: source } = finalParams, other = (0, $bwPfh.default)(finalParams, $c6572c6c8af98ca4$var$_excluded);
        this.code = code;
        this.message = message;
        this.id = (0, $3pDAB.nanoid)(9);
        this.type = type;
        this.source = source;
        this.meta = $c6572c6c8af98ca4$var$_objectSpread($c6572c6c8af98ca4$var$_objectSpread({}, meta), other);
        this.toJSON = ()=>$c6572c6c8af98ca4$var$_objectSpread({
                id: this.id,
                code: this.code,
                type: this.type,
                message: this.message,
                meta: this.meta
            }, this.source && {
                source: this.source.toJSON ? this.source.toJSON() : this.source.message ? this.source.message : this.source
            });
        this.toString = ()=>JSON.stringify(this.toJSON());
        if (Object.prototype.hasOwnProperty.call(Error, 'captureStackTrace')) Error.captureStackTrace(this, CustomError);
        else this.stack = new Error(message).stack;
    });
    if (typeof Object.setPrototypeOf === 'function') Object.setPrototypeOf(CustomError.prototype, Error.prototype);
    else CustomError.prototype = Object.create(Error.prototype, {
        constructor: {
            value: CustomError
        }
    });
    return CustomError;
};
var $c6572c6c8af98ca4$export$2e2bcd8739ae039 = $c6572c6c8af98ca4$var$createErrorType;

});
parcelRegister("3pDAB", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $27c26a7ee1643e03$export$ac4959f4f1338dfc);

var $9tgjU = parcelRequire("9tgjU");
let $27c26a7ee1643e03$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $27c26a7ee1643e03$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length === size) return id;
            }
        }
    };
};
let $27c26a7ee1643e03$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$27c26a7ee1643e03$export$a5cee9e955a615e5(alphabet, size, $27c26a7ee1643e03$export$4385e60b38654f68);
let $27c26a7ee1643e03$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += '-';
        else id += '_';
        return id;
    }, '');

});
parcelRegister("9tgjU", function(module, exports) {
let $6e537b4cb9d9fe59$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

});




parcelRegister("cVLrH", function(module, exports) {

$parcel$export(module.exports, "BillingSystem", () => $969f9caa081b5f8c$export$b98d8c55ee048af0);
const $969f9caa081b5f8c$export$b98d8c55ee048af0 = Object.freeze({
    CCP: 'CCP',
    HAMS: 'HAMS'
});

});

parcelRegister("i0EDR", function(module, exports) {

$parcel$export(module.exports, "CompatibleProductId", () => $d1c7c0b9cbcf61d0$export$df338930ef01ceeb);
$parcel$export(module.exports, "CompatibleProductName", () => $d1c7c0b9cbcf61d0$export$43260f31e4024012);
const $d1c7c0b9cbcf61d0$export$34a11a76909ead13 = Object.freeze({
    JIRA: 'JIRA',
    CONFLUENCE: 'CONFLUENCE',
    CRUCIBLE: 'CRUCIBLE',
    BAMBOO: 'BAMBOO',
    CROWD: 'CROWD',
    BITBUCKET: 'BITBUCKET',
    OPSGENIE: 'OPSGENIE',
    STATUS_PAGE: 'STATUS_PAGE',
    TOWNSQUARE: 'TOWNSQUARE',
    COMPASS: 'COMPASS',
    FISHEYE: 'FISHEYE',
    JIRA_SERVICE_MANAGEMENT: 'JIRA_SERVICE_MANAGEMENT'
});
const $d1c7c0b9cbcf61d0$export$df338930ef01ceeb = Object.freeze({
    Jira: 'jira',
    Confluence: 'confluence',
    Crucible: 'crucible',
    Bamboo: 'bamboo',
    Crowd: 'crowd',
    Bitbucket: 'bitbucket',
    Opsgenie: 'opsgenie',
    StatusPage: 'status_page',
    Townsquare: 'townsquare',
    Hipchat: 'hipchat',
    COMPASS: 'compass',
    Fisheye: 'fisheye',
    JiraServiceManagement: 'jira-service-management'
});
const $d1c7c0b9cbcf61d0$export$43260f31e4024012 = {
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.Jira]: 'Jira',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.Confluence]: 'Confluence',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.JiraServiceManagement]: 'Jira Service Management',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.Fisheye]: 'Fisheye',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.Crucible]: 'Crucible',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.Bitbucket]: 'Bitbucket',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.Crowd]: 'Crowd',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.Bamboo]: 'Bamboo',
    [$d1c7c0b9cbcf61d0$export$df338930ef01ceeb.COMPASS]: 'Compass'
};

});

parcelRegister("bTrQR", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a8a6f8777a3fdf8$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $ighTk = parcelRequire("ighTk");
function $8a8a6f8777a3fdf8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a8a6f8777a3fdf8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a8a6f8777a3fdf8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a8a6f8777a3fdf8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/* Module-scoped config. */ const $8a8a6f8777a3fdf8$var$loggerConfig = {
    mode: 'sentry'
};
const $8a8a6f8777a3fdf8$export$229f4b2b611b052d = ()=>{
    if (window.location.href.includes('emcee')) return window.location.hash.split('#')[1];
};
const $8a8a6f8777a3fdf8$var$logLevelToSentrySeverity = (logLevel)=>{
    const logLevelToSentryLevelMappings = {
        info: 'info',
        warn: 'warning',
        error: 'error'
    };
    return logLevelToSentryLevelMappings[logLevel];
};
const $8a8a6f8777a3fdf8$export$bfcc8eb13073c803 = (options)=>{
    const { mode: mode = 'sentry', context: context = {} } = options || {};
    $8a8a6f8777a3fdf8$var$loggerConfig.mode = mode;
    $8a8a6f8777a3fdf8$var$loggerConfig.context = context;
};
const $8a8a6f8777a3fdf8$export$a4f9dc99be407671 = (context)=>{
    $8a8a6f8777a3fdf8$var$loggerConfig.context = context;
};
const $8a8a6f8777a3fdf8$export$4c8db6aea605e98 = ()=>{
    $8a8a6f8777a3fdf8$var$loggerConfig.context = {};
};
const $8a8a6f8777a3fdf8$var$sendData = (level, location, message, data)=>{
    const eventData = data || {};
    const { mode: mode, context: context = {} } = $8a8a6f8777a3fdf8$var$loggerConfig;
    if (mode === 'console') console[level]($8a8a6f8777a3fdf8$var$_objectSpread($8a8a6f8777a3fdf8$var$_objectSpread({}, eventData), {}, {
        location: location,
        message: message,
        context: context
    }));
    else {
        var _getSentryClient;
        (_getSentryClient = (0, $ighTk.default)()) === null || _getSentryClient === void 0 || _getSentryClient.withScope((scope)=>{
            var _getSentryClient2;
            const { tags: tags = {} } = eventData;
            scope.clear();
            Object.entries(tags).forEach((_ref)=>{
                let [tagKey, tagValue] = _ref;
                scope.setTag(tagKey, tagValue);
            });
            // To override emcee iframe url
            const pathname = $8a8a6f8777a3fdf8$export$229f4b2b611b052d();
            if (pathname) scope.setTag('url', pathname);
            scope.setTag('location', location);
            scope.setTag('structuredLog', 'true');
            scope.setExtra('eventData', eventData);
            (_getSentryClient2 = (0, $ighTk.default)()) === null || _getSentryClient2 === void 0 || _getSentryClient2.captureMessage("".concat(location, ": ").concat(message), $8a8a6f8777a3fdf8$var$logLevelToSentrySeverity(level));
            console[level]("".concat(location, ": ").concat(message));
        });
    }
};
const $8a8a6f8777a3fdf8$var$info = (location, message, eventData)=>{
    $8a8a6f8777a3fdf8$var$sendData('info', location, message, eventData);
};
const $8a8a6f8777a3fdf8$var$warn = (location, message, eventData)=>{
    $8a8a6f8777a3fdf8$var$sendData('warn', location, message, eventData);
};
const $8a8a6f8777a3fdf8$var$error = (location, message, eventData)=>{
    $8a8a6f8777a3fdf8$var$sendData('error', location, message, eventData);
};
var $8a8a6f8777a3fdf8$export$2e2bcd8739ae039 = {
    info: $8a8a6f8777a3fdf8$var$info,
    warn: $8a8a6f8777a3fdf8$var$warn,
    error: $8a8a6f8777a3fdf8$var$error
};

});
parcelRegister("ighTk", function(module, exports) {

$parcel$export(module.exports, "resetSentryClient", () => $d4b7997452326403$export$8a6de2d979474935);
$parcel$export(module.exports, "default", () => $d4b7997452326403$export$2e2bcd8739ae039);
$parcel$export(module.exports, "setSentryClient", () => $d4b7997452326403$export$7d446c6f4e54de82);
let $d4b7997452326403$var$sentryInstance = null;
function $d4b7997452326403$export$8a6de2d979474935() {
    $d4b7997452326403$var$sentryInstance = null;
    delete window.__MARKETPLACE_SENTRY_INSTANCE__;
}
function $d4b7997452326403$export$2e2bcd8739ae039() {
    var _sentryInstance;
    let throwException = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    const instance = (_sentryInstance = $d4b7997452326403$var$sentryInstance) !== null && _sentryInstance !== void 0 ? _sentryInstance : window.__MARKETPLACE_SENTRY_INSTANCE__;
    if (!instance && throwException) console.error('Called sentry method without first calling `init`');
    return instance;
}
function $d4b7997452326403$export$7d446c6f4e54de82(client) {
    let attachToWindow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (attachToWindow) {
        window.__MARKETPLACE_SENTRY_INSTANCE__ = client;
        return window.__MARKETPLACE_SENTRY_INSTANCE__;
    }
    $d4b7997452326403$var$sentryInstance = client;
    return $d4b7997452326403$var$sentryInstance;
}

});


parcelRegister("gQV53", function(module, exports) {

$parcel$export(module.exports, "buildContext", () => $c44dc7ac64a27d3b$export$3a7fe28f9bf4f3d9);
$parcel$export(module.exports, "returnsPromise", () => $c44dc7ac64a27d3b$export$51b23e8c35a8720b);
$parcel$export(module.exports, "throwsAppError", () => $c44dc7ac64a27d3b$export$2c3b49b874dfe566);
$parcel$export(module.exports, "unsupported", () => $c44dc7ac64a27d3b$export$98e633703a635f);
$parcel$export(module.exports, "instanceToModule", () => $c44dc7ac64a27d3b$export$e7303cbbda2866c6);
$parcel$export(module.exports, "getTokenFromUPM", () => $c44dc7ac64a27d3b$export$9e329766bd383c22);
$parcel$export(module.exports, "getUPMCredentials", () => $c44dc7ac64a27d3b$export$9f0387e1e9b3eead);
$parcel$export(module.exports, "postInstallToUPM", () => $c44dc7ac64a27d3b$export$183c3dd865ccae70);
$parcel$export(module.exports, "foldInstallableAddonIdentifier", () => $c44dc7ac64a27d3b$export$d74e456828fa5d02);
$parcel$export(module.exports, "foldPermissionIdentifier", () => $c44dc7ac64a27d3b$export$7adbfe43d093f2b9);
$parcel$export(module.exports, "calculateRetries", () => $c44dc7ac64a27d3b$export$b47ba6e8d4012f84);
$parcel$export(module.exports, "waitForPendingUPMTask", () => $c44dc7ac64a27d3b$export$4fcc92cf5ecc9986);
$parcel$export(module.exports, "setProp", () => $c44dc7ac64a27d3b$export$8a39838a0f735648);
$parcel$export(module.exports, "toInstallableAddonFromUpmAvailableApp", () => $c44dc7ac64a27d3b$export$6a97a6c22226d99);
$parcel$export(module.exports, "toInstalledAddon", () => $c44dc7ac64a27d3b$export$43197df0fd5cbe13);
$parcel$export(module.exports, "arrayToMap", () => $c44dc7ac64a27d3b$export$8ff5edbc8a5b1a81);
$parcel$export(module.exports, "transformToPaymentModel", () => $c44dc7ac64a27d3b$export$581b3b2292f173ff);

var $5zQU9 = parcelRequire("5zQU9");

var $dO8LH = parcelRequire("dO8LH");

var $9fEFB = parcelRequire("9fEFB");

var $iZFTO = parcelRequire("iZFTO");

var $kt9Cs = parcelRequire("kt9Cs");

var $dx2bt = parcelRequire("dx2bt");

var $c0juV = parcelRequire("c0juV");
function $c44dc7ac64a27d3b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c44dc7ac64a27d3b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c44dc7ac64a27d3b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c44dc7ac64a27d3b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $c44dc7ac64a27d3b$export$5ee183ee125d017c = (productName)=>{
    switch(productName){
        case 'jira':
            return 'Jira';
        case 'confluence':
            return 'Confluence';
        case 'compass':
            return 'Compass';
        default:
            throw new Error("Unsupported product name: ".concat(productName));
    }
};
const $c44dc7ac64a27d3b$export$3a7fe28f9bf4f3d9 = (config)=>{
    return {
        name: $c44dc7ac64a27d3b$export$5ee183ee125d017c(config.product),
        type: 'application',
        id: "ari:cloud:".concat(config.product, ":").concat(config.cloudId, ":/"),
        orgId: config.orgId,
        // To understand wrokspaceAri format visit - // https://developer.atlassian.com/platform/atlassian-resource-identifier/resource-owners/registry/#ati%3Acloud%3Ajira%3Aworkspace
        workspaceAri: "ari:cloud:".concat(config.product, ":").concat(config.cloudId, ":workspace/").concat(config.activationId)
    };
};
function $c44dc7ac64a27d3b$export$51b23e8c35a8720b(target, key, descriptor) {
    descriptor.value.returnsPromise = true;
    descriptor.enumerable = true;
    return descriptor;
}
function $c44dc7ac64a27d3b$export$2c3b49b874dfe566(target, key, descriptor) {
    const fn = descriptor.value;
    // eslint-disable-next-line eqeqeq
    const isPromise = (val)=>Promise.resolve(val) == val;
    descriptor.value = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        const result = fn.apply(this, args);
        if (isPromise(result)) return result.then((resolvedValue)=>resolvedValue).catch((error)=>{
            if (error.toJSON) throw error.toJSON();
            else throw error;
        });
        else return result;
    };
    return descriptor;
}
function $c44dc7ac64a27d3b$export$98e633703a635f(target, key, descriptor) {
    const name = descriptor.value.name;
    descriptor.value = ()=>Promise.reject("Marketplace SPI function [".concat(name, "] not implemented"));
    return descriptor;
}
function $c44dc7ac64a27d3b$export$e7303cbbda2866c6(instance) {
    const module = {};
    const prototype = Object.getPrototypeOf(instance);
    Object.keys(prototype).forEach((key)=>{
        module[key] = prototype[key].bind(instance);
        module[key].returnsPromise = prototype[key].returnsPromise;
    });
    return module;
}
async function $c44dc7ac64a27d3b$export$9e329766bd383c22(upm) {
    const options = {
        retries: 2,
        retryDelay: 3000,
        credentials: $c44dc7ac64a27d3b$export$9f0387e1e9b3eead(upm)
    };
    const response = await (0, $dO8LH.fetchOk)("".concat(upm, "/rest/plugins/1.0/upm-token"), $c44dc7ac64a27d3b$var$_objectSpread({
        method: 'HEAD'
    }, options));
    return response.headers.get('upm-token');
}
async function $c44dc7ac64a27d3b$export$183c3dd865ccae70(upm, token, appKey, provisioningRequestId, cmtEligible) {
    const options = {
        method: 'POST',
        credentials: $c44dc7ac64a27d3b$export$9f0387e1e9b3eead(upm),
        headers: new window.Headers({
            'content-type': (0, $dx2bt.REMOTE_INSTALL_JSON)
        })
    };
    return (await (0, $dO8LH.fetchOk)("".concat(upm, "/rest/plugins/1.0/apps/install-subscribe?").concat((0, (/*@__PURE__*/$parcel$interopDefault($kt9Cs))).stringify({
        addonKey: appKey,
        token: token,
        provisioningRequestId: provisioningRequestId,
        cmtEligible: cmtEligible
    })), options)).json();
}
const $c44dc7ac64a27d3b$export$d74e456828fa5d02 = (addonIdentifier)=>(key, url, ari)=>{
        if (addonIdentifier.key) return key(addonIdentifier);
        else if (addonIdentifier.url) return url(addonIdentifier);
        else if (addonIdentifier.ari) return ari(addonIdentifier);
        else throw new Error('Invalid identifier');
    };
const $c44dc7ac64a27d3b$export$7adbfe43d093f2b9 = (addonIdentifier)=>(key, ari)=>{
        if (addonIdentifier.details.ecosystemCloudAppId) return ari(addonIdentifier);
        else return key(addonIdentifier);
    };
const $c44dc7ac64a27d3b$export$b47ba6e8d4012f84 = (maximumDurationInMinutes, pollAfter)=>maximumDurationInMinutes * 60000 / pollAfter;
async function $c44dc7ac64a27d3b$export$4fcc92cf5ecc9986(upm, uri, pollAfter) {
    const options = {
        retries: $c44dc7ac64a27d3b$export$b47ba6e8d4012f84(4.33, pollAfter),
        retryDelay: pollAfter,
        credentials: $c44dc7ac64a27d3b$export$9f0387e1e9b3eead(upm),
        accept: (response)=>response.json().then((bodyJSON)=>{
                var _bodyJSON$status;
                return (_bodyJSON$status = bodyJSON.status) !== null && _bodyJSON$status !== void 0 && _bodyJSON$status.done ? Promise.resolve() : Promise.reject(new Error('Request pending'));
            })
    };
    const response = await (0, $dO8LH.fetchOk)(uri, options);
    const responseJSON = await response.json();
    const contentTypeHeader = response.headers.get('content-type');
    const headerHasInstallComplete = (contentTypeHeader === null || contentTypeHeader === void 0 ? void 0 : contentTypeHeader.indexOf((0, $dx2bt.INSTALL_COMPLETE_JSON))) !== -1;
    if (headerHasInstallComplete) return responseJSON;
    else return Promise.reject($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread({}, responseJSON.status), {}, {
        contentTypeHeader: contentTypeHeader
    }));
}
const $c44dc7ac64a27d3b$export$5e09a4327db89926 = (marketplaceApp, environment)=>{
    var _marketplaceApp$logo$;
    const { version: version, partner: partner } = marketplaceApp;
    const links = (0, $9fEFB.linkTemplates)({
        adminHubBaseUrl: environment.adminHubBaseUrl,
        mpacBaseUrl: environment.mpacBaseUrl,
        mpacCdnBaseUrl: environment.mpacCdnBaseUrl,
        macBaseUrl: environment.macBaseUrl,
        wacBaseUrl: environment.wacBaseUrl,
        atlassianCommunityBaseUrl: environment.atlassianCommunityBaseUrl
    });
    return $c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread({
        key: marketplaceApp.appKey,
        name: marketplaceApp.name,
        origin: 'marketplace',
        description: marketplaceApp.tagline || ''
    }, $c44dc7ac64a27d3b$export$8a39838a0f735648('version', version === null || version === void 0 ? void 0 : version.version)), $c44dc7ac64a27d3b$export$8a39838a0f735648('vendor', partner === null || partner === void 0 ? void 0 : partner.name)), $c44dc7ac64a27d3b$export$8a39838a0f735648('vendorLink', partner ? links.partnerDetails.expand({
        id: partner.id,
        slug: partner.slug
    }) : undefined)), $c44dc7ac64a27d3b$export$8a39838a0f735648('icon', marketplaceApp.logo ? links.mediaFile.expand({
        imageId: ((_marketplaceApp$logo$ = marketplaceApp.logo.highResolution) === null || _marketplaceApp$logo$ === void 0 ? void 0 : _marketplaceApp$logo$.id) || marketplaceApp.logo.original.id
    }) : undefined)), $c44dc7ac64a27d3b$export$8a39838a0f735648('privacyPolicy', marketplaceApp.privacyPolicyUrl)), $c44dc7ac64a27d3b$export$8a39838a0f735648('eula', version === null || version === void 0 ? void 0 : version.endUserLicenseAgreementUrl)), {}, {
        vendorType: (partner === null || partner === void 0 ? void 0 : partner.partnerType) === 'ATLASSIAN_INTERNAL' ? 'internal' : 'thirdParty',
        metadata: undefined
    });
};
const $c44dc7ac64a27d3b$var$resolveScopes = (marketplaceApp)=>{
    var _marketplaceApp$versi;
    // let scopes;
    // if(marketplaceApp.version?.deployment) {
    //   {scopes} = (marketplaceApp.version?.deployment);
    // }
    const { scopes: scopes } = ((_marketplaceApp$versi = marketplaceApp.version) === null || _marketplaceApp$versi === void 0 ? void 0 : _marketplaceApp$versi.deployment) || {};
    return scopes ? scopes.map((a)=>a.id) : [];
};
const $c44dc7ac64a27d3b$export$96613f433d2dc4e1 = (upmAvailableApp)=>{
    var _upmAvailableApp$vend, _upmAvailableApp$vend2, _upmAvailableApp$logo;
    return $c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread({
        key: upmAvailableApp.key,
        name: upmAvailableApp.name,
        origin: 'marketplace',
        description: upmAvailableApp.summary,
        version: upmAvailableApp.version
    }, $c44dc7ac64a27d3b$export$8a39838a0f735648('vendor', (_upmAvailableApp$vend = upmAvailableApp.vendor) === null || _upmAvailableApp$vend === void 0 ? void 0 : _upmAvailableApp$vend.name)), $c44dc7ac64a27d3b$export$8a39838a0f735648('vendorLink', (_upmAvailableApp$vend2 = upmAvailableApp.vendor) === null || _upmAvailableApp$vend2 === void 0 ? void 0 : _upmAvailableApp$vend2.marketplaceLink)), $c44dc7ac64a27d3b$export$8a39838a0f735648('vendorType', upmAvailableApp.vendor ? upmAvailableApp.vendor.isAtlassian ? 'internal' : 'thirdParty' : undefined)), $c44dc7ac64a27d3b$export$8a39838a0f735648('icon', (_upmAvailableApp$logo = upmAvailableApp.logo) === null || _upmAvailableApp$logo === void 0 ? void 0 : _upmAvailableApp$logo.link)), $c44dc7ac64a27d3b$export$8a39838a0f735648('privacyPolicy', upmAvailableApp.links.privacy)), $c44dc7ac64a27d3b$export$8a39838a0f735648('eula', upmAvailableApp.links.eula)), {}, {
        metadata: undefined
    });
};
const $c44dc7ac64a27d3b$export$473c8c83f60f5929 = (upmAvailableApp)=>({
        isEligible: Boolean(upmAvailableApp.cmtEligible),
        btfSenEndDate: upmAvailableApp.btfSenEndDate ? new Date(upmAvailableApp.btfSenEndDate) : undefined
    });
const $c44dc7ac64a27d3b$export$6a97a6c22226d99 = (upmAvailableApp)=>({
        details: $c44dc7ac64a27d3b$export$96613f433d2dc4e1(upmAvailableApp),
        preinstalled: upmAvailableApp.preinstalled,
        scopes: (upmAvailableApp.permissions || []).map((p)=>p.key),
        metadata: undefined,
        eligibleForFreeOnSandbox: upmAvailableApp.eligibleForFreeOnSandbox,
        cloudMigrationTrial: $c44dc7ac64a27d3b$export$473c8c83f60f5929(upmAvailableApp)
    });
function $c44dc7ac64a27d3b$export$8a39838a0f735648(prop, value) {
    return value !== undefined && value !== null ? {
        [prop]: value
    } : {};
}
function $c44dc7ac64a27d3b$export$8d07be9e36a46378(marketplaceApp, environment, getStartedUrl, configureUrl, manageUrl, paymentModel) {
    return $c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread($c44dc7ac64a27d3b$var$_objectSpread({
        details: $c44dc7ac64a27d3b$export$5e09a4327db89926(marketplaceApp, environment),
        scopes: $c44dc7ac64a27d3b$var$resolveScopes(marketplaceApp),
        enabled: true,
        latestVersion: true,
        installationId: marketplaceApp.appKey
    }, $c44dc7ac64a27d3b$export$8a39838a0f735648('getStartedUrl', getStartedUrl)), $c44dc7ac64a27d3b$export$8a39838a0f735648('configureUrl', configureUrl)), $c44dc7ac64a27d3b$export$8a39838a0f735648('manageAppUrl', manageUrl)), {}, {
        paymentModel: paymentModel,
        installTime: new Date(),
        authType: {
            type: '2LO'
        },
        metadata: undefined
    });
}
function $c44dc7ac64a27d3b$export$43197df0fd5cbe13(marketplaceApp, upmInstalledApp, installedMarketplacePlugin, environment) {
    var _upmInstalledApp$link, _upmInstalledApp$link2, _upmInstalledApp$link3;
    const getStartedUrl = (_upmInstalledApp$link = upmInstalledApp.links) === null || _upmInstalledApp$link === void 0 ? void 0 : _upmInstalledApp$link.postInstall;
    const configureUrl = (_upmInstalledApp$link2 = upmInstalledApp.links) === null || _upmInstalledApp$link2 === void 0 ? void 0 : _upmInstalledApp$link2.configure;
    const manageAppUrl = (_upmInstalledApp$link3 = upmInstalledApp.links) === null || _upmInstalledApp$link3 === void 0 ? void 0 : _upmInstalledApp$link3.manage;
    return $c44dc7ac64a27d3b$export$7bfa491acf3d6091(installedMarketplacePlugin, marketplaceApp).map((spiPaymentModel)=>$c44dc7ac64a27d3b$export$8d07be9e36a46378(marketplaceApp, environment, getStartedUrl, configureUrl, manageAppUrl, spiPaymentModel));
}
const $c44dc7ac64a27d3b$export$46b1f780882f13c2 = {
    type: 'free'
};
const $c44dc7ac64a27d3b$export$9c59fa02e3730dbe = (sr)=>({
        type: 'paid',
        licenseType: sr
    });
const $c44dc7ac64a27d3b$var$getEvaluationLicenseType = (expiry, isAutoRenewal)=>expiry != null ? (0, $iZFTO.Either).right({
        type: 'evaluation',
        expiry: expiry,
        isAutoRenewal: isAutoRenewal
    }) : (0, $iZFTO.Either).left('Unable to get Expiry date for evaluation license');
const $c44dc7ac64a27d3b$var$getSubscriptionLicenseType = (endDate, isAutoRenewal)=>isAutoRenewal ? (0, $iZFTO.Either).right({
        type: 'subscription',
        renewalType: {
            isAutoRenewal: true
        }
    }) : endDate != null ? (0, $iZFTO.Either).right({
        type: 'subscription',
        renewalType: {
            isAutoRenewal: false,
            endDate: endDate
        }
    }) : (0, $iZFTO.Either).left('Unable to get end date for subscription license');
const $c44dc7ac64a27d3b$export$7bfa491acf3d6091 = (imp, mp)=>{
    var _mp$version;
    const paymentModel = (_mp$version = mp.version) === null || _mp$version === void 0 ? void 0 : _mp$version.paymentModel;
    if (!paymentModel) return (0, $iZFTO.Either).left('Unable to get payment model from marketplace');
    return (0, $c0juV.foldPaymentModel)(paymentModel)(()=>(0, $iZFTO.Either).right($c44dc7ac64a27d3b$export$46b1f780882f13c2), ()=>{
        var _imp$licenseDetails, _imp$licenseDetails2, _imp$licenseDetails3;
        const evaluation = (_imp$licenseDetails = imp.licenseDetails) === null || _imp$licenseDetails === void 0 ? void 0 : _imp$licenseDetails.evaluation;
        const autoRenewal = (_imp$licenseDetails2 = imp.licenseDetails) === null || _imp$licenseDetails2 === void 0 ? void 0 : _imp$licenseDetails2.autoRenewal;
        const expiryDate = (_imp$licenseDetails3 = imp.licenseDetails) === null || _imp$licenseDetails3 === void 0 ? void 0 : _imp$licenseDetails3.expiryDate;
        if (evaluation != null && autoRenewal != null) {
            var _imp$licenseDetails4;
            return evaluation ? $c44dc7ac64a27d3b$var$getEvaluationLicenseType(expiryDate, autoRenewal).map($c44dc7ac64a27d3b$export$9c59fa02e3730dbe) : $c44dc7ac64a27d3b$var$getSubscriptionLicenseType((_imp$licenseDetails4 = imp.licenseDetails) === null || _imp$licenseDetails4 === void 0 ? void 0 : _imp$licenseDetails4.subscriptionEndDate, autoRenewal).map($c44dc7ac64a27d3b$export$9c59fa02e3730dbe);
        } else return (0, $iZFTO.Either).left('Unable to get subscription information from UPM');
    }, ()=>(0, $iZFTO.Either).left('Cannot get subscription information for a PvV app'));
};
function $c44dc7ac64a27d3b$export$9f0387e1e9b3eead(upmBaseUrl) {
    return upmBaseUrl === '' ? 'same-origin' : 'include';
}
const $c44dc7ac64a27d3b$export$8ff5edbc8a5b1a81 = (array, getKeyFunction)=>array.reduce((acc, value)=>{
        acc[getKeyFunction(value)] = value;
        return acc;
    }, {});
const $c44dc7ac64a27d3b$export$581b3b2292f173ff = (version, marketplaceInstallation)=>{
    var _marketplaceInstallat, _marketplaceInstallat2;
    let type = {
        type: 'free'
    };
    const trialEndDate = (_marketplaceInstallat = marketplaceInstallation.license) === null || _marketplaceInstallat === void 0 ? void 0 : _marketplaceInstallat.trialEndDate;
    const isEvaluation = (_marketplaceInstallat2 = marketplaceInstallation.license) === null || _marketplaceInstallat2 === void 0 ? void 0 : _marketplaceInstallat2.isEvaluation;
    if (version.paymentModel === 'PAID_VIA_ATLASSIAN') {
        if (isEvaluation && trialEndDate) {
            type = {
                type: 'paid',
                licenseType: {
                    type: 'evaluation',
                    expiry: Date.parse(trialEndDate),
                    isAutoRenewal: true
                }
            };
            return type;
        }
        type = {
            type: 'paid',
            licenseType: {
                type: 'subscription',
                renewalType: {
                    isAutoRenewal: true
                }
            }
        };
    }
    return type;
};

});
parcelRegister("9fEFB", function(module, exports) {

$parcel$export(module.exports, "appDetailsLink", () => $6bc50ffb339ccad0$export$2af744f50ccb482a);
$parcel$export(module.exports, "appListingLink", () => $6bc50ffb339ccad0$export$e62f9cc984625834);
$parcel$export(module.exports, "mediaImageLink", () => $6bc50ffb339ccad0$export$b638f7d0a6d44986);
$parcel$export(module.exports, "linkTemplates", () => $6bc50ffb339ccad0$export$9e66cf49300a220c);

var $asbhz = parcelRequire("asbhz");
const $6bc50ffb339ccad0$export$4d75019b4283ecea = function adminHubLink() {
    let adminHubBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(adminHubBaseUrl);
};
const $6bc50ffb339ccad0$export$de647789330ef8b6 = function archivePartnerLink() {
    let mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse("".concat(mpacBaseUrl, "/archive/vendors/{partnerId}"));
};
const $6bc50ffb339ccad0$export$2af744f50ccb482a = function appDetailsLink() {
    let mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse("".concat(mpacBaseUrl, "/plugins/{appKey}/overview"));
};
const $6bc50ffb339ccad0$export$9c10277230abad0d = function appRatingLink() {
    let mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/plugins/{appKey}/reviews');
};
const $6bc50ffb339ccad0$export$943308b735a87d70 = function appIconLink() {
    let mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/plugins/{appKey}/icon');
};
const $6bc50ffb339ccad0$export$e62f9cc984625834 = function appListingLink() {
    let mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse("".concat(mpacBaseUrl, "/apps/{appId}/{slug}?hosting={hosting}&tab={tab}"));
};
const $6bc50ffb339ccad0$export$7902720f9d6d3285 = function archivedAppLink() {
    let mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse("".concat(mpacBaseUrl, "/archive/{appId}"));
};
const $6bc50ffb339ccad0$export$c267fb62c4d84d76 = function partnerDetailsLink() {
    let mpacBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/vendors/{id}/{slug}');
};
const $6bc50ffb339ccad0$export$b638f7d0a6d44986 = function mediaImageLink() {
    let mpacCdnBaseUrl = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacCdnBaseUrl + '/files/{imageId}?fileType=image&mode=full-fit');
};
const $6bc50ffb339ccad0$var$EmptyLinkTemplate = {
    expand: ()=>''
};
const $6bc50ffb339ccad0$export$9e66cf49300a220c = (_ref)=>{
    let { adminHubBaseUrl: adminHubBaseUrl, mpacBaseUrl: mpacBaseUrl, mpacCdnBaseUrl: mpacCdnBaseUrl, macBaseUrl: macBaseUrl, wacBaseUrl: wacBaseUrl, atlassianCommunityBaseUrl: atlassianCommunityBaseUrl } = _ref;
    return {
        adminHub: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(adminHubBaseUrl),
        marketplaceTermsOfUse: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(wacBaseUrl + '/licensing/marketplace/termsofuse/'),
        appDetails: $6bc50ffb339ccad0$export$2af744f50ccb482a(mpacBaseUrl),
        appPricingDetails: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/plugins/{appKey}/pricing'),
        mediaFile: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacCdnBaseUrl + '/files/{imageId}'),
        mediaImage: $6bc50ffb339ccad0$export$b638f7d0a6d44986(mpacCdnBaseUrl),
        appHostingDetails: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/plugins/{appKey}/{hosting}/overview'),
        appIcon: $6bc50ffb339ccad0$export$943308b735a87d70(mpacBaseUrl),
        appRating: $6bc50ffb339ccad0$export$9c10277230abad0d(mpacBaseUrl),
        appManageLink: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/manage/apps/{appId}'),
        appShortLink: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/{appId}'),
        managePrivateListing: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/manage/apps/{appId}/private-listings'),
        partnerDetails: $6bc50ffb339ccad0$export$c267fb62c4d84d76(mpacBaseUrl),
        appCreateCommunityQuestionLink: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse("".concat(atlassianCommunityBaseUrl, "/t5/custom/page/page-id/create-post-step-1?add-tags=atlassian-marketplace,addon-{appKey},{hosting}")),
        appVersionHistory: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/apps/{appId}/{appSlug}/version-history?versionHistoryHosting={hosting}'),
        artifactDownload: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/download/apps/{appId}/version/{buildNumber}'),
        descriptorDownload: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(mpacBaseUrl + '/download/apps/{appId}/version/{buildNumber}/descriptor'),
        appListingCanonical: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse("".concat(mpacBaseUrl, "/apps/{appId}/{slug}")),
        appListing: $6bc50ffb339ccad0$export$e62f9cc984625834(mpacBaseUrl),
        trialLicenseActivation: macBaseUrl ? (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(macBaseUrl + '/addon/try/{hamsAppKey}') : $6bc50ffb339ccad0$var$EmptyLinkTemplate,
        licensePurchase: wacBaseUrl ? (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(wacBaseUrl + '/purchase/addon/{hamsAppKey}') : $6bc50ffb339ccad0$var$EmptyLinkTemplate
    };
};
const $6bc50ffb339ccad0$export$7c41ce19876991bc = ()=>({
        // Todo - specify return type of manageAppsTabRoutes
        appPricing: (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse('/manage/apps/{appKey}/pricing')
    });
const $6bc50ffb339ccad0$export$2d5f19459b59e72b = (link)=>{
    return /\/apps\/\d+\/[^/]+?/.test(link);
};

});

parcelRegister("iZFTO", function(module, exports) {

$parcel$export(module.exports, "Either", () => $dd3e6cce71afb005$export$37cbe166bfc81b63);
function $dd3e6cce71afb005$export$b24f7407c77e5bd(ref) {
    return !!(ref && typeof ref.equals === "function" && typeof ref.hashCode === "function");
}
function $dd3e6cce71afb005$export$226b3eccf92c9ed9(lh, rh) {
    if (lh === rh || lh !== lh && rh !== rh) return true;
    if (!lh || !rh) return false;
    if (typeof lh.valueOf === "function" && typeof rh.valueOf === "function") {
        var lh2 = lh.valueOf();
        var rh2 = rh.valueOf();
        if (lh2 === rh2 || lh2 !== lh2 && rh2 !== rh2) return true;
        if (!lh2 || !rh2) return false;
    }
    return !!($dd3e6cce71afb005$export$b24f7407c77e5bd(lh) && lh.equals(rh));
}
function $dd3e6cce71afb005$export$e9bab7fafb253603(lh, rh) {
    return $dd3e6cce71afb005$export$226b3eccf92c9ed9(lh, rh);
}
var $dd3e6cce71afb005$export$280f210877e5565b = {
    equals: $dd3e6cce71afb005$export$e9bab7fafb253603
};
function $dd3e6cce71afb005$export$d41d9ab3de2def3d(ref) {
    if (typeof ref === "number") return ref & ref;
    if (typeof ref.valueOf === "function") {
        var v = ref.valueOf();
        if (v !== ref) return $dd3e6cce71afb005$export$d41d9ab3de2def3d(v);
    }
    if ($dd3e6cce71afb005$export$b24f7407c77e5bd(ref)) return ref.hashCode();
    return $dd3e6cce71afb005$export$39e05520a596a3da(String(ref));
}
function $dd3e6cce71afb005$export$39e05520a596a3da(str) {
    var hash = 0;
    if (str == null || str.length === 0) return hash;
    for(var i = 0; i < str.length; i++){
        var character = str.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash;
    }
    return hash;
}
function $dd3e6cce71afb005$export$d560c7e4a29451c2(a) {
    return a;
}
function $dd3e6cce71afb005$export$6ccb92ce135089b4(derivedCtor, baseCtors) {
    baseCtors.forEach(function(baseCtor) {
        Object.getOwnPropertyNames(baseCtor.prototype).forEach(function(name) {
            if (!derivedCtor.prototype[name]) derivedCtor.prototype[name] = baseCtor.prototype[name];
        });
    });
}
var $dd3e6cce71afb005$var$classCallCheck = function(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
};
var $dd3e6cce71afb005$var$createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
var $dd3e6cce71afb005$var$inherits = function(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var $dd3e6cce71afb005$var$possibleConstructorReturn = function(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var $dd3e6cce71afb005$export$6fbeb926bac523c3 = function(_Error) {
    $dd3e6cce71afb005$var$inherits(CompositeError, _Error);
    function CompositeError(errors) {
        $dd3e6cce71afb005$var$classCallCheck(this, CompositeError);
        var reasons = "";
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;
        try {
            for(var _iterator = errors.slice(0, 2)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var e = _step.value;
                var message = "";
                if (e instanceof Error) message = e.name + "(" + e.message + ")";
                else message = "" + e;
                reasons += ", " + message;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return) _iterator.return();
            } finally{
                if (_didIteratorError) throw _iteratorError;
            }
        }
        reasons = reasons.slice(2);
        if (errors.length > 2) reasons = reasons + ", ...";
        var _this = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (CompositeError.__proto__ || Object.getPrototypeOf(CompositeError)).call(this, reasons));
        _this.name = "CompositeError";
        _this.errorsRef = errors;
        var self = _this;
        self.constructor = CompositeError;
        self.__proto__ = CompositeError.prototype;
        return _this;
    }
    $dd3e6cce71afb005$var$createClass(CompositeError, [
        {
            key: "errors",
            value: function errors() {
                return this.errorsRef.slice();
            }
        }
    ]);
    return CompositeError;
}(Error);
var $dd3e6cce71afb005$export$4a48f57740b5ad1e = function(_Error2) {
    $dd3e6cce71afb005$var$inherits(DummyError, _Error2);
    function DummyError(message) {
        $dd3e6cce71afb005$var$classCallCheck(this, DummyError);
        var _this2 = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (DummyError.__proto__ || Object.getPrototypeOf(DummyError)).call(this, message));
        _this2.name = "DummyError";
        var self = _this2;
        self.constructor = DummyError;
        self.__proto__ = DummyError.prototype;
        return _this2;
    }
    return DummyError;
}(Error);
var $dd3e6cce71afb005$export$48d368d160387990 = function(_Error3) {
    $dd3e6cce71afb005$var$inherits(NoSuchElementError, _Error3);
    function NoSuchElementError(message) {
        $dd3e6cce71afb005$var$classCallCheck(this, NoSuchElementError);
        var _this3 = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (NoSuchElementError.__proto__ || Object.getPrototypeOf(NoSuchElementError)).call(this, message));
        _this3.name = "NoSuchElementError";
        var self = _this3;
        self.constructor = NoSuchElementError;
        self.__proto__ = NoSuchElementError.prototype;
        return _this3;
    }
    return NoSuchElementError;
}(Error);
var $dd3e6cce71afb005$export$e6c18cacaad31d56 = function(_Error4) {
    $dd3e6cce71afb005$var$inherits(IllegalInheritanceError, _Error4);
    function IllegalInheritanceError(message) {
        $dd3e6cce71afb005$var$classCallCheck(this, IllegalInheritanceError);
        var _this4 = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (IllegalInheritanceError.__proto__ || Object.getPrototypeOf(IllegalInheritanceError)).call(this, message));
        _this4.name = "IllegalInheritanceError";
        var self = _this4;
        self.constructor = IllegalInheritanceError;
        self.__proto__ = IllegalInheritanceError.prototype;
        return _this4;
    }
    return IllegalInheritanceError;
}(Error);
var $dd3e6cce71afb005$export$25b19446f82d7080 = function(_Error5) {
    $dd3e6cce71afb005$var$inherits(IllegalStateError, _Error5);
    function IllegalStateError(message) {
        $dd3e6cce71afb005$var$classCallCheck(this, IllegalStateError);
        var _this5 = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (IllegalStateError.__proto__ || Object.getPrototypeOf(IllegalStateError)).call(this, message));
        _this5.name = "IllegalStateError";
        var self = _this5;
        self.constructor = IllegalStateError;
        self.__proto__ = IllegalStateError.prototype;
        return _this5;
    }
    return IllegalStateError;
}(Error);
var $dd3e6cce71afb005$export$10a4c2bfc9c71dbd = function(_Error6) {
    $dd3e6cce71afb005$var$inherits(IllegalArgumentError, _Error6);
    function IllegalArgumentError(message) {
        $dd3e6cce71afb005$var$classCallCheck(this, IllegalArgumentError);
        var _this6 = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (IllegalArgumentError.__proto__ || Object.getPrototypeOf(IllegalArgumentError)).call(this, message));
        _this6.name = "IllegalArgumentError";
        var self = _this6;
        self.constructor = IllegalArgumentError;
        self.__proto__ = IllegalArgumentError.prototype;
        return _this6;
    }
    return IllegalArgumentError;
}(Error);
var $dd3e6cce71afb005$export$e162153238934121 = function(_Error7) {
    $dd3e6cce71afb005$var$inherits(NotImplementedError, _Error7);
    function NotImplementedError(message) {
        $dd3e6cce71afb005$var$classCallCheck(this, NotImplementedError);
        var _this7 = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (NotImplementedError.__proto__ || Object.getPrototypeOf(NotImplementedError)).call(this, message));
        _this7.name = "NotImplementedError";
        var self = _this7;
        self.constructor = NotImplementedError;
        self.__proto__ = NotImplementedError.prototype;
        return _this7;
    }
    return NotImplementedError;
}(Error);
var $dd3e6cce71afb005$export$66d311bf29d5c89c = function(_Error8) {
    $dd3e6cce71afb005$var$inherits(TimeoutError, _Error8);
    function TimeoutError(message) {
        $dd3e6cce71afb005$var$classCallCheck(this, TimeoutError);
        var _this8 = $dd3e6cce71afb005$var$possibleConstructorReturn(this, (TimeoutError.__proto__ || Object.getPrototypeOf(TimeoutError)).call(this, message));
        _this8.name = "TimeoutError";
        var self = _this8;
        self.constructor = TimeoutError;
        self.__proto__ = TimeoutError.prototype;
        return _this8;
    }
    return TimeoutError;
}(Error);
function $dd3e6cce71afb005$var$convertToMethod(f) {
    return function() {
        var args = Array.prototype.slice.call(arguments);
        args.push(this);
        return f.apply(undefined, args);
    };
}
function $dd3e6cce71afb005$var$fantasyLandRegister(cls, monad, setoid) {
    var c = cls;
    var p = c.prototype;
    var fl = "fantasy-land/";
    var equals = "equals";
    var flEquals = fl + equals;
    var map = "map";
    var flMap = fl + map;
    var ap = "ap";
    var flAp = fl + ap;
    var flOf = fl + "of";
    var chain = "chain";
    var flChain = fl + chain;
    var chainRec = "chainRec";
    var flChainRec = fl + chainRec;
    if (p[equals]) p[flEquals] = p[equals];
    else if (setoid) p[flEquals] = $dd3e6cce71afb005$var$convertToMethod(setoid.equals);
    if (p[map]) p[flMap] = p[map];
    else if (monad) p[flMap] = $dd3e6cce71afb005$var$convertToMethod(monad.map);
    if (p[ap]) p[flAp] = p[ap];
    else if (monad) p[flAp] = $dd3e6cce71afb005$var$convertToMethod(monad.ap);
    if (c["pure"]) c[flOf] = c["pure"];
    else if (monad) c[flOf] = monad.of;
    if (p[chain]) p[flChain] = p[chain];
    else if (monad) p[flChain] = $dd3e6cce71afb005$var$convertToMethod(monad.chain);
    if (c[chainRec]) c[flChainRec] = c[chainRec];
    else if (monad) c[flChainRec] = monad.chainRec;
}
var $dd3e6cce71afb005$export$37fdcdf447590763 = Object.freeze({
    convertToMethod: $dd3e6cce71afb005$var$convertToMethod,
    fantasyLandRegister: $dd3e6cce71afb005$var$fantasyLandRegister
});
var $dd3e6cce71afb005$export$37cbe166bfc81b63 = function() {
    function Either(value, tag) {
        $dd3e6cce71afb005$var$classCallCheck(this, Either);
        this._isRight = tag === "right";
        this.value = value;
    }
    $dd3e6cce71afb005$var$createClass(Either, [
        {
            key: "isLeft",
            value: function isLeft() {
                return !this._isRight;
            }
        },
        {
            key: "isRight",
            value: function isRight() {
                return this._isRight;
            }
        },
        {
            key: "contains",
            value: function contains(elem) {
                return this._isRight && $dd3e6cce71afb005$export$226b3eccf92c9ed9(this.value, elem);
            }
        },
        {
            key: "exists",
            value: function exists(p) {
                return this._isRight && p(this.value);
            }
        },
        {
            key: "filterOrElse",
            value: function filterOrElse(p, zero) {
                return this._isRight ? p(this.value) ? this : $dd3e6cce71afb005$export$37c4d04eafdc5515(zero()) : this;
            }
        },
        {
            key: "flatMap",
            value: function flatMap(f) {
                return this._isRight ? f(this.value) : this;
            }
        },
        {
            key: "chain",
            value: function chain(f) {
                return this.flatMap(f);
            }
        },
        {
            key: "ap",
            value: function ap(ff) {
                var _this = this;
                return ff.flatMap(function(f) {
                    return _this.map(f);
                });
            }
        },
        {
            key: "fold",
            value: function fold(left, right) {
                return this._isRight ? right(this.value) : left(this.value);
            }
        },
        {
            key: "forAll",
            value: function forAll(p) {
                return !this._isRight || p(this.value);
            }
        },
        {
            key: "get",
            value: function get$$1() {
                if (this._isRight) return this.value;
                throw new $dd3e6cce71afb005$export$48d368d160387990("left.get()");
            }
        },
        {
            key: "getOrElse",
            value: function getOrElse(fallback) {
                return this._isRight ? this.value : fallback;
            }
        },
        {
            key: "getOrElseL",
            value: function getOrElseL(thunk) {
                return this._isRight ? this.value : thunk();
            }
        },
        {
            key: "map",
            value: function map(f) {
                return this._isRight ? $dd3e6cce71afb005$export$19db0165690c701a(f(this.value)) : this;
            }
        },
        {
            key: "forEach",
            value: function forEach(cb) {
                if (this._isRight) cb(this.value);
            }
        },
        {
            key: "swap",
            value: function swap() {
                return this._isRight ? $dd3e6cce71afb005$export$37c4d04eafdc5515(this.value) : $dd3e6cce71afb005$export$19db0165690c701a(this.value);
            }
        },
        {
            key: "toOption",
            value: function toOption() {
                return this._isRight ? $dd3e6cce71afb005$export$9f9d0139d032da4f(this.value) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "equals",
            value: function equals$$1(that) {
                if (that == null) return false;
                return this._isRight === that._isRight && $dd3e6cce71afb005$export$226b3eccf92c9ed9(this.value, that.value);
            }
        },
        {
            key: "hashCode",
            value: function hashCode$$1() {
                return this._isRight ? $dd3e6cce71afb005$export$d41d9ab3de2def3d(this.value) << 2 : $dd3e6cce71afb005$export$d41d9ab3de2def3d(this.value) << 3;
            }
        }
    ], [
        {
            key: "pure",
            value: function pure(value) {
                return new $dd3e6cce71afb005$export$8cd6fcff08338c9a(value);
            }
        },
        {
            key: "left",
            value: function left(value) {
                return $dd3e6cce71afb005$export$37c4d04eafdc5515(value);
            }
        },
        {
            key: "right",
            value: function right(value) {
                return $dd3e6cce71afb005$export$19db0165690c701a(value);
            }
        },
        {
            key: "map2",
            value: function map2(fa1, fa2, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                return $dd3e6cce71afb005$export$19db0165690c701a(f(fa1.value, fa2.value));
            }
        },
        {
            key: "map3",
            value: function map3(fa1, fa2, fa3, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                if (fa3.isLeft()) return fa3;
                return $dd3e6cce71afb005$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value));
            }
        },
        {
            key: "map4",
            value: function map4(fa1, fa2, fa3, fa4, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                if (fa3.isLeft()) return fa3;
                if (fa4.isLeft()) return fa4;
                return $dd3e6cce71afb005$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value));
            }
        },
        {
            key: "map5",
            value: function map5(fa1, fa2, fa3, fa4, fa5, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                if (fa3.isLeft()) return fa3;
                if (fa4.isLeft()) return fa4;
                if (fa5.isLeft()) return fa5;
                return $dd3e6cce71afb005$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value));
            }
        },
        {
            key: "map6",
            value: function map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
                if (fa1.isLeft()) return fa1;
                if (fa2.isLeft()) return fa2;
                if (fa3.isLeft()) return fa3;
                if (fa4.isLeft()) return fa4;
                if (fa5.isLeft()) return fa5;
                if (fa6.isLeft()) return fa6;
                return $dd3e6cce71afb005$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value));
            }
        },
        {
            key: "tailRecM",
            value: function tailRecM(a, f) {
                var cursor = a;
                while(true){
                    var result = f(cursor);
                    if (!result.isRight()) return result;
                    var some = result.value;
                    if (some.isRight()) return $dd3e6cce71afb005$export$19db0165690c701a(some.value);
                    cursor = some.value;
                }
            }
        }
    ]);
    return Either;
}();
var $dd3e6cce71afb005$export$500560ce56dda718 = function(_Either) {
    $dd3e6cce71afb005$var$inherits(TLeft, _Either);
    function TLeft(value) {
        $dd3e6cce71afb005$var$classCallCheck(this, TLeft);
        return $dd3e6cce71afb005$var$possibleConstructorReturn(this, (TLeft.__proto__ || Object.getPrototypeOf(TLeft)).call(this, value, "left"));
    }
    return TLeft;
}($dd3e6cce71afb005$export$37cbe166bfc81b63);
function $dd3e6cce71afb005$export$37c4d04eafdc5515(value) {
    return new $dd3e6cce71afb005$export$500560ce56dda718(value);
}
var $dd3e6cce71afb005$export$8cd6fcff08338c9a = function(_Either2) {
    $dd3e6cce71afb005$var$inherits(TRight, _Either2);
    function TRight(value) {
        $dd3e6cce71afb005$var$classCallCheck(this, TRight);
        return $dd3e6cce71afb005$var$possibleConstructorReturn(this, (TRight.__proto__ || Object.getPrototypeOf(TRight)).call(this, value, "right"));
    }
    return TRight;
}($dd3e6cce71afb005$export$37cbe166bfc81b63);
function $dd3e6cce71afb005$export$19db0165690c701a(value) {
    return new $dd3e6cce71afb005$export$8cd6fcff08338c9a(value);
}
var $dd3e6cce71afb005$export$e772b5f99e4d377d = {
    equals: function equals$$1(x, y) {
        return x ? x.equals(y) : !y;
    },
    map: function map(f, fa) {
        return fa.map(f);
    },
    ap: function ap(ff, fa) {
        return fa.ap(ff);
    },
    of: $dd3e6cce71afb005$export$37cbe166bfc81b63.pure,
    chain: function chain(f, fa) {
        return fa.flatMap(f);
    },
    chainRec: function chainRec(f, a) {
        return $dd3e6cce71afb005$export$37cbe166bfc81b63.tailRecM(a, function(a) {
            return f($dd3e6cce71afb005$export$37cbe166bfc81b63.left, $dd3e6cce71afb005$export$37cbe166bfc81b63.right, a);
        });
    }
};
$dd3e6cce71afb005$var$fantasyLandRegister($dd3e6cce71afb005$export$37cbe166bfc81b63, $dd3e6cce71afb005$export$e772b5f99e4d377d, $dd3e6cce71afb005$export$e772b5f99e4d377d);
var $dd3e6cce71afb005$export$36d18380658d5d20 = function() {
    function Option(ref, isEmpty) {
        $dd3e6cce71afb005$var$classCallCheck(this, Option);
        this._isEmpty = isEmpty != null ? isEmpty : ref === null || ref === undefined;
        this.value = ref;
    }
    $dd3e6cce71afb005$var$createClass(Option, [
        {
            key: "get",
            value: function get$$1() {
                if (!this._isEmpty) return this.value;
                throw new $dd3e6cce71afb005$export$48d368d160387990("Option.get");
            }
        },
        {
            key: "getOrElse",
            value: function getOrElse(fallback) {
                if (!this._isEmpty) return this.value;
                else return fallback;
            }
        },
        {
            key: "orNull",
            value: function orNull() {
                return !this._isEmpty ? this.value : null;
            }
        },
        {
            key: "orUndefined",
            value: function orUndefined() {
                return !this._isEmpty ? this.value : undefined;
            }
        },
        {
            key: "getOrElseL",
            value: function getOrElseL(thunk) {
                if (!this._isEmpty) return this.value;
                else return thunk();
            }
        },
        {
            key: "orElse",
            value: function orElse(fallback) {
                if (!this._isEmpty) return this;
                else return fallback;
            }
        },
        {
            key: "orElseL",
            value: function orElseL(thunk) {
                if (!this._isEmpty) return this;
                else return thunk();
            }
        },
        {
            key: "isEmpty",
            value: function isEmpty() {
                return this._isEmpty;
            }
        },
        {
            key: "nonEmpty",
            value: function nonEmpty() {
                return !this._isEmpty;
            }
        },
        {
            key: "map",
            value: function map(f) {
                return this._isEmpty ? $dd3e6cce71afb005$export$57ca7e07b341709d : $dd3e6cce71afb005$export$9f9d0139d032da4f(f(this.value));
            }
        },
        {
            key: "flatMap",
            value: function flatMap(f) {
                if (this._isEmpty) return $dd3e6cce71afb005$export$57ca7e07b341709d;
                else return f(this.value);
            }
        },
        {
            key: "chain",
            value: function chain(f) {
                return this.flatMap(f);
            }
        },
        {
            key: "ap",
            value: function ap(ff) {
                var _this4 = this;
                return ff.flatMap(function(f) {
                    return _this4.map(f);
                });
            }
        },
        {
            key: "filter",
            value: function filter(p) {
                if (this._isEmpty || !p(this.value)) return $dd3e6cce71afb005$export$57ca7e07b341709d;
                else return this;
            }
        },
        {
            key: "fold",
            value: function fold(fallback, f) {
                if (this._isEmpty) return fallback();
                return f(this.value);
            }
        },
        {
            key: "contains",
            value: function contains(elem) {
                return !this._isEmpty && $dd3e6cce71afb005$export$226b3eccf92c9ed9(this.value, elem);
            }
        },
        {
            key: "exists",
            value: function exists(p) {
                return !this._isEmpty && p(this.value);
            }
        },
        {
            key: "forAll",
            value: function forAll(p) {
                return this._isEmpty || p(this.value);
            }
        },
        {
            key: "forEach",
            value: function forEach(cb) {
                if (!this._isEmpty) cb(this.value);
            }
        },
        {
            key: "equals",
            value: function equals$$1(that) {
                if (that == null) return false;
                if (this.nonEmpty() && that.nonEmpty()) return $dd3e6cce71afb005$export$226b3eccf92c9ed9(this.value, that.value);
                return this.isEmpty() && that.isEmpty();
            }
        },
        {
            key: "hashCode",
            value: function hashCode$$1() {
                if (this._isEmpty) return 2433880;
                else if (this.value == null) return 9735524;
                else return $dd3e6cce71afb005$export$d41d9ab3de2def3d(this.value) << 2;
            }
        }
    ], [
        {
            key: "of",
            value: function of(value) {
                return value != null ? $dd3e6cce71afb005$export$9f9d0139d032da4f(value) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "some",
            value: function some(value) {
                return new Option(value, false);
            }
        },
        {
            key: "none",
            value: function none() {
                return $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "empty",
            value: function empty() {
                return $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "pure",
            value: function pure(value) {
                return $dd3e6cce71afb005$export$9f9d0139d032da4f(value);
            }
        },
        {
            key: "map2",
            value: function map2(fa1, fa2, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() ? $dd3e6cce71afb005$export$9f9d0139d032da4f(f(fa1.value, fa2.value)) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "map3",
            value: function map3(fa1, fa2, fa3, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() ? $dd3e6cce71afb005$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value)) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "map4",
            value: function map4(fa1, fa2, fa3, fa4, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() ? $dd3e6cce71afb005$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value)) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "map5",
            value: function map5(fa1, fa2, fa3, fa4, fa5, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() && fa5.nonEmpty() ? $dd3e6cce71afb005$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value)) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "map6",
            value: function map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
                return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() && fa5.nonEmpty() && fa6.nonEmpty() ? $dd3e6cce71afb005$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value)) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "tailRecM",
            value: function tailRecM(a, f) {
                var cursor = a;
                while(true){
                    var result = f(cursor);
                    if (result.nonEmpty()) {
                        var some = result.value;
                        if (some.isRight()) return $dd3e6cce71afb005$export$9f9d0139d032da4f(some.value);
                        cursor = some.value;
                    } else return $dd3e6cce71afb005$export$57ca7e07b341709d;
                }
            }
        }
    ]);
    return Option;
}();
var $dd3e6cce71afb005$export$c279cda0429c6dbe = function(_Option) {
    $dd3e6cce71afb005$var$inherits(TSome, _Option);
    function TSome(value) {
        $dd3e6cce71afb005$var$classCallCheck(this, TSome);
        return $dd3e6cce71afb005$var$possibleConstructorReturn(this, (TSome.__proto__ || Object.getPrototypeOf(TSome)).call(this, value, false));
    }
    return TSome;
}($dd3e6cce71afb005$export$36d18380658d5d20);
function $dd3e6cce71afb005$export$9f9d0139d032da4f(value) {
    return new $dd3e6cce71afb005$export$c279cda0429c6dbe(value);
}
var $dd3e6cce71afb005$export$ee2288f2b4bc04c4 = function(_Option2) {
    $dd3e6cce71afb005$var$inherits(TNone, _Option2);
    function TNone() {
        $dd3e6cce71afb005$var$classCallCheck(this, TNone);
        return $dd3e6cce71afb005$var$possibleConstructorReturn(this, (TNone.__proto__ || Object.getPrototypeOf(TNone)).call(this, undefined, true));
    }
    return TNone;
}($dd3e6cce71afb005$export$36d18380658d5d20);
var $dd3e6cce71afb005$export$57ca7e07b341709d = new $dd3e6cce71afb005$export$ee2288f2b4bc04c4();
var $dd3e6cce71afb005$export$dae05fd938c910bc = {
    equals: function equals$$1(x, y) {
        return x ? x.equals(y) : !y;
    },
    map: function map(f, fa) {
        return fa.map(f);
    },
    ap: function ap(ff, fa) {
        return fa.ap(ff);
    },
    of: $dd3e6cce71afb005$export$36d18380658d5d20.pure,
    chain: function chain(f, fa) {
        return fa.flatMap(f);
    },
    chainRec: function chainRec(f, a) {
        return $dd3e6cce71afb005$export$36d18380658d5d20.tailRecM(a, function(a) {
            return f($dd3e6cce71afb005$export$37cbe166bfc81b63.left, $dd3e6cce71afb005$export$37cbe166bfc81b63.right, a);
        });
    }
};
$dd3e6cce71afb005$var$fantasyLandRegister($dd3e6cce71afb005$export$36d18380658d5d20, $dd3e6cce71afb005$export$dae05fd938c910bc, $dd3e6cce71afb005$export$dae05fd938c910bc);
var $dd3e6cce71afb005$export$fa957d01b0310fd7 = function() {
    function Try(value, tag) {
        $dd3e6cce71afb005$var$classCallCheck(this, Try);
        this._isSuccess = tag === "success";
        this.value = value;
    }
    $dd3e6cce71afb005$var$createClass(Try, [
        {
            key: "isSuccess",
            value: function isSuccess() {
                return this._isSuccess;
            }
        },
        {
            key: "isFailure",
            value: function isFailure() {
                return !this._isSuccess;
            }
        },
        {
            key: "get",
            value: function get$$1() {
                if (!this._isSuccess) throw this.value;
                return this.value;
            }
        },
        {
            key: "getOrElse",
            value: function getOrElse(fallback) {
                return this._isSuccess ? this.value : fallback;
            }
        },
        {
            key: "getOrElseL",
            value: function getOrElseL(thunk) {
                return this._isSuccess ? this.value : thunk();
            }
        },
        {
            key: "orNull",
            value: function orNull() {
                return this._isSuccess ? this.value : null;
            }
        },
        {
            key: "orUndefined",
            value: function orUndefined() {
                return this._isSuccess ? this.value : undefined;
            }
        },
        {
            key: "orElse",
            value: function orElse(fallback) {
                if (this._isSuccess) return this;
                return fallback;
            }
        },
        {
            key: "orElseL",
            value: function orElseL(thunk) {
                if (this._isSuccess) return this;
                return thunk();
            }
        },
        {
            key: "failed",
            value: function failed() {
                return this._isSuccess ? $dd3e6cce71afb005$export$5ebc9a4af3ac0850(new $dd3e6cce71afb005$export$48d368d160387990("try.failed()")) : $dd3e6cce71afb005$export$ffa3d9fee6fd705a(this.value);
            }
        },
        {
            key: "fold",
            value: function fold(failure, success) {
                return this._isSuccess ? success(this.value) : failure(this.value);
            }
        },
        {
            key: "filter",
            value: function filter(p) {
                if (!this._isSuccess) return this;
                try {
                    if (p(this.value)) return this;
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(new $dd3e6cce71afb005$export$48d368d160387990("Predicate does not hold for " + this.value));
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "flatMap",
            value: function flatMap(f) {
                if (!this._isSuccess) return this;
                try {
                    return f(this.value);
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "chain",
            value: function chain(f) {
                return this.flatMap(f);
            }
        },
        {
            key: "ap",
            value: function ap(ff) {
                var _this7 = this;
                return ff.flatMap(function(f) {
                    return _this7.map(f);
                });
            }
        },
        {
            key: "map",
            value: function map(f) {
                var _this8 = this;
                return this._isSuccess ? Try.of(function() {
                    return f(_this8.value);
                }) : this;
            }
        },
        {
            key: "forEach",
            value: function forEach(cb) {
                if (this._isSuccess) cb(this.value);
            }
        },
        {
            key: "recover",
            value: function recover(f) {
                var _this9 = this;
                return this._isSuccess ? this : Try.of(function() {
                    return f(_this9.value);
                });
            }
        },
        {
            key: "recoverWith",
            value: function recoverWith(f) {
                try {
                    return this._isSuccess ? this : f(this.value);
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "toOption",
            value: function toOption() {
                return this._isSuccess ? $dd3e6cce71afb005$export$9f9d0139d032da4f(this.value) : $dd3e6cce71afb005$export$57ca7e07b341709d;
            }
        },
        {
            key: "toEither",
            value: function toEither() {
                return this._isSuccess ? $dd3e6cce71afb005$export$19db0165690c701a(this.value) : $dd3e6cce71afb005$export$37c4d04eafdc5515(this.value);
            }
        },
        {
            key: "equals",
            value: function equals$$1(that) {
                if (that == null) return false;
                return this._isSuccess ? that._isSuccess && $dd3e6cce71afb005$export$226b3eccf92c9ed9(this.value, that.value) : !that._isSuccess && $dd3e6cce71afb005$export$226b3eccf92c9ed9(this.value, that.value);
            }
        },
        {
            key: "hashCode",
            value: function hashCode$$1() {
                return this._isSuccess ? $dd3e6cce71afb005$export$d41d9ab3de2def3d(this.value) : $dd3e6cce71afb005$export$d41d9ab3de2def3d(this.value);
            }
        }
    ], [
        {
            key: "of",
            value: function of(thunk) {
                try {
                    return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(thunk());
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "pure",
            value: function pure(value) {
                return Try.success(value);
            }
        },
        {
            key: "unit",
            value: function unit() {
                return $dd3e6cce71afb005$var$tryUnitRef;
            }
        },
        {
            key: "success",
            value: function success(value) {
                return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(value);
            }
        },
        {
            key: "failure",
            value: function failure(e) {
                return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
            }
        },
        {
            key: "raise",
            value: function raise(e) {
                return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
            }
        },
        {
            key: "map2",
            value: function map2(fa1, fa2, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                try {
                    return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value));
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "map3",
            value: function map3(fa1, fa2, fa3, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                if (fa3.isFailure()) return fa3;
                try {
                    return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value));
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "map4",
            value: function map4(fa1, fa2, fa3, fa4, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                if (fa3.isFailure()) return fa3;
                if (fa4.isFailure()) return fa4;
                try {
                    return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value));
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "map5",
            value: function map5(fa1, fa2, fa3, fa4, fa5, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                if (fa3.isFailure()) return fa3;
                if (fa4.isFailure()) return fa4;
                if (fa5.isFailure()) return fa5;
                try {
                    return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value));
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "map6",
            value: function map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
                if (fa1.isFailure()) return fa1;
                if (fa2.isFailure()) return fa2;
                if (fa3.isFailure()) return fa3;
                if (fa4.isFailure()) return fa4;
                if (fa5.isFailure()) return fa5;
                if (fa6.isFailure()) return fa6;
                try {
                    return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value));
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        },
        {
            key: "tailRecM",
            value: function tailRecM(a, f) {
                var cursor = a;
                while(true)try {
                    var result = f(cursor);
                    if (result.isFailure()) return result;
                    var some = result.get();
                    if (some.isRight()) return $dd3e6cce71afb005$export$ffa3d9fee6fd705a(some.value);
                    cursor = some.value;
                } catch (e) {
                    return $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e);
                }
            }
        }
    ]);
    return Try;
}();
var $dd3e6cce71afb005$export$a78bea8ed2ae2fde = function(_Try) {
    $dd3e6cce71afb005$var$inherits(TSuccess, _Try);
    function TSuccess(value) {
        $dd3e6cce71afb005$var$classCallCheck(this, TSuccess);
        return $dd3e6cce71afb005$var$possibleConstructorReturn(this, (TSuccess.__proto__ || Object.getPrototypeOf(TSuccess)).call(this, value, "success"));
    }
    return TSuccess;
}($dd3e6cce71afb005$export$fa957d01b0310fd7);
function $dd3e6cce71afb005$export$ffa3d9fee6fd705a(value) {
    return new $dd3e6cce71afb005$export$a78bea8ed2ae2fde(value);
}
var $dd3e6cce71afb005$export$a432f16a0795683f = function(_Try2) {
    $dd3e6cce71afb005$var$inherits(TFailure, _Try2);
    function TFailure(value) {
        $dd3e6cce71afb005$var$classCallCheck(this, TFailure);
        return $dd3e6cce71afb005$var$possibleConstructorReturn(this, (TFailure.__proto__ || Object.getPrototypeOf(TFailure)).call(this, value, "failure"));
    }
    return TFailure;
}($dd3e6cce71afb005$export$fa957d01b0310fd7);
function $dd3e6cce71afb005$export$5ebc9a4af3ac0850(e) {
    return new $dd3e6cce71afb005$export$a432f16a0795683f(e);
}
var $dd3e6cce71afb005$export$93cc75c33014d88a = {
    equals: function equals$$1(x, y) {
        return x ? x.equals(y) : !y;
    },
    map: function map(f, fa) {
        return fa.map(f);
    },
    ap: function ap(ff, fa) {
        return fa.ap(ff);
    },
    of: $dd3e6cce71afb005$export$fa957d01b0310fd7.pure,
    chain: function chain(f, fa) {
        return fa.flatMap(f);
    },
    chainRec: function chainRec(f, a) {
        return $dd3e6cce71afb005$export$fa957d01b0310fd7.tailRecM(a, function(a) {
            return f($dd3e6cce71afb005$export$37cbe166bfc81b63.left, $dd3e6cce71afb005$export$37cbe166bfc81b63.right, a);
        });
    }
};
$dd3e6cce71afb005$var$fantasyLandRegister($dd3e6cce71afb005$export$fa957d01b0310fd7, $dd3e6cce71afb005$export$93cc75c33014d88a, $dd3e6cce71afb005$export$93cc75c33014d88a);
var $dd3e6cce71afb005$var$tryUnitRef = $dd3e6cce71afb005$export$ffa3d9fee6fd705a(undefined);

});

parcelRegister("kt9Cs", function(module, exports) {

$parcel$export(module.exports, "extract", () => $ee6dfa4355bf821c$export$f9380c9a627682d3, (v) => $ee6dfa4355bf821c$export$f9380c9a627682d3 = v);
$parcel$export(module.exports, "parse", () => $ee6dfa4355bf821c$export$98e6a39c04603d36, (v) => $ee6dfa4355bf821c$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "stringify", () => $ee6dfa4355bf821c$export$fac44ee5b035f737, (v) => $ee6dfa4355bf821c$export$fac44ee5b035f737 = v);
$parcel$export(module.exports, "parseUrl", () => $ee6dfa4355bf821c$export$7a5253c0f62e0150, (v) => $ee6dfa4355bf821c$export$7a5253c0f62e0150 = v);
$parcel$export(module.exports, "stringifyUrl", () => $ee6dfa4355bf821c$export$a8c1621ea79325d3, (v) => $ee6dfa4355bf821c$export$a8c1621ea79325d3 = v);
$parcel$export(module.exports, "pick", () => $ee6dfa4355bf821c$export$357523c63a2253b9, (v) => $ee6dfa4355bf821c$export$357523c63a2253b9 = v);
$parcel$export(module.exports, "exclude", () => $ee6dfa4355bf821c$export$44c361b8ec72ef7f, (v) => $ee6dfa4355bf821c$export$44c361b8ec72ef7f = v);
var $ee6dfa4355bf821c$export$f9380c9a627682d3;
var $ee6dfa4355bf821c$export$98e6a39c04603d36;
var $ee6dfa4355bf821c$export$fac44ee5b035f737;
var $ee6dfa4355bf821c$export$7a5253c0f62e0150;
var $ee6dfa4355bf821c$export$a8c1621ea79325d3;
var $ee6dfa4355bf821c$export$357523c63a2253b9;
var $ee6dfa4355bf821c$export$44c361b8ec72ef7f;
'use strict';

var $hXDaG = parcelRequire("hXDaG");

var $bJEvY = parcelRequire("bJEvY");

var $9CHQr = parcelRequire("9CHQr");

var $aARfw = parcelRequire("aARfw");
const $ee6dfa4355bf821c$var$isNullOrUndefined = (value)=>value === null || value === undefined;
function $ee6dfa4355bf821c$var$encoderForArrayFormat(options) {
    switch(options.arrayFormat){
        case 'index':
            return (key)=>(result, value)=>{
                    const index = result.length;
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $ee6dfa4355bf821c$var$encode(key, options),
                            '[',
                            index,
                            ']'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $ee6dfa4355bf821c$var$encode(key, options),
                            '[',
                            $ee6dfa4355bf821c$var$encode(index, options),
                            ']=',
                            $ee6dfa4355bf821c$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'bracket':
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        [
                            $ee6dfa4355bf821c$var$encode(key, options),
                            '[]'
                        ].join('')
                    ];
                    return [
                        ...result,
                        [
                            $ee6dfa4355bf821c$var$encode(key, options),
                            '[]=',
                            $ee6dfa4355bf821c$var$encode(value, options)
                        ].join('')
                    ];
                };
        case 'comma':
        case 'separator':
            return (key)=>(result, value)=>{
                    if (value === null || value === undefined || value.length === 0) return result;
                    if (result.length === 0) return [
                        [
                            $ee6dfa4355bf821c$var$encode(key, options),
                            '=',
                            $ee6dfa4355bf821c$var$encode(value, options)
                        ].join('')
                    ];
                    return [
                        [
                            result,
                            $ee6dfa4355bf821c$var$encode(value, options)
                        ].join(options.arrayFormatSeparator)
                    ];
                };
        default:
            return (key)=>(result, value)=>{
                    if (value === undefined || options.skipNull && value === null || options.skipEmptyString && value === '') return result;
                    if (value === null) return [
                        ...result,
                        $ee6dfa4355bf821c$var$encode(key, options)
                    ];
                    return [
                        ...result,
                        [
                            $ee6dfa4355bf821c$var$encode(key, options),
                            '=',
                            $ee6dfa4355bf821c$var$encode(value, options)
                        ].join('')
                    ];
                };
    }
}
function $ee6dfa4355bf821c$var$parserForArrayFormat(options) {
    let result;
    switch(options.arrayFormat){
        case 'index':
            return (key, value, accumulator)=>{
                result = /\[(\d*)\]$/.exec(key);
                key = key.replace(/\[\d*\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) accumulator[key] = {};
                accumulator[key][result[1]] = value;
            };
        case 'bracket':
            return (key, value, accumulator)=>{
                result = /(\[\])$/.exec(key);
                key = key.replace(/\[\]$/, '');
                if (!result) {
                    accumulator[key] = value;
                    return;
                }
                if (accumulator[key] === undefined) {
                    accumulator[key] = [
                        value
                    ];
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
        case 'comma':
        case 'separator':
            return (key, value, accumulator)=>{
                const isArray = typeof value === 'string' && value.includes(options.arrayFormatSeparator);
                const isEncodedArray = typeof value === 'string' && !isArray && $ee6dfa4355bf821c$var$decode(value, options).includes(options.arrayFormatSeparator);
                value = isEncodedArray ? $ee6dfa4355bf821c$var$decode(value, options) : value;
                const newValue = isArray || isEncodedArray ? value.split(options.arrayFormatSeparator).map((item)=>$ee6dfa4355bf821c$var$decode(item, options)) : value === null ? value : $ee6dfa4355bf821c$var$decode(value, options);
                accumulator[key] = newValue;
            };
        default:
            return (key, value, accumulator)=>{
                if (accumulator[key] === undefined) {
                    accumulator[key] = value;
                    return;
                }
                accumulator[key] = [].concat(accumulator[key], value);
            };
    }
}
function $ee6dfa4355bf821c$var$validateArrayFormatSeparator(value) {
    if (typeof value !== 'string' || value.length !== 1) throw new TypeError('arrayFormatSeparator must be single character string');
}
function $ee6dfa4355bf821c$var$encode(value, options) {
    if (options.encode) return options.strict ? $hXDaG(value) : encodeURIComponent(value);
    return value;
}
function $ee6dfa4355bf821c$var$decode(value, options) {
    if (options.decode) return $bJEvY(value);
    return value;
}
function $ee6dfa4355bf821c$var$keysSorter(input) {
    if (Array.isArray(input)) return input.sort();
    if (typeof input === 'object') return $ee6dfa4355bf821c$var$keysSorter(Object.keys(input)).sort((a, b)=>Number(a) - Number(b)).map((key)=>input[key]);
    return input;
}
function $ee6dfa4355bf821c$var$removeHash(input) {
    const hashStart = input.indexOf('#');
    if (hashStart !== -1) input = input.slice(0, hashStart);
    return input;
}
function $ee6dfa4355bf821c$var$getHash(url) {
    let hash = '';
    const hashStart = url.indexOf('#');
    if (hashStart !== -1) hash = url.slice(hashStart);
    return hash;
}
function $ee6dfa4355bf821c$var$extract(input) {
    input = $ee6dfa4355bf821c$var$removeHash(input);
    const queryStart = input.indexOf('?');
    if (queryStart === -1) return '';
    return input.slice(queryStart + 1);
}
function $ee6dfa4355bf821c$var$parseValue(value, options) {
    if (options.parseNumbers && !Number.isNaN(Number(value)) && typeof value === 'string' && value.trim() !== '') value = Number(value);
    else if (options.parseBooleans && value !== null && (value.toLowerCase() === 'true' || value.toLowerCase() === 'false')) value = value.toLowerCase() === 'true';
    return value;
}
function $ee6dfa4355bf821c$var$parse(query, options) {
    options = Object.assign({
        decode: true,
        sort: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ',',
        parseNumbers: false,
        parseBooleans: false
    }, options);
    $ee6dfa4355bf821c$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const formatter = $ee6dfa4355bf821c$var$parserForArrayFormat(options);
    // Create an object with no prototype
    const ret = Object.create(null);
    if (typeof query !== 'string') return ret;
    query = query.trim().replace(/^[?#&]/, '');
    if (!query) return ret;
    for (const param of query.split('&')){
        if (param === '') continue;
        let [key, value] = $9CHQr(options.decode ? param.replace(/\+/g, ' ') : param, '=');
        // Missing `=` should be `null`:
        // http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
        value = value === undefined ? null : [
            'comma',
            'separator'
        ].includes(options.arrayFormat) ? value : $ee6dfa4355bf821c$var$decode(value, options);
        formatter($ee6dfa4355bf821c$var$decode(key, options), value, ret);
    }
    for (const key of Object.keys(ret)){
        const value = ret[key];
        if (typeof value === 'object' && value !== null) for (const k of Object.keys(value))value[k] = $ee6dfa4355bf821c$var$parseValue(value[k], options);
        else ret[key] = $ee6dfa4355bf821c$var$parseValue(value, options);
    }
    if (options.sort === false) return ret;
    return (options.sort === true ? Object.keys(ret).sort() : Object.keys(ret).sort(options.sort)).reduce((result, key)=>{
        const value = ret[key];
        if (Boolean(value) && typeof value === 'object' && !Array.isArray(value)) // Sort object keys, not values
        result[key] = $ee6dfa4355bf821c$var$keysSorter(value);
        else result[key] = value;
        return result;
    }, Object.create(null));
}
$ee6dfa4355bf821c$export$f9380c9a627682d3 = $ee6dfa4355bf821c$var$extract;
$ee6dfa4355bf821c$export$98e6a39c04603d36 = $ee6dfa4355bf821c$var$parse;
$ee6dfa4355bf821c$export$fac44ee5b035f737 = (object, options)=>{
    if (!object) return '';
    options = Object.assign({
        encode: true,
        strict: true,
        arrayFormat: 'none',
        arrayFormatSeparator: ','
    }, options);
    $ee6dfa4355bf821c$var$validateArrayFormatSeparator(options.arrayFormatSeparator);
    const shouldFilter = (key)=>options.skipNull && $ee6dfa4355bf821c$var$isNullOrUndefined(object[key]) || options.skipEmptyString && object[key] === '';
    const formatter = $ee6dfa4355bf821c$var$encoderForArrayFormat(options);
    const objectCopy = {};
    for (const key of Object.keys(object))if (!shouldFilter(key)) objectCopy[key] = object[key];
    const keys = Object.keys(objectCopy);
    if (options.sort !== false) keys.sort(options.sort);
    return keys.map((key)=>{
        const value = object[key];
        if (value === undefined) return '';
        if (value === null) return $ee6dfa4355bf821c$var$encode(key, options);
        if (Array.isArray(value)) return value.reduce(formatter(key), []).join('&');
        return $ee6dfa4355bf821c$var$encode(key, options) + '=' + $ee6dfa4355bf821c$var$encode(value, options);
    }).filter((x)=>x.length > 0).join('&');
};
$ee6dfa4355bf821c$export$7a5253c0f62e0150 = (url, options)=>{
    options = Object.assign({
        decode: true
    }, options);
    const [url_, hash] = $9CHQr(url, '#');
    return Object.assign({
        url: url_.split('?')[0] || '',
        query: $ee6dfa4355bf821c$var$parse($ee6dfa4355bf821c$var$extract(url), options)
    }, options && options.parseFragmentIdentifier && hash ? {
        fragmentIdentifier: $ee6dfa4355bf821c$var$decode(hash, options)
    } : {});
};
$ee6dfa4355bf821c$export$a8c1621ea79325d3 = (object, options)=>{
    options = Object.assign({
        encode: true,
        strict: true
    }, options);
    const url = $ee6dfa4355bf821c$var$removeHash(object.url).split('?')[0] || '';
    const queryFromUrl = $ee6dfa4355bf821c$export$f9380c9a627682d3(object.url);
    const parsedQueryFromUrl = $ee6dfa4355bf821c$export$98e6a39c04603d36(queryFromUrl, {
        sort: false
    });
    const query = Object.assign(parsedQueryFromUrl, object.query);
    let queryString = $ee6dfa4355bf821c$export$fac44ee5b035f737(query, options);
    if (queryString) queryString = `?${queryString}`;
    let hash = $ee6dfa4355bf821c$var$getHash(object.url);
    if (object.fragmentIdentifier) hash = `#${$ee6dfa4355bf821c$var$encode(object.fragmentIdentifier, options)}`;
    return `${url}${queryString}${hash}`;
};
$ee6dfa4355bf821c$export$357523c63a2253b9 = (input, filter, options)=>{
    options = Object.assign({
        parseFragmentIdentifier: true
    }, options);
    const { url: url, query: query, fragmentIdentifier: fragmentIdentifier } = $ee6dfa4355bf821c$export$7a5253c0f62e0150(input, options);
    return $ee6dfa4355bf821c$export$a8c1621ea79325d3({
        url: url,
        query: $aARfw(query, filter),
        fragmentIdentifier: fragmentIdentifier
    }, options);
};
$ee6dfa4355bf821c$export$44c361b8ec72ef7f = (input, filter, options)=>{
    const exclusionFilter = Array.isArray(filter) ? (key)=>!filter.includes(key) : (key, value)=>!filter(key, value);
    return $ee6dfa4355bf821c$export$357523c63a2253b9(input, exclusionFilter, options);
};

});

parcelRegister("dx2bt", function(module, exports) {

$parcel$export(module.exports, "supports", () => $9da00d21ad2c1ecb$export$cde6a56f9669daf6);
$parcel$export(module.exports, "REMOTE_INSTALL_JSON", () => $9da00d21ad2c1ecb$export$e74094f901f05524);
$parcel$export(module.exports, "INSTALL_COMPLETE_JSON", () => $9da00d21ad2c1ecb$export$79b565e847152e77);
const $9da00d21ad2c1ecb$export$cde6a56f9669daf6 = {
    context: false,
    accessToken: false,
    enabled: false
};
const $9da00d21ad2c1ecb$export$e74094f901f05524 = 'application/vnd.atl.plugins.remote.install+json';
const $9da00d21ad2c1ecb$export$79b565e847152e77 = 'application/vnd.atl.plugins.install.complete+json';

});

parcelRegister("c0juV", function(module, exports) {

$parcel$export(module.exports, "foldPaymentModel", () => $8bd49bfafd6cd548$export$78cb43db1b1a42b1);
$parcel$export(module.exports, "makeAppKey", () => $8bd49bfafd6cd548$export$a7c7d13152440f84);

var $gC8Po = parcelRequire("gC8Po");
const $8bd49bfafd6cd548$export$78cb43db1b1a42b1 = (p)=>(free, atlassian, vendor)=>{
        switch(p){
            case 'PAID_VIA_ATLASSIAN':
                return atlassian();
            case 'FREE':
                return free();
            case 'PAID_VIA_PARTNER':
                return vendor();
            default:
                throw (0, $gC8Po.default).unexpectedCase(p);
        }
    };
function $8bd49bfafd6cd548$export$a7c7d13152440f84(key) {
    return key;
}

});
parcelRegister("gC8Po", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1870afb8d649de0$export$2e2bcd8739ae039);
/**
 * This is usually used with exhaustive union type handling
 * It provides compile time validation that we have handled all the cases in the union type
 * It also returns an error to throw which will help at runtime.
 * To know more about it : https://medium.com/@ibosz/advance-flow-type-1-exhaustive-checking-with-empty-type-a02e503cd3a0
 * @param impossible
 * @return {Error}
 */ function $c1870afb8d649de0$var$unexpectedCase(impossible) {
    return new Error("Unexpected case ".concat(impossible));
}
var $c1870afb8d649de0$export$2e2bcd8739ae039 = {
    unexpectedCase: $c1870afb8d649de0$var$unexpectedCase
};

});



parcelRegister("axFWr", function(module, exports) {

$parcel$export(module.exports, "toEcosystemCloudInstallableAddon", () => $7acd852c5628e3a1$export$394991f9b972c6a4);
$parcel$export(module.exports, "toInstalledEcosystemCloudAddon", () => $7acd852c5628e3a1$export$ce01f52a54887770);
$parcel$export(module.exports, "transformInstalledCloudAppsGraphqlApiData", () => $7acd852c5628e3a1$export$f49eb39039925455);
$parcel$export(module.exports, "postGraphQlRequest", () => $7acd852c5628e3a1$export$e6c424c5ceed2a1d);
$parcel$export(module.exports, "getRequestId", () => $7acd852c5628e3a1$export$710171574ebc9a51);
$parcel$export(module.exports, "checkEcosystemCloudAppInstallStatus", () => $7acd852c5628e3a1$export$67cda7b0efd06daa);
$parcel$export(module.exports, "buildSiteContext", () => $7acd852c5628e3a1$export$cf58998fb66fd1de);

var $5zQU9 = parcelRequire("5zQU9");

var $dO8LH = parcelRequire("dO8LH");

var $i0EDR = parcelRequire("i0EDR");

var $fBab0 = parcelRequire("fBab0");

var $fcWBJ = parcelRequire("fcWBJ");

var $gQV53 = parcelRequire("gQV53");

var $kihdI = parcelRequire("kihdI");
function $7acd852c5628e3a1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7acd852c5628e3a1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7acd852c5628e3a1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7acd852c5628e3a1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7acd852c5628e3a1$var$appInstallationTask = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "appInstallationTask"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "id"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appInstallationTask"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "state"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "errors"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 571,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nmutation ecosystemCloudAppInstall($input: AppInstallationInput!) {\n  installApp(input: $input) {\n    success\n    installationId\n    taskId\n    errors {\n      message\n      extensions {\n        statusCode\n        errorType\n      }\n    }\n  }\n}\n\nquery appInstallationTask($id: ID!) {\n  appInstallationTask(id: $id) {\n    id\n    state\n    errors {\n      message\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
const $7acd852c5628e3a1$export$394991f9b972c6a4 = (marketplaceApp)=>{
    var _marketplaceApp$versi;
    const cloudAppsDeployment = (_marketplaceApp$versi = marketplaceApp.version) === null || _marketplaceApp$versi === void 0 ? void 0 : _marketplaceApp$versi.deployment;
    const details = {
        key: marketplaceApp.appKey,
        name: marketplaceApp.name,
        description: marketplaceApp.tagline || '',
        metadata: {},
        ecosystemCloudAppId: cloudAppsDeployment.cloudAppId
    };
    const installableAddon = {
        details: details,
        preinstalled: false,
        scopes: cloudAppsDeployment.scopes.map((s)=>s.capability),
        metadata: undefined,
        eligibleForFreeOnSandbox: false,
        // defaulted to false for the forge apps as they are not eligible for free installation on sandbox
        cloudMigrationTrial: {
            isEligible: false
        }
    };
    return installableAddon;
};
const $7acd852c5628e3a1$export$ce01f52a54887770 = (product, baseUrl, marketplaceInstallation, appGlobalSettingsExtensions)=>{
    var _marketplaceInstallat, _marketplaceAppData$v, _marketplaceAppData$v2;
    const marketplaceAppData = (_marketplaceInstallat = marketplaceInstallation.app) === null || _marketplaceInstallat === void 0 ? void 0 : _marketplaceInstallat.marketplaceApp;
    const getStartedExtension = appGlobalSettingsExtensions.find((extension)=>{
        var _extension$properties;
        return (_extension$properties = extension.properties) === null || _extension$properties === void 0 ? void 0 : _extension$properties.useAsGetStarted;
    });
    const configExtension = appGlobalSettingsExtensions.find((extension)=>{
        var _extension$properties2;
        return ((_extension$properties2 = extension.properties) === null || _extension$properties2 === void 0 ? void 0 : _extension$properties2.useAsConfig) || extension.type === 'compass:adminPage';
    });
    const version = marketplaceAppData && ((_marketplaceAppData$v = marketplaceAppData.versions.edges) === null || _marketplaceAppData$v === void 0 ? void 0 : (_marketplaceAppData$v2 = _marketplaceAppData$v[0]) === null || _marketplaceAppData$v2 === void 0 ? void 0 : _marketplaceAppData$v2.node);
    if (marketplaceAppData && version) {
        var _marketplaceInstallat2;
        const details = {
            key: marketplaceAppData.appKey,
            name: marketplaceAppData.name,
            description: marketplaceAppData.tagline || '',
            metadata: undefined
        };
        const marketplaceCloudAppDeployment = version.deployment;
        const authType = {
            type: '2LO'
        };
        const paymentModel = (0, $gQV53.transformToPaymentModel)(version, marketplaceInstallation);
        const { getStartedUrl: getStartedUrl, configureUrl: configureUrl } = (0, $kihdI.buildProductCloudAppUrls)({
            product: product,
            baseUrl: baseUrl,
            getStartedExtension: getStartedExtension,
            configExtension: configExtension
        });
        const manageAppUrl = product === (0, $i0EDR.CompatibleProductId).COMPASS ? configureUrl : "".concat(baseUrl, "/plugins/servlet/upm#manage/").concat(marketplaceAppData.appKey);
        return $7acd852c5628e3a1$var$_objectSpread($7acd852c5628e3a1$var$_objectSpread($7acd852c5628e3a1$var$_objectSpread({
            authType: authType,
            details: details,
            installationId: marketplaceInstallation.id,
            enabled: true,
            manageAppUrl: manageAppUrl
        }, (0, $gQV53.setProp)('getStartedUrl', getStartedUrl)), (0, $gQV53.setProp)('configureUrl', configureUrl)), {}, {
            installTime: new Date(marketplaceInstallation.createdAt),
            scopes: marketplaceCloudAppDeployment.scopes.map((s)=>s.capability),
            latestVersion: !!((_marketplaceInstallat2 = marketplaceInstallation.appEnvironmentVersion) !== null && _marketplaceInstallat2 !== void 0 && _marketplaceInstallat2.isLatest),
            paymentModel: paymentModel,
            metadata: undefined
        });
    }
    throw new Error("Marketplace app data not present in installed app ".concat(marketplaceInstallation.id));
};
const $7acd852c5628e3a1$export$f49eb39039925455 = (product, baseUrl, appInstallations, globalSettingsExtensions)=>{
    const globalSettingsExtensionsAppGroups = (0, (/*@__PURE__*/$parcel$interopDefault($fcWBJ)))(globalSettingsExtensions, (extension)=>extension.installationId);
    return appInstallations.filter((appInstall)=>{
        var _appInstall$app;
        return (_appInstall$app = appInstall.app) === null || _appInstall$app === void 0 ? void 0 : _appInstall$app.marketplaceApp;
    }).map((appInstall)=>$7acd852c5628e3a1$export$ce01f52a54887770(product, baseUrl, appInstall, globalSettingsExtensionsAppGroups[appInstall.id] || []));
};
const $7acd852c5628e3a1$export$e6c424c5ceed2a1d = async (payload, gqlGatewayUrl)=>{
    const { query: query, variables: variables, options: options = {} } = payload;
    const requestPayload = $7acd852c5628e3a1$var$_objectSpread($7acd852c5628e3a1$var$_objectSpread({}, options), {}, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'atl-client-name': 'marketplace-amkt-upm-spi-impl'
        },
        body: JSON.stringify({
            query: query,
            variables: variables
        })
    });
    const response = await (0, $dO8LH.fetchOk)(gqlGatewayUrl, requestPayload);
    return response.json();
};
const $7acd852c5628e3a1$export$710171574ebc9a51 = (response)=>{
    var _response$extensions, _response$extensions$;
    return (response === null || response === void 0 ? void 0 : (_response$extensions = response.extensions) === null || _response$extensions === void 0 ? void 0 : (_response$extensions$ = _response$extensions.gateway) === null || _response$extensions$ === void 0 ? void 0 : _response$extensions$.request_id) || '';
};
const $7acd852c5628e3a1$export$67cda7b0efd06daa = async (taskId, gqlGatewayUrl)=>{
    const query = (0, $fBab0.print)($7acd852c5628e3a1$var$appInstallationTask);
    const variables = {
        id: taskId
    };
    const pollAfter = 5000;
    const options = {
        retries: (0, $gQV53.calculateRetries)(2, pollAfter),
        retryDelay: pollAfter,
        accept: (response)=>response.json().then((bodyJSON)=>{
                var _bodyJSON$data, _bodyJSON$data$appIns;
                const appInstallationState = bodyJSON === null || bodyJSON === void 0 ? void 0 : (_bodyJSON$data = bodyJSON.data) === null || _bodyJSON$data === void 0 ? void 0 : (_bodyJSON$data$appIns = _bodyJSON$data.appInstallationTask) === null || _bodyJSON$data$appIns === void 0 ? void 0 : _bodyJSON$data$appIns.state;
                return appInstallationState === 'COMPLETE' || appInstallationState === 'FAILED' ? Promise.resolve() : Promise.reject(new Error('Request pending'));
            })
    };
    const responseJSON = await $7acd852c5628e3a1$export$e6c424c5ceed2a1d({
        query: query,
        variables: variables,
        options: options
    }, gqlGatewayUrl);
    const requestId = $7acd852c5628e3a1$export$710171574ebc9a51(responseJSON);
    if (!responseJSON.data) {
        // requestId here can be used to trace the cause of issue in splunk logs for this query
        const error = new Error("App Installation Task Failed for taskId: ".concat(taskId));
        error.cause = requestId;
        throw error;
    }
    const data = $7acd852c5628e3a1$var$_objectSpread($7acd852c5628e3a1$var$_objectSpread({}, responseJSON.data), {}, {
        requestId: requestId
    });
    return data;
};
const $7acd852c5628e3a1$export$cf58998fb66fd1de = (product, cloudId, activationId)=>"ari:cloud:".concat(product, ":").concat(cloudId, ":workspace/").concat(activationId);

});
parcelRegister("fBab0", function(module, exports) {

$parcel$export(module.exports, "print", () => $a0933ad212682f70$export$c2d084dc44961371);

var $d0WTt = parcelRequire("d0WTt");

var $ePVkt = parcelRequire("ePVkt");

var $AQHCf = parcelRequire("AQHCf");
function $a0933ad212682f70$export$c2d084dc44961371(ast) {
    return (0, $AQHCf.visit)(ast, $a0933ad212682f70$var$printDocASTReducer);
}
const $a0933ad212682f70$var$MAX_LINE_LENGTH = 80;
const $a0933ad212682f70$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$a0933ad212682f70$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $a0933ad212682f70$var$wrap('(', $a0933ad212682f70$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $a0933ad212682f70$var$join([
                node.operation,
                $a0933ad212682f70$var$join([
                    node.name,
                    varDefs
                ]),
                $a0933ad212682f70$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ': ' + type + $a0933ad212682f70$var$wrap(' = ', defaultValue) + $a0933ad212682f70$var$wrap(' ', $a0933ad212682f70$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$a0933ad212682f70$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $a0933ad212682f70$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $a0933ad212682f70$var$wrap('(', $a0933ad212682f70$var$join(args, ', '), ')');
            if (argsLine.length > $a0933ad212682f70$var$MAX_LINE_LENGTH) argsLine = prefix + $a0933ad212682f70$var$wrap('(\n', $a0933ad212682f70$var$indent($a0933ad212682f70$var$join(args, '\n')), '\n)');
            return $a0933ad212682f70$var$join([
                argsLine,
                $a0933ad212682f70$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $a0933ad212682f70$var$wrap(' ', $a0933ad212682f70$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$a0933ad212682f70$var$join([
                '...',
                $a0933ad212682f70$var$wrap('on ', typeCondition),
                $a0933ad212682f70$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$a0933ad212682f70$var$wrap('(', $a0933ad212682f70$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$a0933ad212682f70$var$wrap('', $a0933ad212682f70$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $d0WTt.printBlockString)(value) : (0, $ePVkt.printString)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $a0933ad212682f70$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $a0933ad212682f70$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $a0933ad212682f70$var$wrap('(', $a0933ad212682f70$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                'schema',
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                'scalar',
                name,
                $a0933ad212682f70$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                'type',
                name,
                $a0933ad212682f70$var$wrap('implements ', $a0933ad212682f70$var$join(interfaces, ' & ')),
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$a0933ad212682f70$var$wrap('', description, '\n') + name + ($a0933ad212682f70$var$hasMultilineItems(args) ? $a0933ad212682f70$var$wrap('(\n', $a0933ad212682f70$var$indent($a0933ad212682f70$var$join(args, '\n')), '\n)') : $a0933ad212682f70$var$wrap('(', $a0933ad212682f70$var$join(args, ', '), ')')) + ': ' + type + $a0933ad212682f70$var$wrap(' ', $a0933ad212682f70$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                name + ': ' + type,
                $a0933ad212682f70$var$wrap('= ', defaultValue),
                $a0933ad212682f70$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                'interface',
                name,
                $a0933ad212682f70$var$wrap('implements ', $a0933ad212682f70$var$join(interfaces, ' & ')),
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                'union',
                name,
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$wrap('= ', $a0933ad212682f70$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                'enum',
                name,
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                name,
                $a0933ad212682f70$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$a0933ad212682f70$var$wrap('', description, '\n') + $a0933ad212682f70$var$join([
                'input',
                name,
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$a0933ad212682f70$var$wrap('', description, '\n') + 'directive @' + name + ($a0933ad212682f70$var$hasMultilineItems(args) ? $a0933ad212682f70$var$wrap('(\n', $a0933ad212682f70$var$indent($a0933ad212682f70$var$join(args, '\n')), '\n)') : $a0933ad212682f70$var$wrap('(', $a0933ad212682f70$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $a0933ad212682f70$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$a0933ad212682f70$var$join([
                'extend schema',
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$a0933ad212682f70$var$join([
                'extend scalar',
                name,
                $a0933ad212682f70$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$a0933ad212682f70$var$join([
                'extend type',
                name,
                $a0933ad212682f70$var$wrap('implements ', $a0933ad212682f70$var$join(interfaces, ' & ')),
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$a0933ad212682f70$var$join([
                'extend interface',
                name,
                $a0933ad212682f70$var$wrap('implements ', $a0933ad212682f70$var$join(interfaces, ' & ')),
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$a0933ad212682f70$var$join([
                'extend union',
                name,
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$wrap('= ', $a0933ad212682f70$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$a0933ad212682f70$var$join([
                'extend enum',
                name,
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$a0933ad212682f70$var$join([
                'extend input',
                name,
                $a0933ad212682f70$var$join(directives, ' '),
                $a0933ad212682f70$var$block(fields)
            ], ' ')
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $a0933ad212682f70$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $a0933ad212682f70$var$block(array) {
    return $a0933ad212682f70$var$wrap('{\n', $a0933ad212682f70$var$indent($a0933ad212682f70$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $a0933ad212682f70$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $a0933ad212682f70$var$indent(str) {
    return $a0933ad212682f70$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $a0933ad212682f70$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}

});
parcelRegister("d0WTt", function(module, exports) {

$parcel$export(module.exports, "printBlockString", () => $984f27a019dca981$export$adb6ca997eeb1f45);

var $dzN5z = parcelRequire("dzN5z");
function $984f27a019dca981$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $984f27a019dca981$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $984f27a019dca981$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $dzN5z.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
function $984f27a019dca981$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $984f27a019dca981$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $dzN5z.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $dzN5z.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}

});
parcelRegister("dzN5z", function(module, exports) {

$parcel$export(module.exports, "isWhiteSpace", () => $dc76f141e87ad1a9$export$3c52dd84024ae72c);
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $dc76f141e87ad1a9$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $dc76f141e87ad1a9$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $dc76f141e87ad1a9$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $dc76f141e87ad1a9$export$45a677ea7cb6d5c8(code) {
    return $dc76f141e87ad1a9$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $dc76f141e87ad1a9$export$d3f406ff46035894(code) {
    return $dc76f141e87ad1a9$export$79c5d5217943d6a7(code) || $dc76f141e87ad1a9$export$727d9dbc4fbb948f(code) || code === 0x005f;
}

});


parcelRegister("ePVkt", function(module, exports) {

$parcel$export(module.exports, "printString", () => $451e8d75efc537c6$export$3cdec7cf614a0ecc);
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $451e8d75efc537c6$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($451e8d75efc537c6$var$escapedRegExp, $451e8d75efc537c6$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $451e8d75efc537c6$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $451e8d75efc537c6$var$escapedReplacer(str) {
    return $451e8d75efc537c6$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $451e8d75efc537c6$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];

});

parcelRegister("AQHCf", function(module, exports) {

$parcel$export(module.exports, "visit", () => $92cb342f4758688e$export$bf638b60ea8b89b7);

var $8pITG = parcelRequire("8pITG");

var $4gMxR = parcelRequire("4gMxR");

var $I6z1b = parcelRequire("I6z1b");

var $5LGT1 = parcelRequire("5LGT1");
const $92cb342f4758688e$export$a89c95c098ac2a58 = Object.freeze({});
function $92cb342f4758688e$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $I6z1b.QueryDocumentKeys)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $5LGT1.Kind)))enterLeaveMap.set(kind, $92cb342f4758688e$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $I6z1b.isNode)(node) || (0, $8pITG.devAssert)(false, `Invalid AST Node: ${(0, $4gMxR.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $92cb342f4758688e$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $I6z1b.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $92cb342f4758688e$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $5LGT1.Kind))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $92cb342f4758688e$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $92cb342f4758688e$export$a89c95c098ac2a58) skipping[i] = $92cb342f4758688e$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $92cb342f4758688e$export$a89c95c098ac2a58) skipping[i] = $92cb342f4758688e$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $92cb342f4758688e$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $92cb342f4758688e$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $92cb342f4758688e$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}

});
parcelRegister("8pITG", function(module, exports) {

$parcel$export(module.exports, "devAssert", () => $d43a108bedc8bf17$export$b6cb5906f04696c8);
function $d43a108bedc8bf17$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("4gMxR", function(module, exports) {

$parcel$export(module.exports, "inspect", () => $3b7c607a0d7898ba$export$9dec5d1b3b6a130d);
const $3b7c607a0d7898ba$var$MAX_ARRAY_LENGTH = 10;
const $3b7c607a0d7898ba$var$MAX_RECURSIVE_DEPTH = 2;
function $3b7c607a0d7898ba$export$9dec5d1b3b6a130d(value) {
    return $3b7c607a0d7898ba$var$formatValue(value, []);
}
function $3b7c607a0d7898ba$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $3b7c607a0d7898ba$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $3b7c607a0d7898ba$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($3b7c607a0d7898ba$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $3b7c607a0d7898ba$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $3b7c607a0d7898ba$var$formatArray(value, seenValues);
    return $3b7c607a0d7898ba$var$formatObject(value, seenValues);
}
function $3b7c607a0d7898ba$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $3b7c607a0d7898ba$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $3b7c607a0d7898ba$var$MAX_RECURSIVE_DEPTH) return '[' + $3b7c607a0d7898ba$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $3b7c607a0d7898ba$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $3b7c607a0d7898ba$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $3b7c607a0d7898ba$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($3b7c607a0d7898ba$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($3b7c607a0d7898ba$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $3b7c607a0d7898ba$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});

parcelRegister("I6z1b", function(module, exports) {

$parcel$export(module.exports, "QueryDocumentKeys", () => $b9638c572a76d886$export$4fcd777a40ccf407);
$parcel$export(module.exports, "isNode", () => $b9638c572a76d886$export$8ee0fc9ee280b4ee);
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $b9638c572a76d886$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $b9638c572a76d886$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $b9638c572a76d886$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
const $b9638c572a76d886$var$kindValues = new Set(Object.keys($b9638c572a76d886$export$4fcd777a40ccf407));
function $b9638c572a76d886$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $b9638c572a76d886$var$kindValues.has(maybeKind);
}
/** Name */ var $b9638c572a76d886$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($b9638c572a76d886$export$f58c50edb4aef9d4 || ($b9638c572a76d886$export$f58c50edb4aef9d4 = {}));

});

parcelRegister("5LGT1", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $e1db618492f1a48b$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $e1db618492f1a48b$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})($e1db618492f1a48b$export$a84bdc57c5122798 || ($e1db618492f1a48b$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 
});



parcelRegister("kihdI", function(module, exports) {

$parcel$export(module.exports, "buildProductCloudAppUrls", () => $ec62d8ac49648d14$export$ab0204850de84d84);

var $i0EDR = parcelRequire("i0EDR");
const $ec62d8ac49648d14$export$ab0204850de84d84 = (_ref)=>{
    let { product: product, baseUrl: baseUrl, getStartedExtension: getStartedExtension, configExtension: configExtension } = _ref;
    if (product === (0, $i0EDR.CompatibleProductId).Confluence) return {
        getStartedUrl: getStartedExtension && "".concat(baseUrl, "/admin/forge?id=").concat(encodeURIComponent(getStartedExtension.id)),
        configureUrl: configExtension && "".concat(baseUrl, "/admin/forge?id=").concat(encodeURIComponent(configExtension.id))
    };
    if (product === (0, $i0EDR.CompatibleProductId).Jira) return {
        getStartedUrl: getStartedExtension && $ec62d8ac49648d14$var$buildJiraExtensionSettingsPath(baseUrl, getStartedExtension, 'get-started'),
        configureUrl: configExtension && $ec62d8ac49648d14$var$buildJiraExtensionSettingsPath(baseUrl, configExtension, 'configure')
    };
    if (product === (0, $i0EDR.CompatibleProductId).COMPASS) {
        const configureUrl = configExtension && $ec62d8ac49648d14$var$buildCompassExtensionSettingsPath(baseUrl, configExtension.id);
        return {
            configureUrl: configureUrl
        };
    }
    return {};
};
const $ec62d8ac49648d14$var$buildJiraExtensionSettingsPath = (baseUrl, extension, settingsType)=>{
    // exntension.id example: ari:cloud:ecosystem::extension/appId/envId/static/hello-world-admin-page
    const [, appId, envId] = extension.id.split('/');
    return "".concat(baseUrl, "/jira/settings/apps/").concat(settingsType, "/").concat(appId, "/").concat(envId);
};
const $ec62d8ac49648d14$var$buildCompassExtensionSettingsPath = (baseUrl, extension)=>{
    /* The redirection link for configure in compass uses base64 conversion of the extension.id which is done with
    btoa() function.
    Read: https://developer.mozilla.org/en-US/docs/Web/API/btoa
   */ const encodedAppAri = encodeURIComponent("b:".concat(btoa(extension)));
    return "".concat(baseUrl, "/compass/apps/").concat(encodedAppAri);
};

});


parcelRegister("6poH2", function(module, exports) {

$parcel$export(module.exports, "default", () => $4aa83b6a58d62a52$export$2e2bcd8739ae039);
const $4aa83b6a58d62a52$var$prodEnv = {
    adminHubBaseUrl: 'https://admin.atlassian.com',
    mpacBaseUrl: 'https://marketplace.atlassian.com',
    mpacCdnBaseUrl: 'https://marketplace.atlassian.com',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
    macBaseUrl: 'https://my.atlassian.com',
    wacBaseUrl: 'https://www.atlassian.com',
    ecosystemCloudEnvKey: 'production'
};
const $4aa83b6a58d62a52$var$stagingEnv = {
    adminHubBaseUrl: 'https://admin.stg.atlassian.com',
    mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    macBaseUrl: 'https://my.stg.internal.atlassian.com',
    wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
    ecosystemCloudEnvKey: 'production'
};
const $4aa83b6a58d62a52$var$localEnv = {
    adminHubBaseUrl: 'https://admin.stg.atlassian.com',
    mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    macBaseUrl: 'https://my.stg.internal.atlassian.com',
    wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
    ecosystemCloudEnvKey: 'production'
};
var $4aa83b6a58d62a52$export$2e2bcd8739ae039 = (config)=>{
    switch(config.environment){
        case 'prod':
            return $4aa83b6a58d62a52$var$prodEnv;
        case 'staging':
            return $4aa83b6a58d62a52$var$stagingEnv;
        case 'local':
            return $4aa83b6a58d62a52$var$localEnv;
        default:
            console.error('Unable to configure marketplace env: ' + config.environment);
            return $4aa83b6a58d62a52$var$prodEnv;
    }
};

});

parcelRegister("QaRKt", function(module, exports) {

$parcel$export(module.exports, "getRawCloudMarketplaceAppByKey", () => $09cd492ff2df40e2$export$6b17afb8693d5324);
$parcel$export(module.exports, "getInstalledEcosystemCloudAppFromCaaS", () => $09cd492ff2df40e2$export$8712abd2e6bd944d);
$parcel$export(module.exports, "getInstalledEcosystemCloudApp", () => $09cd492ff2df40e2$export$d20f2968c1baec15);
$parcel$export(module.exports, "fetchAllInstalledEcosystemCloudApps", () => $09cd492ff2df40e2$export$d286412e060e80fe);
$parcel$export(module.exports, "getInstalledEcosystemCloudAppOrThrowInstallError", () => $09cd492ff2df40e2$export$c24ba89f6d4f98e3);
$parcel$export(module.exports, "handleInstallAddonByARI", () => $09cd492ff2df40e2$export$cad10fadc88b1e5d);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $1w7m1 = parcelRequire("1w7m1");

var $i0EDR = parcelRequire("i0EDR");

var $bTrQR = parcelRequire("bTrQR");

var $fBab0 = parcelRequire("fBab0");

var $axFWr = parcelRequire("axFWr");

var $6poH2 = parcelRequire("6poH2");

var $c0juV = parcelRequire("c0juV");
const $09cd492ff2df40e2$var$_excluded = [
    "versions"
];
function $09cd492ff2df40e2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $09cd492ff2df40e2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $09cd492ff2df40e2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $09cd492ff2df40e2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $09cd492ff2df40e2$var$ecosystemCloudAppInstall = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ecosystemCloudAppInstall"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "AppInstallationInput"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "installApp"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "success"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installationId"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "taskId"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "errors"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "extensions"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "statusCode"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorType"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 571,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nmutation ecosystemCloudAppInstall($input: AppInstallationInput!) {\n  installApp(input: $input) {\n    success\n    installationId\n    taskId\n    errors {\n      message\n      extensions {\n        statusCode\n        errorType\n      }\n    }\n  }\n}\n\nquery appInstallationTask($id: ID!) {\n  appInstallationTask(id: $id) {\n    id\n    state\n    errors {\n      message\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
var $09cd492ff2df40e2$var$ecosystemCloudAppSubscribe = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "ecosystemCloudAppSubscribe"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "AppSubscribeInput"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "subscribeToApp"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "input"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "input"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "success"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installation"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "taskId"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "errors"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "extensions"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "statusCode"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "errorType"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 461,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nmutation ecosystemCloudAppSubscribe($input: AppSubscribeInput!) {\n  subscribeToApp(input: $input) {\n    success\n    installation {\n      id\n    }\n    taskId\n    errors {\n      message\n      extensions {\n        statusCode\n        errorType\n      }\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
var $09cd492ff2df40e2$var$getEcosystemCloudAppInstallation = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getEcosystemCloudAppInstallation"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "context"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "appId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "environmentType"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "AppEnvironmentType"
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "useDeprecatedQuery"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Boolean"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "extensionContexts"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "contextIds"
                                },
                                value: {
                                    kind: "ListValue",
                                    values: [
                                        {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "context"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installations"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "appId"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "appId"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "environmentType"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "environmentType"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    directives: [
                                        {
                                            kind: "Directive",
                                            name: {
                                                kind: "Name",
                                                value: "include"
                                            },
                                            arguments: [
                                                {
                                                    kind: "Argument",
                                                    name: {
                                                        kind: "Name",
                                                        value: "if"
                                                    },
                                                    value: {
                                                        kind: "Variable",
                                                        name: {
                                                            kind: "Name",
                                                            value: "useDeprecatedQuery"
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "extensionContextsNodes"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "globalSettingsExtensions"
                                    },
                                    directives: []
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "adminPageExtensions"
                                    },
                                    directives: []
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "compassAdminPageExtensions"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "ecosystem"
                        },
                        arguments: [],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "skip"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "useDeprecatedQuery"
                                            }
                                        }
                                    }
                                ]
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "appInstallationsByContext"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "appInstallations"
                                                        },
                                                        value: {
                                                            kind: "ObjectValue",
                                                            fields: [
                                                                {
                                                                    kind: "ObjectField",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "contexts"
                                                                    },
                                                                    value: {
                                                                        kind: "ListValue",
                                                                        values: [
                                                                            {
                                                                                kind: "Variable",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "context"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "apps"
                                                        },
                                                        value: {
                                                            kind: "ObjectValue",
                                                            fields: [
                                                                {
                                                                    kind: "ObjectField",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "ids"
                                                                    },
                                                                    value: {
                                                                        kind: "ListValue",
                                                                        values: [
                                                                            {
                                                                                kind: "Variable",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "appId"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    }
                                                ]
                                            }
                                        }
                                    ],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "appInstallationsByContextNodes"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "extensionContextsNodes"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AppInstallationConnection"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "nodes"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "appEnvironmentVersion"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isLatest"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "requiresLicense"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "app"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "marketplaceApp"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "appKey"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "tagline"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "createdAt"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "versions"
                                                            },
                                                            arguments: [
                                                                {
                                                                    kind: "Argument",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "filter"
                                                                    },
                                                                    value: {
                                                                        kind: "ObjectValue",
                                                                        fields: [
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "productHostingOptions"
                                                                                },
                                                                                value: {
                                                                                    kind: "ListValue",
                                                                                    values: [
                                                                                        {
                                                                                            kind: "EnumValue",
                                                                                            value: "CLOUD"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            },
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "visibility"
                                                                                },
                                                                                value: {
                                                                                    kind: "EnumValue",
                                                                                    value: "PUBLIC"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "edges"
                                                                        },
                                                                        arguments: [],
                                                                        directives: [],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "node"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "paymentModel"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "deployment"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: [],
                                                                                                selectionSet: {
                                                                                                    kind: "SelectionSet",
                                                                                                    selections: [
                                                                                                        {
                                                                                                            kind: "InlineFragment",
                                                                                                            typeCondition: {
                                                                                                                kind: "NamedType",
                                                                                                                name: {
                                                                                                                    kind: "Name",
                                                                                                                    value: "MarketplaceCloudAppDeployment"
                                                                                                                }
                                                                                                            },
                                                                                                            directives: [],
                                                                                                            selectionSet: {
                                                                                                                kind: "SelectionSet",
                                                                                                                selections: [
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "cloudAppId"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: []
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "scopes"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: [],
                                                                                                                        selectionSet: {
                                                                                                                            kind: "SelectionSet",
                                                                                                                            selections: [
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "id"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "name"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "capability"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "license"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "active"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "type"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "supportEntitlementNumber"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "trialEndDate"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isEvaluation"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "globalSettingsExtensions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExtensionContext"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "globalSettingsExtensions"
                        },
                        name: {
                            kind: "Name",
                            value: "extensionsByType"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "type"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "confluence:globalSettings",
                                    block: false
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "extensionTypeFields"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "adminPageExtensions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExtensionContext"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "adminPageExtensions"
                        },
                        name: {
                            kind: "Name",
                            value: "extensionsByType"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "type"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "jira:adminPage",
                                    block: false
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "extensionTypeFields"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "compassAdminPageExtensions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExtensionContext"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "compassAdminPageExtensions"
                        },
                        name: {
                            kind: "Name",
                            value: "extensionsByType"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "type"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "compass:adminPage",
                                    block: false
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "extensionTypeFields"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "appInstallationsByContextNodes"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AppInstallationByIndexConnection"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "nodes"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "appEnvironmentVersion"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isLatest"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "requiresLicense"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installationContext"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "app"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "marketplaceApp"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "appKey"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "tagline"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "createdAt"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "versions"
                                                            },
                                                            arguments: [
                                                                {
                                                                    kind: "Argument",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "filter"
                                                                    },
                                                                    value: {
                                                                        kind: "ObjectValue",
                                                                        fields: [
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "productHostingOptions"
                                                                                },
                                                                                value: {
                                                                                    kind: "ListValue",
                                                                                    values: [
                                                                                        {
                                                                                            kind: "EnumValue",
                                                                                            value: "CLOUD"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            },
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "visibility"
                                                                                },
                                                                                value: {
                                                                                    kind: "EnumValue",
                                                                                    value: "PUBLIC"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "edges"
                                                                        },
                                                                        arguments: [],
                                                                        directives: [],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "node"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "paymentModel"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "deployment"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: [],
                                                                                                selectionSet: {
                                                                                                    kind: "SelectionSet",
                                                                                                    selections: [
                                                                                                        {
                                                                                                            kind: "InlineFragment",
                                                                                                            typeCondition: {
                                                                                                                kind: "NamedType",
                                                                                                                name: {
                                                                                                                    kind: "Name",
                                                                                                                    value: "MarketplaceCloudAppDeployment"
                                                                                                                }
                                                                                                            },
                                                                                                            directives: [],
                                                                                                            selectionSet: {
                                                                                                                kind: "SelectionSet",
                                                                                                                selections: [
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "cloudAppId"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: []
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "scopes"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: [],
                                                                                                                        selectionSet: {
                                                                                                                            kind: "SelectionSet",
                                                                                                                            selections: [
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "id"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "name"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "capability"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "license"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "active"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "type"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "supportEntitlementNumber"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "trialEndDate"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isEvaluation"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pageInfo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasNextPage"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "endCursor"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "extensionTypeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Extension"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "environmentId"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "environmentType"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "properties"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "type"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appVersion"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "installationId"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 4200,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\nquery getEcosystemCloudAppInstallations(\n  $context: ID!\n  $after: String\n  $useDeprecatedQuery: Boolean!\n) {\n  extensionContexts(contextIds: [$context]) {\n    id\n\n    # TODO: MC-3960 - cleanup once migrated\n    # eslint-disable-next-line @graphql-eslint/no-deprecated\n    installations(after: $after) @include(if: $useDeprecatedQuery) {\n      ...extensionContextsNodes\n      ...pageInfo\n    }\n    ...globalSettingsExtensions\n    ...adminPageExtensions\n    ...compassAdminPageExtensions\n  }\n  ecosystem @skip(if: $useDeprecatedQuery) {\n    appInstallationsByContext(\n      filter: { appInstallations: { contexts: [$context] } }\n      after: $after\n    ) {\n      ...appInstallationsByContextNodes\n    }\n  }\n}\n\nquery getEcosystemCloudAppInstallation(\n  $context: ID!\n  $appId: ID!\n  $environmentType: AppEnvironmentType\n  $useDeprecatedQuery: Boolean!\n) {\n  extensionContexts(contextIds: [$context]) {\n    id\n\n    # TODO: MC-3960 - cleanup once migrated\n    # eslint-disable-next-line @graphql-eslint/no-deprecated\n    installations(filter: { appId: $appId, environmentType: $environmentType })\n      @include(if: $useDeprecatedQuery) {\n      ...extensionContextsNodes\n    }\n    ...globalSettingsExtensions\n    ...adminPageExtensions\n    ...compassAdminPageExtensions\n  }\n  ecosystem @skip(if: $useDeprecatedQuery) {\n    appInstallationsByContext(\n      filter: { appInstallations: { contexts: [$context] }, apps: { ids: [$appId] } }\n    ) {\n      ...appInstallationsByContextNodes\n    }\n  }\n}\n\nfragment extensionContextsNodes on AppInstallationConnection {\n  nodes {\n    id\n    appEnvironmentVersion {\n      isLatest\n      requiresLicense\n    }\n    app {\n      marketplaceApp {\n        appKey\n        name\n        tagline\n        createdAt\n        versions(filter: { productHostingOptions: [CLOUD], visibility: PUBLIC }) {\n          edges {\n            node {\n              paymentModel\n              deployment {\n                ... on MarketplaceCloudAppDeployment {\n                  cloudAppId\n                  scopes {\n                    id\n                    name\n                    capability\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    license {\n      active\n      type\n      supportEntitlementNumber\n      trialEndDate\n      isEvaluation\n    }\n    createdAt\n  }\n}\n\nfragment appInstallationsByContextNodes on AppInstallationByIndexConnection {\n  nodes {\n    id\n    appEnvironmentVersion {\n      isLatest\n      requiresLicense\n    }\n    installationContext\n    app {\n      marketplaceApp {\n        name\n        appKey\n        tagline\n        createdAt\n        versions(filter: { productHostingOptions: [CLOUD], visibility: PUBLIC }) {\n          edges {\n            node {\n              paymentModel\n              deployment {\n                ... on MarketplaceCloudAppDeployment {\n                  cloudAppId\n                  scopes {\n                    id\n                    name\n                    capability\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    license {\n      active\n      type\n      supportEntitlementNumber\n      trialEndDate\n      isEvaluation\n    }\n    createdAt\n  }\n  pageInfo {\n    hasNextPage\n    endCursor\n  }\n}\n\nfragment pageInfo on AppInstallationConnection {\n  pageInfo {\n    hasNextPage\n    endCursor\n  }\n}\n\nfragment globalSettingsExtensions on ExtensionContext {\n  globalSettingsExtensions: extensionsByType(type: \"confluence:globalSettings\") {\n    ...extensionTypeFields\n  }\n}\n\nfragment adminPageExtensions on ExtensionContext {\n  adminPageExtensions: extensionsByType(type: \"jira:adminPage\") {\n    ...extensionTypeFields\n  }\n}\n\nfragment compassAdminPageExtensions on ExtensionContext {\n  compassAdminPageExtensions: extensionsByType(type: \"compass:adminPage\") {\n    ...extensionTypeFields\n  }\n}\n\nfragment extensionTypeFields on Extension {\n  id\n  environmentId\n  environmentType\n  properties\n  type\n  appVersion\n  installationId\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
var $09cd492ff2df40e2$var$getEcosystemCloudAppInstallations = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "getEcosystemCloudAppInstallations"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "context"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "after"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "useDeprecatedQuery"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Boolean"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "extensionContexts"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "contextIds"
                                },
                                value: {
                                    kind: "ListValue",
                                    values: [
                                        {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "context"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installations"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "after"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "after"
                                                }
                                            }
                                        }
                                    ],
                                    directives: [
                                        {
                                            kind: "Directive",
                                            name: {
                                                kind: "Name",
                                                value: "include"
                                            },
                                            arguments: [
                                                {
                                                    kind: "Argument",
                                                    name: {
                                                        kind: "Name",
                                                        value: "if"
                                                    },
                                                    value: {
                                                        kind: "Variable",
                                                        name: {
                                                            kind: "Name",
                                                            value: "useDeprecatedQuery"
                                                        }
                                                    }
                                                }
                                            ]
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "extensionContextsNodes"
                                                },
                                                directives: []
                                            },
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "pageInfo"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "globalSettingsExtensions"
                                    },
                                    directives: []
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "adminPageExtensions"
                                    },
                                    directives: []
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "compassAdminPageExtensions"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "ecosystem"
                        },
                        arguments: [],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "skip"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "if"
                                        },
                                        value: {
                                            kind: "Variable",
                                            name: {
                                                kind: "Name",
                                                value: "useDeprecatedQuery"
                                            }
                                        }
                                    }
                                ]
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "appInstallationsByContext"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "appInstallations"
                                                        },
                                                        value: {
                                                            kind: "ObjectValue",
                                                            fields: [
                                                                {
                                                                    kind: "ObjectField",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "contexts"
                                                                    },
                                                                    value: {
                                                                        kind: "ListValue",
                                                                        values: [
                                                                            {
                                                                                kind: "Variable",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "context"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ]
                                                        }
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "after"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "after"
                                                }
                                            }
                                        }
                                    ],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "appInstallationsByContextNodes"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "extensionContextsNodes"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AppInstallationConnection"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "nodes"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "appEnvironmentVersion"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isLatest"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "requiresLicense"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "app"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "marketplaceApp"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "appKey"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "tagline"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "createdAt"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "versions"
                                                            },
                                                            arguments: [
                                                                {
                                                                    kind: "Argument",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "filter"
                                                                    },
                                                                    value: {
                                                                        kind: "ObjectValue",
                                                                        fields: [
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "productHostingOptions"
                                                                                },
                                                                                value: {
                                                                                    kind: "ListValue",
                                                                                    values: [
                                                                                        {
                                                                                            kind: "EnumValue",
                                                                                            value: "CLOUD"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            },
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "visibility"
                                                                                },
                                                                                value: {
                                                                                    kind: "EnumValue",
                                                                                    value: "PUBLIC"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "edges"
                                                                        },
                                                                        arguments: [],
                                                                        directives: [],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "node"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "paymentModel"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "deployment"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: [],
                                                                                                selectionSet: {
                                                                                                    kind: "SelectionSet",
                                                                                                    selections: [
                                                                                                        {
                                                                                                            kind: "InlineFragment",
                                                                                                            typeCondition: {
                                                                                                                kind: "NamedType",
                                                                                                                name: {
                                                                                                                    kind: "Name",
                                                                                                                    value: "MarketplaceCloudAppDeployment"
                                                                                                                }
                                                                                                            },
                                                                                                            directives: [],
                                                                                                            selectionSet: {
                                                                                                                kind: "SelectionSet",
                                                                                                                selections: [
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "cloudAppId"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: []
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "scopes"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: [],
                                                                                                                        selectionSet: {
                                                                                                                            kind: "SelectionSet",
                                                                                                                            selections: [
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "id"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "name"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "capability"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "license"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "active"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "type"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "supportEntitlementNumber"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "trialEndDate"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isEvaluation"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "pageInfo"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AppInstallationConnection"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pageInfo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasNextPage"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "endCursor"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "globalSettingsExtensions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExtensionContext"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "globalSettingsExtensions"
                        },
                        name: {
                            kind: "Name",
                            value: "extensionsByType"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "type"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "confluence:globalSettings",
                                    block: false
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "extensionTypeFields"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "adminPageExtensions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExtensionContext"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "adminPageExtensions"
                        },
                        name: {
                            kind: "Name",
                            value: "extensionsByType"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "type"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "jira:adminPage",
                                    block: false
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "extensionTypeFields"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "compassAdminPageExtensions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "ExtensionContext"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "compassAdminPageExtensions"
                        },
                        name: {
                            kind: "Name",
                            value: "extensionsByType"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "type"
                                },
                                value: {
                                    kind: "StringValue",
                                    value: "compass:adminPage",
                                    block: false
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "extensionTypeFields"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "appInstallationsByContextNodes"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AppInstallationByIndexConnection"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "nodes"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "appEnvironmentVersion"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isLatest"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "requiresLicense"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installationContext"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "app"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "marketplaceApp"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "appKey"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "tagline"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "createdAt"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "versions"
                                                            },
                                                            arguments: [
                                                                {
                                                                    kind: "Argument",
                                                                    name: {
                                                                        kind: "Name",
                                                                        value: "filter"
                                                                    },
                                                                    value: {
                                                                        kind: "ObjectValue",
                                                                        fields: [
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "productHostingOptions"
                                                                                },
                                                                                value: {
                                                                                    kind: "ListValue",
                                                                                    values: [
                                                                                        {
                                                                                            kind: "EnumValue",
                                                                                            value: "CLOUD"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            },
                                                                            {
                                                                                kind: "ObjectField",
                                                                                name: {
                                                                                    kind: "Name",
                                                                                    value: "visibility"
                                                                                },
                                                                                value: {
                                                                                    kind: "EnumValue",
                                                                                    value: "PUBLIC"
                                                                                }
                                                                            }
                                                                        ]
                                                                    }
                                                                }
                                                            ],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "edges"
                                                                        },
                                                                        arguments: [],
                                                                        directives: [],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "node"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "paymentModel"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "deployment"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: [],
                                                                                                selectionSet: {
                                                                                                    kind: "SelectionSet",
                                                                                                    selections: [
                                                                                                        {
                                                                                                            kind: "InlineFragment",
                                                                                                            typeCondition: {
                                                                                                                kind: "NamedType",
                                                                                                                name: {
                                                                                                                    kind: "Name",
                                                                                                                    value: "MarketplaceCloudAppDeployment"
                                                                                                                }
                                                                                                            },
                                                                                                            directives: [],
                                                                                                            selectionSet: {
                                                                                                                kind: "SelectionSet",
                                                                                                                selections: [
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "cloudAppId"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: []
                                                                                                                    },
                                                                                                                    {
                                                                                                                        kind: "Field",
                                                                                                                        name: {
                                                                                                                            kind: "Name",
                                                                                                                            value: "scopes"
                                                                                                                        },
                                                                                                                        arguments: [],
                                                                                                                        directives: [],
                                                                                                                        selectionSet: {
                                                                                                                            kind: "SelectionSet",
                                                                                                                            selections: [
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "id"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "name"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                },
                                                                                                                                {
                                                                                                                                    kind: "Field",
                                                                                                                                    name: {
                                                                                                                                        kind: "Name",
                                                                                                                                        value: "capability"
                                                                                                                                    },
                                                                                                                                    arguments: [],
                                                                                                                                    directives: []
                                                                                                                                }
                                                                                                                            ]
                                                                                                                        }
                                                                                                                    }
                                                                                                                ]
                                                                                                            }
                                                                                                        }
                                                                                                    ]
                                                                                                }
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "license"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "active"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "type"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "supportEntitlementNumber"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "trialEndDate"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "isEvaluation"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "createdAt"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pageInfo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasNextPage"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "endCursor"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "extensionTypeFields"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "Extension"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "environmentId"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "environmentType"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "properties"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "type"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appVersion"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "installationId"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 4200,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\nquery getEcosystemCloudAppInstallations(\n  $context: ID!\n  $after: String\n  $useDeprecatedQuery: Boolean!\n) {\n  extensionContexts(contextIds: [$context]) {\n    id\n\n    # TODO: MC-3960 - cleanup once migrated\n    # eslint-disable-next-line @graphql-eslint/no-deprecated\n    installations(after: $after) @include(if: $useDeprecatedQuery) {\n      ...extensionContextsNodes\n      ...pageInfo\n    }\n    ...globalSettingsExtensions\n    ...adminPageExtensions\n    ...compassAdminPageExtensions\n  }\n  ecosystem @skip(if: $useDeprecatedQuery) {\n    appInstallationsByContext(\n      filter: { appInstallations: { contexts: [$context] } }\n      after: $after\n    ) {\n      ...appInstallationsByContextNodes\n    }\n  }\n}\n\nquery getEcosystemCloudAppInstallation(\n  $context: ID!\n  $appId: ID!\n  $environmentType: AppEnvironmentType\n  $useDeprecatedQuery: Boolean!\n) {\n  extensionContexts(contextIds: [$context]) {\n    id\n\n    # TODO: MC-3960 - cleanup once migrated\n    # eslint-disable-next-line @graphql-eslint/no-deprecated\n    installations(filter: { appId: $appId, environmentType: $environmentType })\n      @include(if: $useDeprecatedQuery) {\n      ...extensionContextsNodes\n    }\n    ...globalSettingsExtensions\n    ...adminPageExtensions\n    ...compassAdminPageExtensions\n  }\n  ecosystem @skip(if: $useDeprecatedQuery) {\n    appInstallationsByContext(\n      filter: { appInstallations: { contexts: [$context] }, apps: { ids: [$appId] } }\n    ) {\n      ...appInstallationsByContextNodes\n    }\n  }\n}\n\nfragment extensionContextsNodes on AppInstallationConnection {\n  nodes {\n    id\n    appEnvironmentVersion {\n      isLatest\n      requiresLicense\n    }\n    app {\n      marketplaceApp {\n        appKey\n        name\n        tagline\n        createdAt\n        versions(filter: { productHostingOptions: [CLOUD], visibility: PUBLIC }) {\n          edges {\n            node {\n              paymentModel\n              deployment {\n                ... on MarketplaceCloudAppDeployment {\n                  cloudAppId\n                  scopes {\n                    id\n                    name\n                    capability\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    license {\n      active\n      type\n      supportEntitlementNumber\n      trialEndDate\n      isEvaluation\n    }\n    createdAt\n  }\n}\n\nfragment appInstallationsByContextNodes on AppInstallationByIndexConnection {\n  nodes {\n    id\n    appEnvironmentVersion {\n      isLatest\n      requiresLicense\n    }\n    installationContext\n    app {\n      marketplaceApp {\n        name\n        appKey\n        tagline\n        createdAt\n        versions(filter: { productHostingOptions: [CLOUD], visibility: PUBLIC }) {\n          edges {\n            node {\n              paymentModel\n              deployment {\n                ... on MarketplaceCloudAppDeployment {\n                  cloudAppId\n                  scopes {\n                    id\n                    name\n                    capability\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n    license {\n      active\n      type\n      supportEntitlementNumber\n      trialEndDate\n      isEvaluation\n    }\n    createdAt\n  }\n  pageInfo {\n    hasNextPage\n    endCursor\n  }\n}\n\nfragment pageInfo on AppInstallationConnection {\n  pageInfo {\n    hasNextPage\n    endCursor\n  }\n}\n\nfragment globalSettingsExtensions on ExtensionContext {\n  globalSettingsExtensions: extensionsByType(type: \"confluence:globalSettings\") {\n    ...extensionTypeFields\n  }\n}\n\nfragment adminPageExtensions on ExtensionContext {\n  adminPageExtensions: extensionsByType(type: \"jira:adminPage\") {\n    ...extensionTypeFields\n  }\n}\n\nfragment compassAdminPageExtensions on ExtensionContext {\n  compassAdminPageExtensions: extensionsByType(type: \"compass:adminPage\") {\n    ...extensionTypeFields\n  }\n}\n\nfragment extensionTypeFields on Extension {\n  id\n  environmentId\n  environmentType\n  properties\n  type\n  appVersion\n  installationId\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
var $09cd492ff2df40e2$var$GetMarketplaceAppByKey = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetMarketplaceAUSIAppByKey"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceAppByKey"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "appKey"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "appKey"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AUSIApp"
                                    },
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "versions"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "productHostingOptions"
                                                        },
                                                        value: {
                                                            kind: "ListValue",
                                                            values: [
                                                                {
                                                                    kind: "EnumValue",
                                                                    value: "CLOUD"
                                                                }
                                                            ]
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "visibility"
                                                        },
                                                        value: {
                                                            kind: "EnumValue",
                                                            value: "PUBLIC"
                                                        }
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "IntValue",
                                                value: "1"
                                            }
                                        }
                                    ],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "edges"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "node"
                                                            },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "FragmentSpread",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "AUSIAppVersion"
                                                                        },
                                                                        directives: []
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AUSIApp"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceApp"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appId"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "tagline"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "privacyPolicyUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "logo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AUSIAppLogo"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "partner"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AUSIAppPartner"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AUSIAppVersion"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppVersion"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "version"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "learnMoreUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "endUserLicenseAgreementUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "paymentModel"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deployment"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                        kind: "NamedType",
                                        name: {
                                            kind: "Name",
                                            value: "MarketplaceConnectAppDeployment"
                                        }
                                    },
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "scopes"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                        kind: "NamedType",
                                        name: {
                                            kind: "Name",
                                            value: "MarketplaceCloudAppDeployment"
                                        }
                                    },
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "cloudAppId"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "cloudAppVersionId"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "scopes"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "name"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "capability"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AUSIAppLogo"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceListingImage"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "original"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "highResolution"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AUSIAppPartner"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplacePartner"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "slug"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "partnerType"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 1237,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nquery GetMarketplaceAUSIAppByKey($appKey: String!) {\n  marketplaceAppByKey(appKey: $appKey) {\n    ...AUSIApp\n    versions(filter: { productHostingOptions: [CLOUD], visibility: PUBLIC }, first: 1) {\n      edges {\n        node {\n          ...AUSIAppVersion\n        }\n      }\n    }\n  }\n}\n\nfragment AUSIAppPartner on MarketplacePartner {\n  name\n  id\n  slug\n  partnerType\n}\n\nfragment AUSIApp on MarketplaceApp {\n  name\n  appKey\n  appId\n  tagline\n  privacyPolicyUrl\n  createdAt\n  logo {\n    ...AUSIAppLogo\n  }\n  partner {\n    ...AUSIAppPartner\n  }\n}\n\nfragment AUSIAppLogo on MarketplaceListingImage {\n  original {\n    id\n  }\n\n  highResolution {\n    id\n  }\n}\n\nfragment AUSIAppVersion on MarketplaceAppVersion {\n  version\n  learnMoreUrl\n  endUserLicenseAgreementUrl\n  paymentModel\n  deployment {\n    ... on MarketplaceConnectAppDeployment {\n      scopes {\n        id\n      }\n    }\n\n    ... on MarketplaceCloudAppDeployment {\n      cloudAppId\n      cloudAppVersionId\n      scopes {\n        id\n        name\n        capability\n      }\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
const $09cd492ff2df40e2$export$6b17afb8693d5324 = async (appKey, gqlGatewayUrl)=>{
    const query = (0, $fBab0.print)($09cd492ff2df40e2$var$GetMarketplaceAppByKey);
    const variables = {
        appKey: appKey
    };
    try {
        const responseJSON = await (0, $axFWr.postGraphQlRequest)({
            query: query,
            variables: variables
        }, gqlGatewayUrl);
        const response = responseJSON.data;
        if (response && response.marketplaceAppByKey) {
            var _versions$edges, _versions$edges$;
            const _response$marketplace = response.marketplaceAppByKey, { versions: versions } = _response$marketplace, appProps = (0, $bwPfh.default)(_response$marketplace, $09cd492ff2df40e2$var$_excluded);
            const rawCloudMarketplaceApp = $09cd492ff2df40e2$var$_objectSpread($09cd492ff2df40e2$var$_objectSpread({}, appProps), {}, {
                version: versions === null || versions === void 0 ? void 0 : (_versions$edges = versions.edges) === null || _versions$edges === void 0 ? void 0 : (_versions$edges$ = _versions$edges[0]) === null || _versions$edges$ === void 0 ? void 0 : _versions$edges$.node
            });
            return Promise.resolve(rawCloudMarketplaceApp);
        } else throw new Error('No app found for ' + appKey + 'and the responseJSON.data is ' + JSON.stringify(responseJSON.data));
    } catch (error) {
        const MarketplaceAppByKeyError = (0, $1w7m1.makeAppFetchError)('MarketplaceAppByKeyError');
        throw new MarketplaceAppByKeyError({
            source: error,
            appKey: appKey
        });
    }
};
const $09cd492ff2df40e2$export$b4c382bfffac831e = async (keyIdentifier, cloudVersionId, contextId, environment, gqlGatewayUrl, provisionRequestId)=>{
    const query = (0, $fBab0.print)($09cd492ff2df40e2$var$ecosystemCloudAppInstall);
    const { ecosystemCloudEnvKey: ecosystemCloudEnvKey } = environment;
    const variables = {
        input: {
            installationContext: contextId,
            appId: keyIdentifier.ari,
            environmentKey: ecosystemCloudEnvKey,
            async: true,
            versionId: cloudVersionId,
            provisionRequestId: provisionRequestId
        }
    };
    const defaultErrorMsg = "Ecosystem cloud app installation failed for appId: ".concat(keyIdentifier.ari);
    try {
        var _responseJSON$data, _responseJSON$data$in;
        const responseJSON = await (0, $axFWr.postGraphQlRequest)({
            query: query,
            variables: variables
        }, gqlGatewayUrl);
        if (!((_responseJSON$data = responseJSON.data) !== null && _responseJSON$data !== void 0 && (_responseJSON$data$in = _responseJSON$data.installApp) !== null && _responseJSON$data$in !== void 0 && _responseJSON$data$in.success)) {
            var _responseJSON$data2, _responseJSON$data2$i, _responseJSON$data2$i2;
            throw (_responseJSON$data2 = responseJSON.data) === null || _responseJSON$data2 === void 0 ? void 0 : (_responseJSON$data2$i = _responseJSON$data2.installApp) === null || _responseJSON$data2$i === void 0 ? void 0 : (_responseJSON$data2$i2 = _responseJSON$data2$i.errors) === null || _responseJSON$data2$i2 === void 0 ? void 0 : _responseJSON$data2$i2[0];
        }
        return responseJSON.data;
    } catch (error) {
        var _error$extensions;
        throw new (0, $1w7m1.AppInstallError)({
            addon: keyIdentifier,
            code: (error === null || error === void 0 ? void 0 : (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.errorType) || 'InstallAppFailure',
            message: (error === null || error === void 0 ? void 0 : error.message) || defaultErrorMsg,
            source: error
        });
    }
};
const $09cd492ff2df40e2$export$5f1aa3602816b978 = async (keyIdentifier, contextId, environment, gqlGatewayUrl)=>{
    const query = (0, $fBab0.print)($09cd492ff2df40e2$var$ecosystemCloudAppSubscribe);
    const { ecosystemCloudEnvKey: ecosystemCloudEnvKey } = environment;
    const variables = {
        input: {
            installationContext: contextId,
            appId: keyIdentifier.ari,
            envKey: ecosystemCloudEnvKey
        }
    };
    const defaultErrorMsg = "Ecosystem cloud app subscription failed for appId: ".concat(keyIdentifier.ari);
    try {
        var _responseJSON$data3, _responseJSON$data3$s;
        const responseJSON = await (0, $axFWr.postGraphQlRequest)({
            query: query,
            variables: variables
        }, gqlGatewayUrl);
        if (!((_responseJSON$data3 = responseJSON.data) !== null && _responseJSON$data3 !== void 0 && (_responseJSON$data3$s = _responseJSON$data3.subscribeToApp) !== null && _responseJSON$data3$s !== void 0 && _responseJSON$data3$s.success)) {
            var _responseJSON$data4, _responseJSON$data4$s, _responseJSON$data4$s2;
            throw (_responseJSON$data4 = responseJSON.data) === null || _responseJSON$data4 === void 0 ? void 0 : (_responseJSON$data4$s = _responseJSON$data4.subscribeToApp) === null || _responseJSON$data4$s === void 0 ? void 0 : (_responseJSON$data4$s2 = _responseJSON$data4$s.errors) === null || _responseJSON$data4$s2 === void 0 ? void 0 : _responseJSON$data4$s2[0];
        }
        return responseJSON.data;
    } catch (error) {
        var _error$extensions2;
        throw new (0, $1w7m1.AppInstallError)({
            addon: keyIdentifier,
            code: (error === null || error === void 0 ? void 0 : (_error$extensions2 = error.extensions) === null || _error$extensions2 === void 0 ? void 0 : _error$extensions2.errorType) || 'SubscribeAppFailure',
            message: (error === null || error === void 0 ? void 0 : error.message) || defaultErrorMsg,
            source: error
        });
    }
};
const $09cd492ff2df40e2$export$8712abd2e6bd944d = async (ariIdentifier, installConfig, enableDeprecatedInstallationsGQL)=>{
    const query = (0, $fBab0.print)($09cd492ff2df40e2$var$getEcosystemCloudAppInstallation);
    const environment = (0, $6poH2.default)(installConfig);
    const { product: product, cloudId: cloudId, gqlGatewayUrl: gqlGatewayUrl, activationId: activationId } = installConfig;
    const appId = ariIdentifier.ari;
    const useDeprecatedQuery = Boolean(enableDeprecatedInstallationsGQL);
    const variables = {
        appId: appId,
        context: (0, $axFWr.buildSiteContext)(product, cloudId, activationId),
        environment: environment.ecosystemCloudEnvKey,
        useDeprecatedQuery: useDeprecatedQuery
    };
    if (useDeprecatedQuery) (0, $bTrQR.default).info('getEcosystemCloudAppInstallation', 'Requested installations using deprecated query');
    const cloudAppData = await (0, $axFWr.postGraphQlRequest)({
        query: query,
        variables: variables
    }, gqlGatewayUrl);
    return cloudAppData;
};
const $09cd492ff2df40e2$export$d20f2968c1baec15 = async (ariIdentifier, installConfig, flags)=>{
    const { product: product, baseUrl: baseUrl } = installConfig;
    const appId = ariIdentifier.ari;
    const defaultErrorMsg = "No ecosystem cloud app found for appId: ".concat(appId);
    try {
        var _cloudAppData$errors, _cloudAppData$data$ex, _cloudAppData$data, _cloudAppData$data$ec, _cloudAppData$data$ex2, _cloudAppData$data$ex3, _cloudAppData$data$ex4;
        const cloudAppData = await $09cd492ff2df40e2$export$8712abd2e6bd944d(ariIdentifier, installConfig, flags === null || flags === void 0 ? void 0 : flags.enableDeprecatedInstallationsGQL);
        const requestId = (0, $axFWr.getRequestId)(cloudAppData);
        if ((_cloudAppData$errors = cloudAppData.errors) !== null && _cloudAppData$errors !== void 0 && _cloudAppData$errors.length || !cloudAppData.data.extensionContexts) {
            var _cloudAppData$errors2;
            throw new Error(((_cloudAppData$errors2 = cloudAppData.errors) === null || _cloudAppData$errors2 === void 0 ? void 0 : _cloudAppData$errors2[0].message) || defaultErrorMsg, {
                cause: requestId
            });
        }
        const installations = flags !== null && flags !== void 0 && flags.enableDeprecatedInstallationsGQL ? (_cloudAppData$data$ex = cloudAppData.data.extensionContexts) === null || _cloudAppData$data$ex === void 0 ? void 0 : _cloudAppData$data$ex[0].installations : (_cloudAppData$data = cloudAppData.data) === null || _cloudAppData$data === void 0 ? void 0 : (_cloudAppData$data$ec = _cloudAppData$data.ecosystem) === null || _cloudAppData$data$ec === void 0 ? void 0 : _cloudAppData$data$ec.appInstallationsByContext;
        const globalSettingsExtensions = (_cloudAppData$data$ex2 = cloudAppData.data.extensionContexts) === null || _cloudAppData$data$ex2 === void 0 ? void 0 : _cloudAppData$data$ex2[0].globalSettingsExtensions;
        const adminPageExtensions = (_cloudAppData$data$ex3 = cloudAppData.data.extensionContexts) === null || _cloudAppData$data$ex3 === void 0 ? void 0 : _cloudAppData$data$ex3[0].adminPageExtensions;
        const compassAdminPageExtensions = (_cloudAppData$data$ex4 = cloudAppData.data.extensionContexts) === null || _cloudAppData$data$ex4 === void 0 ? void 0 : _cloudAppData$data$ex4[0].compassAdminPageExtensions;
        let productExtensions;
        if (product === (0, $i0EDR.CompatibleProductId).Jira) productExtensions = adminPageExtensions;
        else if (product === (0, $i0EDR.CompatibleProductId).Confluence) productExtensions = globalSettingsExtensions;
        else productExtensions = compassAdminPageExtensions;
        if (!installations.nodes.length) throw new Error("No app installation was found by identifier ".concat(ariIdentifier.ari), {
            cause: requestId
        });
        let appInstallation;
        if (flags && flags.enableReactivateForgeAppFromEmcee) {
            var _installations$nodes$, _installations$nodes$2;
            const isPaidApp = (_installations$nodes$ = installations.nodes[0].appEnvironmentVersion) === null || _installations$nodes$ === void 0 ? void 0 : _installations$nodes$.requiresLicense;
            const isLicenseActive = (_installations$nodes$2 = installations.nodes[0].license) === null || _installations$nodes$2 === void 0 ? void 0 : _installations$nodes$2.active;
            if (isPaidApp && isLicenseActive || !isPaidApp) appInstallation = installations.nodes[0];
            else throw new Error("No app subscription was found by identifier ".concat(ariIdentifier.ari), {
                cause: requestId
            });
        } else appInstallation = installations.nodes[0];
        return (0, $axFWr.toInstalledEcosystemCloudAddon)(product, baseUrl, appInstallation, productExtensions.filter((extension)=>extension.installationId === appInstallation.id));
    } catch (error) {
        const MarketplaceAppByAriError = (0, $1w7m1.makeAppFetchError)('MarketplaceAppByAriError');
        throw new MarketplaceAppByAriError({
            source: error,
            appKey: ariIdentifier.appKey,
            requestId: error === null || error === void 0 ? void 0 : error.cause
        });
    }
};
const $09cd492ff2df40e2$var$getInstalledEcosystemCloudApps = async (installConfig, after, flags)=>{
    const { product: product, cloudId: cloudId, baseUrl: baseUrl, gqlGatewayUrl: gqlGatewayUrl, activationId: activationId } = installConfig;
    const query = (0, $fBab0.print)($09cd492ff2df40e2$var$getEcosystemCloudAppInstallations);
    const useDeprecatedQuery = Boolean(flags === null || flags === void 0 ? void 0 : flags.enableDeprecatedInstallationsGQL);
    const variables = {
        context: (0, $axFWr.buildSiteContext)(product, cloudId, activationId),
        after: after,
        useDeprecatedQuery: useDeprecatedQuery
    };
    if (useDeprecatedQuery) (0, $bTrQR.default).info('getEcosystemCloudAppInstallations', 'Requested installations using deprecated query');
    const defaultErrorMsg = 'Failed to fetch installed Ecosystem Cloud Apps';
    try {
        var _cloudAppsData$data, _cloudAppsData$data$e, _cloudAppsData$data2, _cloudAppsData$data2$, _cloudAppsData$data3, _cloudAppsData$data3$, _cloudAppsData$data4, _cloudAppsData$data4$, _cloudAppsData$data5, _cloudAppsData$data5$;
        // @Todo remove double await https://ecosystem.atlassian.net/browse/FMI-520
        const cloudAppsData = await await (0, $axFWr.postGraphQlRequest)({
            query: query,
            variables: variables
        }, gqlGatewayUrl);
        const extensionContextInstallation = flags !== null && flags !== void 0 && flags.enableDeprecatedInstallationsGQL ? (_cloudAppsData$data = cloudAppsData.data) === null || _cloudAppsData$data === void 0 ? void 0 : (_cloudAppsData$data$e = _cloudAppsData$data.extensionContexts) === null || _cloudAppsData$data$e === void 0 ? void 0 : _cloudAppsData$data$e[0].installations : (_cloudAppsData$data2 = cloudAppsData.data) === null || _cloudAppsData$data2 === void 0 ? void 0 : (_cloudAppsData$data2$ = _cloudAppsData$data2.ecosystem) === null || _cloudAppsData$data2$ === void 0 ? void 0 : _cloudAppsData$data2$.appInstallationsByContext;
        const globalSettingsExtensions = (_cloudAppsData$data3 = cloudAppsData.data) === null || _cloudAppsData$data3 === void 0 ? void 0 : (_cloudAppsData$data3$ = _cloudAppsData$data3.extensionContexts) === null || _cloudAppsData$data3$ === void 0 ? void 0 : _cloudAppsData$data3$[0].globalSettingsExtensions;
        const adminPageExtensions = (_cloudAppsData$data4 = cloudAppsData.data) === null || _cloudAppsData$data4 === void 0 ? void 0 : (_cloudAppsData$data4$ = _cloudAppsData$data4.extensionContexts) === null || _cloudAppsData$data4$ === void 0 ? void 0 : _cloudAppsData$data4$[0].adminPageExtensions;
        const compassAdminPageExtensions = (_cloudAppsData$data5 = cloudAppsData.data) === null || _cloudAppsData$data5 === void 0 ? void 0 : (_cloudAppsData$data5$ = _cloudAppsData$data5.extensionContexts) === null || _cloudAppsData$data5$ === void 0 ? void 0 : _cloudAppsData$data5$[0].compassAdminPageExtensions;
        let productExtensions;
        if (product === (0, $i0EDR.CompatibleProductId).Jira) productExtensions = adminPageExtensions;
        else if (product === (0, $i0EDR.CompatibleProductId).Confluence) productExtensions = globalSettingsExtensions;
        else productExtensions = compassAdminPageExtensions;
        if (!extensionContextInstallation) {
            var _cloudAppsData$errors;
            throw new Error(((_cloudAppsData$errors = cloudAppsData.errors) === null || _cloudAppsData$errors === void 0 ? void 0 : _cloudAppsData$errors[0].message) || defaultErrorMsg);
        }
        const installedAddons = (0, $axFWr.transformInstalledCloudAppsGraphqlApiData)(product, baseUrl, flags && flags.enableReactivateForgeAppFromEmcee ? (extensionContextInstallation.nodes || []).filter((node)=>{
            var _node$appEnvironmentV, _node$license;
            const isPaidApp = (_node$appEnvironmentV = node.appEnvironmentVersion) === null || _node$appEnvironmentV === void 0 ? void 0 : _node$appEnvironmentV.requiresLicense;
            const isLicenseActive = (_node$license = node.license) === null || _node$license === void 0 ? void 0 : _node$license.active;
            return node.app && (isPaidApp && isLicenseActive || !isPaidApp);
        }) : (extensionContextInstallation.nodes || []).filter((node)=>node.app), productExtensions.slice() // use .slice to create new mutable array for flow
        );
        return {
            installedAddons: installedAddons,
            hasNextPage: !!extensionContextInstallation.pageInfo.hasNextPage,
            endCursor: extensionContextInstallation.pageInfo.endCursor
        };
    } catch (error) {
        console.error('Failed to fetch installed Ecosystem Cloud Apps:', error);
        return {
            installedAddons: [],
            hasNextPage: false
        };
    }
};
const $09cd492ff2df40e2$export$d286412e060e80fe = async function fetchAllInstalledEcosystemCloudApps(installConfig, flags, endCursor) {
    let allInstalledEcosystemCloudApps = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    try {
        const ecosystemCloudAppResponse = await $09cd492ff2df40e2$var$getInstalledEcosystemCloudApps(installConfig, endCursor, flags);
        const allUpdatedInstalledEcosystemCloudApps = [
            ...allInstalledEcosystemCloudApps,
            ...ecosystemCloudAppResponse.installedAddons
        ];
        if (ecosystemCloudAppResponse.hasNextPage && ecosystemCloudAppResponse.endCursor) return await fetchAllInstalledEcosystemCloudApps(installConfig, flags, ecosystemCloudAppResponse.endCursor, allUpdatedInstalledEcosystemCloudApps);
        return allUpdatedInstalledEcosystemCloudApps;
    } catch (_unused) {
        return allInstalledEcosystemCloudApps;
    }
};
/* For forge apps, some errors from downstream service are not mapped to error code at CaaS.
We do this explicitly here in order to ignore certain non actionable errors from SLO

Known issue: Keeping this list up to date is not easy as there is no list available from CaaS.
*/ const $09cd492ff2df40e2$var$mapEcosystemCloudAppFailuresToErrorCode = (errors)=>{
    const errorsMap = {
        'COFS failure, account pending renewal': 'account.pending.renewal',
        'An unexpected error occurred': 'unexpected.error',
        'Error sending connect plugin lifecycle event callback: product/site does not exist or has been deactivated': 'app.deactivated',
        'Error sending connect plugin lifecycle event callback: A permission sync is already running on the tenant': 'app.install.inprogress',
        'Failed to license app for product jira because this app has not been configured to support this product': 'app.misconfigured',
        'Failed to license app for product confluence because this app has not been configured to support this product': 'app.misconfigured'
    };
    const UNKNOWN_ERROR_CODE = 'unknown.error.code';
    return (errors === null || errors === void 0 ? void 0 : errors[0].message) && errorsMap[errors[0].message] || UNKNOWN_ERROR_CODE;
};
const $09cd492ff2df40e2$export$ddea117e2d623b52 = {
    postInstallToEcosystemCloud: async (keyIdentifier, cloudVersionId, siteBaseUrl, environment, contextId, gqlGatewayUrl, provisionRequestId)=>{
        const ecosystemCloudInstallResponse = await $09cd492ff2df40e2$export$b4c382bfffac831e(keyIdentifier, cloudVersionId, contextId, environment, gqlGatewayUrl, provisionRequestId);
        const installAppData = ecosystemCloudInstallResponse.installApp;
        const defaultErrorMsg = "Ecosystem cloud app installation failed for appId: ".concat(keyIdentifier.ari);
        if (installAppData && !installAppData.success) {
            var _installAppData$error, _installAppData$error2, _installAppData$error3, _installAppData$error4;
            throw new (0, $1w7m1.AppInstallError)({
                addon: keyIdentifier,
                code: ((_installAppData$error = installAppData.errors) === null || _installAppData$error === void 0 ? void 0 : (_installAppData$error2 = _installAppData$error[0].extensions) === null || _installAppData$error2 === void 0 ? void 0 : _installAppData$error2.errorType) || 'InstallAppFailure',
                message: ((_installAppData$error3 = installAppData.errors) === null || _installAppData$error3 === void 0 ? void 0 : _installAppData$error3[0].message) || defaultErrorMsg,
                source: (_installAppData$error4 = installAppData.errors) === null || _installAppData$error4 === void 0 ? void 0 : _installAppData$error4[0]
            });
        }
        return installAppData;
    },
    subscribeToEcosystemCloud: async (keyIdentifier, environment, contextId, gqlGatewayUrl)=>{
        const ecosystemCloudSubscribeResponse = await $09cd492ff2df40e2$export$5f1aa3602816b978(keyIdentifier, contextId, environment, gqlGatewayUrl);
        const subscribeAppData = ecosystemCloudSubscribeResponse.subscribeToApp;
        const defaultErrorMsg = "Ecosystem cloud app installation failed for appId: ".concat(keyIdentifier.ari);
        if (subscribeAppData && !subscribeAppData.success) {
            var _subscribeAppData$err, _subscribeAppData$err2, _subscribeAppData$err3, _subscribeAppData$err4;
            throw new (0, $1w7m1.AppInstallError)({
                addon: keyIdentifier,
                code: ((_subscribeAppData$err = subscribeAppData.errors) === null || _subscribeAppData$err === void 0 ? void 0 : (_subscribeAppData$err2 = _subscribeAppData$err[0].extensions) === null || _subscribeAppData$err2 === void 0 ? void 0 : _subscribeAppData$err2.errorType) || 'SubscribeAppFailure',
                message: ((_subscribeAppData$err3 = subscribeAppData.errors) === null || _subscribeAppData$err3 === void 0 ? void 0 : _subscribeAppData$err3[0].message) || defaultErrorMsg,
                source: (_subscribeAppData$err4 = subscribeAppData.errors) === null || _subscribeAppData$err4 === void 0 ? void 0 : _subscribeAppData$err4[0]
            });
        }
        return subscribeAppData;
    },
    pollEcosystemCloudAppInstallStatus: async (taskId, siteBaseUrl, gqlGatewayUrl, options)=>{
        try {
            const pollingResponse = await (0, $axFWr.checkEcosystemCloudAppInstallStatus)(taskId, gqlGatewayUrl);
            const pollStatus = pollingResponse.appInstallationTask;
            if (pollStatus && pollStatus.state === 'PENDING' || pollStatus && pollStatus.state === 'RUNNING') throw new (0, $1w7m1.AppInstallError)({
                addon: options.addon,
                code: 'EcosystemCloudInstallPollFailure',
                message: "AppInstallationTask in polling response not completed, current state:".concat(pollStatus.state),
                requestId: pollingResponse === null || pollingResponse === void 0 ? void 0 : pollingResponse.requestId
            });
            else if (pollStatus && pollStatus.state === 'COMPLETE') return true;
            else throw new (0, $1w7m1.AppInstallError)({
                addon: options.addon,
                code: "EcosystemCloudInstallPollFailure-".concat($09cd492ff2df40e2$var$mapEcosystemCloudAppFailuresToErrorCode(pollStatus === null || pollStatus === void 0 ? void 0 : pollStatus.errors)),
                message: "AppInstallationTask state is failed due to ".concat(JSON.stringify((pollStatus === null || pollStatus === void 0 ? void 0 : pollStatus.errors) || []) || 'unknown reason'),
                requestId: pollingResponse === null || pollingResponse === void 0 ? void 0 : pollingResponse.requestId
            });
        } catch (error) {
            if (error instanceof (0, $1w7m1.AppInstallError)) throw error;
            throw new (0, $1w7m1.AppInstallError)({
                addon: options.addon,
                code: 'AppInstallationTaskFailedError',
                message: "Failed while polling for app installation status for ".concat(options.addon.toString()),
                source: error,
                requestId: error === null || error === void 0 ? void 0 : error.cause
            });
        }
    }
};
const $09cd492ff2df40e2$export$9501823dbb04cc30 = async (ariIdentifier, config, options)=>{
    var _cloudAppData$errors3, _cloudAppData$data$ex5, _cloudAppData$data2, _cloudAppData$data2$e, _installations$nodes;
    const { baseUrl: baseUrl, gqlGatewayUrl: gqlGatewayUrl } = config;
    const environment = (0, $6poH2.default)(config);
    const cloudAppData = await $09cd492ff2df40e2$export$8712abd2e6bd944d(ariIdentifier, config, options === null || options === void 0 ? void 0 : options.enableDeprecatedInstallationsGQL);
    if ((_cloudAppData$errors3 = cloudAppData.errors) !== null && _cloudAppData$errors3 !== void 0 && _cloudAppData$errors3.length || !cloudAppData.data.extensionContexts) {
        var _cloudAppData$errors4;
        throw new Error((_cloudAppData$errors4 = cloudAppData.errors) === null || _cloudAppData$errors4 === void 0 ? void 0 : _cloudAppData$errors4[0].message);
    }
    const installations = options !== null && options !== void 0 && options.enableDeprecatedInstallationsGQL ? (_cloudAppData$data$ex5 = cloudAppData.data.extensionContexts) === null || _cloudAppData$data$ex5 === void 0 ? void 0 : _cloudAppData$data$ex5[0].installations : (_cloudAppData$data2 = cloudAppData.data) === null || _cloudAppData$data2 === void 0 ? void 0 : (_cloudAppData$data2$e = _cloudAppData$data2.ecosystem) === null || _cloudAppData$data2$e === void 0 ? void 0 : _cloudAppData$data2$e.appInstallationsByContext;
    if ((_installations$nodes = installations.nodes) !== null && _installations$nodes !== void 0 && _installations$nodes.length) {
        var _appInstallation$appE, _appInstallation$lice;
        const appInstallation = installations.nodes[0];
        const isPaidApp = (_appInstallation$appE = appInstallation.appEnvironmentVersion) === null || _appInstallation$appE === void 0 ? void 0 : _appInstallation$appE.requiresLicense;
        const isLicenseActive = (_appInstallation$lice = appInstallation.license) === null || _appInstallation$lice === void 0 ? void 0 : _appInstallation$lice.active;
        if (isPaidApp && !isLicenseActive) {
            const subscribeAppData = await $09cd492ff2df40e2$export$ddea117e2d623b52.subscribeToEcosystemCloud(ariIdentifier, environment, options.contextId, gqlGatewayUrl);
            if (subscribeAppData !== null && subscribeAppData !== void 0 && subscribeAppData.taskId) await $09cd492ff2df40e2$export$ddea117e2d623b52.pollEcosystemCloudAppInstallStatus(subscribeAppData.taskId, baseUrl, gqlGatewayUrl, options);
            try {
                const installedApp = await $09cd492ff2df40e2$export$d20f2968c1baec15(ariIdentifier, config, {
                    enableReactivateForgeAppFromEmcee: options.enableReactivateForgeAppFromEmcee,
                    enableDeprecatedInstallationsGQL: options.enableDeprecatedInstallationsGQL
                });
                return installedApp;
            } catch (error) {
                var _error$meta;
                throw new (0, $1w7m1.AppInstallError)({
                    addon: options.addon,
                    code: 'EcosystemCloudAppFetchFailed',
                    message: "Unable to fetch ecosystem cloud app with identifier ".concat(ariIdentifier.ari),
                    requestId: error === null || error === void 0 ? void 0 : (_error$meta = error.meta) === null || _error$meta === void 0 ? void 0 : _error$meta.requestId
                });
            }
        }
    }
    return Promise.resolve();
};
const $09cd492ff2df40e2$export$c24ba89f6d4f98e3 = async (ariIdentifier, config, options)=>{
    try {
        return $09cd492ff2df40e2$export$d20f2968c1baec15(ariIdentifier, config, {
            enableReactivateForgeAppFromEmcee: options.enableReactivateForgeAppFromEmcee,
            enableDeprecatedInstallationsGQL: options.enableDeprecatedInstallationsGQL
        });
    } catch (error) {
        var _error$meta2;
        throw new (0, $1w7m1.AppInstallError)({
            addon: options.addon,
            code: 'EcosystemCloudAppFetchFailed',
            message: "Unable to fetch ecosystem cloud app with identifier ".concat(ariIdentifier.ari),
            requestId: error === null || error === void 0 ? void 0 : (_error$meta2 = error.meta) === null || _error$meta2 === void 0 ? void 0 : _error$meta2.requestId
        });
    }
};
const $09cd492ff2df40e2$export$cad10fadc88b1e5d = async (ariIdentifier, config, options, provisionRequestId)=>{
    var _MarketplaceApp$versi;
    const { baseUrl: baseUrl, gqlGatewayUrl: gqlGatewayUrl } = config;
    const environment = (0, $6poH2.default)(config);
    const MarketplaceApp = await $09cd492ff2df40e2$export$6b17afb8693d5324((0, $c0juV.makeAppKey)(ariIdentifier.appKey), gqlGatewayUrl);
    const cloudVersionId = (_MarketplaceApp$versi = MarketplaceApp.version.deployment) === null || _MarketplaceApp$versi === void 0 ? void 0 : _MarketplaceApp$versi.cloudAppVersionId;
    if (!cloudVersionId) throw new (0, $1w7m1.AppInstallError)({
        addon: options.addon,
        code: 'CloudVersionIdFetchError',
        message: "CloudVersionId is not present for version specific installation ".concat(options.addon.toString())
    });
    if (options.enableReactivateForgeAppFromEmcee) {
        const subscribeAppResult = await $09cd492ff2df40e2$export$9501823dbb04cc30(ariIdentifier, config, options);
        if (subscribeAppResult) return subscribeAppResult;
    }
    const installedApp = await $09cd492ff2df40e2$export$ddea117e2d623b52.postInstallToEcosystemCloud(ariIdentifier, cloudVersionId, baseUrl, environment, options.contextId, gqlGatewayUrl, provisionRequestId);
    if (installedApp !== null && installedApp !== void 0 && installedApp.taskId) await $09cd492ff2df40e2$export$ddea117e2d623b52.pollEcosystemCloudAppInstallStatus(installedApp.taskId, baseUrl, gqlGatewayUrl, options);
    return $09cd492ff2df40e2$export$c24ba89f6d4f98e3(ariIdentifier, config, options);
};

});

parcelRegister("dDuCy", function(module, exports) {

$parcel$export(module.exports, "installAddonViaStoreBFF", () => $9ed6ab8771e7a5c0$export$975d542216447854);

var $lLYAL = parcelRequire("lLYAL");

var $1w7m1 = parcelRequire("1w7m1");

var $ammkg = parcelRequire("ammkg");

var $fBab0 = parcelRequire("fBab0");

var $gQV53 = parcelRequire("gQV53");

var $axFWr = parcelRequire("axFWr");

var $9y1TQ = parcelRequire("9y1TQ");
var $9ed6ab8771e7a5c0$var$GetInstallStatus = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetInstallStatus"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "taskId"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceStore"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installAppStatus"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "id"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "taskId"
                                                }
                                            }
                                        }
                                    ],
                                    directives: [
                                        {
                                            kind: "Directive",
                                            name: {
                                                kind: "Name",
                                                value: "optIn"
                                            },
                                            arguments: [
                                                {
                                                    kind: "Argument",
                                                    name: {
                                                        kind: "Name",
                                                        value: "to"
                                                    },
                                                    value: {
                                                        kind: "StringValue",
                                                        value: "MarketplaceStoreInstallAppM1",
                                                        block: false
                                                    }
                                                }
                                            ]
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "InstallResult"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InstallResult"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceStoreInstallAppResponse"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "taskId"
                        },
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "status"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 458,
        source: {
            body: "fragment InstallResult on MarketplaceStoreInstallAppResponse {\n  taskId: id\n  status\n}\n\nmutation InstallApp($input: MarketplaceStoreInstallAppInput!) {\n  marketplaceStore {\n    installApp(input: $input) @optIn(to: \"MarketplaceStoreInstallAppM1\") {\n      ...InstallResult\n    }\n  }\n}\n\nquery GetInstallStatus($taskId: ID!) {\n  marketplaceStore {\n    installAppStatus(id: $taskId) @optIn(to: \"MarketplaceStoreInstallAppM1\") {\n      ...InstallResult\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
var $9ed6ab8771e7a5c0$var$InstallApp = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "mutation",
            name: {
                kind: "Name",
                value: "InstallApp"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "input"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "MarketplaceStoreInstallAppInput"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceStore"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "installApp"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "input"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "input"
                                                }
                                            }
                                        }
                                    ],
                                    directives: [
                                        {
                                            kind: "Directive",
                                            name: {
                                                kind: "Name",
                                                value: "optIn"
                                            },
                                            arguments: [
                                                {
                                                    kind: "Argument",
                                                    name: {
                                                        kind: "Name",
                                                        value: "to"
                                                    },
                                                    value: {
                                                        kind: "StringValue",
                                                        value: "MarketplaceStoreInstallAppM1",
                                                        block: false
                                                    }
                                                }
                                            ]
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "InstallResult"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InstallResult"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceStoreInstallAppResponse"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "taskId"
                        },
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "status"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 458,
        source: {
            body: "fragment InstallResult on MarketplaceStoreInstallAppResponse {\n  taskId: id\n  status\n}\n\nmutation InstallApp($input: MarketplaceStoreInstallAppInput!) {\n  marketplaceStore {\n    installApp(input: $input) @optIn(to: \"MarketplaceStoreInstallAppM1\") {\n      ...InstallResult\n    }\n  }\n}\n\nquery GetInstallStatus($taskId: ID!) {\n  marketplaceStore {\n    installAppStatus(id: $taskId) @optIn(to: \"MarketplaceStoreInstallAppM1\") {\n      ...InstallResult\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
const $9ed6ab8771e7a5c0$var$ProductNameToTargetProductMap = {
    confluence: (0, $ammkg.MarketplaceStoreInstallationTargetProduct).Confluence,
    jira: (0, $ammkg.MarketplaceStoreInstallationTargetProduct).Jira,
    compass: (0, $ammkg.MarketplaceStoreInstallationTargetProduct).Compass
};
const $9ed6ab8771e7a5c0$var$executeInstallAppMutation = async (variables, gqlGatewayUrl)=>{
    var _data$marketplaceStor, _data$marketplaceStor2;
    const mutation = (0, $fBab0.print)($9ed6ab8771e7a5c0$var$InstallApp);
    let graphqlResult;
    const { input: { appKey: appKey } } = variables;
    try {
        graphqlResult = await (0, $axFWr.postGraphQlRequest)({
            query: mutation,
            variables: variables
        }, gqlGatewayUrl);
    } catch (error) {
        throw (0, $9y1TQ.appInstallErrorFromGraphQLFetchError)(appKey, 'trigger', error);
    }
    const { data: data, errors: errors, extensions: extensions } = graphqlResult;
    if (data !== null && data !== void 0 && (_data$marketplaceStor = data.marketplaceStore) !== null && _data$marketplaceStor !== void 0 && (_data$marketplaceStor2 = _data$marketplaceStor.installApp) !== null && _data$marketplaceStor2 !== void 0 && _data$marketplaceStor2.taskId) {
        var _data$marketplaceStor3;
        return data === null || data === void 0 ? void 0 : (_data$marketplaceStor3 = data.marketplaceStore) === null || _data$marketplaceStor3 === void 0 ? void 0 : _data$marketplaceStor3.installApp;
    }
    // we're here cause something went wrong and we weren't able to get a taskId
    throw (0, $9y1TQ.appInstallErrorFromGraphQLErrorResponse)(appKey, 'trigger', errors, extensions);
};
const $9ed6ab8771e7a5c0$var$pollAppInstallStatus = async (args)=>{
    var _data$marketplaceStor6, _data$marketplaceStor7;
    const { appKey: appKey, taskId: taskId, gqlGatewayUrl: gqlGatewayUrl } = args;
    const query = (0, $fBab0.print)($9ed6ab8771e7a5c0$var$GetInstallStatus);
    const variables = {
        taskId: taskId
    };
    const pollAfter = 5000;
    const maxMinutesToWait = 5;
    const options = {
        retries: (0, $gQV53.calculateRetries)(maxMinutesToWait, pollAfter),
        retryDelay: pollAfter,
        accept: async (response)=>{
            var _data$marketplaceStor4, _data$marketplaceStor5;
            const { data: data } = await response.json();
            const installStatus = data === null || data === void 0 ? void 0 : (_data$marketplaceStor4 = data.marketplaceStore) === null || _data$marketplaceStor4 === void 0 ? void 0 : (_data$marketplaceStor5 = _data$marketplaceStor4.installAppStatus) === null || _data$marketplaceStor5 === void 0 ? void 0 : _data$marketplaceStor5.status;
            if (installStatus === (0, $ammkg.MarketplaceStoreInstallAppStatus).Pending || installStatus === (0, $ammkg.MarketplaceStoreInstallAppStatus).InProgress) throw new Error('App install still in progress');
        }
    };
    let graphqlResult;
    try {
        graphqlResult = await (0, $axFWr.postGraphQlRequest)({
            query: query,
            variables: variables,
            options: options
        }, gqlGatewayUrl);
    } catch (error) {
        throw (0, $9y1TQ.appInstallErrorFromGraphQLFetchError)(appKey, 'poll', error, taskId);
    }
    const { data: data, errors: errors, extensions: extensions } = graphqlResult;
    if ((data === null || data === void 0 ? void 0 : (_data$marketplaceStor6 = data.marketplaceStore) === null || _data$marketplaceStor6 === void 0 ? void 0 : (_data$marketplaceStor7 = _data$marketplaceStor6.installAppStatus) === null || _data$marketplaceStor7 === void 0 ? void 0 : _data$marketplaceStor7.status) === (0, $ammkg.MarketplaceStoreInstallAppStatus).Success) {
        var _data$marketplaceStor8;
        return data === null || data === void 0 ? void 0 : (_data$marketplaceStor8 = data.marketplaceStore) === null || _data$marketplaceStor8 === void 0 ? void 0 : _data$marketplaceStor8.installAppStatus;
    }
    // we're here cause something went wrong
    throw (0, $9y1TQ.appInstallErrorFromGraphQLErrorResponse)(appKey, 'poll', errors, extensions, taskId);
};
const $9ed6ab8771e7a5c0$export$975d542216447854 = async (installAddonDetails, config)=>{
    const { gqlGatewayUrl: gqlGatewayUrl } = config;
    const { appKey: appKey, installationTargetInfo: installationTargetInfo } = installAddonDetails;
    const { contextId: contextId, productName: productName } = installationTargetInfo;
    const { cloudId: cloudId } = (0, $lLYAL.parse)(contextId);
    const targetProduct = $9ed6ab8771e7a5c0$var$ProductNameToTargetProductMap[productName];
    if (!cloudId) throw new (0, $1w7m1.AppInstallError)({
        addon: {
            key: appKey
        },
        code: (0, $9y1TQ.ErrorCode).InvalidInstallationTargetInfo,
        message: "Unable to parse cloudId from installationTargetInfo.contextId: ".concat(contextId)
    });
    if (!targetProduct) throw new (0, $1w7m1.AppInstallError)({
        addon: {
            key: appKey
        },
        code: (0, $9y1TQ.ErrorCode).InvalidInstallationTargetInfo,
        message: "Invalid productName: ".concat(productName)
    });
    const { taskId: taskId } = await $9ed6ab8771e7a5c0$var$executeInstallAppMutation({
        input: {
            appKey: appKey,
            target: {
                cloudId: cloudId,
                product: targetProduct
            }
        }
    }, gqlGatewayUrl);
    return $9ed6ab8771e7a5c0$var$pollAppInstallStatus({
        appKey: appKey,
        taskId: taskId,
        gqlGatewayUrl: gqlGatewayUrl
    });
};

});
parcelRegister("ammkg", function(module, exports) {

$parcel$export(module.exports, "AtlassianProductHostingType", () => $78ad46e0d6808149$export$38d407d6909984c2);
$parcel$export(module.exports, "MarketplaceAppPaymentModel", () => $78ad46e0d6808149$export$f25ba44b203e3645);
$parcel$export(module.exports, "MarketplaceAppVersionVisibility", () => $78ad46e0d6808149$export$6e069b93ed3dba5f);
$parcel$export(module.exports, "MarketplaceBillingCycle", () => $78ad46e0d6808149$export$dafb60ab7ab08188);
$parcel$export(module.exports, "MarketplaceLocation", () => $78ad46e0d6808149$export$25ad001a38719422);
$parcel$export(module.exports, "MarketplacePartnerSupportHolidayFrequency", () => $78ad46e0d6808149$export$96bfc8c3eec61fd0);
$parcel$export(module.exports, "MarketplacePartnerTierType", () => $78ad46e0d6808149$export$4f999921e3690a15);
$parcel$export(module.exports, "MarketplacePartnerType", () => $78ad46e0d6808149$export$8fec59d6f9a79101);
$parcel$export(module.exports, "MarketplacePricingTierMode", () => $78ad46e0d6808149$export$3c578ff2609d82d7);
$parcel$export(module.exports, "MarketplacePricingTierPolicy", () => $78ad46e0d6808149$export$7edcca7ce5991948);
$parcel$export(module.exports, "MarketplacePricingTierType", () => $78ad46e0d6808149$export$645f0980d82252ac);
$parcel$export(module.exports, "MarketplaceProgramStatus", () => $78ad46e0d6808149$export$2cbd5d0207702c5);
$parcel$export(module.exports, "MarketplaceStoreInstallAppStatus", () => $78ad46e0d6808149$export$f6c61b63a81bc74a);
$parcel$export(module.exports, "MarketplaceStoreInstallationTargetProduct", () => $78ad46e0d6808149$export$36ca2010d8fa9f9a);
/**
 *   This file is auto-generated.
 *   Any manual changes done could be lost.
 **/ /** All built-in and custom scalars, mapped to their actual values */ let $78ad46e0d6808149$export$1798210ae1009578 = /*#__PURE__*/ function(AcceptableResponse) {
    AcceptableResponse["False"] = "FALSE";
    AcceptableResponse["NotApplicable"] = "NOT_APPLICABLE";
    AcceptableResponse["True"] = "TRUE";
    return AcceptableResponse;
}({}); /**
 * "
 * The lifecycle status of the account
 */ 
let $78ad46e0d6808149$export$3693f74db10d5f88 = /*#__PURE__*/ function(AccountStatus) {
    AccountStatus["Active"] = "active";
    AccountStatus["Closed"] = "closed";
    AccountStatus["Inactive"] = "inactive";
    return AccountStatus;
}({}); /** An action that an app implements */  /** A type of action that an app can implement */  /** An app and the actions it supports */ 
let $78ad46e0d6808149$export$db8ac507a39ab8b4 = /*#__PURE__*/ function(ActionsAuthType) {
    ActionsAuthType["ThreeLegged"] = "THREE_LEGGED";
    ActionsAuthType["TwoLegged"] = "TWO_LEGGED";
    return ActionsAuthType;
}({}); /** Description for the action or action input */  /** --------------------------------------- activity_api_v2.graphqls */  /** --------------------------------------- activity_api_v2.graphqls */  /** --------------------------------------- activity_api_v2.graphqls */  /** Extension of ActivitiesEvent, is a part of ActivitiesEventExtension union */ 
let $78ad46e0d6808149$export$d36a88022706d185 = /*#__PURE__*/ function(ActivitiesContainerType) {
    ActivitiesContainerType["Project"] = "PROJECT";
    ActivitiesContainerType["Site"] = "SITE";
    ActivitiesContainerType["Space"] = "SPACE";
    ActivitiesContainerType["Workspace"] = "WORKSPACE";
    return ActivitiesContainerType;
}({});
let $78ad46e0d6808149$export$c1fb1f213efc1d1a = /*#__PURE__*/ function(ActivitiesFilterType) {
    ActivitiesFilterType["And"] = "AND";
    ActivitiesFilterType["Or"] = "OR";
    return ActivitiesFilterType;
}({}); /** Extension of ActivitiesObject, is a part of ActivitiesObjectExtension union */ 
let $78ad46e0d6808149$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["Blogpost"] = "BLOGPOST";
    ActivitiesObjectType["Database"] = "DATABASE";
    ActivitiesObjectType["Embed"] = "EMBED";
    ActivitiesObjectType["Goal"] = "GOAL";
    ActivitiesObjectType["Issue"] = "ISSUE";
    ActivitiesObjectType["Page"] = "PAGE";
    ActivitiesObjectType["Project"] = "PROJECT";
    ActivitiesObjectType["Whiteboard"] = "WHITEBOARD";
    return ActivitiesObjectType;
}({}); /** Extension of ActivitiesEvent, is a part of ActivitiesEventExtension union */  /** --------------------------------------- activity_api_v3 */  /** --------------------------------------- activity_api_v3 */  /** --------------------------------------- activity_api_v3 */ 
let $78ad46e0d6808149$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["Assigned"] = "ASSIGNED";
    ActivityEventType["Commented"] = "COMMENTED";
    ActivityEventType["Created"] = "CREATED";
    ActivityEventType["Edited"] = "EDITED";
    ActivityEventType["Liked"] = "LIKED";
    ActivityEventType["Published"] = "PUBLISHED";
    ActivityEventType["Transitioned"] = "TRANSITIONED";
    ActivityEventType["Unassigned"] = "UNASSIGNED";
    ActivityEventType["Updated"] = "UPDATED";
    ActivityEventType["Viewed"] = "VIEWED";
    return ActivityEventType;
}({});
let $78ad46e0d6808149$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["Blogpost"] = "BLOGPOST";
    ActivityObjectType["Comment"] = "COMMENT";
    ActivityObjectType["Database"] = "DATABASE";
    ActivityObjectType["Embed"] = "EMBED";
    ActivityObjectType["Goal"] = "GOAL";
    ActivityObjectType["Issue"] = "ISSUE";
    ActivityObjectType["Page"] = "PAGE";
    ActivityObjectType["Project"] = "PROJECT";
    ActivityObjectType["Site"] = "SITE";
    ActivityObjectType["Space"] = "SPACE";
    ActivityObjectType["Task"] = "TASK";
    ActivityObjectType["Whiteboard"] = "WHITEBOARD";
    return ActivityObjectType;
}({});
let $78ad46e0d6808149$export$3ca4051c67b8ec7b = /*#__PURE__*/ function(ActivityProduct) {
    ActivityProduct["Confluence"] = "CONFLUENCE";
    ActivityProduct["Jira"] = "JIRA";
    ActivityProduct["JiraBusiness"] = "JIRA_BUSINESS";
    ActivityProduct["JiraOps"] = "JIRA_OPS";
    ActivityProduct["JiraServiceDesk"] = "JIRA_SERVICE_DESK";
    ActivityProduct["JiraSoftware"] = "JIRA_SOFTWARE";
    ActivityProduct["Townsquare"] = "TOWNSQUARE";
    return ActivityProduct;
}({}); /**
 * Represents arbitrary transition,
 * e.g. in case of TRANSITIONED event type it could be `from: "inprogress" to: "done"`.
 */ 
let $78ad46e0d6808149$export$276a961098f2db01 = /*#__PURE__*/ function(AlertEventStatus) {
    AlertEventStatus["Acknowledged"] = "ACKNOWLEDGED";
    AlertEventStatus["Closed"] = "CLOSED";
    AlertEventStatus["Opened"] = "OPENED";
    AlertEventStatus["Snoozed"] = "SNOOZED";
    return AlertEventStatus;
}({});
let $78ad46e0d6808149$export$232eaa1effb46fa2 = /*#__PURE__*/ function(AlertPriority) {
    AlertPriority["P1"] = "P1";
    AlertPriority["P2"] = "P2";
    AlertPriority["P3"] = "P3";
    AlertPriority["P4"] = "P4";
    AlertPriority["P5"] = "P5";
    return AlertPriority;
}({}); /** Only used for inside the schema to mark the context for generic types */ 
let $78ad46e0d6808149$export$f6d52655da4aa77d = /*#__PURE__*/ function(ApiContext) {
    ApiContext["Devops"] = "DEVOPS";
    return ApiContext;
}({}); /**
 * This enum is the names of API groupings within the total Atlassian API.
 *
 * This is used by our documentation tooling to group together types and fields into logical groups
 */ 
let $78ad46e0d6808149$export$8145658f3946b657 = /*#__PURE__*/ function(ApiGroup) {
    ApiGroup["Actions"] = "ACTIONS";
    ApiGroup["AppRecommendations"] = "APP_RECOMMENDATIONS";
    ApiGroup["Caas"] = "CAAS";
    ApiGroup["CloudAdmin"] = "CLOUD_ADMIN";
    ApiGroup["CollaborationGraph"] = "COLLABORATION_GRAPH";
    ApiGroup["CommerceCcp"] = "COMMERCE_CCP";
    ApiGroup["CommerceHams"] = "COMMERCE_HAMS";
    ApiGroup["CommerceSharedApi"] = "COMMERCE_SHARED_API";
    ApiGroup["Compass"] = "COMPASS";
    ApiGroup["Confluence"] = "CONFLUENCE";
    ApiGroup["ConfluenceAnalytics"] = "CONFLUENCE_ANALYTICS";
    ApiGroup["ConfluenceLegacy"] = "CONFLUENCE_LEGACY";
    ApiGroup["ConfluenceMutations"] = "CONFLUENCE_MUTATIONS";
    ApiGroup["ConfluencePages"] = "CONFLUENCE_PAGES";
    ApiGroup["ConfluencePageTree"] = "CONFLUENCE_PAGE_TREE";
    ApiGroup["ConfluenceSmarts"] = "CONFLUENCE_SMARTS";
    ApiGroup["ConfluenceTenant"] = "CONFLUENCE_TENANT";
    ApiGroup["ConfluenceUser"] = "CONFLUENCE_USER";
    ApiGroup["ConfluenceV2"] = "CONFLUENCE_V2";
    ApiGroup["ContentPlatformApi"] = "CONTENT_PLATFORM_API";
    ApiGroup["CustomerService"] = "CUSTOMER_SERVICE";
    ApiGroup["DevopsAriGraph"] = "DEVOPS_ARI_GRAPH";
    ApiGroup["DevopsContainerRelationship"] = "DEVOPS_CONTAINER_RELATIONSHIP";
    ApiGroup["DevopsService"] = "DEVOPS_SERVICE";
    ApiGroup["DevopsThirdParty"] = "DEVOPS_THIRD_PARTY";
    ApiGroup["DevopsToolchain"] = "DEVOPS_TOOLCHAIN";
    ApiGroup["FeatureReleaseQuery"] = "FEATURE_RELEASE_QUERY";
    ApiGroup["Forge"] = "FORGE";
    ApiGroup["Help"] = "HELP";
    ApiGroup["Identity"] = "IDENTITY";
    ApiGroup["InsightsXperienceService"] = "INSIGHTS_XPERIENCE_SERVICE";
    ApiGroup["Jira"] = "JIRA";
    ApiGroup["Papi"] = "PAPI";
    ApiGroup["Polaris"] = "POLARIS";
    ApiGroup["SurfacePlatform"] = "SURFACE_PLATFORM";
    ApiGroup["Teams"] = "TEAMS";
    ApiGroup["VirtualAgent"] = "VIRTUAL_AGENT";
    ApiGroup["WebTriggers"] = "WEB_TRIGGERS";
    ApiGroup["XenInvocationService"] = "XEN_INVOCATION_SERVICE";
    ApiGroup["XenLogsApi"] = "XEN_LOGS_API";
    return ApiGroup;
}({});
let $78ad46e0d6808149$export$50693beeb92df79c = /*#__PURE__*/ function(AppContributorRole) {
    AppContributorRole["Admin"] = "ADMIN";
    AppContributorRole["Deployer"] = "DEPLOYER";
    AppContributorRole["Developer"] = "DEVELOPER";
    AppContributorRole["Viewer"] = "VIEWER";
    AppContributorRole["ViewerAdvanced"] = "VIEWER_ADVANCED";
    return AppContributorRole;
}({});
let $78ad46e0d6808149$export$2f94efde4452c4e8 = /*#__PURE__*/ function(AppDeploymentEventLogLevel) {
    AppDeploymentEventLogLevel["Error"] = "ERROR";
    AppDeploymentEventLogLevel["Info"] = "INFO";
    AppDeploymentEventLogLevel["Warning"] = "WARNING";
    return AppDeploymentEventLogLevel;
}({});
let $78ad46e0d6808149$export$df989df2cca988a2 = /*#__PURE__*/ function(AppDeploymentStatus) {
    AppDeploymentStatus["Done"] = "DONE";
    AppDeploymentStatus["Failed"] = "FAILED";
    AppDeploymentStatus["InProgress"] = "IN_PROGRESS";
    return AppDeploymentStatus;
}({});
let $78ad46e0d6808149$export$aa4fe8ce66c067b1 = /*#__PURE__*/ function(AppDeploymentStepStatus) {
    AppDeploymentStepStatus["Done"] = "DONE";
    AppDeploymentStepStatus["Failed"] = "FAILED";
    AppDeploymentStepStatus["Started"] = "STARTED";
    return AppDeploymentStepStatus;
}({}); /** Used to uniquely identify an environment, when being used as an input. */ 
let $78ad46e0d6808149$export$bbec072c9916131d = /*#__PURE__*/ function(AppEnvironmentType) {
    AppEnvironmentType["Development"] = "DEVELOPMENT";
    AppEnvironmentType["Production"] = "PRODUCTION";
    AppEnvironmentType["Staging"] = "STAGING";
    return AppEnvironmentType;
}({}); /** The input needed to create or update an environment variable. */  /**
 * Represents a major version of an AppEnvironment.
 * A major version is one that requires consent from end users before upgrading installations, typically a change in
 * the permissions an App requires.
 * Other changes do not trigger a new major version to be created and are instead applied to the latest major version
 */ 
let $78ad46e0d6808149$export$cb9e000131989fd = /*#__PURE__*/ function(AppNetworkPermissionType) {
    AppNetworkPermissionType["FetchBackendSide"] = "FETCH_BACKEND_SIDE";
    AppNetworkPermissionType["FetchClientSide"] = "FETCH_CLIENT_SIDE";
    AppNetworkPermissionType["Fonts"] = "FONTS";
    AppNetworkPermissionType["Frames"] = "FRAMES";
    AppNetworkPermissionType["Images"] = "IMAGES";
    AppNetworkPermissionType["Media"] = "MEDIA";
    AppNetworkPermissionType["Navigation"] = "NAVIGATION";
    AppNetworkPermissionType["Scripts"] = "SCRIPTS";
    AppNetworkPermissionType["Styles"] = "STYLES";
    return AppNetworkPermissionType;
}({});
let $78ad46e0d6808149$export$46aa181a404c6a14 = /*#__PURE__*/ function(AppNetworkPermissionTypeExtension) {
    AppNetworkPermissionTypeExtension["FetchBackendSide"] = "FETCH_BACKEND_SIDE";
    AppNetworkPermissionTypeExtension["FetchClientSide"] = "FETCH_CLIENT_SIDE";
    AppNetworkPermissionTypeExtension["Fonts"] = "FONTS";
    AppNetworkPermissionTypeExtension["Frames"] = "FRAMES";
    AppNetworkPermissionTypeExtension["Images"] = "IMAGES";
    AppNetworkPermissionTypeExtension["Media"] = "MEDIA";
    AppNetworkPermissionTypeExtension["Navigation"] = "NAVIGATION";
    AppNetworkPermissionTypeExtension["Scripts"] = "SCRIPTS";
    AppNetworkPermissionTypeExtension["Styles"] = "STYLES";
    return AppNetworkPermissionTypeExtension;
}({}); /** Permissions that relate to the App's interaction with supported APIs and supported network egress */  /**
 * The context object provides essential insights into the users' current experience and operations.
 *
 * The supported product and subproduct keys can be found at https://hello.atlassian.net/wiki/spaces/ECON/pages/2339030895/App+Identifiers
 */ 
let $78ad46e0d6808149$export$1618aa24ce40e8c9 = /*#__PURE__*/ function(AppSecurityPoliciesPermissionType) {
    AppSecurityPoliciesPermissionType["Scripts"] = "SCRIPTS";
    AppSecurityPoliciesPermissionType["Styles"] = "STYLES";
    return AppSecurityPoliciesPermissionType;
}({});
let $78ad46e0d6808149$export$3397fdc734564301 = /*#__PURE__*/ function(AppSecurityPoliciesPermissionTypeExtension) {
    AppSecurityPoliciesPermissionTypeExtension["Scripts"] = "SCRIPTS";
    AppSecurityPoliciesPermissionTypeExtension["Styles"] = "STYLES";
    return AppSecurityPoliciesPermissionTypeExtension;
}({});
let $78ad46e0d6808149$export$abe79a166182d5dd = /*#__PURE__*/ function(AppStoredCustomEntityFilterCondition) {
    AppStoredCustomEntityFilterCondition["BeginsWith"] = "BEGINS_WITH";
    AppStoredCustomEntityFilterCondition["Between"] = "BETWEEN";
    AppStoredCustomEntityFilterCondition["Contains"] = "CONTAINS";
    AppStoredCustomEntityFilterCondition["EqualTo"] = "EQUAL_TO";
    AppStoredCustomEntityFilterCondition["Exists"] = "EXISTS";
    AppStoredCustomEntityFilterCondition["GreaterThan"] = "GREATER_THAN";
    AppStoredCustomEntityFilterCondition["GreaterThanEqualTo"] = "GREATER_THAN_EQUAL_TO";
    AppStoredCustomEntityFilterCondition["LessThan"] = "LESS_THAN";
    AppStoredCustomEntityFilterCondition["LessThanEqualTo"] = "LESS_THAN_EQUAL_TO";
    AppStoredCustomEntityFilterCondition["NotContains"] = "NOT_CONTAINS";
    AppStoredCustomEntityFilterCondition["NotEqualTo"] = "NOT_EQUAL_TO";
    AppStoredCustomEntityFilterCondition["NotExists"] = "NOT_EXISTS";
    return AppStoredCustomEntityFilterCondition;
}({});
let $78ad46e0d6808149$export$8c6210489e377c93 = /*#__PURE__*/ function(AppStoredCustomEntityRangeCondition) {
    AppStoredCustomEntityRangeCondition["BeginsWith"] = "BEGINS_WITH";
    AppStoredCustomEntityRangeCondition["Between"] = "BETWEEN";
    AppStoredCustomEntityRangeCondition["EqualTo"] = "EQUAL_TO";
    AppStoredCustomEntityRangeCondition["GreaterThan"] = "GREATER_THAN";
    AppStoredCustomEntityRangeCondition["GreaterThanEqualTo"] = "GREATER_THAN_EQUAL_TO";
    AppStoredCustomEntityRangeCondition["LessThan"] = "LESS_THAN";
    AppStoredCustomEntityRangeCondition["LessThanEqualTo"] = "LESS_THAN_EQUAL_TO";
    return AppStoredCustomEntityRangeCondition;
}({});
let $78ad46e0d6808149$export$6c1157c4fc1b51c4 = /*#__PURE__*/ function(AppStoredEntityCondition) {
    AppStoredEntityCondition["In"] = "IN";
    AppStoredEntityCondition["NotEqualTo"] = "NOT_EQUAL_TO";
    AppStoredEntityCondition["StartsWith"] = "STARTS_WITH";
    return AppStoredEntityCondition;
}({}); /**
 * The identifier for this entity
 *
 * where condition to filter
 */ 
let $78ad46e0d6808149$export$63fbd5015391964b = /*#__PURE__*/ function(AppTaskState) {
    AppTaskState["Complete"] = "COMPLETE";
    AppTaskState["Failed"] = "FAILED";
    AppTaskState["Pending"] = "PENDING";
    AppTaskState["Running"] = "RUNNING";
    return AppTaskState;
}({}); /** App trust information state */ 
let $78ad46e0d6808149$export$5b9c3b8406b5cf1a = /*#__PURE__*/ function(AppTrustInformationState) {
    AppTrustInformationState["Draft"] = "DRAFT";
    AppTrustInformationState["Live"] = "LIVE";
    return AppTrustInformationState;
}({}); /** Input payload for the app environment uninstall mutation */  /** The response from the uninstallation of an app environment */  /**
 * This does not represent a real person but rather the identity that backs an installed application
 *
 * See the documentation on the `User` for more details
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */ 
let $78ad46e0d6808149$export$c8ae3a8e8f57359f = /*#__PURE__*/ function(ArchivedMode) {
    ArchivedMode["ActiveOnly"] = "ACTIVE_ONLY";
    ArchivedMode["All"] = "ALL";
    ArchivedMode["ArchivedOnly"] = "ARCHIVED_ONLY";
    return ArchivedMode;
}({}); /**
 * At least 'from' or 'to' must be specified. If both are specified, then 'type' is required.
 *
 * If only one side of the relationship is provided, and no type is provided,
 * then every relationship (where that side of the relationship equals the provided ARI)
 * for every applicable relationship type will be deleted.
 */ 
let $78ad46e0d6808149$export$207a81844461bdb0 = /*#__PURE__*/ function(AriGraphRelationshipsSortDirection) {
    AriGraphRelationshipsSortDirection["Asc"] = "ASC";
    AriGraphRelationshipsSortDirection["Desc"] = "DESC";
    return AriGraphRelationshipsSortDirection;
}({}); /**
 * This represents a real person that has an account in a wide range of Atlassian products
 *
 * See the documentation on the `User` and `LocalizationContext` for more details
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */ 
let $78ad46e0d6808149$export$38d407d6909984c2 = /*#__PURE__*/ function(AtlassianProductHostingType) {
    AtlassianProductHostingType["Cloud"] = "CLOUD";
    AtlassianProductHostingType["DataCenter"] = "DATA_CENTER";
    AtlassianProductHostingType["Server"] = "SERVER";
    return AtlassianProductHostingType;
}({}); /** Accepts input to attach a data manager to a component. */  /** The payload returned from attaching a data manager to a component. */  /** This type contains information about the currently logged in user */  /** Entry point for auto-suggestion search */  /** Entry point for auto-suggestion search */  /** Payload to invoke an AUX Effect */  /** A response to an aux invocation */  /** The input for a Avatar for a Third Party Repository */  /** Bitbucket Permission Enum */ 
let $78ad46e0d6808149$export$a3fe6fe047d6ad5c = /*#__PURE__*/ function(BitbucketPermission) {
    BitbucketPermission["Admin"] = "ADMIN";
    return BitbucketPermission;
}({}); /** Relay connection definition for a list of board features */  /** Relay edge definition for a board feature */  /** Relay connection definition for a list of board feature groups */  /** Relay edge definition for a board feature group */ 
let $78ad46e0d6808149$export$dd75b3db211b43be = /*#__PURE__*/ function(BoardFeatureStatus) {
    BoardFeatureStatus["ComingSoon"] = "COMING_SOON";
    BoardFeatureStatus["Disabled"] = "DISABLED";
    BoardFeatureStatus["Enabled"] = "ENABLED";
    return BoardFeatureStatus;
}({});
let $78ad46e0d6808149$export$c0a71a6782116cff = /*#__PURE__*/ function(BoardFeatureToggleStatus) {
    BoardFeatureToggleStatus["Disabled"] = "DISABLED";
    BoardFeatureToggleStatus["Enabled"] = "ENABLED";
    return BoardFeatureToggleStatus;
}({}); /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Available strategies for grouping issues into swimlanes for a classic board */ 
let $78ad46e0d6808149$export$19baf80f4562d4e3 = /*#__PURE__*/ function(BoardSwimlaneStrategy) {
    BoardSwimlaneStrategy["AssigneeUnassignedFirst"] = "ASSIGNEE_UNASSIGNED_FIRST";
    BoardSwimlaneStrategy["AssigneeUnassignedLast"] = "ASSIGNEE_UNASSIGNED_LAST";
    BoardSwimlaneStrategy["Custom"] = "CUSTOM";
    BoardSwimlaneStrategy["Epic"] = "EPIC";
    BoardSwimlaneStrategy["IssueChildren"] = "ISSUE_CHILDREN";
    BoardSwimlaneStrategy["IssueParent"] = "ISSUE_PARENT";
    BoardSwimlaneStrategy["None"] = "NONE";
    BoardSwimlaneStrategy["ParentChild"] = "PARENT_CHILD";
    BoardSwimlaneStrategy["Project"] = "PROJECT";
    BoardSwimlaneStrategy["RequestType"] = "REQUEST_TYPE";
    return BoardSwimlaneStrategy;
}({});
let $78ad46e0d6808149$export$52d25977f4eeeb6 = /*#__PURE__*/ function(BuiltinPolarisIdeaField) {
    BuiltinPolarisIdeaField["Archived"] = "ARCHIVED";
    BuiltinPolarisIdeaField["ArchivedBy"] = "ARCHIVED_BY";
    BuiltinPolarisIdeaField["ArchivedOn"] = "ARCHIVED_ON";
    BuiltinPolarisIdeaField["Assignee"] = "ASSIGNEE";
    BuiltinPolarisIdeaField["AtlasGoal"] = "ATLAS_GOAL";
    BuiltinPolarisIdeaField["AtlasProject"] = "ATLAS_PROJECT";
    BuiltinPolarisIdeaField["AtlasProjectStatus"] = "ATLAS_PROJECT_STATUS";
    BuiltinPolarisIdeaField["AtlasProjectTarget"] = "ATLAS_PROJECT_TARGET";
    BuiltinPolarisIdeaField["Created"] = "CREATED";
    BuiltinPolarisIdeaField["Creator"] = "CREATOR";
    BuiltinPolarisIdeaField["DeliveryProgress"] = "DELIVERY_PROGRESS";
    BuiltinPolarisIdeaField["DeliveryStatus"] = "DELIVERY_STATUS";
    BuiltinPolarisIdeaField["Description"] = "DESCRIPTION";
    BuiltinPolarisIdeaField["IssueComments"] = "ISSUE_COMMENTS";
    BuiltinPolarisIdeaField["IssueId"] = "ISSUE_ID";
    BuiltinPolarisIdeaField["IssueType"] = "ISSUE_TYPE";
    BuiltinPolarisIdeaField["Key"] = "KEY";
    BuiltinPolarisIdeaField["Labels"] = "LABELS";
    BuiltinPolarisIdeaField["LinkedIssues"] = "LINKED_ISSUES";
    BuiltinPolarisIdeaField["NumDataPoints"] = "NUM_DATA_POINTS";
    BuiltinPolarisIdeaField["Reporter"] = "REPORTER";
    BuiltinPolarisIdeaField["Status"] = "STATUS";
    BuiltinPolarisIdeaField["Summary"] = "SUMMARY";
    BuiltinPolarisIdeaField["Updated"] = "UPDATED";
    BuiltinPolarisIdeaField["Votes"] = "VOTES";
    return BuiltinPolarisIdeaField;
}({}); /** Accepts input for deleting multiple existing components. */  /** The payload returned from deleting existing components. */  /**
 * ###################################################################################################################
 *  COMPASS MUTATION RESPONSES
 * ###################################################################################################################
 */ 
let $78ad46e0d6808149$export$184db778f5e78171 = /*#__PURE__*/ function(CapabilitySet) {
    CapabilitySet["CapabilityAdvanced"] = "capabilityAdvanced";
    CapabilitySet["CapabilityStandard"] = "capabilityStandard";
    return CapabilitySet;
}({});
let $78ad46e0d6808149$export$805b6160e3efc186 = /*#__PURE__*/ function(CardHierarchyLevelEnumType) {
    CardHierarchyLevelEnumType["Base"] = "BASE";
    CardHierarchyLevelEnumType["Child"] = "CHILD";
    CardHierarchyLevelEnumType["Parent"] = "PARENT";
    return CardHierarchyLevelEnumType;
}({});
let $78ad46e0d6808149$export$ee2a5f4674ed5b8d = /*#__PURE__*/ function(CcpActivationReason) {
    CcpActivationReason["AdvantagePricing"] = "ADVANTAGE_PRICING";
    CcpActivationReason["DefaultPricing"] = "DEFAULT_PRICING";
    CcpActivationReason["ExperimentalPricing"] = "EXPERIMENTAL_PRICING";
    return CcpActivationReason;
}({}); /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $78ad46e0d6808149$export$dd06bd5976bfc6e3 = /*#__PURE__*/ function(CcpBillingInterval) {
    CcpBillingInterval["Day"] = "DAY";
    CcpBillingInterval["Month"] = "MONTH";
    CcpBillingInterval["Week"] = "WEEK";
    CcpBillingInterval["Year"] = "YEAR";
    return CcpBillingInterval;
}({}); /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $78ad46e0d6808149$export$f1663167a1dfb133 = /*#__PURE__*/ function(CcpChargeType) {
    CcpChargeType["AutoScaling"] = "AUTO_SCALING";
    CcpChargeType["Licensed"] = "LICENSED";
    CcpChargeType["Metered"] = "METERED";
    return CcpChargeType;
}({}); /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $78ad46e0d6808149$export$c0b393797b8a5dd1 = /*#__PURE__*/ function(CcpCurrency) {
    CcpCurrency["Jpy"] = "JPY";
    CcpCurrency["Usd"] = "USD";
    return CcpCurrency;
}({});
let $78ad46e0d6808149$export$5f9edcd77bf8a9b9 = /*#__PURE__*/ function(CcpDuration) {
    CcpDuration["Forever"] = "FOREVER";
    CcpDuration["Once"] = "ONCE";
    CcpDuration["Repeating"] = "REPEATING";
    return CcpDuration;
}({}); /**
 * An effective uncollectible action represents the action that an offering will
 * undergo in the event of non-payment
 */ 
let $78ad46e0d6808149$export$57f8dd5442590d31 = /*#__PURE__*/ function(CcpEntitlementPreDunningStatus) {
    CcpEntitlementPreDunningStatus["InPreDunning"] = "IN_PRE_DUNNING";
    CcpEntitlementPreDunningStatus["NotInPreDunning"] = "NOT_IN_PRE_DUNNING";
    return CcpEntitlementPreDunningStatus;
}({});
let $78ad46e0d6808149$export$21652ca36153879b = /*#__PURE__*/ function(CcpEntitlementStatus) {
    CcpEntitlementStatus["Active"] = "ACTIVE";
    CcpEntitlementStatus["Inactive"] = "INACTIVE";
    return CcpEntitlementStatus;
}({}); /** A type of product usage as it relates to an entitlement */  /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $78ad46e0d6808149$export$e9dd9659ef9f0fb5 = /*#__PURE__*/ function(CcpOfferingHostingType) {
    CcpOfferingHostingType["Cloud"] = "CLOUD";
    return CcpOfferingHostingType;
}({});
let $78ad46e0d6808149$export$a6e9989b075a8458 = /*#__PURE__*/ function(CcpOfferingStatus) {
    CcpOfferingStatus["Active"] = "ACTIVE";
    CcpOfferingStatus["AtNotice"] = "AT_NOTICE";
    CcpOfferingStatus["Draft"] = "DRAFT";
    CcpOfferingStatus["Expired"] = "EXPIRED";
    return CcpOfferingStatus;
}({});
let $78ad46e0d6808149$export$2ec95e801b135b6a = /*#__PURE__*/ function(CcpOfferingType) {
    CcpOfferingType["Child"] = "CHILD";
    CcpOfferingType["Parent"] = "PARENT";
    return CcpOfferingType;
}({});
let $78ad46e0d6808149$export$60c062217a56cebb = /*#__PURE__*/ function(CcpOfferingUncollectibleActionType) {
    CcpOfferingUncollectibleActionType["Cancel"] = "CANCEL";
    CcpOfferingUncollectibleActionType["Downgrade"] = "DOWNGRADE";
    CcpOfferingUncollectibleActionType["NoAction"] = "NO_ACTION";
    return CcpOfferingUncollectibleActionType;
}({}); /** An order from a transaction account. */  /** A pricing plan represents the way to charge for a subscription. */ 
let $78ad46e0d6808149$export$b1c315941e36715 = /*#__PURE__*/ function(CcpPricingPlanStatus) {
    CcpPricingPlanStatus["Active"] = "ACTIVE";
    CcpPricingPlanStatus["AtNotice"] = "AT_NOTICE";
    CcpPricingPlanStatus["Draft"] = "DRAFT";
    CcpPricingPlanStatus["Expired"] = "EXPIRED";
    return CcpPricingPlanStatus;
}({});
let $78ad46e0d6808149$export$c9b826d15992706b = /*#__PURE__*/ function(CcpPricingType) {
    CcpPricingType["External"] = "EXTERNAL";
    CcpPricingType["Free"] = "FREE";
    CcpPricingType["LimitedFree"] = "LIMITED_FREE";
    CcpPricingType["Paid"] = "PAID";
    return CcpPricingType;
}({});
let $78ad46e0d6808149$export$2b3bbef813bc7ddb = /*#__PURE__*/ function(CcpProrateOnUsageChange) {
    CcpProrateOnUsageChange["AlwaysInvoice"] = "ALWAYS_INVOICE";
    CcpProrateOnUsageChange["CreateProrations"] = "CREATE_PRORATIONS";
    CcpProrateOnUsageChange["None"] = "NONE";
    return CcpProrateOnUsageChange;
}({}); /**
 * Commerce Cloud Platform is Atlassian's commerce platform and replaces the legacy platform HAMS.
 * Some of the types in this schema implement interfaces defined in commerce_schema to provide CCP entitlements data for common commerce API.
 */ 
let $78ad46e0d6808149$export$bec7023af534df98 = /*#__PURE__*/ function(CcpRelationshipPricingType) {
    CcpRelationshipPricingType["AdvantagePricing"] = "ADVANTAGE_PRICING";
    CcpRelationshipPricingType["CurrencyGenerated"] = "CURRENCY_GENERATED";
    CcpRelationshipPricingType["NextPricing"] = "NEXT_PRICING";
    CcpRelationshipPricingType["SyntheticGenerated"] = "SYNTHETIC_GENERATED";
    return CcpRelationshipPricingType;
}({});
let $78ad46e0d6808149$export$1597d868ca01d69 = /*#__PURE__*/ function(CcpSubscriptionScheduleAction) {
    CcpSubscriptionScheduleAction["Cancel"] = "CANCEL";
    CcpSubscriptionScheduleAction["Update"] = "UPDATE";
    return CcpSubscriptionScheduleAction;
}({});
let $78ad46e0d6808149$export$dcee3eda38daaeab = /*#__PURE__*/ function(CcpSubscriptionStatus) {
    CcpSubscriptionStatus["Active"] = "ACTIVE";
    CcpSubscriptionStatus["Cancelled"] = "CANCELLED";
    CcpSubscriptionStatus["Processing"] = "PROCESSING";
    return CcpSubscriptionStatus;
}({});
let $78ad46e0d6808149$export$30c9d4dfd26087be = /*#__PURE__*/ function(CcpSupportedBillingSystems) {
    CcpSupportedBillingSystems["Ccp"] = "CCP";
    CcpSupportedBillingSystems["Hams"] = "HAMS";
    CcpSupportedBillingSystems["Opsgenie"] = "OPSGENIE";
    return CcpSupportedBillingSystems;
}({});
let $78ad46e0d6808149$export$55c02debb712e2db = /*#__PURE__*/ function(CcpTiersMode) {
    CcpTiersMode["Graduated"] = "GRADUATED";
    CcpTiersMode["Volume"] = "VOLUME";
    return CcpTiersMode;
}({}); /**
 * A CCP transaction account represents a customer,
 * i.e. the legal entity with which Atlassian is doing business.
 * It may be an individual, a business, etc.
 */ 
let $78ad46e0d6808149$export$cec1fe9fa75edecd = /*#__PURE__*/ function(Classification) {
    Classification["Other"] = "other";
    Classification["Pii"] = "pii";
    Classification["Ugc"] = "ugc";
    return Classification;
}({}); /** Level of access to an Atlassian product that a cloud app can request */  /**
 * A Version Control System object
 * Eg. Bitbucket, GitHub, GitLab
 */ 
let $78ad46e0d6808149$export$998d732c1030d8c = /*#__PURE__*/ function(CompassBuildEventState) {
    CompassBuildEventState["Cancelled"] = "CANCELLED";
    CompassBuildEventState["Error"] = "ERROR";
    CompassBuildEventState["Failed"] = "FAILED";
    CompassBuildEventState["InProgress"] = "IN_PROGRESS";
    CompassBuildEventState["Successful"] = "SUCCESSFUL";
    CompassBuildEventState["TimedOut"] = "TIMED_OUT";
    CompassBuildEventState["Unknown"] = "UNKNOWN";
    return CompassBuildEventState;
}({}); /**
 * ###################################################################################################################
 *  COMPASS Campaign configuration
 * ###################################################################################################################
 */ 
let $78ad46e0d6808149$export$b18beaf85a2196b5 = /*#__PURE__*/ function(CompassCampaignQuerySortOrder) {
    CompassCampaignQuerySortOrder["Asc"] = "ASC";
    CompassCampaignQuerySortOrder["Desc"] = "DESC";
    return CompassCampaignQuerySortOrder;
}({}); /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Metadata about who created or updated the object and when. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** An external integration that manages data for a particular component. */  /** A label provides additional contextual information about a component. */  /** A connection that returns a paginated collection of metric sources. */  /** The query to get the metric sources of a component. */  /** A component scorecard relationship. */  /** A component scorecard relationship. */  /** A component scorecard relationship. */  /** A component scorecard relationship. */  /** Scorecard score on a component for a scorecard. */  /** A tier provides additional contextual information about a component. */  /** Identifies the type of component. */ 
let $78ad46e0d6808149$export$dbf96ee31a2e1415 = /*#__PURE__*/ function(CompassComponentType) {
    CompassComponentType["Application"] = "APPLICATION";
    CompassComponentType["Library"] = "LIBRARY";
    CompassComponentType["Other"] = "OTHER";
    CompassComponentType["Service"] = "SERVICE";
    return CompassComponentType;
}({}); /** Represents a type of software component that is distinguishable from other types.  Service vs Library, for example */  /** Input for querying Compass component types */  /** An alert event. */  /** Accepts input for creating a component announcement. */  /** The payload returned after creating a component announcement. */  /** The payload returned from sending a question to have an answer created. */  /** A build event. */  /** Accepts input for creating a component scorecard Jira issue. */  /** The payload returned from creating a component scorecard Jira issue. */  /** Input for creating a component subscription. */  /** The payload returned from creating a component subscription. */  /** Accepts input for creating a custom boolean field definition. */  /** A custom event. */  /** Accepts input for creating a custom field definition. You must provide exactly one of the fields in this input type. */  /** The payload returned from creating a custom field definition. */  /** Accepts input for creating a custom multi select field definition. */  /** Accepts input for creating a custom number field definition. */  /** Accepts input for creating a custom single select field definition. */  /** Accepts input for creating a custom text field definition. */  /** Accepts input for creating a custom user field definition. */  /** A deployment event. */  /** The list of properties of the deployment event. */  /** A flag event. */  /** The list of properties of the flag event. */  /** Accepts input to create a scorecard criterion checking the value of a specified custom boolean field. */  /** Accepts input to create a scorecard criterion checking the value of a specified custom number field. */  /** Accepts input to create a scorecard criterion checking the value of a specified custom text field. */  /** An incident event. */  /** The list of properties of the incident event. */  /** The user-provided input to create an incoming webhook */  /** The payload returned from sending an incoming webhook to be created */  /** A lifecycle event. */  /** The input for creating a metric definition. */  /** The payload returned from creating a metric definition. */  /** The input to create a metric source. */  /** The payload returned from creating a metric source. */  /** A pull request event. */ 
let $78ad46e0d6808149$export$ad2a5e42be992de9 = /*#__PURE__*/ function(CompassCreatePullRequestStatus) {
    CompassCreatePullRequestStatus["Created"] = "CREATED";
    CompassCreatePullRequestStatus["InReview"] = "IN_REVIEW";
    CompassCreatePullRequestStatus["Merged"] = "MERGED";
    CompassCreatePullRequestStatus["Rejected"] = "REJECTED";
    return CompassCreatePullRequestStatus;
}({}); /** A push event. */  /** Accepts input for creating team checkin's action item. */  /** Accepts input for creating a checkin. */  /** The payload returned after creating a component announcement. */  /** Accepts input for creating team checkin responses with rich text. */ 
let $78ad46e0d6808149$export$ec0d5c1fa3218a83 = /*#__PURE__*/ function(CompassCriteriaBooleanComparatorOptions) {
    CompassCriteriaBooleanComparatorOptions["Equals"] = "EQUALS";
    return CompassCriteriaBooleanComparatorOptions;
}({});
let $78ad46e0d6808149$export$e387eb9a14a2773b = /*#__PURE__*/ function(CompassCriteriaCollectionComparatorOptions) {
    CompassCriteriaCollectionComparatorOptions["AllOf"] = "ALL_OF";
    CompassCriteriaCollectionComparatorOptions["AnyOf"] = "ANY_OF";
    CompassCriteriaCollectionComparatorOptions["NoneOf"] = "NONE_OF";
    return CompassCriteriaCollectionComparatorOptions;
}({});
let $78ad46e0d6808149$export$9597031f08feb1bc = /*#__PURE__*/ function(CompassCriteriaMembershipComparatorOptions) {
    CompassCriteriaMembershipComparatorOptions["In"] = "IN";
    CompassCriteriaMembershipComparatorOptions["NotIn"] = "NOT_IN";
    return CompassCriteriaMembershipComparatorOptions;
}({});
let $78ad46e0d6808149$export$8a8b436a51cf3b62 = /*#__PURE__*/ function(CompassCriteriaNumberComparatorOptions) {
    CompassCriteriaNumberComparatorOptions["Equals"] = "EQUALS";
    CompassCriteriaNumberComparatorOptions["GreaterThan"] = "GREATER_THAN";
    CompassCriteriaNumberComparatorOptions["GreaterThanOrEqualTo"] = "GREATER_THAN_OR_EQUAL_TO";
    CompassCriteriaNumberComparatorOptions["LessThan"] = "LESS_THAN";
    CompassCriteriaNumberComparatorOptions["LessThanOrEqualTo"] = "LESS_THAN_OR_EQUAL_TO";
    return CompassCriteriaNumberComparatorOptions;
}({});
let $78ad46e0d6808149$export$b7f3ac0d38937afa = /*#__PURE__*/ function(CompassCriteriaTextComparatorOptions) {
    CompassCriteriaTextComparatorOptions["IsPresent"] = "IS_PRESENT";
    CompassCriteriaTextComparatorOptions["MatchesRegex"] = "MATCHES_REGEX";
    return CompassCriteriaTextComparatorOptions;
}({}); /** A custom field containing a boolean value. */  /** The definition of a custom field containing a boolean value. */  /** Accepts input for setting a boolean value on a custom field. */ 
let $78ad46e0d6808149$export$ce4ce86422cc81d0 = /*#__PURE__*/ function(CompassCustomEventIcon) {
    CompassCustomEventIcon["Checkpoint"] = "CHECKPOINT";
    CompassCustomEventIcon["Info"] = "INFO";
    CompassCustomEventIcon["Warning"] = "WARNING";
    return CompassCustomEventIcon;
}({}); /** Properties specific to Custom events */  /** The list of properties of the custom event. */  /** A custom field contains data about the component. */  /** Annotation for a custom field value */  /** Annotatation input for a custom field value */  /** Defines a custom field that may be applied to multiple component types. A custom field must be applied to at least one component type. */  /** An edge that contains a custom field definition and a cursor. */  /** The query for retrieving a custom field definition by id on a Compass site. */  /** A connection that returns a paginated collection of custom field definitions. */  /** The query for retrieving custom field definitions on a Compass site. */  /** Accepts input for setting a custom field value. You must provide exactly one of the fields in this input type. */  /** A custom multi-select field. */  /** The definition of a custom multi-select field. */  /** Accepts input for setting options for a multi-select field. */  /** A custom field containing a number. */  /** The definition of a custom field containing a number. */  /** Accepts input for setting a number on a custom field. */  /** Preset options to update custom permission configs, either open to all teams/roles or restricted to product admins and owners. */ 
let $78ad46e0d6808149$export$43cacf9c2c9c2a10 = /*#__PURE__*/ function(CompassCustomPermissionPreset) {
    CompassCustomPermissionPreset["AdminsAndOwners"] = "ADMINS_AND_OWNERS";
    CompassCustomPermissionPreset["Default"] = "DEFAULT";
    return CompassCustomPermissionPreset;
}({}); /** The option of a single-select or multi-select custom field. */  /** A custom single-select field. */  /** The definition of a custom single-select field. */  /** Accepts input for setting an option for single-select field. */  /** A custom field containing a text string. */  /** The definition of a custom field containing a text string. */  /** Accepts input for setting a text string on a custom field. */  /** A custom field containing a user. */  /** The definition of a custom field containing a user. */  /** Accepts input for setting a user on a custom field. */  /** The payload returned from deactivating a scorecard for a component. */  /** Accepts input for deleting a component announcement. */  /** The payload returned after deleting a component announcement. */  /** Accepts input for delete a subscription. */  /** Payload returned from stop watching a component. */  /** Accepts input for deleting a custom field definition, along with all values associated with the definition. */  /** The payload returned from deleting a custom field definition. */  /** The user-provided input to delete an incoming webhook */  /** The payload returned from deleting an incoming webhook */  /** The input to delete a metric definition. */  /** The payload returned from updating a metric definition. */  /** The input to delete a metric source. */  /** The payload returned from deleting a metric source. */  /** Accepts input for deleting a team checkin. */  /** Accepts input for deleting a team checkin. */  /** The payload returned after deleting a team checkin. */ 
let $78ad46e0d6808149$export$15c39df7a190a18a = /*#__PURE__*/ function(CompassDeploymentEventEnvironmentCategory) {
    CompassDeploymentEventEnvironmentCategory["Development"] = "DEVELOPMENT";
    CompassDeploymentEventEnvironmentCategory["Production"] = "PRODUCTION";
    CompassDeploymentEventEnvironmentCategory["Staging"] = "STAGING";
    CompassDeploymentEventEnvironmentCategory["Testing"] = "TESTING";
    CompassDeploymentEventEnvironmentCategory["Unmapped"] = "UNMAPPED";
    return CompassDeploymentEventEnvironmentCategory;
}({}); /** The environment where the deployment event has occurred. */  /** Filters for deployment events. */  /** The deployment event pipeline. */  /** Compass Deployment Event */ 
let $78ad46e0d6808149$export$43d1deedebbbaa4e = /*#__PURE__*/ function(CompassDeploymentEventState) {
    CompassDeploymentEventState["Cancelled"] = "CANCELLED";
    CompassDeploymentEventState["Failed"] = "FAILED";
    CompassDeploymentEventState["InProgress"] = "IN_PROGRESS";
    CompassDeploymentEventState["Pending"] = "PENDING";
    CompassDeploymentEventState["RolledBack"] = "ROLLED_BACK";
    CompassDeploymentEventState["Successful"] = "SUCCESSFUL";
    CompassDeploymentEventState["Unknown"] = "UNKNOWN";
    return CompassDeploymentEventState;
}({}); /** Stores the categories that various pieces of documentation will be grouped under */  /** Filters for events sent to Compass. */  /** The type of event. One and only one of the fields in this input type must be provided. */ 
let $78ad46e0d6808149$export$155351532e5d1b9f = /*#__PURE__*/ function(CompassEventType) {
    CompassEventType["Alert"] = "ALERT";
    CompassEventType["Build"] = "BUILD";
    CompassEventType["Custom"] = "CUSTOM";
    CompassEventType["Deployment"] = "DEPLOYMENT";
    CompassEventType["Flag"] = "FLAG";
    CompassEventType["Incident"] = "INCIDENT";
    CompassEventType["Lifecycle"] = "LIFECYCLE";
    CompassEventType["PullRequest"] = "PULL_REQUEST";
    CompassEventType["Push"] = "PUSH";
    return CompassEventType;
}({}); /** An alias of the component in an external system. */  /** A field represents data about a component. */  /** The schema of a field. */  /** Specifies the type of value for a field. */ 
let $78ad46e0d6808149$export$5ba534b6379276b = /*#__PURE__*/ function(CompassFieldType) {
    CompassFieldType["Date"] = "DATE";
    CompassFieldType["Enum"] = "ENUM";
    CompassFieldType["Number"] = "NUMBER";
    CompassFieldType["Text"] = "TEXT";
    return CompassFieldType;
}({}); /** Accepts input to find filtered components count */  /** Properties specific to Flag events */  /** A user-defined parameter containing a string value. */  /** The configuration for a scorecard criterion checking the value of a specified custom boolean field. */  /** The configuration for a scorecard criterion checking the value of a specified custom boolean field. */  /** The configuration for a scorecard criterion checking the value of a specified custom number field. */  /** The configuration for a scorecard criterion checking the value of a specified custom number field. */  /** The configuration for a scorecard criterion checking the value of a specified custom text field. */  /** The configuration for a scorecard criterion checking the value of a specified custom text field. */  /** The configuration for a scorecard criterion representing the presence of a description. */  /** The configuration for a scorecard criterion representing the presence of a description. */  /** The configuration for a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */  /** The configuration for a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */  /** The configuration for a scorecard criterion representing the presence of a link, for example, 'Has Repository', or 'Has Documentation'. */  /** The configuration for a scorecard criterion representing the presence of a link, for example, 'Has Repository', or 'Has Documentation'. */  /** The configuration for a scorecard criterion checking the value of a specified metric name. */  /** The configuration for a scorecard criterion checking the value of a specified metric name. */  /** Configuration for a scorecard criteria representing the presence of an owner */  /** Configuration for a scorecard criteria representing the presence of an owner */  /** Properties specific to Incident events */  /** The severity of an incident */  /** The severity of an incident */ 
let $78ad46e0d6808149$export$9a02db1f2decc63 = /*#__PURE__*/ function(CompassIncidentEventSeverityLevel) {
    CompassIncidentEventSeverityLevel["Five"] = "FIVE";
    CompassIncidentEventSeverityLevel["Four"] = "FOUR";
    CompassIncidentEventSeverityLevel["One"] = "ONE";
    CompassIncidentEventSeverityLevel["Three"] = "THREE";
    CompassIncidentEventSeverityLevel["Two"] = "TWO";
    return CompassIncidentEventSeverityLevel;
}({});
let $78ad46e0d6808149$export$f8b82012c65b70c9 = /*#__PURE__*/ function(CompassIncidentEventState) {
    CompassIncidentEventState["Deleted"] = "DELETED";
    CompassIncidentEventState["Open"] = "OPEN";
    CompassIncidentEventState["Resolved"] = "RESOLVED";
    return CompassIncidentEventState;
}({}); /** Represents a user-defined incoming webhook for creating events in Compass */  /**
 * ###################################################################################################################
 *  COMPASS INCOMING WEBHOOKS
 * ###################################################################################################################
 */ 
let $78ad46e0d6808149$export$4366f17562f80ce7 = /*#__PURE__*/ function(CompassLifecycleEventStage) {
    CompassLifecycleEventStage["Deprecation"] = "DEPRECATION";
    CompassLifecycleEventStage["EndOfLife"] = "END_OF_LIFE";
    CompassLifecycleEventStage["PreRelease"] = "PRE_RELEASE";
    CompassLifecycleEventStage["Production"] = "PRODUCTION";
    return CompassLifecycleEventStage;
}({}); /** A link to an entity or resource on the internet. */  /** The types used to identify the intent of the link. */ 
let $78ad46e0d6808149$export$56307b64f049eb43 = /*#__PURE__*/ function(CompassLinkType) {
    CompassLinkType["ChatChannel"] = "CHAT_CHANNEL";
    CompassLinkType["Dashboard"] = "DASHBOARD";
    CompassLinkType["Document"] = "DOCUMENT";
    CompassLinkType["OnCall"] = "ON_CALL";
    CompassLinkType["OtherLink"] = "OTHER_LINK";
    CompassLinkType["Project"] = "PROJECT";
    CompassLinkType["Repository"] = "REPOSITORY";
    return CompassLinkType;
}({}); /** A metric definition defines a metric across multiple components. */  /** A metric definition defines a metric across multiple components. */  /** An edge that contains a metric definition and a cursor. */  /** The format option to append a plain-text suffix to metric values. */  /** The format option to append a plain-text suffix to metric values. */  /** Used to identify the type for the metric */ 
let $78ad46e0d6808149$export$270abbff10f02537 = /*#__PURE__*/ function(CompassMetricDefinitionType) {
    CompassMetricDefinitionType["BuiltIn"] = "BUILT_IN";
    CompassMetricDefinitionType["Custom"] = "CUSTOM";
    return CompassMetricDefinitionType;
}({}); /** A connection that returns a paginated collection of metric definitions. */  /** The query to get the metric definitions on a Compass site. */  /** A metric source contains values that provide numerical data about the component. */  /** A metric source contains values that provide numerical data about the component. */  /** An edge that contains a metric source and a cursor. */  /** A base for different scopes of metrics. Future metric sources can implement this and add their scope specific fields */  /** A connection that returns a paginated collection of metric values. */  /** The query to get the metric values from a component's metric source. */  /** A metric value stores the numerical data relating to the component. */  /** An edge that contains a metric value and a cursor. */  /** A metric value to be inserted. */  /** A list of bucketed, ordered, metric values */  /** The details of a Compass pull request. */  /** A pull request event. */  /** The list of properties of the pull request event. */  /** The list of properties of the pull event. */ 
let $78ad46e0d6808149$export$7a6755e08e21a7bd = /*#__PURE__*/ function(CompassPullRequestQuerySortName) {
    CompassPullRequestQuerySortName["CycleTime"] = "CYCLE_TIME";
    CompassPullRequestQuerySortName["OpenToFirstReview"] = "OPEN_TO_FIRST_REVIEW";
    CompassPullRequestQuerySortName["PrClosedTime"] = "PR_CLOSED_TIME";
    CompassPullRequestQuerySortName["PrCreatedTime"] = "PR_CREATED_TIME";
    CompassPullRequestQuerySortName["ReviewTime"] = "REVIEW_TIME";
    return CompassPullRequestQuerySortName;
}({});
let $78ad46e0d6808149$export$d5ddc46f2d03ff56 = /*#__PURE__*/ function(CompassPullRequestStatus) {
    CompassPullRequestStatus["Created"] = "CREATED";
    CompassPullRequestStatus["FirstReviewed"] = "FIRST_REVIEWED";
    CompassPullRequestStatus["Merged"] = "MERGED";
    CompassPullRequestStatus["Overdue"] = "OVERDUE";
    CompassPullRequestStatus["Rejected"] = "REJECTED";
    return CompassPullRequestStatus;
}({}); /** The pull request status used in the StatusInTimeRangeFilter query. */ 
let $78ad46e0d6808149$export$6a1e195288b23c05 = /*#__PURE__*/ function(CompassPullRequestStatusForStatusInTimeRangeFilter) {
    CompassPullRequestStatusForStatusInTimeRangeFilter["Created"] = "CREATED";
    CompassPullRequestStatusForStatusInTimeRangeFilter["FirstReviewed"] = "FIRST_REVIEWED";
    CompassPullRequestStatusForStatusInTimeRangeFilter["Merged"] = "MERGED";
    CompassPullRequestStatusForStatusInTimeRangeFilter["Rejected"] = "REJECTED";
    return CompassPullRequestStatusForStatusInTimeRangeFilter;
}({}); /** Accepts input to find pull requests. */  /** Accepts input for querying pull requests. */  /** A push event. */  /** The author who made the push */  /** The list of properties of the push event. */  /** The list of properties of the push event. */  /** A filter to apply to the search results. */ 
let $78ad46e0d6808149$export$94d43384cf172d05 = /*#__PURE__*/ function(CompassQuerySortOrder) {
    CompassQuerySortOrder["Asc"] = "ASC";
    CompassQuerySortOrder["Desc"] = "DESC";
    return CompassQuerySortOrder;
}({}); /** The payload returned from reactivating a scorecard for a component. */  /** A relationship between two components. The startNode and endNode depends on the direction of the relationship. */  /** Defines the possible relationship directions between components. */ 
let $78ad46e0d6808149$export$c8e6de4296189e26 = /*#__PURE__*/ function(CompassRelationshipDirection) {
    CompassRelationshipDirection["Inward"] = "INWARD";
    CompassRelationshipDirection["Outward"] = "OUTWARD";
    return CompassRelationshipDirection;
}({}); /** Accepts input for finding component relationships. */  /** Defines the relationship types. A relationship must be one of these types. */ 
let $78ad46e0d6808149$export$2a274d082ac90bb0 = /*#__PURE__*/ function(CompassRelationshipType) {
    CompassRelationshipType["DependsOn"] = "DEPENDS_ON";
    return CompassRelationshipType;
}({}); /** Accepts input for removing labels from a team. */  /** The payload returned after removing labels from a team. */  /** An object containing rich text versions of a string. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** Contains the application rules for how a scorecard will apply to components. */  /** Accepts input to find components a scorecard is applied to and their scores */  /** Accepts input to sort the applied components by. */  /** The configuration for a scorecard criterion that can be shared across components. */  /** The configuration for a scorecard criterion that can be shared across components. */  /** Contains the calculated score for each scorecard criteria that is associated with a specific component. */  /** Historical criteria scores. */  /** Specifies the periodicity (regular repetition at fixed intervals) of the criteria score history data. */ 
let $78ad46e0d6808149$export$854cc3c30987ee51 = /*#__PURE__*/ function(CompassScorecardCriteriaScoreHistoryPeriodicity) {
    CompassScorecardCriteriaScoreHistoryPeriodicity["Daily"] = "DAILY";
    CompassScorecardCriteriaScoreHistoryPeriodicity["Weekly"] = "WEEKLY";
    return CompassScorecardCriteriaScoreHistoryPeriodicity;
}({}); /** Accepts input for querying criteria score history. */  /** Accepts input for filtering when querying criteria score history. */  /** Represents a historical breakdown of scorecard criteria score. */  /** Accepts input to filter the scorecard criteria statistics history. */ 
let $78ad46e0d6808149$export$742385f55bd1cd4c = /*#__PURE__*/ function(CompassScorecardCriteriaScoringStrategyRuleAction) {
    CompassScorecardCriteriaScoringStrategyRuleAction["MarkAsFailed"] = "MARK_AS_FAILED";
    CompassScorecardCriteriaScoringStrategyRuleAction["MarkAsPassed"] = "MARK_AS_PASSED";
    CompassScorecardCriteriaScoringStrategyRuleAction["MarkAsSkipped"] = "MARK_AS_SKIPPED";
    return CompassScorecardCriteriaScoringStrategyRuleAction;
}({}); /** Represents a statistical breakdown of scorecard criteria. */  /** Represents a count of components with the given score status for a scorecard criterion. */  /** COMPASS SCORECARD DEACTIVATION TYPES */  /** Accepts input to sort the deactivated components by. */  /** The types used to identify the importance of the scorecard. */ 
let $78ad46e0d6808149$export$8f487531178b2612 = /*#__PURE__*/ function(CompassScorecardImportance) {
    CompassScorecardImportance["Recommended"] = "RECOMMENDED";
    CompassScorecardImportance["Required"] = "REQUIRED";
    CompassScorecardImportance["UserDefined"] = "USER_DEFINED";
    return CompassScorecardImportance;
}({}); /** Accepts input to filter the scorecards by. */  /** Accepts input to sort the scorecards by. */  /** Sort scorecards in ascending or descending order of specified field. */ 
let $78ad46e0d6808149$export$edfe0f1e34848d09 = /*#__PURE__*/ function(CompassScorecardQuerySortOrder) {
    CompassScorecardQuerySortOrder["Asc"] = "ASC";
    CompassScorecardQuerySortOrder["Desc"] = "DESC";
    return CompassScorecardQuerySortOrder;
}({}); /** Contains the calculated score for a component. Each component has one calculated score per scorecard. */  /** Accepts input to filter the scorecard score durations statistics. */  /** A historical scorecard score. */  /** SCORE HISTORY */  /** Specifies the periodicity (regular repetition at fixed intervals) of the scorecard score history data. */ 
let $78ad46e0d6808149$export$ac226c775361dae9 = /*#__PURE__*/ function(CompassScorecardScoreHistoryPeriodicity) {
    CompassScorecardScoreHistoryPeriodicity["Daily"] = "DAILY";
    CompassScorecardScoreHistoryPeriodicity["Weekly"] = "WEEKLY";
    return CompassScorecardScoreHistoryPeriodicity;
}({}); /** Accepts input for querying scorecard score history. */  /** Accepts input for filtering when querying scorecard score history. */  /** Scorecard score on a scorecard for a component. */  /** Represents a count of components with the given score status for a scorecard. */  /** Represents a historical breakdown of scorecard score. */  /** SCORE STATISTICS HISTORY */  /** Accepts input to filter the scorecard score statistics history. */  /** Represents a scorecard score status. */ 
let $78ad46e0d6808149$export$f073cd3745c42272 = /*#__PURE__*/ function(CompassScorecardScoringStrategyType) {
    CompassScorecardScoringStrategyType["PointBased"] = "POINT_BASED";
    CompassScorecardScoringStrategyType["WeightBased"] = "WEIGHT_BASED";
    return CompassScorecardScoringStrategyType;
}({}); /** Accepts input to find available scorecards, optionally filtered and/or sorted. */  /** The query to find component labels within Compass. */  /** The query to find components. */  /** A connection that returns a paginated collection of team labels. */  /** An edge that contains a team label and a cursor. */  /** Accepts input for searching team labels. */  /** A connection that returns a paginated collection of teams */  /** The details of a Pull request's timestamps. */  /** A team checkin communicates checkin for a team. */  /** An action item of a team checkin. */  /** Accepts input for creating/updating/deleting team checkin's action item. */  /** Accepts input for deleting a team checkin. */  /** The payload returned when querying for Compass-specific team data. */  /** The payload returned when querying for Compass-specific team data. */  /** The payload returned when querying for Compass-specific team data. */  /** Accepts input for viewing Compass-specific data about a team. */  /** A label provides additional contextual information about a team. */  /** A metric source scoped to a Team */  /** A metric source scoped to a Team */  /** Accepts input for updating a component announcement. */  /** The payload returned after updating a component announcement. */  /** Accepts input for updating a Component Scorecard Jira issue. */  /** The payload returned after updating a Compass Component Scorecard Jira issue. */  /** Accepts input for updating a custom boolean field definition. */  /** Accepts input for updating a custom field definition. You must provide exactly one of the fields in this input type. */  /** The payload returned from updating a custom field definition. */  /** Accepts input for updating a custom multi select field definition. */  /** Accepts input for updating a custom number field definition. */  /** Accepts input for updating a custom single select field definition. */  /** Accepts input for updating a custom text field definition. */  /** Accepts input for updating a custom user field definition. */  /** Accepts input to update a scorecard criterion checking the value of a specified custom boolean field. */  /** Accepts input to update a scorecard criterion checking the value of a specified custom number field. */  /** Accepts input to update a scorecard criterion checking the value of a specified custom text field. */  /** The input to update a metric definition. */  /** The payload returned from updating a metric definition. */  /** The payload returned after updating the custom permission configs. */  /** Accepts input for updating a team checkin action. */  /** Accepts input for updating a team checkin. */  /** The payload returned after updating a team checkin. */  /** Accepts input for updating team checkin responses with rich text. */  /** Definition of a parameter that enables users to input data */  /** Viewer's subscription. */  /** A webhook that is invoked after a component is created from a template. */  /** All Atlassian Cloud Products an app version is compatible with */  /** All Atlassian DataCenter Products an app version is compatible with */  /** All Atlassian Products an app version is compatible with */  /** All Atlassian Server Products an app version is compatible with */  /** Complete sprint */  /** Event data corresponding to a dataManager updating a component. */  /** Details on the result of the last component sync. */  /** Status types of a data manager sync event. */ 
let $78ad46e0d6808149$export$f1221e641dc6f3ef = /*#__PURE__*/ function(ComponentSyncEventStatus) {
    ComponentSyncEventStatus["ServerError"] = "SERVER_ERROR";
    ComponentSyncEventStatus["Success"] = "SUCCESS";
    ComponentSyncEventStatus["UserError"] = "USER_ERROR";
    return ComponentSyncEventStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:blogpost:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$f2d20e136929adb = /*#__PURE__*/ function(ConfluenceBlogPostStatus) {
    ConfluenceBlogPostStatus["Archived"] = "ARCHIVED";
    ConfluenceBlogPostStatus["Current"] = "CURRENT";
    ConfluenceBlogPostStatus["Deleted"] = "DELETED";
    ConfluenceBlogPostStatus["Draft"] = "DRAFT";
    ConfluenceBlogPostStatus["Historical"] = "HISTORICAL";
    ConfluenceBlogPostStatus["Trashed"] = "TRASHED";
    return ConfluenceBlogPostStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$92fbeeae7bfc11f8 = /*#__PURE__*/ function(ConfluenceBodyRepresentation) {
    ConfluenceBodyRepresentation["AnonymousExportView"] = "ANONYMOUS_EXPORT_VIEW";
    ConfluenceBodyRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceBodyRepresentation["Dynamic"] = "DYNAMIC";
    ConfluenceBodyRepresentation["Editor"] = "EDITOR";
    ConfluenceBodyRepresentation["Editor2"] = "EDITOR2";
    ConfluenceBodyRepresentation["ExportView"] = "EXPORT_VIEW";
    ConfluenceBodyRepresentation["Storage"] = "STORAGE";
    ConfluenceBodyRepresentation["StyledView"] = "STYLED_VIEW";
    ConfluenceBodyRepresentation["View"] = "VIEW";
    return ConfluenceBodyRepresentation;
}({});
let $78ad46e0d6808149$export$c0eb639b68d4388a = /*#__PURE__*/ function(ConfluenceCollaborativeEditingService) {
    ConfluenceCollaborativeEditingService["Ncs"] = "NCS";
    ConfluenceCollaborativeEditingService["Synchrony"] = "SYNCHRONY";
    return ConfluenceCollaborativeEditingService;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:comment:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$33f6fe4ae00b4df5 = /*#__PURE__*/ function(ConfluenceCommentStatus) {
    ConfluenceCommentStatus["Current"] = "CURRENT";
    ConfluenceCommentStatus["Draft"] = "DRAFT";
    return ConfluenceCommentStatus;
}({});
let $78ad46e0d6808149$export$6fc7e2bddad2dec7 = /*#__PURE__*/ function(ConfluenceCommentType) {
    ConfluenceCommentType["Footer"] = "FOOTER";
    ConfluenceCommentType["Inline"] = "INLINE";
    return ConfluenceCommentType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$7ba61dc1e5005a2 = /*#__PURE__*/ function(ConfluenceContentRepresentation) {
    ConfluenceContentRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceContentRepresentation["Editor"] = "EDITOR";
    ConfluenceContentRepresentation["Editor2"] = "EDITOR2";
    ConfluenceContentRepresentation["ExportView"] = "EXPORT_VIEW";
    ConfluenceContentRepresentation["Plain"] = "PLAIN";
    ConfluenceContentRepresentation["Raw"] = "RAW";
    ConfluenceContentRepresentation["Storage"] = "STORAGE";
    ConfluenceContentRepresentation["StyledView"] = "STYLED_VIEW";
    ConfluenceContentRepresentation["View"] = "VIEW";
    ConfluenceContentRepresentation["Wiki"] = "WIKI";
    return ConfluenceContentRepresentation;
}({});
let $78ad46e0d6808149$export$98ac9eece9e68319 = /*#__PURE__*/ function(ConfluenceContentType) {
    ConfluenceContentType["Attachment"] = "ATTACHMENT";
    ConfluenceContentType["BlogPost"] = "BLOG_POST";
    ConfluenceContentType["Comment"] = "COMMENT";
    ConfluenceContentType["Page"] = "PAGE";
    ConfluenceContentType["Whiteboard"] = "WHITEBOARD";
    return ConfluenceContentType;
}({});
let $78ad46e0d6808149$export$353a51d90d6c94b7 = /*#__PURE__*/ function(ConfluenceContributionStatus) {
    ConfluenceContributionStatus["Current"] = "CURRENT";
    ConfluenceContributionStatus["Draft"] = "DRAFT";
    ConfluenceContributionStatus["Unknown"] = "UNKNOWN";
    ConfluenceContributionStatus["Unpublished"] = "UNPUBLISHED";
    return ConfluenceContributionStatus;
}({}); /** The result of a successful copy page Long Task. */  /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$d9c59fb36f888de3 = /*#__PURE__*/ function(ConfluenceInlineCommentResolutionStatus) {
    ConfluenceInlineCommentResolutionStatus["Resolved"] = "RESOLVED";
    ConfluenceInlineCommentResolutionStatus["Unresolved"] = "UNRESOLVED";
    return ConfluenceInlineCommentResolutionStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:inlinetask:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$d6dc66c7e58b1f27 = /*#__PURE__*/ function(ConfluenceInlineTaskStatus) {
    ConfluenceInlineTaskStatus["Complete"] = "COMPLETE";
    ConfluenceInlineTaskStatus["Incomplete"] = "INCOMPLETE";
    return ConfluenceInlineTaskStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:label:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$55cdc784c43406a6 = /*#__PURE__*/ function(ConfluenceLegacyAccessStatus) {
    ConfluenceLegacyAccessStatus["AnonymousAccess"] = "ANONYMOUS_ACCESS";
    ConfluenceLegacyAccessStatus["ExternalCollaboratorAccess"] = "EXTERNAL_COLLABORATOR_ACCESS";
    ConfluenceLegacyAccessStatus["ExternalShareAccess"] = "EXTERNAL_SHARE_ACCESS";
    ConfluenceLegacyAccessStatus["LicensedAdminAccess"] = "LICENSED_ADMIN_ACCESS";
    ConfluenceLegacyAccessStatus["LicensedUseAccess"] = "LICENSED_USE_ACCESS";
    ConfluenceLegacyAccessStatus["NotPermitted"] = "NOT_PERMITTED";
    ConfluenceLegacyAccessStatus["UnlicensedAuthenticatedAccess"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return ConfluenceLegacyAccessStatus;
}({});
let $78ad46e0d6808149$export$6fb100d84dc744ee = /*#__PURE__*/ function(ConfluenceLegacyAccessType) {
    ConfluenceLegacyAccessType["Edit"] = "EDIT";
    ConfluenceLegacyAccessType["View"] = "VIEW";
    return ConfluenceLegacyAccessType;
}({});
let $78ad46e0d6808149$export$f94f4d758ab56d24 = /*#__PURE__*/ function(ConfluenceLegacyAccountType) {
    ConfluenceLegacyAccountType["App"] = "APP";
    ConfluenceLegacyAccountType["Atlassian"] = "ATLASSIAN";
    ConfluenceLegacyAccountType["Customer"] = "CUSTOMER";
    ConfluenceLegacyAccountType["Unknown"] = "UNKNOWN";
    return ConfluenceLegacyAccountType;
}({}); /** --------------------------------------------------------------------------------------------- */  /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$67a1e2571d1b8f49 = /*#__PURE__*/ function(ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder) {
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["Default"] = "DEFAULT";
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["ScheduledEndDate"] = "SCHEDULED_END_DATE";
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["ScheduledStartDate"] = "SCHEDULED_START_DATE";
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["Visibility"] = "VISIBILITY";
    return ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder;
}({});
let $78ad46e0d6808149$export$abe83d18892e131e = /*#__PURE__*/ function(ConfluenceLegacyAdminAnnouncementBannerStatusType) {
    ConfluenceLegacyAdminAnnouncementBannerStatusType["Published"] = "PUBLISHED";
    ConfluenceLegacyAdminAnnouncementBannerStatusType["Saved"] = "SAVED";
    ConfluenceLegacyAdminAnnouncementBannerStatusType["Scheduled"] = "SCHEDULED";
    return ConfluenceLegacyAdminAnnouncementBannerStatusType;
}({});
let $78ad46e0d6808149$export$6ea4d7ff878e1fa7 = /*#__PURE__*/ function(ConfluenceLegacyAdminAnnouncementBannerVisibilityType) {
    ConfluenceLegacyAdminAnnouncementBannerVisibilityType["All"] = "ALL";
    ConfluenceLegacyAdminAnnouncementBannerVisibilityType["Authorized"] = "AUTHORIZED";
    return ConfluenceLegacyAdminAnnouncementBannerVisibilityType;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$592845e9ae5bd115 = /*#__PURE__*/ function(ConfluenceLegacyAllUpdatesFeedEventType) {
    ConfluenceLegacyAllUpdatesFeedEventType["Comment"] = "COMMENT";
    ConfluenceLegacyAllUpdatesFeedEventType["Create"] = "CREATE";
    ConfluenceLegacyAllUpdatesFeedEventType["Edit"] = "EDIT";
    return ConfluenceLegacyAllUpdatesFeedEventType;
}({});
let $78ad46e0d6808149$export$4f7b2d728c929a44 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsCommentType) {
    ConfluenceLegacyAnalyticsCommentType["Inline"] = "inline";
    ConfluenceLegacyAnalyticsCommentType["Page"] = "page";
    return ConfluenceLegacyAnalyticsCommentType;
}({});
let $78ad46e0d6808149$export$e30f067708a78859 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsContentType) {
    ConfluenceLegacyAnalyticsContentType["Blogpost"] = "blogpost";
    ConfluenceLegacyAnalyticsContentType["Page"] = "page";
    return ConfluenceLegacyAnalyticsContentType;
}({}); /** Events to gather analytics for */ 
let $78ad46e0d6808149$export$974cb55686fb4ebc = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsEventName) {
    ConfluenceLegacyAnalyticsEventName["AnalyticsPageModalViewed"] = "analyticsPageModal_viewed";
    ConfluenceLegacyAnalyticsEventName["AutomationRuleTrackCreated"] = "automationRuleTrack_created";
    ConfluenceLegacyAnalyticsEventName["CalendarCreated"] = "calendar_created";
    ConfluenceLegacyAnalyticsEventName["CommentCreated"] = "comment_created";
    ConfluenceLegacyAnalyticsEventName["DatabaseCreated"] = "database_created";
    ConfluenceLegacyAnalyticsEventName["DatabaseViewed"] = "database_viewed";
    ConfluenceLegacyAnalyticsEventName["InspectPermissionsDialogViewed"] = "inspectPermissionsDialog_viewed";
    ConfluenceLegacyAnalyticsEventName["InstanceAnalyticsViewed"] = "instanceAnalytics_viewed";
    ConfluenceLegacyAnalyticsEventName["PageAnalyticsViewed"] = "pageAnalytics_viewed";
    ConfluenceLegacyAnalyticsEventName["PageCreated"] = "page_created";
    ConfluenceLegacyAnalyticsEventName["PageUpdated"] = "page_updated";
    ConfluenceLegacyAnalyticsEventName["PageViewed"] = "page_viewed";
    ConfluenceLegacyAnalyticsEventName["PubliclinkPageViewed"] = "publiclink_page_viewed";
    ConfluenceLegacyAnalyticsEventName["SpaceAnalyticsViewed"] = "spaceAnalytics_viewed";
    ConfluenceLegacyAnalyticsEventName["TeamCalendarsViewed"] = "teamCalendars_viewed";
    ConfluenceLegacyAnalyticsEventName["WhiteboardCreated"] = "whiteboard_created";
    ConfluenceLegacyAnalyticsEventName["WhiteboardViewed"] = "whiteboard_viewed";
    return ConfluenceLegacyAnalyticsEventName;
}({}); /** Events to gather measure analytics for */ 
let $78ad46e0d6808149$export$9dc60e43906fc093 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsMeasuresEventName) {
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentBlogpostCountSitestateMeasured"] = "currentBlogpostCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentBlogpostCountSpacestateMeasured"] = "currentBlogpostCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentDatabaseCountSitestateMeasured"] = "currentDatabaseCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentDatabaseCountSpacestateMeasured"] = "currentDatabaseCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentPageCountSitestateMeasured"] = "currentPageCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentPageCountSpacestateMeasured"] = "currentPageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentWhiteboardCountSitestateMeasured"] = "currentWhiteboardCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentWhiteboardCountSpacestateMeasured"] = "currentWhiteboardCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["InactivePageCountSitestateMeasured"] = "inactivePageCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["InactivePageCountSpacestateMeasured"] = "inactivePageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActiveCommunalSpacesSitestateMeasured"] = "totalActiveCommunalSpaces_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActivePersonalSpacesSitestateMeasured"] = "totalActivePersonalSpaces_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActivePublicLinksSitestateMeasured"] = "totalActivePublicLinks_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActivePublicLinksSpacestateMeasured"] = "totalActivePublicLinks_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActiveSpacesSitestateMeasured"] = "totalActiveSpaces_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentBlogpostCountSitestateMeasured"] = "totalCurrentBlogpostCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentDatabaseCountSitestateMeasured"] = "totalCurrentDatabaseCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentPageCountSitestateMeasured"] = "totalCurrentPageCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentWhiteboardCountSitestateMeasured"] = "totalCurrentWhiteboardCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalPagesDeactivatedOwnerSitestateMeasured"] = "totalPagesDeactivatedOwner_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalPagesDeactivatedOwnerSpacestateMeasured"] = "totalPagesDeactivatedOwner_spacestate_measured";
    return ConfluenceLegacyAnalyticsMeasuresEventName;
}({}); /** Events to gather measure analytics space state */ 
let $78ad46e0d6808149$export$529a0a3fc89fb460 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsMeasuresSpaceEventName) {
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentBlogpostCountSpacestateMeasured"] = "currentBlogpostCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentDatabaseCountSpacestateMeasured"] = "currentDatabaseCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentPageCountSpacestateMeasured"] = "currentPageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentWhiteboardCountSpacestateMeasured"] = "currentWhiteboardCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["InactivePageCountSpacestateMeasured"] = "inactivePageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["TotalActivePublicLinksSpacestateMeasured"] = "totalActivePublicLinks_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["TotalPagesDeactivatedOwnerSpacestateMeasured"] = "totalPagesDeactivatedOwner_spacestate_measured";
    return ConfluenceLegacyAnalyticsMeasuresSpaceEventName;
}({}); /** Events to gather search analytics for */ 
let $78ad46e0d6808149$export$5a62729781e5150 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsSearchEventName) {
    ConfluenceLegacyAnalyticsSearchEventName["AdvancedSearchResultLinkClicked"] = "advancedSearchResultLink_clicked";
    ConfluenceLegacyAnalyticsSearchEventName["AdvancedSearchResultsShown"] = "advancedSearchResults_shown";
    ConfluenceLegacyAnalyticsSearchEventName["QuickSearchRequestCompleted"] = "quickSearchRequest_completed";
    ConfluenceLegacyAnalyticsSearchEventName["QuickSearchResultSelected"] = "quickSearchResult_selected";
    return ConfluenceLegacyAnalyticsSearchEventName;
}({}); /** Granularity to group events by */ 
let $78ad46e0d6808149$export$cd1f6d32ed31f38f = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsTimeseriesGranularity) {
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Day"] = "DAY";
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Hour"] = "HOUR";
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Month"] = "MONTH";
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Week"] = "WEEK";
    return ConfluenceLegacyAnalyticsTimeseriesGranularity;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$84cc0985ee5132c3 = /*#__PURE__*/ function(ConfluenceLegacyBackendExperiment) {
    ConfluenceLegacyBackendExperiment["Einstein"] = "EINSTEIN";
    return ConfluenceLegacyBackendExperiment;
}({});
let $78ad46e0d6808149$export$72d2271493719cd9 = /*#__PURE__*/ function(ConfluenceLegacyBillingSourceSystem) {
    ConfluenceLegacyBillingSourceSystem["Ccp"] = "CCP";
    ConfluenceLegacyBillingSourceSystem["Hams"] = "HAMS";
    return ConfluenceLegacyBillingSourceSystem;
}({}); /** Represents a block-rendered smart-link on a page */ 
let $78ad46e0d6808149$export$1d6c7c01499dab = /*#__PURE__*/ function(ConfluenceLegacyBodyFormatType) {
    ConfluenceLegacyBodyFormatType["AnonymousExportView"] = "ANONYMOUS_EXPORT_VIEW";
    ConfluenceLegacyBodyFormatType["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceLegacyBodyFormatType["Editor"] = "EDITOR";
    ConfluenceLegacyBodyFormatType["Editor2"] = "EDITOR2";
    ConfluenceLegacyBodyFormatType["ExportView"] = "EXPORT_VIEW";
    ConfluenceLegacyBodyFormatType["Storage"] = "STORAGE";
    ConfluenceLegacyBodyFormatType["StyledView"] = "STYLED_VIEW";
    ConfluenceLegacyBodyFormatType["View"] = "VIEW";
    return ConfluenceLegacyBodyFormatType;
}({});
let $78ad46e0d6808149$export$808cc4b811411528 = /*#__PURE__*/ function(ConfluenceLegacyBulkSetSpacePermissionSpaceType) {
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["Collaboration"] = "COLLABORATION";
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["Global"] = "GLOBAL";
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["KnowledgeBase"] = "KNOWLEDGE_BASE";
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["Personal"] = "PERSONAL";
    return ConfluenceLegacyBulkSetSpacePermissionSpaceType;
}({});
let $78ad46e0d6808149$export$7537b52b3e1ca17f = /*#__PURE__*/ function(ConfluenceLegacyBulkSetSpacePermissionSubjectType) {
    ConfluenceLegacyBulkSetSpacePermissionSubjectType["Group"] = "GROUP";
    ConfluenceLegacyBulkSetSpacePermissionSubjectType["User"] = "USER";
    return ConfluenceLegacyBulkSetSpacePermissionSubjectType;
}({});
let $78ad46e0d6808149$export$c274657b6ae8c08b = /*#__PURE__*/ function(ConfluenceLegacyCatchupContentType) {
    ConfluenceLegacyCatchupContentType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacyCatchupContentType["Page"] = "PAGE";
    return ConfluenceLegacyCatchupContentType;
}({});
let $78ad46e0d6808149$export$d3260cc27acb2273 = /*#__PURE__*/ function(ConfluenceLegacyCatchupUpdateType) {
    ConfluenceLegacyCatchupUpdateType["TopN"] = "TOP_N";
    return ConfluenceLegacyCatchupUpdateType;
}({});
let $78ad46e0d6808149$export$fbf27f279c195cfd = /*#__PURE__*/ function(ConfluenceLegacyCommentCreationLocation) {
    ConfluenceLegacyCommentCreationLocation["Editor"] = "EDITOR";
    ConfluenceLegacyCommentCreationLocation["Live"] = "LIVE";
    ConfluenceLegacyCommentCreationLocation["Renderer"] = "RENDERER";
    ConfluenceLegacyCommentCreationLocation["Whiteboard"] = "WHITEBOARD";
    return ConfluenceLegacyCommentCreationLocation;
}({});
let $78ad46e0d6808149$export$68d0cd998b71f75b = /*#__PURE__*/ function(ConfluenceLegacyCommentDeletionLocation) {
    ConfluenceLegacyCommentDeletionLocation["Live"] = "LIVE";
    return ConfluenceLegacyCommentDeletionLocation;
}({});
let $78ad46e0d6808149$export$e2f309d5fad312d0 = /*#__PURE__*/ function(ConfluenceLegacyCommentReplyType) {
    ConfluenceLegacyCommentReplyType["Emoji"] = "EMOJI";
    ConfluenceLegacyCommentReplyType["Prompt"] = "PROMPT";
    ConfluenceLegacyCommentReplyType["QuickReply"] = "QUICK_REPLY";
    return ConfluenceLegacyCommentReplyType;
}({});
let $78ad46e0d6808149$export$2dfdca1bacc36231 = /*#__PURE__*/ function(ConfluenceLegacyCommentType) {
    ConfluenceLegacyCommentType["Footer"] = "FOOTER";
    ConfluenceLegacyCommentType["Inline"] = "INLINE";
    ConfluenceLegacyCommentType["Resolved"] = "RESOLVED";
    ConfluenceLegacyCommentType["Unresolved"] = "UNRESOLVED";
    return ConfluenceLegacyCommentType;
}({});
let $78ad46e0d6808149$export$b6d21fe6703a2599 = /*#__PURE__*/ function(ConfluenceLegacyCommentsType) {
    ConfluenceLegacyCommentsType["Footer"] = "FOOTER";
    ConfluenceLegacyCommentsType["Inline"] = "INLINE";
    return ConfluenceLegacyCommentsType;
}({});
let $78ad46e0d6808149$export$83d2156f88d87d3c = /*#__PURE__*/ function(ConfluenceLegacyContactAdminPageDisabledReason) {
    ConfluenceLegacyContactAdminPageDisabledReason["ConfigOff"] = "CONFIG_OFF";
    ConfluenceLegacyContactAdminPageDisabledReason["NoAdminEmails"] = "NO_ADMIN_EMAILS";
    ConfluenceLegacyContactAdminPageDisabledReason["NoMailServer"] = "NO_MAIL_SERVER";
    ConfluenceLegacyContactAdminPageDisabledReason["NoRecaptcha"] = "NO_RECAPTCHA";
    return ConfluenceLegacyContactAdminPageDisabledReason;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$dc0b3486b6d302da = /*#__PURE__*/ function(ConfluenceLegacyContainerType) {
    ConfluenceLegacyContainerType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacyContainerType["Page"] = "PAGE";
    ConfluenceLegacyContainerType["Space"] = "SPACE";
    ConfluenceLegacyContainerType["Whiteboard"] = "WHITEBOARD";
    return ConfluenceLegacyContainerType;
}({});
let $78ad46e0d6808149$export$14a0d7c84f79aebf = /*#__PURE__*/ function(ConfluenceLegacyContentAccessInputType) {
    ConfluenceLegacyContentAccessInputType["EveryoneCanEdit"] = "EVERYONE_CAN_EDIT";
    ConfluenceLegacyContentAccessInputType["EveryoneCanView"] = "EVERYONE_CAN_VIEW";
    ConfluenceLegacyContentAccessInputType["EveryoneNoAccess"] = "EVERYONE_NO_ACCESS";
    ConfluenceLegacyContentAccessInputType["Private"] = "PRIVATE";
    return ConfluenceLegacyContentAccessInputType;
}({});
let $78ad46e0d6808149$export$cf8f2171d823bde = /*#__PURE__*/ function(ConfluenceLegacyContentAccessType) {
    ConfluenceLegacyContentAccessType["EveryoneCanEdit"] = "EVERYONE_CAN_EDIT";
    ConfluenceLegacyContentAccessType["EveryoneCanView"] = "EVERYONE_CAN_VIEW";
    ConfluenceLegacyContentAccessType["EveryoneNoAccess"] = "EVERYONE_NO_ACCESS";
    return ConfluenceLegacyContentAccessType;
}({});
let $78ad46e0d6808149$export$1c8c23d711ae773e = /*#__PURE__*/ function(ConfluenceLegacyContentAction) {
    ConfluenceLegacyContentAction["Created"] = "created";
    ConfluenceLegacyContentAction["Updated"] = "updated";
    ConfluenceLegacyContentAction["Viewed"] = "viewed";
    return ConfluenceLegacyContentAction;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$a78e2be628bf0936 = /*#__PURE__*/ function(ConfluenceLegacyContentDataClassificationMutationContentStatus) {
    ConfluenceLegacyContentDataClassificationMutationContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyContentDataClassificationMutationContentStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyContentDataClassificationMutationContentStatus;
}({});
let $78ad46e0d6808149$export$8294e4a5584cdafb = /*#__PURE__*/ function(ConfluenceLegacyContentDataClassificationQueryContentStatus) {
    ConfluenceLegacyContentDataClassificationQueryContentStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyContentDataClassificationQueryContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyContentDataClassificationQueryContentStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyContentDataClassificationQueryContentStatus;
}({});
let $78ad46e0d6808149$export$11a7365bbd55a2c3 = /*#__PURE__*/ function(ConfluenceLegacyContentDeleteActionType) {
    ConfluenceLegacyContentDeleteActionType["DeleteDraft"] = "DELETE_DRAFT";
    ConfluenceLegacyContentDeleteActionType["DeleteDraftIfBlank"] = "DELETE_DRAFT_IF_BLANK";
    ConfluenceLegacyContentDeleteActionType["MoveToTrash"] = "MOVE_TO_TRASH";
    ConfluenceLegacyContentDeleteActionType["PurgeFromTrash"] = "PURGE_FROM_TRASH";
    return ConfluenceLegacyContentDeleteActionType;
}({});
let $78ad46e0d6808149$export$e4765167602a01a4 = /*#__PURE__*/ function(ConfluenceLegacyContentPermissionType) {
    ConfluenceLegacyContentPermissionType["Edit"] = "EDIT";
    ConfluenceLegacyContentPermissionType["View"] = "VIEW";
    return ConfluenceLegacyContentPermissionType;
}({});
let $78ad46e0d6808149$export$52bfd28e9d78a168 = /*#__PURE__*/ function(ConfluenceLegacyContentRendererMode) {
    ConfluenceLegacyContentRendererMode["Editor"] = "EDITOR";
    ConfluenceLegacyContentRendererMode["Pdf"] = "PDF";
    ConfluenceLegacyContentRendererMode["Renderer"] = "RENDERER";
    return ConfluenceLegacyContentRendererMode;
}({});
let $78ad46e0d6808149$export$9f48a780e64ab98d = /*#__PURE__*/ function(ConfluenceLegacyContentRepresentation) {
    ConfluenceLegacyContentRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceLegacyContentRepresentation["Editor"] = "EDITOR";
    ConfluenceLegacyContentRepresentation["Editor2"] = "EDITOR2";
    ConfluenceLegacyContentRepresentation["ExportView"] = "EXPORT_VIEW";
    ConfluenceLegacyContentRepresentation["Plain"] = "PLAIN";
    ConfluenceLegacyContentRepresentation["Raw"] = "RAW";
    ConfluenceLegacyContentRepresentation["Storage"] = "STORAGE";
    ConfluenceLegacyContentRepresentation["StyledView"] = "STYLED_VIEW";
    ConfluenceLegacyContentRepresentation["View"] = "VIEW";
    ConfluenceLegacyContentRepresentation["Wiki"] = "WIKI";
    return ConfluenceLegacyContentRepresentation;
}({});
let $78ad46e0d6808149$export$22638a777276bf91 = /*#__PURE__*/ function(ConfluenceLegacyContentRole) {
    ConfluenceLegacyContentRole["Default"] = "DEFAULT";
    ConfluenceLegacyContentRole["Editor"] = "EDITOR";
    ConfluenceLegacyContentRole["Viewer"] = "VIEWER";
    return ConfluenceLegacyContentRole;
}({});
let $78ad46e0d6808149$export$962cbd35615f4fff = /*#__PURE__*/ function(ConfluenceLegacyContentStateRestrictionLevel) {
    ConfluenceLegacyContentStateRestrictionLevel["None"] = "NONE";
    ConfluenceLegacyContentStateRestrictionLevel["PageOwner"] = "PAGE_OWNER";
    return ConfluenceLegacyContentStateRestrictionLevel;
}({});
let $78ad46e0d6808149$export$c24d6a3d72599268 = /*#__PURE__*/ function(ConfluenceLegacyContentStatus) {
    ConfluenceLegacyContentStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyContentStatus["Deleted"] = "DELETED";
    ConfluenceLegacyContentStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyContentStatus;
}({});
let $78ad46e0d6808149$export$492d1092720944e9 = /*#__PURE__*/ function(ConfluenceLegacyContentTemplateType) {
    ConfluenceLegacyContentTemplateType["Blueprint"] = "BLUEPRINT";
    ConfluenceLegacyContentTemplateType["Page"] = "PAGE";
    return ConfluenceLegacyContentTemplateType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$1ead28a8886cdf4e = /*#__PURE__*/ function(ConfluenceLegacyDataSecurityPolicyAction) {
    ConfluenceLegacyDataSecurityPolicyAction["AppAccess"] = "APP_ACCESS";
    ConfluenceLegacyDataSecurityPolicyAction["PageExport"] = "PAGE_EXPORT";
    ConfluenceLegacyDataSecurityPolicyAction["PublicLinks"] = "PUBLIC_LINKS";
    return ConfluenceLegacyDataSecurityPolicyAction;
}({});
let $78ad46e0d6808149$export$d97f1f6b89a9dab8 = /*#__PURE__*/ function(ConfluenceLegacyDataSecurityPolicyCoverageType) {
    ConfluenceLegacyDataSecurityPolicyCoverageType["ClassificationLevel"] = "CLASSIFICATION_LEVEL";
    ConfluenceLegacyDataSecurityPolicyCoverageType["Container"] = "CONTAINER";
    ConfluenceLegacyDataSecurityPolicyCoverageType["None"] = "NONE";
    ConfluenceLegacyDataSecurityPolicyCoverageType["Workspace"] = "WORKSPACE";
    return ConfluenceLegacyDataSecurityPolicyCoverageType;
}({});
let $78ad46e0d6808149$export$b8ebe8bcbe0edcc9 = /*#__PURE__*/ function(ConfluenceLegacyDataSecurityPolicyDecidableContentStatus) {
    ConfluenceLegacyDataSecurityPolicyDecidableContentStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyDataSecurityPolicyDecidableContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyDataSecurityPolicyDecidableContentStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyDataSecurityPolicyDecidableContentStatus;
}({});
let $78ad46e0d6808149$export$8f82f21f1f98a966 = /*#__PURE__*/ function(ConfluenceLegacyDateFormat) {
    ConfluenceLegacyDateFormat["Global"] = "GLOBAL";
    ConfluenceLegacyDateFormat["Millis"] = "MILLIS";
    ConfluenceLegacyDateFormat["User"] = "USER";
    ConfluenceLegacyDateFormat["UserFriendly"] = "USER_FRIENDLY";
    return ConfluenceLegacyDateFormat;
}({});
let $78ad46e0d6808149$export$1c761a9499909678 = /*#__PURE__*/ function(ConfluenceLegacyDeactivatedPageOwnerUserType) {
    ConfluenceLegacyDeactivatedPageOwnerUserType["FormerUsers"] = "FORMER_USERS";
    ConfluenceLegacyDeactivatedPageOwnerUserType["NonFormerUsers"] = "NON_FORMER_USERS";
    return ConfluenceLegacyDeactivatedPageOwnerUserType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$477e85946b13cfd1 = /*#__PURE__*/ function(ConfluenceLegacyDepth) {
    ConfluenceLegacyDepth["All"] = "ALL";
    ConfluenceLegacyDepth["Root"] = "ROOT";
    return ConfluenceLegacyDepth;
}({});
let $78ad46e0d6808149$export$8ca8fdccfce3b6b2 = /*#__PURE__*/ function(ConfluenceLegacyDescendantsNoteApplicationOption) {
    ConfluenceLegacyDescendantsNoteApplicationOption["All"] = "ALL";
    ConfluenceLegacyDescendantsNoteApplicationOption["None"] = "NONE";
    ConfluenceLegacyDescendantsNoteApplicationOption["Roots"] = "ROOTS";
    return ConfluenceLegacyDescendantsNoteApplicationOption;
}({});
let $78ad46e0d6808149$export$9e676a15531fad10 = /*#__PURE__*/ function(ConfluenceLegacyDocumentRepresentation) {
    ConfluenceLegacyDocumentRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceLegacyDocumentRepresentation["Html"] = "HTML";
    ConfluenceLegacyDocumentRepresentation["Storage"] = "STORAGE";
    ConfluenceLegacyDocumentRepresentation["View"] = "VIEW";
    return ConfluenceLegacyDocumentRepresentation;
}({});
let $78ad46e0d6808149$export$c54c52e1dab26d52 = /*#__PURE__*/ function(ConfluenceLegacyEdition) {
    ConfluenceLegacyEdition["Free"] = "FREE";
    ConfluenceLegacyEdition["Premium"] = "PREMIUM";
    ConfluenceLegacyEdition["Standard"] = "STANDARD";
    return ConfluenceLegacyEdition;
}({});
let $78ad46e0d6808149$export$42d27343a8b84fc8 = /*#__PURE__*/ function(ConfluenceLegacyEditorConversionSetting) {
    ConfluenceLegacyEditorConversionSetting["None"] = "NONE";
    ConfluenceLegacyEditorConversionSetting["Supported"] = "SUPPORTED";
    return ConfluenceLegacyEditorConversionSetting;
}({}); /** Represents a smart-link rendered as embedded on a page */  /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$fb03d9af47277a3d = /*#__PURE__*/ function(ConfluenceLegacyEnvironment) {
    ConfluenceLegacyEnvironment["Development"] = "DEVELOPMENT";
    ConfluenceLegacyEnvironment["Production"] = "PRODUCTION";
    ConfluenceLegacyEnvironment["Staging"] = "STAGING";
    return ConfluenceLegacyEnvironment;
}({}); /** The default space assigned to new Confluence Guests on role assignment. */ 
let $78ad46e0d6808149$export$4e6002c4c65764d4 = /*#__PURE__*/ function(ConfluenceLegacyExternalCollaboratorsSortField) {
    ConfluenceLegacyExternalCollaboratorsSortField["Name"] = "NAME";
    return ConfluenceLegacyExternalCollaboratorsSortField;
}({});
let $78ad46e0d6808149$export$a828ec9b508a2266 = /*#__PURE__*/ function(ConfluenceLegacyFeedEventType) {
    ConfluenceLegacyFeedEventType["Comment"] = "COMMENT";
    ConfluenceLegacyFeedEventType["Create"] = "CREATE";
    ConfluenceLegacyFeedEventType["Edit"] = "EDIT";
    return ConfluenceLegacyFeedEventType;
}({});
let $78ad46e0d6808149$export$13866e2e9da2ea4b = /*#__PURE__*/ function(ConfluenceLegacyFeedItemSourceType) {
    ConfluenceLegacyFeedItemSourceType["Person"] = "PERSON";
    ConfluenceLegacyFeedItemSourceType["Space"] = "SPACE";
    return ConfluenceLegacyFeedItemSourceType;
}({});
let $78ad46e0d6808149$export$2e72a60396e89995 = /*#__PURE__*/ function(ConfluenceLegacyFeedType) {
    ConfluenceLegacyFeedType["Direct"] = "DIRECT";
    ConfluenceLegacyFeedType["Following"] = "FOLLOWING";
    ConfluenceLegacyFeedType["Popular"] = "POPULAR";
    return ConfluenceLegacyFeedType;
}({});
let $78ad46e0d6808149$export$25f79122cd5df609 = /*#__PURE__*/ function(ConfluenceLegacyFrontCoverState) {
    ConfluenceLegacyFrontCoverState["Hidden"] = "HIDDEN";
    ConfluenceLegacyFrontCoverState["Shown"] = "SHOWN";
    ConfluenceLegacyFrontCoverState["Transition"] = "TRANSITION";
    ConfluenceLegacyFrontCoverState["Unset"] = "UNSET";
    return ConfluenceLegacyFrontCoverState;
}({});
let $78ad46e0d6808149$export$a19da40648493053 = /*#__PURE__*/ function(ConfluenceLegacyHomeWidgetState) {
    ConfluenceLegacyHomeWidgetState["Collapsed"] = "COLLAPSED";
    ConfluenceLegacyHomeWidgetState["Expanded"] = "EXPANDED";
    return ConfluenceLegacyHomeWidgetState;
}({});
let $78ad46e0d6808149$export$5f0193f955ef0cb1 = /*#__PURE__*/ function(ConfluenceLegacyInitialPermissionOptions) {
    ConfluenceLegacyInitialPermissionOptions["CopyFromSpace"] = "COPY_FROM_SPACE";
    ConfluenceLegacyInitialPermissionOptions["Default"] = "DEFAULT";
    ConfluenceLegacyInitialPermissionOptions["Private"] = "PRIVATE";
    return ConfluenceLegacyInitialPermissionOptions;
}({}); /** Represents an inline-rendered smart-link on a page */  /** The date range for an Inline Tasks Query Date. Start dates and end dates can be null-able to represent no specified boundary. */ 
let $78ad46e0d6808149$export$df2ab38c891954c2 = /*#__PURE__*/ function(ConfluenceLegacyInlineTasksQuerySortColumn) {
    ConfluenceLegacyInlineTasksQuerySortColumn["Assignee"] = "ASSIGNEE";
    ConfluenceLegacyInlineTasksQuerySortColumn["DueDate"] = "DUE_DATE";
    ConfluenceLegacyInlineTasksQuerySortColumn["PageTitle"] = "PAGE_TITLE";
    return ConfluenceLegacyInlineTasksQuerySortColumn;
}({});
let $78ad46e0d6808149$export$cba96ef83f91f0df = /*#__PURE__*/ function(ConfluenceLegacyInlineTasksQuerySortOrder) {
    ConfluenceLegacyInlineTasksQuerySortOrder["Ascending"] = "ASCENDING";
    ConfluenceLegacyInlineTasksQuerySortOrder["Descending"] = "DESCENDING";
    return ConfluenceLegacyInlineTasksQuerySortOrder;
}({});
let $78ad46e0d6808149$export$b2bba2f5e2a7ff3e = /*#__PURE__*/ function(ConfluenceLegacyInspectPermissions) {
    ConfluenceLegacyInspectPermissions["Comment"] = "COMMENT";
    ConfluenceLegacyInspectPermissions["Edit"] = "EDIT";
    ConfluenceLegacyInspectPermissions["View"] = "VIEW";
    return ConfluenceLegacyInspectPermissions;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$56cd0576b91fa37a = /*#__PURE__*/ function(ConfluenceLegacyLabelSortDirection) {
    ConfluenceLegacyLabelSortDirection["Ascending"] = "ASCENDING";
    ConfluenceLegacyLabelSortDirection["Descending"] = "DESCENDING";
    return ConfluenceLegacyLabelSortDirection;
}({});
let $78ad46e0d6808149$export$c05dc088e940cc05 = /*#__PURE__*/ function(ConfluenceLegacyLabelSortField) {
    ConfluenceLegacyLabelSortField["LabellingCreationdate"] = "LABELLING_CREATIONDATE";
    ConfluenceLegacyLabelSortField["LabellingId"] = "LABELLING_ID";
    return ConfluenceLegacyLabelSortField;
}({});
let $78ad46e0d6808149$export$33f17291ac91a786 = /*#__PURE__*/ function(ConfluenceLegacyLicenseStatus) {
    ConfluenceLegacyLicenseStatus["Active"] = "ACTIVE";
    ConfluenceLegacyLicenseStatus["Suspended"] = "SUSPENDED";
    ConfluenceLegacyLicenseStatus["Unlicensed"] = "UNLICENSED";
    return ConfluenceLegacyLicenseStatus;
}({});
let $78ad46e0d6808149$export$662bb1896031bf06 = /*#__PURE__*/ function(ConfluenceLegacyLoomUserStatus) {
    ConfluenceLegacyLoomUserStatus["Linked"] = "LINKED";
    ConfluenceLegacyLoomUserStatus["Mastered"] = "MASTERED";
    ConfluenceLegacyLoomUserStatus["NotFound"] = "NOT_FOUND";
    return ConfluenceLegacyLoomUserStatus;
}({});
let $78ad46e0d6808149$export$fd5adc8aad00cb78 = /*#__PURE__*/ function(ConfluenceLegacyMobilePlatform) {
    ConfluenceLegacyMobilePlatform["Android"] = "ANDROID";
    ConfluenceLegacyMobilePlatform["Ios"] = "IOS";
    return ConfluenceLegacyMobilePlatform;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$728d574e7c9f150a = /*#__PURE__*/ function(ConfluenceLegacyOperation) {
    ConfluenceLegacyOperation["Assigned"] = "ASSIGNED";
    ConfluenceLegacyOperation["Complete"] = "COMPLETE";
    ConfluenceLegacyOperation["Deleted"] = "DELETED";
    ConfluenceLegacyOperation["InComplete"] = "IN_COMPLETE";
    ConfluenceLegacyOperation["Reworded"] = "REWORDED";
    ConfluenceLegacyOperation["Unassigned"] = "UNASSIGNED";
    return ConfluenceLegacyOperation;
}({});
let $78ad46e0d6808149$export$42875c45c64c8240 = /*#__PURE__*/ function(ConfluenceLegacyOutputDeviceType) {
    ConfluenceLegacyOutputDeviceType["Desktop"] = "DESKTOP";
    ConfluenceLegacyOutputDeviceType["Email"] = "EMAIL";
    ConfluenceLegacyOutputDeviceType["Mobile"] = "MOBILE";
    return ConfluenceLegacyOutputDeviceType;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$938d9fc91bf189e3 = /*#__PURE__*/ function(ConfluenceLegacyPtGraphQlPageStatus) {
    ConfluenceLegacyPtGraphQlPageStatus["Current"] = "CURRENT";
    ConfluenceLegacyPtGraphQlPageStatus["Draft"] = "DRAFT";
    ConfluenceLegacyPtGraphQlPageStatus["Historical"] = "HISTORICAL";
    ConfluenceLegacyPtGraphQlPageStatus["Trashed"] = "TRASHED";
    return ConfluenceLegacyPtGraphQlPageStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$32601201a16f0b5d = /*#__PURE__*/ function(ConfluenceLegacyPageActivityAction) {
    ConfluenceLegacyPageActivityAction["Created"] = "created";
    ConfluenceLegacyPageActivityAction["Updated"] = "updated";
    return ConfluenceLegacyPageActivityAction;
}({});
let $78ad46e0d6808149$export$768747d8a19c91ab = /*#__PURE__*/ function(ConfluenceLegacyPageActivityActionSubject) {
    ConfluenceLegacyPageActivityActionSubject["Comment"] = "comment";
    ConfluenceLegacyPageActivityActionSubject["Page"] = "page";
    return ConfluenceLegacyPageActivityActionSubject;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$47389b8ef7f23bf3 = /*#__PURE__*/ function(ConfluenceLegacyPageAnalyticsCountType) {
    ConfluenceLegacyPageAnalyticsCountType["All"] = "ALL";
    ConfluenceLegacyPageAnalyticsCountType["User"] = "USER";
    return ConfluenceLegacyPageAnalyticsCountType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$1a9b6173c3040cc0 = /*#__PURE__*/ function(ConfluenceLegacyPageAnalyticsTimeseriesCountType) {
    ConfluenceLegacyPageAnalyticsTimeseriesCountType["All"] = "ALL";
    return ConfluenceLegacyPageAnalyticsTimeseriesCountType;
}({});
let $78ad46e0d6808149$export$aa202cd8cef6b1c2 = /*#__PURE__*/ function(ConfluenceLegacyPageCardInPageTreeHoverPreference) {
    ConfluenceLegacyPageCardInPageTreeHoverPreference["NoOptionSelected"] = "NO_OPTION_SELECTED";
    ConfluenceLegacyPageCardInPageTreeHoverPreference["NoShowPagecard"] = "NO_SHOW_PAGECARD";
    ConfluenceLegacyPageCardInPageTreeHoverPreference["ShowPagecard"] = "SHOW_PAGECARD";
    return ConfluenceLegacyPageCardInPageTreeHoverPreference;
}({});
let $78ad46e0d6808149$export$865c06c6ecba3931 = /*#__PURE__*/ function(ConfluenceLegacyPageCopyRestrictionValidationStatus) {
    ConfluenceLegacyPageCopyRestrictionValidationStatus["InvalidMultiple"] = "INVALID_MULTIPLE";
    ConfluenceLegacyPageCopyRestrictionValidationStatus["InvalidSingle"] = "INVALID_SINGLE";
    ConfluenceLegacyPageCopyRestrictionValidationStatus["Valid"] = "VALID";
    return ConfluenceLegacyPageCopyRestrictionValidationStatus;
}({});
let $78ad46e0d6808149$export$29a013f0158561e = /*#__PURE__*/ function(ConfluenceLegacyPageStatus) {
    ConfluenceLegacyPageStatus["Current"] = "CURRENT";
    ConfluenceLegacyPageStatus["Draft"] = "DRAFT";
    ConfluenceLegacyPageStatus["Historical"] = "HISTORICAL";
    ConfluenceLegacyPageStatus["Trashed"] = "TRASHED";
    return ConfluenceLegacyPageStatus;
}({});
let $78ad46e0d6808149$export$cb32a82a68eac3ea = /*#__PURE__*/ function(ConfluenceLegacyPageStatusInput) {
    ConfluenceLegacyPageStatusInput["Current"] = "CURRENT";
    ConfluenceLegacyPageStatusInput["Draft"] = "DRAFT";
    return ConfluenceLegacyPageStatusInput;
}({});
let $78ad46e0d6808149$export$88e74ffbe5a7ddc7 = /*#__PURE__*/ function(ConfluenceLegacyPageUpdateTrigger) {
    ConfluenceLegacyPageUpdateTrigger["CreatePage"] = "CREATE_PAGE";
    ConfluenceLegacyPageUpdateTrigger["DiscardChanges"] = "DISCARD_CHANGES";
    ConfluenceLegacyPageUpdateTrigger["EditPage"] = "EDIT_PAGE";
    ConfluenceLegacyPageUpdateTrigger["LinkRefactoring"] = "LINK_REFACTORING";
    ConfluenceLegacyPageUpdateTrigger["MigratePageCollab"] = "MIGRATE_PAGE_COLLAB";
    ConfluenceLegacyPageUpdateTrigger["OwnerChange"] = "OWNER_CHANGE";
    ConfluenceLegacyPageUpdateTrigger["PageRename"] = "PAGE_RENAME";
    ConfluenceLegacyPageUpdateTrigger["PersonalTasklist"] = "PERSONAL_TASKLIST";
    ConfluenceLegacyPageUpdateTrigger["Revert"] = "REVERT";
    ConfluenceLegacyPageUpdateTrigger["SpaceCreate"] = "SPACE_CREATE";
    ConfluenceLegacyPageUpdateTrigger["Unknown"] = "UNKNOWN";
    ConfluenceLegacyPageUpdateTrigger["ViewPage"] = "VIEW_PAGE";
    return ConfluenceLegacyPageUpdateTrigger;
}({});
let $78ad46e0d6808149$export$e9c8dbdf7b225312 = /*#__PURE__*/ function(ConfluenceLegacyPagesDisplayPersistenceOption) {
    ConfluenceLegacyPagesDisplayPersistenceOption["Cards"] = "CARDS";
    ConfluenceLegacyPagesDisplayPersistenceOption["CompactList"] = "COMPACT_LIST";
    ConfluenceLegacyPagesDisplayPersistenceOption["List"] = "LIST";
    return ConfluenceLegacyPagesDisplayPersistenceOption;
}({});
let $78ad46e0d6808149$export$aaf6c229cce2f3b3 = /*#__PURE__*/ function(ConfluenceLegacyPagesSortField) {
    ConfluenceLegacyPagesSortField["LastModifiedDate"] = "LAST_MODIFIED_DATE";
    ConfluenceLegacyPagesSortField["Relevant"] = "RELEVANT";
    ConfluenceLegacyPagesSortField["Title"] = "TITLE";
    return ConfluenceLegacyPagesSortField;
}({});
let $78ad46e0d6808149$export$318b7a7639914e93 = /*#__PURE__*/ function(ConfluenceLegacyPagesSortOrder) {
    ConfluenceLegacyPagesSortOrder["Asc"] = "ASC";
    ConfluenceLegacyPagesSortOrder["Desc"] = "DESC";
    return ConfluenceLegacyPagesSortOrder;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$c7738cb0d3dab26f = /*#__PURE__*/ function(ConfluenceLegacyPathType) {
    ConfluenceLegacyPathType["Absolute"] = "ABSOLUTE";
    ConfluenceLegacyPathType["Relative"] = "RELATIVE";
    ConfluenceLegacyPathType["RelativeNoContext"] = "RELATIVE_NO_CONTEXT";
    return ConfluenceLegacyPathType;
}({});
let $78ad46e0d6808149$export$45c5982866ef3f86 = /*#__PURE__*/ function(ConfluenceLegacyPaywallStatus) {
    ConfluenceLegacyPaywallStatus["Active"] = "ACTIVE";
    ConfluenceLegacyPaywallStatus["Deactivated"] = "DEACTIVATED";
    ConfluenceLegacyPaywallStatus["Unset"] = "UNSET";
    return ConfluenceLegacyPaywallStatus;
}({});
let $78ad46e0d6808149$export$bdd86c404514bf5e = /*#__PURE__*/ function(ConfluenceLegacyPermissionDisplayType) {
    ConfluenceLegacyPermissionDisplayType["Anonymous"] = "ANONYMOUS";
    ConfluenceLegacyPermissionDisplayType["Group"] = "GROUP";
    ConfluenceLegacyPermissionDisplayType["GuestUser"] = "GUEST_USER";
    ConfluenceLegacyPermissionDisplayType["LicensedUser"] = "LICENSED_USER";
    return ConfluenceLegacyPermissionDisplayType;
}({});
let $78ad46e0d6808149$export$5e661380a2aa4206 = /*#__PURE__*/ function(ConfluenceLegacyPlatform) {
    ConfluenceLegacyPlatform["Android"] = "ANDROID";
    ConfluenceLegacyPlatform["Ios"] = "IOS";
    ConfluenceLegacyPlatform["Web"] = "WEB";
    return ConfluenceLegacyPlatform;
}({});
let $78ad46e0d6808149$export$b8313f5a464cf0ed = /*#__PURE__*/ function(ConfluenceLegacyPremiumToolsDropdownStatus) {
    ConfluenceLegacyPremiumToolsDropdownStatus["Collapsed"] = "COLLAPSED";
    ConfluenceLegacyPremiumToolsDropdownStatus["Expanded"] = "EXPANDED";
    ConfluenceLegacyPremiumToolsDropdownStatus["Unset"] = "UNSET";
    return ConfluenceLegacyPremiumToolsDropdownStatus;
}({});
let $78ad46e0d6808149$export$44790dd8acc73dd6 = /*#__PURE__*/ function(ConfluenceLegacyPrincipalType) {
    ConfluenceLegacyPrincipalType["Group"] = "GROUP";
    ConfluenceLegacyPrincipalType["User"] = "USER";
    return ConfluenceLegacyPrincipalType;
}({});
let $78ad46e0d6808149$export$132f1b98364f7846 = /*#__PURE__*/ function(ConfluenceLegacyProduct) {
    ConfluenceLegacyProduct["Confluence"] = "CONFLUENCE";
    return ConfluenceLegacyProduct;
}({});
let $78ad46e0d6808149$export$baf22e4384c384d6 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkAdminAction) {
    ConfluenceLegacyPublicLinkAdminAction["Block"] = "BLOCK";
    ConfluenceLegacyPublicLinkAdminAction["Off"] = "OFF";
    ConfluenceLegacyPublicLinkAdminAction["On"] = "ON";
    ConfluenceLegacyPublicLinkAdminAction["Unblock"] = "UNBLOCK";
    return ConfluenceLegacyPublicLinkAdminAction;
}({});
let $78ad46e0d6808149$export$6c27a44327a1685c = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkDefaultSpaceStatus) {
    ConfluenceLegacyPublicLinkDefaultSpaceStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkDefaultSpaceStatus["On"] = "ON";
    return ConfluenceLegacyPublicLinkDefaultSpaceStatus;
}({});
let $78ad46e0d6808149$export$882b105854002ad0 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPageStatus) {
    ConfluenceLegacyPublicLinkPageStatus["BlockedByClassificationLevel"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    ConfluenceLegacyPublicLinkPageStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkPageStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkPageStatus["BlockedBySpace"] = "BLOCKED_BY_SPACE";
    ConfluenceLegacyPublicLinkPageStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkPageStatus["On"] = "ON";
    ConfluenceLegacyPublicLinkPageStatus["SiteBlocked"] = "SITE_BLOCKED";
    ConfluenceLegacyPublicLinkPageStatus["SiteDisabled"] = "SITE_DISABLED";
    ConfluenceLegacyPublicLinkPageStatus["SpaceBlocked"] = "SPACE_BLOCKED";
    ConfluenceLegacyPublicLinkPageStatus["SpaceDisabled"] = "SPACE_DISABLED";
    return ConfluenceLegacyPublicLinkPageStatus;
}({});
let $78ad46e0d6808149$export$e1e4b830a0825f2b = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPageStatusFilter) {
    ConfluenceLegacyPublicLinkPageStatusFilter["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkPageStatusFilter["BlockedBySpace"] = "BLOCKED_BY_SPACE";
    ConfluenceLegacyPublicLinkPageStatusFilter["Off"] = "OFF";
    ConfluenceLegacyPublicLinkPageStatusFilter["On"] = "ON";
    return ConfluenceLegacyPublicLinkPageStatusFilter;
}({});
let $78ad46e0d6808149$export$9acef11a8ce6e3c6 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPagesByCriteriaOrder) {
    ConfluenceLegacyPublicLinkPagesByCriteriaOrder["DateEnabled"] = "DATE_ENABLED";
    ConfluenceLegacyPublicLinkPagesByCriteriaOrder["Status"] = "STATUS";
    ConfluenceLegacyPublicLinkPagesByCriteriaOrder["Title"] = "TITLE";
    return ConfluenceLegacyPublicLinkPagesByCriteriaOrder;
}({});
let $78ad46e0d6808149$export$892bc471a65769c0 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPermissionsObjectType) {
    ConfluenceLegacyPublicLinkPermissionsObjectType["Content"] = "CONTENT";
    return ConfluenceLegacyPublicLinkPermissionsObjectType;
}({});
let $78ad46e0d6808149$export$353b2d93c5c6cf5c = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPermissionsType) {
    ConfluenceLegacyPublicLinkPermissionsType["Edit"] = "EDIT";
    return ConfluenceLegacyPublicLinkPermissionsType;
}({});
let $78ad46e0d6808149$export$1363899e44b2229b = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkSiteStatus) {
    ConfluenceLegacyPublicLinkSiteStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkSiteStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkSiteStatus["On"] = "ON";
    return ConfluenceLegacyPublicLinkSiteStatus;
}({});
let $78ad46e0d6808149$export$6344a7355e3086d1 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkSpaceStatus) {
    ConfluenceLegacyPublicLinkSpaceStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkSpaceStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkSpaceStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkSpaceStatus["On"] = "ON";
    return ConfluenceLegacyPublicLinkSpaceStatus;
}({});
let $78ad46e0d6808149$export$24ea1c3cc5ac9e7d = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkSpacesByCriteriaOrder) {
    ConfluenceLegacyPublicLinkSpacesByCriteriaOrder["ActiveLinks"] = "ACTIVE_LINKS";
    ConfluenceLegacyPublicLinkSpacesByCriteriaOrder["Name"] = "NAME";
    ConfluenceLegacyPublicLinkSpacesByCriteriaOrder["Status"] = "STATUS";
    return ConfluenceLegacyPublicLinkSpacesByCriteriaOrder;
}({});
let $78ad46e0d6808149$export$fde6c5e19eaa1054 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkStatus) {
    ConfluenceLegacyPublicLinkStatus["BlockedByClassificationLevel"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    ConfluenceLegacyPublicLinkStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkStatus["BlockedBySpace"] = "BLOCKED_BY_SPACE";
    ConfluenceLegacyPublicLinkStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkStatus["On"] = "ON";
    ConfluenceLegacyPublicLinkStatus["SiteBlocked"] = "SITE_BLOCKED";
    ConfluenceLegacyPublicLinkStatus["SiteDisabled"] = "SITE_DISABLED";
    ConfluenceLegacyPublicLinkStatus["SpaceBlocked"] = "SPACE_BLOCKED";
    ConfluenceLegacyPublicLinkStatus["SpaceDisabled"] = "SPACE_DISABLED";
    return ConfluenceLegacyPublicLinkStatus;
}({});
let $78ad46e0d6808149$export$9b956743b565355b = /*#__PURE__*/ function(ConfluenceLegacyPublicLinksByCriteriaOrder) {
    ConfluenceLegacyPublicLinksByCriteriaOrder["DateEnabled"] = "DATE_ENABLED";
    ConfluenceLegacyPublicLinksByCriteriaOrder["Status"] = "STATUS";
    ConfluenceLegacyPublicLinksByCriteriaOrder["Title"] = "TITLE";
    return ConfluenceLegacyPublicLinksByCriteriaOrder;
}({});
let $78ad46e0d6808149$export$9e74ac381de41243 = /*#__PURE__*/ function(ConfluenceLegacyPushNotificationGroupInputType) {
    ConfluenceLegacyPushNotificationGroupInputType["None"] = "NONE";
    ConfluenceLegacyPushNotificationGroupInputType["Quiet"] = "QUIET";
    ConfluenceLegacyPushNotificationGroupInputType["Standard"] = "STANDARD";
    return ConfluenceLegacyPushNotificationGroupInputType;
}({});
let $78ad46e0d6808149$export$4b9d765e6088e3c4 = /*#__PURE__*/ function(ConfluenceLegacyPushNotificationSettingGroup) {
    ConfluenceLegacyPushNotificationSettingGroup["Custom"] = "CUSTOM";
    ConfluenceLegacyPushNotificationSettingGroup["None"] = "NONE";
    ConfluenceLegacyPushNotificationSettingGroup["Quiet"] = "QUIET";
    ConfluenceLegacyPushNotificationSettingGroup["Standard"] = "STANDARD";
    return ConfluenceLegacyPushNotificationSettingGroup;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$4490245889e26dee = /*#__PURE__*/ function(ConfluenceLegacyReactionContentType) {
    ConfluenceLegacyReactionContentType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacyReactionContentType["Comment"] = "COMMENT";
    ConfluenceLegacyReactionContentType["Page"] = "PAGE";
    return ConfluenceLegacyReactionContentType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$74f0035aff7ea1c0 = /*#__PURE__*/ function(ConfluenceLegacyRecentFilter) {
    ConfluenceLegacyRecentFilter["All"] = "ALL";
    ConfluenceLegacyRecentFilter["Created"] = "CREATED";
    ConfluenceLegacyRecentFilter["WorkedOn"] = "WORKED_ON";
    return ConfluenceLegacyRecentFilter;
}({});
let $78ad46e0d6808149$export$6875c90eb8212aba = /*#__PURE__*/ function(ConfluenceLegacyRecommendedPagesSpaceBehavior) {
    ConfluenceLegacyRecommendedPagesSpaceBehavior["Hidden"] = "HIDDEN";
    ConfluenceLegacyRecommendedPagesSpaceBehavior["Shown"] = "SHOWN";
    return ConfluenceLegacyRecommendedPagesSpaceBehavior;
}({});
let $78ad46e0d6808149$export$c3e45d6c8873afa5 = /*#__PURE__*/ function(ConfluenceLegacyRelationSourceType) {
    ConfluenceLegacyRelationSourceType["User"] = "user";
    return ConfluenceLegacyRelationSourceType;
}({});
let $78ad46e0d6808149$export$9cbd9eca53d8233e = /*#__PURE__*/ function(ConfluenceLegacyRelationTargetType) {
    ConfluenceLegacyRelationTargetType["Content"] = "content";
    ConfluenceLegacyRelationTargetType["Space"] = "space";
    return ConfluenceLegacyRelationTargetType;
}({});
let $78ad46e0d6808149$export$b7e6e1a18c840b8f = /*#__PURE__*/ function(ConfluenceLegacyRelationType) {
    ConfluenceLegacyRelationType["Collaborator"] = "collaborator";
    ConfluenceLegacyRelationType["Favourite"] = "favourite";
    ConfluenceLegacyRelationType["Touched"] = "touched";
    return ConfluenceLegacyRelationType;
}({});
let $78ad46e0d6808149$export$367b84a88c23075f = /*#__PURE__*/ function(ConfluenceLegacyRelevantUserFilter) {
    ConfluenceLegacyRelevantUserFilter["Collaborators"] = "collaborators";
    return ConfluenceLegacyRelevantUserFilter;
}({});
let $78ad46e0d6808149$export$8b22f13531a8344e = /*#__PURE__*/ function(ConfluenceLegacyRelevantUsersSortOrder) {
    ConfluenceLegacyRelevantUsersSortOrder["Asc"] = "asc";
    ConfluenceLegacyRelevantUsersSortOrder["Desc"] = "desc";
    return ConfluenceLegacyRelevantUsersSortOrder;
}({});
let $78ad46e0d6808149$export$376441298d996eee = /*#__PURE__*/ function(ConfluenceLegacyResponseType) {
    ConfluenceLegacyResponseType["BulletListAdf"] = "BULLET_LIST_ADF";
    ConfluenceLegacyResponseType["BulletListMarkdown"] = "BULLET_LIST_MARKDOWN";
    ConfluenceLegacyResponseType["ParagraphPlaintext"] = "PARAGRAPH_PLAINTEXT";
    return ConfluenceLegacyResponseType;
}({});
let $78ad46e0d6808149$export$7f316768f979019e = /*#__PURE__*/ function(ConfluenceLegacyReverseTrialCohort) {
    ConfluenceLegacyReverseTrialCohort["Control"] = "CONTROL";
    ConfluenceLegacyReverseTrialCohort["Enrolled"] = "ENROLLED";
    ConfluenceLegacyReverseTrialCohort["NotEnrolled"] = "NOT_ENROLLED";
    ConfluenceLegacyReverseTrialCohort["Unassigned"] = "UNASSIGNED";
    ConfluenceLegacyReverseTrialCohort["Unknown"] = "UNKNOWN";
    ConfluenceLegacyReverseTrialCohort["Variant"] = "VARIANT";
    return ConfluenceLegacyReverseTrialCohort;
}({});
let $78ad46e0d6808149$export$3bf4e8049523f596 = /*#__PURE__*/ function(ConfluenceLegacyRevertToLegacyEditorResult) {
    ConfluenceLegacyRevertToLegacyEditorResult["NotReverted"] = "NOT_REVERTED";
    ConfluenceLegacyRevertToLegacyEditorResult["Reverted"] = "REVERTED";
    return ConfluenceLegacyRevertToLegacyEditorResult;
}({});
let $78ad46e0d6808149$export$ef682e8bdb6dbe2e = /*#__PURE__*/ function(ConfluenceLegacyRoleAssignmentPrincipalType) {
    ConfluenceLegacyRoleAssignmentPrincipalType["AccessClass"] = "ACCESS_CLASS";
    ConfluenceLegacyRoleAssignmentPrincipalType["Group"] = "GROUP";
    ConfluenceLegacyRoleAssignmentPrincipalType["Team"] = "TEAM";
    ConfluenceLegacyRoleAssignmentPrincipalType["User"] = "USER";
    return ConfluenceLegacyRoleAssignmentPrincipalType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$e1172c4cec191be2 = /*#__PURE__*/ function(ConfluenceLegacySearchesByTermColumns) {
    ConfluenceLegacySearchesByTermColumns["PageViewedPercentage"] = "pageViewedPercentage";
    ConfluenceLegacySearchesByTermColumns["SearchClickCount"] = "searchClickCount";
    ConfluenceLegacySearchesByTermColumns["SearchSessionCount"] = "searchSessionCount";
    ConfluenceLegacySearchesByTermColumns["SearchTerm"] = "searchTerm";
    ConfluenceLegacySearchesByTermColumns["Total"] = "total";
    ConfluenceLegacySearchesByTermColumns["UniqueUsers"] = "uniqueUsers";
    return ConfluenceLegacySearchesByTermColumns;
}({});
let $78ad46e0d6808149$export$e7d6f21793433a06 = /*#__PURE__*/ function(ConfluenceLegacySearchesByTermPeriod) {
    ConfluenceLegacySearchesByTermPeriod["Day"] = "day";
    ConfluenceLegacySearchesByTermPeriod["Month"] = "month";
    ConfluenceLegacySearchesByTermPeriod["Week"] = "week";
    return ConfluenceLegacySearchesByTermPeriod;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$a199f440cd936cc = /*#__PURE__*/ function(ConfluenceLegacyShareType) {
    ConfluenceLegacyShareType["InviteToEdit"] = "INVITE_TO_EDIT";
    ConfluenceLegacyShareType["SharePage"] = "SHARE_PAGE";
    return ConfluenceLegacyShareType;
}({});
let $78ad46e0d6808149$export$5f5a76dd02b1e8f0 = /*#__PURE__*/ function(ConfluenceLegacySitePermissionOperationType) {
    ConfluenceLegacySitePermissionOperationType["AdministerConfluence"] = "ADMINISTER_CONFLUENCE";
    ConfluenceLegacySitePermissionOperationType["AdministerSystem"] = "ADMINISTER_SYSTEM";
    ConfluenceLegacySitePermissionOperationType["CreateProfileattachment"] = "CREATE_PROFILEATTACHMENT";
    ConfluenceLegacySitePermissionOperationType["CreateSpace"] = "CREATE_SPACE";
    ConfluenceLegacySitePermissionOperationType["ExternalCollaborator"] = "EXTERNAL_COLLABORATOR";
    ConfluenceLegacySitePermissionOperationType["LimitedUseConfluence"] = "LIMITED_USE_CONFLUENCE";
    ConfluenceLegacySitePermissionOperationType["ReadUserprofile"] = "READ_USERPROFILE";
    ConfluenceLegacySitePermissionOperationType["UpdateUserstatus"] = "UPDATE_USERSTATUS";
    ConfluenceLegacySitePermissionOperationType["UseConfluence"] = "USE_CONFLUENCE";
    ConfluenceLegacySitePermissionOperationType["UsePersonalspace"] = "USE_PERSONALSPACE";
    return ConfluenceLegacySitePermissionOperationType;
}({});
let $78ad46e0d6808149$export$c0dc9e525f1888d7 = /*#__PURE__*/ function(ConfluenceLegacySitePermissionType) {
    ConfluenceLegacySitePermissionType["Anonymous"] = "ANONYMOUS";
    ConfluenceLegacySitePermissionType["App"] = "APP";
    ConfluenceLegacySitePermissionType["External"] = "EXTERNAL";
    ConfluenceLegacySitePermissionType["Internal"] = "INTERNAL";
    ConfluenceLegacySitePermissionType["Jsd"] = "JSD";
    return ConfluenceLegacySitePermissionType;
}({});
let $78ad46e0d6808149$export$cacd2625b0eb5c10 = /*#__PURE__*/ function(ConfluenceLegacySitePermissionTypeFilter) {
    ConfluenceLegacySitePermissionTypeFilter["All"] = "ALL";
    ConfluenceLegacySitePermissionTypeFilter["Externalcollaborator"] = "EXTERNALCOLLABORATOR";
    ConfluenceLegacySitePermissionTypeFilter["None"] = "NONE";
    return ConfluenceLegacySitePermissionTypeFilter;
}({}); /** Represents a smart-link on a page */ 
let $78ad46e0d6808149$export$3427a291ccf5b35f = /*#__PURE__*/ function(ConfluenceLegacySpaceAssignmentType) {
    ConfluenceLegacySpaceAssignmentType["Assigned"] = "ASSIGNED";
    ConfluenceLegacySpaceAssignmentType["Unassigned"] = "UNASSIGNED";
    return ConfluenceLegacySpaceAssignmentType;
}({});
let $78ad46e0d6808149$export$66c6ff50e2fe5ded = /*#__PURE__*/ function(ConfluenceLegacySpacePermissionType) {
    ConfluenceLegacySpacePermissionType["AdministerSpace"] = "ADMINISTER_SPACE";
    ConfluenceLegacySpacePermissionType["ArchivePage"] = "ARCHIVE_PAGE";
    ConfluenceLegacySpacePermissionType["Comment"] = "COMMENT";
    ConfluenceLegacySpacePermissionType["CreateAttachment"] = "CREATE_ATTACHMENT";
    ConfluenceLegacySpacePermissionType["CreateEditPage"] = "CREATE_EDIT_PAGE";
    ConfluenceLegacySpacePermissionType["EditBlog"] = "EDIT_BLOG";
    ConfluenceLegacySpacePermissionType["ExportPage"] = "EXPORT_PAGE";
    ConfluenceLegacySpacePermissionType["ExportSpace"] = "EXPORT_SPACE";
    ConfluenceLegacySpacePermissionType["RemoveAttachment"] = "REMOVE_ATTACHMENT";
    ConfluenceLegacySpacePermissionType["RemoveBlog"] = "REMOVE_BLOG";
    ConfluenceLegacySpacePermissionType["RemoveComment"] = "REMOVE_COMMENT";
    ConfluenceLegacySpacePermissionType["RemoveMail"] = "REMOVE_MAIL";
    ConfluenceLegacySpacePermissionType["RemoveOwnContent"] = "REMOVE_OWN_CONTENT";
    ConfluenceLegacySpacePermissionType["RemovePage"] = "REMOVE_PAGE";
    ConfluenceLegacySpacePermissionType["SetPagePermissions"] = "SET_PAGE_PERMISSIONS";
    ConfluenceLegacySpacePermissionType["ViewSpace"] = "VIEW_SPACE";
    return ConfluenceLegacySpacePermissionType;
}({});
let $78ad46e0d6808149$export$f324862e9abce9a4 = /*#__PURE__*/ function(ConfluenceLegacySpaceRoleType) {
    ConfluenceLegacySpaceRoleType["Custom"] = "CUSTOM";
    ConfluenceLegacySpaceRoleType["System"] = "SYSTEM";
    return ConfluenceLegacySpaceRoleType;
}({});
let $78ad46e0d6808149$export$a816519a4452de22 = /*#__PURE__*/ function(ConfluenceLegacySpaceSidebarLinkType) {
    ConfluenceLegacySpaceSidebarLinkType["ExternalLink"] = "EXTERNAL_LINK";
    ConfluenceLegacySpaceSidebarLinkType["Forge"] = "FORGE";
    ConfluenceLegacySpaceSidebarLinkType["PinnedAttachment"] = "PINNED_ATTACHMENT";
    ConfluenceLegacySpaceSidebarLinkType["PinnedBlogPost"] = "PINNED_BLOG_POST";
    ConfluenceLegacySpaceSidebarLinkType["PinnedPage"] = "PINNED_PAGE";
    ConfluenceLegacySpaceSidebarLinkType["PinnedSpace"] = "PINNED_SPACE";
    ConfluenceLegacySpaceSidebarLinkType["PinnedUserInfo"] = "PINNED_USER_INFO";
    ConfluenceLegacySpaceSidebarLinkType["WebItem"] = "WEB_ITEM";
    return ConfluenceLegacySpaceSidebarLinkType;
}({});
let $78ad46e0d6808149$export$4f08231b454021a7 = /*#__PURE__*/ function(ConfluenceLegacySpaceViewsPersistenceOption) {
    ConfluenceLegacySpaceViewsPersistenceOption["Popularity"] = "POPULARITY";
    ConfluenceLegacySpaceViewsPersistenceOption["RecentlyModified"] = "RECENTLY_MODIFIED";
    ConfluenceLegacySpaceViewsPersistenceOption["RecentlyViewed"] = "RECENTLY_VIEWED";
    ConfluenceLegacySpaceViewsPersistenceOption["TitleAz"] = "TITLE_AZ";
    ConfluenceLegacySpaceViewsPersistenceOption["Tree"] = "TREE";
    return ConfluenceLegacySpaceViewsPersistenceOption;
}({});
let $78ad46e0d6808149$export$b1fc899dd9dab99c = /*#__PURE__*/ function(ConfluenceLegacyStalePageStatus) {
    ConfluenceLegacyStalePageStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyStalePageStatus["Current"] = "CURRENT";
    ConfluenceLegacyStalePageStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyStalePageStatus;
}({});
let $78ad46e0d6808149$export$52d6eaeb13b767d7 = /*#__PURE__*/ function(ConfluenceLegacyStalePagesSortingType) {
    ConfluenceLegacyStalePagesSortingType["Asc"] = "ASC";
    ConfluenceLegacyStalePagesSortingType["Desc"] = "DESC";
    return ConfluenceLegacyStalePagesSortingType;
}({});
let $78ad46e0d6808149$export$2ef0672a533512e5 = /*#__PURE__*/ function(ConfluenceLegacySummaryType) {
    ConfluenceLegacySummaryType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacySummaryType["Page"] = "PAGE";
    return ConfluenceLegacySummaryType;
}({});
let $78ad46e0d6808149$export$ac9323de0f6ac2f9 = /*#__PURE__*/ function(ConfluenceLegacySystemSpaceHomepageTemplate) {
    ConfluenceLegacySystemSpaceHomepageTemplate["Eap"] = "EAP";
    ConfluenceLegacySystemSpaceHomepageTemplate["Minimal"] = "MINIMAL";
    ConfluenceLegacySystemSpaceHomepageTemplate["Visual"] = "VISUAL";
    return ConfluenceLegacySystemSpaceHomepageTemplate;
}({});
let $78ad46e0d6808149$export$d926f0433bfa5cfe = /*#__PURE__*/ function(ConfluenceLegacyTaskStatus) {
    ConfluenceLegacyTaskStatus["Checked"] = "CHECKED";
    ConfluenceLegacyTaskStatus["Unchecked"] = "UNCHECKED";
    return ConfluenceLegacyTaskStatus;
}({});
let $78ad46e0d6808149$export$e59d52222a05db4a = /*#__PURE__*/ function(ConfluenceLegacyTeamCalendarDayOfWeek) {
    ConfluenceLegacyTeamCalendarDayOfWeek["Friday"] = "FRIDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Monday"] = "MONDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Saturday"] = "SATURDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Sunday"] = "SUNDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Thursday"] = "THURSDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Tuesday"] = "TUESDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Wednesday"] = "WEDNESDAY";
    return ConfluenceLegacyTeamCalendarDayOfWeek;
}({});
let $78ad46e0d6808149$export$6fa4f21ea723a4cf = /*#__PURE__*/ function(ConfluenceLegacyTemplateContentAppearance) {
    ConfluenceLegacyTemplateContentAppearance["Default"] = "DEFAULT";
    ConfluenceLegacyTemplateContentAppearance["FullWidth"] = "FULL_WIDTH";
    return ConfluenceLegacyTemplateContentAppearance;
}({}); /** Provides template information. Useful for in - editor template gallery and more in the future. */  /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$a883f3365032d0b5 = /*#__PURE__*/ function(ConfluenceMutationContentStatus) {
    ConfluenceMutationContentStatus["Current"] = "CURRENT";
    ConfluenceMutationContentStatus["Draft"] = "DRAFT";
    return ConfluenceMutationContentStatus;
}({});
let $78ad46e0d6808149$export$629c17cb184cb2f = /*#__PURE__*/ function(ConfluenceOperationName) {
    ConfluenceOperationName["Administer"] = "ADMINISTER";
    ConfluenceOperationName["Archive"] = "ARCHIVE";
    ConfluenceOperationName["Copy"] = "COPY";
    ConfluenceOperationName["Create"] = "CREATE";
    ConfluenceOperationName["CreateSpace"] = "CREATE_SPACE";
    ConfluenceOperationName["Delete"] = "DELETE";
    ConfluenceOperationName["Export"] = "EXPORT";
    ConfluenceOperationName["Move"] = "MOVE";
    ConfluenceOperationName["Purge"] = "PURGE";
    ConfluenceOperationName["PurgeVersion"] = "PURGE_VERSION";
    ConfluenceOperationName["Read"] = "READ";
    ConfluenceOperationName["Restore"] = "RESTORE";
    ConfluenceOperationName["RestrictContent"] = "RESTRICT_CONTENT";
    ConfluenceOperationName["Update"] = "UPDATE";
    ConfluenceOperationName["Use"] = "USE";
    return ConfluenceOperationName;
}({});
let $78ad46e0d6808149$export$406af9bbda9174f7 = /*#__PURE__*/ function(ConfluenceOperationTarget) {
    ConfluenceOperationTarget["Application"] = "APPLICATION";
    ConfluenceOperationTarget["Attachment"] = "ATTACHMENT";
    ConfluenceOperationTarget["BlogPost"] = "BLOG_POST";
    ConfluenceOperationTarget["Comment"] = "COMMENT";
    ConfluenceOperationTarget["Page"] = "PAGE";
    ConfluenceOperationTarget["Space"] = "SPACE";
    ConfluenceOperationTarget["UserProfile"] = "USER_PROFILE";
    return ConfluenceOperationTarget;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:page:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$b9563c27e132ecf3 = /*#__PURE__*/ function(ConfluencePageStatus) {
    ConfluencePageStatus["Archived"] = "ARCHIVED";
    ConfluencePageStatus["Current"] = "CURRENT";
    ConfluencePageStatus["Deleted"] = "DELETED";
    ConfluencePageStatus["Draft"] = "DRAFT";
    ConfluencePageStatus["Historical"] = "HISTORICAL";
    ConfluencePageStatus["Trashed"] = "TRASHED";
    return ConfluencePageStatus;
}({});
let $78ad46e0d6808149$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["Live"] = "LIVE";
    return ConfluencePageSubType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$d939b611ae8d039c = /*#__PURE__*/ function(ConfluenceSpaceSettingEditorVersion) {
    ConfluenceSpaceSettingEditorVersion["V1"] = "V1";
    ConfluenceSpaceSettingEditorVersion["V2"] = "V2";
    return ConfluenceSpaceSettingEditorVersion;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:space.setting:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$2607d60870895ed3 = /*#__PURE__*/ function(ConfluenceSpaceStatus) {
    ConfluenceSpaceStatus["Archived"] = "ARCHIVED";
    ConfluenceSpaceStatus["Current"] = "CURRENT";
    return ConfluenceSpaceStatus;
}({});
let $78ad46e0d6808149$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["Global"] = "GLOBAL";
    ConfluenceSpaceType["Personal"] = "PERSONAL";
    return ConfluenceSpaceType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:user:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$5053ac532e22e9b7 = /*#__PURE__*/ function(ConfluenceUserType) {
    ConfluenceUserType["Anonymous"] = "ANONYMOUS";
    ConfluenceUserType["Known"] = "KNOWN";
    return ConfluenceUserType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:space:confluence__
 * * __confluence:atlassian-external__
 */ 
let $78ad46e0d6808149$export$62c53e2e83119144 = /*#__PURE__*/ function(ContentPlatformBooleanOperators) {
    ContentPlatformBooleanOperators["And"] = "AND";
    ContentPlatformBooleanOperators["Or"] = "OR";
    return ContentPlatformBooleanOperators;
}({});
let $78ad46e0d6808149$export$70152384a4eb0e06 = /*#__PURE__*/ function(ContentPlatformFieldNames) {
    ContentPlatformFieldNames["Description"] = "DESCRIPTION";
    ContentPlatformFieldNames["Title"] = "TITLE";
    return ContentPlatformFieldNames;
}({});
let $78ad46e0d6808149$export$c05e625f37f1df6a = /*#__PURE__*/ function(ContentPlatformOperators) {
    ContentPlatformOperators["All"] = "ALL";
    ContentPlatformOperators["Any"] = "ANY";
    return ContentPlatformOperators;
}({});
let $78ad46e0d6808149$export$e4bac19bb31c7d1 = /*#__PURE__*/ function(ContentPlatformSearchTypes) {
    ContentPlatformSearchTypes["Contains"] = "CONTAINS";
    ContentPlatformSearchTypes["ExactMatch"] = "EXACT_MATCH";
    return ContentPlatformSearchTypes;
}({}); /** Response from creating a deployment */  /** Response from creating an app deployment url */  /** Response from creating an app environment */  /** Response from creating an app */  /** A response to a tunnel creation request */  /**
 * Establish tunnels for a specific environment of an app.
 *
 * This will redirect all function calls to the provided faas url. This URL must implement the same
 * invocation contract that is used elsewhere in Xen.
 *
 * This will also be used to redirect Custom UI product rendering to the custom ui urls. We separate
 * them by extension key.
 */ 
let $78ad46e0d6808149$export$2f3f99f16bab5cdf = /*#__PURE__*/ function(CustomEntityAttributeType) {
    CustomEntityAttributeType["Any"] = "any";
    CustomEntityAttributeType["Boolean"] = "boolean";
    CustomEntityAttributeType["Float"] = "float";
    CustomEntityAttributeType["Integer"] = "integer";
    CustomEntityAttributeType["String"] = "string";
    return CustomEntityAttributeType;
}({}); /** Definition of an existing custom entity when queried */  /** Definition of an existing custom entity index when queried */ 
let $78ad46e0d6808149$export$54f78149dae8a06c = /*#__PURE__*/ function(CustomEntityIndexStatus) {
    CustomEntityIndexStatus["Active"] = "ACTIVE";
    CustomEntityIndexStatus["Creating"] = "CREATING";
    CustomEntityIndexStatus["Inactive"] = "INACTIVE";
    CustomEntityIndexStatus["Pending"] = "PENDING";
    return CustomEntityIndexStatus;
}({}); /** Generic implementation of MutationResponse for responses that don't need any extra data */ 
let $78ad46e0d6808149$export$aecc53098eb55beb = /*#__PURE__*/ function(CustomEntityStatus) {
    CustomEntityStatus["Active"] = "ACTIVE";
    CustomEntityStatus["Inactive"] = "INACTIVE";
    return CustomEntityStatus;
}({}); /**
 * The customer service organization attribute
 * DEPRECATED: use CustomerServiceCustomDetail instead.
 */ 
let $78ad46e0d6808149$export$17ade050935780b6 = /*#__PURE__*/ function(CustomerServiceAttributeTypeName) {
    CustomerServiceAttributeTypeName["Boolean"] = "BOOLEAN";
    CustomerServiceAttributeTypeName["Date"] = "DATE";
    CustomerServiceAttributeTypeName["Email"] = "EMAIL";
    CustomerServiceAttributeTypeName["Multiselect"] = "MULTISELECT";
    CustomerServiceAttributeTypeName["Number"] = "NUMBER";
    CustomerServiceAttributeTypeName["Phone"] = "PHONE";
    CustomerServiceAttributeTypeName["Select"] = "SELECT";
    CustomerServiceAttributeTypeName["Text"] = "TEXT";
    CustomerServiceAttributeTypeName["Url"] = "URL";
    CustomerServiceAttributeTypeName["User"] = "USER";
    return CustomerServiceAttributeTypeName;
}({}); /** DEPRECATED: use CustomerServiceCustomDetailUpdateInput instead. */  /** DEPRECATED: use CustomerServiceCustomDetailUpdatePayload instead. */  /** DEPRECATED: use CustomerServiceCustomDetailUpdateTypeInput instead. */  /**
 * The customer service organization attribute with a value
 * DEPRECATED: use CustomerServiceCustomDetailValue instead.
 */ 
let $78ad46e0d6808149$export$98afe1d41a26dd3b = /*#__PURE__*/ function(CustomerServiceContextType) {
    CustomerServiceContextType["Default"] = "DEFAULT";
    CustomerServiceContextType["Issue"] = "ISSUE";
    return CustomerServiceContextType;
}({}); /** The customer service entity custom detail */  /** Config metadata for a custom detail */ 
let $78ad46e0d6808149$export$65378626fab83b8 = /*#__PURE__*/ function(CustomerServiceCustomDetailCreateErrorCode) {
    CustomerServiceCustomDetailCreateErrorCode["ColorNotSaved"] = "COLOR_NOT_SAVED";
    return CustomerServiceCustomDetailCreateErrorCode;
}({}); /**
 * #########################
 *  Error extensions
 * #########################
 */ 
let $78ad46e0d6808149$export$b39410ef8fd0f614 = /*#__PURE__*/ function(CustomerServiceCustomDetailTypeName) {
    CustomerServiceCustomDetailTypeName["Boolean"] = "BOOLEAN";
    CustomerServiceCustomDetailTypeName["Date"] = "DATE";
    CustomerServiceCustomDetailTypeName["Email"] = "EMAIL";
    CustomerServiceCustomDetailTypeName["Multiselect"] = "MULTISELECT";
    CustomerServiceCustomDetailTypeName["Number"] = "NUMBER";
    CustomerServiceCustomDetailTypeName["Phone"] = "PHONE";
    CustomerServiceCustomDetailTypeName["Select"] = "SELECT";
    CustomerServiceCustomDetailTypeName["Text"] = "TEXT";
    CustomerServiceCustomDetailTypeName["Url"] = "URL";
    CustomerServiceCustomDetailTypeName["User"] = "USER";
    return CustomerServiceCustomDetailTypeName;
}({}); /** The customer service organization attribute with a value */  /** The customer service custom details defined on an entity */  /** The available entities */ 
let $78ad46e0d6808149$export$c8c77ee10baacd37 = /*#__PURE__*/ function(CustomerServiceCustomDetailsEntityType) {
    CustomerServiceCustomDetailsEntityType["Customer"] = "CUSTOMER";
    CustomerServiceCustomDetailsEntityType["Entitlement"] = "ENTITLEMENT";
    CustomerServiceCustomDetailsEntityType["Organization"] = "ORGANIZATION";
    return CustomerServiceCustomDetailsEntityType;
}({}); /**
 * #########################
 *  Query Responses
 * #########################
 */ 
let $78ad46e0d6808149$export$c982791253b48a4e = /*#__PURE__*/ function(CustomerServiceLinkEntityType) {
    CustomerServiceLinkEntityType["Customer"] = "CUSTOMER";
    CustomerServiceLinkEntityType["Organization"] = "ORGANIZATION";
    return CustomerServiceLinkEntityType;
}({}); /**
 * #########################
 *  Query Responses
 * #########################
 */ 
let $78ad46e0d6808149$export$beae497f7881e8b9 = /*#__PURE__*/ function(CustomerServiceNoteEntity) {
    CustomerServiceNoteEntity["Customer"] = "CUSTOMER";
    CustomerServiceNoteEntity["Organization"] = "ORGANIZATION";
    return CustomerServiceNoteEntity;
}({}); /**
 * ###############################
 *  Base objects for notes
 * ###############################
 */ 
let $78ad46e0d6808149$export$950a886e1d68d5 = /*#__PURE__*/ function(CustomerServicePermissionGroupType) {
    CustomerServicePermissionGroupType["Admins"] = "ADMINS";
    CustomerServicePermissionGroupType["AdminsAgents"] = "ADMINS_AGENTS";
    CustomerServicePermissionGroupType["AdminsAgentsCollaborators"] = "ADMINS_AGENTS_COLLABORATORS";
    return CustomerServicePermissionGroupType;
}({}); /**
 * ###############################
 *  Base objects for platform values
 * ###############################
 *  Note: Add any additional platform values to this union
 */ 
let $78ad46e0d6808149$export$94dacf0afef67abf = /*#__PURE__*/ function(DataClassificationPolicyDecisionStatus) {
    DataClassificationPolicyDecisionStatus["Allowed"] = "ALLOWED";
    DataClassificationPolicyDecisionStatus["Blocked"] = "BLOCKED";
    return DataClassificationPolicyDecisionStatus;
}({});
let $78ad46e0d6808149$export$e3d8cf42d600c426 = /*#__PURE__*/ function(DataResidencyResponse) {
    DataResidencyResponse["AppDoesNotSupportDr"] = "APP_DOES_NOT_SUPPORT_DR";
    DataResidencyResponse["NotApplicable"] = "NOT_APPLICABLE";
    DataResidencyResponse["StoredExternalToAtlassian"] = "STORED_EXTERNAL_TO_ATLASSIAN";
    DataResidencyResponse["StoredInAtlassianAndDrNotSupported"] = "STORED_IN_ATLASSIAN_AND_DR_NOT_SUPPORTED";
    DataResidencyResponse["StoredInAtlassianAndDrSupported"] = "STORED_IN_ATLASSIAN_AND_DR_SUPPORTED";
    return DataResidencyResponse;
}({}); /** Time ranges of invocation date. */  /** Response from deleting an app */  /** Generic implementation of MutationResponse for responses that don't need any extra data */  /** Accepts input to delete an external alias. */  /** The payload returned from deleting the external alias of a component. */  /** Accepts input for deleting an existing component. */  /** Accepts input to delete a component link. */  /** The payload retuned after deleting a component link. */  /** The payload returned from deleting an existing component. */  /** Input to delete a component type. */  /** The payload returned after deleting the component type. */  /** Accepts input for deleting an existing relationship between two components. */  /** The payload returned from deleting an existing component. */  /** The payload returned from deleting a scorecard criterion. */  /** Accepts input for deleting a starred component. */  /** Payload returned from deleting a starred component. */  /** Input to delete an individual user defined parameter. */  /** The request input for deleting relationship properties */  /** The response payload of deleting DevOps Service Entity Properties */  /** The request input for deleting a relationship between a DevOps Service and a Jira Project */  /** The request input for deleting a relationship between a DevOps Service and an Opsgenie Team */  /** The response payload of deleting a relationship between a DevOps Service and an Opsgenie Team */  /** The request input for deleting a relationship between a DevOps Service and a Repository */  /** The request input for deleting DevOps Service Entity Properties */  /** The response payload of deleting DevOps Service Entity Properties */  /** The request input for deleting a DevOps Service */  /** The response payload of deleting a DevOps Service */  /** The request input for deleting a DevOps Service Relationship */  /** The request input for deleting a relationship between a Jira project and a repository */  /** Delete sprint */  /** Response from creating an webtrigger url */  /**
 * This object models the Continuous Delivery (CD) Pipeline concept, an automated process (usually comprised of multiple stages)
 * for getting software from version control right through to the production environment.
 */ 
let $78ad46e0d6808149$export$a12a01ce2571070a = /*#__PURE__*/ function(DeploymentState) {
    DeploymentState["Cancelled"] = "CANCELLED";
    DeploymentState["Failed"] = "FAILED";
    DeploymentState["InProgress"] = "IN_PROGRESS";
    DeploymentState["Pending"] = "PENDING";
    DeploymentState["RolledBack"] = "ROLLED_BACK";
    DeploymentState["Successful"] = "SUCCESSFUL";
    DeploymentState["Unknown"] = "UNKNOWN";
    return DeploymentState;
}({}); /**
 * This object models a deployment in the Continuous Delivery (CD) Pipeline concept, an automated process (usually comprised of
 * multiple stages) for getting software from version control right through to the production environment.
 */ 
let $78ad46e0d6808149$export$63bd3fb0666e773f = /*#__PURE__*/ function(DevAiAutofixScanSortField) {
    DevAiAutofixScanSortField["StartDate"] = "START_DATE";
    return DevAiAutofixScanSortField;
}({});
let $78ad46e0d6808149$export$f25325441f229f64 = /*#__PURE__*/ function(DevAiAutofixScanStatus) {
    DevAiAutofixScanStatus["Completed"] = "COMPLETED";
    DevAiAutofixScanStatus["Failed"] = "FAILED";
    DevAiAutofixScanStatus["InProgress"] = "IN_PROGRESS";
    return DevAiAutofixScanStatus;
}({});
let $78ad46e0d6808149$export$d09e4c4b79589a66 = /*#__PURE__*/ function(DevAiAutofixTaskSortField) {
    DevAiAutofixTaskSortField["CreatedAt"] = "CREATED_AT";
    DevAiAutofixTaskSortField["Filename"] = "FILENAME";
    DevAiAutofixTaskSortField["NewCoveragePercentage"] = "NEW_COVERAGE_PERCENTAGE";
    DevAiAutofixTaskSortField["PreviousCoveragePercentage"] = "PREVIOUS_COVERAGE_PERCENTAGE";
    DevAiAutofixTaskSortField["PrimaryLanguage"] = "PRIMARY_LANGUAGE";
    DevAiAutofixTaskSortField["Status"] = "STATUS";
    DevAiAutofixTaskSortField["UpdatedAt"] = "UPDATED_AT";
    return DevAiAutofixTaskSortField;
}({});
let $78ad46e0d6808149$export$265f04bd9f283d5d = /*#__PURE__*/ function(DevAiAutofixTaskStatus) {
    DevAiAutofixTaskStatus["PrDeclined"] = "PR_DECLINED";
    DevAiAutofixTaskStatus["PrMerged"] = "PR_MERGED";
    DevAiAutofixTaskStatus["PrOpened"] = "PR_OPENED";
    DevAiAutofixTaskStatus["WorkflowCancelled"] = "WORKFLOW_CANCELLED";
    DevAiAutofixTaskStatus["WorkflowCompleted"] = "WORKFLOW_COMPLETED";
    DevAiAutofixTaskStatus["WorkflowInprogress"] = "WORKFLOW_INPROGRESS";
    DevAiAutofixTaskStatus["WorkflowPending"] = "WORKFLOW_PENDING";
    return DevAiAutofixTaskStatus;
}({});
let $78ad46e0d6808149$export$e81a3fe0d2b413f = /*#__PURE__*/ function(DevAiScanIntervalUnit) {
    DevAiScanIntervalUnit["Days"] = "DAYS";
    DevAiScanIntervalUnit["Months"] = "MONTHS";
    DevAiScanIntervalUnit["Weeks"] = "WEEKS";
    return DevAiScanIntervalUnit;
}({}); /** Input to enable/disable Autofix for a repository. */ 
let $78ad46e0d6808149$export$bfbfde65991aaecf = /*#__PURE__*/ function(DevAiSupportedRepoFilterOption) {
    DevAiSupportedRepoFilterOption["All"] = "ALL";
    DevAiSupportedRepoFilterOption["DisabledOnly"] = "DISABLED_ONLY";
    DevAiSupportedRepoFilterOption["EnabledOnly"] = "ENABLED_ONLY";
    return DevAiSupportedRepoFilterOption;
}({}); /** Input to trigger an autofix scan of a repository */  /** The return payload for triggering an Autofix repository Scan */  /** Data-Depot Build Provider details. */  /** Data-Depot Build Provider details. */  /** The state of a build. */ 
let $78ad46e0d6808149$export$38ae85b0603265fc = /*#__PURE__*/ function(DevOpsBuildState) {
    DevOpsBuildState["Cancelled"] = "CANCELLED";
    DevOpsBuildState["Failed"] = "FAILED";
    DevOpsBuildState["InProgress"] = "IN_PROGRESS";
    DevOpsBuildState["Pending"] = "PENDING";
    DevOpsBuildState["Successful"] = "SUCCESSFUL";
    DevOpsBuildState["Unknown"] = "UNKNOWN";
    return DevOpsBuildState;
}({});
let $78ad46e0d6808149$export$e81f0008646134d2 = /*#__PURE__*/ function(DevOpsComponentTier) {
    DevOpsComponentTier["Tier_1"] = "TIER_1";
    DevOpsComponentTier["Tier_2"] = "TIER_2";
    DevOpsComponentTier["Tier_3"] = "TIER_3";
    DevOpsComponentTier["Tier_4"] = "TIER_4";
    return DevOpsComponentTier;
}({});
let $78ad46e0d6808149$export$1ecef45184e0481 = /*#__PURE__*/ function(DevOpsComponentType) {
    DevOpsComponentType["Application"] = "APPLICATION";
    DevOpsComponentType["Capability"] = "CAPABILITY";
    DevOpsComponentType["CloudResource"] = "CLOUD_RESOURCE";
    DevOpsComponentType["DataPipeline"] = "DATA_PIPELINE";
    DevOpsComponentType["Library"] = "LIBRARY";
    DevOpsComponentType["MachineLearningModel"] = "MACHINE_LEARNING_MODEL";
    DevOpsComponentType["Other"] = "OTHER";
    DevOpsComponentType["Service"] = "SERVICE";
    DevOpsComponentType["UiElement"] = "UI_ELEMENT";
    DevOpsComponentType["Website"] = "WEBSITE";
    return DevOpsComponentType;
}({}); /** Data-Depot Component Provider details. */  /** Data-Depot Component Provider details. */  /** Data-Depot Component Provider details. */  /** Data-Depot Deployment Provider details. */  /** Data-Depot Deployment Provider details. */  /** ## Data Depot Designs ### */  /** ## Data Depot Designs ### */  /** ## Data Depot Designs ### */  /** Data-Depot Design Provider details. */  /** Data-Depot Design Provider details. */ 
let $78ad46e0d6808149$export$8e9c2240003b2ba6 = /*#__PURE__*/ function(DevOpsDesignStatus) {
    DevOpsDesignStatus["None"] = "NONE";
    DevOpsDesignStatus["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    DevOpsDesignStatus["Unknown"] = "UNKNOWN";
    return DevOpsDesignStatus;
}({});
let $78ad46e0d6808149$export$279a4200dae77ac6 = /*#__PURE__*/ function(DevOpsDesignType) {
    DevOpsDesignType["Canvas"] = "CANVAS";
    DevOpsDesignType["File"] = "FILE";
    DevOpsDesignType["Group"] = "GROUP";
    DevOpsDesignType["Node"] = "NODE";
    DevOpsDesignType["Other"] = "OTHER";
    DevOpsDesignType["Prototype"] = "PROTOTYPE";
    return DevOpsDesignType;
}({}); /** Data-Depot Dev Info Provider details. */  /** Data-Depot Dev Info Provider details. */  /** Data-Depot Dev Info Provider details. */  /** Document Category */ 
let $78ad46e0d6808149$export$eeb884a29ae659e4 = /*#__PURE__*/ function(DevOpsDocumentCategory) {
    DevOpsDocumentCategory["Archive"] = "ARCHIVE";
    DevOpsDocumentCategory["Audio"] = "AUDIO";
    DevOpsDocumentCategory["Code"] = "CODE";
    DevOpsDocumentCategory["Document"] = "DOCUMENT";
    DevOpsDocumentCategory["Folder"] = "FOLDER";
    DevOpsDocumentCategory["Form"] = "FORM";
    DevOpsDocumentCategory["Image"] = "IMAGE";
    DevOpsDocumentCategory["Other"] = "OTHER";
    DevOpsDocumentCategory["Pdf"] = "PDF";
    DevOpsDocumentCategory["Presentation"] = "PRESENTATION";
    DevOpsDocumentCategory["Shortcut"] = "SHORTCUT";
    DevOpsDocumentCategory["Spreadsheet"] = "SPREADSHEET";
    DevOpsDocumentCategory["Video"] = "VIDEO";
    return DevOpsDocumentCategory;
}({}); /** Data-Depot Documentation Provider details. */  /** Data-Depot Documentation Provider details. */  /** Data-Depot Documentation Provider details. */  /**
 * An environment that a code change can be released to.
 *
 * The release may be via a code deployment or via a feature flag change.
 */ 
let $78ad46e0d6808149$export$d897dc8d29fd16eb = /*#__PURE__*/ function(DevOpsEnvironmentCategory) {
    DevOpsEnvironmentCategory["Development"] = "DEVELOPMENT";
    DevOpsEnvironmentCategory["Production"] = "PRODUCTION";
    DevOpsEnvironmentCategory["Staging"] = "STAGING";
    DevOpsEnvironmentCategory["Testing"] = "TESTING";
    DevOpsEnvironmentCategory["Unmapped"] = "UNMAPPED";
    return DevOpsEnvironmentCategory;
}({});
let $78ad46e0d6808149$export$651219dc3d44cf93 = /*#__PURE__*/ function(DevOpsJiraProjectType) {
    DevOpsJiraProjectType["JiraCore"] = "JIRA_CORE";
    DevOpsJiraProjectType["JiraServicedesk"] = "JIRA_SERVICEDESK";
    DevOpsJiraProjectType["JiraSoftware"] = "JIRA_SOFTWARE";
    return DevOpsJiraProjectType;
}({});
let $78ad46e0d6808149$export$18fde50976ec82dd = /*#__PURE__*/ function(DevOpsMetricsCycleTimePhase) {
    DevOpsMetricsCycleTimePhase["CommitToDeployment"] = "COMMIT_TO_DEPLOYMENT";
    DevOpsMetricsCycleTimePhase["CommitToPr"] = "COMMIT_TO_PR";
    return DevOpsMetricsCycleTimePhase;
}({}); /** #### Response ##### */  /** No results will be returned unless an association type is specified. Currently only 'jiraProjectIds' association type is supported. */  /** No results will be returned unless an association type is specified. Currently only 'jiraProjectIds' association type is supported. */  /** No results will be returned unless an association type is specified. Currently only 'jiraProjectIds' association type is supported. */  /** Unit for specified resolution value. */ 
let $78ad46e0d6808149$export$1f082d6bdd7f11d5 = /*#__PURE__*/ function(DevOpsMetricsResolutionUnit) {
    DevOpsMetricsResolutionUnit["Day"] = "DAY";
    DevOpsMetricsResolutionUnit["Hour"] = "HOUR";
    DevOpsMetricsResolutionUnit["Week"] = "WEEK";
    return DevOpsMetricsResolutionUnit;
}({});
let $78ad46e0d6808149$export$fdde013eb4eeffed = /*#__PURE__*/ function(DevOpsMetricsRollupOption) {
    DevOpsMetricsRollupOption["Mean"] = "MEAN";
    DevOpsMetricsRollupOption["Percentile"] = "PERCENTILE";
    return DevOpsMetricsRollupOption;
}({});
let $78ad46e0d6808149$export$ab7231643ddbb509 = /*#__PURE__*/ function(DevOpsOperationsIncidentSeverity) {
    DevOpsOperationsIncidentSeverity["P1"] = "P1";
    DevOpsOperationsIncidentSeverity["P2"] = "P2";
    DevOpsOperationsIncidentSeverity["P3"] = "P3";
    DevOpsOperationsIncidentSeverity["P4"] = "P4";
    DevOpsOperationsIncidentSeverity["P5"] = "P5";
    DevOpsOperationsIncidentSeverity["Pending"] = "PENDING";
    DevOpsOperationsIncidentSeverity["Unknown"] = "UNKNOWN";
    return DevOpsOperationsIncidentSeverity;
}({});
let $78ad46e0d6808149$export$3ef3f18ee7a943de = /*#__PURE__*/ function(DevOpsOperationsIncidentStatus) {
    DevOpsOperationsIncidentStatus["Open"] = "OPEN";
    DevOpsOperationsIncidentStatus["Resolved"] = "RESOLVED";
    DevOpsOperationsIncidentStatus["Unknown"] = "UNKNOWN";
    return DevOpsOperationsIncidentStatus;
}({}); /** Data-Depot Operations Provider details. */  /** Data-Depot Operations Provider details. */  /** Data-Depot Operations Provider details. */ 
let $78ad46e0d6808149$export$1c5eb757d029c7d0 = /*#__PURE__*/ function(DevOpsPostIncidentReviewStatus) {
    DevOpsPostIncidentReviewStatus["Completed"] = "COMPLETED";
    DevOpsPostIncidentReviewStatus["InProgress"] = "IN_PROGRESS";
    DevOpsPostIncidentReviewStatus["Todo"] = "TODO";
    return DevOpsPostIncidentReviewStatus;
}({});
let $78ad46e0d6808149$export$8fd61af3426661d5 = /*#__PURE__*/ function(DevOpsProjectStatus) {
    DevOpsProjectStatus["Cancelled"] = "CANCELLED";
    DevOpsProjectStatus["Completed"] = "COMPLETED";
    DevOpsProjectStatus["InProgress"] = "IN_PROGRESS";
    DevOpsProjectStatus["Paused"] = "PAUSED";
    DevOpsProjectStatus["Pending"] = "PENDING";
    DevOpsProjectStatus["Unknown"] = "UNKNOWN";
    return DevOpsProjectStatus;
}({});
let $78ad46e0d6808149$export$3ba9c1ac88495bed = /*#__PURE__*/ function(DevOpsProjectTargetDateType) {
    DevOpsProjectTargetDateType["Day"] = "DAY";
    DevOpsProjectTargetDateType["Month"] = "MONTH";
    DevOpsProjectTargetDateType["Quarter"] = "QUARTER";
    DevOpsProjectTargetDateType["Unknown"] = "UNKNOWN";
    return DevOpsProjectTargetDateType;
}({}); /** A provider that a deployment has been done with. */  /** A type to group various URLs of Provider */ 
let $78ad46e0d6808149$export$2190b10e3dc81d80 = /*#__PURE__*/ function(DevOpsProviderNamespace) {
    DevOpsProviderNamespace["Asap"] = "ASAP";
    DevOpsProviderNamespace["Classic"] = "CLASSIC";
    DevOpsProviderNamespace["Forge"] = "FORGE";
    DevOpsProviderNamespace["Oauth"] = "OAUTH";
    return DevOpsProviderNamespace;
}({}); /**
 * Type of a data-depot provider.
 * A provider may belongs to multiple types (e.g an connect-app can send both build and deployment info).
 */ 
let $78ad46e0d6808149$export$e0671d592d4ff2a3 = /*#__PURE__*/ function(DevOpsProviderType) {
    DevOpsProviderType["Build"] = "BUILD";
    DevOpsProviderType["Deployment"] = "DEPLOYMENT";
    DevOpsProviderType["Design"] = "DESIGN";
    DevOpsProviderType["DevopsComponents"] = "DEVOPS_COMPONENTS";
    DevOpsProviderType["DevInfo"] = "DEV_INFO";
    DevOpsProviderType["Documentation"] = "DOCUMENTATION";
    DevOpsProviderType["FeatureFlag"] = "FEATURE_FLAG";
    DevOpsProviderType["Operations"] = "OPERATIONS";
    DevOpsProviderType["Project"] = "PROJECT";
    DevOpsProviderType["RemoteLinks"] = "REMOTE_LINKS";
    DevOpsProviderType["Security"] = "SECURITY";
    return DevOpsProviderType;
}({});
let $78ad46e0d6808149$export$4ccf930134e74702 = /*#__PURE__*/ function(DevOpsPullRequestApprovalStatus) {
    DevOpsPullRequestApprovalStatus["Approved"] = "APPROVED";
    DevOpsPullRequestApprovalStatus["Needswork"] = "NEEDSWORK";
    DevOpsPullRequestApprovalStatus["Unapproved"] = "UNAPPROVED";
    return DevOpsPullRequestApprovalStatus;
}({});
let $78ad46e0d6808149$export$4dec602c1ab1d95e = /*#__PURE__*/ function(DevOpsPullRequestStatus) {
    DevOpsPullRequestStatus["Declined"] = "DECLINED";
    DevOpsPullRequestStatus["Draft"] = "DRAFT";
    DevOpsPullRequestStatus["Merged"] = "MERGED";
    DevOpsPullRequestStatus["Open"] = "OPEN";
    DevOpsPullRequestStatus["Unknown"] = "UNKNOWN";
    return DevOpsPullRequestStatus;
}({});
let $78ad46e0d6808149$export$13a31923d75e3a27 = /*#__PURE__*/ function(DevOpsRelationshipCertainty) {
    DevOpsRelationshipCertainty["Explicit"] = "EXPLICIT";
    DevOpsRelationshipCertainty["Implicit"] = "IMPLICIT";
    return DevOpsRelationshipCertainty;
}({});
let $78ad46e0d6808149$export$c5657a9969e35205 = /*#__PURE__*/ function(DevOpsRelationshipCertaintyFilter) {
    DevOpsRelationshipCertaintyFilter["All"] = "ALL";
    DevOpsRelationshipCertaintyFilter["Explicit"] = "EXPLICIT";
    DevOpsRelationshipCertaintyFilter["Implicit"] = "IMPLICIT";
    return DevOpsRelationshipCertaintyFilter;
}({}); /** Data-Depot Remote Links Provider details. */  /** Data-Depot Remote Links Provider details. */ 
let $78ad46e0d6808149$export$15a0db675256459b = /*#__PURE__*/ function(DevOpsRepositoryHostingProviderFilter) {
    DevOpsRepositoryHostingProviderFilter["All"] = "ALL";
    DevOpsRepositoryHostingProviderFilter["BitbucketCloud"] = "BITBUCKET_CLOUD";
    DevOpsRepositoryHostingProviderFilter["ThirdParty"] = "THIRD_PARTY";
    return DevOpsRepositoryHostingProviderFilter;
}({}); /** Data-Depot Security Provider details. */  /** Data-Depot Security Provider details. */  /** Data-Depot Security Provider details. */  /** Data-Depot Security Provider details. */  /** Data-Depot Security Provider details. */  /** ## Data Depot Security Vulnerabilities ### */  /** ## Data Depot Security Vulnerabilities ### */ 
let $78ad46e0d6808149$export$24e732e98f25b4d9 = /*#__PURE__*/ function(DevOpsSecurityVulnerabilitySeverity) {
    DevOpsSecurityVulnerabilitySeverity["Critical"] = "CRITICAL";
    DevOpsSecurityVulnerabilitySeverity["High"] = "HIGH";
    DevOpsSecurityVulnerabilitySeverity["Low"] = "LOW";
    DevOpsSecurityVulnerabilitySeverity["Medium"] = "MEDIUM";
    DevOpsSecurityVulnerabilitySeverity["Unknown"] = "UNKNOWN";
    return DevOpsSecurityVulnerabilitySeverity;
}({});
let $78ad46e0d6808149$export$a1202d25589419a7 = /*#__PURE__*/ function(DevOpsSecurityVulnerabilityStatus) {
    DevOpsSecurityVulnerabilityStatus["Closed"] = "CLOSED";
    DevOpsSecurityVulnerabilityStatus["Ignored"] = "IGNORED";
    DevOpsSecurityVulnerabilityStatus["Open"] = "OPEN";
    DevOpsSecurityVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return DevOpsSecurityVulnerabilityStatus;
}({}); /** A relationship between DevOps Service and Jira Project Team */  /** A relationship between DevOps Service and Jira Project Team */ 
let $78ad46e0d6808149$export$82bbaba9292627e1 = /*#__PURE__*/ function(DevOpsServiceAndJiraProjectRelationshipType) {
    DevOpsServiceAndJiraProjectRelationshipType["ChangeManagement"] = "CHANGE_MANAGEMENT";
    DevOpsServiceAndJiraProjectRelationshipType["Default"] = "DEFAULT";
    return DevOpsServiceAndJiraProjectRelationshipType;
}({}); /** A relationship between DevOps Service and Opsgenie Team */  /** A relationship between DevOps Service and Opsgenie Team */  /** A relationship between a DevOps Service and a Repository */  /** A relationship between a DevOps Service and a Repository */ 
let $78ad46e0d6808149$export$c3e0b3161314e204 = /*#__PURE__*/ function(DevOpsServiceAndRepositoryRelationshipSortBy) {
    DevOpsServiceAndRepositoryRelationshipSortBy["LastInferredAt"] = "LAST_INFERRED_AT";
    return DevOpsServiceAndRepositoryRelationshipSortBy;
}({}); /** The connection object for a collection of Services. */  /** The request input for DevOps Service Entity Property */  /** The connection object for a collection of DevOps Service relationships. */  /** #################### Enums ##################### */ 
let $78ad46e0d6808149$export$cd3c7b586cbb9da5 = /*#__PURE__*/ function(DevOpsServiceRelationshipType) {
    DevOpsServiceRelationshipType["Contains"] = "CONTAINS";
    DevOpsServiceRelationshipType["DependsOn"] = "DEPENDS_ON";
    return DevOpsServiceRelationshipType;
}({}); /** The filtering input for retrieving services. tierLevelIn must not be empty if provided. */  /** Summary of the builds associated with an entity. */  /** #################### Supporting Types ##################### */  /** Represents a product or tool in a DevOps suite */  /** Represents a product or tool in a DevOps suite */  /** Represents a product or tool in a DevOps suite */  /** Represents a product or tool in a DevOps suite */  /** ######################################### Mutations ########################################## */  /** The integration details for the DevOps tool */  /** A marketplace app integration */  /** An Atlassian product integration */ 
let $78ad46e0d6808149$export$b4d01a63edd297ec = /*#__PURE__*/ function(DevOpsToolIntegrationType) {
    DevOpsToolIntegrationType["Any"] = "ANY";
    DevOpsToolIntegrationType["App"] = "APP";
    DevOpsToolIntegrationType["Exists"] = "EXISTS";
    DevOpsToolIntegrationType["None"] = "NONE";
    DevOpsToolIntegrationType["Product"] = "PRODUCT";
    return DevOpsToolIntegrationType;
}({});
let $78ad46e0d6808149$export$1371117f8b853f61 = /*#__PURE__*/ function(DevOpsToolSortOrder) {
    DevOpsToolSortOrder["Asc"] = "ASC";
    DevOpsToolSortOrder["Desc"] = "DESC";
    return DevOpsToolSortOrder;
}({}); /**
 * A user that could tie to a first-party user and/or a third-party user.
 *
 * - "user" is supplied if it is a first-party user
 * - "thirdPartyUser" is supplied if it is a third-party user
 * - Both "user" and "thirdPartyUser" could be supplied if a user matches both a first-party user and a third-party user
 * - Neither "user" nor "thirdPartyUser" is supplied if the user is not found, but they exist. For example, a Pull Request might have a user, but we just don't know who that user is.
 */ 
let $78ad46e0d6808149$export$861966f1b6eab176 = /*#__PURE__*/ function(DevStatusActivity) {
    DevStatusActivity["BranchOpen"] = "BRANCH_OPEN";
    DevStatusActivity["Commit"] = "COMMIT";
    DevStatusActivity["Deployment"] = "DEPLOYMENT";
    DevStatusActivity["Design"] = "DESIGN";
    DevStatusActivity["PrDeclined"] = "PR_DECLINED";
    DevStatusActivity["PrMerged"] = "PR_MERGED";
    DevStatusActivity["PrOpen"] = "PR_OPEN";
    return DevStatusActivity;
}({});
let $78ad46e0d6808149$export$250c76f3771f8949 = /*#__PURE__*/ function(EcosystemAppNetworkPermissionType) {
    EcosystemAppNetworkPermissionType["Connect"] = "CONNECT";
    return EcosystemAppNetworkPermissionType;
}({});
let $78ad46e0d6808149$export$f432b7347a6f0100 = /*#__PURE__*/ function(EcosystemAppsInstalledInContextsFilterType) {
    EcosystemAppsInstalledInContextsFilterType["Name"] = "NAME";
    EcosystemAppsInstalledInContextsFilterType["OnlyAppIds"] = "ONLY_APP_IDS";
    return EcosystemAppsInstalledInContextsFilterType;
}({});
let $78ad46e0d6808149$export$123dfeb539fdf7e4 = /*#__PURE__*/ function(EcosystemAppsInstalledInContextsSortKey) {
    EcosystemAppsInstalledInContextsSortKey["Name"] = "NAME";
    EcosystemAppsInstalledInContextsSortKey["RelatedApps"] = "RELATED_APPS";
    return EcosystemAppsInstalledInContextsSortKey;
}({}); /** Edit sprint */  /** Estimate object which contains an estimate for a card when it exists */ 
let $78ad46e0d6808149$export$38fe23235d685c0d = /*#__PURE__*/ function(EstimationType) {
    EstimationType["CustomNumberField"] = "CUSTOM_NUMBER_FIELD";
    EstimationType["IssueCount"] = "ISSUE_COUNT";
    EstimationType["OriginalEstimate"] = "ORIGINAL_ESTIMATE";
    EstimationType["StoryPoints"] = "STORY_POINTS";
    return EstimationType;
}({}); /** Compass Events */  /** Compass Events */  /** An arbitrary extension definition as defined by the Ecosystem */  /** An arbitrary extension definition as defined by the Ecosystem */  /** The context in which an extension exists */  /** The context in which an extension exists */  /** The context in which an extension exists */  /** The context in which an extension exists */  /** The context in which an extension exists */  /** The context in which an extension exists */ 
let $78ad46e0d6808149$export$f7fc910e99a97ad = /*#__PURE__*/ function(ExtensionContextsFilterType) {
    ExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    ExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    ExtensionContextsFilterType["DefinitionId"] = "DEFINITION_ID";
    ExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    ExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    return ExtensionContextsFilterType;
}({}); /**
 * Details about an extension.
 *
 * This information is used to look up the extension within CaaS so that the
 * correct function can be resolved.
 *
 * This will eventually be superseded by an Id.
 */ 
let $78ad46e0d6808149$export$d11f0d213b47454b = /*#__PURE__*/ function(ExternalApprovalStatus) {
    ExternalApprovalStatus["Approved"] = "APPROVED";
    ExternalApprovalStatus["Needswork"] = "NEEDSWORK";
    ExternalApprovalStatus["Unapproved"] = "UNAPPROVED";
    return ExternalApprovalStatus;
}({}); /**
 * Supported associations ATIs in Data Depot
 *   Implemented for hydration
 *     * GRAPH_SERVICE
 *     * JIRA_ISSUE
 *     * JIRA_DOCUMENT
 *     * JIRA_PROJECT
 *     * JIRA_VERSION
 *     * THIRD_PARTY_USER
 *   To be implemented
 *     * COMPASS_EVENT_SOURCE
 *     * COMPASS_COMPONENT
 *     * MERCURY_FOCUS_AREA
 *     * THIRD_PARTY_GROUP
 */ 
let $78ad46e0d6808149$export$a529a83fbd574a83 = /*#__PURE__*/ function(ExternalBuildState) {
    ExternalBuildState["Cancelled"] = "CANCELLED";
    ExternalBuildState["Failed"] = "FAILED";
    ExternalBuildState["InProgress"] = "IN_PROGRESS";
    ExternalBuildState["Pending"] = "PENDING";
    ExternalBuildState["Successful"] = "SUCCESSFUL";
    ExternalBuildState["Unknown"] = "UNKNOWN";
    return ExternalBuildState;
}({});
let $78ad46e0d6808149$export$21df421064bf3919 = /*#__PURE__*/ function(ExternalChangeType) {
    ExternalChangeType["Added"] = "ADDED";
    ExternalChangeType["Copied"] = "COPIED";
    ExternalChangeType["Deleted"] = "DELETED";
    ExternalChangeType["Modified"] = "MODIFIED";
    ExternalChangeType["Moved"] = "MOVED";
    ExternalChangeType["Unknown"] = "UNKNOWN";
    return ExternalChangeType;
}({});
let $78ad46e0d6808149$export$6759ac6277d955dd = /*#__PURE__*/ function(ExternalCommitFlags) {
    ExternalCommitFlags["MergeCommit"] = "MERGE_COMMIT";
    return ExternalCommitFlags;
}({});
let $78ad46e0d6808149$export$bbf4ad4fb3d17b4c = /*#__PURE__*/ function(ExternalConversationType) {
    ExternalConversationType["Channel"] = "CHANNEL";
    ExternalConversationType["DirectMessage"] = "DIRECT_MESSAGE";
    ExternalConversationType["GroupDirectMessage"] = "GROUP_DIRECT_MESSAGE";
    return ExternalConversationType;
}({});
let $78ad46e0d6808149$export$2b3de6bf362bc793 = /*#__PURE__*/ function(ExternalDeploymentState) {
    ExternalDeploymentState["Cancelled"] = "CANCELLED";
    ExternalDeploymentState["Failed"] = "FAILED";
    ExternalDeploymentState["InProgress"] = "IN_PROGRESS";
    ExternalDeploymentState["Pending"] = "PENDING";
    ExternalDeploymentState["RolledBack"] = "ROLLED_BACK";
    ExternalDeploymentState["Successful"] = "SUCCESSFUL";
    ExternalDeploymentState["Unknown"] = "UNKNOWN";
    return ExternalDeploymentState;
}({});
let $78ad46e0d6808149$export$b3dbc3bb1f3d376e = /*#__PURE__*/ function(ExternalDesignStatus) {
    ExternalDesignStatus["None"] = "NONE";
    ExternalDesignStatus["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    ExternalDesignStatus["Unknown"] = "UNKNOWN";
    return ExternalDesignStatus;
}({});
let $78ad46e0d6808149$export$697e56d9e72094e7 = /*#__PURE__*/ function(ExternalDesignType) {
    ExternalDesignType["Canvas"] = "CANVAS";
    ExternalDesignType["File"] = "FILE";
    ExternalDesignType["Group"] = "GROUP";
    ExternalDesignType["Node"] = "NODE";
    ExternalDesignType["Other"] = "OTHER";
    ExternalDesignType["Prototype"] = "PROTOTYPE";
    return ExternalDesignType;
}({});
let $78ad46e0d6808149$export$febd917fd954ad28 = /*#__PURE__*/ function(ExternalDocumentCategory) {
    ExternalDocumentCategory["Archive"] = "ARCHIVE";
    ExternalDocumentCategory["Audio"] = "AUDIO";
    ExternalDocumentCategory["Code"] = "CODE";
    ExternalDocumentCategory["Document"] = "DOCUMENT";
    ExternalDocumentCategory["Folder"] = "FOLDER";
    ExternalDocumentCategory["Form"] = "FORM";
    ExternalDocumentCategory["Image"] = "IMAGE";
    ExternalDocumentCategory["Other"] = "OTHER";
    ExternalDocumentCategory["Pdf"] = "PDF";
    ExternalDocumentCategory["Presentation"] = "PRESENTATION";
    ExternalDocumentCategory["Shortcut"] = "SHORTCUT";
    ExternalDocumentCategory["Spreadsheet"] = "SPREADSHEET";
    ExternalDocumentCategory["Video"] = "VIDEO";
    ExternalDocumentCategory["WebPage"] = "WEB_PAGE";
    return ExternalDocumentCategory;
}({}); /** Return one or the supported model */ 
let $78ad46e0d6808149$export$58380f2014542325 = /*#__PURE__*/ function(ExternalEnvironmentType) {
    ExternalEnvironmentType["Development"] = "DEVELOPMENT";
    ExternalEnvironmentType["Production"] = "PRODUCTION";
    ExternalEnvironmentType["Staging"] = "STAGING";
    ExternalEnvironmentType["Testing"] = "TESTING";
    ExternalEnvironmentType["Unmapped"] = "UNMAPPED";
    return ExternalEnvironmentType;
}({});
let $78ad46e0d6808149$export$7fbe6f4fd7f8b720 = /*#__PURE__*/ function(ExternalMembershipType) {
    ExternalMembershipType["Private"] = "PRIVATE";
    ExternalMembershipType["Public"] = "PUBLIC";
    ExternalMembershipType["Shared"] = "SHARED";
    return ExternalMembershipType;
}({});
let $78ad46e0d6808149$export$589c937a173b601d = /*#__PURE__*/ function(ExternalPullRequestStatus) {
    ExternalPullRequestStatus["Declined"] = "DECLINED";
    ExternalPullRequestStatus["Draft"] = "DRAFT";
    ExternalPullRequestStatus["Merged"] = "MERGED";
    ExternalPullRequestStatus["Open"] = "OPEN";
    ExternalPullRequestStatus["Unknown"] = "UNKNOWN";
    return ExternalPullRequestStatus;
}({});
let $78ad46e0d6808149$export$6935f9834af32b63 = /*#__PURE__*/ function(ExternalVulnerabilitySeverityLevel) {
    ExternalVulnerabilitySeverityLevel["Critical"] = "CRITICAL";
    ExternalVulnerabilitySeverityLevel["High"] = "HIGH";
    ExternalVulnerabilitySeverityLevel["Low"] = "LOW";
    ExternalVulnerabilitySeverityLevel["Medium"] = "MEDIUM";
    ExternalVulnerabilitySeverityLevel["Unknown"] = "UNKNOWN";
    return ExternalVulnerabilitySeverityLevel;
}({});
let $78ad46e0d6808149$export$4e05add33b7916dd = /*#__PURE__*/ function(ExternalVulnerabilityStatus) {
    ExternalVulnerabilityStatus["Closed"] = "CLOSED";
    ExternalVulnerabilityStatus["Ignored"] = "IGNORED";
    ExternalVulnerabilityStatus["Open"] = "OPEN";
    ExternalVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return ExternalVulnerabilityStatus;
}({});
let $78ad46e0d6808149$export$fe6bc7391e35d6c7 = /*#__PURE__*/ function(ExternalVulnerabilityType) {
    ExternalVulnerabilityType["Dast"] = "DAST";
    ExternalVulnerabilityType["Sast"] = "SAST";
    ExternalVulnerabilityType["Sca"] = "SCA";
    ExternalVulnerabilityType["Unknown"] = "UNKNOWN";
    return ExternalVulnerabilityType;
}({});
let $78ad46e0d6808149$export$2494f7bfd7b17cbf = /*#__PURE__*/ function(ForgeAlertsActivityType) {
    ForgeAlertsActivityType["AlertCreated"] = "ALERT_CREATED";
    ForgeAlertsActivityType["AlertMuted"] = "ALERT_MUTED";
    ForgeAlertsActivityType["AlertOpened"] = "ALERT_OPENED";
    ForgeAlertsActivityType["AlertResolved"] = "ALERT_RESOLVED";
    ForgeAlertsActivityType["AlertSentFiring"] = "ALERT_SENT_FIRING";
    ForgeAlertsActivityType["AlertSentResolved"] = "ALERT_SENT_RESOLVED";
    ForgeAlertsActivityType["AlertUnmuted"] = "ALERT_UNMUTED";
    ForgeAlertsActivityType["AlertUpdated"] = "ALERT_UPDATED";
    return ForgeAlertsActivityType;
}({});
let $78ad46e0d6808149$export$7abb09aca3d3224b = /*#__PURE__*/ function(ForgeAlertsAlertActivityType) {
    ForgeAlertsAlertActivityType["AlertClosed"] = "ALERT_CLOSED";
    ForgeAlertsAlertActivityType["AlertOpen"] = "ALERT_OPEN";
    ForgeAlertsAlertActivityType["EmailSent"] = "EMAIL_SENT";
    ForgeAlertsAlertActivityType["SeverityUpdated"] = "SEVERITY_UPDATED";
    return ForgeAlertsAlertActivityType;
}({});
let $78ad46e0d6808149$export$33c67579a8081e2a = /*#__PURE__*/ function(ForgeAlertsListOrderByColumns) {
    ForgeAlertsListOrderByColumns["AlertId"] = "alertId";
    ForgeAlertsListOrderByColumns["ClosedAt"] = "closedAt";
    ForgeAlertsListOrderByColumns["CreatedAt"] = "createdAt";
    ForgeAlertsListOrderByColumns["Duration"] = "duration";
    ForgeAlertsListOrderByColumns["Severity"] = "severity";
    return ForgeAlertsListOrderByColumns;
}({});
let $78ad46e0d6808149$export$9d3bb71d891b531d = /*#__PURE__*/ function(ForgeAlertsListOrderOptions) {
    ForgeAlertsListOrderOptions["Asc"] = "ASC";
    ForgeAlertsListOrderOptions["Desc"] = "DESC";
    return ForgeAlertsListOrderOptions;
}({});
let $78ad46e0d6808149$export$e762242ac801905f = /*#__PURE__*/ function(ForgeAlertsMetricsDataType) {
    ForgeAlertsMetricsDataType["DateTime"] = "DATE_TIME";
    return ForgeAlertsMetricsDataType;
}({});
let $78ad46e0d6808149$export$84db9ee3d9e00674 = /*#__PURE__*/ function(ForgeAlertsMetricsResolutionUnit) {
    ForgeAlertsMetricsResolutionUnit["Day"] = "DAY";
    ForgeAlertsMetricsResolutionUnit["Hours"] = "HOURS";
    ForgeAlertsMetricsResolutionUnit["Minutes"] = "MINUTES";
    return ForgeAlertsMetricsResolutionUnit;
}({});
let $78ad46e0d6808149$export$804cf64af4f1f8ef = /*#__PURE__*/ function(ForgeAlertsRuleActivityAction) {
    ForgeAlertsRuleActivityAction["Created"] = "CREATED";
    ForgeAlertsRuleActivityAction["Deleted"] = "DELETED";
    ForgeAlertsRuleActivityAction["Disabled"] = "DISABLED";
    ForgeAlertsRuleActivityAction["Enabled"] = "ENABLED";
    ForgeAlertsRuleActivityAction["Updated"] = "UPDATED";
    return ForgeAlertsRuleActivityAction;
}({});
let $78ad46e0d6808149$export$a8eb586b92cbde1f = /*#__PURE__*/ function(ForgeAlertsRuleFilterActions) {
    ForgeAlertsRuleFilterActions["Exclude"] = "EXCLUDE";
    ForgeAlertsRuleFilterActions["Include"] = "INCLUDE";
    return ForgeAlertsRuleFilterActions;
}({});
let $78ad46e0d6808149$export$b8a26accb92dade4 = /*#__PURE__*/ function(ForgeAlertsRuleFilterDimensions) {
    ForgeAlertsRuleFilterDimensions["ErrorTypes"] = "ERROR_TYPES";
    ForgeAlertsRuleFilterDimensions["Functions"] = "FUNCTIONS";
    ForgeAlertsRuleFilterDimensions["Sites"] = "SITES";
    ForgeAlertsRuleFilterDimensions["Versions"] = "VERSIONS";
    return ForgeAlertsRuleFilterDimensions;
}({});
let $78ad46e0d6808149$export$3cd0507df3412180 = /*#__PURE__*/ function(ForgeAlertsRuleMetricType) {
    ForgeAlertsRuleMetricType["InvocationCount"] = "INVOCATION_COUNT";
    ForgeAlertsRuleMetricType["InvocationErrors"] = "INVOCATION_ERRORS";
    ForgeAlertsRuleMetricType["InvocationLatency"] = "INVOCATION_LATENCY";
    ForgeAlertsRuleMetricType["InvocationSuccessRate"] = "INVOCATION_SUCCESS_RATE";
    return ForgeAlertsRuleMetricType;
}({});
let $78ad46e0d6808149$export$49e1bdac0115b9c = /*#__PURE__*/ function(ForgeAlertsRuleSeverity) {
    ForgeAlertsRuleSeverity["Critical"] = "CRITICAL";
    ForgeAlertsRuleSeverity["Major"] = "MAJOR";
    ForgeAlertsRuleSeverity["Minor"] = "MINOR";
    return ForgeAlertsRuleSeverity;
}({});
let $78ad46e0d6808149$export$c665fabcc544b3e1 = /*#__PURE__*/ function(ForgeAlertsRuleWhenConditions) {
    ForgeAlertsRuleWhenConditions["Above"] = "ABOVE";
    ForgeAlertsRuleWhenConditions["AboveOrEqualTo"] = "ABOVE_OR_EQUAL_TO";
    ForgeAlertsRuleWhenConditions["Below"] = "BELOW";
    ForgeAlertsRuleWhenConditions["BelowOrEqualTo"] = "BELOW_OR_EQUAL_TO";
    return ForgeAlertsRuleWhenConditions;
}({});
let $78ad46e0d6808149$export$767f8584da7588f6 = /*#__PURE__*/ function(ForgeAlertsStatus) {
    ForgeAlertsStatus["Closed"] = "CLOSED";
    ForgeAlertsStatus["Firing"] = "FIRING";
    ForgeAlertsStatus["Open"] = "OPEN";
    ForgeAlertsStatus["Resolved"] = "RESOLVED";
    return ForgeAlertsStatus;
}({});
let $78ad46e0d6808149$export$d43e1fd1dac905d1 = /*#__PURE__*/ function(ForgeAuditLogsActionType) {
    ForgeAuditLogsActionType["ContributorAdded"] = "CONTRIBUTOR_ADDED";
    ForgeAuditLogsActionType["ContributorRemoved"] = "CONTRIBUTOR_REMOVED";
    ForgeAuditLogsActionType["ContributorRoleUpdated"] = "CONTRIBUTOR_ROLE_UPDATED";
    ForgeAuditLogsActionType["OwnershipTransferred"] = "OWNERSHIP_TRANSFERRED";
    return ForgeAuditLogsActionType;
}({});
let $78ad46e0d6808149$export$f0a3a970a16c79ec = /*#__PURE__*/ function(ForgeMetricsApiRequestGroupByDimensions) {
    ForgeMetricsApiRequestGroupByDimensions["ContextAri"] = "CONTEXT_ARI";
    ForgeMetricsApiRequestGroupByDimensions["Status"] = "STATUS";
    ForgeMetricsApiRequestGroupByDimensions["Url"] = "URL";
    return ForgeMetricsApiRequestGroupByDimensions;
}({});
let $78ad46e0d6808149$export$ff830a2670c6e0f4 = /*#__PURE__*/ function(ForgeMetricsApiRequestStatus) {
    ForgeMetricsApiRequestStatus["2Xx"] = "_2XX";
    ForgeMetricsApiRequestStatus["4Xx"] = "_4XX";
    ForgeMetricsApiRequestStatus["5Xx"] = "_5XX";
    return ForgeMetricsApiRequestStatus;
}({});
let $78ad46e0d6808149$export$67826916f2c41941 = /*#__PURE__*/ function(ForgeMetricsApiRequestType) {
    ForgeMetricsApiRequestType["Cache"] = "CACHE";
    ForgeMetricsApiRequestType["External"] = "EXTERNAL";
    ForgeMetricsApiRequestType["Product"] = "PRODUCT";
    ForgeMetricsApiRequestType["Sql"] = "SQL";
    return ForgeMetricsApiRequestType;
}({});
let $78ad46e0d6808149$export$6854d9ebadef3813 = /*#__PURE__*/ function(ForgeMetricsChartName) {
    ForgeMetricsChartName["ApiRequestCount_2Xx"] = "API_REQUEST_COUNT_2XX";
    ForgeMetricsChartName["ApiRequestCount_4Xx"] = "API_REQUEST_COUNT_4XX";
    ForgeMetricsChartName["ApiRequestCount_5Xx"] = "API_REQUEST_COUNT_5XX";
    ForgeMetricsChartName["ApiRequestLatency"] = "API_REQUEST_LATENCY";
    ForgeMetricsChartName["InvocationCount"] = "INVOCATION_COUNT";
    ForgeMetricsChartName["InvocationError"] = "INVOCATION_ERROR";
    ForgeMetricsChartName["InvocationLatency"] = "INVOCATION_LATENCY";
    ForgeMetricsChartName["InvocationSuccessRate"] = "INVOCATION_SUCCESS_RATE";
    return ForgeMetricsChartName;
}({});
let $78ad46e0d6808149$export$8220077afa4e34ce = /*#__PURE__*/ function(ForgeMetricsDataType) {
    ForgeMetricsDataType["Category"] = "CATEGORY";
    ForgeMetricsDataType["DateTime"] = "DATE_TIME";
    ForgeMetricsDataType["Numeric"] = "NUMERIC";
    return ForgeMetricsDataType;
}({});
let $78ad46e0d6808149$export$81745303cdddd39e = /*#__PURE__*/ function(ForgeMetricsGroupByDimensions) {
    ForgeMetricsGroupByDimensions["ContextAri"] = "CONTEXT_ARI";
    ForgeMetricsGroupByDimensions["EnvironmentId"] = "ENVIRONMENT_ID";
    ForgeMetricsGroupByDimensions["ErrorType"] = "ERROR_TYPE";
    ForgeMetricsGroupByDimensions["Function"] = "FUNCTION";
    ForgeMetricsGroupByDimensions["UserTier"] = "USER_TIER";
    ForgeMetricsGroupByDimensions["Version"] = "VERSION";
    return ForgeMetricsGroupByDimensions;
}({});
let $78ad46e0d6808149$export$2afbe872edd7ae25 = /*#__PURE__*/ function(ForgeMetricsLabels) {
    ForgeMetricsLabels["ForgeApiRequestCount"] = "FORGE_API_REQUEST_COUNT";
    ForgeMetricsLabels["ForgeApiRequestLatency"] = "FORGE_API_REQUEST_LATENCY";
    ForgeMetricsLabels["ForgeBackendInvocationCount"] = "FORGE_BACKEND_INVOCATION_COUNT";
    ForgeMetricsLabels["ForgeBackendInvocationErrors"] = "FORGE_BACKEND_INVOCATION_ERRORS";
    ForgeMetricsLabels["ForgeBackendInvocationLatency"] = "FORGE_BACKEND_INVOCATION_LATENCY";
    return ForgeMetricsLabels;
}({});
let $78ad46e0d6808149$export$bf91b1fbb61e5286 = /*#__PURE__*/ function(ForgeMetricsResolutionUnit) {
    ForgeMetricsResolutionUnit["Hours"] = "HOURS";
    ForgeMetricsResolutionUnit["Minutes"] = "MINUTES";
    return ForgeMetricsResolutionUnit;
}({});
let $78ad46e0d6808149$export$923266f2817195b3 = /*#__PURE__*/ function(ForgeMetricsSiteFilterCategory) {
    ForgeMetricsSiteFilterCategory["All"] = "ALL";
    ForgeMetricsSiteFilterCategory["HighestInvocationCount"] = "HIGHEST_INVOCATION_COUNT";
    ForgeMetricsSiteFilterCategory["HighestNumberOfErrors"] = "HIGHEST_NUMBER_OF_ERRORS";
    ForgeMetricsSiteFilterCategory["HighestNumberOfUsers"] = "HIGHEST_NUMBER_OF_USERS";
    ForgeMetricsSiteFilterCategory["LowestSuccessRate"] = "LOWEST_SUCCESS_RATE";
    return ForgeMetricsSiteFilterCategory;
}({});
let $78ad46e0d6808149$export$fc8a1cc6d4fd1a88 = /*#__PURE__*/ function(FormStatus) {
    FormStatus["Approved"] = "APPROVED";
    FormStatus["Rejected"] = "REJECTED";
    FormStatus["Saved"] = "SAVED";
    FormStatus["Submitted"] = "SUBMITTED";
    return FormStatus;
}({});
let $78ad46e0d6808149$export$6dc536fb03c01261 = /*#__PURE__*/ function(FortifiedMetricsResolutionUnit) {
    FortifiedMetricsResolutionUnit["Hours"] = "HOURS";
    FortifiedMetricsResolutionUnit["Minutes"] = "MINUTES";
    return FortifiedMetricsResolutionUnit;
}({}); /** The data describing a function invocation. */  /** Which type of trigger */ 
let $78ad46e0d6808149$export$c11461c8b46bd7da = /*#__PURE__*/ function(FunctionTriggerType) {
    FunctionTriggerType["Frontend"] = "FRONTEND";
    FunctionTriggerType["Manual"] = "MANUAL";
    FunctionTriggerType["Product"] = "PRODUCT";
    FunctionTriggerType["Web"] = "WEB";
    return FunctionTriggerType;
}({}); /** Concrete version of MutationErrorExtension that does not include any extra fields */  /** Generic implementation of MutationResponse for responses that don't need any extra data */  /** Concrete version of QueryErrorExtension that does not include any extra fields */  /**
 * Card Creation fields.
 * Only getting used by "jsw-adapted-issue-create-trigger" package
 */ 
let $78ad46e0d6808149$export$7cf25e310e0549b9 = /*#__PURE__*/ function(GrantCheckProduct) {
    GrantCheckProduct["Compass"] = "COMPASS";
    GrantCheckProduct["Confluence"] = "CONFLUENCE";
    GrantCheckProduct["Jira"] = "JIRA";
    GrantCheckProduct["JiraServicedesk"] = "JIRA_SERVICEDESK";
    GrantCheckProduct["Mercury"] = "MERCURY";
    GrantCheckProduct["NoGrantChecks"] = "NO_GRANT_CHECKS";
    GrantCheckProduct["Townsquare"] = "TOWNSQUARE";
    return GrantCheckProduct;
}({}); /** Represents an ati:cloud:confluence:page. Returned by relationship queries */ 
let $78ad46e0d6808149$export$e257ff6d0ceabf65 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum) {
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum;
}({});
let $78ad46e0d6808149$export$d67cf8c91eee6c78 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum) {
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum;
}({});
let $78ad46e0d6808149$export$ee2e640b413dd384 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum) {
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Development"] = "DEVELOPMENT";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Production"] = "PRODUCTION";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Staging"] = "STAGING";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Testing"] = "TESTING";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Unmapped"] = "UNMAPPED";
    return GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum;
}({});
let $78ad46e0d6808149$export$c50c7062a9ebe6be = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum) {
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Merged"] = "MERGED";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum;
}({});
let $78ad46e0d6808149$export$a79d08c6a74f2aa7 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum) {
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
    return GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum;
}({});
let $78ad46e0d6808149$export$6f687fc24be8932d = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum) {
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum;
}({});
let $78ad46e0d6808149$export$49ff7d43116f0b34 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum) {
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum;
}({});
let $78ad46e0d6808149$export$e818e0de20808583 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum) {
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Dast"] = "DAST";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Sast"] = "SAST";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Sca"] = "SCA";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum;
}({});
let $78ad46e0d6808149$export$712746aa2988ba08 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum) {
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum;
}({});
let $78ad46e0d6808149$export$f69c5a9b8fd498a0 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum) {
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum;
}({});
let $78ad46e0d6808149$export$ae5cb07efff2d516 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum) {
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Merged"] = "MERGED";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum;
}({});
let $78ad46e0d6808149$export$784f60349b367f9b = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum) {
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
    return GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum;
}({});
let $78ad46e0d6808149$export$e37d41f18a90ba53 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum) {
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum;
}({});
let $78ad46e0d6808149$export$f53fed6636725b64 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum) {
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum;
}({});
let $78ad46e0d6808149$export$aa057f51e7ce3c82 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum) {
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["Done"] = "DONE";
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["New"] = "NEW";
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum;
}({});
let $78ad46e0d6808149$export$28a810288577486f = /*#__PURE__*/ function(GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum) {
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["Done"] = "DONE";
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["New"] = "NEW";
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum;
}({});
let $78ad46e0d6808149$export$f863dc0cdc1e6a3 = /*#__PURE__*/ function(GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum) {
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["Done"] = "DONE";
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["New"] = "NEW";
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum;
}({}); /** Represents an Generic implementing the Node interface. */  /** Represents an Generic implementing the Node interface. */  /** Represents an ati:cloud:jira:issue. Returned by relationship queries */  /** Represents an ati:cloud:jira:post-incident-review-link implementing the Node interface. */  /** Represents an ati:cloud:jira:post-incident-review-link implementing the Node interface. */  /** Represents an ati:cloud:jira:project implementing the Node interface. */  /** Represents an ati:cloud:jira:security-container implementing the Node interface. */  /** Represents an ati:cloud:jira:sprint. Returned by relationship queries */  /** Represents an ati:cloud:jira:vulnerability implementing the Node interface. */ 
let $78ad46e0d6808149$export$506c56cd93325d6f = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum) {
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum;
}({});
let $78ad46e0d6808149$export$7ea6916b52f9a466 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum) {
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum;
}({});
let $78ad46e0d6808149$export$4a73bb7047a59c43 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum) {
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Development"] = "DEVELOPMENT";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Production"] = "PRODUCTION";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Staging"] = "STAGING";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Testing"] = "TESTING";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Unmapped"] = "UNMAPPED";
    return GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum;
}({});
let $78ad46e0d6808149$export$13841098b50a1391 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum) {
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Merged"] = "MERGED";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum;
}({});
let $78ad46e0d6808149$export$b79540fc1cf58152 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum) {
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
    return GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum;
}({});
let $78ad46e0d6808149$export$f73a51516debfebb = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum) {
    GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum["All"] = "ALL";
    GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum["Any"] = "ANY";
    GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum["None"] = "NONE";
    return GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum;
}({});
let $78ad46e0d6808149$export$ffa68ad6c069c08 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum) {
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum;
}({});
let $78ad46e0d6808149$export$d9c8a38d7a3c7cc8 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum) {
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum;
}({});
let $78ad46e0d6808149$export$5a8ffaaa2ad7aed0 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum) {
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Dast"] = "DAST";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Sast"] = "SAST";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Sca"] = "SCA";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum;
}({});
let $78ad46e0d6808149$export$806eaced01bf01a = /*#__PURE__*/ function(GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum) {
    GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum["All"] = "ALL";
    GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum["Any"] = "ANY";
    GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum["None"] = "NONE";
    return GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum;
}({});
let $78ad46e0d6808149$export$6ca61b0e0124327a = /*#__PURE__*/ function(GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum) {
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum;
}({});
let $78ad46e0d6808149$export$f5a38573abf93209 = /*#__PURE__*/ function(GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum) {
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum;
}({});
let $78ad46e0d6808149$export$e78de564c39ba63a = /*#__PURE__*/ function(GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum) {
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Dast"] = "DAST";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Sast"] = "SAST";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Sca"] = "SCA";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum;
}({});
let $78ad46e0d6808149$export$84e173808cf3fbd = /*#__PURE__*/ function(GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum) {
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P1"] = "P1";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P2"] = "P2";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P3"] = "P3";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P4"] = "P4";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P5"] = "P5";
    return GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum;
}({});
let $78ad46e0d6808149$export$9b119abe5b87afc8 = /*#__PURE__*/ function(GraphQueryMetadataSortEnum) {
    GraphQueryMetadataSortEnum["Asc"] = "ASC";
    GraphQueryMetadataSortEnum["Desc"] = "DESC";
    return GraphQueryMetadataSortEnum;
}({});
let $78ad46e0d6808149$export$c4247d75f3bd62d6 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum) {
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum;
}({});
let $78ad46e0d6808149$export$251196d62f47dadc = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum) {
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum;
}({});
let $78ad46e0d6808149$export$ecfd24ecd1c4c396 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum) {
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Development"] = "DEVELOPMENT";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Production"] = "PRODUCTION";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Staging"] = "STAGING";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Testing"] = "TESTING";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Unmapped"] = "UNMAPPED";
    return GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum;
}({});
let $78ad46e0d6808149$export$2b200e1b05f9a91 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum) {
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Merged"] = "MERGED";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum;
}({});
let $78ad46e0d6808149$export$3782643d0ae02abe = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum) {
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
    return GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum;
}({});
let $78ad46e0d6808149$export$522af156c9a19c25 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum) {
    GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum["All"] = "ALL";
    GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum["Any"] = "ANY";
    GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum["None"] = "NONE";
    return GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum;
}({});
let $78ad46e0d6808149$export$67557b0182f33b6 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum) {
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["Done"] = "DONE";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["New"] = "NEW";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum;
}({});
let $78ad46e0d6808149$export$46a86c882ece79a0 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum) {
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum;
}({});
let $78ad46e0d6808149$export$7fc2bf7b37a3a03c = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum) {
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum;
}({});
let $78ad46e0d6808149$export$39763c846aa96176 = /*#__PURE__*/ function(GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum) {
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["Done"] = "DONE";
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["New"] = "NEW";
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum;
}({}); /** A relationship edge for the relationship type content-referenced-entity */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, CompassComponent] */  /** A relationship inner edge for the relationship type content-referenced-entity */  /** A node representing a content-referenced-entity relationship, with all metadata (if available) */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage] */  /** A relationship edge for the relationship type focus-area-associated-to-project */  /** A union of the possible hydration types for focus-area-associated-to-project: [DevOpsProjectDetails] */  /** A relationship inner edge for the relationship type focus-area-associated-to-project */  /** A node representing a focus-area-associated-to-project relationship, with all metadata (if available) */  /** A union of the possible hydration types for focus-area-associated-to-project: [MercuryFocusArea] */  /** A relationship edge for the relationship type focus-area-has-atlas-goal */  /** A union of the possible hydration types for focus-area-has-atlas-goal: [TownsquareGoal] */  /** A relationship inner edge for the relationship type focus-area-has-atlas-goal */  /** A node representing a focus-area-has-atlas-goal relationship, with all metadata (if available) */  /** A union of the possible hydration types for focus-area-has-atlas-goal: [MercuryFocusArea] */  /** A relationship edge for the relationship type focus-area-has-focus-area */  /** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */  /** A relationship inner edge for the relationship type focus-area-has-focus-area */  /** A node representing a focus-area-has-focus-area relationship, with all metadata (if available) */  /** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */  /** A relationship edge for the relationship type focus-area-has-project */  /** A union of the possible hydration types for focus-area-has-project: [TownsquareProject, JiraIssue] */  /** A relationship inner edge for the relationship type focus-area-has-project */  /** A node representing a focus-area-has-project relationship, with all metadata (if available) */  /** A union of the possible hydration types for focus-area-has-project: [MercuryFocusArea] */  /** A relationship edge for the relationship type incident-associated-post-incident-review */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A relationship inner edge for the relationship type incident-associated-post-incident-review */  /** A relationship edge for the relationship type incident-associated-post-incident-review-link */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, JiraPostIncidentReviewLink, DevOpsOperationsPostIncidentReviewDetails] */  /** A relationship inner edge for the relationship type incident-associated-post-incident-review-link */  /** A node representing a incident-associated-post-incident-review-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A node representing a incident-associated-post-incident-review relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A relationship edge for the relationship type incident-has-action-item */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue] */  /** A relationship inner edge for the relationship type incident-has-action-item */  /** A node representing a incident-has-action-item relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A relationship edge for the relationship type incident-linked-jsw-issue */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue] */  /** A relationship inner edge for the relationship type incident-linked-jsw-issue */  /** A node representing a incident-linked-jsw-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A relationship edge for the relationship type issue-associated-build */  /** A relationship inner edge for the relationship type issue-associated-build */  /** A node representing a issue-associated-build relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-build: [JiraIssue] */  /** A relationship edge for the relationship type issue-associated-deployment */  /** A union of the possible hydration types for issue-associated-deployment: [DeploymentSummary] */  /** A relationship inner edge for the relationship type issue-associated-deployment */  /** A node representing a issue-associated-deployment relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-deployment: [JiraIssue] */  /** A relationship edge for the relationship type issue-associated-issue-remote-link */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink] */  /** A relationship inner edge for the relationship type issue-associated-issue-remote-link */  /** A node representing a issue-associated-issue-remote-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssue] */  /** A relationship edge for the relationship type jsm-project-associated-service */  /** A union of the possible hydration types for jsm-project-associated-service: [DevOpsService] */  /** A relationship inner edge for the relationship type jsm-project-associated-service */  /** A node representing a jsm-project-associated-service relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsm-project-associated-service: [JiraProject] */  /** A relationship edge for the relationship type media-attached-to-content */  /** A union of the possible hydration types for media-attached-to-content: [JiraIssue, ConfluencePage] */  /** A relationship inner edge for the relationship type media-attached-to-content */  /** A node representing a media-attached-to-content relationship, with all metadata (if available) */  /** A relationship edge for the relationship type security-container-associated-to-vulnerability */  /** A union of the possible hydration types for security-container-associated-to-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A relationship inner edge for the relationship type security-container-associated-to-vulnerability */  /** A node representing a security-container-associated-to-vulnerability relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$fb0f42f72b340ab0 = /*#__PURE__*/ function(GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput) {
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["NotSet"] = "NOT_SET";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P1"] = "P1";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P2"] = "P2";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P3"] = "P3";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P4"] = "P4";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P5"] = "P5";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["Pending"] = "PENDING";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["Unknown"] = "UNKNOWN";
    return GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput;
}({});
let $78ad46e0d6808149$export$621f4c3ec3f34f6d = /*#__PURE__*/ function(GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput) {
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["Done"] = "DONE";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["Indeterminate"] = "INDETERMINATE";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["New"] = "NEW";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["NotSet"] = "NOT_SET";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["Undefined"] = "UNDEFINED";
    return GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput;
}({});
let $78ad46e0d6808149$export$2cb64a720d855b98 = /*#__PURE__*/ function(GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput) {
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Critical"] = "CRITICAL";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["High"] = "HIGH";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Low"] = "LOW";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Medium"] = "MEDIUM";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["NotSet"] = "NOT_SET";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Unknown"] = "UNKNOWN";
    return GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput;
}({});
let $78ad46e0d6808149$export$996ea6ee34911f99 = /*#__PURE__*/ function(GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput) {
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Closed"] = "CLOSED";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Ignored"] = "IGNORED";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["NotSet"] = "NOT_SET";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Open"] = "OPEN";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Unknown"] = "UNKNOWN";
    return GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput;
}({});
let $78ad46e0d6808149$export$7db5c45cbd7a8d6a = /*#__PURE__*/ function(GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput) {
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Dast"] = "DAST";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["NotSet"] = "NOT_SET";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Sast"] = "SAST";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Sca"] = "SCA";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Unknown"] = "UNKNOWN";
    return GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput;
}({}); /** A full relationship edge for the relationship type app-installation-associated-to-operations-workspace */  /** A node representing a app-installation-associated-to-operations-workspace relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type app-installation-associated-to-security-workspace */  /** A node representing a app-installation-associated-to-security-workspace relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type atlas-project-contributes-to-atlas-goal */  /** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareGoal] */  /** A node representing a atlas-project-contributes-to-atlas-goal relationship, with all metadata (if available) */  /** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareProject] */  /** A full relationship edge for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [JiraIssue] */  /** A node representing a atlas-project-is-tracked-on-jira-epic relationship, with all metadata (if available) */  /** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [TownsquareProject] */  /** A full relationship edge for the relationship type component-impacted-by-incident */  /** A union of the possible hydration types for component-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */ 
let $78ad46e0d6808149$export$9887284bd91c5bd3 = /*#__PURE__*/ function(GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput) {
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P1"] = "P1";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P2"] = "P2";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P3"] = "P3";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P4"] = "P4";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P5"] = "P5";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["Pending"] = "PENDING";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput;
}({});
let $78ad46e0d6808149$export$753e474d0e2d3bcb = /*#__PURE__*/ function(GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput) {
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["Done"] = "DONE";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["New"] = "NEW";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput;
}({}); /** A node representing a component-impacted-by-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for component-impacted-by-incident: [CompassComponent, DevOpsOperationsComponentDetails] */  /** A full relationship edge for the relationship type component-linked-jsw-issue */  /** A union of the possible hydration types for component-linked-jsw-issue: [JiraIssue] */  /** A node representing a component-linked-jsw-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for component-linked-jsw-issue: [CompassComponent, DevOpsService, DevOpsOperationsComponentDetails] */  /** A full relationship edge for the relationship type content-referenced-entity */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, CompassComponent] */  /** A node representing a content-referenced-entity relationship, with all metadata (if available) */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage] */  /** A full relationship edge for the relationship type incident-associated-post-incident-review */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A full relationship edge for the relationship type incident-associated-post-incident-review-link */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, JiraPostIncidentReviewLink, DevOpsOperationsPostIncidentReviewDetails] */  /** A node representing a incident-associated-post-incident-review-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A node representing a incident-associated-post-incident-review relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A full relationship edge for the relationship type incident-has-action-item */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue] */  /** A node representing a incident-has-action-item relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A full relationship edge for the relationship type incident-linked-jsw-issue */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue] */  /** A node representing a incident-linked-jsw-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A full relationship edge for the relationship type issue-associated-branch */  /** A node representing a issue-associated-branch relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-branch: [JiraIssue] */ 
let $78ad46e0d6808149$export$983eeb7eafc088a9 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedBuildBuildStateOutput) {
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Failed"] = "FAILED";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Pending"] = "PENDING";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullIssueAssociatedBuildBuildStateOutput;
}({}); /** A full relationship edge for the relationship type issue-associated-build */  /** A node representing a issue-associated-build relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-build: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-commit */  /** A node representing a issue-associated-commit relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-commit: [JiraIssue] */ 
let $78ad46e0d6808149$export$6707759160f13c4c = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput) {
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Failed"] = "FAILED";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Pending"] = "PENDING";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["RolledBack"] = "ROLLED_BACK";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput;
}({}); /** A full relationship edge for the relationship type issue-associated-deployment */  /** A union of the possible hydration types for issue-associated-deployment: [DeploymentSummary] */ 
let $78ad46e0d6808149$export$62f69bc9834c2852 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput) {
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Development"] = "DEVELOPMENT";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Production"] = "PRODUCTION";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Staging"] = "STAGING";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Testing"] = "TESTING";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Unmapped"] = "UNMAPPED";
    return GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput;
}({}); /** A node representing a issue-associated-deployment relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-deployment: [JiraIssue] */ 
let $78ad46e0d6808149$export$a3ef183d8c6ea7f8 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedDesignDesignStatusOutput) {
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["None"] = "NONE";
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullIssueAssociatedDesignDesignStatusOutput;
}({});
let $78ad46e0d6808149$export$e0814c7e8e75c569 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedDesignDesignTypeOutput) {
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Canvas"] = "CANVAS";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["File"] = "FILE";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Group"] = "GROUP";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Node"] = "NODE";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Other"] = "OTHER";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Prototype"] = "PROTOTYPE";
    return GraphStoreFullIssueAssociatedDesignDesignTypeOutput;
}({}); /** A full relationship edge for the relationship type issue-associated-design */  /** A union of the possible hydration types for issue-associated-design: [DevOpsDesign] */  /** A node representing a issue-associated-design relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-design: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-feature-flag */  /** A union of the possible hydration types for issue-associated-feature-flag: [DevOpsFeatureFlag] */  /** A node representing a issue-associated-feature-flag relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-feature-flag: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-issue-remote-link */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink] */ 
let $78ad46e0d6808149$export$f82857e2145c8247 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput) {
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Bamboo"] = "BAMBOO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["BbPrComment"] = "BB_PR_COMMENT";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["ConfluencePage"] = "CONFLUENCE_PAGE";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Jira"] = "JIRA";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Snyk"] = "SNYK";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Trello"] = "TRELLO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["WebLink"] = "WEB_LINK";
    return GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput;
}({});
let $78ad46e0d6808149$export$90175675ed9a274f = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput) {
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["AddedToIdea"] = "ADDED_TO_IDEA";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Blocks"] = "BLOCKS";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Causes"] = "CAUSES";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Clones"] = "CLONES";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["CreatedFrom"] = "CREATED_FROM";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Duplicates"] = "DUPLICATES";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Implements"] = "IMPLEMENTS";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsBlockedBy"] = "IS_BLOCKED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsCausedBy"] = "IS_CAUSED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsClonedBy"] = "IS_CLONED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsDuplicatedBy"] = "IS_DUPLICATED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsIdeaFor"] = "IS_IDEA_FOR";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsImplementedBy"] = "IS_IMPLEMENTED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsReviewedBy"] = "IS_REVIEWED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["MentionedIn"] = "MENTIONED_IN";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["MergedFrom"] = "MERGED_FROM";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["MergedInto"] = "MERGED_INTO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["RelatesTo"] = "RELATES_TO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Reviews"] = "REVIEWS";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["SplitFrom"] = "SPLIT_FROM";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["SplitTo"] = "SPLIT_TO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["WikiPage"] = "WIKI_PAGE";
    return GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput;
}({}); /** A node representing a issue-associated-issue-remote-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-pr */  /** A union of the possible hydration types for issue-associated-pr: [DevOpsPullRequestDetails] */  /** A node representing a issue-associated-pr relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$947d4abb5daf138e = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedPrPullRequestStatusOutput) {
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Declined"] = "DECLINED";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Merged"] = "MERGED";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Open"] = "OPEN";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullIssueAssociatedPrPullRequestStatusOutput;
}({});
let $78ad46e0d6808149$export$e353d7be2a12f0f2 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput) {
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["Approved"] = "APPROVED";
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["Needswork"] = "NEEDSWORK";
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["Unapproved"] = "UNAPPROVED";
    return GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput;
}({}); /** A union of the possible hydration types for issue-associated-pr: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-remote-link */  /** A node representing a issue-associated-remote-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-remote-link: [JiraIssue] */  /** A full relationship edge for the relationship type issue-changes-component */  /** A union of the possible hydration types for issue-changes-component: [CompassComponent] */  /** A node representing a issue-changes-component relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-changes-component: [JiraIssue] */  /** A full relationship edge for the relationship type issue-recursive-associated-pr */  /** A union of the possible hydration types for issue-recursive-associated-pr: [DevOpsPullRequestDetails] */  /** A node representing a issue-recursive-associated-pr relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-recursive-associated-pr: [JiraIssue] */  /** A full relationship edge for the relationship type issue-to-whiteboard */  /** A union of the possible hydration types for issue-to-whiteboard: [ConfluenceWhiteboard] */  /** A node representing a issue-to-whiteboard relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-to-whiteboard: [JiraIssue] */  /** A full relationship edge for the relationship type jira-epic-contributes-to-atlas-goal */  /** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [TownsquareGoal] */  /** A node representing a jira-epic-contributes-to-atlas-goal relationship, with all metadata (if available) */  /** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [JiraIssue] */  /** A full relationship edge for the relationship type jira-project-associated-atlas-goal */  /** A union of the possible hydration types for jira-project-associated-atlas-goal: [TownsquareGoal] */  /** A node representing a jira-project-associated-atlas-goal relationship, with all metadata (if available) */  /** A union of the possible hydration types for jira-project-associated-atlas-goal: [JiraProject] */  /** A full relationship edge for the relationship type jsm-project-associated-service */  /** A union of the possible hydration types for jsm-project-associated-service: [DevOpsService] */  /** A node representing a jsm-project-associated-service relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsm-project-associated-service: [JiraProject] */  /** A full relationship edge for the relationship type jsw-project-associated-component */  /** A union of the possible hydration types for jsw-project-associated-component: [DevOpsService, CompassComponent, DevOpsOperationsComponentDetails] */  /** A node representing a jsw-project-associated-component relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsw-project-associated-component: [JiraProject] */  /** A full relationship edge for the relationship type jsw-project-associated-incident */  /** A union of the possible hydration types for jsw-project-associated-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */ 
let $78ad46e0d6808149$export$e336ee68867d9184 = /*#__PURE__*/ function(GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput) {
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P1"] = "P1";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P2"] = "P2";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P3"] = "P3";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P4"] = "P4";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P5"] = "P5";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["Pending"] = "PENDING";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput;
}({});
let $78ad46e0d6808149$export$8a57dccf86b2a6de = /*#__PURE__*/ function(GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput) {
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["Done"] = "DONE";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["New"] = "NEW";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput;
}({}); /** A node representing a jsw-project-associated-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsw-project-associated-incident: [JiraProject] */  /** A full relationship edge for the relationship type jsw-project-shares-component-with-jsm-project */  /** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */  /** A node representing a jsw-project-shares-component-with-jsm-project relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */  /** A full relationship edge for the relationship type linked-project-has-version */  /** A union of the possible hydration types for linked-project-has-version: [JiraVersion] */  /** A node representing a linked-project-has-version relationship, with all metadata (if available) */  /** A union of the possible hydration types for linked-project-has-version: [JiraProject] */  /** A full relationship edge for the relationship type operations-container-impacted-by-incident */  /** A union of the possible hydration types for operations-container-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A node representing a operations-container-impacted-by-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for operations-container-impacted-by-incident: [DevOpsService] */  /** A full relationship edge for the relationship type operations-container-improved-by-action-item */  /** A union of the possible hydration types for operations-container-improved-by-action-item: [JiraIssue] */  /** A node representing a operations-container-improved-by-action-item relationship, with all metadata (if available) */  /** A union of the possible hydration types for operations-container-improved-by-action-item: [DevOpsService] */ 
let $78ad46e0d6808149$export$d781aa0d3a6bc4bd = /*#__PURE__*/ function(GraphStoreFullParentDocumentHasChildDocumentCategoryOutput) {
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Archive"] = "ARCHIVE";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Audio"] = "AUDIO";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Code"] = "CODE";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Document"] = "DOCUMENT";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Folder"] = "FOLDER";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Form"] = "FORM";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Image"] = "IMAGE";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["NotSet"] = "NOT_SET";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Other"] = "OTHER";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Pdf"] = "PDF";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Presentation"] = "PRESENTATION";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Shortcut"] = "SHORTCUT";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Spreadsheet"] = "SPREADSHEET";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Video"] = "VIDEO";
    return GraphStoreFullParentDocumentHasChildDocumentCategoryOutput;
}({}); /** A full relationship edge for the relationship type parent-document-has-child-document */  /** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument] */  /** A node representing a parent-document-has-child-document relationship, with all metadata (if available) */  /** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument] */  /** A full relationship edge for the relationship type parent-issue-has-child-issue */  /** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */  /** A node representing a parent-issue-has-child-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */  /** A full relationship edge for the relationship type pr-in-repo */  /** A union of the possible hydration types for pr-in-repo: [DevOpsRepository] */  /** A node representing a pr-in-repo relationship, with all metadata (if available) */  /** A union of the possible hydration types for pr-in-repo: [DevOpsPullRequestDetails] */  /** A full relationship edge for the relationship type project-associated-branch */  /** A node representing a project-associated-branch relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-branch: [JiraProject] */ 
let $78ad46e0d6808149$export$12686f8906883b4d = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedBuildBuildStateOutput) {
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Failed"] = "FAILED";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Pending"] = "PENDING";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedBuildBuildStateOutput;
}({}); /** A full relationship edge for the relationship type project-associated-build */  /** A node representing a project-associated-build relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-build: [JiraProject] */ 
let $78ad46e0d6808149$export$1a6794f56a498d8 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput) {
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Failed"] = "FAILED";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Pending"] = "PENDING";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["RolledBack"] = "ROLLED_BACK";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput;
}({}); /** A full relationship edge for the relationship type project-associated-deployment */  /** A union of the possible hydration types for project-associated-deployment: [DeploymentSummary] */ 
let $78ad46e0d6808149$export$757f321f826d4b9f = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput) {
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Development"] = "DEVELOPMENT";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Production"] = "PRODUCTION";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Staging"] = "STAGING";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Testing"] = "TESTING";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Unmapped"] = "UNMAPPED";
    return GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput;
}({}); /** A node representing a project-associated-deployment relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-deployment: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-feature-flag */  /** A union of the possible hydration types for project-associated-feature-flag: [DevOpsFeatureFlag] */  /** A node representing a project-associated-feature-flag relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-feature-flag: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-incident */  /** A union of the possible hydration types for project-associated-incident: [JiraIssue] */  /** A node representing a project-associated-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-incident: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-opsgenie-team */  /** A union of the possible hydration types for project-associated-opsgenie-team: [OpsgenieTeam] */  /** A node representing a project-associated-opsgenie-team relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-opsgenie-team: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-pr */  /** A union of the possible hydration types for project-associated-pr: [DevOpsPullRequestDetails] */  /** A node representing a project-associated-pr relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$bed7454cabd50a99 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedPrPullRequestStatusOutput) {
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Declined"] = "DECLINED";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Merged"] = "MERGED";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Open"] = "OPEN";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedPrPullRequestStatusOutput;
}({});
let $78ad46e0d6808149$export$e0795a56969d3929 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput) {
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["Approved"] = "APPROVED";
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["Needswork"] = "NEEDSWORK";
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["Unapproved"] = "UNAPPROVED";
    return GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput;
}({}); /** A union of the possible hydration types for project-associated-pr: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-repo */  /** A union of the possible hydration types for project-associated-repo: [DevOpsRepository] */  /** A node representing a project-associated-repo relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-repo: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-service */  /** A union of the possible hydration types for project-associated-service: [DevOpsService] */  /** A node representing a project-associated-service relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-service: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-to-incident */  /** A union of the possible hydration types for project-associated-to-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A node representing a project-associated-to-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-to-incident: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-to-operations-container */  /** A union of the possible hydration types for project-associated-to-operations-container: [DevOpsService] */  /** A node representing a project-associated-to-operations-container relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-to-operations-container: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-to-security-container */  /** A node representing a project-associated-to-security-container relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-to-security-container: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-vulnerability */  /** A union of the possible hydration types for project-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A node representing a project-associated-vulnerability relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-vulnerability: [JiraProject] */ 
let $78ad46e0d6808149$export$c56f5d7588a02f34 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput) {
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput;
}({});
let $78ad46e0d6808149$export$9406f481f6c79a5d = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput) {
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput;
}({});
let $78ad46e0d6808149$export$d307e59860de1336 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput) {
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Dast"] = "DAST";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Sast"] = "SAST";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Sca"] = "SCA";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput;
}({}); /** A full relationship edge for the relationship type project-disassociated-repo */  /** A union of the possible hydration types for project-disassociated-repo: [DevOpsRepository] */  /** A node representing a project-disassociated-repo relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-disassociated-repo: [JiraProject] */  /** A full relationship edge for the relationship type project-documentation-entity */  /** A union of the possible hydration types for project-documentation-entity: [ConfluenceSpace, ConfluencePage, DevOpsDocument] */  /** A node representing a project-documentation-entity relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-documentation-entity: [JiraProject] */  /** A full relationship edge for the relationship type project-documentation-page */  /** A union of the possible hydration types for project-documentation-page: [ConfluencePage] */  /** A node representing a project-documentation-page relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-documentation-page: [JiraProject] */  /** A full relationship edge for the relationship type project-documentation-space */  /** A union of the possible hydration types for project-documentation-space: [ConfluenceSpace] */  /** A node representing a project-documentation-space relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-documentation-space: [JiraProject] */  /** A full relationship edge for the relationship type project-explicitly-associated-repo */  /** A union of the possible hydration types for project-explicitly-associated-repo: [DevOpsRepository] */  /** A node representing a project-explicitly-associated-repo relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-explicitly-associated-repo: [JiraProject] */  /** A full relationship edge for the relationship type project-has-issue */  /** A union of the possible hydration types for project-has-issue: [JiraIssue] */  /** A node representing a project-has-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-has-issue: [JiraProject] */  /** A full relationship edge for the relationship type project-has-shared-version-with */  /** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */  /** A node representing a project-has-shared-version-with relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */  /** A full relationship edge for the relationship type project-has-version */  /** A union of the possible hydration types for project-has-version: [JiraVersion] */  /** A node representing a project-has-version relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-has-version: [JiraProject] */  /** A full relationship edge for the relationship type security-container-associated-to-vulnerability */  /** A union of the possible hydration types for security-container-associated-to-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A node representing a security-container-associated-to-vulnerability relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$ec0309648167c01f = /*#__PURE__*/ function(GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput) {
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput;
}({});
let $78ad46e0d6808149$export$55ab07a5fac6a121 = /*#__PURE__*/ function(GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput) {
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput;
}({});
let $78ad46e0d6808149$export$93214a30dc67e249 = /*#__PURE__*/ function(GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput) {
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Dast"] = "DAST";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Sast"] = "SAST";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Sca"] = "SCA";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput;
}({}); /** A full relationship edge for the relationship type service-linked-incident */  /** A union of the possible hydration types for service-linked-incident: [JiraIssue] */ 
let $78ad46e0d6808149$export$cb34d20b583b9880 = /*#__PURE__*/ function(GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput) {
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P1"] = "P1";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P2"] = "P2";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P3"] = "P3";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P4"] = "P4";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P5"] = "P5";
    return GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput;
}({});
let $78ad46e0d6808149$export$4f97d0efb46b21d7 = /*#__PURE__*/ function(GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput) {
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["Done"] = "DONE";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["New"] = "NEW";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput;
}({}); /** A node representing a service-linked-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for service-linked-incident: [DevOpsService] */ 
let $78ad46e0d6808149$export$1faf908d1ac6334b = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedBuildBuildStateOutput) {
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Failed"] = "FAILED";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Pending"] = "PENDING";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedBuildBuildStateOutput;
}({}); /** A full relationship edge for the relationship type sprint-associated-build */  /** A node representing a sprint-associated-build relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$5bab79a51fe84df7 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput) {
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Failed"] = "FAILED";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Pending"] = "PENDING";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["RolledBack"] = "ROLLED_BACK";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput;
}({}); /** A full relationship edge for the relationship type sprint-associated-deployment */  /** A union of the possible hydration types for sprint-associated-deployment: [DeploymentSummary] */ 
let $78ad46e0d6808149$export$c8f81b6916886c13 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput) {
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Development"] = "DEVELOPMENT";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Production"] = "PRODUCTION";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Staging"] = "STAGING";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Testing"] = "TESTING";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Unmapped"] = "UNMAPPED";
    return GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput;
}({}); /** A node representing a sprint-associated-deployment relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type sprint-associated-pr */  /** A union of the possible hydration types for sprint-associated-pr: [DevOpsPullRequestDetails] */  /** A node representing a sprint-associated-pr relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$889f8821445073a8 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedPrPullRequestStatusOutput) {
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Declined"] = "DECLINED";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Merged"] = "MERGED";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Open"] = "OPEN";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedPrPullRequestStatusOutput;
}({});
let $78ad46e0d6808149$export$25d6205b4517999 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput) {
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["Approved"] = "APPROVED";
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["Needswork"] = "NEEDSWORK";
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["Unapproved"] = "UNAPPROVED";
    return GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput;
}({}); /** A full relationship edge for the relationship type sprint-associated-vulnerability */  /** A union of the possible hydration types for sprint-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A node representing a sprint-associated-vulnerability relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$f128313c5c33553a = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput) {
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["Done"] = "DONE";
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["New"] = "NEW";
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput;
}({});
let $78ad46e0d6808149$export$987cd4ea5561fc8e = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput) {
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput;
}({});
let $78ad46e0d6808149$export$bf865dbaf78a8d95 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput) {
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput;
}({}); /** A full relationship edge for the relationship type sprint-contains-issue */  /** A union of the possible hydration types for sprint-contains-issue: [JiraIssue] */  /** A node representing a sprint-contains-issue relationship, with all metadata (if available) */ 
let $78ad46e0d6808149$export$5296991171ff0fcb = /*#__PURE__*/ function(GraphStoreFullSprintContainsIssueStatusCategoryOutput) {
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["Done"] = "DONE";
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["New"] = "NEW";
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullSprintContainsIssueStatusCategoryOutput;
}({}); /** A full relationship edge for the relationship type sprint-retrospective-page */  /** A union of the possible hydration types for sprint-retrospective-page: [ConfluencePage] */  /** A node representing a sprint-retrospective-page relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type sprint-retrospective-whiteboard */  /** A union of the possible hydration types for sprint-retrospective-whiteboard: [ConfluenceWhiteboard] */  /** A node representing a sprint-retrospective-whiteboard relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type team-works-on-project */  /** A union of the possible hydration types for team-works-on-project: [JiraProject] */  /** A node representing a team-works-on-project relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type version-associated-branch */  /** A node representing a version-associated-branch relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-branch: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-build */  /** A node representing a version-associated-build relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-build: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-commit */  /** A node representing a version-associated-commit relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-commit: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-deployment */  /** A union of the possible hydration types for version-associated-deployment: [DeploymentSummary] */  /** A node representing a version-associated-deployment relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-deployment: [JiraVersion] */ 
let $78ad46e0d6808149$export$50919f92f150f4c2 = /*#__PURE__*/ function(GraphStoreFullVersionAssociatedDesignDesignStatusOutput) {
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["None"] = "NONE";
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullVersionAssociatedDesignDesignStatusOutput;
}({});
let $78ad46e0d6808149$export$a1b88d68d1f49808 = /*#__PURE__*/ function(GraphStoreFullVersionAssociatedDesignDesignTypeOutput) {
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Canvas"] = "CANVAS";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["File"] = "FILE";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Group"] = "GROUP";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Node"] = "NODE";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Other"] = "OTHER";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Prototype"] = "PROTOTYPE";
    return GraphStoreFullVersionAssociatedDesignDesignTypeOutput;
}({}); /** A full relationship edge for the relationship type version-associated-design */  /** A union of the possible hydration types for version-associated-design: [DevOpsDesign] */  /** A node representing a version-associated-design relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-design: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-feature-flag */  /** A union of the possible hydration types for version-associated-feature-flag: [DevOpsFeatureFlag] */  /** A node representing a version-associated-feature-flag relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-feature-flag: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-issue */  /** A union of the possible hydration types for version-associated-issue: [JiraIssue] */  /** A node representing a version-associated-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-issue: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-pull-request */  /** A union of the possible hydration types for version-associated-pull-request: [DevOpsPullRequestDetails] */  /** A node representing a version-associated-pull-request relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-pull-request: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-remote-link */  /** A node representing a version-associated-remote-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-remote-link: [JiraVersion] */  /** A full relationship edge for the relationship type version-user-associated-feature-flag */  /** A union of the possible hydration types for version-user-associated-feature-flag: [DevOpsFeatureFlag] */  /** A node representing a version-user-associated-feature-flag relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-user-associated-feature-flag: [JiraVersion] */  /** A full relationship edge for the relationship type vulnerability-associated-issue */  /** A union of the possible hydration types for vulnerability-associated-issue: [JiraIssue] */  /** A node representing a vulnerability-associated-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for vulnerability-associated-issue: [DevOpsSecurityVulnerabilityDetails] */ 
let $78ad46e0d6808149$export$fabcab228e2ed9c7 = /*#__PURE__*/ function(GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput) {
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput;
}({});
let $78ad46e0d6808149$export$6e4f0b0ee9bb1b2b = /*#__PURE__*/ function(GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput) {
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput;
}({});
let $78ad46e0d6808149$export$4ec664baba8498fa = /*#__PURE__*/ function(GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput) {
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Dast"] = "DAST";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Sast"] = "SAST";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Sca"] = "SCA";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput;
}({});
let $78ad46e0d6808149$export$ca58efde64d86f94 = /*#__PURE__*/ function(GraphStoreIssueAssociatedDeploymentDeploymentState) {
    GraphStoreIssueAssociatedDeploymentDeploymentState["Cancelled"] = "CANCELLED";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Failed"] = "FAILED";
    GraphStoreIssueAssociatedDeploymentDeploymentState["InProgress"] = "IN_PROGRESS";
    GraphStoreIssueAssociatedDeploymentDeploymentState["NotSet"] = "NOT_SET";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Pending"] = "PENDING";
    GraphStoreIssueAssociatedDeploymentDeploymentState["RolledBack"] = "ROLLED_BACK";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Successful"] = "SUCCESSFUL";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Unknown"] = "UNKNOWN";
    return GraphStoreIssueAssociatedDeploymentDeploymentState;
}({});
let $78ad46e0d6808149$export$3ad8a7711584b9be = /*#__PURE__*/ function(GraphStoreIssueAssociatedDeploymentEnvironmentType) {
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["NotSet"] = "NOT_SET";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Production"] = "PRODUCTION";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Staging"] = "STAGING";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Testing"] = "TESTING";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
    return GraphStoreIssueAssociatedDeploymentEnvironmentType;
}({}); /** Conditional selection for filter field of issue-associated-deployment relationship queries */  /** Conditional selection for filter field of jsw-project-associated-incident relationship queries */ 
let $78ad46e0d6808149$export$a79c5b827301ce70 = /*#__PURE__*/ function(GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority) {
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["NotSet"] = "NOT_SET";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P1"] = "P1";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P2"] = "P2";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P3"] = "P3";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P4"] = "P4";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P5"] = "P5";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["Pending"] = "PENDING";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["Unknown"] = "UNKNOWN";
    return GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority;
}({});
let $78ad46e0d6808149$export$bb923b67e7b3c5a3 = /*#__PURE__*/ function(GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus) {
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["Done"] = "DONE";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["Indeterminate"] = "INDETERMINATE";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["New"] = "NEW";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["NotSet"] = "NOT_SET";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["Undefined"] = "UNDEFINED";
    return GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus;
}({});
let $78ad46e0d6808149$export$f153746befb8db60 = /*#__PURE__*/ function(GraphStoreProjectAssociatedBuildBuildState) {
    GraphStoreProjectAssociatedBuildBuildState["Cancelled"] = "CANCELLED";
    GraphStoreProjectAssociatedBuildBuildState["Failed"] = "FAILED";
    GraphStoreProjectAssociatedBuildBuildState["InProgress"] = "IN_PROGRESS";
    GraphStoreProjectAssociatedBuildBuildState["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedBuildBuildState["Pending"] = "PENDING";
    GraphStoreProjectAssociatedBuildBuildState["Successful"] = "SUCCESSFUL";
    GraphStoreProjectAssociatedBuildBuildState["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedBuildBuildState;
}({}); /** Conditional selection for filter field of project-associated-build relationship queries */ 
let $78ad46e0d6808149$export$3d406ab6bd989229 = /*#__PURE__*/ function(GraphStoreProjectAssociatedDeploymentDeploymentState) {
    GraphStoreProjectAssociatedDeploymentDeploymentState["Cancelled"] = "CANCELLED";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Failed"] = "FAILED";
    GraphStoreProjectAssociatedDeploymentDeploymentState["InProgress"] = "IN_PROGRESS";
    GraphStoreProjectAssociatedDeploymentDeploymentState["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Pending"] = "PENDING";
    GraphStoreProjectAssociatedDeploymentDeploymentState["RolledBack"] = "ROLLED_BACK";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Successful"] = "SUCCESSFUL";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedDeploymentDeploymentState;
}({});
let $78ad46e0d6808149$export$1e042c9b11303649 = /*#__PURE__*/ function(GraphStoreProjectAssociatedDeploymentEnvironmentType) {
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Production"] = "PRODUCTION";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Staging"] = "STAGING";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Testing"] = "TESTING";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
    return GraphStoreProjectAssociatedDeploymentEnvironmentType;
}({}); /** Conditional selection for filter field of project-associated-deployment relationship queries */  /** Conditional selection for filter field of project-associated-pr relationship queries */ 
let $78ad46e0d6808149$export$4d0f434df5bd5f5d = /*#__PURE__*/ function(GraphStoreProjectAssociatedPrPullRequestStatus) {
    GraphStoreProjectAssociatedPrPullRequestStatus["Declined"] = "DECLINED";
    GraphStoreProjectAssociatedPrPullRequestStatus["Merged"] = "MERGED";
    GraphStoreProjectAssociatedPrPullRequestStatus["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedPrPullRequestStatus["Open"] = "OPEN";
    GraphStoreProjectAssociatedPrPullRequestStatus["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedPrPullRequestStatus;
}({});
let $78ad46e0d6808149$export$7b819b5db45ec714 = /*#__PURE__*/ function(GraphStoreProjectAssociatedPrReviewerReviewerStatus) {
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["Approved"] = "APPROVED";
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["Needswork"] = "NEEDSWORK";
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["Unapproved"] = "UNAPPROVED";
    return GraphStoreProjectAssociatedPrReviewerReviewerStatus;
}({}); /** Conditional selection for filter field of project-associated-repo relationship queries */  /** Conditional selection for filter field of project-associated-vulnerability relationship queries */ 
let $78ad46e0d6808149$export$8960ee08b61499ff = /*#__PURE__*/ function(GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity) {
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Critical"] = "CRITICAL";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["High"] = "HIGH";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Low"] = "LOW";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Medium"] = "MEDIUM";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity;
}({});
let $78ad46e0d6808149$export$4079472ae478c8b5 = /*#__PURE__*/ function(GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus) {
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Closed"] = "CLOSED";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Ignored"] = "IGNORED";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Open"] = "OPEN";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus;
}({});
let $78ad46e0d6808149$export$52c8ce54b5f1ece6 = /*#__PURE__*/ function(GraphStoreProjectAssociatedVulnerabilityVulnerabilityType) {
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Dast"] = "DAST";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Sast"] = "SAST";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Sca"] = "SCA";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedVulnerabilityVulnerabilityType;
}({}); /** Conditional selection for filter field of project-has-issue relationship queries */  /** Conditional selection for filter field of service-linked-incident relationship queries */ 
let $78ad46e0d6808149$export$50ace2d33df76dc8 = /*#__PURE__*/ function(GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority) {
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["NotSet"] = "NOT_SET";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P1"] = "P1";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P2"] = "P2";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P3"] = "P3";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P4"] = "P4";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P5"] = "P5";
    return GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority;
}({});
let $78ad46e0d6808149$export$b9597115770809a4 = /*#__PURE__*/ function(GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus) {
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["Done"] = "DONE";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["Indeterminate"] = "INDETERMINATE";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["New"] = "NEW";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["NotSet"] = "NOT_SET";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["Undefined"] = "UNDEFINED";
    return GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus;
}({}); /** A simplified connection for the relationship type atlas-project-contributes-to-atlas-goal */  /** A simplified edge for the relationship type atlas-project-contributes-to-atlas-goal */  /** A simplified connection for the relationship type atlas-project-contributes-to-atlas-goal */  /** A simplified edge for the relationship type atlas-project-contributes-to-atlas-goal */  /** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareProject] */  /** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareGoal] */  /** A simplified connection for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A simplified edge for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A simplified connection for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A simplified edge for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [TownsquareProject] */  /** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [JiraIssue] */  /** A simplified connection for the relationship type component-impacted-by-incident */  /** A simplified edge for the relationship type component-impacted-by-incident */  /** A simplified connection for the relationship type component-impacted-by-incident */  /** A simplified edge for the relationship type component-impacted-by-incident */  /** A union of the possible hydration types for component-impacted-by-incident: [CompassComponent, DevOpsOperationsComponentDetails] */  /** A union of the possible hydration types for component-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A simplified connection for the relationship type component-link-is-jira-project */  /** A simplified edge for the relationship type component-link-is-jira-project */  /** A union of the possible hydration types for component-link-is-jira-project: [JiraProject] */  /** A simplified connection for the relationship type component-linked-jsw-issue */  /** A simplified edge for the relationship type component-linked-jsw-issue */  /** A simplified connection for the relationship type component-linked-jsw-issue */  /** A simplified edge for the relationship type component-linked-jsw-issue */  /** A union of the possible hydration types for component-linked-jsw-issue: [CompassComponent, DevOpsService, DevOpsOperationsComponentDetails] */  /** A union of the possible hydration types for component-linked-jsw-issue: [JiraIssue] */  /** A simplified connection for the relationship type content-referenced-entity */  /** A simplified edge for the relationship type content-referenced-entity */  /** A simplified connection for the relationship type content-referenced-entity */  /** A simplified edge for the relationship type content-referenced-entity */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage] */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, CompassComponent] */  /** A simplified connection for the relationship type focus-area-associated-to-project */  /** A simplified edge for the relationship type focus-area-associated-to-project */  /** A simplified connection for the relationship type focus-area-associated-to-project */  /** A simplified edge for the relationship type focus-area-associated-to-project */  /** A union of the possible hydration types for focus-area-associated-to-project: [MercuryFocusArea] */  /** A union of the possible hydration types for focus-area-associated-to-project: [DevOpsProjectDetails] */  /** A simplified connection for the relationship type focus-area-has-atlas-goal */  /** A simplified edge for the relationship type focus-area-has-atlas-goal */  /** A simplified connection for the relationship type focus-area-has-atlas-goal */  /** A simplified edge for the relationship type focus-area-has-atlas-goal */  /** A union of the possible hydration types for focus-area-has-atlas-goal: [MercuryFocusArea] */  /** A union of the possible hydration types for focus-area-has-atlas-goal: [TownsquareGoal] */  /** A simplified connection for the relationship type focus-area-has-focus-area */  /** A simplified edge for the relationship type focus-area-has-focus-area */  /** A simplified connection for the relationship type focus-area-has-focus-area */  /** A simplified edge for the relationship type focus-area-has-focus-area */  /** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */  /** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */  /** A simplified connection for the relationship type focus-area-has-project */  /** A simplified edge for the relationship type focus-area-has-project */  /** A simplified connection for the relationship type focus-area-has-project */  /** A simplified edge for the relationship type focus-area-has-project */  /** A union of the possible hydration types for focus-area-has-project: [MercuryFocusArea] */  /** A union of the possible hydration types for focus-area-has-project: [TownsquareProject, JiraIssue] */  /** A simplified connection for the relationship type incident-associated-post-incident-review */  /** A simplified edge for the relationship type incident-associated-post-incident-review */  /** A simplified connection for the relationship type incident-associated-post-incident-review */  /** A simplified edge for the relationship type incident-associated-post-incident-review */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A simplified connection for the relationship type incident-associated-post-incident-review-link */  /** A simplified edge for the relationship type incident-associated-post-incident-review-link */  /** A simplified connection for the relationship type incident-associated-post-incident-review-link */  /** A simplified edge for the relationship type incident-associated-post-incident-review-link */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, JiraPostIncidentReviewLink, DevOpsOperationsPostIncidentReviewDetails] */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A simplified connection for the relationship type incident-has-action-item */  /** A simplified edge for the relationship type incident-has-action-item */  /** A simplified connection for the relationship type incident-has-action-item */  /** A simplified edge for the relationship type incident-has-action-item */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue] */  /** A simplified connection for the relationship type incident-linked-jsw-issue */  /** A simplified edge for the relationship type incident-linked-jsw-issue */  /** A simplified connection for the relationship type incident-linked-jsw-issue */  /** A simplified edge for the relationship type incident-linked-jsw-issue */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue] */  /** A simplified connection for the relationship type issue-associated-branch */  /** A simplified edge for the relationship type issue-associated-branch */  /** A union of the possible hydration types for issue-associated-branch: [JiraIssue] */  /** A simplified connection for the relationship type issue-associated-build */  /** A simplified edge for the relationship type issue-associated-build */  /** A union of the possible hydration types for issue-associated-build: [JiraIssue] */  /** A simplified connection for the relationship type issue-associated-commit */  /** A simplified edge for the relationship type issue-associated-commit */  /** A union of the possible hydration types for issue-associated-commit: [JiraIssue] */  /** A simplified connection for the relationship type issue-associated-deployment */  /** A simplified edge for the relationship type issue-associated-deployment */  /** A simplified connection for the relationship type issue-associated-deployment */  /** A simplified edge for the relationship type issue-associated-deployment */  /** A union of the possible hydration types for issue-associated-deployment: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type issue-associated-design */  /** A simplified edge for the relationship type issue-associated-design */  /** A simplified connection for the relationship type issue-associated-design */  /** A simplified edge for the relationship type issue-associated-design */  /** A union of the possible hydration types for issue-associated-design: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-design: [DevOpsDesign] */  /** A simplified connection for the relationship type issue-associated-feature-flag */  /** A simplified edge for the relationship type issue-associated-feature-flag */  /** A simplified connection for the relationship type issue-associated-feature-flag */  /** A simplified edge for the relationship type issue-associated-feature-flag */  /** A union of the possible hydration types for issue-associated-feature-flag: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-feature-flag: [DevOpsFeatureFlag] */  /** A simplified connection for the relationship type issue-associated-issue-remote-link */  /** A simplified edge for the relationship type issue-associated-issue-remote-link */  /** A simplified connection for the relationship type issue-associated-issue-remote-link */  /** A simplified edge for the relationship type issue-associated-issue-remote-link */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink] */  /** A simplified connection for the relationship type issue-associated-pr */  /** A simplified edge for the relationship type issue-associated-pr */  /** A simplified connection for the relationship type issue-associated-pr */  /** A simplified edge for the relationship type issue-associated-pr */  /** A union of the possible hydration types for issue-associated-pr: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-pr: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type issue-associated-remote-link */  /** A simplified edge for the relationship type issue-associated-remote-link */  /** A union of the possible hydration types for issue-associated-remote-link: [JiraIssue] */  /** A simplified connection for the relationship type issue-changes-component */  /** A simplified edge for the relationship type issue-changes-component */  /** A simplified connection for the relationship type issue-changes-component */  /** A simplified edge for the relationship type issue-changes-component */  /** A union of the possible hydration types for issue-changes-component: [JiraIssue] */  /** A union of the possible hydration types for issue-changes-component: [CompassComponent] */  /** A simplified connection for the relationship type issue-recursive-associated-pr */  /** A simplified edge for the relationship type issue-recursive-associated-pr */  /** A simplified connection for the relationship type issue-recursive-associated-pr */  /** A simplified edge for the relationship type issue-recursive-associated-pr */  /** A union of the possible hydration types for issue-recursive-associated-pr: [JiraIssue] */  /** A union of the possible hydration types for issue-recursive-associated-pr: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type issue-to-whiteboard */  /** A simplified edge for the relationship type issue-to-whiteboard */  /** A simplified connection for the relationship type issue-to-whiteboard */  /** A simplified edge for the relationship type issue-to-whiteboard */  /** A union of the possible hydration types for issue-to-whiteboard: [JiraIssue] */  /** A union of the possible hydration types for issue-to-whiteboard: [ConfluenceWhiteboard] */  /** A simplified connection for the relationship type jira-epic-contributes-to-atlas-goal */  /** A simplified edge for the relationship type jira-epic-contributes-to-atlas-goal */  /** A simplified connection for the relationship type jira-epic-contributes-to-atlas-goal */  /** A simplified edge for the relationship type jira-epic-contributes-to-atlas-goal */  /** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [JiraIssue] */  /** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [TownsquareGoal] */  /** A simplified connection for the relationship type jira-project-associated-atlas-goal */  /** A simplified edge for the relationship type jira-project-associated-atlas-goal */  /** A simplified connection for the relationship type jira-project-associated-atlas-goal */  /** A simplified edge for the relationship type jira-project-associated-atlas-goal */  /** A union of the possible hydration types for jira-project-associated-atlas-goal: [JiraProject] */  /** A union of the possible hydration types for jira-project-associated-atlas-goal: [TownsquareGoal] */  /** A simplified connection for the relationship type jsm-project-associated-service */  /** A simplified edge for the relationship type jsm-project-associated-service */  /** A simplified connection for the relationship type jsm-project-associated-service */  /** A simplified edge for the relationship type jsm-project-associated-service */  /** A union of the possible hydration types for jsm-project-associated-service: [JiraProject] */  /** A union of the possible hydration types for jsm-project-associated-service: [DevOpsService] */  /** A simplified connection for the relationship type jsw-project-associated-component */  /** A simplified edge for the relationship type jsw-project-associated-component */  /** A simplified connection for the relationship type jsw-project-associated-component */  /** A simplified edge for the relationship type jsw-project-associated-component */  /** A union of the possible hydration types for jsw-project-associated-component: [JiraProject] */  /** A union of the possible hydration types for jsw-project-associated-component: [DevOpsService, CompassComponent, DevOpsOperationsComponentDetails] */  /** A simplified connection for the relationship type jsw-project-associated-incident */  /** A simplified edge for the relationship type jsw-project-associated-incident */  /** A simplified connection for the relationship type jsw-project-associated-incident */  /** A simplified edge for the relationship type jsw-project-associated-incident */  /** A union of the possible hydration types for jsw-project-associated-incident: [JiraProject] */  /** A union of the possible hydration types for jsw-project-associated-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A simplified connection for the relationship type jsw-project-shares-component-with-jsm-project */  /** A simplified edge for the relationship type jsw-project-shares-component-with-jsm-project */  /** A simplified connection for the relationship type jsw-project-shares-component-with-jsm-project */  /** A simplified edge for the relationship type jsw-project-shares-component-with-jsm-project */  /** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */  /** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */  /** A simplified connection for the relationship type linked-project-has-version */  /** A simplified edge for the relationship type linked-project-has-version */  /** A simplified connection for the relationship type linked-project-has-version */  /** A simplified edge for the relationship type linked-project-has-version */  /** A union of the possible hydration types for linked-project-has-version: [JiraProject] */  /** A union of the possible hydration types for linked-project-has-version: [JiraVersion] */  /** A simplified connection for the relationship type media-attached-to-content */  /** A simplified edge for the relationship type media-attached-to-content */  /** A union of the possible hydration types for media-attached-to-content: [JiraIssue, ConfluencePage] */  /** A simplified connection for the relationship type operations-container-impacted-by-incident */  /** A simplified edge for the relationship type operations-container-impacted-by-incident */  /** A simplified connection for the relationship type operations-container-impacted-by-incident */  /** A simplified edge for the relationship type operations-container-impacted-by-incident */  /** A union of the possible hydration types for operations-container-impacted-by-incident: [DevOpsService] */  /** A union of the possible hydration types for operations-container-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A simplified connection for the relationship type operations-container-improved-by-action-item */  /** A simplified edge for the relationship type operations-container-improved-by-action-item */  /** A simplified connection for the relationship type operations-container-improved-by-action-item */  /** A simplified edge for the relationship type operations-container-improved-by-action-item */  /** A union of the possible hydration types for operations-container-improved-by-action-item: [DevOpsService] */  /** A union of the possible hydration types for operations-container-improved-by-action-item: [JiraIssue] */  /** A simplified connection for the relationship type parent-document-has-child-document */  /** A simplified edge for the relationship type parent-document-has-child-document */  /** A simplified connection for the relationship type parent-document-has-child-document */  /** A simplified edge for the relationship type parent-document-has-child-document */  /** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument] */  /** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument] */  /** A simplified connection for the relationship type parent-issue-has-child-issue */  /** A simplified edge for the relationship type parent-issue-has-child-issue */  /** A simplified connection for the relationship type parent-issue-has-child-issue */  /** A simplified edge for the relationship type parent-issue-has-child-issue */  /** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */  /** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */  /** A simplified connection for the relationship type pr-in-repo */  /** A simplified edge for the relationship type pr-in-repo */  /** A simplified connection for the relationship type pr-in-repo */  /** A simplified edge for the relationship type pr-in-repo */  /** A union of the possible hydration types for pr-in-repo: [DevOpsPullRequestDetails] */  /** A union of the possible hydration types for pr-in-repo: [DevOpsRepository] */  /** A simplified connection for the relationship type project-associated-branch */  /** A simplified edge for the relationship type project-associated-branch */  /** A union of the possible hydration types for project-associated-branch: [JiraProject] */  /** A simplified connection for the relationship type project-associated-build */  /** A simplified edge for the relationship type project-associated-build */  /** A union of the possible hydration types for project-associated-build: [JiraProject] */  /** A simplified connection for the relationship type project-associated-deployment */  /** A simplified edge for the relationship type project-associated-deployment */  /** A simplified connection for the relationship type project-associated-deployment */  /** A simplified edge for the relationship type project-associated-deployment */  /** A union of the possible hydration types for project-associated-deployment: [JiraProject] */  /** A union of the possible hydration types for project-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type project-associated-feature-flag */  /** A simplified edge for the relationship type project-associated-feature-flag */  /** A simplified connection for the relationship type project-associated-feature-flag */  /** A simplified edge for the relationship type project-associated-feature-flag */  /** A union of the possible hydration types for project-associated-feature-flag: [JiraProject] */  /** A union of the possible hydration types for project-associated-feature-flag: [DevOpsFeatureFlag] */  /** A simplified connection for the relationship type project-associated-incident */  /** A simplified edge for the relationship type project-associated-incident */  /** A simplified connection for the relationship type project-associated-incident */  /** A simplified edge for the relationship type project-associated-incident */  /** A union of the possible hydration types for project-associated-incident: [JiraProject] */  /** A union of the possible hydration types for project-associated-incident: [JiraIssue] */  /** A simplified connection for the relationship type project-associated-opsgenie-team */  /** A simplified edge for the relationship type project-associated-opsgenie-team */  /** A simplified connection for the relationship type project-associated-opsgenie-team */  /** A simplified edge for the relationship type project-associated-opsgenie-team */  /** A union of the possible hydration types for project-associated-opsgenie-team: [JiraProject] */  /** A union of the possible hydration types for project-associated-opsgenie-team: [OpsgenieTeam] */  /** A simplified connection for the relationship type project-associated-pr */  /** A simplified edge for the relationship type project-associated-pr */  /** A simplified connection for the relationship type project-associated-pr */  /** A simplified edge for the relationship type project-associated-pr */  /** A union of the possible hydration types for project-associated-pr: [JiraProject] */  /** A union of the possible hydration types for project-associated-pr: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type project-associated-repo */  /** A simplified edge for the relationship type project-associated-repo */  /** A simplified connection for the relationship type project-associated-repo */  /** A simplified edge for the relationship type project-associated-repo */  /** A union of the possible hydration types for project-associated-repo: [JiraProject] */  /** A union of the possible hydration types for project-associated-repo: [DevOpsRepository] */  /** A simplified connection for the relationship type project-associated-service */  /** A simplified edge for the relationship type project-associated-service */  /** A simplified connection for the relationship type project-associated-service */  /** A simplified edge for the relationship type project-associated-service */  /** A union of the possible hydration types for project-associated-service: [JiraProject] */  /** A union of the possible hydration types for project-associated-service: [DevOpsService] */  /** A simplified connection for the relationship type project-associated-to-incident */  /** A simplified edge for the relationship type project-associated-to-incident */  /** A simplified connection for the relationship type project-associated-to-incident */  /** A simplified edge for the relationship type project-associated-to-incident */  /** A union of the possible hydration types for project-associated-to-incident: [JiraProject] */  /** A union of the possible hydration types for project-associated-to-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A simplified connection for the relationship type project-associated-to-operations-container */  /** A simplified edge for the relationship type project-associated-to-operations-container */  /** A simplified connection for the relationship type project-associated-to-operations-container */  /** A simplified edge for the relationship type project-associated-to-operations-container */  /** A union of the possible hydration types for project-associated-to-operations-container: [JiraProject] */  /** A union of the possible hydration types for project-associated-to-operations-container: [DevOpsService] */  /** A simplified connection for the relationship type project-associated-to-security-container */  /** A simplified edge for the relationship type project-associated-to-security-container */  /** A union of the possible hydration types for project-associated-to-security-container: [JiraProject] */  /** A simplified connection for the relationship type project-associated-vulnerability */  /** A simplified edge for the relationship type project-associated-vulnerability */  /** A simplified connection for the relationship type project-associated-vulnerability */  /** A simplified edge for the relationship type project-associated-vulnerability */  /** A union of the possible hydration types for project-associated-vulnerability: [JiraProject] */  /** A union of the possible hydration types for project-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A simplified connection for the relationship type project-disassociated-repo */  /** A simplified edge for the relationship type project-disassociated-repo */  /** A simplified connection for the relationship type project-disassociated-repo */  /** A simplified edge for the relationship type project-disassociated-repo */  /** A union of the possible hydration types for project-disassociated-repo: [JiraProject] */  /** A union of the possible hydration types for project-disassociated-repo: [DevOpsRepository] */  /** A simplified connection for the relationship type project-documentation-entity */  /** A simplified edge for the relationship type project-documentation-entity */  /** A simplified connection for the relationship type project-documentation-entity */  /** A simplified edge for the relationship type project-documentation-entity */  /** A union of the possible hydration types for project-documentation-entity: [JiraProject] */  /** A union of the possible hydration types for project-documentation-entity: [ConfluenceSpace, ConfluencePage, DevOpsDocument] */  /** A simplified connection for the relationship type project-documentation-page */  /** A simplified edge for the relationship type project-documentation-page */  /** A simplified connection for the relationship type project-documentation-page */  /** A simplified edge for the relationship type project-documentation-page */  /** A union of the possible hydration types for project-documentation-page: [JiraProject] */  /** A union of the possible hydration types for project-documentation-page: [ConfluencePage] */  /** A simplified connection for the relationship type project-documentation-space */  /** A simplified edge for the relationship type project-documentation-space */  /** A simplified connection for the relationship type project-documentation-space */  /** A simplified edge for the relationship type project-documentation-space */  /** A union of the possible hydration types for project-documentation-space: [JiraProject] */  /** A union of the possible hydration types for project-documentation-space: [ConfluenceSpace] */  /** A simplified connection for the relationship type project-explicitly-associated-repo */  /** A simplified edge for the relationship type project-explicitly-associated-repo */  /** A simplified connection for the relationship type project-explicitly-associated-repo */  /** A simplified edge for the relationship type project-explicitly-associated-repo */  /** A union of the possible hydration types for project-explicitly-associated-repo: [JiraProject] */  /** A union of the possible hydration types for project-explicitly-associated-repo: [DevOpsRepository] */  /** A simplified connection for the relationship type project-has-issue */  /** A simplified edge for the relationship type project-has-issue */  /** A simplified connection for the relationship type project-has-issue */  /** A simplified edge for the relationship type project-has-issue */  /** A union of the possible hydration types for project-has-issue: [JiraProject] */  /** A union of the possible hydration types for project-has-issue: [JiraIssue] */  /** A simplified connection for the relationship type project-has-related-work-with-project */  /** A simplified edge for the relationship type project-has-related-work-with-project */  /** A simplified connection for the relationship type project-has-related-work-with-project */  /** A simplified edge for the relationship type project-has-related-work-with-project */  /** A union of the possible hydration types for project-has-related-work-with-project: [JiraProject] */  /** A union of the possible hydration types for project-has-related-work-with-project: [JiraProject] */  /** A simplified connection for the relationship type project-has-shared-version-with */  /** A simplified edge for the relationship type project-has-shared-version-with */  /** A simplified connection for the relationship type project-has-shared-version-with */  /** A simplified edge for the relationship type project-has-shared-version-with */  /** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */  /** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */  /** A simplified connection for the relationship type project-has-version */  /** A simplified edge for the relationship type project-has-version */  /** A simplified connection for the relationship type project-has-version */  /** A simplified edge for the relationship type project-has-version */  /** A union of the possible hydration types for project-has-version: [JiraProject] */  /** A union of the possible hydration types for project-has-version: [JiraVersion] */  /** A simplified connection for the relationship type project-linked-to-compass-component */  /** A simplified edge for the relationship type project-linked-to-compass-component */  /** A simplified connection for the relationship type project-linked-to-compass-component */  /** A simplified edge for the relationship type project-linked-to-compass-component */  /** A union of the possible hydration types for project-linked-to-compass-component: [JiraProject] */  /** A union of the possible hydration types for project-linked-to-compass-component: [CompassComponent] */  /** A simplified connection for the relationship type security-container-associated-to-vulnerability */  /** A simplified edge for the relationship type security-container-associated-to-vulnerability */  /** A union of the possible hydration types for security-container-associated-to-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A simplified connection for the relationship type service-associated-deployment */  /** A simplified edge for the relationship type service-associated-deployment */  /** A simplified connection for the relationship type service-associated-deployment */  /** A simplified edge for the relationship type service-associated-deployment */  /** A union of the possible hydration types for service-associated-deployment: [DevOpsService] */  /** A union of the possible hydration types for service-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type service-linked-incident */  /** A simplified edge for the relationship type service-linked-incident */  /** A simplified connection for the relationship type service-linked-incident */  /** A simplified edge for the relationship type service-linked-incident */  /** A union of the possible hydration types for service-linked-incident: [DevOpsService] */  /** A union of the possible hydration types for service-linked-incident: [JiraIssue] */  /** A simplified connection for the relationship type space-associated-with-project */  /** A simplified edge for the relationship type space-associated-with-project */  /** A simplified connection for the relationship type space-associated-with-project */  /** A simplified edge for the relationship type space-associated-with-project */  /** A union of the possible hydration types for space-associated-with-project: [ConfluenceSpace] */  /** A union of the possible hydration types for space-associated-with-project: [JiraProject] */  /** A simplified connection for the relationship type sprint-associated-deployment */  /** A simplified edge for the relationship type sprint-associated-deployment */  /** A union of the possible hydration types for sprint-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type sprint-associated-pr */  /** A simplified edge for the relationship type sprint-associated-pr */  /** A union of the possible hydration types for sprint-associated-pr: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type sprint-associated-vulnerability */  /** A simplified edge for the relationship type sprint-associated-vulnerability */  /** A union of the possible hydration types for sprint-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A simplified connection for the relationship type sprint-contains-issue */  /** A simplified edge for the relationship type sprint-contains-issue */  /** A union of the possible hydration types for sprint-contains-issue: [JiraIssue] */  /** A simplified connection for the relationship type sprint-retrospective-page */  /** A simplified edge for the relationship type sprint-retrospective-page */  /** A union of the possible hydration types for sprint-retrospective-page: [ConfluencePage] */  /** A simplified connection for the relationship type sprint-retrospective-whiteboard */  /** A simplified edge for the relationship type sprint-retrospective-whiteboard */  /** A union of the possible hydration types for sprint-retrospective-whiteboard: [ConfluenceWhiteboard] */  /** A simplified connection for the relationship type team-owns-component */  /** A simplified edge for the relationship type team-owns-component */  /** A union of the possible hydration types for team-owns-component: [CompassComponent] */  /** A simplified connection for the relationship type team-works-on-project */  /** A simplified edge for the relationship type team-works-on-project */  /** A union of the possible hydration types for team-works-on-project: [JiraProject] */  /** A simplified connection for the relationship type user-owns-component */  /** A simplified edge for the relationship type user-owns-component */  /** A union of the possible hydration types for user-owns-component: [CompassComponent] */  /** A simplified connection for the relationship type version-associated-branch */  /** A simplified edge for the relationship type version-associated-branch */  /** A union of the possible hydration types for version-associated-branch: [JiraVersion] */  /** A simplified connection for the relationship type version-associated-build */  /** A simplified edge for the relationship type version-associated-build */  /** A union of the possible hydration types for version-associated-build: [JiraVersion] */  /** A simplified connection for the relationship type version-associated-commit */  /** A simplified edge for the relationship type version-associated-commit */  /** A union of the possible hydration types for version-associated-commit: [JiraVersion] */  /** A simplified connection for the relationship type version-associated-deployment */  /** A simplified edge for the relationship type version-associated-deployment */  /** A simplified connection for the relationship type version-associated-deployment */  /** A simplified edge for the relationship type version-associated-deployment */  /** A union of the possible hydration types for version-associated-deployment: [JiraVersion] */  /** A union of the possible hydration types for version-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type version-associated-design */  /** A simplified edge for the relationship type version-associated-design */  /** A simplified connection for the relationship type version-associated-design */  /** A simplified edge for the relationship type version-associated-design */  /** A union of the possible hydration types for version-associated-design: [JiraVersion] */  /** A union of the possible hydration types for version-associated-design: [DevOpsDesign] */  /** A simplified connection for the relationship type version-associated-feature-flag */  /** A simplified edge for the relationship type version-associated-feature-flag */  /** A simplified connection for the relationship type version-associated-feature-flag */  /** A simplified edge for the relationship type version-associated-feature-flag */  /** A union of the possible hydration types for version-associated-feature-flag: [JiraVersion] */  /** A union of the possible hydration types for version-associated-feature-flag: [DevOpsFeatureFlag] */  /** A simplified connection for the relationship type version-associated-issue */  /** A simplified edge for the relationship type version-associated-issue */  /** A simplified connection for the relationship type version-associated-issue */  /** A simplified edge for the relationship type version-associated-issue */  /** A union of the possible hydration types for version-associated-issue: [JiraVersion] */  /** A union of the possible hydration types for version-associated-issue: [JiraIssue] */  /** A simplified connection for the relationship type version-associated-pull-request */  /** A simplified edge for the relationship type version-associated-pull-request */  /** A simplified connection for the relationship type version-associated-pull-request */  /** A simplified edge for the relationship type version-associated-pull-request */  /** A union of the possible hydration types for version-associated-pull-request: [JiraVersion] */  /** A union of the possible hydration types for version-associated-pull-request: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type version-associated-remote-link */  /** A simplified edge for the relationship type version-associated-remote-link */  /** A union of the possible hydration types for version-associated-remote-link: [JiraVersion] */  /** A simplified connection for the relationship type version-user-associated-feature-flag */  /** A simplified edge for the relationship type version-user-associated-feature-flag */  /** A simplified connection for the relationship type version-user-associated-feature-flag */  /** A simplified edge for the relationship type version-user-associated-feature-flag */  /** A union of the possible hydration types for version-user-associated-feature-flag: [JiraVersion] */  /** A union of the possible hydration types for version-user-associated-feature-flag: [DevOpsFeatureFlag] */  /** A simplified connection for the relationship type vulnerability-associated-issue */  /** A simplified edge for the relationship type vulnerability-associated-issue */  /** A simplified connection for the relationship type vulnerability-associated-issue */  /** A simplified edge for the relationship type vulnerability-associated-issue */  /** A union of the possible hydration types for vulnerability-associated-issue: [DevOpsSecurityVulnerabilityDetails] */  /** A union of the possible hydration types for vulnerability-associated-issue: [JiraIssue] */ 
let $78ad46e0d6808149$export$f295a95cd0626a8f = /*#__PURE__*/ function(GraphStoreSprintAssociatedBuildBuildState) {
    GraphStoreSprintAssociatedBuildBuildState["Cancelled"] = "CANCELLED";
    GraphStoreSprintAssociatedBuildBuildState["Failed"] = "FAILED";
    GraphStoreSprintAssociatedBuildBuildState["InProgress"] = "IN_PROGRESS";
    GraphStoreSprintAssociatedBuildBuildState["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedBuildBuildState["Pending"] = "PENDING";
    GraphStoreSprintAssociatedBuildBuildState["Successful"] = "SUCCESSFUL";
    GraphStoreSprintAssociatedBuildBuildState["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedBuildBuildState;
}({}); /** Conditional selection for filter field of sprint-associated-build relationship queries */ 
let $78ad46e0d6808149$export$6df900849642cd1c = /*#__PURE__*/ function(GraphStoreSprintAssociatedDeploymentDeploymentState) {
    GraphStoreSprintAssociatedDeploymentDeploymentState["Cancelled"] = "CANCELLED";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Failed"] = "FAILED";
    GraphStoreSprintAssociatedDeploymentDeploymentState["InProgress"] = "IN_PROGRESS";
    GraphStoreSprintAssociatedDeploymentDeploymentState["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Pending"] = "PENDING";
    GraphStoreSprintAssociatedDeploymentDeploymentState["RolledBack"] = "ROLLED_BACK";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Successful"] = "SUCCESSFUL";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedDeploymentDeploymentState;
}({});
let $78ad46e0d6808149$export$9f4efa40f1a0faae = /*#__PURE__*/ function(GraphStoreSprintAssociatedDeploymentEnvironmentType) {
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Production"] = "PRODUCTION";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Staging"] = "STAGING";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Testing"] = "TESTING";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
    return GraphStoreSprintAssociatedDeploymentEnvironmentType;
}({}); /** Conditional selection for filter field of sprint-associated-deployment relationship queries */  /** Conditional selection for filter field of sprint-associated-pr relationship queries */ 
let $78ad46e0d6808149$export$5ffbe3a12bdc5b6c = /*#__PURE__*/ function(GraphStoreSprintAssociatedPrPullRequestStatus) {
    GraphStoreSprintAssociatedPrPullRequestStatus["Declined"] = "DECLINED";
    GraphStoreSprintAssociatedPrPullRequestStatus["Merged"] = "MERGED";
    GraphStoreSprintAssociatedPrPullRequestStatus["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedPrPullRequestStatus["Open"] = "OPEN";
    GraphStoreSprintAssociatedPrPullRequestStatus["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedPrPullRequestStatus;
}({});
let $78ad46e0d6808149$export$b397a81d3b3345af = /*#__PURE__*/ function(GraphStoreSprintAssociatedPrReviewerReviewerStatus) {
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["Approved"] = "APPROVED";
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["Needswork"] = "NEEDSWORK";
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["Unapproved"] = "UNAPPROVED";
    return GraphStoreSprintAssociatedPrReviewerReviewerStatus;
}({}); /** Conditional selection for filter field of sprint-associated-vulnerability relationship queries */ 
let $78ad46e0d6808149$export$9ee1edc61daf0f8a = /*#__PURE__*/ function(GraphStoreSprintAssociatedVulnerabilityStatusCategory) {
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["Done"] = "DONE";
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["Indeterminate"] = "INDETERMINATE";
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["New"] = "NEW";
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["Undefined"] = "UNDEFINED";
    return GraphStoreSprintAssociatedVulnerabilityStatusCategory;
}({});
let $78ad46e0d6808149$export$67d1797c0aa2ad19 = /*#__PURE__*/ function(GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity) {
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Critical"] = "CRITICAL";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["High"] = "HIGH";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Low"] = "LOW";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Medium"] = "MEDIUM";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity;
}({});
let $78ad46e0d6808149$export$e55dd9ead99d6d9f = /*#__PURE__*/ function(GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus) {
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Closed"] = "CLOSED";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Ignored"] = "IGNORED";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Open"] = "OPEN";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus;
}({}); /** Conditional selection for filter field of sprint-contains-issue relationship queries */ 
let $78ad46e0d6808149$export$296e777b040fe873 = /*#__PURE__*/ function(GraphStoreSprintContainsIssueStatusCategory) {
    GraphStoreSprintContainsIssueStatusCategory["Done"] = "DONE";
    GraphStoreSprintContainsIssueStatusCategory["Indeterminate"] = "INDETERMINATE";
    GraphStoreSprintContainsIssueStatusCategory["New"] = "NEW";
    GraphStoreSprintContainsIssueStatusCategory["Undefined"] = "UNDEFINED";
    return GraphStoreSprintContainsIssueStatusCategory;
}({});
let $78ad46e0d6808149$export$318f148359ce1fb1 = /*#__PURE__*/ function(GraphStoreVersionAssociatedDesignDesignStatus) {
    GraphStoreVersionAssociatedDesignDesignStatus["None"] = "NONE";
    GraphStoreVersionAssociatedDesignDesignStatus["NotSet"] = "NOT_SET";
    GraphStoreVersionAssociatedDesignDesignStatus["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    GraphStoreVersionAssociatedDesignDesignStatus["Unknown"] = "UNKNOWN";
    return GraphStoreVersionAssociatedDesignDesignStatus;
}({});
let $78ad46e0d6808149$export$c81e290110aa4fde = /*#__PURE__*/ function(GraphStoreVersionAssociatedDesignDesignType) {
    GraphStoreVersionAssociatedDesignDesignType["Canvas"] = "CANVAS";
    GraphStoreVersionAssociatedDesignDesignType["File"] = "FILE";
    GraphStoreVersionAssociatedDesignDesignType["Group"] = "GROUP";
    GraphStoreVersionAssociatedDesignDesignType["Node"] = "NODE";
    GraphStoreVersionAssociatedDesignDesignType["NotSet"] = "NOT_SET";
    GraphStoreVersionAssociatedDesignDesignType["Other"] = "OTHER";
    GraphStoreVersionAssociatedDesignDesignType["Prototype"] = "PROTOTYPE";
    return GraphStoreVersionAssociatedDesignDesignType;
}({}); /** Conditional selection for filter field of version-associated-design relationship queries */  /**
 * The context object provides essential insights into the users' current experience and operations.
 *
 * The supported product and subproduct keys can be found at https://hello.atlassian.net/wiki/spaces/ECON/pages/2339030895/App+Identifiers
 */ 
let $78ad46e0d6808149$export$b5409d01f4236473 = /*#__PURE__*/ function(GrowthUnifiedProfileAnchorType) {
    GrowthUnifiedProfileAnchorType["Pfm"] = "PFM";
    GrowthUnifiedProfileAnchorType["Seo"] = "SEO";
    return GrowthUnifiedProfileAnchorType;
}({}); /**
 * Channel type, this information will be extracted from the query parameters and other sources, such as ML
 * mapping file
 */ 
let $78ad46e0d6808149$export$d608f92bd278cb63 = /*#__PURE__*/ function(GrowthUnifiedProfileChannelName) {
    GrowthUnifiedProfileChannelName["Comarketing"] = "COMARKETING";
    GrowthUnifiedProfileChannelName["Direct"] = "DIRECT";
    GrowthUnifiedProfileChannelName["Email"] = "EMAIL";
    GrowthUnifiedProfileChannelName["EngagementEngine"] = "ENGAGEMENT_ENGINE";
    GrowthUnifiedProfileChannelName["InProductReferral"] = "IN_PRODUCT_REFERRAL";
    GrowthUnifiedProfileChannelName["Organic"] = "ORGANIC";
    GrowthUnifiedProfileChannelName["Other"] = "OTHER";
    GrowthUnifiedProfileChannelName["PaidAffiliate"] = "PAID_AFFILIATE";
    GrowthUnifiedProfileChannelName["PaidDisplay"] = "PAID_DISPLAY";
    GrowthUnifiedProfileChannelName["PaidReviewSites"] = "PAID_REVIEW_SITES";
    GrowthUnifiedProfileChannelName["PaidSearchBranded"] = "PAID_SEARCH_BRANDED";
    GrowthUnifiedProfileChannelName["PaidSearchNonBranded"] = "PAID_SEARCH_NON_BRANDED";
    GrowthUnifiedProfileChannelName["PaidSocial"] = "PAID_SOCIAL";
    GrowthUnifiedProfileChannelName["ReferralExternal"] = "REFERRAL_EXTERNAL";
    GrowthUnifiedProfileChannelName["ReferralInternal"] = "REFERRAL_INTERNAL";
    GrowthUnifiedProfileChannelName["SelfReferral"] = "SELF_REFERRAL";
    GrowthUnifiedProfileChannelName["SlackAppDirectory"] = "SLACK_APP_DIRECTORY";
    GrowthUnifiedProfileChannelName["Suppress"] = "SUPPRESS";
    GrowthUnifiedProfileChannelName["UnpaidSocial"] = "UNPAID_SOCIAL";
    GrowthUnifiedProfileChannelName["UnpaidVideo"] = "UNPAID_VIDEO";
    return GrowthUnifiedProfileChannelName;
}({});
let $78ad46e0d6808149$export$eb044d0d19d592c7 = /*#__PURE__*/ function(GrowthUnifiedProfileCompanySize) {
    GrowthUnifiedProfileCompanySize["Large"] = "LARGE";
    GrowthUnifiedProfileCompanySize["Medium"] = "MEDIUM";
    GrowthUnifiedProfileCompanySize["Small"] = "SMALL";
    GrowthUnifiedProfileCompanySize["Unknown"] = "UNKNOWN";
    return GrowthUnifiedProfileCompanySize;
}({});
let $78ad46e0d6808149$export$4582f4191dc3bb0e = /*#__PURE__*/ function(GrowthUnifiedProfileCompanyType) {
    GrowthUnifiedProfileCompanyType["Private"] = "PRIVATE";
    GrowthUnifiedProfileCompanyType["Public"] = "PUBLIC";
    return GrowthUnifiedProfileCompanyType;
}({});
let $78ad46e0d6808149$export$28880b034aa5dc30 = /*#__PURE__*/ function(GrowthUnifiedProfileEnrichmentStatus) {
    GrowthUnifiedProfileEnrichmentStatus["Complete"] = "COMPLETE";
    GrowthUnifiedProfileEnrichmentStatus["Error"] = "ERROR";
    GrowthUnifiedProfileEnrichmentStatus["InProgress"] = "IN_PROGRESS";
    GrowthUnifiedProfileEnrichmentStatus["Pending"] = "PENDING";
    return GrowthUnifiedProfileEnrichmentStatus;
}({});
let $78ad46e0d6808149$export$8d96e2c494b1d62c = /*#__PURE__*/ function(GrowthUnifiedProfileEnterpriseAccountStatus) {
    GrowthUnifiedProfileEnterpriseAccountStatus["Bronze"] = "BRONZE";
    GrowthUnifiedProfileEnterpriseAccountStatus["Gam"] = "GAM";
    GrowthUnifiedProfileEnterpriseAccountStatus["Gold"] = "GOLD";
    GrowthUnifiedProfileEnterpriseAccountStatus["Platimun"] = "PLATIMUN";
    GrowthUnifiedProfileEnterpriseAccountStatus["Silver"] = "SILVER";
    return GrowthUnifiedProfileEnterpriseAccountStatus;
}({});
let $78ad46e0d6808149$export$71e2332d6e22a291 = /*#__PURE__*/ function(GrowthUnifiedProfileEntityType) {
    GrowthUnifiedProfileEntityType["AjsAnonymousUser"] = "AJS_ANONYMOUS_USER";
    GrowthUnifiedProfileEntityType["AtlassianAccount"] = "ATLASSIAN_ACCOUNT";
    GrowthUnifiedProfileEntityType["Org"] = "ORG";
    GrowthUnifiedProfileEntityType["Site"] = "SITE";
    return GrowthUnifiedProfileEntityType;
}({});
let $78ad46e0d6808149$export$c49017e7afc08542 = /*#__PURE__*/ function(GrowthUnifiedProfileJtbd) {
    GrowthUnifiedProfileJtbd["Budgets"] = "BUDGETS";
    GrowthUnifiedProfileJtbd["CdWrtng"] = "CD_WRTNG";
    GrowthUnifiedProfileJtbd["ImproveWorkflow"] = "IMPROVE_WORKFLOW";
    GrowthUnifiedProfileJtbd["LaunchCampaigns"] = "LAUNCH_CAMPAIGNS";
    GrowthUnifiedProfileJtbd["MarketingContent"] = "MARKETING_CONTENT";
    GrowthUnifiedProfileJtbd["PlanAndManage"] = "PLAN_AND_MANAGE";
    GrowthUnifiedProfileJtbd["ProjectPlanning"] = "PROJECT_PLANNING";
    GrowthUnifiedProfileJtbd["ProjectProgress"] = "PROJECT_PROGRESS";
    GrowthUnifiedProfileJtbd["Stakeholders"] = "STAKEHOLDERS";
    GrowthUnifiedProfileJtbd["StrategiesAndGoals"] = "STRATEGIES_AND_GOALS";
    GrowthUnifiedProfileJtbd["TrackingRprtng"] = "TRACKING_RPRTNG";
    GrowthUnifiedProfileJtbd["UseKanbanBoard"] = "USE_KANBAN_BOARD";
    return GrowthUnifiedProfileJtbd;
}({});
let $78ad46e0d6808149$export$5990898c79cc1feb = /*#__PURE__*/ function(GrowthUnifiedProfileJiraFamiliarity) {
    GrowthUnifiedProfileJiraFamiliarity["Experience"] = "EXPERIENCE";
    GrowthUnifiedProfileJiraFamiliarity["Middle"] = "MIDDLE";
    GrowthUnifiedProfileJiraFamiliarity["New"] = "NEW";
    return GrowthUnifiedProfileJiraFamiliarity;
}({}); /** onboarding context input for jira */  /** onboarding context type for jira or confluence */  /** onboarding context input for jira or confluence */ 
let $78ad46e0d6808149$export$110930cf5e2a2eff = /*#__PURE__*/ function(GrowthUnifiedProfileTeamType) {
    GrowthUnifiedProfileTeamType["CustomerService"] = "CUSTOMER_SERVICE";
    GrowthUnifiedProfileTeamType["Design"] = "DESIGN";
    GrowthUnifiedProfileTeamType["Finance"] = "FINANCE";
    GrowthUnifiedProfileTeamType["HumanResources"] = "HUMAN_RESOURCES";
    GrowthUnifiedProfileTeamType["ItSupport"] = "IT_SUPPORT";
    GrowthUnifiedProfileTeamType["Legal"] = "LEGAL";
    GrowthUnifiedProfileTeamType["Marketing"] = "MARKETING";
    GrowthUnifiedProfileTeamType["Operations"] = "OPERATIONS";
    GrowthUnifiedProfileTeamType["Other"] = "OTHER";
    GrowthUnifiedProfileTeamType["Sales"] = "SALES";
    GrowthUnifiedProfileTeamType["SoftwareDevelopment"] = "SOFTWARE_DEVELOPMENT";
    return GrowthUnifiedProfileTeamType;
}({}); /** Utm typr will be extracted from the url query parameters */  /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $78ad46e0d6808149$export$a4bd4d15a9a3d3f1 = /*#__PURE__*/ function(HelpCenterDescriptionType) {
    HelpCenterDescriptionType["PlainText"] = "PLAIN_TEXT";
    HelpCenterDescriptionType["RichText"] = "RICH_TEXT";
    HelpCenterDescriptionType["WikiMarkup"] = "WIKI_MARKUP";
    return HelpCenterDescriptionType;
}({}); /** Media config provides auth credentials and relevant information to upload images for media related elements. */  /** This describes the type of operation for which mediaConfig needs to be generated */ 
let $78ad46e0d6808149$export$9f54202027f49420 = /*#__PURE__*/ function(HelpCenterMediaConfigOperationType) {
    HelpCenterMediaConfigOperationType["BannerUpload"] = "BANNER_UPLOAD";
    HelpCenterMediaConfigOperationType["LogoUpload"] = "LOGO_UPLOAD";
    return HelpCenterMediaConfigOperationType;
}({});
let $78ad46e0d6808149$export$de6d4d4c47123061 = /*#__PURE__*/ function(HelpCenterPortalsSortOrder) {
    HelpCenterPortalsSortOrder["NameAscending"] = "NAME_ASCENDING";
    HelpCenterPortalsSortOrder["Popularity"] = "POPULARITY";
    return HelpCenterPortalsSortOrder;
}({});
let $78ad46e0d6808149$export$10df61f732f39a6d = /*#__PURE__*/ function(HelpCenterPortalsType) {
    HelpCenterPortalsType["Featured"] = "FEATURED";
    HelpCenterPortalsType["Hidden"] = "HIDDEN";
    HelpCenterPortalsType["Visible"] = "VISIBLE";
    return HelpCenterPortalsType;
}({});
let $78ad46e0d6808149$export$bf41d3d919083034 = /*#__PURE__*/ function(HelpCenterProjectMappingOperationType) {
    HelpCenterProjectMappingOperationType["MapProjects"] = "MAP_PROJECTS";
    HelpCenterProjectMappingOperationType["UnmapProjects"] = "UNMAP_PROJECTS";
    return HelpCenterProjectMappingOperationType;
}({});
let $78ad46e0d6808149$export$98ecf93df3b75669 = /*#__PURE__*/ function(HelpCenterProjectType) {
    HelpCenterProjectType["CustomerService"] = "CUSTOMER_SERVICE";
    HelpCenterProjectType["ServiceDesk"] = "SERVICE_DESK";
    return HelpCenterProjectType;
}({}); /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /**
 * #########################
 *  Base objects for help-center
 * #########################
 */ 
let $78ad46e0d6808149$export$db18c35dcd3a9e38 = /*#__PURE__*/ function(HelpCenterSortOrder) {
    HelpCenterSortOrder["CreatedDateAscending"] = "CREATED_DATE_ASCENDING";
    HelpCenterSortOrder["CreatedDateDescending"] = "CREATED_DATE_DESCENDING";
    return HelpCenterSortOrder;
}({});
let $78ad46e0d6808149$export$404b16ab15b3352c = /*#__PURE__*/ function(HelpCenterType) {
    HelpCenterType["Advanced"] = "ADVANCED";
    HelpCenterType["Basic"] = "BASIC";
    HelpCenterType["CustomerService"] = "CUSTOMER_SERVICE";
    HelpCenterType["Unified"] = "UNIFIED";
    return HelpCenterType;
}({});
let $78ad46e0d6808149$export$25877d5a420a6e71 = /*#__PURE__*/ function(HelpExternalResourceLinkResourceType) {
    HelpExternalResourceLinkResourceType["Channel"] = "CHANNEL";
    HelpExternalResourceLinkResourceType["Knowledge"] = "KNOWLEDGE";
    HelpExternalResourceLinkResourceType["RequestForm"] = "REQUEST_FORM";
    return HelpExternalResourceLinkResourceType;
}({}); /** Mutation */  /** Mutation */  /** Mutation */  /** Mutation */  /** Query Types */  /** Query Types */  /** Represents a layout in the system. */  /** Represents a layout in the system. */  /** Announcement Atomic Element */  /** Portals List Input */  /** This union represents all the atomic elements. */  /**
 * This input type will be used to mutate Atomic Elements inside Composite Elements.
 * This type is used only inside a Composite Element
 */ 
let $78ad46e0d6808149$export$4f955d957799126e = /*#__PURE__*/ function(HelpLayoutAtomicElementKey) {
    HelpLayoutAtomicElementKey["Announcement"] = "ANNOUNCEMENT";
    HelpLayoutAtomicElementKey["Connect"] = "CONNECT";
    HelpLayoutAtomicElementKey["Editor"] = "EDITOR";
    HelpLayoutAtomicElementKey["Forge"] = "FORGE";
    HelpLayoutAtomicElementKey["Heading"] = "HEADING";
    HelpLayoutAtomicElementKey["Hero"] = "HERO";
    HelpLayoutAtomicElementKey["Image"] = "IMAGE";
    HelpLayoutAtomicElementKey["NoContent"] = "NO_CONTENT";
    HelpLayoutAtomicElementKey["Paragraph"] = "PARAGRAPH";
    HelpLayoutAtomicElementKey["PortalsList"] = "PORTALS_LIST";
    HelpLayoutAtomicElementKey["Search"] = "SEARCH";
    HelpLayoutAtomicElementKey["SuggestedRequestFormsList"] = "SUGGESTED_REQUEST_FORMS_LIST";
    HelpLayoutAtomicElementKey["TopicsList"] = "TOPICS_LIST";
    return HelpLayoutAtomicElementKey;
}({}); /** Represents Atomic Element Types. They are fetched while rendering the catalogue. */  /** Represents Atomic Element Types. They are fetched while rendering the catalogue. */  /** This interface is implemented by all composite elements. */  /** This enum represents all the composite element keys. */ 
let $78ad46e0d6808149$export$576a5650ed3956e9 = /*#__PURE__*/ function(HelpLayoutCompositeElementKey) {
    HelpLayoutCompositeElementKey["LinkCard"] = "LINK_CARD";
    return HelpLayoutCompositeElementKey;
}({}); /** Represents Composite Element Types. They are fetched while rendering the catalogue. */  /** Connect App Element */ 
let $78ad46e0d6808149$export$d614d14eebc9034e = /*#__PURE__*/ function(HelpLayoutConnectElementPages) {
    HelpLayoutConnectElementPages["Approvals"] = "APPROVALS";
    HelpLayoutConnectElementPages["CreateRequest"] = "CREATE_REQUEST";
    HelpLayoutConnectElementPages["HelpCenter"] = "HELP_CENTER";
    HelpLayoutConnectElementPages["MyRequest"] = "MY_REQUEST";
    HelpLayoutConnectElementPages["Portal"] = "PORTAL";
    HelpLayoutConnectElementPages["Profile"] = "PROFILE";
    HelpLayoutConnectElementPages["ViewRequest"] = "VIEW_REQUEST";
    return HelpLayoutConnectElementPages;
}({});
let $78ad46e0d6808149$export$13477f5de7466343 = /*#__PURE__*/ function(HelpLayoutConnectElementType) {
    HelpLayoutConnectElementType["DetailsPanels"] = "detailsPanels";
    HelpLayoutConnectElementType["FooterPanels"] = "footerPanels";
    HelpLayoutConnectElementType["HeaderAndSubheaderPanels"] = "headerAndSubheaderPanels";
    HelpLayoutConnectElementType["HeaderPanels"] = "headerPanels";
    HelpLayoutConnectElementType["OptionPanels"] = "optionPanels";
    HelpLayoutConnectElementType["ProfilePagePanel"] = "profilePagePanel";
    HelpLayoutConnectElementType["PropertyPanels"] = "propertyPanels";
    HelpLayoutConnectElementType["RequestCreatePanel"] = "requestCreatePanel";
    HelpLayoutConnectElementType["SubheaderPanels"] = "subheaderPanels";
    return HelpLayoutConnectElementType;
}({}); /** Connect App Input */  /** Editor Element */  /** Editor Input */  /** This union represents all elements, atomic and composite. */  /** This enum represents all the element category. */ 
let $78ad46e0d6808149$export$66fddc1b3eb3d42f = /*#__PURE__*/ function(HelpLayoutElementCategory) {
    HelpLayoutElementCategory["Basic"] = "BASIC";
    HelpLayoutElementCategory["Navigation"] = "NAVIGATION";
    return HelpLayoutElementCategory;
}({}); /**
 * This input type can mutate both atomic and composite elements. Since there is no polymorphism in input types in graphql.
 * Client will have to send the Key to the element they are mutating and respective config.
 * Only one of the config fields will be specified. "elementTypeKey" should match the config provided.
 */ 
let $78ad46e0d6808149$export$7e4f0d562642895e = /*#__PURE__*/ function(HelpLayoutElementKey) {
    HelpLayoutElementKey["Announcement"] = "ANNOUNCEMENT";
    HelpLayoutElementKey["Connect"] = "CONNECT";
    HelpLayoutElementKey["Editor"] = "EDITOR";
    HelpLayoutElementKey["Forge"] = "FORGE";
    HelpLayoutElementKey["Heading"] = "HEADING";
    HelpLayoutElementKey["Hero"] = "HERO";
    HelpLayoutElementKey["Image"] = "IMAGE";
    HelpLayoutElementKey["LinkCard"] = "LINK_CARD";
    HelpLayoutElementKey["NoContent"] = "NO_CONTENT";
    HelpLayoutElementKey["Paragraph"] = "PARAGRAPH";
    HelpLayoutElementKey["PortalsList"] = "PORTALS_LIST";
    HelpLayoutElementKey["Search"] = "SEARCH";
    HelpLayoutElementKey["SuggestedRequestFormsList"] = "SUGGESTED_REQUEST_FORMS_LIST";
    HelpLayoutElementKey["TopicsList"] = "TOPICS_LIST";
    return HelpLayoutElementKey;
}({}); /** This interface represents all the element types which are supported by this schema. */  /** Forge App Element */ 
let $78ad46e0d6808149$export$443851e78d175634 = /*#__PURE__*/ function(HelpLayoutForgeElementPages) {
    HelpLayoutForgeElementPages["Approvals"] = "approvals";
    HelpLayoutForgeElementPages["CreateRequest"] = "create_request";
    HelpLayoutForgeElementPages["HelpCenter"] = "help_center";
    HelpLayoutForgeElementPages["MyRequests"] = "my_requests";
    HelpLayoutForgeElementPages["Portal"] = "portal";
    HelpLayoutForgeElementPages["Profile"] = "profile";
    HelpLayoutForgeElementPages["ViewRequest"] = "view_request";
    return HelpLayoutForgeElementPages;
}({});
let $78ad46e0d6808149$export$fd51ac42041cdcaa = /*#__PURE__*/ function(HelpLayoutForgeElementType) {
    HelpLayoutForgeElementType["Footer"] = "FOOTER";
    HelpLayoutForgeElementType["HeaderAndSubheader"] = "HEADER_AND_SUBHEADER";
    return HelpLayoutForgeElementType;
}({}); /** Forge App Input */  /** Heading Atomic Element */  /** Heading Input */ 
let $78ad46e0d6808149$export$ddbaabbc700bfb0f = /*#__PURE__*/ function(HelpLayoutHeadingType) {
    HelpLayoutHeadingType["H1"] = "h1";
    HelpLayoutHeadingType["H2"] = "h2";
    HelpLayoutHeadingType["H3"] = "h3";
    HelpLayoutHeadingType["H4"] = "h4";
    HelpLayoutHeadingType["H5"] = "h5";
    HelpLayoutHeadingType["H6"] = "h6";
    return HelpLayoutHeadingType;
}({}); /** Hero Element */  /** Hero Element Input */ 
let $78ad46e0d6808149$export$dc0242f9aced7a72 = /*#__PURE__*/ function(HelpLayoutHorizontalAlignment) {
    HelpLayoutHorizontalAlignment["Center"] = "CENTER";
    HelpLayoutHorizontalAlignment["Left"] = "LEFT";
    HelpLayoutHorizontalAlignment["Right"] = "RIGHT";
    return HelpLayoutHorizontalAlignment;
}({}); /** Image Atomic Element */  /** Image Input */  /** Link card Composite Element */  /** Link card input */  /** Media config provides auth credentials and relevant information to upload images for media related elements. */  /**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */ 
let $78ad46e0d6808149$export$da6edd2e84621f40 = /*#__PURE__*/ function(HelpLayoutProjectType) {
    HelpLayoutProjectType["CustomerService"] = "CUSTOMER_SERVICE";
    HelpLayoutProjectType["ServiceDesk"] = "SERVICE_DESK";
    return HelpLayoutProjectType;
}({}); /**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */ 
let $78ad46e0d6808149$export$29b8c6e9ec83845e = /*#__PURE__*/ function(HelpLayoutVerticalAlignment) {
    HelpLayoutVerticalAlignment["Bottom"] = "BOTTOM";
    HelpLayoutVerticalAlignment["Middle"] = "MIDDLE";
    HelpLayoutVerticalAlignment["Top"] = "TOP";
    return HelpLayoutVerticalAlignment;
}({}); /** This represents the visual properties */  /** This represents the visual config input required during mutation */  /**
 * Any element or type that implements visualEntity will get visual config as a field which contains visual properties.
 * Think of this as visual config provider used to provide config such as border, bg-color and so on.
 */ 
let $78ad46e0d6808149$export$fca880a7c8a28341 = /*#__PURE__*/ function(HelpObjectStoreHelpObjectType) {
    HelpObjectStoreHelpObjectType["Article"] = "ARTICLE";
    HelpObjectStoreHelpObjectType["Channel"] = "CHANNEL";
    HelpObjectStoreHelpObjectType["Portal"] = "PORTAL";
    HelpObjectStoreHelpObjectType["RequestForm"] = "REQUEST_FORM";
    return HelpObjectStoreHelpObjectType;
}({});
let $78ad46e0d6808149$export$5a6a464de3389453 = /*#__PURE__*/ function(HelpObjectStoreJsmEntityType) {
    HelpObjectStoreJsmEntityType["Article"] = "ARTICLE";
    HelpObjectStoreJsmEntityType["Channel"] = "CHANNEL";
    HelpObjectStoreJsmEntityType["Portal"] = "PORTAL";
    HelpObjectStoreJsmEntityType["RequestForm"] = "REQUEST_FORM";
    return HelpObjectStoreJsmEntityType;
}({});
let $78ad46e0d6808149$export$714c6e1043f92681 = /*#__PURE__*/ function(HelpObjectStoreSearchAlgorithm) {
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnIssues"] = "KEYWORD_SEARCH_ON_ISSUES";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnPortalsBm25"] = "KEYWORD_SEARCH_ON_PORTALS_BM25";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnPortalsExactMatch"] = "KEYWORD_SEARCH_ON_PORTALS_EXACT_MATCH";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnRequestTypesBm25"] = "KEYWORD_SEARCH_ON_REQUEST_TYPES_BM25";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnRequestTypesExactMatch"] = "KEYWORD_SEARCH_ON_REQUEST_TYPES_EXACT_MATCH";
    return HelpObjectStoreSearchAlgorithm;
}({});
let $78ad46e0d6808149$export$82309e1a4e81fdbf = /*#__PURE__*/ function(HelpObjectStoreSearchBackend) {
    HelpObjectStoreSearchBackend["Jira"] = "JIRA";
    HelpObjectStoreSearchBackend["SearchPlatform"] = "SEARCH_PLATFORM";
    return HelpObjectStoreSearchBackend;
}({});
let $78ad46e0d6808149$export$3cd8bacd120e7d23 = /*#__PURE__*/ function(HelpObjectStoreSearchEntityType) {
    HelpObjectStoreSearchEntityType["Article"] = "ARTICLE";
    HelpObjectStoreSearchEntityType["Channel"] = "CHANNEL";
    HelpObjectStoreSearchEntityType["Portal"] = "PORTAL";
    HelpObjectStoreSearchEntityType["RequestForm"] = "REQUEST_FORM";
    return HelpObjectStoreSearchEntityType;
}({});
let $78ad46e0d6808149$export$78a7af08ea3c76ad = /*#__PURE__*/ function(HelpObjectStoreSearchableEntityType) {
    HelpObjectStoreSearchableEntityType["Article"] = "ARTICLE";
    HelpObjectStoreSearchableEntityType["RequestForm"] = "REQUEST_FORM";
    return HelpObjectStoreSearchableEntityType;
}({}); /** Call-to-action link where the notification is directed to. */ 
let $78ad46e0d6808149$export$add9b70bcde2a1e5 = /*#__PURE__*/ function(InfluentsNotificationAppearance) {
    InfluentsNotificationAppearance["Danger"] = "DANGER";
    InfluentsNotificationAppearance["Default"] = "DEFAULT";
    InfluentsNotificationAppearance["Link"] = "LINK";
    InfluentsNotificationAppearance["Primary"] = "PRIMARY";
    InfluentsNotificationAppearance["Subtle"] = "SUBTLE";
    InfluentsNotificationAppearance["Warning"] = "WARNING";
    return InfluentsNotificationAppearance;
}({}); /**
 * A body item can be sent with two types of appearances, PRIMARY and QUOTED.
 * The latter can be used to for sending comment reply style notifications.
 */ 
let $78ad46e0d6808149$export$3f759331ea860587 = /*#__PURE__*/ function(InfluentsNotificationCategory) {
    InfluentsNotificationCategory["Direct"] = "direct";
    InfluentsNotificationCategory["Watching"] = "watching";
    return InfluentsNotificationCategory;
}({}); /**
 * The Entity is what the notification relates to –
 * in most cases it’s the object (page, issue, pull request) that has been interacted with.
 * Clicking the title takes the user to the entity.
 * An entity can have a related icon.
 */ 
let $78ad46e0d6808149$export$d50fb347f614347c = /*#__PURE__*/ function(InfluentsNotificationReadState) {
    InfluentsNotificationReadState["Read"] = "read";
    InfluentsNotificationReadState["Unread"] = "unread";
    return InfluentsNotificationReadState;
}({}); /** Input for the mutation operations (snooze and remove). */ 
let $78ad46e0d6808149$export$2fe6ad0d43104840 = /*#__PURE__*/ function(InsightsApprovalStatus) {
    InsightsApprovalStatus["Approved"] = "APPROVED";
    InsightsApprovalStatus["Needswork"] = "NEEDSWORK";
    InsightsApprovalStatus["Unapproved"] = "UNAPPROVED";
    InsightsApprovalStatus["Unknown"] = "UNKNOWN";
    return InsightsApprovalStatus;
}({}); /** A context of either sprint or project Ari */ 
let $78ad46e0d6808149$export$2aa37f5a6634dc51 = /*#__PURE__*/ function(InsightsEnvironmentType) {
    InsightsEnvironmentType["Development"] = "DEVELOPMENT";
    InsightsEnvironmentType["Production"] = "PRODUCTION";
    InsightsEnvironmentType["Staging"] = "STAGING";
    InsightsEnvironmentType["Testing"] = "TESTING";
    InsightsEnvironmentType["Unmapped"] = "UNMAPPED";
    return InsightsEnvironmentType;
}({}); /** Input for the onboarding mutation operations (purge / snooze / remove). */ 
let $78ad46e0d6808149$export$32b11fa8a4db8f2e = /*#__PURE__*/ function(InsightsNextBestTaskAction) {
    InsightsNextBestTaskAction["Remove"] = "REMOVE";
    InsightsNextBestTaskAction["Snooze"] = "SNOOZE";
    return InsightsNextBestTaskAction;
}({}); /**
 * Defines whether we show the github onboarding UX
 * VISIBLE means JFE should render the onboarding UX
 * HIDDEN means user is already onboarded, do not show UX
 * SNOOZED means user snoozed the recommendation
 * REMOVED means user explicitly hid the recommendation
 */ 
let $78ad46e0d6808149$export$a20071bd470d2580 = /*#__PURE__*/ function(InsightsRecommendationVisibility) {
    InsightsRecommendationVisibility["Hidden"] = "HIDDEN";
    InsightsRecommendationVisibility["Removed"] = "REMOVED";
    InsightsRecommendationVisibility["Snoozed"] = "SNOOZED";
    InsightsRecommendationVisibility["Visible"] = "VISIBLE";
    return InsightsRecommendationVisibility;
}({});
let $78ad46e0d6808149$export$ef229f124986e5a0 = /*#__PURE__*/ function(InsightsTaskType) {
    InsightsTaskType["BlockingIssue"] = "BLOCKING_ISSUE";
    InsightsTaskType["BuildFailed"] = "BUILD_FAILED";
    InsightsTaskType["CritVuln"] = "CRIT_VULN";
    InsightsTaskType["DeploymentFailed"] = "DEPLOYMENT_FAILED";
    InsightsTaskType["PrNeedsWork"] = "PR_NEEDS_WORK";
    InsightsTaskType["PrReview"] = "PR_REVIEW";
    return InsightsTaskType;
}({}); /** Action object stored in the database for the actions snooze/remove task. */ 
let $78ad46e0d6808149$export$8efcfbc5b7f2cb2f = /*#__PURE__*/ function(InsightsVulnerabilityStatus) {
    InsightsVulnerabilityStatus["Closed"] = "CLOSED";
    InsightsVulnerabilityStatus["Ignored"] = "IGNORED";
    InsightsVulnerabilityStatus["Open"] = "OPEN";
    InsightsVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return InsightsVulnerabilityStatus;
}({}); /** The metrics returned on each invocation */  /** The data returned from a function invocation */  /** Input payload for the invoke aux mutation */  /** The response from an AUX effects invocation */  /** Input payload for the invoke mutation */  /** The response from a function invocation */  /** Detailed information of a repository's branch */  /** Short description of a pull request associated with a branch */  /** Detailed information about a build tied to a provider */  /** A build pipeline provider */  /** Information that links a build to a version control system (commits, branches, etc.) */ 
let $78ad46e0d6808149$export$338894d2bcfa1c6c = /*#__PURE__*/ function(IssueDevOpsCommitChangeType) {
    IssueDevOpsCommitChangeType["Added"] = "ADDED";
    IssueDevOpsCommitChangeType["Copied"] = "COPIED";
    IssueDevOpsCommitChangeType["Deleted"] = "DELETED";
    IssueDevOpsCommitChangeType["Modified"] = "MODIFIED";
    IssueDevOpsCommitChangeType["Modify"] = "MODIFY";
    IssueDevOpsCommitChangeType["Moved"] = "MOVED";
    IssueDevOpsCommitChangeType["Unknown"] = "UNKNOWN";
    return IssueDevOpsCommitChangeType;
}({}); /** Detailed information of a commit in a repository */  /** Information of a file modified in a commit */  /** Detailed information of a deployment */ 
let $78ad46e0d6808149$export$99413405dc72cb24 = /*#__PURE__*/ function(IssueDevOpsDeploymentEnvironmentType) {
    IssueDevOpsDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    IssueDevOpsDeploymentEnvironmentType["Production"] = "PRODUCTION";
    IssueDevOpsDeploymentEnvironmentType["Staging"] = "STAGING";
    IssueDevOpsDeploymentEnvironmentType["Testing"] = "TESTING";
    IssueDevOpsDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
    return IssueDevOpsDeploymentEnvironmentType;
}({}); /**
 * This object witholds deployment providers essential information,
 * as well as its list of latest deployments per pipeline.
 * A provider without deployments related to the asked issueId will not be returned.
 */ 
let $78ad46e0d6808149$export$df40bbb79dc09c24 = /*#__PURE__*/ function(IssueDevOpsDeploymentState) {
    IssueDevOpsDeploymentState["Cancelled"] = "CANCELLED";
    IssueDevOpsDeploymentState["Failed"] = "FAILED";
    IssueDevOpsDeploymentState["InProgress"] = "IN_PROGRESS";
    IssueDevOpsDeploymentState["Pending"] = "PENDING";
    IssueDevOpsDeploymentState["RolledBack"] = "ROLLED_BACK";
    IssueDevOpsDeploymentState["Successful"] = "SUCCESSFUL";
    IssueDevOpsDeploymentState["Unknown"] = "UNKNOWN";
    return IssueDevOpsDeploymentState;
}({}); /** Aggregates all the instance types (bitbucket, stash, github) and its development information */  /** Information related to the development process of an issue */  /** Information related to the development process of an issue */  /**
 * A set of booleans that indicate if the embedded marketplace
 * should be shown if a user does not have installed providers
 */ 
let $78ad46e0d6808149$export$93807e2ffddb6d99 = /*#__PURE__*/ function(IssueDevOpsPullRequestStatus) {
    IssueDevOpsPullRequestStatus["Declined"] = "DECLINED";
    IssueDevOpsPullRequestStatus["Draft"] = "DRAFT";
    IssueDevOpsPullRequestStatus["Merged"] = "MERGED";
    IssueDevOpsPullRequestStatus["Open"] = "OPEN";
    IssueDevOpsPullRequestStatus["Unknown"] = "UNKNOWN";
    return IssueDevOpsPullRequestStatus;
}({}); /** Detailed information of a VCS repository */  /** Short description of the parent repository from which the fork was made */  /** Short desciption of a review associated with a branch or commit */  /** A summary for the tests results for a particular build */  /** Represents a JSM Incident. */ 
let $78ad46e0d6808149$export$7aab904fe49fa56e = /*#__PURE__*/ function(JsmIncidentLinkDirection) {
    JsmIncidentLinkDirection["Inward"] = "INWARD";
    JsmIncidentLinkDirection["Outward"] = "OUTWARD";
    return JsmIncidentLinkDirection;
}({});
let $78ad46e0d6808149$export$cd35cf091a6250bb = /*#__PURE__*/ function(JsmMajorIncident) {
    JsmMajorIncident["MajorIncident"] = "MAJOR_INCIDENT";
    return JsmMajorIncident;
}({}); /** Represents the Atlassian Document Format content in JSON format. */  /** Represents the Atlassian Document Format content in JSON format. */  /** Input type for ADF values on fields */  /** Shows the Atlassian Intelligence feature to the end user. */  /** The different action types that a user can perform on a global level */ 
let $78ad46e0d6808149$export$b40f2294e83c8458 = /*#__PURE__*/ function(JiraActionType) {
    JiraActionType["CreateCompanyManagedProject"] = "CREATE_COMPANY_MANAGED_PROJECT";
    JiraActionType["CreateProject"] = "CREATE_PROJECT";
    JiraActionType["CreateTeamManagedProject"] = "CREATE_TEAM_MANAGED_PROJECT";
    return JiraActionType;
}({}); /** The input to associate issues with a fix version. */  /** The return payload of associating issues with a fix version. */  /** Input to create a new related work item and associated with a version. */  /** The return payload of creating a new related work item and associating it with a version. */  /** Operations that can be performed on fields like attachments and issuelinks etc. */ 
let $78ad46e0d6808149$export$7dab5913fedb74fb = /*#__PURE__*/ function(JiraAddValueFieldOperations) {
    JiraAddValueFieldOperations["Add"] = "ADD";
    return JiraAddValueFieldOperations;
}({}); /** The list of values for supported fields for the issue */  /** The connection type for JiraAdditionalIssueFields including the pagination information */  /** Represents ADF converted to plain text. */  /** Attributes of user configurations specific to richText field */  /** Attributes of user configurations specific to richText field */  /** Navigation information for the currently logged in user regarding Advanced Roadmaps for Jira */  /**
 * Represents an affected service entity for a Jira Issue.
 * AffectedService provides context on what has been changed.
 */ 
let $78ad46e0d6808149$export$35561b7f9e1f55e5 = /*#__PURE__*/ function(JiraAnnouncementBannerVisibility) {
    JiraAnnouncementBannerVisibility["Private"] = "PRIVATE";
    JiraAnnouncementBannerVisibility["Public"] = "PUBLIC";
    return JiraAnnouncementBannerVisibility;
}({}); /** The approval decision input */  /** Config states for an app with a specific id */  /** Config states for an app with a specific id */  /** Connection object representing config state for a set of jira apps */  /** Connection edge representing config state for one jira app */  /** Represent the config information required for a connect/forge app navigation item or nested link */  /** Represents a connect/forge app top-level navigation item */  /** Represents a connect/forge app nested navigation item */  /** Represents the navigation item type for a specific Connect or Forge app. */  /**
 * Represents a nested section for connect/forge apps
 * A collection of orphan/non-sectioned links will also be grouped as a section without a label
 */ 
let $78ad46e0d6808149$export$ce082fc9df0d76d9 = /*#__PURE__*/ function(JiraAppType) {
    JiraAppType["Connect"] = "CONNECT";
    JiraAppType["Forge"] = "FORGE";
    return JiraAppType;
}({}); /** A list of all UI modifications for an app and environment */  /** Representation of each Jira application/sub-product. */ 
let $78ad46e0d6808149$export$3041ba651e0f5411 = /*#__PURE__*/ function(JiraApplicationKey) {
    JiraApplicationKey["JiraCore"] = "JIRA_CORE";
    JiraApplicationKey["JiraProductDiscovery"] = "JIRA_PRODUCT_DISCOVERY";
    JiraApplicationKey["JiraServiceDesk"] = "JIRA_SERVICE_DESK";
    JiraApplicationKey["JiraSoftware"] = "JIRA_SOFTWARE";
    return JiraApplicationKey;
}({}); /**
 * Jira application properties is effectively a key/value store scoped to a Jira instance. A JiraApplicationProperty
 * represents one of these key/value pairs, along with associated metadata about the property.
 */ 
let $78ad46e0d6808149$export$b45afd01a571a7c3 = /*#__PURE__*/ function(JiraApprovalDecision) {
    JiraApprovalDecision["Approved"] = "APPROVED";
    JiraApprovalDecision["Rejected"] = "REJECTED";
    return JiraApprovalDecision;
}({}); /** The input type to approve access request of connected workspace(organization in Jira term) */  /** The response payload to approve access request of connected workspace(organization in Jira term) */  /** Input type to filter archived issues */  /** Field Options for filter by fields for getting archived issues */  /** Field Options for filter by fields for getting archived issues */  /** Field Options for filter by fields for getting archived issues */  /** Field Options for filter by fields for getting archived issues */  /** Input type for archival date range */  /** Represents a single option value for an asset field. */  /** The connection type for JiraAsset. */  /** An edge in a JiraAsset connection. */  /** Represents the Asset field on a Jira Issue. */  /** Represents the Asset field on a Jira Issue. */  /** Input type for asset field */  /** Input type for asset value */  /**
 * DEPRECATED: Superseded by issue linking
 *
 * Input to assign/unassign a related work item to a user.
 */ 
let $78ad46e0d6808149$export$ff923d46af5bc866 = /*#__PURE__*/ function(JiraAtlassianIntelligenceFeatureEnum) {
    JiraAtlassianIntelligenceFeatureEnum["AiMate"] = "AI_MATE";
    JiraAtlassianIntelligenceFeatureEnum["NaturalLanguageToJql"] = "NATURAL_LANGUAGE_TO_JQL";
    return JiraAtlassianIntelligenceFeatureEnum;
}({}); /** Input used to specify which product or feature to check for Atlassian Intelligence. */  /** Deprecated type. Please use `JiraTeamView` instead. */  /** Deprecated type. */  /** Deprecated type. */  /** Represents the Atlassian team field on a Jira Issue. Allows you to select a team to be associated with an issue. */  /** Represents the Atlassian team field on a Jira Issue. Allows you to select a team to be associated with an issue. */  /** Input type for Atlassian team field */  /** Input type for Atlassian team data */  /** An interface shared across all attachment types. */  /** An interface shared across all attachment types. */  /** A Jira Attachment Background, used only when the entity is of Issue type */  /** The connection type for JiraAttachment. */  /** An edge in a JiraAttachment connection. */  /** Input type for defining the operation on the Attachment field of a Jira issue. */  /** The payload type returned after updating the IssueType field of a Jira issue. */  /** Represents a fixed set of attachments' parents */ 
let $78ad46e0d6808149$export$e58d203181411860 = /*#__PURE__*/ function(JiraAttachmentParentName) {
    JiraAttachmentParentName["Comment"] = "COMMENT";
    JiraAttachmentParentName["Customfield"] = "CUSTOMFIELD";
    JiraAttachmentParentName["Description"] = "DESCRIPTION";
    JiraAttachmentParentName["Environment"] = "ENVIRONMENT";
    JiraAttachmentParentName["Form"] = "FORM";
    JiraAttachmentParentName["Issue"] = "ISSUE";
    JiraAttachmentParentName["Worklog"] = "WORKLOG";
    return JiraAttachmentParentName;
}({}); /** The field for sorting attachments. */ 
let $78ad46e0d6808149$export$4452eb40a75908b1 = /*#__PURE__*/ function(JiraAttachmentSortField) {
    JiraAttachmentSortField["Created"] = "CREATED";
    return JiraAttachmentSortField;
}({}); /** Deprecated type. Please use `attachments` field under `JiraIssue` instead. */  /** Deprecated type. Please use `attachments` field under `JiraIssue` instead. */ 
let $78ad46e0d6808149$export$add469b410e3b948 = /*#__PURE__*/ function(JiraAttachmentsPermissions) {
    JiraAttachmentsPermissions["CreateAttachments"] = "CREATE_ATTACHMENTS";
    JiraAttachmentsPermissions["DeleteOwnAttachments"] = "DELETE_OWN_ATTACHMENTS";
    return JiraAttachmentsPermissions;
}({}); /** The payload response for basic autodev mutations */  /** JiraAutodevCodeChange represents a code change associated with the Autodev Job */  /** JiraAutodevCodeChangeConnection represents the connection object for Code changes associated with the Autodev Job */  /** JiraAutodevCodeChangeEdge represents the code change edge object associated with the Autodev Job */  /** Renamed to JiraAutodevCodeChangeEnumType to be compatible with jira/gira prefix validation */ 
let $78ad46e0d6808149$export$20cf66312c009d2a = /*#__PURE__*/ function(JiraAutodevCodeChangeEnumType) {
    JiraAutodevCodeChangeEnumType["Add"] = "ADD";
    JiraAutodevCodeChangeEnumType["Delete"] = "DELETE";
    JiraAutodevCodeChangeEnumType["Edit"] = "EDIT";
    JiraAutodevCodeChangeEnumType["Other"] = "OTHER";
    return JiraAutodevCodeChangeEnumType;
}({}); /** The payload response for the create an autofix job mutation */  /** Autodev job response */  /** Autodev/acra job connection */  /** Connection edge representing autodev job */  /** Autodev job state */ 
let $78ad46e0d6808149$export$7c2c34d9bc1709c = /*#__PURE__*/ function(JiraAutodevPhase) {
    JiraAutodevPhase["CodeGenerating"] = "CODE_GENERATING";
    JiraAutodevPhase["CodeReview"] = "CODE_REVIEW";
    JiraAutodevPhase["CodeReGenerating"] = "CODE_RE_GENERATING";
    JiraAutodevPhase["PlanGenerating"] = "PLAN_GENERATING";
    JiraAutodevPhase["PlanReview"] = "PLAN_REVIEW";
    JiraAutodevPhase["PlanReGenerating"] = "PLAN_RE_GENERATING";
    return JiraAutodevPhase;
}({}); /** Autodev Job Plan */  /** JiraAutodevPlannedChange represents a planned code change associated with the Autodev Job */  /** JiraAutodevPullRequest represents one pull request associated with the Autodev Job */  /** JiraAutodevPullRequestConnection represents the connection object for Pull requests associated with the Autodev Job */  /** JiraAutodevPullRequestEdge represents the pull request edge object associated with the Autodev Job */  /** Autodev job state */ 
let $78ad46e0d6808149$export$9d46e21e99abf4d9 = /*#__PURE__*/ function(JiraAutodevState) {
    JiraAutodevState["Cancelled"] = "CANCELLED";
    JiraAutodevState["CodeGenerating"] = "CODE_GENERATING";
    JiraAutodevState["CodeGenerationFail"] = "CODE_GENERATION_FAIL";
    JiraAutodevState["CodeGenerationReady"] = "CODE_GENERATION_READY";
    JiraAutodevState["CodeGenerationSuccess"] = "CODE_GENERATION_SUCCESS";
    JiraAutodevState["Created"] = "CREATED";
    JiraAutodevState["PlanGenerating"] = "PLAN_GENERATING";
    JiraAutodevState["PlanGenerationFail"] = "PLAN_GENERATION_FAIL";
    JiraAutodevState["PlanGenerationSuccess"] = "PLAN_GENERATION_SUCCESS";
    JiraAutodevState["PullrequestCreating"] = "PULLREQUEST_CREATING";
    JiraAutodevState["PullrequestCreationFail"] = "PULLREQUEST_CREATION_FAIL";
    JiraAutodevState["PullrequestCreationSuccess"] = "PULLREQUEST_CREATION_SUCCESS";
    JiraAutodevState["Unknown"] = "UNKNOWN";
    return JiraAutodevState;
}({}); /** Autodev job status */ 
let $78ad46e0d6808149$export$b45cf8febb3440fe = /*#__PURE__*/ function(JiraAutodevStatus) {
    JiraAutodevStatus["Cancelled"] = "CANCELLED";
    JiraAutodevStatus["Completed"] = "COMPLETED";
    JiraAutodevStatus["Failed"] = "FAILED";
    JiraAutodevStatus["InProgress"] = "IN_PROGRESS";
    JiraAutodevStatus["Pending"] = "PENDING";
    return JiraAutodevStatus;
}({}); /** JiraAutodevStatusHistoryItem represents one status history item associated with the Autodev Job */  /** JiraAutodevStatusHistoryItemConnection represents the connection object for status history items associated with the Autodev Job */  /** JiraAutodevStatusHistoryItemEdge represents the status history item edge object associated with the Autodev Job */  /** JiraAutodevTaskConnection represents the connection object for individual tasks in the plan for the Autodev Job */  /** Response from creating an autofix job */  /** The input type to create an autofix job */  /** Autofix job response */  /** Autofix job connection */  /** Connection edge representing autofix job */  /** Type of autofix job */ 
let $78ad46e0d6808149$export$ffe042497b182587 = /*#__PURE__*/ function(JiraAutofixJobType) {
    JiraAutofixJobType["InternalRemoveFeatureFlag"] = "INTERNAL_REMOVE_FEATURE_FLAG";
    return JiraAutofixJobType;
}({}); /** Autofix job status */ 
let $78ad46e0d6808149$export$9bc56f5589387f27 = /*#__PURE__*/ function(JiraAutofixStatus) {
    JiraAutofixStatus["Completed"] = "COMPLETED";
    JiraAutofixStatus["Failed"] = "FAILED";
    JiraAutofixStatus["InProgress"] = "IN_PROGRESS";
    JiraAutofixStatus["Pending"] = "PENDING";
    return JiraAutofixStatus;
}({}); /** Represents the four avatar sizes' url. */  /** Interface for backgrounds */  /** The supported background types */ 
let $78ad46e0d6808149$export$2c2631a0fafec4d2 = /*#__PURE__*/ function(JiraBackgroundType) {
    JiraBackgroundType["Attachment"] = "ATTACHMENT";
    JiraBackgroundType["Color"] = "COLOR";
    JiraBackgroundType["Custom"] = "CUSTOM";
    JiraBackgroundType["Gradient"] = "GRADIENT";
    JiraBackgroundType["Unsplash"] = "UNSPLASH";
    return JiraBackgroundType;
}({}); /** Type to hold Jira Background upload token auth details */ 
let $78ad46e0d6808149$export$a91e934e29660252 = /*#__PURE__*/ function(JiraBatchWindowPreference) {
    JiraBatchWindowPreference["DefaultBatching"] = "DEFAULT_BATCHING";
    JiraBatchWindowPreference["FifteenMinutes"] = "FIFTEEN_MINUTES";
    JiraBatchWindowPreference["FiveMinutes"] = "FIVE_MINUTES";
    JiraBatchWindowPreference["NoBatching"] = "NO_BATCHING";
    JiraBatchWindowPreference["OncePerDay"] = "ONCE_PER_DAY";
    JiraBatchWindowPreference["OneDay"] = "ONE_DAY";
    JiraBatchWindowPreference["OneHour"] = "ONE_HOUR";
    JiraBatchWindowPreference["TenMinutes"] = "TEN_MINUTES";
    JiraBatchWindowPreference["ThirtyMinutes"] = "THIRTY_MINUTES";
    return JiraBatchWindowPreference;
}({}); /**
 * The internal BB app which provides devOps capabilities
 * This provider will be filtered out from the list of providers if BB SCM is not installed
 */ 
let $78ad46e0d6808149$export$fffb97f85a99dcd3 = /*#__PURE__*/ function(JiraBitbucketWorkspaceApprovalState) {
    JiraBitbucketWorkspaceApprovalState["Approved"] = "APPROVED";
    JiraBitbucketWorkspaceApprovalState["PendingApproval"] = "PENDING_APPROVAL";
    return JiraBitbucketWorkspaceApprovalState;
}({}); /** Represents a Jira Board */  /** The connection type for JiraBoard */  /** An edge in a JiraBoard connection */  /** Types of containers that boards can be located in */ 
let $78ad46e0d6808149$export$4dc98413456458b = /*#__PURE__*/ function(JiraBoardLocationType) {
    JiraBoardLocationType["Project"] = "PROJECT";
    JiraBoardLocationType["User"] = "USER";
    return JiraBoardLocationType;
}({}); /** A union type representing Jira boards within a Jira project */  /** Types of Jira boards */ 
let $78ad46e0d6808149$export$97a2fe75628224ea = /*#__PURE__*/ function(JiraBoardType) {
    JiraBoardType["Kanban"] = "KANBAN";
    JiraBoardType["Scrum"] = "SCRUM";
    return JiraBoardType;
}({}); /** Represents a generic boolean field for an Issue. E.g. JSM alert linking. */  /** The input type for scheduling the execution of project cleanup recommendations */  /** The payload type for bulk project archiving and trashing */  /** Retrieves a field which can be bulk edited */  /** Retrieves a connection of fields which can be bulk edited */  /** An edge in a BulkEditFields connection. */  /** Specifies inputs for search on fields and a boolean to override them */  /** Specified bulk edit operation input */  /**
 * Contains all options available for fields with multi select options available
 * This field is required only for 4 system field: Fix Versions, Affects Versions, Label and Component
 */ 
let $78ad46e0d6808149$export$8dcaa522c00e0bea = /*#__PURE__*/ function(JiraBulkEditMultiSelectFieldOptions) {
    JiraBulkEditMultiSelectFieldOptions["Add"] = "ADD";
    JiraBulkEditMultiSelectFieldOptions["Remove"] = "REMOVE";
    JiraBulkEditMultiSelectFieldOptions["RemoveAll"] = "REMOVE_ALL";
    JiraBulkEditMultiSelectFieldOptions["Replace"] = "REPLACE";
    return JiraBulkEditMultiSelectFieldOptions;
}({}); /** Specified bulk operation input */  /** Specified the type of bulk operation */ 
let $78ad46e0d6808149$export$65634ab0c72ca58 = /*#__PURE__*/ function(JiraBulkOperationType) {
    JiraBulkOperationType["BulkEdit"] = "BULK_EDIT";
    JiraBulkOperationType["BulkTransition"] = "BULK_TRANSITION";
    return JiraBulkOperationType;
}({}); /** Retrives a list of transitions for given issues */  /** Retrives a list of transitions for given issues */  /** Retrives a list of transitions for given issues */  /** Retrieves a connection of transitions applicable for a given list of issues */  /** An edge in a bulk transition connection. */  /** Represents the screen layout for a transition and set of issues. */  /** Represents the screen layout for a transition and set of issues. */  /** Input type for bulk transition */  /** Represents CMDB (Configuration Management Database) field on a Jira Issue. */  /** Represents CMDB (Configuration Management Database) field on a Jira Issue. */ 
let $78ad46e0d6808149$export$598ca3e7e63eeac3 = /*#__PURE__*/ function(JiraCalendarMode) {
    JiraCalendarMode["Day"] = "DAY";
    JiraCalendarMode["Month"] = "MONTH";
    JiraCalendarMode["Week"] = "WEEK";
    return JiraCalendarMode;
}({}); /** An edge in a JiraProjectPermission connection. */ 
let $78ad46e0d6808149$export$80636f9ce4ef8927 = /*#__PURE__*/ function(JiraCalendarPermissionKey) {
    JiraCalendarPermissionKey["ManageSprintsPermission"] = "MANAGE_SPRINTS_PERMISSION";
    return JiraCalendarPermissionKey;
}({}); /** View settings for Jira Calendar */ 
let $78ad46e0d6808149$export$56103bfe65fcf045 = /*#__PURE__*/ function(JiraCalendarWeekStart) {
    JiraCalendarWeekStart["Monday"] = "MONDAY";
    JiraCalendarWeekStart["Saturday"] = "SATURDAY";
    JiraCalendarWeekStart["Sunday"] = "SUNDAY";
    return JiraCalendarWeekStart;
}({}); /** Canned response entity created against a project with defined scope. */  /**
 * #########################
 *  Mutation Inputs
 * #########################
 */ 
let $78ad46e0d6808149$export$ce8ee5a026b40f80 = /*#__PURE__*/ function(JiraCannedResponseScope) {
    JiraCannedResponseScope["Personal"] = "PERSONAL";
    JiraCannedResponseScope["Project"] = "PROJECT";
    return JiraCannedResponseScope;
}({});
let $78ad46e0d6808149$export$c55b15b4975ca485 = /*#__PURE__*/ function(JiraCannedResponseSortOrder) {
    JiraCannedResponseSortOrder["Asc"] = "ASC";
    JiraCannedResponseSortOrder["Desc"] = "DESC";
    return JiraCannedResponseSortOrder;
}({}); /**
 * Represents the pair of values (parent & child combination) in a cascading select.
 * This type is used to represent a selected cascading field value on a Jira Issue.
 * Since this is 2 level hierarchy, it is not possible to represent the same underlying
 * type for both single cascadingOption and list of cascadingOptions. Thus, we have created different types.
 */ 
let $78ad46e0d6808149$export$95ff254e6924dc6f = /*#__PURE__*/ function(JiraCascadingSelectOptionType) {
    JiraCascadingSelectOptionType["All"] = "ALL";
    JiraCascadingSelectOptionType["Child"] = "CHILD";
    JiraCascadingSelectOptionType["Parent"] = "PARENT";
    return JiraCascadingSelectOptionType;
}({}); /** An input filter used to specify the cascading options returned. */  /** Represents the check boxes field on a Jira Issue. */  /** Represents the check boxes field on a Jira Issue. */  /** Represents the check boxes field on a Jira Issue. */  /** Input type for defining the operation on the Checkboxes field of a Jira issue. */  /** The payload type returned after updating the Checkboxes field of a Jira issue. */  /**
 * A union type representing childIssues available within a Jira Issue.
 * The *WithinLimit type is used for childIssues with a count that is within a limit specified by the server.
 * The *ExceedsLimit type is used for childIssues with a count that exceeds a limit specified by the server.
 */ 
let $78ad46e0d6808149$export$f34d058fb688acaf = /*#__PURE__*/ function(JiraClassificationLevelSource) {
    JiraClassificationLevelSource["Issue"] = "ISSUE";
    JiraClassificationLevelSource["Project"] = "PROJECT";
    return JiraClassificationLevelSource;
}({}); /** Enum to define the classification level status. */ 
let $78ad46e0d6808149$export$608cba47cc506457 = /*#__PURE__*/ function(JiraClassificationLevelStatus) {
    JiraClassificationLevelStatus["Archived"] = "ARCHIVED";
    JiraClassificationLevelStatus["Draft"] = "DRAFT";
    JiraClassificationLevelStatus["Published"] = "PUBLISHED";
    return JiraClassificationLevelStatus;
}({}); /** Enum to define the classification level type. */ 
let $78ad46e0d6808149$export$a6a7c946782bf432 = /*#__PURE__*/ function(JiraClassificationLevelType) {
    JiraClassificationLevelType["System"] = "SYSTEM";
    JiraClassificationLevelType["User"] = "USER";
    return JiraClassificationLevelType;
}({}); /** Input type for a clearable number field */  /** Represents the attribute associated with the CMDB object. */  /** Represents the attribute associated with the CMDB object. */  /** The connection type for JiraCmdbAttribute. */  /** An edge in a JiraCmdbAttribute connection. */  /** The category of the CMDB attribute that can be created. */ 
let $78ad46e0d6808149$export$aafda693b12c4a20 = /*#__PURE__*/ function(JiraCmdbAttributeType) {
    JiraCmdbAttributeType["BitbucketRepo"] = "BITBUCKET_REPO";
    JiraCmdbAttributeType["Confluence"] = "CONFLUENCE";
    JiraCmdbAttributeType["Default"] = "DEFAULT";
    JiraCmdbAttributeType["Group"] = "GROUP";
    JiraCmdbAttributeType["OpsgenieTeam"] = "OPSGENIE_TEAM";
    JiraCmdbAttributeType["Project"] = "PROJECT";
    JiraCmdbAttributeType["ReferencedObject"] = "REFERENCED_OBJECT";
    JiraCmdbAttributeType["Status"] = "STATUS";
    JiraCmdbAttributeType["User"] = "USER";
    JiraCmdbAttributeType["Version"] = "VERSION";
    return JiraCmdbAttributeType;
}({}); /** Represents a CMDB avatar. */  /** Represents the CMDB Bitbucket Repository. */  /** The connection type for CMDB config attributes. */  /** An edge in a JiraCmdbConfigAttributeConnection. */  /**
 * Represents the CMDB default type.
 * This contains information about what type of default attribute this is.
 * The possible id: name values are as follows:
 *     0: Text
 *     1: Integer
 *     2: Boolean
 *     3: Float
 *     4: Date
 *     6: DateTime
 *     7: URL
 *     8: Email
 *     9: Textarea
 *     10: Select
 *     11: IP Address
 */ 
let $78ad46e0d6808149$export$7341e48e3db8f8f0 = /*#__PURE__*/ function(JiraColorSchemeThemeSetting) {
    JiraColorSchemeThemeSetting["Automatic"] = "AUTOMATIC";
    JiraColorSchemeThemeSetting["Dark"] = "DARK";
    JiraColorSchemeThemeSetting["Light"] = "LIGHT";
    return JiraColorSchemeThemeSetting;
}({}); /** An interface shared across all comment types. */  /** The connection type for JiraComment. */  /** An edge in a JiraComment connection. */  /** The field for sorting comments. */ 
let $78ad46e0d6808149$export$67f08e20644f2173 = /*#__PURE__*/ function(JiraCommentSortField) {
    JiraCommentSortField["Created"] = "CREATED";
    return JiraCommentSortField;
}({}); /**
 * Jira component defines two kinds of Components:
 *     1. Project Components, sub-selection of a project.
 *     2. Global Components, which span across multiple projects.
 * One of the Global Components type is Compass Components.
 */ 
let $78ad46e0d6808149$export$6f50c8d504c17c7a = /*#__PURE__*/ function(JiraConfigFieldType) {
    JiraConfigFieldType["CustomCascadingSelect"] = "CUSTOM_CASCADING_SELECT";
    JiraConfigFieldType["CustomDatetime"] = "CUSTOM_DATETIME";
    JiraConfigFieldType["CustomDatePicker"] = "CUSTOM_DATE_PICKER";
    JiraConfigFieldType["CustomFloat"] = "CUSTOM_FLOAT";
    JiraConfigFieldType["CustomGroupPicker"] = "CUSTOM_GROUP_PICKER";
    JiraConfigFieldType["CustomImportId"] = "CUSTOM_IMPORT_ID";
    JiraConfigFieldType["CustomLabels"] = "CUSTOM_LABELS";
    JiraConfigFieldType["CustomMultiCheckboxes"] = "CUSTOM_MULTI_CHECKBOXES";
    JiraConfigFieldType["CustomMultiGroupPicker"] = "CUSTOM_MULTI_GROUP_PICKER";
    JiraConfigFieldType["CustomMultiSelect"] = "CUSTOM_MULTI_SELECT";
    JiraConfigFieldType["CustomMultiUserPicker"] = "CUSTOM_MULTI_USER_PICKER";
    JiraConfigFieldType["CustomMultiVersion"] = "CUSTOM_MULTI_VERSION";
    JiraConfigFieldType["CustomProject"] = "CUSTOM_PROJECT";
    JiraConfigFieldType["CustomRadioButtons"] = "CUSTOM_RADIO_BUTTONS";
    JiraConfigFieldType["CustomReadonlyField"] = "CUSTOM_READONLY_FIELD";
    JiraConfigFieldType["CustomSelect"] = "CUSTOM_SELECT";
    JiraConfigFieldType["CustomTextarea"] = "CUSTOM_TEXTAREA";
    JiraConfigFieldType["CustomTextField"] = "CUSTOM_TEXT_FIELD";
    JiraConfigFieldType["CustomUrl"] = "CUSTOM_URL";
    JiraConfigFieldType["CustomUserPicker"] = "CUSTOM_USER_PICKER";
    JiraConfigFieldType["CustomVersion"] = "CUSTOM_VERSION";
    JiraConfigFieldType["ServicedeskApprovals"] = "SERVICEDESK_APPROVALS";
    JiraConfigFieldType["ServicedeskCmdbField"] = "SERVICEDESK_CMDB_FIELD";
    JiraConfigFieldType["ServicedeskCustomerOrganizations"] = "SERVICEDESK_CUSTOMER_ORGANIZATIONS";
    JiraConfigFieldType["ServicedeskRequestFeedback"] = "SERVICEDESK_REQUEST_FEEDBACK";
    JiraConfigFieldType["ServicedeskRequestFeedbackDate"] = "SERVICEDESK_REQUEST_FEEDBACK_DATE";
    JiraConfigFieldType["ServicedeskRequestLanguage"] = "SERVICEDESK_REQUEST_LANGUAGE";
    JiraConfigFieldType["ServicedeskRequestParticipants"] = "SERVICEDESK_REQUEST_PARTICIPANTS";
    JiraConfigFieldType["ServicedeskSlaField"] = "SERVICEDESK_SLA_FIELD";
    JiraConfigFieldType["ServicedeskVpOrigin"] = "SERVICEDESK_VP_ORIGIN";
    JiraConfigFieldType["SoftwareEpicColor"] = "SOFTWARE_EPIC_COLOR";
    JiraConfigFieldType["SoftwareEpicIssueColor"] = "SOFTWARE_EPIC_ISSUE_COLOR";
    JiraConfigFieldType["SoftwareEpicLabel"] = "SOFTWARE_EPIC_LABEL";
    JiraConfigFieldType["SoftwareEpicLexoRank"] = "SOFTWARE_EPIC_LEXO_RANK";
    JiraConfigFieldType["SoftwareEpicLink"] = "SOFTWARE_EPIC_LINK";
    JiraConfigFieldType["SoftwareEpicSprint"] = "SOFTWARE_EPIC_SPRINT";
    JiraConfigFieldType["SoftwareEpicStatus"] = "SOFTWARE_EPIC_STATUS";
    JiraConfigFieldType["StandardAffectedVersions"] = "STANDARD_AFFECTED_VERSIONS";
    JiraConfigFieldType["StandardAggregateProgress"] = "STANDARD_AGGREGATE_PROGRESS";
    JiraConfigFieldType["StandardAggregateTimeEstimate"] = "STANDARD_AGGREGATE_TIME_ESTIMATE";
    JiraConfigFieldType["StandardAggregateTimeOriginalEstimate"] = "STANDARD_AGGREGATE_TIME_ORIGINAL_ESTIMATE";
    JiraConfigFieldType["StandardAggregateTimeSpent"] = "STANDARD_AGGREGATE_TIME_SPENT";
    JiraConfigFieldType["StandardAssignee"] = "STANDARD_ASSIGNEE";
    JiraConfigFieldType["StandardAttachment"] = "STANDARD_ATTACHMENT";
    JiraConfigFieldType["StandardComment"] = "STANDARD_COMMENT";
    JiraConfigFieldType["StandardComponents"] = "STANDARD_COMPONENTS";
    JiraConfigFieldType["StandardCreated"] = "STANDARD_CREATED";
    JiraConfigFieldType["StandardCreator"] = "STANDARD_CREATOR";
    JiraConfigFieldType["StandardDescription"] = "STANDARD_DESCRIPTION";
    JiraConfigFieldType["StandardDueDate"] = "STANDARD_DUE_DATE";
    JiraConfigFieldType["StandardEnvironment"] = "STANDARD_ENVIRONMENT";
    JiraConfigFieldType["StandardFixForVersions"] = "STANDARD_FIX_FOR_VERSIONS";
    JiraConfigFieldType["StandardFormToken"] = "STANDARD_FORM_TOKEN";
    JiraConfigFieldType["StandardIssueKey"] = "STANDARD_ISSUE_KEY";
    JiraConfigFieldType["StandardIssueLinks"] = "STANDARD_ISSUE_LINKS";
    JiraConfigFieldType["StandardIssueNumber"] = "STANDARD_ISSUE_NUMBER";
    JiraConfigFieldType["StandardIssueType"] = "STANDARD_ISSUE_TYPE";
    JiraConfigFieldType["StandardLabels"] = "STANDARD_LABELS";
    JiraConfigFieldType["StandardLastViewed"] = "STANDARD_LAST_VIEWED";
    JiraConfigFieldType["StandardParent"] = "STANDARD_PARENT";
    JiraConfigFieldType["StandardPriority"] = "STANDARD_PRIORITY";
    JiraConfigFieldType["StandardProgress"] = "STANDARD_PROGRESS";
    JiraConfigFieldType["StandardProject"] = "STANDARD_PROJECT";
    JiraConfigFieldType["StandardProjectKey"] = "STANDARD_PROJECT_KEY";
    JiraConfigFieldType["StandardReporter"] = "STANDARD_REPORTER";
    JiraConfigFieldType["StandardResolution"] = "STANDARD_RESOLUTION";
    JiraConfigFieldType["StandardResolutionDate"] = "STANDARD_RESOLUTION_DATE";
    JiraConfigFieldType["StandardSecurity"] = "STANDARD_SECURITY";
    JiraConfigFieldType["StandardStatus"] = "STANDARD_STATUS";
    JiraConfigFieldType["StandardSubtasks"] = "STANDARD_SUBTASKS";
    JiraConfigFieldType["StandardSummary"] = "STANDARD_SUMMARY";
    JiraConfigFieldType["StandardThumbnail"] = "STANDARD_THUMBNAIL";
    JiraConfigFieldType["StandardTimetracking"] = "STANDARD_TIMETRACKING";
    JiraConfigFieldType["StandardTimeEstimate"] = "STANDARD_TIME_ESTIMATE";
    JiraConfigFieldType["StandardTimeOriginalEstimate"] = "STANDARD_TIME_ORIGINAL_ESTIMATE";
    JiraConfigFieldType["StandardTimeSpent"] = "STANDARD_TIME_SPENT";
    JiraConfigFieldType["StandardUpdated"] = "STANDARD_UPDATED";
    JiraConfigFieldType["StandardVoters"] = "STANDARD_VOTERS";
    JiraConfigFieldType["StandardVotes"] = "STANDARD_VOTES";
    JiraConfigFieldType["StandardWatchers"] = "STANDARD_WATCHERS";
    JiraConfigFieldType["StandardWatches"] = "STANDARD_WATCHES";
    JiraConfigFieldType["StandardWorklog"] = "STANDARD_WORKLOG";
    JiraConfigFieldType["StandardWorkratio"] = "STANDARD_WORKRATIO";
    JiraConfigFieldType["Unsupported"] = "UNSUPPORTED";
    return JiraConfigFieldType;
}({}); /** JiraConfigState represents the configured status for a workspace for a jira app */  /** Enum representing the configured status for a jira app/workspace */ 
let $78ad46e0d6808149$export$9d90b408b08d33b7 = /*#__PURE__*/ function(JiraConfigStateConfigurationStatus) {
    JiraConfigStateConfigurationStatus["Configured"] = "CONFIGURED";
    JiraConfigStateConfigurationStatus["NotConfigured"] = "NOT_CONFIGURED";
    JiraConfigStateConfigurationStatus["NotInstalled"] = "NOT_INSTALLED";
    JiraConfigStateConfigurationStatus["NotSet"] = "NOT_SET";
    JiraConfigStateConfigurationStatus["PartiallyConfigured"] = "PARTIALLY_CONFIGURED";
    JiraConfigStateConfigurationStatus["ProviderActionConfigured"] = "PROVIDER_ACTION_CONFIGURED";
    JiraConfigStateConfigurationStatus["ProviderActionNotConfigured"] = "PROVIDER_ACTION_NOT_CONFIGURED";
    return JiraConfigStateConfigurationStatus;
}({}); /** Connection object representing config state for a set of jira app workspaces */  /** Connection edge representing config state for one jira app workspace */  /** Enum representing Provider Type of App for Config State Service */ 
let $78ad46e0d6808149$export$227a4b9b7e3c43f7 = /*#__PURE__*/ function(JiraConfigStateProviderType) {
    JiraConfigStateProviderType["Builds"] = "BUILDS";
    JiraConfigStateProviderType["Deployments"] = "DEPLOYMENTS";
    JiraConfigStateProviderType["Designs"] = "DESIGNS";
    JiraConfigStateProviderType["DevelopmentInfo"] = "DEVELOPMENT_INFO";
    JiraConfigStateProviderType["FeatureFlags"] = "FEATURE_FLAGS";
    JiraConfigStateProviderType["RemoteLinks"] = "REMOTE_LINKS";
    JiraConfigStateProviderType["Security"] = "SECURITY";
    JiraConfigStateProviderType["Unknown"] = "UNKNOWN";
    return JiraConfigStateProviderType;
}({}); /** Each individual nav item that is configurable by the user. */  /** Each individual nav item that is configurable by the user. */  /** Represents a datetime field created by Connect App. Note that a connect field's type dynamic. Consumers can use the schema type to determine this is a connect field */  /** Represents a multi-select field created by Connect App. */  /** Represents a multi-select field created by Connect App. */  /** Represents a multi-select field created by Connect App. */  /** Represents a multi-select field created by Connect App. */  /** Represents a multi-select field created by Connect App. */  /** Represents a number field created by Connect App. */  /**
 * Deprecated. Use JiraConnectTextField | JiraConnectNumberField | JiraConnectDateTimeField + isEditable instead
 * Represents a read only field created by Connect App.
 */ 
let $78ad46e0d6808149$export$2eccc11159f64a0b = /*#__PURE__*/ function(JiraContactOrgAdminToEnableAtlassianIntelligenceState) {
    JiraContactOrgAdminToEnableAtlassianIntelligenceState["Available"] = "AVAILABLE";
    JiraContactOrgAdminToEnableAtlassianIntelligenceState["Unavailable"] = "UNAVAILABLE";
    return JiraContactOrgAdminToEnableAtlassianIntelligenceState;
}({}); /** Represents the details of a navigation for a specific container. */  /** Represents the details of a navigation for a specific container. */  /** Represents the details of a navigation for a specific container. */  /** Represents the details of a navigation for a specific container. */  /** Input to query the navigation of a container scoped to a project by its key. */  /**
 * Input to retrieve the navigation details of a container. As per the `@oneOf` directive, Only one of the fields
 * `byScopeId` or `byProjectKey` must be provided.
 */ 
let $78ad46e0d6808149$export$ab94fb316a642cad = /*#__PURE__*/ function(JiraCustomIssueSearchErrorType) {
    JiraCustomIssueSearchErrorType["CustomImplementationError"] = "CUSTOM_IMPLEMENTATION_ERROR";
    JiraCustomIssueSearchErrorType["CustomSearchDisabled"] = "CUSTOM_SEARCH_DISABLED";
    JiraCustomIssueSearchErrorType["InvalidAri"] = "INVALID_ARI";
    JiraCustomIssueSearchErrorType["UnsupportedAri"] = "UNSUPPORTED_ARI";
    return JiraCustomIssueSearchErrorType;
}({}); /** Represents a Jira dashboard */  /**
 * Represents aggregated DataClassification for an issue. Data Classification for Jira provides Jira users and admins with
 * the capability to assign pre-existing classification tags to all Content levels.
 */ 
let $78ad46e0d6808149$export$2ed4618f2653768 = /*#__PURE__*/ function(JiraDeploymentsFeaturePrecondition) {
    JiraDeploymentsFeaturePrecondition["AllSatisfied"] = "ALL_SATISFIED";
    JiraDeploymentsFeaturePrecondition["DeploymentsEmptyState"] = "DEPLOYMENTS_EMPTY_STATE";
    JiraDeploymentsFeaturePrecondition["NotAvailable"] = "NOT_AVAILABLE";
    return JiraDeploymentsFeaturePrecondition;
}({}); /** User actionable error details. */  /** The possible config error type with a provider that feed devinfo details. */ 
let $78ad46e0d6808149$export$956b9378bb62ef88 = /*#__PURE__*/ function(JiraDevInfoConfigErrorType) {
    JiraDevInfoConfigErrorType["Incapable"] = "INCAPABLE";
    JiraDevInfoConfigErrorType["NotConfigured"] = "NOT_CONFIGURED";
    JiraDevInfoConfigErrorType["Unauthorized"] = "UNAUTHORIZED";
    JiraDevInfoConfigErrorType["UnknownConfigError"] = "UNKNOWN_CONFIG_ERROR";
    return JiraDevInfoConfigErrorType;
}({}); /** The input type for a devOps association */  /** The payload type for a devOps association */  /** Details of a created SCM branch associated with a Jira issue. */  /** The types of capabilities a devOps provider can support */ 
let $78ad46e0d6808149$export$35269253edf4bd98 = /*#__PURE__*/ function(JiraDevOpsCapability) {
    JiraDevOpsCapability["Branch"] = "BRANCH";
    JiraDevOpsCapability["Build"] = "BUILD";
    JiraDevOpsCapability["Commit"] = "COMMIT";
    JiraDevOpsCapability["Deployment"] = "DEPLOYMENT";
    JiraDevOpsCapability["FeatureFlag"] = "FEATURE_FLAG";
    JiraDevOpsCapability["PullRequest"] = "PULL_REQUEST";
    JiraDevOpsCapability["Review"] = "REVIEW";
    return JiraDevOpsCapability;
}({}); /** Details of a SCM commit associated with a Jira issue. */  /** The input type for devOps entity associations */  /** Basic person information who created a SCM entity (Pull-request, Branches, or Commit) */ 
let $78ad46e0d6808149$export$62ac5d058da58a8 = /*#__PURE__*/ function(JiraDevOpsInContextConfigPromptLocation) {
    JiraDevOpsInContextConfigPromptLocation["DevelopmentPanel"] = "DEVELOPMENT_PANEL";
    JiraDevOpsInContextConfigPromptLocation["ReleasesPanel"] = "RELEASES_PANEL";
    JiraDevOpsInContextConfigPromptLocation["SecurityPanel"] = "SECURITY_PANEL";
    return JiraDevOpsInContextConfigPromptLocation;
}({}); /** Container for all DevOps data for an issue, to be displayed in the DevOps Panel of an issue */ 
let $78ad46e0d6808149$export$ab235556283af700 = /*#__PURE__*/ function(JiraDevOpsIssuePanelBannerType) {
    JiraDevOpsIssuePanelBannerType["IssueKeyOnboarding"] = "ISSUE_KEY_ONBOARDING";
    return JiraDevOpsIssuePanelBannerType;
}({}); /** The possible States the DevOps Issue Panel can be in */ 
let $78ad46e0d6808149$export$9deab4622c89c42 = /*#__PURE__*/ function(JiraDevOpsIssuePanelState) {
    JiraDevOpsIssuePanelState["DevSummary"] = "DEV_SUMMARY";
    JiraDevOpsIssuePanelState["Hidden"] = "HIDDEN";
    JiraDevOpsIssuePanelState["NotConnected"] = "NOT_CONNECTED";
    return JiraDevOpsIssuePanelState;
}({}); /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Details of a SCM Pull-request associated with a Jira issue */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */ 
let $78ad46e0d6808149$export$f72ad11cc7a7d264 = /*#__PURE__*/ function(JiraDevOpsUpdateAssociationsEntityType) {
    JiraDevOpsUpdateAssociationsEntityType["Vulnerability"] = "VULNERABILITY";
    return JiraDevOpsUpdateAssociationsEntityType;
}({}); /** The input type for updating devOps associations */  /** The payload type for updating devOps associations */  /** Represents dev summary for an issue. The identifier for this field is devSummary */  /** The response payload to dismiss the banner that displays workspaces that are pending acceptance of access requests */  /** The response payload to dismiss the banner that displays workspaces that are pending acceptance of access requests */  /** The input type for devops panel banner dismissal */  /** The response payload for devops panel banner dismissal */  /** The response payload to dismiss in-context configuration prompt that is per user setting */  /** The response payload to dismiss in-context configuration prompt that is per user setting */  /** Represents a duration. Typically used for time tracking fields. */  /** Input for OriginalEstimate field */  /** Represents the possible email MIME types. */ 
let $78ad46e0d6808149$export$309a4c314bc40eda = /*#__PURE__*/ function(JiraEmailMimeType) {
    JiraEmailMimeType["Html"] = "HTML";
    JiraEmailMimeType["Text"] = "TEXT";
    return JiraEmailMimeType;
}({}); /** Represents the reason why a connection is empty. */  /** Link to send org admins to enable Atlassian Intelligence. */  /** Input type for Entitlement field */  /** Input type representing a single entitlement */  /** An interface for the return type of any Entity Property */  /** The generic Boolean type for any entity property */  /** The generic integer type for any entity property */  /** The generic JSON type for any entity property, use of this interface is NOT recommended as per https://hello.atlassian.net/wiki/spaces/GT3/pages/2567211252/Avoid+using+JSON+as+a+field+type */  /** The generic String type for any entity property */  /** Scope of values for the Entity (Ex: Field) */ 
let $78ad46e0d6808149$export$2d42aa6ed58ded25 = /*#__PURE__*/ function(JiraEntityScope) {
    JiraEntityScope["Global"] = "GLOBAL";
    JiraEntityScope["Project"] = "PROJECT";
    return JiraEntityScope;
}({}); /** Represents an epic. */  /** The connection type for JiraEpic. */  /** An edge in a JiraEpic connection. */  /** Represents epic link field on a Jira Issue. */  /** Represents epic link field on a Jira Issue. */  /** Input type for epic link field */  /** Input type for epic link field */  /** Represents the Jira time tracking estimate type. */  /**
 * Context where the extensions are supposed to be shown.
 *
 * Provide only the most specific entity. For example, there is no need to provide the project if an issue is given; the project will be inferred from the issue automatically.
 */ 
let $78ad46e0d6808149$export$5c4322ab4b397354 = /*#__PURE__*/ function(JiraFavouriteType) {
    JiraFavouriteType["Board"] = "BOARD";
    JiraFavouriteType["Dashboard"] = "DASHBOARD";
    JiraFavouriteType["Filter"] = "FILTER";
    JiraFavouriteType["Plan"] = "PLAN";
    JiraFavouriteType["Project"] = "PROJECT";
    JiraFavouriteType["Queue"] = "QUEUE";
    return JiraFavouriteType;
}({}); /** Favourite Node which is unique to a favouritable entity and a user and returns if the favourite value is true or false. */  /** Represents a Jira field which includes system fields and custom fields */  /** Represents Association of fields with IssueTypes */  /** The connection type for JiraFieldAssociationWithIssueTypes. */  /** An edge in a JiraFieldAssociationWithIssueTypes connection. */  /** Attributes of field configuration. */  /** A connection to a list of FieldConfigs. */  /** An edge in a JiraIssueFieldConfig connection. */  /** The connection type for JiraProjectAssociatedFields. */  /** An edge in a JiraProjectAssociatedFields connection. */  /** Represents the information for a field being non-editable on Issue screens. */  /** Represents operations allowed on a JiraField */  /** Represents argument input type for `fieldOptions` query to provide capability to filter field options by list of IDs */  /** Enum to define a filter operation on the optionIds in input JiraFieldOptionIdsFilterInput */ 
let $78ad46e0d6808149$export$18f16315d2f9166d = /*#__PURE__*/ function(JiraFieldOptionIdsFilterOperation) {
    JiraFieldOptionIdsFilterOperation["Allow"] = "ALLOW";
    JiraFieldOptionIdsFilterOperation["Exclude"] = "EXCLUDE";
    return JiraFieldOptionIdsFilterOperation;
}({}); /** The representation of fieldset preferences. */  /** The payload returned when a User fieldset preferences has been updated. */  /**
 * The representation of a Jira field-type.
 *
 * E.g. `Short Text`, `Number`, `Version Picker`, `Team` etc.
 */ 
let $78ad46e0d6808149$export$8947915968eda69f = /*#__PURE__*/ function(JiraForgeEnvironmentType) {
    JiraForgeEnvironmentType["Development"] = "DEVELOPMENT";
    JiraForgeEnvironmentType["Production"] = "PRODUCTION";
    JiraForgeEnvironmentType["Staging"] = "STAGING";
    return JiraForgeEnvironmentType;
}({}); /** The definition of a Forge extension in Jira. */  /** Represents a Group field created by Forge App. */  /** Represents a Group field created by Forge App. */  /** Represents a Groups field created by Forge App. */  /** Represents a Groups field created by Forge App. */  /** Represents a Groups field created by Forge App. */  /** Represents a number field created by Forge App. */  /** Represents a object field created by Forge App. */  /** Represents a string field created by Forge App. */  /** Represents a strings field created by Forge App. */  /** Represents a strings field created by Forge App. */  /** Represents a strings field created by Forge App. */  /** Represents a User field created by Forge App. */  /** Represents a User field created by Forge App. */  /** Represents a Users field created by Forge App. */  /** Represents a Users field created by Forge App. */  /** Represents a Users field created by Forge App. */ 
let $78ad46e0d6808149$export$a84cede14c0af3e6 = /*#__PURE__*/ function(JiraFormattingArea) {
    JiraFormattingArea["Cell"] = "CELL";
    JiraFormattingArea["Row"] = "ROW";
    return JiraFormattingArea;
}({});
let $78ad46e0d6808149$export$ac68c28f8148831f = /*#__PURE__*/ function(JiraFormattingColor) {
    JiraFormattingColor["Blue"] = "BLUE";
    JiraFormattingColor["Green"] = "GREEN";
    JiraFormattingColor["Red"] = "RED";
    return JiraFormattingColor;
}({}); /** Rule is evaluated against multiple values. Values order does not matter in this condition. */ 
let $78ad46e0d6808149$export$efa4d82804592bca = /*#__PURE__*/ function(JiraFormattingMultipleValueOperator) {
    JiraFormattingMultipleValueOperator["Contains"] = "CONTAINS";
    JiraFormattingMultipleValueOperator["DoesNotContain"] = "DOES_NOT_CONTAIN";
    JiraFormattingMultipleValueOperator["HasAnyOf"] = "HAS_ANY_OF";
    return JiraFormattingMultipleValueOperator;
}({}); /** Rule doesn't require value. */ 
let $78ad46e0d6808149$export$eca120e5a19089a1 = /*#__PURE__*/ function(JiraFormattingNoValueOperator) {
    JiraFormattingNoValueOperator["IsEmpty"] = "IS_EMPTY";
    JiraFormattingNoValueOperator["IsNotEmpty"] = "IS_NOT_EMPTY";
    return JiraFormattingNoValueOperator;
}({}); /** Rule is evaluated against one value */ 
let $78ad46e0d6808149$export$545873d4d5fe4917 = /*#__PURE__*/ function(JiraFormattingSingleValueOperator) {
    JiraFormattingSingleValueOperator["Contains"] = "CONTAINS";
    JiraFormattingSingleValueOperator["DoesNotContain"] = "DOES_NOT_CONTAIN";
    JiraFormattingSingleValueOperator["DoesNotEqual"] = "DOES_NOT_EQUAL";
    JiraFormattingSingleValueOperator["Equals"] = "EQUALS";
    JiraFormattingSingleValueOperator["GreaterThan"] = "GREATER_THAN";
    JiraFormattingSingleValueOperator["GreaterThanOrEquals"] = "GREATER_THAN_OR_EQUALS";
    JiraFormattingSingleValueOperator["Is"] = "IS";
    JiraFormattingSingleValueOperator["IsAfter"] = "IS_AFTER";
    JiraFormattingSingleValueOperator["IsBefore"] = "IS_BEFORE";
    JiraFormattingSingleValueOperator["IsNot"] = "IS_NOT";
    JiraFormattingSingleValueOperator["IsOnOrAfter"] = "IS_ON_OR_AFTER";
    JiraFormattingSingleValueOperator["IsOnOrBefore"] = "IS_ON_OR_BEFORE";
    JiraFormattingSingleValueOperator["LessThan"] = "LESS_THAN";
    JiraFormattingSingleValueOperator["LessThanOrEquals"] = "LESS_THAN_OR_EQUALS";
    return JiraFormattingSingleValueOperator;
}({}); /** Rule is evaluated against two values. Value order does matter in this condition. */ 
let $78ad46e0d6808149$export$7a46afffd251b41d = /*#__PURE__*/ function(JiraFormattingTwoValueOperator) {
    JiraFormattingTwoValueOperator["IsBetween"] = "IS_BETWEEN";
    JiraFormattingTwoValueOperator["IsNotBetween"] = "IS_NOT_BETWEEN";
    return JiraFormattingTwoValueOperator;
}({}); /** The representation for an generic error when the generated JQL was invalid. */  /** WARNING: This type is deprecated and will be removed in the future. DO NOT USE */  /** The global issue create modal view types. */ 
let $78ad46e0d6808149$export$4a2c19fd597ee77f = /*#__PURE__*/ function(JiraGlobalIssueCreateView) {
    JiraGlobalIssueCreateView["FullModal"] = "FULL_MODAL";
    JiraGlobalIssueCreateView["MiniModal"] = "MINI_MODAL";
    return JiraGlobalIssueCreateView;
}({}); /** A global permission in Jira */  /** All the grants given to a global permission */  /** Different Global permissions that the user can have */ 
let $78ad46e0d6808149$export$c30f06fc4059f363 = /*#__PURE__*/ function(JiraGlobalPermissionType) {
    JiraGlobalPermissionType["Administer"] = "ADMINISTER";
    JiraGlobalPermissionType["UserPicker"] = "USER_PICKER";
    return JiraGlobalPermissionType;
}({}); /** Represents a goal in Jira */  /** The connection type for JiraGoal. */  /** An edge in a JiraGoal connection. */ 
let $78ad46e0d6808149$export$6d47154a1de14240 = /*#__PURE__*/ function(JiraGoalStatus) {
    JiraGoalStatus["Archived"] = "ARCHIVED";
    JiraGoalStatus["AtRisk"] = "AT_RISK";
    JiraGoalStatus["Cancelled"] = "CANCELLED";
    JiraGoalStatus["Completed"] = "COMPLETED";
    JiraGoalStatus["Done"] = "DONE";
    JiraGoalStatus["OffTrack"] = "OFF_TRACK";
    JiraGoalStatus["OnTrack"] = "ON_TRACK";
    JiraGoalStatus["Paused"] = "PAUSED";
    JiraGoalStatus["Pending"] = "PENDING";
    return JiraGoalStatus;
}({}); /** Represents the Goals field on a Jira Issue. */  /** Represents the Goals field on a Jira Issue. */  /** A Jira Background which is a gradient type */  /** The unique key of the grant type such as PROJECT_ROLE. */  /**
 * The grant type key enum represents all the possible grant types available in Jira.
 * A grant type may take an optional parameter value.
 * For example: PROJECT_ROLE grant type takes project role id as parameter. And, PROJECT_LEAD grant type do not.
 *
 * The actual ARI formats are documented on the various concrete grant type values.
 */ 
let $78ad46e0d6808149$export$60b5a68a2a59a819 = /*#__PURE__*/ function(JiraGrantTypeKeyEnum) {
    JiraGrantTypeKeyEnum["AnonymousAccess"] = "ANONYMOUS_ACCESS";
    JiraGrantTypeKeyEnum["AnyLoggedinUserApplicationRole"] = "ANY_LOGGEDIN_USER_APPLICATION_ROLE";
    JiraGrantTypeKeyEnum["ApplicationRole"] = "APPLICATION_ROLE";
    JiraGrantTypeKeyEnum["Assignee"] = "ASSIGNEE";
    JiraGrantTypeKeyEnum["Group"] = "GROUP";
    JiraGrantTypeKeyEnum["MultiGroupPicker"] = "MULTI_GROUP_PICKER";
    JiraGrantTypeKeyEnum["MultiUserPicker"] = "MULTI_USER_PICKER";
    JiraGrantTypeKeyEnum["ProjectLead"] = "PROJECT_LEAD";
    JiraGrantTypeKeyEnum["ProjectRole"] = "PROJECT_ROLE";
    JiraGrantTypeKeyEnum["Reporter"] = "REPORTER";
    JiraGrantTypeKeyEnum["ServiceProjectCustomerPortalAccess"] = "SERVICE_PROJECT_CUSTOMER_PORTAL_ACCESS";
    JiraGrantTypeKeyEnum["User"] = "USER";
    return JiraGrantTypeKeyEnum;
}({}); /** The JiraGrantTypeValue union resolves to one of the concrete types such as JiraDefaultGrantTypeValue, JiraProjectRoleGrantTypeValue. */  /** A type to represent one or more paginated list of one or more permission grant values available for a given grant type. */  /** An edge object representing grant type value information used within connection object. */  /** Represents a Jira Group. */  /** The connection type for JiraGroup. */  /** An edge in a JiraGroupConnection connection. */  /** The GROUP grant type value where group data is provided by identity service. */  /** Input for Groups values on fields */  /** The types of Contexts supported by Groups field. */ 
let $78ad46e0d6808149$export$ebb3bfffea31943a = /*#__PURE__*/ function(JiraGroupsContext) {
    JiraGroupsContext["Group"] = "GROUP";
    JiraGroupsContext["User"] = "USER";
    return JiraGroupsContext;
}({}); /** Represents a multiple selected value on a field. */  /** Represents a multiple selected value on a field. */  /** Represent a selectable options that can be selected on an Issue or a field. */  /** Represent a selectable options that can be selected on an Issue or a field. */  /** Represents a single selected value on a field. */  /** The Jira Home Page that a user can be directed to. */  /** The different home page types a user can be directed to. */ 
let $78ad46e0d6808149$export$42ed5df1bdc10783 = /*#__PURE__*/ function(JiraHomePageType) {
    JiraHomePageType["Dashboards"] = "DASHBOARDS";
    JiraHomePageType["LoginRedirect"] = "LOGIN_REDIRECT";
    JiraHomePageType["ProjectsDirectory"] = "PROJECTS_DIRECTORY";
    JiraHomePageType["YourWork"] = "YOUR_WORK";
    return JiraHomePageType;
}({}); /** The JSM incident priority values */ 
let $78ad46e0d6808149$export$f1e981f4a82c46b7 = /*#__PURE__*/ function(JiraIncidentPriority) {
    JiraIncidentPriority["P1"] = "P1";
    JiraIncidentPriority["P2"] = "P2";
    JiraIncidentPriority["P3"] = "P3";
    JiraIncidentPriority["P4"] = "P4";
    JiraIncidentPriority["P5"] = "P5";
    return JiraIncidentPriority;
}({}); /** This is the input argument for initializing the project notification preferences. */  /** The response for the mutation to update the project notification preferences. */  /**
 * DEPRECATED: Banner experiment is no longer active
 *
 * The precondition state of the install-deployments banner for a particular project and user.
 */ 
let $78ad46e0d6808149$export$c8c1ed3f290ea5bf = /*#__PURE__*/ function(JiraInstallDeploymentsBannerPrecondition) {
    JiraInstallDeploymentsBannerPrecondition["DeploymentsEmptyState"] = "DEPLOYMENTS_EMPTY_STATE";
    JiraInstallDeploymentsBannerPrecondition["FeatureNotEnabled"] = "FEATURE_NOT_ENABLED";
    JiraInstallDeploymentsBannerPrecondition["NotAvailable"] = "NOT_AVAILABLE";
    return JiraInstallDeploymentsBannerPrecondition;
}({}); /**
 * The representation for an invalid JQL error.
 * E.g. 'project = TMP' where 'TMP' has been deleted.
 */ 
let $78ad46e0d6808149$export$ca26010eaa3c3804 = /*#__PURE__*/ function(JiraIssueDeploymentEnvironmentState) {
    JiraIssueDeploymentEnvironmentState["Deployed"] = "DEPLOYED";
    JiraIssueDeploymentEnvironmentState["NotDeployed"] = "NOT_DEPLOYED";
    return JiraIssueDeploymentEnvironmentState;
}({}); /** The SCM entities (pullrequest, branches or commits) associated with a Jira issue. */  /** Lists the summaries available for each type of dev info, for a given issue */  /** Aggregates the `count` of entities for a given provider */  /** Error when querying the JiraIssueDevSummary */  /** Basic information on a provider that triggered an error */  /** Container for the Dev Summary of an issue */  /** An edge in a JiraIssue connection. */  /** Indicates an error occurring during submission or execution of an export task. */  /** The types of events published to the onIssueExported subscription. */  /** Input for the onIssueExported subscription. */  /** A Jira issue export task */  /** Indicates a successful completion of a Jira issue export task. */  /** The progress of a Jira issue export task. */  /** Indicates a successful export task submission. */  /**
 * Represents an export task that was terminated due to an error, cancellation, or dead state.
 * The export result would not be available.
 */ 
let $78ad46e0d6808149$export$55363ce84d2e39d7 = /*#__PURE__*/ function(JiraIssueExportType) {
    JiraIssueExportType["CsvAllFields"] = "CSV_ALL_FIELDS";
    JiraIssueExportType["CsvCurrentFields"] = "CSV_CURRENT_FIELDS";
    JiraIssueExportType["CsvWithBomAllFields"] = "CSV_WITH_BOM_ALL_FIELDS";
    JiraIssueExportType["CsvWithBomCurrentFields"] = "CSV_WITH_BOM_CURRENT_FIELDS";
    return JiraIssueExportType;
}({}); /** Represents the common structure across Issue fields. */  /** Represents the configurations associated with an Issue field. */  /** The connection type for JiraIssueField. */  /** An edge in a JiraIssueField connection. */  /**
 * The issue field grant type used to represent field of an issue.
 * Grant types such as ASSIGNEE, REPORTER, MULTI USER PICKER, and MULTI GROUP PICKER use this grant type value.
 */ 
let $78ad46e0d6808149$export$f02f8d5666a4ac9b = /*#__PURE__*/ function(JiraIssueItemLayoutItemLocationRuleType) {
    JiraIssueItemLayoutItemLocationRuleType["Dates"] = "DATES";
    JiraIssueItemLayoutItemLocationRuleType["MultilineText"] = "MULTILINE_TEXT";
    JiraIssueItemLayoutItemLocationRuleType["Other"] = "OTHER";
    JiraIssueItemLayoutItemLocationRuleType["People"] = "PEOPLE";
    JiraIssueItemLayoutItemLocationRuleType["Timetracking"] = "TIMETRACKING";
    return JiraIssueItemLayoutItemLocationRuleType;
}({}); /** Represents a reference to a panel by panel ID, used for laying out panels on an issue. */  /** The system container types that are available for placing items. */ 
let $78ad46e0d6808149$export$697c16cbeca9bb08 = /*#__PURE__*/ function(JiraIssueItemSystemContainerType) {
    JiraIssueItemSystemContainerType["Content"] = "CONTENT";
    JiraIssueItemSystemContainerType["Context"] = "CONTEXT";
    JiraIssueItemSystemContainerType["HiddenItems"] = "HIDDEN_ITEMS";
    JiraIssueItemSystemContainerType["Primary"] = "PRIMARY";
    JiraIssueItemSystemContainerType["Request"] = "REQUEST";
    JiraIssueItemSystemContainerType["RequestPortal"] = "REQUEST_PORTAL";
    JiraIssueItemSystemContainerType["Secondary"] = "SECONDARY";
    return JiraIssueItemSystemContainerType;
}({}); /** Represents a collection of system container types to be fetched by passing in an issue id. */  /** Represents a collection of system container types to be fetched by passing in an issue key and a cloud id. */  /** Represents a collection of items that are held in a tab container. */  /** Represents the items that can be placed in any tab container. */  /** The connection type for `JiraIssueItemTabContainerItem`. */  /** An edge in a `JiraIssueItemTabContainerItem` connection. */  /** This class contains all the possible states an Issue can be in. */ 
let $78ad46e0d6808149$export$be9310abc07a1404 = /*#__PURE__*/ function(JiraIssueLifecycleState) {
    JiraIssueLifecycleState["Active"] = "ACTIVE";
    JiraIssueLifecycleState["Archived"] = "ARCHIVED";
    return JiraIssueLifecycleState;
}({}); /**
 * Represents a single Issue link containing the link id, link type and destination Issue.
 *
 * For Issue create, JiraIssueLink will be populated with
 * the default IssueLink types in the relatedBy field.
 * The issueLinkId and Issue fields will be null.
 *
 * For Issue view, JiraIssueLink will be populated with
 * the Issue link data available on the Issue.
 * The Issue field will contain a nested JiraIssue that is atmost 1 level deep.
 * The nested JiraIssue will not contain fields that can contain further nesting.
 */ 
let $78ad46e0d6808149$export$230ec0d260fcf9aa = /*#__PURE__*/ function(JiraIssueLinkDirection) {
    JiraIssueLinkDirection["Inward"] = "INWARD";
    JiraIssueLinkDirection["Outward"] = "OUTWARD";
    return JiraIssueLinkDirection;
}({}); /** An edge in a JiraIssueLink connection. */  /** Represents linked issues field on a Jira Issue. */  /** Represents linked issues field on a Jira Issue. */  /** Represents linked issues field on a Jira Issue. */  /** Represents linked issues field on a Jira Issue. */  /** Input type for defining the operation on the IssueLink field of a Jira issue. */  /**
 * Represents the issue link type which includes both inwards and outwards relation names
 * For example: blocks, is blocked by, duplicates, is duplicated by, clones, is cloned by.
 */ 
let $78ad46e0d6808149$export$339e1af59c6eefd6 = /*#__PURE__*/ function(JiraIssueNavigatorSearchLayout) {
    JiraIssueNavigatorSearchLayout["Detail"] = "DETAIL";
    JiraIssueNavigatorSearchLayout["List"] = "LIST";
    return JiraIssueNavigatorSearchLayout;
}({}); /** Summary of the Pull Requests attached to the issue */  /** Container for the summary of the Pull Requests attached to the issue */  /** The container of SCM pull requests info associated with a Jira issue. */  /** Represents issue restriction field on an issue for next gen projects. */  /** Represents issue restriction field on an issue for next gen projects. */  /** Represents issue restriction field on an issue for next gen projects. */  /** Summary of the Reviews attached to the issue */  /** Container for the summary of the Reviews attached to the issue */  /** Represents an issue search result when querying with a JiraFilter. */  /** Represents an issue search result when querying with a JiraFilter. */  /** Represents an issue search result when querying with a JiraFilter. */  /** Represents an issue search result when querying with a set of issue ids. */  /** Represents an issue search result when querying with a set of issue ids. */  /** Represents an issue search result when querying with a set of issue ids. */  /** Represents an issue search result when querying with a Jira Query Language (JQL) string. */  /** Represents an issue search result when querying with a Jira Query Language (JQL) string. */  /** Represents an issue search result when querying with a Jira Query Language (JQL) string. */  /**
 * Represents the contextless content for an issue search result in Jira.
 * There is no JiraIssueSearchView associated with this content and is therefore contextless.
 */ 
let $78ad46e0d6808149$export$7ca831dd5735cc4c = /*#__PURE__*/ function(JiraIssueSearchFieldSetSelectedState) {
    JiraIssueSearchFieldSetSelectedState["All"] = "ALL";
    JiraIssueSearchFieldSetSelectedState["NonSelected"] = "NON_SELECTED";
    JiraIssueSearchFieldSetSelectedState["Selected"] = "SELECTED";
    return JiraIssueSearchFieldSetSelectedState;
}({}); /**
 * A filter for the JiraIssueSearchFieldSet connections.
 * By default, if no fieldSetSelectedState is specified, only SELECTED fields are returned.
 */ 
let $78ad46e0d6808149$export$2df7420a9bb23332 = /*#__PURE__*/ function(JiraIssueTransitionCommentType) {
    JiraIssueTransitionCommentType["InternalNote"] = "INTERNAL_NOTE";
    JiraIssueTransitionCommentType["ReplyToCustomer"] = "REPLY_TO_CUSTOMER";
    return JiraIssueTransitionCommentType;
}({}); /** Input type for field level inputs, which may be required to perform a transition for the issue */  /** Enum representing different types of messages to be shown on modal load screen */ 
let $78ad46e0d6808149$export$dafe05b7c43936e0 = /*#__PURE__*/ function(JiraIssueTransitionLayoutMessageType) {
    JiraIssueTransitionLayoutMessageType["Error"] = "ERROR";
    JiraIssueTransitionLayoutMessageType["Info"] = "INFO";
    JiraIssueTransitionLayoutMessageType["Success"] = "SUCCESS";
    JiraIssueTransitionLayoutMessageType["Warn"] = "WARN";
    return JiraIssueTransitionLayoutMessageType;
}({}); /** Represents the messages to be shown on the Transition Modal Load screen */  /** Represents the issue transition modal load screen */  /** The type for response payload, to be returned after making a transition for the issue */  /** Represents an Issue type, e.g. story, task, bug. */  /** The connection type for JiraIssueType. */  /** An edge in a JiraCommentConnection connection. */  /** Represents an issue type field on a Jira Issue. */  /** Represents an issue type field on a Jira Issue. */  /** Represents an issue type field on a Jira Issue. */  /** Input type for defining the operation on the IssueType field of a Jira issue. */  /** The payload type returned after updating the IssueType field of a Jira issue. */  /** Return only issue types that match this filter */  /**
 * The Jira IssueType hierarchy level.
 * Hierarchy levels represent Issue parent-child relationships using an integer scale.
 */ 
let $78ad46e0d6808149$export$8aef47d2eef7b927 = /*#__PURE__*/ function(JiraIssueViewActivityFeedSortOrder) {
    JiraIssueViewActivityFeedSortOrder["NewestFirst"] = "NEWEST_FIRST";
    JiraIssueViewActivityFeedSortOrder["OldestFirst"] = "OLDEST_FIRST";
    return JiraIssueViewActivityFeedSortOrder;
}({}); /** The options for the selected attachment view. */ 
let $78ad46e0d6808149$export$db6a595e3239346 = /*#__PURE__*/ function(JiraIssueViewAttachmentPanelViewMode) {
    JiraIssueViewAttachmentPanelViewMode["ListView"] = "LIST_VIEW";
    JiraIssueViewAttachmentPanelViewMode["StripView"] = "STRIP_VIEW";
    return JiraIssueViewAttachmentPanelViewMode;
}({}); /** The options for displaying timestamps. */ 
let $78ad46e0d6808149$export$c5dd6014d53eac27 = /*#__PURE__*/ function(JiraIssueViewTimestampDisplayMode) {
    JiraIssueViewTimestampDisplayMode["Absolute"] = "ABSOLUTE";
    JiraIssueViewTimestampDisplayMode["Relative"] = "RELATIVE";
    return JiraIssueViewTimestampDisplayMode;
}({});
let $78ad46e0d6808149$export$ab2f34f07eb5e4b6 = /*#__PURE__*/ function(JiraIteration) {
    JiraIteration["Iteration_1"] = "ITERATION_1";
    JiraIteration["Iteration_2"] = "ITERATION_2";
    JiraIteration["IterationDynamic"] = "ITERATION_DYNAMIC";
    return JiraIteration;
}({}); /** The options for jql builder search mode. */ 
let $78ad46e0d6808149$export$3b5b236cf36c7f9a = /*#__PURE__*/ function(JiraJqlBuilderSearchMode) {
    JiraJqlBuilderSearchMode["Advanced"] = "ADVANCED";
    JiraJqlBuilderSearchMode["Basic"] = "BASIC";
    return JiraJqlBuilderSearchMode;
}({}); /** The representation for Natural Language to JQL generation response */  /** The possible errors that can occur during a JQL generation. */  /** JQL History Node. Includes the jql. */  /** The connection to a list of JQL History. */  /** An edge in a JQL History connection. */  /**
 * The autocomplete types available for Jira fields in the context of the Jira Query Language.
 *
 * This enum also describes which fields have field-value support from this schema.
 */ 
let $78ad46e0d6808149$export$fd281481162cf736 = /*#__PURE__*/ function(JiraJqlAutocompleteType) {
    JiraJqlAutocompleteType["Basic"] = "BASIC";
    JiraJqlAutocompleteType["Cascadingoption"] = "CASCADINGOPTION";
    JiraJqlAutocompleteType["Component"] = "COMPONENT";
    JiraJqlAutocompleteType["Group"] = "GROUP";
    JiraJqlAutocompleteType["Issue"] = "ISSUE";
    JiraJqlAutocompleteType["Issuetype"] = "ISSUETYPE";
    JiraJqlAutocompleteType["JwmCategory"] = "JWM_CATEGORY";
    JiraJqlAutocompleteType["Labels"] = "LABELS";
    JiraJqlAutocompleteType["None"] = "NONE";
    JiraJqlAutocompleteType["Option"] = "OPTION";
    JiraJqlAutocompleteType["Organization"] = "ORGANIZATION";
    JiraJqlAutocompleteType["Priority"] = "PRIORITY";
    JiraJqlAutocompleteType["Project"] = "PROJECT";
    JiraJqlAutocompleteType["Requesttype"] = "REQUESTTYPE";
    JiraJqlAutocompleteType["Resolution"] = "RESOLUTION";
    JiraJqlAutocompleteType["Sprint"] = "SPRINT";
    JiraJqlAutocompleteType["Status"] = "STATUS";
    JiraJqlAutocompleteType["Statuscategory"] = "STATUSCATEGORY";
    JiraJqlAutocompleteType["TicketCategory"] = "TICKET_CATEGORY";
    JiraJqlAutocompleteType["User"] = "USER";
    JiraJqlAutocompleteType["Version"] = "VERSION";
    return JiraJqlAutocompleteType;
}({}); /**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */ 
let $78ad46e0d6808149$export$4b728896d4330036 = /*#__PURE__*/ function(JiraJqlBuilderMode) {
    JiraJqlBuilderMode["Basic"] = "BASIC";
    JiraJqlBuilderMode["Jql"] = "JQL";
    return JiraJqlBuilderMode;
}({}); /** Represents a field-value for a JQL cascading option field. */  /** Represents a connection of field-values for a JQL cascading option field. */  /** Represents a field-value edge for a JQL cascading option field. */  /** The types of JQL clauses supported by Jira. */ 
let $78ad46e0d6808149$export$cbea312143ae44f9 = /*#__PURE__*/ function(JiraJqlClauseType) {
    JiraJqlClauseType["Any"] = "ANY";
    JiraJqlClauseType["OrderBy"] = "ORDER_BY";
    JiraJqlClauseType["Where"] = "WHERE";
    return JiraJqlClauseType;
}({}); /** Represents a field-value for a JQL component field. */  /** The representation of a Jira field within the context of the Jira Query Language. */  /** Represents a connection of Jira JQL fields. */  /** A union of a Jira JQL field connection and a GraphQL query error. */  /** Represents a Jira JQL field edge. */  /**
 * The representation of a Jira JQL field-type in the context of the Jira Query Language.
 *
 * E.g. `Short Text`, `Number`, `Version Picker`, `Team` etc.
 *
 * Important note: This information only exists for collapsed fields.
 */ 
let $78ad46e0d6808149$export$c4f30303e8f1794 = /*#__PURE__*/ function(JiraJqlFunctionStatus) {
    JiraJqlFunctionStatus["Finished"] = "FINISHED";
    JiraJqlFunctionStatus["Processing"] = "PROCESSING";
    JiraJqlFunctionStatus["Unknown"] = "UNKNOWN";
    return JiraJqlFunctionStatus;
}({}); /** Represents a field-value for a JQL goals field. */  /** Represents a field-value for a JQL group field. */  /** Represents a connection of field-values for a JQL group field. */  /** Represents a field-value edge for a JQL group field. */  /** Represents a JQL query with hydrated fields and field-values. */  /** A union of a Jira JQL hydrated query and a GraphQL query error. */  /** Represents a field-value for a JQL Issue field. */  /** Represents a field-value for a JQL issue type field. */  /** Represents a connection of field-values for a JQL issue type field. */  /** Represents a field-value edge for a JQL issue type field. */  /** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */  /** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */  /** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */  /** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */  /** Represents a field-value for a JQL label field. */  /**
 * The types of JQL operators supported by Jira.
 *
 * An operator in JQL is one or more symbols or words,which compares the value of a field on its left with one or more values (or functions) on its right,
 * such that only true results are retrieved by the clause.
 *
 * For more information on JQL operators please visit: https://support.atlassian.com/jira-software-cloud/docs/advanced-search-reference-jql-operators.
 */ 
let $78ad46e0d6808149$export$d3fe59ef06ef4fb4 = /*#__PURE__*/ function(JiraJqlOperator) {
    JiraJqlOperator["Changed"] = "CHANGED";
    JiraJqlOperator["Contains"] = "CONTAINS";
    JiraJqlOperator["Equals"] = "EQUALS";
    JiraJqlOperator["GreaterThan"] = "GREATER_THAN";
    JiraJqlOperator["GreaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
    JiraJqlOperator["In"] = "IN";
    JiraJqlOperator["Is"] = "IS";
    JiraJqlOperator["IsNot"] = "IS_NOT";
    JiraJqlOperator["LessThan"] = "LESS_THAN";
    JiraJqlOperator["LessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
    JiraJqlOperator["NotContains"] = "NOT_CONTAINS";
    JiraJqlOperator["NotEquals"] = "NOT_EQUALS";
    JiraJqlOperator["NotIn"] = "NOT_IN";
    JiraJqlOperator["Was"] = "WAS";
    JiraJqlOperator["WasIn"] = "WAS_IN";
    JiraJqlOperator["WasNot"] = "WAS_NOT";
    JiraJqlOperator["WasNotIn"] = "WAS_NOT_IN";
    return JiraJqlOperator;
}({}); /** Represents a field-value for a JQL option field. */  /** Represents a connection of field-values for a JQL option field. */  /** Represents a field-value edge for a JQL option field. */  /** Represents a field-value for a JQL plain text field (as opposed to a rich text one) such as summary. */  /** Represents a field-value for a JQL priority field. */  /** Represents a field-value for a JQL project field. */  /** Represents a connection of field-values for a JQL project field. */  /** Represents a field-value edge for a JQL project field. */  /** Represents an error for a JQL query hydration. */  /** Represents a hydrated field for a JQL query. */  /** A union of a JQL query hydrated field and a GraphQL query error. */  /** Represents a hydrated field-value for a given field in the JQL query. */  /** A union of a JQL query hydrated field-value and a GraphQL query error. */  /** Represents a field-value for a JQL resolution field. */  /** The representation of a Jira field in the basic search mode of the JQL builder. */  /** Represents a field-value for a JQL sprint field. */  /** Represents a connection of field-values for a JQL sprint field. */  /** Represents a field-value edge for a JQL sprint field. */  /** Represents a field-value for a JQL status category field. */  /** Represents a field-value for a JQL status field. */ 
let $78ad46e0d6808149$export$b4868a7397b1d1a3 = /*#__PURE__*/ function(JiraJqlSyntaxError) {
    JiraJqlSyntaxError["BadFieldId"] = "BAD_FIELD_ID";
    JiraJqlSyntaxError["BadFunctionArgument"] = "BAD_FUNCTION_ARGUMENT";
    JiraJqlSyntaxError["BadOperator"] = "BAD_OPERATOR";
    JiraJqlSyntaxError["BadPropertyId"] = "BAD_PROPERTY_ID";
    JiraJqlSyntaxError["EmptyField"] = "EMPTY_FIELD";
    JiraJqlSyntaxError["EmptyFunction"] = "EMPTY_FUNCTION";
    JiraJqlSyntaxError["EmptyFunctionArgument"] = "EMPTY_FUNCTION_ARGUMENT";
    JiraJqlSyntaxError["IllegalCharacter"] = "ILLEGAL_CHARACTER";
    JiraJqlSyntaxError["IllegalEscape"] = "ILLEGAL_ESCAPE";
    JiraJqlSyntaxError["IllegalNumber"] = "ILLEGAL_NUMBER";
    JiraJqlSyntaxError["MissingFieldName"] = "MISSING_FIELD_NAME";
    JiraJqlSyntaxError["MissingLogicalOperator"] = "MISSING_LOGICAL_OPERATOR";
    JiraJqlSyntaxError["NoOperator"] = "NO_OPERATOR";
    JiraJqlSyntaxError["NoOrder"] = "NO_ORDER";
    JiraJqlSyntaxError["OperandUnsupported"] = "OPERAND_UNSUPPORTED";
    JiraJqlSyntaxError["PredicateUnsupported"] = "PREDICATE_UNSUPPORTED";
    JiraJqlSyntaxError["ReservedCharacter"] = "RESERVED_CHARACTER";
    JiraJqlSyntaxError["ReservedWord"] = "RESERVED_WORD";
    JiraJqlSyntaxError["UnexpectedText"] = "UNEXPECTED_TEXT";
    JiraJqlSyntaxError["UnfinishedString"] = "UNFINISHED_STRING";
    JiraJqlSyntaxError["Unknown"] = "UNKNOWN";
    return JiraJqlSyntaxError;
}({}); /** Represents a field-value for a JQL user field. */  /** Represents a connection of field-values for a JQL user field. */  /** Represents a field-value edge for a JQL user field. */  /** Represents a field-value for a JQL version field. */  /** Represents a connection of field-values for a JQL version field. */  /** Represents a field-value edge for a JQL version field. */  /**
 * A variation of the fieldValues query for retrieving specifically Jira version field-values.
 *
 * This type provides the capability to retrieve connections of released, unreleased and archived versions.
 *
 * Important note: that released and unreleased versions can be archived and vice versa.
 */ 
let $78ad46e0d6808149$export$586b6450ae834916 = /*#__PURE__*/ function(JiraJqlViewContext) {
    JiraJqlViewContext["JswPlans"] = "JSW_PLANS";
    JiraJqlViewContext["Jwm"] = "JWM";
    JiraJqlViewContext["ShadowRequest"] = "SHADOW_REQUEST";
    return JiraJqlViewContext;
}({}); /** Represents the label of a custom label field. */  /** The connection type for JiraLabel. */  /** An edge in a Jiralabel connection. */  /** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */  /** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */  /** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */  /** Input type for labels field */  /** Represents the data of a single Label */  /** Input type for defining the operation on the Team field of a Jira issue. */  /** The payload type returned after updating the Team field of a Jira issue. */  /** Input to link/unlink an issue to/from a related work item. */  /** The return payload for linking and unlinking an issue to and from a related work item. */ 
let $78ad46e0d6808149$export$29e67496c83af6d9 = /*#__PURE__*/ function(JiraLinkIssuesToIncidentIssueLinkTypeName) {
    JiraLinkIssuesToIncidentIssueLinkTypeName["PostIncidentReviews"] = "POST_INCIDENT_REVIEWS";
    JiraLinkIssuesToIncidentIssueLinkTypeName["Relates"] = "RELATES";
    return JiraLinkIssuesToIncidentIssueLinkTypeName;
}({}); /** Represents the current state of a long running task. */ 
let $78ad46e0d6808149$export$aad956212e1cffd3 = /*#__PURE__*/ function(JiraLongRunningTaskStatus) {
    JiraLongRunningTaskStatus["Cancelled"] = "CANCELLED";
    JiraLongRunningTaskStatus["CancelRequested"] = "CANCEL_REQUESTED";
    JiraLongRunningTaskStatus["Complete"] = "COMPLETE";
    JiraLongRunningTaskStatus["Dead"] = "DEAD";
    JiraLongRunningTaskStatus["Enqueued"] = "ENQUEUED";
    JiraLongRunningTaskStatus["Failed"] = "FAILED";
    JiraLongRunningTaskStatus["Running"] = "RUNNING";
    return JiraLongRunningTaskStatus;
}({}); /** Description of a single file attachment definition. */  /** A connection for JiraMediaAttachmentFile. */  /** An edge in a JiraMediaAttachmentFile connection. */  /** A Jira Background Media, containing a reference to a custom background */  /** Represents a media context used for file uploads. */  /** Contains the information needed for reading uploaded media content in jira on issue create/view screens. */  /** Contains the information needed for reading uploaded media content in jira on issue create/view screens. */  /** Entry of an attachment read token with its respective files accessible. */  /** Entry of an attachment read token with its respective files accessible. */  /** A connection for JiraMediaTokenWithFiles. */  /** An edge in a JiraMediaTokenWithFiles connection. */  /** Contains the information needed for uploading a media content in jira on issue create/view screens. */  /** Contains either the successful fetched media token information or an error. */  /**
 * The input to merge one version with another, which deletes the source version and moves
 * all issues from the source version to the target version.
 */ 
let $78ad46e0d6808149$export$283b57df1581f83e = /*#__PURE__*/ function(JiraMultiValueFieldOperations) {
    JiraMultiValueFieldOperations["Add"] = "ADD";
    JiraMultiValueFieldOperations["Remove"] = "REMOVE";
    JiraMultiValueFieldOperations["Set"] = "SET";
    return JiraMultiValueFieldOperations;
}({}); /** Represents a multiple group picker field on a Jira Issue. */  /** Represents a multiple group picker field on a Jira Issue. */  /** Represents a multiple group picker field on a Jira Issue. */  /** Input type for multiple group picker field */  /** Input type for defining the operation on the MultipleGroupPicker field of a Jira issue. */  /** The payload type returned after updating the MultipleGroupPicker field of a Jira issue. */  /** Input type for multiple select clearable user picker fields */  /** Represents the multi-select field on a Jira Issue. */  /** Represents the multi-select field on a Jira Issue. */  /** Represents the multi-select field on a Jira Issue. */  /** Represents the multi-select field on a Jira Issue. */  /** Represents the multi-select field on a Jira Issue. */  /** Input type for multi select field */  /** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */  /** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */  /** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */  /** Input type for multiple select user picker fields */  /** Input type for defining the operation on MultipleSelectUserPicker field of a Jira issue. */  /** The payload type returned after updating MultipleSelectUserPicker field of a Jira issue. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Input type for multiple select version picker fields */  /** Input type for defining the operation on Multiple Version Picker field of a Jira issue. */  /** The payload type returned after updating Multiple Version Picker field of a Jira issue. */  /** The input used for an natural language to JQL conversion */  /** The most general interface for a navigation item. Represents pages a user can navigate to within a scope. */  /** The connection type for navigation items. */  /** The edge type for navigation items. */  /** GraphQL does not allow interfaces inside unions, need to list every implementation explicitly. */  /** General interface to represent a type of navigation item, identified by its `JiraNavigationItemTypeKey`. */  /** Connection of navigation item types. */  /** The edge type for navigation item types. */  /**
 * List of values identifying the known navigation item types. This list is shared between
 * business and software projects but only some are supported by one or the other.
 */ 
let $78ad46e0d6808149$export$36f79c8a08b4e752 = /*#__PURE__*/ function(JiraNavigationItemTypeKey) {
    JiraNavigationItemTypeKey["App"] = "APP";
    JiraNavigationItemTypeKey["Approvals"] = "APPROVALS";
    JiraNavigationItemTypeKey["Apps"] = "APPS";
    JiraNavigationItemTypeKey["ArchivedIssues"] = "ARCHIVED_ISSUES";
    JiraNavigationItemTypeKey["Attachments"] = "ATTACHMENTS";
    JiraNavigationItemTypeKey["Backlog"] = "BACKLOG";
    JiraNavigationItemTypeKey["Board"] = "BOARD";
    JiraNavigationItemTypeKey["Calendar"] = "CALENDAR";
    JiraNavigationItemTypeKey["Code"] = "CODE";
    JiraNavigationItemTypeKey["Components"] = "COMPONENTS";
    JiraNavigationItemTypeKey["Deployments"] = "DEPLOYMENTS";
    JiraNavigationItemTypeKey["Development"] = "DEVELOPMENT";
    JiraNavigationItemTypeKey["Forms"] = "FORMS";
    JiraNavigationItemTypeKey["Goals"] = "GOALS";
    JiraNavigationItemTypeKey["Incidents"] = "INCIDENTS";
    JiraNavigationItemTypeKey["Issues"] = "ISSUES";
    JiraNavigationItemTypeKey["List"] = "LIST";
    JiraNavigationItemTypeKey["OnCall"] = "ON_CALL";
    JiraNavigationItemTypeKey["Pages"] = "PAGES";
    JiraNavigationItemTypeKey["Releases"] = "RELEASES";
    JiraNavigationItemTypeKey["Reports"] = "REPORTS";
    JiraNavigationItemTypeKey["Requests"] = "REQUESTS";
    JiraNavigationItemTypeKey["Security"] = "SECURITY";
    JiraNavigationItemTypeKey["Shortcut"] = "SHORTCUT";
    JiraNavigationItemTypeKey["Shortcuts"] = "SHORTCUTS";
    JiraNavigationItemTypeKey["Summary"] = "SUMMARY";
    JiraNavigationItemTypeKey["Timeline"] = "TIMELINE";
    return JiraNavigationItemTypeKey;
}({}); /** The navigation UI state of the left sidebar and right panels user property */  /** The navigation UI state of the left sidebar and right panels user property */  /** Represents the possible notification categories for notification types. */ 
let $78ad46e0d6808149$export$b4137b99365f6ad8 = /*#__PURE__*/ function(JiraNotificationCategoryType) {
    JiraNotificationCategoryType["CommentChanges"] = "COMMENT_CHANGES";
    JiraNotificationCategoryType["IssueAssigned"] = "ISSUE_ASSIGNED";
    JiraNotificationCategoryType["IssueChanges"] = "ISSUE_CHANGES";
    JiraNotificationCategoryType["IssueMentioned"] = "ISSUE_MENTIONED";
    JiraNotificationCategoryType["IssueMiscellaneous"] = "ISSUE_MISCELLANEOUS";
    JiraNotificationCategoryType["IssueWorklogChanges"] = "ISSUE_WORKLOG_CHANGES";
    return JiraNotificationCategoryType;
}({}); /** Represents a preference for a particular notification channel. */  /** Represents the possible types notification channels. */ 
let $78ad46e0d6808149$export$ec1ac0705bb7ee00 = /*#__PURE__*/ function(JiraNotificationChannelType) {
    JiraNotificationChannelType["Email"] = "EMAIL";
    JiraNotificationChannelType["InProduct"] = "IN_PRODUCT";
    JiraNotificationChannelType["MobilePush"] = "MOBILE_PUSH";
    return JiraNotificationChannelType;
}({}); /** Represents notification preferences across all projects. */  /** Represents options for notifications that don't fit in with the recipient calculation oriented preferences in JiraNotificationPreferences. */  /** Represents a notification preference for a particular notification type. */  /** Represents a notification preferences to be updated. */  /** Represents notification preferences by notification type. */  /** The connection type for JiraNotificationProjectPreferences. */  /** Represents a project's notification preferences. */  /** Represents the possible types of notifications. */ 
let $78ad46e0d6808149$export$6e621da855f29918 = /*#__PURE__*/ function(JiraNotificationType) {
    JiraNotificationType["CommentCreated"] = "COMMENT_CREATED";
    JiraNotificationType["CommentDeleted"] = "COMMENT_DELETED";
    JiraNotificationType["CommentEdited"] = "COMMENT_EDITED";
    JiraNotificationType["IssueAssigned"] = "ISSUE_ASSIGNED";
    JiraNotificationType["IssueCreated"] = "ISSUE_CREATED";
    JiraNotificationType["IssueDeleted"] = "ISSUE_DELETED";
    JiraNotificationType["IssueMoved"] = "ISSUE_MOVED";
    JiraNotificationType["IssueUpdated"] = "ISSUE_UPDATED";
    JiraNotificationType["MentionsCombined"] = "MENTIONS_COMBINED";
    JiraNotificationType["MiscellaneousIssueEventCombined"] = "MISCELLANEOUS_ISSUE_EVENT_COMBINED";
    JiraNotificationType["WorklogCombined"] = "WORKLOG_COMBINED";
    return JiraNotificationType;
}({}); /** Represents a number field on a Jira Issue. E.g. float, story points. */  /** Input type for a number field */  /** An OAuth app which may have permissions to push/read extension data from issues */  /** Mutations */  /** An oauth app which provides devOps capabilities. */  /** The types of events published by the onSuggestedChildIssue subscription. */  /** Represents Jira OpsgenieTeam. */  /** Represents a single option value in a select operation. */  /** The connection type for JiraOption. */  /** An edge in a JiraOption connection. */  /** The input type for opting out of the Not Connected state in the DevOpsPanel */  /** The response payload for opting out of the Not Connected state in the DevOpsPanel */  /** Response for the order formatting rule mutation. */  /** Response for the order formatting rule mutation. */ 
let $78ad46e0d6808149$export$59148652a7cacd91 = /*#__PURE__*/ function(JiraOrganizationApprovalLocation) {
    JiraOrganizationApprovalLocation["DuringInstallationFlow"] = "DURING_INSTALLATION_FLOW";
    JiraOrganizationApprovalLocation["DuringProvisioning"] = "DURING_PROVISIONING";
    JiraOrganizationApprovalLocation["OnAdminScreen"] = "ON_ADMIN_SCREEN";
    JiraOrganizationApprovalLocation["RemindBitbucketApprovalBanner"] = "REMIND_BITBUCKET_APPROVAL_BANNER";
    JiraOrganizationApprovalLocation["Unknown"] = "UNKNOWN";
    return JiraOrganizationApprovalLocation;
}({}); /** Input type for an organization field */  /** Input type for an organization value */  /**
 * Represents the original time estimate field on Jira issue screens. Note that this is the same value as the originalEstimate from JiraTimeTrackingField
 * This field should only be used on issue view because issue view hasn't deprecated the original estimation as a standalone field
 */ 
let $78ad46e0d6808149$export$22ca33290808aca8 = /*#__PURE__*/ function(JiraOverviewPlanMigrationChangeboardingStatus) {
    JiraOverviewPlanMigrationChangeboardingStatus["Completed"] = "COMPLETED";
    JiraOverviewPlanMigrationChangeboardingStatus["Triggered"] = "TRIGGERED";
    return JiraOverviewPlanMigrationChangeboardingStatus;
}({}); /** Describe the state of the overview-plan migration for the calling user. */  /** Result type for the jwmOverviewPlanMigrationState field */  /** The base type cursor data necessary for random access pagination. */  /** This encapsulates all the necessary cursors for random access pagination. */  /** Input type for the parent field of an issue */  /** Input type for defining the operation on the Parent field of a Jira issue. */  /** The payload type returned after updating the Parent field of a Jira issue. */  /** Represents Parent field on a Jira Issue. E.g. JSW Parent, JPO Parent (to be unified). */  /** Represents Parent field on a Jira Issue. E.g. JSW Parent, JPO Parent (to be unified). */  /** The connection type for JiraParentOption. */  /** An edge in a JiraParentOption connection. */  /** Represents flags required to determine parent field visibility */  /** Represents a people picker field on a Jira Issue. */  /** Represents a people picker field on a Jira Issue. */  /** Represents a people picker field on a Jira Issue. */  /** Input type for people field */  /** Input type for defining the operation on People field of a Jira issue. */  /** The payload type returned after updating People field of a Jira issue. */  /**
 * This represents Jira Permission with all Permission level details (To be added)
 * and can be used to determine whether a User has certain permissions.
 * Note: This entity only returns `hasPermission`
 * but in future, it should contain more permission level details like ID, description etc.
 */ 
let $78ad46e0d6808149$export$edf2fc589cbdc = /*#__PURE__*/ function(JiraPermissionMessageTypeEnum) {
    JiraPermissionMessageTypeEnum["Information"] = "INFORMATION";
    JiraPermissionMessageTypeEnum["Warning"] = "WARNING";
    return JiraPermissionMessageTypeEnum;
}({}); /** A permission scheme is a collection of permission grants. */  /** The input type to add new permission grants to the given permission scheme. */  /** The response payload for add permission grants mutation operation for a given permission scheme. */  /** The JiraPermissionSchemeConfiguration represents additional configuration information regarding the permission scheme such as its editability. */  /**
 * The JiraPermissionSchemeGrantGroup is an association between project permission category information and a bounded list of one or more
 * associated permission grant holder. A grant holder represents project permission information and its associated permission grants.
 */ 
let $78ad46e0d6808149$export$a7ab8f3606c74f1 = /*#__PURE__*/ function(JiraPermissionTagEnum) {
    JiraPermissionTagEnum["Deprecated"] = "DEPRECATED";
    JiraPermissionTagEnum["Enterprise"] = "ENTERPRISE";
    JiraPermissionTagEnum["New"] = "NEW";
    return JiraPermissionTagEnum;
}({}); /** The different permission types that a user can perform on a global level */ 
let $78ad46e0d6808149$export$b91894fc36442fca = /*#__PURE__*/ function(JiraPermissionType) {
    JiraPermissionType["BrowseProjects"] = "BROWSE_PROJECTS";
    JiraPermissionType["BulkChange"] = "BULK_CHANGE";
    return JiraPermissionType;
}({}); /** Represents a Jira Plan */  /** The status of a Jira Plan */ 
let $78ad46e0d6808149$export$39bfd317df87a9c = /*#__PURE__*/ function(JiraPlanStatus) {
    JiraPlanStatus["Active"] = "ACTIVE";
    JiraPlanStatus["Archived"] = "ARCHIVED";
    JiraPlanStatus["Trashed"] = "TRASHED";
    return JiraPlanStatus;
}({}); /** Represents a Jira platform attachment. */  /** Represents a Jira platform attachment. */  /** Represents a Jira platform attachment. */  /** Represents a Jira platform attachment. */  /** Represents a Jira platform comment. */  /** A link to a post-incident review (also known as a postmortem). */  /** Represents an issue's priority field */  /** The connection type for JiraPriority. */  /** An edge in a JiraPriority connection. */  /** Represents a priority field on a Jira Issue. */  /** Represents a priority field on a Jira Issue. */  /** Input type for priority field */  /** Representation of each Jira product offering. */ 
let $78ad46e0d6808149$export$62abc5008715ef4b = /*#__PURE__*/ function(JiraProductEnum) {
    JiraProductEnum["JiraProductDiscovery"] = "JIRA_PRODUCT_DISCOVERY";
    JiraProductEnum["JiraServiceManagement"] = "JIRA_SERVICE_MANAGEMENT";
    JiraProductEnum["JiraSoftware"] = "JIRA_SOFTWARE";
    JiraProductEnum["JiraWorkManagement"] = "JIRA_WORK_MANAGEMENT";
    return JiraProductEnum;
}({}); /** Represents proforma-forms. */  /** Represents the proforma-forms field for an Issue. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents whether the user has the specific project permission or not */  /** The different action types that a user can perform on a project */ 
let $78ad46e0d6808149$export$456e2c6faf3dd3d9 = /*#__PURE__*/ function(JiraProjectActionType) {
    JiraProjectActionType["CreateIssues"] = "CREATE_ISSUES";
    JiraProjectActionType["DeleteIssues"] = "DELETE_ISSUES";
    JiraProjectActionType["EditIssues"] = "EDIT_ISSUES";
    JiraProjectActionType["EditProjectConfig"] = "EDIT_PROJECT_CONFIG";
    JiraProjectActionType["LinkIssues"] = "LINK_ISSUES";
    JiraProjectActionType["ScheduleIssues"] = "SCHEDULE_ISSUES";
    JiraProjectActionType["TransitionIssues"] = "TRANSITION_ISSUES";
    JiraProjectActionType["ViewIssues"] = "VIEW_ISSUES";
    JiraProjectActionType["ViewProjectConfig"] = "VIEW_PROJECT_CONFIG";
    return JiraProjectActionType;
}({}); /** A relationship between a Jira Project and Opsgenie Team */  /** A relationship between a Jira Project and Opsgenie Team */  /** A relationship between a Jira project and a repository (Bitbucket or third party). */  /** A relationship between a Jira project and a repository (Bitbucket or third party). */  /** The connection object for a collection of Jira project and repository relationships. */  /** #################### Filtering and Sorting Inputs ##################### */  /** #################### Enums ##################### */ 
let $78ad46e0d6808149$export$6867a13128bb4266 = /*#__PURE__*/ function(JiraProjectAndRepositoryRelationshipSortBy) {
    JiraProjectAndRepositoryRelationshipSortBy["LastInferredAt"] = "LAST_INFERRED_AT";
    return JiraProjectAndRepositoryRelationshipSortBy;
}({}); /** An entry in the activity log table for project role actors. */  /** Connection type for JiraProjectCleanupLogTableEntry. */  /** An edge in a JiraProjectCleanupLogTableEntryConnection. */  /** Project cleanup recommendation. */  /** Recommendation action for a project cleanup. */ 
let $78ad46e0d6808149$export$a2f8423691ae525a = /*#__PURE__*/ function(JiraProjectCleanupRecommendationAction) {
    JiraProjectCleanupRecommendationAction["Archive"] = "ARCHIVE";
    JiraProjectCleanupRecommendationAction["Trash"] = "TRASH";
    return JiraProjectCleanupRecommendationAction;
}({}); /** Connection type for JiraProjectCleanupRecommendation. */  /** An edge in a JiraProjectCleanupRecommendation connection. */  /** A period of time since the project was found stale. */ 
let $78ad46e0d6808149$export$9c0ded90f678acb6 = /*#__PURE__*/ function(JiraProjectCleanupRecommendationStaleSince) {
    JiraProjectCleanupRecommendationStaleSince["OneYear"] = "ONE_YEAR";
    JiraProjectCleanupRecommendationStaleSince["SixMonths"] = "SIX_MONTHS";
    JiraProjectCleanupRecommendationStaleSince["TwoYears"] = "TWO_YEARS";
    return JiraProjectCleanupRecommendationStaleSince;
}({}); /** The status of the project cleanup task. */ 
let $78ad46e0d6808149$export$b2cfde8b20600ddf = /*#__PURE__*/ function(JiraProjectCleanupTaskStatusType) {
    JiraProjectCleanupTaskStatusType["Complete"] = "COMPLETE";
    JiraProjectCleanupTaskStatusType["Error"] = "ERROR";
    JiraProjectCleanupTaskStatusType["InProgress"] = "IN_PROGRESS";
    JiraProjectCleanupTaskStatusType["Pending"] = "PENDING";
    JiraProjectCleanupTaskStatusType["TerminalError"] = "TERMINAL_ERROR";
    return JiraProjectCleanupTaskStatusType;
}({}); /** The connection type for JiraProject. */  /**
 * String formats for DateTime in JiraProject, the format is in the value of the jira.date.time.picker.java.format property
 * Please refer to the "Change date and time formats" section of the "Configure the look and feel of Jira applications" page
 * https://support.atlassian.com/jira-cloud-administration/docs/configure-the-look-and-feel-of-jira-applications/
 */ 
let $78ad46e0d6808149$export$8e4f09e2e6362630 = /*#__PURE__*/ function(JiraProjectDateTimeFormat) {
    JiraProjectDateTimeFormat["CompleteDatetimeFormat"] = "COMPLETE_DATETIME_FORMAT";
    JiraProjectDateTimeFormat["DayFormat"] = "DAY_FORMAT";
    JiraProjectDateTimeFormat["DayMonthYearFormat"] = "DAY_MONTH_YEAR_FORMAT";
    JiraProjectDateTimeFormat["Relative"] = "RELATIVE";
    JiraProjectDateTimeFormat["TimeFormat"] = "TIME_FORMAT";
    return JiraProjectDateTimeFormat;
}({}); /** An edge in a JiraProject connection. */  /**
 * Represents a project field on a Jira Issue.
 * Both the system & custom project field can be represented by this type.
 */ 
let $78ad46e0d6808149$export$341e76c920e0710f = /*#__PURE__*/ function(JiraProjectListRightPanelState) {
    JiraProjectListRightPanelState["Closed"] = "CLOSED";
    JiraProjectListRightPanelState["Open"] = "OPEN";
    return JiraProjectListRightPanelState;
}({}); /** A connection that returns a paginated collection of project template */  /** An edge that contains a project template and a cursor. */  /** Simplified version of a project template. */  /** Whether or not the user has configured notification preferences for the project. */ 
let $78ad46e0d6808149$export$6e766e8806e1db62 = /*#__PURE__*/ function(JiraProjectNotificationConfigurationState) {
    JiraProjectNotificationConfigurationState["Configured"] = "CONFIGURED";
    JiraProjectNotificationConfigurationState["Default"] = "DEFAULT";
    return JiraProjectNotificationConfigurationState;
}({}); /** An edge in a JiraNotificationProjectPreferences connection. */  /** Options to filter based on project properties */  /** The project permission in Jira and it is scoped to projects. */  /**
 * The category of the project permission.
 * The category information is typically seen in the permission scheme Admin UI.
 * It is used to group the project permissions in general and available for connect app developers when registering new project permissions.
 */ 
let $78ad46e0d6808149$export$ecfca2e8f1d416c9 = /*#__PURE__*/ function(JiraProjectPermissionCategoryEnum) {
    JiraProjectPermissionCategoryEnum["Attachments"] = "ATTACHMENTS";
    JiraProjectPermissionCategoryEnum["Comments"] = "COMMENTS";
    JiraProjectPermissionCategoryEnum["Issues"] = "ISSUES";
    JiraProjectPermissionCategoryEnum["Other"] = "OTHER";
    JiraProjectPermissionCategoryEnum["Projects"] = "PROJECTS";
    JiraProjectPermissionCategoryEnum["TimeTracking"] = "TIME_TRACKING";
    JiraProjectPermissionCategoryEnum["VotersAndWatchers"] = "VOTERS_AND_WATCHERS";
    return JiraProjectPermissionCategoryEnum;
}({}); /** The different permissions that the user can have for a project */ 
let $78ad46e0d6808149$export$5b73c005b9475dcb = /*#__PURE__*/ function(JiraProjectPermissionType) {
    JiraProjectPermissionType["AddComments"] = "ADD_COMMENTS";
    JiraProjectPermissionType["AdministerProjects"] = "ADMINISTER_PROJECTS";
    JiraProjectPermissionType["ArchiveIssues"] = "ARCHIVE_ISSUES";
    JiraProjectPermissionType["AssignableUser"] = "ASSIGNABLE_USER";
    JiraProjectPermissionType["AssignIssues"] = "ASSIGN_ISSUES";
    JiraProjectPermissionType["BrowseProjects"] = "BROWSE_PROJECTS";
    JiraProjectPermissionType["CloseIssues"] = "CLOSE_ISSUES";
    JiraProjectPermissionType["CreateAttachments"] = "CREATE_ATTACHMENTS";
    JiraProjectPermissionType["CreateIssues"] = "CREATE_ISSUES";
    JiraProjectPermissionType["DeleteAllAttachments"] = "DELETE_ALL_ATTACHMENTS";
    JiraProjectPermissionType["DeleteAllComments"] = "DELETE_ALL_COMMENTS";
    JiraProjectPermissionType["DeleteAllWorklogs"] = "DELETE_ALL_WORKLOGS";
    JiraProjectPermissionType["DeleteIssues"] = "DELETE_ISSUES";
    JiraProjectPermissionType["DeleteOwnAttachments"] = "DELETE_OWN_ATTACHMENTS";
    JiraProjectPermissionType["DeleteOwnComments"] = "DELETE_OWN_COMMENTS";
    JiraProjectPermissionType["DeleteOwnWorklogs"] = "DELETE_OWN_WORKLOGS";
    JiraProjectPermissionType["EditAllComments"] = "EDIT_ALL_COMMENTS";
    JiraProjectPermissionType["EditAllWorklogs"] = "EDIT_ALL_WORKLOGS";
    JiraProjectPermissionType["EditIssues"] = "EDIT_ISSUES";
    JiraProjectPermissionType["EditIssueLayout"] = "EDIT_ISSUE_LAYOUT";
    JiraProjectPermissionType["EditOwnComments"] = "EDIT_OWN_COMMENTS";
    JiraProjectPermissionType["EditOwnWorklogs"] = "EDIT_OWN_WORKLOGS";
    JiraProjectPermissionType["EditWorkflow"] = "EDIT_WORKFLOW";
    JiraProjectPermissionType["LinkIssues"] = "LINK_ISSUES";
    JiraProjectPermissionType["ManageWatchers"] = "MANAGE_WATCHERS";
    JiraProjectPermissionType["ModifyReporter"] = "MODIFY_REPORTER";
    JiraProjectPermissionType["MoveIssues"] = "MOVE_ISSUES";
    JiraProjectPermissionType["ResolveIssues"] = "RESOLVE_ISSUES";
    JiraProjectPermissionType["ScheduleIssues"] = "SCHEDULE_ISSUES";
    JiraProjectPermissionType["SetIssueSecurity"] = "SET_ISSUE_SECURITY";
    JiraProjectPermissionType["TransitionIssues"] = "TRANSITION_ISSUES";
    JiraProjectPermissionType["UnarchiveIssues"] = "UNARCHIVE_ISSUES";
    JiraProjectPermissionType["ViewDevTools"] = "VIEW_DEV_TOOLS";
    JiraProjectPermissionType["ViewReadonlyWorkflow"] = "VIEW_READONLY_WORKFLOW";
    JiraProjectPermissionType["ViewVotersAndWatchers"] = "VIEW_VOTERS_AND_WATCHERS";
    JiraProjectPermissionType["WorkOnIssues"] = "WORK_ON_ISSUES";
    return JiraProjectPermissionType;
}({}); /** An entry in the activity log table for project role actors. */  /** Connection type for JiraProjectRoleActorLogTableEntry. */  /** An edge in a JiraProjectRoleActorLogTableEntryConnection. */  /** Project role actor recommendation. */  /** Recommendation action for a project role actor. */ 
let $78ad46e0d6808149$export$efb7762c97861711 = /*#__PURE__*/ function(JiraProjectRoleActorRecommendationAction) {
    JiraProjectRoleActorRecommendationAction["Trash"] = "TRASH";
    return JiraProjectRoleActorRecommendationAction;
}({}); /** Connection type for JiraProjectRoleActorRecommendation. */  /** An edge in a JiraProjectRoleActorRecommendation connection. */  /** User status for a project role actor. */ 
let $78ad46e0d6808149$export$b44a05ea54d6beba = /*#__PURE__*/ function(JiraProjectRoleActorUserStatus) {
    JiraProjectRoleActorUserStatus["Deleted"] = "DELETED";
    JiraProjectRoleActorUserStatus["Inactive"] = "INACTIVE";
    return JiraProjectRoleActorUserStatus;
}({}); /** The project role grant type value having the project role information. */  /** The Jira Project Shortcut that can be either a repo or basic shortcut link */  /** The supported different shortcut types */ 
let $78ad46e0d6808149$export$15a3b3ba6d4cada1 = /*#__PURE__*/ function(JiraProjectShortcutType) {
    JiraProjectShortcutType["Repository"] = "REPOSITORY";
    JiraProjectShortcutType["ShortcutLink"] = "SHORTCUT_LINK";
    JiraProjectShortcutType["Unknown"] = "UNKNOWN";
    return JiraProjectShortcutType;
}({});
let $78ad46e0d6808149$export$f4b615b47854d356 = /*#__PURE__*/ function(JiraProjectSortField) {
    JiraProjectSortField["Category"] = "CATEGORY";
    JiraProjectSortField["Favourite"] = "FAVOURITE";
    JiraProjectSortField["Key"] = "KEY";
    JiraProjectSortField["LastIssueUpdatedTime"] = "LAST_ISSUE_UPDATED_TIME";
    JiraProjectSortField["Lead"] = "LEAD";
    JiraProjectSortField["Name"] = "NAME";
    return JiraProjectSortField;
}({}); /** Jira Project statuses. */ 
let $78ad46e0d6808149$export$f24d023940410bd2 = /*#__PURE__*/ function(JiraProjectStatus) {
    JiraProjectStatus["Active"] = "ACTIVE";
    JiraProjectStatus["Archived"] = "ARCHIVED";
    JiraProjectStatus["Deleted"] = "DELETED";
    return JiraProjectStatus;
}({}); /** Jira Project Styles. */ 
let $78ad46e0d6808149$export$7108cef8ee0b9c1d = /*#__PURE__*/ function(JiraProjectStyle) {
    JiraProjectStyle["CompanyManagedProject"] = "COMPANY_MANAGED_PROJECT";
    JiraProjectStyle["TeamManagedProject"] = "TEAM_MANAGED_PROJECT";
    return JiraProjectStyle;
}({}); /** Jira Project types. */ 
let $78ad46e0d6808149$export$af05362339233870 = /*#__PURE__*/ function(JiraProjectType) {
    JiraProjectType["Business"] = "BUSINESS";
    JiraProjectType["CustomerService"] = "CUSTOMER_SERVICE";
    JiraProjectType["ProductDiscovery"] = "PRODUCT_DISCOVERY";
    JiraProjectType["ServiceDesk"] = "SERVICE_DESK";
    JiraProjectType["Software"] = "SOFTWARE";
    return JiraProjectType;
}({}); /**
 * This represents Jira Project Type, for instance, software, business. Details can be
 * found here: https://confluence.atlassian.com/adminjiraserver/jira-applications-and-project-types-overview-938846805.html
 */ 
let $78ad46e0d6808149$export$a8cdf7bc23c30cb9 = /*#__PURE__*/ function(JiraProjectsHelpCenterMappingStatus) {
    JiraProjectsHelpCenterMappingStatus["All"] = "ALL";
    JiraProjectsHelpCenterMappingStatus["Linked"] = "LINKED";
    JiraProjectsHelpCenterMappingStatus["Unlinked"] = "UNLINKED";
    return JiraProjectsHelpCenterMappingStatus;
}({}); /** Basic person information who reviews a pull-request. */  /** Possible states for Pull Requests */ 
let $78ad46e0d6808149$export$e4cb38caa605881 = /*#__PURE__*/ function(JiraPullRequestState) {
    JiraPullRequestState["Declined"] = "DECLINED";
    JiraPullRequestState["Draft"] = "DRAFT";
    JiraPullRequestState["Merged"] = "MERGED";
    JiraPullRequestState["Open"] = "OPEN";
    return JiraPullRequestState;
}({}); /** Represents the radio select field on a Jira Issue. */  /** Represents the radio select field on a Jira Issue. */  /** Represents a direction in the ranking of two issues. */ 
let $78ad46e0d6808149$export$ba97d7c27eb56d75 = /*#__PURE__*/ function(JiraRankMutationEdge) {
    JiraRankMutationEdge["Bottom"] = "BOTTOM";
    JiraRankMutationEdge["Top"] = "TOP";
    return JiraRankMutationEdge;
}({}); /** Input for ranking issues against one another using a rank field. */  /** Payload returned when `rankIssues` responds. */  /** Input for ranking a navigation item. Only pass one of beforeItemId or afterItemId. */  /** Response for the rank navigation item mutation. */  /** Response for the rank navigation item mutation. */  /** Input type for the recentItems' filter. */  /** Category of recommendation */ 
let $78ad46e0d6808149$export$8b4c07c95d919811 = /*#__PURE__*/ function(JiraRecommendationCategory) {
    JiraRecommendationCategory["CustomField"] = "CUSTOM_FIELD";
    JiraRecommendationCategory["IssueArchival"] = "ISSUE_ARCHIVAL";
    JiraRecommendationCategory["ProjectCleanup"] = "PROJECT_CLEANUP";
    JiraRecommendationCategory["ProjectRoleActor"] = "PROJECT_ROLE_ACTOR";
    return JiraRecommendationCategory;
}({}); /**
 * The release notes configuration for a version describing how to display properties,
 * types and keys for an issue
 *
 * This configuration is typically saved whenever a new release note is generated on a
 * per version basis.
 */ 
let $78ad46e0d6808149$export$88911ff8dc5ac51b = /*#__PURE__*/ function(JiraReleaseNotesIssueKeyConfig) {
    JiraReleaseNotesIssueKeyConfig["Linked"] = "LINKED";
    JiraReleaseNotesIssueKeyConfig["None"] = "NONE";
    JiraReleaseNotesIssueKeyConfig["Unlinked"] = "UNLINKED";
    return JiraReleaseNotesIssueKeyConfig;
}({}); /**
 * Used for specifying whether or not epics that haven't been released should be included
 * in the results.
 *
 * For an epic to be considered as released, at least one of the issues or subtasks within
 * it must have been released.
 */ 
let $78ad46e0d6808149$export$bb6f763ecaab7945 = /*#__PURE__*/ function(JiraReleasesEpicReleaseStatusFilter) {
    JiraReleasesEpicReleaseStatusFilter["Released"] = "RELEASED";
    JiraReleasesEpicReleaseStatusFilter["ReleasedAndUnreleased"] = "RELEASED_AND_UNRELEASED";
    return JiraReleasesEpicReleaseStatusFilter;
}({}); /**
 * Used for specifying whether or not issues that haven't been released should be included
 * in the results.
 */ 
let $78ad46e0d6808149$export$fe2e4a5cf13d7781 = /*#__PURE__*/ function(JiraReleasesIssueReleaseStatusFilter) {
    JiraReleasesIssueReleaseStatusFilter["Released"] = "RELEASED";
    JiraReleasesIssueReleaseStatusFilter["ReleasedAndUnreleased"] = "RELEASED_AND_UNRELEASED";
    JiraReleasesIssueReleaseStatusFilter["Unreleased"] = "UNRELEASED";
    return JiraReleasesIssueReleaseStatusFilter;
}({}); /**
 * Represents the remaining time estimate field on Jira issue screens and in the time tracking modal. Note that this is the same value as the remainingEstimate
 * from JiraTimeTrackingField.
 */ 
let $78ad46e0d6808149$export$d0483c6fd1bb3a85 = /*#__PURE__*/ function(JiraResourceUsageCustomFieldRecommendationAction) {
    JiraResourceUsageCustomFieldRecommendationAction["Trash"] = "TRASH";
    return JiraResourceUsageCustomFieldRecommendationAction;
}({}); /** Connection type for JiraResourceUsageCustomFieldRecommendation. */  /** An edge in a JiraResourceUsageCustomFieldRecommendation connection. */  /**
 * A resource usage metric is a measurement of a resource that may cause
 * performance degradation.
 */ 
let $78ad46e0d6808149$export$6b943f296ac5a6bd = /*#__PURE__*/ function(JiraResourceUsageRecommendationStatus) {
    JiraResourceUsageRecommendationStatus["Archived"] = "ARCHIVED";
    JiraResourceUsageRecommendationStatus["Executed"] = "EXECUTED";
    JiraResourceUsageRecommendationStatus["New"] = "NEW";
    JiraResourceUsageRecommendationStatus["Obsolete"] = "OBSOLETE";
    JiraResourceUsageRecommendationStatus["Trashed"] = "TRASHED";
    return JiraResourceUsageRecommendationStatus;
}({}); /** Possible states for Reviews */ 
let $78ad46e0d6808149$export$daac6ca3443a8579 = /*#__PURE__*/ function(JiraReviewState) {
    JiraReviewState["Approval"] = "APPROVAL";
    JiraReviewState["Closed"] = "CLOSED";
    JiraReviewState["Dead"] = "DEAD";
    JiraReviewState["Draft"] = "DRAFT";
    JiraReviewState["Rejected"] = "REJECTED";
    JiraReviewState["Review"] = "REVIEW";
    JiraReviewState["Summarize"] = "SUMMARIZE";
    JiraReviewState["Unknown"] = "UNKNOWN";
    return JiraReviewState;
}({}); /** Represents the rich text format of a rich text field. */  /** Represents a rich text field on a Jira Issue. E.g. description, environment. */  /** Input type for rich text fields. Supports both text area and wiki text fields */  /** Input type for rich text field */  /** The state information for a Jira right panel */  /** The connection type for JiraRightPanelState. */  /** An edge in a JiraRightPanelState connection. */  /** Represents a Jira ProjectRole. */  /** The connection type for JiraRole. */  /** An edge in a JiraRoleConnection connection. */  /** Represents a Jira Scenario */  /** Jira Plan ScenarioIssue node. */  /** Jira Plan ScenarioIssue node. */  /** The connection type for JiraScenarioIssueLike. */  /** The connection type for JiraScenarioIssueLike. */  /** An edge in a JiraScenarioIssueLike connection. */  /** Plan scenario data for the issue. */  /** Plan scenario data for the issue. */  /** Types of scenarios that can be an issue. */ 
let $78ad46e0d6808149$export$ac4d9d3c50ca05e6 = /*#__PURE__*/ function(JiraScenarioType) {
    JiraScenarioType["Added"] = "ADDED";
    JiraScenarioType["Deleted"] = "DELETED";
    JiraScenarioType["Deletedfromjira"] = "DELETEDFROMJIRA";
    JiraScenarioType["Updated"] = "UPDATED";
    return JiraScenarioType;
}({}); /** Response for ScheduleCalendarIssue mutation. */  /** Response for ScheduleCalendarIssueV2 mutation. */  /** Repository information provided by data-providers. */  /** Represents the abstraction over list of tabs shown on the Transition modal */  /** Represents the abstraction over list of tabs shown on the Transition modal */  /** Represents the field level details or error received */  /** Represents the contents of the tab */  /** Represent the field in context of the tabs in Issue Transition modal */  /** Represents tab of an Issue Transition Screen */  /** Represents tab of an Issue Transition Screen */  /** Represents list of tabs for transition modal */  /** Type contains information about the tab and its position */  /** Currently supported searchable entities in Jira. */  /** The connection type for JiraSearchableEntity. */  /** An edge in a JiraSearchableEntityConnection connection. */  /** The entity types of searchable items. */ 
let $78ad46e0d6808149$export$fd023c605588471d = /*#__PURE__*/ function(JiraSearchableEntityType) {
    JiraSearchableEntityType["Board"] = "BOARD";
    JiraSearchableEntityType["Dashboard"] = "DASHBOARD";
    JiraSearchableEntityType["Filter"] = "FILTER";
    JiraSearchableEntityType["Issue"] = "ISSUE";
    JiraSearchableEntityType["Plan"] = "PLAN";
    JiraSearchableEntityType["Project"] = "PROJECT";
    JiraSearchableEntityType["Queue"] = "QUEUE";
    return JiraSearchableEntityType;
}({}); /** Represents the security levels on an Issue. */  /** The connection type for JiraSecurityLevel. */  /** An edge in a JiraSecurityLevel connection. */  /** Represents security level field on a Jira Issue. Issue Security allows you to control who can and cannot view issues. */  /** Represents security level field on a Jira Issue. Issue Security allows you to control who can and cannot view issues. */  /** Input type for defining the operation on the Security Level field of a Jira issue. */  /** The payload type returned after updating the Security Level field of a Jira issue. */  /** Input type for security level field */  /** The connection type for JiraHasSelectableValue. */  /** An edge in a JiraHasSelectableValueOptions connection. */  /** Input type for selected option */  /**
 * The representation for a server error
 * E.g. database connection exception.
 */ 
let $78ad46e0d6808149$export$40c351d91e581267 = /*#__PURE__*/ function(JiraServiceManagementApprovalDecisionResponseType) {
    JiraServiceManagementApprovalDecisionResponseType["Approved"] = "approved";
    JiraServiceManagementApprovalDecisionResponseType["Declined"] = "declined";
    JiraServiceManagementApprovalDecisionResponseType["Pending"] = "pending";
    return JiraServiceManagementApprovalDecisionResponseType;
}({}); /** Represents the Approval custom field on an Issue in a JSM project. */  /** Represents the Approval custom field on an Issue in a JSM project. */  /** Represent whether approval can be achieved or not. */ 
let $78ad46e0d6808149$export$f2800242314330d1 = /*#__PURE__*/ function(JiraServiceManagementApprovalState) {
    JiraServiceManagementApprovalState["InsufficientApprovers"] = "INSUFFICIENT_APPROVERS";
    JiraServiceManagementApprovalState["Ok"] = "OK";
    return JiraServiceManagementApprovalState;
}({}); /** Represents details of the approval status. */  /** The user and decision that approved the approval. */  /** The connection type for JiraServiceManagementApprover. */  /** An edge in a JiraServiceManagementApprover connection. */  /** Approver principals are either users or groups that may decide on an approval. */  /** The connection type for JiraServiceManagementApproverPrincipal. */  /** An edge in a JiraServiceManagementApproverPrincipal connection. */  /** Represents the configuration details of the users providing approval. */  /**
 * Represents an attachment within a JiraServiceManagement project.
 * @deprecated: This type is unused as JSM Attachments has no distinct field attributes from the common type JiraAttachment
 */ 
let $78ad46e0d6808149$export$9c65915394dd59bf = /*#__PURE__*/ function(JiraServiceManagementCommentVisibility) {
    JiraServiceManagementCommentVisibility["Internal"] = "INTERNAL";
    JiraServiceManagementCommentVisibility["VisibleToHelpseeker"] = "VISIBLE_TO_HELPSEEKER";
    return JiraServiceManagementCommentVisibility;
}({}); /** Represents an approval that is completed. */  /** Represents an approval that is completed. */  /** The connection type for JiraServiceManagementCompletedApproval. */  /** An edge in a JiraServiceManagementCompletedApproval connection. */  /** Represent the input data for create workflow and associate it to the issue type. */  /** Represents payload of create and associate workflow mutation. */  /** Input for FORM_TEMPLATE_REFERENCE or REQUEST_TYPE_TEMPLATE_REFERENCE JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType. */  /** This enum represents different input variation for the "request form" part of the new request type to be created. */ 
let $78ad46e0d6808149$export$bd4a236d84b2f605 = /*#__PURE__*/ function(JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType) {
    JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType["FormTemplateReference"] = "FORM_TEMPLATE_REFERENCE";
    JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType["RequestTypeTemplateReference"] = "REQUEST_TYPE_TEMPLATE_REFERENCE";
    return JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType;
}({}); /** This enum represent different action variation for workflow. */ 
let $78ad46e0d6808149$export$f35e6061c0db2138 = /*#__PURE__*/ function(JiraServiceManagementCreateRequestTypeFromTemplateWorkflowAction) {
    JiraServiceManagementCreateRequestTypeFromTemplateWorkflowAction["Share"] = "SHARE";
    return JiraServiceManagementCreateRequestTypeFromTemplateWorkflowAction;
}({}); /** This enum represent different input variation for workflow which will be associated with the new request type to be created. */ 
let $78ad46e0d6808149$export$bfa88ab509b645e1 = /*#__PURE__*/ function(JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInputType) {
    JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInputType["ReferenceThroughIssueType"] = "REFERENCE_THROUGH_ISSUE_TYPE";
    return JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInputType;
}({}); /** Input for CreateRequestTypeFromTemplateWorkflowInputType.REFERENCE_THROUGH_ISSUE_TYPE . */  /** Date Preview Field */  /**
 * Represents a datetime field on an Issue in a JSM project.
 * Deprecated: Please use `JiraDateTimePickerField`.
 */ 
let $78ad46e0d6808149$export$ddab2c249424d3a2 = /*#__PURE__*/ function(JiraServiceManagementMajorIncident) {
    JiraServiceManagementMajorIncident["MajorIncident"] = "MAJOR_INCIDENT";
    return JiraServiceManagementMajorIncident;
}({}); /** Represents the major incident field for an Issue in a JSM project. */  /** MultiCheckboxes Field */  /**
 * Multiselect Preview Field
 * Allows users to select more than one option from a list.
 */ 
let $78ad46e0d6808149$export$e93d85fe60017d05 = /*#__PURE__*/ function(JiraServiceManagementPractice) {
    JiraServiceManagementPractice["ChangeManagement"] = "CHANGE_MANAGEMENT";
    JiraServiceManagementPractice["DeveloperEscalation"] = "DEVELOPER_ESCALATION";
    JiraServiceManagementPractice["IncidentManagement"] = "INCIDENT_MANAGEMENT";
    JiraServiceManagementPractice["PostIncidentReview"] = "POST_INCIDENT_REVIEW";
    JiraServiceManagementPractice["ProblemManagement"] = "PROBLEM_MANAGEMENT";
    JiraServiceManagementPractice["ServiceRequest"] = "SERVICE_REQUEST";
    return JiraServiceManagementPractice;
}({}); /**
 * Preview Option
 * Represents a single option in a drop-down list
 */ 
let $78ad46e0d6808149$export$3292ab1fe1c3cdee = /*#__PURE__*/ function(JiraServiceManagementRendererType) {
    JiraServiceManagementRendererType["AtlassianWikiRendererType"] = "ATLASSIAN_WIKI_RENDERER_TYPE";
    JiraServiceManagementRendererType["JiraTextRendererType"] = "JIRA_TEXT_RENDERER_TYPE";
    return JiraServiceManagementRendererType;
}({}); /** Represents the Request Feedback custom field on an Issue in a JSM project. */  /** Represents the Request Language field on an Issue in a JSM project. */  /** Requests the request type structure on an Issue. */  /** The connection type for JiraServiceManagementRequestType. */  /** An edge in a JiraServiceManagementIssueType connection. */  /** Represents the request type field for an Issue in a JSM project. */  /** Represents the request type field for an Issue in a JSM project. */  /**
 * Request Type Field Common
 * These are properties common to each request form field.
 */ 
let $78ad46e0d6808149$export$34d7d8d807e96acf = /*#__PURE__*/ function(JiraShareableEntityGrant) {
    JiraShareableEntityGrant["AnonymousAccess"] = "ANONYMOUS_ACCESS";
    JiraShareableEntityGrant["AnyLoggedinUserApplicationRole"] = "ANY_LOGGEDIN_USER_APPLICATION_ROLE";
    JiraShareableEntityGrant["Group"] = "GROUP";
    JiraShareableEntityGrant["Project"] = "PROJECT";
    JiraShareableEntityGrant["ProjectRole"] = "PROJECT_ROLE";
    JiraShareableEntityGrant["ProjectUnknown"] = "PROJECT_UNKNOWN";
    JiraShareableEntityGrant["User"] = "USER";
    return JiraShareableEntityGrant;
}({}); /** GROUP grant type. */  /** Input for the group that will be granted permission. */  /** PROJECT grant type. */  /** Input for the project ID, members of which will be granted permission. */  /** PROJECT_ROLE grant type. */  /**
 * Input for the id of the role.
 * Users with the specified role will be granted permission.
 */ 
let $78ad46e0d6808149$export$1f76696f6d16d0a3 = /*#__PURE__*/ function(JiraSingleValueFieldOperations) {
    JiraSingleValueFieldOperations["Set"] = "SET";
    return JiraSingleValueFieldOperations;
}({}); /** Represents a version field on a Jira Issue. E.g. custom version picker field. */  /** Represents a version field on a Jira Issue. E.g. custom version picker field. */  /** Represents a version field on a Jira Issue. E.g. custom version picker field. */  /** Input type for single select version picker fields */  /** Input type for defining the operation on the SingleVersionPicker field of a Jira issue. */  /** The payload type returned after updating the SingleVersionPicker field of a Jira issue. */  /** Board and project scope navigation items in JSW. */  /** Custom input definition for Jira Software issue search. */  /**
 * Additional context for Jira Software custom issue search, optionally constraining the search
 * by adding additional clauses to the search query.
 */ 
let $78ad46e0d6808149$export$8da1ba7785d00ed1 = /*#__PURE__*/ function(JiraSoftwareIssueSearchCustomInputContext) {
    JiraSoftwareIssueSearchCustomInputContext["Backlog"] = "BACKLOG";
    JiraSoftwareIssueSearchCustomInputContext["Board"] = "BOARD";
    JiraSoftwareIssueSearchCustomInputContext["None"] = "NONE";
    return JiraSoftwareIssueSearchCustomInputContext;
}({}); /** Types of Jira built in jira pages available for navigation */ 
let $78ad46e0d6808149$export$50c12a2a3005ac54 = /*#__PURE__*/ function(JiraSoftwareSimpleNavigationItemEnum) {
    JiraSoftwareSimpleNavigationItemEnum["JswBacklog"] = "JSW_BACKLOG";
    JiraSoftwareSimpleNavigationItemEnum["JswBoard"] = "JSW_BOARD";
    JiraSoftwareSimpleNavigationItemEnum["JswCalendar"] = "JSW_CALENDAR";
    JiraSoftwareSimpleNavigationItemEnum["JswCode"] = "JSW_CODE";
    JiraSoftwareSimpleNavigationItemEnum["JswComponents"] = "JSW_COMPONENTS";
    JiraSoftwareSimpleNavigationItemEnum["JswDeployments"] = "JSW_DEPLOYMENTS";
    JiraSoftwareSimpleNavigationItemEnum["JswGoals"] = "JSW_GOALS";
    JiraSoftwareSimpleNavigationItemEnum["JswIncidents"] = "JSW_INCIDENTS";
    JiraSoftwareSimpleNavigationItemEnum["JswIssues"] = "JSW_ISSUES";
    JiraSoftwareSimpleNavigationItemEnum["JswList"] = "JSW_LIST";
    JiraSoftwareSimpleNavigationItemEnum["JswOnCall"] = "JSW_ON_CALL";
    JiraSoftwareSimpleNavigationItemEnum["JswPages"] = "JSW_PAGES";
    JiraSoftwareSimpleNavigationItemEnum["JswReleases"] = "JSW_RELEASES";
    JiraSoftwareSimpleNavigationItemEnum["JswReports"] = "JSW_REPORTS";
    JiraSoftwareSimpleNavigationItemEnum["JswRequests"] = "JSW_REQUESTS";
    JiraSoftwareSimpleNavigationItemEnum["JswSecurity"] = "JSW_SECURITY";
    JiraSoftwareSimpleNavigationItemEnum["JswShortcuts"] = "JSW_SHORTCUTS";
    JiraSoftwareSimpleNavigationItemEnum["JswTimeline"] = "JSW_TIMELINE";
    return JiraSoftwareSimpleNavigationItemEnum;
}({}); /** Represents the sprint field of an issue. */  /** Represents the sprint field of an issue. */  /** The connection type for JiraSprint. */  /** An edge in a JiraSprint connection. */  /** Represents sprint field on a Jira Issue. */  /** Represents sprint field on a Jira Issue. */  /** Represents sprint field on a Jira Issue. */  /** Input type for sprint field */  /** Input type for sprints */  /** Represents progress of a sprint */  /** Represents progress of a sprint */  /** Represents the state of the sprint. */ 
let $78ad46e0d6808149$export$4b13eb4595f55ffa = /*#__PURE__*/ function(JiraSprintState) {
    JiraSprintState["Active"] = "ACTIVE";
    JiraSprintState["Closed"] = "CLOSED";
    JiraSprintState["Future"] = "FUTURE";
    return JiraSprintState;
}({}); /** Represents the status field of an issue. */  /** Represents the category of a status. */  /** Color of the status category. */ 
let $78ad46e0d6808149$export$539cfae207f2a8d6 = /*#__PURE__*/ function(JiraStatusCategoryColor) {
    JiraStatusCategoryColor["BlueGray"] = "BLUE_GRAY";
    JiraStatusCategoryColor["Brown"] = "BROWN";
    JiraStatusCategoryColor["Green"] = "GREEN";
    JiraStatusCategoryColor["MediumGray"] = "MEDIUM_GRAY";
    JiraStatusCategoryColor["WarmRed"] = "WARM_RED";
    JiraStatusCategoryColor["Yellow"] = "YELLOW";
    return JiraStatusCategoryColor;
}({}); /** Represents Status Category field. */  /** Represents the status category wise estimate counts */  /** The connection type for JiraStatusCategoryProgress. */  /** An edge in a JiraStatusCategoryProgress connection. */  /** Represents Status field. */  /** Represents Status field. */  /** This is an input argument client will have to give in order to perform bulk edit submit */  /** Response returned by the backend to client after performing bulk operation */  /** Progress object containing taskId for the submitted bulk operation */  /** Deprecated type. Please use `childIssues` field under `JiraIssue` instead. */  /** Deprecated type. Please use `childIssues` field under `JiraIssue` instead. */  /** Represents an error that occurred during the suggest child issues feature */  /** Represents the status of the suggest child issues feature */  /** The type representing the status of the suggest child issues feature */ 
let $78ad46e0d6808149$export$f61057e011c8c809 = /*#__PURE__*/ function(JiraSuggestedChildIssueStatusType) {
    JiraSuggestedChildIssueStatusType["Complete"] = "COMPLETE";
    JiraSuggestedChildIssueStatusType["RefiningSuggestedIssues"] = "REFINING_SUGGESTED_ISSUES";
    JiraSuggestedChildIssueStatusType["ReformattingIssues"] = "REFORMATTING_ISSUES";
    JiraSuggestedChildIssueStatusType["RemovingDuplicateIssues"] = "REMOVING_DUPLICATE_ISSUES";
    JiraSuggestedChildIssueStatusType["RetrievingSourceContext"] = "RETRIEVING_SOURCE_CONTEXT";
    JiraSuggestedChildIssueStatusType["SuggestingInitialIssues"] = "SUGGESTING_INITIAL_ISSUES";
    return JiraSuggestedChildIssueStatusType;
}({}); /** Represents a suggested child issue */  /** Represents the different types of errors that will be returned by the suggest child issues feature */ 
let $78ad46e0d6808149$export$f7abe62a0ee830d = /*#__PURE__*/ function(JiraSuggestedIssueErrorType) {
    JiraSuggestedIssueErrorType["CommunicationsError"] = "COMMUNICATIONS_ERROR";
    JiraSuggestedIssueErrorType["NotEnoughInformation"] = "NOT_ENOUGH_INFORMATION";
    JiraSuggestedIssueErrorType["NoFurtherSuggestions"] = "NO_FURTHER_SUGGESTIONS";
    JiraSuggestedIssueErrorType["Unclassified"] = "UNCLASSIFIED";
    JiraSuggestedIssueErrorType["UnethicalContent"] = "UNETHICAL_CONTENT";
    return JiraSuggestedIssueErrorType;
}({}); /** Represents the common structure across Issue fields value suggestion. */ 
let $78ad46e0d6808149$export$6edac7c7d2e8c8c9 = /*#__PURE__*/ function(JiraSuggestedIssueFieldValueError) {
    JiraSuggestedIssueFieldValueError["HaveRequiredField"] = "HAVE_REQUIRED_FIELD";
    JiraSuggestedIssueFieldValueError["IsSubTask"] = "IS_SUB_TASK";
    JiraSuggestedIssueFieldValueError["NotEnoughInformation"] = "NOT_ENOUGH_INFORMATION";
    JiraSuggestedIssueFieldValueError["NoFurtherSuggestions"] = "NO_FURTHER_SUGGESTIONS";
    JiraSuggestedIssueFieldValueError["SuggestionIsNotEnabled"] = "SUGGESTION_IS_NOT_ENABLED";
    JiraSuggestedIssueFieldValueError["Unclassified"] = "UNCLASSIFIED";
    return JiraSuggestedIssueFieldValueError;
}({}); /** The result of a suggested issue field value query */  /**
 * Represents an issue supplied to the suggest child issues feature to prevent semantically similar issues from being
 * suggested
 */ 
let $78ad46e0d6808149$export$edaa045cf8e612c1 = /*#__PURE__*/ function(JiraTimeFormat) {
    JiraTimeFormat["Days"] = "DAYS";
    JiraTimeFormat["Hours"] = "HOURS";
    JiraTimeFormat["Pretty"] = "PRETTY";
    return JiraTimeFormat;
}({}); /** Represents the time tracking field on Jira issue screens. */  /** Input for TimeTracking field */  /** Represents the type for representing global time tracking settings. */  /**
 * Different time units supported for entering & displaying time tracking related data.
 * Get the currently configured default duration to use when parsing duration string for time tracking.
 */ 
let $78ad46e0d6808149$export$98bcea6c013bc229 = /*#__PURE__*/ function(JiraTimeUnit) {
    JiraTimeUnit["Day"] = "DAY";
    JiraTimeUnit["Hour"] = "HOUR";
    JiraTimeUnit["Minute"] = "MINUTE";
    JiraTimeUnit["Week"] = "WEEK";
    return JiraTimeUnit;
}({}); /** The connection type for JiraTransition. */  /** An edge in a JiraTransition connection. */  /** Input type for transition screen when fields have to be edited */  /** Enum representing different sort options for transitions. */ 
let $78ad46e0d6808149$export$f68bbce1273585a7 = /*#__PURE__*/ function(JiraTransitionSortOption) {
    JiraTransitionSortOption["OpsBar"] = "OPS_BAR";
    JiraTransitionSortOption["OpsBarThenStatusCategory"] = "OPS_BAR_THEN_STATUS_CATEGORY";
    return JiraTransitionSortOption;
}({}); /** The representation for an error message that can be exposed to the UI. */ 
let $78ad46e0d6808149$export$8cb0419b0b598690 = /*#__PURE__*/ function(JiraUiModificationsViewType) {
    JiraUiModificationsViewType["Gic"] = "GIC";
    JiraUiModificationsViewType["IssueTransition"] = "IssueTransition";
    JiraUiModificationsViewType["IssueView"] = "IssueView";
    JiraUiModificationsViewType["JsmRequestCreate"] = "JSMRequestCreate";
    return JiraUiModificationsViewType;
}({}); /** Input for attributing Unsplash images */  /** The response for the attributeUnsplashImage mutation */  /** The result of an Unsplash image search */  /**
 * The input for searching Unsplash images. Uses Unsplash's API definition for pagination
 * https://unsplash.com/documentation#parameters-16
 */ 
let $78ad46e0d6808149$export$5e761940e4c8e671 = /*#__PURE__*/ function(JiraVersionApproverStatus) {
    JiraVersionApproverStatus["Approved"] = "APPROVED";
    JiraVersionApproverStatus["Declined"] = "DECLINED";
    JiraVersionApproverStatus["Pending"] = "PENDING";
    return JiraVersionApproverStatus;
}({}); /**
 * Marketplace connect app iframe data for Version details page's top right corner extension
 * point(location: atl.jira.releasereport.top.right.panels)
 * If options is null, parsing string json into json object failed while mapping.
 */ 
let $78ad46e0d6808149$export$ec4fbd90ada48f79 = /*#__PURE__*/ function(JiraVersionDetailsCollapsedUi) {
    JiraVersionDetailsCollapsedUi["Description"] = "DESCRIPTION";
    JiraVersionDetailsCollapsedUi["Issues"] = "ISSUES";
    JiraVersionDetailsCollapsedUi["IssueAssociatedDesigns"] = "ISSUE_ASSOCIATED_DESIGNS";
    JiraVersionDetailsCollapsedUi["ProgressCard"] = "PROGRESS_CARD";
    JiraVersionDetailsCollapsedUi["RelatedWork"] = "RELATED_WORK";
    JiraVersionDetailsCollapsedUi["RichTextSection"] = "RICH_TEXT_SECTION";
    JiraVersionDetailsCollapsedUi["RightSidebar"] = "RIGHT_SIDEBAR";
    return JiraVersionDetailsCollapsedUi;
}({}); /** The connection type for JiraVersionDriver. */  /** An edge in a JiraVersionDriver connection. */  /** An edge in a JiraVersion connection. */  /** Input for Versions values on fields */  /** The table column enum of version details page. */ 
let $78ad46e0d6808149$export$41dca0c2bc0964ff = /*#__PURE__*/ function(JiraVersionIssueTableColumn) {
    JiraVersionIssueTableColumn["BuildStatus"] = "BUILD_STATUS";
    JiraVersionIssueTableColumn["DeploymentStatus"] = "DEPLOYMENT_STATUS";
    JiraVersionIssueTableColumn["DevelopmentStatus"] = "DEVELOPMENT_STATUS";
    JiraVersionIssueTableColumn["FeatureFlagStatus"] = "FEATURE_FLAG_STATUS";
    JiraVersionIssueTableColumn["IssueAssignee"] = "ISSUE_ASSIGNEE";
    JiraVersionIssueTableColumn["IssuePriority"] = "ISSUE_PRIORITY";
    JiraVersionIssueTableColumn["IssueStatus"] = "ISSUE_STATUS";
    JiraVersionIssueTableColumn["MoreAction"] = "MORE_ACTION";
    JiraVersionIssueTableColumn["Warnings"] = "WARNINGS";
    return JiraVersionIssueTableColumn;
}({}); /** Type for the result of an update operation to an issue in a version */  /** The filter for a version's issues */ 
let $78ad46e0d6808149$export$2f70e0a7311bc8e6 = /*#__PURE__*/ function(JiraVersionIssuesFilter) {
    JiraVersionIssuesFilter["All"] = "ALL";
    JiraVersionIssuesFilter["Done"] = "DONE";
    JiraVersionIssuesFilter["FailingBuild"] = "FAILING_BUILD";
    JiraVersionIssuesFilter["InProgress"] = "IN_PROGRESS";
    JiraVersionIssuesFilter["OpenPullRequest"] = "OPEN_PULL_REQUEST";
    JiraVersionIssuesFilter["OpenReview"] = "OPEN_REVIEW";
    JiraVersionIssuesFilter["Todo"] = "TODO";
    JiraVersionIssuesFilter["UnreviewedCode"] = "UNREVIEWED_CODE";
    return JiraVersionIssuesFilter;
}({}); /** Fields that can be used to sort issues returned on the version. */ 
let $78ad46e0d6808149$export$70909551a8657943 = /*#__PURE__*/ function(JiraVersionIssuesSortField) {
    JiraVersionIssuesSortField["Assignee"] = "ASSIGNEE";
    JiraVersionIssuesSortField["Created"] = "CREATED";
    JiraVersionIssuesSortField["Key"] = "KEY";
    JiraVersionIssuesSortField["Priority"] = "PRIORITY";
    JiraVersionIssuesSortField["Status"] = "STATUS";
    JiraVersionIssuesSortField["Type"] = "TYPE";
    return JiraVersionIssuesSortField;
}({}); /** The sort criteria used for a version's issues */ 
let $78ad46e0d6808149$export$e857541964b7b4a4 = /*#__PURE__*/ function(JiraVersionIssuesStatusCategories) {
    JiraVersionIssuesStatusCategories["Done"] = "DONE";
    JiraVersionIssuesStatusCategories["InProgress"] = "IN_PROGRESS";
    JiraVersionIssuesStatusCategories["Todo"] = "TODO";
    return JiraVersionIssuesStatusCategories;
}({}); /** Type representing cross project version changes in a plan scenario */  /** Jira version related work type, which is used to associate "smart links" with a given Jira version. */  /** The connection type for JiraVersionRelatedWork. */  /** An edge in a JiraVersionRelatedWork connection. */  /** Jira version related work type, which is used to associate "smart links" with a given Jira version. */  /** Jira version related work type, which is used to associate "smart links" with a given Jira version. */  /** Enumeration of the kinds of Jira version related work items. */ 
let $78ad46e0d6808149$export$df98b03ce20f1d71 = /*#__PURE__*/ function(JiraVersionRelatedWorkType) {
    JiraVersionRelatedWorkType["ConfluenceReleaseNotes"] = "CONFLUENCE_RELEASE_NOTES";
    JiraVersionRelatedWorkType["GenericLink"] = "GENERIC_LINK";
    JiraVersionRelatedWorkType["NativeReleaseNotes"] = "NATIVE_RELEASE_NOTES";
    return JiraVersionRelatedWorkType;
}({}); /** Jira version related work type, which is used to associate "smart links" with a given Jira version. */  /** The connection type for JiraVersionRelatedWork. */  /** An edge in a JiraVersionRelatedWork connection. */  /** The input for fetching a preview of the release notes */  /** Types of Release Notes that are available */ 
let $78ad46e0d6808149$export$f1ccce3810e15115 = /*#__PURE__*/ function(JiraVersionReleaseNotesType) {
    JiraVersionReleaseNotesType["ConfluenceReleaseNote"] = "CONFLUENCE_RELEASE_NOTE";
    JiraVersionReleaseNotesType["NativeReleaseNote"] = "NATIVE_RELEASE_NOTE";
    return JiraVersionReleaseNotesType;
}({}); /** Contains either the successful fetched version information or an error. */  /** Version rich text section */  /** The argument for sorting project versions. */ 
let $78ad46e0d6808149$export$14819bc3909a411 = /*#__PURE__*/ function(JiraVersionSortField) {
    JiraVersionSortField["Description"] = "DESCRIPTION";
    JiraVersionSortField["Name"] = "NAME";
    JiraVersionSortField["ReleaseDate"] = "RELEASE_DATE";
    JiraVersionSortField["Sequence"] = "SEQUENCE";
    JiraVersionSortField["StartDate"] = "START_DATE";
    return JiraVersionSortField;
}({}); /** The status of a version field. */ 
let $78ad46e0d6808149$export$661a9c551e5e752c = /*#__PURE__*/ function(JiraVersionStatus) {
    JiraVersionStatus["Archived"] = "ARCHIVED";
    JiraVersionStatus["Released"] = "RELEASED";
    JiraVersionStatus["Unreleased"] = "UNRELEASED";
    return JiraVersionStatus;
}({}); /** The connection type for Jira Version approver suggestion */  /** The edge type for Jira Version approver suggestion */  /** The input to update approval description */  /** The return payload of updating an approval description */  /** The input to update approval status */  /** The return payload of updating an approval description */  /** GraphQL input shape for updating an entire(all fields) version object */  /**
 * The warning configuration to be updated for version details page warning report.
 * Applicable values will have their value updated. Null values will default to true.
 */ 
let $78ad46e0d6808149$export$fc74821556ba9086 = /*#__PURE__*/ function(JiraVersionWarningCategories) {
    JiraVersionWarningCategories["FailingBuild"] = "FAILING_BUILD";
    JiraVersionWarningCategories["OpenPullRequest"] = "OPEN_PULL_REQUEST";
    JiraVersionWarningCategories["OpenReview"] = "OPEN_REVIEW";
    JiraVersionWarningCategories["UnreviewedCode"] = "UNREVIEWED_CODE";
    return JiraVersionWarningCategories;
}({}); /** The warning configuration to generate version details page warning report. */  /** The warning config for version details page to generate warning report. Depending on tenant settings and providers installed, some warning config could be in NOT_APPLICABLE state. */ 
let $78ad46e0d6808149$export$953aa8fa6e3444b5 = /*#__PURE__*/ function(JiraVersionWarningConfigState) {
    JiraVersionWarningConfigState["Disabled"] = "DISABLED";
    JiraVersionWarningConfigState["Enabled"] = "ENABLED";
    JiraVersionWarningConfigState["NotApplicable"] = "NOT_APPLICABLE";
    return JiraVersionWarningConfigState;
}({}); /** Input for the view that can be shared across multiple products, i.e., Jira Calendar */  /** The reason why an extension shouldn't be visible in the given context. */ 
let $78ad46e0d6808149$export$d93e6e69204ae0db = /*#__PURE__*/ function(JiraVisibilityControlMechanism) {
    JiraVisibilityControlMechanism["AppAccessRules"] = "AppAccessRules";
    JiraVisibilityControlMechanism["DisplayConditions"] = "DisplayConditions";
    return JiraVisibilityControlMechanism;
}({}); /** Represents the votes information of an Issue. */  /** Represents a votes field on a Jira Issue. */  /** Represents a votes field on a Jira Issue. */  /** Operations that can be performed on vote field. */ 
let $78ad46e0d6808149$export$b1636d2c563ea928 = /*#__PURE__*/ function(JiraVotesOperations) {
    JiraVotesOperations["Add"] = "ADD";
    JiraVotesOperations["Remove"] = "REMOVE";
    return JiraVotesOperations;
}({}); /** Represents the watches information. */  /** Represents the Watches system field. */  /** Represents the Watches system field. */  /** Represents the Watches system field. */  /** Operations that can be performed on watches field. */ 
let $78ad46e0d6808149$export$859195aa80d24a0e = /*#__PURE__*/ function(JiraWatchesOperations) {
    JiraWatchesOperations["Add"] = "ADD";
    JiraWatchesOperations["Remove"] = "REMOVE";
    return JiraWatchesOperations;
}({}); /** Represents a WorkCategory. */  /** Represents the WorkCategory field on an Issue. */  /** The connection type for JiraWorklog. */  /** An edge in a JiraWorkLog connection. */  /** Represents the log work field on jira issue screens. Used to log time while working on issues */  /** A Jira Work Management Attachment Background, used only when the entity is of Issue type */  /** Interface for backgrounds in JWM */  /** The supported background types */ 
let $78ad46e0d6808149$export$bba45fb1219c9de3 = /*#__PURE__*/ function(JiraWorkManagementBackgroundType) {
    JiraWorkManagementBackgroundType["Attachment"] = "ATTACHMENT";
    JiraWorkManagementBackgroundType["Color"] = "COLOR";
    JiraWorkManagementBackgroundType["Custom"] = "CUSTOM";
    JiraWorkManagementBackgroundType["Gradient"] = "GRADIENT";
    return JiraWorkManagementBackgroundType;
}({}); /** Type to hold Jira Work Management Background upload token auth details */  /** A Jira Work Management Background which is a solid color type */  /** Input for creating a Jira Work Management Custom Background */  /** The response for the jwmCreateCustomBackground mutation */  /** Represents the input data required for JWM issue creation. */  /** Represents the payload of the JWM Create Issue mutation. */  /** Input for creating a Jira Work Management Overview. */  /** Input for creating a saved view. */  /** Response for the create saved view mutation. */  /** The type for a Jira Work Management Custom Background, which is associated with a Media API file */  /** The type for a Jira Work Management Custom Background, which is associated with a Media API file */  /** The connection type for Jira Work Management Custom Background. */  /** The edge type for Jira Work Management Custom Background. */  /** Represents the input data required for Jwm Delete Attachment mutation. */  /** Represents the payload of the Jwm Delete Attachment mutation. */  /** The input for deleting a custom background */  /** The response for the jwmDeleteCustomBackground mutation */  /** Input for deleting a Jira Work Management Overview. */  /** A node that represents a Jira Work Management form and all the configuration associated with it. */  /** Represents a Jira Issue Field and its alias within the form. */  /** Response for the create Jira Work Management Overview mutation. */  /** Response for the delete Jira Work Management Overview mutation. */  /** Represents a Jira Work Management Overview. This is currently used in Jira Work Management as a collection of Projects. */  /** Represents a Jira Work Management Overview. This is currently used in Jira Work Management as a collection of Projects. */  /** Represents a Jira Work Management Overview. This is currently used in Jira Work Management as a collection of Projects. */  /** The connection type for Jira Work Management Overview. */  /** The edge type for Jira Work Management Overview. */  /** Response for the update Jira Work Management Overview mutation. */  /** A Jira Work Management Background which is a gradient type */  /** A Jira Work Management Media Background Media, containing a reference to a custom background */  /** Represents the input data to rank an issue upon creation. */  /** The input for deleting an active background */  /** The response for the jwmRemoveActiveBackground mutation */  /** The general concrete type for navigation items in JWM. Represents a saved view in the horizontal navigation. */  /** Represents a type of saved view, identified by its `JiraNavigationItemTypeKey`. */  /** The connection type for saved view types. */  /** The edge type for saved view types. */  /** The response for the jwmUpdateActiveBackground mutation */  /** The input for updating a Jira Work Management Background */  /** The input for updating a custom background */  /** The returned payload when updating a custom background */  /** Input for updating a Jira Work Management Overview. */ 
let $78ad46e0d6808149$export$2eb64d234500f795 = /*#__PURE__*/ function(JiraWorkManagementUserLicenseSeatEdition) {
    JiraWorkManagementUserLicenseSeatEdition["Free"] = "FREE";
    JiraWorkManagementUserLicenseSeatEdition["Premium"] = "PREMIUM";
    JiraWorkManagementUserLicenseSeatEdition["Standard"] = "STANDARD";
    return JiraWorkManagementUserLicenseSeatEdition;
}({}); /** Represents a Jira worklog. */  /** Accepted Worklog adjustments */ 
let $78ad46e0d6808149$export$6ff2b5b641c7145c = /*#__PURE__*/ function(JiraWorklogAdjustmentEstimateOperation) {
    JiraWorklogAdjustmentEstimateOperation["Auto"] = "AUTO";
    JiraWorklogAdjustmentEstimateOperation["Leave"] = "LEAVE";
    JiraWorklogAdjustmentEstimateOperation["Manual"] = "MANUAL";
    JiraWorklogAdjustmentEstimateOperation["New"] = "NEW";
    return JiraWorklogAdjustmentEstimateOperation;
}({}); /** Input type for defining the operation on the Worklog field of a Jira issue. */ 
let $78ad46e0d6808149$export$becc47419f149198 = /*#__PURE__*/ function(JsmChatChannelType) {
    JsmChatChannelType["Agent"] = "AGENT";
    JsmChatChannelType["Request"] = "REQUEST";
    return JsmChatChannelType;
}({});
let $78ad46e0d6808149$export$a89b8ac8c955a6b8 = /*#__PURE__*/ function(JsmChatConnectedApps) {
    JsmChatConnectedApps["Slack"] = "SLACK";
    JsmChatConnectedApps["Teams"] = "TEAMS";
    return JsmChatConnectedApps;
}({});
let $78ad46e0d6808149$export$80c78efe35efe1e8 = /*#__PURE__*/ function(JsmChatConversationMessageContentType) {
    JsmChatConversationMessageContentType["Adf"] = "ADF";
    return JsmChatConversationMessageContentType;
}({});
let $78ad46e0d6808149$export$b48e72793880c81d = /*#__PURE__*/ function(JsmChatConversationUserRole) {
    JsmChatConversationUserRole["JsmAgent"] = "JSM_Agent";
    JsmChatConversationUserRole["Participant"] = "Participant";
    JsmChatConversationUserRole["Reporter"] = "Reporter";
    JsmChatConversationUserRole["VirtualAgent"] = "VirtualAgent";
    return JsmChatConversationUserRole;
}({});
let $78ad46e0d6808149$export$f209cecbea0db715 = /*#__PURE__*/ function(JsmChatMessageSource) {
    JsmChatMessageSource["Email"] = "EMAIL";
    return JsmChatMessageSource;
}({});
let $78ad46e0d6808149$export$6c33ffba63a39eab = /*#__PURE__*/ function(JsmChatMessageType) {
    JsmChatMessageType["Adf"] = "ADF";
    return JsmChatMessageType;
}({}); /** The response when a subscription is established. */ 
let $78ad46e0d6808149$export$c9816db2d5d28541 = /*#__PURE__*/ function(KnowledgeBaseSpacePermissionType) {
    KnowledgeBaseSpacePermissionType["AnonymousUsers"] = "ANONYMOUS_USERS";
    KnowledgeBaseSpacePermissionType["ConfluenceLicensedUsers"] = "CONFLUENCE_LICENSED_USERS";
    KnowledgeBaseSpacePermissionType["ConfluenceUnlicensedUsers"] = "CONFLUENCE_UNLICENSED_USERS";
    return KnowledgeBaseSpacePermissionType;
}({});
let $78ad46e0d6808149$export$237aec910e197d97 = /*#__PURE__*/ function(KnowledgeDiscoveryDefinitionScope) {
    KnowledgeDiscoveryDefinitionScope["Blogpost"] = "BLOGPOST";
    KnowledgeDiscoveryDefinitionScope["Organization"] = "ORGANIZATION";
    KnowledgeDiscoveryDefinitionScope["Page"] = "PAGE";
    KnowledgeDiscoveryDefinitionScope["Project"] = "PROJECT";
    KnowledgeDiscoveryDefinitionScope["Space"] = "SPACE";
    return KnowledgeDiscoveryDefinitionScope;
}({});
let $78ad46e0d6808149$export$d2d7439a14c13cac = /*#__PURE__*/ function(KnowledgeDiscoveryEntityType) {
    KnowledgeDiscoveryEntityType["ConfluenceBlogpost"] = "CONFLUENCE_BLOGPOST";
    KnowledgeDiscoveryEntityType["ConfluenceDocument"] = "CONFLUENCE_DOCUMENT";
    KnowledgeDiscoveryEntityType["ConfluencePage"] = "CONFLUENCE_PAGE";
    KnowledgeDiscoveryEntityType["ConfluenceSpace"] = "CONFLUENCE_SPACE";
    KnowledgeDiscoveryEntityType["JiraProject"] = "JIRA_PROJECT";
    KnowledgeDiscoveryEntityType["KeyPhrase"] = "KEY_PHRASE";
    KnowledgeDiscoveryEntityType["Topic"] = "TOPIC";
    KnowledgeDiscoveryEntityType["User"] = "USER";
    return KnowledgeDiscoveryEntityType;
}({});
let $78ad46e0d6808149$export$4c5402ac41e05bd0 = /*#__PURE__*/ function(KnowledgeDiscoveryKeyPhraseCategory) {
    KnowledgeDiscoveryKeyPhraseCategory["Acronym"] = "ACRONYM";
    KnowledgeDiscoveryKeyPhraseCategory["Other"] = "OTHER";
    KnowledgeDiscoveryKeyPhraseCategory["Project"] = "PROJECT";
    KnowledgeDiscoveryKeyPhraseCategory["Team"] = "TEAM";
    return KnowledgeDiscoveryKeyPhraseCategory;
}({});
let $78ad46e0d6808149$export$5fc610914b028d97 = /*#__PURE__*/ function(KnowledgeDiscoveryKeyPhraseInputTextFormat) {
    KnowledgeDiscoveryKeyPhraseInputTextFormat["Adf"] = "ADF";
    KnowledgeDiscoveryKeyPhraseInputTextFormat["Plain"] = "PLAIN";
    return KnowledgeDiscoveryKeyPhraseInputTextFormat;
}({});
let $78ad46e0d6808149$export$be3a90b14f5b3f96 = /*#__PURE__*/ function(KnowledgeDiscoverySearchQueryClassification) {
    KnowledgeDiscoverySearchQueryClassification["KeywordOrAcronym"] = "KEYWORD_OR_ACRONYM";
    KnowledgeDiscoverySearchQueryClassification["NaturalLanguageQuery"] = "NATURAL_LANGUAGE_QUERY";
    KnowledgeDiscoverySearchQueryClassification["None"] = "NONE";
    KnowledgeDiscoverySearchQueryClassification["Person"] = "PERSON";
    KnowledgeDiscoverySearchQueryClassification["Team"] = "TEAM";
    return KnowledgeDiscoverySearchQueryClassification;
}({});
let $78ad46e0d6808149$export$3b6332b650771b7c = /*#__PURE__*/ function(KnowledgeDiscoverySummaryLength) {
    KnowledgeDiscoverySummaryLength["Large"] = "LARGE";
    KnowledgeDiscoverySummaryLength["Medium"] = "MEDIUM";
    KnowledgeDiscoverySummaryLength["Small"] = "SMALL";
    return KnowledgeDiscoverySummaryLength;
}({});
let $78ad46e0d6808149$export$476bafd4888ee246 = /*#__PURE__*/ function(KnowledgeDiscoveryTopicType) {
    KnowledgeDiscoveryTopicType["Area"] = "AREA";
    KnowledgeDiscoveryTopicType["Company"] = "COMPANY";
    KnowledgeDiscoveryTopicType["Event"] = "EVENT";
    KnowledgeDiscoveryTopicType["Process"] = "PROCESS";
    KnowledgeDiscoveryTopicType["Program"] = "PROGRAM";
    KnowledgeDiscoveryTopicType["Team"] = "TEAM";
    return KnowledgeDiscoveryTopicType;
}({});
let $78ad46e0d6808149$export$522f238043d058cb = /*#__PURE__*/ function(LicenseOverrideState) {
    LicenseOverrideState["Active"] = "ACTIVE";
    LicenseOverrideState["Advanced"] = "ADVANCED";
    LicenseOverrideState["Inactive"] = "INACTIVE";
    LicenseOverrideState["Standard"] = "STANDARD";
    LicenseOverrideState["Trial"] = "TRIAL";
    return LicenseOverrideState;
}({}); /**
 * See https://developer.atlassian.com/platform/graphql-gateway/schemas/lifecycle-support/#lifecycle-stages for more
 * information on how to use these stages and what they mean in detail.
 * | Lifecycle            | Visible in Prod | Needs `@optIn` directive |                     Allow third parties                       |
 * |----------------------|:---------------:|:------------------------:|:-------------------------------------------------------------:|
 * | STAGING              |       No        |            No            | By default no. Can enable via `allowThirdParties` directive   |
 * | EXPERIMENTAL         |       Yes       |           Yes            | By default no. Can enable via `allowThirdParties` directive   |
 * | BETA                 |       Yes       |           Yes            |                       Always                                  |
 * | PRODUCTION (default) |       Yes       |            No            |                       Always                                  |
 */ 
let $78ad46e0d6808149$export$3b3519737999098f = /*#__PURE__*/ function(LifecycleStage) {
    LifecycleStage["Beta"] = "BETA";
    LifecycleStage["Experimental"] = "EXPERIMENTAL";
    LifecycleStage["Production"] = "PRODUCTION";
    LifecycleStage["Staging"] = "STAGING";
    return LifecycleStage;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */ 
let $78ad46e0d6808149$export$f02742739c4d10 = /*#__PURE__*/ function(LpCertSortField) {
    LpCertSortField["ActiveDate"] = "ACTIVE_DATE";
    LpCertSortField["ExpireDate"] = "EXPIRE_DATE";
    LpCertSortField["Id"] = "ID";
    LpCertSortField["ImageUrl"] = "IMAGE_URL";
    LpCertSortField["Name"] = "NAME";
    LpCertSortField["NameAbbr"] = "NAME_ABBR";
    LpCertSortField["PublicUrl"] = "PUBLIC_URL";
    LpCertSortField["Status"] = "STATUS";
    LpCertSortField["Type"] = "TYPE";
    return LpCertSortField;
}({});
let $78ad46e0d6808149$export$a8eb0a5903a5312c = /*#__PURE__*/ function(LpCertStatus) {
    LpCertStatus["Active"] = "ACTIVE";
    LpCertStatus["Expired"] = "EXPIRED";
    return LpCertStatus;
}({});
let $78ad46e0d6808149$export$9999af1e50a41e44 = /*#__PURE__*/ function(LpCertType) {
    LpCertType["Badge"] = "BADGE";
    LpCertType["Certification"] = "CERTIFICATION";
    LpCertType["Standing"] = "STANDING";
    return LpCertType;
}({}); /** Certmetrics credentials: certifications/badges/standings */  /** Course progress: Information of courses progress */ 
let $78ad46e0d6808149$export$a8f04761d618cfe2 = /*#__PURE__*/ function(LpCourseSortField) {
    LpCourseSortField["CompletedDate"] = "COMPLETED_DATE";
    LpCourseSortField["CourseId"] = "COURSE_ID";
    LpCourseSortField["Id"] = "ID";
    LpCourseSortField["Status"] = "STATUS";
    LpCourseSortField["Title"] = "TITLE";
    LpCourseSortField["Url"] = "URL";
    return LpCourseSortField;
}({});
let $78ad46e0d6808149$export$b2608a9d91a1b256 = /*#__PURE__*/ function(LpCourseStatus) {
    LpCourseStatus["Completed"] = "COMPLETED";
    LpCourseStatus["InProgress"] = "IN_PROGRESS";
    return LpCourseStatus;
}({}); /** Learner/atlassian user */  /** Learner/atlassian user */  /** Learner/atlassian user */  /** Lesson progress: Information of lessons progress */ 
let $78ad46e0d6808149$export$dcfe2c64979f9e2c = /*#__PURE__*/ function(LpSortOrder) {
    LpSortOrder["Asc"] = "ASC";
    LpSortOrder["Desc"] = "DESC";
    return LpSortOrder;
}({}); /** A piece of code that modifies the functionality or look and feel of Atlassian products */  /** A piece of code that modifies the functionality or look and feel of Atlassian products */  /** A piece of code that modifies the functionality or look and feel of Atlassian products */  /** Category associated with an app */  /** A connection providing cursor-based pagination for a list of apps. */  /** An entry in a paginated list of apps. */  /** All deployment related properties for an app version */  /** Step for installing the instructional app */  /** Marketplace app's distribution information */  /** Payment model for integrating an app with an Atlassian product. */ 
let $78ad46e0d6808149$export$f25ba44b203e3645 = /*#__PURE__*/ function(MarketplaceAppPaymentModel) {
    MarketplaceAppPaymentModel["Free"] = "FREE";
    MarketplaceAppPaymentModel["PaidViaAtlassian"] = "PAID_VIA_ATLASSIAN";
    MarketplaceAppPaymentModel["PaidViaPartner"] = "PAID_VIA_PARTNER";
    return MarketplaceAppPaymentModel;
}({}); /** Marketplace App Programs that this Marketplace App has enrolled into. */  /** Summary of the reviews for an app */  /** App trust information for a marketplace entity */  /** App trust information or associated error in querying */  /** Version of App in Marketplace system */  /** License type for an app version */  /** Visibility of the Marketplace app's version */ 
let $78ad46e0d6808149$export$6e069b93ed3dba5f = /*#__PURE__*/ function(MarketplaceAppVersionVisibility) {
    MarketplaceAppVersionVisibility["Private"] = "PRIVATE";
    MarketplaceAppVersionVisibility["Public"] = "PUBLIC";
    return MarketplaceAppVersionVisibility;
}({}); /** Information of watchers of a Marketplace app */  /** Filters to apply when querying for my apps. */  /** Billing cycle for which pricing plan applies */ 
let $78ad46e0d6808149$export$dafb60ab7ab08188 = /*#__PURE__*/ function(MarketplaceBillingCycle) {
    MarketplaceBillingCycle["Annual"] = "ANNUAL";
    MarketplaceBillingCycle["Monthly"] = "MONTHLY";
    return MarketplaceBillingCycle;
}({}); /** Details of Bug bounty program */  /** Cloud app deployment properties */  /** Details of Cloud fortified program. */ 
let $78ad46e0d6808149$export$468594da24feab1 = /*#__PURE__*/ function(MarketplaceCloudFortifiedStatus) {
    MarketplaceCloudFortifiedStatus["Applied"] = "APPLIED";
    MarketplaceCloudFortifiedStatus["Approved"] = "APPROVED";
    MarketplaceCloudFortifiedStatus["NotAParticipant"] = "NOT_A_PARTICIPANT";
    MarketplaceCloudFortifiedStatus["Rejected"] = "REJECTED";
    return MarketplaceCloudFortifiedStatus;
}({}); /** Connect app deployment properties */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$c1efd3e80d58f939 = /*#__PURE__*/ function(MarketplaceConsoleAppSoftwareVersionLicenseTypeId) {
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Asl"] = "ASL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["AtlassianClosedSource"] = "ATLASSIAN_CLOSED_SOURCE";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Bsd"] = "BSD";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Commercial"] = "COMMERCIAL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["CommercialFree"] = "COMMERCIAL_FREE";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Epl"] = "EPL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Gpl"] = "GPL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Lgpl"] = "LGPL";
    return MarketplaceConsoleAppSoftwareVersionLicenseTypeId;
}({}); /** This file defines the GQL type definition for the AppSoftwareVersionListing used in the marketplace console */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$fb9cecbbd253ebc0 = /*#__PURE__*/ function(MarketplaceConsoleAppSoftwareVersionState) {
    MarketplaceConsoleAppSoftwareVersionState["Active"] = "ACTIVE";
    MarketplaceConsoleAppSoftwareVersionState["Approved"] = "APPROVED";
    MarketplaceConsoleAppSoftwareVersionState["Archived"] = "ARCHIVED";
    MarketplaceConsoleAppSoftwareVersionState["AutoApproved"] = "AUTO_APPROVED";
    MarketplaceConsoleAppSoftwareVersionState["Draft"] = "DRAFT";
    MarketplaceConsoleAppSoftwareVersionState["Rejected"] = "REJECTED";
    MarketplaceConsoleAppSoftwareVersionState["Submitted"] = "SUBMITTED";
    return MarketplaceConsoleAppSoftwareVersionState;
}({}); /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Represents an artifact which was uploaded from local file system or remote URL */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$9de5cbe727291181 = /*#__PURE__*/ function(MarketplaceConsoleDevSpaceProgram) {
    MarketplaceConsoleDevSpaceProgram["AtlassianParter"] = "ATLASSIAN_PARTER";
    MarketplaceConsoleDevSpaceProgram["FreeLicense"] = "FREE_LICENSE";
    MarketplaceConsoleDevSpaceProgram["MarketplacePartner"] = "MARKETPLACE_PARTNER";
    MarketplaceConsoleDevSpaceProgram["SolutionPartner"] = "SOLUTION_PARTNER";
    return MarketplaceConsoleDevSpaceProgram;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$2f6a1d40840e6e7a = /*#__PURE__*/ function(MarketplaceConsoleDevSpaceTier) {
    MarketplaceConsoleDevSpaceTier["Gold"] = "GOLD";
    MarketplaceConsoleDevSpaceTier["Platinum"] = "PLATINUM";
    MarketplaceConsoleDevSpaceTier["Silver"] = "SILVER";
    return MarketplaceConsoleDevSpaceTier;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$63c7f04a210975b2 = /*#__PURE__*/ function(MarketplaceConsoleEditionType) {
    MarketplaceConsoleEditionType["Advanced"] = "ADVANCED";
    MarketplaceConsoleEditionType["Standard"] = "STANDARD";
    return MarketplaceConsoleEditionType;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$26ce6a16987d908d = /*#__PURE__*/ function(MarketplaceConsoleEditionsActivationStatus) {
    MarketplaceConsoleEditionsActivationStatus["Approved"] = "APPROVED";
    MarketplaceConsoleEditionsActivationStatus["Pending"] = "PENDING";
    MarketplaceConsoleEditionsActivationStatus["Rejected"] = "REJECTED";
    return MarketplaceConsoleEditionsActivationStatus;
}({}); /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * The file contains the common types that are used across
 * different parts of the Marketplace Console BFF GQL schema.
 */ 
let $78ad46e0d6808149$export$14f32a11a50ded19 = /*#__PURE__*/ function(MarketplaceConsoleHosting) {
    MarketplaceConsoleHosting["Cloud"] = "CLOUD";
    MarketplaceConsoleHosting["DataCenter"] = "DATA_CENTER";
    MarketplaceConsoleHosting["Server"] = "SERVER";
    return MarketplaceConsoleHosting;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Ref: https://hello.atlassian.net/wiki/spaces/~549868828/pages/2204917928/Rollout+Plan+Blocking+RuBy+partners+access+to+Marketplace */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$5636d960d9fd9d0a = /*#__PURE__*/ function(MarketplaceConsoleLegacyMongoPluginHiddenIn) {
    MarketplaceConsoleLegacyMongoPluginHiddenIn["HiddenInSiteAndAppMarketplace"] = "HIDDEN_IN_SITE_AND_APP_MARKETPLACE";
    MarketplaceConsoleLegacyMongoPluginHiddenIn["HiddenInSiteOnly"] = "HIDDEN_IN_SITE_ONLY";
    return MarketplaceConsoleLegacyMongoPluginHiddenIn;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$b16d3f44b490e152 = /*#__PURE__*/ function(MarketplaceConsoleLegacyMongoStatus) {
    MarketplaceConsoleLegacyMongoStatus["Notassigned"] = "NOTASSIGNED";
    MarketplaceConsoleLegacyMongoStatus["Private"] = "PRIVATE";
    MarketplaceConsoleLegacyMongoStatus["Public"] = "PUBLIC";
    MarketplaceConsoleLegacyMongoStatus["Readytolaunch"] = "READYTOLAUNCH";
    MarketplaceConsoleLegacyMongoStatus["Rejected"] = "REJECTED";
    MarketplaceConsoleLegacyMongoStatus["Submitted"] = "SUBMITTED";
    return MarketplaceConsoleLegacyMongoStatus;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Represents details of a link */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$a3c494bbbdf25ee3 = /*#__PURE__*/ function(MarketplaceConsoleParentSoftwareState) {
    MarketplaceConsoleParentSoftwareState["Active"] = "ACTIVE";
    MarketplaceConsoleParentSoftwareState["Archived"] = "ARCHIVED";
    MarketplaceConsoleParentSoftwareState["Draft"] = "DRAFT";
    return MarketplaceConsoleParentSoftwareState;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$1393796fd66f6532 = /*#__PURE__*/ function(MarketplaceConsolePaymentModel) {
    MarketplaceConsolePaymentModel["Free"] = "FREE";
    MarketplaceConsolePaymentModel["PaidViaAtlassian"] = "PAID_VIA_ATLASSIAN";
    MarketplaceConsolePaymentModel["PaidViaVendor"] = "PAID_VIA_VENDOR";
    return MarketplaceConsolePaymentModel;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$e1c43740a06d58bb = /*#__PURE__*/ function(MarketplaceConsolePluginFrameworkType) {
    MarketplaceConsolePluginFrameworkType["P1"] = "P1";
    MarketplaceConsolePluginFrameworkType["P2"] = "P2";
    return MarketplaceConsolePluginFrameworkType;
}({});
let $78ad46e0d6808149$export$7e092f87e8d91044 = /*#__PURE__*/ function(MarketplaceConsolePricingCurrency) {
    MarketplaceConsolePricingCurrency["Jpy"] = "JPY";
    MarketplaceConsolePricingCurrency["Usd"] = "USD";
    return MarketplaceConsolePricingCurrency;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$4c5c05b960837cad = /*#__PURE__*/ function(MarketplaceConsolePricingPlanStatus) {
    MarketplaceConsolePricingPlanStatus["Draft"] = "DRAFT";
    MarketplaceConsolePricingPlanStatus["Live"] = "LIVE";
    MarketplaceConsolePricingPlanStatus["Pending"] = "PENDING";
    return MarketplaceConsolePricingPlanStatus;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Represents links pertaining to a remotely fetched artifact */  /** Represents an artifact which was fetched from a remote URL */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */  /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Status of an entity in Marketplace system */ 
let $78ad46e0d6808149$export$8b7b15f5e0317b5a = /*#__PURE__*/ function(MarketplaceEntityStatus) {
    MarketplaceEntityStatus["Active"] = "ACTIVE";
    MarketplaceEntityStatus["Archived"] = "ARCHIVED";
    return MarketplaceEntityStatus;
}({}); /** An image file in Atlassian Marketplace system */  /** Instructional app deployment properties */  /** Image to be displayed on a listing in Marketplace */  /** Status of app’s listing in Marketplace. */ 
let $78ad46e0d6808149$export$1a1d4383d2498aa8 = /*#__PURE__*/ function(MarketplaceListingStatus) {
    MarketplaceListingStatus["Private"] = "PRIVATE";
    MarketplaceListingStatus["Public"] = "PUBLIC";
    MarketplaceListingStatus["ReadyToLaunch"] = "READY_TO_LAUNCH";
    MarketplaceListingStatus["Rejected"] = "REJECTED";
    MarketplaceListingStatus["Submitted"] = "SUBMITTED";
    return MarketplaceListingStatus;
}({}); /** Marketplace location */ 
let $78ad46e0d6808149$export$25ad001a38719422 = /*#__PURE__*/ function(MarketplaceLocation) {
    MarketplaceLocation["InProduct"] = "IN_PRODUCT";
    MarketplaceLocation["Website"] = "WEBSITE";
    return MarketplaceLocation;
}({}); /** Marketplace Partners provide apps and integrations available for purchase on the Atlassian Marketplace that extend the power of Atlassian products. */  /** Marketplace Partner's address */  /** Marketplace Partner's contact information */  /** Marketplace Programs that this Marketplace Partner has participated in. */  /** Marketplace Partner's support information. */  /** Marketplace Partner's support availability information */  /** Marketplace Partner's support contact information */  /** Marketplace Partner's support holiday */  /** Tells whether support is on holiday only one time or if it repeats annually. */ 
let $78ad46e0d6808149$export$96bfc8c3eec61fd0 = /*#__PURE__*/ function(MarketplacePartnerSupportHolidayFrequency) {
    MarketplacePartnerSupportHolidayFrequency["Annual"] = "ANNUAL";
    MarketplacePartnerSupportHolidayFrequency["OneTime"] = "ONE_TIME";
    return MarketplacePartnerSupportHolidayFrequency;
}({}); /** Marketplace Partner's tier */ 
let $78ad46e0d6808149$export$4f999921e3690a15 = /*#__PURE__*/ function(MarketplacePartnerTierType) {
    MarketplacePartnerTierType["Gold"] = "GOLD";
    MarketplacePartnerTierType["Platinum"] = "PLATINUM";
    MarketplacePartnerTierType["Silver"] = "SILVER";
    return MarketplacePartnerTierType;
}({}); /** Tells if the Marketplace partner is an Atlassian’s internal one. */ 
let $78ad46e0d6808149$export$8fec59d6f9a79101 = /*#__PURE__*/ function(MarketplacePartnerType) {
    MarketplacePartnerType["AtlassianInternal"] = "ATLASSIAN_INTERNAL";
    return MarketplacePartnerType;
}({}); /** Plugins1 app deployment properties */  /** Plugins2 app deployment properties */  /** Pricing items based on tiers */  /** Pricing plan for a marketplace entity */  /** Option parameters to fetch pricing plan for a marketplace entity */  /** Status of the plan : LIVE, PENDING or DRAFT */ 
let $78ad46e0d6808149$export$72afefd58b6b80d0 = /*#__PURE__*/ function(MarketplacePricingPlanStatus) {
    MarketplacePricingPlanStatus["Draft"] = "DRAFT";
    MarketplacePricingPlanStatus["Live"] = "LIVE";
    MarketplacePricingPlanStatus["Pending"] = "PENDING";
    return MarketplacePricingPlanStatus;
}({}); /** Mode of the tier : GRADUATED (progressive PUP), VOLUME (constant for all users) */ 
let $78ad46e0d6808149$export$3c578ff2609d82d7 = /*#__PURE__*/ function(MarketplacePricingTierMode) {
    MarketplacePricingTierMode["Graduated"] = "GRADUATED";
    MarketplacePricingTierMode["Volume"] = "VOLUME";
    return MarketplacePricingTierMode;
}({}); /** Policy of the tier : BLOCK (FLAT) or PER_UNIT (PUP) */ 
let $78ad46e0d6808149$export$7edcca7ce5991948 = /*#__PURE__*/ function(MarketplacePricingTierPolicy) {
    MarketplacePricingTierPolicy["Block"] = "BLOCK";
    MarketplacePricingTierPolicy["PerUnit"] = "PER_UNIT";
    return MarketplacePricingTierPolicy;
}({}); /** Type of the tier */ 
let $78ad46e0d6808149$export$645f0980d82252ac = /*#__PURE__*/ function(MarketplacePricingTierType) {
    MarketplacePricingTierType["RemoteAgentTiered"] = "REMOTE_AGENT_TIERED";
    MarketplacePricingTierType["UserTiered"] = "USER_TIERED";
    return MarketplacePricingTierType;
}({});
let $78ad46e0d6808149$export$2cbd5d0207702c5 = /*#__PURE__*/ function(MarketplaceProgramStatus) {
    MarketplaceProgramStatus["Applied"] = "APPLIED";
    MarketplaceProgramStatus["Approved"] = "APPROVED";
    MarketplaceProgramStatus["NotAParticipant"] = "NOT_A_PARTICIPANT";
    MarketplaceProgramStatus["Rejected"] = "REJECTED";
    return MarketplaceProgramStatus;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * Metadata for algolia which can be used by the UI to fetch
 * app tiles data corresponding to a collection, category etc.
 *
 * Will be deprecated when search service starts providing app tiles data
 * in which case, BFF should integrate with search service to return the app tiles
 * data directly
 */ 
let $78ad46e0d6808149$export$da28f7301ad006a5 = /*#__PURE__*/ function(MarketplaceStoreDeveloperSpaceStatus) {
    MarketplaceStoreDeveloperSpaceStatus["Active"] = "ACTIVE";
    MarketplaceStoreDeveloperSpaceStatus["Archived"] = "ARCHIVED";
    MarketplaceStoreDeveloperSpaceStatus["Inactive"] = "INACTIVE";
    return MarketplaceStoreDeveloperSpaceStatus;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$fe42024bf862f826 = /*#__PURE__*/ function(MarketplaceStoreEditionType) {
    MarketplaceStoreEditionType["Advanced"] = "ADVANCED";
    MarketplaceStoreEditionType["Standard"] = "STANDARD";
    return MarketplaceStoreEditionType;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $78ad46e0d6808149$export$b36f406ff2fbbafe = /*#__PURE__*/ function(MarketplaceStoreHomePageHighlightedSectionVariation) {
    MarketplaceStoreHomePageHighlightedSectionVariation["Prominent"] = "PROMINENT";
    return MarketplaceStoreHomePageHighlightedSectionVariation;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * These breakpoints map to the breakpoints on the client
 * eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required
 */ 
let $78ad46e0d6808149$export$f6c61b63a81bc74a = /*#__PURE__*/ function(MarketplaceStoreInstallAppStatus) {
    MarketplaceStoreInstallAppStatus["InProgress"] = "IN_PROGRESS";
    MarketplaceStoreInstallAppStatus["Pending"] = "PENDING";
    MarketplaceStoreInstallAppStatus["ProvisioningFailure"] = "PROVISIONING_FAILURE";
    MarketplaceStoreInstallAppStatus["Success"] = "SUCCESS";
    MarketplaceStoreInstallAppStatus["TimedOut"] = "TIMED_OUT";
    return MarketplaceStoreInstallAppStatus;
}({}); /** Input for specifying the target or "site" of an app installation. */  /** Products onto which an app can be installed */ 
let $78ad46e0d6808149$export$36ca2010d8fa9f9a = /*#__PURE__*/ function(MarketplaceStoreInstallationTargetProduct) {
    MarketplaceStoreInstallationTargetProduct["Compass"] = "COMPASS";
    MarketplaceStoreInstallationTargetProduct["Confluence"] = "CONFLUENCE";
    MarketplaceStoreInstallationTargetProduct["Jira"] = "JIRA";
    return MarketplaceStoreInstallationTargetProduct;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * This is a top level mutation type under which all of Marketplace Store's supported mutations
 * will reside. It is namespaced to avoid conflicts with other Atlassian mutations.
 */ 
let $78ad46e0d6808149$export$ebb4384456a718fc = /*#__PURE__*/ function(MarketplaceStorePartnerEnrollmentProgram) {
    MarketplaceStorePartnerEnrollmentProgram["MarketplacePartner"] = "MARKETPLACE_PARTNER";
    MarketplaceStorePartnerEnrollmentProgram["SolutionPartner"] = "SOLUTION_PARTNER";
    return MarketplaceStorePartnerEnrollmentProgram;
}({});
let $78ad46e0d6808149$export$e29b364dec316f58 = /*#__PURE__*/ function(MarketplaceStorePartnerEnrollmentProgramValue) {
    MarketplaceStorePartnerEnrollmentProgramValue["Gold"] = "GOLD";
    MarketplaceStorePartnerEnrollmentProgramValue["Platinum"] = "PLATINUM";
    MarketplaceStorePartnerEnrollmentProgramValue["Silver"] = "SILVER";
    return MarketplaceStorePartnerEnrollmentProgramValue;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$9f0778caa5aa9129 = /*#__PURE__*/ function(MarketplaceStorePartnerSupportAvailabilityDay) {
    MarketplaceStorePartnerSupportAvailabilityDay["Friday"] = "FRIDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Monday"] = "MONDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Saturday"] = "SATURDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Sunday"] = "SUNDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Thursday"] = "THURSDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Tuesday"] = "TUESDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Wednesday"] = "WEDNESDAY";
    return MarketplaceStorePartnerSupportAvailabilityDay;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $78ad46e0d6808149$export$81bd7d703c9c9b4c = /*#__PURE__*/ function(MarketplaceStorePricingCurrency) {
    MarketplaceStorePricingCurrency["Jpy"] = "JPY";
    MarketplaceStorePricingCurrency["Usd"] = "USD";
    return MarketplaceStorePricingCurrency;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */ 
let $78ad46e0d6808149$export$2dd83c49139620d1 = /*#__PURE__*/ function(MembershipRole) {
    MembershipRole["Admin"] = "ADMIN";
    MembershipRole["Regular"] = "REGULAR";
    return MembershipRole;
}({}); /** The settings which a team can have describing how members are added to the team */ 
let $78ad46e0d6808149$export$86e062496769357c = /*#__PURE__*/ function(MembershipSetting) {
    MembershipSetting["MemberInvite"] = "MEMBER_INVITE";
    MembershipSetting["Open"] = "OPEN";
    return MembershipSetting;
}({}); /** The states that a member can have within a team */ 
let $78ad46e0d6808149$export$74cd14b61afb55b0 = /*#__PURE__*/ function(MembershipState) {
    MembershipState["Alumni"] = "ALUMNI";
    MembershipState["FullMember"] = "FULL_MEMBER";
    MembershipState["Invited"] = "INVITED";
    MembershipState["RequestingToJoin"] = "REQUESTING_TO_JOIN";
    return MembershipState;
}({}); /**
 * ------------------------------------------------------
 *  Watch/Unwatch Focus Area mutations
 * ------------------------------------------------------
 */ 
let $78ad46e0d6808149$export$973400a550f738ec = /*#__PURE__*/ function(MercuryAggregatedHeadcountSortField) {
    MercuryAggregatedHeadcountSortField["FilledPositions"] = "FILLED_POSITIONS";
    MercuryAggregatedHeadcountSortField["OpenPositions"] = "OPEN_POSITIONS";
    MercuryAggregatedHeadcountSortField["TotalHeadcount"] = "TOTAL_HEADCOUNT";
    return MercuryAggregatedHeadcountSortField;
}({}); /** Counts by Focus Area Status at the level of a Portfolio */  /**
 * ------------------------------------------------------
 *  Focus Area
 * ------------------------------------------------------
 */ 
let $78ad46e0d6808149$export$bc3e48f4065d763e = /*#__PURE__*/ function(MercuryEntityType) {
    MercuryEntityType["Comment"] = "COMMENT";
    MercuryEntityType["FocusArea"] = "FOCUS_AREA";
    MercuryEntityType["FocusAreaStatusUpdate"] = "FOCUS_AREA_STATUS_UPDATE";
    MercuryEntityType["Program"] = "PROGRAM";
    MercuryEntityType["ProgramStatusUpdate"] = "PROGRAM_STATUS_UPDATE";
    return MercuryEntityType;
}({}); /** ADF holding the about content within the editor */ 
let $78ad46e0d6808149$export$b8aac8b3d4a5c526 = /*#__PURE__*/ function(MercuryFocusAreaHealthColor) {
    MercuryFocusAreaHealthColor["Green"] = "GREEN";
    MercuryFocusAreaHealthColor["Red"] = "RED";
    MercuryFocusAreaHealthColor["Yellow"] = "YELLOW";
    return MercuryFocusAreaHealthColor;
}({});
let $78ad46e0d6808149$export$aabad147dc044911 = /*#__PURE__*/ function(MercuryFocusAreaHierarchySortField) {
    MercuryFocusAreaHierarchySortField["HierarchyLevel"] = "HIERARCHY_LEVEL";
    MercuryFocusAreaHierarchySortField["Name"] = "NAME";
    return MercuryFocusAreaHierarchySortField;
}({});
let $78ad46e0d6808149$export$a1abf0dad11e643b = /*#__PURE__*/ function(MercuryFocusAreaSortField) {
    MercuryFocusAreaSortField["Budget"] = "BUDGET";
    MercuryFocusAreaSortField["FocusAreaType"] = "FOCUS_AREA_TYPE";
    MercuryFocusAreaSortField["HasParent"] = "HAS_PARENT";
    MercuryFocusAreaSortField["HierarchyLevel"] = "HIERARCHY_LEVEL";
    MercuryFocusAreaSortField["LastUpdated"] = "LAST_UPDATED";
    MercuryFocusAreaSortField["Name"] = "NAME";
    MercuryFocusAreaSortField["Spend"] = "SPEND";
    MercuryFocusAreaSortField["Status"] = "STATUS";
    MercuryFocusAreaSortField["TargetDate"] = "TARGET_DATE";
    MercuryFocusAreaSortField["Watching"] = "WATCHING";
    return MercuryFocusAreaSortField;
}({}); /** Counts by different Focus Area status */  /**
 * ------------------------------------------------------
 *  Atlassian Intelligence
 * ------------------------------------------------------
 */ 
let $78ad46e0d6808149$export$64e01af19826bbd8 = /*#__PURE__*/ function(MercuryFocusAreaTeamAllocationAggregationSortField) {
    MercuryFocusAreaTeamAllocationAggregationSortField["FilledPositions"] = "FILLED_POSITIONS";
    MercuryFocusAreaTeamAllocationAggregationSortField["OpenPositions"] = "OPEN_POSITIONS";
    MercuryFocusAreaTeamAllocationAggregationSortField["TeamName"] = "TEAM_NAME";
    MercuryFocusAreaTeamAllocationAggregationSortField["TotalPositions"] = "TOTAL_POSITIONS";
    return MercuryFocusAreaTeamAllocationAggregationSortField;
}({}); /** Aggregation of headcount and positions for a focus area and its children. */  /**
 * ------------------------------------------------------
 *  Focus Area links
 * ------------------------------------------------------
 */ 
let $78ad46e0d6808149$export$ae3bb205c58a2aef = /*#__PURE__*/ function(MercuryProviderConfigurationStatus) {
    MercuryProviderConfigurationStatus["Connected"] = "CONNECTED";
    MercuryProviderConfigurationStatus["SignUp"] = "SIGN_UP";
    return MercuryProviderConfigurationStatus;
}({}); /**
 * ----------------------------------------
 *  Provider Pagination
 * ----------------------------------------
 */ 
let $78ad46e0d6808149$export$3733411202b02987 = /*#__PURE__*/ function(MercuryProviderWorkErrorType) {
    MercuryProviderWorkErrorType["Invalid"] = "INVALID";
    MercuryProviderWorkErrorType["NotFound"] = "NOT_FOUND";
    MercuryProviderWorkErrorType["NoPermissions"] = "NO_PERMISSIONS";
    return MercuryProviderWorkErrorType;
}({});
let $78ad46e0d6808149$export$9f4b40ce69c1d6a5 = /*#__PURE__*/ function(MercuryProviderWorkStatusColor) {
    MercuryProviderWorkStatusColor["Blue"] = "BLUE";
    MercuryProviderWorkStatusColor["Gray"] = "GRAY";
    MercuryProviderWorkStatusColor["Green"] = "GREEN";
    MercuryProviderWorkStatusColor["Red"] = "RED";
    MercuryProviderWorkStatusColor["Yellow"] = "YELLOW";
    return MercuryProviderWorkStatusColor;
}({});
let $78ad46e0d6808149$export$26be07f0f07696ad = /*#__PURE__*/ function(MercuryProviderWorkTargetDateType) {
    MercuryProviderWorkTargetDateType["Day"] = "DAY";
    MercuryProviderWorkTargetDateType["Month"] = "MONTH";
    MercuryProviderWorkTargetDateType["Quarter"] = "QUARTER";
    return MercuryProviderWorkTargetDateType;
}({}); /**
 * ----------------------------------------
 *  Preference Mutations
 * ----------------------------------------
 */ 
let $78ad46e0d6808149$export$5615eb511c3f7b44 = /*#__PURE__*/ function(MercuryTargetDateType) {
    MercuryTargetDateType["Day"] = "DAY";
    MercuryTargetDateType["Month"] = "MONTH";
    MercuryTargetDateType["Quarter"] = "QUARTER";
    return MercuryTargetDateType;
}({}); /** Team's capacity for allocation to a focus area. */ 
let $78ad46e0d6808149$export$6eb0d144e13a497b = /*#__PURE__*/ function(MercuryTeamFocusAreaAllocationSortField) {
    MercuryTeamFocusAreaAllocationSortField["FilledPositions"] = "FILLED_POSITIONS";
    MercuryTeamFocusAreaAllocationSortField["OpenPositions"] = "OPEN_POSITIONS";
    return MercuryTeamFocusAreaAllocationSortField;
}({}); /**
 * ------------------------------------------------------
 *  Team
 * ------------------------------------------------------
 */ 
let $78ad46e0d6808149$export$8c8ab86a3ad574d9 = /*#__PURE__*/ function(MercuryTeamSortField) {
    MercuryTeamSortField["Name"] = "NAME";
    return MercuryTeamSortField;
}({}); /**
 * ----------------------------------------
 *  Focus Area workflow mutations
 * ----------------------------------------
 */ 
let $78ad46e0d6808149$export$e5ba5b8b5f2756a8 = /*#__PURE__*/ function(MigrationEventStatus) {
    MigrationEventStatus["Cancelled"] = "CANCELLED";
    MigrationEventStatus["Cancelling"] = "CANCELLING";
    MigrationEventStatus["Failed"] = "FAILED";
    MigrationEventStatus["Incomplete"] = "INCOMPLETE";
    MigrationEventStatus["InProgress"] = "IN_PROGRESS";
    MigrationEventStatus["Paused"] = "PAUSED";
    MigrationEventStatus["Ready"] = "READY";
    MigrationEventStatus["Skipped"] = "SKIPPED";
    MigrationEventStatus["Success"] = "SUCCESS";
    MigrationEventStatus["TimedOut"] = "TIMED_OUT";
    return MigrationEventStatus;
}({}); /** An enum of the possible types of a migration event. */ 
let $78ad46e0d6808149$export$6b9f180c97bd81c9 = /*#__PURE__*/ function(MigrationEventType) {
    MigrationEventType["Container"] = "CONTAINER";
    MigrationEventType["Migration"] = "MIGRATION";
    MigrationEventType["Transfer"] = "TRANSFER";
    return MigrationEventType;
}({}); /** A type that represents a migrationPlanningService event. */  /** The top-level migrationPlanningService subscription type. */  /** The top-level migrationPlanningService subscription type. */  /** A type that represents a migration progress event. */  /** The top-level migration query type. */  /** The top-level migration query type. */  /** The top-level migration subscription type. */  /** The top-level migration subscription type. */  /** The top-level migration subscription type. */  /** Card mutations response */  /** Move sprint down */  /** Move sprint up */  /** An error that has occurred in response to a mutation */  /**
 * A error type that can be returned in response to a failed mutation
 *
 * This extension carries additional categorisation information about the error
 */ 
let $78ad46e0d6808149$export$a7e8a9c9b5c9e259 = /*#__PURE__*/ function(NadelHydrationTemplate) {
    NadelHydrationTemplate["NadelPlaceholder"] = "NADEL_PLACEHOLDER";
    return NadelHydrationTemplate;
}({}); /** Minimal details required to create a new card (as opposed to Card which is everything). */ 
let $78ad46e0d6808149$export$e129faa8dbff76aa = /*#__PURE__*/ function(NlpDisclaimer) {
    NlpDisclaimer["WhoQuestion"] = "WHO_QUESTION";
    return NlpDisclaimer;
}({});
let $78ad46e0d6808149$export$c5b04a82c748b9bd = /*#__PURE__*/ function(NlpErrorState) {
    NlpErrorState["AcceptableUseViolations"] = "ACCEPTABLE_USE_VIOLATIONS";
    NlpErrorState["AiDisabled"] = "AI_DISABLED";
    NlpErrorState["NoAnswer"] = "NO_ANSWER";
    NlpErrorState["NoAnswerHydration"] = "NO_ANSWER_HYDRATION";
    NlpErrorState["NoAnswerKeywords"] = "NO_ANSWER_KEYWORDS";
    NlpErrorState["NoAnswerOpenAiResponseErr"] = "NO_ANSWER_OPEN_AI_RESPONSE_ERR";
    NlpErrorState["NoAnswerRelevantContent"] = "NO_ANSWER_RELEVANT_CONTENT";
    NlpErrorState["NoAnswerSearchResults"] = "NO_ANSWER_SEARCH_RESULTS";
    NlpErrorState["NoAnswerWhoQuestion"] = "NO_ANSWER_WHO_QUESTION";
    NlpErrorState["OpenaiRateLimitUserAbuse"] = "OPENAI_RATE_LIMIT_USER_ABUSE";
    NlpErrorState["SubjectiveQuery"] = "SUBJECTIVE_QUERY";
    return NlpErrorState;
}({}); /** For Reading Aids */ 
let $78ad46e0d6808149$export$db433339b7e07571 = /*#__PURE__*/ function(NlpGetKeywordsTextFormat) {
    NlpGetKeywordsTextFormat["Adf"] = "ADF";
    NlpGetKeywordsTextFormat["PlainText"] = "PLAIN_TEXT";
    return NlpGetKeywordsTextFormat;
}({}); /** Result for Q&A Searches */ 
let $78ad46e0d6808149$export$b1971cd5d32db392 = /*#__PURE__*/ function(NlpSearchResultFormat) {
    NlpSearchResultFormat["Adf"] = "ADF";
    NlpSearchResultFormat["Json"] = "JSON";
    NlpSearchResultFormat["Markdown"] = "MARKDOWN";
    NlpSearchResultFormat["PlainText"] = "PLAIN_TEXT";
    return NlpSearchResultFormat;
}({});
let $78ad46e0d6808149$export$3f22e424998acb73 = /*#__PURE__*/ function(NlpSearchResultType) {
    NlpSearchResultType["Blogpost"] = "blogpost";
    NlpSearchResultType["Page"] = "page";
    NlpSearchResultType["User"] = "user";
    return NlpSearchResultType;
}({}); /**
 * From the [relay Node specification](https://relay.dev/graphql/objectidentification.htm#sec-Node-Interface)
 *
 * The server must provide an interface called `Node`. That interface must include exactly one field, called `id` that returns a non-null `ID`.
 *
 * This `id` should be a globally unique identifier for this object, and given just this `id`, the server should be able to refetch the object.
 */ 
let $78ad46e0d6808149$export$d197034e0ce6cbfa = /*#__PURE__*/ function(PeapProgramStatus) {
    PeapProgramStatus["Abandoned"] = "ABANDONED";
    PeapProgramStatus["Active"] = "ACTIVE";
    PeapProgramStatus["Ended"] = "ENDED";
    PeapProgramStatus["New"] = "NEW";
    PeapProgramStatus["Planned"] = "PLANNED";
    return PeapProgramStatus;
}({}); /** Query Parameters when looking for EAPs */  /**
 * input PEAPUserSiteEnrollmentMutationInput {
 *   programId: ID!
 *   cloudId: ID! #@ARI(....)
 *   desiredStatus: Boolean!
 * }
 * input PEAPOrgEnrollmentMutationInput {
 *   programId: ID!
 *   orgId: ID! @ARI(type: "org", owner: "platform")
 *   desiredStatus: Boolean!
 * }
 * input PEAPOrgUserEnrollmentMutationInput {
 *   programId: ID!
 *   orgId: ID! @ARI(type: "org", owner: "platform")
 *   desiredStatus: Boolean!
 * }
 */ 
let $78ad46e0d6808149$export$20d511023e79b2f8 = /*#__PURE__*/ function(PartnerBtfLicenseType) {
    PartnerBtfLicenseType["Academic"] = "ACADEMIC";
    PartnerBtfLicenseType["Commercial"] = "COMMERCIAL";
    PartnerBtfLicenseType["Evaluation"] = "EVALUATION";
    PartnerBtfLicenseType["Starter"] = "STARTER";
    return PartnerBtfLicenseType;
}({});
let $78ad46e0d6808149$export$d8bdcda0cbd9a410 = /*#__PURE__*/ function(PartnerCloudLicenseType) {
    PartnerCloudLicenseType["Academic"] = "ACADEMIC";
    PartnerCloudLicenseType["Commercial"] = "COMMERCIAL";
    PartnerCloudLicenseType["Community"] = "COMMUNITY";
    PartnerCloudLicenseType["Demonstration"] = "DEMONSTRATION";
    PartnerCloudLicenseType["Developer"] = "DEVELOPER";
    PartnerCloudLicenseType["Evaluation"] = "EVALUATION";
    PartnerCloudLicenseType["Free"] = "FREE";
    PartnerCloudLicenseType["OpenSource"] = "OPEN_SOURCE";
    PartnerCloudLicenseType["Starter"] = "STARTER";
    return PartnerCloudLicenseType;
}({});
let $78ad46e0d6808149$export$f0c4b6a2f4cddbe1 = /*#__PURE__*/ function(PartnerCurrency) {
    PartnerCurrency["Jpy"] = "JPY";
    PartnerCurrency["Usd"] = "USD";
    return PartnerCurrency;
}({});
let $78ad46e0d6808149$export$e141851b33100510 = /*#__PURE__*/ function(PartnerInvoiceJsonCurrency) {
    PartnerInvoiceJsonCurrency["Aud"] = "AUD";
    PartnerInvoiceJsonCurrency["Eur"] = "EUR";
    PartnerInvoiceJsonCurrency["Gbp"] = "GBP";
    PartnerInvoiceJsonCurrency["Jpy"] = "JPY";
    PartnerInvoiceJsonCurrency["Usd"] = "USD";
    return PartnerInvoiceJsonCurrency;
}({}); /** --------------------------------------------------------------------------------------------- */  /** Search for available product offerings */  /** The general shape of a mutation response. */  /** ## Plan mode create cards ### */ 
let $78ad46e0d6808149$export$f2dc2b898b108911 = /*#__PURE__*/ function(PlanModeDestination) {
    PlanModeDestination["Backlog"] = "BACKLOG";
    PlanModeDestination["Board"] = "BOARD";
    PlanModeDestination["Sprint"] = "SPRINT";
    return PlanModeDestination;
}({}); /** # Types */ 
let $78ad46e0d6808149$export$2cbcdf3f71413e2f = /*#__PURE__*/ function(PolarisCommentKind) {
    PolarisCommentKind["PlayContribution"] = "PLAY_CONTRIBUTION";
    PolarisCommentKind["View"] = "VIEW";
    return PolarisCommentKind;
}({}); /** # Types */ 
let $78ad46e0d6808149$export$fb5683d231e089bf = /*#__PURE__*/ function(PolarisFieldType) {
    PolarisFieldType["PolarisIdeaDateField"] = "PolarisIdeaDateField";
    PolarisFieldType["PolarisIdeaDateTimeField"] = "PolarisIdeaDateTimeField";
    PolarisFieldType["PolarisIdeaExternalReferenceField"] = "PolarisIdeaExternalReferenceField";
    PolarisFieldType["PolarisIdeaExternalReferencePropertyField"] = "PolarisIdeaExternalReferencePropertyField";
    PolarisFieldType["PolarisIdeaIntervalField"] = "PolarisIdeaIntervalField";
    PolarisFieldType["PolarisIdeaLabelsField"] = "PolarisIdeaLabelsField";
    PolarisFieldType["PolarisIdeaNumberField"] = "PolarisIdeaNumberField";
    PolarisFieldType["PolarisIdeaOptionField"] = "PolarisIdeaOptionField";
    PolarisFieldType["PolarisIdeaOptionsField"] = "PolarisIdeaOptionsField";
    PolarisFieldType["PolarisIdeaPlayField"] = "PolarisIdeaPlayField";
    PolarisFieldType["PolarisIdeaReactionsField"] = "PolarisIdeaReactionsField";
    PolarisFieldType["PolarisIdeaStringField"] = "PolarisIdeaStringField";
    PolarisFieldType["PolarisIdeaUserField"] = "PolarisIdeaUserField";
    PolarisFieldType["PolarisIdeaUsersField"] = "PolarisIdeaUsersField";
    PolarisFieldType["PolarisJiraField"] = "PolarisJiraField";
    return PolarisFieldType;
}({}); /** # Types */  /**
 * An PolarisIdeaField is a unit of information that can be instantiated
 * for an PolarisIdea.
 */ 
let $78ad46e0d6808149$export$123c361c0586acd4 = /*#__PURE__*/ function(PolarisPlayKind) {
    PolarisPlayKind["PolarisBudgetAllocationPlay"] = "PolarisBudgetAllocationPlay";
    return PolarisPlayKind;
}({}); /**
 * ======================================
 *   _____             _    _
 *  |  __ \           | |  (_)
 *  | |__) |__ _ _ __ | | ___ _ __   __ _
 *  |  _  // _` | '_ \| |/ / | '_ \ / _` |
 *  | | \ \ (_| | | | |   <| | | | | (_| |
 *  |_|  \_\__,_|_| |_|_|\_\_|_| |_|\__, |
 *                                   __/ |
 *                                  |___/
 *  Mutations
 */ 
let $78ad46e0d6808149$export$ec111ec92c0d7d70 = /*#__PURE__*/ function(PolarisRefreshError) {
    PolarisRefreshError["InternalError"] = "INTERNAL_ERROR";
    PolarisRefreshError["InvalidSnippet"] = "INVALID_SNIPPET";
    PolarisRefreshError["NeedAuth"] = "NEED_AUTH";
    PolarisRefreshError["NotFound"] = "NOT_FOUND";
    return PolarisRefreshError;
}({}); /** # Types */ 
let $78ad46e0d6808149$export$f3e14b5f4d20c3d5 = /*#__PURE__*/ function(PolarisResolvedObjectAuthType) {
    PolarisResolvedObjectAuthType["ApiKey"] = "API_KEY";
    PolarisResolvedObjectAuthType["Oauth2"] = "OAUTH2";
    return PolarisResolvedObjectAuthType;
}({}); /** # Types */ 
let $78ad46e0d6808149$export$57783d255575ae4b = /*#__PURE__*/ function(PolarisSnippetPropertyKind) {
    PolarisSnippetPropertyKind["Labels"] = "LABELS";
    PolarisSnippetPropertyKind["Number"] = "NUMBER";
    PolarisSnippetPropertyKind["Rating"] = "RATING";
    return PolarisSnippetPropertyKind;
}({});
let $78ad46e0d6808149$export$bda785e7d71f1240 = /*#__PURE__*/ function(PolarisSortOrder) {
    PolarisSortOrder["Asc"] = "ASC";
    PolarisSortOrder["Desc"] = "DESC";
    return PolarisSortOrder;
}({});
let $78ad46e0d6808149$export$14a23e97810cf04b = /*#__PURE__*/ function(PolarisTimelineMode) {
    PolarisTimelineMode["Months"] = "MONTHS";
    PolarisTimelineMode["Quarters"] = "QUARTERS";
    PolarisTimelineMode["Years"] = "YEARS";
    return PolarisTimelineMode;
}({});
let $78ad46e0d6808149$export$2b6d541a0ba09b1f = /*#__PURE__*/ function(PolarisValueOperator) {
    PolarisValueOperator["Eq"] = "EQ";
    PolarisValueOperator["Gt"] = "GT";
    PolarisValueOperator["Gte"] = "GTE";
    PolarisValueOperator["Lt"] = "LT";
    PolarisValueOperator["Lte"] = "LTE";
    return PolarisValueOperator;
}({});
let $78ad46e0d6808149$export$dbd70c8a392059ec = /*#__PURE__*/ function(PolarisViewFieldRollupType) {
    PolarisViewFieldRollupType["Avg"] = "AVG";
    PolarisViewFieldRollupType["Count"] = "COUNT";
    PolarisViewFieldRollupType["Empty"] = "EMPTY";
    PolarisViewFieldRollupType["Filled"] = "FILLED";
    PolarisViewFieldRollupType["Max"] = "MAX";
    PolarisViewFieldRollupType["Median"] = "MEDIAN";
    PolarisViewFieldRollupType["Min"] = "MIN";
    PolarisViewFieldRollupType["Range"] = "RANGE";
    PolarisViewFieldRollupType["Sum"] = "SUM";
    return PolarisViewFieldRollupType;
}({}); /** # Types */ 
let $78ad46e0d6808149$export$54183e329a6730fd = /*#__PURE__*/ function(PolarisViewFilterKind) {
    PolarisViewFilterKind["FieldIdentity"] = "FIELD_IDENTITY";
    PolarisViewFilterKind["FieldNumeric"] = "FIELD_NUMERIC";
    PolarisViewFilterKind["Interval"] = "INTERVAL";
    PolarisViewFilterKind["Text"] = "TEXT";
    return PolarisViewFilterKind;
}({});
let $78ad46e0d6808149$export$d6c8f262b1709692 = /*#__PURE__*/ function(PolarisViewFilterOperator) {
    PolarisViewFilterOperator["EndAfterNow"] = "END_AFTER_NOW";
    PolarisViewFilterOperator["EndBeforeNow"] = "END_BEFORE_NOW";
    PolarisViewFilterOperator["Eq"] = "EQ";
    PolarisViewFilterOperator["Gt"] = "GT";
    PolarisViewFilterOperator["Gte"] = "GTE";
    PolarisViewFilterOperator["Lt"] = "LT";
    PolarisViewFilterOperator["Lte"] = "LTE";
    PolarisViewFilterOperator["Neq"] = "NEQ";
    PolarisViewFilterOperator["StartAfterNow"] = "START_AFTER_NOW";
    PolarisViewFilterOperator["StartBeforeNow"] = "START_BEFORE_NOW";
    return PolarisViewFilterOperator;
}({});
let $78ad46e0d6808149$export$2503fee82ee05536 = /*#__PURE__*/ function(PolarisViewLayoutType) {
    PolarisViewLayoutType["Compact"] = "COMPACT";
    PolarisViewLayoutType["Detailed"] = "DETAILED";
    PolarisViewLayoutType["Summary"] = "SUMMARY";
    return PolarisViewLayoutType;
}({}); /** # Types */ 
let $78ad46e0d6808149$export$975689d1b7b4351b = /*#__PURE__*/ function(PolarisViewSetType) {
    PolarisViewSetType["Capture"] = "CAPTURE";
    PolarisViewSetType["Custom"] = "CUSTOM";
    PolarisViewSetType["Deliver"] = "DELIVER";
    PolarisViewSetType["Prioritize"] = "PRIORITIZE";
    PolarisViewSetType["Section"] = "SECTION";
    PolarisViewSetType["Single"] = "SINGLE";
    PolarisViewSetType["System"] = "SYSTEM";
    return PolarisViewSetType;
}({});
let $78ad46e0d6808149$export$6d557cf9ccdcf3b3 = /*#__PURE__*/ function(PolarisViewSortMode) {
    PolarisViewSortMode["FieldsSort"] = "FIELDS_SORT";
    PolarisViewSortMode["ProjectRank"] = "PROJECT_RANK";
    PolarisViewSortMode["ViewRank"] = "VIEW_RANK";
    return PolarisViewSortMode;
}({});
let $78ad46e0d6808149$export$9dec0b77614b677b = /*#__PURE__*/ function(PolarisVisualizationType) {
    PolarisVisualizationType["Board"] = "BOARD";
    PolarisVisualizationType["Matrix"] = "MATRIX";
    PolarisVisualizationType["Table"] = "TABLE";
    PolarisVisualizationType["Timeline"] = "TIMELINE";
    PolarisVisualizationType["Twoxtwo"] = "TWOXTWO";
    return PolarisVisualizationType;
}({}); /**
 * Principals types that App can allow for unlicensed access. This maps to different type of users in product.
 * For example - in case of JSM users can be UNLICENSED, CUSTOMER and ANONYMOUS.
 * UNLICENSED is Atlassian Account users who do not have a license on the underlying product where the extension is rendering
 * CUSTOMER - A site-specific Customer Account (accountId in format qm:{uuid}:{uuid} see https://developer.atlassian.com/platform/identity/rest/v1/))
 * ANONYMOUS - An invocation by a user that is not authenticated i.e. a Public JSM Portal/Confluence Space/Jira Project etc
 */ 
let $78ad46e0d6808149$export$39adac38571da5a2 = /*#__PURE__*/ function(PrincipalType) {
    PrincipalType["Anonymous"] = "ANONYMOUS";
    PrincipalType["Customer"] = "CUSTOMER";
    PrincipalType["Unlicensed"] = "UNLICENSED";
    return PrincipalType;
}({}); /** Listing data for a product */  /** Listing data for a product */  /** Listing data for a product */  /** Product Listing Information or associated error in querying */  /** Accepts input to find pull requests based on the status and time range. */  /** Entry point for query suggestion */  /** Entry point for query suggestion */  /** Metadata on any analytics related fields, these do not affect the search */  /** Filters to apply to query suggestions */ 
let $78ad46e0d6808149$export$e0affd64059d9f82 = /*#__PURE__*/ function(RateLimitingCurrency) {
    RateLimitingCurrency["CannedResponseMutationCurrency"] = "CANNED_RESPONSE_MUTATION_CURRENCY";
    RateLimitingCurrency["CannedResponseQueryCurrency"] = "CANNED_RESPONSE_QUERY_CURRENCY";
    RateLimitingCurrency["CompassSynchronizeLinkAssociationsCurrency"] = "COMPASS_SYNCHRONIZE_LINK_ASSOCIATIONS_CURRENCY";
    RateLimitingCurrency["DevopsContainerRelationshipsReadCurrency"] = "DEVOPS_CONTAINER_RELATIONSHIPS_READ_CURRENCY";
    RateLimitingCurrency["DevopsContainerRelationshipsWriteCurrency"] = "DEVOPS_CONTAINER_RELATIONSHIPS_WRITE_CURRENCY";
    RateLimitingCurrency["DevopsServiceReadCurrency"] = "DEVOPS_SERVICE_READ_CURRENCY";
    RateLimitingCurrency["DevopsServiceWriteCurrency"] = "DEVOPS_SERVICE_WRITE_CURRENCY";
    RateLimitingCurrency["ExportMetricsCurrency"] = "EXPORT_METRICS_CURRENCY";
    RateLimitingCurrency["ForgeAlertsCurrency"] = "FORGE_ALERTS_CURRENCY";
    RateLimitingCurrency["ForgeAppContributorCurrency"] = "FORGE_APP_CONTRIBUTOR_CURRENCY";
    RateLimitingCurrency["ForgeAuditLogsCurrency"] = "FORGE_AUDIT_LOGS_CURRENCY";
    RateLimitingCurrency["ForgeMetricsCurrency"] = "FORGE_METRICS_CURRENCY";
    RateLimitingCurrency["HelpCenterCurrency"] = "HELP_CENTER_CURRENCY";
    RateLimitingCurrency["HelpLayoutCurrency"] = "HELP_LAYOUT_CURRENCY";
    RateLimitingCurrency["HelpObjectStoreCurrency"] = "HELP_OBJECT_STORE_CURRENCY";
    RateLimitingCurrency["KnowledgeBaseCurrency"] = "KNOWLEDGE_BASE_CURRENCY";
    RateLimitingCurrency["PolarisBetaUserCurrency"] = "POLARIS_BETA_USER_CURRENCY";
    RateLimitingCurrency["PolarisCollabTokenQueryCurrency"] = "POLARIS_COLLAB_TOKEN_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisCommentCurrency"] = "POLARIS_COMMENT_CURRENCY";
    RateLimitingCurrency["PolarisCurrency"] = "POLARIS_CURRENCY";
    RateLimitingCurrency["PolarisFieldCurrency"] = "POLARIS_FIELD_CURRENCY";
    RateLimitingCurrency["PolarisIdeaCurrency"] = "POLARIS_IDEA_CURRENCY";
    RateLimitingCurrency["PolarisIdeaTemplatesQueryCurrency"] = "POLARIS_IDEA_TEMPLATES_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisIdeaTemplateCurrency"] = "POLARIS_IDEA_TEMPLATE_CURRENCY";
    RateLimitingCurrency["PolarisInsightsQueryCurrency"] = "POLARIS_INSIGHTS_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisInsightsWithErrorsQueryCurrency"] = "POLARIS_INSIGHTS_WITH_ERRORS_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisInsightCurrency"] = "POLARIS_INSIGHT_CURRENCY";
    RateLimitingCurrency["PolarisInsightQueryCurrency"] = "POLARIS_INSIGHT_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisLabelsQueryCurrency"] = "POLARIS_LABELS_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisOnboardingCurrency"] = "POLARIS_ONBOARDING_CURRENCY";
    RateLimitingCurrency["PolarisPlayCurrency"] = "POLARIS_PLAY_CURRENCY";
    RateLimitingCurrency["PolarisProjectConfigCurrency"] = "POLARIS_PROJECT_CONFIG_CURRENCY";
    RateLimitingCurrency["PolarisProjectQueryCurrency"] = "POLARIS_PROJECT_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisRankingCurrency"] = "POLARIS_RANKING_CURRENCY";
    RateLimitingCurrency["PolarisReactionCurrency"] = "POLARIS_REACTION_CURRENCY";
    RateLimitingCurrency["PolarisSnippetCurrency"] = "POLARIS_SNIPPET_CURRENCY";
    RateLimitingCurrency["PolarisSnippetPropertiesConfigQueryCurrency"] = "POLARIS_SNIPPET_PROPERTIES_CONFIG_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisTermsConsentQueryCurrency"] = "POLARIS_TERMS_CONSENT_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisUnfurlCurrency"] = "POLARIS_UNFURL_CURRENCY";
    RateLimitingCurrency["PolarisViewsetCurrency"] = "POLARIS_VIEWSET_CURRENCY";
    RateLimitingCurrency["PolarisViewArrangementInfoQueryCurrency"] = "POLARIS_VIEW_ARRANGEMENT_INFO_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisViewCurrency"] = "POLARIS_VIEW_CURRENCY";
    RateLimitingCurrency["PolarisViewQueryCurrency"] = "POLARIS_VIEW_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisWriteCurrency"] = "POLARIS_WRITE_CURRENCY";
    RateLimitingCurrency["ShepherdDefaultCurrency"] = "SHEPHERD_DEFAULT_CURRENCY";
    RateLimitingCurrency["ShepherdMultipleReadsCurrency"] = "SHEPHERD_MULTIPLE_READS_CURRENCY";
    RateLimitingCurrency["ShepherdReadAlertCurrency"] = "SHEPHERD_READ_ALERT_CURRENCY";
    RateLimitingCurrency["TeamsCurrency"] = "TEAMS_CURRENCY";
    RateLimitingCurrency["TeamMembersCurrency"] = "TEAM_MEMBERS_CURRENCY";
    RateLimitingCurrency["TeamMembersV2Currency"] = "TEAM_MEMBERS_V2_CURRENCY";
    RateLimitingCurrency["TeamRoleGrantsMutatePrincipalsCurrency"] = "TEAM_ROLE_GRANTS_MUTATE_PRINCIPALS_CURRENCY";
    RateLimitingCurrency["TeamRoleGrantsQueryPrincipalsCurrency"] = "TEAM_ROLE_GRANTS_QUERY_PRINCIPALS_CURRENCY";
    RateLimitingCurrency["TeamSearchCurrency"] = "TEAM_SEARCH_CURRENCY";
    RateLimitingCurrency["TeamSearchV2Currency"] = "TEAM_SEARCH_V2_CURRENCY";
    RateLimitingCurrency["TeamV2Currency"] = "TEAM_V2_CURRENCY";
    RateLimitingCurrency["TestingService"] = "TESTING_SERVICE";
    RateLimitingCurrency["TrelloCurrency"] = "TRELLO_CURRENCY";
    RateLimitingCurrency["TrelloMutationCurrency"] = "TRELLO_MUTATION_CURRENCY";
    return RateLimitingCurrency;
}({}); /** Represents a status object from a workflow in Jira without any calculcated fields */  /**
 * Establish tunnels for a specific environment of an app.
 *
 * This will create a cloudflare tunnel for forge app debugging
 */ 
let $78ad46e0d6808149$export$4df1ed283b73df16 = /*#__PURE__*/ function(RoadmapChildIssuePlanningMode) {
    RoadmapChildIssuePlanningMode["Date"] = "DATE";
    RoadmapChildIssuePlanningMode["Disabled"] = "DISABLED";
    RoadmapChildIssuePlanningMode["Sprint"] = "SPRINT";
    return RoadmapChildIssuePlanningMode;
}({}); /** Relay connection definition for a roadmap item */  /** Relay edge definition for a roadmap item */  /** Details of a component */  /** Content of a valid roadmap */  /** Content of a valid roadmap */  /** Content of a valid roadmap */  /** Details of a custom filter */  /** Details about dependency configuration for roadmaps */  /** Details of a roadmap */  /** View settings for epics on the roadmap */ 
let $78ad46e0d6808149$export$1c9f5b28aa44f22d = /*#__PURE__*/ function(RoadmapEpicView) {
    RoadmapEpicView["All"] = "ALL";
    RoadmapEpicView["Completed"] = "COMPLETED";
    RoadmapEpicView["Incomplete"] = "INCOMPLETE";
    return RoadmapEpicView;
}({}); /** Configuration values for the external system(s) behind the roadmap data */  /** Details of a field derived from JQL */  /** Field configuration */  /** Details about filter configuration for roadmaps */  /** Describes a problem with the roadmaps that needs to be resolved in order to successfully fetch the content */  /** Link to a documentation page relevant to the healthcheck */  /** Healthcheck resolution action */  /** Details about hierarchy configuration for roadmaps */  /** The roadmap item data */  /** Relay connection definition for a roadmap item */  /** Relay edge definition for a roadmap item */  /** Details of the status an item has */  /** Details of the category that a status belongs to */  /** Information about the type of a roadmap Item */  /** Relay connection definition for a roadmap item */  /** Relay edge definition for a roadmap item */  /** View settings for hierarchy level one items on the roadmap */ 
let $78ad46e0d6808149$export$7f14fc5a386166cb = /*#__PURE__*/ function(RoadmapLevelOneView) {
    RoadmapLevelOneView["Complete1M"] = "COMPLETE1M";
    RoadmapLevelOneView["Complete3M"] = "COMPLETE3M";
    RoadmapLevelOneView["Complete6M"] = "COMPLETE6M";
    RoadmapLevelOneView["Complete9M"] = "COMPLETE9M";
    RoadmapLevelOneView["Complete12M"] = "COMPLETE12M";
    RoadmapLevelOneView["Incomplete"] = "INCOMPLETE";
    return RoadmapLevelOneView;
}({}); /**
 * ###########################################################################
 * ####################### END ROADMAP QUERIES TYPES #########################
 * ###########################################################################
 * ###########################################################################
 * ######### BELOW HERE ARE THE TYPES SUPPORTING ROADMAPS MUTATIONS ##########
 * ###########################################################################
 */ 
let $78ad46e0d6808149$export$6df418813509b448 = /*#__PURE__*/ function(RoadmapPaletteColor) {
    RoadmapPaletteColor["Blue"] = "BLUE";
    RoadmapPaletteColor["DarkBlue"] = "DARK_BLUE";
    RoadmapPaletteColor["DarkGreen"] = "DARK_GREEN";
    RoadmapPaletteColor["DarkGrey"] = "DARK_GREY";
    RoadmapPaletteColor["DarkOrange"] = "DARK_ORANGE";
    RoadmapPaletteColor["DarkPurple"] = "DARK_PURPLE";
    RoadmapPaletteColor["DarkTeal"] = "DARK_TEAL";
    RoadmapPaletteColor["DarkYellow"] = "DARK_YELLOW";
    RoadmapPaletteColor["Green"] = "GREEN";
    RoadmapPaletteColor["Grey"] = "GREY";
    RoadmapPaletteColor["Orange"] = "ORANGE";
    RoadmapPaletteColor["Purple"] = "PURPLE";
    RoadmapPaletteColor["Teal"] = "TEAL";
    RoadmapPaletteColor["Yellow"] = "YELLOW";
    return RoadmapPaletteColor;
}({}); /** Aggregated progress of child issues */  /** Details of a project for a roadmap */  /** Configuration details specific to a project */  /** Information about the permissions available for the roadmap project for the current user */  /** Details about how valid the roadmap project is */  /** Details of a quick filter */ 
let $78ad46e0d6808149$export$718224d6d55ce2e9 = /*#__PURE__*/ function(RoadmapRankPosition) {
    RoadmapRankPosition["After"] = "AFTER";
    RoadmapRankPosition["Before"] = "BEFORE";
    return RoadmapRankPosition;
}({}); /** Input for setting up a project with a roadmap */  /** Input for a single roadmap schedule item. */  /** Input of a roadmap schedule items mutation. */  /** Details of a roadmap sprint */  /** States that a sprint can be in */ 
let $78ad46e0d6808149$export$8fd1e37e60920853 = /*#__PURE__*/ function(RoadmapSprintState) {
    RoadmapSprintState["Active"] = "ACTIVE";
    RoadmapSprintState["Closed"] = "CLOSED";
    RoadmapSprintState["Future"] = "FUTURE";
    return RoadmapSprintState;
}({}); /** Details of the roadmap status category */  /** Subtask issues */  /** Subtask issues and its status category details */  /** Defines the available timeline modes */ 
let $78ad46e0d6808149$export$d1eb62afe3c5898c = /*#__PURE__*/ function(RoadmapTimelineMode) {
    RoadmapTimelineMode["Months"] = "MONTHS";
    RoadmapTimelineMode["Quarters"] = "QUARTERS";
    RoadmapTimelineMode["Weeks"] = "WEEKS";
    return RoadmapTimelineMode;
}({}); /** Input of a roadmap update item mutation. */  /** Input for updating roadmap settings */  /** Any user specific configuration for the roadmap */  /** Details of a version */  /** Avaliable version statuses */ 
let $78ad46e0d6808149$export$e12a64c0aae94c50 = /*#__PURE__*/ function(RoadmapVersionStatus) {
    RoadmapVersionStatus["Archived"] = "ARCHIVED";
    RoadmapVersionStatus["Released"] = "RELEASED";
    RoadmapVersionStatus["Unreleased"] = "UNRELEASED";
    return RoadmapVersionStatus;
}({}); /** View settings for items on the roadmap */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** A type that represents a sandbox product. */  /** A type that represents a sandbox event. */  /** An enum of the possible values of a sandbox event result. */ 
let $78ad46e0d6808149$export$74a8f61d42003686 = /*#__PURE__*/ function(SandboxEventResult) {
    SandboxEventResult["Failed"] = "failed";
    SandboxEventResult["Incomplete"] = "incomplete";
    SandboxEventResult["Successful"] = "successful";
    SandboxEventResult["Unknown"] = "unknown";
    return SandboxEventResult;
}({}); /** An enum of the possible values of a sandbox event source. */ 
let $78ad46e0d6808149$export$fc03b8f4df65e1a2 = /*#__PURE__*/ function(SandboxEventSource) {
    SandboxEventSource["Admin"] = "admin";
    SandboxEventSource["System"] = "system";
    SandboxEventSource["User"] = "user";
    return SandboxEventSource;
}({}); /** An enum of the possible values of a sandbox event status. */ 
let $78ad46e0d6808149$export$c4acd5ebccb10941 = /*#__PURE__*/ function(SandboxEventStatus) {
    SandboxEventStatus["AwaitingReplay"] = "awaiting_replay";
    SandboxEventStatus["Cancelled"] = "cancelled";
    SandboxEventStatus["Completed"] = "completed";
    SandboxEventStatus["Started"] = "started";
    return SandboxEventStatus;
}({}); /** An enum of the possible values of a sandbox event type. */ 
let $78ad46e0d6808149$export$e370ebae241bc22f = /*#__PURE__*/ function(SandboxEventType) {
    SandboxEventType["Create"] = "create";
    SandboxEventType["DataClone"] = "data_clone";
    SandboxEventType["DataCloneSelective"] = "data_clone_selective";
    SandboxEventType["HardDelete"] = "hard_delete";
    SandboxEventType["Reset"] = "reset";
    SandboxEventType["Reshard"] = "reshard";
    SandboxEventType["Rollback"] = "rollback";
    SandboxEventType["SoftDelete"] = "soft_delete";
    return SandboxEventType;
}({}); /** The top-level sandbox query type. */  /** The top-level sandbox query type. */  /** The top-level sandbox subscription type. */  /** The top-level sandbox subscription type. */ 
let $78ad46e0d6808149$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["AdminContainer"] = "ADMIN_CONTAINER";
    Scope["ApiAccess"] = "API_ACCESS";
    Scope["ApplicationRoleRead"] = "APPLICATION_ROLE_READ";
    Scope["AsyncTaskDelete"] = "ASYNC_TASK_DELETE";
    Scope["AttachmentDelete"] = "ATTACHMENT_DELETE";
    Scope["AttachmentRead"] = "ATTACHMENT_READ";
    Scope["AttachmentWrite"] = "ATTACHMENT_WRITE";
    Scope["AuditLogRead"] = "AUDIT_LOG_READ";
    Scope["AuthConfluenceUser"] = "AUTH_CONFLUENCE_USER";
    Scope["AvatarDelete"] = "AVATAR_DELETE";
    Scope["AvatarRead"] = "AVATAR_READ";
    Scope["AvatarWrite"] = "AVATAR_WRITE";
    Scope["CatalogRead"] = "CATALOG_READ";
    Scope["CommentDelete"] = "COMMENT_DELETE";
    Scope["CommentPropertyDelete"] = "COMMENT_PROPERTY_DELETE";
    Scope["CommentPropertyRead"] = "COMMENT_PROPERTY_READ";
    Scope["CommentPropertyWrite"] = "COMMENT_PROPERTY_WRITE";
    Scope["CommentRead"] = "COMMENT_READ";
    Scope["CommentWrite"] = "COMMENT_WRITE";
    Scope["CompassAtlassianExternal"] = "COMPASS_ATLASSIAN_EXTERNAL";
    Scope["ConfluenceAtlassianExternal"] = "CONFLUENCE_ATLASSIAN_EXTERNAL";
    Scope["CustomFieldContextualConfigurationRead"] = "CUSTOM_FIELD_CONTEXTUAL_CONFIGURATION_READ";
    Scope["CustomFieldContextualConfigurationWrite"] = "CUSTOM_FIELD_CONTEXTUAL_CONFIGURATION_WRITE";
    Scope["DashboardDelete"] = "DASHBOARD_DELETE";
    Scope["DashboardPropertyDelete"] = "DASHBOARD_PROPERTY_DELETE";
    Scope["DashboardPropertyRead"] = "DASHBOARD_PROPERTY_READ";
    Scope["DashboardPropertyWrite"] = "DASHBOARD_PROPERTY_WRITE";
    Scope["DashboardRead"] = "DASHBOARD_READ";
    Scope["DashboardWrite"] = "DASHBOARD_WRITE";
    Scope["DeleteConfluenceAttachment"] = "DELETE_CONFLUENCE_ATTACHMENT";
    Scope["DeleteConfluenceBlogpost"] = "DELETE_CONFLUENCE_BLOGPOST";
    Scope["DeleteConfluenceComment"] = "DELETE_CONFLUENCE_COMMENT";
    Scope["DeleteConfluenceCustomContent"] = "DELETE_CONFLUENCE_CUSTOM_CONTENT";
    Scope["DeleteConfluencePage"] = "DELETE_CONFLUENCE_PAGE";
    Scope["DeleteConfluenceSpace"] = "DELETE_CONFLUENCE_SPACE";
    Scope["DeleteJswBoardScopeAdmin"] = "DELETE_JSW_BOARD_SCOPE_ADMIN";
    Scope["DeleteJswSprint"] = "DELETE_JSW_SPRINT";
    Scope["DeleteOrganization"] = "DELETE_ORGANIZATION";
    Scope["DeleteOrganizationProperty"] = "DELETE_ORGANIZATION_PROPERTY";
    Scope["DeleteOrganizationUser"] = "DELETE_ORGANIZATION_USER";
    Scope["DeleteRequesttypeProperty"] = "DELETE_REQUESTTYPE_PROPERTY";
    Scope["DeleteRequestFeedback"] = "DELETE_REQUEST_FEEDBACK";
    Scope["DeleteRequestNotification"] = "DELETE_REQUEST_NOTIFICATION";
    Scope["DeleteRequestParticipant"] = "DELETE_REQUEST_PARTICIPANT";
    Scope["DeleteServicedeskCustomer"] = "DELETE_SERVICEDESK_CUSTOMER";
    Scope["DeleteServicedeskOrganization"] = "DELETE_SERVICEDESK_ORGANIZATION";
    Scope["DeleteServicedeskProperty"] = "DELETE_SERVICEDESK_PROPERTY";
    Scope["FieldConfigurationDelete"] = "FIELD_CONFIGURATION_DELETE";
    Scope["FieldConfigurationRead"] = "FIELD_CONFIGURATION_READ";
    Scope["FieldConfigurationSchemeDelete"] = "FIELD_CONFIGURATION_SCHEME_DELETE";
    Scope["FieldConfigurationSchemeRead"] = "FIELD_CONFIGURATION_SCHEME_READ";
    Scope["FieldConfigurationSchemeWrite"] = "FIELD_CONFIGURATION_SCHEME_WRITE";
    Scope["FieldConfigurationWrite"] = "FIELD_CONFIGURATION_WRITE";
    Scope["FieldDefaultValueRead"] = "FIELD_DEFAULT_VALUE_READ";
    Scope["FieldDefaultValueWrite"] = "FIELD_DEFAULT_VALUE_WRITE";
    Scope["FieldDelete"] = "FIELD_DELETE";
    Scope["FieldOptionsRead"] = "FIELD_OPTIONS_READ";
    Scope["FieldOptionDelete"] = "FIELD_OPTION_DELETE";
    Scope["FieldOptionRead"] = "FIELD_OPTION_READ";
    Scope["FieldOptionWrite"] = "FIELD_OPTION_WRITE";
    Scope["FieldRead"] = "FIELD_READ";
    Scope["FieldWrite"] = "FIELD_WRITE";
    Scope["FilterColumnDelete"] = "FILTER_COLUMN_DELETE";
    Scope["FilterColumnRead"] = "FILTER_COLUMN_READ";
    Scope["FilterColumnWrite"] = "FILTER_COLUMN_WRITE";
    Scope["FilterDefaultShareScopeRead"] = "FILTER_DEFAULT_SHARE_SCOPE_READ";
    Scope["FilterDefaultShareScopeWrite"] = "FILTER_DEFAULT_SHARE_SCOPE_WRITE";
    Scope["FilterDelete"] = "FILTER_DELETE";
    Scope["FilterRead"] = "FILTER_READ";
    Scope["FilterWrite"] = "FILTER_WRITE";
    Scope["GroupDelete"] = "GROUP_DELETE";
    Scope["GroupRead"] = "GROUP_READ";
    Scope["GroupWrite"] = "GROUP_WRITE";
    Scope["IdentityAtlassianExternal"] = "IDENTITY_ATLASSIAN_EXTERNAL";
    Scope["InstanceConfigurationRead"] = "INSTANCE_CONFIGURATION_READ";
    Scope["InstanceConfigurationWrite"] = "INSTANCE_CONFIGURATION_WRITE";
    Scope["IssueAdjustmentsDelete"] = "ISSUE_ADJUSTMENTS_DELETE";
    Scope["IssueAdjustmentsRead"] = "ISSUE_ADJUSTMENTS_READ";
    Scope["IssueAdjustmentsWrite"] = "ISSUE_ADJUSTMENTS_WRITE";
    Scope["IssueChangelogRead"] = "ISSUE_CHANGELOG_READ";
    Scope["IssueDelete"] = "ISSUE_DELETE";
    Scope["IssueDetailsRead"] = "ISSUE_DETAILS_READ";
    Scope["IssueEventRead"] = "ISSUE_EVENT_READ";
    Scope["IssueFieldValuesRead"] = "ISSUE_FIELD_VALUES_READ";
    Scope["IssueLinkDelete"] = "ISSUE_LINK_DELETE";
    Scope["IssueLinkRead"] = "ISSUE_LINK_READ";
    Scope["IssueLinkTypeDelete"] = "ISSUE_LINK_TYPE_DELETE";
    Scope["IssueLinkTypeRead"] = "ISSUE_LINK_TYPE_READ";
    Scope["IssueLinkTypeWrite"] = "ISSUE_LINK_TYPE_WRITE";
    Scope["IssueLinkWrite"] = "ISSUE_LINK_WRITE";
    Scope["IssueMetaRead"] = "ISSUE_META_READ";
    Scope["IssuePropertyDelete"] = "ISSUE_PROPERTY_DELETE";
    Scope["IssuePropertyRead"] = "ISSUE_PROPERTY_READ";
    Scope["IssuePropertyWrite"] = "ISSUE_PROPERTY_WRITE";
    Scope["IssueRead"] = "ISSUE_READ";
    Scope["IssueRemoteLinkDelete"] = "ISSUE_REMOTE_LINK_DELETE";
    Scope["IssueRemoteLinkRead"] = "ISSUE_REMOTE_LINK_READ";
    Scope["IssueRemoteLinkWrite"] = "ISSUE_REMOTE_LINK_WRITE";
    Scope["IssueSecurityLevelRead"] = "ISSUE_SECURITY_LEVEL_READ";
    Scope["IssueSecuritySchemeRead"] = "ISSUE_SECURITY_SCHEME_READ";
    Scope["IssueStatusRead"] = "ISSUE_STATUS_READ";
    Scope["IssueTimeTrackingRead"] = "ISSUE_TIME_TRACKING_READ";
    Scope["IssueTimeTrackingWrite"] = "ISSUE_TIME_TRACKING_WRITE";
    Scope["IssueTransitionRead"] = "ISSUE_TRANSITION_READ";
    Scope["IssueTypeDelete"] = "ISSUE_TYPE_DELETE";
    Scope["IssueTypeHierarchyRead"] = "ISSUE_TYPE_HIERARCHY_READ";
    Scope["IssueTypePropertyDelete"] = "ISSUE_TYPE_PROPERTY_DELETE";
    Scope["IssueTypePropertyRead"] = "ISSUE_TYPE_PROPERTY_READ";
    Scope["IssueTypePropertyWrite"] = "ISSUE_TYPE_PROPERTY_WRITE";
    Scope["IssueTypeRead"] = "ISSUE_TYPE_READ";
    Scope["IssueTypeSchemeDelete"] = "ISSUE_TYPE_SCHEME_DELETE";
    Scope["IssueTypeSchemeRead"] = "ISSUE_TYPE_SCHEME_READ";
    Scope["IssueTypeSchemeWrite"] = "ISSUE_TYPE_SCHEME_WRITE";
    Scope["IssueTypeScreenSchemeDelete"] = "ISSUE_TYPE_SCREEN_SCHEME_DELETE";
    Scope["IssueTypeScreenSchemeRead"] = "ISSUE_TYPE_SCREEN_SCHEME_READ";
    Scope["IssueTypeScreenSchemeWrite"] = "ISSUE_TYPE_SCREEN_SCHEME_WRITE";
    Scope["IssueTypeWrite"] = "ISSUE_TYPE_WRITE";
    Scope["IssueVotesRead"] = "ISSUE_VOTES_READ";
    Scope["IssueVoteRead"] = "ISSUE_VOTE_READ";
    Scope["IssueVoteWrite"] = "ISSUE_VOTE_WRITE";
    Scope["IssueWatcherRead"] = "ISSUE_WATCHER_READ";
    Scope["IssueWatcherWrite"] = "ISSUE_WATCHER_WRITE";
    Scope["IssueWorklogDelete"] = "ISSUE_WORKLOG_DELETE";
    Scope["IssueWorklogPropertyDelete"] = "ISSUE_WORKLOG_PROPERTY_DELETE";
    Scope["IssueWorklogPropertyRead"] = "ISSUE_WORKLOG_PROPERTY_READ";
    Scope["IssueWorklogPropertyWrite"] = "ISSUE_WORKLOG_PROPERTY_WRITE";
    Scope["IssueWorklogRead"] = "ISSUE_WORKLOG_READ";
    Scope["IssueWorklogWrite"] = "ISSUE_WORKLOG_WRITE";
    Scope["IssueWrite"] = "ISSUE_WRITE";
    Scope["JiraAtlassianExternal"] = "JIRA_ATLASSIAN_EXTERNAL";
    Scope["JiraExpressionsRead"] = "JIRA_EXPRESSIONS_READ";
    Scope["JqlRead"] = "JQL_READ";
    Scope["JqlValidate"] = "JQL_VALIDATE";
    Scope["LabelRead"] = "LABEL_READ";
    Scope["LicenseRead"] = "LICENSE_READ";
    Scope["ManageApp"] = "MANAGE_APP";
    Scope["ManageDirectory"] = "MANAGE_DIRECTORY";
    Scope["ManageJiraConfiguration"] = "MANAGE_JIRA_CONFIGURATION";
    Scope["ManageJiraDataProvider"] = "MANAGE_JIRA_DATA_PROVIDER";
    Scope["ManageJiraProject"] = "MANAGE_JIRA_PROJECT";
    Scope["ManageJiraWebhook"] = "MANAGE_JIRA_WEBHOOK";
    Scope["ManageOrg"] = "MANAGE_ORG";
    Scope["ManageOrgPublicApis"] = "MANAGE_ORG_PUBLIC_APIS";
    Scope["ManageServicedeskCustomer"] = "MANAGE_SERVICEDESK_CUSTOMER";
    Scope["MigrateConfluence"] = "MIGRATE_CONFLUENCE";
    Scope["NotificationSchemeRead"] = "NOTIFICATION_SCHEME_READ";
    Scope["NotificationSend"] = "NOTIFICATION_SEND";
    Scope["PermissionDelete"] = "PERMISSION_DELETE";
    Scope["PermissionRead"] = "PERMISSION_READ";
    Scope["PermissionSchemeDelete"] = "PERMISSION_SCHEME_DELETE";
    Scope["PermissionSchemeRead"] = "PERMISSION_SCHEME_READ";
    Scope["PermissionSchemeWrite"] = "PERMISSION_SCHEME_WRITE";
    Scope["PermissionWrite"] = "PERMISSION_WRITE";
    Scope["PriorityRead"] = "PRIORITY_READ";
    Scope["ProjectAvatarDelete"] = "PROJECT_AVATAR_DELETE";
    Scope["ProjectAvatarRead"] = "PROJECT_AVATAR_READ";
    Scope["ProjectAvatarWrite"] = "PROJECT_AVATAR_WRITE";
    Scope["ProjectCategoryDelete"] = "PROJECT_CATEGORY_DELETE";
    Scope["ProjectCategoryRead"] = "PROJECT_CATEGORY_READ";
    Scope["ProjectCategoryWrite"] = "PROJECT_CATEGORY_WRITE";
    Scope["ProjectComponentDelete"] = "PROJECT_COMPONENT_DELETE";
    Scope["ProjectComponentRead"] = "PROJECT_COMPONENT_READ";
    Scope["ProjectComponentWrite"] = "PROJECT_COMPONENT_WRITE";
    Scope["ProjectDelete"] = "PROJECT_DELETE";
    Scope["ProjectEmailRead"] = "PROJECT_EMAIL_READ";
    Scope["ProjectEmailWrite"] = "PROJECT_EMAIL_WRITE";
    Scope["ProjectFeatureRead"] = "PROJECT_FEATURE_READ";
    Scope["ProjectFeatureWrite"] = "PROJECT_FEATURE_WRITE";
    Scope["ProjectPropertyDelete"] = "PROJECT_PROPERTY_DELETE";
    Scope["ProjectPropertyRead"] = "PROJECT_PROPERTY_READ";
    Scope["ProjectPropertyWrite"] = "PROJECT_PROPERTY_WRITE";
    Scope["ProjectRead"] = "PROJECT_READ";
    Scope["ProjectRoleDelete"] = "PROJECT_ROLE_DELETE";
    Scope["ProjectRoleRead"] = "PROJECT_ROLE_READ";
    Scope["ProjectRoleWrite"] = "PROJECT_ROLE_WRITE";
    Scope["ProjectTypeRead"] = "PROJECT_TYPE_READ";
    Scope["ProjectVersionDelete"] = "PROJECT_VERSION_DELETE";
    Scope["ProjectVersionRead"] = "PROJECT_VERSION_READ";
    Scope["ProjectVersionWrite"] = "PROJECT_VERSION_WRITE";
    Scope["ProjectWrite"] = "PROJECT_WRITE";
    Scope["PullRequest"] = "PULL_REQUEST";
    Scope["PullRequestWrite"] = "PULL_REQUEST_WRITE";
    Scope["ReadAccount"] = "READ_ACCOUNT";
    Scope["ReadCompassAttentionItem"] = "READ_COMPASS_ATTENTION_ITEM";
    Scope["ReadCompassComponent"] = "READ_COMPASS_COMPONENT";
    Scope["ReadCompassEvent"] = "READ_COMPASS_EVENT";
    Scope["ReadCompassMetric"] = "READ_COMPASS_METRIC";
    Scope["ReadCompassScorecard"] = "READ_COMPASS_SCORECARD";
    Scope["ReadConfluenceAttachment"] = "READ_CONFLUENCE_ATTACHMENT";
    Scope["ReadConfluenceAuditLog"] = "READ_CONFLUENCE_AUDIT_LOG";
    Scope["ReadConfluenceBlogpost"] = "READ_CONFLUENCE_BLOGPOST";
    Scope["ReadConfluenceComment"] = "READ_CONFLUENCE_COMMENT";
    Scope["ReadConfluenceConfiguration"] = "READ_CONFLUENCE_CONFIGURATION";
    Scope["ReadConfluenceContentAnalytics"] = "READ_CONFLUENCE_CONTENT_ANALYTICS";
    Scope["ReadConfluenceContentMetadata"] = "READ_CONFLUENCE_CONTENT_METADATA";
    Scope["ReadConfluenceContentPermission"] = "READ_CONFLUENCE_CONTENT_PERMISSION";
    Scope["ReadConfluenceContentProperty"] = "READ_CONFLUENCE_CONTENT_PROPERTY";
    Scope["ReadConfluenceContentRestriction"] = "READ_CONFLUENCE_CONTENT_RESTRICTION";
    Scope["ReadConfluenceCustomContent"] = "READ_CONFLUENCE_CUSTOM_CONTENT";
    Scope["ReadConfluenceGroup"] = "READ_CONFLUENCE_GROUP";
    Scope["ReadConfluenceInlineTask"] = "READ_CONFLUENCE_INLINE_TASK";
    Scope["ReadConfluenceLabel"] = "READ_CONFLUENCE_LABEL";
    Scope["ReadConfluencePage"] = "READ_CONFLUENCE_PAGE";
    Scope["ReadConfluenceRelation"] = "READ_CONFLUENCE_RELATION";
    Scope["ReadConfluenceSpace"] = "READ_CONFLUENCE_SPACE";
    Scope["ReadConfluenceSpacePermission"] = "READ_CONFLUENCE_SPACE_PERMISSION";
    Scope["ReadConfluenceSpaceProperty"] = "READ_CONFLUENCE_SPACE_PROPERTY";
    Scope["ReadConfluenceSpaceSetting"] = "READ_CONFLUENCE_SPACE_SETTING";
    Scope["ReadConfluenceTemplate"] = "READ_CONFLUENCE_TEMPLATE";
    Scope["ReadConfluenceUser"] = "READ_CONFLUENCE_USER";
    Scope["ReadConfluenceUserProperty"] = "READ_CONFLUENCE_USER_PROPERTY";
    Scope["ReadConfluenceWatcher"] = "READ_CONFLUENCE_WATCHER";
    Scope["ReadContainer"] = "READ_CONTAINER";
    Scope["ReadCustomer"] = "READ_CUSTOMER";
    Scope["ReadDesign"] = "READ_DESIGN";
    Scope["ReadJiraUser"] = "READ_JIRA_USER";
    Scope["ReadJiraWork"] = "READ_JIRA_WORK";
    Scope["ReadJswBoardScope"] = "READ_JSW_BOARD_SCOPE";
    Scope["ReadJswBoardScopeAdmin"] = "READ_JSW_BOARD_SCOPE_ADMIN";
    Scope["ReadJswBuild"] = "READ_JSW_BUILD";
    Scope["ReadJswDeployment"] = "READ_JSW_DEPLOYMENT";
    Scope["ReadJswEpic"] = "READ_JSW_EPIC";
    Scope["ReadJswFeatureFlag"] = "READ_JSW_FEATURE_FLAG";
    Scope["ReadJswIssue"] = "READ_JSW_ISSUE";
    Scope["ReadJswRemoteLink"] = "READ_JSW_REMOTE_LINK";
    Scope["ReadJswSourceCode"] = "READ_JSW_SOURCE_CODE";
    Scope["ReadJswSprint"] = "READ_JSW_SPRINT";
    Scope["ReadKnowledgebase"] = "READ_KNOWLEDGEBASE";
    Scope["ReadMe"] = "READ_ME";
    Scope["ReadMercury"] = "READ_MERCURY";
    Scope["ReadNotifications"] = "READ_NOTIFICATIONS";
    Scope["ReadOrganization"] = "READ_ORGANIZATION";
    Scope["ReadOrganizationProperty"] = "READ_ORGANIZATION_PROPERTY";
    Scope["ReadOrganizationUser"] = "READ_ORGANIZATION_USER";
    Scope["ReadQueue"] = "READ_QUEUE";
    Scope["ReadRequest"] = "READ_REQUEST";
    Scope["ReadRequesttype"] = "READ_REQUESTTYPE";
    Scope["ReadRequesttypeProperty"] = "READ_REQUESTTYPE_PROPERTY";
    Scope["ReadRequestAction"] = "READ_REQUEST_ACTION";
    Scope["ReadRequestApproval"] = "READ_REQUEST_APPROVAL";
    Scope["ReadRequestAttachment"] = "READ_REQUEST_ATTACHMENT";
    Scope["ReadRequestComment"] = "READ_REQUEST_COMMENT";
    Scope["ReadRequestFeedback"] = "READ_REQUEST_FEEDBACK";
    Scope["ReadRequestNotification"] = "READ_REQUEST_NOTIFICATION";
    Scope["ReadRequestParticipant"] = "READ_REQUEST_PARTICIPANT";
    Scope["ReadRequestSla"] = "READ_REQUEST_SLA";
    Scope["ReadRequestStatus"] = "READ_REQUEST_STATUS";
    Scope["ReadServicedesk"] = "READ_SERVICEDESK";
    Scope["ReadServicedeskCustomer"] = "READ_SERVICEDESK_CUSTOMER";
    Scope["ReadServicedeskOrganization"] = "READ_SERVICEDESK_ORGANIZATION";
    Scope["ReadServicedeskProperty"] = "READ_SERVICEDESK_PROPERTY";
    Scope["ReadServicedeskRequest"] = "READ_SERVICEDESK_REQUEST";
    Scope["ReadTeam"] = "READ_TEAM";
    Scope["ReadTeamMembers"] = "READ_TEAM_MEMBERS";
    Scope["ReadTownsquareComment"] = "READ_TOWNSQUARE_COMMENT";
    Scope["ReadTownsquareGoal"] = "READ_TOWNSQUARE_GOAL";
    Scope["ReadTownsquareProject"] = "READ_TOWNSQUARE_PROJECT";
    Scope["ReadTownsquareWorkspace"] = "READ_TOWNSQUARE_WORKSPACE";
    Scope["ResolutionRead"] = "RESOLUTION_READ";
    Scope["ScreenableFieldDelete"] = "SCREENABLE_FIELD_DELETE";
    Scope["ScreenableFieldRead"] = "SCREENABLE_FIELD_READ";
    Scope["ScreenableFieldWrite"] = "SCREENABLE_FIELD_WRITE";
    Scope["ScreenDelete"] = "SCREEN_DELETE";
    Scope["ScreenFieldRead"] = "SCREEN_FIELD_READ";
    Scope["ScreenRead"] = "SCREEN_READ";
    Scope["ScreenSchemeDelete"] = "SCREEN_SCHEME_DELETE";
    Scope["ScreenSchemeRead"] = "SCREEN_SCHEME_READ";
    Scope["ScreenSchemeWrite"] = "SCREEN_SCHEME_WRITE";
    Scope["ScreenTabDelete"] = "SCREEN_TAB_DELETE";
    Scope["ScreenTabRead"] = "SCREEN_TAB_READ";
    Scope["ScreenTabWrite"] = "SCREEN_TAB_WRITE";
    Scope["ScreenWrite"] = "SCREEN_WRITE";
    Scope["StatusRead"] = "STATUS_READ";
    Scope["StorageApp"] = "STORAGE_APP";
    Scope["TrelloAtlassianExternal"] = "TRELLO_ATLASSIAN_EXTERNAL";
    Scope["UserColumnsRead"] = "USER_COLUMNS_READ";
    Scope["UserConfigurationDelete"] = "USER_CONFIGURATION_DELETE";
    Scope["UserConfigurationRead"] = "USER_CONFIGURATION_READ";
    Scope["UserConfigurationWrite"] = "USER_CONFIGURATION_WRITE";
    Scope["UserPropertyDelete"] = "USER_PROPERTY_DELETE";
    Scope["UserPropertyRead"] = "USER_PROPERTY_READ";
    Scope["UserPropertyWrite"] = "USER_PROPERTY_WRITE";
    Scope["UserRead"] = "USER_READ";
    Scope["ViewUserprofile"] = "VIEW_USERPROFILE";
    Scope["WebhookDelete"] = "WEBHOOK_DELETE";
    Scope["WebhookRead"] = "WEBHOOK_READ";
    Scope["WebhookWrite"] = "WEBHOOK_WRITE";
    Scope["WorkflowDelete"] = "WORKFLOW_DELETE";
    Scope["WorkflowPropertyDelete"] = "WORKFLOW_PROPERTY_DELETE";
    Scope["WorkflowPropertyRead"] = "WORKFLOW_PROPERTY_READ";
    Scope["WorkflowPropertyWrite"] = "WORKFLOW_PROPERTY_WRITE";
    Scope["WorkflowRead"] = "WORKFLOW_READ";
    Scope["WorkflowSchemeDelete"] = "WORKFLOW_SCHEME_DELETE";
    Scope["WorkflowSchemeRead"] = "WORKFLOW_SCHEME_READ";
    Scope["WorkflowSchemeWrite"] = "WORKFLOW_SCHEME_WRITE";
    Scope["WorkflowWrite"] = "WORKFLOW_WRITE";
    Scope["WriteCompassComponent"] = "WRITE_COMPASS_COMPONENT";
    Scope["WriteCompassEvent"] = "WRITE_COMPASS_EVENT";
    Scope["WriteCompassMetric"] = "WRITE_COMPASS_METRIC";
    Scope["WriteCompassScorecard"] = "WRITE_COMPASS_SCORECARD";
    Scope["WriteConfluenceAttachment"] = "WRITE_CONFLUENCE_ATTACHMENT";
    Scope["WriteConfluenceAuditLog"] = "WRITE_CONFLUENCE_AUDIT_LOG";
    Scope["WriteConfluenceBlogpost"] = "WRITE_CONFLUENCE_BLOGPOST";
    Scope["WriteConfluenceComment"] = "WRITE_CONFLUENCE_COMMENT";
    Scope["WriteConfluenceConfiguration"] = "WRITE_CONFLUENCE_CONFIGURATION";
    Scope["WriteConfluenceContentProperty"] = "WRITE_CONFLUENCE_CONTENT_PROPERTY";
    Scope["WriteConfluenceContentRestriction"] = "WRITE_CONFLUENCE_CONTENT_RESTRICTION";
    Scope["WriteConfluenceCustomContent"] = "WRITE_CONFLUENCE_CUSTOM_CONTENT";
    Scope["WriteConfluenceGroup"] = "WRITE_CONFLUENCE_GROUP";
    Scope["WriteConfluenceInlineTask"] = "WRITE_CONFLUENCE_INLINE_TASK";
    Scope["WriteConfluenceLabel"] = "WRITE_CONFLUENCE_LABEL";
    Scope["WriteConfluencePage"] = "WRITE_CONFLUENCE_PAGE";
    Scope["WriteConfluenceRelation"] = "WRITE_CONFLUENCE_RELATION";
    Scope["WriteConfluenceSpace"] = "WRITE_CONFLUENCE_SPACE";
    Scope["WriteConfluenceSpacePermission"] = "WRITE_CONFLUENCE_SPACE_PERMISSION";
    Scope["WriteConfluenceSpaceProperty"] = "WRITE_CONFLUENCE_SPACE_PROPERTY";
    Scope["WriteConfluenceSpaceSetting"] = "WRITE_CONFLUENCE_SPACE_SETTING";
    Scope["WriteConfluenceTemplate"] = "WRITE_CONFLUENCE_TEMPLATE";
    Scope["WriteConfluenceUserProperty"] = "WRITE_CONFLUENCE_USER_PROPERTY";
    Scope["WriteConfluenceWatcher"] = "WRITE_CONFLUENCE_WATCHER";
    Scope["WriteContainer"] = "WRITE_CONTAINER";
    Scope["WriteCustomer"] = "WRITE_CUSTOMER";
    Scope["WriteDesign"] = "WRITE_DESIGN";
    Scope["WriteJiraWork"] = "WRITE_JIRA_WORK";
    Scope["WriteJswBoardScope"] = "WRITE_JSW_BOARD_SCOPE";
    Scope["WriteJswBoardScopeAdmin"] = "WRITE_JSW_BOARD_SCOPE_ADMIN";
    Scope["WriteJswBuild"] = "WRITE_JSW_BUILD";
    Scope["WriteJswDeployment"] = "WRITE_JSW_DEPLOYMENT";
    Scope["WriteJswEpic"] = "WRITE_JSW_EPIC";
    Scope["WriteJswFeatureFlag"] = "WRITE_JSW_FEATURE_FLAG";
    Scope["WriteJswIssue"] = "WRITE_JSW_ISSUE";
    Scope["WriteJswRemoteLink"] = "WRITE_JSW_REMOTE_LINK";
    Scope["WriteJswSourceCode"] = "WRITE_JSW_SOURCE_CODE";
    Scope["WriteJswSprint"] = "WRITE_JSW_SPRINT";
    Scope["WriteMercury"] = "WRITE_MERCURY";
    Scope["WriteNotifications"] = "WRITE_NOTIFICATIONS";
    Scope["WriteOrganization"] = "WRITE_ORGANIZATION";
    Scope["WriteOrganizationProperty"] = "WRITE_ORGANIZATION_PROPERTY";
    Scope["WriteOrganizationUser"] = "WRITE_ORGANIZATION_USER";
    Scope["WriteRequest"] = "WRITE_REQUEST";
    Scope["WriteRequesttype"] = "WRITE_REQUESTTYPE";
    Scope["WriteRequesttypeProperty"] = "WRITE_REQUESTTYPE_PROPERTY";
    Scope["WriteRequestApproval"] = "WRITE_REQUEST_APPROVAL";
    Scope["WriteRequestAttachment"] = "WRITE_REQUEST_ATTACHMENT";
    Scope["WriteRequestComment"] = "WRITE_REQUEST_COMMENT";
    Scope["WriteRequestFeedback"] = "WRITE_REQUEST_FEEDBACK";
    Scope["WriteRequestNotification"] = "WRITE_REQUEST_NOTIFICATION";
    Scope["WriteRequestParticipant"] = "WRITE_REQUEST_PARTICIPANT";
    Scope["WriteRequestStatus"] = "WRITE_REQUEST_STATUS";
    Scope["WriteServicedesk"] = "WRITE_SERVICEDESK";
    Scope["WriteServicedeskCustomer"] = "WRITE_SERVICEDESK_CUSTOMER";
    Scope["WriteServicedeskOrganization"] = "WRITE_SERVICEDESK_ORGANIZATION";
    Scope["WriteServicedeskProperty"] = "WRITE_SERVICEDESK_PROPERTY";
    Scope["WriteServicedeskRequest"] = "WRITE_SERVICEDESK_REQUEST";
    Scope["WriteTownsquareGoal"] = "WRITE_TOWNSQUARE_GOAL";
    Scope["WriteTownsquareProject"] = "WRITE_TOWNSQUARE_PROJECT";
    Scope["WriteTownsquareRelationship"] = "WRITE_TOWNSQUARE_RELATIONSHIP";
    return Scope;
}({}); /** The AB test context that can be associated to a specific principal/scope. */  /** Metadata on any analytics related fields, these do not affect the search */ 
let $78ad46e0d6808149$export$58320bdd6b26937a = /*#__PURE__*/ function(SearchBoardProductType) {
    SearchBoardProductType["Business"] = "BUSINESS";
    SearchBoardProductType["Software"] = "SOFTWARE";
    return SearchBoardProductType;
}({});
let $78ad46e0d6808149$export$75fb70288e44d634 = /*#__PURE__*/ function(SearchConfluenceDocumentStatus) {
    SearchConfluenceDocumentStatus["Archived"] = "ARCHIVED";
    SearchConfluenceDocumentStatus["Current"] = "CURRENT";
    SearchConfluenceDocumentStatus["Draft"] = "DRAFT";
    return SearchConfluenceDocumentStatus;
}({}); /**
 * Add only product specific properties below. Generic properties must be in the SearchResult
 *
 * CONFLUENCE
 */ 
let $78ad46e0d6808149$export$641731d7c91b88de = /*#__PURE__*/ function(SearchConfluenceRangeField) {
    SearchConfluenceRangeField["Created"] = "CREATED";
    SearchConfluenceRangeField["Lastmodified"] = "LASTMODIFIED";
    return SearchConfluenceRangeField;
}({});
let $78ad46e0d6808149$export$3646d7b76c420c42 = /*#__PURE__*/ function(SearchContainerStatus) {
    SearchContainerStatus["Archived"] = "ARCHIVED";
    SearchContainerStatus["Current"] = "CURRENT";
    return SearchContainerStatus;
}({}); /** Context for the search experiment */  /** Filters to apply to a search */ 
let $78ad46e0d6808149$export$981cf94add4585a6 = /*#__PURE__*/ function(SearchIssueStatusCategory) {
    SearchIssueStatusCategory["Done"] = "DONE";
    SearchIssueStatusCategory["Open"] = "OPEN";
    return SearchIssueStatusCategory;
}({}); /** L2 Feature Provider */ 
let $78ad46e0d6808149$export$395d337d64b9f57f = /*#__PURE__*/ function(SearchProjectType) {
    SearchProjectType["Business"] = "business";
    SearchProjectType["ProductDiscovery"] = "product_discovery";
    SearchProjectType["ServiceDesk"] = "service_desk";
    SearchProjectType["Software"] = "software";
    return SearchProjectType;
}({}); /** Entry point for all searches */  /** Entry point for all searches */  /** Entry point for all searches */  /** Filters to apply to recent query */  /** Search Result type */  /** Atlas */  /** Bitbucket */  /** Compass */  /** Google */  /** TeamworkGraph type search results */  /** Jira */  /** Jira */  /** Microsoft Document */  /** Slack */  /** Trello */ 
let $78ad46e0d6808149$export$95cacd63dfd98bee = /*#__PURE__*/ function(SearchResultType) {
    SearchResultType["Attachment"] = "attachment";
    SearchResultType["Blogpost"] = "blogpost";
    SearchResultType["Board"] = "board";
    SearchResultType["Comment"] = "comment";
    SearchResultType["Component"] = "component";
    SearchResultType["Dashboard"] = "dashboard";
    SearchResultType["Database"] = "database";
    SearchResultType["Document"] = "document";
    SearchResultType["Embed"] = "embed";
    SearchResultType["Filter"] = "filter";
    SearchResultType["Folder"] = "folder";
    SearchResultType["Goal"] = "goal";
    SearchResultType["Issue"] = "issue";
    SearchResultType["Learning"] = "learning";
    SearchResultType["Message"] = "message";
    SearchResultType["Page"] = "page";
    SearchResultType["Plan"] = "plan";
    SearchResultType["Presentation"] = "presentation";
    SearchResultType["Project"] = "project";
    SearchResultType["Question"] = "question";
    SearchResultType["Repository"] = "repository";
    SearchResultType["Space"] = "space";
    SearchResultType["Spreadsheet"] = "spreadsheet";
    SearchResultType["Tag"] = "tag";
    SearchResultType["Unrecognised"] = "unrecognised";
    SearchResultType["Whiteboard"] = "whiteboard";
    return SearchResultType;
}({}); /** Fields used to sort the query */  /** SearchSortOrder describes the sorting order of the query. */ 
let $78ad46e0d6808149$export$3cf9b6ba26bc95c6 = /*#__PURE__*/ function(SearchSortOrder) {
    SearchSortOrder["Asc"] = "ASC";
    SearchSortOrder["Desc"] = "DESC";
    return SearchSortOrder;
}({});
let $78ad46e0d6808149$export$1eed0ec46c1a7935 = /*#__PURE__*/ function(SearchThirdPartyRangeField) {
    SearchThirdPartyRangeField["Created"] = "CREATED";
    SearchThirdPartyRangeField["Lastmodified"] = "LASTMODIFIED";
    return SearchThirdPartyRangeField;
}({}); /** Generic implementation of MutationResponse for responses that don't need any extra data */  /** Generic implementation of MutationResponse for responses that don't need any extra data */  /** Estimation Mutation */  /** Swimlane Mutations */  /** The kind of action that was performed and caused or contributed to an alert */ 
let $78ad46e0d6808149$export$34f9eb005ab98ff7 = /*#__PURE__*/ function(ShepherdActionType) {
    ShepherdActionType["Activate"] = "ACTIVATE";
    ShepherdActionType["Archive"] = "ARCHIVE";
    ShepherdActionType["Crawl"] = "CRAWL";
    ShepherdActionType["Create"] = "CREATE";
    ShepherdActionType["Deactivate"] = "DEACTIVATE";
    ShepherdActionType["Delete"] = "DELETE";
    ShepherdActionType["Download"] = "DOWNLOAD";
    ShepherdActionType["Export"] = "EXPORT";
    ShepherdActionType["Grant"] = "GRANT";
    ShepherdActionType["Install"] = "INSTALL";
    ShepherdActionType["Login"] = "LOGIN";
    ShepherdActionType["LoginAs"] = "LOGIN_AS";
    ShepherdActionType["Publish"] = "PUBLISH";
    ShepherdActionType["Read"] = "READ";
    ShepherdActionType["Revoke"] = "REVOKE";
    ShepherdActionType["Search"] = "SEARCH";
    ShepherdActionType["Uninstall"] = "UNINSTALL";
    ShepherdActionType["Update"] = "UPDATE";
    return ShepherdActionType;
}({}); /** Represents the pertinent fields of specific events (from the Audit Log, for example) matching given search criteria. */  /** ShepherdActivityHighlight captures a pointer to some user activity that is relevant for an alert. */  /** Contextual information about the activity that originated the alert. */  /** Single data point about distribution of numerical data related to the activity */  /** Represents an actor in the Shepherd system. */  /** Represents an actor in the Shepherd system. */ 
let $78ad46e0d6808149$export$54f03cbb2a3e778f = /*#__PURE__*/ function(ShepherdActorOrgStatus) {
    ShepherdActorOrgStatus["Active"] = "ACTIVE";
    ShepherdActorOrgStatus["Deactivated"] = "DEACTIVATED";
    ShepherdActorOrgStatus["Suspended"] = "SUSPENDED";
    return ShepherdActorOrgStatus;
}({}); /** Represents access to a product for an actor in the Shepherd system. */  /** #### Types: Alert ##### */ 
let $78ad46e0d6808149$export$467ce4c000663710 = /*#__PURE__*/ function(ShepherdAlertAction) {
    ShepherdAlertAction["AddLabel"] = "ADD_LABEL";
    ShepherdAlertAction["Redact"] = "REDACT";
    ShepherdAlertAction["Restrict"] = "RESTRICT";
    ShepherdAlertAction["UpdateDataClassification"] = "UPDATE_DATA_CLASSIFICATION";
    return ShepherdAlertAction;
}({});
let $78ad46e0d6808149$export$ec1710c62a266610 = /*#__PURE__*/ function(ShepherdAlertDetectionCategory) {
    ShepherdAlertDetectionCategory["Data"] = "DATA";
    ShepherdAlertDetectionCategory["Threat"] = "THREAT";
    return ShepherdAlertDetectionCategory;
}({}); /** Represents metadata that adds context to the alert */ 
let $78ad46e0d6808149$export$48343fd5997afd49 = /*#__PURE__*/ function(ShepherdAlertStatus) {
    ShepherdAlertStatus["InProgress"] = "IN_PROGRESS";
    ShepherdAlertStatus["Triaged"] = "TRIAGED";
    ShepherdAlertStatus["TriagedExpectedActivity"] = "TRIAGED_EXPECTED_ACTIVITY";
    ShepherdAlertStatus["TriagedTruePositive"] = "TRIAGED_TRUE_POSITIVE";
    ShepherdAlertStatus["Untriaged"] = "UNTRIAGED";
    return ShepherdAlertStatus;
}({}); /**
 * Contains supporting information useful for evaluating an alert.
 * Today it attaches the concept of a "highlight" to alerts. It can be extended to hold additional highlights or
 * other types of information.
 */ 
let $78ad46e0d6808149$export$78b33ffe8847c025 = /*#__PURE__*/ function(ShepherdAlertTemplateType) {
    ShepherdAlertTemplateType["AddedConfluenceGlobalPermission"] = "ADDED_CONFLUENCE_GLOBAL_PERMISSION";
    ShepherdAlertTemplateType["AddedConfluenceSpacePermission"] = "ADDED_CONFLUENCE_SPACE_PERMISSION";
    ShepherdAlertTemplateType["AddedDomain"] = "ADDED_DOMAIN";
    ShepherdAlertTemplateType["AddedJiraGlobalPermission"] = "ADDED_JIRA_GLOBAL_PERMISSION";
    ShepherdAlertTemplateType["AddedOrgadmin"] = "ADDED_ORGADMIN";
    ShepherdAlertTemplateType["BitbucketRepositoryPrivacy"] = "BITBUCKET_REPOSITORY_PRIVACY";
    ShepherdAlertTemplateType["BitbucketWorkspacePrivacy"] = "BITBUCKET_WORKSPACE_PRIVACY";
    ShepherdAlertTemplateType["ClassificationLevelArchived"] = "CLASSIFICATION_LEVEL_ARCHIVED";
    ShepherdAlertTemplateType["ClassificationLevelPublished"] = "CLASSIFICATION_LEVEL_PUBLISHED";
    ShepherdAlertTemplateType["ConfluenceCustomDetection"] = "CONFLUENCE_CUSTOM_DETECTION";
    ShepherdAlertTemplateType["ConfluenceDataDiscovery"] = "CONFLUENCE_DATA_DISCOVERY";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryAtlassianToken"] = "CONFLUENCE_DATA_DISCOVERY_ATLASSIAN_TOKEN";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryAuTfn"] = "CONFLUENCE_DATA_DISCOVERY_AU_TFN";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryAwsKeys"] = "CONFLUENCE_DATA_DISCOVERY_AWS_KEYS";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryCreditCard"] = "CONFLUENCE_DATA_DISCOVERY_CREDIT_CARD";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryCrypto"] = "CONFLUENCE_DATA_DISCOVERY_CRYPTO";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryIban"] = "CONFLUENCE_DATA_DISCOVERY_IBAN";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryJwtKey"] = "CONFLUENCE_DATA_DISCOVERY_JWT_KEY";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryPassword"] = "CONFLUENCE_DATA_DISCOVERY_PASSWORD";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryPrivateKey"] = "CONFLUENCE_DATA_DISCOVERY_PRIVATE_KEY";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryUsSsn"] = "CONFLUENCE_DATA_DISCOVERY_US_SSN";
    ShepherdAlertTemplateType["ConfluencePageCrawling"] = "CONFLUENCE_PAGE_CRAWLING";
    ShepherdAlertTemplateType["ConfluencePageExports"] = "CONFLUENCE_PAGE_EXPORTS";
    ShepherdAlertTemplateType["ConfluenceSiteBackupDownloaded"] = "CONFLUENCE_SITE_BACKUP_DOWNLOADED";
    ShepherdAlertTemplateType["ConfluenceSpaceExports"] = "CONFLUENCE_SPACE_EXPORTS";
    ShepherdAlertTemplateType["ConfluenceSuspiciousSearch"] = "CONFLUENCE_SUSPICIOUS_SEARCH";
    ShepherdAlertTemplateType["CreatedAuthPolicy"] = "CREATED_AUTH_POLICY";
    ShepherdAlertTemplateType["CreatedPolicy"] = "CREATED_POLICY";
    ShepherdAlertTemplateType["CreatedSamlConfig"] = "CREATED_SAML_CONFIG";
    ShepherdAlertTemplateType["CreatedTunnel"] = "CREATED_TUNNEL";
    ShepherdAlertTemplateType["CreatedUserProvisioning"] = "CREATED_USER_PROVISIONING";
    ShepherdAlertTemplateType["DataSecurityPolicyActivated"] = "DATA_SECURITY_POLICY_ACTIVATED";
    ShepherdAlertTemplateType["DataSecurityPolicyDeactivated"] = "DATA_SECURITY_POLICY_DEACTIVATED";
    ShepherdAlertTemplateType["DataSecurityPolicyDeleted"] = "DATA_SECURITY_POLICY_DELETED";
    ShepherdAlertTemplateType["DataSecurityPolicyUpdated"] = "DATA_SECURITY_POLICY_UPDATED";
    ShepherdAlertTemplateType["Default"] = "DEFAULT";
    ShepherdAlertTemplateType["DeletedAuthPolicy"] = "DELETED_AUTH_POLICY";
    ShepherdAlertTemplateType["DeletedDomain"] = "DELETED_DOMAIN";
    ShepherdAlertTemplateType["DeletedPolicy"] = "DELETED_POLICY";
    ShepherdAlertTemplateType["DeletedTunnel"] = "DELETED_TUNNEL";
    ShepherdAlertTemplateType["EcosystemAuditLogInstallationCreated"] = "ECOSYSTEM_AUDIT_LOG_INSTALLATION_CREATED";
    ShepherdAlertTemplateType["EcosystemAuditLogInstallationDeleted"] = "ECOSYSTEM_AUDIT_LOG_INSTALLATION_DELETED";
    ShepherdAlertTemplateType["EcosystemAuditLogUserGrantCreated"] = "ECOSYSTEM_AUDIT_LOG_USER_GRANT_CREATED";
    ShepherdAlertTemplateType["EducationalAlert"] = "EDUCATIONAL_ALERT";
    ShepherdAlertTemplateType["EnableScimSync"] = "ENABLE_SCIM_SYNC";
    ShepherdAlertTemplateType["ExportedOrgeventscsv"] = "EXPORTED_ORGEVENTSCSV";
    ShepherdAlertTemplateType["GrantAssignedJiraPermissionScheme"] = "GRANT_ASSIGNED_JIRA_PERMISSION_SCHEME";
    ShepherdAlertTemplateType["IdentityPasswordResetCompletedUser"] = "IDENTITY_PASSWORD_RESET_COMPLETED_USER";
    ShepherdAlertTemplateType["ImpossibleTravel"] = "IMPOSSIBLE_TRAVEL";
    ShepherdAlertTemplateType["InitiatedGsyncConnection"] = "INITIATED_GSYNC_CONNECTION";
    ShepherdAlertTemplateType["JiraCustomDetection"] = "JIRA_CUSTOM_DETECTION";
    ShepherdAlertTemplateType["JiraDataDiscoveryAtlassianToken"] = "JIRA_DATA_DISCOVERY_ATLASSIAN_TOKEN";
    ShepherdAlertTemplateType["JiraDataDiscoveryAuTfn"] = "JIRA_DATA_DISCOVERY_AU_TFN";
    ShepherdAlertTemplateType["JiraDataDiscoveryAwsKeys"] = "JIRA_DATA_DISCOVERY_AWS_KEYS";
    ShepherdAlertTemplateType["JiraDataDiscoveryCreditCard"] = "JIRA_DATA_DISCOVERY_CREDIT_CARD";
    ShepherdAlertTemplateType["JiraDataDiscoveryCrypto"] = "JIRA_DATA_DISCOVERY_CRYPTO";
    ShepherdAlertTemplateType["JiraDataDiscoveryIban"] = "JIRA_DATA_DISCOVERY_IBAN";
    ShepherdAlertTemplateType["JiraDataDiscoveryJwtKey"] = "JIRA_DATA_DISCOVERY_JWT_KEY";
    ShepherdAlertTemplateType["JiraDataDiscoveryPassword"] = "JIRA_DATA_DISCOVERY_PASSWORD";
    ShepherdAlertTemplateType["JiraDataDiscoveryPrivateKey"] = "JIRA_DATA_DISCOVERY_PRIVATE_KEY";
    ShepherdAlertTemplateType["JiraDataDiscoveryUsSsn"] = "JIRA_DATA_DISCOVERY_US_SSN";
    ShepherdAlertTemplateType["JiraIssueCrawling"] = "JIRA_ISSUE_CRAWLING";
    ShepherdAlertTemplateType["LoginFromMaliciousIpAddress"] = "LOGIN_FROM_MALICIOUS_IP_ADDRESS";
    ShepherdAlertTemplateType["LoginFromTorExitNode"] = "LOGIN_FROM_TOR_EXIT_NODE";
    ShepherdAlertTemplateType["OrgLoggedInAsUser"] = "ORG_LOGGED_IN_AS_USER";
    ShepherdAlertTemplateType["ProjectClassificationLevelDecreased"] = "PROJECT_CLASSIFICATION_LEVEL_DECREASED";
    ShepherdAlertTemplateType["ProjectClassificationLevelIncreased"] = "PROJECT_CLASSIFICATION_LEVEL_INCREASED";
    ShepherdAlertTemplateType["RotateScimDirectoryToken"] = "ROTATE_SCIM_DIRECTORY_TOKEN";
    ShepherdAlertTemplateType["SpaceClassificationLevelDecreased"] = "SPACE_CLASSIFICATION_LEVEL_DECREASED";
    ShepherdAlertTemplateType["SpaceClassificationLevelIncreased"] = "SPACE_CLASSIFICATION_LEVEL_INCREASED";
    ShepherdAlertTemplateType["TestAlert"] = "TEST_ALERT";
    ShepherdAlertTemplateType["TokenCreated"] = "TOKEN_CREATED";
    ShepherdAlertTemplateType["TokenRevoked"] = "TOKEN_REVOKED";
    ShepherdAlertTemplateType["UpdatedAuthPolicy"] = "UPDATED_AUTH_POLICY";
    ShepherdAlertTemplateType["UpdatedPolicy"] = "UPDATED_POLICY";
    ShepherdAlertTemplateType["UpdatedSamlConfig"] = "UPDATED_SAML_CONFIG";
    ShepherdAlertTemplateType["UserAddedToBeacon"] = "USER_ADDED_TO_BEACON";
    ShepherdAlertTemplateType["UserGrantedRole"] = "USER_GRANTED_ROLE";
    ShepherdAlertTemplateType["UserRemovedFromBeacon"] = "USER_REMOVED_FROM_BEACON";
    ShepherdAlertTemplateType["UserRevokedRole"] = "USER_REVOKED_ROLE";
    ShepherdAlertTemplateType["VerifiedDomainVerification"] = "VERIFIED_DOMAIN_VERIFICATION";
    return ShepherdAlertTemplateType;
}({}); /** Placeholder type to enable eventually adding pagination via the relay connection pattern (https://relay.dev/graphql/connections.htm). */  /** #### Types: Query Results ##### */ 
let $78ad46e0d6808149$export$9dd0637f1b429aee = /*#__PURE__*/ function(ShepherdAtlassianProduct) {
    ShepherdAtlassianProduct["AdminHub"] = "ADMIN_HUB";
    ShepherdAtlassianProduct["Bitbucket"] = "BITBUCKET";
    ShepherdAtlassianProduct["Confluence"] = "CONFLUENCE";
    ShepherdAtlassianProduct["GuardDetect"] = "GUARD_DETECT";
    ShepherdAtlassianProduct["JiraSoftware"] = "JIRA_SOFTWARE";
    ShepherdAtlassianProduct["Marketplace"] = "MARKETPLACE";
    return ShepherdAtlassianProduct;
}({}); /** Represent metadata for the alert grouped by category */ 
let $78ad46e0d6808149$export$4ee416f20f5a941a = /*#__PURE__*/ function(ShepherdClassificationLevelColor) {
    ShepherdClassificationLevelColor["Blue"] = "BLUE";
    ShepherdClassificationLevelColor["BlueBold"] = "BLUE_BOLD";
    ShepherdClassificationLevelColor["Green"] = "GREEN";
    ShepherdClassificationLevelColor["Grey"] = "GREY";
    ShepherdClassificationLevelColor["Lime"] = "LIME";
    ShepherdClassificationLevelColor["Navy"] = "NAVY";
    ShepherdClassificationLevelColor["None"] = "NONE";
    ShepherdClassificationLevelColor["Orange"] = "ORANGE";
    ShepherdClassificationLevelColor["Purple"] = "PURPLE";
    ShepherdClassificationLevelColor["Red"] = "RED";
    ShepherdClassificationLevelColor["RedBold"] = "RED_BOLD";
    ShepherdClassificationLevelColor["Teal"] = "TEAL";
    ShepherdClassificationLevelColor["Yellow"] = "YELLOW";
    return ShepherdClassificationLevelColor;
}({});
let $78ad46e0d6808149$export$dddaf5557f82edf7 = /*#__PURE__*/ function(ShepherdClassificationStatus) {
    ShepherdClassificationStatus["Archived"] = "ARCHIVED";
    ShepherdClassificationStatus["Draft"] = "DRAFT";
    ShepherdClassificationStatus["Published"] = "PUBLISHED";
    return ShepherdClassificationStatus;
}({}); /** ##### Input ###### */  /** #### Payload ##### */  /** Represents the current user in the Shepherd system. */  /** Configuration for a custom content scanning detection. A list of rules that will be matched against content. */  /** A user created detection. Currently only custom content scanning is supported. */ 
let $78ad46e0d6808149$export$f961d21a5cd3eed7 = /*#__PURE__*/ function(ShepherdCustomScanningMatchType) {
    ShepherdCustomScanningMatchType["Regex"] = "REGEX";
    ShepherdCustomScanningMatchType["String"] = "STRING";
    ShepherdCustomScanningMatchType["Word"] = "WORD";
    return ShepherdCustomScanningMatchType;
}({}); /** GraphQL doesn't allow unions in input types so this is to allow for different rule types in the future. */  /** A rule to match against content. Contains a term an whether it's a string match or word match. */  /** Input type for a rule to match against content. Contains a term an whether it's a string match or word match. */  /** This would represent a detection in beacon, each detection possibly containing a set of settings */  /** Represents an individual exclusion. */  /** Setting that contains exclusion configuration so that a detection can filter out unwanted alerts for customers. */  /** An individual resource exclusion */ 
let $78ad46e0d6808149$export$db4af14fade5e4e5 = /*#__PURE__*/ function(ShepherdDetectionScanningFrequency) {
    ShepherdDetectionScanningFrequency["RealTime"] = "REAL_TIME";
    ShepherdDetectionScanningFrequency["Scheduled"] = "SCHEDULED";
    return ShepherdDetectionScanningFrequency;
}({}); /** Describes the data the setting can hold. */  /** Represents specific metadata that adds context to DSP list changes */  /** A highlight contains contextual information produced by the detection that created the alert. */  /**
 * A highlight contains contextual information produced by the detection that created the alert.
 * One field is required and only one can be informed at a time.
 */ 
let $78ad46e0d6808149$export$2f9e73ea31c391f3 = /*#__PURE__*/ function(ShepherdLoginDeviceType) {
    ShepherdLoginDeviceType["Computer"] = "COMPUTER";
    ShepherdLoginDeviceType["Console"] = "CONSOLE";
    ShepherdLoginDeviceType["Embedded"] = "EMBEDDED";
    ShepherdLoginDeviceType["Mobile"] = "MOBILE";
    ShepherdLoginDeviceType["SmartTv"] = "SMART_TV";
    ShepherdLoginDeviceType["Tablet"] = "TABLET";
    ShepherdLoginDeviceType["Wearable"] = "WEARABLE";
    return ShepherdLoginDeviceType;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** #### Types: Mutation ##### */ 
let $78ad46e0d6808149$export$c8dd2e548b70194f = /*#__PURE__*/ function(ShepherdMutationErrorType) {
    ShepherdMutationErrorType["BadRequest"] = "BAD_REQUEST";
    ShepherdMutationErrorType["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    ShepherdMutationErrorType["NoProductAccess"] = "NO_PRODUCT_ACCESS";
    ShepherdMutationErrorType["Unauthorized"] = "UNAUTHORIZED";
    return ShepherdMutationErrorType;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** #### Types: Query ##### */ 
let $78ad46e0d6808149$export$60854452710d481b = /*#__PURE__*/ function(ShepherdQueryErrorType) {
    ShepherdQueryErrorType["BadRequest"] = "BAD_REQUEST";
    ShepherdQueryErrorType["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    ShepherdQueryErrorType["NoProductAccess"] = "NO_PRODUCT_ACCESS";
    ShepherdQueryErrorType["Unauthorized"] = "UNAUTHORIZED";
    return ShepherdQueryErrorType;
}({}); /** A rate type detection has 3 modes, LOW will produce the most alerts, HIGH will product the least alerts */ 
let $78ad46e0d6808149$export$359aa80f049e8938 = /*#__PURE__*/ function(ShepherdRateThresholdValue) {
    ShepherdRateThresholdValue["High"] = "HIGH";
    ShepherdRateThresholdValue["Low"] = "LOW";
    ShepherdRateThresholdValue["Medium"] = "MEDIUM";
    return ShepherdRateThresholdValue;
}({});
let $78ad46e0d6808149$export$8bcebd025de2c46b = /*#__PURE__*/ function(ShepherdRemediationActionType) {
    ShepherdRemediationActionType["AnonAccessDspRemediation"] = "ANON_ACCESS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ApplyClassificationRemediation"] = "APPLY_CLASSIFICATION_REMEDIATION";
    ShepherdRemediationActionType["AppsAccessDspRemediation"] = "APPS_ACCESS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ArchiveRestoreClassificationRemediation"] = "ARCHIVE_RESTORE_CLASSIFICATION_REMEDIATION";
    ShepherdRemediationActionType["BlockchainExplorerRemediation"] = "BLOCKCHAIN_EXPLORER_REMEDIATION";
    ShepherdRemediationActionType["BlockIpAllowlistRemediation"] = "BLOCK_IP_ALLOWLIST_REMEDIATION";
    ShepherdRemediationActionType["ClassificationLevelChangeRemediation"] = "CLASSIFICATION_LEVEL_CHANGE_REMEDIATION";
    ShepherdRemediationActionType["ConfluenceAnonAccessRemediation"] = "CONFLUENCE_ANON_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["DeleteDataRemediation"] = "DELETE_DATA_REMEDIATION";
    ShepherdRemediationActionType["DeleteFilesRemediation"] = "DELETE_FILES_REMEDIATION";
    ShepherdRemediationActionType["EditCustomDetectionRemediation"] = "EDIT_CUSTOM_DETECTION_REMEDIATION";
    ShepherdRemediationActionType["ExcludePageRemediation"] = "EXCLUDE_PAGE_REMEDIATION";
    ShepherdRemediationActionType["ExcludeUserRemediation"] = "EXCLUDE_USER_REMEDIATION";
    ShepherdRemediationActionType["ExportsDspRemediation"] = "EXPORTS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ExportDspRemediation"] = "EXPORT_DSP_REMEDIATION";
    ShepherdRemediationActionType["ExportSpacePermissionsRemediation"] = "EXPORT_SPACE_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["JiraGlobalPermissionsRemediation"] = "JIRA_GLOBAL_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["KeyOwnerRemediation"] = "KEY_OWNER_REMEDIATION";
    ShepherdRemediationActionType["LimitJiraPermissionsRemediation"] = "LIMIT_JIRA_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["ManageAppsRemediation"] = "MANAGE_APPS_REMEDIATION";
    ShepherdRemediationActionType["ManageDomainRemediation"] = "MANAGE_DOMAIN_REMEDIATION";
    ShepherdRemediationActionType["ManageDspRemediation"] = "MANAGE_DSP_REMEDIATION";
    ShepherdRemediationActionType["PublicAccessDspRemediation"] = "PUBLIC_ACCESS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ResetAccountPasswordRemediation"] = "RESET_ACCOUNT_PASSWORD_REMEDIATION";
    ShepherdRemediationActionType["RestoreAccessRemediation"] = "RESTORE_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["ReviewAccessRemediation"] = "REVIEW_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["ReviewApiKeysRemediation"] = "REVIEW_API_KEYS_REMEDIATION";
    ShepherdRemediationActionType["ReviewApiTokensRemediation"] = "REVIEW_API_TOKENS_REMEDIATION";
    ShepherdRemediationActionType["ReviewAuditLogRemediation"] = "REVIEW_AUDIT_LOG_REMEDIATION";
    ShepherdRemediationActionType["ReviewAuthPolicyRemediation"] = "REVIEW_AUTH_POLICY_REMEDIATION";
    ShepherdRemediationActionType["ReviewGsyncRemediation"] = "REVIEW_GSYNC_REMEDIATION";
    ShepherdRemediationActionType["ReviewIpAllowlistRemediation"] = "REVIEW_IP_ALLOWLIST_REMEDIATION";
    ShepherdRemediationActionType["ReviewIssueRemediation"] = "REVIEW_ISSUE_REMEDIATION";
    ShepherdRemediationActionType["ReviewOtherAuthPoliciesRemediation"] = "REVIEW_OTHER_AUTH_POLICIES_REMEDIATION";
    ShepherdRemediationActionType["ReviewOtherIpAllowlistRemediation"] = "REVIEW_OTHER_IP_ALLOWLIST_REMEDIATION";
    ShepherdRemediationActionType["ReviewPageRemediation"] = "REVIEW_PAGE_REMEDIATION";
    ShepherdRemediationActionType["ReviewSamlRemediation"] = "REVIEW_SAML_REMEDIATION";
    ShepherdRemediationActionType["ReviewScimRemediation"] = "REVIEW_SCIM_REMEDIATION";
    ShepherdRemediationActionType["ReviewTunnelsConfigurationRemediation"] = "REVIEW_TUNNELS_CONFIGURATION_REMEDIATION";
    ShepherdRemediationActionType["ReviewTunnelsRemediation"] = "REVIEW_TUNNELS_REMEDIATION";
    ShepherdRemediationActionType["RevokeAccessRemediation"] = "REVOKE_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["RevokeApiKeyRemediation"] = "REVOKE_API_KEY_REMEDIATION";
    ShepherdRemediationActionType["RevokeApiTokensRemediation"] = "REVOKE_API_TOKENS_REMEDIATION";
    ShepherdRemediationActionType["SpacePermissionsRemediation"] = "SPACE_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["SuspendActorRemediation"] = "SUSPEND_ACTOR_REMEDIATION";
    ShepherdRemediationActionType["SuspendSubjectRemediation"] = "SUSPEND_SUBJECT_REMEDIATION";
    ShepherdRemediationActionType["TurnOffJiraPermissionsRemediation"] = "TURN_OFF_JIRA_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["TwoStepPolicyRemediation"] = "TWO_STEP_POLICY_REMEDIATION";
    ShepherdRemediationActionType["ViewSpacePermissionsRemediation"] = "VIEW_SPACE_PERMISSIONS_REMEDIATION";
    return ShepherdRemediationActionType;
}({}); /** Represents a resource that was acted upon at a specific time */ 
let $78ad46e0d6808149$export$e0c4be2f8b0999ce = /*#__PURE__*/ function(ShepherdSearchOrigin) {
    ShepherdSearchOrigin["AdvancedSearch"] = "ADVANCED_SEARCH";
    ShepherdSearchOrigin["Ai"] = "AI";
    ShepherdSearchOrigin["QuickSearch"] = "QUICK_SEARCH";
    return ShepherdSearchOrigin;
}({}); /** Provides all necessary metadata about a search query */  /** Represents a slack subscription in the Shepherd system. */  /** The resource was acted on */  /** The resource was acted on */  /** Common interface for all subscriptions. */  /**
 * Use a type instead of an interface.
 *
 * "Edge type must be an Object type."
 * See: https://github.com/B2o5T/graphql-eslint/blob/master/docs/rules/relay-edge-types.md
 */ 
let $78ad46e0d6808149$export$8f5af6e8802c488 = /*#__PURE__*/ function(ShepherdSubscriptionStatus) {
    ShepherdSubscriptionStatus["Active"] = "ACTIVE";
    ShepherdSubscriptionStatus["Inactive"] = "INACTIVE";
    return ShepherdSubscriptionStatus;
}({}); /** Represents a point in time or an interval (when `end` is present) */  /** Time or interval */  /** Represents a user in the Shepherd system. */  /** Represents the possible vortexMode values for a workspace. */ 
let $78ad46e0d6808149$export$80ad4b94a728f2e2 = /*#__PURE__*/ function(ShepherdVortexModeStatus) {
    ShepherdVortexModeStatus["Disabled"] = "DISABLED";
    ShepherdVortexModeStatus["Enabled"] = "ENABLED";
    return ShepherdVortexModeStatus;
}({}); /** Represents type of Webhook payload */ 
let $78ad46e0d6808149$export$cfc31900765a3ba4 = /*#__PURE__*/ function(ShepherdWebhookDestinationType) {
    ShepherdWebhookDestinationType["Default"] = "DEFAULT";
    ShepherdWebhookDestinationType["MicrosoftTeams"] = "MICROSOFT_TEAMS";
    return ShepherdWebhookDestinationType;
}({}); /** Represents a webhook subscription in the Shepherd system. */  /**
 * Represents type of Webhook
 * DEPRECATED: Use destinationType instead.
 */ 
let $78ad46e0d6808149$export$2e013066679d73f8 = /*#__PURE__*/ function(ShepherdWebhookType) {
    ShepherdWebhookType["Custom"] = "CUSTOM";
    ShepherdWebhookType["MicrosoftTeams"] = "MICROSOFT_TEAMS";
    ShepherdWebhookType["Slack"] = "SLACK";
    return ShepherdWebhookType;
}({}); /** Represents a workspace in the Shepherd system. */  /** Represents a workspace in the Shepherd system. */  /** Represents a workspace in the Shepherd system. */  /**
 * Contains the setting value for a detection
 * While we currently only have one detection type (threshold), if we add more in the future there would be more fields
 * on this type, only one of which should be populated at a time.
 */ 
let $78ad46e0d6808149$export$c32ed3061693e3f1 = /*#__PURE__*/ function(SoftwareCardsDestinationEnum) {
    SoftwareCardsDestinationEnum["Backlog"] = "BACKLOG";
    SoftwareCardsDestinationEnum["ExistingSprint"] = "EXISTING_SPRINT";
    SoftwareCardsDestinationEnum["NewSprint"] = "NEW_SPRINT";
    return SoftwareCardsDestinationEnum;
}({}); /** Node for querying any report page's data */  /** The sort direction of the collection */ 
let $78ad46e0d6808149$export$79e2d9500680dd96 = /*#__PURE__*/ function(SortDirection) {
    SortDirection["Asc"] = "ASC";
    SortDirection["Desc"] = "DESC";
    return SortDirection;
}({});
let $78ad46e0d6808149$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["Asc"] = "ASC";
    SortOrder["Desc"] = "DESC";
    return SortOrder;
}({});
let $78ad46e0d6808149$export$88ef8388f421e95e = /*#__PURE__*/ function(SprintReportsEstimationStatisticType) {
    SprintReportsEstimationStatisticType["IssueCount"] = "ISSUE_COUNT";
    SprintReportsEstimationStatisticType["OriginalEstimate"] = "ORIGINAL_ESTIMATE";
    SprintReportsEstimationStatisticType["StoryPoints"] = "STORY_POINTS";
    return SprintReportsEstimationStatisticType;
}({});
let $78ad46e0d6808149$export$f37cb7e02dc42251 = /*#__PURE__*/ function(SprintState) {
    SprintState["Active"] = "ACTIVE";
    SprintState["Closed"] = "CLOSED";
    SprintState["Future"] = "FUTURE";
    return SprintState;
}({}); /** Start sprint */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** Top level wrapper for CSP Support Request queries API */  /** Top level wrapper for CSP Support Request queries API */  /** A comment for the request. These are non-hierarchical comments and are only linked to a single request. */  /** A DateTime type for the request, this contains multiple formats of datetime */  /** Enum that specify the data type of the field. */ 
let $78ad46e0d6808149$export$db58b0fec288f2d5 = /*#__PURE__*/ function(SupportRequestFieldDataType) {
    SupportRequestFieldDataType["Boolean"] = "BOOLEAN";
    SupportRequestFieldDataType["Date"] = "DATE";
    SupportRequestFieldDataType["Number"] = "NUMBER";
    SupportRequestFieldDataType["String"] = "STRING";
    return SupportRequestFieldDataType;
}({}); /** The value of the field. This has been kept as a seperate type for extensibility, such as including icons. */  /** Query parameter for how this user has access to the request, e.g. they were the reporter or added as a participant. */ 
let $78ad46e0d6808149$export$5d395d1469cf6904 = /*#__PURE__*/ function(SupportRequestNamedContactOperation) {
    SupportRequestNamedContactOperation["Add"] = "ADD";
    SupportRequestNamedContactOperation["Remove"] = "REMOVE";
    return SupportRequestNamedContactOperation;
}({}); /** A user (customer or agent) of the support system. */  /** A user (customer or agent) of the support system. */  /** A user (customer or agent) of the support system. */  /** Query parameter for how this user has access to the request, e.g. they were the reporter or added as a participant. */ 
let $78ad46e0d6808149$export$15d04aa1faaca584 = /*#__PURE__*/ function(SupportRequestQueryOwnership) {
    SupportRequestQueryOwnership["Participant"] = "PARTICIPANT";
    SupportRequestQueryOwnership["Reporter"] = "REPORTER";
    return SupportRequestQueryOwnership;
}({}); /** The general category for the status of the ticket. */ 
let $78ad46e0d6808149$export$cf9ba11854f7cb39 = /*#__PURE__*/ function(SupportRequestQueryStatusCategory) {
    SupportRequestQueryStatusCategory["Done"] = "DONE";
    SupportRequestQueryStatusCategory["Open"] = "OPEN";
    return SupportRequestQueryStatusCategory;
}({}); /** The general category for the status of the ticket. */ 
let $78ad46e0d6808149$export$21de27a5998af787 = /*#__PURE__*/ function(SupportRequestStatusCategory) {
    SupportRequestStatusCategory["Done"] = "DONE";
    SupportRequestStatusCategory["InProgress"] = "IN_PROGRESS";
    SupportRequestStatusCategory["Open"] = "OPEN";
    return SupportRequestStatusCategory;
}({}); /** The supported usertype of user in system */ 
let $78ad46e0d6808149$export$4e3e0500b62d4705 = /*#__PURE__*/ function(SupportRequestUserType) {
    SupportRequestUserType["Customer"] = "CUSTOMER";
    SupportRequestUserType["Partner"] = "PARTNER";
    return SupportRequestUserType;
}({}); /** How to group cards on the board into swimlanes */ 
let $78ad46e0d6808149$export$39b890c79449a0 = /*#__PURE__*/ function(SwimlaneStrategy) {
    SwimlaneStrategy["Assignee"] = "ASSIGNEE";
    SwimlaneStrategy["Issuechildren"] = "ISSUECHILDREN";
    SwimlaneStrategy["Issueparent"] = "ISSUEPARENT";
    SwimlaneStrategy["None"] = "NONE";
    return SwimlaneStrategy;
}({}); /** Team returned in a team query */  /** Team returned in a team query */  /** Returns the details of the team member and details about their membership within a team */  /** The connection entity for the members of a team for pagination */  /** The connection entity for the members of a team for pagination */  /** Returns the details of the team member and details about their membership within a team */  /** Member filter used as input on team search filter */  /** The roles that a member can have within a team */ 
let $78ad46e0d6808149$export$6a422ea3acdf9d9b = /*#__PURE__*/ function(TeamMembershipRole) {
    TeamMembershipRole["Admin"] = "ADMIN";
    TeamMembershipRole["Regular"] = "REGULAR";
    return TeamMembershipRole;
}({}); /** The settings which a team can have describing how members are added to the team */ 
let $78ad46e0d6808149$export$93b1c6cf9d16dce6 = /*#__PURE__*/ function(TeamMembershipSettings) {
    TeamMembershipSettings["External"] = "EXTERNAL";
    TeamMembershipSettings["MemberInvite"] = "MEMBER_INVITE";
    TeamMembershipSettings["Open"] = "OPEN";
    return TeamMembershipSettings;
}({}); /** The states that a member can have within a team */ 
let $78ad46e0d6808149$export$f627e98535fb8637 = /*#__PURE__*/ function(TeamMembershipState) {
    TeamMembershipState["Alumni"] = "ALUMNI";
    TeamMembershipState["FullMember"] = "FULL_MEMBER";
    TeamMembershipState["RequestingToJoin"] = "REQUESTING_TO_JOIN";
    return TeamMembershipState;
}({});
let $78ad46e0d6808149$export$76b040ede9e99a0e = /*#__PURE__*/ function(TeamRole) {
    TeamRole["TeamsAdmin"] = "TEAMS_ADMIN";
    TeamRole["TeamsObserver"] = "TEAMS_OBSERVER";
    TeamRole["TeamsUser"] = "TEAMS_USER";
    return TeamRole;
}({}); /** Enum representing the search fields for teams. */ 
let $78ad46e0d6808149$export$3d32048696128045 = /*#__PURE__*/ function(TeamSearchField) {
    TeamSearchField["Description"] = "DESCRIPTION";
    TeamSearchField["Name"] = "NAME";
    return TeamSearchField;
}({}); /** Team filter used as input on team search */  /** Team returned in search */  /** The result of the search for teams. */  /** The result of the search for teams. */  /** An edge from a team search */  /** An edge from a team search */  /** Team returned in search */  /** Team sort used as input on team search */  /** Team sort fields */ 
let $78ad46e0d6808149$export$c701f1c8ac34f3b8 = /*#__PURE__*/ function(TeamSortField) {
    TeamSortField["DisplayName"] = "DISPLAY_NAME";
    TeamSortField["Id"] = "ID";
    TeamSortField["State"] = "STATE";
    return TeamSortField;
}({}); /** Team Sort Order */ 
let $78ad46e0d6808149$export$cecdee868554f386 = /*#__PURE__*/ function(TeamSortOrder) {
    TeamSortOrder["Asc"] = "ASC";
    TeamSortOrder["Desc"] = "DESC";
    return TeamSortOrder;
}({}); /** The states that a team can have */ 
let $78ad46e0d6808149$export$c5c56131401e0716 = /*#__PURE__*/ function(TeamState) {
    TeamState["Active"] = "ACTIVE";
    TeamState["Disbanded"] = "DISBANDED";
    TeamState["Purged"] = "PURGED";
    return TeamState;
}({}); /** The states that a team can have */ 
let $78ad46e0d6808149$export$15fa8968cce33b6 = /*#__PURE__*/ function(TeamStateV2) {
    TeamStateV2["Active"] = "ACTIVE";
    TeamStateV2["Purged"] = "PURGED";
    return TeamStateV2;
}({}); /** Team returned in a team query */  /** Team returned in a team query */  /** The input for a Third Party Repository */  /**
 * This represent a third party user
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */ 
let $78ad46e0d6808149$export$be996b3d78d87257 = /*#__PURE__*/ function(ToolchainAssociateEntitiesErrorCode) {
    ToolchainAssociateEntitiesErrorCode["EntityRejected"] = "ENTITY_REJECTED";
    ToolchainAssociateEntitiesErrorCode["EntityUrlInvalid"] = "ENTITY_URL_INVALID";
    ToolchainAssociateEntitiesErrorCode["ProviderEntityFetchForbidden"] = "PROVIDER_ENTITY_FETCH_FORBIDDEN";
    ToolchainAssociateEntitiesErrorCode["ProviderEntityNotFound"] = "PROVIDER_ENTITY_NOT_FOUND";
    ToolchainAssociateEntitiesErrorCode["ProviderError"] = "PROVIDER_ERROR";
    ToolchainAssociateEntitiesErrorCode["ProviderInputInvalid"] = "PROVIDER_INPUT_INVALID";
    return ToolchainAssociateEntitiesErrorCode;
}({}); /** This is a union of all the consumer schemas supported by the associate container API */  /** This is a union of all the consumer schemas supported by the associate entity API */ 
let $78ad46e0d6808149$export$96ad634185a48695 = /*#__PURE__*/ function(ToolchainCheckAuthErrorCode) {
    ToolchainCheckAuthErrorCode["ProviderError"] = "PROVIDER_ERROR";
    return ToolchainCheckAuthErrorCode;
}({}); /** This is a union of all the auth types supported by the check auth API and query error if check auth is unsuccessful */ 
let $78ad46e0d6808149$export$a675cf96020918d = /*#__PURE__*/ function(ToolchainCreateContainerErrorCode) {
    ToolchainCreateContainerErrorCode["ProviderContainerAlreadyExists"] = "PROVIDER_CONTAINER_ALREADY_EXISTS";
    ToolchainCreateContainerErrorCode["ProviderContainerCreateForbidden"] = "PROVIDER_CONTAINER_CREATE_FORBIDDEN";
    ToolchainCreateContainerErrorCode["ProviderError"] = "PROVIDER_ERROR";
    ToolchainCreateContainerErrorCode["ProviderInputInvalid"] = "PROVIDER_INPUT_INVALID";
    ToolchainCreateContainerErrorCode["ProviderWorkspaceNotFound"] = "PROVIDER_WORKSPACE_NOT_FOUND";
    return ToolchainCreateContainerErrorCode;
}({}); /** Either both `cloudId` and 'providerId', or 'workspaceId' must be specified. */ 
let $78ad46e0d6808149$export$911f961eae9c7bb3 = /*#__PURE__*/ function(ToolchainDisassociateEntitiesErrorCode) {
    ToolchainDisassociateEntitiesErrorCode["UnknownAssociation"] = "UNKNOWN_ASSOCIATION";
    return ToolchainDisassociateEntitiesErrorCode;
}({}); /**
 * Type of a data-depot provider.
 * A provider may belongs to multiple types (e.g an connect-app can send both build and deployment info).
 */ 
let $78ad46e0d6808149$export$a76864a49f160fd1 = /*#__PURE__*/ function(ToolchainProviderType) {
    ToolchainProviderType["Build"] = "BUILD";
    ToolchainProviderType["Deployment"] = "DEPLOYMENT";
    ToolchainProviderType["Design"] = "DESIGN";
    ToolchainProviderType["DevopsComponents"] = "DEVOPS_COMPONENTS";
    ToolchainProviderType["DevInfo"] = "DEV_INFO";
    ToolchainProviderType["Documentation"] = "DOCUMENTATION";
    ToolchainProviderType["FeatureFlag"] = "FEATURE_FLAG";
    ToolchainProviderType["Operations"] = "OPERATIONS";
    ToolchainProviderType["RemoteLinks"] = "REMOTE_LINKS";
    ToolchainProviderType["Security"] = "SECURITY";
    return ToolchainProviderType;
}({});
let $78ad46e0d6808149$export$358b14067bcbe24d = /*#__PURE__*/ function(ToolchainSyncState) {
    ToolchainSyncState["Complete"] = "COMPLETE";
    ToolchainSyncState["Error"] = "ERROR";
    ToolchainSyncState["InProgress"] = "IN_PROGRESS";
    return ToolchainSyncState;
}({});
let $78ad46e0d6808149$export$74b7a9159262d2e = /*#__PURE__*/ function(ToolchainWorkspaceConnectionErrorCode) {
    ToolchainWorkspaceConnectionErrorCode["ProviderActionError"] = "PROVIDER_ACTION_ERROR";
    ToolchainWorkspaceConnectionErrorCode["ProviderNotSupported"] = "PROVIDER_NOT_SUPPORTED";
    return ToolchainWorkspaceConnectionErrorCode;
}({});
let $78ad46e0d6808149$export$e2d891f9dd055fc4 = /*#__PURE__*/ function(TownsquareGoalSortEnum) {
    TownsquareGoalSortEnum["CreationDateAsc"] = "CREATION_DATE_ASC";
    TownsquareGoalSortEnum["CreationDateDesc"] = "CREATION_DATE_DESC";
    TownsquareGoalSortEnum["HierarchyAsc"] = "HIERARCHY_ASC";
    TownsquareGoalSortEnum["HierarchyDesc"] = "HIERARCHY_DESC";
    TownsquareGoalSortEnum["HierarchyLevelAsc"] = "HIERARCHY_LEVEL_ASC";
    TownsquareGoalSortEnum["HierarchyLevelDesc"] = "HIERARCHY_LEVEL_DESC";
    TownsquareGoalSortEnum["IdAsc"] = "ID_ASC";
    TownsquareGoalSortEnum["IdDesc"] = "ID_DESC";
    TownsquareGoalSortEnum["LatestUpdateDateAsc"] = "LATEST_UPDATE_DATE_ASC";
    TownsquareGoalSortEnum["LatestUpdateDateDesc"] = "LATEST_UPDATE_DATE_DESC";
    TownsquareGoalSortEnum["NameAsc"] = "NAME_ASC";
    TownsquareGoalSortEnum["NameDesc"] = "NAME_DESC";
    TownsquareGoalSortEnum["ProjectCountAsc"] = "PROJECT_COUNT_ASC";
    TownsquareGoalSortEnum["ProjectCountDesc"] = "PROJECT_COUNT_DESC";
    TownsquareGoalSortEnum["ScoreAsc"] = "SCORE_ASC";
    TownsquareGoalSortEnum["ScoreDesc"] = "SCORE_DESC";
    TownsquareGoalSortEnum["TargetDateAsc"] = "TARGET_DATE_ASC";
    TownsquareGoalSortEnum["TargetDateDesc"] = "TARGET_DATE_DESC";
    TownsquareGoalSortEnum["WatchingAsc"] = "WATCHING_ASC";
    TownsquareGoalSortEnum["WatchingDesc"] = "WATCHING_DESC";
    return TownsquareGoalSortEnum;
}({});
let $78ad46e0d6808149$export$114cd33b2bd21562 = /*#__PURE__*/ function(TownsquareGoalStateValue) {
    TownsquareGoalStateValue["Archived"] = "archived";
    TownsquareGoalStateValue["AtRisk"] = "at_risk";
    TownsquareGoalStateValue["Cancelled"] = "cancelled";
    TownsquareGoalStateValue["Done"] = "done";
    TownsquareGoalStateValue["OffTrack"] = "off_track";
    TownsquareGoalStateValue["OnTrack"] = "on_track";
    TownsquareGoalStateValue["Paused"] = "paused";
    TownsquareGoalStateValue["Pending"] = "pending";
    return TownsquareGoalStateValue;
}({});
let $78ad46e0d6808149$export$d857eec43cac6124 = /*#__PURE__*/ function(TownsquareGoalTypeState) {
    TownsquareGoalTypeState["Disabled"] = "DISABLED";
    TownsquareGoalTypeState["Enabled"] = "ENABLED";
    return TownsquareGoalTypeState;
}({});
let $78ad46e0d6808149$export$8aa4fdb7ade2bdbb = /*#__PURE__*/ function(TownsquareProjectSortEnum) {
    TownsquareProjectSortEnum["CreationDateAsc"] = "CREATION_DATE_ASC";
    TownsquareProjectSortEnum["CreationDateDesc"] = "CREATION_DATE_DESC";
    TownsquareProjectSortEnum["IdAsc"] = "ID_ASC";
    TownsquareProjectSortEnum["IdDesc"] = "ID_DESC";
    TownsquareProjectSortEnum["LatestUpdateDateAsc"] = "LATEST_UPDATE_DATE_ASC";
    TownsquareProjectSortEnum["LatestUpdateDateDesc"] = "LATEST_UPDATE_DATE_DESC";
    TownsquareProjectSortEnum["NameAsc"] = "NAME_ASC";
    TownsquareProjectSortEnum["NameDesc"] = "NAME_DESC";
    TownsquareProjectSortEnum["StartDateAsc"] = "START_DATE_ASC";
    TownsquareProjectSortEnum["StartDateDesc"] = "START_DATE_DESC";
    TownsquareProjectSortEnum["StatusAsc"] = "STATUS_ASC";
    TownsquareProjectSortEnum["StatusDesc"] = "STATUS_DESC";
    TownsquareProjectSortEnum["TargetDateAsc"] = "TARGET_DATE_ASC";
    TownsquareProjectSortEnum["TargetDateDesc"] = "TARGET_DATE_DESC";
    TownsquareProjectSortEnum["WatchingAsc"] = "WATCHING_ASC";
    TownsquareProjectSortEnum["WatchingDesc"] = "WATCHING_DESC";
    return TownsquareProjectSortEnum;
}({});
let $78ad46e0d6808149$export$ee344fc0997809d6 = /*#__PURE__*/ function(TownsquareProjectStateValue) {
    TownsquareProjectStateValue["Archived"] = "archived";
    TownsquareProjectStateValue["AtRisk"] = "at_risk";
    TownsquareProjectStateValue["Cancelled"] = "cancelled";
    TownsquareProjectStateValue["Done"] = "done";
    TownsquareProjectStateValue["OffTrack"] = "off_track";
    TownsquareProjectStateValue["OnTrack"] = "on_track";
    TownsquareProjectStateValue["Paused"] = "paused";
    TownsquareProjectStateValue["Pending"] = "pending";
    return TownsquareProjectStateValue;
}({}); /**
 * These are the currently supported relationships. The relationships are directional in the ARI Graph Store, so the order of "from" and "to" does matter.
 *
 *
 * | From           |   | To         |
 * |----------------|---|------------|
 * | Atlas Project  | → | Jira Issue |
 * | Jira Issue     | → | Atlas Goal |
 */ 
let $78ad46e0d6808149$export$84f5d3c1f2497f3c = /*#__PURE__*/ function(TownsquareTargetDateType) {
    TownsquareTargetDateType["Day"] = "DAY";
    TownsquareTargetDateType["Month"] = "MONTH";
    TownsquareTargetDateType["Quarter"] = "QUARTER";
    return TownsquareTargetDateType;
}({}); /** Collection of AI preferences */  /** An Attachment on a Trello Card */  /** Trello attachment connection */  /** Trello attachment edge */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** Attachment limits for the board */  /** Collection of attributes representing the board background. */  /** Limits that apply to the board itself */  /** Card limits for the board */  /** CheckItem limits for the board */  /** Checklist limits for the board */  /** CustomFieldOption limits for the board */  /** CustomField limits for the board */  /** Represents a basic relationship between a node and a TrelloBoard. */  /** Label limits for the board */  /** Collection of limits that apply to a TrelloBoard */  /** List limits for the board */  /** Represents a relationship between a board and a member */  /** Filter input for TrelloBoard.members */  /** Metadata about a relationship between a member and a board */  /** Membership types for a TrelloBoard */ 
let $78ad46e0d6808149$export$532fae07bf79d169 = /*#__PURE__*/ function(TrelloBoardMembershipType) {
    TrelloBoardMembershipType["Admin"] = "ADMIN";
    TrelloBoardMembershipType["Normal"] = "NORMAL";
    TrelloBoardMembershipType["Observer"] = "OBSERVER";
    return TrelloBoardMembershipType;
}({}); /** Connection type to represent board memberships */  /** Connection type between a board and its powerUps */  /**
 * Represents a basic relationship between a node and a TrelloPowerUp.
 * The fields promotional, objectId, and memberId are null if the
 * powerUp is not enabled on the board
 */ 
let $78ad46e0d6808149$export$e19d69c6b75aa26f = /*#__PURE__*/ function(TrelloCardCoverBrightness) {
    TrelloCardCoverBrightness["Dark"] = "DARK";
    TrelloCardCoverBrightness["Light"] = "LIGHT";
    return TrelloCardCoverBrightness;
}({}); /** TrelloCardCover color */ 
let $78ad46e0d6808149$export$b1a4da8c2172956c = /*#__PURE__*/ function(TrelloCardCoverColor) {
    TrelloCardCoverColor["Black"] = "BLACK";
    TrelloCardCoverColor["Blue"] = "BLUE";
    TrelloCardCoverColor["Green"] = "GREEN";
    TrelloCardCoverColor["Lime"] = "LIME";
    TrelloCardCoverColor["Orange"] = "ORANGE";
    TrelloCardCoverColor["Pink"] = "PINK";
    TrelloCardCoverColor["Purple"] = "PURPLE";
    TrelloCardCoverColor["Red"] = "RED";
    TrelloCardCoverColor["Sky"] = "SKY";
    TrelloCardCoverColor["Yellow"] = "YELLOW";
    return TrelloCardCoverColor;
}({}); /** TrelloCardCover size */ 
let $78ad46e0d6808149$export$17aa2e5fc86f2e30 = /*#__PURE__*/ function(TrelloCardCoverSize) {
    TrelloCardCoverSize["Full"] = "FULL";
    TrelloCardCoverSize["Normal"] = "NORMAL";
    return TrelloCardCoverSize;
}({}); /** The cover of a trello card. */  /** Information about the due property of a TrelloCard */  /** Represents a basic relationship between a node and a TrelloCard. */  /** TrelloCard external sources, from which cards can be generated */ 
let $78ad46e0d6808149$export$a209f50d5cb5f744 = /*#__PURE__*/ function(TrelloCardExternalSource) {
    TrelloCardExternalSource["Email"] = "EMAIL";
    return TrelloCardExternalSource;
}({}); /** Trello Card Limit */  /** Limits for a card */  /** TrelloCard location information */  /** Special TrelloCard roles */ 
let $78ad46e0d6808149$export$3246e4d5604c366a = /*#__PURE__*/ function(TrelloCardRole) {
    TrelloCardRole["Board"] = "BOARD";
    TrelloCardRole["Link"] = "LINK";
    TrelloCardRole["Mirror"] = "MIRROR";
    TrelloCardRole["Separator"] = "SEPARATOR";
    return TrelloCardRole;
}({}); /** The updated card fields within a TrelloBoardUpdated event. */  /** Connection type emulating relay-style paging for list data on TrelloBoardUpdated events */  /** Trello card viewer for card front badges */  /** A Trello checklist */  /** Connection type between a container and its checklists. */  /** Represents a basic relationship between a node and a TrelloChecklist. */  /** A Trello Custom Field */  /** Custom field connection */  /** Display options for the custom field. */  /** Custom field edge. */  /** A Trello Custom Field item */  /** Connection type between an entity and its Custom Field items. */  /** Represents a basic relationship between a node and a TrelloCustomFieldItem. */  /** Information describing the value of a Custom Field item. */  /** An option for a custom field (e.g. a dropdown option) */  /** The value of the custom field option. */  /** User-generated description of a Trello entity */  /** The data required to render custom emoji in description fields on Trello entities */  /** Connection type between a description data and its set of custom emojis */  /** Represents a basic relationship between a node and a TrelloDescriptionCustomEmoji. */  /** Custom data used to render the description of certain Trello entities */  /** Custom data used to render the description of certain Trello entities */  /** A Trello Enterprise. */  /** Collection of preferences for the enterprise */  /** A Trello Image Preview */  /** Connection type between an object that contains an image and its previews. */  /** Represents a basic relationship between a node and a TrelloImagePreview. */  /**
 * Connection type between an object that contains an image and its previews, modified
 * for subscriptions
 */ 
let $78ad46e0d6808149$export$d6da0c6d5fb213f0 = /*#__PURE__*/ function(TrelloPowerUpDataAccess) {
    TrelloPowerUpDataAccess["Private"] = "PRIVATE";
    TrelloPowerUpDataAccess["Shared"] = "SHARED";
    return TrelloPowerUpDataAccess;
}({}); /** Connection type between an entity and its powerUpData entries. */  /** Represents a basic relationship between a node and a TrelloPowerUpData. */  /** Filters to apply when querying powerUpData. */  /** TrelloPowerUpData scope */ 
let $78ad46e0d6808149$export$bc6cfd4fe0c319ad = /*#__PURE__*/ function(TrelloPowerUpDataScope) {
    TrelloPowerUpDataScope["Board"] = "BOARD";
    TrelloPowerUpDataScope["Card"] = "CARD";
    TrelloPowerUpDataScope["Organization"] = "ORGANIZATION";
    return TrelloPowerUpDataScope;
}({}); /** Represents the icon for this powerUp */  /** The updated powerUp ID on the card */  /**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */ 
let $78ad46e0d6808149$export$1ee95821123803e6 = /*#__PURE__*/ function(TrelloSupportedPlannerProviders) {
    TrelloSupportedPlannerProviders["Google"] = "GOOGLE";
    return TrelloSupportedPlannerProviders;
}({}); /** Information for which switcher views are enabled for this board. */  /** Tag (or Collection). Used to group related entities in a workspace. */  /** A generic connection type to related Tags. */  /** A generic edge between an entity and a related Tag. */  /** The categories for the Trello template gallery. */  /** Connection type between the Template Gallery and the related Board Templates. */  /** Filters to apply when querying the Template Gallery. */  /** Information about a Template Gallery Item. */  /**
 * Statistics of the template gallery item such as view count and number of times
 * it's been copied.
 */ 
let $78ad46e0d6808149$export$d563dba18e915a44 = /*#__PURE__*/ function(TrelloWorkspaceMembershipType) {
    TrelloWorkspaceMembershipType["Admin"] = "ADMIN";
    TrelloWorkspaceMembershipType["Normal"] = "NORMAL";
    return TrelloWorkspaceMembershipType;
}({}); /** Connection type to represent workspace memberships */  /** Collection of preferences for the workspace. */  /** Product tiers for a TrelloWorkspace */ 
let $78ad46e0d6808149$export$c8c804aa42adf4e6 = /*#__PURE__*/ function(TrelloWorkspaceTier) {
    TrelloWorkspaceTier["Paid"] = "PAID";
    return TrelloWorkspaceTier;
}({}); /** Handles detaching a dataManager from a Component */  /** Response from editing an app contributor role */  /** Input payload for enrolling scopes to an app environment */  /** Response from enrolling scopes into an app environment */  /** Input payload for updating an Atlassian OAuth Client mutation */  /** Response from updating an oauth client */  /** Accepts input to update a data manager on a component. */  /** The payload returned from updating a data manager of a component. */  /** Accepts input for updating an existing component. */  /** Accepts input for updating a component link. */  /** The payload returned after updating a component link. */  /** The payload returned from updating an existing component. */  /** Accepts input for updating an existing component's type. */  /** Input to update the metadata for a component type. */  /** The result from updating the metadata for a component type. */  /** The payload returned from updating a component's type. */  /** Accepts input to update a field. */  /** Accepts input to a update a scorecard criterion representing the presence of a description. */  /** Accepts input to update a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */  /** Accepts input to update a scorecard criterion representing the presence of a link, for example, 'Has Repository' or 'Has Documentation'. */  /** Accepts input to update a scorecard criterion checking the value of a specified metric ID. */  /** Accepts input to a update a scorecard criterion representing the presence of an owner. */  /** Accepts details of the link to be updated. */  /** The payload returned from updating a scorecard criterion. */  /** The input sent when updating user defined parameters. */  /** The payload returned from updating user defined parameters. */  /**
 * ###################################################################################################################
 *  COMPASS API SPEC
 * ###################################################################################################################
 */ 
let $78ad46e0d6808149$export$8808d536a6b2ef88 = /*#__PURE__*/ function(UserInstallationRuleValue) {
    UserInstallationRuleValue["Allow"] = "allow";
    UserInstallationRuleValue["Deny"] = "deny";
    return UserInstallationRuleValue;
}({});
let $78ad46e0d6808149$export$4789b44fbe86836 = /*#__PURE__*/ function(VirtualAgentConversationActionType) {
    VirtualAgentConversationActionType["AiAnswered"] = "AI_ANSWERED";
    VirtualAgentConversationActionType["Matched"] = "MATCHED";
    VirtualAgentConversationActionType["Unhandled"] = "UNHANDLED";
    return VirtualAgentConversationActionType;
}({});
let $78ad46e0d6808149$export$e372c28ac4fddc25 = /*#__PURE__*/ function(VirtualAgentConversationCsatOptionType) {
    VirtualAgentConversationCsatOptionType["CsatOption_1"] = "CSAT_OPTION_1";
    VirtualAgentConversationCsatOptionType["CsatOption_2"] = "CSAT_OPTION_2";
    VirtualAgentConversationCsatOptionType["CsatOption_3"] = "CSAT_OPTION_3";
    VirtualAgentConversationCsatOptionType["CsatOption_4"] = "CSAT_OPTION_4";
    VirtualAgentConversationCsatOptionType["CsatOption_5"] = "CSAT_OPTION_5";
    return VirtualAgentConversationCsatOptionType;
}({});
let $78ad46e0d6808149$export$620fe609179029be = /*#__PURE__*/ function(VirtualAgentConversationState) {
    VirtualAgentConversationState["Closed"] = "CLOSED";
    VirtualAgentConversationState["Escalated"] = "ESCALATED";
    VirtualAgentConversationState["Open"] = "OPEN";
    VirtualAgentConversationState["Resolved"] = "RESOLVED";
    return VirtualAgentConversationState;
}({}); /** Accepts input for creating a VirtualAgent Configuration. */  /**
 * A temporary type for VirtualAgentIntentProjection until it's properly migrated over to Verbena
 * Do not diverge it from the original
 */ 
let $78ad46e0d6808149$export$68d524b762f21460 = /*#__PURE__*/ function(VirtualAgentIntentTemplateType) {
    VirtualAgentIntentTemplateType["Discovered"] = "DISCOVERED";
    VirtualAgentIntentTemplateType["Shared"] = "SHARED";
    VirtualAgentIntentTemplateType["Standard"] = "STANDARD";
    return VirtualAgentIntentTemplateType;
}({}); /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Query API. */  /** The top level wrapper for the Virtual Agent Query API. */  /** The top level wrapper for the Virtual Agent Query API. */  /** Accepts input for updating an existing VirtualAgent Configuration. */  /** User facing validation error. On the FE this mutation error will not go to Sentry */ 
let $78ad46e0d6808149$export$f794720beec52585 = /*#__PURE__*/ function(WorkSuggestionsAction) {
    WorkSuggestionsAction["Remove"] = "REMOVE";
    WorkSuggestionsAction["Snooze"] = "SNOOZE";
    return WorkSuggestionsAction;
}({}); /** Input for the mutation operations (snooze and remove). */ 
let $78ad46e0d6808149$export$fcfd01bc876454f4 = /*#__PURE__*/ function(WorkSuggestionsApprovalStatus) {
    WorkSuggestionsApprovalStatus["Approved"] = "APPROVED";
    WorkSuggestionsApprovalStatus["Needswork"] = "NEEDSWORK";
    WorkSuggestionsApprovalStatus["Unapproved"] = "UNAPPROVED";
    WorkSuggestionsApprovalStatus["Unknown"] = "UNKNOWN";
    return WorkSuggestionsApprovalStatus;
}({});
let $78ad46e0d6808149$export$4dffae97a15618f = /*#__PURE__*/ function(WorkSuggestionsAutoDevJobState) {
    WorkSuggestionsAutoDevJobState["Cancelled"] = "CANCELLED";
    WorkSuggestionsAutoDevJobState["CodeGenerating"] = "CODE_GENERATING";
    WorkSuggestionsAutoDevJobState["CodeGenerationFail"] = "CODE_GENERATION_FAIL";
    WorkSuggestionsAutoDevJobState["CodeGenerationReady"] = "CODE_GENERATION_READY";
    WorkSuggestionsAutoDevJobState["CodeGenerationSuccess"] = "CODE_GENERATION_SUCCESS";
    WorkSuggestionsAutoDevJobState["Created"] = "CREATED";
    WorkSuggestionsAutoDevJobState["PlanGenerating"] = "PLAN_GENERATING";
    WorkSuggestionsAutoDevJobState["PlanGenerationFail"] = "PLAN_GENERATION_FAIL";
    WorkSuggestionsAutoDevJobState["PlanGenerationSuccess"] = "PLAN_GENERATION_SUCCESS";
    WorkSuggestionsAutoDevJobState["PullrequestCreating"] = "PULLREQUEST_CREATING";
    WorkSuggestionsAutoDevJobState["PullrequestCreationFail"] = "PULLREQUEST_CREATION_FAIL";
    WorkSuggestionsAutoDevJobState["PullrequestCreationSuccess"] = "PULLREQUEST_CREATION_SUCCESS";
    WorkSuggestionsAutoDevJobState["Unknown"] = "UNKNOWN";
    return WorkSuggestionsAutoDevJobState;
}({}); /** projectAri is always required, but sprintAri can also be specified */ 
let $78ad46e0d6808149$export$4f315a2279163c82 = /*#__PURE__*/ function(WorkSuggestionsEnvironmentType) {
    WorkSuggestionsEnvironmentType["Development"] = "DEVELOPMENT";
    WorkSuggestionsEnvironmentType["Production"] = "PRODUCTION";
    WorkSuggestionsEnvironmentType["Staging"] = "STAGING";
    WorkSuggestionsEnvironmentType["Testing"] = "TESTING";
    WorkSuggestionsEnvironmentType["Unmapped"] = "UNMAPPED";
    return WorkSuggestionsEnvironmentType;
}({}); /** An interface for all suggestion types supported by Periscope page */  /** Response for the recent pull requests suggestions */  /** Input for the mutation operations (save user profile). */ 
let $78ad46e0d6808149$export$bf7ed014c948227 = /*#__PURE__*/ function(WorkSuggestionsTargetAudience) {
    WorkSuggestionsTargetAudience["Me"] = "ME";
    WorkSuggestionsTargetAudience["Team"] = "TEAM";
    return WorkSuggestionsTargetAudience;
}({}); /** Action object stored in the database for the actions snooze/remove task. */  /**
 * Persona for the user profile.
 * For example: DEVELOPER
 */ 
let $78ad46e0d6808149$export$6d0f92f77f50b1c2 = /*#__PURE__*/ function(WorkSuggestionsUserPersona) {
    WorkSuggestionsUserPersona["Developer"] = "DEVELOPER";
    return WorkSuggestionsUserPersona;
}({}); /** User profile type for the user */ 
let $78ad46e0d6808149$export$88e2a9ce86b144d3 = /*#__PURE__*/ function(WorkSuggestionsVulnerabilityStatus) {
    WorkSuggestionsVulnerabilityStatus["Closed"] = "CLOSED";
    WorkSuggestionsVulnerabilityStatus["Ignored"] = "IGNORED";
    WorkSuggestionsVulnerabilityStatus["Open"] = "OPEN";
    WorkSuggestionsVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return WorkSuggestionsVulnerabilityStatus;
}({}); /** An Applied Directive is an instances of a directive as applied to a schema element. This type is NOT specified by the graphql specification presently. */  /** Directive arguments can have names and values.  The values are in graphql SDL syntax printed as a string. This type is NOT specified by the graphql specification presently. */ 
let $78ad46e0d6808149$export$32baded4868555f5 = /*#__PURE__*/ function(SourceBillingType) {
    SourceBillingType["Ccp"] = "CCP";
    SourceBillingType["Hams"] = "HAMS";
    return SourceBillingType;
}({});

});

parcelRegister("9y1TQ", function(module, exports) {

$parcel$export(module.exports, "ErrorCode", () => $6f38c34300a9988c$export$d4e71bc0b80dc0fb);
$parcel$export(module.exports, "appInstallErrorFromGraphQLFetchError", () => $6f38c34300a9988c$export$6f90b36850979bb8);
$parcel$export(module.exports, "appInstallErrorFromGraphQLErrorResponse", () => $6f38c34300a9988c$export$d2e572bf56497e18);

var $1w7m1 = parcelRequire("1w7m1");
let $6f38c34300a9988c$export$d4e71bc0b80dc0fb = /*#__PURE__*/ function(ErrorCode) {
    ErrorCode["InvalidInstallationTargetInfo"] = "InvalidInstallationTargetInfo";
    ErrorCode["FallbackStoreBFFErrorCode"] = "UnknownErrorInMarketplaceStoreAppInstall";
    ErrorCode["AppAlreadyProvisioned"] = "APP_ALREADY_PROVISIONED";
    ErrorCode["GraphQLFetchError"] = "GraphQLFetchError";
    return ErrorCode;
}({});
const $6f38c34300a9988c$var$appendTaskId = (message, taskId)=>{
    if (taskId) return "".concat(message, " [taskId: ").concat(taskId, "]");
    return message;
};
const $6f38c34300a9988c$export$6f90b36850979bb8 = (appKey, operation, source, taskId)=>{
    const message = operation === 'trigger' ? "Failed to trigger installation for app with key ".concat(appKey) : "Unknown error getting installation status for app with key ".concat(appKey);
    throw new (0, $1w7m1.AppInstallError)({
        addon: {
            key: appKey
        },
        code: $6f38c34300a9988c$export$d4e71bc0b80dc0fb.GraphQLFetchError,
        message: $6f38c34300a9988c$var$appendTaskId(message, taskId),
        source: source
    });
};
const $6f38c34300a9988c$export$d2e572bf56497e18 = (appKey, operation, errors, extensions, taskId)=>{
    var _error$extensions, _extensions$gateway, _error$message;
    const error = errors === null || errors === void 0 ? void 0 : errors[0];
    const errorCode = (error === null || error === void 0 ? void 0 : (_error$extensions = error.extensions) === null || _error$extensions === void 0 ? void 0 : _error$extensions.code) || $6f38c34300a9988c$export$d4e71bc0b80dc0fb.FallbackStoreBFFErrorCode;
    const requestId = extensions === null || extensions === void 0 ? void 0 : (_extensions$gateway = extensions.gateway) === null || _extensions$gateway === void 0 ? void 0 : _extensions$gateway.request_id;
    const message = (_error$message = error === null || error === void 0 ? void 0 : error.message) !== null && _error$message !== void 0 ? _error$message : operation === 'trigger' ? "Error triggering installation for app with key ".concat(appKey) : "Error getting installation status for app with key ".concat(appKey);
    throw new (0, $1w7m1.AppInstallError)({
        addon: {
            key: appKey
        },
        code: errorCode,
        message: $6f38c34300a9988c$var$appendTaskId(message, taskId),
        source: error,
        requestId: requestId
    });
};

});


parcelRegister("56eyA", function(module, exports) {

$parcel$export(module.exports, "getInstalledAppFromUpm", () => $3b68cdff11d9fe6c$export$f8f9f9ee7ac59403);
$parcel$export(module.exports, "getInstallPermissions", () => $3b68cdff11d9fe6c$export$69e4ce869d45957f);
$parcel$export(module.exports, "getInstalledMarketplacePluginFromUpm", () => $3b68cdff11d9fe6c$export$7dddfef125b8b373);
$parcel$export(module.exports, "getAvailableAppFromUpm", () => $3b68cdff11d9fe6c$export$a4ff2c0f02e68c0b);
$parcel$export(module.exports, "getInstalledMarketplaceFromUpm", () => $3b68cdff11d9fe6c$export$7203b6ab97ad4508);
$parcel$export(module.exports, "getAllInstalledAppsFromUpm", () => $3b68cdff11d9fe6c$export$204e4607d8fa2086);
$parcel$export(module.exports, "getHostStatusFromUpm", () => $3b68cdff11d9fe6c$export$ee0bd730334c3b4);

var $dO8LH = parcelRequire("dO8LH");

var $1w7m1 = parcelRequire("1w7m1");

var $bTrQR = parcelRequire("bTrQR");

var $kt9Cs = parcelRequire("kt9Cs");

var $gQV53 = parcelRequire("gQV53");
const $3b68cdff11d9fe6c$var$defaultOptions = (upmBaseUrl)=>({
        credentials: (0, $gQV53.getUPMCredentials)(upmBaseUrl)
    });
const $3b68cdff11d9fe6c$var$getInstallPermissionsUrl = (upmBaseUrl, appKey)=>"".concat(upmBaseUrl, "/rest/plugins/1.0/apps/install-subscribe/permission?addonKey=").concat(appKey);
const $3b68cdff11d9fe6c$var$getInstalledPluginUrl = (upmBaseUrl, appKey)=>"".concat(upmBaseUrl, "/rest/plugins/1.0/").concat(appKey, "-key");
const $3b68cdff11d9fe6c$var$getInstalledMarketplacePluginUrl = (upmBaseUrl, appKey)=>"".concat(upmBaseUrl, "/rest/plugins/1.0/").concat(appKey, "/marketplace");
const $3b68cdff11d9fe6c$var$getAvailablePluginUrl = (upmBaseUrl, appKey, query)=>"".concat(upmBaseUrl, "/rest/plugins/1.0/available/").concat(appKey, "-key").concat(query ? "?".concat(query) : '');
const $3b68cdff11d9fe6c$var$getAllInstalledMarketplacePluginsUrl = (upmBaseUrl)=>"".concat(upmBaseUrl, "/rest/plugins/1.0/installed-marketplace");
const $3b68cdff11d9fe6c$var$getHostStatusUrl = (upmBaseUrl)=>"".concat(upmBaseUrl, "/rest/plugins/1.0/host-status");
const $3b68cdff11d9fe6c$var$getAllInstalledPluginsUrl = (upmBaseUrl)=>"".concat(upmBaseUrl, "/rest/plugins/1.0/");
async function $3b68cdff11d9fe6c$export$f8f9f9ee7ac59403(upmBaseUrl, appKey) {
    try {
        const result = await (0, $dO8LH.fetchOk)($3b68cdff11d9fe6c$var$getInstalledPluginUrl(upmBaseUrl, appKey), $3b68cdff11d9fe6c$var$defaultOptions(upmBaseUrl));
        const response = await result.json();
        return {
            links: {
                postInstall: response.links['post-install'],
                configure: response.links.configure,
                manage: response.links.manage
            },
            key: response.key
        };
    } catch (error) {
        const InstalledAppFromUPMError = (0, $1w7m1.makeAppFetchError)('InstalledAppFromUPMError');
        throw new InstalledAppFromUPMError({
            source: error,
            appKey: appKey
        });
    }
}
async function $3b68cdff11d9fe6c$export$69e4ce869d45957f(upmBaseUrl, appKey) {
    const response = await (0, $dO8LH.fetch)($3b68cdff11d9fe6c$var$getInstallPermissionsUrl(upmBaseUrl, appKey), $3b68cdff11d9fe6c$var$defaultOptions(upmBaseUrl));
    if (response.status >= 200 && response.status <= 299) return Promise.resolve(true);
    else if (response.status === 401 || response.status === 403) return Promise.resolve(false);
    else return Promise.reject("".concat(response.status, ": ").concat(response.statusText));
}
const $3b68cdff11d9fe6c$var$fetchInstalledMarketplacePluginFromUpm = (upmBaseUrl, appKey, options)=>(0, $dO8LH.fetchOk)($3b68cdff11d9fe6c$var$getInstalledMarketplacePluginUrl(upmBaseUrl, appKey), options).then((response)=>response.json());
const $3b68cdff11d9fe6c$export$e5eee0dc3e886151 = (upmBaseUrl, shouldRetryForLicenseDetails)=>{
    const pollAfter = 3000;
    const optionsForRetry = {
        retries: (0, $gQV53.calculateRetries)(0.16, pollAfter),
        retryDelay: pollAfter,
        credentials: (0, $gQV53.getUPMCredentials)(upmBaseUrl),
        accept: (response)=>response.json().then((bodyJSON)=>{
                if (bodyJSON.licenseDetails === undefined) {
                    (0, $bTrQR.default).info('upmApi', "Retries failed for fetching license details of the app : ".concat(bodyJSON.appKey, " "));
                    throw new Error('Error in fetching license details');
                }
            })
    };
    const optionsForNoRetry = $3b68cdff11d9fe6c$var$defaultOptions(upmBaseUrl);
    if (shouldRetryForLicenseDetails) return optionsForRetry;
    else return optionsForNoRetry;
};
const $3b68cdff11d9fe6c$export$7dddfef125b8b373 = async (upmBaseUrl, appKey, shouldRetryForLicenseDetails)=>{
    try {
        const options = $3b68cdff11d9fe6c$export$e5eee0dc3e886151(upmBaseUrl, shouldRetryForLicenseDetails);
        const result = await $3b68cdff11d9fe6c$var$fetchInstalledMarketplacePluginFromUpm(upmBaseUrl, appKey, options);
        return result;
    } catch (error) {
        const InstalledMarketplacePluginUPMError = (0, $1w7m1.makeAppFetchError)('InstalledMarketplacePluginUPMError');
        throw new InstalledMarketplacePluginUPMError({
            source: error,
            appKey: appKey
        });
    }
};
const $3b68cdff11d9fe6c$export$a4ff2c0f02e68c0b = (upmBaseUrl, appKey, hostCmtEnabled)=>(0, $dO8LH.fetchOk)($3b68cdff11d9fe6c$var$getAvailablePluginUrl(upmBaseUrl, appKey, (0, (/*@__PURE__*/$parcel$interopDefault($kt9Cs))).stringify({
        hostCmtEnabled: hostCmtEnabled
    })), $3b68cdff11d9fe6c$var$defaultOptions(upmBaseUrl)).then((r)=>r.json());
const $3b68cdff11d9fe6c$export$7203b6ab97ad4508 = (upmBaseUrl)=>(0, $dO8LH.fetchOk)($3b68cdff11d9fe6c$var$getAllInstalledMarketplacePluginsUrl(upmBaseUrl), $3b68cdff11d9fe6c$var$defaultOptions(upmBaseUrl)).then((r)=>r.json());
async function $3b68cdff11d9fe6c$export$204e4607d8fa2086(upmBaseUrl) {
    const result = await (0, $dO8LH.fetchOk)($3b68cdff11d9fe6c$var$getAllInstalledPluginsUrl(upmBaseUrl), $3b68cdff11d9fe6c$var$defaultOptions(upmBaseUrl));
    const response = await result.json();
    return response.plugins.filter((app)=>(app.userInstalled || app.usesLicensing) && app.name !== 'Embedded Marketplace').map((app)=>({
            links: {
                postInstall: app.links['post-install'],
                configure: app.links.configure,
                manage: app.links.manage
            },
            key: app.key
        }));
}
const $3b68cdff11d9fe6c$export$ee0bd730334c3b4 = (upmBaseUrl)=>(0, $dO8LH.fetchOk)($3b68cdff11d9fe6c$var$getHostStatusUrl(upmBaseUrl), $3b68cdff11d9fe6c$var$defaultOptions(upmBaseUrl)).then((r)=>r.json());

});


parcelRegister("7jpYj", function(module, exports) {

$parcel$export(module.exports, "default", () => $552e742e5c09f50f$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $je2Cw = parcelRequire("je2Cw");

var $gQV53 = parcelRequire("gQV53");
var $552e742e5c09f50f$var$_class;
let $552e742e5c09f50f$var$Contexts = ($552e742e5c09f50f$var$_class = class Contexts {
    constructor(config){
        (0, $5zQU9.default)(this, "config", void 0);
        this.config = config;
    }
    getMostRecentContext() {
        return Promise.reject();
    }
    getContextInstallationForInstalledAddonContext(_options) {
        return Promise.reject();
    }
    getContextInstallationsForInstalledAddon(_options) {
        return Promise.reject();
    }
    getContext(_options) {
        return Promise.reject();
    }
    getContexts(_options) {
        return Promise.reject();
    }
}, (0, $je2Cw.default)($552e742e5c09f50f$var$_class.prototype, "getMostRecentContext", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($552e742e5c09f50f$var$_class.prototype, "getMostRecentContext"), $552e742e5c09f50f$var$_class.prototype), (0, $je2Cw.default)($552e742e5c09f50f$var$_class.prototype, "getContextInstallationForInstalledAddonContext", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($552e742e5c09f50f$var$_class.prototype, "getContextInstallationForInstalledAddonContext"), $552e742e5c09f50f$var$_class.prototype), (0, $je2Cw.default)($552e742e5c09f50f$var$_class.prototype, "getContextInstallationsForInstalledAddon", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($552e742e5c09f50f$var$_class.prototype, "getContextInstallationsForInstalledAddon"), $552e742e5c09f50f$var$_class.prototype), (0, $je2Cw.default)($552e742e5c09f50f$var$_class.prototype, "getContext", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($552e742e5c09f50f$var$_class.prototype, "getContext"), $552e742e5c09f50f$var$_class.prototype), (0, $je2Cw.default)($552e742e5c09f50f$var$_class.prototype, "getContexts", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($552e742e5c09f50f$var$_class.prototype, "getContexts"), $552e742e5c09f50f$var$_class.prototype), $552e742e5c09f50f$var$_class);
var $552e742e5c09f50f$export$2e2bcd8739ae039 = (config)=>(0, $gQV53.instanceToModule)(new $552e742e5c09f50f$var$Contexts(config));

});

parcelRegister("d1veh", function(module, exports) {

$parcel$export(module.exports, "default", () => $97b397d9781ce20f$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $je2Cw = parcelRequire("je2Cw");

var $lyT6v = parcelRequire("lyT6v");

var $gQV53 = parcelRequire("gQV53");

var $dx2bt = parcelRequire("dx2bt");

var $56eyA = parcelRequire("56eyA");
var $97b397d9781ce20f$var$_class;
function $97b397d9781ce20f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $97b397d9781ce20f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $97b397d9781ce20f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $97b397d9781ce20f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
let $97b397d9781ce20f$var$Extra = ($97b397d9781ce20f$var$_class = class Extra {
    constructor(config){
        (0, $5zQU9.default)(this, "config", void 0);
        this.config = config;
    }
    getHostInfo() {
        return Promise.resolve($97b397d9781ce20f$var$_objectSpread($97b397d9781ce20f$var$_objectSpread({
            supports: $dx2bt.supports,
            product: this.config.product
        }, this.config.subproduct ? {
            subproduct: this.config.subproduct
        } : {}), {}, {
            baseUrl: this.config.baseUrl,
            globalContext: (0, $gQV53.buildContext)(this.config)
        }));
    }
    async getHostPricingInfo() {
        if (this.config.product === 'compass') {
            const hostBillingSystem = await (0, $lyT6v.getHostBillingSystem)(this.config.cloudId);
            /* This is being done only for compass apps, excluding billingSystem property
      all the other properties are mocked with dummy data as compass installation doesn't need any of those
      as all the compass apps are free for now. */ return {
                instanceType: 'production',
                evaluation: false,
                currentLicensedUsers: 0,
                renewalType: 'auto',
                maximumLicensedUsers: 0,
                billingCurrency: 'USD',
                subscriptionPeriod: 'monthly',
                hostCmtEnabled: false,
                billingSystem: hostBillingSystem.billingSystem
            };
        }
        const hostStatus = await (0, $56eyA.getHostStatusFromUpm)(this.config.baseUrl);
        return {
            instanceType: hostStatus.instanceType,
            billingSystem: hostStatus.billingSystem,
            evaluation: hostStatus.hostLicense.evaluation,
            currentLicensedUsers: hostStatus.upmLicensedHostUsers,
            renewalType: hostStatus.hostLicense.autoRenewal ? 'auto' : 'quote',
            maximumLicensedUsers: hostStatus.hostLicense.maximumNumberOfUsers,
            billingCurrency: hostStatus.billingCurrency,
            subscriptionPeriod: Object.prototype.hasOwnProperty.call(hostStatus.hostLicense, 'subscriptionAnnual') ? hostStatus.hostLicense.subscriptionAnnual ? 'annual' : 'monthly' : 'monthly',
            hostCmtEnabled: Boolean(hostStatus.hostCmtEnabled)
        };
    }
}, (0, $je2Cw.default)($97b397d9781ce20f$var$_class.prototype, "getHostInfo", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($97b397d9781ce20f$var$_class.prototype, "getHostInfo"), $97b397d9781ce20f$var$_class.prototype), (0, $je2Cw.default)($97b397d9781ce20f$var$_class.prototype, "getHostPricingInfo", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($97b397d9781ce20f$var$_class.prototype, "getHostPricingInfo"), $97b397d9781ce20f$var$_class.prototype), $97b397d9781ce20f$var$_class);
var $97b397d9781ce20f$export$2e2bcd8739ae039 = (config)=>(0, $gQV53.instanceToModule)(new $97b397d9781ce20f$var$Extra(config));

});
parcelRegister("lyT6v", function(module, exports) {

$parcel$export(module.exports, "getHostBillingSystem", () => $fb278475ce5c6093$export$94e02b5509a97c9a);

var $5zQU9 = parcelRequire("5zQU9");

var $dO8LH = parcelRequire("dO8LH");
function $fb278475ce5c6093$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fb278475ce5c6093$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fb278475ce5c6093$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fb278475ce5c6093$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $fb278475ce5c6093$var$defaultDemandApiConfig = {
    credentials: 'include',
    headers: {
        'Content-Type': 'application/json'
    }
};
const $fb278475ce5c6093$var$demandServicePath = '/gateway/api/marketplace/internal/demand';
const $fb278475ce5c6093$var$getSiteDetailsUrl = (mpacBaseUrl, cloudId)=>"".concat(mpacBaseUrl).concat($fb278475ce5c6093$var$demandServicePath, "/site-details/cloud-id/").concat(cloudId);
const $fb278475ce5c6093$export$94e02b5509a97c9a = (cloudId)=>(0, $dO8LH.fetchOk)("/gateway/api/marketplace/internal/demand/billing-system/".concat(cloudId)).then((response)=>response.json());
const $fb278475ce5c6093$export$763ef3b9199a11b4 = async (mpacBaseUrl, cloudId)=>{
    return (await (0, $dO8LH.fetchOk)($fb278475ce5c6093$var$getSiteDetailsUrl(mpacBaseUrl, cloudId), $fb278475ce5c6093$var$_objectSpread({
        method: 'GET'
    }, $fb278475ce5c6093$var$defaultDemandApiConfig))).json();
};

});


parcelRegister("7tJ3W", function(module, exports) {

$parcel$export(module.exports, "default", () => $571e324d87bae977$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $je2Cw = parcelRequire("je2Cw");

var $c0UlX = parcelRequire("c0UlX");
var $1oMwC = parcelRequire("1oMwC");
var $6u78H = parcelRequire("6u78H");

var $ammkg = parcelRequire("ammkg");

var $gQV53 = parcelRequire("gQV53");

var $QaRKt = parcelRequire("QaRKt");

var $c0juV = parcelRequire("c0juV");

var $56eyA = parcelRequire("56eyA");
var $571e324d87bae977$var$_class;
const $571e324d87bae977$var$formatInstallPermissionToSPI = (canInstallApp)=>canInstallApp ? {
        allowed: true
    } : {
        allowed: false,
        message: 'No addon manage permission',
        key: 'noAddonManagePermission'
    };
const $571e324d87bae977$var$checkInstallPermissionFromStargate = (config, marketplaceApp, installPermission)=>{
    const product = config.product;
    if ((0, $1oMwC.isCompatibleMarketplaceProduct)(product)) {
        var _marketplaceApp$versi;
        const paymentModel = (_marketplaceApp$versi = marketplaceApp.version) === null || _marketplaceApp$versi === void 0 ? void 0 : _marketplaceApp$versi.paymentModel;
        return paymentModel === (0, $ammkg.MarketplaceAppPaymentModel).Free ? installPermission !== (0, $c0UlX.AppInstallPermission).CANNOT_INSTALL : installPermission === (0, $c0UlX.AppInstallPermission).CAN_INSTALL_FREE_AND_PAID;
    }
    return false;
};
let $571e324d87bae977$var$Permissions = ($571e324d87bae977$var$_class = class Permissions {
    constructor(config){
        (0, $5zQU9.default)(this, "config", void 0);
        this.config = config;
    }
    async hasInstallPermission(options) {
        return (0, $gQV53.foldPermissionIdentifier)(options.addon)(async (keyIdentifier)=>{
            const response = await (0, $56eyA.getInstallPermissions)(this.config.baseUrl, keyIdentifier.details.key);
            return $571e324d87bae977$var$formatInstallPermissionToSPI(response);
        }, async (ariIdentifier)=>{
            const { gqlGatewayUrl: gqlGatewayUrl } = this.config;
            const product = this.config.product;
            if ((0, $1oMwC.isCompatibleMarketplaceProduct)(product)) {
                const starGateUrl = this.config.environment === 'local' ? "".concat(this.config.baseUrl, "/gateway/api") : '/gateway/api';
                const [marketplaceApp, installPermission] = await Promise.all([
                    (0, $QaRKt.getRawCloudMarketplaceAppByKey)((0, $c0juV.makeAppKey)(ariIdentifier.details.key), gqlGatewayUrl),
                    new (0, $6u78H.default)(starGateUrl).marketplace.appInstallPermission(product, this.config.cloudId)
                ]);
                const permission = $571e324d87bae977$var$checkInstallPermissionFromStargate(this.config, marketplaceApp, installPermission);
                return $571e324d87bae977$var$formatInstallPermissionToSPI(permission);
            } else return $571e324d87bae977$var$formatInstallPermissionToSPI(false);
        });
    }
    hasUninstallPermission(_options) {
        return Promise.reject();
    }
}, (0, $je2Cw.default)($571e324d87bae977$var$_class.prototype, "hasInstallPermission", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($571e324d87bae977$var$_class.prototype, "hasInstallPermission"), $571e324d87bae977$var$_class.prototype), (0, $je2Cw.default)($571e324d87bae977$var$_class.prototype, "hasUninstallPermission", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($571e324d87bae977$var$_class.prototype, "hasUninstallPermission"), $571e324d87bae977$var$_class.prototype), $571e324d87bae977$var$_class);
var $571e324d87bae977$export$2e2bcd8739ae039 = (config)=>(0, $gQV53.instanceToModule)(new $571e324d87bae977$var$Permissions(config));

});
parcelRegister("c0UlX", function(module, exports) {

$parcel$export(module.exports, "MarketplaceProduct", () => $8bf132ac2f5aa45a$export$f43438c1653c8a7f);
$parcel$export(module.exports, "AppInstallPermission", () => $8bf132ac2f5aa45a$export$6a17a2610f6da8f7);
$parcel$export(module.exports, "StargateCloudProduct", () => $8bf132ac2f5aa45a$export$9024016c479bb2b5);
$parcel$export(module.exports, "StargateAPIErrorCode", () => $8bf132ac2f5aa45a$export$5be4334c4ffb02d2);
$parcel$export(module.exports, "StargatePermissionId", () => $8bf132ac2f5aa45a$export$f9ee0408cd98bfae);
/* MC-2850 Use enums for these to simplify the types */ const $8bf132ac2f5aa45a$export$f43438c1653c8a7f = Object.freeze({
    JIRA: 'jira',
    CONFLUENCE: 'confluence',
    COMPASS: 'compass'
});
const $8bf132ac2f5aa45a$export$6a17a2610f6da8f7 = Object.freeze({
    CAN_INSTALL_FREE_AND_PAID: 'CAN_INSTALL_FREE_AND_PAID',
    CAN_INSTALL_FREE_ONLY: 'CAN_INSTALL_FREE_ONLY',
    CANNOT_INSTALL: 'CANNOT_INSTALL'
});
const $8bf132ac2f5aa45a$export$9024016c479bb2b5 = Object.freeze({
    HIPCHAT: 'hipchat.cloud',
    JIRA_CORE: 'jira-core.ondemand',
    JIRA_SERVICE_DESK: 'jira-servicedesk.ondemand',
    JIRA_SOFTWARE: 'jira-software.ondemand',
    CONFLUENCE: 'confluence.ondemand',
    COMPASS: 'compass'
});
const $8bf132ac2f5aa45a$export$5be4334c4ffb02d2 = Object.freeze({
    UNAUTHORIZED: 'UNAUTHORIZED_ERROR',
    UNKNOWN: 'UNKNOWN_ERROR'
});
const $8bf132ac2f5aa45a$export$f9ee0408cd98bfae = Object.freeze({
    ADD_PRODUCTS: 'add-products',
    /** @deprecated Legacy. Use `ADD_PRODUCTS` instead */ ADD_PRODUCT: 'addProduct',
    INVITE_USERS: 'invite-users',
    MANAGE: 'manage',
    WRITE: 'write'
});

});

parcelRegister("1oMwC", function(module, exports) {

$parcel$export(module.exports, "toStargateProducts", () => $104dac6fa2ab9eb5$export$af73be4b3ce86fd4);
$parcel$export(module.exports, "isCompatibleMarketplaceProduct", () => $104dac6fa2ab9eb5$export$176cda4e1d690b30);
$parcel$export(module.exports, "toMarketplaceProducts", () => $104dac6fa2ab9eb5$export$6434c425ac61cf94);

var $c0UlX = parcelRequire("c0UlX");
const $104dac6fa2ab9eb5$var$marketplaceStargateProductMapping = Object.freeze({
    [(0, $c0UlX.MarketplaceProduct).JIRA]: [
        (0, $c0UlX.StargateCloudProduct).JIRA_CORE,
        (0, $c0UlX.StargateCloudProduct).JIRA_SERVICE_DESK,
        (0, $c0UlX.StargateCloudProduct).JIRA_SOFTWARE
    ],
    [(0, $c0UlX.MarketplaceProduct).CONFLUENCE]: [
        (0, $c0UlX.StargateCloudProduct).CONFLUENCE
    ],
    [(0, $c0UlX.MarketplaceProduct).COMPASS]: [
        (0, $c0UlX.StargateCloudProduct).COMPASS
    ]
});
const $104dac6fa2ab9eb5$var$toMarketplaceProduct = (stargateProduct)=>{
    const marketplaceProducts = Object.keys($104dac6fa2ab9eb5$var$marketplaceStargateProductMapping);
    return marketplaceProducts.find((product)=>$104dac6fa2ab9eb5$var$marketplaceStargateProductMapping[product].includes(stargateProduct));
};
const $104dac6fa2ab9eb5$export$af73be4b3ce86fd4 = (marketplaceProducts)=>marketplaceProducts.flatMap((product)=>$104dac6fa2ab9eb5$var$marketplaceStargateProductMapping[product]).filter((product)=>!!product);
const $104dac6fa2ab9eb5$export$176cda4e1d690b30 = (marketplaceProduct)=>marketplaceProduct === 'jira' || marketplaceProduct === 'confluence' || marketplaceProduct === 'compass';
const $104dac6fa2ab9eb5$export$6434c425ac61cf94 = (stargateProducts)=>{
    const marketplaceProducts = new Set();
    stargateProducts.forEach((stargateProduct)=>{
        const marketplaceProduct = $104dac6fa2ab9eb5$var$toMarketplaceProduct(stargateProduct);
        if (marketplaceProduct) marketplaceProducts.add(marketplaceProduct);
    });
    return [
        ...marketplaceProducts
    ];
};

});

parcelRegister("6u78H", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b8b1522bc0df4cd$export$2e2bcd8739ae039);

var $f5aYf = parcelRequire("f5aYf");


var $4b8b1522bc0df4cd$export$2e2bcd8739ae039 = (0, $f5aYf.default);

});
parcelRegister("f5aYf", function(module, exports) {

$parcel$export(module.exports, "default", () => $afafd5384b9407b2$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("jULLl");
var $jGreP = parcelRequire("jGreP");

var $gsf25 = parcelRequire("gsf25");

var $2c2FY = parcelRequire("2c2FY");

var $c0UlX = parcelRequire("c0UlX");
class $afafd5384b9407b2$export$2e2bcd8739ae039 {
    constructor(baseUrl){
        (0, $5zQU9.default)(this, "_api", void 0);
        (0, $5zQU9.default)(this, "marketplace", (0, $2c2FY.default)(this));
        this._api = (0, $jGreP.default).create({
            prefixUrl: baseUrl
        });
    }
    /**
   * Get available sites for the logged in Atlassian Account session
   * @throws {StargateAPIError}
   */ async availableSites(products) {
        try {
            return await this._api.post('available-sites', {
                json: {
                    products: products
                }
            }).json();
        } catch (error) {
            const { status: status, response: response } = await (0, $gsf25.parseError)(error);
            throw (0, $gsf25.makeAPIError)({
                name: 'AvailableSitesError',
                code: status === 401 ? (0, $c0UlX.StargateAPIErrorCode).UNAUTHORIZED : (0, $c0UlX.StargateAPIErrorCode).UNKNOWN,
                response: response
            });
        }
    }
    /**
   * Get whether a user has a permission for a particular resource
   * @throws {StargateAPIError}
   */ async permitted(permissionId, resourceId) {
        try {
            return await this._api.post('permissions/permitted', {
                json: {
                    permissionId: permissionId,
                    resourceId: resourceId
                }
            }).json();
        } catch (error) {
            const { status: status, response: response } = await (0, $gsf25.parseError)(error);
            throw (0, $gsf25.makeAPIError)({
                name: 'PermittedError',
                code: status === 401 ? (0, $c0UlX.StargateAPIErrorCode).UNAUTHORIZED : (0, $c0UlX.StargateAPIErrorCode).UNKNOWN,
                response: response
            });
        }
    }
}

});
parcelRegister("jULLl", function(module, exports) {

$parcel$export(module.exports, "default", () => (parcelRequire("jGreP")).default);

var $jGreP = parcelRequire("jGreP");

});
parcelRegister("jGreP", function(module, exports) {

$parcel$export(module.exports, "default", () => $e54711839dd73311$export$2e2bcd8739ae039);
/*! MIT License © Sindre Sorhus */ const $e54711839dd73311$var$globals = {};
const $e54711839dd73311$var$getGlobal = (property)=>{
    /* istanbul ignore next */ if (typeof self !== 'undefined' && self && property in self) return self;
    /* istanbul ignore next */ if (typeof window !== 'undefined' && window && property in window) return window;
    if (typeof $parcel$global !== 'undefined' && $parcel$global && property in $parcel$global) return $parcel$global;
    /* istanbul ignore next */ if (typeof globalThis !== 'undefined' && globalThis) return globalThis;
};
const $e54711839dd73311$var$globalProperties = [
    'Headers',
    'Request',
    'Response',
    'ReadableStream',
    'fetch',
    'AbortController',
    'FormData'
];
for (const property of $e54711839dd73311$var$globalProperties)Object.defineProperty($e54711839dd73311$var$globals, property, {
    get () {
        const globalObject = $e54711839dd73311$var$getGlobal(property);
        const value = globalObject && globalObject[property];
        return typeof value === 'function' ? value.bind(globalObject) : value;
    }
});
const $e54711839dd73311$var$isObject = (value)=>value !== null && typeof value === 'object';
const $e54711839dd73311$var$supportsAbortController = typeof $e54711839dd73311$var$globals.AbortController === 'function';
const $e54711839dd73311$var$supportsStreams = typeof $e54711839dd73311$var$globals.ReadableStream === 'function';
const $e54711839dd73311$var$deepMerge = (...sources)=>{
    let returnValue = {};
    for (const source of sources){
        if (Array.isArray(source)) {
            if (!Array.isArray(returnValue)) returnValue = [];
            returnValue = [
                ...returnValue,
                ...source
            ];
        } else if ($e54711839dd73311$var$isObject(source)) for (let [key, value] of Object.entries(source)){
            if ($e54711839dd73311$var$isObject(value) && Reflect.has(returnValue, key)) value = $e54711839dd73311$var$deepMerge(returnValue[key], value);
            returnValue = {
                ...returnValue,
                [key]: value
            };
        }
    }
    return returnValue;
};
const $e54711839dd73311$var$requestMethods = [
    'get',
    'post',
    'put',
    'patch',
    'head',
    'delete'
];
const $e54711839dd73311$var$responseTypes = {
    json: 'application/json',
    text: 'text/*',
    formData: 'multipart/form-data',
    arrayBuffer: '*/*',
    blob: '*/*'
};
const $e54711839dd73311$var$retryMethods = [
    'get',
    'put',
    'head',
    'delete',
    'options',
    'trace'
];
const $e54711839dd73311$var$retryStatusCodes = [
    408,
    413,
    429,
    500,
    502,
    503,
    504
];
const $e54711839dd73311$var$retryAfterStatusCodes = [
    413,
    429,
    503
];
const $e54711839dd73311$var$stop = Symbol('stop');
class $e54711839dd73311$export$aa9d629c530f62a7 extends Error {
    constructor(response){
        super(response.statusText);
        this.name = 'HTTPError';
        this.response = response;
    }
}
class $e54711839dd73311$export$66d311bf29d5c89c extends Error {
    constructor(){
        super('Request timed out');
        this.name = 'TimeoutError';
    }
}
const $e54711839dd73311$var$delay = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
// `Promise.race()` workaround (#91)
const $e54711839dd73311$var$timeout = (promise, ms, abortController)=>new Promise((resolve, reject)=>{
        const timeoutID = setTimeout(()=>{
            if (abortController) abortController.abort();
            reject(new $e54711839dd73311$export$66d311bf29d5c89c());
        }, ms);
        /* eslint-disable promise/prefer-await-to-then */ promise.then(resolve).catch(reject).then(()=>{
            clearTimeout(timeoutID);
        });
    /* eslint-enable promise/prefer-await-to-then */ });
const $e54711839dd73311$var$normalizeRequestMethod = (input)=>$e54711839dd73311$var$requestMethods.includes(input) ? input.toUpperCase() : input;
const $e54711839dd73311$var$defaultRetryOptions = {
    limit: 2,
    methods: $e54711839dd73311$var$retryMethods,
    statusCodes: $e54711839dd73311$var$retryStatusCodes,
    afterStatusCodes: $e54711839dd73311$var$retryAfterStatusCodes
};
const $e54711839dd73311$var$normalizeRetryOptions = (retry = {})=>{
    if (typeof retry === 'number') return {
        ...$e54711839dd73311$var$defaultRetryOptions,
        limit: retry
    };
    if (retry.methods && !Array.isArray(retry.methods)) throw new Error('retry.methods must be an array');
    if (retry.statusCodes && !Array.isArray(retry.statusCodes)) throw new Error('retry.statusCodes must be an array');
    return {
        ...$e54711839dd73311$var$defaultRetryOptions,
        ...retry,
        afterStatusCodes: $e54711839dd73311$var$retryAfterStatusCodes
    };
};
// The maximum value of a 32bit int (see issue #117)
const $e54711839dd73311$var$maxSafeTimeout = 2147483647;
class $e54711839dd73311$var$Ky {
    constructor(input, options = {}){
        this._retryCount = 0;
        this._input = input;
        this._options = {
            // TODO: credentials can be removed when the spec change is implemented in all browsers. Context: https://www.chromestatus.com/feature/4539473312350208
            credentials: this._input.credentials || 'same-origin',
            ...options,
            hooks: $e54711839dd73311$var$deepMerge({
                beforeRequest: [],
                beforeRetry: [],
                afterResponse: []
            }, options.hooks),
            method: $e54711839dd73311$var$normalizeRequestMethod(options.method || this._input.method),
            prefixUrl: String(options.prefixUrl || ''),
            retry: $e54711839dd73311$var$normalizeRetryOptions(options.retry),
            throwHttpErrors: options.throwHttpErrors !== false,
            timeout: typeof options.timeout === 'undefined' ? 10000 : options.timeout
        };
        if (typeof this._input !== 'string' && !(this._input instanceof URL || this._input instanceof $e54711839dd73311$var$globals.Request)) throw new TypeError('`input` must be a string, URL, or Request');
        if (this._options.prefixUrl && typeof this._input === 'string') {
            if (this._input.startsWith('/')) throw new Error('`input` must not begin with a slash when using `prefixUrl`');
            if (!this._options.prefixUrl.endsWith('/')) this._options.prefixUrl += '/';
            this._input = this._options.prefixUrl + this._input;
        }
        if ($e54711839dd73311$var$supportsAbortController) {
            this.abortController = new $e54711839dd73311$var$globals.AbortController();
            if (this._options.signal) {
                this._options.signal.addEventListener('abort', ()=>{
                    this.abortController.abort();
                });
                this._options.signal = this.abortController.signal;
            }
        }
        this.request = new $e54711839dd73311$var$globals.Request(this._input, this._options);
        if (this._options.searchParams) {
            const url = new URL(this.request.url);
            url.search = new URLSearchParams(this._options.searchParams);
            this.request = new $e54711839dd73311$var$globals.Request(new $e54711839dd73311$var$globals.Request(url, this.request), this._options);
        }
        if (this._options.json !== undefined) {
            this._options.body = JSON.stringify(this._options.json);
            this.request.headers.set('content-type', 'application/json');
            this.request = new $e54711839dd73311$var$globals.Request(this.request, {
                body: this._options.body
            });
        }
        const fn = async ()=>{
            if (this._options.timeout > $e54711839dd73311$var$maxSafeTimeout) throw new RangeError(`The \`timeout\` option cannot be greater than ${$e54711839dd73311$var$maxSafeTimeout}`);
            await $e54711839dd73311$var$delay(1);
            let response = await this._fetch();
            for (const hook of this._options.hooks.afterResponse){
                // eslint-disable-next-line no-await-in-loop
                const modifiedResponse = await hook(this.request, this._options, response.clone());
                if (modifiedResponse instanceof $e54711839dd73311$var$globals.Response) response = modifiedResponse;
            }
            if (!response.ok && this._options.throwHttpErrors) throw new $e54711839dd73311$export$aa9d629c530f62a7(response);
            // If `onDownloadProgress` is passed, it uses the stream API internally
            /* istanbul ignore next */ if (this._options.onDownloadProgress) {
                if (typeof this._options.onDownloadProgress !== 'function') throw new TypeError('The `onDownloadProgress` option must be a function');
                if (!$e54711839dd73311$var$supportsStreams) throw new Error('Streams are not supported in your environment. `ReadableStream` is missing.');
                return this._stream(response.clone(), this._options.onDownloadProgress);
            }
            return response;
        };
        const isRetriableMethod = this._options.retry.methods.includes(this.request.method.toLowerCase());
        const result = isRetriableMethod ? this._retry(fn) : fn();
        for (const [type, mimeType] of Object.entries($e54711839dd73311$var$responseTypes))result[type] = async ()=>{
            this.request.headers.set('accept', this.request.headers.get('accept') || mimeType);
            const response = (await result).clone();
            return type === 'json' && response.status === 204 ? '' : response[type]();
        };
        return result;
    }
    _calculateRetryDelay(error) {
        this._retryCount++;
        if (this._retryCount < this._options.retry.limit && !(error instanceof $e54711839dd73311$export$66d311bf29d5c89c)) {
            if (error instanceof $e54711839dd73311$export$aa9d629c530f62a7) {
                if (!this._options.retry.statusCodes.includes(error.response.status)) return 0;
                const retryAfter = error.response.headers.get('Retry-After');
                if (retryAfter && this._options.retry.afterStatusCodes.includes(error.response.status)) {
                    let after = Number(retryAfter);
                    if (Number.isNaN(after)) after = Date.parse(retryAfter) - Date.now();
                    else after *= 1000;
                    if (typeof this._options.retry.maxRetryAfter !== 'undefined' && after > this._options.retry.maxRetryAfter) return 0;
                    return after;
                }
                if (error.response.status === 413) return 0;
            }
            const BACKOFF_FACTOR = 0.3;
            return BACKOFF_FACTOR * 2 ** (this._retryCount - 1) * 1000;
        }
        return 0;
    }
    async _retry(fn) {
        try {
            return await fn();
        } catch (error) {
            const ms = Math.min(this._calculateRetryDelay(error), $e54711839dd73311$var$maxSafeTimeout);
            if (ms !== 0 && this._retryCount > 0) {
                await $e54711839dd73311$var$delay(ms);
                for (const hook of this._options.hooks.beforeRetry){
                    // eslint-disable-next-line no-await-in-loop
                    const hookResult = await hook(this.request, this._options, error, this._retryCount);
                    // If `stop` is returned from the hook, the retry process is stopped
                    if (hookResult === $e54711839dd73311$var$stop) return;
                }
                return this._retry(fn);
            }
            if (this._options.throwHttpErrors) throw error;
        }
    }
    async _fetch() {
        for (const hook of this._options.hooks.beforeRequest){
            // eslint-disable-next-line no-await-in-loop
            const result = await hook(this.request, this._options);
            if (result instanceof Request) {
                this.request = result;
                break;
            }
            if (result instanceof Response) return result;
        }
        if (this._options.timeout === false) return $e54711839dd73311$var$globals.fetch(this.request);
        return $e54711839dd73311$var$timeout($e54711839dd73311$var$globals.fetch(this.request), this._options.timeout, this.abortController);
    }
    /* istanbul ignore next */ _stream(response, onDownloadProgress) {
        const totalBytes = Number(response.headers.get('content-length')) || 0;
        let transferredBytes = 0;
        return new $e54711839dd73311$var$globals.Response(new $e54711839dd73311$var$globals.ReadableStream({
            start (controller) {
                const reader = response.body.getReader();
                if (onDownloadProgress) onDownloadProgress({
                    percent: 0,
                    transferredBytes: 0,
                    totalBytes: totalBytes
                }, new Uint8Array());
                async function read() {
                    const { done: done, value: value } = await reader.read();
                    if (done) {
                        controller.close();
                        return;
                    }
                    if (onDownloadProgress) {
                        transferredBytes += value.byteLength;
                        const percent = totalBytes === 0 ? 0 : transferredBytes / totalBytes;
                        onDownloadProgress({
                            percent: percent,
                            transferredBytes: transferredBytes,
                            totalBytes: totalBytes
                        }, value);
                    }
                    controller.enqueue(value);
                    read();
                }
                read();
            }
        }));
    }
}
const $e54711839dd73311$var$validateAndMerge = (...sources)=>{
    for (const source of sources){
        if ((!$e54711839dd73311$var$isObject(source) || Array.isArray(source)) && typeof source !== 'undefined') throw new TypeError('The `options` argument must be an object');
    }
    return $e54711839dd73311$var$deepMerge({}, ...sources);
};
const $e54711839dd73311$var$createInstance = (defaults)=>{
    const ky = (input, options)=>new $e54711839dd73311$var$Ky(input, $e54711839dd73311$var$validateAndMerge(defaults, options));
    for (const method of $e54711839dd73311$var$requestMethods)ky[method] = (input, options)=>new $e54711839dd73311$var$Ky(input, $e54711839dd73311$var$validateAndMerge(defaults, options, {
            method: method
        }));
    ky.create = (newDefaults)=>$e54711839dd73311$var$createInstance($e54711839dd73311$var$validateAndMerge(newDefaults));
    ky.extend = (newDefaults)=>$e54711839dd73311$var$createInstance($e54711839dd73311$var$validateAndMerge(defaults, newDefaults));
    ky.stop = $e54711839dd73311$var$stop;
    return ky;
};
var $e54711839dd73311$export$2e2bcd8739ae039 = $e54711839dd73311$var$createInstance();

});


parcelRegister("gsf25", function(module, exports) {

$parcel$export(module.exports, "parseError", () => $bfaaec0c999e8fbf$export$e80a9284539c1797);
$parcel$export(module.exports, "makeAPIError", () => $bfaaec0c999e8fbf$export$d5526006016d9ee2);

var $h1LeU = parcelRequire("h1LeU");
async function $bfaaec0c999e8fbf$export$e80a9284539c1797(error) {
    var _error$response;
    let response;
    if (error.response) try {
        response = await error.response.json();
    } catch (_unused) {
        try {
            response = await error.response.text();
        } catch (_unused2) {
            console.error('parseError: failed to parse response', error);
        }
    }
    return {
        status: (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status,
        response: response
    };
}
function $bfaaec0c999e8fbf$export$d5526006016d9ee2(_ref) {
    let { name: name, code: code, response: response } = _ref;
    const APIError = (0, $h1LeU.default)(name);
    return new APIError({
        code: code,
        message: "".concat(name, " error"),
        meta: {
            response: response
        }
    });
}

});

parcelRegister("2c2FY", function(module, exports) {

$parcel$export(module.exports, "default", () => $198ec72bb799401e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $c0UlX = parcelRequire("c0UlX");

var $1oMwC = parcelRequire("1oMwC");
function $198ec72bb799401e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $198ec72bb799401e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $198ec72bb799401e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $198ec72bb799401e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $198ec72bb799401e$export$2e2bcd8739ae039(self) {
    return {
        async appInstallPermission (product, cloudId) {
            const productAdminPermittedPromise = self.permitted((0, $c0UlX.StargatePermissionId).MANAGE, "ari:cloud:".concat(product, "::site/").concat(cloudId));
            const siteAdminPermittedPromise = self.permitted((0, $c0UlX.StargatePermissionId).MANAGE, "ari:cloud:platform::site/".concat(cloudId));
            const [productAdminPermission, siteAdminPermission] = await Promise.all([
                productAdminPermittedPromise,
                siteAdminPermittedPromise
            ]);
            return siteAdminPermission.permitted ? (0, $c0UlX.AppInstallPermission).CAN_INSTALL_FREE_AND_PAID : productAdminPermission.permitted ? (0, $c0UlX.AppInstallPermission).CAN_INSTALL_FREE_ONLY : (0, $c0UlX.AppInstallPermission).CANNOT_INSTALL;
        },
        async availableSites (products) {
            const stargateProducts = (0, $1oMwC.toStargateProducts)(products);
            const { sites: sites } = await self.availableSites(stargateProducts);
            const marketplaceSites = sites.map((site)=>$198ec72bb799401e$var$_objectSpread($198ec72bb799401e$var$_objectSpread({}, site), {}, {
                    products: (0, $1oMwC.toMarketplaceProducts)(site.products)
                }));
            return {
                sites: marketplaceSites
            };
        }
    };
}

});




parcelRegister("4J2mT", function(module, exports) {

$parcel$export(module.exports, "default", () => $370d33b009b124df$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $je2Cw = parcelRequire("je2Cw");

var $dO8LH = parcelRequire("dO8LH");

var $k4nIh = parcelRequire("k4nIh");

var $gQV53 = parcelRequire("gQV53");
var $370d33b009b124df$var$_class;
const $370d33b009b124df$var$getStargateMarketplaceUrl = (siteBaseUrl, stargatePath)=>"".concat(siteBaseUrl, "/gateway/api/marketplace").concat(stargatePath);
let $370d33b009b124df$var$StargateMarketplaceApi = ($370d33b009b124df$var$_class = class StargateMarketplaceApi {
    constructor(config){
        (0, $5zQU9.default)(this, "config", void 0);
        (0, $5zQU9.default)(this, "siteBaseUrl", void 0);
        this.config = config;
        // Stargate APIs are available only on the base url excluding wiki
        this.siteBaseUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(this.config.baseUrl).origin;
    }
    async fetchOk(url, options) {
        let response;
        try {
            response = await (0, $dO8LH.fetchOk)($370d33b009b124df$var$getStargateMarketplaceUrl(this.siteBaseUrl, url), options);
            const responseJson = await response.json();
            return Promise.resolve(responseJson);
        } catch (error) {
            if (response && response.ok) return Promise.resolve({
                status: response.status
            });
            return Promise.reject(error);
        }
    }
    async fetch(url, options) {
        return (0, $dO8LH.fetch)($370d33b009b124df$var$getStargateMarketplaceUrl(this.siteBaseUrl, url), options);
    }
}, (0, $je2Cw.default)($370d33b009b124df$var$_class.prototype, "fetchOk", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($370d33b009b124df$var$_class.prototype, "fetchOk"), $370d33b009b124df$var$_class.prototype), (0, $je2Cw.default)($370d33b009b124df$var$_class.prototype, "fetch", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($370d33b009b124df$var$_class.prototype, "fetch"), $370d33b009b124df$var$_class.prototype), $370d33b009b124df$var$_class);
var $370d33b009b124df$export$2e2bcd8739ae039 = (config)=>(0, $gQV53.instanceToModule)(new $370d33b009b124df$var$StargateMarketplaceApi(config));

});

parcelRegister("lpNoO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9724069834fcc01$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $je2Cw = parcelRequire("je2Cw");

var $dO8LH = parcelRequire("dO8LH");

var $gQV53 = parcelRequire("gQV53");
var $f9724069834fcc01$var$_class;
let $f9724069834fcc01$var$User = ($f9724069834fcc01$var$_class = class User {
    constructor(config){
        (0, $5zQU9.default)(this, "config", void 0);
        this.config = config;
    }
    async getCurrentUser() {
        const response = await (0, $dO8LH.fetchOk)('/gateway/api/me');
        const result = await response.json();
        return {
            atlassianAccountId: result.account_id,
            name: result.name,
            avatarUrl: result.picture,
            email: result.email
        };
    }
    revokeUserGrant(_options) {
        return Promise.reject();
    }
}, (0, $je2Cw.default)($f9724069834fcc01$var$_class.prototype, "getCurrentUser", [
    (0, $gQV53.returnsPromise)
], Object.getOwnPropertyDescriptor($f9724069834fcc01$var$_class.prototype, "getCurrentUser"), $f9724069834fcc01$var$_class.prototype), (0, $je2Cw.default)($f9724069834fcc01$var$_class.prototype, "revokeUserGrant", [
    (0, $gQV53.returnsPromise),
    (0, $gQV53.unsupported)
], Object.getOwnPropertyDescriptor($f9724069834fcc01$var$_class.prototype, "revokeUserGrant"), $f9724069834fcc01$var$_class.prototype), $f9724069834fcc01$var$_class);
var $f9724069834fcc01$export$2e2bcd8739ae039 = (config)=>(0, $gQV53.instanceToModule)(new $f9724069834fcc01$var$User(config));

});


parcelRegister("7DEW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $58fbedf742f1da91$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $8SD4O = parcelRequire("8SD4O");

var $jkLPm = parcelRequire("jkLPm");

var $1fIAX = parcelRequire("1fIAX");

var $1S6Gv = parcelRequire("1S6Gv");
var $ighTk = parcelRequire("ighTk");

var $5sMiL = parcelRequire("5sMiL");

var $eUqFw = parcelRequire("eUqFw");

var $3dvqV = parcelRequire("3dvqV");

var $iUPNF = parcelRequire("iUPNF");

var $8AYXA = parcelRequire("8AYXA");

var $jdziS = parcelRequire("jdziS");

var $55gtq = parcelRequire("55gtq");

var $iBvuY = parcelRequire("iBvuY");

var $lHkHI = parcelRequire("lHkHI");
function $58fbedf742f1da91$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $58fbedf742f1da91$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $58fbedf742f1da91$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $58fbedf742f1da91$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $58fbedf742f1da91$var$SentryGlobalListeners = (_ref)=>{
    let { children: children, onExternalSentryEvent: onExternalSentryEvent } = _ref;
    (0, $eUqFw.useEffect)(()=>{
        if (onExternalSentryEvent) (0, $1S6Gv.attachGlobalSentryListeners)(onExternalSentryEvent);
        return 0, $1S6Gv.detachSentryListeners;
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: children
    });
};
const $58fbedf742f1da91$var$Emcee = (_ref2)=>{
    let { spi: spi, history: productHistory, productVersion: productVersion, applicationConfig: applicationConfig, mountPath: mountPath, onExternalSentryEvent: onExternalSentryEvent, onRouteTransitionEnd: onRouteTransitionEnd } = _ref2;
    const isDev = applicationConfig.environment === 'local' || applicationConfig.environment === 'dev';
    const releaseVersion = "EMCEE_NATIVE_".concat((0, $iUPNF.default)).concat(isDev ? '-dev' : '');
    (0, $55gtq.initSPI)(spi);
    (0, $3dvqV.setConfiguration)({
        maxScreenClass: 'xl'
    });
    const statsigClient = (0, $eUqFw.useMemo)(()=>new (0, $jkLPm.StatsigClient)(), []);
    (0, $1S6Gv.initSentry)($58fbedf742f1da91$var$_objectSpread($58fbedf742f1da91$var$_objectSpread({}, applicationConfig.sentry), {}, {
        releaseVersion: releaseVersion,
        productVersion: productVersion,
        setupGlobalListeners: false
    }));
    const { reduxStore: reduxStore } = (0, $eUqFw.useMemo)(()=>({
            reduxStore: (0, $jdziS.createReduxStore)()
        }), []);
    const algoliaClient = (0, $eUqFw.useMemo)(()=>(0, $8SD4O.AddonDiscoveryUtils).createAlgoliaClient(applicationConfig.algolia), [
        applicationConfig.algolia
    ]);
    const bootstrapConfig = (0, $eUqFw.useMemo)(()=>$58fbedf742f1da91$var$_objectSpread($58fbedf742f1da91$var$_objectSpread({}, applicationConfig), {}, {
            isInProductConnectModule: false,
            isManageAppRequests: false,
            isManagePromotions: false,
            releaseVersion: releaseVersion,
            source: (0, $1fIAX.Source).PRODUCT
        }), [
        applicationConfig,
        releaseVersion
    ]);
    (0, $eUqFw.useEffect)(()=>{
        (0, $iBvuY.default)({
            emceeContainer: document.getElementById('emcee'),
            config: applicationConfig.metal,
            SPI: spi,
            emceeVersion: releaseVersion,
            onRouteTransitionEnd: onRouteTransitionEnd
        });
        return ()=>{
            (0, $ighTk.resetSentryClient)();
        };
    }, []);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5sMiL.default), {
        name: "emcee-root",
        children: /*#__PURE__*/ (0, $lHkHI.jsx)($58fbedf742f1da91$var$SentryGlobalListeners, {
            onExternalSentryEvent: onExternalSentryEvent,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8AYXA.default), {
                bootstrapConfig: bootstrapConfig,
                store: reduxStore,
                history: productHistory,
                algoliaClient: algoliaClient,
                onBootstrapConfigChange: ()=>{
                /*
          [legacy] Was used in Emcee Connect to act upon config changes via the DevTools, has no
          usage in Emcee Native
          */ },
                mountPath: mountPath,
                statsigClient: statsigClient
            })
        })
    });
};
var $58fbedf742f1da91$export$2e2bcd8739ae039 = $58fbedf742f1da91$var$Emcee;

});
parcelRegister("8SD4O", function(module, exports) {

$parcel$export(module.exports, "default", () => $6771adaca34c8785$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AddonDiscoveryUtils", () => $6771adaca34c8785$export$99d0ea0fe8a5ff34);

var $dmAP6 = parcelRequire("dmAP6");
var $4fL5K = parcelRequire("4fL5K");
var $arYdl = parcelRequire("arYdl");

var $5YKni = parcelRequire("5YKni");

var $ieOz2 = parcelRequire("ieOz2");



var $lwEMm = parcelRequire("lwEMm");


var $eMCmH = parcelRequire("eMCmH");

var $ELb1a = parcelRequire("ELb1a");

var $b5Eig = parcelRequire("b5Eig");

var $bavaN = parcelRequire("bavaN");

var $8HDz3 = parcelRequire("8HDz3");



var $62VCw = parcelRequire("62VCw");

var $1zZny = parcelRequire("1zZny");

var $6XDNr = parcelRequire("6XDNr");
var $6771adaca34c8785$export$2e2bcd8739ae039 = (0, $dmAP6.default);
const $6771adaca34c8785$export$99d0ea0fe8a5ff34 = (0, $arYdl.Utils);

});
parcelRegister("dmAP6", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ba9e4c66119a1bd$export$2e2bcd8739ae039);

var $lgRZl = parcelRequire("lgRZl");

var $biTOe = parcelRequire("biTOe");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("jJs3W");
var $b02ud = parcelRequire("b02ud");


var $90ON9 = parcelRequire("90ON9");

var $dfDXD = parcelRequire("dfDXD");

var $b5Eig = parcelRequire("b5Eig");

var $emLm3 = parcelRequire("emLm3");

var $8OnOc = parcelRequire("8OnOc");

var $3ONu7 = parcelRequire("3ONu7");


var $6jEcw = parcelRequire("6jEcw");

var $8M3um = parcelRequire("8M3um");

var $5cT8z = parcelRequire("5cT8z");

var $lHkHI = parcelRequire("lHkHI");
const $9ba9e4c66119a1bd$var$App = (props)=>{
    const store = (0, $eUqFw.useMemo)(()=>(0, $emLm3.default)({
            debug: props.debug,
            reducer: $5cT8z.default
        }), []);
    const getDiscoverCollectionsConfig = ()=>{
        return (0, $3ONu7.default)({
            featuredAddonsConfig: props.featuredAddonsConfig,
            options: {}
        });
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $b02ud.default), {
        store: store,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8M3um.default), {
            discoverCollectionsConfig: getDiscoverCollectionsConfig(),
            algoliaClient: props.algoliaClient || (0, $8OnOc.createAlgoliaClient)(props.algoliaConfig.toObject()),
            applyOverrides: props.applyOverrides,
            className: props.className,
            colSpan: props.colSpan,
            containerClassName: props.containerClassName,
            debug: props.debug,
            environment: props.environment,
            externalFacets: props.externalFacets,
            featuredContentOverride: props.featuredContentOverride,
            filtersContext: props.filtersContext,
            filters: props.filters,
            hiddenFilters: props.hiddenFilters,
            hideHeading: props.hideHeading,
            hitContext: props.hitContext,
            hideTextSearch: props.hideTextSearch,
            perspective: props.perspective,
            resolveAlgoliaQueryFilterOverrides: props.resolveAlgoliaQueryFilterOverrides,
            screenClass: props.screenClass,
            stateChangeRequested: props.stateChangeRequested,
            heroComponent: props.heroComponent,
            topPanel: props.topPanel,
            recommendationsPanel: props.recommendationsPanel,
            transitions: props.transitions,
            discoverHeading: props.discoverHeading,
            overrideLargeHitRightContent: props.overrideLargeHitRightContent,
            showBrowseHeading: props.showBrowseHeading
        })
    });
};
$9ba9e4c66119a1bd$var$App.propTypes = {
    /**
   * Specifies if the filters are applied or not. Omits hidden filters
   */ showBrowseHeading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * A node to be injected for showing recommended apps
   */ recommendationsPanel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    /**
   * Algolia config, ie. Application and API keys
   *
   * shape: Map({
   *      applicationId: string,
   *      apiKey: string
   * })
   *
   * Required if Algolia Client is not provided
   */ algoliaConfig: (0, $lgRZl.default).requiredIf((0, $90ON9.default).algoliaConfig, (props)=>!props.algoliaClient),
    /**
   * Algolia search client for maintaining cache between searches
   * Provided by third-party algoliasearch library, and not dereferenced
   *
   * shape: any (but must have AlgoliaClient class name)
   *
   * Required if Algolia Config is not provided
   */ algoliaClient: (0, $lgRZl.default).requiredIf((0, $90ON9.default).algoliaClient, (props)=>!props.algoliaConfig),
    /**
   * A SearchParamsUpdate where:
   * types: Set<FacetType>
   * apply: (AlgoliaSearchHelper.SearchParameters) => AlgoliaSearchHelper.SearchParameters
   *
   * `types` lets you define a set of facets that aren't already known to Addon Discovery but are defined
   * in Algolia. `apply` lets you apply relevant filtering to the SearchParameters.
   */ applyOverrides: (0, $b5Eig.SearchParamsUpdatePropType),
    /**
   * A class name to apply to the top-level element of Addon Discovery.
   */ className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    /**
   * Given a hit type (small tiles or large tiles), and a `screenClass`, how many
   * "columns" should a hit take up? 12 columns = 100% width, so setting "largeHits" and
   * "xl" to `4` means that on the largest screens, there will be 3 hits per row.
   * If specified, this property should contain every combination of hit type and `screenClass`.
   *
   * shape: Map({
   *      xl: number (optional),
   *      lg: number (optional),
   *      md: number (optional),
   *      sm: number (optional),
   *      xs: number (optional)
   * })
   */ colSpan: (0, $90ON9.default).colSpan,
    /**
   * A class name to apply to the top-level element of Addon Discovery, not including the `heroComponent`.
   */ containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    /**
   * When true, will turn on debug mode.
   */ debug: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * A node to be injected at the top of all perspectives, above the search box and facets.
   */ discoverHeading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    /**
   * Which environment we are running in.
   */ environment: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        (0, $658e6bd3ffbfdac1$export$404582bc18fe4d9e),
        (0, $658e6bd3ffbfdac1$export$46be287603848c56),
        (0, $658e6bd3ffbfdac1$export$e51cdc15d0c6bee2)
    ]).isRequired,
    /**
   * A node to be injected underneath the facets. Typically used when you want to add custom links.
   */ externalFacets: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    /**
   * List<FeaturedContentOverride>
   * For each FeaturedContentOverride, we will always render the node from `render()` in place of the
   * tile at `index`.
   */ featuredContentOverride: (0, $90ON9.default).contentOverrides,
    /**
   * Map<string, Set<string>>
   * "Staff picks" for each product. The key represents a product key (`jira`, `bitbucket` etc.) and
   * the value is a set of 6 app keys in Marketplace. Not all supported products need to be specified.
   */ featuredAddonsConfig: (0, $dfDXD.FeaturedAddonsConfigPropType),
    /**
   * Map({
   *   discoverFacetHrefResolver: ({ filters: Filters }) => string
   *   searchFacetHrefResolver: ({ filters: Filters }) => string
   * })
   * Functions that each take filters and return a URL that, when visited, displays the same view
   * but with the given filters pre-applied.
   * Each returned URL will be set as the `href` on the corresponding filter link, so that new-tab-openers
   * can still have filters applied, and search engines can crawl and index your filters.
   */ filtersContext: (0, $6jEcw.default).filtersContext.isRequired,
    /**
   * Map<string, string | Set<string>>
   * The filters to apply to the search facets. Each key corresponds to a facet name.
   * Accepts "unenhanced" filters, meaning that for filters that accept
   * multiple values, it will also accept a single value.
   */ filters: (0, $90ON9.default).unenhancedFilters,
    heroComponent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * Map<string, bool | Set<string>>
   * Configure which facets are not visible or editable by the user. For example, if embedding in JIRA,
   * you don't want the user to select a different product.
   * With the key being a facet (eg. `product` or `sort`), set the value to `true` to hide the
   * whole facet, or to a set of strings to hide just the facet values within that set.
   */ hiddenFilters: (0, $6jEcw.default).hiddenFilters,
    /**
   * When true, it will hide the default heading at the top of both the discover and search perspectives.
   */ hideHeading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * When true, it will hide the default search textbox.
   */ hideTextSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * A map of callbacks for when hit-related actions occur such as click or mount, plus
   * functions for resolving relative URLs in search results into absolute URLs.
   *
   * shape: Map({
   *      hitHrefResolver: function (optional),
   *      hitImageHrefResolver: function,
   *      onHitClick: function,
   *      onHitMount: function (optional),
   *      onRatingsClick: function (optional)
   * })
   */ hitContext: (0, $90ON9.default).hitContext.isRequired,
    /**
   * The perspective to show. `discover` refers to the front page containing curated results or
   * multiple "top" searches. `search` shows only search results.
   */ perspective: (0, $6jEcw.default).perspective,
    /**
   * Map<string,
   *     ({ params: AlgoliaSearchHelper.SearchParameters, filters: Filters }) => AlgoliaSearchHelper.SearchParameters>
   * With the key being a facet, each function allows low-level modifications to the SearchParameters sent to Algolia.
   */ resolveAlgoliaQueryFilterOverrides: (0, $90ON9.default).resolveAlgoliaQueryFilterOverrides,
    /**
   * "xl" | "lg" | "md" | "sm" | "xs"
   * Which "responsive view" to render, based on browser window size. Generally, you will use
   * ScreenClassRender from react-grid-system and pass in the value from that.
   */ screenClass: (0, $90ON9.default).screenClass,
    /**
   * ({ perspective, filters }) => void
   * Addon Discovery is stateless. Use this callback to listen for when Addon Discovery requests any changes in state.
   * It's up to the embedder to update our props as it sees fit whenever we request a state change.
   */ stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    /**
   * A node to be injected at the top of the discover or search perspective, and beside the facets.
   */ topPanel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    /**
   * A map of callbacks for when a view transition starts or ends.
   *
   * shape: Map({
   *      transitionStarted: function (optional),
   *      transitionComplete: function (optional)
   * })
   */ transitions: (0, $90ON9.default).transitions,
    /**
   * (appkey: string) => ?React.Node
   *  This callback used to override LargeHit right content
   *  Returns React.Node to override
   */ overrideLargeHitRightContent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
};
$9ba9e4c66119a1bd$var$App.defaultProps = {
    applyOverrides: (0, $b5Eig.default).default_(),
    colSpan: (0, $g5DHJ.Map)(),
    debug: false,
    filters: (0, $g5DHJ.Map)(),
    hiddenFilters: (0, $g5DHJ.Map)(),
    hideHeading: false,
    hideTextSearch: false,
    perspective: (0, $37a31921fd56c86d$export$27b2e48e28163360),
    screenClass: 'xl',
    featuredAddonsConfig: new (0, $dfDXD.FeaturedAddonsConfig)()
};
var $9ba9e4c66119a1bd$export$2e2bcd8739ae039 = (0, $biTOe.withFeatureFlags)($9ba9e4c66119a1bd$var$App);

});
parcelRegister("lgRZl", function(module, exports) {

$parcel$export(module.exports, "default", () => $03ff0c44770159d9$export$2e2bcd8739ae039);

var $1Qivz = parcelRequire("1Qivz");
var $03ff0c44770159d9$export$2e2bcd8739ae039 = {
    requiredIf (type, condition) {
        return function(props) {
            const test = condition(props) ? type.isRequired : type; // eslint-disable-next-line prefer-rest-params
            return test.apply(this, arguments);
        };
    },
    screenClass: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        'xl',
        'lg',
        'md',
        'sm',
        'xs'
    ])
};

});

parcelRegister("biTOe", function(module, exports) {

$parcel$export(module.exports, "withFeatureFlags", () => $83acaab187a6f443$export$871b61ce44f2bb3a);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("eUqFw");

var $inwKI = parcelRequire("inwKI");

var $lHkHI = parcelRequire("lHkHI");
function $83acaab187a6f443$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $83acaab187a6f443$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $83acaab187a6f443$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $83acaab187a6f443$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $83acaab187a6f443$export$871b61ce44f2bb3a(Component) {
    const WrappedComponent = (props)=>{
        const featureFlags = (0, $inwKI.useFeatureFlags)();
        return /*#__PURE__*/ (0, $lHkHI.jsx)(Component, $83acaab187a6f443$var$_objectSpread($83acaab187a6f443$var$_objectSpread({}, featureFlags), props));
    };
    WrappedComponent.displayName = "withFeatureFlags(".concat(Component.displayName, ")");
    return WrappedComponent;
}

});
parcelRegister("inwKI", function(module, exports) {

$parcel$export(module.exports, "FeatureFlagsProvider", () => $d613c7f31008c942$export$6d7e43f2d6e1c7c6);
$parcel$export(module.exports, "useFeatureFlags", () => $d613c7f31008c942$export$90335b3ff08f335);

var $eUqFw = parcelRequire("eUqFw");

var $d5mip = parcelRequire("d5mip");
const $d613c7f31008c942$var$FeatureFlagsContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext((0, $d5mip.DEFAULT_MARKETPLACE_FEATURE_FLAGS));
const $d613c7f31008c942$export$6d7e43f2d6e1c7c6 = $d613c7f31008c942$var$FeatureFlagsContext.Provider;
function $d613c7f31008c942$export$90335b3ff08f335() {
    return (0, $eUqFw.useContext)($d613c7f31008c942$var$FeatureFlagsContext);
}

});
parcelRegister("d5mip", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_MARKETPLACE_FEATURE_FLAGS", () => $986d097efb87e48f$export$7abc7769c16a0fd6);

var $1lmYm = parcelRequire("1lmYm");
const $986d097efb87e48f$export$7abc7769c16a0fd6 = {
    replaceCategoriesOnAppTilesWithVendorName: false,
    enableBugBountyProgram: false,
    showCustomBackendErrorsFromUpm: false,
    enableFreeStarterTierFilter: false,
    disableAppInstall: false,
    showManageAppRequestAlternativeLayout: false,
    disableAllHostingFromPromotionsDropdown: false,
    enableInContextAppRequest: false,
    enableInProductHelpPartnerReporting: false,
    showTrustSignalsInManageAppRequests: false,
    showDatePickerOnManagePricingTab: false,
    showQualtricsSurvey: false,
    enableRetryForLicenseDetailsPostInstallation: false,
    allowSectionMessageForPartnersForMigrationToCcp: [],
    enableIncludePartnerForAllowSectionMessageForMigrationToCcp: false,
    enableReactivateForgeAppFromEmcee: false,
    enableReactivateForgeAppFromEmceeForHAMS: false,
    enableDualLicenseToggleInPartnersTable: false,
    enablePrefixCodeSectionForGenericCloudPromotions: false,
    enableBacRedirectionForCcpPromotions: false,
    enableMpacServerEolWarning: false,
    enableFiftyKPricingTiers: false,
    useAnalyticsWebClient: false,
    enableDeprecatedInstallationsGQL: false,
    enableV2SearchIndex: false,
    partnersNavigationRefresh: false,
    enablePartnerPaymentsViaConsoleBff: false,
    maintenanceBannerConfiguration: (0, $1lmYm.MaintenanceNone),
    privacySecurityTabDataResidency: false,
    useAnalyticsWebClientForPartnerEvents: false,
    showCommunityLicensesUnderPaidFilter: false,
    enablecapabilitysets: []
};

});
parcelRegister("1lmYm", function(module, exports) {

$parcel$export(module.exports, "MAINTENANCE_TYPE", () => $0fa992813a9efe2d$export$31f47edd0bcc48ff);
$parcel$export(module.exports, "MAINTENANCE_STATE", () => $0fa992813a9efe2d$export$8a69e83ecdbdde43);
$parcel$export(module.exports, "MAINTENANCE_BANNER_TARGET_PAGES", () => $0fa992813a9efe2d$export$d0f207d82e583b99);
$parcel$export(module.exports, "MaintenanceNone", () => $0fa992813a9efe2d$export$3f6ca9ffd8c7b46e);
let $0fa992813a9efe2d$export$31f47edd0bcc48ff = /*#__PURE__*/ function(MAINTENANCE_TYPE) {
    MAINTENANCE_TYPE["NONE"] = "maintenance-none";
    MAINTENANCE_TYPE["NO_CAPABILITIES_DISRUPTION"] = "no-disruption";
    MAINTENANCE_TYPE["WITH_CAPABILITIES_DISRUPTION"] = "with-disruption";
    return MAINTENANCE_TYPE;
}({});
let $0fa992813a9efe2d$export$8a69e83ecdbdde43 = /*#__PURE__*/ function(MAINTENANCE_STATE) {
    MAINTENANCE_STATE["SCHEDULED"] = "scheduled";
    MAINTENANCE_STATE["IN_PROGRESS"] = "in-progress";
    return MAINTENANCE_STATE;
}({});
let $0fa992813a9efe2d$export$d0f207d82e583b99 = /*#__PURE__*/ function(MAINTENANCE_BANNER_TARGET_PAGES) {
    MAINTENANCE_BANNER_TARGET_PAGES["ALL"] = "all";
    MAINTENANCE_BANNER_TARGET_PAGES["MARKETPLACE_PARTNER_PORTAL"] = "marketplace-partner-portal";
    return MAINTENANCE_BANNER_TARGET_PAGES;
}({});
const $0fa992813a9efe2d$export$3f6ca9ffd8c7b46e = {
    type: $0fa992813a9efe2d$export$31f47edd0bcc48ff.NONE,
    content: ''
};

});




parcelRegister("g5DHJ", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "isImmutable", () => isImmutable);
$parcel$export(module.exports, "isCollection", () => isCollection);
$parcel$export(module.exports, "isKeyed", () => isKeyed);
$parcel$export(module.exports, "isIndexed", () => isIndexed);
$parcel$export(module.exports, "isAssociative", () => isAssociative);
$parcel$export(module.exports, "isOrdered", () => isOrdered);
$parcel$export(module.exports, "isValueObject", () => isValueObject);
$parcel$export(module.exports, "Collection", () => Collection);
$parcel$export(module.exports, "Seq", () => Seq);
$parcel$export(module.exports, "is", () => is);
$parcel$export(module.exports, "hash", () => hash);
$parcel$export(module.exports, "Map", () => Map);
$parcel$export(module.exports, "OrderedMap", () => OrderedMap);
$parcel$export(module.exports, "has", () => has);
$parcel$export(module.exports, "get", () => get);
$parcel$export(module.exports, "remove", () => remove);
$parcel$export(module.exports, "set", () => set);
$parcel$export(module.exports, "updateIn", () => updateIn);
$parcel$export(module.exports, "setIn", () => setIn$1);
$parcel$export(module.exports, "removeIn", () => removeIn);
$parcel$export(module.exports, "update", () => update$1);
$parcel$export(module.exports, "merge", () => merge$1);
$parcel$export(module.exports, "mergeWith", () => mergeWith$1);
$parcel$export(module.exports, "mergeDeep", () => mergeDeep$1);
$parcel$export(module.exports, "mergeDeepWith", () => mergeDeepWith$1);
$parcel$export(module.exports, "List", () => List);
$parcel$export(module.exports, "Stack", () => Stack);
$parcel$export(module.exports, "Set", () => Set);
$parcel$export(module.exports, "OrderedSet", () => OrderedSet);
$parcel$export(module.exports, "Range", () => Range);
$parcel$export(module.exports, "getIn", () => getIn$1);
$parcel$export(module.exports, "hasIn", () => hasIn$1);
$parcel$export(module.exports, "Record", () => Record);
$parcel$export(module.exports, "Repeat", () => Repeat);
$parcel$export(module.exports, "fromJS", () => fromJS);
$parcel$export(module.exports, "version", () => version);
$parcel$export(module.exports, "Iterable", () => Iterable);
$parcel$export(module.exports, "default", () => $bb6be968fd3babc9$export$2e2bcd8739ae039);
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ // Used for setting prototype methods that IE8 chokes on.
var DELETE = 'delete';
// Constants describing the size of trie nodes.
var SHIFT = 5; // Resulted in best performance after ______?
var SIZE = 1 << SHIFT;
var MASK = SIZE - 1;
// A consistent shared value representing "not set" which equals nothing other
// than itself, and nothing that could be provided externally.
var NOT_SET = {};
// Boolean references, Rough equivalent of `bool &`.
var CHANGE_LENGTH = {
    value: false
};
var DID_ALTER = {
    value: false
};
function MakeRef(ref) {
    ref.value = false;
    return ref;
}
function SetRef(ref) {
    ref && (ref.value = true);
}
// A function which returns a value representing an "owner" for transient writes
// to tries. The return value will only ever equal itself, and will not equal
// the return of any subsequent call of this function.
function OwnerID() {}
function ensureSize(iter) {
    if (iter.size === undefined) iter.size = iter.__iterate(returnTrue);
    return iter.size;
}
function wrapIndex(iter, index) {
    // This implements "is array index" which the ECMAString spec defines as:
    //
    //     A String property name P is an array index if and only if
    //     ToString(ToUint32(P)) is equal to P and ToUint32(P) is not equal
    //     to 2^32−1.
    //
    // http://www.ecma-international.org/ecma-262/6.0/#sec-array-exotic-objects
    if (typeof index !== 'number') {
        var uint32Index = index >>> 0; // N >>> 0 is shorthand for ToUint32
        if ('' + uint32Index !== index || uint32Index === 4294967295) return NaN;
        index = uint32Index;
    }
    return index < 0 ? ensureSize(iter) + index : index;
}
function returnTrue() {
    return true;
}
function wholeSlice(begin, end, size) {
    return (begin === 0 && !isNeg(begin) || size !== undefined && begin <= -size) && (end === undefined || size !== undefined && end >= size);
}
function resolveBegin(begin, size) {
    return resolveIndex(begin, size, 0);
}
function resolveEnd(end, size) {
    return resolveIndex(end, size, size);
}
function resolveIndex(index, size, defaultIndex) {
    // Sanitize indices using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    return index === undefined ? defaultIndex : isNeg(index) ? size === Infinity ? size : Math.max(0, size + index) | 0 : size === undefined || size === index ? index : Math.min(size, index) | 0;
}
function isNeg(value) {
    // Account for -0 which is negative, but not less than 0.
    return value < 0 || value === 0 && 1 / value === -Infinity;
}
function isImmutable(maybeImmutable) {
    return isCollection(maybeImmutable) || isRecord(maybeImmutable);
}
function isCollection(maybeCollection) {
    return !!(maybeCollection && maybeCollection[IS_ITERABLE_SENTINEL]);
}
function isKeyed(maybeKeyed) {
    return !!(maybeKeyed && maybeKeyed[IS_KEYED_SENTINEL]);
}
function isIndexed(maybeIndexed) {
    return !!(maybeIndexed && maybeIndexed[IS_INDEXED_SENTINEL]);
}
function isAssociative(maybeAssociative) {
    return isKeyed(maybeAssociative) || isIndexed(maybeAssociative);
}
function isOrdered(maybeOrdered) {
    return !!(maybeOrdered && maybeOrdered[IS_ORDERED_SENTINEL]);
}
function isRecord(maybeRecord) {
    return !!(maybeRecord && maybeRecord[IS_RECORD_SENTINEL]);
}
function isValueObject(maybeValue) {
    return !!(maybeValue && typeof maybeValue.equals === 'function' && typeof maybeValue.hashCode === 'function');
}
var IS_ITERABLE_SENTINEL = '@@__IMMUTABLE_ITERABLE__@@';
var IS_KEYED_SENTINEL = '@@__IMMUTABLE_KEYED__@@';
var IS_INDEXED_SENTINEL = '@@__IMMUTABLE_INDEXED__@@';
var IS_ORDERED_SENTINEL = '@@__IMMUTABLE_ORDERED__@@';
var IS_RECORD_SENTINEL = '@@__IMMUTABLE_RECORD__@@';
var Collection = function Collection(value) {
    return isCollection(value) ? value : Seq(value);
};
var KeyedCollection = function(Collection) {
    function KeyedCollection(value) {
        return isKeyed(value) ? value : KeyedSeq(value);
    }
    if (Collection) KeyedCollection.__proto__ = Collection;
    KeyedCollection.prototype = Object.create(Collection && Collection.prototype);
    KeyedCollection.prototype.constructor = KeyedCollection;
    return KeyedCollection;
}(Collection);
var IndexedCollection = function(Collection) {
    function IndexedCollection(value) {
        return isIndexed(value) ? value : IndexedSeq(value);
    }
    if (Collection) IndexedCollection.__proto__ = Collection;
    IndexedCollection.prototype = Object.create(Collection && Collection.prototype);
    IndexedCollection.prototype.constructor = IndexedCollection;
    return IndexedCollection;
}(Collection);
var SetCollection = function(Collection) {
    function SetCollection(value) {
        return isCollection(value) && !isAssociative(value) ? value : SetSeq(value);
    }
    if (Collection) SetCollection.__proto__ = Collection;
    SetCollection.prototype = Object.create(Collection && Collection.prototype);
    SetCollection.prototype.constructor = SetCollection;
    return SetCollection;
}(Collection);
Collection.Keyed = KeyedCollection;
Collection.Indexed = IndexedCollection;
Collection.Set = SetCollection;
var ITERATE_KEYS = 0;
var ITERATE_VALUES = 1;
var ITERATE_ENTRIES = 2;
var REAL_ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator';
var ITERATOR_SYMBOL = REAL_ITERATOR_SYMBOL || FAUX_ITERATOR_SYMBOL;
var Iterator = function Iterator(next) {
    this.next = next;
};
Iterator.prototype.toString = function toString() {
    return '[Iterator]';
};
Iterator.KEYS = ITERATE_KEYS;
Iterator.VALUES = ITERATE_VALUES;
Iterator.ENTRIES = ITERATE_ENTRIES;
Iterator.prototype.inspect = Iterator.prototype.toSource = function() {
    return this.toString();
};
Iterator.prototype[ITERATOR_SYMBOL] = function() {
    return this;
};
function iteratorValue(type, k, v, iteratorResult) {
    var value = type === 0 ? k : type === 1 ? v : [
        k,
        v
    ];
    iteratorResult ? iteratorResult.value = value : iteratorResult = {
        value: value,
        done: false
    };
    return iteratorResult;
}
function iteratorDone() {
    return {
        value: undefined,
        done: true
    };
}
function hasIterator(maybeIterable) {
    return !!getIteratorFn(maybeIterable);
}
function isIterator(maybeIterator) {
    return maybeIterator && typeof maybeIterator.next === 'function';
}
function getIterator(iterable) {
    var iteratorFn = getIteratorFn(iterable);
    return iteratorFn && iteratorFn.call(iterable);
}
function getIteratorFn(iterable) {
    var iteratorFn = iterable && (REAL_ITERATOR_SYMBOL && iterable[REAL_ITERATOR_SYMBOL] || iterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') return iteratorFn;
}
var hasOwnProperty = Object.prototype.hasOwnProperty;
function isArrayLike(value) {
    return value && typeof value.length === 'number';
}
var Seq = function(Collection$$1) {
    function Seq(value) {
        return value === null || value === undefined ? emptySequence() : isImmutable(value) ? value.toSeq() : seqFromValue(value);
    }
    if (Collection$$1) Seq.__proto__ = Collection$$1;
    Seq.prototype = Object.create(Collection$$1 && Collection$$1.prototype);
    Seq.prototype.constructor = Seq;
    Seq.prototype.toSeq = function toSeq() {
        return this;
    };
    Seq.prototype.toString = function toString() {
        return this.__toString('Seq {', '}');
    };
    Seq.prototype.cacheResult = function cacheResult() {
        if (!this._cache && this.__iterateUncached) {
            this._cache = this.entrySeq().toArray();
            this.size = this._cache.length;
        }
        return this;
    };
    // abstract __iterateUncached(fn, reverse)
    Seq.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            while(i !== size){
                var entry = cache[reverse ? size - ++i : i++];
                if (fn(entry[1], entry[0], this$1) === false) break;
            }
            return i;
        }
        return this.__iterateUncached(fn, reverse);
    };
    // abstract __iteratorUncached(type, reverse)
    Seq.prototype.__iterator = function __iterator(type, reverse) {
        var cache = this._cache;
        if (cache) {
            var size = cache.length;
            var i = 0;
            return new Iterator(function() {
                if (i === size) return iteratorDone();
                var entry = cache[reverse ? size - ++i : i++];
                return iteratorValue(type, entry[0], entry[1]);
            });
        }
        return this.__iteratorUncached(type, reverse);
    };
    return Seq;
}(Collection);
var KeyedSeq = function(Seq) {
    function KeyedSeq(value) {
        return value === null || value === undefined ? emptySequence().toKeyedSeq() : isCollection(value) ? isKeyed(value) ? value.toSeq() : value.fromEntrySeq() : isRecord(value) ? value.toSeq() : keyedSeqFromValue(value);
    }
    if (Seq) KeyedSeq.__proto__ = Seq;
    KeyedSeq.prototype = Object.create(Seq && Seq.prototype);
    KeyedSeq.prototype.constructor = KeyedSeq;
    KeyedSeq.prototype.toKeyedSeq = function toKeyedSeq() {
        return this;
    };
    return KeyedSeq;
}(Seq);
var IndexedSeq = function(Seq) {
    function IndexedSeq(value) {
        return value === null || value === undefined ? emptySequence() : isCollection(value) ? isKeyed(value) ? value.entrySeq() : value.toIndexedSeq() : isRecord(value) ? value.toSeq().entrySeq() : indexedSeqFromValue(value);
    }
    if (Seq) IndexedSeq.__proto__ = Seq;
    IndexedSeq.prototype = Object.create(Seq && Seq.prototype);
    IndexedSeq.prototype.constructor = IndexedSeq;
    IndexedSeq.of = function of() {
        return IndexedSeq(arguments);
    };
    IndexedSeq.prototype.toIndexedSeq = function toIndexedSeq() {
        return this;
    };
    IndexedSeq.prototype.toString = function toString() {
        return this.__toString('Seq [', ']');
    };
    return IndexedSeq;
}(Seq);
var SetSeq = function(Seq) {
    function SetSeq(value) {
        return (isCollection(value) && !isAssociative(value) ? value : IndexedSeq(value)).toSetSeq();
    }
    if (Seq) SetSeq.__proto__ = Seq;
    SetSeq.prototype = Object.create(Seq && Seq.prototype);
    SetSeq.prototype.constructor = SetSeq;
    SetSeq.of = function of() {
        return SetSeq(arguments);
    };
    SetSeq.prototype.toSetSeq = function toSetSeq() {
        return this;
    };
    return SetSeq;
}(Seq);
Seq.isSeq = isSeq;
Seq.Keyed = KeyedSeq;
Seq.Set = SetSeq;
Seq.Indexed = IndexedSeq;
var IS_SEQ_SENTINEL = '@@__IMMUTABLE_SEQ__@@';
Seq.prototype[IS_SEQ_SENTINEL] = true;
// #pragma Root Sequences
var ArraySeq = function(IndexedSeq) {
    function ArraySeq(array) {
        this._array = array;
        this.size = array.length;
    }
    if (IndexedSeq) ArraySeq.__proto__ = IndexedSeq;
    ArraySeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    ArraySeq.prototype.constructor = ArraySeq;
    ArraySeq.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._array[wrapIndex(this, index)] : notSetValue;
    };
    ArraySeq.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var array = this._array;
        var size = array.length;
        var i = 0;
        while(i !== size){
            var ii = reverse ? size - ++i : i++;
            if (fn(array[ii], ii, this$1) === false) break;
        }
        return i;
    };
    ArraySeq.prototype.__iterator = function __iterator(type, reverse) {
        var array = this._array;
        var size = array.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var ii = reverse ? size - ++i : i++;
            return iteratorValue(type, ii, array[ii]);
        });
    };
    return ArraySeq;
}(IndexedSeq);
var ObjectSeq = function(KeyedSeq) {
    function ObjectSeq(object) {
        var keys = Object.keys(object);
        this._object = object;
        this._keys = keys;
        this.size = keys.length;
    }
    if (KeyedSeq) ObjectSeq.__proto__ = KeyedSeq;
    ObjectSeq.prototype = Object.create(KeyedSeq && KeyedSeq.prototype);
    ObjectSeq.prototype.constructor = ObjectSeq;
    ObjectSeq.prototype.get = function get(key, notSetValue) {
        if (notSetValue !== undefined && !this.has(key)) return notSetValue;
        return this._object[key];
    };
    ObjectSeq.prototype.has = function has(key) {
        return hasOwnProperty.call(this._object, key);
    };
    ObjectSeq.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        while(i !== size){
            var key = keys[reverse ? size - ++i : i++];
            if (fn(object[key], key, this$1) === false) break;
        }
        return i;
    };
    ObjectSeq.prototype.__iterator = function __iterator(type, reverse) {
        var object = this._object;
        var keys = this._keys;
        var size = keys.length;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var key = keys[reverse ? size - ++i : i++];
            return iteratorValue(type, key, object[key]);
        });
    };
    return ObjectSeq;
}(KeyedSeq);
ObjectSeq.prototype[IS_ORDERED_SENTINEL] = true;
var CollectionSeq = function(IndexedSeq) {
    function CollectionSeq(collection) {
        this._collection = collection;
        this.size = collection.length || collection.size;
    }
    if (IndexedSeq) CollectionSeq.__proto__ = IndexedSeq;
    CollectionSeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    CollectionSeq.prototype.constructor = CollectionSeq;
    CollectionSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        var this$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        var iterations = 0;
        if (isIterator(iterator)) {
            var step;
            while(!(step = iterator.next()).done){
                if (fn(step.value, iterations++, this$1) === false) break;
            }
        }
        return iterations;
    };
    CollectionSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var collection = this._collection;
        var iterator = getIterator(collection);
        if (!isIterator(iterator)) return new Iterator(iteratorDone);
        var iterations = 0;
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, iterations++, step.value);
        });
    };
    return CollectionSeq;
}(IndexedSeq);
var IteratorSeq = function(IndexedSeq) {
    function IteratorSeq(iterator) {
        this._iterator = iterator;
        this._iteratorCache = [];
    }
    if (IndexedSeq) IteratorSeq.__proto__ = IndexedSeq;
    IteratorSeq.prototype = Object.create(IndexedSeq && IndexedSeq.prototype);
    IteratorSeq.prototype.constructor = IteratorSeq;
    IteratorSeq.prototype.__iterateUncached = function __iterateUncached(fn, reverse) {
        var this$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        while(iterations < cache.length){
            if (fn(cache[iterations], iterations++, this$1) === false) return iterations;
        }
        var step;
        while(!(step = iterator.next()).done){
            var val = step.value;
            cache[iterations] = val;
            if (fn(val, iterations++, this$1) === false) break;
        }
        return iterations;
    };
    IteratorSeq.prototype.__iteratorUncached = function __iteratorUncached(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = this._iterator;
        var cache = this._iteratorCache;
        var iterations = 0;
        return new Iterator(function() {
            if (iterations >= cache.length) {
                var step = iterator.next();
                if (step.done) return step;
                cache[iterations] = step.value;
            }
            return iteratorValue(type, iterations, cache[iterations++]);
        });
    };
    return IteratorSeq;
}(IndexedSeq);
// # pragma Helper functions
function isSeq(maybeSeq) {
    return !!(maybeSeq && maybeSeq[IS_SEQ_SENTINEL]);
}
var EMPTY_SEQ;
function emptySequence() {
    return EMPTY_SEQ || (EMPTY_SEQ = new ArraySeq([]));
}
function keyedSeqFromValue(value) {
    var seq = Array.isArray(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new CollectionSeq(value) : undefined;
    if (seq) return seq.fromEntrySeq();
    if (typeof value === 'object') return new ObjectSeq(value);
    throw new TypeError('Expected Array or collection object of [k, v] entries, or keyed object: ' + value);
}
function indexedSeqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq;
    throw new TypeError('Expected Array or collection object of values: ' + value);
}
function seqFromValue(value) {
    var seq = maybeIndexedSeqFromValue(value);
    if (seq) return seq;
    if (typeof value === 'object') return new ObjectSeq(value);
    throw new TypeError('Expected Array or collection object of values, or keyed object: ' + value);
}
function maybeIndexedSeqFromValue(value) {
    return isArrayLike(value) ? new ArraySeq(value) : isIterator(value) ? new IteratorSeq(value) : hasIterator(value) ? new CollectionSeq(value) : undefined;
}
/**
 * An extension of the "same-value" algorithm as [described for use by ES6 Map
 * and Set](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map#Key_equality)
 *
 * NaN is considered the same as NaN, however -0 and 0 are considered the same
 * value, which is different from the algorithm described by
 * [`Object.is`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is).
 *
 * This is extended further to allow Objects to describe the values they
 * represent, by way of `valueOf` or `equals` (and `hashCode`).
 *
 * Note: because of this extension, the key equality of Immutable.Map and the
 * value equality of Immutable.Set will differ from ES6 Map and Set.
 *
 * ### Defining custom values
 *
 * The easiest way to describe the value an object represents is by implementing
 * `valueOf`. For example, `Date` represents a value by returning a unix
 * timestamp for `valueOf`:
 *
 *     var date1 = new Date(1234567890000); // Fri Feb 13 2009 ...
 *     var date2 = new Date(1234567890000);
 *     date1.valueOf(); // 1234567890000
 *     assert( date1 !== date2 );
 *     assert( Immutable.is( date1, date2 ) );
 *
 * Note: overriding `valueOf` may have other implications if you use this object
 * where JavaScript expects a primitive, such as implicit string coercion.
 *
 * For more complex types, especially collections, implementing `valueOf` may
 * not be performant. An alternative is to implement `equals` and `hashCode`.
 *
 * `equals` takes another object, presumably of similar type, and returns true
 * if it is equal. Equality is symmetrical, so the same result should be
 * returned if this and the argument are flipped.
 *
 *     assert( a.equals(b) === b.equals(a) );
 *
 * `hashCode` returns a 32bit integer number representing the object which will
 * be used to determine how to store the value object in a Map or Set. You must
 * provide both or neither methods, one must not exist without the other.
 *
 * Also, an important relationship between these methods must be upheld: if two
 * values are equal, they *must* return the same hashCode. If the values are not
 * equal, they might have the same hashCode; this is called a hash collision,
 * and while undesirable for performance reasons, it is acceptable.
 *
 *     if (a.equals(b)) {
 *       assert( a.hashCode() === b.hashCode() );
 *     }
 *
 * All Immutable collections are Value Objects: they implement `equals()`
 * and `hashCode()`.
 */ function is(valueA, valueB) {
    if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
    if (!valueA || !valueB) return false;
    if (typeof valueA.valueOf === 'function' && typeof valueB.valueOf === 'function') {
        valueA = valueA.valueOf();
        valueB = valueB.valueOf();
        if (valueA === valueB || valueA !== valueA && valueB !== valueB) return true;
        if (!valueA || !valueB) return false;
    }
    return !!(isValueObject(valueA) && isValueObject(valueB) && valueA.equals(valueB));
}
var imul = typeof Math.imul === 'function' && Math.imul(0xffffffff, 2) === -2 ? Math.imul : function imul(a, b) {
    a |= 0; // int
    b |= 0; // int
    var c = a & 0xffff;
    var d = b & 0xffff;
    // Shift by 0 fixes the sign on the high part.
    return c * d + ((a >>> 16) * d + c * (b >>> 16) << 16 >>> 0) | 0; // int
};
// v8 has an optimization for storing 31-bit signed numbers.
// Values which have either 00 or 11 as the high order bits qualify.
// This function drops the highest order bit in a signed number, maintaining
// the sign bit.
function smi(i32) {
    return i32 >>> 1 & 0x40000000 | i32 & 0xbfffffff;
}
function hash(o) {
    if (o === false || o === null || o === undefined) return 0;
    if (typeof o.valueOf === 'function') {
        o = o.valueOf();
        if (o === false || o === null || o === undefined) return 0;
    }
    if (o === true) return 1;
    var type = typeof o;
    if (type === 'number') {
        if (o !== o || o === Infinity) return 0;
        var h = o | 0;
        if (h !== o) h ^= o * 0xffffffff;
        while(o > 0xffffffff){
            o /= 0xffffffff;
            h ^= o;
        }
        return smi(h);
    }
    if (type === 'string') return o.length > STRING_HASH_CACHE_MIN_STRLEN ? cachedHashString(o) : hashString(o);
    if (typeof o.hashCode === 'function') // Drop any high bits from accidentally long hash codes.
    return smi(o.hashCode());
    if (type === 'object') return hashJSObj(o);
    if (typeof o.toString === 'function') return hashString(o.toString());
    throw new Error('Value type ' + type + ' cannot be hashed.');
}
function cachedHashString(string) {
    var hashed = stringHashCache[string];
    if (hashed === undefined) {
        hashed = hashString(string);
        if (STRING_HASH_CACHE_SIZE === STRING_HASH_CACHE_MAX_SIZE) {
            STRING_HASH_CACHE_SIZE = 0;
            stringHashCache = {};
        }
        STRING_HASH_CACHE_SIZE++;
        stringHashCache[string] = hashed;
    }
    return hashed;
}
// http://jsperf.com/hashing-strings
function hashString(string) {
    // This is the hash from JVM
    // The hash code for a string is computed as
    // s[0] * 31 ^ (n - 1) + s[1] * 31 ^ (n - 2) + ... + s[n - 1],
    // where s[i] is the ith character of the string and n is the length of
    // the string. We "mod" the result to make it between 0 (inclusive) and 2^31
    // (exclusive) by dropping high bits.
    var hashed = 0;
    for(var ii = 0; ii < string.length; ii++)hashed = 31 * hashed + string.charCodeAt(ii) | 0;
    return smi(hashed);
}
function hashJSObj(obj) {
    var hashed;
    if (usingWeakMap) {
        hashed = weakMap.get(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = obj[UID_HASH_KEY];
    if (hashed !== undefined) return hashed;
    if (!canDefineProperty) {
        hashed = obj.propertyIsEnumerable && obj.propertyIsEnumerable[UID_HASH_KEY];
        if (hashed !== undefined) return hashed;
        hashed = getIENodeHash(obj);
        if (hashed !== undefined) return hashed;
    }
    hashed = ++objHashUID;
    if (objHashUID & 0x40000000) objHashUID = 0;
    if (usingWeakMap) weakMap.set(obj, hashed);
    else if (isExtensible !== undefined && isExtensible(obj) === false) throw new Error('Non-extensible objects are not allowed as keys.');
    else if (canDefineProperty) Object.defineProperty(obj, UID_HASH_KEY, {
        enumerable: false,
        configurable: false,
        writable: false,
        value: hashed
    });
    else if (obj.propertyIsEnumerable !== undefined && obj.propertyIsEnumerable === obj.constructor.prototype.propertyIsEnumerable) {
        // Since we can't define a non-enumerable property on the object
        // we'll hijack one of the less-used non-enumerable properties to
        // save our hash on it. Since this is a function it will not show up in
        // `JSON.stringify` which is what we want.
        obj.propertyIsEnumerable = function() {
            return this.constructor.prototype.propertyIsEnumerable.apply(this, arguments);
        };
        obj.propertyIsEnumerable[UID_HASH_KEY] = hashed;
    } else if (obj.nodeType !== undefined) // At this point we couldn't get the IE `uniqueID` to use as a hash
    // and we couldn't use a non-enumerable property to exploit the
    // dontEnum bug so we simply add the `UID_HASH_KEY` on the node
    // itself.
    obj[UID_HASH_KEY] = hashed;
    else throw new Error('Unable to set a non-enumerable property on object.');
    return hashed;
}
// Get references to ES5 object methods.
var isExtensible = Object.isExtensible;
// True if Object.defineProperty works as expected. IE8 fails this test.
var canDefineProperty = function() {
    try {
        Object.defineProperty({}, '@', {});
        return true;
    } catch (e) {
        return false;
    }
}();
// IE has a `uniqueID` property on DOM nodes. We can construct the hash from it
// and avoid memory leaks from the IE cloneNode bug.
function getIENodeHash(node) {
    if (node && node.nodeType > 0) switch(node.nodeType){
        case 1:
            return node.uniqueID;
        case 9:
            return node.documentElement && node.documentElement.uniqueID;
    }
}
// If possible, use a WeakMap.
var usingWeakMap = typeof WeakMap === 'function';
var weakMap;
if (usingWeakMap) weakMap = new WeakMap();
var objHashUID = 0;
var UID_HASH_KEY = '__immutablehash__';
if (typeof Symbol === 'function') UID_HASH_KEY = Symbol(UID_HASH_KEY);
var STRING_HASH_CACHE_MIN_STRLEN = 16;
var STRING_HASH_CACHE_MAX_SIZE = 255;
var STRING_HASH_CACHE_SIZE = 0;
var stringHashCache = {};
var ToKeyedSequence = function(KeyedSeq$$1) {
    function ToKeyedSequence(indexed, useKeys) {
        this._iter = indexed;
        this._useKeys = useKeys;
        this.size = indexed.size;
    }
    if (KeyedSeq$$1) ToKeyedSequence.__proto__ = KeyedSeq$$1;
    ToKeyedSequence.prototype = Object.create(KeyedSeq$$1 && KeyedSeq$$1.prototype);
    ToKeyedSequence.prototype.constructor = ToKeyedSequence;
    ToKeyedSequence.prototype.get = function get(key, notSetValue) {
        return this._iter.get(key, notSetValue);
    };
    ToKeyedSequence.prototype.has = function has(key) {
        return this._iter.has(key);
    };
    ToKeyedSequence.prototype.valueSeq = function valueSeq() {
        return this._iter.valueSeq();
    };
    ToKeyedSequence.prototype.reverse = function reverse() {
        var this$1 = this;
        var reversedSequence = reverseFactory(this, true);
        if (!this._useKeys) reversedSequence.valueSeq = function() {
            return this$1._iter.toSeq().reverse();
        };
        return reversedSequence;
    };
    ToKeyedSequence.prototype.map = function map(mapper, context) {
        var this$1 = this;
        var mappedSequence = mapFactory(this, mapper, context);
        if (!this._useKeys) mappedSequence.valueSeq = function() {
            return this$1._iter.toSeq().map(mapper, context);
        };
        return mappedSequence;
    };
    ToKeyedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        return this._iter.__iterate(function(v, k) {
            return fn(v, k, this$1);
        }, reverse);
    };
    ToKeyedSequence.prototype.__iterator = function __iterator(type, reverse) {
        return this._iter.__iterator(type, reverse);
    };
    return ToKeyedSequence;
}(KeyedSeq);
ToKeyedSequence.prototype[IS_ORDERED_SENTINEL] = true;
var ToIndexedSequence = function(IndexedSeq$$1) {
    function ToIndexedSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (IndexedSeq$$1) ToIndexedSequence.__proto__ = IndexedSeq$$1;
    ToIndexedSequence.prototype = Object.create(IndexedSeq$$1 && IndexedSeq$$1.prototype);
    ToIndexedSequence.prototype.constructor = ToIndexedSequence;
    ToIndexedSequence.prototype.includes = function includes(value) {
        return this._iter.includes(value);
    };
    ToIndexedSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var i = 0;
        reverse && ensureSize(this);
        return this._iter.__iterate(function(v) {
            return fn(v, reverse ? this$1.size - ++i : i++, this$1);
        }, reverse);
    };
    ToIndexedSequence.prototype.__iterator = function __iterator(type, reverse) {
        var this$1 = this;
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        var i = 0;
        reverse && ensureSize(this);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, reverse ? this$1.size - ++i : i++, step.value, step);
        });
    };
    return ToIndexedSequence;
}(IndexedSeq);
var ToSetSequence = function(SetSeq$$1) {
    function ToSetSequence(iter) {
        this._iter = iter;
        this.size = iter.size;
    }
    if (SetSeq$$1) ToSetSequence.__proto__ = SetSeq$$1;
    ToSetSequence.prototype = Object.create(SetSeq$$1 && SetSeq$$1.prototype);
    ToSetSequence.prototype.constructor = ToSetSequence;
    ToSetSequence.prototype.has = function has(key) {
        return this._iter.includes(key);
    };
    ToSetSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        return this._iter.__iterate(function(v) {
            return fn(v, v, this$1);
        }, reverse);
    };
    ToSetSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            return step.done ? step : iteratorValue(type, step.value, step.value, step);
        });
    };
    return ToSetSequence;
}(SetSeq);
var FromEntriesSequence = function(KeyedSeq$$1) {
    function FromEntriesSequence(entries) {
        this._iter = entries;
        this.size = entries.size;
    }
    if (KeyedSeq$$1) FromEntriesSequence.__proto__ = KeyedSeq$$1;
    FromEntriesSequence.prototype = Object.create(KeyedSeq$$1 && KeyedSeq$$1.prototype);
    FromEntriesSequence.prototype.constructor = FromEntriesSequence;
    FromEntriesSequence.prototype.entrySeq = function entrySeq() {
        return this._iter.toSeq();
    };
    FromEntriesSequence.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        return this._iter.__iterate(function(entry) {
            // Check if entry exists first so array access doesn't throw for holes
            // in the parent iteration.
            if (entry) {
                validateEntry(entry);
                var indexedCollection = isCollection(entry);
                return fn(indexedCollection ? entry.get(1) : entry[1], indexedCollection ? entry.get(0) : entry[0], this$1);
            }
        }, reverse);
    };
    FromEntriesSequence.prototype.__iterator = function __iterator(type, reverse) {
        var iterator = this._iter.__iterator(ITERATE_VALUES, reverse);
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                // Check if entry exists first so array access doesn't throw for holes
                // in the parent iteration.
                if (entry) {
                    validateEntry(entry);
                    var indexedCollection = isCollection(entry);
                    return iteratorValue(type, indexedCollection ? entry.get(0) : entry[0], indexedCollection ? entry.get(1) : entry[1], step);
                }
            }
        });
    };
    return FromEntriesSequence;
}(KeyedSeq);
ToIndexedSequence.prototype.cacheResult = ToKeyedSequence.prototype.cacheResult = ToSetSequence.prototype.cacheResult = FromEntriesSequence.prototype.cacheResult = cacheResultThrough;
function flipFactory(collection) {
    var flipSequence = makeSequence(collection);
    flipSequence._iter = collection;
    flipSequence.size = collection.size;
    flipSequence.flip = function() {
        return collection;
    };
    flipSequence.reverse = function() {
        var reversedSequence = collection.reverse.apply(this); // super.reverse()
        reversedSequence.flip = function() {
            return collection.reverse();
        };
        return reversedSequence;
    };
    flipSequence.has = function(key) {
        return collection.includes(key);
    };
    flipSequence.includes = function(key) {
        return collection.has(key);
    };
    flipSequence.cacheResult = cacheResultThrough;
    flipSequence.__iterateUncached = function(fn, reverse) {
        var this$1 = this;
        return collection.__iterate(function(v, k) {
            return fn(k, v, this$1) !== false;
        }, reverse);
    };
    flipSequence.__iteratorUncached = function(type, reverse) {
        if (type === ITERATE_ENTRIES) {
            var iterator = collection.__iterator(type, reverse);
            return new Iterator(function() {
                var step = iterator.next();
                if (!step.done) {
                    var k = step.value[0];
                    step.value[0] = step.value[1];
                    step.value[1] = k;
                }
                return step;
            });
        }
        return collection.__iterator(type === ITERATE_VALUES ? ITERATE_KEYS : ITERATE_VALUES, reverse);
    };
    return flipSequence;
}
function mapFactory(collection, mapper, context) {
    var mappedSequence = makeSequence(collection);
    mappedSequence.size = collection.size;
    mappedSequence.has = function(key) {
        return collection.has(key);
    };
    mappedSequence.get = function(key, notSetValue) {
        var v = collection.get(key, NOT_SET);
        return v === NOT_SET ? notSetValue : mapper.call(context, v, key, collection);
    };
    mappedSequence.__iterateUncached = function(fn, reverse) {
        var this$1 = this;
        return collection.__iterate(function(v, k, c) {
            return fn(mapper.call(context, v, k, c), k, this$1) !== false;
        }, reverse);
    };
    mappedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var key = entry[0];
            return iteratorValue(type, key, mapper.call(context, entry[1], key, collection), step);
        });
    };
    return mappedSequence;
}
function reverseFactory(collection, useKeys) {
    var this$1 = this;
    var reversedSequence = makeSequence(collection);
    reversedSequence._iter = collection;
    reversedSequence.size = collection.size;
    reversedSequence.reverse = function() {
        return collection;
    };
    if (collection.flip) reversedSequence.flip = function() {
        var flipSequence = flipFactory(collection);
        flipSequence.reverse = function() {
            return collection.flip();
        };
        return flipSequence;
    };
    reversedSequence.get = function(key, notSetValue) {
        return collection.get(useKeys ? key : -1 - key, notSetValue);
    };
    reversedSequence.has = function(key) {
        return collection.has(useKeys ? key : -1 - key);
    };
    reversedSequence.includes = function(value) {
        return collection.includes(value);
    };
    reversedSequence.cacheResult = cacheResultThrough;
    reversedSequence.__iterate = function(fn, reverse) {
        var this$1 = this;
        var i = 0;
        reverse && ensureSize(collection);
        return collection.__iterate(function(v, k) {
            return fn(v, useKeys ? k : reverse ? this$1.size - ++i : i++, this$1);
        }, !reverse);
    };
    reversedSequence.__iterator = function(type, reverse) {
        var i = 0;
        reverse && ensureSize(collection);
        var iterator = collection.__iterator(ITERATE_ENTRIES, !reverse);
        return new Iterator(function() {
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            return iteratorValue(type, useKeys ? entry[0] : reverse ? this$1.size - ++i : i++, entry[1], step);
        });
    };
    return reversedSequence;
}
function filterFactory(collection, predicate, context, useKeys) {
    var filterSequence = makeSequence(collection);
    if (useKeys) {
        filterSequence.has = function(key) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && !!predicate.call(context, v, key, collection);
        };
        filterSequence.get = function(key, notSetValue) {
            var v = collection.get(key, NOT_SET);
            return v !== NOT_SET && predicate.call(context, v, key, collection) ? v : notSetValue;
        };
    }
    filterSequence.__iterateUncached = function(fn, reverse) {
        var this$1 = this;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1);
            }
        }, reverse);
        return iterations;
    };
    filterSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterations = 0;
        return new Iterator(function() {
            while(true){
                var step = iterator.next();
                if (step.done) return step;
                var entry = step.value;
                var key = entry[0];
                var value = entry[1];
                if (predicate.call(context, value, key, collection)) return iteratorValue(type, useKeys ? key : iterations++, value, step);
            }
        });
    };
    return filterSequence;
}
function countByFactory(collection, grouper, context) {
    var groups = Map().asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), 0, function(a) {
            return a + 1;
        });
    });
    return groups.asImmutable();
}
function groupByFactory(collection, grouper, context) {
    var isKeyedIter = isKeyed(collection);
    var groups = (isOrdered(collection) ? OrderedMap() : Map()).asMutable();
    collection.__iterate(function(v, k) {
        groups.update(grouper.call(context, v, k, collection), function(a) {
            return a = a || [], a.push(isKeyedIter ? [
                k,
                v
            ] : v), a;
        });
    });
    var coerce = collectionClass(collection);
    return groups.map(function(arr) {
        return reify(collection, coerce(arr));
    });
}
function sliceFactory(collection, begin, end, useKeys) {
    var originalSize = collection.size;
    if (wholeSlice(begin, end, originalSize)) return collection;
    var resolvedBegin = resolveBegin(begin, originalSize);
    var resolvedEnd = resolveEnd(end, originalSize);
    // begin or end will be NaN if they were provided as negative numbers and
    // this collection's size is unknown. In that case, cache first so there is
    // a known size and these do not resolve to NaN.
    if (resolvedBegin !== resolvedBegin || resolvedEnd !== resolvedEnd) return sliceFactory(collection.toSeq().cacheResult(), begin, end, useKeys);
    // Note: resolvedEnd is undefined when the original sequence's length is
    // unknown and this slice did not supply an end and should contain all
    // elements after resolvedBegin.
    // In that case, resolvedSize will be NaN and sliceSize will remain undefined.
    var resolvedSize = resolvedEnd - resolvedBegin;
    var sliceSize;
    if (resolvedSize === resolvedSize) sliceSize = resolvedSize < 0 ? 0 : resolvedSize;
    var sliceSeq = makeSequence(collection);
    // If collection.size is undefined, the size of the realized sliceSeq is
    // unknown at this point unless the number of items to slice is 0
    sliceSeq.size = sliceSize === 0 ? sliceSize : collection.size && sliceSize || undefined;
    if (!useKeys && isSeq(collection) && sliceSize >= 0) sliceSeq.get = function(index, notSetValue) {
        index = wrapIndex(this, index);
        return index >= 0 && index < sliceSize ? collection.get(index + resolvedBegin, notSetValue) : notSetValue;
    };
    sliceSeq.__iterateUncached = function(fn, reverse) {
        var this$1 = this;
        if (sliceSize === 0) return 0;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var skipped = 0;
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k) {
            if (!(isSkipping && (isSkipping = skipped++ < resolvedBegin))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1) !== false && iterations !== sliceSize;
            }
        });
        return iterations;
    };
    sliceSeq.__iteratorUncached = function(type, reverse) {
        if (sliceSize !== 0 && reverse) return this.cacheResult().__iterator(type, reverse);
        // Don't bother instantiating parent iterator if taking 0.
        if (sliceSize === 0) return new Iterator(iteratorDone);
        var iterator = collection.__iterator(type, reverse);
        var skipped = 0;
        var iterations = 0;
        return new Iterator(function() {
            while(skipped++ < resolvedBegin)iterator.next();
            if (++iterations > sliceSize) return iteratorDone();
            var step = iterator.next();
            if (useKeys || type === ITERATE_VALUES || step.done) return step;
            if (type === ITERATE_KEYS) return iteratorValue(type, iterations - 1, undefined, step);
            return iteratorValue(type, iterations - 1, step.value[1], step);
        });
    };
    return sliceSeq;
}
function takeWhileFactory(collection, predicate, context) {
    var takeSequence = makeSequence(collection);
    takeSequence.__iterateUncached = function(fn, reverse) {
        var this$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            return predicate.call(context, v, k, c) && ++iterations && fn(v, k, this$1);
        });
        return iterations;
    };
    takeSequence.__iteratorUncached = function(type, reverse) {
        var this$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var iterating = true;
        return new Iterator(function() {
            if (!iterating) return iteratorDone();
            var step = iterator.next();
            if (step.done) return step;
            var entry = step.value;
            var k = entry[0];
            var v = entry[1];
            if (!predicate.call(context, v, k, this$1)) {
                iterating = false;
                return iteratorDone();
            }
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return takeSequence;
}
function skipWhileFactory(collection, predicate, context, useKeys) {
    var skipSequence = makeSequence(collection);
    skipSequence.__iterateUncached = function(fn, reverse) {
        var this$1 = this;
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var isSkipping = true;
        var iterations = 0;
        collection.__iterate(function(v, k, c) {
            if (!(isSkipping && (isSkipping = predicate.call(context, v, k, c)))) {
                iterations++;
                return fn(v, useKeys ? k : iterations - 1, this$1);
            }
        });
        return iterations;
    };
    skipSequence.__iteratorUncached = function(type, reverse) {
        var this$1 = this;
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(ITERATE_ENTRIES, reverse);
        var skipping = true;
        var iterations = 0;
        return new Iterator(function() {
            var step;
            var k;
            var v;
            do {
                step = iterator.next();
                if (step.done) {
                    if (useKeys || type === ITERATE_VALUES) return step;
                    if (type === ITERATE_KEYS) return iteratorValue(type, iterations++, undefined, step);
                    return iteratorValue(type, iterations++, step.value[1], step);
                }
                var entry = step.value;
                k = entry[0];
                v = entry[1];
                skipping && (skipping = predicate.call(context, v, k, this$1));
            }while (skipping);
            return type === ITERATE_ENTRIES ? step : iteratorValue(type, k, v, step);
        });
    };
    return skipSequence;
}
function concatFactory(collection, values) {
    var isKeyedCollection = isKeyed(collection);
    var iters = [
        collection
    ].concat(values).map(function(v) {
        if (!isCollection(v)) v = isKeyedCollection ? keyedSeqFromValue(v) : indexedSeqFromValue(Array.isArray(v) ? v : [
            v
        ]);
        else if (isKeyedCollection) v = KeyedCollection(v);
        return v;
    }).filter(function(v) {
        return v.size !== 0;
    });
    if (iters.length === 0) return collection;
    if (iters.length === 1) {
        var singleton = iters[0];
        if (singleton === collection || isKeyedCollection && isKeyed(singleton) || isIndexed(collection) && isIndexed(singleton)) return singleton;
    }
    var concatSeq = new ArraySeq(iters);
    if (isKeyedCollection) concatSeq = concatSeq.toKeyedSeq();
    else if (!isIndexed(collection)) concatSeq = concatSeq.toSetSeq();
    concatSeq = concatSeq.flatten(true);
    concatSeq.size = iters.reduce(function(sum, seq) {
        if (sum !== undefined) {
            var size = seq.size;
            if (size !== undefined) return sum + size;
        }
    }, 0);
    return concatSeq;
}
function flattenFactory(collection, depth, useKeys) {
    var flatSequence = makeSequence(collection);
    flatSequence.__iterateUncached = function(fn, reverse) {
        if (reverse) return this.cacheResult().__iterate(fn, reverse);
        var iterations = 0;
        var stopped = false;
        function flatDeep(iter, currentDepth) {
            iter.__iterate(function(v, k) {
                if ((!depth || currentDepth < depth) && isCollection(v)) flatDeep(v, currentDepth + 1);
                else {
                    iterations++;
                    if (fn(v, useKeys ? k : iterations - 1, flatSequence) === false) stopped = true;
                }
                return !stopped;
            }, reverse);
        }
        flatDeep(collection, 0);
        return iterations;
    };
    flatSequence.__iteratorUncached = function(type, reverse) {
        if (reverse) return this.cacheResult().__iterator(type, reverse);
        var iterator = collection.__iterator(type, reverse);
        var stack = [];
        var iterations = 0;
        return new Iterator(function() {
            while(iterator){
                var step = iterator.next();
                if (step.done !== false) {
                    iterator = stack.pop();
                    continue;
                }
                var v = step.value;
                if (type === ITERATE_ENTRIES) v = v[1];
                if ((!depth || stack.length < depth) && isCollection(v)) {
                    stack.push(iterator);
                    iterator = v.__iterator(type, reverse);
                } else return useKeys ? step : iteratorValue(type, iterations++, v, step);
            }
            return iteratorDone();
        });
    };
    return flatSequence;
}
function flatMapFactory(collection, mapper, context) {
    var coerce = collectionClass(collection);
    return collection.toSeq().map(function(v, k) {
        return coerce(mapper.call(context, v, k, collection));
    }).flatten(true);
}
function interposeFactory(collection, separator) {
    var interposedSequence = makeSequence(collection);
    interposedSequence.size = collection.size && collection.size * 2 - 1;
    interposedSequence.__iterateUncached = function(fn, reverse) {
        var this$1 = this;
        var iterations = 0;
        collection.__iterate(function(v) {
            return (!iterations || fn(separator, iterations++, this$1) !== false) && fn(v, iterations++, this$1) !== false;
        }, reverse);
        return iterations;
    };
    interposedSequence.__iteratorUncached = function(type, reverse) {
        var iterator = collection.__iterator(ITERATE_VALUES, reverse);
        var iterations = 0;
        var step;
        return new Iterator(function() {
            if (!step || iterations % 2) {
                step = iterator.next();
                if (step.done) return step;
            }
            return iterations % 2 ? iteratorValue(type, iterations++, separator) : iteratorValue(type, iterations++, step.value, step);
        });
    };
    return interposedSequence;
}
function sortFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    var isKeyedCollection = isKeyed(collection);
    var index = 0;
    var entries = collection.toSeq().map(function(v, k) {
        return [
            k,
            v,
            index++,
            mapper ? mapper(v, k, collection) : v
        ];
    }).valueSeq().toArray();
    entries.sort(function(a, b) {
        return comparator(a[3], b[3]) || a[2] - b[2];
    }).forEach(isKeyedCollection ? function(v, i) {
        entries[i].length = 2;
    } : function(v, i) {
        entries[i] = v[1];
    });
    return isKeyedCollection ? KeyedSeq(entries) : isIndexed(collection) ? IndexedSeq(entries) : SetSeq(entries);
}
function maxFactory(collection, comparator, mapper) {
    if (!comparator) comparator = defaultComparator;
    if (mapper) {
        var entry = collection.toSeq().map(function(v, k) {
            return [
                v,
                mapper(v, k, collection)
            ];
        }).reduce(function(a, b) {
            return maxCompare(comparator, a[1], b[1]) ? b : a;
        });
        return entry && entry[0];
    }
    return collection.reduce(function(a, b) {
        return maxCompare(comparator, a, b) ? b : a;
    });
}
function maxCompare(comparator, a, b) {
    var comp = comparator(b, a);
    // b is considered the new max if the comparator declares them equal, but
    // they are not equal and b is in fact a nullish value.
    return comp === 0 && b !== a && (b === undefined || b === null || b !== b) || comp > 0;
}
function zipWithFactory(keyIter, zipper, iters, zipAll) {
    var zipSequence = makeSequence(keyIter);
    var sizes = new ArraySeq(iters).map(function(i) {
        return i.size;
    });
    zipSequence.size = zipAll ? sizes.max() : sizes.min();
    // Note: this a generic base implementation of __iterate in terms of
    // __iterator which may be more generically useful in the future.
    zipSequence.__iterate = function(fn, reverse) {
        var this$1 = this;
        /* generic:
    var iterator = this.__iterator(ITERATE_ENTRIES, reverse);
    var step;
    var iterations = 0;
    while (!(step = iterator.next()).done) {
      iterations++;
      if (fn(step.value[1], step.value[0], this) === false) {
        break;
      }
    }
    return iterations;
    */ // indexed:
        var iterator = this.__iterator(ITERATE_VALUES, reverse);
        var step;
        var iterations = 0;
        while(!(step = iterator.next()).done){
            if (fn(step.value, iterations++, this$1) === false) break;
        }
        return iterations;
    };
    zipSequence.__iteratorUncached = function(type, reverse) {
        var iterators = iters.map(function(i) {
            return i = Collection(i), getIterator(reverse ? i.reverse() : i);
        });
        var iterations = 0;
        var isDone = false;
        return new Iterator(function() {
            var steps;
            if (!isDone) {
                steps = iterators.map(function(i) {
                    return i.next();
                });
                isDone = zipAll ? steps.every(function(s) {
                    return s.done;
                }) : steps.some(function(s) {
                    return s.done;
                });
            }
            if (isDone) return iteratorDone();
            return iteratorValue(type, iterations++, zipper.apply(null, steps.map(function(s) {
                return s.value;
            })));
        });
    };
    return zipSequence;
}
// #pragma Helper Functions
function reify(iter, seq) {
    return iter === seq ? iter : isSeq(iter) ? seq : iter.constructor(seq);
}
function validateEntry(entry) {
    if (entry !== Object(entry)) throw new TypeError('Expected [K, V] tuple: ' + entry);
}
function collectionClass(collection) {
    return isKeyed(collection) ? KeyedCollection : isIndexed(collection) ? IndexedCollection : SetCollection;
}
function makeSequence(collection) {
    return Object.create((isKeyed(collection) ? KeyedSeq : isIndexed(collection) ? IndexedSeq : SetSeq).prototype);
}
function cacheResultThrough() {
    if (this._iter.cacheResult) {
        this._iter.cacheResult();
        this.size = this._iter.size;
        return this;
    }
    return Seq.prototype.cacheResult.call(this);
}
function defaultComparator(a, b) {
    if (a === undefined && b === undefined) return 0;
    if (a === undefined) return 1;
    if (b === undefined) return -1;
    return a > b ? 1 : a < b ? -1 : 0;
}
// http://jsperf.com/copy-array-inline
function arrCopy(arr, offset) {
    offset = offset || 0;
    var len = Math.max(0, arr.length - offset);
    var newArr = new Array(len);
    for(var ii = 0; ii < len; ii++)newArr[ii] = arr[ii + offset];
    return newArr;
}
function invariant(condition, error) {
    if (!condition) throw new Error(error);
}
function assertNotInfinite(size) {
    invariant(size !== Infinity, 'Cannot perform this action with an infinite size.');
}
function coerceKeyPath(keyPath) {
    if (isArrayLike(keyPath) && typeof keyPath !== 'string') return keyPath;
    if (isOrdered(keyPath)) return keyPath.toArray();
    throw new TypeError('Invalid keyPath: expected Ordered Collection or Array: ' + keyPath);
}
function isPlainObj(value) {
    return value && (value.constructor === Object || value.constructor === undefined);
}
/**
 * Returns true if the value is a potentially-persistent data structure, either
 * provided by Immutable.js or a plain Array or Object.
 */ function isDataStructure(value) {
    return isImmutable(value) || Array.isArray(value) || isPlainObj(value);
}
/**
 * Converts a value to a string, adding quotes if a string was provided.
 */ function quoteString(value) {
    try {
        return typeof value === 'string' ? JSON.stringify(value) : String(value);
    } catch (_ignoreError) {
        return JSON.stringify(value);
    }
}
function has(collection, key) {
    return isImmutable(collection) ? collection.has(key) : isDataStructure(collection) && hasOwnProperty.call(collection, key);
}
function get(collection, key, notSetValue) {
    return isImmutable(collection) ? collection.get(key, notSetValue) : !has(collection, key) ? notSetValue : typeof collection.get === 'function' ? collection.get(key) : collection[key];
}
function shallowCopy(from) {
    if (Array.isArray(from)) return arrCopy(from);
    var to = {};
    for(var key in from)if (hasOwnProperty.call(from, key)) to[key] = from[key];
    return to;
}
function remove(collection, key) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot update non-data-structure value: ' + collection);
    if (isImmutable(collection)) {
        if (!collection.remove) throw new TypeError('Cannot update immutable value without .remove() method: ' + collection);
        return collection.remove(key);
    }
    if (!hasOwnProperty.call(collection, key)) return collection;
    var collectionCopy = shallowCopy(collection);
    if (Array.isArray(collectionCopy)) collectionCopy.splice(key, 1);
    else delete collectionCopy[key];
    return collectionCopy;
}
function set(collection, key, value) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot update non-data-structure value: ' + collection);
    if (isImmutable(collection)) {
        if (!collection.set) throw new TypeError('Cannot update immutable value without .set() method: ' + collection);
        return collection.set(key, value);
    }
    if (hasOwnProperty.call(collection, key) && value === collection[key]) return collection;
    var collectionCopy = shallowCopy(collection);
    collectionCopy[key] = value;
    return collectionCopy;
}
function updateIn(collection, keyPath, notSetValue, updater) {
    if (!updater) {
        updater = notSetValue;
        notSetValue = undefined;
    }
    var updatedValue = updateInDeeply(isImmutable(collection), collection, coerceKeyPath(keyPath), 0, notSetValue, updater);
    return updatedValue === NOT_SET ? notSetValue : updatedValue;
}
function updateInDeeply(inImmutable, existing, keyPath, i, notSetValue, updater) {
    var wasNotSet = existing === NOT_SET;
    if (i === keyPath.length) {
        var existingValue = wasNotSet ? notSetValue : existing;
        var newValue = updater(existingValue);
        return newValue === existingValue ? existing : newValue;
    }
    if (!wasNotSet && !isDataStructure(existing)) throw new TypeError('Cannot update within non-data-structure value in path [' + keyPath.slice(0, i).map(quoteString) + ']: ' + existing);
    var key = keyPath[i];
    var nextExisting = wasNotSet ? NOT_SET : get(existing, key, NOT_SET);
    var nextUpdated = updateInDeeply(nextExisting === NOT_SET ? inImmutable : isImmutable(nextExisting), nextExisting, keyPath, i + 1, notSetValue, updater);
    return nextUpdated === nextExisting ? existing : nextUpdated === NOT_SET ? remove(existing, key) : set(wasNotSet ? inImmutable ? emptyMap() : {} : existing, key, nextUpdated);
}
function setIn$1(collection, keyPath, value) {
    return updateIn(collection, keyPath, NOT_SET, function() {
        return value;
    });
}
function setIn$$1(keyPath, v) {
    return setIn$1(this, keyPath, v);
}
function removeIn(collection, keyPath) {
    return updateIn(collection, keyPath, function() {
        return NOT_SET;
    });
}
function deleteIn(keyPath) {
    return removeIn(this, keyPath);
}
function update$1(collection, key, notSetValue, updater) {
    return updateIn(collection, [
        key
    ], notSetValue, updater);
}
function update$$1(key, notSetValue, updater) {
    return arguments.length === 1 ? key(this) : update$1(this, key, notSetValue, updater);
}
function updateIn$1(keyPath, notSetValue, updater) {
    return updateIn(this, keyPath, notSetValue, updater);
}
function merge() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeIntoKeyedWith(this, iters);
}
function mergeWith(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return mergeIntoKeyedWith(this, iters, merger);
}
function mergeIntoKeyedWith(collection, collections, merger) {
    var iters = [];
    for(var ii = 0; ii < collections.length; ii++){
        var collection$1 = KeyedCollection(collections[ii]);
        if (collection$1.size !== 0) iters.push(collection$1);
    }
    if (iters.length === 0) return collection;
    if (collection.size === 0 && !collection.__ownerID && iters.length === 1) return collection.constructor(iters[0]);
    return collection.withMutations(function(collection) {
        var mergeIntoCollection = merger ? function(value, key) {
            update$1(collection, key, NOT_SET, function(oldVal) {
                return oldVal === NOT_SET ? value : merger(oldVal, value, key);
            });
        } : function(value, key) {
            collection.set(key, value);
        };
        for(var ii = 0; ii < iters.length; ii++)iters[ii].forEach(mergeIntoCollection);
    });
}
function merge$1(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeWithSources(collection, sources);
}
function mergeWith$1(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeWithSources(collection, sources, merger);
}
function mergeDeep$1(collection) {
    var sources = [], len = arguments.length - 1;
    while(len-- > 0)sources[len] = arguments[len + 1];
    return mergeDeepWithSources(collection, sources);
}
function mergeDeepWith$1(merger, collection) {
    var sources = [], len = arguments.length - 2;
    while(len-- > 0)sources[len] = arguments[len + 2];
    return mergeDeepWithSources(collection, sources, merger);
}
function mergeDeepWithSources(collection, sources, merger) {
    return mergeWithSources(collection, sources, deepMergerWith(merger));
}
function mergeWithSources(collection, sources, merger) {
    if (!isDataStructure(collection)) throw new TypeError('Cannot merge into non-data-structure value: ' + collection);
    if (isImmutable(collection)) return collection.mergeWith ? collection.mergeWith.apply(collection, [
        merger
    ].concat(sources)) : collection.concat.apply(collection, sources);
    var isArray = Array.isArray(collection);
    var merged = collection;
    var Collection$$1 = isArray ? IndexedCollection : KeyedCollection;
    var mergeItem = isArray ? function(value) {
        // Copy on write
        if (merged === collection) merged = shallowCopy(merged);
        merged.push(value);
    } : function(value, key) {
        var hasVal = hasOwnProperty.call(merged, key);
        var nextVal = hasVal && merger ? merger(merged[key], value, key) : value;
        if (!hasVal || nextVal !== merged[key]) {
            // Copy on write
            if (merged === collection) merged = shallowCopy(merged);
            merged[key] = nextVal;
        }
    };
    for(var i = 0; i < sources.length; i++)Collection$$1(sources[i]).forEach(mergeItem);
    return merged;
}
function deepMergerWith(merger) {
    function deepMerger(oldValue, newValue, key) {
        return isDataStructure(oldValue) && isDataStructure(newValue) ? mergeWithSources(oldValue, [
            newValue
        ], deepMerger) : merger ? merger(oldValue, newValue, key) : newValue;
    }
    return deepMerger;
}
function mergeDeep() {
    var iters = [], len = arguments.length;
    while(len--)iters[len] = arguments[len];
    return mergeDeepWithSources(this, iters);
}
function mergeDeepWith(merger) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return mergeDeepWithSources(this, iters, merger);
}
function mergeIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn(this, keyPath, emptyMap(), function(m) {
        return mergeWithSources(m, iters);
    });
}
function mergeDeepIn(keyPath) {
    var iters = [], len = arguments.length - 1;
    while(len-- > 0)iters[len] = arguments[len + 1];
    return updateIn(this, keyPath, emptyMap(), function(m) {
        return mergeDeepWithSources(m, iters);
    });
}
function withMutations(fn) {
    var mutable = this.asMutable();
    fn(mutable);
    return mutable.wasAltered() ? mutable.__ensureOwner(this.__ownerID) : this;
}
function asMutable() {
    return this.__ownerID ? this : this.__ensureOwner(new OwnerID());
}
function asImmutable() {
    return this.__ensureOwner();
}
function wasAltered() {
    return this.__altered;
}
var Map = function(KeyedCollection$$1) {
    function Map(value) {
        return value === null || value === undefined ? emptyMap() : isMap(value) && !isOrdered(value) ? value : emptyMap().withMutations(function(map) {
            var iter = KeyedCollection$$1(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (KeyedCollection$$1) Map.__proto__ = KeyedCollection$$1;
    Map.prototype = Object.create(KeyedCollection$$1 && KeyedCollection$$1.prototype);
    Map.prototype.constructor = Map;
    Map.of = function of() {
        var keyValues = [], len = arguments.length;
        while(len--)keyValues[len] = arguments[len];
        return emptyMap().withMutations(function(map) {
            for(var i = 0; i < keyValues.length; i += 2){
                if (i + 1 >= keyValues.length) throw new Error('Missing value for key: ' + keyValues[i]);
                map.set(keyValues[i], keyValues[i + 1]);
            }
        });
    };
    Map.prototype.toString = function toString() {
        return this.__toString('Map {', '}');
    };
    // @pragma Access
    Map.prototype.get = function get(k, notSetValue) {
        return this._root ? this._root.get(0, undefined, k, notSetValue) : notSetValue;
    };
    // @pragma Modification
    Map.prototype.set = function set(k, v) {
        return updateMap(this, k, v);
    };
    Map.prototype.remove = function remove(k) {
        return updateMap(this, k, NOT_SET);
    };
    Map.prototype.deleteAll = function deleteAll(keys) {
        var collection = Collection(keys);
        if (collection.size === 0) return this;
        return this.withMutations(function(map) {
            collection.forEach(function(key) {
                return map.remove(key);
            });
        });
    };
    Map.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._root = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyMap();
    };
    // @pragma Composition
    Map.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator));
    };
    Map.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedMap(sortFactory(this, comparator, mapper));
    };
    // @pragma Mutability
    Map.prototype.__iterator = function __iterator(type, reverse) {
        return new MapIterator(this, type, reverse);
    };
    Map.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var iterations = 0;
        this._root && this._root.iterate(function(entry) {
            iterations++;
            return fn(entry[1], entry[0], this$1);
        }, reverse);
        return iterations;
    };
    Map.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyMap();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeMap(this.size, this._root, ownerID, this.__hash);
    };
    return Map;
}(KeyedCollection);
function isMap(maybeMap) {
    return !!(maybeMap && maybeMap[IS_MAP_SENTINEL]);
}
Map.isMap = isMap;
var IS_MAP_SENTINEL = '@@__IMMUTABLE_MAP__@@';
var MapPrototype = Map.prototype;
MapPrototype[IS_MAP_SENTINEL] = true;
MapPrototype[DELETE] = MapPrototype.remove;
MapPrototype.removeAll = MapPrototype.deleteAll;
MapPrototype.concat = MapPrototype.merge;
MapPrototype.setIn = setIn$$1;
MapPrototype.removeIn = MapPrototype.deleteIn = deleteIn;
MapPrototype.update = update$$1;
MapPrototype.updateIn = updateIn$1;
MapPrototype.merge = merge;
MapPrototype.mergeWith = mergeWith;
MapPrototype.mergeDeep = mergeDeep;
MapPrototype.mergeDeepWith = mergeDeepWith;
MapPrototype.mergeIn = mergeIn;
MapPrototype.mergeDeepIn = mergeDeepIn;
MapPrototype.withMutations = withMutations;
MapPrototype.wasAltered = wasAltered;
MapPrototype.asImmutable = asImmutable;
MapPrototype['@@transducer/init'] = MapPrototype.asMutable = asMutable;
MapPrototype['@@transducer/step'] = function(result, arr) {
    return result.set(arr[0], arr[1]);
};
MapPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
// #pragma Trie Nodes
var ArrayMapNode = function ArrayMapNode(ownerID, entries) {
    this.ownerID = ownerID;
    this.entries = entries;
};
ArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
ArrayMapNode.prototype.update = function update$$1(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && entries.length === 1) return; // undefined
    if (!exists && !removed && entries.length >= MAX_ARRAY_MAP_SIZE) return createNodes(ownerID, entries, key, value);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new ArrayMapNode(ownerID, newEntries);
};
var BitmapIndexedNode = function BitmapIndexedNode(ownerID, bitmap, nodes) {
    this.ownerID = ownerID;
    this.bitmap = bitmap;
    this.nodes = nodes;
};
BitmapIndexedNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var bit = 1 << ((shift === 0 ? keyHash : keyHash >>> shift) & MASK);
    var bitmap = this.bitmap;
    return (bitmap & bit) === 0 ? notSetValue : this.nodes[popCount(bitmap & bit - 1)].get(shift + SHIFT, keyHash, key, notSetValue);
};
BitmapIndexedNode.prototype.update = function update$$1(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var keyHashFrag = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var bit = 1 << keyHashFrag;
    var bitmap = this.bitmap;
    var exists = (bitmap & bit) !== 0;
    if (!exists && value === NOT_SET) return this;
    var idx = popCount(bitmap & bit - 1);
    var nodes = this.nodes;
    var node = exists ? nodes[idx] : undefined;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    if (!exists && newNode && nodes.length >= MAX_BITMAP_INDEXED_SIZE) return expandNodes(ownerID, nodes, bitmap, keyHashFrag, newNode);
    if (exists && !newNode && nodes.length === 2 && isLeafNode(nodes[idx ^ 1])) return nodes[idx ^ 1];
    if (exists && newNode && nodes.length === 1 && isLeafNode(newNode)) return newNode;
    var isEditable = ownerID && ownerID === this.ownerID;
    var newBitmap = exists ? newNode ? bitmap : bitmap ^ bit : bitmap | bit;
    var newNodes = exists ? newNode ? setAt(nodes, idx, newNode, isEditable) : spliceOut(nodes, idx, isEditable) : spliceIn(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.bitmap = newBitmap;
        this.nodes = newNodes;
        return this;
    }
    return new BitmapIndexedNode(ownerID, newBitmap, newNodes);
};
var HashArrayMapNode = function HashArrayMapNode(ownerID, count, nodes) {
    this.ownerID = ownerID;
    this.count = count;
    this.nodes = nodes;
};
HashArrayMapNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var node = this.nodes[idx];
    return node ? node.get(shift + SHIFT, keyHash, key, notSetValue) : notSetValue;
};
HashArrayMapNode.prototype.update = function update$$1(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var idx = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var removed = value === NOT_SET;
    var nodes = this.nodes;
    var node = nodes[idx];
    if (removed && !node) return this;
    var newNode = updateNode(node, ownerID, shift + SHIFT, keyHash, key, value, didChangeSize, didAlter);
    if (newNode === node) return this;
    var newCount = this.count;
    if (!node) newCount++;
    else if (!newNode) {
        newCount--;
        if (newCount < MIN_HASH_ARRAY_MAP_SIZE) return packNodes(ownerID, nodes, newCount, idx);
    }
    var isEditable = ownerID && ownerID === this.ownerID;
    var newNodes = setAt(nodes, idx, newNode, isEditable);
    if (isEditable) {
        this.count = newCount;
        this.nodes = newNodes;
        return this;
    }
    return new HashArrayMapNode(ownerID, newCount, newNodes);
};
var HashCollisionNode = function HashCollisionNode(ownerID, keyHash, entries) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entries = entries;
};
HashCollisionNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    var entries = this.entries;
    for(var ii = 0, len = entries.length; ii < len; ii++){
        if (is(key, entries[ii][0])) return entries[ii][1];
    }
    return notSetValue;
};
HashCollisionNode.prototype.update = function update$$1(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (keyHash === undefined) keyHash = hash(key);
    var removed = value === NOT_SET;
    if (keyHash !== this.keyHash) {
        if (removed) return this;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return mergeIntoNode(this, ownerID, shift, keyHash, [
            key,
            value
        ]);
    }
    var entries = this.entries;
    var idx = 0;
    var len = entries.length;
    for(; idx < len; idx++){
        if (is(key, entries[idx][0])) break;
    }
    var exists = idx < len;
    if (exists ? entries[idx][1] === value : removed) return this;
    SetRef(didAlter);
    (removed || !exists) && SetRef(didChangeSize);
    if (removed && len === 2) return new ValueNode(ownerID, this.keyHash, entries[idx ^ 1]);
    var isEditable = ownerID && ownerID === this.ownerID;
    var newEntries = isEditable ? entries : arrCopy(entries);
    if (exists) {
        if (removed) idx === len - 1 ? newEntries.pop() : newEntries[idx] = newEntries.pop();
        else newEntries[idx] = [
            key,
            value
        ];
    } else newEntries.push([
        key,
        value
    ]);
    if (isEditable) {
        this.entries = newEntries;
        return this;
    }
    return new HashCollisionNode(ownerID, this.keyHash, newEntries);
};
var ValueNode = function ValueNode(ownerID, keyHash, entry) {
    this.ownerID = ownerID;
    this.keyHash = keyHash;
    this.entry = entry;
};
ValueNode.prototype.get = function get(shift, keyHash, key, notSetValue) {
    return is(key, this.entry[0]) ? this.entry[1] : notSetValue;
};
ValueNode.prototype.update = function update$$1(ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    var removed = value === NOT_SET;
    var keyMatch = is(key, this.entry[0]);
    if (keyMatch ? value === this.entry[1] : removed) return this;
    SetRef(didAlter);
    if (removed) {
        SetRef(didChangeSize);
        return; // undefined
    }
    if (keyMatch) {
        if (ownerID && ownerID === this.ownerID) {
            this.entry[1] = value;
            return this;
        }
        return new ValueNode(ownerID, this.keyHash, [
            key,
            value
        ]);
    }
    SetRef(didChangeSize);
    return mergeIntoNode(this, ownerID, shift, hash(key), [
        key,
        value
    ]);
};
// #pragma Iterators
ArrayMapNode.prototype.iterate = HashCollisionNode.prototype.iterate = function(fn, reverse) {
    var entries = this.entries;
    for(var ii = 0, maxIndex = entries.length - 1; ii <= maxIndex; ii++){
        if (fn(entries[reverse ? maxIndex - ii : ii]) === false) return false;
    }
};
BitmapIndexedNode.prototype.iterate = HashArrayMapNode.prototype.iterate = function(fn, reverse) {
    var nodes = this.nodes;
    for(var ii = 0, maxIndex = nodes.length - 1; ii <= maxIndex; ii++){
        var node = nodes[reverse ? maxIndex - ii : ii];
        if (node && node.iterate(fn, reverse) === false) return false;
    }
};
// eslint-disable-next-line no-unused-vars
ValueNode.prototype.iterate = function(fn, reverse) {
    return fn(this.entry);
};
var MapIterator = function(Iterator$$1) {
    function MapIterator(map, type, reverse) {
        this._type = type;
        this._reverse = reverse;
        this._stack = map._root && mapIteratorFrame(map._root);
    }
    if (Iterator$$1) MapIterator.__proto__ = Iterator$$1;
    MapIterator.prototype = Object.create(Iterator$$1 && Iterator$$1.prototype);
    MapIterator.prototype.constructor = MapIterator;
    MapIterator.prototype.next = function next() {
        var this$1 = this;
        var type = this._type;
        var stack = this._stack;
        while(stack){
            var node = stack.node;
            var index = stack.index++;
            var maxIndex = void 0;
            if (node.entry) {
                if (index === 0) return mapIteratorValue(type, node.entry);
            } else if (node.entries) {
                maxIndex = node.entries.length - 1;
                if (index <= maxIndex) return mapIteratorValue(type, node.entries[this$1._reverse ? maxIndex - index : index]);
            } else {
                maxIndex = node.nodes.length - 1;
                if (index <= maxIndex) {
                    var subNode = node.nodes[this$1._reverse ? maxIndex - index : index];
                    if (subNode) {
                        if (subNode.entry) return mapIteratorValue(type, subNode.entry);
                        stack = this$1._stack = mapIteratorFrame(subNode, stack);
                    }
                    continue;
                }
            }
            stack = this$1._stack = this$1._stack.__prev;
        }
        return iteratorDone();
    };
    return MapIterator;
}(Iterator);
function mapIteratorValue(type, entry) {
    return iteratorValue(type, entry[0], entry[1]);
}
function mapIteratorFrame(node, prev) {
    return {
        node: node,
        index: 0,
        __prev: prev
    };
}
function makeMap(size, root, ownerID, hash$$1) {
    var map = Object.create(MapPrototype);
    map.size = size;
    map._root = root;
    map.__ownerID = ownerID;
    map.__hash = hash$$1;
    map.__altered = false;
    return map;
}
var EMPTY_MAP;
function emptyMap() {
    return EMPTY_MAP || (EMPTY_MAP = makeMap(0));
}
function updateMap(map, k, v) {
    var newRoot;
    var newSize;
    if (!map._root) {
        if (v === NOT_SET) return map;
        newSize = 1;
        newRoot = new ArrayMapNode(map.__ownerID, [
            [
                k,
                v
            ]
        ]);
    } else {
        var didChangeSize = MakeRef(CHANGE_LENGTH);
        var didAlter = MakeRef(DID_ALTER);
        newRoot = updateNode(map._root, map.__ownerID, 0, undefined, k, v, didChangeSize, didAlter);
        if (!didAlter.value) return map;
        newSize = map.size + (didChangeSize.value ? v === NOT_SET ? -1 : 1 : 0);
    }
    if (map.__ownerID) {
        map.size = newSize;
        map._root = newRoot;
        map.__hash = undefined;
        map.__altered = true;
        return map;
    }
    return newRoot ? makeMap(newSize, newRoot) : emptyMap();
}
function updateNode(node, ownerID, shift, keyHash, key, value, didChangeSize, didAlter) {
    if (!node) {
        if (value === NOT_SET) return node;
        SetRef(didAlter);
        SetRef(didChangeSize);
        return new ValueNode(ownerID, keyHash, [
            key,
            value
        ]);
    }
    return node.update(ownerID, shift, keyHash, key, value, didChangeSize, didAlter);
}
function isLeafNode(node) {
    return node.constructor === ValueNode || node.constructor === HashCollisionNode;
}
function mergeIntoNode(node, ownerID, shift, keyHash, entry) {
    if (node.keyHash === keyHash) return new HashCollisionNode(ownerID, keyHash, [
        node.entry,
        entry
    ]);
    var idx1 = (shift === 0 ? node.keyHash : node.keyHash >>> shift) & MASK;
    var idx2 = (shift === 0 ? keyHash : keyHash >>> shift) & MASK;
    var newNode;
    var nodes = idx1 === idx2 ? [
        mergeIntoNode(node, ownerID, shift + SHIFT, keyHash, entry)
    ] : (newNode = new ValueNode(ownerID, keyHash, entry), idx1 < idx2 ? [
        node,
        newNode
    ] : [
        newNode,
        node
    ]);
    return new BitmapIndexedNode(ownerID, 1 << idx1 | 1 << idx2, nodes);
}
function createNodes(ownerID, entries, key, value) {
    if (!ownerID) ownerID = new OwnerID();
    var node = new ValueNode(ownerID, hash(key), [
        key,
        value
    ]);
    for(var ii = 0; ii < entries.length; ii++){
        var entry = entries[ii];
        node = node.update(ownerID, 0, undefined, entry[0], entry[1]);
    }
    return node;
}
function packNodes(ownerID, nodes, count, excluding) {
    var bitmap = 0;
    var packedII = 0;
    var packedNodes = new Array(count);
    for(var ii = 0, bit = 1, len = nodes.length; ii < len; ii++, bit <<= 1){
        var node = nodes[ii];
        if (node !== undefined && ii !== excluding) {
            bitmap |= bit;
            packedNodes[packedII++] = node;
        }
    }
    return new BitmapIndexedNode(ownerID, bitmap, packedNodes);
}
function expandNodes(ownerID, nodes, bitmap, including, node) {
    var count = 0;
    var expandedNodes = new Array(SIZE);
    for(var ii = 0; bitmap !== 0; ii++, bitmap >>>= 1)expandedNodes[ii] = bitmap & 1 ? nodes[count++] : undefined;
    expandedNodes[including] = node;
    return new HashArrayMapNode(ownerID, count + 1, expandedNodes);
}
function popCount(x) {
    x -= x >> 1 & 0x55555555;
    x = (x & 0x33333333) + (x >> 2 & 0x33333333);
    x = x + (x >> 4) & 0x0f0f0f0f;
    x += x >> 8;
    x += x >> 16;
    return x & 0x7f;
}
function setAt(array, idx, val, canEdit) {
    var newArray = canEdit ? array : arrCopy(array);
    newArray[idx] = val;
    return newArray;
}
function spliceIn(array, idx, val, canEdit) {
    var newLen = array.length + 1;
    if (canEdit && idx + 1 === newLen) {
        array[idx] = val;
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++)if (ii === idx) {
        newArray[ii] = val;
        after = -1;
    } else newArray[ii] = array[ii + after];
    return newArray;
}
function spliceOut(array, idx, canEdit) {
    var newLen = array.length - 1;
    if (canEdit && idx === newLen) {
        array.pop();
        return array;
    }
    var newArray = new Array(newLen);
    var after = 0;
    for(var ii = 0; ii < newLen; ii++){
        if (ii === idx) after = 1;
        newArray[ii] = array[ii + after];
    }
    return newArray;
}
var MAX_ARRAY_MAP_SIZE = SIZE / 4;
var MAX_BITMAP_INDEXED_SIZE = SIZE / 2;
var MIN_HASH_ARRAY_MAP_SIZE = SIZE / 4;
var List = function(IndexedCollection$$1) {
    function List(value) {
        var empty = emptyList();
        if (value === null || value === undefined) return empty;
        if (isList(value)) return value;
        var iter = IndexedCollection$$1(value);
        var size = iter.size;
        if (size === 0) return empty;
        assertNotInfinite(size);
        if (size > 0 && size < SIZE) return makeList(0, size, SHIFT, null, new VNode(iter.toArray()));
        return empty.withMutations(function(list) {
            list.setSize(size);
            iter.forEach(function(v, i) {
                return list.set(i, v);
            });
        });
    }
    if (IndexedCollection$$1) List.__proto__ = IndexedCollection$$1;
    List.prototype = Object.create(IndexedCollection$$1 && IndexedCollection$$1.prototype);
    List.prototype.constructor = List;
    List.of = function of() {
        return this(arguments);
    };
    List.prototype.toString = function toString() {
        return this.__toString('List [', ']');
    };
    // @pragma Access
    List.prototype.get = function get(index, notSetValue) {
        index = wrapIndex(this, index);
        if (index >= 0 && index < this.size) {
            index += this._origin;
            var node = listNodeFor(this, index);
            return node && node.array[index & MASK];
        }
        return notSetValue;
    };
    // @pragma Modification
    List.prototype.set = function set(index, value) {
        return updateList(this, index, value);
    };
    List.prototype.remove = function remove(index) {
        return !this.has(index) ? this : index === 0 ? this.shift() : index === this.size - 1 ? this.pop() : this.splice(index, 1);
    };
    List.prototype.insert = function insert(index, value) {
        return this.splice(index, 0, value);
    };
    List.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = this._origin = this._capacity = 0;
            this._level = SHIFT;
            this._root = this._tail = null;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyList();
    };
    List.prototype.push = function push() {
        var values = arguments;
        var oldSize = this.size;
        return this.withMutations(function(list) {
            setListBounds(list, 0, oldSize + values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(oldSize + ii, values[ii]);
        });
    };
    List.prototype.pop = function pop() {
        return setListBounds(this, 0, -1);
    };
    List.prototype.unshift = function unshift() {
        var values = arguments;
        return this.withMutations(function(list) {
            setListBounds(list, -values.length);
            for(var ii = 0; ii < values.length; ii++)list.set(ii, values[ii]);
        });
    };
    List.prototype.shift = function shift() {
        return setListBounds(this, 1);
    };
    // @pragma Composition
    List.prototype.concat = function concat() {
        var arguments$1 = arguments;
        var seqs = [];
        for(var i = 0; i < arguments.length; i++){
            var argument = arguments$1[i];
            var seq = IndexedCollection$$1(typeof argument !== 'string' && hasIterator(argument) ? argument : [
                argument
            ]);
            if (seq.size !== 0) seqs.push(seq);
        }
        if (seqs.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && seqs.length === 1) return this.constructor(seqs[0]);
        return this.withMutations(function(list) {
            seqs.forEach(function(seq) {
                return seq.forEach(function(value) {
                    return list.push(value);
                });
            });
        });
    };
    List.prototype.setSize = function setSize(size) {
        return setListBounds(this, 0, size);
    };
    // @pragma Iteration
    List.prototype.slice = function slice(begin, end) {
        var size = this.size;
        if (wholeSlice(begin, end, size)) return this;
        return setListBounds(this, resolveBegin(begin, size), resolveEnd(end, size));
    };
    List.prototype.__iterator = function __iterator(type, reverse) {
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        return new Iterator(function() {
            var value = values();
            return value === DONE ? iteratorDone() : iteratorValue(type, reverse ? --index : index++, value);
        });
    };
    List.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var index = reverse ? this.size : 0;
        var values = iterateList(this, reverse);
        var value;
        while((value = values()) !== DONE){
            if (fn(value, reverse ? --index : index++, this$1) === false) break;
        }
        return index;
    };
    List.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyList();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeList(this._origin, this._capacity, this._level, this._root, this._tail, ownerID, this.__hash);
    };
    return List;
}(IndexedCollection);
function isList(maybeList) {
    return !!(maybeList && maybeList[IS_LIST_SENTINEL]);
}
List.isList = isList;
var IS_LIST_SENTINEL = '@@__IMMUTABLE_LIST__@@';
var ListPrototype = List.prototype;
ListPrototype[IS_LIST_SENTINEL] = true;
ListPrototype[DELETE] = ListPrototype.remove;
ListPrototype.merge = ListPrototype.concat;
ListPrototype.setIn = setIn$$1;
ListPrototype.deleteIn = ListPrototype.removeIn = deleteIn;
ListPrototype.update = update$$1;
ListPrototype.updateIn = updateIn$1;
ListPrototype.mergeIn = mergeIn;
ListPrototype.mergeDeepIn = mergeDeepIn;
ListPrototype.withMutations = withMutations;
ListPrototype.wasAltered = wasAltered;
ListPrototype.asImmutable = asImmutable;
ListPrototype['@@transducer/init'] = ListPrototype.asMutable = asMutable;
ListPrototype['@@transducer/step'] = function(result, arr) {
    return result.push(arr);
};
ListPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
var VNode = function VNode(array, ownerID) {
    this.array = array;
    this.ownerID = ownerID;
};
// TODO: seems like these methods are very similar
VNode.prototype.removeBefore = function removeBefore(ownerID, level, index) {
    if (index === level ? 1 << level : this.array.length === 0) return this;
    var originIndex = index >>> level & MASK;
    if (originIndex >= this.array.length) return new VNode([], ownerID);
    var removingFirst = originIndex === 0;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[originIndex];
        newChild = oldChild && oldChild.removeBefore(ownerID, level - SHIFT, index);
        if (newChild === oldChild && removingFirst) return this;
    }
    if (removingFirst && !newChild) return this;
    var editable = editableVNode(this, ownerID);
    if (!removingFirst) for(var ii = 0; ii < originIndex; ii++)editable.array[ii] = undefined;
    if (newChild) editable.array[originIndex] = newChild;
    return editable;
};
VNode.prototype.removeAfter = function removeAfter(ownerID, level, index) {
    if (index === (level ? 1 << level : 0) || this.array.length === 0) return this;
    var sizeIndex = index - 1 >>> level & MASK;
    if (sizeIndex >= this.array.length) return this;
    var newChild;
    if (level > 0) {
        var oldChild = this.array[sizeIndex];
        newChild = oldChild && oldChild.removeAfter(ownerID, level - SHIFT, index);
        if (newChild === oldChild && sizeIndex === this.array.length - 1) return this;
    }
    var editable = editableVNode(this, ownerID);
    editable.array.splice(sizeIndex + 1);
    if (newChild) editable.array[sizeIndex] = newChild;
    return editable;
};
var DONE = {};
function iterateList(list, reverse) {
    var left = list._origin;
    var right = list._capacity;
    var tailPos = getTailOffset(right);
    var tail = list._tail;
    return iterateNodeOrLeaf(list._root, list._level, 0);
    function iterateNodeOrLeaf(node, level, offset) {
        return level === 0 ? iterateLeaf(node, offset) : iterateNode(node, level, offset);
    }
    function iterateLeaf(node, offset) {
        var array = offset === tailPos ? tail && tail.array : node && node.array;
        var from = offset > left ? 0 : left - offset;
        var to = right - offset;
        if (to > SIZE) to = SIZE;
        return function() {
            if (from === to) return DONE;
            var idx = reverse ? --to : from++;
            return array && array[idx];
        };
    }
    function iterateNode(node, level, offset) {
        var values;
        var array = node && node.array;
        var from = offset > left ? 0 : left - offset >> level;
        var to = (right - offset >> level) + 1;
        if (to > SIZE) to = SIZE;
        return function() {
            while(true){
                if (values) {
                    var value = values();
                    if (value !== DONE) return value;
                    values = null;
                }
                if (from === to) return DONE;
                var idx = reverse ? --to : from++;
                values = iterateNodeOrLeaf(array && array[idx], level - SHIFT, offset + (idx << level));
            }
        };
    }
}
function makeList(origin, capacity, level, root, tail, ownerID, hash) {
    var list = Object.create(ListPrototype);
    list.size = capacity - origin;
    list._origin = origin;
    list._capacity = capacity;
    list._level = level;
    list._root = root;
    list._tail = tail;
    list.__ownerID = ownerID;
    list.__hash = hash;
    list.__altered = false;
    return list;
}
var EMPTY_LIST;
function emptyList() {
    return EMPTY_LIST || (EMPTY_LIST = makeList(0, 0, SHIFT));
}
function updateList(list, index, value) {
    index = wrapIndex(list, index);
    if (index !== index) return list;
    if (index >= list.size || index < 0) return list.withMutations(function(list) {
        index < 0 ? setListBounds(list, index).set(0, value) : setListBounds(list, 0, index + 1).set(index, value);
    });
    index += list._origin;
    var newTail = list._tail;
    var newRoot = list._root;
    var didAlter = MakeRef(DID_ALTER);
    if (index >= getTailOffset(list._capacity)) newTail = updateVNode(newTail, list.__ownerID, 0, index, value, didAlter);
    else newRoot = updateVNode(newRoot, list.__ownerID, list._level, index, value, didAlter);
    if (!didAlter.value) return list;
    if (list.__ownerID) {
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(list._origin, list._capacity, list._level, newRoot, newTail);
}
function updateVNode(node, ownerID, level, index, value, didAlter) {
    var idx = index >>> level & MASK;
    var nodeHas = node && idx < node.array.length;
    if (!nodeHas && value === undefined) return node;
    var newNode;
    if (level > 0) {
        var lowerNode = node && node.array[idx];
        var newLowerNode = updateVNode(lowerNode, ownerID, level - SHIFT, index, value, didAlter);
        if (newLowerNode === lowerNode) return node;
        newNode = editableVNode(node, ownerID);
        newNode.array[idx] = newLowerNode;
        return newNode;
    }
    if (nodeHas && node.array[idx] === value) return node;
    SetRef(didAlter);
    newNode = editableVNode(node, ownerID);
    if (value === undefined && idx === newNode.array.length - 1) newNode.array.pop();
    else newNode.array[idx] = value;
    return newNode;
}
function editableVNode(node, ownerID) {
    if (ownerID && node && ownerID === node.ownerID) return node;
    return new VNode(node ? node.array.slice() : [], ownerID);
}
function listNodeFor(list, rawIndex) {
    if (rawIndex >= getTailOffset(list._capacity)) return list._tail;
    if (rawIndex < 1 << list._level + SHIFT) {
        var node = list._root;
        var level = list._level;
        while(node && level > 0){
            node = node.array[rawIndex >>> level & MASK];
            level -= SHIFT;
        }
        return node;
    }
}
function setListBounds(list, begin, end) {
    // Sanitize begin & end using this shorthand for ToInt32(argument)
    // http://www.ecma-international.org/ecma-262/6.0/#sec-toint32
    if (begin !== undefined) begin |= 0;
    if (end !== undefined) end |= 0;
    var owner = list.__ownerID || new OwnerID();
    var oldOrigin = list._origin;
    var oldCapacity = list._capacity;
    var newOrigin = oldOrigin + begin;
    var newCapacity = end === undefined ? oldCapacity : end < 0 ? oldCapacity + end : oldOrigin + end;
    if (newOrigin === oldOrigin && newCapacity === oldCapacity) return list;
    // If it's going to end after it starts, it's empty.
    if (newOrigin >= newCapacity) return list.clear();
    var newLevel = list._level;
    var newRoot = list._root;
    // New origin might need creating a higher root.
    var offsetShift = 0;
    while(newOrigin + offsetShift < 0){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            undefined,
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
        offsetShift += 1 << newLevel;
    }
    if (offsetShift) {
        newOrigin += offsetShift;
        oldOrigin += offsetShift;
        newCapacity += offsetShift;
        oldCapacity += offsetShift;
    }
    var oldTailOffset = getTailOffset(oldCapacity);
    var newTailOffset = getTailOffset(newCapacity);
    // New size might need creating a higher root.
    while(newTailOffset >= 1 << newLevel + SHIFT){
        newRoot = new VNode(newRoot && newRoot.array.length ? [
            newRoot
        ] : [], owner);
        newLevel += SHIFT;
    }
    // Locate or create the new tail.
    var oldTail = list._tail;
    var newTail = newTailOffset < oldTailOffset ? listNodeFor(list, newCapacity - 1) : newTailOffset > oldTailOffset ? new VNode([], owner) : oldTail;
    // Merge Tail into tree.
    if (oldTail && newTailOffset > oldTailOffset && newOrigin < oldCapacity && oldTail.array.length) {
        newRoot = editableVNode(newRoot, owner);
        var node = newRoot;
        for(var level = newLevel; level > SHIFT; level -= SHIFT){
            var idx = oldTailOffset >>> level & MASK;
            node = node.array[idx] = editableVNode(node.array[idx], owner);
        }
        node.array[oldTailOffset >>> SHIFT & MASK] = oldTail;
    }
    // If the size has been reduced, there's a chance the tail needs to be trimmed.
    if (newCapacity < oldCapacity) newTail = newTail && newTail.removeAfter(owner, 0, newCapacity);
    // If the new origin is within the tail, then we do not need a root.
    if (newOrigin >= newTailOffset) {
        newOrigin -= newTailOffset;
        newCapacity -= newTailOffset;
        newLevel = SHIFT;
        newRoot = null;
        newTail = newTail && newTail.removeBefore(owner, 0, newOrigin);
    // Otherwise, if the root has been trimmed, garbage collect.
    } else if (newOrigin > oldOrigin || newTailOffset < oldTailOffset) {
        offsetShift = 0;
        // Identify the new top root node of the subtree of the old root.
        while(newRoot){
            var beginIndex = newOrigin >>> newLevel & MASK;
            if (beginIndex !== newTailOffset >>> newLevel & MASK) break;
            if (beginIndex) offsetShift += (1 << newLevel) * beginIndex;
            newLevel -= SHIFT;
            newRoot = newRoot.array[beginIndex];
        }
        // Trim the new sides of the new root.
        if (newRoot && newOrigin > oldOrigin) newRoot = newRoot.removeBefore(owner, newLevel, newOrigin - offsetShift);
        if (newRoot && newTailOffset < oldTailOffset) newRoot = newRoot.removeAfter(owner, newLevel, newTailOffset - offsetShift);
        if (offsetShift) {
            newOrigin -= offsetShift;
            newCapacity -= offsetShift;
        }
    }
    if (list.__ownerID) {
        list.size = newCapacity - newOrigin;
        list._origin = newOrigin;
        list._capacity = newCapacity;
        list._level = newLevel;
        list._root = newRoot;
        list._tail = newTail;
        list.__hash = undefined;
        list.__altered = true;
        return list;
    }
    return makeList(newOrigin, newCapacity, newLevel, newRoot, newTail);
}
function getTailOffset(size) {
    return size < SIZE ? 0 : size - 1 >>> SHIFT << SHIFT;
}
var OrderedMap = function(Map$$1) {
    function OrderedMap(value) {
        return value === null || value === undefined ? emptyOrderedMap() : isOrderedMap(value) ? value : emptyOrderedMap().withMutations(function(map) {
            var iter = KeyedCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v, k) {
                return map.set(k, v);
            });
        });
    }
    if (Map$$1) OrderedMap.__proto__ = Map$$1;
    OrderedMap.prototype = Object.create(Map$$1 && Map$$1.prototype);
    OrderedMap.prototype.constructor = OrderedMap;
    OrderedMap.of = function of() {
        return this(arguments);
    };
    OrderedMap.prototype.toString = function toString() {
        return this.__toString('OrderedMap {', '}');
    };
    // @pragma Access
    OrderedMap.prototype.get = function get(k, notSetValue) {
        var index = this._map.get(k);
        return index !== undefined ? this._list.get(index)[1] : notSetValue;
    };
    // @pragma Modification
    OrderedMap.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._map.clear();
            this._list.clear();
            return this;
        }
        return emptyOrderedMap();
    };
    OrderedMap.prototype.set = function set(k, v) {
        return updateOrderedMap(this, k, v);
    };
    OrderedMap.prototype.remove = function remove(k) {
        return updateOrderedMap(this, k, NOT_SET);
    };
    OrderedMap.prototype.wasAltered = function wasAltered() {
        return this._map.wasAltered() || this._list.wasAltered();
    };
    OrderedMap.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        return this._list.__iterate(function(entry) {
            return entry && fn(entry[1], entry[0], this$1);
        }, reverse);
    };
    OrderedMap.prototype.__iterator = function __iterator(type, reverse) {
        return this._list.fromEntrySeq().__iterator(type, reverse);
    };
    OrderedMap.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        var newList = this._list.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return emptyOrderedMap();
            this.__ownerID = ownerID;
            this._map = newMap;
            this._list = newList;
            return this;
        }
        return makeOrderedMap(newMap, newList, ownerID, this.__hash);
    };
    return OrderedMap;
}(Map);
function isOrderedMap(maybeOrderedMap) {
    return isMap(maybeOrderedMap) && isOrdered(maybeOrderedMap);
}
OrderedMap.isOrderedMap = isOrderedMap;
OrderedMap.prototype[IS_ORDERED_SENTINEL] = true;
OrderedMap.prototype[DELETE] = OrderedMap.prototype.remove;
function makeOrderedMap(map, list, ownerID, hash) {
    var omap = Object.create(OrderedMap.prototype);
    omap.size = map ? map.size : 0;
    omap._map = map;
    omap._list = list;
    omap.__ownerID = ownerID;
    omap.__hash = hash;
    return omap;
}
var EMPTY_ORDERED_MAP;
function emptyOrderedMap() {
    return EMPTY_ORDERED_MAP || (EMPTY_ORDERED_MAP = makeOrderedMap(emptyMap(), emptyList()));
}
function updateOrderedMap(omap, k, v) {
    var map = omap._map;
    var list = omap._list;
    var i = map.get(k);
    var has = i !== undefined;
    var newMap;
    var newList;
    if (v === NOT_SET) {
        // removed
        if (!has) return omap;
        if (list.size >= SIZE && list.size >= map.size * 2) {
            newList = list.filter(function(entry, idx) {
                return entry !== undefined && i !== idx;
            });
            newMap = newList.toKeyedSeq().map(function(entry) {
                return entry[0];
            }).flip().toMap();
            if (omap.__ownerID) newMap.__ownerID = newList.__ownerID = omap.__ownerID;
        } else {
            newMap = map.remove(k);
            newList = i === list.size - 1 ? list.pop() : list.set(i, undefined);
        }
    } else if (has) {
        if (v === list.get(i)[1]) return omap;
        newMap = map;
        newList = list.set(i, [
            k,
            v
        ]);
    } else {
        newMap = map.set(k, list.size);
        newList = list.set(list.size, [
            k,
            v
        ]);
    }
    if (omap.__ownerID) {
        omap.size = newMap.size;
        omap._map = newMap;
        omap._list = newList;
        omap.__hash = undefined;
        return omap;
    }
    return makeOrderedMap(newMap, newList);
}
var Stack = function(IndexedCollection$$1) {
    function Stack(value) {
        return value === null || value === undefined ? emptyStack() : isStack(value) ? value : emptyStack().pushAll(value);
    }
    if (IndexedCollection$$1) Stack.__proto__ = IndexedCollection$$1;
    Stack.prototype = Object.create(IndexedCollection$$1 && IndexedCollection$$1.prototype);
    Stack.prototype.constructor = Stack;
    Stack.of = function of() {
        return this(arguments);
    };
    Stack.prototype.toString = function toString() {
        return this.__toString('Stack [', ']');
    };
    // @pragma Access
    Stack.prototype.get = function get(index, notSetValue) {
        var head = this._head;
        index = wrapIndex(this, index);
        while(head && index--)head = head.next;
        return head ? head.value : notSetValue;
    };
    Stack.prototype.peek = function peek() {
        return this._head && this._head.value;
    };
    // @pragma Modification
    Stack.prototype.push = function push() {
        var arguments$1 = arguments;
        if (arguments.length === 0) return this;
        var newSize = this.size + arguments.length;
        var head = this._head;
        for(var ii = arguments.length - 1; ii >= 0; ii--)head = {
            value: arguments$1[ii],
            next: head
        };
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pushAll = function pushAll(iter) {
        iter = IndexedCollection$$1(iter);
        if (iter.size === 0) return this;
        if (this.size === 0 && isStack(iter)) return iter;
        assertNotInfinite(iter.size);
        var newSize = this.size;
        var head = this._head;
        iter.__iterate(function(value) {
            newSize++;
            head = {
                value: value,
                next: head
            };
        }, /* reverse */ true);
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    Stack.prototype.pop = function pop() {
        return this.slice(1);
    };
    Stack.prototype.clear = function clear() {
        if (this.size === 0) return this;
        if (this.__ownerID) {
            this.size = 0;
            this._head = undefined;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return emptyStack();
    };
    Stack.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        var resolvedBegin = resolveBegin(begin, this.size);
        var resolvedEnd = resolveEnd(end, this.size);
        if (resolvedEnd !== this.size) // super.slice(begin, end);
        return IndexedCollection$$1.prototype.slice.call(this, begin, end);
        var newSize = this.size - resolvedBegin;
        var head = this._head;
        while(resolvedBegin--)head = head.next;
        if (this.__ownerID) {
            this.size = newSize;
            this._head = head;
            this.__hash = undefined;
            this.__altered = true;
            return this;
        }
        return makeStack(newSize, head);
    };
    // @pragma Mutability
    Stack.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        if (!ownerID) {
            if (this.size === 0) return emptyStack();
            this.__ownerID = ownerID;
            this.__altered = false;
            return this;
        }
        return makeStack(this.size, this._head, ownerID, this.__hash);
    };
    // @pragma Iteration
    Stack.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        if (reverse) return new ArraySeq(this.toArray()).__iterate(function(v, k) {
            return fn(v, k, this$1);
        }, reverse);
        var iterations = 0;
        var node = this._head;
        while(node){
            if (fn(node.value, iterations++, this$1) === false) break;
            node = node.next;
        }
        return iterations;
    };
    Stack.prototype.__iterator = function __iterator(type, reverse) {
        if (reverse) return new ArraySeq(this.toArray()).__iterator(type, reverse);
        var iterations = 0;
        var node = this._head;
        return new Iterator(function() {
            if (node) {
                var value = node.value;
                node = node.next;
                return iteratorValue(type, iterations++, value);
            }
            return iteratorDone();
        });
    };
    return Stack;
}(IndexedCollection);
function isStack(maybeStack) {
    return !!(maybeStack && maybeStack[IS_STACK_SENTINEL]);
}
Stack.isStack = isStack;
var IS_STACK_SENTINEL = '@@__IMMUTABLE_STACK__@@';
var StackPrototype = Stack.prototype;
StackPrototype[IS_STACK_SENTINEL] = true;
StackPrototype.shift = StackPrototype.pop;
StackPrototype.unshift = StackPrototype.push;
StackPrototype.unshiftAll = StackPrototype.pushAll;
StackPrototype.withMutations = withMutations;
StackPrototype.wasAltered = wasAltered;
StackPrototype.asImmutable = asImmutable;
StackPrototype['@@transducer/init'] = StackPrototype.asMutable = asMutable;
StackPrototype['@@transducer/step'] = function(result, arr) {
    return result.unshift(arr);
};
StackPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
function makeStack(size, head, ownerID, hash) {
    var map = Object.create(StackPrototype);
    map.size = size;
    map._head = head;
    map.__ownerID = ownerID;
    map.__hash = hash;
    map.__altered = false;
    return map;
}
var EMPTY_STACK;
function emptyStack() {
    return EMPTY_STACK || (EMPTY_STACK = makeStack(0));
}
function deepEqual(a, b) {
    if (a === b) return true;
    if (!isCollection(b) || a.size !== undefined && b.size !== undefined && a.size !== b.size || a.__hash !== undefined && b.__hash !== undefined && a.__hash !== b.__hash || isKeyed(a) !== isKeyed(b) || isIndexed(a) !== isIndexed(b) || isOrdered(a) !== isOrdered(b)) return false;
    if (a.size === 0 && b.size === 0) return true;
    var notAssociative = !isAssociative(a);
    if (isOrdered(a)) {
        var entries = a.entries();
        return b.every(function(v, k) {
            var entry = entries.next().value;
            return entry && is(entry[1], v) && (notAssociative || is(entry[0], k));
        }) && entries.next().done;
    }
    var flipped = false;
    if (a.size === undefined) {
        if (b.size === undefined) {
            if (typeof a.cacheResult === 'function') a.cacheResult();
        } else {
            flipped = true;
            var _ = a;
            a = b;
            b = _;
        }
    }
    var allEqual = true;
    var bSize = b.__iterate(function(v, k) {
        if (notAssociative ? !a.has(v) : flipped ? !is(v, a.get(k, NOT_SET)) : !is(a.get(k, NOT_SET), v)) {
            allEqual = false;
            return false;
        }
    });
    return allEqual && a.size === bSize;
}
/**
 * Contributes additional methods to a constructor
 */ function mixin(ctor, methods) {
    var keyCopier = function(key) {
        ctor.prototype[key] = methods[key];
    };
    Object.keys(methods).forEach(keyCopier);
    Object.getOwnPropertySymbols && Object.getOwnPropertySymbols(methods).forEach(keyCopier);
    return ctor;
}
function toJS(value) {
    return isDataStructure(value) ? Seq(value).map(toJS).toJSON() : value;
}
var Set = function(SetCollection$$1) {
    function Set(value) {
        return value === null || value === undefined ? emptySet() : isSet(value) && !isOrdered(value) ? value : emptySet().withMutations(function(set) {
            var iter = SetCollection$$1(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (SetCollection$$1) Set.__proto__ = SetCollection$$1;
    Set.prototype = Object.create(SetCollection$$1 && SetCollection$$1.prototype);
    Set.prototype.constructor = Set;
    Set.of = function of() {
        return this(arguments);
    };
    Set.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    Set.intersect = function intersect(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.intersect.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.union = function union(sets) {
        sets = Collection(sets).toArray();
        return sets.length ? SetPrototype.union.apply(Set(sets.pop()), sets) : emptySet();
    };
    Set.prototype.toString = function toString() {
        return this.__toString('Set {', '}');
    };
    // @pragma Access
    Set.prototype.has = function has(value) {
        return this._map.has(value);
    };
    // @pragma Modification
    Set.prototype.add = function add(value) {
        return updateSet(this, this._map.set(value, value));
    };
    Set.prototype.remove = function remove(value) {
        return updateSet(this, this._map.remove(value));
    };
    Set.prototype.clear = function clear() {
        return updateSet(this, this._map.clear());
    };
    // @pragma Composition
    Set.prototype.union = function union() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        iters = iters.filter(function(x) {
            return x.size !== 0;
        });
        if (iters.length === 0) return this;
        if (this.size === 0 && !this.__ownerID && iters.length === 1) return this.constructor(iters[0]);
        return this.withMutations(function(set) {
            for(var ii = 0; ii < iters.length; ii++)SetCollection$$1(iters[ii]).forEach(function(value) {
                return set.add(value);
            });
        });
    };
    Set.prototype.intersect = function intersect() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection$$1(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (!iters.every(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.subtract = function subtract() {
        var iters = [], len = arguments.length;
        while(len--)iters[len] = arguments[len];
        if (iters.length === 0) return this;
        iters = iters.map(function(iter) {
            return SetCollection$$1(iter);
        });
        var toRemove = [];
        this.forEach(function(value) {
            if (iters.some(function(iter) {
                return iter.includes(value);
            })) toRemove.push(value);
        });
        return this.withMutations(function(set) {
            toRemove.forEach(function(value) {
                set.remove(value);
            });
        });
    };
    Set.prototype.sort = function sort(comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator));
    };
    Set.prototype.sortBy = function sortBy(mapper, comparator) {
        // Late binding
        return OrderedSet(sortFactory(this, comparator, mapper));
    };
    Set.prototype.wasAltered = function wasAltered() {
        return this._map.wasAltered();
    };
    Set.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        return this._map.__iterate(function(k) {
            return fn(k, k, this$1);
        }, reverse);
    };
    Set.prototype.__iterator = function __iterator(type, reverse) {
        return this._map.__iterator(type, reverse);
    };
    Set.prototype.__ensureOwner = function __ensureOwner(ownerID) {
        if (ownerID === this.__ownerID) return this;
        var newMap = this._map.__ensureOwner(ownerID);
        if (!ownerID) {
            if (this.size === 0) return this.__empty();
            this.__ownerID = ownerID;
            this._map = newMap;
            return this;
        }
        return this.__make(newMap, ownerID);
    };
    return Set;
}(SetCollection);
function isSet(maybeSet) {
    return !!(maybeSet && maybeSet[IS_SET_SENTINEL]);
}
Set.isSet = isSet;
var IS_SET_SENTINEL = '@@__IMMUTABLE_SET__@@';
var SetPrototype = Set.prototype;
SetPrototype[IS_SET_SENTINEL] = true;
SetPrototype[DELETE] = SetPrototype.remove;
SetPrototype.merge = SetPrototype.concat = SetPrototype.union;
SetPrototype.withMutations = withMutations;
SetPrototype.asImmutable = asImmutable;
SetPrototype['@@transducer/init'] = SetPrototype.asMutable = asMutable;
SetPrototype['@@transducer/step'] = function(result, arr) {
    return result.add(arr);
};
SetPrototype['@@transducer/result'] = function(obj) {
    return obj.asImmutable();
};
SetPrototype.__empty = emptySet;
SetPrototype.__make = makeSet;
function updateSet(set, newMap) {
    if (set.__ownerID) {
        set.size = newMap.size;
        set._map = newMap;
        return set;
    }
    return newMap === set._map ? set : newMap.size === 0 ? set.__empty() : set.__make(newMap);
}
function makeSet(map, ownerID) {
    var set = Object.create(SetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_SET;
function emptySet() {
    return EMPTY_SET || (EMPTY_SET = makeSet(emptyMap()));
}
/**
 * Returns a lazy seq of nums from start (inclusive) to end
 * (exclusive), by step, where start defaults to 0, step to 1, and end to
 * infinity. When start is equal to end, returns empty list.
 */ var Range = function(IndexedSeq$$1) {
    function Range(start, end, step) {
        if (!(this instanceof Range)) return new Range(start, end, step);
        invariant(step !== 0, 'Cannot step a Range by 0');
        start = start || 0;
        if (end === undefined) end = Infinity;
        step = step === undefined ? 1 : Math.abs(step);
        if (end < start) step = -step;
        this._start = start;
        this._end = end;
        this._step = step;
        this.size = Math.max(0, Math.ceil((end - start) / step - 1) + 1);
        if (this.size === 0) {
            if (EMPTY_RANGE) return EMPTY_RANGE;
            EMPTY_RANGE = this;
        }
    }
    if (IndexedSeq$$1) Range.__proto__ = IndexedSeq$$1;
    Range.prototype = Object.create(IndexedSeq$$1 && IndexedSeq$$1.prototype);
    Range.prototype.constructor = Range;
    Range.prototype.toString = function toString() {
        if (this.size === 0) return 'Range []';
        return 'Range [ ' + this._start + '...' + this._end + (this._step !== 1 ? ' by ' + this._step : '') + ' ]';
    };
    Range.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._start + wrapIndex(this, index) * this._step : notSetValue;
    };
    Range.prototype.includes = function includes(searchValue) {
        var possibleIndex = (searchValue - this._start) / this._step;
        return possibleIndex >= 0 && possibleIndex < this.size && possibleIndex === Math.floor(possibleIndex);
    };
    Range.prototype.slice = function slice(begin, end) {
        if (wholeSlice(begin, end, this.size)) return this;
        begin = resolveBegin(begin, this.size);
        end = resolveEnd(end, this.size);
        if (end <= begin) return new Range(0, 0);
        return new Range(this.get(begin, this._end), this.get(end, this._end), this._step);
    };
    Range.prototype.indexOf = function indexOf(searchValue) {
        var offsetValue = searchValue - this._start;
        if (offsetValue % this._step === 0) {
            var index = offsetValue / this._step;
            if (index >= 0 && index < this.size) return index;
        }
        return -1;
    };
    Range.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        return this.indexOf(searchValue);
    };
    Range.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        while(i !== size){
            if (fn(value, reverse ? size - ++i : i++, this$1) === false) break;
            value += reverse ? -step : step;
        }
        return i;
    };
    Range.prototype.__iterator = function __iterator(type, reverse) {
        var size = this.size;
        var step = this._step;
        var value = reverse ? this._start + (size - 1) * step : this._start;
        var i = 0;
        return new Iterator(function() {
            if (i === size) return iteratorDone();
            var v = value;
            value += reverse ? -step : step;
            return iteratorValue(type, reverse ? size - ++i : i++, v);
        });
    };
    Range.prototype.equals = function equals(other) {
        return other instanceof Range ? this._start === other._start && this._end === other._end && this._step === other._step : deepEqual(this, other);
    };
    return Range;
}(IndexedSeq);
var EMPTY_RANGE;
function getIn$1(collection, searchKeyPath, notSetValue) {
    var keyPath = coerceKeyPath(searchKeyPath);
    var i = 0;
    while(i !== keyPath.length){
        collection = get(collection, keyPath[i++], NOT_SET);
        if (collection === NOT_SET) return notSetValue;
    }
    return collection;
}
function getIn$$1(searchKeyPath, notSetValue) {
    return getIn$1(this, searchKeyPath, notSetValue);
}
function hasIn$1(collection, keyPath) {
    return getIn$1(collection, keyPath, NOT_SET) !== NOT_SET;
}
function hasIn$$1(searchKeyPath) {
    return hasIn$1(this, searchKeyPath);
}
function toObject() {
    assertNotInfinite(this.size);
    var object = {};
    this.__iterate(function(v, k) {
        object[k] = v;
    });
    return object;
}
// Note: all of these methods are deprecated.
Collection.isIterable = isCollection;
Collection.isKeyed = isKeyed;
Collection.isIndexed = isIndexed;
Collection.isAssociative = isAssociative;
Collection.isOrdered = isOrdered;
Collection.Iterator = Iterator;
mixin(Collection, {
    // ### Conversion to other types
    toArray: function toArray() {
        assertNotInfinite(this.size);
        var array = new Array(this.size || 0);
        var useTuples = isKeyed(this);
        var i = 0;
        this.__iterate(function(v, k) {
            // Keyed collections produce an array of tuples.
            array[i++] = useTuples ? [
                k,
                v
            ] : v;
        });
        return array;
    },
    toIndexedSeq: function toIndexedSeq() {
        return new ToIndexedSequence(this);
    },
    toJS: function toJS$1() {
        return toJS(this);
    },
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, true);
    },
    toMap: function toMap() {
        // Use Late Binding here to solve the circular dependency.
        return Map(this.toKeyedSeq());
    },
    toObject: toObject,
    toOrderedMap: function toOrderedMap() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedMap(this.toKeyedSeq());
    },
    toOrderedSet: function toOrderedSet() {
        // Use Late Binding here to solve the circular dependency.
        return OrderedSet(isKeyed(this) ? this.valueSeq() : this);
    },
    toSet: function toSet() {
        // Use Late Binding here to solve the circular dependency.
        return Set(isKeyed(this) ? this.valueSeq() : this);
    },
    toSetSeq: function toSetSeq() {
        return new ToSetSequence(this);
    },
    toSeq: function toSeq() {
        return isIndexed(this) ? this.toIndexedSeq() : isKeyed(this) ? this.toKeyedSeq() : this.toSetSeq();
    },
    toStack: function toStack() {
        // Use Late Binding here to solve the circular dependency.
        return Stack(isKeyed(this) ? this.valueSeq() : this);
    },
    toList: function toList() {
        // Use Late Binding here to solve the circular dependency.
        return List(isKeyed(this) ? this.valueSeq() : this);
    },
    // ### Common JavaScript methods and properties
    toString: function toString() {
        return '[Collection]';
    },
    __toString: function __toString(head, tail) {
        if (this.size === 0) return head + tail;
        return head + ' ' + this.toSeq().map(this.__toStringMapper).join(', ') + ' ' + tail;
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    concat: function concat() {
        var values = [], len = arguments.length;
        while(len--)values[len] = arguments[len];
        return reify(this, concatFactory(this, values));
    },
    includes: function includes(searchValue) {
        return this.some(function(value) {
            return is(value, searchValue);
        });
    },
    entries: function entries() {
        return this.__iterator(ITERATE_ENTRIES);
    },
    every: function every(predicate, context) {
        assertNotInfinite(this.size);
        var returnValue = true;
        this.__iterate(function(v, k, c) {
            if (!predicate.call(context, v, k, c)) {
                returnValue = false;
                return false;
            }
        });
        return returnValue;
    },
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, true));
    },
    find: function find(predicate, context, notSetValue) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[1] : notSetValue;
    },
    forEach: function forEach(sideEffect, context) {
        assertNotInfinite(this.size);
        return this.__iterate(context ? sideEffect.bind(context) : sideEffect);
    },
    join: function join(separator) {
        assertNotInfinite(this.size);
        separator = separator !== undefined ? '' + separator : ',';
        var joined = '';
        var isFirst = true;
        this.__iterate(function(v) {
            isFirst ? isFirst = false : joined += separator;
            joined += v !== null && v !== undefined ? v.toString() : '';
        });
        return joined;
    },
    keys: function keys() {
        return this.__iterator(ITERATE_KEYS);
    },
    map: function map(mapper, context) {
        return reify(this, mapFactory(this, mapper, context));
    },
    reduce: function reduce$1(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, false);
    },
    reduceRight: function reduceRight(reducer, initialReduction, context) {
        return reduce(this, reducer, initialReduction, context, arguments.length < 2, true);
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, true));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, true));
    },
    some: function some(predicate, context) {
        return !this.every(not(predicate), context);
    },
    sort: function sort(comparator) {
        return reify(this, sortFactory(this, comparator));
    },
    values: function values() {
        return this.__iterator(ITERATE_VALUES);
    },
    // ### More sequential methods
    butLast: function butLast() {
        return this.slice(0, -1);
    },
    isEmpty: function isEmpty() {
        return this.size !== undefined ? this.size === 0 : !this.some(function() {
            return true;
        });
    },
    count: function count(predicate, context) {
        return ensureSize(predicate ? this.toSeq().filter(predicate, context) : this);
    },
    countBy: function countBy(grouper, context) {
        return countByFactory(this, grouper, context);
    },
    equals: function equals(other) {
        return deepEqual(this, other);
    },
    entrySeq: function entrySeq() {
        var collection = this;
        if (collection._cache) // We cache as an entries array, so we can just return the cache!
        return new ArraySeq(collection._cache);
        var entriesSequence = collection.toSeq().map(entryMapper).toIndexedSeq();
        entriesSequence.fromEntrySeq = function() {
            return collection.toSeq();
        };
        return entriesSequence;
    },
    filterNot: function filterNot(predicate, context) {
        return this.filter(not(predicate), context);
    },
    findEntry: function findEntry(predicate, context, notSetValue) {
        var found = notSetValue;
        this.__iterate(function(v, k, c) {
            if (predicate.call(context, v, k, c)) {
                found = [
                    k,
                    v
                ];
                return false;
            }
        });
        return found;
    },
    findKey: function findKey(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry && entry[0];
    },
    findLast: function findLast(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().find(predicate, context, notSetValue);
    },
    findLastEntry: function findLastEntry(predicate, context, notSetValue) {
        return this.toKeyedSeq().reverse().findEntry(predicate, context, notSetValue);
    },
    findLastKey: function findLastKey(predicate, context) {
        return this.toKeyedSeq().reverse().findKey(predicate, context);
    },
    first: function first() {
        return this.find(returnTrue);
    },
    flatMap: function flatMap(mapper, context) {
        return reify(this, flatMapFactory(this, mapper, context));
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, true));
    },
    fromEntrySeq: function fromEntrySeq() {
        return new FromEntriesSequence(this);
    },
    get: function get(searchKey, notSetValue) {
        return this.find(function(_, key) {
            return is(key, searchKey);
        }, undefined, notSetValue);
    },
    getIn: getIn$$1,
    groupBy: function groupBy(grouper, context) {
        return groupByFactory(this, grouper, context);
    },
    has: function has(searchKey) {
        return this.get(searchKey, NOT_SET) !== NOT_SET;
    },
    hasIn: hasIn$$1,
    isSubset: function isSubset(iter) {
        iter = typeof iter.includes === 'function' ? iter : Collection(iter);
        return this.every(function(value) {
            return iter.includes(value);
        });
    },
    isSuperset: function isSuperset(iter) {
        iter = typeof iter.isSubset === 'function' ? iter : Collection(iter);
        return iter.isSubset(this);
    },
    keyOf: function keyOf(searchValue) {
        return this.findKey(function(value) {
            return is(value, searchValue);
        });
    },
    keySeq: function keySeq() {
        return this.toSeq().map(keyMapper).toIndexedSeq();
    },
    last: function last() {
        return this.toSeq().reverse().first();
    },
    lastKeyOf: function lastKeyOf(searchValue) {
        return this.toKeyedSeq().reverse().keyOf(searchValue);
    },
    max: function max(comparator) {
        return maxFactory(this, comparator);
    },
    maxBy: function maxBy(mapper, comparator) {
        return maxFactory(this, comparator, mapper);
    },
    min: function min(comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator);
    },
    minBy: function minBy(mapper, comparator) {
        return maxFactory(this, comparator ? neg(comparator) : defaultNegComparator, mapper);
    },
    rest: function rest() {
        return this.slice(1);
    },
    skip: function skip(amount) {
        return amount === 0 ? this : this.slice(Math.max(0, amount));
    },
    skipLast: function skipLast(amount) {
        return amount === 0 ? this : this.slice(0, -Math.max(0, amount));
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, true));
    },
    skipUntil: function skipUntil(predicate, context) {
        return this.skipWhile(not(predicate), context);
    },
    sortBy: function sortBy(mapper, comparator) {
        return reify(this, sortFactory(this, comparator, mapper));
    },
    take: function take(amount) {
        return this.slice(0, Math.max(0, amount));
    },
    takeLast: function takeLast(amount) {
        return this.slice(-Math.max(0, amount));
    },
    takeWhile: function takeWhile(predicate, context) {
        return reify(this, takeWhileFactory(this, predicate, context));
    },
    takeUntil: function takeUntil(predicate, context) {
        return this.takeWhile(not(predicate), context);
    },
    update: function update(fn) {
        return fn(this);
    },
    valueSeq: function valueSeq() {
        return this.toIndexedSeq();
    },
    // ### Hashable Object
    hashCode: function hashCode() {
        return this.__hash || (this.__hash = hashCollection(this));
    }
});
var CollectionPrototype = Collection.prototype;
CollectionPrototype[IS_ITERABLE_SENTINEL] = true;
CollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.values;
CollectionPrototype.toJSON = CollectionPrototype.toArray;
CollectionPrototype.__toStringMapper = quoteString;
CollectionPrototype.inspect = CollectionPrototype.toSource = function() {
    return this.toString();
};
CollectionPrototype.chain = CollectionPrototype.flatMap;
CollectionPrototype.contains = CollectionPrototype.includes;
mixin(KeyedCollection, {
    // ### More sequential methods
    flip: function flip() {
        return reify(this, flipFactory(this));
    },
    mapEntries: function mapEntries(mapper, context) {
        var this$1 = this;
        var iterations = 0;
        return reify(this, this.toSeq().map(function(v, k) {
            return mapper.call(context, [
                k,
                v
            ], iterations++, this$1);
        }).fromEntrySeq());
    },
    mapKeys: function mapKeys(mapper, context) {
        var this$1 = this;
        return reify(this, this.toSeq().flip().map(function(k, v) {
            return mapper.call(context, k, v, this$1);
        }).flip());
    }
});
var KeyedCollectionPrototype = KeyedCollection.prototype;
KeyedCollectionPrototype[IS_KEYED_SENTINEL] = true;
KeyedCollectionPrototype[ITERATOR_SYMBOL] = CollectionPrototype.entries;
KeyedCollectionPrototype.toJSON = toObject;
KeyedCollectionPrototype.__toStringMapper = function(v, k) {
    return quoteString(k) + ': ' + quoteString(v);
};
mixin(IndexedCollection, {
    // ### Conversion to other types
    toKeyedSeq: function toKeyedSeq() {
        return new ToKeyedSequence(this, false);
    },
    // ### ES6 Collection methods (ES6 Array and Map)
    filter: function filter(predicate, context) {
        return reify(this, filterFactory(this, predicate, context, false));
    },
    findIndex: function findIndex(predicate, context) {
        var entry = this.findEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    indexOf: function indexOf(searchValue) {
        var key = this.keyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    lastIndexOf: function lastIndexOf(searchValue) {
        var key = this.lastKeyOf(searchValue);
        return key === undefined ? -1 : key;
    },
    reverse: function reverse() {
        return reify(this, reverseFactory(this, false));
    },
    slice: function slice(begin, end) {
        return reify(this, sliceFactory(this, begin, end, false));
    },
    splice: function splice(index, removeNum /*, ...values*/ ) {
        var numArgs = arguments.length;
        removeNum = Math.max(removeNum || 0, 0);
        if (numArgs === 0 || numArgs === 2 && !removeNum) return this;
        // If index is negative, it should resolve relative to the size of the
        // collection. However size may be expensive to compute if not cached, so
        // only call count() if the number is in fact negative.
        index = resolveBegin(index, index < 0 ? this.count() : this.size);
        var spliced = this.slice(0, index);
        return reify(this, numArgs === 1 ? spliced : spliced.concat(arrCopy(arguments, 2), this.slice(index + removeNum)));
    },
    // ### More collection methods
    findLastIndex: function findLastIndex(predicate, context) {
        var entry = this.findLastEntry(predicate, context);
        return entry ? entry[0] : -1;
    },
    first: function first() {
        return this.get(0);
    },
    flatten: function flatten(depth) {
        return reify(this, flattenFactory(this, depth, false));
    },
    get: function get(index, notSetValue) {
        index = wrapIndex(this, index);
        return index < 0 || this.size === Infinity || this.size !== undefined && index > this.size ? notSetValue : this.find(function(_, key) {
            return key === index;
        }, undefined, notSetValue);
    },
    has: function has(index) {
        index = wrapIndex(this, index);
        return index >= 0 && (this.size !== undefined ? this.size === Infinity || index < this.size : this.indexOf(index) !== -1);
    },
    interpose: function interpose(separator) {
        return reify(this, interposeFactory(this, separator));
    },
    interleave: function interleave() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        var zipped = zipWithFactory(this.toSeq(), IndexedSeq.of, collections);
        var interleaved = zipped.flatten(true);
        if (zipped.size) interleaved.size = zipped.size * collections.length;
        return reify(this, interleaved);
    },
    keySeq: function keySeq() {
        return Range(0, this.size);
    },
    last: function last() {
        return this.get(-1);
    },
    skipWhile: function skipWhile(predicate, context) {
        return reify(this, skipWhileFactory(this, predicate, context, false));
    },
    zip: function zip() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections));
    },
    zipAll: function zipAll() {
        var collections = [
            this
        ].concat(arrCopy(arguments));
        return reify(this, zipWithFactory(this, defaultZipper, collections, true));
    },
    zipWith: function zipWith(zipper /*, ...collections */ ) {
        var collections = arrCopy(arguments);
        collections[0] = this;
        return reify(this, zipWithFactory(this, zipper, collections));
    }
});
var IndexedCollectionPrototype = IndexedCollection.prototype;
IndexedCollectionPrototype[IS_INDEXED_SENTINEL] = true;
IndexedCollectionPrototype[IS_ORDERED_SENTINEL] = true;
mixin(SetCollection, {
    // ### ES6 Collection methods (ES6 Array and Map)
    get: function get(value, notSetValue) {
        return this.has(value) ? value : notSetValue;
    },
    includes: function includes(value) {
        return this.has(value);
    },
    // ### More sequential methods
    keySeq: function keySeq() {
        return this.valueSeq();
    }
});
SetCollection.prototype.has = CollectionPrototype.includes;
SetCollection.prototype.contains = SetCollection.prototype.includes;
// Mixin subclasses
mixin(KeyedSeq, KeyedCollection.prototype);
mixin(IndexedSeq, IndexedCollection.prototype);
mixin(SetSeq, SetCollection.prototype);
// #pragma Helper functions
function reduce(collection, reducer, reduction, context, useFirst, reverse) {
    assertNotInfinite(collection.size);
    collection.__iterate(function(v, k, c) {
        if (useFirst) {
            useFirst = false;
            reduction = v;
        } else reduction = reducer.call(context, reduction, v, k, c);
    }, reverse);
    return reduction;
}
function keyMapper(v, k) {
    return k;
}
function entryMapper(v, k) {
    return [
        k,
        v
    ];
}
function not(predicate) {
    return function() {
        return !predicate.apply(this, arguments);
    };
}
function neg(predicate) {
    return function() {
        return -predicate.apply(this, arguments);
    };
}
function defaultZipper() {
    return arrCopy(arguments);
}
function defaultNegComparator(a, b) {
    return a < b ? 1 : a > b ? -1 : 0;
}
function hashCollection(collection) {
    if (collection.size === Infinity) return 0;
    var ordered = isOrdered(collection);
    var keyed = isKeyed(collection);
    var h = ordered ? 1 : 0;
    var size = collection.__iterate(keyed ? ordered ? function(v, k) {
        h = 31 * h + hashMerge(hash(v), hash(k)) | 0;
    } : function(v, k) {
        h = h + hashMerge(hash(v), hash(k)) | 0;
    } : ordered ? function(v) {
        h = 31 * h + hash(v) | 0;
    } : function(v) {
        h = h + hash(v) | 0;
    });
    return murmurHashOfSize(size, h);
}
function murmurHashOfSize(size, h) {
    h = imul(h, 0xcc9e2d51);
    h = imul(h << 15 | h >>> -15, 0x1b873593);
    h = imul(h << 13 | h >>> -13, 5);
    h = (h + 0xe6546b64 | 0) ^ size;
    h = imul(h ^ h >>> 16, 0x85ebca6b);
    h = imul(h ^ h >>> 13, 0xc2b2ae35);
    h = smi(h ^ h >>> 16);
    return h;
}
function hashMerge(a, b) {
    return a ^ b + 0x9e3779b9 + (a << 6) + (a >> 2) | 0; // int
}
var OrderedSet = function(Set$$1) {
    function OrderedSet(value) {
        return value === null || value === undefined ? emptyOrderedSet() : isOrderedSet(value) ? value : emptyOrderedSet().withMutations(function(set) {
            var iter = SetCollection(value);
            assertNotInfinite(iter.size);
            iter.forEach(function(v) {
                return set.add(v);
            });
        });
    }
    if (Set$$1) OrderedSet.__proto__ = Set$$1;
    OrderedSet.prototype = Object.create(Set$$1 && Set$$1.prototype);
    OrderedSet.prototype.constructor = OrderedSet;
    OrderedSet.of = function of() {
        return this(arguments);
    };
    OrderedSet.fromKeys = function fromKeys(value) {
        return this(KeyedCollection(value).keySeq());
    };
    OrderedSet.prototype.toString = function toString() {
        return this.__toString('OrderedSet {', '}');
    };
    return OrderedSet;
}(Set);
function isOrderedSet(maybeOrderedSet) {
    return isSet(maybeOrderedSet) && isOrdered(maybeOrderedSet);
}
OrderedSet.isOrderedSet = isOrderedSet;
var OrderedSetPrototype = OrderedSet.prototype;
OrderedSetPrototype[IS_ORDERED_SENTINEL] = true;
OrderedSetPrototype.zip = IndexedCollectionPrototype.zip;
OrderedSetPrototype.zipWith = IndexedCollectionPrototype.zipWith;
OrderedSetPrototype.__empty = emptyOrderedSet;
OrderedSetPrototype.__make = makeOrderedSet;
function makeOrderedSet(map, ownerID) {
    var set = Object.create(OrderedSetPrototype);
    set.size = map ? map.size : 0;
    set._map = map;
    set.__ownerID = ownerID;
    return set;
}
var EMPTY_ORDERED_SET;
function emptyOrderedSet() {
    return EMPTY_ORDERED_SET || (EMPTY_ORDERED_SET = makeOrderedSet(emptyOrderedMap()));
}
var Record = function Record(defaultValues, name) {
    var hasInitialized;
    var RecordType = function Record(values) {
        var this$1 = this;
        if (values instanceof RecordType) return values;
        if (!(this instanceof RecordType)) return new RecordType(values);
        if (!hasInitialized) {
            hasInitialized = true;
            var keys = Object.keys(defaultValues);
            var indices = RecordTypePrototype._indices = {};
            RecordTypePrototype._name = name;
            RecordTypePrototype._keys = keys;
            RecordTypePrototype._defaultValues = defaultValues;
            for(var i = 0; i < keys.length; i++){
                var propName = keys[i];
                indices[propName] = i;
                if (RecordTypePrototype[propName]) /* eslint-disable no-console */ typeof console === 'object' && console.warn && console.warn('Cannot define ' + recordName(this$1) + ' with property "' + propName + '" since that property name is part of the Record API.');
                else setProp(RecordTypePrototype, propName);
            }
        }
        this.__ownerID = undefined;
        this._values = List().withMutations(function(l) {
            l.setSize(this$1._keys.length);
            KeyedCollection(values).forEach(function(v, k) {
                l.set(this$1._indices[k], v === this$1._defaultValues[k] ? undefined : v);
            });
        });
    };
    var RecordTypePrototype = RecordType.prototype = Object.create(RecordPrototype);
    RecordTypePrototype.constructor = RecordType;
    return RecordType;
};
Record.prototype.toString = function toString() {
    var this$1 = this;
    var str = recordName(this) + ' { ';
    var keys = this._keys;
    var k;
    for(var i = 0, l = keys.length; i !== l; i++){
        k = keys[i];
        str += (i ? ', ' : '') + k + ': ' + quoteString(this$1.get(k));
    }
    return str + ' }';
};
Record.prototype.equals = function equals(other) {
    return this === other || other && this._keys === other._keys && recordSeq(this).equals(recordSeq(other));
};
Record.prototype.hashCode = function hashCode() {
    return recordSeq(this).hashCode();
};
// @pragma Access
Record.prototype.has = function has(k) {
    return this._indices.hasOwnProperty(k);
};
Record.prototype.get = function get(k, notSetValue) {
    if (!this.has(k)) return notSetValue;
    var index = this._indices[k];
    var value = this._values.get(index);
    return value === undefined ? this._defaultValues[k] : value;
};
// @pragma Modification
Record.prototype.set = function set(k, v) {
    if (this.has(k)) {
        var newValues = this._values.set(this._indices[k], v === this._defaultValues[k] ? undefined : v);
        if (newValues !== this._values && !this.__ownerID) return makeRecord(this, newValues);
    }
    return this;
};
Record.prototype.remove = function remove(k) {
    return this.set(k);
};
Record.prototype.clear = function clear() {
    var newValues = this._values.clear().setSize(this._keys.length);
    return this.__ownerID ? this : makeRecord(this, newValues);
};
Record.prototype.wasAltered = function wasAltered() {
    return this._values.wasAltered();
};
Record.prototype.toSeq = function toSeq() {
    return recordSeq(this);
};
Record.prototype.toJS = function toJS$1() {
    return toJS(this);
};
Record.prototype.entries = function entries() {
    return this.__iterator(ITERATE_ENTRIES);
};
Record.prototype.__iterator = function __iterator(type, reverse) {
    return recordSeq(this).__iterator(type, reverse);
};
Record.prototype.__iterate = function __iterate(fn, reverse) {
    return recordSeq(this).__iterate(fn, reverse);
};
Record.prototype.__ensureOwner = function __ensureOwner(ownerID) {
    if (ownerID === this.__ownerID) return this;
    var newValues = this._values.__ensureOwner(ownerID);
    if (!ownerID) {
        this.__ownerID = ownerID;
        this._values = newValues;
        return this;
    }
    return makeRecord(this, newValues, ownerID);
};
Record.isRecord = isRecord;
Record.getDescriptiveName = recordName;
var RecordPrototype = Record.prototype;
RecordPrototype[IS_RECORD_SENTINEL] = true;
RecordPrototype[DELETE] = RecordPrototype.remove;
RecordPrototype.deleteIn = RecordPrototype.removeIn = deleteIn;
RecordPrototype.getIn = getIn$$1;
RecordPrototype.hasIn = CollectionPrototype.hasIn;
RecordPrototype.merge = merge;
RecordPrototype.mergeWith = mergeWith;
RecordPrototype.mergeIn = mergeIn;
RecordPrototype.mergeDeep = mergeDeep;
RecordPrototype.mergeDeepWith = mergeDeepWith;
RecordPrototype.mergeDeepIn = mergeDeepIn;
RecordPrototype.setIn = setIn$$1;
RecordPrototype.update = update$$1;
RecordPrototype.updateIn = updateIn$1;
RecordPrototype.withMutations = withMutations;
RecordPrototype.asMutable = asMutable;
RecordPrototype.asImmutable = asImmutable;
RecordPrototype[ITERATOR_SYMBOL] = RecordPrototype.entries;
RecordPrototype.toJSON = RecordPrototype.toObject = CollectionPrototype.toObject;
RecordPrototype.inspect = RecordPrototype.toSource = function() {
    return this.toString();
};
function makeRecord(likeRecord, values, ownerID) {
    var record = Object.create(Object.getPrototypeOf(likeRecord));
    record._values = values;
    record.__ownerID = ownerID;
    return record;
}
function recordName(record) {
    return record._name || record.constructor.name || 'Record';
}
function recordSeq(record) {
    return keyedSeqFromValue(record._keys.map(function(k) {
        return [
            k,
            record.get(k)
        ];
    }));
}
function setProp(prototype, name) {
    try {
        Object.defineProperty(prototype, name, {
            get: function() {
                return this.get(name);
            },
            set: function(value) {
                invariant(this.__ownerID, 'Cannot set on an immutable record.');
                this.set(name, value);
            }
        });
    } catch (error) {
    // Object.defineProperty failed. Probably IE8.
    }
}
/**
 * Returns a lazy Seq of `value` repeated `times` times. When `times` is
 * undefined, returns an infinite sequence of `value`.
 */ var Repeat = function(IndexedSeq$$1) {
    function Repeat(value, times) {
        if (!(this instanceof Repeat)) return new Repeat(value, times);
        this._value = value;
        this.size = times === undefined ? Infinity : Math.max(0, times);
        if (this.size === 0) {
            if (EMPTY_REPEAT) return EMPTY_REPEAT;
            EMPTY_REPEAT = this;
        }
    }
    if (IndexedSeq$$1) Repeat.__proto__ = IndexedSeq$$1;
    Repeat.prototype = Object.create(IndexedSeq$$1 && IndexedSeq$$1.prototype);
    Repeat.prototype.constructor = Repeat;
    Repeat.prototype.toString = function toString() {
        if (this.size === 0) return 'Repeat []';
        return 'Repeat [ ' + this._value + ' ' + this.size + ' times ]';
    };
    Repeat.prototype.get = function get(index, notSetValue) {
        return this.has(index) ? this._value : notSetValue;
    };
    Repeat.prototype.includes = function includes(searchValue) {
        return is(this._value, searchValue);
    };
    Repeat.prototype.slice = function slice(begin, end) {
        var size = this.size;
        return wholeSlice(begin, end, size) ? this : new Repeat(this._value, resolveEnd(end, size) - resolveBegin(begin, size));
    };
    Repeat.prototype.reverse = function reverse() {
        return this;
    };
    Repeat.prototype.indexOf = function indexOf(searchValue) {
        if (is(this._value, searchValue)) return 0;
        return -1;
    };
    Repeat.prototype.lastIndexOf = function lastIndexOf(searchValue) {
        if (is(this._value, searchValue)) return this.size;
        return -1;
    };
    Repeat.prototype.__iterate = function __iterate(fn, reverse) {
        var this$1 = this;
        var size = this.size;
        var i = 0;
        while(i !== size){
            if (fn(this$1._value, reverse ? size - ++i : i++, this$1) === false) break;
        }
        return i;
    };
    Repeat.prototype.__iterator = function __iterator(type, reverse) {
        var this$1 = this;
        var size = this.size;
        var i = 0;
        return new Iterator(function() {
            return i === size ? iteratorDone() : iteratorValue(type, reverse ? size - ++i : i++, this$1._value);
        });
    };
    Repeat.prototype.equals = function equals(other) {
        return other instanceof Repeat ? is(this._value, other._value) : deepEqual(other);
    };
    return Repeat;
}(IndexedSeq);
var EMPTY_REPEAT;
function fromJS(value, converter) {
    return fromJSWith([], converter || defaultConverter, value, '', converter && converter.length > 2 ? [] : undefined, {
        '': value
    });
}
function fromJSWith(stack, converter, value, key, keyPath, parentValue) {
    var toSeq = Array.isArray(value) ? IndexedSeq : isPlainObj(value) ? KeyedSeq : null;
    if (toSeq) {
        if (~stack.indexOf(value)) throw new TypeError('Cannot convert circular structure to Immutable');
        stack.push(value);
        keyPath && key !== '' && keyPath.push(key);
        var converted = converter.call(parentValue, key, toSeq(value).map(function(v, k) {
            return fromJSWith(stack, converter, v, k, keyPath, value);
        }), keyPath && keyPath.slice());
        stack.pop();
        keyPath && keyPath.pop();
        return converted;
    }
    return value;
}
function defaultConverter(k, v) {
    return isKeyed(v) ? v.toMap() : v.toList();
}
var version = "4.0.0-rc.9";
// Functional read/write API
var Immutable = {
    version: version,
    Collection: Collection,
    // Note: Iterable is deprecated
    Iterable: Collection,
    Seq: Seq,
    Map: Map,
    OrderedMap: OrderedMap,
    List: List,
    Stack: Stack,
    Set: Set,
    OrderedSet: OrderedSet,
    Record: Record,
    Range: Range,
    Repeat: Repeat,
    is: is,
    fromJS: fromJS,
    hash: hash,
    isImmutable: isImmutable,
    isCollection: isCollection,
    isKeyed: isKeyed,
    isIndexed: isIndexed,
    isAssociative: isAssociative,
    isOrdered: isOrdered,
    isValueObject: isValueObject,
    get: get,
    getIn: getIn$1,
    has: has,
    hasIn: hasIn$1,
    merge: merge$1,
    mergeDeep: mergeDeep$1,
    mergeWith: mergeWith$1,
    mergeDeepWith: mergeDeepWith$1,
    remove: remove,
    removeIn: removeIn,
    set: set,
    setIn: setIn$1,
    update: update$1,
    updateIn: updateIn
};
// Note: Iterable is deprecated
var Iterable = Collection;
var $bb6be968fd3babc9$export$2e2bcd8739ae039 = Immutable;

});

parcelRegister("jJs3W", function(module, exports) {
$parcel$export(module.exports, "connect", () => (parcelRequire("94zHK")).default);
$parcel$export(module.exports, "Provider", () => (parcelRequire("b02ud")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("6N2vY")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("cU4FA")).useSelector);
parcelRequire("lPIk7");
parcelRequire("035eW");
var $lEfVV = parcelRequire("lEfVV");

var $4Ut1d = parcelRequire("4Ut1d");
// with standard React renderers (ReactDOM, React Native)
(0, $4Ut1d.setBatch)((0, $lEfVV.unstable_batchedUpdates));

});
parcelRegister("lPIk7", function(module, exports) {

$parcel$export(module.exports, "Provider", () => (parcelRequire("b02ud")).default);
$parcel$export(module.exports, "connect", () => (parcelRequire("94zHK")).default);
$parcel$export(module.exports, "useDispatch", () => (parcelRequire("6N2vY")).useDispatch);
$parcel$export(module.exports, "useSelector", () => (parcelRequire("cU4FA")).useSelector);

var $b02ud = parcelRequire("b02ud");

var $lwCWn = parcelRequire("lwCWn");

var $iqB4h = parcelRequire("iqB4h");

var $94zHK = parcelRequire("94zHK");

var $6N2vY = parcelRequire("6N2vY");

var $cU4FA = parcelRequire("cU4FA");

var $2bGhE = parcelRequire("2bGhE");

var $9UMSs = parcelRequire("9UMSs");

});
parcelRegister("b02ud", function(module, exports) {

$parcel$export(module.exports, "default", () => $80219f881731fd50$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");


var $iqB4h = parcelRequire("iqB4h");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");
function $80219f881731fd50$var$Provider(_ref) {
    var store = _ref.store, context = _ref.context, children = _ref.children;
    var contextValue = (0, $eUqFw.useMemo)(function() {
        var subscription = (0, $eOZYb.createSubscription)(store);
        return {
            store: store,
            subscription: subscription
        };
    }, [
        store
    ]);
    var previousState = (0, $eUqFw.useMemo)(function() {
        return store.getState();
    }, [
        store
    ]);
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        var subscription = contextValue.subscription;
        subscription.onStateChange = subscription.notifyNestedSubs;
        subscription.trySubscribe();
        if (previousState !== store.getState()) subscription.notifyNestedSubs();
        return function() {
            subscription.tryUnsubscribe();
            subscription.onStateChange = null;
        };
    }, [
        contextValue,
        previousState
    ]);
    var Context = context || (0, $iqB4h.ReactReduxContext);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Context.Provider, {
        value: contextValue
    }, children);
}
var $80219f881731fd50$export$2e2bcd8739ae039 = $80219f881731fd50$var$Provider;

});
parcelRegister("iqB4h", function(module, exports) {

$parcel$export(module.exports, "ReactReduxContext", () => $d6a768a4a73470b3$export$cc80c08dc91f1c00);

var $eUqFw = parcelRequire("eUqFw");
var $d6a768a4a73470b3$export$cc80c08dc91f1c00 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
var $d6a768a4a73470b3$export$2e2bcd8739ae039 = $d6a768a4a73470b3$export$cc80c08dc91f1c00;

});

parcelRegister("eOZYb", function(module, exports) {

$parcel$export(module.exports, "createSubscription", () => $aca5ce1240833bb9$export$d567d2b9af322f8f);

var $4Ut1d = parcelRequire("4Ut1d");
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
function $aca5ce1240833bb9$var$createListenerCollection() {
    var batch = (0, $4Ut1d.getBatch)();
    var first = null;
    var last = null;
    return {
        clear: function clear() {
            first = null;
            last = null;
        },
        notify: function notify() {
            batch(function() {
                var listener = first;
                while(listener){
                    listener.callback();
                    listener = listener.next;
                }
            });
        },
        get: function get() {
            var listeners = [];
            var listener = first;
            while(listener){
                listeners.push(listener);
                listener = listener.next;
            }
            return listeners;
        },
        subscribe: function subscribe(callback) {
            var isSubscribed = true;
            var listener = last = {
                callback: callback,
                next: null,
                prev: last
            };
            if (listener.prev) listener.prev.next = listener;
            else first = listener;
            return function unsubscribe() {
                if (!isSubscribed || first === null) return;
                isSubscribed = false;
                if (listener.next) listener.next.prev = listener.prev;
                else last = listener.prev;
                if (listener.prev) listener.prev.next = listener.next;
                else first = listener.next;
            };
        }
    };
}
var $aca5ce1240833bb9$var$nullListeners = {
    notify: function notify() {},
    get: function get() {
        return [];
    }
};
function $aca5ce1240833bb9$export$d567d2b9af322f8f(store, parentSub) {
    var unsubscribe;
    var listeners = $aca5ce1240833bb9$var$nullListeners;
    function addNestedSub(listener) {
        trySubscribe();
        return listeners.subscribe(listener);
    }
    function notifyNestedSubs() {
        listeners.notify();
    }
    function handleChangeWrapper() {
        if (subscription.onStateChange) subscription.onStateChange();
    }
    function isSubscribed() {
        return Boolean(unsubscribe);
    }
    function trySubscribe() {
        if (!unsubscribe) {
            unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
            listeners = $aca5ce1240833bb9$var$createListenerCollection();
        }
    }
    function tryUnsubscribe() {
        if (unsubscribe) {
            unsubscribe();
            unsubscribe = undefined;
            listeners.clear();
            listeners = $aca5ce1240833bb9$var$nullListeners;
        }
    }
    var subscription = {
        addNestedSub: addNestedSub,
        notifyNestedSubs: notifyNestedSubs,
        handleChangeWrapper: handleChangeWrapper,
        isSubscribed: isSubscribed,
        trySubscribe: trySubscribe,
        tryUnsubscribe: tryUnsubscribe,
        getListeners: function getListeners() {
            return listeners;
        }
    };
    return subscription;
}

});
parcelRegister("4Ut1d", function(module, exports) {

$parcel$export(module.exports, "setBatch", () => $3932e6df69670101$export$4b9874722d0da7bc);
$parcel$export(module.exports, "getBatch", () => $3932e6df69670101$export$fc47d4c0ba3bd2c6);
// Default to a dummy "batch" implementation that just runs the callback
function $3932e6df69670101$var$defaultNoopBatch(callback) {
    callback();
}
var $3932e6df69670101$var$batch = $3932e6df69670101$var$defaultNoopBatch; // Allow injecting another batching function later
var $3932e6df69670101$export$4b9874722d0da7bc = function setBatch(newBatch) {
    return $3932e6df69670101$var$batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings
var $3932e6df69670101$export$fc47d4c0ba3bd2c6 = function getBatch() {
    return $3932e6df69670101$var$batch;
};

});


parcelRegister("8RW1t", function(module, exports) {

$parcel$export(module.exports, "useIsomorphicLayoutEffect", () => $67504818408d46d4$export$700979bc83e7db82);

var $eUqFw = parcelRequire("eUqFw");
var $67504818408d46d4$export$700979bc83e7db82 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $eUqFw.useLayoutEffect) : (0, $eUqFw.useEffect);

});


parcelRegister("lwCWn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fabacaeccb986465$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $lxchL = parcelRequire("lxchL");

var $eUqFw = parcelRequire("eUqFw");

var $8T8or = parcelRequire("8T8or");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");

var $iqB4h = parcelRequire("iqB4h");
var $fabacaeccb986465$var$_excluded = [
    "getDisplayName",
    "methodName",
    "renderCountProp",
    "shouldHandleStateChanges",
    "storeKey",
    "withRef",
    "forwardRef",
    "context"
], $fabacaeccb986465$var$_excluded2 = [
    "reactReduxForwardedRef"
];
var $fabacaeccb986465$var$EMPTY_ARRAY = [];
var $fabacaeccb986465$var$NO_SUBSCRIPTION_ARRAY = [
    null,
    null
];
var $fabacaeccb986465$var$stringifyComponent = function stringifyComponent(Comp) {
    try {
        return JSON.stringify(Comp);
    } catch (err) {
        return String(Comp);
    }
};
function $fabacaeccb986465$var$storeStateUpdatesReducer(state, action) {
    var updateCount = state[1];
    return [
        action.payload,
        updateCount + 1
    ];
}
function $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        return effectFunc.apply(void 0, effectArgs);
    }, dependencies);
}
function $fabacaeccb986465$var$captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
    // We want to capture the wrapper props and child props we used for later comparisons
    lastWrapperProps.current = wrapperProps;
    lastChildProps.current = actualChildProps;
    renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update
    if (childPropsFromStoreUpdate.current) {
        childPropsFromStoreUpdate.current = null;
        notifyNestedSubs();
    }
}
function $fabacaeccb986465$var$subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
    // If we're not subscribed to the store, nothing to do here
    if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts
    var didUnsubscribe = false;
    var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component
    var checkForUpdates = function checkForUpdates() {
        if (didUnsubscribe) // Don't run stale listeners.
        // Redux doesn't guarantee unsubscriptions happen until next dispatch.
        return;
        var latestStoreState = store.getState();
        var newChildProps, error;
        try {
            // Actually run the selector with the most recent store state and wrapper props
            // to determine what the child props should be
            newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
        } catch (e) {
            error = e;
            lastThrownError = e;
        }
        if (!error) lastThrownError = null;
         // If the child props haven't changed, nothing to do here - cascade the subscription update
        if (newChildProps === lastChildProps.current) {
            if (!renderIsScheduled.current) notifyNestedSubs();
        } else {
            // Save references to the new child props.  Note that we track the "child props from store update"
            // as a ref instead of a useState/useReducer because we need a way to determine if that value has
            // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
            // forcing another re-render, which we don't want.
            lastChildProps.current = newChildProps;
            childPropsFromStoreUpdate.current = newChildProps;
            renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render
            forceComponentUpdateDispatch({
                type: 'STORE_UPDATED',
                payload: {
                    error: error
                }
            });
        }
    }; // Actually subscribe to the nearest connected ancestor (or store)
    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe(); // Pull data from the store after first render in case the store has
    // changed since we began.
    checkForUpdates();
    var unsubscribeWrapper = function unsubscribeWrapper() {
        didUnsubscribe = true;
        subscription.tryUnsubscribe();
        subscription.onStateChange = null;
        if (lastThrownError) // It's possible that we caught an error due to a bad mapState function, but the
        // parent re-rendered without this component and we're about to unmount.
        // This shouldn't happen as long as we do top-down subscriptions correctly, but
        // if we ever do those wrong, this throw will surface the error in our tests.
        // In that case, throw the error from here so it doesn't get lost.
        throw lastThrownError;
    };
    return unsubscribeWrapper;
}
var $fabacaeccb986465$var$initStateUpdates = function initStateUpdates() {
    return [
        null,
        0
    ];
};
function $fabacaeccb986465$export$2e2bcd8739ae039(/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/ selectorFactory, _ref) {
    if (_ref === void 0) _ref = {};
    var _ref2 = _ref, _ref2$getDisplayName = _ref2.getDisplayName, getDisplayName = _ref2$getDisplayName === void 0 ? function(name) {
        return "ConnectAdvanced(" + name + ")";
    } : _ref2$getDisplayName, _ref2$methodName = _ref2.methodName, methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName, _ref2$renderCountProp = _ref2.renderCountProp, renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp, _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges, shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta, _ref2$storeKey = _ref2.storeKey, storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey, _ref2$withRef = _ref2.withRef, withRef = _ref2$withRef === void 0 ? false : _ref2$withRef, _ref2$forwardRef = _ref2.forwardRef, forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef, _ref2$context = _ref2.context, context = _ref2$context === void 0 ? (0, $iqB4h.ReactReduxContext) : _ref2$context, connectOptions = (0, $6XgOP.default)(_ref2, $fabacaeccb986465$var$_excluded);
    var customStoreWarningMessage;
    var Context = context;
    return function wrapWithConnect(WrappedComponent) {
        var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
        var displayName = getDisplayName(wrappedComponentName);
        var selectorFactoryOptions = (0, $kU09D.default)({}, connectOptions, {
            getDisplayName: getDisplayName,
            methodName: methodName,
            renderCountProp: renderCountProp,
            shouldHandleStateChanges: shouldHandleStateChanges,
            storeKey: storeKey,
            displayName: displayName,
            wrappedComponentName: wrappedComponentName,
            WrappedComponent: WrappedComponent
        });
        var pure = connectOptions.pure;
        function createChildSelector(store) {
            return selectorFactory(store.dispatch, selectorFactoryOptions);
        } // If we aren't running in "pure" mode, we don't want to memoize values.
        // To avoid conditionally calling hooks, we fall back to a tiny wrapper
        // that just executes the given callback immediately.
        var usePureOnlyMemo = pure ? (0, $eUqFw.useMemo) : function(callback) {
            return callback();
        };
        function ConnectFunction(props) {
            var _useMemo = (0, $eUqFw.useMemo)(function() {
                // Distinguish between actual "data" props that were passed to the wrapper component,
                // and values needed to control behavior (forwarded refs, alternate context instances).
                // To maintain the wrapperProps object reference, memoize this destructuring.
                var reactReduxForwardedRef = props.reactReduxForwardedRef, wrapperProps = (0, $6XgOP.default)(props, $fabacaeccb986465$var$_excluded2);
                return [
                    props.context,
                    reactReduxForwardedRef,
                    wrapperProps
                ];
            }, [
                props
            ]), propsContext = _useMemo[0], reactReduxForwardedRef = _useMemo[1], wrapperProps = _useMemo[2];
            var ContextToUse = (0, $eUqFw.useMemo)(function() {
                // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
                // Memoize the check that determines which context instance we should use.
                return propsContext && propsContext.Consumer && (0, $8T8or.isContextConsumer)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(propsContext.Consumer, null)) ? propsContext : Context;
            }, [
                propsContext,
                Context
            ]); // Retrieve the store and ancestor subscription via context, if available
            var contextValue = (0, $eUqFw.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
            // We'll check to see if it _looks_ like a Redux store first.
            // This allows us to pass through a `store` prop that is just a plain value.
            var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
            var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);
            var store = didStoreComeFromProps ? props.store : contextValue.store;
            var childPropsSelector = (0, $eUqFw.useMemo)(function() {
                // The child props selector needs the store reference as an input.
                // Re-create this selector whenever the store changes.
                return createChildSelector(store);
            }, [
                store
            ]);
            var _useMemo2 = (0, $eUqFw.useMemo)(function() {
                if (!shouldHandleStateChanges) return $fabacaeccb986465$var$NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                // This Subscription's source should match where store came from: props vs. context. A component
                // connected to the store via props shouldn't use subscription from context, or vice versa.
                var subscription = (0, $eOZYb.createSubscription)(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
                // the middle of the notification loop, where `subscription` will then be null. This can
                // probably be avoided if Subscription's listeners logic is changed to not call listeners
                // that have been unsubscribed in the  middle of the notification loop.
                var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
                return [
                    subscription,
                    notifyNestedSubs
                ];
            }, [
                store,
                didStoreComeFromProps,
                contextValue
            ]), subscription = _useMemo2[0], notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
            // and memoize that value to avoid unnecessary context updates.
            var overriddenContextValue = (0, $eUqFw.useMemo)(function() {
                if (didStoreComeFromProps) // This component is directly subscribed to a store from props.
                // We don't want descendants reading from this store - pass down whatever
                // the existing context value is from the nearest connected ancestor.
                return contextValue;
                 // Otherwise, put this component's subscription instance into context, so that
                // connected descendants won't update until after this component is done
                return (0, $kU09D.default)({}, contextValue, {
                    subscription: subscription
                });
            }, [
                didStoreComeFromProps,
                contextValue,
                subscription
            ]); // We need to force this wrapper component to re-render whenever a Redux store update
            // causes a change to the calculated child component props (or we caught an error in mapState)
            var _useReducer = (0, $eUqFw.useReducer)($fabacaeccb986465$var$storeStateUpdatesReducer, $fabacaeccb986465$var$EMPTY_ARRAY, $fabacaeccb986465$var$initStateUpdates), _useReducer$ = _useReducer[0], previousStateUpdateResult = _useReducer$[0], forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards
            if (previousStateUpdateResult && previousStateUpdateResult.error) throw previousStateUpdateResult.error;
             // Set up refs to coordinate values between the subscription effect and the render logic
            var lastChildProps = (0, $eUqFw.useRef)();
            var lastWrapperProps = (0, $eUqFw.useRef)(wrapperProps);
            var childPropsFromStoreUpdate = (0, $eUqFw.useRef)();
            var renderIsScheduled = (0, $eUqFw.useRef)(false);
            var actualChildProps = usePureOnlyMemo(function() {
                // Tricky logic here:
                // - This render may have been triggered by a Redux store update that produced new child props
                // - However, we may have gotten new wrapper props after that
                // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
                // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
                // So, we'll use the child props from store update only if the wrapper props are the same as last time.
                if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) return childPropsFromStoreUpdate.current;
                 // TODO We're reading the store directly in render() here. Bad idea?
                // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
                // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
                // to determine what the child props should be.
                return childPropsSelector(store.getState(), wrapperProps);
            }, [
                store,
                previousStateUpdateResult,
                wrapperProps
            ]); // We need this to execute synchronously every time we re-render. However, React warns
            // about useLayoutEffect in SSR, so we try to detect environment and fall back to
            // just useEffect instead to avoid the warning, since neither will run anyway.
            $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs($fabacaeccb986465$var$captureWrapperProps, [
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                wrapperProps,
                actualChildProps,
                childPropsFromStoreUpdate,
                notifyNestedSubs
            ]); // Our re-subscribe logic only runs when the store/subscription setup changes
            $fabacaeccb986465$var$useIsomorphicLayoutEffectWithArgs($fabacaeccb986465$var$subscribeUpdates, [
                shouldHandleStateChanges,
                store,
                subscription,
                childPropsSelector,
                lastWrapperProps,
                lastChildProps,
                renderIsScheduled,
                childPropsFromStoreUpdate,
                notifyNestedSubs,
                forceComponentUpdateDispatch
            ], [
                store,
                subscription,
                childPropsSelector
            ]); // Now that all that's done, we can finally try to actually render the child component.
            // We memoize the elements for the rendered child component as an optimization.
            var renderedWrappedComponent = (0, $eUqFw.useMemo)(function() {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, (0, $kU09D.default)({}, actualChildProps, {
                    ref: reactReduxForwardedRef
                }));
            }, [
                reactReduxForwardedRef,
                WrappedComponent,
                actualChildProps
            ]); // If React sees the exact same element reference as last time, it bails out of re-rendering
            // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.
            var renderedChild = (0, $eUqFw.useMemo)(function() {
                if (shouldHandleStateChanges) // If this component is subscribed to store updates, we need to pass its own
                // subscription instance down to our descendants. That means rendering the same
                // Context instance, and putting a different value into the context.
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ContextToUse.Provider, {
                    value: overriddenContextValue
                }, renderedWrappedComponent);
                return renderedWrappedComponent;
            }, [
                ContextToUse,
                renderedWrappedComponent,
                overriddenContextValue
            ]);
            return renderedChild;
        } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.
        var Connect = pure ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(ConnectFunction) : ConnectFunction;
        Connect.WrappedComponent = WrappedComponent;
        Connect.displayName = ConnectFunction.displayName = displayName;
        if (forwardRef) {
            var forwarded = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function forwardConnectRef(props, ref) {
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Connect, (0, $kU09D.default)({}, props, {
                    reactReduxForwardedRef: ref
                }));
            });
            forwarded.displayName = displayName;
            forwarded.WrappedComponent = WrappedComponent;
            return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(forwarded, WrappedComponent);
        }
        return (0, (/*@__PURE__*/$parcel$interopDefault($lxchL)))(Connect, WrappedComponent);
    };
}

});
parcelRegister("8T8or", function(module, exports) {
'use strict';

module.exports = (parcelRequire("eU3cC"));

});
parcelRegister("eU3cC", function(module, exports) {

$parcel$export(module.exports, "ContextConsumer", () => $ad98c79b0cc564ad$export$a7c73072b1a182ae, (v) => $ad98c79b0cc564ad$export$a7c73072b1a182ae = v);
$parcel$export(module.exports, "ContextProvider", () => $ad98c79b0cc564ad$export$9f27bc3417b4524d, (v) => $ad98c79b0cc564ad$export$9f27bc3417b4524d = v);
$parcel$export(module.exports, "Element", () => $ad98c79b0cc564ad$export$db77ccec0bb4ccac, (v) => $ad98c79b0cc564ad$export$db77ccec0bb4ccac = v);
$parcel$export(module.exports, "ForwardRef", () => $ad98c79b0cc564ad$export$8392c0c9d3dcbd35, (v) => $ad98c79b0cc564ad$export$8392c0c9d3dcbd35 = v);
$parcel$export(module.exports, "Fragment", () => $ad98c79b0cc564ad$export$ffb0004e005737fa, (v) => $ad98c79b0cc564ad$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Lazy", () => $ad98c79b0cc564ad$export$b624eff549462981, (v) => $ad98c79b0cc564ad$export$b624eff549462981 = v);
$parcel$export(module.exports, "Memo", () => $ad98c79b0cc564ad$export$7897aa7841a5380c, (v) => $ad98c79b0cc564ad$export$7897aa7841a5380c = v);
$parcel$export(module.exports, "Portal", () => $ad98c79b0cc564ad$export$602eac185826482c, (v) => $ad98c79b0cc564ad$export$602eac185826482c = v);
$parcel$export(module.exports, "Profiler", () => $ad98c79b0cc564ad$export$e2c29f18771995cb, (v) => $ad98c79b0cc564ad$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "StrictMode", () => $ad98c79b0cc564ad$export$5f8d39834fd61797, (v) => $ad98c79b0cc564ad$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $ad98c79b0cc564ad$export$74bf444e3cd11ea5, (v) => $ad98c79b0cc564ad$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "isAsyncMode", () => $ad98c79b0cc564ad$export$92387174baf9b227, (v) => $ad98c79b0cc564ad$export$92387174baf9b227 = v);
$parcel$export(module.exports, "isConcurrentMode", () => $ad98c79b0cc564ad$export$ec112efeb987d9c6, (v) => $ad98c79b0cc564ad$export$ec112efeb987d9c6 = v);
$parcel$export(module.exports, "isContextConsumer", () => $ad98c79b0cc564ad$export$b706b080d889d2c9, (v) => $ad98c79b0cc564ad$export$b706b080d889d2c9 = v);
$parcel$export(module.exports, "isContextProvider", () => $ad98c79b0cc564ad$export$5be5a87408f70ddc, (v) => $ad98c79b0cc564ad$export$5be5a87408f70ddc = v);
$parcel$export(module.exports, "isElement", () => $ad98c79b0cc564ad$export$45a5e7f76e0caa8d, (v) => $ad98c79b0cc564ad$export$45a5e7f76e0caa8d = v);
$parcel$export(module.exports, "isForwardRef", () => $ad98c79b0cc564ad$export$455c2e768291efa6, (v) => $ad98c79b0cc564ad$export$455c2e768291efa6 = v);
$parcel$export(module.exports, "isFragment", () => $ad98c79b0cc564ad$export$9522e17588c12572, (v) => $ad98c79b0cc564ad$export$9522e17588c12572 = v);
$parcel$export(module.exports, "isLazy", () => $ad98c79b0cc564ad$export$2110ac352bb060b9, (v) => $ad98c79b0cc564ad$export$2110ac352bb060b9 = v);
$parcel$export(module.exports, "isMemo", () => $ad98c79b0cc564ad$export$56885ab8b9c456ab, (v) => $ad98c79b0cc564ad$export$56885ab8b9c456ab = v);
$parcel$export(module.exports, "isPortal", () => $ad98c79b0cc564ad$export$d927fcb6adf8f9de, (v) => $ad98c79b0cc564ad$export$d927fcb6adf8f9de = v);
$parcel$export(module.exports, "isProfiler", () => $ad98c79b0cc564ad$export$b82d16f27459e05a, (v) => $ad98c79b0cc564ad$export$b82d16f27459e05a = v);
$parcel$export(module.exports, "isStrictMode", () => $ad98c79b0cc564ad$export$522c17b4f5e123e8, (v) => $ad98c79b0cc564ad$export$522c17b4f5e123e8 = v);
$parcel$export(module.exports, "isSuspense", () => $ad98c79b0cc564ad$export$1aabd8a0274ecfd6, (v) => $ad98c79b0cc564ad$export$1aabd8a0274ecfd6 = v);
$parcel$export(module.exports, "isValidElementType", () => $ad98c79b0cc564ad$export$9b621391a187a31a, (v) => $ad98c79b0cc564ad$export$9b621391a187a31a = v);
$parcel$export(module.exports, "typeOf", () => $ad98c79b0cc564ad$export$f5bbd400c2f4426f, (v) => $ad98c79b0cc564ad$export$f5bbd400c2f4426f = v);
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $ad98c79b0cc564ad$export$a7c73072b1a182ae;
var $ad98c79b0cc564ad$export$9f27bc3417b4524d;
var $ad98c79b0cc564ad$export$db77ccec0bb4ccac;
var $ad98c79b0cc564ad$export$8392c0c9d3dcbd35;
var $ad98c79b0cc564ad$export$ffb0004e005737fa;
var $ad98c79b0cc564ad$export$b624eff549462981;
var $ad98c79b0cc564ad$export$7897aa7841a5380c;
var $ad98c79b0cc564ad$export$602eac185826482c;
var $ad98c79b0cc564ad$export$e2c29f18771995cb;
var $ad98c79b0cc564ad$export$5f8d39834fd61797;
var $ad98c79b0cc564ad$export$74bf444e3cd11ea5;
var $ad98c79b0cc564ad$export$92387174baf9b227;
var $ad98c79b0cc564ad$export$ec112efeb987d9c6;
var $ad98c79b0cc564ad$export$b706b080d889d2c9;
var $ad98c79b0cc564ad$export$5be5a87408f70ddc;
var $ad98c79b0cc564ad$export$45a5e7f76e0caa8d;
var $ad98c79b0cc564ad$export$455c2e768291efa6;
var $ad98c79b0cc564ad$export$9522e17588c12572;
var $ad98c79b0cc564ad$export$2110ac352bb060b9;
var $ad98c79b0cc564ad$export$56885ab8b9c456ab;
var $ad98c79b0cc564ad$export$d927fcb6adf8f9de;
var $ad98c79b0cc564ad$export$b82d16f27459e05a;
var $ad98c79b0cc564ad$export$522c17b4f5e123e8;
var $ad98c79b0cc564ad$export$1aabd8a0274ecfd6;
var $ad98c79b0cc564ad$export$9b621391a187a31a;
var $ad98c79b0cc564ad$export$f5bbd400c2f4426f;
'use strict';
var $ad98c79b0cc564ad$var$b = 60103, $ad98c79b0cc564ad$var$c = 60106, $ad98c79b0cc564ad$var$d = 60107, $ad98c79b0cc564ad$var$e = 60108, $ad98c79b0cc564ad$var$f = 60114, $ad98c79b0cc564ad$var$g = 60109, $ad98c79b0cc564ad$var$h = 60110, $ad98c79b0cc564ad$var$k = 60112, $ad98c79b0cc564ad$var$l = 60113, $ad98c79b0cc564ad$var$m = 60120, $ad98c79b0cc564ad$var$n = 60115, $ad98c79b0cc564ad$var$p = 60116, $ad98c79b0cc564ad$var$q = 60121, $ad98c79b0cc564ad$var$r = 60122, $ad98c79b0cc564ad$var$u = 60117, $ad98c79b0cc564ad$var$v = 60129, $ad98c79b0cc564ad$var$w = 60131;
if ("function" === typeof Symbol && Symbol.for) {
    var $ad98c79b0cc564ad$var$x = Symbol.for;
    $ad98c79b0cc564ad$var$b = $ad98c79b0cc564ad$var$x("react.element");
    $ad98c79b0cc564ad$var$c = $ad98c79b0cc564ad$var$x("react.portal");
    $ad98c79b0cc564ad$var$d = $ad98c79b0cc564ad$var$x("react.fragment");
    $ad98c79b0cc564ad$var$e = $ad98c79b0cc564ad$var$x("react.strict_mode");
    $ad98c79b0cc564ad$var$f = $ad98c79b0cc564ad$var$x("react.profiler");
    $ad98c79b0cc564ad$var$g = $ad98c79b0cc564ad$var$x("react.provider");
    $ad98c79b0cc564ad$var$h = $ad98c79b0cc564ad$var$x("react.context");
    $ad98c79b0cc564ad$var$k = $ad98c79b0cc564ad$var$x("react.forward_ref");
    $ad98c79b0cc564ad$var$l = $ad98c79b0cc564ad$var$x("react.suspense");
    $ad98c79b0cc564ad$var$m = $ad98c79b0cc564ad$var$x("react.suspense_list");
    $ad98c79b0cc564ad$var$n = $ad98c79b0cc564ad$var$x("react.memo");
    $ad98c79b0cc564ad$var$p = $ad98c79b0cc564ad$var$x("react.lazy");
    $ad98c79b0cc564ad$var$q = $ad98c79b0cc564ad$var$x("react.block");
    $ad98c79b0cc564ad$var$r = $ad98c79b0cc564ad$var$x("react.server.block");
    $ad98c79b0cc564ad$var$u = $ad98c79b0cc564ad$var$x("react.fundamental");
    $ad98c79b0cc564ad$var$v = $ad98c79b0cc564ad$var$x("react.debug_trace_mode");
    $ad98c79b0cc564ad$var$w = $ad98c79b0cc564ad$var$x("react.legacy_hidden");
}
function $ad98c79b0cc564ad$var$y(a) {
    if ("object" === typeof a && null !== a) {
        var t = a.$$typeof;
        switch(t){
            case $ad98c79b0cc564ad$var$b:
                switch(a = a.type, a){
                    case $ad98c79b0cc564ad$var$d:
                    case $ad98c79b0cc564ad$var$f:
                    case $ad98c79b0cc564ad$var$e:
                    case $ad98c79b0cc564ad$var$l:
                    case $ad98c79b0cc564ad$var$m:
                        return a;
                    default:
                        switch(a = a && a.$$typeof, a){
                            case $ad98c79b0cc564ad$var$h:
                            case $ad98c79b0cc564ad$var$k:
                            case $ad98c79b0cc564ad$var$p:
                            case $ad98c79b0cc564ad$var$n:
                            case $ad98c79b0cc564ad$var$g:
                                return a;
                            default:
                                return t;
                        }
                }
            case $ad98c79b0cc564ad$var$c:
                return t;
        }
    }
}
var $ad98c79b0cc564ad$var$z = $ad98c79b0cc564ad$var$g, $ad98c79b0cc564ad$var$A = $ad98c79b0cc564ad$var$b, $ad98c79b0cc564ad$var$B = $ad98c79b0cc564ad$var$k, $ad98c79b0cc564ad$var$C = $ad98c79b0cc564ad$var$d, $ad98c79b0cc564ad$var$D = $ad98c79b0cc564ad$var$p, $ad98c79b0cc564ad$var$E = $ad98c79b0cc564ad$var$n, $ad98c79b0cc564ad$var$F = $ad98c79b0cc564ad$var$c, $ad98c79b0cc564ad$var$G = $ad98c79b0cc564ad$var$f, $ad98c79b0cc564ad$var$H = $ad98c79b0cc564ad$var$e, $ad98c79b0cc564ad$var$I = $ad98c79b0cc564ad$var$l;
$ad98c79b0cc564ad$export$a7c73072b1a182ae = $ad98c79b0cc564ad$var$h;
$ad98c79b0cc564ad$export$9f27bc3417b4524d = $ad98c79b0cc564ad$var$z;
$ad98c79b0cc564ad$export$db77ccec0bb4ccac = $ad98c79b0cc564ad$var$A;
$ad98c79b0cc564ad$export$8392c0c9d3dcbd35 = $ad98c79b0cc564ad$var$B;
$ad98c79b0cc564ad$export$ffb0004e005737fa = $ad98c79b0cc564ad$var$C;
$ad98c79b0cc564ad$export$b624eff549462981 = $ad98c79b0cc564ad$var$D;
$ad98c79b0cc564ad$export$7897aa7841a5380c = $ad98c79b0cc564ad$var$E;
$ad98c79b0cc564ad$export$602eac185826482c = $ad98c79b0cc564ad$var$F;
$ad98c79b0cc564ad$export$e2c29f18771995cb = $ad98c79b0cc564ad$var$G;
$ad98c79b0cc564ad$export$5f8d39834fd61797 = $ad98c79b0cc564ad$var$H;
$ad98c79b0cc564ad$export$74bf444e3cd11ea5 = $ad98c79b0cc564ad$var$I;
$ad98c79b0cc564ad$export$92387174baf9b227 = function() {
    return !1;
};
$ad98c79b0cc564ad$export$ec112efeb987d9c6 = function() {
    return !1;
};
$ad98c79b0cc564ad$export$b706b080d889d2c9 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$h;
};
$ad98c79b0cc564ad$export$5be5a87408f70ddc = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$g;
};
$ad98c79b0cc564ad$export$45a5e7f76e0caa8d = function(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $ad98c79b0cc564ad$var$b;
};
$ad98c79b0cc564ad$export$455c2e768291efa6 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$k;
};
$ad98c79b0cc564ad$export$9522e17588c12572 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$d;
};
$ad98c79b0cc564ad$export$2110ac352bb060b9 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$p;
};
$ad98c79b0cc564ad$export$56885ab8b9c456ab = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$n;
};
$ad98c79b0cc564ad$export$d927fcb6adf8f9de = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$c;
};
$ad98c79b0cc564ad$export$b82d16f27459e05a = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$f;
};
$ad98c79b0cc564ad$export$522c17b4f5e123e8 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$e;
};
$ad98c79b0cc564ad$export$1aabd8a0274ecfd6 = function(a) {
    return $ad98c79b0cc564ad$var$y(a) === $ad98c79b0cc564ad$var$l;
};
$ad98c79b0cc564ad$export$9b621391a187a31a = function(a) {
    return "string" === typeof a || "function" === typeof a || a === $ad98c79b0cc564ad$var$d || a === $ad98c79b0cc564ad$var$f || a === $ad98c79b0cc564ad$var$v || a === $ad98c79b0cc564ad$var$e || a === $ad98c79b0cc564ad$var$l || a === $ad98c79b0cc564ad$var$m || a === $ad98c79b0cc564ad$var$w || "object" === typeof a && null !== a && (a.$$typeof === $ad98c79b0cc564ad$var$p || a.$$typeof === $ad98c79b0cc564ad$var$n || a.$$typeof === $ad98c79b0cc564ad$var$g || a.$$typeof === $ad98c79b0cc564ad$var$h || a.$$typeof === $ad98c79b0cc564ad$var$k || a.$$typeof === $ad98c79b0cc564ad$var$u || a.$$typeof === $ad98c79b0cc564ad$var$q || a[0] === $ad98c79b0cc564ad$var$r) ? !0 : !1;
};
$ad98c79b0cc564ad$export$f5bbd400c2f4426f = $ad98c79b0cc564ad$var$y;

});



parcelRegister("94zHK", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b02ef9f183b3d3$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");

var $lwCWn = parcelRequire("lwCWn");

var $9UMSs = parcelRequire("9UMSs");

var $foygv = parcelRequire("foygv");

var $jjA10 = parcelRequire("jjA10");

var $2Spd8 = parcelRequire("2Spd8");

var $eEprf = parcelRequire("eEprf");
var $69b02ef9f183b3d3$var$_excluded = [
    "pure",
    "areStatesEqual",
    "areOwnPropsEqual",
    "areStatePropsEqual",
    "areMergedPropsEqual"
];
/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */ function $69b02ef9f183b3d3$var$match(arg, factories, name) {
    for(var i = factories.length - 1; i >= 0; i--){
        var result = factories[i](arg);
        if (result) return result;
    }
    return function(dispatch, options) {
        throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
    };
}
function $69b02ef9f183b3d3$var$strictEqual(a, b) {
    return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
function $69b02ef9f183b3d3$export$9f9feb656dec1fc4(_temp) {
    var _ref = _temp === void 0 ? {} : _temp, _ref$connectHOC = _ref.connectHOC, connectHOC = _ref$connectHOC === void 0 ? (0, $lwCWn.default) : _ref$connectHOC, _ref$mapStateToPropsF = _ref.mapStateToPropsFactories, mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? (0, $jjA10.default) : _ref$mapStateToPropsF, _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories, mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? (0, $foygv.default) : _ref$mapDispatchToPro, _ref$mergePropsFactor = _ref.mergePropsFactories, mergePropsFactories = _ref$mergePropsFactor === void 0 ? (0, $2Spd8.default) : _ref$mergePropsFactor, _ref$selectorFactory = _ref.selectorFactory, selectorFactory = _ref$selectorFactory === void 0 ? (0, $eEprf.default) : _ref$selectorFactory;
    return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
        if (_ref2 === void 0) _ref2 = {};
        var _ref3 = _ref2, _ref3$pure = _ref3.pure, pure = _ref3$pure === void 0 ? true : _ref3$pure, _ref3$areStatesEqual = _ref3.areStatesEqual, areStatesEqual = _ref3$areStatesEqual === void 0 ? $69b02ef9f183b3d3$var$strictEqual : _ref3$areStatesEqual, _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual, areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? (0, $9UMSs.default) : _ref3$areOwnPropsEqua, _ref3$areStatePropsEq = _ref3.areStatePropsEqual, areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? (0, $9UMSs.default) : _ref3$areStatePropsEq, _ref3$areMergedPropsE = _ref3.areMergedPropsEqual, areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? (0, $9UMSs.default) : _ref3$areMergedPropsE, extraOptions = (0, $6XgOP.default)(_ref3, $69b02ef9f183b3d3$var$_excluded);
        var initMapStateToProps = $69b02ef9f183b3d3$var$match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
        var initMapDispatchToProps = $69b02ef9f183b3d3$var$match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
        var initMergeProps = $69b02ef9f183b3d3$var$match(mergeProps, mergePropsFactories, 'mergeProps');
        return connectHOC(selectorFactory, (0, $kU09D.default)({
            // used in error messages
            methodName: 'connect',
            // used to compute Connect's displayName from the wrapped component's displayName.
            getDisplayName: function getDisplayName(name) {
                return "Connect(" + name + ")";
            },
            // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
            shouldHandleStateChanges: Boolean(mapStateToProps),
            // passed through to selectorFactory
            initMapStateToProps: initMapStateToProps,
            initMapDispatchToProps: initMapDispatchToProps,
            initMergeProps: initMergeProps,
            pure: pure,
            areStatesEqual: areStatesEqual,
            areOwnPropsEqual: areOwnPropsEqual,
            areStatePropsEqual: areStatePropsEqual,
            areMergedPropsEqual: areMergedPropsEqual
        }, extraOptions));
    };
}
var $69b02ef9f183b3d3$export$2e2bcd8739ae039 = /*#__PURE__*/ $69b02ef9f183b3d3$export$9f9feb656dec1fc4();

});
parcelRegister("9UMSs", function(module, exports) {

$parcel$export(module.exports, "default", () => $737f420d78dbedc2$export$2e2bcd8739ae039);
function $737f420d78dbedc2$var$is(x, y) {
    if (x === y) return x !== 0 || y !== 0 || 1 / x === 1 / y;
    else return x !== x && y !== y;
}
function $737f420d78dbedc2$export$2e2bcd8739ae039(objA, objB) {
    if ($737f420d78dbedc2$var$is(objA, objB)) return true;
    if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for(var i = 0; i < keysA.length; i++){
        if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !$737f420d78dbedc2$var$is(objA[keysA[i]], objB[keysA[i]])) return false;
    }
    return true;
}

});

parcelRegister("foygv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b353ad45ed306afd$export$2e2bcd8739ae039);

var $aGUDQ = parcelRequire("aGUDQ");

var $16dJ8 = parcelRequire("16dJ8");
function $b353ad45ed306afd$export$a9f27b4b187c1166(mapDispatchToProps) {
    return typeof mapDispatchToProps === 'function' ? (0, $16dJ8.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function $b353ad45ed306afd$export$ba20d1a7aa0c4a90(mapDispatchToProps) {
    return !mapDispatchToProps ? (0, $16dJ8.wrapMapToPropsConstant)(function(dispatch) {
        return {
            dispatch: dispatch
        };
    }) : undefined;
}
function $b353ad45ed306afd$export$94a6e55709d4d961(mapDispatchToProps) {
    return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, $16dJ8.wrapMapToPropsConstant)(function(dispatch) {
        return (0, $aGUDQ.default)(mapDispatchToProps, dispatch);
    }) : undefined;
}
var $b353ad45ed306afd$export$2e2bcd8739ae039 = [
    $b353ad45ed306afd$export$a9f27b4b187c1166,
    $b353ad45ed306afd$export$ba20d1a7aa0c4a90,
    $b353ad45ed306afd$export$94a6e55709d4d961
];

});
parcelRegister("aGUDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c89c37b8d715cdf$export$2e2bcd8739ae039);
function $7c89c37b8d715cdf$export$2e2bcd8739ae039(actionCreators, dispatch) {
    var boundActionCreators = {};
    var _loop = function _loop(key) {
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = function() {
            return dispatch(actionCreator.apply(void 0, arguments));
        };
    };
    for(var key in actionCreators)_loop(key);
    return boundActionCreators;
}

});

parcelRegister("16dJ8", function(module, exports) {

$parcel$export(module.exports, "wrapMapToPropsConstant", () => $0cd0ffddfe5f8933$export$710f7c60f68acd3e);
$parcel$export(module.exports, "wrapMapToPropsFunc", () => $0cd0ffddfe5f8933$export$8d46c7f53c8c602f);
parcelRequire("32fpu");
function $0cd0ffddfe5f8933$export$710f7c60f68acd3e(getConstant) {
    return function initConstantSelector(dispatch, options) {
        var constant = getConstant(dispatch, options);
        function constantSelector() {
            return constant;
        }
        constantSelector.dependsOnOwnProps = false;
        return constantSelector;
    };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
function $0cd0ffddfe5f8933$export$e561b938df936d57(mapToProps) {
    return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
function $0cd0ffddfe5f8933$export$8d46c7f53c8c602f(mapToProps, methodName) {
    return function initProxySelector(dispatch, _ref) {
        var displayName = _ref.displayName;
        var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
            return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
        }; // allow detectFactoryAndVerify to get ownProps
        proxy.dependsOnOwnProps = true;
        proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
            proxy.mapToProps = mapToProps;
            proxy.dependsOnOwnProps = $0cd0ffddfe5f8933$export$e561b938df936d57(mapToProps);
            var props = proxy(stateOrDispatch, ownProps);
            if (typeof props === 'function') {
                proxy.mapToProps = props;
                proxy.dependsOnOwnProps = $0cd0ffddfe5f8933$export$e561b938df936d57(props);
                props = proxy(stateOrDispatch, ownProps);
            }
            return props;
        };
        return proxy;
    };
}

});
parcelRegister("32fpu", function(module, exports) {

var $lkFcE = parcelRequire("lkFcE");

var $2pJov = parcelRequire("2pJov");
function $235d832188fff043$export$2e2bcd8739ae039(value, displayName, methodName) {
    if (!(0, $lkFcE.default)(value)) (0, $2pJov.default)(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
}

});
parcelRegister("lkFcE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f87b6d4f23da449f$export$2e2bcd8739ae039);
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $f87b6d4f23da449f$export$2e2bcd8739ae039(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = Object.getPrototypeOf(obj);
    if (proto === null) return true;
    var baseProto = proto;
    while(Object.getPrototypeOf(baseProto) !== null)baseProto = Object.getPrototypeOf(baseProto);
    return proto === baseProto;
}

});

parcelRegister("2pJov", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2120ec62b602d3$export$2e2bcd8739ae039);
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $1c2120ec62b602d3$export$2e2bcd8739ae039(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    /* eslint-disable no-empty */ } catch (e) {}
/* eslint-enable no-empty */ }

});




parcelRegister("jjA10", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0fbba8fd20a154b$export$2e2bcd8739ae039);

var $16dJ8 = parcelRequire("16dJ8");
function $e0fbba8fd20a154b$export$23fc470827b14aa(mapStateToProps) {
    return typeof mapStateToProps === 'function' ? (0, $16dJ8.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
}
function $e0fbba8fd20a154b$export$514bc8c1a53c1d66(mapStateToProps) {
    return !mapStateToProps ? (0, $16dJ8.wrapMapToPropsConstant)(function() {
        return {};
    }) : undefined;
}
var $e0fbba8fd20a154b$export$2e2bcd8739ae039 = [
    $e0fbba8fd20a154b$export$23fc470827b14aa,
    $e0fbba8fd20a154b$export$514bc8c1a53c1d66
];

});

parcelRegister("2Spd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $21842e43b7ea3faa$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");
parcelRequire("32fpu");
function $21842e43b7ea3faa$export$691c327fc30bc857(stateProps, dispatchProps, ownProps) {
    return (0, $kU09D.default)({}, ownProps, stateProps, dispatchProps);
}
function $21842e43b7ea3faa$export$5b105939c84b5234(mergeProps) {
    return function initMergePropsProxy(dispatch, _ref) {
        var displayName = _ref.displayName, pure = _ref.pure, areMergedPropsEqual = _ref.areMergedPropsEqual;
        var hasRunOnce = false;
        var mergedProps;
        return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
            var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
            if (hasRunOnce) {
                if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
            } else {
                hasRunOnce = true;
                mergedProps = nextMergedProps;
            }
            return mergedProps;
        };
    };
}
function $21842e43b7ea3faa$export$d61b680184bc3f00(mergeProps) {
    return typeof mergeProps === 'function' ? $21842e43b7ea3faa$export$5b105939c84b5234(mergeProps) : undefined;
}
function $21842e43b7ea3faa$export$a13ba70ef50dda6d(mergeProps) {
    return !mergeProps ? function() {
        return $21842e43b7ea3faa$export$691c327fc30bc857;
    } : undefined;
}
var $21842e43b7ea3faa$export$2e2bcd8739ae039 = [
    $21842e43b7ea3faa$export$d61b680184bc3f00,
    $21842e43b7ea3faa$export$a13ba70ef50dda6d
];

});

parcelRegister("eEprf", function(module, exports) {

$parcel$export(module.exports, "default", () => $aaa888a6349e99a0$export$2e2bcd8739ae039);

var $6XgOP = parcelRequire("6XgOP");
parcelRequire("dGyYX");
var $aaa888a6349e99a0$var$_excluded = [
    "initMapStateToProps",
    "initMapDispatchToProps",
    "initMergeProps"
];
function $aaa888a6349e99a0$export$68c2c73bda6aa4b0(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
    return function impureFinalPropsSelector(state, ownProps) {
        return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
    };
}
function $aaa888a6349e99a0$export$d20c0c2ca6eb2b6f(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
    var areStatesEqual = _ref.areStatesEqual, areOwnPropsEqual = _ref.areOwnPropsEqual, areStatePropsEqual = _ref.areStatePropsEqual;
    var hasRunAtLeastOnce = false;
    var state;
    var ownProps;
    var stateProps;
    var dispatchProps;
    var mergedProps;
    function handleFirstCall(firstState, firstOwnProps) {
        state = firstState;
        ownProps = firstOwnProps;
        stateProps = mapStateToProps(state, ownProps);
        dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        hasRunAtLeastOnce = true;
        return mergedProps;
    }
    function handleNewPropsAndNewState() {
        stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewProps() {
        if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
        if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
        mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleNewState() {
        var nextStateProps = mapStateToProps(state, ownProps);
        var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
        stateProps = nextStateProps;
        if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
        return mergedProps;
    }
    function handleSubsequentCalls(nextState, nextOwnProps) {
        var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
        var stateChanged = !areStatesEqual(nextState, state, nextOwnProps, ownProps);
        state = nextState;
        ownProps = nextOwnProps;
        if (propsChanged && stateChanged) return handleNewPropsAndNewState();
        if (propsChanged) return handleNewProps();
        if (stateChanged) return handleNewState();
        return mergedProps;
    }
    return function pureFinalPropsSelector(nextState, nextOwnProps) {
        return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
    };
} // TODO: Add more comments
function $aaa888a6349e99a0$export$2e2bcd8739ae039(dispatch, _ref2) {
    var initMapStateToProps = _ref2.initMapStateToProps, initMapDispatchToProps = _ref2.initMapDispatchToProps, initMergeProps = _ref2.initMergeProps, options = (0, $6XgOP.default)(_ref2, $aaa888a6349e99a0$var$_excluded);
    var mapStateToProps = initMapStateToProps(dispatch, options);
    var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
    var mergeProps = initMergeProps(dispatch, options);
    var selectorFactory = options.pure ? $aaa888a6349e99a0$export$d20c0c2ca6eb2b6f : $aaa888a6349e99a0$export$68c2c73bda6aa4b0;
    return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

});
parcelRegister("dGyYX", function(module, exports) {

var $2pJov = parcelRequire("2pJov");
function $9f6a5555b7986929$var$verify(selector, methodName, displayName) {
    if (!selector) throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
    else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
        if (!Object.prototype.hasOwnProperty.call(selector, 'dependsOnOwnProps')) (0, $2pJov.default)("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
}
function $9f6a5555b7986929$export$2e2bcd8739ae039(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
    $9f6a5555b7986929$var$verify(mapStateToProps, 'mapStateToProps', displayName);
    $9f6a5555b7986929$var$verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
    $9f6a5555b7986929$var$verify(mergeProps, 'mergeProps', displayName);
}

});



parcelRegister("6N2vY", function(module, exports) {

$parcel$export(module.exports, "useDispatch", () => $4f194509acee95c5$export$8ad76b76a4c905f8);

var $iqB4h = parcelRequire("iqB4h");

var $2bGhE = parcelRequire("2bGhE");
function $4f194509acee95c5$export$bc9b55530897c558(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useStore = context === (0, $iqB4h.ReactReduxContext) ? (0, $2bGhE.useStore) : (0, $2bGhE.createStoreHook)(context);
    return function useDispatch() {
        var store = useStore();
        return store.dispatch;
    };
}
var $4f194509acee95c5$export$8ad76b76a4c905f8 = /*#__PURE__*/ $4f194509acee95c5$export$bc9b55530897c558();

});
parcelRegister("2bGhE", function(module, exports) {

$parcel$export(module.exports, "createStoreHook", () => $197d688751cead73$export$671dba69185d0304);
$parcel$export(module.exports, "useStore", () => $197d688751cead73$export$6ccbb43953eebf8);

var $eUqFw = parcelRequire("eUqFw");

var $iqB4h = parcelRequire("iqB4h");

var $bs1OA = parcelRequire("bs1OA");
function $197d688751cead73$export$671dba69185d0304(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useReduxContext = context === (0, $iqB4h.ReactReduxContext) ? (0, $bs1OA.useReduxContext) : function() {
        return (0, $eUqFw.useContext)(context);
    };
    return function useStore() {
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store;
        return store;
    };
}
var $197d688751cead73$export$6ccbb43953eebf8 = /*#__PURE__*/ $197d688751cead73$export$671dba69185d0304();

});
parcelRegister("bs1OA", function(module, exports) {

$parcel$export(module.exports, "useReduxContext", () => $8563b7a80af4c71a$export$c1275ca9a6fd3ec5);

var $eUqFw = parcelRequire("eUqFw");

var $iqB4h = parcelRequire("iqB4h");
function $8563b7a80af4c71a$export$c1275ca9a6fd3ec5() {
    var contextValue = (0, $eUqFw.useContext)((0, $iqB4h.ReactReduxContext));
    return contextValue;
}

});



parcelRegister("cU4FA", function(module, exports) {

$parcel$export(module.exports, "useSelector", () => $964e5656bc2edcae$export$2105062e25df4afe);

var $eUqFw = parcelRequire("eUqFw");

var $bs1OA = parcelRequire("bs1OA");

var $eOZYb = parcelRequire("eOZYb");

var $8RW1t = parcelRequire("8RW1t");

var $iqB4h = parcelRequire("iqB4h");
var $964e5656bc2edcae$var$refEquality = function refEquality(a, b) {
    return a === b;
};
function $964e5656bc2edcae$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
    var _useReducer = (0, $eUqFw.useReducer)(function(s) {
        return s + 1;
    }, 0), forceRender = _useReducer[1];
    var subscription = (0, $eUqFw.useMemo)(function() {
        return (0, $eOZYb.createSubscription)(store, contextSub);
    }, [
        store,
        contextSub
    ]);
    var latestSubscriptionCallbackError = (0, $eUqFw.useRef)();
    var latestSelector = (0, $eUqFw.useRef)();
    var latestStoreState = (0, $eUqFw.useRef)();
    var latestSelectedState = (0, $eUqFw.useRef)();
    var storeState = store.getState();
    var selectedState;
    try {
        if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
            var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references
            if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) selectedState = newSelectedState;
            else selectedState = latestSelectedState.current;
        } else selectedState = latestSelectedState.current;
    } catch (err) {
        if (latestSubscriptionCallbackError.current) err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
        throw err;
    }
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        latestSelector.current = selector;
        latestStoreState.current = storeState;
        latestSelectedState.current = selectedState;
        latestSubscriptionCallbackError.current = undefined;
    });
    (0, $8RW1t.useIsomorphicLayoutEffect)(function() {
        function checkForUpdates() {
            try {
                var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed
                if (newStoreState === latestStoreState.current) return;
                var _newSelectedState = latestSelector.current(newStoreState);
                if (equalityFn(_newSelectedState, latestSelectedState.current)) return;
                latestSelectedState.current = _newSelectedState;
                latestStoreState.current = newStoreState;
            } catch (err) {
                // we ignore all errors here, since when the component
                // is re-rendered, the selectors are called again, and
                // will throw again, if neither props nor store state
                // changed
                latestSubscriptionCallbackError.current = err;
            }
            forceRender();
        }
        subscription.onStateChange = checkForUpdates;
        subscription.trySubscribe();
        checkForUpdates();
        return function() {
            return subscription.tryUnsubscribe();
        };
    }, [
        store,
        subscription
    ]);
    return selectedState;
}
function $964e5656bc2edcae$export$2b53f90d2bd1cbfb(context) {
    if (context === void 0) context = (0, $iqB4h.ReactReduxContext);
    var useReduxContext = context === (0, $iqB4h.ReactReduxContext) ? (0, $bs1OA.useReduxContext) : function() {
        return (0, $eUqFw.useContext)(context);
    };
    return function useSelector(selector, equalityFn) {
        if (equalityFn === void 0) equalityFn = $964e5656bc2edcae$var$refEquality;
        var _useReduxContext = useReduxContext(), store = _useReduxContext.store, contextSub = _useReduxContext.subscription;
        var selectedState = $964e5656bc2edcae$var$useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
        (0, $eUqFw.useDebugValue)(selectedState);
        return selectedState;
    };
}
var $964e5656bc2edcae$export$2105062e25df4afe = /*#__PURE__*/ $964e5656bc2edcae$export$2b53f90d2bd1cbfb();

});


parcelRegister("035eW", function(module, exports) {

$parcel$export(module.exports, "unstable_batchedUpdates", () => (parcelRequire("lEfVV")).unstable_batchedUpdates);
/* eslint-disable import/no-unresolved */ 
var $lEfVV = parcelRequire("lEfVV");

});


const $658e6bd3ffbfdac1$export$404582bc18fe4d9e = 'dev';
const $658e6bd3ffbfdac1$export$46be287603848c56 = 'stg';
const $658e6bd3ffbfdac1$export$e51cdc15d0c6bee2 = 'prod';

parcelRegister("90ON9", function(module, exports) {

$parcel$export(module.exports, "default", () => $68fb835227ef2e44$export$2e2bcd8739ae039);

var $lgRZl = parcelRequire("lgRZl");

var $fEeDC = parcelRequire("fEeDC");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $3ONu7 = parcelRequire("3ONu7");

var $fCICH = parcelRequire("fCICH");

var $eMCmH = parcelRequire("eMCmH");

var $fOzGB = parcelRequire("fOzGB");


var $gggoS = parcelRequire("gggoS");
const $68fb835227ef2e44$var$highlightResult = (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
    matchLevel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    value: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired
});
const $68fb835227ef2e44$var$hitImage = (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
    image: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    highRes: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    smallImage: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    smallHighResImage: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
});
const $68fb835227ef2e44$var$hitVendor = (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
    isTopVendor: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired
});
const $68fb835227ef2e44$var$hitDistribution = (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
    bundled: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    activeInstalls: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    downloads: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    deltaInstalls: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired
});
const $68fb835227ef2e44$var$hitVersion = (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
    compatibilities: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        applicationKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        applicationName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        hosting: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired
    })),
    remotable: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired
});
const $68fb835227ef2e44$var$hitRatings = (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
    avgStars: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    numRatings: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired
});
const $68fb835227ef2e44$var$hit = (fromSearch)=>(0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).recordOf({
        _highlightResult: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
            name: $68fb835227ef2e44$var$highlightResult.isRequired,
            tokenizedName: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf($68fb835227ef2e44$var$highlightResult).isRequired,
            tagLine: $68fb835227ef2e44$var$highlightResult,
            tokenizedTagLine: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf($68fb835227ef2e44$var$highlightResult)
        }), ()=>fromSearch),
        addonId: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number, ()=>fromSearch),
        addonKey: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string, ()=>fromSearch),
        releaseDate: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number, ()=>fromSearch),
        name: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        tagLine: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        categories: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string), ()=>fromSearch),
        deployments: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string), ()=>fromSearch),
        documentType: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string, ()=>fromSearch),
        logo: (0, $lgRZl.default).requiredIf($68fb835227ef2e44$var$hitImage, ()=>fromSearch),
        vendor: (0, $lgRZl.default).requiredIf($68fb835227ef2e44$var$hitVendor, ()=>fromSearch),
        distribution: (0, $lgRZl.default).requiredIf($68fb835227ef2e44$var$hitDistribution, ()=>fromSearch),
        version: (0, $lgRZl.default).requiredIf($68fb835227ef2e44$var$hitVersion, ()=>fromSearch),
        ratings: (0, $lgRZl.default).requiredIf($68fb835227ef2e44$var$hitRatings, ()=>fromSearch)
    });
const $68fb835227ef2e44$var$colSpan = (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
    xl: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    lg: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    md: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    sm: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    xs: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
});
const $68fb835227ef2e44$var$featuredContentOverride = (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).instanceOf((0, $eMCmH.default));
const $68fb835227ef2e44$var$algoliaClientPropType = (0, $fOzGB.chainablePropType)((props, propName, componentName)=>props[propName].constructor.name !== 'AlgoliaClient' ? new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". Validation failed.")) : null);
const $68fb835227ef2e44$var$CommonPropTypes = {
    algoliaClient: $68fb835227ef2e44$var$algoliaClientPropType,
    algoliaConfig: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        applicationId: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        apiKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired
    }),
    colSpan: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        largeHits: $68fb835227ef2e44$var$colSpan,
        smallHits: $68fb835227ef2e44$var$colSpan
    }),
    contentOverrides: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf($68fb835227ef2e44$var$featuredContentOverride),
    discoverCollectionsConfig: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).mapOf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list, (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf((0, $g5DHJ.Map)($122620c1047e308e$exports).toList().push((0, $3ONu7.HOME)).toArray())),
    featuredContentOverride: $68fb835227ef2e44$var$featuredContentOverride,
    filters: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains((0, $gggoS.filtersPropTypeFactory)((0, $fCICH.getFilters)()).toJS()),
    resolveAlgoliaQueryFilterOverrides: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).mapOf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func, (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf((0, $fCICH.getFilters)().keySeq().toJS())),
    hit () {
        function checkType(isRequired, props) {
            const test = $68fb835227ef2e44$var$hit(props.fromSearch);
            for(var _len = arguments.length, restArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)restArgs[_key - 2] = arguments[_key];
            return (isRequired ? test.isRequired : test).apply(this, [
                props,
                ...restArgs
            ]);
        }
        const chainedCheckType = checkType.bind(null, false);
        chainedCheckType.isRequired = checkType.bind(null, true);
        return chainedCheckType;
    },
    hitContext: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        hitHrefResolver: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        hitImageHrefResolver: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
        onHitClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
        onHitMount: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        onRatingsClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        hitGroup: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
    }),
    hitSize: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        'large',
        'small'
    ]),
    screenClass: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        'xl',
        'lg',
        'md',
        'sm',
        'xs'
    ]),
    search: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        currentPage: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
        dataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
        dataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
        loadingFreshSearchResults: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
        moreResultsDataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
        moreResultsDataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
        searchResults: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
            searchId: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
            facets: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list,
            hits: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list,
            numberOfPages: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
            numberOfHits: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
        }),
        initialized: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
        searchInProgress: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired
    }),
    transitions: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        transitionStarted: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        transitionCompleted: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    }),
    unenhancedFilters: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains((0, $gggoS.unenhancedPropTypeFactory)((0, $fCICH.getFilters)()).toJS())
};
var $68fb835227ef2e44$export$2e2bcd8739ae039 = $68fb835227ef2e44$var$CommonPropTypes;

});
parcelRegister("fEeDC", function(module, exports) {
/**
 * This is a straight rip-off of the React.js ReactPropTypes.js proptype validators,
 * modified to make it possible to validate Immutable.js data.
 *     ImmutableTypes.listOf is patterned after React.PropTypes.arrayOf, but for Immutable.List
 *     ImmutableTypes.shape  is based on React.PropTypes.shape, but for any Immutable.Iterable
 */ "use strict";

var $g5DHJ = parcelRequire("g5DHJ");
var $b645f239ba611daa$var$ANONYMOUS = "<<anonymous>>";
var $b645f239ba611daa$var$ImmutablePropTypes;
var $b645f239ba611daa$var$productionTypeChecker = function productionTypeChecker() {
    invariant(false, "ImmutablePropTypes type checking code is stripped in production.");
};
$b645f239ba611daa$var$productionTypeChecker.isRequired = $b645f239ba611daa$var$productionTypeChecker;
var $b645f239ba611daa$var$getProductionTypeChecker = function getProductionTypeChecker() {
    return $b645f239ba611daa$var$productionTypeChecker;
};
$b645f239ba611daa$var$ImmutablePropTypes = {
    listOf: $b645f239ba611daa$var$getProductionTypeChecker,
    mapOf: $b645f239ba611daa$var$getProductionTypeChecker,
    orderedMapOf: $b645f239ba611daa$var$getProductionTypeChecker,
    setOf: $b645f239ba611daa$var$getProductionTypeChecker,
    orderedSetOf: $b645f239ba611daa$var$getProductionTypeChecker,
    stackOf: $b645f239ba611daa$var$getProductionTypeChecker,
    iterableOf: $b645f239ba611daa$var$getProductionTypeChecker,
    recordOf: $b645f239ba611daa$var$getProductionTypeChecker,
    shape: $b645f239ba611daa$var$getProductionTypeChecker,
    contains: $b645f239ba611daa$var$getProductionTypeChecker,
    mapContains: $b645f239ba611daa$var$getProductionTypeChecker,
    // Primitive Types
    list: $b645f239ba611daa$var$productionTypeChecker,
    map: $b645f239ba611daa$var$productionTypeChecker,
    orderedMap: $b645f239ba611daa$var$productionTypeChecker,
    set: $b645f239ba611daa$var$productionTypeChecker,
    orderedSet: $b645f239ba611daa$var$productionTypeChecker,
    stack: $b645f239ba611daa$var$productionTypeChecker,
    seq: $b645f239ba611daa$var$productionTypeChecker,
    record: $b645f239ba611daa$var$productionTypeChecker,
    iterable: $b645f239ba611daa$var$productionTypeChecker
};
$b645f239ba611daa$var$ImmutablePropTypes.iterable.indexed = $b645f239ba611daa$var$createIterableSubclassTypeChecker("Indexed", $g5DHJ.Iterable.isIndexed);
$b645f239ba611daa$var$ImmutablePropTypes.iterable.keyed = $b645f239ba611daa$var$createIterableSubclassTypeChecker("Keyed", $g5DHJ.Iterable.isKeyed);
function $b645f239ba611daa$var$getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) return "array";
    if (propValue instanceof RegExp) // Old webkits (at least until Android 4.0) return 'function' rather than
    // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
    // passes PropTypes.object.
    return "object";
    if (propValue instanceof $g5DHJ.Iterable) return "Immutable." + propValue.toSource().split(" ")[0];
    return propType;
}
function $b645f239ba611daa$var$createChainableTypeChecker(validate) {
    function checkType(isRequired, props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = Array(_len > 6 ? _len - 6 : 0), _key = 6; _key < _len; _key++)rest[_key - 6] = arguments[_key];
        propFullName = propFullName || propName;
        componentName = componentName || $b645f239ba611daa$var$ANONYMOUS;
        if (props[propName] == null) {
            var locationName = location;
            if (isRequired) return new Error("Required " + locationName + " `" + propFullName + "` was not specified in " + ("`" + componentName + "`."));
        } else return validate.apply(undefined, [
            props,
            propName,
            componentName,
            location,
            propFullName
        ].concat(rest));
    }
    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);
    return chainedCheckType;
}
function $b645f239ba611daa$var$createImmutableTypeChecker(immutableClassName, immutableClassTypeValidator) {
    function validate(props, propName, componentName, location, propFullName) {
        var propValue = props[propName];
        if (!immutableClassTypeValidator(propValue)) {
            var propType = $b645f239ba611daa$var$getPropType(propValue);
            return new Error("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected `" + immutableClassName + "`."));
        }
        return null;
    }
    return $b645f239ba611daa$var$createChainableTypeChecker(validate);
}
function $b645f239ba611daa$var$createIterableSubclassTypeChecker(subclassName, validator) {
    return $b645f239ba611daa$var$createImmutableTypeChecker("Iterable." + subclassName, function(propValue) {
        return $g5DHJ.Iterable.isIterable(propValue) && validator(propValue);
    });
}
function $b645f239ba611daa$var$createIterableTypeChecker(typeChecker, immutableClassName, immutableClassTypeValidator) {
    function validate(props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)rest[_key - 5] = arguments[_key];
        var propValue = props[propName];
        if (!immutableClassTypeValidator(propValue)) {
            var locationName = location;
            var propType = $b645f239ba611daa$var$getPropType(propValue);
            return new Error("Invalid " + locationName + " `" + propFullName + "` of type " + ("`" + propType + "` supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
        }
        if (typeof typeChecker !== "function") return new Error("Invalid typeChecker supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
        var propValues = propValue.valueSeq().toArray();
        for(var i = 0, len = propValues.length; i < len; i++){
            var error = typeChecker.apply(undefined, [
                propValues,
                i,
                componentName,
                location,
                "" + propFullName + "[" + i + "]"
            ].concat(rest));
            if (error instanceof Error) return error;
        }
    }
    return $b645f239ba611daa$var$createChainableTypeChecker(validate);
}
function $b645f239ba611daa$var$createKeysTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)rest[_key - 5] = arguments[_key];
        var propValue = props[propName];
        if (typeof typeChecker !== "function") return new Error("Invalid keysTypeChecker (optional second argument) supplied to `" + componentName + "` " + ("for propType `" + propFullName + "`, expected a function."));
        var keys = propValue.keySeq().toArray();
        for(var i = 0, len = keys.length; i < len; i++){
            var error = typeChecker.apply(undefined, [
                keys,
                i,
                componentName,
                location,
                "" + propFullName + " -> key(" + keys[i] + ")"
            ].concat(rest));
            if (error instanceof Error) return error;
        }
    }
    return $b645f239ba611daa$var$createChainableTypeChecker(validate);
}
function $b645f239ba611daa$var$createListOfTypeChecker(typeChecker) {
    return $b645f239ba611daa$var$createIterableTypeChecker(typeChecker, "List", $g5DHJ.List.isList);
}
function $b645f239ba611daa$var$createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, immutableClassName, immutableClassTypeValidator) {
    function validate() {
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return $b645f239ba611daa$var$createIterableTypeChecker(valuesTypeChecker, immutableClassName, immutableClassTypeValidator).apply(undefined, args) || keysTypeChecker && $b645f239ba611daa$var$createKeysTypeChecker(keysTypeChecker).apply(undefined, args);
    }
    return $b645f239ba611daa$var$createChainableTypeChecker(validate);
}
function $b645f239ba611daa$var$createMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
    return $b645f239ba611daa$var$createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "Map", $g5DHJ.Map.isMap);
}
function $b645f239ba611daa$var$createOrderedMapOfTypeChecker(valuesTypeChecker, keysTypeChecker) {
    return $b645f239ba611daa$var$createMapOfTypeCheckerFactory(valuesTypeChecker, keysTypeChecker, "OrderedMap", $g5DHJ.OrderedMap.isOrderedMap);
}
function $b645f239ba611daa$var$createSetOfTypeChecker(typeChecker) {
    return $b645f239ba611daa$var$createIterableTypeChecker(typeChecker, "Set", $g5DHJ.Set.isSet);
}
function $b645f239ba611daa$var$createOrderedSetOfTypeChecker(typeChecker) {
    return $b645f239ba611daa$var$createIterableTypeChecker(typeChecker, "OrderedSet", $g5DHJ.OrderedSet.isOrderedSet);
}
function $b645f239ba611daa$var$createStackOfTypeChecker(typeChecker) {
    return $b645f239ba611daa$var$createIterableTypeChecker(typeChecker, "Stack", $g5DHJ.Stack.isStack);
}
function $b645f239ba611daa$var$createIterableOfTypeChecker(typeChecker) {
    return $b645f239ba611daa$var$createIterableTypeChecker(typeChecker, "Iterable", $g5DHJ.Iterable.isIterable);
}
function $b645f239ba611daa$var$createRecordOfTypeChecker(recordKeys) {
    function validate(props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)rest[_key - 5] = arguments[_key];
        var propValue = props[propName];
        if (!(propValue instanceof $g5DHJ.Record)) {
            var propType = $b645f239ba611daa$var$getPropType(propValue);
            var locationName = location;
            return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js Record."));
        }
        for(var key in recordKeys){
            var checker = recordKeys[key];
            if (!checker) continue;
            var mutablePropValue = propValue.toObject();
            var error = checker.apply(undefined, [
                mutablePropValue,
                key,
                componentName,
                location,
                "" + propFullName + "." + key
            ].concat(rest));
            if (error) return error;
        }
    }
    return $b645f239ba611daa$var$createChainableTypeChecker(validate);
}
// there is some irony in the fact that shapeTypes is a standard hash and not an immutable collection
function $b645f239ba611daa$var$createShapeTypeChecker(shapeTypes) {
    var immutableClassName = arguments[1] === undefined ? "Iterable" : arguments[1];
    var immutableClassTypeValidator = arguments[2] === undefined ? $g5DHJ.Iterable.isIterable : arguments[2];
    function validate(props, propName, componentName, location, propFullName) {
        for(var _len = arguments.length, rest = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++)rest[_key - 5] = arguments[_key];
        var propValue = props[propName];
        if (!immutableClassTypeValidator(propValue)) {
            var propType = $b645f239ba611daa$var$getPropType(propValue);
            var locationName = location;
            return new Error("Invalid " + locationName + " `" + propFullName + "` of type `" + propType + "` " + ("supplied to `" + componentName + "`, expected an Immutable.js " + immutableClassName + "."));
        }
        var mutablePropValue = propValue.toObject();
        for(var key in shapeTypes){
            var checker = shapeTypes[key];
            if (!checker) continue;
            var error = checker.apply(undefined, [
                mutablePropValue,
                key,
                componentName,
                location,
                "" + propFullName + "." + key
            ].concat(rest));
            if (error) return error;
        }
    }
    return $b645f239ba611daa$var$createChainableTypeChecker(validate);
}
function $b645f239ba611daa$var$createShapeChecker(shapeTypes) {
    return $b645f239ba611daa$var$createShapeTypeChecker(shapeTypes);
}
function $b645f239ba611daa$var$createMapContainsChecker(shapeTypes) {
    return $b645f239ba611daa$var$createShapeTypeChecker(shapeTypes, "Map", $g5DHJ.Map.isMap);
}
module.exports = $b645f239ba611daa$var$ImmutablePropTypes;

});

parcelRegister("3ONu7", function(module, exports) {

$parcel$export(module.exports, "HOME", () => $2c7c6d4234dd21cf$export$a7c5707626fc90f);
$parcel$export(module.exports, "CollectionsEnum", () => $2c7c6d4234dd21cf$export$39bbf650e2467463);
$parcel$export(module.exports, "LARGE_COLLECTION_TYPE", () => $2c7c6d4234dd21cf$export$1da19aa559318561);
$parcel$export(module.exports, "SMALL_COLLECTION_TYPE", () => $2c7c6d4234dd21cf$export$954f870831c20abc);
$parcel$export(module.exports, "default", () => $2c7c6d4234dd21cf$export$2e2bcd8739ae039);

var $3RTYU = parcelRequire("3RTYU");

var $g5DHJ = parcelRequire("g5DHJ");

var $c8Guq = parcelRequire("c8Guq");

var $fMsDx = parcelRequire("fMsDx");

var $fCICH = parcelRequire("fCICH");

var $9LwYq = parcelRequire("9LwYq");



var $b5Eig = parcelRequire("b5Eig");

var $bavaN = parcelRequire("bavaN");
const $2c7c6d4234dd21cf$export$a7c5707626fc90f = 'home';
const $2c7c6d4234dd21cf$export$fb0b7b8e1356bdd8 = {
    SPOTLIGHT: 'marketplaceSpotlight',
    BEST_SELLER: 'marketplaceBestSeller',
    RISING_STAR: 'marketplaceRisingStar'
};
const $2c7c6d4234dd21cf$export$39bbf650e2467463 = {
    FEATURED: 'featured',
    TOP_SELLING: 'topSelling',
    TOP_SELLING_CLOUD: 'topSellingCloud',
    TOP_SELLING_SERVER: 'topSellingServer',
    RECENTLY_ADDED: 'recentlyAdded',
    TRENDING: 'trending',
    NATURAL_WITHOUT_FEATURED: 'naturalWithoutFeatured',
    CLOUD_FORTIFIED: 'cloudFortified',
    SPOTLIGHT: 'spotlight',
    BEST_SELLER: 'bestseller',
    RISING_STAR: 'risingStar'
};
const $2c7c6d4234dd21cf$var$emptyQuery = (0, $g5DHJ.Map)({
    filters: (0, $g5DHJ.Map)(),
    applyOverrides: (0, $b5Eig.default).default_()
});
const $2c7c6d4234dd21cf$var$baseWithoutAtlassianQuery = $2c7c6d4234dd21cf$var$emptyQuery.update('applyOverrides', (applyOverrides)=>applyOverrides.compose({
        types: (0, $g5DHJ.Set)([
            (0, $fMsDx.default).get('isAtlassian')
        ]),
        apply: (params)=>params.addFacetRefinement((0, $fMsDx.default).get('isAtlassian').algoliaFacetKey, 'false')
    }));
const $2c7c6d4234dd21cf$var$basePaidViaAtlassianQuery = $2c7c6d4234dd21cf$var$baseWithoutAtlassianQuery.update('applyOverrides', (applyOverrides)=>applyOverrides.composeApply((p)=>p.addDisjunctiveFacetRefinement((0, $fMsDx.default).get('marketplaceType').algoliaFacetKey, (0, $ad0fdcf1dd8b1c21$export$820680178c2de888))));
const $2c7c6d4234dd21cf$export$1da19aa559318561 = 'LARGE_COLLECTION_TYPE';
const $2c7c6d4234dd21cf$export$954f870831c20abc = 'SMALL_COLLECTION_TYPE';
const $2c7c6d4234dd21cf$var$resolveProductLabel = (_ref)=>{
    let { productKey: productKey, options: options } = _ref;
    return (0, $fCICH.getFilters)({
        featureFlags: options
    }).getIn([
        'product',
        'customFilters',
        productKey,
        'label'
    ]);
};
const $2c7c6d4234dd21cf$var$resolveBaseWithoutAtlassianQueries = (_ref2)=>{
    let { baseFilters: baseFilters, baseApplyOverrides: baseApplyOverrides } = _ref2;
    return $2c7c6d4234dd21cf$var$resolveQueriesFactory({
        baseQuery: $2c7c6d4234dd21cf$var$baseWithoutAtlassianQuery,
        baseFilters: baseFilters,
        baseApplyOverrides: baseApplyOverrides
    });
};
const $2c7c6d4234dd21cf$var$resolveQueriesFactory = (_ref3)=>{
    let { baseQuery: baseQuery, baseFilters: baseFilters, baseApplyOverrides: baseApplyOverrides } = _ref3;
    baseFilters = baseFilters || (0, $g5DHJ.Map)();
    baseApplyOverrides = baseApplyOverrides || (0, $b5Eig.default).default_();
    return function() {
        let { filters: filters, applyOverrides: applyOverrides } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
            filters: (0, $g5DHJ.Map)(),
            applyOverrides: (0, $b5Eig.default).default_()
        };
        const apo = applyOverrides || (0, $b5Eig.default).default_();
        return (0, $g5DHJ.List)([
            baseQuery.update('filters', (fs)=>fs.merge(baseFilters).merge(filters)).update('applyOverrides', (ao)=>ao.compose(baseApplyOverrides).compose(apo))
        ]);
    };
};
const $2c7c6d4234dd21cf$var$singleResolveHits = (_ref4)=>{
    let { hits: hits } = _ref4;
    return (0, $3RTYU).sample(hits.flatten(1), 6);
};
const $2c7c6d4234dd21cf$var$singleResolveHitsForCompass = (_ref5)=>{
    let { hits: hits } = _ref5;
    return (0, $3RTYU).sample(hits.flatten(1), 18);
};
const $2c7c6d4234dd21cf$var$preserveHitsOrder = (addonKeys)=>(hits)=>hits.sort((a, b)=>addonKeys.indexOf(a.get('addonKey')) - addonKeys.indexOf(b.get('addonKey')));
const $2c7c6d4234dd21cf$var$flattenHits = (_ref6)=>{
    let { hits: hits } = _ref6;
    return hits.flatten(1);
};
const $2c7c6d4234dd21cf$var$customCriteriaCollectionFactory = (_ref7)=>{
    let { key: key, featuredCollectionConfig: featuredCollectionConfig, tileType: tileType, numDisplayResults: numDisplayResults, marketingLabelFilter: marketingLabelFilter } = _ref7;
    const flattenRequiredNumberOfHits = (_ref8)=>{
        let { hits: hits } = _ref8;
        return (0, $3RTYU).sample(hits.flatten(1), numDisplayResults);
    };
    const baseQueries = (0, $g5DHJ.List)([
        $2c7c6d4234dd21cf$var$emptyQuery.update('applyOverrides', (applyOverrides)=>applyOverrides.compose((0, $bavaN.searchParamsUpdateForAddonKeys)(featuredCollectionConfig.curatedApps)))
    ]);
    const { title: title, tagline: tagline, curatedApps: curatedApps } = featuredCollectionConfig;
    return (0, $g5DHJ.Map)({
        key: key,
        analyticsTileType: key,
        numResults: 10,
        numDisplayResults: numDisplayResults,
        title: title,
        tagline: tagline,
        type: tileType,
        usesContentOverride: true,
        resolveQueries: (_ref9)=>{
            let { filters: filters, applyOverrides: applyOverrides } = _ref9;
            return baseQueries.map((bq)=>bq.update('filters', (fs)=>fs.mergeDeep(filters)).update('applyOverrides', (ao)=>ao.compose(applyOverrides)));
        },
        resolveHits: (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
            flattenRequiredNumberOfHits,
            $2c7c6d4234dd21cf$var$preserveHitsOrder(curatedApps)
        ]),
        filters: (0, $g5DHJ.Map)({
            marketingLabel: (0, $g5DHJ.Set)([
                marketingLabelFilter
            ])
        })
    });
};
const $2c7c6d4234dd21cf$var$spotlightCollectionFactory = (featuredCollectionsConfig)=>{
    const spotlightCollection = featuredCollectionsConfig.find((featuredCollectionConfig)=>featuredCollectionConfig.key === $2c7c6d4234dd21cf$export$fb0b7b8e1356bdd8.SPOTLIGHT);
    if (spotlightCollection) return $2c7c6d4234dd21cf$var$customCriteriaCollectionFactory({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.SPOTLIGHT,
        featuredCollectionConfig: spotlightCollection,
        tileType: $2c7c6d4234dd21cf$export$1da19aa559318561,
        numDisplayResults: 6,
        marketingLabelFilter: 'Spotlight'
    });
};
const $2c7c6d4234dd21cf$var$bestSellerCollectionFactory = (featuredCollectionsConfig)=>{
    const bestsellerCollection = featuredCollectionsConfig.find((featuredCollectionConfig)=>featuredCollectionConfig.key === $2c7c6d4234dd21cf$export$fb0b7b8e1356bdd8.BEST_SELLER);
    if (bestsellerCollection) return $2c7c6d4234dd21cf$var$customCriteriaCollectionFactory({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.BEST_SELLER,
        featuredCollectionConfig: bestsellerCollection,
        tileType: $2c7c6d4234dd21cf$export$954f870831c20abc,
        numDisplayResults: 9,
        marketingLabelFilter: 'Bestseller'
    });
};
const $2c7c6d4234dd21cf$var$risingStarCollectionFactory = (featuredCollectionsConfig)=>{
    const risingStarCollection = featuredCollectionsConfig.find((featuredCollectionConfig)=>featuredCollectionConfig.key === $2c7c6d4234dd21cf$export$fb0b7b8e1356bdd8.RISING_STAR);
    if (risingStarCollection) return $2c7c6d4234dd21cf$var$customCriteriaCollectionFactory({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.RISING_STAR,
        featuredCollectionConfig: risingStarCollection,
        tileType: $2c7c6d4234dd21cf$export$954f870831c20abc,
        numDisplayResults: 9,
        marketingLabelFilter: 'Rising Star'
    });
};
const $2c7c6d4234dd21cf$var$featuredCollectionFactory = (_ref10)=>{
    let { baseQueries: baseQueries, numDisplayResults: numDisplayResults, resolveHits: resolveHits, title: title, tagline: tagline, product: product } = _ref10;
    return (0, $g5DHJ.Map)({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.FEATURED,
        analyticsTileType: 'exploreTile',
        numResults: product === (0, $122620c1047e308e$export$d5e9b613bc4c47f) ? 18 : 10,
        numDisplayResults: numDisplayResults,
        title: title,
        tagline: tagline,
        type: $2c7c6d4234dd21cf$export$1da19aa559318561,
        hideViewMore: product !== (0, $122620c1047e308e$export$d5e9b613bc4c47f),
        recordTileImpressions: true,
        usesContentOverride: true,
        resolveQueries: (_ref11)=>{
            let { filters: filters, applyOverrides: applyOverrides = (0, $b5Eig.default).default_() } = _ref11;
            return baseQueries.map((bq)=>bq.update('filters', (fs)=>fs.mergeDeep(filters)).update('applyOverrides', (ao)=>ao.compose(applyOverrides)));
        },
        resolveHits: resolveHits
    });
};
const $2c7c6d4234dd21cf$var$topSellingCollectionFactory = function topSellingCollectionFactory() {
    let { productKey: productKey, tagline: tagline, options: options } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, $g5DHJ.Map)({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.TOP_SELLING,
        analyticsTileType: 'topSelling',
        numResults: 9,
        title: productKey ? "Top-selling ".concat($2c7c6d4234dd21cf$var$resolveProductLabel({
            productKey: productKey,
            options: options
        }), " apps") : 'Top-selling apps',
        tagline: tagline,
        type: $2c7c6d4234dd21cf$export$954f870831c20abc,
        resolveQueries: $2c7c6d4234dd21cf$var$resolveBaseWithoutAtlassianQueries({
            baseFilters: $2c7c6d4234dd21cf$var$topSellingBaseFilters
        }),
        resolveHits: $2c7c6d4234dd21cf$var$flattenHits,
        filters: $2c7c6d4234dd21cf$var$topSellingBaseFilters
    });
};
const $2c7c6d4234dd21cf$var$topSellingBaseFilters = (0, $g5DHJ.Map)({
    sort: (0, $9LwYq.sortOptions).get('topSelling').get('key')
});
const $2c7c6d4234dd21cf$var$recentlyAddedCollectionFactory = function recentlyAddedCollectionFactory() {
    let { productKey: productKey, tagline: tagline, options: options } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, $g5DHJ.Map)({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.RECENTLY_ADDED,
        analyticsTileType: 'newestTile',
        numResults: 9,
        title: productKey ? "Newest ".concat($2c7c6d4234dd21cf$var$resolveProductLabel({
            productKey: productKey,
            options: options
        }), " apps") : 'Newest apps',
        tagline: tagline,
        type: $2c7c6d4234dd21cf$export$954f870831c20abc,
        resolveQueries: $2c7c6d4234dd21cf$var$resolveBaseWithoutAtlassianQueries({
            baseFilters: $2c7c6d4234dd21cf$var$recentlyAddedBaseFilters
        }),
        resolveHits: $2c7c6d4234dd21cf$var$flattenHits,
        filters: $2c7c6d4234dd21cf$var$recentlyAddedBaseFilters
    });
};
const $2c7c6d4234dd21cf$var$recentlyAddedBaseFilters = (0, $g5DHJ.Map)({
    sort: (0, $9LwYq.sortOptions).get('newest').get('key')
});
const $2c7c6d4234dd21cf$var$trendingCollectionFactory = function trendingCollectionFactory() {
    let { productKey: productKey, tagline: tagline, options: options } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (0, $g5DHJ.Map)({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.TRENDING,
        analyticsTileType: 'trendingTile',
        numResults: 9,
        title: productKey ? "Trending ".concat($2c7c6d4234dd21cf$var$resolveProductLabel({
            productKey: productKey,
            options: options
        }), " apps") : 'Trending apps',
        tagline: tagline,
        type: $2c7c6d4234dd21cf$export$954f870831c20abc,
        resolveQueries: $2c7c6d4234dd21cf$var$resolveBaseWithoutAtlassianQueries({
            baseFilters: $2c7c6d4234dd21cf$var$trendingBaseFilters
        }),
        resolveHits: $2c7c6d4234dd21cf$var$flattenHits,
        filters: $2c7c6d4234dd21cf$var$trendingBaseFilters
    });
};
const $2c7c6d4234dd21cf$var$trendingBaseFilters = (0, $g5DHJ.Map)({
    sort: (0, $9LwYq.sortOptions).get('trending').get('key')
});
const $2c7c6d4234dd21cf$var$featuredCollectionNumDisplayResults = 6;
const $2c7c6d4234dd21cf$export$dfaaf09f3edb4c4a = (0, $g5DHJ.Map)({
    moreFilters: (0, $g5DHJ.Set)([
        'cloudFortified'
    ])
});
const $2c7c6d4234dd21cf$var$cloudFortifiedAppsCollectionFactory = ()=>(0, $g5DHJ.Map)({
        key: $2c7c6d4234dd21cf$export$39bbf650e2467463.CLOUD_FORTIFIED,
        analyticsTileType: 'cloudFortifiedAppTile',
        numResults: 3,
        title: 'Cloud Fortified Apps',
        tagline: "Cloud apps with additional security, reliability, and support to meet your organization's needs.",
        type: $2c7c6d4234dd21cf$export$1da19aa559318561,
        resolveHits: $2c7c6d4234dd21cf$var$flattenHits,
        hideViewMore: false,
        resolveQueries: $2c7c6d4234dd21cf$var$resolveQueriesFactory({
            baseQuery: $2c7c6d4234dd21cf$var$cloudFortifiedAppQuery
        }),
        filters: $2c7c6d4234dd21cf$export$dfaaf09f3edb4c4a
    });
const $2c7c6d4234dd21cf$var$cloudFortifiedAppQuery = $2c7c6d4234dd21cf$var$basePaidViaAtlassianQuery.update('applyOverrides', (applyOverrides)=>applyOverrides.composeApply((p)=>p.addFacetRefinement((0, $fMsDx.default).get('cloudFortified').algoliaFacetKey, 'approved')));
const $2c7c6d4234dd21cf$var$getHomeCollections = (featuredAddonsConfig)=>{
    if (featuredAddonsConfig) {
        const featuredCollectionsHomeConfig = featuredAddonsConfig.get($2c7c6d4234dd21cf$export$a7c5707626fc90f);
        const homeDefaultCollections = [
            $2c7c6d4234dd21cf$var$cloudFortifiedAppsCollectionFactory()
        ];
        const customCriteriaCollections = featuredCollectionsHomeConfig && featuredCollectionsHomeConfig.length > 0 ? [
            $2c7c6d4234dd21cf$var$spotlightCollectionFactory(featuredCollectionsHomeConfig),
            $2c7c6d4234dd21cf$var$bestSellerCollectionFactory(featuredCollectionsHomeConfig),
            $2c7c6d4234dd21cf$var$risingStarCollectionFactory(featuredCollectionsHomeConfig)
        ] : [];
        return (0, $g5DHJ.List)([
            ...homeDefaultCollections,
            ...customCriteriaCollections
        ]);
    }
    return (0, $g5DHJ.List)([]);
};
const $2c7c6d4234dd21cf$var$getJiraCollections = (featuredAddonsConfig)=>{
    if (featuredAddonsConfig) {
        const featuredCollectionsJiraConfig = featuredAddonsConfig.get((0, $122620c1047e308e$export$c1fabc4e59d98025));
        return featuredCollectionsJiraConfig && featuredCollectionsJiraConfig.length > 0 ? (0, $g5DHJ.List)([
            $2c7c6d4234dd21cf$var$spotlightCollectionFactory(featuredCollectionsJiraConfig),
            $2c7c6d4234dd21cf$var$bestSellerCollectionFactory(featuredCollectionsJiraConfig),
            $2c7c6d4234dd21cf$var$risingStarCollectionFactory(featuredCollectionsJiraConfig)
        ]) : (0, $g5DHJ.List)([]);
    }
    return (0, $g5DHJ.List)([]);
};
const $2c7c6d4234dd21cf$var$getJiraServiceDeskCollections = (featuredAddonsConfig)=>{
    if (featuredAddonsConfig) {
        const featuredCollectionsJsdConfig = featuredAddonsConfig.get((0, $122620c1047e308e$export$3afc372bb8c4538c));
        return featuredCollectionsJsdConfig && featuredCollectionsJsdConfig.length > 0 ? (0, $g5DHJ.List)([
            $2c7c6d4234dd21cf$var$spotlightCollectionFactory(featuredCollectionsJsdConfig),
            $2c7c6d4234dd21cf$var$bestSellerCollectionFactory(featuredCollectionsJsdConfig),
            $2c7c6d4234dd21cf$var$risingStarCollectionFactory(featuredCollectionsJsdConfig)
        ]) : (0, $g5DHJ.List)([]);
    }
    return (0, $g5DHJ.List)([]);
};
const $2c7c6d4234dd21cf$var$getConfluenceCollections = (featuredAddonsConfig)=>{
    if (featuredAddonsConfig) {
        const featuredCollectionsConfluenceConfig = featuredAddonsConfig.get((0, $122620c1047e308e$export$c811f21c9ad05dc2));
        return featuredCollectionsConfluenceConfig && featuredCollectionsConfluenceConfig.length > 0 ? (0, $g5DHJ.List)([
            $2c7c6d4234dd21cf$var$spotlightCollectionFactory(featuredCollectionsConfluenceConfig),
            $2c7c6d4234dd21cf$var$bestSellerCollectionFactory(featuredCollectionsConfluenceConfig),
            $2c7c6d4234dd21cf$var$risingStarCollectionFactory(featuredCollectionsConfluenceConfig)
        ]) : (0, $g5DHJ.List)([]);
    }
    return (0, $g5DHJ.List)([]);
};
const $2c7c6d4234dd21cf$var$getBitbucketCollections = (featuredAddonsConfig, options)=>{
    const commonBitbucketCollections = [
        $2c7c6d4234dd21cf$var$topSellingCollectionFactory({
            productKey: (0, $122620c1047e308e$export$59864d7602eb300a),
            options: options
        }),
        $2c7c6d4234dd21cf$var$recentlyAddedCollectionFactory({
            productKey: (0, $122620c1047e308e$export$59864d7602eb300a),
            options: options
        })
    ];
    let featuredBitbucketCollection;
    if (featuredAddonsConfig) {
        featuredBitbucketCollection = $2c7c6d4234dd21cf$var$featuredCollectionFactory({
            baseQueries: $2c7c6d4234dd21cf$var$resolveProductQueries({
                productBaseQuery: $2c7c6d4234dd21cf$var$basePaidViaAtlassianQuery,
                product: (0, $122620c1047e308e$export$59864d7602eb300a),
                featuredAddonsConfig: featuredAddonsConfig
            }),
            numDisplayResults: $2c7c6d4234dd21cf$var$featuredCollectionNumDisplayResults,
            resolveHits: $2c7c6d4234dd21cf$var$resolveHits((0, $122620c1047e308e$export$59864d7602eb300a), featuredAddonsConfig)
        });
        return (0, $g5DHJ.List)([
            featuredBitbucketCollection,
            ...commonBitbucketCollections
        ]);
    }
};
const $2c7c6d4234dd21cf$var$getHipchatCollections = (featuredAddonsConfig, options)=>{
    const commonHipchatCollections = [
        $2c7c6d4234dd21cf$var$recentlyAddedCollectionFactory({
            productKey: (0, $122620c1047e308e$export$77363fc37d01ae41),
            options: options
        }),
        $2c7c6d4234dd21cf$var$trendingCollectionFactory({
            productKey: (0, $122620c1047e308e$export$77363fc37d01ae41),
            options: options
        })
    ];
    const featuredHipchatCollection = $2c7c6d4234dd21cf$var$featuredCollectionFactory({
        baseQueries: $2c7c6d4234dd21cf$var$resolveProductQueries({
            productBaseQuery: $2c7c6d4234dd21cf$var$baseWithoutAtlassianQuery.update('filters', (filters)=>filters.set('marketingLabel', (0, $g5DHJ.Set)([
                    'hipchat-default'
                ]))),
            product: (0, $122620c1047e308e$export$77363fc37d01ae41),
            featuredAddonsConfig: featuredAddonsConfig
        }),
        numDisplayResults: $2c7c6d4234dd21cf$var$featuredCollectionNumDisplayResults,
        resolveHits: $2c7c6d4234dd21cf$var$resolveHits((0, $122620c1047e308e$export$77363fc37d01ae41), featuredAddonsConfig)
    });
    return (0, $g5DHJ.List)([
        featuredHipchatCollection,
        ...commonHipchatCollections
    ]);
};
const $2c7c6d4234dd21cf$var$getFecruCollections = (featuredAddonsConfig, options)=>{
    const commonFecruCollections = [
        $2c7c6d4234dd21cf$var$topSellingCollectionFactory({
            productKey: (0, $122620c1047e308e$export$e95554a59f3e0c28),
            options: options
        }),
        $2c7c6d4234dd21cf$var$recentlyAddedCollectionFactory({
            productKey: (0, $122620c1047e308e$export$e95554a59f3e0c28),
            options: options
        }),
        $2c7c6d4234dd21cf$var$trendingCollectionFactory({
            productKey: (0, $122620c1047e308e$export$e95554a59f3e0c28),
            options: options
        })
    ];
    const featuredFecruCollection = $2c7c6d4234dd21cf$var$featuredCollectionFactory({
        baseQueries: $2c7c6d4234dd21cf$var$resolveProductQueries({
            productBaseQuery: $2c7c6d4234dd21cf$var$basePaidViaAtlassianQuery,
            product: (0, $122620c1047e308e$export$e95554a59f3e0c28),
            featuredAddonsConfig: featuredAddonsConfig
        }),
        numDisplayResults: $2c7c6d4234dd21cf$var$featuredCollectionNumDisplayResults,
        resolveHits: $2c7c6d4234dd21cf$var$resolveHits((0, $122620c1047e308e$export$e95554a59f3e0c28), featuredAddonsConfig)
    });
    return (0, $g5DHJ.List)([
        featuredFecruCollection,
        ...commonFecruCollections
    ]);
};
const $2c7c6d4234dd21cf$var$getBambooCollections = (featuredAddonsConfig, options)=>{
    const commonBambooCollections = [
        $2c7c6d4234dd21cf$var$topSellingCollectionFactory({
            productKey: (0, $122620c1047e308e$export$1876370d95915b3b),
            options: options
        }),
        $2c7c6d4234dd21cf$var$recentlyAddedCollectionFactory({
            productKey: (0, $122620c1047e308e$export$1876370d95915b3b),
            options: options
        }),
        $2c7c6d4234dd21cf$var$trendingCollectionFactory({
            productKey: (0, $122620c1047e308e$export$1876370d95915b3b),
            options: options
        })
    ];
    const featuredBambooCollection = $2c7c6d4234dd21cf$var$featuredCollectionFactory({
        baseQueries: $2c7c6d4234dd21cf$var$resolveProductQueries({
            productBaseQuery: $2c7c6d4234dd21cf$var$basePaidViaAtlassianQuery,
            product: (0, $122620c1047e308e$export$1876370d95915b3b),
            featuredAddonsConfig: featuredAddonsConfig
        }),
        numDisplayResults: $2c7c6d4234dd21cf$var$featuredCollectionNumDisplayResults,
        resolveHits: $2c7c6d4234dd21cf$var$resolveHits((0, $122620c1047e308e$export$1876370d95915b3b), featuredAddonsConfig)
    });
    return (0, $g5DHJ.List)([
        featuredBambooCollection,
        ...commonBambooCollections
    ]);
};
const $2c7c6d4234dd21cf$var$getCompassCollections = (featuredAddonsConfig)=>{
    const featuredCompassCollection = $2c7c6d4234dd21cf$var$featuredCollectionFactory({
        baseQueries: $2c7c6d4234dd21cf$var$resolveProductQueries({
            productBaseQuery: $2c7c6d4234dd21cf$var$emptyQuery,
            product: (0, $122620c1047e308e$export$d5e9b613bc4c47f),
            featuredAddonsConfig: featuredAddonsConfig
        }),
        numDisplayResults: 18,
        resolveHits: $2c7c6d4234dd21cf$var$resolveHits((0, $122620c1047e308e$export$d5e9b613bc4c47f), featuredAddonsConfig),
        product: (0, $122620c1047e308e$export$d5e9b613bc4c47f)
    });
    return (0, $g5DHJ.List)([
        featuredCompassCollection
    ]);
};
const $2c7c6d4234dd21cf$var$getCrowdCollections = (featuredAddonsConfig, options)=>{
    const commonCrowdCollections = [
        $2c7c6d4234dd21cf$var$recentlyAddedCollectionFactory({
            productKey: (0, $122620c1047e308e$export$6bc23744ed8b8097),
            options: options
        }),
        $2c7c6d4234dd21cf$var$trendingCollectionFactory({
            productKey: (0, $122620c1047e308e$export$6bc23744ed8b8097),
            options: options
        })
    ];
    const featuredCrowdCollection = $2c7c6d4234dd21cf$var$featuredCollectionFactory({
        baseQueries: $2c7c6d4234dd21cf$var$resolveProductQueries({
            productBaseQuery: $2c7c6d4234dd21cf$var$baseWithoutAtlassianQuery,
            product: (0, $122620c1047e308e$export$6bc23744ed8b8097),
            featuredAddonsConfig: featuredAddonsConfig
        }),
        numDisplayResults: $2c7c6d4234dd21cf$var$featuredCollectionNumDisplayResults,
        resolveHits: $2c7c6d4234dd21cf$var$resolveHits((0, $122620c1047e308e$export$6bc23744ed8b8097), featuredAddonsConfig)
    });
    return (0, $g5DHJ.List)([
        featuredCrowdCollection,
        ...commonCrowdCollections
    ]);
};
const $2c7c6d4234dd21cf$var$resolveHits = (product, featuredAddonsConfig)=>{
    const featuredAddons = featuredAddonsConfig.get(product);
    if (product === (0, $122620c1047e308e$export$d5e9b613bc4c47f)) return $2c7c6d4234dd21cf$var$singleResolveHitsForCompass;
    return featuredAddons !== null && featuredAddons !== void 0 && featuredAddons.curatedApps ? (0, (/*@__PURE__*/$parcel$interopDefault($c8Guq)))([
        $2c7c6d4234dd21cf$var$singleResolveHits,
        $2c7c6d4234dd21cf$var$preserveHitsOrder(featuredAddons.curatedApps)
    ]) : $2c7c6d4234dd21cf$var$singleResolveHits;
};
const $2c7c6d4234dd21cf$var$resolveProductQueries = (_ref12)=>{
    let { productBaseQuery: productBaseQuery, product: product, featuredAddonsConfig: featuredAddonsConfig } = _ref12;
    const featuredAddons = featuredAddonsConfig.get(product);
    return (0, $g5DHJ.List)([
        featuredAddons !== null && featuredAddons !== void 0 && featuredAddons.curatedApps ? $2c7c6d4234dd21cf$var$emptyQuery.update('applyOverrides', (applyOverrides)=>applyOverrides.compose((0, $bavaN.searchParamsUpdateForAddonKeys)(featuredAddons.curatedApps))) : productBaseQuery.update('filters', (filters)=>filters.set('product', product))
    ]);
};
var $2c7c6d4234dd21cf$export$2e2bcd8739ae039 = (_ref13)=>{
    let { featuredAddonsConfig: featuredAddonsConfig, options: options } = _ref13;
    const homeCollections = $2c7c6d4234dd21cf$var$getHomeCollections(featuredAddonsConfig);
    const jiraCollections = $2c7c6d4234dd21cf$var$getJiraCollections(featuredAddonsConfig);
    const jiraServiceDeskCollections = $2c7c6d4234dd21cf$var$getJiraServiceDeskCollections(featuredAddonsConfig);
    const confluenceCollections = $2c7c6d4234dd21cf$var$getConfluenceCollections(featuredAddonsConfig);
    const bitbucketCollections = $2c7c6d4234dd21cf$var$getBitbucketCollections(featuredAddonsConfig, options);
    const hipchatCollections = $2c7c6d4234dd21cf$var$getHipchatCollections(featuredAddonsConfig, options);
    const fecruCollections = $2c7c6d4234dd21cf$var$getFecruCollections(featuredAddonsConfig, options);
    const bambooCollections = $2c7c6d4234dd21cf$var$getBambooCollections(featuredAddonsConfig, options);
    const crowdCollections = $2c7c6d4234dd21cf$var$getCrowdCollections(featuredAddonsConfig, options);
    const compassCollections = $2c7c6d4234dd21cf$var$getCompassCollections(featuredAddonsConfig);
    return (0, $g5DHJ.Map)({
        [$2c7c6d4234dd21cf$export$a7c5707626fc90f]: homeCollections,
        [(0, $122620c1047e308e$export$c1fabc4e59d98025)]: jiraCollections,
        [(0, $122620c1047e308e$export$d5e9b613bc4c47f)]: compassCollections,
        [(0, $122620c1047e308e$export$3afc372bb8c4538c)]: jiraServiceDeskCollections,
        [(0, $122620c1047e308e$export$c811f21c9ad05dc2)]: confluenceCollections,
        [(0, $122620c1047e308e$export$59864d7602eb300a)]: bitbucketCollections,
        [(0, $122620c1047e308e$export$77363fc37d01ae41)]: hipchatCollections,
        [(0, $122620c1047e308e$export$e95554a59f3e0c28)]: fecruCollections,
        [(0, $122620c1047e308e$export$1876370d95915b3b)]: bambooCollections,
        [(0, $122620c1047e308e$export$6bc23744ed8b8097)]: crowdCollections
    });
};

});
parcelRegister("3RTYU", function(module, exports) {

$parcel$export(module.exports, "fill", () => (parcelRequire("2sAIk")).default);
$parcel$export(module.exports, "listToMap", () => (parcelRequire("h5SyG")).default);
$parcel$export(module.exports, "sample", () => (parcelRequire("1U4eV")).default);
$parcel$export(module.exports, "shuffle", () => (parcelRequire("loHyr")).default);

var $2sAIk = parcelRequire("2sAIk");

var $h5SyG = parcelRequire("h5SyG");

var $1U4eV = parcelRequire("1U4eV");

var $loHyr = parcelRequire("loHyr");

});
parcelRegister("2sAIk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1caaaceb3739a06c$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $loHyr = parcelRequire("loHyr");
function $1caaaceb3739a06c$export$2e2bcd8739ae039() {
    let startList = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $g5DHJ.List)();
    return (totalSize)=>(withList)=>{
            return startList.size > totalSize ? startList.take(totalSize) : startList.concat((0, $loHyr.default)(withList || (0, $g5DHJ.List)()).take(totalSize - startList.size));
        };
}

});
parcelRegister("loHyr", function(module, exports) {

$parcel$export(module.exports, "default", () => $f93d9fdebd9d7277$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");
function $f93d9fdebd9d7277$export$2e2bcd8739ae039(list) {
    const set = list;
    const size = set.size;
    return list.reduce((acc, _item, i)=>{
        const rand = $f93d9fdebd9d7277$var$random(0, i);
        if (rand !== i) {
            const randItem = acc.get(rand);
            acc = acc.set(i, randItem);
        }
        const itemAtI = set.get(i);
        return acc.set(rand, itemAtI);
    }, (0, $g5DHJ.List)(new Array(size)));
}
function $f93d9fdebd9d7277$var$random(min, max) {
    if (max === null) {
        max = min;
        min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
}

});


parcelRegister("h5SyG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c71d3972fa41c563$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");
function $c71d3972fa41c563$export$2e2bcd8739ae039(list, getKeyFunction) {
    return list.reduce((acc, value)=>acc.set(getKeyFunction(value), value), (0, $g5DHJ.Map)());
}

});

parcelRegister("1U4eV", function(module, exports) {

$parcel$export(module.exports, "default", () => $162e4f58c41cdac3$export$2e2bcd8739ae039);

var $loHyr = parcelRequire("loHyr");
function $162e4f58c41cdac3$export$2e2bcd8739ae039(list, n) {
    return (0, $loHyr.default)(list).slice(0, Math.max(0, n));
}

});


parcelRegister("fMsDx", function(module, exports) {

$parcel$export(module.exports, "default", () => $b7d18d5f855d684c$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $lwEMm = parcelRequire("lwEMm");
var $b7d18d5f855d684c$export$2e2bcd8739ae039 = (0, $g5DHJ.Map)({
    product: (0, $lwEMm.default).disjunctive('version.compatibilities.applicationKey'),
    hidden: (0, $lwEMm.default).disjunctive('hidden'),
    hosting: (0, $lwEMm.default).disjunctive('version.compatibilities.hosting'),
    deployments: (0, $lwEMm.default).disjunctive('deployments'),
    categories: (0, $lwEMm.default).disjunctive('categories'),
    paid: (0, $lwEMm.default).conjunctive('version.paid'),
    topVendor: (0, $lwEMm.default).conjunctive('vendor.isTopVendor'),
    vendorSupported: (0, $lwEMm.default).conjunctive('version.supported'),
    stable: (0, $lwEMm.default).conjunctive('version.stable'),
    canonicalVersion: (0, $lwEMm.default).conjunctive('version.canonicalVersion'),
    latestOfHosting: (0, $lwEMm.default).conjunctive('version.latestOfHosting'),
    isAtlassian: (0, $lwEMm.default).conjunctive('vendor.isAtlassian'),
    marketplaceType: (0, $lwEMm.default).disjunctive('version.marketplaceType'),
    marketingLabels: (0, $lwEMm.default).disjunctive('marketingLabels'),
    pluginSystemVersion: (0, $lwEMm.default).conjunctive('version.pluginSystemVersion'),
    cloudFortified: (0, $lwEMm.default).conjunctive('programs.cloudFortified.status'),
    freeStarterTier: (0, $lwEMm.default).conjunctive('freeStarterTierStatus'),
    bugBountyParticipant: (0, $lwEMm.default).conjunctive('programs.bugBountyParticipant')
});

});
parcelRegister("lwEMm", function(module, exports) {

$parcel$export(module.exports, "DISJUNCTIVE_FACET_TYPE", () => $fabc37f8a80d584d$export$91bee53bcb4bd3f8);
$parcel$export(module.exports, "CONJUNCTIVE_FACET_TYPE", () => $fabc37f8a80d584d$export$67e226be74e0a900);
$parcel$export(module.exports, "default", () => $fabc37f8a80d584d$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");
const $fabc37f8a80d584d$export$91bee53bcb4bd3f8 = 'disjunctive';
const $fabc37f8a80d584d$export$67e226be74e0a900 = 'conjunctive';
class $fabc37f8a80d584d$export$2e2bcd8739ae039 extends (0, $g5DHJ.Record)({
    algoliaFacetKey: undefined,
    queryType: undefined
}) {
    static disjunctive(algoliaFacetKey) {
        return new $fabc37f8a80d584d$export$2e2bcd8739ae039({
            algoliaFacetKey: algoliaFacetKey,
            queryType: $fabc37f8a80d584d$export$91bee53bcb4bd3f8
        });
    }
    static conjunctive(algoliaFacetKey) {
        return new $fabc37f8a80d584d$export$2e2bcd8739ae039({
            algoliaFacetKey: algoliaFacetKey,
            queryType: $fabc37f8a80d584d$export$67e226be74e0a900
        });
    }
}
const $fabc37f8a80d584d$export$a0dd41b84533ed48 = (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).instanceOf($fabc37f8a80d584d$export$2e2bcd8739ae039);

});


parcelRegister("fCICH", function(module, exports) {

$parcel$export(module.exports, "sortingLogic", () => $b5fd04e2494471c1$export$1daa9d759361acf);
$parcel$export(module.exports, "getFilters", () => $b5fd04e2494471c1$export$1933a9fe712fc1fd);
$parcel$export(module.exports, "getTabletMobileFilters", () => $b5fd04e2494471c1$export$fa7a9d830f6dbd45);

var $kafab = parcelRequire("kafab");

var $g5DHJ = parcelRequire("g5DHJ");



var $lwEMm = parcelRequire("lwEMm");

var $fMsDx = parcelRequire("fMsDx");

var $io1ow = parcelRequire("io1ow");

var $9LwYq = parcelRequire("9LwYq");
const $b5fd04e2494471c1$var$categoriesByUsage = (0, $io1ow.default).sortedByUsage.map((categoryName)=>categoryName.toLowerCase());
const $b5fd04e2494471c1$export$1daa9d759361acf = {
    USAGE_AND_ALPHABETICAL: 'usage-and-alphabetical',
    ALPHABETICAL: 'alphabetical',
    COUNT_AND_ALPHABETICAL: 'count-and-alphabetical',
    DEFAULT: 'default'
};
const $b5fd04e2494471c1$export$efc12c4ce5cdead = Object.freeze({
    enabled: 'enabled',
    disabled: 'disabled'
});
function $b5fd04e2494471c1$var$resolveFacetProductCount(facets, facetKey, facetProductKey) {
    const facet = facets.find((f)=>f.get('name') === facetKey);
    return facet ? facet.getIn([
        'data',
        facetProductKey
    ]) || 0 : 0;
}
function $b5fd04e2494471c1$var$sortByCountDesc(a, b) {
    if (b.get('count') - a.get('count') !== 0) return b.get('count') - a.get('count');
    return a.get('label').localeCompare(b.get('label'));
}
const $b5fd04e2494471c1$var$sortByUsage = (a, b)=>{
    const getIndex = (element)=>!$b5fd04e2494471c1$var$categoriesByUsage.includes(element.toLowerCase()) ? Number.POSITIVE_INFINITY : $b5fd04e2494471c1$var$categoriesByUsage.indexOf(element.toLowerCase());
    return getIndex(a.get('label')) - getIndex(b.get('label'));
};
// eslint-disable-next-line max-lines-per-function -- Fix me
const $b5fd04e2494471c1$var$productFilter = function productFilter() {
    var _options$featureFlags;
    let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    const customFilters = {
        [(0, $122620c1047e308e$export$c1fabc4e59d98025)]: (0, $g5DHJ.Map)({
            value: (0, $122620c1047e308e$export$c1fabc4e59d98025),
            algoliaValue: 'jira',
            label: 'Jira',
            resolveFacetCount (facets) {
                return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'jira');
            }
        }),
        [(0, $122620c1047e308e$export$3afc372bb8c4538c)]: (0, $g5DHJ.Map)({
            value: (0, $122620c1047e308e$export$3afc372bb8c4538c),
            algoliaValue: 'jira-service-desk',
            label: 'Jira Service Management',
            resolveFacetCount (facets) {
                return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'jira-service-desk');
            }
        }),
        [(0, $122620c1047e308e$export$c811f21c9ad05dc2)]: (0, $g5DHJ.Map)({
            algoliaValue: 'confluence',
            value: (0, $122620c1047e308e$export$c811f21c9ad05dc2),
            label: 'Confluence',
            resolveFacetCount (facets) {
                return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'confluence');
            }
        }),
        [(0, $122620c1047e308e$export$59864d7602eb300a)]: (0, $g5DHJ.Map)({
            algoliaValue: 'bitbucket',
            value: (0, $122620c1047e308e$export$59864d7602eb300a),
            label: 'Bitbucket',
            resolveFacetCount (facets) {
                return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'bitbucket');
            }
        })
    };
    if ((options === null || options === void 0 ? void 0 : (_options$featureFlags = options.featureFlags) === null || _options$featureFlags === void 0 ? void 0 : _options$featureFlags.showCompassApps) !== false) customFilters[0, $122620c1047e308e$export$d5e9b613bc4c47f] = (0, $g5DHJ.Map)({
        algoliaValue: 'compass',
        value: (0, $122620c1047e308e$export$d5e9b613bc4c47f),
        label: 'Compass',
        resolveFacetCount (facets) {
            return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'compass');
        }
    });
    customFilters[0, $122620c1047e308e$export$e95554a59f3e0c28] = (0, $g5DHJ.Map)({
        algoliaValue: 'fecru',
        value: (0, $122620c1047e308e$export$e95554a59f3e0c28),
        label: 'Fisheye/Crucible',
        resolveFacetCount (facets) {
            return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'fecru');
        }
    });
    customFilters[0, $122620c1047e308e$export$1876370d95915b3b] = (0, $g5DHJ.Map)({
        algoliaValue: 'bamboo',
        value: (0, $122620c1047e308e$export$1876370d95915b3b),
        label: 'Bamboo',
        resolveFacetCount (facets) {
            return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'bamboo');
        }
    });
    customFilters[0, $122620c1047e308e$export$6bc23744ed8b8097] = (0, $g5DHJ.Map)({
        algoliaValue: 'crowd',
        value: (0, $122620c1047e308e$export$6bc23744ed8b8097),
        label: 'Crowd',
        resolveFacetCount (facets) {
            return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, productFilter().get('algoliaFacetKey'), 'crowd');
        }
    });
    return (0, $g5DHJ.Map)({
        key: 'product',
        label: 'Product',
        sidebarLabel: 'All Products',
        topBarLabel: 'Products',
        algoliaFacetKey: (0, $fMsDx.default).getIn([
            'product',
            'algoliaFacetKey'
        ]),
        queryType: (0, $lwEMm.DISJUNCTIVE_FACET_TYPE),
        type: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
        primary: true,
        custom: true,
        displayInCurrent: true,
        facet: true,
        discoverFilter: true,
        requiredDiscoverFilterWhenNonEmpty: true,
        useDropDownComponentForSidebar: true,
        resolveAlgoliaQuery (_ref) {
            let { params: params, filters: filters } = _ref;
            const product = filters.get('product');
            return product ? params.addDisjunctiveFacetRefinement(productFilter().get('algoliaFacetKey'), productFilter().getIn([
                'customFilters',
                product,
                'algoliaValue'
            ])) : params;
        },
        customFilters: (0, $g5DHJ.OrderedMap)(customFilters)
    });
};
const $b5fd04e2494471c1$var$hostingFilter = ()=>(0, $g5DHJ.Map)({
        key: 'hosting',
        label: 'Select a hosting type',
        sidebarLabel: 'Select a hosting type',
        topBarLabel: 'Hosting',
        algoliaFacetKey: (0, $fMsDx.default).getIn([
            'hosting',
            'algoliaFacetKey'
        ]),
        queryType: (0, $lwEMm.DISJUNCTIVE_FACET_TYPE),
        type: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
        custom: true,
        displayInCurrent: true,
        facet: true,
        openByDefault: true,
        useDropDownComponentForSidebar: true,
        resolveAlgoliaQuery (_ref2) {
            let { params: params, filters: filters } = _ref2;
            const customFilter = $b5fd04e2494471c1$var$hostingFilter().getIn([
                'customFilters',
                filters.get('hosting')
            ]);
            return customFilter ? params.addFacetRefinement((0, $fMsDx.default).getIn([
                'latestOfHosting',
                'algoliaFacetKey'
            ]), 'true').addDisjunctiveFacetRefinement($b5fd04e2494471c1$var$hostingFilter().get('algoliaFacetKey'), customFilter.get('value')) : params.addFacetRefinement((0, $fMsDx.default).getIn([
                'canonicalVersion',
                'algoliaFacetKey'
            ]), 'true');
        },
        customFilters: (0, $g5DHJ.Map)({
            cloud: (0, $g5DHJ.Map)({
                algoliaValue: (0, $8749bcdb7e4afe9a$export$428c0af80a7329cd),
                value: (0, $8749bcdb7e4afe9a$export$428c0af80a7329cd),
                label: 'Cloud',
                resolveFacetCount (facets, filters) {
                    const facetKey = filters.get('hosting') ? $b5fd04e2494471c1$var$hostingFilter().get('algoliaFacetKey') : (0, $fMsDx.default).getIn([
                        'deployments',
                        'algoliaFacetKey'
                    ]);
                    return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, facetKey, (0, $8749bcdb7e4afe9a$export$428c0af80a7329cd));
                }
            }),
            server: (0, $g5DHJ.Map)({
                algoliaValue: (0, $8749bcdb7e4afe9a$export$7fc2afdd98086cb1),
                value: (0, $8749bcdb7e4afe9a$export$7fc2afdd98086cb1),
                label: 'Server',
                resolveFacetCount (facets, filters) {
                    const facetKey = filters.get('hosting') ? $b5fd04e2494471c1$var$hostingFilter().get('algoliaFacetKey') : (0, $fMsDx.default).getIn([
                        'deployments',
                        'algoliaFacetKey'
                    ]);
                    return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, facetKey, (0, $8749bcdb7e4afe9a$export$7fc2afdd98086cb1));
                }
            }),
            dataCenter: (0, $g5DHJ.Map)({
                algoliaValue: (0, $8749bcdb7e4afe9a$export$35e53a8bdbe06647),
                value: (0, $8749bcdb7e4afe9a$export$35e53a8bdbe06647),
                label: 'Data Center',
                resolveFacetCount (facets, filters) {
                    const facetKey = filters.get('hosting') ? $b5fd04e2494471c1$var$hostingFilter().get('algoliaFacetKey') : (0, $fMsDx.default).getIn([
                        'deployments',
                        'algoliaFacetKey'
                    ]);
                    return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, facetKey, (0, $8749bcdb7e4afe9a$export$35e53a8bdbe06647));
                }
            })
        })
    });
const $b5fd04e2494471c1$var$categoryFilter = ()=>(0, $g5DHJ.Map)({
        key: 'category',
        algoliaFacetKey: (0, $fMsDx.default).getIn([
            'categories',
            'algoliaFacetKey'
        ]),
        label: 'Categories',
        queryType: (0, $lwEMm.DISJUNCTIVE_FACET_TYPE),
        type: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
        displayInCurrent: true,
        facet: true,
        primary: true,
        resolveAlgoliaQuery (_ref3) {
            let { params: params, filters: filters } = _ref3;
            const category = filters.get('category');
            return category ? params.addDisjunctiveFacetRefinement((0, $fMsDx.default).getIn([
                'categories',
                'algoliaFacetKey'
            ]), category) : params;
        },
        // MC-731 Experiment when sorting logic is usage-and-alphabetical, render in groups of popular and all
        collateFunction (facetProducts, sortLogic) {
            if (sortLogic === $b5fd04e2494471c1$export$1daa9d759361acf.USAGE_AND_ALPHABETICAL) {
                const firstFiveByUsage = facetProducts.slice(0, 5);
                const restByLabel = facetProducts.slice(5);
                return {
                    popular: firstFiveByUsage,
                    all: restByLabel
                };
            }
            return facetProducts;
        },
        sortFunction (facetProducts, sortLogic) {
            const productsByUsage = facetProducts.sort($b5fd04e2494471c1$var$sortByUsage);
            const productsByLabel = facetProducts.sortBy((valA)=>valA.get('label'));
            const productsByAppCount = facetProducts.sort($b5fd04e2494471c1$var$sortByCountDesc);
            switch(sortLogic){
                case $b5fd04e2494471c1$export$1daa9d759361acf.ALPHABETICAL:
                    return productsByLabel;
                case $b5fd04e2494471c1$export$1daa9d759361acf.USAGE_AND_ALPHABETICAL:
                    {
                        const firstFiveByUsage = productsByUsage.slice(0, 5);
                        const restByLabel = productsByUsage.sortBy((valA)=>valA.get('label'));
                        return firstFiveByUsage.concat(restByLabel);
                    }
                case $b5fd04e2494471c1$export$1daa9d759361acf.COUNT_AND_ALPHABETICAL:
                    {
                        const firstFiveByCount = productsByAppCount.slice(0, 5);
                        const restByLabel = productsByAppCount.slice(5).sortBy((valA)=>valA.get('label'));
                        return firstFiveByCount.concat(restByLabel);
                    }
                default:
                    return facetProducts;
            }
        }
    });
const $b5fd04e2494471c1$var$freeCustomFilter = (0, $g5DHJ.Map)({
    label: 'Free for all teams',
    value: 'free',
    algoliaFacetKey: (0, $fMsDx.default).getIn([
        'paid',
        'algoliaFacetKey'
    ]),
    queryType: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
    resolveFacetCount (facets) {
        return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, $b5fd04e2494471c1$var$freeCustomFilter.get('algoliaFacetKey'), 'false');
    },
    resolveAlgoliaQuery (_ref4) {
        let { params: params, moreFilters: moreFilters } = _ref4;
        return moreFilters.includes($b5fd04e2494471c1$var$freeCustomFilter.get('value')) ? params.addFacetRefinement($b5fd04e2494471c1$var$freeCustomFilter.get('algoliaFacetKey'), 'false') : params;
    }
});
const $b5fd04e2494471c1$var$ecosystemCloudAppsFilter = ()=>(0, $g5DHJ.Map)({
        key: 'nonEcosystemCloudApps',
        label: 'Non Ecosystem Cloud Apps',
        value: 'nonEcosystemCloudApps',
        algoliaFacetKey: (0, $fMsDx.default).getIn([
            'pluginSystemVersion',
            'algoliaFacetKey'
        ]),
        queryType: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
        resolveAlgoliaQuery (_ref5) {
            let { params: params } = _ref5;
            return params;
        }
    });
const $b5fd04e2494471c1$var$vendorSupportedCustomFilter = (0, $g5DHJ.Map)({
    label: 'Partner supported',
    value: 'vendorSupported',
    algoliaFacetKey: (0, $fMsDx.default).getIn([
        'vendorSupported',
        'algoliaFacetKey'
    ]),
    queryType: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
    resolveFacetCount (facets) {
        return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, $b5fd04e2494471c1$var$vendorSupportedCustomFilter.get('algoliaFacetKey'), 'true');
    },
    resolveAlgoliaQuery (_ref6) {
        let { params: params, moreFilters: moreFilters } = _ref6;
        return moreFilters.includes($b5fd04e2494471c1$var$vendorSupportedCustomFilter.get('value')) ? params.addFacetRefinement($b5fd04e2494471c1$var$vendorSupportedCustomFilter.get('algoliaFacetKey'), 'true') : params;
    }
});
const $b5fd04e2494471c1$var$betaVersionCustomFilter = (0, $g5DHJ.Map)({
    label: 'Beta version',
    value: 'betaVersion',
    algoliaFacetKey: (0, $fMsDx.default).getIn([
        'stable',
        'algoliaFacetKey'
    ]),
    queryType: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
    resolveFacetCount (facets) {
        return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, $b5fd04e2494471c1$var$betaVersionCustomFilter.get('algoliaFacetKey'), 'false');
    },
    resolveAlgoliaQuery (_ref7) {
        let { params: params, moreFilters: moreFilters } = _ref7;
        return moreFilters.includes($b5fd04e2494471c1$var$betaVersionCustomFilter.get('value')) ? params.addFacetRefinement($b5fd04e2494471c1$var$betaVersionCustomFilter.get('algoliaFacetKey'), 'false') : params;
    }
});
const $b5fd04e2494471c1$var$cloudFortifiedAppCustomFilter = (0, $g5DHJ.Map)({
    key: 'cloudFortified',
    label: 'Cloud Fortified apps',
    value: 'cloudFortified',
    algoliaFacetKey: (0, $fMsDx.default).getIn([
        'cloudFortified',
        'algoliaFacetKey'
    ]),
    queryType: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
    resolveFacetCount (facets) {
        return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, $b5fd04e2494471c1$var$cloudFortifiedAppCustomFilter.get('algoliaFacetKey'), (0, $kafab.CloudFortifiedStatusValues).Approved);
    },
    resolveAlgoliaQuery (_ref8) {
        let { params: params, moreFilters: moreFilters } = _ref8;
        return moreFilters.includes($b5fd04e2494471c1$var$cloudFortifiedAppCustomFilter.get('value')) ? params.addFacetRefinement($b5fd04e2494471c1$var$cloudFortifiedAppCustomFilter.get('algoliaFacetKey'), (0, $kafab.CloudFortifiedStatusValues).Approved) : params;
    }
});
const $b5fd04e2494471c1$var$freeStarterTierFilter = (0, $g5DHJ.Map)({
    key: 'freeStarterTier',
    label: 'Free up to 10 users',
    value: 'freeStarterTier',
    algoliaFacetKey: (0, $fMsDx.default).getIn([
        'freeStarterTier',
        'algoliaFacetKey'
    ]),
    queryType: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
    resolveFacetCount (facets) {
        return $b5fd04e2494471c1$var$resolveFacetProductCount(facets, $b5fd04e2494471c1$var$freeStarterTierFilter.get('algoliaFacetKey'), $b5fd04e2494471c1$export$efc12c4ce5cdead.enabled);
    },
    resolveAlgoliaQuery (_ref9) {
        let { params: params, moreFilters: moreFilters } = _ref9;
        return moreFilters.includes($b5fd04e2494471c1$var$freeStarterTierFilter.get('value')) ? params.addFacetRefinement($b5fd04e2494471c1$var$freeStarterTierFilter.get('algoliaFacetKey'), $b5fd04e2494471c1$export$efc12c4ce5cdead.enabled) : params;
    }
});
const $b5fd04e2494471c1$var$moreCustomFilters = (0, $g5DHJ.OrderedMap)({
    cloudFortified: $b5fd04e2494471c1$var$cloudFortifiedAppCustomFilter,
    vendorSupported: $b5fd04e2494471c1$var$vendorSupportedCustomFilter,
    free: $b5fd04e2494471c1$var$freeCustomFilter,
    betaVersion: $b5fd04e2494471c1$var$betaVersionCustomFilter,
    freeStarterTier: $b5fd04e2494471c1$var$freeStarterTierFilter
});
const $b5fd04e2494471c1$var$moreFiltersFilter = ()=>(0, $g5DHJ.Map)({
        key: 'moreFilters',
        label: 'Filter By',
        sidebarLabel: 'Filter By',
        topBarLabel: 'More Filters',
        type: (0, $lwEMm.DISJUNCTIVE_FACET_TYPE),
        custom: true,
        displayInCurrent: true,
        facet: true,
        primary: true,
        resolveAlgoliaQuery (_ref10) {
            let { params: params, filters: filters } = _ref10;
            const moreFilters = filters.get('moreFilters');
            return $b5fd04e2494471c1$var$moreFiltersFilter().get('customFilters').reduce((p, cf)=>cf.get('resolveAlgoliaQuery')({
                    params: p,
                    moreFilters: moreFilters
                }), params);
        },
        customFilters: $b5fd04e2494471c1$var$moreCustomFilters
    });
const $b5fd04e2494471c1$var$queryFilter = (0, $g5DHJ.Map)({
    key: 'query',
    facet: false,
    displayInCurrent: true,
    resolveCurrentFilterText (_ref11) {
        let { value: value } = _ref11;
        return "\"".concat(value, "\"");
    },
    resolveAlgoliaQuery (_ref12) {
        let { params: params, filters: filters } = _ref12;
        return params.setQuery(filters.get('query') || '');
    }
});
const $b5fd04e2494471c1$var$marketingLabel = (0, $g5DHJ.Map)({
    algoliaFacetKey: (0, $fMsDx.default).getIn([
        'marketingLabels',
        'algoliaFacetKey'
    ]),
    key: 'marketingLabel',
    queryType: (0, $lwEMm.DISJUNCTIVE_FACET_TYPE),
    type: (0, $lwEMm.DISJUNCTIVE_FACET_TYPE),
    facet: false,
    displayInCurrent: true,
    resolveCurrentFilterText (_ref13) {
        let { value: value } = _ref13;
        return value;
    },
    resolveAlgoliaQuery (_ref14) {
        let { params: params, filters: filters } = _ref14;
        return filters.get('marketingLabel').reduce((p, c)=>p.addDisjunctiveFacetRefinement((0, $fMsDx.default).getIn([
                'marketingLabels',
                'algoliaFacetKey'
            ]), c), params);
    }
});
const $b5fd04e2494471c1$var$sortFilter = ()=>(0, $g5DHJ.Map)({
        key: 'sort',
        facet: true,
        label: 'Sort By',
        sidebarLabel: 'Sort By',
        topBarLabel: 'Sort',
        displayInCurrent: false,
        type: (0, $lwEMm.CONJUNCTIVE_FACET_TYPE),
        primary: true,
        custom: true,
        nonRetrievableAttribute: true,
        useDropDownComponentForSidebar: true,
        resolveAlgoliaQuery (_ref15) {
            let { params: params, sort: sort } = _ref15;
            const applyOverrides = sort && sort.get('applyOverrides') || ((q)=>q);
            return applyOverrides(params);
        },
        customFilters: (0, $9LwYq.sortOptions).reduce((acc, so)=>acc.set(so.get('key'), (0, $g5DHJ.Map)({
                value: so.get('key'),
                label: so.get('label')
            })), (0, $g5DHJ.OrderedMap)())
    });
const $b5fd04e2494471c1$export$1933a9fe712fc1fd = function getFilters() {
    let Config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        featureFlags: {}
    };
    const { featureFlags: featureFlags = {} } = Config;
    return (0, $g5DHJ.List)([
        $b5fd04e2494471c1$var$ecosystemCloudAppsFilter(),
        $b5fd04e2494471c1$var$productFilter({
            featureFlags: featureFlags
        }),
        $b5fd04e2494471c1$var$hostingFilter(),
        $b5fd04e2494471c1$var$sortFilter(),
        $b5fd04e2494471c1$var$moreFiltersFilter(),
        $b5fd04e2494471c1$var$categoryFilter(),
        $b5fd04e2494471c1$var$queryFilter,
        $b5fd04e2494471c1$var$marketingLabel
    ]).reduce((acc, f)=>acc.set(f.get('key'), f), (0, $g5DHJ.Map)());
};
const $b5fd04e2494471c1$export$fa7a9d830f6dbd45 = function getTabletMobileFilters() {
    let Config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        featureFlags: {}
    };
    const { featureFlags: featureFlags = {} } = Config;
    return (0, $g5DHJ.List)([
        $b5fd04e2494471c1$var$ecosystemCloudAppsFilter(),
        $b5fd04e2494471c1$var$sortFilter(),
        $b5fd04e2494471c1$var$productFilter({
            featureFlags: featureFlags
        }),
        $b5fd04e2494471c1$var$hostingFilter(),
        $b5fd04e2494471c1$var$categoryFilter(),
        $b5fd04e2494471c1$var$moreFiltersFilter(),
        $b5fd04e2494471c1$var$queryFilter,
        $b5fd04e2494471c1$var$marketingLabel
    ]).reduce((acc, f)=>acc.set(f.get('key'), f), (0, $g5DHJ.Map)());
};

});
parcelRegister("kafab", function(module, exports) {

$parcel$export(module.exports, "AppDeployment", () => $eae080eae4c0a874$export$2e70d094723cb405);
$parcel$export(module.exports, "CloudFortifiedStatusValues", () => $eae080eae4c0a874$export$bd6703b2aeee9fc9);
$parcel$export(module.exports, "BugBountyStatusValues", () => $eae080eae4c0a874$export$8091ba0174454217);
$parcel$export(module.exports, "CompatibleProductTypeValues", () => $eae080eae4c0a874$export$ef4576ddc4afe7f4);
$parcel$export(module.exports, "AppMarketingLabel", () => $eae080eae4c0a874$export$631cc0d39f36372a);
const $eae080eae4c0a874$var$CONNECT_DEPLOYMENT = 'MarketplaceConnectAppDeployment';
const $eae080eae4c0a874$var$ECOSYSTEM_CLOUD_DEPLOYMENT = 'MarketplaceCloudAppDeployment';
const $eae080eae4c0a874$var$INSTRUCTIONAL_DEPLOYMENT = 'MarketplaceInstructionalAppDeployment';
const $eae080eae4c0a874$var$PLUGINS1_DEPLOYMENT = 'MarketplacePlugins1AppDeployment';
const $eae080eae4c0a874$var$PLUGINS2_DEPLOYMENT = 'MarketplacePlugins2AppDeployment';
const $eae080eae4c0a874$var$WORKFLOW_DEPLOYMENT = 'MarketplaceWorkflowAppDeployment';
const $eae080eae4c0a874$export$2e70d094723cb405 = Object.freeze({
    CONNECT: $eae080eae4c0a874$var$CONNECT_DEPLOYMENT,
    ECOSYSTEM_CLOUD: $eae080eae4c0a874$var$ECOSYSTEM_CLOUD_DEPLOYMENT,
    INSTRUCTIONAL: $eae080eae4c0a874$var$INSTRUCTIONAL_DEPLOYMENT,
    PLUGINS1: $eae080eae4c0a874$var$PLUGINS1_DEPLOYMENT,
    PLUGINS2: $eae080eae4c0a874$var$PLUGINS2_DEPLOYMENT,
    WORKFLOW: $eae080eae4c0a874$var$WORKFLOW_DEPLOYMENT
});
const $eae080eae4c0a874$export$bd6703b2aeee9fc9 = Object.freeze({
    Approved: 'approved',
    Rejected: 'rejected'
});
const $eae080eae4c0a874$export$8091ba0174454217 = Object.freeze({
    Approved: 'approved',
    Rejected: 'rejected'
});
const $eae080eae4c0a874$export$ef4576ddc4afe7f4 = Object.freeze({
    CLOUD_PRODUCT: 'CompatibleAtlassianCloudProduct',
    SERVER_PRODUCT: 'CompatibleAtlassianServerProduct',
    DATACENTER_PRODUCT: 'CompatibleAtlassianDataCenterProduct'
});
const $eae080eae4c0a874$export$631cc0d39f36372a = Object.freeze({
    CompatibleWithJSM: 'jira-servicedesk',
    CompatibleWithJSW: 'jira-software'
});

});

const $8749bcdb7e4afe9a$export$7fc2afdd98086cb1 = 'server';
const $8749bcdb7e4afe9a$export$428c0af80a7329cd = 'cloud';
const $8749bcdb7e4afe9a$export$35e53a8bdbe06647 = 'dataCenter';

var $122620c1047e308e$exports = {};

$parcel$export($122620c1047e308e$exports, "JIRA", () => $122620c1047e308e$export$c1fabc4e59d98025);
$parcel$export($122620c1047e308e$exports, "JIRA_SERVICE_DESK", () => $122620c1047e308e$export$3afc372bb8c4538c);
$parcel$export($122620c1047e308e$exports, "CONFLUENCE", () => $122620c1047e308e$export$c811f21c9ad05dc2);
$parcel$export($122620c1047e308e$exports, "HIPCHAT", () => $122620c1047e308e$export$77363fc37d01ae41);
$parcel$export($122620c1047e308e$exports, "BITBUCKET", () => $122620c1047e308e$export$59864d7602eb300a);
$parcel$export($122620c1047e308e$exports, "FECRU", () => $122620c1047e308e$export$e95554a59f3e0c28);
$parcel$export($122620c1047e308e$exports, "BAMBOO", () => $122620c1047e308e$export$1876370d95915b3b);
$parcel$export($122620c1047e308e$exports, "CROWD", () => $122620c1047e308e$export$6bc23744ed8b8097);
$parcel$export($122620c1047e308e$exports, "COMPASS", () => $122620c1047e308e$export$d5e9b613bc4c47f);
const $122620c1047e308e$export$c1fabc4e59d98025 = 'jira';
const $122620c1047e308e$export$3afc372bb8c4538c = 'jsd';
const $122620c1047e308e$export$c811f21c9ad05dc2 = 'confluence';
const $122620c1047e308e$export$77363fc37d01ae41 = 'hipchat';
const $122620c1047e308e$export$59864d7602eb300a = 'bitbucket';
const $122620c1047e308e$export$e95554a59f3e0c28 = 'fecru';
const $122620c1047e308e$export$1876370d95915b3b = 'bamboo';
const $122620c1047e308e$export$6bc23744ed8b8097 = 'crowd';
const $122620c1047e308e$export$d5e9b613bc4c47f = 'compass';

parcelRegister("io1ow", function(module, exports) {

$parcel$export(module.exports, "default", () => $d62b8ccdcf201916$export$2e2bcd8739ae039);
var $d62b8ccdcf201916$export$2e2bcd8739ae039 = {
    sortedByUsage: [
        'Project management',
        'Time tracking',
        'Charts & diagramming',
        'IT & helpdesk',
        'Reports',
        'Workflow',
        'Monitoring',
        'Testing & QA',
        'Document management',
        'Custom fields',
        'Messaging',
        'Integrations',
        'Admin tools',
        'Continuous integration',
        'Dashboard gadgets',
        'Utilities',
        'Tasks',
        'Mobile',
        'Security',
        'Themes & styles',
        'CRM',
        'Blueprints',
        'Design tools',
        'Documentation',
        'Email',
        'Code review',
        'Macros',
        'Source code',
        'Code quality',
        'Deployments',
        'Dependency management',
        'Repository connectors',
        'Build management',
        'Shared workflows',
        'Repository hooks',
        'Language packs'
    ]
};

});

parcelRegister("9LwYq", function(module, exports) {

$parcel$export(module.exports, "sortOptions", () => $71c214b547f03e4a$export$2ecc3309bc48a1e0);

var $g5DHJ = parcelRequire("g5DHJ");



var $fMsDx = parcelRequire("fMsDx");
const $71c214b547f03e4a$export$2ecc3309bc48a1e0 = (0, $g5DHJ.List)([
    (0, $g5DHJ.Map)({
        key: 'topRated',
        label: 'Top rated',
        title: 'Top-rated',
        indexSuffix: ()=>{
            return 'desc_ratings.ratingsScore';
        }
    }),
    (0, $g5DHJ.Map)({
        key: 'trending',
        label: 'Top trending',
        title: 'Trending',
        indexSuffix: ()=>{
            return 'desc_distribution.deltaInstalls';
        },
        applyOverrides: (query)=>query.addFacetRefinement((0, $fMsDx.default).getIn([
                'isAtlassian',
                'algoliaFacetKey'
            ]), 'false')
    }),
    (0, $g5DHJ.Map)({
        key: 'topSelling',
        label: 'Top selling',
        title: 'Top-selling',
        indexSuffix: (_ref)=>{
            let { filters: filters } = _ref;
            switch(filters.get('hosting')){
                case 0, $8749bcdb7e4afe9a$export$428c0af80a7329cd:
                    return 'desc_sales.recentGrossCloud';
                case 0, $8749bcdb7e4afe9a$export$7fc2afdd98086cb1:
                    return 'desc_sales.recentGrossServer';
                case 0, $8749bcdb7e4afe9a$export$35e53a8bdbe06647:
                    return 'desc_sales.recentGrossServer';
                default:
                    return 'desc_sales.recentGrossTotal';
            }
        },
        applyOverrides: (query)=>query.addFacetRefinement((0, $fMsDx.default).getIn([
                'isAtlassian',
                'algoliaFacetKey'
            ]), 'false').addDisjunctiveFacetRefinement((0, $fMsDx.default).getIn([
                'marketplaceType',
                'algoliaFacetKey'
            ]), (0, $ad0fdcf1dd8b1c21$export$820680178c2de888))
    }),
    (0, $g5DHJ.Map)({
        key: 'newest',
        label: 'Newest',
        title: 'Newest',
        indexSuffix: ()=>{
            return 'desc_releaseDate';
        }
    })
]).reduce((acc, s)=>acc.set(s.get('key'), s), (0, $g5DHJ.OrderedMap)());

});
const $ad0fdcf1dd8b1c21$export$820680178c2de888 = 'Paid via Atlassian';
const $ad0fdcf1dd8b1c21$export$694bcde6b7d89a08 = 'Paid via Vendor';
const $ad0fdcf1dd8b1c21$export$f6a4630f2b8ac290 = 'Free';



parcelRegister("b5Eig", function(module, exports) {

$parcel$export(module.exports, "default", () => $812f6ac9b2b15b51$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SearchParamsUpdatePropType", () => $812f6ac9b2b15b51$export$851407edb471805);

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");
class $812f6ac9b2b15b51$export$2e2bcd8739ae039 extends (0, $g5DHJ.Record)({
    /**
   * Set[FacetType]
   */ types: undefined,
    /**
   * params => params
   */ apply: undefined
}) {
    compose(spu2) {
        return new $812f6ac9b2b15b51$export$2e2bcd8739ae039({
            types: this.types.concat(spu2.types),
            apply: (params)=>spu2.apply(this.apply(params))
        });
    }
    copy(_ref) {
        let { types: types, apply: apply } = _ref;
        return new $812f6ac9b2b15b51$export$2e2bcd8739ae039({
            types: types || this.types,
            apply: apply || this.apply
        });
    }
    /**
   * @param f : params => params
   * @return {SearchParamsUpdate}
   */ composeApply(f) {
        return new $812f6ac9b2b15b51$export$2e2bcd8739ae039({
            types: this.types,
            apply: (params)=>f(this.apply(params))
        });
    }
    static default_() {
        return new $812f6ac9b2b15b51$export$2e2bcd8739ae039({
            types: (0, $g5DHJ.Set)(),
            apply: (q)=>q
        });
    }
}
const $812f6ac9b2b15b51$export$851407edb471805 = (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).instanceOf($812f6ac9b2b15b51$export$2e2bcd8739ae039);

});

parcelRegister("bavaN", function(module, exports) {

$parcel$export(module.exports, "search", () => $8218cf38b62bc272$export$d76128d007d19019);
$parcel$export(module.exports, "getAppDetailsByAppKeys", () => $8218cf38b62bc272$export$3a72445f5cc3c98d);
$parcel$export(module.exports, "searchParamsUpdateForAddonKeys", () => $8218cf38b62bc272$export$bbe41be4aeb45c0e);

var $kPJQm = parcelRequire("kPJQm");

var $7TFuJ = parcelRequire("7TFuJ");

var $g5DHJ = parcelRequire("g5DHJ");

var $lwEMm = parcelRequire("lwEMm");

var $b5Eig = parcelRequire("b5Eig");

var $8HDz3 = parcelRequire("8HDz3");

var $72e1Y = parcelRequire("72e1Y");

var $7Qfm4 = parcelRequire("7Qfm4");

var $dbmA1 = parcelRequire("dbmA1");

var $aViHK = parcelRequire("aViHK");
function $8218cf38b62bc272$export$d76128d007d19019(_ref) {
    let { algoliaClient: algoliaClient, environment: environment, filters: filters, numHits: numHits, page: page, applyOverrides: applyOverrides, resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides, featureFlags: featureFlags = {} } = _ref;
    const enhancedFilters = (0, $72e1Y.default)(filters, featureFlags);
    const sort = (0, $aViHK.resolveSortFromFilters)({
        filters: enhancedFilters
    });
    const { enableV2SearchIndex: enableV2SearchIndex } = featureFlags;
    const searchIndexToUse = (0, $dbmA1.resolveSearchIndex)({
        environment: environment,
        filters: filters,
        sort: sort,
        enableV2SearchIndex: enableV2SearchIndex
    });
    const searchParameters = (0, $7Qfm4.default)({
        applyOverrides: applyOverrides,
        filters: enhancedFilters,
        index: searchIndexToUse,
        numHits: numHits,
        page: page,
        sort: sort,
        resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides,
        featureFlags: featureFlags
    });
    return $8218cf38b62bc272$var$doSearch({
        algoliaClient: algoliaClient,
        filters: filters,
        index: searchIndexToUse,
        searchParameters: searchParameters,
        featureFlags: featureFlags
    });
}
function $8218cf38b62bc272$export$3a72445f5cc3c98d(algoliaClient, environment, appKeys) {
    const searchIndexToUse = (0, $dbmA1.resolveSearchIndex)({
        environment: environment
    });
    const searchParameters = {
        facetFilters: [
            appKeys.map((addonKey)=>"addonKey:".concat(addonKey))
        ]
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($7TFuJ)))(algoliaClient, searchIndexToUse, {
        hitsPerPage: appKeys.length
    }).searchOnce(searchParameters);
}
function $8218cf38b62bc272$var$doSearch(_ref2) {
    let { algoliaClient: algoliaClient, filters: filters, index: index, searchParameters: searchParameters, featureFlags: featureFlags } = _ref2;
    return new Promise((resolve, reject)=>{
        // This random request id is added to track algolia requests to debug issues faced while upgrading
        // algoliasearch from version 3.35.1 -> 4.19.1 https://ecosystem.atlassian.net/browse/MC-3539
        algoliaClient.setExtraHeader('x-request-id', (0, $kPJQm.generateRequestId)());
        (0, (/*@__PURE__*/$parcel$interopDefault($7TFuJ)))(algoliaClient, index).searchOnce(searchParameters).then((_ref3)=>{
            let { content: content } = _ref3;
            resolve((0, $g5DHJ.Map)({
                facets: (0, $8HDz3.resolveFacets)({
                    facets: (0, $g5DHJ.fromJS)(content.facets).concat((0, $g5DHJ.fromJS)(content.disjunctiveFacets)),
                    filters: filters,
                    featureFlags: featureFlags
                }),
                searchResults: (0, $8HDz3.resolveSearchResults)({
                    hits: (0, $g5DHJ.fromJS)(content.hits),
                    page: content.page,
                    numberOfHits: content.nbHits,
                    numberOfPages: content.nbPages
                })
            }));
        }, (error)=>{
            reject(error.name === 'AlgoliaSearchJSONPScriptErrorError' ? {
                message: 'Connection error'
            } : error);
        });
    });
}
function $8218cf38b62bc272$export$bbe41be4aeb45c0e(addonKeys) {
    return new (0, $b5Eig.default)({
        types: (0, $g5DHJ.Set)([
            (0, $lwEMm.default).disjunctive('addonKey')
        ]),
        apply: (params)=>addonKeys.reduce((finalParams, key)=>finalParams.addDisjunctiveFacetRefinement('addonKey', key), params)
    });
}
function $8218cf38b62bc272$export$af4868b408661b46(addonKeys) {
    return new (0, $b5Eig.default)({
        types: (0, $g5DHJ.Set)([
            (0, $lwEMm.default).conjunctive('addonKey')
        ]),
        apply: (params)=>addonKeys.reduce((finalParams, key)=>finalParams.addExcludeRefinement('addonKey', key), params)
    });
}

});
parcelRegister("kPJQm", function(module, exports) {

$parcel$export(module.exports, "generateRequestId", () => $f2ac219f1a32cffd$export$adb840ec535541d1);

var $xL0Mh = parcelRequire("xL0Mh");
const $f2ac219f1a32cffd$export$adb840ec535541d1 = ()=>{
    return (0, $xL0Mh.default)();
};

});
parcelRegister("xL0Mh", function(module, exports) {

$parcel$export(module.exports, "default", () => $06578cb21acca6fd$export$2e2bcd8739ae039);

var $hDwuw = parcelRequire("hDwuw");

var $HdBQi = parcelRequire("HdBQi");

var $li8Mb = parcelRequire("li8Mb");
function $06578cb21acca6fd$var$v4(options, buf, offset) {
    if ((0, $hDwuw.default).randomUUID && !buf && !options) return (0, $hDwuw.default).randomUUID();
    options = options || {};
    const rnds = options.random || (options.rng || (0, $HdBQi.default))(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided
    if (buf) {
        offset = offset || 0;
        for(let i = 0; i < 16; ++i)buf[offset + i] = rnds[i];
        return buf;
    }
    return (0, $li8Mb.unsafeStringify)(rnds);
}
var $06578cb21acca6fd$export$2e2bcd8739ae039 = $06578cb21acca6fd$var$v4;

});
parcelRegister("hDwuw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd6f48419f6a0d5c$export$2e2bcd8739ae039);
const $cd6f48419f6a0d5c$var$randomUUID = typeof crypto !== 'undefined' && crypto.randomUUID && crypto.randomUUID.bind(crypto);
var $cd6f48419f6a0d5c$export$2e2bcd8739ae039 = {
    randomUUID: $cd6f48419f6a0d5c$var$randomUUID
};

});

parcelRegister("HdBQi", function(module, exports) {

$parcel$export(module.exports, "default", () => $081e92cd8e858721$export$2e2bcd8739ae039);
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
let $081e92cd8e858721$var$getRandomValues;
const $081e92cd8e858721$var$rnds8 = new Uint8Array(16);
function $081e92cd8e858721$export$2e2bcd8739ae039() {
    // lazy load so that environments that need to polyfill have a chance to do so
    if (!$081e92cd8e858721$var$getRandomValues) {
        // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation.
        $081e92cd8e858721$var$getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto);
        if (!$081e92cd8e858721$var$getRandomValues) throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
    return $081e92cd8e858721$var$getRandomValues($081e92cd8e858721$var$rnds8);
}

});

parcelRegister("li8Mb", function(module, exports) {

$parcel$export(module.exports, "unsafeStringify", () => $f802162c6c4c14f9$export$8fb373d660548968);

var $3s81w = parcelRequire("3s81w");
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ const $f802162c6c4c14f9$var$byteToHex = [];
for(let i = 0; i < 256; ++i)$f802162c6c4c14f9$var$byteToHex.push((i + 0x100).toString(16).slice(1));
function $f802162c6c4c14f9$export$8fb373d660548968(arr, offset = 0) {
    // Note: Be careful editing this code!  It's been tuned for performance
    // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
    return $f802162c6c4c14f9$var$byteToHex[arr[offset + 0]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 1]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 2]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 3]] + '-' + $f802162c6c4c14f9$var$byteToHex[arr[offset + 4]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 5]] + '-' + $f802162c6c4c14f9$var$byteToHex[arr[offset + 6]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 7]] + '-' + $f802162c6c4c14f9$var$byteToHex[arr[offset + 8]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 9]] + '-' + $f802162c6c4c14f9$var$byteToHex[arr[offset + 10]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 11]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 12]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 13]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 14]] + $f802162c6c4c14f9$var$byteToHex[arr[offset + 15]];
}
function $f802162c6c4c14f9$var$stringify(arr, offset = 0) {
    const uuid = $f802162c6c4c14f9$export$8fb373d660548968(arr, offset); // Consistency check for valid UUID.  If this throws, it's likely due to one
    // of the following:
    // - One or more input array values don't map to a hex octet (leading to
    // "undefined" in the uuid)
    // - Invalid input values for the RFC `version` or `variant` fields
    if (!(0, $3s81w.default)(uuid)) throw TypeError('Stringified UUID is invalid');
    return uuid;
}
var $f802162c6c4c14f9$export$2e2bcd8739ae039 = $f802162c6c4c14f9$var$stringify;

});
parcelRegister("3s81w", function(module, exports) {

$parcel$export(module.exports, "default", () => $283a35f0440388bc$export$2e2bcd8739ae039);

var $k3dlA = parcelRequire("k3dlA");
function $283a35f0440388bc$var$validate(uuid) {
    return typeof uuid === 'string' && (0, $k3dlA.default).test(uuid);
}
var $283a35f0440388bc$export$2e2bcd8739ae039 = $283a35f0440388bc$var$validate;

});
parcelRegister("k3dlA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e98e70ee3642a85d$export$2e2bcd8739ae039);
var $e98e70ee3642a85d$export$2e2bcd8739ae039 = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

});





parcelRegister("7TFuJ", function(module, exports) {
'use strict';

var $9stTq = parcelRequire("9stTq");

var $ltsLR = parcelRequire("ltsLR");

var $dBe1E = parcelRequire("dBe1E");
/**
 * The algoliasearchHelper module is the function that will let its
 * contains everything needed to use the Algoliasearch
 * Helper. It is a also a function that instanciate the helper.
 * To use the helper, you also need the Algolia JS client v3.
 * @example
 * //using the UMD build
 * var client = algoliasearch('latency', '6be0576ff61c053d5f9a3225e2a90f76');
 * var helper = algoliasearchHelper(client, 'bestbuy', {
 *   facets: ['shipping'],
 *   disjunctiveFacets: ['category']
 * });
 * helper.on('result', function(event) {
 *   console.log(event.results);
 * });
 * helper
 *   .toggleFacetRefinement('category', 'Movies & TV Shows')
 *   .toggleFacetRefinement('shipping', 'Free shipping')
 *   .search();
 * @example
 * // The helper is an event emitter using the node API
 * helper.on('result', updateTheResults);
 * helper.once('result', updateTheResults);
 * helper.removeListener('result', updateTheResults);
 * helper.removeAllListeners('result');
 * @module algoliasearchHelper
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the name of the index to query
 * @param  {SearchParameters|object} opts an object defining the initial config of the search. It doesn't have to be a {SearchParameters}, just an object containing the properties you need from it.
 * @return {AlgoliaSearchHelper} The helper instance
 */ function $5bfddb6cbac80ba9$var$algoliasearchHelper(client, index, opts) {
    return new $9stTq(client, index, opts);
}

/**
 * The version currently used
 * @member module:algoliasearchHelper.version
 * @type {number}
 */ $5bfddb6cbac80ba9$var$algoliasearchHelper.version = (parcelRequire("2s3Na"));
/**
 * Constructor for the Helper.
 * @member module:algoliasearchHelper.AlgoliaSearchHelper
 * @type {AlgoliaSearchHelper}
 */ $5bfddb6cbac80ba9$var$algoliasearchHelper.AlgoliaSearchHelper = $9stTq;
/**
 * Constructor for the object containing all the parameters of the search.
 * @member module:algoliasearchHelper.SearchParameters
 * @type {SearchParameters}
 */ $5bfddb6cbac80ba9$var$algoliasearchHelper.SearchParameters = $ltsLR;
/**
 * Constructor for the object containing the results of the search.
 * @member module:algoliasearchHelper.SearchResults
 * @type {SearchResults}
 */ $5bfddb6cbac80ba9$var$algoliasearchHelper.SearchResults = $dBe1E;
module.exports = $5bfddb6cbac80ba9$var$algoliasearchHelper;

});
parcelRegister("9stTq", function(module, exports) {
'use strict';

var $90FFK = parcelRequire("90FFK");

var $9SPXt = parcelRequire("9SPXt");

var $iOTWh = parcelRequire("iOTWh");
var $6e2deaae49fcf720$require$escapeFacetValue = $iOTWh.escapeFacetValue;

var $gVBvC = parcelRequire("gVBvC");

var $2KSyk = parcelRequire("2KSyk");

var $6Wgxo = parcelRequire("6Wgxo");

var $ka9BV = parcelRequire("ka9BV");

var $5BVQk = parcelRequire("5BVQk");

var $ltsLR = parcelRequire("ltsLR");

var $dBe1E = parcelRequire("dBe1E");

var $2s3Na = parcelRequire("2s3Na");
/**
 * Event triggered when a parameter is set or updated
 * @event AlgoliaSearchHelper#event:change
 * @property {object} event
 * @property {SearchParameters} event.state the current parameters with the latest changes applied
 * @property {SearchResults} event.results the previous results received from Algolia. `null` before the first request
 * @example
 * helper.on('change', function(event) {
 *   console.log('The parameters have changed');
 * });
 */ /**
 * Event triggered when a main search is sent to Algolia
 * @event AlgoliaSearchHelper#event:search
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search
 * @property {SearchResults} event.results the results from the previous search. `null` if it is the first search.
 * @example
 * helper.on('search', function(event) {
 *   console.log('Search sent');
 * });
 */ /**
 * Event triggered when a search using `searchForFacetValues` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchForFacetValues
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @property {string} event.facet the facet searched into
 * @property {string} event.query the query used to search in the facets
 * @example
 * helper.on('searchForFacetValues', function(event) {
 *   console.log('searchForFacetValues sent');
 * });
 */ /**
 * Event triggered when a search using `searchOnce` is sent to Algolia
 * @event AlgoliaSearchHelper#event:searchOnce
 * @property {object} event
 * @property {SearchParameters} event.state the parameters used for this search it is the first search.
 * @example
 * helper.on('searchOnce', function(event) {
 *   console.log('searchOnce sent');
 * });
 */ /**
 * Event triggered when the results are retrieved from Algolia
 * @event AlgoliaSearchHelper#event:result
 * @property {object} event
 * @property {SearchResults} event.results the results received from Algolia
 * @property {SearchParameters} event.state the parameters used to query Algolia. Those might be different from the one in the helper instance (for example if the network is unreliable).
 * @example
 * helper.on('result', function(event) {
 *   console.log('Search results received');
 * });
 */ /**
 * Event triggered when Algolia sends back an error. For example, if an unknown parameter is
 * used, the error can be caught using this event.
 * @event AlgoliaSearchHelper#event:error
 * @property {object} event
 * @property {Error} event.error the error returned by the Algolia.
 * @example
 * helper.on('error', function(event) {
 *   console.log('Houston we got a problem.');
 * });
 */ /**
 * Event triggered when the queue of queries have been depleted (with any result or outdated queries)
 * @event AlgoliaSearchHelper#event:searchQueueEmpty
 * @example
 * helper.on('searchQueueEmpty', function() {
 *   console.log('No more search pending');
 *   // This is received before the result event if we're not expecting new results
 * });
 *
 * helper.search();
 */ /**
 * Initialize a new AlgoliaSearchHelper
 * @class
 * @classdesc The AlgoliaSearchHelper is a class that ease the management of the
 * search. It provides an event based interface for search callbacks:
 *  - change: when the internal search state is changed.
 *    This event contains a {@link SearchParameters} object and the
 *    {@link SearchResults} of the last result if any.
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 *  - error: when the response is an error. This event contains the error returned by the server.
 * @param  {AlgoliaSearch} client an AlgoliaSearch client
 * @param  {string} index the index name to query
 * @param  {SearchParameters | object} options an object defining the initial
 * config of the search. It doesn't have to be a {SearchParameters},
 * just an object containing the properties you need from it.
 */ function $6e2deaae49fcf720$var$AlgoliaSearchHelper(client, index, options) {
    if (typeof client.addAlgoliaAgent === 'function') client.addAlgoliaAgent('JS Helper (' + $2s3Na + ')');
    this.setClient(client);
    var opts = options || {};
    opts.index = index;
    this.state = $ltsLR.make(opts);
    this.lastResults = null;
    this._queryId = 0;
    this._lastQueryIdReceived = -1;
    this.derivedHelpers = [];
    this._currentNbQueries = 0;
}
$gVBvC($6e2deaae49fcf720$var$AlgoliaSearchHelper, $90FFK);
/**
 * Start the search with the parameters set in the state. When the
 * method is called, it triggers a `search` event. The results will
 * be available through the `result` event. If an error occurs, an
 * `error` will be fired instead.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires search
 * @fires result
 * @fires error
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.search = function() {
    this._search({
        onlyWithDerivedHelpers: false
    });
    return this;
};
$6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.searchOnlyWithDerivedHelpers = function() {
    this._search({
        onlyWithDerivedHelpers: true
    });
    return this;
};
/**
 * Gets the search query parameters that would be sent to the Algolia Client
 * for the hits
 * @return {object} Query Parameters
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getQuery = function() {
    var state = this.state;
    return $5BVQk._getHitsSearchParams(state);
};
/**
 * Start a search using a modified version of the current state. This method does
 * not trigger the helper lifecycle and does not modify the state kept internally
 * by the helper. This second aspect means that the next search call will be the
 * same as a search call before calling searchOnce.
 * @param {object} options can contain all the parameters that can be set to SearchParameters
 * plus the index
 * @param {function} [cb] optional callback executed when the response from the
 * server is back.
 * @return {promise|undefined} if a callback is passed the method returns undefined
 * otherwise it returns a promise containing an object with two keys :
 *  - content with a SearchResults
 *  - state with the state used for the query as a SearchParameters
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the callback API
 * var state = helper.searchOnce({hitsPerPage: 1},
 *   function(error, content, state) {
 *     // if an error occurred it will be passed in error, otherwise its value is null
 *     // content contains the results formatted as a SearchResults
 *     // state is the instance of SearchParameters used for this search
 *   });
 * @example
 * // Changing the number of records returned per page to 1
 * // This example uses the promise API
 * var state1 = helper.searchOnce({hitsPerPage: 1})
 *                 .then(promiseHandler);
 *
 * function promiseHandler(res) {
 *   // res contains
 *   // {
 *   //   content : SearchResults
 *   //   state   : SearchParameters (the one used for this specific search)
 *   // }
 * }
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.searchOnce = function(options, cb) {
    var tempState = !options ? this.state : this.state.setQueryParameters(options);
    var queries = $5BVQk._getQueries(tempState.index, tempState);
    // eslint-disable-next-line consistent-this
    var self = this;
    this._currentNbQueries++;
    this.emit('searchOnce', {
        state: tempState
    });
    if (cb) {
        this.client.search(queries).then(function(content) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
            cb(null, new $dBe1E(tempState, content.results), tempState);
        }).catch(function(err) {
            self._currentNbQueries--;
            if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
            cb(err, null, tempState);
        });
        return undefined;
    }
    return this.client.search(queries).then(function(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        return {
            content: new $dBe1E(tempState, content.results),
            state: tempState,
            _originalResponse: content
        };
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Start the search for answers with the parameters set in the state.
 * This method returns a promise.
 * @param {Object} options - the options for answers API call
 * @param {string[]} options.attributesForPrediction - Attributes to use for predictions. If empty, `searchableAttributes` is used instead.
 * @param {string[]} options.queryLanguages - The languages in the query. Currently only supports ['en'].
 * @param {number} options.nbHits - Maximum number of answers to retrieve from the Answers Engine. Cannot be greater than 1000.
 *
 * @return {promise} the answer results
 * @deprecated answers is deprecated and will be replaced with new initiatives
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.findAnswers = function(options) {
    // eslint-disable-next-line no-console
    console.warn('[algoliasearch-helper] answers is no longer supported');
    var state = this.state;
    var derivedHelper = this.derivedHelpers[0];
    if (!derivedHelper) return Promise.resolve([]);
    var derivedState = derivedHelper.getModifiedState(state);
    var data = $2KSyk({
        attributesForPrediction: options.attributesForPrediction,
        nbHits: options.nbHits
    }, {
        params: $ka9BV($5BVQk._getHitsSearchParams(derivedState), [
            'attributesToSnippet',
            'hitsPerPage',
            'restrictSearchableAttributes',
            'snippetEllipsisText'
        ])
    });
    var errorMessage = 'search for answers was called, but this client does not have a function client.initIndex(index).findAnswers';
    if (typeof this.client.initIndex !== 'function') throw new Error(errorMessage);
    var index = this.client.initIndex(derivedState.index);
    if (typeof index.findAnswers !== 'function') throw new Error(errorMessage);
    return index.findAnswers(derivedState.query, options.queryLanguages, data);
};
/**
 * Structure of each result when using
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * @typedef FacetSearchHit
 * @type {object}
 * @property {string} value the facet value
 * @property {string} highlighted the facet value highlighted with the query string
 * @property {number} count number of occurrence of this facet value
 * @property {boolean} isRefined true if the value is already refined
 */ /**
 * Structure of the data resolved by the
 * [`searchForFacetValues()`](reference.html#AlgoliaSearchHelper#searchForFacetValues)
 * promise.
 * @typedef FacetSearchResult
 * @type {object}
 * @property {FacetSearchHit} facetHits the results for this search for facet values
 * @property {number} processingTimeMS time taken by the query inside the engine
 */ /**
 * Search for facet values based on an query and the name of a faceted attribute. This
 * triggers a search and will return a promise. On top of using the query, it also sends
 * the parameters from the state so that the search is narrowed down to only the possible values.
 *
 * See the description of [FacetSearchResult](reference.html#FacetSearchResult)
 * @param {string} facet the name of the faceted attribute
 * @param {string} query the string query for the search
 * @param {number} [maxFacetHits] the maximum number values returned. Should be > 0 and <= 100
 * @param {object} [userState] the set of custom parameters to use on top of the current state. Setting a property to `undefined` removes
 * it in the generated query.
 * @return {promise.<FacetSearchResult>} the results of the search
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.searchForFacetValues = function(facet, query, maxFacetHits, userState) {
    var clientHasSFFV = typeof this.client.searchForFacetValues === 'function';
    var clientHasInitIndex = typeof this.client.initIndex === 'function';
    if (!clientHasSFFV && !clientHasInitIndex && typeof this.client.search !== 'function') throw new Error('search for facet values (searchable) was called, but this client does not have a function client.searchForFacetValues or client.initIndex(index).searchForFacetValues');
    var state = this.state.setQueryParameters(userState || {});
    var isDisjunctive = state.isDisjunctiveFacet(facet);
    var algoliaQuery = $5BVQk.getSearchForFacetQuery(facet, query, maxFacetHits, state);
    this._currentNbQueries++;
    // eslint-disable-next-line consistent-this
    var self = this;
    var searchForFacetValuesPromise;
    // newer algoliasearch ^3.27.1 - ~4.0.0
    if (clientHasSFFV) searchForFacetValuesPromise = this.client.searchForFacetValues([
        {
            indexName: state.index,
            params: algoliaQuery
        }
    ]);
    else if (clientHasInitIndex) searchForFacetValuesPromise = this.client.initIndex(state.index).searchForFacetValues(algoliaQuery);
    else {
        // @MAJOR only use client.search
        delete algoliaQuery.facetName;
        searchForFacetValuesPromise = this.client.search([
            {
                type: 'facet',
                facet: facet,
                indexName: state.index,
                params: algoliaQuery
            }
        ]).then(function processResponse(response) {
            return response.results[0];
        });
    }
    this.emit('searchForFacetValues', {
        state: state,
        facet: facet,
        query: query
    });
    return searchForFacetValuesPromise.then(function addIsRefined(content) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        content = Array.isArray(content) ? content[0] : content;
        content.facetHits.forEach(function(f) {
            f.escapedValue = $6e2deaae49fcf720$require$escapeFacetValue(f.value);
            f.isRefined = isDisjunctive ? state.isDisjunctiveFacetRefined(facet, f.escapedValue) : state.isFacetRefined(facet, f.escapedValue);
        });
        return content;
    }, function(e) {
        self._currentNbQueries--;
        if (self._currentNbQueries === 0) self.emit('searchQueueEmpty');
        throw e;
    });
};
/**
 * Sets the text query used for the search.
 *
 * This method resets the current page to 0.
 * @param  {string} q the user query
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.setQuery = function(q) {
    this._change({
        state: this.state.resetPage().setQuery(q),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the types of refinements except tags. A string can be provided to remove
 * only the refinements of a specific attribute. For more advanced use case, you can
 * provide a function instead. This function should follow the
 * [clearCallback definition](#SearchParameters.clearCallback).
 *
 * This method resets the current page to 0.
 * @param {string} [name] optional name of the facet / attribute on which we want to remove all refinements
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * // Removing all the refinements
 * helper.clearRefinements().search();
 * @example
 * // Removing all the filters on a the category attribute.
 * helper.clearRefinements('category').search();
 * @example
 * // Removing only the exclude filters on the category facet.
 * helper.clearRefinements(function(value, attribute, type) {
 *   return type === 'exclude' && attribute === 'category';
 * }).search();
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.clearRefinements = function(name) {
    this._change({
        state: this.state.resetPage().clearRefinements(name),
        isPageReset: true
    });
    return this;
};
/**
 * Remove all the tag filters.
 *
 * This method resets the current page to 0.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.clearTags = function() {
    this._change({
        state: this.state.resetPage().clearTags(),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addDisjunctiveFacetRefinement}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addDisjunctiveRefine = function() {
    return this.addDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Adds a refinement on a hierarchical facet. It will throw
 * an exception if the facet is not defined or if the facet
 * is already refined.
 *
 * This method resets the current page to 0.
 * @param {string} facet the facet name
 * @param {string} path the hierarchical facet path
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is refined
 * @chainable
 * @fires change
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addHierarchicalFacetRefinement = function(facet, path) {
    this._change({
        state: this.state.resetPage().addHierarchicalFacetRefinement(facet, path),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} operator the operator of the filter
 * @param  {number} value the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().addNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Adds a filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().addFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetRefinement}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addRefine = function() {
    return this.addFacetRefinement.apply(this, arguments);
};
/**
 * Adds a an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value (will be converted to string)
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().addExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#addFacetExclusion}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addExclude = function() {
    return this.addFacetExclusion.apply(this, arguments);
};
/**
 * Adds a tag filter with the `tag` provided. If the
 * filter is already set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag the tag to add to the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.addTag = function(tag) {
    this._change({
        state: this.state.resetPage().addTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Removes an numeric filter to an attribute with the `operator` and `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * Some parameters are optional, triggering different behavior:
 *  - if the value is not provided, then all the numeric value will be removed for the
 *  specified attribute/operator couple.
 *  - if the operator is not provided either, then all the numeric filter on this attribute
 *  will be removed.
 *
 * This method resets the current page to 0.
 * @param  {string} attribute the attribute on which the numeric filter applies
 * @param  {string} [operator] the operator of the filter
 * @param  {number} [value] the value of the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeNumericRefinement = function(attribute, operator, value) {
    this._change({
        state: this.state.resetPage().removeNumericRefinement(attribute, operator, value),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a disjunctive filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeDisjunctiveFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeDisjunctiveFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeDisjunctiveFacetRefinement}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeDisjunctiveRefine = function() {
    return this.removeDisjunctiveFacetRefinement.apply(this, arguments);
};
/**
 * Removes the refinement set on a hierarchical facet.
 * @param {string} facet the facet name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error if the facet is not defined or if the facet is not refined
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeHierarchicalFacetRefinement = function(facet) {
    this._change({
        state: this.state.resetPage().removeHierarchicalFacetRefinement(facet),
        isPageReset: true
    });
    return this;
};
/**
 * Removes a filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetRefinement}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeRefine = function() {
    return this.removeFacetRefinement.apply(this, arguments);
};
/**
 * Removes an exclusion filter to a faceted attribute with the `value` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * If the value is omitted, then this method will remove all the filters for the
 * attribute.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} [value] the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().removeExcludeRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#removeFacetExclusion}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeExclude = function() {
    return this.removeFacetExclusion.apply(this, arguments);
};
/**
 * Removes a tag filter with the `tag` provided. If the
 * filter is not set, it doesn't change the filters.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove from the filter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.removeTag = function(tag) {
    this._change({
        state: this.state.resetPage().removeTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Adds or removes an exclusion filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.toggleFacetExclusion = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleExcludeFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetExclusion}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.toggleExclude = function() {
    return this.toggleFacetExclusion.apply(this, arguments);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 * @deprecated since version 2.19.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.toggleRefinement = function(facet, value) {
    return this.toggleFacetRefinement(facet, value);
};
/**
 * Adds or removes a filter to a faceted attribute with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method can be used for conjunctive, disjunctive and hierarchical filters.
 *
 * This method resets the current page to 0.
 * @param  {string} facet the facet to refine
 * @param  {string} value the associated value
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @throws Error will throw an error if the facet is not declared in the settings of the helper
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.toggleFacetRefinement = function(facet, value) {
    this._change({
        state: this.state.resetPage().toggleFacetRefinement(facet, value),
        isPageReset: true
    });
    return this;
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since version 2.4.0, see {@link AlgoliaSearchHelper#toggleFacetRefinement}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.toggleRefine = function() {
    return this.toggleFacetRefinement.apply(this, arguments);
};
/**
 * Adds or removes a tag filter with the `value` provided. If
 * the value is set then it removes it, otherwise it adds the filter.
 *
 * This method resets the current page to 0.
 * @param {string} tag tag to remove or add
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.toggleTag = function(tag) {
    this._change({
        state: this.state.resetPage().toggleTagRefinement(tag),
        isPageReset: true
    });
    return this;
};
/**
 * Increments the page number by one.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setPage(0).nextPage().getPage();
 * // returns 1
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.nextPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page + 1);
};
/**
 * Decrements the page number by one.
 * @fires change
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @example
 * helper.setPage(1).previousPage().getPage();
 * // returns 0
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.previousPage = function() {
    var page = this.state.page || 0;
    return this.setPage(page - 1);
};
/**
 * @private
 * @param {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @chainable
 * @fires change
 */ function $6e2deaae49fcf720$var$setCurrentPage(page) {
    if (page < 0) throw new Error('Page requested below 0.');
    this._change({
        state: this.state.setPage(page),
        isPageReset: false
    });
    return this;
}
/**
 * Change the current page
 * @deprecated
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.setCurrentPage = $6e2deaae49fcf720$var$setCurrentPage;
/**
 * Updates the current page.
 * @function
 * @param  {number} page The page number
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.setPage = $6e2deaae49fcf720$var$setCurrentPage;
/**
 * Updates the name of the index that will be targeted by the query.
 *
 * This method resets the current page to 0.
 * @param {string} name the index name
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.setIndex = function(name) {
    this._change({
        state: this.state.resetPage().setIndex(name),
        isPageReset: true
    });
    return this;
};
/**
 * Update a parameter of the search. This method reset the page
 *
 * The complete list of parameters is available on the
 * [Algolia website](https://www.algolia.com/doc/rest#query-an-index).
 * The most commonly used parameters have their own [shortcuts](#query-parameters-shortcuts)
 * or benefit from higher-level APIs (all the kind of filters and facets have their own API)
 *
 * This method resets the current page to 0.
 * @param {string} parameter name of the parameter to update
 * @param {any} value new value of the parameter
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 * @example
 * helper.setQueryParameter('hitsPerPage', 20).search();
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.setQueryParameter = function(parameter, value) {
    this._change({
        state: this.state.resetPage().setQueryParameter(parameter, value),
        isPageReset: true
    });
    return this;
};
/**
 * Set the whole state (warning: will erase previous state)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @fires change
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.setState = function(newState) {
    this._change({
        state: $ltsLR.make(newState),
        isPageReset: false
    });
    return this;
};
/**
 * Override the current state without triggering a change event.
 * Do not use this method unless you know what you are doing. (see the example
 * for a legit use case)
 * @param {SearchParameters} newState the whole new state
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 * @example
 *  helper.on('change', function(state){
 *    // In this function you might want to find a way to store the state in the url/history
 *    updateYourURL(state)
 *  })
 *  window.onpopstate = function(event){
 *    // This is naive though as you should check if the state is really defined etc.
 *    helper.overrideStateWithoutTriggeringChangeEvent(event.state).search()
 *  }
 * @chainable
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.overrideStateWithoutTriggeringChangeEvent = function(newState) {
    this.state = new $ltsLR(newState);
    return this;
};
/**
 * Check if an attribute has any numeric, conjunctive, disjunctive or hierarchical filters.
 * @param {string} attribute the name of the attribute
 * @return {boolean} true if the attribute is filtered by at least one value
 * @example
 * // hasRefinements works with numeric, conjunctive, disjunctive and hierarchical filters
 * helper.hasRefinements('price'); // false
 * helper.addNumericRefinement('price', '>', 100);
 * helper.hasRefinements('price'); // true
 *
 * helper.hasRefinements('color'); // false
 * helper.addFacetRefinement('color', 'blue');
 * helper.hasRefinements('color'); // true
 *
 * helper.hasRefinements('material'); // false
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * helper.hasRefinements('material'); // true
 *
 * helper.hasRefinements('categories'); // false
 * helper.toggleFacetRefinement('categories', 'kitchen > knife');
 * helper.hasRefinements('categories'); // true
 *
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.hasRefinements = function(attribute) {
    if ($6Wgxo(this.state.getNumericRefinements(attribute))) return true;
    else if (this.state.isConjunctiveFacet(attribute)) return this.state.isFacetRefined(attribute);
    else if (this.state.isDisjunctiveFacet(attribute)) return this.state.isDisjunctiveFacetRefined(attribute);
    else if (this.state.isHierarchicalFacet(attribute)) return this.state.isHierarchicalFacetRefined(attribute);
    // there's currently no way to know that the user did call `addNumericRefinement` at some point
    // thus we cannot distinguish if there once was a numeric refinement that was cleared
    // so we will return false in every other situations to be consistent
    // while what we should do here is throw because we did not find the attribute in any type
    // of refinement
    return false;
};
/**
 * Check if a value is excluded for a specific faceted attribute. If the value
 * is omitted then the function checks if there is any excluding refinements.
 *
 * @param  {string}  facet name of the attribute for used for faceting
 * @param  {string}  [value] optional value. If passed will test that this value
 * is filtering the given facet.
 * @return {boolean} true if refined
 * @example
 * helper.isExcludeRefined('color'); // false
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // false
 *
 * helper.addFacetExclusion('color', 'red');
 *
 * helper.isExcludeRefined('color'); // true
 * helper.isExcludeRefined('color', 'blue') // false
 * helper.isExcludeRefined('color', 'red') // true
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.isExcluded = function(facet, value) {
    return this.state.isExcludeRefined(facet, value);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasRefinements}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.isDisjunctiveRefined = function(facet, value) {
    return this.state.isDisjunctiveFacetRefined(facet, value);
};
/**
 * Check if the string is a currently filtering tag.
 * @param {string} tag tag to check
 * @return {boolean} true if the tag is currently refined
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.hasTag = function(tag) {
    return this.state.isTagRefined(tag);
};
// eslint-disable-next-line valid-jsdoc
/**
 * @deprecated since 2.4.0, see {@link AlgoliaSearchHelper#hasTag}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.isTagRefined = function() {
    return this.hasTagRefinements.apply(this, arguments);
};
/**
 * Get the name of the currently used index.
 * @return {string} name of the index
 * @example
 * helper.setIndex('highestPrice_products').getIndex();
 * // returns 'highestPrice_products'
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getIndex = function() {
    return this.state.index;
};
function $6e2deaae49fcf720$var$getCurrentPage() {
    return this.state.page;
}
/**
 * Get the currently selected page
 * @deprecated
 * @return {number} the current page
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getCurrentPage = $6e2deaae49fcf720$var$getCurrentPage;
/**
 * Get the currently selected page
 * @function
 * @return {number} the current page
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getPage = $6e2deaae49fcf720$var$getCurrentPage;
/**
 * Get all the tags currently set to filters the results.
 *
 * @return {string[]} The list of tags currently set.
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getTags = function() {
    return this.state.tagRefinements;
};
/**
 * Get the list of refinements for a given attribute. This method works with
 * conjunctive, disjunctive, excluding and numerical filters.
 *
 * See also SearchResults#getRefinements
 *
 * @param {string} facetName attribute name used for faceting
 * @return {Array.<FacetRefinement|NumericRefinement>} All Refinement are objects that contain a value, and
 * a type. Numeric also contains an operator.
 * @example
 * helper.addNumericRefinement('price', '>', 100);
 * helper.getRefinements('price');
 * // [
 * //   {
 * //     "value": [
 * //       100
 * //     ],
 * //     "operator": ">",
 * //     "type": "numeric"
 * //   }
 * // ]
 * @example
 * helper.addFacetRefinement('color', 'blue');
 * helper.addFacetExclusion('color', 'red');
 * helper.getRefinements('color');
 * // [
 * //   {
 * //     "value": "blue",
 * //     "type": "conjunctive"
 * //   },
 * //   {
 * //     "value": "red",
 * //     "type": "exclude"
 * //   }
 * // ]
 * @example
 * helper.addDisjunctiveFacetRefinement('material', 'plastic');
 * // [
 * //   {
 * //     "value": "plastic",
 * //     "type": "disjunctive"
 * //   }
 * // ]
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getRefinements = function(facetName) {
    var refinements = [];
    if (this.state.isConjunctiveFacet(facetName)) {
        var conjRefinements = this.state.getConjunctiveRefinements(facetName);
        conjRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'conjunctive'
            });
        });
        var excludeRefinements = this.state.getExcludeRefinements(facetName);
        excludeRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'exclude'
            });
        });
    } else if (this.state.isDisjunctiveFacet(facetName)) {
        var disjunctiveRefinements = this.state.getDisjunctiveRefinements(facetName);
        disjunctiveRefinements.forEach(function(r) {
            refinements.push({
                value: r,
                type: 'disjunctive'
            });
        });
    }
    var numericRefinements = this.state.getNumericRefinements(facetName);
    Object.keys(numericRefinements).forEach(function(operator) {
        var value = numericRefinements[operator];
        refinements.push({
            value: value,
            operator: operator,
            type: 'numeric'
        });
    });
    return refinements;
};
/**
 * Return the current refinement for the (attribute, operator)
 * @param {string} attribute attribute in the record
 * @param {string} operator operator applied on the refined values
 * @return {Array.<number|number[]>} refined values
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getNumericRefinement = function(attribute, operator) {
    return this.state.getNumericRefinement(attribute, operator);
};
/**
 * Get the current breadcrumb for a hierarchical facet, as an array
 * @param  {string} facetName Hierarchical facet name
 * @return {array.<string>} the path as an array of string
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getHierarchicalFacetBreadcrumb = function(facetName) {
    return this.state.getHierarchicalFacetBreadcrumb(facetName);
};
// /////////// PRIVATE
/**
 * Perform the underlying queries
 * @private
 * @param {object} options options for the query
 * @param {boolean} [options.onlyWithDerivedHelpers=false] if true, only the derived helpers will be queried
 * @return {undefined} does not return anything
 * @fires search
 * @fires result
 * @fires error
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype._search = function(options) {
    var state = this.state;
    var states = [];
    var mainQueries = [];
    if (!options.onlyWithDerivedHelpers) {
        mainQueries = $5BVQk._getQueries(state.index, state);
        states.push({
            state: state,
            queriesCount: mainQueries.length,
            helper: this
        });
        this.emit('search', {
            state: state,
            results: this.lastResults
        });
    }
    var derivedQueries = this.derivedHelpers.map(function(derivedHelper) {
        var derivedState = derivedHelper.getModifiedState(state);
        var derivedStateQueries = derivedState.index ? $5BVQk._getQueries(derivedState.index, derivedState) : [];
        states.push({
            state: derivedState,
            queriesCount: derivedStateQueries.length,
            helper: derivedHelper
        });
        derivedHelper.emit('search', {
            state: derivedState,
            results: derivedHelper.lastResults
        });
        return derivedStateQueries;
    });
    var queries = Array.prototype.concat.apply(mainQueries, derivedQueries);
    var queryId = this._queryId++;
    this._currentNbQueries++;
    if (!queries.length) return Promise.resolve({
        results: []
    }).then(this._dispatchAlgoliaResponse.bind(this, states, queryId));
    try {
        this.client.search(queries).then(this._dispatchAlgoliaResponse.bind(this, states, queryId)).catch(this._dispatchAlgoliaError.bind(this, queryId));
    } catch (error) {
        // If we reach this part, we're in an internal error state
        this.emit('error', {
            error: error
        });
    }
    return undefined;
};
/**
 * Transform the responses as sent by the server and transform them into a user
 * usable object that merge the results of all the batch requests. It will dispatch
 * over the different helper + derived helpers (when there are some).
 * @private
 * @param {array.<{SearchParameters, AlgoliaQueries, AlgoliaSearchHelper}>} states state used to generate the request
 * @param {number} queryId id of the current request
 * @param {object} content content of the response
 * @return {undefined}
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaResponse = function(states, queryId, content) {
    // @TODO remove the number of outdated queries discarded instead of just one
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
    var results = content.results.slice();
    states.forEach(function(s) {
        var state = s.state;
        var queriesCount = s.queriesCount;
        var helper = s.helper;
        var specificResults = results.splice(0, queriesCount);
        if (!state.index) {
            helper.emit('result', {
                results: null,
                state: state
            });
            return;
        }
        helper.lastResults = new $dBe1E(state, specificResults);
        helper.emit('result', {
            results: helper.lastResults,
            state: state
        });
    });
};
$6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype._dispatchAlgoliaError = function(queryId, error) {
    if (queryId < this._lastQueryIdReceived) // Outdated answer
    return;
    this._currentNbQueries -= queryId - this._lastQueryIdReceived;
    this._lastQueryIdReceived = queryId;
    this.emit('error', {
        error: error
    });
    if (this._currentNbQueries === 0) this.emit('searchQueueEmpty');
};
$6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.containsRefinement = function(query, facetFilters, numericFilters, tagFilters) {
    return query || facetFilters.length !== 0 || numericFilters.length !== 0 || tagFilters.length !== 0;
};
/**
 * Test if there are some disjunctive refinements on the facet
 * @private
 * @param {string} facet the attribute to test
 * @return {boolean} true if there are refinements on this attribute
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype._hasDisjunctiveRefinements = function(facet) {
    return this.state.disjunctiveRefinements[facet] && this.state.disjunctiveRefinements[facet].length > 0;
};
$6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype._change = function(event) {
    var state = event.state;
    var isPageReset = event.isPageReset;
    if (state !== this.state) {
        this.state = state;
        this.emit('change', {
            state: this.state,
            results: this.lastResults,
            isPageReset: isPageReset
        });
    }
};
/**
 * Clears the cache of the underlying Algolia client.
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.clearCache = function() {
    if (this.client.clearCache) this.client.clearCache();
    return this;
};
/**
 * Updates the internal client instance. If the reference of the clients
 * are equal then no update is actually done.
 * @param  {AlgoliaSearch} newClient an AlgoliaSearch client
 * @return {AlgoliaSearchHelper} Method is chainable, it returns itself
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.setClient = function(newClient) {
    if (this.client === newClient) return this;
    if (typeof newClient.addAlgoliaAgent === 'function') newClient.addAlgoliaAgent('JS Helper (' + $2s3Na + ')');
    this.client = newClient;
    return this;
};
/**
 * Gets the instance of the currently used client.
 * @return {AlgoliaSearch} the currently used client
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.getClient = function() {
    return this.client;
};
/**
 * Creates an derived instance of the Helper. A derived helper
 * is a way to request other indices synchronised with the lifecycle
 * of the main Helper. This mechanism uses the multiqueries feature
 * of Algolia to aggregate all the requests in a single network call.
 *
 * This method takes a function that is used to create a new SearchParameter
 * that will be used to create requests to Algolia. Those new requests
 * are created just before the `search` event. The signature of the function
 * is `SearchParameters -> SearchParameters`.
 *
 * This method returns a new DerivedHelper which is an EventEmitter
 * that fires the same `search`, `result` and `error` events. Those
 * events, however, will receive data specific to this DerivedHelper
 * and the SearchParameters that is returned by the call of the
 * parameter function.
 * @param {function} fn SearchParameters -> SearchParameters
 * @return {DerivedHelper} a new DerivedHelper
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.derive = function(fn) {
    var derivedHelper = new $9SPXt(this, fn);
    this.derivedHelpers.push(derivedHelper);
    return derivedHelper;
};
/**
 * This method detaches a derived Helper from the main one. Prefer using the one from the
 * derived helper itself, to remove the event listeners too.
 * @private
 * @param  {DerivedHelper} derivedHelper the derived helper to detach
 * @return {undefined} nothing is returned
 * @throws Error
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.detachDerivedHelper = function(derivedHelper) {
    var pos = this.derivedHelpers.indexOf(derivedHelper);
    if (pos === -1) throw new Error('Derived helper already detached');
    this.derivedHelpers.splice(pos, 1);
};
/**
 * This method returns true if there is currently at least one on-going search.
 * @return {boolean} true if there is a search pending
 */ $6e2deaae49fcf720$var$AlgoliaSearchHelper.prototype.hasPendingRequests = function() {
    return this._currentNbQueries > 0;
};
/**
 * @typedef AlgoliaSearchHelper.NumericRefinement
 * @type {object}
 * @property {number[]} value the numbers that are used for filtering this attribute with
 * the operator specified.
 * @property {string} operator the faceting data: value, number of entries
 * @property {string} type will be 'numeric'
 */ /**
 * @typedef AlgoliaSearchHelper.FacetRefinement
 * @type {object}
 * @property {string} value the string use to filter the attribute
 * @property {string} type the type of filter: 'conjunctive', 'disjunctive', 'exclude'
 */ module.exports = $6e2deaae49fcf720$var$AlgoliaSearchHelper;

});
parcelRegister("90FFK", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $68f47069226118a5$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
module.exports = $68f47069226118a5$var$EventEmitter;
// Backwards-compat with node 0.10.x
// EventEmitter.EventEmitter = EventEmitter;
$68f47069226118a5$var$EventEmitter.prototype._events = undefined;
$68f47069226118a5$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$68f47069226118a5$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$68f47069226118a5$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$68f47069226118a5$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
    this._maxListeners = n;
    return this;
};
$68f47069226118a5$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === 'error') {
        if (!this._events.error || $68f47069226118a5$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($68f47069226118a5$var$isUndefined(handler)) return false;
    if ($68f47069226118a5$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($68f47069226118a5$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$68f47069226118a5$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$68f47069226118a5$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit('newListener', type, $68f47069226118a5$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($68f47069226118a5$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($68f47069226118a5$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$68f47069226118a5$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $68f47069226118a5$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === 'function') // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$68f47069226118a5$var$EventEmitter.prototype.on = $68f47069226118a5$var$EventEmitter.prototype.addListener;
$68f47069226118a5$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$68f47069226118a5$var$isFunction(listener)) throw TypeError('listener must be a function');
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$68f47069226118a5$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$68f47069226118a5$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $68f47069226118a5$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    } else if ($68f47069226118a5$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    }
    return this;
};
$68f47069226118a5$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($68f47069226118a5$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$68f47069226118a5$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($68f47069226118a5$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$68f47069226118a5$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($68f47069226118a5$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$68f47069226118a5$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $68f47069226118a5$var$isFunction(arg) {
    return typeof arg === 'function';
}
function $68f47069226118a5$var$isNumber(arg) {
    return typeof arg === 'number';
}
function $68f47069226118a5$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function $68f47069226118a5$var$isUndefined(arg) {
    return arg === void 0;
}

});

parcelRegister("9SPXt", function(module, exports) {
'use strict';

var $90FFK = parcelRequire("90FFK");

var $gVBvC = parcelRequire("gVBvC");
/**
 * A DerivedHelper is a way to create sub requests to
 * Algolia from a main helper.
 * @class
 * @classdesc The DerivedHelper provides an event based interface for search callbacks:
 *  - search: when a search is triggered using the `search()` method.
 *  - result: when the response is retrieved from Algolia and is processed.
 *    This event contains a {@link SearchResults} object and the
 *    {@link SearchParameters} corresponding to this answer.
 * @param {AlgoliaSearchHelper} mainHelper the main helper
 * @param {function} fn the function to create the derived state
 */ function $7321760683955e1d$var$DerivedHelper(mainHelper, fn) {
    this.main = mainHelper;
    this.fn = fn;
    this.lastResults = null;
}
$gVBvC($7321760683955e1d$var$DerivedHelper, $90FFK);
/**
 * Detach this helper from the main helper
 * @return {undefined}
 * @throws Error if the derived helper is already detached
 */ $7321760683955e1d$var$DerivedHelper.prototype.detach = function() {
    this.removeAllListeners();
    this.main.detachDerivedHelper(this);
};
$7321760683955e1d$var$DerivedHelper.prototype.getModifiedState = function(parameters) {
    return this.fn(parameters);
};
module.exports = $7321760683955e1d$var$DerivedHelper;

});
parcelRegister("gVBvC", function(module, exports) {
'use strict';
function $c52f10bd4374e9c0$var$inherits(ctor, superCtor) {
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
}
module.exports = $c52f10bd4374e9c0$var$inherits;

});


parcelRegister("iOTWh", function(module, exports) {
'use strict';
/**
 * Replaces a leading - with \-
 * @private
 * @param {any} value the facet value to replace
 * @returns {any} the escaped facet value or the value if it was not a string
 */ function $db3849d6a8baa0a3$var$escapeFacetValue(value) {
    if (typeof value !== 'string') return value;
    return String(value).replace(/^-/, '\\-');
}
/**
 * Replaces a leading \- with -
 * @private
 * @param {any} value the escaped facet value
 * @returns {any} the unescaped facet value or the value if it was not a string
 */ function $db3849d6a8baa0a3$var$unescapeFacetValue(value) {
    if (typeof value !== 'string') return value;
    return value.replace(/^\\-/, '-');
}
module.exports = {
    escapeFacetValue: $db3849d6a8baa0a3$var$escapeFacetValue,
    unescapeFacetValue: $db3849d6a8baa0a3$var$unescapeFacetValue
};

});

parcelRegister("2KSyk", function(module, exports) {
'use strict';
function $201a31a8d237951d$var$clone(value) {
    if (typeof value === 'object' && value !== null) return $201a31a8d237951d$var$_merge(Array.isArray(value) ? [] : {}, value);
    return value;
}
function $201a31a8d237951d$var$isObjectOrArrayOrFunction(value) {
    return typeof value === 'function' || Array.isArray(value) || Object.prototype.toString.call(value) === '[object Object]';
}
function $201a31a8d237951d$var$_merge(target, source) {
    if (target === source) return target;
    // eslint-disable-next-line no-restricted-syntax
    for(var key in source){
        if (!Object.prototype.hasOwnProperty.call(source, key) || key === '__proto__' || key === 'constructor') continue;
        var sourceVal = source[key];
        var targetVal = target[key];
        if (typeof targetVal !== 'undefined' && typeof sourceVal === 'undefined') continue;
        if ($201a31a8d237951d$var$isObjectOrArrayOrFunction(targetVal) && $201a31a8d237951d$var$isObjectOrArrayOrFunction(sourceVal)) target[key] = $201a31a8d237951d$var$_merge(targetVal, sourceVal);
        else target[key] = $201a31a8d237951d$var$clone(sourceVal);
    }
    return target;
}
/**
 * This method is like Object.assign, but recursively merges own and inherited
 * enumerable keyed properties of source objects into the destination object.
 *
 * NOTE: this behaves like lodash/merge, but:
 * - does mutate functions if they are a source
 * - treats non-plain objects as plain
 * - does not work for circular objects
 * - treats sparse arrays as sparse
 * - does not convert Array-like objects (Arguments, NodeLists, etc.) to arrays
 *
 * @param {Object} target The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 */ function $201a31a8d237951d$var$merge(target) {
    if (!$201a31a8d237951d$var$isObjectOrArrayOrFunction(target)) target = {};
    for(var i = 1, l = arguments.length; i < l; i++){
        var source = arguments[i];
        if ($201a31a8d237951d$var$isObjectOrArrayOrFunction(source)) $201a31a8d237951d$var$_merge(target, source);
    }
    return target;
}
module.exports = $201a31a8d237951d$var$merge;

});

parcelRegister("6Wgxo", function(module, exports) {
'use strict';
function $50d4fcde2ec60061$var$objectHasKeys(obj) {
    return obj && Object.keys(obj).length > 0;
}
module.exports = $50d4fcde2ec60061$var$objectHasKeys;

});

parcelRegister("ka9BV", function(module, exports) {
'use strict';
// https://github.com/babel/babel/blob/3aaafae053fa75febb3aa45d45b6f00646e30ba4/packages/babel-helpers/src/helpers.js#L604-L620
function $eadc324ca96c39f3$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source === null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key;
    var i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        // eslint-disable-next-line no-continue
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
module.exports = $eadc324ca96c39f3$var$_objectWithoutPropertiesLoose;

});

parcelRegister("5BVQk", function(module, exports) {
'use strict';

var $2KSyk = parcelRequire("2KSyk");
function $010de43d4c96dde2$var$sortObject(obj) {
    return Object.keys(obj).sort().reduce(function(acc, curr) {
        acc[curr] = obj[curr];
        return acc;
    }, {});
}
var $010de43d4c96dde2$var$requestBuilder = {
    /**
   * Get all the queries to send to the client, those queries can used directly
   * with the Algolia client.
   * @private
   * @param  {string} index The name of the index
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object[]} The queries
   */ _getQueries: function getQueries(index, state) {
        var queries = [];
        // One query for the hits
        queries.push({
            indexName: index,
            params: $010de43d4c96dde2$var$requestBuilder._getHitsSearchParams(state)
        });
        // One for each disjunctive facets
        state.getRefinedDisjunctiveFacets().forEach(function(refinedFacet) {
            queries.push({
                indexName: index,
                params: $010de43d4c96dde2$var$requestBuilder._getDisjunctiveFacetSearchParams(state, refinedFacet)
            });
        });
        // More to get the parent levels of the hierarchical facets when refined
        state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
            var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
            var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            // If we are deeper than level 0 (starting from `beer > IPA`)
            // we want to get all parent values
            if (currentRefinement.length > 0 && currentRefinement[0].split(separator).length > 1) {
                // We generate a map of the filters we will use for our facet values queries
                var filtersMap = currentRefinement[0].split(separator).slice(0, -1).reduce(function createFiltersMap(map, segment, level) {
                    return map.concat({
                        attribute: hierarchicalFacet.attributes[level],
                        value: level === 0 ? segment : [
                            map[map.length - 1].value,
                            segment
                        ].join(separator)
                    });
                }, []);
                filtersMap.forEach(function(filter, level) {
                    var params = $010de43d4c96dde2$var$requestBuilder._getDisjunctiveFacetSearchParams(state, filter.attribute, level === 0);
                    // Keep facet filters unrelated to current hierarchical attributes
                    function hasHierarchicalFacetFilter(value) {
                        return hierarchicalFacet.attributes.some(function(attribute) {
                            return attribute === value.split(':')[0];
                        });
                    }
                    var filteredFacetFilters = (params.facetFilters || []).reduce(function(acc, facetFilter) {
                        if (Array.isArray(facetFilter)) {
                            var filtered = facetFilter.filter(function(filterValue) {
                                return !hasHierarchicalFacetFilter(filterValue);
                            });
                            if (filtered.length > 0) acc.push(filtered);
                        }
                        if (typeof facetFilter === 'string' && !hasHierarchicalFacetFilter(facetFilter)) acc.push(facetFilter);
                        return acc;
                    }, []);
                    var parent = filtersMap[level - 1];
                    if (level > 0) params.facetFilters = filteredFacetFilters.concat(parent.attribute + ':' + parent.value);
                    else params.facetFilters = filteredFacetFilters.length > 0 ? filteredFacetFilters : undefined;
                    queries.push({
                        indexName: index,
                        params: params
                    });
                });
            }
        });
        return queries;
    },
    /**
   * Build search parameters used to fetch hits
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @return {object.<string, any>} The search parameters for hits
   */ _getHitsSearchParams: function(state) {
        var facets = state.facets.concat(state.disjunctiveFacets).concat($010de43d4c96dde2$var$requestBuilder._getHitsHierarchicalFacetsAttributes(state)).sort();
        var facetFilters = $010de43d4c96dde2$var$requestBuilder._getFacetFilters(state);
        var numericFilters = $010de43d4c96dde2$var$requestBuilder._getNumericFilters(state);
        var tagFilters = $010de43d4c96dde2$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            facets: facets.indexOf('*') > -1 ? [
                '*'
            ] : facets,
            tagFilters: tagFilters
        };
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        return $010de43d4c96dde2$var$sortObject($2KSyk({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Build search parameters used to fetch a disjunctive facet
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} facet the associated facet name
   * @param  {boolean} hierarchicalRootLevel ?? FIXME
   * @return {object} The search parameters for a disjunctive facet
   */ _getDisjunctiveFacetSearchParams: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = $010de43d4c96dde2$var$requestBuilder._getFacetFilters(state, facet, hierarchicalRootLevel);
        var numericFilters = $010de43d4c96dde2$var$requestBuilder._getNumericFilters(state, facet);
        var tagFilters = $010de43d4c96dde2$var$requestBuilder._getTagFilters(state);
        var additionalParams = {
            hitsPerPage: 0,
            page: 0,
            analytics: false,
            clickAnalytics: false
        };
        if (tagFilters.length > 0) additionalParams.tagFilters = tagFilters;
        var hierarchicalFacet = state.getHierarchicalFacetByName(facet);
        if (hierarchicalFacet) additionalParams.facets = $010de43d4c96dde2$var$requestBuilder._getDisjunctiveHierarchicalFacetAttribute(state, hierarchicalFacet, hierarchicalRootLevel);
        else additionalParams.facets = facet;
        if (numericFilters.length > 0) additionalParams.numericFilters = numericFilters;
        if (facetFilters.length > 0) additionalParams.facetFilters = facetFilters;
        return $010de43d4c96dde2$var$sortObject($2KSyk({}, state.getQueryParams(), additionalParams));
    },
    /**
   * Return the numeric filters in an algolia request fashion
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @param {string} [facetName] the name of the attribute for which the filters should be excluded
   * @return {string[]} the numeric filters in the algolia format
   */ _getNumericFilters: function(state, facetName) {
        if (state.numericFilters) return state.numericFilters;
        var numericFilters = [];
        Object.keys(state.numericRefinements).forEach(function(attribute) {
            var operators = state.numericRefinements[attribute] || {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator] || [];
                if (facetName !== attribute) values.forEach(function(value) {
                    if (Array.isArray(value)) {
                        var vs = value.map(function(v) {
                            return attribute + operator + v;
                        });
                        numericFilters.push(vs);
                    } else numericFilters.push(attribute + operator + value);
                });
            });
        });
        return numericFilters;
    },
    /**
   * Return the tags filters depending on which format is used, either tagFilters or tagRefinements
   * @private
   * @param {SearchParameters} state the state from which to get the filters
   * @return {string} Tag filters in a single string
   */ _getTagFilters: function(state) {
        if (state.tagFilters) return state.tagFilters;
        return state.tagRefinements.join(',');
    },
    /**
   * Build facetFilters parameter based on current refinements. The array returned
   * contains strings representing the facet filters in the algolia format.
   * @private
   * @param  {SearchParameters} state The state from which to get the queries
   * @param  {string} [facet] if set, the current disjunctive facet
   * @param  {boolean} [hierarchicalRootLevel] ?? FIXME
   * @return {array.<string>} The facet filters in the algolia format
   */ _getFacetFilters: function(state, facet, hierarchicalRootLevel) {
        var facetFilters = [];
        var facetsRefinements = state.facetsRefinements || {};
        Object.keys(facetsRefinements).sort().forEach(function(facetName) {
            var facetValues = facetsRefinements[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ':' + facetValue);
            });
        });
        var facetsExcludes = state.facetsExcludes || {};
        Object.keys(facetsExcludes).sort().forEach(function(facetName) {
            var facetValues = facetsExcludes[facetName] || [];
            facetValues.sort().forEach(function(facetValue) {
                facetFilters.push(facetName + ':-' + facetValue);
            });
        });
        var disjunctiveFacetsRefinements = state.disjunctiveFacetsRefinements || {};
        Object.keys(disjunctiveFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = disjunctiveFacetsRefinements[facetName] || [];
            if (facetName === facet || !facetValues || facetValues.length === 0) return;
            var orFilters = [];
            facetValues.sort().forEach(function(facetValue) {
                orFilters.push(facetName + ':' + facetValue);
            });
            facetFilters.push(orFilters);
        });
        var hierarchicalFacetsRefinements = state.hierarchicalFacetsRefinements || {};
        Object.keys(hierarchicalFacetsRefinements).sort().forEach(function(facetName) {
            var facetValues = hierarchicalFacetsRefinements[facetName] || [];
            var facetValue = facetValues[0];
            if (facetValue === undefined) return;
            var hierarchicalFacet = state.getHierarchicalFacetByName(facetName);
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeToRefine;
            var attributesIndex;
            // we ask for parent facet values only when the `facet` is the current hierarchical facet
            if (facet === facetName) {
                // if we are at the root level already, no need to ask for facet values, we get them from
                // the hits query
                if (facetValue.indexOf(separator) === -1 || !rootPath && hierarchicalRootLevel === true || rootPath && rootPath.split(separator).length === facetValue.split(separator).length) return;
                if (!rootPath) {
                    attributesIndex = facetValue.split(separator).length - 2;
                    facetValue = facetValue.slice(0, facetValue.lastIndexOf(separator));
                } else {
                    attributesIndex = rootPath.split(separator).length - 1;
                    facetValue = rootPath;
                }
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            } else {
                attributesIndex = facetValue.split(separator).length - 1;
                attributeToRefine = hierarchicalFacet.attributes[attributesIndex];
            }
            if (attributeToRefine) facetFilters.push([
                attributeToRefine + ':' + facetValue
            ]);
        });
        return facetFilters;
    },
    _getHitsHierarchicalFacetsAttributes: function(state) {
        var out = [];
        return state.hierarchicalFacets.reduce(// ask for as much levels as there's hierarchical refinements
        function getHitsAttributesForHierarchicalFacet(allAttributes, hierarchicalFacet) {
            var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0];
            // if no refinement, ask for root level
            if (!hierarchicalRefinement) {
                allAttributes.push(hierarchicalFacet.attributes[0]);
                return allAttributes;
            }
            var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
            var level = hierarchicalRefinement.split(separator).length;
            var newAttributes = hierarchicalFacet.attributes.slice(0, level + 1);
            return allAttributes.concat(newAttributes);
        }, out);
    },
    _getDisjunctiveHierarchicalFacetAttribute: function(state, hierarchicalFacet, rootLevel) {
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        if (rootLevel === true) {
            var rootPath = state._getHierarchicalRootPath(hierarchicalFacet);
            var attributeIndex = 0;
            if (rootPath) attributeIndex = rootPath.split(separator).length;
            return [
                hierarchicalFacet.attributes[attributeIndex]
            ];
        }
        var hierarchicalRefinement = state.getHierarchicalRefinement(hierarchicalFacet.name)[0] || '';
        // if refinement is 'beers > IPA > Flying dog',
        // then we want `facets: ['beers > IPA']` as disjunctive facet (parent level values)
        var parentLevel = hierarchicalRefinement.split(separator).length - 1;
        return hierarchicalFacet.attributes.slice(0, parentLevel + 1);
    },
    getSearchForFacetQuery: function(facetName, query, maxFacetHits, state) {
        var stateForSearchForFacetValues = state.isDisjunctiveFacet(facetName) ? state.clearRefinements(facetName) : state;
        var searchForFacetSearchParameters = {
            facetQuery: query,
            facetName: facetName
        };
        if (typeof maxFacetHits === 'number') searchForFacetSearchParameters.maxFacetHits = maxFacetHits;
        return $010de43d4c96dde2$var$sortObject($2KSyk({}, $010de43d4c96dde2$var$requestBuilder._getHitsSearchParams(stateForSearchForFacetValues), searchForFacetSearchParameters));
    }
};
module.exports = $010de43d4c96dde2$var$requestBuilder;

});

parcelRegister("ltsLR", function(module, exports) {
'use strict';

var $kee8o = parcelRequire("kee8o");

var $5B6z1 = parcelRequire("5B6z1");

var $7t031 = parcelRequire("7t031");

var $2KSyk = parcelRequire("2KSyk");

var $6Wgxo = parcelRequire("6Wgxo");

var $ka9BV = parcelRequire("ka9BV");

var $b5TIZ = parcelRequire("b5TIZ");

var $1dEVb = parcelRequire("1dEVb");

var $gRx5R = parcelRequire("gRx5R");
/**
 * isEqual, but only for numeric refinement values, possible values:
 * - 5
 * - [5]
 * - [[5]]
 * - [[5,5],[4]]
 * @param {any} a numeric refinement value
 * @param {any} b numeric refinement value
 * @return {boolean} true if the values are equal
 */ function $fa229fb6834531c7$var$isEqualNumericRefinement(a, b) {
    if (Array.isArray(a) && Array.isArray(b)) return a.length === b.length && a.every(function(el, i) {
        return $fa229fb6834531c7$var$isEqualNumericRefinement(b[i], el);
    });
    return a === b;
}
/**
 * like _.find but using deep equality to be able to use it
 * to find arrays.
 * @private
 * @param {any[]} array array to search into (elements are base or array of base)
 * @param {any} searchedValue the value we're looking for (base or array of base)
 * @return {any} the searched value or undefined
 */ function $fa229fb6834531c7$var$findArray(array, searchedValue) {
    return $5B6z1(array, function(currentValue) {
        return $fa229fb6834531c7$var$isEqualNumericRefinement(currentValue, searchedValue);
    });
}
/**
 * The facet list is the structure used to store the list of values used to
 * filter a single attribute.
 * @typedef {string[]} SearchParameters.FacetList
 */ /**
 * Structure to store numeric filters with the operator as the key. The supported operators
 * are `=`, `>`, `<`, `>=`, `<=` and `!=`.
 * @typedef {Object.<string, Array.<number|number[]>>} SearchParameters.OperatorList
 */ /**
 * SearchParameters is the data structure that contains all the information
 * usable for making a search to Algolia API. It doesn't do the search itself,
 * nor does it contains logic about the parameters.
 * It is an immutable object, therefore it has been created in a way that each
 * changes does not change the object itself but returns a copy with the
 * modification.
 * This object should probably not be instantiated outside of the helper. It will
 * be provided when needed. This object is documented for reference as you'll
 * get it from events generated by the {@link AlgoliaSearchHelper}.
 * If need be, instantiate the Helper from the factory function {@link SearchParameters.make}
 * @constructor
 * @classdesc contains all the parameters of a search
 * @param {object|SearchParameters} newParameters existing parameters or partial object
 * for the properties of a new SearchParameters
 * @see SearchParameters.make
 * @example <caption>SearchParameters of the first query in
 *   <a href="http://demos.algolia.com/instant-search-demo/">the instant search demo</a></caption>
{
   "query": "",
   "disjunctiveFacets": [
      "customerReviewCount",
      "category",
      "salePrice_range",
      "manufacturer"
  ],
   "maxValuesPerFacet": 30,
   "page": 0,
   "hitsPerPage": 10,
   "facets": [
      "type",
      "shipping"
  ]
}
 */ function $fa229fb6834531c7$var$SearchParameters(newParameters) {
    var params = newParameters ? $fa229fb6834531c7$var$SearchParameters._parseNumbers(newParameters) : {};
    if (params.userToken !== undefined && !$1dEVb(params.userToken)) // eslint-disable-next-line no-console
    console.warn('[algoliasearch-helper] The `userToken` parameter is invalid. This can lead to wrong analytics.\n  - Format: [a-zA-Z0-9_-]{1,64}');
    /**
   * This attribute contains the list of all the conjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.facets = params.facets || [];
    /**
   * This attribute contains the list of all the disjunctive facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * @member {string[]}
   */ this.disjunctiveFacets = params.disjunctiveFacets || [];
    /**
   * This attribute contains the list of all the hierarchical facets
   * used. This list will be added to requested facets in the
   * [facets attribute](https://www.algolia.com/doc/rest-api/search#param-facets) sent to algolia.
   * Hierarchical facets are a sub type of disjunctive facets that
   * let you filter faceted attributes hierarchically.
   * @member {string[]|object[]}
   */ this.hierarchicalFacets = params.hierarchicalFacets || [];
    // Refinements
    /**
   * This attribute contains all the filters that need to be
   * applied on the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsRefinements = params.facetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * excluded from the conjunctive facets. Each facet must be properly
   * defined in the `facets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters excluded for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.facetsExcludes = params.facetsExcludes || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the disjunctive facets. Each facet must be properly
   * defined in the `disjunctiveFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.disjunctiveFacetsRefinements = params.disjunctiveFacetsRefinements || {};
    /**
   * This attribute contains all the filters that need to be
   * applied on the numeric attributes.
   *
   * The key is the name of the attribute, and the value is the
   * filters to apply to this attribute.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `numericFilters` attribute.
   * @member {Object.<string, SearchParameters.OperatorList>}
   */ this.numericRefinements = params.numericRefinements || {};
    /**
   * This attribute contains all the tags used to refine the query.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `tagFilters` attribute.
   * @member {string[]}
   */ this.tagRefinements = params.tagRefinements || [];
    /**
   * This attribute contains all the filters that need to be
   * applied on the hierarchical facets. Each facet must be properly
   * defined in the `hierarchicalFacets` attribute.
   *
   * The key is the name of the facet, and the `FacetList` contains all
   * filters selected for the associated facet name. The FacetList values
   * are structured as a string that contain the values for each level
   * separated by the configured separator.
   *
   * When querying algolia, the values stored in this attribute will
   * be translated into the `facetFilters` attribute.
   * @member {Object.<string, SearchParameters.FacetList>}
   */ this.hierarchicalFacetsRefinements = params.hierarchicalFacetsRefinements || {};
    // eslint-disable-next-line consistent-this
    var self = this;
    Object.keys(params).forEach(function(paramName) {
        var isKeyKnown = $fa229fb6834531c7$var$SearchParameters.PARAMETERS.indexOf(paramName) !== -1;
        var isValueDefined = params[paramName] !== undefined;
        if (!isKeyKnown && isValueDefined) self[paramName] = params[paramName];
    });
}
/**
 * List all the properties in SearchParameters and therefore all the known Algolia properties
 * This doesn't contain any beta/hidden features.
 * @private
 */ $fa229fb6834531c7$var$SearchParameters.PARAMETERS = Object.keys(new $fa229fb6834531c7$var$SearchParameters());
/**
 * @private
 * @param {object} partialState full or part of a state
 * @return {object} a new object with the number keys as number
 */ $fa229fb6834531c7$var$SearchParameters._parseNumbers = function(partialState) {
    // Do not parse numbers again in SearchParameters, they ought to be parsed already
    if (partialState instanceof $fa229fb6834531c7$var$SearchParameters) return partialState;
    var numbers = {};
    var numberKeys = [
        'aroundPrecision',
        'aroundRadius',
        'getRankingInfo',
        'minWordSizefor2Typos',
        'minWordSizefor1Typo',
        'page',
        'maxValuesPerFacet',
        'distinct',
        'minimumAroundRadius',
        'hitsPerPage',
        'minProximity'
    ];
    numberKeys.forEach(function(k) {
        var value = partialState[k];
        if (typeof value === 'string') {
            var parsedValue = parseFloat(value);
            // global isNaN is ok to use here, value is only number or NaN
            numbers[k] = isNaN(parsedValue) ? value : parsedValue;
        }
    });
    // there's two formats of insideBoundingBox, we need to parse
    // the one which is an array of float geo rectangles
    if (Array.isArray(partialState.insideBoundingBox)) numbers.insideBoundingBox = partialState.insideBoundingBox.map(function(geoRect) {
        if (Array.isArray(geoRect)) return geoRect.map(function(value) {
            return parseFloat(value);
        });
        return geoRect;
    });
    if (partialState.numericRefinements) {
        var numericRefinements = {};
        Object.keys(partialState.numericRefinements).forEach(function(attribute) {
            var operators = partialState.numericRefinements[attribute] || {};
            numericRefinements[attribute] = {};
            Object.keys(operators).forEach(function(operator) {
                var values = operators[operator];
                var parsedValues = values.map(function(v) {
                    if (Array.isArray(v)) return v.map(function(vPrime) {
                        if (typeof vPrime === 'string') return parseFloat(vPrime);
                        return vPrime;
                    });
                    else if (typeof v === 'string') return parseFloat(v);
                    return v;
                });
                numericRefinements[attribute][operator] = parsedValues;
            });
        });
        numbers.numericRefinements = numericRefinements;
    }
    return $2KSyk({}, partialState, numbers);
};
/**
 * Factory for SearchParameters
 * @param {object|SearchParameters} newParameters existing parameters or partial
 * object for the properties of a new SearchParameters
 * @return {SearchParameters} frozen instance of SearchParameters
 */ $fa229fb6834531c7$var$SearchParameters.make = function makeSearchParameters(newParameters) {
    var instance = new $fa229fb6834531c7$var$SearchParameters(newParameters);
    var hierarchicalFacets = newParameters.hierarchicalFacets || [];
    hierarchicalFacets.forEach(function(facet) {
        if (facet.rootPath) {
            var currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length > 0 && currentRefinement[0].indexOf(facet.rootPath) !== 0) instance = instance.clearRefinements(facet.name);
            // get it again in case it has been cleared
            currentRefinement = instance.getHierarchicalRefinement(facet.name);
            if (currentRefinement.length === 0) instance = instance.toggleHierarchicalFacetRefinement(facet.name, facet.rootPath);
        }
    });
    return instance;
};
/**
 * Validates the new parameters based on the previous state
 * @param {SearchParameters} currentState the current state
 * @param {object|SearchParameters} parameters the new parameters to set
 * @return {Error|null} Error if the modification is invalid, null otherwise
 */ $fa229fb6834531c7$var$SearchParameters.validate = function(currentState, parameters) {
    var params = parameters || {};
    if (currentState.tagFilters && params.tagRefinements && params.tagRefinements.length > 0) return new Error("[Tags] Cannot switch from the managed tag API to the advanced API. It is probably an error, if it is really what you want, you should first clear the tags with clearTags method.");
    if (currentState.tagRefinements.length > 0 && params.tagFilters) return new Error("[Tags] Cannot switch from the advanced tag API to the managed API. It is probably an error, if it is not, you should first clear the tags with clearTags method.");
    if (currentState.numericFilters && params.numericRefinements && $6Wgxo(params.numericRefinements)) return new Error("[Numeric filters] Can't switch from the advanced to the managed API. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    if ($6Wgxo(currentState.numericRefinements) && params.numericFilters) return new Error("[Numeric filters] Can't switch from the managed API to the advanced. It is probably an error, if this is really what you want, you have to first clear the numeric filters.");
    return null;
};
$fa229fb6834531c7$var$SearchParameters.prototype = {
    constructor: $fa229fb6834531c7$var$SearchParameters,
    /**
   * Remove all refinements (disjunctive + conjunctive + excludes + numeric filters)
   * @method
   * @param {undefined|string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {SearchParameters} new instance with filters cleared
   */ clearRefinements: function clearRefinements(attribute) {
        var patch = {
            numericRefinements: this._clearNumericRefinements(attribute),
            facetsRefinements: $gRx5R.clearRefinement(this.facetsRefinements, attribute, 'conjunctiveFacet'),
            facetsExcludes: $gRx5R.clearRefinement(this.facetsExcludes, attribute, 'exclude'),
            disjunctiveFacetsRefinements: $gRx5R.clearRefinement(this.disjunctiveFacetsRefinements, attribute, 'disjunctiveFacet'),
            hierarchicalFacetsRefinements: $gRx5R.clearRefinement(this.hierarchicalFacetsRefinements, attribute, 'hierarchicalFacet')
        };
        if (patch.numericRefinements === this.numericRefinements && patch.facetsRefinements === this.facetsRefinements && patch.facetsExcludes === this.facetsExcludes && patch.disjunctiveFacetsRefinements === this.disjunctiveFacetsRefinements && patch.hierarchicalFacetsRefinements === this.hierarchicalFacetsRefinements) return this;
        return this.setQueryParameters(patch);
    },
    /**
   * Remove all the refined tags from the SearchParameters
   * @method
   * @return {SearchParameters} new instance with tags cleared
   */ clearTags: function clearTags() {
        if (this.tagFilters === undefined && this.tagRefinements.length === 0) return this;
        return this.setQueryParameters({
            tagFilters: undefined,
            tagRefinements: []
        });
    },
    /**
   * Set the index.
   * @method
   * @param {string} index the index name
   * @return {SearchParameters} new instance
   */ setIndex: function setIndex(index) {
        if (index === this.index) return this;
        return this.setQueryParameters({
            index: index
        });
    },
    /**
   * Query setter
   * @method
   * @param {string} newQuery value for the new query
   * @return {SearchParameters} new instance
   */ setQuery: function setQuery(newQuery) {
        if (newQuery === this.query) return this;
        return this.setQueryParameters({
            query: newQuery
        });
    },
    /**
   * Page setter
   * @method
   * @param {number} newPage new page number
   * @return {SearchParameters} new instance
   */ setPage: function setPage(newPage) {
        if (newPage === this.page) return this;
        return this.setQueryParameters({
            page: newPage
        });
    },
    /**
   * Facets setter
   * The facets are the simple facets, used for conjunctive (and) faceting.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for conjunctive faceting
   * @return {SearchParameters} new instance
   */ setFacets: function setFacets(facets) {
        return this.setQueryParameters({
            facets: facets
        });
    },
    /**
   * Disjunctive facets setter
   * Change the list of disjunctive (or) facets the helper chan handle.
   * @method
   * @param {string[]} facets all the attributes of the algolia records used for disjunctive faceting
   * @return {SearchParameters} new instance
   */ setDisjunctiveFacets: function setDisjunctiveFacets(facets) {
        return this.setQueryParameters({
            disjunctiveFacets: facets
        });
    },
    /**
   * HitsPerPage setter
   * Hits per page represents the number of hits retrieved for this query
   * @method
   * @param {number} n number of hits retrieved per page of results
   * @return {SearchParameters} new instance
   */ setHitsPerPage: function setHitsPerPage(n) {
        if (this.hitsPerPage === n) return this;
        return this.setQueryParameters({
            hitsPerPage: n
        });
    },
    /**
   * typoTolerance setter
   * Set the value of typoTolerance
   * @method
   * @param {string} typoTolerance new value of typoTolerance ("true", "false", "min" or "strict")
   * @return {SearchParameters} new instance
   */ setTypoTolerance: function setTypoTolerance(typoTolerance) {
        if (this.typoTolerance === typoTolerance) return this;
        return this.setQueryParameters({
            typoTolerance: typoTolerance
        });
    },
    /**
   * Add a numeric filter for a given attribute
   * When value is an array, they are combined with OR
   * When value is a single value, it will combined with AND
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} operator operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number | number[]} value value of the filter
   * @return {SearchParameters} new instance
   * @example
   * // for price = 50 or 40
   * state.addNumericRefinement('price', '=', [50, 40]);
   * @example
   * // for size = 38 and 40
   * state.addNumericRefinement('size', '=', 38);
   * state.addNumericRefinement('size', '=', 40);
   */ addNumericRefinement: function(attribute, operator, value) {
        var val = $b5TIZ(value);
        if (this.isNumericRefined(attribute, operator, val)) return this;
        var mod = $2KSyk({}, this.numericRefinements);
        mod[attribute] = $2KSyk({}, mod[attribute]);
        if (mod[attribute][operator]) {
            // Array copy
            mod[attribute][operator] = mod[attribute][operator].slice();
            // Add the element. Concat can't be used here because value can be an array.
            mod[attribute][operator].push(val);
        } else mod[attribute][operator] = [
            val
        ];
        return this.setQueryParameters({
            numericRefinements: mod
        });
    },
    /**
   * Get the list of conjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getConjunctiveRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsRefinements[facetName] || [];
    },
    /**
   * Get the list of disjunctive refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getDisjunctiveRefinements: function(facetName) {
        if (!this.isDisjunctiveFacet(facetName)) return [];
        return this.disjunctiveFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of hierarchical refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getHierarchicalRefinement: function(facetName) {
        // we send an array but we currently do not support multiple
        // hierarchicalRefinements for a hierarchicalFacet
        return this.hierarchicalFacetsRefinements[facetName] || [];
    },
    /**
   * Get the list of exclude refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {string[]} list of refinements
   */ getExcludeRefinements: function(facetName) {
        if (!this.isConjunctiveFacet(facetName)) return [];
        return this.facetsExcludes[facetName] || [];
    },
    /**
   * Remove all the numeric filter for a given (attribute, operator)
   * @method
   * @param {string} attribute attribute to set the filter on
   * @param {string} [operator] operator of the filter (possible values: =, >, >=, <, <=, !=)
   * @param {number} [number] the value to be removed
   * @return {SearchParameters} new instance
   */ removeNumericRefinement: function(attribute, operator, number) {
        var paramValue = number;
        if (paramValue !== undefined) {
            if (!this.isNumericRefined(attribute, operator, paramValue)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator && $fa229fb6834531c7$var$isEqualNumericRefinement(value.val, $b5TIZ(paramValue));
                })
            });
        } else if (operator !== undefined) {
            if (!this.isNumericRefined(attribute, operator)) return this;
            return this.setQueryParameters({
                numericRefinements: this._clearNumericRefinements(function(value, key) {
                    return key === attribute && value.op === operator;
                })
            });
        }
        if (!this.isNumericRefined(attribute)) return this;
        return this.setQueryParameters({
            numericRefinements: this._clearNumericRefinements(function(value, key) {
                return key === attribute;
            })
        });
    },
    /**
   * Get the list of numeric refinements for a single facet
   * @param {string} facetName name of the attribute used for faceting
   * @return {SearchParameters.OperatorList} list of refinements
   */ getNumericRefinements: function(facetName) {
        return this.numericRefinements[facetName] || {};
    },
    /**
   * Return the current refinement for the (attribute, operator)
   * @param {string} attribute attribute in the record
   * @param {string} operator operator applied on the refined values
   * @return {Array.<number|number[]>} refined values
   */ getNumericRefinement: function(attribute, operator) {
        return this.numericRefinements[attribute] && this.numericRefinements[attribute][operator];
    },
    /**
   * Clear numeric filters.
   * @method
   * @private
   * @param {string|SearchParameters.clearCallback} [attribute] optional string or function
   * - If not given, means to clear all the filters.
   * - If `string`, means to clear all refinements for the `attribute` named filter.
   * - If `function`, means to clear all the refinements that return truthy values.
   * @return {Object.<string, OperatorList>} new numeric refinements
   */ _clearNumericRefinements: function _clearNumericRefinements(attribute) {
        if (attribute === undefined) {
            if (!$6Wgxo(this.numericRefinements)) return this.numericRefinements;
            return {};
        } else if (typeof attribute === 'string') return $ka9BV(this.numericRefinements, [
            attribute
        ]);
        else if (typeof attribute === 'function') {
            var hasChanged = false;
            var numericRefinements = this.numericRefinements;
            var newNumericRefinements = Object.keys(numericRefinements).reduce(function(memo, key) {
                var operators = numericRefinements[key];
                var operatorList = {};
                operators = operators || {};
                Object.keys(operators).forEach(function(operator) {
                    var values = operators[operator] || [];
                    var outValues = [];
                    values.forEach(function(value) {
                        var predicateResult = attribute({
                            val: value,
                            op: operator
                        }, key, 'numeric');
                        if (!predicateResult) outValues.push(value);
                    });
                    if (outValues.length !== values.length) hasChanged = true;
                    operatorList[operator] = outValues;
                });
                memo[key] = operatorList;
                return memo;
            }, {});
            if (hasChanged) return newNumericRefinements;
            return this.numericRefinements;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Add a facet to the facets attribute of the helper configuration, if it
   * isn't already present.
   * @method
   * @param {string} facet facet name to add
   * @return {SearchParameters} new instance
   */ addFacet: function addFacet(facet) {
        if (this.isConjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            facets: this.facets.concat([
                facet
            ])
        });
    },
    /**
   * Add a disjunctive facet to the disjunctiveFacets attribute of the helper
   * configuration, if it isn't already present.
   * @method
   * @param {string} facet disjunctive facet name to add
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacet: function addDisjunctiveFacet(facet) {
        if (this.isDisjunctiveFacet(facet)) return this;
        return this.setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.concat([
                facet
            ])
        });
    },
    /**
   * Add a hierarchical facet to the hierarchicalFacets attribute of the helper
   * configuration.
   * @method
   * @param {object} hierarchicalFacet hierarchical facet to add
   * @return {SearchParameters} new instance
   * @throws will throw an error if a hierarchical facet with the same name was already declared
   */ addHierarchicalFacet: function addHierarchicalFacet(hierarchicalFacet) {
        if (this.isHierarchicalFacet(hierarchicalFacet.name)) throw new Error('Cannot declare two hierarchical facets with the same name: `' + hierarchicalFacet.name + '`');
        return this.setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.concat([
                hierarchicalFacet
            ])
        });
    },
    /**
   * Add a refinement on a "normal" facet
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addFacetRefinement: function addFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if ($gRx5R.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $gRx5R.addRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Exclude a value from a "normal" facet
   * @method
   * @param {string} facet attribute to apply the exclusion on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addExcludeRefinement: function addExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if ($gRx5R.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $gRx5R.addRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Adds a refinement on a disjunctive facet.
   * @method
   * @param {string} facet attribute to apply the faceting on
   * @param {string} value value of the attribute (will be converted to string)
   * @return {SearchParameters} new instance
   */ addDisjunctiveFacetRefinement: function addDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        if ($gRx5R.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $gRx5R.addRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * addTagRefinement adds a tag to the list used to filter the results
   * @param {string} tag tag to be added
   * @return {SearchParameters} new instance
   */ addTagRefinement: function addTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.concat(tag)
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Remove a facet from the facets attribute of the helper configuration, if it
   * is present.
   * @method
   * @param {string} facet facet name to remove
   * @return {SearchParameters} new instance
   */ removeFacet: function removeFacet(facet) {
        if (!this.isConjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            facets: this.facets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a disjunctive facet from the disjunctiveFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet disjunctive facet name to remove
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacet: function removeDisjunctiveFacet(facet) {
        if (!this.isDisjunctiveFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            disjunctiveFacets: this.disjunctiveFacets.filter(function(f) {
                return f !== facet;
            })
        });
    },
    /**
   * Remove a hierarchical facet from the hierarchicalFacets attribute of the
   * helper configuration, if it is present.
   * @method
   * @param {string} facet hierarchical facet name to remove
   * @return {SearchParameters} new instance
   */ removeHierarchicalFacet: function removeHierarchicalFacet(facet) {
        if (!this.isHierarchicalFacet(facet)) return this;
        return this.clearRefinements(facet).setQueryParameters({
            hierarchicalFacets: this.hierarchicalFacets.filter(function(f) {
                return f.name !== facet;
            })
        });
    },
    /**
   * Remove a refinement set on facet. If a value is provided, it will clear the
   * refinement for the given value, otherwise it will clear all the refinement
   * values for the faceted attribute.
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} [value] value used to filter
   * @return {SearchParameters} new instance
   */ removeFacetRefinement: function removeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if (!$gRx5R.isRefined(this.facetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            facetsRefinements: $gRx5R.removeRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Remove a negative refinement on a facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeExcludeRefinement: function removeExcludeRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        if (!$gRx5R.isRefined(this.facetsExcludes, facet, value)) return this;
        return this.setQueryParameters({
            facetsExcludes: $gRx5R.removeRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Remove a refinement on a disjunctive facet
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {string} value value used to filter
   * @return {SearchParameters} new instance
   */ removeDisjunctiveFacetRefinement: function removeDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        if (!$gRx5R.isRefined(this.disjunctiveFacetsRefinements, facet, value)) return this;
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $gRx5R.removeRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Remove a tag from the list of tag refinements
   * @method
   * @param {string} tag the tag to remove
   * @return {SearchParameters} new instance
   */ removeTagRefinement: function removeTagRefinement(tag) {
        if (!this.isTagRefined(tag)) return this;
        var modification = {
            tagRefinements: this.tagRefinements.filter(function(t) {
                return t !== tag;
            })
        };
        return this.setQueryParameters(modification);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   * @deprecated since version 2.19.0, see {@link SearchParameters#toggleFacetRefinement}
   */ toggleRefinement: function toggleRefinement(facet, value) {
        return this.toggleFacetRefinement(facet, value);
    },
    /**
   * Generic toggle refinement method to use with facet, disjunctive facets
   * and hierarchical facets
   * @param  {string} facet the facet to refine
   * @param  {string} value the associated value
   * @return {SearchParameters} new instance
   * @throws will throw an error if the facet is not declared in the settings of the helper
   */ toggleFacetRefinement: function toggleFacetRefinement(facet, value) {
        if (this.isHierarchicalFacet(facet)) return this.toggleHierarchicalFacetRefinement(facet, value);
        else if (this.isConjunctiveFacet(facet)) return this.toggleConjunctiveFacetRefinement(facet, value);
        else if (this.isDisjunctiveFacet(facet)) return this.toggleDisjunctiveFacetRefinement(facet, value);
        throw new Error('Cannot refine the undeclared facet ' + facet + '; it should be added to the helper options facets, disjunctiveFacets or hierarchicalFacets');
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleConjunctiveFacetRefinement: function toggleConjunctiveFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        return this.setQueryParameters({
            facetsRefinements: $gRx5R.toggleRefinement(this.facetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleExcludeFacetRefinement: function toggleExcludeFacetRefinement(facet, value) {
        if (!this.isConjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the facets attribute of the helper configuration');
        return this.setQueryParameters({
            facetsExcludes: $gRx5R.toggleRefinement(this.facetsExcludes, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleDisjunctiveFacetRefinement: function toggleDisjunctiveFacetRefinement(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) throw new Error(facet + ' is not defined in the disjunctiveFacets attribute of the helper configuration');
        return this.setQueryParameters({
            disjunctiveFacetsRefinements: $gRx5R.toggleRefinement(this.disjunctiveFacetsRefinements, facet, value)
        });
    },
    /**
   * Switch the refinement applied over a facet/value
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {SearchParameters} new instance
   */ toggleHierarchicalFacetRefinement: function toggleHierarchicalFacetRefinement(facet, value) {
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration');
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facet));
        var mod = {};
        var upOneOrMultipleLevel = this.hierarchicalFacetsRefinements[facet] !== undefined && this.hierarchicalFacetsRefinements[facet].length > 0 && // remove current refinement:
        // refinement was 'beer > IPA', call is toggleRefine('beer > IPA'), refinement should be `beer`
        (this.hierarchicalFacetsRefinements[facet][0] === value || // remove a parent refinement of the current refinement:
        //  - refinement was 'beer > IPA > Flying dog'
        //  - call is toggleRefine('beer > IPA')
        //  - refinement should be `beer`
        this.hierarchicalFacetsRefinements[facet][0].indexOf(value + separator) === 0);
        if (upOneOrMultipleLevel) {
            if (value.indexOf(separator) === -1) // go back to root level
            mod[facet] = [];
            else mod[facet] = [
                value.slice(0, value.lastIndexOf(separator))
            ];
        } else mod[facet] = [
            value
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $kee8o({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Adds a refinement on a hierarchical facet.
   * @param {string} facet the facet name
   * @param {string} path the hierarchical facet path
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is refined
   */ addHierarchicalFacetRefinement: function(facet, path) {
        if (this.isHierarchicalFacetRefined(facet)) throw new Error(facet + ' is already refined.');
        if (!this.isHierarchicalFacet(facet)) throw new Error(facet + ' is not defined in the hierarchicalFacets attribute of the helper configuration.');
        var mod = {};
        mod[facet] = [
            path
        ];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $kee8o({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Removes the refinement set on a hierarchical facet.
   * @param {string} facet the facet name
   * @return {SearchParameter} the new state
   * @throws Error if the facet is not defined or if the facet is not refined
   */ removeHierarchicalFacetRefinement: function(facet) {
        if (!this.isHierarchicalFacetRefined(facet)) return this;
        var mod = {};
        mod[facet] = [];
        return this.setQueryParameters({
            hierarchicalFacetsRefinements: $kee8o({}, mod, this.hierarchicalFacetsRefinements)
        });
    },
    /**
   * Switch the tag refinement
   * @method
   * @param {string} tag the tag to remove or add
   * @return {SearchParameters} new instance
   */ toggleTagRefinement: function toggleTagRefinement(tag) {
        if (this.isTagRefined(tag)) return this.removeTagRefinement(tag);
        return this.addTagRefinement(tag);
    },
    /**
   * Test if the facet name is from one of the disjunctive facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a disjunctive facet
   */ isDisjunctiveFacet: function(facet) {
        return this.disjunctiveFacets.indexOf(facet) > -1;
    },
    /**
   * Test if the facet name is from one of the hierarchical facets
   * @method
   * @param {string} facetName facet name to test
   * @return {boolean} true if facetName is a hierarchical facet
   */ isHierarchicalFacet: function(facetName) {
        return this.getHierarchicalFacetByName(facetName) !== undefined;
    },
    /**
   * Test if the facet name is from one of the conjunctive/normal facets
   * @method
   * @param {string} facet facet name to test
   * @return {boolean} true if facet is a conjunctive facet
   */ isConjunctiveFacet: function(facet) {
        return this.facets.indexOf(facet) > -1;
    },
    /**
   * Returns true if the facet is refined, either for a specific value or in
   * general.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value, optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isFacetRefined: function isFacetRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $gRx5R.isRefined(this.facetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains exclusions or if a specific value is
   * excluded.
   *
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} [value] optional value. If passed will test that this value
   * is filtering the given facet.
   * @return {boolean} returns true if refined
   */ isExcludeRefined: function isExcludeRefined(facet, value) {
        if (!this.isConjunctiveFacet(facet)) return false;
        return $gRx5R.isRefined(this.facetsExcludes, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isDisjunctiveFacetRefined: function isDisjunctiveFacetRefined(facet, value) {
        if (!this.isDisjunctiveFacet(facet)) return false;
        return $gRx5R.isRefined(this.disjunctiveFacetsRefinements, facet, value);
    },
    /**
   * Returns true if the facet contains a refinement, or if a value passed is a
   * refinement for the facet.
   * @method
   * @param {string} facet name of the attribute for used for faceting
   * @param {string} value optional, will test if the value is used for refinement
   * if there is one, otherwise will test if the facet contains any refinement
   * @return {boolean} true if the facet is refined
   */ isHierarchicalFacetRefined: function isHierarchicalFacetRefined(facet, value) {
        if (!this.isHierarchicalFacet(facet)) return false;
        var refinements = this.getHierarchicalRefinement(facet);
        if (!value) return refinements.length > 0;
        return refinements.indexOf(value) !== -1;
    },
    /**
   * Test if the triple (attribute, operator, value) is already refined.
   * If only the attribute and the operator are provided, it tests if the
   * contains any refinement value.
   * @method
   * @param {string} attribute attribute for which the refinement is applied
   * @param {string} [operator] operator of the refinement
   * @param {string} [value] value of the refinement
   * @return {boolean} true if it is refined
   */ isNumericRefined: function isNumericRefined(attribute, operator, value) {
        if (value === undefined && operator === undefined) return Boolean(this.numericRefinements[attribute]);
        var isOperatorDefined = this.numericRefinements[attribute] && this.numericRefinements[attribute][operator] !== undefined;
        if (value === undefined || !isOperatorDefined) return isOperatorDefined;
        var parsedValue = $b5TIZ(value);
        var isAttributeValueDefined = $fa229fb6834531c7$var$findArray(this.numericRefinements[attribute][operator], parsedValue) !== undefined;
        return isOperatorDefined && isAttributeValueDefined;
    },
    /**
   * Returns true if the tag refined, false otherwise
   * @method
   * @param {string} tag the tag to check
   * @return {boolean} true if tag is refined
   */ isTagRefined: function isTagRefined(tag) {
        return this.tagRefinements.indexOf(tag) !== -1;
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedDisjunctiveFacets: function getRefinedDisjunctiveFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        // attributes used for numeric filter can also be disjunctive
        var disjunctiveNumericRefinedFacets = $7t031(Object.keys(this.numericRefinements).filter(function(facet) {
            return Object.keys(self.numericRefinements[facet]).length > 0;
        }), this.disjunctiveFacets);
        return Object.keys(this.disjunctiveFacetsRefinements).filter(function(facet) {
            return self.disjunctiveFacetsRefinements[facet].length > 0;
        }).concat(disjunctiveNumericRefinedFacets).concat(this.getRefinedHierarchicalFacets()).sort();
    },
    /**
   * Returns the list of all disjunctive facets refined
   * @method
   * @param {string} facet name of the attribute used for faceting
   * @param {value} value value used for filtering
   * @return {string[]} returns the list of refinements
   */ getRefinedHierarchicalFacets: function getRefinedHierarchicalFacets() {
        // eslint-disable-next-line consistent-this
        var self = this;
        return $7t031(// enforce the order between the two arrays,
        // so that refinement name index === hierarchical facet index
        this.hierarchicalFacets.map(function(facet) {
            return facet.name;
        }), Object.keys(this.hierarchicalFacetsRefinements).filter(function(facet) {
            return self.hierarchicalFacetsRefinements[facet].length > 0;
        })).sort();
    },
    /**
   * Returned the list of all disjunctive facets not refined
   * @method
   * @return {string[]} returns the list of facets that are not refined
   */ getUnrefinedDisjunctiveFacets: function() {
        var refinedFacets = this.getRefinedDisjunctiveFacets();
        return this.disjunctiveFacets.filter(function(f) {
            return refinedFacets.indexOf(f) === -1;
        });
    },
    managedParameters: [
        'index',
        'facets',
        'disjunctiveFacets',
        'facetsRefinements',
        'hierarchicalFacets',
        'facetsExcludes',
        'disjunctiveFacetsRefinements',
        'numericRefinements',
        'tagRefinements',
        'hierarchicalFacetsRefinements'
    ],
    getQueryParams: function getQueryParams() {
        var managedParameters = this.managedParameters;
        var queryParams = {};
        // eslint-disable-next-line consistent-this
        var self = this;
        Object.keys(this).forEach(function(paramName) {
            var paramValue = self[paramName];
            if (managedParameters.indexOf(paramName) === -1 && paramValue !== undefined) queryParams[paramName] = paramValue;
        });
        return queryParams;
    },
    /**
   * Let the user set a specific value for a given parameter. Will return the
   * same instance if the parameter is invalid or if the value is the same as the
   * previous one.
   * @method
   * @param {string} parameter the parameter name
   * @param {any} value the value to be set, must be compliant with the definition
   * of the attribute on the object
   * @return {SearchParameters} the updated state
   */ setQueryParameter: function setParameter(parameter, value) {
        if (this[parameter] === value) return this;
        var modification = {};
        modification[parameter] = value;
        return this.setQueryParameters(modification);
    },
    /**
   * Let the user set any of the parameters with a plain object.
   * @method
   * @param {object} params all the keys and the values to be updated
   * @return {SearchParameters} a new updated instance
   */ setQueryParameters: function setQueryParameters(params) {
        if (!params) return this;
        var error = $fa229fb6834531c7$var$SearchParameters.validate(this, params);
        if (error) throw error;
        // eslint-disable-next-line consistent-this
        var self = this;
        var nextWithNumbers = $fa229fb6834531c7$var$SearchParameters._parseNumbers(params);
        var previousPlainObject = Object.keys(this).reduce(function(acc, key) {
            acc[key] = self[key];
            return acc;
        }, {});
        var nextPlainObject = Object.keys(nextWithNumbers).reduce(function(previous, key) {
            var isPreviousValueDefined = previous[key] !== undefined;
            var isNextValueDefined = nextWithNumbers[key] !== undefined;
            if (isPreviousValueDefined && !isNextValueDefined) return $ka9BV(previous, [
                key
            ]);
            if (isNextValueDefined) previous[key] = nextWithNumbers[key];
            return previous;
        }, previousPlainObject);
        return new this.constructor(nextPlainObject);
    },
    /**
   * Returns a new instance with the page reset. Two scenarios possible:
   * the page is omitted -> return the given instance
   * the page is set -> return a new instance with a page of 0
   * @return {SearchParameters} a new updated instance
   */ resetPage: function() {
        if (this.page === undefined) return this;
        return this.setPage(0);
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSortBy: function(hierarchicalFacet) {
        return hierarchicalFacet.sortBy || [
            'isRefined:desc',
            'name:asc'
        ];
    },
    /**
   * Helper function to get the hierarchicalFacet separator or the default one (`>`)
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.separator or `>` as default
   */ _getHierarchicalFacetSeparator: function(hierarchicalFacet) {
        return hierarchicalFacet.separator || ' > ';
    },
    /**
   * Helper function to get the hierarchicalFacet prefix path or null
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.rootPath or null as default
   */ _getHierarchicalRootPath: function(hierarchicalFacet) {
        return hierarchicalFacet.rootPath || null;
    },
    /**
   * Helper function to check if we show the parent level of the hierarchicalFacet
   * @private
   * @param  {object} hierarchicalFacet the hierarchicalFacet object
   * @return {string} returns the hierarchicalFacet.showParentLevel or true as default
   */ _getHierarchicalShowParentLevel: function(hierarchicalFacet) {
        if (typeof hierarchicalFacet.showParentLevel === 'boolean') return hierarchicalFacet.showParentLevel;
        return true;
    },
    /**
   * Helper function to get the hierarchicalFacet by it's name
   * @param  {string} hierarchicalFacetName the hierarchicalFacet name
   * @return {object} a hierarchicalFacet
   */ getHierarchicalFacetByName: function(hierarchicalFacetName) {
        return $5B6z1(this.hierarchicalFacets, function(f) {
            return f.name === hierarchicalFacetName;
        });
    },
    /**
   * Get the current breadcrumb for a hierarchical facet, as an array
   * @param  {string} facetName Hierarchical facet name
   * @return {array.<string>} the path as an array of string
   */ getHierarchicalFacetBreadcrumb: function(facetName) {
        if (!this.isHierarchicalFacet(facetName)) return [];
        var refinement = this.getHierarchicalRefinement(facetName)[0];
        if (!refinement) return [];
        var separator = this._getHierarchicalFacetSeparator(this.getHierarchicalFacetByName(facetName));
        var path = refinement.split(separator);
        return path.map(function(part) {
            return part.trim();
        });
    },
    toString: function() {
        return JSON.stringify(this, null, 2);
    }
};
/**
 * Callback used for clearRefinement method
 * @callback SearchParameters.clearCallback
 * @param {OperatorList|FacetList} value the value of the filter
 * @param {string} key the current attribute name
 * @param {string} type `numeric`, `disjunctiveFacet`, `conjunctiveFacet`, `hierarchicalFacet` or `exclude`
 * depending on the type of facet
 * @return {boolean} `true` if the element should be removed. `false` otherwise.
 */ module.exports = $fa229fb6834531c7$var$SearchParameters;

});
parcelRegister("kee8o", function(module, exports) {
'use strict';
// NOTE: this behaves like lodash/defaults, but doesn't mutate the target
// it also preserve keys order
module.exports = function defaultsPure() {
    var sources = Array.prototype.slice.call(arguments);
    return sources.reduceRight(function(acc, source) {
        Object.keys(Object(source)).forEach(function(key) {
            if (source[key] === undefined) return;
            if (acc[key] !== undefined) // remove if already added, so that we can add it in correct order
            delete acc[key];
            acc[key] = source[key];
        });
        return acc;
    }, {});
};

});

parcelRegister("5B6z1", function(module, exports) {
'use strict';
// @MAJOR can be replaced by native Array#find when we change support
module.exports = function find(array, comparator) {
    if (!Array.isArray(array)) return undefined;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return array[i];
    }
    return undefined;
};

});

parcelRegister("7t031", function(module, exports) {
'use strict';
function $56fb47540a73f032$var$intersection(arr1, arr2) {
    return arr1.filter(function(value, index) {
        return arr2.indexOf(value) > -1 && arr1.indexOf(value) === index /* skips duplicates */ ;
    });
}
module.exports = $56fb47540a73f032$var$intersection;

});

parcelRegister("b5TIZ", function(module, exports) {
'use strict';
function $813b63199a18d078$var$valToNumber(v) {
    if (typeof v === 'number') return v;
    else if (typeof v === 'string') return parseFloat(v);
    else if (Array.isArray(v)) return v.map($813b63199a18d078$var$valToNumber);
    throw new Error('The value should be a number, a parsable string or an array of those.');
}
module.exports = $813b63199a18d078$var$valToNumber;

});

parcelRegister("1dEVb", function(module, exports) {
'use strict';
module.exports = function isValidUserToken(userToken) {
    if (userToken === null) return false;
    return /^[a-zA-Z0-9_-]{1,64}$/.test(userToken);
};

});

parcelRegister("gRx5R", function(module, exports) {
'use strict';

var $kee8o = parcelRequire("kee8o");

var $6Wgxo = parcelRequire("6Wgxo");

var $ka9BV = parcelRequire("ka9BV");
var $c46b4446075c5ddd$var$lib = {
    /**
   * Adds a refinement to a RefinementList
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement, if the value is not a string it will be converted
   * @return {RefinementList} a new and updated refinement list
   */ addRefinement: function addRefinement(refinementList, attribute, value) {
        if ($c46b4446075c5ddd$var$lib.isRefined(refinementList, attribute, value)) return refinementList;
        var valueAsString = '' + value;
        var facetRefinement = !refinementList[attribute] ? [
            valueAsString
        ] : refinementList[attribute].concat(valueAsString);
        var mod = {};
        mod[attribute] = facetRefinement;
        return $kee8o({}, mod, refinementList);
    },
    /**
   * Removes refinement(s) for an attribute:
   *  - if the value is specified removes the refinement for the value on the attribute
   *  - if no value is specified removes all the refinements for this attribute
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} [value] the value of the refinement
   * @return {RefinementList} a new and updated refinement lst
   */ removeRefinement: function removeRefinement(refinementList, attribute, value) {
        if (value === undefined) // we use the "filter" form of clearRefinement, since it leaves empty values as-is
        // the form with a string will remove the attribute completely
        return $c46b4446075c5ddd$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f;
        });
        var valueAsString = '' + value;
        return $c46b4446075c5ddd$var$lib.clearRefinement(refinementList, function(v, f) {
            return attribute === f && valueAsString === v;
        });
    },
    /**
   * Toggles the refinement value for an attribute.
   * @param {RefinementList} refinementList the initial list
   * @param {string} attribute the attribute to refine
   * @param {string} value the value of the refinement
   * @return {RefinementList} a new and updated list
   */ toggleRefinement: function toggleRefinement(refinementList, attribute, value) {
        if (value === undefined) throw new Error('toggleRefinement should be used with a value');
        if ($c46b4446075c5ddd$var$lib.isRefined(refinementList, attribute, value)) return $c46b4446075c5ddd$var$lib.removeRefinement(refinementList, attribute, value);
        return $c46b4446075c5ddd$var$lib.addRefinement(refinementList, attribute, value);
    },
    /**
   * Clear all or parts of a RefinementList. Depending on the arguments, three
   * kinds of behavior can happen:
   *  - if no attribute is provided: clears the whole list
   *  - if an attribute is provided as a string: clears the list for the specific attribute
   *  - if an attribute is provided as a function: discards the elements for which the function returns true
   * @param {RefinementList} refinementList the initial list
   * @param {string} [attribute] the attribute or function to discard
   * @param {string} [refinementType] optional parameter to give more context to the attribute function
   * @return {RefinementList} a new and updated refinement list
   */ clearRefinement: function clearRefinement(refinementList, attribute, refinementType) {
        if (attribute === undefined) {
            // return the same object if the list is already empty
            // this is mainly for tests, as it doesn't have much impact on performance
            if (!$6Wgxo(refinementList)) return refinementList;
            return {};
        } else if (typeof attribute === 'string') return $ka9BV(refinementList, [
            attribute
        ]);
        else if (typeof attribute === 'function') {
            var hasChanged = false;
            var newRefinementList = Object.keys(refinementList).reduce(function(memo, key) {
                var values = refinementList[key] || [];
                var facetList = values.filter(function(value) {
                    return !attribute(value, key, refinementType);
                });
                if (facetList.length !== values.length) hasChanged = true;
                memo[key] = facetList;
                return memo;
            }, {});
            if (hasChanged) return newRefinementList;
            return refinementList;
        }
        // We return nothing if the attribute is not undefined, a string or a function,
        // as it is not a valid value for a refinement
        return undefined;
    },
    /**
   * Test if the refinement value is used for the attribute. If no refinement value
   * is provided, test if the refinementList contains any refinement for the
   * given attribute.
   * @param {RefinementList} refinementList the list of refinement
   * @param {string} attribute name of the attribute
   * @param {string} [refinementValue] value of the filter/refinement
   * @return {boolean} true if the attribute is refined, false otherwise
   */ isRefined: function isRefined(refinementList, attribute, refinementValue) {
        var containsRefinements = Boolean(refinementList[attribute]) && refinementList[attribute].length > 0;
        if (refinementValue === undefined || !containsRefinements) return containsRefinements;
        var refinementValueAsString = '' + refinementValue;
        return refinementList[attribute].indexOf(refinementValueAsString) !== -1;
    }
};
module.exports = $c46b4446075c5ddd$var$lib;

});


parcelRegister("dBe1E", function(module, exports) {
'use strict';

var $5Y7uW = parcelRequire("5Y7uW");

var $kee8o = parcelRequire("kee8o");

var $iOTWh = parcelRequire("iOTWh");

var $5B6z1 = parcelRequire("5B6z1");

var $7qXEB = parcelRequire("7qXEB");

var $jARvP = parcelRequire("jARvP");

var $2KSyk = parcelRequire("2KSyk");

var $3XDAH = parcelRequire("3XDAH");
var $9e699c47e0c26cf0$var$escapeFacetValue = $iOTWh.escapeFacetValue;
var $9e699c47e0c26cf0$var$unescapeFacetValue = $iOTWh.unescapeFacetValue;

var $9ztro = parcelRequire("9ztro");
/**
 * @typedef SearchResults.Facet
 * @type {object}
 * @property {string} name name of the attribute in the record
 * @property {object} data the faceting data: value, number of entries
 * @property {object} stats undefined unless facet_stats is retrieved from algolia
 */ /**
 * @typedef SearchResults.HierarchicalFacet
 * @type {object}
 * @property {string} name name of the current value given the hierarchical level, trimmed.
 * If root node, you get the facet name
 * @property {number} count number of objects matching this hierarchical value
 * @property {string} path the current hierarchical value full path
 * @property {boolean} isRefined `true` if the current value was refined, `false` otherwise
 * @property {HierarchicalFacet[]} data sub values for the current level
 */ /**
 * @typedef SearchResults.FacetValue
 * @type {object}
 * @property {string} name the facet value itself
 * @property {number} count times this facet appears in the results
 * @property {boolean} isRefined is the facet currently selected
 * @property {boolean} isExcluded is the facet currently excluded (only for conjunctive facets)
 */ /**
 * @typedef Refinement
 * @type {object}
 * @property {string} type the type of filter used:
 * `numeric`, `facet`, `exclude`, `disjunctive`, `hierarchical`
 * @property {string} attributeName name of the attribute used for filtering
 * @property {string} name the value of the filter
 * @property {number} numericValue the value as a number. Only for numeric filters.
 * @property {string} operator the operator used. Only for numeric filters.
 * @property {number} count the number of computed hits for this filter. Only on facets.
 * @property {boolean} exhaustive if the count is exhaustive
 */ /**
 * Turn an array of attributes in an object of attributes with their position in the array as value
 * @param {string[]} attributes the list of attributes in the record
 * @return {object} the list of attributes indexed by attribute name
 */ function $9e699c47e0c26cf0$var$getIndices(attributes) {
    var indices = {};
    attributes.forEach(function(val, idx) {
        indices[val] = idx;
    });
    return indices;
}
function $9e699c47e0c26cf0$var$assignFacetStats(dest, facetStats, key) {
    if (facetStats && facetStats[key]) dest.stats = facetStats[key];
}
/**
 * @typedef {Object} HierarchicalFacet
 * @property {string} name
 * @property {string[]} attributes
 */ /**
 * @param {HierarchicalFacet[]} hierarchicalFacets All hierarchical facets
 * @param {string} hierarchicalAttributeName The name of the hierarchical attribute
 * @return {HierarchicalFacet} The hierarchical facet matching the attribute name
 */ function $9e699c47e0c26cf0$var$findMatchingHierarchicalFacetFromAttributeName(hierarchicalFacets, hierarchicalAttributeName) {
    return $5B6z1(hierarchicalFacets, function facetKeyMatchesAttribute(hierarchicalFacet) {
        var facetNames = hierarchicalFacet.attributes || [];
        return facetNames.indexOf(hierarchicalAttributeName) > -1;
    });
}
// eslint-disable-next-line valid-jsdoc
/**
 * Constructor for SearchResults
 * @class
 * @classdesc SearchResults contains the results of a query to Algolia using the
 * {@link AlgoliaSearchHelper}.
 * @param {SearchParameters} state state that led to the response
 * @param {array.<object>} results the results from algolia client
 * @example <caption>SearchResults of the first query in
 * <a href="http://demos.algolia.com/instant-search-demo">the instant search demo</a></caption>
{
   "hitsPerPage": 10,
   "processingTimeMS": 2,
   "facets": [
      {
         "name": "type",
         "data": {
            "HardGood": 6627,
            "BlackTie": 550,
            "Music": 665,
            "Software": 131,
            "Game": 456,
            "Movie": 1571
         },
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "Free shipping": 5507
         },
         "name": "shipping"
      }
  ],
   "hits": [
      {
         "thumbnailImage": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_54x108_s.gif",
         "_highlightResult": {
            "shortDescription": {
               "matchLevel": "none",
               "value": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
               "matchedWords": []
            },
            "category": {
               "matchLevel": "none",
               "value": "Computer Security Software",
               "matchedWords": []
            },
            "manufacturer": {
               "matchedWords": [],
               "value": "Webroot",
               "matchLevel": "none"
            },
            "name": {
               "value": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
               "matchedWords": [],
               "matchLevel": "none"
            }
         },
         "image": "http://img.bbystatic.com/BestBuy_US/images/products/1688/1688832_105x210_sc.jpg",
         "shipping": "Free shipping",
         "bestSellingRank": 4,
         "shortDescription": "Safeguard your PC, Mac, Android and iOS devices with comprehensive Internet protection",
         "url": "http://www.bestbuy.com/site/webroot-secureanywhere-internet-security-3-devi…d=1219060687969&skuId=1688832&cmp=RMX&ky=2d3GfEmNIzjA0vkzveHdZEBgpPCyMnLTJ",
         "name": "Webroot SecureAnywhere Internet Security (3-Device) (1-Year Subscription) - Mac/Windows",
         "category": "Computer Security Software",
         "salePrice_range": "1 - 50",
         "objectID": "1688832",
         "type": "Software",
         "customerReviewCount": 5980,
         "salePrice": 49.99,
         "manufacturer": "Webroot"
      },
      ....
  ],
   "nbHits": 10000,
   "disjunctiveFacets": [
      {
         "exhaustive": false,
         "data": {
            "5": 183,
            "12": 112,
            "7": 149,
            ...
         },
         "name": "customerReviewCount",
         "stats": {
            "max": 7461,
            "avg": 157.939,
            "min": 1
         }
      },
      {
         "data": {
            "Printer Ink": 142,
            "Wireless Speakers": 60,
            "Point & Shoot Cameras": 48,
            ...
         },
         "name": "category",
         "exhaustive": false
      },
      {
         "exhaustive": false,
         "data": {
            "> 5000": 2,
            "1 - 50": 6524,
            "501 - 2000": 566,
            "201 - 500": 1501,
            "101 - 200": 1360,
            "2001 - 5000": 47
         },
         "name": "salePrice_range"
      },
      {
         "data": {
            "Dynex™": 202,
            "Insignia™": 230,
            "PNY": 72,
            ...
         },
         "name": "manufacturer",
         "exhaustive": false
      }
  ],
   "query": "",
   "nbPages": 100,
   "page": 0,
   "index": "bestbuy"
}
 **/ function $9e699c47e0c26cf0$var$SearchResults(state, results, options) {
    var mainSubResponse = results[0];
    this._rawResults = results;
    // eslint-disable-next-line consistent-this
    var self = this;
    // https://www.algolia.com/doc/api-reference/api-methods/search/#response
    Object.keys(mainSubResponse).forEach(function(key) {
        self[key] = mainSubResponse[key];
    });
    // Make every key of the result options reachable from the instance
    Object.keys(options || {}).forEach(function(key) {
        self[key] = options[key];
    });
    /**
   * query used to generate the results
   * @name query
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * The query as parsed by the engine given all the rules.
   * @name parsedQuery
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * all the records that match the search parameters. Each record is
   * augmented with a new attribute `_highlightResult`
   * which is an object keyed by attribute and with the following properties:
   * - `value` : the value of the facet highlighted (html)
   * - `matchLevel`: `full`, `partial` or `none`, depending on how the query terms match
   * @name hits
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * index where the results come from
   * @name index
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * number of hits per page requested
   * @name hitsPerPage
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of hits of this query on the index
   * @name nbHits
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * total number of pages with respect to the number of hits per page and the total number of hits
   * @name nbPages
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * current page
   * @name page
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ /**
   * The position if the position was guessed by IP.
   * @name aroundLatLng
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "48.8637,2.3615",
   */ /**
   * The radius computed by Algolia.
   * @name automaticRadius
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "126792922",
   */ /**
   * String identifying the server used to serve this request.
   *
   * getRankingInfo needs to be set to `true` for this to be returned
   *
   * @name serverUsed
   * @member {string}
   * @memberof SearchResults
   * @instance
   * @example "c7-use-2.algolia.net",
   */ /**
   * Boolean that indicates if the computation of the counts did time out.
   * @deprecated
   * @name timeoutCounts
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Boolean that indicates if the computation of the hits did time out.
   * @deprecated
   * @name timeoutHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the counts of the facets is exhaustive
   * @name exhaustiveFacetsCount
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * True if the number of hits is exhaustive
   * @name exhaustiveNbHits
   * @member {boolean}
   * @memberof SearchResults
   * @instance
   */ /**
   * Contains the userData if they are set by a [query rule](https://www.algolia.com/doc/guides/query-rules/query-rules-overview/).
   * @name userData
   * @member {object[]}
   * @memberof SearchResults
   * @instance
   */ /**
   * queryID is the unique identifier of the query used to generate the current search results.
   * This value is only available if the `clickAnalytics` search parameter is set to `true`.
   * @name queryID
   * @member {string}
   * @memberof SearchResults
   * @instance
   */ /**
   * sum of the processing time of all the queries
   * @name processingTimeMS
   * @member {number}
   * @memberof SearchResults
   * @instance
   */ this.processingTimeMS = results.reduce(function(sum, result) {
        return result.processingTimeMS === undefined ? sum : sum + result.processingTimeMS;
    }, 0);
    /**
   * disjunctive facets results
   * @member {SearchResults.Facet[]}
   */ this.disjunctiveFacets = [];
    /**
   * disjunctive facets results
   * @member {SearchResults.HierarchicalFacet[]}
   */ this.hierarchicalFacets = state.hierarchicalFacets.map(function initFutureTree() {
        return [];
    });
    /**
   * other facets results
   * @member {SearchResults.Facet[]}
   */ this.facets = [];
    var disjunctiveFacets = state.getRefinedDisjunctiveFacets();
    var facetsIndices = $9e699c47e0c26cf0$var$getIndices(state.facets);
    var disjunctiveFacetsIndices = $9e699c47e0c26cf0$var$getIndices(state.disjunctiveFacets);
    var nextDisjunctiveResult = 1;
    // Since we send request only for disjunctive facets that have been refined,
    // we get the facets information from the first, general, response.
    var mainFacets = mainSubResponse.facets || {};
    Object.keys(mainFacets).forEach(function(facetKey) {
        var facetValueObject = mainFacets[facetKey];
        var hierarchicalFacet = $9e699c47e0c26cf0$var$findMatchingHierarchicalFacetFromAttributeName(state.hierarchicalFacets, facetKey);
        if (hierarchicalFacet) {
            // Place the hierarchicalFacet data at the correct index depending on
            // the attributes order that was defined at the helper initialization
            var facetIndex = hierarchicalFacet.attributes.indexOf(facetKey);
            var idxAttributeName = $7qXEB(state.hierarchicalFacets, function(f) {
                return f.name === hierarchicalFacet.name;
            });
            self.hierarchicalFacets[idxAttributeName][facetIndex] = {
                attribute: facetKey,
                data: facetValueObject,
                exhaustive: mainSubResponse.exhaustiveFacetsCount
            };
        } else {
            var isFacetDisjunctive = state.disjunctiveFacets.indexOf(facetKey) !== -1;
            var isFacetConjunctive = state.facets.indexOf(facetKey) !== -1;
            var position;
            if (isFacetDisjunctive) {
                position = disjunctiveFacetsIndices[facetKey];
                self.disjunctiveFacets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $9e699c47e0c26cf0$var$assignFacetStats(self.disjunctiveFacets[position], mainSubResponse.facets_stats, facetKey);
            }
            if (isFacetConjunctive) {
                position = facetsIndices[facetKey];
                self.facets[position] = {
                    name: facetKey,
                    data: facetValueObject,
                    exhaustive: mainSubResponse.exhaustiveFacetsCount
                };
                $9e699c47e0c26cf0$var$assignFacetStats(self.facets[position], mainSubResponse.facets_stats, facetKey);
            }
        }
    });
    // Make sure we do not keep holes within the hierarchical facets
    this.hierarchicalFacets = $5Y7uW(this.hierarchicalFacets);
    // aggregate the refined disjunctive facets
    disjunctiveFacets.forEach(function(disjunctiveFacet) {
        var result = results[nextDisjunctiveResult];
        var facets = result && result.facets ? result.facets : {};
        var hierarchicalFacet = state.getHierarchicalFacetByName(disjunctiveFacet);
        // There should be only item in facets.
        Object.keys(facets).forEach(function(dfacet) {
            var facetResults = facets[dfacet];
            var position;
            if (hierarchicalFacet) {
                position = $7qXEB(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $7qXEB(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                self.hierarchicalFacets[position][attributeIndex].data = $2KSyk({}, self.hierarchicalFacets[position][attributeIndex].data, facetResults);
            } else {
                position = disjunctiveFacetsIndices[dfacet];
                var dataFromMainRequest = mainSubResponse.facets && mainSubResponse.facets[dfacet] || {};
                self.disjunctiveFacets[position] = {
                    name: dfacet,
                    data: $kee8o({}, facetResults, dataFromMainRequest),
                    exhaustive: result.exhaustiveFacetsCount
                };
                $9e699c47e0c26cf0$var$assignFacetStats(self.disjunctiveFacets[position], result.facets_stats, dfacet);
                if (state.disjunctiveFacetsRefinements[dfacet]) state.disjunctiveFacetsRefinements[dfacet].forEach(function(refinementValue) {
                    // add the disjunctive refinements if it is no more retrieved
                    if (!self.disjunctiveFacets[position].data[refinementValue] && state.disjunctiveFacetsRefinements[dfacet].indexOf($9e699c47e0c26cf0$var$unescapeFacetValue(refinementValue)) > -1) self.disjunctiveFacets[position].data[refinementValue] = 0;
                });
            }
        });
        nextDisjunctiveResult++;
    });
    // if we have some parent level values for hierarchical facets, merge them
    state.getRefinedHierarchicalFacets().forEach(function(refinedFacet) {
        var hierarchicalFacet = state.getHierarchicalFacetByName(refinedFacet);
        var separator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = state.getHierarchicalRefinement(refinedFacet);
        // if we are already at a root refinement (or no refinement at all), there is no
        // root level values request
        if (currentRefinement.length === 0 || currentRefinement[0].split(separator).length < 2) return;
        results.slice(nextDisjunctiveResult).forEach(function(result) {
            var facets = result && result.facets ? result.facets : {};
            Object.keys(facets).forEach(function(dfacet) {
                var facetResults = facets[dfacet];
                var position = $7qXEB(state.hierarchicalFacets, function(f) {
                    return f.name === hierarchicalFacet.name;
                });
                var attributeIndex = $7qXEB(self.hierarchicalFacets[position], function(f) {
                    return f.attribute === dfacet;
                });
                // previous refinements and no results so not able to find it
                if (attributeIndex === -1) return;
                // when we always get root levels, if the hits refinement is `beers > IPA` (count: 5),
                // then the disjunctive values will be `beers` (count: 100),
                // but we do not want to display
                //   | beers (100)
                //     > IPA (5)
                // We want
                //   | beers (5)
                //     > IPA (5)
                var defaultData = {};
                if (currentRefinement.length > 0) {
                    var root = currentRefinement[0].split(separator)[0];
                    defaultData[root] = self.hierarchicalFacets[position][attributeIndex].data[root];
                }
                self.hierarchicalFacets[position][attributeIndex].data = $kee8o(defaultData, facetResults, self.hierarchicalFacets[position][attributeIndex].data);
            });
            nextDisjunctiveResult++;
        });
    });
    // add the excludes
    Object.keys(state.facetsExcludes).forEach(function(facetName) {
        var excludes = state.facetsExcludes[facetName];
        var position = facetsIndices[facetName];
        self.facets[position] = {
            name: facetName,
            data: mainFacets[facetName],
            exhaustive: mainSubResponse.exhaustiveFacetsCount
        };
        excludes.forEach(function(facetValue) {
            self.facets[position] = self.facets[position] || {
                name: facetName
            };
            self.facets[position].data = self.facets[position].data || {};
            self.facets[position].data[facetValue] = 0;
        });
    });
    /**
   * @type {Array}
   */ this.hierarchicalFacets = this.hierarchicalFacets.map($9ztro(state));
    /**
   * @type {Array}
   */ this.facets = $5Y7uW(this.facets);
    /**
   * @type {Array}
   */ this.disjunctiveFacets = $5Y7uW(this.disjunctiveFacets);
    this._state = state;
}
/**
 * Get a facet object with its name
 * @deprecated
 * @param {string} name name of the faceted attribute
 * @return {SearchResults.Facet} the facet object
 */ $9e699c47e0c26cf0$var$SearchResults.prototype.getFacetByName = function(name) {
    function predicate(facet) {
        return facet.name === name;
    }
    return $5B6z1(this.facets, predicate) || $5B6z1(this.disjunctiveFacets, predicate) || $5B6z1(this.hierarchicalFacets, predicate);
};
/**
 * Get the facet values of a specified attribute from a SearchResults object.
 * @private
 * @param {SearchResults} results the search results to search in
 * @param {string} attribute name of the faceted attribute to search for
 * @return {array|object} facet values. For the hierarchical facets it is an object.
 */ function $9e699c47e0c26cf0$var$extractNormalizedFacetValues(results, attribute) {
    function predicate(facet) {
        return facet.name === attribute;
    }
    if (results._state.isConjunctiveFacet(attribute)) {
        var facet = $5B6z1(results.facets, predicate);
        if (!facet) return [];
        return Object.keys(facet.data).map(function(name) {
            var value = $9e699c47e0c26cf0$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: facet.data[name],
                isRefined: results._state.isFacetRefined(attribute, value),
                isExcluded: results._state.isExcludeRefined(attribute, name)
            };
        });
    } else if (results._state.isDisjunctiveFacet(attribute)) {
        var disjunctiveFacet = $5B6z1(results.disjunctiveFacets, predicate);
        if (!disjunctiveFacet) return [];
        return Object.keys(disjunctiveFacet.data).map(function(name) {
            var value = $9e699c47e0c26cf0$var$escapeFacetValue(name);
            return {
                name: name,
                escapedValue: value,
                count: disjunctiveFacet.data[name],
                isRefined: results._state.isDisjunctiveFacetRefined(attribute, value)
            };
        });
    } else if (results._state.isHierarchicalFacet(attribute)) {
        var hierarchicalFacetValues = $5B6z1(results.hierarchicalFacets, predicate);
        if (!hierarchicalFacetValues) return hierarchicalFacetValues;
        var hierarchicalFacet = results._state.getHierarchicalFacetByName(attribute);
        var separator = results._state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var currentRefinement = $9e699c47e0c26cf0$var$unescapeFacetValue(results._state.getHierarchicalRefinement(attribute)[0] || '');
        if (currentRefinement.indexOf(hierarchicalFacet.rootPath) === 0) currentRefinement = currentRefinement.replace(hierarchicalFacet.rootPath + separator, '');
        var currentRefinementSplit = currentRefinement.split(separator);
        currentRefinementSplit.unshift(attribute);
        $9e699c47e0c26cf0$var$setIsRefined(hierarchicalFacetValues, currentRefinementSplit, 0);
        return hierarchicalFacetValues;
    }
    return undefined;
}
/**
 * Set the isRefined of a hierarchical facet result based on the current state.
 * @param {SearchResults.HierarchicalFacet} item Hierarchical facet to fix
 * @param {string[]} currentRefinement array of parts of the current hierarchical refinement
 * @param {number} depth recursion depth in the currentRefinement
 * @return {undefined} function mutates the item
 */ function $9e699c47e0c26cf0$var$setIsRefined(item, currentRefinement, depth) {
    item.isRefined = item.name === currentRefinement[depth];
    if (item.data) item.data.forEach(function(child) {
        $9e699c47e0c26cf0$var$setIsRefined(child, currentRefinement, depth + 1);
    });
}
/**
 * Sort nodes of a hierarchical or disjunctive facet results
 * @private
 * @param {function} sortFn sort function to apply
 * @param {HierarchicalFacet|Array} node node upon which we want to apply the sort
 * @param {string[]} names attribute names
 * @param {number} [level=0] current index in the names array
 * @return {HierarchicalFacet|Array} sorted node
 */ function $9e699c47e0c26cf0$var$recSort(sortFn, node, names, level) {
    level = level || 0;
    if (Array.isArray(node)) return sortFn(node, names[level]);
    if (!node.data || node.data.length === 0) return node;
    var children = node.data.map(function(childNode) {
        return $9e699c47e0c26cf0$var$recSort(sortFn, childNode, names, level + 1);
    });
    var sortedChildren = sortFn(children, names[level]);
    var newNode = $kee8o({
        data: sortedChildren
    }, node);
    return newNode;
}
$9e699c47e0c26cf0$var$SearchResults.DEFAULT_SORT = [
    'isRefined:desc',
    'count:desc',
    'name:asc'
];
function $9e699c47e0c26cf0$var$vanillaSortFn(order, data) {
    return data.sort(order);
}
/**
 * @typedef FacetOrdering
 * @type {Object}
 * @property {string[]} [order]
 * @property {'count' | 'alpha' | 'hidden'} [sortRemainingBy]
 */ /**
 * Sorts facet arrays via their facet ordering
 * @param {Array} facetValues the values
 * @param {FacetOrdering} facetOrdering the ordering
 * @returns {Array} the sorted facet values
 */ function $9e699c47e0c26cf0$var$sortViaFacetOrdering(facetValues, facetOrdering) {
    var orderedFacets = [];
    var remainingFacets = [];
    var order = facetOrdering.order || [];
    /**
   * an object with the keys being the values in order, the values their index:
   * ['one', 'two'] -> { one: 0, two: 1 }
   */ var reverseOrder = order.reduce(function(acc, name, i) {
        acc[name] = i;
        return acc;
    }, {});
    facetValues.forEach(function(item) {
        // hierarchical facets get sorted using their raw name
        var name = item.path || item.name;
        if (reverseOrder[name] !== undefined) orderedFacets[reverseOrder[name]] = item;
        else remainingFacets.push(item);
    });
    orderedFacets = orderedFacets.filter(function(facet) {
        return facet;
    });
    var sortRemainingBy = facetOrdering.sortRemainingBy;
    var ordering;
    if (sortRemainingBy === 'hidden') return orderedFacets;
    else if (sortRemainingBy === 'alpha') ordering = [
        [
            'path',
            'name'
        ],
        [
            'asc',
            'asc'
        ]
    ];
    else ordering = [
        [
            'count'
        ],
        [
            'desc'
        ]
    ];
    return orderedFacets.concat($3XDAH(remainingFacets, ordering[0], ordering[1]));
}
/**
 * @param {SearchResults} results the search results class
 * @param {string} attribute the attribute to retrieve ordering of
 * @returns {FacetOrdering | undefined} the facet ordering
 */ function $9e699c47e0c26cf0$var$getFacetOrdering(results, attribute) {
    return results.renderingContent && results.renderingContent.facetOrdering && results.renderingContent.facetOrdering.values && results.renderingContent.facetOrdering.values[attribute];
}
/**
 * Get a the list of values for a given facet attribute. Those values are sorted
 * refinement first, descending count (bigger value on top), and name ascending
 * (alphabetical order). The sort formula can overridden using either string based
 * predicates or a function.
 *
 * This method will return all the values returned by the Algolia engine plus all
 * the values already refined. This means that it can happen that the
 * `maxValuesPerFacet` [configuration](https://www.algolia.com/doc/rest-api/search#param-maxValuesPerFacet)
 * might not be respected if you have facet values that are already refined.
 * @param {string} attribute attribute name
 * @param {object} opts configuration options.
 * @param {boolean} [opts.facetOrdering]
 * Force the use of facetOrdering from the result if a sortBy is present. If
 * sortBy isn't present, facetOrdering will be used automatically.
 * @param {Array.<string> | function} opts.sortBy
 * When using strings, it consists of
 * the name of the [FacetValue](#SearchResults.FacetValue) or the
 * [HierarchicalFacet](#SearchResults.HierarchicalFacet) attributes with the
 * order (`asc` or `desc`). For example to order the value by count, the
 * argument would be `['count:asc']`.
 *
 * If only the attribute name is specified, the ordering defaults to the one
 * specified in the default value for this attribute.
 *
 * When not specified, the order is
 * ascending.  This parameter can also be a function which takes two facet
 * values and should return a number, 0 if equal, 1 if the first argument is
 * bigger or -1 otherwise.
 *
 * The default value for this attribute `['isRefined:desc', 'count:desc', 'name:asc']`
 * @return {FacetValue[]|HierarchicalFacet|undefined} depending on the type of facet of
 * the attribute requested (hierarchical, disjunctive or conjunctive)
 * @example
 * helper.on('result', function(event){
 *   //get values ordered only by name ascending using the string predicate
 *   event.results.getFacetValues('city', {sortBy: ['name:asc']});
 *   //get values  ordered only by count ascending using a function
 *   event.results.getFacetValues('city', {
 *     // this is equivalent to ['count:asc']
 *     sortBy: function(a, b) {
 *       if (a.count === b.count) return 0;
 *       if (a.count > b.count)   return 1;
 *       if (b.count > a.count)   return -1;
 *     }
 *   });
 * });
 */ $9e699c47e0c26cf0$var$SearchResults.prototype.getFacetValues = function(attribute, opts) {
    var facetValues = $9e699c47e0c26cf0$var$extractNormalizedFacetValues(this, attribute);
    if (!facetValues) return undefined;
    var options = $kee8o({}, opts, {
        sortBy: $9e699c47e0c26cf0$var$SearchResults.DEFAULT_SORT,
        // if no sortBy is given, attempt to sort based on facetOrdering
        // if it is given, we still allow to sort via facet ordering first
        facetOrdering: !(opts && opts.sortBy)
    });
    // eslint-disable-next-line consistent-this
    var results = this;
    var attributes;
    if (Array.isArray(facetValues)) attributes = [
        attribute
    ];
    else {
        var config = results._state.getHierarchicalFacetByName(facetValues.name);
        attributes = config.attributes;
    }
    return $9e699c47e0c26cf0$var$recSort(function(data, facetName) {
        if (options.facetOrdering) {
            var facetOrdering = $9e699c47e0c26cf0$var$getFacetOrdering(results, facetName);
            if (facetOrdering) return $9e699c47e0c26cf0$var$sortViaFacetOrdering(data, facetOrdering);
        }
        if (Array.isArray(options.sortBy)) {
            var order = $jARvP(options.sortBy, $9e699c47e0c26cf0$var$SearchResults.DEFAULT_SORT);
            return $3XDAH(data, order[0], order[1]);
        } else if (typeof options.sortBy === 'function') return $9e699c47e0c26cf0$var$vanillaSortFn(options.sortBy, data);
        throw new Error("options.sortBy is optional but if defined it must be either an array of string (predicates) or a sorting function");
    }, facetValues, attributes);
};
/**
 * Returns the facet stats if attribute is defined and the facet contains some.
 * Otherwise returns undefined.
 * @param {string} attribute name of the faceted attribute
 * @return {object} The stats of the facet
 */ $9e699c47e0c26cf0$var$SearchResults.prototype.getFacetStats = function(attribute) {
    if (this._state.isConjunctiveFacet(attribute)) return $9e699c47e0c26cf0$var$getFacetStatsIfAvailable(this.facets, attribute);
    else if (this._state.isDisjunctiveFacet(attribute)) return $9e699c47e0c26cf0$var$getFacetStatsIfAvailable(this.disjunctiveFacets, attribute);
    return undefined;
};
/**
 * @typedef {Object} FacetListItem
 * @property {string} name
 */ /**
 * @param {FacetListItem[]} facetList (has more items, but enough for here)
 * @param {string} facetName The attribute to look for
 * @return {object|undefined} The stats of the facet
 */ function $9e699c47e0c26cf0$var$getFacetStatsIfAvailable(facetList, facetName) {
    var data = $5B6z1(facetList, function(facet) {
        return facet.name === facetName;
    });
    return data && data.stats;
}
/**
 * Returns all refinements for all filters + tags. It also provides
 * additional information: count and exhaustiveness for each filter.
 *
 * See the [refinement type](#Refinement) for an exhaustive view of the available
 * data.
 *
 * Note that for a numeric refinement, results are grouped per operator, this
 * means that it will return responses for operators which are empty.
 *
 * @return {Array.<Refinement>} all the refinements
 */ $9e699c47e0c26cf0$var$SearchResults.prototype.getRefinements = function() {
    var state = this._state;
    // eslint-disable-next-line consistent-this
    var results = this;
    var res = [];
    Object.keys(state.facetsRefinements).forEach(function(attributeName) {
        state.facetsRefinements[attributeName].forEach(function(name) {
            res.push($9e699c47e0c26cf0$var$getRefinement(state, 'facet', attributeName, name, results.facets));
        });
    });
    Object.keys(state.facetsExcludes).forEach(function(attributeName) {
        state.facetsExcludes[attributeName].forEach(function(name) {
            res.push($9e699c47e0c26cf0$var$getRefinement(state, 'exclude', attributeName, name, results.facets));
        });
    });
    Object.keys(state.disjunctiveFacetsRefinements).forEach(function(attributeName) {
        state.disjunctiveFacetsRefinements[attributeName].forEach(function(name) {
            res.push($9e699c47e0c26cf0$var$getRefinement(state, 'disjunctive', attributeName, name, results.disjunctiveFacets));
        });
    });
    Object.keys(state.hierarchicalFacetsRefinements).forEach(function(attributeName) {
        state.hierarchicalFacetsRefinements[attributeName].forEach(function(name) {
            res.push($9e699c47e0c26cf0$var$getHierarchicalRefinement(state, attributeName, name, results.hierarchicalFacets));
        });
    });
    Object.keys(state.numericRefinements).forEach(function(attributeName) {
        var operators = state.numericRefinements[attributeName];
        Object.keys(operators).forEach(function(operator) {
            operators[operator].forEach(function(value) {
                res.push({
                    type: 'numeric',
                    attributeName: attributeName,
                    name: value,
                    numericValue: value,
                    operator: operator
                });
            });
        });
    });
    state.tagRefinements.forEach(function(name) {
        res.push({
            type: 'tag',
            attributeName: '_tags',
            name: name
        });
    });
    return res;
};
/**
 * @typedef {Object} Facet
 * @property {string} name
 * @property {Object} data
 * @property {boolean} exhaustive
 */ /**
 * @param {SearchParameters} state the current state
 * @param {string} type the type of the refinement
 * @param {string} attributeName The attribute of the facet
 * @param {*} name The name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {Refinement} the refinement
 */ function $9e699c47e0c26cf0$var$getRefinement(state, type, attributeName, name, resultsFacets) {
    var facet = $5B6z1(resultsFacets, function(f) {
        return f.name === attributeName;
    });
    var count = facet && facet.data && facet.data[name] ? facet.data[name] : 0;
    var exhaustive = facet && facet.exhaustive || false;
    return {
        type: type,
        attributeName: attributeName,
        name: name,
        count: count,
        exhaustive: exhaustive
    };
}
/**
 * @param {SearchParameters} state the current state
 * @param {string} attributeName the attribute of the hierarchical facet
 * @param {string} name the name of the facet
 * @param {Facet[]} resultsFacets facets from the results
 * @return {HierarchicalFacet} the hierarchical facet
 */ function $9e699c47e0c26cf0$var$getHierarchicalRefinement(state, attributeName, name, resultsFacets) {
    var facetDeclaration = state.getHierarchicalFacetByName(attributeName);
    var separator = state._getHierarchicalFacetSeparator(facetDeclaration);
    var split = name.split(separator);
    var rootFacet = $5B6z1(resultsFacets, function(facet) {
        return facet.name === attributeName;
    });
    var facet = split.reduce(function(intermediateFacet, part) {
        var newFacet = intermediateFacet && $5B6z1(intermediateFacet.data, function(f) {
            return f.name === part;
        });
        return newFacet !== undefined ? newFacet : intermediateFacet;
    }, rootFacet);
    var count = facet && facet.count || 0;
    var exhaustive = facet && facet.exhaustive || false;
    var path = facet && facet.path || '';
    return {
        type: 'hierarchical',
        attributeName: attributeName,
        name: path,
        count: count,
        exhaustive: exhaustive
    };
}
module.exports = $9e699c47e0c26cf0$var$SearchResults;

});
parcelRegister("5Y7uW", function(module, exports) {
'use strict';
module.exports = function compact(array) {
    if (!Array.isArray(array)) return [];
    return array.filter(Boolean);
};

});

parcelRegister("7qXEB", function(module, exports) {
'use strict';
// @MAJOR can be replaced by native Array#findIndex when we change support
module.exports = function find(array, comparator) {
    if (!Array.isArray(array)) return -1;
    for(var i = 0; i < array.length; i++){
        if (comparator(array[i])) return i;
    }
    return -1;
};

});

parcelRegister("jARvP", function(module, exports) {
'use strict';

var $5B6z1 = parcelRequire("5B6z1");
/**
 * Transform sort format from user friendly notation to lodash format
 * @param {string[]} sortBy array of predicate of the form "attribute:order"
 * @param {string[]} [defaults] array of predicate of the form "attribute:order"
 * @return {array.<string[]>} array containing 2 elements : attributes, orders
 */ module.exports = function formatSort(sortBy, defaults) {
    var defaultInstructions = (defaults || []).map(function(sort) {
        return sort.split(':');
    });
    return sortBy.reduce(function preparePredicate(out, sort) {
        var sortInstruction = sort.split(':');
        var matchingDefault = $5B6z1(defaultInstructions, function(defaultInstruction) {
            return defaultInstruction[0] === sortInstruction[0];
        });
        if (sortInstruction.length > 1 || !matchingDefault) {
            out[0].push(sortInstruction[0]);
            out[1].push(sortInstruction[1]);
            return out;
        }
        out[0].push(matchingDefault[0]);
        out[1].push(matchingDefault[1]);
        return out;
    }, [
        [],
        []
    ]);
};

});

parcelRegister("3XDAH", function(module, exports) {
'use strict';
function $2e2597bb3c738014$var$compareAscending(value, other) {
    if (value !== other) {
        var valIsDefined = value !== undefined;
        var valIsNull = value === null;
        var othIsDefined = other !== undefined;
        var othIsNull = other === null;
        if (!othIsNull && value > other || valIsNull && othIsDefined || !valIsDefined) return 1;
        if (!valIsNull && value < other || othIsNull && valIsDefined || !othIsDefined) return -1;
    }
    return 0;
}
/**
 * @param {Array<object>} collection object with keys in attributes
 * @param {Array<string>} iteratees attributes
 * @param {Array<string>} orders asc | desc
 * @return {Array<object>} sorted collection
 */ function $2e2597bb3c738014$var$orderBy(collection, iteratees, orders) {
    if (!Array.isArray(collection)) return [];
    if (!Array.isArray(orders)) orders = [];
    var result = collection.map(function(value, index) {
        return {
            criteria: iteratees.map(function(iteratee) {
                return value[iteratee];
            }),
            index: index,
            value: value
        };
    });
    result.sort(function comparer(object, other) {
        var index = -1;
        while(++index < object.criteria.length){
            var res = $2e2597bb3c738014$var$compareAscending(object.criteria[index], other.criteria[index]);
            if (res) {
                if (index >= orders.length) return res;
                if (orders[index] === 'desc') return -res;
                return res;
            }
        }
        // This ensures a stable sort in V8 and other engines.
        // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
        return object.index - other.index;
    });
    return result.map(function(res) {
        return res.value;
    });
}
module.exports = $2e2597bb3c738014$var$orderBy;

});

parcelRegister("9ztro", function(module, exports) {
'use strict';
module.exports = $6f7e3846909b74d4$var$generateTrees;

var $iOTWh = parcelRequire("iOTWh");

var $5B6z1 = parcelRequire("5B6z1");

var $jARvP = parcelRequire("jARvP");

var $3XDAH = parcelRequire("3XDAH");
var $6f7e3846909b74d4$var$escapeFacetValue = $iOTWh.escapeFacetValue;
var $6f7e3846909b74d4$var$unescapeFacetValue = $iOTWh.unescapeFacetValue;
function $6f7e3846909b74d4$var$generateTrees(state) {
    return function generate(hierarchicalFacetResult, hierarchicalFacetIndex) {
        var hierarchicalFacet = state.hierarchicalFacets[hierarchicalFacetIndex];
        var hierarchicalFacetRefinement = state.hierarchicalFacetsRefinements[hierarchicalFacet.name] && state.hierarchicalFacetsRefinements[hierarchicalFacet.name][0] || '';
        var hierarchicalSeparator = state._getHierarchicalFacetSeparator(hierarchicalFacet);
        var hierarchicalRootPath = state._getHierarchicalRootPath(hierarchicalFacet);
        var hierarchicalShowParentLevel = state._getHierarchicalShowParentLevel(hierarchicalFacet);
        var sortBy = $jARvP(state._getHierarchicalFacetSortBy(hierarchicalFacet));
        var rootExhaustive = hierarchicalFacetResult.every(function(facetResult) {
            return facetResult.exhaustive;
        });
        var generateTreeFn = $6f7e3846909b74d4$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, hierarchicalFacetRefinement);
        var results = hierarchicalFacetResult;
        if (hierarchicalRootPath) results = hierarchicalFacetResult.slice(hierarchicalRootPath.split(hierarchicalSeparator).length);
        return results.reduce(generateTreeFn, {
            name: state.hierarchicalFacets[hierarchicalFacetIndex].name,
            count: null,
            isRefined: true,
            path: null,
            escapedValue: null,
            exhaustive: rootExhaustive,
            data: null
        });
    };
}
function $6f7e3846909b74d4$var$generateHierarchicalTree(sortBy, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel, currentRefinement) {
    return function generateTree(hierarchicalTree, hierarchicalFacetResult, currentHierarchicalLevel) {
        var parent = hierarchicalTree;
        if (currentHierarchicalLevel > 0) {
            var level = 0;
            parent = hierarchicalTree;
            while(level < currentHierarchicalLevel){
                /**
         * @type {object[]]} hierarchical data
         */ var data = parent && Array.isArray(parent.data) ? parent.data : [];
                parent = $5B6z1(data, function(subtree) {
                    return subtree.isRefined;
                });
                level++;
            }
        }
        // we found a refined parent, let's add current level data under it
        if (parent) {
            // filter values in case an object has multiple categories:
            //   {
            //     categories: {
            //       level0: ['beers', 'bières'],
            //       level1: ['beers > IPA', 'bières > Belges']
            //     }
            //   }
            //
            // If parent refinement is `beers`, then we do not want to have `bières > Belges`
            // showing up
            var picked = Object.keys(hierarchicalFacetResult.data).map(function(facetValue) {
                return [
                    facetValue,
                    hierarchicalFacetResult.data[facetValue]
                ];
            }).filter(function(tuple) {
                var facetValue = tuple[0];
                return $6f7e3846909b74d4$var$onlyMatchingTree(facetValue, parent.path || hierarchicalRootPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel);
            });
            parent.data = $3XDAH(picked.map(function(tuple) {
                var facetValue = tuple[0];
                var facetCount = tuple[1];
                return $6f7e3846909b74d4$var$format(facetCount, facetValue, hierarchicalSeparator, $6f7e3846909b74d4$var$unescapeFacetValue(currentRefinement), hierarchicalFacetResult.exhaustive);
            }), sortBy[0], sortBy[1]);
        }
        return hierarchicalTree;
    };
}
// eslint-disable-next-line max-params
function $6f7e3846909b74d4$var$onlyMatchingTree(facetValue, parentPath, currentRefinement, hierarchicalSeparator, hierarchicalRootPath, hierarchicalShowParentLevel) {
    // we want the facetValue is a child of hierarchicalRootPath
    if (hierarchicalRootPath && (facetValue.indexOf(hierarchicalRootPath) !== 0 || hierarchicalRootPath === facetValue)) return false;
    // we always want root levels (only when there is no prefix path)
    return !hierarchicalRootPath && facetValue.indexOf(hierarchicalSeparator) === -1 || // if there is a rootPath, being root level mean 1 level under rootPath
    hierarchicalRootPath && facetValue.split(hierarchicalSeparator).length - hierarchicalRootPath.split(hierarchicalSeparator).length === 1 || // if current refinement is a root level and current facetValue is a root level,
    // keep the facetValue
    facetValue.indexOf(hierarchicalSeparator) === -1 && currentRefinement.indexOf(hierarchicalSeparator) === -1 || // currentRefinement is a child of the facet value
    currentRefinement.indexOf(facetValue) === 0 || // facetValue is a child of the current parent, add it
    facetValue.indexOf(parentPath + hierarchicalSeparator) === 0 && (hierarchicalShowParentLevel || facetValue.indexOf(currentRefinement) === 0);
}
function $6f7e3846909b74d4$var$format(facetCount, facetValue, hierarchicalSeparator, currentRefinement, exhaustive) {
    var parts = facetValue.split(hierarchicalSeparator);
    return {
        name: parts[parts.length - 1].trim(),
        path: facetValue,
        escapedValue: $6f7e3846909b74d4$var$escapeFacetValue(facetValue),
        count: facetCount,
        isRefined: currentRefinement === facetValue || currentRefinement.indexOf(facetValue + hierarchicalSeparator) === 0,
        exhaustive: exhaustive,
        data: null
    };
}

});


parcelRegister("2s3Na", function(module, exports) {
'use strict';
module.exports = '3.14.0';

});



parcelRegister("8HDz3", function(module, exports) {

$parcel$export(module.exports, "resolveFacets", () => $6561078758bfdc64$export$a182255654db46e1);
$parcel$export(module.exports, "resolveSearchResults", () => $6561078758bfdc64$export$11ccebd170701e17);
$parcel$export(module.exports, "resolveHits", () => $6561078758bfdc64$export$2438408af19dc22a);

var $g5DHJ = parcelRequire("g5DHJ");

var $fCICH = parcelRequire("fCICH");

var $ELb1a = parcelRequire("ELb1a");

var $3lrDB = parcelRequire("3lrDB");
function $6561078758bfdc64$var$resolveFacetValuesAndCount(facets, facetKey) {
    const foundFacent = facets.find((facet)=>facet.get('name') === facetKey);
    return foundFacent ? foundFacent.get('data') : (0, $g5DHJ.Map)();
}
function $6561078758bfdc64$export$a182255654db46e1(_ref) {
    let { facets: facets, filters: filters, featureFlags: featureFlags } = _ref;
    const screenClass = (0, $3lrDB.getScreenClass)(window.innerWidth);
    const showDesktopFilters = screenClass === 'xl';
    const receivedFilters = showDesktopFilters ? (0, $fCICH.getFilters)({
        featureFlags: featureFlags
    }) : (0, $fCICH.getTabletMobileFilters)({
        featureFlags: featureFlags
    });
    return receivedFilters.filter((f)=>f.get('facet')).map((f)=>{
        let facetProducts;
        if (f.get('custom')) facetProducts = f.get('customFilters').map((cfp)=>(0, $g5DHJ.Map)({
                label: cfp.get('label'),
                value: cfp.get('value'),
                count: cfp.get('resolveFacetCount') && cfp.get('resolveFacetCount')(facets, filters)
            })).toList();
        else facetProducts = $6561078758bfdc64$var$resolveFacetValuesAndCount(facets, f.get('algoliaFacetKey')).map((count, facetProductValue)=>(0, $g5DHJ.Map)({
                label: facetProductValue,
                value: facetProductValue,
                count: count
            })).toList();
        return (0, $g5DHJ.Map)({
            useDropDownComponentForSidebar: f.get('useDropDownComponentForSidebar'),
            key: f.get('key'),
            sidebarLabel: f.get('sidebarLabel') || f.get('label'),
            topBarLabel: f.get('topBarLabel') || f.get('label'),
            type: f.get('type'),
            facetProducts: facetProducts,
            openByDefault: !!f.get('openByDefault'),
            primary: !!f.get('primary')
        });
    }).toList();
}
function $6561078758bfdc64$export$11ccebd170701e17(_ref2) {
    let { hits: hits, numberOfHits: numberOfHits, numberOfPages: numberOfPages } = _ref2;
    return (0, $g5DHJ.Map)({
        hits: hits.map((h)=>new (0, $ELb1a.default)(h)),
        numberOfHits: numberOfHits,
        numberOfPages: numberOfPages
    });
}
function $6561078758bfdc64$export$2438408af19dc22a(hits) {
    return (0, $g5DHJ.fromJS)(hits).map((h)=>new (0, $ELb1a.default)(h));
}

});
parcelRegister("ELb1a", function(module, exports) {

$parcel$export(module.exports, "defaults", () => $07a854da62cebaeb$export$ebe90cb607ad99e);
$parcel$export(module.exports, "default", () => $07a854da62cebaeb$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");
const $07a854da62cebaeb$export$ebe90cb607ad99e = {
    _highlightResult: undefined,
    addonId: undefined,
    addonKey: undefined,
    releaseDate: undefined,
    name: undefined,
    tagLine: undefined,
    categories: undefined,
    deployments: undefined,
    documentType: undefined,
    logo: undefined,
    vendor: undefined,
    distribution: undefined,
    version: undefined,
    ratings: undefined,
    marketingLabels: undefined,
    programs: undefined
};
var $07a854da62cebaeb$export$2e2bcd8739ae039 = (0, $g5DHJ.Record)($07a854da62cebaeb$export$ebe90cb607ad99e);

});

parcelRegister("3lrDB", function(module, exports) {

$parcel$export(module.exports, "getScreenClass", () => $26f8c585788e6a6c$export$334677fa002011d3);
function $26f8c585788e6a6c$export$334677fa002011d3(innerWidth) {
    if (innerWidth < 576) return 'sm';
    else if (innerWidth >= 576 && innerWidth < 768) return 'md';
    else if (innerWidth >= 768 && innerWidth < 992) return 'lg';
    else if (innerWidth >= 992) return 'xl';
}

});


parcelRegister("72e1Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $51f39a85cb5f5249$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $fCICH = parcelRequire("fCICH");

var $lwEMm = parcelRequire("lwEMm");
const $51f39a85cb5f5249$var$multiFilters = (featureFlags)=>(0, $fCICH.getFilters)({
        featureFlags: featureFlags
    }).filter((f)=>f.get('type') === (0, $lwEMm.DISJUNCTIVE_FACET_TYPE)).map((f)=>f.get('key'));
const $51f39a85cb5f5249$var$baseFilters = (featureFlags)=>$51f39a85cb5f5249$var$multiFilters(featureFlags).reduce((r, q)=>r.set(q, (0, $g5DHJ.Set)()), (0, $g5DHJ.Map)());
function $51f39a85cb5f5249$export$2e2bcd8739ae039(filters) {
    let featureFlags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return $51f39a85cb5f5249$var$baseFilters(featureFlags).merge(filters.filter((q)=>q)).map((v, k)=>{
        if ($51f39a85cb5f5249$var$multiFilters(featureFlags).includes(k)) {
            if ((0, $g5DHJ.Iterable).isIterable(v)) return v.toSet();
            else return (0, $g5DHJ.Set)([
                v
            ]);
        }
        return v;
    });
}

});

parcelRegister("7Qfm4", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b594ce74739029e$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $fCICH = parcelRequire("fCICH");

var $jdVrg = parcelRequire("jdVrg");
function $5b594ce74739029e$export$2e2bcd8739ae039(_ref) {
    let { applyOverrides: applyOverrides, filters: filters, index: index, numHits: numHits, page: page, sort: sort, resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides = (0, $g5DHJ.Map)(), featureFlags: featureFlags } = _ref;
    const searchParameters = (0, $jdVrg.default)({
        additionalFacets: applyOverrides ? applyOverrides.types : (0, $g5DHJ.Set)()
    }).setIndex(index).setHitsPerPage(numHits);
    // if (featureFlags?.showCompassApps === false) {
    //   searchParameters = searchParameters.addDisjunctiveFacetRefinement(
    //     'version.compatibilities.applicationKey',
    //     '-compass'
    //   );
    // }
    const filtersSearchParameters = (0, $fCICH.getFilters)({
        featureFlags: featureFlags
    }).reduce((filterParams, f)=>(resolveAlgoliaQueryFilterOverrides.get(f.get('key')) || f.get('resolveAlgoliaQuery') || ((_ref2)=>{
            let { params: params } = _ref2;
            return params;
        }))({
            params: filterParams,
            filters: filters,
            sort: sort
        }), searchParameters);
    return (applyOverrides ? applyOverrides.apply(filtersSearchParameters) : filtersSearchParameters).setPage(page); // Must be last as changing parameters resets page to 0
}

});
parcelRegister("jdVrg", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfebc95c71c01cbe$export$2e2bcd8739ae039);

var $7TFuJ = parcelRequire("7TFuJ");

var $g5DHJ = parcelRequire("g5DHJ");

var $fMsDx = parcelRequire("fMsDx");

var $fCICH = parcelRequire("fCICH");

var $lwEMm = parcelRequire("lwEMm");

var $ELb1a = parcelRequire("ELb1a");
const $dfebc95c71c01cbe$var$resolvePartition = (facets, basePartition)=>facets.reduce((_ref, f)=>{
        let { disjunctive: disjunctive, conjunctive: conjunctive } = _ref;
        if (f.get('queryType') === (0, $lwEMm.DISJUNCTIVE_FACET_TYPE)) return {
            disjunctive: disjunctive.add(f.get('algoliaFacetKey')),
            conjunctive: conjunctive
        };
        else return {
            disjunctive: disjunctive,
            conjunctive: conjunctive.add(f.get('algoliaFacetKey'))
        };
    }, basePartition);
const { disjunctive: $dfebc95c71c01cbe$var$disjunctive, conjunctive: $dfebc95c71c01cbe$var$conjunctive } = (0, $fCICH.getFilters)().toSet().filter((f)=>!f.get('nonRetrievableAttribute')).reduce((filterAccumulator, f)=>{
    if (f.get('algoliaFacetKey')) {
        if (f.get('queryType') === (0, $lwEMm.DISJUNCTIVE_FACET_TYPE)) return {
            disjunctive: filterAccumulator.disjunctive.add(f.get('algoliaFacetKey')),
            conjunctive: filterAccumulator.conjunctive
        };
        else return {
            disjunctive: filterAccumulator.disjunctive,
            conjunctive: filterAccumulator.conjunctive.add(f.get('algoliaFacetKey'))
        };
    } else if (f.get('custom')) return f.get('customFilters').toSet().reduce((customFilterAccumulator, cf)=>{
        if (cf.get('queryType') === (0, $lwEMm.DISJUNCTIVE_FACET_TYPE)) return {
            disjunctive: customFilterAccumulator.disjunctive.add(cf.get('algoliaFacetKey')),
            conjunctive: customFilterAccumulator.conjunctive
        };
        else return {
            disjunctive: customFilterAccumulator.disjunctive,
            conjunctive: customFilterAccumulator.conjunctive.add(cf.get('algoliaFacetKey'))
        };
    }, {
        disjunctive: filterAccumulator.disjunctive,
        conjunctive: filterAccumulator.disjunctive
    });
    return {
        disjunctive: filterAccumulator.disjunctive,
        conjunctive: filterAccumulator.conjunctive
    };
}, {
    disjunctive: (0, $g5DHJ.Set)(),
    conjunctive: (0, $g5DHJ.Set)()
});
const $dfebc95c71c01cbe$var$combinedAlreadyResolved = new Set($dfebc95c71c01cbe$var$disjunctive.concat($dfebc95c71c01cbe$var$conjunctive));
const $dfebc95c71c01cbe$var$intermediatePartition = $dfebc95c71c01cbe$var$resolvePartition((0, $fMsDx.default).toSet().filter((af)=>!$dfebc95c71c01cbe$var$combinedAlreadyResolved.has(af.get('algoliaFacetKey'))), {
    disjunctive: $dfebc95c71c01cbe$var$disjunctive,
    conjunctive: $dfebc95c71c01cbe$var$conjunctive
});
var $dfebc95c71c01cbe$export$2e2bcd8739ae039 = (_ref2)=>{
    let { additionalFacets: additionalFacets } = _ref2;
    const finalPartition = $dfebc95c71c01cbe$var$resolvePartition(additionalFacets, $dfebc95c71c01cbe$var$intermediatePartition);
    return new (0, $7TFuJ.SearchParameters)({
        attributesToRetrieve: Object.keys((0, $ELb1a.defaults)),
        disjunctiveFacets: finalPartition.disjunctive.toJS(),
        facets: finalPartition.conjunctive.toJS()
    }).addDisjunctiveFacetRefinement((0, $fMsDx.default).getIn([
        'hidden',
        'algoliaFacetKey'
    ]), 'notHidden');
};

});


parcelRegister("dbmA1", function(module, exports) {

$parcel$export(module.exports, "resolveSearchIndex", () => $998dd161474b2914$export$e9da379f185a7937);

var $73HyZ = parcelRequire("73HyZ");
function $998dd161474b2914$export$e9da379f185a7937(_ref) {
    let { environment: environment, filters: filters, sort: sort, enableV2SearchIndex: enableV2SearchIndex = false } = _ref;
    const index = enableV2SearchIndex ? (0, $73HyZ.searchIndicesV2) : (0, $73HyZ.searchIndicesV1);
    const sortIndexSuffix = sort ? sort.get('indexSuffix')({
        filters: filters
    }) : undefined;
    return "".concat(index.getIn([
        environment,
        'indexName'
    ])).concat(sortIndexSuffix ? "_".concat(sortIndexSuffix) : '');
}

});
parcelRegister("73HyZ", function(module, exports) {

$parcel$export(module.exports, "searchIndicesV1", () => $523a9afc12d99df8$export$1cce0c12da2f23c3);
$parcel$export(module.exports, "searchIndicesV2", () => $523a9afc12d99df8$export$ba433f7d838a8998);

var $g5DHJ = parcelRequire("g5DHJ");

const $523a9afc12d99df8$export$1cce0c12da2f23c3 = (0, $g5DHJ.Map)({
    [(0, $658e6bd3ffbfdac1$export$404582bc18fe4d9e)]: (0, $g5DHJ.Map)({
        indexName: 'marketplace_plugins_dev'
    }),
    [(0, $658e6bd3ffbfdac1$export$46be287603848c56)]: (0, $g5DHJ.Map)({
        indexName: 'marketplace_plugins_stg'
    }),
    [(0, $658e6bd3ffbfdac1$export$e51cdc15d0c6bee2)]: (0, $g5DHJ.Map)({
        indexName: 'marketplace_plugins_prod'
    })
});
const $523a9afc12d99df8$export$ba433f7d838a8998 = (0, $g5DHJ.Map)({
    [(0, $658e6bd3ffbfdac1$export$404582bc18fe4d9e)]: (0, $g5DHJ.Map)({
        indexName: 'marketplace_plugins_dev_v2'
    }),
    [(0, $658e6bd3ffbfdac1$export$46be287603848c56)]: (0, $g5DHJ.Map)({
        indexName: 'marketplace_plugins_stg_v2'
    }),
    [(0, $658e6bd3ffbfdac1$export$e51cdc15d0c6bee2)]: (0, $g5DHJ.Map)({
        indexName: 'marketplace_plugins_prod_v2'
    })
});

});


parcelRegister("aViHK", function(module, exports) {

$parcel$export(module.exports, "resolveSortFromFilters", () => $020d620270581175$export$e313698ed48e2e6b);

var $9LwYq = parcelRequire("9LwYq");
function $020d620270581175$export$e313698ed48e2e6b(_ref) {
    let { filters: filters } = _ref;
    return (0, $9LwYq.sortOptions).get(filters.get('sort'));
}

});



parcelRegister("eMCmH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac334ee9c816a80e$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");
var $ac334ee9c816a80e$export$2e2bcd8739ae039 = (0, $g5DHJ.Record)({
    index: undefined,
    render: undefined
});

});

parcelRegister("fOzGB", function(module, exports) {

$parcel$export(module.exports, "chainablePropType", () => $b837350d8718cc7e$export$f6667e36efa19954);
const $b837350d8718cc7e$export$f6667e36efa19954 = (predicate)=>{
    const propType = (props, propName, componentName)=>{
        if (props[propName] == null) return;
        return predicate(props, propName, componentName);
    };
    propType.isRequired = (props, propName, componentName)=>{
        if (props[propName] == null) return new Error("Required prop `".concat(propName, "` was not specified in `").concat(componentName, "`."));
        return predicate(props, propName, componentName);
    };
    return propType;
};

});

parcelRegister("gggoS", function(module, exports) {

$parcel$export(module.exports, "baseFiltersPropTypeFactory", () => $bd6adcb5f859022b$export$3ca42cd8b2f1d091);
$parcel$export(module.exports, "filtersPropTypeFactory", () => $bd6adcb5f859022b$export$8e6e41f029c56cfa);
$parcel$export(module.exports, "unenhancedPropTypeFactory", () => $bd6adcb5f859022b$export$5db18c4d5558cd79);

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $9LwYq = parcelRequire("9LwYq");

var $lwEMm = parcelRequire("lwEMm");
function $bd6adcb5f859022b$export$3ca42cd8b2f1d091(fs, disjunctiveFacetPropType) {
    let isFilterRequired = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : ()=>false;
    return fs.map((f)=>{
        const filterValueType = f.get('custom') ? (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
            ...f.get('customFilters').map((cf)=>cf.get('value')).values()
        ]) : (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string;
        const propType = f.get('type') === (0, $lwEMm.DISJUNCTIVE_FACET_TYPE) ? disjunctiveFacetPropType(filterValueType) : filterValueType;
        return isFilterRequired(f) ? propType.isRequired : propType;
    }).set('sort', (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf((0, $9LwYq.sortOptions).keySeq().toJS()));
}
function $bd6adcb5f859022b$export$8e6e41f029c56cfa(fs) {
    let isFilterRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ()=>false;
    return $bd6adcb5f859022b$export$3ca42cd8b2f1d091(fs, (fvt)=>(0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).setOf(fvt), isFilterRequired);
}
function $bd6adcb5f859022b$export$5db18c4d5558cd79(fs) {
    let isFilterRequired = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ()=>false;
    return $bd6adcb5f859022b$export$3ca42cd8b2f1d091(fs, (fvt)=>(0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
            fvt,
            (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).setOf(fvt)
        ]), isFilterRequired);
}

});


parcelRegister("dfDXD", function(module, exports) {

$parcel$export(module.exports, "FeaturedAddonsConfig", () => $9a5bac7aad8ab29c$export$e2db550fe5c67869);
$parcel$export(module.exports, "FeaturedAddonsConfigPropType", () => $9a5bac7aad8ab29c$export$443ab4f25dbfa557);

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $3ONu7 = parcelRequire("3ONu7");

const $9a5bac7aad8ab29c$var$featuredAddonsHome = {
    title: 'Staff Picks',
    tagline: "Try out any of these apps curated by our ecosystem team for free. We think they are a great place to start if you've never tried Atlassian Marketplace apps before.",
    curatedApps: undefined
};
const $9a5bac7aad8ab29c$var$featuredAddonsJira = {
    title: 'Staff Picks',
    tagline: "Try out any of these apps curated by our ecosystem team for free. We think they are a great place to start if you've never tried apps before with Jira.",
    curatedApps: undefined
};
const $9a5bac7aad8ab29c$var$featuredAddonsJsd = {
    title: 'Staff Picks',
    tagline: 'Your favorite apps for ITSM, customer support and more - right at your fingertips.',
    curatedApps: undefined
};
const $9a5bac7aad8ab29c$var$featuredAddonsConfluence = {
    title: 'Staff Picks',
    tagline: 'Top apps to transform and improve the way your teams work together, curated by Atlassian to ensure a seamless experience.',
    curatedApps: undefined
};
const $9a5bac7aad8ab29c$var$featuredAddonsBitbucket = {
    title: 'Staff Picks',
    tagline: "Bitbucket is the Git solution for teams that's flexible, secure, and scalable. Streamline the development process through integrations and apps to give teams get a tool that fits into the fabric of your organization.",
    curatedApps: undefined
};
class $9a5bac7aad8ab29c$export$e2db550fe5c67869 extends (0, $g5DHJ.Record)({
    /**
   * Value is an List<String>
   */ [(0, $3ONu7.HOME)]: $9a5bac7aad8ab29c$var$featuredAddonsHome,
    [(0, $122620c1047e308e$export$c1fabc4e59d98025)]: $9a5bac7aad8ab29c$var$featuredAddonsJira,
    [(0, $122620c1047e308e$export$3afc372bb8c4538c)]: $9a5bac7aad8ab29c$var$featuredAddonsJsd,
    [(0, $122620c1047e308e$export$c811f21c9ad05dc2)]: $9a5bac7aad8ab29c$var$featuredAddonsConfluence,
    [(0, $122620c1047e308e$export$59864d7602eb300a)]: $9a5bac7aad8ab29c$var$featuredAddonsBitbucket,
    [(0, $122620c1047e308e$export$77363fc37d01ae41)]: undefined,
    [(0, $122620c1047e308e$export$e95554a59f3e0c28)]: undefined,
    [(0, $122620c1047e308e$export$1876370d95915b3b)]: undefined,
    [(0, $122620c1047e308e$export$6bc23744ed8b8097)]: undefined,
    [(0, $122620c1047e308e$export$d5e9b613bc4c47f)]: undefined
}) {
    static default_() {
        return new $9a5bac7aad8ab29c$export$e2db550fe5c67869();
    }
}
const $9a5bac7aad8ab29c$export$443ab4f25dbfa557 = (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).instanceOf($9a5bac7aad8ab29c$export$e2db550fe5c67869);

});

parcelRegister("emLm3", function(module, exports) {

$parcel$export(module.exports, "default", () => $a757da6ae28ebe7a$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $4QJdp = parcelRequire("4QJdp");

var $8Cu0c = parcelRequire("8Cu0c");
const $a757da6ae28ebe7a$var$middleware = [
    (0, $8Cu0c.default)
];
function $a757da6ae28ebe7a$var$finalCreateStore(_ref) {
    let { debug: debug } = _ref;
    if (debug && window.__REDUX_DEVTOOLS_EXTENSION__) {
        const reduxDevtools = window.__REDUX_DEVTOOLS_EXTENSION__({
            serialize: {
                immutable: (0, $g5DHJ.default)
            }
        });
        return (0, $4QJdp.compose)((0, $4QJdp.applyMiddleware)(...$a757da6ae28ebe7a$var$middleware), reduxDevtools)((0, $4QJdp.createStore));
    } else return (0, $4QJdp.compose)((0, $4QJdp.applyMiddleware)(...$a757da6ae28ebe7a$var$middleware))((0, $4QJdp.createStore));
}
function $a757da6ae28ebe7a$export$2e2bcd8739ae039(_ref2) {
    let { debug: debug, reducer: reducer } = _ref2;
    return $a757da6ae28ebe7a$var$finalCreateStore({
        debug: debug
    })(reducer);
}

});
parcelRegister("4QJdp", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $387f179275880db7$export$f51a9068ac82ea43);
$parcel$export(module.exports, "combineReducers", () => $387f179275880db7$export$66e4520cdb265d18);
$parcel$export(module.exports, "bindActionCreators", () => $387f179275880db7$export$aea084d96e84da92);
$parcel$export(module.exports, "compose", () => $387f179275880db7$export$f672e0b6f7222cd7);
$parcel$export(module.exports, "applyMiddleware", () => $387f179275880db7$export$9ff26e0402cc7b7);

var $1Xn5q = parcelRequire("1Xn5q");
/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */ function $387f179275880db7$var$formatProdErrorMessage(code) {
    return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}
// Inlined version of the `symbol-observable` polyfill
var $387f179275880db7$var$$$observable = function() {
    return typeof Symbol === 'function' && Symbol.observable || '@@observable';
}();
/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */ var $387f179275880db7$var$randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
};
var $387f179275880db7$export$4219e499db7ca678 = {
    INIT: "@@redux/INIT" + $387f179275880db7$var$randomString(),
    REPLACE: "@@redux/REPLACE" + $387f179275880db7$var$randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
        return "@@redux/PROBE_UNKNOWN_ACTION" + $387f179275880db7$var$randomString();
    }
};
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */ function $387f179275880db7$var$isPlainObject(obj) {
    if (typeof obj !== 'object' || obj === null) return false;
    var proto = obj;
    while(Object.getPrototypeOf(proto) !== null)proto = Object.getPrototypeOf(proto);
    return Object.getPrototypeOf(obj) === proto;
}
// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function $387f179275880db7$var$miniKindOf(val) {
    if (val === void 0) return 'undefined';
    if (val === null) return 'null';
    var type = typeof val;
    switch(type){
        case 'boolean':
        case 'string':
        case 'number':
        case 'symbol':
        case 'function':
            return type;
    }
    if (Array.isArray(val)) return 'array';
    if ($387f179275880db7$var$isDate(val)) return 'date';
    if ($387f179275880db7$var$isError(val)) return 'error';
    var constructorName = $387f179275880db7$var$ctorName(val);
    switch(constructorName){
        case 'Symbol':
        case 'Promise':
        case 'WeakMap':
        case 'WeakSet':
        case 'Map':
        case 'Set':
            return constructorName;
    } // other
    return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}
function $387f179275880db7$var$ctorName(val) {
    return typeof val.constructor === 'function' ? val.constructor.name : null;
}
function $387f179275880db7$var$isError(val) {
    return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}
function $387f179275880db7$var$isDate(val) {
    if (val instanceof Date) return true;
    return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}
function $387f179275880db7$var$kindOf(val) {
    var typeOfVal = typeof val;
    return typeOfVal;
}
/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */ function $387f179275880db7$export$f51a9068ac82ea43(reducer, preloadedState, enhancer) {
    var _ref2;
    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(0));
    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
        enhancer = preloadedState;
        preloadedState = undefined;
    }
    if (typeof enhancer !== 'undefined') {
        if (typeof enhancer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(1));
        return enhancer($387f179275880db7$export$f51a9068ac82ea43)(reducer, preloadedState);
    }
    if (typeof reducer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(2));
    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */ function ensureCanMutateNextListeners() {
        if (nextListeners === currentListeners) nextListeners = currentListeners.slice();
    }
    /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */ function getState() {
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(3));
        return currentState;
    }
    /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */ function subscribe(listener) {
        if (typeof listener !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(4));
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(5));
        var isSubscribed = true;
        ensureCanMutateNextListeners();
        nextListeners.push(listener);
        return function unsubscribe() {
            if (!isSubscribed) return;
            if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(6));
            isSubscribed = false;
            ensureCanMutateNextListeners();
            var index = nextListeners.indexOf(listener);
            nextListeners.splice(index, 1);
            currentListeners = null;
        };
    }
    /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */ function dispatch(action) {
        if (!$387f179275880db7$var$isPlainObject(action)) throw new Error($387f179275880db7$var$formatProdErrorMessage(7));
        if (typeof action.type === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(8));
        if (isDispatching) throw new Error($387f179275880db7$var$formatProdErrorMessage(9));
        try {
            isDispatching = true;
            currentState = currentReducer(currentState, action);
        } finally{
            isDispatching = false;
        }
        var listeners = currentListeners = nextListeners;
        for(var i = 0; i < listeners.length; i++){
            var listener = listeners[i];
            listener();
        }
        return action;
    }
    /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */ function replaceReducer(nextReducer) {
        if (typeof nextReducer !== 'function') throw new Error($387f179275880db7$var$formatProdErrorMessage(10));
        currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
        // Any reducers that existed in both the new and old rootReducer
        // will receive the previous state. This effectively populates
        // the new state tree with any relevant data from the old one.
        dispatch({
            type: $387f179275880db7$export$4219e499db7ca678.REPLACE
        });
    }
    /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */ function observable() {
        var _ref;
        var outerSubscribe = subscribe;
        return _ref = {
            /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */ subscribe: function subscribe(observer) {
                if (typeof observer !== 'object' || observer === null) throw new Error($387f179275880db7$var$formatProdErrorMessage(11));
                function observeState() {
                    if (observer.next) observer.next(getState());
                }
                observeState();
                var unsubscribe = outerSubscribe(observeState);
                return {
                    unsubscribe: unsubscribe
                };
            }
        }, _ref[$387f179275880db7$var$$$observable] = function() {
            return this;
        }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.
    dispatch({
        type: $387f179275880db7$export$4219e499db7ca678.INIT
    });
    return _ref2 = {
        dispatch: dispatch,
        subscribe: subscribe,
        getState: getState,
        replaceReducer: replaceReducer
    }, _ref2[$387f179275880db7$var$$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */ var $387f179275880db7$export$8928921ea2d3b126 = $387f179275880db7$export$f51a9068ac82ea43;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */ function $387f179275880db7$var$warning(message) {
    /* eslint-disable no-console */ if (typeof console !== 'undefined' && typeof console.error === 'function') console.error(message);
    /* eslint-enable no-console */ try {
        // This error was thrown as a convenience so that if you enable
        // "break on all exceptions" in your console,
        // it would pause the execution at this line.
        throw new Error(message);
    } catch (e) {} // eslint-disable-line no-empty
}
function $387f179275880db7$var$getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
    var reducerKeys = Object.keys(reducers);
    var argumentName = action && action.type === $387f179275880db7$export$4219e499db7ca678.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
    if (reducerKeys.length === 0) return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
    if (!$387f179275880db7$var$isPlainObject(inputState)) return "The " + argumentName + " has unexpected type of \"" + $387f179275880db7$var$kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
    var unexpectedKeys = Object.keys(inputState).filter(function(key) {
        return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
    });
    unexpectedKeys.forEach(function(key) {
        unexpectedKeyCache[key] = true;
    });
    if (action && action.type === $387f179275880db7$export$4219e499db7ca678.REPLACE) return;
    if (unexpectedKeys.length > 0) return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
}
function $387f179275880db7$var$assertReducerShape(reducers) {
    Object.keys(reducers).forEach(function(key) {
        var reducer = reducers[key];
        var initialState = reducer(undefined, {
            type: $387f179275880db7$export$4219e499db7ca678.INIT
        });
        if (typeof initialState === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(12));
        if (typeof reducer(undefined, {
            type: $387f179275880db7$export$4219e499db7ca678.PROBE_UNKNOWN_ACTION()
        }) === 'undefined') throw new Error($387f179275880db7$var$formatProdErrorMessage(13));
    });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */ function $387f179275880db7$export$66e4520cdb265d18(reducers) {
    var reducerKeys = Object.keys(reducers);
    var finalReducers = {};
    for(var i = 0; i < reducerKeys.length; i++){
        var key = reducerKeys[i];
        if (typeof reducers[key] === 'function') finalReducers[key] = reducers[key];
    }
    var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
    // keys multiple times.
    var unexpectedKeyCache;
    var shapeAssertionError;
    try {
        $387f179275880db7$var$assertReducerShape(finalReducers);
    } catch (e) {
        shapeAssertionError = e;
    }
    return function combination(state, action) {
        if (state === void 0) state = {};
        if (shapeAssertionError) throw shapeAssertionError;
        var warningMessage;
        var hasChanged = false;
        var nextState = {};
        for(var _i = 0; _i < finalReducerKeys.length; _i++){
            var _key = finalReducerKeys[_i];
            var reducer = finalReducers[_key];
            var previousStateForKey = state[_key];
            var nextStateForKey = reducer(previousStateForKey, action);
            if (typeof nextStateForKey === 'undefined') {
                var actionType = action && action.type;
                throw new Error($387f179275880db7$var$formatProdErrorMessage(14));
            }
            nextState[_key] = nextStateForKey;
            hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
        }
        hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
        return hasChanged ? nextState : state;
    };
}
function $387f179275880db7$var$bindActionCreator(actionCreator, dispatch) {
    return function() {
        return dispatch(actionCreator.apply(this, arguments));
    };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */ function $387f179275880db7$export$aea084d96e84da92(actionCreators, dispatch) {
    if (typeof actionCreators === 'function') return $387f179275880db7$var$bindActionCreator(actionCreators, dispatch);
    if (typeof actionCreators !== 'object' || actionCreators === null) throw new Error($387f179275880db7$var$formatProdErrorMessage(16));
    var boundActionCreators = {};
    for(var key in actionCreators){
        var actionCreator = actionCreators[key];
        if (typeof actionCreator === 'function') boundActionCreators[key] = $387f179275880db7$var$bindActionCreator(actionCreator, dispatch);
    }
    return boundActionCreators;
}
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */ function $387f179275880db7$export$f672e0b6f7222cd7() {
    for(var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++)funcs[_key] = arguments[_key];
    if (funcs.length === 0) return function(arg) {
        return arg;
    };
    if (funcs.length === 1) return funcs[0];
    return funcs.reduce(function(a, b) {
        return function() {
            return a(b.apply(void 0, arguments));
        };
    });
}
/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */ function $387f179275880db7$export$9ff26e0402cc7b7() {
    for(var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++)middlewares[_key] = arguments[_key];
    return function(createStore) {
        return function() {
            var store = createStore.apply(void 0, arguments);
            var _dispatch = function dispatch() {
                throw new Error($387f179275880db7$var$formatProdErrorMessage(15));
            };
            var middlewareAPI = {
                getState: store.getState,
                dispatch: function dispatch() {
                    return _dispatch.apply(void 0, arguments);
                }
            };
            var chain = middlewares.map(function(middleware) {
                return middleware(middlewareAPI);
            });
            _dispatch = $387f179275880db7$export$f672e0b6f7222cd7.apply(void 0, chain)(store.dispatch);
            return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, store), {}, {
                dispatch: _dispatch
            });
        };
    };
}

});
parcelRegister("1Xn5q", function(module, exports) {

$parcel$export(module.exports, "default", () => $16cd35a30248fb20$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $16cd35a30248fb20$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16cd35a30248fb20$export$2e2bcd8739ae039(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16cd35a30248fb20$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16cd35a30248fb20$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

});


parcelRegister("8Cu0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $6469252af98da682$export$2e2bcd8739ae039);
function $6469252af98da682$var$createThunkMiddleware(extraArgument) {
    return function(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                if (typeof action === 'function') return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
}
var $6469252af98da682$var$thunk = $6469252af98da682$var$createThunkMiddleware();
$6469252af98da682$var$thunk.withExtraArgument = $6469252af98da682$var$createThunkMiddleware;
var $6469252af98da682$export$2e2bcd8739ae039 = $6469252af98da682$var$thunk;

});


parcelRegister("8OnOc", function(module, exports) {

$parcel$export(module.exports, "createAlgoliaClient", () => $66a576258c3c5b84$export$87d27fb85ba26f49);

var $f2Nkd = parcelRequire("f2Nkd");
function $66a576258c3c5b84$export$87d27fb85ba26f49(algoliaConfig) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($f2Nkd)))(algoliaConfig.applicationId, algoliaConfig.apiKey);
}

});
parcelRegister("f2Nkd", function(module, exports) {
'use strict';

var $38oKI = parcelRequire("38oKI");

var $bRA3t = parcelRequire("bRA3t");
module.exports = $bRA3t($38oKI, 'Browser');

});
parcelRegister("38oKI", function(module, exports) {
module.exports = $248551c8b7135f69$var$AlgoliaSearch;

var $9uH7N = parcelRequire("9uH7N");

var $5Zn4S = parcelRequire("5Zn4S");

var $gWPav = parcelRequire("gWPav");

var $eQwxt = parcelRequire("eQwxt");

var $lyUaN = parcelRequire("lyUaN");

var $bRG5U = parcelRequire("bRG5U");
function $248551c8b7135f69$var$AlgoliaSearch() {
    $eQwxt.apply(this, arguments);
}
$lyUaN($248551c8b7135f69$var$AlgoliaSearch, $eQwxt);
/*
 * Delete an index
 *
 * @param indexName the name of index to delete
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer that contains the task ID
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.deleteIndex = function(indexName, callback) {
    return this._jsonRequest({
        method: 'DELETE',
        url: '/1/indexes/' + encodeURIComponent(indexName),
        hostType: 'write',
        callback: callback
    });
};
/**
 * Move an existing index.
 * @param srcIndexName the name of index to copy.
 * @param dstIndexName the new index name that will contains a copy of
 * srcIndexName (destination will be overriten if it already exist).
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer that contains the task ID
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.moveIndex = function(srcIndexName, dstIndexName, callback) {
    var postObj = {
        operation: 'move',
        destination: dstIndexName
    };
    return this._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(srcIndexName) + '/operation',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
};
/**
 * Copy an existing index.
 * @param srcIndexName the name of index to copy.
 * @param dstIndexName the new index name that will contains a copy
 * of srcIndexName (destination will be overriten if it already exist).
 * @param scope an array of scopes to copy: ['settings', 'synonyms', 'rules']
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer that contains the task ID
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.copyIndex = function(srcIndexName, dstIndexName, scopeOrCallback, _callback) {
    var postObj = {
        operation: 'copy',
        destination: dstIndexName
    };
    var callback = _callback;
    if (typeof scopeOrCallback === 'function') // oops, old behaviour of third argument being a function
    callback = scopeOrCallback;
    else if (Array.isArray(scopeOrCallback) && scopeOrCallback.length > 0) postObj.scope = scopeOrCallback;
    else if (typeof scopeOrCallback !== 'undefined') throw new Error('the scope given to `copyIndex` was not an array with settings, synonyms or rules');
    return this._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(srcIndexName) + '/operation',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
};

/**
 * Return last log entries.
 * @param offset Specify the first entry to retrieve (0-based, 0 is the most recent log entry).
 * @param length Specify the maximum number of entries to retrieve starting
 * at offset. Maximum allowed value: 1000.
 * @param type Specify the maximum number of entries to retrieve starting
 * at offset. Maximum allowed value: 1000.
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer that contains the task ID
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.getLogs = function(offset, length, callback) {
    var clone = (parcelRequire("eFOtW"));
    var params = {};
    if (typeof offset === 'object') {
        // getLogs(params)
        params = clone(offset);
        callback = length;
    } else if (arguments.length === 0 || typeof offset === 'function') // getLogs([cb])
    callback = offset;
    else if (arguments.length === 1 || typeof length === 'function') {
        // getLogs(1, [cb)]
        callback = length;
        params.offset = offset;
    } else {
        // getLogs(1, 2, [cb])
        params.offset = offset;
        params.length = length;
    }
    if (params.offset === undefined) params.offset = 0;
    if (params.length === undefined) params.length = 10;
    return this._jsonRequest({
        method: 'GET',
        url: '/1/logs?' + this._getSearchParams(params, ''),
        hostType: 'read',
        callback: callback
    });
};
/*
 * List all existing indexes (paginated)
 *
 * @param page The page to retrieve, starting at 0.
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer with index list
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.listIndexes = function(page, callback) {
    var params = '';
    if (page === undefined || typeof page === 'function') callback = page;
    else params = '?page=' + page;
    return this._jsonRequest({
        method: 'GET',
        url: '/1/indexes' + params,
        hostType: 'read',
        callback: callback
    });
};
/*
 * Get the index object initialized
 *
 * @param indexName the name of index
 * @param callback the result callback with one argument (the Index instance)
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.initIndex = function(indexName) {
    return new $9uH7N(this, indexName);
};

$248551c8b7135f69$var$AlgoliaSearch.prototype.initAnalytics = function(opts) {
    // the actual require must be inside the function, when put outside then you have a cyclic dependency
    // not well resolved that ends up making the main "./index.js" (main module, the agloliasearch function)
    // export an object instead of a function
    // Other workarounds:
    // - rewrite the lib in ES6, cyclic dependencies may be better supported
    // - move initAnalytics to a property on the main module (algoliasearch.initAnalytics),
    // same as places.
    // The current API was made mostly to mimic the one made in PHP
    var createAnalyticsClient = (parcelRequire("hz3TB"));
    return createAnalyticsClient(this.applicationID, this.apiKey, opts);
};
/*
 * @deprecated use client.listApiKeys
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.listUserKeys = $5Zn4S(function(callback) {
    return this.listApiKeys(callback);
}, $gWPav('client.listUserKeys()', 'client.listApiKeys()'));
/*
 * List all existing api keys with their associated ACLs
 *
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer with api keys list
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.listApiKeys = function(callback) {
    return this._jsonRequest({
        method: 'GET',
        url: '/1/keys',
        hostType: 'read',
        callback: callback
    });
};
/*
 * @deprecated see client.getApiKey
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.getUserKeyACL = $5Zn4S(function(key, callback) {
    return this.getApiKey(key, callback);
}, $gWPav('client.getUserKeyACL()', 'client.getApiKey()'));
/*
 * Get an API key
 *
 * @param key
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer with the right API key
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.getApiKey = function(key, callback) {
    return this._jsonRequest({
        method: 'GET',
        url: '/1/keys/' + key,
        hostType: 'read',
        callback: callback
    });
};
/*
 * @deprecated see client.deleteApiKey
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.deleteUserKey = $5Zn4S(function(key, callback) {
    return this.deleteApiKey(key, callback);
}, $gWPav('client.deleteUserKey()', 'client.deleteApiKey()'));
/*
 * Delete an existing API key
 * @param key
 * @param callback the result callback called with two arguments
 *  error: null or Error('message')
 *  content: the server answer with the date of deletion
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.deleteApiKey = function(key, callback) {
    return this._jsonRequest({
        method: 'DELETE',
        url: '/1/keys/' + key,
        hostType: 'write',
        callback: callback
    });
};
/**
 * Restore a deleted API key
 *
 * @param {String} key - The key to restore
 * @param {Function} callback - The result callback called with two arguments
 *   error: null or Error('message')
 *   content: the server answer with the restored API key
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.restoreApiKey('APIKEY')
 * @see {@link https://www.algolia.com/doc/rest-api/search/#restore-api-key|Algolia REST API Documentation}
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.restoreApiKey = function(key, callback) {
    return this._jsonRequest({
        method: 'POST',
        url: '/1/keys/' + key + '/restore',
        hostType: 'write',
        callback: callback
    });
};
/*
 @deprecated see client.addApiKey
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.addUserKey = $5Zn4S(function(acls, params, callback) {
    return this.addApiKey(acls, params, callback);
}, $gWPav('client.addUserKey()', 'client.addApiKey()'));

/*
 * Add a new global API key
 *
 * @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
 *   can contains the following values:
 *     - search: allow to search (https and http)
 *     - addObject: allows to add/update an object in the index (https only)
 *     - deleteObject : allows to delete an existing object (https only)
 *     - deleteIndex : allows to delete index content (https only)
 *     - settings : allows to get index settings (https only)
 *     - editSettings : allows to change index settings (https only)
 * @param {Object} [params] - Optionnal parameters to set for the key
 * @param {number} params.validity - Number of seconds after which the key will be automatically removed (0 means no time limit for this key)
 * @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
 * @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
 * @param {string[]} params.indexes - Allowed targeted indexes for this key
 * @param {string} params.description - A description for your key
 * @param {string[]} params.referers - A list of authorized referers
 * @param {Object} params.queryParameters - Force the key to use specific query parameters
 * @param {Function} callback - The result callback called with two arguments
 *   error: null or Error('message')
 *   content: the server answer with the added API key
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.addApiKey(['search'], {
 *   validity: 300,
 *   maxQueriesPerIPPerHour: 2000,
 *   maxHitsPerQuery: 3,
 *   indexes: ['fruits'],
 *   description: 'Eat three fruits',
 *   referers: ['*.algolia.com'],
 *   queryParameters: {
 *     tagFilters: ['public'],
 *   }
 * })
 * @see {@link https://www.algolia.com/doc/rest_api#AddKey|Algolia REST API Documentation}
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.addApiKey = function(acls, params, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: client.addApiKey(arrayOfAcls[, params, callback])';
    if (!isArray(acls)) throw new Error(usage);
    if (arguments.length === 1 || typeof params === 'function') {
        callback = params;
        params = null;
    }
    var postObj = {
        acl: acls
    };
    if (params) {
        postObj.validity = params.validity;
        postObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
        postObj.maxHitsPerQuery = params.maxHitsPerQuery;
        postObj.indexes = params.indexes;
        postObj.description = params.description;
        if (params.queryParameters) postObj.queryParameters = this._getSearchParams(params.queryParameters, '');
        postObj.referers = params.referers;
    }
    return this._jsonRequest({
        method: 'POST',
        url: '/1/keys',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
};
/**
 * @deprecated Please use client.addApiKey()
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.addUserKeyWithValidity = $5Zn4S(function(acls, params, callback) {
    return this.addApiKey(acls, params, callback);
}, $gWPav('client.addUserKeyWithValidity()', 'client.addApiKey()'));
/**
 * @deprecated Please use client.updateApiKey()
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.updateUserKey = $5Zn4S(function(key, acls, params, callback) {
    return this.updateApiKey(key, acls, params, callback);
}, $gWPav('client.updateUserKey()', 'client.updateApiKey()'));

/**
 * Update an existing API key
 * @param {string} key - The key to update
 * @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
 *   can contains the following values:
 *     - search: allow to search (https and http)
 *     - addObject: allows to add/update an object in the index (https only)
 *     - deleteObject : allows to delete an existing object (https only)
 *     - deleteIndex : allows to delete index content (https only)
 *     - settings : allows to get index settings (https only)
 *     - editSettings : allows to change index settings (https only)
 * @param {Object} [params] - Optionnal parameters to set for the key
 * @param {number} params.validity - Number of seconds after which the key will be automatically removed (0 means no time limit for this key)
 * @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
 * @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
 * @param {string[]} params.indexes - Allowed targeted indexes for this key
 * @param {string} params.description - A description for your key
 * @param {string[]} params.referers - A list of authorized referers
 * @param {Object} params.queryParameters - Force the key to use specific query parameters
 * @param {Function} callback - The result callback called with two arguments
 *   error: null or Error('message')
 *   content: the server answer with the modified API key
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.updateApiKey('APIKEY', ['search'], {
 *   validity: 300,
 *   maxQueriesPerIPPerHour: 2000,
 *   maxHitsPerQuery: 3,
 *   indexes: ['fruits'],
 *   description: 'Eat three fruits',
 *   referers: ['*.algolia.com'],
 *   queryParameters: {
 *     tagFilters: ['public'],
 *   }
 * })
 * @see {@link https://www.algolia.com/doc/rest_api#UpdateIndexKey|Algolia REST API Documentation}
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.updateApiKey = function(key, acls, params, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: client.updateApiKey(key, arrayOfAcls[, params, callback])';
    if (!isArray(acls)) throw new Error(usage);
    if (arguments.length === 2 || typeof params === 'function') {
        callback = params;
        params = null;
    }
    var putObj = {
        acl: acls
    };
    if (params) {
        putObj.validity = params.validity;
        putObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
        putObj.maxHitsPerQuery = params.maxHitsPerQuery;
        putObj.indexes = params.indexes;
        putObj.description = params.description;
        if (params.queryParameters) putObj.queryParameters = this._getSearchParams(params.queryParameters, '');
        putObj.referers = params.referers;
    }
    return this._jsonRequest({
        method: 'PUT',
        url: '/1/keys/' + key,
        body: putObj,
        hostType: 'write',
        callback: callback
    });
};
/**
 * Initialize a new batch of search queries
 * @deprecated use client.search()
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.startQueriesBatch = $5Zn4S(function startQueriesBatchDeprecated() {
    this._batch = [];
}, $gWPav('client.startQueriesBatch()', 'client.search()'));
/**
 * Add a search query in the batch
 * @deprecated use client.search()
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.addQueryInBatch = $5Zn4S(function addQueryInBatchDeprecated(indexName, query, args) {
    this._batch.push({
        indexName: indexName,
        query: query,
        params: args
    });
}, $gWPav('client.addQueryInBatch()', 'client.search()'));
/**
 * Launch the batch of queries using XMLHttpRequest.
 * @deprecated use client.search()
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.sendQueriesBatch = $5Zn4S(function sendQueriesBatchDeprecated(callback) {
    return this.search(this._batch, callback);
}, $gWPav('client.sendQueriesBatch()', 'client.search()'));

/**
 * Perform write operations across multiple indexes.
 *
 * To reduce the amount of time spent on network round trips,
 * you can create, update, or delete several objects in one call,
 * using the batch endpoint (all operations are done in the given order).
 *
 * Available actions:
 *   - addObject
 *   - updateObject
 *   - partialUpdateObject
 *   - partialUpdateObjectNoCreate
 *   - deleteObject
 *
 * https://www.algolia.com/doc/rest_api#Indexes
 * @param  {Object[]} operations An array of operations to perform
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.batch([{
 *   action: 'addObject',
 *   indexName: 'clients',
 *   body: {
 *     name: 'Bill'
 *   }
 * }, {
 *   action: 'udpateObject',
 *   indexName: 'fruits',
 *   body: {
 *     objectID: '29138',
 *     name: 'banana'
 *   }
 * }], cb)
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.batch = function(operations, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: client.batch(operations[, callback])';
    if (!isArray(operations)) throw new Error(usage);
    return this._jsonRequest({
        method: 'POST',
        url: '/1/indexes/*/batch',
        body: {
            requests: operations
        },
        hostType: 'write',
        callback: callback
    });
};
/**
 * Assign or Move a userID to a cluster
 *
 * @param {string} data.userID The userID to assign to a new cluster
 * @param {string} data.cluster The cluster to assign the user to
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.assignUserID({ cluster: 'c1-test', userID: 'some-user' });
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.assignUserID = function(data, callback) {
    if (!data.userID || !data.cluster) throw new $bRG5U.AlgoliaSearchError('You have to provide both a userID and cluster', data);
    return this._jsonRequest({
        method: 'POST',
        url: '/1/clusters/mapping',
        hostType: 'write',
        body: {
            cluster: data.cluster
        },
        callback: callback,
        headers: {
            'x-algolia-user-id': data.userID
        }
    });
};
/**
 * Assign a array of userIDs to a cluster.
 *
 * @param {Array} data.userIDs The array of userIDs to assign to a new cluster
 * @param {string} data.cluster The cluster to assign the user to
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.assignUserIDs({ cluster: 'c1-test', userIDs: ['some-user-1', 'some-user-2'] });
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.assignUserIDs = function(data, callback) {
    if (!data.userIDs || !data.cluster) throw new $bRG5U.AlgoliaSearchError('You have to provide both an array of userIDs and cluster', data);
    return this._jsonRequest({
        method: 'POST',
        url: '/1/clusters/mapping/batch',
        hostType: 'write',
        body: {
            cluster: data.cluster,
            users: data.userIDs
        },
        callback: callback
    });
};
/**
 * Get the top userIDs
 *
 * (the callback is the second argument)
 *
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.getTopUserID();
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.getTopUserID = function(callback) {
    return this._jsonRequest({
        method: 'GET',
        url: '/1/clusters/mapping/top',
        hostType: 'read',
        callback: callback
    });
};
/**
 * Get userID
 *
 * @param {string} data.userID The userID to get info about
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.getUserID({ userID: 'some-user' });
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.getUserID = function(data, callback) {
    if (!data.userID) throw new $bRG5U.AlgoliaSearchError('You have to provide a userID', {
        debugData: data
    });
    return this._jsonRequest({
        method: 'GET',
        url: '/1/clusters/mapping/' + data.userID,
        hostType: 'read',
        callback: callback
    });
};
/**
 * List all the clusters
 *
 * (the callback is the second argument)
 *
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.listClusters();
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.listClusters = function(callback) {
    return this._jsonRequest({
        method: 'GET',
        url: '/1/clusters',
        hostType: 'read',
        callback: callback
    });
};
/**
 * List the userIDs
 *
 * (the callback is the second argument)
 *
 * @param {string} data.hitsPerPage How many hits on every page
 * @param {string} data.page The page to retrieve
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.listClusters();
 * client.listClusters({ page: 3, hitsPerPage: 30});
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.listUserIDs = function(data, callback) {
    return this._jsonRequest({
        method: 'GET',
        url: '/1/clusters/mapping',
        body: data,
        hostType: 'read',
        callback: callback
    });
};
/**
 * Remove an userID
 *
 * @param {string} data.userID The userID to assign to a new cluster
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.removeUserID({ userID: 'some-user' });
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.removeUserID = function(data, callback) {
    if (!data.userID) throw new $bRG5U.AlgoliaSearchError('You have to provide a userID', {
        debugData: data
    });
    return this._jsonRequest({
        method: 'DELETE',
        url: '/1/clusters/mapping',
        hostType: 'write',
        callback: callback,
        headers: {
            'x-algolia-user-id': data.userID
        }
    });
};
/**
 * Search for userIDs
 *
 * @param {string} data.cluster The cluster to target
 * @param {string} data.query The query to execute
 * @param {string} data.hitsPerPage How many hits on every page
 * @param {string} data.page The page to retrieve
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.searchUserIDs({ cluster: 'c1-test', query: 'some-user' });
 * client.searchUserIDs({
 *   cluster: "c1-test",
 *   query: "some-user",
 *   page: 3,
 *   hitsPerPage: 2
 * });
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.searchUserIDs = function(data, callback) {
    return this._jsonRequest({
        method: 'POST',
        url: '/1/clusters/mapping/search',
        body: data,
        hostType: 'read',
        callback: callback
    });
};
/**
 * Set strategy for personalization
 *
 * @param {Object} data
 * @param {Object} data.eventsScoring Associate a score to an event
 * @param {Object} data.eventsScoring.<eventName> The name of the event
 * @param {Number} data.eventsScoring.<eventName>.score The score to associate to <eventName>
 * @param {String} data.eventsScoring.<eventName>.type Either "click", "conversion" or "view"
 * @param {Object} data.facetsScoring Associate a score to a facet
 * @param {Object} data.facetsScoring.<facetName> The name of the facet
 * @param {Number} data.facetsScoring.<facetName>.score The score to associate to <facetName>
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.setPersonalizationStrategy({
 *   eventsScoring: {
 *      "Add to cart": { score: 50, type: "conversion" },
 *      Purchase: { score: 100, type: "conversion" }
 *   },
 *   facetsScoring: {
 *      brand: { score: 100 },
 *      categories: { score: 10 }
 *   }
 * });
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.setPersonalizationStrategy = function(data, callback) {
    return this._jsonRequest({
        method: 'POST',
        url: '/1/recommendation/personalization/strategy',
        body: data,
        hostType: 'write',
        callback: callback
    });
};
/**
 * Get strategy for personalization
 *
 * @return {Promise|undefined} Returns a promise if no callback given
 * @example
 * client.getPersonalizationStrategy();
 */ $248551c8b7135f69$var$AlgoliaSearch.prototype.getPersonalizationStrategy = function(callback) {
    return this._jsonRequest({
        method: 'GET',
        url: '/1/recommendation/personalization/strategy',
        hostType: 'read',
        callback: callback
    });
};
// environment specific methods
$248551c8b7135f69$var$AlgoliaSearch.prototype.destroy = $248551c8b7135f69$var$notImplemented;
$248551c8b7135f69$var$AlgoliaSearch.prototype.enableRateLimitForward = $248551c8b7135f69$var$notImplemented;
$248551c8b7135f69$var$AlgoliaSearch.prototype.disableRateLimitForward = $248551c8b7135f69$var$notImplemented;
$248551c8b7135f69$var$AlgoliaSearch.prototype.useSecuredAPIKey = $248551c8b7135f69$var$notImplemented;
$248551c8b7135f69$var$AlgoliaSearch.prototype.disableSecuredAPIKey = $248551c8b7135f69$var$notImplemented;
$248551c8b7135f69$var$AlgoliaSearch.prototype.generateSecuredApiKey = $248551c8b7135f69$var$notImplemented;
$248551c8b7135f69$var$AlgoliaSearch.prototype.getSecuredApiKeyRemainingValidity = $248551c8b7135f69$var$notImplemented;
function $248551c8b7135f69$var$notImplemented() {
    var message = "Not implemented in this environment.\nIf you feel this is a mistake, write to support@algolia.com";
    throw new $bRG5U.AlgoliaSearchError(message);
}

});
parcelRegister("9uH7N", function(module, exports) {

var $lyUaN = parcelRequire("lyUaN");

var $dsyjX = parcelRequire("dsyjX");

var $5Zn4S = parcelRequire("5Zn4S");

var $gWPav = parcelRequire("gWPav");

var $hb1rf = parcelRequire("hb1rf");

var $bRG5U = parcelRequire("bRG5U");
var $6e985e154f6271a8$var$deprecateForwardToSlaves = $5Zn4S(function() {}, $gWPav('forwardToSlaves', 'forwardToReplicas'));
module.exports = $6e985e154f6271a8$var$Index;
function $6e985e154f6271a8$var$Index() {
    $dsyjX.apply(this, arguments);
}
$lyUaN($6e985e154f6271a8$var$Index, $dsyjX);
/*
* Add an object in this index
*
* @param content contains the javascript object to add inside the index
* @param objectID (optional) an objectID you want to attribute to this object
* (if the attribute already exist the old object will be overwrite)
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that contains 3 elements: createAt, taskId and objectID
*/ $6e985e154f6271a8$var$Index.prototype.addObject = function(content, objectID, callback) {
    var indexObj = this;
    if (arguments.length === 1 || typeof objectID === 'function') {
        callback = objectID;
        objectID = undefined;
    }
    return this.as._jsonRequest({
        method: objectID !== undefined ? 'PUT' : 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + // create
        (objectID !== undefined ? '/' + encodeURIComponent(objectID) : ''),
        body: content,
        hostType: 'write',
        callback: callback
    });
};

/*
* Add several objects
*
* @param objects contains an array of objects to add
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that updateAt and taskID
*/ $6e985e154f6271a8$var$Index.prototype.addObjects = function(objects, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: index.addObjects(arrayOfObjects[, callback])';
    if (!isArray(objects)) throw new Error(usage);
    var indexObj = this;
    var postObj = {
        requests: []
    };
    for(var i = 0; i < objects.length; ++i){
        var request = {
            action: 'addObject',
            body: objects[i]
        };
        postObj.requests.push(request);
    }
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
};
/*
* Update partially an object (only update attributes passed in argument)
*
* @param partialObject contains the javascript attributes to override, the
*  object must contains an objectID attribute
* @param createIfNotExists (optional) if false, avoid an automatic creation of the object
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that contains 3 elements: createAt, taskId and objectID
*/ $6e985e154f6271a8$var$Index.prototype.partialUpdateObject = function(partialObject, createIfNotExists, callback) {
    if (arguments.length === 1 || typeof createIfNotExists === 'function') {
        callback = createIfNotExists;
        createIfNotExists = undefined;
    }
    var indexObj = this;
    var url = '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(partialObject.objectID) + '/partial';
    if (createIfNotExists === false) url += '?createIfNotExists=false';
    return this.as._jsonRequest({
        method: 'POST',
        url: url,
        body: partialObject,
        hostType: 'write',
        callback: callback
    });
};

/*
* Partially Override the content of several objects
*
* @param objects contains an array of objects to update (each object must contains a objectID attribute)
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that updateAt and taskID
*/ $6e985e154f6271a8$var$Index.prototype.partialUpdateObjects = function(objects, createIfNotExists, callback) {
    if (arguments.length === 1 || typeof createIfNotExists === 'function') {
        callback = createIfNotExists;
        createIfNotExists = true;
    }
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: index.partialUpdateObjects(arrayOfObjects[, callback])';
    if (!isArray(objects)) throw new Error(usage);
    var indexObj = this;
    var postObj = {
        requests: []
    };
    for(var i = 0; i < objects.length; ++i){
        var request = {
            action: createIfNotExists === true ? 'partialUpdateObject' : 'partialUpdateObjectNoCreate',
            objectID: objects[i].objectID,
            body: objects[i]
        };
        postObj.requests.push(request);
    }
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
};
/*
* Override the content of object
*
* @param object contains the javascript object to save, the object must contains an objectID attribute
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that updateAt and taskID
*/ $6e985e154f6271a8$var$Index.prototype.saveObject = function(object, callback) {
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'PUT',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(object.objectID),
        body: object,
        hostType: 'write',
        callback: callback
    });
};

/*
* Override the content of several objects
*
* @param objects contains an array of objects to update (each object must contains a objectID attribute)
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that updateAt and taskID
*/ $6e985e154f6271a8$var$Index.prototype.saveObjects = function(objects, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: index.saveObjects(arrayOfObjects[, callback])';
    if (!isArray(objects)) throw new Error(usage);
    var indexObj = this;
    var postObj = {
        requests: []
    };
    for(var i = 0; i < objects.length; ++i){
        var request = {
            action: 'updateObject',
            objectID: objects[i].objectID,
            body: objects[i]
        };
        postObj.requests.push(request);
    }
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
};
/*
* Delete an object from the index
*
* @param objectID the unique identifier of object to delete
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that contains 3 elements: createAt, taskId and objectID
*/ $6e985e154f6271a8$var$Index.prototype.deleteObject = function(objectID, callback) {
    if (typeof objectID === 'function' || typeof objectID !== 'string' && typeof objectID !== 'number') {
        var err = new $bRG5U.AlgoliaSearchError(objectID && typeof objectID !== 'function' ? 'ObjectID must be a string' : 'Cannot delete an object without an objectID');
        callback = objectID;
        if (typeof callback === 'function') return callback(err);
        return this.as._promise.reject(err);
    }
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'DELETE',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(objectID),
        hostType: 'write',
        callback: callback
    });
};


/*
* Delete several objects from an index
*
* @param objectIDs contains an array of objectID to delete
* @param callback (optional) the result callback called with two arguments:
*  error: null or Error('message')
*  content: the server answer that contains 3 elements: createAt, taskId and objectID
*/ $6e985e154f6271a8$var$Index.prototype.deleteObjects = function(objectIDs, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var map = (parcelRequire("4B8vt"));
    var usage = 'Usage: index.deleteObjects(arrayOfObjectIDs[, callback])';
    if (!isArray(objectIDs)) throw new Error(usage);
    var indexObj = this;
    var postObj = {
        requests: map(objectIDs, function prepareRequest(objectID) {
            return {
                action: 'deleteObject',
                objectID: objectID,
                body: {
                    objectID: objectID
                }
            };
        })
    };
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/batch',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
};


/*
* Delete all objects matching a query
*
* @param query the query string
* @param params the optional query parameters
* @param callback (optional) the result callback called with one argument
*  error: null or Error('message')
* @deprecated see index.deleteBy
*/ $6e985e154f6271a8$var$Index.prototype.deleteByQuery = $5Zn4S(function(query, params, callback) {
    var clone = (parcelRequire("eFOtW"));
    var map = (parcelRequire("4B8vt"));
    var indexObj = this;
    var client = indexObj.as;
    if (arguments.length === 1 || typeof params === 'function') {
        callback = params;
        params = {};
    } else params = clone(params);
    params.attributesToRetrieve = 'objectID';
    params.hitsPerPage = 1000;
    params.distinct = false;
    // when deleting, we should never use cache to get the
    // search results
    this.clearCache();
    // there's a problem in how we use the promise chain,
    // see how waitTask is done
    var promise = this.search(query, params).then(stopOrDelete);
    function stopOrDelete(searchContent) {
        // stop here
        if (searchContent.nbHits === 0) // return indexObj.as._request.resolve();
        return searchContent;
        // continue and do a recursive call
        var objectIDs = map(searchContent.hits, function getObjectID(object) {
            return object.objectID;
        });
        return indexObj.deleteObjects(objectIDs).then(waitTask).then(doDeleteByQuery);
    }
    function waitTask(deleteObjectsContent) {
        return indexObj.waitTask(deleteObjectsContent.taskID);
    }
    function doDeleteByQuery() {
        return indexObj.deleteByQuery(query, params);
    }
    if (!callback) return promise;
    promise.then(success, failure);
    function success() {
        $hb1rf(function exit() {
            callback(null);
        }, client._setTimeout || setTimeout);
    }
    function failure(err) {
        $hb1rf(function exit() {
            callback(err);
        }, client._setTimeout || setTimeout);
    }
}, $gWPav('index.deleteByQuery()', 'index.deleteBy()'));
/**
* Delete all objects matching a query
*
* the query parameters that can be used are:
* - filters (numeric, facet, tag)
* - geo
*
* you can not send an empty query or filters
*
* @param params the optional query parameters
* @param callback (optional) the result callback called with one argument
*  error: null or Error('message')
*/ $6e985e154f6271a8$var$Index.prototype.deleteBy = function(params, callback) {
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/deleteByQuery',
        body: {
            params: indexObj.as._getSearchParams(params, '')
        },
        hostType: 'write',
        callback: callback
    });
};


/*
* Browse all content from an index using events. Basically this will do
* .browse() -> .browseFrom -> .browseFrom -> .. until all the results are returned
*
* @param {string} query - The full text query
* @param {Object} [queryParameters] - Any search query parameter
* @return {EventEmitter}
* @example
* var browser = index.browseAll('cool songs', {
*   tagFilters: 'public,comments',
*   hitsPerPage: 500
* });
*
* browser.on('result', function resultCallback(content) {
*   console.log(content.hits);
* });
*
* // if any error occurs, you get it
* browser.on('error', function(err) {
*   throw err;
* });
*
* // when you have browsed the whole index, you get this event
* browser.on('end', function() {
*   console.log('finished');
* });
*
* // at any point if you want to stop the browsing process, you can stop it manually
* // otherwise it will go on and on
* browser.stop();
*
* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
*/ $6e985e154f6271a8$var$Index.prototype.browseAll = function(query, queryParameters) {
    if (typeof query === 'object') {
        queryParameters = query;
        query = undefined;
    }
    var merge = (parcelRequire("e1p6j"));
    var IndexBrowser = (parcelRequire("eSgQh"));
    var browser = new IndexBrowser();
    var client = this.as;
    var index = this;
    var params = client._getSearchParams(merge({}, queryParameters || {}, {
        query: query
    }), '');
    // start browsing
    browseLoop();
    function browseLoop(cursor) {
        if (browser._stopped) return;
        var body;
        if (cursor !== undefined) body = {
            cursor: cursor
        };
        else body = {
            params: params
        };
        client._jsonRequest({
            method: 'POST',
            url: '/1/indexes/' + encodeURIComponent(index.indexName) + '/browse',
            hostType: 'read',
            body: body,
            callback: browseCallback
        });
    }
    function browseCallback(err, content) {
        if (browser._stopped) return;
        if (err) {
            browser._error(err);
            return;
        }
        browser._result(content);
        // no cursor means we are finished browsing
        if (content.cursor === undefined) {
            browser._end();
            return;
        }
        browseLoop(content.cursor);
    }
    return browser;
};
/*
* Get a Typeahead.js adapter
* @param searchParams contains an object with query parameters (see search for details)
*/ $6e985e154f6271a8$var$Index.prototype.ttAdapter = $5Zn4S(function(params) {
    var self = this;
    return function ttAdapter(query, syncCb, asyncCb) {
        var cb;
        if (typeof asyncCb === 'function') // typeahead 0.11
        cb = asyncCb;
        else // pre typeahead 0.11
        cb = syncCb;
        self.search(query, params, function searchDone(err, content) {
            if (err) {
                cb(err);
                return;
            }
            cb(content.hits);
        });
    };
}, "ttAdapter is not necessary anymore and will be removed in the next version,\nhave a look at autocomplete.js (https://github.com/algolia/autocomplete.js)");
/*
* Wait the publication of a task on the server.
* All server task are asynchronous and you can check with this method that the task is published.
*
* @param taskID the id of the task returned by server
* @param callback the result callback with with two arguments:
*  error: null or Error('message')
*  content: the server answer that contains the list of results
*/ $6e985e154f6271a8$var$Index.prototype.waitTask = function(taskID, callback) {
    // wait minimum 100ms before retrying
    var baseDelay = 100;
    // wait maximum 5s before retrying
    var maxDelay = 5000;
    var loop = 0;
    // waitTask() must be handled differently from other methods,
    // it's a recursive method using a timeout
    var indexObj = this;
    var client = indexObj.as;
    var promise = retryLoop();
    function retryLoop() {
        return client._jsonRequest({
            method: 'GET',
            hostType: 'read',
            url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/task/' + taskID
        }).then(function success(content) {
            loop++;
            var delay = baseDelay * loop * loop;
            if (delay > maxDelay) delay = maxDelay;
            if (content.status !== 'published') return client._promise.delay(delay).then(retryLoop);
            return content;
        });
    }
    if (!callback) return promise;
    promise.then(successCb, failureCb);
    function successCb(content) {
        $hb1rf(function exit() {
            callback(null, content);
        }, client._setTimeout || setTimeout);
    }
    function failureCb(err) {
        $hb1rf(function exit() {
            callback(err);
        }, client._setTimeout || setTimeout);
    }
};
/*
* This function deletes the index content. Settings and index specific API keys are kept untouched.
*
* @param callback (optional) the result callback called with two arguments
*  error: null or Error('message')
*  content: the settings object or the error message if a failure occurred
*/ $6e985e154f6271a8$var$Index.prototype.clearIndex = function(callback) {
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/clear',
        hostType: 'write',
        callback: callback
    });
};
/*
* Get settings of this index
*
* @param opts an object of options to add
* @param opts.advanced get more settings like nbShards (useful for Enterprise)
* @param callback (optional) the result callback called with two arguments
*  error: null or Error('message')
*  content: the settings object or the error message if a failure occurred
*/ $6e985e154f6271a8$var$Index.prototype.getSettings = function(opts, callback) {
    if (arguments.length === 1 && typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    opts = opts || {};
    var indexName = encodeURIComponent(this.indexName);
    return this.as._jsonRequest({
        method: 'GET',
        url: '/1/indexes/' + indexName + '/settings?getVersion=2' + (opts.advanced ? '&advanced=' + opts.advanced : ''),
        hostType: 'read',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.searchSynonyms = function(params, callback) {
    if (typeof params === 'function') {
        callback = params;
        params = {};
    } else if (params === undefined) params = {};
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/search',
        body: params,
        hostType: 'read',
        callback: callback
    });
};
function $6e985e154f6271a8$var$exportData(method, _hitsPerPage, callback) {
    function search(page, _previous) {
        var options = {
            page: page || 0,
            hitsPerPage: _hitsPerPage || 100
        };
        var previous = _previous || [];
        return method(options).then(function(result) {
            var hits = result.hits;
            var nbHits = result.nbHits;
            var current = hits.map(function(s) {
                delete s._highlightResult;
                return s;
            });
            var synonyms = previous.concat(current);
            if (synonyms.length < nbHits) return search(options.page + 1, synonyms);
            return synonyms;
        });
    }
    return search().then(function(data) {
        if (typeof callback === 'function') {
            callback(data);
            return undefined;
        }
        return data;
    });
}
/**
 * Retrieve all the synonyms in an index
 * @param [number=100] hitsPerPage The amount of synonyms to retrieve per batch
 * @param [function] callback will be called after all synonyms are retrieved
 */ $6e985e154f6271a8$var$Index.prototype.exportSynonyms = function(hitsPerPage, callback) {
    return $6e985e154f6271a8$var$exportData(this.searchSynonyms.bind(this), hitsPerPage, callback);
};
$6e985e154f6271a8$var$Index.prototype.saveSynonym = function(synonym, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    if (opts.forwardToSlaves !== undefined) $6e985e154f6271a8$var$deprecateForwardToSlaves();
    var forwardToReplicas = opts.forwardToSlaves || opts.forwardToReplicas ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'PUT',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(synonym.objectID) + '?forwardToReplicas=' + forwardToReplicas,
        body: synonym,
        hostType: 'write',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.getSynonym = function(objectID, callback) {
    return this.as._jsonRequest({
        method: 'GET',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(objectID),
        hostType: 'read',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.deleteSynonym = function(objectID, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    if (opts.forwardToSlaves !== undefined) $6e985e154f6271a8$var$deprecateForwardToSlaves();
    var forwardToReplicas = opts.forwardToSlaves || opts.forwardToReplicas ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'DELETE',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/' + encodeURIComponent(objectID) + '?forwardToReplicas=' + forwardToReplicas,
        hostType: 'write',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.clearSynonyms = function(opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    if (opts.forwardToSlaves !== undefined) $6e985e154f6271a8$var$deprecateForwardToSlaves();
    var forwardToReplicas = opts.forwardToSlaves || opts.forwardToReplicas ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/clear' + '?forwardToReplicas=' + forwardToReplicas,
        hostType: 'write',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.batchSynonyms = function(synonyms, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    if (opts.forwardToSlaves !== undefined) $6e985e154f6271a8$var$deprecateForwardToSlaves();
    var forwardToReplicas = opts.forwardToSlaves || opts.forwardToReplicas ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/synonyms/batch' + '?forwardToReplicas=' + forwardToReplicas + '&replaceExistingSynonyms=' + (opts.replaceExistingSynonyms ? 'true' : 'false'),
        hostType: 'write',
        body: synonyms,
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.searchRules = function(params, callback) {
    if (typeof params === 'function') {
        callback = params;
        params = {};
    } else if (params === undefined) params = {};
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/search',
        body: params,
        hostType: 'read',
        callback: callback
    });
};
/**
 * Retrieve all the query rules in an index
 * @param [number=100] hitsPerPage The amount of query rules to retrieve per batch
 * @param [function] callback will be called after all query rules are retrieved
 *  error: null or Error('message')
 */ $6e985e154f6271a8$var$Index.prototype.exportRules = function(hitsPerPage, callback) {
    return $6e985e154f6271a8$var$exportData(this.searchRules.bind(this), hitsPerPage, callback);
};
$6e985e154f6271a8$var$Index.prototype.saveRule = function(rule, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    if (!rule.objectID) throw new $bRG5U.AlgoliaSearchError('Missing or empty objectID field for rule');
    var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'PUT',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/' + encodeURIComponent(rule.objectID) + '?forwardToReplicas=' + forwardToReplicas,
        body: rule,
        hostType: 'write',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.getRule = function(objectID, callback) {
    return this.as._jsonRequest({
        method: 'GET',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/' + encodeURIComponent(objectID),
        hostType: 'read',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.deleteRule = function(objectID, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'DELETE',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/' + encodeURIComponent(objectID) + '?forwardToReplicas=' + forwardToReplicas,
        hostType: 'write',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.clearRules = function(opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/clear' + '?forwardToReplicas=' + forwardToReplicas,
        hostType: 'write',
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.batchRules = function(rules, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    var forwardToReplicas = opts.forwardToReplicas === true ? 'true' : 'false';
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/rules/batch' + '?forwardToReplicas=' + forwardToReplicas + '&clearExistingRules=' + (opts.clearExistingRules === true ? 'true' : 'false'),
        hostType: 'write',
        body: rules,
        callback: callback
    });
};
$6e985e154f6271a8$var$Index.prototype.exists = function(callback) {
    var result = this.getSettings().then(function() {
        return true;
    }).catch(function(err) {
        if (err instanceof $bRG5U.AlgoliaSearchError && err.statusCode === 404) return false;
        throw err;
    });
    if (typeof callback !== 'function') return result;
    result.then(function(res) {
        callback(null, res);
    }).catch(function(err) {
        callback(err);
    });
};
$6e985e154f6271a8$var$Index.prototype.findObject = function(findCallback, requestOptions, callback) {
    requestOptions = requestOptions === undefined ? {} : requestOptions;
    var paginate = requestOptions.paginate !== undefined ? requestOptions.paginate : true;
    var query = requestOptions.query !== undefined ? requestOptions.query : '';
    var that = this;
    var page = 0;
    var paginateLoop = function() {
        requestOptions.page = page;
        return that.search(query, requestOptions).then(function(result) {
            var hits = result.hits;
            for(var position = 0; position < hits.length; position++){
                var hit = hits[position];
                if (findCallback(hit)) return {
                    object: hit,
                    position: position,
                    page: page
                };
            }
            page += 1;
            // paginate if option was set and has next page
            if (!paginate || page >= result.nbPages) throw new $bRG5U.ObjectNotFound('Object not found');
            return paginateLoop();
        });
    };
    var promise = paginateLoop(page);
    if (callback === undefined) return promise;
    promise.then(function(res) {
        callback(null, res);
    }).catch(function(err) {
        callback(err);
    });
};
$6e985e154f6271a8$var$Index.prototype.getObjectPosition = function(result, objectID) {
    var hits = result.hits;
    for(var position = 0; position < hits.length; position++){
        if (hits[position].objectID === objectID) return position;
    }
    return -1;
};
/*
* Set settings for this index
*
* @param settings the settings object that can contains :
* - minWordSizefor1Typo: (integer) the minimum number of characters to accept one typo (default = 3).
* - minWordSizefor2Typos: (integer) the minimum number of characters to accept two typos (default = 7).
* - hitsPerPage: (integer) the number of hits per page (default = 10).
* - attributesToRetrieve: (array of strings) default list of attributes to retrieve in objects.
*   If set to null, all attributes are retrieved.
* - attributesToHighlight: (array of strings) default list of attributes to highlight.
*   If set to null, all indexed attributes are highlighted.
* - attributesToSnippet**: (array of strings) default list of attributes to snippet alongside the number
* of words to return (syntax is attributeName:nbWords).
*   By default no snippet is computed. If set to null, no snippet is computed.
* - attributesToIndex: (array of strings) the list of fields you want to index.
*   If set to null, all textual and numerical attributes of your objects are indexed,
*   but you should update it to get optimal results.
*   This parameter has two important uses:
*     - Limit the attributes to index: For example if you store a binary image in base64,
*     you want to store it and be able to
*       retrieve it but you don't want to search in the base64 string.
*     - Control part of the ranking*: (see the ranking parameter for full explanation)
*     Matches in attributes at the beginning of
*       the list will be considered more important than matches in attributes further down the list.
*       In one attribute, matching text at the beginning of the attribute will be
*       considered more important than text after, you can disable
*       this behavior if you add your attribute inside `unordered(AttributeName)`,
*       for example attributesToIndex: ["title", "unordered(text)"].
* - attributesForFaceting: (array of strings) The list of fields you want to use for faceting.
*   All strings in the attribute selected for faceting are extracted and added as a facet.
*   If set to null, no attribute is used for faceting.
* - attributeForDistinct: (string) The attribute name used for the Distinct feature.
* This feature is similar to the SQL "distinct" keyword: when enabled
*   in query with the distinct=1 parameter, all hits containing a duplicate
*   value for this attribute are removed from results.
*   For example, if the chosen attribute is show_name and several hits have
*   the same value for show_name, then only the best one is kept and others are removed.
* - ranking: (array of strings) controls the way results are sorted.
*   We have six available criteria:
*    - typo: sort according to number of typos,
*    - geo: sort according to decreassing distance when performing a geo-location based search,
*    - proximity: sort according to the proximity of query words in hits,
*    - attribute: sort according to the order of attributes defined by attributesToIndex,
*    - exact:
*        - if the user query contains one word: sort objects having an attribute
*        that is exactly the query word before others.
*          For example if you search for the "V" TV show, you want to find it
*          with the "V" query and avoid to have all popular TV
*          show starting by the v letter before it.
*        - if the user query contains multiple words: sort according to the
*        number of words that matched exactly (and not as a prefix).
*    - custom: sort according to a user defined formula set in **customRanking** attribute.
*   The standard order is ["typo", "geo", "proximity", "attribute", "exact", "custom"]
* - customRanking: (array of strings) lets you specify part of the ranking.
*   The syntax of this condition is an array of strings containing attributes
*   prefixed by asc (ascending order) or desc (descending order) operator.
*   For example `"customRanking" => ["desc(population)", "asc(name)"]`
* - queryType: Select how the query words are interpreted, it can be one of the following value:
*   - prefixAll: all query words are interpreted as prefixes,
*   - prefixLast: only the last word is interpreted as a prefix (default behavior),
*   - prefixNone: no query word is interpreted as a prefix. This option is not recommended.
* - highlightPreTag: (string) Specify the string that is inserted before
* the highlighted parts in the query result (default to "<em>").
* - highlightPostTag: (string) Specify the string that is inserted after
* the highlighted parts in the query result (default to "</em>").
* - optionalWords: (array of strings) Specify a list of words that should
* be considered as optional when found in the query.
* @param callback (optional) the result callback called with two arguments
*  error: null or Error('message')
*  content: the server answer or the error message if a failure occurred
*/ $6e985e154f6271a8$var$Index.prototype.setSettings = function(settings, opts, callback) {
    if (arguments.length === 1 || typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    if (opts.forwardToSlaves !== undefined) $6e985e154f6271a8$var$deprecateForwardToSlaves();
    var forwardToReplicas = opts.forwardToSlaves || opts.forwardToReplicas ? 'true' : 'false';
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'PUT',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/settings?forwardToReplicas=' + forwardToReplicas,
        hostType: 'write',
        body: settings,
        callback: callback
    });
};
/*
* @deprecated see client.listApiKeys()
*/ $6e985e154f6271a8$var$Index.prototype.listUserKeys = $5Zn4S(function(callback) {
    return this.listApiKeys(callback);
}, $gWPav('index.listUserKeys()', 'client.listApiKeys()'));
/*
* List all existing API keys to this index
*
* @param callback the result callback called with two arguments
*  error: null or Error('message')
*  content: the server answer with API keys belonging to the index
*
* @deprecated see client.listApiKeys()
*/ $6e985e154f6271a8$var$Index.prototype.listApiKeys = $5Zn4S(function(callback) {
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'GET',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys',
        hostType: 'read',
        callback: callback
    });
}, $gWPav('index.listApiKeys()', 'client.listApiKeys()'));
/*
* @deprecated see client.getApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.getUserKeyACL = $5Zn4S(function(key, callback) {
    return this.getApiKey(key, callback);
}, $gWPav('index.getUserKeyACL()', 'client.getApiKey()'));
/*
* Get an API key from this index
*
* @param key
* @param callback the result callback called with two arguments
*  error: null or Error('message')
*  content: the server answer with the right API key
*
* @deprecated see client.getApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.getApiKey = $5Zn4S(function(key, callback) {
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'GET',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys/' + key,
        hostType: 'read',
        callback: callback
    });
}, $gWPav('index.getApiKey()', 'client.getApiKey()'));
/*
* @deprecated see client.deleteApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.deleteUserKey = $5Zn4S(function(key, callback) {
    return this.deleteApiKey(key, callback);
}, $gWPav('index.deleteUserKey()', 'client.deleteApiKey()'));
/*
* Delete an existing API key associated to this index
*
* @param key
* @param callback the result callback called with two arguments
*  error: null or Error('message')
*  content: the server answer with the deletion date
*
* @deprecated see client.deleteApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.deleteApiKey = $5Zn4S(function(key, callback) {
    var indexObj = this;
    return this.as._jsonRequest({
        method: 'DELETE',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/keys/' + key,
        hostType: 'write',
        callback: callback
    });
}, $gWPav('index.deleteApiKey()', 'client.deleteApiKey()'));
/*
* @deprecated see client.addApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.addUserKey = $5Zn4S(function(acls, params, callback) {
    return this.addApiKey(acls, params, callback);
}, $gWPav('index.addUserKey()', 'client.addApiKey()'));

/*
* Add a new API key to this index
*
* @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
*   can contains the following values:
*     - search: allow to search (https and http)
*     - addObject: allows to add/update an object in the index (https only)
*     - deleteObject : allows to delete an existing object (https only)
*     - deleteIndex : allows to delete index content (https only)
*     - settings : allows to get index settings (https only)
*     - editSettings : allows to change index settings (https only)
* @param {Object} [params] - Optionnal parameters to set for the key
* @param {number} params.validity - Number of seconds after which the key will
* be automatically removed (0 means no time limit for this key)
* @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
* @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
* @param {string} params.description - A description for your key
* @param {string[]} params.referers - A list of authorized referers
* @param {Object} params.queryParameters - Force the key to use specific query parameters
* @param {Function} callback - The result callback called with two arguments
*   error: null or Error('message')
*   content: the server answer with the added API key
* @return {Promise|undefined} Returns a promise if no callback given
* @example
* index.addUserKey(['search'], {
*   validity: 300,
*   maxQueriesPerIPPerHour: 2000,
*   maxHitsPerQuery: 3,
*   description: 'Eat three fruits',
*   referers: ['*.algolia.com'],
*   queryParameters: {
*     tagFilters: ['public'],
*   }
* })
* @see {@link https://www.algolia.com/doc/rest_api#AddIndexKey|Algolia REST API Documentation}
*
* @deprecated see client.addApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.addApiKey = $5Zn4S(function(acls, params, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: index.addApiKey(arrayOfAcls[, params, callback])';
    if (!isArray(acls)) throw new Error(usage);
    if (arguments.length === 1 || typeof params === 'function') {
        callback = params;
        params = null;
    }
    var postObj = {
        acl: acls
    };
    if (params) {
        postObj.validity = params.validity;
        postObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
        postObj.maxHitsPerQuery = params.maxHitsPerQuery;
        postObj.description = params.description;
        if (params.queryParameters) postObj.queryParameters = this.as._getSearchParams(params.queryParameters, '');
        postObj.referers = params.referers;
    }
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/keys',
        body: postObj,
        hostType: 'write',
        callback: callback
    });
}, $gWPav('index.addApiKey()', 'client.addApiKey()'));
/**
* @deprecated use client.addApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.addUserKeyWithValidity = $5Zn4S(function deprecatedAddUserKeyWithValidity(acls, params, callback) {
    return this.addApiKey(acls, params, callback);
}, $gWPav('index.addUserKeyWithValidity()', 'client.addApiKey()'));
/*
* @deprecated see client.updateApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.updateUserKey = $5Zn4S(function(key, acls, params, callback) {
    return this.updateApiKey(key, acls, params, callback);
}, $gWPav('index.updateUserKey()', 'client.updateApiKey()'));

/**
* Update an existing API key of this index
* @param {string} key - The key to update
* @param {string[]} acls - The list of ACL for this key. Defined by an array of strings that
*   can contains the following values:
*     - search: allow to search (https and http)
*     - addObject: allows to add/update an object in the index (https only)
*     - deleteObject : allows to delete an existing object (https only)
*     - deleteIndex : allows to delete index content (https only)
*     - settings : allows to get index settings (https only)
*     - editSettings : allows to change index settings (https only)
* @param {Object} [params] - Optionnal parameters to set for the key
* @param {number} params.validity - Number of seconds after which the key will
* be automatically removed (0 means no time limit for this key)
* @param {number} params.maxQueriesPerIPPerHour - Number of API calls allowed from an IP address per hour
* @param {number} params.maxHitsPerQuery - Number of hits this API key can retrieve in one call
* @param {string} params.description - A description for your key
* @param {string[]} params.referers - A list of authorized referers
* @param {Object} params.queryParameters - Force the key to use specific query parameters
* @param {Function} callback - The result callback called with two arguments
*   error: null or Error('message')
*   content: the server answer with user keys list
* @return {Promise|undefined} Returns a promise if no callback given
* @example
* index.updateApiKey('APIKEY', ['search'], {
*   validity: 300,
*   maxQueriesPerIPPerHour: 2000,
*   maxHitsPerQuery: 3,
*   description: 'Eat three fruits',
*   referers: ['*.algolia.com'],
*   queryParameters: {
*     tagFilters: ['public'],
*   }
* })
* @see {@link https://www.algolia.com/doc/rest_api#UpdateIndexKey|Algolia REST API Documentation}
*
* @deprecated see client.updateApiKey()
*/ $6e985e154f6271a8$var$Index.prototype.updateApiKey = $5Zn4S(function(key, acls, params, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var usage = 'Usage: index.updateApiKey(key, arrayOfAcls[, params, callback])';
    if (!isArray(acls)) throw new Error(usage);
    if (arguments.length === 2 || typeof params === 'function') {
        callback = params;
        params = null;
    }
    var putObj = {
        acl: acls
    };
    if (params) {
        putObj.validity = params.validity;
        putObj.maxQueriesPerIPPerHour = params.maxQueriesPerIPPerHour;
        putObj.maxHitsPerQuery = params.maxHitsPerQuery;
        putObj.description = params.description;
        if (params.queryParameters) putObj.queryParameters = this.as._getSearchParams(params.queryParameters, '');
        putObj.referers = params.referers;
    }
    return this.as._jsonRequest({
        method: 'PUT',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/keys/' + key,
        body: putObj,
        hostType: 'write',
        callback: callback
    });
}, $gWPav('index.updateApiKey()', 'client.updateApiKey()'));

});
parcelRegister("lyUaN", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("dsyjX", function(module, exports) {

var $lfQVS = parcelRequire("lfQVS");

var $5Zn4S = parcelRequire("5Zn4S");

var $gWPav = parcelRequire("gWPav");
module.exports = $9cc883490bc9625b$var$IndexCore;
/*
* Index class constructor.
* You should not use this method directly but use initIndex() function
*/ function $9cc883490bc9625b$var$IndexCore(algoliasearch, indexName) {
    this.indexName = indexName;
    this.as = algoliasearch;
    this.typeAheadArgs = null;
    this.typeAheadValueOption = null;
    // make sure every index instance has it's own cache
    this.cache = {};
}
/*
* Clear all queries in cache
*/ $9cc883490bc9625b$var$IndexCore.prototype.clearCache = function() {
    this.cache = {};
};
/*
* Search inside the index using XMLHttpRequest request (Using a POST query to
* minimize number of OPTIONS queries: Cross-Origin Resource Sharing).
*
* @param {string} [query] the full text query
* @param {object} [args] (optional) if set, contains an object with query parameters:
* - page: (integer) Pagination parameter used to select the page to retrieve.
*                   Page is zero-based and defaults to 0. Thus,
*                   to retrieve the 10th page you need to set page=9
* - hitsPerPage: (integer) Pagination parameter used to select the number of hits per page. Defaults to 20.
* - attributesToRetrieve: a string that contains the list of object attributes
* you want to retrieve (let you minimize the answer size).
*   Attributes are separated with a comma (for example "name,address").
*   You can also use an array (for example ["name","address"]).
*   By default, all attributes are retrieved. You can also use '*' to retrieve all
*   values when an attributesToRetrieve setting is specified for your index.
* - attributesToHighlight: a string that contains the list of attributes you
*   want to highlight according to the query.
*   Attributes are separated by a comma. You can also use an array (for example ["name","address"]).
*   If an attribute has no match for the query, the raw value is returned.
*   By default all indexed text attributes are highlighted.
*   You can use `*` if you want to highlight all textual attributes.
*   Numerical attributes are not highlighted.
*   A matchLevel is returned for each highlighted attribute and can contain:
*      - full: if all the query terms were found in the attribute,
*      - partial: if only some of the query terms were found,
*      - none: if none of the query terms were found.
* - attributesToSnippet: a string that contains the list of attributes to snippet alongside
* the number of words to return (syntax is `attributeName:nbWords`).
*    Attributes are separated by a comma (Example: attributesToSnippet=name:10,content:10).
*    You can also use an array (Example: attributesToSnippet: ['name:10','content:10']).
*    By default no snippet is computed.
* - minWordSizefor1Typo: the minimum number of characters in a query word to accept one typo in this word.
* Defaults to 3.
* - minWordSizefor2Typos: the minimum number of characters in a query word
* to accept two typos in this word. Defaults to 7.
* - getRankingInfo: if set to 1, the result hits will contain ranking
* information in _rankingInfo attribute.
* - aroundLatLng: search for entries around a given
* latitude/longitude (specified as two floats separated by a comma).
*   For example aroundLatLng=47.316669,5.016670).
*   You can specify the maximum distance in meters with the aroundRadius parameter (in meters)
*   and the precision for ranking with aroundPrecision
*   (for example if you set aroundPrecision=100, two objects that are distant of
*   less than 100m will be considered as identical for "geo" ranking parameter).
*   At indexing, you should specify geoloc of an object with the _geoloc attribute
*   (in the form {"_geoloc":{"lat":48.853409, "lng":2.348800}})
* - insideBoundingBox: search entries inside a given area defined by the two extreme points
* of a rectangle (defined by 4 floats: p1Lat,p1Lng,p2Lat,p2Lng).
*   For example insideBoundingBox=47.3165,4.9665,47.3424,5.0201).
*   At indexing, you should specify geoloc of an object with the _geoloc attribute
*   (in the form {"_geoloc":{"lat":48.853409, "lng":2.348800}})
* - numericFilters: a string that contains the list of numeric filters you want to
* apply separated by a comma.
*   The syntax of one filter is `attributeName` followed by `operand` followed by `value`.
*   Supported operands are `<`, `<=`, `=`, `>` and `>=`.
*   You can have multiple conditions on one attribute like for example numericFilters=price>100,price<1000.
*   You can also use an array (for example numericFilters: ["price>100","price<1000"]).
* - tagFilters: filter the query by a set of tags. You can AND tags by separating them by commas.
*   To OR tags, you must add parentheses. For example, tags=tag1,(tag2,tag3) means tag1 AND (tag2 OR tag3).
*   You can also use an array, for example tagFilters: ["tag1",["tag2","tag3"]]
*   means tag1 AND (tag2 OR tag3).
*   At indexing, tags should be added in the _tags** attribute
*   of objects (for example {"_tags":["tag1","tag2"]}).
* - facetFilters: filter the query by a list of facets.
*   Facets are separated by commas and each facet is encoded as `attributeName:value`.
*   For example: `facetFilters=category:Book,author:John%20Doe`.
*   You can also use an array (for example `["category:Book","author:John%20Doe"]`).
* - facets: List of object attributes that you want to use for faceting.
*   Comma separated list: `"category,author"` or array `['category','author']`
*   Only attributes that have been added in **attributesForFaceting** index setting
*   can be used in this parameter.
*   You can also use `*` to perform faceting on all attributes specified in **attributesForFaceting**.
* - queryType: select how the query words are interpreted, it can be one of the following value:
*    - prefixAll: all query words are interpreted as prefixes,
*    - prefixLast: only the last word is interpreted as a prefix (default behavior),
*    - prefixNone: no query word is interpreted as a prefix. This option is not recommended.
* - optionalWords: a string that contains the list of words that should
* be considered as optional when found in the query.
*   Comma separated and array are accepted.
* - distinct: If set to 1, enable the distinct feature (disabled by default)
* if the attributeForDistinct index setting is set.
*   This feature is similar to the SQL "distinct" keyword: when enabled
*   in a query with the distinct=1 parameter,
*   all hits containing a duplicate value for the attributeForDistinct attribute are removed from results.
*   For example, if the chosen attribute is show_name and several hits have
*   the same value for show_name, then only the best
*   one is kept and others are removed.
* - restrictSearchableAttributes: List of attributes you want to use for
* textual search (must be a subset of the attributesToIndex index setting)
* either comma separated or as an array
* @param {function} [callback] the result callback called with two arguments:
*  error: null or Error('message'). If false, the content contains the error.
*  content: the server answer that contains the list of results.
*/ $9cc883490bc9625b$var$IndexCore.prototype.search = $lfQVS('query');
/*
* -- BETA --
* Search a record similar to the query inside the index using XMLHttpRequest request (Using a POST query to
* minimize number of OPTIONS queries: Cross-Origin Resource Sharing).
*
* @param {string} [query] the similar query
* @param {object} [args] (optional) if set, contains an object with query parameters.
*   All search parameters are supported (see search function), restrictSearchableAttributes and facetFilters
*   are the two most useful to restrict the similar results and get more relevant content
*/ $9cc883490bc9625b$var$IndexCore.prototype.similarSearch = $5Zn4S($lfQVS('similarQuery'), $gWPav('index.similarSearch(query[, callback])', 'index.search({ similarQuery: query }[, callback])'));

/*
* Browse index content. The response content will have a `cursor` property that you can use
* to browse subsequent pages for this query. Use `index.browseFrom(cursor)` when you want.
*
* @param {string} query - The full text query
* @param {Object} [queryParameters] - Any search query parameter
* @param {Function} [callback] - The result callback called with two arguments
*   error: null or Error('message')
*   content: the server answer with the browse result
* @return {Promise|undefined} Returns a promise if no callback given
* @example
* index.browse('cool songs', {
*   tagFilters: 'public,comments',
*   hitsPerPage: 500
* }, callback);
* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
*/ $9cc883490bc9625b$var$IndexCore.prototype.browse = function(query, queryParameters, callback) {
    var merge = (parcelRequire("e1p6j"));
    var indexObj = this;
    var page;
    var hitsPerPage;
    // we check variadic calls that are not the one defined
    // .browse()/.browse(fn)
    // => page = 0
    if (arguments.length === 0 || arguments.length === 1 && typeof arguments[0] === 'function') {
        page = 0;
        callback = arguments[0];
        query = undefined;
    } else if (typeof arguments[0] === 'number') {
        // .browse(2)/.browse(2, 10)/.browse(2, fn)/.browse(2, 10, fn)
        page = arguments[0];
        if (typeof arguments[1] === 'number') hitsPerPage = arguments[1];
        else if (typeof arguments[1] === 'function') {
            callback = arguments[1];
            hitsPerPage = undefined;
        }
        query = undefined;
        queryParameters = undefined;
    } else if (typeof arguments[0] === 'object') {
        // .browse(queryParameters)/.browse(queryParameters, cb)
        if (typeof arguments[1] === 'function') callback = arguments[1];
        queryParameters = arguments[0];
        query = undefined;
    } else if (typeof arguments[0] === 'string' && typeof arguments[1] === 'function') {
        // .browse(query, cb)
        callback = arguments[1];
        queryParameters = undefined;
    }
    // otherwise it's a .browse(query)/.browse(query, queryParameters)/.browse(query, queryParameters, cb)
    // get search query parameters combining various possible calls
    // to .browse();
    queryParameters = merge({}, queryParameters || {}, {
        page: page,
        hitsPerPage: hitsPerPage,
        query: query
    });
    var params = this.as._getSearchParams(queryParameters, '');
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/browse',
        body: {
            params: params
        },
        hostType: 'read',
        callback: callback
    });
};
/*
* Continue browsing from a previous position (cursor), obtained via a call to `.browse()`.
*
* @param {string} query - The full text query
* @param {Object} [queryParameters] - Any search query parameter
* @param {Function} [callback] - The result callback called with two arguments
*   error: null or Error('message')
*   content: the server answer with the browse result
* @return {Promise|undefined} Returns a promise if no callback given
* @example
* index.browseFrom('14lkfsakl32', callback);
* @see {@link https://www.algolia.com/doc/rest_api#Browse|Algolia REST API Documentation}
*/ $9cc883490bc9625b$var$IndexCore.prototype.browseFrom = function(cursor, callback) {
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/browse',
        body: {
            cursor: cursor
        },
        hostType: 'read',
        callback: callback
    });
};


/*
* Search for facet values
* https://www.algolia.com/doc/rest-api/search#search-for-facet-values
*
* @param {string} params.facetName Facet name, name of the attribute to search for values in.
* Must be declared as a facet
* @param {string} params.facetQuery Query for the facet search
* @param {string} [params.*] Any search parameter of Algolia,
* see https://www.algolia.com/doc/api-client/javascript/search#search-parameters
* Pagination is not supported. The page and hitsPerPage parameters will be ignored.
* @param callback (optional)
*/ $9cc883490bc9625b$var$IndexCore.prototype.searchForFacetValues = function(params, callback) {
    var clone = (parcelRequire("eFOtW"));
    var omit = (parcelRequire("eTtOA"));
    var usage = 'Usage: index.searchForFacetValues({facetName, facetQuery, ...params}[, callback])';
    if (params.facetName === undefined || params.facetQuery === undefined) throw new Error(usage);
    var facetName = params.facetName;
    var filteredParams = omit(clone(params), function(keyName) {
        return keyName === 'facetName';
    });
    var searchParameters = this.as._getSearchParams(filteredParams, '');
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/' + encodeURIComponent(this.indexName) + '/facets/' + encodeURIComponent(facetName) + '/query',
        hostType: 'read',
        body: {
            params: searchParameters
        },
        callback: callback
    });
};
$9cc883490bc9625b$var$IndexCore.prototype.searchFacet = $5Zn4S(function(params, callback) {
    return this.searchForFacetValues(params, callback);
}, $gWPav('index.searchFacet(params[, callback])', 'index.searchForFacetValues(params[, callback])'));
$9cc883490bc9625b$var$IndexCore.prototype._search = function(params, url, callback, additionalUA) {
    return this.as._jsonRequest({
        cache: this.cache,
        method: 'POST',
        url: url || '/1/indexes/' + encodeURIComponent(this.indexName) + '/query',
        body: {
            params: params
        },
        hostType: 'read',
        fallback: {
            method: 'GET',
            url: '/1/indexes/' + encodeURIComponent(this.indexName),
            body: {
                params: params
            }
        },
        callback: callback,
        additionalUA: additionalUA
    });
};
/*
* Get an object from this index
*
* @param objectID the unique identifier of the object to retrieve
* @param attrs (optional) if set, contains the array of attribute names to retrieve
* @param callback (optional) the result callback called with two arguments
*  error: null or Error('message')
*  content: the object to retrieve or the error message if a failure occurred
*/ $9cc883490bc9625b$var$IndexCore.prototype.getObject = function(objectID, attrs, callback) {
    var indexObj = this;
    if (arguments.length === 1 || typeof attrs === 'function') {
        callback = attrs;
        attrs = undefined;
    }
    var params = '';
    if (attrs !== undefined) {
        params = '?attributes=';
        for(var i = 0; i < attrs.length; ++i){
            if (i !== 0) params += ',';
            params += attrs[i];
        }
    }
    return this.as._jsonRequest({
        method: 'GET',
        url: '/1/indexes/' + encodeURIComponent(indexObj.indexName) + '/' + encodeURIComponent(objectID) + params,
        hostType: 'read',
        callback: callback
    });
};


/*
* Get several objects from this index
*
* @param objectIDs the array of unique identifier of objects to retrieve
*/ $9cc883490bc9625b$var$IndexCore.prototype.getObjects = function(objectIDs, attributesToRetrieve, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var map = (parcelRequire("4B8vt"));
    var usage = 'Usage: index.getObjects(arrayOfObjectIDs[, callback])';
    if (!isArray(objectIDs)) throw new Error(usage);
    var indexObj = this;
    if (arguments.length === 1 || typeof attributesToRetrieve === 'function') {
        callback = attributesToRetrieve;
        attributesToRetrieve = undefined;
    }
    var body = {
        requests: map(objectIDs, function prepareRequest(objectID) {
            var request = {
                indexName: indexObj.indexName,
                objectID: objectID
            };
            if (attributesToRetrieve) request.attributesToRetrieve = attributesToRetrieve.join(',');
            return request;
        })
    };
    return this.as._jsonRequest({
        method: 'POST',
        url: '/1/indexes/*/objects',
        hostType: 'read',
        body: body,
        callback: callback
    });
};
$9cc883490bc9625b$var$IndexCore.prototype.as = null;
$9cc883490bc9625b$var$IndexCore.prototype.indexName = null;
$9cc883490bc9625b$var$IndexCore.prototype.typeAheadArgs = null;
$9cc883490bc9625b$var$IndexCore.prototype.typeAheadValueOption = null;

});
parcelRegister("lfQVS", function(module, exports) {
module.exports = $f7940efec25e04bb$var$buildSearchMethod;

var $bRG5U = parcelRequire("bRG5U");
/**
 * Creates a search method to be used in clients
 * @param {string} queryParam the name of the attribute used for the query
 * @param {string} url the url
 * @return {function} the search method
 */ function $f7940efec25e04bb$var$buildSearchMethod(queryParam, url) {
    /**
   * The search method. Prepares the data and send the query to Algolia.
   * @param {string} query the string used for query search
   * @param {object} args additional parameters to send with the search
   * @param {function} [callback] the callback to be called with the client gets the answer
   * @return {undefined|Promise} If the callback is not provided then this methods returns a Promise
   */ return function search(query, args, callback) {
        // warn V2 users on how to search
        if (typeof query === 'function' && typeof args === 'object' || typeof callback === 'object') // .search(query, params, cb)
        // .search(cb, params)
        throw new $bRG5U.AlgoliaSearchError('index.search usage is index.search(query, params, cb)');
        // Normalizing the function signature
        if (arguments.length === 0 || typeof query === 'function') {
            // Usage : .search(), .search(cb)
            callback = query;
            query = '';
        } else if (arguments.length === 1 || typeof args === 'function') {
            // Usage : .search(query/args), .search(query, cb)
            callback = args;
            args = undefined;
        }
        // At this point we have 3 arguments with values
        // Usage : .search(args) // careful: typeof null === 'object'
        if (typeof query === 'object' && query !== null) {
            args = query;
            query = undefined;
        } else if (query === undefined || query === null) query = '';
        var params = '';
        if (query !== undefined) params += queryParam + '=' + encodeURIComponent(query);
        var additionalUA;
        if (args !== undefined) {
            if (args.additionalUA) {
                additionalUA = args.additionalUA;
                delete args.additionalUA;
            }
            // `_getSearchParams` will augment params, do not be fooled by the = versus += from previous if
            params = this.as._getSearchParams(args, params);
        }
        return this._search(params, url, callback, additionalUA);
    };
}

});
parcelRegister("bRG5U", function(module, exports) {
'use strict';

var $lyUaN = parcelRequire("lyUaN");

function $8a354bfab069986d$var$AlgoliaSearchError(message, extraProperties) {
    var forEach = (parcelRequire("8wZP1"));
    var error = this;
    // try to get a stacktrace
    if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
    else error.stack = new Error().stack || 'Cannot get a stacktrace, browser is too old';
    this.name = 'AlgoliaSearchError';
    this.message = message || 'Unknown error';
    if (extraProperties) forEach(extraProperties, function addToErrorObject(value, key) {
        error[key] = value;
    });
}
$lyUaN($8a354bfab069986d$var$AlgoliaSearchError, Error);
function $8a354bfab069986d$var$createCustomError(name, message) {
    function AlgoliaSearchCustomError() {
        var args = Array.prototype.slice.call(arguments, 0);
        // custom message not set, use default
        if (typeof args[0] !== 'string') args.unshift(message);
        $8a354bfab069986d$var$AlgoliaSearchError.apply(this, args);
        this.name = 'AlgoliaSearch' + name + 'Error';
    }
    $lyUaN(AlgoliaSearchCustomError, $8a354bfab069986d$var$AlgoliaSearchError);
    return AlgoliaSearchCustomError;
}
// late exports to let various fn defs and inherits take place
module.exports = {
    AlgoliaSearchError: $8a354bfab069986d$var$AlgoliaSearchError,
    UnparsableJSON: $8a354bfab069986d$var$createCustomError('UnparsableJSON', 'Could not parse the incoming response as JSON, see err.more for details'),
    RequestTimeout: $8a354bfab069986d$var$createCustomError('RequestTimeout', 'Request timed out before getting a response'),
    Network: $8a354bfab069986d$var$createCustomError('Network', 'Network issue, see err.more for details'),
    JSONPScriptFail: $8a354bfab069986d$var$createCustomError('JSONPScriptFail', '<script> was loaded but did not call our provided callback'),
    ValidUntilNotFound: $8a354bfab069986d$var$createCustomError('ValidUntilNotFound', 'The SecuredAPIKey does not have a validUntil parameter.'),
    JSONPScriptError: $8a354bfab069986d$var$createCustomError('JSONPScriptError', '<script> unable to load due to an `error` event on it'),
    ObjectNotFound: $8a354bfab069986d$var$createCustomError('ObjectNotFound', 'Object not found'),
    Unknown: $8a354bfab069986d$var$createCustomError('Unknown', 'Unknown error occured')
};

});
parcelRegister("8wZP1", function(module, exports) {
var $63614473feb41dab$var$hasOwn = Object.prototype.hasOwnProperty;
var $63614473feb41dab$var$toString = Object.prototype.toString;
module.exports = function forEach(obj, fn, ctx) {
    if ($63614473feb41dab$var$toString.call(fn) !== '[object Function]') throw new TypeError('iterator must be a function');
    var l = obj.length;
    if (l === +l) for(var i = 0; i < l; i++)fn.call(ctx, obj[i], i, obj);
    else {
        for(var k in obj)if ($63614473feb41dab$var$hasOwn.call(obj, k)) fn.call(ctx, obj[k], k, obj);
    }
};

});



parcelRegister("5Zn4S", function(module, exports) {
module.exports = function deprecate(fn, message) {
    var warned = false;
    function deprecated() {
        if (!warned) {
            /* eslint no-console:0 */ console.warn(message);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
};

});

parcelRegister("gWPav", function(module, exports) {
module.exports = function deprecatedMessage(previousUsage, newUsage) {
    var githubAnchorLink = previousUsage.toLowerCase().replace(/[\.\(\)]/g, '');
    return 'algoliasearch: `' + previousUsage + '` was replaced by `' + newUsage + '`. Please see https://github.com/algolia/algoliasearch-client-javascript/wiki/Deprecated#' + githubAnchorLink;
};

});

parcelRegister("e1p6j", function(module, exports) {

var $8wZP1 = parcelRequire("8wZP1");
module.exports = function merge(destination /* , sources */ ) {
    var sources = Array.prototype.slice.call(arguments);
    $8wZP1(sources, function(source) {
        for(var keyName in source)if (source.hasOwnProperty(keyName)) {
            if (typeof destination[keyName] === 'object' && typeof source[keyName] === 'object') destination[keyName] = merge({}, destination[keyName], source[keyName]);
            else if (source[keyName] !== undefined) destination[keyName] = source[keyName];
        }
    });
    return destination;
};

});

parcelRegister("eFOtW", function(module, exports) {
module.exports = function clone(obj) {
    return JSON.parse(JSON.stringify(obj));
};

});

parcelRegister("eTtOA", function(module, exports) {


module.exports = function omit(obj, test) {
    var keys = (parcelRequire("4jDQV"));
    var foreach = (parcelRequire("8wZP1"));
    var filtered = {};
    foreach(keys(obj), function doFilter(keyName) {
        if (test(keyName) !== true) filtered[keyName] = obj[keyName];
    });
    return filtered;
};

});
parcelRegister("4jDQV", function(module, exports) {
'use strict';
var $3247d9b061104208$var$slice = Array.prototype.slice;

var $96nTn = parcelRequire("96nTn");
var $3247d9b061104208$var$origKeys = Object.keys;

var $3247d9b061104208$var$keysShim = $3247d9b061104208$var$origKeys ? function keys(o) {
    return $3247d9b061104208$var$origKeys(o);
} : (parcelRequire("a7WlO"));
var $3247d9b061104208$var$originalKeys = Object.keys;
$3247d9b061104208$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($96nTn(object)) return $3247d9b061104208$var$originalKeys($3247d9b061104208$var$slice.call(object));
            return $3247d9b061104208$var$originalKeys(object);
        };
    } else Object.keys = $3247d9b061104208$var$keysShim;
    return Object.keys || $3247d9b061104208$var$keysShim;
};
module.exports = $3247d9b061104208$var$keysShim;

});
parcelRegister("96nTn", function(module, exports) {
'use strict';
var $6a0735185fec05e3$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $6a0735185fec05e3$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $6a0735185fec05e3$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("a7WlO", function(module, exports) {
'use strict';
var $75f7d21b7a735a78$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $75f7d21b7a735a78$var$has = Object.prototype.hasOwnProperty;
    var $75f7d21b7a735a78$var$toStr = Object.prototype.toString;
    var $75f7d21b7a735a78$var$isArgs = (parcelRequire("96nTn")); // eslint-disable-line global-require
    var $75f7d21b7a735a78$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $75f7d21b7a735a78$var$hasDontEnumBug = !$75f7d21b7a735a78$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $75f7d21b7a735a78$var$hasProtoEnumBug = $75f7d21b7a735a78$var$isEnumerable.call(function() {}, 'prototype');
    var $75f7d21b7a735a78$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $75f7d21b7a735a78$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $75f7d21b7a735a78$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $75f7d21b7a735a78$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$75f7d21b7a735a78$var$excludedKeys['$' + k] && $75f7d21b7a735a78$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $75f7d21b7a735a78$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $75f7d21b7a735a78$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$75f7d21b7a735a78$var$hasAutomationEqualityBug) return $75f7d21b7a735a78$var$equalsConstructorPrototype(o);
        try {
            return $75f7d21b7a735a78$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $75f7d21b7a735a78$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $75f7d21b7a735a78$var$toStr.call(object) === '[object Function]';
        var isArguments = $75f7d21b7a735a78$var$isArgs(object);
        var isString = isObject && $75f7d21b7a735a78$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $75f7d21b7a735a78$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$75f7d21b7a735a78$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $75f7d21b7a735a78$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($75f7d21b7a735a78$var$hasDontEnumBug) {
            var skipConstructor = $75f7d21b7a735a78$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $75f7d21b7a735a78$var$dontEnums.length; ++k)if (!(skipConstructor && $75f7d21b7a735a78$var$dontEnums[k] === 'constructor') && $75f7d21b7a735a78$var$has.call(object, $75f7d21b7a735a78$var$dontEnums[k])) theKeys.push($75f7d21b7a735a78$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $75f7d21b7a735a78$var$keysShim;

});



parcelRegister("HZ0dR", function(module, exports) {
var $0843561c5784f7ef$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $0843561c5784f7ef$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("4B8vt", function(module, exports) {

var $8wZP1 = parcelRequire("8wZP1");
module.exports = function map(arr, fn) {
    var newArr = [];
    $8wZP1(arr, function(item, itemIndex) {
        newArr.push(fn(item, itemIndex, arr));
    });
    return newArr;
};

});


parcelRegister("hb1rf", function(module, exports) {
// Parse cloud does not supports setTimeout
// We do not store a setTimeout reference in the client everytime
// We only fallback to a fake setTimeout when not available
// setTimeout cannot be override globally sadly
module.exports = function exitPromise(fn, _setTimeout) {
    _setTimeout(fn, 0);
};

});

parcelRegister("eSgQh", function(module, exports) {
'use strict';
// This is the object returned by the `index.browseAll()` method
module.exports = $ad432c584df945d4$var$IndexBrowser;

var $lyUaN = parcelRequire("lyUaN");

var $3yIb1 = parcelRequire("3yIb1");
var $ad432c584df945d4$require$EventEmitter = $3yIb1.EventEmitter;
function $ad432c584df945d4$var$IndexBrowser() {}
$lyUaN($ad432c584df945d4$var$IndexBrowser, $ad432c584df945d4$require$EventEmitter);
$ad432c584df945d4$var$IndexBrowser.prototype.stop = function() {
    this._stopped = true;
    this._clean();
};
$ad432c584df945d4$var$IndexBrowser.prototype._end = function() {
    this.emit('end');
    this._clean();
};
$ad432c584df945d4$var$IndexBrowser.prototype._error = function(err) {
    this.emit('error', err);
    this._clean();
};
$ad432c584df945d4$var$IndexBrowser.prototype._result = function(content) {
    this.emit('result', content);
};
$ad432c584df945d4$var$IndexBrowser.prototype._clean = function() {
    this.removeAllListeners('stop');
    this.removeAllListeners('end');
    this.removeAllListeners('error');
    this.removeAllListeners('result');
};

});
parcelRegister("3yIb1", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
function $2976d0a902c30135$var$EventEmitter() {
    this._events = this._events || {};
    this._maxListeners = this._maxListeners || undefined;
}
module.exports = $2976d0a902c30135$var$EventEmitter;
// Backwards-compat with node 0.10.x
$2976d0a902c30135$var$EventEmitter.EventEmitter = $2976d0a902c30135$var$EventEmitter;
$2976d0a902c30135$var$EventEmitter.prototype._events = undefined;
$2976d0a902c30135$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$2976d0a902c30135$var$EventEmitter.defaultMaxListeners = 10;
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$2976d0a902c30135$var$EventEmitter.prototype.setMaxListeners = function(n) {
    if (!$2976d0a902c30135$var$isNumber(n) || n < 0 || isNaN(n)) throw TypeError('n must be a positive number');
    this._maxListeners = n;
    return this;
};
$2976d0a902c30135$var$EventEmitter.prototype.emit = function(type) {
    var er, handler, len, args, i, listeners;
    if (!this._events) this._events = {};
    // If there is no 'error' event listener then throw.
    if (type === 'error') {
        if (!this._events.error || $2976d0a902c30135$var$isObject(this._events.error) && !this._events.error.length) {
            er = arguments[1];
            if (er instanceof Error) throw er; // Unhandled 'error' event
            else {
                // At least give some kind of context to the user
                var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
                err.context = er;
                throw err;
            }
        }
    }
    handler = this._events[type];
    if ($2976d0a902c30135$var$isUndefined(handler)) return false;
    if ($2976d0a902c30135$var$isFunction(handler)) switch(arguments.length){
        // fast cases
        case 1:
            handler.call(this);
            break;
        case 2:
            handler.call(this, arguments[1]);
            break;
        case 3:
            handler.call(this, arguments[1], arguments[2]);
            break;
        // slower
        default:
            args = Array.prototype.slice.call(arguments, 1);
            handler.apply(this, args);
    }
    else if ($2976d0a902c30135$var$isObject(handler)) {
        args = Array.prototype.slice.call(arguments, 1);
        listeners = handler.slice();
        len = listeners.length;
        for(i = 0; i < len; i++)listeners[i].apply(this, args);
    }
    return true;
};
$2976d0a902c30135$var$EventEmitter.prototype.addListener = function(type, listener) {
    var m;
    if (!$2976d0a902c30135$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events) this._events = {};
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (this._events.newListener) this.emit('newListener', type, $2976d0a902c30135$var$isFunction(listener.listener) ? listener.listener : listener);
    if (!this._events[type]) // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
    else if ($2976d0a902c30135$var$isObject(this._events[type])) // If we've already got an array, just append.
    this._events[type].push(listener);
    else // Adding the second element, need to change to array.
    this._events[type] = [
        this._events[type],
        listener
    ];
    // Check for listener leak
    if ($2976d0a902c30135$var$isObject(this._events[type]) && !this._events[type].warned) {
        if (!$2976d0a902c30135$var$isUndefined(this._maxListeners)) m = this._maxListeners;
        else m = $2976d0a902c30135$var$EventEmitter.defaultMaxListeners;
        if (m && m > 0 && this._events[type].length > m) {
            this._events[type].warned = true;
            console.error("(node) warning: possible EventEmitter memory leak detected. %d listeners added. Use emitter.setMaxListeners() to increase limit.", this._events[type].length);
            if (typeof console.trace === 'function') // not supported in IE 10
            console.trace();
        }
    }
    return this;
};
$2976d0a902c30135$var$EventEmitter.prototype.on = $2976d0a902c30135$var$EventEmitter.prototype.addListener;
$2976d0a902c30135$var$EventEmitter.prototype.once = function(type, listener) {
    if (!$2976d0a902c30135$var$isFunction(listener)) throw TypeError('listener must be a function');
    var fired = false;
    function g() {
        this.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(this, arguments);
        }
    }
    g.listener = listener;
    this.on(type, g);
    return this;
};
// emits a 'removeListener' event iff the listener was removed
$2976d0a902c30135$var$EventEmitter.prototype.removeListener = function(type, listener) {
    var list, position, length, i;
    if (!$2976d0a902c30135$var$isFunction(listener)) throw TypeError('listener must be a function');
    if (!this._events || !this._events[type]) return this;
    list = this._events[type];
    length = list.length;
    position = -1;
    if (list === listener || $2976d0a902c30135$var$isFunction(list.listener) && list.listener === listener) {
        delete this._events[type];
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    } else if ($2976d0a902c30135$var$isObject(list)) {
        for(i = length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list.length = 0;
            delete this._events[type];
        } else list.splice(position, 1);
        if (this._events.removeListener) this.emit('removeListener', type, listener);
    }
    return this;
};
$2976d0a902c30135$var$EventEmitter.prototype.removeAllListeners = function(type) {
    var key, listeners;
    if (!this._events) return this;
    // not listening for removeListener, no need to emit
    if (!this._events.removeListener) {
        if (arguments.length === 0) this._events = {};
        else if (this._events[type]) delete this._events[type];
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        for(key in this._events){
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = {};
        return this;
    }
    listeners = this._events[type];
    if ($2976d0a902c30135$var$isFunction(listeners)) this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    while(listeners.length)this.removeListener(type, listeners[listeners.length - 1]);
    delete this._events[type];
    return this;
};
$2976d0a902c30135$var$EventEmitter.prototype.listeners = function(type) {
    var ret;
    if (!this._events || !this._events[type]) ret = [];
    else if ($2976d0a902c30135$var$isFunction(this._events[type])) ret = [
        this._events[type]
    ];
    else ret = this._events[type].slice();
    return ret;
};
$2976d0a902c30135$var$EventEmitter.prototype.listenerCount = function(type) {
    if (this._events) {
        var evlistener = this._events[type];
        if ($2976d0a902c30135$var$isFunction(evlistener)) return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
};
$2976d0a902c30135$var$EventEmitter.listenerCount = function(emitter, type) {
    return emitter.listenerCount(type);
};
function $2976d0a902c30135$var$isFunction(arg) {
    return typeof arg === 'function';
}
function $2976d0a902c30135$var$isNumber(arg) {
    return typeof arg === 'number';
}
function $2976d0a902c30135$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function $2976d0a902c30135$var$isUndefined(arg) {
    return arg === void 0;
}

});



parcelRegister("eQwxt", function(module, exports) {
module.exports = $acef29916697dd9e$var$AlgoliaSearchCore;

var $bRG5U = parcelRequire("bRG5U");

var $hb1rf = parcelRequire("hb1rf");

var $dsyjX = parcelRequire("dsyjX");

var $72Pfb = parcelRequire("72Pfb");
// We will always put the API KEY in the JSON body in case of too long API KEY,
// to avoid query string being too long and failing in various conditions (our server limit, browser limit,
// proxies limit)
var $acef29916697dd9e$var$MAX_API_KEY_LENGTH = 500;
var $acef29916697dd9e$var$RESET_APP_DATA_TIMER = 120000; // after 2 minutes reset to first host




/*
 * Algolia Search library initialization
 * https://www.algolia.com/
 *
 * @param {string} applicationID - Your applicationID, found in your dashboard
 * @param {string} apiKey - Your API key, found in your dashboard
 * @param {Object} [opts]
 * @param {number} [opts.timeout=2000] - The request timeout set in milliseconds,
 * another request will be issued after this timeout
 * @param {string} [opts.protocol='https:'] - The protocol used to query Algolia Search API.
 *                                        Set to 'http:' to force using http.
 * @param {Object|Array} [opts.hosts={
 *           read: [this.applicationID + '-dsn.algolia.net'].concat([
 *             this.applicationID + '-1.algolianet.com',
 *             this.applicationID + '-2.algolianet.com',
 *             this.applicationID + '-3.algolianet.com']
 *           ]),
 *           write: [this.applicationID + '.algolia.net'].concat([
 *             this.applicationID + '-1.algolianet.com',
 *             this.applicationID + '-2.algolianet.com',
 *             this.applicationID + '-3.algolianet.com']
 *           ]) - The hosts to use for Algolia Search API.
 *           If you provide them, you will less benefit from our HA implementation
 */ function $acef29916697dd9e$var$AlgoliaSearchCore(applicationID, apiKey, opts) {
    var debug = (parcelRequire("5KxQY"))('algoliasearch');
    var clone = (parcelRequire("eFOtW"));
    var isArray = (parcelRequire("HZ0dR"));
    var map = (parcelRequire("4B8vt"));
    var usage = 'Usage: algoliasearch(applicationID, apiKey, opts)';
    if (opts._allowEmptyCredentials !== true && !applicationID) throw new $bRG5U.AlgoliaSearchError('Please provide an application ID. ' + usage);
    if (opts._allowEmptyCredentials !== true && !apiKey) throw new $bRG5U.AlgoliaSearchError('Please provide an API key. ' + usage);
    this.applicationID = applicationID;
    this.apiKey = apiKey;
    this.hosts = {
        read: [],
        write: []
    };
    opts = opts || {};
    this._timeouts = opts.timeouts || {
        connect: 1000,
        read: 2000,
        write: 30000
    };
    // backward compat, if opts.timeout is passed, we use it to configure all timeouts like before
    if (opts.timeout) this._timeouts.connect = this._timeouts.read = this._timeouts.write = opts.timeout;
    var protocol = opts.protocol || 'https:';
    // while we advocate for colon-at-the-end values: 'http:' for `opts.protocol`
    // we also accept `http` and `https`. It's a common error.
    if (!/:$/.test(protocol)) protocol = protocol + ':';
    if (protocol !== 'http:' && protocol !== 'https:') throw new $bRG5U.AlgoliaSearchError('protocol must be `http:` or `https:` (was `' + opts.protocol + '`)');
    this._checkAppIdData();
    if (!opts.hosts) {
        var defaultHosts = map(this._shuffleResult, function(hostNumber) {
            return applicationID + '-' + hostNumber + '.algolianet.com';
        });
        // no hosts given, compute defaults
        var mainSuffix = (opts.dsn === false ? '' : '-dsn') + '.algolia.net';
        this.hosts.read = [
            this.applicationID + mainSuffix
        ].concat(defaultHosts);
        this.hosts.write = [
            this.applicationID + '.algolia.net'
        ].concat(defaultHosts);
    } else if (isArray(opts.hosts)) {
        // when passing custom hosts, we need to have a different host index if the number
        // of write/read hosts are different.
        this.hosts.read = clone(opts.hosts);
        this.hosts.write = clone(opts.hosts);
    } else {
        this.hosts.read = clone(opts.hosts.read);
        this.hosts.write = clone(opts.hosts.write);
    }
    // add protocol and lowercase hosts
    this.hosts.read = map(this.hosts.read, $acef29916697dd9e$var$prepareHost(protocol));
    this.hosts.write = map(this.hosts.write, $acef29916697dd9e$var$prepareHost(protocol));
    this.extraHeaders = {};
    // In some situations you might want to warm the cache
    this.cache = opts._cache || {};
    this._ua = opts._ua;
    this._useCache = opts._useCache === undefined || opts._cache ? true : opts._useCache;
    this._useRequestCache = this._useCache && opts._useRequestCache;
    this._useFallback = opts.useFallback === undefined ? true : opts.useFallback;
    this._setTimeout = opts._setTimeout;
    debug('init done, %j', this);
}
/*
 * Get the index object initialized
 *
 * @param indexName the name of index
 * @param callback the result callback with one argument (the Index instance)
 */ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.initIndex = function(indexName) {
    return new $dsyjX(this, indexName);
};
/**
* Add an extra field to the HTTP request
*
* @param name the header field name
* @param value the header field value
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.setExtraHeader = function(name, value) {
    this.extraHeaders[name.toLowerCase()] = value;
};
/**
* Get the value of an extra HTTP header
*
* @param name the header field name
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.getExtraHeader = function(name) {
    return this.extraHeaders[name.toLowerCase()];
};
/**
* Remove an extra field from the HTTP request
*
* @param name the header field name
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.unsetExtraHeader = function(name) {
    delete this.extraHeaders[name.toLowerCase()];
};
/**
* Augment sent x-algolia-agent with more data, each agent part
* is automatically separated from the others by a semicolon;
*
* @param algoliaAgent the agent to add
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.addAlgoliaAgent = function(algoliaAgent) {
    var algoliaAgentWithDelimiter = '; ' + algoliaAgent;
    if (this._ua.indexOf(algoliaAgentWithDelimiter) === -1) this._ua += algoliaAgentWithDelimiter;
};

/*
 * Wrapper that try all hosts to maximize the quality of service
 */ $acef29916697dd9e$var$AlgoliaSearchCore.prototype._jsonRequest = function(initialOpts) {
    this._checkAppIdData();
    var requestDebug = (parcelRequire("5KxQY"))('algoliasearch:' + initialOpts.url);
    var body;
    var cacheID;
    var additionalUA = initialOpts.additionalUA || '';
    var cache = initialOpts.cache;
    var client = this;
    var tries = 0;
    var usingFallback = false;
    var hasFallback = client._useFallback && client._request.fallback && initialOpts.fallback;
    var headers;
    if (this.apiKey.length > $acef29916697dd9e$var$MAX_API_KEY_LENGTH && initialOpts.body !== undefined && (initialOpts.body.params !== undefined || // index.search()
    initialOpts.body.requests !== undefined // client.search()
    )) {
        initialOpts.body.apiKey = this.apiKey;
        headers = this._computeRequestHeaders({
            additionalUA: additionalUA,
            withApiKey: false,
            headers: initialOpts.headers
        });
    } else headers = this._computeRequestHeaders({
        additionalUA: additionalUA,
        headers: initialOpts.headers
    });
    if (initialOpts.body !== undefined) body = $acef29916697dd9e$var$safeJSONStringify(initialOpts.body);
    requestDebug('request start');
    var debugData = [];
    function doRequest(requester, reqOpts) {
        client._checkAppIdData();
        var startTime = new Date();
        if (client._useCache && !client._useRequestCache) cacheID = initialOpts.url;
        // as we sometime use POST requests to pass parameters (like query='aa'),
        // the cacheID must also include the body to be different between calls
        if (client._useCache && !client._useRequestCache && body) cacheID += '_body_' + reqOpts.body;
        // handle cache existence
        if (isCacheValidWithCurrentID(!client._useRequestCache, cache, cacheID)) {
            requestDebug('serving response from cache');
            var responseText = cache[cacheID];
            // Cache response must match the type of the original one
            return client._promise.resolve({
                body: JSON.parse(responseText),
                responseText: responseText
            });
        }
        // if we reached max tries
        if (tries >= client.hosts[initialOpts.hostType].length) {
            if (!hasFallback || usingFallback) {
                requestDebug('could not get any response');
                // then stop
                return client._promise.reject(new $bRG5U.AlgoliaSearchError("Cannot connect to the AlgoliaSearch API. Send an email to support@algolia.com to report and resolve the issue. Application id was: " + client.applicationID, {
                    debugData: debugData
                }));
            }
            requestDebug('switching to fallback');
            // let's try the fallback starting from here
            tries = 0;
            // method, url and body are fallback dependent
            reqOpts.method = initialOpts.fallback.method;
            reqOpts.url = initialOpts.fallback.url;
            reqOpts.jsonBody = initialOpts.fallback.body;
            if (reqOpts.jsonBody) reqOpts.body = $acef29916697dd9e$var$safeJSONStringify(reqOpts.jsonBody);
            // re-compute headers, they could be omitting the API KEY
            headers = client._computeRequestHeaders({
                additionalUA: additionalUA,
                headers: initialOpts.headers
            });
            reqOpts.timeouts = client._getTimeoutsForRequest(initialOpts.hostType);
            client._setHostIndexByType(0, initialOpts.hostType);
            usingFallback = true; // the current request is now using fallback
            return doRequest(client._request.fallback, reqOpts);
        }
        var currentHost = client._getHostByType(initialOpts.hostType);
        var url = currentHost + reqOpts.url;
        var options = {
            body: reqOpts.body,
            jsonBody: reqOpts.jsonBody,
            method: reqOpts.method,
            headers: headers,
            timeouts: reqOpts.timeouts,
            debug: requestDebug,
            forceAuthHeaders: reqOpts.forceAuthHeaders
        };
        requestDebug('method: %s, url: %s, headers: %j, timeouts: %d', options.method, url, options.headers, options.timeouts);
        if (requester === client._request.fallback) requestDebug('using fallback');
        // `requester` is any of this._request or this._request.fallback
        // thus it needs to be called using the client as context
        return requester.call(client, url, options).then(success, tryFallback);
        function success(httpResponse) {
            // compute the status of the response,
            //
            // When in browser mode, using XDR or JSONP, we have no statusCode available
            // So we rely on our API response `status` property.
            // But `waitTask` can set a `status` property which is not the statusCode (it's the task status)
            // So we check if there's a `message` along `status` and it means it's an error
            //
            // That's the only case where we have a response.status that's not the http statusCode
            var status = httpResponse && httpResponse.body && httpResponse.body.message && httpResponse.body.status || // this is important to check the request statusCode AFTER the body eventual
            // statusCode because some implementations (jQuery XDomainRequest transport) may
            // send statusCode 200 while we had an error
            httpResponse.statusCode || // When in browser mode, using XDR or JSONP
            // we default to success when no error (no response.status && response.message)
            // If there was a JSON.parse() error then body is null and it fails
            httpResponse && httpResponse.body && 200;
            requestDebug('received response: statusCode: %s, computed statusCode: %d, headers: %j', httpResponse.statusCode, status, httpResponse.headers);
            var httpResponseOk = Math.floor(status / 100) === 2;
            var endTime = new Date();
            debugData.push({
                currentHost: currentHost,
                headers: $acef29916697dd9e$var$removeCredentials(headers),
                content: body || null,
                contentLength: body !== undefined ? body.length : null,
                method: reqOpts.method,
                timeouts: reqOpts.timeouts,
                url: reqOpts.url,
                startTime: startTime,
                endTime: endTime,
                duration: endTime - startTime,
                statusCode: status
            });
            if (httpResponseOk) {
                if (client._useCache && !client._useRequestCache && cache) cache[cacheID] = httpResponse.responseText;
                return {
                    responseText: httpResponse.responseText,
                    body: httpResponse.body
                };
            }
            var shouldRetry = Math.floor(status / 100) !== 4;
            if (shouldRetry) {
                tries += 1;
                return retryRequest();
            }
            requestDebug('unrecoverable error');
            // no success and no retry => fail
            var unrecoverableError = new $bRG5U.AlgoliaSearchError(httpResponse.body && httpResponse.body.message, {
                debugData: debugData,
                statusCode: status
            });
            return client._promise.reject(unrecoverableError);
        }
        function tryFallback(err) {
            // error cases:
            //  While not in fallback mode:
            //    - CORS not supported
            //    - network error
            //  While in fallback mode:
            //    - timeout
            //    - network error
            //    - badly formatted JSONP (script loaded, did not call our callback)
            //  In both cases:
            //    - uncaught exception occurs (TypeError)
            requestDebug('error: %s, stack: %s', err.message, err.stack);
            var endTime = new Date();
            debugData.push({
                currentHost: currentHost,
                headers: $acef29916697dd9e$var$removeCredentials(headers),
                content: body || null,
                contentLength: body !== undefined ? body.length : null,
                method: reqOpts.method,
                timeouts: reqOpts.timeouts,
                url: reqOpts.url,
                startTime: startTime,
                endTime: endTime,
                duration: endTime - startTime
            });
            if (!(err instanceof $bRG5U.AlgoliaSearchError)) err = new $bRG5U.Unknown(err && err.message, err);
            tries += 1;
            // stop the request implementation when:
            if (// we did not generate this error,
            // it comes from a throw in some other piece of code
            err instanceof $bRG5U.Unknown || // server sent unparsable JSON
            err instanceof $bRG5U.UnparsableJSON || // max tries and already using fallback or no fallback
            tries >= client.hosts[initialOpts.hostType].length && (usingFallback || !hasFallback)) {
                // stop request implementation for this command
                err.debugData = debugData;
                return client._promise.reject(err);
            }
            // When a timeout occurred, retry by raising timeout
            if (err instanceof $bRG5U.RequestTimeout) return retryRequestWithHigherTimeout();
            return retryRequest();
        }
        function retryRequest() {
            requestDebug('retrying request');
            client._incrementHostIndex(initialOpts.hostType);
            return doRequest(requester, reqOpts);
        }
        function retryRequestWithHigherTimeout() {
            requestDebug('retrying request with higher timeout');
            client._incrementHostIndex(initialOpts.hostType);
            client._incrementTimeoutMultipler();
            reqOpts.timeouts = client._getTimeoutsForRequest(initialOpts.hostType);
            return doRequest(requester, reqOpts);
        }
    }
    function isCacheValidWithCurrentID(useRequestCache, currentCache, currentCacheID) {
        return client._useCache && useRequestCache && currentCache && currentCache[currentCacheID] !== undefined;
    }
    function interopCallbackReturn(request, callback) {
        if (isCacheValidWithCurrentID(client._useRequestCache, cache, cacheID)) request.catch(function() {
            // Release the cache on error
            delete cache[cacheID];
        });
        if (typeof initialOpts.callback === 'function') // either we have a callback
        request.then(function okCb(content) {
            $hb1rf(function() {
                initialOpts.callback(null, callback(content));
            }, client._setTimeout || setTimeout);
        }, function nookCb(err) {
            $hb1rf(function() {
                initialOpts.callback(err);
            }, client._setTimeout || setTimeout);
        });
        else // either we are using promises
        return request.then(callback);
    }
    if (client._useCache && client._useRequestCache) cacheID = initialOpts.url;
    // as we sometime use POST requests to pass parameters (like query='aa'),
    // the cacheID must also include the body to be different between calls
    if (client._useCache && client._useRequestCache && body) cacheID += '_body_' + body;
    if (isCacheValidWithCurrentID(client._useRequestCache, cache, cacheID)) {
        requestDebug('serving request from cache');
        var maybePromiseForCache = cache[cacheID];
        // In case the cache is warmup with value that is not a promise
        var promiseForCache = typeof maybePromiseForCache.then !== 'function' ? client._promise.resolve({
            responseText: maybePromiseForCache
        }) : maybePromiseForCache;
        return interopCallbackReturn(promiseForCache, function(content) {
            // In case of the cache request, return the original value
            return JSON.parse(content.responseText);
        });
    }
    var request = doRequest(client._request, {
        url: initialOpts.url,
        method: initialOpts.method,
        body: body,
        jsonBody: initialOpts.body,
        timeouts: client._getTimeoutsForRequest(initialOpts.hostType),
        forceAuthHeaders: initialOpts.forceAuthHeaders
    });
    if (client._useCache && client._useRequestCache && cache) cache[cacheID] = request;
    return interopCallbackReturn(request, function(content) {
        // In case of the first request, return the JSON value
        return content.body;
    });
};
/*
* Transform search param object in query string
* @param {object} args arguments to add to the current query string
* @param {string} params current query string
* @return {string} the final query string
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype._getSearchParams = function(args, params) {
    if (args === undefined || args === null) return params;
    for(var key in args)if (key !== null && args[key] !== undefined && args.hasOwnProperty(key)) {
        params += params === '' ? '' : '&';
        params += key + '=' + encodeURIComponent(Object.prototype.toString.call(args[key]) === '[object Array]' ? $acef29916697dd9e$var$safeJSONStringify(args[key]) : args[key]);
    }
    return params;
};

/**
 * Compute the headers for a request
 *
 * @param [string] options.additionalUA semi-colon separated string with other user agents to add
 * @param [boolean=true] options.withApiKey Send the api key as a header
 * @param [Object] options.headers Extra headers to send
 */ $acef29916697dd9e$var$AlgoliaSearchCore.prototype._computeRequestHeaders = function(options) {
    var forEach = (parcelRequire("8wZP1"));
    var ua = options.additionalUA ? this._ua + '; ' + options.additionalUA : this._ua;
    var requestHeaders = {
        'x-algolia-agent': ua,
        'x-algolia-application-id': this.applicationID
    };
    // browser will inline headers in the url, node.js will use http headers
    // but in some situations, the API KEY will be too long (big secured API keys)
    // so if the request is a POST and the KEY is very long, we will be asked to not put
    // it into headers but in the JSON body
    if (options.withApiKey !== false) requestHeaders['x-algolia-api-key'] = this.apiKey;
    if (this.userToken) requestHeaders['x-algolia-usertoken'] = this.userToken;
    if (this.securityTags) requestHeaders['x-algolia-tagfilters'] = this.securityTags;
    forEach(this.extraHeaders, function addToRequestHeaders(value, key) {
        requestHeaders[key] = value;
    });
    if (options.headers) forEach(options.headers, function addToRequestHeaders(value, key) {
        requestHeaders[key] = value;
    });
    return requestHeaders;
};


/**
 * Search through multiple indices at the same time
 * @param  {Object[]}   queries  An array of queries you want to run.
 * @param {string} queries[].indexName The index name you want to target
 * @param {string} [queries[].query] The query to issue on this index. Can also be passed into `params`
 * @param {Object} queries[].params Any search param like hitsPerPage, ..
 * @param  {Function} callback Callback to be called
 * @return {Promise|undefined} Returns a promise if no callback given
 */ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.search = function(queries, opts, callback) {
    var isArray = (parcelRequire("HZ0dR"));
    var map = (parcelRequire("4B8vt"));
    var usage = 'Usage: client.search(arrayOfQueries[, callback])';
    if (!isArray(queries)) throw new Error(usage);
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    } else if (opts === undefined) opts = {};
    var client = this;
    var postObj = {
        requests: map(queries, function prepareRequest(query) {
            var params = '';
            // allow query.query
            // so we are mimicing the index.search(query, params) method
            // {indexName:, query:, params:}
            if (query.query !== undefined) params += 'query=' + encodeURIComponent(query.query);
            return {
                indexName: query.indexName,
                params: client._getSearchParams(query.params, params)
            };
        })
    };
    var JSONPParams = map(postObj.requests, function prepareJSONPParams(request, requestId) {
        return requestId + '=' + encodeURIComponent('/1/indexes/' + encodeURIComponent(request.indexName) + '?' + request.params);
    }).join('&');
    var url = '/1/indexes/*/queries';
    if (opts.strategy !== undefined) postObj.strategy = opts.strategy;
    return this._jsonRequest({
        cache: this.cache,
        method: 'POST',
        url: url,
        body: postObj,
        hostType: 'read',
        fallback: {
            method: 'GET',
            url: '/1/indexes/*',
            body: {
                params: JSONPParams
            }
        },
        callback: callback
    });
};




/**
* Search for facet values
* https://www.algolia.com/doc/rest-api/search#search-for-facet-values
* This is the top-level API for SFFV.
*
* @param {object[]} queries An array of queries to run.
* @param {string} queries[].indexName Index name, name of the index to search.
* @param {object} queries[].params Query parameters.
* @param {string} queries[].params.facetName Facet name, name of the attribute to search for values in.
* Must be declared as a facet
* @param {string} queries[].params.facetQuery Query for the facet search
* @param {string} [queries[].params.*] Any search parameter of Algolia,
* see https://www.algolia.com/doc/api-client/javascript/search#search-parameters
* Pagination is not supported. The page and hitsPerPage parameters will be ignored.
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.searchForFacetValues = function(queries) {
    var isArray = (parcelRequire("HZ0dR"));
    var map = (parcelRequire("4B8vt"));
    var usage = 'Usage: client.searchForFacetValues([{indexName, params: {facetName, facetQuery, ...params}}, ...queries])'; // eslint-disable-line max-len
    if (!isArray(queries)) throw new Error(usage);
    var client = this;
    return client._promise.all(map(queries, function performQuery(query) {
        if (!query || query.indexName === undefined || query.params.facetName === undefined || query.params.facetQuery === undefined) throw new Error(usage);
        var clone = (parcelRequire("eFOtW"));
        var omit = (parcelRequire("eTtOA"));
        var indexName = query.indexName;
        var params = query.params;
        var facetName = params.facetName;
        var filteredParams = omit(clone(params), function(keyName) {
            return keyName === 'facetName';
        });
        var searchParameters = client._getSearchParams(filteredParams, '');
        return client._jsonRequest({
            cache: client.cache,
            method: 'POST',
            url: '/1/indexes/' + encodeURIComponent(indexName) + '/facets/' + encodeURIComponent(facetName) + '/query',
            hostType: 'read',
            body: {
                params: searchParameters
            }
        });
    }));
};
/**
 * Set the extra security tagFilters header
 * @param {string|array} tags The list of tags defining the current security filters
 */ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.setSecurityTags = function(tags) {
    if (Object.prototype.toString.call(tags) === '[object Array]') {
        var strTags = [];
        for(var i = 0; i < tags.length; ++i)if (Object.prototype.toString.call(tags[i]) === '[object Array]') {
            var oredTags = [];
            for(var j = 0; j < tags[i].length; ++j)oredTags.push(tags[i][j]);
            strTags.push('(' + oredTags.join(',') + ')');
        } else strTags.push(tags[i]);
        tags = strTags.join(',');
    }
    this.securityTags = tags;
};
/**
 * Set the extra user token header
 * @param {string} userToken The token identifying a uniq user (used to apply rate limits)
 */ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.setUserToken = function(userToken) {
    this.userToken = userToken;
};
/**
 * Clear all queries in client's cache
 * @return undefined
 */ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.clearCache = function() {
    this.cache = {};
};
/**
* Set the number of milliseconds a request can take before automatically being terminated.
* @deprecated
* @param {Number} milliseconds
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.setRequestTimeout = function(milliseconds) {
    if (milliseconds) this._timeouts.connect = this._timeouts.read = this._timeouts.write = milliseconds;
};
/**
* Set the three different (connect, read, write) timeouts to be used when requesting
* @param {Object} timeouts
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.setTimeouts = function(timeouts) {
    this._timeouts = timeouts;
};
/**
* Get the three different (connect, read, write) timeouts to be used when requesting
* @param {Object} timeouts
*/ $acef29916697dd9e$var$AlgoliaSearchCore.prototype.getTimeouts = function() {
    return this._timeouts;
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._getAppIdData = function() {
    var data = $72Pfb.get(this.applicationID);
    if (data !== null) this._cacheAppIdData(data);
    return data;
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._setAppIdData = function(data) {
    data.lastChange = new Date().getTime();
    this._cacheAppIdData(data);
    return $72Pfb.set(this.applicationID, data);
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._checkAppIdData = function() {
    var data = this._getAppIdData();
    var now = new Date().getTime();
    if (data === null || now - data.lastChange > $acef29916697dd9e$var$RESET_APP_DATA_TIMER) return this._resetInitialAppIdData(data);
    return data;
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._resetInitialAppIdData = function(data) {
    var newData = data || {};
    newData.hostIndexes = {
        read: 0,
        write: 0
    };
    newData.timeoutMultiplier = 1;
    newData.shuffleResult = newData.shuffleResult || $acef29916697dd9e$var$shuffle([
        1,
        2,
        3
    ]);
    return this._setAppIdData(newData);
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._cacheAppIdData = function(data) {
    this._hostIndexes = data.hostIndexes;
    this._timeoutMultiplier = data.timeoutMultiplier;
    this._shuffleResult = data.shuffleResult;
};

$acef29916697dd9e$var$AlgoliaSearchCore.prototype._partialAppIdDataUpdate = function(newData) {
    var foreach = (parcelRequire("8wZP1"));
    var currentData = this._getAppIdData();
    foreach(newData, function(value, key) {
        currentData[key] = value;
    });
    return this._setAppIdData(currentData);
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._getHostByType = function(hostType) {
    return this.hosts[hostType][this._getHostIndexByType(hostType)];
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._getTimeoutMultiplier = function() {
    return this._timeoutMultiplier;
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._getHostIndexByType = function(hostType) {
    return this._hostIndexes[hostType];
};

$acef29916697dd9e$var$AlgoliaSearchCore.prototype._setHostIndexByType = function(hostIndex, hostType) {
    var clone = (parcelRequire("eFOtW"));
    var newHostIndexes = clone(this._hostIndexes);
    newHostIndexes[hostType] = hostIndex;
    this._partialAppIdDataUpdate({
        hostIndexes: newHostIndexes
    });
    return hostIndex;
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._incrementHostIndex = function(hostType) {
    return this._setHostIndexByType((this._getHostIndexByType(hostType) + 1) % this.hosts[hostType].length, hostType);
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._incrementTimeoutMultipler = function() {
    var timeoutMultiplier = Math.max(this._timeoutMultiplier + 1, 4);
    return this._partialAppIdDataUpdate({
        timeoutMultiplier: timeoutMultiplier
    });
};
$acef29916697dd9e$var$AlgoliaSearchCore.prototype._getTimeoutsForRequest = function(hostType) {
    return {
        connect: this._timeouts.connect * this._timeoutMultiplier,
        complete: this._timeouts[hostType] * this._timeoutMultiplier
    };
};
function $acef29916697dd9e$var$prepareHost(protocol) {
    return function prepare(host) {
        return protocol + '//' + host.toLowerCase();
    };
}
// Prototype.js < 1.7, a widely used library, defines a weird
// Array.prototype.toJSON function that will fail to stringify our content
// appropriately
// refs:
//   - https://groups.google.com/forum/#!topic/prototype-core/E-SAVvV_V9Q
//   - https://github.com/sstephenson/prototype/commit/038a2985a70593c1a86c230fadbdfe2e4898a48c
//   - http://stackoverflow.com/a/3148441/147079
function $acef29916697dd9e$var$safeJSONStringify(obj) {
    /* eslint no-extend-native:0 */ if (Array.prototype.toJSON === undefined) return JSON.stringify(obj);
    var toJSON = Array.prototype.toJSON;
    delete Array.prototype.toJSON;
    var out = JSON.stringify(obj);
    Array.prototype.toJSON = toJSON;
    return out;
}
function $acef29916697dd9e$var$shuffle(array) {
    var currentIndex = array.length;
    var temporaryValue;
    var randomIndex;
    // While there remain elements to shuffle...
    while(currentIndex !== 0){
        // Pick a remaining element...
        randomIndex = Math.floor(Math.random() * currentIndex);
        currentIndex -= 1;
        // And swap it with the current element.
        temporaryValue = array[currentIndex];
        array[currentIndex] = array[randomIndex];
        array[randomIndex] = temporaryValue;
    }
    return array;
}
function $acef29916697dd9e$var$removeCredentials(headers) {
    var newHeaders = {};
    for(var headerName in headers)if (Object.prototype.hasOwnProperty.call(headers, headerName)) {
        var value;
        if (headerName === 'x-algolia-api-key' || headerName === 'x-algolia-application-id') value = '**hidden for security purposes**';
        else value = headers[headerName];
        newHeaders[headerName] = value;
    }
    return newHeaders;
}

});
parcelRegister("72Pfb", function(module, exports) {

var $5210784c65a6e35e$var$debug = (parcelRequire("5KxQY"))('algoliasearch:src/hostIndexState.js');
var $5210784c65a6e35e$var$localStorageNamespace = 'algoliasearch-client-js';
var $5210784c65a6e35e$var$store;
var $5210784c65a6e35e$var$moduleStore = {
    state: {},
    set: function(key, data) {
        this.state[key] = data;
        return this.state[key];
    },
    get: function(key) {
        return this.state[key] || null;
    }
};
var $5210784c65a6e35e$var$localStorageStore = {
    set: function(key, data) {
        $5210784c65a6e35e$var$moduleStore.set(key, data); // always replicate localStorageStore to moduleStore in case of failure
        try {
            var namespace = JSON.parse($parcel$global.localStorage[$5210784c65a6e35e$var$localStorageNamespace]);
            namespace[key] = data;
            $parcel$global.localStorage[$5210784c65a6e35e$var$localStorageNamespace] = JSON.stringify(namespace);
            return namespace[key];
        } catch (e) {
            return $5210784c65a6e35e$var$localStorageFailure(key, e);
        }
    },
    get: function(key) {
        try {
            return JSON.parse($parcel$global.localStorage[$5210784c65a6e35e$var$localStorageNamespace])[key] || null;
        } catch (e) {
            return $5210784c65a6e35e$var$localStorageFailure(key, e);
        }
    }
};
function $5210784c65a6e35e$var$localStorageFailure(key, e) {
    $5210784c65a6e35e$var$debug('localStorage failed with', e);
    $5210784c65a6e35e$var$cleanup();
    $5210784c65a6e35e$var$store = $5210784c65a6e35e$var$moduleStore;
    return $5210784c65a6e35e$var$store.get(key);
}
$5210784c65a6e35e$var$store = $5210784c65a6e35e$var$supportsLocalStorage() ? $5210784c65a6e35e$var$localStorageStore : $5210784c65a6e35e$var$moduleStore;
module.exports = {
    get: $5210784c65a6e35e$var$getOrSet,
    set: $5210784c65a6e35e$var$getOrSet,
    supportsLocalStorage: $5210784c65a6e35e$var$supportsLocalStorage
};
function $5210784c65a6e35e$var$getOrSet(key, data) {
    if (arguments.length === 1) return $5210784c65a6e35e$var$store.get(key);
    return $5210784c65a6e35e$var$store.set(key, data);
}
function $5210784c65a6e35e$var$supportsLocalStorage() {
    try {
        if ('localStorage' in $parcel$global && $parcel$global.localStorage !== null) {
            if (!$parcel$global.localStorage[$5210784c65a6e35e$var$localStorageNamespace]) // actual creation of the namespace
            $parcel$global.localStorage.setItem($5210784c65a6e35e$var$localStorageNamespace, JSON.stringify({}));
            return true;
        }
        return false;
    } catch (_) {
        return false;
    }
}
// In case of any error on localStorage, we clean our own namespace, this should handle
// quota errors when a lot of keys + data are used
function $5210784c65a6e35e$var$cleanup() {
    try {
        $parcel$global.localStorage.removeItem($5210784c65a6e35e$var$localStorageNamespace);
    } catch (_) {
    // nothing to do
    }
}

});
parcelRegister("5KxQY", function(module, exports) {
/**
 * This is the web browser implementation of `debug()`.
 *
 * Expose `debug()` as the module.
 */ 
var $2fFJv = parcelRequire("2fFJv");

exports = module.exports = (parcelRequire("6WfuY"));
exports.log = log;
exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = 'undefined' != typeof chrome && 'undefined' != typeof chrome.storage ? chrome.storage.local : localstorage();
/**
 * Colors.
 */ exports.colors = [
    'lightseagreen',
    'forestgreen',
    'goldenrod',
    'dodgerblue',
    'darkorchid',
    'crimson'
];
/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */ function useColors() {
    // NB: In an Electron preload script, document will be defined but not fully
    // initialized. Since we know we're in Chrome, we'll just detect this case
    // explicitly
    if (typeof window !== 'undefined' && window.process && window.process.type === 'renderer') return true;
    // is webkit? http://stackoverflow.com/a/16459606/376773
    // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
    return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // is firebug? http://stackoverflow.com/a/398120/376773
    typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // is firefox >= v31?
    // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // double check webkit in userAgent just in case we are in a worker
    typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
}
/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */ exports.formatters.j = function(v) {
    try {
        return JSON.stringify(v);
    } catch (err) {
        return '[UnexpectedJSONParseError]: ' + err.message;
    }
};
/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */ function formatArgs(args) {
    var useColors = this.useColors;
    args[0] = (useColors ? '%c' : '') + this.namespace + (useColors ? ' %c' : ' ') + args[0] + (useColors ? '%c ' : ' ') + '+' + exports.humanize(this.diff);
    if (!useColors) return;
    var c = 'color: ' + this.color;
    args.splice(1, 0, c, 'color: inherit');
    // the final "%c" is somewhat tricky, because there could be other
    // arguments passed either before or after the %c, so we need to
    // figure out the correct index to insert the CSS into
    var index = 0;
    var lastC = 0;
    args[0].replace(/%[a-zA-Z%]/g, function(match) {
        if ('%%' === match) return;
        index++;
        if ('%c' === match) // we only are interested in the *last* %c
        // (the user may have provided their own)
        lastC = index;
    });
    args.splice(lastC, 0, c);
}
/**
 * Invokes `console.log()` when available.
 * No-op when `console.log` is not a "function".
 *
 * @api public
 */ function log() {
    // this hackery is required for IE8/9, where
    // the `console.log` function doesn't have 'apply'
    return 'object' === typeof console && console.log && Function.prototype.apply.call(console.log, console, arguments);
}
/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */ function save(namespaces) {
    try {
        if (null == namespaces) exports.storage.removeItem('debug');
        else exports.storage.debug = namespaces;
    } catch (e) {}
}
/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */ function load() {
    var r;
    try {
        r = exports.storage.debug;
    } catch (e) {}
    // If debug isn't set in LS, and we're in Electron, try to load $DEBUG
    if (!r && typeof $2fFJv !== 'undefined' && 'env' in $2fFJv) r = undefined;
    return r;
}
/**
 * Enable namespaces listed in `localStorage.debug` initially.
 */ exports.enable(load());
/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */ function localstorage() {
    try {
        return window.localStorage;
    } catch (e) {}
}

});
parcelRegister("6WfuY", function(module, exports) {
/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 *
 * Expose `debug()` as the module.
 */ exports = module.exports = createDebug.debug = createDebug['default'] = createDebug;
exports.coerce = coerce;
exports.disable = disable;
exports.enable = enable;
exports.enabled = enabled;

exports.humanize = (parcelRequire("4Hrkz"));
/**
 * The currently active debug mode names, and names to skip.
 */ exports.names = [];
exports.skips = [];
/**
 * Map of special "%n" handling functions, for the debug "format" argument.
 *
 * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
 */ exports.formatters = {};
/**
 * Previous log timestamp.
 */ var prevTime;
/**
 * Select a color.
 * @param {String} namespace
 * @return {Number}
 * @api private
 */ function selectColor(namespace) {
    var hash = 0, i;
    for(i in namespace){
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
    }
    return exports.colors[Math.abs(hash) % exports.colors.length];
}
/**
 * Create a debugger with the given `namespace`.
 *
 * @param {String} namespace
 * @return {Function}
 * @api public
 */ function createDebug(namespace) {
    function debug() {
        // disabled?
        if (!debug.enabled) return;
        var self = debug;
        // set `diff` timestamp
        var curr = +new Date();
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        // turn the `arguments` into a proper Array
        var args = new Array(arguments.length);
        for(var i = 0; i < args.length; i++)args[i] = arguments[i];
        args[0] = exports.coerce(args[0]);
        if ('string' !== typeof args[0]) // anything else let's inspect with %O
        args.unshift('%O');
        // apply any `formatters` transformations
        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function(match, format) {
            // if we encounter an escaped % then don't increase the array index
            if (match === '%%') return match;
            index++;
            var formatter = exports.formatters[format];
            if ('function' === typeof formatter) {
                var val = args[index];
                match = formatter.call(self, val);
                // now we need to remove `args[index]` since it's inlined in the `format`
                args.splice(index, 1);
                index--;
            }
            return match;
        });
        // apply env-specific formatting (colors, etc.)
        exports.formatArgs.call(self, args);
        var logFn = debug.log || exports.log || console.log.bind(console);
        logFn.apply(self, args);
    }
    debug.namespace = namespace;
    debug.enabled = exports.enabled(namespace);
    debug.useColors = exports.useColors();
    debug.color = selectColor(namespace);
    // env-specific initialization logic for debug instances
    if ('function' === typeof exports.init) exports.init(debug);
    return debug;
}
/**
 * Enables a debug mode by namespaces. This can include modes
 * separated by a colon and wildcards.
 *
 * @param {String} namespaces
 * @api public
 */ function enable(namespaces) {
    exports.save(namespaces);
    exports.names = [];
    exports.skips = [];
    var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
    var len = split.length;
    for(var i = 0; i < len; i++){
        if (!split[i]) continue; // ignore empty strings
        namespaces = split[i].replace(/\*/g, '.*?');
        if (namespaces[0] === '-') exports.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        else exports.names.push(new RegExp('^' + namespaces + '$'));
    }
}
/**
 * Disable debug output.
 *
 * @api public
 */ function disable() {
    exports.enable('');
}
/**
 * Returns true if the given mode name is enabled, false otherwise.
 *
 * @param {String} name
 * @return {Boolean}
 * @api public
 */ function enabled(name) {
    var i, len;
    for(i = 0, len = exports.skips.length; i < len; i++){
        if (exports.skips[i].test(name)) return false;
    }
    for(i = 0, len = exports.names.length; i < len; i++){
        if (exports.names[i].test(name)) return true;
    }
    return false;
}
/**
 * Coerce `val`.
 *
 * @param {Mixed} val
 * @return {Mixed}
 * @api private
 */ function coerce(val) {
    if (val instanceof Error) return val.stack || val.message;
    return val;
}

});
parcelRegister("4Hrkz", function(module, exports) {
/**
 * Helpers.
 */ var $36c060e549cc702e$var$s = 1000;
var $36c060e549cc702e$var$m = $36c060e549cc702e$var$s * 60;
var $36c060e549cc702e$var$h = $36c060e549cc702e$var$m * 60;
var $36c060e549cc702e$var$d = $36c060e549cc702e$var$h * 24;
var $36c060e549cc702e$var$y = $36c060e549cc702e$var$d * 365.25;
/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */ module.exports = function(val, options) {
    options = options || {};
    var type = typeof val;
    if (type === 'string' && val.length > 0) return $36c060e549cc702e$var$parse(val);
    else if (type === 'number' && isNaN(val) === false) return options.long ? $36c060e549cc702e$var$fmtLong(val) : $36c060e549cc702e$var$fmtShort(val);
    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
};
/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */ function $36c060e549cc702e$var$parse(str) {
    str = String(str);
    if (str.length > 100) return;
    var match = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(str);
    if (!match) return;
    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();
    switch(type){
        case 'years':
        case 'year':
        case 'yrs':
        case 'yr':
        case 'y':
            return n * $36c060e549cc702e$var$y;
        case 'days':
        case 'day':
        case 'd':
            return n * $36c060e549cc702e$var$d;
        case 'hours':
        case 'hour':
        case 'hrs':
        case 'hr':
        case 'h':
            return n * $36c060e549cc702e$var$h;
        case 'minutes':
        case 'minute':
        case 'mins':
        case 'min':
        case 'm':
            return n * $36c060e549cc702e$var$m;
        case 'seconds':
        case 'second':
        case 'secs':
        case 'sec':
        case 's':
            return n * $36c060e549cc702e$var$s;
        case 'milliseconds':
        case 'millisecond':
        case 'msecs':
        case 'msec':
        case 'ms':
            return n;
        default:
            return undefined;
    }
}
/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $36c060e549cc702e$var$fmtShort(ms) {
    if (ms >= $36c060e549cc702e$var$d) return Math.round(ms / $36c060e549cc702e$var$d) + 'd';
    if (ms >= $36c060e549cc702e$var$h) return Math.round(ms / $36c060e549cc702e$var$h) + 'h';
    if (ms >= $36c060e549cc702e$var$m) return Math.round(ms / $36c060e549cc702e$var$m) + 'm';
    if (ms >= $36c060e549cc702e$var$s) return Math.round(ms / $36c060e549cc702e$var$s) + 's';
    return ms + 'ms';
}
/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */ function $36c060e549cc702e$var$fmtLong(ms) {
    return $36c060e549cc702e$var$plural(ms, $36c060e549cc702e$var$d, 'day') || $36c060e549cc702e$var$plural(ms, $36c060e549cc702e$var$h, 'hour') || $36c060e549cc702e$var$plural(ms, $36c060e549cc702e$var$m, 'minute') || $36c060e549cc702e$var$plural(ms, $36c060e549cc702e$var$s, 'second') || ms + ' ms';
}
/**
 * Pluralization helper.
 */ function $36c060e549cc702e$var$plural(ms, n, name) {
    if (ms < n) return;
    if (ms < n * 1.5) return Math.floor(ms / n) + ' ' + name;
    return Math.ceil(ms / n) + ' ' + name + 's';
}

});





parcelRegister("hz3TB", function(module, exports) {
module.exports = $cc98ba2a31b758a9$var$createAnalyticsClient;

var $f2Nkd = parcelRequire("f2Nkd");
function $cc98ba2a31b758a9$var$createAnalyticsClient(appId, apiKey, opts) {
    var analytics = {};
    opts = opts || {};
    // there need to be 4 hosts, like on the client, since if requests fail,
    // the counter goes up by 1, so we need to have the same amount of hosts
    // 4 because: -dsn, -1, -2, -3
    // This is done because the APPID used for search will be the same for the analytics client created,
    // and since the state of available hosts is shared by APPID globally for the module, we had issues
    // where the hostIndex would be 1 while the array was only one entry (you got an empty host)
    opts.hosts = opts.hosts || [
        'analytics.algolia.com',
        'analytics.algolia.com',
        'analytics.algolia.com',
        'analytics.algolia.com'
    ];
    opts.protocol = opts.protocol || 'https:';
    analytics.as = $f2Nkd(appId, apiKey, opts);
    analytics.getABTests = function(_params, callback) {
        var params = params || {};
        var offset = params.offset || 0;
        var limit = params.limit || 10;
        return this.as._jsonRequest({
            method: 'GET',
            url: '/2/abtests?offset=' + encodeURIComponent(offset) + '&limit=' + encodeURIComponent(limit),
            hostType: 'read',
            forceAuthHeaders: true,
            callback: callback
        });
    };
    analytics.getABTest = function(abTestID, callback) {
        return this.as._jsonRequest({
            method: 'GET',
            url: '/2/abtests/' + encodeURIComponent(abTestID),
            hostType: 'read',
            forceAuthHeaders: true,
            callback: callback
        });
    };
    analytics.addABTest = function(abTest, callback) {
        return this.as._jsonRequest({
            method: 'POST',
            url: '/2/abtests',
            body: abTest,
            hostType: 'read',
            forceAuthHeaders: true,
            callback: callback
        });
    };
    analytics.stopABTest = function(abTestID, callback) {
        return this.as._jsonRequest({
            method: 'POST',
            url: '/2/abtests/' + encodeURIComponent(abTestID) + '/stop',
            hostType: 'read',
            forceAuthHeaders: true,
            callback: callback
        });
    };
    analytics.deleteABTest = function(abTestID, callback) {
        return this.as._jsonRequest({
            method: 'DELETE',
            url: '/2/abtests/' + encodeURIComponent(abTestID),
            hostType: 'write',
            forceAuthHeaders: true,
            callback: callback
        });
    };
    analytics.waitTask = function(indexName, taskID, callback) {
        return this.as.initIndex(indexName).waitTask(taskID, callback);
    };
    return analytics;
}

});


parcelRegister("bRA3t", function(module, exports) {
'use strict';

var $ggJ6Z = parcelRequire("ggJ6Z");

var $8a309cbc55d5afac$var$Promise = $ggJ6Z.Promise || (parcelRequire("7C6pt")).Promise;








// This is the standalone browser build entry point
// Browser implementation of the Algolia Search JavaScript client,
// using XMLHttpRequest, XDomainRequest and JSONP as fallback
module.exports = function createAlgoliasearch(AlgoliaSearch, uaSuffix) {
    var inherits = (parcelRequire("lyUaN"));
    var errors = (parcelRequire("bRG5U"));
    var inlineHeaders = (parcelRequire("jvF5r"));
    var jsonpRequest = (parcelRequire("4udmp"));
    var places = (parcelRequire("joGZo"));
    uaSuffix = uaSuffix || '';
    function algoliasearch(applicationID, apiKey, opts) {
        var cloneDeep = (parcelRequire("eFOtW"));
        opts = cloneDeep(opts || {});
        opts._ua = opts._ua || algoliasearch.ua;
        return new AlgoliaSearchBrowser(applicationID, apiKey, opts);
    }
    algoliasearch.version = (parcelRequire("7FtoO"));
    algoliasearch.ua = 'Algolia for JavaScript (' + algoliasearch.version + '); ' + uaSuffix;
    algoliasearch.initPlaces = places(algoliasearch);
    // we expose into window no matter how we are used, this will allow
    // us to easily debug any website running algolia
    $ggJ6Z.__algolia = {
        debug: (parcelRequire("5KxQY")),
        algoliasearch: algoliasearch
    };
    var support = {
        hasXMLHttpRequest: 'XMLHttpRequest' in $ggJ6Z,
        hasXDomainRequest: 'XDomainRequest' in $ggJ6Z
    };
    if (support.hasXMLHttpRequest) support.cors = 'withCredentials' in new XMLHttpRequest();
    function AlgoliaSearchBrowser() {
        // call AlgoliaSearch constructor
        AlgoliaSearch.apply(this, arguments);
    }
    inherits(AlgoliaSearchBrowser, AlgoliaSearch);
    AlgoliaSearchBrowser.prototype._request = function request(url, opts) {
        return new $8a309cbc55d5afac$var$Promise(function wrapRequest(resolve, reject) {
            // no cors or XDomainRequest, no request
            if (!support.cors && !support.hasXDomainRequest) {
                // very old browser, not supported
                reject(new errors.Network('CORS not supported'));
                return;
            }
            url = inlineHeaders(url, opts.headers);
            var body = opts.body;
            var req = support.cors ? new XMLHttpRequest() : new XDomainRequest();
            var reqTimeout;
            var timedOut;
            var connected = false;
            reqTimeout = setTimeout(onTimeout, opts.timeouts.connect);
            // we set an empty onprogress listener
            // so that XDomainRequest on IE9 is not aborted
            // refs:
            //  - https://github.com/algolia/algoliasearch-client-js/issues/76
            //  - https://social.msdn.microsoft.com/Forums/ie/en-US/30ef3add-767c-4436-b8a9-f1ca19b4812e/ie9-rtm-xdomainrequest-issued-requests-may-abort-if-all-event-handlers-not-specified?forum=iewebdevelopment
            req.onprogress = onProgress;
            if ('onreadystatechange' in req) req.onreadystatechange = onReadyStateChange;
            req.onload = onLoad;
            req.onerror = onError;
            // do not rely on default XHR async flag, as some analytics code like hotjar
            // breaks it and set it to false by default
            if (req instanceof XMLHttpRequest) {
                req.open(opts.method, url, true);
                // The Analytics API never accepts Auth headers as query string
                // this option exists specifically for them.
                if (opts.forceAuthHeaders) {
                    req.setRequestHeader('x-algolia-application-id', opts.headers['x-algolia-application-id']);
                    req.setRequestHeader('x-algolia-api-key', opts.headers['x-algolia-api-key']);
                }
            } else req.open(opts.method, url);
            // headers are meant to be sent after open
            if (support.cors) {
                if (body) {
                    if (opts.method === 'POST') // https://developer.mozilla.org/en-US/docs/Web/HTTP/Access_control_CORS#Simple_requests
                    req.setRequestHeader('content-type', 'application/x-www-form-urlencoded');
                    else req.setRequestHeader('content-type', 'application/json');
                }
                req.setRequestHeader('accept', 'application/json');
            }
            if (body) req.send(body);
            else req.send();
            // event object not received in IE8, at least
            // but we do not use it, still important to note
            function onLoad() {
                // When browser does not supports req.timeout, we can
                // have both a load and timeout event, since handled by a dumb setTimeout
                if (timedOut) return;
                clearTimeout(reqTimeout);
                var out;
                try {
                    out = {
                        body: JSON.parse(req.responseText),
                        responseText: req.responseText,
                        statusCode: req.status,
                        // XDomainRequest does not have any response headers
                        headers: req.getAllResponseHeaders && req.getAllResponseHeaders() || {}
                    };
                } catch (e) {
                    out = new errors.UnparsableJSON({
                        more: req.responseText
                    });
                }
                if (out instanceof errors.UnparsableJSON) reject(out);
                else resolve(out);
            }
            function onError(event) {
                if (timedOut) return;
                clearTimeout(reqTimeout);
                // error event is trigerred both with XDR/XHR on:
                //   - DNS error
                //   - unallowed cross domain request
                reject(new errors.Network({
                    more: event
                }));
            }
            function onTimeout() {
                timedOut = true;
                req.abort();
                reject(new errors.RequestTimeout());
            }
            function onConnect() {
                connected = true;
                clearTimeout(reqTimeout);
                reqTimeout = setTimeout(onTimeout, opts.timeouts.complete);
            }
            function onProgress() {
                if (!connected) onConnect();
            }
            function onReadyStateChange() {
                if (!connected && req.readyState > 1) onConnect();
            }
        });
    };
    AlgoliaSearchBrowser.prototype._request.fallback = function requestFallback(url, opts) {
        url = inlineHeaders(url, opts.headers);
        return new $8a309cbc55d5afac$var$Promise(function wrapJsonpRequest(resolve, reject) {
            jsonpRequest(url, opts, function jsonpRequestDone(err, content) {
                if (err) {
                    reject(err);
                    return;
                }
                resolve(content);
            });
        });
    };
    AlgoliaSearchBrowser.prototype._promise = {
        reject: function rejectPromise(val) {
            return $8a309cbc55d5afac$var$Promise.reject(val);
        },
        resolve: function resolvePromise(val) {
            return $8a309cbc55d5afac$var$Promise.resolve(val);
        },
        delay: function delayPromise(ms) {
            return new $8a309cbc55d5afac$var$Promise(function resolveOnTimeout(resolve /* , reject*/ ) {
                setTimeout(resolve, ms);
            });
        },
        all: function all(promises) {
            return $8a309cbc55d5afac$var$Promise.all(promises);
        }
    };
    return algoliasearch;
};

});
parcelRegister("ggJ6Z", function(module, exports) {
var $bd81223a300b482e$var$win;
if (typeof window !== "undefined") $bd81223a300b482e$var$win = window;
else if (typeof $parcel$global !== "undefined") $bd81223a300b482e$var$win = $parcel$global;
else if (typeof self !== "undefined") $bd81223a300b482e$var$win = self;
else $bd81223a300b482e$var$win = {};
module.exports = $bd81223a300b482e$var$win;

});

parcelRegister("7C6pt", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.8+1e68dce6
 */ (function(global1, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function objectOrFunction(x) {
        var type = typeof x;
        return x !== null && (type === 'object' || type === 'function');
    }
    function isFunction(x) {
        return typeof x === 'function';
    }
    var _isArray = void 0;
    if (Array.isArray) _isArray = Array.isArray;
    else _isArray = function(x) {
        return Object.prototype.toString.call(x) === '[object Array]';
    };
    var isArray = _isArray;
    var len = 0;
    var vertxNext = void 0;
    var customSchedulerFn = void 0;
    var asap = function asap(callback, arg) {
        queue[len] = callback;
        queue[len + 1] = arg;
        len += 2;
        if (len === 2) {
            // If len is 2, that means that we need to schedule an async flush.
            // If additional callbacks are queued before the queue is flushed, they
            // will be processed by this flush that we are scheduling.
            if (customSchedulerFn) customSchedulerFn(flush);
            else scheduleFlush();
        }
    };
    function setScheduler(scheduleFn) {
        customSchedulerFn = scheduleFn;
    }
    function setAsap(asapFn) {
        asap = asapFn;
    }
    var browserWindow = typeof window !== 'undefined' ? window : undefined;
    var browserGlobal = browserWindow || {};
    var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
    var isNode = typeof self === 'undefined' && typeof $2fFJv !== 'undefined' && ({}).toString.call($2fFJv) === '[object process]';
    // test for web worker but not in IE10
    var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';
    // node
    function useNextTick() {
        // node version 0.10.x displays a deprecation warning when nextTick is used recursively
        // see https://github.com/cujojs/when/issues/410 for details
        return function() {
            return $2fFJv.nextTick(flush);
        };
    }
    // vertx
    function useVertxTimer() {
        if (typeof vertxNext !== 'undefined') return function() {
            vertxNext(flush);
        };
        return useSetTimeout();
    }
    function useMutationObserver() {
        var iterations = 0;
        var observer = new BrowserMutationObserver(flush);
        var node = document.createTextNode('');
        observer.observe(node, {
            characterData: true
        });
        return function() {
            node.data = iterations = ++iterations % 2;
        };
    }
    // web worker
    function useMessageChannel() {
        var channel = new MessageChannel();
        channel.port1.onmessage = flush;
        return function() {
            return channel.port2.postMessage(0);
        };
    }
    function useSetTimeout() {
        // Store setTimeout reference so es6-promise will be unaffected by
        // other code modifying setTimeout (like sinon.useFakeTimers())
        var globalSetTimeout = setTimeout;
        return function() {
            return globalSetTimeout(flush, 1);
        };
    }
    var queue = new Array(1000);
    function flush() {
        for(var i = 0; i < len; i += 2){
            var callback = queue[i];
            var arg = queue[i + 1];
            callback(arg);
            queue[i] = undefined;
            queue[i + 1] = undefined;
        }
        len = 0;
    }
    function attemptVertx() {
        try {
            var vertx = Function('return this')().require('vertx');
            vertxNext = vertx.runOnLoop || vertx.runOnContext;
            return useVertxTimer();
        } catch (e) {
            return useSetTimeout();
        }
    }
    var scheduleFlush = void 0;
    // Decide what async method to use to triggering processing of queued callbacks:
    if (isNode) scheduleFlush = useNextTick();
    else if (BrowserMutationObserver) scheduleFlush = useMutationObserver();
    else if (isWorker) scheduleFlush = useMessageChannel();
    else if (browserWindow === undefined && true) scheduleFlush = attemptVertx();
    else scheduleFlush = useSetTimeout();
    function then(onFulfillment, onRejection) {
        var parent = this;
        var child = new this.constructor(noop);
        if (child[PROMISE_ID] === undefined) makePromise(child);
        var _state = parent._state;
        if (_state) {
            var callback = arguments[_state - 1];
            asap(function() {
                return invokeCallback(_state, child, callback, parent._result);
            });
        } else subscribe(parent, child, onFulfillment, onRejection);
        return child;
    }
    /**
  `Promise.resolve` returns a promise that will become resolved with the
  passed `value`. It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    resolve(1);
  });

  promise.then(function(value){
    // value === 1
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.resolve(1);

  promise.then(function(value){
    // value === 1
  });
  ```

  @method resolve
  @static
  @param {Any} value value that the returned promise will be resolved with
  Useful for tooling.
  @return {Promise} a promise that will become fulfilled with the given
  `value`
*/ function resolve$1(object) {
        /*jshint validthis:true */ var Constructor = this;
        if (object && typeof object === 'object' && object.constructor === Constructor) return object;
        var promise = new Constructor(noop);
        resolve(promise, object);
        return promise;
    }
    var PROMISE_ID = Math.random().toString(36).substring(2);
    function noop() {}
    var PENDING = void 0;
    var FULFILLED = 1;
    var REJECTED = 2;
    function selfFulfillment() {
        return new TypeError("You cannot resolve a promise with itself");
    }
    function cannotReturnOwn() {
        return new TypeError('A promises callback cannot return that same promise.');
    }
    function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
        try {
            then$$1.call(value, fulfillmentHandler, rejectionHandler);
        } catch (e) {
            return e;
        }
    }
    function handleForeignThenable(promise, thenable, then$$1) {
        asap(function(promise) {
            var sealed = false;
            var error = tryThen(then$$1, thenable, function(value) {
                if (sealed) return;
                sealed = true;
                if (thenable !== value) resolve(promise, value);
                else fulfill(promise, value);
            }, function(reason) {
                if (sealed) return;
                sealed = true;
                reject(promise, reason);
            }, 'Settle: ' + (promise._label || ' unknown promise'));
            if (!sealed && error) {
                sealed = true;
                reject(promise, error);
            }
        }, promise);
    }
    function handleOwnThenable(promise, thenable) {
        if (thenable._state === FULFILLED) fulfill(promise, thenable._result);
        else if (thenable._state === REJECTED) reject(promise, thenable._result);
        else subscribe(thenable, undefined, function(value) {
            return resolve(promise, value);
        }, function(reason) {
            return reject(promise, reason);
        });
    }
    function handleMaybeThenable(promise, maybeThenable, then$$1) {
        if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) handleOwnThenable(promise, maybeThenable);
        else {
            if (then$$1 === undefined) fulfill(promise, maybeThenable);
            else if (isFunction(then$$1)) handleForeignThenable(promise, maybeThenable, then$$1);
            else fulfill(promise, maybeThenable);
        }
    }
    function resolve(promise, value) {
        if (promise === value) reject(promise, selfFulfillment());
        else if (objectOrFunction(value)) {
            var then$$1 = void 0;
            try {
                then$$1 = value.then;
            } catch (error) {
                reject(promise, error);
                return;
            }
            handleMaybeThenable(promise, value, then$$1);
        } else fulfill(promise, value);
    }
    function publishRejection(promise) {
        if (promise._onerror) promise._onerror(promise._result);
        publish(promise);
    }
    function fulfill(promise, value) {
        if (promise._state !== PENDING) return;
        promise._result = value;
        promise._state = FULFILLED;
        if (promise._subscribers.length !== 0) asap(publish, promise);
    }
    function reject(promise, reason) {
        if (promise._state !== PENDING) return;
        promise._state = REJECTED;
        promise._result = reason;
        asap(publishRejection, promise);
    }
    function subscribe(parent, child, onFulfillment, onRejection) {
        var _subscribers = parent._subscribers;
        var length = _subscribers.length;
        parent._onerror = null;
        _subscribers[length] = child;
        _subscribers[length + FULFILLED] = onFulfillment;
        _subscribers[length + REJECTED] = onRejection;
        if (length === 0 && parent._state) asap(publish, parent);
    }
    function publish(promise) {
        var subscribers = promise._subscribers;
        var settled = promise._state;
        if (subscribers.length === 0) return;
        var child = void 0, callback = void 0, detail = promise._result;
        for(var i = 0; i < subscribers.length; i += 3){
            child = subscribers[i];
            callback = subscribers[i + settled];
            if (child) invokeCallback(settled, child, callback, detail);
            else callback(detail);
        }
        promise._subscribers.length = 0;
    }
    function invokeCallback(settled, promise, callback, detail) {
        var hasCallback = isFunction(callback), value = void 0, error = void 0, succeeded = true;
        if (hasCallback) {
            try {
                value = callback(detail);
            } catch (e) {
                succeeded = false;
                error = e;
            }
            if (promise === value) {
                reject(promise, cannotReturnOwn());
                return;
            }
        } else value = detail;
        if (promise._state !== PENDING) ;
        else if (hasCallback && succeeded) resolve(promise, value);
        else if (succeeded === false) reject(promise, error);
        else if (settled === FULFILLED) fulfill(promise, value);
        else if (settled === REJECTED) reject(promise, value);
    }
    function initializePromise(promise, resolver) {
        try {
            resolver(function resolvePromise(value) {
                resolve(promise, value);
            }, function rejectPromise(reason) {
                reject(promise, reason);
            });
        } catch (e) {
            reject(promise, e);
        }
    }
    var id = 0;
    function nextId() {
        return id++;
    }
    function makePromise(promise) {
        promise[PROMISE_ID] = id++;
        promise._state = undefined;
        promise._result = undefined;
        promise._subscribers = [];
    }
    function validationError() {
        return new Error('Array Methods must be provided an Array');
    }
    var Enumerator = function() {
        function Enumerator(Constructor, input) {
            this._instanceConstructor = Constructor;
            this.promise = new Constructor(noop);
            if (!this.promise[PROMISE_ID]) makePromise(this.promise);
            if (isArray(input)) {
                this.length = input.length;
                this._remaining = input.length;
                this._result = new Array(this.length);
                if (this.length === 0) fulfill(this.promise, this._result);
                else {
                    this.length = this.length || 0;
                    this._enumerate(input);
                    if (this._remaining === 0) fulfill(this.promise, this._result);
                }
            } else reject(this.promise, validationError());
        }
        Enumerator.prototype._enumerate = function _enumerate(input) {
            for(var i = 0; this._state === PENDING && i < input.length; i++)this._eachEntry(input[i], i);
        };
        Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
            var c = this._instanceConstructor;
            var resolve$$1 = c.resolve;
            if (resolve$$1 === resolve$1) {
                var _then = void 0;
                var error = void 0;
                var didError = false;
                try {
                    _then = entry.then;
                } catch (e) {
                    didError = true;
                    error = e;
                }
                if (_then === then && entry._state !== PENDING) this._settledAt(entry._state, i, entry._result);
                else if (typeof _then !== 'function') {
                    this._remaining--;
                    this._result[i] = entry;
                } else if (c === Promise$1) {
                    var promise = new c(noop);
                    if (didError) reject(promise, error);
                    else handleMaybeThenable(promise, entry, _then);
                    this._willSettleAt(promise, i);
                } else this._willSettleAt(new c(function(resolve$$1) {
                    return resolve$$1(entry);
                }), i);
            } else this._willSettleAt(resolve$$1(entry), i);
        };
        Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
            var promise = this.promise;
            if (promise._state === PENDING) {
                this._remaining--;
                if (state === REJECTED) reject(promise, value);
                else this._result[i] = value;
            }
            if (this._remaining === 0) fulfill(promise, this._result);
        };
        Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
            var enumerator = this;
            subscribe(promise, undefined, function(value) {
                return enumerator._settledAt(FULFILLED, i, value);
            }, function(reason) {
                return enumerator._settledAt(REJECTED, i, reason);
            });
        };
        return Enumerator;
    }();
    /**
  `Promise.all` accepts an array of promises, and returns a new promise which
  is fulfilled with an array of fulfillment values for the passed promises, or
  rejected with the reason of the first passed promise to be rejected. It casts all
  elements of the passed iterable to promises as it runs this algorithm.

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = resolve(2);
  let promise3 = resolve(3);
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // The array here would be [ 1, 2, 3 ];
  });
  ```

  If any of the `promises` given to `all` are rejected, the first promise
  that is rejected will be given as an argument to the returned promises's
  rejection handler. For example:

  Example:

  ```javascript
  let promise1 = resolve(1);
  let promise2 = reject(new Error("2"));
  let promise3 = reject(new Error("3"));
  let promises = [ promise1, promise2, promise3 ];

  Promise.all(promises).then(function(array){
    // Code here never runs because there are rejected promises!
  }, function(error) {
    // error.message === "2"
  });
  ```

  @method all
  @static
  @param {Array} entries array of promises
  @param {String} label optional string for labeling the promise.
  Useful for tooling.
  @return {Promise} promise that is fulfilled when all `promises` have been
  fulfilled, or rejected if any of them become rejected.
  @static
*/ function all(entries) {
        return new Enumerator(this, entries).promise;
    }
    /**
  `Promise.race` returns a new promise which is settled in the same way as the
  first passed promise to settle.

  Example:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 2');
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // result === 'promise 2' because it was resolved before promise1
    // was resolved.
  });
  ```

  `Promise.race` is deterministic in that only the state of the first
  settled promise matters. For example, even if other promises given to the
  `promises` array argument are resolved, but the first settled promise has
  become rejected before the other promises became fulfilled, the returned
  promise will become rejected:

  ```javascript
  let promise1 = new Promise(function(resolve, reject){
    setTimeout(function(){
      resolve('promise 1');
    }, 200);
  });

  let promise2 = new Promise(function(resolve, reject){
    setTimeout(function(){
      reject(new Error('promise 2'));
    }, 100);
  });

  Promise.race([promise1, promise2]).then(function(result){
    // Code here never runs
  }, function(reason){
    // reason.message === 'promise 2' because promise 2 became rejected before
    // promise 1 became fulfilled
  });
  ```

  An example real-world use case is implementing timeouts:

  ```javascript
  Promise.race([ajax('foo.json'), timeout(5000)])
  ```

  @method race
  @static
  @param {Array} promises array of promises to observe
  Useful for tooling.
  @return {Promise} a promise which settles in the same way as the first passed
  promise to settle.
*/ function race(entries) {
        /*jshint validthis:true */ var Constructor = this;
        if (!isArray(entries)) return new Constructor(function(_, reject) {
            return reject(new TypeError('You must pass an array to race.'));
        });
        else return new Constructor(function(resolve, reject) {
            var length = entries.length;
            for(var i = 0; i < length; i++)Constructor.resolve(entries[i]).then(resolve, reject);
        });
    }
    /**
  `Promise.reject` returns a promise rejected with the passed `reason`.
  It is shorthand for the following:

  ```javascript
  let promise = new Promise(function(resolve, reject){
    reject(new Error('WHOOPS'));
  });

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  Instead of writing the above, your code now simply becomes the following:

  ```javascript
  let promise = Promise.reject(new Error('WHOOPS'));

  promise.then(function(value){
    // Code here doesn't run because the promise is rejected!
  }, function(reason){
    // reason.message === 'WHOOPS'
  });
  ```

  @method reject
  @static
  @param {Any} reason value that the returned promise will be rejected with.
  Useful for tooling.
  @return {Promise} a promise rejected with the given `reason`.
*/ function reject$1(reason) {
        /*jshint validthis:true */ var Constructor = this;
        var promise = new Constructor(noop);
        reject(promise, reason);
        return promise;
    }
    function needsResolver() {
        throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
    }
    function needsNew() {
        throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
    }
    /**
  Promise objects represent the eventual result of an asynchronous operation. The
  primary way of interacting with a promise is through its `then` method, which
  registers callbacks to receive either a promise's eventual value or the reason
  why the promise cannot be fulfilled.

  Terminology
  -----------

  - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
  - `thenable` is an object or function that defines a `then` method.
  - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
  - `exception` is a value that is thrown using the throw statement.
  - `reason` is a value that indicates why a promise was rejected.
  - `settled` the final resting state of a promise, fulfilled or rejected.

  A promise can be in one of three states: pending, fulfilled, or rejected.

  Promises that are fulfilled have a fulfillment value and are in the fulfilled
  state.  Promises that are rejected have a rejection reason and are in the
  rejected state.  A fulfillment value is never a thenable.

  Promises can also be said to *resolve* a value.  If this value is also a
  promise, then the original promise's settled state will match the value's
  settled state.  So a promise that *resolves* a promise that rejects will
  itself reject, and a promise that *resolves* a promise that fulfills will
  itself fulfill.


  Basic Usage:
  ------------

  ```js
  let promise = new Promise(function(resolve, reject) {
    // on success
    resolve(value);

    // on failure
    reject(reason);
  });

  promise.then(function(value) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Advanced Usage:
  ---------------

  Promises shine when abstracting away asynchronous interactions such as
  `XMLHttpRequest`s.

  ```js
  function getJSON(url) {
    return new Promise(function(resolve, reject){
      let xhr = new XMLHttpRequest();

      xhr.open('GET', url);
      xhr.onreadystatechange = handler;
      xhr.responseType = 'json';
      xhr.setRequestHeader('Accept', 'application/json');
      xhr.send();

      function handler() {
        if (this.readyState === this.DONE) {
          if (this.status === 200) {
            resolve(this.response);
          } else {
            reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
          }
        }
      };
    });
  }

  getJSON('/posts.json').then(function(json) {
    // on fulfillment
  }, function(reason) {
    // on rejection
  });
  ```

  Unlike callbacks, promises are great composable primitives.

  ```js
  Promise.all([
    getJSON('/posts'),
    getJSON('/comments')
  ]).then(function(values){
    values[0] // => postsJSON
    values[1] // => commentsJSON

    return values;
  });
  ```

  @class Promise
  @param {Function} resolver
  Useful for tooling.
  @constructor
*/ var Promise$1 = function() {
        function Promise(resolver) {
            this[PROMISE_ID] = nextId();
            this._result = this._state = undefined;
            this._subscribers = [];
            if (noop !== resolver) {
                typeof resolver !== 'function' && needsResolver();
                this instanceof Promise ? initializePromise(this, resolver) : needsNew();
            }
        }
        /**
  The primary way of interacting with a promise is through its `then` method,
  which registers callbacks to receive either a promise's eventual value or the
  reason why the promise cannot be fulfilled.
   ```js
  findUser().then(function(user){
    // user is available
  }, function(reason){
    // user is unavailable, and you are given the reason why
  });
  ```
   Chaining
  --------
   The return value of `then` is itself a promise.  This second, 'downstream'
  promise is resolved with the return value of the first promise's fulfillment
  or rejection handler, or rejected if the handler throws an exception.
   ```js
  findUser().then(function (user) {
    return user.name;
  }, function (reason) {
    return 'default name';
  }).then(function (userName) {
    // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
    // will be `'default name'`
  });
   findUser().then(function (user) {
    throw new Error('Found user, but still unhappy');
  }, function (reason) {
    throw new Error('`findUser` rejected and we're unhappy');
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
    // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
  });
  ```
  If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
   ```js
  findUser().then(function (user) {
    throw new PedagogicalException('Upstream error');
  }).then(function (value) {
    // never reached
  }).then(function (value) {
    // never reached
  }, function (reason) {
    // The `PedgagocialException` is propagated all the way down to here
  });
  ```
   Assimilation
  ------------
   Sometimes the value you want to propagate to a downstream promise can only be
  retrieved asynchronously. This can be achieved by returning a promise in the
  fulfillment or rejection handler. The downstream promise will then be pending
  until the returned promise is settled. This is called *assimilation*.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // The user's comments are now available
  });
  ```
   If the assimliated promise rejects, then the downstream promise will also reject.
   ```js
  findUser().then(function (user) {
    return findCommentsByAuthor(user);
  }).then(function (comments) {
    // If `findCommentsByAuthor` fulfills, we'll have the value here
  }, function (reason) {
    // If `findCommentsByAuthor` rejects, we'll have the reason here
  });
  ```
   Simple Example
  --------------
   Synchronous Example
   ```javascript
  let result;
   try {
    result = findResult();
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
  findResult(function(result, err){
    if (err) {
      // failure
    } else {
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findResult().then(function(result){
    // success
  }, function(reason){
    // failure
  });
  ```
   Advanced Example
  --------------
   Synchronous Example
   ```javascript
  let author, books;
   try {
    author = findAuthor();
    books  = findBooksByAuthor(author);
    // success
  } catch(reason) {
    // failure
  }
  ```
   Errback Example
   ```js
   function foundBooks(books) {
   }
   function failure(reason) {
   }
   findAuthor(function(author, err){
    if (err) {
      failure(err);
      // failure
    } else {
      try {
        findBoooksByAuthor(author, function(books, err) {
          if (err) {
            failure(err);
          } else {
            try {
              foundBooks(books);
            } catch(reason) {
              failure(reason);
            }
          }
        });
      } catch(error) {
        failure(err);
      }
      // success
    }
  });
  ```
   Promise Example;
   ```javascript
  findAuthor().
    then(findBooksByAuthor).
    then(function(books){
      // found books
  }).catch(function(reason){
    // something went wrong
  });
  ```
   @method then
  @param {Function} onFulfilled
  @param {Function} onRejected
  Useful for tooling.
  @return {Promise}
  */ /**
  `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
  as the catch block of a try/catch statement.
  ```js
  function findAuthor(){
  throw new Error('couldn't find that author');
  }
  // synchronous
  try {
  findAuthor();
  } catch(reason) {
  // something went wrong
  }
  // async with promises
  findAuthor().catch(function(reason){
  // something went wrong
  });
  ```
  @method catch
  @param {Function} onRejection
  Useful for tooling.
  @return {Promise}
  */ Promise.prototype.catch = function _catch(onRejection) {
            return this.then(null, onRejection);
        };
        /**
    `finally` will be invoked regardless of the promise's fate just as native
    try/catch/finally behaves
  
    Synchronous example:
  
    ```js
    findAuthor() {
      if (Math.random() > 0.5) {
        throw new Error();
      }
      return new Author();
    }
  
    try {
      return findAuthor(); // succeed or fail
    } catch(error) {
      return findOtherAuther();
    } finally {
      // always runs
      // doesn't affect the return value
    }
    ```
  
    Asynchronous example:
  
    ```js
    findAuthor().catch(function(reason){
      return findOtherAuther();
    }).finally(function(){
      // author was either found, or not
    });
    ```
  
    @method finally
    @param {Function} callback
    @return {Promise}
  */ Promise.prototype.finally = function _finally(callback) {
            var promise = this;
            var constructor = promise.constructor;
            if (isFunction(callback)) return promise.then(function(value) {
                return constructor.resolve(callback()).then(function() {
                    return value;
                });
            }, function(reason) {
                return constructor.resolve(callback()).then(function() {
                    throw reason;
                });
            });
            return promise.then(callback, callback);
        };
        return Promise;
    }();
    Promise$1.prototype.then = then;
    Promise$1.all = all;
    Promise$1.race = race;
    Promise$1.resolve = resolve$1;
    Promise$1.reject = reject$1;
    Promise$1._setScheduler = setScheduler;
    Promise$1._setAsap = setAsap;
    Promise$1._asap = asap;
    /*global self*/ function polyfill() {
        var local = void 0;
        if (typeof $parcel$global !== 'undefined') local = $parcel$global;
        else if (typeof self !== 'undefined') local = self;
        else try {
            local = Function('return this')();
        } catch (e) {
            throw new Error('polyfill failed because global object is unavailable in this environment');
        }
        var P = local.Promise;
        if (P) {
            var promiseToString = null;
            try {
                promiseToString = Object.prototype.toString.call(P.resolve());
            } catch (e) {
            // silently ignored
            }
            if (promiseToString === '[object Promise]' && !P.cast) return;
        }
        local.Promise = Promise$1;
    }
    // Strange compat..
    Promise$1.polyfill = polyfill;
    Promise$1.Promise = Promise$1;
    return Promise$1;
});

});

parcelRegister("jvF5r", function(module, exports) {
'use strict';
module.exports = $e340c886c300671b$var$inlineHeaders;

var $9xtCu = parcelRequire("9xtCu");
function $e340c886c300671b$var$inlineHeaders(url, headers) {
    if (/\?/.test(url)) url += '&';
    else url += '?';
    return url + $9xtCu(headers);
}

});
parcelRegister("9xtCu", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $6f1e2c05a5f80c6e$var$stringifyPrimitive = function(v) {
    switch(typeof v){
        case 'string':
            return v;
        case 'boolean':
            return v ? 'true' : 'false';
        case 'number':
            return isFinite(v) ? v : '';
        default:
            return '';
    }
};
module.exports = function(obj, sep, eq, name) {
    sep = sep || '&';
    eq = eq || '=';
    if (obj === null) obj = undefined;
    if (typeof obj === 'object') return $6f1e2c05a5f80c6e$var$map($6f1e2c05a5f80c6e$var$objectKeys(obj), function(k) {
        var ks = encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(k)) + eq;
        if ($6f1e2c05a5f80c6e$var$isArray(obj[k])) return $6f1e2c05a5f80c6e$var$map(obj[k], function(v) {
            return ks + encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(v));
        }).join(sep);
        else return ks + encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(obj[k]));
    }).join(sep);
    if (!name) return '';
    return encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(name)) + eq + encodeURIComponent($6f1e2c05a5f80c6e$var$stringifyPrimitive(obj));
};
var $6f1e2c05a5f80c6e$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};
function $6f1e2c05a5f80c6e$var$map(xs, f) {
    if (xs.map) return xs.map(f);
    var res = [];
    for(var i = 0; i < xs.length; i++)res.push(f(xs[i], i));
    return res;
}
var $6f1e2c05a5f80c6e$var$objectKeys = Object.keys || function(obj) {
    var res = [];
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) res.push(key);
    return res;
};

});


parcelRegister("4udmp", function(module, exports) {
'use strict';
module.exports = $344453e151f0cff5$var$jsonpRequest;

var $bRG5U = parcelRequire("bRG5U");
var $344453e151f0cff5$var$JSONPCounter = 0;
function $344453e151f0cff5$var$jsonpRequest(url, opts, cb) {
    if (opts.method !== 'GET') {
        cb(new Error('Method ' + opts.method + ' ' + url + ' is not supported by JSONP.'));
        return;
    }
    opts.debug('JSONP: start');
    var cbCalled = false;
    var timedOut = false;
    $344453e151f0cff5$var$JSONPCounter += 1;
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    var cbName = 'algoliaJSONP_' + $344453e151f0cff5$var$JSONPCounter;
    var done = false;
    window[cbName] = function(data) {
        removeGlobals();
        if (timedOut) {
            opts.debug('JSONP: Late answer, ignoring');
            return;
        }
        cbCalled = true;
        clean();
        cb(null, {
            body: data,
            responseText: JSON.stringify(data)
        });
    };
    // add callback by hand
    url += '&callback=' + cbName;
    // add body params manually
    if (opts.jsonBody && opts.jsonBody.params) url += '&' + opts.jsonBody.params;
    var ontimeout = setTimeout(timeout, opts.timeouts.complete);
    // script onreadystatechange needed only for
    // <= IE8
    // https://github.com/angular/angular.js/issues/4523
    script.onreadystatechange = readystatechange;
    script.onload = success;
    script.onerror = error;
    script.async = true;
    script.defer = true;
    script.src = url;
    head.appendChild(script);
    function success() {
        opts.debug('JSONP: success');
        if (done || timedOut) return;
        done = true;
        // script loaded but did not call the fn => script loading error
        if (!cbCalled) {
            opts.debug('JSONP: Fail. Script loaded but did not call the callback');
            clean();
            cb(new $bRG5U.JSONPScriptFail());
        }
    }
    function readystatechange() {
        if (this.readyState === 'loaded' || this.readyState === 'complete') success();
    }
    function clean() {
        clearTimeout(ontimeout);
        script.onload = null;
        script.onreadystatechange = null;
        script.onerror = null;
        head.removeChild(script);
    }
    function removeGlobals() {
        try {
            delete window[cbName];
            delete window[cbName + '_loaded'];
        } catch (e) {
            window[cbName] = window[cbName + '_loaded'] = undefined;
        }
    }
    function timeout() {
        opts.debug('JSONP: Script timeout');
        timedOut = true;
        clean();
        cb(new $bRG5U.RequestTimeout());
    }
    function error() {
        opts.debug('JSONP: Script error');
        if (done || timedOut) return;
        clean();
        cb(new $bRG5U.JSONPScriptError());
    }
}

});

parcelRegister("joGZo", function(module, exports) {
module.exports = $e1f19af914187025$var$createPlacesClient;

var $8itcz = parcelRequire("8itcz");

var $lfQVS = parcelRequire("lfQVS");

function $e1f19af914187025$var$createPlacesClient(algoliasearch) {
    return function places(appID, apiKey, opts) {
        var cloneDeep = (parcelRequire("eFOtW"));
        opts = opts && cloneDeep(opts) || {};
        opts.hosts = opts.hosts || [
            'places-dsn.algolia.net',
            'places-1.algolianet.com',
            'places-2.algolianet.com',
            'places-3.algolianet.com'
        ];
        // allow initPlaces() no arguments => community rate limited
        if (arguments.length === 0 || typeof appID === 'object' || appID === undefined) {
            appID = '';
            apiKey = '';
            opts._allowEmptyCredentials = true;
        }
        var client = algoliasearch(appID, apiKey, opts);
        var index = client.initIndex('places');
        index.search = $lfQVS('query', '/1/places/query');
        index.reverse = function(options, callback) {
            var encoded = $8itcz.encode(options);
            return this.as._jsonRequest({
                method: 'GET',
                url: '/1/places/reverse?' + encoded,
                hostType: 'read',
                callback: callback
            });
        };
        index.getObject = function(objectID, callback) {
            return this.as._jsonRequest({
                method: 'GET',
                url: '/1/places/' + encodeURIComponent(objectID),
                hostType: 'read',
                callback: callback
            });
        };
        return index;
    };
}

});
parcelRegister("8itcz", function(module, exports) {

$parcel$export(module.exports, "decode", () => $60a6a8029ffaae01$export$2f872c0f2117be69, (v) => $60a6a8029ffaae01$export$2f872c0f2117be69 = v);
$parcel$export(module.exports, "parse", () => $60a6a8029ffaae01$export$98e6a39c04603d36, (v) => $60a6a8029ffaae01$export$98e6a39c04603d36 = v);
$parcel$export(module.exports, "encode", () => $60a6a8029ffaae01$export$c564cdbbe6da493, (v) => $60a6a8029ffaae01$export$c564cdbbe6da493 = v);
$parcel$export(module.exports, "stringify", () => $60a6a8029ffaae01$export$fac44ee5b035f737, (v) => $60a6a8029ffaae01$export$fac44ee5b035f737 = v);
var $60a6a8029ffaae01$export$2f872c0f2117be69;
var $60a6a8029ffaae01$export$98e6a39c04603d36;
var $60a6a8029ffaae01$export$c564cdbbe6da493;
var $60a6a8029ffaae01$export$fac44ee5b035f737;
'use strict';

$60a6a8029ffaae01$export$2f872c0f2117be69 = $60a6a8029ffaae01$export$98e6a39c04603d36 = (parcelRequire("4WGGY"));

$60a6a8029ffaae01$export$c564cdbbe6da493 = $60a6a8029ffaae01$export$fac44ee5b035f737 = (parcelRequire("9xtCu"));

});
parcelRegister("4WGGY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
// If obj.hasOwnProperty has been overridden, then calling
// obj.hasOwnProperty(prop) will break.
// See: https://github.com/joyent/node/issues/1707
function $399db1fd33a7e3fa$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
module.exports = function(qs, sep, eq, options) {
    sep = sep || '&';
    eq = eq || '=';
    var obj = {};
    if (typeof qs !== 'string' || qs.length === 0) return obj;
    var regexp = /\+/g;
    qs = qs.split(sep);
    var maxKeys = 1000;
    if (options && typeof options.maxKeys === 'number') maxKeys = options.maxKeys;
    var len = qs.length;
    // maxKeys <= 0 means that we should not limit keys count
    if (maxKeys > 0 && len > maxKeys) len = maxKeys;
    for(var i = 0; i < len; ++i){
        var x = qs[i].replace(regexp, '%20'), idx = x.indexOf(eq), kstr, vstr, k, v;
        if (idx >= 0) {
            kstr = x.substr(0, idx);
            vstr = x.substr(idx + 1);
        } else {
            kstr = x;
            vstr = '';
        }
        k = decodeURIComponent(kstr);
        v = decodeURIComponent(vstr);
        if (!$399db1fd33a7e3fa$var$hasOwnProperty(obj, k)) obj[k] = v;
        else if ($399db1fd33a7e3fa$var$isArray(obj[k])) obj[k].push(v);
        else obj[k] = [
            obj[k],
            v
        ];
    }
    return obj;
};
var $399db1fd33a7e3fa$var$isArray = Array.isArray || function(xs) {
    return Object.prototype.toString.call(xs) === '[object Array]';
};

});



parcelRegister("7FtoO", function(module, exports) {
'use strict';
module.exports = '3.35.1';

});




const $37a31921fd56c86d$export$27b2e48e28163360 = 'discover';
const $37a31921fd56c86d$export$a6b9aaee40d49fd0 = 'search';

parcelRegister("6jEcw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4993b38195ee1ef3$export$2e2bcd8739ae039);

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $fCICH = parcelRequire("fCICH");

var $gggoS = parcelRequire("gggoS");

var $isqrX = parcelRequire("isqrX");

const $4993b38195ee1ef3$var$facetType = (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
    'disjunctive',
    'conjunctive'
]);
var $4993b38195ee1ef3$export$2e2bcd8739ae039 = {
    filtersContext: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        discoverFacetHrefResolver: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        searchFacetHrefResolver: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    }),
    sortOption: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        key: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        label: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        indexSuffix: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
        exclusions: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).map
    }),
    discoverFilters: $4993b38195ee1ef3$var$discoverFilters,
    facetType: $4993b38195ee1ef3$var$facetType,
    hiddenFilters: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains((0, $gggoS.baseFiltersPropTypeFactory)((0, $fCICH.getFilters)(), (fvt)=>fvt).map((pt)=>(0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
            (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).setOf(pt)
        ])).toJS()),
    perspective: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        (0, $37a31921fd56c86d$export$27b2e48e28163360),
        (0, $37a31921fd56c86d$export$a6b9aaee40d49fd0)
    ]),
    processedFacet: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        facetProducts: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
            count: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
            label: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
            value: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired
        })),
        key: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        sidebarLabel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        topBarLabel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
        openByDefault: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
        primary: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
        type: $4993b38195ee1ef3$var$facetType.isRequired
    })
};
function $4993b38195ee1ef3$var$discoverFilters(props) {
    for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)rest[_key - 1] = arguments[_key];
    return (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains((0, $gggoS.filtersPropTypeFactory)((0, $fCICH.getFilters)().filter((f)=>f.get('discoverFilter')), (f)=>f.get('requiredDiscoverFilterWhenNonEmpty') && (0, $isqrX.valuedFilters)(props.filters).size).toJS())(props, ...rest);
}

});
parcelRegister("isqrX", function(module, exports) {

$parcel$export(module.exports, "valuedFilters", () => $d6ff5bef0d7aac4e$export$7c675e3025ea0a3a);
$parcel$export(module.exports, "validateFilters", () => $d6ff5bef0d7aac4e$export$d04f997183dbc18f);
$parcel$export(module.exports, "shouldFacetBeShown", () => $d6ff5bef0d7aac4e$export$73b3d0d53f61a5d0);
$parcel$export(module.exports, "shouldFacetProductBeShown", () => $d6ff5bef0d7aac4e$export$af318335bdaeb886);
$parcel$export(module.exports, "shouldFreeStarterFacetProductBeShown", () => $d6ff5bef0d7aac4e$export$1659162fb5c0ed51);

var $eA9U1 = parcelRequire("eA9U1");

var $g5DHJ = parcelRequire("g5DHJ");

var $fCICH = parcelRequire("fCICH");

var $lwEMm = parcelRequire("lwEMm");
function $d6ff5bef0d7aac4e$export$7c675e3025ea0a3a(filters) {
    return filters.filter((f)=>(0, $g5DHJ.Iterable).isIterable(f) ? f.size : f);
}
const $d6ff5bef0d7aac4e$var$filtersValidator = (0, $fCICH.getFilters)().reduce((validator, f)=>{
    if (f.get('custom')) return validator.addOneOfValidator(f.get('key'), f.get('customFilters').map((cf)=>cf.get('value')).toSet(), f.get('type') === (0, $lwEMm.DISJUNCTIVE_FACET_TYPE));
    else return validator;
}, new (0, $eA9U1.default)());
function $d6ff5bef0d7aac4e$export$d04f997183dbc18f(filters) {
    return $d6ff5bef0d7aac4e$var$filtersValidator.validate(filters);
}
function $d6ff5bef0d7aac4e$export$73b3d0d53f61a5d0(facetKey, hiddenFilters) {
    return hiddenFilters.get(facetKey) !== true;
}
function $d6ff5bef0d7aac4e$export$af318335bdaeb886(facetKey, facetProductKey, hiddenFilters) {
    const hiddenFilter = hiddenFilters.get(facetKey);
    if (hiddenFilter !== undefined) return (0, $g5DHJ.Set).isSet(hiddenFilter) ? !hiddenFilter.includes(facetProductKey) : $d6ff5bef0d7aac4e$export$73b3d0d53f61a5d0(facetKey, hiddenFilters);
    else return true;
}
function $d6ff5bef0d7aac4e$export$1659162fb5c0ed51(value, enableFreeStarterTierFilter) {
    return value !== 'freeStarterTier' || enableFreeStarterTierFilter;
}

});
parcelRegister("eA9U1", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9dc1becfc64d1c8$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $g5DHJ = parcelRequire("g5DHJ");
function $a9dc1becfc64d1c8$var$requiredValidator(key) {
    return (queryParams)=>{
        const value = queryParams.get(key);
        if (!value || (0, $g5DHJ.isCollection)(value) && !value.size) return (0, $g5DHJ.Set)([
            "A value for '".concat(key, "' is required.")
        ]);
        return (0, $g5DHJ.Set)();
    };
}
function $a9dc1becfc64d1c8$var$oneOfValidatorHelper(value, key, inSet, state) {
    const valueSet = typeof inSet === 'function' ? inSet(state) : inSet;
    if (!valueSet.includes(value)) return (0, $g5DHJ.Set)([
        "Value '".concat(value, "' is invalid for parameter '").concat(key, "'. Acceptable values are ").concat(valueSet.map((k)=>"'".concat(k, "'")).join(', '), ".")
    ]);
    return (0, $g5DHJ.Set)();
}
function $a9dc1becfc64d1c8$var$oneOfValidator(key, inSet, multipleAllowed) {
    return (queryParams, state)=>{
        const value = queryParams.get(key);
        if (!value) return (0, $g5DHJ.Set)();
        else if ((0, $g5DHJ.isCollection)(value)) {
            const valueSet = value;
            if (!multipleAllowed && valueSet.size >= 2) return (0, $g5DHJ.Set)([
                "Multiple values for '".concat(key, "' are not allowed.")
            ]);
            return valueSet.reduce((acc, v)=>acc.union($a9dc1becfc64d1c8$var$oneOfValidatorHelper(v, key, inSet, state)), (0, $g5DHJ.Set)());
        } else return $a9dc1becfc64d1c8$var$oneOfValidatorHelper(value, key, inSet, state);
    };
}
class $a9dc1becfc64d1c8$export$2e2bcd8739ae039 {
    constructor(validators){
        (0, $5zQU9.default)(this, "validatorSet", void 0);
        if ((0, $g5DHJ.isCollection)(validators)) this.validatorSet = validators;
        else if (typeof validators === 'function') this.validatorSet = (0, $g5DHJ.Set)([
            validators
        ]);
        else this.validatorSet = (0, $g5DHJ.Set)();
    }
    addValidator(validator) {
        return new $a9dc1becfc64d1c8$export$2e2bcd8739ae039(this.validatorSet.union(validator instanceof (0, $g5DHJ.Set) ? validator : (0, $g5DHJ.Set)([
            validator
        ]) // Must be a function
        ));
    }
    addRequiredValidator() {
        for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++)keys[_key] = arguments[_key];
        return new $a9dc1becfc64d1c8$export$2e2bcd8739ae039(keys.reduce((res, key)=>{
            return res.add($a9dc1becfc64d1c8$var$requiredValidator(key));
        }, this.validatorSet));
    }
    addOneOfValidator(key, inSet) {
        let multipleAllowed = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        return this.addValidator($a9dc1becfc64d1c8$var$oneOfValidator(key, inSet, multipleAllowed));
    }
    validate(queryParams, state) {
        return this.validatorSet.reduce((res, validator)=>{
            return res.union(validator(queryParams, state));
        }, (0, $g5DHJ.Set)());
    }
}

});



parcelRegister("8M3um", function(module, exports) {

$parcel$export(module.exports, "default", () => $663583341abefb8e$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");

var $408r2 = parcelRequire("408r2");

var $kKkev = parcelRequire("kKkev");

var $lXXS4 = parcelRequire("lXXS4");

var $f7sBl = parcelRequire("f7sBl");

function $663583341abefb8e$var$mapStateToProps(state) {
    const perspectives = state.get('perspectives');
    return {
        discover: perspectives.get('discover'),
        search: perspectives.get('search'),
        searchContainer: state.get('searchContainer')
    };
}
function $663583341abefb8e$var$mapDispatchToProps(dispatch, ownProps) {
    return {
        discoverActions: (0, $g5DHJ.Map)({
            retrieveDiscoverData (_ref) {
                let { filters: filters, featureFlags: featureFlags } = _ref;
                dispatch((0, $lXXS4.doRetrieveData)({
                    algoliaClient: ownProps.algoliaClient,
                    applyOverrides: ownProps.applyOverrides,
                    environment: ownProps.environment,
                    filters: filters,
                    resolveAlgoliaQueryFilterOverrides: ownProps.resolveAlgoliaQueryFilterOverrides,
                    discoverCollectionsConfig: ownProps.discoverCollectionsConfig,
                    featureFlags: featureFlags
                }));
            }
        }),
        searchActions: (0, $g5DHJ.Map)({
            doFreshSearch (_ref2) {
                let { filters: filters, featureFlags: featureFlags } = _ref2;
                dispatch((0, $kKkev.doFreshSearch)({
                    algoliaClient: ownProps.algoliaClient,
                    applyOverrides: ownProps.applyOverrides,
                    environment: ownProps.environment,
                    filters: filters,
                    resolveAlgoliaQueryFilterOverrides: ownProps.resolveAlgoliaQueryFilterOverrides,
                    featureFlags: featureFlags
                }));
            }
        }),
        onLoadMoreResultsClick (_ref3) {
            let { currentPage: currentPage, featureFlags: featureFlags } = _ref3;
            dispatch((0, $kKkev.loadMoreResults)({
                algoliaClient: ownProps.algoliaClient,
                applyOverrides: ownProps.applyOverrides,
                environment: ownProps.environment,
                filters: ownProps.filters,
                nextPage: currentPage + 1,
                resolveAlgoliaQueryFilterOverrides: ownProps.resolveAlgoliaQueryFilterOverrides,
                featureFlags: featureFlags
            }));
        },
        onPerspectiveChange () {
            dispatch((0, $408r2.resetState)());
        },
        onHitCategoryClick (_ref4) {
            let { newFilters: newFilters } = _ref4;
            ownProps.stateChangeRequested({
                perspective: (0, $37a31921fd56c86d$export$a6b9aaee40d49fd0),
                filters: newFilters
            });
        }
    };
}
var $663583341abefb8e$export$2e2bcd8739ae039 = (0, $94zHK.default)($663583341abefb8e$var$mapStateToProps, $663583341abefb8e$var$mapDispatchToProps)((0, $f7sBl.default));

});
parcelRegister("408r2", function(module, exports) {

$parcel$export(module.exports, "RESET_STATE", () => $2e9db4926d009086$export$7431817582ed8a25);
$parcel$export(module.exports, "resetState", () => $2e9db4926d009086$export$8e84bad0b35de9e8);
const $2e9db4926d009086$export$7431817582ed8a25 = 'GENERAL_RESET_STATE';
function $2e9db4926d009086$export$8e84bad0b35de9e8() {
    return {
        type: $2e9db4926d009086$export$7431817582ed8a25
    };
}

});

parcelRegister("kKkev", function(module, exports) {

$parcel$export(module.exports, "RECEIVE_FACETS", () => $f1a7cc5ea189d86b$export$84c83b2dccce27d0);
$parcel$export(module.exports, "FACETS_DATA_ERROR", () => $f1a7cc5ea189d86b$export$5033f6e9d7ffa3d4);
$parcel$export(module.exports, "RETRIEVE_FRESH_SEARCH_RESULTS", () => $f1a7cc5ea189d86b$export$da8cccd087c6db9b);
$parcel$export(module.exports, "RECEIVE_FRESH_SEARCH_RESULTS", () => $f1a7cc5ea189d86b$export$7ef116fec8a1ad14);
$parcel$export(module.exports, "DATA_ERROR_FRESH_SEARCH_RESULTS", () => $f1a7cc5ea189d86b$export$61ce092fd8b8a8ef);
$parcel$export(module.exports, "RETRIEVE_MORE_SEARCH_RESULTS", () => $f1a7cc5ea189d86b$export$b2107ac8eb4fbfd9);
$parcel$export(module.exports, "RECEIVE_MORE_SEARCH_RESULTS", () => $f1a7cc5ea189d86b$export$49f90134eeb0802d);
$parcel$export(module.exports, "DATA_ERROR_MORE_SEARCH_RESULTS", () => $f1a7cc5ea189d86b$export$f15d7aa2af12e80f);
$parcel$export(module.exports, "doFreshSearch", () => $f1a7cc5ea189d86b$export$ab0863ca760fbd87);
$parcel$export(module.exports, "loadMoreResults", () => $f1a7cc5ea189d86b$export$4b86a09a3957e324);

var $fUOHe = parcelRequire("fUOHe");

var $4fL5K = parcelRequire("4fL5K");

var $bavaN = parcelRequire("bavaN");

var $iDEAo = parcelRequire("iDEAo");

var $8Hj3g = parcelRequire("8Hj3g");
const $f1a7cc5ea189d86b$export$84c83b2dccce27d0 = 'SEARCH_RECEIVE_FACETS';
const $f1a7cc5ea189d86b$export$5033f6e9d7ffa3d4 = 'SEARCH_FACETS_DATA_ERROR';
const $f1a7cc5ea189d86b$export$da8cccd087c6db9b = 'SEARCH_RETRIEVE_FRESH_SEARCH_RESULTS';
const $f1a7cc5ea189d86b$export$7ef116fec8a1ad14 = 'SEARCH_RECEIVE_FRESH_SEARCH_RESULTS';
const $f1a7cc5ea189d86b$export$61ce092fd8b8a8ef = 'SEARCH_DATA_ERROR_FRESH_SEARCH_RESULTS';
const $f1a7cc5ea189d86b$export$b2107ac8eb4fbfd9 = 'SEARCH_RETRIEVE_MORE_SEARCH_RESULTS';
const $f1a7cc5ea189d86b$export$49f90134eeb0802d = 'SEARCH_RECEIVE_MORE_SEARCH_RESULTS';
const $f1a7cc5ea189d86b$export$f15d7aa2af12e80f = 'SEARCH_DATA_ERROR_MORE_SEARCH_RESULTS';
function $f1a7cc5ea189d86b$var$retrieveFreshSearchResults(_ref) {
    let { searchId: searchId, reducerId: reducerId } = _ref;
    return {
        type: $f1a7cc5ea189d86b$export$da8cccd087c6db9b,
        searchId: searchId,
        reducerId: reducerId
    };
}
function $f1a7cc5ea189d86b$var$receiveFreshSearchResults(_ref2) {
    let { searchId: searchId, searchResults: searchResults, reducerId: reducerId } = _ref2;
    return {
        type: $f1a7cc5ea189d86b$export$7ef116fec8a1ad14,
        searchId: searchId,
        searchResults: searchResults,
        reducerId: reducerId
    };
}
function $f1a7cc5ea189d86b$var$dataErrorFreshSearchResults(_ref3) {
    let { dataErrorMessages: dataErrorMessages, reducerId: reducerId } = _ref3;
    return {
        type: $f1a7cc5ea189d86b$export$61ce092fd8b8a8ef,
        dataErrorMessages: dataErrorMessages,
        reducerId: reducerId
    };
}
function $f1a7cc5ea189d86b$var$retrieveMoreSearchResults(_ref4) {
    let { reducerId: reducerId } = _ref4;
    return {
        type: $f1a7cc5ea189d86b$export$b2107ac8eb4fbfd9,
        reducerId: reducerId
    };
}
function $f1a7cc5ea189d86b$var$receiveMoreSearchResults(_ref5) {
    let { page: page, searchResults: searchResults, reducerId: reducerId } = _ref5;
    return {
        type: $f1a7cc5ea189d86b$export$49f90134eeb0802d,
        page: page,
        searchResults: searchResults,
        reducerId: reducerId
    };
}
function $f1a7cc5ea189d86b$var$dataErrorMoreSearchResults(_ref6) {
    let { dataErrorMessages: dataErrorMessages, reducerId: reducerId } = _ref6;
    return {
        type: $f1a7cc5ea189d86b$export$f15d7aa2af12e80f,
        dataErrorMessages: dataErrorMessages,
        reducerId: reducerId
    };
}
function $f1a7cc5ea189d86b$var$receiveFacets(_ref7) {
    let { facets: facets, reducerId: reducerId } = _ref7;
    return {
        type: $f1a7cc5ea189d86b$export$84c83b2dccce27d0,
        facets: facets,
        reducerId: reducerId
    };
}
function $f1a7cc5ea189d86b$var$facetsDataError(_ref8) {
    let { dataErrorMessages: dataErrorMessages, reducerId: reducerId } = _ref8;
    return {
        type: $f1a7cc5ea189d86b$export$5033f6e9d7ffa3d4,
        dataErrorMessages: dataErrorMessages,
        reducerId: reducerId
    };
}
const $f1a7cc5ea189d86b$var$HITS_PER_PAGE = 24;
function $f1a7cc5ea189d86b$export$ab0863ca760fbd87(_ref9) {
    let { algoliaClient: algoliaClient, applyOverrides: applyOverrides, environment: environment, filters: filters, resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides, featureFlags: featureFlags } = _ref9;
    let { forReducerId: forReducerId } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        forReducerId: undefined
    };
    return (dispatch)=>{
        (0, $4fL5K.SearchTask).start();
        const searchId = (0, $iDEAo.generateSearchId)();
        dispatch($f1a7cc5ea189d86b$var$retrieveFreshSearchResults({
            searchId: searchId,
            reducerId: forReducerId
        }));
        (0, $bavaN.search)({
            algoliaClient: algoliaClient,
            applyOverrides: applyOverrides,
            resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides,
            environment: environment,
            filters: filters,
            numHits: $f1a7cc5ea189d86b$var$HITS_PER_PAGE,
            page: 0,
            featureFlags: featureFlags
        }).then((data)=>{
            dispatch($f1a7cc5ea189d86b$var$receiveFacets({
                facets: data.get('facets'),
                reducerId: forReducerId
            }));
            dispatch($f1a7cc5ea189d86b$var$receiveFreshSearchResults({
                searchId: searchId,
                searchResults: data.get('searchResults'),
                reducerId: forReducerId
            }));
            (0, $4fL5K.SearchTask).succeeded();
        }, (error)=>{
            if (error.debugData) {
                console.error('Search error, debug data: ');
                console.error(error.debugData);
            }
            const dataErrorMessages = (0, $8Hj3g.default)(error);
            dispatch($f1a7cc5ea189d86b$var$facetsDataError({
                dataErrorMessages: dataErrorMessages,
                reducerId: forReducerId
            }));
            dispatch($f1a7cc5ea189d86b$var$dataErrorFreshSearchResults({
                dataErrorMessages: dataErrorMessages,
                reducerId: forReducerId
            }));
            (0, $fUOHe.default).setUFOInteractionError({
                name: (0, $4fL5K.searchTaskName),
                errorMessage: error === null || error === void 0 ? void 0 : error.message
            });
            (0, $4fL5K.SearchTask).failed(error);
        });
    };
}
function $f1a7cc5ea189d86b$export$4b86a09a3957e324(_ref10) {
    let { algoliaClient: algoliaClient, applyOverrides: applyOverrides, environment: environment, filters: filters, nextPage: nextPage, resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides, featureFlags: featureFlags } = _ref10;
    let { forReducerId: forReducerId } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        forReducerId: undefined
    };
    return (dispatch)=>{
        dispatch($f1a7cc5ea189d86b$var$retrieveMoreSearchResults({
            reducerId: forReducerId
        }));
        (0, $bavaN.search)({
            algoliaClient: algoliaClient,
            applyOverrides: applyOverrides,
            environment: environment,
            filters: filters,
            numHits: $f1a7cc5ea189d86b$var$HITS_PER_PAGE,
            page: nextPage,
            resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides,
            featureFlags: featureFlags
        }).then((data)=>{
            dispatch($f1a7cc5ea189d86b$var$receiveFacets({
                facets: data.get('facets'),
                reducerId: forReducerId
            }));
            dispatch($f1a7cc5ea189d86b$var$receiveMoreSearchResults({
                page: nextPage,
                searchResults: data.get('searchResults'),
                reducerId: forReducerId
            }));
        }, (error)=>{
            if (error.debugData) {
                console.error('Search error, debug data: ');
                console.error(error.debugData);
            }
            const dataErrorMessages = (0, $8Hj3g.default)(error);
            dispatch($f1a7cc5ea189d86b$var$dataErrorMoreSearchResults({
                dataErrorMessages: dataErrorMessages,
                reducerId: forReducerId
            }));
        });
    };
}

});
parcelRegister("fUOHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b963692fe4cd3445$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $6bWmm = parcelRequire("6bWmm");

var $fX8fU = parcelRequire("fX8fU");

var $ilgCJ = parcelRequire("ilgCJ");

var $MB7Ow = parcelRequire("MB7Ow");

var $kCL8m = parcelRequire("kCL8m");
function $b963692fe4cd3445$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b963692fe4cd3445$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b963692fe4cd3445$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b963692fe4cd3445$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $b963692fe4cd3445$export$2e2bcd8739ae039 {
    static setPage() {
        let pageName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'PAGE_UNKNOWN';
        // If we'd previously set a page and are changing it now,
        // it should be a client side render
        if ($b963692fe4cd3445$export$2e2bcd8739ae039.activePageName && $b963692fe4cd3445$export$2e2bcd8739ae039.activePageName !== pageName) {
            $b963692fe4cd3445$export$2e2bcd8739ae039.isInitialRender = false;
            $b963692fe4cd3445$export$2e2bcd8739ae039.pageNavigationStartTime = performance.now();
            $b963692fe4cd3445$export$2e2bcd8739ae039.isPageReady.resolve();
        }
        $b963692fe4cd3445$export$2e2bcd8739ae039.activePageName = pageName;
    }
    static fireComponentBoundaryError(componentName, error) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_COMPONENT_ERROR_BOUNDARY,
            componentName: componentName,
            error: error
        });
        $b963692fe4cd3445$export$2e2bcd8739ae039.abortAllTasks(error);
    }
    static fireSearchTiming(duration) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_ALGOLIA_SEARCH_TIMING,
            duration: duration
        });
    }
    static task(options) {
        const { successful: successful, task: task, taskId: taskId, duration: duration, cause: cause } = options;
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_GENERIC_TASK,
            successful: successful,
            task: task,
            taskId: taskId,
            duration: duration,
            cause: cause
        });
    }
    static _createTask(taskName, taskType) {
        const createdTask = new (0, $fX8fU.default)(taskName);
        createdTask.addCompletionListener((args)=>{
            const { success: success, duration: duration, cause: cause, taskId: taskId, task: task } = args;
            $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit($b963692fe4cd3445$var$_objectSpread($b963692fe4cd3445$var$_objectSpread({}, taskType), {}, {
                successful: success,
                task: task,
                taskId: taskId,
                duration: duration,
                cause: cause
            }));
        });
        $b963692fe4cd3445$export$2e2bcd8739ae039.registeredTasks.push(createdTask);
        return createdTask;
    }
    static createPageViewTask(taskName) {
        return $b963692fe4cd3445$export$2e2bcd8739ae039._createTask(taskName, {
            type: (0, $6bWmm.Events).LABEL_PAGE_VIEW_TASK
        });
    }
    static createGenericTask(taskName) {
        return $b963692fe4cd3445$export$2e2bcd8739ae039._createTask(taskName, {
            type: (0, $6bWmm.Events).LABEL_GENERIC_TASK
        });
    }
    static abortAllTasks(error) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.registeredTasks.forEach((task)=>task.failed(error));
    }
    static routeChangeStart() {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_ROUTE_CHANGE_START
        });
    }
    static timeToFirstPaint(duration) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_TIME_TO_FIRST_CONTENTFUL_PAINT,
            duration: duration
        });
    }
    static timeToFirstMeaningfulPaint(endTime) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_TIME_TO_FIRST_MEANINGFUL_PAINT,
            endTime: endTime
        });
    }
    static timeToLargestContentfulPaint(duration) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_TIME_TO_LARGEST_CONTENTFUL_PAINT,
            duration: duration
        });
    }
    static firstInputDelay(duration) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_FIRST_INPUT_DELAY,
            duration: duration
        });
    }
    static timeToFirstByte(duration) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_TIME_TO_FIRST_BYTE,
            duration: duration
        });
    }
    static timeToInteractive(duration) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_TIME_TO_INTERACTIVE,
            duration: duration
        });
    }
    static cumulativeLayoutShift(shift) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_CUMULATIVE_LAYOUT_SHIFT,
            shift: shift
        });
    }
    static resourceDownloadTime(type, duration) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_RESOURCE_DOWNLOAD_TIME_SUM,
            duration: duration,
            resourceType: type
        });
    }
    static traceUFOPageLoad(routeName) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_TRACE_UFO_PAGE_LOAD,
            routeName: routeName
        });
    }
    static setUFOInteractionError(error, interactionName) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_UFO_INTERACTION_ERROR,
            error: error,
            interactionName: interactionName
        });
    }
    static traceUFOPress(interactionName) {
        $b963692fe4cd3445$export$2e2bcd8739ae039.messageQueue.emit({
            type: (0, $6bWmm.Events).LABEL_TRACE_UFO_PRESS,
            interactionName: interactionName
        });
    }
}
(0, $5zQU9.default)($b963692fe4cd3445$export$2e2bcd8739ae039, "messageQueue", new (0, $MB7Ow.default)());
(0, $5zQU9.default)($b963692fe4cd3445$export$2e2bcd8739ae039, "registeredTasks", []);
(0, $5zQU9.default)($b963692fe4cd3445$export$2e2bcd8739ae039, "isInitialRender", true);
(0, $5zQU9.default)($b963692fe4cd3445$export$2e2bcd8739ae039, "activePageName", '');
(0, $5zQU9.default)($b963692fe4cd3445$export$2e2bcd8739ae039, "pageNavigationStartTime", (0, $kCL8m.getNavigationTiming)().fetchStart);
(0, $5zQU9.default)($b963692fe4cd3445$export$2e2bcd8739ae039, "isPageReady", new (0, $ilgCJ.default)());

});
parcelRegister("6bWmm", function(module, exports) {

$parcel$export(module.exports, "Events", () => $48210a2505b4e0c9$export$ada873a34909da65);
let $48210a2505b4e0c9$export$ada873a34909da65 = /*#__PURE__*/ function(Events) {
    Events["LABEL_FIRST_INPUT_DELAY"] = "first-input-delay";
    Events["LABEL_TIME_TO_FIRST_BYTE"] = "time-to-first-byte";
    Events["LABEL_TIME_TO_INTERACTIVE"] = "time-to-interactive";
    Events["LABEL_TIME_TO_FIRST_CONTENTFUL_PAINT"] = "first-contentful-paint";
    Events["LABEL_TIME_TO_LARGEST_CONTENTFUL_PAINT"] = "largest-contentful-paint";
    Events["LABEL_CUMULATIVE_LAYOUT_SHIFT"] = "cumulative-layout-shift";
    Events["LABEL_TIME_TO_FIRST_MEANINGFUL_PAINT"] = "first-meaningful-paint";
    Events["LABEL_RESOURCE_DOWNLOAD_TIME_SUM"] = "resource-download-time-sum";
    Events["LABEL_CAAS_SPI_METHOD_EXECUTION"] = "caas-spi-execution";
    Events["LABEL_ALGOLIA_SEARCH_TIMING"] = "algolia-search";
    Events["LABEL_COMPONENT_ERROR_BOUNDARY"] = "component-error-boundary";
    Events["LABEL_GENERIC_TASK"] = "generic-task";
    Events["LABEL_PAGE_VIEW_TASK"] = "page-view-task";
    Events["LABEL_ROUTE_CHANGE_START"] = "route-change-start";
    Events["LABEL_TRACE_UFO_PAGE_LOAD"] = "trace-ufo-page-load";
    Events["LABEL_UFO_INTERACTION_ERROR"] = "set-ufo-interaction-error";
    Events["LABEL_TRACE_UFO_PRESS"] = "trace-ufo-page-press";
    return Events;
}({}); /** @see https://developer.atlassian.com/platform/metal/introduction/metric-descriptions/#component-boundary-errors */ 

});

parcelRegister("fX8fU", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9d2c51a881f167c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $b9d2c51a881f167c$var$_classPrivateFieldInitSpec(e, t, a) {
    $b9d2c51a881f167c$var$_checkPrivateRedeclaration(e, t), t.set(e, a);
}
function $b9d2c51a881f167c$var$_checkPrivateRedeclaration(e, t) {
    if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}
function $b9d2c51a881f167c$var$_classPrivateFieldGet(s, a) {
    return s.get($b9d2c51a881f167c$var$_assertClassBrand(s, a));
}
function $b9d2c51a881f167c$var$_classPrivateFieldSet(s, a, r) {
    return s.set($b9d2c51a881f167c$var$_assertClassBrand(s, a), r), r;
}
function $b9d2c51a881f167c$var$_assertClassBrand(e, t, n) {
    if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n;
    throw new TypeError("Private element is not present on this object");
}
var $b9d2c51a881f167c$var$_dependencies = /*#__PURE__*/ new WeakMap();
var $b9d2c51a881f167c$var$_startTime = /*#__PURE__*/ new WeakMap();
var $b9d2c51a881f167c$var$_pendingDependencies = /*#__PURE__*/ new WeakMap();
var $b9d2c51a881f167c$var$_onCompleteListeners = /*#__PURE__*/ new WeakMap();
var $b9d2c51a881f167c$var$_onDependencyCompleted = /*#__PURE__*/ new WeakMap();
class $b9d2c51a881f167c$export$2e2bcd8739ae039 {
    constructor(task){
        (0, $5zQU9.default)(this, "task", void 0);
        $b9d2c51a881f167c$var$_classPrivateFieldInitSpec(this, $b9d2c51a881f167c$var$_dependencies, void 0);
        $b9d2c51a881f167c$var$_classPrivateFieldInitSpec(this, $b9d2c51a881f167c$var$_startTime, void 0);
        $b9d2c51a881f167c$var$_classPrivateFieldInitSpec(this, $b9d2c51a881f167c$var$_pendingDependencies, void 0);
        $b9d2c51a881f167c$var$_classPrivateFieldInitSpec(this, $b9d2c51a881f167c$var$_onCompleteListeners, void 0);
        $b9d2c51a881f167c$var$_classPrivateFieldInitSpec(this, $b9d2c51a881f167c$var$_onDependencyCompleted, void 0);
        this.task = task;
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_onCompleteListeners, this, []);
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_dependencies, this, []);
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_onDependencyCompleted, this, (completedTask)=>{
            const { task: currentTask, success: success } = completedTask;
            if (!$b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_startTime, this)) return;
            if (!success) {
                // a dependency has failed, so we must end the current task as a failure
                // end also takes care of cleanup
                this.failed(completedTask);
                return;
            }
            // remove the current dependency task from the pending list
            $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_pendingDependencies, this, $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_pendingDependencies, this).filter((dependency)=>dependency.task !== currentTask));
            // if all pending tasks have been completed (successfully), this task should also be marked complete
            if ($b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_pendingDependencies, this).length === 0) this.succeeded();
        });
    }
    hasDependencies() {
        return $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_dependencies, this).length !== 0;
    }
    addCompletionListener(listener) {
        $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_onCompleteListeners, this).push(listener);
        return this;
    }
    start() {
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_startTime, this, performance.now());
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_pendingDependencies, this, $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_dependencies, this).map((dependency)=>dependency));
        return this;
    }
    /**
   * Call when the task is successfully completed. If this task has dependencies, it will
   * automatically be marked as successfully completed when _all_ of the dependencies also
   * successfully completed.
   */ succeeded() {
        this._end(true);
    }
    /**
   * Call when the task fails. If this task has dependencies, it will automatically be marked as
   * failed if _any one_ of the dependencies also fail.
   */ failed(cause, errorIdentifier) {
        this._end(false, cause, errorIdentifier);
    }
    /**
   * Call when the task needs to be aborted. This resets the state without triggering any "success"
   * or "failure" events.
   * Eg: For an App Listing page view task, if the used is redirected to the login page, the task
   * would need to be aborted since its neither a success not a failure.
   */ abort() {
        if (typeof $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_startTime, this) !== 'number') {
            console.warn("[".concat(this.task, "] noop: Attempted to \"abort\" a task which wasn't started."));
            return;
        }
        $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_pendingDependencies, this).forEach((depdendency)=>depdendency.abort());
        this._resetState();
    }
    _end(success, cause, identifier) {
        const startTime = $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_startTime, this);
        if (typeof startTime !== 'number') {
            console.warn("[".concat(this.task, "] noop: Attempted to \"end\" a task which wasn't started."));
            return;
        }
        const duration = performance.now() - startTime;
        /* Metal doesn't provide an option to pass error identifier.
     * So, utilising taskId as a error identifier */ $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_onCompleteListeners, this).forEach((listener)=>listener({
                task: this.task,
                taskId: identifier,
                success: success,
                cause: cause,
                duration: duration
            }));
        this._resetState();
        return this;
    }
    _resetState() {
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_startTime, this, null);
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_pendingDependencies, this, []);
        return this;
    }
    dependsOn(dependencies) {
        const hasNestedDependencies = dependencies.some((dependency)=>dependency.hasDependencies());
        if (hasNestedDependencies) throw new Error("[".concat(this.task, "] task may not depend on sub-tasks which themselves have other dependencies"));
        $b9d2c51a881f167c$var$_classPrivateFieldSet($b9d2c51a881f167c$var$_dependencies, this, [
            ...dependencies
        ]);
        $b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_dependencies, this).forEach((dependency)=>{
            dependency.addCompletionListener($b9d2c51a881f167c$var$_classPrivateFieldGet($b9d2c51a881f167c$var$_onDependencyCompleted, this));
        });
        return this;
    }
}

});

parcelRegister("ilgCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5a71545a2ea84cc$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
class $d5a71545a2ea84cc$export$2e2bcd8739ae039 {
    constructor(){
        (0, $5zQU9.default)(this, "resolve", ()=>{
        /* resolve undefined by default */ });
        (0, $5zQU9.default)(this, "reject", ()=>{
        /* reject with undefined by default */ });
        (0, $5zQU9.default)(this, "promise", new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        }));
        (0, $5zQU9.default)(this, "then", this.promise.then.bind(this.promise));
        (0, $5zQU9.default)(this, "catch", this.promise.catch.bind(this.promise));
    }
}

});

parcelRegister("MB7Ow", function(module, exports) {

$parcel$export(module.exports, "default", () => $0921481131df09da$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $94Bah = parcelRequire("94Bah");
function $0921481131df09da$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0921481131df09da$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0921481131df09da$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0921481131df09da$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $0921481131df09da$export$2e2bcd8739ae039 {
    constructor(){
        (0, $5zQU9.default)(this, "messages", []);
        (0, $5zQU9.default)(this, "subscriber", void 0);
    }
    emit(message) {
        this.messages.push($0921481131df09da$var$_objectSpread({
            id: (0, $94Bah.nanoid)()
        }, message));
        if (this.subscriber) this.processQueue();
    }
    setSubscriber(subscriber) {
        this.subscriber = subscriber;
        this.processQueue();
    }
    dequeueMessage(messageId) {
        this.messages = this.messages.filter((message)=>message.id !== messageId);
    }
    processQueue() {
        this.messages.forEach((message)=>{
            this.subscriber(message);
            this.dequeueMessage(message.id);
        });
    }
}

});
parcelRegister("94Bah", function(module, exports) {

$parcel$export(module.exports, "nanoid", () => $69b150f0899625f9$export$ac4959f4f1338dfc);

var $5AMK0 = parcelRequire("5AMK0");
let $69b150f0899625f9$export$4385e60b38654f68 = (bytes)=>crypto.getRandomValues(new Uint8Array(bytes));
let $69b150f0899625f9$export$a5cee9e955a615e5 = (alphabet, defaultSize, getRandom)=>{
    let mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1;
    let step = -~(1.6 * mask * defaultSize / alphabet.length);
    return (size = defaultSize)=>{
        let id = '';
        while(true){
            let bytes = getRandom(step);
            let j = step;
            while(j--){
                id += alphabet[bytes[j] & mask] || '';
                if (id.length === size) return id;
            }
        }
    };
};
let $69b150f0899625f9$export$62e99e5c9f473d7f = (alphabet, size = 21)=>$69b150f0899625f9$export$a5cee9e955a615e5(alphabet, size, $69b150f0899625f9$export$4385e60b38654f68);
let $69b150f0899625f9$export$ac4959f4f1338dfc = (size = 21)=>crypto.getRandomValues(new Uint8Array(size)).reduce((id, byte)=>{
        byte &= 63;
        if (byte < 36) id += byte.toString(36);
        else if (byte < 62) id += (byte - 26).toString(36).toUpperCase();
        else if (byte > 62) id += '-';
        else id += '_';
        return id;
    }, '');

});
parcelRegister("5AMK0", function(module, exports) {
let $41261f7b5bd1b133$export$2b646eea95309f00 = 'useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict';

});



parcelRegister("kCL8m", function(module, exports) {

$parcel$export(module.exports, "getNavigationTiming", () => $f03beb0b696c28bd$export$e413ff2bddb62bda);
$parcel$export(module.exports, "getNetworkRequestTimes", () => $f03beb0b696c28bd$export$b6d9d88295231c29);
$parcel$export(module.exports, "waitForFirstContentfulPaint", () => $f03beb0b696c28bd$export$78f1760dd462ea4a);
$parcel$export(module.exports, "waitForNoLongTasks", () => $f03beb0b696c28bd$export$1d86caac13391b1c);
$parcel$export(module.exports, "waitForNoDOMMutations", () => $f03beb0b696c28bd$export$bd525458204149d0);
$parcel$export(module.exports, "waitForTimeToInteractive", () => $f03beb0b696c28bd$export$8d11ab137fc90ae1);
$parcel$export(module.exports, "PageVisibilityObserver", () => $f03beb0b696c28bd$export$e1e90d5d8290b834);

var $5zQU9 = parcelRequire("5zQU9");

var $66CK0 = parcelRequire("66CK0");

var $isJAq = parcelRequire("isJAq");
function $f03beb0b696c28bd$export$e413ff2bddb62bda() {
    var _performance, _performance$timing;
    if (typeof ((_performance = performance) === null || _performance === void 0 ? void 0 : (_performance$timing = _performance.timing) === null || _performance$timing === void 0 ? void 0 : _performance$timing.responseStart) !== 'number') // when we're on the server, there's no appropriate value for this so we'll just default to 0.
    // none of the metrics collected here should be published when running on the server
    return {
        responseStart: 0,
        fetchStart: 0
    };
    // Performance Timing API has been deprecated and replaced with Navigation Timing Level 2,
    // but browsers like Firefox are populate quirky values when using this new API.
    // To simulate L2, values are normalized to start from the beginning of page load than epoch time
    return {
        responseStart: performance.timing.responseStart - performance.timing.navigationStart,
        fetchStart: performance.timing.fetchStart - performance.timing.navigationStart
    };
}
const $f03beb0b696c28bd$var$getFileExtension = (path)=>{
    const matches = path.match(/.+\.(\w+)$/);
    return matches === null || matches === void 0 ? void 0 : matches[1];
};
/**
 * The `initiatorType` property on the resource timing object indicates the type of
 * the source which initiated the resource load rather than type of resource being loaded.
 * While `initiatorType` provides a good approximation usually, for some cases this needs to
 * be normalized.
 * E.g. Image requests triggered from CSS files will have `initiatorType: css` instead of `img`.
 */ const $f03beb0b696c28bd$var$getResourceType = (resource)=>{
    const resourcePath = new URL(resource.name).pathname;
    const resourceFileExtension = $f03beb0b696c28bd$var$getFileExtension(resourcePath);
    // Files from https://marketplace.com/files/... are more likely
    // to be images than CSS assets if initiated from CSS
    if (resource.initiatorType === 'css' && resourcePath.startsWith('/files/')) return resourceFileExtension || 'img';
    if (resource.initiatorType === 'link' && resourceFileExtension) return resourceFileExtension;
    return resource.initiatorType;
};
function $f03beb0b696c28bd$export$b6d9d88295231c29(allowRegexes, denyRegexes) {
    const perfEntries = performance.getEntriesByType('resource');
    // 1. Filter all requests based on match criteria
    const matchedRequests = perfEntries.filter((entry)=>allowRegexes.some((regex)=>{
            var _entry$name$match;
            return (_entry$name$match = entry.name.match(regex)) === null || _entry$name$match === void 0 ? void 0 : _entry$name$match.length;
        })).filter((entry)=>denyRegexes.every((regex)=>{
            var _entry$name$match2;
            return !((_entry$name$match2 = entry.name.match(regex)) !== null && _entry$name$match2 !== void 0 && _entry$name$match2.length);
        })).map((entry)=>({
            type: $f03beb0b696c28bd$var$getResourceType(entry),
            name: entry.name,
            duration: entry.responseEnd - entry.startTime
        }));
    // 2. Sum up download times by resource type
    const requestTimeGroupedByType = matchedRequests.reduce((groupedByType, nextRequest)=>{
        if (nextRequest.type in groupedByType) groupedByType[nextRequest.type] += nextRequest.duration;
        else groupedByType[nextRequest.type] = nextRequest.duration;
        return groupedByType;
    }, {});
    // 3. Return sum of times as an array
    return Object.entries(requestTimeGroupedByType).map((_ref)=>{
        let [type, duration] = _ref;
        return {
            type: type,
            duration: duration
        };
    });
}
function $f03beb0b696c28bd$export$78f1760dd462ea4a() {
    return new Promise((resolve)=>{
        (0, $66CK0.getFCP)((_ref2)=>{
            let { value: value } = _ref2;
            return resolve(value);
        });
    });
}
function $f03beb0b696c28bd$export$1d86caac13391b1c() {
    let quiescenceFor = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2000;
    return new Promise((resolve)=>{
        let lastLongRunningTaskTime = null;
        const timer = new (0, $isJAq.default)(quiescenceFor, ()=>{
            observer.disconnect();
            resolve(lastLongRunningTaskTime);
        });
        timer.start();
        const callback = (list)=>{
            const perfEntries = list.getEntries();
            if (perfEntries.length) {
                const lastEntry = perfEntries[perfEntries.length - 1];
                lastLongRunningTaskTime = lastEntry.startTime + lastEntry.duration;
                timer.restart();
            }
        };
        const observer = new PerformanceObserver(callback);
        observer.observe({
            type: 'longtask',
            buffered: true
        });
    });
}
function $f03beb0b696c28bd$export$bd525458204149d0(rootNode) {
    let quiescenceFor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 2000;
    const mutationObserverConfig = {
        attributes: false,
        childList: true,
        subtree: true
    };
    return new Promise((resolve)=>{
        let lastMutationTime = null;
        const timer = new (0, $isJAq.default)(quiescenceFor, ()=>{
            observer.disconnect();
            resolve(lastMutationTime);
        });
        timer.start();
        const callback = ()=>{
            lastMutationTime = performance.now();
            timer.restart();
        };
        const observer = new MutationObserver(callback);
        observer.observe(rootNode, mutationObserverConfig);
    });
}
function $f03beb0b696c28bd$export$8d11ab137fc90ae1(rootNode) {
    return $f03beb0b696c28bd$export$78f1760dd462ea4a().then((FCPTimestamp)=>Promise.all([
            $f03beb0b696c28bd$export$1d86caac13391b1c(),
            $f03beb0b696c28bd$export$bd525458204149d0(rootNode)
        ]).then((_ref3)=>{
            let [mainTheadFreeTimestamp, DOMMutationFreeTimestamp] = _ref3;
            return Math.max(FCPTimestamp, mainTheadFreeTimestamp || 0, DOMMutationFreeTimestamp || 0);
        }));
}
class $f03beb0b696c28bd$export$e1e90d5d8290b834 {
    static start() {
        $f03beb0b696c28bd$export$e1e90d5d8290b834.hasDocumentBeenHidden = document.hidden;
        if (!$f03beb0b696c28bd$export$e1e90d5d8290b834.isObserving) {
            document.addEventListener('visibilitychange', $f03beb0b696c28bd$export$e1e90d5d8290b834.handleVisibilityChange, true);
            $f03beb0b696c28bd$export$e1e90d5d8290b834.isObserving = true;
        }
    }
    static handleVisibilityChange() {
        if (document.hidden) {
            $f03beb0b696c28bd$export$e1e90d5d8290b834.hasDocumentBeenHidden = true;
            document.removeEventListener('visibilitychange', $f03beb0b696c28bd$export$e1e90d5d8290b834.handleVisibilityChange, true);
        }
    }
}
(0, $5zQU9.default)($f03beb0b696c28bd$export$e1e90d5d8290b834, "isObserving", false);
(0, $5zQU9.default)($f03beb0b696c28bd$export$e1e90d5d8290b834, "hasDocumentBeenHidden", false);

});
parcelRegister("66CK0", function(module, exports) {

$parcel$export(module.exports, "getFCP", () => $47215ac651147e49$export$52489892712e8192);
$parcel$export(module.exports, "getCLS", () => $47215ac651147e49$export$fc6227831ee7c7);
$parcel$export(module.exports, "getFID", () => $47215ac651147e49$export$134ed2977d320dfd);
$parcel$export(module.exports, "getLCP", () => $47215ac651147e49$export$da982ced0ff8a670);
$parcel$export(module.exports, "getTTFB", () => $47215ac651147e49$export$6e8eea9a35032c92);
var $47215ac651147e49$var$e, $47215ac651147e49$var$t, $47215ac651147e49$var$n, $47215ac651147e49$var$i, $47215ac651147e49$var$r = function(e, t) {
    return {
        name: e,
        value: void 0 === t ? -1 : t,
        delta: 0,
        entries: [],
        id: "v2-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12)
    };
}, $47215ac651147e49$var$a = function(e, t) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(e)) {
            if ("first-input" === e && !("PerformanceEventTiming" in self)) return;
            var n = new PerformanceObserver(function(e) {
                return e.getEntries().map(t);
            });
            return n.observe({
                type: e,
                buffered: !0
            }), n;
        }
    } catch (e) {}
}, $47215ac651147e49$var$o = function(e, t) {
    var n = function n(i) {
        "pagehide" !== i.type && "hidden" !== document.visibilityState || (e(i), t && (removeEventListener("visibilitychange", n, !0), removeEventListener("pagehide", n, !0)));
    };
    addEventListener("visibilitychange", n, !0), addEventListener("pagehide", n, !0);
}, $47215ac651147e49$var$u = function(e) {
    addEventListener("pageshow", function(t) {
        t.persisted && e(t);
    }, !0);
}, $47215ac651147e49$var$c = function(e, t, n) {
    var i;
    return function(r) {
        t.value >= 0 && (r || n) && (t.delta = t.value - (i || 0), (t.delta || void 0 === i) && (i = t.value, e(t)));
    };
}, $47215ac651147e49$var$f = -1, $47215ac651147e49$var$s = function() {
    return "hidden" === document.visibilityState ? 0 : 1 / 0;
}, $47215ac651147e49$var$m = function() {
    $47215ac651147e49$var$o(function(e) {
        var t = e.timeStamp;
        $47215ac651147e49$var$f = t;
    }, !0);
}, $47215ac651147e49$var$v = function() {
    return $47215ac651147e49$var$f < 0 && ($47215ac651147e49$var$f = $47215ac651147e49$var$s(), $47215ac651147e49$var$m(), $47215ac651147e49$var$u(function() {
        setTimeout(function() {
            $47215ac651147e49$var$f = $47215ac651147e49$var$s(), $47215ac651147e49$var$m();
        }, 0);
    })), {
        get firstHiddenTime () {
            return $47215ac651147e49$var$f;
        }
    };
}, $47215ac651147e49$export$52489892712e8192 = function(e, t) {
    var n, i = $47215ac651147e49$var$v(), o = $47215ac651147e49$var$r("FCP"), f = function(e) {
        "first-contentful-paint" === e.name && (m && m.disconnect(), e.startTime < i.firstHiddenTime && (o.value = e.startTime, o.entries.push(e), n(!0)));
    }, s = window.performance && performance.getEntriesByName && performance.getEntriesByName("first-contentful-paint")[0], m = s ? null : $47215ac651147e49$var$a("paint", f);
    (s || m) && (n = $47215ac651147e49$var$c(e, o, t), s && f(s), $47215ac651147e49$var$u(function(i) {
        o = $47215ac651147e49$var$r("FCP"), n = $47215ac651147e49$var$c(e, o, t), requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                o.value = performance.now() - i.timeStamp, n(!0);
            });
        });
    }));
}, $47215ac651147e49$var$p = !1, $47215ac651147e49$var$l = -1, $47215ac651147e49$export$fc6227831ee7c7 = function(e, t) {
    $47215ac651147e49$var$p || ($47215ac651147e49$export$52489892712e8192(function(e) {
        $47215ac651147e49$var$l = e.value;
    }), $47215ac651147e49$var$p = !0);
    var n, i = function(t) {
        $47215ac651147e49$var$l > -1 && e(t);
    }, f = $47215ac651147e49$var$r("CLS", 0), s = 0, m = [], v = function(e) {
        if (!e.hadRecentInput) {
            var t = m[0], i = m[m.length - 1];
            s && e.startTime - i.startTime < 1e3 && e.startTime - t.startTime < 5e3 ? (s += e.value, m.push(e)) : (s = e.value, m = [
                e
            ]), s > f.value && (f.value = s, f.entries = m, n());
        }
    }, h = $47215ac651147e49$var$a("layout-shift", v);
    h && (n = $47215ac651147e49$var$c(i, f, t), $47215ac651147e49$var$o(function() {
        h.takeRecords().map(v), n(!0);
    }), $47215ac651147e49$var$u(function() {
        s = 0, $47215ac651147e49$var$l = -1, f = $47215ac651147e49$var$r("CLS", 0), n = $47215ac651147e49$var$c(i, f, t);
    }));
}, $47215ac651147e49$var$T = {
    passive: !0,
    capture: !0
}, $47215ac651147e49$var$y = new Date, $47215ac651147e49$var$g = function(i, r) {
    $47215ac651147e49$var$e || ($47215ac651147e49$var$e = r, $47215ac651147e49$var$t = i, $47215ac651147e49$var$n = new Date, $47215ac651147e49$var$w(removeEventListener), $47215ac651147e49$var$E());
}, $47215ac651147e49$var$E = function() {
    if ($47215ac651147e49$var$t >= 0 && $47215ac651147e49$var$t < $47215ac651147e49$var$n - $47215ac651147e49$var$y) {
        var r = {
            entryType: "first-input",
            name: $47215ac651147e49$var$e.type,
            target: $47215ac651147e49$var$e.target,
            cancelable: $47215ac651147e49$var$e.cancelable,
            startTime: $47215ac651147e49$var$e.timeStamp,
            processingStart: $47215ac651147e49$var$e.timeStamp + $47215ac651147e49$var$t
        };
        $47215ac651147e49$var$i.forEach(function(e) {
            e(r);
        }), $47215ac651147e49$var$i = [];
    }
}, $47215ac651147e49$var$S = function(e) {
    if (e.cancelable) {
        var t = (e.timeStamp > 1e12 ? new Date : performance.now()) - e.timeStamp;
        "pointerdown" == e.type ? function(e, t) {
            var n = function() {
                $47215ac651147e49$var$g(e, t), r();
            }, i = function() {
                r();
            }, r = function() {
                removeEventListener("pointerup", n, $47215ac651147e49$var$T), removeEventListener("pointercancel", i, $47215ac651147e49$var$T);
            };
            addEventListener("pointerup", n, $47215ac651147e49$var$T), addEventListener("pointercancel", i, $47215ac651147e49$var$T);
        }(t, e) : $47215ac651147e49$var$g(t, e);
    }
}, $47215ac651147e49$var$w = function(e) {
    [
        "mousedown",
        "keydown",
        "touchstart",
        "pointerdown"
    ].forEach(function(t) {
        return e(t, $47215ac651147e49$var$S, $47215ac651147e49$var$T);
    });
}, $47215ac651147e49$export$134ed2977d320dfd = function(n, f) {
    var s, m = $47215ac651147e49$var$v(), d = $47215ac651147e49$var$r("FID"), p = function(e) {
        e.startTime < m.firstHiddenTime && (d.value = e.processingStart - e.startTime, d.entries.push(e), s(!0));
    }, l = $47215ac651147e49$var$a("first-input", p);
    s = $47215ac651147e49$var$c(n, d, f), l && $47215ac651147e49$var$o(function() {
        l.takeRecords().map(p), l.disconnect();
    }, !0), l && $47215ac651147e49$var$u(function() {
        var a;
        d = $47215ac651147e49$var$r("FID"), s = $47215ac651147e49$var$c(n, d, f), $47215ac651147e49$var$i = [], $47215ac651147e49$var$t = -1, $47215ac651147e49$var$e = null, $47215ac651147e49$var$w(addEventListener), a = p, $47215ac651147e49$var$i.push(a), $47215ac651147e49$var$E();
    });
}, $47215ac651147e49$var$b = {}, $47215ac651147e49$export$da982ced0ff8a670 = function(e, t) {
    var n, i = $47215ac651147e49$var$v(), f = $47215ac651147e49$var$r("LCP"), s = function(e) {
        var t = e.startTime;
        t < i.firstHiddenTime && (f.value = t, f.entries.push(e), n());
    }, m = $47215ac651147e49$var$a("largest-contentful-paint", s);
    if (m) {
        n = $47215ac651147e49$var$c(e, f, t);
        var d = function() {
            $47215ac651147e49$var$b[f.id] || (m.takeRecords().map(s), m.disconnect(), $47215ac651147e49$var$b[f.id] = !0, n(!0));
        };
        [
            "keydown",
            "click"
        ].forEach(function(e) {
            addEventListener(e, d, {
                once: !0,
                capture: !0
            });
        }), $47215ac651147e49$var$o(d, !0), $47215ac651147e49$var$u(function(i) {
            f = $47215ac651147e49$var$r("LCP"), n = $47215ac651147e49$var$c(e, f, t), requestAnimationFrame(function() {
                requestAnimationFrame(function() {
                    f.value = performance.now() - i.timeStamp, $47215ac651147e49$var$b[f.id] = !0, n(!0);
                });
            });
        });
    }
}, $47215ac651147e49$export$6e8eea9a35032c92 = function(e) {
    var t, n = $47215ac651147e49$var$r("TTFB");
    t = function() {
        try {
            var t = performance.getEntriesByType("navigation")[0] || function() {
                var e = performance.timing, t = {
                    entryType: "navigation",
                    startTime: 0
                };
                for(var n in e)"navigationStart" !== n && "toJSON" !== n && (t[n] = Math.max(e[n] - e.navigationStart, 0));
                return t;
            }();
            if (n.value = n.delta = t.responseStart, n.value < 0 || n.value > performance.now()) return;
            n.entries = [
                t
            ], e(n);
        } catch (e) {}
    }, "complete" === document.readyState ? setTimeout(t, 0) : addEventListener("load", function() {
        return setTimeout(t, 0);
    });
};

});

parcelRegister("isJAq", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70e3410a186ec1e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
class $d70e3410a186ec1e$export$2e2bcd8739ae039 {
    constructor(duration, onEndCallback){
        (0, $5zQU9.default)(this, "duration", void 0);
        (0, $5zQU9.default)(this, "onExpire", void 0);
        (0, $5zQU9.default)(this, "timerID", void 0);
        this.duration = duration;
        this.onExpire = onEndCallback;
    }
    start() {
        if (this.timerID) clearTimeout(this.timerID);
        this.timerID = setTimeout(()=>{
            this.onExpire();
        }, this.duration);
    }
    restart() {
        this.start();
    }
    stop() {
        if (this.timerID) clearTimeout(this.timerID);
    }
}

});



parcelRegister("4fL5K", function(module, exports) {

$parcel$export(module.exports, "discoveryFacetsTaskName", () => $318d178ba33992d8$export$3a8eb4d94d5abd40);
$parcel$export(module.exports, "discoveryCollectionsTaskName", () => $318d178ba33992d8$export$1d21d04e724b0ea8);
$parcel$export(module.exports, "DiscoveryFacetsTask", () => $318d178ba33992d8$export$bd5e6f65f2096339);
$parcel$export(module.exports, "DiscoveryCollectionsTask", () => $318d178ba33992d8$export$293c4a6d0b0af62f);
$parcel$export(module.exports, "searchTaskName", () => $318d178ba33992d8$export$91794a5b17bc9a0d);
$parcel$export(module.exports, "SearchTask", () => $318d178ba33992d8$export$e2d2b3bbeec3756f);

var $fUOHe = parcelRequire("fUOHe");
const $318d178ba33992d8$export$3a8eb4d94d5abd40 = 'view-discovery-facets';
const $318d178ba33992d8$export$1d21d04e724b0ea8 = 'view-discovery-collections';
const $318d178ba33992d8$export$bd5e6f65f2096339 = (0, $fUOHe.default).createGenericTask($318d178ba33992d8$export$3a8eb4d94d5abd40);
const $318d178ba33992d8$export$293c4a6d0b0af62f = (0, $fUOHe.default).createGenericTask('view-discovery-collections');
const $318d178ba33992d8$export$91794a5b17bc9a0d = 'view-search-results';
const $318d178ba33992d8$export$e2d2b3bbeec3756f = (0, $fUOHe.default).createGenericTask($318d178ba33992d8$export$91794a5b17bc9a0d);

});

parcelRegister("iDEAo", function(module, exports) {

$parcel$export(module.exports, "generateSearchId", () => $d91b5a089d99586f$export$6ebf659764156c0a);
function $d91b5a089d99586f$export$6ebf659764156c0a() {
    return Number.parseInt(Math.random() * 1000000);
}

});

parcelRegister("8Hj3g", function(module, exports) {

$parcel$export(module.exports, "default", () => $65511e29407d312a$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");
function $65511e29407d312a$export$2e2bcd8739ae039(err) {
    return (0, $g5DHJ.List)([
        (0, $g5DHJ.Map)({
            message: err.message
        }) // Just one message for now, but let's make it accommodate for more
    ]);
}

});


parcelRegister("lXXS4", function(module, exports) {

$parcel$export(module.exports, "RETRIEVE_COLLECTIONS_DATA", () => $04207a034c181411$export$942792cae9ad0d6a);
$parcel$export(module.exports, "RECEIVE_COLLECTIONS_DATA", () => $04207a034c181411$export$91f4c473d4a33781);
$parcel$export(module.exports, "COLLECTIONS_DATA_ERROR", () => $04207a034c181411$export$cc0920bba7573856);
$parcel$export(module.exports, "RECEIVE_FACETS", () => $04207a034c181411$export$84c83b2dccce27d0);
$parcel$export(module.exports, "FACETS_DATA_ERROR", () => $04207a034c181411$export$5033f6e9d7ffa3d4);
$parcel$export(module.exports, "doRetrieveData", () => $04207a034c181411$export$f4c5762aa7c3f790);

var $fUOHe = parcelRequire("fUOHe");

var $g5DHJ = parcelRequire("g5DHJ");

var $bavaN = parcelRequire("bavaN");

var $iDEAo = parcelRequire("iDEAo");

var $8Hj3g = parcelRequire("8Hj3g");

var $3ONu7 = parcelRequire("3ONu7");

var $4fL5K = parcelRequire("4fL5K");
const $04207a034c181411$export$942792cae9ad0d6a = 'DISCOVER_RETRIEVE_COLLECTIONS_DATA';
const $04207a034c181411$export$91f4c473d4a33781 = 'DISCOVER_RECEIVE_COLLECTIONS_DATA';
const $04207a034c181411$export$cc0920bba7573856 = 'DISCOVER_COLLECTIONS_DATA_ERROR';
const $04207a034c181411$export$84c83b2dccce27d0 = 'DISCOVER_RECEIVE_FACETS';
const $04207a034c181411$export$5033f6e9d7ffa3d4 = 'DISCOVER_FACETS_DATA_ERROR';
function $04207a034c181411$var$retrieveCollectionsData() {
    return {
        type: $04207a034c181411$export$942792cae9ad0d6a
    };
}
function $04207a034c181411$var$receiveCollectionsData(_ref) {
    let { data: data } = _ref;
    return {
        type: $04207a034c181411$export$91f4c473d4a33781,
        data: data
    };
}
function $04207a034c181411$var$collectionsDataError(_ref2) {
    let { dataErrorMessages: dataErrorMessages } = _ref2;
    return {
        type: $04207a034c181411$export$cc0920bba7573856,
        dataErrorMessages: dataErrorMessages
    };
}
function $04207a034c181411$var$receiveFacets(_ref3) {
    let { facets: facets } = _ref3;
    return {
        type: $04207a034c181411$export$84c83b2dccce27d0,
        facets: facets
    };
}
function $04207a034c181411$var$facetsDataError(_ref4) {
    let { dataErrorMessages: dataErrorMessages } = _ref4;
    return {
        type: $04207a034c181411$export$5033f6e9d7ffa3d4,
        dataErrorMessages: dataErrorMessages
    };
}
const $04207a034c181411$var$doCollectionSearch = (_ref5)=>{
    let { algoliaClient: algoliaClient, collection: collection, environment: environment, filters: filters, applyOverrides: applyOverrides, featureFlags: featureFlags } = _ref5;
    return Promise.all(collection.get('resolveQueries')({
        filters: filters,
        applyOverrides: applyOverrides
    }).map((q)=>(0, $bavaN.search)({
            algoliaClient: algoliaClient,
            environment: environment,
            filters: q.get('filters'),
            numHits: collection.get('numResults'),
            applyOverrides: q.get('applyOverrides'),
            featureFlags: featureFlags
        }))).then((data)=>(0, $g5DHJ.Map)({
            hits: collection.get('resolveHits')({
                hits: (0, $g5DHJ.List)(data).map((d)=>d.getIn([
                        'searchResults',
                        'hits'
                    ]))
            }),
            searchId: (0, $iDEAo.generateSearchId)()
        }));
};
function $04207a034c181411$export$f4c5762aa7c3f790(_ref6) {
    let { algoliaClient: algoliaClient, environment: environment, filters: filters, applyOverrides: applyOverrides, resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides, discoverCollectionsConfig: discoverCollectionsConfig, featureFlags: featureFlags } = _ref6;
    return (dispatch)=>{
        dispatch($04207a034c181411$var$retrieveCollectionsData());
        (0, $4fL5K.DiscoveryFacetsTask).start();
        (0, $bavaN.search)({
            algoliaClient: algoliaClient,
            applyOverrides: applyOverrides,
            environment: environment,
            filters: filters,
            resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides,
            featureFlags: featureFlags
        }).then((data)=>{
            dispatch($04207a034c181411$var$receiveFacets({
                facets: data.get('facets')
            }));
            (0, $4fL5K.DiscoveryFacetsTask).succeeded();
        }, (error)=>{
            if (error.debugData) {
                console.error('Search error, debug data:', error.debugData);
                console.error(error.debugData);
            }
            const dataErrorMessages = (0, $8Hj3g.default)(error);
            dispatch($04207a034c181411$var$facetsDataError({
                dataErrorMessages: dataErrorMessages
            }));
            (0, $fUOHe.default).setUFOInteractionError({
                name: (0, $4fL5K.discoveryFacetsTaskName),
                errorMessage: error === null || error === void 0 ? void 0 : error.message
            });
            (0, $4fL5K.DiscoveryFacetsTask).failed(error);
        });
        (0, $4fL5K.DiscoveryCollectionsTask).start();
        Promise.all(discoverCollectionsConfig.get(filters.get('product', (0, $3ONu7.HOME))).map((collection)=>$04207a034c181411$var$doCollectionSearch({
                algoliaClient: algoliaClient,
                collection: collection,
                environment: environment,
                filters: filters,
                applyOverrides: applyOverrides,
                featureFlags: featureFlags
            }).then((data)=>(0, $g5DHJ.Map)({
                    key: collection.get('key'),
                    data: data
                }))).toJS()).then((data)=>{
            dispatch($04207a034c181411$var$receiveCollectionsData({
                data: (0, $g5DHJ.List)(data).reduce((acc, d)=>acc.set(d.get('key'), d.get('data')), (0, $g5DHJ.Map)())
            }));
            (0, $4fL5K.DiscoveryCollectionsTask).succeeded();
        }, (error)=>{
            if (error.debugData) {
                console.error('Search error, debug data: ');
                console.error(error.debugData);
            }
            const dataErrorMessages = (0, $8Hj3g.default)(error);
            dispatch($04207a034c181411$var$collectionsDataError({
                dataErrorMessages: dataErrorMessages
            }));
            (0, $fUOHe.default).setUFOInteractionError({
                name: (0, $4fL5K.discoveryCollectionsTaskName),
                errorMessage: error === null || error === void 0 ? void 0 : error.message
            });
            (0, $4fL5K.DiscoveryCollectionsTask).failed(error);
        });
    };
}

});

parcelRegister("f7sBl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b01db2164004985a$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $hvUUg = parcelRequire("hvUUg");

var $9osuT = parcelRequire("9osuT");

var $biTOe = parcelRequire("biTOe");

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $44zkz = parcelRequire("44zkz");

var $90ON9 = parcelRequire("90ON9");

var $72e1Y = parcelRequire("72e1Y");


var $6jEcw = parcelRequire("6jEcw");

var $b2B2X = parcelRequire("b2B2X");

var $goyDl = parcelRequire("goyDl");

var $4xjZQ = parcelRequire("4xjZQ");

var $aobPH = parcelRequire("aobPH");

var $8VJ2L = parcelRequire("8VJ2L");

var $kT6nf = parcelRequire("kT6nf");

var $64h1R = parcelRequire("64h1R");

var $6pYzn = parcelRequire("6pYzn");

var $cAD4n = parcelRequire("cAD4n");

var $8xLRx = parcelRequire("8xLRx");

var $lHkHI = parcelRequire("lHkHI");
const $b01db2164004985a$export$e5ed71f9f4bebfab = (0, $3UXZ8.default)("div", {
    target: "elevy7a0",
    label: "AddonDiscoveryContainer"
})((0, $hvUUg.baseStylesCss), " min-height:100px;");
class $b01db2164004985a$var$AddonDiscovery extends (0, $eUqFw.Component) {
    UNSAFE_componentWillReceiveProps(newProps) {
        if (this.props.perspective !== newProps.perspective) this.props.onPerspectiveChange();
        (0, $goyDl.trackTileRenders)(this.props, newProps);
    }
    resolvePerspectiveData(_ref) {
        let { filters: filters } = _ref;
        switch(this.props.perspective){
            case 0, $37a31921fd56c86d$export$27b2e48e28163360:
                return {
                    component: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6pYzn.default), {
                        colSpan: this.props.colSpan,
                        discover: this.props.discover,
                        discoverCollectionsConfig: this.props.discoverCollectionsConfig,
                        featuredContentOverride: this.props.featuredContentOverride,
                        filters: filters,
                        filtersContext: this.props.filtersContext,
                        hitContext: this.props.hitContext,
                        onCollectionHitCategoryClick: this.props.onHitCategoryClick,
                        retrieveDiscoverData: this.props.discoverActions.get('retrieveDiscoverData'),
                        screenClass: this.props.screenClass,
                        stateChangeRequested: this.props.stateChangeRequested,
                        topPanel: this.props.topPanel,
                        transitions: this.props.transitions,
                        overrideLargeHitRightContent: this.props.overrideLargeHitRightContent
                    }),
                    filtersLink: (0, $8VJ2L.default),
                    itemFactory: (0, $4xjZQ.default),
                    resolveHeadingText: this.props.hideHeading || this.props.heroComponent ? undefined : (0, $b2B2X.resolveDiscoverHeadingText)
                };
            case 0, $37a31921fd56c86d$export$a6b9aaee40d49fd0:
                return {
                    component: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8xLRx.default), {
                        colSpan: this.props.colSpan,
                        doFreshSearch: this.props.searchActions.get('doFreshSearch'),
                        contentOverrides: this.props.featuredContentOverride,
                        filters: filters,
                        hiddenFilters: this.props.hiddenFilters,
                        hitContext: this.props.hitContext,
                        onHitCategoryClick: this.props.onHitCategoryClick,
                        onLoadMoreResultsClick: this.props.onLoadMoreResultsClick,
                        screenClass: this.props.screenClass,
                        search: this.props.search,
                        stateChangeRequested: this.props.stateChangeRequested,
                        topPanel: this.props.topPanel,
                        transitions: this.props.transitions,
                        overrideLargeHitRightContent: this.props.overrideLargeHitRightContent,
                        showBrowseHeading: this.props.showBrowseHeading
                    }),
                    filtersLink: (0, $kT6nf.default),
                    itemFactory: (0, $aobPH.default),
                    resolveHeadingText: this.props.hideHeading ? undefined : (0, $b2B2X.resolveSearchHeadingText)
                };
            default:
                console.error('Invalid perspective specified - unable to render');
                return {
                    component: undefined,
                    filtersLink: undefined,
                    itemFactory: undefined
                };
        }
    }
    render() {
        const filters = (0, $72e1Y.default)(this.props.filters, {});
        const { component: component, filtersLink: filtersLink, itemFactory: itemFactory, resolveHeadingText: resolveHeadingText } = this.resolvePerspectiveData({
            filters: filters
        });
        return /*#__PURE__*/ (0, $lHkHI.jsx)($b01db2164004985a$export$e5ed71f9f4bebfab, {
            className: this.props.className,
            children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $44zkz.default), {
                filters: filters,
                children: [
                    this.props.heroComponent ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cAD4n.default), {
                        filters: filters,
                        heroComponent: this.props.heroComponent,
                        perspective: this.props.perspective,
                        stateChangeRequested: this.props.stateChangeRequested
                    }) : undefined,
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $64h1R.default), {
                        className: this.props.containerClassName,
                        dataError: this.props.searchContainer.get('dataError'),
                        dataErrorMessages: this.props.searchContainer.get('dataErrorMessages'),
                        externalFacets: this.props.externalFacets,
                        facets: this.props.searchContainer.get('facets'),
                        filtersContext: this.props.filtersContext,
                        filters: filters,
                        filtersLink: filtersLink,
                        displayTextSearch: !this.props.hideTextSearch,
                        hiddenFilters: this.props.hiddenFilters,
                        initialized: this.props.searchContainer.get('initialized'),
                        itemFactory: itemFactory,
                        perspective: this.props.perspective,
                        resolveHeadingText: resolveHeadingText,
                        screenClass: this.props.screenClass,
                        stateChangeRequested: this.props.stateChangeRequested,
                        discoverHeading: this.props.discoverHeading,
                        children: [
                            this.props.recommendationsPanel,
                            /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                                className: this.props.perspective ? "ui-perspective-".concat(this.props.perspective) : undefined,
                                children: component
                            })
                        ]
                    })
                ]
            })
        });
    }
}
(0, $5zQU9.default)($b01db2164004985a$var$AddonDiscovery, "propTypes", {
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    colSpan: (0, $90ON9.default).colSpan.isRequired,
    containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    discover: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
    discoverActions: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        retrieveDiscoverData: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
    }).isRequired,
    discoverCollectionsConfig: (0, $90ON9.default).discoverCollectionsConfig.isRequired,
    externalFacets: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    featuredContentOverride: (0, $90ON9.default).contentOverrides,
    filters: (0, $90ON9.default).unenhancedFilters.isRequired,
    filtersContext: (0, $6jEcw.default).filtersContext.isRequired,
    heroComponent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    hiddenFilters: (0, $6jEcw.default).hiddenFilters.isRequired,
    hideHeading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    hitContext: (0, $90ON9.default).hitContext.isRequired,
    hideTextSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    onHitCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    onLoadMoreResultsClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    onPerspectiveChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    fireAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    perspective: (0, $6jEcw.default).perspective,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    search: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
    searchActions: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        doFreshSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
    }).isRequired,
    searchContainer: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        facets: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list,
        initialized: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired
    }).isRequired,
    discoverHeading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    topPanel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    recommendationsPanel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    transitions: (0, $90ON9.default).transitions,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    overrideLargeHitRightContent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    showBrowseHeading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    enableBugBountyProgram: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool
});
var $b01db2164004985a$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)((0, $biTOe.withFeatureFlags)($b01db2164004985a$var$AddonDiscovery));

});
parcelRegister("3UXZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $2da521dca9c97a7c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $rDBG3 = parcelRequire("rDBG3");

var $ibjku = parcelRequire("ibjku");

var $k0tcF = parcelRequire("k0tcF");

var $1FjgH = parcelRequire("1FjgH");
var $2da521dca9c97a7c$var$testOmitPropsOnStringTag = (0, $rDBG3.default);
var $2da521dca9c97a7c$var$testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
    return key !== 'theme' && key !== 'innerRef';
};
var $2da521dca9c97a7c$var$getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
    return typeof tag === 'string' && // 96 is one less than the char code
    // for "a" so this is checking that
    // it's a lowercase character
    tag.charCodeAt(0) > 96 ? $2da521dca9c97a7c$var$testOmitPropsOnStringTag : $2da521dca9c97a7c$var$testOmitPropsOnComponent;
};
function $2da521dca9c97a7c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2da521dca9c97a7c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $2da521dca9c97a7c$var$ownKeys(Object(source), true).forEach(function(key) {
            (0, $5zQU9.default)(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $2da521dca9c97a7c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
var $2da521dca9c97a7c$var$ILLEGAL_ESCAPE_SEQUENCE_ERROR = "You have illegal escape sequence in your template literal, most likely inside content's property value.\nBecause you write your CSS inside a JavaScript string you actually have to do double escaping, so for example \"content: '\\00d7';\" should become \"content: '\\\\00d7';\".\nYou can read more about this here:\nhttps://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Template_literals#ES2018_revision_of_illegal_escape_sequences";
var $2da521dca9c97a7c$var$Noop = function Noop() {
    return null;
};
var $2da521dca9c97a7c$var$createStyled = function createStyled(tag, options) {
    var identifierName;
    var shouldForwardProp;
    var targetClassName;
    if (options !== undefined) {
        identifierName = options.label;
        targetClassName = options.target;
        shouldForwardProp = tag.__emotion_forwardProp && options.shouldForwardProp ? function(propName) {
            return tag.__emotion_forwardProp(propName) && // $FlowFixMe
            options.shouldForwardProp(propName);
        } : options.shouldForwardProp;
    }
    var isReal = tag.__emotion_real === tag;
    var baseTag = isReal && tag.__emotion_base || tag;
    if (typeof shouldForwardProp !== 'function' && isReal) shouldForwardProp = tag.__emotion_forwardProp;
    var defaultShouldForwardProp = shouldForwardProp || $2da521dca9c97a7c$var$getDefaultShouldForwardProp(baseTag);
    var shouldUseAs = !defaultShouldForwardProp('as');
    return function() {
        var args = arguments;
        var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];
        if (identifierName !== undefined) styles.push("label:" + identifierName + ";");
        if (args[0] == null || args[0].raw === undefined) styles.push.apply(styles, args);
        else {
            styles.push(args[0][0]);
            var len = args.length;
            var i = 1;
            for(; i < len; i++)styles.push(args[i], args[0][i]);
        } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class
        var Styled = (0, $ibjku.withEmotionCache)(function(props, context, ref) {
            return /*#__PURE__*/ (0, $eUqFw.createElement)((0, $ibjku.ThemeContext).Consumer, null, function(theme) {
                var finalTag = shouldUseAs && props.as || baseTag;
                var className = '';
                var classInterpolations = [];
                var mergedProps = props;
                if (props.theme == null) {
                    mergedProps = {};
                    for(var key in props)mergedProps[key] = props[key];
                    mergedProps.theme = theme;
                }
                if (typeof props.className === 'string') className = (0, $k0tcF.getRegisteredStyles)(context.registered, classInterpolations, props.className);
                else if (props.className != null) className = props.className + " ";
                var serialized = (0, $1FjgH.serializeStyles)(styles.concat(classInterpolations), context.registered, mergedProps);
                var rules = (0, $k0tcF.insertStyles)(context, serialized, typeof finalTag === 'string');
                className += context.key + "-" + serialized.name;
                if (targetClassName !== undefined) className += " " + targetClassName;
                var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? $2da521dca9c97a7c$var$getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
                var newProps = {};
                for(var _key in props){
                    if (shouldUseAs && _key === 'as') continue;
                    if (finalShouldForwardProp(_key)) newProps[_key] = props[_key];
                }
                newProps.className = className;
                newProps.ref = ref || props.innerRef;
                var ele = /*#__PURE__*/ (0, $eUqFw.createElement)(finalTag, newProps);
                var possiblyStyleElement = /*#__PURE__*/ (0, $eUqFw.createElement)($2da521dca9c97a7c$var$Noop, null);
                return /*#__PURE__*/ (0, $eUqFw.createElement)((0, $eUqFw.Fragment), null, possiblyStyleElement, ele);
            });
        });
        Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
        Styled.defaultProps = tag.defaultProps;
        Styled.__emotion_real = Styled;
        Styled.__emotion_base = baseTag;
        Styled.__emotion_styles = styles;
        Styled.__emotion_forwardProp = shouldForwardProp;
        Object.defineProperty(Styled, 'toString', {
            value: function value() {
                return "." + targetClassName;
            }
        });
        Styled.withComponent = function(nextTag, nextOptions) {
            return createStyled(nextTag, nextOptions !== undefined ? $2da521dca9c97a7c$var$_objectSpread({}, options || {}, {}, nextOptions) : options).apply(void 0, styles);
        };
        return Styled;
    };
};
var $2da521dca9c97a7c$export$2e2bcd8739ae039 = $2da521dca9c97a7c$var$createStyled;

});
parcelRegister("rDBG3", function(module, exports) {

$parcel$export(module.exports, "default", () => $05313ecbd5cc202f$export$2e2bcd8739ae039);

var $jCqUa = parcelRequire("jCqUa");
var $05313ecbd5cc202f$var$reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|inert|itemProp|itemScope|itemType|itemID|itemRef|on|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23
var $05313ecbd5cc202f$var$index = (0, $jCqUa.default)(function(prop) {
    return $05313ecbd5cc202f$var$reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111 && prop.charCodeAt(1) === 110 && prop.charCodeAt(2) < 91;
});
var $05313ecbd5cc202f$export$2e2bcd8739ae039 = $05313ecbd5cc202f$var$index;

});


parcelRegister("hvUUg", function(module, exports) {

$parcel$export(module.exports, "baseStylesCss", () => $cc01795616bab096$export$c1b112a4bc2bf8b2);
$parcel$export(module.exports, "baseMediumFontSize", () => $cc01795616bab096$export$8b11cc0b368dc9df);
$parcel$export(module.exports, "baseLineHeight", () => $cc01795616bab096$export$535730c89dd84be3);
$parcel$export(module.exports, "CharlieFontFamily", () => $cc01795616bab096$export$f611bc8c56762dcf);
$parcel$export(module.exports, "BoldText", () => $cc01795616bab096$export$d8a8e2cd87eed68c);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");
var $ivTMz = parcelRequire("ivTMz");

var $ibjku = parcelRequire("ibjku");
function $cc01795616bab096$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cc01795616bab096$export$c1b112a4bc2bf8b2 = /*#__PURE__*/ (0, $ibjku.css)("color:", "var(--ds-text, ".concat((0, $j0gMm).N800, ")"), ";font-family:", (0, $ivTMz.fontFamily)(), ";font-size:", (0, $ivTMz.fontSize)() + 'px', ";;label:baseStylesCss;");
const $cc01795616bab096$export$8b11cc0b368dc9df = {
    name: "1rgsehg-baseMediumFontSize",
    styles: "font-size:16px;;label:baseMediumFontSize;"
};
const $cc01795616bab096$export$535730c89dd84be3 = {
    name: "nf0vu6-baseLineHeight",
    styles: "line-height:24px;;label:baseLineHeight;"
};
const $cc01795616bab096$export$e8b14c4827b02e0d = /*#__PURE__*/ (0, $ibjku.css)("a{color:", "var(--ds-link, ".concat((0, $j0gMm).B400, ")"), ";text-decoration:none;cursor:pointer;&:active,&:hover{outline:0;text-decoration:underline;}};label:baseAnchorStylesCss;");
const $cc01795616bab096$export$f611bc8c56762dcf = /*#__PURE__*/ (0, $ibjku.css)("font-family:'Charlie Display',", (0, $ivTMz.fontFamily)(), ";;label:CharlieFontFamily;");
const $cc01795616bab096$export$d8a8e2cd87eed68c = (0, $3UXZ8.default)("b", {
    target: "e11879yo0",
    label: "BoldText"
})({
    name: "35ezg3",
    styles: "font-weight:600;"
});
var $cc01795616bab096$export$2e2bcd8739ae039 = (0, $3UXZ8.default)("div", {
    target: "e11879yo1"
})($cc01795616bab096$export$c1b112a4bc2bf8b2, "");

});
parcelRegister("j0gMm", function(module, exports) {

$parcel$export(module.exports, "R50", () => $dd5b085d4e6867fb$export$4b84fd0e2c617bd);
$parcel$export(module.exports, "R75", () => $dd5b085d4e6867fb$export$b34b069eff244586);
$parcel$export(module.exports, "R100", () => $dd5b085d4e6867fb$export$be802dd0d8b57f35);
$parcel$export(module.exports, "R200", () => $dd5b085d4e6867fb$export$60847d42f9da92a6);
$parcel$export(module.exports, "R300", () => $dd5b085d4e6867fb$export$4a7404f376229999);
$parcel$export(module.exports, "R400", () => $dd5b085d4e6867fb$export$2010d0fb4295b346);
$parcel$export(module.exports, "R500", () => $dd5b085d4e6867fb$export$2837b5a1a71d5c02);
$parcel$export(module.exports, "Y50", () => $dd5b085d4e6867fb$export$8d9596b529bbb9cf);
$parcel$export(module.exports, "Y75", () => $dd5b085d4e6867fb$export$41060a744ab0b7ae);
$parcel$export(module.exports, "Y100", () => $dd5b085d4e6867fb$export$1cc05bbbf340e559);
$parcel$export(module.exports, "Y200", () => $dd5b085d4e6867fb$export$5aae31392d72caaa);
$parcel$export(module.exports, "Y300", () => $dd5b085d4e6867fb$export$c6930421db9fa514);
$parcel$export(module.exports, "Y400", () => $dd5b085d4e6867fb$export$59619663aa6500fb);
$parcel$export(module.exports, "Y500", () => $dd5b085d4e6867fb$export$874739ea9e379ab6);
$parcel$export(module.exports, "G50", () => $dd5b085d4e6867fb$export$8a6341c32b6a3ee6);
$parcel$export(module.exports, "G75", () => $dd5b085d4e6867fb$export$69a3bf21b9686c2b);
$parcel$export(module.exports, "G100", () => $dd5b085d4e6867fb$export$afbce1382ec95f73);
$parcel$export(module.exports, "G200", () => $dd5b085d4e6867fb$export$747d86715d4175de);
$parcel$export(module.exports, "G300", () => $dd5b085d4e6867fb$export$940e1f69e873f202);
$parcel$export(module.exports, "G400", () => $dd5b085d4e6867fb$export$a49394138f7b8e85);
$parcel$export(module.exports, "G500", () => $dd5b085d4e6867fb$export$6fa04827ac68a4fb);
$parcel$export(module.exports, "B50", () => $dd5b085d4e6867fb$export$226de0355ed012f8);
$parcel$export(module.exports, "B75", () => $dd5b085d4e6867fb$export$8c13c2ee36917869);
$parcel$export(module.exports, "B100", () => $dd5b085d4e6867fb$export$ecfc1dff386a3e7a);
$parcel$export(module.exports, "B200", () => $dd5b085d4e6867fb$export$215b7063051591f1);
$parcel$export(module.exports, "B300", () => $dd5b085d4e6867fb$export$e62e8919cca44969);
$parcel$export(module.exports, "B400", () => $dd5b085d4e6867fb$export$b3de0ae08da2ce64);
$parcel$export(module.exports, "B500", () => $dd5b085d4e6867fb$export$a6ee3d71bc067634);
$parcel$export(module.exports, "P50", () => $dd5b085d4e6867fb$export$363e4475840015bb);
$parcel$export(module.exports, "P75", () => $dd5b085d4e6867fb$export$4b0a4417ed59760f);
$parcel$export(module.exports, "P100", () => $dd5b085d4e6867fb$export$6011520a64d9a187);
$parcel$export(module.exports, "P200", () => $dd5b085d4e6867fb$export$a7175d4e9206bc80);
$parcel$export(module.exports, "P300", () => $dd5b085d4e6867fb$export$b48405b95304b5a1);
$parcel$export(module.exports, "P400", () => $dd5b085d4e6867fb$export$c71e4279dd54a18d);
$parcel$export(module.exports, "P500", () => $dd5b085d4e6867fb$export$147899de772240ec);
$parcel$export(module.exports, "T50", () => $dd5b085d4e6867fb$export$2cf711fe14c66f06);
$parcel$export(module.exports, "T75", () => $dd5b085d4e6867fb$export$7a8f4d33f6f9772c);
$parcel$export(module.exports, "T100", () => $dd5b085d4e6867fb$export$776c9c497ef08533);
$parcel$export(module.exports, "T200", () => $dd5b085d4e6867fb$export$69cb3ca10c1e330e);
$parcel$export(module.exports, "T300", () => $dd5b085d4e6867fb$export$9dc1ef0f3f48059b);
$parcel$export(module.exports, "T400", () => $dd5b085d4e6867fb$export$7c835c78b6fcdef8);
$parcel$export(module.exports, "T500", () => $dd5b085d4e6867fb$export$6036577f95c3877e);
$parcel$export(module.exports, "N0", () => $dd5b085d4e6867fb$export$29a4f05edc054374);
$parcel$export(module.exports, "N10", () => $dd5b085d4e6867fb$export$e655ef011c4aa1a2);
$parcel$export(module.exports, "N20", () => $dd5b085d4e6867fb$export$9fdfb749e33cdf97);
$parcel$export(module.exports, "N30", () => $dd5b085d4e6867fb$export$3e51e8f1440314ba);
$parcel$export(module.exports, "N40", () => $dd5b085d4e6867fb$export$1ce2d1575d444ceb);
$parcel$export(module.exports, "N50", () => $dd5b085d4e6867fb$export$8754fc7e6d8b3000);
$parcel$export(module.exports, "N60", () => $dd5b085d4e6867fb$export$c2e91cbeada39b8b);
$parcel$export(module.exports, "N70", () => $dd5b085d4e6867fb$export$5f71e19f3a7ad9de);
$parcel$export(module.exports, "N80", () => $dd5b085d4e6867fb$export$eaa8c8a70ac22806);
$parcel$export(module.exports, "N90", () => $dd5b085d4e6867fb$export$7c87d337fb91a97d);
$parcel$export(module.exports, "N100", () => $dd5b085d4e6867fb$export$d6447c357493214f);
$parcel$export(module.exports, "N200", () => $dd5b085d4e6867fb$export$f563ee71e9ee74cd);
$parcel$export(module.exports, "N300", () => $dd5b085d4e6867fb$export$e2ef2124cf4024b1);
$parcel$export(module.exports, "N400", () => $dd5b085d4e6867fb$export$eece5f492e429f08);
$parcel$export(module.exports, "N500", () => $dd5b085d4e6867fb$export$c39c0fe0f26207ae);
$parcel$export(module.exports, "N600", () => $dd5b085d4e6867fb$export$7090862dc3038a9f);
$parcel$export(module.exports, "N700", () => $dd5b085d4e6867fb$export$ad0bacf983b7ddaa);
$parcel$export(module.exports, "N800", () => $dd5b085d4e6867fb$export$7d61b15e0da132af);
$parcel$export(module.exports, "N900", () => $dd5b085d4e6867fb$export$fbda843f0a27fe96);
$parcel$export(module.exports, "N10A", () => $dd5b085d4e6867fb$export$791e57b27ca738ef);
$parcel$export(module.exports, "N20A", () => $dd5b085d4e6867fb$export$8d43898f60b96a82);
$parcel$export(module.exports, "N30A", () => $dd5b085d4e6867fb$export$920c0d5c49070351);
$parcel$export(module.exports, "N40A", () => $dd5b085d4e6867fb$export$46987b49aab6d1a8);
$parcel$export(module.exports, "N50A", () => $dd5b085d4e6867fb$export$7d3359664e8bb0e5);
$parcel$export(module.exports, "N60A", () => $dd5b085d4e6867fb$export$d2d3bedfb276cac0);
$parcel$export(module.exports, "N70A", () => $dd5b085d4e6867fb$export$6e5e7499ff054f6d);
$parcel$export(module.exports, "N80A", () => $dd5b085d4e6867fb$export$59264b346c877fa7);
$parcel$export(module.exports, "N90A", () => $dd5b085d4e6867fb$export$d092757d7c64925c);
$parcel$export(module.exports, "N100A", () => $dd5b085d4e6867fb$export$486ab785e4bac3c6);
$parcel$export(module.exports, "N200A", () => $dd5b085d4e6867fb$export$fba592bbc6419fea);
$parcel$export(module.exports, "N300A", () => $dd5b085d4e6867fb$export$13609db0e6812ab8);
$parcel$export(module.exports, "N400A", () => $dd5b085d4e6867fb$export$fbae4efaa892d883);
$parcel$export(module.exports, "N500A", () => $dd5b085d4e6867fb$export$f13946d26f440ce6);
$parcel$export(module.exports, "N600A", () => $dd5b085d4e6867fb$export$19f58225ac52a306);
$parcel$export(module.exports, "N700A", () => $dd5b085d4e6867fb$export$6384f09da70e7b62);
$parcel$export(module.exports, "N800A", () => $dd5b085d4e6867fb$export$d0dccc730683edc2);
$parcel$export(module.exports, "DN900", () => $dd5b085d4e6867fb$export$2f6319cf7d736c2a);
$parcel$export(module.exports, "DN800", () => $dd5b085d4e6867fb$export$95126bc8884d6634);
$parcel$export(module.exports, "DN700", () => $dd5b085d4e6867fb$export$8338d8c35d44ff1);
$parcel$export(module.exports, "DN600", () => $dd5b085d4e6867fb$export$5368d76ae4fbbda7);
$parcel$export(module.exports, "DN500", () => $dd5b085d4e6867fb$export$9f0a771d16ec8d36);
$parcel$export(module.exports, "DN400", () => $dd5b085d4e6867fb$export$abcf8c38338b4aa5);
$parcel$export(module.exports, "DN300", () => $dd5b085d4e6867fb$export$97e81faa16a182c7);
$parcel$export(module.exports, "DN200", () => $dd5b085d4e6867fb$export$bfe21c59123ecf33);
$parcel$export(module.exports, "DN100", () => $dd5b085d4e6867fb$export$ee82aa2ea6a1558);
$parcel$export(module.exports, "DN90", () => $dd5b085d4e6867fb$export$682927c6ed76be02);
$parcel$export(module.exports, "DN80", () => $dd5b085d4e6867fb$export$91fd9994c5be9757);
$parcel$export(module.exports, "DN70", () => $dd5b085d4e6867fb$export$d281fbfe3cff2df6);
$parcel$export(module.exports, "DN60", () => $dd5b085d4e6867fb$export$3902c91d8b98a753);
$parcel$export(module.exports, "DN50", () => $dd5b085d4e6867fb$export$8e8133c1ba5845b5);
$parcel$export(module.exports, "DN40", () => $dd5b085d4e6867fb$export$33ff357f6620b39);
$parcel$export(module.exports, "DN30", () => $dd5b085d4e6867fb$export$633847cf062b69e0);
$parcel$export(module.exports, "DN20", () => $dd5b085d4e6867fb$export$9776a6e503bdbf76);
$parcel$export(module.exports, "DN10", () => $dd5b085d4e6867fb$export$6c813d5160dff5db);
$parcel$export(module.exports, "DN0", () => $dd5b085d4e6867fb$export$3d4f271a500072a);
$parcel$export(module.exports, "DN800A", () => $dd5b085d4e6867fb$export$fe151285c22759ec);
$parcel$export(module.exports, "DN700A", () => $dd5b085d4e6867fb$export$a101c6190d0da34);
$parcel$export(module.exports, "DN600A", () => $dd5b085d4e6867fb$export$4b16f52932fda51);
$parcel$export(module.exports, "DN500A", () => $dd5b085d4e6867fb$export$a74bcd7b9845b0d8);
$parcel$export(module.exports, "DN400A", () => $dd5b085d4e6867fb$export$9209c179316d1751);
$parcel$export(module.exports, "DN300A", () => $dd5b085d4e6867fb$export$88f55133f636c8dd);
$parcel$export(module.exports, "DN200A", () => $dd5b085d4e6867fb$export$51126f85d1009512);
$parcel$export(module.exports, "DN100A", () => $dd5b085d4e6867fb$export$a069b547bd23af78);
$parcel$export(module.exports, "DN90A", () => $dd5b085d4e6867fb$export$40cce05af3b2600a);
$parcel$export(module.exports, "DN80A", () => $dd5b085d4e6867fb$export$b78942185925a0d);
$parcel$export(module.exports, "DN70A", () => $dd5b085d4e6867fb$export$e058fb44b8eaafca);
$parcel$export(module.exports, "DN60A", () => $dd5b085d4e6867fb$export$92b0b8de26920c18);
$parcel$export(module.exports, "DN50A", () => $dd5b085d4e6867fb$export$67564f7459d3fc9e);
$parcel$export(module.exports, "DN40A", () => $dd5b085d4e6867fb$export$77868e1ca884ffa3);
$parcel$export(module.exports, "DN30A", () => $dd5b085d4e6867fb$export$2afd71d7d3ea2cd5);
$parcel$export(module.exports, "DN20A", () => $dd5b085d4e6867fb$export$f2a0acaab9972c70);
$parcel$export(module.exports, "DN10A", () => $dd5b085d4e6867fb$export$9ab70e67d6475361);
$parcel$export(module.exports, "background", () => $dd5b085d4e6867fb$export$8ce1fd94bee2f412);
$parcel$export(module.exports, "backgroundActive", () => $dd5b085d4e6867fb$export$b861914ea877b580);
$parcel$export(module.exports, "backgroundHover", () => $dd5b085d4e6867fb$export$3f1b020df94387af);
$parcel$export(module.exports, "backgroundOnLayer", () => $dd5b085d4e6867fb$export$c0183dbab98ca63e);
$parcel$export(module.exports, "text", () => $dd5b085d4e6867fb$export$6f093cfa640b7166);
$parcel$export(module.exports, "textHover", () => $dd5b085d4e6867fb$export$42f8e9c698766e7a);
$parcel$export(module.exports, "textActive", () => $dd5b085d4e6867fb$export$c2d157ca1c34b6e3);
$parcel$export(module.exports, "subtleText", () => $dd5b085d4e6867fb$export$1905ba28d7cf066f);
$parcel$export(module.exports, "placeholderText", () => $dd5b085d4e6867fb$export$bd9002130d306d39);
$parcel$export(module.exports, "heading", () => $dd5b085d4e6867fb$export$46e4a324ac90507f);
$parcel$export(module.exports, "subtleHeading", () => $dd5b085d4e6867fb$export$79f3f2b82beb0d36);
$parcel$export(module.exports, "codeBlock", () => $dd5b085d4e6867fb$export$7bb0d5c671655cc4);
$parcel$export(module.exports, "link", () => $dd5b085d4e6867fb$export$9c30223ca0a664fb);
$parcel$export(module.exports, "linkHover", () => $dd5b085d4e6867fb$export$7ed258b0728b004b);
$parcel$export(module.exports, "linkActive", () => $dd5b085d4e6867fb$export$dfa920d8decc8a59);
$parcel$export(module.exports, "linkOutline", () => $dd5b085d4e6867fb$export$6069e6ad5c78f632);
$parcel$export(module.exports, "primary", () => $dd5b085d4e6867fb$export$9ad721cf3b3debe0);
$parcel$export(module.exports, "blue", () => $dd5b085d4e6867fb$export$2aa0182783e7e9de);
$parcel$export(module.exports, "teal", () => $dd5b085d4e6867fb$export$8bf7dff220b82b4a);
$parcel$export(module.exports, "purple", () => $dd5b085d4e6867fb$export$e13cce2a2d16a9d4);
$parcel$export(module.exports, "red", () => $dd5b085d4e6867fb$export$a90204d1394caf30);
$parcel$export(module.exports, "yellow", () => $dd5b085d4e6867fb$export$594c5a8758200c32);
$parcel$export(module.exports, "green", () => $dd5b085d4e6867fb$export$955a2ebd2fb142ae);
$parcel$export(module.exports, "skeleton", () => $dd5b085d4e6867fb$export$2a0674ff2eb10214);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $kvIKC = parcelRequire("kvIKC");
const $dd5b085d4e6867fb$export$4b84fd0e2c617bd = '#FFEBE6';
const $dd5b085d4e6867fb$export$b34b069eff244586 = '#FFBDAD';
const $dd5b085d4e6867fb$export$be802dd0d8b57f35 = '#FF8F73';
const $dd5b085d4e6867fb$export$60847d42f9da92a6 = '#FF7452';
const $dd5b085d4e6867fb$export$4a7404f376229999 = '#FF5630';
const $dd5b085d4e6867fb$export$2010d0fb4295b346 = '#DE350B';
const $dd5b085d4e6867fb$export$2837b5a1a71d5c02 = '#BF2600';
const $dd5b085d4e6867fb$export$8d9596b529bbb9cf = '#FFFAE6';
const $dd5b085d4e6867fb$export$41060a744ab0b7ae = '#FFF0B3';
const $dd5b085d4e6867fb$export$1cc05bbbf340e559 = '#FFE380';
const $dd5b085d4e6867fb$export$5aae31392d72caaa = '#FFC400';
const $dd5b085d4e6867fb$export$c6930421db9fa514 = '#FFAB00';
const $dd5b085d4e6867fb$export$59619663aa6500fb = '#FF991F';
const $dd5b085d4e6867fb$export$874739ea9e379ab6 = '#FF8B00';
const $dd5b085d4e6867fb$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $dd5b085d4e6867fb$export$69a3bf21b9686c2b = '#ABF5D1';
const $dd5b085d4e6867fb$export$afbce1382ec95f73 = '#79F2C0';
const $dd5b085d4e6867fb$export$747d86715d4175de = '#57D9A3';
const $dd5b085d4e6867fb$export$940e1f69e873f202 = '#36B37E';
const $dd5b085d4e6867fb$export$a49394138f7b8e85 = '#00875A';
const $dd5b085d4e6867fb$export$6fa04827ac68a4fb = '#006644';
const $dd5b085d4e6867fb$export$226de0355ed012f8 = '#DEEBFF';
const $dd5b085d4e6867fb$export$8c13c2ee36917869 = '#B3D4FF';
const $dd5b085d4e6867fb$export$ecfc1dff386a3e7a = '#4C9AFF';
const $dd5b085d4e6867fb$export$215b7063051591f1 = '#2684FF';
const $dd5b085d4e6867fb$export$e62e8919cca44969 = '#0065FF';
const $dd5b085d4e6867fb$export$b3de0ae08da2ce64 = '#0052CC';
const $dd5b085d4e6867fb$export$a6ee3d71bc067634 = '#0747A6';
const $dd5b085d4e6867fb$export$363e4475840015bb = '#EAE6FF';
const $dd5b085d4e6867fb$export$4b0a4417ed59760f = '#C0B6F2';
const $dd5b085d4e6867fb$export$6011520a64d9a187 = '#998DD9';
const $dd5b085d4e6867fb$export$a7175d4e9206bc80 = '#8777D9';
const $dd5b085d4e6867fb$export$b48405b95304b5a1 = '#6554C0';
const $dd5b085d4e6867fb$export$c71e4279dd54a18d = '#5243AA';
const $dd5b085d4e6867fb$export$147899de772240ec = '#403294';
const $dd5b085d4e6867fb$export$2cf711fe14c66f06 = '#E6FCFF';
const $dd5b085d4e6867fb$export$7a8f4d33f6f9772c = '#B3F5FF';
const $dd5b085d4e6867fb$export$776c9c497ef08533 = '#79E2F2';
const $dd5b085d4e6867fb$export$69cb3ca10c1e330e = '#00C7E6';
const $dd5b085d4e6867fb$export$9dc1ef0f3f48059b = '#00B8D9';
const $dd5b085d4e6867fb$export$7c835c78b6fcdef8 = '#00A3BF';
const $dd5b085d4e6867fb$export$6036577f95c3877e = '#008DA6';
const $dd5b085d4e6867fb$export$29a4f05edc054374 = '#FFFFFF';
const $dd5b085d4e6867fb$export$e655ef011c4aa1a2 = '#FAFBFC';
const $dd5b085d4e6867fb$export$9fdfb749e33cdf97 = '#F4F5F7';
const $dd5b085d4e6867fb$export$3e51e8f1440314ba = '#EBECF0';
const $dd5b085d4e6867fb$export$1ce2d1575d444ceb = '#DFE1E6';
const $dd5b085d4e6867fb$export$8754fc7e6d8b3000 = '#C1C7D0';
const $dd5b085d4e6867fb$export$c2e91cbeada39b8b = '#B3BAC5';
const $dd5b085d4e6867fb$export$5f71e19f3a7ad9de = '#A5ADBA';
const $dd5b085d4e6867fb$export$eaa8c8a70ac22806 = '#97A0AF';
const $dd5b085d4e6867fb$export$7c87d337fb91a97d = '#8993A4';
const $dd5b085d4e6867fb$export$d6447c357493214f = '#7A869A';
const $dd5b085d4e6867fb$export$f563ee71e9ee74cd = '#6B778C';
const $dd5b085d4e6867fb$export$e2ef2124cf4024b1 = '#5E6C84';
const $dd5b085d4e6867fb$export$eece5f492e429f08 = '#505F79';
const $dd5b085d4e6867fb$export$c39c0fe0f26207ae = '#42526E';
const $dd5b085d4e6867fb$export$7090862dc3038a9f = '#344563';
const $dd5b085d4e6867fb$export$ad0bacf983b7ddaa = '#253858';
const $dd5b085d4e6867fb$export$7d61b15e0da132af = '#172B4D';
const $dd5b085d4e6867fb$export$fbda843f0a27fe96 = '#091E42';
const $dd5b085d4e6867fb$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $dd5b085d4e6867fb$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $dd5b085d4e6867fb$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $dd5b085d4e6867fb$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $dd5b085d4e6867fb$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $dd5b085d4e6867fb$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $dd5b085d4e6867fb$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $dd5b085d4e6867fb$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $dd5b085d4e6867fb$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $dd5b085d4e6867fb$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $dd5b085d4e6867fb$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $dd5b085d4e6867fb$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $dd5b085d4e6867fb$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $dd5b085d4e6867fb$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $dd5b085d4e6867fb$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $dd5b085d4e6867fb$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $dd5b085d4e6867fb$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $dd5b085d4e6867fb$export$2f6319cf7d736c2a = '#E6EDFA';
const $dd5b085d4e6867fb$export$95126bc8884d6634 = '#DCE5F5';
const $dd5b085d4e6867fb$export$8338d8c35d44ff1 = '#CED9EB';
const $dd5b085d4e6867fb$export$5368d76ae4fbbda7 = '#B8C7E0';
const $dd5b085d4e6867fb$export$9f0a771d16ec8d36 = '#ABBBD6';
const $dd5b085d4e6867fb$export$abcf8c38338b4aa5 = '#9FB0CC';
const $dd5b085d4e6867fb$export$97e81faa16a182c7 = '#8C9CB8';
const $dd5b085d4e6867fb$export$bfe21c59123ecf33 = '#7988A3';
const $dd5b085d4e6867fb$export$ee82aa2ea6a1558 = '#67758F';
const $dd5b085d4e6867fb$export$682927c6ed76be02 = '#56637A';
const $dd5b085d4e6867fb$export$91fd9994c5be9757 = '#455166';
const $dd5b085d4e6867fb$export$d281fbfe3cff2df6 = '#3B475C';
const $dd5b085d4e6867fb$export$3902c91d8b98a753 = '#313D52';
const $dd5b085d4e6867fb$export$8e8133c1ba5845b5 = '#283447';
const $dd5b085d4e6867fb$export$33ff357f6620b39 = '#202B3D';
const $dd5b085d4e6867fb$export$633847cf062b69e0 = '#1B2638';
const $dd5b085d4e6867fb$export$9776a6e503bdbf76 = '#121A29';
const $dd5b085d4e6867fb$export$6c813d5160dff5db = '#0E1624';
const $dd5b085d4e6867fb$export$3d4f271a500072a = '#0D1424';
const $dd5b085d4e6867fb$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $dd5b085d4e6867fb$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $dd5b085d4e6867fb$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $dd5b085d4e6867fb$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $dd5b085d4e6867fb$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $dd5b085d4e6867fb$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $dd5b085d4e6867fb$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $dd5b085d4e6867fb$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $dd5b085d4e6867fb$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $dd5b085d4e6867fb$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $dd5b085d4e6867fb$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $dd5b085d4e6867fb$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $dd5b085d4e6867fb$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $dd5b085d4e6867fb$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $dd5b085d4e6867fb$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $dd5b085d4e6867fb$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $dd5b085d4e6867fb$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $dd5b085d4e6867fb$export$8ce1fd94bee2f412 = (0, $kvIKC.default)({
    light: `var(--ds-surface, ${$dd5b085d4e6867fb$export$29a4f05edc054374})`,
    dark: `var(--ds-surface, ${$dd5b085d4e6867fb$export$633847cf062b69e0})`
});
const $dd5b085d4e6867fb$export$b861914ea877b580 = (0, $kvIKC.default)({
    light: `var(--ds-background-selected, ${$dd5b085d4e6867fb$export$226de0355ed012f8})`,
    dark: `var(--ds-background-selected, ${$dd5b085d4e6867fb$export$8c13c2ee36917869})`
});
const $dd5b085d4e6867fb$export$3f1b020df94387af = (0, $kvIKC.default)({
    light: `var(--ds-background-neutral-hovered, ${$dd5b085d4e6867fb$export$3e51e8f1440314ba})`,
    dark: `var(--ds-background-neutral-hovered, ${$dd5b085d4e6867fb$export$d281fbfe3cff2df6})`
});
const $dd5b085d4e6867fb$export$c0183dbab98ca63e = (0, $kvIKC.default)({
    light: `var(--ds-surface-overlay, ${$dd5b085d4e6867fb$export$29a4f05edc054374})`,
    dark: `var(--ds-surface-overlay, ${$dd5b085d4e6867fb$export$8e8133c1ba5845b5})`
});
const $dd5b085d4e6867fb$export$6f093cfa640b7166 = (0, $kvIKC.default)({
    light: `var(--ds-text, ${$dd5b085d4e6867fb$export$fbda843f0a27fe96})`,
    dark: `var(--ds-text, ${$dd5b085d4e6867fb$export$5368d76ae4fbbda7})`
});
const $dd5b085d4e6867fb$export$42f8e9c698766e7a = (0, $kvIKC.default)({
    light: `var(--ds-text, ${$dd5b085d4e6867fb$export$7d61b15e0da132af})`,
    dark: `var(--ds-text, ${$dd5b085d4e6867fb$export$5368d76ae4fbbda7})`
});
const $dd5b085d4e6867fb$export$c2d157ca1c34b6e3 = (0, $kvIKC.default)({
    light: `var(--ds-text-selected, ${$dd5b085d4e6867fb$export$b3de0ae08da2ce64})`,
    dark: `var(--ds-text-selected, ${$dd5b085d4e6867fb$export$b3de0ae08da2ce64})`
});
const $dd5b085d4e6867fb$export$1905ba28d7cf066f = (0, $kvIKC.default)({
    light: `var(--ds-text-subtlest, ${$dd5b085d4e6867fb$export$f563ee71e9ee74cd})`,
    dark: `var(--ds-text-subtlest, ${$dd5b085d4e6867fb$export$97e81faa16a182c7})`
});
const $dd5b085d4e6867fb$export$bd9002130d306d39 = (0, $kvIKC.default)({
    light: `var(--ds-text-subtlest, ${$dd5b085d4e6867fb$export$f563ee71e9ee74cd})`,
    dark: `var(--ds-text-subtlest, ${$dd5b085d4e6867fb$export$bfe21c59123ecf33})`
});
const $dd5b085d4e6867fb$export$46e4a324ac90507f = (0, $kvIKC.default)({
    light: `var(--ds-text, ${$dd5b085d4e6867fb$export$7d61b15e0da132af})`,
    dark: `var(--ds-text, ${$dd5b085d4e6867fb$export$5368d76ae4fbbda7})`
});
const $dd5b085d4e6867fb$export$79f3f2b82beb0d36 = (0, $kvIKC.default)({
    light: `var(--ds-text-subtlest, ${$dd5b085d4e6867fb$export$f563ee71e9ee74cd})`,
    dark: `var(--ds-text-subtlest, ${$dd5b085d4e6867fb$export$97e81faa16a182c7})`
});
const $dd5b085d4e6867fb$export$7bb0d5c671655cc4 = (0, $kvIKC.default)({
    light: $dd5b085d4e6867fb$export$9fdfb749e33cdf97,
    dark: $dd5b085d4e6867fb$export$8e8133c1ba5845b5
});
const $dd5b085d4e6867fb$export$9c30223ca0a664fb = (0, $kvIKC.default)({
    light: `var(--ds-link, ${$dd5b085d4e6867fb$export$b3de0ae08da2ce64})`,
    dark: `var(--ds-link, ${$dd5b085d4e6867fb$export$ecfc1dff386a3e7a})`
});
const $dd5b085d4e6867fb$export$7ed258b0728b004b = (0, $kvIKC.default)({
    light: `var(--ds-link-pressed, ${$dd5b085d4e6867fb$export$e62e8919cca44969})`,
    dark: `var(--ds-link-pressed, ${$dd5b085d4e6867fb$export$215b7063051591f1})`
});
const $dd5b085d4e6867fb$export$dfa920d8decc8a59 = (0, $kvIKC.default)({
    light: `var(--ds-link-pressed, ${$dd5b085d4e6867fb$export$a6ee3d71bc067634})`,
    dark: `var(--ds-link-pressed, ${$dd5b085d4e6867fb$export$ecfc1dff386a3e7a})`
});
const $dd5b085d4e6867fb$export$6069e6ad5c78f632 = (0, $kvIKC.default)({
    light: `var(--ds-border-focused, ${$dd5b085d4e6867fb$export$215b7063051591f1})`,
    dark: `var(--ds-border-focused, ${$dd5b085d4e6867fb$export$215b7063051591f1})`
});
const $dd5b085d4e6867fb$export$9ad721cf3b3debe0 = (0, $kvIKC.default)({
    light: `var(--ds-background-brand-bold, ${$dd5b085d4e6867fb$export$b3de0ae08da2ce64})`,
    dark: `var(--ds-background-brand-bold, ${$dd5b085d4e6867fb$export$ecfc1dff386a3e7a})`
});
const $dd5b085d4e6867fb$export$2aa0182783e7e9de = (0, $kvIKC.default)({
    light: $dd5b085d4e6867fb$export$b3de0ae08da2ce64,
    dark: $dd5b085d4e6867fb$export$ecfc1dff386a3e7a
});
const $dd5b085d4e6867fb$export$8bf7dff220b82b4a = (0, $kvIKC.default)({
    light: $dd5b085d4e6867fb$export$9dc1ef0f3f48059b,
    dark: $dd5b085d4e6867fb$export$69cb3ca10c1e330e
});
const $dd5b085d4e6867fb$export$e13cce2a2d16a9d4 = (0, $kvIKC.default)({
    light: $dd5b085d4e6867fb$export$b48405b95304b5a1,
    dark: $dd5b085d4e6867fb$export$6011520a64d9a187
});
const $dd5b085d4e6867fb$export$a90204d1394caf30 = (0, $kvIKC.default)({
    light: $dd5b085d4e6867fb$export$4a7404f376229999,
    dark: $dd5b085d4e6867fb$export$4a7404f376229999
});
const $dd5b085d4e6867fb$export$594c5a8758200c32 = (0, $kvIKC.default)({
    light: $dd5b085d4e6867fb$export$c6930421db9fa514,
    dark: $dd5b085d4e6867fb$export$c6930421db9fa514
});
const $dd5b085d4e6867fb$export$955a2ebd2fb142ae = (0, $kvIKC.default)({
    light: $dd5b085d4e6867fb$export$940e1f69e873f202,
    dark: $dd5b085d4e6867fb$export$940e1f69e873f202
});
const $dd5b085d4e6867fb$export$2a0674ff2eb10214 = ()=>`var(--ds-skeleton, ${$dd5b085d4e6867fb$export$8d43898f60b96a82})`;

});
parcelRegister("kvIKC", function(module, exports) {

$parcel$export(module.exports, "default", () => $eee96a7bfa4a30f7$export$2e2bcd8739ae039);
/* eslint-disable prefer-rest-params */ 
var $2d3Fv = parcelRequire("2d3Fv");
// Unpack custom variants, and get correct value for the current theme
function $eee96a7bfa4a30f7$var$themedVariants(variantProp, variants) {
    return (props)=>{
        const theme = (0, $2d3Fv.default)(props);
        if (props && props[variantProp] && variants) {
            const modes = variants[props[variantProp]];
            if (modes && modes[theme.mode]) {
                const value = modes[theme.mode];
                if (value) return value;
                 // TS believes value can be undefined
            }
        }
        return '';
    };
}
function $eee96a7bfa4a30f7$export$2e2bcd8739ae039(modesOrVariant, variantModes) {
    if (typeof modesOrVariant === 'string') return $eee96a7bfa4a30f7$var$themedVariants(modesOrVariant, variantModes);
    const modes = modesOrVariant;
    return (props)=>{
        // Get theme from the user's props
        const theme = (0, $2d3Fv.default)(props);
        // User isn't required to provide both light and dark values
        if (theme.mode in modes) {
            const value = modes[theme.mode]; // TS believes value can be undefined
            if (value) return value;
        }
        return '';
    };
}

});
parcelRegister("2d3Fv", function(module, exports) {

$parcel$export(module.exports, "default", () => $19bfa42aaeedfa77$export$2e2bcd8739ae039);

var $ivTMz = parcelRequire("ivTMz");
function $19bfa42aaeedfa77$export$2e2bcd8739ae039(props) {
    if (props && props.theme) {
        // Theme is the global Atlaskit theme
        if ((0, $ivTMz.CHANNEL) in props.theme) return props.theme[0, $ivTMz.CHANNEL];
        else if ('mode' in props.theme && (0, $ivTMz.THEME_MODES).includes(props.theme.mode)) return props.theme;
    }
    // If format not supported (or no theme provided), return standard theme
    return {
        mode: (0, $ivTMz.DEFAULT_THEME_MODE)
    };
}

});
parcelRegister("ivTMz", function(module, exports) {

$parcel$export(module.exports, "CHANNEL", () => $d7a664710b9e9400$export$44ffba16bd48dac6);
$parcel$export(module.exports, "DEFAULT_THEME_MODE", () => $d7a664710b9e9400$export$c93026a968943f95);
$parcel$export(module.exports, "THEME_MODES", () => $d7a664710b9e9400$export$6ba72c8346b4c57e);
$parcel$export(module.exports, "borderRadius", () => $d7a664710b9e9400$export$7a57f79000377ca2);
$parcel$export(module.exports, "gridSize", () => $d7a664710b9e9400$export$6d8204c2cb2e06b8);
$parcel$export(module.exports, "fontSize", () => $d7a664710b9e9400$export$85e3c3ca0c6fb93);
$parcel$export(module.exports, "fontSizeSmall", () => $d7a664710b9e9400$export$6746fe0d9c9fab54);
$parcel$export(module.exports, "fontFamily", () => $d7a664710b9e9400$export$a5975749f0374264);
$parcel$export(module.exports, "codeFontFamily", () => $d7a664710b9e9400$export$356129969ee49c55);
$parcel$export(module.exports, "layers", () => $d7a664710b9e9400$export$7be255094ccdc533);
$parcel$export(module.exports, "skeletonShimmer", () => $d7a664710b9e9400$export$e497e856b4f89fcd);

var $3z9ie = parcelRequire("3z9ie");

var $j0gMm = parcelRequire("j0gMm");
const $d7a664710b9e9400$export$44ffba16bd48dac6 = '__ATLASKIT_THEME__';
const $d7a664710b9e9400$export$c93026a968943f95 = 'light';
const $d7a664710b9e9400$export$6ba72c8346b4c57e = [
    'light',
    'dark'
];
const $d7a664710b9e9400$export$7a57f79000377ca2 = ()=>3;
const $d7a664710b9e9400$export$6d8204c2cb2e06b8 = ()=>8;
const $d7a664710b9e9400$export$85e3c3ca0c6fb93 = ()=>14;
const $d7a664710b9e9400$export$6746fe0d9c9fab54 = ()=>11;
const $d7a664710b9e9400$export$a5975749f0374264 = ()=>`-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif`;
const $d7a664710b9e9400$export$356129969ee49c55 = ()=>`'SFMono-Medium', 'SF Mono', 'Segoe UI Mono', 'Roboto Mono', 'Ubuntu Mono', Menlo, Consolas, Courier, monospace`;
const $d7a664710b9e9400$export$8e24544ddba725ee = (color = `var(--ds-border-focused, ${0, $j0gMm.B200})`, outlineWidth = $d7a664710b9e9400$export$6d8204c2cb2e06b8() / 4)=>{
    (0, $3z9ie.default)('@atlaskit/theme', 'focus ring mixin', 'Please use `@atlaskit/focus-ring` instead.');
    return `
  &:focus {
    outline: none;
    box-shadow: 0px 0px 0px ${outlineWidth}px ${color};
  }
`;
};
const $d7a664710b9e9400$export$c0dd343266bc3261 = ()=>`
  box-shadow: none;
`;
const $d7a664710b9e9400$export$7be255094ccdc533 = {
    card: ()=>100,
    navigation: ()=>200,
    dialog: ()=>300,
    layer: ()=>400,
    blanket: ()=>500,
    modal: ()=>510,
    flag: ()=>600,
    spotlight: ()=>700,
    tooltip: ()=>9999
};
const $d7a664710b9e9400$export$a1b3edb637fb4f35 = ()=>{
    (0, $3z9ie.default)('@atlaskit/theme', 'visually hidden mixin', 'Please use `@atlaskit/visually-hidden` instead.');
    return {
        border: '0 !important',
        clip: 'rect(1px, 1px, 1px, 1px) !important',
        height: '1px !important',
        overflow: 'hidden !important',
        padding: '0 !important',
        position: 'absolute !important',
        width: '1px !important',
        whiteSpace: 'nowrap !important'
    };
};
const $d7a664710b9e9400$export$ba1d834b86d72a09 = $d7a664710b9e9400$export$a1b3edb637fb4f35;
const $d7a664710b9e9400$export$e497e856b4f89fcd = ()=>({
        css: {
            backgroundColor: `var(--ds-skeleton, ${(0, $j0gMm.skeleton)()})`,
            animationDuration: '1.5s',
            animationIterationCount: 'infinite',
            animationTimingFunction: 'linear',
            animationDirection: 'alternate'
        },
        keyframes: {
            from: {
                backgroundColor: `var(--ds-skeleton, ${(0, $j0gMm.skeleton)()})`
            },
            to: {
                backgroundColor: `var(--ds-skeleton-subtle, ${0, $j0gMm.N30A})`
            }
        }
    });

});
parcelRegister("3z9ie", function(module, exports) {

$parcel$export(module.exports, "default", () => $298bd966fc331adf$export$2e2bcd8739ae039);
$parcel$export(module.exports, "propDeprecationWarning", () => $298bd966fc331adf$export$eb1decd851a5ae56);

var $ieyfV = parcelRequire("ieyfV");

var $2fFJv = parcelRequire("2fFJv");
function $298bd966fc331adf$export$2e2bcd8739ae039(packageName, api, additionalMessage) {
    (0, $ieyfV.default)(`[${packageName}]: The ${api} is deprecated.${additionalMessage && ` ${additionalMessage}`}`);
}
function $298bd966fc331adf$export$eb1decd851a5ae56(packageName, propName, predicate, deprecationAnnouncementOnDAC) {
    typeof $2fFJv;
}

});
parcelRegister("ieyfV", function(module, exports) {

$parcel$export(module.exports, "default", () => $d4641b50ca52cebc$export$2e2bcd8739ae039);
/* eslint-disable no-console */ const $d4641b50ca52cebc$var$printed = {};
function $d4641b50ca52cebc$export$2e2bcd8739ae039(message) {
    if ($d4641b50ca52cebc$var$printed[message]) return;
    $d4641b50ca52cebc$var$printed[message] = true;
    if (typeof window !== 'undefined') console.warn(message);
}

});







parcelRegister("9osuT", function(module, exports) {

$parcel$export(module.exports, "withAnalytics", () => $6d6c75e3b31068d4$export$af9baadf0e4f6e13);
$parcel$export(module.exports, "useAnalyticsEvents", () => $6d6c75e3b31068d4$export$5bf35293e545f20c);

var $5zQU9 = parcelRequire("5zQU9");

var $jzkzF = parcelRequire("jzkzF");
var $dY3D1 = parcelRequire("dY3D1");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $6d6c75e3b31068d4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6d6c75e3b31068d4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6d6c75e3b31068d4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6d6c75e3b31068d4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6d6c75e3b31068d4$export$af9baadf0e4f6e13(BaseComponent) {
    function HOCComponent(props) {
        const fireAnalyticsEvent = (prop)=>{
            return function(payload) {
                let channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'marketplace';
                return prop.createAnalyticsEvent($6d6c75e3b31068d4$var$_objectSpread({}, payload)).fire(channel);
            };
        };
        return /*#__PURE__*/ (0, $lHkHI.jsx)(BaseComponent, $6d6c75e3b31068d4$var$_objectSpread($6d6c75e3b31068d4$var$_objectSpread({}, props), {}, {
            fireAnalyticsEvent: fireAnalyticsEvent(props)
        }));
    }
    return (0, $dY3D1.default)()(HOCComponent);
}
const $6d6c75e3b31068d4$export$5bf35293e545f20c = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $jzkzF.useAnalyticsEvents)();
    const handleAnalyticsEvent = function handleAnalyticsEvent(payload) {
        let channel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'marketplace';
        createAnalyticsEvent($6d6c75e3b31068d4$var$_objectSpread({}, payload)).fire(channel);
    };
    return handleAnalyticsEvent;
};

});

parcelRegister("44zkz", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f72f11befe07fdf$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $fyH4h = parcelRequire("fyH4h");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $isqrX = parcelRequire("isqrX");

var $lHkHI = parcelRequire("lHkHI");
class $2f72f11befe07fdf$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const validationErrs = (0, $isqrX.validateFilters)(this.props.filters);
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fyH4h.default), {
            baseMessage: "Oops! The filters you provided are invalid.",
            dataError: validationErrs.size > 0,
            dataErrorMessages: validationErrs.map((err)=>(0, $g5DHJ.Map)({
                    message: err
                })).toList(),
            loading: false,
            children: this.props.children
        });
    }
}
(0, $5zQU9.default)($2f72f11befe07fdf$export$2e2bcd8739ae039, "propTypes", {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    filters: (0, $90ON9.default).filters.isRequired
});

});
parcelRegister("fyH4h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b53b7069df6cb5b3$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $8VfNq = parcelRequire("8VfNq");

var $fEeDC = parcelRequire("fEeDC");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $kU8RF = parcelRequire("kU8RF");

var $lHkHI = parcelRequire("lHkHI");
function $b53b7069df6cb5b3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b53b7069df6cb5b3$export$42a852a2b6b56249 = (0, $3UXZ8.default)("div", {
    target: "ebku820",
    label: "Container"
})({
    name: "8atqhb",
    styles: "width:100%;"
});
const $b53b7069df6cb5b3$export$6586c12bbf6d0c20 = (0, $3UXZ8.default)("ul", {
    target: "ebku821",
    label: "ErrorMessages"
})({
    name: "gx0lhm",
    styles: "margin-bottom:0;"
});
class $b53b7069df6cb5b3$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const errorMessages = this.props.dataErrorMessages.map((e, i)=>{
            return /*#__PURE__*/ (0, $lHkHI.jsx)("li", {
                children: e.get('message')
            }, 'data-error-message-' + i);
        });
        return /*#__PURE__*/ (0, $lHkHI.jsx)($b53b7069df6cb5b3$export$42a852a2b6b56249, {
            className: this.props.className,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kU8RF.default), {
                active: this.props.loading,
                delay: this.props.optimisticLoadTime,
                size: this.props.spinnerSize,
                testId: "content-container-loader",
                children: this.props.dataError ? /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $8VfNq.default), {
                    appearance: "error",
                    children: [
                        this.props.baseMessage,
                        errorMessages.size > 0 ? /*#__PURE__*/ (0, $lHkHI.jsx)($b53b7069df6cb5b3$export$6586c12bbf6d0c20, {
                            children: errorMessages
                        }) : undefined
                    ]
                }) : this.props.children
            })
        });
    }
}
(0, $5zQU9.default)($b53b7069df6cb5b3$export$2e2bcd8739ae039, "propTypes", {
    baseMessage: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    dataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    dataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        message: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
    })),
    optimisticLoadTime: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    spinnerSize: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
});
(0, $5zQU9.default)($b53b7069df6cb5b3$export$2e2bcd8739ae039, "defaultProps", {
    baseMessage: 'Oops! Looks like something went wrong.',
    dataError: false,
    loading: false,
    dataErrorMessages: (0, $g5DHJ.List)(),
    spinnerSize: 50
});

});
parcelRegister("8VfNq", function(module, exports) {

$parcel$export(module.exports, "default", () => $811dd37ca08ef06e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1bh6L = parcelRequire("1bh6L");

var $1QWP9 = parcelRequire("1QWP9");
var $c6J9g = parcelRequire("c6J9g");
var $loDxn = parcelRequire("loDxn");
var $gv7Ek = parcelRequire("gv7Ek");

var $931Ew = parcelRequire("931Ew");
const $811dd37ca08ef06e$var$containerStyles = (0, $gv7Ek.xcss)({
    wordBreak: 'break-word',
    borderRadius: 'border.radius'
});
const $811dd37ca08ef06e$var$bleedStyles = (0, $gv7Ek.xcss)({
    display: 'flex',
    marginBlock: 'space.negative.025'
});
const $811dd37ca08ef06e$var$contentStyles = (0, $gv7Ek.xcss)({
    color: 'color.text',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $811dd37ca08ef06e$var$SectionMessage = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $931Ew.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QWP9.default), {
        as: "section",
        backgroundColor: $811dd37ca08ef06e$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $811dd37ca08ef06e$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c6J9g.default), {
        space: "space.200",
        alignBlock: "stretch"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QWP9.default), {
        xcss: $811dd37ca08ef06e$var$bleedStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        size: "medium",
        primaryColor: primaryColor,
        secondaryColor: secondaryColor
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $loDxn.default), {
        space: "space.100",
        testId: testId && `${testId}--content`
    }, !!title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1bh6L.default), {
        as: "h2",
        size: "small"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QWP9.default), {
        xcss: $811dd37ca08ef06e$var$contentStyles
    }, children), actionsArray.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c6J9g.default), {
        shouldWrap: true,
        testId: testId && `${testId}--actions`,
        separator: "\xb7",
        space: "space.100",
        rowSpace: "space.0",
        role: "list"
    }, actionsArray.map((action, id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c6J9g.default), {
            role: "listitem",
            key: id
        }, action))))));
});
const $811dd37ca08ef06e$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$811dd37ca08ef06e$var$SectionMessage.displayName = 'SectionMessage';
var $811dd37ca08ef06e$export$2e2bcd8739ae039 = $811dd37ca08ef06e$var$SectionMessage;

});
parcelRegister("931Ew", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $2cc17321a1319549$export$e9b82d2e21ac0c1f);

var $eUqFw = parcelRequire("eUqFw");

var $3XolV = parcelRequire("3XolV");

var $gEwvS = parcelRequire("gEwvS");

var $58ZVT = parcelRequire("58ZVT");

var $c2Oyo = parcelRequire("c2Oyo");

var $d8i0J = parcelRequire("d8i0J");

const $2cc17321a1319549$export$faa35441caff5bb6 = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $ab6d6432a4c55680$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($58ZVT))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $ab6d6432a4c55680$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $ab6d6432a4c55680$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($d8i0J))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $ab6d6432a4c55680$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $ab6d6432a4c55680$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gEwvS))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $ab6d6432a4c55680$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $ab6d6432a4c55680$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($3XolV))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $ab6d6432a4c55680$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $ab6d6432a4c55680$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2Oyo))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $ab6d6432a4c55680$export$147899de772240ec)})`
    }
};
function $2cc17321a1319549$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $2cc17321a1319549$export$faa35441caff5bb6[appearance] || $2cc17321a1319549$export$faa35441caff5bb6.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(appearanceIconStyles.Icon, {
            size: size,
            primaryColor: primaryColor,
            secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});
parcelRegister("3XolV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2e19c5b646b0d928$var$_react = $2e19c5b646b0d928$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $2e19c5b646b0d928$var$_success = $2e19c5b646b0d928$var$_interopRequireDefault((parcelRequire("iMOte")));
function $2e19c5b646b0d928$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2e19c5b646b0d928$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $2e19c5b646b0d928$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $2e19c5b646b0d928$var$_success.default
    }));
$2e19c5b646b0d928$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $2e19c5b646b0d928$var$_default = module.exports.default = $2e19c5b646b0d928$var$CheckCircleIcon;

});
parcelRegister("iMOte", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3f4494144da7877c599489a550534c1d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $dad3dc17cb899f10$var$_react = $dad3dc17cb899f10$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $dad3dc17cb899f10$var$_UNSAFE_baseNew = $dad3dc17cb899f10$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $dad3dc17cb899f10$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $dad3dc17cb899f10$var$SuccessIcon = (props)=>/*#__PURE__*/ $dad3dc17cb899f10$var$_react.default.createElement($dad3dc17cb899f10$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m12.326-2.52-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$dad3dc17cb899f10$var$SuccessIcon.displayName = 'SuccessIcon';
var $dad3dc17cb899f10$var$_default = module.exports.default = $dad3dc17cb899f10$var$SuccessIcon;

});


parcelRegister("58ZVT", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3bedbdaea97b91c4$var$_react = $3bedbdaea97b91c4$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $3bedbdaea97b91c4$var$_information = $3bedbdaea97b91c4$var$_interopRequireDefault((parcelRequire("4To0r")));
function $3bedbdaea97b91c4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $3bedbdaea97b91c4$var$InfoIcon = (props)=>/*#__PURE__*/ $3bedbdaea97b91c4$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><path fill="currentcolor" d="M2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2 2 6.477 2 12"/><rect width="2" height="7" x="11" y="10" fill="inherit" rx="1"/><circle cx="12" cy="8" r="1" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $3bedbdaea97b91c4$var$_information.default
    }));
$3bedbdaea97b91c4$var$InfoIcon.displayName = 'InfoIcon';
var $3bedbdaea97b91c4$var$_default = module.exports.default = $3bedbdaea97b91c4$var$InfoIcon;

});
parcelRegister("4To0r", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6db48d6c22f8d07c19434865c237f982>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $38feeb9def9c6739$var$_react = $38feeb9def9c6739$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $38feeb9def9c6739$var$_UNSAFE_baseNew = $38feeb9def9c6739$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $38feeb9def9c6739$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Information".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: information state in section messages or inline messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $38feeb9def9c6739$var$InformationIcon = (props)=>/*#__PURE__*/ $38feeb9def9c6739$var$_react.default.createElement($38feeb9def9c6739$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m6.5-1.25H8a.75.75 0 0 1 .75.75v5h-1.5V8.25H6.5zM8 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`
    }, props));
$38feeb9def9c6739$var$InformationIcon.displayName = 'InformationIcon';
var $38feeb9def9c6739$var$_default = module.exports.default = $38feeb9def9c6739$var$InformationIcon;

});


var $ab6d6432a4c55680$exports = {};

$parcel$export($ab6d6432a4c55680$exports, "R50", () => $ab6d6432a4c55680$export$4b84fd0e2c617bd);
$parcel$export($ab6d6432a4c55680$exports, "R75", () => $ab6d6432a4c55680$export$b34b069eff244586);
$parcel$export($ab6d6432a4c55680$exports, "R100", () => $ab6d6432a4c55680$export$be802dd0d8b57f35);
$parcel$export($ab6d6432a4c55680$exports, "R200", () => $ab6d6432a4c55680$export$60847d42f9da92a6);
$parcel$export($ab6d6432a4c55680$exports, "R300", () => $ab6d6432a4c55680$export$4a7404f376229999);
$parcel$export($ab6d6432a4c55680$exports, "R400", () => $ab6d6432a4c55680$export$2010d0fb4295b346);
$parcel$export($ab6d6432a4c55680$exports, "R500", () => $ab6d6432a4c55680$export$2837b5a1a71d5c02);
$parcel$export($ab6d6432a4c55680$exports, "Y50", () => $ab6d6432a4c55680$export$8d9596b529bbb9cf);
$parcel$export($ab6d6432a4c55680$exports, "Y75", () => $ab6d6432a4c55680$export$41060a744ab0b7ae);
$parcel$export($ab6d6432a4c55680$exports, "Y100", () => $ab6d6432a4c55680$export$1cc05bbbf340e559);
$parcel$export($ab6d6432a4c55680$exports, "Y200", () => $ab6d6432a4c55680$export$5aae31392d72caaa);
$parcel$export($ab6d6432a4c55680$exports, "Y300", () => $ab6d6432a4c55680$export$c6930421db9fa514);
$parcel$export($ab6d6432a4c55680$exports, "Y400", () => $ab6d6432a4c55680$export$59619663aa6500fb);
$parcel$export($ab6d6432a4c55680$exports, "Y500", () => $ab6d6432a4c55680$export$874739ea9e379ab6);
$parcel$export($ab6d6432a4c55680$exports, "G50", () => $ab6d6432a4c55680$export$8a6341c32b6a3ee6);
$parcel$export($ab6d6432a4c55680$exports, "G75", () => $ab6d6432a4c55680$export$69a3bf21b9686c2b);
$parcel$export($ab6d6432a4c55680$exports, "G100", () => $ab6d6432a4c55680$export$afbce1382ec95f73);
$parcel$export($ab6d6432a4c55680$exports, "G200", () => $ab6d6432a4c55680$export$747d86715d4175de);
$parcel$export($ab6d6432a4c55680$exports, "G300", () => $ab6d6432a4c55680$export$940e1f69e873f202);
$parcel$export($ab6d6432a4c55680$exports, "G400", () => $ab6d6432a4c55680$export$a49394138f7b8e85);
$parcel$export($ab6d6432a4c55680$exports, "G500", () => $ab6d6432a4c55680$export$6fa04827ac68a4fb);
$parcel$export($ab6d6432a4c55680$exports, "B50", () => $ab6d6432a4c55680$export$226de0355ed012f8);
$parcel$export($ab6d6432a4c55680$exports, "B75", () => $ab6d6432a4c55680$export$8c13c2ee36917869);
$parcel$export($ab6d6432a4c55680$exports, "B100", () => $ab6d6432a4c55680$export$ecfc1dff386a3e7a);
$parcel$export($ab6d6432a4c55680$exports, "B200", () => $ab6d6432a4c55680$export$215b7063051591f1);
$parcel$export($ab6d6432a4c55680$exports, "B300", () => $ab6d6432a4c55680$export$e62e8919cca44969);
$parcel$export($ab6d6432a4c55680$exports, "B400", () => $ab6d6432a4c55680$export$b3de0ae08da2ce64);
$parcel$export($ab6d6432a4c55680$exports, "B500", () => $ab6d6432a4c55680$export$a6ee3d71bc067634);
$parcel$export($ab6d6432a4c55680$exports, "B600", () => $ab6d6432a4c55680$export$67f15409e87642a1);
$parcel$export($ab6d6432a4c55680$exports, "B700", () => $ab6d6432a4c55680$export$f0539dbc42dbb067);
$parcel$export($ab6d6432a4c55680$exports, "P50", () => $ab6d6432a4c55680$export$363e4475840015bb);
$parcel$export($ab6d6432a4c55680$exports, "P75", () => $ab6d6432a4c55680$export$4b0a4417ed59760f);
$parcel$export($ab6d6432a4c55680$exports, "P100", () => $ab6d6432a4c55680$export$6011520a64d9a187);
$parcel$export($ab6d6432a4c55680$exports, "P200", () => $ab6d6432a4c55680$export$a7175d4e9206bc80);
$parcel$export($ab6d6432a4c55680$exports, "P300", () => $ab6d6432a4c55680$export$b48405b95304b5a1);
$parcel$export($ab6d6432a4c55680$exports, "P400", () => $ab6d6432a4c55680$export$c71e4279dd54a18d);
$parcel$export($ab6d6432a4c55680$exports, "P500", () => $ab6d6432a4c55680$export$147899de772240ec);
$parcel$export($ab6d6432a4c55680$exports, "T50", () => $ab6d6432a4c55680$export$2cf711fe14c66f06);
$parcel$export($ab6d6432a4c55680$exports, "T75", () => $ab6d6432a4c55680$export$7a8f4d33f6f9772c);
$parcel$export($ab6d6432a4c55680$exports, "T100", () => $ab6d6432a4c55680$export$776c9c497ef08533);
$parcel$export($ab6d6432a4c55680$exports, "T200", () => $ab6d6432a4c55680$export$69cb3ca10c1e330e);
$parcel$export($ab6d6432a4c55680$exports, "T300", () => $ab6d6432a4c55680$export$9dc1ef0f3f48059b);
$parcel$export($ab6d6432a4c55680$exports, "T400", () => $ab6d6432a4c55680$export$7c835c78b6fcdef8);
$parcel$export($ab6d6432a4c55680$exports, "T500", () => $ab6d6432a4c55680$export$6036577f95c3877e);
$parcel$export($ab6d6432a4c55680$exports, "N0", () => $ab6d6432a4c55680$export$29a4f05edc054374);
$parcel$export($ab6d6432a4c55680$exports, "N10", () => $ab6d6432a4c55680$export$e655ef011c4aa1a2);
$parcel$export($ab6d6432a4c55680$exports, "N20", () => $ab6d6432a4c55680$export$9fdfb749e33cdf97);
$parcel$export($ab6d6432a4c55680$exports, "N30", () => $ab6d6432a4c55680$export$3e51e8f1440314ba);
$parcel$export($ab6d6432a4c55680$exports, "N40", () => $ab6d6432a4c55680$export$1ce2d1575d444ceb);
$parcel$export($ab6d6432a4c55680$exports, "N50", () => $ab6d6432a4c55680$export$8754fc7e6d8b3000);
$parcel$export($ab6d6432a4c55680$exports, "N60", () => $ab6d6432a4c55680$export$c2e91cbeada39b8b);
$parcel$export($ab6d6432a4c55680$exports, "N70", () => $ab6d6432a4c55680$export$5f71e19f3a7ad9de);
$parcel$export($ab6d6432a4c55680$exports, "N80", () => $ab6d6432a4c55680$export$eaa8c8a70ac22806);
$parcel$export($ab6d6432a4c55680$exports, "N90", () => $ab6d6432a4c55680$export$7c87d337fb91a97d);
$parcel$export($ab6d6432a4c55680$exports, "N100", () => $ab6d6432a4c55680$export$d6447c357493214f);
$parcel$export($ab6d6432a4c55680$exports, "N200", () => $ab6d6432a4c55680$export$f563ee71e9ee74cd);
$parcel$export($ab6d6432a4c55680$exports, "N300", () => $ab6d6432a4c55680$export$e2ef2124cf4024b1);
$parcel$export($ab6d6432a4c55680$exports, "N400", () => $ab6d6432a4c55680$export$eece5f492e429f08);
$parcel$export($ab6d6432a4c55680$exports, "N500", () => $ab6d6432a4c55680$export$c39c0fe0f26207ae);
$parcel$export($ab6d6432a4c55680$exports, "N600", () => $ab6d6432a4c55680$export$7090862dc3038a9f);
$parcel$export($ab6d6432a4c55680$exports, "N700", () => $ab6d6432a4c55680$export$ad0bacf983b7ddaa);
$parcel$export($ab6d6432a4c55680$exports, "N800", () => $ab6d6432a4c55680$export$7d61b15e0da132af);
$parcel$export($ab6d6432a4c55680$exports, "N900", () => $ab6d6432a4c55680$export$fbda843f0a27fe96);
$parcel$export($ab6d6432a4c55680$exports, "N10A", () => $ab6d6432a4c55680$export$791e57b27ca738ef);
$parcel$export($ab6d6432a4c55680$exports, "N20A", () => $ab6d6432a4c55680$export$8d43898f60b96a82);
$parcel$export($ab6d6432a4c55680$exports, "N30A", () => $ab6d6432a4c55680$export$920c0d5c49070351);
$parcel$export($ab6d6432a4c55680$exports, "N40A", () => $ab6d6432a4c55680$export$46987b49aab6d1a8);
$parcel$export($ab6d6432a4c55680$exports, "N50A", () => $ab6d6432a4c55680$export$7d3359664e8bb0e5);
$parcel$export($ab6d6432a4c55680$exports, "N60A", () => $ab6d6432a4c55680$export$d2d3bedfb276cac0);
$parcel$export($ab6d6432a4c55680$exports, "N70A", () => $ab6d6432a4c55680$export$6e5e7499ff054f6d);
$parcel$export($ab6d6432a4c55680$exports, "N80A", () => $ab6d6432a4c55680$export$59264b346c877fa7);
$parcel$export($ab6d6432a4c55680$exports, "N90A", () => $ab6d6432a4c55680$export$d092757d7c64925c);
$parcel$export($ab6d6432a4c55680$exports, "N100A", () => $ab6d6432a4c55680$export$486ab785e4bac3c6);
$parcel$export($ab6d6432a4c55680$exports, "N200A", () => $ab6d6432a4c55680$export$fba592bbc6419fea);
$parcel$export($ab6d6432a4c55680$exports, "N300A", () => $ab6d6432a4c55680$export$13609db0e6812ab8);
$parcel$export($ab6d6432a4c55680$exports, "N400A", () => $ab6d6432a4c55680$export$fbae4efaa892d883);
$parcel$export($ab6d6432a4c55680$exports, "N500A", () => $ab6d6432a4c55680$export$f13946d26f440ce6);
$parcel$export($ab6d6432a4c55680$exports, "N600A", () => $ab6d6432a4c55680$export$19f58225ac52a306);
$parcel$export($ab6d6432a4c55680$exports, "N700A", () => $ab6d6432a4c55680$export$6384f09da70e7b62);
$parcel$export($ab6d6432a4c55680$exports, "N800A", () => $ab6d6432a4c55680$export$d0dccc730683edc2);
$parcel$export($ab6d6432a4c55680$exports, "DN900", () => $ab6d6432a4c55680$export$2f6319cf7d736c2a);
$parcel$export($ab6d6432a4c55680$exports, "DN800", () => $ab6d6432a4c55680$export$95126bc8884d6634);
$parcel$export($ab6d6432a4c55680$exports, "DN700", () => $ab6d6432a4c55680$export$8338d8c35d44ff1);
$parcel$export($ab6d6432a4c55680$exports, "DN600", () => $ab6d6432a4c55680$export$5368d76ae4fbbda7);
$parcel$export($ab6d6432a4c55680$exports, "DN500", () => $ab6d6432a4c55680$export$9f0a771d16ec8d36);
$parcel$export($ab6d6432a4c55680$exports, "DN400", () => $ab6d6432a4c55680$export$abcf8c38338b4aa5);
$parcel$export($ab6d6432a4c55680$exports, "DN300", () => $ab6d6432a4c55680$export$97e81faa16a182c7);
$parcel$export($ab6d6432a4c55680$exports, "DN200", () => $ab6d6432a4c55680$export$bfe21c59123ecf33);
$parcel$export($ab6d6432a4c55680$exports, "DN100", () => $ab6d6432a4c55680$export$ee82aa2ea6a1558);
$parcel$export($ab6d6432a4c55680$exports, "DN90", () => $ab6d6432a4c55680$export$682927c6ed76be02);
$parcel$export($ab6d6432a4c55680$exports, "DN80", () => $ab6d6432a4c55680$export$91fd9994c5be9757);
$parcel$export($ab6d6432a4c55680$exports, "DN70", () => $ab6d6432a4c55680$export$d281fbfe3cff2df6);
$parcel$export($ab6d6432a4c55680$exports, "DN60", () => $ab6d6432a4c55680$export$3902c91d8b98a753);
$parcel$export($ab6d6432a4c55680$exports, "DN50", () => $ab6d6432a4c55680$export$8e8133c1ba5845b5);
$parcel$export($ab6d6432a4c55680$exports, "DN40", () => $ab6d6432a4c55680$export$33ff357f6620b39);
$parcel$export($ab6d6432a4c55680$exports, "DN30", () => $ab6d6432a4c55680$export$633847cf062b69e0);
$parcel$export($ab6d6432a4c55680$exports, "DN20", () => $ab6d6432a4c55680$export$9776a6e503bdbf76);
$parcel$export($ab6d6432a4c55680$exports, "DN10", () => $ab6d6432a4c55680$export$6c813d5160dff5db);
$parcel$export($ab6d6432a4c55680$exports, "DN0", () => $ab6d6432a4c55680$export$3d4f271a500072a);
$parcel$export($ab6d6432a4c55680$exports, "DN800A", () => $ab6d6432a4c55680$export$fe151285c22759ec);
$parcel$export($ab6d6432a4c55680$exports, "DN700A", () => $ab6d6432a4c55680$export$a101c6190d0da34);
$parcel$export($ab6d6432a4c55680$exports, "DN600A", () => $ab6d6432a4c55680$export$4b16f52932fda51);
$parcel$export($ab6d6432a4c55680$exports, "DN500A", () => $ab6d6432a4c55680$export$a74bcd7b9845b0d8);
$parcel$export($ab6d6432a4c55680$exports, "DN400A", () => $ab6d6432a4c55680$export$9209c179316d1751);
$parcel$export($ab6d6432a4c55680$exports, "DN300A", () => $ab6d6432a4c55680$export$88f55133f636c8dd);
$parcel$export($ab6d6432a4c55680$exports, "DN200A", () => $ab6d6432a4c55680$export$51126f85d1009512);
$parcel$export($ab6d6432a4c55680$exports, "DN100A", () => $ab6d6432a4c55680$export$a069b547bd23af78);
$parcel$export($ab6d6432a4c55680$exports, "DN90A", () => $ab6d6432a4c55680$export$40cce05af3b2600a);
$parcel$export($ab6d6432a4c55680$exports, "DN80A", () => $ab6d6432a4c55680$export$b78942185925a0d);
$parcel$export($ab6d6432a4c55680$exports, "DN70A", () => $ab6d6432a4c55680$export$e058fb44b8eaafca);
$parcel$export($ab6d6432a4c55680$exports, "DN60A", () => $ab6d6432a4c55680$export$92b0b8de26920c18);
$parcel$export($ab6d6432a4c55680$exports, "DN50A", () => $ab6d6432a4c55680$export$67564f7459d3fc9e);
$parcel$export($ab6d6432a4c55680$exports, "DN40A", () => $ab6d6432a4c55680$export$77868e1ca884ffa3);
$parcel$export($ab6d6432a4c55680$exports, "DN30A", () => $ab6d6432a4c55680$export$2afd71d7d3ea2cd5);
$parcel$export($ab6d6432a4c55680$exports, "DN20A", () => $ab6d6432a4c55680$export$f2a0acaab9972c70);
$parcel$export($ab6d6432a4c55680$exports, "DN10A", () => $ab6d6432a4c55680$export$9ab70e67d6475361);
$parcel$export($ab6d6432a4c55680$exports, "T30", () => $ab6d6432a4c55680$export$d2adc5dedf09fced);
$parcel$export($ab6d6432a4c55680$exports, "L50", () => $ab6d6432a4c55680$export$f51762073d2bb381);
$parcel$export($ab6d6432a4c55680$exports, "L75", () => $ab6d6432a4c55680$export$95e26d54def96891);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // Reds
const $ab6d6432a4c55680$export$4b84fd0e2c617bd = '#FFEBE6';
const $ab6d6432a4c55680$export$b34b069eff244586 = '#FFBDAD';
const $ab6d6432a4c55680$export$be802dd0d8b57f35 = '#FF8F73';
const $ab6d6432a4c55680$export$60847d42f9da92a6 = '#FF7452';
const $ab6d6432a4c55680$export$4a7404f376229999 = '#FF5630';
const $ab6d6432a4c55680$export$2010d0fb4295b346 = '#DE350B';
const $ab6d6432a4c55680$export$2837b5a1a71d5c02 = '#BF2600';
const $ab6d6432a4c55680$export$8d9596b529bbb9cf = '#FFFAE6';
const $ab6d6432a4c55680$export$41060a744ab0b7ae = '#FFF0B3';
const $ab6d6432a4c55680$export$1cc05bbbf340e559 = '#FFE380';
const $ab6d6432a4c55680$export$5aae31392d72caaa = '#FFC400';
const $ab6d6432a4c55680$export$c6930421db9fa514 = '#FFAB00';
const $ab6d6432a4c55680$export$59619663aa6500fb = '#FF991F';
const $ab6d6432a4c55680$export$874739ea9e379ab6 = '#FF8B00';
const $ab6d6432a4c55680$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $ab6d6432a4c55680$export$69a3bf21b9686c2b = '#ABF5D1';
const $ab6d6432a4c55680$export$afbce1382ec95f73 = '#79F2C0';
const $ab6d6432a4c55680$export$747d86715d4175de = '#57D9A3';
const $ab6d6432a4c55680$export$940e1f69e873f202 = '#36B37E';
const $ab6d6432a4c55680$export$a49394138f7b8e85 = '#00875A';
const $ab6d6432a4c55680$export$6fa04827ac68a4fb = '#006644';
const $ab6d6432a4c55680$export$226de0355ed012f8 = '#DEEBFF';
const $ab6d6432a4c55680$export$8c13c2ee36917869 = '#B3D4FF';
const $ab6d6432a4c55680$export$ecfc1dff386a3e7a = '#4C9AFF';
const $ab6d6432a4c55680$export$215b7063051591f1 = '#2684FF';
const $ab6d6432a4c55680$export$e62e8919cca44969 = '#0065FF';
const $ab6d6432a4c55680$export$b3de0ae08da2ce64 = '#0052CC';
const $ab6d6432a4c55680$export$a6ee3d71bc067634 = '#0747A6';
const $ab6d6432a4c55680$export$67f15409e87642a1 = '#669DF1';
const $ab6d6432a4c55680$export$f0539dbc42dbb067 = '#8FB8F6';
const $ab6d6432a4c55680$export$363e4475840015bb = '#EAE6FF';
const $ab6d6432a4c55680$export$4b0a4417ed59760f = '#C0B6F2';
const $ab6d6432a4c55680$export$6011520a64d9a187 = '#998DD9';
const $ab6d6432a4c55680$export$a7175d4e9206bc80 = '#8777D9';
const $ab6d6432a4c55680$export$b48405b95304b5a1 = '#6554C0';
const $ab6d6432a4c55680$export$c71e4279dd54a18d = '#5243AA';
const $ab6d6432a4c55680$export$147899de772240ec = '#403294';
const $ab6d6432a4c55680$export$2cf711fe14c66f06 = '#E6FCFF';
const $ab6d6432a4c55680$export$7a8f4d33f6f9772c = '#B3F5FF';
const $ab6d6432a4c55680$export$776c9c497ef08533 = '#79E2F2';
const $ab6d6432a4c55680$export$69cb3ca10c1e330e = '#00C7E6';
const $ab6d6432a4c55680$export$9dc1ef0f3f48059b = '#00B8D9';
const $ab6d6432a4c55680$export$7c835c78b6fcdef8 = '#00A3BF';
const $ab6d6432a4c55680$export$6036577f95c3877e = '#008DA6';
const $ab6d6432a4c55680$export$29a4f05edc054374 = '#FFFFFF';
const $ab6d6432a4c55680$export$e655ef011c4aa1a2 = '#FAFBFC';
const $ab6d6432a4c55680$export$9fdfb749e33cdf97 = '#F4F5F7';
const $ab6d6432a4c55680$export$3e51e8f1440314ba = '#EBECF0';
const $ab6d6432a4c55680$export$1ce2d1575d444ceb = '#DFE1E6';
const $ab6d6432a4c55680$export$8754fc7e6d8b3000 = '#C1C7D0';
const $ab6d6432a4c55680$export$c2e91cbeada39b8b = '#B3BAC5';
const $ab6d6432a4c55680$export$5f71e19f3a7ad9de = '#A5ADBA';
const $ab6d6432a4c55680$export$eaa8c8a70ac22806 = '#97A0AF';
const $ab6d6432a4c55680$export$7c87d337fb91a97d = '#8993A4';
const $ab6d6432a4c55680$export$d6447c357493214f = '#7A869A';
const $ab6d6432a4c55680$export$f563ee71e9ee74cd = '#6B778C';
const $ab6d6432a4c55680$export$e2ef2124cf4024b1 = '#5E6C84';
const $ab6d6432a4c55680$export$eece5f492e429f08 = '#505F79';
const $ab6d6432a4c55680$export$c39c0fe0f26207ae = '#42526E';
const $ab6d6432a4c55680$export$7090862dc3038a9f = '#344563';
const $ab6d6432a4c55680$export$ad0bacf983b7ddaa = '#253858';
const $ab6d6432a4c55680$export$7d61b15e0da132af = '#172B4D';
const $ab6d6432a4c55680$export$fbda843f0a27fe96 = '#091E42';
const $ab6d6432a4c55680$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $ab6d6432a4c55680$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $ab6d6432a4c55680$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $ab6d6432a4c55680$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $ab6d6432a4c55680$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $ab6d6432a4c55680$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $ab6d6432a4c55680$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $ab6d6432a4c55680$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $ab6d6432a4c55680$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $ab6d6432a4c55680$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $ab6d6432a4c55680$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $ab6d6432a4c55680$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $ab6d6432a4c55680$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $ab6d6432a4c55680$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $ab6d6432a4c55680$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $ab6d6432a4c55680$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $ab6d6432a4c55680$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $ab6d6432a4c55680$export$2f6319cf7d736c2a = '#E6EDFA';
const $ab6d6432a4c55680$export$95126bc8884d6634 = '#DCE5F5';
const $ab6d6432a4c55680$export$8338d8c35d44ff1 = '#CED9EB';
const $ab6d6432a4c55680$export$5368d76ae4fbbda7 = '#B8C7E0';
const $ab6d6432a4c55680$export$9f0a771d16ec8d36 = '#ABBBD6';
const $ab6d6432a4c55680$export$abcf8c38338b4aa5 = '#9FB0CC';
const $ab6d6432a4c55680$export$97e81faa16a182c7 = '#8C9CB8';
const $ab6d6432a4c55680$export$bfe21c59123ecf33 = '#7988A3';
const $ab6d6432a4c55680$export$ee82aa2ea6a1558 = '#67758F';
const $ab6d6432a4c55680$export$682927c6ed76be02 = '#56637A';
const $ab6d6432a4c55680$export$91fd9994c5be9757 = '#455166';
const $ab6d6432a4c55680$export$d281fbfe3cff2df6 = '#3B475C';
const $ab6d6432a4c55680$export$3902c91d8b98a753 = '#313D52';
const $ab6d6432a4c55680$export$8e8133c1ba5845b5 = '#283447';
const $ab6d6432a4c55680$export$33ff357f6620b39 = '#202B3D';
const $ab6d6432a4c55680$export$633847cf062b69e0 = '#1B2638';
const $ab6d6432a4c55680$export$9776a6e503bdbf76 = '#121A29';
const $ab6d6432a4c55680$export$6c813d5160dff5db = '#0E1624';
const $ab6d6432a4c55680$export$3d4f271a500072a = '#0D1424';
const $ab6d6432a4c55680$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $ab6d6432a4c55680$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $ab6d6432a4c55680$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $ab6d6432a4c55680$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $ab6d6432a4c55680$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $ab6d6432a4c55680$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $ab6d6432a4c55680$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $ab6d6432a4c55680$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $ab6d6432a4c55680$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $ab6d6432a4c55680$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $ab6d6432a4c55680$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $ab6d6432a4c55680$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $ab6d6432a4c55680$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $ab6d6432a4c55680$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $ab6d6432a4c55680$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $ab6d6432a4c55680$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $ab6d6432a4c55680$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $ab6d6432a4c55680$export$d2adc5dedf09fced = '#292A2E';
const $ab6d6432a4c55680$export$f51762073d2bb381 = '#94C748';
const $ab6d6432a4c55680$export$95e26d54def96891 = '#B3DF72';



parcelRegister("kU8RF", function(module, exports) {

$parcel$export(module.exports, "default", () => $f37fe9eb95d1abf5$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3yJNH = parcelRequire("3yJNH");
var $b9y3e = parcelRequire("b9y3e");

var $hvCdF = parcelRequire("hvCdF");
parcelRequire("eUqFw");

var $9kUzi = parcelRequire("9kUzi");

var $lHkHI = parcelRequire("lHkHI");
function $f37fe9eb95d1abf5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f37fe9eb95d1abf5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f37fe9eb95d1abf5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f37fe9eb95d1abf5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f37fe9eb95d1abf5$var$getSpinnerTestId = (testId)=>{
    if (testId !== null && testId !== void 0 && testId.length) return "".concat(testId, "--spinner");
};
const $f37fe9eb95d1abf5$var$SPINNER_MASK_DEFAULT_SIZE = 'large';
const $f37fe9eb95d1abf5$var$SPINNER_MASK_DEFAULT_MIN_HEIGHT = 100;
const $f37fe9eb95d1abf5$var$SpinnerMask = (props)=>{
    const { active: active, appearance: appearance, children: children, className: className, delay: delay, minHeight: minHeight = $f37fe9eb95d1abf5$var$SPINNER_MASK_DEFAULT_MIN_HEIGHT, size: size = $f37fe9eb95d1abf5$var$SPINNER_MASK_DEFAULT_SIZE, testId: testId } = props;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $9kUzi.Mask), {
        minHeight: minHeight,
        "data-testid": testId,
        className: className,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3yJNH.default), {
                appear: true,
                children: active && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $b9y3e.default), {
                    children: (fadeProps)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $9kUzi.SpinnerContainer), $f37fe9eb95d1abf5$var$_objectSpread($f37fe9eb95d1abf5$var$_objectSpread({}, fadeProps), {}, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hvCdF.default), {
                                appearance: appearance,
                                delay: delay,
                                size: size,
                                testId: $f37fe9eb95d1abf5$var$getSpinnerTestId(testId)
                            })
                        }))
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9kUzi.ContentWrapper), {
                visible: !active,
                children: children
            })
        ]
    });
};
var $f37fe9eb95d1abf5$export$2e2bcd8739ae039 = $f37fe9eb95d1abf5$var$SpinnerMask;

});
parcelRegister("9kUzi", function(module, exports) {

$parcel$export(module.exports, "ContentWrapper", () => $6cc1dc9af648698c$export$6ce170286acaa8d3);
$parcel$export(module.exports, "Mask", () => $6cc1dc9af648698c$export$991dcf7284de63d);
$parcel$export(module.exports, "SpinnerContainer", () => $6cc1dc9af648698c$export$a5e06607a5ac6158);

var $3UXZ8 = parcelRequire("3UXZ8");
function $6cc1dc9af648698c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6cc1dc9af648698c$export$6ce170286acaa8d3 = (0, $3UXZ8.default)("div", {
    target: "ex486hq0",
    label: "ContentWrapper"
})("width:100%;transition:opacity ", (_ref)=>{
    let { visible: visible } = _ref;
    return visible ? 'linear 0.2s' : '0s';
}, ";opacity:", (_ref2)=>{
    let { visible: visible } = _ref2;
    return visible ? 1 : 0;
}, ";visibility:", (_ref3)=>{
    let { visible: visible } = _ref3;
    return visible ? 'visible' : 'hidden';
}, ";");
const $6cc1dc9af648698c$export$991dcf7284de63d = (0, $3UXZ8.default)("div", {
    target: "ex486hq1",
    label: "Mask"
})("position:relative;width:100%;min-height:", (props)=>props.minHeight, "px;");
const $6cc1dc9af648698c$export$a5e06607a5ac6158 = (0, $3UXZ8.default)("div", {
    target: "ex486hq2",
    label: "SpinnerContainer"
})({
    name: "16jw3vr",
    styles: "width:100%;display:flex;justify-content:center;height:100%;align-items:center;position:absolute;top:0;"
});

});




parcelRegister("b2B2X", function(module, exports) {

$parcel$export(module.exports, "resolveDiscoverHeadingText", () => $809c9e50e144a44c$export$aaea25d73f7275f1);
$parcel$export(module.exports, "resolveSearchHeadingText", () => $809c9e50e144a44c$export$215d00ad72b299a4);
$parcel$export(module.exports, "resolveMeta", () => $809c9e50e144a44c$export$e50a9cee91177117);

var $g5DHJ = parcelRequire("g5DHJ");

var $7GXrf = parcelRequire("7GXrf");

var $fCICH = parcelRequire("fCICH");

var $72e1Y = parcelRequire("72e1Y");

var $isqrX = parcelRequire("isqrX");

var $aViHK = parcelRequire("aViHK");

function $809c9e50e144a44c$export$aaea25d73f7275f1(_ref) {
    let { filters: filters, featureFlags: featureFlags } = _ref;
    if (filters.get('product')) return "Explore apps for ".concat((0, $fCICH.getFilters)({
        featureFlags: featureFlags
    }).getIn([
        'product',
        'customFilters',
        filters.get('product'),
        'label'
    ]));
    return 'Explore apps for Atlassian products';
}
function $809c9e50e144a44c$export$215d00ad72b299a4(_ref2) {
    let { filters: filters, featureFlags: featureFlags } = _ref2;
    const currentSort = (0, $aViHK.resolveSortFromFilters)({
        filters: filters
    });
    const productFilter = (0, $fCICH.getFilters)({
        featureFlags: featureFlags
    }).get('product').get('customFilters').get(filters.get('product'));
    const moreFilters = filters.get('moreFilters');
    const topVendorFilter = moreFilters ? moreFilters.includes('topVendor') : false;
    const baseTitle = (0, (/*@__PURE__*/$parcel$interopDefault($7GXrf)))([
        currentSort && currentSort.get('title'),
        filters.get('category') || productFilter && productFilter.get('label')
    ], undefined).join(' ');
    if (baseTitle.length) return "".concat(baseTitle, " apps").concat(topVendorFilter ? ' from Top Vendors' : '');
    else if (topVendorFilter) return 'Apps from Top Vendors';
    else if ((0, $isqrX.valuedFilters)(filters).size) return 'Search results';
    else return 'Search for apps';
}
function $809c9e50e144a44c$var$resolveTitle(_ref3) {
    let { filters: filters, perspectiveKey: perspectiveKey, featureFlags: featureFlags } = _ref3;
    switch(perspectiveKey){
        case 0, $37a31921fd56c86d$export$a6b9aaee40d49fd0:
            return $809c9e50e144a44c$export$215d00ad72b299a4({
                filters: filters,
                featureFlags: featureFlags
            });
        case 0, $37a31921fd56c86d$export$27b2e48e28163360:
            return $809c9e50e144a44c$export$aaea25d73f7275f1({
                filters: filters,
                featureFlags: featureFlags
            });
        default:
            console.error("Invalid perspective provided '".concat(perspectiveKey, " - cannot resolve title"));
    }
}
function $809c9e50e144a44c$var$resolveMetaDescription(_ref4) {
    let { filters: filters, perspectiveKey: perspectiveKey, featureFlags: featureFlags } = _ref4;
    const productFilter = (0, $fCICH.getFilters)({
        featureFlags: featureFlags
    }).get('product').get('customFilters').get(filters.get('product'));
    const products = productFilter ? "Atlassian ".concat(productFilter.get('label')) : 'Jira, Confluence, Bitbucket & other Atlassian products';
    const currentSort = (0, $aViHK.resolveSortFromFilters)({
        filters: filters
    });
    const sortLabel = currentSort ? currentSort.get('label').toLowerCase() : undefined;
    const defaultPrefix = perspectiveKey === (0, $37a31921fd56c86d$export$a6b9aaee40d49fd0) ? 'Find' : 'Browse the top';
    const filterPrefix = sortLabel ? "Find the ".concat(sortLabel) : defaultPrefix;
    const moreFilters = filters.get('moreFilters');
    const topVendorFilter = moreFilters ? moreFilters.includes('topVendor') : false;
    const prefix = topVendorFilter ? 'Find Top Vendor' : filterPrefix;
    return "".concat(prefix, " apps, add-ons, plugins & integrations for ").concat(products, ". Free 30-day trial for all apps.");
}
function $809c9e50e144a44c$export$e50a9cee91177117(_ref5) {
    let { filters: filters, perspectiveKey: perspectiveKey, featureFlags: featureFlags } = _ref5;
    const enhancedFilters = (0, $72e1Y.default)(filters, featureFlags);
    return (0, $g5DHJ.Map)({
        title: $809c9e50e144a44c$var$resolveTitle({
            filters: enhancedFilters,
            perspectiveKey: perspectiveKey,
            featureFlags: featureFlags
        }),
        description: $809c9e50e144a44c$var$resolveMetaDescription({
            filters: enhancedFilters,
            perspectiveKey: perspectiveKey,
            featureFlags: featureFlags
        })
    });
}

});
parcelRegister("7GXrf", function(module, exports) {

var $fa0Ox = parcelRequire("fa0Ox");

var $9eFtX = parcelRequire("9eFtX");

var $cRpul = parcelRequire("cRpul");
/**
 * Creates an array excluding all given values using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * **Note:** Unlike `_.pull`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {...*} [values] The values to exclude.
 * @returns {Array} Returns the new array of filtered values.
 * @see _.difference, _.xor
 * @example
 *
 * _.without([2, 1, 2, 3], 1, 2);
 * // => [3]
 */ var $599a8fe1eb632ef8$var$without = $9eFtX(function(array, values) {
    return $cRpul(array) ? $fa0Ox(array, values) : [];
});
module.exports = $599a8fe1eb632ef8$var$without;

});


parcelRegister("goyDl", function(module, exports) {

$parcel$export(module.exports, "trackTileRenders", () => $bef9c0c152f7a7c7$export$def705c7c6d9d65f);

var $5zQU9 = parcelRequire("5zQU9");

var $fCICH = parcelRequire("fCICH");

var $k8gZV = parcelRequire("k8gZV");

var $3ONu7 = parcelRequire("3ONu7");

var $5YKni = parcelRequire("5YKni");
function $bef9c0c152f7a7c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $bef9c0c152f7a7c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $bef9c0c152f7a7c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $bef9c0c152f7a7c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
let $bef9c0c152f7a7c7$var$rank = 1;
const $bef9c0c152f7a7c7$var$getAllAppTilesData = (appTiles, isContinuation)=>{
    // if more tiles of some other search is rendered, rank will restart from 1
    if (!isContinuation) $bef9c0c152f7a7c7$var$rank = 1;
    let totalEcosystemCloudAppTiles = 0;
    const allAppKeys = appTiles.map((tile, i)=>{
        let isCloudApp = false;
        if ((0, $k8gZV.isEcosystemCloudApp)(tile)) {
            totalEcosystemCloudAppTiles++;
            isCloudApp = true;
        }
        return {
            key: tile.addonKey,
            rank: $bef9c0c152f7a7c7$var$rank + i,
            isEcosystemCloudApp: isCloudApp
        };
    });
    $bef9c0c152f7a7c7$var$rank = $bef9c0c152f7a7c7$var$rank + allAppKeys.length;
    return {
        appKeys: allAppKeys,
        totalEcosystemCloudAppTiles: totalEcosystemCloudAppTiles
    };
};
const $bef9c0c152f7a7c7$var$getDiscoverAppTilesData = (discoverData, collectionData)=>{
    let totalEcosystemCloudAppTiles = 0;
    let allAppKeysData = [];
    Object.keys(discoverData).forEach((key)=>{
        const currentCollectionTiles = discoverData[key].hits;
        const currentAppKeysData = currentCollectionTiles.map((tile, i)=>{
            let isCloudApp = false;
            if ((0, $k8gZV.isEcosystemCloudApp)(tile)) {
                totalEcosystemCloudAppTiles++;
                isCloudApp = true;
            }
            return {
                key: tile.addonKey,
                rank: i + 1,
                tileType: collectionData.get(key) === (0, $3ONu7.LARGE_COLLECTION_TYPE) ? 'large' : 'small',
                isEcosystemCloudApp: isCloudApp,
                collectionName: key
            };
        });
        allAppKeysData = [
            ...allAppKeysData,
            ...currentAppKeysData
        ];
    });
    return {
        appKeys: allAppKeysData,
        totalEcosystemCloudAppTiles: totalEcosystemCloudAppTiles
    };
};
const $bef9c0c152f7a7c7$var$getSearchTileCounts = (oldSearchData, newSearchData)=>{
    const oldHits = oldSearchData.searchResults.hits;
    const newHits = newSearchData.searchResults.hits;
    const incrementalTilesRendered = oldSearchData !== null && oldSearchData !== void 0 && oldSearchData.loadingFreshSearchResults ? newHits : newHits.slice(oldHits.length);
    const isContinuation = !(oldSearchData !== null && oldSearchData !== void 0 && oldSearchData.loadingFreshSearchResults);
    const { hasCloudFortifiedBadge: hasCloudFortifiedBadge, hasCloudSecurityBadge: hasCloudSecurityBadge } = (0, $k8gZV.certificationBadgeResolver)();
    const incrementalTilesRenderedWithCloudSecurityBadge = incrementalTilesRendered.filter(hasCloudSecurityBadge);
    const incrementalTilesRenderedWithCloudFortifiedBadge = incrementalTilesRendered.filter(hasCloudFortifiedBadge);
    const { appKeys: appKeys, totalEcosystemCloudAppTiles: totalEcosystemCloudAppTiles } = $bef9c0c152f7a7c7$var$getAllAppTilesData(incrementalTilesRendered, isContinuation);
    return {
        totalTiles: incrementalTilesRendered.length,
        totalTilesWithCloudSecurityBadge: incrementalTilesRenderedWithCloudSecurityBadge.length,
        totalTilesWithCloudFortifiedBadge: incrementalTilesRenderedWithCloudFortifiedBadge.length,
        appKeys: appKeys,
        totalEcosystemCloudAppTiles: totalEcosystemCloudAppTiles
    };
};
const $bef9c0c152f7a7c7$var$getDiscoverTileCounts = (discoverData, collectionData)=>{
    let allTiles = [];
    Object.keys(discoverData).forEach((key)=>{
        allTiles = [
            ...allTiles,
            ...discoverData[key].hits
        ];
    });
    const totalTiles = allTiles.length;
    const { hasCloudFortifiedBadge: hasCloudFortifiedBadge, hasCloudSecurityBadge: hasCloudSecurityBadge } = (0, $k8gZV.certificationBadgeResolver)();
    const totalTilesWithCloudSecurityBadge = allTiles.filter(hasCloudSecurityBadge).length;
    const totalTilesWithCloudFortifiedBadge = allTiles.filter(hasCloudFortifiedBadge).length;
    const { appKeys: appKeys, totalEcosystemCloudAppTiles: totalEcosystemCloudAppTiles } = $bef9c0c152f7a7c7$var$getDiscoverAppTilesData(discoverData, collectionData);
    return {
        totalTiles: totalTiles,
        totalTilesWithCloudSecurityBadge: totalTilesWithCloudSecurityBadge,
        totalTilesWithCloudFortifiedBadge: totalTilesWithCloudFortifiedBadge,
        appKeys: appKeys,
        totalEcosystemCloudAppTiles: totalEcosystemCloudAppTiles
    };
};
const $bef9c0c152f7a7c7$var$fireAnalyticsEvent = (createAnalyticsEvent)=>(actionSubjectId, objectId, attribute, source)=>{
        createAnalyticsEvent({
            eventType: (0, $5YKni.TilesRenderedEvent),
            objectType: (0, $5YKni.OBJECT_TYPE_APP),
            source: source,
            objectId: objectId,
            actionSubjectId: actionSubjectId,
            attributes: $bef9c0c152f7a7c7$var$_objectSpread($bef9c0c152f7a7c7$var$_objectSpread({}, attribute), {}, {
                sourceComponent: (0, $5YKni.EVENT_SOURCE)
            })
        }, (0, $5YKni.EVENT_CHANNEL));
    };
const $bef9c0c152f7a7c7$export$def705c7c6d9d65f = (props, newProps)=>{
    var _props$discoverCollec, _props$discoverCollec2;
    const oldSearchData = props.search;
    const newSearchData = newProps.search;
    const oldHits = oldSearchData.getIn([
        'searchResults',
        'hits'
    ]);
    const newHits = newSearchData.getIn([
        'searchResults',
        'hits'
    ]);
    const oldDiscoverData = props.discover.get('data');
    const newDiscoverData = newProps.discover.get('data');
    const fireEvent = $bef9c0c152f7a7c7$var$fireAnalyticsEvent(props.fireAnalyticsEvent);
    const searchTerm = newProps.filters.get((0, $fCICH.getFilters)().getIn([
        'query',
        'key'
    ]));
    const filters = newProps.filters.toJS();
    const collectionData = new Map();
    props === null || props === void 0 || (_props$discoverCollec = props.discoverCollectionsConfig) === null || _props$discoverCollec === void 0 || (_props$discoverCollec2 = _props$discoverCollec.get(props.filters.get('product', 'home'))) === null || _props$discoverCollec2 === void 0 || _props$discoverCollec2.map((collection)=>{
        collectionData.set(collection.get('key'), collection.get('type'));
    });
    if (newDiscoverData && newDiscoverData !== oldDiscoverData) fireEvent((0, $5YKni.ANALYTICS_SUBJECT_ID_DISCOVER_TILES), 0, $bef9c0c152f7a7c7$var$getDiscoverTileCounts(newDiscoverData.toJS(), collectionData), newProps.perspective);
    else if (newHits && newHits !== oldHits) fireEvent((0, $5YKni.ANALYTICS_SUBJECT_ID_SEARCH_TILES), newSearchData.get('currentPage'), $bef9c0c152f7a7c7$var$_objectSpread($bef9c0c152f7a7c7$var$_objectSpread({}, $bef9c0c152f7a7c7$var$getSearchTileCounts(oldSearchData.toJS(), newSearchData.toJS())), {}, {
        searchTerm: searchTerm,
        filters: filters
    }), newProps.perspective);
};

});
parcelRegister("k8gZV", function(module, exports) {

$parcel$export(module.exports, "isEcosystemCloudApp", () => $ea81bd699e11662b$export$1fbc8f8bc46dcc29);
$parcel$export(module.exports, "certificationBadgeResolver", () => $ea81bd699e11662b$export$65541c4b58338902);

var $gwoWU = parcelRequire("gwoWU");

var $kafab = parcelRequire("kafab");

var $ammkg = parcelRequire("ammkg");
const $ea81bd699e11662b$export$58d3020a1a1fe6b = (app)=>{
    var _app$programs;
    return (0, $gwoWU.isBugBountyParticipant)((0, $ammkg.AtlassianProductHostingType).Cloud, app === null || app === void 0 ? void 0 : (_app$programs = app.programs) === null || _app$programs === void 0 ? void 0 : _app$programs.bugBountyParticipant) && app.deployments.includes('cloud');
};
const $ea81bd699e11662b$export$c88d72b90811f5dc = (app)=>{
    var _app$programs2, _app$programs2$cloudF;
    return ((_app$programs2 = app.programs) === null || _app$programs2 === void 0 ? void 0 : (_app$programs2$cloudF = _app$programs2.cloudFortified) === null || _app$programs2$cloudF === void 0 ? void 0 : _app$programs2$cloudF.status) === (0, $kafab.CloudFortifiedStatusValues).Approved;
};
const $ea81bd699e11662b$export$1fbc8f8bc46dcc29 = (tile)=>tile.version.cloud && tile.version.cloud.cloudAppId;
const $ea81bd699e11662b$export$65541c4b58338902 = ()=>{
    const hasCloudFortifiedBadge = (app)=>$ea81bd699e11662b$export$c88d72b90811f5dc(app);
    const hasCloudSecurityBadge = (app)=>!hasCloudFortifiedBadge(app) && $ea81bd699e11662b$export$58d3020a1a1fe6b(app);
    return {
        hasCloudFortifiedBadge: hasCloudFortifiedBadge,
        hasCloudSecurityBadge: hasCloudSecurityBadge
    };
};

});
parcelRegister("gwoWU", function(module, exports) {

$parcel$export(module.exports, "isBugBountyParticipant", () => $c072fce12c6e26f6$export$8892bb2726357eb0);

var $kafab = parcelRequire("kafab");

var $ammkg = parcelRequire("ammkg");

var $bTrQR = parcelRequire("bTrQR");
const $c072fce12c6e26f6$export$ea94770af14d60f6 = (hosting)=>{
    if (hosting === (0, $ammkg.AtlassianProductHostingType).Cloud) return 'cloud';
    else if (hosting === (0, $ammkg.AtlassianProductHostingType).DataCenter) return 'dataCenter';
    else if (hosting === (0, $ammkg.AtlassianProductHostingType).Server) return 'server';
};
const $c072fce12c6e26f6$export$aaafe22bbdc50ba8 = (bb, hosting)=>{
    if (hosting === (0, $ammkg.AtlassianProductHostingType).Cloud) {
        var _bb$cloud, _bb$cloud$status;
        return (bb === null || bb === void 0 ? void 0 : (_bb$cloud = bb.cloud) === null || _bb$cloud === void 0 ? void 0 : (_bb$cloud$status = _bb$cloud.status) === null || _bb$cloud$status === void 0 ? void 0 : _bb$cloud$status.toLowerCase()) === (0, $kafab.BugBountyStatusValues).Approved;
    } else if (hosting === (0, $ammkg.AtlassianProductHostingType).DataCenter) {
        var _bb$dataCenter, _bb$dataCenter$status;
        return (bb === null || bb === void 0 ? void 0 : (_bb$dataCenter = bb.dataCenter) === null || _bb$dataCenter === void 0 ? void 0 : (_bb$dataCenter$status = _bb$dataCenter.status) === null || _bb$dataCenter$status === void 0 ? void 0 : _bb$dataCenter$status.toLowerCase()) === (0, $kafab.BugBountyStatusValues).Approved;
    } else if (hosting === (0, $ammkg.AtlassianProductHostingType).Server) {
        var _bb$server, _bb$server$status;
        return (bb === null || bb === void 0 ? void 0 : (_bb$server = bb.server) === null || _bb$server === void 0 ? void 0 : (_bb$server$status = _bb$server.status) === null || _bb$server$status === void 0 ? void 0 : _bb$server$status.toLowerCase()) === (0, $kafab.BugBountyStatusValues).Approved;
    }
    return false;
};
const $c072fce12c6e26f6$export$8892bb2726357eb0 = (hostingType, bugBountyParticipant)=>{
    const bugBountyHosting = $c072fce12c6e26f6$export$ea94770af14d60f6(hostingType);
    if (!bugBountyHosting) {
        (0, $bTrQR.default).error("isBugBountyParticipant", "Error in mapping hosting value for ".concat(hostingType));
        return false;
    }
    return $c072fce12c6e26f6$export$aaafe22bbdc50ba8(bugBountyParticipant, hostingType);
};

});


parcelRegister("5YKni", function(module, exports) {

$parcel$export(module.exports, "EVENT_CHANNEL", () => $45a6876c6afbbcae$export$3f072f06b90c3985);
$parcel$export(module.exports, "EVENT_SOURCE", () => $45a6876c6afbbcae$export$ad44d4a0591d8dba);
$parcel$export(module.exports, "ANALYTICS_EVENT_SOURCE_APP_TILE", () => $45a6876c6afbbcae$export$c0d95cba1328281f);
$parcel$export(module.exports, "OBJECT_TYPE_APP", () => $45a6876c6afbbcae$export$3447b6239ae57ddd);
$parcel$export(module.exports, "OBJECT_TYPE_FILTER", () => $45a6876c6afbbcae$export$5905e5171c9f2f40);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_COLLECTION_VIEW_MORE_LINK", () => $45a6876c6afbbcae$export$7f88c9ee14d66e0);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_STANDARD_TEXT_SEARCH", () => $45a6876c6afbbcae$export$51bbb2ceb2c4ced8);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MOBILE_DROPDOWN_MENU_APPLY_BUTTON", () => $45a6876c6afbbcae$export$84c5cf81a5e0304a);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MOBILE_DROPDOWN_TOGGLE_BUTTON", () => $45a6876c6afbbcae$export$61eefd3744bff60d);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_SEARCH_RESULTS_LOAD_MORE_BUTTON", () => $45a6876c6afbbcae$export$f69ce01328abf193);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_TOPBAR_FACET_FILTER", () => $45a6876c6afbbcae$export$58f7a306966c5bd0);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER", () => $45a6876c6afbbcae$export$959c0b270f8b1f8f);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_TILE_CATEGORY_FILTER", () => $45a6876c6afbbcae$export$92135508c9017260);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_CURRENT_FILTER_X_REMOVE_ICON", () => $45a6876c6afbbcae$export$f6872a52104678ed);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_TOPBAR_FACET", () => $45a6876c6afbbcae$export$ab7453ac757dacc9);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_SIDEBAR_FACET", () => $45a6876c6afbbcae$export$93db890f8d9684f);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_COLLECTION_TILE", () => $45a6876c6afbbcae$export$87b79657bc96eff0);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_DISCOVER_TILES", () => $45a6876c6afbbcae$export$23fcac335494955c);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_SEARCH_TILES", () => $45a6876c6afbbcae$export$360bd94af1885bc7);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_HIT", () => $45a6876c6afbbcae$export$37779239347ba832);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_RIGHT_CLICK_HIT", () => $45a6876c6afbbcae$export$5a290d8d68e9fd69);
$parcel$export(module.exports, "ButtonClickedEvent", () => $45a6876c6afbbcae$export$17f5c589a3d47ee0);
$parcel$export(module.exports, "FacetCollapsedEvent", () => $45a6876c6afbbcae$export$4dfc9f322ac27c10);
$parcel$export(module.exports, "FacetExpandedEvent", () => $45a6876c6afbbcae$export$f641b6c08ddea7b0);
$parcel$export(module.exports, "LinkClickedEvent", () => $45a6876c6afbbcae$export$12ddebffbf3b4da1);
$parcel$export(module.exports, "TileClickedEvent", () => $45a6876c6afbbcae$export$140af44fcdb541fc);
$parcel$export(module.exports, "TilesRenderedEvent", () => $45a6876c6afbbcae$export$a0ce8ac2d8f9789f);
$parcel$export(module.exports, "default", () => $45a6876c6afbbcae$export$2e2bcd8739ae039);
// IMPORTANT!!
//
// To add a new analytics event, you MUST:
// 1) Add a const below representing the event's action, actionSubject, and details
// 2) Add the const from step 1 to the default export
//
// If you skip any step, you will cause issues for the consumer, because they will not
// have any way to query this event.

var $gaiog = parcelRequire("gaiog");
var $lNaxt = parcelRequire("lNaxt");

var $g5DHJ = parcelRequire("g5DHJ");
const $45a6876c6afbbcae$export$3f072f06b90c3985 = 'addonDiscovery';
const $45a6876c6afbbcae$export$ad44d4a0591d8dba = 'addonDiscovery';
const $45a6876c6afbbcae$export$c0d95cba1328281f = 'appTile';
const $45a6876c6afbbcae$export$3447b6239ae57ddd = 'app';
const $45a6876c6afbbcae$export$5905e5171c9f2f40 = 'filter';
// Analytics Action Subjects
const $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_FACET = 'facet';
const $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_TILE = 'tile';
const $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_TILES = 'tiles';
const $45a6876c6afbbcae$export$7f88c9ee14d66e0 = 'collectionViewMoreLink';
const $45a6876c6afbbcae$export$51bbb2ceb2c4ced8 = 'standardTextSearch';
const $45a6876c6afbbcae$export$84c5cf81a5e0304a = 'mobileDropdownMenuApplyButton';
const $45a6876c6afbbcae$export$61eefd3744bff60d = 'mobileDropdownToggleButton';
const $45a6876c6afbbcae$export$f69ce01328abf193 = 'searchResultsLoadMoreButton';
const $45a6876c6afbbcae$export$58f7a306966c5bd0 = 'topbarFacetFilter';
const $45a6876c6afbbcae$export$959c0b270f8b1f8f = 'sidebarFacetFilter';
const $45a6876c6afbbcae$export$92135508c9017260 = 'tileCategoryFilter';
const $45a6876c6afbbcae$export$f6872a52104678ed = 'currentFilterXRemoveIcon';
const $45a6876c6afbbcae$export$ab7453ac757dacc9 = 'topbarFacet';
const $45a6876c6afbbcae$export$93db890f8d9684f = 'sidebarFacet';
const $45a6876c6afbbcae$export$87b79657bc96eff0 = 'collectionTile';
const $45a6876c6afbbcae$export$23fcac335494955c = 'discoverTiles';
const $45a6876c6afbbcae$export$360bd94af1885bc7 = 'searchTiles';
const $45a6876c6afbbcae$export$37779239347ba832 = 'hit';
const $45a6876c6afbbcae$export$5a290d8d68e9fd69 = 'rightHit';
const $45a6876c6afbbcae$export$17f5c589a3d47ee0 = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_BUTTON),
    details: 'User clicked a button',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $45a6876c6afbbcae$export$4dfc9f322ac27c10 = {
    action: (0, $gaiog.ANALYTICS_ACTION_COLLAPSED),
    actionSubject: $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_FACET,
    details: 'User has collapsed a search facet',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $45a6876c6afbbcae$export$f641b6c08ddea7b0 = {
    action: (0, $gaiog.ANALYTICS_ACTION_EXPANDED),
    actionSubject: $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_FACET,
    details: 'User has expanded a search facet',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $45a6876c6afbbcae$export$12ddebffbf3b4da1 = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_LINK),
    details: 'User clicked a link',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $45a6876c6afbbcae$export$140af44fcdb541fc = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_TILE,
    details: 'User clicked a tile',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $45a6876c6afbbcae$export$1f3e456d736fa1ca = {
    action: (0, $gaiog.ANALYTICS_ACTION_RENDERED),
    actionSubject: $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_TILE,
    details: 'A Marketplace app tile was rendered and is now visible to the user',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $45a6876c6afbbcae$export$a0ce8ac2d8f9789f = {
    action: (0, $gaiog.ANALYTICS_ACTION_RENDERED),
    actionSubject: $45a6876c6afbbcae$var$ANALYTICS_SUBJECT_TILES,
    details: 'Marketplace app tiles were rendered and are now visible to the user',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
var $45a6876c6afbbcae$export$2e2bcd8739ae039 = (0, $g5DHJ.List)([
    $45a6876c6afbbcae$export$17f5c589a3d47ee0,
    $45a6876c6afbbcae$export$4dfc9f322ac27c10,
    $45a6876c6afbbcae$export$f641b6c08ddea7b0,
    $45a6876c6afbbcae$export$12ddebffbf3b4da1,
    $45a6876c6afbbcae$export$140af44fcdb541fc,
    $45a6876c6afbbcae$export$1f3e456d736fa1ca,
    $45a6876c6afbbcae$export$a0ce8ac2d8f9789f,
    (0, $gaiog.FilterClickedEvent)
]);

});
parcelRegister("gaiog", function(module, exports) {

$parcel$export(module.exports, "makeEventContainer", () => $bc4bd871465bb41c$export$6f3dfcfde2a26c23);
$parcel$export(module.exports, "EVENT_CONTAINER_CLOUD_FORTIFIED_INFO_MODAL", () => $bc4bd871465bb41c$export$ab846e0a50e2a2f7);
$parcel$export(module.exports, "EVENT_CONTAINER_CLOUD_FORTIFIED_TOOLTIP", () => $bc4bd871465bb41c$export$9b6461c33e3d2a74);
$parcel$export(module.exports, "EVENT_CONTAINER_CERTIFICATION_SECTION", () => $bc4bd871465bb41c$export$bd2524a30eaf04e7);
$parcel$export(module.exports, "EVENT_CONTAINER_APPLISTING_SCREEN", () => $bc4bd871465bb41c$export$4bc4b1926fda6c51);
$parcel$export(module.exports, "EVENT_CONTAINER_SUPPORT_APPLISTING_TAB", () => $bc4bd871465bb41c$export$473571ee36f54def);
$parcel$export(module.exports, "makeAnalyticsAction", () => $bc4bd871465bb41c$export$4859a05fe90e78fe);
$parcel$export(module.exports, "ANALYTICS_ACTION_CLICKED", () => $bc4bd871465bb41c$export$c7a8bc68d822f729);
$parcel$export(module.exports, "ANALYTICS_ACTION_COLLAPSED", () => $bc4bd871465bb41c$export$afa7a066ba6e8212);
$parcel$export(module.exports, "ANALYTICS_ACTION_EXPANDED", () => $bc4bd871465bb41c$export$a5b9d8afa6e5173d);
$parcel$export(module.exports, "ANALYTICS_ACTION_FETCH_FAILED", () => $bc4bd871465bb41c$export$d46f53f6e9d0c675);
$parcel$export(module.exports, "ANALYTICS_ACTION_REMOVED", () => $bc4bd871465bb41c$export$a48c0b3ec8978236);
$parcel$export(module.exports, "ANALYTICS_ACTION_REMOVE_FAILED", () => $bc4bd871465bb41c$export$bfeff6b6f5f68025);
$parcel$export(module.exports, "ANALYTICS_ACTION_RENDERED", () => $bc4bd871465bb41c$export$e6ff11761cb083ce);
$parcel$export(module.exports, "ANALYTICS_ACTION_CHANGED", () => $bc4bd871465bb41c$export$6b270c18231f6695);
$parcel$export(module.exports, "makeAnalyticsActionSubject", () => $bc4bd871465bb41c$export$d4e5825945a3cdda);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_APP", () => $bc4bd871465bb41c$export$c52d8f46dfbf2dbd);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_BUTTON", () => $bc4bd871465bb41c$export$e416b27154b468db);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_LINK", () => $bc4bd871465bb41c$export$ea9f82a04bb0c5a6);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_TILES", () => $bc4bd871465bb41c$export$84007be1e3689955);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_UI", () => $bc4bd871465bb41c$export$7d8b518bcf85a1d1);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_IMAGE", () => $bc4bd871465bb41c$export$92bc2c5a9eecf3e8);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_IMAGE_LINK", () => $bc4bd871465bb41c$export$ff7b08d6eeeefff8);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_DOCUMENTATION_LINK", () => $bc4bd871465bb41c$export$24a8c739518b831b);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_FORUMS_LINK", () => $bc4bd871465bb41c$export$b230e89140cf55ed);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_STATUS_PAGE_LINK", () => $bc4bd871465bb41c$export$5312a593452aafaf);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_ISSUE_TRACKER_LINK", () => $bc4bd871465bb41c$export$269c3ac827ccca4);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_COMMUNITY_QUESTION_LINK", () => $bc4bd871465bb41c$export$a47a806019d7c6e1);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_SUPPORT_TICKET_LINK", () => $bc4bd871465bb41c$export$8cf343804eb3c603);
$parcel$export(module.exports, "makeAnalyticsCategory", () => $bc4bd871465bb41c$export$7805576a5ac813be);
$parcel$export(module.exports, "ButtonClickedEvent", () => $bc4bd871465bb41c$export$17f5c589a3d47ee0);
$parcel$export(module.exports, "ImageClickedEvent", () => $bc4bd871465bb41c$export$12c476215d2a57f9);
$parcel$export(module.exports, "LinkClickedEvent", () => $bc4bd871465bb41c$export$12ddebffbf3b4da1);
$parcel$export(module.exports, "TextFieldBlurEvent", () => $bc4bd871465bb41c$export$3c2219e2206e58b);
$parcel$export(module.exports, "TileClickedEvent", () => $bc4bd871465bb41c$export$140af44fcdb541fc);
$parcel$export(module.exports, "MenuItemClickedEvent", () => $bc4bd871465bb41c$export$13221a3b471c7ff5);
$parcel$export(module.exports, "BreadcrumbClickedEvent", () => $bc4bd871465bb41c$export$c6143a15227d967d);
$parcel$export(module.exports, "SearchSubmittedEvent", () => $bc4bd871465bb41c$export$574ad81d49991481);
$parcel$export(module.exports, "FilterClickedEvent", () => $bc4bd871465bb41c$export$1bc924770e976d12);
$parcel$export(module.exports, "TabClickedEvent", () => $bc4bd871465bb41c$export$484fdf4eeab12e86);
$parcel$export(module.exports, "ModalRenderedEvent", () => $bc4bd871465bb41c$export$8aa882460238b456);
$parcel$export(module.exports, "TooltipViewedEvent", () => $bc4bd871465bb41c$export$368aeee6baccc0e0);
$parcel$export(module.exports, "SearchOverlayViewEvent", () => $bc4bd871465bb41c$export$eef4c4c219985794);
$parcel$export(module.exports, "SearchOverlaySuggestionClickEvent", () => $bc4bd871465bb41c$export$95c08a8a1d00d5d9);
$parcel$export(module.exports, "SearchOverlayEnterKeyEvent", () => $bc4bd871465bb41c$export$5f2ac52054ff0703);
$parcel$export(module.exports, "SearchEmbeddedViewEvent", () => $bc4bd871465bb41c$export$3b5c1a8abac22038);
$parcel$export(module.exports, "SearchEmbeddedSuggestionClickEvent", () => $bc4bd871465bb41c$export$835e2ca6154629af);
$parcel$export(module.exports, "TilesRenderedEvent", () => $bc4bd871465bb41c$export$a0ce8ac2d8f9789f);
$parcel$export(module.exports, "SearchEmbeddedEnterKeyEvent", () => $bc4bd871465bb41c$export$f015ff8244e789d5);
$parcel$export(module.exports, "ClearFilterEvent", () => $bc4bd871465bb41c$export$15a0a93c7224b959);
$parcel$export(module.exports, "ErrorStateEvent", () => $bc4bd871465bb41c$export$3024be86a7637e37);
// Analytics Actions

var $eqVJB = parcelRequire("eqVJB");

var $lNaxt = parcelRequire("lNaxt");
const $bc4bd871465bb41c$export$6f3dfcfde2a26c23 = (v)=>v;
const $bc4bd871465bb41c$export$ab846e0a50e2a2f7 = $bc4bd871465bb41c$export$6f3dfcfde2a26c23('cloudFortifiedInfoModal');
const $bc4bd871465bb41c$export$9b6461c33e3d2a74 = $bc4bd871465bb41c$export$6f3dfcfde2a26c23('cloudFortifiedTooltip');
const $bc4bd871465bb41c$export$bd2524a30eaf04e7 = $bc4bd871465bb41c$export$6f3dfcfde2a26c23('certificationSection');
const $bc4bd871465bb41c$export$81880ccc80ea713d = $bc4bd871465bb41c$export$6f3dfcfde2a26c23('homeScreen');
const $bc4bd871465bb41c$export$8cc795b5314dd424 = $bc4bd871465bb41c$export$6f3dfcfde2a26c23('collectionsScreen');
const $bc4bd871465bb41c$export$4bc4b1926fda6c51 = $bc4bd871465bb41c$export$6f3dfcfde2a26c23('appListingScreen');
const $bc4bd871465bb41c$export$473571ee36f54def = $bc4bd871465bb41c$export$6f3dfcfde2a26c23('supportAppListingTab');
const $bc4bd871465bb41c$export$4859a05fe90e78fe = (v)=>v;
const $bc4bd871465bb41c$export$c7a8bc68d822f729 = $bc4bd871465bb41c$export$4859a05fe90e78fe('clicked');
const $bc4bd871465bb41c$export$afa7a066ba6e8212 = $bc4bd871465bb41c$export$4859a05fe90e78fe('collapsed');
const $bc4bd871465bb41c$export$a5b9d8afa6e5173d = $bc4bd871465bb41c$export$4859a05fe90e78fe('expanded');
const $bc4bd871465bb41c$export$d46f53f6e9d0c675 = $bc4bd871465bb41c$export$4859a05fe90e78fe('fetchFailed');
const $bc4bd871465bb41c$export$a48c0b3ec8978236 = $bc4bd871465bb41c$export$4859a05fe90e78fe('removed');
const $bc4bd871465bb41c$export$bfeff6b6f5f68025 = $bc4bd871465bb41c$export$4859a05fe90e78fe('removeFailed');
const $bc4bd871465bb41c$export$e6ff11761cb083ce = $bc4bd871465bb41c$export$4859a05fe90e78fe('rendered');
const $bc4bd871465bb41c$export$a96187c6d64d9f94 = $bc4bd871465bb41c$export$4859a05fe90e78fe('submitted');
const $bc4bd871465bb41c$export$6b270c18231f6695 = $bc4bd871465bb41c$export$4859a05fe90e78fe('changed');
const $bc4bd871465bb41c$export$34804d491cd2e7c9 = $bc4bd871465bb41c$export$4859a05fe90e78fe('toggled');
const $bc4bd871465bb41c$export$e52f895ec237339d = $bc4bd871465bb41c$export$4859a05fe90e78fe('blurred');
const $bc4bd871465bb41c$export$db23786aad95018a = $bc4bd871465bb41c$export$4859a05fe90e78fe('viewed');
const $bc4bd871465bb41c$export$cc8e7fae1116fc7b = $bc4bd871465bb41c$export$4859a05fe90e78fe('entered');
const $bc4bd871465bb41c$export$d4e5825945a3cdda = (v)=>v;
const $bc4bd871465bb41c$export$854041e05049ffd3 = $bc4bd871465bb41c$export$d4e5825945a3cdda('formField');
const $bc4bd871465bb41c$export$c52d8f46dfbf2dbd = $bc4bd871465bb41c$export$d4e5825945a3cdda('app');
const $bc4bd871465bb41c$export$dfa59625382b09c7 = $bc4bd871465bb41c$export$d4e5825945a3cdda('breadcrumb');
const $bc4bd871465bb41c$export$e416b27154b468db = $bc4bd871465bb41c$export$d4e5825945a3cdda('button');
const $bc4bd871465bb41c$export$ea9f82a04bb0c5a6 = $bc4bd871465bb41c$export$d4e5825945a3cdda('link');
const $bc4bd871465bb41c$export$7c5ceefc025e6114 = $bc4bd871465bb41c$export$d4e5825945a3cdda('menu');
const $bc4bd871465bb41c$export$27511148c59b417 = $bc4bd871465bb41c$export$d4e5825945a3cdda('menuItem');
const $bc4bd871465bb41c$export$ed02ca6faedaddbc = $bc4bd871465bb41c$export$d4e5825945a3cdda('tab');
const $bc4bd871465bb41c$export$80226708124d0f9 = $bc4bd871465bb41c$export$d4e5825945a3cdda('lozenge');
const $bc4bd871465bb41c$export$5b9593189ff4ac2c = $bc4bd871465bb41c$export$d4e5825945a3cdda('tile');
const $bc4bd871465bb41c$export$84007be1e3689955 = $bc4bd871465bb41c$export$d4e5825945a3cdda('tiles');
const $bc4bd871465bb41c$export$7d8b518bcf85a1d1 = $bc4bd871465bb41c$export$d4e5825945a3cdda('ui');
const $bc4bd871465bb41c$export$d21f0ec946449799 = $bc4bd871465bb41c$export$d4e5825945a3cdda('search');
const $bc4bd871465bb41c$export$8372f7a903a3e882 = $bc4bd871465bb41c$export$d4e5825945a3cdda('filter');
const $bc4bd871465bb41c$export$b5beeddca34af740 = $bc4bd871465bb41c$export$d4e5825945a3cdda('sort');
const $bc4bd871465bb41c$export$7914c2967253beb2 = $bc4bd871465bb41c$export$4859a05fe90e78fe('radioButton');
const $bc4bd871465bb41c$export$e17d600e77461f28 = $bc4bd871465bb41c$export$d4e5825945a3cdda('textField');
const $bc4bd871465bb41c$export$693afa5826a27336 = $bc4bd871465bb41c$export$d4e5825945a3cdda('pageNotFound');
const $bc4bd871465bb41c$export$1990eb2a6896738f = $bc4bd871465bb41c$export$d4e5825945a3cdda('modal');
const $bc4bd871465bb41c$export$f6de073840adcdec = $bc4bd871465bb41c$export$d4e5825945a3cdda('rowItem');
const $bc4bd871465bb41c$export$754b7bb056ca55bc = $bc4bd871465bb41c$export$d4e5825945a3cdda('checkbox');
const $bc4bd871465bb41c$export$67e91a0457e9466b = $bc4bd871465bb41c$export$d4e5825945a3cdda('banner');
const $bc4bd871465bb41c$export$27ffada7d4695dc6 = $bc4bd871465bb41c$export$d4e5825945a3cdda('tooltip');
const $bc4bd871465bb41c$export$fc86e2bd1ade636d = $bc4bd871465bb41c$export$d4e5825945a3cdda('discoverTile');
const $bc4bd871465bb41c$export$5dc1597cf4b6c0c7 = $bc4bd871465bb41c$export$d4e5825945a3cdda('collectionTile');
const $bc4bd871465bb41c$export$92bc2c5a9eecf3e8 = $bc4bd871465bb41c$export$d4e5825945a3cdda('image');
const $bc4bd871465bb41c$export$ff7b08d6eeeefff8 = $bc4bd871465bb41c$export$d4e5825945a3cdda('imageLink');
const $bc4bd871465bb41c$export$24a8c739518b831b = $bc4bd871465bb41c$export$d4e5825945a3cdda('appDocumentationLink');
const $bc4bd871465bb41c$export$b230e89140cf55ed = $bc4bd871465bb41c$export$d4e5825945a3cdda('appForumsLink');
const $bc4bd871465bb41c$export$5312a593452aafaf = $bc4bd871465bb41c$export$d4e5825945a3cdda('statusPageLink');
const $bc4bd871465bb41c$export$269c3ac827ccca4 = $bc4bd871465bb41c$export$d4e5825945a3cdda('issueTrackerLink');
const $bc4bd871465bb41c$export$a47a806019d7c6e1 = $bc4bd871465bb41c$export$d4e5825945a3cdda('communityQuestionLink');
const $bc4bd871465bb41c$export$8cf343804eb3c603 = $bc4bd871465bb41c$export$d4e5825945a3cdda('supportRequestLink');
const $bc4bd871465bb41c$export$bcfbaf5a28647621 = $bc4bd871465bb41c$export$d4e5825945a3cdda('searchOverlay');
const $bc4bd871465bb41c$export$f49811924c23f531 = $bc4bd871465bb41c$export$d4e5825945a3cdda('searchEmbedded');
const $bc4bd871465bb41c$export$2c845c02055cfe32 = $bc4bd871465bb41c$export$d4e5825945a3cdda('error');
const $bc4bd871465bb41c$export$2dfd3d1dcf2c7652 = $bc4bd871465bb41c$export$d4e5825945a3cdda('navigationItem');
const $bc4bd871465bb41c$export$292cd545f4464697 = $bc4bd871465bb41c$export$d4e5825945a3cdda('screenViewed');
const $bc4bd871465bb41c$export$7805576a5ac813be = (v)=>v;
const $bc4bd871465bb41c$export$17f5c589a3d47ee0 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$e416b27154b468db,
    details: 'User clicked a button',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$12c476215d2a57f9 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$92bc2c5a9eecf3e8,
    details: 'User clicked a image',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$12ddebffbf3b4da1 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$ea9f82a04bb0c5a6,
    details: 'User clicked a link',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$3c2219e2206e58b = {
    action: $bc4bd871465bb41c$export$e52f895ec237339d,
    actionSubject: $bc4bd871465bb41c$export$e17d600e77461f28,
    details: 'User clicked away from the text field',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$592238d52ca28e8d = {
    action: $bc4bd871465bb41c$export$34804d491cd2e7c9,
    actionSubject: $bc4bd871465bb41c$export$7914c2967253beb2,
    details: 'User toggled a radio option',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$140af44fcdb541fc = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$5b9593189ff4ac2c,
    details: 'User clicked a tile',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$20dbd94f06494a41 = {
    action: $bc4bd871465bb41c$export$a5b9d8afa6e5173d,
    actionSubject: $bc4bd871465bb41c$export$7c5ceefc025e6114,
    details: 'User expanded a menu',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$13221a3b471c7ff5 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$27511148c59b417,
    details: 'User clicked a menu item',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$c6143a15227d967d = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$dfa59625382b09c7,
    details: 'User clicked a breadcrumb item',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$574ad81d49991481 = {
    action: $bc4bd871465bb41c$export$a96187c6d64d9f94,
    actionSubject: $bc4bd871465bb41c$export$d21f0ec946449799,
    details: 'When a search input is submitted',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$1bc924770e976d12 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$8372f7a903a3e882,
    details: 'User has selected a filter for the app search',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$484fdf4eeab12e86 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$ed02ca6faedaddbc,
    details: 'User clicked a tab',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$1b1fb2b1e7140655 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$80226708124d0f9,
    details: 'User clicked a lozenge',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$8459b73933570c5b = {
    action: $bc4bd871465bb41c$export$e6ff11761cb083ce,
    actionSubject: $bc4bd871465bb41c$export$693afa5826a27336,
    details: 'User landed on a not found page',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$8aa882460238b456 = {
    action: $bc4bd871465bb41c$export$e6ff11761cb083ce,
    actionSubject: $bc4bd871465bb41c$export$1990eb2a6896738f,
    details: 'User opened a Modal',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$5d2f57e0f5e426a0 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$754b7bb056ca55bc,
    details: 'User clicked a checkbox',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$2736b9cdccb89154 = {
    action: $bc4bd871465bb41c$export$db23786aad95018a,
    actionSubject: $bc4bd871465bb41c$export$67e91a0457e9466b,
    details: 'User viewed a banner',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$368aeee6baccc0e0 = {
    action: $bc4bd871465bb41c$export$db23786aad95018a,
    actionSubject: $bc4bd871465bb41c$export$27ffada7d4695dc6,
    details: 'User viewed a Tooltip',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$eef4c4c219985794 = {
    action: $bc4bd871465bb41c$export$db23786aad95018a,
    actionSubject: $bc4bd871465bb41c$export$bcfbaf5a28647621,
    details: 'User has viewed the search overlay',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$95c08a8a1d00d5d9 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$bcfbaf5a28647621,
    details: 'User has selected a suggestion',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$5f2ac52054ff0703 = {
    action: $bc4bd871465bb41c$export$cc8e7fae1116fc7b,
    actionSubject: $bc4bd871465bb41c$export$bcfbaf5a28647621,
    details: 'User pressed an enter key',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$3b5c1a8abac22038 = {
    action: $bc4bd871465bb41c$export$db23786aad95018a,
    actionSubject: $bc4bd871465bb41c$export$f49811924c23f531,
    details: 'User has viewed the search overlay',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$835e2ca6154629af = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$f49811924c23f531,
    details: 'User has selected a suggestion',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$a0ce8ac2d8f9789f = {
    action: $bc4bd871465bb41c$export$e6ff11761cb083ce,
    actionSubject: $bc4bd871465bb41c$export$84007be1e3689955,
    details: 'Marketplace app tiles were rendered and are now visible to the user',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$57e303b46a8f8ad2 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$2dfd3d1dcf2c7652,
    details: 'User clicked a navbar item',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$f015ff8244e789d5 = {
    action: $bc4bd871465bb41c$export$cc8e7fae1116fc7b,
    actionSubject: $bc4bd871465bb41c$export$f49811924c23f531,
    details: 'User pressed an enter key',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$15a0a93c7224b959 = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$8372f7a903a3e882,
    details: 'User has cleared a selected filter for the app search',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$3024be86a7637e37 = {
    action: $bc4bd871465bb41c$export$e6ff11761cb083ce,
    actionSubject: $bc4bd871465bb41c$export$2c845c02055cfe32,
    details: 'An error state has been rendered',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$4b1506fea14c13bf = {
    action: $bc4bd871465bb41c$export$db23786aad95018a,
    actionSubject: $bc4bd871465bb41c$export$292cd545f4464697,
    details: 'User viewed screen',
    type: (0, $eqVJB.SCREEN_EVENT_TYPE)
};
const $bc4bd871465bb41c$export$b30d9e3d99fe197b = {
    action: $bc4bd871465bb41c$export$c7a8bc68d822f729,
    actionSubject: $bc4bd871465bb41c$export$b5beeddca34af740,
    details: 'User has selected a sort option',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};

});
parcelRegister("eqVJB", function(module, exports) {

$parcel$export(module.exports, "makeAnalyticsSourceID", () => $a8204745d0602e03$export$1223c02d6be97202);
$parcel$export(module.exports, "SCREEN_EVENT_TYPE", () => $a8204745d0602e03$export$f1d537d508d2945a);
const $a8204745d0602e03$export$1223c02d6be97202 = (v)=>v;
const $a8204745d0602e03$export$f1d537d508d2945a = 'screen';

});

parcelRegister("lNaxt", function(module, exports) {

$parcel$export(module.exports, "OPERATIONAL_EVENT_TYPE", () => $fdd65966a4263b8f$export$12346a674644c156);
$parcel$export(module.exports, "TRACK_EVENT_TYPE", () => $fdd65966a4263b8f$export$947dac6c72b26f81);
$parcel$export(module.exports, "UI_EVENT_TYPE", () => $fdd65966a4263b8f$export$a1562d08625f5d7e);
$parcel$export(module.exports, "foldAnalyticsEventType", () => $fdd65966a4263b8f$export$de3afd46ec224b2f);

var $gC8Po = parcelRequire("gC8Po");
const $fdd65966a4263b8f$export$12346a674644c156 = 'operational';
const $fdd65966a4263b8f$export$947dac6c72b26f81 = 'track';
const $fdd65966a4263b8f$export$a1562d08625f5d7e = 'ui';
function $fdd65966a4263b8f$export$de3afd46ec224b2f(analyticsEventType) {
    return function foldAnalyticsEventTypeInner(track, ui, operational) {
        switch(analyticsEventType){
            case 'track':
                return track();
            case 'ui':
                return ui();
            case 'operational':
                return operational();
            default:
                throw (0, $gC8Po.default).unexpectedCase(analyticsEventType);
        }
    };
}

});




parcelRegister("4xjZQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $34d9c1615e2b9d7b$export$2e2bcd8739ae039);

var $ck30h = parcelRequire("ck30h");

var $aSOsp = parcelRequire("aSOsp");
var $34d9c1615e2b9d7b$export$2e2bcd8739ae039 = (_ref)=>{
    let { options: options, newFilters: newFilters } = _ref;
    return (0, $aSOsp.default)({
        options: options,
        newFilters: newFilters,
        newPerspective: (0, $ck30h.resolveNewPerspectiveFromTransitionFilters)(newFilters)
    });
};

});
parcelRegister("ck30h", function(module, exports) {

$parcel$export(module.exports, "resolveNewPerspectiveFromTransitionFilters", () => $8f89aeb75c1fbbf6$export$aea980e3417e5ff7);

var $fCICH = parcelRequire("fCICH");

var $isqrX = parcelRequire("isqrX");

function $8f89aeb75c1fbbf6$export$aea980e3417e5ff7(newFilters) {
    return (0, $isqrX.valuedFilters)(newFilters).some((_, k)=>(0, $fCICH.getFilters)().get(k) && !(0, $fCICH.getFilters)().getIn([
            k,
            'discoverFilter'
        ])) ? (0, $37a31921fd56c86d$export$a6b9aaee40d49fd0) : (0, $37a31921fd56c86d$export$27b2e48e28163360);
}

});

parcelRegister("aSOsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ec6164b6d3e13e7$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
function $7ec6164b6d3e13e7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7ec6164b6d3e13e7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7ec6164b6d3e13e7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7ec6164b6d3e13e7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
var $7ec6164b6d3e13e7$export$2e2bcd8739ae039 = (_ref)=>{
    let { options: options, newFilters: newFilters, newPerspective: newPerspective } = _ref;
    return $7ec6164b6d3e13e7$var$_objectSpread($7ec6164b6d3e13e7$var$_objectSpread({}, options), {}, {
        newFilters: newFilters,
        newPerspective: newPerspective
    });
};

});


parcelRegister("aobPH", function(module, exports) {

$parcel$export(module.exports, "default", () => $79055304a3faec65$export$2e2bcd8739ae039);


var $aSOsp = parcelRequire("aSOsp");
var $79055304a3faec65$export$2e2bcd8739ae039 = (_ref)=>{
    let { options: options, newFilters: newFilters } = _ref;
    return (0, $aSOsp.default)({
        options: options,
        newFilters: newFilters,
        newPerspective: (0, $37a31921fd56c86d$export$a6b9aaee40d49fd0)
    });
};

});

parcelRegister("8VJ2L", function(module, exports) {

$parcel$export(module.exports, "default", () => $68069652f6252be8$export$2e2bcd8739ae039);
parcelRequire("eUqFw");


var $ck30h = parcelRequire("ck30h");

var $1yXOZ = parcelRequire("1yXOZ");

var $lHkHI = parcelRequire("lHkHI");
const $68069652f6252be8$var$DiscoverFiltersLink = (props)=>{
    const newPerspective = (0, $ck30h.resolveNewPerspectiveFromTransitionFilters)(props.newFilters);
    let href;
    if (newPerspective === (0, $37a31921fd56c86d$export$a6b9aaee40d49fd0)) href = props.filtersContext.get('searchFacetHrefResolver') ? props.filtersContext.get('searchFacetHrefResolver')({
        filters: props.newFilters
    }) : '#';
    else href = props.filtersContext.get('discoverFacetHrefResolver') ? props.filtersContext.get('discoverFacetHrefResolver')({
        filters: props.newFilters
    }) : '#';
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1yXOZ.default), {
        className: props.className,
        href: href,
        onClick: props.onClick,
        newFilters: props.newFilters,
        newPerspective: newPerspective,
        tabIndex: props.tabIndex,
        children: props.children
    });
};
var $68069652f6252be8$export$2e2bcd8739ae039 = $68069652f6252be8$var$DiscoverFiltersLink;

});
parcelRegister("1yXOZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $12375eb90d8edbcb$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $gykb8 = parcelRequire("gykb8");

var $eUqFw = parcelRequire("eUqFw");

var $9MMjz = parcelRequire("9MMjz");

var $lHkHI = parcelRequire("lHkHI");
class $12375eb90d8edbcb$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onClick", (event)=>{
            this.props.onClick(event, {
                newFilters: this.props.newFilters,
                newPerspective: this.props.newPerspective
            });
        });
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
            "data-testid": (0, $9MMjz.TEST_IDS).FILTERS_LINK,
            className: this.props.className,
            href: this.props.href,
            onClick: this.onClick,
            tabIndex: this.props.tabIndex,
            children: this.props.children
        });
    }
}
(0, $5zQU9.default)($12375eb90d8edbcb$export$2e2bcd8739ae039, "defaultProps", {
    href: '#',
    tabIndex: 0
});

});
parcelRegister("gykb8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0cf7960612c47df$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $ibjku = parcelRequire("ibjku");
const $c0cf7960612c47df$export$3aa88e89e7885d6a = /*#__PURE__*/ (0, $ibjku.css)("color:", "var(--ds-link, ".concat((0, $j0gMm.B400), ")"), ";text-decoration:none;cursor:pointer;&:hover{color:", "var(--ds-link, ".concat((0, $j0gMm.B300), ")"), ";}&:active{color:", "var(--ds-link-pressed, ".concat((0, $j0gMm.B500), ")"), ";}&:hover,&:active{outline:0;text-decoration:underline;};label:linkCss;");
var $c0cf7960612c47df$export$2e2bcd8739ae039 = (0, $3UXZ8.default)("a", {
    target: "e1xywzwe0"
})($c0cf7960612c47df$export$3aa88e89e7885d6a, "");

});

parcelRegister("9MMjz", function(module, exports) {

$parcel$export(module.exports, "TEST_IDS", () => $71fe1304804dc7b6$export$a2b4f255152a6585);
const $71fe1304804dc7b6$export$a2b4f255152a6585 = {
    APP_TILE: 'app-tile',
    FILTERS_LINK: 'filters-link',
    FACET_DROPDOWN: 'facet-dropdown',
    FACET_DROPDOWN_TRIGGER: 'facet-dropdown--trigger',
    FILTER_SIDEBAR_ITEM: 'filter-sidebar-item',
    FACET_CHECKBOX_GROUP: 'facet-checkbox-group'
};

});



parcelRegister("kT6nf", function(module, exports) {

$parcel$export(module.exports, "default", () => $03ec9c71322230f3$export$2e2bcd8739ae039);
parcelRequire("eUqFw");


var $1yXOZ = parcelRequire("1yXOZ");

var $lHkHI = parcelRequire("lHkHI");
const $03ec9c71322230f3$var$SearchFiltersLink = (props)=>{
    const href = props.filtersContext.get('searchFacetHrefResolver') ? props.filtersContext.get('searchFacetHrefResolver')({
        filters: props.newFilters
    }) : '#';
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1yXOZ.default), {
        className: props.className,
        href: href,
        newFilters: props.newFilters,
        newPerspective: (0, $37a31921fd56c86d$export$a6b9aaee40d49fd0),
        onClick: props.onClick,
        tabIndex: props.tabIndex,
        children: props.children
    });
};
var $03ec9c71322230f3$export$2e2bcd8739ae039 = $03ec9c71322230f3$var$SearchFiltersLink;

});

parcelRegister("64h1R", function(module, exports) {

$parcel$export(module.exports, "default", () => $46b0536b17c83eb9$export$2e2bcd8739ae039);

var $ogTdu = parcelRequire("ogTdu");
var $46b0536b17c83eb9$export$2e2bcd8739ae039 = (0, $ogTdu.default);

});
parcelRegister("ogTdu", function(module, exports) {

$parcel$export(module.exports, "default", () => $048f57ed2563893d$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $fyH4h = parcelRequire("fyH4h");

var $biTOe = parcelRequire("biTOe");

var $eUqFw = parcelRequire("eUqFw");

var $d9njc = parcelRequire("d9njc");

var $czTDJ = parcelRequire("czTDJ");

var $7xU0G = parcelRequire("7xU0G");

var $ajvzn = parcelRequire("ajvzn");

var $lHkHI = parcelRequire("lHkHI");
function $048f57ed2563893d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $048f57ed2563893d$export$9d2b4227a95687cc = /*#__PURE__*/ (0, $3UXZ8.default)((0, $fyH4h.default), {
    target: "e1fvbslq0",
    label: "ContentContainer"
})({
    name: "1tclgm4",
    styles: "max-width:1270px;min-width:0;"
});
const $048f57ed2563893d$export$7c6e2c02157bb7d2 = (0, $3UXZ8.default)("div", {
    target: "e1fvbslq1",
    label: "Content"
})("border:none;margin:0;display:flex;width:100%;", (props)=>props.visible ? '' : 'display: none;', "");
const $048f57ed2563893d$var$SearchContainerContent = (0, $3UXZ8.default)("div", {
    target: "e1fvbslq2",
    label: "SearchContainerContent"
})({
    name: "542elh",
    styles: "padding-top:10px;"
});
const $048f57ed2563893d$var$SideBar = (0, $3UXZ8.default)("div", {
    target: "e1fvbslq3",
    label: "SideBar"
})({
    name: "14t2r3y",
    styles: "width:280px;display:flex;flex-direction:column;"
});
const $048f57ed2563893d$var$Heading = (0, $3UXZ8.default)("div", {
    target: "e1fvbslq4",
    label: "Heading"
})({
    name: "odz94x",
    styles: "margin-top:5px;"
});
const $048f57ed2563893d$var$TopBar = (0, $3UXZ8.default)("div", {
    target: "e1fvbslq5",
    label: "TopBar"
})({
    name: "odz94x",
    styles: "margin-top:5px;"
});
const $048f57ed2563893d$var$ContentInner = (0, $3UXZ8.default)("div", {
    target: "e1fvbslq6",
    label: "ContentInner"
})({
    name: "btg7xs",
    styles: "max-width:990px;min-width:0;width:100%;"
});
const $048f57ed2563893d$var$TextSearchContainer = (0, $3UXZ8.default)("div", {
    target: "e1fvbslq7",
    label: "TextSearchContainer"
})({
    name: "ud5h78",
    styles: "margin-bottom:var(--ds-space-250, 20px);"
});
const $048f57ed2563893d$var$facetSidebarScreenClasses = new Set([
    'xl',
    'lg'
]);
const $048f57ed2563893d$var$textSearchScreenClasses = new Set([
    'xl',
    'lg'
]);
const $048f57ed2563893d$var$facetTopbarScreenClasses = new Set([
    'md',
    'sm',
    'xs'
]);
class $048f57ed2563893d$var$SearchContainer extends (0, $eUqFw.Component) {
    // eslint-disable-next-line complexity -- Fix me
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
            className: this.props.className,
            children: /*#__PURE__*/ (0, $lHkHI.jsxs)($048f57ed2563893d$export$9d2b4227a95687cc, {
                baseMessage: "Oops! Looks like something went wrong while initializing.",
                dataError: !this.props.initialized && this.props.dataError,
                dataErrorMessages: this.props.dataErrorMessages,
                loading: !this.props.dataError && !this.props.initialized,
                optimisticLoadTime: 1000,
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($048f57ed2563893d$export$7c6e2c02157bb7d2, {
                        className: "discoverNavigationHeader",
                        visible: this.props.initialized,
                        children: [
                            $048f57ed2563893d$var$facetSidebarScreenClasses.has(this.props.screenClass) ? /*#__PURE__*/ (0, $lHkHI.jsx)($048f57ed2563893d$var$SideBar, {}) : undefined,
                            /*#__PURE__*/ (0, $lHkHI.jsx)($048f57ed2563893d$var$ContentInner, {
                                children: this.props.discoverHeading
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($048f57ed2563893d$export$7c6e2c02157bb7d2, {
                        visible: this.props.initialized,
                        children: [
                            $048f57ed2563893d$var$facetSidebarScreenClasses.has(this.props.screenClass) ? /*#__PURE__*/ (0, $lHkHI.jsxs)($048f57ed2563893d$var$SideBar, {
                                children: [
                                    this.props.facets ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7xU0G.default), {
                                        facets: this.props.facets,
                                        filters: this.props.filters,
                                        filtersContext: this.props.filtersContext,
                                        filtersLink: this.props.filtersLink,
                                        hiddenFilters: this.props.hiddenFilters,
                                        perspective: this.props.perspective,
                                        stateChangeRequested: this.props.stateChangeRequested,
                                        itemFactory: this.props.itemFactory
                                    }) : undefined,
                                    this.props.externalFacets
                                ]
                            }) : undefined,
                            /*#__PURE__*/ (0, $lHkHI.jsxs)($048f57ed2563893d$var$ContentInner, {
                                children: [
                                    this.props.displayTextSearch && $048f57ed2563893d$var$textSearchScreenClasses.has(this.props.screenClass) ? /*#__PURE__*/ (0, $lHkHI.jsx)($048f57ed2563893d$var$TextSearchContainer, {
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $czTDJ.default), {
                                            filters: this.props.filters,
                                            perspective: this.props.perspective,
                                            stateChangeRequested: this.props.stateChangeRequested
                                        })
                                    }) : undefined,
                                    this.props.resolveHeadingText ? /*#__PURE__*/ (0, $lHkHI.jsx)($048f57ed2563893d$var$Heading, {
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $d9njc.default), {
                                            children: this.props.resolveHeadingText({
                                                filters: this.props.filters,
                                                featureFlags: {}
                                            })
                                        })
                                    }) : undefined,
                                    $048f57ed2563893d$var$facetTopbarScreenClasses.has(this.props.screenClass) ? /*#__PURE__*/ (0, $lHkHI.jsx)($048f57ed2563893d$var$TopBar, {
                                        children: this.props.facets ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ajvzn.default), {
                                            displayTextSearch: this.props.displayTextSearch,
                                            facets: this.props.facets,
                                            filters: this.props.filters,
                                            filtersContext: this.props.filtersContext,
                                            hiddenFilters: this.props.hiddenFilters,
                                            itemFactory: this.props.itemFactory,
                                            perspective: this.props.perspective,
                                            stateChangeRequested: this.props.stateChangeRequested,
                                            screenClass: this.props.screenClass
                                        }) : undefined
                                    }) : undefined,
                                    /*#__PURE__*/ (0, $lHkHI.jsx)($048f57ed2563893d$var$SearchContainerContent, {
                                        children: this.props.children
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    }
}
(0, $5zQU9.default)($048f57ed2563893d$var$SearchContainer, "defaultProps", {
    displayTextSearch: true
});
var $048f57ed2563893d$export$2e2bcd8739ae039 = (0, $biTOe.withFeatureFlags)($048f57ed2563893d$var$SearchContainer);

});
parcelRegister("d9njc", function(module, exports) {

$parcel$export(module.exports, "default", () => $992e3241c25db0c3$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $62cXe = parcelRequire("62cXe");

var $8gcXz = parcelRequire("8gcXz");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $992e3241c25db0c3$var$SectionHeadingStyle = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H1), {
    target: "e8xsm2i0",
    label: "SectionHeadingStyle"
})((props)=>props.mixin(), ";margin:0;padding-left:10px;font-weight:600;");
class $992e3241c25db0c3$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)($992e3241c25db0c3$var$SectionHeadingStyle, {
                mixin: (0, $62cXe).h700,
                children: this.props.children
            })
        });
    }
}
(0, $5zQU9.default)($992e3241c25db0c3$export$2e2bcd8739ae039, "propTypes", {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node.isRequired
});

});
parcelRegister("62cXe", function(module, exports) {

$parcel$export(module.exports, "fontFallback", () => $464cfa778ce4f1f2$export$2a99220fb32ec798);
$parcel$export(module.exports, "headingSizes", () => $464cfa778ce4f1f2$export$bc02e067df412c3b);
$parcel$export(module.exports, "h900", () => $464cfa778ce4f1f2$export$bdb8f897727a9c67);
$parcel$export(module.exports, "h800", () => $464cfa778ce4f1f2$export$3953fb6fbd158d23);
$parcel$export(module.exports, "h700", () => $464cfa778ce4f1f2$export$e4f993a313607daa);
$parcel$export(module.exports, "h600", () => $464cfa778ce4f1f2$export$1e8b2acea3fb3119);
$parcel$export(module.exports, "h500", () => $464cfa778ce4f1f2$export$85aa43a9b9f06707);
$parcel$export(module.exports, "h400", () => $464cfa778ce4f1f2$export$fcb7764b80bd908f);
$parcel$export(module.exports, "h300", () => $464cfa778ce4f1f2$export$a0e59c3bbc05e815);
$parcel$export(module.exports, "h200", () => $464cfa778ce4f1f2$export$7ccf32eb2150ac7e);
$parcel$export(module.exports, "h100", () => $464cfa778ce4f1f2$export$dfc0e69214efdc3c);

var $j0gMm = parcelRequire("j0gMm");

var $ivTMz = parcelRequire("ivTMz");
const $464cfa778ce4f1f2$export$2a99220fb32ec798 = {
    heading: {
        xxlarge: 'normal 500 35px/40px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xlarge: 'normal 600 29px/32px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        large: 'normal 500 24px/28px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 600 16px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xsmall: 'normal 600 14px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        xxsmall: 'normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    },
    body: {
        large: 'normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        medium: 'normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        UNSAFE_small: 'normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif',
        small: 'normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, "Segoe UI", Ubuntu, system-ui, "Helvetica Neue", sans-serif'
    }
};
const $464cfa778ce4f1f2$var$baseHeading = (size, lineHeight)=>({
        fontSize: `${size / 14}em`,
        fontStyle: 'inherit',
        lineHeight: lineHeight / size
    });
const $464cfa778ce4f1f2$export$bc02e067df412c3b = {
    h900: {
        size: 35,
        lineHeight: 40
    },
    h800: {
        size: 29,
        lineHeight: 32
    },
    h700: {
        size: 24,
        lineHeight: 28
    },
    h600: {
        size: 20,
        lineHeight: 24
    },
    h500: {
        size: 16,
        lineHeight: 20
    },
    h400: {
        size: 14,
        lineHeight: 16
    },
    h300: {
        size: 12,
        lineHeight: 16
    },
    h200: {
        size: 12,
        lineHeight: 16
    },
    h100: {
        size: 11,
        lineHeight: 16
    }
};
const $464cfa778ce4f1f2$export$bdb8f897727a9c67 = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h900.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h900.lineHeight),
        color: `var(--ds-text, ${(0, $j0gMm.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: `-0.01em`,
        marginTop: `${(0, $ivTMz.gridSize)() * 6.5}px`
    });
const $464cfa778ce4f1f2$export$3953fb6fbd158d23 = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h800.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h800.lineHeight),
        color: `var(--ds-text, ${(0, $j0gMm.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: `-0.01em`,
        marginTop: `${(0, $ivTMz.gridSize)() * 5}px`
    });
const $464cfa778ce4f1f2$export$e4f993a313607daa = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h700.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h700.lineHeight),
        color: `var(--ds-text, ${(0, $j0gMm.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: `-0.01em`,
        marginTop: `${(0, $ivTMz.gridSize)() * 5}px`
    });
const $464cfa778ce4f1f2$export$1e8b2acea3fb3119 = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h600.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h600.lineHeight),
        color: `var(--ds-text, ${(0, $j0gMm.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-medium, 500)",
        letterSpacing: `-0.008em`,
        marginTop: `${(0, $ivTMz.gridSize)() * 3.5}px`
    });
const $464cfa778ce4f1f2$export$85aa43a9b9f06707 = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h500.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h500.lineHeight),
        color: `var(--ds-text, ${(0, $j0gMm.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: `-0.006em`,
        marginTop: `${(0, $ivTMz.gridSize)() * 3}px`
    });
const $464cfa778ce4f1f2$export$fcb7764b80bd908f = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h400.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h400.lineHeight),
        color: `var(--ds-text, ${(0, $j0gMm.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        letterSpacing: `-0.003em`,
        marginTop: `${(0, $ivTMz.gridSize)() * 2}px`
    });
const $464cfa778ce4f1f2$export$a0e59c3bbc05e815 = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h300.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h300.lineHeight),
        color: `var(--ds-text, ${(0, $j0gMm.heading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: `${(0, $ivTMz.gridSize)() * 2.5}px`,
        textTransform: 'uppercase'
    });
const $464cfa778ce4f1f2$export$7ccf32eb2150ac7e = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h200.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h200.lineHeight),
        color: `var(--ds-text-subtlest, ${(0, $j0gMm.subtleHeading)(props)})`,
        fontWeight: "var(--ds-font-weight-semibold, 600)",
        marginTop: `${(0, $ivTMz.gridSize)() * 2}px`
    });
const $464cfa778ce4f1f2$export$dfc0e69214efdc3c = (props = {})=>({
        ...$464cfa778ce4f1f2$var$baseHeading($464cfa778ce4f1f2$export$bc02e067df412c3b.h100.size, $464cfa778ce4f1f2$export$bc02e067df412c3b.h100.lineHeight),
        color: `var(--ds-text-subtlest, ${(0, $j0gMm.subtleHeading)(props)})`,
        fontWeight: "var(--ds-font-weight-bold, 700)",
        marginTop: `${(0, $ivTMz.gridSize)() * 2}px`
    });

});

parcelRegister("8gcXz", function(module, exports) {

$parcel$export(module.exports, "baseHeadingsCss", () => $6039deebad083d08$export$38c21f0e09ea380e);
$parcel$export(module.exports, "H1", () => $6039deebad083d08$export$5523b16adee8048);
$parcel$export(module.exports, "h2Css", () => $6039deebad083d08$export$1099dd8523c836a1);
$parcel$export(module.exports, "H2", () => $6039deebad083d08$export$cb94397127ac9363);
$parcel$export(module.exports, "h3Css", () => $6039deebad083d08$export$4c070d318b3e6c6b);
$parcel$export(module.exports, "H3", () => $6039deebad083d08$export$746be9e3a3dfff1f);
$parcel$export(module.exports, "H4", () => $6039deebad083d08$export$cc5e069d64fda823);
$parcel$export(module.exports, "h5Css", () => $6039deebad083d08$export$47aaf3a45d11f623);
$parcel$export(module.exports, "H5", () => $6039deebad083d08$export$88ef9fdaf11f7a1f);
$parcel$export(module.exports, "h6Css", () => $6039deebad083d08$export$29a24c7e0a822a0d);
$parcel$export(module.exports, "H6", () => $6039deebad083d08$export$a559fb8039b06400);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");
var $ivTMz = parcelRequire("ivTMz");

var $ibjku = parcelRequire("ibjku");

var $hvUUg = parcelRequire("hvUUg");
const $6039deebad083d08$export$38c21f0e09ea380e = /*#__PURE__*/ (0, $ibjku.css)("color:", "var(--ds-text, ".concat((0, $j0gMm).N700, ")"), ";font-family:'Charlie Display',", (0, $ivTMz.fontFamily)(), ";font-weight:600;;label:baseHeadingsCss;");
const $6039deebad083d08$export$74619e1c6d9d9b34 = /*#__PURE__*/ (0, $ibjku.css)($6039deebad083d08$export$38c21f0e09ea380e, " font-size:52px;line-height:60px;margin-bottom:var(--ds-space-300, 24px);;label:h1Css;");
const $6039deebad083d08$export$5523b16adee8048 = (0, $3UXZ8.default)("h1", {
    target: "e1q0b7mc0",
    label: "H1"
})($6039deebad083d08$export$74619e1c6d9d9b34, "");
const $6039deebad083d08$export$1099dd8523c836a1 = /*#__PURE__*/ (0, $ibjku.css)($6039deebad083d08$export$38c21f0e09ea380e, " font-size:36px;line-height:44px;margin-bottom:var(--ds-space-300, 24px);;label:h2Css;");
const $6039deebad083d08$export$cb94397127ac9363 = (0, $3UXZ8.default)("h2", {
    target: "e1q0b7mc1",
    label: "H2"
})($6039deebad083d08$export$1099dd8523c836a1, "");
const $6039deebad083d08$export$4c070d318b3e6c6b = /*#__PURE__*/ (0, $ibjku.css)($6039deebad083d08$export$38c21f0e09ea380e, " font-size:24px;letter-spacing:0.3px;line-height:32px;margin-bottom:var(--ds-space-300, 24px);;label:h3Css;");
const $6039deebad083d08$export$746be9e3a3dfff1f = (0, $3UXZ8.default)("h3", {
    target: "e1q0b7mc2",
    label: "H3"
})($6039deebad083d08$export$4c070d318b3e6c6b, "");
const $6039deebad083d08$export$670093d479e4c626 = /*#__PURE__*/ (0, $ibjku.css)($6039deebad083d08$export$38c21f0e09ea380e, " font-size:20px;", (0, $hvUUg.baseLineHeight), ";letter-spacing:0;;label:h4Css;");
const $6039deebad083d08$export$cc5e069d64fda823 = (0, $3UXZ8.default)("h4", {
    target: "e1q0b7mc3",
    label: "H4"
})($6039deebad083d08$export$670093d479e4c626, "");
const $6039deebad083d08$export$47aaf3a45d11f623 = /*#__PURE__*/ (0, $ibjku.css)($6039deebad083d08$export$38c21f0e09ea380e, " font-size:20px;", (0, $hvUUg.baseLineHeight), ";margin-bottom:var(--ds-space-300, 24px);letter-spacing:0.3px;;label:h5Css;");
const $6039deebad083d08$export$88ef9fdaf11f7a1f = (0, $3UXZ8.default)("h5", {
    target: "e1q0b7mc4",
    label: "H5"
})($6039deebad083d08$export$47aaf3a45d11f623, "");
const $6039deebad083d08$export$29a24c7e0a822a0d = /*#__PURE__*/ (0, $ibjku.css)($6039deebad083d08$export$38c21f0e09ea380e, " font-size:12px;line-height:18px;margin-bottom:var(--ds-space-200, 16px);text-transform:uppercase;letter-spacing:1px;;label:h6Css;");
const $6039deebad083d08$export$a559fb8039b06400 = (0, $3UXZ8.default)("h6", {
    target: "e1q0b7mc5",
    label: "H6"
})($6039deebad083d08$export$29a24c7e0a822a0d, "");

});


parcelRegister("czTDJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9283e9d10c14ebc2$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $6jEcw = parcelRequire("6jEcw");

var $e1Mnq = parcelRequire("e1Mnq");

var $6sPuu = parcelRequire("6sPuu");

var $lHkHI = parcelRequire("lHkHI");
class $9283e9d10c14ebc2$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $e1Mnq.default), {
            filters: this.props.filters,
            searchComponent: (0, $6sPuu.default),
            perspective: this.props.perspective,
            stateChangeRequested: this.props.stateChangeRequested
        });
    }
}
(0, $5zQU9.default)($9283e9d10c14ebc2$export$2e2bcd8739ae039, "propTypes", {
    filters: (0, $90ON9.default).filters.isRequired,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});

});
parcelRegister("e1Mnq", function(module, exports) {

$parcel$export(module.exports, "default", () => $a366af4e18f1737b$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $9l6Pq = parcelRequire("9l6Pq");
var $biTOe = parcelRequire("biTOe");

var $aB8Wc = parcelRequire("aB8Wc");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $fCICH = parcelRequire("fCICH");

var $90ON9 = parcelRequire("90ON9");

var $5YKni = parcelRequire("5YKni");


var $6jEcw = parcelRequire("6jEcw");

var $lHkHI = parcelRequire("lHkHI");
function $a366af4e18f1737b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a366af4e18f1737b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a366af4e18f1737b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a366af4e18f1737b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a366af4e18f1737b$var$TextSearchWrapper = (props)=>{
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const { enableAetherSearchOverlay: enableAetherSearchOverlay } = (0, $9l6Pq.useStatsig)();
    const [showSearchOverlay, setShowSearchOverlay] = (0, $eUqFw.useState)(false);
    const [query, setQuery] = (0, $eUqFw.useState)(props.filters.get((0, $fCICH.getFilters)().getIn([
        'query',
        'key'
    ])) || '');
    const formQuery = props.filters.get((0, $fCICH.getFilters)().getIn([
        'query',
        'key'
    ])) || '';
    (0, $eUqFw.useEffect)(()=>{
        const currentQuery = props.filters.get((0, $fCICH.getFilters)().getIn([
            'query',
            'key'
        ])) || '';
        setQuery(currentQuery || '');
    }, [
        formQuery
    ]);
    const onChangeQuery = (newQuery)=>{
        if (enableAetherSearchOverlay()) return;
        setQuery(newQuery || '');
        if (props.onChange) props.onChange({
            newQuery: newQuery,
            newFilters: props.filters.set((0, $fCICH.getFilters)().getIn([
                'query',
                'key'
            ]), newQuery)
        });
    };
    const onSubmit = (e)=>{
        e.preventDefault();
        if (enableAetherSearchOverlay()) return;
        if (!props.onChange) {
            const newFilters = props.filters.set((0, $fCICH.getFilters)().getIn([
                'query',
                'key'
            ]), query);
            fireAnalyticsEvent({
                eventType: (0, $gaiog.SearchSubmittedEvent),
                actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_STANDARD_TEXT_SEARCH),
                source: props.perspective,
                objectType: (0, $5YKni.OBJECT_TYPE_FILTER),
                objectId: 'query',
                attributes: {
                    currentPerspective: props.perspective,
                    filterValue: query
                }
            }, (0, $5YKni.EVENT_CHANNEL));
            props.stateChangeRequested({
                filters: newFilters,
                perspective: (0, $37a31921fd56c86d$export$a6b9aaee40d49fd0)
            });
        }
    };
    const onClick = ()=>{
        if (enableAetherSearchOverlay()) setShowSearchOverlay(true);
    };
    const SearchComponent = props.searchComponent;
    const searchOverlaySource = window.location.pathname.includes('/search') ? 'search-page' : 'home-page-hero';
    return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
        "data-testid": "text-search-wrapper",
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)("form", {
                onSubmit: onSubmit,
                children: /*#__PURE__*/ (0, $lHkHI.jsx)(SearchComponent, $a366af4e18f1737b$var$_objectSpread($a366af4e18f1737b$var$_objectSpread({}, props.extraProps), {}, {
                    perspective: props.perspective,
                    onChangeQuery: onChangeQuery,
                    onClick: onClick,
                    query: query
                }))
            }),
            showSearchOverlay && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aB8Wc.SearchOverlay), {
                onClose: ()=>setShowSearchOverlay(false),
                analytics: {
                    source: searchOverlaySource
                }
            })
        ]
    });
};
$a366af4e18f1737b$var$TextSearchWrapper.propTypes = {
    fireAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    extraProps: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    filters: (0, $90ON9.default).filters.isRequired,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    /**
   * searchComponent must contain an input or button element with type "submit"
   * so that the onSubmit of this component's form can be executed
   */ searchComponent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
};
$a366af4e18f1737b$var$TextSearchWrapper.defaultProps = {
    extraProps: {}
};
var $a366af4e18f1737b$export$2e2bcd8739ae039 = (0, $biTOe.withFeatureFlags)($a366af4e18f1737b$var$TextSearchWrapper);

});
parcelRegister("9l6Pq", function(module, exports) {

$parcel$export(module.exports, "StatsigContext", () => $6ccb5f35c6d3739c$export$d3dd0785b656dcb6);
$parcel$export(module.exports, "useStatsig", () => $6ccb5f35c6d3739c$export$ddc6406e1d54d599);
$parcel$export(module.exports, "withStatsig", () => $6ccb5f35c6d3739c$export$974e56e25a4e0e09);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $jkLPm = parcelRequire("jkLPm");

var $lHkHI = parcelRequire("lHkHI");
function $6ccb5f35c6d3739c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6ccb5f35c6d3739c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6ccb5f35c6d3739c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6ccb5f35c6d3739c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $6ccb5f35c6d3739c$export$d3dd0785b656dcb6 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    statsigClient: new (0, $jkLPm.StatsigClient)() // without init it will return only falsy or default value. its required so that consumer does has to put a check for undefined
});
function $6ccb5f35c6d3739c$export$ddc6406e1d54d599() {
    const context = (0, $eUqFw.useContext)($6ccb5f35c6d3739c$export$d3dd0785b656dcb6);
    if (context === undefined) console.error('useStatsig must be used within a StatsigProvider');
    return context.statsigClient;
}
function $6ccb5f35c6d3739c$export$974e56e25a4e0e09(Component) {
    return function StatsigComponent(props) {
        return /*#__PURE__*/ (0, $lHkHI.jsx)($6ccb5f35c6d3739c$export$d3dd0785b656dcb6.Consumer, {
            children: (_ref)=>{
                let { statsigClient: statsigClient } = _ref;
                return /*#__PURE__*/ (0, $lHkHI.jsx)(Component, $6ccb5f35c6d3739c$var$_objectSpread($6ccb5f35c6d3739c$var$_objectSpread({}, props), {}, {
                    statsigClient: statsigClient
                }));
            }
        });
    };
}

});
parcelRegister("jkLPm", function(module, exports) {

$parcel$export(module.exports, "StatsigClient", () => $e134fc1d6577ca86$export$189a85bb51d82b2e);

var $5zQU9 = parcelRequire("5zQU9");

var $8z3dZ = parcelRequire("8z3dZ");
function $e134fc1d6577ca86$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e134fc1d6577ca86$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e134fc1d6577ca86$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e134fc1d6577ca86$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $e134fc1d6577ca86$export$189a85bb51d82b2e {
    constructor(){
        var _this = this;
        (0, $5zQU9.default)(this, "isStatsigInitialized", false);
        (0, $5zQU9.default)(this, "evaluatedFlags", {});
        (0, $5zQU9.default)(this, "evaluatedExperiments", {});
        (0, $5zQU9.default)(this, "source", undefined);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0, $5zQU9.default)(this, "overrides", {});
        (0, $5zQU9.default)(this, "getExperimentValue", function(experimentName, propertyName) {
            let defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            let options = arguments.length > 3 ? arguments[3] : undefined;
            if (!_this.isStatsigInitialized) {
                console.warn('Statsig client not initialized.');
                return defaultValue;
            }
            if (_this.overrides[experimentName] !== undefined && _this.overrides[experimentName][propertyName] !== undefined) return _this.overrides[experimentName][propertyName];
            const evaluatedValue = (0, $8z3dZ.default).getExperimentValue(experimentName, propertyName, defaultValue, options);
            _this.evaluatedExperiments = $e134fc1d6577ca86$var$_objectSpread($e134fc1d6577ca86$var$_objectSpread({}, _this.evaluatedExperiments), {}, {
                [experimentName]: $e134fc1d6577ca86$var$_objectSpread($e134fc1d6577ca86$var$_objectSpread({}, _this.evaluatedExperiments[experimentName]), {}, {
                    [propertyName]: evaluatedValue
                })
            });
            return evaluatedValue;
        });
        (0, $5zQU9.default)(this, "checkGate", function(gateName) {
            let defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            if (!_this.isStatsigInitialized) {
                console.warn('Statsig client not initialized.');
                return defaultValue;
            }
            if (_this.overrides[gateName] !== undefined) return Boolean(_this.overrides[gateName]);
            const evaluatedValue = (0, $8z3dZ.default).checkGate(gateName);
            _this.evaluatedFlags[gateName] = evaluatedValue;
            return evaluatedValue;
        });
        (0, $5zQU9.default)(this, "initializeStatsigClientWithValues", async (_ref, source)=>{
            let { marketplaceAnonymousId: marketplaceAnonymousId, environment: environment, targetApp: targetApp, clientSdkKey: clientSdkKey, experimentValues: experimentValues, customAttributes: customAttributes } = _ref;
            this.source = source;
            await (0, $8z3dZ.default).initializeFromValues({
                environment: environment,
                targetApp: targetApp,
                sdkKey: clientSdkKey
            }, {
                marketplaceAnonymousId: marketplaceAnonymousId
            }, customAttributes, experimentValues);
            this.isStatsigInitialized = true;
        });
        (0, $5zQU9.default)(this, "setOverride", (overrideValues)=>{
            this.overrides = overrideValues;
        });
        (0, $5zQU9.default)(this, "getEvaluatedFlags", ()=>{
            return this.evaluatedFlags;
        });
        (0, $5zQU9.default)(this, "getEvaluatedExperiments", ()=>{
            return this.evaluatedExperiments;
        });
        // ---------------------- Experiments EMCEE-------------------------
        /**
     * discussion: https://atlassian.enterprise.slack.com/archives/C04PR2YE4UC/p1725317404567309?thread_ts=1725277152.022099&channel=C04PR2YE4UC&message_ts=1725317404.567309
     * suggests that the exposures from the other target apps will cause issues, and recommends either suppressing the experiment or adding an in-code check
     **/ (0, $5zQU9.default)(this, "enableEmceeAetherExperience", ()=>{
            if (this.source !== 'PRODUCT') return false;
            return this.getExperimentValue('enable_emcee_aether_experiment_by_tenant', 'isExperienceEnabled', false);
        });
        // ---------------------- Experiments MPAC-------------------------
        (0, $5zQU9.default)(this, "enableAetherExperience", ()=>{
            // this event is only for MPAC, for else return false
            if (this.source === 'PRODUCT') return false;
            return this.checkGate('enable_aether_experience', false);
        });
        (0, $5zQU9.default)(this, "enableNlpSearch", function() {
            let { fireExperimentExposure: fireExperimentExposure = false } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
            if (_this.source === 'PRODUCT') return false;
            if (_this.source === 'MPAC') return _this.getExperimentValue('enable_mpac_nlp_search_experiment', 'isExperienceEnabled', false, {
                fireExperimentExposure: fireExperimentExposure
            });
            return false;
        });
        // ---------------------- Feature Flags ----------------------
        (0, $5zQU9.default)(this, "enableStaffPickOnAppListing", ()=>{
            return this.checkGate('enable_staff_pick_on_app_listing');
        });
        (0, $5zQU9.default)(this, "showAnnouncementBannerInResourcesTab", ()=>{
            return this.checkGate('show_announcement_banner_in_resources_tab');
        });
        (0, $5zQU9.default)(this, "enableAetherSearchOverlay", ()=>{
            return this.checkGate('enable_aether_search_overlay');
        });
        (0, $5zQU9.default)(this, "enableAetherSearchEmbedded", ()=>{
            return this.checkGate('enable_aether_embedded_search_experience');
        });
        (0, $5zQU9.default)(this, "showCompassApps", ()=>{
            return this.checkGate('show_compass_apps');
        });
        (0, $5zQU9.default)(this, "showNewJiraSoftwareLabel", ()=>{
            return this.checkGate('show_new_jira_software_label');
        });
        (0, $5zQU9.default)(this, "enableMosaicPartnerProfileExperience", ()=>{
            return this.checkGate('enable_mosaic_partner_profile_experience');
        });
        (0, $5zQU9.default)(this, "showChangemakersCollectionTile", ()=>{
            return this.checkGate('show_changemakers_collection_tile');
        });
        (0, $5zQU9.default)(this, "showAtlassianRovoCollectionTile", ()=>{
            return this.checkGate('enable_atlassian_rovo_marketplace_collection');
        });
        (0, $5zQU9.default)(this, "enableAetherBenefitsModal", ()=>{
            return this.checkGate('enable_aether_benefits_modal');
        });
        (0, $5zQU9.default)(this, "enableAetherFeedbackCollector", ()=>{
            return this.checkGate('enable_aether_feedback_collector');
        });
        (0, $5zQU9.default)(this, "enableAetherAppListingPage", ()=>{
            if (this.enableEmceeAetherExperience()) return true;
            if (this.enableAetherExperience()) return this.checkGate('enable_aether_applisting_page');
            return false;
        });
        (0, $5zQU9.default)(this, "enableCurrentUserApiViaStoreBff", ()=>{
            return this.checkGate('enable_current_user_api_via_store_bff');
        });
        (0, $5zQU9.default)(this, "enableTeamsWithMakerIntegration", ()=>{
            return this.checkGate('partner_teams_tab_maker_integration');
        });
        (0, $5zQU9.default)(this, "displayAuditTabInManagePartnerPage", ()=>{
            return this.checkGate('display_audit_tab_in_manage_partner_page');
        });
        (0, $5zQU9.default)(this, "enableAlgoliaCallOnAppListingAndDialogs", ()=>{
            return this.checkGate('enable_algolia_call_on_applising_and_dialogs');
        });
        (0, $5zQU9.default)(this, "enablePartnerUserApiViaConsoleBffGql", ()=>{
            return this.checkGate('enable_partner_user_api_via_console_bff_gql');
        });
        (0, $5zQU9.default)(this, "showUpdatedPartnerTierMessage", ()=>this.checkGate('partner_tier_messaging_update'));
        // ---------------------- Permanent Feature Flags ----------------------
        (0, $5zQU9.default)(this, "showAppListingTrustTab", ()=>{
            // https://switcheroo.atlassian.com/ui/gates/1301e2c9-053a-4d13-9697-b06d84d481bf
            return this.checkGate('show_applisting_trust_tab');
        });
    }
    async initWithStatsigGlobalInstance(source) {
        // for jira and connie the statsig client is already initialized globally
        // we cannot pass the custom attributes as statsig is initialized in their backend
        this.isStatsigInitialized = true;
        this.source = source;
    }
    // IMPORTANT: Calling this method will completely re-initialize the client with a new set of flags. You will need to re-render the entire page after this completes to ensure everything picks up the new flag values. You should avoid using this frequently as it has implications on the user experience.
    async initializeStatsigClient(_ref2) {
        let { clientKey: clientKey, environment: environment, targetApp: targetApp, marketplaceAnonymousId: marketplaceAnonymousId, tenantId: tenantId, atlassianAccountId: atlassianAccountId } = _ref2;
        let customAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        let source = arguments.length > 2 ? arguments[2] : undefined;
        this.source = source;
        try {
            await (0, $8z3dZ.default).initialize({
                apiKey: clientKey,
                environment: environment,
                targetApp: targetApp,
                fetchTimeoutMs: 5000
            }, {
                marketplaceAnonymousId: marketplaceAnonymousId,
                tenantId: tenantId,
                atlassianAccountId: atlassianAccountId
            }, customAttributes);
            this.isStatsigInitialized = true;
        } catch (err) {
            console.error('Failed to initialize FeatureGates client.', err);
        }
    }
}
var $e134fc1d6577ca86$export$2e2bcd8739ae039 = $e134fc1d6577ca86$export$189a85bb51d82b2e;

});


parcelRegister("aB8Wc", function(module, exports) {

$parcel$export(module.exports, "SearchOverlay", () => $7b744aeebd7023df$export$d21daa44c5434d21);
/* SearchOverlay.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $l9NvU = parcelRequire("l9NvU");
var $fHOFY = parcelRequire("fHOFY");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $lMOk7 = parcelRequire("lMOk7");
var $cpR7D = parcelRequire("cpR7D");

var $9AuiZ = parcelRequire("9AuiZ");

var $ag464 = parcelRequire("ag464");

var $lHkHI = parcelRequire("lHkHI");
const $7b744aeebd7023df$var$_excluded = [
    "as",
    "style"
], $7b744aeebd7023df$var$_excluded2 = [
    "as",
    "style"
];
function $7b744aeebd7023df$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7b744aeebd7023df$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7b744aeebd7023df$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7b744aeebd7023df$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $7b744aeebd7023df$var$FullWidthSearchDropdown = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $7b744aeebd7023df$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7b744aeebd7023df$var$_objectSpread($7b744aeebd7023df$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1pbyjbo9 _11q76ota",
            __cmplp.className
        ])
    }));
});
const $7b744aeebd7023df$var$Overlay = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $7b744aeebd7023df$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7b744aeebd7023df$var$_objectSpread($7b744aeebd7023df$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1ule _11q76ota _2rko1j6v _18s81dzm _1bsb1c3h _kqswstnw _154i1fqw _1ltv1ssb _t9eczr6s",
            __cmplp.className
        ])
    }));
});
function $7b744aeebd7023df$export$d21daa44c5434d21(_ref3) {
    let { onClose: onClose, analytics: analytics } = _ref3;
    const { value: screenSize } = (0, $cpR7D.useResponsiveBreakpoint)();
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const handleViewedAnalytics = (_ref4)=>{
        let { query: query, suggestionSource: suggestionSource, count: count } = _ref4;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.SearchOverlayViewEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).SEARCH_OVERLAY_VIEW,
            source: analytics.source,
            attributes: {
                query: query,
                suggestionSource: suggestionSource,
                count: count
            }
        });
    };
    const handleSearchItemSelectionAnalytics = (_ref5)=>{
        let { query: query, position: position, popularity: popularity, suggestionSource: suggestionSource, count: count } = _ref5;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.SearchOverlaySuggestionClickEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).SEARCH_OVERLAY_ITEM_SELECTED,
            source: analytics.source,
            attributes: {
                query: query,
                position: position,
                popularity: popularity,
                suggestionSource: suggestionSource,
                count: count
            }
        });
    };
    const handleEnterKeyPressAnalytics = (_ref6)=>{
        let { query: query, suggestionSource: suggestionSource, count: count } = _ref6;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.SearchOverlayEnterKeyEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).SEARCH_OVERLAY_ENTER_KEY_PRESSED,
            source: analytics.source,
            attributes: {
                query: query,
                position: -1,
                suggestionSource: suggestionSource,
                count: count
            }
        });
    };
    const searchInput = /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ag464.SearchDropdownOverlay), {
        onViewed: handleViewedAnalytics,
        closeOverlay: onClose,
        onSuggestionSelection: handleSearchItemSelectionAnalytics,
        onEnterKeyPress: handleEnterKeyPressAnalytics
    });
    if (screenSize <= (0, $lMOk7.breakpointValues).sm) return /*#__PURE__*/ (0, $lHkHI.jsx)($7b744aeebd7023df$var$FullWidthSearchDropdown, {
        children: searchInput
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fHOFY.default), {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l9NvU.default), {
            label: "Search input",
            onClose: onClose,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)($7b744aeebd7023df$var$Overlay, {
                children: searchInput
            })
        })
    });
}

});
parcelRegister("lMOk7", function(module, exports) {

$parcel$export(module.exports, "breakpointValues", () => $fdc51de3e110806f$export$ff13e982ca5afe86);
$parcel$export(module.exports, "Breakpoint", () => $fdc51de3e110806f$export$114247090b0aae30);
// https://atlassian.design/components/primitives/responsive/breakpoints
const $fdc51de3e110806f$export$ff13e982ca5afe86 = {
    xxs: 0,
    xs: 480,
    sm: 768,
    md: 1024,
    lg: 1440,
    xl: 1760
};
let $fdc51de3e110806f$export$114247090b0aae30 = /*#__PURE__*/ function(Breakpoint) {
    Breakpoint["xxs"] = "xxs";
    Breakpoint["xs"] = "xs";
    Breakpoint["sm"] = "sm";
    Breakpoint["md"] = "md";
    Breakpoint["lg"] = "lg";
    Breakpoint["xl"] = "xl";
    return Breakpoint;
}({});
const $fdc51de3e110806f$export$d3b55241f5c2bf93 = Object.values($fdc51de3e110806f$export$114247090b0aae30);

});

parcelRegister("cpR7D", function(module, exports) {

$parcel$export(module.exports, "useResponsiveBreakpoint", () => $90a106cc5f1e8676$export$6dde8b0e67ca9bc0);

var $dxIU5 = parcelRequire("dxIU5");

var $eUqFw = parcelRequire("eUqFw");

var $lMOk7 = parcelRequire("lMOk7");
const $90a106cc5f1e8676$export$6dde8b0e67ca9bc0 = ()=>{
    const [rawWidth, setRawWidth] = (0, $eUqFw.useState)(window.innerWidth);
    const [breakpoint, setBreakpoint] = (0, $eUqFw.useState)(()=>getBreakpoint());
    function getBreakpoint() {
        const width = window.innerWidth;
        if (width < (0, $lMOk7.breakpointValues).xs) return {
            value: (0, $lMOk7.breakpointValues).xxs,
            id: (0, $lMOk7.Breakpoint).xxs
        };
        if (width < (0, $lMOk7.breakpointValues).sm) return {
            value: (0, $lMOk7.breakpointValues).xs,
            id: (0, $lMOk7.Breakpoint).xs
        };
        if (width < (0, $lMOk7.breakpointValues).md) return {
            value: (0, $lMOk7.breakpointValues).sm,
            id: (0, $lMOk7.Breakpoint).sm
        };
        if (width < (0, $lMOk7.breakpointValues).lg) return {
            value: (0, $lMOk7.breakpointValues).md,
            id: (0, $lMOk7.Breakpoint).md
        };
        if (width < (0, $lMOk7.breakpointValues).xl) return {
            value: (0, $lMOk7.breakpointValues).lg,
            id: (0, $lMOk7.Breakpoint).lg
        };
        return {
            value: (0, $lMOk7.breakpointValues).xl,
            id: (0, $lMOk7.Breakpoint).xl
        };
    }
    (0, $eUqFw.useEffect)(()=>{
        const calcInnerWidth = (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))(()=>{
            setBreakpoint(getBreakpoint());
            setRawWidth(window.innerWidth);
        }, 200);
        window.addEventListener('resize', calcInnerWidth);
        return ()=>window.removeEventListener('resize', calcInnerWidth);
    }, []);
    return {
        value: breakpoint.value,
        id: breakpoint.id,
        rawWidth: rawWidth
    };
};

});

parcelRegister("9AuiZ", function(module, exports) {

$parcel$export(module.exports, "HIGHLIGHT_PRE_TAG", () => $6faefbd27ef321f2$export$2df5424f792538bd);
$parcel$export(module.exports, "HIGHLIGHT_POST_TAG", () => $6faefbd27ef321f2$export$2681d4c6a4ae86);
$parcel$export(module.exports, "SEARCH_INDEX_NAME", () => $6faefbd27ef321f2$export$86fae1fa872d8847);
$parcel$export(module.exports, "AutoCompleteStatusValues", () => $6faefbd27ef321f2$export$5609876b666ac3a3);
$parcel$export(module.exports, "desktopPlaceholder", () => $6faefbd27ef321f2$export$f158b34e207bb3aa);
$parcel$export(module.exports, "mobilePlaceholder", () => $6faefbd27ef321f2$export$3a02b80511d3131e);
$parcel$export(module.exports, "embeddedPlaceholder", () => $6faefbd27ef321f2$export$990eaf55768d2f08);
$parcel$export(module.exports, "inProductPlaceholder", () => $6faefbd27ef321f2$export$b1960ca0e3cd64f3);
$parcel$export(module.exports, "BODY_STATES", () => $6faefbd27ef321f2$export$3ab3e2ad453df1ad);
$parcel$export(module.exports, "ANALYTICS_ACTION_SUBJECT_ID", () => $6faefbd27ef321f2$export$4b2f4d2c3169cefb);
$parcel$export(module.exports, "ANALYTICS", () => $6faefbd27ef321f2$export$ae00ae4e61a620eb);
/* We use parseAlgoliaHitHighlight() from @algolia/autocomplete-preset-algolia
  There's a limitation of this function, that it only parses the highlight for following
  highlightPreTag and highlightPostTag. Hence we are passing same as arguments when fetching search results.
*/ const $6faefbd27ef321f2$export$2df5424f792538bd = '__aa-highlight__';
const $6faefbd27ef321f2$export$2681d4c6a4ae86 = '__/aa-highlight__';
const $6faefbd27ef321f2$export$86fae1fa872d8847 = 'marketplace_plugins_prod_v2_query_suggestions';
const $6faefbd27ef321f2$export$5609876b666ac3a3 = {
    IDLE: 'idle',
    LOADING: 'loading',
    STALLED: 'stalled',
    ERROR: 'error'
};
const $6faefbd27ef321f2$export$f158b34e207bb3aa = 'Type your search query here';
const $6faefbd27ef321f2$export$3a02b80511d3131e = 'Search for apps';
const $6faefbd27ef321f2$export$990eaf55768d2f08 = 'Search for apps within Marketplace';
const $6faefbd27ef321f2$export$b1960ca0e3cd64f3 = 'Search for apps';
const $6faefbd27ef321f2$export$3ab3e2ad453df1ad = {
    LOADING: 'loading',
    SEARCH_RESULTS: 'searchResults',
    RECENT_SEARCHES: 'recentSearches',
    EMPTY_STATE: 'emptyState',
    API_FAILURE: 'apiFailure',
    NO_SUGGESTIONS: 'noSuggestions',
    NO_BODY: 'noBody'
};
const $6faefbd27ef321f2$export$4b2f4d2c3169cefb = {
    FILTER_OPTION_SELECTED: 'filterOptionSelected',
    CLEAR_FILTER_CLICKED: 'clearFilterClicked',
    CLEAR_ALL_FILTERS_CLICKED: 'clearAllFiltersClicked',
    SEARCH_TILES_RENDERED: 'searchTilesRendered',
    SEARCH_TILE_CLICKED: 'searchTileClicked',
    LOAD_MORE_CLICKED: 'loadMoreClicked',
    APPLY_FILTERS_CLICKED: 'applyFiltersClicked',
    YOUR_SEARCH_QUERY_CLICKED: 'yourSearchQueryClicked',
    FILTER_OPTIONS_ERROR_RENDERED: 'filterOptionsErrorRendered',
    SEARCH_EMBEDDED_VIEW: 'searchEmbeddedViewed',
    SEARCH_EMBEDDED_ITEM_SELECTED: 'searchEmbeddedItemSelected',
    SEARCH_EMBEDDED_ENTER_KEY_PRESSED: 'searchEmbeddedEnterKeyPressed',
    SEARCH_OVERLAY_VIEW: 'searchOverlayViewed',
    SEARCH_OVERLAY_ITEM_SELECTED: 'searchOverlayItemSelected',
    SEARCH_OVERLAY_ENTER_KEY_PRESSED: 'searchOverlayEnterKeyPressed'
};
const $6faefbd27ef321f2$export$ae00ae4e61a620eb = {
    GLOBAL: 'global',
    INITIAL: 'initial',
    LOAD_MORE: 'load more'
};

});

parcelRegister("ag464", function(module, exports) {

$parcel$export(module.exports, "SearchDropdownOverlay", () => $777e939664e9f1cd$export$18bef0261b4c8faf);
/* SearchDropdownOverlay.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $lMOk7 = parcelRequire("lMOk7");
var $cpR7D = parcelRequire("cpR7D");

var $dM9ZW = parcelRequire("dM9ZW");

var $c0qPT = parcelRequire("c0qPT");

var $ai7SS = parcelRequire("ai7SS");

var $hCl9L = parcelRequire("hCl9L");

var $9AuiZ = parcelRequire("9AuiZ");

var $gCUJI = parcelRequire("gCUJI");

var $118My = parcelRequire("118My");

var $fItra = parcelRequire("fItra");

var $dMD7U = parcelRequire("dMD7U");

var $POywL = parcelRequire("POywL");

var $7RGla = parcelRequire("7RGla");

var $8qFnR = parcelRequire("8qFnR");

var $eEXJs = parcelRequire("eEXJs");

var $lHkHI = parcelRequire("lHkHI");
const $777e939664e9f1cd$var$_excluded = [
    "as",
    "style"
], $777e939664e9f1cd$var$_excluded2 = [
    "mobileVisibility"
], $777e939664e9f1cd$var$_excluded3 = [
    "as",
    "style"
];
function $777e939664e9f1cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $777e939664e9f1cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $777e939664e9f1cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $777e939664e9f1cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $777e939664e9f1cd$var$Separator = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $777e939664e9f1cd$var$_excluded);
    const { mobileVisibility: mobileVisibility } = __cmplp, __cmpldp = (0, $bwPfh.default)(__cmplp, $777e939664e9f1cd$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $777e939664e9f1cd$var$_objectSpread($777e939664e9f1cd$var$_objectSpread({}, __cmpldp), {}, {
        style: $777e939664e9f1cd$var$_objectSpread($777e939664e9f1cd$var$_objectSpread({}, __cmpls), {}, {
            "--_2rzkic": (0, $9t7rW.default)("".concat(__cmplp.height, "px solid ", "var(--ds-border)"))
        }),
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n7zlsj58 _dm251ule",
            __cmplp.mobileVisibility ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    }));
});
const $777e939664e9f1cd$var$Header = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $777e939664e9f1cd$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $777e939664e9f1cd$var$_objectSpread($777e939664e9f1cd$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1yt4ot5x _1e0c1txw _4cvr1h6o _zulp1eps _syaz1jij _1yagxgen",
            __cmplp.className
        ])
    }));
});
// RECENT SEARCH HANDLINGS
const $777e939664e9f1cd$var$recentSearch = new (0, $gCUJI.RecentSearch)(5, 'mpac-search-recent-searches');
function $777e939664e9f1cd$export$18bef0261b4c8faf(_ref3) {
    let { closeOverlay: closeOverlay, onViewed: onViewed, onSuggestionSelection: onSuggestionSelection, onEnterKeyPress: onEnterKeyPress, backButtonRef: backButtonRef, additionalQueryParams: additionalQueryParams = {} } = _ref3;
    // LOCATION HANDLINGS
    const { query: queryFromUrl } = (0, $dM9ZW.useQueryParams)();
    const locationHref = (0, $dM9ZW.useLocationHref)();
    const history = (0, $dM9ZW.useHistory)();
    const source = (0, $c0qPT.useSource)();
    const mountPath = (0, $c0qPT.useMountPath)();
    // AUTOCOMPLETE HANDLINGS
    const inputRef = (0, $eUqFw.useRef)(null);
    const searchSuggestionCountRef = (0, $eUqFw.useRef)(0);
    const hasFiredViewedAnalyticsRef = (0, $eUqFw.useRef)(false);
    const handleNewSearch = (0, $eUqFw.useCallback)((hit)=>{
        var _inputRef$current, _hit$__autocomplete_i;
        const inputValue = (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.value;
        onSuggestionSelection({
            query: hit.query,
            position: ((_hit$__autocomplete_i = hit.__autocomplete_id) !== null && _hit$__autocomplete_i !== void 0 ? _hit$__autocomplete_i : 0) + 1,
            popularity: hit.popularity,
            suggestionSource: (0, $hCl9L.getSuggestionSource)(!!inputValue),
            count: inputValue ? searchSuggestionCountRef.current : $777e939664e9f1cd$var$recentSearch.count()
        });
        $777e939664e9f1cd$var$recentSearch.push(hit);
        (0, $118My.redirectToNewQuery)({
            query: hit.query,
            locationHref: locationHref,
            history: history,
            additionalQueryParams: additionalQueryParams,
            source: source,
            mountPath: mountPath
        });
        closeOverlay();
    }, [
        locationHref,
        history,
        closeOverlay,
        onSuggestionSelection
    ]);
    const onFormSubmit = (query)=>{
        handleEnterKeyPress(query);
        closeOverlay();
    };
    const { value: breakpoint } = (0, $cpR7D.useResponsiveBreakpoint)();
    const isMobile = breakpoint < (0, $lMOk7.breakpointValues).md;
    const { autocomplete: autocomplete, autocompleteState: autocompleteState } = (0, $ai7SS.useAlgoliaAutocomplete)(inputRef, isMobile ? (0, $9AuiZ.mobilePlaceholder) : (0, $9AuiZ.desktopPlaceholder), queryFromUrl, handleNewSearch, $777e939664e9f1cd$var$recentSearch);
    const { handleAppend: handleAppend, handleEnterKeyPress: handleEnterKeyPress, clearRecentSearches: clearRecentSearches, clearSearchInput: clearSearchInput } = (0, $8qFnR.useSearchDropdown)({
        inputRef: inputRef,
        autocomplete: autocomplete,
        autocompleteState: autocompleteState,
        recentSearch: $777e939664e9f1cd$var$recentSearch,
        onEnterKeyPress: onEnterKeyPress,
        additionalQueryParams: additionalQueryParams
    });
    // BODY STATE HANDLINGS
    const { bodyState: bodyState } = (0, $7RGla.useAutocompleteState)({
        autocompleteState: autocompleteState
    });
    const searchSuggestionProps = {
        hits: autocompleteState.collections,
        autocomplete: autocomplete,
        onAppend: handleAppend
    };
    (0, $eUqFw.useEffect)(()=>{
        var _autocompleteState$co, _autocompleteState$co2, _autocompleteState$co3;
        searchSuggestionCountRef.current = (_autocompleteState$co = (_autocompleteState$co2 = autocompleteState.collections[0]) === null || _autocompleteState$co2 === void 0 ? void 0 : (_autocompleteState$co3 = _autocompleteState$co2.items) === null || _autocompleteState$co3 === void 0 ? void 0 : _autocompleteState$co3.length) !== null && _autocompleteState$co !== void 0 ? _autocompleteState$co : 0;
    }, [
        bodyState,
        autocompleteState
    ]);
    (0, $eUqFw.useEffect)(()=>{
        autocomplete.refresh();
    }, []);
    (0, $eEXJs.useSearchViewAnalytics)({
        showSuggestionPopup: true,
        inputRef: inputRef,
        isQueryFromUrl: !!queryFromUrl,
        onViewed: onViewed,
        recentSearch: $777e939664e9f1cd$var$recentSearch,
        hasFiredViewedAnalyticsRef: hasFiredViewedAnalyticsRef,
        autocompleteState: autocompleteState,
        bodyState: bodyState
    });
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($777e939664e9f1cd$var$Header, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $POywL.SearchHeader), {
                    autocomplete: autocomplete,
                    ref: inputRef,
                    handleEnterKeyPress: onFormSubmit,
                    handleBackClick: closeOverlay,
                    clearSearchInput: clearSearchInput,
                    isEmbedded: false,
                    backButtonRef: backButtonRef
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($777e939664e9f1cd$var$Separator, {
                height: 2,
                mobileVisibility: true
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                role: "status",
                "aria-live": "assertive",
                "aria-relevant": "additions",
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fItra.SearchBodyFactory), {
                    type: bodyState,
                    searchQuerySuggestionsBodyProps: $777e939664e9f1cd$var$_objectSpread({
                        query: autocompleteState.query
                    }, searchSuggestionProps),
                    searchLoadingProps: {
                        query: autocompleteState.query
                    },
                    recentSearchBodyProps: $777e939664e9f1cd$var$_objectSpread({
                        onClearAll: clearRecentSearches
                    }, searchSuggestionProps),
                    noSuggestionsBodyProps: {
                        query: autocompleteState.query
                    }
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($777e939664e9f1cd$var$Separator, {
                height: 1,
                mobileVisibility: false
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dMD7U.SearchFooter), {
                closeOverlay: closeOverlay
            })
        ]
    });
}

});
parcelRegister("dM9ZW", function(module, exports) {

$parcel$export(module.exports, "useLocation", () => $a07783720b17fb4a$export$45d76561a5302f2b);
$parcel$export(module.exports, "useLocationHref", () => $a07783720b17fb4a$export$49fc3f3d8c7f99);
$parcel$export(module.exports, "useHistory", () => $a07783720b17fb4a$export$3420e1dc2c4a518c);
$parcel$export(module.exports, "useQueryParams", () => $a07783720b17fb4a$export$b37ee0d76c6d2fbc);

var $5zQU9 = parcelRequire("5zQU9");

var $c9Mth = parcelRequire("c9Mth");

var $kt9Cs = parcelRequire("kt9Cs");

var $eUqFw = parcelRequire("eUqFw");

var $2j88s = parcelRequire("2j88s");
function $a07783720b17fb4a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a07783720b17fb4a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a07783720b17fb4a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a07783720b17fb4a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $a07783720b17fb4a$export$45d76561a5302f2b() {
    const { location: location } = (0, $eUqFw.useContext)((0, $2j88s.default));
    return location;
}
const $a07783720b17fb4a$export$49fc3f3d8c7f99 = ()=>{
    const location = $a07783720b17fb4a$export$45d76561a5302f2b();
    if (typeof location === 'string') return location;
    const { pathname: pathname, search: search } = location;
    return "".concat(pathname).concat(search);
};
function $a07783720b17fb4a$export$3420e1dc2c4a518c() {
    const { history: history } = (0, $eUqFw.useContext)((0, $2j88s.default));
    return history;
}
function $a07783720b17fb4a$export$99eaa27ddbbb95ef() {
    const { match: match } = (0, $eUqFw.useContext)((0, $2j88s.default));
    return match ? match.params : {};
}
function $a07783720b17fb4a$export$b37ee0d76c6d2fbc() {
    const { search: search } = $a07783720b17fb4a$export$45d76561a5302f2b();
    return $kt9Cs.parse(search || '');
}
function $a07783720b17fb4a$export$cb5afe0593c0213f(queryParam) {
    const queryParams = $a07783720b17fb4a$export$b37ee0d76c6d2fbc();
    const history = $a07783720b17fb4a$export$3420e1dc2c4a518c();
    const currentPath = window.location.href;
    const updatedPath = (0, $c9Mth).unsetQueryParam(window.location.href, queryParam);
    if (!currentPath.endsWith(updatedPath)) history === null || history === void 0 || history.replace(updatedPath);
    return queryParams[queryParam];
}
const $a07783720b17fb4a$export$1fc7227ddad78bcb = (paramValidation)=>{
    const { search: oldSearch, pathname: pathname } = $a07783720b17fb4a$export$45d76561a5302f2b();
    const queryParams = $kt9Cs.parse(oldSearch || '');
    const updatedQueryParams = $a07783720b17fb4a$var$_objectSpread({}, queryParams);
    let hasInvalidOrMissingParams = false;
    Object.keys(paramValidation).forEach((key)=>{
        const { validate: validate, defaultValue: defaultValue } = paramValidation[key];
        const originalValue = queryParams[key];
        const isMissingValue = typeof originalValue === 'undefined' && typeof defaultValue !== 'undefined';
        const isValidValue = validate ? validate(originalValue) : true;
        if (isMissingValue || !isValidValue) {
            hasInvalidOrMissingParams = true;
            updatedQueryParams[key] = defaultValue;
        }
    });
    const updatedQueryString = $kt9Cs.stringify(updatedQueryParams);
    const updatedSearch = updatedQueryString ? "?".concat(updatedQueryString) : '';
    const redirectRoute = hasInvalidOrMissingParams ? pathname + updatedSearch : null;
    return {
        redirectRoute: redirectRoute,
        queryParams: updatedQueryParams
    };
};

});
parcelRegister("c9Mth", function(module, exports) {

$parcel$export(module.exports, "foldImmutableQueryValue", () => $8d9becace223ea55$export$ec2cc0d104405d89);
$parcel$export(module.exports, "resolveImmutableQuery", () => $8d9becace223ea55$export$2f29c6d56345bc56);
$parcel$export(module.exports, "resolveSearchFromImmutableQuery", () => $8d9becace223ea55$export$9e7e24308e926219);
$parcel$export(module.exports, "resolveUrlFromTemplateAndParameters", () => $8d9becace223ea55$export$10644f36e75cf071);
$parcel$export(module.exports, "transformUriTemplateToRoutePath", () => $8d9becace223ea55$export$245832c1b751eda7);
$parcel$export(module.exports, "transformRoutePathToUriTemplate", () => $8d9becace223ea55$export$938373130bd7fa6a);
$parcel$export(module.exports, "validateSafeAbsoluteUrl", () => $8d9becace223ea55$export$4e26b30a7632545f);
$parcel$export(module.exports, "updateQueryParam", () => $8d9becace223ea55$export$7ae7176e19061de2);
$parcel$export(module.exports, "unsetQueryParam", () => $8d9becace223ea55$export$948ccc3319401bd9);
$parcel$export(module.exports, "getLocationPath", () => $8d9becace223ea55$export$3cb209e120f6c244);
$parcel$export(module.exports, "getSupportTicketNumber", () => $8d9becace223ea55$export$27993c66b241fcf3);
$parcel$export(module.exports, "joinPathNames", () => $8d9becace223ea55$export$36dee12cc8f9a22a);
$parcel$export(module.exports, "removeDomainFromUrl", () => $8d9becace223ea55$export$daba15f6f1abfa21);
$parcel$export(module.exports, "removeQueryParamsFromUrl", () => $8d9becace223ea55$export$8189558ac52562eb);

var $bwPfh = parcelRequire("bwPfh");

var $5zQU9 = parcelRequire("5zQU9");

var $g5DHJ = parcelRequire("g5DHJ");

var $kt9Cs = parcelRequire("kt9Cs");

var $k4nIh = parcelRequire("k4nIh");

var $asbhz = parcelRequire("asbhz");
function $8d9becace223ea55$var$_toPropertyKey(t) {
    var i = $8d9becace223ea55$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $8d9becace223ea55$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $8d9becace223ea55$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8d9becace223ea55$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8d9becace223ea55$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8d9becace223ea55$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8d9becace223ea55$export$ec2cc0d104405d89(iqv) {
    return function(string, set) {
        if (typeof iqv === 'string') return string(iqv);
        else if ((0, $g5DHJ.Set).isSet(iqv)) return set(iqv);
        else throw new TypeError("foldResolvedImmutableQueryValue is not comprehensive in ResolvedImmutableQueryValue: ".concat(JSON.stringify(iqv)));
    };
}
function $8d9becace223ea55$export$2f29c6d56345bc56(search) {
    const immutableMap = (0, $g5DHJ.fromJS)((0, (/*@__PURE__*/$parcel$interopDefault($kt9Cs))).parse(search), (_key, value)=>(0, $g5DHJ.Collection).isIndexed(value) ? value.toSet() : value.toMap());
    return immutableMap;
}
function $8d9becace223ea55$export$9e7e24308e926219(query) {
    const stringifiedQuery = $8d9becace223ea55$var$stringifyImmutableQuery(query);
    return stringifiedQuery ? "?".concat(stringifiedQuery) : '';
}
const $8d9becace223ea55$var$filterEmptyStringsFromQuery = (queryObject)=>{
    return Object.entries(queryObject).filter((_ref)=>{
        let [_, v] = _ref;
        return !(typeof v === 'string' && v.trim() === '');
    }).reduce((res, _ref2)=>{
        let [k, _] = _ref2;
        res[k] = queryObject[k];
        return res;
    }, {});
};
function $8d9becace223ea55$var$stringifyImmutableQuery(query) {
    const queryObject = query && query.toJS();
    return queryObject ? (0, (/*@__PURE__*/$parcel$interopDefault($kt9Cs))).stringify($8d9becace223ea55$var$filterEmptyStringsFromQuery(queryObject)) : '';
}
function $8d9becace223ea55$export$10644f36e75cf071(options) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(options.template).expand(options.parameters);
}
function $8d9becace223ea55$export$245832c1b751eda7(_ref3) {
    let { template: template } = _ref3;
    return template.replace(/{([^{}]+)}/g, (_, expression)=>":".concat(expression));
}
function $8d9becace223ea55$export$938373130bd7fa6a(_ref4) {
    let { routePath: routePath } = _ref4;
    return routePath// Remove route regex from the path ( <>/:param((\d+)) -> <>/:param )
    .replace(/ *\([^)]*\) */g, '')// convert Route Parameters to URI template expression ( <>/:param -> <>/{param} )
    .replace(/:([^/]+)/g, (_, expression)=>"{".concat(expression, "}"));
}
function $8d9becace223ea55$export$4e26b30a7632545f(url) {
    if (!url) return null;
    const urlObj = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, {});
    const scheme = urlObj.protocol.toLowerCase();
    switch(scheme){
        case 'http:':
        case 'https:':
            return url;
        default:
            return null;
    }
}
const $8d9becace223ea55$export$7ae7176e19061de2 = (url, paramName, paramValue)=>{
    const newUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, {}, true);
    const { query: query, pathname: pathname, hash: hash } = newUrl;
    const urlPath = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))('', {});
    urlPath.set('query', $8d9becace223ea55$var$_objectSpread($8d9becace223ea55$var$_objectSpread({}, query), {}, {
        [paramName]: paramValue
    })).set('pathname', pathname).set('hash', hash);
    return urlPath.toString();
};
const $8d9becace223ea55$export$948ccc3319401bd9 = (url, paramName)=>{
    const newUrl = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url, {}, true);
    const { query: query, pathname: pathname, hash: hash } = newUrl;
    const { [paramName]: _paramToRemove } = query, otherQueryParams = (0, $bwPfh.default)(query, [
        paramName
    ].map($8d9becace223ea55$var$_toPropertyKey));
    const urlPath = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))('', {});
    urlPath.set('query', $8d9becace223ea55$var$_objectSpread({}, otherQueryParams)).set('pathname', pathname).set('hash', hash);
    return urlPath.toString();
};
const $8d9becace223ea55$export$3cb209e120f6c244 = ()=>window.location.hash.split('#')[1].split('?')[0];
const $8d9becace223ea55$export$27993c66b241fcf3 = (url)=>url.split('/').pop();
const $8d9becace223ea55$export$36dee12cc8f9a22a = (pathNames)=>{
    const fullPath = pathNames.join('/');
    return fullPath.replace(/\/+/g, '/');
};
const $8d9becace223ea55$export$daba15f6f1abfa21 = (url)=>{
    const urlObject = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url);
    return urlObject.pathname + urlObject.query;
};
const $8d9becace223ea55$export$8189558ac52562eb = (url)=>{
    const urlObject = new (0, (/*@__PURE__*/$parcel$interopDefault($k4nIh)))(url);
    return urlObject.origin + urlObject.pathname;
};

});

parcelRegister("2j88s", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ae3aaa3993088af$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $1ae3aaa3993088af$var$defaultContextValue = {
    location: {},
    history: {},
    match: {},
    staticContext: {}
};
var $1ae3aaa3993088af$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($1ae3aaa3993088af$var$defaultContextValue);

});


parcelRegister("c0qPT", function(module, exports) {

$parcel$export(module.exports, "ApplicationConfigProvider", () => $8bda4d319329cc81$export$573ea730061074fd);
$parcel$export(module.exports, "useApplicationConfig", () => $8bda4d319329cc81$export$8bb18d9f2fcfba06);
$parcel$export(module.exports, "useEnvironment", () => $8bda4d319329cc81$export$ea7ed2425832167d);
$parcel$export(module.exports, "useHostUrl", () => $8bda4d319329cc81$export$78cfd5a06734c78e);
$parcel$export(module.exports, "useSource", () => $8bda4d319329cc81$export$fe488720f15adbf8);
$parcel$export(module.exports, "useMountPath", () => $8bda4d319329cc81$export$4987786278697d67);

var $1fIAX = parcelRequire("1fIAX");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $8bda4d319329cc81$var$ApplicationConfig = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $8bda4d319329cc81$export$573ea730061074fd = (_ref)=>{
    let { children: children, applicationConfig: applicationConfig } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsx)($8bda4d319329cc81$var$ApplicationConfig.Provider, {
        value: applicationConfig,
        children: children
    });
};
const $8bda4d319329cc81$export$8bb18d9f2fcfba06 = ()=>{
    return (0, $eUqFw.useContext)($8bda4d319329cc81$var$ApplicationConfig);
};
const $8bda4d319329cc81$export$ea7ed2425832167d = ()=>{
    const applicationConfig = $8bda4d319329cc81$export$8bb18d9f2fcfba06();
    const environment = applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.environment;
    if (!environment) throw new Error('useEnvironment must be used within a ApplicationConfigProvider');
    return environment;
};
const $8bda4d319329cc81$export$3cc557c49a8fd7f0 = ()=>{
    const applicationConfig = $8bda4d319329cc81$export$8bb18d9f2fcfba06();
    const algoliaConfig = applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.algoliaConfig;
    if (!algoliaConfig) throw new Error('useAlgoliaConfig must be used within a ApplicationConfigProvider');
    return algoliaConfig;
};
const $8bda4d319329cc81$export$78cfd5a06734c78e = ()=>{
    const applicationConfig = $8bda4d319329cc81$export$8bb18d9f2fcfba06();
    const hostUrl = applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.hostUrl;
    if (!hostUrl) throw new Error('useHostUrl must be used within a ApplicationConfigProvider');
    return hostUrl;
};
const $8bda4d319329cc81$export$fe488720f15adbf8 = ()=>{
    const applicationConfig = $8bda4d319329cc81$export$8bb18d9f2fcfba06();
    const source = applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.source;
    return source || (0, $1fIAX.Source).PRODUCT;
};
const $8bda4d319329cc81$export$4987786278697d67 = ()=>{
    const applicationConfig = $8bda4d319329cc81$export$8bb18d9f2fcfba06();
    const mountPath = applicationConfig === null || applicationConfig === void 0 ? void 0 : applicationConfig.mountPath;
    return mountPath || '';
};

});
parcelRegister("1fIAX", function(module, exports) {

$parcel$export(module.exports, "AlgoliaEnvironment", () => $0e99c8d163642c80$export$9270e4dc8b1c78c5);
$parcel$export(module.exports, "Source", () => $0e99c8d163642c80$export$1d2df86270c81ecb);
const $0e99c8d163642c80$export$9270e4dc8b1c78c5 = Object.freeze({
    DEV: 'dev',
    STG: 'stg',
    PROD: 'prod'
});
const $0e99c8d163642c80$export$1d2df86270c81ecb = Object.freeze({
    MPAC: 'MPAC',
    PRODUCT: 'PRODUCT'
});

});


parcelRegister("ai7SS", function(module, exports) {

$parcel$export(module.exports, "useAlgoliaAutocomplete", () => $77e1b37037d34f52$export$c548dd7dbbbc1dbd);

var $3RXHj = parcelRequire("3RXHj");

var $c0qPT = parcelRequire("c0qPT");

var $6BoHr = parcelRequire("6BoHr");

var $eUqFw = parcelRequire("eUqFw");

var $9AuiZ = parcelRequire("9AuiZ");

var $93D6q = parcelRequire("93D6q");

var $2pdRg = parcelRequire("2pdRg");
// TODO: Replace with value from bootstrap config
const $77e1b37037d34f52$var$searchClient = (0, (/*@__PURE__*/$parcel$interopDefault($6BoHr)))('7LVR1JKTDF', '3ef48f0fc67ee7e9c5a9dbbf6b45908c');
// eslint-disable-next-line max-lines-per-function
const $77e1b37037d34f52$export$c548dd7dbbbc1dbd = (inputRef, placeholder, initQuery, handleNewSearch, recentSearch)=>{
    const [autocompleteState, setAutocompleteState] = (0, $eUqFw.useState)({
        collections: [],
        completion: null,
        context: {},
        isOpen: false,
        query: '',
        activeItemId: null,
        status: 'idle'
    });
    const appConfig = (0, $c0qPT.useApplicationConfig)();
    const debouncedGetSources = (0, $eUqFw.useCallback)((_ref)=>{
        let { query: query } = _ref;
        if (!query) return [
            {
                sourceId: 'recentSearches',
                onSelect (_ref2) {
                    let { item: item } = _ref2;
                    handleNewSearch(item);
                },
                getItemUrl (_ref3) {
                    let { item: item } = _ref3;
                    return item;
                },
                getItems () {
                    return recentSearch.getRecentSearches();
                },
                // This sets the value in input field when user selects an item in dropdown
                getItemInputValue (_ref4) {
                    let { item: item } = _ref4;
                    return item.query;
                }
            }
        ];
        return (0, $93D6q.debounceAutoComplete)([
            {
                sourceId: 'querySuggestions',
                onSelect (_ref5) {
                    let { item: item } = _ref5;
                    handleNewSearch(item);
                },
                getItems () {
                    return $77e1b37037d34f52$var$searchClient.search([
                        {
                            indexName: (0, $9AuiZ.SEARCH_INDEX_NAME),
                            query: query,
                            params: {
                                hitsPerPage: 6,
                                snippetEllipsisText: "\u2026",
                                highlightPreTag: (0, $9AuiZ.HIGHLIGHT_PRE_TAG),
                                highlightPostTag: (0, $9AuiZ.HIGHLIGHT_POST_TAG)
                            }
                        }
                    ]).then((_ref6)=>{
                        let { results: results } = _ref6;
                        const firstResult = results[0];
                        const { hits: hits } = firstResult;
                        return (0, $2pdRg.filterSearchSuggestionsKeywords)({
                            hits: hits,
                            hostProductId: appConfig === null || appConfig === void 0 ? void 0 : appConfig.hostProductId,
                            query: query
                        });
                    }).catch((error)=>{
                        console.error('Error fetching query suggestions', error);
                        return [];
                    });
                },
                getItemUrl (_ref7) {
                    let { item: item } = _ref7;
                    return item;
                },
                // This sets the value in input field when user selects an item in dropdown
                getItemInputValue (_ref8) {
                    let { item: item } = _ref8;
                    return item.query;
                }
            }
        ]);
    }, [
        handleNewSearch,
        recentSearch
    ]);
    const autocomplete = (0, $eUqFw.useMemo)(()=>(0, $3RXHj.createAutocomplete)({
            id: 'search',
            placeholder: placeholder,
            openOnFocus: true,
            onStateChange (props) {
                setAutocompleteState(props.state);
            },
            getSources: debouncedGetSources,
            initialState: {
                query: initQuery
            },
            navigator: {
                // only called when user presses enter
                // not called when user clicked on a suggestion
                navigate (_ref9) {
                    let { item: item } = _ref9;
                    // slack discussion: https://atlassian.slack.com/archives/C05U00RCWAE/p1711440109816469
                    // handle the case when user has hover over a suggestion and pressed enter
                    // in this case, we should navigate to the input value and not the suggestion value
                    const queryFromInput = inputRef.current.value;
                    // if input value is same as hovered suggestion, then navigate to the suggestion because the item object has popularity and other details
                    if (item.query === queryFromInput) handleNewSearch(item);
                    else handleNewSearch({
                        query: queryFromInput,
                        objectID: queryFromInput
                    });
                }
            }
        }), [
        inputRef,
        initQuery,
        debouncedGetSources,
        handleNewSearch,
        placeholder
    ]);
    return {
        autocomplete: autocomplete,
        autocompleteState: autocompleteState
    };
};

});
parcelRegister("3RXHj", function(module, exports) {

$parcel$export(module.exports, "createAutocomplete", () => $2d14a10d0968a93a$export$b00b86c416695282);

var $cYoID = parcelRequire("cYoID");

var $5WnGV = parcelRequire("5WnGV");

var $9YOpx = parcelRequire("9YOpx");

var $Whdqp = parcelRequire("Whdqp");

var $8G3Ib = parcelRequire("8G3Ib");

var $3p1lt = parcelRequire("3p1lt");

var $kJ7uN = parcelRequire("kJ7uN");

var $1Ni2w = parcelRequire("1Ni2w");

var $2A1cy = parcelRequire("2A1cy");
function $2d14a10d0968a93a$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $2d14a10d0968a93a$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $2d14a10d0968a93a$var$_typeof(obj);
}
function $2d14a10d0968a93a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $2d14a10d0968a93a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $2d14a10d0968a93a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $2d14a10d0968a93a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $2d14a10d0968a93a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $2d14a10d0968a93a$var$_defineProperty(obj, key, value) {
    key = $2d14a10d0968a93a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $2d14a10d0968a93a$var$_toPropertyKey(arg) {
    var key = $2d14a10d0968a93a$var$_toPrimitive(arg, "string");
    return $2d14a10d0968a93a$var$_typeof(key) === "symbol" ? key : String(key);
}
function $2d14a10d0968a93a$var$_toPrimitive(input, hint) {
    if ($2d14a10d0968a93a$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($2d14a10d0968a93a$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $2d14a10d0968a93a$export$b00b86c416695282(options) {
    (0, $5WnGV.checkOptions)(options);
    var subscribers = [];
    var props = (0, $8G3Ib.getDefaultProps)(options, subscribers);
    var store = (0, $9YOpx.createStore)((0, $2A1cy.stateReducer), props, onStoreStateChange);
    var setters = (0, $Whdqp.getAutocompleteSetters)({
        store: store
    });
    var propGetters = (0, $3p1lt.getPropGetters)($2d14a10d0968a93a$var$_objectSpread({
        props: props,
        refresh: refresh,
        store: store,
        navigator: props.navigator
    }, setters));
    function onStoreStateChange(_ref) {
        var _state$context, _state$context$algoli;
        var prevState = _ref.prevState, state = _ref.state;
        props.onStateChange($2d14a10d0968a93a$var$_objectSpread({
            prevState: prevState,
            state: state,
            refresh: refresh,
            navigator: props.navigator
        }, setters));
        if (!isAlgoliaInsightsPluginEnabled() && (_state$context = state.context) !== null && _state$context !== void 0 && (_state$context$algoli = _state$context.algoliaInsightsPlugin) !== null && _state$context$algoli !== void 0 && _state$context$algoli.__automaticInsights && props.insights !== false) {
            var plugin = (0, $cYoID.createAlgoliaInsightsPlugin)({
                __autocomplete_clickAnalytics: false
            });
            props.plugins.push(plugin);
            subscribePlugins([
                plugin
            ]);
        }
    }
    function refresh() {
        return (0, $1Ni2w.onInput)($2d14a10d0968a93a$var$_objectSpread({
            event: new Event('input'),
            nextState: {
                isOpen: store.getState().isOpen
            },
            props: props,
            navigator: props.navigator,
            query: store.getState().query,
            refresh: refresh,
            store: store
        }, setters));
    }
    function subscribePlugins(plugins) {
        plugins.forEach(function(plugin) {
            var _plugin$subscribe;
            return (_plugin$subscribe = plugin.subscribe) === null || _plugin$subscribe === void 0 ? void 0 : _plugin$subscribe.call(plugin, $2d14a10d0968a93a$var$_objectSpread($2d14a10d0968a93a$var$_objectSpread({}, setters), {}, {
                navigator: props.navigator,
                refresh: refresh,
                onSelect: function onSelect(fn) {
                    subscribers.push({
                        onSelect: fn
                    });
                },
                onActive: function onActive(fn) {
                    subscribers.push({
                        onActive: fn
                    });
                },
                onResolve: function onResolve(fn) {
                    subscribers.push({
                        onResolve: fn
                    });
                }
            }));
        });
    }
    function isAlgoliaInsightsPluginEnabled() {
        return props.plugins.some(function(plugin) {
            return plugin.name === 'aa.algoliaInsightsPlugin';
        });
    }
    if (props.insights && !isAlgoliaInsightsPluginEnabled()) {
        var insightsParams = typeof props.insights === 'boolean' ? {} : props.insights;
        props.plugins.push((0, $cYoID.createAlgoliaInsightsPlugin)(insightsParams));
    }
    subscribePlugins(props.plugins);
    (0, $kJ7uN.injectMetadata)({
        metadata: (0, $kJ7uN.getMetadata)({
            plugins: props.plugins,
            options: options
        }),
        environment: props.environment
    });
    return $2d14a10d0968a93a$var$_objectSpread($2d14a10d0968a93a$var$_objectSpread({
        refresh: refresh,
        navigator: props.navigator
    }, propGetters), setters);
}

});
parcelRegister("cYoID", function(module, exports) {

$parcel$export(module.exports, "createAlgoliaInsightsPlugin", () => $971e434d9af19f5e$export$89ab4208990a3782);

var $kXmDY = parcelRequire("kXmDY");
var $eoCWv = parcelRequire("eoCWv");
var $coVvG = parcelRequire("coVvG");
var $iKicX = parcelRequire("iKicX");
var $abpMF = parcelRequire("abpMF");

var $fdXQc = parcelRequire("fdXQc");

var $dyPt6 = parcelRequire("dyPt6");

var $7AGxz = parcelRequire("7AGxz");

var $5cc0Q = parcelRequire("5cc0Q");
function $971e434d9af19f5e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $971e434d9af19f5e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $971e434d9af19f5e$var$_typeof(obj);
}
function $971e434d9af19f5e$var$_toConsumableArray(arr) {
    return $971e434d9af19f5e$var$_arrayWithoutHoles(arr) || $971e434d9af19f5e$var$_iterableToArray(arr) || $971e434d9af19f5e$var$_unsupportedIterableToArray(arr) || $971e434d9af19f5e$var$_nonIterableSpread();
}
function $971e434d9af19f5e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $971e434d9af19f5e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $971e434d9af19f5e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $971e434d9af19f5e$var$_arrayLikeToArray(o, minLen);
}
function $971e434d9af19f5e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $971e434d9af19f5e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $971e434d9af19f5e$var$_arrayLikeToArray(arr);
}
function $971e434d9af19f5e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $971e434d9af19f5e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $971e434d9af19f5e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $971e434d9af19f5e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $971e434d9af19f5e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $971e434d9af19f5e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $971e434d9af19f5e$var$_defineProperty(obj, key, value) {
    key = $971e434d9af19f5e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $971e434d9af19f5e$var$_toPropertyKey(arg) {
    var key = $971e434d9af19f5e$var$_toPrimitive(arg, "string");
    return $971e434d9af19f5e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $971e434d9af19f5e$var$_toPrimitive(input, hint) {
    if ($971e434d9af19f5e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($971e434d9af19f5e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $971e434d9af19f5e$var$VIEW_EVENT_DELAY = 400;
var $971e434d9af19f5e$var$ALGOLIA_INSIGHTS_VERSION = '2.13.0';
var $971e434d9af19f5e$var$ALGOLIA_INSIGHTS_SRC = "https://cdn.jsdelivr.net/npm/search-insights@".concat($971e434d9af19f5e$var$ALGOLIA_INSIGHTS_VERSION, "/dist/search-insights.min.js");
var $971e434d9af19f5e$var$sendViewedObjectIDs = (0, $eoCWv.debounce)(function(_ref) {
    var onItemsChange = _ref.onItemsChange, items = _ref.items, insights = _ref.insights, state = _ref.state;
    onItemsChange({
        insights: insights,
        insightsEvents: (0, $7AGxz.createViewedEvents)({
            items: items
        }).map(function(event) {
            return $971e434d9af19f5e$var$_objectSpread({
                eventName: 'Items Viewed'
            }, event);
        }),
        state: state
    });
}, $971e434d9af19f5e$var$VIEW_EVENT_DELAY);
function $971e434d9af19f5e$export$89ab4208990a3782(options) {
    var _getOptions = $971e434d9af19f5e$var$getOptions(options), providedInsightsClient = _getOptions.insightsClient, insightsInitParams = _getOptions.insightsInitParams, onItemsChange = _getOptions.onItemsChange, onSelectEvent = _getOptions.onSelect, onActiveEvent = _getOptions.onActive, __autocomplete_clickAnalytics = _getOptions.__autocomplete_clickAnalytics;
    var insightsClient = providedInsightsClient;
    if (!providedInsightsClient) (0, $abpMF.safelyRunOnBrowser)(function(_ref2) {
        var window = _ref2.window;
        var pointer = window.AlgoliaAnalyticsObject || 'aa';
        if (typeof pointer === 'string') insightsClient = window[pointer];
        if (!insightsClient) {
            window.AlgoliaAnalyticsObject = pointer;
            if (!window[pointer]) window[pointer] = function() {
                if (!window[pointer].queue) window[pointer].queue = [];
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                window[pointer].queue.push(args);
            };
            window[pointer].version = $971e434d9af19f5e$var$ALGOLIA_INSIGHTS_VERSION;
            insightsClient = window[pointer];
            $971e434d9af19f5e$var$loadInsights(window);
        }
    });
    // We return an empty plugin if `insightsClient` is still undefined at
    // this stage, which can happen in server environments.
    if (!insightsClient) return {};
    if (insightsInitParams) insightsClient('init', $971e434d9af19f5e$var$_objectSpread({
        partial: true
    }, insightsInitParams));
    var insights = (0, $dyPt6.createSearchInsightsApi)(insightsClient);
    var previousItems = (0, $kXmDY.createRef)([]);
    var debouncedOnStateChange = (0, $eoCWv.debounce)(function(_ref3) {
        var state = _ref3.state;
        if (!state.isOpen) return;
        var items = state.collections.reduce(function(acc, current) {
            return [].concat($971e434d9af19f5e$var$_toConsumableArray(acc), $971e434d9af19f5e$var$_toConsumableArray(current.items));
        }, []).filter((0, $5cc0Q.isAlgoliaInsightsHit));
        if (!(0, $coVvG.isEqual)(previousItems.current.map(function(x) {
            return x.objectID;
        }), items.map(function(x) {
            return x.objectID;
        }))) {
            previousItems.current = items;
            if (items.length > 0) $971e434d9af19f5e$var$sendViewedObjectIDs({
                onItemsChange: onItemsChange,
                items: items,
                insights: insights,
                state: state
            });
        }
    }, 0);
    return {
        name: 'aa.algoliaInsightsPlugin',
        subscribe: function subscribe(_ref4) {
            var setContext = _ref4.setContext, onSelect = _ref4.onSelect, onActive = _ref4.onActive;
            function setInsightsContext(userToken) {
                setContext({
                    algoliaInsightsPlugin: {
                        __algoliaSearchParameters: $971e434d9af19f5e$var$_objectSpread($971e434d9af19f5e$var$_objectSpread({}, __autocomplete_clickAnalytics ? {
                            clickAnalytics: true
                        } : {}), userToken ? {
                            userToken: $971e434d9af19f5e$var$normalizeUserToken(userToken)
                        } : {}),
                        insights: insights
                    }
                });
            }
            insightsClient('addAlgoliaAgent', 'insights-plugin');
            setInsightsContext();
            // Handles user token changes
            insightsClient('onUserTokenChange', setInsightsContext);
            insightsClient('getUserToken', null, function(_error, userToken) {
                setInsightsContext(userToken);
            });
            // Handles authenticated user token changes
            insightsClient('onAuthenticatedUserTokenChange', function(authenticatedUserToken) {
                if (authenticatedUserToken) setInsightsContext(authenticatedUserToken);
                else insightsClient('getUserToken', null, function(_error, userToken) {
                    return setInsightsContext(userToken);
                });
            });
            insightsClient('getAuthenticatedUserToken', null, function(_error, authenticatedUserToken) {
                if (authenticatedUserToken) setInsightsContext(authenticatedUserToken);
            });
            onSelect(function(_ref5) {
                var item = _ref5.item, state = _ref5.state, event = _ref5.event, source = _ref5.source;
                if (!(0, $5cc0Q.isAlgoliaInsightsHit)(item)) return;
                onSelectEvent({
                    state: state,
                    event: event,
                    insights: insights,
                    item: item,
                    insightsEvents: [
                        $971e434d9af19f5e$var$_objectSpread({
                            eventName: 'Item Selected'
                        }, (0, $fdXQc.createClickedEvent)({
                            item: item,
                            items: source.getItems().filter((0, $5cc0Q.isAlgoliaInsightsHit))
                        }))
                    ]
                });
            });
            onActive(function(_ref6) {
                var item = _ref6.item, source = _ref6.source, state = _ref6.state, event = _ref6.event;
                if (!(0, $5cc0Q.isAlgoliaInsightsHit)(item)) return;
                onActiveEvent({
                    state: state,
                    event: event,
                    insights: insights,
                    item: item,
                    insightsEvents: [
                        $971e434d9af19f5e$var$_objectSpread({
                            eventName: 'Item Active'
                        }, (0, $fdXQc.createClickedEvent)({
                            item: item,
                            items: source.getItems().filter((0, $5cc0Q.isAlgoliaInsightsHit))
                        }))
                    ]
                });
            });
        },
        onStateChange: function onStateChange(_ref7) {
            var state = _ref7.state;
            debouncedOnStateChange({
                state: state
            });
        },
        __autocomplete_pluginOptions: options
    };
}
function $971e434d9af19f5e$var$getAlgoliaSources() {
    var _context$algoliaInsig;
    var algoliaSourceBase = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var context = arguments.length > 1 ? arguments[1] : undefined;
    return [].concat($971e434d9af19f5e$var$_toConsumableArray(algoliaSourceBase), [
        'autocomplete-internal'
    ], $971e434d9af19f5e$var$_toConsumableArray((_context$algoliaInsig = context.algoliaInsightsPlugin) !== null && _context$algoliaInsig !== void 0 && _context$algoliaInsig.__automaticInsights ? [
        'autocomplete-automatic'
    ] : []));
}
function $971e434d9af19f5e$var$getOptions(options) {
    return $971e434d9af19f5e$var$_objectSpread({
        onItemsChange: function onItemsChange(_ref8) {
            var insights = _ref8.insights, insightsEvents = _ref8.insightsEvents, state = _ref8.state;
            insights.viewedObjectIDs.apply(insights, $971e434d9af19f5e$var$_toConsumableArray(insightsEvents.map(function(event) {
                return $971e434d9af19f5e$var$_objectSpread($971e434d9af19f5e$var$_objectSpread({}, event), {}, {
                    algoliaSource: $971e434d9af19f5e$var$getAlgoliaSources(event.algoliaSource, state.context)
                });
            })));
        },
        onSelect: function onSelect(_ref9) {
            var insights = _ref9.insights, insightsEvents = _ref9.insightsEvents, state = _ref9.state;
            insights.clickedObjectIDsAfterSearch.apply(insights, $971e434d9af19f5e$var$_toConsumableArray(insightsEvents.map(function(event) {
                return $971e434d9af19f5e$var$_objectSpread($971e434d9af19f5e$var$_objectSpread({}, event), {}, {
                    algoliaSource: $971e434d9af19f5e$var$getAlgoliaSources(event.algoliaSource, state.context)
                });
            })));
        },
        onActive: (0, $iKicX.noop),
        __autocomplete_clickAnalytics: true
    }, options);
}
function $971e434d9af19f5e$var$loadInsights(environment) {
    var errorMessage = "[Autocomplete]: Could not load search-insights.js. Please load it manually following https://alg.li/insights-autocomplete";
    try {
        var script = environment.document.createElement('script');
        script.async = true;
        script.src = $971e434d9af19f5e$var$ALGOLIA_INSIGHTS_SRC;
        script.onerror = function() {
            // eslint-disable-next-line no-console
            console.error(errorMessage);
        };
        document.body.appendChild(script);
    } catch (cause) {
        // eslint-disable-next-line no-console
        console.error(errorMessage);
    }
}
/**
 * While `search-insights` supports both string and number user tokens,
 * the Search API only accepts strings. This function normalizes the user token.
 */ function $971e434d9af19f5e$var$normalizeUserToken(userToken) {
    return typeof userToken === 'number' ? userToken.toString() : userToken;
}

});
parcelRegister("kXmDY", function(module, exports) {

$parcel$export(module.exports, "createRef", () => $f41ae1e2dd5a6868$export$7d1e3a5e95ceca43);
function $f41ae1e2dd5a6868$export$7d1e3a5e95ceca43(initialValue) {
    return {
        current: initialValue
    };
}

});

parcelRegister("eoCWv", function(module, exports) {

$parcel$export(module.exports, "debounce", () => $a7b183c3ce801543$export$61fc7d43ac8f84b0);
function $a7b183c3ce801543$export$61fc7d43ac8f84b0(fn, time) {
    var timerId = undefined;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (timerId) clearTimeout(timerId);
        timerId = setTimeout(function() {
            return fn.apply(void 0, args);
        }, time);
    };
}

});

parcelRegister("coVvG", function(module, exports) {

$parcel$export(module.exports, "isEqual", () => $9074563d7813ab4a$export$248d38f6296296c5);
function $9074563d7813ab4a$var$isPrimitive(obj) {
    return obj !== Object(obj);
}
function $9074563d7813ab4a$export$248d38f6296296c5(first, second) {
    if (first === second) return true;
    if ($9074563d7813ab4a$var$isPrimitive(first) || $9074563d7813ab4a$var$isPrimitive(second) || typeof first === 'function' || typeof second === 'function') return first === second;
    if (Object.keys(first).length !== Object.keys(second).length) return false;
    for(var _i = 0, _Object$keys = Object.keys(first); _i < _Object$keys.length; _i++){
        var key = _Object$keys[_i];
        if (!(key in second)) return false;
        if (!$9074563d7813ab4a$export$248d38f6296296c5(first[key], second[key])) return false;
    }
    return true;
}

});

parcelRegister("iKicX", function(module, exports) {

$parcel$export(module.exports, "noop", () => $da5aa5991d70c9a7$export$8793edee2d425525);
var $da5aa5991d70c9a7$export$8793edee2d425525 = function noop() {};

});

parcelRegister("abpMF", function(module, exports) {

$parcel$export(module.exports, "safelyRunOnBrowser", () => $769eee982b659459$export$39f19eed34acd2f1);
/**
 * Safely runs code meant for browser environments only.
 */ function $769eee982b659459$export$39f19eed34acd2f1(callback) {
    if (typeof window !== 'undefined') return callback({
        window: window
    });
    return undefined;
}

});

parcelRegister("fdXQc", function(module, exports) {

$parcel$export(module.exports, "createClickedEvent", () => $b1567d102b8d25ae$export$285269928260a84d);
function $b1567d102b8d25ae$export$285269928260a84d(_ref) {
    var item = _ref.item, _ref$items = _ref.items, items = _ref$items === void 0 ? [] : _ref$items;
    return {
        index: item.__autocomplete_indexName,
        items: [
            item
        ],
        positions: [
            1 + items.findIndex(function(x) {
                return x.objectID === item.objectID;
            })
        ],
        queryID: item.__autocomplete_queryID,
        algoliaSource: [
            'autocomplete'
        ]
    };
}

});

parcelRegister("dyPt6", function(module, exports) {

$parcel$export(module.exports, "createSearchInsightsApi", () => $9df65fdf1bebdacf$export$96bc93a891c6f784);

var $7Q0NB = parcelRequire("7Q0NB");
var $9df65fdf1bebdacf$var$_excluded = [
    "items"
], $9df65fdf1bebdacf$var$_excluded2 = [
    "items"
];
function $9df65fdf1bebdacf$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $9df65fdf1bebdacf$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $9df65fdf1bebdacf$var$_typeof(obj);
}
function $9df65fdf1bebdacf$var$_toConsumableArray(arr) {
    return $9df65fdf1bebdacf$var$_arrayWithoutHoles(arr) || $9df65fdf1bebdacf$var$_iterableToArray(arr) || $9df65fdf1bebdacf$var$_unsupportedIterableToArray(arr) || $9df65fdf1bebdacf$var$_nonIterableSpread();
}
function $9df65fdf1bebdacf$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $9df65fdf1bebdacf$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $9df65fdf1bebdacf$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $9df65fdf1bebdacf$var$_arrayLikeToArray(o, minLen);
}
function $9df65fdf1bebdacf$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $9df65fdf1bebdacf$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $9df65fdf1bebdacf$var$_arrayLikeToArray(arr);
}
function $9df65fdf1bebdacf$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $9df65fdf1bebdacf$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $9df65fdf1bebdacf$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $9df65fdf1bebdacf$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $9df65fdf1bebdacf$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $9df65fdf1bebdacf$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $9df65fdf1bebdacf$var$ownKeys(Object(source), !0).forEach(function(key) {
            $9df65fdf1bebdacf$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $9df65fdf1bebdacf$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $9df65fdf1bebdacf$var$_defineProperty(obj, key, value) {
    key = $9df65fdf1bebdacf$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $9df65fdf1bebdacf$var$_toPropertyKey(arg) {
    var key = $9df65fdf1bebdacf$var$_toPrimitive(arg, "string");
    return $9df65fdf1bebdacf$var$_typeof(key) === "symbol" ? key : String(key);
}
function $9df65fdf1bebdacf$var$_toPrimitive(input, hint) {
    if ($9df65fdf1bebdacf$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($9df65fdf1bebdacf$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $9df65fdf1bebdacf$var$chunk(item) {
    var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 20;
    var chunks = [];
    for(var i = 0; i < item.objectIDs.length; i += chunkSize)chunks.push($9df65fdf1bebdacf$var$_objectSpread($9df65fdf1bebdacf$var$_objectSpread({}, item), {}, {
        objectIDs: item.objectIDs.slice(i, i + chunkSize)
    }));
    return chunks;
}
function $9df65fdf1bebdacf$var$mapToInsightsParamsApi(params) {
    return params.map(function(_ref) {
        var items = _ref.items, param = $9df65fdf1bebdacf$var$_objectWithoutProperties(_ref, $9df65fdf1bebdacf$var$_excluded);
        return $9df65fdf1bebdacf$var$_objectSpread($9df65fdf1bebdacf$var$_objectSpread({}, param), {}, {
            objectIDs: (items === null || items === void 0 ? void 0 : items.map(function(_ref2) {
                var objectID = _ref2.objectID;
                return objectID;
            })) || param.objectIDs
        });
    });
}
function $9df65fdf1bebdacf$export$96bc93a891c6f784(searchInsights) {
    var canSendHeaders = (0, $7Q0NB.isModernInsightsClient)(searchInsights);
    function sendToInsights(method, payloads, items) {
        if (canSendHeaders && typeof items !== 'undefined') {
            var _items$0$__autocomple = items[0].__autocomplete_algoliaCredentials, appId = _items$0$__autocomple.appId, apiKey = _items$0$__autocomple.apiKey;
            var headers = {
                'X-Algolia-Application-Id': appId,
                'X-Algolia-API-Key': apiKey
            };
            searchInsights.apply(void 0, [
                method
            ].concat($9df65fdf1bebdacf$var$_toConsumableArray(payloads), [
                {
                    headers: headers
                }
            ]));
        } else searchInsights.apply(void 0, [
            method
        ].concat($9df65fdf1bebdacf$var$_toConsumableArray(payloads)));
    }
    return {
        /**
     * Initializes Insights with Algolia credentials.
     */ init: function init(appId, apiKey) {
            searchInsights('init', {
                appId: appId,
                apiKey: apiKey
            });
        },
        /**
     * Sets the authenticated user token to attach to events.
     * Unsets the authenticated token by passing `undefined`.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/set-authenticated-user-token/
     */ setAuthenticatedUserToken: function setAuthenticatedUserToken(authenticatedUserToken) {
            searchInsights('setAuthenticatedUserToken', authenticatedUserToken);
        },
        /**
     * Sets the user token to attach to events.
     */ setUserToken: function setUserToken(userToken) {
            searchInsights('setUserToken', userToken);
        },
        /**
     * Sends click events to capture a query and its clicked items and positions.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-object-ids-after-search/
     */ clickedObjectIDsAfterSearch: function clickedObjectIDsAfterSearch() {
            for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++)params[_key] = arguments[_key];
            if (params.length > 0) sendToInsights('clickedObjectIDsAfterSearch', $9df65fdf1bebdacf$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends click events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-object-ids/
     */ clickedObjectIDs: function clickedObjectIDs() {
            for(var _len2 = arguments.length, params = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)params[_key2] = arguments[_key2];
            if (params.length > 0) sendToInsights('clickedObjectIDs', $9df65fdf1bebdacf$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends click events to capture the filters a user clicks on.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/clicked-filters/
     */ clickedFilters: function clickedFilters() {
            for(var _len3 = arguments.length, params = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++)params[_key3] = arguments[_key3];
            if (params.length > 0) searchInsights.apply(void 0, [
                'clickedFilters'
            ].concat(params));
        },
        /**
     * Sends conversion events to capture a query and its clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-object-ids-after-search/
     */ convertedObjectIDsAfterSearch: function convertedObjectIDsAfterSearch() {
            for(var _len4 = arguments.length, params = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)params[_key4] = arguments[_key4];
            if (params.length > 0) sendToInsights('convertedObjectIDsAfterSearch', $9df65fdf1bebdacf$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends conversion events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-object-ids/
     */ convertedObjectIDs: function convertedObjectIDs() {
            for(var _len5 = arguments.length, params = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++)params[_key5] = arguments[_key5];
            if (params.length > 0) sendToInsights('convertedObjectIDs', $9df65fdf1bebdacf$var$mapToInsightsParamsApi(params), params[0].items);
        },
        /**
     * Sends conversion events to capture the filters a user uses when converting.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/converted-filters/
     */ convertedFilters: function convertedFilters() {
            for(var _len6 = arguments.length, params = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)params[_key6] = arguments[_key6];
            if (params.length > 0) searchInsights.apply(void 0, [
                'convertedFilters'
            ].concat(params));
        },
        /**
     * Sends view events to capture clicked items.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/viewed-object-ids/
     */ viewedObjectIDs: function viewedObjectIDs() {
            for(var _len7 = arguments.length, params = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++)params[_key7] = arguments[_key7];
            if (params.length > 0) params.reduce(function(acc, _ref3) {
                var items = _ref3.items, param = $9df65fdf1bebdacf$var$_objectWithoutProperties(_ref3, $9df65fdf1bebdacf$var$_excluded2);
                return [].concat($9df65fdf1bebdacf$var$_toConsumableArray(acc), $9df65fdf1bebdacf$var$_toConsumableArray($9df65fdf1bebdacf$var$chunk($9df65fdf1bebdacf$var$_objectSpread($9df65fdf1bebdacf$var$_objectSpread({}, param), {}, {
                    objectIDs: (items === null || items === void 0 ? void 0 : items.map(function(_ref4) {
                        var objectID = _ref4.objectID;
                        return objectID;
                    })) || param.objectIDs
                })).map(function(payload) {
                    return {
                        items: items,
                        payload: payload
                    };
                })));
            }, []).forEach(function(_ref5) {
                var items = _ref5.items, payload = _ref5.payload;
                return sendToInsights('viewedObjectIDs', [
                    payload
                ], items);
            });
        },
        /**
     * Sends view events to capture the filters a user uses when viewing.
     *
     * @link https://www.algolia.com/doc/api-reference/api-methods/viewed-filters/
     */ viewedFilters: function viewedFilters() {
            for(var _len8 = arguments.length, params = new Array(_len8), _key8 = 0; _key8 < _len8; _key8++)params[_key8] = arguments[_key8];
            if (params.length > 0) searchInsights.apply(void 0, [
                'viewedFilters'
            ].concat(params));
        }
    };
}

});
parcelRegister("7Q0NB", function(module, exports) {

$parcel$export(module.exports, "isModernInsightsClient", () => $5b4e0261a7b52161$export$5c9cfc0c9d3b5e01);
function $5b4e0261a7b52161$var$_slicedToArray(arr, i) {
    return $5b4e0261a7b52161$var$_arrayWithHoles(arr) || $5b4e0261a7b52161$var$_iterableToArrayLimit(arr, i) || $5b4e0261a7b52161$var$_unsupportedIterableToArray(arr, i) || $5b4e0261a7b52161$var$_nonIterableRest();
}
function $5b4e0261a7b52161$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5b4e0261a7b52161$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5b4e0261a7b52161$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5b4e0261a7b52161$var$_arrayLikeToArray(o, minLen);
}
function $5b4e0261a7b52161$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $5b4e0261a7b52161$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $5b4e0261a7b52161$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $5b4e0261a7b52161$export$5c9cfc0c9d3b5e01(client) {
    var _split$map = (client.version || '').split('.').map(Number), _split$map2 = $5b4e0261a7b52161$var$_slicedToArray(_split$map, 2), major = _split$map2[0], minor = _split$map2[1];
    /* eslint-disable @typescript-eslint/camelcase */ var v3 = major >= 3;
    var v2_4 = major === 2 && minor >= 4;
    var v1_10 = major === 1 && minor >= 10;
    return v3 || v2_4 || v1_10;
/* eslint-enable @typescript-eslint/camelcase */ }

});


parcelRegister("7AGxz", function(module, exports) {

$parcel$export(module.exports, "createViewedEvents", () => $586ce4d2f424a1ab$export$8bae0094a47f6972);
function $586ce4d2f424a1ab$export$8bae0094a47f6972(_ref) {
    var items = _ref.items;
    var itemsByIndexName = items.reduce(function(acc, current) {
        var _acc$current$__autoco;
        acc[current.__autocomplete_indexName] = ((_acc$current$__autoco = acc[current.__autocomplete_indexName]) !== null && _acc$current$__autoco !== void 0 ? _acc$current$__autoco : []).concat(current);
        return acc;
    }, {});
    return Object.keys(itemsByIndexName).map(function(indexName) {
        var items = itemsByIndexName[indexName];
        return {
            index: indexName,
            items: items,
            algoliaSource: [
                'autocomplete'
            ]
        };
    });
}

});

parcelRegister("5cc0Q", function(module, exports) {

$parcel$export(module.exports, "isAlgoliaInsightsHit", () => $3c87642dd26ad97b$export$977f4849b4f88a72);
function $3c87642dd26ad97b$export$977f4849b4f88a72(hit) {
    return hit.objectID && hit.__autocomplete_indexName && hit.__autocomplete_queryID;
}

});


parcelRegister("5WnGV", function(module, exports) {

$parcel$export(module.exports, "checkOptions", () => $4534bf1f4cb4b414$export$6fe837ce0e0e0cdf);

function $4534bf1f4cb4b414$export$6fe837ce0e0e0cdf(options) {}

});

parcelRegister("9YOpx", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $7440d23715ea488b$export$f51a9068ac82ea43);

var $evTan = parcelRequire("evTan");
function $7440d23715ea488b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $7440d23715ea488b$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $7440d23715ea488b$var$_typeof(obj);
}
function $7440d23715ea488b$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $7440d23715ea488b$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $7440d23715ea488b$var$ownKeys(Object(source), !0).forEach(function(key) {
            $7440d23715ea488b$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $7440d23715ea488b$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $7440d23715ea488b$var$_defineProperty(obj, key, value) {
    key = $7440d23715ea488b$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $7440d23715ea488b$var$_toPropertyKey(arg) {
    var key = $7440d23715ea488b$var$_toPrimitive(arg, "string");
    return $7440d23715ea488b$var$_typeof(key) === "symbol" ? key : String(key);
}
function $7440d23715ea488b$var$_toPrimitive(input, hint) {
    if ($7440d23715ea488b$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($7440d23715ea488b$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $7440d23715ea488b$export$f51a9068ac82ea43(reducer, props, onStoreStateChange) {
    var state = props.initialState;
    return {
        getState: function getState() {
            return state;
        },
        dispatch: function dispatch(action, payload) {
            var prevState = $7440d23715ea488b$var$_objectSpread({}, state);
            state = reducer(state, {
                type: action,
                props: props,
                payload: payload
            });
            onStoreStateChange({
                state: state,
                prevState: prevState
            });
        },
        pendingRequests: (0, $evTan.createCancelablePromiseList)()
    };
}

});
parcelRegister("evTan", function(module, exports) {

$parcel$export(module.exports, "createCancelablePromiseList", () => $a90ec0d63f4922f5$export$9661f890aacb4415);
function $a90ec0d63f4922f5$export$9661f890aacb4415() {
    var list = [];
    return {
        add: function add(cancelablePromise) {
            list.push(cancelablePromise);
            return cancelablePromise.finally(function() {
                list = list.filter(function(item) {
                    return item !== cancelablePromise;
                });
            });
        },
        cancelAll: function cancelAll() {
            list.forEach(function(promise) {
                return promise.cancel();
            });
        },
        isEmpty: function isEmpty() {
            return list.length === 0;
        }
    };
}

});


parcelRegister("Whdqp", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteSetters", () => $0af2c58a4f8888f7$export$5085b122b817cee);

var $gHn53 = parcelRequire("gHn53");
function $0af2c58a4f8888f7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0af2c58a4f8888f7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0af2c58a4f8888f7$var$_typeof(obj);
}
function $0af2c58a4f8888f7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0af2c58a4f8888f7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0af2c58a4f8888f7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0af2c58a4f8888f7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0af2c58a4f8888f7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0af2c58a4f8888f7$var$_defineProperty(obj, key, value) {
    key = $0af2c58a4f8888f7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0af2c58a4f8888f7$var$_toPropertyKey(arg) {
    var key = $0af2c58a4f8888f7$var$_toPrimitive(arg, "string");
    return $0af2c58a4f8888f7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0af2c58a4f8888f7$var$_toPrimitive(input, hint) {
    if ($0af2c58a4f8888f7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0af2c58a4f8888f7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0af2c58a4f8888f7$export$5085b122b817cee(_ref) {
    var store = _ref.store;
    var setActiveItemId = function setActiveItemId(value) {
        store.dispatch('setActiveItemId', value);
    };
    var setQuery = function setQuery(value) {
        store.dispatch('setQuery', value);
    };
    var setCollections = function setCollections(rawValue) {
        var baseItemId = 0;
        var value = rawValue.map(function(collection) {
            return $0af2c58a4f8888f7$var$_objectSpread($0af2c58a4f8888f7$var$_objectSpread({}, collection), {}, {
                // We flatten the stored items to support calling `getAlgoliaResults`
                // from the source itself.
                items: (0, $gHn53.flatten)(collection.items).map(function(item) {
                    return $0af2c58a4f8888f7$var$_objectSpread($0af2c58a4f8888f7$var$_objectSpread({}, item), {}, {
                        __autocomplete_id: baseItemId++
                    });
                })
            });
        });
        store.dispatch('setCollections', value);
    };
    var setIsOpen = function setIsOpen(value) {
        store.dispatch('setIsOpen', value);
    };
    var setStatus = function setStatus(value) {
        store.dispatch('setStatus', value);
    };
    var setContext = function setContext(value) {
        store.dispatch('setContext', value);
    };
    return {
        setActiveItemId: setActiveItemId,
        setQuery: setQuery,
        setCollections: setCollections,
        setIsOpen: setIsOpen,
        setStatus: setStatus,
        setContext: setContext
    };
}

});
parcelRegister("gHn53", function(module, exports) {

$parcel$export(module.exports, "flatten", () => $c28290ceb9e930fa$export$bffa455ba8c619a6);
function $c28290ceb9e930fa$export$bffa455ba8c619a6(values) {
    return values.reduce(function(a, b) {
        return a.concat(b);
    }, []);
}

});


parcelRegister("8G3Ib", function(module, exports) {

$parcel$export(module.exports, "getDefaultProps", () => $65152009aa541cf1$export$61b94149aeb1f59);

var $gHn53 = parcelRequire("gHn53");
var $2Gogh = parcelRequire("2Gogh");
var $avN8a = parcelRequire("avN8a");

var $bK6N5 = parcelRequire("bK6N5");
function $65152009aa541cf1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $65152009aa541cf1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $65152009aa541cf1$var$_typeof(obj);
}
function $65152009aa541cf1$var$_toConsumableArray(arr) {
    return $65152009aa541cf1$var$_arrayWithoutHoles(arr) || $65152009aa541cf1$var$_iterableToArray(arr) || $65152009aa541cf1$var$_unsupportedIterableToArray(arr) || $65152009aa541cf1$var$_nonIterableSpread();
}
function $65152009aa541cf1$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $65152009aa541cf1$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $65152009aa541cf1$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $65152009aa541cf1$var$_arrayLikeToArray(o, minLen);
}
function $65152009aa541cf1$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $65152009aa541cf1$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $65152009aa541cf1$var$_arrayLikeToArray(arr);
}
function $65152009aa541cf1$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $65152009aa541cf1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $65152009aa541cf1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $65152009aa541cf1$var$ownKeys(Object(source), !0).forEach(function(key) {
            $65152009aa541cf1$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $65152009aa541cf1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $65152009aa541cf1$var$_defineProperty(obj, key, value) {
    key = $65152009aa541cf1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $65152009aa541cf1$var$_toPropertyKey(arg) {
    var key = $65152009aa541cf1$var$_toPrimitive(arg, "string");
    return $65152009aa541cf1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $65152009aa541cf1$var$_toPrimitive(input, hint) {
    if ($65152009aa541cf1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($65152009aa541cf1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $65152009aa541cf1$export$61b94149aeb1f59(props, pluginSubscribers) {
    var _props$id;
    /* eslint-disable no-restricted-globals */ var environment = typeof window !== 'undefined' ? window : {};
    /* eslint-enable no-restricted-globals */ var plugins = props.plugins || [];
    return $65152009aa541cf1$var$_objectSpread($65152009aa541cf1$var$_objectSpread({
        debug: false,
        openOnFocus: false,
        enterKeyHint: undefined,
        placeholder: '',
        autoFocus: false,
        defaultActiveItemId: null,
        stallThreshold: 300,
        insights: undefined,
        environment: environment,
        shouldPanelOpen: function shouldPanelOpen(_ref) {
            var state = _ref.state;
            return (0, $avN8a.getItemsCount)(state) > 0;
        },
        reshape: function reshape(_ref2) {
            var sources = _ref2.sources;
            return sources;
        }
    }, props), {}, {
        // Since `generateAutocompleteId` triggers a side effect (it increments
        // an internal counter), we don't want to execute it if unnecessary.
        id: (_props$id = props.id) !== null && _props$id !== void 0 ? _props$id : (0, $2Gogh.generateAutocompleteId)(),
        plugins: plugins,
        // The following props need to be deeply defaulted.
        initialState: $65152009aa541cf1$var$_objectSpread({
            activeItemId: null,
            query: '',
            completion: null,
            collections: [],
            isOpen: false,
            status: 'idle',
            context: {}
        }, props.initialState),
        onStateChange: function onStateChange(params) {
            var _props$onStateChange;
            (_props$onStateChange = props.onStateChange) === null || _props$onStateChange === void 0 || _props$onStateChange.call(props, params);
            plugins.forEach(function(x) {
                var _x$onStateChange;
                return (_x$onStateChange = x.onStateChange) === null || _x$onStateChange === void 0 ? void 0 : _x$onStateChange.call(x, params);
            });
        },
        onSubmit: function onSubmit(params) {
            var _props$onSubmit;
            (_props$onSubmit = props.onSubmit) === null || _props$onSubmit === void 0 || _props$onSubmit.call(props, params);
            plugins.forEach(function(x) {
                var _x$onSubmit;
                return (_x$onSubmit = x.onSubmit) === null || _x$onSubmit === void 0 ? void 0 : _x$onSubmit.call(x, params);
            });
        },
        onReset: function onReset(params) {
            var _props$onReset;
            (_props$onReset = props.onReset) === null || _props$onReset === void 0 || _props$onReset.call(props, params);
            plugins.forEach(function(x) {
                var _x$onReset;
                return (_x$onReset = x.onReset) === null || _x$onReset === void 0 ? void 0 : _x$onReset.call(x, params);
            });
        },
        getSources: function getSources(params) {
            return Promise.all([].concat($65152009aa541cf1$var$_toConsumableArray(plugins.map(function(plugin) {
                return plugin.getSources;
            })), [
                props.getSources
            ]).filter(Boolean).map(function(getSources) {
                return (0, $bK6N5.getNormalizedSources)(getSources, params);
            })).then(function(nested) {
                return (0, $gHn53.flatten)(nested);
            }).then(function(sources) {
                return sources.map(function(source) {
                    return $65152009aa541cf1$var$_objectSpread($65152009aa541cf1$var$_objectSpread({}, source), {}, {
                        onSelect: function onSelect(params) {
                            source.onSelect(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onSelect;
                                return (_x$onSelect = x.onSelect) === null || _x$onSelect === void 0 ? void 0 : _x$onSelect.call(x, params);
                            });
                        },
                        onActive: function onActive(params) {
                            source.onActive(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onActive;
                                return (_x$onActive = x.onActive) === null || _x$onActive === void 0 ? void 0 : _x$onActive.call(x, params);
                            });
                        },
                        onResolve: function onResolve(params) {
                            source.onResolve(params);
                            pluginSubscribers.forEach(function(x) {
                                var _x$onResolve;
                                return (_x$onResolve = x.onResolve) === null || _x$onResolve === void 0 ? void 0 : _x$onResolve.call(x, params);
                            });
                        }
                    });
                });
            });
        },
        navigator: $65152009aa541cf1$var$_objectSpread({
            navigate: function navigate(_ref3) {
                var itemUrl = _ref3.itemUrl;
                environment.location.assign(itemUrl);
            },
            navigateNewTab: function navigateNewTab(_ref4) {
                var itemUrl = _ref4.itemUrl;
                var windowReference = environment.open(itemUrl, '_blank', 'noopener');
                windowReference === null || windowReference === void 0 || windowReference.focus();
            },
            navigateNewWindow: function navigateNewWindow(_ref5) {
                var itemUrl = _ref5.itemUrl;
                environment.open(itemUrl, '_blank', 'noopener');
            }
        }, props.navigator)
    });
}

});
parcelRegister("2Gogh", function(module, exports) {

$parcel$export(module.exports, "generateAutocompleteId", () => $1f4252dd114fbd48$export$46ae397d8484b6c2);
var $1f4252dd114fbd48$var$autocompleteId = 0;
function $1f4252dd114fbd48$export$46ae397d8484b6c2() {
    return "autocomplete-".concat($1f4252dd114fbd48$var$autocompleteId++);
}

});

parcelRegister("avN8a", function(module, exports) {

$parcel$export(module.exports, "getItemsCount", () => $7a72e8f4d8ec595f$export$dd01a43948d7de86);
function $7a72e8f4d8ec595f$export$dd01a43948d7de86(state) {
    if (state.collections.length === 0) return 0;
    return state.collections.reduce(function(sum, collection) {
        return sum + collection.items.length;
    }, 0);
}

});

parcelRegister("bK6N5", function(module, exports) {

$parcel$export(module.exports, "getNormalizedSources", () => $0234cb636ed4e205$export$c7afda361f77b571);

var $cN70B = parcelRequire("cN70B");
var $6HaDi = parcelRequire("6HaDi");
var $iKicX = parcelRequire("iKicX");
function $0234cb636ed4e205$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $0234cb636ed4e205$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $0234cb636ed4e205$var$ownKeys(Object(source), !0).forEach(function(key) {
            $0234cb636ed4e205$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $0234cb636ed4e205$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $0234cb636ed4e205$var$_defineProperty(obj, key, value) {
    key = $0234cb636ed4e205$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $0234cb636ed4e205$var$_toPropertyKey(arg) {
    var key = $0234cb636ed4e205$var$_toPrimitive(arg, "string");
    return $0234cb636ed4e205$var$_typeof(key) === "symbol" ? key : String(key);
}
function $0234cb636ed4e205$var$_toPrimitive(input, hint) {
    if ($0234cb636ed4e205$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($0234cb636ed4e205$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $0234cb636ed4e205$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $0234cb636ed4e205$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $0234cb636ed4e205$var$_typeof(obj);
}
function $0234cb636ed4e205$export$c7afda361f77b571(getSources, params) {
    var seenSourceIds = [];
    return Promise.resolve(getSources(params)).then(function(sources) {
        (0, $6HaDi.invariant)(Array.isArray(sources), function() {
            return "The `getSources` function must return an array of sources but returned type ".concat(JSON.stringify($0234cb636ed4e205$var$_typeof(sources)), ":\n\n").concat(JSON.stringify((0, $cN70B.decycle)(sources), null, 2));
        });
        return Promise.all(sources// We allow `undefined` and `false` sources to allow users to use
        // `Boolean(query) && source` (=> `false`).
        // We need to remove these values at this point.
        .filter(function(maybeSource) {
            return Boolean(maybeSource);
        }).map(function(source) {
            (0, $6HaDi.invariant)(typeof source.sourceId === 'string', 'A source must provide a `sourceId` string.');
            if (seenSourceIds.includes(source.sourceId)) throw new Error("[Autocomplete] The `sourceId` ".concat(JSON.stringify(source.sourceId), " is not unique."));
            seenSourceIds.push(source.sourceId);
            var defaultSource = {
                getItemInputValue: function getItemInputValue(_ref) {
                    var state = _ref.state;
                    return state.query;
                },
                getItemUrl: function getItemUrl() {
                    return undefined;
                },
                onSelect: function onSelect(_ref2) {
                    var setIsOpen = _ref2.setIsOpen;
                    setIsOpen(false);
                },
                onActive: (0, $iKicX.noop),
                onResolve: (0, $iKicX.noop)
            };
            Object.keys(defaultSource).forEach(function(key) {
                defaultSource[key].__default = true;
            });
            var normalizedSource = $0234cb636ed4e205$var$_objectSpread($0234cb636ed4e205$var$_objectSpread({}, defaultSource), source);
            return Promise.resolve(normalizedSource);
        }));
    });
}

});
parcelRegister("cN70B", function(module, exports) {

$parcel$export(module.exports, "decycle", () => $94ff7f692f6fd971$export$ed3e2bdb532b061f);
function $94ff7f692f6fd971$var$_slicedToArray(arr, i) {
    return $94ff7f692f6fd971$var$_arrayWithHoles(arr) || $94ff7f692f6fd971$var$_iterableToArrayLimit(arr, i) || $94ff7f692f6fd971$var$_unsupportedIterableToArray(arr, i) || $94ff7f692f6fd971$var$_nonIterableRest();
}
function $94ff7f692f6fd971$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $94ff7f692f6fd971$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $94ff7f692f6fd971$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $94ff7f692f6fd971$var$_arrayLikeToArray(o, minLen);
}
function $94ff7f692f6fd971$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $94ff7f692f6fd971$var$_iterableToArrayLimit(arr, i) {
    var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
    if (null != _i) {
        var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1;
        try {
            if (_x = (_i = _i.call(arr)).next, 0 === i) {
                if (Object(_i) !== _i) return;
                _n = !1;
            } else for(; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
        } catch (err) {
            _d = !0, _e = err;
        } finally{
            try {
                if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
            } finally{
                if (_d) throw _e;
            }
        }
        return _arr;
    }
}
function $94ff7f692f6fd971$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $94ff7f692f6fd971$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $94ff7f692f6fd971$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $94ff7f692f6fd971$var$_typeof(obj);
}
function $94ff7f692f6fd971$export$ed3e2bdb532b061f(obj) {
    var seen = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : new Set();
    var newSeen;
    return obj;
}

});

parcelRegister("6HaDi", function(module, exports) {

$parcel$export(module.exports, "invariant", () => $4dff01ac5c46ed87$export$f5708dca728d7177);
/**
 * Throws an error if the condition is not met in development mode.
 * This is used to make development a better experience to provide guidance as
 * to where the error comes from.
 */ function $4dff01ac5c46ed87$export$f5708dca728d7177(condition, message) {
    return;
}

});



parcelRegister("3p1lt", function(module, exports) {

$parcel$export(module.exports, "getPropGetters", () => $27a4c0083de1c0c7$export$a4b47c9a40a3a795);

var $iKicX = parcelRequire("iKicX");

var $1Ni2w = parcelRequire("1Ni2w");

var $ji6c9 = parcelRequire("ji6c9");

var $4d50Q = parcelRequire("4d50Q");
var $0VpsC = parcelRequire("0VpsC");
var $66GDI = parcelRequire("66GDI");
var $1IbUX = parcelRequire("1IbUX");
function $27a4c0083de1c0c7$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $27a4c0083de1c0c7$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $27a4c0083de1c0c7$var$_typeof(obj);
}
var $27a4c0083de1c0c7$var$_excluded = [
    "props",
    "refresh",
    "store"
], $27a4c0083de1c0c7$var$_excluded2 = [
    "inputElement",
    "formElement",
    "panelElement"
], $27a4c0083de1c0c7$var$_excluded3 = [
    "inputElement"
], $27a4c0083de1c0c7$var$_excluded4 = [
    "inputElement",
    "maxLength"
], $27a4c0083de1c0c7$var$_excluded5 = [
    "source"
], $27a4c0083de1c0c7$var$_excluded6 = [
    "item",
    "source"
];
function $27a4c0083de1c0c7$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $27a4c0083de1c0c7$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $27a4c0083de1c0c7$var$ownKeys(Object(source), !0).forEach(function(key) {
            $27a4c0083de1c0c7$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $27a4c0083de1c0c7$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $27a4c0083de1c0c7$var$_defineProperty(obj, key, value) {
    key = $27a4c0083de1c0c7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $27a4c0083de1c0c7$var$_toPropertyKey(arg) {
    var key = $27a4c0083de1c0c7$var$_toPrimitive(arg, "string");
    return $27a4c0083de1c0c7$var$_typeof(key) === "symbol" ? key : String(key);
}
function $27a4c0083de1c0c7$var$_toPrimitive(input, hint) {
    if ($27a4c0083de1c0c7$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($27a4c0083de1c0c7$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $27a4c0083de1c0c7$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $27a4c0083de1c0c7$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $27a4c0083de1c0c7$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $27a4c0083de1c0c7$export$a4b47c9a40a3a795(_ref) {
    var props = _ref.props, refresh = _ref.refresh, store = _ref.store, setters = $27a4c0083de1c0c7$var$_objectWithoutProperties(_ref, $27a4c0083de1c0c7$var$_excluded);
    var getEnvironmentProps = function getEnvironmentProps(providedProps) {
        var inputElement = providedProps.inputElement, formElement = providedProps.formElement, panelElement = providedProps.panelElement, rest = $27a4c0083de1c0c7$var$_objectWithoutProperties(providedProps, $27a4c0083de1c0c7$var$_excluded2);
        function onMouseDownOrTouchStart(event) {
            // The `onTouchStart`/`onMouseDown` events shouldn't trigger the `blur`
            // handler when it's not an interaction with Autocomplete.
            // We detect it with the following heuristics:
            // - the panel is closed AND there are no pending requests
            //   (no interaction with the autocomplete, no future state updates)
            // - OR the touched target is the input element (should open the panel)
            var isAutocompleteInteraction = store.getState().isOpen || !store.pendingRequests.isEmpty();
            if (!isAutocompleteInteraction || event.target === inputElement) return;
            // @TODO: support cases where there are multiple Autocomplete instances.
            // Right now, a second instance makes this computation return false.
            var isTargetWithinAutocomplete = [
                formElement,
                panelElement
            ].some(function(contextNode) {
                return (0, $66GDI.isOrContainsNode)(contextNode, event.target);
            });
            if (isTargetWithinAutocomplete === false) {
                store.dispatch('blur', null);
                // If requests are still pending when the user closes the panel, they
                // could reopen the panel once they resolve.
                // We want to prevent any subsequent query from reopening the panel
                // because it would result in an unsolicited UI behavior.
                if (!props.debug) store.pendingRequests.cancelAll();
            }
        }
        return $27a4c0083de1c0c7$var$_objectSpread({
            // We do not rely on the native `blur` event of the input to close the
            // panel, but rather on a custom `touchstart`/`mousedown` event outside
            // of the autocomplete elements.
            // This ensures we don't mistakenly interpret interactions within the
            // autocomplete (but outside of the input) as a signal to close the panel.
            // For example, clicking reset button causes an input blur, but if
            // `openOnFocus=true`, it shouldn't close the panel.
            // On touch devices, scrolling results (`touchmove`) causes an input blur
            // but shouldn't close the panel.
            onTouchStart: onMouseDownOrTouchStart,
            onMouseDown: onMouseDownOrTouchStart,
            // When scrolling on touch devices (mobiles, tablets, etc.), we want to
            // mimic the native platform behavior where the input is blurred to
            // hide the virtual keyboard. This gives more vertical space to
            // discover all the suggestions showing up in the panel.
            onTouchMove: function onTouchMove(event) {
                if (store.getState().isOpen === false || inputElement !== props.environment.document.activeElement || event.target === inputElement) return;
                inputElement.blur();
            }
        }, rest);
    };
    var getRootProps = function getRootProps(rest) {
        return $27a4c0083de1c0c7$var$_objectSpread({
            role: 'combobox',
            'aria-expanded': store.getState().isOpen,
            'aria-haspopup': 'listbox',
            'aria-owns': store.getState().isOpen ? store.getState().collections.map(function(_ref2) {
                var source = _ref2.source;
                return (0, $0VpsC.getAutocompleteElementId)(props.id, 'list', source);
            }).join(' ') : undefined,
            'aria-labelledby': (0, $0VpsC.getAutocompleteElementId)(props.id, 'label')
        }, rest);
    };
    var getFormProps = function getFormProps(providedProps) {
        var inputElement = providedProps.inputElement, rest = $27a4c0083de1c0c7$var$_objectWithoutProperties(providedProps, $27a4c0083de1c0c7$var$_excluded3);
        return $27a4c0083de1c0c7$var$_objectSpread({
            action: '',
            noValidate: true,
            role: 'search',
            onSubmit: function onSubmit(event) {
                var _providedProps$inputE;
                event.preventDefault();
                props.onSubmit($27a4c0083de1c0c7$var$_objectSpread({
                    event: event,
                    refresh: refresh,
                    state: store.getState()
                }, setters));
                store.dispatch('submit', null);
                (_providedProps$inputE = providedProps.inputElement) === null || _providedProps$inputE === void 0 || _providedProps$inputE.blur();
            },
            onReset: function onReset(event) {
                var _providedProps$inputE2;
                event.preventDefault();
                props.onReset($27a4c0083de1c0c7$var$_objectSpread({
                    event: event,
                    refresh: refresh,
                    state: store.getState()
                }, setters));
                store.dispatch('reset', null);
                (_providedProps$inputE2 = providedProps.inputElement) === null || _providedProps$inputE2 === void 0 || _providedProps$inputE2.focus();
            }
        }, rest);
    };
    var getInputProps = function getInputProps(providedProps) {
        var _props$environment$na;
        function onFocus(event) {
            // We want to trigger a query when `openOnFocus` is true
            // because the panel should open with the current query.
            if (props.openOnFocus || Boolean(store.getState().query)) (0, $1Ni2w.onInput)($27a4c0083de1c0c7$var$_objectSpread({
                event: event,
                props: props,
                query: store.getState().completion || store.getState().query,
                refresh: refresh,
                store: store
            }, setters));
            store.dispatch('focus', null);
        }
        var _ref3 = providedProps || {}, inputElement = _ref3.inputElement, _ref3$maxLength = _ref3.maxLength, maxLength = _ref3$maxLength === void 0 ? 512 : _ref3$maxLength, rest = $27a4c0083de1c0c7$var$_objectWithoutProperties(_ref3, $27a4c0083de1c0c7$var$_excluded4);
        var activeItem = (0, $4d50Q.getActiveItem)(store.getState());
        var userAgent = ((_props$environment$na = props.environment.navigator) === null || _props$environment$na === void 0 ? void 0 : _props$environment$na.userAgent) || '';
        var shouldFallbackKeyHint = (0, $1IbUX.isSamsung)(userAgent);
        var enterKeyHint = props.enterKeyHint || (activeItem !== null && activeItem !== void 0 && activeItem.itemUrl && !shouldFallbackKeyHint ? 'go' : 'search');
        return $27a4c0083de1c0c7$var$_objectSpread({
            'aria-autocomplete': 'both',
            'aria-activedescendant': store.getState().isOpen && store.getState().activeItemId !== null ? (0, $0VpsC.getAutocompleteElementId)(props.id, "item-".concat(store.getState().activeItemId), activeItem === null || activeItem === void 0 ? void 0 : activeItem.source) : undefined,
            'aria-controls': store.getState().isOpen ? store.getState().collections.map(function(_ref4) {
                var source = _ref4.source;
                return (0, $0VpsC.getAutocompleteElementId)(props.id, 'list', source);
            }).join(' ') : undefined,
            'aria-labelledby': (0, $0VpsC.getAutocompleteElementId)(props.id, 'label'),
            value: store.getState().completion || store.getState().query,
            id: (0, $0VpsC.getAutocompleteElementId)(props.id, 'input'),
            autoComplete: 'off',
            autoCorrect: 'off',
            autoCapitalize: 'off',
            enterKeyHint: enterKeyHint,
            spellCheck: 'false',
            autoFocus: props.autoFocus,
            placeholder: props.placeholder,
            maxLength: maxLength,
            type: 'search',
            onChange: function onChange(event) {
                (0, $1Ni2w.onInput)($27a4c0083de1c0c7$var$_objectSpread({
                    event: event,
                    props: props,
                    query: event.currentTarget.value.slice(0, maxLength),
                    refresh: refresh,
                    store: store
                }, setters));
            },
            onKeyDown: function onKeyDown(event) {
                (0, $ji6c9.onKeyDown)($27a4c0083de1c0c7$var$_objectSpread({
                    event: event,
                    props: props,
                    refresh: refresh,
                    store: store
                }, setters));
            },
            onFocus: onFocus,
            // We don't rely on the `blur` event.
            // See explanation in `onTouchStart`/`onMouseDown`.
            // @MAJOR See if we need to keep this handler.
            onBlur: (0, $iKicX.noop),
            onClick: function onClick(event) {
                // When the panel is closed and you click on the input while
                // the input is focused, the `onFocus` event is not triggered
                // (default browser behavior).
                // In an autocomplete context, it makes sense to open the panel in this
                // case.
                // We mimic this event by catching the `onClick` event which
                // triggers the `onFocus` for the panel to open.
                if (providedProps.inputElement === props.environment.document.activeElement && !store.getState().isOpen) onFocus(event);
            }
        }, rest);
    };
    var getLabelProps = function getLabelProps(rest) {
        return $27a4c0083de1c0c7$var$_objectSpread({
            htmlFor: (0, $0VpsC.getAutocompleteElementId)(props.id, 'input'),
            id: (0, $0VpsC.getAutocompleteElementId)(props.id, 'label')
        }, rest);
    };
    var getListProps = function getListProps(providedProps) {
        var _ref5 = providedProps || {}, source = _ref5.source, rest = $27a4c0083de1c0c7$var$_objectWithoutProperties(_ref5, $27a4c0083de1c0c7$var$_excluded5);
        return $27a4c0083de1c0c7$var$_objectSpread({
            role: 'listbox',
            'aria-labelledby': (0, $0VpsC.getAutocompleteElementId)(props.id, 'label'),
            id: (0, $0VpsC.getAutocompleteElementId)(props.id, 'list', source)
        }, rest);
    };
    var getPanelProps = function getPanelProps(rest) {
        return $27a4c0083de1c0c7$var$_objectSpread({
            onMouseDown: function onMouseDown(event) {
                // Prevents the `activeElement` from being changed to the panel so
                // that the blur event is not triggered, otherwise it closes the
                // panel.
                event.preventDefault();
            },
            onMouseLeave: function onMouseLeave() {
                store.dispatch('mouseleave', null);
            }
        }, rest);
    };
    var getItemProps = function getItemProps(providedProps) {
        var item = providedProps.item, source = providedProps.source, rest = $27a4c0083de1c0c7$var$_objectWithoutProperties(providedProps, $27a4c0083de1c0c7$var$_excluded6);
        return $27a4c0083de1c0c7$var$_objectSpread({
            id: (0, $0VpsC.getAutocompleteElementId)(props.id, "item-".concat(item.__autocomplete_id), source),
            role: 'option',
            'aria-selected': store.getState().activeItemId === item.__autocomplete_id,
            onMouseMove: function onMouseMove(event) {
                if (item.__autocomplete_id === store.getState().activeItemId) return;
                store.dispatch('mousemove', item.__autocomplete_id);
                var activeItem = (0, $4d50Q.getActiveItem)(store.getState());
                if (store.getState().activeItemId !== null && activeItem) {
                    var _item = activeItem.item, itemInputValue = activeItem.itemInputValue, itemUrl = activeItem.itemUrl, _source = activeItem.source;
                    _source.onActive($27a4c0083de1c0c7$var$_objectSpread({
                        event: event,
                        item: _item,
                        itemInputValue: itemInputValue,
                        itemUrl: itemUrl,
                        refresh: refresh,
                        source: _source,
                        state: store.getState()
                    }, setters));
                }
            },
            onMouseDown: function onMouseDown(event) {
                // Prevents the `activeElement` from being changed to the item so it
                // can remain with the current `activeElement`.
                event.preventDefault();
            },
            onClick: function onClick(event) {
                var itemInputValue = source.getItemInputValue({
                    item: item,
                    state: store.getState()
                });
                var itemUrl = source.getItemUrl({
                    item: item,
                    state: store.getState()
                });
                // If `getItemUrl` is provided, it means that the suggestion
                // is a link, not plain text that aims at updating the query.
                // We can therefore skip the state change because it will update
                // the `activeItemId`, resulting in a UI flash, especially
                // noticeable on mobile.
                var runPreCommand = itemUrl ? Promise.resolve() : (0, $1Ni2w.onInput)($27a4c0083de1c0c7$var$_objectSpread({
                    event: event,
                    nextState: {
                        isOpen: false
                    },
                    props: props,
                    query: itemInputValue,
                    refresh: refresh,
                    store: store
                }, setters));
                runPreCommand.then(function() {
                    source.onSelect($27a4c0083de1c0c7$var$_objectSpread({
                        event: event,
                        item: item,
                        itemInputValue: itemInputValue,
                        itemUrl: itemUrl,
                        refresh: refresh,
                        source: source,
                        state: store.getState()
                    }, setters));
                });
            }
        }, rest);
    };
    return {
        getEnvironmentProps: getEnvironmentProps,
        getRootProps: getRootProps,
        getFormProps: getFormProps,
        getLabelProps: getLabelProps,
        getInputProps: getInputProps,
        getPanelProps: getPanelProps,
        getListProps: getListProps,
        getItemProps: getItemProps
    };
}

});
parcelRegister("1Ni2w", function(module, exports) {

$parcel$export(module.exports, "onInput", () => $14e85c5bb036d9e1$export$7fbc06d7c1beb512);

var $9JvX2 = parcelRequire("9JvX2");

var $9fqif = parcelRequire("9fqif");

var $BpBoE = parcelRequire("BpBoE");
var $a0gYU = parcelRequire("a0gYU");
var $4d50Q = parcelRequire("4d50Q");
function $14e85c5bb036d9e1$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $14e85c5bb036d9e1$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $14e85c5bb036d9e1$var$_typeof(obj);
}
var $14e85c5bb036d9e1$var$_excluded = [
    "event",
    "nextState",
    "props",
    "query",
    "refresh",
    "store"
];
function $14e85c5bb036d9e1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $14e85c5bb036d9e1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $14e85c5bb036d9e1$var$ownKeys(Object(source), !0).forEach(function(key) {
            $14e85c5bb036d9e1$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $14e85c5bb036d9e1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $14e85c5bb036d9e1$var$_defineProperty(obj, key, value) {
    key = $14e85c5bb036d9e1$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $14e85c5bb036d9e1$var$_toPropertyKey(arg) {
    var key = $14e85c5bb036d9e1$var$_toPrimitive(arg, "string");
    return $14e85c5bb036d9e1$var$_typeof(key) === "symbol" ? key : String(key);
}
function $14e85c5bb036d9e1$var$_toPrimitive(input, hint) {
    if ($14e85c5bb036d9e1$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($14e85c5bb036d9e1$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $14e85c5bb036d9e1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $14e85c5bb036d9e1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $14e85c5bb036d9e1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $14e85c5bb036d9e1$var$lastStalledId = null;
var $14e85c5bb036d9e1$var$runConcurrentSafePromise = (0, $a0gYU.createConcurrentSafePromise)();
function $14e85c5bb036d9e1$export$7fbc06d7c1beb512(_ref) {
    var event = _ref.event, _ref$nextState = _ref.nextState, nextState = _ref$nextState === void 0 ? {} : _ref$nextState, props = _ref.props, query = _ref.query, refresh = _ref.refresh, store = _ref.store, setters = $14e85c5bb036d9e1$var$_objectWithoutProperties(_ref, $14e85c5bb036d9e1$var$_excluded);
    if ($14e85c5bb036d9e1$var$lastStalledId) props.environment.clearTimeout($14e85c5bb036d9e1$var$lastStalledId);
    var setCollections = setters.setCollections, setIsOpen = setters.setIsOpen, setQuery = setters.setQuery, setActiveItemId = setters.setActiveItemId, setStatus = setters.setStatus, setContext = setters.setContext;
    setQuery(query);
    setActiveItemId(props.defaultActiveItemId);
    if (!query && props.openOnFocus === false) {
        var _nextState$isOpen;
        var collections = store.getState().collections.map(function(collection) {
            return $14e85c5bb036d9e1$var$_objectSpread($14e85c5bb036d9e1$var$_objectSpread({}, collection), {}, {
                items: []
            });
        });
        setStatus('idle');
        setCollections(collections);
        setIsOpen((_nextState$isOpen = nextState.isOpen) !== null && _nextState$isOpen !== void 0 ? _nextState$isOpen : props.shouldPanelOpen({
            state: store.getState()
        }));
        // We make sure to update the latest resolved value of the tracked
        // promises to keep late resolving promises from "cancelling" the state
        // updates performed in this code path.
        // We chain with a void promise to respect `onInput`'s expected return type.
        var _request = (0, $BpBoE.cancelable)($14e85c5bb036d9e1$var$runConcurrentSafePromise(collections).then(function() {
            return Promise.resolve();
        }));
        return store.pendingRequests.add(_request);
    }
    setStatus('loading');
    $14e85c5bb036d9e1$var$lastStalledId = props.environment.setTimeout(function() {
        setStatus('stalled');
    }, props.stallThreshold);
    // We track the entire promise chain triggered by `onInput` before mutating
    // the Autocomplete state to make sure that any state manipulation is based on
    // fresh data regardless of when promises individually resolve.
    // We don't track nested promises and only rely on the full chain resolution,
    // meaning we should only ever manipulate the state once this concurrent-safe
    // promise is resolved.
    var request = (0, $BpBoE.cancelable)($14e85c5bb036d9e1$var$runConcurrentSafePromise(props.getSources($14e85c5bb036d9e1$var$_objectSpread({
        query: query,
        refresh: refresh,
        state: store.getState()
    }, setters)).then(function(sources) {
        return Promise.all(sources.map(function(source) {
            return Promise.resolve(source.getItems($14e85c5bb036d9e1$var$_objectSpread({
                query: query,
                refresh: refresh,
                state: store.getState()
            }, setters))).then(function(itemsOrDescription) {
                return (0, $9fqif.preResolve)(itemsOrDescription, source.sourceId, store.getState());
            });
        })).then((0, $9fqif.resolve)).then(function(responses) {
            var __automaticInsights = responses.some(function(_ref2) {
                var items = _ref2.items;
                return $14e85c5bb036d9e1$var$isSearchResponseWithAutomaticInsightsFlag(items);
            });
            // No need to pollute the context if `__automaticInsights=false`
            if (__automaticInsights) {
                var _store$getState$conte;
                setContext({
                    algoliaInsightsPlugin: $14e85c5bb036d9e1$var$_objectSpread($14e85c5bb036d9e1$var$_objectSpread({}, ((_store$getState$conte = store.getState().context) === null || _store$getState$conte === void 0 ? void 0 : _store$getState$conte.algoliaInsightsPlugin) || {}), {}, {
                        __automaticInsights: __automaticInsights
                    })
                });
            }
            return (0, $9fqif.postResolve)(responses, sources, store);
        }).then(function(collections) {
            return (0, $9JvX2.reshape)({
                collections: collections,
                props: props,
                state: store.getState()
            });
        });
    }))).then(function(collections) {
        var _nextState$isOpen2;
        // Parameters passed to `onInput` could be stale when the following code
        // executes, because `onInput` calls may not resolve in order.
        // If it becomes a problem we'll need to save the last passed parameters.
        // See: https://codesandbox.io/s/agitated-cookies-y290z
        setStatus('idle');
        setCollections(collections);
        var isPanelOpen = props.shouldPanelOpen({
            state: store.getState()
        });
        setIsOpen((_nextState$isOpen2 = nextState.isOpen) !== null && _nextState$isOpen2 !== void 0 ? _nextState$isOpen2 : props.openOnFocus && !query && isPanelOpen || isPanelOpen);
        var highlightedItem = (0, $4d50Q.getActiveItem)(store.getState());
        if (store.getState().activeItemId !== null && highlightedItem) {
            var item = highlightedItem.item, itemInputValue = highlightedItem.itemInputValue, itemUrl = highlightedItem.itemUrl, source = highlightedItem.source;
            source.onActive($14e85c5bb036d9e1$var$_objectSpread({
                event: event,
                item: item,
                itemInputValue: itemInputValue,
                itemUrl: itemUrl,
                refresh: refresh,
                source: source,
                state: store.getState()
            }, setters));
        }
    }).finally(function() {
        setStatus('idle');
        if ($14e85c5bb036d9e1$var$lastStalledId) props.environment.clearTimeout($14e85c5bb036d9e1$var$lastStalledId);
    });
    return store.pendingRequests.add(request);
}
function $14e85c5bb036d9e1$var$isSearchResponseWithAutomaticInsightsFlag(items) {
    return !Array.isArray(items) && Boolean(items === null || items === void 0 ? void 0 : items._automaticInsights);
}

});
parcelRegister("9JvX2", function(module, exports) {

$parcel$export(module.exports, "reshape", () => $716119dbb411e1cb$export$9eaad88cf88cee2b);

var $gHn53 = parcelRequire("gHn53");
function $716119dbb411e1cb$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $716119dbb411e1cb$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $716119dbb411e1cb$var$_typeof(obj);
}
function $716119dbb411e1cb$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $716119dbb411e1cb$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $716119dbb411e1cb$var$ownKeys(Object(source), !0).forEach(function(key) {
            $716119dbb411e1cb$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $716119dbb411e1cb$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $716119dbb411e1cb$var$_defineProperty(obj, key, value) {
    key = $716119dbb411e1cb$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $716119dbb411e1cb$var$_toPropertyKey(arg) {
    var key = $716119dbb411e1cb$var$_toPrimitive(arg, "string");
    return $716119dbb411e1cb$var$_typeof(key) === "symbol" ? key : String(key);
}
function $716119dbb411e1cb$var$_toPrimitive(input, hint) {
    if ($716119dbb411e1cb$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($716119dbb411e1cb$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $716119dbb411e1cb$export$9eaad88cf88cee2b(_ref) {
    var collections = _ref.collections, props = _ref.props, state = _ref.state;
    // Sources are grouped by `sourceId` to conveniently pick them via destructuring.
    // Example: `const { recentSearchesPlugin } = sourcesBySourceId`
    var originalSourcesBySourceId = collections.reduce(function(acc, collection) {
        return $716119dbb411e1cb$var$_objectSpread($716119dbb411e1cb$var$_objectSpread({}, acc), {}, $716119dbb411e1cb$var$_defineProperty({}, collection.source.sourceId, $716119dbb411e1cb$var$_objectSpread($716119dbb411e1cb$var$_objectSpread({}, collection.source), {}, {
            getItems: function getItems() {
                // We provide the resolved items from the collection to the `reshape` prop.
                return (0, $gHn53.flatten)(collection.items);
            }
        })));
    }, {});
    var _props$plugins$reduce = props.plugins.reduce(function(acc, plugin) {
        if (plugin.reshape) return plugin.reshape(acc);
        return acc;
    }, {
        sourcesBySourceId: originalSourcesBySourceId,
        state: state
    }), sourcesBySourceId = _props$plugins$reduce.sourcesBySourceId;
    var reshapeSources = props.reshape({
        sourcesBySourceId: sourcesBySourceId,
        sources: Object.values(sourcesBySourceId),
        state: state
    });
    // We reconstruct the collections with the items modified by the `reshape` prop.
    return (0, $gHn53.flatten)(reshapeSources).filter(Boolean).map(function(source) {
        return {
            source: source,
            items: source.getItems()
        };
    });
}

});

parcelRegister("9fqif", function(module, exports) {

$parcel$export(module.exports, "preResolve", () => $6bb9e9194577c63e$export$ae3cd3529c74e69e);
$parcel$export(module.exports, "resolve", () => $6bb9e9194577c63e$export$f7ad0328861e2f03);
$parcel$export(module.exports, "postResolve", () => $6bb9e9194577c63e$export$c1b3edf5a28f586);

var $cN70B = parcelRequire("cN70B");
var $gHn53 = parcelRequire("gHn53");
var $6HaDi = parcelRequire("6HaDi");

var $58jeg = parcelRequire("58jeg");
function $6bb9e9194577c63e$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $6bb9e9194577c63e$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $6bb9e9194577c63e$var$_typeof(obj);
}
function $6bb9e9194577c63e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6bb9e9194577c63e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $6bb9e9194577c63e$var$ownKeys(Object(source), !0).forEach(function(key) {
            $6bb9e9194577c63e$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $6bb9e9194577c63e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6bb9e9194577c63e$var$_defineProperty(obj, key, value) {
    key = $6bb9e9194577c63e$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $6bb9e9194577c63e$var$_toPropertyKey(arg) {
    var key = $6bb9e9194577c63e$var$_toPrimitive(arg, "string");
    return $6bb9e9194577c63e$var$_typeof(key) === "symbol" ? key : String(key);
}
function $6bb9e9194577c63e$var$_toPrimitive(input, hint) {
    if ($6bb9e9194577c63e$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($6bb9e9194577c63e$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $6bb9e9194577c63e$var$_toConsumableArray(arr) {
    return $6bb9e9194577c63e$var$_arrayWithoutHoles(arr) || $6bb9e9194577c63e$var$_iterableToArray(arr) || $6bb9e9194577c63e$var$_unsupportedIterableToArray(arr) || $6bb9e9194577c63e$var$_nonIterableSpread();
}
function $6bb9e9194577c63e$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $6bb9e9194577c63e$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $6bb9e9194577c63e$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $6bb9e9194577c63e$var$_arrayLikeToArray(o, minLen);
}
function $6bb9e9194577c63e$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $6bb9e9194577c63e$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $6bb9e9194577c63e$var$_arrayLikeToArray(arr);
}
function $6bb9e9194577c63e$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $6bb9e9194577c63e$var$isDescription(item) {
    return Boolean(item.execute);
}
function $6bb9e9194577c63e$var$isRequesterDescription(description) {
    return Boolean(description === null || description === void 0 ? void 0 : description.execute);
}
function $6bb9e9194577c63e$export$ae3cd3529c74e69e(itemsOrDescription, sourceId, state) {
    if ($6bb9e9194577c63e$var$isRequesterDescription(itemsOrDescription)) {
        var contextParameters = itemsOrDescription.requesterId === 'algolia' ? Object.assign.apply(Object, [
            {}
        ].concat($6bb9e9194577c63e$var$_toConsumableArray(Object.keys(state.context).map(function(key) {
            var _state$context$key;
            return (_state$context$key = state.context[key]) === null || _state$context$key === void 0 ? void 0 : _state$context$key.__algoliaSearchParameters;
        })))) : {};
        return $6bb9e9194577c63e$var$_objectSpread($6bb9e9194577c63e$var$_objectSpread({}, itemsOrDescription), {}, {
            requests: itemsOrDescription.queries.map(function(query) {
                return {
                    query: itemsOrDescription.requesterId === 'algolia' ? $6bb9e9194577c63e$var$_objectSpread($6bb9e9194577c63e$var$_objectSpread({}, query), {}, {
                        params: $6bb9e9194577c63e$var$_objectSpread($6bb9e9194577c63e$var$_objectSpread({}, contextParameters), query.params)
                    }) : query,
                    sourceId: sourceId,
                    transformResponse: itemsOrDescription.transformResponse
                };
            })
        });
    }
    return {
        items: itemsOrDescription,
        sourceId: sourceId
    };
}
function $6bb9e9194577c63e$export$f7ad0328861e2f03(items) {
    var packed = items.reduce(function(acc, current) {
        if (!$6bb9e9194577c63e$var$isDescription(current)) {
            acc.push(current);
            return acc;
        }
        var searchClient = current.searchClient, execute = current.execute, requesterId = current.requesterId, requests = current.requests;
        var container = acc.find(function(item) {
            return $6bb9e9194577c63e$var$isDescription(current) && $6bb9e9194577c63e$var$isDescription(item) && item.searchClient === searchClient && Boolean(requesterId) && item.requesterId === requesterId;
        });
        if (container) {
            var _container$items;
            (_container$items = container.items).push.apply(_container$items, $6bb9e9194577c63e$var$_toConsumableArray(requests));
        } else {
            var request = {
                execute: execute,
                requesterId: requesterId,
                items: requests,
                searchClient: searchClient
            };
            acc.push(request);
        }
        return acc;
    }, []);
    var values = packed.map(function(maybeDescription) {
        if (!$6bb9e9194577c63e$var$isDescription(maybeDescription)) return Promise.resolve(maybeDescription);
        var _ref = maybeDescription, execute = _ref.execute, items = _ref.items, searchClient = _ref.searchClient;
        return execute({
            searchClient: searchClient,
            requests: items
        });
    });
    return Promise.all(values).then(function(responses) {
        return (0, $gHn53.flatten)(responses);
    });
}
function $6bb9e9194577c63e$export$c1b3edf5a28f586(responses, sources, store) {
    return sources.map(function(source) {
        var matches = responses.filter(function(response) {
            return response.sourceId === source.sourceId;
        });
        var results = matches.map(function(_ref2) {
            var items = _ref2.items;
            return items;
        });
        var transform = matches[0].transformResponse;
        var items = transform ? transform((0, $58jeg.mapToAlgoliaResponse)(results)) : results;
        source.onResolve({
            source: source,
            results: results,
            items: items,
            state: store.getState()
        });
        (0, $6HaDi.invariant)(Array.isArray(items), function() {
            return "The `getItems` function from source \"".concat(source.sourceId, "\" must return an array of items but returned type ").concat(JSON.stringify($6bb9e9194577c63e$var$_typeof(items)), ":\n\n").concat(JSON.stringify((0, $cN70B.decycle)(items), null, 2), ".\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems");
        });
        (0, $6HaDi.invariant)(items.every(Boolean), "The `getItems` function from source \"".concat(source.sourceId, "\" must return an array of items but returned ").concat(JSON.stringify(undefined), ".\n\nDid you forget to return items?\n\nSee: https://www.algolia.com/doc/ui-libraries/autocomplete/core-concepts/sources/#param-getitems"));
        return {
            source: source,
            items: items
        };
    });
}

});
parcelRegister("58jeg", function(module, exports) {

$parcel$export(module.exports, "mapToAlgoliaResponse", () => $3bcc9d9b25024fec$export$23042d7bd0b8d14b);
function $3bcc9d9b25024fec$export$23042d7bd0b8d14b(rawResults) {
    return {
        results: rawResults,
        hits: rawResults.map(function(result) {
            return result.hits;
        }).filter(Boolean),
        facetHits: rawResults.map(function(result) {
            var _facetHits;
            return (_facetHits = result.facetHits) === null || _facetHits === void 0 ? void 0 : _facetHits.map(function(facetHit) {
                // Bring support for the highlighting components.
                return {
                    label: facetHit.value,
                    count: facetHit.count,
                    _highlightResult: {
                        label: {
                            value: facetHit.highlighted
                        }
                    }
                };
            });
        }).filter(Boolean)
    };
}

});


parcelRegister("BpBoE", function(module, exports) {

$parcel$export(module.exports, "cancelable", () => $070750dfa08ee930$export$95ff25b64c2b7c9d);
function $070750dfa08ee930$var$createInternalCancelablePromise(promise, initialState) {
    var state = initialState;
    return {
        then: function then(onfulfilled, onrejected) {
            return $070750dfa08ee930$var$createInternalCancelablePromise(promise.then($070750dfa08ee930$var$createCallback(onfulfilled, state, promise), $070750dfa08ee930$var$createCallback(onrejected, state, promise)), state);
        },
        catch: function _catch(onrejected) {
            return $070750dfa08ee930$var$createInternalCancelablePromise(promise.catch($070750dfa08ee930$var$createCallback(onrejected, state, promise)), state);
        },
        finally: function _finally(onfinally) {
            if (onfinally) state.onCancelList.push(onfinally);
            return $070750dfa08ee930$var$createInternalCancelablePromise(promise.finally($070750dfa08ee930$var$createCallback(onfinally && function() {
                state.onCancelList = [];
                return onfinally();
            }, state, promise)), state);
        },
        cancel: function cancel() {
            state.isCanceled = true;
            var callbacks = state.onCancelList;
            state.onCancelList = [];
            callbacks.forEach(function(callback) {
                callback();
            });
        },
        isCanceled: function isCanceled() {
            return state.isCanceled === true;
        }
    };
}
function $070750dfa08ee930$export$72af18a8b033265c(executor) {
    return $070750dfa08ee930$var$createInternalCancelablePromise(new Promise(function(resolve, reject) {
        return executor(resolve, reject);
    }), {
        isCanceled: false,
        onCancelList: []
    });
}
$070750dfa08ee930$export$72af18a8b033265c.resolve = function(value) {
    return $070750dfa08ee930$export$95ff25b64c2b7c9d(Promise.resolve(value));
};
$070750dfa08ee930$export$72af18a8b033265c.reject = function(reason) {
    return $070750dfa08ee930$export$95ff25b64c2b7c9d(Promise.reject(reason));
};
function $070750dfa08ee930$export$95ff25b64c2b7c9d(promise) {
    return $070750dfa08ee930$var$createInternalCancelablePromise(promise, {
        isCanceled: false,
        onCancelList: []
    });
}
function $070750dfa08ee930$var$createCallback(onResult, state, fallback) {
    if (!onResult) return fallback;
    return function callback(arg) {
        if (state.isCanceled) return arg;
        return onResult(arg);
    };
}

});

parcelRegister("a0gYU", function(module, exports) {

$parcel$export(module.exports, "createConcurrentSafePromise", () => $7487139d6bef7cff$export$8829b68d73f73d13);
/**
 * Creates a runner that executes promises in a concurrent-safe way.
 *
 * This is useful to prevent older promises to resolve after a newer promise,
 * otherwise resulting in stale resolved values.
 */ function $7487139d6bef7cff$export$8829b68d73f73d13() {
    var basePromiseId = -1;
    var latestResolvedId = -1;
    var latestResolvedValue = undefined;
    return function runConcurrentSafePromise(promise) {
        basePromiseId++;
        var currentPromiseId = basePromiseId;
        return Promise.resolve(promise).then(function(x) {
            // The promise might take too long to resolve and get outdated. This would
            // result in resolving stale values.
            // When this happens, we ignore the promise value and return the one
            // coming from the latest resolved value.
            //
            // +----------------------------------+
            // |        100ms                     |
            // | run(1) +--->  R1                 |
            // |        300ms                     |
            // | run(2) +-------------> R2 (SKIP) |
            // |        200ms                     |
            // | run(3) +--------> R3             |
            // +----------------------------------+
            if (latestResolvedValue && currentPromiseId < latestResolvedId) return latestResolvedValue;
            latestResolvedId = currentPromiseId;
            latestResolvedValue = x;
            return x;
        });
    };
}

});

parcelRegister("4d50Q", function(module, exports) {

$parcel$export(module.exports, "getActiveItem", () => $310c43be0f959476$export$f0f14253205ef68f);
// We don't have access to the autocomplete source when we call `onKeyDown`
// or `onClick` because those are native browser events.
// However, we can get the source from the suggestion index.
function $310c43be0f959476$var$getCollectionFromActiveItemId(state) {
    // Given 3 sources with respectively 1, 2 and 3 suggestions: [1, 2, 3]
    // We want to get the accumulated counts:
    // [1, 1 + 2, 1 + 2 + 3] = [1, 3, 3 + 3] = [1, 3, 6]
    var accumulatedCollectionsCount = state.collections.map(function(collections) {
        return collections.items.length;
    }).reduce(function(acc, collectionsCount, index) {
        var previousValue = acc[index - 1] || 0;
        var nextValue = previousValue + collectionsCount;
        acc.push(nextValue);
        return acc;
    }, []);
    // Based on the accumulated counts, we can infer the index of the suggestion.
    var collectionIndex = accumulatedCollectionsCount.reduce(function(acc, current) {
        if (current <= state.activeItemId) return acc + 1;
        return acc;
    }, 0);
    return state.collections[collectionIndex];
}
/**
 * Gets the highlighted index relative to a suggestion object (not the absolute
 * highlighted index).
 *
 * Example:
 *  [['a', 'b'], ['c', 'd', 'e'], ['f']]
 *                      ↑
 *         (absolute: 3, relative: 1)
 */ function $310c43be0f959476$var$getRelativeActiveItemId(_ref) {
    var state = _ref.state, collection = _ref.collection;
    var isOffsetFound = false;
    var counter = 0;
    var previousItemsOffset = 0;
    while(isOffsetFound === false){
        var currentCollection = state.collections[counter];
        if (currentCollection === collection) {
            isOffsetFound = true;
            break;
        }
        previousItemsOffset += currentCollection.items.length;
        counter++;
    }
    return state.activeItemId - previousItemsOffset;
}
function $310c43be0f959476$export$f0f14253205ef68f(state) {
    var collection = $310c43be0f959476$var$getCollectionFromActiveItemId(state);
    if (!collection) return null;
    var item = collection.items[$310c43be0f959476$var$getRelativeActiveItemId({
        state: state,
        collection: collection
    })];
    var source = collection.source;
    var itemInputValue = source.getItemInputValue({
        item: item,
        state: state
    });
    var itemUrl = source.getItemUrl({
        item: item,
        state: state
    });
    return {
        item: item,
        itemInputValue: itemInputValue,
        itemUrl: itemUrl,
        source: source
    };
}

});


parcelRegister("ji6c9", function(module, exports) {

$parcel$export(module.exports, "onKeyDown", () => $e0b480f1fd79130f$export$de8e1b1372cdb41b);

var $1Ni2w = parcelRequire("1Ni2w");

var $4d50Q = parcelRequire("4d50Q");
var $0VpsC = parcelRequire("0VpsC");
function $e0b480f1fd79130f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $e0b480f1fd79130f$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $e0b480f1fd79130f$var$_typeof(obj);
}
var $e0b480f1fd79130f$var$_excluded = [
    "event",
    "props",
    "refresh",
    "store"
];
function $e0b480f1fd79130f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $e0b480f1fd79130f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $e0b480f1fd79130f$var$ownKeys(Object(source), !0).forEach(function(key) {
            $e0b480f1fd79130f$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $e0b480f1fd79130f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $e0b480f1fd79130f$var$_defineProperty(obj, key, value) {
    key = $e0b480f1fd79130f$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $e0b480f1fd79130f$var$_toPropertyKey(arg) {
    var key = $e0b480f1fd79130f$var$_toPrimitive(arg, "string");
    return $e0b480f1fd79130f$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e0b480f1fd79130f$var$_toPrimitive(input, hint) {
    if ($e0b480f1fd79130f$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e0b480f1fd79130f$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e0b480f1fd79130f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $e0b480f1fd79130f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $e0b480f1fd79130f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $e0b480f1fd79130f$export$de8e1b1372cdb41b(_ref) {
    var event = _ref.event, props = _ref.props, refresh = _ref.refresh, store = _ref.store, setters = $e0b480f1fd79130f$var$_objectWithoutProperties(_ref, $e0b480f1fd79130f$var$_excluded);
    if (event.key === 'ArrowUp' || event.key === 'ArrowDown') {
        // eslint-disable-next-line no-inner-declarations
        var triggerScrollIntoView = function triggerScrollIntoView() {
            var highlightedItem = (0, $4d50Q.getActiveItem)(store.getState());
            var nodeItem = props.environment.document.getElementById((0, $0VpsC.getAutocompleteElementId)(props.id, "item-".concat(store.getState().activeItemId), highlightedItem === null || highlightedItem === void 0 ? void 0 : highlightedItem.source));
            if (nodeItem) {
                if (nodeItem.scrollIntoViewIfNeeded) nodeItem.scrollIntoViewIfNeeded(false);
                else nodeItem.scrollIntoView(false);
            }
        }; // eslint-disable-next-line no-inner-declarations
        var triggerOnActive = function triggerOnActive() {
            var highlightedItem = (0, $4d50Q.getActiveItem)(store.getState());
            if (store.getState().activeItemId !== null && highlightedItem) {
                var item = highlightedItem.item, itemInputValue = highlightedItem.itemInputValue, itemUrl = highlightedItem.itemUrl, source = highlightedItem.source;
                source.onActive($e0b480f1fd79130f$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
            }
        }; // Default browser behavior changes the caret placement on ArrowUp and
        // ArrowDown.
        event.preventDefault();
        // When re-opening the panel, we need to split the logic to keep the actions
        // synchronized as `onInput` returns a promise.
        if (store.getState().isOpen === false && (props.openOnFocus || Boolean(store.getState().query))) (0, $1Ni2w.onInput)($e0b480f1fd79130f$var$_objectSpread({
            event: event,
            props: props,
            query: store.getState().query,
            refresh: refresh,
            store: store
        }, setters)).then(function() {
            store.dispatch(event.key, {
                nextActiveItemId: props.defaultActiveItemId
            });
            triggerOnActive();
            // Since we rely on the DOM, we need to wait for all the micro tasks to
            // finish (which include re-opening the panel) to make sure all the
            // elements are available.
            setTimeout(triggerScrollIntoView, 0);
        });
        else {
            store.dispatch(event.key, {});
            triggerOnActive();
            triggerScrollIntoView();
        }
    } else if (event.key === 'Escape') {
        // This prevents the default browser behavior on `input[type="search"]`
        // from removing the query right away because we first want to close the
        // panel.
        event.preventDefault();
        store.dispatch(event.key, null);
        // Hitting the `Escape` key signals the end of a user interaction with the
        // autocomplete. At this point, we should ignore any requests that are still
        // pending and could reopen the panel once they resolve, because that would
        // result in an unsolicited UI behavior.
        store.pendingRequests.cancelAll();
    } else if (event.key === 'Tab') {
        store.dispatch('blur', null);
        // Hitting the `Tab` key signals the end of a user interaction with the
        // autocomplete. At this point, we should ignore any requests that are still
        // pending and could reopen the panel once they resolve, because that would
        // result in an unsolicited UI behavior.
        store.pendingRequests.cancelAll();
    } else if (event.key === 'Enter') {
        // No active item, so we let the browser handle the native `onSubmit` form
        // event.
        if (store.getState().activeItemId === null || store.getState().collections.every(function(collection) {
            return collection.items.length === 0;
        })) {
            // If requests are still pending when the panel closes, they could reopen
            // the panel once they resolve.
            // We want to prevent any subsequent query from reopening the panel
            // because it would result in an unsolicited UI behavior.
            if (!props.debug) store.pendingRequests.cancelAll();
            return;
        }
        // This prevents the `onSubmit` event to be sent because an item is
        // highlighted.
        event.preventDefault();
        var _ref2 = (0, $4d50Q.getActiveItem)(store.getState()), item = _ref2.item, itemInputValue = _ref2.itemInputValue, itemUrl = _ref2.itemUrl, source = _ref2.source;
        if (event.metaKey || event.ctrlKey) {
            if (itemUrl !== undefined) {
                source.onSelect($e0b480f1fd79130f$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigateNewTab({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
            }
        } else if (event.shiftKey) {
            if (itemUrl !== undefined) {
                source.onSelect($e0b480f1fd79130f$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigateNewWindow({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
            }
        } else if (event.altKey) ;
        else {
            if (itemUrl !== undefined) {
                source.onSelect($e0b480f1fd79130f$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
                props.navigator.navigate({
                    itemUrl: itemUrl,
                    item: item,
                    state: store.getState()
                });
                return;
            }
            (0, $1Ni2w.onInput)($e0b480f1fd79130f$var$_objectSpread({
                event: event,
                nextState: {
                    isOpen: false
                },
                props: props,
                query: itemInputValue,
                refresh: refresh,
                store: store
            }, setters)).then(function() {
                source.onSelect($e0b480f1fd79130f$var$_objectSpread({
                    event: event,
                    item: item,
                    itemInputValue: itemInputValue,
                    itemUrl: itemUrl,
                    refresh: refresh,
                    source: source,
                    state: store.getState()
                }, setters));
            });
        }
    }
}

});
parcelRegister("0VpsC", function(module, exports) {

$parcel$export(module.exports, "getAutocompleteElementId", () => $002c8890274fd45f$export$17f5bb35a44b3f03);
/**
 * Returns a full element id for an autocomplete element.
 *
 * @param autocompleteInstanceId The id of the autocomplete instance
 * @param elementId The specific element id
 * @param source The source of the element, when it needs to be scoped
 */ function $002c8890274fd45f$export$17f5bb35a44b3f03(autocompleteInstanceId, elementId, source) {
    return [
        autocompleteInstanceId,
        source === null || source === void 0 ? void 0 : source.sourceId,
        elementId
    ].filter(Boolean).join('-').replace(/\s/g, '');
}

});


parcelRegister("66GDI", function(module, exports) {

$parcel$export(module.exports, "isOrContainsNode", () => $472460effc0b7ae6$export$428954767edfafa7);
function $472460effc0b7ae6$export$428954767edfafa7(parent, child) {
    return parent === child || parent.contains(child);
}

});

parcelRegister("1IbUX", function(module, exports) {

$parcel$export(module.exports, "isSamsung", () => $13f325201215d6aa$export$838732a363f40fc6);
var $13f325201215d6aa$var$regex = /((gt|sm)-|galaxy nexus)|samsung[- ]|samsungbrowser/i;
function $13f325201215d6aa$export$838732a363f40fc6(userAgent) {
    return Boolean(userAgent && userAgent.match($13f325201215d6aa$var$regex));
}

});


parcelRegister("kJ7uN", function(module, exports) {

$parcel$export(module.exports, "getMetadata", () => $f16dd31f872bc0f0$export$8548546c0aa631e6);
$parcel$export(module.exports, "injectMetadata", () => $f16dd31f872bc0f0$export$404feeb97c870f44);

var $kEz0A = parcelRequire("kEz0A");
function $f16dd31f872bc0f0$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $f16dd31f872bc0f0$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $f16dd31f872bc0f0$var$_typeof(obj);
}
function $f16dd31f872bc0f0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $f16dd31f872bc0f0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $f16dd31f872bc0f0$var$ownKeys(Object(source), !0).forEach(function(key) {
            $f16dd31f872bc0f0$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $f16dd31f872bc0f0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $f16dd31f872bc0f0$var$_defineProperty(obj, key, value) {
    key = $f16dd31f872bc0f0$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $f16dd31f872bc0f0$var$_toPropertyKey(arg) {
    var key = $f16dd31f872bc0f0$var$_toPrimitive(arg, "string");
    return $f16dd31f872bc0f0$var$_typeof(key) === "symbol" ? key : String(key);
}
function $f16dd31f872bc0f0$var$_toPrimitive(input, hint) {
    if ($f16dd31f872bc0f0$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($f16dd31f872bc0f0$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $f16dd31f872bc0f0$export$8548546c0aa631e6(_ref) {
    var _, _options$__autocomple, _options$__autocomple2, _options$__autocomple3;
    var plugins = _ref.plugins, options = _ref.options;
    var optionsKey = (_ = (((_options$__autocomple = options.__autocomplete_metadata) === null || _options$__autocomple === void 0 ? void 0 : _options$__autocomple.userAgents) || [])[0]) === null || _ === void 0 ? void 0 : _.segment;
    var extraOptions = optionsKey ? $f16dd31f872bc0f0$var$_defineProperty({}, optionsKey, Object.keys(((_options$__autocomple2 = options.__autocomplete_metadata) === null || _options$__autocomple2 === void 0 ? void 0 : _options$__autocomple2.options) || {})) : {};
    return {
        plugins: plugins.map(function(plugin) {
            return {
                name: plugin.name,
                options: Object.keys(plugin.__autocomplete_pluginOptions || [])
            };
        }),
        options: $f16dd31f872bc0f0$var$_objectSpread({
            'autocomplete-core': Object.keys(options)
        }, extraOptions),
        ua: (0, $kEz0A.userAgents).concat(((_options$__autocomple3 = options.__autocomplete_metadata) === null || _options$__autocomple3 === void 0 ? void 0 : _options$__autocomple3.userAgents) || [])
    };
}
function $f16dd31f872bc0f0$export$404feeb97c870f44(_ref3) {
    var _environment$navigato, _environment$navigato2;
    var metadata = _ref3.metadata, environment = _ref3.environment;
    var isMetadataEnabled = (_environment$navigato = environment.navigator) === null || _environment$navigato === void 0 ? void 0 : (_environment$navigato2 = _environment$navigato.userAgent) === null || _environment$navigato2 === void 0 ? void 0 : _environment$navigato2.includes('Algolia Crawler');
    if (isMetadataEnabled) {
        var metadataContainer = environment.document.createElement('meta');
        var headRef = environment.document.querySelector('head');
        metadataContainer.name = 'algolia:metadata';
        setTimeout(function() {
            metadataContainer.content = JSON.stringify(metadata);
            headRef.appendChild(metadataContainer);
        }, 0);
    }
}

});
parcelRegister("kEz0A", function(module, exports) {

$parcel$export(module.exports, "userAgents", () => $f092b301697e6743$export$9536ea83a4cbd560);

var $46ND6 = parcelRequire("46ND6");
var $f092b301697e6743$export$9536ea83a4cbd560 = [
    {
        segment: 'autocomplete-core',
        version: (0, $46ND6.version)
    }
];

});
parcelRegister("46ND6", function(module, exports) {

$parcel$export(module.exports, "version", () => $2fde38662d683740$export$83d89fbfd8236492);
var $2fde38662d683740$export$83d89fbfd8236492 = '1.15.0';

});



parcelRegister("2A1cy", function(module, exports) {

$parcel$export(module.exports, "stateReducer", () => $1e0fe0293b1922b3$export$ca8ebd435faad836);

var $avN8a = parcelRequire("avN8a");
var $6HaDi = parcelRequire("6HaDi");

var $k8E5p = parcelRequire("k8E5p");

var $7T00Q = parcelRequire("7T00Q");
function $1e0fe0293b1922b3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    return $1e0fe0293b1922b3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
        return typeof obj;
    } : function(obj) {
        return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, $1e0fe0293b1922b3$var$_typeof(obj);
}
function $1e0fe0293b1922b3$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1e0fe0293b1922b3$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $1e0fe0293b1922b3$var$ownKeys(Object(source), !0).forEach(function(key) {
            $1e0fe0293b1922b3$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $1e0fe0293b1922b3$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1e0fe0293b1922b3$var$_defineProperty(obj, key, value) {
    key = $1e0fe0293b1922b3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1e0fe0293b1922b3$var$_toPropertyKey(arg) {
    var key = $1e0fe0293b1922b3$var$_toPrimitive(arg, "string");
    return $1e0fe0293b1922b3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $1e0fe0293b1922b3$var$_toPrimitive(input, hint) {
    if ($1e0fe0293b1922b3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($1e0fe0293b1922b3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $1e0fe0293b1922b3$export$ca8ebd435faad836 = function stateReducer(state, action) {
    switch(action.type){
        case 'setActiveItemId':
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload
            });
        case 'setQuery':
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                query: action.payload,
                completion: null
            });
        case 'setCollections':
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                collections: action.payload
            });
        case 'setIsOpen':
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                isOpen: action.payload
            });
        case 'setStatus':
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                status: action.payload
            });
        case 'setContext':
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                context: $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state.context), action.payload)
            });
        case 'ArrowDown':
            var nextState = $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload.hasOwnProperty('nextActiveItemId') ? action.payload.nextActiveItemId : (0, $7T00Q.getNextActiveItemId)(1, state.activeItemId, (0, $avN8a.getItemsCount)(state), action.props.defaultActiveItemId)
            });
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, nextState), {}, {
                completion: (0, $k8E5p.getCompletion)({
                    state: nextState
                })
            });
        case 'ArrowUp':
            var _nextState = $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                activeItemId: (0, $7T00Q.getNextActiveItemId)(-1, state.activeItemId, (0, $avN8a.getItemsCount)(state), action.props.defaultActiveItemId)
            });
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, _nextState), {}, {
                completion: (0, $k8E5p.getCompletion)({
                    state: _nextState
                })
            });
        case 'Escape':
            if (state.isOpen) return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                isOpen: false,
                completion: null
            });
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                query: '',
                status: 'idle',
                collections: []
            });
        case 'submit':
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                activeItemId: null,
                isOpen: false,
                status: 'idle'
            });
        case 'reset':
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                activeItemId: // Since we open the panel on reset when openOnFocus=true
                // we need to restore the highlighted index to the defaultActiveItemId. (DocSearch use-case)
                // Since we close the panel when openOnFocus=false
                // we lose track of the highlighted index. (Query-suggestions use-case)
                action.props.openOnFocus === true ? action.props.defaultActiveItemId : null,
                status: 'idle',
                completion: null,
                query: ''
            });
        case 'focus':
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                activeItemId: action.props.defaultActiveItemId,
                isOpen: (action.props.openOnFocus || Boolean(state.query)) && action.props.shouldPanelOpen({
                    state: state
                })
            });
        case 'blur':
            if (action.props.debug) return state;
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                isOpen: false,
                activeItemId: null
            });
        case 'mousemove':
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                activeItemId: action.payload
            });
        case 'mouseleave':
            return $1e0fe0293b1922b3$var$_objectSpread($1e0fe0293b1922b3$var$_objectSpread({}, state), {}, {
                activeItemId: action.props.defaultActiveItemId
            });
        default:
            (0, $6HaDi.invariant)(false, "The reducer action ".concat(JSON.stringify(action.type), " is not supported."));
            return state;
    }
};

});
parcelRegister("k8E5p", function(module, exports) {

$parcel$export(module.exports, "getCompletion", () => $ea93a64ac6e9d07f$export$6c69e642446172b6);

var $4d50Q = parcelRequire("4d50Q");
function $ea93a64ac6e9d07f$export$6c69e642446172b6(_ref) {
    var _getActiveItem;
    var state = _ref.state;
    if (state.isOpen === false || state.activeItemId === null) return null;
    return ((_getActiveItem = (0, $4d50Q.getActiveItem)(state)) === null || _getActiveItem === void 0 ? void 0 : _getActiveItem.itemInputValue) || null;
}

});

parcelRegister("7T00Q", function(module, exports) {

$parcel$export(module.exports, "getNextActiveItemId", () => $5bddadf2c36d0e6f$export$9e353209669d8620);
/**
 * Returns the next active item ID from the current state.
 *
 * We allow circular keyboard navigation from the base index.
 * The base index can either be `null` (nothing is highlighted) or `0`
 * (the first item is highlighted).
 * The base index is allowed to get assigned `null` only if
 * `props.defaultActiveItemId` is `null`. This pattern allows to "stop"
 * by the actual query before navigating to other suggestions as seen on
 * Google or Amazon.
 *
 * @param moveAmount The offset to increment (or decrement) the last index
 * @param baseIndex The current index to compute the next index from
 * @param itemCount The number of items
 * @param defaultActiveItemId The default active index to fallback to
 */ function $5bddadf2c36d0e6f$export$9e353209669d8620(moveAmount, baseIndex, itemCount, defaultActiveItemId) {
    if (!itemCount) return null;
    if (moveAmount < 0 && (baseIndex === null || defaultActiveItemId !== null && baseIndex === 0)) return itemCount + moveAmount;
    var numericIndex = (baseIndex === null ? -1 : baseIndex) + moveAmount;
    if (numericIndex <= -1 || numericIndex >= itemCount) return defaultActiveItemId === null ? null : 0;
    return numericIndex;
}

});



parcelRegister("6BoHr", function(module, exports) {
'use strict';

var $eQwxt = parcelRequire("eQwxt");

var $bRA3t = parcelRequire("bRA3t");
module.exports = $bRA3t($eQwxt, 'Browser (lite)');

});

parcelRegister("93D6q", function(module, exports) {

$parcel$export(module.exports, "debounceAutoComplete", () => $6982b9da3034eb8a$export$6fd8701e4db0a38);
// source: https://www.algolia.com/doc/ui-libraries/autocomplete/guides/debouncing-sources/#writing-an-asynchronous-debouncing-function
function $6982b9da3034eb8a$var$debouncePromise(fn, time) {
    let timerId;
    return function debounced() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (timerId) clearTimeout(timerId);
        return new Promise((resolve)=>{
            timerId = setTimeout(()=>resolve(fn(...args)), time);
        });
    };
}
const $6982b9da3034eb8a$export$6fd8701e4db0a38 = $6982b9da3034eb8a$var$debouncePromise((items)=>Promise.resolve(items), 300);

});

parcelRegister("2pdRg", function(module, exports) {

$parcel$export(module.exports, "filterSearchSuggestionsKeywords", () => $1c08aa7f2adb2ec7$export$8051996a25653ecf);

var $jqvCZ = parcelRequire("jqvCZ");

var $9qqD0 = parcelRequire("9qqD0");
const $1c08aa7f2adb2ec7$export$7d87fadd6525f103 = (productId)=>{
    return [
        "marketplace_plugins_prod.facets.exact_matches.version.compatibilities.applicationKey.value:".concat((0, $9qqD0.COMPATIBLE_PRODUCT_FILTER_VALUES)[productId])
    ];
};
const $1c08aa7f2adb2ec7$var$getProductIdsToBeFiltered = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))((hostProductId)=>{
    const productIdsToBeFiltered = Object.values((0, $9qqD0.COMPATIBLE_PRODUCT_FILTER_VALUES)).filter((value)=>{
        if (hostProductId === (0, $9qqD0.COMPATIBLE_PRODUCT_FILTER_VALUES).jira || hostProductId === (0, $9qqD0.COMPATIBLE_PRODUCT_FILTER_VALUES)['jira-service-management']) return value !== (0, $9qqD0.COMPATIBLE_PRODUCT_FILTER_VALUES)['jira-service-management'] && value !== (0, $9qqD0.COMPATIBLE_PRODUCT_FILTER_VALUES).jira;
        return value !== hostProductId;
    });
    return productIdsToBeFiltered;
});
const $1c08aa7f2adb2ec7$var$getHostingToBeFiltered = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(()=>{
    return [
        'server',
        'datacenter'
    ];
});
const $1c08aa7f2adb2ec7$export$8051996a25653ecf = (_ref)=>{
    let { hits: hits, query: query, hostProductId: hostProductId } = _ref;
    // Filter out hits that exactly match the query
    let filteredHits = hits.filter((hit)=>hit.query !== query);
    if (hostProductId) {
        const productIdsToBeFiltered = $1c08aa7f2adb2ec7$var$getProductIdsToBeFiltered(hostProductId);
        const hostingIdsToBeFiltered = $1c08aa7f2adb2ec7$var$getHostingToBeFiltered();
        filteredHits = filteredHits.filter((hit)=>!productIdsToBeFiltered.some((product)=>hit.query.toLowerCase().includes(product)) && !hostingIdsToBeFiltered.some((hosting)=>hit.query.toLowerCase().includes(hosting)));
    }
    return filteredHits;
};

});
parcelRegister("9qqD0", function(module, exports) {

$parcel$export(module.exports, "FILTER_KEYS", () => $6dcb32890c24f286$export$53d040d638907d5e);
$parcel$export(module.exports, "COMPATIBLE_PRODUCT_FILTER_VALUES", () => $6dcb32890c24f286$export$3ed6879d59f7de77);

var $i0EDR = parcelRequire("i0EDR");
const $6dcb32890c24f286$export$53d040d638907d5e = {
    PRODUCT: 'product',
    PRICE: 'price',
    PAID: 'paid',
    FREE_STARTER_TIER: 'freeStarterTier',
    HOSTING: 'hosting',
    TRUST_SIGNALS: 'trustSignals',
    CLOUD_FORTIFIED: 'cloudFortified',
    BUG_BOUNTY_PARTICIPANT: 'bugBountyParticipant',
    OTHER: 'other',
    STABLE: 'stable',
    VENDOR_SUPPORTED: 'vendorSupported',
    CATEGORIES: 'categories',
    USE_CASES: 'useCases',
    HIDDEN: 'hidden',
    CANONICAL_VERSION: 'canonicalVersion',
    DEPLOYMENTS: 'deployments',
    TOP_VENDOR: 'topVendor',
    LATEST_OF_HOSTING: 'latestOfHosting',
    IS_ATLASSIAN: 'isAtlassian',
    MARKETPLACE_TYPE: 'marketplaceType',
    MARKETING_LABELS: 'marketingLabels',
    PLUGIN_SYSTEM_VERSION: 'pluginSystemVersion'
};
const $6dcb32890c24f286$export$3ed6879d59f7de77 = {
    [(0, $i0EDR.CompatibleProductId).Jira]: 'jira',
    [(0, $i0EDR.CompatibleProductId).Confluence]: 'confluence',
    [(0, $i0EDR.CompatibleProductId).JiraServiceManagement]: 'jira-service-desk',
    [(0, $i0EDR.CompatibleProductId).Fisheye]: 'fecru',
    [(0, $i0EDR.CompatibleProductId).Crucible]: 'fecru',
    [(0, $i0EDR.CompatibleProductId).Bitbucket]: 'bitbucket',
    [(0, $i0EDR.CompatibleProductId).Crowd]: 'crowd',
    [(0, $i0EDR.CompatibleProductId).Bamboo]: 'bamboo',
    [(0, $i0EDR.CompatibleProductId).COMPASS]: 'compass'
};

});



parcelRegister("hCl9L", function(module, exports) {

$parcel$export(module.exports, "getSuggestionSource", () => $cd366582f0a26fc8$export$bfd5a6c517b54975);
$parcel$export(module.exports, "getAnalyticsFilters", () => $cd366582f0a26fc8$export$7a25d25bcaaa708d);
$parcel$export(module.exports, "getAnalyticsFilterOption", () => $cd366582f0a26fc8$export$a632be0d9177d6d0);

var $5zQU9 = parcelRequire("5zQU9");
function $cd366582f0a26fc8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cd366582f0a26fc8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cd366582f0a26fc8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cd366582f0a26fc8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $cd366582f0a26fc8$export$bfd5a6c517b54975 = (query)=>query ? 'search results' : 'recent searches';
const $cd366582f0a26fc8$export$7a25d25bcaaa708d = (selectedOptions)=>Object.keys(selectedOptions).reduce((acc, key)=>{
        const selectedOption = selectedOptions[key];
        if (selectedOption.length) return $cd366582f0a26fc8$var$_objectSpread($cd366582f0a26fc8$var$_objectSpread({}, acc), {}, {
            [key]: Array.isArray(selectedOption) ? selectedOption.map((option)=>({
                    id: option.id,
                    value: option.value
                })) : selectedOption
        });
        return acc;
    }, {});
const $cd366582f0a26fc8$export$a632be0d9177d6d0 = (filterOption)=>Array.isArray(filterOption) ? filterOption.map((option)=>({
            id: option.id,
            value: option.value
        })) : filterOption;

});

parcelRegister("gCUJI", function(module, exports) {

$parcel$export(module.exports, "RecentSearch", () => $c1ac349b14879aca$export$cab26ff6460cbde0);

var $5zQU9 = parcelRequire("5zQU9");

var $ebb1z = parcelRequire("ebb1z");
class $c1ac349b14879aca$export$cab26ff6460cbde0 {
    constructor(limit, storageKey){
        (0, $5zQU9.default)(this, "limit", void 0);
        (0, $5zQU9.default)(this, "recentSearches", []);
        (0, $5zQU9.default)(this, "storageKey", void 0);
        (0, $5zQU9.default)(this, "loadFromLocalStorage", ()=>{
            const storedSearches = (0, $ebb1z).getFromStorage(this.storageKey);
            if (storedSearches) this.recentSearches = JSON.parse(storedSearches);
        });
        (0, $5zQU9.default)(this, "saveToLocalStorage", ()=>{
            (0, $ebb1z).writeStorage(this.storageKey, JSON.stringify(this.recentSearches));
        });
        (0, $5zQU9.default)(this, "clearAll", ()=>{
            this.recentSearches = [];
            this.saveToLocalStorage();
        });
        (0, $5zQU9.default)(this, "push", (search)=>{
            if (!search || !search.query) return;
            const index = this.recentSearches.findIndex((s)=>s.objectID === search.objectID);
            if (index > -1) this.recentSearches.splice(index, 1);
            if (this.recentSearches.length >= this.limit) this.recentSearches.pop();
            this.recentSearches.unshift(search);
            this.saveToLocalStorage();
        });
        (0, $5zQU9.default)(this, "remove", (search)=>{
            const index = this.recentSearches.findIndex((s)=>s.objectID === search.objectID);
            if (index > -1) {
                this.recentSearches.splice(index, 1);
                this.saveToLocalStorage();
            } else console.warn('Search not found in recent searches');
        });
        (0, $5zQU9.default)(this, "getRecentSearches", ()=>{
            return [
                ...this.recentSearches
            ];
        });
        (0, $5zQU9.default)(this, "count", ()=>{
            return this.recentSearches.length;
        });
        (0, $5zQU9.default)(this, "refreshRecentSearches", ()=>{
            this.loadFromLocalStorage();
        });
        if (limit < 1) throw new Error('Limit should be greater than 0');
        this.limit = limit;
        this.storageKey = storageKey;
        this.loadFromLocalStorage();
    }
}

});
parcelRegister("ebb1z", function(module, exports) {

$parcel$export(module.exports, "LOCAL_STORAGE_CHANGE_EVENT_NAME", () => $a52aa4f9822e2605$export$f34e2fac54530283);
$parcel$export(module.exports, "isGivenStorageSupported", () => $a52aa4f9822e2605$export$205353b6505417a5);
$parcel$export(module.exports, "getLocalStorageSupport", () => $a52aa4f9822e2605$export$f3d0784f7aa42f59);
$parcel$export(module.exports, "isTypeOfLocalStorageChanged", () => $a52aa4f9822e2605$export$d5ee54606f404fe7);
$parcel$export(module.exports, "tryParse", () => $a52aa4f9822e2605$export$468ff95b83d315e5);
$parcel$export(module.exports, "writeStorage", () => $a52aa4f9822e2605$export$330a8aa32aa99ddb);
$parcel$export(module.exports, "deleteFromStorage", () => $a52aa4f9822e2605$export$9139156688d13b77);
$parcel$export(module.exports, "getFromStorage", () => $a52aa4f9822e2605$export$e4c9b9bae9539063);
const $a52aa4f9822e2605$export$f34e2fac54530283 = 'onLocalStorageChange';
const $a52aa4f9822e2605$export$205353b6505417a5 = (givenStorage)=>(function() {
        let supported = false;
        let calculated = false;
        return function() {
            try {
                if (calculated) return supported;
                if (!$a52aa4f9822e2605$var$isBrowser()) return false;
                const key = 'storageTest';
                givenStorage.setItem(key, key);
                const result = givenStorage.getItem(key) === key;
                givenStorage.removeItem(key);
                supported = result && !!givenStorage;
                calculated = true;
                return supported;
            } catch (_unused) {
                supported = false;
                calculated = true;
                return supported;
            }
        };
    })();
const $a52aa4f9822e2605$export$f3d0784f7aa42f59 = ()=>$a52aa4f9822e2605$export$205353b6505417a5(window.localStorage)();
const $a52aa4f9822e2605$var$isBrowser = ()=>{
    return typeof window !== 'undefined' && typeof window.document !== 'undefined';
};
function $a52aa4f9822e2605$export$d5ee54606f404fe7(evt) {
    return !!evt && evt.type === $a52aa4f9822e2605$export$f34e2fac54530283;
}
function $a52aa4f9822e2605$export$468ff95b83d315e5(value) {
    try {
        return JSON.parse(value);
    } catch (_unused2) {
        return value;
    }
}
function $a52aa4f9822e2605$export$330a8aa32aa99ddb(key, value) {
    if (!$a52aa4f9822e2605$export$f3d0784f7aa42f59()) return;
    window.localStorage.setItem(key, typeof value === 'object' ? JSON.stringify(value) : "".concat(String(value)));
    window.dispatchEvent(new CustomEvent($a52aa4f9822e2605$export$f34e2fac54530283, {
        detail: {
            key: key,
            value: value
        }
    }));
}
function $a52aa4f9822e2605$export$9139156688d13b77(key) {
    if (!$a52aa4f9822e2605$export$f3d0784f7aa42f59()) return;
    window.localStorage.removeItem(key);
    window.dispatchEvent(new CustomEvent($a52aa4f9822e2605$export$f34e2fac54530283, {
        detail: {
            key: key,
            value: null
        }
    }));
}
function $a52aa4f9822e2605$export$e4c9b9bae9539063(key) {
    if (!$a52aa4f9822e2605$export$f3d0784f7aa42f59()) return;
    return window.localStorage.getItem(key);
}

});


parcelRegister("118My", function(module, exports) {

$parcel$export(module.exports, "redirectToNewQuery", () => $0bdcb268c91708a9$export$c4cc17dec2d832a7);

var $c9Mth = parcelRequire("c9Mth");
const { updateQueryParam: $0bdcb268c91708a9$var$updateQueryParam } = (0, $c9Mth);
const $0bdcb268c91708a9$export$c4cc17dec2d832a7 = (_ref)=>{
    let { query: query, locationHref: locationHref, history: history, additionalQueryParams: additionalQueryParams, source: source, mountPath: mountPath } = _ref;
    const isSearchPage = locationHref.includes('/search');
    if (isSearchPage) {
        const updatedPathname = $0bdcb268c91708a9$var$updateQueryParam(locationHref, 'query', query);
        history === null || history === void 0 || history.push(updatedPathname);
    } else {
        const queryParams = Object.keys(additionalQueryParams).reduce((acc, key)=>{
            return "".concat(acc, "&").concat(key, "=").concat(additionalQueryParams[key]);
        }, '');
        if (source === 'PRODUCT') history === null || history === void 0 || history.push("".concat(mountPath, "/discover/search?query=").concat(query) + queryParams);
        else history === null || history === void 0 || history.push("/search?query=".concat(query) + queryParams);
    }
};

});

parcelRegister("fItra", function(module, exports) {

$parcel$export(module.exports, "SearchBodyFactory", () => $b711ccaaebf9e0a0$export$6aafb526eb31f0d3);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("eUqFw");

var $9AuiZ = parcelRequire("9AuiZ");

var $dzgqf = parcelRequire("dzgqf");

var $kNBHL = parcelRequire("kNBHL");

var $3RQrA = parcelRequire("3RQrA");

var $5ZLSe = parcelRequire("5ZLSe");

var $lHkHI = parcelRequire("lHkHI");
function $b711ccaaebf9e0a0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b711ccaaebf9e0a0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b711ccaaebf9e0a0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b711ccaaebf9e0a0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $b711ccaaebf9e0a0$export$6aafb526eb31f0d3(_ref) {
    let { type: type, searchQuerySuggestionsBodyProps: searchQuerySuggestionsBodyProps, searchLoadingProps: searchLoadingProps, recentSearchBodyProps: recentSearchBodyProps, noSuggestionsBodyProps: noSuggestionsBodyProps } = _ref;
    switch(type){
        case (0, $9AuiZ.BODY_STATES).LOADING:
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3RQrA.SearchLoading), $b711ccaaebf9e0a0$var$_objectSpread({}, searchLoadingProps));
        case (0, $9AuiZ.BODY_STATES).SEARCH_RESULTS:
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5ZLSe.SearchQuerySuggestionsBody), $b711ccaaebf9e0a0$var$_objectSpread({}, searchQuerySuggestionsBodyProps));
        case (0, $9AuiZ.BODY_STATES).RECENT_SEARCHES:
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kNBHL.RecentSearchBody), $b711ccaaebf9e0a0$var$_objectSpread({}, recentSearchBodyProps));
        case (0, $9AuiZ.BODY_STATES).NO_SUGGESTIONS:
        case (0, $9AuiZ.BODY_STATES).API_FAILURE:
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dzgqf.NoSuggestionsBody), $b711ccaaebf9e0a0$var$_objectSpread({}, noSuggestionsBodyProps));
        case (0, $9AuiZ.BODY_STATES).EMPTY_STATE:
        case (0, $9AuiZ.BODY_STATES).NO_BODY:
        default:
            return null;
    }
}

});
parcelRegister("dzgqf", function(module, exports) {

$parcel$export(module.exports, "NoSuggestionsBody", () => $9e0b4864b023b65c$export$289d4ad6ba6b761c);
/* NoSuggestionsBody.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cCrLo = parcelRequire("cCrLo");



var $lHkHI = parcelRequire("lHkHI");
const $9e0b4864b023b65c$var$_excluded = [
    "as",
    "style"
], $9e0b4864b023b65c$var$_excluded2 = [
    "as",
    "style"
], $9e0b4864b023b65c$var$_excluded3 = [
    "as",
    "style"
];
function $9e0b4864b023b65c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9e0b4864b023b65c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9e0b4864b023b65c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9e0b4864b023b65c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $9e0b4864b023b65c$var$SearchSubHeader = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $9e0b4864b023b65c$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $9e0b4864b023b65c$var$_objectSpread($9e0b4864b023b65c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt46vnp _1bah1yb4 _4cvr1h6o _1wpz1fhb _zulp1eps",
            __cmplp.className
        ])
    }));
});
const $9e0b4864b023b65c$var$baseLabel = {
    color: "var(--ds-text-subtle)",
    fontFamily: 'Charlie Text',
    fontSize: '0.75rem',
    fontWeight: 400,
    lineHeight: '18px',
    margin: 0
};
const $9e0b4864b023b65c$var$LargeLabel = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $9e0b4864b023b65c$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $9e0b4864b023b65c$var$_objectSpread($9e0b4864b023b65c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _o5721q9c _1reo15vq _18m915vq _syaz1k3w _ect48q0o _1wyboqnp _k48p1nn1 _vwz4f6fq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cglyw _dm251ule",
            __cmplp.className
        ])
    }));
});
const $9e0b4864b023b65c$var$SmallLabel = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $9e0b4864b023b65c$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $9e0b4864b023b65c$var$_objectSpread($9e0b4864b023b65c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _o5721q9c _1reo15vq _18m915vq _syaz1k3w _ect48q0o _1wyboqnp _k48p1nn1 _vwz4f6fq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1ule _dm25glyw",
            __cmplp.className
        ])
    }));
});
function $9e0b4864b023b65c$export$289d4ad6ba6b761c(_ref4) {
    let { query: query } = _ref4;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($9e0b4864b023b65c$var$SearchSubHeader, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($9e0b4864b023b65c$var$LargeLabel, {
                children: "Press Enter/Return to get results for \u2018".concat(query, "\u2019")
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($9e0b4864b023b65c$var$SmallLabel, {
                children: "Press Enter/Return key to see results"
            })
        ]
    });
}

});
parcelRegister("cCrLo", function(module, exports) {

$parcel$export(module.exports, "H3", () => $92fe91e6af513127$export$746be9e3a3dfff1f);
$parcel$export(module.exports, "H4", () => $92fe91e6af513127$export$cc5e069d64fda823);
$parcel$export(module.exports, "H5", () => $92fe91e6af513127$export$88ef9fdaf11f7a1f);
$parcel$export(module.exports, "H6", () => $92fe91e6af513127$export$a559fb8039b06400);
$parcel$export(module.exports, "EyebrowSmall", () => $92fe91e6af513127$export$b23b65e5c526dfb2);
$parcel$export(module.exports, "BodySmall", () => $92fe91e6af513127$export$476b59e00e6c3fbd);
$parcel$export(module.exports, "BodyNormal", () => $92fe91e6af513127$export$2c8d5c6cefa197f7);
$parcel$export(module.exports, "FinePrint", () => $92fe91e6af513127$export$56ff71eb7b6bd339);
/* Typography.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");



var $lHkHI = parcelRequire("lHkHI");
const $92fe91e6af513127$var$_excluded = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded2 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded3 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded4 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded5 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded6 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded7 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded8 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded9 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded10 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded11 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded12 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded13 = [
    "as",
    "style"
], $92fe91e6af513127$var$_excluded14 = [
    "as",
    "style"
];
function $92fe91e6af513127$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $92fe91e6af513127$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $92fe91e6af513127$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $92fe91e6af513127$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $92fe91e6af513127$var$baseStyles = {
    color: "var(--ds-text)"
};
const $92fe91e6af513127$export$5523b16adee8048 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "h1", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $92fe91e6af513127$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $92fe91e6af513127$var$_objectSpread($92fe91e6af513127$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1wyb8pqr _vwz41p2n _k48pni7l _1s18yn4p _17gqqf5o _3p1cne5d _py5o1qiw",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$cb94397127ac9363 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "h2", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $92fe91e6af513127$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $92fe91e6af513127$var$_objectSpread($92fe91e6af513127$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1wybviql _vwz411uf _k48pni7l _1s18ahaf _17gq13ei _3p1c1ihe _py5o18a8",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$746be9e3a3dfff1f = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "h3", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $92fe91e6af513127$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $92fe91e6af513127$var$_objectSpread($92fe91e6af513127$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1wyb1k8s _vwz4l07h _k48pni7l _1dyzdrct _1s181m1q _17gqc5mb _3p1c1kjp _py5o1nre",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$cc5e069d64fda823 = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "h4", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $92fe91e6af513127$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $92fe91e6af513127$var$_objectSpread($92fe91e6af513127$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1wyb1k92 _vwz41slo _k48pni7l _1dyzdrct _1s18imiu _17gq1m1q _3p1c1lzw _py5o1ds4",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$88ef9fdaf11f7a1f = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "h5", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $92fe91e6af513127$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $92fe91e6af513127$var$_objectSpread($92fe91e6af513127$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1wyb1cby _vwz41slo _k48pni7l _1dyzdrct _3p1c1uvp _py5o1nsk",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$a559fb8039b06400 = (0, $eUqFw.forwardRef)((_ref6, __cmplr)=>{
    let { as: C = "h6", style: __cmpls } = _ref6, __cmplp = (0, $bwPfh.default)(_ref6, $92fe91e6af513127$var$_excluded6);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $92fe91e6af513127$var$_objectSpread($92fe91e6af513127$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1wyb1j6v _vwz41k8s _k48pni7l _1dyzdrct _1p1dglyw",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$b23b65e5c526dfb2 = (0, $eUqFw.forwardRef)((_ref7, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref7, __cmplp = (0, $bwPfh.default)(_ref7, $92fe91e6af513127$var$_excluded7);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $92fe91e6af513127$var$_objectSpread($92fe91e6af513127$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1p1dangw _1wyboqnp _vwz47vkz",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$bf81649988183949 = (0, $eUqFw.forwardRef)((_ref8, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref8, __cmplp = (0, $bwPfh.default)(_ref8, $92fe91e6af513127$var$_excluded8);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $92fe91e6af513127$var$_objectSpread($92fe91e6af513127$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1p1dangw _1wyboxwj _vwz4f6fq",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$476b59e00e6c3fbd = (0, $eUqFw.forwardRef)((_ref9, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref9, __cmplp = (0, $bwPfh.default)(_ref9, $92fe91e6af513127$var$_excluded9);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $92fe91e6af513127$var$_objectSpread($92fe91e6af513127$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect41sdi _1wyboxwj _vwz4gktf",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$2c8d5c6cefa197f7 = (0, $eUqFw.forwardRef)((_ref10, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref10, __cmplp = (0, $bwPfh.default)(_ref10, $92fe91e6af513127$var$_excluded10);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $92fe91e6af513127$var$_objectSpread($92fe91e6af513127$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect41sdi _1wyb1j6v _vwz41tcg",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$ea6aee68c7b1694f = (0, $eUqFw.forwardRef)((_ref11, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref11, __cmplp = (0, $bwPfh.default)(_ref11, $92fe91e6af513127$var$_excluded11);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $92fe91e6af513127$var$_objectSpread($92fe91e6af513127$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _1wyb1cby _vwz41slo _3p1c1qiz _py5o1r6l",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$var$PullQuoteSmall = (0, $eUqFw.forwardRef)((_ref12, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref12, __cmplp = (0, $bwPfh.default)(_ref12, $92fe91e6af513127$var$_excluded12);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $92fe91e6af513127$var$_objectSpread($92fe91e6af513127$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _k48powjs _1wyb1k92 _vwz41f4h _1s181k8s _17gqviql _3p1c1ryw _py5o18o1",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$var$PullQuoteLarge = (0, $eUqFw.forwardRef)((_ref13, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref13, __cmplp = (0, $bwPfh.default)(_ref13, $92fe91e6af513127$var$_excluded13);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $92fe91e6af513127$var$_objectSpread($92fe91e6af513127$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect4khal _k48pb4wl _1wyb1m1q _vwz48pqr _1s18viql _17gqyn4p _3p1c1knc _py5ov4nf _duivowjs",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$56ff71eb7b6bd339 = (0, $eUqFw.forwardRef)((_ref14, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref14, __cmplp = (0, $bwPfh.default)(_ref14, $92fe91e6af513127$var$_excluded14);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $92fe91e6af513127$var$_objectSpread($92fe91e6af513127$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1blv _ect41sdi _1wybud5o _vwz41j6v _1s18oqnp _17gq1cby",
            __cmplp.className
        ])
    }));
});
const $92fe91e6af513127$export$71f050e2efa708bb = (_ref15)=>{
    let { size: size, children: children } = _ref15;
    switch(size){
        case 'small':
            return /*#__PURE__*/ (0, $lHkHI.jsx)($92fe91e6af513127$export$b23b65e5c526dfb2, {
                children: children
            });
        case 'medium':
            return /*#__PURE__*/ (0, $lHkHI.jsx)($92fe91e6af513127$export$bf81649988183949, {
                children: children
            });
    }
};
const $92fe91e6af513127$export$f32a6ca59ed1d5d5 = (_ref16)=>{
    let { size: size, children: children } = _ref16;
    switch(size){
        case 'small':
            return /*#__PURE__*/ (0, $lHkHI.jsx)($92fe91e6af513127$var$PullQuoteSmall, {
                children: children
            });
        case 'large':
            return /*#__PURE__*/ (0, $lHkHI.jsx)($92fe91e6af513127$var$PullQuoteLarge, {
                children: children
            });
    }
};
 /*
  Though we have started using @compiled/react, we are not using it in a perfect way.
  We are still following the styled components way of writing css that is having some limitations like:
  - component composition doesn't work
  - functions interpolation doesn't work. Explicitly declaring the rule name is required.
  Also, the recommended way of using @compiled/react is to use the css prop. But we are not using it.
  We might have to relook our way of writing css with @compiled/react in future.
  More details inside -> https://ecosystem.atlassian.net/browse/MC-4428
*/  // const BodySmallStyles = {
 //   fontSize: '0.875rem',
 //   lineHeight: '20px',
 // };
 // const Body = ({
 //   size,
 //   children,
 //   style,
 //   className,
 // }: {
 //   size: string;
 //   children: ReactNode;
 //   style?: any;
 //   className?: any;
 // }) => {
 //   switch (size) {
 //     case 'small':
 //       return (
 //         <ClassNames>
 //           {({ css }) => (
 //             <p
 //               style={style}
 //               className={ax([css(BodySmallStyles), css(charlieDisplayFontFamily), className])}
 //             >
 //               {children}
 //             </p>
 //           )}
 //         </ClassNames>
 //       );
 //     case 'medium':
 //       return <BodyMedium>{children}</BodyMedium>;
 //     case 'large':
 //       return <BodyLarge>{children}</BodyLarge>;
 //   }
 // };

});


parcelRegister("kNBHL", function(module, exports) {

$parcel$export(module.exports, "RecentSearchBody", () => $f245a1a9414a2913$export$922743fa106b9af7);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("eUqFw");

var $ip9av = parcelRequire("ip9av");

var $98JqU = parcelRequire("98JqU");

var $lHkHI = parcelRequire("lHkHI");
function $f245a1a9414a2913$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f245a1a9414a2913$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f245a1a9414a2913$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f245a1a9414a2913$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f245a1a9414a2913$export$922743fa106b9af7(_ref) {
    let { hits: hits, onClearAll: onClearAll, onKeyDown: onKeyDown, autocomplete: autocomplete, onAppend: _onAppend } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $98JqU.SearchSubHeader), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $98JqU.LabelDesktop), {
                        children: "Recent searches"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $98JqU.LabelMobile), {
                        children: "Recent Searches"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $98JqU.ClearButton), {
                        type: "button",
                        role: "button",
                        onClick: onClearAll,
                        onKeyDown: onKeyDown,
                        "aria-label": "Clear search history"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $98JqU.QueriesContainer), {
                id: "search-field-listbox",
                role: "listbox",
                "aria-label": "Recent searches",
                children: hits.map((collection)=>{
                    const { source: source, items: items } = collection;
                    return items.length > 0 && items.map((item)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $ip9av.SearchItem), $f245a1a9414a2913$var$_objectSpread({
                            type: (0, $ip9av.SearchItemType).RECENT,
                            onAppend: ()=>_onAppend(item),
                            item: item
                        }, autocomplete.getItemProps({
                            item: item,
                            source: source
                        })), item.objectID));
                })
            })
        ]
    });
}

});
parcelRegister("ip9av", function(module, exports) {

$parcel$export(module.exports, "SearchItemType", () => $d661ac7320e8b62a$export$24ae08ddc9bf62b1);
$parcel$export(module.exports, "SearchItem", () => $d661ac7320e8b62a$export$de9b0d4a0e561f1c);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $bFaqu = parcelRequire("bFaqu");

var $eUqFw = parcelRequire("eUqFw");

var $dDUGM = parcelRequire("dDUGM");

var $6kSKs = parcelRequire("6kSKs");

var $7Nl1r = parcelRequire("7Nl1r");

var $4OzAz = parcelRequire("4OzAz");

var $9wI76 = parcelRequire("9wI76");

var $lHkHI = parcelRequire("lHkHI");
const $d661ac7320e8b62a$var$_excluded = [
    "item",
    "type",
    "onAppend"
];
function $d661ac7320e8b62a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d661ac7320e8b62a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d661ac7320e8b62a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d661ac7320e8b62a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
let $d661ac7320e8b62a$export$24ae08ddc9bf62b1 = /*#__PURE__*/ function(SearchItemType) {
    SearchItemType["SEARCH"] = "search";
    SearchItemType["RECENT"] = "recent";
    return SearchItemType;
}({});
// Component to highlight inout query in suggestions
function $d661ac7320e8b62a$var$Highlight(_ref) {
    let { hit: hit, attribute: attribute } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dDUGM.Text), {
        children: (0, $bFaqu.parseAlgoliaHitHighlight)({
            hit: hit,
            attribute: attribute
        }).map((_ref2, index)=>{
            let { value: value, isHighlighted: isHighlighted } = _ref2;
            if (isHighlighted) return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $dDUGM.TextHighlighted), {
                children: [
                    value,
                    " "
                ]
            }, index);
            return value;
        })
    });
}
const $d661ac7320e8b62a$var$MemoizedHighlight = /*#__PURE__*/ (0, $eUqFw.memo)($d661ac7320e8b62a$var$Highlight);
function $d661ac7320e8b62a$export$de9b0d4a0e561f1c(_ref3) {
    let { item: item, type: type, onAppend: onAppend } = _ref3, autocompleteProps = (0, $bwPfh.default)(_ref3, $d661ac7320e8b62a$var$_excluded);
    const icon = type === $d661ac7320e8b62a$export$24ae08ddc9bf62b1.SEARCH ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dDUGM.Icon16), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9wI76))),
        alt: type
    }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dDUGM.Icon16), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($7Nl1r))),
        alt: type
    });
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $dDUGM.ParentContainer), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $dDUGM.SearchItemContainer), $d661ac7320e8b62a$var$_objectSpread($d661ac7320e8b62a$var$_objectSpread({
                className: "search-item-container"
            }, autocompleteProps), {}, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dDUGM.SelectedMarker), {
                        className: "selected-marker"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $dDUGM.Query), {
                        role: "button",
                        type: "button",
                        "aria-label": item.query,
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $dDUGM.QueryContainer), {
                                "aria-hidden": "true",
                                children: [
                                    icon,
                                    type === $d661ac7320e8b62a$export$24ae08ddc9bf62b1.SEARCH ? /*#__PURE__*/ (0, $lHkHI.jsx)($d661ac7320e8b62a$var$MemoizedHighlight, {
                                        hit: item,
                                        attribute: "query"
                                    }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dDUGM.Text), {
                                        children: item.query
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dDUGM.ArrowIcon), {
                                className: "suggestion-arrow-icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($4OzAz))),
                                alt: "select"
                            })
                        ]
                    })
                ]
            })),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dDUGM.AppendButton), {
                className: "append-button",
                role: "button",
                type: "button",
                "aria-label": "Append query to search bar",
                onClick: ()=>onAppend(item),
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dDUGM.Icon24), {
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($6kSKs))),
                    alt: "append"
                })
            })
        ]
    });
}

});
parcelRegister("bFaqu", function(module, exports) {

$parcel$export(module.exports, "parseAlgoliaHitHighlight", () => $87db9c7e7d4b7d1f$export$8d253e1eb996c525);

var $bRhGC = parcelRequire("bRhGC");

var $j4caG = parcelRequire("j4caG");
function $87db9c7e7d4b7d1f$var$_toConsumableArray(arr) {
    return $87db9c7e7d4b7d1f$var$_arrayWithoutHoles(arr) || $87db9c7e7d4b7d1f$var$_iterableToArray(arr) || $87db9c7e7d4b7d1f$var$_unsupportedIterableToArray(arr) || $87db9c7e7d4b7d1f$var$_nonIterableSpread();
}
function $87db9c7e7d4b7d1f$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $87db9c7e7d4b7d1f$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $87db9c7e7d4b7d1f$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $87db9c7e7d4b7d1f$var$_arrayLikeToArray(o, minLen);
}
function $87db9c7e7d4b7d1f$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $87db9c7e7d4b7d1f$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $87db9c7e7d4b7d1f$var$_arrayLikeToArray(arr);
}
function $87db9c7e7d4b7d1f$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $87db9c7e7d4b7d1f$export$8d253e1eb996c525(_ref) {
    var hit = _ref.hit, attribute = _ref.attribute;
    var path = Array.isArray(attribute) ? attribute : [
        attribute
    ];
    var highlightedValue = (0, $bRhGC.getAttributeValueByPath)(hit, [
        '_highlightResult'
    ].concat($87db9c7e7d4b7d1f$var$_toConsumableArray(path), [
        'value'
    ]));
    if (typeof highlightedValue !== 'string') highlightedValue = (0, $bRhGC.getAttributeValueByPath)(hit, path) || '';
    return (0, $j4caG.parseAttribute)({
        highlightedValue: highlightedValue
    });
}

});
parcelRegister("bRhGC", function(module, exports) {

$parcel$export(module.exports, "getAttributeValueByPath", () => $8a225d17299519a0$export$3219add52b18c0d7);
function $8a225d17299519a0$export$3219add52b18c0d7(record, path) {
    return path.reduce(function(current, key) {
        return current && current[key];
    }, record);
}

});

parcelRegister("j4caG", function(module, exports) {

$parcel$export(module.exports, "parseAttribute", () => $de17d505d9a85aa7$export$dd369bc78e81a241);

var $9j4N6 = parcelRequire("9j4N6");
/**
 * Creates a data structure that allows to concatenate similar highlighting
 * parts in a single value.
 */ function $de17d505d9a85aa7$var$createAttributeSet() {
    var initialValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var value = initialValue;
    return {
        get: function get() {
            return value;
        },
        add: function add(part) {
            var lastPart = value[value.length - 1];
            if ((lastPart === null || lastPart === void 0 ? void 0 : lastPart.isHighlighted) === part.isHighlighted) value[value.length - 1] = {
                value: lastPart.value + part.value,
                isHighlighted: lastPart.isHighlighted
            };
            else value.push(part);
        }
    };
}
function $de17d505d9a85aa7$export$dd369bc78e81a241(_ref) {
    var highlightedValue = _ref.highlightedValue;
    var preTagParts = highlightedValue.split((0, $9j4N6.HIGHLIGHT_PRE_TAG));
    var firstValue = preTagParts.shift();
    var parts = $de17d505d9a85aa7$var$createAttributeSet(firstValue ? [
        {
            value: firstValue,
            isHighlighted: false
        }
    ] : []);
    preTagParts.forEach(function(part) {
        var postTagParts = part.split((0, $9j4N6.HIGHLIGHT_POST_TAG));
        parts.add({
            value: postTagParts[0],
            isHighlighted: true
        });
        if (postTagParts[1] !== '') parts.add({
            value: postTagParts[1],
            isHighlighted: false
        });
    });
    return parts.get();
}

});
parcelRegister("9j4N6", function(module, exports) {

$parcel$export(module.exports, "HIGHLIGHT_PRE_TAG", () => $6c699ac5d6639d7d$export$2df5424f792538bd);
$parcel$export(module.exports, "HIGHLIGHT_POST_TAG", () => $6c699ac5d6639d7d$export$2681d4c6a4ae86);
var $6c699ac5d6639d7d$export$2df5424f792538bd = '__aa-highlight__';
var $6c699ac5d6639d7d$export$2681d4c6a4ae86 = '__/aa-highlight__';

});



parcelRegister("dDUGM", function(module, exports) {

$parcel$export(module.exports, "ParentContainer", () => $9eeae41cf51b644f$export$29b190105ef1a92d);
$parcel$export(module.exports, "Icon24", () => $9eeae41cf51b644f$export$cbc2bb619cdd4f4c);
$parcel$export(module.exports, "AppendButton", () => $9eeae41cf51b644f$export$55cc16be301a58b);
$parcel$export(module.exports, "Icon16", () => $9eeae41cf51b644f$export$882a6719ec143a2d);
$parcel$export(module.exports, "ArrowIcon", () => $9eeae41cf51b644f$export$26b09f677ead9482);
$parcel$export(module.exports, "QueryContainer", () => $9eeae41cf51b644f$export$55f74874c3e93590);
$parcel$export(module.exports, "Query", () => $9eeae41cf51b644f$export$62297b13309008b2);
$parcel$export(module.exports, "SearchItemContainer", () => $9eeae41cf51b644f$export$b4de3f9386a8844e);
$parcel$export(module.exports, "SelectedMarker", () => $9eeae41cf51b644f$export$6c02916718145058);
$parcel$export(module.exports, "Text", () => $9eeae41cf51b644f$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "TextHighlighted", () => $9eeae41cf51b644f$export$74b337a44cb03a53);
/* SearchItem.styles.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");



var $lHkHI = parcelRequire("lHkHI");
const $9eeae41cf51b644f$var$_excluded = [
    "as",
    "style"
], $9eeae41cf51b644f$var$_excluded2 = [
    "as",
    "style"
], $9eeae41cf51b644f$var$_excluded3 = [
    "as",
    "style"
], $9eeae41cf51b644f$var$_excluded4 = [
    "as",
    "style"
], $9eeae41cf51b644f$var$_excluded5 = [
    "as",
    "style"
], $9eeae41cf51b644f$var$_excluded6 = [
    "as",
    "style"
], $9eeae41cf51b644f$var$_excluded7 = [
    "as",
    "style"
], $9eeae41cf51b644f$var$_excluded8 = [
    "as",
    "style"
], $9eeae41cf51b644f$var$_excluded9 = [
    "as",
    "style"
], $9eeae41cf51b644f$var$_excluded10 = [
    "as",
    "style"
], $9eeae41cf51b644f$var$_excluded11 = [
    "as",
    "style"
];
function $9eeae41cf51b644f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9eeae41cf51b644f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9eeae41cf51b644f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9eeae41cf51b644f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $9eeae41cf51b644f$export$29b190105ef1a92d = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "li", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $9eeae41cf51b644f$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $9eeae41cf51b644f$var$_objectSpread($9eeae41cf51b644f$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    }));
});
const $9eeae41cf51b644f$export$cbc2bb619cdd4f4c = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "img", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $9eeae41cf51b644f$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $9eeae41cf51b644f$var$_objectSpread($9eeae41cf51b644f$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg",
            __cmplp.className
        ])
    }));
});
const $9eeae41cf51b644f$export$55cc16be301a58b = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "button", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $9eeae41cf51b644f$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $9eeae41cf51b644f$var$_objectSpread($9eeae41cf51b644f$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbt9kd _4t3ickbl _1o9zidpf _19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke _1e0c1txw _1bah1h6o _4cvr1h6o _11q7glyw _j6xtfqd3 _dm25glyw _1j6p4suz",
            __cmplp.className
        ])
    }));
});
const $9eeae41cf51b644f$export$882a6719ec143a2d = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "img", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $9eeae41cf51b644f$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $9eeae41cf51b644f$var$_objectSpread($9eeae41cf51b644f$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb7vkz _4t3i7vkz _19pkh461",
            __cmplp.className
        ])
    }));
});
const $9eeae41cf51b644f$export$26b09f677ead9482 = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "img", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $9eeae41cf51b644f$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $9eeae41cf51b644f$var$_objectSpread($9eeae41cf51b644f$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1tcg _4t3i1tcg _1e0cglyw _w14j15vq _dm251ule",
            __cmplp.className
        ])
    }));
});
const $9eeae41cf51b644f$export$55f74874c3e93590 = (0, $eUqFw.forwardRef)((_ref6, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref6, __cmplp = (0, $bwPfh.default)(_ref6, $9eeae41cf51b644f$var$_excluded6);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $9eeae41cf51b644f$var$_objectSpread($9eeae41cf51b644f$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1txw _zulp1eps _4cvr1h6o",
            __cmplp.className
        ])
    }));
});
const $9eeae41cf51b644f$export$62297b13309008b2 = (0, $eUqFw.forwardRef)((_ref7, __cmplr)=>{
    let { as: C = "button", style: __cmpls } = _ref7, __cmplp = (0, $bwPfh.default)(_ref7, $9eeae41cf51b644f$var$_excluded7);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $9eeae41cf51b644f$var$_objectSpread($9eeae41cf51b644f$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _1e0c1txw _1bah1yb4 _1bsb1osq _4t3ickbl _4cvr1h6o _11q7glyw _1yt41qtk _x5db4suz _165t1ylp _1yag1pm9 _1wapewfl",
            __cmplp.className
        ])
    }));
});
const $9eeae41cf51b644f$export$b4de3f9386a8844e = (0, $eUqFw.forwardRef)((_ref8, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref8, __cmplp = (0, $bwPfh.default)(_ref8, $9eeae41cf51b644f$var$_excluded8);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $9eeae41cf51b644f$var$_objectSpread($9eeae41cf51b644f$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _1bsb1osq _1ul9idpf _kqswh2mm _1lg6glyw _1vdz1egq _j6xtfqd3 _1rdt1ule _wrkn1eg3 _41ybewfl _fkkaewfl",
            __cmplp.className
        ])
    }));
});
const $9eeae41cf51b644f$export$6c02916718145058 = (0, $eUqFw.forwardRef)((_ref9, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref9, __cmplp = (0, $bwPfh.default)(_ref9, $9eeae41cf51b644f$var$_excluded9);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $9eeae41cf51b644f$var$_objectSpread($9eeae41cf51b644f$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqswstnw _1ltvidpf _154iidpf _94n5idpf _1bsbyh40 _11q71oj9",
            __cmplp.className
        ])
    }));
});
const $9eeae41cf51b644f$export$5f1af8db9871e1d6 = (0, $eUqFw.forwardRef)((_ref10, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref10, __cmplp = (0, $bwPfh.default)(_ref10, $9eeae41cf51b644f$var$_excluded10);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $9eeae41cf51b644f$var$_objectSpread($9eeae41cf51b644f$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _o5721q9c _1reo15vq _18m915vq _syaz1blv _k48p1nn1 _ect48q0o _1wyb1j6v _zg8l4jg8 _vwz41k8s _1e0c1o8l",
            __cmplp.className
        ])
    }));
});
const $9eeae41cf51b644f$export$74b337a44cb03a53 = (0, $eUqFw.forwardRef)((_ref11, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref11, __cmplp = (0, $bwPfh.default)(_ref11, $9eeae41cf51b644f$var$_excluded11);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $9eeae41cf51b644f$var$_objectSpread($9eeae41cf51b644f$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _syaztmrq _k48p1nn1",
            __cmplp.className
        ])
    }));
});

});

parcelRegister("6kSKs", function(module, exports) {
module.exports = new URL("Append.30cd52be.svg", import.meta.url).toString();

});

parcelRegister("7Nl1r", function(module, exports) {
module.exports = new URL("Recent.d6a38253.svg", import.meta.url).toString();

});

parcelRegister("4OzAz", function(module, exports) {
module.exports = new URL("RightArrow.b920000b.svg", import.meta.url).toString();

});

parcelRegister("9wI76", function(module, exports) {
module.exports = new URL("Search.702e5fa0.svg", import.meta.url).toString();

});


parcelRegister("98JqU", function(module, exports) {

$parcel$export(module.exports, "SearchSubHeader", () => $6a781a73d50de92d$export$4c9125bf64795d1f);
$parcel$export(module.exports, "LabelMobile", () => $6a781a73d50de92d$export$9004d641ad43fa81);
$parcel$export(module.exports, "LabelDesktop", () => $6a781a73d50de92d$export$c969f88e5928300b);
$parcel$export(module.exports, "ClearButton", () => $6a781a73d50de92d$export$13ec83e50bf04290);
$parcel$export(module.exports, "QueriesContainer", () => $6a781a73d50de92d$export$ecb4f76d577c3dc5);
/* RecentSearchBody.styles.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $lHkHI = parcelRequire("lHkHI");
const $6a781a73d50de92d$var$_excluded = [
    "as",
    "style"
], $6a781a73d50de92d$var$_excluded2 = [
    "as",
    "style"
], $6a781a73d50de92d$var$_excluded3 = [
    "as",
    "style"
], $6a781a73d50de92d$var$_excluded4 = [
    "as",
    "style"
], $6a781a73d50de92d$var$_excluded5 = [
    "as",
    "style"
];
function $6a781a73d50de92d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6a781a73d50de92d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6a781a73d50de92d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6a781a73d50de92d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $6a781a73d50de92d$export$4c9125bf64795d1f = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $6a781a73d50de92d$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $6a781a73d50de92d$var$_objectSpread($6a781a73d50de92d$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt47ahi _1bah1yb4 _4cvr1h6o _1wpz1fhb _vwz4f6fq",
            __cmplp.className
        ])
    }));
});
const $6a781a73d50de92d$export$9004d641ad43fa81 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $6a781a73d50de92d$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $6a781a73d50de92d$var$_objectSpread($6a781a73d50de92d$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1k3w _1wyboqnp _ect48q0o _k48p1nn1 _1e0c1ule _dm25glyw",
            __cmplp.className
        ])
    }));
});
const $6a781a73d50de92d$export$c969f88e5928300b = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $6a781a73d50de92d$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $6a781a73d50de92d$var$_objectSpread($6a781a73d50de92d$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1k3w _1wyboqnp _ect48q0o _k48p1nn1 _1e0cglyw _dm251ule",
            __cmplp.className
        ])
    }));
});
const $6a781a73d50de92d$export$13ec83e50bf04290 = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "button", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $6a781a73d50de92d$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $6a781a73d50de92d$var$_objectSpread($6a781a73d50de92d$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itglyw _2rkoiti9 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _80omtlke _11q76ota _syaz1jij _y3gn1h6o _ect48q0o _1wyboqnp _k48p1nn1 _vwz4qgp8 _1e0c116y _1yt4mhsw _2lx21bp4 _1bah1h6o _4cvr1h6o _zulp1eps _x5db4suz _1kt91kbs _19lc1eg3 _j6xtfqd3 _ne9p1370",
            __cmplp.className
        ])
    }));
});
const $6a781a73d50de92d$export$ecb4f76d577c3dc5 = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "ul", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $6a781a73d50de92d$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $6a781a73d50de92d$var$_objectSpread($6a781a73d50de92d$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_n3td1eps _1bsb1osq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    }));
});

});


parcelRegister("3RQrA", function(module, exports) {

$parcel$export(module.exports, "SearchLoading", () => $2d0f009b95627179$export$8934683688a2f019);
/* SearchLoading.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hvCdF = parcelRequire("hvCdF");

var $cCrLo = parcelRequire("cCrLo");



var $lHkHI = parcelRequire("lHkHI");
const $2d0f009b95627179$var$_excluded = [
    "as",
    "style"
], $2d0f009b95627179$var$_excluded2 = [
    "as",
    "style"
], $2d0f009b95627179$var$_excluded3 = [
    "as",
    "style"
];
function $2d0f009b95627179$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2d0f009b95627179$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2d0f009b95627179$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2d0f009b95627179$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $2d0f009b95627179$var$Container = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $2d0f009b95627179$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $2d0f009b95627179$var$_objectSpread($2d0f009b95627179$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt47ahi _zulp1eps _1tke1mjv",
            __cmplp.className
        ])
    }));
});
const $2d0f009b95627179$var$baseLabel = {
    color: "var(--ds-text-subtle)",
    fontSize: '0.75rem',
    fontFamily: 'Charlie Text',
    fontWeight: 400,
    lineHeight: '18px',
    margin: 0
};
const $2d0f009b95627179$var$LargeLabel = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $2d0f009b95627179$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $2d0f009b95627179$var$_objectSpread($2d0f009b95627179$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0cglyw _syaz1k3w _1wyboqnp _ect48q0o _k48p1nn1 _vwz4f6fq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _dm251ule",
            __cmplp.className
        ])
    }));
});
const $2d0f009b95627179$var$SmallLabel = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $2d0f009b95627179$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $2d0f009b95627179$var$_objectSpread($2d0f009b95627179$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _o5721q9c _1reo15vq _18m915vq _1e0c1ule _syaz1k3w _1wyboqnp _ect48q0o _k48p1nn1 _vwz4f6fq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _dm25glyw",
            __cmplp.className
        ])
    }));
});
const $2d0f009b95627179$export$8934683688a2f019 = (_ref4)=>{
    let { query: query = 'suggesti' } = _ref4;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($2d0f009b95627179$var$Container, {
        "data-testid": "skeleton-items",
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)($2d0f009b95627179$var$LargeLabel, {
                as: "h3",
                children: [
                    "Suggestions for \u2018",
                    query,
                    "\u2019"
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($2d0f009b95627179$var$SmallLabel, {
                children: "Suggestions"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hvCdF.default), {
                interactionName: "load",
                size: "small"
            })
        ]
    });
};

});

parcelRegister("5ZLSe", function(module, exports) {

$parcel$export(module.exports, "SearchQuerySuggestionsBody", () => $45d7c8fa5cd04b17$export$917f663295c58392);
/* SearchQuerySuggestionsBody.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $cCrLo = parcelRequire("cCrLo");


var $ip9av = parcelRequire("ip9av");


var $lHkHI = parcelRequire("lHkHI");
const $45d7c8fa5cd04b17$var$_excluded = [
    "as",
    "style"
], $45d7c8fa5cd04b17$var$_excluded2 = [
    "as",
    "style"
], $45d7c8fa5cd04b17$var$_excluded3 = [
    "as",
    "style"
], $45d7c8fa5cd04b17$var$_excluded4 = [
    "as",
    "style"
];
function $45d7c8fa5cd04b17$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $45d7c8fa5cd04b17$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $45d7c8fa5cd04b17$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $45d7c8fa5cd04b17$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $45d7c8fa5cd04b17$var$baseLabel = {
    padding: " ".concat("var(--ds-space-250)", " ", "var(--ds-space-300)", " ", "var(--ds-space-050)", " ", "var(--ds-space-300)"),
    alignItems: 'center',
    color: "var(--ds-text-subtle)",
    fontFamily: 'Charlie Text',
    fontWeight: 400,
    fontSize: '0.75rem',
    lineHeight: '18px',
    margin: 0
};
const $45d7c8fa5cd04b17$var$LargeLabel = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $45d7c8fa5cd04b17$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $45d7c8fa5cd04b17$var$_objectSpread($45d7c8fa5cd04b17$var$_objectSpread({}, __cmplp), {}, {
        style: $45d7c8fa5cd04b17$var$_objectSpread($45d7c8fa5cd04b17$var$_objectSpread({}, __cmpls), {}, {
            "--_5r0phe": (0, $9t7rW.default)(" ".concat("var(--ds-space-250)", " ", "var(--ds-space-300)", " ", "var(--ds-space-050)", " ", "var(--ds-space-300)"))
        }),
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _o5721q9c _1reo15vq _18m915vq _1yt4le8v _4cvr1h6o _syaz1k3w _ect48q0o _k48p1nn1 _1wyboqnp _vwz4f6fq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0cglyw _dm251ule",
            __cmplp.className
        ])
    }));
});
const $45d7c8fa5cd04b17$var$SmallLabel = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $45d7c8fa5cd04b17$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $45d7c8fa5cd04b17$var$_objectSpread($45d7c8fa5cd04b17$var$_objectSpread({}, __cmplp), {}, {
        style: $45d7c8fa5cd04b17$var$_objectSpread($45d7c8fa5cd04b17$var$_objectSpread({}, __cmpls), {}, {
            "--_5r0phe": (0, $9t7rW.default)(" ".concat("var(--ds-space-250)", " ", "var(--ds-space-300)", " ", "var(--ds-space-050)", " ", "var(--ds-space-300)"))
        }),
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bto1l2s _o5721q9c _1reo15vq _18m915vq _1yt4le8v _4cvr1h6o _syaz1k3w _ect48q0o _k48p1nn1 _1wyboqnp _vwz4f6fq _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1e0c1ule _dm25glyw",
            __cmplp.className
        ])
    }));
});
const $45d7c8fa5cd04b17$var$Container = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $45d7c8fa5cd04b17$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $45d7c8fa5cd04b17$var$_objectSpread($45d7c8fa5cd04b17$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq _n3td1fcb",
            __cmplp.className
        ])
    }));
});
const $45d7c8fa5cd04b17$var$SuggestionsList = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "ul", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $45d7c8fa5cd04b17$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $45d7c8fa5cd04b17$var$_objectSpread($45d7c8fa5cd04b17$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1yt41l6n _2lx21bp4 _qtt8glyw _18s81sck _1bsb1osq",
            __cmplp.className
        ])
    }));
});
function $45d7c8fa5cd04b17$export$917f663295c58392(_ref5) {
    let { query: query, hits: hits, autocomplete: autocomplete, onAppend: onAppend } = _ref5;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($45d7c8fa5cd04b17$var$Container, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)($45d7c8fa5cd04b17$var$LargeLabel, {
                as: "h3",
                children: [
                    "Suggestions for '",
                    query,
                    "'"
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($45d7c8fa5cd04b17$var$SmallLabel, {
                children: "Suggestions"
            }),
            hits.map((collection, index)=>{
                const { source: source, items: items } = collection;
                return items.length > 0 && /*#__PURE__*/ (0, $lHkHI.jsx)($45d7c8fa5cd04b17$var$SuggestionsList, $45d7c8fa5cd04b17$var$_objectSpread($45d7c8fa5cd04b17$var$_objectSpread({}, autocomplete.getListProps()), {}, {
                    children: items.map((item)=>{
                        const itemProps = $45d7c8fa5cd04b17$var$_objectSpread($45d7c8fa5cd04b17$var$_objectSpread({}, autocomplete.getItemProps({
                            item: item,
                            source: source
                        })), {}, {
                            role: 'presentation'
                        });
                        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ip9av.SearchItem), $45d7c8fa5cd04b17$var$_objectSpread({
                            type: (0, $ip9av.SearchItemType).SEARCH,
                            onAppend: onAppend,
                            item: item
                        }, itemProps), item.objectID);
                    })
                }), "source-".concat(index));
            })
        ]
    });
}

});


parcelRegister("dMD7U", function(module, exports) {

$parcel$export(module.exports, "SearchFooter", () => $a08e1bc98eac8866$export$64ded8b71dfcba9e);
/* SearchFooter.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $eWXWl = parcelRequire("eWXWl");


var $eu8X4 = parcelRequire("eu8X4");

var $7OO07 = parcelRequire("7OO07");

var $eCy7Y = parcelRequire("eCy7Y");

var $jv19K = parcelRequire("jv19K");

var $lHkHI = parcelRequire("lHkHI");
const $a08e1bc98eac8866$var$_excluded = [
    "as",
    "style"
], $a08e1bc98eac8866$var$_excluded2 = [
    "as",
    "style"
], $a08e1bc98eac8866$var$_excluded3 = [
    "as",
    "style"
], $a08e1bc98eac8866$var$_excluded4 = [
    "as",
    "style"
], $a08e1bc98eac8866$var$_excluded5 = [
    "as",
    "style"
];
function $a08e1bc98eac8866$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a08e1bc98eac8866$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a08e1bc98eac8866$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a08e1bc98eac8866$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a08e1bc98eac8866$var$Footer = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $a08e1bc98eac8866$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $a08e1bc98eac8866$var$_objectSpread($a08e1bc98eac8866$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4g30r _zulpxjmg _1e0cglyw _4cvr1h6o _1bah1yb4 _dm251txw",
            __cmplp.className
        ])
    }));
});
const $a08e1bc98eac8866$var$Icon = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "dt", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $a08e1bc98eac8866$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $a08e1bc98eac8866$var$_objectSpread($a08e1bc98eac8866$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1tcg _4t3i7vkz _1yt4y3tf _1bah1h6o _4cvr1h6o _zulpxjmg _2lx21bp4 _bfhk146w _2rko1y44",
            __cmplp.className
        ])
    }));
});
const $a08e1bc98eac8866$var$IconImg = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "img", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $a08e1bc98eac8866$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $a08e1bc98eac8866$var$_objectSpread($a08e1bc98eac8866$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1crf",
            __cmplp.className
        ])
    }));
});
const $a08e1bc98eac8866$var$ActionText = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $a08e1bc98eac8866$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $a08e1bc98eac8866$var$_objectSpread($a08e1bc98eac8866$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wyboqnp _zg8l4jg8 _k48p1nn1 _vwz41j6v _syaz1k3w _2hwxutpp",
            __cmplp.className
        ])
    }));
});
const $a08e1bc98eac8866$var$ActionInfoWrapper = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $a08e1bc98eac8866$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $a08e1bc98eac8866$var$_objectSpread($a08e1bc98eac8866$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulp1eps _4cvr1h6o _vwz41eps",
            __cmplp.className
        ])
    }));
});
const $a08e1bc98eac8866$var$viewCloseButtonStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: "var(--ds-space-050)",
    lineHeight: "var(--ds-space-200)"
};
function $a08e1bc98eac8866$var$ActionInfo(_ref6) {
    let { icon: icon, text: text, alt: alt } = _ref6;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($a08e1bc98eac8866$var$Icon, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)($a08e1bc98eac8866$var$IconImg, {
                    src: icon,
                    alt: "".concat(alt, " icon")
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($a08e1bc98eac8866$var$ActionText, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                    "aria-label": "".concat(text, " label"),
                    children: text
                })
            })
        ]
    });
}
function $a08e1bc98eac8866$export$64ded8b71dfcba9e(_ref7) {
    let { closeOverlay: closeOverlay } = _ref7;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($a08e1bc98eac8866$var$Footer, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)($a08e1bc98eac8866$var$ActionInfoWrapper, {
                title: "Navigation info",
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($a08e1bc98eac8866$var$ActionInfo, {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jv19K))),
                        text: "Navigate",
                        alt: "Up and Down arrow key"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($a08e1bc98eac8866$var$ActionInfo, {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($eCy7Y))),
                        text: "Select",
                        alt: "Enter/Return"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($a08e1bc98eac8866$var$ActionInfo, {
                        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7OO07))),
                        text: "Close",
                        alt: "Escape"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eu8X4.Button), {
                onClick: closeOverlay,
                "aria-label": "Close overlay",
                testId: "CloseButton",
                style: $a08e1bc98eac8866$var$viewCloseButtonStyle,
                iconAfter: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eWXWl))), {
                    label: "CloseOverlay",
                    size: "medium"
                }),
                appearance: "link",
                children: "Close"
            })
        ]
    });
}

});
parcelRegister("eWXWl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ae24fa496a1b2e28$var$_react = $ae24fa496a1b2e28$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $ae24fa496a1b2e28$var$_close = $ae24fa496a1b2e28$var$_interopRequireDefault((parcelRequire("gaTP1")));
function $ae24fa496a1b2e28$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ae24fa496a1b2e28$var$EditorCloseIcon = (props)=>/*#__PURE__*/ $ae24fa496a1b2e28$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m15.185 7.4-3.184 3.185-3.186-3.186a.507.507 0 0 0-.712.003l-.7.701a.496.496 0 0 0-.004.712l3.185 3.184L7.4 15.185a.507.507 0 0 0 .004.712l.7.7c.206.207.516.2.712.004l3.186-3.185 3.184 3.185a.507.507 0 0 0 .712-.004l.701-.7a.496.496 0 0 0 .003-.712l-3.186-3.186 3.186-3.184a.507.507 0 0 0-.003-.712l-.7-.7a.5.5 0 0 0-.36-.153.5.5 0 0 0-.353.15"/></svg>`
    }, props, {
        newIcon: $ae24fa496a1b2e28$var$_close.default
    }));
$ae24fa496a1b2e28$var$EditorCloseIcon.displayName = 'EditorCloseIcon';
var $ae24fa496a1b2e28$var$_default = module.exports.default = $ae24fa496a1b2e28$var$EditorCloseIcon;

});

parcelRegister("eu8X4", function(module, exports) {

$parcel$export(module.exports, "Button", () => $a8bacfa6fdbb1ebd$export$353f5b6fc5456de1);
$parcel$export(module.exports, "LinkButton", () => $a8bacfa6fdbb1ebd$export$29d11c0fe2fc51d8);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $4Qskl = parcelRequire("4Qskl");

var $c0qPT = parcelRequire("c0qPT");
parcelRequire("eUqFw");

var $lLBy7 = parcelRequire("lLBy7");

var $lHkHI = parcelRequire("lHkHI");
const $a8bacfa6fdbb1ebd$var$_excluded = [
    "buttonStyles"
];
function $a8bacfa6fdbb1ebd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a8bacfa6fdbb1ebd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a8bacfa6fdbb1ebd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a8bacfa6fdbb1ebd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a8bacfa6fdbb1ebd$var$ourTheme = function ourTheme() {
    let overrideStyles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return (currentTheme, themeProps)=>{
        const _currentTheme = currentTheme(themeProps), { buttonStyles: buttonStyles } = _currentTheme, rest = (0, $bwPfh.default)(_currentTheme, $a8bacfa6fdbb1ebd$var$_excluded);
        return $a8bacfa6fdbb1ebd$var$_objectSpread({
            buttonStyles: $a8bacfa6fdbb1ebd$var$_objectSpread($a8bacfa6fdbb1ebd$var$_objectSpread({}, buttonStyles), overrideStyles)
        }, rest);
    };
};
function $a8bacfa6fdbb1ebd$export$353f5b6fc5456de1(props) {
    const source = (0, $c0qPT.useSource)();
    const styles = source === 'MPAC' ? (0, $lLBy7.mpacBaseStyles) : (0, $lLBy7.emceeBaseStyles);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4Qskl.default), $a8bacfa6fdbb1ebd$var$_objectSpread($a8bacfa6fdbb1ebd$var$_objectSpread({
        theme: $a8bacfa6fdbb1ebd$var$ourTheme(styles)
    }, props), {}, {
        children: props.children
    }));
}
function $a8bacfa6fdbb1ebd$export$29d11c0fe2fc51d8(props) {
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4Qskl.default), $a8bacfa6fdbb1ebd$var$_objectSpread($a8bacfa6fdbb1ebd$var$_objectSpread({
        theme: $a8bacfa6fdbb1ebd$var$ourTheme((0, $lLBy7.linkOverrideStyles))
    }, props), {}, {
        spacing: "none",
        children: props.children
    }));
}
function $a8bacfa6fdbb1ebd$export$1d982206696707a9(props) {
    const source = (0, $c0qPT.useSource)();
    const styles = source === 'MPAC' ? (0, $lLBy7.mpacGhostStyles) : (0, $lLBy7.emceeGhostStyles);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4Qskl.default), $a8bacfa6fdbb1ebd$var$_objectSpread($a8bacfa6fdbb1ebd$var$_objectSpread({
        theme: $a8bacfa6fdbb1ebd$var$ourTheme(styles)
    }, props), {}, {
        children: props.children
    }));
}

});
parcelRegister("4Qskl", function(module, exports) {

$parcel$export(module.exports, "default", () => $3871fdee97c56d30$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $6ZjRV = parcelRequire("6ZjRV");

var $atXX9 = parcelRequire("atXX9");

var $i8QFr = parcelRequire("i8QFr");

var $5nZDj = parcelRequire("5nZDj");

var $6ZNIT = parcelRequire("6ZNIT");
function $3871fdee97c56d30$var$getInteractionState({ isDisabled: isDisabled = false, isActive: isActive = false, isFocus: isFocus = false, isHover: isHover = false, isSelected: isSelected = false, isLoading: isLoading = false }) {
    if (isDisabled) return 'disabled';
    if (isSelected && isFocus) return 'focusSelected';
    if (isSelected) return 'selected';
    // not allowing active or focus style changes while loading
    if (!isLoading && isActive) return 'active';
    if (!isLoading && isHover) return 'hover';
    if (isFocus) return 'focus';
    return 'default';
}
const $3871fdee97c56d30$var$initial = {
    isHover: false,
    isActive: false,
    isFocus: false
};
/**
 * __Custom theme button__
 *
 * A custom theme button. Avoid using this component. It exists for those already using custom theming, which is hard to use and has performance issues.
 *
 * - [Examples](https://atlassian.design/components/button/examples#custom-theme-button)
 */ const $3871fdee97c56d30$var$CustomThemeButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function CustomThemeButton({ appearance: // Calculate default props for use in custom themes
appearance = 'default', autoFocus: autoFocus = false, isDisabled: isDisabled = false, isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', isLoading: isLoading = false, onMouseEnter: providedOnMouseEnter, onMouseLeave: providedOnMouseLeave, onMouseDown: providedOnMouseDown, onMouseUp: providedOnMouseUp, onFocus: providedOnFocus, onBlur: providedOnBlur, theme: theme = (0, $6ZNIT.defaultThemeFn), ...rest }, ref) {
    // TODO is there a nicer way to do this?
    // Add default props back into object for spreading
    const restProps = {
        appearance: appearance,
        autoFocus: autoFocus,
        isDisabled: isDisabled,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        ...rest
    };
    const [state, setState] = (0, $eUqFw.useState)($3871fdee97c56d30$var$initial);
    const onMouseEnter = (0, $eUqFw.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: true
            }));
        if (providedOnMouseEnter) providedOnMouseEnter(event);
    }, [
        providedOnMouseEnter
    ]);
    const onMouseLeave = (0, $eUqFw.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isHover: false,
                isActive: false
            }));
        if (providedOnMouseLeave) providedOnMouseLeave(event);
    }, [
        providedOnMouseLeave
    ]);
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: true
            }));
        if (providedOnMouseDown) providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isActive: false
            }));
        if (providedOnMouseUp) providedOnMouseUp(event);
    }, [
        providedOnMouseUp
    ]);
    const onFocus = (0, $eUqFw.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: true
            }));
        if (providedOnFocus) providedOnFocus(event);
    }, [
        providedOnFocus
    ]);
    const onBlur = (0, $eUqFw.useCallback)((event)=>{
        setState((current)=>({
                ...current,
                isFocus: false
            }));
        if (providedOnBlur) providedOnBlur(event);
    }, [
        providedOnBlur
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ZNIT.default).Provider, {
        value: theme
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ZjRV.default).Consumer, null, ({ mode: mode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6ZNIT.default).Consumer, (0, $kU09D.default)({
            mode: mode,
            state: $3871fdee97c56d30$var$getInteractionState({
                ...state,
                isLoading: isLoading,
                isSelected: restProps.isSelected,
                isDisabled: restProps.isDisabled
            }),
            iconIsOnlyChild: (0, $i8QFr.default)(restProps),
            isLoading: isLoading
        }, restProps), ({ buttonStyles: buttonStyles })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atXX9.default), (0, $kU09D.default)({}, restProps, {
                ref: ref,
                overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5nZDj.default), restProps) : null,
                "aria-disabled": isLoading || restProps['aria-disabled'],
                onMouseEnter: onMouseEnter,
                onMouseLeave: onMouseLeave,
                onMouseDown: onMouseDown,
                onMouseUp: onMouseUp,
                onFocus: onFocus,
                onBlur: onBlur,
                buttonCss: (0, $6ZNIT.getSpecifiers)(buttonStyles)
            })))));
}));
// Tools including enzyme rely on components having a display name
$3871fdee97c56d30$var$CustomThemeButton.displayName = 'CustomThemeButton';
var $3871fdee97c56d30$export$2e2bcd8739ae039 = $3871fdee97c56d30$var$CustomThemeButton;

});
parcelRegister("6ZjRV", function(module, exports) {

$parcel$export(module.exports, "useGlobalTheme", () => $5167da1ef3c95e68$export$7692396083754928);
$parcel$export(module.exports, "default", () => $5167da1ef3c95e68$export$2e2bcd8739ae039);

var $d8yWP = parcelRequire("d8yWP");
// Create default global light theme
const { Provider: $5167da1ef3c95e68$var$Provider, Consumer: $5167da1ef3c95e68$var$Consumer, useTheme: $5167da1ef3c95e68$export$7692396083754928 } = (0, $d8yWP.createTheme)(()=>({
        mode: 'light'
    }));
const $5167da1ef3c95e68$var$Theme = {
    Provider: $5167da1ef3c95e68$var$Provider,
    Consumer: $5167da1ef3c95e68$var$Consumer
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5167da1ef3c95e68$export$2e2bcd8739ae039 = $5167da1ef3c95e68$var$Theme;

});
parcelRegister("d8yWP", function(module, exports) {

$parcel$export(module.exports, "createTheme", () => $990721a330b4da83$export$25d302a5b900a763);

var $eUqFw = parcelRequire("eUqFw");
function $990721a330b4da83$export$25d302a5b900a763(defaultGetTokens) {
    const emptyThemeFn = (getTokens, props)=>getTokens(props);
    /**
   * Internally, Theme uses React Context, with internal providers and consumers.
   * The React Context passes only a function that gets props, and turns them into tokens. This
   * function gets mixed as more Providers with their own themes are added. This mixed function
   * is ultimately picked up by Consumers, which implement a context consumer internally to fetch
   * the theme.
   */ const ThemeContext = /*#__PURE__*/ (0, $eUqFw.createContext)(defaultGetTokens);
    function useTheme(themeProps) {
        const theme = (0, $eUqFw.useContext)(ThemeContext);
        const themeFn = theme || emptyThemeFn;
        const tokens = themeFn(themeProps);
        return tokens;
    }
    // The Theme Consumer takes a function as its child - this function takes tokens, and the
    // return value is generally a set of nodes with the tokens applied appropriately.
    function Consumer(props) {
        const { children: children, ...themeProps } = props;
        // @ts-ignore See issue for more info: https://github.com/Microsoft/TypeScript/issues/10727
        // Argument of type 'Pick<ThemeProps & { children: (tokens: ThemeTokens) => ReactNode; }, Exclude<keyof ThemeProps, "children">>' is not assignable to parameter of type 'ThemeProps'.ts(2345)
        const tokens = useTheme(themeProps);
        // We add a fragment to ensure we don't break people upgrading.
        // Previously they may have been able to pass in undefined without things blowing up.
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children(tokens));
    }
    /**
   * The Theme Provider takes regular nodes as its children, but also takes a *theme function*
   * - The theme function takes a set of props, as well as a function (getTokens) that can turn props into tokens.
   * - The getTokens function isn't called immediately - instead the props are passed
   *    through a mix of parent theming functions
   * Children of this provider will receive this mixed theme
   */ function Provider(props) {
        const themeFn = (0, $eUqFw.useContext)(ThemeContext);
        const valueFn = props.value || emptyThemeFn;
        const mixedFn = (0, $eUqFw.useCallback)((themeProps)=>valueFn(themeFn, themeProps), [
            themeFn,
            valueFn
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ThemeContext.Provider, {
            value: mixedFn
        }, props.children);
    }
    return {
        Consumer: Consumer,
        Provider: Provider,
        useTheme: useTheme
    };
}

});


parcelRegister("atXX9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7a1b1e3e76c89374$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $lv3Pn = parcelRequire("lv3Pn");

var $eiQBT = parcelRequire("eiQBT");

var $fogbu = parcelRequire("fogbu");

var $jljCj = parcelRequire("jljCj");

var $7R4Cu = parcelRequire("7R4Cu");

var $j0gMm = parcelRequire("j0gMm");

var $isb2W = parcelRequire("isb2W");

var $96HLH = parcelRequire("96HLH");

var $gp7Z4 = parcelRequire("gp7Z4");
// Disabled buttons will still publish events for nested elements in webkit.
// We are disabling pointer events on child elements so that
// the button will always be the target of events
// Note: firefox does not have this behaviour for child elements
const $7a1b1e3e76c89374$var$noPointerEventsOnChildrenCss = {
    '> *': {
        pointerEvents: 'none'
    }
};
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $7a1b1e3e76c89374$var$iconBeforeSpacingFixStyle = (0, $byn9U.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    marginInlineStart: "var(--ds-space-negative-025, -2px)"
});
const $7a1b1e3e76c89374$var$iconAfterSpacingFixStyle = (0, $byn9U.css)({
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)",
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    marginInlineEnd: "var(--ds-space-negative-025, -2px)"
});
const $7a1b1e3e76c89374$var$getSpacingFix = (children, spacingStyles)=>{
    if (!children || (0, $gp7Z4.getIfVisuallyHiddenChildren)(children)) return null;
    return spacingStyles;
};
const $7a1b1e3e76c89374$var$getChildren = (children, childrenStyles)=>{
    if ((0, $gp7Z4.getIfVisuallyHiddenChildren)(children)) return children;
    return children ? (0, $byn9U.jsx)("span", {
        css: childrenStyles
    }, children) : null;
};
const $7a1b1e3e76c89374$var$ButtonBase = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function ButtonBase(props, ref) {
    const { analyticsContext: // I don't think analytics should be in button, but for now it is
    analyticsContext, appearance: appearance = 'default', autoFocus: autoFocus = false, buttonCss: buttonCss, children: children, className: className, href: href, // use the provided component prop,
    // else default to anchor if there is a href, and button if there is no href
    component: Component = href ? 'a' : 'button', iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled = false, isSelected: isSelected = false, onBlur: onBlur, onClick: providedOnClick = (0, $eiQBT.default), onFocus: onFocus, onMouseDown: providedOnMouseDown = (0, $eiQBT.default), overlay: overlay, shouldFitContainer: // Pulling out so it doesn't spread on rendered component
    shouldFitContainer, spacing: spacing = 'default', tabIndex: tabIndex = 0, type: type = !href ? 'button' : undefined, testId: testId, ...rest } = props;
    const ourRef = (0, $eUqFw.useRef)();
    const setRef = (0, $eUqFw.useCallback)((node)=>{
        ourRef.current = node;
        if (ref == null) return;
        if (typeof ref === 'function') {
            ref(node);
            return;
        }
        // We can write to ref's `current` property, but Typescript does not like it.
        // @ts-ignore
        ref.current = node;
    }, [
        ourRef,
        ref
    ]);
    // Cross browser auto focusing is pretty broken, so we are doing it ourselves
    (0, $fogbu.default)(ourRef, autoFocus);
    const interactionContext = (0, $eUqFw.useContext)((0, $7R4Cu.default));
    const handleClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $lv3Pn.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: 'button',
        packageName: "@atlaskit/button",
        packageVersion: "18.4.1",
        analyticsData: analyticsContext
    });
    // Button currently calls preventDefault, which is not standard button behaviour
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        providedOnMouseDown(event);
    }, [
        providedOnMouseDown
    ]);
    // Lose focus when becoming disabled (standard button behaviour)
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (isDisabled && el && el === document.activeElement) el.blur();
    }, [
        isDisabled
    ]);
    // we are 'disabling' input with a button when there is an overlay
    const hasOverlay = Boolean(overlay);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const fadeStyles = (0, $byn9U.css)((0, $96HLH.getFadingCss)({
        hasOverlay: hasOverlay
    }));
    const isInteractive = !isDisabled && !hasOverlay;
    /**
   * HACK: Spinner needs to have different colours in the "new" tokens design compared to the old design.
   * For now, while we support both, these styles reach into Spinner when a theme is set, applies the right color.
   * Ticket to remove: https://product-fabric.atlassian.net/browse/DSP-2067.
   */ var spinnerHackCss = {};
    if (isSelected || isDisabled || appearance === 'warning') spinnerHackCss = {
        '[data-theme] & circle': {
            stroke: `${isSelected || isDisabled ? `var(--ds-icon-subtle, ${0, $j0gMm.N500})` : `var(--ds-icon-warning-inverse, ${0, $j0gMm.N500})`} !important`
        }
    };
    return (0, $byn9U.jsx)((0, $jljCj.default), null, (0, $byn9U.jsx)(Component, (0, $kU09D.default)({}, rest, {
        ref: setRef,
        className: className,
        css: [
            buttonCss,
            isInteractive ? null : $7a1b1e3e76c89374$var$noPointerEventsOnChildrenCss
        ],
        "data-has-overlay": hasOverlay ? true : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        href: isInteractive ? href : undefined,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        onMouseDown: onMouseDown,
        tabIndex: isDisabled ? -1 : tabIndex,
        type: type
    }, (0, $isb2W.default)({
        isInteractive: isInteractive
    })), iconBefore ? (0, $byn9U.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $96HLH.getIconStyle)({
                spacing: spacing
            }),
            $7a1b1e3e76c89374$var$getSpacingFix(children, $7a1b1e3e76c89374$var$iconBeforeSpacingFixStyle)
        ]
    }, iconBefore) : null, $7a1b1e3e76c89374$var$getChildren(children, [
        fadeStyles,
        (0, $96HLH.getContentStyle)({
            spacing: spacing
        })
    ]), iconAfter ? (0, $byn9U.jsx)("span", {
        css: [
            fadeStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $96HLH.getIconStyle)({
                spacing: spacing
            }),
            $7a1b1e3e76c89374$var$getSpacingFix(children, $7a1b1e3e76c89374$var$iconAfterSpacingFixStyle)
        ]
    }, iconAfter) : null, overlay ? (0, $byn9U.jsx)("span", {
        css: [
            (0, $96HLH.overlayCss),
            spinnerHackCss
        ]
    }, overlay) : null));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$7a1b1e3e76c89374$export$2e2bcd8739ae039 = $7a1b1e3e76c89374$var$ButtonBase;

});
parcelRegister("lv3Pn", function(module, exports) {

$parcel$export(module.exports, "usePlatformLeafEventHandler", () => $040a0e4b9b09a444$export$a4687b0234b40e28);

var $eUqFw = parcelRequire("eUqFw");

var $6lQr9 = parcelRequire("6lQr9");

var $l94Sf = parcelRequire("l94Sf");
function $040a0e4b9b09a444$export$a4687b0234b40e28({ fn: fn, action: action, componentName: componentName, actionSubject: actionSubject, packageName: packageName, packageVersion: packageVersion, analyticsData: analyticsData }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6lQr9.useAnalyticsEvents)();
    // We put analyticsData and fn in a ref so that we don't need to break
    // memoization.
    // Generally these could be defined by consumers inline
    // and so we do this to avoid breaking memoization of useCallback
    const dataRef = (0, $l94Sf.useTrackedRef)(analyticsData);
    const fnRef = (0, $l94Sf.useTrackedRef)(fn);
    const handler = (0, $eUqFw.useCallback)((value)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject || componentName,
            attributes: {
                componentName: componentName,
                packageName: packageName,
                packageVersion: packageVersion
            }
        });
        // To avoid wrapping this component in AnalyticsContext we manually
        // push the parent context's meta data into the context.
        // Note: this new 'context'
        const context = {
            componentName: componentName,
            packageName: packageName,
            packageVersion: packageVersion,
            ...dataRef.current
        };
        analyticsEvent.context.push(context);
        // fire an event on the atlaskit channel
        const clone = analyticsEvent.clone();
        if (clone) clone.fire('atlaskit');
        fnRef.current(value, analyticsEvent);
    }, [
        // These are strings and won't change
        action,
        componentName,
        actionSubject,
        packageName,
        packageVersion,
        // This function is memoized in the context
        createAnalyticsEvent,
        // these are a stable ref because of the useTrackedRef hook
        dataRef,
        fnRef
    ]);
    return handler;
}

});
parcelRegister("6lQr9", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $49fd61246242ecc9$export$5bf35293e545f20c);

var $fzXll = parcelRequire("fzXll");

var $8HgcJ = parcelRequire("8HgcJ");

var $jxAQm = parcelRequire("jxAQm");
function $49fd61246242ecc9$export$5bf35293e545f20c() {
    const analyticsContext = (0, $jxAQm.useAnalyticsContext)();
    const createAnalyticsEvent = (0, $fzXll.useCallbackOne)((payload)=>{
        return new (0, $8HgcJ.default)({
            context: analyticsContext.getAtlaskitAnalyticsContext(),
            handlers: analyticsContext.getAtlaskitAnalyticsEventHandlers(),
            payload: payload
        });
    }, [
        analyticsContext
    ]);
    return {
        createAnalyticsEvent: createAnalyticsEvent
    };
}

});
parcelRegister("8HgcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $654ee8bdc6dd9dd0$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $7g3jL = parcelRequire("7g3jL");
const $654ee8bdc6dd9dd0$export$35f8383928ba8d7 = (obj)=>{
    var _obj$constructor;
    return obj instanceof $654ee8bdc6dd9dd0$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isUIAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'UIAnalyticsEvent';
};
class $654ee8bdc6dd9dd0$export$2e2bcd8739ae039 extends (0, $7g3jL.default) {
    constructor(props){
        super(props);
        (0, $5zQU9.default)(this, "_isUIAnalyticsEvent", true);
        (0, $5zQU9.default)(this, "clone", ()=>{
            if (this.hasFired) return null;
            const context = [
                ...this.context
            ];
            const handlers = [
                ...this.handlers
            ];
            /**
       * A hacky "deep clone" of the object. This is limited in that it wont
       * support functions, regexs, Maps, Sets, etc, but none of those need to
       * be represented in our payload.
       */ const payload = JSON.parse(JSON.stringify(this.payload));
            return new $654ee8bdc6dd9dd0$export$2e2bcd8739ae039({
                context: context,
                handlers: handlers,
                payload: payload
            });
        });
        (0, $5zQU9.default)(this, "fire", (channel)=>{
            if (this.hasFired) return;
            this.handlers.forEach((handler)=>handler(this, channel));
            this.hasFired = true;
        });
        this.context = props.context || [];
        this.handlers = props.handlers || [];
        this.hasFired = false;
    }
    update(updater) {
        if (this.hasFired) return this;
        return super.update(updater);
    }
}

});
parcelRegister("7g3jL", function(module, exports) {

$parcel$export(module.exports, "default", () => $548c99e3fa1120c4$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
const $548c99e3fa1120c4$export$ad4be5c2ec28cecf = (obj)=>{
    var _obj$constructor;
    return obj instanceof $548c99e3fa1120c4$export$2e2bcd8739ae039 || !!(obj !== null && obj !== void 0 && obj._isAnalyticsEvent) || // Backwards compatibility with older analytics-next packages
    (obj === null || obj === void 0 ? void 0 : (_obj$constructor = obj.constructor) === null || _obj$constructor === void 0 ? void 0 : _obj$constructor.name) === 'AnalyticsEvent';
};
class $548c99e3fa1120c4$export$2e2bcd8739ae039 {
    constructor(props){
        (0, $5zQU9.default)(this, "_isAnalyticsEvent", true);
        (0, $5zQU9.default)(this, "clone", ()=>{
            // just a shallow clone, don't change sub refs unless you want to
            // affect the original's too
            const payload = {
                ...this.payload
            };
            return new $548c99e3fa1120c4$export$2e2bcd8739ae039({
                payload: payload
            });
        });
        this.payload = props.payload;
    }
    update(updater) {
        if (typeof updater === 'function') this.payload = updater(this.payload);
        if (typeof updater === 'object') this.payload = {
            ...this.payload,
            ...updater
        };
        return this;
    }
}

});


parcelRegister("jxAQm", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsContext", () => $e39dadba9c41f28f$export$d1f587f82ad51c4);

var $eUqFw = parcelRequire("eUqFw");

var $kNx8v = parcelRequire("kNx8v");
const $e39dadba9c41f28f$export$d1f587f82ad51c4 = ()=>{
    return (0, $eUqFw.useContext)((0, $kNx8v.default));
};

});


parcelRegister("l94Sf", function(module, exports) {

$parcel$export(module.exports, "useTrackedRef", () => $f64e381c18db5f8b$export$1d27a74659855e44);

var $eUqFw = parcelRequire("eUqFw");
const $f64e381c18db5f8b$export$1d27a74659855e44 = (value)=>{
    const ref = (0, $eUqFw.useRef)(value);
    ref.current = value;
    return ref;
};

});


parcelRegister("eiQBT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69b8e686dbf3ba8$export$2e2bcd8739ae039);
/**
 * An empty function which does nothing.
 */ // eslint-disable-next-line @repo/internal/react/use-noop
function $a69b8e686dbf3ba8$export$2e2bcd8739ae039() {}

});

parcelRegister("fogbu", function(module, exports) {

$parcel$export(module.exports, "default", () => $b345a6c8ce289ff8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $b345a6c8ce289ff8$export$2e2bcd8739ae039(ref, autoFocus) {
    const initialMount = (0, $eUqFw.useRef)(true);
    (0, $eUqFw.useEffect)(()=>{
        if (ref && initialMount.current && autoFocus && ref.current) ref.current.focus();
        initialMount.current = false;
    }, [
        autoFocus,
        ref
    ]);
}

});

parcelRegister("isb2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6f369235bd69ccd$export$2e2bcd8739ae039);
function $d6f369235bd69ccd$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $d6f369235bd69ccd$var$tabKeyCode = 9;
function $d6f369235bd69ccd$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $d6f369235bd69ccd$var$tabKeyCode) return;
    $d6f369235bd69ccd$var$abort(event);
}
const $d6f369235bd69ccd$var$block = {
    onMouseDownCapture: $d6f369235bd69ccd$var$abort,
    onMouseUpCapture: $d6f369235bd69ccd$var$abort,
    // because we have tabIndex = -1 when disabled,
    // keyboard events can only occur when there is an overlay
    onKeyDownCapture: $d6f369235bd69ccd$var$onKey,
    onKeyUpCapture: $d6f369235bd69ccd$var$onKey,
    onTouchStartCapture: $d6f369235bd69ccd$var$abort,
    onTouchEndCapture: $d6f369235bd69ccd$var$abort,
    onPointerDownCapture: $d6f369235bd69ccd$var$abort,
    onPointerUpCapture: $d6f369235bd69ccd$var$abort,
    onClickCapture: $d6f369235bd69ccd$var$abort,
    // Just smashing the existing onClick for good measure
    onClick: $d6f369235bd69ccd$var$abort
};
const $d6f369235bd69ccd$var$doNotBlock = {};
function $d6f369235bd69ccd$export$2e2bcd8739ae039({ isInteractive: isInteractive }) {
    return isInteractive ? $d6f369235bd69ccd$var$doNotBlock : $d6f369235bd69ccd$var$block;
}

});

parcelRegister("96HLH", function(module, exports) {

$parcel$export(module.exports, "getCss", () => $6a16a016cffcb4ff$export$955358618f994a11);
$parcel$export(module.exports, "getIconStyle", () => $6a16a016cffcb4ff$export$864eea3f4ec3368f);
$parcel$export(module.exports, "getContentStyle", () => $6a16a016cffcb4ff$export$7ad0316cc0dd65a);
$parcel$export(module.exports, "getFadingCss", () => $6a16a016cffcb4ff$export$1b5827d324e945b1);
$parcel$export(module.exports, "overlayCss", () => $6a16a016cffcb4ff$export$1a9fe1b84c876bb5);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $3puyA = parcelRequire("3puyA");

var $ivTMz = parcelRequire("ivTMz");

var $5JMSv = parcelRequire("5JMSv");
const $6a16a016cffcb4ff$var$gridSize = (0, $ivTMz.gridSize)();
const $6a16a016cffcb4ff$var$HAS_DISABLED_BACKGROUND = [
    'default',
    'primary',
    'danger',
    'warning'
];
// ## Button layout
//
// /------------------------------------------------------------------------------------------------------------------\
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// |  10px →  |  ← 2px  |   icon   |  2px →  |  ← 2px  |           |  2px →  |  ← 2px  |  icon   |  2px →  |  ← 10px  |
// |  padding |  margin |  before  |  margin |  margin |  content  |  margin |  margin |  after  |  margin |  padding |
// |    (12px total)    |          |    (4px total)    |           |    (4px total)    |         |    (12px total)    |
// |       →  |  ←      |          |      →  |  ←      |           |      →  |  ←      |         |      →  |  ←       |
// \------------------------------------------------------------------------------------------------------------------/
//                                           ↑                               ↑
//                                        Margins don't collapse with inline-flex
//
const $6a16a016cffcb4ff$var$heights = {
    default: `${32 / 14}em`,
    // 32px
    compact: `${24 / 14}em`,
    none: 'auto'
};
const $6a16a016cffcb4ff$var$lineHeights = {
    default: $6a16a016cffcb4ff$var$heights.default,
    compact: $6a16a016cffcb4ff$var$heights.compact,
    none: 'inherit'
};
const $6a16a016cffcb4ff$var$padding = {
    // 10px gutter
    default: `0 ${$6a16a016cffcb4ff$var$gridSize + $6a16a016cffcb4ff$var$gridSize / 4}px`,
    compact: `0 ${$6a16a016cffcb4ff$var$gridSize + $6a16a016cffcb4ff$var$gridSize / 4}px`,
    none: '0'
};
const $6a16a016cffcb4ff$var$singleIconPadding = {
    // 2px gutter
    compact: `0 ${$6a16a016cffcb4ff$var$gridSize / 4}px`,
    default: `0 ${$6a16a016cffcb4ff$var$gridSize / 4}px`,
    none: '0'
};
const $6a16a016cffcb4ff$var$verticalAlign = {
    default: 'middle',
    compact: 'middle',
    none: 'baseline'
};
const $6a16a016cffcb4ff$var$innerMargin = {
    content: `0 ${$6a16a016cffcb4ff$var$gridSize / 4}px`,
    icon: `0 ${$6a16a016cffcb4ff$var$gridSize / 4}px`
};
const $6a16a016cffcb4ff$var$defaultAfterStyles = {
    borderRadius: 'inherit',
    inset: "var(--ds-space-0, 0px)",
    borderStyle: 'solid',
    borderWidth: "var(--ds-border-width, 1px)",
    pointerEvents: 'none',
    position: 'absolute'
};
const $6a16a016cffcb4ff$var$defaultStyles = {
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: "var(--ds-text, #172B4D)",
    '&:not([disabled])::after': {
        ...$6a16a016cffcb4ff$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border, #091E4224)"
    },
    '&:hover': {
        background: "var(--ds-background-neutral-hovered, #091E4224)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-pressed, #091E424F)"
    }
};
const $6a16a016cffcb4ff$var$primaryStyles = {
    background: "var(--ds-background-brand-bold, #0C66E4)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-brand-bold-hovered, #0055CC)"
    },
    '&:active': {
        background: "var(--ds-background-brand-bold-pressed, #09326C)"
    }
};
const $6a16a016cffcb4ff$var$linkStyles = {
    background: 'transparent',
    color: "var(--ds-link, #0C66E4)",
    '&:hover': {
        color: "var(--ds-link, #0C66E4)",
        textDecoration: 'underline'
    },
    '&:active': {
        color: "var(--ds-link-pressed, #0055CC)",
        textDecoration: 'underline'
    }
};
const $6a16a016cffcb4ff$var$subtleStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    '&:active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
    }
};
const $6a16a016cffcb4ff$var$subtleLinkStyles = {
    background: 'transparent',
    color: "var(--ds-text-subtle, #44546F)",
    '&:hover': {
        background: 'transparent',
        color: "var(--ds-text-subtle, #44546F)",
        textDecoration: 'underline'
    },
    '&:active': {
        background: 'transparent',
        color: "var(--ds-text, #172B4D)",
        textDecoration: 'underline'
    }
};
const $6a16a016cffcb4ff$var$warningStyles = {
    background: "var(--ds-background-warning-bold, #F5CD47)",
    color: "var(--ds-text-warning-inverse, #172B4D)",
    '&:hover': {
        background: "var(--ds-background-warning-bold-hovered, #E2B203)"
    },
    '&:active': {
        background: "var(--ds-background-warning-bold-pressed, #CF9F02)"
    }
};
const $6a16a016cffcb4ff$var$dangerStyles = {
    background: "var(--ds-background-danger-bold, #C9372C)",
    color: "var(--ds-text-inverse, #FFFFFF)",
    '&:hover': {
        background: "var(--ds-background-danger-bold-hovered, #AE2E24)"
    },
    '&:active': {
        background: "var(--ds-background-danger-bold-pressed, #5D1F1A)"
    }
};
const $6a16a016cffcb4ff$var$selectedStyles = {
    background: "var(--ds-background-selected, #E9F2FF)",
    color: "var(--ds-text-selected, #0C66E4)",
    '&:not([disabled])::after': {
        ...$6a16a016cffcb4ff$var$defaultAfterStyles,
        content: '""',
        borderColor: "var(--ds-border-selected, #0C66E4)"
    }
};
const $6a16a016cffcb4ff$var$hasOverlayStyles = {
    '&[data-has-overlay="true"]': {
        cursor: 'default',
        textDecoration: 'none'
    }
};
function $6a16a016cffcb4ff$var$getColor({ group: group, key: key, mode: mode }) {
    const rule = group[key] || group.default;
    return rule[mode];
}
function $6a16a016cffcb4ff$var$getColors({ appearance: appearance, key: key, mode: mode }) {
    return {
        background: $6a16a016cffcb4ff$var$getColor({
            group: (0, $5JMSv.default).background[appearance],
            key: key,
            mode: mode
        }),
        // Needing to add !important to overcome specificity issue caused by deprecated AtlaskitThemeProvider
        color: `${$6a16a016cffcb4ff$var$getColor({
            group: (0, $5JMSv.default).color[appearance],
            key: key,
            mode: mode
        })} !important`
    };
}
function $6a16a016cffcb4ff$export$955358618f994a11({ appearance: appearance, spacing: spacing, mode: mode, isSelected: isSelected, shouldFitContainer: shouldFitContainer, isOnlySingleIcon: isOnlySingleIcon }) {
    const baseColors = $6a16a016cffcb4ff$var$getColors({
        appearance: appearance,
        key: isSelected ? 'selected' : 'default',
        mode: mode
    });
    return {
        // 0px margin added to css-reset
        alignItems: 'baseline',
        borderWidth: 0,
        borderRadius: "var(--ds-border-radius, 3px)",
        boxSizing: 'border-box',
        display: 'inline-flex',
        fontSize: 'inherit',
        fontStyle: 'normal',
        // Chrome recently changed button so that they use 'arial' as the font family
        fontFamily: 'inherit',
        fontWeight: 500,
        // margin for button has been applied to css reset
        maxWidth: '100%',
        // Needed to position overlay
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38)',
        whiteSpace: 'nowrap',
        // dynamic styles
        ...!(0, $3puyA.fg)('platform.design-system-team.component-visual-refresh_t8zbo') && baseColors,
        cursor: 'pointer',
        height: $6a16a016cffcb4ff$var$heights[spacing],
        lineHeight: $6a16a016cffcb4ff$var$lineHeights[spacing],
        padding: isOnlySingleIcon ? $6a16a016cffcb4ff$var$singleIconPadding[spacing] : $6a16a016cffcb4ff$var$padding[spacing],
        verticalAlign: $6a16a016cffcb4ff$var$verticalAlign[spacing],
        width: shouldFitContainer ? '100%' : 'auto',
        // justifyContent required for shouldFitContainer buttons with an icon inside
        justifyContent: 'center',
        // Note: we cannot disable pointer events when there is an overlay.
        // That would be easy for styling, but it would start letting events through on disabled buttons
        ...!(0, $3puyA.fg)('platform.design-system-team.component-visual-refresh_t8zbo') && {
            // Disabling visited styles (just using the base colors)
            '&:visited': {
                ...baseColors
            },
            '&:hover': {
                ...$6a16a016cffcb4ff$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'hover',
                    mode: mode
                }),
                textDecoration: !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? 'underline' : 'inherit',
                // background, box-shadow
                transitionDuration: '0s, 0.15s'
            },
            // giving active styles preference by listing them after focus
            '&:active': {
                ...$6a16a016cffcb4ff$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'active',
                    mode: mode
                }),
                // background, box-shadow
                transitionDuration: '0s, 0s'
            },
            // preventDefault prevents regular active styles from applying in Firefox
            '&[data-firefox-is-active="true"]': {
                ...$6a16a016cffcb4ff$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'active',
                    mode: mode
                }),
                // background, box-shadow
                transitionDuration: '0s, 0s'
            },
            // Giving disabled styles preference over active by listing them after.
            // Not using '&:disabled' because :disabled is not a valid state for all element types
            // so we are targeting the attribute
            // Attributes have the same specificity a pseudo classes so we are overriding :disabled here
            '&[disabled]': {
                // always using 'disabled' even when selected
                ...$6a16a016cffcb4ff$var$getColors({
                    appearance: appearance,
                    key: 'disabled',
                    mode: mode
                }),
                cursor: 'not-allowed',
                textDecoration: 'none'
            },
            ...$6a16a016cffcb4ff$var$hasOverlayStyles,
            // disabling hover and active color changes when there is an overlay, but the button is not disabled
            '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': {
                ...$6a16a016cffcb4ff$var$getColors({
                    appearance: appearance,
                    key: isSelected ? 'selected' : 'default',
                    mode: mode
                })
            }
        },
        // dynamic colours for visual refresh:
        ...(0, $3puyA.fg)('platform.design-system-team.component-visual-refresh_t8zbo') && (isSelected ? $6a16a016cffcb4ff$var$selectedStyles : {
            ...appearance === 'default' && $6a16a016cffcb4ff$var$defaultStyles,
            ...appearance === 'primary' && $6a16a016cffcb4ff$var$primaryStyles,
            ...appearance === 'link' && $6a16a016cffcb4ff$var$linkStyles,
            ...appearance === 'subtle' && $6a16a016cffcb4ff$var$subtleStyles,
            ...appearance === 'subtle-link' && $6a16a016cffcb4ff$var$subtleLinkStyles,
            ...appearance === 'warning' && $6a16a016cffcb4ff$var$warningStyles,
            ...appearance === 'danger' && $6a16a016cffcb4ff$var$dangerStyles,
            '&[disabled]': {
                color: "var(--ds-text-disabled, #091E424F)",
                backgroundColor: $6a16a016cffcb4ff$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent',
                cursor: 'not-allowed',
                textDecoration: 'none',
                '&:hovered': {
                    backgroundColor: $6a16a016cffcb4ff$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
                },
                '&:active': {
                    backgroundColor: $6a16a016cffcb4ff$var$HAS_DISABLED_BACKGROUND.includes(appearance) ? "var(--ds-background-disabled, #091E4208)" : 'transparent'
                }
            },
            ...$6a16a016cffcb4ff$var$hasOverlayStyles,
            // disabling hover and active color changes when there is an overlay, but the button is not disabled
            '&[data-has-overlay="true"]:not([disabled]):hover, &[data-has-overlay="true"]:not([disabled]):active': {
                background: 'inherit'
            }
        }),
        '&::-moz-focus-inner': {
            border: 0,
            margin: 0,
            padding: 0
        }
    };
}
function $6a16a016cffcb4ff$export$864eea3f4ec3368f({ spacing: spacing }) {
    return (0, $byn9U.css)({
        display: 'flex',
        // icon size cannot grow and shrink
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $6a16a016cffcb4ff$var$innerMargin.icon,
        flexGrow: 0,
        flexShrink: 0,
        alignSelf: 'center',
        fontSize: 0,
        lineHeight: 0,
        userSelect: 'none'
    });
}
function $6a16a016cffcb4ff$export$7ad0316cc0dd65a({ spacing: spacing }) {
    return (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        margin: spacing === 'none' ? 0 : $6a16a016cffcb4ff$var$innerMargin.content,
        // content can grow and shrink
        flexGrow: 1,
        flexShrink: 1,
        // ellipsis for overflow text
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    });
}
function $6a16a016cffcb4ff$export$1b5827d324e945b1({ hasOverlay: hasOverlay }) {
    return (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        opacity: hasOverlay ? 0 : 1,
        transition: 'opacity 0.3s'
    });
}
const $6a16a016cffcb4ff$export$1a9fe1b84c876bb5 = {
    // stretching to full width / height of button
    // this is important as we need it to still block
    // event if clicking in the button's own padding
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    // Putting all children in the center
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

});
parcelRegister("5JMSv", function(module, exports) {

$parcel$export(module.exports, "default", () => $42d711e5758e758b$export$2e2bcd8739ae039);

var $j0gMm = parcelRequire("j0gMm");
// Hard coding the active rgba color value rather than using a helper to convert it
// With helper it would be: hex2rgba(colors.B75, 0.6)
const $42d711e5758e758b$var$fadedB75 = 'rgba(179, 212, 255, 0.6)';
const $42d711e5758e758b$var$values = {
    // Default appearance
    background: {
        default: {
            default: {
                light: `var(--ds-background-neutral, ${$j0gMm.N20A})`,
                dark: `var(--ds-background-neutral, ${$j0gMm.DN70})`
            },
            hover: {
                light: `var(--ds-background-neutral-hovered, ${$j0gMm.N30A})`,
                dark: `var(--ds-background-neutral-hovered, ${$j0gMm.DN60})`
            },
            active: {
                light: `var(--ds-background-neutral-pressed, ${$42d711e5758e758b$var$fadedB75})`,
                dark: `var(--ds-background-neutral-pressed, ${$j0gMm.B75})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$j0gMm.N20A})`,
                dark: `var(--ds-background-disabled, ${$j0gMm.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.DN0})`
            }
        },
        primary: {
            default: {
                light: `var(--ds-background-brand-bold, ${$j0gMm.B400})`,
                dark: `var(--ds-background-brand-bold, ${$j0gMm.B100})`
            },
            hover: {
                light: `var(--ds-background-brand-bold-hovered, ${$j0gMm.B300})`,
                dark: `var(--ds-background-brand-bold-hovered, ${$j0gMm.B75})`
            },
            active: {
                light: `var(--ds-background-brand-bold-pressed, ${$j0gMm.B500})`,
                dark: `var(--ds-background-brand-bold-pressed, ${$j0gMm.B200})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$j0gMm.N20A})`,
                dark: `var(--ds-background-disabled, ${$j0gMm.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.DN0})`
            }
        },
        warning: {
            default: {
                light: `var(--ds-background-warning-bold, ${$j0gMm.Y300})`,
                dark: `var(--ds-background-warning-bold, ${$j0gMm.Y300})`
            },
            hover: {
                light: `var(--ds-background-warning-bold-hovered, ${$j0gMm.Y200})`,
                dark: `var(--ds-background-warning-bold-hovered, ${$j0gMm.Y200})`
            },
            active: {
                light: `var(--ds-background-warning-bold-pressed, ${$j0gMm.Y400})`,
                dark: `var(--ds-background-warning-bold-pressed, ${$j0gMm.Y400})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$j0gMm.N20A})`,
                dark: `var(--ds-background-disabled, ${$j0gMm.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$j0gMm.Y400})`,
                dark: `var(--ds-background-selected, ${$j0gMm.Y400})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$j0gMm.Y400})`,
                dark: `var(--ds-background-selected, ${$j0gMm.Y400})`
            }
        },
        danger: {
            default: {
                light: `var(--ds-background-danger-bold, ${$j0gMm.R400})`,
                dark: `var(--ds-background-danger-bold, ${$j0gMm.R400})`
            },
            hover: {
                light: `var(--ds-background-danger-bold-hovered, ${$j0gMm.R300})`,
                dark: `var(--ds-background-danger-bold-hovered, ${$j0gMm.R300})`
            },
            active: {
                light: `var(--ds-background-danger-bold-pressed, ${$j0gMm.R500})`,
                dark: `var(--ds-background-danger-bold-pressed, ${$j0gMm.R500})`
            },
            disabled: {
                light: `var(--ds-background-disabled, ${$j0gMm.N20A})`,
                dark: `var(--ds-background-disabled, ${$j0gMm.DN70})`
            },
            selected: {
                light: `var(--ds-background-selected, ${$j0gMm.R500})`,
                dark: `var(--ds-background-selected, ${$j0gMm.R500})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$j0gMm.R500})`,
                dark: `var(--ds-background-selected, ${$j0gMm.R500})`
            }
        },
        link: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.N20})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.N20})`
            }
        },
        subtle: {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            hover: {
                light: `var(--ds-background-neutral-subtle-hovered, ${$j0gMm.N30A})`,
                dark: `var(--ds-background-neutral-subtle-hovered, ${$j0gMm.DN60})`
            },
            active: {
                light: `var(--ds-background-neutral-subtle-pressed, ${$42d711e5758e758b$var$fadedB75})`,
                dark: `var(--ds-background-neutral-subtle-pressed, ${$j0gMm.B75})`
            },
            disabled: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.DN0})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.DN0})`
            }
        },
        'subtle-link': {
            default: {
                light: "var(--ds-background-neutral-subtle, none)",
                dark: "var(--ds-background-neutral-subtle, none)"
            },
            selected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.N20})`
            },
            focusSelected: {
                light: `var(--ds-background-selected, ${$j0gMm.N700})`,
                dark: `var(--ds-background-selected, ${$j0gMm.N20})`
            }
        }
    },
    color: {
        default: {
            default: {
                light: `var(--ds-text, ${$j0gMm.N500})`,
                dark: `var(--ds-text, ${$j0gMm.DN400})`
            },
            active: {
                light: `var(--ds-text, ${$j0gMm.B400})`,
                dark: `var(--ds-text, ${$j0gMm.B400})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$j0gMm.N70})`,
                dark: `var(--ds-text-disabled, ${$j0gMm.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            }
        },
        primary: {
            default: {
                light: `var(--ds-text-inverse, ${$j0gMm.N0})`,
                dark: `var(--ds-text-inverse, ${$j0gMm.DN30})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$j0gMm.N70})`,
                dark: `var(--ds-text-disabled, ${$j0gMm.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            }
        },
        warning: {
            default: {
                light: `var(--ds-text-warning-inverse, ${$j0gMm.N800})`,
                dark: `var(--ds-text-warning-inverse, ${$j0gMm.N800})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$j0gMm.N70})`,
                dark: `var(--ds-text-disabled, ${$j0gMm.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$j0gMm.N800})`,
                dark: `var(--ds-text-selected, ${$j0gMm.N800})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$j0gMm.N800})`,
                dark: `var(--ds-text-selected, ${$j0gMm.N800})`
            }
        },
        danger: {
            default: {
                light: `var(--ds-text-inverse, ${$j0gMm.N0})`,
                dark: `var(--ds-text-inverse, ${$j0gMm.N0})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$j0gMm.N70})`,
                dark: `var(--ds-text-disabled, ${$j0gMm.DN30})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$j0gMm.N0})`,
                dark: `var(--ds-text-selected, ${$j0gMm.N0})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$j0gMm.N0})`,
                dark: `var(--ds-text-selected, ${$j0gMm.N0})`
            }
        },
        link: {
            default: {
                light: `var(--ds-link, ${$j0gMm.B400})`,
                dark: `var(--ds-link, ${$j0gMm.B100})`
            },
            hover: {
                light: `var(--ds-link, ${$j0gMm.B300})`,
                dark: `var(--ds-link, ${$j0gMm.B75})`
            },
            active: {
                light: `var(--ds-link-pressed, ${$j0gMm.B500})`,
                dark: `var(--ds-link-pressed, ${$j0gMm.B200})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$j0gMm.N70})`,
                dark: `var(--ds-text-disabled, ${$j0gMm.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.N700})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.N700})`
            }
        },
        subtle: {
            default: {
                light: `var(--ds-text, ${$j0gMm.N500})`,
                dark: `var(--ds-text, ${$j0gMm.DN400})`
            },
            active: {
                light: `var(--ds-text, ${$j0gMm.B400})`,
                dark: `var(--ds-text, ${$j0gMm.B400})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$j0gMm.N70})`,
                dark: `var(--ds-text-disabled, ${$j0gMm.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            }
        },
        'subtle-link': {
            default: {
                light: `var(--ds-text-subtle, ${$j0gMm.N200})`,
                dark: `var(--ds-text-subtle, ${$j0gMm.DN400})`
            },
            hover: {
                light: `var(--ds-text-subtle, ${$j0gMm.N90})`,
                dark: `var(--ds-text-subtle, ${$j0gMm.B50})`
            },
            active: {
                light: `var(--ds-text, ${$j0gMm.N400})`,
                dark: `var(--ds-text, ${$j0gMm.DN300})`
            },
            disabled: {
                light: `var(--ds-text-disabled, ${$j0gMm.N70})`,
                dark: `var(--ds-text-disabled, ${$j0gMm.DN100})`
            },
            selected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            },
            focusSelected: {
                light: `var(--ds-text-selected, ${$j0gMm.N20})`,
                dark: `var(--ds-text-selected, ${$j0gMm.DN400})`
            }
        }
    }
};
var $42d711e5758e758b$export$2e2bcd8739ae039 = $42d711e5758e758b$var$values;

});


parcelRegister("gp7Z4", function(module, exports) {

$parcel$export(module.exports, "getIfVisuallyHiddenChildren", () => $bf152c964bbefff2$export$20bbd2efb0d734c4);

var $eUqFw = parcelRequire("eUqFw");

var $lWrn5 = parcelRequire("lWrn5");
const $bf152c964bbefff2$export$20bbd2efb0d734c4 = (children)=>{
    return children && /*#__PURE__*/ (0, $eUqFw.isValidElement)(children) && children.type === (0, $lWrn5.default);
};

});


parcelRegister("i8QFr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d351d3f9e19f85a3$export$2e2bcd8739ae039);

var $gp7Z4 = parcelRequire("gp7Z4");
function $d351d3f9e19f85a3$export$2e2bcd8739ae039({ children: children, iconBefore: iconBefore, iconAfter: iconAfter }) {
    if ((0, $gp7Z4.getIfVisuallyHiddenChildren)(children)) return true;
    if (children) return false;
    if (iconBefore && !iconAfter) return true;
    if (!iconBefore && iconAfter) return true;
    return false;
}

});

parcelRegister("5nZDj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ebee8c55e1da628$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hvCdF = parcelRequire("hvCdF");
function $3ebee8c55e1da628$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled) return 'inherit';
    if (isSelected) return 'invert';
    if (appearance === 'primary' || appearance === 'danger') return 'invert';
    return 'inherit';
}
function $3ebee8c55e1da628$export$2e2bcd8739ae039({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, spacing: spacing = 'default' }) {
    const size = spacing === 'default' ? 'medium' : 'small';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hvCdF.default), {
        size: size,
        label: ", Loading",
        appearance: $3ebee8c55e1da628$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        })
    });
}

});

parcelRegister("6ZNIT", function(module, exports) {

$parcel$export(module.exports, "getSpecifiers", () => $517f029200c8b8bb$export$643db0b8d8778e);
$parcel$export(module.exports, "defaultThemeFn", () => $517f029200c8b8bb$export$437a7f77d13d7916);
$parcel$export(module.exports, "default", () => $517f029200c8b8bb$export$2e2bcd8739ae039);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $d8yWP = parcelRequire("d8yWP");

var $96HLH = parcelRequire("96HLH");
const $517f029200c8b8bb$var$stateToSelectorMap = {
    focus: '&:focus',
    focusSelected: '&:focus',
    hover: '&:hover',
    active: '&:active',
    disabled: '&[disabled]'
};
function $517f029200c8b8bb$export$31512de7fa606fa4({ appearance: appearance = 'default', spacing: spacing = 'default', mode: mode = 'light', isSelected: isSelected = false, shouldFitContainer: shouldFitContainer = false, iconIsOnlyChild: iconIsOnlyChild = false, isLoading: isLoading = false, state: state }) {
    let result = (0, $96HLH.getCss)({
        appearance: appearance,
        spacing: spacing,
        mode: mode,
        isSelected: isSelected,
        shouldFitContainer: shouldFitContainer,
        isOnlySingleIcon: iconIsOnlyChild
    });
    // we need to disable the default browser focus styles always
    // this is because we are not expressing that we can have two pseudo states at a time
    result.outline = 'none';
    // Pulling relevant styles up to the top level
    const selector = $517f029200c8b8bb$var$stateToSelectorMap[state];
    if (selector) result = {
        ...result,
        ...result[selector]
    };
    if (isLoading) result = {
        ...result,
        // Pull overlay styles up to the top
        ...result['&[data-has-overlay="true"]']
    };
    // Delete all selectors and just keep root styles
    Object.keys(result).forEach((key)=>{
        // want to keep this one
        if (key === '&::-moz-focus-inner') return;
        // Not using .startsWith for ie11
        if (key.indexOf('&') === 0) delete result[key];
    });
    return result;
}
function $517f029200c8b8bb$export$643db0b8d8778e(styles) {
    return {
        '&, &:hover, &:active, &:focus, &:focus-visible, &:visited, &:disabled, &[disabled]': styles
    };
}
function $517f029200c8b8bb$export$437a7f77d13d7916(current, values) {
    return current(values);
}
const $517f029200c8b8bb$var$Theme = (0, $d8yWP.createTheme)((themeProps)=>({
        buttonStyles: $517f029200c8b8bb$export$31512de7fa606fa4(themeProps),
        // No styles being applied directly to spinner by default
        // Keeping this for legacy compat. We could remove it, but given
        // that we are changing theme soon there is no point
        spinnerStyles: {}
    }));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$517f029200c8b8bb$export$2e2bcd8739ae039 = $517f029200c8b8bb$var$Theme;

});


parcelRegister("lLBy7", function(module, exports) {

$parcel$export(module.exports, "linkOverrideStyles", () => $fd8b1d4622ba7c32$export$f5ebc45b1d7eb8e5);
$parcel$export(module.exports, "mpacBaseStyles", () => $fd8b1d4622ba7c32$export$7c5aa24e0dc7faef);
$parcel$export(module.exports, "emceeBaseStyles", () => $fd8b1d4622ba7c32$export$31a00939637100f7);
$parcel$export(module.exports, "mpacGhostStyles", () => $fd8b1d4622ba7c32$export$c9fd3f5dfc94c95);
$parcel$export(module.exports, "emceeGhostStyles", () => $fd8b1d4622ba7c32$export$37c63af48cd54705);

var $5zQU9 = parcelRequire("5zQU9");

var $3DYxj = parcelRequire("3DYxj");
function $fd8b1d4622ba7c32$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fd8b1d4622ba7c32$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fd8b1d4622ba7c32$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fd8b1d4622ba7c32$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $fd8b1d4622ba7c32$var$baseStyles = $fd8b1d4622ba7c32$var$_objectSpread($fd8b1d4622ba7c32$var$_objectSpread({}, (0, $3DYxj.charlieTextFontFamily)), {}, {
    fontSize: '1rem',
    borderRadius: '4px',
    padding: "0 ".concat("var(--ds-space-200, 16px)"),
    fontWeight: 600,
    lineHeight: '1.25rem',
    alignItems: 'center'
});
const $fd8b1d4622ba7c32$export$f5ebc45b1d7eb8e5 = $fd8b1d4622ba7c32$var$_objectSpread($fd8b1d4622ba7c32$var$_objectSpread({}, $fd8b1d4622ba7c32$var$baseStyles), {}, {
    color: "var(--ds-link)",
    background: 'none',
    border: 'none',
    height: '1.25rem',
    padding: 0,
    '&:hover': {
        textDecoration: 'underline'
    }
});
const $fd8b1d4622ba7c32$var$mpacBaseOverrides = {
    fontSize: '1rem',
    height: '2.5rem'
};
const $fd8b1d4622ba7c32$var$emceeBaseOverrides = {
    fontSize: '0.875rem',
    height: '2rem'
};
const $fd8b1d4622ba7c32$export$7c5aa24e0dc7faef = $fd8b1d4622ba7c32$var$_objectSpread($fd8b1d4622ba7c32$var$_objectSpread({}, $fd8b1d4622ba7c32$var$baseStyles), $fd8b1d4622ba7c32$var$mpacBaseOverrides);
const $fd8b1d4622ba7c32$export$31a00939637100f7 = $fd8b1d4622ba7c32$var$_objectSpread($fd8b1d4622ba7c32$var$_objectSpread({}, $fd8b1d4622ba7c32$var$baseStyles), $fd8b1d4622ba7c32$var$emceeBaseOverrides);
const $fd8b1d4622ba7c32$var$ghostStyles = $fd8b1d4622ba7c32$var$_objectSpread($fd8b1d4622ba7c32$var$_objectSpread({}, $fd8b1d4622ba7c32$var$baseStyles), {}, {
    background: 'transparent',
    color: "var(--ds-text-brand)",
    border: "1px solid ".concat("var(--ds-border-brand)"),
    '&:hover': {
        background: "var(--ds-background-selected-hovered)"
    },
    '&:active': {
        background: "var(--ds-background-selected-pressed)"
    }
});
const $fd8b1d4622ba7c32$export$c9fd3f5dfc94c95 = $fd8b1d4622ba7c32$var$_objectSpread($fd8b1d4622ba7c32$var$_objectSpread({}, $fd8b1d4622ba7c32$var$ghostStyles), $fd8b1d4622ba7c32$var$mpacBaseOverrides);
const $fd8b1d4622ba7c32$export$37c63af48cd54705 = $fd8b1d4622ba7c32$var$_objectSpread($fd8b1d4622ba7c32$var$_objectSpread({}, $fd8b1d4622ba7c32$var$ghostStyles), $fd8b1d4622ba7c32$var$emceeBaseOverrides);

});
parcelRegister("3DYxj", function(module, exports) {

$parcel$export(module.exports, "charlieTextFontFamily", () => $2a73f8d740cfd8f7$export$f4dac65c086899d4);

var $ivTMz = parcelRequire("ivTMz");
const $2a73f8d740cfd8f7$export$3f4d05b455b17f33 = {
    fontFamily: "Charlie Display, ".concat((0, $ivTMz.fontFamily)())
};
const $2a73f8d740cfd8f7$export$f4dac65c086899d4 = {
    fontFamily: "Charlie Text, ".concat((0, $ivTMz.fontFamily)())
};

});



parcelRegister("7OO07", function(module, exports) {
module.exports = new URL("escape.04a5682a.svg", import.meta.url).toString();

});

parcelRegister("eCy7Y", function(module, exports) {
module.exports = new URL("return.44414c16.svg", import.meta.url).toString();

});

parcelRegister("jv19K", function(module, exports) {
module.exports = new URL("up-down.9c5a4c4d.svg", import.meta.url).toString();

});


parcelRegister("POywL", function(module, exports) {

$parcel$export(module.exports, "SearchHeader", () => $09bbfae1cf1f141c$export$8a9b225579f9b6a7);
/* SearchHeader.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $7JEyt = parcelRequire("7JEyt");

var $7nRDV = parcelRequire("7nRDV");

var $hXNHP = parcelRequire("hXNHP");

var $2Nahn = parcelRequire("2Nahn");


var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $09bbfae1cf1f141c$var$_excluded = [
    "as",
    "style"
], $09bbfae1cf1f141c$var$_excluded2 = [
    "as",
    "style"
], $09bbfae1cf1f141c$var$_excluded3 = [
    "isEmbedded"
], $09bbfae1cf1f141c$var$_excluded4 = [
    "as",
    "style"
], $09bbfae1cf1f141c$var$_excluded5 = [
    "as",
    "style"
], $09bbfae1cf1f141c$var$_excluded6 = [
    "isEmbedded"
], $09bbfae1cf1f141c$var$_excluded7 = [
    "as",
    "style"
], $09bbfae1cf1f141c$var$_excluded8 = [
    "aria-labelledby"
];
function $09bbfae1cf1f141c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $09bbfae1cf1f141c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $09bbfae1cf1f141c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $09bbfae1cf1f141c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $09bbfae1cf1f141c$var$Input = /*#__PURE__*/ (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "input", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $09bbfae1cf1f141c$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $09bbfae1cf1f141c$var$_objectSpread($09bbfae1cf1f141c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19itglyw _syaz1blv _ect4wevw _1wyb1j6v _zg8l4jg8 _k48p1nn1 _vwz41k8s _16jlkb7n _12y3idpf _r06hglyw _12ji1r31 _1qu2glyw _12y31o36 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _bfhk6ota _18ql6ota _1idr1k3w _tdaxglyw",
            __cmplp.className
        ])
    }));
});
const $09bbfae1cf1f141c$var$Form = /*#__PURE__*/ (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "form", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $09bbfae1cf1f141c$var$_excluded2);
    const { isEmbedded: isEmbedded } = __cmplp, __cmpldp = (0, $bwPfh.default)(__cmplp, $09bbfae1cf1f141c$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $09bbfae1cf1f141c$var$_objectSpread($09bbfae1cf1f141c$var$_objectSpread({}, __cmpldp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhk6ota _1e0c1txw _1bsb1osq _4cvr1h6o _pdlm1eps _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf",
            __cmplp.isEmbedded ? "_1yt4xnej" : "_1yt4s9pv",
            __cmplp.isEmbedded ? "_zulp1eps" : "_zulp1fcb",
            __cmplp.className
        ])
    }));
});
const $09bbfae1cf1f141c$var$BackButtonMobile = /*#__PURE__*/ (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "button", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $09bbfae1cf1f141c$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $09bbfae1cf1f141c$var$_objectSpread($09bbfae1cf1f141c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ady _1bsb1ady _1e0c1txw _1bah1h6o _4cvr1h6o _80omtlke _1yt41llo _19itglyw _11q7glyw _syaz1jij _1ygb4suz _dm25glyw",
            __cmplp.className
        ])
    }));
});
const $09bbfae1cf1f141c$var$SearchButtonDesktop = /*#__PURE__*/ (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $09bbfae1cf1f141c$var$_excluded5);
    const { isEmbedded: isEmbedded } = __cmplp, __cmpldp = (0, $bwPfh.default)(__cmplp, $09bbfae1cf1f141c$var$_excluded6);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $09bbfae1cf1f141c$var$_objectSpread($09bbfae1cf1f141c$var$_objectSpread({}, __cmpldp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1tcg _dm251ule",
            !__cmplp.isEmbedded ? "_1e0cglyw" : "_1e0c1ule",
            __cmplp.className
        ])
    }));
});
const $09bbfae1cf1f141c$var$ClearButton = /*#__PURE__*/ (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "button", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $09bbfae1cf1f141c$var$_excluded7);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $09bbfae1cf1f141c$var$_objectSpread($09bbfae1cf1f141c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omtlke _11q7glyw _19itglyw _r06hglyw _syaz1k3w _1bsb1ady _4t3i1ady _x5db4suz _glte7vkz _165t7vkz _oqicidpf _1rmjidpf _cjbtidpf _pnmbidpf",
            __cmplp.className
        ])
    }));
});
const $09bbfae1cf1f141c$export$8a9b225579f9b6a7 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((_ref6, inputRef)=>{
    var _current2;
    let { autocomplete: autocomplete, handleEnterKeyPress: handleEnterKeyPress, handleBackClick: handleBackClick, clearSearchInput: clearSearchInput, onBlur: onBlur, onFocus: onFocus, onKeyDown: onKeyDown, onClearTextKeyDown: onClearTextKeyDown, isEmbedded: isEmbedded, showFullScreenComponent: showFullScreenComponent = false, backButtonRef: backButtonRef } = _ref6;
    const onFormSubmit = (e)=>{
        var _current;
        e.preventDefault();
        const query = inputRef === null || inputRef === void 0 ? void 0 : (_current = inputRef.current) === null || _current === void 0 ? void 0 : _current.value;
        handleEnterKeyPress(query || '');
    };
    const inputProp = autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getInputProps({
        inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current,
        autoFocus: !isEmbedded,
        maxLength: 200
    });
    const rootProps = !isEmbedded ? autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getRootProps({}) : {};
    const _ref7 = (autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getInputProps({
        inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current,
        autoFocus: !isEmbedded,
        maxLength: 200
    })) || {}, { 'aria-labelledby': ariaLabelledby } = _ref7, inputProps = (0, $bwPfh.default)(_ref7, $09bbfae1cf1f141c$var$_excluded8);
    const searchFieldProps = $09bbfae1cf1f141c$var$_objectSpread($09bbfae1cf1f141c$var$_objectSpread({}, rootProps), inputProps);
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)($09bbfae1cf1f141c$var$Form, $09bbfae1cf1f141c$var$_objectSpread($09bbfae1cf1f141c$var$_objectSpread({}, autocomplete === null || autocomplete === void 0 ? void 0 : autocomplete.getFormProps({
                inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
            })), {}, {
                onSubmit: onFormSubmit,
                onBlur: onBlur,
                onFocus: onFocus,
                isEmbedded: isEmbedded,
                onKeyDown: onKeyDown,
                className: "dont-default-focus" // this classname is added to prevent the autofocus on load in Jira
                ,
                children: [
                    handleBackClick && /*#__PURE__*/ (0, $lHkHI.jsx)($09bbfae1cf1f141c$var$BackButtonMobile, {
                        onClick: handleBackClick,
                        ref: backButtonRef,
                        type: "button",
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7nRDV))), {
                            label: "back button"
                        })
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($09bbfae1cf1f141c$var$SearchButtonDesktop, {
                        isEmbedded: isEmbedded,
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hXNHP))), {
                            label: "search"
                        })
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($09bbfae1cf1f141c$var$Input, $09bbfae1cf1f141c$var$_objectSpread($09bbfae1cf1f141c$var$_objectSpread({
                        ref: inputRef
                    }, searchFieldProps), {}, {
                        "aria-label": (inputProp === null || inputProp === void 0 ? void 0 : inputProp.placeholder) || 'Search for apps within Marketplace'
                    }))
                ]
            })),
            !showFullScreenComponent && inputRef && (inputRef === null || inputRef === void 0 ? void 0 : (_current2 = inputRef.current) === null || _current2 === void 0 ? void 0 : _current2.value) && /*#__PURE__*/ (0, $lHkHI.jsx)($09bbfae1cf1f141c$var$ClearButton, {
                onClick: clearSearchInput,
                onKeyDown: onClearTextKeyDown,
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Nahn))), {
                    label: "Clear search input field",
                    size: "small",
                    "aria-controls": "search-input"
                })
            })
        ]
    });
});
$09bbfae1cf1f141c$export$8a9b225579f9b6a7.displayName = 'SearchHeader';

});
parcelRegister("7nRDV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $56044ac2d23ae4ce$var$_react = $56044ac2d23ae4ce$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $56044ac2d23ae4ce$var$_arrowLeft = $56044ac2d23ae4ce$var$_interopRequireDefault((parcelRequire("hP8A3")));
function $56044ac2d23ae4ce$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $56044ac2d23ae4ce$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $56044ac2d23ae4ce$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12.207 5.793a1 1 0 0 1 0 1.414L8.414 11H18a1 1 0 1 1 0 2H8.414l3.793 3.793a1 1 0 1 1-1.415 1.414l-5.499-5.5A1 1 0 0 1 5 12.028v-.057a1 1 0 0 1 .293-.678l5.499-5.5a1 1 0 0 1 1.415 0" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $56044ac2d23ae4ce$var$_arrowLeft.default
    }));
$56044ac2d23ae4ce$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $56044ac2d23ae4ce$var$_default = module.exports.default = $56044ac2d23ae4ce$var$ArrowLeftIcon;

});
parcelRegister("hP8A3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8eff4e7c48a4dd161566c1dd735476d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cf9ddb048de7be2f$var$_react = $cf9ddb048de7be2f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cf9ddb048de7be2f$var$_UNSAFE_baseNew = $cf9ddb048de7be2f$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $cf9ddb048de7be2f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to previous screen, previous slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cf9ddb048de7be2f$var$ArrowLeftIcon = (props)=>/*#__PURE__*/ $cf9ddb048de7be2f$var$_react.default.createElement($cf9ddb048de7be2f$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15 8H2.25m4.5-5-5 5 5 5"/>`
    }, props));
$cf9ddb048de7be2f$var$ArrowLeftIcon.displayName = 'ArrowLeftIcon';
var $cf9ddb048de7be2f$var$_default = module.exports.default = $cf9ddb048de7be2f$var$ArrowLeftIcon;

});


parcelRegister("2Nahn", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $208821a09b3cb498$var$_react = $208821a09b3cb498$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $208821a09b3cb498$var$_crossCircle = $208821a09b3cb498$var$_interopRequireDefault((parcelRequire("evEgf")));
function $208821a09b3cb498$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $208821a09b3cb498$var$SelectClearIcon = (props)=>/*#__PURE__*/ $208821a09b3cb498$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="9" fill="currentcolor"/><path fill="inherit" d="M16.155 14.493a1.174 1.174 0 1 1-1.662 1.663L12 13.662l-2.494 2.494a1.17 1.17 0 0 1-1.662 0 1.176 1.176 0 0 1 0-1.663L10.337 12 7.844 9.507a1.176 1.176 0 0 1 1.662-1.662L12 10.338l2.493-2.493a1.174 1.174 0 1 1 1.662 1.662L13.662 12z"/></g></svg>`
    }, props, {
        newIcon: $208821a09b3cb498$var$_crossCircle.default
    }));
$208821a09b3cb498$var$SelectClearIcon.displayName = 'SelectClearIcon';
var $208821a09b3cb498$var$_default = module.exports.default = $208821a09b3cb498$var$SelectClearIcon;

});
parcelRegister("evEgf", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b195e70c8e4b45875c876105018c6db5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a90330f204c5cc22$var$_react = $a90330f204c5cc22$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a90330f204c5cc22$var$_UNSAFE_baseNew = $a90330f204c5cc22$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $a90330f204c5cc22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: clear text field, error status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a90330f204c5cc22$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $a90330f204c5cc22$var$_react.default.createElement($a90330f204c5cc22$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m4.03 5.03L9.06 8l2.97 2.97-1.06 1.06L8 9.06l-2.97 2.97-1.06-1.06L6.94 8 3.97 5.03l1.06-1.06L8 6.94l2.97-2.97z" clip-rule="evenodd"/>`
    }, props));
$a90330f204c5cc22$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $a90330f204c5cc22$var$_default = module.exports.default = $a90330f204c5cc22$var$CrossCircleIcon;

});



parcelRegister("7RGla", function(module, exports) {

$parcel$export(module.exports, "useAutocompleteState", () => $5b9e538ddadeb05d$export$ce1595f6e1a63433);

var $eUqFw = parcelRequire("eUqFw");

var $9AuiZ = parcelRequire("9AuiZ");
const $5b9e538ddadeb05d$export$ce1595f6e1a63433 = (_ref)=>{
    let { autocompleteState: autocompleteState } = _ref;
    const [bodyState, setBodyState] = (0, $eUqFw.useState)((0, $9AuiZ.BODY_STATES).EMPTY_STATE);
    const hasCollections = (0, $eUqFw.useMemo)(()=>{
        return autocompleteState.collections.some((collection)=>collection.items.length > 0);
    }, [
        autocompleteState.collections
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (autocompleteState.query && (autocompleteState.status === (0, $9AuiZ.AutoCompleteStatusValues).LOADING || autocompleteState.status === (0, $9AuiZ.AutoCompleteStatusValues).STALLED)) setBodyState((0, $9AuiZ.BODY_STATES).LOADING);
        else if (autocompleteState.status === (0, $9AuiZ.AutoCompleteStatusValues).ERROR) setBodyState((0, $9AuiZ.BODY_STATES).API_FAILURE);
        else if (autocompleteState.query && hasCollections) setBodyState((0, $9AuiZ.BODY_STATES).SEARCH_RESULTS);
        else if (!autocompleteState.query && hasCollections) setBodyState((0, $9AuiZ.BODY_STATES).RECENT_SEARCHES);
        else if (autocompleteState.query && !hasCollections) setBodyState((0, $9AuiZ.BODY_STATES).NO_SUGGESTIONS);
        else if (!autocompleteState.query && !hasCollections) setBodyState((0, $9AuiZ.BODY_STATES).EMPTY_STATE);
    }, [
        autocompleteState,
        hasCollections
    ]);
    return {
        bodyState: bodyState
    };
};

});

parcelRegister("8qFnR", function(module, exports) {

$parcel$export(module.exports, "useSearchDropdown", () => $6230da6ce21eb070$export$fba8fab595cd40e0);

var $dM9ZW = parcelRequire("dM9ZW");

var $c0qPT = parcelRequire("c0qPT");

var $eUqFw = parcelRequire("eUqFw");

var $hCl9L = parcelRequire("hCl9L");

var $118My = parcelRequire("118My");
const $6230da6ce21eb070$export$fba8fab595cd40e0 = (_ref)=>{
    let { inputRef: inputRef, autocomplete: autocomplete, autocompleteState: autocompleteState, recentSearch: recentSearch, onEnterKeyPress: onEnterKeyPress, additionalQueryParams: additionalQueryParams } = _ref;
    // This is needed to refresh the recent searches when the component mounts
    // If we don't do this, the recent searches will not be updated seacrh embedded component
    // when the user searches in overlay component
    (0, $eUqFw.useEffect)(()=>{
        recentSearch.refreshRecentSearches();
    }, []);
    const locationHref = (0, $dM9ZW.useLocationHref)();
    const history = (0, $dM9ZW.useHistory)();
    const handleAppend = (hit)=>{
        var _inputRef$current;
        autocomplete.setQuery(hit.query);
        (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    };
    const source = (0, $c0qPT.useSource)();
    const mountPath = (0, $c0qPT.useMountPath)();
    const handleEnterKeyPress = (query)=>{
        var _inputRef$current2, _autocompleteState$co;
        if (query) {
            const queryToBeSaved = {
                query: query,
                objectID: query
            };
            recentSearch.push(queryToBeSaved);
        }
        (0, $118My.redirectToNewQuery)({
            query: query,
            locationHref: locationHref,
            history: history,
            additionalQueryParams: additionalQueryParams,
            source: source,
            mountPath: mountPath
        });
        inputRef === null || inputRef === void 0 || (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
        // HANLDE ANALYTCS
        onEnterKeyPress({
            query: query,
            suggestionSource: (0, $hCl9L.getSuggestionSource)(!!query),
            count: query ? (_autocompleteState$co = autocompleteState.collections[0].items.length) !== null && _autocompleteState$co !== void 0 ? _autocompleteState$co : 0 : recentSearch.count()
        });
    };
    const clearRecentSearches = ()=>{
        var _inputRef$current3;
        recentSearch.clearAll();
        autocomplete.refresh();
        inputRef === null || inputRef === void 0 || (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.focus();
    };
    const clearSearchInput = ()=>{
        if (inputRef.current && inputRef.current.value) {
            autocomplete.setQuery('');
            inputRef.current.focus();
        }
    };
    return {
        handleAppend: handleAppend,
        handleEnterKeyPress: handleEnterKeyPress,
        clearRecentSearches: clearRecentSearches,
        clearSearchInput: clearSearchInput
    };
};

});

parcelRegister("eEXJs", function(module, exports) {

$parcel$export(module.exports, "useSearchViewAnalytics", () => $aac322acd017a132$export$1dbd2381ba335445);

var $eUqFw = parcelRequire("eUqFw");

var $hCl9L = parcelRequire("hCl9L");

var $9AuiZ = parcelRequire("9AuiZ");
const $aac322acd017a132$export$1dbd2381ba335445 = (_ref)=>{
    let { showSuggestionPopup: showSuggestionPopup, isQueryFromUrl: isQueryFromUrl, inputRef: inputRef, onViewed: onViewed, recentSearch: recentSearch, hasFiredViewedAnalyticsRef: hasFiredViewedAnalyticsRef, autocompleteState: autocompleteState, bodyState: bodyState } = _ref;
    (0, $eUqFw.useEffect)(()=>{
        recentSearch.refreshRecentSearches();
        // HANDLE ANALYTICS FOR EMPTY QUERY
        if (showSuggestionPopup && !isQueryFromUrl && !hasFiredViewedAnalyticsRef.current) {
            onViewed({
                query: '',
                suggestionSource: (0, $hCl9L.getSuggestionSource)(false),
                count: recentSearch.count()
            });
            hasFiredViewedAnalyticsRef.current = true;
        }
    }, [
        showSuggestionPopup,
        isQueryFromUrl,
        recentSearch,
        onViewed
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // HANDLE ANALYTICS FOR EXISTING QUERY
        if (showSuggestionPopup && isQueryFromUrl && !hasFiredViewedAnalyticsRef.current) {
            if ((bodyState === (0, $9AuiZ.BODY_STATES).SEARCH_RESULTS || bodyState === (0, $9AuiZ.BODY_STATES).NO_SUGGESTIONS) && autocompleteState.status === 'idle') {
                var _inputRef$current$val, _inputRef$current, _autocompleteState$co, _autocompleteState$co2, _autocompleteState$co3;
                onViewed({
                    query: (_inputRef$current$val = (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.value) !== null && _inputRef$current$val !== void 0 ? _inputRef$current$val : '',
                    suggestionSource: (0, $hCl9L.getSuggestionSource)(true),
                    count: (_autocompleteState$co = (_autocompleteState$co2 = autocompleteState.collections[0]) === null || _autocompleteState$co2 === void 0 ? void 0 : (_autocompleteState$co3 = _autocompleteState$co2.items) === null || _autocompleteState$co3 === void 0 ? void 0 : _autocompleteState$co3.length) !== null && _autocompleteState$co !== void 0 ? _autocompleteState$co : 0
                });
                hasFiredViewedAnalyticsRef.current = true;
            }
        }
    }, [
        showSuggestionPopup,
        bodyState
    ]);
};

});




parcelRegister("6sPuu", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b4d4c9dab44f60e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $hXNHP = parcelRequire("hXNHP");

var $j0gMm = parcelRequire("j0gMm");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $4b4d4c9dab44f60e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4b4d4c9dab44f60e$var$StandardTextSearchInnerStyles = (0, $3UXZ8.default)("div", {
    target: "e18yf3jw0",
    label: "StandardTextSearchInnerStyles"
})({
    name: "79elbk",
    styles: "position:relative;"
});
const $4b4d4c9dab44f60e$export$5a58787633b0b5d8 = (0, $3UXZ8.default)("input", {
    target: "e18yf3jw1",
    label: "SearchBox"
})("color:", (0, $j0gMm.N700), ";height:2.14285714em;text-indent:55px;font-size:32px;border:none;width:100%;&::-webkit-input-placeholder{color:", (0, $j0gMm.N100), ";}&::-moz-placeholder{color:", (0, $j0gMm.N100), ";}&:focus{outline:none;}");
const $4b4d4c9dab44f60e$var$SearchGlass = (0, $3UXZ8.default)("span", {
    target: "e18yf3jw2",
    label: "SearchGlass"
})("position:absolute;top:var(--ds-space-250, 20px);left:7px;pointer-events:none;color:", (0, $j0gMm.N100), ";");
const $4b4d4c9dab44f60e$var$HorizontalRule = (0, $3UXZ8.default)("hr", {
    target: "e18yf3jw3",
    label: "HorizontalRule"
})("color:", (0, $j0gMm.N100), ";display:block;height:1px;border:0;border-top:1px solid ", (0, $j0gMm.N50), ";margin-bottom:0.5em;margin-top:0.1em;padding:0;");
class $4b4d4c9dab44f60e$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "searchBox", void 0);
        (0, $5zQU9.default)(this, "onSubmit", (e)=>{
            e.preventDefault();
        });
        (0, $5zQU9.default)(this, "onChangeQuery", (_ref)=>{
            let { target: { value: value } } = _ref;
            this.props.onChangeQuery(value);
        });
    }
    componentDidMount() {
        window.addEventListener('load', ()=>this.searchBox.focus());
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($4b4d4c9dab44f60e$var$StandardTextSearchInnerStyles, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($4b4d4c9dab44f60e$export$5a58787633b0b5d8, {
                    className: "text",
                    ref: (input)=>this.searchBox = input,
                    type: "text",
                    placeholder: "Search for apps",
                    onChange: this.onChangeQuery,
                    value: this.props.query
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($4b4d4c9dab44f60e$var$SearchGlass, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hXNHP))), {
                        label: "Search",
                        size: "large"
                    })
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($4b4d4c9dab44f60e$var$HorizontalRule, {})
            ]
        });
    }
}

});


parcelRegister("7xU0G", function(module, exports) {

$parcel$export(module.exports, "default", () => $57e70fdefde53fab$export$2e2bcd8739ae039);

var $aDunJ = parcelRequire("aDunJ");
var $57e70fdefde53fab$export$2e2bcd8739ae039 = (0, $aDunJ.default);

});
parcelRegister("aDunJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be51d157c387125$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");
parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $6jEcw = parcelRequire("6jEcw");

var $8VJ2L = parcelRequire("8VJ2L");

var $g7tPp = parcelRequire("g7tPp");

var $lHkHI = parcelRequire("lHkHI");
function $7be51d157c387125$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7be51d157c387125$export$614264b7ca4804e6 = (0, $3UXZ8.default)("aside", {
    target: "eu8uy5q0",
    label: "SideBar"
})({
    name: "8atqhb",
    styles: "width:100%;"
});
const $7be51d157c387125$export$3ca6a01ec1fca3fe = (0, $3UXZ8.default)("div", {
    target: "eu8uy5q1",
    label: "ShowAppsForText"
})("color:", (0, $j0gMm.N300), ";font-size:14px;margin:var(--ds-space-100, 8px) var(--ds-space-200, 16px) var(--ds-space-025, 2px) var(--ds-space-400, 32px);");
function $7be51d157c387125$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $lHkHI.jsx)($7be51d157c387125$export$614264b7ca4804e6, {
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)("nav", {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($7be51d157c387125$export$3ca6a01ec1fca3fe, {
                    children: "Show apps for"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $g7tPp.default), {
                    facets: props.facets,
                    filters: props.filters,
                    filtersContext: props.filtersContext,
                    filtersLink: props.filtersLink,
                    hiddenFilters: props.hiddenFilters,
                    itemFactory: props.itemFactory,
                    perspective: props.perspective,
                    stateChangeRequested: props.stateChangeRequested
                })
            ]
        })
    });
}
$7be51d157c387125$export$2e2bcd8739ae039.propTypes = {
    facets: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
    filters: (0, $90ON9.default).filters,
    filtersContext: (0, $6jEcw.default).filtersContext,
    filtersLink: typeof (0, $8VJ2L.default),
    hiddenFilters: (0, $6jEcw.default).hiddenFilters.isRequired,
    itemFactory: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
};

});
parcelRegister("g7tPp", function(module, exports) {

$parcel$export(module.exports, "default", () => $03074c211ffd0bd0$export$2e2bcd8739ae039);

var $6REPi = parcelRequire("6REPi");
var $03074c211ffd0bd0$export$2e2bcd8739ae039 = (0, $6REPi.default);

});
parcelRegister("6REPi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ff75c943b32dc84$export$2e2bcd8739ae039);

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $9rIMC = parcelRequire("9rIMC");

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");
parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $isqrX = parcelRequire("isqrX");

var $5YKni = parcelRequire("5YKni");

var $6jEcw = parcelRequire("6jEcw");

var $bwZCP = parcelRequire("bwZCP");

var $lHkHI = parcelRequire("lHkHI");
function $4ff75c943b32dc84$export$2e2bcd8739ae039(props) {
    const facets = props.facets.filter((f)=>(0, $isqrX.shouldFacetBeShown)(f.get('key'), props.hiddenFilters));
    const forceFacetsExpanded = facets.size <= 2;
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const onFacetProductClick = (event, _ref)=>{
        let { facetKey: facetKey, facetValue: facetValue, selected: selected, newPerspective: newPerspective, newFilters: newFilters, selectedContent: selectedContent } = _ref;
        let source = props.perspective;
        if (facetKey === 'product' && newPerspective === 'discover') source = selectedContent + 'HomeScreen';
        fireAnalyticsEvent({
            eventType: (0, $gaiog.FilterClickedEvent),
            actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER),
            objectType: (0, $5YKni.OBJECT_TYPE_FILTER),
            objectId: facetKey,
            source: source,
            label: selectedContent,
            attributes: {
                sourceComponent: (0, $5YKni.EVENT_SOURCE),
                currentPerspective: props.perspective,
                filterValue: facetValue,
                selected: !selected
            }
        }, (0, $5YKni.EVENT_CHANNEL));
        (0, $9rIMC).maybeOpenInNewTab(event, ()=>{
            props.stateChangeRequested({
                perspective: newPerspective,
                filters: newFilters
            });
        });
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
        children: facets.map((facet)=>{
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bwZCP.default), {
                itemFactory: props.itemFactory,
                forceExpanded: forceFacetsExpanded,
                facet: facet,
                filters: props.filters,
                filtersContext: props.filtersContext,
                filtersLink: props.filtersLink,
                hiddenFilters: props.hiddenFilters,
                onFacetProductClick: onFacetProductClick,
                perspective: props.perspective,
                stateChangeRequested: props.stateChangeRequested
            }, "facet-".concat(facet.get('key')));
        })
    });
}
$4ff75c943b32dc84$export$2e2bcd8739ae039.propTypes = {
    facets: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
    filters: (0, $90ON9.default).filters,
    filtersContext: (0, $6jEcw.default).filtersContext,
    filtersLink: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    hiddenFilters: (0, $6jEcw.default).hiddenFilters.isRequired,
    itemFactory: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
};

});
parcelRegister("9rIMC", function(module, exports) {

$parcel$export(module.exports, "maybeOpenInNewTab", () => $6e095fb112aa4bef$export$f0d8de8635f8e7e9);
$parcel$export(module.exports, "setTargetForAllLinks", () => $6e095fb112aa4bef$export$c3bafcaa9fe2e252);
function $6e095fb112aa4bef$export$f0d8de8635f8e7e9(e, execWhenNotNewTabAction) {
    if (!e) execWhenNotNewTabAction();
    else if (!e.ctrlKey && !e.metaKey && !e.shiftKey && e.button !== 1) {
        e.preventDefault();
        execWhenNotNewTabAction();
    }
}
const $6e095fb112aa4bef$export$c3bafcaa9fe2e252 = (ele, target)=>{
    if (ele) {
        const links = [
            ...ele.getElementsByTagName('a')
        ];
        links.forEach((a)=>{
            a.setAttribute('target', target);
            if (target === '_blank') a.setAttribute('rel', 'noopener noreferrer');
        });
    }
};

});

parcelRegister("bwZCP", function(module, exports) {

$parcel$export(module.exports, "default", () => $86527c5f503f05e0$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $6jEcw = parcelRequire("6jEcw");

var $fw3UM = parcelRequire("fw3UM");

var $lOK7e = parcelRequire("lOK7e");

var $fUACZ = parcelRequire("fUACZ");

var $lHkHI = parcelRequire("lHkHI");
class $86527c5f503f05e0$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fw3UM.default), {
            ConjunctiveFacet: (0, $lOK7e.default),
            DisjunctiveFacet: (0, $fUACZ.default),
            facet: this.props.facet,
            facetType: this.props.facet.get('type'),
            filters: this.props.filters,
            filtersContext: this.props.filtersContext,
            filtersLink: this.props.filtersLink,
            forceExpanded: this.props.forceExpanded,
            hiddenFilters: this.props.hiddenFilters,
            itemFactory: this.props.itemFactory,
            onFacetProductClick: this.props.onFacetProductClick,
            perspective: this.props.perspective,
            stateChangeRequested: this.props.stateChangeRequested
        });
    }
}
(0, $5zQU9.default)($86527c5f503f05e0$export$2e2bcd8739ae039, "propTypes", {
    facet: (0, $6jEcw.default).processedFacet.isRequired,
    filters: (0, $90ON9.default).filters.isRequired,
    filtersContext: (0, $6jEcw.default).filtersContext,
    filtersLink: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    forceExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    hiddenFilters: (0, $6jEcw.default).hiddenFilters.isRequired,
    itemFactory: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    onFacetProductClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});

});
parcelRegister("fw3UM", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4bce19016c47527$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $lwEMm = parcelRequire("lwEMm");

var $lHkHI = parcelRequire("lHkHI");
const $b4bce19016c47527$var$_excluded = [
    "ConjunctiveFacet",
    "DisjunctiveFacet",
    "facetType"
];
function $b4bce19016c47527$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b4bce19016c47527$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b4bce19016c47527$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b4bce19016c47527$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $b4bce19016c47527$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const _this$props = this.props, { ConjunctiveFacet: ConjunctiveFacet, DisjunctiveFacet: DisjunctiveFacet, facetType: facetType } = _this$props, otherProps = (0, $bwPfh.default)(_this$props, $b4bce19016c47527$var$_excluded);
        switch(facetType){
            case 0, $lwEMm.DISJUNCTIVE_FACET_TYPE:
                return /*#__PURE__*/ (0, $lHkHI.jsx)(DisjunctiveFacet, $b4bce19016c47527$var$_objectSpread({}, otherProps));
            case 0, $lwEMm.CONJUNCTIVE_FACET_TYPE:
                return /*#__PURE__*/ (0, $lHkHI.jsx)(ConjunctiveFacet, $b4bce19016c47527$var$_objectSpread({}, otherProps));
            default:
                console.error("Invalid facet type '".concat(facetType, "'."));
        }
    }
}

});

parcelRegister("lOK7e", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe220a18387b703a$export$2e2bcd8739ae039);

var $fZ268 = parcelRequire("fZ268");
var $fe220a18387b703a$export$2e2bcd8739ae039 = (0, $fZ268.default);

});
parcelRegister("fZ268", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba2e2e1b2f904935$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $6jEcw = parcelRequire("6jEcw");

var $a040Q = parcelRequire("a040Q");

var $26qEF = parcelRequire("26qEF");

var $lHkHI = parcelRequire("lHkHI");
class $ba2e2e1b2f904935$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const FiltersLink = this.props.filtersLink;
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $a040Q.default), {
            facet: this.props.facet,
            facetProductComponentClass: (0, $26qEF.default),
            filters: this.props.filters,
            filtersContext: this.props.filtersContext,
            filtersLink: FiltersLink,
            forceExpanded: this.props.forceExpanded,
            hiddenFilters: this.props.hiddenFilters,
            itemFactory: this.props.itemFactory,
            onFacetProductClick: this.props.onFacetProductClick,
            perspective: this.props.perspective,
            stateChangeRequested: this.props.stateChangeRequested
        });
    }
}
(0, $5zQU9.default)($ba2e2e1b2f904935$export$2e2bcd8739ae039, "propTypes", {
    facet: (0, $6jEcw.default).processedFacet.isRequired,
    filters: (0, $90ON9.default).filters.isRequired,
    filtersContext: (0, $6jEcw.default).filtersContext,
    filtersLink: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    forceExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    hiddenFilters: (0, $6jEcw.default).hiddenFilters.isRequired,
    itemFactory: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    onFacetProductClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});
(0, $5zQU9.default)($ba2e2e1b2f904935$export$2e2bcd8739ae039, "defaultProps", {
    forceExpanded: false
});

});
parcelRegister("a040Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $747d044fab2a6caf$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $drftW = parcelRequire("drftW");

var $1VibC = parcelRequire("1VibC");

var $j0gMm = parcelRequire("j0gMm");

var $8gcXz = parcelRequire("8gcXz");

var $9osuT = parcelRequire("9osuT");

var $biTOe = parcelRequire("biTOe");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $hheqg = parcelRequire("hheqg");

var $fCICH = parcelRequire("fCICH");

var $isqrX = parcelRequire("isqrX");

var $5YKni = parcelRequire("5YKni");

var $aVhi9 = parcelRequire("aVhi9");

var $lHkHI = parcelRequire("lHkHI");
function $747d044fab2a6caf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $747d044fab2a6caf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $747d044fab2a6caf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $747d044fab2a6caf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $747d044fab2a6caf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $747d044fab2a6caf$var$FacetsSideBarContainer = (0, $3UXZ8.default)("div", {
    target: "e1cupn2u0",
    label: "FacetsSideBarContainer"
})({
    fontSize: '14px',
    margin: "var(--ds-space-150, 12px)".concat(" ", "var(--ds-space-600, 48px)", " ", "var(--ds-space-025, 2px)", " ", "var(--ds-space-400, 32px)"),
    background: (0, $j0gMm.N20),
    borderRadius: "var(--ds-border-radius-100, 3px)"
}, "");
function $747d044fab2a6caf$var$resolveExpanded(_ref) {
    let { currentlyExpanded: currentlyExpanded, facet: facet, forceExpanded: forceExpanded } = _ref;
    return currentlyExpanded || !!facet.get('openByDefault') || forceExpanded;
}
const $747d044fab2a6caf$export$153345471e2e4cca = (0, $3UXZ8.default)("div", {
    target: "e1cupn2u1",
    label: "FacetContainerHeading"
})((0, $8gcXz.h6Css), (props)=>({
        fontSize: '14px',
        margin: "var(--ds-space-200, 16px)".concat(" ", "var(--ds-space-200, 16px)", " ", "var(--ds-space-025, 2px)", " ", "var(--ds-space-400, 32px)"),
        display: 'flex',
        alignItems: 'center',
        cursor: props.collapsible ? 'pointer' : 'auto'
    }), "");
const $747d044fab2a6caf$export$5d4f0c1fceb4eb19 = (0, $3UXZ8.default)("ul", {
    target: "e1cupn2u2",
    label: "FacetContainerProductList"
})({
    name: "1iruc8t",
    styles: "list-style:none;margin:0;padding:0;"
});
const $747d044fab2a6caf$export$a7b06bfba60a8a78 = (0, $3UXZ8.default)("li", {
    target: "e1cupn2u3",
    label: "ListItem"
})({
    name: "1uk1gs8",
    styles: "margin:0;"
});
class $747d044fab2a6caf$var$FacetContainer extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            data: (0, $g5DHJ.Map)({
                expanded: $747d044fab2a6caf$var$resolveExpanded({
                    currentlyExpanded: false,
                    facet: this.props.facet,
                    forceExpanded: this.props.forceExpanded || (0, $isqrX.valuedFilters)(this.props.filters).has(this.props.facet.get('key'))
                })
            })
        });
        (0, $5zQU9.default)(this, "isSelectedValue", (facetProductValue)=>this.props.filters.get(this.props.facet.get('key')) === facetProductValue);
        (0, $5zQU9.default)(this, "createNewFilters", (facetProduct)=>this.props.filters.get(this.props.facet.get('key')) === facetProduct ? this.props.filters.delete(this.props.facet.get('key')) : this.props.filters.set(this.props.facet.get('key'), facetProduct));
        (0, $5zQU9.default)(this, "facetProductSelected", (selection)=>{
            this.props.onFacetProductClick(null, $747d044fab2a6caf$var$_objectSpread($747d044fab2a6caf$var$_objectSpread({}, selection.item), {}, {
                facetKey: this.props.facet.get('key')
            }));
        });
        (0, $5zQU9.default)(this, "toggleExpand", ()=>{
            this.setState((_ref2)=>{
                let { data: data } = _ref2;
                const expanded = !data.get('expanded');
                this.props.fireAnalyticsEvent({
                    eventType: expanded ? (0, $5YKni.FacetExpandedEvent) : (0, $5YKni.FacetCollapsedEvent),
                    actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_SIDEBAR_FACET),
                    objectType: (0, $5YKni.OBJECT_TYPE_FILTER),
                    objectId: this.props.facet.get('key'),
                    source: (0, $5YKni.EVENT_SOURCE),
                    attributes: {
                        currentPerspective: this.props.perspective
                    }
                }, (0, $5YKni.EVENT_CHANNEL));
                return {
                    data: data.set('expanded', expanded)
                };
            });
        });
    }
    static getDerivedStateFromProps(nextProps) {
        const { facet: facet, forceExpanded: forceExpanded } = nextProps;
        return (state)=>({
                data: state.data.update((data)=>data.set('expanded', $747d044fab2a6caf$var$resolveExpanded({
                        currentlyExpanded: data.get('expanded'),
                        facet: facet,
                        forceExpanded: forceExpanded
                    })))
            });
    }
    mapProductstoItem(facetProduct) {
        const value = facetProduct.get('value');
        const selected = this.isSelectedValue(value);
        return this.props.itemFactory({
            options: {
                content: "".concat(facetProduct.get('label')),
                selectedContent: facetProduct.get('label'),
                type: this.props.itemType,
                selected: selected,
                isChecked: selected,
                facetKey: this.props.facet.get('key'),
                facetValue: value
            },
            newFilters: this.createNewFilters(value)
        });
    }
    createProductsList(facetProducts) {
        const FacetProduct = this.props.facetProductComponentClass;
        const filtersForThisFacet = this.props.filters.get(this.props.facet.get('key'));
        const facetProductsSelected = (0, $g5DHJ.Iterable).isIterable(filtersForThisFacet) ? filtersForThisFacet : (0, $g5DHJ.Set)([
            filtersForThisFacet
        ]);
        return /*#__PURE__*/ (0, $lHkHI.jsx)($747d044fab2a6caf$export$5d4f0c1fceb4eb19, {
            className: "ui-product-list-".concat(this.props.facet.get('key')),
            children: this.getFilteredFacetProducts(facetProducts).map((fp)=>{
                const selected = facetProductsSelected.contains(fp.get('value'));
                return /*#__PURE__*/ (0, $lHkHI.jsx)($747d044fab2a6caf$export$a7b06bfba60a8a78, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)(FacetProduct, {
                        facet: this.props.facet,
                        filters: this.props.filters,
                        filtersContext: this.props.filtersContext,
                        filtersLink: this.props.filtersLink,
                        selected: selected,
                        facetProduct: fp,
                        perspective: this.props.perspective,
                        stateChangeRequested: this.props.stateChangeRequested
                    })
                }, "".concat(this.props.facet.get('key'), "-").concat(fp.get('value')));
            })
        });
    }
    renderMenuFacet() {
        const facetProducts = this.getSortedFacetProducts(this.props.facet);
        const primary = this.props.facet.get('primary');
        return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
            className: "ui-facet-container",
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsxs)($747d044fab2a6caf$export$153345471e2e4cca, {
                    className: "ui-facet-header-".concat(this.props.facet.get('key')),
                    collapsible: !primary,
                    onClick: !primary ? this.toggleExpand : undefined,
                    children: [
                        this.props.facet.get('sidebarLabel'),
                        !primary && (this.state.data.get('expanded') ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1VibC))), {
                            label: ""
                        }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($drftW))), {
                            label: ""
                        }))
                    ]
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hheqg.Collapse), {
                    isOpened: primary || this.state.data.get('expanded'),
                    children: this.createProductsList(facetProducts)
                })
            ]
        });
    }
    renderDropdownFacet() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)($747d044fab2a6caf$var$FacetsSideBarContainer, {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aVhi9.default), {
                closeOnItemSelected: true,
                facetBar: "side",
                facetKey: this.props.facet.get('key'),
                facetType: this.props.facet.get('type'),
                filters: this.props.filters,
                label: this.props.facet.get('sidebarLabel'),
                items: this.getItems(this.props.facet),
                perspective: this.props.perspective,
                shouldFitContainer: true,
                stateChangeRequested: this.props.stateChangeRequested,
                onItemActivated: this.facetProductSelected
            })
        });
    }
    getSortedFacetProducts(facet) {
        const sort = (0, $fCICH.getFilters)().get(facet.get('key')).get('sortFunction') || ((fps)=>fps);
        const sortedFacetProducts = sort(this.props.facet.get('facetProducts'), (0, $fCICH.sortingLogic).COUNT_AND_ALPHABETICAL);
        return sortedFacetProducts;
    }
    getFilteredFacetProducts(facetProducts) {
        return facetProducts.filter((fp)=>(0, $isqrX.shouldFacetProductBeShown)(this.props.facet.get('key'), fp.get('value'), this.props.hiddenFilters) && (0, $isqrX.shouldFreeStarterFacetProductBeShown)(fp.get('value'), this.props.enableFreeStarterTierFilter));
    }
    getItems(facet) {
        const sortedFacetProducts = this.getSortedFacetProducts(facet);
        const facetProducts = this.getFilteredFacetProducts(sortedFacetProducts).map((fp)=>this.mapProductstoItem(fp));
        return facetProducts;
    }
    render() {
        const facetProductsCount = this.props.facet.get('facetProducts').size;
        const useDropDownComponentForSidebar = this.props.facet.get('useDropDownComponentForSidebar');
        if (facetProductsCount && useDropDownComponentForSidebar) return this.renderDropdownFacet();
        return this.renderMenuFacet();
    }
}
(0, $5zQU9.default)($747d044fab2a6caf$var$FacetContainer, "defaultProps", {
    forceExpanded: false
});
var $747d044fab2a6caf$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)((0, $biTOe.withFeatureFlags)($747d044fab2a6caf$var$FacetContainer));

});
parcelRegister("1VibC", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $166938c27e914c41$var$_react = $166938c27e914c41$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $166938c27e914c41$var$_chevronUp = $166938c27e914c41$var$_interopRequireDefault((parcelRequire("eoAiF")));
function $166938c27e914c41$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $166938c27e914c41$var$ChevronUpIcon = (props)=>/*#__PURE__*/ $166938c27e914c41$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.221 9.322-2.929 2.955a1.01 1.01 0 0 0 0 1.419.986.986 0 0 0 1.405 0l2.298-2.317 2.307 2.327a.99.99 0 0 0 1.407 0 1.01 1.01 0 0 0 0-1.419l-2.94-2.965A1.1 1.1 0 0 0 11.991 9c-.279 0-.557.107-.77.322"/></svg>`
    }, props, {
        newIcon: $166938c27e914c41$var$_chevronUp.default,
        iconType: "utility"
    }));
$166938c27e914c41$var$ChevronUpIcon.displayName = 'ChevronUpIcon';
var $166938c27e914c41$var$_default = module.exports.default = $166938c27e914c41$var$ChevronUpIcon;

});

parcelRegister("hheqg", function(module, exports) {
'use strict';

var $g0tPF = parcelRequire("g0tPF");
var $c93f363954d15ab3$var$Collapse = $g0tPF.Collapse;

var $bob1S = parcelRequire("bob1S");
var $c93f363954d15ab3$var$UnmountClosed = $bob1S.UnmountClosed;
$c93f363954d15ab3$var$UnmountClosed.Collapse = $c93f363954d15ab3$var$Collapse;
$c93f363954d15ab3$var$UnmountClosed.UnmountClosed = $c93f363954d15ab3$var$UnmountClosed;
module.exports = $c93f363954d15ab3$var$UnmountClosed;

});
parcelRegister("g0tPF", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Collapse = undefined;
var $ba73c980bcbcb61f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $ba73c980bcbcb61f$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eUqFw = parcelRequire("eUqFw");
var $ba73c980bcbcb61f$var$_react2 = $ba73c980bcbcb61f$var$_interopRequireDefault($eUqFw);

var $1Qivz = parcelRequire("1Qivz");
var $ba73c980bcbcb61f$var$_propTypes2 = $ba73c980bcbcb61f$var$_interopRequireDefault($1Qivz);

var $4Ld00 = parcelRequire("4Ld00");
function $ba73c980bcbcb61f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ba73c980bcbcb61f$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $ba73c980bcbcb61f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $ba73c980bcbcb61f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $ba73c980bcbcb61f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $ba73c980bcbcb61f$var$SPRING_PRECISION = 1;
var $ba73c980bcbcb61f$var$WAITING = 'WAITING';
var $ba73c980bcbcb61f$var$RESIZING = 'RESIZING';
var $ba73c980bcbcb61f$var$RESTING = 'RESTING';
var $ba73c980bcbcb61f$var$IDLING = 'IDLING';
var $ba73c980bcbcb61f$var$noop = function noop() {
    return null;
};
var $ba73c980bcbcb61f$var$css = {
    collapse: 'ReactCollapse--collapse',
    content: 'ReactCollapse--content'
};
var $ba73c980bcbcb61f$var$Collapse = module.exports.Collapse = function(_React$PureComponent) {
    $ba73c980bcbcb61f$var$_inherits(Collapse, _React$PureComponent);
    function Collapse(props) {
        $ba73c980bcbcb61f$var$_classCallCheck(this, Collapse);
        var _this = $ba73c980bcbcb61f$var$_possibleConstructorReturn(this, (Collapse.__proto__ || Object.getPrototypeOf(Collapse)).call(this, props));
        $ba73c980bcbcb61f$var$_initialiseProps.call(_this);
        _this.state = {
            currentState: $ba73c980bcbcb61f$var$IDLING,
            from: 0,
            to: 0
        };
        return _this;
    }
    $ba73c980bcbcb61f$var$_createClass(Collapse, [
        {
            key: 'componentDidMount',
            value: function componentDidMount() {
                var _props = this.props, isOpened = _props.isOpened, forceInitialAnimation = _props.forceInitialAnimation, onRest = _props.onRest;
                if (isOpened) {
                    var to = this.getTo();
                    if (forceInitialAnimation) {
                        var from = this.wrapper.clientHeight;
                        this.setState({
                            currentState: $ba73c980bcbcb61f$var$RESIZING,
                            from: from,
                            to: to
                        });
                    } else this.setState({
                        currentState: $ba73c980bcbcb61f$var$IDLING,
                        from: to,
                        to: to
                    });
                }
                onRest();
            }
        },
        {
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (nextProps.hasNestedCollapse) // For nested collapses we do not need to change to waiting state
                // and should keep `height:auto`
                // Because children will be animated and height will not jump anyway
                // See https://github.com/nkbt/react-collapse/issues/76 for more details
                {
                    if (nextProps.isOpened !== this.props.isOpened) // Still go to WAITING state if own isOpened was changed
                    this.setState({
                        currentState: $ba73c980bcbcb61f$var$WAITING
                    });
                } else if (this.state.currentState === $ba73c980bcbcb61f$var$IDLING && (nextProps.isOpened || this.props.isOpened)) this.setState({
                    currentState: $ba73c980bcbcb61f$var$WAITING
                });
            }
        },
        {
            key: 'componentDidUpdate',
            value: function componentDidUpdate(_, prevState) {
                var _props2 = this.props, isOpened = _props2.isOpened, onRest = _props2.onRest, onMeasure = _props2.onMeasure;
                if (this.state.currentState === $ba73c980bcbcb61f$var$IDLING) {
                    onRest();
                    return;
                }
                if (prevState.to !== this.state.to) onMeasure({
                    height: this.state.to,
                    width: this.content.clientWidth
                });
                var from = this.wrapper.clientHeight;
                var to = isOpened ? this.getTo() : 0;
                if (from !== to) {
                    this.setState({
                        currentState: $ba73c980bcbcb61f$var$RESIZING,
                        from: from,
                        to: to
                    });
                    return;
                }
                if (this.state.currentState === $ba73c980bcbcb61f$var$RESTING || this.state.currentState === $ba73c980bcbcb61f$var$WAITING) this.setState({
                    currentState: $ba73c980bcbcb61f$var$IDLING,
                    from: from,
                    to: to
                });
            }
        },
        {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                cancelAnimationFrame(this.raf);
            }
        },
        {
            key: 'render',
            value: function render() {
                return $ba73c980bcbcb61f$var$_react2.default.createElement($4Ld00.Motion, $ba73c980bcbcb61f$var$_extends({}, this.getMotionProps(), {
                    onRest: this.onRest,
                    children: this.renderContent
                }));
            }
        }
    ]);
    return Collapse;
}($ba73c980bcbcb61f$var$_react2.default.PureComponent);
$ba73c980bcbcb61f$var$Collapse.propTypes = {
    isOpened: $ba73c980bcbcb61f$var$_propTypes2.default.bool.isRequired,
    springConfig: $ba73c980bcbcb61f$var$_propTypes2.default.objectOf($ba73c980bcbcb61f$var$_propTypes2.default.number),
    forceInitialAnimation: $ba73c980bcbcb61f$var$_propTypes2.default.bool,
    hasNestedCollapse: $ba73c980bcbcb61f$var$_propTypes2.default.bool,
    fixedHeight: $ba73c980bcbcb61f$var$_propTypes2.default.number,
    theme: $ba73c980bcbcb61f$var$_propTypes2.default.objectOf($ba73c980bcbcb61f$var$_propTypes2.default.string),
    style: $ba73c980bcbcb61f$var$_propTypes2.default.object,
    onRender: $ba73c980bcbcb61f$var$_propTypes2.default.func,
    onRest: $ba73c980bcbcb61f$var$_propTypes2.default.func,
    onMeasure: $ba73c980bcbcb61f$var$_propTypes2.default.func,
    children: $ba73c980bcbcb61f$var$_propTypes2.default.node.isRequired
};
$ba73c980bcbcb61f$var$Collapse.defaultProps = {
    forceInitialAnimation: false,
    hasNestedCollapse: false,
    fixedHeight: -1,
    style: {},
    theme: $ba73c980bcbcb61f$var$css,
    onRender: $ba73c980bcbcb61f$var$noop,
    onRest: $ba73c980bcbcb61f$var$noop,
    onMeasure: $ba73c980bcbcb61f$var$noop
};
var $ba73c980bcbcb61f$var$_initialiseProps = function _initialiseProps() {
    var _this2 = this;
    this.onContentRef = function(content) {
        _this2.content = content;
    };
    this.onWrapperRef = function(wrapper) {
        _this2.wrapper = wrapper;
    };
    this.onRest = function() {
        _this2.raf = requestAnimationFrame(_this2.setResting);
    };
    this.setResting = function() {
        _this2.setState({
            currentState: $ba73c980bcbcb61f$var$RESTING
        });
    };
    this.getTo = function() {
        var fixedHeight = _this2.props.fixedHeight;
        return fixedHeight > -1 ? fixedHeight : _this2.content.clientHeight;
    };
    this.getWrapperStyle = function(height) {
        if (_this2.state.currentState === $ba73c980bcbcb61f$var$IDLING && _this2.state.to) {
            var fixedHeight = _this2.props.fixedHeight;
            if (fixedHeight > -1) return {
                overflow: 'hidden',
                height: fixedHeight
            };
            return {
                height: 'auto'
            };
        }
        if (_this2.state.currentState === $ba73c980bcbcb61f$var$WAITING && !_this2.state.to) return {
            overflow: 'hidden',
            height: 0
        };
        return {
            overflow: 'hidden',
            height: Math.max(0, height)
        };
    };
    this.getMotionProps = function() {
        var springConfig = _this2.props.springConfig;
        return _this2.state.currentState === $ba73c980bcbcb61f$var$IDLING ? {
            // When completely stable, instantly jump to the position
            defaultStyle: {
                height: _this2.state.to
            },
            style: {
                height: _this2.state.to
            }
        } : {
            // Otherwise, animate
            defaultStyle: {
                height: _this2.state.from
            },
            style: {
                height: (0, $4Ld00.spring)(_this2.state.to, $ba73c980bcbcb61f$var$_extends({
                    precision: $ba73c980bcbcb61f$var$SPRING_PRECISION
                }, springConfig))
            }
        };
    };
    this.renderContent = function(_ref) {
        var height = _ref.height;
        // eslint-disable-line
        var _props3 = _this2.props, _isOpened = _props3.isOpened, _springConfig = _props3.springConfig, _forceInitialAnimation = _props3.forceInitialAnimation, _hasNestedCollapse = _props3.hasNestedCollapse, _fixedHeight = _props3.fixedHeight, theme = _props3.theme, style = _props3.style, onRender = _props3.onRender, _onRest = _props3.onRest, _onMeasure = _props3.onMeasure, children = _props3.children, props = $ba73c980bcbcb61f$var$_objectWithoutProperties(_props3, [
            'isOpened',
            'springConfig',
            'forceInitialAnimation',
            'hasNestedCollapse',
            'fixedHeight',
            'theme',
            'style',
            'onRender',
            'onRest',
            'onMeasure',
            'children'
        ]);
        var _state = _this2.state, from = _state.from, to = _state.to;
        // DANGEROUS, use with caution, never do setState with it
        onRender({
            current: height,
            from: from,
            to: to
        });
        return $ba73c980bcbcb61f$var$_react2.default.createElement('div', $ba73c980bcbcb61f$var$_extends({
            ref: _this2.onWrapperRef,
            className: theme.collapse,
            style: $ba73c980bcbcb61f$var$_extends({}, _this2.getWrapperStyle(Math.max(0, height)), style)
        }, props), $ba73c980bcbcb61f$var$_react2.default.createElement('div', {
            ref: _this2.onContentRef,
            className: theme.content
        }, children));
    };
};

});
parcelRegister("4Ld00", function(module, exports) {

$parcel$export(module.exports, "Motion", () => $3775a28fa0faf647$export$ab7b018719e111db, (v) => $3775a28fa0faf647$export$ab7b018719e111db = v);
$parcel$export(module.exports, "spring", () => $3775a28fa0faf647$export$b36281d89752ae66, (v) => $3775a28fa0faf647$export$b36281d89752ae66 = v);
var $3775a28fa0faf647$export$1e511d4a378977f5;
var $3775a28fa0faf647$export$ab7b018719e111db;
var $3775a28fa0faf647$export$8e2db863497d88e8;
var $3775a28fa0faf647$export$f55099f28d39dce4;
var $3775a28fa0faf647$export$b36281d89752ae66;
var $3775a28fa0faf647$export$7afd9c1079ecedf7;
var $3775a28fa0faf647$export$5d0a73a0957eccf0;
var $3775a28fa0faf647$export$e4c0b4e3a05535fb;
'use strict';
$3775a28fa0faf647$export$1e511d4a378977f5 = true;
function $3775a28fa0faf647$var$_interopRequire(obj) {
    return obj && obj.__esModule ? obj['default'] : obj;
}

var $aM8Hi = parcelRequire("aM8Hi");
$3775a28fa0faf647$export$ab7b018719e111db = $3775a28fa0faf647$var$_interopRequire($aM8Hi);

var $jNHy5 = parcelRequire("jNHy5");
$3775a28fa0faf647$export$8e2db863497d88e8 = $3775a28fa0faf647$var$_interopRequire($jNHy5);

var $bl73G = parcelRequire("bl73G");
$3775a28fa0faf647$export$f55099f28d39dce4 = $3775a28fa0faf647$var$_interopRequire($bl73G);

var $4R87Z = parcelRequire("4R87Z");
$3775a28fa0faf647$export$b36281d89752ae66 = $3775a28fa0faf647$var$_interopRequire($4R87Z);

var $573iS = parcelRequire("573iS");
$3775a28fa0faf647$export$7afd9c1079ecedf7 = $3775a28fa0faf647$var$_interopRequire($573iS);

var $5L0Ck = parcelRequire("5L0Ck");
$3775a28fa0faf647$export$5d0a73a0957eccf0 = $3775a28fa0faf647$var$_interopRequire($5L0Ck);

var $7HUoU = parcelRequire("7HUoU");
$3775a28fa0faf647$export$e4c0b4e3a05535fb = $3775a28fa0faf647$var$_interopRequire($7HUoU);

});
parcelRegister("aM8Hi", function(module, exports) {
'use strict';
module.exports.__esModule = true;
var $7d85222a7417a201$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $7d85222a7417a201$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $7d85222a7417a201$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $7d85222a7417a201$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}
function $7d85222a7417a201$var$_inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $4mifw = parcelRequire("4mifw");
var $7d85222a7417a201$var$_mapToZero2 = $7d85222a7417a201$var$_interopRequireDefault($4mifw);

var $5L0Ck = parcelRequire("5L0Ck");
var $7d85222a7417a201$var$_stripStyle2 = $7d85222a7417a201$var$_interopRequireDefault($5L0Ck);

var $fOvMG = parcelRequire("fOvMG");
var $7d85222a7417a201$var$_stepper4 = $7d85222a7417a201$var$_interopRequireDefault($fOvMG);

var $3IPh5 = parcelRequire("3IPh5");
var $7d85222a7417a201$var$_performanceNow2 = $7d85222a7417a201$var$_interopRequireDefault($3IPh5);

var $le4ma = parcelRequire("le4ma");
var $7d85222a7417a201$var$_raf2 = $7d85222a7417a201$var$_interopRequireDefault($le4ma);

var $dqh1o = parcelRequire("dqh1o");
var $7d85222a7417a201$var$_shouldStopAnimation2 = $7d85222a7417a201$var$_interopRequireDefault($dqh1o);

var $eUqFw = parcelRequire("eUqFw");
var $7d85222a7417a201$var$_react2 = $7d85222a7417a201$var$_interopRequireDefault($eUqFw);

var $1Qivz = parcelRequire("1Qivz");
var $7d85222a7417a201$var$_propTypes2 = $7d85222a7417a201$var$_interopRequireDefault($1Qivz);
var $7d85222a7417a201$var$msPerFrame = 1000 / 60;
var $7d85222a7417a201$var$Motion = function(_React$Component) {
    $7d85222a7417a201$var$_inherits(Motion, _React$Component);
    $7d85222a7417a201$var$_createClass(Motion, null, [
        {
            key: 'propTypes',
            value: {
                // TOOD: warn against putting a config in here
                defaultStyle: $7d85222a7417a201$var$_propTypes2['default'].objectOf($7d85222a7417a201$var$_propTypes2['default'].number),
                style: $7d85222a7417a201$var$_propTypes2['default'].objectOf($7d85222a7417a201$var$_propTypes2['default'].oneOfType([
                    $7d85222a7417a201$var$_propTypes2['default'].number,
                    $7d85222a7417a201$var$_propTypes2['default'].object
                ])).isRequired,
                children: $7d85222a7417a201$var$_propTypes2['default'].func.isRequired,
                onRest: $7d85222a7417a201$var$_propTypes2['default'].func
            },
            enumerable: true
        }
    ]);
    function Motion(props) {
        var _this = this;
        $7d85222a7417a201$var$_classCallCheck(this, Motion);
        _React$Component.call(this, props);
        this.wasAnimating = false;
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyle = null;
        this.clearUnreadPropStyle = function(destStyle) {
            var dirty = false;
            var _state = _this.state;
            var currentStyle = _state.currentStyle;
            var currentVelocity = _state.currentVelocity;
            var lastIdealStyle = _state.lastIdealStyle;
            var lastIdealVelocity = _state.lastIdealVelocity;
            for(var key in destStyle){
                if (!Object.prototype.hasOwnProperty.call(destStyle, key)) continue;
                var styleValue = destStyle[key];
                if (typeof styleValue === 'number') {
                    if (!dirty) {
                        dirty = true;
                        currentStyle = $7d85222a7417a201$var$_extends({}, currentStyle);
                        currentVelocity = $7d85222a7417a201$var$_extends({}, currentVelocity);
                        lastIdealStyle = $7d85222a7417a201$var$_extends({}, lastIdealStyle);
                        lastIdealVelocity = $7d85222a7417a201$var$_extends({}, lastIdealVelocity);
                    }
                    currentStyle[key] = styleValue;
                    currentVelocity[key] = 0;
                    lastIdealStyle[key] = styleValue;
                    lastIdealVelocity[key] = 0;
                }
            }
            if (dirty) _this.setState({
                currentStyle: currentStyle,
                currentVelocity: currentVelocity,
                lastIdealStyle: lastIdealStyle,
                lastIdealVelocity: lastIdealVelocity
            });
        };
        this.startAnimationIfNecessary = function() {
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $7d85222a7417a201$var$_raf2['default'](function(timestamp) {
                // check if we need to animate in the first place
                var propsStyle = _this.props.style;
                if ($7d85222a7417a201$var$_shouldStopAnimation2['default'](_this.state.currentStyle, propsStyle, _this.state.currentVelocity)) {
                    if (_this.wasAnimating && _this.props.onRest) _this.props.onRest();
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.wasAnimating = false;
                    _this.accumulatedTime = 0;
                    return;
                }
                _this.wasAnimating = true;
                var currentTime = timestamp || $7d85222a7417a201$var$_performanceNow2['default']();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $7d85222a7417a201$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $7d85222a7417a201$var$msPerFrame) * $7d85222a7417a201$var$msPerFrame) / $7d85222a7417a201$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $7d85222a7417a201$var$msPerFrame);
                var newLastIdealStyle = {};
                var newLastIdealVelocity = {};
                var newCurrentStyle = {};
                var newCurrentVelocity = {};
                for(var key in propsStyle){
                    if (!Object.prototype.hasOwnProperty.call(propsStyle, key)) continue;
                    var styleValue = propsStyle[key];
                    if (typeof styleValue === 'number') {
                        newCurrentStyle[key] = styleValue;
                        newCurrentVelocity[key] = 0;
                        newLastIdealStyle[key] = styleValue;
                        newLastIdealVelocity[key] = 0;
                    } else {
                        var newLastIdealStyleValue = _this.state.lastIdealStyle[key];
                        var newLastIdealVelocityValue = _this.state.lastIdealVelocity[key];
                        for(var i = 0; i < framesToCatchUp; i++){
                            var _stepper = $7d85222a7417a201$var$_stepper4['default']($7d85222a7417a201$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            newLastIdealStyleValue = _stepper[0];
                            newLastIdealVelocityValue = _stepper[1];
                        }
                        var _stepper2 = $7d85222a7417a201$var$_stepper4['default']($7d85222a7417a201$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                        var nextIdealX = _stepper2[0];
                        var nextIdealV = _stepper2[1];
                        newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                        newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                        newLastIdealStyle[key] = newLastIdealStyleValue;
                        newLastIdealVelocity[key] = newLastIdealVelocityValue;
                    }
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $7d85222a7417a201$var$msPerFrame;
                _this.setState({
                    currentStyle: newCurrentStyle,
                    currentVelocity: newCurrentVelocity,
                    lastIdealStyle: newLastIdealStyle,
                    lastIdealVelocity: newLastIdealVelocity
                });
                _this.unreadPropStyle = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    Motion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyle = _props.defaultStyle;
        var style = _props.style;
        var currentStyle = defaultStyle || $7d85222a7417a201$var$_stripStyle2['default'](style);
        var currentVelocity = $7d85222a7417a201$var$_mapToZero2['default'](currentStyle);
        return {
            currentStyle: currentStyle,
            currentVelocity: currentVelocity,
            lastIdealStyle: currentStyle,
            lastIdealVelocity: currentVelocity
        };
    };
    // it's possible that currentStyle's value is stale: if props is immediately
    // changed from 0 to 400 to spring(0) again, the async currentStyle is still
    // at 0 (didn't have time to tick and interpolate even once). If we naively
    // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
    // In reality currentStyle should be 400
    Motion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $7d85222a7417a201$var$_performanceNow2['default']();
        this.startAnimationIfNecessary();
    };
    Motion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyle != null) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyle);
        this.unreadPropStyle = props.style;
        if (this.animationID == null) {
            this.prevTime = $7d85222a7417a201$var$_performanceNow2['default']();
            this.startAnimationIfNecessary();
        }
    };
    Motion.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.animationID != null) {
            $7d85222a7417a201$var$_raf2['default'].cancel(this.animationID);
            this.animationID = null;
        }
    };
    Motion.prototype.render = function render() {
        var renderedChildren = this.props.children(this.state.currentStyle);
        return renderedChildren && $7d85222a7417a201$var$_react2['default'].Children.only(renderedChildren);
    };
    return Motion;
}($7d85222a7417a201$var$_react2['default'].Component);
module.exports['default'] = $7d85222a7417a201$var$Motion;
module.exports = module.exports['default']; // after checking for unreadPropStyle != null, we manually go set the
 // non-interpolating values (those that are a number, without a spring
 // config)

});
parcelRegister("4mifw", function(module, exports) {
// currently used to initiate the velocity style object to 0
'use strict';
module.exports.__esModule = true;
module.exports['default'] = $32c75f6be65110d5$var$mapToZero;
function $32c75f6be65110d5$var$mapToZero(obj) {
    var ret = {};
    for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) ret[key] = 0;
    return ret;
}
module.exports = module.exports['default'];

});

parcelRegister("5L0Ck", function(module, exports) {
// turn {x: {val: 1, stiffness: 1, damping: 2}, y: 2} generated by
// `{x: spring(1, {stiffness: 1, damping: 2}), y: 2}` into {x: 1, y: 2}
'use strict';
module.exports.__esModule = true;
module.exports['default'] = $4311d21bd5243163$var$stripStyle;
function $4311d21bd5243163$var$stripStyle(style) {
    var ret = {};
    for(var key in style){
        if (!Object.prototype.hasOwnProperty.call(style, key)) continue;
        ret[key] = typeof style[key] === 'number' ? style[key] : style[key].val;
    }
    return ret;
}
module.exports = module.exports['default'];

});

parcelRegister("fOvMG", function(module, exports) {
// stepper is used a lot. Saves allocation to return the same array wrapper.
// This is fine and danger-free against mutations because the callsite
// immediately destructures it and gets the numbers inside without passing the
"use strict";
module.exports.__esModule = true;
module.exports["default"] = $b8342e37f2676cf5$var$stepper;
var $b8342e37f2676cf5$var$reusedTuple = [
    0,
    0
];
function $b8342e37f2676cf5$var$stepper(secondPerFrame, x, v, destX, k, b, precision) {
    // Spring stiffness, in kg / s^2
    // for animations, destX is really spring length (spring at rest). initial
    // position is considered as the stretched/compressed position of a spring
    var Fspring = -k * (x - destX);
    // Damping, in kg / s
    var Fdamper = -b * v;
    // usually we put mass here, but for animation purposes, specifying mass is a
    // bit redundant. you could simply adjust k and b accordingly
    // let a = (Fspring + Fdamper) / mass;
    var a = Fspring + Fdamper;
    var newV = v + a * secondPerFrame;
    var newX = x + newV * secondPerFrame;
    if (Math.abs(newV) < precision && Math.abs(newX - destX) < precision) {
        $b8342e37f2676cf5$var$reusedTuple[0] = destX;
        $b8342e37f2676cf5$var$reusedTuple[1] = 0;
        return $b8342e37f2676cf5$var$reusedTuple;
    }
    $b8342e37f2676cf5$var$reusedTuple[0] = newX;
    $b8342e37f2676cf5$var$reusedTuple[1] = newV;
    return $b8342e37f2676cf5$var$reusedTuple;
}
module.exports = module.exports["default"]; // array reference around.

});

parcelRegister("3IPh5", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
// Generated by CoffeeScript 1.7.1
(function() {
    var getNanoSeconds, hrtime, loadTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (typeof $2fFJv !== "undefined" && $2fFJv !== null && $2fFJv.hrtime) {
        module.exports = function() {
            return (getNanoSeconds() - loadTime) / 1e6;
        };
        hrtime = $2fFJv.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        loadTime = getNanoSeconds();
    } else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(module.exports);

});

parcelRegister("le4ma", function(module, exports) {

var $fKI31 = parcelRequire("fKI31");
var $f73e48e49de1bdfb$var$root = typeof window === 'undefined' ? $parcel$global : window, $f73e48e49de1bdfb$var$vendors = [
    'moz',
    'webkit'
], $f73e48e49de1bdfb$var$suffix = 'AnimationFrame', $f73e48e49de1bdfb$var$raf = $f73e48e49de1bdfb$var$root['request' + $f73e48e49de1bdfb$var$suffix], $f73e48e49de1bdfb$var$caf = $f73e48e49de1bdfb$var$root['cancel' + $f73e48e49de1bdfb$var$suffix] || $f73e48e49de1bdfb$var$root['cancelRequest' + $f73e48e49de1bdfb$var$suffix];
for(var $f73e48e49de1bdfb$var$i = 0; !$f73e48e49de1bdfb$var$raf && $f73e48e49de1bdfb$var$i < $f73e48e49de1bdfb$var$vendors.length; $f73e48e49de1bdfb$var$i++){
    $f73e48e49de1bdfb$var$raf = $f73e48e49de1bdfb$var$root[$f73e48e49de1bdfb$var$vendors[$f73e48e49de1bdfb$var$i] + 'Request' + $f73e48e49de1bdfb$var$suffix];
    $f73e48e49de1bdfb$var$caf = $f73e48e49de1bdfb$var$root[$f73e48e49de1bdfb$var$vendors[$f73e48e49de1bdfb$var$i] + 'Cancel' + $f73e48e49de1bdfb$var$suffix] || $f73e48e49de1bdfb$var$root[$f73e48e49de1bdfb$var$vendors[$f73e48e49de1bdfb$var$i] + 'CancelRequest' + $f73e48e49de1bdfb$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$f73e48e49de1bdfb$var$raf || !$f73e48e49de1bdfb$var$caf) {
    var $f73e48e49de1bdfb$var$last = 0, $f73e48e49de1bdfb$var$id = 0, $f73e48e49de1bdfb$var$queue = [], $f73e48e49de1bdfb$var$frameDuration = 1000 / 60;
    $f73e48e49de1bdfb$var$raf = function(callback) {
        if ($f73e48e49de1bdfb$var$queue.length === 0) {
            var _now = $fKI31(), next = Math.max(0, $f73e48e49de1bdfb$var$frameDuration - (_now - $f73e48e49de1bdfb$var$last));
            $f73e48e49de1bdfb$var$last = next + _now;
            setTimeout(function() {
                var cp = $f73e48e49de1bdfb$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $f73e48e49de1bdfb$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($f73e48e49de1bdfb$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $f73e48e49de1bdfb$var$queue.push({
            handle: ++$f73e48e49de1bdfb$var$id,
            callback: callback,
            cancelled: false
        });
        return $f73e48e49de1bdfb$var$id;
    };
    $f73e48e49de1bdfb$var$caf = function(handle) {
        for(var i = 0; i < $f73e48e49de1bdfb$var$queue.length; i++)if ($f73e48e49de1bdfb$var$queue[i].handle === handle) $f73e48e49de1bdfb$var$queue[i].cancelled = true;
    };
}
module.exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $f73e48e49de1bdfb$var$raf.call($f73e48e49de1bdfb$var$root, fn);
};
module.exports.cancel = function() {
    $f73e48e49de1bdfb$var$caf.apply($f73e48e49de1bdfb$var$root, arguments);
};
module.exports.polyfill = function(object) {
    if (!object) object = $f73e48e49de1bdfb$var$root;
    object.requestAnimationFrame = $f73e48e49de1bdfb$var$raf;
    object.cancelAnimationFrame = $f73e48e49de1bdfb$var$caf;
};

});
parcelRegister("fKI31", function(module, exports) {

var $2fFJv = parcelRequire("2fFJv");
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) module.exports = function() {
        return performance.now();
    };
    else if (typeof $2fFJv !== "undefined" && $2fFJv !== null && $2fFJv.hrtime) {
        module.exports = function() {
            return (getNanoSeconds() - nodeLoadTime) / 1e6;
        };
        hrtime = $2fFJv.hrtime;
        getNanoSeconds = function() {
            var hr;
            hr = hrtime();
            return hr[0] * 1e9 + hr[1];
        };
        moduleLoadTime = getNanoSeconds();
        upTime = $2fFJv.uptime() * 1e9;
        nodeLoadTime = moduleLoadTime - upTime;
    } else if (Date.now) {
        module.exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        module.exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call(module.exports);

});


parcelRegister("dqh1o", function(module, exports) {
// usage assumption: currentStyle values have already been rendered but it says
// nothing of whether currentStyle is stale (see unreadPropStyle)
'use strict';
module.exports.__esModule = true;
module.exports['default'] = $9c5ae82eda828740$var$shouldStopAnimation;
function $9c5ae82eda828740$var$shouldStopAnimation(currentStyle, style, currentVelocity) {
    for(var key in style){
        if (!Object.prototype.hasOwnProperty.call(style, key)) continue;
        if (currentVelocity[key] !== 0) return false;
        var styleValue = typeof style[key] === 'number' ? style[key] : style[key].val;
        // stepper will have already taken care of rounding precision errors, so
        // won't have such thing as 0.9999 !=== 1
        if (currentStyle[key] !== styleValue) return false;
    }
    return true;
}
module.exports = module.exports['default'];

});


parcelRegister("jNHy5", function(module, exports) {
'use strict';
module.exports.__esModule = true;
var $e6a45fd2cb604795$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $e6a45fd2cb604795$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $e6a45fd2cb604795$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $e6a45fd2cb604795$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}
function $e6a45fd2cb604795$var$_inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $4mifw = parcelRequire("4mifw");
var $e6a45fd2cb604795$var$_mapToZero2 = $e6a45fd2cb604795$var$_interopRequireDefault($4mifw);

var $5L0Ck = parcelRequire("5L0Ck");
var $e6a45fd2cb604795$var$_stripStyle2 = $e6a45fd2cb604795$var$_interopRequireDefault($5L0Ck);

var $fOvMG = parcelRequire("fOvMG");
var $e6a45fd2cb604795$var$_stepper4 = $e6a45fd2cb604795$var$_interopRequireDefault($fOvMG);

var $3IPh5 = parcelRequire("3IPh5");
var $e6a45fd2cb604795$var$_performanceNow2 = $e6a45fd2cb604795$var$_interopRequireDefault($3IPh5);

var $le4ma = parcelRequire("le4ma");
var $e6a45fd2cb604795$var$_raf2 = $e6a45fd2cb604795$var$_interopRequireDefault($le4ma);

var $dqh1o = parcelRequire("dqh1o");
var $e6a45fd2cb604795$var$_shouldStopAnimation2 = $e6a45fd2cb604795$var$_interopRequireDefault($dqh1o);

var $eUqFw = parcelRequire("eUqFw");
var $e6a45fd2cb604795$var$_react2 = $e6a45fd2cb604795$var$_interopRequireDefault($eUqFw);

var $1Qivz = parcelRequire("1Qivz");
var $e6a45fd2cb604795$var$_propTypes2 = $e6a45fd2cb604795$var$_interopRequireDefault($1Qivz);
var $e6a45fd2cb604795$var$msPerFrame = 1000 / 60;
function $e6a45fd2cb604795$var$shouldStopAnimationAll(currentStyles, styles, currentVelocities) {
    for(var i = 0; i < currentStyles.length; i++){
        if (!$e6a45fd2cb604795$var$_shouldStopAnimation2['default'](currentStyles[i], styles[i], currentVelocities[i])) return false;
    }
    return true;
}
var $e6a45fd2cb604795$var$StaggeredMotion = function(_React$Component) {
    $e6a45fd2cb604795$var$_inherits(StaggeredMotion, _React$Component);
    $e6a45fd2cb604795$var$_createClass(StaggeredMotion, null, [
        {
            key: 'propTypes',
            value: {
                // TOOD: warn against putting a config in here
                defaultStyles: $e6a45fd2cb604795$var$_propTypes2['default'].arrayOf($e6a45fd2cb604795$var$_propTypes2['default'].objectOf($e6a45fd2cb604795$var$_propTypes2['default'].number)),
                styles: $e6a45fd2cb604795$var$_propTypes2['default'].func.isRequired,
                children: $e6a45fd2cb604795$var$_propTypes2['default'].func.isRequired
            },
            enumerable: true
        }
    ]);
    function StaggeredMotion(props) {
        var _this = this;
        $e6a45fd2cb604795$var$_classCallCheck(this, StaggeredMotion);
        _React$Component.call(this, props);
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyles = null;
        this.clearUnreadPropStyle = function(unreadPropStyles) {
            var _state = _this.state;
            var currentStyles = _state.currentStyles;
            var currentVelocities = _state.currentVelocities;
            var lastIdealStyles = _state.lastIdealStyles;
            var lastIdealVelocities = _state.lastIdealVelocities;
            var someDirty = false;
            for(var i = 0; i < unreadPropStyles.length; i++){
                var unreadPropStyle = unreadPropStyles[i];
                var dirty = false;
                for(var key in unreadPropStyle){
                    if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) continue;
                    var styleValue = unreadPropStyle[key];
                    if (typeof styleValue === 'number') {
                        if (!dirty) {
                            dirty = true;
                            someDirty = true;
                            currentStyles[i] = $e6a45fd2cb604795$var$_extends({}, currentStyles[i]);
                            currentVelocities[i] = $e6a45fd2cb604795$var$_extends({}, currentVelocities[i]);
                            lastIdealStyles[i] = $e6a45fd2cb604795$var$_extends({}, lastIdealStyles[i]);
                            lastIdealVelocities[i] = $e6a45fd2cb604795$var$_extends({}, lastIdealVelocities[i]);
                        }
                        currentStyles[i][key] = styleValue;
                        currentVelocities[i][key] = 0;
                        lastIdealStyles[i][key] = styleValue;
                        lastIdealVelocities[i][key] = 0;
                    }
                }
            }
            if (someDirty) _this.setState({
                currentStyles: currentStyles,
                currentVelocities: currentVelocities,
                lastIdealStyles: lastIdealStyles,
                lastIdealVelocities: lastIdealVelocities
            });
        };
        this.startAnimationIfNecessary = function() {
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $e6a45fd2cb604795$var$_raf2['default'](function(timestamp) {
                var destStyles = _this.props.styles(_this.state.lastIdealStyles);
                // check if we need to animate in the first place
                if ($e6a45fd2cb604795$var$shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities)) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.accumulatedTime = 0;
                    return;
                }
                var currentTime = timestamp || $e6a45fd2cb604795$var$_performanceNow2['default']();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $e6a45fd2cb604795$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $e6a45fd2cb604795$var$msPerFrame) * $e6a45fd2cb604795$var$msPerFrame) / $e6a45fd2cb604795$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $e6a45fd2cb604795$var$msPerFrame);
                var newLastIdealStyles = [];
                var newLastIdealVelocities = [];
                var newCurrentStyles = [];
                var newCurrentVelocities = [];
                for(var i = 0; i < destStyles.length; i++){
                    var destStyle = destStyles[i];
                    var newCurrentStyle = {};
                    var newCurrentVelocity = {};
                    var newLastIdealStyle = {};
                    var newLastIdealVelocity = {};
                    for(var key in destStyle){
                        if (!Object.prototype.hasOwnProperty.call(destStyle, key)) continue;
                        var styleValue = destStyle[key];
                        if (typeof styleValue === 'number') {
                            newCurrentStyle[key] = styleValue;
                            newCurrentVelocity[key] = 0;
                            newLastIdealStyle[key] = styleValue;
                            newLastIdealVelocity[key] = 0;
                        } else {
                            var newLastIdealStyleValue = _this.state.lastIdealStyles[i][key];
                            var newLastIdealVelocityValue = _this.state.lastIdealVelocities[i][key];
                            for(var j = 0; j < framesToCatchUp; j++){
                                var _stepper = $e6a45fd2cb604795$var$_stepper4['default']($e6a45fd2cb604795$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                                newLastIdealStyleValue = _stepper[0];
                                newLastIdealVelocityValue = _stepper[1];
                            }
                            var _stepper2 = $e6a45fd2cb604795$var$_stepper4['default']($e6a45fd2cb604795$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            var nextIdealX = _stepper2[0];
                            var nextIdealV = _stepper2[1];
                            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                            newLastIdealStyle[key] = newLastIdealStyleValue;
                            newLastIdealVelocity[key] = newLastIdealVelocityValue;
                        }
                    }
                    newCurrentStyles[i] = newCurrentStyle;
                    newCurrentVelocities[i] = newCurrentVelocity;
                    newLastIdealStyles[i] = newLastIdealStyle;
                    newLastIdealVelocities[i] = newLastIdealVelocity;
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $e6a45fd2cb604795$var$msPerFrame;
                _this.setState({
                    currentStyles: newCurrentStyles,
                    currentVelocities: newCurrentVelocities,
                    lastIdealStyles: newLastIdealStyles,
                    lastIdealVelocities: newLastIdealVelocities
                });
                _this.unreadPropStyles = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    StaggeredMotion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyles = _props.defaultStyles;
        var styles = _props.styles;
        var currentStyles = defaultStyles || styles().map($e6a45fd2cb604795$var$_stripStyle2['default']);
        var currentVelocities = currentStyles.map(function(currentStyle) {
            return $e6a45fd2cb604795$var$_mapToZero2['default'](currentStyle);
        });
        return {
            currentStyles: currentStyles,
            currentVelocities: currentVelocities,
            lastIdealStyles: currentStyles,
            lastIdealVelocities: currentVelocities
        };
    };
    StaggeredMotion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $e6a45fd2cb604795$var$_performanceNow2['default']();
        this.startAnimationIfNecessary();
    };
    StaggeredMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyles != null) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyles);
        this.unreadPropStyles = props.styles(this.state.lastIdealStyles);
        if (this.animationID == null) {
            this.prevTime = $e6a45fd2cb604795$var$_performanceNow2['default']();
            this.startAnimationIfNecessary();
        }
    };
    StaggeredMotion.prototype.componentWillUnmount = function componentWillUnmount() {
        if (this.animationID != null) {
            $e6a45fd2cb604795$var$_raf2['default'].cancel(this.animationID);
            this.animationID = null;
        }
    };
    StaggeredMotion.prototype.render = function render() {
        var renderedChildren = this.props.children(this.state.currentStyles);
        return renderedChildren && $e6a45fd2cb604795$var$_react2['default'].Children.only(renderedChildren);
    };
    return StaggeredMotion;
}($e6a45fd2cb604795$var$_react2['default'].Component);
module.exports['default'] = $e6a45fd2cb604795$var$StaggeredMotion;
module.exports = module.exports['default']; // it's possible that currentStyle's value is stale: if props is immediately
 // changed from 0 to 400 to spring(0) again, the async currentStyle is still
 // at 0 (didn't have time to tick and interpolate even once). If we naively
 // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
 // In reality currentStyle should be 400
 // after checking for unreadPropStyles != null, we manually go set the
 // non-interpolating values (those that are a number, without a spring
 // config)

});

parcelRegister("bl73G", function(module, exports) {
'use strict';
module.exports.__esModule = true;
var $8417218d9b0c379b$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $8417218d9b0c379b$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ('value' in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();
function $8417218d9b0c379b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}
function $8417218d9b0c379b$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}
function $8417218d9b0c379b$var$_inherits(subClass, superClass) {
    if (typeof superClass !== 'function' && superClass !== null) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var $4mifw = parcelRequire("4mifw");
var $8417218d9b0c379b$var$_mapToZero2 = $8417218d9b0c379b$var$_interopRequireDefault($4mifw);

var $5L0Ck = parcelRequire("5L0Ck");
var $8417218d9b0c379b$var$_stripStyle2 = $8417218d9b0c379b$var$_interopRequireDefault($5L0Ck);

var $fOvMG = parcelRequire("fOvMG");
var $8417218d9b0c379b$var$_stepper4 = $8417218d9b0c379b$var$_interopRequireDefault($fOvMG);

var $2nrbB = parcelRequire("2nrbB");
var $8417218d9b0c379b$var$_mergeDiff2 = $8417218d9b0c379b$var$_interopRequireDefault($2nrbB);

var $3IPh5 = parcelRequire("3IPh5");
var $8417218d9b0c379b$var$_performanceNow2 = $8417218d9b0c379b$var$_interopRequireDefault($3IPh5);

var $le4ma = parcelRequire("le4ma");
var $8417218d9b0c379b$var$_raf2 = $8417218d9b0c379b$var$_interopRequireDefault($le4ma);

var $dqh1o = parcelRequire("dqh1o");
var $8417218d9b0c379b$var$_shouldStopAnimation2 = $8417218d9b0c379b$var$_interopRequireDefault($dqh1o);

var $eUqFw = parcelRequire("eUqFw");
var $8417218d9b0c379b$var$_react2 = $8417218d9b0c379b$var$_interopRequireDefault($eUqFw);

var $1Qivz = parcelRequire("1Qivz");
var $8417218d9b0c379b$var$_propTypes2 = $8417218d9b0c379b$var$_interopRequireDefault($1Qivz);
var $8417218d9b0c379b$var$msPerFrame = 1000 / 60;
// the children function & (potential) styles function asks as param an
// Array<TransitionPlainStyle>, where each TransitionPlainStyle is of the format
// {key: string, data?: any, style: PlainStyle}. However, the way we keep
// internal states doesn't contain such a data structure (check the state and
// TransitionMotionState). So when children function and others ask for such
// data we need to generate them on the fly by combining mergedPropsStyles and
// currentStyles/lastIdealStyles
function $8417218d9b0c379b$var$rehydrateStyles(mergedPropsStyles, unreadPropStyles, plainStyles) {
    // Copy the value to a `const` so that Flow understands that the const won't
    // change and will be non-nullable in the callback below.
    var cUnreadPropStyles = unreadPropStyles;
    if (cUnreadPropStyles == null) return mergedPropsStyles.map(function(mergedPropsStyle, i) {
        return {
            key: mergedPropsStyle.key,
            data: mergedPropsStyle.data,
            style: plainStyles[i]
        };
    });
    return mergedPropsStyles.map(function(mergedPropsStyle, i) {
        for(var j = 0; j < cUnreadPropStyles.length; j++){
            if (cUnreadPropStyles[j].key === mergedPropsStyle.key) return {
                key: cUnreadPropStyles[j].key,
                data: cUnreadPropStyles[j].data,
                style: plainStyles[i]
            };
        }
        return {
            key: mergedPropsStyle.key,
            data: mergedPropsStyle.data,
            style: plainStyles[i]
        };
    });
}
function $8417218d9b0c379b$var$shouldStopAnimationAll(currentStyles, destStyles, currentVelocities, mergedPropsStyles) {
    if (mergedPropsStyles.length !== destStyles.length) return false;
    for(var i = 0; i < mergedPropsStyles.length; i++){
        if (mergedPropsStyles[i].key !== destStyles[i].key) return false;
    }
    // we have the invariant that mergedPropsStyles and
    // currentStyles/currentVelocities/last* are synced in terms of cells, see
    // mergeAndSync comment for more info
    for(var i = 0; i < mergedPropsStyles.length; i++){
        if (!$8417218d9b0c379b$var$_shouldStopAnimation2['default'](currentStyles[i], destStyles[i].style, currentVelocities[i])) return false;
    }
    return true;
}
// core key merging logic
// things to do: say previously merged style is {a, b}, dest style (prop) is {b,
// c}, previous current (interpolating) style is {a, b}
// **invariant**: current[i] corresponds to merged[i] in terms of key
// steps:
// turn merged style into {a?, b, c}
//    add c, value of c is destStyles.c
//    maybe remove a, aka call willLeave(a), then merged is either {b, c} or {a, b, c}
// turn current (interpolating) style from {a, b} into {a?, b, c}
//    maybe remove a
//    certainly add c, value of c is willEnter(c)
// loop over merged and construct new current
// dest doesn't change, that's owner's
function $8417218d9b0c379b$var$mergeAndSync(willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldLastIdealStyles, oldLastIdealVelocities) {
    var newMergedPropsStyles = $8417218d9b0c379b$var$_mergeDiff2['default'](oldMergedPropsStyles, destStyles, function(oldIndex, oldMergedPropsStyle) {
        var leavingStyle = willLeave(oldMergedPropsStyle);
        if (leavingStyle == null) {
            didLeave({
                key: oldMergedPropsStyle.key,
                data: oldMergedPropsStyle.data
            });
            return null;
        }
        if ($8417218d9b0c379b$var$_shouldStopAnimation2['default'](oldCurrentStyles[oldIndex], leavingStyle, oldCurrentVelocities[oldIndex])) {
            didLeave({
                key: oldMergedPropsStyle.key,
                data: oldMergedPropsStyle.data
            });
            return null;
        }
        return {
            key: oldMergedPropsStyle.key,
            data: oldMergedPropsStyle.data,
            style: leavingStyle
        };
    });
    var newCurrentStyles = [];
    var newCurrentVelocities = [];
    var newLastIdealStyles = [];
    var newLastIdealVelocities = [];
    for(var i = 0; i < newMergedPropsStyles.length; i++){
        var newMergedPropsStyleCell = newMergedPropsStyles[i];
        var foundOldIndex = null;
        for(var j = 0; j < oldMergedPropsStyles.length; j++)if (oldMergedPropsStyles[j].key === newMergedPropsStyleCell.key) {
            foundOldIndex = j;
            break;
        }
        // TODO: key search code
        if (foundOldIndex == null) {
            var plainStyle = willEnter(newMergedPropsStyleCell);
            newCurrentStyles[i] = plainStyle;
            newLastIdealStyles[i] = plainStyle;
            var velocity = $8417218d9b0c379b$var$_mapToZero2['default'](newMergedPropsStyleCell.style);
            newCurrentVelocities[i] = velocity;
            newLastIdealVelocities[i] = velocity;
        } else {
            newCurrentStyles[i] = oldCurrentStyles[foundOldIndex];
            newLastIdealStyles[i] = oldLastIdealStyles[foundOldIndex];
            newCurrentVelocities[i] = oldCurrentVelocities[foundOldIndex];
            newLastIdealVelocities[i] = oldLastIdealVelocities[foundOldIndex];
        }
    }
    return [
        newMergedPropsStyles,
        newCurrentStyles,
        newCurrentVelocities,
        newLastIdealStyles,
        newLastIdealVelocities
    ];
}
var $8417218d9b0c379b$var$TransitionMotion = function(_React$Component) {
    $8417218d9b0c379b$var$_inherits(TransitionMotion, _React$Component);
    $8417218d9b0c379b$var$_createClass(TransitionMotion, null, [
        {
            key: 'propTypes',
            value: {
                defaultStyles: $8417218d9b0c379b$var$_propTypes2['default'].arrayOf($8417218d9b0c379b$var$_propTypes2['default'].shape({
                    key: $8417218d9b0c379b$var$_propTypes2['default'].string.isRequired,
                    data: $8417218d9b0c379b$var$_propTypes2['default'].any,
                    style: $8417218d9b0c379b$var$_propTypes2['default'].objectOf($8417218d9b0c379b$var$_propTypes2['default'].number).isRequired
                })),
                styles: $8417218d9b0c379b$var$_propTypes2['default'].oneOfType([
                    $8417218d9b0c379b$var$_propTypes2['default'].func,
                    $8417218d9b0c379b$var$_propTypes2['default'].arrayOf($8417218d9b0c379b$var$_propTypes2['default'].shape({
                        key: $8417218d9b0c379b$var$_propTypes2['default'].string.isRequired,
                        data: $8417218d9b0c379b$var$_propTypes2['default'].any,
                        style: $8417218d9b0c379b$var$_propTypes2['default'].objectOf($8417218d9b0c379b$var$_propTypes2['default'].oneOfType([
                            $8417218d9b0c379b$var$_propTypes2['default'].number,
                            $8417218d9b0c379b$var$_propTypes2['default'].object
                        ])).isRequired
                    }))
                ]).isRequired,
                children: $8417218d9b0c379b$var$_propTypes2['default'].func.isRequired,
                willEnter: $8417218d9b0c379b$var$_propTypes2['default'].func,
                willLeave: $8417218d9b0c379b$var$_propTypes2['default'].func,
                didLeave: $8417218d9b0c379b$var$_propTypes2['default'].func
            },
            enumerable: true
        },
        {
            key: 'defaultProps',
            value: {
                willEnter: function willEnter(styleThatEntered) {
                    return $8417218d9b0c379b$var$_stripStyle2['default'](styleThatEntered.style);
                },
                // recall: returning null makes the current unmounting TransitionStyle
                // disappear immediately
                willLeave: function willLeave() {
                    return null;
                },
                didLeave: function didLeave() {}
            },
            enumerable: true
        }
    ]);
    function TransitionMotion(props) {
        var _this = this;
        $8417218d9b0c379b$var$_classCallCheck(this, TransitionMotion);
        _React$Component.call(this, props);
        this.unmounting = false;
        this.animationID = null;
        this.prevTime = 0;
        this.accumulatedTime = 0;
        this.unreadPropStyles = null;
        this.clearUnreadPropStyle = function(unreadPropStyles) {
            var _mergeAndSync = $8417218d9b0c379b$var$mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, unreadPropStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
            var mergedPropsStyles = _mergeAndSync[0];
            var currentStyles = _mergeAndSync[1];
            var currentVelocities = _mergeAndSync[2];
            var lastIdealStyles = _mergeAndSync[3];
            var lastIdealVelocities = _mergeAndSync[4];
            for(var i = 0; i < unreadPropStyles.length; i++){
                var unreadPropStyle = unreadPropStyles[i].style;
                var dirty = false;
                for(var key in unreadPropStyle){
                    if (!Object.prototype.hasOwnProperty.call(unreadPropStyle, key)) continue;
                    var styleValue = unreadPropStyle[key];
                    if (typeof styleValue === 'number') {
                        if (!dirty) {
                            dirty = true;
                            currentStyles[i] = $8417218d9b0c379b$var$_extends({}, currentStyles[i]);
                            currentVelocities[i] = $8417218d9b0c379b$var$_extends({}, currentVelocities[i]);
                            lastIdealStyles[i] = $8417218d9b0c379b$var$_extends({}, lastIdealStyles[i]);
                            lastIdealVelocities[i] = $8417218d9b0c379b$var$_extends({}, lastIdealVelocities[i]);
                            mergedPropsStyles[i] = {
                                key: mergedPropsStyles[i].key,
                                data: mergedPropsStyles[i].data,
                                style: $8417218d9b0c379b$var$_extends({}, mergedPropsStyles[i].style)
                            };
                        }
                        currentStyles[i][key] = styleValue;
                        currentVelocities[i][key] = 0;
                        lastIdealStyles[i][key] = styleValue;
                        lastIdealVelocities[i][key] = 0;
                        mergedPropsStyles[i].style[key] = styleValue;
                    }
                }
            }
            // unlike the other 2 components, we can't detect staleness and optionally
            // opt out of setState here. each style object's data might contain new
            // stuff we're not/cannot compare
            _this.setState({
                currentStyles: currentStyles,
                currentVelocities: currentVelocities,
                mergedPropsStyles: mergedPropsStyles,
                lastIdealStyles: lastIdealStyles,
                lastIdealVelocities: lastIdealVelocities
            });
        };
        this.startAnimationIfNecessary = function() {
            if (_this.unmounting) return;
            // TODO: when config is {a: 10} and dest is {a: 10} do we raf once and
            // call cb? No, otherwise accidental parent rerender causes cb trigger
            _this.animationID = $8417218d9b0c379b$var$_raf2['default'](function(timestamp) {
                // https://github.com/chenglou/react-motion/pull/420
                // > if execution passes the conditional if (this.unmounting), then
                // executes async defaultRaf and after that component unmounts and after
                // that the callback of defaultRaf is called, then setState will be called
                // on unmounted component.
                if (_this.unmounting) return;
                var propStyles = _this.props.styles;
                var destStyles = typeof propStyles === 'function' ? propStyles($8417218d9b0c379b$var$rehydrateStyles(_this.state.mergedPropsStyles, _this.unreadPropStyles, _this.state.lastIdealStyles)) : propStyles;
                // check if we need to animate in the first place
                if ($8417218d9b0c379b$var$shouldStopAnimationAll(_this.state.currentStyles, destStyles, _this.state.currentVelocities, _this.state.mergedPropsStyles)) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.accumulatedTime = 0;
                    return;
                }
                var currentTime = timestamp || $8417218d9b0c379b$var$_performanceNow2['default']();
                var timeDelta = currentTime - _this.prevTime;
                _this.prevTime = currentTime;
                _this.accumulatedTime = _this.accumulatedTime + timeDelta;
                // more than 10 frames? prolly switched browser tab. Restart
                if (_this.accumulatedTime > $8417218d9b0c379b$var$msPerFrame * 10) _this.accumulatedTime = 0;
                if (_this.accumulatedTime === 0) {
                    // no need to cancel animationID here; shouldn't have any in flight
                    _this.animationID = null;
                    _this.startAnimationIfNecessary();
                    return;
                }
                var currentFrameCompletion = (_this.accumulatedTime - Math.floor(_this.accumulatedTime / $8417218d9b0c379b$var$msPerFrame) * $8417218d9b0c379b$var$msPerFrame) / $8417218d9b0c379b$var$msPerFrame;
                var framesToCatchUp = Math.floor(_this.accumulatedTime / $8417218d9b0c379b$var$msPerFrame);
                var _mergeAndSync2 = $8417218d9b0c379b$var$mergeAndSync(_this.props.willEnter, _this.props.willLeave, _this.props.didLeave, _this.state.mergedPropsStyles, destStyles, _this.state.currentStyles, _this.state.currentVelocities, _this.state.lastIdealStyles, _this.state.lastIdealVelocities);
                var newMergedPropsStyles = _mergeAndSync2[0];
                var newCurrentStyles = _mergeAndSync2[1];
                var newCurrentVelocities = _mergeAndSync2[2];
                var newLastIdealStyles = _mergeAndSync2[3];
                var newLastIdealVelocities = _mergeAndSync2[4];
                for(var i = 0; i < newMergedPropsStyles.length; i++){
                    var newMergedPropsStyle = newMergedPropsStyles[i].style;
                    var newCurrentStyle = {};
                    var newCurrentVelocity = {};
                    var newLastIdealStyle = {};
                    var newLastIdealVelocity = {};
                    for(var key in newMergedPropsStyle){
                        if (!Object.prototype.hasOwnProperty.call(newMergedPropsStyle, key)) continue;
                        var styleValue = newMergedPropsStyle[key];
                        if (typeof styleValue === 'number') {
                            newCurrentStyle[key] = styleValue;
                            newCurrentVelocity[key] = 0;
                            newLastIdealStyle[key] = styleValue;
                            newLastIdealVelocity[key] = 0;
                        } else {
                            var newLastIdealStyleValue = newLastIdealStyles[i][key];
                            var newLastIdealVelocityValue = newLastIdealVelocities[i][key];
                            for(var j = 0; j < framesToCatchUp; j++){
                                var _stepper = $8417218d9b0c379b$var$_stepper4['default']($8417218d9b0c379b$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                                newLastIdealStyleValue = _stepper[0];
                                newLastIdealVelocityValue = _stepper[1];
                            }
                            var _stepper2 = $8417218d9b0c379b$var$_stepper4['default']($8417218d9b0c379b$var$msPerFrame / 1000, newLastIdealStyleValue, newLastIdealVelocityValue, styleValue.val, styleValue.stiffness, styleValue.damping, styleValue.precision);
                            var nextIdealX = _stepper2[0];
                            var nextIdealV = _stepper2[1];
                            newCurrentStyle[key] = newLastIdealStyleValue + (nextIdealX - newLastIdealStyleValue) * currentFrameCompletion;
                            newCurrentVelocity[key] = newLastIdealVelocityValue + (nextIdealV - newLastIdealVelocityValue) * currentFrameCompletion;
                            newLastIdealStyle[key] = newLastIdealStyleValue;
                            newLastIdealVelocity[key] = newLastIdealVelocityValue;
                        }
                    }
                    newLastIdealStyles[i] = newLastIdealStyle;
                    newLastIdealVelocities[i] = newLastIdealVelocity;
                    newCurrentStyles[i] = newCurrentStyle;
                    newCurrentVelocities[i] = newCurrentVelocity;
                }
                _this.animationID = null;
                // the amount we're looped over above
                _this.accumulatedTime -= framesToCatchUp * $8417218d9b0c379b$var$msPerFrame;
                _this.setState({
                    currentStyles: newCurrentStyles,
                    currentVelocities: newCurrentVelocities,
                    lastIdealStyles: newLastIdealStyles,
                    lastIdealVelocities: newLastIdealVelocities,
                    mergedPropsStyles: newMergedPropsStyles
                });
                _this.unreadPropStyles = null;
                _this.startAnimationIfNecessary();
            });
        };
        this.state = this.defaultState();
    }
    TransitionMotion.prototype.defaultState = function defaultState() {
        var _props = this.props;
        var defaultStyles = _props.defaultStyles;
        var styles = _props.styles;
        var willEnter = _props.willEnter;
        var willLeave = _props.willLeave;
        var didLeave = _props.didLeave;
        var destStyles = typeof styles === 'function' ? styles(defaultStyles) : styles;
        // this is special. for the first time around, we don't have a comparison
        // between last (no last) and current merged props. we'll compute last so:
        // say default is {a, b} and styles (dest style) is {b, c}, we'll
        // fabricate last as {a, b}
        var oldMergedPropsStyles = undefined;
        if (defaultStyles == null) oldMergedPropsStyles = destStyles;
        else oldMergedPropsStyles = defaultStyles.map(function(defaultStyleCell) {
            // TODO: key search code
            for(var i = 0; i < destStyles.length; i++){
                if (destStyles[i].key === defaultStyleCell.key) return destStyles[i];
            }
            return defaultStyleCell;
        });
        var oldCurrentStyles = defaultStyles == null ? destStyles.map(function(s) {
            return $8417218d9b0c379b$var$_stripStyle2['default'](s.style);
        }) : defaultStyles.map(function(s) {
            return $8417218d9b0c379b$var$_stripStyle2['default'](s.style);
        });
        var oldCurrentVelocities = defaultStyles == null ? destStyles.map(function(s) {
            return $8417218d9b0c379b$var$_mapToZero2['default'](s.style);
        }) : defaultStyles.map(function(s) {
            return $8417218d9b0c379b$var$_mapToZero2['default'](s.style);
        });
        var _mergeAndSync3 = $8417218d9b0c379b$var$mergeAndSync(// Because this is an old-style createReactClass component, Flow doesn't
        // understand that the willEnter and willLeave props have default values
        // and will always be present.
        willEnter, willLeave, didLeave, oldMergedPropsStyles, destStyles, oldCurrentStyles, oldCurrentVelocities, oldCurrentStyles, oldCurrentVelocities);
        var mergedPropsStyles = _mergeAndSync3[0];
        var currentStyles = _mergeAndSync3[1];
        var currentVelocities = _mergeAndSync3[2];
        var lastIdealStyles = _mergeAndSync3[3];
        var lastIdealVelocities = _mergeAndSync3[4];
        // oldLastIdealVelocities really
        return {
            currentStyles: currentStyles,
            currentVelocities: currentVelocities,
            lastIdealStyles: lastIdealStyles,
            lastIdealVelocities: lastIdealVelocities,
            mergedPropsStyles: mergedPropsStyles
        };
    };
    // after checking for unreadPropStyles != null, we manually go set the
    // non-interpolating values (those that are a number, without a spring
    // config)
    TransitionMotion.prototype.componentDidMount = function componentDidMount() {
        this.prevTime = $8417218d9b0c379b$var$_performanceNow2['default']();
        this.startAnimationIfNecessary();
    };
    TransitionMotion.prototype.componentWillReceiveProps = function componentWillReceiveProps(props) {
        if (this.unreadPropStyles) // previous props haven't had the chance to be set yet; set them here
        this.clearUnreadPropStyle(this.unreadPropStyles);
        var styles = props.styles;
        if (typeof styles === 'function') this.unreadPropStyles = styles($8417218d9b0c379b$var$rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.lastIdealStyles));
        else this.unreadPropStyles = styles;
        if (this.animationID == null) {
            this.prevTime = $8417218d9b0c379b$var$_performanceNow2['default']();
            this.startAnimationIfNecessary();
        }
    };
    TransitionMotion.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unmounting = true;
        if (this.animationID != null) {
            $8417218d9b0c379b$var$_raf2['default'].cancel(this.animationID);
            this.animationID = null;
        }
    };
    TransitionMotion.prototype.render = function render() {
        var hydratedStyles = $8417218d9b0c379b$var$rehydrateStyles(this.state.mergedPropsStyles, this.unreadPropStyles, this.state.currentStyles);
        var renderedChildren = this.props.children(hydratedStyles);
        return renderedChildren && $8417218d9b0c379b$var$_react2['default'].Children.only(renderedChildren);
    };
    return TransitionMotion;
}($8417218d9b0c379b$var$_react2['default'].Component);
module.exports['default'] = $8417218d9b0c379b$var$TransitionMotion;
module.exports = module.exports['default']; // list of styles, each containing interpolating values. Part of what's passed
 // to children function. Notice that this is
 // Array<ActualInterpolatingStyleObject>, without the wrapper that is {key: ...,
 // data: ... style: ActualInterpolatingStyleObject}. Only mergedPropsStyles
 // contains the key & data info (so that we only have a single source of truth
 // for these, and to save space). Check the comment for `rehydrateStyles` to
 // see how we regenerate the entirety of what's passed to children function
 // the array that keeps track of currently rendered stuff! Including stuff
 // that you've unmounted but that's still animating. This is where it lives
 // it's possible that currentStyle's value is stale: if props is immediately
 // changed from 0 to 400 to spring(0) again, the async currentStyle is still
 // at 0 (didn't have time to tick and interpolate even once). If we naively
 // compare currentStyle with destVal it'll be 0 === 0 (no animation, stop).
 // In reality currentStyle should be 400

});
parcelRegister("2nrbB", function(module, exports) {
// core keys merging algorithm. If previous render's keys are [a, b], and the
// next render's [c, b, d], what's the final merged keys and ordering?
// - c and a must both be before b
// - b before d
// - ordering between a and c ambiguous
// this reduces to merging two partially ordered lists (e.g. lists where not
// every item has a definite ordering, like comparing a and c above). For the
// ambiguous ordering we deterministically choose to place the next render's
// item after the previous'; so c after a
// this is called a topological sorting. Except the existing algorithms don't
// work well with js bc of the amount of allocation, and isn't optimized for our
// current use-case bc the runtime is linear in terms of edges (see wiki for
// meaning), which is huge when two lists have many common elements
'use strict';
module.exports.__esModule = true;
module.exports['default'] = $1bb2d15e7ecfa8b9$var$mergeDiff;
function $1bb2d15e7ecfa8b9$var$mergeDiff(prev, next, onRemove) {
    // bookkeeping for easier access of a key's index below. This is 2 allocations +
    // potentially triggering chrome hash map mode for objs (so it might be faster
    var prevKeyIndex = {};
    for(var i = 0; i < prev.length; i++)prevKeyIndex[prev[i].key] = i;
    var nextKeyIndex = {};
    for(var i = 0; i < next.length; i++)nextKeyIndex[next[i].key] = i;
    // first, an overly elaborate way of merging prev and next, eliminating
    // duplicates (in terms of keys). If there's dupe, keep the item in next).
    // This way of writing it saves allocations
    var ret = [];
    for(var i = 0; i < next.length; i++)ret[i] = next[i];
    for(var i = 0; i < prev.length; i++)if (!Object.prototype.hasOwnProperty.call(nextKeyIndex, prev[i].key)) {
        // this is called my TM's `mergeAndSync`, which calls willLeave. We don't
        // merge in keys that the user desires to kill
        var fill = onRemove(i, prev[i]);
        if (fill != null) ret.push(fill);
    }
    // now all the items all present. Core sorting logic to have the right order
    return ret.sort(function(a, b) {
        var nextOrderA = nextKeyIndex[a.key];
        var nextOrderB = nextKeyIndex[b.key];
        var prevOrderA = prevKeyIndex[a.key];
        var prevOrderB = prevKeyIndex[b.key];
        if (nextOrderA != null && nextOrderB != null) // both keys in next
        return nextKeyIndex[a.key] - nextKeyIndex[b.key];
        else if (prevOrderA != null && prevOrderB != null) // both keys in prev
        return prevKeyIndex[a.key] - prevKeyIndex[b.key];
        else if (nextOrderA != null) {
            // key a in next, key b in prev
            // how to determine the order between a and b? We find a "pivot" (term
            // abuse), a key present in both prev and next, that is sandwiched between
            // a and b. In the context of our above example, if we're comparing a and
            // d, b's (the only) pivot
            for(var i = 0; i < next.length; i++){
                var pivot = next[i].key;
                if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) continue;
                if (nextOrderA < nextKeyIndex[pivot] && prevOrderB > prevKeyIndex[pivot]) return -1;
                else if (nextOrderA > nextKeyIndex[pivot] && prevOrderB < prevKeyIndex[pivot]) return 1;
            }
            // pluggable. default to: next bigger than prev
            return 1;
        }
        // prevOrderA, nextOrderB
        for(var i = 0; i < next.length; i++){
            var pivot = next[i].key;
            if (!Object.prototype.hasOwnProperty.call(prevKeyIndex, pivot)) continue;
            if (nextOrderB < nextKeyIndex[pivot] && prevOrderA > prevKeyIndex[pivot]) return 1;
            else if (nextOrderB > nextKeyIndex[pivot] && prevOrderA < prevKeyIndex[pivot]) return -1;
        }
        // pluggable. default to: next bigger than prev
        return -1;
    });
}
module.exports = module.exports['default']; // to loop through and find a key's index each time), but I no longer care

});


parcelRegister("4R87Z", function(module, exports) {
'use strict';
module.exports.__esModule = true;
var $38926ab16271cfd4$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
module.exports['default'] = $38926ab16271cfd4$var$spring;
function $38926ab16271cfd4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        'default': obj
    };
}

var $573iS = parcelRequire("573iS");
var $38926ab16271cfd4$var$_presets2 = $38926ab16271cfd4$var$_interopRequireDefault($573iS);
var $38926ab16271cfd4$var$defaultConfig = $38926ab16271cfd4$var$_extends({}, $38926ab16271cfd4$var$_presets2['default'].noWobble, {
    precision: 0.01
});
function $38926ab16271cfd4$var$spring(val, config) {
    return $38926ab16271cfd4$var$_extends({}, $38926ab16271cfd4$var$defaultConfig, config, {
        val: val
    });
}
module.exports = module.exports['default'];

});
parcelRegister("573iS", function(module, exports) {
"use strict";
module.exports.__esModule = true;
module.exports["default"] = {
    noWobble: {
        stiffness: 170,
        damping: 26
    },
    gentle: {
        stiffness: 120,
        damping: 14
    },
    wobbly: {
        stiffness: 180,
        damping: 12
    },
    stiff: {
        stiffness: 210,
        damping: 20
    }
};
module.exports = module.exports["default"];

});


parcelRegister("7HUoU", function(module, exports) {
'use strict';
module.exports.__esModule = true;
module.exports['default'] = $59c84c96449be391$var$reorderKeys;
var $59c84c96449be391$var$hasWarned = false;
function $59c84c96449be391$var$reorderKeys() {}
module.exports = module.exports['default'];

});



parcelRegister("bob1S", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.UnmountClosed = undefined;
var $84aa7dc2d5decf92$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
var $84aa7dc2d5decf92$var$_createClass = function() {
    function defineProperties(target, props) {
        for(var i = 0; i < props.length; i++){
            var descriptor = props[i];
            descriptor.enumerable = descriptor.enumerable || false;
            descriptor.configurable = true;
            if ("value" in descriptor) descriptor.writable = true;
            Object.defineProperty(target, descriptor.key, descriptor);
        }
    }
    return function(Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
    };
}();

var $eUqFw = parcelRequire("eUqFw");
var $84aa7dc2d5decf92$var$_react2 = $84aa7dc2d5decf92$var$_interopRequireDefault($eUqFw);

var $1Qivz = parcelRequire("1Qivz");
var $84aa7dc2d5decf92$var$_propTypes2 = $84aa7dc2d5decf92$var$_interopRequireDefault($1Qivz);

var $g0tPF = parcelRequire("g0tPF");
function $84aa7dc2d5decf92$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $84aa7dc2d5decf92$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $84aa7dc2d5decf92$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $84aa7dc2d5decf92$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $84aa7dc2d5decf92$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $84aa7dc2d5decf92$var$UnmountClosed = module.exports.UnmountClosed = function(_React$PureComponent) {
    $84aa7dc2d5decf92$var$_inherits(UnmountClosed, _React$PureComponent);
    function UnmountClosed(props) {
        $84aa7dc2d5decf92$var$_classCallCheck(this, UnmountClosed);
        var _this = $84aa7dc2d5decf92$var$_possibleConstructorReturn(this, (UnmountClosed.__proto__ || Object.getPrototypeOf(UnmountClosed)).call(this, props));
        _this.componentWillReceiveProps = function(_ref) {
            var isOpened = _ref.isOpened;
            if (!_this.props.isOpened && isOpened) _this.setState({
                forceInitialAnimation: true,
                shouldUnmount: false
            });
        };
        _this.onRest = function() {
            var _this$props = _this.props, isOpened = _this$props.isOpened, onRest = _this$props.onRest;
            if (!isOpened) _this.setState({
                shouldUnmount: true
            });
            if (onRest) onRest.apply(undefined, arguments);
        };
        _this.state = {
            shouldUnmount: !_this.props.isOpened,
            forceInitialAnimation: !_this.props.isOpened
        };
        return _this;
    }
    $84aa7dc2d5decf92$var$_createClass(UnmountClosed, [
        {
            key: 'render',
            value: function render() {
                var _props = this.props, isOpened = _props.isOpened, _onRest = _props.onRest, props = $84aa7dc2d5decf92$var$_objectWithoutProperties(_props, [
                    'isOpened',
                    'onRest'
                ]);
                var _state = this.state, forceInitialAnimation = _state.forceInitialAnimation, shouldUnmount = _state.shouldUnmount;
                return shouldUnmount ? null : $84aa7dc2d5decf92$var$_react2.default.createElement($g0tPF.Collapse, $84aa7dc2d5decf92$var$_extends({
                    forceInitialAnimation: forceInitialAnimation,
                    isOpened: isOpened,
                    onRest: this.onRest
                }, props));
            }
        }
    ]);
    return UnmountClosed;
}($84aa7dc2d5decf92$var$_react2.default.PureComponent);
$84aa7dc2d5decf92$var$UnmountClosed.propTypes = {
    isOpened: $84aa7dc2d5decf92$var$_propTypes2.default.bool.isRequired,
    onRest: $84aa7dc2d5decf92$var$_propTypes2.default.func
};

});


parcelRegister("aVhi9", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f3ca405ef8b737b$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $6jEcw = parcelRequire("6jEcw");

var $fw3UM = parcelRequire("fw3UM");

var $95Vof = parcelRequire("95Vof");

var $gPveH = parcelRequire("gPveH");

var $lHkHI = parcelRequire("lHkHI");
class $7f3ca405ef8b737b$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fw3UM.default), {
            facetBar: this.props.facetBar,
            facetType: this.props.facetType,
            filters: this.props.filters,
            items: this.props.items,
            label: this.props.label,
            onItemActivated: this.props.onItemActivated,
            ConjunctiveFacet: (0, $95Vof.default),
            DisjunctiveFacet: (0, $gPveH.default),
            perspective: this.props.perspective,
            stateChangeRequested: this.props.stateChangeRequested
        });
    }
}
(0, $5zQU9.default)($7f3ca405ef8b737b$export$2e2bcd8739ae039, "propTypes", {
    facetBar: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        'top',
        'side'
    ]),
    facetType: (0, $6jEcw.default).facetType.isRequired,
    filters: (0, $90ON9.default).filters.isRequired,
    items: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
    ]).isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    onItemActivated: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});

});
parcelRegister("95Vof", function(module, exports) {

$parcel$export(module.exports, "default", () => $69f11923648a3ab5$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $5YKni = parcelRequire("5YKni");

var $5JtOr = parcelRequire("5JtOr");

var $lHkHI = parcelRequire("lHkHI");
class $69f11923648a3ab5$export$d2ee45d7e2051b71 extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onConjunctiveFacetRemoveClick", (e)=>{
            const selectedItem = this.getSelectedItem();
            if (selectedItem) {
                const filterKey = selectedItem.facetKey;
                const filterValue = selectedItem.facetValue;
                const newFilters = this.props.filters.delete(filterKey);
                const label = selectedItem.selectedContent;
                this.props.fireAnalyticsEvent({
                    eventType: (0, $gaiog.FilterClickedEvent),
                    actionSubjectId: this.props.facetBar === 'side' ? (0, $5YKni.ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER) : (0, $5YKni.ANALYTICS_SUBJECT_ID_TOPBAR_FACET_FILTER),
                    source: this.props.perspective,
                    label: label,
                    attributes: {
                        sourceComponent: (0, $5YKni.EVENT_SOURCE),
                        currentPerspective: this.props.perspective,
                        filterKey: filterKey,
                        filterValue: filterValue,
                        selected: false
                    }
                }, (0, $5YKni.EVENT_CHANNEL));
                this.props.stateChangeRequested({
                    filters: newFilters
                });
            }
            e.stopPropagation();
        });
    }
    getSelectedItem() {
        if ((0, $g5DHJ.List).isList(this.props.items)) return this.props.items.find((i)=>i.selected);
        else return Object.values(this.props.items)[0].merge(Object.values(this.props.items)[1]).find((item)=>item.selected);
    }
    render() {
        const selectedItem = this.getSelectedItem();
        const noFilterSelectedItem = !selectedItem;
        const label = noFilterSelectedItem ? this.props.label : selectedItem.selectedContent || selectedItem.content;
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5JtOr.default), {
            closeOnItemSelected: true,
            facetBar: this.props.facetBar,
            facetValue: this.props.label,
            filters: this.props.filters,
            hasSelectedItem: !noFilterSelectedItem,
            items: this.props.items,
            label: label,
            onItemActivated: this.props.onItemActivated,
            onRemoveClick: this.onConjunctiveFacetRemoveClick,
            perspective: this.props.perspective
        });
    }
}
var $69f11923648a3ab5$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($69f11923648a3ab5$export$d2ee45d7e2051b71);

});
parcelRegister("5JtOr", function(module, exports) {

$parcel$export(module.exports, "default", () => $42c847e33bd1c7cd$export$2e2bcd8739ae039);

var $bwPfh = parcelRequire("bwPfh");

var $5zQU9 = parcelRequire("5zQU9");

var $jqNEH = parcelRequire("jqNEH");

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $ZN2Lb = parcelRequire("ZN2Lb");
var $gTOQV = parcelRequire("gTOQV");
var $71CV8 = parcelRequire("71CV8");

var $drftW = parcelRequire("drftW");

var $eWXWl = parcelRequire("eWXWl");

var $9osuT = parcelRequire("9osuT");

var $biTOe = parcelRequire("biTOe");

var $kO6Ah = parcelRequire("kO6Ah");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $9MMjz = parcelRequire("9MMjz");

var $5YKni = parcelRequire("5YKni");

var $lHkHI = parcelRequire("lHkHI");
const $42c847e33bd1c7cd$var$_excluded = [
    "triggerRef"
];
var $42c847e33bd1c7cd$var$_templateObject;
function $42c847e33bd1c7cd$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $42c847e33bd1c7cd$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $42c847e33bd1c7cd$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $42c847e33bd1c7cd$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $42c847e33bd1c7cd$export$ba33e3b83bca219e = /*#__PURE__*/ (0, $3UXZ8.default)((0, $71CV8.default), {
    target: "ebqkm2v0",
    label: "DropdownItemGroupStyled"
})("max-height:317px;", (0, $kO6Ah.mediaBreakpoints).largeUp($42c847e33bd1c7cd$var$_templateObject || ($42c847e33bd1c7cd$var$_templateObject = (0, $jqNEH.default)([
    "\n    min-width: 198px;\n  "
]))), "");
class $42c847e33bd1c7cd$export$ea771fd5e51726bc extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            isOpen: false
        });
        (0, $5zQU9.default)(this, "close", ()=>{
            this.setState({
                isOpen: false
            });
        });
        (0, $5zQU9.default)(this, "handleOpenChange", (_ref)=>{
            let { isOpen: isOpen } = _ref;
            // Work around an issue in Atlaskit where onOpenChange handler
            // is called when pressing Esc even when closed: https://ecosystem.atlassian.net/browse/AK-5044
            if (this.state.isOpen === isOpen) return;
            this.props.fireAnalyticsEvent({
                eventType: isOpen ? (0, $5YKni.FacetExpandedEvent) : (0, $5YKni.FacetCollapsedEvent),
                actionSubjectId: this.props.facetBar === 'side' ? (0, $5YKni.ANALYTICS_SUBJECT_ID_SIDEBAR_FACET) : (0, $5YKni.ANALYTICS_SUBJECT_ID_TOPBAR_FACET),
                objectType: (0, $5YKni.OBJECT_TYPE_FILTER),
                objectId: this.props.facetValue,
                source: (0, $5YKni.EVENT_SOURCE),
                attributes: {
                    currentPerspective: this.props.perspective
                }
            }, (0, $5YKni.EVENT_CHANNEL));
            this.setState({
                isOpen: isOpen
            });
        });
        (0, $5zQU9.default)(this, "handleItemActivated", (selection)=>{
            if (this.props.closeOnItemSelected) this.close();
            this.props.onItemActivated(selection);
        });
    }
    renderDropDownItemGroups() {
        return Object.keys(this.props.items).map((group)=>/*#__PURE__*/ (0, $lHkHI.jsx)($42c847e33bd1c7cd$export$ba33e3b83bca219e, {
                title: group.toUpperCase(),
                children: this.props.items[group].map((item)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $gTOQV.default), {
                        isSelected: item.isChecked,
                        onClick: ()=>this.handleItemActivated({
                                item: item
                            }),
                        children: item.content
                    }, item.facetValue))
            }, group));
    }
    renderDropDownItems() {
        const items = this.props.items.toArray();
        return /*#__PURE__*/ (0, $lHkHI.jsx)($42c847e33bd1c7cd$export$ba33e3b83bca219e, {
            children: items.map((item)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $gTOQV.default), {
                    isSelected: item.isChecked,
                    onClick: ()=>this.handleItemActivated({
                            item: item
                        }),
                    children: item.content
                }, item.facetValue))
        });
    }
    render() {
        const iconAfter = this.props.hasSelectedItem ? /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
            onClick: this.props.onRemoveClick,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eWXWl))), {
                label: "Remove selected"
            })
        }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($drftW))), {
            label: ""
        });
        const shouldFitContainer = this.props.facetBar === 'side';
        const buttonProps = {
            component: 'div',
            appearance: 'subtle',
            isSelected: this.state.isOpen,
            shouldFitContainer: shouldFitContainer,
            style: {
                textAlign: 'left'
            },
            iconAfter: iconAfter
        };
        // MC-731 facet = categories && sortingLogicForCategory = usage-and-alphabetical
        // items = {popular: List of popular categories , all: List of all categories}
        const dropdownItems = !(0, $g5DHJ.List).isList(this.props.items) ? this.renderDropDownItemGroups() : this.renderDropDownItems();
        return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ZN2Lb.default), {
                testId: (0, $9MMjz.TEST_IDS).FACET_DROPDOWN,
                isOpen: this.state.isOpen,
                onOpenChange: this.handleOpenChange,
                shouldFlip: false,
                appearance: "default",
                trigger: (_ref2)=>{
                    let { triggerRef: triggerRef } = _ref2, props = (0, $bwPfh.default)(_ref2, $42c847e33bd1c7cd$var$_excluded);
                    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), $42c847e33bd1c7cd$var$_objectSpread($42c847e33bd1c7cd$var$_objectSpread($42c847e33bd1c7cd$var$_objectSpread({
                        ref: triggerRef
                    }, buttonProps), props), {}, {
                        children: this.props.label
                    }));
                },
                children: dropdownItems
            })
        });
    }
}
var $42c847e33bd1c7cd$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)((0, $biTOe.withFeatureFlags)($42c847e33bd1c7cd$export$ea771fd5e51726bc));

});
parcelRegister("jqNEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $e256f68f3295e6bf$export$2e2bcd8739ae039);
function $e256f68f3295e6bf$export$2e2bcd8739ae039(e, t) {
    return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, {
        raw: {
            value: Object.freeze(t)
        }
    }));
}

});

parcelRegister("9oiuL", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d64b3bb3ca126ae$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $eiQBT = parcelRequire("eiQBT");

var $6ZjRV = parcelRequire("6ZjRV");

var $atXX9 = parcelRequire("atXX9");

var $96HLH = parcelRequire("96HLH");

var $i8QFr = parcelRequire("i8QFr");
const $6d64b3bb3ca126ae$var$isFirefox = typeof navigator !== 'undefined' && navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
/**
 * __Button__
 *
 * CAUTION: Legacy buttons will soon be deprecated. Please use the new Button components from `@atlaskit/button/new`.
 *
 * A button triggers an event or action. They let users know what will happen next.
 *
 * - [Examples](https://atlassian.design/components/button/button-legacy/examples)
 * - [Code](https://atlassian.design/components/button/button-legacy/code)
 * - [Usage](https://atlassian.design/components/button/button-legacy/usage)
 */ const $6d64b3bb3ca126ae$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ appearance: appearance = 'default', children: children, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected = false, onMouseDown: providedOnMouseDown = (0, $eiQBT.default), onMouseUp: providedOnMouseUp = (0, $eiQBT.default), shouldFitContainer: shouldFitContainer = false, spacing: spacing = 'default', ...rest }, ref) {
    const { mode: mode } = (0, $6ZjRV.useGlobalTheme)();
    const isOnlySingleIcon = (0, $i8QFr.default)({
        children: children,
        iconBefore: iconBefore,
        iconAfter: iconAfter
    });
    const [isActive, setIsActive] = (0, $eUqFw.useState)(false);
    // Wrap onMouseDown / onMouseUp to manually trigger active state
    //  in Firefox
    const onMouseDown = (0, $eUqFw.useCallback)((event)=>{
        providedOnMouseDown(event);
        if ($6d64b3bb3ca126ae$var$isFirefox) setIsActive(true);
    }, [
        providedOnMouseDown,
        setIsActive
    ]);
    const onMouseUp = (0, $eUqFw.useCallback)((event)=>{
        providedOnMouseUp(event);
        if ($6d64b3bb3ca126ae$var$isFirefox) setIsActive(false);
    }, [
        providedOnMouseUp,
        setIsActive
    ]);
    const buttonCss = (0, $eUqFw.useMemo)(()=>(0, $96HLH.getCss)({
            appearance: appearance,
            spacing: spacing,
            mode: mode,
            isSelected: isSelected,
            shouldFitContainer: shouldFitContainer,
            isOnlySingleIcon: isOnlySingleIcon
        }), [
        appearance,
        spacing,
        mode,
        isSelected,
        shouldFitContainer,
        isOnlySingleIcon
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $atXX9.default), (0, $kU09D.default)({}, rest, {
        ref: ref,
        appearance: appearance,
        buttonCss: buttonCss,
        children: children,
        "data-firefox-is-active": isActive ? true : undefined,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        isSelected: isSelected,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        spacing: spacing
    }));
}));
// Tools including enzyme rely on components having a display name
$6d64b3bb3ca126ae$var$Button.displayName = 'Button';
var $6d64b3bb3ca126ae$export$2e2bcd8739ae039 = $6d64b3bb3ca126ae$var$Button;

});

parcelRegister("gTOQV", function(module, exports) {

$parcel$export(module.exports, "default", () => $480c1250e74ae3fb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5zGDY = parcelRequire("5zGDY");

var $9XtCG = parcelRequire("9XtCG");

var $aZQkJ = parcelRequire("aZQkJ");

var $1zyzq = parcelRequire("1zyzq");

var $3puyA = parcelRequire("3puyA");

var $bUsQ4 = parcelRequire("bUsQ4");
/**
 * __Dropdown menu item__
 *
 * A dropdown item populates the dropdown menu with items. Every item should be inside a dropdown item group.
 *
 * - [Examples](https://atlassian.design/components/dropdown-item/examples)
 * - [Code](https://atlassian.design/components/dropdown-item/code)
 * - [Usage](https://atlassian.design/components/dropdown-item/usage)
 */ const $480c1250e74ae3fb$var$DropdownMenuItem = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, component: component, description: description, elemAfter: elemAfter, elemBefore: elemBefore, href: href, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, rel: rel, shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, target: target, testId: testId, UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink, returnFocusRef: returnFocusRef, interactionName: interactionName, ...rest }, ref)=>{
    const itemRef = (0, $bUsQ4.default)();
    const handleItemClick = (0, $eUqFw.useCallback)((event)=>{
        if (returnFocusRef?.current) returnFocusRef.current.focus();
        if (onClick) onClick(event);
    }, [
        onClick,
        returnFocusRef
    ]);
    if (component) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aZQkJ.default), {
        component: component,
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $5zGDY.default)([
            ref,
            itemRef
        ]),
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        href: href,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $3puyA.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else if (href) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zyzq.default), {
        description: description,
        href: href,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $5zGDY.default)([
            ref,
            itemRef
        ]),
        rel: rel,
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        target: target,
        testId: testId,
        UNSAFE_shouldDisableRouterLink: UNSAFE_shouldDisableRouterLink,
        ...(0, $3puyA.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
    else return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9XtCG.default), {
        description: description,
        iconAfter: elemAfter,
        iconBefore: elemBefore,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: handleItemClick,
        ref: (0, $5zGDY.default)([
            ref,
            itemRef
        ]),
        role: "menuitem",
        shouldDescriptionWrap: shouldDescriptionWrap,
        shouldTitleWrap: shouldTitleWrap,
        testId: testId,
        // Thanks to spread props, these attributes are passed to CustomItem, even though
        // it's not in the component's prop types.
        // @ts-expect-error
        target: target,
        rel: rel,
        ...(0, $3puyA.fg)('platform_button_item-add-ufo-metrics') && {
            interactionName: interactionName
        },
        ...rest
    }, children);
});
var $480c1250e74ae3fb$export$2e2bcd8739ae039 = $480c1250e74ae3fb$var$DropdownMenuItem;

});

parcelRegister("71CV8", function(module, exports) {

$parcel$export(module.exports, "default", () => $4deea4ede0c59b6e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k1TCz = parcelRequire("k1TCz");

var $g4K15 = parcelRequire("g4K15");

var $hoQcQ = parcelRequire("hoQcQ");
/**
 * __Dropdown item checkbox group__
 *
 * A wrapping element for dropdown menu items.
 *
 */ const $4deea4ede0c59b6e$var$DropdownMenuItemGroup = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, id: id, isList: isList, isScrollable: isScrollable, title: title, testId: testId, hasSeparator: hasSeparator, overrides: overrides, ...rest }, ref)=>{
    const uid = (0, $k1TCz.useId)();
    const titleId = `dropdown-menu-item-group-title-${uid}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $g4K15.default), {
        id: id,
        ref: ref,
        isList: isList,
        isScrollable: isScrollable,
        hasSeparator: hasSeparator,
        testId: testId,
        titleId: title ? titleId : undefined,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides, @atlaskit/design-system/no-deprecated-apis
        overrides: overrides,
        ...rest
    }, title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hoQcQ.default), {
        id: titleId,
        title: title
    }), children);
});
var $4deea4ede0c59b6e$export$2e2bcd8739ae039 = $4deea4ede0c59b6e$var$DropdownMenuItemGroup;

});

parcelRegister("kO6Ah", function(module, exports) {

$parcel$export(module.exports, "gridBreakpoints", () => $f25d95a5735986e6$export$273d622ab270ee14);
$parcel$export(module.exports, "mediaBreakpoints", () => $f25d95a5735986e6$export$9a428948031ea39f);

var $ibjku = parcelRequire("ibjku");
const $f25d95a5735986e6$export$273d622ab270ee14 = Object.freeze({
    sm: 576,
    // max-width for mobiles/small devices
    md: 768,
    lg: 992
});
/**
 * This delta is to prevent two states co-existing on boundary condition.
 * for example: when screen width is of exact 768px, the small-only and medium-only
 * view would co-exist if they had same bounds.
 * therefore, to prevent we introduce 0.02px difference in them
 */ const $f25d95a5735986e6$var$delta = 0.02;
const $f25d95a5735986e6$var$getMediaQuery = (screenQuery)=>{
    return function(strings) {
        for(var _len = arguments.length, expressions = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)expressions[_key - 1] = arguments[_key];
        return /*#__PURE__*/ (0, $ibjku.css)("@media (", screenQuery, "){", /*#__PURE__*/ (0, $ibjku.css)(strings, ...expressions), "}");
    };
};
const $f25d95a5735986e6$export$9a428948031ea39f = {
    smallUp: $f25d95a5735986e6$var$getMediaQuery("min-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.sm, "px")),
    smallDown: $f25d95a5735986e6$var$getMediaQuery("max-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.sm - $f25d95a5735986e6$var$delta, "px")),
    mediumUp: $f25d95a5735986e6$var$getMediaQuery("min-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.md, "px")),
    mediumDown: $f25d95a5735986e6$var$getMediaQuery("max-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.md - $f25d95a5735986e6$var$delta, "px")),
    mediumOnly: $f25d95a5735986e6$var$getMediaQuery("min-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.sm, "px) and (max-width: ").concat($f25d95a5735986e6$export$273d622ab270ee14.md - $f25d95a5735986e6$var$delta, "px")),
    largeUp: $f25d95a5735986e6$var$getMediaQuery("min-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.lg, "px")),
    largeDown: $f25d95a5735986e6$var$getMediaQuery("max-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.lg - $f25d95a5735986e6$var$delta, "px")),
    largeOnly: $f25d95a5735986e6$var$getMediaQuery("min-width: ".concat($f25d95a5735986e6$export$273d622ab270ee14.md, "px) and (max-width: ").concat($f25d95a5735986e6$export$273d622ab270ee14.lg - $f25d95a5735986e6$var$delta, "px"))
};

});



parcelRegister("gPveH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c409a39c7330e683$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $5YKni = parcelRequire("5YKni");

var $5JtOr = parcelRequire("5JtOr");

var $lHkHI = parcelRequire("lHkHI");
class $c409a39c7330e683$var$DisjunctiveFacetDropdown extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onDisjunctiveFacetRemoveClick", (e)=>{
            this.props.items.reduce((filters, i)=>{
                if (i.selected) {
                    const newFilters = filters.update(i.facetKey, (f)=>f.delete(i.facetValue));
                    this.props.fireAnalyticsEvent({
                        eventType: (0, $gaiog.FilterClickedEvent),
                        actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_TOPBAR_FACET_FILTER),
                        source: (0, $5YKni.EVENT_SOURCE),
                        attributes: {
                            currentPerspective: this.props.perspective,
                            filterKey: i.facetKey,
                            filterValue: i.facetValue,
                            selected: false
                        }
                    }, (0, $5YKni.EVENT_CHANNEL));
                    this.props.stateChangeRequested({
                        filters: newFilters
                    });
                    return newFilters;
                }
                return filters;
            }, this.props.filters);
            e.stopPropagation();
        });
    }
    render() {
        const numberSelectedItems = this.props.items.filter((i)=>i.selected).size;
        const someSelectedItemsExist = numberSelectedItems > 0;
        const label = someSelectedItemsExist ? "".concat(numberSelectedItems, " selected") : this.props.label;
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5JtOr.default), {
            closeOnItemSelected: false,
            facetBar: this.props.facetBar,
            facetValue: this.props.label,
            filters: this.props.filters,
            hasSelectedItem: someSelectedItemsExist,
            items: this.props.items,
            label: label,
            onItemActivated: this.props.onItemActivated,
            onRemoveClick: this.onDisjunctiveFacetRemoveClick,
            perspective: this.props.perspective
        });
    }
}
var $c409a39c7330e683$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($c409a39c7330e683$var$DisjunctiveFacetDropdown);

});



parcelRegister("26qEF", function(module, exports) {

$parcel$export(module.exports, "default", () => $1880d16f7f5fd8fd$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $f2I7b = parcelRequire("f2I7b");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $9rIMC = parcelRequire("9rIMC");

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $9MMjz = parcelRequire("9MMjz");

var $5YKni = parcelRequire("5YKni");

var $6jEcw = parcelRequire("6jEcw");

var $hsbtR = parcelRequire("hsbtR");

var $lHkHI = parcelRequire("lHkHI");
class $1880d16f7f5fd8fd$var$ConjunctiveFacetProduct extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onClick", (event, options)=>{
            const facetKey = this.props.facet.get('key');
            const filterValue = this.props.facetProduct.get('value');
            const newIsSelected = !this.props.selected;
            this.props.fireAnalyticsEvent({
                eventType: (0, $gaiog.FilterClickedEvent),
                actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER),
                objectType: (0, $5YKni.OBJECT_TYPE_FILTER),
                objectId: facetKey,
                label: this.props.facetProduct.get('label'),
                parentLabel: this.props.facet.get('sidebarLabel'),
                source: this.props.perspective,
                attributes: {
                    sourceComponent: (0, $5YKni.EVENT_SOURCE),
                    currentPerspective: this.props.perspective,
                    filterValue: filterValue,
                    selected: newIsSelected
                }
            }, (0, $5YKni.EVENT_CHANNEL));
            (0, $9rIMC).maybeOpenInNewTab(event, ()=>{
                this.props.stateChangeRequested({
                    perspective: options.newPerspective,
                    filters: options.newFilters
                });
            });
        });
    }
    render() {
        const FiltersLink = this.props.filtersLink;
        const newFilters = this.props.selected ? this.props.filters.delete(this.props.facet.get('key')) : this.props.filters.set(this.props.facet.get('key'), this.props.facetProduct.get('value'));
        return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $hsbtR.FacetSidebarItemContainer), {
            selected: this.props.selected,
            "data-testid": (0, $9MMjz.TEST_IDS).FILTER_SIDEBAR_ITEM,
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hsbtR.TickIcon), {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($f2I7b))), {
                        label: "Selected",
                        size: "medium"
                    })
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)(FiltersLink, {
                    className: "ui-product",
                    filtersContext: this.props.filtersContext,
                    newFilters: newFilters,
                    onClick: this.onClick,
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hsbtR.Label), {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                            children: this.props.facetProduct.get('label')
                        })
                    })
                })
            ]
        });
    }
}
(0, $5zQU9.default)($1880d16f7f5fd8fd$var$ConjunctiveFacetProduct, "propTypes", {
    fireAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    facet: (0, $6jEcw.default).processedFacet.isRequired,
    facetProduct: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).map.isRequired,
    filters: (0, $90ON9.default).filters.isRequired,
    filtersContext: (0, $6jEcw.default).filtersContext,
    filtersLink: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});
var $1880d16f7f5fd8fd$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($1880d16f7f5fd8fd$var$ConjunctiveFacetProduct);

});
parcelRegister("f2I7b", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af394332a2970cd5$var$_react = $af394332a2970cd5$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $af394332a2970cd5$var$_checkMark = $af394332a2970cd5$var$_interopRequireDefault((parcelRequire("FsJIG")));
function $af394332a2970cd5$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $af394332a2970cd5$var$CheckIcon = (props)=>/*#__PURE__*/ $af394332a2970cd5$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $af394332a2970cd5$var$_checkMark.default
    }));
$af394332a2970cd5$var$CheckIcon.displayName = 'CheckIcon';
var $af394332a2970cd5$var$_default = module.exports.default = $af394332a2970cd5$var$CheckIcon;

});
parcelRegister("FsJIG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::209317c625743d387bf26edea0c296a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $07ca1ee7430dd6b9$var$_react = $07ca1ee7430dd6b9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $07ca1ee7430dd6b9$var$_UNSAFE_baseNew = $07ca1ee7430dd6b9$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $07ca1ee7430dd6b9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $07ca1ee7430dd6b9$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $07ca1ee7430dd6b9$var$_react.default.createElement($07ca1ee7430dd6b9$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m1.5 8 4.25 5.25 8.75-10.5"/>`
    }, props));
$07ca1ee7430dd6b9$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $07ca1ee7430dd6b9$var$_default = module.exports.default = $07ca1ee7430dd6b9$var$CheckMarkIcon;

});


parcelRegister("hsbtR", function(module, exports) {

$parcel$export(module.exports, "FacetSidebarItemContainer", () => $cb4df501b9bba70c$export$73ad934284e55363);
$parcel$export(module.exports, "TickIcon", () => $cb4df501b9bba70c$export$f2ca6fc699ca1fb4);
$parcel$export(module.exports, "Label", () => $cb4df501b9bba70c$export$b04be29aa201d4f5);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $jdjb1 = parcelRequire("jdjb1");

var $ibjku = parcelRequire("ibjku");
const $cb4df501b9bba70c$export$73ad934284e55363 = (0, $3UXZ8.default)("div", {
    target: "edlh3f00",
    label: "FacetSidebarItemContainer"
})("display:block;line-height:20px;margin-left:-0.25rem;padding:var(--ds-space-100, 8px) var(--ds-space-300, 24px) var(--ds-space-100, 8px) var(--ds-space-050, 4px);", (0, $jdjb1.ellipsis), " ", (props)=>props.selected ? /*#__PURE__*/ (0, $ibjku.css)("font-weight:700;", $cb4df501b9bba70c$export$f2ca6fc699ca1fb4, "{visibility:visible;};label:FacetSidebarItemContainer;") : '', " & .ui-product{display:flex;}");
const $cb4df501b9bba70c$export$b04be29aa201d4f5 = (0, $3UXZ8.default)("span", {
    target: "edlh3f01",
    label: "Label"
})("display:inline-block;", (0, $jdjb1.ellipsis), " word-wrap:normal;flex-grow:1;");
const $cb4df501b9bba70c$export$f2ca6fc699ca1fb4 = (0, $3UXZ8.default)("span", {
    target: "edlh3f02",
    label: "TickIcon"
})("color:", "var(--ds-link, ".concat((0, $j0gMm.B400), ")"), ";align-items:center;display:flex;float:left;height:20px;margin-right:var(--ds-space-100, 8px);visibility:hidden;");

});
parcelRegister("jdjb1", function(module, exports) {

$parcel$export(module.exports, "multilineEllipsis", () => $dfce1b59b04c2ad5$export$139cbccd083cc2ff);
$parcel$export(module.exports, "ellipsis", () => $dfce1b59b04c2ad5$export$a5b94313d6908893);

var $ivTMz = parcelRequire("ivTMz");

var $ibjku = parcelRequire("ibjku");
function $dfce1b59b04c2ad5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dfce1b59b04c2ad5$export$3f4d05b455b17f33 = ()=>"Charlie Display', ".concat((0, $ivTMz.fontFamily)());
const $dfce1b59b04c2ad5$export$139cbccd083cc2ff = (noOfLines, fallbackMaxHeight)=>/*#__PURE__*/ (0, $ibjku.css)("display:-webkit-box;-webkit-line-clamp:", noOfLines, ";overflow:hidden;-webkit-box-orient:vertical;max-height:", fallbackMaxHeight, ";");
const $dfce1b59b04c2ad5$export$a5b94313d6908893 = {
    name: "irnju7-ellipsis",
    styles: "text-overflow:ellipsis;white-space:nowrap;overflow:hidden;;label:ellipsis;"
};
const $dfce1b59b04c2ad5$export$79a2fb060a0872a6 = {
    'text-overflow': 'ellipsis',
    'white-space': 'nowrap',
    overflow: 'hidden'
};

});





parcelRegister("fUACZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9587f7f018a4fbd$export$2e2bcd8739ae039);

var $iWqLM = parcelRequire("iWqLM");
var $b9587f7f018a4fbd$export$2e2bcd8739ae039 = (0, $iWqLM.default);

});
parcelRegister("iWqLM", function(module, exports) {

$parcel$export(module.exports, "default", () => $dca268aba8b5bbe6$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $6jEcw = parcelRequire("6jEcw");

var $a040Q = parcelRequire("a040Q");

var $b9k0s = parcelRequire("b9k0s");

var $lHkHI = parcelRequire("lHkHI");
class $dca268aba8b5bbe6$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $a040Q.default), {
            facet: this.props.facet,
            facetProductComponentClass: (0, $b9k0s.default),
            filters: this.props.filters,
            filtersContext: this.props.filtersContext,
            filtersLink: this.props.filtersLink,
            forceExpanded: this.props.forceExpanded,
            hiddenFilters: this.props.hiddenFilters,
            itemFactory: this.props.itemFactory,
            itemType: "checkbox",
            onFacetProductClick: this.props.onFacetProductClick,
            perspective: this.props.perspective,
            stateChangeRequested: this.props.stateChangeRequested
        });
    }
}
(0, $5zQU9.default)($dca268aba8b5bbe6$export$2e2bcd8739ae039, "propTypes", {
    facet: (0, $6jEcw.default).processedFacet.isRequired,
    filters: (0, $90ON9.default).filters.isRequired,
    filtersContext: (0, $6jEcw.default).filtersContext,
    filtersLink: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    forceExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    hiddenFilters: (0, $6jEcw.default).hiddenFilters.isRequired,
    itemFactory: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    onFacetProductClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});

});
parcelRegister("b9k0s", function(module, exports) {

$parcel$export(module.exports, "default", () => $81e00dd2681d2f41$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $jC9Rj = parcelRequire("jC9Rj");

var $9rIMC = parcelRequire("9rIMC");

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $5YKni = parcelRequire("5YKni");

var $6jEcw = parcelRequire("6jEcw");

var $hsbtR = parcelRequire("hsbtR");

var $lHkHI = parcelRequire("lHkHI");
function $81e00dd2681d2f41$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $81e00dd2681d2f41$export$5c881a0ecca73ffa = (0, $3UXZ8.default)("input", {
    target: "e1micsik0",
    label: "DisjunctiveCheckbox"
})({
    name: "9kc2p6",
    styles: "margin:0 var(--ds-space-200, 16px) 0 var(--ds-space-400, 32px);padding:0;"
});
class $81e00dd2681d2f41$var$DisjunctiveFacetProduct extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onClick", (event, options)=>{
            const newSelected = !this.props.selected;
            this.props.fireAnalyticsEvent({
                eventType: (0, $gaiog.FilterClickedEvent),
                actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_SIDEBAR_FACET_FILTER),
                objectType: (0, $5YKni.OBJECT_TYPE_FILTER),
                objectId: this.props.facet.get('key'),
                label: this.props.facetProduct.get('label'),
                parentLabel: this.props.facet.get('sidebarLabel'),
                source: this.props.perspective,
                attributes: {
                    sourceComponent: (0, $5YKni.EVENT_SOURCE),
                    currentPerspective: this.props.perspective,
                    filterValue: this.props.facetProduct.get('value'),
                    selected: newSelected
                }
            }, (0, $5YKni.EVENT_CHANNEL));
            (0, $9rIMC).maybeOpenInNewTab(event, ()=>{
                this.props.stateChangeRequested({
                    perspective: options.newPerspective,
                    filters: options.newFilters
                });
            });
        });
        (0, $5zQU9.default)(this, "renderLabel", ()=>{
            const { facetProduct: facetProduct } = this.props;
            if (facetProduct.get('value') === 'topVendor') return /*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jC9Rj.default), {})
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                        children: facetProduct.get('label')
                    })
                ]
            });
            else return /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                children: facetProduct.get('label')
            });
        });
    }
    render() {
        const FiltersLink = this.props.filtersLink;
        const facetFilters = this.props.filters.get(this.props.facet.get('key'));
        const value = this.props.facetProduct.get('value');
        const newFilters = this.props.filters.update(this.props.facet.get('key'), (fs)=>facetFilters.includes(value) ? fs.delete(value) : fs.add(value));
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hsbtR.FacetSidebarItemContainer), {
            selected: this.props.selected,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)(FiltersLink, {
                className: "ui-product",
                newFilters: newFilters,
                filtersContext: this.props.filtersContext,
                onClick: this.onClick,
                tabIndex: -1,
                children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $hsbtR.Label), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)($81e00dd2681d2f41$export$5c881a0ecca73ffa, {
                            type: "checkbox",
                            checked: this.props.selected,
                            readOnly: true
                        }),
                        this.renderLabel()
                    ]
                })
            })
        });
    }
}
(0, $5zQU9.default)($81e00dd2681d2f41$var$DisjunctiveFacetProduct, "propTypes", {
    fireAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    facet: (0, $6jEcw.default).processedFacet.isRequired,
    facetProduct: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).map.isRequired,
    filters: (0, $90ON9.default).filters.isRequired,
    filtersContext: (0, $6jEcw.default).filtersContext,
    filtersLink: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    selected: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});
var $81e00dd2681d2f41$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($81e00dd2681d2f41$var$DisjunctiveFacetProduct);

});
parcelRegister("jC9Rj", function(module, exports) {

$parcel$export(module.exports, "default", () => $e47936b24729a92e$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $gykb8 = parcelRequire("gykb8");
parcelRequire("eUqFw");

var $4lmb9 = parcelRequire("4lmb9");

var $2e8x7 = parcelRequire("2e8x7");

var $lHkHI = parcelRequire("lHkHI");
function $e47936b24729a92e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e47936b24729a92e$var$StyledImg = (0, $3UXZ8.default)("img", {
    target: "e1aam84i0",
    label: "StyledImg"
})({
    name: "fopvyl",
    styles: "width:18px;height:18px;vertical-align:text-top;"
});
const $e47936b24729a92e$var$StyledParagraph = (0, $3UXZ8.default)("p", {
    target: "e1aam84i1",
    label: "StyledParagraph"
})({
    name: "9uewxx",
    styles: "margin-top:0;margin-bottom:10px;max-width:250px;"
});
const $e47936b24729a92e$var$StyledLink = /*#__PURE__*/ (0, $3UXZ8.default)((0, $gykb8.default), {
    target: "e1aam84i2",
    label: "StyledLink"
})({
    name: "15ult4h",
    styles: "margin-left:5px;color:inherit;font-weight:500;"
});
function $e47936b24729a92e$export$2e2bcd8739ae039(_ref) {
    let { vendorName: vendorName, className: className, showLabel: showLabel } = _ref;
    if (!showLabel) return /*#__PURE__*/ (0, $lHkHI.jsx)($e47936b24729a92e$var$StyledImg, {
        alt: "Top Vendor",
        className: className,
        src: (0, (/*@__PURE__*/$parcel$interopDefault($2e8x7))),
        title: "Top Vendor"
    });
    const tooltipContent = /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)($e47936b24729a92e$var$StyledParagraph, {
                children: [
                    vendorName,
                    " is a Top Vendor. Top Vendors have high standards for app quality, reliability, and support."
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                target: "_blank",
                href: "https://www.atlassian.com/licensing/marketplace#generalmarketplacequestions-7",
                children: "Learn more"
            })
        ]
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4lmb9.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
            className: className,
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($e47936b24729a92e$var$StyledImg, {
                    alt: "Top Vendor",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($2e8x7)))
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($e47936b24729a92e$var$StyledLink, {
                    target: "_blank",
                    href: "https://www.atlassian.com/licensing/marketplace#generalmarketplacequestions-7",
                    children: "Top Vendor"
                })
            ]
        })
    });
}

});
parcelRegister("4lmb9", function(module, exports) {

$parcel$export(module.exports, "default", () => $329a53df95c5a343$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $eRsJy = parcelRequire("eRsJy");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $329a53df95c5a343$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $329a53df95c5a343$export$e72bfb66b5de904f = (0, $3UXZ8.default)("span", {
    target: "e1l6eq9s0",
    label: "RichTooltipContainer"
})({
    name: "1c3h18e",
    styles: "flex:1 0 auto;"
});
const $329a53df95c5a343$var$RICH_TOOLTIP_CLASS = 'rich_tooltip__container';
class $329a53df95c5a343$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "showTimerId", void 0);
        (0, $5zQU9.default)(this, "hideTimerId", void 0);
        (0, $5zQU9.default)(this, "isFocused", void 0);
        (0, $5zQU9.default)(this, "state", {
            isOpen: false
        });
        (0, $5zQU9.default)(this, "handleFocusChange", (e)=>{
            const isTooltipChild = (target)=>!(target instanceof HTMLElement) || !target.closest(".".concat($329a53df95c5a343$var$RICH_TOOLTIP_CLASS));
            if (isTooltipChild(e.target)) {
                this.isFocused = false;
                this.setState({
                    isOpen: false
                });
            }
        });
        (0, $5zQU9.default)(this, "handleMouseEnter", ()=>{
            clearTimeout(this.hideTimerId);
            this.showTimerId = setTimeout(()=>{
                this.setState({
                    isOpen: true
                });
            }, this.props.delay);
        });
        (0, $5zQU9.default)(this, "handleMouseLeave", ()=>{
            if (this.isFocused) return;
            clearTimeout(this.showTimerId);
            // Add a delay, allowing some time for the cursor to
            // hop onto the tooltip area without close being triggered
            this.hideTimerId = setTimeout(()=>{
                this.setState({
                    isOpen: false
                });
            }, 150);
        });
        (0, $5zQU9.default)(this, "handleFocus", ()=>{
            this.isFocused = true;
            this.setState({
                isOpen: true
            });
        });
        (0, $5zQU9.default)(this, "onClose", ()=>{
            this.isFocused = false;
            this.setState({
                isOpen: false
            });
        });
        (0, $5zQU9.default)(this, "handleContentBlur", ()=>{
            if (!this.props.disableBlurEvent) this.onClose();
        });
    }
    componentDidMount() {
        document.addEventListener('focus', this.handleFocusChange, true);
    }
    componentWillUnmount() {
        document.removeEventListener('focus', this.handleFocusChange, true);
    }
    render() {
        const { isOpen: isOpen } = this.state;
        const { children: children, content: content } = this.props;
        return /*#__PURE__*/ (0, $lHkHI.jsx)($329a53df95c5a343$export$e72bfb66b5de904f, {
            className: $329a53df95c5a343$var$RICH_TOOLTIP_CLASS,
            onMouseEnter: this.handleMouseEnter,
            onMouseLeave: this.handleMouseLeave,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eRsJy.default), {
                content: content,
                isOpen: isOpen,
                onClose: this.onClose,
                onContentBlur: this.handleContentBlur,
                testId: "inline-dialog",
                children: /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                    tabIndex: 0,
                    onFocus: this.handleFocus,
                    role: "tooltip",
                    children: children
                })
            })
        });
    }
}
(0, $5zQU9.default)($329a53df95c5a343$export$2e2bcd8739ae039, "defaultProps", {
    delay: 200
});

});
parcelRegister("eRsJy", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad1c4dd89bf46491$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $74BVL = parcelRequire("74BVL");

var $lzpNt = parcelRequire("lzpNt");
var $dki1H = parcelRequire("dki1H");
var $dY3D1 = parcelRequire("dY3D1");

var $eiQBT = parcelRequire("eiQBT");

var $KWaBz = parcelRequire("KWaBz");
var $3MxTX = parcelRequire("3MxTX");

var $3puyA = parcelRequire("3puyA");

var $2QaEW = parcelRequire("2QaEW");
var $kjy3U = parcelRequire("kjy3U");
var $iZrYs = parcelRequire("iZrYs");

var $8zWvy = parcelRequire("8zWvy");

var $iekpz = parcelRequire("iekpz");
const $ad1c4dd89bf46491$var$packageName = "@atlaskit/inline-dialog";
const $ad1c4dd89bf46491$var$packageVersion = "14.3.1";
const $ad1c4dd89bf46491$var$checkIsChildOfPortal = (node)=>{
    if (!node) return false;
    return node.classList && node.classList.contains('atlaskit-portal-container') || $ad1c4dd89bf46491$var$checkIsChildOfPortal(node.parentElement);
};
// escape close manager for layering
const $ad1c4dd89bf46491$var$EscapeCloseManager = ({ handleClose: handleClose })=>{
    (0, $3MxTX.useCloseOnEscapePress)({
        onClose: handleClose
    });
    // only create a dummy component for using ths hook in class component
    return (0, $byn9U.jsx)("span", null);
};
const $ad1c4dd89bf46491$export$513033cc22e3bc20 = /*#__PURE__*/ (0, $eUqFw.memo)(function InlineDialog({ isOpen: isOpen = false, onContentBlur: onContentBlur = (0, $eiQBT.default), onContentClick: onContentClick = (0, $eiQBT.default), onContentFocus: onContentFocus = (0, $eiQBT.default), onClose: onClose = (0, $eiQBT.default), placement: placement = 'bottom-start', strategy: strategy = 'fixed', testId: testId, content: content, children: children }) {
    const containerRef = (0, $eUqFw.useRef)(null);
    const triggerRef = (0, $eUqFw.useRef)(null);
    // we put this into a ref to avoid handleCloseRequest having this as a dependency
    const onCloseRef = (0, $eUqFw.useRef)(onClose);
    const isLayeringEnabled = (0, $3puyA.fg)('platform.design-system-team.inline-message-layering_wfp1p') && isOpen;
    (0, $eUqFw.useEffect)(()=>{
        onCloseRef.current = onClose;
    });
    const handleCloseRequest = (0, $eUqFw.useCallback)((event)=>{
        const { target: target } = event;
        // checks for when target is not HTMLElement
        if (!(target instanceof HTMLElement)) return;
        // TODO: This is to handle the case where the target is no longer in the DOM.
        // This happens with react-select in datetime picker. There might be other
        // edge cases for this.
        if (!document.body.contains(target)) return;
        if (isLayeringEnabled) {
            var _onCloseRef$current;
            (_onCloseRef$current = onCloseRef.current) === null || _onCloseRef$current === void 0 || _onCloseRef$current.call(onCloseRef, {
                isOpen: false,
                event: event
            });
            return;
        }
        // handles the case where inline dialog opens portalled elements such as modal
        if ($ad1c4dd89bf46491$var$checkIsChildOfPortal(target)) return;
        // call onClose if the click originated from outside the dialog
        if (containerRef.current && !containerRef.current.contains(target)) {
            var _onCloseRef$current2;
            (_onCloseRef$current2 = onCloseRef.current) === null || _onCloseRef$current2 === void 0 || _onCloseRef$current2.call(onCloseRef, {
                isOpen: false,
                event: event
            });
        }
    }, [
        isLayeringEnabled
    ]);
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        var _containerRef$current;
        // exit if we click outside but on the trigger — it can handle the clicks itself
        if (triggerRef.current && triggerRef.current.contains(event.target)) return;
        // if feature flag is enabled we won't file the close event when clicking inside dialog
        if (isLayeringEnabled && (_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(event.target)) return;
        handleCloseRequest(event);
    }, [
        handleCloseRequest,
        isLayeringEnabled
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isOpen) return;
        return (0, $74BVL.bind)(window, {
            type: 'click',
            listener: handleClick,
            options: {
                capture: true
            }
        });
    }, [
        isOpen,
        handleClick
    ]);
    const handleKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (event.key === 'Escape') handleCloseRequest(event);
    }, [
        handleCloseRequest
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // if layering is enabled, we will use useCloseOnEscapePress hook instead
        if (!isOpen || isLayeringEnabled) return;
        const unbind = (0, $74BVL.bind)(window, {
            type: 'keydown',
            listener: handleKeyDown,
            options: {
                capture: true
            }
        });
        return unbind;
    }, [
        isOpen,
        handleKeyDown,
        isLayeringEnabled
    ]);
    const popper = isOpen ? (0, $byn9U.jsx)((0, $kjy3U.Popper), {
        placement: placement,
        strategy: strategy
    }, ({ ref: ref, style: style })=>(0, $byn9U.jsx)((0, $iekpz.Container), {
            onBlur: onContentBlur,
            onFocus: onContentFocus,
            onClick: onContentClick,
            ref: (node)=>{
                if (node) {
                    containerRef.current = node;
                    if (typeof ref === 'function') ref(node);
                    else ref.current = node;
                }
            },
            style: style,
            testId: testId
        }, content)) : null;
    return (0, $byn9U.jsx)((0, $2QaEW.Manager), null, (0, $byn9U.jsx)((0, $iZrYs.Reference), null, ({ ref: ref })=>(0, $byn9U.jsx)((0, $8zWvy.default), {
            innerRef: (node)=>{
                triggerRef.current = node;
                if (typeof ref === 'function') ref(node);
                else ref.current = node;
            // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            },
            hasNodeResolver: !(0, $3puyA.fg)('dsp-19516-design-system-portal-logic-update')
        }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children))), isLayeringEnabled ? (0, $byn9U.jsx)((0, $KWaBz.UNSAFE_LAYERING), {
        isDisabled: false
    }, popper, (0, $byn9U.jsx)($ad1c4dd89bf46491$var$EscapeCloseManager, {
        handleClose: handleCloseRequest
    })) : popper);
});
$ad1c4dd89bf46491$export$513033cc22e3bc20.displayName = 'InlineDialog';
const $ad1c4dd89bf46491$var$createAndFireEventOnAtlaskit = (0, $lzpNt.default)('atlaskit');
/**
 * __Inline dialog__
 *
 * _We are planning on deprecating Inline dialog. We recommend using the Popup component instead._
 *
 * An inline dialog is a pop-up container for small amounts of information. It can also contain controls.
 *
 * - [Examples](https://atlassian.design/components/inline-dialog/examples)
 * - [Code](https://atlassian.design/components/inline-dialog/code)
 * - [Usage](https://atlassian.design/components/inline-dialog/usage)
 */ const $ad1c4dd89bf46491$var$InlineDialog = (0, $dki1H.default)({
    componentName: 'inlineDialog',
    packageName: $ad1c4dd89bf46491$var$packageName,
    packageVersion: $ad1c4dd89bf46491$var$packageVersion
})((0, $dY3D1.default)({
    onClose: $ad1c4dd89bf46491$var$createAndFireEventOnAtlaskit({
        action: 'closed',
        actionSubject: 'inlineDialog',
        attributes: {
            componentName: 'inlineDialog',
            packageName: $ad1c4dd89bf46491$var$packageName,
            packageVersion: $ad1c4dd89bf46491$var$packageVersion
        }
    })
})($ad1c4dd89bf46491$export$513033cc22e3bc20));
var $ad1c4dd89bf46491$export$2e2bcd8739ae039 = $ad1c4dd89bf46491$var$InlineDialog;

});
parcelRegister("KWaBz", function(module, exports) {

$parcel$export(module.exports, "LevelContext", () => $08d16b5a411cd6b7$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "TopLevelContext", () => $08d16b5a411cd6b7$export$48b383b280e20440);
$parcel$export(module.exports, "UNSAFE_LAYERING", () => $08d16b5a411cd6b7$export$a183686c3f6f4ea8);

var $eUqFw = parcelRequire("eUqFw");

var $eiQBT = parcelRequire("eiQBT");
const $08d16b5a411cd6b7$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $eUqFw.createContext)(0);
const $08d16b5a411cd6b7$export$48b383b280e20440 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $eiQBT.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ const $08d16b5a411cd6b7$var$LevelProvider = ({ children: children, currentLevel: currentLevel })=>{
    const { setTopLevel: setTopLevel, topLevelRef: topLevelRef } = (0, $eUqFw.useContext)($08d16b5a411cd6b7$export$48b383b280e20440);
    if (topLevelRef.current === null || currentLevel > topLevelRef.current) setTopLevel(currentLevel);
    (0, $eUqFw.useEffect)(()=>{
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return ()=>{
            setTimeout(()=>{
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08d16b5a411cd6b7$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ const $08d16b5a411cd6b7$var$LayeringProvider = ({ children: children })=>{
    const topLevelRef = (0, $eUqFw.useRef)(0);
    const value = (0, $eUqFw.useMemo)(()=>({
            topLevelRef: topLevelRef,
            setTopLevel: (level)=>{
                topLevelRef.current = level;
            }
        }), [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08d16b5a411cd6b7$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
const $08d16b5a411cd6b7$export$a183686c3f6f4ea8 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $eUqFw.useContext)($08d16b5a411cd6b7$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08d16b5a411cd6b7$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($08d16b5a411cd6b7$var$LayeringProvider, null, content);
};

});

parcelRegister("3MxTX", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", () => $2c1026ea90ae8f60$export$4a4bf067ea9e7886);

var $eUqFw = parcelRequire("eUqFw");

var $74BVL = parcelRequire("74BVL");

var $KWaBz = parcelRequire("KWaBz");
const $2c1026ea90ae8f60$var$ESCAPE = 'Escape';
function $2c1026ea90ae8f60$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $eUqFw.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = $2c1026ea90ae8f60$export$cec37b93989366d4();
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $2c1026ea90ae8f60$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $eUqFw.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $74BVL.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $2c1026ea90ae8f60$export$cec37b93989366d4() {
    const currentLevel = (0, $eUqFw.useContext)((0, $KWaBz.LevelContext));
    const { topLevelRef: topLevelRef } = (0, $eUqFw.useContext)((0, $KWaBz.TopLevelContext));
    const isLayerDisabled = (0, $eUqFw.useCallback)(()=>{
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});

parcelRegister("8zWvy", function(module, exports) {

$parcel$export(module.exports, "default", () => $63eefa122eb901b1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lbDTY = parcelRequire("lbDTY");
/**
 * A wrapper component that conditionally applies a NodeResolver to its children.
 *
 * Note: NodeResolver should not be used in React 18 concurrent mode. This component
 * is intended to be removed once the feature flag  is removed.
 * @param {boolean} props.hasNodeResolver - Determines whether to apply the NodeResolver.
 * @param {ReactElement} props.children - The child elements to be wrapped.
 * @param {(instance: HTMLDivElement) => void} props.innerRef - A ref callback to get the instance of the HTMLDivElement.
 * @returns {ReactElement} The children wrapped with NodeResolver if hasNodeResolver is true, wrape the children in a div setting innerRef with ref to the div.
 */ const $63eefa122eb901b1$var$NodeResolverWrapper = ({ hasNodeResolver: hasNodeResolver, children: children, innerRef: innerRef })=>{
    if (hasNodeResolver) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lbDTY))), {
        innerRef: innerRef
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", {
        ref: (node)=>innerRef(node)
    }, children);
};
var $63eefa122eb901b1$export$2e2bcd8739ae039 = $63eefa122eb901b1$var$NodeResolverWrapper;

});

parcelRegister("iekpz", function(module, exports) {

$parcel$export(module.exports, "Container", () => $d4595e182c0900fd$export$42a852a2b6b56249);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");


var $56FC2 = parcelRequire("56FC2");
const $d4595e182c0900fd$var$CSS_THEME_BACKGROUND = '--theme-background';
const $d4595e182c0900fd$var$CSS_THEME_COLOR = '--theme-color';
const $d4595e182c0900fd$var$CSS_THEME_BOX_SHADOW = '--theme-box-shadow';
const $d4595e182c0900fd$var$containerStyles = (0, $byn9U.css)({
    boxSizing: 'content-box',
    maxWidth: `${448}px`,
    maxHeight: `${448}px`,
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-300, 24px)"}`,
    zIndex: (0, $56FC2.layers).dialog(),
    background: `var(${$d4595e182c0900fd$var$CSS_THEME_BACKGROUND})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    boxShadow: `var(${$d4595e182c0900fd$var$CSS_THEME_BOX_SHADOW})`,
    color: `var(${$d4595e182c0900fd$var$CSS_THEME_COLOR})`,
    '&:focus': {
        outline: 'none'
    }
});
const $d4595e182c0900fd$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, onBlur: onBlur, onClick: onClick, onFocus: onFocus, style: style, testId: testId }, ref)=>{
    return(// Unfortunately, these are used for products to pass through. Inline Dialog is being deprecated anyway
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    (0, $byn9U.jsx)("div", {
        css: $d4595e182c0900fd$var$containerStyles,
        "data-testid": testId,
        onBlur: onBlur,
        onClick: onClick,
        onFocus: onFocus,
        ref: ref,
        style: {
            [$d4595e182c0900fd$var$CSS_THEME_BACKGROUND]: `var(--ds-surface-overlay, ${(0, $ab6d6432a4c55680$export$29a4f05edc054374)})`,
            [$d4595e182c0900fd$var$CSS_THEME_COLOR]: `var(--ds-text, ${(0, $ab6d6432a4c55680$export$fbda843f0a27fe96)})`,
            [$d4595e182c0900fd$var$CSS_THEME_BOX_SHADOW]: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $ab6d6432a4c55680$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $ab6d6432a4c55680$export$d2d3bedfb276cac0)}`})`,
            ...style
        }
    }, children));
});

});



parcelRegister("2e8x7", function(module, exports) {
module.exports = new URL("top-vendor-badge.d27cc922.svg", import.meta.url).toString();

});










parcelRegister("ajvzn", function(module, exports) {

$parcel$export(module.exports, "default", () => $78242acad277c651$export$2e2bcd8739ae039);

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");
parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $6jEcw = parcelRequire("6jEcw");

var $fKlNY = parcelRequire("fKlNY");

var $1D32T = parcelRequire("1D32T");

var $lHkHI = parcelRequire("lHkHI");
function $78242acad277c651$export$2e2bcd8739ae039(props) {
    return props.screenClass === 'xs' ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1D32T.default), {
        displayTextSearch: props.displayTextSearch,
        facets: props.facets,
        filters: props.filters,
        hiddenFilters: props.hiddenFilters,
        itemFactory: props.itemFactory,
        perspective: props.perspective,
        screenClass: props.screenClass,
        stateChangeRequested: props.stateChangeRequested
    }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fKlNY.default), {
        displayTextSearch: props.displayTextSearch,
        facets: props.facets,
        filters: props.filters,
        hiddenFilters: props.hiddenFilters,
        itemFactory: props.itemFactory,
        perspective: props.perspective,
        screenClass: props.screenClass,
        sortingLogicForCategory: "usage-and-alphabetical",
        stateChangeRequested: props.stateChangeRequested
    });
}
$78242acad277c651$export$2e2bcd8739ae039.propTypes = {
    displayTextSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    facets: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
    filters: (0, $90ON9.default).filters,
    hiddenFilters: (0, $6jEcw.default).hiddenFilters.isRequired,
    itemFactory: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
};

});
parcelRegister("fKlNY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b76c10e86c5ff79b$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $9l6Pq = parcelRequire("9l6Pq");

var $aB8Wc = parcelRequire("aB8Wc");

var $9rIMC = parcelRequire("9rIMC");
parcelRequire("ibjku");

var $eUqFw = parcelRequire("eUqFw");

var $isqrX = parcelRequire("isqrX");

var $5YKni = parcelRequire("5YKni");

var $MjCo4 = parcelRequire("MjCo4");

var $aVhi9 = parcelRequire("aVhi9");

var $jrWj3 = parcelRequire("jrWj3");

var $lHkHI = parcelRequire("lHkHI");
function $b76c10e86c5ff79b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b76c10e86c5ff79b$var$FacetsHorizontalMenuStyle = (0, $3UXZ8.default)("div", {
    target: "e1ycl0zu0",
    label: "FacetsHorizontalMenuStyle"
})({
    name: "1lkog1",
    styles: "padding:0 10px;width:100%;"
});
// type FacetsHorizontalContainerProps = {
//     oneRow?: boolean,
// };
var $b76c10e86c5ff79b$var$_ref = {
    name: "gokb7f-FacetsHorizontalContainer",
    styles: "height:inherit;;label:FacetsHorizontalContainer;"
};
const $b76c10e86c5ff79b$export$d2b618d8c796f70 = (0, $3UXZ8.default)("div", {
    target: "e1ycl0zu1",
    label: "FacetsHorizontalContainer"
})("display:flex;flex-wrap:wrap;height:90px;margin-top:10px;align-items:center;", (props)=>props.oneRow ? $b76c10e86c5ff79b$var$_ref : '', "");
const $b76c10e86c5ff79b$var$FacetsHorizontalMenuItem = (0, $3UXZ8.default)("div", {
    target: "e1ycl0zu2",
    label: "FacetsHorizontalMenuItem"
})({
    name: "rxjkss",
    styles: "display:flex;margin-right:15px;"
});
const $b76c10e86c5ff79b$export$36b35e0794022c3c = /*#__PURE__*/ (0, $3UXZ8.default)($b76c10e86c5ff79b$var$FacetsHorizontalMenuItem, {
    target: "e1ycl0zu3",
    label: "SmallTextSearchContainer"
})("transition:width 200ms ease;width:", (props)=>props.expanded ? '300' : '250', "px;");
const $b76c10e86c5ff79b$export$ed4ca47dbafc4d6d = (0, $3UXZ8.default)("div", {
    target: "e1ycl0zu4",
    label: "FacetsHorizontalMenuItemInner"
})({
    name: "6cjp67",
    styles: "margin:auto;width:100%;"
});
class $b76c10e86c5ff79b$var$FacetsHorizontalMenu extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            textSearchFocused: false,
            showSearchOverlay: false
        });
        (0, $5zQU9.default)(this, "onTextSearchFocus", ()=>{
            this.setState({
                textSearchFocused: true
            });
        });
        (0, $5zQU9.default)(this, "onTextSearchBlur", ()=>{
            this.setState({
                textSearchFocused: false
            });
        });
        (0, $5zQU9.default)(this, "onFacetProductClick", (event, _ref2)=>{
            let { facetKey: facetKey, facetValue: facetValue, selected: selected, newPerspective: newPerspective, newFilters: newFilters } = _ref2;
            this.props.fireAnalyticsEvent({
                eventType: (0, $gaiog.FilterClickedEvent),
                actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_TOPBAR_FACET_FILTER),
                objectType: (0, $5YKni.OBJECT_TYPE_FILTER),
                objectId: facetKey,
                source: (0, $5YKni.EVENT_SOURCE),
                attributes: {
                    currentPerspective: this.props.perspective,
                    filterValue: facetValue,
                    selected: !selected
                }
            }, (0, $5YKni.EVENT_CHANNEL));
            (0, $9rIMC).maybeOpenInNewTab(event, ()=>{
                this.props.stateChangeRequested({
                    perspective: newPerspective,
                    filters: newFilters
                });
            });
        });
        (0, $5zQU9.default)(this, "handleSearchInputClick", ()=>{
            var _this$props$statsigCl;
            const enableSearchOverlay = (_this$props$statsigCl = this.props.statsigClient) === null || _this$props$statsigCl === void 0 ? void 0 : _this$props$statsigCl.enableAetherSearchOverlay();
            if (enableSearchOverlay) this.setState({
                showSearchOverlay: true
            });
        });
    }
    render() {
        const facetsToShow = this.props.facets.filter((facet)=>(0, $isqrX.shouldFacetBeShown)(facet.get('key'), this.props.hiddenFilters));
        return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
            children: [
                this.state.showSearchOverlay && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aB8Wc.SearchOverlay), {
                    onClose: ()=>{
                        this.setState({
                            showSearchOverlay: false
                        });
                    },
                    analytics: {
                        source: 'search-tablet'
                    }
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($b76c10e86c5ff79b$var$FacetsHorizontalMenuStyle, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsxs)($b76c10e86c5ff79b$export$d2b618d8c796f70, {
                        oneRow: facetsToShow.size <= 4,
                        children: [
                            this.props.displayTextSearch ? /*#__PURE__*/ (0, $lHkHI.jsx)($b76c10e86c5ff79b$export$36b35e0794022c3c, {
                                expanded: this.state.textSearchFocused,
                                children: /*#__PURE__*/ (0, $lHkHI.jsx)($b76c10e86c5ff79b$export$ed4ca47dbafc4d6d, {
                                    onClick: this.handleSearchInputClick,
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $MjCo4.default), {
                                        filters: this.props.filters,
                                        onBlur: this.onTextSearchBlur,
                                        onFocus: this.onTextSearchFocus,
                                        perspective: this.props.perspective,
                                        screenClass: this.props.screenClass,
                                        stateChangeRequested: this.props.stateChangeRequested
                                    })
                                })
                            }) : undefined,
                            facetsToShow.map((facet)=>{
                                return /*#__PURE__*/ (0, $lHkHI.jsx)($b76c10e86c5ff79b$var$FacetsHorizontalMenuItem, {
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)($b76c10e86c5ff79b$export$ed4ca47dbafc4d6d, {
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jrWj3.default), {
                                            sortingLogicForCategory: this.props.sortingLogicForCategory,
                                            facet: facet,
                                            filters: this.props.filters,
                                            hiddenFilters: this.props.hiddenFilters,
                                            itemFactory: this.props.itemFactory,
                                            perspective: this.props.perspective,
                                            onFacetProductClick: this.onFacetProductClick,
                                            stateChangeRequested: this.props.stateChangeRequested,
                                            FacetComponent: (0, $aVhi9.default)
                                        })
                                    })
                                }, "facet-".concat(facet.get('key')));
                            })
                        ]
                    })
                })
            ]
        });
    }
}
var $b76c10e86c5ff79b$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)((0, $9l6Pq.withStatsig)($b76c10e86c5ff79b$var$FacetsHorizontalMenu));

});
parcelRegister("MjCo4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0913b390980d18a6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $e1Mnq = parcelRequire("e1Mnq");

var $aIgIm = parcelRequire("aIgIm");

var $lHkHI = parcelRequire("lHkHI");
class $0913b390980d18a6$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $e1Mnq.default), {
            compact: true,
            extraProps: {
                onBlur: this.props.onBlur,
                onFocus: this.props.onFocus,
                screenClass: this.props.screenClass
            },
            filters: this.props.filters,
            onChange: this.props.onChange,
            perspective: this.props.perspective,
            searchComponent: (0, $aIgIm.default),
            stateChangeRequested: this.props.stateChangeRequested
        });
    }
}

});
parcelRegister("aIgIm", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ccafa9a3813d994$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $1Tfhj = parcelRequire("1Tfhj");
parcelRequire("ibjku");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $7ccafa9a3813d994$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $7ccafa9a3813d994$var$_ref = {
    name: "12fclrw-SmallTextSearchInnerStyle",
    styles: "input{height:40px;};label:SmallTextSearchInnerStyle;"
};
const $7ccafa9a3813d994$var$SmallTextSearchInnerStyle = (0, $3UXZ8.default)("div", {
    target: "e135zlyd0",
    label: "SmallTextSearchInnerStyle"
})((props)=>$7ccafa9a3813d994$var$screenClassIsMediumOrSmaller(props.screenClass) ? $7ccafa9a3813d994$var$_ref : '', "");
const $7ccafa9a3813d994$var$screenClassIsMediumOrSmaller = (sc)=>sc === 'xs' || sc === 'sm' || sc === 'md';
const $7ccafa9a3813d994$var$SmallTextSearchInner = (props)=>{
    const handleOnChange = (_ref2)=>{
        let { target: { value: value } } = _ref2;
        props.onChangeQuery(value);
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)($7ccafa9a3813d994$var$SmallTextSearchInnerStyle, {
        screenClass: props.screenClass,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1Tfhj.default), {
            "aria-label": "Search for apps",
            autoFocus: true,
            css: {
                padding: "var(--ds-space-050, 4px)".concat(" ", "var(--ds-space-025, 2px)")
            },
            onBlur: props.onBlur,
            onChange: handleOnChange,
            onFocus: props.onFocus,
            placeholder: "Search for apps",
            value: props.query
        })
    });
};
var $7ccafa9a3813d994$export$2e2bcd8739ae039 = $7ccafa9a3813d994$var$SmallTextSearchInner;

});
parcelRegister("1Tfhj", function(module, exports) {

$parcel$export(module.exports, "default", () => $7345963ba34cfe6f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2MblP = parcelRequire("2MblP");

var $kVHdB = parcelRequire("kVHdB");
const $7345963ba34cfe6f$var$analyticsParams = {
    componentName: 'textField',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
/**
 * __Textfield__
 *
 * A text field is an input that allows a user to write or edit text.
 *
 * - [Examples](https://atlassian.design/components/textfield/examples)
 * - [Code](https://atlassian.design/components/textfield/code)
 * - [Usage](https://atlassian.design/components/textfield/usage)
 */ const $7345963ba34cfe6f$var$Textfield = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { appearance: appearance = 'standard', className: className, elemAfterInput: elemAfterInput, elemBeforeInput: elemBeforeInput, isCompact: isCompact = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, isReadOnly: isReadOnly = false, isRequired: isRequired = false, name: name, onBlur: onBlur, onChange: onChange, onFocus: onFocus, onMouseDown: onMouseDown, placeholder: placeholder, testId: testId, width: width, ...spreadProps } = props;
    const inputRef = (0, $eUqFw.useRef)(null);
    const handleOnFocus = (0, $2MblP.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$7345963ba34cfe6f$var$analyticsParams
    });
    const handleOnBlur = (0, $2MblP.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$7345963ba34cfe6f$var$analyticsParams
    });
    const handleOnMouseDown = (0, $eUqFw.useCallback)((event)=>{
        // Running e.preventDefault() on the INPUT prevents double click behaviour
        // Sadly we needed this cast as the target type is being correctly set
        const target = event.target;
        if (target.tagName !== 'INPUT') event.preventDefault();
        if (inputRef && inputRef.current && !isDisabled && document.activeElement !== inputRef.current) inputRef.current.focus();
        onMouseDown && onMouseDown(event);
    }, [
        onMouseDown,
        isDisabled
    ]);
    const setInputRef = (0, $eUqFw.useCallback)((inputElement)=>{
        inputRef.current = inputElement;
        if (!ref) return;
        if (typeof ref === 'object') ref.current = inputElement;
        if (typeof ref === 'function') ref(inputElement);
    }, [
        ref
    ]);
    const containerStyles = (0, $eUqFw.useMemo)(()=>(0, $kVHdB.containerStyles)(appearance, width), [
        appearance,
        width
    ]);
    const inputStyle = (0, $kVHdB.inputStyles)();
    return(/**
     * It is not normally acceptable to add click and key handlers to
     * non-interactive elements as this is an accessibility anti-pattern.
     * However, because this instance is to handle events on all children that
     * should be associated with the input, we can add role="presentation" so
     * that there are no negative impacts to assistive technologies.
     */ /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "presentation",
        "data-disabled": isDisabled ? isDisabled : undefined,
        "data-invalid": isInvalid ? isInvalid : undefined,
        "data-ds--text-field--container": true,
        "data-testid": testId && `${testId}-container`,
        onMouseDown: handleOnMouseDown,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: containerStyles,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className
    }, elemBeforeInput, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ...spreadProps,
        "aria-invalid": isInvalid ? isInvalid : undefined,
        // TODO: When removing legacy theming fix this.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: inputStyle,
        "data-compact": isCompact ? isCompact : undefined,
        "data-ds--text-field--input": true,
        "data-monospaced": isMonospaced ? isMonospaced : undefined,
        "data-testid": testId,
        disabled: isDisabled,
        name: name,
        onBlur: handleOnBlur,
        onChange: onChange,
        onFocus: handleOnFocus,
        placeholder: placeholder,
        readOnly: isReadOnly,
        ref: setInputRef,
        required: isRequired
    }), elemAfterInput));
});
var $7345963ba34cfe6f$export$2e2bcd8739ae039 = $7345963ba34cfe6f$var$Textfield;

});
parcelRegister("kVHdB", function(module, exports) {

$parcel$export(module.exports, "containerStyles", () => $e489531664054db5$export$5972a68b6e54f38f);
$parcel$export(module.exports, "inputStyles", () => $e489531664054db5$export$3eeb47dc8e6249d9);

const $e489531664054db5$var$backgroundColor = {
    standard: `var(--ds-background-input, ${(0, $ab6d6432a4c55680$export$e655ef011c4aa1a2)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $e489531664054db5$var$backgroundColorFocus = {
    standard: `var(--ds-background-input-pressed, ${(0, $ab6d6432a4c55680$export$29a4f05edc054374)})`,
    subtle: `var(--ds-background-input-pressed, ${(0, $ab6d6432a4c55680$export$29a4f05edc054374)})`,
    none: 'transparent'
};
const $e489531664054db5$var$backgroundColorHover = {
    standard: `var(--ds-background-input-hovered, ${(0, $ab6d6432a4c55680$export$3e51e8f1440314ba)})`,
    subtle: `var(--ds-background-input-hovered, ${(0, $ab6d6432a4c55680$export$3e51e8f1440314ba)})`,
    none: 'transparent'
};
const $e489531664054db5$var$borderColor = {
    standard: `var(--ds-border-input, ${(0, $ab6d6432a4c55680$export$d6447c357493214f)})`,
    subtle: 'transparent',
    none: 'transparent'
};
const $e489531664054db5$var$borderColorFocus = {
    standard: `var(--ds-border-focused, ${(0, $ab6d6432a4c55680$export$215b7063051591f1)})`,
    subtle: `var(--ds-border-focused, ${(0, $ab6d6432a4c55680$export$215b7063051591f1)})`,
    none: 'transparent'
};
const $e489531664054db5$var$borderColorHover = {
    standard: `var(--ds-border-input, ${(0, $ab6d6432a4c55680$export$d6447c357493214f)})`,
    subtle: "var(--ds-border-input, transparent)",
    none: 'transparent'
};
const $e489531664054db5$var$getContainerTextBgAndBorderColor = (appearance)=>({
        backgroundColor: $e489531664054db5$var$backgroundColor[appearance],
        borderColor: $e489531664054db5$var$borderColor[appearance],
        color: `var(--ds-text, ${0, $ab6d6432a4c55680$export$fbda843f0a27fe96})`,
        cursor: 'text',
        '&:hover:not([data-disabled])': {
            backgroundColor: $e489531664054db5$var$backgroundColorHover[appearance],
            borderColor: $e489531664054db5$var$borderColorHover[appearance]
        },
        '&:focus-within:not([data-disabled])': {
            backgroundColor: $e489531664054db5$var$backgroundColorFocus[appearance],
            borderColor: $e489531664054db5$var$borderColorFocus[appearance],
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$e489531664054db5$var$borderColorFocus[appearance]}`
        },
        '&[data-disabled]': {
            color: `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})`,
            cursor: 'not-allowed',
            // Disabled background and border styles should not be applied to components that
            // have either no background or transparent background to begin with
            ...appearance === 'standard' && {
                backgroundColor: `var(--ds-background-disabled, ${0, $ab6d6432a4c55680$export$e655ef011c4aa1a2})`,
                borderColor: `var(--ds-background-disabled, ${0, $ab6d6432a4c55680$export$e655ef011c4aa1a2})`
            }
        },
        '&[data-invalid], &[data-invalid]:hover': {
            borderColor: `var(--ds-border-danger, ${0, $ab6d6432a4c55680$export$2010d0fb4295b346})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-danger, ${0, $ab6d6432a4c55680$export$2010d0fb4295b346})`}`
        },
        '&[data-invalid]:focus-within': {
            backgroundColor: `var(--ds-background-input-pressed, ${0, $ab6d6432a4c55680$export$29a4f05edc054374})`,
            borderColor: `var(--ds-border-focused, ${0, $ab6d6432a4c55680$export$215b7063051591f1})`,
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${`var(--ds-border-focused, ${0, $ab6d6432a4c55680$export$215b7063051591f1})`}`
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[data-invalid]:focus-within': {
                borderColor: 'Highlight'
            },
            '&:focus-within': {
                borderColor: 'Highlight'
            },
            '&[data-disabled]': {
                borderColor: 'GrayText'
            }
        }
    });
const $e489531664054db5$var$widthMap = {
    xsmall: 80,
    small: 160,
    medium: 240,
    large: 320,
    xlarge: 480
};
const $e489531664054db5$var$getMaxWidth = (width)=>!width ? `100%` : width in $e489531664054db5$var$widthMap ? $e489531664054db5$var$widthMap[width] : +width;
const $e489531664054db5$export$5972a68b6e54f38f = (appearance, width)=>({
        alignItems: 'center',
        ...$e489531664054db5$var$getContainerTextBgAndBorderColor(appearance),
        borderRadius: 3,
        borderWidth: "var(--ds-border-width, 1px)",
        // add 1px padding on both top and bottom to keep the same overall height after border reduced from 2px to 1px under feature flag
        ...appearance !== 'none' ? {
            padding: `${"var(--ds-border-width, 1px)"} 0`
        } : {},
        borderStyle: appearance === 'none' ? 'none' : 'solid',
        boxSizing: 'border-box',
        display: 'flex',
        flex: '1 1 100%',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        justifyContent: 'space-between',
        maxWidth: $e489531664054db5$var$getMaxWidth(width),
        overflow: 'hidden',
        transition: `background-color 0.2s ease-in-out, border-color 0.2s ease-in-out`,
        wordWrap: 'break-word',
        verticalAlign: 'top',
        pointerEvents: 'auto'
    });
const $e489531664054db5$export$3eeb47dc8e6249d9 = ()=>({
        backgroundColor: 'transparent',
        border: 0,
        boxSizing: 'border-box',
        color: 'inherit',
        cursor: 'inherit',
        font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
        minWidth: '0',
        outline: 'none',
        width: '100%',
        '&[data-monospaced]': {
            fontFamily: "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)"
        },
        '&[data-compact]': {
            padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&:not([data-compact])': {
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-075, 6px)"}`
        },
        '&[disabled]': {
            // Safari (WebKit) adds a -webkit-text-fill-color style to disabled inputs
            // which takes priority over color and makes the text unreadable. Need to
            // override it with the color we want.
            WebkitTextFillColor: `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})`
        },
        // Hide the clear indicator on Edge (Windows only)
        '&::-ms-clear': {
            display: 'none'
        },
        '&:invalid': {
            boxShadow: 'none'
        },
        '&:placeholder-shown': {
            textOverflow: 'ellipsis'
        },
        '&::placeholder': {
            color: `var(--ds-text-subtlest, ${0, $ab6d6432a4c55680$export$f563ee71e9ee74cd})`,
            '&:disabled': {
                color: `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})`
            }
        },
        '@media screen and (-ms-high-contrast: active)': {
            '&[disabled]': {
                color: 'GrayText'
            }
        }
    });

});




parcelRegister("jrWj3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e28dc45bb7007cd8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $fw3UM = parcelRequire("fw3UM");

var $e1HCz = parcelRequire("e1HCz");

var $49rmB = parcelRequire("49rmB");

var $lHkHI = parcelRequire("lHkHI");
class $e28dc45bb7007cd8$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fw3UM.default), {
            facet: this.props.facet,
            facetType: this.props.facet.get('type'),
            filters: this.props.filters,
            hiddenFilters: this.props.hiddenFilters,
            itemFactory: this.props.itemFactory,
            onFacetProductClick: this.props.onFacetProductClick,
            perspective: this.props.perspective,
            sortingLogicForCategory: this.props.sortingLogicForCategory,
            stateChangeRequested: this.props.stateChangeRequested,
            FacetComponent: this.props.FacetComponent,
            ConjunctiveFacet: (0, $e1HCz.default),
            DisjunctiveFacet: (0, $49rmB.default)
        });
    }
}

});
parcelRegister("e1HCz", function(module, exports) {

$parcel$export(module.exports, "default", () => $a362feebaad62951$export$2e2bcd8739ae039);

var $9osuT = parcelRequire("9osuT");

var $1Qivz = parcelRequire("1Qivz");
parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $6jEcw = parcelRequire("6jEcw");

var $2rn21 = parcelRequire("2rn21");

var $lHkHI = parcelRequire("lHkHI");
function $a362feebaad62951$export$2e2bcd8739ae039(props) {
    const isSelectedValue = (facetProductValue)=>props.filters.get(props.facet.get('key')) === facetProductValue;
    const createNewFilters = (facetProduct)=>props.filters.get(props.facet.get('key')) === facetProduct ? props.filters.delete(props.facet.get('key')) : props.filters.set(props.facet.get('key'), facetProduct);
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2rn21.default), {
        closeOnItemSelected: true,
        createNewFilters: createNewFilters,
        facet: props.facet,
        filters: props.filters,
        fireAnalyticsEvent: fireAnalyticsEvent,
        hiddenFilters: props.hiddenFilters,
        isSelectedValue: isSelectedValue,
        itemFactory: props.itemFactory,
        FacetComponent: props.FacetComponent,
        onFacetProductClick: props.onFacetProductClick,
        perspective: props.perspective,
        sortingLogicForCategory: props.sortingLogicForCategory,
        stateChangeRequested: props.stateChangeRequested
    });
}
$a362feebaad62951$export$2e2bcd8739ae039.propTypes = {
    facet: (0, $6jEcw.default).processedFacet.isRequired,
    filters: (0, $90ON9.default).filters.isRequired,
    hiddenFilters: (0, $6jEcw.default).hiddenFilters.isRequired,
    itemFactory: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    FacetComponent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    onFacetProductClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    sortingLogicForCategory: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
};

});
parcelRegister("2rn21", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c6ff7f9f4c17fec$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $biTOe = parcelRequire("biTOe");

var $eUqFw = parcelRequire("eUqFw");

var $fCICH = parcelRequire("fCICH");

var $isqrX = parcelRequire("isqrX");

var $eRLqU = parcelRequire("eRLqU");

var $lHkHI = parcelRequire("lHkHI");
function $1c6ff7f9f4c17fec$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1c6ff7f9f4c17fec$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1c6ff7f9f4c17fec$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1c6ff7f9f4c17fec$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1c6ff7f9f4c17fec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1c6ff7f9f4c17fec$export$d2b618d8c796f70 = (0, $3UXZ8.default)("div", {
    target: "e1mvubcl0",
    label: "FacetsHorizontalContainer"
})({
    name: "xxdqwu",
    styles: "display:flex;flex-wrap:wrap;align-items:center;"
});
class $1c6ff7f9f4c17fec$var$FacetView extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "facetProductSelected", (selection)=>{
            this.props.onFacetProductClick(null, $1c6ff7f9f4c17fec$var$_objectSpread($1c6ff7f9f4c17fec$var$_objectSpread({}, selection.item), {}, {
                facetKey: this.props.facet.get('key')
            }));
        });
    }
    mapProductstoItem(facetProduct) {
        const value = facetProduct.get('value');
        const selected = this.props.isSelectedValue(value);
        return this.props.itemFactory({
            options: {
                content: "".concat(facetProduct.get('label')),
                selectedContent: facetProduct.get('label'),
                type: this.props.itemType,
                selected: selected,
                isChecked: selected,
                facetKey: this.props.facet.get('key'),
                facetValue: value
            },
            newFilters: this.props.createNewFilters(value)
        });
    }
    getFreeCheckbox(facet) {
        const freeFilterIndex = facet.get('facetProducts').findIndex((filter)=>filter.get('value') === 'free');
        if (freeFilterIndex < 0) return null;
        const freeFilter = facet.get('facetProducts').get(freeFilterIndex);
        const checkBoxItem = [
            this.mapProductstoItem(freeFilter)
        ];
        return checkBoxItem;
    }
    getItems(facet) {
        const sort = (0, $fCICH.getFilters)().get(facet.get('key')).get('sortFunction') || ((fps)=>fps);
        const sortedFacetProducts = sort(this.props.facet.get('facetProducts'), this.props.sortingLogicForCategory);
        const facetProducts = sortedFacetProducts.filter((fp)=>(0, $isqrX.shouldFacetProductBeShown)(this.props.facet.get('key'), fp.get('value'), this.props.hiddenFilters) && fp.get('value') !== 'free' && (0, $isqrX.shouldFreeStarterFacetProductBeShown)(fp.get('value'), this.props.enableFreeStarterTierFilter) // returns true for other facet products
        ).map((fp)=>this.mapProductstoItem(fp));
        const collate = (0, $fCICH.getFilters)().get(facet.get('key')).get('collateFunction') || ((fps)=>fps);
        return collate(facetProducts, this.props.sortingLogicForCategory);
    }
    renderFacetComponent(itemList, FacetComponent) {
        return /*#__PURE__*/ (0, $lHkHI.jsx)(FacetComponent, {
            closeOnItemSelected: this.props.closeOnItemSelected,
            facetBar: "top",
            facetKey: this.props.facet.get('key'),
            facetType: this.props.facet.get('type'),
            filters: this.props.filters,
            label: this.props.facet.get('topBarLabel'),
            items: itemList,
            onFacetProductClick: this.props.onFacetProductClick,
            perspective: this.props.perspective,
            stateChangeRequested: this.props.stateChangeRequested,
            onItemActivated: this.facetProductSelected
        });
    }
    renderFreeCheckbox(freeCheckBoxItem) {
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eRLqU.default), {
            facetKey: this.props.facet.get('key'),
            facetType: this.props.facet.get('type'),
            filters: this.props.filters,
            label: this.props.facet.get('topBarLabel'),
            items: freeCheckBoxItem,
            onFacetProductClick: this.props.onFacetProductClick,
            perspective: this.props.perspective,
            stateChangeRequested: this.props.stateChangeRequested,
            onItemActivated: this.facetProductSelected
        });
    }
    render() {
        // Done as part of MC-730 experiment. Need to modify it after experiment
        const freeCheckBoxItem = this.getFreeCheckbox(this.props.facet);
        const itemList = this.getItems(this.props.facet);
        const FacetComponent = this.props.FacetComponent;
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($1c6ff7f9f4c17fec$export$d2b618d8c796f70, {
            children: [
                this.props.facet.get('key') === 'moreFilters' && this.renderFreeCheckbox(freeCheckBoxItem),
                this.renderFacetComponent(itemList, FacetComponent)
            ]
        });
    }
}
var $1c6ff7f9f4c17fec$export$2e2bcd8739ae039 = (0, $biTOe.withFeatureFlags)($1c6ff7f9f4c17fec$var$FacetView);

});
parcelRegister("eRLqU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad2acf20d84e3030$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $jbfSh = parcelRequire("jbfSh");
parcelRequire("eUqFw");

var $9MMjz = parcelRequire("9MMjz");

var $lHkHI = parcelRequire("lHkHI");
function $ad2acf20d84e3030$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ad2acf20d84e3030$var$FacetCheckboxGroupWrapper = (0, $3UXZ8.default)("div", {
    target: "emfn83h0",
    label: "FacetCheckboxGroupWrapper"
})({
    name: "1d5m7t5",
    styles: "margin-left:5px;margin-right:5px;"
});
function $ad2acf20d84e3030$var$FacetCheckboxGroup(props) {
    return /*#__PURE__*/ (0, $lHkHI.jsx)($ad2acf20d84e3030$var$FacetCheckboxGroupWrapper, {
        "data-testid": (0, $9MMjz.TEST_IDS).FACET_CHECKBOX_GROUP,
        children: props.items.map((item)=>{
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jbfSh.default), {
                isChecked: item.isChecked,
                value: item.content,
                label: item.selectedContent,
                onChange: (selection)=>props.onItemActivated({
                        selection: selection,
                        item: item
                    })
            }, item.content);
        })
    });
}
var $ad2acf20d84e3030$export$2e2bcd8739ae039 = $ad2acf20d84e3030$var$FacetCheckboxGroup;

});
parcelRegister("jbfSh", function(module, exports) {

$parcel$export(module.exports, "default", () => $df6b5bb868fce840$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2MblP = parcelRequire("2MblP");

var $2lroc = parcelRequire("2lroc");


var $8n7Vn = parcelRequire("8n7Vn");
var $lYtkQ = parcelRequire("lYtkQ");
var $eguaP = parcelRequire("eguaP");
var $ikBXK = parcelRequire("ikBXK");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $df6b5bb868fce840$var$checkboxStyles = (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $ab6d6432a4c55680$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $df6b5bb868fce840$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $2MblP.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "@atlaskit/checkbox",
        packageVersion: "13.7.1"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $2lroc.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eUqFw.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return (0, $byn9U.jsx)((0, $lYtkQ.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        xcss: xcss
    }, (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0
    }, rest, {
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $df6b5bb868fce840$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    })), (0, $byn9U.jsx)((0, $8n7Vn.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && (0, $byn9U.jsx)((0, $eguaP.default), null, label, isRequired && (0, $byn9U.jsx)((0, $ikBXK.default), null)));
}));
$df6b5bb868fce840$var$Checkbox.displayName = 'Checkbox';
var $df6b5bb868fce840$export$2e2bcd8739ae039 = $df6b5bb868fce840$var$Checkbox;

});
parcelRegister("2lroc", function(module, exports) {

$parcel$export(module.exports, "default", () => $1b52c9e16d974bd7$export$2e2bcd8739ae039);
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * @param refs: An array of refs (as function or ref object)
 */ function $1b52c9e16d974bd7$export$2e2bcd8739ae039(refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null) ref.current = value;
        });
    };
}

});

parcelRegister("8n7Vn", function(module, exports) {

$parcel$export(module.exports, "default", () => $61869e58f51e4800$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $feXUN = parcelRequire("feXUN");
function $61869e58f51e4800$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $61869e58f51e4800$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$61869e58f51e4800$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return (0, $byn9U.jsx)((0, $feXUN.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $61869e58f51e4800$export$2e2bcd8739ae039 = $61869e58f51e4800$var$CheckboxIcon;

});

parcelRegister("lYtkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fff5f4f0c76734b8$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $fff5f4f0c76734b8$var$baseStyles = (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $ab6d6432a4c55680$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $fff5f4f0c76734b8$var$textLabelLayoutStyles = (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $fff5f4f0c76734b8$var$disabledStyles = (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $ab6d6432a4c55680$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $fff5f4f0c76734b8$var$labelStyles = (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $ab6d6432a4c55680$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $ab6d6432a4c55680$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $ab6d6432a4c55680$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $ab6d6432a4c55680$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $ab6d6432a4c55680$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $ab6d6432a4c55680$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $ab6d6432a4c55680$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $ab6d6432a4c55680$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $ab6d6432a4c55680$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $ab6d6432a4c55680$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $ab6d6432a4c55680$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $ab6d6432a4c55680$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $ab6d6432a4c55680$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $ab6d6432a4c55680$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $ab6d6432a4c55680$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $ab6d6432a4c55680$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $ab6d6432a4c55680$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $fff5f4f0c76734b8$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $fff5f4f0c76734b8$var$baseStyles,
            label && $fff5f4f0c76734b8$var$textLabelLayoutStyles,
            isDisabled && $fff5f4f0c76734b8$var$disabledStyles,
            $fff5f4f0c76734b8$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("eguaP", function(module, exports) {

$parcel$export(module.exports, "default", () => $02ae18a1bc35029f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $02ae18a1bc35029f$var$labelTextStyles = (0, $byn9U.css)({
    alignSelf: 'center',
    gridArea: '1 / 2 / 2 / 3'
});
function $02ae18a1bc35029f$export$2e2bcd8739ae039({ children: children }) {
    return (0, $byn9U.jsx)("span", {
        css: $02ae18a1bc35029f$var$labelTextStyles
    }, children);
}

});

parcelRegister("ikBXK", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5878ad6b9293b79$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $d5878ad6b9293b79$var$requiredIndicatorStyles = (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $ab6d6432a4c55680$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $d5878ad6b9293b79$export$2e2bcd8739ae039() {
    return (0, $byn9U.jsx)("span", {
        css: $d5878ad6b9293b79$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});





parcelRegister("49rmB", function(module, exports) {

$parcel$export(module.exports, "default", () => $305d3a84b0b36fe3$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $9osuT = parcelRequire("9osuT");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");
parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $6jEcw = parcelRequire("6jEcw");

var $2rn21 = parcelRequire("2rn21");

var $lHkHI = parcelRequire("lHkHI");
function $305d3a84b0b36fe3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $305d3a84b0b36fe3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $305d3a84b0b36fe3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $305d3a84b0b36fe3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $305d3a84b0b36fe3$export$2e2bcd8739ae039(props) {
    const itemFactory = (args)=>props.itemFactory($305d3a84b0b36fe3$var$_objectSpread($305d3a84b0b36fe3$var$_objectSpread({}, args), {}, {
            options: $305d3a84b0b36fe3$var$_objectSpread($305d3a84b0b36fe3$var$_objectSpread({}, args.options), {}, {
                isChecked: args.options.selected
            })
        }));
    const isSelectedValue = (facetProduct)=>{
        const filtersForThisFacet = props.filters.get(props.facet.get('key'));
        const facetProductsSelected = (0, $g5DHJ.Iterable).isIterable(filtersForThisFacet) ? filtersForThisFacet : (0, $g5DHJ.Set)([
            filtersForThisFacet
        ]);
        return facetProductsSelected.contains(facetProduct);
    };
    const createNewFilters = (facetProduct)=>props.filters.update(props.facet.get('key'), (fs)=>fs.includes(facetProduct) ? fs.delete(facetProduct) : fs.add(facetProduct));
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2rn21.default), {
        createNewFilters: createNewFilters,
        facet: props.facet,
        filters: props.filters,
        fireAnalyticsEvent: fireAnalyticsEvent,
        hiddenFilters: props.hiddenFilters,
        isSelectedValue: isSelectedValue,
        itemFactory: itemFactory,
        itemType: "checkbox",
        onFacetProductClick: props.onFacetProductClick,
        perspective: props.perspective,
        stateChangeRequested: props.stateChangeRequested,
        FacetComponent: props.FacetComponent
    });
}
$305d3a84b0b36fe3$export$2e2bcd8739ae039.propTypes = {
    facet: (0, $6jEcw.default).processedFacet.isRequired,
    filters: (0, $90ON9.default).filters.isRequired,
    hiddenFilters: (0, $6jEcw.default).hiddenFilters.isRequired,
    itemFactory: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    onFacetProductClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    FacetComponent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
};

});



parcelRegister("1D32T", function(module, exports) {

$parcel$export(module.exports, "default", () => $12fbcbc286e37ebb$export$2e2bcd8739ae039);

var $bwPfh = parcelRequire("bwPfh");

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $ZN2Lb = parcelRequire("ZN2Lb");
var $71CV8 = parcelRequire("71CV8");

var $8gcXz = parcelRequire("8gcXz");

var $9osuT = parcelRequire("9osuT");

var $9l6Pq = parcelRequire("9l6Pq");

var $aB8Wc = parcelRequire("aB8Wc");
parcelRequire("ibjku");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $isqrX = parcelRequire("isqrX");

var $5YKni = parcelRequire("5YKni");


var $MjCo4 = parcelRequire("MjCo4");

var $jrWj3 = parcelRequire("jrWj3");

var $7Aual = parcelRequire("7Aual");

var $lHkHI = parcelRequire("lHkHI");
const $12fbcbc286e37ebb$var$_excluded = [
    "triggerRef"
];
function $12fbcbc286e37ebb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $12fbcbc286e37ebb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $12fbcbc286e37ebb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $12fbcbc286e37ebb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $12fbcbc286e37ebb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $12fbcbc286e37ebb$var$FacetVerticalMenuStyles = (0, $3UXZ8.default)("div", {
    target: "e93fhdp0",
    label: "FacetVerticalMenuStyles"
})({
    name: "1ub7cu0",
    styles: "padding:0 10px;div[data-role='droplistContent']{max-height:100% !important;}"
});
const $12fbcbc286e37ebb$var$DropdownItemGroupStyled = /*#__PURE__*/ (0, $3UXZ8.default)((0, $71CV8.default), {
    target: "e93fhdp1",
    label: "DropdownItemGroupStyled"
})({
    name: "1fd0cf4",
    styles: "width:calc(100vw - 20px);max-height:60vh;"
});
const $12fbcbc286e37ebb$export$f99233281efd08a0 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H3), {
    target: "e93fhdp2",
    label: "Title"
})({
    name: "13ddqne",
    styles: "margin:10px;font-size:16px;font-weight:600;"
});
const $12fbcbc286e37ebb$var$TextSearch = (0, $3UXZ8.default)("div", {
    target: "e93fhdp3",
    label: "TextSearch"
})({
    name: "1gf7ecb",
    styles: "padding:0 10px 15px;"
});
const $12fbcbc286e37ebb$export$a06f1c675e846f6f = (0, $3UXZ8.default)("div", {
    target: "e93fhdp4",
    label: "Footer"
})({
    name: "1fe5rwc",
    styles: "display:flex;flex-direction:column;align-items:center;position:static;"
});
const $12fbcbc286e37ebb$var$ButtonContainer = (0, $3UXZ8.default)("div", {
    target: "e93fhdp5",
    label: "ButtonContainer"
})({
    name: "l60fdn",
    styles: "display:flex;width:100%;padding-top:10px;flex-direction:column;"
});
const $12fbcbc286e37ebb$var$centeredButton = {
    name: "ib5mzi-centeredButton",
    styles: "display:flex;justify-content:center;min-height:40px;height:40px;align-items:center;span{justify-content:center;margin:3px var(--ds-space-025, 2px);};label:centeredButton;"
};
const $12fbcbc286e37ebb$export$353f5b6fc5456de1 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $9oiuL.default), {
    target: "e93fhdp6",
    label: "Button"
})("margin:0 10px;", $12fbcbc286e37ebb$var$centeredButton, "");
const $12fbcbc286e37ebb$export$4129321aecd13375 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $9oiuL.default), {
    target: "e93fhdp7",
    label: "TriggerButton"
})("width:100%;", $12fbcbc286e37ebb$var$centeredButton, "");
const $12fbcbc286e37ebb$var$defaultState = {
    facetProductClicks: (0, $g5DHJ.OrderedSet)(),
    isOpen: false
};
class $12fbcbc286e37ebb$var$FacetsVerticalMenu extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", $12fbcbc286e37ebb$var$_objectSpread($12fbcbc286e37ebb$var$_objectSpread({}, $12fbcbc286e37ebb$var$defaultState), {}, {
            unappliedFilters: this.props.filters,
            showSearchOverlay: false
        }));
        (0, $5zQU9.default)(this, "reset", ()=>{
            this.setState($12fbcbc286e37ebb$var$_objectSpread($12fbcbc286e37ebb$var$_objectSpread({}, $12fbcbc286e37ebb$var$defaultState), {}, {
                unappliedFilters: this.props.filters
            }));
        });
        (0, $5zQU9.default)(this, "onOpenChange", (_ref)=>{
            let { isOpen: isOpen } = _ref;
            if (isOpen) this.setState({
                isOpen: true,
                unappliedFilters: this.props.filters
            });
            else this.reset();
        });
        (0, $5zQU9.default)(this, "open", ()=>{
            this.setState({
                isOpen: true,
                unappliedFilters: this.props.filters
            });
        });
        (0, $5zQU9.default)(this, "close", ()=>{
            this.reset();
        });
        (0, $5zQU9.default)(this, "toggle", ()=>{
            if (this.state.isOpen) this.close();
            else this.open();
        });
        (0, $5zQU9.default)(this, "onTriggerClick", ()=>{
            this.props.fireAnalyticsEvent({
                eventType: (0, $5YKni.ButtonClickedEvent),
                actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_MOBILE_DROPDOWN_TOGGLE_BUTTON),
                source: (0, $5YKni.EVENT_SOURCE),
                attributes: {
                    expanded: !this.state.isOpen
                }
            }, (0, $5YKni.EVENT_CHANNEL));
            this.toggle();
        });
        (0, $5zQU9.default)(this, "onFacetProductClick", (event, item)=>{
            this.setState({
                unappliedFilters: item.newFilters
            });
            this.setState((_ref2)=>{
                let { facetProductClicks: facetProductClicks } = _ref2;
                return {
                    facetProductClicks: facetProductClicks.add((0, $g5DHJ.Map)({
                        event: event,
                        item: item
                    }))
                };
            });
        });
        (0, $5zQU9.default)(this, "onApplyClick", ()=>{
            this.props.fireAnalyticsEvent({
                eventType: (0, $5YKni.ButtonClickedEvent),
                actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_MOBILE_DROPDOWN_MENU_APPLY_BUTTON),
                source: (0, $5YKni.EVENT_SOURCE),
                attributes: {
                    currentPerspective: this.props.perspective,
                    filters: this.state.unappliedFilters.toJS()
                }
            }, (0, $5YKni.EVENT_CHANNEL));
            this.props.stateChangeRequested({
                filters: this.state.unappliedFilters,
                perspective: (0, $37a31921fd56c86d$export$a6b9aaee40d49fd0)
            });
            this.reset();
        });
        (0, $5zQU9.default)(this, "renderTrigger", (_ref3)=>{
            let { triggerRef: triggerRef } = _ref3, otherProps = (0, $bwPfh.default)(_ref3, $12fbcbc286e37ebb$var$_excluded);
            return /*#__PURE__*/ (0, $lHkHI.jsx)($12fbcbc286e37ebb$var$ButtonContainer, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)($12fbcbc286e37ebb$export$4129321aecd13375, $12fbcbc286e37ebb$var$_objectSpread($12fbcbc286e37ebb$var$_objectSpread({
                    ref: triggerRef,
                    isSelected: this.state.isOpen,
                    onClick: this.onTriggerClick
                }, otherProps), {}, {
                    children: "Search/filter"
                }))
            });
        });
        (0, $5zQU9.default)(this, "renderFooter", ()=>{
            return /*#__PURE__*/ (0, $lHkHI.jsxs)($12fbcbc286e37ebb$export$a06f1c675e846f6f, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($12fbcbc286e37ebb$var$ButtonContainer, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)($12fbcbc286e37ebb$export$353f5b6fc5456de1, {
                            appearance: "primary",
                            onClick: this.onApplyClick,
                            children: "Apply filters"
                        })
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($12fbcbc286e37ebb$var$ButtonContainer, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)($12fbcbc286e37ebb$export$353f5b6fc5456de1, {
                            appearance: "subtle",
                            onClick: this.close,
                            children: "Cancel"
                        })
                    })
                ]
            });
        });
        (0, $5zQU9.default)(this, "handleTextSearchChange", (change)=>{
            this.setState({
                unappliedFilters: change.newFilters
            });
        });
        (0, $5zQU9.default)(this, "handleSearchInputClick", ()=>{
            var _this$props$statsigCl;
            const enableSearchOverlay = (_this$props$statsigCl = this.props.statsigClient) === null || _this$props$statsigCl === void 0 ? void 0 : _this$props$statsigCl.enableAetherSearchOverlay();
            if (enableSearchOverlay) this.setState({
                showSearchOverlay: true
            });
        });
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
            children: [
                this.state.showSearchOverlay && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aB8Wc.SearchOverlay), {
                    onClose: ()=>{
                        this.setState({
                            showSearchOverlay: false
                        });
                    },
                    analytics: {
                        source: 'search-mobile'
                    }
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($12fbcbc286e37ebb$var$FacetVerticalMenuStyles, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ZN2Lb.default), {
                        trigger: this.renderTrigger,
                        onOpenChange: this.onOpenChange,
                        isOpen: this.state.isOpen,
                        shouldFlip: false,
                        children: /*#__PURE__*/ (0, $lHkHI.jsxs)($12fbcbc286e37ebb$var$DropdownItemGroupStyled, {
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)($12fbcbc286e37ebb$export$f99233281efd08a0, {
                                    children: "Search and filter apps"
                                }),
                                this.props.displayTextSearch ? /*#__PURE__*/ // eslint-disable-next-line styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions
                                (0, $lHkHI.jsx)($12fbcbc286e37ebb$var$TextSearch, {
                                    onClick: this.handleSearchInputClick,
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $MjCo4.default), {
                                        filters: this.state.unappliedFilters,
                                        onChange: this.handleTextSearchChange,
                                        perspective: this.props.perspective,
                                        screenClass: this.props.screenClass,
                                        stateChangeRequested: this.props.stateChangeRequested
                                    })
                                }) : undefined,
                                this.props.facets.filter((facet)=>(0, $isqrX.shouldFacetBeShown)(facet.get('key'), this.props.hiddenFilters)).map((facet)=>{
                                    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jrWj3.default), {
                                        facet: facet,
                                        filters: this.state.unappliedFilters,
                                        hiddenFilters: this.props.hiddenFilters,
                                        itemFactory: this.props.itemFactory,
                                        onFacetProductClick: this.onFacetProductClick,
                                        perspective: this.props.perspective,
                                        stateChangeRequested: this.props.stateChangeRequested,
                                        FacetComponent: (0, $7Aual.default)
                                    }, "facet-".concat(facet.get('key')));
                                }),
                                this.renderFooter()
                            ]
                        })
                    })
                })
            ]
        });
    }
}
var $12fbcbc286e37ebb$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)((0, $9l6Pq.withStatsig)($12fbcbc286e37ebb$var$FacetsVerticalMenu));

});
parcelRegister("7Aual", function(module, exports) {

$parcel$export(module.exports, "default", () => $58634b84d2274c77$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $drftW = parcelRequire("drftW");

var $1VibC = parcelRequire("1VibC");

var $59QdN = parcelRequire("59QdN");

var $j0gMm = parcelRequire("j0gMm");

var $gykb8 = parcelRequire("gykb8");

var $9osuT = parcelRequire("9osuT");

var $fEeDC = parcelRequire("fEeDC");

var $ibjku = parcelRequire("ibjku");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $hheqg = parcelRequire("hheqg");

var $5YKni = parcelRequire("5YKni");

var $6jEcw = parcelRequire("6jEcw");

var $lHkHI = parcelRequire("lHkHI");
function $58634b84d2274c77$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $58634b84d2274c77$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $58634b84d2274c77$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $58634b84d2274c77$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $58634b84d2274c77$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $58634b84d2274c77$var$FacetMenuSectionStyle = (0, $3UXZ8.default)("div", {
    target: "e1jusbow0",
    label: "FacetMenuSectionStyle"
})({
    name: "13uaed4",
    styles: "width:100%;&:first-of-type{margin-top:0;}"
});
const $58634b84d2274c77$var$commonHeading = /*#__PURE__*/ (0, $ibjku.css)("align-items:center;border-top:1px solid ", (0, $j0gMm.N40), ";color:", (0, $j0gMm.N300), ";display:flex;font-size:16px;font-weight:normal;justify-content:space-between;min-height:40px;padding:0 var(--ds-space-150, 12px);;label:commonHeading;");
const $58634b84d2274c77$var$HeadingSpan = (0, $3UXZ8.default)("span", {
    target: "e1jusbow1",
    label: "HeadingSpan"
})($58634b84d2274c77$var$commonHeading, "");
const $58634b84d2274c77$var$HeadingDiv = (0, $3UXZ8.default)("div", {
    target: "e1jusbow2",
    label: "HeadingDiv"
})($58634b84d2274c77$var$commonHeading, " cursor:pointer;");
const $58634b84d2274c77$var$ItemsList = (0, $3UXZ8.default)("ul", {
    target: "e1jusbow3",
    label: "ItemsList"
})({
    name: "1m4q0rc",
    styles: "display:flex;flex-direction:column;list-style:none;margin:0;padding-left:var(--ds-space-200, 16px);"
});
const $58634b84d2274c77$var$ListItem = (0, $3UXZ8.default)("li", {
    target: "e1jusbow4",
    label: "ListItem"
})({
    name: "1fnb1u5",
    styles: "align-items:center;display:flex;min-height:40px;"
});
class $58634b84d2274c77$var$FacetMenuSection extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            isExpanded: false
        });
        (0, $5zQU9.default)(this, "dismissSelection", ()=>{
            const removeItemFromFilters = (filters, item)=>{
                const facetValues = filters.get(this.props.facetKey);
                return (0, $g5DHJ.Iterable).isIterable(facetValues) ? filters.set(this.props.facetKey, facetValues.remove(item)) : filters.delete(this.props.facetKey);
            };
            const selectedItem = this.props.items.find((i)=>i.selected);
            if (selectedItem) this.props.onItemActivated({
                item: $58634b84d2274c77$var$_objectSpread($58634b84d2274c77$var$_objectSpread({}, selectedItem), {}, {
                    newFilters: removeItemFromFilters(selectedItem.newFilters, selectedItem)
                })
            });
        });
        (0, $5zQU9.default)(this, "renderItems", ()=>this.props.items.map((item, itemIndex)=>/*#__PURE__*/ (0, $lHkHI.jsx)($58634b84d2274c77$var$ListItem, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                        onClick: ()=>{
                            this.props.onItemActivated({
                                item: item
                            });
                            this.toggle();
                        },
                        children: item.content
                    })
                }, itemIndex)));
        (0, $5zQU9.default)(this, "toggle", ()=>{
            this.setState((_ref)=>{
                let { isExpanded: isExpanded } = _ref;
                return {
                    isExpanded: !isExpanded
                };
            });
        });
        (0, $5zQU9.default)(this, "onFacetClick", ()=>{
            const eventType = this.state.isExpanded ? (0, $5YKni.FacetCollapsedEvent) : (0, $5YKni.FacetExpandedEvent);
            this.props.fireAnalyticsEvent({
                eventType: eventType,
                actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_TOPBAR_FACET),
                objectType: (0, $5YKni.OBJECT_TYPE_FILTER),
                objectId: this.props.facetKey,
                source: (0, $5YKni.EVENT_SOURCE),
                attributes: {
                    currentPerspective: this.props.perspective
                }
            }, (0, $5YKni.EVENT_CHANNEL));
            this.toggle();
        });
        (0, $5zQU9.default)(this, "renderHeading", ()=>{
            const selectedItem = this.props.items.find((i)=>i.selected);
            return selectedItem ? /*#__PURE__*/ (0, $lHkHI.jsx)($58634b84d2274c77$var$HeadingSpan, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $59QdN.default), {
                    onBeforeRemoveAction: this.dismissSelection,
                    removeButtonLabel: "Remove filter",
                    text: selectedItem.content
                })
            }) : /*#__PURE__*/ // eslint-disable-next-line styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions
            (0, $lHkHI.jsxs)($58634b84d2274c77$var$HeadingDiv, {
                onClick: this.onFacetClick,
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                        children: this.props.label
                    }),
                    !this.state.isExpanded ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($drftW))), {
                        label: "Expand facet",
                        size: "small"
                    }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1VibC))), {
                        label: "Collapse facet",
                        size: "small"
                    })
                ]
            });
        });
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($58634b84d2274c77$var$FacetMenuSectionStyle, {
            children: [
                this.renderHeading(),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hheqg.Collapse), {
                    isOpened: this.state.isExpanded,
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)($58634b84d2274c77$var$ItemsList, {
                        children: this.renderItems()
                    })
                })
            ]
        });
    }
}
(0, $5zQU9.default)($58634b84d2274c77$var$FacetMenuSection, "propTypes", {
    fireAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    facetKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    label: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    items: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
    onItemActivated: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    perspective: (0, $6jEcw.default).perspective.isRequired
});
var $58634b84d2274c77$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($58634b84d2274c77$var$FacetMenuSection);

});
parcelRegister("59QdN", function(module, exports) {

$parcel$export(module.exports, "default", () => $370f6cfb03332d95$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jnUR4 = parcelRequire("jnUR4");

var $5zGDY = parcelRequire("5zGDY");

var $hRu1S = parcelRequire("hRu1S");

var $3yJNH = parcelRequire("3yJNH");
var $hJdvb = parcelRequire("hJdvb");

var $3puyA = parcelRequire("3puyA");

var $bi4SK = parcelRequire("bi4SK");

var $cTUJW = parcelRequire("cTUJW");

var $lMnxr = parcelRequire("lMnxr");

var $2VXjs = parcelRequire("2VXjs");

var $ikrrN = parcelRequire("ikrrN");

var $1MEQc = parcelRequire("1MEQc");
var $370f6cfb03332d95$var$TagStatus;
(function(TagStatus) {
    TagStatus["Showing"] = "showing";
    TagStatus["Removing"] = "removing";
    TagStatus["Removed"] = "removed";
})($370f6cfb03332d95$var$TagStatus || ($370f6cfb03332d95$var$TagStatus = {}));
const $370f6cfb03332d95$var$packageName = "platform-pkg";
const $370f6cfb03332d95$var$packageVersion = "0.0.0-use.local";
const $370f6cfb03332d95$var$defaultBeforeRemoveAction = ()=>true;
/**
 * These hide the focus ring for the tag when its remove button is focused,
 * preventing a double focus ring.
 */ const $370f6cfb03332d95$var$removingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        boxShadow: `0 0 0 2px transparent`,
        outline: 'none'
    }
});
const $370f6cfb03332d95$var$RemovableTagComponent = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, removeButtonLabel: removeButtonLabel, testId: testId, onBeforeRemoveAction: onBeforeRemoveAction = $370f6cfb03332d95$var$defaultBeforeRemoveAction, onAfterRemoveAction: onAfterRemoveAction = (0, $hRu1S.default), linkComponent: linkComponent }, ref)=>{
    const [status, setStatus] = (0, $eUqFw.useState)("showing");
    const [isHoverCloseButton, setIsHoverCloseButton] = (0, $eUqFw.useState)(false);
    const onAfterRemoveActionWithAnalytics = (0, $jnUR4.useCallbackWithAnalytics)(onAfterRemoveAction, {
        action: 'removed',
        actionSubject: 'tag',
        attributes: {
            componentName: 'tag',
            packageName: $370f6cfb03332d95$var$packageName,
            packageVersion: $370f6cfb03332d95$var$packageVersion
        }
    }, 'atlaskit');
    const handleRemoveComplete = (0, $eUqFw.useCallback)(()=>{
        onAfterRemoveActionWithAnalytics(text);
        setStatus("removed");
    }, [
        onAfterRemoveActionWithAnalytics,
        text
    ]);
    const handleRemoveRequest = (0, $eUqFw.useCallback)(()=>{
        if (onBeforeRemoveAction && onBeforeRemoveAction()) handleRemoveComplete();
    }, [
        handleRemoveComplete,
        onBeforeRemoveAction
    ]);
    const onKeyPress = (0, $eUqFw.useCallback)((e)=>{
        const spacebarOrEnter = e.key === ' ' || e.key === 'Enter';
        if (spacebarOrEnter) {
            e.stopPropagation();
            handleRemoveRequest();
        }
    }, [
        handleRemoveRequest
    ]);
    const removingTag = (0, $eUqFw.useCallback)(()=>setStatus("removing"), []);
    const showingTag = (0, $eUqFw.useCallback)(()=>setStatus("showing"), []);
    const handleMouseOver = (0, $eUqFw.useCallback)(()=>setIsHoverCloseButton(true), []);
    const handleMouseOut = (0, $eUqFw.useCallback)(()=>setIsHoverCloseButton(false), []);
    const removeButton = isRemovable ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $1MEQc.default), {
        "aria-label": `${removeButtonLabel || 'Remove'} ${text}`,
        onClick: handleRemoveRequest,
        onFocus: removingTag,
        onBlur: showingTag,
        onKeyPress: onKeyPress,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut,
        testId: `close-button-${testId}`
    }) : undefined;
    const content = /*#__PURE__*/ (0, $byn9U.jsx)((0, $ikrrN.default), {
        elemBefore: elemBefore,
        isRemovable: isRemovable,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    const hoverCloseButtonColors = {
        backgroundColor: (0, $3puyA.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle, #00000000)" : undefined,
        // Tag background color on hover
        [(0, $bi4SK.cssVar).color.background.hover]: (0, $3puyA.fg)('platform-component-visual-refresh') ? undefined : $cTUJW.removalHoverBackgroundColors,
        // Tag background color on press
        [(0, $bi4SK.cssVar).color.background.active]: (0, $3puyA.fg)('platform-component-visual-refresh') ? undefined : $cTUJW.removalActiveBackgroundColors,
        // The tag text on hover of remove button
        [(0, $bi4SK.cssVar).color.text.default]: (0, $3puyA.fg)('platform-component-visual-refresh') ? undefined : $cTUJW.removalTextColors,
        // 'elemBefore' text on press of remove button
        [(0, $bi4SK.cssVar).color.text.active]: (0, $3puyA.fg)('platform-component-visual-refresh') ? undefined : $cTUJW.removalTextColors,
        // The tag link text on hover of remove button
        [(0, $bi4SK.cssVar).color.text.link]: (0, $3puyA.fg)('platform-component-visual-refresh') ? undefined : $cTUJW.removalTextColors
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $3yJNH.default), null, !(status === "removed") && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hJdvb.default), null, (motion)=>{
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $lMnxr.default), {
            ref: (0, $5zGDY.default)([
                motion.ref,
                ref
            ]),
            appearance: appearance,
            color: color,
            testId: testId,
            css: [
                status === "removing" && $370f6cfb03332d95$var$removingStyles
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: isHoverCloseButton ? hoverCloseButtonColors : undefined,
            "data-removable": true,
            "data-removing": status === "removing",
            "data-ishoverclosebutton": isHoverCloseButton,
            href: href,
            before: /*#__PURE__*/ (0, $byn9U.jsx)((0, $2VXjs.default), {
                elemBefore: elemBefore
            }),
            contentElement: content,
            after: removeButton
        });
    }));
});
/**
 * __Removable tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * Once a tag has been removed, it cannot be re-rendered. Removable tags are visible in "edit" mode or in multi-select controls.
 *
 */ const $370f6cfb03332d95$var$RemovableTag = /*#__PURE__*/ (0, $eUqFw.memo)($370f6cfb03332d95$var$RemovableTagComponent);
var $370f6cfb03332d95$export$2e2bcd8739ae039 = $370f6cfb03332d95$var$RemovableTag;

});
parcelRegister("hJdvb", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c95022330525b26$export$2e2bcd8739ae039);


var $bA2mG = parcelRequire("bA2mG");

var $dtwdA = parcelRequire("dtwdA");

var $3DW9D = parcelRequire("3DW9D");

var $1iASr = parcelRequire("1iASr");

var $3yJNH = parcelRequire("3yJNH");
/**
 * __ShrinkOut__
 *
 * Will shrink an element down to nothing when exiting.
 * Works best with flex children as collapsing margins can come with undesired behaviour.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/motion/docs/entering-motions)
 */ const $3c95022330525b26$var$ShrinkOut = ({ children: children, duration: duration = (0, $bA2mG.smallDurationMs), onFinish: onFinish })=>{
    const [element, setElementRef] = (0, $3DW9D.useElementRef)();
    const exiting = (0, $3yJNH.useExitingPersistence)();
    const requestAnimationFrame = (0, $dtwdA.useRequestAnimationFrame)();
    const setTimeout = (0, $dtwdA.useSetTimeout)();
    const direction = exiting.isExiting ? 'exiting' : 'entering';
    (0, $1iASr.useLayoutEffect)(()=>{
        if (exiting.isExiting && element) {
            const newStyles = {
                // We fix both width and height because when changing box sizing to border-box.
                width: `${element.offsetWidth}px`,
                height: `${element.offsetHeight}px`,
                boxSizing: 'border-box',
                willChange: 'width,margin'
            };
            Object.assign(element.style, newStyles);
            requestAnimationFrame(()=>{
                requestAnimationFrame(()=>{
                    const newStyles = {
                        width: '0px',
                        margin: '0px',
                        transitionTimingFunction: (0, $107158c6da8dcc8b$export$929e5a82286172a6),
                        transitionDuration: `${duration}ms`,
                        transitionProperty: 'width,margin'
                    };
                    Object.assign(element.style, newStyles);
                    setTimeout(()=>{
                        exiting.onFinish && exiting.onFinish();
                        onFinish && onFinish('exiting');
                    }, duration);
                });
            });
        }
    });
    return children({
        ref: setElementRef
    }, direction);
};
var $3c95022330525b26$export$2e2bcd8739ae039 = $3c95022330525b26$var$ShrinkOut;

});
const $107158c6da8dcc8b$export$c07234257a03d5e9 = 'cubic-bezier(0.15,1,0.3,1)';
const $107158c6da8dcc8b$export$57636bb43b1ccbb0 = 'cubic-bezier(0.2,0,0,1)';
const $107158c6da8dcc8b$export$929e5a82286172a6 = 'cubic-bezier(0.8,0,0,0.8)';

parcelRegister("3DW9D", function(module, exports) {

$parcel$export(module.exports, "useElementRef", () => $3f8cc885160c6730$export$ff879f35a69d56b7);

var $eUqFw = parcelRequire("eUqFw");
const $3f8cc885160c6730$export$ff879f35a69d56b7 = ()=>{
    const elementRef = (0, $eUqFw.useRef)(null);
    const setRef = (0, $eUqFw.useCallback)((ref)=>{
        elementRef.current = ref;
    }, []);
    return [
        elementRef.current,
        setRef
    ];
};

});


parcelRegister("bi4SK", function(module, exports) {

$parcel$export(module.exports, "tagHeight", () => $d38c6a36d67e729f$export$5b2b1030a679f37);
$parcel$export(module.exports, "buttonWidthUnitless", () => $d38c6a36d67e729f$export$c6f3ea2b4cffd0ca);
$parcel$export(module.exports, "maxTextWidthUnitless", () => $d38c6a36d67e729f$export$2e3bcb01bf928995);
$parcel$export(module.exports, "maxTextWidth", () => $d38c6a36d67e729f$export$982d4a1a6de11130);
$parcel$export(module.exports, "defaultBorderRadius", () => $d38c6a36d67e729f$export$35d5d1e251b985cf);
$parcel$export(module.exports, "defaultRoundedBorderRadius", () => $d38c6a36d67e729f$export$c49771100fee18c8);
$parcel$export(module.exports, "defaultMargin", () => $d38c6a36d67e729f$export$6728fea658cfb92e);
$parcel$export(module.exports, "defaultTextPadding", () => $d38c6a36d67e729f$export$c2d03c4c68282362);
$parcel$export(module.exports, "textPaddingRight", () => $d38c6a36d67e729f$export$b5686dedf408caa0);
$parcel$export(module.exports, "textMarginLeft", () => $d38c6a36d67e729f$export$b824cac86306f7a2);
$parcel$export(module.exports, "cssVar", () => $d38c6a36d67e729f$export$8b4981022bd80a4e);
// eslint-disable-next-line @atlaskit/design-system/no-deprecated-imports

var $56FC2 = parcelRequire("56FC2");
const $d38c6a36d67e729f$var$gridSizeValue = (0, $56FC2.gridSize)();
const $d38c6a36d67e729f$var$borderRadiusValue = (0, $56FC2.borderRadius)();
const $d38c6a36d67e729f$export$b4d89c3994664204 = 2.5 * $d38c6a36d67e729f$var$gridSizeValue;
const $d38c6a36d67e729f$export$5b2b1030a679f37 = `var(--ds-space-250, ${`${$d38c6a36d67e729f$export$b4d89c3994664204}px`})`;
const $d38c6a36d67e729f$export$c6f3ea2b4cffd0ca = $d38c6a36d67e729f$export$b4d89c3994664204; // button should be square
const $d38c6a36d67e729f$export$aba002ef70684916 = $d38c6a36d67e729f$export$5b2b1030a679f37; // button should be square
const $d38c6a36d67e729f$export$d5949a2c2ea9dcea = 25 * $d38c6a36d67e729f$var$gridSizeValue;
const $d38c6a36d67e729f$export$488fda99655ff65a = `${$d38c6a36d67e729f$export$d5949a2c2ea9dcea}px`;
const $d38c6a36d67e729f$export$2e3bcb01bf928995 = $d38c6a36d67e729f$export$d5949a2c2ea9dcea - $d38c6a36d67e729f$export$b4d89c3994664204;
const $d38c6a36d67e729f$export$982d4a1a6de11130 = `${$d38c6a36d67e729f$export$2e3bcb01bf928995}px`;
const $d38c6a36d67e729f$export$35d5d1e251b985cf = `${$d38c6a36d67e729f$var$borderRadiusValue}px`;
const $d38c6a36d67e729f$export$c49771100fee18c8 = `${$d38c6a36d67e729f$export$c6f3ea2b4cffd0ca / 2}px`;
const $d38c6a36d67e729f$export$6728fea658cfb92e = `var(--ds-space-050, ${`${$d38c6a36d67e729f$var$gridSizeValue / 2}px`})`;
const $d38c6a36d67e729f$export$c2d03c4c68282362 = `var(--ds-space-050, ${`${$d38c6a36d67e729f$var$gridSizeValue / 2}px`})`;
const $d38c6a36d67e729f$export$b5686dedf408caa0 = `var(--ds-space-200, ${`${2 * $d38c6a36d67e729f$var$gridSizeValue}px`})`;
const $d38c6a36d67e729f$export$b824cac86306f7a2 = $d38c6a36d67e729f$export$5b2b1030a679f37;
const $d38c6a36d67e729f$export$8b4981022bd80a4e = {
    color: {
        background: {
            default: '--ds-cb',
            hover: '--ds-cbh',
            active: '--ds-cba'
        },
        borderColor: '--ds-bc',
        focusRing: '--ds-cfr',
        text: {
            default: '--ds-ct',
            hover: '--ds-cth',
            active: '--ds-ctp',
            link: '--ds-ctl'
        },
        removeButton: {
            default: '--ds-rb',
            hover: '--ds-rbh'
        }
    },
    borderRadius: '--ds-br'
};

});

parcelRegister("cTUJW", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $d73f16e97f480f98$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $d73f16e97f480f98$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $d73f16e97f480f98$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $d73f16e97f480f98$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $d73f16e97f480f98$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $d73f16e97f480f98$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $d73f16e97f480f98$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $d73f16e97f480f98$export$2a31dbe82788f940);
$parcel$export(module.exports, "borderRadius", () => $d73f16e97f480f98$export$7a57f79000377ca2);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $d73f16e97f480f98$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $d73f16e97f480f98$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $d73f16e97f480f98$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $d73f16e97f480f98$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $d73f16e97f480f98$export$b03fbc2a369c563e);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 

var $bi4SK = parcelRequire("bi4SK");
const $d73f16e97f480f98$export$daa0ace263cb20d2 = {
    standard: `var(--ds-text, ${$ab6d6432a4c55680$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-link, ${$ab6d6432a4c55680$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$ab6d6432a4c55680$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$ab6d6432a4c55680$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$ab6d6432a4c55680$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$ab6d6432a4c55680$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`
};
const $d73f16e97f480f98$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $d73f16e97f480f98$export$7c7104a5f052cab7 = {
    standard: `var(--ds-link, ${$ab6d6432a4c55680$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red-bolder, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green-bolder, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: `var(--ds-text-accent-gray-bolder, ${$ab6d6432a4c55680$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue, ${$ab6d6432a4c55680$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$ab6d6432a4c55680$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$ab6d6432a4c55680$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: `var(--ds-text-accent-gray, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`
};
const $d73f16e97f480f98$export$382469baad253eb7 = {
    standard: `var(--ds-link-pressed, ${$ab6d6432a4c55680$export$e62e8919cca44969})`,
    blue: `var(--ds-text-accent-blue, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    red: `var(--ds-text-accent-red, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-accent-yellow, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    green: `var(--ds-text-accent-green, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-accent-teal, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-accent-purple, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: `var(--ds-text-accent-gray, ${$ab6d6432a4c55680$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-accent-blue-bolder, ${$ab6d6432a4c55680$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-accent-red-bolder, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow-bolder, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green-bolder, ${$ab6d6432a4c55680$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-accent-teal-bolder, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple-bolder, ${$ab6d6432a4c55680$export$147899de772240ec})`,
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: `var(--ds-text-accent-gray-bolder, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`
};
const $d73f16e97f480f98$export$b9d7c59a579c23c6 = {
    standard: `var(--ds-background-neutral, ${$ab6d6432a4c55680$export$9fdfb749e33cdf97})`,
    blue: `var(--ds-background-accent-blue-subtle, ${$ab6d6432a4c55680$export$ecfc1dff386a3e7a})`,
    red: `var(--ds-background-accent-red-subtle, ${$ab6d6432a4c55680$export$be802dd0d8b57f35})`,
    yellow: `var(--ds-background-accent-yellow-subtle, ${$ab6d6432a4c55680$export$5aae31392d72caaa})`,
    green: `var(--ds-background-accent-green-subtle, ${$ab6d6432a4c55680$export$747d86715d4175de})`,
    teal: `var(--ds-background-accent-teal-subtle, ${$ab6d6432a4c55680$export$69cb3ca10c1e330e})`,
    purple: `var(--ds-background-accent-purple-subtle, ${$ab6d6432a4c55680$export$6011520a64d9a187})`,
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: `var(--ds-background-accent-gray-subtle, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-background-accent-blue-subtler, ${$ab6d6432a4c55680$export$8c13c2ee36917869})`,
    redLight: `var(--ds-background-accent-red-subtler, ${$ab6d6432a4c55680$export$b34b069eff244586})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler, ${$ab6d6432a4c55680$export$1cc05bbbf340e559})`,
    greenLight: `var(--ds-background-accent-green-subtler, ${$ab6d6432a4c55680$export$afbce1382ec95f73})`,
    tealLight: `var(--ds-background-accent-teal-subtler, ${$ab6d6432a4c55680$export$776c9c497ef08533})`,
    purpleLight: `var(--ds-background-accent-purple-subtler, ${$ab6d6432a4c55680$export$4b0a4417ed59760f})`,
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: `var(--ds-background-accent-gray-subtler, ${$ab6d6432a4c55680$export$3e51e8f1440314ba})`
};
const $d73f16e97f480f98$export$4410079763249c74 = {
    standard: `var(--ds-background-neutral-hovered, ${$ab6d6432a4c55680$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-hovered, ${$ab6d6432a4c55680$export$8c13c2ee36917869})`,
    red: `var(--ds-background-accent-red-subtle-hovered, ${$ab6d6432a4c55680$export$b34b069eff244586})`,
    yellow: `var(--ds-background-accent-yellow-subtle-hovered, ${$ab6d6432a4c55680$export$1cc05bbbf340e559})`,
    green: `var(--ds-background-accent-green-subtle-hovered, ${$ab6d6432a4c55680$export$afbce1382ec95f73})`,
    teal: `var(--ds-background-accent-teal-subtle-hovered, ${$ab6d6432a4c55680$export$776c9c497ef08533})`,
    purple: `var(--ds-background-accent-purple-subtle-hovered, ${$ab6d6432a4c55680$export$4b0a4417ed59760f})`,
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: `var(--ds-background-accent-gray-subtle-hovered, ${$ab6d6432a4c55680$export$eece5f492e429f08})`,
    blueLight: `var(--ds-background-accent-blue-subtler-hovered, ${$ab6d6432a4c55680$export$226de0355ed012f8})`,
    redLight: `var(--ds-background-accent-red-subtler-hovered, ${$ab6d6432a4c55680$export$4b84fd0e2c617bd})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-hovered, ${$ab6d6432a4c55680$export$41060a744ab0b7ae})`,
    greenLight: `var(--ds-background-accent-green-subtler-hovered, ${$ab6d6432a4c55680$export$69a3bf21b9686c2b})`,
    tealLight: `var(--ds-background-accent-teal-subtler-hovered, ${$ab6d6432a4c55680$export$7a8f4d33f6f9772c})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-hovered, ${$ab6d6432a4c55680$export$363e4475840015bb})`,
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: `var(--ds-background-accent-gray-subtler-hovered, ${$ab6d6432a4c55680$export$1ce2d1575d444ceb})`
};
const $d73f16e97f480f98$export$76be99c5e13e3566 = {
    standard: `var(--ds-background-neutral-pressed, ${$ab6d6432a4c55680$export$3e51e8f1440314ba})`,
    blue: `var(--ds-background-accent-blue-subtle-pressed, ${$ab6d6432a4c55680$export$226de0355ed012f8})`,
    red: `var(--ds-background-accent-red-subtle-pressed, ${$ab6d6432a4c55680$export$4b84fd0e2c617bd})`,
    yellow: `var(--ds-background-accent-yellow-subtle-pressed, ${$ab6d6432a4c55680$export$41060a744ab0b7ae})`,
    green: `var(--ds-background-accent-green-subtle-pressed, ${$ab6d6432a4c55680$export$69a3bf21b9686c2b})`,
    teal: `var(--ds-background-accent-teal-subtle-pressed, ${$ab6d6432a4c55680$export$7a8f4d33f6f9772c})`,
    purple: `var(--ds-background-accent-purple-subtle-pressed, ${$ab6d6432a4c55680$export$363e4475840015bb})`,
    grey: `var(--ds-background-accent-gray-subtle-pressed, ${$ab6d6432a4c55680$export$e2ef2124cf4024b1})`,
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: `var(--ds-background-accent-blue-subtler-pressed, ${$ab6d6432a4c55680$export$ecfc1dff386a3e7a})`,
    redLight: `var(--ds-background-accent-red-subtler-pressed, ${$ab6d6432a4c55680$export$be802dd0d8b57f35})`,
    yellowLight: `var(--ds-background-accent-yellow-subtler-pressed, ${$ab6d6432a4c55680$export$5aae31392d72caaa})`,
    greenLight: `var(--ds-background-accent-green-subtler-pressed, ${$ab6d6432a4c55680$export$747d86715d4175de})`,
    tealLight: `var(--ds-background-accent-teal-subtler-pressed, ${$ab6d6432a4c55680$export$69cb3ca10c1e330e})`,
    purpleLight: `var(--ds-background-accent-purple-subtler-pressed, ${$ab6d6432a4c55680$export$6011520a64d9a187})`,
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: `var(--ds-background-accent-gray-subtler-pressed, ${$ab6d6432a4c55680$export$8754fc7e6d8b3000})`
};
const $d73f16e97f480f98$export$2a31dbe82788f940 = `var(--ds-border-focused, ${$ab6d6432a4c55680$export$ecfc1dff386a3e7a})`;
const $d73f16e97f480f98$export$7a57f79000377ca2 = {
    default: (0, $bi4SK.defaultBorderRadius),
    rounded: (0, $bi4SK.defaultRoundedBorderRadius)
};
const $d73f16e97f480f98$export$1202b7eb21da7b58 = `var(--ds-background-danger, ${$ab6d6432a4c55680$export$4b84fd0e2c617bd})`;
const $d73f16e97f480f98$export$62ace793ebb16bda = `var(--ds-background-danger-hovered, ${$ab6d6432a4c55680$export$4b84fd0e2c617bd})`;
const $d73f16e97f480f98$export$17d206ccea111bbb = `var(--ds-text-danger, ${$ab6d6432a4c55680$export$2837b5a1a71d5c02})`;
const $d73f16e97f480f98$export$f64c7641cbc22da7 = {
    standard: `var(--ds-text, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    blue: `var(--ds-text-accent-blue-bolder, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    red: `var(--ds-text-accent-red-bolder, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    yellow: `var(--ds-text-accent-yellow-bolder, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    green: `var(--ds-text-accent-green-bolder, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    teal: `var(--ds-text-accent-teal-bolder, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    purple: `var(--ds-text-accent-purple-bolder, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    lime: `var(--ds-text-accent-lime-bolder, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    magenta: `var(--ds-text-accent-magenta-bolder, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    orange: `var(--ds-text-accent-orange-bolder, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    grey: `var(--ds-text-accent-gray-bolder, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    blueLight: `var(--ds-text-accent-blue, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    redLight: `var(--ds-text-accent-red, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-accent-yellow, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-accent-green, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    tealLight: `var(--ds-text-accent-teal, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-accent-purple, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    limeLight: `var(--ds-text-accent-lime, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    magentaLight: `var(--ds-text-accent-magenta, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    orangeLight: `var(--ds-text-accent-orange, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    greyLight: `var(--ds-text-accent-gray, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`
};
const $d73f16e97f480f98$export$b03fbc2a369c563e = {
    standard: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$ad0bacf983b7ddaa})`,
    standardLink: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$b3de0ae08da2ce64})`,
    blue: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    red: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    yellow: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    green: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    teal: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    purple: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    lime: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    magenta: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    orange: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$7d61b15e0da132af})`,
    grey: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$29a4f05edc054374})`,
    blueLight: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$a6ee3d71bc067634})`,
    redLight: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    yellowLight: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    greenLight: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$6fa04827ac68a4fb})`,
    tealLight: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`,
    purpleLight: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$147899de772240ec})`,
    limeLight: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$147899de772240ec})`,
    magentaLight: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$147899de772240ec})`,
    orangeLight: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$147899de772240ec})`,
    greyLight: `var(--ds-text-danger, ${$ab6d6432a4c55680$export$c39c0fe0f26207ae})`
};

});

parcelRegister("lMnxr", function(module, exports) {

$parcel$export(module.exports, "default", () => $206eb960e4dafcc7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $3puyA = parcelRequire("3puyA");

var $bi4SK = parcelRequire("bi4SK");

var $cTUJW = parcelRequire("cTUJW");
function $206eb960e4dafcc7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $206eb960e4dafcc7$var$baseStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $bi4SK.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $bi4SK.defaultMargin),
    padding: "var(--ds-space-0, 0px)",
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    backgroundColor: `var(${(0, $bi4SK.cssVar).color.background.default})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $bi4SK.cssVar).borderRadius})`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $bi4SK.cssVar).color.text.default})`,
    cursor: 'default'
});
const $206eb960e4dafcc7$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    minWidth: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: (0, $bi4SK.tagHeight),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    margin: (0, $bi4SK.defaultMargin),
    position: 'relative',
    alignItems: 'center',
    gap: "var(--ds-space-050, 4px)",
    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
    border: 'solid',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderColor: `var(${(0, $bi4SK.cssVar).color.borderColor})`,
    borderRadius: "var(--ds-border-radius, 3px)",
    borderWidth: "var(--ds-border-width, 1px)",
    color: "var(--ds-text, #172B4D)",
    cursor: 'default',
    paddingInline: "var(--ds-space-050, 4px)"
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $206eb960e4dafcc7$var$interactiveStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $bi4SK.cssVar).color.background.hover})`
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        backgroundColor: `var(${(0, $bi4SK.cssVar).color.background.active})`
    }
});
const $206eb960e4dafcc7$var$interactiveStyles = {
    name: "jcdcgl",
    styles: "&:hover{background-color:var(--ds-background-neutral-subtle-hovered, #091E420F);}&:active{background-color:var(--ds-background-neutral-subtle-pressed, #091E4224);}"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $206eb960e4dafcc7$var$focusRingStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        boxShadow: `0 0 0 2px var(${(0, $bi4SK.cssVar).color.focusRing})`,
        outline: 'none'
    }
});
const $206eb960e4dafcc7$var$focusRingStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:focus-within': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        outline: `2px solid ${$cTUJW.focusRingColors}`,
        outlineOffset: '2px '
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $206eb960e4dafcc7$var$nonStandardLinkStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $bi4SK.cssVar).color.text.active})`
    }
});
const $206eb960e4dafcc7$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? $cTUJW.textColors['standardLink'] : $cTUJW.textColors[color];
    const backgroundHoverColors = isRemovable && !isLink ? $cTUJW.backgroundColors[color] : $cTUJW.linkHoverBackgroundColors[color];
    const backgroundActiveColors = isRemovable && !isLink ? $cTUJW.backgroundColors[color] : $cTUJW.linkActiveBackgroundColors[color];
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...other,
        ref: ref,
        css: [
            (0, $3puyA.fg)('platform-component-visual-refresh') ? $206eb960e4dafcc7$var$baseStyles : $206eb960e4dafcc7$var$baseStylesOld,
            isInteractive && ((0, $3puyA.fg)('platform-component-visual-refresh') ? $206eb960e4dafcc7$var$focusRingStyles : $206eb960e4dafcc7$var$focusRingStylesOld),
            (0, $3puyA.fg)('platform-component-visual-refresh') ? isLink && $206eb960e4dafcc7$var$interactiveStyles : undefined,
            !(0, $3puyA.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && $206eb960e4dafcc7$var$nonStandardLinkStyles,
            !(0, $3puyA.fg)('platform-component-visual-refresh') && isInteractive && $206eb960e4dafcc7$var$interactiveStylesOld
        ],
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $bi4SK.cssVar).color.borderColor]: $cTUJW.borderColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $bi4SK.cssVar).color.text.default]: $cTUJW.textColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $bi4SK.cssVar).color.text.hover]: $cTUJW.textHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $bi4SK.cssVar).color.text.active]: $cTUJW.textActiveColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $bi4SK.cssVar).color.text.link]: textLinkColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $bi4SK.cssVar).color.background.default]: $cTUJW.backgroundColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $bi4SK.cssVar).color.background.hover]: backgroundHoverColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $bi4SK.cssVar).color.background.active]: backgroundActiveColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $bi4SK.cssVar).color.focusRing]: $cTUJW.focusRingColors,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $bi4SK.cssVar).color.removeButton.default]: $cTUJW.removeButtonColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $bi4SK.cssVar).color.removeButton.hover]: $cTUJW.removeButtonHoverColors[color],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [(0, $bi4SK.cssVar).borderRadius]: $cTUJW.borderRadius[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: className,
        "data-testid": testId
    }, before, contentElement, after);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$206eb960e4dafcc7$export$2e2bcd8739ae039 = $206eb960e4dafcc7$var$BaseTag;

});

parcelRegister("2VXjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $6172d02e48698de4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $3puyA = parcelRequire("3puyA");

var $bi4SK = parcelRequire("bi4SK");
function $6172d02e48698de4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6172d02e48698de4$var$beforeElementStyles = {
    name: "cfjv6",
    styles: "display:flex;height:16px;align-items:center;justify-content:center;inset-block-start:var(--ds-space-0, 0px)"
};
// To be removed with platform-component-visual-refresh (BLU-2992)
const $6172d02e48698de4$var$beforeElementStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $bi4SK.cssVar).borderRadius})`,
    insetBlockStart: "var(--ds-space-0, 0px)"
});
const $6172d02e48698de4$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: (0, $3puyA.fg)('platform-component-visual-refresh') ? $6172d02e48698de4$var$beforeElementStyles : $6172d02e48698de4$var$beforeElementStylesOld
    }, elemBefore) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6172d02e48698de4$export$2e2bcd8739ae039 = $6172d02e48698de4$var$Before;

});

parcelRegister("ikrrN", function(module, exports) {

$parcel$export(module.exports, "default", () => $63cf132208f4ed20$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $3puyA = parcelRequire("3puyA");

var $bi4SK = parcelRequire("bi4SK");
function $63cf132208f4ed20$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// To be removed with platform-component-visual-refresh (BLU-2992)
const $63cf132208f4ed20$var$baseStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $bi4SK.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $bi4SK.defaultTextPadding),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineStart: (0, $bi4SK.defaultTextPadding),
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $63cf132208f4ed20$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: (0, $bi4SK.maxTextWidth),
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $63cf132208f4ed20$var$linkStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $bi4SK.cssVar).color.text.link})`,
    pointerEvents: 'auto',
    textDecoration: 'none',
    '&:hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $bi4SK.cssVar).color.text.hover})`,
        textDecoration: 'underline'
    },
    '&:active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $bi4SK.cssVar).color.text.active})`,
        textDecoration: 'underline'
    },
    '&:focus': {
        outline: 'none'
    }
});
const $63cf132208f4ed20$var$linkStyles = {
    name: "1e5oc06",
    styles: "color:var(--ds-text, #172B4D);pointer-events:auto;text-decoration:none;&:hover{color:var(--ds-text, #172B4D);text-decoration:underline;}&:active{color:var(--ds-text, #172B4D);text-decoration:underline;}&:focus{outline:none;}"
};
const $63cf132208f4ed20$var$hasAfterStylesOld = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $bi4SK.maxTextWidthUnitless) - (0, $bi4SK.buttonWidthUnitless)}px`,
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    paddingInlineEnd: (0, $bi4SK.textPaddingRight)
});
const $63cf132208f4ed20$var$hasAfterStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $bi4SK.maxTextWidthUnitless) - (0, $bi4SK.buttonWidthUnitless)}px`
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $63cf132208f4ed20$var$hasBeforeStyles = /*#__PURE__*/ (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    marginInlineStart: (0, $bi4SK.textMarginLeft)
});
const $63cf132208f4ed20$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $byn9U.jsx)(Link, {
        href: href,
        "data-color": color,
        css: [
            (0, $3puyA.fg)('platform-component-visual-refresh') ? $63cf132208f4ed20$var$baseStyles : $63cf132208f4ed20$var$baseStylesOld,
            (0, $3puyA.fg)('platform-component-visual-refresh') ? $63cf132208f4ed20$var$linkStyles : $63cf132208f4ed20$var$linkStylesOld,
            !(0, $3puyA.fg)('platform-component-visual-refresh') && elemBefore && $63cf132208f4ed20$var$hasBeforeStyles,
            isRemovable && (0, $3puyA.fg)('platform-component-visual-refresh') ? $63cf132208f4ed20$var$hasAfterStyles : undefined,
            isRemovable && !(0, $3puyA.fg)('platform-component-visual-refresh') ? $63cf132208f4ed20$var$hasAfterStylesOld : undefined
        ]
    }, text);
    else return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: [
            (0, $3puyA.fg)('platform-component-visual-refresh') ? $63cf132208f4ed20$var$baseStyles : $63cf132208f4ed20$var$baseStylesOld,
            !(0, $3puyA.fg)('platform-component-visual-refresh') && elemBefore && $63cf132208f4ed20$var$hasBeforeStyles,
            isRemovable && (0, $3puyA.fg)('platform-component-visual-refresh') ? $63cf132208f4ed20$var$hasAfterStyles : undefined,
            isRemovable && !(0, $3puyA.fg)('platform-component-visual-refresh') ? $63cf132208f4ed20$var$hasAfterStylesOld : undefined
        ]
    }, text);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$63cf132208f4ed20$export$2e2bcd8739ae039 = $63cf132208f4ed20$var$Content;

});

parcelRegister("1MEQc", function(module, exports) {

$parcel$export(module.exports, "default", () => $635b2e3223436d71$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $7iVwB = parcelRequire("7iVwB");

var $3puyA = parcelRequire("3puyA");

var $7iUNK = parcelRequire("7iUNK");
var $gv7Ek = parcelRequire("gv7Ek");

var $bi4SK = parcelRequire("bi4SK");
const $635b2e3223436d71$var$removeButtonStyles = (0, $gv7Ek.xcss)({
    display: 'flex',
    height: '16px',
    width: '16px',
    margin: 'space.0',
    padding: 'space.0',
    insetInlineEnd: 'space.0',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    appearance: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none',
    borderRadius: 'border.radius.050',
    color: 'color.text',
    cursor: 'pointer',
    pointerEvents: 'auto',
    marginInlineStart: 'space.negative.025',
    marginInlineEnd: 'space.negative.025',
    ':focus-visible': {
        outlineOffset: 'space.negative.025'
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    }
});
// To be removed with platform-component-visual-refresh (BLU-2992)
const $635b2e3223436d71$var$removeButtonStylesOld = (0, $gv7Ek.xcss)({
    display: 'flex',
    height: '16px',
    margin: 'space.0',
    padding: 'space.0',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    appearance: 'none',
    backgroundColor: 'color.background.neutral.subtle',
    border: 'none',
    // Once legacy theming is dropped, this can be changed to 'border.radius'
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `var(${(0, $bi4SK.cssVar).borderRadius})`,
    // Once legacy theming is dropped, this can be changed to 'inherit'
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    color: `var(${(0, $bi4SK.cssVar).color.removeButton.default})`,
    cursor: 'pointer',
    pointerEvents: 'auto',
    ':focus-visible': {
        outlineOffset: 'space.0'
    },
    ':hover': {
        // Once legacy theming is dropped, this can be changed to 'cssVar.color.text.default'
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: `var(${(0, $bi4SK.cssVar).color.removeButton.hover})`
    }
});
const $635b2e3223436d71$var$removeButtonStylesOldIcon = (0, $gv7Ek.xcss)({
    insetInlineEnd: 'space.0'
});
const $635b2e3223436d71$var$removeButtonStylesNewIcon = (0, $gv7Ek.xcss)({
    insetInlineEnd: 'space.025'
});
const $635b2e3223436d71$var$RemoveButton = ({ 'aria-label': ariaLabel, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onKeyPress: onKeyPress, onMouseOver: onMouseOver, onMouseOut: onMouseOut, testId: testId })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7iUNK.default), {
        xcss: [
            (0, $3puyA.fg)('platform-component-visual-refresh') ? $635b2e3223436d71$var$removeButtonStyles : $635b2e3223436d71$var$removeButtonStylesOld,
            (0, $3puyA.fg)('platform-visual-refresh-icons') ? $635b2e3223436d71$var$removeButtonStylesNewIcon : $635b2e3223436d71$var$removeButtonStylesOldIcon
        ],
        "aria-label": ariaLabel,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyPress: onKeyPress,
        onMouseOver: onMouseOver,
        onMouseOut: onMouseOut,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7iVwB))), {
        color: "currentColor",
        label: "",
        LEGACY_size: "small"
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$635b2e3223436d71$export$2e2bcd8739ae039 = $635b2e3223436d71$var$RemoveButton;

});
parcelRegister("7iVwB", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::77b0cdbbee1b52bd7575a4eda010b0e1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5516d60e9a5ed16a$var$_react = $5516d60e9a5ed16a$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $5516d60e9a5ed16a$var$_cross = $5516d60e9a5ed16a$var$_interopRequireDefault((parcelRequire("a4PmP")));

var $5516d60e9a5ed16a$var$_close = $5516d60e9a5ed16a$var$_interopRequireDefault((parcelRequire("eWXWl")));
function $5516d60e9a5ed16a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossIcon.
 * This component is CrossIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5516d60e9a5ed16a$var$CrossIcon = (props)=>/*#__PURE__*/ $5516d60e9a5ed16a$var$_react.default.createElement($5516d60e9a5ed16a$var$_cross.default, Object.assign({
        LEGACY_fallbackIcon: $5516d60e9a5ed16a$var$_close.default
    }, props));
$5516d60e9a5ed16a$var$CrossIcon.Name = 'CrossIconMigration';
var $5516d60e9a5ed16a$var$_default = module.exports.default = $5516d60e9a5ed16a$var$CrossIcon;

});
parcelRegister("a4PmP", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::8a2857e231b7db111b6bd9efbc440f24>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $75621f8c6251a036$var$_react = $75621f8c6251a036$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $75621f8c6251a036$var$_UNSAFE_baseNew = $75621f8c6251a036$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $75621f8c6251a036$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Cross".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Known uses: remove tag.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $75621f8c6251a036$var$CrossIcon = (props)=>/*#__PURE__*/ $75621f8c6251a036$var$_react.default.createElement($75621f8c6251a036$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m2 10 4-4m4-4L6 6m0 0L2 2m4 4 4 4"/>`,
        type: 'utility'
    }, props));
$75621f8c6251a036$var$CrossIcon.displayName = 'CrossIcon';
var $75621f8c6251a036$var$_default = module.exports.default = $75621f8c6251a036$var$CrossIcon;

});









parcelRegister("6pYzn", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ac40fc10076e405$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $fyH4h = parcelRequire("fyH4h");

var $biTOe = parcelRequire("biTOe");
var $9l6Pq = parcelRequire("9l6Pq");

var $fUOHe = parcelRequire("fUOHe");

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $3ONu7 = parcelRequire("3ONu7");

var $6jEcw = parcelRequire("6jEcw");

var $6SyGj = parcelRequire("6SyGj");

var $7Zwos = parcelRequire("7Zwos");

var $lHkHI = parcelRequire("lHkHI");
function $4ac40fc10076e405$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4ac40fc10076e405$export$ee5162861c725095 = (0, $3UXZ8.default)("div", {
    target: "ewcus6q0",
    label: "CollectionContainer"
})({
    name: "1ymp5ti",
    styles: "& + &{margin-top:var(--ds-space-250, 20px);}"
});
class $4ac40fc10076e405$var$Discover extends (0, $eUqFw.Component) {
    componentDidMount() {
        this.discover({
            filters: this.props.filters
        });
        (0, $fUOHe.default).timeToFirstMeaningfulPaint(performance.now());
    }
    componentDidUpdate(prevProps) {
        if (this.props.transitions && this.props.transitions.get('transitionStarted') && prevProps.discover.get('discoverInProgress') && !this.props.discover.get('discoverInProgress') && this.props.transitions.get('transitionCompleted')) this.props.transitions.get('transitionCompleted')();
        if (!this.props.filters.equals(prevProps.filters)) this.discover({
            filters: this.props.filters
        });
    }
    discover(_ref) {
        let { filters: filters } = _ref;
        const { enableV2SearchIndex: enableV2SearchIndex } = this.props;
        const showCompassApps = this.props.statsigClient.showCompassApps();
        if (this.props.transitions && this.props.transitions.get('transitionStarted')) this.props.transitions.get('transitionStarted')();
        this.props.retrieveDiscoverData({
            filters: filters,
            featureFlags: {
                enableV2SearchIndex: enableV2SearchIndex,
                showCompassApps: !!showCompassApps
            }
        });
    }
    render() {
        const discoverInitialized = this.props.discover.get('initialized');
        const discoverInProgress = this.props.discover.get('discoverInProgress');
        const loading = !discoverInitialized || discoverInProgress;
        return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fyH4h.default), {
            baseMessage: "Oops! Looks like something went wrong.",
            dataError: this.props.discover.get('dataError'),
            dataErrorMessages: this.props.discover.get('dataErrorMessages'),
            loading: !this.props.discover.get('dataError') && loading,
            optimisticLoadTime: 1000,
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6SyGj.default), {
                    topPanel: this.props.topPanel
                }),
                !loading ? this.props.discoverCollectionsConfig.get(this.props.filters.get('product', (0, $3ONu7.HOME))).map((collection)=>{
                    return this.props.discover.getIn([
                        'data',
                        collection.get('key')
                    ]) ? /*#__PURE__*/ (0, $lHkHI.jsx)($4ac40fc10076e405$export$ee5162861c725095, {
                        className: "ui-collection-container",
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7Zwos.default), {
                            collectionData: this.props.discover.getIn([
                                'data',
                                collection.get('key')
                            ]),
                            collectionMetadata: collection,
                            colSpan: this.props.colSpan,
                            contentOverrides: collection.get('usesContentOverride') ? this.props.featuredContentOverride : undefined,
                            filters: this.props.filters,
                            filtersContext: this.props.filtersContext,
                            hitContext: this.props.hitContext,
                            onHitCategoryClick: this.props.onCollectionHitCategoryClick,
                            screenClass: this.props.screenClass,
                            stateChangeRequested: this.props.stateChangeRequested,
                            overrideLargeHitRightContent: this.props.overrideLargeHitRightContent
                        })
                    }, "collection-".concat(collection.get('key'))) : null;
                }).toList() : undefined
            ]
        });
    }
}
(0, $5zQU9.default)($4ac40fc10076e405$var$Discover, "propTypes", {
    colSpan: (0, $90ON9.default).colSpan.isRequired,
    discover: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        data: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).map,
        dataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
        dataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
        discoverInProgress: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
        initialized: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired
    }).isRequired,
    discoverCollectionsConfig: (0, $90ON9.default).discoverCollectionsConfig,
    featuredContentOverride: (0, $90ON9.default).contentOverrides,
    filters: (0, $6jEcw.default).discoverFilters,
    filtersContext: (0, $6jEcw.default).filtersContext,
    hitContext: (0, $90ON9.default).hitContext,
    onCollectionHitCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    retrieveDiscoverData: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    topPanel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    transitions: (0, $90ON9.default).transitions,
    overrideLargeHitRightContent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
});
var $4ac40fc10076e405$export$2e2bcd8739ae039 = (0, $biTOe.withFeatureFlags)((0, $9l6Pq.withStatsig)($4ac40fc10076e405$var$Discover));

});
parcelRegister("6SyGj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5022b03d60599c74$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $5022b03d60599c74$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5022b03d60599c74$var$TopPanelContainer = (0, $3UXZ8.default)("div", {
    target: "e1sbw8iy0",
    label: "TopPanelContainer"
})({
    name: "96erew",
    styles: "display:flex;margin:0 0 var(--ds-space-300, 24px) 10px;"
});
class $5022b03d60599c74$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        return this.props.topPanel ? /*#__PURE__*/ (0, $lHkHI.jsx)($5022b03d60599c74$var$TopPanelContainer, {
            children: this.props.topPanel
        }) : null;
    }
}
(0, $5zQU9.default)($5022b03d60599c74$export$2e2bcd8739ae039, "propTypes", {
    topPanel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node
});

});

parcelRegister("7Zwos", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d175b8fdcbff3a8$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $kYTrj = parcelRequire("kYTrj");

var $9osuT = parcelRequire("9osuT");

var $9rIMC = parcelRequire("9rIMC");

var $fEeDC = parcelRequire("fEeDC");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $2Ywog = parcelRequire("2Ywog");

var $90ON9 = parcelRequire("90ON9");

var $isqrX = parcelRequire("isqrX");

var $3ONu7 = parcelRequire("3ONu7");

var $5YKni = parcelRequire("5YKni");


var $6jEcw = parcelRequire("6jEcw");

var $iW4kt = parcelRequire("iW4kt");

var $kT6nf = parcelRequire("kT6nf");

var $lHkHI = parcelRequire("lHkHI");
function $5d175b8fdcbff3a8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5d175b8fdcbff3a8$var$COLLECTION_CONTAINER_HEADING_CLASS = 'collectionContainerHeading';
const $5d175b8fdcbff3a8$var$COLLECTION_CONTAINER_DESCRIPTION_CLASS = 'collectionContainerDescription';
const $5d175b8fdcbff3a8$export$1c406ca67e901e4b = /*#__PURE__*/ (0, $3UXZ8.default)((0, $kYTrj.default), {
    target: "enjsffu0",
    label: "CollectionContainerStyled"
})("display:inline-block;width:100%;.", $5d175b8fdcbff3a8$var$COLLECTION_CONTAINER_HEADING_CLASS, ",.", $5d175b8fdcbff3a8$var$COLLECTION_CONTAINER_DESCRIPTION_CLASS, "{margin-left:10px;}");
const $5d175b8fdcbff3a8$var$ViewMoreLinkContainer = (0, $3UXZ8.default)("div", {
    target: "enjsffu1",
    label: "ViewMoreLinkContainer"
})({
    name: "k008qs",
    styles: "display:flex;"
});
const $5d175b8fdcbff3a8$var$ViewMoreLink = (0, $3UXZ8.default)("div", {
    target: "enjsffu2",
    label: "ViewMoreLink"
})({
    name: "157rcp1",
    styles: "font-size:16px;margin:0 auto;"
});
class $5d175b8fdcbff3a8$var$Collection extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "getAppKeysAttributes", ()=>{
            return this.props.collectionData.get('hits').map((hit, i)=>{
                return {
                    objectId: hit.get('addonKey'),
                    analyticsTileType: this.props.collectionMetadata.get('analyticsTileType'),
                    hitRank: i + 1
                };
            });
        });
        (0, $5zQU9.default)(this, "onViewMoreClick", (event, options)=>{
            this.props.fireAnalyticsEvent({
                eventType: (0, $5YKni.LinkClickedEvent),
                actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_COLLECTION_VIEW_MORE_LINK),
                objectType: (0, $5YKni.OBJECT_TYPE_APP),
                objectId: this.props.collectionMetadata.get('key'),
                source: (0, $5YKni.EVENT_SOURCE),
                attributes: {
                    currentPerspective: (0, $37a31921fd56c86d$export$27b2e48e28163360)
                }
            }, (0, $5YKni.EVENT_CHANNEL));
            (0, $9rIMC).maybeOpenInNewTab(event, ()=>{
                this.props.stateChangeRequested({
                    perspective: options.newPerspective,
                    filters: options.newFilters
                });
            });
        });
    }
    componentDidMount() {
        if (this.props.collectionMetadata.get('recordTileImpressions')) this.props.fireAnalyticsEvent({
            eventType: (0, $5YKni.TilesRenderedEvent),
            actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_COLLECTION_TILE),
            objectType: (0, $5YKni.OBJECT_TYPE_APP),
            source: (0, $37a31921fd56c86d$export$27b2e48e28163360),
            currentPerspective: (0, $37a31921fd56c86d$export$27b2e48e28163360),
            sourceComponent: (0, $5YKni.EVENT_SOURCE),
            attributes: {
                appKeys: this.getAppKeysAttributes().toJS()
            }
        }, (0, $5YKni.EVENT_CHANNEL));
    }
    render() {
        const filters = this.props.filters.merge(this.props.collectionMetadata.get('filters') || (0, $g5DHJ.Map)());
        const title = this.props.collectionMetadata.get('title');
        const tagline = this.props.collectionMetadata.get('tagline');
        const viewMoreText = this.props.collectionMetadata.get('viewMoreText');
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($5d175b8fdcbff3a8$export$1c406ca67e901e4b, {
            headingClassName: $5d175b8fdcbff3a8$var$COLLECTION_CONTAINER_HEADING_CLASS,
            headingText: title,
            headingTag: (0, $kYTrj.headingTags).H3,
            description: tagline,
            descriptionClassName: $5d175b8fdcbff3a8$var$COLLECTION_CONTAINER_DESCRIPTION_CLASS,
            children: [
                this.resolveCollectionInner(),
                !this.props.collectionMetadata.get('hideViewMore') && (0, $isqrX.valuedFilters)(filters).size ? /*#__PURE__*/ (0, $lHkHI.jsx)($5d175b8fdcbff3a8$var$ViewMoreLinkContainer, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)($5d175b8fdcbff3a8$var$ViewMoreLink, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kT6nf.default), {
                            filtersContext: this.props.filtersContext,
                            newFilters: filters,
                            onClick: this.onViewMoreClick,
                            children: viewMoreText || 'View more'
                        })
                    })
                }) : null
            ]
        });
    }
    resolveCollectionInner() {
        const analyticsTileType = this.props.collectionMetadata.get('analyticsTileType');
        const maxLength = this.props.collectionMetadata.get('numDisplayResults') || this.props.collectionMetadata.get('numResults');
        switch(this.props.collectionMetadata.get('type')){
            case 0, $3ONu7.LARGE_COLLECTION_TYPE:
                return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $iW4kt.default), {
                    analyticsTileType: analyticsTileType,
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2Ywog.default), {
                        colSpan: this.props.colSpan,
                        contentOverrides: this.props.contentOverrides,
                        fromSearch: true,
                        hitContext: this.props.hitContext,
                        hitSize: "large",
                        hits: this.props.collectionData.get('hits'),
                        maxLength: maxLength,
                        onCategoryClick: this.props.onHitCategoryClick,
                        perspective: (0, $37a31921fd56c86d$export$27b2e48e28163360),
                        screenClass: this.props.screenClass,
                        searchId: this.props.collectionData.get('searchId'),
                        stateChangeRequested: this.props.stateChangeRequested,
                        overrideLargeHitRightContent: this.props.overrideLargeHitRightContent,
                        filters: this.props.filters,
                        sectionTitle: this.props.collectionMetadata.get('title')
                    })
                });
            case 0, $3ONu7.SMALL_COLLECTION_TYPE:
                return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $iW4kt.default), {
                    analyticsTileType: analyticsTileType,
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2Ywog.default), {
                        colSpan: this.props.colSpan,
                        contentOverrides: this.props.contentOverrides,
                        fromSearch: true,
                        hitContext: this.props.hitContext,
                        hitSize: "small",
                        hits: this.props.collectionData.get('hits'),
                        maxLength: maxLength,
                        perspective: (0, $37a31921fd56c86d$export$27b2e48e28163360),
                        screenClass: this.props.screenClass,
                        searchId: this.props.collectionData.get('searchId'),
                        filters: this.props.filters,
                        sectionTitle: this.props.collectionMetadata.get('title')
                    })
                });
            default:
                console.error("Invalid collection type specified: '".concat(this.props.collectionMetadata.get('type'), "'"));
        }
    }
}
(0, $5zQU9.default)($5d175b8fdcbff3a8$var$Collection, "propTypes", {
    colSpan: (0, $90ON9.default).colSpan.isRequired,
    collectionData: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        hits: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, $90ON9.default).hit()),
        searchId: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired
    }).isRequired,
    collectionMetadata: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        key: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf(Object.values((0, $3ONu7.CollectionsEnum))).isRequired,
        title: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        type: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
            (0, $3ONu7.LARGE_COLLECTION_TYPE),
            (0, $3ONu7.SMALL_COLLECTION_TYPE)
        ]),
        viewMoreFilters: (0, $90ON9.default).filters
    }).isRequired,
    contentOverrides: (0, $90ON9.default).contentOverrides,
    fireAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    filters: (0, $90ON9.default).filters,
    filtersContext: (0, $6jEcw.default).filtersContext,
    hitContext: (0, $90ON9.default).hitContext,
    hitSize: (0, $90ON9.default).hitSize,
    onHitCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    overrideLargeHitRightContent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
});
var $5d175b8fdcbff3a8$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($5d175b8fdcbff3a8$var$Collection);

});
parcelRegister("kYTrj", function(module, exports) {

$parcel$export(module.exports, "headingTags", () => $f4646a64e8de4e4e$export$ce5651ae2311c701);
$parcel$export(module.exports, "default", () => $f4646a64e8de4e4e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");
parcelRequire("ibjku");

var $hjlb6 = parcelRequire("hjlb6");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $hvUUg = parcelRequire("hvUUg");
var $8gcXz = parcelRequire("8gcXz");

var $lHkHI = parcelRequire("lHkHI");
function $f4646a64e8de4e4e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f4646a64e8de4e4e$export$ef0be9956142103d = (0, $3UXZ8.default)("div", {
    target: "ebekl6l0",
    label: "CollectionContainerStyle"
})({
    name: "fa7ybv",
    styles: "display:inline-block;width:100%;"
});
const $f4646a64e8de4e4e$export$31dea26885d599bc = (0, $3UXZ8.default)("div", {
    target: "ebekl6l1",
    label: "DescriptionContainer"
})("margin-top:15px;", (0, $hvUUg.baseMediumFontSize), ";color:", (0, $j0gMm.N700), ";word-wrap:break-word;", (0, $hvUUg.baseLineHeight), ";max-width:850px;");
const $f4646a64e8de4e4e$export$7c6e2c02157bb7d2 = (0, $3UXZ8.default)("div", {
    target: "ebekl6l2",
    label: "Content"
})({
    name: "46b038",
    styles: "margin-top:30px;"
});
const $f4646a64e8de4e4e$export$22585efc9aff372f = {
    name: "xyo9h4-headerCss",
    styles: "margin:0;;label:headerCss;"
};
const $f4646a64e8de4e4e$export$ce5651ae2311c701 = {
    H1: 'h1',
    H2: 'h2',
    H3: 'h3',
    H4: 'h4',
    H5: 'h5',
    H6: 'h6'
};
const $f4646a64e8de4e4e$export$8f0a2c4a876f052b = {
    h1: /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H1), {
        target: "ebekl6l3",
        label: "h1"
    })($f4646a64e8de4e4e$export$22585efc9aff372f, ""),
    h2: /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H2), {
        target: "ebekl6l4",
        label: "h2"
    })($f4646a64e8de4e4e$export$22585efc9aff372f, ""),
    h3: /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H3), {
        target: "ebekl6l5",
        label: "h3"
    })($f4646a64e8de4e4e$export$22585efc9aff372f, ""),
    h4: /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H4), {
        target: "ebekl6l6",
        label: "h4"
    })($f4646a64e8de4e4e$export$22585efc9aff372f, ""),
    h5: /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H5), {
        target: "ebekl6l7",
        label: "h5"
    })($f4646a64e8de4e4e$export$22585efc9aff372f, ""),
    h6: /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H6), {
        target: "ebekl6l8",
        label: "h6"
    })($f4646a64e8de4e4e$export$22585efc9aff372f, "")
};
class $f4646a64e8de4e4e$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const Heading = $f4646a64e8de4e4e$export$8f0a2c4a876f052b[this.props.headingTag];
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($f4646a64e8de4e4e$export$ef0be9956142103d, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this.props.containerClassName, this.props.className),
            children: [
                this.props.headingText && Heading ? /*#__PURE__*/ (0, $lHkHI.jsx)(Heading, {
                    className: this.props.headingClassName,
                    children: this.props.headingText
                }) : null,
                this.props.description ? /*#__PURE__*/ (0, $lHkHI.jsx)($f4646a64e8de4e4e$export$31dea26885d599bc, {
                    className: this.props.descriptionClassName,
                    children: this.props.description
                }) : null,
                this.props.children != null ? /*#__PURE__*/ (0, $lHkHI.jsx)($f4646a64e8de4e4e$export$7c6e2c02157bb7d2, {
                    children: this.props.children
                }) : null
            ]
        });
    }
}
(0, $5zQU9.default)($f4646a64e8de4e4e$export$2e2bcd8739ae039, "propTypes", {
    // text to appear as title
    headingText: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    // heading tag, defaults to h2
    headingTag: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf((0, $g5DHJ.Map)($f4646a64e8de4e4e$export$ce5651ae2311c701).reduce((acc, value)=>acc.push(value), (0, $g5DHJ.List)()).toArray()),
    // additional class name
    headingClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    // text that will appear bellow title
    description: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    // additional description class name
    descriptionClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    // children to be rendered
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    // additional class names to container
    containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    // styled components className
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
});
(0, $5zQU9.default)($f4646a64e8de4e4e$export$2e2bcd8739ae039, "defaultProps", {
    headingTag: $f4646a64e8de4e4e$export$ce5651ae2311c701.H2
});

});
parcelRegister("hjlb6", function(module, exports) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if (0, module.exports) {
        classNames.default = classNames;
        module.exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();

});


parcelRegister("2Ywog", function(module, exports) {

$parcel$export(module.exports, "default", () => $22aa4f71021b1d83$export$2e2bcd8739ae039);

var $hM72j = parcelRequire("hM72j");
var $22aa4f71021b1d83$export$2e2bcd8739ae039 = (0, $hM72j.default);

});
parcelRegister("hM72j", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf0c60a66fbd41a7$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $gwoWU = parcelRequire("gwoWU");
var $lgRZl = parcelRequire("lgRZl");

var $inwKI = parcelRequire("inwKI");

var $kafab = parcelRequire("kafab");

var $ammkg = parcelRequire("ammkg");

var $fEeDC = parcelRequire("fEeDC");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");
parcelRequire("eUqFw");

var $l5PRC = parcelRequire("l5PRC");
var $e2VTq = parcelRequire("e2VTq");

var $iW4kt = parcelRequire("iW4kt");

var $6jEcw = parcelRequire("6jEcw");

var $90ON9 = parcelRequire("90ON9");

var $iDEAo = parcelRequire("iDEAo");

var $ieOz2 = parcelRequire("ieOz2");

var $kLILm = parcelRequire("kLILm");

var $lHkHI = parcelRequire("lHkHI");
function $cf0c60a66fbd41a7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cf0c60a66fbd41a7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cf0c60a66fbd41a7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cf0c60a66fbd41a7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $cf0c60a66fbd41a7$export$3d3ee440779f81f = 'hits';
const $cf0c60a66fbd41a7$export$eb54c0b36b24646d = 'fadeIn';
const $cf0c60a66fbd41a7$export$407c97aa5ff397af = 'fadeInActive';
const $cf0c60a66fbd41a7$var$HitsContainer = (0, $3UXZ8.default)("div", {
    target: "e1m4a8560",
    label: "HitsContainer"
})(".", ()=>$cf0c60a66fbd41a7$export$3d3ee440779f81f, "{display:flex;flex-flow:row wrap;.", ()=>$cf0c60a66fbd41a7$export$eb54c0b36b24646d, "{opacity:0.01;&.", ()=>$cf0c60a66fbd41a7$export$407c97aa5ff397af, "{opacity:1;transition:opacity 200ms ease-in;}}}");
const $cf0c60a66fbd41a7$var$fadeMs = 200;
function $cf0c60a66fbd41a7$var$resolveSearchId(props) {
    return props.searchId || (0, $iDEAo.generateSearchId)();
}
// eslint-disable-next-line max-lines-per-function
const $cf0c60a66fbd41a7$var$Hits = (props)=>{
    const context = (0, $inwKI.useFeatureFlags)();
    const searchId = $cf0c60a66fbd41a7$var$resolveSearchId(props);
    const onHitClickFactory = (_ref)=>{
        let { hitRank: hitRank } = _ref;
        return (options, event)=>{
            props.hitContext.get('onHitClick')($cf0c60a66fbd41a7$var$_objectSpread($cf0c60a66fbd41a7$var$_objectSpread({}, options), {}, {
                hitRank: hitRank
            }), event);
        };
    };
    const onHitMountFactory = (_ref2)=>{
        let { hitRank: hitRank } = _ref2;
        return (_ref3)=>{
            let { hit: hit } = _ref3;
            if (props.hitContext.get('onHitMount')) props.hitContext.get('onHitMount')({
                hit: hit,
                hitRank: hitRank
            });
        };
    };
    const getHitContextForRank = (hitRank)=>props.hitContext.set('onHitClick', onHitClickFactory({
            hitRank: hitRank
        })).set('onHitMount', onHitMountFactory({
            hitRank: hitRank
        }));
    const mapToBugBountyParticipant = (bbp)=>{
        return {
            cloud: {
                status: bbp === null || bbp === void 0 ? void 0 : bbp.getIn([
                    'cloud',
                    'status'
                ])
            },
            server: {
                status: bbp === null || bbp === void 0 ? void 0 : bbp.getIn([
                    'server',
                    'status'
                ])
            },
            dataCenter: {
                status: bbp === null || bbp === void 0 ? void 0 : bbp.getIn([
                    'dataCenter',
                    'status'
                ])
            }
        };
    };
    const resolveSingleHit = (h, i)=>{
        const hasCloudSecurityBadge = (context === null || context === void 0 ? void 0 : context.enableBugBountyProgram) && // True only if cloud app is enrolled in the program. Eg: don't show if server is enrolled and cloud isn't
        (0, $gwoWU.isBugBountyParticipant)((0, $ammkg.AtlassianProductHostingType).Cloud, mapToBugBountyParticipant(h === null || h === void 0 ? void 0 : h.getIn([
            'programs',
            'bugBountyParticipant'
        ]))) && // Verify that app has cloud deployment
        h.get('deployments').includes('cloud');
        const hasCloudFortifiedBadge = h.getIn([
            'programs',
            'cloudFortified',
            'status'
        ]) === (0, $kafab.CloudFortifiedStatusValues).Approved;
        const hitAnalyticsAttributes = {
            hasCloudSecurityBadge: hasCloudFortifiedBadge ? false : hasCloudSecurityBadge,
            hasCloudFortifiedBadge: hasCloudFortifiedBadge
        };
        const hitRank = i + 1;
        switch(props.hitSize){
            case 'large':
                return resolveHitTransition(/*#__PURE__*/ (0, $lHkHI.jsx)((0, $ieOz2.default), {
                    colSpan: props.colSpan,
                    fromSearch: props.fromSearch,
                    hit: h,
                    hitContext: getHitContextForRank(hitRank),
                    onCategoryClick: props.onCategoryClick,
                    perspective: props.perspective,
                    screenClass: props.screenClass,
                    stateChangeRequested: props.stateChangeRequested,
                    overrideLargeHitRightContent: props.overrideLargeHitRightContent,
                    hasCloudSecurityBadge: hasCloudSecurityBadge,
                    hasCloudFortifiedBadge: hasCloudFortifiedBadge,
                    filters: props.filters,
                    sectionTitle: props.sectionTitle
                }), i, hitAnalyticsAttributes);
            case 'small':
                return resolveHitTransition(/*#__PURE__*/ (0, $lHkHI.jsx)((0, $kLILm.default), {
                    colSpan: props.colSpan,
                    fromSearch: props.fromSearch,
                    hit: h,
                    hitContext: getHitContextForRank(hitRank),
                    perspective: props.perspective,
                    screenClass: props.screenClass,
                    hasCloudSecurityBadge: hasCloudSecurityBadge,
                    hasCloudFortifiedBadge: hasCloudFortifiedBadge,
                    filters: props.filters,
                    sectionTitle: props.sectionTitle
                }), i, hitAnalyticsAttributes);
            default:
                console.error("Invalid hit type specified: '".concat(props.hitSize, "'"));
        }
    };
    const resolveCustomHit = (fn, i)=>{
        const Hit = props.hitSize === 'small' ? (0, $kLILm.default) : (0, $ieOz2.default);
        const contentOverride = fn({
            screenClass: props.screenClass,
            hitSize: props.hitSize
        });
        return resolveHitTransition(/*#__PURE__*/ (0, $lHkHI.jsx)(Hit, {
            colSpan: props.colSpan,
            contentOverride: contentOverride,
            fromSearch: false,
            screenClass: props.screenClass
        }), i);
    };
    const resolveHits = ()=>{
        const hitRenderers = (props.hits || (0, $g5DHJ.List)()).map((h)=>{
            return (i)=>resolveSingleHit(h, i);
        });
        const overrideRenderers = (props.contentOverrides || (0, $g5DHJ.List)()).sortBy((o)=>o.get('index'));
        const allRenderers = overrideRenderers.reduce((acc, override)=>acc.insert(Math.max(0, Math.min(override.get('index'), acc.size)), (i)=>resolveCustomHit(override.get('render'), i)), hitRenderers);
        const clampedRenderers = props.maxLength && allRenderers.size > props.maxLength ? allRenderers.setSize(props.maxLength) : allRenderers;
        return clampedRenderers.map((fn, i)=>fn(i));
    };
    const resolveHitTransition = (hit, i, hitAnalyticsAttributes)=>{
        const analyticsAttributes = $cf0c60a66fbd41a7$var$_objectSpread({
            hitRank: i + 1,
            hitSize: props.hitSize
        }, hitAnalyticsAttributes);
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l5PRC.default), {
            classNames: {
                enter: $cf0c60a66fbd41a7$export$eb54c0b36b24646d,
                enterActive: $cf0c60a66fbd41a7$export$407c97aa5ff397af,
                appear: $cf0c60a66fbd41a7$export$eb54c0b36b24646d,
                appearActive: $cf0c60a66fbd41a7$export$407c97aa5ff397af
            },
            appear: true,
            exit: false,
            timeout: {
                enter: $cf0c60a66fbd41a7$var$fadeMs,
                appear: $cf0c60a66fbd41a7$var$fadeMs
            },
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $iW4kt.default), $cf0c60a66fbd41a7$var$_objectSpread($cf0c60a66fbd41a7$var$_objectSpread({}, analyticsAttributes), {}, {
                children: hit
            }))
        }, "searchId_".concat(searchId, "_hit_").concat(i));
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)($cf0c60a66fbd41a7$var$HitsContainer, {
        className: "ui-hits-container",
        "data-search-id": searchId,
        "data-testid": "hits-container",
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $e2VTq.default), {
            className: $cf0c60a66fbd41a7$export$3d3ee440779f81f,
            children: resolveHits()
        })
    });
};
$cf0c60a66fbd41a7$var$Hits.propTypes = {
    colSpan: (0, $90ON9.default).colSpan.isRequired,
    contentOverrides: (0, $90ON9.default).contentOverrides,
    fromSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    hitContext: (0, $90ON9.default).hitContext,
    hits: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, $90ON9.default).hit()), (props)=>!props.contentOverrides),
    hitSize: (0, $90ON9.default).hitSize.isRequired,
    maxLength: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    onCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    searchId: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    overrideLargeHitRightContent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    filters: (0, $90ON9.default).filters,
    sectionTitle: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
};
var $cf0c60a66fbd41a7$export$2e2bcd8739ae039 = $cf0c60a66fbd41a7$var$Hits;

});
parcelRegister("iW4kt", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc91007814345ce6$export$2e2bcd8739ae039);

var $bwPfh = parcelRequire("bwPfh");

var $5zQU9 = parcelRequire("5zQU9");

var $d4wjA = parcelRequire("d4wjA");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $5YKni = parcelRequire("5YKni");

var $lHkHI = parcelRequire("lHkHI");
const $dc91007814345ce6$var$_excluded = [
    "children"
];
function $dc91007814345ce6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dc91007814345ce6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dc91007814345ce6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dc91007814345ce6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $dc91007814345ce6$export$2e2bcd8739ae039 extends $eUqFw.Component {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onEvent", (event)=>{
            const _this$props = this.props, { children: children } = _this$props, attributes = (0, $bwPfh.default)(_this$props, $dc91007814345ce6$var$_excluded);
            event.update((payload)=>$dc91007814345ce6$var$_objectSpread($dc91007814345ce6$var$_objectSpread({}, payload), {}, {
                    attributes: $dc91007814345ce6$var$_objectSpread($dc91007814345ce6$var$_objectSpread({}, payload.attributes), attributes)
                }));
        });
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $d4wjA.default), {
            channel: (0, $5YKni.EVENT_CHANNEL),
            onEvent: this.onEvent,
            children: this.props.children
        });
    }
}
(0, $5zQU9.default)($dc91007814345ce6$export$2e2bcd8739ae039, "propTypes", {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node.isRequired
});

});

parcelRegister("ieOz2", function(module, exports) {

$parcel$export(module.exports, "default", () => $d470c1cdfeeb1097$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $lgRZl = parcelRequire("lgRZl");

var $f2QOW = parcelRequire("f2QOW");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $5YKni = parcelRequire("5YKni");

var $6jEcw = parcelRequire("6jEcw");

var $90ON9 = parcelRequire("90ON9");

var $4KyM2 = parcelRequire("4KyM2");

var $kLILm = parcelRequire("kLILm");

var $lHkHI = parcelRequire("lHkHI");
class $d470c1cdfeeb1097$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        var _this$props$hit, _this$props$hit2;
        const analyticsContextAttributes = {
            source: (0, $5YKni.ANALYTICS_EVENT_SOURCE_APP_TILE),
            appName: (_this$props$hit = this.props.hit) === null || _this$props$hit === void 0 ? void 0 : _this$props$hit.getIn([
                'name'
            ]),
            vendorName: (_this$props$hit2 = this.props.hit) === null || _this$props$hit2 === void 0 ? void 0 : _this$props$hit2.getIn([
                'vendor',
                'name'
            ])
        };
        return this.props.screenClass === 'xs' ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kLILm.default), {
            colSpan: this.props.colSpan,
            contentOverride: this.props.contentOverride,
            fromSearch: this.props.fromSearch,
            hit: this.props.hit,
            hitContext: this.props.hitContext,
            perspective: this.props.perspective,
            screenClass: this.props.screenClass,
            hasCloudSecurityBadge: this.props.hasCloudSecurityBadge,
            hasCloudFortifiedBadge: this.props.hasCloudFortifiedBadge,
            filters: this.props.filters,
            sectionTitle: this.props.sectionTitle
        }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $f2QOW.default), {
            attributes: analyticsContextAttributes,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4KyM2.default), {
                colSpan: this.props.colSpan,
                contentOverride: this.props.contentOverride,
                fromSearch: this.props.fromSearch,
                hit: this.props.hit,
                hitContext: this.props.hitContext,
                onCategoryClick: this.props.onCategoryClick,
                perspective: this.props.perspective,
                screenClass: this.props.screenClass,
                stateChangeRequested: this.props.stateChangeRequested,
                overrideLargeHitRightContent: this.props.overrideLargeHitRightContent,
                hasCloudSecurityBadge: this.props.hasCloudSecurityBadge,
                hasCloudFortifiedBadge: this.props.hasCloudFortifiedBadge,
                filters: this.props.filters,
                sectionTitle: this.props.sectionTitle
            })
        });
    }
}
(0, $5zQU9.default)($d470c1cdfeeb1097$export$2e2bcd8739ae039, "propTypes", {
    colSpan: (0, $90ON9.default).colSpan.isRequired,
    contentOverride: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    fromSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    hit: (0, $lgRZl.default).requiredIf((0, $90ON9.default).hit(), (props)=>!props.contentOverride),
    hitContext: (0, $lgRZl.default).requiredIf((0, $90ON9.default).hitContext, (props)=>!props.contentOverride),
    onCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    overrideLargeHitRightContent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    hasCloudSecurityBadge: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    hasCloudFortifiedBadge: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    filters: (0, $90ON9.default).filters,
    sectionTitle: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
});

});
parcelRegister("f2QOW", function(module, exports) {

$parcel$export(module.exports, "MARKETPLACE_ANALYTICS_CONTEXT_NAMESPACE", () => $af4003f95e63f44c$export$62dccf523df3e44b);
$parcel$export(module.exports, "default", () => $af4003f95e63f44c$export$2e2bcd8739ae039);
// eslint-disable-next-line no-restricted-imports

var $6XVIn = parcelRequire("6XVIn");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $af4003f95e63f44c$export$62dccf523df3e44b = 'marketplaceCtx';
const $af4003f95e63f44c$var$MarketplaceAnalyticsContext = (props)=>{
    const { attributes: attributes = {}, properties: properties = {}, children: children } = props;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6XVIn.default), {
        data: {
            [$af4003f95e63f44c$export$62dccf523df3e44b]: {
                attributes: attributes,
                properties: properties
            }
        },
        children: children
    });
};
var $af4003f95e63f44c$export$2e2bcd8739ae039 = $af4003f95e63f44c$var$MarketplaceAnalyticsContext;

});

parcelRegister("4KyM2", function(module, exports) {

$parcel$export(module.exports, "default", () => $37566ea4338deec6$export$2e2bcd8739ae039);

var $ivYBE = parcelRequire("ivYBE");
var $37566ea4338deec6$export$2e2bcd8739ae039 = (0, $ivYBE.default);

});
parcelRegister("ivYBE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7aa2267046a5aad$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j8E8v = parcelRequire("j8E8v");

var $ivTMz = parcelRequire("ivTMz");

var $j0gMm = parcelRequire("j0gMm");

var $f7YGc = parcelRequire("f7YGc");
var $lgRZl = parcelRequire("lgRZl");
var $Lig7B = parcelRequire("Lig7B");
var $hxCMl = parcelRequire("hxCMl");

var $inwKI = parcelRequire("inwKI");

var $3BBSQ = parcelRequire("3BBSQ");
var $8sH3O = parcelRequire("8sH3O");
var $5YcrV = parcelRequire("5YcrV");
var $3ihpf = parcelRequire("3ihpf");
var $8xfj9 = parcelRequire("8xfj9");

var $jdjb1 = parcelRequire("jdjb1");

var $76fzC = parcelRequire("76fzC");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $6jEcw = parcelRequire("6jEcw");

var $90ON9 = parcelRequire("90ON9");

var $8wSvA = parcelRequire("8wSvA");

var $23J4Z = parcelRequire("23J4Z");

var $2AdLY = parcelRequire("2AdLY");

var $kXHwt = parcelRequire("kXHwt");

var $lHkHI = parcelRequire("lHkHI");
function $d7aa2267046a5aad$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d7aa2267046a5aad$export$a4cdd86caeeed29c = (0, $3UXZ8.default)("div", {
    target: "e1p4sqm40",
    label: "LargeHitContainer"
})({
    name: "1g4yje1",
    styles: "display:flex;flex-direction:column;height:100%;"
});
const $d7aa2267046a5aad$export$bfc559a6587679fa = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8sH3O.default), {
    target: "e1p4sqm41",
    label: "LargeHitStyled"
})("display:flex;flex-direction:column;padding:0;height:100%;background:", "var(--ds-surface-overlay, ".concat((0, $j0gMm.N0), ")"), ";a{text-decoration:none;&:hover,&:focus{text-decoration:none;}}");
const $d7aa2267046a5aad$export$29c0e362412a40fd = /*#__PURE__*/ (0, $3UXZ8.default)((0, $2AdLY.default), {
    target: "e1p4sqm42",
    label: "HitLinkStyled"
})({
    name: "1xgo7sw",
    styles: "display:flex;flex-direction:column;max-height:290px;padding:var(--ds-space-200, 16px) var(--ds-space-150, 12px) 10px;flex-grow:1;"
});
const $d7aa2267046a5aad$export$9204afa15bdaec56 = (0, $3UXZ8.default)("div", {
    target: "e1p4sqm43",
    label: "HeadingContainer"
})({
    name: "1tu59u4",
    styles: "flex:0 0 auto;"
});
const $d7aa2267046a5aad$export$4b2c32e08f77ff18 = (0, $3UXZ8.default)("div", {
    target: "e1p4sqm44",
    label: "Body"
})("display:flex;flex-direction:column;color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N500), ")"), ";font-size:14px;overflow:hidden;word-wrap:break-word;line-height:", 18 / 14, ";", (0, $jdjb1.multilineEllipsis)(3, "var(--ds-space-800, 64px)"), "");
const $d7aa2267046a5aad$export$aab12223ec536033 = (0, $3UXZ8.default)("div", {
    target: "e1p4sqm45",
    label: "CategoriesContainer"
})({
    name: "1l4a28d",
    styles: "min-height:16px;max-height:16px;margin-top:var(--ds-space-050, 4px);"
});
const $d7aa2267046a5aad$export$a06f1c675e846f6f = (0, $3UXZ8.default)("div", {
    target: "e1p4sqm46",
    label: "Footer"
})({
    name: "cjkuwg",
    styles: "display:flex;flex-direction:row;min-height:22px;max-height:22px;margin-top:var(--ds-space-150, 12px);"
});
const $d7aa2267046a5aad$export$1a18b36cd550751e = (0, $3UXZ8.default)("div", {
    target: "e1p4sqm47",
    label: "FooterRightContainer"
})("flex:1 1 auto;margin-left:5px;text-align:right;", (0, $jdjb1.ellipsis), "");
const $d7aa2267046a5aad$export$7488dbc17290f084 = (0, $3UXZ8.default)("div", {
    target: "e1p4sqm48",
    label: "LargeHitVendorStyled"
})({
    name: "1ed1egu",
    styles: "padding-top:5px;font-size:14px;"
});
const $d7aa2267046a5aad$export$83a341453e49cfdc = (0, $3UXZ8.default)("span", {
    target: "e1p4sqm49",
    label: "Installs"
})("color:", "var(--ds-text-subtlest, ".concat((0, $j0gMm.N100), ")"), ";font-size:12px;");
const $d7aa2267046a5aad$export$3b754b8c8a8062da = /*#__PURE__*/ (0, $3UXZ8.default)((0, $5YcrV.default), {
    target: "e1p4sqm410",
    label: "CloudFortifiedAppBadgeStyled"
})("display:flex;justify-content:center;align-items:center;border-top:1px solid ", "var(--ds-border, ".concat((0, $j0gMm.N30), ")"), ";padding:var(--ds-space-100, 8px) 0;font-size:14px;border-radius:0 0 ", (0, $ivTMz.borderRadius)(), "px ", (0, $ivTMz.borderRadius)(), "px;");
const $d7aa2267046a5aad$export$177cf549479db0d9 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $3ihpf.default), {
    target: "e1p4sqm411",
    label: "CloudSecurityParticipantBadgeStyled"
})("display:flex;justify-content:center;border-top:1px solid ", "var(--ds-border, ".concat((0, $j0gMm.N30), ")"), ";padding:var(--ds-space-100, 8px) 0;font-size:14px;");
const $d7aa2267046a5aad$export$93a18d2ec5ed521f = /*#__PURE__*/ (0, $3UXZ8.default)((0, $hxCMl.default), {
    target: "e1p4sqm412",
    label: "StatelessColStyled"
})({
    name: "ud5h78",
    styles: "margin-bottom:var(--ds-space-250, 20px);"
});
function $d7aa2267046a5aad$export$2e2bcd8739ae039(props) {
    (0, $eUqFw.useEffect)(()=>{
        if (props.hitContext && props.hitContext.get('onHitMount')) props.hitContext.get('onHitMount')({
            hit: props.hit
        });
    }, []);
    const { replaceCategoriesOnAppTilesWithVendorName: replaceCategoriesOnAppTilesWithVendorName } = (0, $inwKI.useFeatureFlags)();
    const onRatingsClick = ()=>{
        props.hitContext.get('onRatingsClick')({
            hit: props.hit
        });
    };
    const certificationBadge = (hasCloudSecurityBadge, hasCloudFortifiedBadge)=>{
        if (hasCloudFortifiedBadge) return /*#__PURE__*/ (0, $lHkHI.jsx)($d7aa2267046a5aad$export$3b754b8c8a8062da, {
            showLabel: true,
            source: (0, $5YcrV.CloudFortifiedAppBadgeSources).AppTile
        });
        return hasCloudSecurityBadge && /*#__PURE__*/ (0, $lHkHI.jsx)($d7aa2267046a5aad$export$177cf549479db0d9, {
            showLabel: true
        });
    };
    const renderHitContents = ()=>{
        var _props$hit$getIn;
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($d7aa2267046a5aad$export$bfc559a6587679fa, {
            testId: "app-tile",
            badgeVariant: resolveAppTileBadgeVariant(),
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsxs)($d7aa2267046a5aad$export$29c0e362412a40fd, {
                    fromSearch: props.fromSearch,
                    hit: props.hit,
                    hitContext: props.hitContext,
                    perspective: props.perspective,
                    filters: props.filters,
                    sectionTitle: props.sectionTitle,
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)($d7aa2267046a5aad$export$9204afa15bdaec56, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kXHwt.default), {
                                fromSearch: props.fromSearch,
                                hit: props.hit,
                                hitImageHrefResolver: props.hitContext.get('hitImageHrefResolver')
                            })
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)($d7aa2267046a5aad$export$4b2c32e08f77ff18, {
                            children: resolveTagLine()
                        }),
                        replaceCategoriesOnAppTilesWithVendorName ? props.hit.get('vendor') && /*#__PURE__*/ (0, $lHkHI.jsx)($d7aa2267046a5aad$export$7488dbc17290f084, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8xfj9.default), {
                                name: props.hit.getIn([
                                    'vendor',
                                    'name'
                                ]),
                                pathname: "/vendors/".concat(props.hit.getIn([
                                    'vendor',
                                    'id'
                                ])),
                                partnerTierType: (_props$hit$getIn = props.hit.getIn([
                                    'vendor',
                                    'partnerTier',
                                    'type'
                                ])) === null || _props$hit$getIn === void 0 ? void 0 : _props$hit$getIn.toUpperCase()
                            })
                        }) : /*#__PURE__*/ (0, $lHkHI.jsx)($d7aa2267046a5aad$export$aab12223ec536033, {
                            children: props.hit.get('categories') ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $23J4Z.default), {
                                categories: props.hit.get('categories'),
                                onCategoryClick: props.onCategoryClick,
                                perspective: props.perspective
                            }) : undefined
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsxs)($d7aa2267046a5aad$export$a06f1c675e846f6f, {
                            children: [
                                props.hit.get('ratings') ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $Lig7B.default), {
                                    onClick: props.hitContext.get('onRatingsClick') && onRatingsClick,
                                    ratings: props.hit.get('ratings').toJS()
                                }) : undefined,
                                /*#__PURE__*/ (0, $lHkHI.jsx)($d7aa2267046a5aad$export$1a18b36cd550751e, {
                                    children: resolveRightContent()
                                })
                            ]
                        })
                    ]
                }),
                certificationBadge(props.hasCloudSecurityBadge, props.hasCloudFortifiedBadge)
            ]
        });
    };
    const resolveTagLine = ()=>{
        if (props.hit.get('tagLine')) {
            const highlightedText = (0, $8wSvA.createHighlights)(props.hit, 'tagLine', 'tokenizedTagLine');
            return highlightedText ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3BBSQ.AppTileHighlightedText), {
                highlightedText: highlightedText,
                originalText: props.hit.get('tagLine')
            }) : props.hit.get('tagLine');
        }
    };
    const hasMarketingLabel = (marketingLabels, labelToFilter)=>{
        return marketingLabels && marketingLabels.some((label)=>label === labelToFilter);
    };
    const resolveAppTileBadgeVariant = ()=>{
        let badgeVariant;
        const marketingLabels = props.hit.get('marketingLabels');
        if (hasMarketingLabel(marketingLabels, 'Spotlight')) badgeVariant = 'spotlight';
        else if (hasMarketingLabel(marketingLabels, 'Bestseller')) badgeVariant = 'bestSeller';
        else if (hasMarketingLabel(marketingLabels, 'Rising Star')) badgeVariant = 'risingStar';
        else {
            const releaseDate = props.hit.get('releaseDate');
            badgeVariant = Math.abs((0, $76fzC).differenceInDaysToNow(releaseDate)) < 14 ? 'new' : undefined;
        }
        return badgeVariant;
    };
    const resolveRightContent = ()=>{
        const isBundled = props.hit.getIn([
            'distribution',
            'bundled'
        ]);
        const overriddenContent = props.overrideLargeHitRightContent(props.hit.get('addonKey'));
        if (overriddenContent) return overriddenContent;
        else {
            if (isBundled) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j8E8v.default), {
                appearance: "default",
                children: "Preinstalled"
            });
            const installs = props.hit.getIn([
                'distribution',
                'activeInstalls'
            ]);
            const downloads = props.hit.getIn([
                'distribution',
                'downloads'
            ]);
            if (installs || downloads) return /*#__PURE__*/ (0, $lHkHI.jsx)($d7aa2267046a5aad$export$83a341453e49cfdc, {
                children: installs ? /*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
                    children: [
                        (0, $f7YGc).shortFormat(installs),
                        " install",
                        installs > 1 ? 's' : ''
                    ]
                }) : /*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
                    children: [
                        (0, $f7YGc).shortFormat(downloads),
                        " download",
                        downloads > 1 ? 's' : ''
                    ]
                })
            });
        }
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)($d7aa2267046a5aad$export$93a18d2ec5ed521f, {
        gutterWidth: 20,
        xl: props.colSpan.getIn([
            'largeHits',
            'xl'
        ]) || 4,
        lg: props.colSpan.getIn([
            'largeHits',
            'lg'
        ]) || 4,
        md: props.colSpan.getIn([
            'largeHits',
            'md'
        ]) || 4,
        sm: props.colSpan.getIn([
            'largeHits',
            'sm'
        ]) || 6,
        xs: props.colSpan.getIn([
            'largeHits',
            'xs'
        ]) || 12,
        screenClass: props.screenClass,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)($d7aa2267046a5aad$export$a4cdd86caeeed29c, {
            children: props.contentOverride || renderHitContents()
        })
    });
}
$d7aa2267046a5aad$export$2e2bcd8739ae039.propTypes = {
    colSpan: (0, $90ON9.default).colSpan.isRequired,
    contentOverride: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    fromSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    hit: (0, $lgRZl.default).requiredIf((0, $90ON9.default).hit(), (props)=>!props.contentOverride),
    hitContext: (0, $lgRZl.default).requiredIf((0, $90ON9.default).hitContext, (props)=>!props.contentOverride),
    onCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    overrideLargeHitRightContent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    hasCloudSecurityBadge: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    hasCloudFortifiedBadge: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    badgeVariant: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    filters: (0, $90ON9.default).filters,
    sectionTitle: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
};
$d7aa2267046a5aad$export$2e2bcd8739ae039.defaultProps = {
    overrideLargeHitRightContent: ()=>{
    /* do nothing by default */ }
};

});
parcelRegister("f7YGc", function(module, exports) {

$parcel$export(module.exports, "longFormat", () => $b03694281b9bb755$export$8425645f696d2172);
$parcel$export(module.exports, "longCurrencyFormat", () => $b03694281b9bb755$export$cc801163984d8dcc);
$parcel$export(module.exports, "shortFormat", () => $b03694281b9bb755$export$e4ad565cfdf0f5ad);
$parcel$export(module.exports, "shortCurrencyFormat", () => $b03694281b9bb755$export$d305380cf8231832);

var $9IgQE = parcelRequire("9IgQE");
const $b03694281b9bb755$export$8425645f696d2172 = (number)=>(0, (/*@__PURE__*/$parcel$interopDefault($9IgQE)))(number).format('0,0');
const $b03694281b9bb755$export$cc801163984d8dcc = (number)=>(0, (/*@__PURE__*/$parcel$interopDefault($9IgQE)))(number).format('$0,0');
const $b03694281b9bb755$export$e4ad565cfdf0f5ad = (number)=>(0, (/*@__PURE__*/$parcel$interopDefault($9IgQE)))(number).format('0[.]0a');
const $b03694281b9bb755$export$d305380cf8231832 = (number)=>(0, (/*@__PURE__*/$parcel$interopDefault($9IgQE)))(number).format('$0[.]00a');

});
parcelRegister("9IgQE", function(module, exports) {
/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */ (function(global, factory) {
    if (typeof define === 'function' && define.amd) define(factory);
    else if (0, module.exports) module.exports = factory();
    else global.numeral = factory();
})(module.exports, function() {
    /************************************
        Variables
    ************************************/ var numeral, _, VERSION = '2.0.6', formats = {}, locales = {}, defaults = {
        currentLocale: 'en',
        zeroFormat: null,
        nullFormat: null,
        defaultFormat: '0,0',
        scalePercentBy100: true
    }, options = {
        currentLocale: defaults.currentLocale,
        zeroFormat: defaults.zeroFormat,
        nullFormat: defaults.nullFormat,
        defaultFormat: defaults.defaultFormat,
        scalePercentBy100: defaults.scalePercentBy100
    };
    /************************************
        Constructors
    ************************************/ // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;
        this._value = number;
    }
    numeral = function(input) {
        var value, kind, unformatFunction, regexp;
        if (numeral.isNumeral(input)) value = input.value();
        else if (input === 0 || typeof input === 'undefined') value = 0;
        else if (input === null || _.isNaN(input)) value = null;
        else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) value = 0;
            else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) value = null;
            else {
                for(kind in formats){
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;
                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;
                        break;
                    }
                }
                unformatFunction = unformatFunction || numeral._.stringToNumber;
                value = unformatFunction(input);
            }
        } else value = Number(input) || null;
        return new Numeral(input, value);
    };
    // version number
    numeral.version = VERSION;
    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };
    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale], negP = false, optDec = false, leadingCount = 0, abbr = '', trillion = 1000000000000, billion = 1000000000, million = 1000000, thousand = 1000, decimal = '', neg = false, abbrForce, abs, min, max, power, int, precision, signed, thousands, output;
            // make sure we never format a null value
            value = value || 0;
            abs = Math.abs(value);
            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }
            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);
                abbrForce = abbrForce ? abbrForce[1] : false;
                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) abbr = ' ';
                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');
                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }
            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }
            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;
            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, precision[0].length + precision[1].length, roundingFunction, precision[1].length);
                } else decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                int = decimal.split('.')[0];
                if (numeral._.includes(decimal, '.')) decimal = locale.delimiters.decimal + decimal.split('.')[1];
                else decimal = '';
                if (optDec && Number(decimal.slice(1)) === 0) decimal = '';
            } else int = numeral._.toFixed(value, 0, roundingFunction);
            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);
                switch(abbr){
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }
            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }
            if (int.length < leadingCount) for(var i = leadingCount - int.length; i > 0; i--)int = '0' + int;
            if (thousands > -1) int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            if (format.indexOf('.') === 0) int = '';
            output = int + decimal + (abbr ? abbr : '');
            if (negP) output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            else {
                if (signed >= 0) output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                else if (neg) output = '-' + output;
            }
            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale], stringOriginal = string, abbreviations = {
                thousand: 3,
                million: 6,
                billion: 9,
                trillion: 12
            }, abbreviation, value, i, regexp;
            if (options.zeroFormat && string === options.zeroFormat) value = 0;
            else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) value = null;
            else {
                value = 1;
                if (locale.delimiters.decimal !== '.') string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                for(abbreviation in abbreviations){
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');
                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }
                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;
                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');
                value *= Number(string);
            }
            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/ ) {
            if (this === null) throw new TypeError('Array.prototype.reduce called on null or undefined');
            if (typeof callback !== 'function') throw new TypeError(callback + ' is not a function');
            var t = Object(array), len = t.length >>> 0, k = 0, value;
            if (arguments.length === 3) value = arguments[2];
            else {
                while(k < len && !(k in t))k++;
                if (k >= len) throw new TypeError('Reduce of empty array with no initial value');
                value = t[k++];
            }
            for(; k < len; k++)if (k in t) value = callback(value, t[k], k, t);
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */ multiplier: function(x) {
            var parts = x.toString().split('.');
            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */ correctionFactor: function() {
            var args = Array.prototype.slice.call(arguments);
            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */ toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'), minDecimals = maxDecimals - (optionals || 0), boundedPrecision, optionalsRegExp, power, output;
            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            else boundedPrecision = minDecimals;
            power = Math.pow(10, boundedPrecision);
            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);
            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }
            return output;
        }
    };
    // avaliable options
    numeral.options = options;
    // avaliable formats
    numeral.formats = formats;
    // avaliable formats
    numeral.locales = locales;
    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) options.currentLocale = key.toLowerCase();
        return options.currentLocale;
    };
    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) return locales[options.currentLocale];
        key = key.toLowerCase();
        if (!locales[key]) throw new Error('Unknown locale : ' + key);
        return locales[key];
    };
    numeral.reset = function() {
        for(var property in defaults)options[property] = defaults[property];
    };
    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof format === 'string' ? format : null;
    };
    numeral.nullFormat = function(format) {
        options.nullFormat = typeof format === 'string' ? format : null;
    };
    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof format === 'string' ? format : '0.0';
    };
    numeral.register = function(type, name, format) {
        name = name.toLowerCase();
        if (this[type + 's'][name]) throw new TypeError(name + ' ' + type + ' already registered.');
        this[type + 's'][name] = format;
        return format;
    };
    numeral.validate = function(val, culture) {
        var _decimalSep, _thousandSep, _currSymbol, _valArray, _abbrObj, _thousandRegEx, localeData, temp;
        //coerce val to string
        if (typeof val !== 'string') {
            val += '';
            if (console.warn) console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
        }
        //trim whitespaces from either sides
        val = val.trim();
        //if val is just digits return true
        if (!!val.match(/^\d+$/)) return true;
        //if val is empty return false
        if (val === '') return false;
        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }
        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') _thousandSep = '\\.';
        else _thousandSep = localeData.delimiters.thousands;
        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) return false;
        }
        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) return false;
        }
        _thousandRegEx = new RegExp(_thousandSep + '{2}');
        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) return false;
            else {
                if (_valArray.length < 2) return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx);
                else {
                    if (_valArray[0].length === 1) return !!_valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                    else return !!_valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !!_valArray[1].match(/^\d+$/);
                }
            }
        }
        return false;
    };
    /************************************
        Numeral Prototype
    ************************************/ numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value, format = inputString || options.defaultFormat, kind, output, formatFunction;
            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;
            // format based on value
            if (value === 0 && options.zeroFormat !== null) output = options.zeroFormat;
            else if (value === null && options.nullFormat !== null) output = options.nullFormat;
            else {
                for(kind in formats)if (format.match(formats[kind].regexps.format)) {
                    formatFunction = formats[kind].format;
                    break;
                }
                formatFunction = formatFunction || numeral._.numberToFormat;
                output = formatFunction(value, format, roundingFunction);
            }
            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);
            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 0) / corrFactor;
            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);
            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }
            this._value = _.reduce([
                value
            ], cback, Math.round(this._value * corrFactor)) / corrFactor;
            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback, 1);
            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }
            this._value = _.reduce([
                this._value,
                value
            ], cback);
            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };
    /************************************
        Default Locale && Format
    ************************************/ numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return ~~(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });
    (function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '', output;
                value = value * 10000;
                // check for space before BPS
                format = format.replace(/\s?BPS/, '');
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ')')) {
                    output = output.split('');
                    output.splice(-1, 0, space + 'BPS');
                    output = output.join('');
                } else output = output + space + 'BPS';
                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
    })();
    (function() {
        var decimal = {
            base: 1000,
            suffixes: [
                'B',
                'KB',
                'MB',
                'GB',
                'TB',
                'PB',
                'EB',
                'ZB',
                'YB'
            ]
        }, binary = {
            base: 1024,
            suffixes: [
                'B',
                'KiB',
                'MiB',
                'GiB',
                'TiB',
                'PiB',
                'EiB',
                'ZiB',
                'YiB'
            ]
        };
        var allSuffixes = decimal.suffixes.concat(binary.suffixes.filter(function(item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';
        numeral.register('format', 'bytes', {
            regexps: {
                format: /([0\s]i?b)/,
                unformat: new RegExp(unformatRegex)
            },
            format: function(value, format, roundingFunction) {
                var output, bytes = numeral._.includes(format, 'ib') ? binary : decimal, suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '', power, min, max;
                // check for space before
                format = format.replace(/\s?i?b/, '');
                for(power = 0; power <= bytes.suffixes.length; power++){
                    min = Math.pow(bytes.base, power);
                    max = Math.pow(bytes.base, power + 1);
                    if (value === null || value === 0 || value >= min && value < max) {
                        suffix += bytes.suffixes[power];
                        if (min > 0) value = value / min;
                        break;
                    }
                }
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + suffix;
            },
            unformat: function(string) {
                var value = numeral._.stringToNumber(string), power, bytesMultiplier;
                if (value) {
                    for(power = decimal.suffixes.length - 1; power >= 0; power--){
                        if (numeral._.includes(string, decimal.suffixes[power])) {
                            bytesMultiplier = Math.pow(decimal.base, power);
                            break;
                        }
                        if (numeral._.includes(string, binary.suffixes[power])) {
                            bytesMultiplier = Math.pow(binary.base, power);
                            break;
                        }
                    }
                    value *= bytesMultiplier || 1;
                }
                return value;
            }
        });
    })();
    (function() {
        numeral.register('format', 'currency', {
            regexps: {
                format: /(\$)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                }, output, symbol, i;
                // strip format of spaces and $
                format = format.replace(/\s?\$\s?/, '');
                // format the number
                output = numeral._.numberToFormat(value, format, roundingFunction);
                // update the before and after based on value
                if (value >= 0) {
                    symbols.before = symbols.before.replace(/[\-\(]/, '');
                    symbols.after = symbols.after.replace(/[\-\)]/, '');
                } else if (value < 0 && !numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '(')) symbols.before = '-' + symbols.before;
                // loop through each before symbol
                for(i = 0; i < symbols.before.length; i++){
                    symbol = symbols.before[i];
                    switch(symbol){
                        case '$':
                            output = numeral._.insert(output, locale.currency.symbol, i);
                            break;
                        case ' ':
                            output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                            break;
                    }
                }
                // loop through each after symbol
                for(i = symbols.after.length - 1; i >= 0; i--){
                    symbol = symbols.after[i];
                    switch(symbol){
                        case '$':
                            output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                            break;
                        case ' ':
                            output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                            break;
                    }
                }
                return output;
            }
        });
    })();
    (function() {
        numeral.register('format', 'exponential', {
            regexps: {
                format: /(e\+|e-)/,
                unformat: /(e\+|e-)/
            },
            format: function(value, format, roundingFunction) {
                var output, exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0', parts = exponential.split('e');
                format = format.replace(/e[\+|\-]{1}0/, '');
                output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);
                return output + 'e' + parts[1];
            },
            unformat: function(string) {
                var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'), value = Number(parts[0]), power = Number(parts[1]);
                power = numeral._.includes(string, 'e-') ? power *= -1 : power;
                function cback(accum, curr, currI, O) {
                    var corrFactor = numeral._.correctionFactor(accum, curr), num = accum * corrFactor * (curr * corrFactor) / (corrFactor * corrFactor);
                    return num;
                }
                return numeral._.reduce([
                    value,
                    Math.pow(10, power)
                ], cback, 1);
            }
        });
    })();
    (function() {
        numeral.register('format', 'ordinal', {
            regexps: {
                format: /(o)/
            },
            format: function(value, format, roundingFunction) {
                var locale = numeral.locales[numeral.options.currentLocale], output, ordinal = numeral._.includes(format, ' o') ? ' ' : '';
                // check for space before
                format = format.replace(/\s?o/, '');
                ordinal += locale.ordinal(value);
                output = numeral._.numberToFormat(value, format, roundingFunction);
                return output + ordinal;
            }
        });
    })();
    (function() {
        numeral.register('format', 'percentage', {
            regexps: {
                format: /(%)/,
                unformat: /(%)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' %') ? ' ' : '', output;
                if (numeral.options.scalePercentBy100) value = value * 100;
                // check for space before %
                format = format.replace(/\s?\%/, '');
                output = numeral._.numberToFormat(value, format, roundingFunction);
                if (numeral._.includes(output, ')')) {
                    output = output.split('');
                    output.splice(-1, 0, space + '%');
                    output = output.join('');
                } else output = output + space + '%';
                return output;
            },
            unformat: function(string) {
                var number = numeral._.stringToNumber(string);
                if (numeral.options.scalePercentBy100) return number * 0.01;
                return number;
            }
        });
    })();
    (function() {
        numeral.register('format', 'time', {
            regexps: {
                format: /(:)/,
                unformat: /(:)/
            },
            format: function(value, format, roundingFunction) {
                var hours = Math.floor(value / 60 / 60), minutes = Math.floor((value - hours * 3600) / 60), seconds = Math.round(value - hours * 3600 - minutes * 60);
                return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
            },
            unformat: function(string) {
                var timeArray = string.split(':'), seconds = 0;
                // turn hours and minutes into seconds and add them all up
                if (timeArray.length === 3) {
                    // hours
                    seconds = seconds + Number(timeArray[0]) * 3600;
                    // minutes
                    seconds = seconds + Number(timeArray[1]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[2]);
                } else if (timeArray.length === 2) {
                    // minutes
                    seconds = seconds + Number(timeArray[0]) * 60;
                    // seconds
                    seconds = seconds + Number(timeArray[1]);
                }
                return Number(seconds);
            }
        });
    })();
    return numeral;
});

});


parcelRegister("Lig7B", function(module, exports) {

$parcel$export(module.exports, "default", () => $08e28dc35f711e9a$export$2e2bcd8739ae039);
parcelRequire("eUqFw");

var $KC0XU = parcelRequire("KC0XU");

var $lHkHI = parcelRequire("lHkHI");
const $08e28dc35f711e9a$var$RatingsWithMinimum = (props)=>{
    const { ratings: ratings, ratings: { numRatings: numRatings }, onClick: onClick, showRatingCount: showRatingCount, numericRatingStyles: numericRatingStyles } = props;
    if (numRatings < 3) return null;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $KC0XU.default), {
        onClick: onClick,
        ratings: ratings,
        showRatingCount: showRatingCount,
        numericRatingStyles: numericRatingStyles
    });
};
$08e28dc35f711e9a$var$RatingsWithMinimum.defaultProps = {
    showRatingCount: true
};
var $08e28dc35f711e9a$export$2e2bcd8739ae039 = $08e28dc35f711e9a$var$RatingsWithMinimum;

});
parcelRegister("KC0XU", function(module, exports) {

$parcel$export(module.exports, "default", () => $08c1c8e4d0196956$export$2e2bcd8739ae039);

var $k3yE3 = parcelRequire("k3yE3");

var $lpjDh = parcelRequire("lpjDh");

var $9rIMC = parcelRequire("9rIMC");
parcelRequire("eUqFw");

var $f7YGc = parcelRequire("f7YGc");

var $jwyfr = parcelRequire("jwyfr");

var $g29Wx = parcelRequire("g29Wx");

var $v9N0g = parcelRequire("v9N0g");

var $coqei = parcelRequire("coqei");

var $lHkHI = parcelRequire("lHkHI");
const $08c1c8e4d0196956$var$Ratings = (props)=>{
    const { onClick: onClick, ratings: ratings, showRatingCount: showRatingCount = true, showNumericRating: showNumericRating = true, numericRatingStyles: numericRatingStyles } = props;
    const getStars = (clickable)=>(0, $v9N0g.getStarVariations)(ratings).map((variation, index)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $g29Wx.StarIconContainer), {
                clickable: clickable,
                variation: variation,
                "data-testid": "star-rating-".concat(variation),
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lpjDh))), {
                    label: ""
                })
            }, index));
    const onRatingsClick = (e)=>{
        if (onClick) (0, $9rIMC).maybeOpenInNewTab(e, ()=>{
            e.stopPropagation();
            onClick();
        });
    };
    const clickable = !!onClick;
    const stars = getStars(clickable);
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $g29Wx.RatingContainer), {
        onClick: onRatingsClick,
        clickable: clickable,
        "aria-label": "Star Ratings",
        children: [
            !!ratings.numRatings && showNumericRating && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $g29Wx.NumericRatingContainer), {
                "data-testid": (0, $jwyfr.NUMERIC_RATING_TESTID),
                overrideStyles: numericRatingStyles,
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $g29Wx.AverageNumericRating), {
                        overrideStyles: numericRatingStyles,
                        children: (0, $v9N0g.getRoundedRating)(ratings.avgStars)
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                        children: "/"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                        children: (0, $jwyfr.TOTAL_STARS)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $coqei.StarGradients), {}),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $g29Wx.AverageRating), {
                "data-testid": (0, $jwyfr.STAR_RATINGS_TESTID),
                children: stars
            }),
            !ratings.numRatings && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $g29Wx.NoReviewText), {
                children: "No reviews yet"
            }),
            !!ratings.numRatings && showRatingCount && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $g29Wx.RatingsCount), {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $k3yE3.default), {
                    children: "".concat((0, $f7YGc.shortFormat)(ratings.numRatings))
                })
            })
        ]
    });
};
var $08c1c8e4d0196956$export$2e2bcd8739ae039 = $08c1c8e4d0196956$var$Ratings;

});
parcelRegister("k3yE3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d5a9a7f5745cdfb$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $3puyA = parcelRequire("3puyA");

var $1QWP9 = parcelRequire("1QWP9");
var $ixqNN = parcelRequire("ixqNN");
var $gv7Ek = parcelRequire("gv7Ek");

var $3h6E1 = parcelRequire("3h6E1");
function $6d5a9a7f5745cdfb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6d5a9a7f5745cdfb$var$boxStyles = (0, $gv7Ek.xcss)({
    borderRadius: 'border.radius.200',
    display: 'inline-flex',
    blockSize: 'min-content',
    flexShrink: 0 // Text component can wrap text, this ensures it doesn't wrap in flex containers.
});
/**
 * Visual refresh colors.
 * Hardcoded hex colors are used as the they should not change based on theme, and there are no appropriate color tokens.
 *
 * Using separate variables as opposed to an object, to comply with UI styling standard
 * https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-unsafe-values/usage#object-access
 */ const $6d5a9a7f5745cdfb$var$neutral300 = '#DDDEE1';
const $6d5a9a7f5745cdfb$var$red300 = '#FD9891';
const $6d5a9a7f5745cdfb$var$blue300 = '#8FB8F6';
const $6d5a9a7f5745cdfb$var$neutral1000 = '#292A2E';
const $6d5a9a7f5745cdfb$var$styles = {
    root: {
        name: "85bcg3",
        styles: "display:inline-flex;box-sizing:border-box;min-width:var(--ds-space-300, 24px);justify-content:center;flex-shrink:0;block-size:min-content;border-radius:var(--ds-border-radius-050, 2px);padding-inline:var(--ds-space-050, 4px)"
    },
    added: {
        name: "4x7cmh",
        styles: "background-color:var(--ds-background-success, #DCFFF1);color:var(--ds-text, #172B4D)"
    },
    default: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $6d5a9a7f5745cdfb$var$neutral300,
        color: $6d5a9a7f5745cdfb$var$neutral1000
    }),
    important: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $6d5a9a7f5745cdfb$var$red300,
        color: $6d5a9a7f5745cdfb$var$neutral1000
    }),
    primary: /*#__PURE__*/ (0, $byn9U.css)({
        backgroundColor: $6d5a9a7f5745cdfb$var$blue300,
        color: $6d5a9a7f5745cdfb$var$neutral1000
    }),
    primaryInverted: {
        name: "1425qmy",
        styles: "background-color:var(--ds-surface, #FFFFFF);color:var(--ds-text-brand, #0C66E4)"
    },
    removed: {
        name: "10hiq01",
        styles: "background-color:var(--ds-background-danger, #FFECEB);color:var(--ds-text, #172B4D)"
    }
};
/**
 * __Badge__
 *
 * This component gives you the full badge functionality and automatically formats the number you provide in \`children\`.
 *
 * - [Examples](https://atlassian.design/components/badge/examples)
 * - [Code](https://atlassian.design/components/badge/code)
 * - [Usage](https://atlassian.design/components/badge/usage)
 */ const $6d5a9a7f5745cdfb$var$Badge = /*#__PURE__*/ (0, $eUqFw.memo)(function Badge({ appearance: appearance = 'default', children: children = 0, max: max = 99, style: style, testId: testId }) {
    if ((0, $3puyA.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        "data-testid": testId,
        css: [
            $6d5a9a7f5745cdfb$var$styles.root,
            $6d5a9a7f5745cdfb$var$styles[appearance]
        ],
        style: {
            background: style?.backgroundColor,
            color: style?.color
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ixqNN.default), {
        size: "small",
        align: "center",
        color: "inherit"
    }, typeof children === 'number' && max ? (0, $3h6E1.formatValue)(children, max) : children));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $1QWP9.default), {
        testId: testId,
        as: "span",
        backgroundColor: $6d5a9a7f5745cdfb$var$backgroundColors[appearance],
        xcss: $6d5a9a7f5745cdfb$var$boxStyles,
        style: {
            background: style?.backgroundColor,
            color: style?.color
        },
        paddingInline: "space.075"
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ixqNN.default), {
        size: "UNSAFE_small",
        align: "center",
        color: style?.color ? 'inherit' : $6d5a9a7f5745cdfb$var$textColors[appearance]
    }, typeof children === 'number' && max ? (0, $3h6E1.formatValue)(children, max) : children));
});
$6d5a9a7f5745cdfb$var$Badge.displayName = 'Badge';
var $6d5a9a7f5745cdfb$export$2e2bcd8739ae039 = $6d5a9a7f5745cdfb$var$Badge;
const $6d5a9a7f5745cdfb$var$backgroundColors = {
    added: 'color.background.success',
    default: 'color.background.neutral',
    important: 'color.background.danger.bold',
    primary: 'color.background.brand.bold',
    primaryInverted: 'elevation.surface',
    removed: 'color.background.danger'
};
const $6d5a9a7f5745cdfb$var$textColors = {
    added: 'color.text.success',
    default: 'color.text',
    important: 'color.text.inverse',
    primary: 'color.text.inverse',
    primaryInverted: 'color.text.brand',
    removed: 'color.text.danger'
};

});
parcelRegister("3h6E1", function(module, exports) {

$parcel$export(module.exports, "formatValue", () => $b9503f1ff7c199bb$export$7c4d25c0c3217d8c);
function $b9503f1ff7c199bb$var$getSafeValue(value = 0) {
    const numericValue = +value;
    if (numericValue < 0) return 0;
    return value;
}
function $b9503f1ff7c199bb$export$7c4d25c0c3217d8c(value, max) {
    const safeValue = $b9503f1ff7c199bb$var$getSafeValue(value);
    const safeMax = $b9503f1ff7c199bb$var$getSafeValue(max);
    if (safeMax && safeMax < safeValue) return `${safeMax}+`;
    if (safeValue === Infinity) return "\u221E";
    return safeValue.toString();
}

});


parcelRegister("jwyfr", function(module, exports) {

$parcel$export(module.exports, "TOTAL_STARS", () => $e36b9270a51c36a3$export$8cb47a0365023893);
$parcel$export(module.exports, "STAR_RATINGS_TESTID", () => $e36b9270a51c36a3$export$8740eabc94da0660);
$parcel$export(module.exports, "NUMERIC_RATING_TESTID", () => $e36b9270a51c36a3$export$ef523ba528d58576);
$parcel$export(module.exports, "YELLOW_STAR", () => $e36b9270a51c36a3$export$f184eda4b0b77bc);
$parcel$export(module.exports, "GREY_STAR", () => $e36b9270a51c36a3$export$94b653fff3d5e100);
$parcel$export(module.exports, "DISABLED_STAR", () => $e36b9270a51c36a3$export$81dd0c41798198d4);
$parcel$export(module.exports, "QUARTER_STAR", () => $e36b9270a51c36a3$export$5ba14a4123b4d7e7);
$parcel$export(module.exports, "QUARTER_STAR_GRADIENT_ID", () => $e36b9270a51c36a3$export$7a173ef8f4ab2536);
$parcel$export(module.exports, "QUARTER_STAR_GRADIENT_HOVER_ID", () => $e36b9270a51c36a3$export$3879bdb57085600b);
$parcel$export(module.exports, "HALF_STAR", () => $e36b9270a51c36a3$export$c0557090bfd42e78);
$parcel$export(module.exports, "HALF_STAR_GRADIENT_ID", () => $e36b9270a51c36a3$export$8587a005cca6e251);
$parcel$export(module.exports, "HALF_STAR_GRADIENT_HOVER_ID", () => $e36b9270a51c36a3$export$cd10504e797b759d);
$parcel$export(module.exports, "THREE_QUARTER_STAR", () => $e36b9270a51c36a3$export$a908142c7b579a36);
$parcel$export(module.exports, "THREE_QUARTER_STAR_GRADIENT_ID", () => $e36b9270a51c36a3$export$656b127be67bb0a1);
$parcel$export(module.exports, "THREE_QUARTER_STAR_GRADIENT_HOVER_ID", () => $e36b9270a51c36a3$export$d0d735bd13762d53);
$parcel$export(module.exports, "STAR_FILL_MAP", () => $e36b9270a51c36a3$export$fe8acbce00b8388b);

var $j0gMm = parcelRequire("j0gMm");
const $e36b9270a51c36a3$export$8cb47a0365023893 = 4;
const $e36b9270a51c36a3$export$8740eabc94da0660 = 'star-ratings';
const $e36b9270a51c36a3$export$ef523ba528d58576 = 'numeric-rating';
const $e36b9270a51c36a3$export$f184eda4b0b77bc = 'yellowStar';
const $e36b9270a51c36a3$export$94b653fff3d5e100 = 'greyStar';
const $e36b9270a51c36a3$export$81dd0c41798198d4 = 'disabledStar';
const $e36b9270a51c36a3$export$5ba14a4123b4d7e7 = 'quarterStar';
const $e36b9270a51c36a3$export$7a173ef8f4ab2536 = 'amktCommonQuarterStar';
const $e36b9270a51c36a3$export$3879bdb57085600b = 'amktCommonQuarterStarHover';
const $e36b9270a51c36a3$export$c0557090bfd42e78 = 'halfStar';
const $e36b9270a51c36a3$export$8587a005cca6e251 = 'amktCommonHalfStar';
const $e36b9270a51c36a3$export$cd10504e797b759d = 'amktCommonHalfStarHover';
const $e36b9270a51c36a3$export$a908142c7b579a36 = 'threeQuarterStar';
const $e36b9270a51c36a3$export$656b127be67bb0a1 = 'amktCommonThreeQuarterStar';
const $e36b9270a51c36a3$export$d0d735bd13762d53 = 'amktCommonThreeQuarterStarHover';
const $e36b9270a51c36a3$export$fe8acbce00b8388b = {
    [$e36b9270a51c36a3$export$f184eda4b0b77bc]: {
        fill: "var(--ds-icon-accent-orange, ".concat((0, $j0gMm.R300), ")"),
        fillHover: "var(--ds-background-accent-orange-bolder, ".concat((0, $j0gMm.R400), ")")
    },
    [$e36b9270a51c36a3$export$94b653fff3d5e100]: {
        fill: "var(--ds-background-accent-gray-bolder, ".concat((0, $j0gMm.N600), ")"),
        fillHover: "var(--ds-background-accent-gray-bolder-hovered, ".concat((0, $j0gMm.N100), ")")
    },
    [$e36b9270a51c36a3$export$5ba14a4123b4d7e7]: {
        fill: "url(#".concat($e36b9270a51c36a3$export$7a173ef8f4ab2536, ")"),
        fillHover: "url(#".concat($e36b9270a51c36a3$export$3879bdb57085600b, ")")
    },
    [$e36b9270a51c36a3$export$c0557090bfd42e78]: {
        fill: "url(#".concat($e36b9270a51c36a3$export$8587a005cca6e251, ")"),
        fillHover: "url(#".concat($e36b9270a51c36a3$export$cd10504e797b759d, ")")
    },
    [$e36b9270a51c36a3$export$a908142c7b579a36]: {
        fill: "url(#".concat($e36b9270a51c36a3$export$656b127be67bb0a1, ")"),
        fillHover: "url(#".concat($e36b9270a51c36a3$export$d0d735bd13762d53, ")")
    },
    [$e36b9270a51c36a3$export$81dd0c41798198d4]: {
        fill: "var(--ds-icon-disabled, ".concat((0, $j0gMm.N70A), ")")
    }
};

});

parcelRegister("g29Wx", function(module, exports) {

$parcel$export(module.exports, "AverageRating", () => $bac48bbba69b5bae$export$9765b38cba07b8b9);
$parcel$export(module.exports, "RatingsCount", () => $bac48bbba69b5bae$export$7490f2556754ce37);
$parcel$export(module.exports, "RatingContainer", () => $bac48bbba69b5bae$export$ea0e22a430af9019);
$parcel$export(module.exports, "StarIconContainer", () => $bac48bbba69b5bae$export$a6a73f636a2683f4);
$parcel$export(module.exports, "StarGradientContainer", () => $bac48bbba69b5bae$export$aff3f8e463c240a6);
$parcel$export(module.exports, "NoReviewText", () => $bac48bbba69b5bae$export$ff6c83e6916ea5bc);
$parcel$export(module.exports, "AverageNumericRating", () => $bac48bbba69b5bae$export$e381297bd872844d);
$parcel$export(module.exports, "NumericRatingContainer", () => $bac48bbba69b5bae$export$36bec2463c85305d);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $jwyfr = parcelRequire("jwyfr");
function $bac48bbba69b5bae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bac48bbba69b5bae$export$9765b38cba07b8b9 = (0, $3UXZ8.default)("span", {
    target: "e1csono30",
    label: "AverageRating"
})({
    name: "10p9k66",
    styles: "vertical-align:middle;display:inline-flex;flex-wrap:nowrap;"
});
const $bac48bbba69b5bae$export$7490f2556754ce37 = (0, $3UXZ8.default)("span", {
    target: "e1csono31",
    label: "RatingsCount"
})({
    name: "z0txda",
    styles: "margin-left:var(--ds-space-050, 4px);"
});
const $bac48bbba69b5bae$export$ea0e22a430af9019 = (0, $3UXZ8.default)("button", {
    target: "e1csono32",
    label: "RatingContainer"
})("background:none;border:none;padding:0;display:flex;align-items:center;flex:1 0 auto;margin-left:var(--ds-space-negative-050, -4px);height:fit-content;", (props)=>{
    if (props.clickable) return "\n                &:hover {\n                    cursor: pointer;\n                }\n            ";
}, "");
const $bac48bbba69b5bae$export$a6a73f636a2683f4 = (0, $3UXZ8.default)("span", {
    target: "e1csono33",
    label: "StarIconContainer"
})("display:inline-block;vertical-align:middle;line-height:1;svg{width:24px;height:24px;}path{fill:", (props)=>(0, $jwyfr.STAR_FILL_MAP)[props.variation].fill, ";}", $bac48bbba69b5bae$export$ea0e22a430af9019, ":hover &{path{", (props)=>props.clickable ? "fill:  ".concat((0, $jwyfr.STAR_FILL_MAP)[props.variation].fillHover) : "", "}}&:not(:first-of-type){margin-left:-3px;}");
const $bac48bbba69b5bae$export$aff3f8e463c240a6 = (0, $3UXZ8.default)("svg", {
    target: "e1csono34",
    label: "StarGradientContainer"
})({
    name: "zm89ux",
    styles: "width:0;height:0;position:absolute;"
});
const $bac48bbba69b5bae$export$ff6c83e6916ea5bc = (0, $3UXZ8.default)("span", {
    target: "e1csono35",
    label: "NoReviewText"
})("font-size:14px;color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N500), ")"), ";");
const $bac48bbba69b5bae$export$e381297bd872844d = (0, $3UXZ8.default)("span", {
    target: "e1csono36",
    label: "AverageNumericRating"
})("font-weight:600;font-size:", (props)=>{
    var _props$overrideStyles;
    return ((_props$overrideStyles = props.overrideStyles) === null || _props$overrideStyles === void 0 ? void 0 : _props$overrideStyles.avgNumFontSize) || 14;
}, "px;");
const $bac48bbba69b5bae$export$36bec2463c85305d = (0, $3UXZ8.default)("span", {
    target: "e1csono37",
    label: "NumericRatingContainer"
})("display:flex;align-items:center;color:", "var(--ds-text, ".concat((0, $j0gMm.N800), ")"), ";gap:", (props)=>{
    var _props$overrideStyles2;
    return ((_props$overrideStyles2 = props.overrideStyles) === null || _props$overrideStyles2 === void 0 ? void 0 : _props$overrideStyles2.gap) || '0px';
}, ";font-weight:", (props)=>{
    var _props$overrideStyles3;
    return ((_props$overrideStyles3 = props.overrideStyles) === null || _props$overrideStyles3 === void 0 ? void 0 : _props$overrideStyles3.fontWeight) || 400;
}, ";font-size:", (props)=>{
    var _props$overrideStyles4;
    return ((_props$overrideStyles4 = props.overrideStyles) === null || _props$overrideStyles4 === void 0 ? void 0 : _props$overrideStyles4.fontSize) || 14;
}, "px;margin-left:var(--ds-space-050, 4px);");

});

parcelRegister("v9N0g", function(module, exports) {

$parcel$export(module.exports, "getStarVariations", () => $05da7d54c5db5a85$export$2463346a7bf59173);
$parcel$export(module.exports, "getRoundedRating", () => $05da7d54c5db5a85$export$258e17a1bfb65cc4);

var $5zQU9 = parcelRequire("5zQU9");

var $jwyfr = parcelRequire("jwyfr");
function $05da7d54c5db5a85$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $05da7d54c5db5a85$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $05da7d54c5db5a85$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $05da7d54c5db5a85$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $05da7d54c5db5a85$export$e20af336285857cb = (val)=>{
    if (val >= 0.875) return 1;
    else if (val >= 0.625) return 0.75;
    else if (val >= 0.375) return 0.5;
    else if (val >= 0.125) return 0.25;
    return 0;
};
const $05da7d54c5db5a85$export$e7373081cdd0df48 = (averageStars)=>{
    const integer = Math.trunc(averageStars);
    const decimal = averageStars % 1;
    return integer + $05da7d54c5db5a85$export$e20af336285857cb(decimal);
};
const $05da7d54c5db5a85$export$c3b5857cf6a23fc = {
    0: {},
    0.25: {
        quarterStarsCount: 1
    },
    0.5: {
        halfStarsCount: 1
    },
    0.75: {
        threeQuarterStarsCount: 1
    }
};
const $05da7d54c5db5a85$export$a00beb5a07c70ef1 = (averageStars)=>{
    const discreteRating = $05da7d54c5db5a85$export$e7373081cdd0df48(averageStars);
    const yellowStarsCount = Math.trunc(discreteRating);
    const partiallyFilledStarsCount = Math.ceil(discreteRating % 1);
    const partiallyFilledStars = $05da7d54c5db5a85$export$c3b5857cf6a23fc[discreteRating % 1];
    const greyStarsCount = (0, $jwyfr.TOTAL_STARS) - yellowStarsCount - partiallyFilledStarsCount;
    return $05da7d54c5db5a85$var$_objectSpread({
        yellowStarsCount: yellowStarsCount,
        greyStarsCount: greyStarsCount
    }, partiallyFilledStars);
};
const $05da7d54c5db5a85$export$2463346a7bf59173 = (ratings)=>{
    if (!ratings.numRatings) return [
        (0, $jwyfr.DISABLED_STAR)
    ];
    const { yellowStarsCount: yellowStarsCount, quarterStarsCount: quarterStarsCount = 0, halfStarsCount: halfStarsCount = 0, threeQuarterStarsCount: threeQuarterStarsCount = 0, greyStarsCount: greyStarsCount } = $05da7d54c5db5a85$export$a00beb5a07c70ef1(ratings.avgStars);
    return [
        ...new Array(yellowStarsCount).fill((0, $jwyfr.YELLOW_STAR)),
        ...new Array(quarterStarsCount).fill((0, $jwyfr.QUARTER_STAR)),
        ...new Array(halfStarsCount).fill((0, $jwyfr.HALF_STAR)),
        ...new Array(threeQuarterStarsCount).fill((0, $jwyfr.THREE_QUARTER_STAR)),
        ...new Array(greyStarsCount).fill((0, $jwyfr.GREY_STAR))
    ];
};
const $05da7d54c5db5a85$export$258e17a1bfb65cc4 = (rating)=>Number(rating.toFixed(1));

});

parcelRegister("coqei", function(module, exports) {

$parcel$export(module.exports, "StarGradients", () => $905c128e7a489545$export$9e5638a6deed949e);
parcelRequire("eUqFw");

var $jwyfr = parcelRequire("jwyfr");

var $g29Wx = parcelRequire("g29Wx");

var $lHkHI = parcelRequire("lHkHI");
const $905c128e7a489545$var$STAR_GRADIENT_CONFIG = [
    {
        starType: (0, $jwyfr.QUARTER_STAR),
        id: (0, $jwyfr.QUARTER_STAR_GRADIENT_ID),
        hoverId: (0, $jwyfr.QUARTER_STAR_GRADIENT_HOVER_ID),
        offset: '25%'
    },
    {
        startType: (0, $jwyfr.HALF_STAR),
        id: (0, $jwyfr.HALF_STAR_GRADIENT_ID),
        hoverId: (0, $jwyfr.HALF_STAR_GRADIENT_HOVER_ID),
        offset: '50%'
    },
    {
        starType: (0, $jwyfr.THREE_QUARTER_STAR),
        id: (0, $jwyfr.THREE_QUARTER_STAR_GRADIENT_ID),
        hoverId: (0, $jwyfr.THREE_QUARTER_STAR_GRADIENT_HOVER_ID),
        offset: '75%'
    }
];
const $905c128e7a489545$export$9e5638a6deed949e = ()=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: $905c128e7a489545$var$STAR_GRADIENT_CONFIG.map((_ref)=>{
            let { id: id, hoverId: hoverId, offset: offset } = _ref;
            return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $g29Wx.StarGradientContainer), {
                        children: /*#__PURE__*/ (0, $lHkHI.jsxs)("linearGradient", {
                            id: id,
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)("stop", {
                                    offset: offset,
                                    stopColor: (0, $jwyfr.STAR_FILL_MAP)[0, $jwyfr.YELLOW_STAR].fill
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)("stop", {
                                    offset: offset,
                                    stopColor: (0, $jwyfr.STAR_FILL_MAP)[0, $jwyfr.GREY_STAR].fill
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $g29Wx.StarGradientContainer), {
                        children: /*#__PURE__*/ (0, $lHkHI.jsxs)("linearGradient", {
                            id: hoverId,
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)("stop", {
                                    offset: offset,
                                    stopColor: (0, $jwyfr.STAR_FILL_MAP)[0, $jwyfr.YELLOW_STAR].fillHover
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)("stop", {
                                    offset: offset,
                                    stopColor: (0, $jwyfr.STAR_FILL_MAP)[0, $jwyfr.GREY_STAR].fillHover
                                })
                            ]
                        })
                    })
                ]
            });
        })
    });
};

});



parcelRegister("hxCMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc5399619ca3744b$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $4IPhO = parcelRequire("4IPhO");

var $lgRZl = parcelRequire("lgRZl");

var $lHkHI = parcelRequire("lHkHI");
const $cc5399619ca3744b$var$DEFAULT_GRID_COLUMNS = 12;
class $cc5399619ca3744b$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { children: children, className: className, xs: xs, sm: sm, md: md, lg: lg, xl: xl } = this.props;
        const style = (0, (/*@__PURE__*/$parcel$interopDefault($4IPhO)))({
            width: {
                xs: xs,
                sm: sm,
                md: md,
                lg: lg,
                xl: xl
            },
            screenClass: this.props.screenClass,
            gutterWidth: this.props.gutterWidth,
            gridColumns: $cc5399619ca3744b$var$DEFAULT_GRID_COLUMNS,
            moreStyle: {
                overflow: 'visible'
            }
        });
        return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
            className: className,
            style: style,
            children: children
        });
    }
}
(0, $5zQU9.default)($cc5399619ca3744b$export$2e2bcd8739ae039, "propTypes", {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    screenClass: (0, $lgRZl.default).screenClass.isRequired,
    gutterWidth: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    xs: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    sm: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    md: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    lg: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    xl: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
});
(0, $5zQU9.default)($cc5399619ca3744b$export$2e2bcd8739ae039, "defaultProps", {
    children: null,
    xs: 12,
    sm: 12,
    md: 12,
    lg: 12,
    xl: 12
});

});
parcelRegister("4IPhO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $j4Wxq = parcelRequire("j4Wxq");
function $37030ddd36a9f945$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $37030ddd36a9f945$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $37030ddd36a9f945$var$ownKeys(Object(source), true).forEach(function(key) {
            $37030ddd36a9f945$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $37030ddd36a9f945$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $37030ddd36a9f945$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $37030ddd36a9f945$var$hasWidth = function hasWidth(widths) {
    return Object.keys(widths).reduce(function(acc, cur) {
        return acc || widths[cur];
    }, false);
};
var $37030ddd36a9f945$var$getWidth = function getWidth(width, gridColumns) {
    if (typeof width !== 'number') return undefined;
    var normalizedWidth = Math.max(0, Math.min(gridColumns, width));
    return "".concat(100 / gridColumns * normalizedWidth, "%");
};
var $37030ddd36a9f945$var$_default = function _default(_ref) {
    var _ref$forceWidth = _ref.forceWidth, forceWidth = _ref$forceWidth === void 0 ? null : _ref$forceWidth, _ref$width = _ref.width, width = _ref$width === void 0 ? {} : _ref$width, _ref$offset = _ref.offset, offset = _ref$offset === void 0 ? {} : _ref$offset, _ref$pull = _ref.pull, pull = _ref$pull === void 0 ? {} : _ref$pull, _ref$push = _ref.push, push = _ref$push === void 0 ? {} : _ref$push, debug = _ref.debug, screenClass = _ref.screenClass, gutterWidth = _ref.gutterWidth, moreStyle = _ref.moreStyle, gridColumns = _ref.gridColumns;
    var styles = {
        boxSizing: 'border-box',
        minHeight: 1,
        position: 'relative',
        paddingLeft: gutterWidth / 2,
        paddingRight: gutterWidth / 2,
        width: '100%'
    };
    if (debug) {
        styles.outline = '1px solid silver';
        styles.background = 'rgba(0,0,0,.05)';
        styles.lineHeight = '32px';
    }
    styles.flexBasis = '100%';
    styles.flexGrow = 0;
    styles.flexShrink = 0;
    styles.maxWidth = '100%';
    styles.marginLeft = '0%';
    styles.right = 'auto';
    styles.left = 'auto';
    $j4Wxq.screenClasses.forEach(function(size, index) {
        if ($j4Wxq.screenClasses.indexOf(screenClass) >= index) {
            var currentWidth = $37030ddd36a9f945$var$getWidth(width[size], gridColumns);
            var isSizedToContent = width[size] === 'content';
            styles.flexBasis = isSizedToContent ? 'auto' : currentWidth || styles.flexBasis;
            styles.width = styles.flexBasis;
            styles.maxWidth = currentWidth || styles.maxWidth;
            styles.marginLeft = $37030ddd36a9f945$var$getWidth(offset[size], gridColumns) || styles.marginLeft;
            styles.right = $37030ddd36a9f945$var$getWidth(pull[size], gridColumns) || styles.right;
            styles.left = $37030ddd36a9f945$var$getWidth(push[size], gridColumns) || styles.left;
        }
    });
    if (!$37030ddd36a9f945$var$hasWidth(width)) {
        styles.flexBasis = 0;
        styles.flexGrow = 1;
    }
    if (forceWidth) {
        styles.flexBasis = 'unset';
        styles.flexGrow = 'unset';
        styles.flexShrink = 'unset';
        styles.width = forceWidth;
    }
    return $37030ddd36a9f945$var$_objectSpread($37030ddd36a9f945$var$_objectSpread({}, styles), moreStyle);
};
module.exports.default = $37030ddd36a9f945$var$_default;

});
parcelRegister("j4Wxq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.useScreenClass = module.exports.screenClasses = void 0;

var $eUqFw = parcelRequire("eUqFw");

var $ET433 = parcelRequire("ET433");

var $8A7Vu = parcelRequire("8A7Vu");
function $de3bcc7ef89f62c7$var$_slicedToArray(arr, i) {
    return $de3bcc7ef89f62c7$var$_arrayWithHoles(arr) || $de3bcc7ef89f62c7$var$_iterableToArrayLimit(arr, i) || $de3bcc7ef89f62c7$var$_unsupportedIterableToArray(arr, i) || $de3bcc7ef89f62c7$var$_nonIterableRest();
}
function $de3bcc7ef89f62c7$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $de3bcc7ef89f62c7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $de3bcc7ef89f62c7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $de3bcc7ef89f62c7$var$_arrayLikeToArray(o, minLen);
}
function $de3bcc7ef89f62c7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $de3bcc7ef89f62c7$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $de3bcc7ef89f62c7$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $de3bcc7ef89f62c7$var$getViewPort = function getViewPort(source) {
    if (source && source.current && source.current.clientWidth) return source.current.clientWidth;
    if (typeof $8A7Vu.Window !== 'undefined' && $8A7Vu.Window.innerWidth) return $8A7Vu.Window.innerWidth;
    return null;
};
var $de3bcc7ef89f62c7$var$screenClasses = [
    'xs',
    'sm',
    'md',
    'lg',
    'xl',
    'xxl'
];
module.exports.screenClasses = $de3bcc7ef89f62c7$var$screenClasses;
var $de3bcc7ef89f62c7$var$useScreenClass = function useScreenClass(source, fallbackScreenClass) {
    var getScreenClass = function getScreenClass() {
        var _getConfiguration = (0, $ET433.getConfiguration)(), breakpoints = _getConfiguration.breakpoints, defaultScreenClass = _getConfiguration.defaultScreenClass, maxScreenClass = _getConfiguration.maxScreenClass;
        var newScreenClass = defaultScreenClass;
        var viewport = $de3bcc7ef89f62c7$var$getViewPort(source);
        if (viewport) {
            newScreenClass = 'xs';
            if (breakpoints[0] && viewport >= breakpoints[0]) newScreenClass = 'sm';
            if (breakpoints[1] && viewport >= breakpoints[1]) newScreenClass = 'md';
            if (breakpoints[2] && viewport >= breakpoints[2]) newScreenClass = 'lg';
            if (breakpoints[3] && viewport >= breakpoints[3]) newScreenClass = 'xl';
            if (breakpoints[4] && viewport >= breakpoints[4]) newScreenClass = 'xxl';
        } else if (fallbackScreenClass) newScreenClass = fallbackScreenClass;
        var newScreenClassIndex = $de3bcc7ef89f62c7$var$screenClasses.indexOf(newScreenClass);
        var maxScreenClassIndex = $de3bcc7ef89f62c7$var$screenClasses.indexOf(maxScreenClass);
        if (maxScreenClassIndex >= 0 && newScreenClassIndex > maxScreenClassIndex) newScreenClass = $de3bcc7ef89f62c7$var$screenClasses[maxScreenClassIndex];
        return newScreenClass;
    };
    var _useState = (0, $eUqFw.useState)(function() {
        return getScreenClass();
    }), _useState2 = $de3bcc7ef89f62c7$var$_slicedToArray(_useState, 2), screenClass = _useState2[0], setScreenClass = _useState2[1];
    (0, $eUqFw.useEffect)(function() {
        var handleWindowResized = function handleWindowResized() {
            return setScreenClass(getScreenClass());
        };
        $8A7Vu.Window.addEventListener('resize', handleWindowResized, false);
        return function() {
            $8A7Vu.Window.removeEventListener('resize', handleWindowResized, false);
        };
    }, []);
    return screenClass;
};
module.exports.useScreenClass = $de3bcc7ef89f62c7$var$useScreenClass;

});
parcelRegister("ET433", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.setConfiguration = module.exports.getConfiguration = void 0;
function $07ae7329db35275e$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $07ae7329db35275e$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $07ae7329db35275e$var$ownKeys(Object(source), true).forEach(function(key) {
            $07ae7329db35275e$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $07ae7329db35275e$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $07ae7329db35275e$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $07ae7329db35275e$var$configuration = {
    breakpoints: [
        576,
        768,
        992,
        1200,
        1600
    ],
    containerWidths: [
        540,
        750,
        960,
        1140,
        1540
    ],
    gutterWidth: 30,
    gridColumns: 12,
    defaultScreenClass: 'xxl',
    maxScreenClass: 'xxl'
};
var $07ae7329db35275e$var$getConfiguration = function getConfiguration() {
    return $07ae7329db35275e$var$configuration;
};
module.exports.getConfiguration = $07ae7329db35275e$var$getConfiguration;
var $07ae7329db35275e$var$setConfiguration = function setConfiguration(newConfiguration) {
    $07ae7329db35275e$var$configuration = $07ae7329db35275e$var$_objectSpread($07ae7329db35275e$var$_objectSpread({}, $07ae7329db35275e$var$configuration), newConfiguration);
};
module.exports.setConfiguration = $07ae7329db35275e$var$setConfiguration;

});

parcelRegister("8A7Vu", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Div", {
    enumerable: true,
    get: function get() {
        return $63f7d5853c53700c$var$_Div.default;
    }
});
Object.defineProperty(module.exports, "Span", {
    enumerable: true,
    get: function get() {
        return $63f7d5853c53700c$var$_Span.default;
    }
});
Object.defineProperty(module.exports, "Window", {
    enumerable: true,
    get: function get() {
        return $63f7d5853c53700c$var$_Window.default;
    }
});

var $63f7d5853c53700c$var$_Div = $63f7d5853c53700c$var$_interopRequireDefault((parcelRequire("hJQ9s")));

var $63f7d5853c53700c$var$_Span = $63f7d5853c53700c$var$_interopRequireDefault((parcelRequire("jecJY")));

var $63f7d5853c53700c$var$_Window = $63f7d5853c53700c$var$_interopRequireDefault((parcelRequire("3wHEH")));
function $63f7d5853c53700c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("hJQ9s", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $ce9f17d7ebefbcb1$var$_default = 'div';
module.exports.default = $ce9f17d7ebefbcb1$var$_default;

});

parcelRegister("jecJY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $dff93524f79b65cf$var$_default = 'span';
module.exports.default = $dff93524f79b65cf$var$_default;

});

parcelRegister("3wHEH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
/* global window */ var $2916395300190687$var$_default = typeof window !== 'undefined' ? window : undefined;
module.exports.default = $2916395300190687$var$_default;

});





parcelRegister("3BBSQ", function(module, exports) {

$parcel$export(module.exports, "AppTileHighlightedText", () => $2a0236b61eb86ec3$export$2f2d27674dcbd0cc);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $g5DHJ = parcelRequire("g5DHJ");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $2a0236b61eb86ec3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2a0236b61eb86ec3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2a0236b61eb86ec3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2a0236b61eb86ec3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $2a0236b61eb86ec3$export$73b5d8f6bf77aa3b = (0, $3UXZ8.default)("span", {
    target: "ef1epbp0",
    label: "SearchHighlight"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N900), ")"), ";font-weight:700;", (props)=>props.overrideStyles && $2a0236b61eb86ec3$var$_objectSpread({}, props.overrideStyles), "");
const $2a0236b61eb86ec3$var$ALGOLIA_HIGHLIGHT_REGEX = /<algoliaHighlight>(.+?)<\/algoliaHighlight>/g;
const $2a0236b61eb86ec3$export$2f2d27674dcbd0cc = (_ref)=>{
    let { highlightedText: highlightedText, originalText: originalText, overrideStyles: overrideStyles } = _ref;
    const highlightMatches = ()=>{
        let matches;
        // Resolve all the unique highlights
        let highlights = (0, $g5DHJ.Set)();
        while((matches = $2a0236b61eb86ec3$var$ALGOLIA_HIGHLIGHT_REGEX.exec(highlightedText)) !== null)highlights = highlights.add(matches[1]);
        // For each of the unique highlights
        return highlights.reduce((acc, h)=>// For each of the already accumulated highlights and raw text
            acc.flatMap((a)=>// If the accumulated item is a string (i.e. non-highlighted)
                typeof a === 'string' ? // Create a list of this item split by the highlighted text
                (0, $g5DHJ.List)(a.split(h)).flatMap((s)=>// For each of the split parts of the item, if it is valued include it, otherwise don't
                    (s ? (0, $g5DHJ.List)([
                        s
                    ]) : (0, $g5DHJ.List)()).push(/*#__PURE__*/ (0, $lHkHI.jsx)($2a0236b61eb86ec3$export$73b5d8f6bf77aa3b, {
                        overrideStyles: overrideStyles,
                        children: h
                    })))// Remove the last one since it is not correct (we blindly append the highlight text to the end,
                // but actually only want it between split items
                .butLast() : // If it is not a string, this is already highlighted text and we don't need to do anything so
                // just return a list of the item (since we are flatMapping).
                (0, $g5DHJ.List)([
                    a
                ])), // Initial value of the accumulator is a list of the actual text of what we are highlighting
        (0, $g5DHJ.List)([
            originalText
        ]))// Once we have resolve all highlights and non-highlighted text, wrap in spans with a key (since we need keys)
        .map((s, i)=>/*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                children: s
            }, i));
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
        children: highlightMatches()
    });
};

});

parcelRegister("8sH3O", function(module, exports) {

$parcel$export(module.exports, "default", () => $6292572f3f362d16$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $ivTMz = parcelRequire("ivTMz");
var $62HOr = parcelRequire("62HOr");

var $ibjku = parcelRequire("ibjku");
parcelRequire("eUqFw");

var $1r1q4 = parcelRequire("1r1q4");

var $lHkHI = parcelRequire("lHkHI");
const $6292572f3f362d16$var$StyledClickableCard = /*#__PURE__*/ (0, $ibjku.css)("cursor:pointer;transition:box-shadow 0.1s;&:hover{", (0, $62HOr).e300(), "};label:StyledClickableCard;");
const $6292572f3f362d16$export$94fdbc1f5368d5e4 = (0, $3UXZ8.default)("div", {
    target: "e1i5f6pi0",
    label: "StyledCard"
})("padding:10px 15px;border-radius:", (0, $ivTMz.borderRadius)(), "px;color:inherit;position:relative;", (0, $62HOr).e100(), ";", (props)=>props.clickable ? $6292572f3f362d16$var$StyledClickableCard : '', ";");
function $6292572f3f362d16$export$2e2bcd8739ae039(_ref) {
    let { children: children, className: className, clickable: clickable = true, testId: testId, badgeVariant: badgeVariant } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($6292572f3f362d16$export$94fdbc1f5368d5e4, {
        className: className,
        clickable: clickable,
        "data-testid": testId,
        children: [
            badgeVariant && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1r1q4.default), {
                badgeVariant: badgeVariant
            }),
            children
        ]
    });
}

});
parcelRegister("62HOr", function(module, exports) {

$parcel$export(module.exports, "e100", () => $4664ea3c79447258$export$b390b459b8b8d8d0);
$parcel$export(module.exports, "e200", () => $4664ea3c79447258$export$3c35fb2adfe0992);
$parcel$export(module.exports, "e300", () => $4664ea3c79447258$export$f330dca4c33ed51f);
$parcel$export(module.exports, "e400", () => $4664ea3c79447258$export$3c7c047ca0ed675e);
$parcel$export(module.exports, "e500", () => $4664ea3c79447258$export$e6af781b0d301e56);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $j0gMm = parcelRequire("j0gMm");

var $kvIKC = parcelRequire("kvIKC");
const $4664ea3c79447258$export$b390b459b8b8d8d0 = (0, $kvIKC.default)({
    light: `box-shadow: ${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $j0gMm.N50A)}, 0 0 1px 1px ${(0, $j0gMm.N40A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-raised, ${`0 1px 1px ${(0, $j0gMm.DN50A)}, 0 0 1px 1px ${(0, $j0gMm.DN40A)}`})`};`
});
const $4664ea3c79447258$export$3c35fb2adfe0992 = (0, $kvIKC.default)({
    light: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $j0gMm.N50A)}, 0 0 1px ${(0, $j0gMm.N60A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $j0gMm.DN50A)}, 0 0 1px ${(0, $j0gMm.DN60A)}`})`};`
});
const $4664ea3c79447258$export$f330dca4c33ed51f = (0, $kvIKC.default)({
    light: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 8px 16px -4px ${(0, $j0gMm.N50A)}, 0 0 1px ${(0, $j0gMm.N60A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 8px 16px -4px ${(0, $j0gMm.DN50A)}, 0 0 1px ${(0, $j0gMm.DN60A)}`})`};`
});
const $4664ea3c79447258$export$3c7c047ca0ed675e = (0, $kvIKC.default)({
    light: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 12px 24px -6px ${(0, $j0gMm.N50A)}, 0 0 1px ${(0, $j0gMm.N60A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 12px 24px -6px ${(0, $j0gMm.DN50A)}, 0 0 1px ${(0, $j0gMm.DN60A)}`})`};`
});
const $4664ea3c79447258$export$e6af781b0d301e56 = (0, $kvIKC.default)({
    light: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 20px 32px -8px ${(0, $j0gMm.N50A)}, 0 0 1px ${(0, $j0gMm.N60A)}`})`};`,
    dark: `box-shadow: ${`var(--ds-shadow-overlay, ${`0 20px 32px -8px ${(0, $j0gMm.DN50A)}, 0 0 1px ${(0, $j0gMm.DN60A)}`})`};`
});

});

parcelRegister("1r1q4", function(module, exports) {

$parcel$export(module.exports, "default", () => $10b969ec6374db28$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $hvUUg = parcelRequire("hvUUg");

var $ibjku = parcelRequire("ibjku");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $10b969ec6374db28$export$37acb3580601e69a = /*#__PURE__*/ (0, $ibjku.css)((0, $hvUUg.CharlieFontFamily), ";box-sizing:border-box;position:absolute;right:0px;border-radius:0px 3px 0px 12px;padding:0px var(--ds-space-150, 12px) var(--ds-space-025, 2px) var(--ds-space-150, 12px);font-size:13px;word-spacing:1px;;label:Badge;");
const $10b969ec6374db28$export$78604ebaa20070be = (0, $3UXZ8.default)("div", {
    target: "eh3pdla0",
    label: "StaffPickBadge"
})($10b969ec6374db28$export$37acb3580601e69a, ";font-weight:400;background:", "var(--ds-background-accent-purple-bolder, ".concat((0, $j0gMm.P400), ")"), ";color:", "var(--ds-text-inverse, ".concat((0, $j0gMm.N0), ")"), ";");
const $10b969ec6374db28$export$43fbb77c138b6530 = (0, $3UXZ8.default)("div", {
    target: "eh3pdla1",
    label: "RisingStarBadge"
})($10b969ec6374db28$export$37acb3580601e69a, ";font-weight:400;background:", "var(--ds-background-accent-blue-bolder, ".concat((0, $j0gMm.B400), ")"), ";color:", "var(--ds-text-inverse, ".concat((0, $j0gMm.N0), ")"), ";");
const $10b969ec6374db28$export$da75d320d418532d = (0, $3UXZ8.default)("div", {
    target: "eh3pdla2",
    label: "BestSellerBadge"
})($10b969ec6374db28$export$37acb3580601e69a, ";font-weight:400;background:", "var(--ds-background-accent-green-bolder, ".concat((0, $j0gMm.G400), ")"), ";color:", "var(--ds-text-inverse, ".concat((0, $j0gMm.N0), ")"), ";");
const $10b969ec6374db28$export$34f0e43b54903c1a = (0, $3UXZ8.default)("div", {
    target: "eh3pdla3",
    label: "SpotlightBadge"
})($10b969ec6374db28$export$37acb3580601e69a, ";font-weight:400;background:", "var(--ds-background-accent-purple-bolder, ".concat((0, $j0gMm.P400), ")"), ";color:", "var(--ds-text-inverse, ".concat((0, $j0gMm.N0), ")"), ";");
const $10b969ec6374db28$export$46d88e67b10ab119 = (0, $3UXZ8.default)("div", {
    target: "eh3pdla4",
    label: "NewBadge"
})($10b969ec6374db28$export$37acb3580601e69a, ";background:", "var(--ds-background-accent-purple-subtlest, ".concat((0, $j0gMm.P50), ")"), ";font-weight:600;color:", "var(--ds-text-accent-purple, ".concat((0, $j0gMm.P400), ")"), ";");
function $10b969ec6374db28$export$2e2bcd8739ae039(_ref) {
    let { badgeVariant: badgeVariant } = _ref;
    switch(badgeVariant){
        case 'staffPick':
            return /*#__PURE__*/ (0, $lHkHI.jsx)($10b969ec6374db28$export$78604ebaa20070be, {
                children: "STAFF PICK"
            });
        case 'spotlight':
            return /*#__PURE__*/ (0, $lHkHI.jsx)($10b969ec6374db28$export$34f0e43b54903c1a, {
                children: "SPOTLIGHT"
            });
        case 'bestSeller':
            return /*#__PURE__*/ (0, $lHkHI.jsx)($10b969ec6374db28$export$da75d320d418532d, {
                children: "BESTSELLER"
            });
        case 'risingStar':
            return /*#__PURE__*/ (0, $lHkHI.jsx)($10b969ec6374db28$export$43fbb77c138b6530, {
                children: "RISING STAR"
            });
        default:
            return /*#__PURE__*/ (0, $lHkHI.jsx)($10b969ec6374db28$export$46d88e67b10ab119, {
                children: "NEW"
            });
    }
}

});


parcelRegister("5YcrV", function(module, exports) {

$parcel$export(module.exports, "CloudFortifiedAppBadgeSources", () => $458c36893034c4de$export$faf8b8eedbcaaaed);
$parcel$export(module.exports, "default", () => $458c36893034c4de$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $hvUUg = parcelRequire("hvUUg");
var $gykb8 = parcelRequire("gykb8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $259xn = parcelRequire("259xn");

var $kt9Cs = parcelRequire("kt9Cs");
parcelRequire("eUqFw");

var $4lmb9 = parcelRequire("4lmb9");

var $7BUhe = parcelRequire("7BUhe");

var $8PT8s = parcelRequire("8PT8s");

var $e8A8d = parcelRequire("e8A8d");

var $kNAhC = parcelRequire("kNAhC");

var $3ihpf = parcelRequire("3ihpf");

var $3ogmU = parcelRequire("3ogmU");

var $lHkHI = parcelRequire("lHkHI");
function $458c36893034c4de$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $458c36893034c4de$var$ANALYTICS_SUBJECT_ID_VIEW_MORE_LINK = 'viewMoreLink';
const $458c36893034c4de$var$ToolTipContainer = (0, $3UXZ8.default)("div", {
    target: "e4w3pke0",
    label: "ToolTipContainer"
})("line-height:1.5;margin-top:0;max-width:16.375rem;color:", "var(--ds-text, ".concat((0, $j0gMm).N600, ")"), ";");
const $458c36893034c4de$export$56c0d5a1e737357d = (0, $3UXZ8.default)("p", {
    target: "e4w3pke1",
    label: "P"
})({
    name: "gr2y0k",
    styles: "display:flex;align-items:center;margin:var(--ds-space-100, 8px) 0 0;"
});
const $458c36893034c4de$var$BadgeLabel = (0, $3UXZ8.default)("span", {
    target: "e4w3pke2",
    label: "BadgeLabel"
})("margin-left:var(--ds-space-050, 4px);", (0, $hvUUg.CharlieFontFamily), " color:", (_ref)=>{
    let { showAetherAppListingPage: showAetherAppListingPage } = _ref;
    return showAetherAppListingPage ? "var(--ds-text-subtle)" : "var(--ds-text)";
}, ";word-spacing:1px;font-weight:", (_ref2)=>{
    let { showAetherAppListingPage: showAetherAppListingPage } = _ref2;
    return showAetherAppListingPage ? '600' : '400';
}, ";font-size:", (_ref3)=>{
    let { showAetherAppListingPage: showAetherAppListingPage } = _ref3;
    return showAetherAppListingPage ? '1rem' : '0.875rem';
}, ";");
const $458c36893034c4de$var$BadgeContainer = (0, $3UXZ8.default)("button", {
    target: "e4w3pke3",
    label: "BadgeContainer"
})({
    name: "vk8q2x",
    styles: "all:unset;display:flex;align-items:center;width:100%;"
});
const $458c36893034c4de$var$StyledCloudSecurityParticipantBadgeContainer = (0, $3UXZ8.default)("span", {
    target: "e4w3pke4",
    label: "StyledCloudSecurityParticipantBadgeContainer"
})({
    name: "1ii4fqw",
    styles: "display:inline-block;line-height:1;margin-right:var(--ds-space-100, 8px);"
});
const $458c36893034c4de$export$faf8b8eedbcaaaed = Object.freeze({
    AppListing: 'app-listing-badge',
    AppTile: 'app-tile-badge'
});
const $458c36893034c4de$var$CloudFortifiedSupportIconContainer = (0, $3UXZ8.default)("span", {
    target: "e4w3pke5",
    label: "CloudFortifiedSupportIconContainer"
})({
    name: "1ww2aq1",
    styles: "margin-right:var(--ds-space-100, 8px);"
});
const $458c36893034c4de$var$CloudFortifiedReliabilityIconContainer = (0, $3UXZ8.default)("span", {
    target: "e4w3pke6",
    label: "CloudFortifiedReliabilityIconContainer"
})({
    name: "1ww2aq1",
    styles: "margin-right:var(--ds-space-100, 8px);"
});
function $458c36893034c4de$export$2e2bcd8739ae039(_ref4) {
    let { className: className, showLabel: showLabel, source: source, showAetherAppListingPage: showAetherAppListingPage } = _ref4;
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    if (!showLabel) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8PT8s.default), {
        className: className,
        label: "Cloud Fortified App badge"
    });
    const stopEventPropagation = (e)=>e.stopPropagation();
    const onViewDetailsClick = (e)=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.LinkClickedEvent),
            actionSubjectId: $458c36893034c4de$var$ANALYTICS_SUBJECT_ID_VIEW_MORE_LINK,
            attributes: {
                label: e.target.text,
                eventContainer: (0, $gaiog.EVENT_CONTAINER_CLOUD_FORTIFIED_TOOLTIP)
            }
        });
    };
    const faqPageLink = source ? (0, (/*@__PURE__*/$parcel$interopDefault($kt9Cs))).stringifyUrl({
        url: (0, $259xn.default).cloudFortified.faq,
        query: {
            source: source
        }
    }) : (0, $259xn.default).cloudFortified.faq;
    const tooltipContentV1 = /*#__PURE__*/ (0, $lHkHI.jsxs)($458c36893034c4de$var$ToolTipContainer, {
        "data-testid": (0, $7BUhe.TEST_IDS).CLOUD_FORTIFIED_TOOLTIP,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)("b", {
                children: "Cloud Fortified"
            }),
            " apps offer additional security, reliability and support through:",
            /*#__PURE__*/ (0, $lHkHI.jsxs)($458c36893034c4de$export$56c0d5a1e737357d, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($458c36893034c4de$var$StyledCloudSecurityParticipantBadgeContainer, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3ihpf.default), {
                            showLabel: false,
                            iconColor: (0, $3ihpf.CloudSecurityParticipantIconColor).secondary
                        })
                    }),
                    "Cloud security participation"
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)($458c36893034c4de$export$56c0d5a1e737357d, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($458c36893034c4de$var$CloudFortifiedReliabilityIconContainer, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $e8A8d.default), {
                            label: "Cloud Fortified Reliability badge"
                        })
                    }),
                    "Reliability checks"
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)($458c36893034c4de$export$56c0d5a1e737357d, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($458c36893034c4de$var$CloudFortifiedSupportIconContainer, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kNAhC.default), {
                            label: "Cloud Fortified Support badge"
                        })
                    }),
                    "24hr support response time"
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($458c36893034c4de$export$56c0d5a1e737357d, {
                children: "and more."
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($458c36893034c4de$export$56c0d5a1e737357d, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                    target: "_blank",
                    href: faqPageLink,
                    onClick: onViewDetailsClick,
                    children: "Learn about the Cloud Fortified apps program"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4lmb9.default), {
            content: showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3ogmU.default), {
                faqPageLink: faqPageLink,
                onViewDetailsClick: onViewDetailsClick
            }) : tooltipContentV1,
            children: /*#__PURE__*/ (0, $lHkHI.jsxs)($458c36893034c4de$var$BadgeContainer, {
                tabIndex: -1,
                className: className,
                onClick: stopEventPropagation,
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8PT8s.default), {
                        showAetherAppListingPage: showAetherAppListingPage,
                        label: "Cloud Fortified app badge"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($458c36893034c4de$var$BadgeLabel, {
                        showAetherAppListingPage: showAetherAppListingPage,
                        children: "CLOUD FORTIFIED"
                    })
                ]
            })
        })
    });
}

});
parcelRegister("259xn", function(module, exports) {

$parcel$export(module.exports, "default", () => $184372504a3f2102$export$2e2bcd8739ae039);
var $184372504a3f2102$export$2e2bcd8739ae039 = {
    cloudFortified: {
        faq: 'https://www.atlassian.com/trust/marketplace',
        supportRequirements: 'https://developer.atlassian.com/platform/marketplace/cloud-fortified-apps-program-support-requirements'
    },
    bugBountyProgramDetails: 'https://www.atlassian.com/licensing/marketplace#what-is-the-marketplace-bug-bounty-program'
};

});

parcelRegister("7BUhe", function(module, exports) {

$parcel$export(module.exports, "TEST_IDS", () => $58a7a48ce1c17f4e$export$a2b4f255152a6585);
const $58a7a48ce1c17f4e$export$a2b4f255152a6585 = {
    PARTNER_DETAILS: 'partner-details',
    CLOUD_SECURITY_PARTICIPANT_TOOLTIP: 'cloud-security-participant__tooltip',
    CLOUD_SECURITY_PARTICIPANT_TOOLTIP_V2: 'cloud-security-participant__tooltip_v2',
    CLOUD_FORTIFIED_TOOLTIP: 'cloud-fortified__tooltip',
    CLOUD_FORTIFIED_TOOLTIP_V2: 'cloud-fortified__tooltip_v2',
    CLOUD_FORTIFIED_INFO_MODAL: 'cloudfortified-info-modal',
    CERTIFICATION_SECTION: 'certification-section',
    APP_HEADER_LOZENGES: 'app-header__lozenges',
    APP_HEADER: 'app-header',
    APP_HEADER_ICON: 'app-header__icon',
    APP_HEADER_APP_NAME: 'app-header__app-name',
    APP_HEADER_COMPATIBILITIES: 'app-header__compatibilities',
    APP_HEADER_RATINGS: 'app-header__ratings',
    APP_HEADER_INSTALL_COUNT: 'app-header__install-count',
    APP_HEADER_CERTIFICATION: 'app-header__certification',
    APP_HEADER_STAFF_PICK: 'app-header__staff-pick',
    APP_HEADER_INJECTION: 'app-header__injection'
};

});

parcelRegister("8PT8s", function(module, exports) {

$parcel$export(module.exports, "default", () => $66eddaea9416f040$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $ilkNu = parcelRequire("ilkNu");

var $j0gMm = parcelRequire("j0gMm");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $66eddaea9416f040$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $66eddaea9416f040$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $66eddaea9416f040$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $66eddaea9416f040$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $66eddaea9416f040$var$CloudFortifiedAppIcon = (props)=>{
    const CloudFortifiedGlyph = ()=>/*#__PURE__*/ (0, $lHkHI.jsx)("svg", {
            className: props.className,
            width: props.showAetherAppListingPage ? '20' : '24',
            height: props.showAetherAppListingPage ? '20' : '24',
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M4.33103 2H7.64138C7.8242 2 7.97241 2.14289 7.97241 2.31915V4.44681H9.95862V2.31915C9.95862 2.14289 10.1068 2 10.2897 2H13.6C13.7828 2 13.931 2.14289 13.931 2.31915V4.44681H15.9172V2.31915C15.9172 2.14289 16.0655 2 16.2483 2H19.669C19.8518 2 20 2.14289 20 2.31915V9.65168C20 9.73992 19.9621 9.82421 19.8953 9.88455L18.0081 11.5897C17.9413 11.65 17.9034 11.7343 17.9034 11.8226V17.3672L18.4618 21.2746C18.5167 21.6581 18.2076 22 17.806 22H6.08368C5.68211 22 5.373 21.6581 5.42781 21.2746L5.98621 17.3672V11.8175C5.98621 11.7322 5.95084 11.6505 5.88798 11.5906L4.19645 9.97734C4.07074 9.85745 4 9.69405 4 9.52356V2.31915C4 2.14289 4.14821 2 4.33103 2ZM10.3584 16.6809H13.5313C13.7521 16.6809 13.931 16.5083 13.931 16.2955V13.7447C13.931 13.0375 13.5267 12.3879 12.8795 12.0551C12.2953 11.7547 11.5943 11.7547 11.0101 12.0551C10.3629 12.3879 9.95862 13.0375 9.95862 13.7447V16.2955C9.95862 16.5083 10.1376 16.6809 10.3584 16.6809Z",
                fill: "currentColor"
            })
        });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ilkNu.Icon), $66eddaea9416f040$var$_objectSpread({
        glyph: CloudFortifiedGlyph,
        primaryColor: "var(--ds-icon-brand, ".concat((0, $j0gMm.B400), ")")
    }, props));
};
var $66eddaea9416f040$export$2e2bcd8739ae039 = $66eddaea9416f040$var$CloudFortifiedAppIcon;

});

parcelRegister("e8A8d", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4add704019c82c4$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $ilkNu = parcelRequire("ilkNu");

var $j0gMm = parcelRequire("j0gMm");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $a4add704019c82c4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a4add704019c82c4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a4add704019c82c4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a4add704019c82c4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a4add704019c82c4$var$CloudFortifiedReliabilityIcon = (props)=>{
    const CloudFortifiedReliabilityGlyph = ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)("svg", {
            className: props.className,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
                    d: "M21.9226 13.25H17.625C17.349 13.25 17.1057 13.069 17.0264 12.8046L15.823 8.79346L13.8584 17.1432C13.7938 17.4178 13.5531 17.6151 13.2711 17.6246C12.989 17.6342 12.7356 17.4535 12.6526 17.1838L10.6114 10.5498L9.43402 12.9045C9.33715 13.0983 9.14686 13.228 8.93113 13.2475C8.71539 13.2669 8.50497 13.1733 8.375 13L7 11.1667L5.625 13C5.50697 13.1574 5.32172 13.25 5.125 13.25H2.07737C2.69249 18.1829 6.90048 22 12 22C17.0995 22 21.3075 18.1829 21.9226 13.25Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
                    d: "M22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12H4.8125L6.5 9.75C6.61803 9.59262 6.80328 9.5 7 9.5C7.19672 9.5 7.38197 9.59262 7.5 9.75L8.76824 11.441L10.191 8.59549C10.3052 8.36702 10.547 8.23106 10.8015 8.25213C11.0561 8.2732 11.2722 8.44706 11.3474 8.6912L13.1695 14.6132L15.1416 6.23185C15.2064 5.95637 15.4483 5.75883 15.7311 5.75028C16.014 5.74174 16.2673 5.92434 16.3486 6.19541L18.09 12H22Z",
                    fill: "currentColor"
                })
            ]
        });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ilkNu.Icon), $a4add704019c82c4$var$_objectSpread({
        glyph: CloudFortifiedReliabilityGlyph,
        primaryColor: "var(--ds-icon, ".concat((0, $j0gMm.N500), ")")
    }, props));
};
var $a4add704019c82c4$export$2e2bcd8739ae039 = $a4add704019c82c4$var$CloudFortifiedReliabilityIcon;

});

parcelRegister("kNAhC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f24487531c098250$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $ilkNu = parcelRequire("ilkNu");

var $j0gMm = parcelRequire("j0gMm");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $f24487531c098250$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f24487531c098250$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f24487531c098250$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f24487531c098250$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f24487531c098250$var$CloudFortifiedSupportIcon = (props)=>{
    const CloudFortifiedSupportGlyph = ()=>/*#__PURE__*/ (0, $lHkHI.jsx)("svg", {
            className: props.className,
            width: "24",
            height: "24",
            viewBox: "0 0 24 24",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22ZM5.33333 12C5.33333 8.324 8.324 5.33333 12 5.33333C15.676 5.33333 18.6667 8.324 18.6667 12V14.762C18.6667 15.4447 18.0687 16 17.3333 16C17.3333 17.4707 16.1373 18.6667 14.6667 18.6667H11.6667C11.1144 18.6667 10.6667 18.219 10.6667 17.6667C10.6667 17.1144 11.1144 16.6667 11.6667 16.6667H13.3333V17.3333H14.6667C15.402 17.3333 16 16.7353 16 16V11.9047C16 11.7279 16.0702 11.5583 16.1953 11.4333C16.3203 11.3082 16.4899 11.238 16.6667 11.238H17.272C16.9013 8.658 14.6813 6.66667 12 6.66667C9.31867 6.66667 7.09867 8.658 6.728 11.238H7.33333C7.51015 11.238 7.67971 11.3082 7.80474 11.4333C7.92976 11.5583 8 11.7279 8 11.9047V15.3333C8 15.5101 7.92976 15.6797 7.80474 15.8047C7.67971 15.9298 7.51015 16 7.33333 16H6.66667C5.93133 16 5.33333 15.4447 5.33333 14.762V12Z",
                fill: "currentColor"
            })
        });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ilkNu.Icon), $f24487531c098250$var$_objectSpread({
        glyph: CloudFortifiedSupportGlyph,
        primaryColor: "var(--ds-icon, ".concat((0, $j0gMm.N500), ")")
    }, props));
};
var $f24487531c098250$export$2e2bcd8739ae039 = $f24487531c098250$var$CloudFortifiedSupportIcon;

});

parcelRegister("3ihpf", function(module, exports) {

$parcel$export(module.exports, "CloudSecurityParticipantIconColor", () => $26608e112b48d193$export$31cb4060a77ad5a0);
$parcel$export(module.exports, "CLOUD_SECURITY_BADGE_LABEL", () => $26608e112b48d193$export$bcd38832e93f158e);
$parcel$export(module.exports, "default", () => $26608e112b48d193$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $j0gMm = parcelRequire("j0gMm");

var $hvUUg = parcelRequire("hvUUg");
var $gykb8 = parcelRequire("gykb8");
parcelRequire("eUqFw");

var $4lmb9 = parcelRequire("4lmb9");

var $7BUhe = parcelRequire("7BUhe");

var $g1o8Q = parcelRequire("g1o8Q");

var $f9qVk = parcelRequire("f9qVk");

var $2C2Cj = parcelRequire("2C2Cj");

var $lHkHI = parcelRequire("lHkHI");
function $26608e112b48d193$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $26608e112b48d193$var$StyledParagraph = (0, $3UXZ8.default)("p", {
    target: "e1g39hrb0",
    label: "StyledParagraph"
})({
    name: "i38rxf",
    styles: "margin-top:0;margin-bottom:var(--ds-space-100, 8px);"
});
const $26608e112b48d193$var$BadgeText = (0, $3UXZ8.default)("span", {
    target: "e1g39hrb1",
    label: "BadgeText"
})((0, $hvUUg.CharlieFontFamily), " text-transform:uppercase;margin-left:var(--ds-space-050, 4px);color:", (_ref)=>{
    let { showAetherAppListingPage: showAetherAppListingPage } = _ref;
    return showAetherAppListingPage ? "var(--ds-text-subtle)" : "var(--ds-text)";
}, ";word-spacing:1px;white-space:nowrap;font-weight:", (_ref2)=>{
    let { showAetherAppListingPage: showAetherAppListingPage } = _ref2;
    return showAetherAppListingPage ? '600' : '400';
}, ";font-size:", (_ref3)=>{
    let { showAetherAppListingPage: showAetherAppListingPage } = _ref3;
    return showAetherAppListingPage ? '1rem' : '14px';
}, ";");
const $26608e112b48d193$var$BadgeContainer = (0, $3UXZ8.default)("button", {
    target: "e1g39hrb2",
    label: "BadgeContainer"
})({
    name: "18gbust",
    styles: "all:unset;width:100%;display:flex;align-items:center;"
});
const $26608e112b48d193$var$P = (0, $3UXZ8.default)("p", {
    target: "e1g39hrb3",
    label: "P"
})({
    name: "bjwoin",
    styles: "display:flex;align-items:inherit;margin:0 0 var(--ds-space-150, 12px);"
});
const $26608e112b48d193$var$TooltipContainer = (0, $3UXZ8.default)("div", {
    target: "e1g39hrb4",
    label: "TooltipContainer"
})("max-width:16rem;color:", "var(--ds-text, ".concat((0, $j0gMm).N600, ")"), ";");
const $26608e112b48d193$var$Span = (0, $3UXZ8.default)("span", {
    target: "e1g39hrb5",
    label: "Span"
})({
    name: "ob0vux",
    styles: "margin-left:var(--ds-space-100, 8px);max-width:11rem;"
});
const $26608e112b48d193$export$31cb4060a77ad5a0 = {
    primary: "var(--ds-icon-brand, ".concat((0, $j0gMm.B400), ")"),
    secondary: "var(--ds-icon, ".concat((0, $j0gMm.N500), ")")
};
const $26608e112b48d193$export$bcd38832e93f158e = 'Cloud Security Participant';
function $26608e112b48d193$export$2e2bcd8739ae039(_ref4) {
    let { className: className, showLabel: showLabel, iconSize: iconSize, iconColor: iconColor, showAetherAppListingPage: showAetherAppListingPage } = _ref4;
    const badgeIconColor = iconColor ? iconColor : $26608e112b48d193$export$31cb4060a77ad5a0.primary;
    if (!showLabel) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $f9qVk.default), {
        label: "".concat($26608e112b48d193$export$bcd38832e93f158e, " badge"),
        size: iconSize,
        primaryColor: badgeIconColor
    });
    const stopEventPropagation = (e)=>e.stopPropagation();
    const link = 'https://www.atlassian.com/licensing/marketplace#what-is-the-marketplace-bug-bounty-program';
    const tooltipContent = /*#__PURE__*/ (0, $lHkHI.jsxs)($26608e112b48d193$var$TooltipContainer, {
        "data-testid": (0, $7BUhe.TEST_IDS).CLOUD_SECURITY_PARTICIPANT_TOOLTIP,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)($26608e112b48d193$var$StyledParagraph, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)("b", {
                        children: "Cloud Security participant"
                    }),
                    " apps offer verified security through:"
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)($26608e112b48d193$var$P, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $g1o8Q.default), {}),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($26608e112b48d193$var$Span, {
                        children: "Participation in the Marketplace Bug Bounty program"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                target: "_blank",
                href: link,
                onClick: stopEventPropagation,
                children: "Learn about the Marketplace Bug Bounty program"
            })
        ]
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4lmb9.default), {
            content: showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2C2Cj.default), {
                learnMoreLink: link
            }) : tooltipContent,
            children: /*#__PURE__*/ (0, $lHkHI.jsxs)($26608e112b48d193$var$BadgeContainer, {
                tabIndex: -1,
                className: className,
                onClick: stopEventPropagation,
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $f9qVk.default), {
                        label: "".concat($26608e112b48d193$export$bcd38832e93f158e, " badge"),
                        size: iconSize,
                        primaryColor: badgeIconColor,
                        showAetherAppListingPage: showAetherAppListingPage
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($26608e112b48d193$var$BadgeText, {
                        showAetherAppListingPage: showAetherAppListingPage,
                        children: $26608e112b48d193$export$bcd38832e93f158e
                    })
                ]
            })
        })
    });
}

});
parcelRegister("g1o8Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba9f775c19c361c0$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $3XolV = parcelRequire("3XolV");

var $j0gMm = parcelRequire("j0gMm");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $ba9f775c19c361c0$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ba9f775c19c361c0$var$CheckCircleIconContainer = (0, $3UXZ8.default)("div", {
    target: "e1d73sv30",
    label: "CheckCircleIconContainer"
})({
    name: "1mzw1zc",
    styles: "display:flex;height:20px;"
});
function $ba9f775c19c361c0$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $lHkHI.jsx)($ba9f775c19c361c0$var$CheckCircleIconContainer, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3XolV))), {
            primaryColor: (0, $j0gMm.G400),
            label: "Check Circle"
        })
    });
}

});

parcelRegister("f9qVk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b07c94bb50af0f90$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $ilkNu = parcelRequire("ilkNu");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $b07c94bb50af0f90$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b07c94bb50af0f90$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b07c94bb50af0f90$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b07c94bb50af0f90$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $b07c94bb50af0f90$var$CloudSecurityParticipantIcon = (props)=>{
    const CloudSecurityParticipantGlyph = (customGlyphProps)=>/*#__PURE__*/ (0, $lHkHI.jsx)("svg", $b07c94bb50af0f90$var$_objectSpread($b07c94bb50af0f90$var$_objectSpread({
            width: props.showAetherAppListingPage ? '20' : '24',
            height: props.showAetherAppListingPage ? '20' : '24',
            viewBox: "0 0 24 24"
        }, customGlyphProps), {}, {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
                fill: "currentColor",
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M11.6051 2.11511C11.8188 1.94054 12.1318 1.94075 12.3453 2.11552C14.2453 3.67094 18.1926 4.96529 19.8264 5.45653C20.2591 5.58663 20.5595 5.98264 20.5567 6.43444C20.5165 12.8551 19.8453 18.4583 12.3203 21.4067C12.0977 21.4939 11.8421 21.4939 11.6195 21.4067C4.09451 18.4584 3.42328 12.8552 3.38308 6.43461C3.38025 5.98273 3.68081 5.58667 4.1136 5.45667C5.74876 4.96549 9.7011 3.67085 11.6051 2.11511ZM8.42778 10.7852C8.61008 10.7917 8.78245 10.8699 8.9074 11.0027L11.0515 13.3303C11.9236 12.4727 12.7945 11.6141 13.6642 10.7543L13.6919 10.7266C14.5358 9.89447 15.3756 9.05817 16.2112 8.21772C16.3408 8.0904 16.5152 8.01914 16.6968 8.0193C16.8785 8.01945 17.0528 8.09102 17.1822 8.21856C17.3115 8.3461 17.3856 8.51938 17.3883 8.70101C17.391 8.88265 17.3222 9.05807 17.1967 9.18943C16.3572 10.0343 15.5133 10.8748 14.665 11.7108L14.6373 11.7385C13.7297 12.6353 12.8209 13.5312 11.9111 14.4259L11.6592 14.6744C11.3152 15.0176 10.7616 15.0176 10.3899 14.6536L7.89001 11.9412C7.76761 11.806 7.70356 11.6279 7.71178 11.4457C7.72001 11.2634 7.79984 11.0918 7.93392 10.9681C8.068 10.8444 8.24548 10.7787 8.42778 10.7852Z"
            })
        }));
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ilkNu.Icon), $b07c94bb50af0f90$var$_objectSpread({
        glyph: CloudSecurityParticipantGlyph
    }, props));
};
var $b07c94bb50af0f90$export$2e2bcd8739ae039 = $b07c94bb50af0f90$var$CloudSecurityParticipantIcon;

});

parcelRegister("2C2Cj", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e7129118bafaf97$export$2e2bcd8739ae039);
/* CloudSecurityParticipantTooltipV2.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cCrLo = parcelRequire("cCrLo");
var $ixQHh = parcelRequire("ixQHh");

var $7BUhe = parcelRequire("7BUhe");

var $f9qVk = parcelRequire("f9qVk");

var $lHkHI = parcelRequire("lHkHI");
const $1e7129118bafaf97$var$_excluded = [
    "as",
    "style"
], $1e7129118bafaf97$var$_excluded2 = [
    "as",
    "style"
], $1e7129118bafaf97$var$_excluded3 = [
    "as",
    "style"
], $1e7129118bafaf97$var$_excluded4 = [
    "as",
    "style"
];
function $1e7129118bafaf97$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1e7129118bafaf97$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1e7129118bafaf97$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1e7129118bafaf97$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $1e7129118bafaf97$var$Container = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $1e7129118bafaf97$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $1e7129118bafaf97$var$_objectSpread($1e7129118bafaf97$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1tad",
            __cmplp.className
        ])
    }));
});
const $1e7129118bafaf97$var$BoldText = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $1e7129118bafaf97$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $1e7129118bafaf97$var$_objectSpread($1e7129118bafaf97$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1nu9 _k48pni7l",
            __cmplp.className
        ])
    }));
});
const $1e7129118bafaf97$var$DetailsContainer = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $1e7129118bafaf97$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $1e7129118bafaf97$var$_objectSpread($1e7129118bafaf97$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkxjmg _otyrxjmg _1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    }));
});
const $1e7129118bafaf97$var$DetailsText = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $1e7129118bafaf97$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $1e7129118bafaf97$var$_objectSpread($1e7129118bafaf97$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _18u01eps",
            __cmplp.className
        ])
    }));
});
const $1e7129118bafaf97$var$CloudSecurityParticipantTooltipV2 = (_ref5)=>{
    let { learnMoreLink: learnMoreLink } = _ref5;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($1e7129118bafaf97$var$Container, {
        "data-testid": (0, $7BUhe.TEST_IDS).CLOUD_SECURITY_PARTICIPANT_TOOLTIP_V2,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $cCrLo.BodySmall), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($1e7129118bafaf97$var$BoldText, {
                        children: "Cloud Security Participant"
                    }),
                    " apps offer verified security through:"
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)($1e7129118bafaf97$var$DetailsContainer, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $f9qVk.default), {
                        label: "Cloud Security Participant Badge",
                        size: "medium",
                        primaryColor: "var(--ds-icon)"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($1e7129118bafaf97$var$DetailsText, {
                        children: "Participation in the Marketplace Bug Bounty program"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ixQHh.LinkWithIcon), {
                href: learnMoreLink,
                type: "external",
                size: "small",
                children: "Know more about the Bug bounty program"
            })
        ]
    });
};
var $1e7129118bafaf97$export$2e2bcd8739ae039 = $1e7129118bafaf97$var$CloudSecurityParticipantTooltipV2;

});
parcelRegister("ixQHh", function(module, exports) {

$parcel$export(module.exports, "SubtleLink", () => $d8042f95a3a0adea$export$902dde2c01bb0707);
$parcel$export(module.exports, "Link", () => $d8042f95a3a0adea$export$a6c7ac8248d6e38a);
$parcel$export(module.exports, "ExternalLink", () => $d8042f95a3a0adea$export$b2bf131c9f9cce5d);
$parcel$export(module.exports, "LinkWithIcon", () => $d8042f95a3a0adea$export$e67e718b4b9e91b1);
/* Links.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $h5JnE = parcelRequire("h5JnE");

var $bBqrH = parcelRequire("bBqrH");

var $lMIGT = parcelRequire("lMIGT");

var $lHkHI = parcelRequire("lHkHI");
const $d8042f95a3a0adea$var$_excluded = [
    "as",
    "style"
], $d8042f95a3a0adea$var$_excluded2 = [
    "as",
    "style"
], $d8042f95a3a0adea$var$_excluded3 = [
    "as",
    "style"
], $d8042f95a3a0adea$var$_excluded4 = [
    "as",
    "style"
], $d8042f95a3a0adea$var$_excluded5 = [
    "as",
    "style"
], $d8042f95a3a0adea$var$_excluded6 = [
    "size",
    "type",
    "children",
    "href",
    "onClick",
    "dataTestId"
];
function $d8042f95a3a0adea$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d8042f95a3a0adea$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d8042f95a3a0adea$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d8042f95a3a0adea$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $d8042f95a3a0adea$var$getExternalLinkAttributes = (text)=>{
    const linkText = typeof text === 'string' ? "".concat(text, " ") : '';
    return {
        target: '_blank',
        rel: 'external noopener noreferrer',
        'aria-label': "".concat(linkText, "open in new window")
    };
};
const $d8042f95a3a0adea$export$902dde2c01bb0707 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "a", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $d8042f95a3a0adea$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect41sdi _syaz1blv _vwz4gktf _4bfu18uv _1hmsglyw _ajmmnqa1 _1bas14y2 _1ygb4suz _30l31qtk _9oik18uv _1bnxglyw _jf4cnqa1 _9h8h1vef _1nrm18uv _c2waglyw _1iohnqa1",
            __cmplp.size === 'small' ? "_1wyboxwj" : "_1wyb1j6v",
            __cmplp.size === 'small' ? "_k48p1nn1" : "_k48pni7l",
            __cmplp.className
        ])
    }));
});
const $d8042f95a3a0adea$export$a6c7ac8248d6e38a = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "a", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $d8042f95a3a0adea$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect41sdi _syaz1qtk _vwz4gktf _1bas14y2 _1ygb4suz _9h8h1vef",
            __cmplp.size === 'small' ? "_1wyboxwj" : "_1wyb1j6v",
            __cmplp.size === 'small' ? "_k48p1nn1" : "_k48pni7l",
            __cmplp.className
        ])
    }));
});
const $d8042f95a3a0adea$var$LinkWithIconStyles = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = $d8042f95a3a0adea$export$a6c7ac8248d6e38a, style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $d8042f95a3a0adea$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1jmq18uv _apju8stv _ku3unqa1 _9oik18uv _1bnxglyw _jf4cnqa1",
            __cmplp.className
        ])
    }));
});
const $d8042f95a3a0adea$export$b2bf131c9f9cce5d = (props)=>{
    const externalAttributes = $d8042f95a3a0adea$var$getExternalLinkAttributes(props['aria-label'] || props.children);
    const linkProps = $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({}, props), externalAttributes), {}, {
        size: props.size || 'medium'
    });
    return linkProps.type === 'subtle' ? /*#__PURE__*/ (0, $lHkHI.jsx)($d8042f95a3a0adea$export$902dde2c01bb0707, $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({}, linkProps), {}, {
        children: props.children
    })) : /*#__PURE__*/ (0, $lHkHI.jsx)($d8042f95a3a0adea$export$a6c7ac8248d6e38a, $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({}, linkProps), {}, {
        children: props.children
    }));
};
const $d8042f95a3a0adea$var$LinkWithIconWrapper = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $d8042f95a3a0adea$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1o8l _y3gn1e5h _t4pt1hna",
            __cmplp.className
        ])
    }));
});
const $d8042f95a3a0adea$var$LastWordWithIcon = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $d8042f95a3a0adea$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_o5721q9c _1e0c116y _4cvr1h6o",
            __cmplp.className
        ])
    }));
});
const $d8042f95a3a0adea$export$dbeaa712979697c5 = (props)=>{
    const externalAttributes = $d8042f95a3a0adea$var$getExternalLinkAttributes(props['aria-label'] || props.children);
    const linkProps = $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({}, props), externalAttributes);
    return /*#__PURE__*/ (0, $lHkHI.jsx)($d8042f95a3a0adea$export$902dde2c01bb0707, $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({}, linkProps), {}, {
        children: props.children
    }));
};
const $d8042f95a3a0adea$export$e67e718b4b9e91b1 = (_ref6)=>{
    let { size: size, type: type = 'internal', children: children, href: href, onClick: onClick, dataTestId: dataTestId } = _ref6, props = (0, $bwPfh.default)(_ref6, $d8042f95a3a0adea$var$_excluded6);
    let linkProps = $d8042f95a3a0adea$var$_objectSpread({
        href: href,
        onClick: onClick
    }, props);
    let icon;
    if (type === 'external') {
        icon = /*#__PURE__*/ (0, $lHkHI.jsx)((0, $h5JnE.DiagonalUpwardArrowIcon), {});
        const externalAttributes = $d8042f95a3a0adea$var$getExternalLinkAttributes(children);
        linkProps = $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({}, externalAttributes), linkProps);
    } else if (type === 'internal') icon = /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bBqrH.RightArrowIcon), {});
    if (typeof children === 'string') {
        const words = children.split(' ');
        const lastWord = words.pop();
        return /*#__PURE__*/ (0, $lHkHI.jsx)($d8042f95a3a0adea$var$LinkWithIconStyles, $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({
            size: size
        }, linkProps), {}, {
            "data-testid": dataTestId || (0, $lMIGT.TEST_IDS).APP_LINK_WITH_ICON,
            children: /*#__PURE__*/ (0, $lHkHI.jsxs)($d8042f95a3a0adea$var$LinkWithIconWrapper, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                        className: "linkText",
                        children: words.join(' ')
                    }),
                    ' ',
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($d8042f95a3a0adea$var$LastWordWithIcon, {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                                className: "linkText",
                                children: lastWord
                            }),
                            icon
                        ]
                    })
                ]
            })
        }));
    }
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($d8042f95a3a0adea$var$LinkWithIconStyles, $d8042f95a3a0adea$var$_objectSpread($d8042f95a3a0adea$var$_objectSpread({
        size: size
    }, linkProps), {}, {
        "data-testid": (0, $lMIGT.TEST_IDS).APP_LINK_WITH_ICON,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                className: "linkText",
                children: children
            }),
            icon
        ]
    }));
};

});
parcelRegister("h5JnE", function(module, exports) {

$parcel$export(module.exports, "DiagonalUpwardArrowIcon", () => $c7161aef6d89c8e1$export$de97d9835adee853);
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $c7161aef6d89c8e1$export$de97d9835adee853 = ()=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M9.51111 6V8.55066H13.6467L6.37368 15.8217C5.87544 16.32 5.87544 17.1277 6.37368 17.6259C6.62366 17.8742 6.94845 18 7.27665 18C7.60315 18 7.92794 17.8742 8.17791 17.6259L15.4493 10.3548V14.4886H18V6H9.51111Z",
            fill: "currentColor"
        })
    });
};

});

parcelRegister("bBqrH", function(module, exports) {

$parcel$export(module.exports, "RightArrowIcon", () => $8727a9ffd5a6c357$export$fec93b5f1e2bccb4);
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $8727a9ffd5a6c357$export$fec93b5f1e2bccb4 = ()=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        children: /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.6018 6L13.1295 7.80314L15.5162 10.7245H5.5407C4.96623 10.7245 4.5 11.2956 4.5 11.9992C4.5 12.7027 4.96623 13.2738 5.5407 13.2738H15.5162L13.1295 16.1969L14.6018 18L19.5 11.9992L14.6018 6Z",
            fill: "currentColor"
        })
    });
};

});

parcelRegister("lMIGT", function(module, exports) {

$parcel$export(module.exports, "TEST_IDS", () => $fdc0bf52b05494d5$export$a2b4f255152a6585);
const $fdc0bf52b05494d5$export$a2b4f255152a6585 = {
    APP_GO_BACK_LINK: 'app-go-back-link',
    APP_SUPPORT_LINK: 'app-support-link',
    APP_STATUS_LINK: 'app-status-link',
    APP_LINK_WITH_ICON: 'app-link-with-icon',
    FACET_DROPDOWN_TRIGGERS: 'facet-dropdown--trigger'
};

});




parcelRegister("3ogmU", function(module, exports) {

$parcel$export(module.exports, "default", () => $27804f69534737fb$export$2e2bcd8739ae039);
/* CloudFortifiedAppTooltipV2.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cCrLo = parcelRequire("cCrLo");
var $ixQHh = parcelRequire("ixQHh");

var $7BUhe = parcelRequire("7BUhe");

var $e8A8d = parcelRequire("e8A8d");

var $kNAhC = parcelRequire("kNAhC");

var $f9qVk = parcelRequire("f9qVk");

var $lHkHI = parcelRequire("lHkHI");
const $27804f69534737fb$var$_excluded = [
    "as",
    "style"
], $27804f69534737fb$var$_excluded2 = [
    "as",
    "style"
], $27804f69534737fb$var$_excluded3 = [
    "as",
    "style"
], $27804f69534737fb$var$_excluded4 = [
    "as",
    "style"
], $27804f69534737fb$var$_excluded5 = [
    "as",
    "style"
];
function $27804f69534737fb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $27804f69534737fb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $27804f69534737fb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $27804f69534737fb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $27804f69534737fb$var$Container = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $27804f69534737fb$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $27804f69534737fb$var$_objectSpread($27804f69534737fb$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1tad",
            __cmplp.className
        ])
    }));
});
const $27804f69534737fb$var$BoldText = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $27804f69534737fb$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $27804f69534737fb$var$_objectSpread($27804f69534737fb$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1nu9 _k48pni7l",
            __cmplp.className
        ])
    }));
});
const $27804f69534737fb$var$DetailsContainer = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $27804f69534737fb$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $27804f69534737fb$var$_objectSpread($27804f69534737fb$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkxjmg _otyrxjmg _1e0c1txw _2lx21bp4 _1p571eps",
            __cmplp.className
        ])
    }));
});
const $27804f69534737fb$var$DetailsRow = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $27804f69534737fb$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $27804f69534737fb$var$_objectSpread($27804f69534737fb$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    }));
});
const $27804f69534737fb$var$DetailsText = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $27804f69534737fb$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $27804f69534737fb$var$_objectSpread($27804f69534737fb$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _18u01eps",
            __cmplp.className
        ])
    }));
});
const $27804f69534737fb$var$CloudFortifiedAppTooltipV2 = (_ref6)=>{
    let { onViewDetailsClick: onViewDetailsClick, faqPageLink: faqPageLink } = _ref6;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($27804f69534737fb$var$Container, {
        "data-testid": (0, $7BUhe.TEST_IDS).CLOUD_FORTIFIED_TOOLTIP_V2,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $cCrLo.BodySmall), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($27804f69534737fb$var$BoldText, {
                        children: "Cloud Fortified"
                    }),
                    " apps offer additional security, reliability, and support through:"
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)($27804f69534737fb$var$DetailsContainer, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($27804f69534737fb$var$DetailsRow, {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $f9qVk.default), {
                                label: "Cloud Security Participant Badge",
                                size: "medium",
                                primaryColor: "var(--ds-icon)"
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)($27804f69534737fb$var$DetailsText, {
                                children: "Cloud security participation"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($27804f69534737fb$var$DetailsRow, {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $e8A8d.default), {
                                label: "Cloud Fortified Reliability badge"
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)($27804f69534737fb$var$DetailsText, {
                                children: "Timely reliability checks"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($27804f69534737fb$var$DetailsRow, {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kNAhC.default), {
                                label: "Cloud Fortified Support badge"
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)($27804f69534737fb$var$DetailsText, {
                                children: "24hr support response time and more"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ixQHh.LinkWithIcon), {
                type: "external",
                size: "small",
                href: faqPageLink,
                onClick: onViewDetailsClick,
                children: "More details"
            })
        ]
    });
};
var $27804f69534737fb$export$2e2bcd8739ae039 = $27804f69534737fb$var$CloudFortifiedAppTooltipV2;

});


parcelRegister("8xfj9", function(module, exports) {

$parcel$export(module.exports, "resolvePartnerTier", () => $636d47a2eec1a784$export$5a849d5aaf447b77);
$parcel$export(module.exports, "default", () => $636d47a2eec1a784$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $9l6Pq = parcelRequire("9l6Pq");

var $ammkg = parcelRequire("ammkg");
parcelRequire("eUqFw");

var $cmZSX = parcelRequire("cmZSX");

var $4lmb9 = parcelRequire("4lmb9");

var $l501X = parcelRequire("l501X");

var $7BUhe = parcelRequire("7BUhe");

var $jdjb1 = parcelRequire("jdjb1");

var $fI3dH = parcelRequire("fI3dH");

var $aqC9O = parcelRequire("aqC9O");

var $4Ekia = parcelRequire("4Ekia");

var $lHkHI = parcelRequire("lHkHI");
function $636d47a2eec1a784$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $636d47a2eec1a784$export$a33d9f95d57cad28 = 'partnerName';
const $636d47a2eec1a784$export$bbc7eef4cce3da2c = 'https://developer.atlassian.com/platform/marketplace/marketplace-partner-program/';
const $636d47a2eec1a784$export$878bbd785b35ed1e = 'https://developer.atlassian.com/platform/marketplace/marketplace-security-bug-bounty-program/';
const $636d47a2eec1a784$export$32d72254fe4d6919 = (0, $3UXZ8.default)("div", {
    target: "emh330k0",
    label: "PartnerDetailsContainer"
})((props)=>({
        color: props.showAetherAppListingPage ? "var(--ds-text-subtle)" : "var(--ds-text, ".concat((0, $j0gMm.N300), ")"),
        display: 'flex',
        lineHeight: '1.5rem'
    }), "");
const $636d47a2eec1a784$export$33463a3675a65980 = (0, $3UXZ8.default)("div", {
    target: "emh330k1",
    label: "PartnerTierDescription"
})({
    name: "1v5z18m",
    styles: "width:300px;"
});
const $636d47a2eec1a784$export$7e3913cd0c2fa379 = (0, $3UXZ8.default)("img", {
    target: "emh330k2",
    label: "PartnerBadgeWrapper"
})({
    name: "1y2hais",
    styles: "padding-left:5px;vertical-align:middle;"
});
const $636d47a2eec1a784$export$3463702bb58e307a = (0, $3UXZ8.default)("span", {
    target: "emh330k3",
    label: "PartnerNameContainer"
})((0, $jdjb1.ellipsis), (props)=>({
        fontWeight: props.showAetherAppListingPage ? 600 : 400,
        a: {
            '&:hover, &:focus': {
                textDecoration: 'underline'
            }
        }
    }), "");
const $636d47a2eec1a784$var$PartnerTiers = {
    goldMarketplacePartner: {
        label: (0, $ammkg.MarketplacePartnerTierType).Gold,
        badge: (0, (/*@__PURE__*/$parcel$interopDefault($fI3dH)))
    },
    platinumMarketplacePartner: {
        label: (0, $ammkg.MarketplacePartnerTierType).Platinum,
        badge: (0, (/*@__PURE__*/$parcel$interopDefault($aqC9O)))
    },
    silverMarketplacePartner: {
        label: (0, $ammkg.MarketplacePartnerTierType).Silver,
        badge: (0, (/*@__PURE__*/$parcel$interopDefault($4Ekia)))
    }
};
const $636d47a2eec1a784$export$5a849d5aaf447b77 = (partnerTier)=>{
    switch(partnerTier){
        case 'SILVER':
            return $636d47a2eec1a784$var$PartnerTiers.silverMarketplacePartner;
        case 'GOLD':
            return $636d47a2eec1a784$var$PartnerTiers.goldMarketplacePartner;
        case 'PLATINUM':
            return $636d47a2eec1a784$var$PartnerTiers.platinumMarketplacePartner;
        default:
            return null;
    }
};
const $636d47a2eec1a784$export$abec1d4f7cef555e = (partnerTier)=>{
    const { showUpdatedPartnerTierMessage: showUpdatedPartnerTierMessage } = (0, $9l6Pq.useStatsig)();
    const partnerTierType = $636d47a2eec1a784$export$5a849d5aaf447b77(partnerTier);
    if (!partnerTierType) return null;
    const type = partnerTierType.label.toString().charAt(0) + partnerTierType.label.toString().slice(1).toLowerCase();
    const shouldShowUpdatedPartnerTierMessage = showUpdatedPartnerTierMessage();
    const DESCRIPTION = shouldShowUpdatedPartnerTierMessage ? /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            "This ",
            type,
            " Marketplace partner participates in Atlassian's",
            ' ',
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                href: $636d47a2eec1a784$export$878bbd785b35ed1e,
                children: "Marketplace Security Bug Bounty Program"
            }),
            ", and invests in Cloud and Data Center versions of their most popular server apps."
        ]
    }) : "".concat(type, " Marketplace Partners have met enhanced Atlassian requirements by investing in areas such as creating Cloud and Data Center app versions for their popular server apps and participating in Marketplace security programs, among others.");
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4lmb9.default), {
        content: /*#__PURE__*/ (0, $lHkHI.jsxs)($636d47a2eec1a784$export$33463a3675a65980, {
            children: [
                DESCRIPTION,
                /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                        href: $636d47a2eec1a784$export$bbc7eef4cce3da2c,
                        children: shouldShowUpdatedPartnerTierMessage ? 'About Marketplace partner program' : 'Learn more about Marketplace partner program'
                    })
                })
            ]
        }),
        disableBlurEvent: true,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)($636d47a2eec1a784$export$7e3913cd0c2fa379, {
            alt: "".concat(type, " Marketplace Partner"),
            src: partnerTierType.badge
        })
    });
};
const $636d47a2eec1a784$var$HeaderPartnerDetails = (props)=>{
    const { name: name, link: link, pathname: pathname, partnerTierType: partnerTierType, showAetherAppListingPage: showAetherAppListingPage } = props;
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const onNameClick = (e)=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: $636d47a2eec1a784$export$a33d9f95d57cad28
        });
        e === null || e === void 0 || e.stopPropagation();
    };
    if (!name) return null;
    if (!link && !pathname) return /*#__PURE__*/ (0, $lHkHI.jsxs)($636d47a2eec1a784$export$32d72254fe4d6919, {
        showAetherAppListingPage: showAetherAppListingPage,
        "data-testid": (0, $7BUhe.TEST_IDS).PARTNER_DETAILS,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                children: "by\xA0"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($636d47a2eec1a784$export$3463702bb58e307a, {
                showAetherAppListingPage: showAetherAppListingPage,
                children: name
            }),
            partnerTierType && $636d47a2eec1a784$export$abec1d4f7cef555e(partnerTierType)
        ]
    });
    if (link) return /*#__PURE__*/ (0, $lHkHI.jsxs)($636d47a2eec1a784$export$32d72254fe4d6919, {
        showAetherAppListingPage: showAetherAppListingPage,
        "data-testid": (0, $7BUhe.TEST_IDS).PARTNER_DETAILS,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                children: "by\xA0"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($636d47a2eec1a784$export$3463702bb58e307a, {
                showAetherAppListingPage: showAetherAppListingPage,
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                    href: link,
                    onClick: onNameClick,
                    children: name
                })
            }),
            partnerTierType && $636d47a2eec1a784$export$abec1d4f7cef555e(partnerTierType)
        ]
    });
    let path = '';
    if (pathname) path = pathname;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($636d47a2eec1a784$export$32d72254fe4d6919, {
        showAetherAppListingPage: showAetherAppListingPage,
        "data-testid": (0, $7BUhe.TEST_IDS).PARTNER_DETAILS,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                children: "by\xA0"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($636d47a2eec1a784$export$3463702bb58e307a, {
                showAetherAppListingPage: showAetherAppListingPage,
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cmZSX.default), {
                    to: path,
                    onClick: onNameClick,
                    children: name
                })
            }),
            partnerTierType && $636d47a2eec1a784$export$abec1d4f7cef555e(partnerTierType)
        ]
    });
};
var $636d47a2eec1a784$export$2e2bcd8739ae039 = $636d47a2eec1a784$var$HeaderPartnerDetails;

});
parcelRegister("cmZSX", function(module, exports) {

$parcel$export(module.exports, "default", () => $90178b3d4e48f04f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $h8TzT = parcelRequire("h8TzT");

var $gSncF = parcelRequire("gSncF");
var $90178b3d4e48f04f$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $90178b3d4e48f04f$var$_objectWithoutProperties(obj, keys) {
    var target = {};
    for(var i in obj){
        if (keys.indexOf(i) >= 0) continue;
        if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
        target[i] = obj[i];
    }
    return target;
}
function $90178b3d4e48f04f$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $90178b3d4e48f04f$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $90178b3d4e48f04f$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $90178b3d4e48f04f$var$isModifiedEvent = function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};
/**
 * The public API for rendering a history-aware <a>.
 */ var $90178b3d4e48f04f$var$Link = function(_React$Component) {
    $90178b3d4e48f04f$var$_inherits(Link, _React$Component);
    function Link() {
        var _temp, _this, _ret;
        $90178b3d4e48f04f$var$_classCallCheck(this, Link);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $90178b3d4e48f04f$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.handleClick = function(event) {
            if (_this.props.onClick) _this.props.onClick(event);
            if (!event.defaultPrevented && // onClick prevented default
            event.button === 0 && // ignore everything but left clicks
            !_this.props.target && // let browser handle "target=_blank" etc.
            !$90178b3d4e48f04f$var$isModifiedEvent(event) // ignore clicks with modifier keys
            ) {
                event.preventDefault();
                var history = _this.context.router.history;
                var _this$props = _this.props, replace = _this$props.replace, to = _this$props.to;
                if (replace) history.replace(to);
                else history.push(to);
            }
        }, _temp), $90178b3d4e48f04f$var$_possibleConstructorReturn(_this, _ret);
    }
    Link.prototype.render = function render() {
        var _props = this.props, replace = _props.replace, to = _props.to, innerRef = _props.innerRef, props = $90178b3d4e48f04f$var$_objectWithoutProperties(_props, [
            "replace",
            "to",
            "innerRef"
        ]); // eslint-disable-line no-unused-vars
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(this.context.router, "You should not use <Link> outside a <Router>");
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(to !== undefined, 'You must specify the "to" property');
        var history = this.context.router.history;
        var location = typeof to === "string" ? (0, $gSncF.createLocation)(to, null, null, history.location) : to;
        var href = history.createHref(location);
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", $90178b3d4e48f04f$var$_extends({}, props, {
            onClick: this.handleClick,
            href: href,
            ref: innerRef
        }));
    };
    return Link;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$90178b3d4e48f04f$var$Link.propTypes = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    target: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    replace: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
    ]).isRequired,
    innerRef: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
    ])
};
$90178b3d4e48f04f$var$Link.defaultProps = {
    replace: false
};
$90178b3d4e48f04f$var$Link.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
            push: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
            replace: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
            createHref: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
        }).isRequired
    }).isRequired
};
var $90178b3d4e48f04f$export$2e2bcd8739ae039 = $90178b3d4e48f04f$var$Link;

});

parcelRegister("l501X", function(module, exports) {

$parcel$export(module.exports, "default", () => $f58a16ade376eabb$export$2e2bcd8739ae039);

var $gykb8 = parcelRequire("gykb8");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $f58a16ade376eabb$var$ExternalLink = (props)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
        className: props.className,
        href: props.href,
        target: "_blank",
        rel: "noopener noreferrer",
        onClick: props.onClick,
        title: props.title,
        "data-testid": props['data-testid'],
        children: props.children
    });
var $f58a16ade376eabb$export$2e2bcd8739ae039 = $f58a16ade376eabb$var$ExternalLink;

});

parcelRegister("fI3dH", function(module, exports) {
module.exports = new URL("GoldMiniPartnerBadge.static.5f3b45ae.svg", import.meta.url).toString();

});

parcelRegister("aqC9O", function(module, exports) {
module.exports = new URL("PlatinumMiniPartnerBadge.static.37515d24.svg", import.meta.url).toString();

});

parcelRegister("4Ekia", function(module, exports) {
module.exports = new URL("SilverMiniPartnerBadge.static.873be33b.svg", import.meta.url).toString();

});


parcelRegister("76fzC", function(module, exports) {

$parcel$export(module.exports, "formatDayOfWeek", () => $52b52c7fd4cb6b92$export$f484d8a20c1ae790);
$parcel$export(module.exports, "toWeekdayRanges", () => $52b52c7fd4cb6b92$export$1cc0e6cb49769df6);
$parcel$export(module.exports, "to12HourFormat", () => $52b52c7fd4cb6b92$export$a8078872fdc7223f);
$parcel$export(module.exports, "longDate", () => $52b52c7fd4cb6b92$export$73df931598513ca3);
$parcel$export(module.exports, "subtractDateByDays", () => $52b52c7fd4cb6b92$export$e30f1a20d59dd134);
$parcel$export(module.exports, "isFutureDate", () => $52b52c7fd4cb6b92$export$3c3ec13c4ecfb550);
$parcel$export(module.exports, "ISOFormatHyphenatedDate", () => $52b52c7fd4cb6b92$export$ffdb6493ffaf1eaa);
$parcel$export(module.exports, "differenceInDaysToNow", () => $52b52c7fd4cb6b92$export$c1d4577b61060cb1);
$parcel$export(module.exports, "weekdayToISODayNumber", () => $52b52c7fd4cb6b92$export$1721a40b71c1546e);
$parcel$export(module.exports, "getUtcTime", () => $52b52c7fd4cb6b92$export$ce02ba817385328);
$parcel$export(module.exports, "getUtcLongDate", () => $52b52c7fd4cb6b92$export$9a1b4f0fb6d8f159);
$parcel$export(module.exports, "getDay", () => $52b52c7fd4cb6b92$export$1b64bc9c5306ed54);
$parcel$export(module.exports, "differenceInDaysOrMonths", () => $52b52c7fd4cb6b92$export$6ce82cc6568079c);
$parcel$export(module.exports, "parseDateString", () => $52b52c7fd4cb6b92$export$e684af8cfb294f41);
$parcel$export(module.exports, "calculateDateRange", () => $52b52c7fd4cb6b92$export$c0560fec2aaf785f);
$parcel$export(module.exports, "formatDate", () => $52b52c7fd4cb6b92$export$3ae94a2503e890a1);
$parcel$export(module.exports, "formatDateObject", () => $52b52c7fd4cb6b92$export$f51d97cc5465fda6);
$parcel$export(module.exports, "dateToISODayNumber", () => $52b52c7fd4cb6b92$export$4f59265c40720700);

var $d2wNG = parcelRequire("d2wNG");
var $1raUW = parcelRequire("1raUW");
var $EN9B6 = parcelRequire("EN9B6");
var $dpnxM = parcelRequire("dpnxM");
var $7ueqz = parcelRequire("7ueqz");
var $5YjhU = parcelRequire("5YjhU");
var $2u0SN = parcelRequire("2u0SN");
var $fiOXn = parcelRequire("fiOXn");

var $bTrQR = parcelRequire("bTrQR");
const $52b52c7fd4cb6b92$export$f484d8a20c1ae790 = (day, short)=>(0, $EN9B6.default)((0, $2u0SN.default)(new Date(), day), short ? 'iii' : 'iiii');
const $52b52c7fd4cb6b92$export$1cc0e6cb49769df6 = (days, options)=>{
    const orderedDays = [
        ...days
    ].sort(); // sort() mutates the array, hence making a copy
    const { shortDaysOfWeek: shortDaysOfWeek = true } = options || {};
    const ranges = [
        []
    ];
    let currentRange = 0;
    /* This loop puts the days into ranges, example:
    days: [2,3,5,6]
    ranges: [[2,3],[5,6]]
  */ for(let i = 0; i < orderedDays.length; i += 1){
        ranges[currentRange].push(orderedDays[i]);
        if (orderedDays[i + 1] !== orderedDays[i] + 1 && i !== orderedDays.length - 1) {
            currentRange += 1;
            ranges[currentRange] = [];
        }
    }
    // flatten ranges of the day "orders" back into day name ranges
    // ranges: [[2,3],[5,6]]
    // result: ["Tue-Wed","Fri-Sat"]
    return ranges.map((range)=>{
        const startDay = $52b52c7fd4cb6b92$export$f484d8a20c1ae790(range[0], shortDaysOfWeek);
        const endDay = $52b52c7fd4cb6b92$export$f484d8a20c1ae790(range[range.length - 1], shortDaysOfWeek);
        return startDay === endDay ? startDay : [
            startDay,
            endDay
        ].join('-');
    });
};
const $52b52c7fd4cb6b92$export$a8078872fdc7223f = (time)=>{
    const date = (0, $5YjhU.default)(time, 'HH:mm', new Date());
    return (0, $EN9B6.default)(date, 'h:mm aa');
};
const $52b52c7fd4cb6b92$export$73df931598513ca3 = (date, formatString)=>(0, $EN9B6.default)(new Date(date), formatString || 'MMM do yyyy');
const $52b52c7fd4cb6b92$export$e30f1a20d59dd134 = (date, days)=>(0, $fiOXn.default)(new Date(date), {
        days: days
    });
const $52b52c7fd4cb6b92$export$3c3ec13c4ecfb550 = (date)=>(0, $dpnxM.default)(date);
const $52b52c7fd4cb6b92$export$ffdb6493ffaf1eaa = (date)=>(0, $EN9B6.default)(new Date(date), 'yyyy-MM-dd');
const $52b52c7fd4cb6b92$export$c1d4577b61060cb1 = (date)=>(0, $d2wNG.default)(date, Date.now());
const $52b52c7fd4cb6b92$export$1721a40b71c1546e = (day)=>{
    const days = [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
    ];
    return days.findIndex((dayName)=>dayName === day.toLocaleLowerCase()) + 1;
};
function $52b52c7fd4cb6b92$export$ce02ba817385328(unixTime) {
    const date = new Date(unixTime);
    const hours = date.getUTCHours();
    const hour = (hours % 12).toString().padStart(2, '0');
    const meridiem = hours < 12 ? 'a.m.' : 'p.m.';
    const minutes = date.getUTCMinutes().toString().padStart(2, '0');
    return "".concat(hour, ":").concat(minutes, " ").concat(meridiem);
}
function $52b52c7fd4cb6b92$export$9a1b4f0fb6d8f159(unixTime) {
    const date = new Date(unixTime);
    const day = date.getUTCDate();
    const month = date.toLocaleString('en-US', {
        month: 'long'
    });
    const year = date.getUTCFullYear();
    return "".concat(month, " ").concat(day, ", ").concat(year);
}
function $52b52c7fd4cb6b92$export$1b64bc9c5306ed54(unixTime) {
    const date = new Date(unixTime);
    const dayIndex = date.getDay();
    const days = [
        'Sunday',
        'Monday',
        'Tuesday',
        'Wednesday',
        'Thursday',
        'Friday',
        'Saturday'
    ];
    // Get the day name using the day index
    const dayName = days[dayIndex];
    return dayName;
}
function $52b52c7fd4cb6b92$export$6ce82cc6568079c(endDate, startDate) {
    let options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
        pluralizeUnits: true,
        countUnitSeparator: ' '
    };
    const monthsDiff = (0, $1raUW.default)(endDate, startDate);
    const daysDiff = (0, $d2wNG.default)(endDate, startDate);
    const pluralize = (unit, count)=>count > 1 ? unit + 's' : unit;
    if (monthsDiff > 0) return "".concat(monthsDiff).concat(options.countUnitSeparator).concat(options.pluralizeUnits ? pluralize('month', monthsDiff) : 'month');
    else return "".concat(daysDiff).concat(options.countUnitSeparator).concat(options.pluralizeUnits ? pluralize('day', daysDiff) : 'day');
}
const $52b52c7fd4cb6b92$export$e684af8cfb294f41 = function parseDateString(dateString) {
    let context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'marketplace';
    const date = (0, $5YjhU.default)(dateString, 'yyyy-MM-dd', new Date());
    if (!(0, $7ueqz.default)(date)) {
        (0, $bTrQR.default).error(context, 'Error in creating Date object');
        return new Date();
    }
    return date;
};
const $52b52c7fd4cb6b92$export$c0560fec2aaf785f = (daysAgo)=>{
    const dateNow = Date.now();
    return {
        startDate: $52b52c7fd4cb6b92$export$ffdb6493ffaf1eaa($52b52c7fd4cb6b92$export$e30f1a20d59dd134(dateNow, daysAgo)),
        endDate: $52b52c7fd4cb6b92$export$ffdb6493ffaf1eaa($52b52c7fd4cb6b92$export$e30f1a20d59dd134(dateNow, 1))
    };
};
const $52b52c7fd4cb6b92$export$3ae94a2503e890a1 = function formatDate(dateString, formatString) {
    let context = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'marketplace';
    const date = Date.parse(dateString);
    if (!Number.isNaN(date)) {
        const dateObject = $52b52c7fd4cb6b92$export$e684af8cfb294f41(dateString, context);
        return (0, $EN9B6.default)(dateObject, formatString);
    } else return dateString;
};
const $52b52c7fd4cb6b92$export$f51d97cc5465fda6 = (date, formatString)=>{
    return (0, $EN9B6.default)(date, formatString);
};
const $52b52c7fd4cb6b92$export$4f59265c40720700 = (date)=>{
    const days = [
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday',
        'sunday'
    ];
    const dayName = (0, $EN9B6.default)(date, 'iiii').toLowerCase();
    return days.findIndex((day)=>day === dayName) + 1;
};

});

parcelRegister("8wSvA", function(module, exports) {

$parcel$export(module.exports, "createHighlights", () => $635b9828183a846c$export$be36e179709c50d0);
function $635b9828183a846c$export$be36e179709c50d0(hit, fieldName, tokensFieldName) {
    const tokensHighlights = hit.getIn([
        '_highlightResult',
        tokensFieldName
    ]);
    return tokensHighlights ? tokensHighlights.filter((h)=>h.get('matchLevel') !== 'none').map((h)=>h.get('value')).push(hit.getIn([
        '_highlightResult',
        fieldName,
        'value'
    ])).join(' ') : hit.getIn([
        '_highlightResult',
        fieldName,
        'value'
    ]);
}

});

parcelRegister("23J4Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $17fed46c6f140672$export$2e2bcd8739ae039);

var $1qPAw = parcelRequire("1qPAw");
var $17fed46c6f140672$export$2e2bcd8739ae039 = (0, $1qPAw.default);

});
parcelRegister("1qPAw", function(module, exports) {

$parcel$export(module.exports, "default", () => $10b03c7a78b09173$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $jdjb1 = parcelRequire("jdjb1");

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $6jEcw = parcelRequire("6jEcw");

var $b8jn7 = parcelRequire("b8jn7");

var $lHkHI = parcelRequire("lHkHI");
const $10b03c7a78b09173$var$CategoriesStyled = (0, $3UXZ8.default)("div", {
    target: "eb1o6oq0",
    label: "CategoriesStyled"
})((0, $jdjb1.ellipsis), " height:18px;font-size:12px;color:", "var(--ds-text-subtlest, ".concat((0, $j0gMm.N100), ")"), ";");
class $10b03c7a78b09173$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)($10b03c7a78b09173$var$CategoriesStyled, {
            children: this.props.categories.map((category, i)=>/*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
                    children: [
                        i > 0 ? ', ' : '',
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $b8jn7.default), {
                            name: category,
                            onClick: this.props.onCategoryClick,
                            perspective: this.props.perspective
                        })
                    ]
                }, i))
        });
    }
}
(0, $5zQU9.default)($10b03c7a78b09173$export$2e2bcd8739ae039, "propTypes", {
    categories: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
    onCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    perspective: (0, $6jEcw.default).perspective
});

});
parcelRegister("b8jn7", function(module, exports) {

$parcel$export(module.exports, "default", () => $81af77ec8b70d2e4$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");
parcelRequire("ibjku");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $5YKni = parcelRequire("5YKni");

var $fCICH = parcelRequire("fCICH");

var $lHkHI = parcelRequire("lHkHI");
function $81af77ec8b70d2e4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $81af77ec8b70d2e4$var$_ref = {
    name: "da5mst-CategoryStyled",
    styles: "&:hover{text-decoration:underline;};label:CategoryStyled;"
};
const $81af77ec8b70d2e4$var$CategoryStyled = (0, $3UXZ8.default)("span", {
    target: "e4f8r6y0",
    label: "CategoryStyled"
})("font-size:12px;list-style:none;", (props)=>props.clickable ? $81af77ec8b70d2e4$var$_ref : '', "");
class $81af77ec8b70d2e4$var$Category extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onClick", (e)=>{
            if (this.props.onClick) {
                e.preventDefault();
                e.stopPropagation();
                this.props.onClick({
                    newFilters: (0, $g5DHJ.Map)({
                        [(0, $fCICH.getFilters)().get('category').get('key')]: this.props.name
                    })
                });
                this.props.fireAnalyticsEvent({
                    eventType: (0, $gaiog.FilterClickedEvent),
                    actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_TILE_CATEGORY_FILTER),
                    objectType: (0, $5YKni.OBJECT_TYPE_FILTER),
                    objectId: (0, $fCICH.getFilters)().get('category').get('key'),
                    source: (0, $5YKni.EVENT_SOURCE),
                    attributes: {
                        currentPerspective: this.props.perspective,
                        filterValue: this.props.name,
                        selected: true
                    }
                }, (0, $5YKni.EVENT_CHANNEL));
            }
        });
    }
    render() {
        return(/*#__PURE__*/ // eslint-disable-next-line styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions
        (0, $lHkHI.jsx)($81af77ec8b70d2e4$var$CategoryStyled, {
            clickable: !!this.props.onClick,
            onClick: this.onClick,
            children: this.props.name
        }));
    }
}
var $81af77ec8b70d2e4$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($81af77ec8b70d2e4$var$Category);

});



parcelRegister("2AdLY", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e19a08f31c2c8e3$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $gykb8 = parcelRequire("gykb8");

var $9osuT = parcelRequire("9osuT");

var $9rIMC = parcelRequire("9rIMC");

var $hjlb6 = parcelRequire("hjlb6");

var $eUqFw = parcelRequire("eUqFw");

var $5YKni = parcelRequire("5YKni");

var $lHkHI = parcelRequire("lHkHI");
function $1e19a08f31c2c8e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1e19a08f31c2c8e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1e19a08f31c2c8e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1e19a08f31c2c8e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $1e19a08f31c2c8e3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e19a08f31c2c8e3$var$isLeftClick = (event)=>event.button === 0;
const $1e19a08f31c2c8e3$export$29c0e362412a40fd = /*#__PURE__*/ (0, $3UXZ8.default)((0, $gykb8.default), {
    target: "envz1090",
    label: "HitLinkStyled"
})({
    name: "1iwiupw",
    styles: "color:inherit;&:hover,&:active,&:focus{text-decoration:none;}"
});
class $1e19a08f31c2c8e3$var$HitLink extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onClick", (event)=>{
            var _this$props$filters;
            const ecosystemCloudAppData = this.props.hit.version.get('cloud');
            const ecosystemCloudAppId = ecosystemCloudAppData === null || ecosystemCloudAppData === void 0 ? void 0 : ecosystemCloudAppData.get('cloudAppId');
            const productKeys = this.props.hit.getIn([
                'version',
                'compatibilities'
            ]).map((a)=>a.get('applicationName'));
            this.props.fireAnalyticsEvent({
                eventType: (0, $5YKni.TileClickedEvent),
                actionSubjectId: $1e19a08f31c2c8e3$var$isLeftClick(event) ? (0, $5YKni.ANALYTICS_SUBJECT_ID_HIT) : (0, $5YKni.ANALYTICS_SUBJECT_ID_RIGHT_CLICK_HIT),
                objectType: (0, $5YKni.OBJECT_TYPE_APP),
                objectId: this.props.hit.get('addonKey'),
                source: this.props.perspective,
                attributes: $1e19a08f31c2c8e3$var$_objectSpread($1e19a08f31c2c8e3$var$_objectSpread({
                    currentPerspective: this.props.perspective,
                    hitGroup: this.props.hitContext.get('hitGroup')
                }, ecosystemCloudAppId && {
                    isEcosystemCloudApp: true,
                    ecosystemCloudAppId: ecosystemCloudAppId
                }), {}, {
                    isPaidApp: this.props.hit.getIn([
                        'version',
                        'paid'
                    ]),
                    productKeys: productKeys === null || productKeys === void 0 ? void 0 : productKeys.toJS(),
                    filters: (_this$props$filters = this.props.filters) === null || _this$props$filters === void 0 ? void 0 : _this$props$filters.toJS(),
                    sectionTitle: this.props.sectionTitle
                })
            }, (0, $5YKni.EVENT_CHANNEL));
            if ($1e19a08f31c2c8e3$var$isLeftClick(event)) (0, $9rIMC).maybeOpenInNewTab(event, ()=>{
                this.props.hitContext.get('onHitClick')({
                    hit: this.props.hit
                }, event);
            });
        });
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)($1e19a08f31c2c8e3$export$29c0e362412a40fd, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this.props.extraClasses, this.props.className),
            href: this.props.hitContext.get('hitHrefResolver')({
                hit: this.props.hit
            }),
            onClick: this.onClick,
            onContextMenu: this.onClick,
            children: this.props.children
        });
    }
}
var $1e19a08f31c2c8e3$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($1e19a08f31c2c8e3$var$HitLink);

});

parcelRegister("kXHwt", function(module, exports) {

$parcel$export(module.exports, "default", () => $f42b14121d8411ab$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $62cXe = parcelRequire("62cXe");

var $j0gMm = parcelRequire("j0gMm");

var $8gcXz = parcelRequire("8gcXz");

var $3BBSQ = parcelRequire("3BBSQ");
var $8U0Ec = parcelRequire("8U0Ec");
var $jC9Rj = parcelRequire("jC9Rj");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $8wSvA = parcelRequire("8wSvA");

var $k5pOx = parcelRequire("k5pOx");

var $lHkHI = parcelRequire("lHkHI");
function $f42b14121d8411ab$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f42b14121d8411ab$export$e6ff31bff12b7ff4 = (0, $3UXZ8.default)("div", {
    target: "e1fkgwv50",
    label: "Logo"
})({
    name: "4dguu7",
    styles: "display:flex;flex-direction:row;justify-content:start;position:relative;width:72px;height:72px;border-radius:var(--ds-border-radius-100, 3px);overflow:hidden;&:hover{cursor:pointer;}"
});
const $f42b14121d8411ab$export$3f3deff8b74a6b4f = (0, $3UXZ8.default)("div", {
    target: "e1fkgwv51",
    label: "HitHeadingStyled"
})({
    name: "j7qwjs",
    styles: "display:flex;flex-direction:column;"
});
const $f42b14121d8411ab$export$ef41ebc44b9c1fe4 = (0, $3UXZ8.default)("img", {
    target: "e1fkgwv52",
    label: "LogoImage"
})("width:100%;height:100%;color:", (0, $j0gMm.N500), ";");
const $f42b14121d8411ab$export$4836b6f4d0c0d87f = (0, $3UXZ8.default)("div", {
    target: "e1fkgwv53",
    label: "TopVendorContainer"
})({
    name: "949zxw",
    styles: "right:var(--ds-space-150, 12px);top:-0.75rem;position:relative;width:0;"
});
const $f42b14121d8411ab$export$a7235ebc5e93af41 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $jC9Rj.default), {
    target: "e1fkgwv54",
    label: "TopVendorBadgeStyled"
})({
    name: "1tueaee",
    styles: "z-index:10;width:24px;height:24px;"
});
const $f42b14121d8411ab$export$eda0685f2d9ca1b9 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H3), {
    target: "e1fkgwv55",
    label: "NameHeader"
})((props)=>props.mixin(), ";color:", "var(--ds-text, ".concat((0, $j0gMm.N800), ")"), ";font-weight:600;overflow:hidden;text-overflow:ellipsis;margin:var(--ds-space-200, 16px) 0 var(--ds-space-100, 8px);line-height:1.42857143;max-height:var(--ds-space-600, 48px);");
class $f42b14121d8411ab$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const highlightedText = (0, $8wSvA.createHighlights)(this.props.hit, 'name', 'tokenizedName');
        const logoImage = this.props.hitImageHrefResolver({
            hit: this.props.hit
        }) || (0, (/*@__PURE__*/$parcel$interopDefault($k5pOx)));
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($f42b14121d8411ab$export$3f3deff8b74a6b4f, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsxs)($f42b14121d8411ab$export$e6ff31bff12b7ff4, {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8U0Ec.default), {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)($f42b14121d8411ab$export$ef41ebc44b9c1fe4, {
                                alt: highlightedText,
                                loading: "lazy",
                                src: logoImage
                            })
                        }),
                        this.props.hit.getIn([
                            'vendor',
                            'isTopVendor'
                        ]) && /*#__PURE__*/ (0, $lHkHI.jsx)($f42b14121d8411ab$export$4836b6f4d0c0d87f, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)($f42b14121d8411ab$export$a7235ebc5e93af41, {})
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($f42b14121d8411ab$export$eda0685f2d9ca1b9, {
                    mixin: (0, $62cXe).h500,
                    children: highlightedText ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3BBSQ.AppTileHighlightedText), {
                        highlightedText: highlightedText,
                        originalText: this.props.hit.get('name')
                    }) : this.props.hit.get('name')
                })
            ]
        });
    }
}
(0, $5zQU9.default)($f42b14121d8411ab$export$2e2bcd8739ae039, "propTypes", {
    fromSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    hit: (0, $90ON9.default).hit().isRequired,
    hitImageHrefResolver: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});

});
parcelRegister("8U0Ec", function(module, exports) {

$parcel$export(module.exports, "default", () => $67b40e3a6c755658$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $lAV1A = parcelRequire("lAV1A");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $67b40e3a6c755658$export$398a70353a4cf5f3 = "\nbackground: rgba(255,255,255,0.89);\nborder-radius: 3px;\nbox-sizing: border-box;\npadding: 12.5%;\n";
const $67b40e3a6c755658$var$Background = (0, $3UXZ8.default)("div", {
    target: "e1lk71cd0",
    label: "Background"
})("width:100%;height:100%;", (props)=>props.isDarkMode ? $67b40e3a6c755658$export$398a70353a4cf5f3 : '', "");
function $67b40e3a6c755658$export$2e2bcd8739ae039(props) {
    const theme = (0, $lAV1A.default)();
    const isDarkMode = (theme === null || theme === void 0 ? void 0 : theme.colorMode) === 'dark';
    return /*#__PURE__*/ (0, $lHkHI.jsx)($67b40e3a6c755658$var$Background, {
        "data-testid": "dark-modo-logo-bg",
        isDarkMode: isDarkMode,
        children: props.children
    });
}

});
parcelRegister("lAV1A", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb8931ab47177118$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $k6OHd = parcelRequire("k6OHd");

var $cHqPT = parcelRequire("cHqPT");
/**
 * A React hook which returns the current themes and color-mode set on `<html>`.
 *
 * @example
 * ```
 * const { colorMode, dark, light, spacing, typography } = useThemeObserver();
 *
 * // Performing side effects when it changes
 * useEffect(() => {
 *   console.log(`The color mode has changed to ${theme.colorMode}`);
 * }, [theme.colorMode]);
 * ```
 */ const $fb8931ab47177118$var$useThemeObserver = ()=>{
    const [theme, setTheme] = (0, $eUqFw.useState)((0, $k6OHd.default)());
    (0, $eUqFw.useEffect)(()=>{
        const observer = new (0, $cHqPT.default)((theme)=>setTheme(theme));
        observer.observe();
        return ()=>observer.disconnect();
    }, []);
    return theme;
};
var $fb8931ab47177118$export$2e2bcd8739ae039 = $fb8931ab47177118$var$useThemeObserver;

});
parcelRegister("k6OHd", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea3bb15dbb905771$export$2e2bcd8739ae039);

var $axYky = parcelRequire("axYky");

var $5IQVo = parcelRequire("5IQVo");

var $2l4Xw = parcelRequire("2l4Xw");
const $ea3bb15dbb905771$var$isThemeColorMode = (colorMode)=>{
    return (0, $5IQVo.themeColorModes).find((mode)=>mode === colorMode) !== undefined;
};
const $ea3bb15dbb905771$var$getGlobalTheme = ()=>{
    if (typeof document === 'undefined') return {};
    const element = document.documentElement;
    const colorMode = element.getAttribute((0, $axYky.COLOR_MODE_ATTRIBUTE)) || '';
    const theme = element.getAttribute((0, $axYky.THEME_DATA_ATTRIBUTE)) || '';
    return {
        ...(0, $2l4Xw.themeStringToObject)(theme),
        ...$ea3bb15dbb905771$var$isThemeColorMode(colorMode) && {
            colorMode: colorMode
        }
    };
};
var $ea3bb15dbb905771$export$2e2bcd8739ae039 = $ea3bb15dbb905771$var$getGlobalTheme;

});
parcelRegister("axYky", function(module, exports) {

$parcel$export(module.exports, "THEME_DATA_ATTRIBUTE", () => $7adbc8d9611938f1$export$4ef52930e33717cd);
$parcel$export(module.exports, "COLOR_MODE_ATTRIBUTE", () => $7adbc8d9611938f1$export$a00eac3f8684bcd0);
$parcel$export(module.exports, "CONTRAST_MODE_ATTRIBUTE", () => $7adbc8d9611938f1$export$2112803007239c61);
$parcel$export(module.exports, "CUSTOM_THEME_ATTRIBUTE", () => $7adbc8d9611938f1$export$352e418ed5b6193a);
$parcel$export(module.exports, "TOKEN_NOT_FOUND_CSS_VAR", () => $7adbc8d9611938f1$export$dddac1532e822863);
$parcel$export(module.exports, "CURRENT_SURFACE_CSS_VAR", () => $7adbc8d9611938f1$export$9d7b58831ae93caa);
const $7adbc8d9611938f1$export$4ef52930e33717cd = 'data-theme';
const $7adbc8d9611938f1$export$a00eac3f8684bcd0 = 'data-color-mode';
const $7adbc8d9611938f1$export$2112803007239c61 = 'data-contrast-mode';
const $7adbc8d9611938f1$export$352e418ed5b6193a = 'data-custom-theme';
const $7adbc8d9611938f1$export$2faeed762aac6741 = 'light';
const $7adbc8d9611938f1$export$6f0c6fb8c80fcc92 = 'ds';
const $7adbc8d9611938f1$export$4d0c7bbf80185957 = [
    'opacity',
    'font',
    'space',
    'border'
];
const $7adbc8d9611938f1$export$dddac1532e822863 = `--${$7adbc8d9611938f1$export$6f0c6fb8c80fcc92}-token-not-found`;
const $7adbc8d9611938f1$export$9d7b58831ae93caa = `--${$7adbc8d9611938f1$export$6f0c6fb8c80fcc92}-elevation-surface-current`;

});

parcelRegister("5IQVo", function(module, exports) {

$parcel$export(module.exports, "themeColorModes", () => $42aa1d91cefcf17e$export$83993de8eb66733);
$parcel$export(module.exports, "themeIds", () => $42aa1d91cefcf17e$export$7d43e72a58e3283f);
$parcel$export(module.exports, "themeStateDefaults", () => $42aa1d91cefcf17e$export$9aedcfa7336a207);
$parcel$export(module.exports, "default", () => $42aa1d91cefcf17e$export$2e2bcd8739ae039);
/**
 * This file contains the source of truth for themes and all associated meta data.
 */ /**
 * Themes: The internal identifier of a theme.
 * These ids are what the actual theme files/folders are called.
 * style-dictionary will attempt to locate these in the file-system.
 */ /**
 * ThemeOverrides: The internal identifier of a theme override. Which are themes that contain
 * a subset of tokens intended to override an existing theme. These ids are what the actual
 * theme files/folders are called. style-dictionary will attempt to locate these in the file-system.
 * Theme overrides are temporary and there may not be any defined at times.
 */ /**
 * Theme kinds: The type of theme.
 * Some themes are entirely focused on Color, whilst others are purely focused on spacing.
 * In the future other types may be introduced such as typography.
 */ /**
 * Theme modes: The general purpose of a theme.
 * This attr is used to apply the appropriate system-preference option
 * It may also be used as a selector for mode-specific overrides such as light/dark images.
 * The idea is there may exist many color themes, but every theme must either fit into light or dark.
 */ const $42aa1d91cefcf17e$export$83993de8eb66733 = [
    'light',
    'dark',
    'auto'
];
const $42aa1d91cefcf17e$export$8ce7e340c74e86c5 = [
    'more',
    'no-preference',
    'auto'
];
const $42aa1d91cefcf17e$export$7d43e72a58e3283f = [
    'light-increased-contrast',
    'light',
    'light-future',
    'light-brand-refresh',
    'dark',
    'dark-future',
    'dark-increased-contrast',
    'dark-brand-refresh',
    'legacy-light',
    'legacy-dark',
    'spacing',
    'shape',
    'typography-adg3',
    'typography-modernized',
    'typography-refreshed'
];
const $42aa1d91cefcf17e$export$ba8a43b83ecc69f8 = [];
const $42aa1d91cefcf17e$export$92ba366331403db2 = [
    ...$42aa1d91cefcf17e$export$7d43e72a58e3283f,
    ...$42aa1d91cefcf17e$export$ba8a43b83ecc69f8
];
/**
 * Theme to use a base. This will create the theme as
 * an extension with all token values marked as optional
 * to allow tokens to be overridden as required.
 */ /**
 * Palettes: The set of base tokens a given theme may be populated with.
 * For example: legacy light & dark themes use the "legacyPalette" containing colors from our
 * previous color set.
 */ /**
 * ThemeConfig: the source of truth for all theme meta-data.
 * This object should be used whenever interfacing with themes.
 */ const $42aa1d91cefcf17e$var$themeConfig = {
    'atlassian-light': {
        id: 'light',
        displayName: 'Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-light-future': {
        id: 'light-future',
        displayName: 'Future Light Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        override: 'light'
    },
    'atlassian-light-increased-contrast': {
        id: 'light-increased-contrast',
        displayName: 'Light Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        },
        extends: 'light',
        increasesContrastFor: 'light'
    },
    'atlassian-dark': {
        id: 'dark',
        displayName: 'Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-dark-future': {
        id: 'dark-future',
        displayName: 'Future Dark Theme',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        override: 'light'
    },
    'atlassian-dark-increased-contrast': {
        id: 'dark-increased-contrast',
        displayName: 'Dark Theme (increased contrast)',
        palette: 'defaultPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        },
        extends: 'dark',
        increasesContrastFor: 'dark'
    },
    'atlassian-legacy-light': {
        id: 'legacy-light',
        displayName: 'Light Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-legacy-dark': {
        id: 'legacy-dark',
        displayName: 'Dark Theme (legacy)',
        palette: 'legacyPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    },
    'atlassian-spacing': {
        id: 'spacing',
        displayName: 'Atlassian Spacing',
        palette: 'spacingScale',
        attributes: {
            type: 'spacing'
        }
    },
    'atlassian-typography-adg3': {
        id: 'typography-adg3',
        displayName: 'ADG3 Typography',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-shape': {
        id: 'shape',
        displayName: 'Atlassian Shape',
        palette: 'shapePalette',
        attributes: {
            type: 'shape'
        }
    },
    'atlassian-typography-modernized': {
        id: 'typography-modernized',
        displayName: 'Atlassian Typography (Modernized)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-typography-refreshed': {
        id: 'typography-refreshed',
        displayName: 'Atlassian Typography (Refreshed)',
        palette: 'typographyPalette',
        attributes: {
            type: 'typography'
        }
    },
    'atlassian-light-brand-refresh': {
        id: 'light-brand-refresh',
        displayName: 'Light theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'light'
        }
    },
    'atlassian-dark-brand-refresh': {
        id: 'dark-brand-refresh',
        displayName: 'Dark theme (Brand refresh)',
        palette: 'brandRefreshPalette',
        attributes: {
            type: 'color',
            mode: 'dark'
        }
    }
};
const $42aa1d91cefcf17e$export$9aedcfa7336a207 = {
    colorMode: 'auto',
    contrastMode: 'auto',
    dark: 'dark',
    light: 'light',
    shape: undefined,
    spacing: 'spacing',
    typography: undefined,
    UNSAFE_themeOptions: undefined
};
var /**
 * Represents theme state once mounted to the page
 * (the page doesn't have an "auto" color mode, it's either light or dark)
 */ $42aa1d91cefcf17e$export$2e2bcd8739ae039 = $42aa1d91cefcf17e$var$themeConfig;

});

parcelRegister("2l4Xw", function(module, exports) {

$parcel$export(module.exports, "themeStringToObject", () => $1b4163b1766a770b$export$f19b488f7c0547ee);
$parcel$export(module.exports, "themeObjectToString", () => $1b4163b1766a770b$export$62c37ab81302621a);

var $5IQVo = parcelRequire("5IQVo");
const $1b4163b1766a770b$var$themeKinds = [
    'light',
    'dark',
    'spacing',
    'typography',
    'shape'
];
const $1b4163b1766a770b$var$customThemeOptions = 'UNSAFE_themeOptions';
const $1b4163b1766a770b$var$isThemeKind = (themeKind)=>{
    return $1b4163b1766a770b$var$themeKinds.find((kind)=>kind === themeKind) !== undefined;
};
const $1b4163b1766a770b$var$isThemeIds = (themeId)=>{
    return (0, $5IQVo.themeIds).find((id)=>id === themeId) !== undefined;
};
const $1b4163b1766a770b$var$isColorMode = (modeId)=>{
    return [
        'light',
        'dark',
        'auto'
    ].includes(modeId);
};
const $1b4163b1766a770b$export$f19b488f7c0547ee = (themeState)=>{
    return themeState.split(' ').map((theme)=>theme.split(/:(.*)/s)).reduce((themeObject, [kind, id])=>{
        if (kind === 'colorMode' && $1b4163b1766a770b$var$isColorMode(id)) themeObject[kind] = id;
        if ($1b4163b1766a770b$var$isThemeKind(kind) && $1b4163b1766a770b$var$isThemeIds(id)) // @ts-expect-error FIXME - this is a valid ts error
        themeObject[kind] = id;
        if (kind === $1b4163b1766a770b$var$customThemeOptions) try {
            themeObject[$1b4163b1766a770b$var$customThemeOptions] = JSON.parse(id);
        } catch (e) {
            new Error('Invalid custom theme string');
        }
        return themeObject;
    }, {});
};
const $1b4163b1766a770b$export$62c37ab81302621a = (themeState)=>Object.entries(themeState).reduce((themeString, [kind, id])=>{
        if (// colorMode theme state
        kind === 'colorMode' && typeof id === 'string' && $1b4163b1766a770b$var$isColorMode(id) || // custom theme state
        kind === $1b4163b1766a770b$var$customThemeOptions && typeof id === 'object' || // other theme states
        $1b4163b1766a770b$var$isThemeKind(kind) && typeof id === 'string' && $1b4163b1766a770b$var$isThemeIds(id)) return themeString + `${themeString ? ' ' : ''}` + `${kind}:${typeof id === 'object' ? JSON.stringify(id) : id}`;
        return themeString;
    }, '');

});


parcelRegister("cHqPT", function(module, exports) {

$parcel$export(module.exports, "default", () => $93ee51407198d51a$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $axYky = parcelRequire("axYky");

var $k6OHd = parcelRequire("k6OHd");
class $93ee51407198d51a$export$2e2bcd8739ae039 {
    constructor(callback){
        (0, $5zQU9.default)(this, "legacyObserver", null);
        this.callback = callback;
        $93ee51407198d51a$export$2e2bcd8739ae039.callbacks.add(callback);
    }
    observe() {
        if (!$93ee51407198d51a$export$2e2bcd8739ae039.observer) {
            $93ee51407198d51a$export$2e2bcd8739ae039.observer = new MutationObserver(()=>{
                const theme = (0, $k6OHd.default)();
                $93ee51407198d51a$export$2e2bcd8739ae039.callbacks.forEach((callback)=>callback(theme));
            });
            // Observer only needs to be configured once
            $93ee51407198d51a$export$2e2bcd8739ae039.observer.observe(document.documentElement, {
                attributeFilter: [
                    (0, $axYky.THEME_DATA_ATTRIBUTE),
                    (0, $axYky.COLOR_MODE_ATTRIBUTE)
                ]
            });
        }
    }
    disconnect() {
        if (this.callback) $93ee51407198d51a$export$2e2bcd8739ae039.callbacks.delete(this.callback);
        if ($93ee51407198d51a$export$2e2bcd8739ae039.callbacks.size === 0 && $93ee51407198d51a$export$2e2bcd8739ae039.observer) {
            $93ee51407198d51a$export$2e2bcd8739ae039.observer.disconnect();
            $93ee51407198d51a$export$2e2bcd8739ae039.observer = null;
        }
    }
}
(0, $5zQU9.default)($93ee51407198d51a$export$2e2bcd8739ae039, "observer", null);
(0, $5zQU9.default)($93ee51407198d51a$export$2e2bcd8739ae039, "callbacks", new Set());

});



parcelRegister("k5pOx", function(module, exports) {
module.exports = new URL("icon-default-grey.2a68d370.png", import.meta.url).toString();

});




parcelRegister("kLILm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f1eaeb666c71200e$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $ivTMz = parcelRequire("ivTMz");
var $62HOr = parcelRequire("62HOr");

var $j0gMm = parcelRequire("j0gMm");

var $hvUUg = parcelRequire("hvUUg");
var $lgRZl = parcelRequire("lgRZl");
var $Lig7B = parcelRequire("Lig7B");
var $hxCMl = parcelRequire("hxCMl");

var $inwKI = parcelRequire("inwKI");

var $3ihpf = parcelRequire("3ihpf");
var $5YcrV = parcelRequire("5YcrV");
var $8xfj9 = parcelRequire("8xfj9");

var $hgNMk = parcelRequire("hgNMk");

var $1Qivz = parcelRequire("1Qivz");
parcelRequire("eUqFw");

var $6jEcw = parcelRequire("6jEcw");

var $90ON9 = parcelRequire("90ON9");

var $23J4Z = parcelRequire("23J4Z");

var $2AdLY = parcelRequire("2AdLY");

var $k5pOx = parcelRequire("k5pOx");

var $lHkHI = parcelRequire("lHkHI");
function $f1eaeb666c71200e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f1eaeb666c71200e$var$SmallHitContainer = (0, $3UXZ8.default)("div", {
    target: "e1xfsn510",
    label: "SmallHitContainer"
})({
    name: "ud5h78",
    styles: "margin-bottom:var(--ds-space-250, 20px);"
});
const $f1eaeb666c71200e$var$SmallHitStyled = (0, $3UXZ8.default)("div", {
    target: "e1xfsn511",
    label: "SmallHitStyled"
})("cursor:pointer;border-radius:", (0, $ivTMz.borderRadius)(), "px;padding:var(--ds-space-025, 2px);text-decoration:none;background:", (0, $j0gMm.N0), ";padding:var(--ds-space-150, 12px) var(--ds-space-150, 12px) var(--ds-space-025, 2px) var(--ds-space-150, 12px);transition:box-shadow 0.1s;&:hover{", (0, $62HOr).e300(), "}");
const $f1eaeb666c71200e$var$HitLinkStyled = /*#__PURE__*/ (0, $3UXZ8.default)((0, $2AdLY.default), {
    target: "e1xfsn512",
    label: "HitLinkStyled"
})({
    name: "123c98n",
    styles: "text-decoration:none;&:hover,&:focus,&:-webkit-any-link{text-decoration:none;}"
});
const $f1eaeb666c71200e$var$SmallHitContent = (0, $3UXZ8.default)("div", {
    target: "e1xfsn513",
    label: "SmallHitContent"
})({
    name: "1xfbt88",
    styles: "display:flex;min-height:74px;"
});
const $f1eaeb666c71200e$var$LogoImage = (0, $3UXZ8.default)("img", {
    target: "e1xfsn514",
    label: "LogoImage"
})({
    name: "fxzd9f",
    styles: "width:46px;height:46px;&:hover{cursor:pointer;}"
});
const $f1eaeb666c71200e$var$SmallHitLogo = (0, $3UXZ8.default)("div", {
    target: "e1xfsn515",
    label: "SmallHitLogo"
})("display:flex;flex:0 0 auto;margin:0 var(--ds-space-100, 8px) 0 0;position:relative;width:46px;height:46px;& ", $f1eaeb666c71200e$var$LogoImage, "{box-sizing:content-box;}");
const $f1eaeb666c71200e$var$CloudSecurityParticipantIconStyled = /*#__PURE__*/ (0, $3UXZ8.default)((0, $3ihpf.default), {
    target: "e1xfsn516",
    label: "CloudSecurityParticipantIconStyled"
})({
    name: "12ld2x7",
    styles: "z-index:10;width:14px;height:16px;"
});
const $f1eaeb666c71200e$var$CertificationContainer = (0, $3UXZ8.default)("div", {
    target: "e1xfsn517",
    label: "CertificationContainer"
})({
    name: "hk313c",
    styles: "display:flex;flex-direction:row;align-items:center;margin-bottom:3px;"
});
const $f1eaeb666c71200e$var$SmallHitDetailsContainer = (0, $3UXZ8.default)("div", {
    target: "e1xfsn518",
    label: "SmallHitDetailsContainer"
})({
    name: "18yctn0",
    styles: "display:flex;flex:0 1 auto;margin-left:5px;min-width:0;"
});
const $f1eaeb666c71200e$var$SmallHitDetails = (0, $3UXZ8.default)("div", {
    target: "e1xfsn519",
    label: "SmallHitDetails"
})({
    name: "1b4gndf",
    styles: "display:flex;flex-direction:column;margin-bottom:auto;min-width:1px;"
});
const $f1eaeb666c71200e$var$SmallHitHeading = (0, $3UXZ8.default)("div", {
    target: "e1xfsn5110",
    label: "SmallHitHeading"
})((0, $hvUUg.CharlieFontFamily), ";font-weight:600;font-size:16px;line-height:1.2;flex:1 0 auto;max-height:46px;overflow:hidden;margin-bottom:5px;");
const $f1eaeb666c71200e$var$SmallHitCategories = (0, $3UXZ8.default)("div", {
    target: "e1xfsn5111",
    label: "SmallHitCategories"
})({
    name: "1tu59u4",
    styles: "flex:0 0 auto;"
});
const $f1eaeb666c71200e$var$SmallHitVendorStyled = (0, $3UXZ8.default)("div", {
    target: "e1xfsn5112",
    label: "SmallHitVendorStyled"
})("height:22px;font-size:13px;color:", (0, $j0gMm.N100), ";");
const $f1eaeb666c71200e$var$SmallHitRatings = (0, $3UXZ8.default)("div", {
    target: "e1xfsn5113",
    label: "SmallHitRatings"
})({
    name: "1tu59u4",
    styles: "flex:0 0 auto;"
});
const $f1eaeb666c71200e$var$CertificationTitle = (0, $3UXZ8.default)("span", {
    target: "e1xfsn5114",
    label: "CertificationTitle"
})((0, $hvUUg.CharlieFontFamily), " font-size:14px;line-height:1;text-transform:uppercase;color:", (0, $j0gMm.N600), ";margin-left:var(--ds-space-025, 2px);");
const $f1eaeb666c71200e$var$CloudFortifiedIconStyled = /*#__PURE__*/ (0, $3UXZ8.default)((0, $5YcrV.default), {
    target: "e1xfsn5115",
    label: "CloudFortifiedIconStyled"
})({
    name: "3o0h5k",
    styles: "width:16px;height:16px;"
});
function $f1eaeb666c71200e$export$2e2bcd8739ae039(props) {
    const { replaceCategoriesOnAppTilesWithVendorName: replaceCategoriesOnAppTilesWithVendorName } = (0, $inwKI.useFeatureFlags)();
    const certificationBadge = (hasCloudSecurityBadge, hasCloudFortifiedBadge)=>{
        if (hasCloudFortifiedBadge) return /*#__PURE__*/ (0, $lHkHI.jsxs)($f1eaeb666c71200e$var$CertificationContainer, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($f1eaeb666c71200e$var$CloudFortifiedIconStyled, {
                    showLabel: false
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($f1eaeb666c71200e$var$CertificationTitle, {
                    children: "Cloud Fortified"
                })
            ]
        });
        if (hasCloudSecurityBadge) return /*#__PURE__*/ (0, $lHkHI.jsxs)($f1eaeb666c71200e$var$CertificationContainer, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($f1eaeb666c71200e$var$CloudSecurityParticipantIconStyled, {
                    iconSize: "small"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($f1eaeb666c71200e$var$CertificationTitle, {
                    children: (0, $3ihpf.CLOUD_SECURITY_BADGE_LABEL)
                })
            ]
        });
        return null;
    };
    function renderHitContents() {
        var _props$hit$getIn;
        const logoImage = props.hitContext.get('hitImageHrefResolver')({
            hit: props.hit
        }) || (0, (/*@__PURE__*/$parcel$interopDefault($k5pOx)));
        return /*#__PURE__*/ (0, $lHkHI.jsx)($f1eaeb666c71200e$var$SmallHitStyled, {
            "data-testid": "small-hit",
            children: /*#__PURE__*/ (0, $lHkHI.jsx)($f1eaeb666c71200e$var$HitLinkStyled, {
                fromSearch: props.fromSearch,
                hitContext: props.hitContext,
                hit: props.hit,
                perspective: props.perspective,
                filters: props.filters,
                sectionTitle: props.sectionTitle,
                children: /*#__PURE__*/ (0, $lHkHI.jsxs)($f1eaeb666c71200e$var$SmallHitContent, {
                    title: props.hit.get('name'),
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)($f1eaeb666c71200e$var$SmallHitLogo, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)($f1eaeb666c71200e$var$LogoImage, {
                                loading: "lazy",
                                src: logoImage,
                                alt: props.hit.get('name')
                            })
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)($f1eaeb666c71200e$var$SmallHitDetailsContainer, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsxs)($f1eaeb666c71200e$var$SmallHitDetails, {
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsx)($f1eaeb666c71200e$var$SmallHitHeading, {
                                        children: props.screenClass === 'xs' ? props.hit.get('name') : (0, $hgNMk.trimAfter)(props.hit.get('name'), 42)
                                    }),
                                    certificationBadge(props.hasCloudSecurityBadge, props.hasCloudFortifiedBadge),
                                    replaceCategoriesOnAppTilesWithVendorName ? props.hit.get('vendor') && /*#__PURE__*/ (0, $lHkHI.jsx)($f1eaeb666c71200e$var$SmallHitVendorStyled, {
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8xfj9.default), {
                                            name: props.hit.getIn([
                                                'vendor',
                                                'name'
                                            ]),
                                            partnerTierType: (_props$hit$getIn = props.hit.getIn([
                                                'vendor',
                                                'partnerTier',
                                                'type'
                                            ])) === null || _props$hit$getIn === void 0 ? void 0 : _props$hit$getIn.toUpperCase()
                                        })
                                    }) : props.hit.get('categories') && props.hit.get('categories').size > 0 ? /*#__PURE__*/ (0, $lHkHI.jsx)($f1eaeb666c71200e$var$SmallHitCategories, {
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $23J4Z.default), {
                                            categories: props.hit.get('categories')
                                        })
                                    }) : null,
                                    /*#__PURE__*/ (0, $lHkHI.jsx)($f1eaeb666c71200e$var$SmallHitRatings, {
                                        children: props.hit.get('ratings') ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $Lig7B.default), {
                                            ratings: props.hit.get('ratings').toJS(),
                                            showRatingCount: false,
                                            numericRatingStyles: {
                                                fontSize: 13,
                                                avgNumFontSize: 13
                                            }
                                        }) : undefined
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        });
    }
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hxCMl.default), {
        xl: props.colSpan.getIn([
            'smallHits',
            'xl'
        ]) || 4,
        lg: props.colSpan.getIn([
            'smallHits',
            'lg'
        ]) || 4,
        md: props.colSpan.getIn([
            'smallHits',
            'md'
        ]) || 4,
        sm: props.colSpan.getIn([
            'smallHits',
            'sm'
        ]) || 12,
        xs: props.colSpan.getIn([
            'smallHits',
            'xs'
        ]) || 12,
        gutterWidth: 20,
        screenClass: props.screenClass,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)($f1eaeb666c71200e$var$SmallHitContainer, {
            children: props.contentOverride || renderHitContents()
        })
    });
}
$f1eaeb666c71200e$export$2e2bcd8739ae039.propTypes = {
    colSpan: (0, $90ON9.default).colSpan,
    contentOverride: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    fromSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    hit: (0, $lgRZl.default).requiredIf((0, $90ON9.default).hit(), (props)=>!props.contentOverride),
    hitContext: (0, $lgRZl.default).requiredIf((0, $90ON9.default).hitContext, (props)=>!props.contentOverride),
    perspective: (0, $6jEcw.default).perspective,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    hasCloudSecurityBadge: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    hasCloudFortifiedBadge: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    filters: (0, $90ON9.default).filters,
    sectionTitle: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string
};

});
parcelRegister("hgNMk", function(module, exports) {

$parcel$export(module.exports, "trimAfter", () => $c92a8b3e8a1db66c$export$6069abcbf3229af7);
$parcel$export(module.exports, "pluralize", () => $c92a8b3e8a1db66c$export$cefb40c9962541b5);
$parcel$export(module.exports, "tryParseJSON", () => $c92a8b3e8a1db66c$export$a011e92e61f46a0f);
$parcel$export(module.exports, "removeDuplicates", () => $c92a8b3e8a1db66c$export$2e2262a44ac61957);
const $c92a8b3e8a1db66c$export$6069abcbf3229af7 = (str, threshold)=>str.length > threshold ? "".concat(str.substring(0, threshold), "...") : str;
const $c92a8b3e8a1db66c$export$cefb40c9962541b5 = (word, count, inclusive, pluralWord)=>{
    const finalPluralWord = pluralWord ? pluralWord : "".concat(word, "s");
    const finalWord = count === 1 ? word : finalPluralWord;
    return inclusive ? "".concat(count, " ").concat(finalWord) : finalWord;
};
function $c92a8b3e8a1db66c$export$a011e92e61f46a0f(maybeJSON) {
    if (typeof maybeJSON !== 'string') return {
        success: false,
        result: null
    };
    try {
        const json = JSON.parse(maybeJSON);
        return {
            success: true,
            result: json
        };
    } catch (_unused) {
        return {
            success: false,
            result: null
        };
    }
}
const $c92a8b3e8a1db66c$export$2e2262a44ac61957 = (arr)=>{
    return arr.filter((item, index)=>arr.indexOf(item) === index);
};
const $c92a8b3e8a1db66c$export$ee5543708084e0d = (str)=>{
    return str.trim().toLowerCase().replace(/([^A-Z0-9]+)(.)/gi, // match multiple non-letter/numbers followed by any character
    function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return args[2].toUpperCase(); //3rd index is the character we need to transform uppercase
    });
};

});







parcelRegister("cAD4n", function(module, exports) {

$parcel$export(module.exports, "default", () => $92a727381507be3a$export$2e2bcd8739ae039);

var $biTOe = parcelRequire("biTOe");
parcelRequire("eUqFw");

var $b2B2X = parcelRequire("b2B2X");

var $e1Mnq = parcelRequire("e1Mnq");

var $lHkHI = parcelRequire("lHkHI");
const $92a727381507be3a$var$HeroWrapper = (props)=>{
    const Hero = props.heroComponent;
    return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $e1Mnq.default), {
            filters: props.filters,
            searchComponent: Hero,
            extraProps: {
                discoverHeading: (0, $b2B2X.resolveDiscoverHeadingText)({
                    filters: props.filters,
                    featureFlags: {}
                }),
                filters: props.filters
            },
            perspective: props.perspective,
            stateChangeRequested: props.stateChangeRequested
        })
    });
};
var $92a727381507be3a$export$2e2bcd8739ae039 = (0, $biTOe.withFeatureFlags)($92a727381507be3a$var$HeroWrapper);

});

parcelRegister("8xLRx", function(module, exports) {

$parcel$export(module.exports, "default", () => $6386884d949a9f7c$export$2e2bcd8739ae039);

var $2zTU0 = parcelRequire("2zTU0");
var $6386884d949a9f7c$export$2e2bcd8739ae039 = (0, $2zTU0.default);

});
parcelRegister("2zTU0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e0a36aea8b75f5d$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $fyH4h = parcelRequire("fyH4h");

var $biTOe = parcelRequire("biTOe");
var $9l6Pq = parcelRequire("9l6Pq");

var $fUOHe = parcelRequire("fUOHe");

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $3qG4B = parcelRequire("3qG4B");

var $90ON9 = parcelRequire("90ON9");


var $6jEcw = parcelRequire("6jEcw");

var $6SyGj = parcelRequire("6SyGj");

var $fiHJG = parcelRequire("fiHJG");

var $lHkHI = parcelRequire("lHkHI");
function $1e0a36aea8b75f5d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1e0a36aea8b75f5d$var$SearchContentWrapper = (0, $3UXZ8.default)("div", {
    target: "e108fsba0",
    label: "SearchContentWrapper"
})({
    name: "odz94x",
    styles: "margin-top:5px;"
});
// TODO MC-3162 Add types for SearchProps to match Search.propTypes
class $1e0a36aea8b75f5d$var$Search extends (0, $eUqFw.Component) {
    constructor(){
        var _this;
        super(...arguments);
        _this = this;
        (0, $5zQU9.default)(this, "onLoadMoreResultsClick", function() {
            _this.transitionStarted();
            _this.props.onLoadMoreResultsClick(...arguments);
        });
    }
    componentDidMount() {
        (0, $fUOHe.default).timeToFirstMeaningfulPaint(performance.now());
        this.doFreshSearch({
            filters: this.props.filters
        });
    }
    componentDidUpdate(prevProps) {
        if (!this.props.filters.equals(prevProps.filters)) this.doFreshSearch({
            filters: this.props.filters
        });
        if (this.props.transitions && this.props.transitions.get('transitionStarted') && prevProps.search.get('searchInProgress') && !this.props.search.get('searchInProgress') && this.props.transitions.get('transitionCompleted')) this.props.transitions.get('transitionCompleted')();
    }
    doFreshSearch(_ref) {
        let { filters: filters } = _ref;
        const { enableV2SearchIndex: enableV2SearchIndex } = this.props;
        const showCompassApps = this.props.statsigClient.showCompassApps();
        this.transitionStarted();
        this.props.doFreshSearch({
            filters: filters,
            featureFlags: {
                enableV2SearchIndex: enableV2SearchIndex,
                showCompassApps: !!showCompassApps
            }
        });
    }
    transitionStarted() {
        if (this.props.transitions && this.props.transitions.get('transitionStarted')) this.props.transitions.get('transitionStarted')();
    }
    render() {
        const searchInitialized = this.props.search.get('initialized');
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fyH4h.default), {
            baseMessage: "Oops! Looks like something went wrong.",
            dataError: !searchInitialized && this.props.search.get('dataError'),
            dataErrorMessages: this.props.search.get('dataErrorMessages'),
            loading: !this.props.search.get('dataError') && !searchInitialized,
            optimisticLoadTime: 1000,
            children: searchInitialized ? /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fiHJG.default), {
                        showBrowseHeading: this.props.showBrowseHeading,
                        filters: this.props.filters,
                        hiddenFilters: this.props.hiddenFilters,
                        numberOfHits: this.props.search.getIn([
                            'searchResults',
                            'numberOfHits'
                        ]),
                        screenClass: this.props.screenClass,
                        stateChangeRequested: this.props.stateChangeRequested
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6SyGj.default), {
                        topPanel: this.props.topPanel
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($1e0a36aea8b75f5d$var$SearchContentWrapper, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3qG4B.default), {
                            colSpan: this.props.colSpan,
                            currentPage: this.props.search.get('currentPage'),
                            dataError: this.props.search.get('dataError'),
                            dataErrorMessages: this.props.search.get('dataErrorMessages'),
                            contentOverrides: this.props.contentOverrides,
                            hitContext: this.props.hitContext,
                            hits: this.props.search.getIn([
                                'searchResults',
                                'hits'
                            ]),
                            loading: this.props.search.get('loadingFreshSearchResults'),
                            loadingMoreResults: this.props.search.get('loadingMoreResults'),
                            moreResultsDataError: this.props.search.get('moreResultsDataError'),
                            moreResultsDataErrorMessages: this.props.search.get('moreResultsDataErrorMessages'),
                            numberOfPages: this.props.search.getIn([
                                'searchResults',
                                'numberOfPages'
                            ]),
                            onHitCategoryClick: this.props.onHitCategoryClick,
                            onLoadMoreResultsClick: this.onLoadMoreResultsClick,
                            perspective: (0, $37a31921fd56c86d$export$a6b9aaee40d49fd0),
                            screenClass: this.props.screenClass,
                            searchId: this.props.search.get('currentSearchId'),
                            stateChangeRequested: this.props.stateChangeRequested,
                            overrideLargeHitRightContent: this.props.overrideLargeHitRightContent,
                            filters: this.props.filters
                        })
                    })
                ]
            }) : undefined
        });
    }
}
$1e0a36aea8b75f5d$var$Search.propTypes = {
    colSpan: (0, $90ON9.default).colSpan.isRequired,
    contentOverrides: (0, $90ON9.default).contentOverrides,
    doFreshSearch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    filters: (0, $90ON9.default).filters.isRequired,
    hiddenFilters: (0, $6jEcw.default).hiddenFilters.isRequired,
    hitContext: (0, $90ON9.default).hitContext,
    onHitCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    onLoadMoreResultsClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    search: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
        currentPage: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
        dataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
        dataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
        loadingFreshSearchResults: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
        moreResultsDataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
        moreResultsDataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
        searchResults: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).contains({
            searchId: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
            facets: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list,
            hits: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list,
            numberOfPages: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
        }),
        initialized: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
        searchInProgress: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired
    }).isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    topPanel: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    transitions: (0, $90ON9.default).transitions,
    overrideLargeHitRightContent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    showBrowseHeading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool
};
var $1e0a36aea8b75f5d$export$2e2bcd8739ae039 = (0, $biTOe.withFeatureFlags)((0, $9l6Pq.withStatsig)($1e0a36aea8b75f5d$var$Search));

});
parcelRegister("3qG4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $27f46fa8c3f90cb8$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $gqYUo = parcelRequire("gqYUo");

var $fyH4h = parcelRequire("fyH4h");
var $czlCy = parcelRequire("czlCy");
var $lgRZl = parcelRequire("lgRZl");

var $9osuT = parcelRequire("9osuT");

var $biTOe = parcelRequire("biTOe");
var $9l6Pq = parcelRequire("9l6Pq");

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $5YKni = parcelRequire("5YKni");


var $6jEcw = parcelRequire("6jEcw");

var $90ON9 = parcelRequire("90ON9");

var $2Ywog = parcelRequire("2Ywog");

var $lHkHI = parcelRequire("lHkHI");
function $27f46fa8c3f90cb8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $27f46fa8c3f90cb8$var$PaginationStyled = (0, $3UXZ8.default)("div", {
    target: "eglpq9d0",
    label: "PaginationStyled"
})({
    name: "gt4wuf",
    styles: "margin-top:var(--ds-space-250, 20px);"
});
function $27f46fa8c3f90cb8$var$isLoading(props) {
    return !props.dataError && props.loading;
}
class $27f46fa8c3f90cb8$var$SearchResults extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onLoadMoreResultsClick", ()=>{
            const showCompassApps = this.props.statsigClient.showCompassApps();
            this.props.onLoadMoreResultsClick({
                currentPage: this.props.currentPage,
                featureFlags: {
                    enableV2SearchIndex: !!this.props.enableV2SearchIndex,
                    showCompassApps: !!showCompassApps
                }
            });
            this.props.fireAnalyticsEvent({
                eventType: (0, $5YKni.ButtonClickedEvent),
                actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_SEARCH_RESULTS_LOAD_MORE_BUTTON),
                source: (0, $5YKni.EVENT_SOURCE),
                attributes: {
                    currentPage: this.props.currentPage + '',
                    currentPerspective: (0, $37a31921fd56c86d$export$a6b9aaee40d49fd0)
                }
            }, (0, $5YKni.EVENT_CHANNEL));
        });
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fyH4h.default), {
            baseMessage: "Oops! Looks like something went wrong.",
            dataError: this.props.dataError,
            dataErrorMessages: this.props.dataErrorMessages,
            loading: $27f46fa8c3f90cb8$var$isLoading(this.props),
            optimisticLoadTime: 1000,
            children: /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    this.props.contentOverrides || this.props.hits && !this.props.hits.isEmpty() ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2Ywog.default), {
                        colSpan: this.props.colSpan,
                        contentOverrides: this.props.contentOverrides,
                        fromSearch: true,
                        hitContext: this.props.hitContext,
                        hits: this.props.hits,
                        hitSize: this.props.hitSize,
                        maxLength: this.props.maxLength,
                        onCategoryClick: this.props.onHitCategoryClick,
                        perspective: this.props.perspective,
                        screenClass: this.props.screenClass,
                        searchId: this.props.searchId,
                        stateChangeRequested: this.props.stateChangeRequested,
                        overrideLargeHitRightContent: this.props.overrideLargeHitRightContent,
                        filters: this.props.filters
                    }) : /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                                children: "Sorry! We didn't find any matching apps."
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                                        children: "Did you know that you can build your own apps? Find out how at "
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gqYUo.default), {
                                        href: "https://developer.atlassian.com",
                                        rel: "noopener noreferrer",
                                        target: "_blank",
                                        children: "https://developer.atlassian.com"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    }),
                    !this.props.hidePagination && this.props.numberOfPages - 1 > this.props.currentPage ? /*#__PURE__*/ (0, $lHkHI.jsx)($27f46fa8c3f90cb8$var$PaginationStyled, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $czlCy.default), {
                            loadingMoreResults: this.props.loadingMoreResults,
                            moreResultsDataError: this.props.moreResultsDataError,
                            moreResultsDataErrorMessages: this.props.moreResultsDataErrorMessages,
                            onLoadMoreResultsClick: this.onLoadMoreResultsClick
                        })
                    }) : undefined
                ]
            })
        });
    }
}
(0, $5zQU9.default)($27f46fa8c3f90cb8$var$SearchResults, "propTypes", {
    colSpan: (0, $90ON9.default).colSpan.isRequired,
    contentOverrides: (0, $90ON9.default).contentOverrides,
    fireAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    currentPage: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number, (props)=>!$27f46fa8c3f90cb8$var$isLoading(props)),
    dataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    dataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
    hidePagination: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    hitContext: (0, $90ON9.default).hitContext,
    hitSize: (0, $90ON9.default).hitSize,
    hits: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, $90ON9.default).hit()),
    loading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    loadingMoreResults: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    maxLength: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    moreResultsDataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    moreResultsDataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
    numberOfPages: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number, (props)=>!$27f46fa8c3f90cb8$var$isLoading(props)),
    onHitCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    onLoadMoreResultsClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    perspective: (0, $6jEcw.default).perspective.isRequired,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    searchId: (0, $lgRZl.default).requiredIf((0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number, (props)=>!$27f46fa8c3f90cb8$var$isLoading(props)),
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    overrideLargeHitRightContent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    filters: (0, $90ON9.default).filters,
    enableV2SearchIndex: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool
});
(0, $5zQU9.default)($27f46fa8c3f90cb8$var$SearchResults, "defaultProps", {
    hidePagination: false,
    hitSize: 'large'
});
var $27f46fa8c3f90cb8$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)((0, $biTOe.withFeatureFlags)((0, $9l6Pq.withStatsig)($27f46fa8c3f90cb8$var$SearchResults)));

});
parcelRegister("czlCy", function(module, exports) {

$parcel$export(module.exports, "default", () => $9269865f7dc51cbb$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $8VfNq = parcelRequire("8VfNq");

var $fEeDC = parcelRequire("fEeDC");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $kU8RF = parcelRequire("kU8RF");

var $lHkHI = parcelRequire("lHkHI");
function $9269865f7dc51cbb$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9269865f7dc51cbb$var$ErrorWrapper = (0, $3UXZ8.default)("div", {
    target: "e19hyeel0",
    label: "ErrorWrapper"
})({
    name: "nel67k",
    styles: "display:flex;justify-content:center;margin-bottom:10px;"
});
const $9269865f7dc51cbb$var$ButtonWrapper = (0, $3UXZ8.default)("div", {
    target: "e19hyeel1",
    label: "ButtonWrapper"
})({
    name: "1iahunv",
    styles: "display:flex;justify-content:center;height:45px;"
});
const $9269865f7dc51cbb$export$378165210bc6a84a = (0, $3UXZ8.default)("div", {
    target: "e19hyeel2",
    label: "AkButtonWrapper"
})({
    name: "1l4w6pd",
    styles: "display:flex;justify-content:center;"
});
function $9269865f7dc51cbb$var$resolveErrorMessage(_ref) {
    let { dataErrorMessages: dataErrorMessages } = _ref;
    return "Oops! Looks like something went wrong - ".concat(dataErrorMessages.map((e)=>e.get('message')).join(', '), ". Try again.");
}
class $9269865f7dc51cbb$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
            children: [
                this.props.moreResultsDataError ? /*#__PURE__*/ (0, $lHkHI.jsx)($9269865f7dc51cbb$var$ErrorWrapper, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8VfNq.default), {
                        appearance: "warning",
                        children: $9269865f7dc51cbb$var$resolveErrorMessage({
                            dataErrorMessages: this.props.moreResultsDataErrorMessages
                        })
                    })
                }) : undefined,
                /*#__PURE__*/ (0, $lHkHI.jsx)($9269865f7dc51cbb$var$ButtonWrapper, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kU8RF.default), {
                        active: this.props.loadingMoreResults,
                        size: 20,
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)($9269865f7dc51cbb$export$378165210bc6a84a, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                                appearance: this.props.appearance,
                                onClick: this.props.onLoadMoreResultsClick,
                                children: "More results"
                            })
                        })
                    })
                })
            ]
        });
    }
}
(0, $5zQU9.default)($9269865f7dc51cbb$export$2e2bcd8739ae039, "propTypes", {
    appearance: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    loadingMoreResults: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    moreResultsDataError: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    moreResultsDataErrorMessages: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).list.isRequired,
    onLoadMoreResultsClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});
(0, $5zQU9.default)($9269865f7dc51cbb$export$2e2bcd8739ae039, "defaultProps", {
    appearance: 'primary'
});

});


parcelRegister("fiHJG", function(module, exports) {

$parcel$export(module.exports, "default", () => $b23a767cd5965a9d$export$2e2bcd8739ae039);

var $2fmDN = parcelRequire("2fmDN");
var $b23a767cd5965a9d$export$2e2bcd8739ae039 = (0, $2fmDN.default);

});
parcelRegister("2fmDN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a2e8b816affe4bc$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $8gcXz = parcelRequire("8gcXz");
var $f7YGc = parcelRequire("f7YGc");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $6jEcw = parcelRequire("6jEcw");

var $5Hzwh = parcelRequire("5Hzwh");

var $lHkHI = parcelRequire("lHkHI");
function $1a2e8b816affe4bc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1a2e8b816affe4bc$var$StatsContainer = (0, $3UXZ8.default)("div", {
    target: "ek7pc810",
    label: "StatsContainer"
})({
    name: "1rv0z2d",
    styles: "margin-top:10px;margin-bottom:var(--ds-space-250, 20px);padding-left:10px;"
});
const $1a2e8b816affe4bc$var$BrowseHeading = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H4), {
    target: "ek7pc811",
    label: "BrowseHeading"
})({
    name: "1llei53",
    styles: "font-weight:normal;padding:var(--ds-space-250, 20px) 10px;"
});
class $1a2e8b816affe4bc$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    getFormattedNumberOfHits() {
        const { numberOfHits: numberOfHits } = this.props;
        if (numberOfHits <= 1000) return (0, $f7YGc).longFormat(numberOfHits);
        return 'Over 1,000';
    }
    render() {
        if (this.props.showBrowseHeading) {
            const hits = this.getFormattedNumberOfHits();
            return /*#__PURE__*/ (0, $lHkHI.jsx)($1a2e8b816affe4bc$var$BrowseHeading, {
                children: "Browse ".concat(hits, " apps")
            });
        }
        return /*#__PURE__*/ (0, $lHkHI.jsx)($1a2e8b816affe4bc$var$StatsContainer, {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5Hzwh.default), {
                filters: this.props.filters,
                hiddenFilters: this.props.hiddenFilters,
                numberOfHits: this.props.numberOfHits,
                screenClass: this.props.screenClass,
                stateChangeRequested: this.props.stateChangeRequested
            })
        });
    }
}
(0, $5zQU9.default)($1a2e8b816affe4bc$export$2e2bcd8739ae039, "propTypes", {
    filters: (0, $90ON9.default).filters.isRequired,
    hiddenFilters: (0, $6jEcw.default).hiddenFilters.isRequired,
    numberOfHits: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    showBrowseHeading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool
});

});
parcelRegister("5Hzwh", function(module, exports) {

$parcel$export(module.exports, "default", () => $426c855f5d3ee451$export$2e2bcd8739ae039);

var $byH5f = parcelRequire("byH5f");
var $426c855f5d3ee451$export$2e2bcd8739ae039 = (0, $byH5f.default);

});
parcelRegister("byH5f", function(module, exports) {

$parcel$export(module.exports, "default", () => $86a44a2c84304adb$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $90ON9 = parcelRequire("90ON9");

var $6jEcw = parcelRequire("6jEcw");

var $edPBA = parcelRequire("edPBA");

var $c7JEu = parcelRequire("c7JEu");

var $lHkHI = parcelRequire("lHkHI");
class $86a44a2c84304adb$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const mediumScreenClass = this.props.screenClass === 'md';
        return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $c7JEu.default), {
                    filters: this.props.filters,
                    numberOfHits: this.props.numberOfHits
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                    children: " "
                }),
                !mediumScreenClass && /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $edPBA.default), {
                        filters: this.props.filters,
                        hiddenFilters: this.props.hiddenFilters,
                        stateChangeRequested: this.props.stateChangeRequested
                    })
                })
            ]
        });
    }
}
(0, $5zQU9.default)($86a44a2c84304adb$export$2e2bcd8739ae039, "propTypes", {
    filters: (0, $90ON9.default).filters.isRequired,
    hiddenFilters: (0, $6jEcw.default).hiddenFilters.isRequired,
    numberOfHits: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired,
    screenClass: (0, $90ON9.default).screenClass.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});

});
parcelRegister("edPBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $a5aa4f558a6d8f16$export$2e2bcd8739ae039);

var $03ZzC = parcelRequire("03ZzC");
var $a5aa4f558a6d8f16$export$2e2bcd8739ae039 = (0, $03ZzC.default);

});
parcelRegister("03ZzC", function(module, exports) {

$parcel$export(module.exports, "default", () => $00c00b20953292e6$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $fCICH = parcelRequire("fCICH");

var $90ON9 = parcelRequire("90ON9");

var $isqrX = parcelRequire("isqrX");

var $6jEcw = parcelRequire("6jEcw");

var $kBTLE = parcelRequire("kBTLE");

var $lHkHI = parcelRequire("lHkHI");
function $00c00b20953292e6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $00c00b20953292e6$export$e0f9e36dd85dd846 = (0, $3UXZ8.default)("span", {
    target: "emri5zd0",
    label: "CurrentFiltersContent"
})({
    name: "v7ibj3",
    styles: "display:inline-block;vertical-align:middle;"
});
function $00c00b20953292e6$var$resolveCurrentFilters(_ref) {
    let { filters: filters, hiddenFilters: hiddenFilters } = _ref;
    return filters.filter((v, key)=>(0, $fCICH.getFilters)().has(key) && (0, $fCICH.getFilters)().get(key).get('displayInCurrent')).entrySeq().flatMap((_ref2)=>{
        let [key, value] = _ref2;
        return (0, $g5DHJ.Iterable).isIterable(value) ? value.toList().map((v)=>(0, $g5DHJ.Map)({
                key: key,
                value: v,
                multi: true
            })) : (0, $g5DHJ.List).of((0, $g5DHJ.Map)({
            key: key,
            value: value,
            multi: false
        }));
    }).filter((cf)=>(0, $isqrX.shouldFacetProductBeShown)(cf.get('key'), cf.get('value'), hiddenFilters)).toList();
}
class $00c00b20953292e6$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            currentFilters: $00c00b20953292e6$var$resolveCurrentFilters({
                filters: this.props.filters,
                hiddenFilters: this.props.hiddenFilters
            })
        });
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        const { filters: filters, hiddenFilters: hiddenFilters } = nextProps;
        const newCurrentFilters = $00c00b20953292e6$var$resolveCurrentFilters({
            filters: filters,
            hiddenFilters: hiddenFilters
        });
        return {
            currentFilters: // This ensures that new filters are always at the end
            prevState.currentFilters.filter((cf)=>newCurrentFilters.contains(cf)).concat(newCurrentFilters.filterNot((ncf)=>prevState.currentFilters.contains(ncf)))
        };
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
            children: [
                this.state.currentFilters.size ? /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                    children: "filtered by "
                }) : undefined,
                /*#__PURE__*/ (0, $lHkHI.jsx)($00c00b20953292e6$export$e0f9e36dd85dd846, {
                    children: this.state.currentFilters.map((cf)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $kBTLE.default), {
                            filters: this.props.filters,
                            filterKey: cf.get('key'),
                            filterValue: cf.get('value'),
                            multi: cf.get('multi'),
                            stateChangeRequested: this.props.stateChangeRequested
                        }, "currentFilter_".concat(cf.get('key'), "_").concat(cf.get('value'))))
                })
            ]
        });
    }
}
(0, $5zQU9.default)($00c00b20953292e6$export$2e2bcd8739ae039, "propTypes", {
    filters: (0, $90ON9.default).filters.isRequired,
    hiddenFilters: (0, $6jEcw.default).hiddenFilters.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});

});
parcelRegister("kBTLE", function(module, exports) {

$parcel$export(module.exports, "default", () => $f01285a652472543$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $59QdN = parcelRequire("59QdN");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $biTOe = parcelRequire("biTOe");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $fCICH = parcelRequire("fCICH");

var $90ON9 = parcelRequire("90ON9");

var $5YKni = parcelRequire("5YKni");


var $lHkHI = parcelRequire("lHkHI");
class $f01285a652472543$var$CurrentFilter extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "removeFilter", ()=>{
            const newFilters = this.props.multi ? this.props.filters.update(this.props.filterKey, (0, $g5DHJ.Set)(), (f)=>f.remove(this.props.filterValue)) : this.props.filters.delete(this.props.filterKey);
            this.props.fireAnalyticsEvent({
                eventType: (0, $gaiog.FilterClickedEvent),
                actionSubjectId: (0, $5YKni.ANALYTICS_SUBJECT_ID_CURRENT_FILTER_X_REMOVE_ICON),
                objectType: (0, $5YKni.OBJECT_TYPE_FILTER),
                objectId: this.props.filterKey,
                source: (0, $5YKni.EVENT_SOURCE),
                attributes: {
                    currentPerspective: (0, $37a31921fd56c86d$export$a6b9aaee40d49fd0),
                    filterValue: this.props.filterValue,
                    selected: false
                }
            }, (0, $5YKni.EVENT_CHANNEL));
            this.props.stateChangeRequested({
                filters: newFilters
            });
            return false;
        });
    }
    render() {
        // Must be wrapped in a span otherwise React invariant violations are thrown in non-Chrome browsers
        // (i.e. those that use the custom element polyfill)
        return /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $59QdN.default), {
                text: this.resolveFilterText(),
                removeButtonLabel: "Remove filter",
                onBeforeRemoveAction: this.removeFilter
            })
        });
    }
    resolveFilterText() {
        const { filterKey: filterKey, filterValue: filterValue } = this.props;
        const filter = (0, $fCICH.getFilters)().get(filterKey);
        return filter.get('resolveCurrentFilterText') ? filter.get('resolveCurrentFilterText')({
            value: filterValue
        }) : filter.get('custom') ? filter.getIn([
            'customFilters',
            this.props.filterValue
        ]).get('label') : this.props.filterValue;
    }
}
(0, $5zQU9.default)($f01285a652472543$var$CurrentFilter, "propTypes", {
    fireAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
    filters: (0, $90ON9.default).filters.isRequired,
    filterKey: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    filterValue: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string.isRequired,
    multi: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    stateChangeRequested: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});
var $f01285a652472543$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)((0, $biTOe.withFeatureFlags)($f01285a652472543$var$CurrentFilter));

});



parcelRegister("c7JEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d398d018264549c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $f7YGc = parcelRequire("f7YGc");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
class $8d398d018264549c$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    getFormattedNumberOfHits() {
        const { numberOfHits: numberOfHits } = this.props;
        if (numberOfHits <= 1000) return (0, $f7YGc).longFormat(numberOfHits);
        return 'Over 1,000';
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                    children: this.getFormattedNumberOfHits()
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                    children: " results"
                })
            ]
        });
    }
}
(0, $5zQU9.default)($8d398d018264549c$export$2e2bcd8739ae039, "propTypes", {
    numberOfHits: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number.isRequired
});

});









parcelRegister("5cT8z", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ca8d7d7c62fbe54$export$2e2bcd8739ae039);

var $8x3tg = parcelRequire("8x3tg");

var $59Tha = parcelRequire("59Tha");

var $9lCOW = parcelRequire("9lCOW");
const $3ca8d7d7c62fbe54$var$store = (0, $8x3tg.combineReducers)({
    perspectives: (0, $59Tha.default),
    searchContainer: (0, $9lCOW.default)
});
var $3ca8d7d7c62fbe54$export$2e2bcd8739ae039 = $3ca8d7d7c62fbe54$var$store;

});
parcelRegister("8x3tg", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.combineReducers = undefined;

var $4mhi4 = parcelRequire("4mhi4");
var $63641912f63d9f10$var$_combineReducers3 = $63641912f63d9f10$var$_interopRequireDefault($4mhi4);
function $63641912f63d9f10$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.combineReducers = $63641912f63d9f10$var$_combineReducers3.default;

});
parcelRegister("4mhi4", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g5DHJ = parcelRequire("g5DHJ");
var $32c6a1030e5b2a5f$var$_immutable2 = $32c6a1030e5b2a5f$var$_interopRequireDefault($g5DHJ);

var $eZN8G = parcelRequire("eZN8G");
function $32c6a1030e5b2a5f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(reducers) {
    var getDefaultState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $32c6a1030e5b2a5f$var$_immutable2.default.Map;
    var reducerKeys = Object.keys(reducers);
    // eslint-disable-next-line space-infix-ops
    return function() {
        var inputState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getDefaultState();
        var action = arguments[1];
        var warningMessage;
        return inputState.withMutations(function(temporaryState) {
            reducerKeys.forEach(function(reducerName) {
                var reducer = reducers[reducerName];
                var currentDomainState = temporaryState.get(reducerName);
                var nextDomainState = reducer(currentDomainState, action);
                (0, $eZN8G.validateNextState)(nextDomainState, reducerName, action);
                temporaryState.set(reducerName, nextDomainState);
            });
        });
    };
};
module.exports = module.exports['default'];

});
parcelRegister("eZN8G", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateNextState = module.exports.getUnexpectedInvocationParameterMessage = module.exports.getStateName = undefined;

var $26hZy = parcelRequire("26hZy");
var $aeace12de0098e50$var$_getStateName3 = $aeace12de0098e50$var$_interopRequireDefault($26hZy);

var $lWF4j = parcelRequire("lWF4j");
var $aeace12de0098e50$var$_getUnexpectedInvocationParameterMessage3 = $aeace12de0098e50$var$_interopRequireDefault($lWF4j);

var $1R4n3 = parcelRequire("1R4n3");
var $aeace12de0098e50$var$_validateNextState3 = $aeace12de0098e50$var$_interopRequireDefault($1R4n3);
function $aeace12de0098e50$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.getStateName = $aeace12de0098e50$var$_getStateName3.default;
module.exports.getUnexpectedInvocationParameterMessage = $aeace12de0098e50$var$_getUnexpectedInvocationParameterMessage3.default;
module.exports.validateNextState = $aeace12de0098e50$var$_validateNextState3.default;

});
parcelRegister("26hZy", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(action) {
    return action && action.type === '@@redux/INIT' ? 'initialState argument passed to createStore' : 'previous state received by the reducer';
};
module.exports = module.exports['default'];

});

parcelRegister("lWF4j", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $g5DHJ = parcelRequire("g5DHJ");
var $041f773629ff88b2$var$_immutable2 = $041f773629ff88b2$var$_interopRequireDefault($g5DHJ);

var $26hZy = parcelRequire("26hZy");
var $041f773629ff88b2$var$_getStateName2 = $041f773629ff88b2$var$_interopRequireDefault($26hZy);
function $041f773629ff88b2$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
module.exports.default = function(state, reducers, action) {
    var reducerNames = Object.keys(reducers);
    if (!reducerNames.length) return 'Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.';
    var stateName = (0, $041f773629ff88b2$var$_getStateName2.default)(action);
    if ($041f773629ff88b2$var$_immutable2.default.isImmutable ? !$041f773629ff88b2$var$_immutable2.default.isImmutable(state) : !$041f773629ff88b2$var$_immutable2.default.Iterable.isIterable(state)) return 'The ' + stateName + ' is of unexpected type. Expected argument to be an instance of Immutable.Collection or Immutable.Record with the following properties: "' + reducerNames.join('", "') + '".';
    var unexpectedStatePropertyNames = state.toSeq().keySeq().toArray().filter(function(name) {
        return !reducers.hasOwnProperty(name);
    });
    if (unexpectedStatePropertyNames.length > 0) return 'Unexpected ' + (unexpectedStatePropertyNames.length === 1 ? 'property' : 'properties') + ' "' + unexpectedStatePropertyNames.join('", "') + '" found in ' + stateName + '. Expected to find one of the known reducer property names instead: "' + reducerNames.join('", "') + '". Unexpected properties will be ignored.';
    return null;
};
module.exports = module.exports['default'];

});

parcelRegister("1R4n3", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = function(nextState, reducerName, action) {
    // eslint-disable-next-line no-undefined
    if (nextState === undefined) throw new Error('Reducer "' + reducerName + '" returned undefined when handling "' + action.type + '" action. To ignore an action, you must explicitly return the previous state.');
};
module.exports = module.exports['default'];

});




parcelRegister("59Tha", function(module, exports) {

$parcel$export(module.exports, "default", () => $3c18abaad2ea06fd$export$2e2bcd8739ae039);

var $8x3tg = parcelRequire("8x3tg");

var $ayd98 = parcelRequire("ayd98");

var $gT0k8 = parcelRequire("gT0k8");
const $3c18abaad2ea06fd$var$store = (0, $8x3tg.combineReducers)({
    discover: (0, $gT0k8.default),
    search: (0, $ayd98.default)
});
var $3c18abaad2ea06fd$export$2e2bcd8739ae039 = $3c18abaad2ea06fd$var$store;

});
parcelRegister("ayd98", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ae746ebfd9b4a1d$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $408r2 = parcelRequire("408r2");

var $kKkev = parcelRequire("kKkev");
const $7ae746ebfd9b4a1d$var$initialState = (0, $g5DHJ.Map)({
    currentPage: undefined,
    dataError: false,
    dataErrorMessages: (0, $g5DHJ.List)(),
    initialized: false,
    loadingFreshSearchResults: false,
    loadingMoreResults: false,
    moreResultsDataError: false,
    moreResultsDataErrorMessages: (0, $g5DHJ.List)(),
    searchInProgress: false,
    currentSearchId: undefined,
    searchResults: (0, $g5DHJ.Map)({
        hits: undefined,
        numberOfHits: undefined,
        numberOfPages: undefined
    })
});
function $7ae746ebfd9b4a1d$var$appendSearchResults(_ref) {
    let { oldSearchResults: oldSearchResults, newSearchResults: newSearchResults } = _ref;
    return (0, $g5DHJ.Map)({
        hits: oldSearchResults.get('hits').concat(newSearchResults.get('hits')),
        numberOfHits: newSearchResults.get('numberOfHits'),
        numberOfPages: newSearchResults.get('numberOfPages')
    });
}
function $7ae746ebfd9b4a1d$export$2e2bcd8739ae039() {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $7ae746ebfd9b4a1d$var$initialState;
    let action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $408r2.RESET_STATE:
            return $7ae746ebfd9b4a1d$var$initialState;
        case 0, $kKkev.RETRIEVE_FRESH_SEARCH_RESULTS:
            return state.set('pendingSearchId', action.searchId).set('searchInProgress', true).set('loadingFreshSearchResults', true);
        case 0, $kKkev.RECEIVE_FRESH_SEARCH_RESULTS:
            return state.get('pendingSearchId') === action.searchId ? state.set('pendingSearchId', undefined).set('currentSearchId', action.searchId).set('initialized', true).set('searchInProgress', false).set('searchResults', action.searchResults).set('loadingFreshSearchResults', false).set('dataError', false).set('dataErrorMessages', (0, $g5DHJ.List)()).set('currentPage', 0) : state;
        case 0, $kKkev.DATA_ERROR_FRESH_SEARCH_RESULTS:
            return state.update('searchResults', (searchResults)=>searchResults.set('hits', undefined).set('numberOfHits', 0).set('numberOfPages', 0)).set('searchInProgress', false).set('dataError', true).set('dataErrorMessages', action.dataErrorMessages);
        case 0, $kKkev.RETRIEVE_MORE_SEARCH_RESULTS:
            return state.set('searchInProgress', true).set('loadingMoreResults', true);
        case 0, $kKkev.RECEIVE_MORE_SEARCH_RESULTS:
            return state.set('searchInProgress', false).set('loadingMoreResults', false).set('searchResults', $7ae746ebfd9b4a1d$var$appendSearchResults({
                oldSearchResults: state.get('searchResults'),
                newSearchResults: action.searchResults
            })).set('moreResultsDataError', false).set('moreResultsDataErrorMessages', (0, $g5DHJ.List)()).set('currentPage', action.page);
        case 0, $kKkev.DATA_ERROR_MORE_SEARCH_RESULTS:
            return state.set('searchInProgress', false).set('loadingMoreResults', false).set('moreResultsDataError', true).set('moreResultsDataErrorMessages', action.dataErrorMessages);
        default:
            return state;
    }
}

});

parcelRegister("gT0k8", function(module, exports) {

$parcel$export(module.exports, "default", () => $c4b208af775b4c71$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $408r2 = parcelRequire("408r2");

var $lXXS4 = parcelRequire("lXXS4");
const $c4b208af775b4c71$var$initialState = (0, $g5DHJ.Map)({
    data: undefined,
    dataError: false,
    dataErrorMessages: (0, $g5DHJ.List)(),
    discoverInProgress: false,
    initialized: false
});
function $c4b208af775b4c71$export$2e2bcd8739ae039() {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $c4b208af775b4c71$var$initialState;
    let action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $408r2.RESET_STATE:
            return $c4b208af775b4c71$var$initialState;
        case 0, $lXXS4.RETRIEVE_COLLECTIONS_DATA:
            return state.set('discoverInProgress', true);
        case 0, $lXXS4.RECEIVE_COLLECTIONS_DATA:
            return state.set('data', action.data).set('dataError', false).set('dataErrorMessages', (0, $g5DHJ.List)()).set('discoverInProgress', false).set('initialized', true);
        case 0, $lXXS4.COLLECTIONS_DATA_ERROR:
            return state.set('data', undefined).set('dataError', true).set('dataErrorMessages', action.dataErrorMessages);
        default:
            return state;
    }
}

});


parcelRegister("9lCOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ce43034c471be7e$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $kKkev = parcelRequire("kKkev");

var $lXXS4 = parcelRequire("lXXS4");
const $6ce43034c471be7e$var$initialState = (0, $g5DHJ.Map)({
    dataError: false,
    dataErrorMessages: (0, $g5DHJ.List)(),
    initialized: false,
    facets: undefined
});
function $6ce43034c471be7e$export$2e2bcd8739ae039() {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $6ce43034c471be7e$var$initialState;
    let action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $lXXS4.RECEIVE_FACETS:
        case 0, $kKkev.RECEIVE_FACETS:
            return state.set('initialized', true).set('facets', action.facets).set('dataError', false);
        case 0, $lXXS4.FACETS_DATA_ERROR:
        case 0, $kKkev.FACETS_DATA_ERROR:
            return state.set('dataError', true).set('dataErrorMessages', action.dataErrorMessages);
        default:
            return state;
    }
}

});



parcelRegister("arYdl", function(module, exports) {

$parcel$export(module.exports, "Utils", () => $79bb224889912cc4$export$d2ca453b913dcdea);

var $8OnOc = parcelRequire("8OnOc");

var $b2B2X = parcelRequire("b2B2X");

var $dmAP6 = parcelRequire("dmAP6");


var $4fL5K = parcelRequire("4fL5K");
const $79bb224889912cc4$export$d2ca453b913dcdea = {
    resolveMeta: $b2B2X.resolveMeta,
    createAlgoliaClient: $8OnOc.createAlgoliaClient
};

});

parcelRegister("62VCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $466fa030d0946d1e$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $8gcXz = parcelRequire("8gcXz");

var $9osuT = parcelRequire("9osuT");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $3dvqV = parcelRequire("3dvqV");

var $1zeHk = parcelRequire("1zeHk");

var $7QPXA = parcelRequire("7QPXA");

var $hcvuS = parcelRequire("hcvuS");

var $2cDWd = parcelRequire("2cDWd");

var $lHkHI = parcelRequire("lHkHI");
function $466fa030d0946d1e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $466fa030d0946d1e$var$RecommendationContainer = (0, $3UXZ8.default)("div", {
    target: "e1dicjsr0",
    label: "RecommendationContainer"
})({
    color: "var(--ds-text, ".concat((0, $j0gMm.N0), ")")
}, "");
const $466fa030d0946d1e$var$backgroundUnderlayHeight = 140;
const $466fa030d0946d1e$var$BackgroundUnderlay = (0, $3UXZ8.default)("div", {
    target: "e1dicjsr1",
    label: "BackgroundUnderlay"
})({
    marginTop: '10px',
    background: "var(--ds-background-accent-blue-subtlest, ".concat((0, $j0gMm.N500), ")"),
    height: "".concat($466fa030d0946d1e$var$backgroundUnderlayHeight, "px"),
    width: '145vw',
    transform: 'translateX(-50vw)'
}, "");
const $466fa030d0946d1e$var$RecommendationHeader = (0, $3UXZ8.default)("div", {
    target: "e1dicjsr2",
    label: "RecommendationHeader"
})({
    position: 'relative',
    zIndex: 1,
    color: "var(--ds-text, ".concat((0, $j0gMm.N0), ")"),
    marginTop: "-".concat($466fa030d0946d1e$var$backgroundUnderlayHeight - 16, "px"),
    paddingLeft: '10px',
    paddingBottom: "var(--ds-space-200, 16px)"
}, "");
// Higher specificity using && for emcee native to avoid conflict with global parent styles
// TODO: Rahul - Can be removed after addressing https://ecosystem.atlassian.net/browse/MC-2251
const $466fa030d0946d1e$var$RecommendationH4 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H4), {
    target: "e1dicjsr3",
    label: "RecommendationH4"
})({
    name: "33ddbq",
    styles: "&&{color:inherit;font-weight:normal;margin:0;}"
});
const $466fa030d0946d1e$var$RecommendationDesc = (0, $3UXZ8.default)("div", {
    target: "e1dicjsr4",
    label: "RecommendationDesc"
})({
    name: "okc7pe",
    styles: "font-size:14px;line-height:20px;"
});
const $466fa030d0946d1e$export$ebd86fc7badb9a5d = (props)=>{
    const { product: product, containerClassName: containerClassName, recommendationsResult: recommendationsResult, hitContext: hitContext, screenClass: screenClass } = props;
    const hits = recommendationsResult.hits;
    const labels = (0, $hcvuS.default)[recommendationsResult.hitsType];
    (0, $eUqFw.useEffect)(()=>{
        (0, $2cDWd.trackTileRenders)(props);
    }, []);
    if (hits.isEmpty()) return null;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($466fa030d0946d1e$var$RecommendationContainer, {
        className: containerClassName,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($466fa030d0946d1e$var$BackgroundUnderlay, {}),
            /*#__PURE__*/ (0, $lHkHI.jsxs)($466fa030d0946d1e$var$RecommendationHeader, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($466fa030d0946d1e$var$RecommendationH4, {
                        children: labels.title
                    }),
                    labels.description && /*#__PURE__*/ (0, $lHkHI.jsx)($466fa030d0946d1e$var$RecommendationDesc, {
                        children: labels.description.replace('$product', product)
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3dvqV.ScreenClassRender), {
                render: ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $7QPXA.default), {
                        colSpan: (0, $1zeHk.default),
                        hitContext: (0, $g5DHJ.fromJS)(hitContext),
                        hitSize: "large",
                        hits: hits,
                        screenClass: screenClass
                    })
            })
        ]
    });
};
$466fa030d0946d1e$export$ebd86fc7badb9a5d.defaultProps = {
    product: '',
    containerClassName: ''
};
var $466fa030d0946d1e$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($466fa030d0946d1e$export$ebd86fc7badb9a5d);

});
parcelRegister("3dvqV", function(module, exports) {
"use strict";
function $257af7ffaf25f62b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $257af7ffaf25f62b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $257af7ffaf25f62b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $257af7ffaf25f62b$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
Object.defineProperty(module.exports, "Col", {
    enumerable: true,
    get: function get() {
        return $257af7ffaf25f62b$var$_Col.default;
    }
});
Object.defineProperty(module.exports, "Container", {
    enumerable: true,
    get: function get() {
        return $257af7ffaf25f62b$var$_Container.default;
    }
});
Object.defineProperty(module.exports, "Row", {
    enumerable: true,
    get: function get() {
        return $257af7ffaf25f62b$var$_Row.default;
    }
});
Object.defineProperty(module.exports, "Hidden", {
    enumerable: true,
    get: function get() {
        return $257af7ffaf25f62b$var$_Hidden.default;
    }
});
Object.defineProperty(module.exports, "Visible", {
    enumerable: true,
    get: function get() {
        return $257af7ffaf25f62b$var$_Visible.default;
    }
});
Object.defineProperty(module.exports, "ScreenClassRender", {
    enumerable: true,
    get: function get() {
        return $257af7ffaf25f62b$var$_ScreenClassRender.default;
    }
});
Object.defineProperty(module.exports, "ScreenClassProvider", {
    enumerable: true,
    get: function get() {
        return $257af7ffaf25f62b$var$_ScreenClassProvider.default;
    }
});
Object.defineProperty(module.exports, "ScreenClassContext", {
    enumerable: true,
    get: function get() {
        return $257af7ffaf25f62b$var$_ScreenClassProvider.ScreenClassContext;
    }
});
Object.defineProperty(module.exports, "setConfiguration", {
    enumerable: true,
    get: function get() {
        return $ET433.setConfiguration;
    }
});
Object.defineProperty(module.exports, "useScreenClass", {
    enumerable: true,
    get: function get() {
        return $j4Wxq.useScreenClass;
    }
});

var $257af7ffaf25f62b$var$_Col = $257af7ffaf25f62b$var$_interopRequireDefault((parcelRequire("gUBhR")));

var $257af7ffaf25f62b$var$_Container = $257af7ffaf25f62b$var$_interopRequireDefault((parcelRequire("gno8y")));

var $257af7ffaf25f62b$var$_Row = $257af7ffaf25f62b$var$_interopRequireDefault((parcelRequire("hUJ3K")));

var $257af7ffaf25f62b$var$_Hidden = $257af7ffaf25f62b$var$_interopRequireDefault((parcelRequire("fw9QM")));

var $257af7ffaf25f62b$var$_Visible = $257af7ffaf25f62b$var$_interopRequireDefault((parcelRequire("5VhyD")));

var $257af7ffaf25f62b$var$_ScreenClassRender = $257af7ffaf25f62b$var$_interopRequireDefault((parcelRequire("aqfu2")));

var $257af7ffaf25f62b$var$_ScreenClassProvider = $257af7ffaf25f62b$var$_interopRequireWildcard((parcelRequire("lXUbC")));

var $ET433 = parcelRequire("ET433");

var $j4Wxq = parcelRequire("j4Wxq");
function $257af7ffaf25f62b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($257af7ffaf25f62b$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $257af7ffaf25f62b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $257af7ffaf25f62b$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $257af7ffaf25f62b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $257af7ffaf25f62b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}

});
parcelRegister("gUBhR", function(module, exports) {
"use strict";
function $c4feccc2895837e4$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $c4feccc2895837e4$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $c4feccc2895837e4$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $c4feccc2895837e4$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4feccc2895837e4$var$_react = $c4feccc2895837e4$var$_interopRequireWildcard((parcelRequire("eUqFw")));

var $c4feccc2895837e4$var$_propTypes = $c4feccc2895837e4$var$_interopRequireDefault((parcelRequire("1Qivz")));

var $c4feccc2895837e4$var$_style = $c4feccc2895837e4$var$_interopRequireDefault((parcelRequire("4IPhO")));

var $ET433 = parcelRequire("ET433");

var $hUJ3K = parcelRequire("hUJ3K");

var $c4feccc2895837e4$var$_ScreenClassResolver = $c4feccc2895837e4$var$_interopRequireDefault((parcelRequire("1rMZi")));

var $8A7Vu = parcelRequire("8A7Vu");
var $c4feccc2895837e4$var$_excluded = [
    "children",
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl",
    "offset",
    "pull",
    "push",
    "debug",
    "style",
    "component",
    "width"
];
function $c4feccc2895837e4$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $c4feccc2895837e4$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($c4feccc2895837e4$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $c4feccc2895837e4$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $c4feccc2895837e4$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $c4feccc2895837e4$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $c4feccc2895837e4$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c4feccc2895837e4$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c4feccc2895837e4$var$ownKeys(Object(source), true).forEach(function(key) {
            $c4feccc2895837e4$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c4feccc2895837e4$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c4feccc2895837e4$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $c4feccc2895837e4$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $c4feccc2895837e4$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $c4feccc2895837e4$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $c4feccc2895837e4$var$Col = function Col(_ref) {
    var children = _ref.children, xs = _ref.xs, sm = _ref.sm, md = _ref.md, lg = _ref.lg, xl = _ref.xl, xxl = _ref.xxl, offset = _ref.offset, pull = _ref.pull, push = _ref.push, debug = _ref.debug, style = _ref.style, component = _ref.component, width = _ref.width, otherProps = $c4feccc2895837e4$var$_objectWithoutProperties(_ref, $c4feccc2895837e4$var$_excluded);
    return /*#__PURE__*/ $c4feccc2895837e4$var$_react.default.createElement($c4feccc2895837e4$var$_ScreenClassResolver.default, null, function(screenClass) {
        return /*#__PURE__*/ $c4feccc2895837e4$var$_react.default.createElement($hUJ3K.GutterWidthContext.Consumer, null, function(gutterWidth) {
            var theStyle = (0, $c4feccc2895837e4$var$_style.default)({
                forceWidth: width,
                width: {
                    xs: xs,
                    sm: sm,
                    md: md,
                    lg: lg,
                    xl: xl,
                    xxl: xxl
                },
                offset: offset,
                pull: pull,
                push: push,
                debug: debug,
                screenClass: screenClass,
                gutterWidth: gutterWidth,
                gridColumns: (0, $ET433.getConfiguration)().gridColumns,
                moreStyle: style
            });
            return /*#__PURE__*/ (0, $c4feccc2895837e4$var$_react.createElement)(component, $c4feccc2895837e4$var$_objectSpread($c4feccc2895837e4$var$_objectSpread({
                style: theStyle
            }, otherProps), {}, {
                children: children
            }));
        });
    });
};
$c4feccc2895837e4$var$Col.propTypes = {
    /**
   * Content of the column
   */ children: $c4feccc2895837e4$var$_propTypes.default.node,
    /**
   * The width of the column for screenclass `xs`, either a number between 0 and 12, or "content"
   */ xs: $c4feccc2895837e4$var$_propTypes.default.oneOfType([
        $c4feccc2895837e4$var$_propTypes.default.number,
        $c4feccc2895837e4$var$_propTypes.default.oneOf([
            'content'
        ])
    ]),
    /**
   * The width of the column for screenclass `sm`, either a number between 0 and 12, or "content"
   */ sm: $c4feccc2895837e4$var$_propTypes.default.oneOfType([
        $c4feccc2895837e4$var$_propTypes.default.number,
        $c4feccc2895837e4$var$_propTypes.default.oneOf([
            'content'
        ])
    ]),
    /**
   * The width of the column for screenclass `md`, either a number between 0 and 12, or "content"
   */ md: $c4feccc2895837e4$var$_propTypes.default.oneOfType([
        $c4feccc2895837e4$var$_propTypes.default.number,
        $c4feccc2895837e4$var$_propTypes.default.oneOf([
            'content'
        ])
    ]),
    /**
   * The width of the column for screenclass `lg`, either a number between 0 and 12, or "content"
   */ lg: $c4feccc2895837e4$var$_propTypes.default.oneOfType([
        $c4feccc2895837e4$var$_propTypes.default.number,
        $c4feccc2895837e4$var$_propTypes.default.oneOf([
            'content'
        ])
    ]),
    /**
   * The width of the column for screenclass `xl`, either a number between 0 and 12, or "content"
   */ xl: $c4feccc2895837e4$var$_propTypes.default.oneOfType([
        $c4feccc2895837e4$var$_propTypes.default.number,
        $c4feccc2895837e4$var$_propTypes.default.oneOf([
            'content'
        ])
    ]),
    /**
   * The width of the column for screenclass `xxl`, either a number between 0 and 12, or "content"
   */ xxl: $c4feccc2895837e4$var$_propTypes.default.oneOfType([
        $c4feccc2895837e4$var$_propTypes.default.number,
        $c4feccc2895837e4$var$_propTypes.default.oneOf([
            'content'
        ])
    ]),
    /**
   * A fixed width of the column for all screenclasses"
   */ width: $c4feccc2895837e4$var$_propTypes.default.oneOfType([
        $c4feccc2895837e4$var$_propTypes.default.number,
        $c4feccc2895837e4$var$_propTypes.default.string
    ]),
    /**
   * The offset of this column for all screenclasses
   */ offset: $c4feccc2895837e4$var$_propTypes.default.shape({
        xs: $c4feccc2895837e4$var$_propTypes.default.number,
        sm: $c4feccc2895837e4$var$_propTypes.default.number,
        md: $c4feccc2895837e4$var$_propTypes.default.number,
        lg: $c4feccc2895837e4$var$_propTypes.default.number,
        xl: $c4feccc2895837e4$var$_propTypes.default.number,
        xxl: $c4feccc2895837e4$var$_propTypes.default.number
    }),
    /**
   * The amount this column is pushed to the right for all screenclasses
   */ push: $c4feccc2895837e4$var$_propTypes.default.shape({
        xs: $c4feccc2895837e4$var$_propTypes.default.number,
        sm: $c4feccc2895837e4$var$_propTypes.default.number,
        md: $c4feccc2895837e4$var$_propTypes.default.number,
        lg: $c4feccc2895837e4$var$_propTypes.default.number,
        xl: $c4feccc2895837e4$var$_propTypes.default.number,
        xxl: $c4feccc2895837e4$var$_propTypes.default.number
    }),
    /**
   * The amount this column is pulled to the left for all screenclasses
   */ pull: $c4feccc2895837e4$var$_propTypes.default.shape({
        xs: $c4feccc2895837e4$var$_propTypes.default.number,
        sm: $c4feccc2895837e4$var$_propTypes.default.number,
        md: $c4feccc2895837e4$var$_propTypes.default.number,
        lg: $c4feccc2895837e4$var$_propTypes.default.number,
        xl: $c4feccc2895837e4$var$_propTypes.default.number,
        xxl: $c4feccc2895837e4$var$_propTypes.default.number
    }),
    /**
   * Optional styling
   */ style: $c4feccc2895837e4$var$_propTypes.default.objectOf($c4feccc2895837e4$var$_propTypes.default.oneOfType([
        $c4feccc2895837e4$var$_propTypes.default.number,
        $c4feccc2895837e4$var$_propTypes.default.string
    ])),
    /**
   * Set to apply some debug styling
   */ debug: $c4feccc2895837e4$var$_propTypes.default.bool,
    /**
   * Use your own component
   */ component: $c4feccc2895837e4$var$_propTypes.default.elementType
};
$c4feccc2895837e4$var$Col.defaultProps = {
    children: null,
    xs: null,
    sm: null,
    md: null,
    lg: null,
    xl: null,
    xxl: null,
    width: null,
    offset: {},
    push: {},
    pull: {},
    style: {},
    debug: false,
    component: $8A7Vu.Div
};
var $c4feccc2895837e4$var$_default = $c4feccc2895837e4$var$Col;
module.exports.default = $c4feccc2895837e4$var$_default;

});
parcelRegister("hUJ3K", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.GutterWidthContext = void 0;

var $d0aa9e834ac266a1$var$_react = $d0aa9e834ac266a1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d0aa9e834ac266a1$var$_propTypes = $d0aa9e834ac266a1$var$_interopRequireDefault((parcelRequire("1Qivz")));

var $ET433 = parcelRequire("ET433");

var $d0aa9e834ac266a1$var$_style = $d0aa9e834ac266a1$var$_interopRequireDefault((parcelRequire("51JBi")));

var $8A7Vu = parcelRequire("8A7Vu");
var $d0aa9e834ac266a1$var$_excluded = [
    "children",
    "style",
    "align",
    "justify",
    "debug",
    "nogutter",
    "gutterWidth",
    "component",
    "nowrap",
    "direction"
];
function $d0aa9e834ac266a1$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $d0aa9e834ac266a1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $d0aa9e834ac266a1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $d0aa9e834ac266a1$var$ownKeys(Object(source), true).forEach(function(key) {
            $d0aa9e834ac266a1$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $d0aa9e834ac266a1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $d0aa9e834ac266a1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $d0aa9e834ac266a1$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $d0aa9e834ac266a1$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $d0aa9e834ac266a1$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $d0aa9e834ac266a1$var$GutterWidthContext = /*#__PURE__*/ $d0aa9e834ac266a1$var$_react.default.createContext(false);
module.exports.GutterWidthContext = $d0aa9e834ac266a1$var$GutterWidthContext;
var $d0aa9e834ac266a1$var$Row = function Row(_ref) {
    var children = _ref.children, style = _ref.style, align = _ref.align, justify = _ref.justify, debug = _ref.debug, nogutter = _ref.nogutter, gutterWidth = _ref.gutterWidth, component = _ref.component, nowrap = _ref.nowrap, direction = _ref.direction, otherProps = $d0aa9e834ac266a1$var$_objectWithoutProperties(_ref, $d0aa9e834ac266a1$var$_excluded);
    var theGutterWidth = (0, $ET433.getConfiguration)().gutterWidth;
    if (nogutter) theGutterWidth = 0;
    if (typeof gutterWidth === 'number') theGutterWidth = gutterWidth;
    var theStyle = (0, $d0aa9e834ac266a1$var$_style.default)({
        gutterWidth: theGutterWidth,
        align: align,
        justify: justify,
        debug: debug,
        moreStyle: style,
        nowrap: nowrap,
        direction: direction
    });
    return /*#__PURE__*/ $d0aa9e834ac266a1$var$_react.default.createElement(component, $d0aa9e834ac266a1$var$_objectSpread({
        style: theStyle
    }, otherProps), /*#__PURE__*/ $d0aa9e834ac266a1$var$_react.default.createElement($d0aa9e834ac266a1$var$GutterWidthContext.Provider, {
        value: theGutterWidth
    }, children));
};
$d0aa9e834ac266a1$var$Row.propTypes = {
    /**
   * Content of the element
   */ children: $d0aa9e834ac266a1$var$_propTypes.default.node.isRequired,
    /**
   * Vertical column alignment
   */ align: $d0aa9e834ac266a1$var$_propTypes.default.oneOf([
        'normal',
        'start',
        'center',
        'end',
        'stretch'
    ]),
    /**
   * Horizontal column alignment
   */ justify: $d0aa9e834ac266a1$var$_propTypes.default.oneOf([
        'start',
        'center',
        'end',
        'between',
        'around',
        'initial',
        'inherit'
    ]),
    /**
   * flex-direction style attribute
   */ direction: $d0aa9e834ac266a1$var$_propTypes.default.oneOf([
        'column',
        'row',
        'column-reverse',
        'row-reverse'
    ]),
    /**
   * No gutter for this row
   */ nogutter: $d0aa9e834ac266a1$var$_propTypes.default.bool,
    /**
   * Custom gutter width for this row
   */ gutterWidth: $d0aa9e834ac266a1$var$_propTypes.default.number,
    /**
   * Optional styling
   */ style: $d0aa9e834ac266a1$var$_propTypes.default.objectOf($d0aa9e834ac266a1$var$_propTypes.default.oneOfType([
        $d0aa9e834ac266a1$var$_propTypes.default.number,
        $d0aa9e834ac266a1$var$_propTypes.default.string
    ])),
    /**
   * Set to apply some debug styling
   */ debug: $d0aa9e834ac266a1$var$_propTypes.default.bool,
    /**
   * Use your own component
   */ component: $d0aa9e834ac266a1$var$_propTypes.default.elementType,
    /**
   * Whether the cols should not wrap
   */ nowrap: $d0aa9e834ac266a1$var$_propTypes.default.bool
};
$d0aa9e834ac266a1$var$Row.defaultProps = {
    align: 'normal',
    justify: 'start',
    direction: 'row',
    nogutter: false,
    gutterWidth: null,
    style: {},
    debug: false,
    component: $8A7Vu.Div,
    nowrap: false
};
var $d0aa9e834ac266a1$var$_default = $d0aa9e834ac266a1$var$Row;
module.exports.default = $d0aa9e834ac266a1$var$_default;

});
parcelRegister("51JBi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
function $3a906b17591c6564$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $3a906b17591c6564$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $3a906b17591c6564$var$ownKeys(Object(source), true).forEach(function(key) {
            $3a906b17591c6564$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $3a906b17591c6564$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $3a906b17591c6564$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $3a906b17591c6564$var$_default = function _default(_ref) {
    var gutterWidth = _ref.gutterWidth, align = _ref.align, justify = _ref.justify, debug = _ref.debug, moreStyle = _ref.moreStyle, nowrap = _ref.nowrap, direction = _ref.direction;
    // Vertical alignment
    var alignItems = align;
    if (align === 'start') alignItems = 'flex-start';
    if (align === 'end') alignItems = 'flex-end'; // Horizontal alignment
    var justifyContent = justify;
    if (justify === 'start') justifyContent = 'flex-start';
    if (justify === 'end') justifyContent = 'flex-end';
    if (justify === 'between') justifyContent = 'space-between';
    if (justify === 'around') justifyContent = 'space-around';
    if (justify === 'center') justifyContent = 'center';
    if (justify === 'initial') justifyContent = 'initial';
    if (justify === 'inherit') justifyContent = 'inherit';
    var flexDirection = [
        'column',
        'row',
        'column-reverse',
        'row-reverse'
    ].includes(direction) ? direction : undefined;
    var styles = {
        marginLeft: -gutterWidth / 2,
        marginRight: -gutterWidth / 2,
        display: 'flex',
        flexWrap: nowrap ? 'nowrap' : 'wrap',
        flexGrow: 0,
        flexShrink: 0,
        alignItems: alignItems,
        justifyContent: justifyContent,
        flexDirection: flexDirection
    };
    if (debug) styles.background = 'rgba(128,128,128,.05)';
    return $3a906b17591c6564$var$_objectSpread($3a906b17591c6564$var$_objectSpread({}, styles), moreStyle);
};
module.exports.default = $3a906b17591c6564$var$_default;

});


parcelRegister("1rMZi", function(module, exports) {
"use strict";
function $10de4ff8bd9c3280$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $10de4ff8bd9c3280$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $10de4ff8bd9c3280$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $10de4ff8bd9c3280$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $10de4ff8bd9c3280$var$_react = $10de4ff8bd9c3280$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $10de4ff8bd9c3280$var$_propTypes = $10de4ff8bd9c3280$var$_interopRequireDefault((parcelRequire("1Qivz")));

var $10de4ff8bd9c3280$var$_ScreenClassProvider = $10de4ff8bd9c3280$var$_interopRequireWildcard((parcelRequire("lXUbC")));
function $10de4ff8bd9c3280$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($10de4ff8bd9c3280$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $10de4ff8bd9c3280$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $10de4ff8bd9c3280$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $10de4ff8bd9c3280$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $10de4ff8bd9c3280$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $10de4ff8bd9c3280$var$ScreenClassResolver = function ScreenClassResolver(_ref) {
    var children = _ref.children;
    return /*#__PURE__*/ $10de4ff8bd9c3280$var$_react.default.createElement($10de4ff8bd9c3280$var$_ScreenClassProvider.ScreenClassContext.Consumer, null, function(screenClassCheck) {
        if (screenClassCheck === $10de4ff8bd9c3280$var$_ScreenClassProvider.NO_PROVIDER_FLAG) return /*#__PURE__*/ $10de4ff8bd9c3280$var$_react.default.createElement($10de4ff8bd9c3280$var$_ScreenClassProvider.default, null, /*#__PURE__*/ $10de4ff8bd9c3280$var$_react.default.createElement($10de4ff8bd9c3280$var$_ScreenClassProvider.ScreenClassContext.Consumer, null, function(screenClassResolved) {
            return children(screenClassResolved);
        }));
        return children(screenClassCheck);
    });
};
$10de4ff8bd9c3280$var$ScreenClassResolver.propTypes = {
    children: $10de4ff8bd9c3280$var$_propTypes.default.func.isRequired
};
var $10de4ff8bd9c3280$var$_default = $10de4ff8bd9c3280$var$ScreenClassResolver;
module.exports.default = $10de4ff8bd9c3280$var$_default;

});
parcelRegister("lXUbC", function(module, exports) {
"use strict";
function $ffdab11c6fcf7fcc$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $ffdab11c6fcf7fcc$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $ffdab11c6fcf7fcc$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $ffdab11c6fcf7fcc$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.ScreenClassContext = module.exports.NO_PROVIDER_FLAG = void 0;

var $ffdab11c6fcf7fcc$var$_react = $ffdab11c6fcf7fcc$var$_interopRequireWildcard((parcelRequire("eUqFw")));

var $ffdab11c6fcf7fcc$var$_propTypes = $ffdab11c6fcf7fcc$var$_interopRequireDefault((parcelRequire("1Qivz")));

var $j4Wxq = parcelRequire("j4Wxq");

var $ET433 = parcelRequire("ET433");

var $8A7Vu = parcelRequire("8A7Vu");
function $ffdab11c6fcf7fcc$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $ffdab11c6fcf7fcc$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($ffdab11c6fcf7fcc$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $ffdab11c6fcf7fcc$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $ffdab11c6fcf7fcc$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $ffdab11c6fcf7fcc$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $ffdab11c6fcf7fcc$var$_slicedToArray(arr, i) {
    return $ffdab11c6fcf7fcc$var$_arrayWithHoles(arr) || $ffdab11c6fcf7fcc$var$_iterableToArrayLimit(arr, i) || $ffdab11c6fcf7fcc$var$_unsupportedIterableToArray(arr, i) || $ffdab11c6fcf7fcc$var$_nonIterableRest();
}
function $ffdab11c6fcf7fcc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $ffdab11c6fcf7fcc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $ffdab11c6fcf7fcc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $ffdab11c6fcf7fcc$var$_arrayLikeToArray(o, minLen);
}
function $ffdab11c6fcf7fcc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $ffdab11c6fcf7fcc$var$_iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $ffdab11c6fcf7fcc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
var $ffdab11c6fcf7fcc$var$NO_PROVIDER_FLAG = 'NO_PROVIDER_FLAG';
module.exports.NO_PROVIDER_FLAG = $ffdab11c6fcf7fcc$var$NO_PROVIDER_FLAG;
var $ffdab11c6fcf7fcc$var$ScreenClassContext = /*#__PURE__*/ $ffdab11c6fcf7fcc$var$_react.default.createContext($ffdab11c6fcf7fcc$var$NO_PROVIDER_FLAG);
module.exports.ScreenClassContext = $ffdab11c6fcf7fcc$var$ScreenClassContext;
var $ffdab11c6fcf7fcc$var$ScreenClassProvider = function ScreenClassProvider(_ref) {
    var useOwnWidth = _ref.useOwnWidth, children = _ref.children, fallbackScreenClass = _ref.fallbackScreenClass;
    var screenClassRef = (0, $ffdab11c6fcf7fcc$var$_react.useRef)();
    var _useState = (0, $ffdab11c6fcf7fcc$var$_react.useState)(false), _useState2 = $ffdab11c6fcf7fcc$var$_slicedToArray(_useState, 2), mounted = _useState2[0], setMounted = _useState2[1];
    var detectedScreenClass = (0, $j4Wxq.useScreenClass)(screenClassRef, fallbackScreenClass);
    var _getConfiguration = (0, $ET433.getConfiguration)(), defaultScreenClass = _getConfiguration.defaultScreenClass;
    var screenClass = mounted ? detectedScreenClass : fallbackScreenClass || defaultScreenClass;
    (0, $ffdab11c6fcf7fcc$var$_react.useEffect)(function() {
        return setMounted(true);
    }, []);
    return /*#__PURE__*/ $ffdab11c6fcf7fcc$var$_react.default.createElement($ffdab11c6fcf7fcc$var$ScreenClassContext.Provider, {
        value: screenClass
    }, useOwnWidth ? /*#__PURE__*/ $ffdab11c6fcf7fcc$var$_react.default.createElement($8A7Vu.Div, {
        ref: useOwnWidth ? screenClassRef : null
    }, children) : /*#__PURE__*/ $ffdab11c6fcf7fcc$var$_react.default.createElement($ffdab11c6fcf7fcc$var$_react.default.Fragment, null, children));
};
$ffdab11c6fcf7fcc$var$ScreenClassProvider.propTypes = {
    /**
   * Children of the ScreenClassProvider.
   * This should be all your child React nodes that are using `react-grid-system`.
   */ children: $ffdab11c6fcf7fcc$var$_propTypes.default.node.isRequired,
    /**
   * Boolean to determine whether own width should be used as source.
   * When provided, the screen class is derived from own dimensions instead of the window.
   */ useOwnWidth: $ffdab11c6fcf7fcc$var$_propTypes.default.bool,
    /**
   * Screen class to use when it cannot be determined otherwise.
   * Useful for server side rendering.
   */ fallbackScreenClass: $ffdab11c6fcf7fcc$var$_propTypes.default.oneOf([
        null,
        'xs',
        'sm',
        'md',
        'lg',
        'xl',
        'xxl'
    ])
};
$ffdab11c6fcf7fcc$var$ScreenClassProvider.defaultProps = {
    useOwnWidth: false,
    fallbackScreenClass: null
};
var $ffdab11c6fcf7fcc$var$_default = $ffdab11c6fcf7fcc$var$ScreenClassProvider;
module.exports.default = $ffdab11c6fcf7fcc$var$_default;

});



parcelRegister("gno8y", function(module, exports) {
"use strict";
function $bec18467e34cb16f$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $bec18467e34cb16f$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $bec18467e34cb16f$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $bec18467e34cb16f$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bec18467e34cb16f$var$_react = $bec18467e34cb16f$var$_interopRequireWildcard((parcelRequire("eUqFw")));

var $bec18467e34cb16f$var$_propTypes = $bec18467e34cb16f$var$_interopRequireDefault((parcelRequire("1Qivz")));

var $bec18467e34cb16f$var$_style = $bec18467e34cb16f$var$_interopRequireWildcard((parcelRequire("9dXSX")));

var $ET433 = parcelRequire("ET433");

var $bec18467e34cb16f$var$_ScreenClassResolver = $bec18467e34cb16f$var$_interopRequireDefault((parcelRequire("1rMZi")));

var $8A7Vu = parcelRequire("8A7Vu");
var $bec18467e34cb16f$var$_excluded = [
    "children",
    "fluid",
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
    "xxl",
    "style",
    "component"
];
function $bec18467e34cb16f$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $bec18467e34cb16f$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($bec18467e34cb16f$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $bec18467e34cb16f$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $bec18467e34cb16f$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $bec18467e34cb16f$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $bec18467e34cb16f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bec18467e34cb16f$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $bec18467e34cb16f$var$ownKeys(Object(source), true).forEach(function(key) {
            $bec18467e34cb16f$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $bec18467e34cb16f$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $bec18467e34cb16f$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $bec18467e34cb16f$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $bec18467e34cb16f$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $bec18467e34cb16f$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var $bec18467e34cb16f$var$Container = function Container(_ref) {
    var children = _ref.children, fluid = _ref.fluid, xs = _ref.xs, sm = _ref.sm, md = _ref.md, lg = _ref.lg, xl = _ref.xl, xxl = _ref.xxl, style = _ref.style, component = _ref.component, otherProps = $bec18467e34cb16f$var$_objectWithoutProperties(_ref, $bec18467e34cb16f$var$_excluded);
    return /*#__PURE__*/ $bec18467e34cb16f$var$_react.default.createElement($bec18467e34cb16f$var$_ScreenClassResolver.default, null, function(screenClass) {
        return /*#__PURE__*/ (0, $bec18467e34cb16f$var$_react.createElement)(component, $bec18467e34cb16f$var$_objectSpread({
            style: (0, $bec18467e34cb16f$var$_style.default)({
                fluid: fluid,
                xs: xs,
                sm: sm,
                md: md,
                lg: lg,
                xl: xl,
                xxl: xxl,
                screenClass: screenClass,
                containerWidths: (0, $ET433.getConfiguration)().containerWidths,
                gutterWidth: (0, $ET433.getConfiguration)().gutterWidth,
                moreStyle: style
            })
        }, otherProps), /*#__PURE__*/ $bec18467e34cb16f$var$_react.default.createElement($bec18467e34cb16f$var$_react.default.Fragment, null, children, /*#__PURE__*/ $bec18467e34cb16f$var$_react.default.createElement($8A7Vu.Span, {
            style: (0, $bec18467e34cb16f$var$_style.getAfterStyle)()
        })));
    });
};
$bec18467e34cb16f$var$Container.propTypes = {
    /**
   * Content of the component
   */ children: $bec18467e34cb16f$var$_propTypes.default.node.isRequired,
    /**
   * True makes the container full-width, false fixed-width
   */ fluid: $bec18467e34cb16f$var$_propTypes.default.bool,
    /**
   * This is in combination with fluid enabled
   * True makes container fluid only in xs, not present means fluid everywhere
   */ xs: $bec18467e34cb16f$var$_propTypes.default.bool,
    /**
   * This is in combination with fluid enabled
   * True makes container fluid only in sm, not present means fluid everywhere
   */ sm: $bec18467e34cb16f$var$_propTypes.default.bool,
    /**
   * This is in combination with fluid enabled
   * True makes container fluid only in md, not present means fluid everywhere
   */ md: $bec18467e34cb16f$var$_propTypes.default.bool,
    /**
   * This is in combination with fluid enabled
   * True makes container fluid only in lg, not present means fluid everywhere
   */ lg: $bec18467e34cb16f$var$_propTypes.default.bool,
    /**
   * This is in combination with fluid enabled
   * True makes container fluid only in xl, not present means fluid everywhere
   */ xl: $bec18467e34cb16f$var$_propTypes.default.bool,
    /**
   * This is in combination with fluid enabled
   * True makes container fluid only in xxl, not present means fluid everywhere
   */ xxl: $bec18467e34cb16f$var$_propTypes.default.bool,
    /**
   * Optional styling
   */ style: $bec18467e34cb16f$var$_propTypes.default.objectOf($bec18467e34cb16f$var$_propTypes.default.oneOfType([
        $bec18467e34cb16f$var$_propTypes.default.number,
        $bec18467e34cb16f$var$_propTypes.default.string
    ])),
    /**
   * Use your own component
   */ component: $bec18467e34cb16f$var$_propTypes.default.elementType
};
$bec18467e34cb16f$var$Container.defaultProps = {
    fluid: false,
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    xxl: false,
    style: {},
    component: $8A7Vu.Div
};
var $bec18467e34cb16f$var$_default = $bec18467e34cb16f$var$Container;
module.exports.default = $bec18467e34cb16f$var$_default;

});
parcelRegister("9dXSX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getAfterStyle = module.exports.default = void 0;
function $6b73c7ee4c3812d1$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $6b73c7ee4c3812d1$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $6b73c7ee4c3812d1$var$ownKeys(Object(source), true).forEach(function(key) {
            $6b73c7ee4c3812d1$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $6b73c7ee4c3812d1$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $6b73c7ee4c3812d1$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $6b73c7ee4c3812d1$var$_default = function _default(_ref) {
    var fluid = _ref.fluid, xs = _ref.xs, sm = _ref.sm, md = _ref.md, lg = _ref.lg, xl = _ref.xl, xxl = _ref.xxl, screenClass = _ref.screenClass, containerWidths = _ref.containerWidths, gutterWidth = _ref.gutterWidth, moreStyle = _ref.moreStyle;
    var styles = {
        boxSizing: 'border-box',
        position: 'relative',
        marginLeft: 'auto',
        marginRight: 'auto',
        paddingLeft: gutterWidth / 2,
        paddingRight: gutterWidth / 2
    };
    if (fluid && !xs && !sm && !md && !lg && !xl) return $6b73c7ee4c3812d1$var$_objectSpread($6b73c7ee4c3812d1$var$_objectSpread({}, styles), moreStyle);
    if (screenClass === 'xs' && containerWidths[0] && !xs) styles.maxWidth = containerWidths[0];
    if (screenClass === 'sm' && containerWidths[0] && !sm) styles.maxWidth = containerWidths[0];
    if (screenClass === 'md' && containerWidths[1] && !md) styles.maxWidth = containerWidths[1];
    if (screenClass === 'lg' && containerWidths[2] && !lg) styles.maxWidth = containerWidths[2];
    if (screenClass === 'xl' && containerWidths[3] && !xl) styles.maxWidth = containerWidths[3];
    if (screenClass === 'xxl' && containerWidths[4] && !xxl) styles.maxWidth = containerWidths[4];
    return $6b73c7ee4c3812d1$var$_objectSpread($6b73c7ee4c3812d1$var$_objectSpread({}, styles), moreStyle);
};
module.exports.default = $6b73c7ee4c3812d1$var$_default;
var $6b73c7ee4c3812d1$var$getAfterStyle = function getAfterStyle() {
    return {
        display: 'table',
        clear: 'both'
    };
};
module.exports.getAfterStyle = $6b73c7ee4c3812d1$var$getAfterStyle;

});


parcelRegister("fw9QM", function(module, exports) {
"use strict";
function $b4c17c39f7e988a3$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $b4c17c39f7e988a3$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $b4c17c39f7e988a3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $b4c17c39f7e988a3$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b4c17c39f7e988a3$var$_react = $b4c17c39f7e988a3$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $b4c17c39f7e988a3$var$_propTypes = $b4c17c39f7e988a3$var$_interopRequireDefault((parcelRequire("1Qivz")));

var $b4c17c39f7e988a3$var$style = $b4c17c39f7e988a3$var$_interopRequireWildcard((parcelRequire("kr3cb")));

var $b4c17c39f7e988a3$var$_ScreenClassResolver = $b4c17c39f7e988a3$var$_interopRequireDefault((parcelRequire("1rMZi")));
function $b4c17c39f7e988a3$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($b4c17c39f7e988a3$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $b4c17c39f7e988a3$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $b4c17c39f7e988a3$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $b4c17c39f7e988a3$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $b4c17c39f7e988a3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $b4c17c39f7e988a3$var$Hidden = function Hidden(_ref) {
    var children = _ref.children, xs = _ref.xs, sm = _ref.sm, md = _ref.md, lg = _ref.lg, xl = _ref.xl, xxl = _ref.xxl;
    return /*#__PURE__*/ $b4c17c39f7e988a3$var$_react.default.createElement($b4c17c39f7e988a3$var$_ScreenClassResolver.default, null, function(screenClass) {
        return $b4c17c39f7e988a3$var$style.hidden({
            screenClass: screenClass,
            xs: xs,
            sm: sm,
            md: md,
            lg: lg,
            xl: xl,
            xxl: xxl
        }) ? null : children;
    });
};
$b4c17c39f7e988a3$var$Hidden.propTypes = {
    /**
   * Content of the component
   */ children: $b4c17c39f7e988a3$var$_propTypes.default.node.isRequired,
    /**
   * Hide on extra small devices
   */ xs: $b4c17c39f7e988a3$var$_propTypes.default.bool,
    /**
   * Hide on small devices
   */ sm: $b4c17c39f7e988a3$var$_propTypes.default.bool,
    /**
   * Hide on medium devices
   */ md: $b4c17c39f7e988a3$var$_propTypes.default.bool,
    /**
   * Hide on large devices
   */ lg: $b4c17c39f7e988a3$var$_propTypes.default.bool,
    /**
   * Hide on xlarge devices
   */ xl: $b4c17c39f7e988a3$var$_propTypes.default.bool,
    /**
   * Hide on xxlarge devices
   */ xxl: $b4c17c39f7e988a3$var$_propTypes.default.bool
};
$b4c17c39f7e988a3$var$Hidden.defaultProps = {
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    xxl: false
};
var $b4c17c39f7e988a3$var$_default = $b4c17c39f7e988a3$var$Hidden;
module.exports.default = $b4c17c39f7e988a3$var$_default;

});
parcelRegister("kr3cb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.hidden = void 0;
var $ee08ced1c54d16ef$var$hidden = function hidden(_ref) {
    var screenClass = _ref.screenClass, xs = _ref.xs, sm = _ref.sm, md = _ref.md, lg = _ref.lg, xl = _ref.xl, xxl = _ref.xxl;
    if (screenClass === 'xxl') return xxl;
    if (screenClass === 'xl') return xl;
    if (screenClass === 'lg') return lg;
    if (screenClass === 'md') return md;
    if (screenClass === 'sm') return sm;
    return xs;
};
module.exports.hidden = $ee08ced1c54d16ef$var$hidden;
var $ee08ced1c54d16ef$var$_default = $ee08ced1c54d16ef$var$hidden;
module.exports.default = $ee08ced1c54d16ef$var$_default;

});


parcelRegister("5VhyD", function(module, exports) {
"use strict";
function $44ffe53923ece76b$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $44ffe53923ece76b$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $44ffe53923ece76b$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $44ffe53923ece76b$var$_typeof(obj);
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $44ffe53923ece76b$var$_react = $44ffe53923ece76b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $44ffe53923ece76b$var$_propTypes = $44ffe53923ece76b$var$_interopRequireDefault((parcelRequire("1Qivz")));

var $44ffe53923ece76b$var$style = $44ffe53923ece76b$var$_interopRequireWildcard((parcelRequire("7byPU")));

var $44ffe53923ece76b$var$_ScreenClassResolver = $44ffe53923ece76b$var$_interopRequireDefault((parcelRequire("1rMZi")));
function $44ffe53923ece76b$var$_getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function") return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return ($44ffe53923ece76b$var$_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
        return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
}
function $44ffe53923ece76b$var$_interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) return obj;
    if (obj === null || $44ffe53923ece76b$var$_typeof(obj) !== "object" && typeof obj !== "function") return {
        default: obj
    };
    var cache = $44ffe53923ece76b$var$_getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) return cache.get(obj);
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for(var key in obj)if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) Object.defineProperty(newObj, key, desc);
        else newObj[key] = obj[key];
    }
    newObj.default = obj;
    if (cache) cache.set(obj, newObj);
    return newObj;
}
function $44ffe53923ece76b$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $44ffe53923ece76b$var$Visible = function Visible(_ref) {
    var children = _ref.children, xs = _ref.xs, sm = _ref.sm, md = _ref.md, lg = _ref.lg, xl = _ref.xl, xxl = _ref.xxl;
    return /*#__PURE__*/ $44ffe53923ece76b$var$_react.default.createElement($44ffe53923ece76b$var$_ScreenClassResolver.default, null, function(screenClass) {
        return !$44ffe53923ece76b$var$style.visible({
            screenClass: screenClass,
            xs: xs,
            sm: sm,
            md: md,
            lg: lg,
            xl: xl,
            xxl: xxl
        }) ? null : children;
    });
};
$44ffe53923ece76b$var$Visible.propTypes = {
    /**
   * Content of the component
   */ children: $44ffe53923ece76b$var$_propTypes.default.node.isRequired,
    /**
   * Show on extra small devices
   */ xs: $44ffe53923ece76b$var$_propTypes.default.bool,
    /**
   * Show on small devices
   */ sm: $44ffe53923ece76b$var$_propTypes.default.bool,
    /**
   * Show on medium devices
   */ md: $44ffe53923ece76b$var$_propTypes.default.bool,
    /**
   * Show on large devices
   */ lg: $44ffe53923ece76b$var$_propTypes.default.bool,
    /**
   * Show on xlarge devices
   */ xl: $44ffe53923ece76b$var$_propTypes.default.bool,
    /**
   * Show on xxlarge devices
   */ xxl: $44ffe53923ece76b$var$_propTypes.default.bool
};
$44ffe53923ece76b$var$Visible.defaultProps = {
    xs: false,
    sm: false,
    md: false,
    lg: false,
    xl: false,
    xxl: false
};
var $44ffe53923ece76b$var$_default = $44ffe53923ece76b$var$Visible;
module.exports.default = $44ffe53923ece76b$var$_default;

});
parcelRegister("7byPU", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = module.exports.visible = void 0;
var $53b4953cf84bedb8$var$visible = function visible(_ref) {
    var screenClass = _ref.screenClass, xs = _ref.xs, sm = _ref.sm, md = _ref.md, lg = _ref.lg, xl = _ref.xl, xxl = _ref.xxl;
    if (screenClass === 'xxl') return xxl;
    if (screenClass === 'xl') return xl;
    if (screenClass === 'lg') return lg;
    if (screenClass === 'md') return md;
    if (screenClass === 'sm') return sm;
    return xs;
};
module.exports.visible = $53b4953cf84bedb8$var$visible;
var $53b4953cf84bedb8$var$_default = $53b4953cf84bedb8$var$visible;
module.exports.default = $53b4953cf84bedb8$var$_default;

});


parcelRegister("aqfu2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $796857cfd52069a9$var$_react = $796857cfd52069a9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $796857cfd52069a9$var$_propTypes = $796857cfd52069a9$var$_interopRequireDefault((parcelRequire("1Qivz")));

var $796857cfd52069a9$var$_ScreenClassResolver = $796857cfd52069a9$var$_interopRequireDefault((parcelRequire("1rMZi")));
function $796857cfd52069a9$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $796857cfd52069a9$var$ScreenClassRender = function ScreenClassRender(_ref) {
    var render = _ref.render;
    return /*#__PURE__*/ $796857cfd52069a9$var$_react.default.createElement($796857cfd52069a9$var$_ScreenClassResolver.default, null, function(screenClass) {
        return render(screenClass);
    });
};
$796857cfd52069a9$var$ScreenClassRender.propTypes = {
    /**
   * The function which return value will be rendered.
   * Will be called with one argument: the screen class.
   */ render: $796857cfd52069a9$var$_propTypes.default.func.isRequired
};
var $796857cfd52069a9$var$_default = $796857cfd52069a9$var$ScreenClassRender;
module.exports.default = $796857cfd52069a9$var$_default;

});


parcelRegister("1zeHk", function(module, exports) {

$parcel$export(module.exports, "default", () => $12447608bf4bb1ec$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");
var $12447608bf4bb1ec$export$2e2bcd8739ae039 = (0, $g5DHJ.Map)({
    smallHits: (0, $g5DHJ.Map)({
        xl: 4,
        lg: 4,
        md: 4,
        sm: 12,
        xs: 12
    })
});

});

parcelRegister("7QPXA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b75b1e796b8ee21$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $hvUUg = parcelRequire("hvUUg");

var $fEeDC = parcelRequire("fEeDC");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $2Ywog = parcelRequire("2Ywog");

var $90ON9 = parcelRequire("90ON9");

var $lHkHI = parcelRequire("lHkHI");
function $5b75b1e796b8ee21$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5b75b1e796b8ee21$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5b75b1e796b8ee21$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5b75b1e796b8ee21$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5b75b1e796b8ee21$var$HitsContainer = (0, $3UXZ8.default)("div", {
    target: "e8zl7vk0",
    label: "HitsContainer"
})((0, $hvUUg.baseStylesCss), "");
class $5b75b1e796b8ee21$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)($5b75b1e796b8ee21$var$HitsContainer, {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2Ywog.default), $5b75b1e796b8ee21$var$_objectSpread({
                fromSearch: false
            }, this.props))
        });
    }
}
(0, $5zQU9.default)($5b75b1e796b8ee21$export$2e2bcd8739ae039, "propTypes", {
    /**
   * Given a hit type (small tiles or large tiles), and a `screenClass`, how many
   * "columns" should a hit take up? 12 columns = 100% width, so setting "largeHits" and
   * "xl" to `4` means that on the largest screens, there will be 3 hits per row.
   * If specified, this property should contain every combination of hit type and `screenClass`.
   *
   * shape: Map({
   *      xl: number (optional),
   *      lg: number (optional),
   *      md: number (optional),
   *      sm: number (optional),
   *      xs: number (optional)
   * })
   */ colSpan: (0, $90ON9.default).colSpan,
    /**
   * A map of callbacks for when hit-related actions occur such as click or mount, plus
   * functions for resolving relative URLs in search results into absolute URLs.
   *
   * shape: Map({
   *      hitHrefResolver: function (optional),
   *      hitImageHrefResolver: function,
   *      onHitClick: function,
   *      onHitMount: function (optional),
   *      onRatingsClick: function (optional)
   * })
   */ hitContext: (0, $90ON9.default).hitContext,
    /**
   * A list of hits to render.
   *
   * shape: List.of(
   *      hit(): Record({
   *          _highlightResult: Map({
   *              name: Map({
   *                  matchLevel: string,
   *                  value: string
   *              }),
   *              tokenizedName: List.of(
   *                  Map({
   *                      matchLevel: string,
   *                      value: string
   *                  })
   *              ),
   *              tagLine: Map({
   *                  matchLevel: string,
   *                  value: string
   *              }),
   *              tokenizedTagLine: List.of(
   *                  Map({
   *                      matchLevel: string,
   *                      value: string
   *                  })
   *              )
   *          }),
   *          addonId: number,
   *          addonKey: string,
   *          releaseDate: number,
   *          name: string,
   *          tagLine: string (optional),
   *          categories: string,
   *          deployments: List.of(string),
   *          documentType: string,
   *          logo: Map({
   *              image: string (optional),
   *              highRes: string (optional),
   *              smallImage: string (optional),
   *              smallHighResImage: string (optional)
   *          }),
   *          vendor: Map({
   *              isTopVendor: boolean
   *          }),
   *          distribution: Map({
   *              activeInstalls: number (optional),
   *              downloads: number,
   *              bundled: boolean,
   *              deltaInstalls: number
   *          )},
   *          version: Map({
   *              compatibilities: List.of(
   *                  Map({
   *                      applicationKey: string,
   *                      applicationName: string,
   *                      hosting: string
   *                  })
   *              )
   *          }),
   *          ratings: Map({
   *              avgStars: number,
   *              numRatings: number
   *          })
   *      })
   *  )
   */ hits: (0, (/*@__PURE__*/$parcel$interopDefault($fEeDC))).listOf((0, $90ON9.default).hit()).isRequired,
    /**
   * "large" | "small"
   * The size of each hit to render.
   */ hitSize: (0, $90ON9.default).hitSize.isRequired,
    /**
   * If defined, the maximum number of hits to render.
   */ maxLength: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * A callback for when a hit's category is clicked.
   */ onCategoryClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * "xl" | "lg" | "md" | "sm" | "xs"
   * Which "responsive view" to render, based on browser window size. Generally, you will use
   * ScreenClassRender from react-grid-system and pass in the value from that.
   */ screenClass: (0, $90ON9.default).screenClass.isRequired,
    /**
   * A unique ID for the results. If not specified, one will be generated, and re-generated
   * every time the `hits` prop changes.
   */ searchId: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number
});
(0, $5zQU9.default)($5b75b1e796b8ee21$export$2e2bcd8739ae039, "defaultProps", {
    colSpan: (0, $g5DHJ.Map)(),
    hitSize: 'large',
    screenClass: 'xl'
});

});

parcelRegister("hcvuS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c85bfd4dff8c434b$export$2e2bcd8739ae039);

var $1zZny = parcelRequire("1zZny");
const $c85bfd4dff8c434b$var$recommendLabels = {
    [(0, $1zZny.HitsType).recommendedApps]: {
        title: 'Recommended for you',
        description: 'Based on the apps that are currently installed on your $product instance'
    },
    [(0, $1zZny.HitsType).newAndNoteworthyApps]: {
        title: 'New and Noteworthy apps',
        description: ''
    }
};
var $c85bfd4dff8c434b$export$2e2bcd8739ae039 = $c85bfd4dff8c434b$var$recommendLabels;

});
parcelRegister("1zZny", function(module, exports) {

$parcel$export(module.exports, "HitsType", () => $1268abe9c5c56559$export$f23753736a199126);
const $1268abe9c5c56559$export$f23753736a199126 = Object.freeze({
    newAndNoteworthyApps: 'newAndNoteworthyApps',
    recommendedApps: 'recommendedApps'
});

});


parcelRegister("2cDWd", function(module, exports) {

$parcel$export(module.exports, "trackTileRenders", () => $19abae96cb80b45d$export$def705c7c6d9d65f);

var $5zQU9 = parcelRequire("5zQU9");

var $gaiog = parcelRequire("gaiog");
var $lNaxt = parcelRequire("lNaxt");

var $k8gZV = parcelRequire("k8gZV");
function $19abae96cb80b45d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $19abae96cb80b45d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $19abae96cb80b45d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $19abae96cb80b45d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $19abae96cb80b45d$var$ANALYTICS_SUBJECT_ID_RECOMMENDATION_TILES = 'recommendationTiles';
const $19abae96cb80b45d$var$EVENT_CHANNEL = 'addonDiscovery';
const $19abae96cb80b45d$var$OBJECT_TYPE_APP = 'app';
const $19abae96cb80b45d$var$TilesRenderedEvent = {
    action: (0, $gaiog.ANALYTICS_ACTION_RENDERED),
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_TILES),
    details: 'Marketplace recommendation app tiles were rendered and are now visible to the user',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $19abae96cb80b45d$var$handleAnalyticsEvent = (fireAnalyticsEvent)=>(actionSubjectId, attributes)=>{
        fireAnalyticsEvent({
            eventType: $19abae96cb80b45d$var$TilesRenderedEvent,
            objectType: $19abae96cb80b45d$var$OBJECT_TYPE_APP,
            actionSubjectId: actionSubjectId,
            attributes: $19abae96cb80b45d$var$_objectSpread({}, attributes)
        }, $19abae96cb80b45d$var$EVENT_CHANNEL);
    };
const $19abae96cb80b45d$export$def705c7c6d9d65f = (props)=>{
    const recommendationsData = props.recommendationsResult.hits;
    const fireEvent = $19abae96cb80b45d$var$handleAnalyticsEvent(props.fireAnalyticsEvent);
    if (recommendationsData && recommendationsData.size) {
        const ecosystemCloudAppTiles = recommendationsData.filter((0, $k8gZV.isEcosystemCloudApp));
        const ecosystemCloudAppKeys = ecosystemCloudAppTiles.map((tile)=>({
                key: tile.addonKey,
                isEcosystemCloudApp: true
            }));
        const { hasCloudFortifiedBadge: hasCloudFortifiedBadge, hasCloudSecurityBadge: hasCloudSecurityBadge } = (0, $k8gZV.certificationBadgeResolver)();
        fireEvent($19abae96cb80b45d$var$ANALYTICS_SUBJECT_ID_RECOMMENDATION_TILES, {
            totalTiles: recommendationsData.size,
            totalTilesWithCloudSecurityBadge: recommendationsData.filter(hasCloudSecurityBadge).size,
            totalTilesWithCloudFortifiedBadge: recommendationsData.filter(hasCloudFortifiedBadge).size,
            appKeys: ecosystemCloudAppKeys,
            totalEcosystemCloudAppTiles: ecosystemCloudAppTiles.size,
            hitsType: props.recommendationsResult.hitsType
        });
    }
};

});


parcelRegister("6XDNr", function(module, exports) {

$parcel$export(module.exports, "default", () => $51171f84a5f42d79$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $lgRZl = parcelRequire("lgRZl");

var $g5DHJ = parcelRequire("g5DHJ");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("jJs3W");
var $b02ud = parcelRequire("b02ud");


var $90ON9 = parcelRequire("90ON9");

var $b5Eig = parcelRequire("b5Eig");

var $emLm3 = parcelRequire("emLm3");

var $8OnOc = parcelRequire("8OnOc");

var $iXJMo = parcelRequire("iXJMo");

var $lqDCJ = parcelRequire("lqDCJ");

var $lHkHI = parcelRequire("lHkHI");
function $51171f84a5f42d79$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $51171f84a5f42d79$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $51171f84a5f42d79$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $51171f84a5f42d79$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $51171f84a5f42d79$var$App = (props)=>{
    const store = (0, $eUqFw.useMemo)(()=>(0, $emLm3.default)({
            debug: props.debug,
            reducer: $lqDCJ.default
        }), []);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $b02ud.default), {
        store: store,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $iXJMo.default), $51171f84a5f42d79$var$_objectSpread($51171f84a5f42d79$var$_objectSpread({}, props), {}, {
            algoliaClient: props.algoliaClient || (0, $8OnOc.createAlgoliaClient)(props.algoliaConfig.toObject())
        }))
    });
};
$51171f84a5f42d79$var$App.propTypes = {
    /**
   * Algolia config, ie. Application and API keys
   *
   * shape: Map({
   *      applicationId: string,
   *      apiKey: string
   * })
   *
   * Required if Algolia Client is not provided
   */ algoliaConfig: (0, $lgRZl.default).requiredIf((0, $90ON9.default).algoliaConfig, (props)=>!props.algoliaClient),
    /**
   * Algolia search client for maintaining cache between searches
   * Provided by third-party algoliasearch library, and not dereferenced
   *
   * shape: any (but must have AlgoliaClient class name)
   *
   * Required if Algolia Config is not provided
   */ algoliaClient: (0, $lgRZl.default).requiredIf((0, $90ON9.default).algoliaClient, (props)=>!props.algoliaConfig),
    /**
   * A SearchParamsUpdate where:
   * types: Set<FacetType>
   * apply: (AlgoliaSearchHelper.SearchParameters) => AlgoliaSearchHelper.SearchParameters
   *
   * `types` lets you define a set of facets that aren't already known to Addon Discovery but are defined
   * in Algolia. `apply` lets you apply relevant filtering to the SearchParameters.
   */ applyOverrides: (0, $b5Eig.SearchParamsUpdatePropType),
    /**
   * List<FeaturedContentOverride>
   * For each FeaturedContentOverride, we will always render the node from `render()` in place of the
   * tile at `index`.
   *
   * shape: List.of(
   *      featuredContentOverride : Record({
   *           index: number,
   *           render: function
   *      })
   * )
   */ contentOverrides: (0, $90ON9.default).contentOverrides,
    /**
   * A class name to apply to the top-level element.
   */ containerClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    /**
   * When true, will turn on debug mode.
   */ debug: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * Which environment we are running in.
   */ environment: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        (0, $658e6bd3ffbfdac1$export$404582bc18fe4d9e),
        (0, $658e6bd3ffbfdac1$export$46be287603848c56),
        (0, $658e6bd3ffbfdac1$export$e51cdc15d0c6bee2)
    ]).isRequired,
    /**
   * Map<string, string | Set<string>>
   * The filters to apply to the search facets. Each key corresponds to a facet name.
   * Accepts "unenhanced" filters, meaning that for filters that accept
   * multiple values, it will also accept a single value.
   */ filters: (0, $90ON9.default).filters,
    /**
   * When true, the "Load more results" button will not be rendered even if there are
   * more possible results to fetch.
   */ hidePagination: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    /**
   * A map of callbacks for when hit-related actions occur such as click or mount, plus
   * functions for resolving relative URLs in search results into absolute URLs.
   *
   * shape: Map({
   *     hitHrefResolver: function (optional),
   *     hitImageHrefResolver: function,
   *     onHitClick: function,
   *     onHitMount: function (optional),
   *     onRatingsClick: function (optional)
   * })
   */ hitContext: (0, $90ON9.default).hitContext.isRequired,
    /**
   * "large" | "small"
   * The size of each hit to render.
   */ hitSize: (0, $90ON9.default).hitSize,
    /**
   * If defined, the maximum number of hits to render.
   */ maxLength: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).number,
    /**
   * ({ currentPage: number }) => void
   * A callback for when the "Load more results" button is clicked. This overrides the default
   * behaviour of fetching another page of results.
   */ onLoadMoreResultsClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    /**
   * Map<string,
   *     ({ params: AlgoliaSearchHelper.SearchParameters, filters: Filters }) => AlgoliaSearchHelper.SearchParameters>
   * With the key being a facet, each function allows low-level modifications to the SearchParameters sent to Algolia.
   */ resolveAlgoliaQueryFilterOverrides: (0, $90ON9.default).resolveAlgoliaQueryFilterOverrides,
    /**
   * (List<Hit>) => List<Hit>
   * A function that reorders the given list of hits to a desired order.
   * If provided, only one page of results will ever be displayed.
   */ sortHits: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
};
$51171f84a5f42d79$var$App.defaultProps = {
    colSpan: (0, $g5DHJ.Map)(),
    debug: false,
    applyOverrides: (0, $b5Eig.default).default_(),
    filters: (0, $g5DHJ.Map)(),
    hidePagination: false,
    screenClass: 'xl'
};
var $51171f84a5f42d79$export$2e2bcd8739ae039 = $51171f84a5f42d79$var$App;

});
parcelRegister("iXJMo", function(module, exports) {

$parcel$export(module.exports, "default", () => $dce13f907d833a6d$export$2e2bcd8739ae039);
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");

var $kKkev = parcelRequire("kKkev");

var $kUEnb = parcelRequire("kUEnb");
function $dce13f907d833a6d$var$mapStateToProps(state) {
    return {
        search: state.get('search')
    };
}
function $dce13f907d833a6d$var$mapDispatchToProps(dispatch, ownProps) {
    return {
        doFreshSearch (_ref) {
            let { filters: filters, resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides, featureFlags: featureFlags } = _ref;
            dispatch((0, $kKkev.doFreshSearch)({
                algoliaClient: ownProps.algoliaClient,
                applyOverrides: ownProps.applyOverrides,
                environment: ownProps.environment,
                filters: filters,
                resolveAlgoliaQueryFilterOverrides: resolveAlgoliaQueryFilterOverrides,
                featureFlags: featureFlags
            }));
        },
        onLoadMoreResultsClick (_ref2) {
            let { currentPage: currentPage, featureFlags: featureFlags } = _ref2;
            if (ownProps.onLoadMoreResultsClick) ownProps.onLoadMoreResultsClick({
                currentPage: currentPage
            });
            dispatch((0, $kKkev.loadMoreResults)({
                algoliaClient: ownProps.algoliaClient,
                applyOverrides: ownProps.applyOverrides,
                environment: ownProps.environment,
                filters: ownProps.filters,
                nextPage: currentPage + 1,
                resolveAlgoliaQueryFilterOverrides: ownProps.resolveAlgoliaQueryFilterOverrides,
                featureFlags: featureFlags
            }));
        }
    };
}
var $dce13f907d833a6d$export$2e2bcd8739ae039 = (0, $94zHK.default)($dce13f907d833a6d$var$mapStateToProps, $dce13f907d833a6d$var$mapDispatchToProps)((0, $kUEnb.default));

});
parcelRegister("kUEnb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f3985ad36e06b010$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $hvUUg = parcelRequire("hvUUg");

var $biTOe = parcelRequire("biTOe");
var $9l6Pq = parcelRequire("9l6Pq");

var $hjlb6 = parcelRequire("hjlb6");

var $eUqFw = parcelRequire("eUqFw");

var $3qG4B = parcelRequire("3qG4B");

var $lHkHI = parcelRequire("lHkHI");
const $f3985ad36e06b010$var$StaticSearchContainer = (0, $3UXZ8.default)("div", {
    target: "e78wpkx0",
    label: "StaticSearchContainer"
})((0, $hvUUg.baseStylesCss), "");
class $f3985ad36e06b010$var$StaticSearch extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onLoadMoreResultsClick", (_ref)=>{
            let { currentPage: currentPage } = _ref;
            this.transitionStarted();
            this.props.onLoadMoreResultsClick({
                currentPage: currentPage
            });
        });
    }
    componentDidMount() {
        this.doFreshSearch({
            filters: this.props.filters
        });
    }
    componentDidUpdate(prevProps) {
        const newFilters = this.props.filters;
        if (!newFilters.equals(prevProps.filters)) this.doFreshSearch({
            filters: newFilters
        });
        if (this.props.transitions && this.props.transitions.get('transitionStarted') && prevProps.search.get('searchInProgress') && !this.props.search.get('searchInProgress')) this.props.transitions.get('transitionCompleted')();
    }
    doFreshSearch(_ref2) {
        var _this$props$statsigCl;
        let { filters: filters } = _ref2;
        const { enableV2SearchIndex: enableV2SearchIndex } = this.props;
        const showCompassApps = (_this$props$statsigCl = this.props.statsigClient) === null || _this$props$statsigCl === void 0 ? void 0 : _this$props$statsigCl.showCompassApps();
        this.transitionStarted();
        this.props.doFreshSearch({
            filters: filters,
            featureFlags: {
                enableV2SearchIndex: enableV2SearchIndex,
                showCompassApps: !!showCompassApps
            }
        });
    }
    transitionStarted() {
        if (this.props.transitions && this.props.transitions.get('transitionStarted')) this.props.transitions.get('transitionStarted')();
    }
    render() {
        const hits = this.props.sortHits && this.props.search.getIn([
            'searchResults',
            'hits'
        ]) ? this.props.sortHits(this.props.search.getIn([
            'searchResults',
            'hits'
        ])) : this.props.search.getIn([
            'searchResults',
            'hits'
        ]);
        const numberOfPages = this.props.sortHits ? 1 : this.props.search.getIn([
            'searchResults',
            'numberOfPages'
        ]);
        return /*#__PURE__*/ (0, $lHkHI.jsx)($f3985ad36e06b010$var$StaticSearchContainer, {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($hjlb6)))(this.props.containerClassName, this.props.className),
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3qG4B.default), {
                colSpan: this.props.colSpan,
                contentOverrides: this.props.contentOverrides,
                currentPage: this.props.search.get('currentPage'),
                dataError: this.props.search.get('dataError'),
                dataErrorMessages: this.props.search.get('dataErrorMessages'),
                filters: this.props.filters,
                hidePagination: this.props.hidePagination,
                hitContext: this.props.hitContext,
                hitSize: this.props.hitSize,
                hits: hits,
                loading: !this.props.search.get('initialized'),
                loadingMoreResults: this.props.search.get('loadingMoreResults'),
                maxLength: this.props.maxLength,
                moreResultsDataError: this.props.search.get('moreResultsDataError'),
                moreResultsDataErrorMessages: this.props.search.get('moreResultsDataErrorMessages'),
                numberOfPages: numberOfPages,
                onLoadMoreResultsClick: this.onLoadMoreResultsClick,
                screenClass: this.props.screenClass,
                searchId: this.props.search.get('currentSearchId')
            })
        });
    }
}
var $f3985ad36e06b010$export$2e2bcd8739ae039 = (0, $biTOe.withFeatureFlags)((0, $9l6Pq.withStatsig)($f3985ad36e06b010$var$StaticSearch));

});


parcelRegister("lqDCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f99ac319f84df5ed$export$2e2bcd8739ae039);

var $8x3tg = parcelRequire("8x3tg");

var $ayd98 = parcelRequire("ayd98");
const $f99ac319f84df5ed$var$store = (0, $8x3tg.combineReducers)({
    search: (0, $ayd98.default)
});
var $f99ac319f84df5ed$export$2e2bcd8739ae039 = $f99ac319f84df5ed$var$store;

});



parcelRegister("1S6Gv", function(module, exports) {

$parcel$export(module.exports, "initSentry", () => $15d004ff874d7070$export$f5ae3c4820871661);
$parcel$export(module.exports, "attachGlobalSentryListeners", () => $15d004ff874d7070$export$3e63e46a6b1c4e7e);
$parcel$export(module.exports, "detachSentryListeners", () => $15d004ff874d7070$export$f709362b9fa5f73d);

var $5zQU9 = parcelRequire("5zQU9");

var $fPzSk = parcelRequire("fPzSk");
var $jaeY6 = parcelRequire("jaeY6");
var $2gk4m = parcelRequire("2gk4m");
var $jLMZ4 = parcelRequire("jLMZ4");
var $jwnlf = parcelRequire("jwnlf");
var $fytMA = parcelRequire("fytMA");

var $HeIBQ = parcelRequire("HeIBQ");

var $4xrfU = parcelRequire("4xrfU");

var $cdSID = parcelRequire("cdSID");

var $7lvGB = parcelRequire("7lvGB");

var $ighTk = parcelRequire("ighTk");
function $15d004ff874d7070$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $15d004ff874d7070$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $15d004ff874d7070$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $15d004ff874d7070$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $15d004ff874d7070$var$getEmceePath() {
    if (window.location.href.includes('emcee')) return window.location.hash.split('#')[1];
}
const $15d004ff874d7070$var$getFormattedEventWithTags = (event)=>{
    let message = '';
    let tags = {};
    const args = event.message;
    const pathname = $15d004ff874d7070$var$getEmceePath();
    message = args.filter((arg)=>typeof arg === 'string' || arg.constructor !== Object).join(' ');
    tags = args.filter((arg)=>arg.constructor === Object).reduce((arg, tagsAccumulated)=>$15d004ff874d7070$var$_objectSpread($15d004ff874d7070$var$_objectSpread({}, tagsAccumulated), (0, $7lvGB.objectToPathValuePair)(arg)), {});
    $fytMA.withScope((scope)=>{
        scope.setExtra('arguments', args);
    });
    message = message || JSON.stringify(args);
    return $15d004ff874d7070$var$_objectSpread($15d004ff874d7070$var$_objectSpread($15d004ff874d7070$var$_objectSpread({}, event), pathname && {
        request: $15d004ff874d7070$var$_objectSpread($15d004ff874d7070$var$_objectSpread({}, event.request), {}, {
            url: pathname
        })
    }), {}, {
        message: message,
        // This is display error message in the header
        exception: message,
        tags: $15d004ff874d7070$var$_objectSpread($15d004ff874d7070$var$_objectSpread({}, event.tags), tags)
    });
};
const $15d004ff874d7070$var$beforeSend = (event)=>{
    const formattedEvent = Array.isArray(event.message) ? $15d004ff874d7070$var$getFormattedEventWithTags(event) : event;
    (0, $cdSID.default).add(formattedEvent.event_id);
    return formattedEvent;
};
const $15d004ff874d7070$var$ignoredHTTPTraffic = [
    /api.segment.io/,
    /google-analytics.com/,
    /https:\/\/xid\./,
    /pingdom.net/,
    /stats.g.doubleclick.net/,
    /api-private.atlassian.com\/gasv3/,
    /hn.inspectlet.com/,
    /events.launchdarkly.com/,
    /gateway\/api\/session\/heartbeat/,
    /logx.optimizely.com\/v1\/events/,
    /gateway\/api\/gasv3\/api\/v1/
];
const $15d004ff874d7070$var$beforeBreadcrumb = (crumb)=>{
    if (crumb.type === 'http' && $15d004ff874d7070$var$ignoredHTTPTraffic.some((denyUrl)=>denyUrl.test(crumb.data.url))) return false;
    return crumb;
};
async function $15d004ff874d7070$var$SHA256(message) {
    var _window$crypto;
    if (!((_window$crypto = window.crypto) !== null && _window$crypto !== void 0 && _window$crypto.subtle)) return;
    return window.crypto.subtle.digest('SHA-256', new TextEncoder().encode(message));
}
let $15d004ff874d7070$var$isCapturingGlobalErrors = false;
/**
 * Adds a prefix to exception messages
 */ function $15d004ff874d7070$var$prefixExceptionValue(event) {
    var _event$exception, _event$exception$valu;
    const exceptionValue = (_event$exception = event.exception) === null || _event$exception === void 0 ? void 0 : (_event$exception$valu = _event$exception.values) === null || _event$exception$valu === void 0 ? void 0 : _event$exception$valu[0].value;
    if (!exceptionValue) return null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($4xrfU)))([
        'exception',
        'values',
        '0',
        'value'
    ])("[Marketplace] ".concat(exceptionValue))(event);
}
function $15d004ff874d7070$export$f5ae3c4820871661(sentryConfig) {
    let sentryInstance = (0, $ighTk.default)(false);
    if (sentryInstance) return sentryInstance;
    const integrations = sentryConfig.setupGlobalListeners ? [
        ...$jaeY6.defaultIntegrations,
        new (0, $HeIBQ.Integrations).BrowserTracing()
    ] : [
        ...$jaeY6.defaultIntegrations.filter((integration)=>integration.name !== 'GlobalHandlers'),
        new (0, $HeIBQ.Integrations).BrowserTracing()
    ];
    const tracesSampler = ()=>{
        if (sentryConfig.environment === 'production') return 0.5;
        return 1;
    };
    const sentryOptions = {
        dsn: sentryConfig.dsn,
        beforeBreadcrumb: $15d004ff874d7070$var$beforeBreadcrumb,
        environment: sentryConfig.environment,
        attachStacktrace: true,
        release: sentryConfig.releaseVersion,
        denyUrls: [
            /cdn.segment.com/
        ],
        beforeSend: $15d004ff874d7070$var$beforeSend,
        integrations: integrations,
        tracesSampler: tracesSampler,
        normalizeDepth: 5
    };
    if (sentryConfig.setupGlobalListeners) {
        $jaeY6.init(sentryOptions);
        // sentry init() internally creates a hub
        sentryInstance = (0, $ighTk.setSentryClient)($jLMZ4.getCurrentHub());
    } else {
        const client = new $fPzSk.BrowserClient($15d004ff874d7070$var$_objectSpread({
            transport: $jwnlf.makeFetchTransport,
            stackParser: $2gk4m.defaultStackParser,
            integrations: integrations
        }, sentryConfig));
        sentryInstance = (0, $ighTk.setSentryClient)(new $jLMZ4.Hub(client), true);
    }
    if (sentryConfig.productVersion) sentryInstance.setTag('productVersion', sentryConfig.productVersion);
    $15d004ff874d7070$var$isCapturingGlobalErrors = sentryConfig.setupGlobalListeners;
}
function $15d004ff874d7070$export$3e63e46a6b1c4e7e(onSentryEvent) {
    $15d004ff874d7070$var$isCapturingGlobalErrors = true;
    onSentryEvent((event)=>{
        var _event$tags, _event$tags2;
        if (!$15d004ff874d7070$var$isCapturingGlobalErrors) return;
        const hasBeenPreviouslyProcessed = ((_event$tags = event.tags) === null || _event$tags === void 0 ? void 0 : _event$tags.structuredLog) || ((_event$tags2 = event.tags) === null || _event$tags2 === void 0 ? void 0 : _event$tags2.processedError);
        const rewrittenEvent = $15d004ff874d7070$var$prefixExceptionValue(event);
        if (!hasBeenPreviouslyProcessed && rewrittenEvent) {
            rewrittenEvent.tags = $15d004ff874d7070$var$_objectSpread($15d004ff874d7070$var$_objectSpread({}, event.tags), {}, {
                processedError: 'true'
            });
            const sentryInstance = (0, $ighTk.default)(false);
            sentryInstance === null || sentryInstance === void 0 || sentryInstance.captureEvent(rewrittenEvent);
        }
    });
}
function $15d004ff874d7070$export$f709362b9fa5f73d() {
    $15d004ff874d7070$var$isCapturingGlobalErrors = false;
}
async function $15d004ff874d7070$export$55ca9de3e3dcdd17(id) {
    const saltedId = "KE3WvP2iYT14lIfa".concat(id, "ATtNdgf1Qhok0D9bhv");
    const userIdHashed = await $15d004ff874d7070$var$SHA256(saltedId);
    const sentryInstance = (0, $ighTk.default)();
    sentryInstance === null || sentryInstance === void 0 || sentryInstance.configureScope((scope)=>{
        scope.setUser({
            id: userIdHashed
        });
    });
}

});
parcelRegister("HeIBQ", function(module, exports) {

$parcel$export(module.exports, "Integrations", () => $081f6f0e43c5117f$export$99d02219d259eb94);

var $6gKsn = parcelRequire("6gKsn");
var $bv9YB = parcelRequire("bv9YB");
var $aYACQ = parcelRequire("aYACQ");
var $lpkeJ = parcelRequire("lpkeJ");
var $8szh8 = parcelRequire("8szh8");
var $3LZi0 = parcelRequire("3LZi0");
var $ebD1W = parcelRequire("ebD1W");
var $kWON5 = parcelRequire("kWON5");
var $9hRAY = parcelRequire("9hRAY");
var $26wej = parcelRequire("26wej");
var $571pR = parcelRequire("571pR");
var $he8el = parcelRequire("he8el");
var $d1Bxg = parcelRequire("d1Bxg");
var $fv3Z4 = parcelRequire("fv3Z4");
var $cIUeM = parcelRequire("cIUeM");
var $kBpSh = parcelRequire("kBpSh");
var $103Ol = parcelRequire("103Ol");
var $d4cKa = parcelRequire("d4cKa");
var $fTr2B = parcelRequire("fTr2B");
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ const $081f6f0e43c5117f$export$46d3bbd0375f5fa4 = (0, $aYACQ.BrowserTracing);
// BrowserTracing is already exported as part of `Integrations` below (and for the moment will remain so for
// backwards compatibility), but that interferes with treeshaking, so we also export it separately
// here.
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
 *
 * import { BrowserTracing } from '@sentry/browser';
 * new BrowserTracing()
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $081f6f0e43c5117f$export$5a20b45239a3c0a6 = (0, $6gKsn.addExtensionMethods);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `getActiveTransaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $081f6f0e43c5117f$export$a7feb32fdd923295 = (0, $ebD1W.getActiveTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `extractTraceparentData` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $081f6f0e43c5117f$export$8e9a29865c0a1226 = (0, $3LZi0.extractTraceparentData);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `spanStatusfromHttpCode` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $081f6f0e43c5117f$export$ac65c70d78fcdb55 = (0, $cIUeM.spanStatusfromHttpCode);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `SpanStatusType` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $081f6f0e43c5117f$export$febc5573c75cefb0 = (0, $fTr2B.Transaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Transaction` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ const $081f6f0e43c5117f$export$5f1714a13ed34c01 = (0, $cIUeM.Span);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `Span` can be imported from `@sentry/node`, `@sentry/browser`, or your framework SDK
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $081f6f0e43c5117f$export$bbd2089f30bd3708 = (0, $aYACQ.BROWSER_TRACING_INTEGRATION_ID);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `defaultRequestInstrumentationOptions` can be imported from `@sentry/browser`, or your framework SDK
 */ const $081f6f0e43c5117f$export$cc17fb3c0bc95cd7 = (0, $lpkeJ.defaultRequestInstrumentationOptions);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `hasTracingEnabled` can be imported from `@sentry/utils`
 */ const $081f6f0e43c5117f$export$5008da00b1b6dee6 = (0, $9hRAY.hasTracingEnabled);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `stripUrlQueryAndFragment` can be imported from `@sentry/utils`
 */ const $081f6f0e43c5117f$export$ce084c78234bd35 = (0, $d4cKa.stripUrlQueryAndFragment);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 *
 * `TRACEPARENT_REGEXP` can be imported from `@sentry/utils`
 */ const $081f6f0e43c5117f$export$394a210812ba3012 = (0, $3LZi0.TRACEPARENT_REGEXP);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $081f6f0e43c5117f$export$b279e6bd7040371f = (0, $26wej.IdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ /**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $081f6f0e43c5117f$export$864489cb3478db3e = (0, $lpkeJ.instrumentOutgoingRequests);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ const $081f6f0e43c5117f$export$479dbd817e392a4f = (0, $103Ol.startIdleTransaction);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $081f6f0e43c5117f$export$beb8e6a823e89c5d = (0, $kBpSh.SpanStatus);
/**
 * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
 */ // eslint-disable-next-line deprecation/deprecation
const $081f6f0e43c5117f$export$99d02219d259eb94 = {
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `BrowserTracing` can be imported from `@sentry/browser` or your framework SDK
   *
   * import { BrowserTracing } from '@sentry/browser';
   * new BrowserTracing()
   */ // eslint-disable-next-line deprecation/deprecation
    BrowserTracing: $081f6f0e43c5117f$export$46d3bbd0375f5fa4,
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Apollo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Apollo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Apollo: (0, $bv9YB.Apollo),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Express` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Express({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Express: (0, $8szh8.Express),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `GraphQL` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.GraphQL({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    GraphQL: (0, $kWON5.GraphQL),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mongo` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mongo({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mongo: (0, $571pR.Mongo),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Mysql` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Mysql({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Mysql: (0, $he8el.Mysql),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Postgres` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Postgres({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Postgres: (0, $d1Bxg.Postgres),
    /**
   * @deprecated `@sentry/tracing` has been deprecated and will be moved to to `@sentry/node`, `@sentry/browser`, or your framework SDK in the next major version.
   * `Prisma` can be imported from `@sentry/node`
   *
   * import { Integrations } from '@sentry/node';
   * new Integrations.Prisma({ ... })
   */ // eslint-disable-next-line deprecation/deprecation
    Prisma: (0, $fv3Z4.Prisma)
};
// Treeshakable guard to remove all code related to tracing
// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) // We are patching the global object with our hub extension methods
(0, $6gKsn.addExtensionMethods)();

});
parcelRegister("6gKsn", function(module, exports) {

$parcel$export(module.exports, "addExtensionMethods", () => addExtensionMethods);

var $103Ol = parcelRequire("103Ol");
var $7Qe7s = parcelRequire("7Qe7s");

var $fEKkD = parcelRequire("fEKkD");
/**
 * @private
 */ function _autoloadDatabaseIntegrations() {
    const carrier = (0, $7Qe7s.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    const packageToIntegrationMapping = {
        mongodb () {
            const integration = (0, $fEKkD.dynamicRequire)(module, './node/integrations/mongo');
            return new integration.Mongo();
        },
        mongoose () {
            const integration = (0, $fEKkD.dynamicRequire)(module, './node/integrations/mongo');
            return new integration.Mongo({
                mongoose: true
            });
        },
        mysql () {
            const integration = (0, $fEKkD.dynamicRequire)(module, './node/integrations/mysql');
            return new integration.Mysql();
        },
        pg () {
            const integration = (0, $fEKkD.dynamicRequire)(module, './node/integrations/postgres');
            return new integration.Postgres();
        }
    };
    const mappedPackages = Object.keys(packageToIntegrationMapping).filter((moduleName)=>!!(0, $fEKkD.loadModule)(moduleName)).map((pkg)=>{
        try {
            return packageToIntegrationMapping[pkg]();
        } catch (e) {
            return undefined;
        }
    }).filter((p)=>p);
    if (mappedPackages.length > 0) carrier.__SENTRY__.integrations = [
        ...carrier.__SENTRY__.integrations || [],
        ...mappedPackages
    ];
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */ function addExtensionMethods() {
    (0, $103Ol.addTracingExtensions)();
    // Detect and automatically load specified integrations.
    if ((0, $fEKkD.isNodeEnv)()) _autoloadDatabaseIntegrations();
}

});
parcelRegister("103Ol", function(module, exports) {

$parcel$export(module.exports, "startIdleTransaction", () => $0ba8bf5499097e04$export$479dbd817e392a4f);
$parcel$export(module.exports, "addTracingExtensions", () => $0ba8bf5499097e04$export$653d0ef2bad9cdf9);

var $k7rM9 = parcelRequire("k7rM9");
var $elKLM = parcelRequire("elKLM");

var $7Qe7s = parcelRequire("7Qe7s");

var $9hRAY = parcelRequire("9hRAY");

var $cXhcW = parcelRequire("cXhcW");

var $26wej = parcelRequire("26wej");

var $fTr2B = parcelRequire("fTr2B");
/** Returns all trace headers that are currently on the top scope. */ function $0ba8bf5499097e04$var$traceHeaders() {
    const scope = this.getScope();
    const span = scope.getSpan();
    return span ? {
        'sentry-trace': span.toTraceparent()
    } : {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */ function $0ba8bf5499097e04$var$sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!(0, $9hRAY.hasTracingEnabled)(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            sampleRate: Number(transaction.sampled)
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` nor `enableTracing` were defined, so one of these should
    // work; prefer the hook if so
    let sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else if (samplingContext.parentSampled !== undefined) sampleRate = samplingContext.parentSampled;
    else if (typeof options.tracesSampleRate !== 'undefined') {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            sampleRate: Number(sampleRate)
        });
    } else {
        // When `enableTracing === true`, we use a sample rate of 100%
        sampleRate = 1;
        transaction.setMetadata({
            sampleRate: sampleRate
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!$0ba8bf5499097e04$var$isValidSampleRate(sampleRate)) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn('[Tracing] Discarding transaction because of invalid sample rate.');
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Discarding transaction because ${typeof options.tracesSampler === 'function' ? 'tracesSampler returned 0 or false' : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'}`);
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(sampleRate)})`);
        return transaction;
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */ function $0ba8bf5499097e04$var$isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if ((0, $k7rM9.isNaN)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(rate)} of type ${JSON.stringify(typeof rate)}.`);
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */ function $0ba8bf5499097e04$var$_startTransaction(transactionContext, customSamplingContext) {
    const client = this.getClient();
    const options = client && client.getOptions() || {};
    const configInstrumenter = options.instrumenter || 'sentry';
    const transactionInstrumenter = transactionContext.instrumenter || 'sentry';
    if (configInstrumenter !== transactionInstrumenter) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error(`A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`);
        transactionContext.sampled = false;
    }
    let transaction = new (0, $fTr2B.Transaction)(transactionContext, this);
    transaction = $0ba8bf5499097e04$var$sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Create new idle transaction.
 */ function $0ba8bf5499097e04$export$479dbd817e392a4f(hub, transactionContext, idleTimeout, finalTimeout, onScope, customSamplingContext, heartbeatInterval) {
    const client = hub.getClient();
    const options = client && client.getOptions() || {};
    let transaction = new (0, $26wej.IdleTransaction)(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
    transaction = $0ba8bf5499097e04$var$sample(transaction, options, {
        parentSampled: transactionContext.parentSampled,
        transactionContext: transactionContext,
        ...customSamplingContext
    });
    if (transaction.sampled) transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    if (client && client.emit) client.emit('startTransaction', transaction);
    return transaction;
}
/**
 * Adds tracing extensions to the global hub.
 */ function $0ba8bf5499097e04$export$653d0ef2bad9cdf9() {
    const carrier = (0, $7Qe7s.getMainCarrier)();
    if (!carrier.__SENTRY__) return;
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) carrier.__SENTRY__.extensions.startTransaction = $0ba8bf5499097e04$var$_startTransaction;
    if (!carrier.__SENTRY__.extensions.traceHeaders) carrier.__SENTRY__.extensions.traceHeaders = $0ba8bf5499097e04$var$traceHeaders;
    (0, $cXhcW.registerErrorInstrumentation)();
}

});
parcelRegister("k7rM9", function(module, exports) {

$parcel$export(module.exports, "isError", () => $ea5a01c26e7e3a1f$export$e6127cc7fe7395c3);
$parcel$export(module.exports, "isInstanceOf", () => $ea5a01c26e7e3a1f$export$49034edbe6b62415);
$parcel$export(module.exports, "isString", () => $ea5a01c26e7e3a1f$export$844ec244b1367d54);
$parcel$export(module.exports, "isPrimitive", () => $ea5a01c26e7e3a1f$export$c3825b437cbdea5c);
$parcel$export(module.exports, "isPlainObject", () => $ea5a01c26e7e3a1f$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isEvent", () => $ea5a01c26e7e3a1f$export$9671ea99bd126ace);
$parcel$export(module.exports, "isElement", () => $ea5a01c26e7e3a1f$export$45a5e7f76e0caa8d);
$parcel$export(module.exports, "isRegExp", () => $ea5a01c26e7e3a1f$export$49841c62b9eff15);
$parcel$export(module.exports, "isThenable", () => $ea5a01c26e7e3a1f$export$f5b060c2914b97c8);
$parcel$export(module.exports, "isSyntheticEvent", () => $ea5a01c26e7e3a1f$export$bc2894c7158efbac);
$parcel$export(module.exports, "isNaN", () => $ea5a01c26e7e3a1f$export$c9f5652083b8129d);
// eslint-disable-next-line @typescript-eslint/unbound-method
const $ea5a01c26e7e3a1f$var$objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$e6127cc7fe7395c3(wat) {
    switch($ea5a01c26e7e3a1f$var$objectToString.call(wat)){
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return $ea5a01c26e7e3a1f$export$49034edbe6b62415(wat, Error);
    }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$var$isBuiltin(wat, className) {
    return $ea5a01c26e7e3a1f$var$objectToString.call(wat) === `[object ${className}]`;
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$9f9636d330b71954(wat) {
    return $ea5a01c26e7e3a1f$var$isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$ef9e2056653f0c8e(wat) {
    return $ea5a01c26e7e3a1f$var$isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$12e869b2a583f783(wat) {
    return $ea5a01c26e7e3a1f$var$isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$844ec244b1367d54(wat) {
    return $ea5a01c26e7e3a1f$var$isBuiltin(wat, 'String');
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$c3825b437cbdea5c(wat) {
    return wat === null || typeof wat !== 'object' && typeof wat !== 'function';
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$53b83ca8eaab0383(wat) {
    return $ea5a01c26e7e3a1f$var$isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$9671ea99bd126ace(wat) {
    return typeof Event !== 'undefined' && $ea5a01c26e7e3a1f$export$49034edbe6b62415(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$45a5e7f76e0caa8d(wat) {
    return typeof Element !== 'undefined' && $ea5a01c26e7e3a1f$export$49034edbe6b62415(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$49841c62b9eff15(wat) {
    return $ea5a01c26e7e3a1f$var$isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */ function $ea5a01c26e7e3a1f$export$f5b060c2914b97c8(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$bc2894c7158efbac(wat) {
    return $ea5a01c26e7e3a1f$export$53b83ca8eaab0383(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$c9f5652083b8129d(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */ function $ea5a01c26e7e3a1f$export$49034edbe6b62415(wat, base) {
    try {
        return wat instanceof base;
    } catch (_e) {
        return false;
    }
}

});

parcelRegister("elKLM", function(module, exports) {

$parcel$export(module.exports, "CONSOLE_LEVELS", () => $a7274e53d5c777ba$export$2a2b1d2252a69ecb);
$parcel$export(module.exports, "consoleSandbox", () => $a7274e53d5c777ba$export$cda52e2a8927a2ca);
$parcel$export(module.exports, "logger", () => $a7274e53d5c777ba$export$af88d00dbe7f521);

var $dQTB1 = parcelRequire("dQTB1");
/** Prefix for logging strings */ const $a7274e53d5c777ba$var$PREFIX = 'Sentry Logger ';
const $a7274e53d5c777ba$export$2a2b1d2252a69ecb = [
    'debug',
    'info',
    'warn',
    'error',
    'log',
    'assert',
    'trace'
];
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */ function $a7274e53d5c777ba$export$cda52e2a8927a2ca(callback) {
    if (!('console' in (0, $dQTB1.GLOBAL_OBJ))) return callback();
    const originalConsole = (0, $dQTB1.GLOBAL_OBJ).console;
    const wrappedLevels = {};
    // Restore all wrapped console methods
    $a7274e53d5c777ba$export$2a2b1d2252a69ecb.forEach((level)=>{
        // TODO(v7): Remove this check as it's only needed for Node 6
        const originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in originalConsole && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    } finally{
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach((level)=>{
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function $a7274e53d5c777ba$var$makeLogger() {
    let enabled = false;
    const logger = {
        enable: ()=>{
            enabled = true;
        },
        disable: ()=>{
            enabled = false;
        }
    };
    if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) $a7274e53d5c777ba$export$2a2b1d2252a69ecb.forEach((name)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        logger[name] = (...args)=>{
            if (enabled) $a7274e53d5c777ba$export$cda52e2a8927a2ca(()=>{
                (0, $dQTB1.GLOBAL_OBJ).console[name](`${$a7274e53d5c777ba$var$PREFIX}[${name}]:`, ...args);
            });
        };
    });
    else $a7274e53d5c777ba$export$2a2b1d2252a69ecb.forEach((name)=>{
        logger[name] = ()=>undefined;
    });
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let $a7274e53d5c777ba$export$af88d00dbe7f521;
if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) $a7274e53d5c777ba$export$af88d00dbe7f521 = (0, $dQTB1.getGlobalSingleton)('logger', $a7274e53d5c777ba$var$makeLogger);
else $a7274e53d5c777ba$export$af88d00dbe7f521 = $a7274e53d5c777ba$var$makeLogger();

});
parcelRegister("dQTB1", function(module, exports) {

$parcel$export(module.exports, "GLOBAL_OBJ", () => $a15b41f059b7d958$export$f1a6cdb1459e81d1);
$parcel$export(module.exports, "getGlobalObject", () => $a15b41f059b7d958$export$256479dc0cea61c4);
$parcel$export(module.exports, "getGlobalSingleton", () => $a15b41f059b7d958$export$7e223ec222791509);
/** Internal global with common properties and Sentry extensions  */ // The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.
/** Returns 'obj' if it's the global object, otherwise returns undefined */ function $a15b41f059b7d958$var$isGlobalObj(obj) {
    return obj && obj.Math == Math ? obj : undefined;
}
/** Get's the global object for the current JavaScript runtime */ const $a15b41f059b7d958$export$f1a6cdb1459e81d1 = typeof globalThis == 'object' && $a15b41f059b7d958$var$isGlobalObj(globalThis) || // eslint-disable-next-line no-restricted-globals
typeof window == 'object' && $a15b41f059b7d958$var$isGlobalObj(window) || typeof self == 'object' && $a15b41f059b7d958$var$isGlobalObj(self) || typeof $parcel$global == 'object' && $a15b41f059b7d958$var$isGlobalObj($parcel$global) || function() {
    return this;
}() || {};
/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */ function $a15b41f059b7d958$export$256479dc0cea61c4() {
    return $a15b41f059b7d958$export$f1a6cdb1459e81d1;
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */ function $a15b41f059b7d958$export$7e223ec222791509(name, creator, obj) {
    const gbl = obj || $a15b41f059b7d958$export$f1a6cdb1459e81d1;
    const __SENTRY__ = gbl.__SENTRY__ = gbl.__SENTRY__ || {};
    const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

});


parcelRegister("7Qe7s", function(module, exports) {

$parcel$export(module.exports, "getMainCarrier", () => $5b5857818542040b$export$19eade501500c6c1);
$parcel$export(module.exports, "getCurrentHub", () => $5b5857818542040b$export$a07cdf6544bbd7c);

var $elKLM = parcelRequire("elKLM");
var $43Vyk = parcelRequire("43Vyk");
var $dQTB1 = parcelRequire("dQTB1");
var $fEKkD = parcelRequire("fEKkD");
var $aG8PM = parcelRequire("aG8PM");

var $94HCL = parcelRequire("94HCL");

var $drFYh = parcelRequire("drFYh");

var $8ureE = parcelRequire("8ureE");
/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */ const $5b5857818542040b$export$24a86ef7798177e4 = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */ const $5b5857818542040b$var$DEFAULT_BREADCRUMBS = 100;
/**
 * A layer in the process stack.
 * @hidden
 */ /**
 * @inheritDoc
 */ class $5b5857818542040b$export$8c41bb232f1008b1 {
    /** Is a {@link Layer}[] containing the client and scope */ /** Contains the last event id of a captured event.  */ /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */ constructor(client, scope = new (0, $drFYh.Scope)(), _version = $5b5857818542040b$export$24a86ef7798177e4){
        this._version = _version;
        this._stack = [
            {
                scope: scope
            }
        ];
        if (client) this.bindClient(client);
    }
    /**
   * @inheritDoc
   */ isOlderThan(version) {
        return this._version < version;
    }
    /**
   * @inheritDoc
   */ bindClient(client) {
        const top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) client.setupIntegrations();
    }
    /**
   * @inheritDoc
   */ pushScope() {
        // We want to clone the content of prev scope
        const scope = (0, $drFYh.Scope).clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope
        });
        return scope;
    }
    /**
   * @inheritDoc
   */ popScope() {
        if (this.getStack().length <= 1) return false;
        return !!this.getStack().pop();
    }
    /**
   * @inheritDoc
   */ withScope(callback) {
        const scope = this.pushScope();
        try {
            callback(scope);
        } finally{
            this.popScope();
        }
    }
    /**
   * @inheritDoc
   */ getClient() {
        return this.getStackTop().client;
    }
    /** Returns the scope of the top stack. */ getScope() {
        return this.getStackTop().scope;
    }
    /** Returns the scope stack for domains or the process. */ getStack() {
        return this._stack;
    }
    /** Returns the topmost scope layer in the order domain > local > process. */ getStackTop() {
        return this._stack[this._stack.length - 1];
    }
    /**
   * @inheritDoc
   */ captureException(exception, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $aG8PM.uuid4)();
        const syntheticException = new Error('Sentry syntheticException');
        this._withClient((client, scope)=>{
            client.captureException(exception, {
                originalException: exception,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureMessage(message, // eslint-disable-next-line deprecation/deprecation
    level, hint) {
        const eventId = this._lastEventId = hint && hint.event_id ? hint.event_id : (0, $aG8PM.uuid4)();
        const syntheticException = new Error(message);
        this._withClient((client, scope)=>{
            client.captureMessage(message, level, {
                originalException: message,
                syntheticException: syntheticException,
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ captureEvent(event, hint) {
        const eventId = hint && hint.event_id ? hint.event_id : (0, $aG8PM.uuid4)();
        if (!event.type) this._lastEventId = eventId;
        this._withClient((client, scope)=>{
            client.captureEvent(event, {
                ...hint,
                event_id: eventId
            }, scope);
        });
        return eventId;
    }
    /**
   * @inheritDoc
   */ lastEventId() {
        return this._lastEventId;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, hint) {
        const { scope: scope, client: client } = this.getStackTop();
        if (!client) return;
        const { beforeBreadcrumb: beforeBreadcrumb = null, maxBreadcrumbs: maxBreadcrumbs = $5b5857818542040b$var$DEFAULT_BREADCRUMBS } = client.getOptions && client.getOptions() || {};
        if (maxBreadcrumbs <= 0) return;
        const timestamp = (0, $43Vyk.dateTimestampInSeconds)();
        const mergedBreadcrumb = {
            timestamp: timestamp,
            ...breadcrumb
        };
        const finalBreadcrumb = beforeBreadcrumb ? (0, $elKLM.consoleSandbox)(()=>beforeBreadcrumb(mergedBreadcrumb, hint)) : mergedBreadcrumb;
        if (finalBreadcrumb === null) return;
        if (client.emit) client.emit('beforeAddBreadcrumb', finalBreadcrumb, hint);
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this.getScope().setUser(user);
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this.getScope().setTags(tags);
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this.getScope().setExtras(extras);
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.getScope().setTag(key, value);
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this.getScope().setExtra(key, extra);
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    setContext(name, context) {
        this.getScope().setContext(name, context);
    }
    /**
   * @inheritDoc
   */ configureScope(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(scope);
    }
    /**
   * @inheritDoc
   */ run(callback) {
        const oldHub = $5b5857818542040b$export$4188a14ad302d1bc(this);
        try {
            callback(this);
        } finally{
            $5b5857818542040b$export$4188a14ad302d1bc(oldHub);
        }
    }
    /**
   * @inheritDoc
   */ getIntegration(integration) {
        const client = this.getClient();
        if (!client) return null;
        try {
            return client.getIntegration(integration);
        } catch (_oO) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
            return null;
        }
    }
    /**
   * @inheritDoc
   */ startTransaction(context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    }
    /**
   * @inheritDoc
   */ traceHeaders() {
        return this._callExtensionMethod('traceHeaders');
    }
    /**
   * @inheritDoc
   */ captureSession(endSession = false) {
        // both send the update and pull the session from the scope
        if (endSession) return this.endSession();
        // only send the update
        this._sendSessionUpdate();
    }
    /**
   * @inheritDoc
   */ endSession() {
        const layer = this.getStackTop();
        const scope = layer.scope;
        const session = scope.getSession();
        if (session) (0, $8ureE.closeSession)(session);
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        scope.setSession();
    }
    /**
   * @inheritDoc
   */ startSession(context) {
        const { scope: scope, client: client } = this.getStackTop();
        const { release: release, environment: environment = (0, $94HCL.DEFAULT_ENVIRONMENT) } = client && client.getOptions() || {};
        // Will fetch userAgent if called from browser sdk
        const { userAgent: userAgent } = (0, $dQTB1.GLOBAL_OBJ).navigator || {};
        const session = (0, $8ureE.makeSession)({
            release: release,
            environment: environment,
            user: scope.getUser(),
            ...userAgent && {
                userAgent: userAgent
            },
            ...context
        });
        // End existing session if there's one
        const currentSession = scope.getSession && scope.getSession();
        if (currentSession && currentSession.status === 'ok') (0, $8ureE.updateSession)(currentSession, {
            status: 'exited'
        });
        this.endSession();
        // Afterwards we set the new session on the scope
        scope.setSession(session);
        return session;
    }
    /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */ shouldSendDefaultPii() {
        const client = this.getClient();
        const options = client && client.getOptions();
        return Boolean(options && options.sendDefaultPii);
    }
    /**
   * Sends the current Session on the scope
   */ _sendSessionUpdate() {
        const { scope: scope, client: client } = this.getStackTop();
        const session = scope.getSession();
        if (session && client && client.captureSession) client.captureSession(session);
    }
    /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */ _withClient(callback) {
        const { scope: scope, client: client } = this.getStackTop();
        if (client) callback(client, scope);
    }
    /**
   * Calls global extension method and binding current instance to the function call
   */ // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _callExtensionMethod(method, ...args) {
        const carrier = $5b5857818542040b$export$19eade501500c6c1();
        const sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') return sentry.extensions[method].apply(this, args);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`Extension method ${method} couldn't be found, doing nothing.`);
    }
}
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/ function $5b5857818542040b$export$19eade501500c6c1() {
    (0, $dQTB1.GLOBAL_OBJ).__SENTRY__ = (0, $dQTB1.GLOBAL_OBJ).__SENTRY__ || {
        extensions: {},
        hub: undefined
    };
    return 0, $dQTB1.GLOBAL_OBJ;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */ function $5b5857818542040b$export$4188a14ad302d1bc(hub) {
    const registry = $5b5857818542040b$export$19eade501500c6c1();
    const oldHub = $5b5857818542040b$export$bfa8a924a84a76b7(registry);
    $5b5857818542040b$export$849f05434e95d2f2(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */ function $5b5857818542040b$export$a07cdf6544bbd7c() {
    // Get main carrier (global for every environment)
    const registry = $5b5857818542040b$export$19eade501500c6c1();
    // If there's no hub, or its an old API, assign a new one
    if (!$5b5857818542040b$var$hasHubOnCarrier(registry) || $5b5857818542040b$export$bfa8a924a84a76b7(registry).isOlderThan($5b5857818542040b$export$24a86ef7798177e4)) $5b5857818542040b$export$849f05434e95d2f2(registry, new $5b5857818542040b$export$8c41bb232f1008b1());
    // Prefer domains over global if they are there (applicable only to Node environment)
    if ((0, $fEKkD.isNodeEnv)()) return $5b5857818542040b$var$getHubFromActiveDomain(registry);
    // Return hub that lives on a global object
    return $5b5857818542040b$export$bfa8a924a84a76b7(registry);
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */ function $5b5857818542040b$var$getHubFromActiveDomain(registry) {
    try {
        const sentry = $5b5857818542040b$export$19eade501500c6c1().__SENTRY__;
        const activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) return $5b5857818542040b$export$bfa8a924a84a76b7(registry);
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!$5b5857818542040b$var$hasHubOnCarrier(activeDomain) || $5b5857818542040b$export$bfa8a924a84a76b7(activeDomain).isOlderThan($5b5857818542040b$export$24a86ef7798177e4)) {
            const registryHubTopStack = $5b5857818542040b$export$bfa8a924a84a76b7(registry).getStackTop();
            $5b5857818542040b$export$849f05434e95d2f2(activeDomain, new $5b5857818542040b$export$8c41bb232f1008b1(registryHubTopStack.client, (0, $drFYh.Scope).clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return $5b5857818542040b$export$bfa8a924a84a76b7(activeDomain);
    } catch (_Oo) {
        // Return hub that lives on a global object
        return $5b5857818542040b$export$bfa8a924a84a76b7(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */ function $5b5857818542040b$var$hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */ function $5b5857818542040b$export$bfa8a924a84a76b7(carrier) {
    return (0, $dQTB1.getGlobalSingleton)('hub', ()=>new $5b5857818542040b$export$8c41bb232f1008b1(), carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */ function $5b5857818542040b$export$849f05434e95d2f2(carrier, hub) {
    if (!carrier) return false;
    const __SENTRY__ = carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    __SENTRY__.hub = hub;
    return true;
}

});
parcelRegister("43Vyk", function(module, exports) {

$parcel$export(module.exports, "dateTimestampInSeconds", () => dateTimestampInSeconds);
$parcel$export(module.exports, "timestampInSeconds", () => timestampInSeconds);
$parcel$export(module.exports, "timestampWithMs", () => timestampWithMs);
$parcel$export(module.exports, "browserPerformanceTimeOrigin", () => browserPerformanceTimeOrigin);

var $fEKkD = parcelRequire("fEKkD");

var $dQTB1 = parcelRequire("dQTB1");
// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0, $dQTB1.getGlobalObject)();
/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */ /**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */ const dateTimestampSource = {
    nowSeconds: ()=>Date.now() / 1000
};
/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */ /**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */ function getBrowserPerformance() {
    const { performance } = WINDOW;
    if (!performance || !performance.now) return undefined;
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    const timeOrigin = Date.now() - performance.now();
    return {
        now: ()=>performance.now(),
        timeOrigin: timeOrigin
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */ function getNodePerformance() {
    try {
        const perfHooks = (0, $fEKkD.dynamicRequire)(module, 'perf_hooks');
        return perfHooks.performance;
    } catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */ const platformPerformance = (0, $fEKkD.isNodeEnv)() ? getNodePerformance() : getBrowserPerformance();
const timestampSource = platformPerformance === undefined ? dateTimestampSource : {
    nowSeconds: ()=>(platformPerformance.timeOrigin + platformPerformance.now()) / 1000
};
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */ const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */ const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
const timestampWithMs = timestampInSeconds;
/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */ const usingPerformanceAPI = platformPerformance !== undefined;
/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */ let _browserPerformanceTimeOriginMode;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */ const browserPerformanceTimeOrigin = (()=>{
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    const { performance } = WINDOW;
    if (!performance || !performance.now) {
        _browserPerformanceTimeOriginMode = 'none';
        return undefined;
    }
    const threshold = 3600000;
    const performanceNow = performance.now();
    const dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    const timeOriginDelta = performance.timeOrigin ? Math.abs(performance.timeOrigin + performanceNow - dateNow) : threshold;
    const timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    const navigationStart = performance.timing && performance.timing.navigationStart;
    const hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    const navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            _browserPerformanceTimeOriginMode = 'timeOrigin';
            return performance.timeOrigin;
        } else {
            _browserPerformanceTimeOriginMode = 'navigationStart';
            return navigationStart;
        }
    }
    // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
    _browserPerformanceTimeOriginMode = 'dateNow';
    return dateNow;
})();

});
parcelRegister("fEKkD", function(module, exports) {

$parcel$export(module.exports, "isNodeEnv", () => isNodeEnv);
$parcel$export(module.exports, "dynamicRequire", () => dynamicRequire);
$parcel$export(module.exports, "loadModule", () => loadModule);

var $5aT4e = parcelRequire("5aT4e");

var $2fFJv = parcelRequire("2fFJv");
/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */ /**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */ function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return !(0, $5aT4e.isBrowserBundle)() && Object.prototype.toString.call(typeof $2fFJv !== 'undefined' ? $2fFJv : 0) === '[object process]';
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */ // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */ function loadModule(moduleName) {
    let mod;
    try {
        mod = dynamicRequire(module, moduleName);
    } catch (e) {
    // no-empty
    }
    try {
        const { cwd } = dynamicRequire(module, 'process');
        mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`);
    } catch (e) {
    // no-empty
    }
    return mod;
}

});
parcelRegister("5aT4e", function(module, exports) {

$parcel$export(module.exports, "isBrowserBundle", () => $3c489a1c020467c4$export$2928c40372e623c0);
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These flags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */ /**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */ function $3c489a1c020467c4$export$2928c40372e623c0() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Get source of SDK.
 */ function $3c489a1c020467c4$export$8ad33f488b1ab046() {
    // @ts-ignore "npm" is injected by rollup during build process
    return "npm";
}

});



parcelRegister("aG8PM", function(module, exports) {

$parcel$export(module.exports, "uuid4", () => $7c64ade93992989e$export$19f53698e68b2496);
$parcel$export(module.exports, "arrayify", () => $7c64ade93992989e$export$3131421a7d01b4fb);

var $3CK1O = parcelRequire("3CK1O");

var $4J3fm = parcelRequire("4J3fm");

var $dQTB1 = parcelRequire("dQTB1");
/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */ function $7c64ade93992989e$export$19f53698e68b2496() {
    const gbl = (0, $dQTB1.GLOBAL_OBJ);
    const crypto = gbl.crypto || gbl.msCrypto;
    if (crypto && crypto.randomUUID) return crypto.randomUUID().replace(/-/g, '');
    const getRandomByte = crypto && crypto.getRandomValues ? ()=>crypto.getRandomValues(new Uint8Array(1))[0] : ()=>Math.random() * 16;
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
    return "10000000100040008000100000000000".replace(/[018]/g, (c)=>// eslint-disable-next-line no-bitwise
        (c ^ (getRandomByte() & 15) >> c / 4).toString(16));
}
function $7c64ade93992989e$var$getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */ function $7c64ade93992989e$export$4157119e2b157127(event) {
    const { message: message, event_id: eventId } = event;
    if (message) return message;
    const firstException = $7c64ade93992989e$var$getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) return `${firstException.type}: ${firstException.value}`;
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */ function $7c64ade93992989e$export$f26508487bf83ee7(event, value, type) {
    const exception = event.exception = event.exception || {};
    const values = exception.values = exception.values || [];
    const firstException = values[0] = values[0] || {};
    if (!firstException.value) firstException.value = value || '';
    if (!firstException.type) firstException.type = type || 'Error';
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */ function $7c64ade93992989e$export$c69a9a0313b03bb1(event, newMechanism) {
    const firstException = $7c64ade93992989e$var$getFirstException(event);
    if (!firstException) return;
    const defaultMechanism = {
        type: 'generic',
        handled: true
    };
    const currentMechanism = firstException.mechanism;
    firstException.mechanism = {
        ...defaultMechanism,
        ...currentMechanism,
        ...newMechanism
    };
    if (newMechanism && 'data' in newMechanism) {
        const mergedData = {
            ...currentMechanism && currentMechanism.data,
            ...newMechanism.data
        };
        firstException.mechanism.data = mergedData;
    }
}
// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const $7c64ade93992989e$var$SEMVER_REGEXP = /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;
/**
 * Represents Semantic Versioning object
 */ /**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */ function $7c64ade93992989e$export$d364f2020ab30578(input) {
    const match = input.match($7c64ade93992989e$var$SEMVER_REGEXP) || [];
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3], 10);
    return {
        buildmetadata: match[5],
        major: isNaN(major) ? undefined : major,
        minor: isNaN(minor) ? undefined : minor,
        patch: isNaN(patch) ? undefined : patch,
        prerelease: match[4]
    };
}
/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */ function $7c64ade93992989e$export$ec2291bfc64632f0(lines, frame, linesOfContext = 5) {
    // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
    if (frame.lineno === undefined) return;
    const maxLines = lines.length;
    const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);
    frame.pre_context = lines.slice(Math.max(0, sourceLine - linesOfContext), sourceLine).map((line)=>(0, $4J3fm.snipLine)(line, 0));
    frame.context_line = (0, $4J3fm.snipLine)(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);
    frame.post_context = lines.slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext).map((line)=>(0, $4J3fm.snipLine)(line, 0));
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */ function $7c64ade93992989e$export$6de4ffac6a2f1098(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) return true;
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        (0, $3CK1O.addNonEnumerableProperty)(exception, '__sentry_captured__', true);
    } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}
/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */ function $7c64ade93992989e$export$3131421a7d01b4fb(maybeArray) {
    return Array.isArray(maybeArray) ? maybeArray : [
        maybeArray
    ];
}

});
parcelRegister("3CK1O", function(module, exports) {

$parcel$export(module.exports, "fill", () => $2a389ff2091c49a1$export$9563e054e6f787fb);
$parcel$export(module.exports, "addNonEnumerableProperty", () => $2a389ff2091c49a1$export$e73679ffaf56810e);
$parcel$export(module.exports, "convertToPlainObject", () => $2a389ff2091c49a1$export$62ff257738bf57f5);
$parcel$export(module.exports, "dropUndefinedKeys", () => $2a389ff2091c49a1$export$d25f2688db1bb433);

var $c12av = parcelRequire("c12av");

var $k7rM9 = parcelRequire("k7rM9");

var $4J3fm = parcelRequire("4J3fm");
/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */ function $2a389ff2091c49a1$export$9563e054e6f787fb(source, name, replacementFactory) {
    if (!(name in source)) return;
    const original = source[name];
    const wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') try {
        $2a389ff2091c49a1$export$5c1499e2e5d010ae(wrapped, original);
    } catch (_Oo) {
    // This can throw if multiple fill happens on a global object like XMLHttpRequest
    // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */ function $2a389ff2091c49a1$export$e73679ffaf56810e(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */ function $2a389ff2091c49a1$export$5c1499e2e5d010ae(wrapped, original) {
    const proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    $2a389ff2091c49a1$export$e73679ffaf56810e(wrapped, '__sentry_original__', original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */ function $2a389ff2091c49a1$export$e6cc1e135e2092e5(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */ function $2a389ff2091c49a1$export$9ef804feabbcbaf1(object) {
    return Object.keys(object).map((key)=>`${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`).join('&');
}
/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */ function $2a389ff2091c49a1$export$62ff257738bf57f5(value) {
    if ((0, $k7rM9.isError)(value)) return {
        message: value.message,
        name: value.name,
        stack: value.stack,
        ...$2a389ff2091c49a1$var$getOwnProperties(value)
    };
    else if ((0, $k7rM9.isEvent)(value)) {
        const newObj = {
            type: value.type,
            target: $2a389ff2091c49a1$var$serializeEventTarget(value.target),
            currentTarget: $2a389ff2091c49a1$var$serializeEventTarget(value.currentTarget),
            ...$2a389ff2091c49a1$var$getOwnProperties(value)
        };
        if (typeof CustomEvent !== 'undefined' && (0, $k7rM9.isInstanceOf)(value, CustomEvent)) newObj.detail = value.detail;
        return newObj;
    } else return value;
}
/** Creates a string representation of the target of an `Event` object */ function $2a389ff2091c49a1$var$serializeEventTarget(target) {
    try {
        return (0, $k7rM9.isElement)(target) ? (0, $c12av.htmlTreeAsString)(target) : Object.prototype.toString.call(target);
    } catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */ function $2a389ff2091c49a1$var$getOwnProperties(obj) {
    if (typeof obj === 'object' && obj !== null) {
        const extractedProps = {};
        for(const property in obj)if (Object.prototype.hasOwnProperty.call(obj, property)) extractedProps[property] = obj[property];
        return extractedProps;
    } else return {};
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */ function $2a389ff2091c49a1$export$b0244d5063c0b61b(exception, maxLength = 40) {
    const keys = Object.keys($2a389ff2091c49a1$export$62ff257738bf57f5(exception));
    keys.sort();
    if (!keys.length) return '[object has no keys]';
    if (keys[0].length >= maxLength) return (0, $4J3fm.truncate)(keys[0], maxLength);
    for(let includedKeys = keys.length; includedKeys > 0; includedKeys--){
        const serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) continue;
        if (includedKeys === keys.length) return serialized;
        return (0, $4J3fm.truncate)(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */ function $2a389ff2091c49a1$export$d25f2688db1bb433(inputValue) {
    // This map keeps track of what already visited nodes map to.
    // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
    // references as the input object.
    const memoizationMap = new Map();
    // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
    return $2a389ff2091c49a1$var$_dropUndefinedKeys(inputValue, memoizationMap);
}
function $2a389ff2091c49a1$var$_dropUndefinedKeys(inputValue, memoizationMap) {
    if ((0, $k7rM9.isPlainObject)(inputValue)) {
        // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = {};
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        for (const key of Object.keys(inputValue))if (typeof inputValue[key] !== 'undefined') returnValue[key] = $2a389ff2091c49a1$var$_dropUndefinedKeys(inputValue[key], memoizationMap);
        return returnValue;
    }
    if (Array.isArray(inputValue)) {
        // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
        const memoVal = memoizationMap.get(inputValue);
        if (memoVal !== undefined) return memoVal;
        const returnValue = [];
        // Store the mapping of this value in case we visit it again, in case of circular data
        memoizationMap.set(inputValue, returnValue);
        inputValue.forEach((item)=>{
            returnValue.push($2a389ff2091c49a1$var$_dropUndefinedKeys(item, memoizationMap));
        });
        return returnValue;
    }
    return inputValue;
}
/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */ function $2a389ff2091c49a1$export$92b78acdbe066b6b(wat) {
    let objectified;
    switch(true){
        case wat === undefined || wat === null:
            objectified = new String(wat);
            break;
        // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
        // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
        // an object in order to wrap it.
        case typeof wat === 'symbol' || typeof wat === 'bigint':
            objectified = Object(wat);
            break;
        // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
        case (0, $k7rM9.isPrimitive)(wat):
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            objectified = new wat.constructor(wat);
            break;
        // by process of elimination, at this point we know that `wat` must already be an object
        default:
            objectified = wat;
            break;
    }
    return objectified;
}

});
parcelRegister("c12av", function(module, exports) {

$parcel$export(module.exports, "htmlTreeAsString", () => $8bf742a186aee709$export$5647df6b7814ac86);
$parcel$export(module.exports, "getDomElement", () => $8bf742a186aee709$export$c660c1f3ab49225c);

var $k7rM9 = parcelRequire("k7rM9");

var $dQTB1 = parcelRequire("dQTB1");
// eslint-disable-next-line deprecation/deprecation
const $8bf742a186aee709$var$WINDOW = (0, $dQTB1.getGlobalObject)();
const $8bf742a186aee709$var$DEFAULT_MAX_STRING_LENGTH = 80;
/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8bf742a186aee709$export$5647df6b7814ac86(elem, options = {}) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        let currentElem = elem;
        const MAX_TRAVERSE_HEIGHT = 5;
        const out = [];
        let height = 0;
        let len = 0;
        const separator = ' > ';
        const sepLength = separator.length;
        let nextStr;
        const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
        const maxStringLength = !Array.isArray(options) && options.maxStringLength || $8bf742a186aee709$var$DEFAULT_MAX_STRING_LENGTH;
        while(currentElem && height++ < MAX_TRAVERSE_HEIGHT){
            nextStr = $8bf742a186aee709$var$_htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds maxStringLength
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength) break;
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    } catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */ function $8bf742a186aee709$var$_htmlElementAsString(el, keyAttrs) {
    const elem = el;
    const out = [];
    let className;
    let classes;
    let key;
    let attr;
    let i;
    if (!elem || !elem.tagName) return '';
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    const keyAttrPairs = keyAttrs && keyAttrs.length ? keyAttrs.filter((keyAttr)=>elem.getAttribute(keyAttr)).map((keyAttr)=>[
            keyAttr,
            elem.getAttribute(keyAttr)
        ]) : null;
    if (keyAttrPairs && keyAttrPairs.length) keyAttrPairs.forEach((keyAttrPair)=>{
        out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
    else {
        if (elem.id) out.push(`#${elem.id}`);
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && (0, $k7rM9.isString)(className)) {
            classes = className.split(/\s+/);
            for(i = 0; i < classes.length; i++)out.push(`.${classes[i]}`);
        }
    }
    const allowedAttrs = [
        'aria-label',
        'type',
        'name',
        'title',
        'alt'
    ];
    for(i = 0; i < allowedAttrs.length; i++){
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) out.push(`[${key}="${attr}"]`);
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */ function $8bf742a186aee709$export$1cfafeee2987818b() {
    try {
        return $8bf742a186aee709$var$WINDOW.document.location.href;
    } catch (oO) {
        return '';
    }
}
/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $8bf742a186aee709$export$c660c1f3ab49225c(selector) {
    if ($8bf742a186aee709$var$WINDOW.document && $8bf742a186aee709$var$WINDOW.document.querySelector) return $8bf742a186aee709$var$WINDOW.document.querySelector(selector);
    return null;
}

});

parcelRegister("4J3fm", function(module, exports) {

$parcel$export(module.exports, "truncate", () => $370de222704f04cc$export$6a506b36fdea397d);
$parcel$export(module.exports, "snipLine", () => $370de222704f04cc$export$4215662d762d6f9d);
$parcel$export(module.exports, "stringMatchesSomePattern", () => $370de222704f04cc$export$a7a5ec66062ea5d);

var $k7rM9 = parcelRequire("k7rM9");
/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */ function $370de222704f04cc$export$6a506b36fdea397d(str, max = 0) {
    if (typeof str !== 'string' || max === 0) return str;
    return str.length <= max ? str : `${str.slice(0, max)}...`;
}
/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */ function $370de222704f04cc$export$4215662d762d6f9d(line, colno) {
    let newLine = line;
    const lineLength = newLine.length;
    if (lineLength <= 150) return newLine;
    if (colno > lineLength) // eslint-disable-next-line no-param-reassign
    colno = lineLength;
    let start = Math.max(colno - 60, 0);
    if (start < 5) start = 0;
    let end = Math.min(start + 140, lineLength);
    if (end > lineLength - 5) end = lineLength;
    if (end === lineLength) start = Math.max(end - 140, 0);
    newLine = newLine.slice(start, end);
    if (start > 0) newLine = `'{snip} ${newLine}`;
    if (end < lineLength) newLine += ' {snip}';
    return newLine;
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $370de222704f04cc$export$465e9d514283d4fd(input, delimiter) {
    if (!Array.isArray(input)) return '';
    const output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for(let i = 0; i < input.length; i++){
        const value = input[i];
        try {
            output.push(String(value));
        } catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */ function $370de222704f04cc$export$cdded5b28a5f8c6d(value, pattern, requireExactStringMatch = false) {
    if (!(0, $k7rM9.isString)(value)) return false;
    if ((0, $k7rM9.isRegExp)(pattern)) return pattern.test(value);
    if ((0, $k7rM9.isString)(pattern)) return requireExactStringMatch ? value === pattern : value.includes(pattern);
    return false;
}
/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */ function $370de222704f04cc$export$a7a5ec66062ea5d(testString, patterns = [], requireExactStringMatch = false) {
    return patterns.some((pattern)=>$370de222704f04cc$export$cdded5b28a5f8c6d(testString, pattern, requireExactStringMatch));
}

});



parcelRegister("94HCL", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_ENVIRONMENT", () => $69b6539f233067c3$export$849dbeeeda01ae98);
const $69b6539f233067c3$export$849dbeeeda01ae98 = 'production';

});

parcelRegister("drFYh", function(module, exports) {

$parcel$export(module.exports, "Scope", () => $9c9e5a93b8a75971$export$775b6bb06e53a214);

var $aG8PM = parcelRequire("aG8PM");
var $43Vyk = parcelRequire("43Vyk");
var $dQTB1 = parcelRequire("dQTB1");
var $k7rM9 = parcelRequire("k7rM9");
var $elKLM = parcelRequire("elKLM");
var $f2NIL = parcelRequire("f2NIL");

var $8ureE = parcelRequire("8ureE");
/**
 * Default value for maximum number of breadcrumbs added to an event.
 */ const $9c9e5a93b8a75971$var$DEFAULT_MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */ class $9c9e5a93b8a75971$export$775b6bb06e53a214 {
    /** Flag if notifying is happening. */ /** Callback for client to receive scope changes. */ /** Callback list that will be called after {@link applyToEvent}. */ /** Array of breadcrumbs. */ /** User */ /** Tags */ /** Extra */ /** Contexts */ /** Attachments */ /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */ /** Fingerprint */ /** Severity */ // eslint-disable-next-line deprecation/deprecation
    /** Transaction Name */ /** Span */ /** Session */ /** Request Mode Session Status */ // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
    constructor(){
        this._notifyingListeners = false;
        this._scopeListeners = [];
        this._eventProcessors = [];
        this._breadcrumbs = [];
        this._attachments = [];
        this._user = {};
        this._tags = {};
        this._extra = {};
        this._contexts = {};
        this._sdkProcessingMetadata = {};
    }
    /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */ static clone(scope) {
        const newScope = new $9c9e5a93b8a75971$export$775b6bb06e53a214();
        if (scope) {
            newScope._breadcrumbs = [
                ...scope._breadcrumbs
            ];
            newScope._tags = {
                ...scope._tags
            };
            newScope._extra = {
                ...scope._extra
            };
            newScope._contexts = {
                ...scope._contexts
            };
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = [
                ...scope._eventProcessors
            ];
            newScope._requestSession = scope._requestSession;
            newScope._attachments = [
                ...scope._attachments
            ];
            newScope._sdkProcessingMetadata = {
                ...scope._sdkProcessingMetadata
            };
        }
        return newScope;
    }
    /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */ addScopeListener(callback) {
        this._scopeListeners.push(callback);
    }
    /**
   * @inheritDoc
   */ addEventProcessor(callback) {
        this._eventProcessors.push(callback);
        return this;
    }
    /**
   * @inheritDoc
   */ setUser(user) {
        this._user = user || {};
        if (this._session) (0, $8ureE.updateSession)(this._session, {
            user: user
        });
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getUser() {
        return this._user;
    }
    /**
   * @inheritDoc
   */ getRequestSession() {
        return this._requestSession;
    }
    /**
   * @inheritDoc
   */ setRequestSession(requestSession) {
        this._requestSession = requestSession;
        return this;
    }
    /**
   * @inheritDoc
   */ setTags(tags) {
        this._tags = {
            ...this._tags,
            ...tags
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this._tags = {
            ...this._tags,
            [key]: value
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtras(extras) {
        this._extra = {
            ...this._extra,
            ...extras
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setExtra(key, extra) {
        this._extra = {
            ...this._extra,
            [key]: extra
        };
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setFingerprint(fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setLevel(// eslint-disable-next-line deprecation/deprecation
    level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setTransactionName(name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ setSpan(span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSpan() {
        return this._span;
    }
    /**
   * @inheritDoc
   */ getTransaction() {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        const span = this.getSpan();
        return span && span.transaction;
    }
    /**
   * @inheritDoc
   */ setSession(session) {
        if (!session) delete this._session;
        else this._session = session;
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getSession() {
        return this._session;
    }
    /**
   * @inheritDoc
   */ update(captureContext) {
        if (!captureContext) return this;
        if (typeof captureContext === 'function') {
            const updatedScope = captureContext(this);
            return updatedScope instanceof $9c9e5a93b8a75971$export$775b6bb06e53a214 ? updatedScope : this;
        }
        if (captureContext instanceof $9c9e5a93b8a75971$export$775b6bb06e53a214) {
            this._tags = {
                ...this._tags,
                ...captureContext._tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext._extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext._contexts
            };
            if (captureContext._user && Object.keys(captureContext._user).length) this._user = captureContext._user;
            if (captureContext._level) this._level = captureContext._level;
            if (captureContext._fingerprint) this._fingerprint = captureContext._fingerprint;
            if (captureContext._requestSession) this._requestSession = captureContext._requestSession;
        } else if ((0, $k7rM9.isPlainObject)(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext;
            this._tags = {
                ...this._tags,
                ...captureContext.tags
            };
            this._extra = {
                ...this._extra,
                ...captureContext.extra
            };
            this._contexts = {
                ...this._contexts,
                ...captureContext.contexts
            };
            if (captureContext.user) this._user = captureContext.user;
            if (captureContext.level) this._level = captureContext.level;
            if (captureContext.fingerprint) this._fingerprint = captureContext.fingerprint;
            if (captureContext.requestSession) this._requestSession = captureContext.requestSession;
        }
        return this;
    }
    /**
   * @inheritDoc
   */ clear() {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        this._attachments = [];
        return this;
    }
    /**
   * @inheritDoc
   */ addBreadcrumb(breadcrumb, maxBreadcrumbs) {
        const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : $9c9e5a93b8a75971$var$DEFAULT_MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) return this;
        const mergedBreadcrumb = {
            timestamp: (0, $43Vyk.dateTimestampInSeconds)(),
            ...breadcrumb
        };
        this._breadcrumbs = [
            ...this._breadcrumbs,
            mergedBreadcrumb
        ].slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ getLastBreadcrumb() {
        return this._breadcrumbs[this._breadcrumbs.length - 1];
    }
    /**
   * @inheritDoc
   */ clearBreadcrumbs() {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    }
    /**
   * @inheritDoc
   */ addAttachment(attachment) {
        this._attachments.push(attachment);
        return this;
    }
    /**
   * @inheritDoc
   */ getAttachments() {
        return this._attachments;
    }
    /**
   * @inheritDoc
   */ clearAttachments() {
        this._attachments = [];
        return this;
    }
    /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */ applyToEvent(event, hint = {}) {
        if (this._extra && Object.keys(this._extra).length) event.extra = {
            ...this._extra,
            ...event.extra
        };
        if (this._tags && Object.keys(this._tags).length) event.tags = {
            ...this._tags,
            ...event.tags
        };
        if (this._user && Object.keys(this._user).length) event.user = {
            ...this._user,
            ...event.user
        };
        if (this._contexts && Object.keys(this._contexts).length) event.contexts = {
            ...this._contexts,
            ...event.contexts
        };
        if (this._level) event.level = this._level;
        if (this._transactionName) event.transaction = this._transactionName;
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = {
                trace: this._span.getTraceContext(),
                ...event.contexts
            };
            const transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) event.tags = {
                transaction: transactionName,
                ...event.tags
            };
        }
        this._applyFingerprint(event);
        event.breadcrumbs = [
            ...event.breadcrumbs || [],
            ...this._breadcrumbs
        ];
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = {
            ...event.sdkProcessingMetadata,
            ...this._sdkProcessingMetadata
        };
        return this._notifyEventProcessors([
            ...$9c9e5a93b8a75971$var$getGlobalEventProcessors(),
            ...this._eventProcessors
        ], event, hint);
    }
    /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */ setSDKProcessingMetadata(newData) {
        this._sdkProcessingMetadata = {
            ...this._sdkProcessingMetadata,
            ...newData
        };
        return this;
    }
    /**
   * This will be called after {@link applyToEvent} is finished.
   */ _notifyEventProcessors(processors, event, hint, index = 0) {
        return new (0, $f2NIL.SyncPromise)((resolve, reject)=>{
            const processor = processors[index];
            if (event === null || typeof processor !== 'function') resolve(event);
            else {
                const result = processor({
                    ...event
                }, hint);
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && processor.id && result === null && (0, $elKLM.logger).log(`Event processor "${processor.id}" dropped event`);
                if ((0, $k7rM9.isThenable)(result)) result.then((final)=>this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve)).then(null, reject);
                else this._notifyEventProcessors(processors, result, hint, index + 1).then(resolve).then(null, reject);
            }
        });
    }
    /**
   * This will be called on every set call.
   */ _notifyScopeListeners() {
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach((callback)=>{
                callback(this);
            });
            this._notifyingListeners = false;
        }
    }
    /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */ _applyFingerprint(event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint ? (0, $aG8PM.arrayify)(event.fingerprint) : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) event.fingerprint = event.fingerprint.concat(this._fingerprint);
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) delete event.fingerprint;
    }
}
/**
 * Returns the global event processors.
 */ function $9c9e5a93b8a75971$var$getGlobalEventProcessors() {
    return (0, $dQTB1.getGlobalSingleton)('globalEventProcessors', ()=>[]);
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */ function $9c9e5a93b8a75971$export$8e4e25f54d456511(callback) {
    $9c9e5a93b8a75971$var$getGlobalEventProcessors().push(callback);
}

});
parcelRegister("f2NIL", function(module, exports) {

$parcel$export(module.exports, "SyncPromise", () => $af3d9c7da797ccef$export$6f292d4960313241);

var $k7rM9 = parcelRequire("k7rM9");
/* eslint-disable @typescript-eslint/explicit-function-return-type */ /** SyncPromise internal states */ var $af3d9c7da797ccef$var$States;
(function(States) {
    /** Pending */ const PENDING = 0;
    States[States["PENDING"] = PENDING] = "PENDING";
    /** Resolved / OK */ const RESOLVED = 1;
    States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
    /** Rejected / Error */ const REJECTED = 2;
    States[States["REJECTED"] = REJECTED] = "REJECTED";
})($af3d9c7da797ccef$var$States || ($af3d9c7da797ccef$var$States = {}));
// Overloads so we can call resolvedSyncPromise without arguments and generic argument
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */ function $af3d9c7da797ccef$export$1fda8aa4d135f8aa(value) {
    return new $af3d9c7da797ccef$export$6f292d4960313241((resolve)=>{
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */ function $af3d9c7da797ccef$export$78e43115b553f358(reason) {
    return new $af3d9c7da797ccef$export$6f292d4960313241((_, reject)=>{
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */ class $af3d9c7da797ccef$export$6f292d4960313241 {
    __init() {
        this._state = $af3d9c7da797ccef$var$States.PENDING;
    }
    __init2() {
        this._handlers = [];
    }
    constructor(executor){
        $af3d9c7da797ccef$export$6f292d4960313241.prototype.__init.call(this);
        $af3d9c7da797ccef$export$6f292d4960313241.prototype.__init2.call(this);
        $af3d9c7da797ccef$export$6f292d4960313241.prototype.__init3.call(this);
        $af3d9c7da797ccef$export$6f292d4960313241.prototype.__init4.call(this);
        $af3d9c7da797ccef$export$6f292d4960313241.prototype.__init5.call(this);
        $af3d9c7da797ccef$export$6f292d4960313241.prototype.__init6.call(this);
        try {
            executor(this._resolve, this._reject);
        } catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */ then(onfulfilled, onrejected) {
        return new $af3d9c7da797ccef$export$6f292d4960313241((resolve, reject)=>{
            this._handlers.push([
                false,
                (result)=>{
                    if (!onfulfilled) // TODO: ¯\_(ツ)_/¯
                    // TODO: FIXME
                    resolve(result);
                    else try {
                        resolve(onfulfilled(result));
                    } catch (e) {
                        reject(e);
                    }
                },
                (reason)=>{
                    if (!onrejected) reject(reason);
                    else try {
                        resolve(onrejected(reason));
                    } catch (e) {
                        reject(e);
                    }
                }
            ]);
            this._executeHandlers();
        });
    }
    /** JSDoc */ catch(onrejected) {
        return this.then((val)=>val, onrejected);
    }
    /** JSDoc */ finally(onfinally) {
        return new $af3d9c7da797ccef$export$6f292d4960313241((resolve, reject)=>{
            let val;
            let isRejected;
            return this.then((value)=>{
                isRejected = false;
                val = value;
                if (onfinally) onfinally();
            }, (reason)=>{
                isRejected = true;
                val = reason;
                if (onfinally) onfinally();
            }).then(()=>{
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    }
    /** JSDoc */ __init3() {
        this._resolve = (value)=>{
            this._setResult($af3d9c7da797ccef$var$States.RESOLVED, value);
        };
    }
    /** JSDoc */ __init4() {
        this._reject = (reason)=>{
            this._setResult($af3d9c7da797ccef$var$States.REJECTED, reason);
        };
    }
    /** JSDoc */ __init5() {
        this._setResult = (state, value)=>{
            if (this._state !== $af3d9c7da797ccef$var$States.PENDING) return;
            if ((0, $k7rM9.isThenable)(value)) {
                value.then(this._resolve, this._reject);
                return;
            }
            this._state = state;
            this._value = value;
            this._executeHandlers();
        };
    }
    /** JSDoc */ __init6() {
        this._executeHandlers = ()=>{
            if (this._state === $af3d9c7da797ccef$var$States.PENDING) return;
            const cachedHandlers = this._handlers.slice();
            this._handlers = [];
            cachedHandlers.forEach((handler)=>{
                if (handler[0]) return;
                if (this._state === $af3d9c7da797ccef$var$States.RESOLVED) // eslint-disable-next-line @typescript-eslint/no-floating-promises
                handler[1](this._value);
                if (this._state === $af3d9c7da797ccef$var$States.REJECTED) handler[2](this._value);
                handler[0] = true;
            });
        };
    }
}

});

parcelRegister("8ureE", function(module, exports) {

$parcel$export(module.exports, "makeSession", () => $62e64069fcf5bf2c$export$14a186326edbb264);
$parcel$export(module.exports, "updateSession", () => $62e64069fcf5bf2c$export$531818e825e774db);
$parcel$export(module.exports, "closeSession", () => $62e64069fcf5bf2c$export$56521d9ba90f62ee);

var $3CK1O = parcelRequire("3CK1O");
var $43Vyk = parcelRequire("43Vyk");
var $aG8PM = parcelRequire("aG8PM");
/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */ function $62e64069fcf5bf2c$export$14a186326edbb264(context) {
    // Both timestamp and started are in seconds since the UNIX epoch.
    const startingTime = (0, $43Vyk.timestampInSeconds)();
    const session = {
        sid: (0, $aG8PM.uuid4)(),
        init: true,
        timestamp: startingTime,
        started: startingTime,
        duration: 0,
        status: 'ok',
        errors: 0,
        ignoreDuration: false,
        toJSON: ()=>$62e64069fcf5bf2c$var$sessionToJSON(session)
    };
    if (context) $62e64069fcf5bf2c$export$531818e825e774db(session, context);
    return session;
}
/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */ // eslint-disable-next-line complexity
function $62e64069fcf5bf2c$export$531818e825e774db(session, context = {}) {
    if (context.user) {
        if (!session.ipAddress && context.user.ip_address) session.ipAddress = context.user.ip_address;
        if (!session.did && !context.did) session.did = context.user.id || context.user.email || context.user.username;
    }
    session.timestamp = context.timestamp || (0, $43Vyk.timestampInSeconds)();
    if (context.ignoreDuration) session.ignoreDuration = context.ignoreDuration;
    if (context.sid) // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0, $aG8PM.uuid4)();
    if (context.init !== undefined) session.init = context.init;
    if (!session.did && context.did) session.did = `${context.did}`;
    if (typeof context.started === 'number') session.started = context.started;
    if (session.ignoreDuration) session.duration = undefined;
    else if (typeof context.duration === 'number') session.duration = context.duration;
    else {
        const duration = session.timestamp - session.started;
        session.duration = duration >= 0 ? duration : 0;
    }
    if (context.release) session.release = context.release;
    if (context.environment) session.environment = context.environment;
    if (!session.ipAddress && context.ipAddress) session.ipAddress = context.ipAddress;
    if (!session.userAgent && context.userAgent) session.userAgent = context.userAgent;
    if (typeof context.errors === 'number') session.errors = context.errors;
    if (context.status) session.status = context.status;
}
/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */ function $62e64069fcf5bf2c$export$56521d9ba90f62ee(session, status) {
    let context = {};
    if (status) context = {
        status: status
    };
    else if (session.status === 'ok') context = {
        status: 'exited'
    };
    $62e64069fcf5bf2c$export$531818e825e774db(session, context);
}
/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */ function $62e64069fcf5bf2c$var$sessionToJSON(session) {
    return (0, $3CK1O.dropUndefinedKeys)({
        sid: `${session.sid}`,
        init: session.init,
        // Make sure that sec is converted to ms for date constructor
        started: new Date(session.started * 1000).toISOString(),
        timestamp: new Date(session.timestamp * 1000).toISOString(),
        status: session.status,
        errors: session.errors,
        did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
        duration: session.duration,
        attrs: {
            release: session.release,
            environment: session.environment,
            ip_address: session.ipAddress,
            user_agent: session.userAgent
        }
    });
}

});



parcelRegister("9hRAY", function(module, exports) {

$parcel$export(module.exports, "hasTracingEnabled", () => $6c2f46828a8a05a8$export$5008da00b1b6dee6);

var $7Qe7s = parcelRequire("7Qe7s");
// Treeshakable guard to remove all code related to tracing
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */ function $6c2f46828a8a05a8$export$5008da00b1b6dee6(maybeOptions) {
    if (typeof __SENTRY_TRACING__ === 'boolean' && !__SENTRY_TRACING__) return false;
    const client = (0, $7Qe7s.getCurrentHub)().getClient();
    const options = maybeOptions || client && client.getOptions();
    return !!options && (options.enableTracing || 'tracesSampleRate' in options || 'tracesSampler' in options);
}

});

parcelRegister("cXhcW", function(module, exports) {

$parcel$export(module.exports, "registerErrorInstrumentation", () => $96e857ce9486361b$export$637857c1d87b640c);

var $lChn2 = parcelRequire("lChn2");
var $elKLM = parcelRequire("elKLM");

var $ebD1W = parcelRequire("ebD1W");
let $96e857ce9486361b$var$errorsInstrumented = false;
/**
 * Configures global error listeners
 */ function $96e857ce9486361b$export$637857c1d87b640c() {
    if ($96e857ce9486361b$var$errorsInstrumented) return;
    $96e857ce9486361b$var$errorsInstrumented = true;
    (0, $lChn2.addInstrumentationHandler)('error', $96e857ce9486361b$var$errorCallback);
    (0, $lChn2.addInstrumentationHandler)('unhandledrejection', $96e857ce9486361b$var$errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */ function $96e857ce9486361b$var$errorCallback() {
    const activeTransaction = (0, $ebD1W.getActiveTransaction)();
    if (activeTransaction) {
        const status = 'internal_error';
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Transaction: ${status} -> Global error occured`);
        activeTransaction.setStatus(status);
    }
}
// The function name will be lost when bundling but we need to be able to identify this listener later to maintain the
// node.js default exit behaviour
$96e857ce9486361b$var$errorCallback.tag = 'sentry_tracingErrorCallback';

});
parcelRegister("lChn2", function(module, exports) {

$parcel$export(module.exports, "addInstrumentationHandler", () => $fbca9f0141e13736$export$285b9172a3741fb7);

var $k7rM9 = parcelRequire("k7rM9");

var $elKLM = parcelRequire("elKLM");

var $3CK1O = parcelRequire("3CK1O");

var $8yub9 = parcelRequire("8yub9");

var $7VirA = parcelRequire("7VirA");

var $dQTB1 = parcelRequire("dQTB1");

var $2t4YI = parcelRequire("2t4YI");
// eslint-disable-next-line deprecation/deprecation
const $fbca9f0141e13736$var$WINDOW = (0, $dQTB1.getGlobalObject)();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */ const $fbca9f0141e13736$var$handlers = {};
const $fbca9f0141e13736$var$instrumented = {};
/** Instruments given API */ function $fbca9f0141e13736$var$instrument(type) {
    if ($fbca9f0141e13736$var$instrumented[type]) return;
    $fbca9f0141e13736$var$instrumented[type] = true;
    switch(type){
        case 'console':
            $fbca9f0141e13736$var$instrumentConsole();
            break;
        case 'dom':
            $fbca9f0141e13736$var$instrumentDOM();
            break;
        case 'xhr':
            $fbca9f0141e13736$var$instrumentXHR();
            break;
        case 'fetch':
            $fbca9f0141e13736$var$instrumentFetch();
            break;
        case 'history':
            $fbca9f0141e13736$var$instrumentHistory();
            break;
        case 'error':
            $fbca9f0141e13736$var$instrumentError();
            break;
        case 'unhandledrejection':
            $fbca9f0141e13736$var$instrumentUnhandledRejection();
            break;
        default:
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn('unknown instrumentation type:', type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */ function $fbca9f0141e13736$export$285b9172a3741fb7(type, callback) {
    $fbca9f0141e13736$var$handlers[type] = $fbca9f0141e13736$var$handlers[type] || [];
    $fbca9f0141e13736$var$handlers[type].push(callback);
    $fbca9f0141e13736$var$instrument(type);
}
/** JSDoc */ function $fbca9f0141e13736$var$triggerHandlers(type, data) {
    if (!type || !$fbca9f0141e13736$var$handlers[type]) return;
    for (const handler of $fbca9f0141e13736$var$handlers[type] || [])try {
        handler(data);
    } catch (e) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error(`Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0, $8yub9.getFunctionName)(handler)}\nError:`, e);
    }
}
/** JSDoc */ function $fbca9f0141e13736$var$instrumentConsole() {
    if (!('console' in $fbca9f0141e13736$var$WINDOW)) return;
    (0, $elKLM.CONSOLE_LEVELS).forEach(function(level) {
        if (!(level in $fbca9f0141e13736$var$WINDOW.console)) return;
        (0, $3CK1O.fill)($fbca9f0141e13736$var$WINDOW.console, level, function(originalConsoleMethod) {
            return function(...args) {
                $fbca9f0141e13736$var$triggerHandlers('console', {
                    args: args,
                    level: level
                });
                // this fails for some browsers. :(
                if (originalConsoleMethod) originalConsoleMethod.apply($fbca9f0141e13736$var$WINDOW.console, args);
            };
        });
    });
}
/** JSDoc */ function $fbca9f0141e13736$var$instrumentFetch() {
    if (!(0, $7VirA.supportsNativeFetch)()) return;
    (0, $3CK1O.fill)($fbca9f0141e13736$var$WINDOW, 'fetch', function(originalFetch) {
        return function(...args) {
            const { method: method, url: url } = $fbca9f0141e13736$export$f7a71163cc309d9a(args);
            const handlerData = {
                args: args,
                fetchData: {
                    method: method,
                    url: url
                },
                startTimestamp: Date.now()
            };
            $fbca9f0141e13736$var$triggerHandlers('fetch', {
                ...handlerData
            });
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply($fbca9f0141e13736$var$WINDOW, args).then((response)=>{
                $fbca9f0141e13736$var$triggerHandlers('fetch', {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    response: response
                });
                return response;
            }, (error)=>{
                $fbca9f0141e13736$var$triggerHandlers('fetch', {
                    ...handlerData,
                    endTimestamp: Date.now(),
                    error: error
                });
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
function $fbca9f0141e13736$var$hasProp(obj, prop) {
    return !!obj && typeof obj === 'object' && !!obj[prop];
}
function $fbca9f0141e13736$var$getUrlFromResource(resource) {
    if (typeof resource === 'string') return resource;
    if (!resource) return '';
    if ($fbca9f0141e13736$var$hasProp(resource, 'url')) return resource.url;
    if (resource.toString) return resource.toString();
    return '';
}
/**
 * Parses the fetch arguments to find the used Http method and the url of the request
 */ function $fbca9f0141e13736$export$f7a71163cc309d9a(fetchArgs) {
    if (fetchArgs.length === 0) return {
        method: 'GET',
        url: ''
    };
    if (fetchArgs.length === 2) {
        const [url, options] = fetchArgs;
        return {
            url: $fbca9f0141e13736$var$getUrlFromResource(url),
            method: $fbca9f0141e13736$var$hasProp(options, 'method') ? String(options.method).toUpperCase() : 'GET'
        };
    }
    const arg = fetchArgs[0];
    return {
        url: $fbca9f0141e13736$var$getUrlFromResource(arg),
        method: $fbca9f0141e13736$var$hasProp(arg, 'method') ? String(arg.method).toUpperCase() : 'GET'
    };
}
/** JSDoc */ function $fbca9f0141e13736$var$instrumentXHR() {
    if (!('XMLHttpRequest' in $fbca9f0141e13736$var$WINDOW)) return;
    const xhrproto = XMLHttpRequest.prototype;
    (0, $3CK1O.fill)(xhrproto, 'open', function(originalOpen) {
        return function(...args) {
            const url = args[1];
            const xhrInfo = this.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: (0, $k7rM9.isString)(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
                request_headers: {}
            };
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if ((0, $k7rM9.isString)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) this.__sentry_own_request__ = true;
            const onreadystatechangeHandler = ()=>{
                // For whatever reason, this is not the same instance here as from the outer method
                const xhrInfo = this.__sentry_xhr__;
                if (!xhrInfo) return;
                if (this.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = this.status;
                    } catch (e) {
                    /* do nothing */ }
                    $fbca9f0141e13736$var$triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: this
                    });
                }
            };
            if ('onreadystatechange' in this && typeof this.onreadystatechange === 'function') (0, $3CK1O.fill)(this, 'onreadystatechange', function(original) {
                return function(...readyStateArgs) {
                    onreadystatechangeHandler();
                    return original.apply(this, readyStateArgs);
                };
            });
            else this.addEventListener('readystatechange', onreadystatechangeHandler);
            // Intercepting `setRequestHeader` to access the request headers of XHR instance.
            // This will only work for user/library defined headers, not for the default/browser-assigned headers.
            // Request cookies are also unavailable for XHR, as `Cookie` header can't be defined by `setRequestHeader`.
            (0, $3CK1O.fill)(this, 'setRequestHeader', function(original) {
                return function(...setRequestHeaderArgs) {
                    const [header, value] = setRequestHeaderArgs;
                    const xhrInfo = this.__sentry_xhr__;
                    if (xhrInfo) xhrInfo.request_headers[header] = value;
                    return original.apply(this, setRequestHeaderArgs);
                };
            });
            return originalOpen.apply(this, args);
        };
    });
    (0, $3CK1O.fill)(xhrproto, 'send', function(originalSend) {
        return function(...args) {
            if (this.__sentry_xhr__ && args[0] !== undefined) this.__sentry_xhr__.body = args[0];
            $fbca9f0141e13736$var$triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this
            });
            return originalSend.apply(this, args);
        };
    });
}
let $fbca9f0141e13736$var$lastHref;
/** JSDoc */ function $fbca9f0141e13736$var$instrumentHistory() {
    if (!(0, $2t4YI.supportsHistory)()) return;
    const oldOnPopState = $fbca9f0141e13736$var$WINDOW.onpopstate;
    $fbca9f0141e13736$var$WINDOW.onpopstate = function(...args) {
        const to = $fbca9f0141e13736$var$WINDOW.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        const from = $fbca9f0141e13736$var$lastHref;
        $fbca9f0141e13736$var$lastHref = to;
        $fbca9f0141e13736$var$triggerHandlers('history', {
            from: from,
            to: to
        });
        if (oldOnPopState) // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
        // https://github.com/getsentry/sentry-javascript/issues/3344
        // https://github.com/bugsnag/bugsnag-js/issues/469
        try {
            return oldOnPopState.apply(this, args);
        } catch (_oO) {
        // no-empty
        }
    };
    /** @hidden */ function historyReplacementFunction(originalHistoryFunction) {
        return function(...args) {
            const url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                const from = $fbca9f0141e13736$var$lastHref;
                const to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                $fbca9f0141e13736$var$lastHref = to;
                $fbca9f0141e13736$var$triggerHandlers('history', {
                    from: from,
                    to: to
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    (0, $3CK1O.fill)($fbca9f0141e13736$var$WINDOW.history, 'pushState', historyReplacementFunction);
    (0, $3CK1O.fill)($fbca9f0141e13736$var$WINDOW.history, 'replaceState', historyReplacementFunction);
}
const $fbca9f0141e13736$var$debounceDuration = 1000;
let $fbca9f0141e13736$var$debounceTimerID;
let $fbca9f0141e13736$var$lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */ function $fbca9f0141e13736$var$shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) return true;
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) return true;
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) return true;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */ function $fbca9f0141e13736$var$shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') return false;
    try {
        const target = event.target;
        if (!target || !target.tagName) return true;
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) return false;
    } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */ function $fbca9f0141e13736$var$makeDOMEventHandler(handler, globalListener = false) {
    return (event)=>{
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || $fbca9f0141e13736$var$lastCapturedEvent === event) return;
        // We always want to skip _some_ events.
        if ($fbca9f0141e13736$var$shouldSkipDOMEvent(event)) return;
        const name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if ($fbca9f0141e13736$var$debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $fbca9f0141e13736$var$lastCapturedEvent = event;
        } else if ($fbca9f0141e13736$var$shouldShortcircuitPreviousDebounce($fbca9f0141e13736$var$lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener
            });
            $fbca9f0141e13736$var$lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout($fbca9f0141e13736$var$debounceTimerID);
        $fbca9f0141e13736$var$debounceTimerID = $fbca9f0141e13736$var$WINDOW.setTimeout(()=>{
            $fbca9f0141e13736$var$debounceTimerID = undefined;
        }, $fbca9f0141e13736$var$debounceDuration);
    };
}
/** JSDoc */ function $fbca9f0141e13736$var$instrumentDOM() {
    if (!('document' in $fbca9f0141e13736$var$WINDOW)) return;
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    const triggerDOMHandler = $fbca9f0141e13736$var$triggerHandlers.bind(null, 'dom');
    const globalDOMEventHandler = $fbca9f0141e13736$var$makeDOMEventHandler(triggerDOMHandler, true);
    $fbca9f0141e13736$var$WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
    $fbca9f0141e13736$var$WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    [
        'EventTarget',
        'Node'
    ].forEach((target)=>{
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const proto = $fbca9f0141e13736$var$WINDOW[target] && $fbca9f0141e13736$var$WINDOW[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) return;
        (0, $3CK1O.fill)(proto, 'addEventListener', function(originalAddEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type] = handlers[type] || {
                        refCount: 0
                    };
                    if (!handlerForType.handler) {
                        const handler = $fbca9f0141e13736$var$makeDOMEventHandler(triggerDOMHandler);
                        handlerForType.handler = handler;
                        originalAddEventListener.call(this, type, handler, options);
                    }
                    handlerForType.refCount++;
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        (0, $3CK1O.fill)(proto, 'removeEventListener', function(originalRemoveEventListener) {
            return function(type, listener, options) {
                if (type === 'click' || type == 'keypress') try {
                    const el = this;
                    const handlers = el.__sentry_instrumentation_handlers__ || {};
                    const handlerForType = handlers[type];
                    if (handlerForType) {
                        handlerForType.refCount--;
                        // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                        if (handlerForType.refCount <= 0) {
                            originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                            handlerForType.handler = undefined;
                            delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                        }
                        // If there are no longer any custom handlers of any type on this element, cleanup everything.
                        if (Object.keys(handlers).length === 0) delete el.__sentry_instrumentation_handlers__;
                    }
                } catch (e) {
                // Accessing dom properties is always fragile.
                // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
let $fbca9f0141e13736$var$_oldOnErrorHandler = null;
/** JSDoc */ function $fbca9f0141e13736$var$instrumentError() {
    $fbca9f0141e13736$var$_oldOnErrorHandler = $fbca9f0141e13736$var$WINDOW.onerror;
    $fbca9f0141e13736$var$WINDOW.onerror = function(msg, url, line, column, error) {
        $fbca9f0141e13736$var$triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url
        });
        if ($fbca9f0141e13736$var$_oldOnErrorHandler && !$fbca9f0141e13736$var$_oldOnErrorHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $fbca9f0141e13736$var$_oldOnErrorHandler.apply(this, arguments);
        return false;
    };
    $fbca9f0141e13736$var$WINDOW.onerror.__SENTRY_INSTRUMENTED__ = true;
}
let $fbca9f0141e13736$var$_oldOnUnhandledRejectionHandler = null;
/** JSDoc */ function $fbca9f0141e13736$var$instrumentUnhandledRejection() {
    $fbca9f0141e13736$var$_oldOnUnhandledRejectionHandler = $fbca9f0141e13736$var$WINDOW.onunhandledrejection;
    $fbca9f0141e13736$var$WINDOW.onunhandledrejection = function(e) {
        $fbca9f0141e13736$var$triggerHandlers('unhandledrejection', e);
        if ($fbca9f0141e13736$var$_oldOnUnhandledRejectionHandler && !$fbca9f0141e13736$var$_oldOnUnhandledRejectionHandler.__SENTRY_LOADER__) // eslint-disable-next-line prefer-rest-params
        return $fbca9f0141e13736$var$_oldOnUnhandledRejectionHandler.apply(this, arguments);
        return true;
    };
    $fbca9f0141e13736$var$WINDOW.onunhandledrejection.__SENTRY_INSTRUMENTED__ = true;
}

});
parcelRegister("8yub9", function(module, exports) {

$parcel$export(module.exports, "getFunctionName", () => $63a8e898f1509e2a$export$aad197c7121a6651);

var $hvdHR = parcelRequire("hvdHR");
const $63a8e898f1509e2a$var$STACKTRACE_FRAME_LIMIT = 50;
// Used to sanitize webpack (error: *) wrapped stack errors
const $63a8e898f1509e2a$var$WEBPACK_ERROR_REGEXP = /\(error: (.*)\)/;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */ function $63a8e898f1509e2a$export$a5739666fb2d03d4(...parsers) {
    const sortedParsers = parsers.sort((a, b)=>a[0] - b[0]).map((p)=>p[1]);
    return (stack, skipFirst = 0)=>{
        const frames = [];
        const lines = stack.split('\n');
        for(let i = skipFirst; i < lines.length; i++){
            const line = lines[i];
            // Ignore lines over 1kb as they are unlikely to be stack frames.
            // Many of the regular expressions use backtracking which results in run time that increases exponentially with
            // input size. Huge strings can result in hangs/Denial of Service:
            // https://github.com/getsentry/sentry-javascript/issues/2286
            if (line.length > 1024) continue;
            // https://github.com/getsentry/sentry-javascript/issues/5459
            // Remove webpack (error: *) wrappers
            const cleanedLine = $63a8e898f1509e2a$var$WEBPACK_ERROR_REGEXP.test(line) ? line.replace($63a8e898f1509e2a$var$WEBPACK_ERROR_REGEXP, '$1') : line;
            for (const parser of sortedParsers){
                const frame = parser(cleanedLine);
                if (frame) {
                    frames.push(frame);
                    break;
                }
            }
            if (frames.length >= $63a8e898f1509e2a$var$STACKTRACE_FRAME_LIMIT) break;
        }
        return $63a8e898f1509e2a$export$c55c24c0eeba0205(frames);
    };
}
/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */ function $63a8e898f1509e2a$export$1d5cf88b347146d4(stackParser) {
    if (Array.isArray(stackParser)) return $63a8e898f1509e2a$export$a5739666fb2d03d4(...stackParser);
    return stackParser;
}
/**
 * Removes Sentry frames from the top and bottom of the stack if present and enforces a limit of max number of frames.
 * Assumes stack input is ordered from top to bottom and returns the reverse representation so call site of the
 * function that caused the crash is the last frame in the array.
 * @hidden
 */ function $63a8e898f1509e2a$export$c55c24c0eeba0205(stack) {
    if (!stack.length) return [];
    const localStack = stack.slice(0, $63a8e898f1509e2a$var$STACKTRACE_FRAME_LIMIT);
    const lastFrameFunction = localStack[localStack.length - 1].function;
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (lastFrameFunction && /sentryWrapped/.test(lastFrameFunction)) localStack.pop();
    // Reversing in the middle of the procedure allows us to just pop the values off the stack
    localStack.reverse();
    const firstFrameFunction = localStack[localStack.length - 1].function;
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (firstFrameFunction && /captureMessage|captureException/.test(firstFrameFunction)) localStack.pop();
    return localStack.map((frame)=>({
            ...frame,
            filename: frame.filename || localStack[localStack.length - 1].filename,
            function: frame.function || '?'
        }));
}
const $63a8e898f1509e2a$var$defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */ function $63a8e898f1509e2a$export$aad197c7121a6651(fn) {
    try {
        if (!fn || typeof fn !== 'function') return $63a8e898f1509e2a$var$defaultFunctionName;
        return fn.name || $63a8e898f1509e2a$var$defaultFunctionName;
    } catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return $63a8e898f1509e2a$var$defaultFunctionName;
    }
}
/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */ function $63a8e898f1509e2a$export$673345a0da635a78(getModule) {
    return [
        90,
        (0, $hvdHR.node)(getModule)
    ];
}

});
parcelRegister("hvdHR", function(module, exports) {

$parcel$export(module.exports, "node", () => $cbdff6bfb5826762$export$35059013cd4a06db);
/** Node Stack line parser */ // eslint-disable-next-line complexity
function $cbdff6bfb5826762$export$35059013cd4a06db(getModule) {
    const FILENAME_MATCH = /^\s*[-]{4,}$/;
    const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;
    // eslint-disable-next-line complexity
    return (line)=>{
        const lineMatch = line.match(FULL_MATCH);
        if (lineMatch) {
            let object;
            let method;
            let functionName;
            let typeName;
            let methodName;
            if (lineMatch[1]) {
                functionName = lineMatch[1];
                let methodStart = functionName.lastIndexOf('.');
                if (functionName[methodStart - 1] === '.') methodStart--;
                if (methodStart > 0) {
                    object = functionName.slice(0, methodStart);
                    method = functionName.slice(methodStart + 1);
                    const objectEnd = object.indexOf('.Module');
                    if (objectEnd > 0) {
                        functionName = functionName.slice(objectEnd + 1);
                        object = object.slice(0, objectEnd);
                    }
                }
                typeName = undefined;
            }
            if (method) {
                typeName = object;
                methodName = method;
            }
            if (method === '<anonymous>') {
                methodName = undefined;
                functionName = undefined;
            }
            if (functionName === undefined) {
                methodName = methodName || '<anonymous>';
                functionName = typeName ? `${typeName}.${methodName}` : methodName;
            }
            let filename = lineMatch[2] && lineMatch[2].startsWith('file://') ? lineMatch[2].slice(7) : lineMatch[2];
            const isNative = lineMatch[5] === 'native';
            if (!filename && lineMatch[5] && !isNative) filename = lineMatch[5];
            const isInternal = isNative || filename && !filename.startsWith('/') && !filename.startsWith('.') && !filename.includes(':\\');
            // in_app is all that's not an internal Node function or a module within node_modules
            // note that isNative appears to return true even for node core libraries
            // see https://github.com/getsentry/raven-node/issues/176
            const in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');
            return {
                filename: filename,
                module: getModule ? getModule(filename) : undefined,
                function: functionName,
                lineno: parseInt(lineMatch[3], 10) || undefined,
                colno: parseInt(lineMatch[4], 10) || undefined,
                in_app: in_app
            };
        }
        if (line.match(FILENAME_MATCH)) return {
            filename: line
        };
        return undefined;
    };
}

});


parcelRegister("7VirA", function(module, exports) {

$parcel$export(module.exports, "supportsNativeFetch", () => $5c4c29dc9a8086e3$export$c82d238e23c40b21);

var $elKLM = parcelRequire("elKLM");

var $dQTB1 = parcelRequire("dQTB1");
// eslint-disable-next-line deprecation/deprecation
const $5c4c29dc9a8086e3$var$WINDOW = (0, $dQTB1.getGlobalObject)();
/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */ function $5c4c29dc9a8086e3$export$caa710b4d7f9cadf() {
    try {
        new ErrorEvent('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */ function $5c4c29dc9a8086e3$export$1c08bd1a7eb3c472() {
    try {
        // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
        // 1 argument required, but only 0 present.
        // @ts-ignore It really needs 1 argument, not 0.
        new DOMError('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */ function $5c4c29dc9a8086e3$export$ab12a5d056f1d3a() {
    try {
        new DOMException('');
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */ function $5c4c29dc9a8086e3$export$edf3cb81fd7d2a3e() {
    if (!('fetch' in $5c4c29dc9a8086e3$var$WINDOW)) return false;
    try {
        new Headers();
        new Request('http://www.example.com');
        new Response();
        return true;
    } catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */ // eslint-disable-next-line @typescript-eslint/ban-types
function $5c4c29dc9a8086e3$export$18cf36ed71d733e7(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */ function $5c4c29dc9a8086e3$export$c82d238e23c40b21() {
    if (!$5c4c29dc9a8086e3$export$edf3cb81fd7d2a3e()) return false;
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if ($5c4c29dc9a8086e3$export$18cf36ed71d733e7($5c4c29dc9a8086e3$var$WINDOW.fetch)) return true;
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    let result = false;
    const doc = $5c4c29dc9a8086e3$var$WINDOW.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') try {
        const sandbox = doc.createElement('iframe');
        sandbox.hidden = true;
        doc.head.appendChild(sandbox);
        if (sandbox.contentWindow && sandbox.contentWindow.fetch) // eslint-disable-next-line @typescript-eslint/unbound-method
        result = $5c4c29dc9a8086e3$export$18cf36ed71d733e7(sandbox.contentWindow.fetch);
        doc.head.removeChild(sandbox);
    } catch (err) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
    return result;
}
/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */ function $5c4c29dc9a8086e3$export$531055a6c684a70a() {
    return 'ReportingObserver' in $5c4c29dc9a8086e3$var$WINDOW;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */ function $5c4c29dc9a8086e3$export$2d308b428295192f() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!$5c4c29dc9a8086e3$export$edf3cb81fd7d2a3e()) return false;
    try {
        new Request('_', {
            referrerPolicy: 'origin'
        });
        return true;
    } catch (e) {
        return false;
    }
}

});

parcelRegister("2t4YI", function(module, exports) {

$parcel$export(module.exports, "supportsHistory", () => $1cc226cd197b06c3$export$67fc34576016d6ec);

var $dQTB1 = parcelRequire("dQTB1");
// Based on https://github.com/angular/angular.js/pull/13945/files
// eslint-disable-next-line deprecation/deprecation
const $1cc226cd197b06c3$var$WINDOW = (0, $dQTB1.getGlobalObject)();
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */ function $1cc226cd197b06c3$export$67fc34576016d6ec() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const chrome = $1cc226cd197b06c3$var$WINDOW.chrome;
    const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */ const hasHistoryApi = 'history' in $1cc226cd197b06c3$var$WINDOW && !!$1cc226cd197b06c3$var$WINDOW.history.pushState && !!$1cc226cd197b06c3$var$WINDOW.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

});


parcelRegister("ebD1W", function(module, exports) {

$parcel$export(module.exports, "getActiveTransaction", () => $a5405e5c6e90ec59$export$a7feb32fdd923295);

var $7Qe7s = parcelRequire("7Qe7s");

/** Grabs active transaction off scope, if any */ function $a5405e5c6e90ec59$export$a7feb32fdd923295(maybeHub) {
    const hub = maybeHub || (0, $7Qe7s.getCurrentHub)();
    const scope = hub.getScope();
    return scope.getTransaction();
}

});


parcelRegister("26wej", function(module, exports) {

$parcel$export(module.exports, "TRACING_DEFAULTS", () => $188524781b2d46ba$export$809a2b7987fd5306);
$parcel$export(module.exports, "IdleTransaction", () => $188524781b2d46ba$export$b279e6bd7040371f);

var $elKLM = parcelRequire("elKLM");
var $43Vyk = parcelRequire("43Vyk");

var $cIUeM = parcelRequire("cIUeM");

var $fTr2B = parcelRequire("fTr2B");
const $188524781b2d46ba$export$809a2b7987fd5306 = {
    idleTimeout: 1000,
    finalTimeout: 30000,
    heartbeatInterval: 5000
};
const $188524781b2d46ba$var$FINISH_REASON_TAG = 'finishReason';
const $188524781b2d46ba$var$IDLE_TRANSACTION_FINISH_REASONS = [
    'heartbeatFailed',
    'idleTimeout',
    'documentHidden',
    'finalTimeout',
    'externalFinish',
    'cancelled'
];
/**
 * @inheritDoc
 */ class $188524781b2d46ba$export$370d6113c18ba86c extends (0, $cIUeM.SpanRecorder) {
    constructor(_pushActivity, _popActivity, transactionSpanId, maxlen){
        super(maxlen);
        this._pushActivity = _pushActivity;
        this._popActivity = _popActivity;
        this.transactionSpanId = transactionSpanId;
    }
    /**
   * @inheritDoc
   */ add(span) {
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = (endTimestamp)=>{
                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0, $43Vyk.timestampWithMs)();
                this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) this._pushActivity(span.spanId);
        }
        super.add(span);
    }
}
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */ class $188524781b2d46ba$export$b279e6bd7040371f extends (0, $fTr2B.Transaction) {
    // Activities store a list of active spans
    __init() {
        this.activities = {};
    }
    // Track state of activities in previous heartbeat
    // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
    __init2() {
        this._heartbeatCounter = 0;
    }
    // We should not use heartbeat if we finished a transaction
    __init3() {
        this._finished = false;
    }
    // Idle timeout was canceled and we should finish the transaction with the last span end.
    __init4() {
        this._idleTimeoutCanceledPermanently = false;
    }
    __init5() {
        this._beforeFinishCallbacks = [];
    }
    /**
   * Timer that tracks Transaction idleTimeout
   */ __init6() {
        this._finishReason = $188524781b2d46ba$var$IDLE_TRANSACTION_FINISH_REASONS[4];
    }
    constructor(transactionContext, _idleHub, /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */ _idleTimeout = $188524781b2d46ba$export$809a2b7987fd5306.idleTimeout, /**
     * The final value in ms that a transaction cannot exceed
     */ _finalTimeout = $188524781b2d46ba$export$809a2b7987fd5306.finalTimeout, _heartbeatInterval = $188524781b2d46ba$export$809a2b7987fd5306.heartbeatInterval, // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope = false){
        super(transactionContext, _idleHub);
        this._idleHub = _idleHub;
        this._idleTimeout = _idleTimeout;
        this._finalTimeout = _finalTimeout;
        this._heartbeatInterval = _heartbeatInterval;
        this._onScope = _onScope;
        $188524781b2d46ba$export$b279e6bd7040371f.prototype.__init.call(this);
        $188524781b2d46ba$export$b279e6bd7040371f.prototype.__init2.call(this);
        $188524781b2d46ba$export$b279e6bd7040371f.prototype.__init3.call(this);
        $188524781b2d46ba$export$b279e6bd7040371f.prototype.__init4.call(this);
        $188524781b2d46ba$export$b279e6bd7040371f.prototype.__init5.call(this);
        $188524781b2d46ba$export$b279e6bd7040371f.prototype.__init6.call(this);
        if (_onScope) {
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
            _idleHub.configureScope((scope)=>scope.setSpan(this));
        }
        this._restartIdleTimeout();
        setTimeout(()=>{
            if (!this._finished) {
                this.setStatus('deadline_exceeded');
                this._finishReason = $188524781b2d46ba$var$IDLE_TRANSACTION_FINISH_REASONS[3];
                this.finish();
            }
        }, this._finalTimeout);
    }
    /** {@inheritDoc} */ finish(endTimestamp = (0, $43Vyk.timestampWithMs)()) {
        this._finished = true;
        this.activities = {};
        if (this.op === 'ui.action.click') this.setTag($188524781b2d46ba$var$FINISH_REASON_TAG, this._finishReason);
        if (this.spanRecorder) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
            for (const callback of this._beforeFinishCallbacks)callback(this, endTimestamp);
            this.spanRecorder.spans = this.spanRecorder.spans.filter((span)=>{
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === this.spanId) return true;
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus('cancelled');
                    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                const keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
                return keepSpan;
            });
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] flushing IdleTransaction');
        } else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] No active IdleTransaction');
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            const scope = this._idleHub.getScope();
            if (scope.getTransaction() === this) scope.setSpan(undefined);
        }
        return super.finish(endTimestamp);
    }
    /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */ registerBeforeFinishCallback(callback) {
        this._beforeFinishCallbacks.push(callback);
    }
    /**
   * @inheritDoc
   */ initSpanRecorder(maxlen) {
        if (!this.spanRecorder) {
            const pushActivity = (id)=>{
                if (this._finished) return;
                this._pushActivity(id);
            };
            const popActivity = (id)=>{
                if (this._finished) return;
                this._popActivity(id);
            };
            this.spanRecorder = new $188524781b2d46ba$export$370d6113c18ba86c(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('Starting heartbeat');
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    }
    /**
   * Cancels the existing idle timeout, if there is one.
   * @param restartOnChildSpanChange Default is `true`.
   *                                 If set to false the transaction will end
   *                                 with the last child span.
   */ cancelIdleTimeout(endTimestamp, { restartOnChildSpanChange: restartOnChildSpanChange } = {
        restartOnChildSpanChange: true
    }) {
        this._idleTimeoutCanceledPermanently = restartOnChildSpanChange === false;
        if (this._idleTimeoutID) {
            clearTimeout(this._idleTimeoutID);
            this._idleTimeoutID = undefined;
            if (Object.keys(this.activities).length === 0 && this._idleTimeoutCanceledPermanently) {
                this._finishReason = $188524781b2d46ba$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            }
        }
    }
    /**
   * Temporary method used to externally set the transaction's `finishReason`
   *
   * ** WARNING**
   * This is for the purpose of experimentation only and will be removed in the near future, do not use!
   *
   * @internal
   *
   */ setFinishReason(reason) {
        this._finishReason = reason;
    }
    /**
   * Restarts idle timeout, if there is no running idle timeout it will start one.
   */ _restartIdleTimeout(endTimestamp) {
        this.cancelIdleTimeout();
        this._idleTimeoutID = setTimeout(()=>{
            if (!this._finished && Object.keys(this.activities).length === 0) {
                this._finishReason = $188524781b2d46ba$var$IDLE_TRANSACTION_FINISH_REASONS[1];
                this.finish(endTimestamp);
            }
        }, this._idleTimeout);
    }
    /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */ _pushActivity(spanId) {
        this.cancelIdleTimeout(undefined, {
            restartOnChildSpanChange: !this._idleTimeoutCanceledPermanently
        });
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] pushActivity: ${spanId}`);
        this.activities[spanId] = true;
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
    }
    /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */ _popActivity(spanId) {
        if (this.activities[spanId]) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] popActivity ${spanId}`);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            const endTimestamp = (0, $43Vyk.timestampWithMs)();
            if (this._idleTimeoutCanceledPermanently) {
                this._finishReason = $188524781b2d46ba$var$IDLE_TRANSACTION_FINISH_REASONS[5];
                this.finish(endTimestamp);
            } else // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampWithMs is in seconds, timeout is in ms
            this._restartIdleTimeout(endTimestamp + this._idleTimeout / 1000);
        }
    }
    /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */ _beat() {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) return;
        const heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) this._heartbeatCounter++;
        else this._heartbeatCounter = 1;
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] Transaction finished because of no change for 3 heart beats');
            this.setStatus('deadline_exceeded');
            this._finishReason = $188524781b2d46ba$var$IDLE_TRANSACTION_FINISH_REASONS[0];
            this.finish();
        } else this._pingHeartbeat();
    }
    /**
   * Pings the heartbeat
   */ _pingHeartbeat() {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
        setTimeout(()=>{
            this._beat();
        }, this._heartbeatInterval);
    }
}

});
parcelRegister("cIUeM", function(module, exports) {

$parcel$export(module.exports, "SpanRecorder", () => $943537a60a46221f$export$10c95c129cd0d4fe);
$parcel$export(module.exports, "Span", () => $943537a60a46221f$export$5f1714a13ed34c01);
$parcel$export(module.exports, "spanStatusfromHttpCode", () => $943537a60a46221f$export$ac65c70d78fcdb55);

var $3CK1O = parcelRequire("3CK1O");
var $elKLM = parcelRequire("elKLM");
var $43Vyk = parcelRequire("43Vyk");
var $aG8PM = parcelRequire("aG8PM");
/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */ class $943537a60a46221f$export$10c95c129cd0d4fe {
    __init() {
        this.spans = [];
    }
    constructor(maxlen = 1000){
        $943537a60a46221f$export$10c95c129cd0d4fe.prototype.__init.call(this);
        this._maxlen = maxlen;
    }
    /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */ add(span) {
        if (this.spans.length > this._maxlen) span.spanRecorder = undefined;
        else this.spans.push(span);
    }
}
/**
 * Span contains all data about a span
 */ class $943537a60a46221f$export$5f1714a13ed34c01 {
    /**
   * @inheritDoc
   */ __init2() {
        this.traceId = (0, $aG8PM.uuid4)();
    }
    /**
   * @inheritDoc
   */ __init3() {
        this.spanId = (0, $aG8PM.uuid4)().substring(16);
    }
    /**
   * @inheritDoc
   */ /**
   * Internal keeper of the status
   */ /**
   * @inheritDoc
   */ /**
   * Timestamp in seconds when the span was created.
   */ __init4() {
        this.startTimestamp = (0, $43Vyk.timestampWithMs)();
    }
    /**
   * Timestamp in seconds when the span ended.
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ /**
   * @inheritDoc
   */ __init5() {
        this.tags = {};
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    __init6() {
        this.data = {};
    }
    /**
   * List of spans that were finalized
   */ /**
   * @inheritDoc
   */ /**
   * The instrumenter that created this span.
   */ __init7() {
        this.instrumenter = 'sentry';
    }
    /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(spanContext){
        $943537a60a46221f$export$5f1714a13ed34c01.prototype.__init2.call(this);
        $943537a60a46221f$export$5f1714a13ed34c01.prototype.__init3.call(this);
        $943537a60a46221f$export$5f1714a13ed34c01.prototype.__init4.call(this);
        $943537a60a46221f$export$5f1714a13ed34c01.prototype.__init5.call(this);
        $943537a60a46221f$export$5f1714a13ed34c01.prototype.__init6.call(this);
        $943537a60a46221f$export$5f1714a13ed34c01.prototype.__init7.call(this);
        if (!spanContext) return this;
        if (spanContext.traceId) this.traceId = spanContext.traceId;
        if (spanContext.spanId) this.spanId = spanContext.spanId;
        if (spanContext.parentSpanId) this.parentSpanId = spanContext.parentSpanId;
        // We want to include booleans as well here
        if ('sampled' in spanContext) this.sampled = spanContext.sampled;
        if (spanContext.op) this.op = spanContext.op;
        if (spanContext.description) this.description = spanContext.description;
        if (spanContext.data) this.data = spanContext.data;
        if (spanContext.tags) this.tags = spanContext.tags;
        if (spanContext.status) this.status = spanContext.status;
        if (spanContext.startTimestamp) this.startTimestamp = spanContext.startTimestamp;
        if (spanContext.endTimestamp) this.endTimestamp = spanContext.endTimestamp;
        if (spanContext.instrumenter) this.instrumenter = spanContext.instrumenter;
    }
    /**
   * @inheritDoc
   */ startChild(spanContext) {
        const childSpan = new $943537a60a46221f$export$5f1714a13ed34c01({
            ...spanContext,
            parentSpanId: this.spanId,
            sampled: this.sampled,
            traceId: this.traceId
        });
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) childSpan.spanRecorder.add(childSpan);
        childSpan.transaction = this.transaction;
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
            const opStr = spanContext && spanContext.op || '< unknown op >';
            const nameStr = childSpan.transaction.name || '< unknown name >';
            const idStr = childSpan.transaction.spanId;
            const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
            childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = {
                logMessage: logMessage
            };
            (0, $elKLM.logger).log(logMessage);
        }
        return childSpan;
    }
    /**
   * @inheritDoc
   */ setTag(key, value) {
        this.tags = {
            ...this.tags,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    setData(key, value) {
        this.data = {
            ...this.data,
            [key]: value
        };
        return this;
    }
    /**
   * @inheritDoc
   */ setStatus(value) {
        this.status = value;
        return this;
    }
    /**
   * @inheritDoc
   */ setHttpStatus(httpStatus) {
        this.setTag('http.status_code', String(httpStatus));
        const spanStatus = $943537a60a46221f$export$ac65c70d78fcdb55(httpStatus);
        if (spanStatus !== 'unknown_error') this.setStatus(spanStatus);
        return this;
    }
    /**
   * @inheritDoc
   */ isSuccess() {
        return this.status === 'ok';
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && // Don't call this for transactions
        this.transaction && this.transaction.spanId !== this.spanId) {
            const { logMessage: logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
            if (logMessage) (0, $elKLM.logger).log(logMessage.replace('Starting', 'Finishing'));
        }
        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0, $43Vyk.timestampWithMs)();
    }
    /**
   * @inheritDoc
   */ toTraceparent() {
        let sampledString = '';
        if (this.sampled !== undefined) sampledString = this.sampled ? '-1' : '-0';
        return `${this.traceId}-${this.spanId}${sampledString}`;
    }
    /**
   * @inheritDoc
   */ toContext() {
        return (0, $3CK1O.dropUndefinedKeys)({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(spanContext) {
        this.data = spanContext.data || {};
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = spanContext.spanId || this.spanId;
        this.startTimestamp = spanContext.startTimestamp || this.startTimestamp;
        this.status = spanContext.status;
        this.tags = spanContext.tags || {};
        this.traceId = spanContext.traceId || this.traceId;
        return this;
    }
    /**
   * @inheritDoc
   */ getTraceContext() {
        return (0, $3CK1O.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId
        });
    }
    /**
   * @inheritDoc
   */ toJSON() {
        return (0, $3CK1O.dropUndefinedKeys)({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId
        });
    }
}
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */ function $943537a60a46221f$export$ac65c70d78fcdb55(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) return 'ok';
    if (httpStatus >= 400 && httpStatus < 500) switch(httpStatus){
        case 401:
            return 'unauthenticated';
        case 403:
            return 'permission_denied';
        case 404:
            return 'not_found';
        case 409:
            return 'already_exists';
        case 413:
            return 'failed_precondition';
        case 429:
            return 'resource_exhausted';
        default:
            return 'invalid_argument';
    }
    if (httpStatus >= 500 && httpStatus < 600) switch(httpStatus){
        case 501:
            return 'unimplemented';
        case 503:
            return 'unavailable';
        case 504:
            return 'deadline_exceeded';
        default:
            return 'internal_error';
    }
    return 'unknown_error';
}

});

parcelRegister("fTr2B", function(module, exports) {

$parcel$export(module.exports, "Transaction", () => $b920f7d2140dfb3f$export$febc5573c75cefb0);

var $3CK1O = parcelRequire("3CK1O");
var $elKLM = parcelRequire("elKLM");

var $94HCL = parcelRequire("94HCL");

var $7Qe7s = parcelRequire("7Qe7s");

var $cIUeM = parcelRequire("cIUeM");
/** JSDoc */ class $b920f7d2140dfb3f$export$febc5573c75cefb0 extends (0, $cIUeM.Span) {
    /**
   * The reference to the current hub.
   */ __init() {
        this._measurements = {};
    }
    __init2() {
        this._contexts = {};
    }
    __init3() {
        this._frozenDynamicSamplingContext = undefined;
    }
    /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */ constructor(transactionContext, hub){
        super(transactionContext);
        $b920f7d2140dfb3f$export$febc5573c75cefb0.prototype.__init.call(this);
        $b920f7d2140dfb3f$export$febc5573c75cefb0.prototype.__init2.call(this);
        $b920f7d2140dfb3f$export$febc5573c75cefb0.prototype.__init3.call(this);
        this._hub = hub || (0, $7Qe7s.getCurrentHub)();
        this._name = transactionContext.name || '';
        this.metadata = {
            source: 'custom',
            ...transactionContext.metadata,
            spanMetadata: {}
        };
        this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        this.transaction = this;
        // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
        // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
        const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
        if (incomingDynamicSamplingContext) // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
        this._frozenDynamicSamplingContext = {
            ...incomingDynamicSamplingContext
        };
    }
    /** Getter for `name` property */ get name() {
        return this._name;
    }
    /** Setter for `name` property, which also sets `source` as custom */ set name(newName) {
        this.setName(newName);
    }
    /**
   * JSDoc
   */ setName(name, source = 'custom') {
        this._name = name;
        this.metadata.source = source;
    }
    /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */ initSpanRecorder(maxlen = 1000) {
        if (!this.spanRecorder) this.spanRecorder = new (0, $cIUeM.SpanRecorder)(maxlen);
        this.spanRecorder.add(this);
    }
    /**
   * @inheritDoc
   */ setContext(key, context) {
        if (context === null) // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
        delete this._contexts[key];
        else this._contexts[key] = context;
    }
    /**
   * @inheritDoc
   */ setMeasurement(name, value, unit = '') {
        this._measurements[name] = {
            value: value,
            unit: unit
        };
    }
    /**
   * @inheritDoc
   */ setMetadata(newMetadata) {
        this.metadata = {
            ...this.metadata,
            ...newMetadata
        };
    }
    /**
   * @inheritDoc
   */ finish(endTimestamp) {
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) return undefined;
        if (!this.name) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this.name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        super.finish(endTimestamp);
        const client = this._hub.getClient();
        if (client && client.emit) client.emit('finishTransaction', this);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            if (client) client.recordDroppedEvent('sample_rate', 'transaction');
            return undefined;
        }
        const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter((s)=>s !== this && s.endTimestamp) : [];
        if (this._trimEnd && finishedSpans.length > 0) this.endTimestamp = finishedSpans.reduce((prev, current)=>{
            if (prev.endTimestamp && current.endTimestamp) return prev.endTimestamp > current.endTimestamp ? prev : current;
            return prev;
        }).endTimestamp;
        const metadata = this.metadata;
        const transaction = {
            contexts: {
                ...this._contexts,
                // We don't want to override trace context
                trace: this.getTraceContext()
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: 'transaction',
            sdkProcessingMetadata: {
                ...metadata,
                dynamicSamplingContext: this.getDynamicSamplingContext()
            },
            ...metadata.source && {
                transaction_info: {
                    source: metadata.source
                }
            }
        };
        const hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);
        return this._hub.captureEvent(transaction);
    }
    /**
   * @inheritDoc
   */ toContext() {
        const spanContext = super.toContext();
        return (0, $3CK1O.dropUndefinedKeys)({
            ...spanContext,
            name: this.name,
            trimEnd: this._trimEnd
        });
    }
    /**
   * @inheritDoc
   */ updateWithContext(transactionContext) {
        super.updateWithContext(transactionContext);
        this.name = transactionContext.name || '';
        this._trimEnd = transactionContext.trimEnd;
        return this;
    }
    /**
   * @inheritdoc
   *
   * @experimental
   */ getDynamicSamplingContext() {
        if (this._frozenDynamicSamplingContext) return this._frozenDynamicSamplingContext;
        const hub = this._hub || (0, $7Qe7s.getCurrentHub)();
        const client = hub && hub.getClient();
        if (!client) return {};
        const { environment: environment, release: release } = client.getOptions() || {};
        const { publicKey: public_key } = client.getDsn() || {};
        const maybeSampleRate = this.metadata.sampleRate;
        const sample_rate = maybeSampleRate !== undefined ? maybeSampleRate.toString() : undefined;
        const { segment: user_segment } = hub.getScope().getUser() || {};
        const source = this.metadata.source;
        // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
        const transaction = source && source !== 'url' ? this.name : undefined;
        const dsc = (0, $3CK1O.dropUndefinedKeys)({
            environment: environment || (0, $94HCL.DEFAULT_ENVIRONMENT),
            release: release,
            transaction: transaction,
            user_segment: user_segment,
            public_key: public_key,
            trace_id: this.traceId,
            sample_rate: sample_rate
        });
        // Uncomment if we want to make DSC immutable
        // this._frozenDynamicSamplingContext = dsc;
        client.emit && client.emit('createDsc', dsc);
        return dsc;
    }
    /**
   * Override the current hub with a new one.
   * Used if you want another hub to finish the transaction.
   *
   * @internal
   */ setHub(hub) {
        this._hub = hub;
    }
}

});




parcelRegister("bv9YB", function(module, exports) {

$parcel$export(module.exports, "Apollo", () => $85fa5419e8b334e7$export$3db3e396472fda8d);

var $4Aa3G = parcelRequire("4Aa3G");

var $aG8PM = parcelRequire("aG8PM");
var $3CK1O = parcelRequire("3CK1O");
var $k7rM9 = parcelRequire("k7rM9");
var $fEKkD = parcelRequire("fEKkD");
var $elKLM = parcelRequire("elKLM");

var $fzFcM = parcelRequire("fzFcM");
/** Tracing integration for Apollo */ class $85fa5419e8b334e7$export$3db3e396472fda8d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Apollo';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $85fa5419e8b334e7$export$3db3e396472fda8d.id;
    }
    /**
   * @inheritDoc
   */ constructor(options = {
        useNestjs: false
    }){
        $85fa5419e8b334e7$export$3db3e396472fda8d.prototype.__init.call(this);
        this._useNest = !!options.useNestjs;
    }
    /** @inheritdoc */ loadDependency() {
        if (this._useNest) this._module = this._module || (0, $fEKkD.loadModule)('@nestjs/graphql');
        else this._module = this._module || (0, $fEKkD.loadModule)('apollo-server-core');
        return this._module;
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $fzFcM.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('Apollo Integration is skipped because of instrumenter configuration.');
            return;
        }
        if (this._useNest) {
            const pkg = this.loadDependency();
            if (!pkg) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error('Apollo-NestJS Integration was unable to require @nestjs/graphql package.');
                return;
            }
            /**
       * Iterate over resolvers of NestJS ResolversExplorerService before schemas are constructed.
       */ (0, $3CK1O.fill)(pkg.GraphQLFactory.prototype, 'mergeWithSchema', function(orig) {
                return function(...args) {
                    (0, $3CK1O.fill)(this.resolversExplorerService, 'explore', function(orig) {
                        return function() {
                            const resolvers = (0, $aG8PM.arrayify)(orig.call(this));
                            const instrumentedResolvers = $85fa5419e8b334e7$var$instrumentResolvers(resolvers, getCurrentHub);
                            return instrumentedResolvers;
                        };
                    });
                    return orig.call(this, ...args);
                };
            });
        } else {
            const pkg = this.loadDependency();
            if (!pkg) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error('Apollo Integration was unable to require apollo-server-core package.');
                return;
            }
            /**
       * Iterate over resolvers of the ApolloServer instance before schemas are constructed.
       */ (0, $3CK1O.fill)(pkg.ApolloServerBase.prototype, 'constructSchema', function(orig) {
                return function() {
                    if (!this.config.resolvers) {
                        if (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) {
                            if (this.config.schema) {
                                (0, $elKLM.logger).warn("Apollo integration is not able to trace `ApolloServer` instances constructed via `schema` property.If you are using NestJS with Apollo, please use `Sentry.Integrations.Apollo({ useNestjs: true })` instead.");
                                (0, $elKLM.logger).warn();
                            } else if (this.config.modules) (0, $elKLM.logger).warn('Apollo integration is not able to trace `ApolloServer` instances constructed via `modules` property.');
                            (0, $elKLM.logger).error('Skipping tracing as no resolvers found on the `ApolloServer` instance.');
                        }
                        return orig.call(this);
                    }
                    const resolvers = (0, $aG8PM.arrayify)(this.config.resolvers);
                    this.config.resolvers = $85fa5419e8b334e7$var$instrumentResolvers(resolvers, getCurrentHub);
                    return orig.call(this);
                };
            });
        }
    }
}
$85fa5419e8b334e7$export$3db3e396472fda8d.__initStatic();
function $85fa5419e8b334e7$var$instrumentResolvers(resolvers, getCurrentHub) {
    return resolvers.map((model)=>{
        Object.keys(model).forEach((resolverGroupName)=>{
            Object.keys(model[resolverGroupName]).forEach((resolverName)=>{
                if (typeof model[resolverGroupName][resolverName] !== 'function') return;
                $85fa5419e8b334e7$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub);
            });
        });
        return model;
    });
}
/**
 * Wrap a single resolver which can be a parent of other resolvers and/or db operations.
 */ function $85fa5419e8b334e7$var$wrapResolver(model, resolverGroupName, resolverName, getCurrentHub) {
    (0, $3CK1O.fill)(model[resolverGroupName], resolverName, function(orig) {
        return function(...args) {
            const scope = getCurrentHub().getScope();
            const parentSpan = (0, $4Aa3G._optionalChain)([
                scope,
                'optionalAccess',
                (_2)=>_2.getSpan,
                'call',
                (_3)=>_3()
            ]);
            const span = (0, $4Aa3G._optionalChain)([
                parentSpan,
                'optionalAccess',
                (_4)=>_4.startChild,
                'call',
                (_5)=>_5({
                        description: `${resolverGroupName}.${resolverName}`,
                        op: 'graphql.resolve'
                    })
            ]);
            const rv = orig.call(this, ...args);
            if ((0, $k7rM9.isThenable)(rv)) return rv.then((res)=>{
                (0, $4Aa3G._optionalChain)([
                    span,
                    'optionalAccess',
                    (_6)=>_6.finish,
                    'call',
                    (_7)=>_7()
                ]);
                return res;
            });
            (0, $4Aa3G._optionalChain)([
                span,
                'optionalAccess',
                (_8)=>_8.finish,
                'call',
                (_9)=>_9()
            ]);
            return rv;
        };
    });
}

});
parcelRegister("4Aa3G", function(module, exports) {

$parcel$export(module.exports, "_optionalChain", () => $356253a02a7490cb$export$3cc482e6b02f32f7);
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */ function $356253a02a7490cb$export$3cc482e6b02f32f7(ops) {
    let lastAccessLHS = undefined;
    let value = ops[0];
    let i = 1;
    while(i < ops.length){
        const op = ops[i];
        const fn = ops[i + 1];
        i += 2;
        // by checking for loose equality to `null`, we catch both `null` and `undefined`
        if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
        return;
        if (op === 'access' || op === 'optionalAccess') {
            lastAccessLHS = value;
            value = fn(value);
        } else if (op === 'call' || op === 'optionalCall') {
            value = fn((...args)=>value.call(lastAccessLHS, ...args));
            lastAccessLHS = undefined;
        }
    }
    return value;
}

});

parcelRegister("fzFcM", function(module, exports) {

$parcel$export(module.exports, "shouldDisableAutoInstrumentation", () => $b56a165d4a2bfa75$export$34db76d03eb96b7e);

var $4Aa3G = parcelRequire("4Aa3G");
/**
 * Check if Sentry auto-instrumentation should be disabled.
 *
 * @param getCurrentHub A method to fetch the current hub
 * @returns boolean
 */ function $b56a165d4a2bfa75$export$34db76d03eb96b7e(getCurrentHub) {
    const clientOptions = (0, $4Aa3G._optionalChain)([
        getCurrentHub,
        'call',
        (_)=>_(),
        'access',
        (_2)=>_2.getClient,
        'call',
        (_3)=>_3(),
        'optionalAccess',
        (_4)=>_4.getOptions,
        'call',
        (_5)=>_5()
    ]);
    const instrumenter = (0, $4Aa3G._optionalChain)([
        clientOptions,
        'optionalAccess',
        (_6)=>_6.instrumenter
    ]) || 'sentry';
    return instrumenter !== 'sentry';
}

});


parcelRegister("aYACQ", function(module, exports) {

$parcel$export(module.exports, "BROWSER_TRACING_INTEGRATION_ID", () => $7fdbeb07910059fd$export$bbd2089f30bd3708);
$parcel$export(module.exports, "BrowserTracing", () => $7fdbeb07910059fd$export$46d3bbd0375f5fa4);

var $103Ol = parcelRequire("103Ol");
var $3LZi0 = parcelRequire("3LZi0");
var $ebD1W = parcelRequire("ebD1W");
var $26wej = parcelRequire("26wej");

var $eNSFS = parcelRequire("eNSFS");
var $c12av = parcelRequire("c12av");
var $elKLM = parcelRequire("elKLM");

var $a9CTT = parcelRequire("a9CTT");

var $aX8fK = parcelRequire("aX8fK");

var $lpkeJ = parcelRequire("lpkeJ");

var $4V91W = parcelRequire("4V91W");

var $7qPZ8 = parcelRequire("7qPZ8");
const $7fdbeb07910059fd$export$bbd2089f30bd3708 = 'BrowserTracing';
/** Options for Browser Tracing integration */ const $7fdbeb07910059fd$var$DEFAULT_BROWSER_TRACING_OPTIONS = {
    ...(0, $26wej.TRACING_DEFAULTS),
    markBackgroundTransactions: true,
    routingInstrumentation: (0, $4V91W.instrumentRoutingWithDefaults),
    startTransactionOnLocationChange: true,
    startTransactionOnPageLoad: true,
    enableLongTask: true,
    _experiments: {},
    ...(0, $lpkeJ.defaultRequestInstrumentationOptions)
};
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */ class $7fdbeb07910059fd$export$46d3bbd0375f5fa4 {
    // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
    // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
    // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
    // integrations.
    /** Browser Tracing integration options */ /**
   * @inheritDoc
   */ __init() {
        this.name = $7fdbeb07910059fd$export$bbd2089f30bd3708;
    }
    constructor(_options){
        $7fdbeb07910059fd$export$46d3bbd0375f5fa4.prototype.__init.call(this);
        (0, $103Ol.addTracingExtensions)();
        this.options = {
            ...$7fdbeb07910059fd$var$DEFAULT_BROWSER_TRACING_OPTIONS,
            ..._options
        };
        // Special case: enableLongTask can be set in _experiments
        // TODO (v8): Remove this in v8
        if (this.options._experiments.enableLongTask !== undefined) this.options.enableLongTask = this.options._experiments.enableLongTask;
        // TODO (v8): remove this block after tracingOrigins is removed
        // Set tracePropagationTargets to tracingOrigins if specified by the user
        // In case both are specified, tracePropagationTargets takes precedence
        // eslint-disable-next-line deprecation/deprecation
        if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) // eslint-disable-next-line deprecation/deprecation
        this.options.tracePropagationTargets = _options.tracingOrigins;
        this._collectWebVitals = (0, $aX8fK.startTrackingWebVitals)();
        if (this.options.enableLongTask) (0, $aX8fK.startTrackingLongTasks)();
        if (this.options._experiments.enableInteractions) (0, $aX8fK.startTrackingInteractions)();
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        this._getCurrentHub = getCurrentHub;
        const { routingInstrumentation: instrumentRouting, startTransactionOnLocationChange: startTransactionOnLocationChange, startTransactionOnPageLoad: startTransactionOnPageLoad, markBackgroundTransactions: markBackgroundTransactions, traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: tracePropagationTargets, shouldCreateSpanForRequest: shouldCreateSpanForRequest, _experiments: _experiments } = this.options;
        instrumentRouting((context)=>{
            const transaction = this._createRouteTransaction(context);
            this.options._experiments.onStartRouteTransaction && this.options._experiments.onStartRouteTransaction(transaction, context, getCurrentHub);
            return transaction;
        }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) (0, $a9CTT.registerBackgroundTabDetection)();
        if (_experiments.enableInteractions) this._registerInteractionListener();
        (0, $lpkeJ.instrumentOutgoingRequests)({
            traceFetch: traceFetch,
            traceXHR: traceXHR,
            tracePropagationTargets: tracePropagationTargets,
            shouldCreateSpanForRequest: shouldCreateSpanForRequest
        });
    }
    /** Create routing idle transaction. */ _createRouteTransaction(context) {
        if (!this._getCurrentHub) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
            return undefined;
        }
        const { beforeNavigate: beforeNavigate, idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
        const isPageloadTransaction = context.op === 'pageload';
        const sentryTraceMetaTagValue = isPageloadTransaction ? $7fdbeb07910059fd$export$f147b32b03c9cf11('sentry-trace') : null;
        const baggageMetaTagValue = isPageloadTransaction ? $7fdbeb07910059fd$export$f147b32b03c9cf11('baggage') : null;
        const traceParentData = sentryTraceMetaTagValue ? (0, $3LZi0.extractTraceparentData)(sentryTraceMetaTagValue) : undefined;
        const dynamicSamplingContext = baggageMetaTagValue ? (0, $eNSFS.baggageHeaderToDynamicSamplingContext)(baggageMetaTagValue) : undefined;
        const expandedContext = {
            ...context,
            ...traceParentData,
            metadata: {
                ...context.metadata,
                dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext
            },
            trimEnd: true
        };
        const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        const finalContext = modifiedContext === undefined ? {
            ...expandedContext,
            sampled: false
        } : modifiedContext;
        // If `beforeNavigate` set a custom name, record that fact
        finalContext.metadata = finalContext.name !== expandedContext.name ? {
            ...finalContext.metadata,
            source: 'custom'
        } : finalContext.metadata;
        this._latestRouteName = finalContext.name;
        this._latestRouteSource = finalContext.metadata && finalContext.metadata.source;
        if (finalContext.sampled === false) (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Starting ${finalContext.op} transaction on scope`);
        const hub = this._getCurrentHub();
        const { location: location } = (0, $7qPZ8.WINDOW);
        const idleTransaction = (0, $103Ol.startIdleTransaction)(hub, finalContext, idleTimeout, finalTimeout, true, {
            location: location
        }, heartbeatInterval);
        idleTransaction.registerBeforeFinishCallback((transaction)=>{
            this._collectWebVitals();
            (0, $aX8fK.addPerformanceEntries)(transaction);
        });
        return idleTransaction;
    }
    /** Start listener for interaction transactions */ _registerInteractionListener() {
        let inflightInteractionTransaction;
        const registerInteractionTransaction = ()=>{
            const { idleTimeout: idleTimeout, finalTimeout: finalTimeout, heartbeatInterval: heartbeatInterval } = this.options;
            const op = 'ui.action.click';
            const currentTransaction = (0, $ebD1W.getActiveTransaction)();
            if (currentTransaction && currentTransaction.op && [
                'navigation',
                'pageload'
            ].includes(currentTransaction.op)) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`[Tracing] Did not create ${op} transaction because a pageload or navigation transaction is in progress.`);
                return undefined;
            }
            if (inflightInteractionTransaction) {
                inflightInteractionTransaction.setFinishReason('interactionInterrupted');
                inflightInteractionTransaction.finish();
                inflightInteractionTransaction = undefined;
            }
            if (!this._getCurrentHub) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
                return undefined;
            }
            if (!this._latestRouteName) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
                return undefined;
            }
            const hub = this._getCurrentHub();
            const { location: location } = (0, $7qPZ8.WINDOW);
            const context = {
                name: this._latestRouteName,
                op: op,
                trimEnd: true,
                metadata: {
                    source: this._latestRouteSource || 'url'
                }
            };
            inflightInteractionTransaction = (0, $103Ol.startIdleTransaction)(hub, context, idleTimeout, finalTimeout, true, {
                location: location
            }, heartbeatInterval);
        };
        [
            'click'
        ].forEach((type)=>{
            addEventListener(type, registerInteractionTransaction, {
                once: false,
                capture: true
            });
        });
    }
}
/** Returns the value of a meta tag */ function $7fdbeb07910059fd$export$f147b32b03c9cf11(metaName) {
    // Can't specify generic to `getDomElement` because tracing can be used
    // in a variety of environments, have to disable `no-unsafe-member-access`
    // as a result.
    const metaTag = (0, $c12av.getDomElement)(`meta[name=${metaName}]`);
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return metaTag ? metaTag.getAttribute('content') : null;
}

});
parcelRegister("3LZi0", function(module, exports) {

$parcel$export(module.exports, "TRACEPARENT_REGEXP", () => $2bf54daf8a1dd4aa$export$394a210812ba3012);
$parcel$export(module.exports, "extractTraceparentData", () => $2bf54daf8a1dd4aa$export$8e9a29865c0a1226);
const $2bf54daf8a1dd4aa$export$394a210812ba3012 = new RegExp("^[ \\t]*([0-9a-f]{32})?-?([0-9a-f]{16})?-?([01])?[ \\t]*$");
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */ function $2bf54daf8a1dd4aa$export$8e9a29865c0a1226(traceparent) {
    const matches = traceparent.match($2bf54daf8a1dd4aa$export$394a210812ba3012);
    if (!traceparent || !matches) // empty string or no matches is invalid traceparent data
    return undefined;
    let parentSampled;
    if (matches[3] === '1') parentSampled = true;
    else if (matches[3] === '0') parentSampled = false;
    return {
        traceId: matches[1],
        parentSampled: parentSampled,
        parentSpanId: matches[2]
    };
}

});

parcelRegister("eNSFS", function(module, exports) {

$parcel$export(module.exports, "BAGGAGE_HEADER_NAME", () => $ac700d7ad7652c84$export$9ca9946bd449ac06);
$parcel$export(module.exports, "baggageHeaderToDynamicSamplingContext", () => $ac700d7ad7652c84$export$5b96ee2c8421f107);
$parcel$export(module.exports, "dynamicSamplingContextToSentryBaggageHeader", () => $ac700d7ad7652c84$export$56766feef403f365);

var $k7rM9 = parcelRequire("k7rM9");

var $elKLM = parcelRequire("elKLM");
const $ac700d7ad7652c84$export$9ca9946bd449ac06 = 'baggage';
const $ac700d7ad7652c84$export$6e69537d67fa20f = 'sentry-';
const $ac700d7ad7652c84$export$eb0401070c617ea5 = /^sentry-/;
/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */ const $ac700d7ad7652c84$export$bdd844ddb2def819 = 8192;
/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */ function $ac700d7ad7652c84$export$5b96ee2c8421f107(// Very liberal definition of what any incoming header might look like
baggageHeader) {
    if (!(0, $k7rM9.isString)(baggageHeader) && !Array.isArray(baggageHeader)) return undefined;
    // Intermediary object to store baggage key value pairs of incoming baggage headers on.
    // It is later used to read Sentry-DSC-values from.
    let baggageObject = {};
    if (Array.isArray(baggageHeader)) // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr)=>{
        const currBaggageObject = $ac700d7ad7652c84$var$baggageHeaderToObject(curr);
        return {
            ...acc,
            ...currBaggageObject
        };
    }, {});
    else {
        // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
        // this is how we choose to handle it)
        if (!baggageHeader) return undefined;
        baggageObject = $ac700d7ad7652c84$var$baggageHeaderToObject(baggageHeader);
    }
    // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
    const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value])=>{
        if (key.match($ac700d7ad7652c84$export$eb0401070c617ea5)) {
            const nonPrefixedKey = key.slice($ac700d7ad7652c84$export$6e69537d67fa20f.length);
            acc[nonPrefixedKey] = value;
        }
        return acc;
    }, {});
    // Only return a dynamic sampling context object if there are keys in it.
    // A keyless object means there were no sentry values on the header, which means that there is no DSC.
    if (Object.keys(dynamicSamplingContext).length > 0) return dynamicSamplingContext;
    else return undefined;
}
/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */ function $ac700d7ad7652c84$export$56766feef403f365(// this also takes undefined for convenience and bundle size in other places
dynamicSamplingContext) {
    // Prefix all DSC keys with "sentry-" and put them into a new object
    const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce((acc, [dscKey, dscValue])=>{
        if (dscValue) acc[`${$ac700d7ad7652c84$export$6e69537d67fa20f}${dscKey}`] = dscValue;
        return acc;
    }, {});
    return $ac700d7ad7652c84$var$objectToBaggageHeader(sentryPrefixedDSC);
}
/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */ function $ac700d7ad7652c84$var$baggageHeaderToObject(baggageHeader) {
    return baggageHeader.split(',').map((baggageEntry)=>baggageEntry.split('=').map((keyOrValue)=>decodeURIComponent(keyOrValue.trim()))).reduce((acc, [key, value])=>{
        acc[key] = value;
        return acc;
    }, {});
}
/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */ function $ac700d7ad7652c84$var$objectToBaggageHeader(object) {
    if (Object.keys(object).length === 0) // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
    return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex)=>{
        const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
        const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
        if (newBaggageHeader.length > $ac700d7ad7652c84$export$bdd844ddb2def819) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`);
            return baggageHeader;
        } else return newBaggageHeader;
    }, '');
}

});

parcelRegister("a9CTT", function(module, exports) {

$parcel$export(module.exports, "registerBackgroundTabDetection", () => $7648eb77d2222fdd$export$6f18f55521af71a1);

var $ebD1W = parcelRequire("ebD1W");

var $elKLM = parcelRequire("elKLM");

var $7qPZ8 = parcelRequire("7qPZ8");
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */ function $7648eb77d2222fdd$export$6f18f55521af71a1() {
    if ((0, $7qPZ8.WINDOW) && (0, $7qPZ8.WINDOW).document) (0, $7qPZ8.WINDOW).document.addEventListener('visibilitychange', ()=>{
        const activeTransaction = (0, $ebD1W.getActiveTransaction)();
        if ((0, $7qPZ8.WINDOW).document.hidden && activeTransaction) {
            const statusType = 'cancelled';
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`);
            // We should not set status if it is already set, this prevent important statuses like
            // error or data loss from being overwritten on transaction.
            if (!activeTransaction.status) activeTransaction.setStatus(statusType);
            activeTransaction.setTag('visibilitychange', 'document.hidden');
            activeTransaction.finish();
        }
    });
    else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn('[Tracing] Could not set up background tab detection due to lack of global document');
}

});
parcelRegister("7qPZ8", function(module, exports) {

$parcel$export(module.exports, "WINDOW", () => $5693493d7afcb0fd$export$56d8a8a25bd48b81);

var $dQTB1 = parcelRequire("dQTB1");
const $5693493d7afcb0fd$export$56d8a8a25bd48b81 = (0, $dQTB1.GLOBAL_OBJ);

});


parcelRegister("aX8fK", function(module, exports) {

$parcel$export(module.exports, "startTrackingWebVitals", () => $7f95d0f3331744df$export$7c69f0412d101b88);
$parcel$export(module.exports, "startTrackingLongTasks", () => $7f95d0f3331744df$export$f396d19077034ad2);
$parcel$export(module.exports, "startTrackingInteractions", () => $7f95d0f3331744df$export$e27543e0976315e4);
$parcel$export(module.exports, "addPerformanceEntries", () => $7f95d0f3331744df$export$5f8fa6b3467a7443);

var $ebD1W = parcelRequire("ebD1W");

var $43Vyk = parcelRequire("43Vyk");
var $c12av = parcelRequire("c12av");
var $elKLM = parcelRequire("elKLM");

var $7qPZ8 = parcelRequire("7qPZ8");

var $bnUbo = parcelRequire("bnUbo");

var $2DGo3 = parcelRequire("2DGo3");

var $1iEEQ = parcelRequire("1iEEQ");

var $dwcXr = parcelRequire("dwcXr");

var $jiVMn = parcelRequire("jiVMn");

var $74dVd = parcelRequire("74dVd");
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */ function $7f95d0f3331744df$var$msToSec(time) {
    return time / 1000;
}
function $7f95d0f3331744df$var$getBrowserPerformanceAPI() {
    return (0, $7qPZ8.WINDOW) && (0, $7qPZ8.WINDOW).addEventListener && (0, $7qPZ8.WINDOW).performance;
}
let $7f95d0f3331744df$var$_performanceCursor = 0;
let $7f95d0f3331744df$var$_measurements = {};
let $7f95d0f3331744df$var$_lcpEntry;
let $7f95d0f3331744df$var$_clsEntry;
/**
 * Start tracking web vitals
 *
 * @returns A function that forces web vitals collection
 */ function $7f95d0f3331744df$export$7c69f0412d101b88() {
    const performance = $7f95d0f3331744df$var$getBrowserPerformanceAPI();
    if (performance && (0, $43Vyk.browserPerformanceTimeOrigin)) {
        if (performance.mark) (0, $7qPZ8.WINDOW).performance.mark('sentry-tracing-init');
        $7f95d0f3331744df$var$_trackFID();
        const clsCallback = $7f95d0f3331744df$var$_trackCLS();
        const lcpCallback = $7f95d0f3331744df$var$_trackLCP();
        return ()=>{
            if (clsCallback) clsCallback();
            if (lcpCallback) lcpCallback();
        };
    }
    return ()=>undefined;
}
/**
 * Start tracking long tasks.
 */ function $7f95d0f3331744df$export$f396d19077034ad2() {
    const entryHandler = (entries)=>{
        for (const entry of entries){
            const transaction = (0, $ebD1W.getActiveTransaction)();
            if (!transaction) return;
            const startTime = $7f95d0f3331744df$var$msToSec((0, $43Vyk.browserPerformanceTimeOrigin) + entry.startTime);
            const duration = $7f95d0f3331744df$var$msToSec(entry.duration);
            transaction.startChild({
                description: 'Main UI thread blocked',
                op: 'ui.long-task',
                startTimestamp: startTime,
                endTimestamp: startTime + duration
            });
        }
    };
    (0, $jiVMn.observe)('longtask', entryHandler);
}
/**
 * Start tracking interaction events.
 */ function $7f95d0f3331744df$export$e27543e0976315e4() {
    const entryHandler = (entries)=>{
        for (const entry of entries){
            const transaction = (0, $ebD1W.getActiveTransaction)();
            if (!transaction) return;
            if (entry.name === 'click') {
                const startTime = $7f95d0f3331744df$var$msToSec((0, $43Vyk.browserPerformanceTimeOrigin) + entry.startTime);
                const duration = $7f95d0f3331744df$var$msToSec(entry.duration);
                transaction.startChild({
                    description: (0, $c12av.htmlTreeAsString)(entry.target),
                    op: `ui.interaction.${entry.name}`,
                    startTimestamp: startTime,
                    endTimestamp: startTime + duration
                });
            }
        }
    };
    (0, $jiVMn.observe)('event', entryHandler, {
        durationThreshold: 0
    });
}
/** Starts tracking the Cumulative Layout Shift on the current page. */ function $7f95d0f3331744df$var$_trackCLS() {
    // See:
    // https://web.dev/evolving-cls/
    // https://web.dev/cls-web-tooling/
    return (0, $bnUbo.onCLS)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding CLS');
        $7f95d0f3331744df$var$_measurements['cls'] = {
            value: metric.value,
            unit: ''
        };
        $7f95d0f3331744df$var$_clsEntry = entry;
    });
}
/** Starts tracking the Largest Contentful Paint on the current page. */ function $7f95d0f3331744df$var$_trackLCP() {
    return (0, $1iEEQ.onLCP)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding LCP');
        $7f95d0f3331744df$var$_measurements['lcp'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $7f95d0f3331744df$var$_lcpEntry = entry;
    });
}
/** Starts tracking the First Input Delay on the current page. */ function $7f95d0f3331744df$var$_trackFID() {
    (0, $2DGo3.onFID)((metric)=>{
        const entry = metric.entries.pop();
        if (!entry) return;
        const timeOrigin = $7f95d0f3331744df$var$msToSec((0, $43Vyk.browserPerformanceTimeOrigin));
        const startTime = $7f95d0f3331744df$var$msToSec(entry.startTime);
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding FID');
        $7f95d0f3331744df$var$_measurements['fid'] = {
            value: metric.value,
            unit: 'millisecond'
        };
        $7f95d0f3331744df$var$_measurements['mark.fid'] = {
            value: timeOrigin + startTime,
            unit: 'second'
        };
    });
}
/** Add performance related spans to a transaction */ function $7f95d0f3331744df$export$5f8fa6b3467a7443(transaction) {
    const performance = $7f95d0f3331744df$var$getBrowserPerformanceAPI();
    if (!performance || !(0, $7qPZ8.WINDOW).performance.getEntries || !(0, $43Vyk.browserPerformanceTimeOrigin)) // Gatekeeper if performance API not available
    return;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Tracing] Adding & adjusting spans using Performance API');
    const timeOrigin = $7f95d0f3331744df$var$msToSec((0, $43Vyk.browserPerformanceTimeOrigin));
    const performanceEntries = performance.getEntries();
    let responseStartTimestamp;
    let requestStartTimestamp;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    performanceEntries.slice($7f95d0f3331744df$var$_performanceCursor).forEach((entry)=>{
        const startTime = $7f95d0f3331744df$var$msToSec(entry.startTime);
        const duration = $7f95d0f3331744df$var$msToSec(entry.duration);
        if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) return;
        switch(entry.entryType){
            case 'navigation':
                $7f95d0f3331744df$var$_addNavigationSpans(transaction, entry, timeOrigin);
                responseStartTimestamp = timeOrigin + $7f95d0f3331744df$var$msToSec(entry.responseStart);
                requestStartTimestamp = timeOrigin + $7f95d0f3331744df$var$msToSec(entry.requestStart);
                break;
            case 'mark':
            case 'paint':
            case 'measure':
                {
                    $7f95d0f3331744df$export$bc93b84e4d45912d(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    const firstHidden = (0, $dwcXr.getVisibilityWatcher)();
                    // Only report if the page wasn't hidden prior to the web vital.
                    const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding FP');
                        $7f95d0f3331744df$var$_measurements['fp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding FCP');
                        $7f95d0f3331744df$var$_measurements['fcp'] = {
                            value: entry.startTime,
                            unit: 'millisecond'
                        };
                    }
                    break;
                }
            case 'resource':
                {
                    const resourceName = entry.name.replace((0, $7qPZ8.WINDOW).location.origin, '');
                    $7f95d0f3331744df$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
        }
    });
    $7f95d0f3331744df$var$_performanceCursor = Math.max(performanceEntries.length - 1, 0);
    $7f95d0f3331744df$var$_trackNavigator(transaction);
    // Measurements are only available for pageload transactions
    if (transaction.op === 'pageload') {
        // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
        // start of the response in milliseconds
        if (typeof responseStartTimestamp === 'number') {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding TTFB');
            $7f95d0f3331744df$var$_measurements['ttfb'] = {
                value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
                unit: 'millisecond'
            };
            if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) // Capture the time spent making the request and receiving the first byte of the response.
            // This is the time between the start of the request and the start of the response in milliseconds.
            $7f95d0f3331744df$var$_measurements['ttfb.requestTime'] = {
                value: (responseStartTimestamp - requestStartTimestamp) * 1000,
                unit: 'millisecond'
            };
        }
        [
            'fcp',
            'fp',
            'lcp'
        ].forEach((name)=>{
            if (!$7f95d0f3331744df$var$_measurements[name] || timeOrigin >= transaction.startTimestamp) return;
            // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
            // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
            // to be adjusted to be relative to transaction.startTimestamp.
            const oldValue = $7f95d0f3331744df$var$_measurements[name].value;
            const measurementTimestamp = timeOrigin + $7f95d0f3331744df$var$msToSec(oldValue);
            // normalizedValue should be in milliseconds
            const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
            const delta = normalizedValue - oldValue;
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
            $7f95d0f3331744df$var$_measurements[name].value = normalizedValue;
        });
        const fidMark = $7f95d0f3331744df$var$_measurements['mark.fid'];
        if (fidMark && $7f95d0f3331744df$var$_measurements['fid']) {
            // create span for FID
            (0, $74dVd._startChild)(transaction, {
                description: 'first input delay',
                endTimestamp: fidMark.value + $7f95d0f3331744df$var$msToSec($7f95d0f3331744df$var$_measurements['fid'].value),
                op: 'ui.action',
                startTimestamp: fidMark.value
            });
            // Delete mark.fid as we don't want it to be part of final payload
            delete $7f95d0f3331744df$var$_measurements['mark.fid'];
        }
        // If FCP is not recorded we should not record the cls value
        // according to the new definition of CLS.
        if (!('fcp' in $7f95d0f3331744df$var$_measurements)) delete $7f95d0f3331744df$var$_measurements.cls;
        Object.keys($7f95d0f3331744df$var$_measurements).forEach((measurementName)=>{
            transaction.setMeasurement(measurementName, $7f95d0f3331744df$var$_measurements[measurementName].value, $7f95d0f3331744df$var$_measurements[measurementName].unit);
        });
        $7f95d0f3331744df$var$_tagMetricInfo(transaction);
    }
    $7f95d0f3331744df$var$_lcpEntry = undefined;
    $7f95d0f3331744df$var$_clsEntry = undefined;
    $7f95d0f3331744df$var$_measurements = {};
}
/** Create measure related spans */ function $7f95d0f3331744df$export$bc93b84e4d45912d(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, startTime, duration, timeOrigin) {
    const measureStartTimestamp = timeOrigin + startTime;
    const measureEndTimestamp = measureStartTimestamp + duration;
    (0, $74dVd._startChild)(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp
    });
    return measureStartTimestamp;
}
/** Instrument navigation entries */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7f95d0f3331744df$var$_addNavigationSpans(transaction, entry, timeOrigin) {
    [
        'unloadEvent',
        'redirect',
        'domContentLoadedEvent',
        'loadEvent',
        'connect'
    ].forEach((event)=>{
        $7f95d0f3331744df$var$_addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    $7f95d0f3331744df$var$_addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    $7f95d0f3331744df$var$_addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    $7f95d0f3331744df$var$_addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    $7f95d0f3331744df$var$_addRequest(transaction, entry, timeOrigin);
}
/** Create performance navigation related spans */ function $7f95d0f3331744df$var$_addPerformanceNavigationTiming(transaction, // eslint-disable-next-line @typescript-eslint/no-explicit-any
entry, event, timeOrigin, description, eventEnd) {
    const end = eventEnd ? entry[eventEnd] : entry[`${event}End`];
    const start = entry[`${event}Start`];
    if (!start || !end) return;
    (0, $74dVd._startChild)(transaction, {
        op: 'browser',
        description: description || event,
        startTimestamp: timeOrigin + $7f95d0f3331744df$var$msToSec(start),
        endTimestamp: timeOrigin + $7f95d0f3331744df$var$msToSec(end)
    });
}
/** Create request and response related spans */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $7f95d0f3331744df$var$_addRequest(transaction, entry, timeOrigin) {
    (0, $74dVd._startChild)(transaction, {
        op: 'browser',
        description: 'request',
        startTimestamp: timeOrigin + $7f95d0f3331744df$var$msToSec(entry.requestStart),
        endTimestamp: timeOrigin + $7f95d0f3331744df$var$msToSec(entry.responseEnd)
    });
    (0, $74dVd._startChild)(transaction, {
        op: 'browser',
        description: 'response',
        startTimestamp: timeOrigin + $7f95d0f3331744df$var$msToSec(entry.responseStart),
        endTimestamp: timeOrigin + $7f95d0f3331744df$var$msToSec(entry.responseEnd)
    });
}
/** Create resource-related spans */ function $7f95d0f3331744df$export$c82fe1a70634f317(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') return;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const data = {};
    if ('transferSize' in entry) data['Transfer Size'] = entry.transferSize;
    if ('encodedBodySize' in entry) data['Encoded Body Size'] = entry.encodedBodySize;
    if ('decodedBodySize' in entry) data['Decoded Body Size'] = entry.decodedBodySize;
    if ('renderBlockingStatus' in entry) data['resource.render_blocking_status'] = entry.renderBlockingStatus;
    const startTimestamp = timeOrigin + startTime;
    const endTimestamp = startTimestamp + duration;
    (0, $74dVd._startChild)(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
        startTimestamp: startTimestamp,
        data: data
    });
}
/**
 * Capture the information of the user agent.
 */ function $7f95d0f3331744df$var$_trackNavigator(transaction) {
    const navigator = (0, $7qPZ8.WINDOW).navigator;
    if (!navigator) return;
    // track network connectivity
    const connection = navigator.connection;
    if (connection) {
        if (connection.effectiveType) transaction.setTag('effectiveConnectionType', connection.effectiveType);
        if (connection.type) transaction.setTag('connectionType', connection.type);
        if ((0, $74dVd.isMeasurementValue)(connection.rtt)) $7f95d0f3331744df$var$_measurements['connection.rtt'] = {
            value: connection.rtt,
            unit: 'millisecond'
        };
    }
    if ((0, $74dVd.isMeasurementValue)(navigator.deviceMemory)) transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
    if ((0, $74dVd.isMeasurementValue)(navigator.hardwareConcurrency)) transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
}
/** Add LCP / CLS data to transaction to allow debugging */ function $7f95d0f3331744df$var$_tagMetricInfo(transaction) {
    if ($7f95d0f3331744df$var$_lcpEntry) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if ($7f95d0f3331744df$var$_lcpEntry.element) transaction.setTag('lcp.element', (0, $c12av.htmlTreeAsString)($7f95d0f3331744df$var$_lcpEntry.element));
        if ($7f95d0f3331744df$var$_lcpEntry.id) transaction.setTag('lcp.id', $7f95d0f3331744df$var$_lcpEntry.id);
        if ($7f95d0f3331744df$var$_lcpEntry.url) // Trim URL to the first 200 characters.
        transaction.setTag('lcp.url', $7f95d0f3331744df$var$_lcpEntry.url.trim().slice(0, 200));
        transaction.setTag('lcp.size', $7f95d0f3331744df$var$_lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if ($7f95d0f3331744df$var$_clsEntry && $7f95d0f3331744df$var$_clsEntry.sources) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('[Measurements] Adding CLS Data');
        $7f95d0f3331744df$var$_clsEntry.sources.forEach((source, index)=>transaction.setTag(`cls.source.${index + 1}`, (0, $c12av.htmlTreeAsString)(source.node)));
    }
}

});
parcelRegister("bnUbo", function(module, exports) {

$parcel$export(module.exports, "onCLS", () => $849d6c6e16502dd7$export$a7873055838e5ad8);

var $9Ovd5 = parcelRequire("9Ovd5");

var $5djE8 = parcelRequire("5djE8");

var $jiVMn = parcelRequire("jiVMn");

var $cexnv = parcelRequire("cexnv");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */ const $849d6c6e16502dd7$export$a7873055838e5ad8 = (onReport)=>{
    const metric = (0, $5djE8.initMetric)('CLS', 0);
    let report;
    let sessionValue = 0;
    let sessionEntries = [];
    // const handleEntries = (entries: Metric['entries']) => {
    const handleEntries = (entries)=>{
        entries.forEach((entry)=>{
            // Only count layout shifts without recent user input.
            if (!entry.hadRecentInput) {
                const firstSessionEntry = sessionEntries[0];
                const lastSessionEntry = sessionEntries[sessionEntries.length - 1];
                // If the entry occurred less than 1 second after the previous entry and
                // less than 5 seconds after the first entry in the session, include the
                // entry in the current session. Otherwise, start a new session.
                if (sessionValue && sessionEntries.length !== 0 && entry.startTime - lastSessionEntry.startTime < 1000 && entry.startTime - firstSessionEntry.startTime < 5000) {
                    sessionValue += entry.value;
                    sessionEntries.push(entry);
                } else {
                    sessionValue = entry.value;
                    sessionEntries = [
                        entry
                    ];
                }
                // If the current session value is larger than the current CLS value,
                // update CLS and the entries contributing to it.
                if (sessionValue > metric.value) {
                    metric.value = sessionValue;
                    metric.entries = sessionEntries;
                    if (report) report();
                }
            }
        });
    };
    const po = (0, $jiVMn.observe)('layout-shift', handleEntries);
    if (po) {
        report = (0, $9Ovd5.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            handleEntries(po.takeRecords());
            report(true);
        };
        (0, $cexnv.onHidden)(stopListening);
        return stopListening;
    }
    return;
};

});
parcelRegister("9Ovd5", function(module, exports) {

$parcel$export(module.exports, "bindReporter", () => $7250fe41ed8f8ef3$export$17679dccdd551979);
const $7250fe41ed8f8ef3$export$17679dccdd551979 = (callback, metric, reportAllChanges)=>{
    let prevValue;
    let delta;
    return (forceReport)=>{
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (delta || prevValue === undefined) {
                    prevValue = metric.value;
                    metric.delta = delta;
                    callback(metric);
                }
            }
        }
    };
};

});

parcelRegister("5djE8", function(module, exports) {

$parcel$export(module.exports, "initMetric", () => $3cbd67fd0b1f32b2$export$3c29b44508a0612b);

var $7qPZ8 = parcelRequire("7qPZ8");

var $ezBQe = parcelRequire("ezBQe");

var $b91AC = parcelRequire("b91AC");

var $fnJfe = parcelRequire("fnJfe");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $3cbd67fd0b1f32b2$export$3c29b44508a0612b = (name, value)=>{
    const navEntry = (0, $fnJfe.getNavigationEntry)();
    let navigationType = 'navigate';
    if (navEntry) {
        if ((0, $7qPZ8.WINDOW).document.prerendering || (0, $b91AC.getActivationStart)() > 0) navigationType = 'prerender';
        else navigationType = navEntry.type.replace(/_/g, '-');
    }
    return {
        name: name,
        value: typeof value === 'undefined' ? -1 : value,
        rating: 'good',
        delta: 0,
        entries: [],
        id: (0, $ezBQe.generateUniqueID)(),
        navigationType: navigationType
    };
};

});
parcelRegister("ezBQe", function(module, exports) {

$parcel$export(module.exports, "generateUniqueID", () => $a9c1b01acfab9777$export$407ea409d1f3b539);
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */ const $a9c1b01acfab9777$export$407ea409d1f3b539 = ()=>{
    return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};

});

parcelRegister("b91AC", function(module, exports) {

$parcel$export(module.exports, "getActivationStart", () => $81d1c4a7485c6265$export$d3e828b3c7b5b845);

var $fnJfe = parcelRequire("fnJfe");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $81d1c4a7485c6265$export$d3e828b3c7b5b845 = ()=>{
    const navEntry = (0, $fnJfe.getNavigationEntry)();
    return navEntry && navEntry.activationStart || 0;
};

});
parcelRegister("fnJfe", function(module, exports) {

$parcel$export(module.exports, "getNavigationEntry", () => $b32c19a24e627ae7$export$6431553786c94949);

var $7qPZ8 = parcelRequire("7qPZ8");
/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $b32c19a24e627ae7$var$getNavigationEntryFromPerformanceTiming = ()=>{
    // eslint-disable-next-line deprecation/deprecation
    const timing = (0, $7qPZ8.WINDOW).performance.timing;
    // eslint-disable-next-line deprecation/deprecation
    const type = (0, $7qPZ8.WINDOW).performance.navigation.type;
    const navigationEntry = {
        entryType: 'navigation',
        startTime: 0,
        type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate'
    };
    for(const key in timing)if (key !== 'navigationStart' && key !== 'toJSON') navigationEntry[key] = Math.max(timing[key] - timing.navigationStart, 0);
    return navigationEntry;
};
const $b32c19a24e627ae7$export$6431553786c94949 = ()=>{
    if ((0, $7qPZ8.WINDOW).__WEB_VITALS_POLYFILL__) return (0, $7qPZ8.WINDOW).performance && (performance.getEntriesByType && performance.getEntriesByType('navigation')[0] || $b32c19a24e627ae7$var$getNavigationEntryFromPerformanceTiming());
    else return (0, $7qPZ8.WINDOW).performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
};

});



parcelRegister("jiVMn", function(module, exports) {

$parcel$export(module.exports, "observe", () => $e0dc848959f54dea$export$d1203567a167490e);
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */ const $e0dc848959f54dea$export$d1203567a167490e = (type, callback, opts)=>{
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            const po = new PerformanceObserver((list)=>{
                callback(list.getEntries());
            });
            po.observe(Object.assign({
                type: type,
                buffered: true
            }, opts || {}));
            return po;
        }
    } catch (e) {
    // Do nothing.
    }
    return;
};

});

parcelRegister("cexnv", function(module, exports) {

$parcel$export(module.exports, "onHidden", () => $8e80af0c3857ece5$export$91ec2be6fdd8f1b4);

var $7qPZ8 = parcelRequire("7qPZ8");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $8e80af0c3857ece5$export$91ec2be6fdd8f1b4 = (cb, once)=>{
    const onHiddenOrPageHide = (event)=>{
        if (event.type === 'pagehide' || (0, $7qPZ8.WINDOW).document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
};

});


parcelRegister("2DGo3", function(module, exports) {

$parcel$export(module.exports, "onFID", () => $1ec01a75695a6448$export$39705a25c49af873);

var $9Ovd5 = parcelRequire("9Ovd5");

var $dwcXr = parcelRequire("dwcXr");

var $5djE8 = parcelRequire("5djE8");

var $jiVMn = parcelRequire("jiVMn");

var $cexnv = parcelRequire("cexnv");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */ const $1ec01a75695a6448$export$39705a25c49af873 = (onReport)=>{
    const visibilityWatcher = (0, $dwcXr.getVisibilityWatcher)();
    const metric = (0, $5djE8.initMetric)('FID');
    // eslint-disable-next-line prefer-const
    let report;
    const handleEntry = (entry)=>{
        // Only report if the page wasn't hidden prior to the first input.
        if (entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    const handleEntries = (entries)=>{
        entries.forEach(handleEntry);
    };
    const po = (0, $jiVMn.observe)('first-input', handleEntries);
    report = (0, $9Ovd5.bindReporter)(onReport, metric);
    if (po) (0, $cexnv.onHidden)(()=>{
        handleEntries(po.takeRecords());
        po.disconnect();
    }, true);
};

});
parcelRegister("dwcXr", function(module, exports) {

$parcel$export(module.exports, "getVisibilityWatcher", () => $9d7850a6c70a3992$export$443f86b2c77012c4);

var $7qPZ8 = parcelRequire("7qPZ8");

var $cexnv = parcelRequire("cexnv");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ let $9d7850a6c70a3992$var$firstHiddenTime = -1;
const $9d7850a6c70a3992$var$initHiddenTime = ()=>{
    // If the document is hidden and not prerendering, assume it was always
    // hidden and the page was loaded in the background.
    return (0, $7qPZ8.WINDOW).document.visibilityState === 'hidden' && !(0, $7qPZ8.WINDOW).document.prerendering ? 0 : Infinity;
};
const $9d7850a6c70a3992$var$trackChanges = ()=>{
    // Update the time if/when the document becomes hidden.
    (0, $cexnv.onHidden)(({ timeStamp: timeStamp })=>{
        $9d7850a6c70a3992$var$firstHiddenTime = timeStamp;
    }, true);
};
const $9d7850a6c70a3992$export$443f86b2c77012c4 = ()=>{
    if ($9d7850a6c70a3992$var$firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        $9d7850a6c70a3992$var$firstHiddenTime = $9d7850a6c70a3992$var$initHiddenTime();
        $9d7850a6c70a3992$var$trackChanges();
    }
    return {
        get firstHiddenTime () {
            return $9d7850a6c70a3992$var$firstHiddenTime;
        }
    };
};

});


parcelRegister("1iEEQ", function(module, exports) {

$parcel$export(module.exports, "onLCP", () => $0f2702aa148edfe6$export$947b1626ab8d5632);

var $9Ovd5 = parcelRequire("9Ovd5");

var $b91AC = parcelRequire("b91AC");

var $dwcXr = parcelRequire("dwcXr");

var $5djE8 = parcelRequire("5djE8");

var $jiVMn = parcelRequire("jiVMn");

var $cexnv = parcelRequire("cexnv");
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ const $0f2702aa148edfe6$var$reportedMetricIDs = {};
/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */ const $0f2702aa148edfe6$export$947b1626ab8d5632 = (onReport)=>{
    const visibilityWatcher = (0, $dwcXr.getVisibilityWatcher)();
    const metric = (0, $5djE8.initMetric)('LCP');
    let report;
    const handleEntries = (entries)=>{
        const lastEntry = entries[entries.length - 1];
        if (lastEntry) {
            // The startTime attribute returns the value of the renderTime if it is
            // not 0, and the value of the loadTime otherwise. The activationStart
            // reference is used because LCP should be relative to page activation
            // rather than navigation start if the page was prerendered.
            const value = Math.max(lastEntry.startTime - (0, $b91AC.getActivationStart)(), 0);
            // Only report if the page wasn't hidden prior to LCP.
            if (value < visibilityWatcher.firstHiddenTime) {
                metric.value = value;
                metric.entries = [
                    lastEntry
                ];
                report();
            }
        }
    };
    const po = (0, $jiVMn.observe)('largest-contentful-paint', handleEntries);
    if (po) {
        report = (0, $9Ovd5.bindReporter)(onReport, metric);
        const stopListening = ()=>{
            if (!$0f2702aa148edfe6$var$reportedMetricIDs[metric.id]) {
                handleEntries(po.takeRecords());
                po.disconnect();
                $0f2702aa148edfe6$var$reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        [
            'keydown',
            'click'
        ].forEach((type)=>{
            addEventListener(type, stopListening, {
                once: true,
                capture: true
            });
        });
        (0, $cexnv.onHidden)(stopListening, true);
        return stopListening;
    }
    return;
};

});

parcelRegister("74dVd", function(module, exports) {

$parcel$export(module.exports, "isMeasurementValue", () => $5253b4b77eda1398$export$27169ccae1b439e3);
$parcel$export(module.exports, "_startChild", () => $5253b4b77eda1398$export$8bd469e1f37aa721);
/**
 * Checks if a given value is a valid measurement value.
 */ function $5253b4b77eda1398$export$27169ccae1b439e3(value) {
    return typeof value === 'number' && isFinite(value);
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */ function $5253b4b77eda1398$export$8bd469e1f37aa721(transaction, { startTimestamp: startTimestamp, ...ctx }) {
    if (startTimestamp && transaction.startTimestamp > startTimestamp) transaction.startTimestamp = startTimestamp;
    return transaction.startChild({
        startTimestamp: startTimestamp,
        ...ctx
    });
}

});


parcelRegister("lpkeJ", function(module, exports) {

$parcel$export(module.exports, "defaultRequestInstrumentationOptions", () => $f95ba1533cc96a20$export$cc17fb3c0bc95cd7);
$parcel$export(module.exports, "instrumentOutgoingRequests", () => $f95ba1533cc96a20$export$864489cb3478db3e);

var $7Qe7s = parcelRequire("7Qe7s");
var $9hRAY = parcelRequire("9hRAY");

var $lChn2 = parcelRequire("lChn2");
var $eNSFS = parcelRequire("eNSFS");
var $k7rM9 = parcelRequire("k7rM9");
var $4J3fm = parcelRequire("4J3fm");
/* eslint-disable max-lines */ const $f95ba1533cc96a20$export$15bd0305d05ad07b = [
    'localhost',
    /^\//
];
/** Options for Request Instrumentation */ const $f95ba1533cc96a20$export$cc17fb3c0bc95cd7 = {
    traceFetch: true,
    traceXHR: true,
    // TODO (v8): Remove this property
    tracingOrigins: $f95ba1533cc96a20$export$15bd0305d05ad07b,
    tracePropagationTargets: $f95ba1533cc96a20$export$15bd0305d05ad07b
};
/** Registers span creators for xhr and fetch requests  */ function $f95ba1533cc96a20$export$864489cb3478db3e(_options) {
    // eslint-disable-next-line deprecation/deprecation
    const { traceFetch: traceFetch, traceXHR: traceXHR, tracePropagationTargets: tracePropagationTargets, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest } = {
        traceFetch: $f95ba1533cc96a20$export$cc17fb3c0bc95cd7.traceFetch,
        traceXHR: $f95ba1533cc96a20$export$cc17fb3c0bc95cd7.traceXHR,
        ..._options
    };
    const shouldCreateSpan = typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_)=>true;
    // TODO(v8) Remove tracingOrigins here
    // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
    // and we don't want to break the API. We can remove it in v8.
    const shouldAttachHeadersWithTargets = (url)=>$f95ba1533cc96a20$export$c260386ab3f0b3dd(url, tracePropagationTargets || tracingOrigins);
    const spans = {};
    if (traceFetch) (0, $lChn2.addInstrumentationHandler)('fetch', (handlerData)=>{
        $f95ba1533cc96a20$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
    if (traceXHR) (0, $lChn2.addInstrumentationHandler)('xhr', (handlerData)=>{
        $f95ba1533cc96a20$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
}
/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */ function $f95ba1533cc96a20$export$c260386ab3f0b3dd(url, tracePropagationTargets) {
    return (0, $4J3fm.stringMatchesSomePattern)(url, tracePropagationTargets || $f95ba1533cc96a20$export$15bd0305d05ad07b);
}
/**
 * Create and track fetch request spans
 */ function $f95ba1533cc96a20$export$cd8846dd8ea4bd7a(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    if (!(0, $9hRAY.hasTracingEnabled)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) return;
    if (handlerData.endTimestamp) {
        const spanId = handlerData.fetchData.__span;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            if (handlerData.response) // TODO (kmclb) remove this once types PR goes through
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            span.setHttpStatus(handlerData.response.status);
            else if (handlerData.error) span.setStatus('internal_error');
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    const currentScope = (0, $7Qe7s.getCurrentHub)().getScope();
    const currentSpan = currentScope && currentScope.getSpan();
    const activeTransaction = currentSpan && currentSpan.transaction;
    if (currentSpan && activeTransaction) {
        const span = currentSpan.startChild({
            data: {
                ...handlerData.fetchData,
                type: 'fetch'
            },
            description: `${handlerData.fetchData.method} ${handlerData.fetchData.url}`,
            op: 'http.client'
        });
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
        const request = handlerData.args[0];
        // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
        handlerData.args[1] = handlerData.args[1] || {};
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const options = handlerData.args[1];
        if (shouldAttachHeaders(handlerData.fetchData.url)) options.headers = $f95ba1533cc96a20$export$6717acf674206871(request, activeTransaction.getDynamicSamplingContext(), span, options);
    }
}
/**
 * Adds sentry-trace and baggage headers to the various forms of fetch headers
 */ function $f95ba1533cc96a20$export$6717acf674206871(request, dynamicSamplingContext, span, options) {
    const sentryBaggageHeader = (0, $eNSFS.dynamicSamplingContextToSentryBaggageHeader)(dynamicSamplingContext);
    const sentryTraceHeader = span.toTraceparent();
    const headers = typeof Request !== 'undefined' && (0, $k7rM9.isInstanceOf)(request, Request) ? request.headers : options.headers;
    if (!headers) return {
        'sentry-trace': sentryTraceHeader,
        baggage: sentryBaggageHeader
    };
    else if (typeof Headers !== 'undefined' && (0, $k7rM9.isInstanceOf)(headers, Headers)) {
        const newHeaders = new Headers(headers);
        newHeaders.append('sentry-trace', sentryTraceHeader);
        if (sentryBaggageHeader) // If the same header is appended multiple times the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.append((0, $eNSFS.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        return newHeaders;
    } else if (Array.isArray(headers)) {
        const newHeaders = [
            ...headers,
            [
                'sentry-trace',
                sentryTraceHeader
            ]
        ];
        if (sentryBaggageHeader) // If there are multiple entries with the same key, the browser will merge the values into a single request header.
        // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
        newHeaders.push([
            (0, $eNSFS.BAGGAGE_HEADER_NAME),
            sentryBaggageHeader
        ]);
        return newHeaders;
    } else {
        const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
        const newBaggageHeaders = [];
        if (Array.isArray(existingBaggageHeader)) newBaggageHeaders.push(...existingBaggageHeader);
        else if (existingBaggageHeader) newBaggageHeaders.push(existingBaggageHeader);
        if (sentryBaggageHeader) newBaggageHeaders.push(sentryBaggageHeader);
        return {
            ...headers,
            'sentry-trace': sentryTraceHeader,
            baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined
        };
    }
}
/**
 * Create and track xhr request spans
 */ function $f95ba1533cc96a20$export$49680d91e75e2ef7(handlerData, shouldCreateSpan, shouldAttachHeaders, spans) {
    if (!(0, $9hRAY.hasTracingEnabled)() || handlerData.xhr && handlerData.xhr.__sentry_own_request__ || !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))) return;
    const xhr = handlerData.xhr.__sentry_xhr__;
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp) {
        const spanId = handlerData.xhr.__sentry_xhr_span_id__;
        if (!spanId) return;
        const span = spans[spanId];
        if (span) {
            span.setHttpStatus(xhr.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    const currentScope = (0, $7Qe7s.getCurrentHub)().getScope();
    const currentSpan = currentScope && currentScope.getSpan();
    const activeTransaction = currentSpan && currentSpan.transaction;
    if (currentSpan && activeTransaction) {
        const span = currentSpan.startChild({
            data: {
                ...xhr.data,
                type: 'xhr',
                method: xhr.method,
                url: xhr.url
            },
            description: `${xhr.method} ${xhr.url}`,
            op: 'http.client'
        });
        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
        if (handlerData.xhr.setRequestHeader && shouldAttachHeaders(handlerData.xhr.__sentry_xhr__.url)) try {
            handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
            const dynamicSamplingContext = activeTransaction.getDynamicSamplingContext();
            const sentryBaggageHeader = (0, $eNSFS.dynamicSamplingContextToSentryBaggageHeader)(dynamicSamplingContext);
            if (sentryBaggageHeader) // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
            // We can therefore simply set a baggage header without checking what was there before
            // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
            handlerData.xhr.setRequestHeader((0, $eNSFS.BAGGAGE_HEADER_NAME), sentryBaggageHeader);
        } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
        }
    }
}

});

parcelRegister("4V91W", function(module, exports) {

$parcel$export(module.exports, "instrumentRoutingWithDefaults", () => $39537d8adc82dc22$export$86649cc09fe75143);

var $lChn2 = parcelRequire("lChn2");
var $43Vyk = parcelRequire("43Vyk");
var $elKLM = parcelRequire("elKLM");

var $7qPZ8 = parcelRequire("7qPZ8");
/**
 * Default function implementing pageload and navigation transactions
 */ function $39537d8adc82dc22$export$86649cc09fe75143(customStartTransaction, startTransactionOnPageLoad = true, startTransactionOnLocationChange = true) {
    if (!(0, $7qPZ8.WINDOW) || !(0, $7qPZ8.WINDOW).location) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    let startingUrl = (0, $7qPZ8.WINDOW).location.href;
    let activeTransaction;
    if (startTransactionOnPageLoad) activeTransaction = customStartTransaction({
        name: (0, $7qPZ8.WINDOW).location.pathname,
        // pageload should always start at timeOrigin
        startTimestamp: (0, $43Vyk.browserPerformanceTimeOrigin),
        op: 'pageload',
        metadata: {
            source: 'url'
        }
    });
    if (startTransactionOnLocationChange) (0, $lChn2.addInstrumentationHandler)('history', ({ to: to, from: from })=>{
        /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */ if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
            startingUrl = undefined;
            return;
        }
        if (from !== to) {
            startingUrl = undefined;
            if (activeTransaction) {
                (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
                // If there's an open transaction on the scope, we need to finish it before creating an new one.
                activeTransaction.finish();
            }
            activeTransaction = customStartTransaction({
                name: (0, $7qPZ8.WINDOW).location.pathname,
                op: 'navigation',
                metadata: {
                    source: 'url'
                }
            });
        }
    });
}

});


parcelRegister("8szh8", function(module, exports) {

$parcel$export(module.exports, "Express", () => $628c4d30933e5d98$export$6dafdd8fec05099d);

var $4Aa3G = parcelRequire("4Aa3G");

var $7vcr7 = parcelRequire("7vcr7");
var $d4cKa = parcelRequire("d4cKa");
var $k7rM9 = parcelRequire("k7rM9");
var $elKLM = parcelRequire("elKLM");

var $fzFcM = parcelRequire("fzFcM");
/**
 * Express integration
 *
 * Provides an request and error handler for Express framework as well as tracing capabilities
 */ class $628c4d30933e5d98$export$6dafdd8fec05099d {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Express';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $628c4d30933e5d98$export$6dafdd8fec05099d.id;
    }
    /**
   * Express App instance
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        $628c4d30933e5d98$export$6dafdd8fec05099d.prototype.__init.call(this);
        this._router = options.router || options.app;
        this._methods = (Array.isArray(options.methods) ? options.methods : []).concat('use');
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if (!this._router) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error('ExpressIntegration is missing an Express instance');
            return;
        }
        if ((0, $fzFcM.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('Express Integration is skipped because of instrumenter configuration.');
            return;
        }
        $628c4d30933e5d98$var$instrumentMiddlewares(this._router, this._methods);
        $628c4d30933e5d98$var$instrumentRouter(this._router);
    }
}
$628c4d30933e5d98$export$6dafdd8fec05099d.__initStatic();
/**
 * Wraps original middleware function in a tracing call, which stores the info about the call as a span,
 * and finishes it once the middleware is done invoking.
 *
 * Express middlewares have 3 various forms, thus we have to take care of all of them:
 * // sync
 * app.use(function (req, res) { ... })
 * // async
 * app.use(function (req, res, next) { ... })
 * // error handler
 * app.use(function (err, req, res, next) { ... })
 *
 * They all internally delegate to the `router[method]` of the given application instance.
 */ // eslint-disable-next-line @typescript-eslint/ban-types, @typescript-eslint/no-explicit-any
function $628c4d30933e5d98$var$wrap(fn, method) {
    const arity = fn.length;
    switch(arity){
        case 2:
            return function(req, res) {
                const transaction = res.__sentry_transaction;
                if (transaction) {
                    const span = transaction.startChild({
                        description: fn.name,
                        op: `middleware.express.${method}`
                    });
                    res.once('finish', ()=>{
                        span.finish();
                    });
                }
                return fn.call(this, req, res);
            };
        case 3:
            return function(req, res, next) {
                const transaction = res.__sentry_transaction;
                const span = (0, $4Aa3G._optionalChain)([
                    transaction,
                    'optionalAccess',
                    (_2)=>_2.startChild,
                    'call',
                    (_3)=>_3({
                            description: fn.name,
                            op: `middleware.express.${method}`
                        })
                ]);
                fn.call(this, req, res, function(...args) {
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_4)=>_4.finish,
                        'call',
                        (_5)=>_5()
                    ]);
                    next.call(this, ...args);
                });
            };
        case 4:
            return function(err, req, res, next) {
                const transaction = res.__sentry_transaction;
                const span = (0, $4Aa3G._optionalChain)([
                    transaction,
                    'optionalAccess',
                    (_6)=>_6.startChild,
                    'call',
                    (_7)=>_7({
                            description: fn.name,
                            op: `middleware.express.${method}`
                        })
                ]);
                fn.call(this, err, req, res, function(...args) {
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_8)=>_8.finish,
                        'call',
                        (_9)=>_9()
                    ]);
                    next.call(this, ...args);
                });
            };
        default:
            throw new Error(`Express middleware takes 2-4 arguments. Got: ${arity}`);
    }
}
/**
 * Takes all the function arguments passed to the original `app` or `router` method, eg. `app.use` or `router.use`
 * and wraps every function, as well as array of functions with a call to our `wrap` method.
 * We have to take care of the arrays as well as iterate over all of the arguments,
 * as `app.use` can accept middlewares in few various forms.
 *
 * app.use([<path>], <fn>)
 * app.use([<path>], <fn>, ...<fn>)
 * app.use([<path>], ...<fn>[])
 */ function $628c4d30933e5d98$var$wrapMiddlewareArgs(args, method) {
    return args.map((arg)=>{
        if (typeof arg === 'function') return $628c4d30933e5d98$var$wrap(arg, method);
        if (Array.isArray(arg)) return arg.map((a)=>{
            if (typeof a === 'function') return $628c4d30933e5d98$var$wrap(a, method);
            return a;
        });
        return arg;
    });
}
/**
 * Patches original router to utilize our tracing functionality
 */ function $628c4d30933e5d98$var$patchMiddleware(router, method) {
    const originalCallback = router[method];
    router[method] = function(...args) {
        return originalCallback.call(this, ...$628c4d30933e5d98$var$wrapMiddlewareArgs(args, method));
    };
    return router;
}
/**
 * Patches original router methods
 */ function $628c4d30933e5d98$var$instrumentMiddlewares(router, methods = []) {
    methods.forEach((method)=>$628c4d30933e5d98$var$patchMiddleware(router, method));
}
/**
 * Patches the prototype of Express.Router to accumulate the resolved route
 * if a layer instance's `match` function was called and it returned a successful match.
 *
 * @see https://github.com/expressjs/express/blob/master/lib/router/index.js
 *
 * @param appOrRouter the router instance which can either be an app (i.e. top-level) or a (nested) router.
 */ function $628c4d30933e5d98$var$instrumentRouter(appOrRouter) {
    // This is how we can distinguish between app and routers
    const isApp = 'settings' in appOrRouter;
    // In case the app's top-level router hasn't been initialized yet, we have to do it now
    if (isApp && appOrRouter._router === undefined && appOrRouter.lazyrouter) appOrRouter.lazyrouter();
    const router = isApp ? appOrRouter._router : appOrRouter;
    if (!router) {
        /*
    If we end up here, this means likely that this integration is used with Express 3 or Express 5.
    For now, we don't support these versions (3 is very old and 5 is still in beta). To support Express 5,
    we'd need to make more changes to the routing instrumentation because the router is no longer part of
    the Express core package but maintained in its own package. The new router has different function
    signatures and works slightly differently, demanding more changes than just taking the router from
    `app.router` instead of `app._router`.
    @see https://github.com/pillarjs/router

    TODO: Proper Express 5 support
    */ (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).debug('Cannot instrument router for URL Parameterization (did not find a valid router).');
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).debug('Routing instrumentation is currently only supported in Express 4.');
        return;
    }
    const routerProto = Object.getPrototypeOf(router);
    const originalProcessParams = routerProto.process_params;
    routerProto.process_params = function process_params(layer, called, req, res, done) {
        // Base case: We're in the first part of the URL (thus we start with the root '/')
        if (!req._reconstructedRoute) req._reconstructedRoute = '';
        // If the layer's partial route has params, is a regex or an array, the route is stored in layer.route.
        const { layerRoutePath: layerRoutePath, isRegex: isRegex, isArray: isArray, numExtraSegments: numExtraSegments } = $628c4d30933e5d98$var$getLayerRoutePathInfo(layer);
        if (layerRoutePath || isRegex || isArray) req._hasParameters = true;
        // Otherwise, the hardcoded path (i.e. a partial route without params) is stored in layer.path
        const partialRoute = layerRoutePath || layer.path || '';
        // Normalize the partial route so that it doesn't contain leading or trailing slashes
        // and exclude empty or '*' wildcard routes.
        // The exclusion of '*' routes is our best effort to not "pollute" the transaction name
        // with interim handlers (e.g. ones that check authentication or do other middleware stuff).
        // We want to end up with the parameterized URL of the incoming request without any extraneous path segments.
        const finalPartialRoute = partialRoute.split('/').filter((segment)=>segment.length > 0 && (isRegex || isArray || !segment.includes('*'))).join('/');
        // If we found a valid partial URL, we append it to the reconstructed route
        if (finalPartialRoute && finalPartialRoute.length > 0) // If the partial route is from a regex route, we append a '/' to close the regex
        req._reconstructedRoute += `/${finalPartialRoute}${isRegex ? '/' : ''}`;
        // Now we check if we are in the "last" part of the route. We determine this by comparing the
        // number of URL segments from the original URL to that of our reconstructed parameterized URL.
        // If we've reached our final destination, we update the transaction name.
        const urlLength = (0, $d4cKa.getNumberOfUrlSegments)(req.originalUrl || '') + numExtraSegments;
        const routeLength = (0, $d4cKa.getNumberOfUrlSegments)(req._reconstructedRoute);
        if (urlLength === routeLength) {
            if (!req._hasParameters) {
                if (req._reconstructedRoute !== req.originalUrl) req._reconstructedRoute = req.originalUrl;
            }
            const transaction = res.__sentry_transaction;
            if (transaction && transaction.metadata.source !== 'custom') {
                // If the request URL is '/' or empty, the reconstructed route will be empty.
                // Therefore, we fall back to setting the final route to '/' in this case.
                const finalRoute = req._reconstructedRoute || '/';
                transaction.setName(...(0, $7vcr7.extractPathForTransaction)(req, {
                    path: true,
                    method: true,
                    customRoute: finalRoute
                }));
            }
        }
        return originalProcessParams.call(this, layer, called, req, res, done);
    };
}
/**
 * Extracts and stringifies the layer's route which can either be a string with parameters (`users/:id`),
 * a RegEx (`/test/`) or an array of strings and regexes (`['/path1', /\/path[2-5]/, /path/:id]`). Additionally
 * returns extra information about the route, such as if the route is defined as regex or as an array.
 *
 * @param layer the layer to extract the stringified route from
 *
 * @returns an object containing the stringified route, a flag determining if the route was a regex
 *          and the number of extra segments to the matched path that are additionally in the route,
 *          if the route was an array (defaults to 0).
 */ function $628c4d30933e5d98$var$getLayerRoutePathInfo(layer) {
    const lrp = (0, $4Aa3G._optionalChain)([
        layer,
        'access',
        (_10)=>_10.route,
        'optionalAccess',
        (_11)=>_11.path
    ]);
    const isRegex = (0, $k7rM9.isRegExp)(lrp);
    const isArray = Array.isArray(lrp);
    if (!lrp) return {
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: 0
    };
    const numExtraSegments = isArray ? Math.max($628c4d30933e5d98$var$getNumberOfArrayUrlSegments(lrp) - (0, $d4cKa.getNumberOfUrlSegments)(layer.path || ''), 0) : 0;
    const layerRoutePath = $628c4d30933e5d98$var$getLayerRoutePathString(isArray, lrp);
    return {
        layerRoutePath: layerRoutePath,
        isRegex: isRegex,
        isArray: isArray,
        numExtraSegments: numExtraSegments
    };
}
/**
 * Returns the number of URL segments in an array of routes
 *
 * Example: ['/api/test', /\/api\/post[0-9]/, '/users/:id/details`] -> 7
 */ function $628c4d30933e5d98$var$getNumberOfArrayUrlSegments(routesArray) {
    return routesArray.reduce((accNumSegments, currentRoute)=>{
        // array members can be a RegEx -> convert them toString
        return accNumSegments + (0, $d4cKa.getNumberOfUrlSegments)(currentRoute.toString());
    }, 0);
}
/**
 * Extracts and returns the stringified version of the layers route path
 * Handles route arrays (by joining the paths together) as well as RegExp and normal
 * string values (in the latter case the toString conversion is technically unnecessary but
 * it doesn't hurt us either).
 */ function $628c4d30933e5d98$var$getLayerRoutePathString(isArray, lrp) {
    if (isArray) return lrp.map((r)=>r.toString()).join(',');
    return lrp && lrp.toString();
}

});
parcelRegister("7vcr7", function(module, exports) {

$parcel$export(module.exports, "extractPathForTransaction", () => $576513448c542400$export$8c5ebee2e5bb9575);

var $k7rM9 = parcelRequire("k7rM9");

var $b9f5Q = parcelRequire("b9f5Q");

var $d4cKa = parcelRequire("d4cKa");
const $576513448c542400$var$DEFAULT_INCLUDES = {
    ip: false,
    request: true,
    transaction: true,
    user: true
};
const $576513448c542400$var$DEFAULT_REQUEST_INCLUDES = [
    'cookies',
    'data',
    'headers',
    'method',
    'query_string',
    'url'
];
const $576513448c542400$var$DEFAULT_USER_INCLUDES = [
    'id',
    'username',
    'email'
];
/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request
 */ function $576513448c542400$export$1973410ef8793cd6(transaction, req, deps) {
    if (!transaction) return;
    if (!transaction.metadata.source || transaction.metadata.source === 'url') // Attempt to grab a parameterized route off of the request
    transaction.setName(...$576513448c542400$export$8c5ebee2e5bb9575(req, {
        path: true,
        method: true
    }));
    transaction.setData('url', req.originalUrl || req.url);
    if (req.baseUrl) transaction.setData('baseUrl', req.baseUrl);
    transaction.setData('query', $576513448c542400$var$extractQueryParams(req, deps));
}
/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */ function $576513448c542400$export$8c5ebee2e5bb9575(req, options = {}) {
    const method = req.method && req.method.toUpperCase();
    let path = '';
    let source = 'url';
    // Check to see if there's a parameterized route we can use (as there is in Express)
    if (options.customRoute || req.route) {
        path = options.customRoute || `${req.baseUrl || ''}${req.route && req.route.path}`;
        source = 'route';
    } else if (req.originalUrl || req.url) path = (0, $d4cKa.stripUrlQueryAndFragment)(req.originalUrl || req.url || '');
    let name = '';
    if (options.method && method) name += method;
    if (options.method && options.path) name += ' ';
    if (options.path && path) name += path;
    return [
        name,
        source
    ];
}
/** JSDoc */ function $576513448c542400$var$extractTransaction(req, type) {
    switch(type){
        case 'path':
            return $576513448c542400$export$8c5ebee2e5bb9575(req, {
                path: true
            })[0];
        case 'handler':
            return req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name || '<anonymous>';
        case 'methodPath':
        default:
            return $576513448c542400$export$8c5ebee2e5bb9575(req, {
                path: true,
                method: true
            })[0];
    }
}
/** JSDoc */ function $576513448c542400$var$extractUserData(user, keys) {
    const extractedUser = {};
    const attributes = Array.isArray(keys) ? keys : $576513448c542400$var$DEFAULT_USER_INCLUDES;
    attributes.forEach((key)=>{
        if (user && key in user) extractedUser[key] = user[key];
    });
    return extractedUser;
}
/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */ function $576513448c542400$export$b5c5d78255f11c84(req, options) {
    const { include: include = $576513448c542400$var$DEFAULT_REQUEST_INCLUDES, deps: deps } = options || {};
    const requestData = {};
    // headers:
    //   node, express, koa, nextjs: req.headers
    const headers = req.headers || {};
    // method:
    //   node, express, koa, nextjs: req.method
    const method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node, nextjs: req.headers.host
    const host = req.hostname || req.host || headers.host || '<no host>';
    // protocol:
    //   node, nextjs: <n/a>
    //   express, koa: req.protocol
    const protocol = req.protocol === 'https' || req.socket && req.socket.encrypted ? 'https' : 'http';
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    const originalUrl = req.originalUrl || req.url || '';
    // absolute url
    const absoluteUrl = `${protocol}://${host}${originalUrl}`;
    include.forEach((key)=>{
        switch(key){
            case 'headers':
                requestData.headers = headers;
                break;
            case 'method':
                requestData.method = method;
                break;
            case 'url':
                requestData.url = absoluteUrl;
                break;
            case 'cookies':
                // cookies:
                //   node, express, koa: req.headers.cookie
                //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.cookies = // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
                // come off in v8
                req.cookies || headers.cookie && deps && deps.cookie && deps.cookie.parse(headers.cookie) || {};
                break;
            case 'query_string':
                // query string:
                //   node: req.url (raw)
                //   express, koa, nextjs: req.query
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                requestData.query_string = $576513448c542400$var$extractQueryParams(req, deps);
                break;
            case 'data':
                if (method === 'GET' || method === 'HEAD') break;
                // body data:
                //   express, koa, nextjs: req.body
                //
                //   when using node by itself, you have to read the incoming stream(see
                //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
                //   where they're going to store the final result, so they'll have to capture this data themselves
                if (req.body !== undefined) requestData.data = (0, $k7rM9.isString)(req.body) ? req.body : JSON.stringify((0, $b9f5Q.normalize)(req.body));
                break;
            default:
                if (({}).hasOwnProperty.call(req, key)) requestData[key] = req[key];
        }
    });
    return requestData;
}
/**
 * Options deciding what parts of the request to use when enhancing an event
 */ /**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @hidden
 */ function $576513448c542400$export$e560aeb323d2791d(event, req, options) {
    const include = {
        ...$576513448c542400$var$DEFAULT_INCLUDES,
        ...options && options.include
    };
    if (include.request) {
        const extractedRequestData = Array.isArray(include.request) ? $576513448c542400$export$b5c5d78255f11c84(req, {
            include: include.request,
            deps: options && options.deps
        }) : $576513448c542400$export$b5c5d78255f11c84(req, {
            deps: options && options.deps
        });
        event.request = {
            ...event.request,
            ...extractedRequestData
        };
    }
    if (include.user) {
        const extractedUser = req.user && (0, $k7rM9.isPlainObject)(req.user) ? $576513448c542400$var$extractUserData(req.user, include.user) : {};
        if (Object.keys(extractedUser).length) event.user = {
            ...event.user,
            ...extractedUser
        };
    }
    // client ip:
    //   node, nextjs: req.socket.remoteAddress
    //   express, koa: req.ip
    if (include.ip) {
        const ip = req.ip || req.socket && req.socket.remoteAddress;
        if (ip) event.user = {
            ...event.user,
            ip_address: ip
        };
    }
    if (include.transaction && !event.transaction) // TODO do we even need this anymore?
    // TODO make this work for nextjs
    event.transaction = $576513448c542400$var$extractTransaction(req, include.transaction);
    return event;
}
function $576513448c542400$var$extractQueryParams(req, deps) {
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    let originalUrl = req.originalUrl || req.url || '';
    if (!originalUrl) return;
    // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
    // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
    if (originalUrl.startsWith('/')) originalUrl = `http://dogs.are.great${originalUrl}`;
    return req.query || new URL(originalUrl).search.replace('?', '') || // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
    deps && deps.url && deps.url.parse(originalUrl).query || undefined;
}

});
parcelRegister("b9f5Q", function(module, exports) {

$parcel$export(module.exports, "normalize", () => $81dc3e2f626cbd24$export$a3295358bff77e);

var $k7rM9 = parcelRequire("k7rM9");

var $H8bUY = parcelRequire("H8bUY");

var $3CK1O = parcelRequire("3CK1O");

var $8yub9 = parcelRequire("8yub9");
/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $81dc3e2f626cbd24$export$a3295358bff77e(input, depth = Infinity, maxProperties = Infinity) {
    try {
        // since we're at the outermost level, we don't provide a key
        return $81dc3e2f626cbd24$export$588732934346abbf('', input, depth, maxProperties);
    } catch (err) {
        return {
            ERROR: `**non-serializable** (${err})`
        };
    }
}
/** JSDoc */ function $81dc3e2f626cbd24$export$23fbbb20bed71033(// eslint-disable-next-line @typescript-eslint/no-explicit-any
object, // Default Node.js REPL depth
depth = 3, // 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize = 102400) {
    const normalized = $81dc3e2f626cbd24$export$a3295358bff77e(object, depth);
    if ($81dc3e2f626cbd24$var$jsonSize(normalized) > maxSize) return $81dc3e2f626cbd24$export$23fbbb20bed71033(object, depth - 1, maxSize);
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */ function $81dc3e2f626cbd24$export$588732934346abbf(key, value, depth = Infinity, maxProperties = Infinity, memo = (0, $H8bUY.memoBuilder)()) {
    const [memoize, unmemoize] = memo;
    // Get the simple cases out of the way first
    if (value === null || [
        'number',
        'boolean',
        'string'
    ].includes(typeof value) && !(0, $k7rM9.isNaN)(value)) return value;
    const stringified = $81dc3e2f626cbd24$var$stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) return stringified;
    // From here on, we can assert that `value` is either an object or an array.
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    if (value['__sentry_skip_normalization__']) return value;
    // Do not normalize objects that we know have already been normalized. As a general rule, the
    // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
    // have already been normalized.
    let overriddenDepth = depth;
    if (typeof value['__sentry_override_normalization_depth__'] === 'number') overriddenDepth = value['__sentry_override_normalization_depth__'];
    // We're also done if we've reached the max depth
    if (overriddenDepth === 0) // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) return '[Circular ~]';
    // If the value has a `toJSON` method, we call it to extract more information
    const valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') try {
        const jsonValue = valueWithToJSON.toJSON();
        // We need to normalize the return value of `.toJSON()` in case it has circular references
        return $81dc3e2f626cbd24$export$588732934346abbf('', jsonValue, overriddenDepth - 1, maxProperties, memo);
    } catch (err) {
    // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    const normalized = Array.isArray(value) ? [] : {};
    let numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    const visitable = (0, $3CK1O.convertToPlainObject)(value);
    for(const visitKey in visitable){
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) continue;
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        const visitValue = visitable[visitKey];
        normalized[visitKey] = $81dc3e2f626cbd24$export$588732934346abbf(visitKey, visitValue, overriddenDepth - 1, maxProperties, memo);
        numAdded++;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */ function $81dc3e2f626cbd24$var$stringifyValue(key, // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) return '[Domain]';
        if (key === 'domainEmitter') return '[DomainEmitter]';
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof $parcel$global !== 'undefined' && value === $parcel$global) return '[Global]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) return '[Window]';
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) return '[Document]';
        // React's SyntheticEvent thingy
        if ((0, $k7rM9.isSyntheticEvent)(value)) return '[SyntheticEvent]';
        if (typeof value === 'number' && value !== value) return '[NaN]';
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) return '[undefined]';
        if (typeof value === 'function') return `[Function: ${(0, $8yub9.getFunctionName)(value)}]`;
        if (typeof value === 'symbol') return `[${String(value)}]`;
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') return `[BigInt: ${String(value)}]`;
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return `[object ${$81dc3e2f626cbd24$var$getConstructorName(value)}]`;
    } catch (err) {
        return `**non-serializable** (${err})`;
    }
}
function $81dc3e2f626cbd24$var$getConstructorName(value) {
    const prototype = Object.getPrototypeOf(value);
    return prototype ? prototype.constructor.name : 'null prototype';
}
/** Calculates bytes size of input string */ function $81dc3e2f626cbd24$var$utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function $81dc3e2f626cbd24$var$jsonSize(value) {
    return $81dc3e2f626cbd24$var$utf8Length(JSON.stringify(value));
}

});
parcelRegister("H8bUY", function(module, exports) {

$parcel$export(module.exports, "memoBuilder", () => $081a5edf8dbb05ab$export$8115b0b78e956ab3);
/* eslint-disable @typescript-eslint/no-unsafe-member-access */ /* eslint-disable @typescript-eslint/no-explicit-any */ /**
 * Helper to decycle json objects
 */ function $081a5edf8dbb05ab$export$8115b0b78e956ab3() {
    const hasWeakSet = typeof WeakSet === 'function';
    const inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) return true;
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(let i = 0; i < inner.length; i++){
            const value = inner[i];
            if (value === obj) return true;
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) inner.delete(obj);
        else {
            for(let i = 0; i < inner.length; i++)if (inner[i] === obj) {
                inner.splice(i, 1);
                break;
            }
        }
    }
    return [
        memoize,
        unmemoize
    ];
}

});


parcelRegister("d4cKa", function(module, exports) {

$parcel$export(module.exports, "stripUrlQueryAndFragment", () => $983588b0c69df13f$export$ce084c78234bd35);
$parcel$export(module.exports, "getNumberOfUrlSegments", () => $983588b0c69df13f$export$69dd85280a8d374c);
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */ function $983588b0c69df13f$export$7a5253c0f62e0150(url) {
    if (!url) return {};
    const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) return {};
    // coerce to undefined values to empty string so we don't get 'undefined'
    const query = match[6] || '';
    const fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        search: query,
        hash: fragment,
        relative: match[5] + query + fragment
    };
}
/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */ function $983588b0c69df13f$export$ce084c78234bd35(urlPath) {
    // eslint-disable-next-line no-useless-escape
    return urlPath.split(/[\?#]/, 1)[0];
}
/**
 * Returns number of URL segments of a passed string URL.
 */ function $983588b0c69df13f$export$69dd85280a8d374c(url) {
    // split at '/' or at '\/' to split regex urls correctly
    return url.split(/\\?\//).filter((s)=>s.length > 0 && s !== ',').length;
}
/**
 * Takes a URL object and returns a sanitized string which is safe to use as span description
 * see: https://develop.sentry.dev/sdk/data-handling/#structuring-data
 */ function $983588b0c69df13f$export$e0ba26c9e23e1fe0(url) {
    const { protocol: protocol, host: host, path: path } = url;
    const filteredHost = host && host// Always filter out authority
    .replace(/^.*@/, '[filtered]:[filtered]@')// Don't show standard :80 (http) and :443 (https) ports to reduce the noise
    .replace(':80', '').replace(':443', '') || '';
    return `${protocol ? `${protocol}://` : ''}${filteredHost}${path}`;
}

});



parcelRegister("kWON5", function(module, exports) {

$parcel$export(module.exports, "GraphQL", () => $f4009f6a48aceb62$export$b735d011553f1049);

var $4Aa3G = parcelRequire("4Aa3G");

var $3CK1O = parcelRequire("3CK1O");
var $k7rM9 = parcelRequire("k7rM9");
var $fEKkD = parcelRequire("fEKkD");
var $elKLM = parcelRequire("elKLM");

var $fzFcM = parcelRequire("fzFcM");
/** Tracing integration for graphql package */ class $f4009f6a48aceb62$export$b735d011553f1049 {
    constructor(){
        $f4009f6a48aceb62$export$b735d011553f1049.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'GraphQL';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $f4009f6a48aceb62$export$b735d011553f1049.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $fEKkD.loadModule)('graphql/execution/execute.js');
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $fzFcM.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('GraphQL Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error('GraphQL Integration was unable to require graphql/execution package.');
            return;
        }
        (0, $3CK1O.fill)(pkg, 'execute', function(orig) {
            return function(...args) {
                const scope = getCurrentHub().getScope();
                const parentSpan = (0, $4Aa3G._optionalChain)([
                    scope,
                    'optionalAccess',
                    (_2)=>_2.getSpan,
                    'call',
                    (_3)=>_3()
                ]);
                const span = (0, $4Aa3G._optionalChain)([
                    parentSpan,
                    'optionalAccess',
                    (_4)=>_4.startChild,
                    'call',
                    (_5)=>_5({
                            description: 'execute',
                            op: 'graphql.execute'
                        })
                ]);
                (0, $4Aa3G._optionalChain)([
                    scope,
                    'optionalAccess',
                    (_6)=>_6.setSpan,
                    'call',
                    (_7)=>_7(span)
                ]);
                const rv = orig.call(this, ...args);
                if ((0, $k7rM9.isThenable)(rv)) return rv.then((res)=>{
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_8)=>_8.finish,
                        'call',
                        (_9)=>_9()
                    ]);
                    (0, $4Aa3G._optionalChain)([
                        scope,
                        'optionalAccess',
                        (_10)=>_10.setSpan,
                        'call',
                        (_11)=>_11(parentSpan)
                    ]);
                    return res;
                });
                (0, $4Aa3G._optionalChain)([
                    span,
                    'optionalAccess',
                    (_12)=>_12.finish,
                    'call',
                    (_13)=>_13()
                ]);
                (0, $4Aa3G._optionalChain)([
                    scope,
                    'optionalAccess',
                    (_14)=>_14.setSpan,
                    'call',
                    (_15)=>_15(parentSpan)
                ]);
                return rv;
            };
        });
    }
}
$f4009f6a48aceb62$export$b735d011553f1049.__initStatic();

});

parcelRegister("571pR", function(module, exports) {

$parcel$export(module.exports, "Mongo", () => $3b8eb46a587f8679$export$968aa4360b02a334);

var $4Aa3G = parcelRequire("4Aa3G");

var $3CK1O = parcelRequire("3CK1O");
var $k7rM9 = parcelRequire("k7rM9");
var $fEKkD = parcelRequire("fEKkD");
var $elKLM = parcelRequire("elKLM");

var $fzFcM = parcelRequire("fzFcM");
// This allows us to use the same array for both defaults options and the type itself.
// (note `as const` at the end to make it a union of string literal types (i.e. "a" | "b" | ... )
// and not just a string[])
const $3b8eb46a587f8679$var$OPERATIONS = [
    'aggregate',
    'bulkWrite',
    'countDocuments',
    'createIndex',
    'createIndexes',
    'deleteMany',
    'deleteOne',
    'distinct',
    'drop',
    'dropIndex',
    'dropIndexes',
    'estimatedDocumentCount',
    'find',
    'findOne',
    'findOneAndDelete',
    'findOneAndReplace',
    'findOneAndUpdate',
    'indexes',
    'indexExists',
    'indexInformation',
    'initializeOrderedBulkOp',
    'insertMany',
    'insertOne',
    'isCapped',
    'mapReduce',
    'options',
    'parallelCollectionScan',
    'rename',
    'replaceOne',
    'stats',
    'updateMany',
    'updateOne'
];
// All of the operations above take `options` and `callback` as their final parameters, but some of them
// take additional parameters as well. For those operations, this is a map of
// { <operation name>:  [<names of additional parameters>] }, as a way to know what to call the operation's
// positional arguments when we add them to the span's `data` object later
const $3b8eb46a587f8679$var$OPERATION_SIGNATURES = {
    // aggregate intentionally not included because `pipeline` arguments are too complex to serialize well
    // see https://github.com/getsentry/sentry-javascript/pull/3102
    bulkWrite: [
        'operations'
    ],
    countDocuments: [
        'query'
    ],
    createIndex: [
        'fieldOrSpec'
    ],
    createIndexes: [
        'indexSpecs'
    ],
    deleteMany: [
        'filter'
    ],
    deleteOne: [
        'filter'
    ],
    distinct: [
        'key',
        'query'
    ],
    dropIndex: [
        'indexName'
    ],
    find: [
        'query'
    ],
    findOne: [
        'query'
    ],
    findOneAndDelete: [
        'filter'
    ],
    findOneAndReplace: [
        'filter',
        'replacement'
    ],
    findOneAndUpdate: [
        'filter',
        'update'
    ],
    indexExists: [
        'indexes'
    ],
    insertMany: [
        'docs'
    ],
    insertOne: [
        'doc'
    ],
    mapReduce: [
        'map',
        'reduce'
    ],
    rename: [
        'newName'
    ],
    replaceOne: [
        'filter',
        'doc'
    ],
    updateMany: [
        'filter',
        'update'
    ],
    updateOne: [
        'filter',
        'update'
    ]
};
function $3b8eb46a587f8679$var$isCursor(maybeCursor) {
    return maybeCursor && typeof maybeCursor === 'object' && maybeCursor.once && typeof maybeCursor.once === 'function';
}
/** Tracing integration for mongo package */ class $3b8eb46a587f8679$export$968aa4360b02a334 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Mongo';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $3b8eb46a587f8679$export$968aa4360b02a334.id;
    }
    /**
   * @inheritDoc
   */ constructor(options = {}){
        $3b8eb46a587f8679$export$968aa4360b02a334.prototype.__init.call(this);
        this._operations = Array.isArray(options.operations) ? options.operations : $3b8eb46a587f8679$var$OPERATIONS;
        this._describeOperations = 'describeOperations' in options ? options.describeOperations : true;
        this._useMongoose = !!options.useMongoose;
    }
    /** @inheritdoc */ loadDependency() {
        const moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
        return this._module = this._module || (0, $fEKkD.loadModule)(moduleName);
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $fzFcM.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('Mongo Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            const moduleName = this._useMongoose ? 'mongoose' : 'mongodb';
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error(`Mongo Integration was unable to require \`${moduleName}\` package.`);
            return;
        }
        this._instrumentOperations(pkg.Collection, this._operations, getCurrentHub);
    }
    /**
   * Patches original collection methods
   */ _instrumentOperations(collection, operations, getCurrentHub) {
        operations.forEach((operation)=>this._patchOperation(collection, operation, getCurrentHub));
    }
    /**
   * Patches original collection to utilize our tracing functionality
   */ _patchOperation(collection, operation, getCurrentHub) {
        if (!(operation in collection.prototype)) return;
        const getSpanContext = this._getSpanContextFromOperationArguments.bind(this);
        (0, $3CK1O.fill)(collection.prototype, operation, function(orig) {
            return function(...args) {
                const lastArg = args[args.length - 1];
                const scope = getCurrentHub().getScope();
                const parentSpan = (0, $4Aa3G._optionalChain)([
                    scope,
                    'optionalAccess',
                    (_2)=>_2.getSpan,
                    'call',
                    (_3)=>_3()
                ]);
                // Check if the operation was passed a callback. (mapReduce requires a different check, as
                // its (non-callback) arguments can also be functions.)
                if (typeof lastArg !== 'function' || operation === 'mapReduce' && args.length === 2) {
                    const span = (0, $4Aa3G._optionalChain)([
                        parentSpan,
                        'optionalAccess',
                        (_4)=>_4.startChild,
                        'call',
                        (_5)=>_5(getSpanContext(this, operation, args))
                    ]);
                    const maybePromiseOrCursor = orig.call(this, ...args);
                    if ((0, $k7rM9.isThenable)(maybePromiseOrCursor)) return maybePromiseOrCursor.then((res)=>{
                        (0, $4Aa3G._optionalChain)([
                            span,
                            'optionalAccess',
                            (_6)=>_6.finish,
                            'call',
                            (_7)=>_7()
                        ]);
                        return res;
                    });
                    else if ($3b8eb46a587f8679$var$isCursor(maybePromiseOrCursor)) {
                        const cursor = maybePromiseOrCursor;
                        try {
                            cursor.once('close', ()=>{
                                (0, $4Aa3G._optionalChain)([
                                    span,
                                    'optionalAccess',
                                    (_8)=>_8.finish,
                                    'call',
                                    (_9)=>_9()
                                ]);
                            });
                        } catch (e) {
                            // If the cursor is already closed, `once` will throw an error. In that case, we can
                            // finish the span immediately.
                            (0, $4Aa3G._optionalChain)([
                                span,
                                'optionalAccess',
                                (_10)=>_10.finish,
                                'call',
                                (_11)=>_11()
                            ]);
                        }
                        return cursor;
                    } else {
                        (0, $4Aa3G._optionalChain)([
                            span,
                            'optionalAccess',
                            (_12)=>_12.finish,
                            'call',
                            (_13)=>_13()
                        ]);
                        return maybePromiseOrCursor;
                    }
                }
                const span = (0, $4Aa3G._optionalChain)([
                    parentSpan,
                    'optionalAccess',
                    (_14)=>_14.startChild,
                    'call',
                    (_15)=>_15(getSpanContext(this, operation, args.slice(0, -1)))
                ]);
                return orig.call(this, ...args.slice(0, -1), function(err, result) {
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_16)=>_16.finish,
                        'call',
                        (_17)=>_17()
                    ]);
                    lastArg(err, result);
                });
            };
        });
    }
    /**
   * Form a SpanContext based on the user input to a given operation.
   */ _getSpanContextFromOperationArguments(collection, operation, args) {
        const data = {
            collectionName: collection.collectionName,
            dbName: collection.dbName,
            namespace: collection.namespace
        };
        const spanContext = {
            op: 'db',
            description: operation,
            data: data
        };
        // If the operation takes no arguments besides `options` and `callback`, or if argument
        // collection is disabled for this operation, just return early.
        const signature = $3b8eb46a587f8679$var$OPERATION_SIGNATURES[operation];
        const shouldDescribe = Array.isArray(this._describeOperations) ? this._describeOperations.includes(operation) : this._describeOperations;
        if (!signature || !shouldDescribe) return spanContext;
        try {
            // Special case for `mapReduce`, as the only one accepting functions as arguments.
            if (operation === 'mapReduce') {
                const [map, reduce] = args;
                data[signature[0]] = typeof map === 'string' ? map : map.name || '<anonymous>';
                data[signature[1]] = typeof reduce === 'string' ? reduce : reduce.name || '<anonymous>';
            } else for(let i = 0; i < signature.length; i++)data[signature[i]] = JSON.stringify(args[i]);
        } catch (_oO) {
        // no-empty
        }
        return spanContext;
    }
}
$3b8eb46a587f8679$export$968aa4360b02a334.__initStatic();

});

parcelRegister("he8el", function(module, exports) {

$parcel$export(module.exports, "Mysql", () => $c8aa20d9a32af88d$export$a2cc26ff91a3f8ad);

var $4Aa3G = parcelRequire("4Aa3G");

var $3CK1O = parcelRequire("3CK1O");
var $fEKkD = parcelRequire("fEKkD");
var $elKLM = parcelRequire("elKLM");

var $fzFcM = parcelRequire("fzFcM");
/** Tracing integration for node-mysql package */ class $c8aa20d9a32af88d$export$a2cc26ff91a3f8ad {
    constructor(){
        $c8aa20d9a32af88d$export$a2cc26ff91a3f8ad.prototype.__init.call(this);
    }
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Mysql';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $c8aa20d9a32af88d$export$a2cc26ff91a3f8ad.id;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $fEKkD.loadModule)('mysql/lib/Connection.js');
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $fzFcM.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('Mysql Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error('Mysql Integration was unable to require `mysql` package.');
            return;
        }
        // The original function will have one of these signatures:
        //    function (callback) => void
        //    function (options, callback) => void
        //    function (options, values, callback) => void
        (0, $3CK1O.fill)(pkg, 'createQuery', function(orig) {
            return function(options, values, callback) {
                const scope = getCurrentHub().getScope();
                const parentSpan = (0, $4Aa3G._optionalChain)([
                    scope,
                    'optionalAccess',
                    (_2)=>_2.getSpan,
                    'call',
                    (_3)=>_3()
                ]);
                const span = (0, $4Aa3G._optionalChain)([
                    parentSpan,
                    'optionalAccess',
                    (_4)=>_4.startChild,
                    'call',
                    (_5)=>_5({
                            description: typeof options === 'string' ? options : options.sql,
                            op: 'db'
                        })
                ]);
                if (typeof callback === 'function') return orig.call(this, options, values, function(err, result, fields) {
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_6)=>_6.finish,
                        'call',
                        (_7)=>_7()
                    ]);
                    callback(err, result, fields);
                });
                if (typeof values === 'function') return orig.call(this, options, function(err, result, fields) {
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_8)=>_8.finish,
                        'call',
                        (_9)=>_9()
                    ]);
                    values(err, result, fields);
                });
                return orig.call(this, options, values, callback);
            };
        });
    }
}
$c8aa20d9a32af88d$export$a2cc26ff91a3f8ad.__initStatic();

});

parcelRegister("d1Bxg", function(module, exports) {

$parcel$export(module.exports, "Postgres", () => $97b87c233cb827f1$export$806ddb599177abc4);

var $4Aa3G = parcelRequire("4Aa3G");

var $3CK1O = parcelRequire("3CK1O");
var $k7rM9 = parcelRequire("k7rM9");
var $fEKkD = parcelRequire("fEKkD");
var $elKLM = parcelRequire("elKLM");

var $fzFcM = parcelRequire("fzFcM");
/** Tracing integration for node-postgres package */ class $97b87c233cb827f1$export$806ddb599177abc4 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Postgres';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $97b87c233cb827f1$export$806ddb599177abc4.id;
    }
    constructor(options = {}){
        $97b87c233cb827f1$export$806ddb599177abc4.prototype.__init.call(this);
        this._usePgNative = !!options.usePgNative;
    }
    /** @inheritdoc */ loadDependency() {
        return this._module = this._module || (0, $fEKkD.loadModule)('pg');
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if ((0, $fzFcM.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('Postgres Integration is skipped because of instrumenter configuration.');
            return;
        }
        const pkg = this.loadDependency();
        if (!pkg) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error('Postgres Integration was unable to require `pg` package.');
            return;
        }
        if (this._usePgNative && !(0, $4Aa3G._optionalChain)([
            pkg,
            'access',
            (_2)=>_2.native,
            'optionalAccess',
            (_3)=>_3.Client
        ])) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error("Postgres Integration was unable to access 'pg-native' bindings.");
            return;
        }
        const { Client: Client } = this._usePgNative ? pkg.native : pkg;
        /**
     * function (query, callback) => void
     * function (query, params, callback) => void
     * function (query) => Promise
     * function (query, params) => Promise
     * function (pg.Cursor) => pg.Cursor
     */ (0, $3CK1O.fill)(Client.prototype, 'query', function(orig) {
            return function(config, values, callback) {
                const scope = getCurrentHub().getScope();
                const parentSpan = (0, $4Aa3G._optionalChain)([
                    scope,
                    'optionalAccess',
                    (_4)=>_4.getSpan,
                    'call',
                    (_5)=>_5()
                ]);
                const span = (0, $4Aa3G._optionalChain)([
                    parentSpan,
                    'optionalAccess',
                    (_6)=>_6.startChild,
                    'call',
                    (_7)=>_7({
                            description: typeof config === 'string' ? config : config.text,
                            op: 'db'
                        })
                ]);
                if (typeof callback === 'function') return orig.call(this, config, values, function(err, result) {
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_8)=>_8.finish,
                        'call',
                        (_9)=>_9()
                    ]);
                    callback(err, result);
                });
                if (typeof values === 'function') return orig.call(this, config, function(err, result) {
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_10)=>_10.finish,
                        'call',
                        (_11)=>_11()
                    ]);
                    values(err, result);
                });
                const rv = typeof values !== 'undefined' ? orig.call(this, config, values) : orig.call(this, config);
                if ((0, $k7rM9.isThenable)(rv)) return rv.then((res)=>{
                    (0, $4Aa3G._optionalChain)([
                        span,
                        'optionalAccess',
                        (_12)=>_12.finish,
                        'call',
                        (_13)=>_13()
                    ]);
                    return res;
                });
                (0, $4Aa3G._optionalChain)([
                    span,
                    'optionalAccess',
                    (_14)=>_14.finish,
                    'call',
                    (_15)=>_15()
                ]);
                return rv;
            };
        });
    }
}
$97b87c233cb827f1$export$806ddb599177abc4.__initStatic();

});

parcelRegister("fv3Z4", function(module, exports) {

$parcel$export(module.exports, "Prisma", () => $b48cd7643a1b3562$export$e300e6f4779d55c2);

var $4Aa3G = parcelRequire("4Aa3G");

var $k7rM9 = parcelRequire("k7rM9");
var $elKLM = parcelRequire("elKLM");

var $fzFcM = parcelRequire("fzFcM");
function $b48cd7643a1b3562$var$isValidPrismaClient(possibleClient) {
    return possibleClient && !!possibleClient['$use'];
}
/** Tracing integration for @prisma/client package */ class $b48cd7643a1b3562$export$e300e6f4779d55c2 {
    /**
   * @inheritDoc
   */ static __initStatic() {
        this.id = 'Prisma';
    }
    /**
   * @inheritDoc
   */ __init() {
        this.name = $b48cd7643a1b3562$export$e300e6f4779d55c2.id;
    }
    /**
   * Prisma ORM Client Instance
   */ /**
   * @inheritDoc
   */ constructor(options = {}){
        $b48cd7643a1b3562$export$e300e6f4779d55c2.prototype.__init.call(this);
        if ($b48cd7643a1b3562$var$isValidPrismaClient(options.client)) this._client = options.client;
        else (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).warn(`Unsupported Prisma client provided to PrismaIntegration. Provided client: ${JSON.stringify(options.client)}`);
    }
    /**
   * @inheritDoc
   */ setupOnce(_, getCurrentHub) {
        if (!this._client) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).error('PrismaIntegration is missing a Prisma Client Instance');
            return;
        }
        if ((0, $fzFcM.shouldDisableAutoInstrumentation)(getCurrentHub)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && (0, $elKLM.logger).log('Prisma Integration is skipped because of instrumenter configuration.');
            return;
        }
        this._client.$use((params, next)=>{
            const scope = getCurrentHub().getScope();
            const parentSpan = (0, $4Aa3G._optionalChain)([
                scope,
                'optionalAccess',
                (_2)=>_2.getSpan,
                'call',
                (_3)=>_3()
            ]);
            const action = params.action;
            const model = params.model;
            const span = (0, $4Aa3G._optionalChain)([
                parentSpan,
                'optionalAccess',
                (_4)=>_4.startChild,
                'call',
                (_5)=>_5({
                        description: model ? `${model} ${action}` : action,
                        op: 'db.sql.prisma'
                    })
            ]);
            const rv = next(params);
            if ((0, $k7rM9.isThenable)(rv)) return rv.then((res)=>{
                (0, $4Aa3G._optionalChain)([
                    span,
                    'optionalAccess',
                    (_6)=>_6.finish,
                    'call',
                    (_7)=>_7()
                ]);
                return res;
            });
            (0, $4Aa3G._optionalChain)([
                span,
                'optionalAccess',
                (_8)=>_8.finish,
                'call',
                (_9)=>_9()
            ]);
            return rv;
        });
    }
}
$b48cd7643a1b3562$export$e300e6f4779d55c2.__initStatic();

});

parcelRegister("kBpSh", function(module, exports) {

$parcel$export(module.exports, "SpanStatus", () => $effb55811c4fa66a$export$beb8e6a823e89c5d);
/** The status of an Span.
 *
 * @deprecated Use string literals - if you require type casting, cast to SpanStatusType type
 */ // eslint-disable-next-line import/export
var $effb55811c4fa66a$export$beb8e6a823e89c5d;
(function(SpanStatus) {
    /** The operation completed successfully. */ const Ok = 'ok';
    SpanStatus["Ok"] = Ok;
    /** Deadline expired before operation could complete. */ const DeadlineExceeded = 'deadline_exceeded';
    SpanStatus["DeadlineExceeded"] = DeadlineExceeded;
    /** 401 Unauthorized (actually does mean unauthenticated according to RFC 7235) */ const Unauthenticated = 'unauthenticated';
    SpanStatus["Unauthenticated"] = Unauthenticated;
    /** 403 Forbidden */ const PermissionDenied = 'permission_denied';
    SpanStatus["PermissionDenied"] = PermissionDenied;
    /** 404 Not Found. Some requested entity (file or directory) was not found. */ const NotFound = 'not_found';
    SpanStatus["NotFound"] = NotFound;
    /** 429 Too Many Requests */ const ResourceExhausted = 'resource_exhausted';
    SpanStatus["ResourceExhausted"] = ResourceExhausted;
    /** Client specified an invalid argument. 4xx. */ const InvalidArgument = 'invalid_argument';
    SpanStatus["InvalidArgument"] = InvalidArgument;
    /** 501 Not Implemented */ const Unimplemented = 'unimplemented';
    SpanStatus["Unimplemented"] = Unimplemented;
    /** 503 Service Unavailable */ const Unavailable = 'unavailable';
    SpanStatus["Unavailable"] = Unavailable;
    /** Other/generic 5xx. */ const InternalError = 'internal_error';
    SpanStatus["InternalError"] = InternalError;
    /** Unknown. Any non-standard HTTP status code. */ const UnknownError = 'unknown_error';
    SpanStatus["UnknownError"] = UnknownError;
    /** The operation was cancelled (typically by the user). */ const Cancelled = 'cancelled';
    SpanStatus["Cancelled"] = Cancelled;
    /** Already exists (409) */ const AlreadyExists = 'already_exists';
    SpanStatus["AlreadyExists"] = AlreadyExists;
    /** Operation was rejected because the system is not in a state required for the operation's */ const FailedPrecondition = 'failed_precondition';
    SpanStatus["FailedPrecondition"] = FailedPrecondition;
    /** The operation was aborted, typically due to a concurrency issue. */ const Aborted = 'aborted';
    SpanStatus["Aborted"] = Aborted;
    /** Operation was attempted past the valid range. */ const OutOfRange = 'out_of_range';
    SpanStatus["OutOfRange"] = OutOfRange;
    /** Unrecoverable data loss or corruption */ const DataLoss = 'data_loss';
    SpanStatus["DataLoss"] = DataLoss;
})($effb55811c4fa66a$export$beb8e6a823e89c5d || ($effb55811c4fa66a$export$beb8e6a823e89c5d = {}));

});


parcelRegister("4xrfU", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $34df62e34a2e7a21$var$func = $jFIrw('set', (parcelRequire("a0i0f")));

$34df62e34a2e7a21$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $34df62e34a2e7a21$var$func;

});
parcelRegister("jFIrw", function(module, exports) {

var $imppR = parcelRequire("imppR");

var $a02m0 = parcelRequire("a02m0");
/**
 * Converts `func` of `name` to an immutable auto-curried iteratee-first data-last
 * version with conversion `options` applied. If `name` is an object its methods
 * will be converted.
 *
 * @param {string} name The name of the function to wrap.
 * @param {Function} [func] The function to wrap.
 * @param {Object} [options] The options object. See `baseConvert` for more details.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $e524521dc9be9d0c$var$convert(name, func, options) {
    return $imppR($a02m0, name, func, options);
}
module.exports = $e524521dc9be9d0c$var$convert;

});
parcelRegister("imppR", function(module, exports) {

var $89eBv = parcelRequire("89eBv");

var $l6Yg9 = parcelRequire("l6Yg9");
/** Built-in value reference. */ var $d5ddff315914c7cb$var$push = Array.prototype.push;
/**
 * Creates a function, with an arity of `n`, that invokes `func` with the
 * arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} n The arity of the new function.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$baseArity(func, n) {
    return n == 2 ? function(a, b) {
        return func.apply(undefined, arguments);
    } : function(a) {
        return func.apply(undefined, arguments);
    };
}
/**
 * Creates a function that invokes `func`, with up to `n` arguments, ignoring
 * any additional arguments.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @param {number} n The arity cap.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$baseAry(func, n) {
    return n == 2 ? function(a, b) {
        return func(a, b);
    } : function(a) {
        return func(a);
    };
}
/**
 * Creates a clone of `array`.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the cloned array.
 */ function $d5ddff315914c7cb$var$cloneArray(array) {
    var length = array ? array.length : 0, result = Array(length);
    while(length--)result[length] = array[length];
    return result;
}
/**
 * Creates a function that clones a given object using the assignment `func`.
 *
 * @private
 * @param {Function} func The assignment function.
 * @returns {Function} Returns the new cloner function.
 */ function $d5ddff315914c7cb$var$createCloner(func) {
    return function(object) {
        return func({}, object);
    };
}
/**
 * A specialized version of `_.spread` which flattens the spread array into
 * the arguments of the invoked `func`.
 *
 * @private
 * @param {Function} func The function to spread arguments over.
 * @param {number} start The start position of the spread.
 * @returns {Function} Returns the new function.
 */ function $d5ddff315914c7cb$var$flatSpread(func, start) {
    return function() {
        var length = arguments.length, lastIndex = length - 1, args = Array(length);
        while(length--)args[length] = arguments[length];
        var array = args[start], otherArgs = args.slice(0, start);
        if (array) $d5ddff315914c7cb$var$push.apply(otherArgs, array);
        if (start != lastIndex) $d5ddff315914c7cb$var$push.apply(otherArgs, args.slice(start + 1));
        return func.apply(this, otherArgs);
    };
}
/**
 * Creates a function that wraps `func` and uses `cloner` to clone the first
 * argument it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} cloner The function to clone arguments.
 * @returns {Function} Returns the new immutable function.
 */ function $d5ddff315914c7cb$var$wrapImmutable(func, cloner) {
    return function() {
        var length = arguments.length;
        if (!length) return;
        var args = Array(length);
        while(length--)args[length] = arguments[length];
        var result = args[0] = cloner.apply(undefined, args);
        func.apply(undefined, args);
        return result;
    };
}
/**
 * The base implementation of `convert` which accepts a `util` object of methods
 * required to perform conversions.
 *
 * @param {Object} util The util object.
 * @param {string} name The name of the function to convert.
 * @param {Function} func The function to convert.
 * @param {Object} [options] The options object.
 * @param {boolean} [options.cap=true] Specify capping iteratee arguments.
 * @param {boolean} [options.curry=true] Specify currying.
 * @param {boolean} [options.fixed=true] Specify fixed arity.
 * @param {boolean} [options.immutable=true] Specify immutable operations.
 * @param {boolean} [options.rearg=true] Specify rearranging arguments.
 * @returns {Function|Object} Returns the converted function or object.
 */ function $d5ddff315914c7cb$var$baseConvert(util, name, func, options) {
    var isLib = typeof name == 'function', isObj = name === Object(name);
    if (isObj) {
        options = func;
        func = name;
        name = undefined;
    }
    if (func == null) throw new TypeError;
    options || (options = {});
    var config = {
        'cap': 'cap' in options ? options.cap : true,
        'curry': 'curry' in options ? options.curry : true,
        'fixed': 'fixed' in options ? options.fixed : true,
        'immutable': 'immutable' in options ? options.immutable : true,
        'rearg': 'rearg' in options ? options.rearg : true
    };
    var defaultHolder = isLib ? func : $l6Yg9, forceCurry = 'curry' in options && options.curry, forceFixed = 'fixed' in options && options.fixed, forceRearg = 'rearg' in options && options.rearg, pristine = isLib ? func.runInContext() : undefined;
    var helpers = isLib ? func : {
        'ary': util.ary,
        'assign': util.assign,
        'clone': util.clone,
        'curry': util.curry,
        'forEach': util.forEach,
        'isArray': util.isArray,
        'isError': util.isError,
        'isFunction': util.isFunction,
        'isWeakMap': util.isWeakMap,
        'iteratee': util.iteratee,
        'keys': util.keys,
        'rearg': util.rearg,
        'toInteger': util.toInteger,
        'toPath': util.toPath
    };
    var ary = helpers.ary, assign = helpers.assign, clone = helpers.clone, curry = helpers.curry, each = helpers.forEach, isArray = helpers.isArray, isError = helpers.isError, isFunction = helpers.isFunction, isWeakMap = helpers.isWeakMap, keys = helpers.keys, rearg = helpers.rearg, toInteger = helpers.toInteger, toPath = helpers.toPath;
    var aryMethodKeys = keys($89eBv.aryMethod);
    var wrappers = {
        'castArray': function(castArray) {
            return function() {
                var value = arguments[0];
                return isArray(value) ? castArray($d5ddff315914c7cb$var$cloneArray(value)) : castArray.apply(undefined, arguments);
            };
        },
        'iteratee': function(iteratee) {
            return function() {
                var func = arguments[0], arity = arguments[1], result = iteratee(func, arity), length = result.length;
                if (config.cap && typeof arity == 'number') {
                    arity = arity > 2 ? arity - 2 : 1;
                    return length && length <= arity ? result : $d5ddff315914c7cb$var$baseAry(result, arity);
                }
                return result;
            };
        },
        'mixin': function(mixin) {
            return function(source) {
                var func = this;
                if (!isFunction(func)) return mixin(func, Object(source));
                var pairs = [];
                each(keys(source), function(key) {
                    if (isFunction(source[key])) pairs.push([
                        key,
                        func.prototype[key]
                    ]);
                });
                mixin(func, Object(source));
                each(pairs, function(pair) {
                    var value = pair[1];
                    if (isFunction(value)) func.prototype[pair[0]] = value;
                    else delete func.prototype[pair[0]];
                });
                return func;
            };
        },
        'nthArg': function(nthArg) {
            return function(n) {
                var arity = n < 0 ? 1 : toInteger(n) + 1;
                return curry(nthArg(n), arity);
            };
        },
        'rearg': function(rearg) {
            return function(func, indexes) {
                var arity = indexes ? indexes.length : 0;
                return curry(rearg(func, indexes), arity);
            };
        },
        'runInContext': function(runInContext) {
            return function(context) {
                return $d5ddff315914c7cb$var$baseConvert(util, runInContext(context), options);
            };
        }
    };
    /*--------------------------------------------------------------------------*/ /**
   * Casts `func` to a function with an arity capped iteratee if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @returns {Function} Returns the cast function.
   */ function castCap(name, func) {
        if (config.cap) {
            var indexes = $89eBv.iterateeRearg[name];
            if (indexes) return iterateeRearg(func, indexes);
            var n = !isLib && $89eBv.iterateeAry[name];
            if (n) return iterateeAry(func, n);
        }
        return func;
    }
    /**
   * Casts `func` to a curried function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castCurry(name, func, n) {
        return forceCurry || config.curry && n > 1 ? curry(func, n) : func;
    }
    /**
   * Casts `func` to a fixed arity function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the cast function.
   */ function castFixed(name, func, n) {
        if (config.fixed && (forceFixed || !$89eBv.skipFixed[name])) {
            var data = $89eBv.methodSpread[name], start = data && data.start;
            return start === undefined ? ary(func, n) : $d5ddff315914c7cb$var$flatSpread(func, start);
        }
        return func;
    }
    /**
   * Casts `func` to an rearged function if needed.
   *
   * @private
   * @param {string} name The name of the function to inspect.
   * @param {Function} func The function to inspect.
   * @param {number} n The arity of `func`.
   * @returns {Function} Returns the cast function.
   */ function castRearg(name, func, n) {
        return config.rearg && n > 1 && (forceRearg || !$89eBv.skipRearg[name]) ? rearg(func, $89eBv.methodRearg[name] || $89eBv.aryRearg[n]) : func;
    }
    /**
   * Creates a clone of `object` by `path`.
   *
   * @private
   * @param {Object} object The object to clone.
   * @param {Array|string} path The path to clone by.
   * @returns {Object} Returns the cloned object.
   */ function cloneByPath(object, path) {
        path = toPath(path);
        var index = -1, length = path.length, lastIndex = length - 1, result = clone(Object(object)), nested = result;
        while(nested != null && ++index < length){
            var key = path[index], value = nested[key];
            if (value != null && !(isFunction(value) || isError(value) || isWeakMap(value))) nested[key] = clone(index == lastIndex ? value : Object(value));
            nested = nested[key];
        }
        return result;
    }
    /**
   * Converts `lodash` to an immutable auto-curried iteratee-first data-last
   * version with conversion `options` applied.
   *
   * @param {Object} [options] The options object. See `baseConvert` for more details.
   * @returns {Function} Returns the converted `lodash`.
   */ function convertLib(options) {
        return _.runInContext.convert(options)(undefined);
    }
    /**
   * Create a converter function for `func` of `name`.
   *
   * @param {string} name The name of the function to convert.
   * @param {Function} func The function to convert.
   * @returns {Function} Returns the new converter function.
   */ function createConverter(name, func) {
        var realName = $89eBv.aliasToReal[name] || name, methodName = $89eBv.remap[realName] || realName, oldOptions = options;
        return function(options) {
            var newUtil = isLib ? pristine : helpers, newFunc = isLib ? pristine[methodName] : func, newOptions = assign(assign({}, oldOptions), options);
            return $d5ddff315914c7cb$var$baseConvert(newUtil, realName, newFunc, newOptions);
        };
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee, with up to `n`
   * arguments, ignoring any additional arguments.
   *
   * @private
   * @param {Function} func The function to cap iteratee arguments for.
   * @param {number} n The arity cap.
   * @returns {Function} Returns the new function.
   */ function iterateeAry(func, n) {
        return overArg(func, function(func) {
            return typeof func == 'function' ? $d5ddff315914c7cb$var$baseAry(func, n) : func;
        });
    }
    /**
   * Creates a function that wraps `func` to invoke its iteratee with arguments
   * arranged according to the specified `indexes` where the argument value at
   * the first index is provided as the first argument, the argument value at
   * the second index is provided as the second argument, and so on.
   *
   * @private
   * @param {Function} func The function to rearrange iteratee arguments for.
   * @param {number[]} indexes The arranged argument indexes.
   * @returns {Function} Returns the new function.
   */ function iterateeRearg(func, indexes) {
        return overArg(func, function(func) {
            var n = indexes.length;
            return $d5ddff315914c7cb$var$baseArity(rearg($d5ddff315914c7cb$var$baseAry(func, n), indexes), n);
        });
    }
    /**
   * Creates a function that invokes `func` with its first argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */ function overArg(func, transform) {
        return function() {
            var length = arguments.length;
            if (!length) return func();
            var args = Array(length);
            while(length--)args[length] = arguments[length];
            var index = config.rearg ? 0 : length - 1;
            args[index] = transform(args[index]);
            return func.apply(undefined, args);
        };
    }
    /**
   * Creates a function that wraps `func` and applys the conversions
   * rules by `name`.
   *
   * @private
   * @param {string} name The name of the function to wrap.
   * @param {Function} func The function to wrap.
   * @returns {Function} Returns the converted function.
   */ function wrap(name, func, placeholder) {
        var result, realName = $89eBv.aliasToReal[name] || name, wrapped = func, wrapper = wrappers[realName];
        if (wrapper) wrapped = wrapper(func);
        else if (config.immutable) {
            if ($89eBv.mutate.array[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, $d5ddff315914c7cb$var$cloneArray);
            else if ($89eBv.mutate.object[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, $d5ddff315914c7cb$var$createCloner(func));
            else if ($89eBv.mutate.set[realName]) wrapped = $d5ddff315914c7cb$var$wrapImmutable(func, cloneByPath);
        }
        each(aryMethodKeys, function(aryKey) {
            each($89eBv.aryMethod[aryKey], function(otherName) {
                if (realName == otherName) {
                    var data = $89eBv.methodSpread[realName], afterRearg = data && data.afterRearg;
                    result = afterRearg ? castFixed(realName, castRearg(realName, wrapped, aryKey), aryKey) : castRearg(realName, castFixed(realName, wrapped, aryKey), aryKey);
                    result = castCap(realName, result);
                    result = castCurry(realName, result, aryKey);
                    return false;
                }
            });
            return !result;
        });
        result || (result = wrapped);
        if (result == func) result = forceCurry ? curry(result, 1) : function() {
            return func.apply(this, arguments);
        };
        result.convert = createConverter(realName, func);
        result.placeholder = func.placeholder = placeholder;
        return result;
    }
    /*--------------------------------------------------------------------------*/ if (!isObj) return wrap(name, func, defaultHolder);
    var _ = func;
    // Convert methods by ary cap.
    var pairs = [];
    each(aryMethodKeys, function(aryKey) {
        each($89eBv.aryMethod[aryKey], function(key) {
            var func = _[$89eBv.remap[key] || key];
            if (func) pairs.push([
                key,
                wrap(key, func, _)
            ]);
        });
    });
    // Convert remaining methods.
    each(keys(_), function(key) {
        var func = _[key];
        if (typeof func == 'function') {
            var length = pairs.length;
            while(length--){
                if (pairs[length][0] == key) return;
            }
            func.convert = createConverter(key, func);
            pairs.push([
                key,
                func
            ]);
        }
    });
    // Assign to `_` leaving `_.prototype` unchanged to allow chaining.
    each(pairs, function(pair) {
        _[pair[0]] = pair[1];
    });
    _.convert = convertLib;
    _.placeholder = _;
    // Assign aliases.
    each(keys(_), function(key) {
        each($89eBv.realToAlias[key] || [], function(alias) {
            _[alias] = _[key];
        });
    });
    return _;
}
module.exports = $d5ddff315914c7cb$var$baseConvert;

});
parcelRegister("89eBv", function(module, exports) {

$parcel$export(module.exports, "aliasToReal", () => $5eea7e08a1db1590$export$bd0f5e6e44efa6b4, (v) => $5eea7e08a1db1590$export$bd0f5e6e44efa6b4 = v);
$parcel$export(module.exports, "aryMethod", () => $5eea7e08a1db1590$export$85c665b4d7da9cb4, (v) => $5eea7e08a1db1590$export$85c665b4d7da9cb4 = v);
$parcel$export(module.exports, "aryRearg", () => $5eea7e08a1db1590$export$42564e045b285e32, (v) => $5eea7e08a1db1590$export$42564e045b285e32 = v);
$parcel$export(module.exports, "iterateeAry", () => $5eea7e08a1db1590$export$81e17196e6a22b07, (v) => $5eea7e08a1db1590$export$81e17196e6a22b07 = v);
$parcel$export(module.exports, "iterateeRearg", () => $5eea7e08a1db1590$export$30975ceb42167ebd, (v) => $5eea7e08a1db1590$export$30975ceb42167ebd = v);
$parcel$export(module.exports, "methodRearg", () => $5eea7e08a1db1590$export$8ceb0ad7e94d3801, (v) => $5eea7e08a1db1590$export$8ceb0ad7e94d3801 = v);
$parcel$export(module.exports, "methodSpread", () => $5eea7e08a1db1590$export$fbaeb3f87df3cf26, (v) => $5eea7e08a1db1590$export$fbaeb3f87df3cf26 = v);
$parcel$export(module.exports, "mutate", () => $5eea7e08a1db1590$export$57e795267c26e600, (v) => $5eea7e08a1db1590$export$57e795267c26e600 = v);
$parcel$export(module.exports, "realToAlias", () => $5eea7e08a1db1590$export$1eb71a7e27943e71, (v) => $5eea7e08a1db1590$export$1eb71a7e27943e71 = v);
$parcel$export(module.exports, "remap", () => $5eea7e08a1db1590$export$aee1dbae5de2db9d, (v) => $5eea7e08a1db1590$export$aee1dbae5de2db9d = v);
$parcel$export(module.exports, "skipFixed", () => $5eea7e08a1db1590$export$87ffbe4821a5d5e0, (v) => $5eea7e08a1db1590$export$87ffbe4821a5d5e0 = v);
$parcel$export(module.exports, "skipRearg", () => $5eea7e08a1db1590$export$b4d07413ce528c90, (v) => $5eea7e08a1db1590$export$b4d07413ce528c90 = v);
/** Used to map aliases to their real names. */ var $5eea7e08a1db1590$export$bd0f5e6e44efa6b4;
/** Used to map ary to method names. */ var $5eea7e08a1db1590$export$85c665b4d7da9cb4;
/** Used to map ary to rearg configs. */ var $5eea7e08a1db1590$export$42564e045b285e32;
/** Used to map method names to their iteratee ary. */ var $5eea7e08a1db1590$export$81e17196e6a22b07;
/** Used to map method names to iteratee rearg configs. */ var $5eea7e08a1db1590$export$30975ceb42167ebd;
/** Used to map method names to rearg configs. */ var $5eea7e08a1db1590$export$8ceb0ad7e94d3801;
/** Used to map method names to spread configs. */ var $5eea7e08a1db1590$export$fbaeb3f87df3cf26;
/** Used to identify methods which mutate arrays or objects. */ var $5eea7e08a1db1590$export$57e795267c26e600;
/** Used to map real names to their aliases. */ var $5eea7e08a1db1590$export$1eb71a7e27943e71;
/** Used to map method names to other names. */ var $5eea7e08a1db1590$export$aee1dbae5de2db9d;
/** Used to track methods that skip fixing their arity. */ var $5eea7e08a1db1590$export$87ffbe4821a5d5e0;
/** Used to track methods that skip rearranging arguments. */ var $5eea7e08a1db1590$export$b4d07413ce528c90;
$5eea7e08a1db1590$export$bd0f5e6e44efa6b4 = {
    // Lodash aliases.
    'each': 'forEach',
    'eachRight': 'forEachRight',
    'entries': 'toPairs',
    'entriesIn': 'toPairsIn',
    'extend': 'assignIn',
    'extendAll': 'assignInAll',
    'extendAllWith': 'assignInAllWith',
    'extendWith': 'assignInWith',
    'first': 'head',
    // Methods that are curried variants of others.
    'conforms': 'conformsTo',
    'matches': 'isMatch',
    'property': 'get',
    // Ramda aliases.
    '__': 'placeholder',
    'F': 'stubFalse',
    'T': 'stubTrue',
    'all': 'every',
    'allPass': 'overEvery',
    'always': 'constant',
    'any': 'some',
    'anyPass': 'overSome',
    'apply': 'spread',
    'assoc': 'set',
    'assocPath': 'set',
    'complement': 'negate',
    'compose': 'flowRight',
    'contains': 'includes',
    'dissoc': 'unset',
    'dissocPath': 'unset',
    'dropLast': 'dropRight',
    'dropLastWhile': 'dropRightWhile',
    'equals': 'isEqual',
    'identical': 'eq',
    'indexBy': 'keyBy',
    'init': 'initial',
    'invertObj': 'invert',
    'juxt': 'over',
    'omitAll': 'omit',
    'nAry': 'ary',
    'path': 'get',
    'pathEq': 'matchesProperty',
    'pathOr': 'getOr',
    'paths': 'at',
    'pickAll': 'pick',
    'pipe': 'flow',
    'pluck': 'map',
    'prop': 'get',
    'propEq': 'matchesProperty',
    'propOr': 'getOr',
    'props': 'at',
    'symmetricDifference': 'xor',
    'symmetricDifferenceBy': 'xorBy',
    'symmetricDifferenceWith': 'xorWith',
    'takeLast': 'takeRight',
    'takeLastWhile': 'takeRightWhile',
    'unapply': 'rest',
    'unnest': 'flatten',
    'useWith': 'overArgs',
    'where': 'conformsTo',
    'whereEq': 'isMatch',
    'zipObj': 'zipObject'
};
$5eea7e08a1db1590$export$85c665b4d7da9cb4 = {
    '1': [
        'assignAll',
        'assignInAll',
        'attempt',
        'castArray',
        'ceil',
        'create',
        'curry',
        'curryRight',
        'defaultsAll',
        'defaultsDeepAll',
        'floor',
        'flow',
        'flowRight',
        'fromPairs',
        'invert',
        'iteratee',
        'memoize',
        'method',
        'mergeAll',
        'methodOf',
        'mixin',
        'nthArg',
        'over',
        'overEvery',
        'overSome',
        'rest',
        'reverse',
        'round',
        'runInContext',
        'spread',
        'template',
        'trim',
        'trimEnd',
        'trimStart',
        'uniqueId',
        'words',
        'zipAll'
    ],
    '2': [
        'add',
        'after',
        'ary',
        'assign',
        'assignAllWith',
        'assignIn',
        'assignInAllWith',
        'at',
        'before',
        'bind',
        'bindAll',
        'bindKey',
        'chunk',
        'cloneDeepWith',
        'cloneWith',
        'concat',
        'conformsTo',
        'countBy',
        'curryN',
        'curryRightN',
        'debounce',
        'defaults',
        'defaultsDeep',
        'defaultTo',
        'delay',
        'difference',
        'divide',
        'drop',
        'dropRight',
        'dropRightWhile',
        'dropWhile',
        'endsWith',
        'eq',
        'every',
        'filter',
        'find',
        'findIndex',
        'findKey',
        'findLast',
        'findLastIndex',
        'findLastKey',
        'flatMap',
        'flatMapDeep',
        'flattenDepth',
        'forEach',
        'forEachRight',
        'forIn',
        'forInRight',
        'forOwn',
        'forOwnRight',
        'get',
        'groupBy',
        'gt',
        'gte',
        'has',
        'hasIn',
        'includes',
        'indexOf',
        'intersection',
        'invertBy',
        'invoke',
        'invokeMap',
        'isEqual',
        'isMatch',
        'join',
        'keyBy',
        'lastIndexOf',
        'lt',
        'lte',
        'map',
        'mapKeys',
        'mapValues',
        'matchesProperty',
        'maxBy',
        'meanBy',
        'merge',
        'mergeAllWith',
        'minBy',
        'multiply',
        'nth',
        'omit',
        'omitBy',
        'overArgs',
        'pad',
        'padEnd',
        'padStart',
        'parseInt',
        'partial',
        'partialRight',
        'partition',
        'pick',
        'pickBy',
        'propertyOf',
        'pull',
        'pullAll',
        'pullAt',
        'random',
        'range',
        'rangeRight',
        'rearg',
        'reject',
        'remove',
        'repeat',
        'restFrom',
        'result',
        'sampleSize',
        'some',
        'sortBy',
        'sortedIndex',
        'sortedIndexOf',
        'sortedLastIndex',
        'sortedLastIndexOf',
        'sortedUniqBy',
        'split',
        'spreadFrom',
        'startsWith',
        'subtract',
        'sumBy',
        'take',
        'takeRight',
        'takeRightWhile',
        'takeWhile',
        'tap',
        'throttle',
        'thru',
        'times',
        'trimChars',
        'trimCharsEnd',
        'trimCharsStart',
        'truncate',
        'union',
        'uniqBy',
        'uniqWith',
        'unset',
        'unzipWith',
        'without',
        'wrap',
        'xor',
        'zip',
        'zipObject',
        'zipObjectDeep'
    ],
    '3': [
        'assignInWith',
        'assignWith',
        'clamp',
        'differenceBy',
        'differenceWith',
        'findFrom',
        'findIndexFrom',
        'findLastFrom',
        'findLastIndexFrom',
        'getOr',
        'includesFrom',
        'indexOfFrom',
        'inRange',
        'intersectionBy',
        'intersectionWith',
        'invokeArgs',
        'invokeArgsMap',
        'isEqualWith',
        'isMatchWith',
        'flatMapDepth',
        'lastIndexOfFrom',
        'mergeWith',
        'orderBy',
        'padChars',
        'padCharsEnd',
        'padCharsStart',
        'pullAllBy',
        'pullAllWith',
        'rangeStep',
        'rangeStepRight',
        'reduce',
        'reduceRight',
        'replace',
        'set',
        'slice',
        'sortedIndexBy',
        'sortedLastIndexBy',
        'transform',
        'unionBy',
        'unionWith',
        'update',
        'xorBy',
        'xorWith',
        'zipWith'
    ],
    '4': [
        'fill',
        'setWith',
        'updateWith'
    ]
};
$5eea7e08a1db1590$export$42564e045b285e32 = {
    '2': [
        1,
        0
    ],
    '3': [
        2,
        0,
        1
    ],
    '4': [
        3,
        2,
        0,
        1
    ]
};
$5eea7e08a1db1590$export$81e17196e6a22b07 = {
    'dropRightWhile': 1,
    'dropWhile': 1,
    'every': 1,
    'filter': 1,
    'find': 1,
    'findFrom': 1,
    'findIndex': 1,
    'findIndexFrom': 1,
    'findKey': 1,
    'findLast': 1,
    'findLastFrom': 1,
    'findLastIndex': 1,
    'findLastIndexFrom': 1,
    'findLastKey': 1,
    'flatMap': 1,
    'flatMapDeep': 1,
    'flatMapDepth': 1,
    'forEach': 1,
    'forEachRight': 1,
    'forIn': 1,
    'forInRight': 1,
    'forOwn': 1,
    'forOwnRight': 1,
    'map': 1,
    'mapKeys': 1,
    'mapValues': 1,
    'partition': 1,
    'reduce': 2,
    'reduceRight': 2,
    'reject': 1,
    'remove': 1,
    'some': 1,
    'takeRightWhile': 1,
    'takeWhile': 1,
    'times': 1,
    'transform': 2
};
$5eea7e08a1db1590$export$30975ceb42167ebd = {
    'mapKeys': [
        1
    ],
    'reduceRight': [
        1,
        0
    ]
};
$5eea7e08a1db1590$export$8ceb0ad7e94d3801 = {
    'assignInAllWith': [
        1,
        0
    ],
    'assignInWith': [
        1,
        2,
        0
    ],
    'assignAllWith': [
        1,
        0
    ],
    'assignWith': [
        1,
        2,
        0
    ],
    'differenceBy': [
        1,
        2,
        0
    ],
    'differenceWith': [
        1,
        2,
        0
    ],
    'getOr': [
        2,
        1,
        0
    ],
    'intersectionBy': [
        1,
        2,
        0
    ],
    'intersectionWith': [
        1,
        2,
        0
    ],
    'isEqualWith': [
        1,
        2,
        0
    ],
    'isMatchWith': [
        2,
        1,
        0
    ],
    'mergeAllWith': [
        1,
        0
    ],
    'mergeWith': [
        1,
        2,
        0
    ],
    'padChars': [
        2,
        1,
        0
    ],
    'padCharsEnd': [
        2,
        1,
        0
    ],
    'padCharsStart': [
        2,
        1,
        0
    ],
    'pullAllBy': [
        2,
        1,
        0
    ],
    'pullAllWith': [
        2,
        1,
        0
    ],
    'rangeStep': [
        1,
        2,
        0
    ],
    'rangeStepRight': [
        1,
        2,
        0
    ],
    'setWith': [
        3,
        1,
        2,
        0
    ],
    'sortedIndexBy': [
        2,
        1,
        0
    ],
    'sortedLastIndexBy': [
        2,
        1,
        0
    ],
    'unionBy': [
        1,
        2,
        0
    ],
    'unionWith': [
        1,
        2,
        0
    ],
    'updateWith': [
        3,
        1,
        2,
        0
    ],
    'xorBy': [
        1,
        2,
        0
    ],
    'xorWith': [
        1,
        2,
        0
    ],
    'zipWith': [
        1,
        2,
        0
    ]
};
$5eea7e08a1db1590$export$fbaeb3f87df3cf26 = {
    'assignAll': {
        'start': 0
    },
    'assignAllWith': {
        'start': 0
    },
    'assignInAll': {
        'start': 0
    },
    'assignInAllWith': {
        'start': 0
    },
    'defaultsAll': {
        'start': 0
    },
    'defaultsDeepAll': {
        'start': 0
    },
    'invokeArgs': {
        'start': 2
    },
    'invokeArgsMap': {
        'start': 2
    },
    'mergeAll': {
        'start': 0
    },
    'mergeAllWith': {
        'start': 0
    },
    'partial': {
        'start': 1
    },
    'partialRight': {
        'start': 1
    },
    'without': {
        'start': 1
    },
    'zipAll': {
        'start': 0
    }
};
$5eea7e08a1db1590$export$57e795267c26e600 = {
    'array': {
        'fill': true,
        'pull': true,
        'pullAll': true,
        'pullAllBy': true,
        'pullAllWith': true,
        'pullAt': true,
        'remove': true,
        'reverse': true
    },
    'object': {
        'assign': true,
        'assignAll': true,
        'assignAllWith': true,
        'assignIn': true,
        'assignInAll': true,
        'assignInAllWith': true,
        'assignInWith': true,
        'assignWith': true,
        'defaults': true,
        'defaultsAll': true,
        'defaultsDeep': true,
        'defaultsDeepAll': true,
        'merge': true,
        'mergeAll': true,
        'mergeAllWith': true,
        'mergeWith': true
    },
    'set': {
        'set': true,
        'setWith': true,
        'unset': true,
        'update': true,
        'updateWith': true
    }
};
$5eea7e08a1db1590$export$1eb71a7e27943e71 = function() {
    var hasOwnProperty = Object.prototype.hasOwnProperty, object = $5eea7e08a1db1590$export$bd0f5e6e44efa6b4, result = {};
    for(var key in object){
        var value = object[key];
        if (hasOwnProperty.call(result, value)) result[value].push(key);
        else result[value] = [
            key
        ];
    }
    return result;
}();
$5eea7e08a1db1590$export$aee1dbae5de2db9d = {
    'assignAll': 'assign',
    'assignAllWith': 'assignWith',
    'assignInAll': 'assignIn',
    'assignInAllWith': 'assignInWith',
    'curryN': 'curry',
    'curryRightN': 'curryRight',
    'defaultsAll': 'defaults',
    'defaultsDeepAll': 'defaultsDeep',
    'findFrom': 'find',
    'findIndexFrom': 'findIndex',
    'findLastFrom': 'findLast',
    'findLastIndexFrom': 'findLastIndex',
    'getOr': 'get',
    'includesFrom': 'includes',
    'indexOfFrom': 'indexOf',
    'invokeArgs': 'invoke',
    'invokeArgsMap': 'invokeMap',
    'lastIndexOfFrom': 'lastIndexOf',
    'mergeAll': 'merge',
    'mergeAllWith': 'mergeWith',
    'padChars': 'pad',
    'padCharsEnd': 'padEnd',
    'padCharsStart': 'padStart',
    'propertyOf': 'get',
    'rangeStep': 'range',
    'rangeStepRight': 'rangeRight',
    'restFrom': 'rest',
    'spreadFrom': 'spread',
    'trimChars': 'trim',
    'trimCharsEnd': 'trimEnd',
    'trimCharsStart': 'trimStart',
    'zipAll': 'zip'
};
$5eea7e08a1db1590$export$87ffbe4821a5d5e0 = {
    'castArray': true,
    'flow': true,
    'flowRight': true,
    'iteratee': true,
    'mixin': true,
    'rearg': true,
    'runInContext': true
};
$5eea7e08a1db1590$export$b4d07413ce528c90 = {
    'add': true,
    'assign': true,
    'assignIn': true,
    'bind': true,
    'bindKey': true,
    'concat': true,
    'difference': true,
    'divide': true,
    'eq': true,
    'gt': true,
    'gte': true,
    'isEqual': true,
    'lt': true,
    'lte': true,
    'matchesProperty': true,
    'merge': true,
    'multiply': true,
    'overArgs': true,
    'partial': true,
    'partialRight': true,
    'propertyOf': true,
    'random': true,
    'range': true,
    'rangeRight': true,
    'subtract': true,
    'zip': true,
    'zipObject': true,
    'zipObjectDeep': true
};

});

parcelRegister("l6Yg9", function(module, exports) {
/**
 * The default argument placeholder value for methods.
 *
 * @type {Object}
 */ module.exports = {};

});


parcelRegister("a02m0", function(module, exports) {














module.exports = {
    'ary': (parcelRequire("iX5mF")),
    'assign': (parcelRequire("k1JQY")),
    'clone': (parcelRequire("E0NNP")),
    'curry': (parcelRequire("cleLA")),
    'forEach': (parcelRequire("9Kzih")),
    'isArray': (parcelRequire("1c8hB")),
    'isError': (parcelRequire("dbogu")),
    'isFunction': (parcelRequire("eoCgY")),
    'isWeakMap': (parcelRequire("a1CHL")),
    'iteratee': (parcelRequire("akHxB")),
    'keys': (parcelRequire("fCpZe")),
    'rearg': (parcelRequire("k5dRT")),
    'toInteger': (parcelRequire("hNahz")),
    'toPath': (parcelRequire("d0KBl"))
};

});
parcelRegister("iX5mF", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");
/** Used to compose bitmasks for function metadata. */ var $dcc1e600da485164$var$WRAP_ARY_FLAG = 128;
/**
 * Creates a function that invokes `func`, with up to `n` arguments,
 * ignoring any additional arguments.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to cap arguments for.
 * @param {number} [n=func.length] The arity cap.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new capped function.
 * @example
 *
 * _.map(['6', '8', '10'], _.ary(parseInt, 1));
 * // => [6, 8, 10]
 */ function $dcc1e600da485164$var$ary(func, n, guard) {
    n = guard ? undefined : n;
    n = func && n == null ? func.length : n;
    return $xQ3hV(func, $dcc1e600da485164$var$WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
}
module.exports = $dcc1e600da485164$var$ary;

});
parcelRegister("xQ3hV", function(module, exports) {

var $2n5KA = parcelRequire("2n5KA");

var $ajgvA = parcelRequire("ajgvA");

var $4sFI9 = parcelRequire("4sFI9");

var $dJxZV = parcelRequire("dJxZV");

var $3slGh = parcelRequire("3slGh");

var $6bTTb = parcelRequire("6bTTb");

var $fHM5F = parcelRequire("fHM5F");

var $bV9co = parcelRequire("bV9co");

var $3mXyn = parcelRequire("3mXyn");

var $hNahz = parcelRequire("hNahz");
/** Error message constants. */ var $065b75a1a2ef24b3$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used to compose bitmasks for function metadata. */ var $065b75a1a2ef24b3$var$WRAP_BIND_FLAG = 1, $065b75a1a2ef24b3$var$WRAP_BIND_KEY_FLAG = 2, $065b75a1a2ef24b3$var$WRAP_CURRY_FLAG = 8, $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG = 16, $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG = 32, $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $065b75a1a2ef24b3$var$nativeMax = Math.max;
/**
 * Creates a function that either curries or invokes `func` with optional
 * `this` binding and partially applied arguments.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags.
 *    1 - `_.bind`
 *    2 - `_.bindKey`
 *    4 - `_.curry` or `_.curryRight` of a bound function
 *    8 - `_.curry`
 *   16 - `_.curryRight`
 *   32 - `_.partial`
 *   64 - `_.partialRight`
 *  128 - `_.rearg`
 *  256 - `_.ary`
 *  512 - `_.flip`
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to be partially applied.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $065b75a1a2ef24b3$var$createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
    var isBindKey = bitmask & $065b75a1a2ef24b3$var$WRAP_BIND_KEY_FLAG;
    if (!isBindKey && typeof func != 'function') throw new TypeError($065b75a1a2ef24b3$var$FUNC_ERROR_TEXT);
    var length = partials ? partials.length : 0;
    if (!length) {
        bitmask &= ~($065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG | $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
    }
    ary = ary === undefined ? ary : $065b75a1a2ef24b3$var$nativeMax($hNahz(ary), 0);
    arity = arity === undefined ? arity : $hNahz(arity);
    length -= holders ? holders.length : 0;
    if (bitmask & $065b75a1a2ef24b3$var$WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials, holdersRight = holders;
        partials = holders = undefined;
    }
    var data = isBindKey ? undefined : $6bTTb(func);
    var newData = [
        func,
        bitmask,
        thisArg,
        partials,
        holders,
        partialsRight,
        holdersRight,
        argPos,
        ary,
        arity
    ];
    if (data) $fHM5F(newData, data);
    func = newData[0];
    bitmask = newData[1];
    thisArg = newData[2];
    partials = newData[3];
    holders = newData[4];
    arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : $065b75a1a2ef24b3$var$nativeMax(newData[9] - length, 0);
    if (!arity && bitmask & ($065b75a1a2ef24b3$var$WRAP_CURRY_FLAG | $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG)) bitmask &= ~($065b75a1a2ef24b3$var$WRAP_CURRY_FLAG | $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG);
    if (!bitmask || bitmask == $065b75a1a2ef24b3$var$WRAP_BIND_FLAG) var result = $ajgvA(func, bitmask, thisArg);
    else if (bitmask == $065b75a1a2ef24b3$var$WRAP_CURRY_FLAG || bitmask == $065b75a1a2ef24b3$var$WRAP_CURRY_RIGHT_FLAG) result = $4sFI9(func, bitmask, arity);
    else if ((bitmask == $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG || bitmask == ($065b75a1a2ef24b3$var$WRAP_BIND_FLAG | $065b75a1a2ef24b3$var$WRAP_PARTIAL_FLAG)) && !holders.length) result = $3slGh(func, bitmask, thisArg, partials);
    else result = $dJxZV.apply(undefined, newData);
    var setter = data ? $2n5KA : $bV9co;
    return $3mXyn(setter(result, newData), func, bitmask);
}
module.exports = $065b75a1a2ef24b3$var$createWrap;

});
parcelRegister("2n5KA", function(module, exports) {

var $3QMTK = parcelRequire("3QMTK");

var $beYtW = parcelRequire("beYtW");
/**
 * The base implementation of `setData` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $1ba230a38b363991$var$baseSetData = !$beYtW ? $3QMTK : function(func, data) {
    $beYtW.set(func, data);
    return func;
};
module.exports = $1ba230a38b363991$var$baseSetData;

});

parcelRegister("ajgvA", function(module, exports) {

var $4ptXN = parcelRequire("4ptXN");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $78187bf3ce07aa33$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the optional `this`
 * binding of `thisArg`.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $78187bf3ce07aa33$var$createBind(func, bitmask, thisArg) {
    var isBind = bitmask & $78187bf3ce07aa33$var$WRAP_BIND_FLAG, Ctor = $4ptXN(func);
    function wrapper() {
        var fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
    }
    return wrapper;
}
module.exports = $78187bf3ce07aa33$var$createBind;

});
parcelRegister("4ptXN", function(module, exports) {

var $9F9XB = parcelRequire("9F9XB");

var $feGjZ = parcelRequire("feGjZ");
/**
 * Creates a function that produces an instance of `Ctor` regardless of
 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
 *
 * @private
 * @param {Function} Ctor The constructor to wrap.
 * @returns {Function} Returns the new wrapped function.
 */ function $3360bd57e2c33b86$var$createCtor(Ctor) {
    return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch(args.length){
            case 0:
                return new Ctor;
            case 1:
                return new Ctor(args[0]);
            case 2:
                return new Ctor(args[0], args[1]);
            case 3:
                return new Ctor(args[0], args[1], args[2]);
            case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
            case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
            case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
            case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = $9F9XB(Ctor.prototype), result = Ctor.apply(thisBinding, args);
        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return $feGjZ(result) ? result : thisBinding;
    };
}
module.exports = $3360bd57e2c33b86$var$createCtor;

});


parcelRegister("4sFI9", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $4ptXN = parcelRequire("4ptXN");

var $dJxZV = parcelRequire("dJxZV");

var $lOKcz = parcelRequire("lOKcz");

var $9xQzO = parcelRequire("9xQzO");

var $kBgrU = parcelRequire("kBgrU");

var $c1MCs = parcelRequire("c1MCs");
/**
 * Creates a function that wraps `func` to enable currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {number} arity The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $33fa21eee8bcca6f$var$createCurry(func, bitmask, arity) {
    var Ctor = $4ptXN(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length, placeholder = $9xQzO(wrapper);
        while(index--)args[index] = arguments[index];
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : $kBgrU(args, placeholder);
        length -= holders.length;
        if (length < arity) return $lOKcz(func, bitmask, $dJxZV, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        var fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        return $5VdlS(fn, this, args);
    }
    return wrapper;
}
module.exports = $33fa21eee8bcca6f$var$createCurry;

});
parcelRegister("dJxZV", function(module, exports) {

var $98OfC = parcelRequire("98OfC");

var $aoNSM = parcelRequire("aoNSM");

var $24kQN = parcelRequire("24kQN");

var $4ptXN = parcelRequire("4ptXN");

var $lOKcz = parcelRequire("lOKcz");

var $9xQzO = parcelRequire("9xQzO");

var $jtjhF = parcelRequire("jtjhF");

var $kBgrU = parcelRequire("kBgrU");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $9ff9d999ee3e5b26$var$WRAP_BIND_FLAG = 1, $9ff9d999ee3e5b26$var$WRAP_BIND_KEY_FLAG = 2, $9ff9d999ee3e5b26$var$WRAP_CURRY_FLAG = 8, $9ff9d999ee3e5b26$var$WRAP_CURRY_RIGHT_FLAG = 16, $9ff9d999ee3e5b26$var$WRAP_ARY_FLAG = 128, $9ff9d999ee3e5b26$var$WRAP_FLIP_FLAG = 512;
/**
 * Creates a function that wraps `func` to invoke it with optional `this`
 * binding of `thisArg`, partial application, and currying.
 *
 * @private
 * @param {Function|string} func The function or method name to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [partialsRight] The arguments to append to those provided
 *  to the new function.
 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $9ff9d999ee3e5b26$var$createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
    var isAry = bitmask & $9ff9d999ee3e5b26$var$WRAP_ARY_FLAG, isBind = bitmask & $9ff9d999ee3e5b26$var$WRAP_BIND_FLAG, isBindKey = bitmask & $9ff9d999ee3e5b26$var$WRAP_BIND_KEY_FLAG, isCurried = bitmask & ($9ff9d999ee3e5b26$var$WRAP_CURRY_FLAG | $9ff9d999ee3e5b26$var$WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & $9ff9d999ee3e5b26$var$WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined : $4ptXN(func);
    function wrapper() {
        var length = arguments.length, args = Array(length), index = length;
        while(index--)args[index] = arguments[index];
        if (isCurried) var placeholder = $9xQzO(wrapper), holdersCount = $24kQN(args, placeholder);
        if (partials) args = $98OfC(args, partials, holders, isCurried);
        if (partialsRight) args = $aoNSM(args, partialsRight, holdersRight, isCurried);
        length -= holdersCount;
        if (isCurried && length < arity) {
            var newHolders = $kBgrU(args, placeholder);
            return $lOKcz(func, bitmask, $9ff9d999ee3e5b26$var$createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) args = $jtjhF(args, argPos);
        else if (isFlip && length > 1) args.reverse();
        if (isAry && ary < length) args.length = ary;
        if (this && this !== $c1MCs && this instanceof wrapper) fn = Ctor || $4ptXN(fn);
        return fn.apply(thisBinding, args);
    }
    return wrapper;
}
module.exports = $9ff9d999ee3e5b26$var$createHybrid;

});
parcelRegister("98OfC", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6a7bd72e71453dbc$var$nativeMax = Math.max;
/**
 * Creates an array that is the composition of partially applied arguments,
 * placeholders, and provided arguments into a single array of arguments.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to prepend to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $6a7bd72e71453dbc$var$composeArgs(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = $6a7bd72e71453dbc$var$nativeMax(argsLength - holdersLength, 0), result = Array(leftLength + rangeLength), isUncurried = !isCurried;
    while(++leftIndex < leftLength)result[leftIndex] = partials[leftIndex];
    while(++argsIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[holders[argsIndex]] = args[argsIndex];
    while(rangeLength--)result[leftIndex++] = args[argsIndex++];
    return result;
}
module.exports = $6a7bd72e71453dbc$var$composeArgs;

});

parcelRegister("aoNSM", function(module, exports) {
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7922d6e81726c41f$var$nativeMax = Math.max;
/**
 * This function is like `composeArgs` except that the arguments composition
 * is tailored for `_.partialRight`.
 *
 * @private
 * @param {Array} args The provided arguments.
 * @param {Array} partials The arguments to append to those provided.
 * @param {Array} holders The `partials` placeholder indexes.
 * @params {boolean} [isCurried] Specify composing for a curried function.
 * @returns {Array} Returns the new array of composed arguments.
 */ function $7922d6e81726c41f$var$composeArgsRight(args, partials, holders, isCurried) {
    var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = $7922d6e81726c41f$var$nativeMax(argsLength - holdersLength, 0), result = Array(rangeLength + rightLength), isUncurried = !isCurried;
    while(++argsIndex < rangeLength)result[argsIndex] = args[argsIndex];
    var offset = argsIndex;
    while(++rightIndex < rightLength)result[offset + rightIndex] = partials[rightIndex];
    while(++holdersIndex < holdersLength)if (isUncurried || argsIndex < argsLength) result[offset + holders[holdersIndex]] = args[argsIndex++];
    return result;
}
module.exports = $7922d6e81726c41f$var$composeArgsRight;

});

parcelRegister("24kQN", function(module, exports) {
/**
 * Gets the number of `placeholder` occurrences in `array`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} placeholder The placeholder to search for.
 * @returns {number} Returns the placeholder count.
 */ function $181c20ffe0a73f5e$var$countHolders(array, placeholder) {
    var length = array.length, result = 0;
    while(length--)if (array[length] === placeholder) ++result;
    return result;
}
module.exports = $181c20ffe0a73f5e$var$countHolders;

});

parcelRegister("lOKcz", function(module, exports) {

var $cp9gS = parcelRequire("cp9gS");

var $bV9co = parcelRequire("bV9co");

var $3mXyn = parcelRequire("3mXyn");
/** Used to compose bitmasks for function metadata. */ var $fe221b32db6745a2$var$WRAP_BIND_FLAG = 1, $fe221b32db6745a2$var$WRAP_BIND_KEY_FLAG = 2, $fe221b32db6745a2$var$WRAP_CURRY_BOUND_FLAG = 4, $fe221b32db6745a2$var$WRAP_CURRY_FLAG = 8, $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG = 32, $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG = 64;
/**
 * Creates a function that wraps `func` to continue currying.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {Function} wrapFunc The function to create the `func` wrapper.
 * @param {*} placeholder The placeholder value.
 * @param {*} [thisArg] The `this` binding of `func`.
 * @param {Array} [partials] The arguments to prepend to those provided to
 *  the new function.
 * @param {Array} [holders] The `partials` placeholder indexes.
 * @param {Array} [argPos] The argument positions of the new function.
 * @param {number} [ary] The arity cap of `func`.
 * @param {number} [arity] The arity of `func`.
 * @returns {Function} Returns the new wrapped function.
 */ function $fe221b32db6745a2$var$createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
    var isCurry = bitmask & $fe221b32db6745a2$var$WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined, newHoldersRight = isCurry ? undefined : holders, newPartials = isCurry ? partials : undefined, newPartialsRight = isCurry ? undefined : partials;
    bitmask |= isCurry ? $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG : $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG;
    bitmask &= ~(isCurry ? $fe221b32db6745a2$var$WRAP_PARTIAL_RIGHT_FLAG : $fe221b32db6745a2$var$WRAP_PARTIAL_FLAG);
    if (!(bitmask & $fe221b32db6745a2$var$WRAP_CURRY_BOUND_FLAG)) bitmask &= ~($fe221b32db6745a2$var$WRAP_BIND_FLAG | $fe221b32db6745a2$var$WRAP_BIND_KEY_FLAG);
    var newData = [
        func,
        bitmask,
        thisArg,
        newPartials,
        newHolders,
        newPartialsRight,
        newHoldersRight,
        argPos,
        ary,
        arity
    ];
    var result = wrapFunc.apply(undefined, newData);
    if ($cp9gS(func)) $bV9co(result, newData);
    result.placeholder = placeholder;
    return $3mXyn(result, func, bitmask);
}
module.exports = $fe221b32db6745a2$var$createRecurry;

});
parcelRegister("bV9co", function(module, exports) {

var $2n5KA = parcelRequire("2n5KA");

var $d1V3m = parcelRequire("d1V3m");
/**
 * Sets metadata for `func`.
 *
 * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
 * period of time, it will trip its breaker and transition to an identity
 * function to avoid garbage collection pauses in V8. See
 * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
 * for more details.
 *
 * @private
 * @param {Function} func The function to associate metadata with.
 * @param {*} data The metadata.
 * @returns {Function} Returns `func`.
 */ var $8adc2746a2aa5eeb$var$setData = $d1V3m($2n5KA);
module.exports = $8adc2746a2aa5eeb$var$setData;

});

parcelRegister("3mXyn", function(module, exports) {

var $4pgZb = parcelRequire("4pgZb");

var $1k0ou = parcelRequire("1k0ou");

var $ly0Gc = parcelRequire("ly0Gc");

var $7YePn = parcelRequire("7YePn");
/**
 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
 * with wrapper details in a comment at the top of the source body.
 *
 * @private
 * @param {Function} wrapper The function to modify.
 * @param {Function} reference The reference function.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Function} Returns `wrapper`.
 */ function $27419f3ed4dc5d4c$var$setWrapToString(wrapper, reference, bitmask) {
    var source = reference + '';
    return $ly0Gc(wrapper, $1k0ou(source, $7YePn($4pgZb(source), bitmask)));
}
module.exports = $27419f3ed4dc5d4c$var$setWrapToString;

});
parcelRegister("4pgZb", function(module, exports) {
/** Used to match wrap detail comments. */ var $3356ac43c54e635f$var$reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, $3356ac43c54e635f$var$reSplitDetails = /,? & /;
/**
 * Extracts wrapper details from the `source` body comment.
 *
 * @private
 * @param {string} source The source to inspect.
 * @returns {Array} Returns the wrapper details.
 */ function $3356ac43c54e635f$var$getWrapDetails(source) {
    var match = source.match($3356ac43c54e635f$var$reWrapDetails);
    return match ? match[1].split($3356ac43c54e635f$var$reSplitDetails) : [];
}
module.exports = $3356ac43c54e635f$var$getWrapDetails;

});

parcelRegister("1k0ou", function(module, exports) {
/** Used to match wrap detail comments. */ var $0f67f6f702bebdca$var$reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/;
/**
 * Inserts wrapper `details` in a comment at the top of the `source` body.
 *
 * @private
 * @param {string} source The source to modify.
 * @returns {Array} details The details to insert.
 * @returns {string} Returns the modified source.
 */ function $0f67f6f702bebdca$var$insertWrapDetails(source, details) {
    var length = details.length;
    if (!length) return source;
    var lastIndex = length - 1;
    details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
    details = details.join(length > 2 ? ', ' : ' ');
    return source.replace($0f67f6f702bebdca$var$reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
}
module.exports = $0f67f6f702bebdca$var$insertWrapDetails;

});

parcelRegister("7YePn", function(module, exports) {

var $9Kzih = parcelRequire("9Kzih");

var $lqZWH = parcelRequire("lqZWH");
/** Used to compose bitmasks for function metadata. */ var $5cd9a37742eb8774$var$WRAP_BIND_FLAG = 1, $5cd9a37742eb8774$var$WRAP_BIND_KEY_FLAG = 2, $5cd9a37742eb8774$var$WRAP_CURRY_FLAG = 8, $5cd9a37742eb8774$var$WRAP_CURRY_RIGHT_FLAG = 16, $5cd9a37742eb8774$var$WRAP_PARTIAL_FLAG = 32, $5cd9a37742eb8774$var$WRAP_PARTIAL_RIGHT_FLAG = 64, $5cd9a37742eb8774$var$WRAP_ARY_FLAG = 128, $5cd9a37742eb8774$var$WRAP_REARG_FLAG = 256, $5cd9a37742eb8774$var$WRAP_FLIP_FLAG = 512;
/** Used to associate wrap methods with their bit flags. */ var $5cd9a37742eb8774$var$wrapFlags = [
    [
        'ary',
        $5cd9a37742eb8774$var$WRAP_ARY_FLAG
    ],
    [
        'bind',
        $5cd9a37742eb8774$var$WRAP_BIND_FLAG
    ],
    [
        'bindKey',
        $5cd9a37742eb8774$var$WRAP_BIND_KEY_FLAG
    ],
    [
        'curry',
        $5cd9a37742eb8774$var$WRAP_CURRY_FLAG
    ],
    [
        'curryRight',
        $5cd9a37742eb8774$var$WRAP_CURRY_RIGHT_FLAG
    ],
    [
        'flip',
        $5cd9a37742eb8774$var$WRAP_FLIP_FLAG
    ],
    [
        'partial',
        $5cd9a37742eb8774$var$WRAP_PARTIAL_FLAG
    ],
    [
        'partialRight',
        $5cd9a37742eb8774$var$WRAP_PARTIAL_RIGHT_FLAG
    ],
    [
        'rearg',
        $5cd9a37742eb8774$var$WRAP_REARG_FLAG
    ]
];
/**
 * Updates wrapper `details` based on `bitmask` flags.
 *
 * @private
 * @returns {Array} details The details to modify.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @returns {Array} Returns `details`.
 */ function $5cd9a37742eb8774$var$updateWrapDetails(details, bitmask) {
    $9Kzih($5cd9a37742eb8774$var$wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !$lqZWH(details, value)) details.push(value);
    });
    return details.sort();
}
module.exports = $5cd9a37742eb8774$var$updateWrapDetails;

});



parcelRegister("9xQzO", function(module, exports) {
/**
 * Gets the argument placeholder value for `func`.
 *
 * @private
 * @param {Function} func The function to inspect.
 * @returns {*} Returns the placeholder value.
 */ function $6f2ffabf17208972$var$getHolder(func) {
    var object = func;
    return object.placeholder;
}
module.exports = $6f2ffabf17208972$var$getHolder;

});

parcelRegister("jtjhF", function(module, exports) {

var $b69Sx = parcelRequire("b69Sx");

var $3hFfZ = parcelRequire("3hFfZ");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $e2cfaf2379d6eef4$var$nativeMin = Math.min;
/**
 * Reorder `array` according to the specified indexes where the element at
 * the first index is assigned as the first element, the element at
 * the second index is assigned as the second element, and so on.
 *
 * @private
 * @param {Array} array The array to reorder.
 * @param {Array} indexes The arranged array indexes.
 * @returns {Array} Returns `array`.
 */ function $e2cfaf2379d6eef4$var$reorder(array, indexes) {
    var arrLength = array.length, length = $e2cfaf2379d6eef4$var$nativeMin(indexes.length, arrLength), oldArray = $b69Sx(array);
    while(length--){
        var index = indexes[length];
        array[length] = $3hFfZ(index, arrLength) ? oldArray[index] : undefined;
    }
    return array;
}
module.exports = $e2cfaf2379d6eef4$var$reorder;

});

parcelRegister("kBgrU", function(module, exports) {
/** Used as the internal argument placeholder. */ var $eff405cccdf3a041$var$PLACEHOLDER = '__lodash_placeholder__';
/**
 * Replaces all `placeholder` elements in `array` with an internal placeholder
 * and returns an array of their indexes.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {*} placeholder The placeholder to replace.
 * @returns {Array} Returns the new array of placeholder indexes.
 */ function $eff405cccdf3a041$var$replaceHolders(array, placeholder) {
    var index = -1, length = array.length, resIndex = 0, result = [];
    while(++index < length){
        var value = array[index];
        if (value === placeholder || value === $eff405cccdf3a041$var$PLACEHOLDER) {
            array[index] = $eff405cccdf3a041$var$PLACEHOLDER;
            result[resIndex++] = index;
        }
    }
    return result;
}
module.exports = $eff405cccdf3a041$var$replaceHolders;

});



parcelRegister("3slGh", function(module, exports) {

var $5VdlS = parcelRequire("5VdlS");

var $4ptXN = parcelRequire("4ptXN");

var $c1MCs = parcelRequire("c1MCs");
/** Used to compose bitmasks for function metadata. */ var $2844ce06b6725f7d$var$WRAP_BIND_FLAG = 1;
/**
 * Creates a function that wraps `func` to invoke it with the `this` binding
 * of `thisArg` and `partials` prepended to the arguments it receives.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} partials The arguments to prepend to those provided to
 *  the new function.
 * @returns {Function} Returns the new wrapped function.
 */ function $2844ce06b6725f7d$var$createPartial(func, bitmask, thisArg, partials) {
    var isBind = bitmask & $2844ce06b6725f7d$var$WRAP_BIND_FLAG, Ctor = $4ptXN(func);
    function wrapper() {
        var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array(leftLength + argsLength), fn = this && this !== $c1MCs && this instanceof wrapper ? Ctor : func;
        while(++leftIndex < leftLength)args[leftIndex] = partials[leftIndex];
        while(argsLength--)args[leftIndex++] = arguments[++argsIndex];
        return $5VdlS(fn, isBind ? thisArg : this, args);
    }
    return wrapper;
}
module.exports = $2844ce06b6725f7d$var$createPartial;

});

parcelRegister("fHM5F", function(module, exports) {

var $98OfC = parcelRequire("98OfC");

var $aoNSM = parcelRequire("aoNSM");

var $kBgrU = parcelRequire("kBgrU");
/** Used as the internal argument placeholder. */ var $b6f02cf0a655a19e$var$PLACEHOLDER = '__lodash_placeholder__';
/** Used to compose bitmasks for function metadata. */ var $b6f02cf0a655a19e$var$WRAP_BIND_FLAG = 1, $b6f02cf0a655a19e$var$WRAP_BIND_KEY_FLAG = 2, $b6f02cf0a655a19e$var$WRAP_CURRY_BOUND_FLAG = 4, $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG = 8, $b6f02cf0a655a19e$var$WRAP_ARY_FLAG = 128, $b6f02cf0a655a19e$var$WRAP_REARG_FLAG = 256;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b6f02cf0a655a19e$var$nativeMin = Math.min;
/**
 * Merges the function metadata of `source` into `data`.
 *
 * Merging metadata reduces the number of wrappers used to invoke a function.
 * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
 * may be applied regardless of execution order. Methods like `_.ary` and
 * `_.rearg` modify function arguments, making the order in which they are
 * executed important, preventing the merging of metadata. However, we make
 * an exception for a safe combined case where curried functions have `_.ary`
 * and or `_.rearg` applied.
 *
 * @private
 * @param {Array} data The destination metadata.
 * @param {Array} source The source metadata.
 * @returns {Array} Returns `data`.
 */ function $b6f02cf0a655a19e$var$mergeData(data, source) {
    var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < ($b6f02cf0a655a19e$var$WRAP_BIND_FLAG | $b6f02cf0a655a19e$var$WRAP_BIND_KEY_FLAG | $b6f02cf0a655a19e$var$WRAP_ARY_FLAG);
    var isCombo = srcBitmask == $b6f02cf0a655a19e$var$WRAP_ARY_FLAG && bitmask == $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG || srcBitmask == $b6f02cf0a655a19e$var$WRAP_ARY_FLAG && bitmask == $b6f02cf0a655a19e$var$WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == ($b6f02cf0a655a19e$var$WRAP_ARY_FLAG | $b6f02cf0a655a19e$var$WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == $b6f02cf0a655a19e$var$WRAP_CURRY_FLAG;
    // Exit early if metadata can't be merged.
    if (!(isCommon || isCombo)) return data;
    // Use source `thisArg` if available.
    if (srcBitmask & $b6f02cf0a655a19e$var$WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & $b6f02cf0a655a19e$var$WRAP_BIND_FLAG ? 0 : $b6f02cf0a655a19e$var$WRAP_CURRY_BOUND_FLAG;
    }
    // Compose partial arguments.
    var value = source[3];
    if (value) {
        var partials = data[3];
        data[3] = partials ? $98OfC(partials, value, source[4]) : value;
        data[4] = partials ? $kBgrU(data[3], $b6f02cf0a655a19e$var$PLACEHOLDER) : source[4];
    }
    // Compose partial right arguments.
    value = source[5];
    if (value) {
        partials = data[5];
        data[5] = partials ? $aoNSM(partials, value, source[6]) : value;
        data[6] = partials ? $kBgrU(data[5], $b6f02cf0a655a19e$var$PLACEHOLDER) : source[6];
    }
    // Use source `argPos` if available.
    value = source[7];
    if (value) data[7] = value;
    // Use source `ary` if it's smaller.
    if (srcBitmask & $b6f02cf0a655a19e$var$WRAP_ARY_FLAG) data[8] = data[8] == null ? source[8] : $b6f02cf0a655a19e$var$nativeMin(data[8], source[8]);
    // Use source `arity` if one is not provided.
    if (data[9] == null) data[9] = source[9];
    // Use source `func` and merge bitmasks.
    data[0] = source[0];
    data[1] = newBitmask;
    return data;
}
module.exports = $b6f02cf0a655a19e$var$mergeData;

});



parcelRegister("E0NNP", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");
/** Used to compose bitmasks for cloning. */ var $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG = 4;
/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */ function $07845bdb18fff27f$var$clone(value) {
    return $ee7Ev(value, $07845bdb18fff27f$var$CLONE_SYMBOLS_FLAG);
}
module.exports = $07845bdb18fff27f$var$clone;

});

parcelRegister("cleLA", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");
/** Used to compose bitmasks for function metadata. */ var $8fc2e687045586ce$var$WRAP_CURRY_FLAG = 8;
/**
 * Creates a function that accepts arguments of `func` and either invokes
 * `func` returning its result, if at least `arity` number of arguments have
 * been provided, or returns a function that accepts the remaining `func`
 * arguments, and so on. The arity of `func` may be specified if `func.length`
 * is not sufficient.
 *
 * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for provided arguments.
 *
 * **Note:** This method doesn't set the "length" property of curried functions.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Function
 * @param {Function} func The function to curry.
 * @param {number} [arity=func.length] The arity of `func`.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Function} Returns the new curried function.
 * @example
 *
 * var abc = function(a, b, c) {
 *   return [a, b, c];
 * };
 *
 * var curried = _.curry(abc);
 *
 * curried(1)(2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2)(3);
 * // => [1, 2, 3]
 *
 * curried(1, 2, 3);
 * // => [1, 2, 3]
 *
 * // Curried with placeholders.
 * curried(1)(_, 3)(2);
 * // => [1, 2, 3]
 */ function $8fc2e687045586ce$var$curry(func, arity, guard) {
    arity = guard ? undefined : arity;
    var result = $xQ3hV(func, $8fc2e687045586ce$var$WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
    result.placeholder = $8fc2e687045586ce$var$curry.placeholder;
    return result;
}
// Assign default placeholders.
$8fc2e687045586ce$var$curry.placeholder = {};
module.exports = $8fc2e687045586ce$var$curry;

});

parcelRegister("dbogu", function(module, exports) {

var $2OY5s = parcelRequire("2OY5s");

var $hYEMs = parcelRequire("hYEMs");

var $jtsd5 = parcelRequire("jtsd5");
/** `Object#toString` result references. */ var $998f1ff604abccc1$var$domExcTag = '[object DOMException]', $998f1ff604abccc1$var$errorTag = '[object Error]';
/**
 * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
 * `SyntaxError`, `TypeError`, or `URIError` object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
 * @example
 *
 * _.isError(new Error);
 * // => true
 *
 * _.isError(Error);
 * // => false
 */ function $998f1ff604abccc1$var$isError(value) {
    if (!$hYEMs(value)) return false;
    var tag = $2OY5s(value);
    return tag == $998f1ff604abccc1$var$errorTag || tag == $998f1ff604abccc1$var$domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !$jtsd5(value);
}
module.exports = $998f1ff604abccc1$var$isError;

});

parcelRegister("a1CHL", function(module, exports) {

var $fjnSB = parcelRequire("fjnSB");

var $hYEMs = parcelRequire("hYEMs");
/** `Object#toString` result references. */ var $74c80559f18c75f2$var$weakMapTag = '[object WeakMap]';
/**
 * Checks if `value` is classified as a `WeakMap` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
 * @example
 *
 * _.isWeakMap(new WeakMap);
 * // => true
 *
 * _.isWeakMap(new Map);
 * // => false
 */ function $74c80559f18c75f2$var$isWeakMap(value) {
    return $hYEMs(value) && $fjnSB(value) == $74c80559f18c75f2$var$weakMapTag;
}
module.exports = $74c80559f18c75f2$var$isWeakMap;

});

parcelRegister("akHxB", function(module, exports) {

var $ee7Ev = parcelRequire("ee7Ev");

var $7qARj = parcelRequire("7qARj");
/** Used to compose bitmasks for cloning. */ var $785d8bf9eb54b1a7$var$CLONE_DEEP_FLAG = 1;
/**
 * Creates a function that invokes `func` with the arguments of the created
 * function. If `func` is a property name, the created function returns the
 * property value for a given element. If `func` is an array or object, the
 * created function returns `true` for elements that contain the equivalent
 * source properties, otherwise it returns `false`.
 *
 * @static
 * @since 4.0.0
 * @memberOf _
 * @category Util
 * @param {*} [func=_.identity] The value to convert to a callback.
 * @returns {Function} Returns the callback.
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
 * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, _.iteratee(['user', 'fred']));
 * // => [{ 'user': 'fred', 'age': 40 }]
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, _.iteratee('user'));
 * // => ['barney', 'fred']
 *
 * // Create custom iteratee shorthands.
 * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
 *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
 *     return func.test(string);
 *   };
 * });
 *
 * _.filter(['abc', 'def'], /ef/);
 * // => ['def']
 */ function $785d8bf9eb54b1a7$var$iteratee(func) {
    return $7qARj(typeof func == 'function' ? func : $ee7Ev(func, $785d8bf9eb54b1a7$var$CLONE_DEEP_FLAG));
}
module.exports = $785d8bf9eb54b1a7$var$iteratee;

});

parcelRegister("k5dRT", function(module, exports) {

var $xQ3hV = parcelRequire("xQ3hV");

var $224h2 = parcelRequire("224h2");
/** Used to compose bitmasks for function metadata. */ var $e9ef0836fe6d24f1$var$WRAP_REARG_FLAG = 256;
/**
 * Creates a function that invokes `func` with arguments arranged according
 * to the specified `indexes` where the argument value at the first index is
 * provided as the first argument, the argument value at the second index is
 * provided as the second argument, and so on.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} func The function to rearrange arguments for.
 * @param {...(number|number[])} indexes The arranged argument indexes.
 * @returns {Function} Returns the new function.
 * @example
 *
 * var rearged = _.rearg(function(a, b, c) {
 *   return [a, b, c];
 * }, [2, 0, 1]);
 *
 * rearged('b', 'c', 'a')
 * // => ['a', 'b', 'c']
 */ var $e9ef0836fe6d24f1$var$rearg = $224h2(function(func, indexes) {
    return $xQ3hV(func, $e9ef0836fe6d24f1$var$WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
});
module.exports = $e9ef0836fe6d24f1$var$rearg;

});

parcelRegister("d0KBl", function(module, exports) {

var $kJvGp = parcelRequire("kJvGp");

var $b69Sx = parcelRequire("b69Sx");

var $1c8hB = parcelRequire("1c8hB");

var $8aco7 = parcelRequire("8aco7");

var $1xzs7 = parcelRequire("1xzs7");

var $cNyDu = parcelRequire("cNyDu");

var $1uqnh = parcelRequire("1uqnh");
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */ function $978f6c7ba8ca5ebf$var$toPath(value) {
    if ($1c8hB(value)) return $kJvGp(value, $cNyDu);
    return $8aco7(value) ? [
        value
    ] : $b69Sx($1xzs7($1uqnh(value)));
}
module.exports = $978f6c7ba8ca5ebf$var$toPath;

});



parcelRegister("a0i0f", function(module, exports) {

var $buvff = parcelRequire("buvff");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $7487de7aebcafd99$var$set(object, path, value) {
    return object == null ? object : $buvff(object, path, value);
}
module.exports = $7487de7aebcafd99$var$set;

});


parcelRegister("cdSID", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e6124fcef72411c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
const $8e6124fcef72411c$var$getRecentErrors = (errors, maxMinutesOld)=>{
    const maxMillisecondsOld = maxMinutesOld * 60000;
    const minAge = Date.now() - maxMillisecondsOld;
    return errors.filter((error)=>error.time >= minAge);
};
class $8e6124fcef72411c$var$ErrorKeeper {
    static add(errorId) {
        $8e6124fcef72411c$var$ErrorKeeper.errors.push({
            id: errorId,
            time: Date.now()
        });
        // keeping a stack of 20 error assuming this much stack
        // should be sufficient to debug user issues under last 3 minutes.
        // since use may chose to register a bug some time after the error has actually happened.
        // so not filtering based on time here.
        if ($8e6124fcef72411c$var$ErrorKeeper.errors.length > 20) $8e6124fcef72411c$var$ErrorKeeper.errors.shift();
    }
    static getLastNMinutesErrors() {
        let min = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 3;
        return $8e6124fcef72411c$var$getRecentErrors($8e6124fcef72411c$var$ErrorKeeper.errors, min).map((error)=>error.id);
    }
}
(0, $5zQU9.default)($8e6124fcef72411c$var$ErrorKeeper, "errors", []);
var $8e6124fcef72411c$export$2e2bcd8739ae039 = $8e6124fcef72411c$var$ErrorKeeper;

});

parcelRegister("7lvGB", function(module, exports) {

$parcel$export(module.exports, "objectToPathValuePair", () => $559312c81b6f4425$export$d030967c0b6e21ad);
$parcel$export(module.exports, "pathValuePairToObject", () => $559312c81b6f4425$export$cb17130c973f58ff);
$parcel$export(module.exports, "removeAttributes", () => $559312c81b6f4425$export$53fcb63c2c7a968f);
$parcel$export(module.exports, "isPlainObject", () => $559312c81b6f4425$export$53b83ca8eaab0383);
$parcel$export(module.exports, "isOptionSelected", () => $559312c81b6f4425$export$1c98cb0a1dc8129e);

var $jtsd5 = parcelRequire("jtsd5");

var $kd0cS = parcelRequire("kd0cS");

var $a0i0f = parcelRequire("a0i0f");

var $fUTZC = parcelRequire("fUTZC");

var $9BtCH = parcelRequire("9BtCH");

var $1c8hB = parcelRequire("1c8hB");

var $feGjZ = parcelRequire("feGjZ");

var $lUFEu = parcelRequire("lUFEu");

var $gKA5o = parcelRequire("gKA5o");

var $jh2R9 = parcelRequire("jh2R9");
function $559312c81b6f4425$export$7ca75779cdfd0dd5(originalObject) {
    let depth = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
    return Object.entries(originalObject).reduce((transformedObject, _ref)=>{
        let [key, value] = _ref;
        const newKey = (0, (/*@__PURE__*/$parcel$interopDefault($jh2R9)))(key);
        const newValue = typeof value === 'object' && (depth === null || depth > 1) ? $559312c81b6f4425$export$7ca75779cdfd0dd5(value, depth === null ? depth : depth - 1) : value;
        transformedObject[newKey] = newValue;
        return transformedObject;
    }, {});
}
const $559312c81b6f4425$export$c4f1fe821c494e19 = (()=>{
    // eslint-disable-next-line unicorn/better-regex, no-useless-escape
    const UNSAFE_CHARS_REGEXP = /[<>\/\u2028\u2029]/g;
    const ESCAPED_CHARS = {
        '<': '\\u003C',
        '>': '\\u003E',
        '/': '\\u002F',
        '\u2028': '\\u2028',
        '\u2029': '\\u2029'
    };
    const escapeUnsafeChars = (unsafeChar)=>ESCAPED_CHARS[unsafeChar];
    return (obj)=>{
        const serialized = typeof obj === 'string' ? obj : JSON.stringify(obj);
        // Protects against `JSON.stringify()` returning `undefined`, by serializing
        // to the literal string: "undefined".
        if (typeof serialized !== 'string') return String(serialized);
        return serialized.replace(UNSAFE_CHARS_REGEXP, escapeUnsafeChars);
    };
})();
const $559312c81b6f4425$export$de7358b4991653b1 = function flattenObject(obj) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    return Object.keys(obj).reduce((acc, k)=>{
        const pre = prefix.length ? prefix + '.' : '';
        if (obj[k] && typeof obj[k] === 'object' && !Array.isArray(obj[k])) Object.assign(acc, flattenObject(obj[k], pre + k));
        else acc[pre + k] = obj[k];
        return acc;
    }, {});
};
const $559312c81b6f4425$export$d8669a1344423b58 = (data)=>{
    const result = {};
    for(const i in data){
        const keys = i.split('.');
        keys.reduce((r, e, j)=>{
            return r[e] || (r[e] = isNaN(Number(keys[j + 1])) ? keys.length - 1 == j ? data[i] : {} : []);
        }, result);
    }
    return result;
};
function $559312c81b6f4425$export$641b3aa2ed837fc2(obj) {
    try {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(obj) || (0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(obj)) return JSON.parse(JSON.stringify(obj));
        else throw new Error('Expected an object however received something else');
    } catch (e) {
        console.error('ERROR: objectToPathValuePair -> e', e);
        throw e;
    }
}
function $559312c81b6f4425$export$d030967c0b6e21ad(obj) {
    let prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
    obj = $559312c81b6f4425$export$641b3aa2ed837fc2(obj);
    return (0, (/*@__PURE__*/$parcel$interopDefault($9BtCH)))(obj, (result, value, key)=>{
        const newKey = prefix ? "".concat(prefix, ".").concat(key) : key;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(value) && !(0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(value)) Object.assign(result, $559312c81b6f4425$export$d030967c0b6e21ad(value, newKey));
        else if ((0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(value)) (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(value, (item, index)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($feGjZ)))(item) && !(0, (/*@__PURE__*/$parcel$interopDefault($1c8hB)))(item)) Object.assign(result, $559312c81b6f4425$export$d030967c0b6e21ad(item, "".concat(newKey, "[").concat(index, "]")));
            else result["".concat(newKey, "[").concat(index, "]")] = item;
        });
        else result[newKey] = value;
        return result;
    }, {});
}
function $559312c81b6f4425$export$cb17130c973f58ff(obj) {
    obj = $559312c81b6f4425$export$641b3aa2ed837fc2(obj);
    const result = {};
    (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(obj, (value, key)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(result, key, value);
    });
    return result;
}
function $559312c81b6f4425$export$53fcb63c2c7a968f(obj, keys) {
    const newObj = (0, (/*@__PURE__*/$parcel$interopDefault($kd0cS)))(obj);
    const helper = (paramObj)=>{
        (0, (/*@__PURE__*/$parcel$interopDefault($fUTZC)))(paramObj, (value, key)=>{
            if (value && typeof value === 'object') helper(value);
            if (keys.includes(key)) delete paramObj[key];
        });
    };
    helper(newObj);
    return newObj;
}
function $559312c81b6f4425$export$53b83ca8eaab0383(obj) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($jtsd5)))(obj);
}
function $559312c81b6f4425$export$1c98cb0a1dc8129e(selectedOptions) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($lUFEu)))(selectedOptions, (option)=>(0, (/*@__PURE__*/$parcel$interopDefault($gKA5o)))(option) > 0);
}

});
parcelRegister("9BtCH", function(module, exports) {

var $flmMe = parcelRequire("flmMe");

var $awetI = parcelRequire("awetI");

var $7qARj = parcelRequire("7qARj");

var $jhbYY = parcelRequire("jhbYY");

var $1c8hB = parcelRequire("1c8hB");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $6fde8c506e131c3e$var$reduce(collection, iteratee, accumulator) {
    var func = $1c8hB(collection) ? $flmMe : $jhbYY, initAccum = arguments.length < 3;
    return func(collection, $7qARj(iteratee, 4), accumulator, initAccum, $awetI);
}
module.exports = $6fde8c506e131c3e$var$reduce;

});
parcelRegister("jhbYY", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $e088e655a3a9a31d$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $e088e655a3a9a31d$var$baseReduce;

});


parcelRegister("lUFEu", function(module, exports) {

var $jqs7R = parcelRequire("jqs7R");

var $7qARj = parcelRequire("7qARj");

var $8v3yf = parcelRequire("8v3yf");

var $1c8hB = parcelRequire("1c8hB");

var $3P7i5 = parcelRequire("3P7i5");
/**
 * Checks if `predicate` returns truthy for **any** element of `collection`.
 * Iteration is stopped once `predicate` returns truthy. The predicate is
 * invoked with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 * @example
 *
 * _.some([null, 0, 'yes', false], Boolean);
 * // => true
 *
 * var users = [
 *   { 'user': 'barney', 'active': true },
 *   { 'user': 'fred',   'active': false }
 * ];
 *
 * // The `_.matches` iteratee shorthand.
 * _.some(users, { 'user': 'barney', 'active': false });
 * // => false
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.some(users, ['active', false]);
 * // => true
 *
 * // The `_.property` iteratee shorthand.
 * _.some(users, 'active');
 * // => true
 */ function $ff3f232f92bb24aa$var$some(collection, predicate, guard) {
    var func = $1c8hB(collection) ? $jqs7R : $8v3yf;
    if (guard && $3P7i5(collection, predicate, guard)) predicate = undefined;
    return func(collection, $7qARj(predicate, 3));
}
module.exports = $ff3f232f92bb24aa$var$some;

});
parcelRegister("8v3yf", function(module, exports) {

var $awetI = parcelRequire("awetI");
/**
 * The base implementation of `_.some` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */ function $6303f9332a27a1b4$var$baseSome(collection, predicate) {
    var result;
    $awetI(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
    });
    return !!result;
}
module.exports = $6303f9332a27a1b4$var$baseSome;

});


parcelRegister("gKA5o", function(module, exports) {

var $fCpZe = parcelRequire("fCpZe");

var $fjnSB = parcelRequire("fjnSB");

var $jxg5X = parcelRequire("jxg5X");

var $4ZYEI = parcelRequire("4ZYEI");

var $eQiJU = parcelRequire("eQiJU");
/** `Object#toString` result references. */ var $c31cef206f882b8b$var$mapTag = '[object Map]', $c31cef206f882b8b$var$setTag = '[object Set]';
/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */ function $c31cef206f882b8b$var$size(collection) {
    if (collection == null) return 0;
    if ($jxg5X(collection)) return $4ZYEI(collection) ? $eQiJU(collection) : collection.length;
    var tag = $fjnSB(collection);
    if (tag == $c31cef206f882b8b$var$mapTag || tag == $c31cef206f882b8b$var$setTag) return collection.size;
    return $fCpZe(collection).length;
}
module.exports = $c31cef206f882b8b$var$size;

});
parcelRegister("eQiJU", function(module, exports) {

var $3K42x = parcelRequire("3K42x");

var $fFFC0 = parcelRequire("fFFC0");

var $CYLq5 = parcelRequire("CYLq5");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $ace4754dece6a484$var$stringSize(string) {
    return $fFFC0(string) ? $CYLq5(string) : $3K42x(string);
}
module.exports = $ace4754dece6a484$var$stringSize;

});
parcelRegister("3K42x", function(module, exports) {

var $pRnxj = parcelRequire("pRnxj");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $2b98cd398295eed4$var$asciiSize = $pRnxj('length');
module.exports = $2b98cd398295eed4$var$asciiSize;

});

parcelRegister("CYLq5", function(module, exports) {
/** Used to compose unicode character classes. */ var $0752af280e68c649$var$rsAstralRange = '\\ud800-\\udfff', $0752af280e68c649$var$rsComboMarksRange = '\\u0300-\\u036f', $0752af280e68c649$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $0752af280e68c649$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $0752af280e68c649$var$rsComboRange = $0752af280e68c649$var$rsComboMarksRange + $0752af280e68c649$var$reComboHalfMarksRange + $0752af280e68c649$var$rsComboSymbolsRange, $0752af280e68c649$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $0752af280e68c649$var$rsAstral = '[' + $0752af280e68c649$var$rsAstralRange + ']', $0752af280e68c649$var$rsCombo = '[' + $0752af280e68c649$var$rsComboRange + ']', $0752af280e68c649$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $0752af280e68c649$var$rsModifier = '(?:' + $0752af280e68c649$var$rsCombo + '|' + $0752af280e68c649$var$rsFitz + ')', $0752af280e68c649$var$rsNonAstral = '[^' + $0752af280e68c649$var$rsAstralRange + ']', $0752af280e68c649$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $0752af280e68c649$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $0752af280e68c649$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $0752af280e68c649$var$reOptMod = $0752af280e68c649$var$rsModifier + '?', $0752af280e68c649$var$rsOptVar = '[' + $0752af280e68c649$var$rsVarRange + ']?', $0752af280e68c649$var$rsOptJoin = '(?:' + $0752af280e68c649$var$rsZWJ + '(?:' + [
    $0752af280e68c649$var$rsNonAstral,
    $0752af280e68c649$var$rsRegional,
    $0752af280e68c649$var$rsSurrPair
].join('|') + ')' + $0752af280e68c649$var$rsOptVar + $0752af280e68c649$var$reOptMod + ')*', $0752af280e68c649$var$rsSeq = $0752af280e68c649$var$rsOptVar + $0752af280e68c649$var$reOptMod + $0752af280e68c649$var$rsOptJoin, $0752af280e68c649$var$rsSymbol = '(?:' + [
    $0752af280e68c649$var$rsNonAstral + $0752af280e68c649$var$rsCombo + '?',
    $0752af280e68c649$var$rsCombo,
    $0752af280e68c649$var$rsRegional,
    $0752af280e68c649$var$rsSurrPair,
    $0752af280e68c649$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $0752af280e68c649$var$reUnicode = RegExp($0752af280e68c649$var$rsFitz + '(?=' + $0752af280e68c649$var$rsFitz + ')|' + $0752af280e68c649$var$rsSymbol + $0752af280e68c649$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $0752af280e68c649$var$unicodeSize(string) {
    var result = $0752af280e68c649$var$reUnicode.lastIndex = 0;
    while($0752af280e68c649$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $0752af280e68c649$var$unicodeSize;

});





parcelRegister("5sMiL", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fa508f83a43344d$export$2e2bcd8739ae039);

var $hHgKO = parcelRequire("hHgKO");
var $3fa508f83a43344d$export$2e2bcd8739ae039 = (0, $hHgKO.default);

});

parcelRegister("iUPNF", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc55a35fafe6e4e8$export$2e2bcd8739ae039);
/**
 * NOTE: THIS FILE IS ONLY USED IN DEVELOPMENT",
 * DURING PACKAGE BUILD IT IS REGENERATED WITH ACTUAL VERSION OF THE EMCEE PACKAGE
 */ const $dc55a35fafe6e4e8$var$placeholderVersion = '19.25.0';
var $dc55a35fafe6e4e8$export$2e2bcd8739ae039 = $dc55a35fafe6e4e8$var$placeholderVersion;

});

parcelRegister("8AYXA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6420f8e7fbb1f784$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $hvUUg = parcelRequire("hvUUg");
var $2AfD7 = parcelRequire("2AfD7");

var $4iWU0 = parcelRequire("4iWU0");
var $8rirv = parcelRequire("8rirv");

var $c0qPT = parcelRequire("c0qPT");
var $c9Mth = parcelRequire("c9Mth");

var $eUqFw = parcelRequire("eUqFw");

var $3dvqV = parcelRequire("3dvqV");
parcelRequire("jJs3W");
var $b02ud = parcelRequire("b02ud");

var $lCIzm = parcelRequire("lCIzm");
var $e8LPn = parcelRequire("e8LPn");

var $40nqT = parcelRequire("40nqT");

var $iEgm6 = parcelRequire("iEgm6");

var $bPtM5 = parcelRequire("bPtM5");

var $i6Nih = parcelRequire("i6Nih");

var $jHg79 = parcelRequire("jHg79");

var $c7npB = parcelRequire("c7npB");

var $2bHSm = parcelRequire("2bHSm");

var $lHkHI = parcelRequire("lHkHI");
function $6420f8e7fbb1f784$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6420f8e7fbb1f784$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6420f8e7fbb1f784$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6420f8e7fbb1f784$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $6420f8e7fbb1f784$var$DecideDefaultRoute = (props)=>{
    const mountPath = (0, $jHg79.useMountPath)();
    if (props.bootstrapConfig.isManageAppRequests) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lCIzm.default), {
        to: $6420f8e7fbb1f784$var$_objectSpread($6420f8e7fbb1f784$var$_objectSpread({}, props.location), {}, {
            pathname: (0, $c9Mth).joinPathNames([
                mountPath,
                (0, $40nqT.manageAppRequestsRoute).path
            ])
        })
    });
    else if (props.bootstrapConfig.isManagePromotions) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lCIzm.default), {
        to: $6420f8e7fbb1f784$var$_objectSpread($6420f8e7fbb1f784$var$_objectSpread({}, props.location), {}, {
            pathname: (0, $c9Mth).joinPathNames([
                mountPath,
                (0, $40nqT.managePromotionsRoute).path
            ])
        })
    });
    else return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lCIzm.default), {
        to: $6420f8e7fbb1f784$var$_objectSpread($6420f8e7fbb1f784$var$_objectSpread({}, props.location), {}, {
            pathname: (0, $c9Mth).joinPathNames([
                mountPath,
                (0, $40nqT.discoverRoute).path
            ])
        })
    });
};
// We need overflow settings only in case of emcee connect since it renders as an Iframe
// Emcee native will render these components are part of their page, the whole page scroll
// should work without needed to have any overflows
const $6420f8e7fbb1f784$var$AppStyles = (0, $3UXZ8.default)("div", {
    target: "e15eck5s0",
    label: "AppStyles"
})((0, $hvUUg.baseStylesCss), " ", (0, $2AfD7.default), " height:100%;margin:0;display:flex;flex-direction:column;line-height:1.46;box-sizing:border-box;", (0, $bPtM5.isEmceeConnect)() ? 'overflow-x: hidden;' : '', " --mp-h1-font-size-md:2.75rem;--mp-h2-font-size-md:2.25rem;--mp-h3-font-size-md:1.75rem;--mp-h4-font-size-md:1.375rem;--mp-h5-font-size-md:1.125rem;--mp-body-large-font-size-md:1.125rem;--mp-pullquote-small-font-size-md:1.5rem;--mp-pullquote-large-font-size-md:2rem;--mp-h1-line-height-md:3.25rem;--mp-h2-line-height-md:2.625rem;--mp-h3-line-height-md:2.125rem;--mp-h4-line-height-md:1.75rem;--mp-h5-line-height-md:1.625rem;--mp-body-large-line-height-md:1.625rem;--mp-pullquote-small-line-height-md:2rem;--mp-pullquote-large-line-height-md:2.75rem;");
const $6420f8e7fbb1f784$var$App = (_ref)=>{
    let { bootstrapConfig: bootstrapConfig, store: store, history: history, algoliaClient: algoliaClient, onBootstrapConfigChange: onBootstrapConfigChange, mountPath: mountPath, statsigClient: statsigClient } = _ref;
    const { mpacBaseUrl: mpacBaseUrl } = bootstrapConfig;
    const { hostInfo: hostInfo } = (0, $2bHSm.useHostData)();
    const applicationConfig = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useMemo(()=>{
        return $6420f8e7fbb1f784$var$_objectSpread($6420f8e7fbb1f784$var$_objectSpread({}, bootstrapConfig), {}, {
            environment: (0, $iEgm6.mapBootstrapEnvToDeployEnv)(bootstrapConfig.environment),
            source: 'PRODUCT',
            algoliaConfig: bootstrapConfig.algolia,
            hostUrl: mpacBaseUrl,
            hostProductId: hostInfo === null || hostInfo === void 0 ? void 0 : hostInfo.product,
            mountPath: mountPath
        });
    }, [
        bootstrapConfig,
        mpacBaseUrl,
        hostInfo === null || hostInfo === void 0 ? void 0 : hostInfo.product
    ]);
    return /*#__PURE__*/ (0, $lHkHI.jsx)($6420f8e7fbb1f784$var$AppStyles, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jHg79.AppContextProvider), {
            mountPath: mountPath,
            bootstrapConfig: bootstrapConfig,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $c0qPT.ApplicationConfigProvider), {
                applicationConfig: applicationConfig,
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $b02ud.default), {
                    store: store,
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3dvqV.ScreenClassProvider), {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8rirv.RouterWithContext), {
                            history: history,
                            children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $e8LPn.default), {
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4iWU0.RouteWithContext), {
                                        exact: true,
                                        path: (0, $c9Mth).joinPathNames([
                                            mountPath,
                                            '/'
                                        ]),
                                        render: (routeProps)=>/*#__PURE__*/ (0, $lHkHI.jsx)($6420f8e7fbb1f784$var$DecideDefaultRoute, {
                                                location: routeProps.location,
                                                bootstrapConfig: bootstrapConfig
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4iWU0.RouteWithContext), {
                                        exact: true,
                                        path: (0, $c9Mth).joinPathNames([
                                            mountPath,
                                            '/search'
                                        ]),
                                        render: (routeProps)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $lCIzm.default), {
                                                to: $6420f8e7fbb1f784$var$_objectSpread($6420f8e7fbb1f784$var$_objectSpread({}, routeProps.location), {}, {
                                                    pathname: (0, $c9Mth).joinPathNames([
                                                        mountPath,
                                                        (0, $40nqT.searchRoute).path
                                                    ])
                                                })
                                            })
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4iWU0.RouteWithContext), {
                                        path: (0, $c9Mth).joinPathNames([
                                            mountPath,
                                            '/'
                                        ]),
                                        render: (routeProps)=>/**
                   * Because emcee maintains its own history copy, it might happen that
                   * a product navigation out of emcee mount path is read by emcee's history
                   * first. This causes a brief flash of emcee's 404 page, till the product's history
                   * unmounts emcee.
                   *
                   * Here, we simply ignore paths that don't start with the emcee mount path
                   */ window.location.pathname.startsWith(mountPath) ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $i6Nih.default), {
                                                algoliaClient: algoliaClient,
                                                bootstrapConfig: bootstrapConfig,
                                                history: routeProps.history,
                                                location: routeProps.location,
                                                component: (0, $c7npB.default),
                                                onBootstrapConfigChange: onBootstrapConfigChange,
                                                statsigClient: statsigClient
                                            }) : null
                                    })
                                ]
                            })
                        })
                    })
                })
            })
        })
    });
};
var $6420f8e7fbb1f784$export$2e2bcd8739ae039 = $6420f8e7fbb1f784$var$App;

});
parcelRegister("2AfD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e1b1157409ec9a9$export$2e2bcd8739ae039);

var $ibjku = parcelRequire("ibjku");

var $ijiK6 = parcelRequire("ijiK6");

var $jsVvg = parcelRequire("jsVvg");

var $icBxM = parcelRequire("icBxM");

var $cFwN8 = parcelRequire("cFwN8");

var $3OhdZ = parcelRequire("3OhdZ");

var $eJfMp = parcelRequire("eJfMp");

var $cCTgx = parcelRequire("cCTgx");

var $cVHv7 = parcelRequire("cVHv7");

var $5g6Vg = parcelRequire("5g6Vg");

var $jMydS = parcelRequire("jMydS");

var $fdcOq = parcelRequire("fdcOq");

var $dubTk = parcelRequire("dubTk");

var $bUdAl = parcelRequire("bUdAl");

var $baQdk = parcelRequire("baQdk");

var $d2BBz = parcelRequire("d2BBz");

var $2ax4b = parcelRequire("2ax4b");

var $7cflg = parcelRequire("7cflg");

var $aW17J = parcelRequire("aW17J");

var $i5kwB = parcelRequire("i5kwB");

var $faG4I = parcelRequire("faG4I");

var $ffmIq = parcelRequire("ffmIq");

var $gJmUS = parcelRequire("gJmUS");

var $8jHAM = parcelRequire("8jHAM");

var $8IUkd = parcelRequire("8IUkd");

var $1PL3l = parcelRequire("1PL3l");

var $93PZC = parcelRequire("93PZC");

var $3P7ek = parcelRequire("3P7ek");

var $6lW06 = parcelRequire("6lW06");

var $7UJnc = parcelRequire("7UJnc");

var $lKGYp = parcelRequire("lKGYp");

var $03uso = parcelRequire("03uso");

var $aARDD = parcelRequire("aARDD");

var $57f9V = parcelRequire("57f9V");

var $kpojx = parcelRequire("kpojx");

var $b7byv = parcelRequire("b7byv");

var $jTLYp = parcelRequire("jTLYp");

var $6BvPM = parcelRequire("6BvPM");

var $aMRT8 = parcelRequire("aMRT8");

var $6dWDi = parcelRequire("6dWDi");

var $76MB7 = parcelRequire("76MB7");

var $Zb2sO = parcelRequire("Zb2sO");

var $6lpTK = parcelRequire("6lpTK");

var $izjuh = parcelRequire("izjuh");

var $46IeJ = parcelRequire("46IeJ");

var $4YJgN = parcelRequire("4YJgN");

var $7kFG2 = parcelRequire("7kFG2");

var $186G7 = parcelRequire("186G7");

var $aGePI = parcelRequire("aGePI");

var $3anXD = parcelRequire("3anXD");

var $2Lvcx = parcelRequire("2Lvcx");

var $89CSj = parcelRequire("89CSj");

var $2EhU1 = parcelRequire("2EhU1");
var $1e1b1157409ec9a9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $ibjku.css)("@font-face{font-family:'Charlie Display';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($jsVvg))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($ijiK6))), ") format('woff');font-weight:800;font-style:normal;font-display:swap;}@font-face{font-family:'Charlie Display';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($eJfMp))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($3OhdZ))), ") format('woff');font-weight:700;font-style:normal;font-display:swap;}@font-face{font-family:'Charlie Display';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($dubTk))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($fdcOq))), ") format('woff');font-weight:300;font-style:normal;font-display:swap;}@font-face{font-family:'Charlie Display';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($2ax4b))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($d2BBz))), ") format('woff');font-weight:normal;font-style:normal;font-display:swap;}@font-face{font-family:'Charlie Display';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($aW17J))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($7cflg))), ") format('woff');font-weight:600;font-style:normal;font-display:swap;}@font-face{font-family:'Charlie Display';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($gJmUS))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($ffmIq))), ") format('woff');font-weight:100;font-style:normal;font-display:swap;}@font-face{font-family:'Charlie Display';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($93PZC))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($1PL3l))), ") format('woff');font-weight:900;font-style:normal;font-display:swap;}@font-face{font-family:'Charlie Display';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($cFwN8))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($icBxM))), ") format('woff');font-weight:800;font-style:italic;font-display:swap;}@font-face{font-family:'Charlie Display';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($cVHv7))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($cCTgx))), ") format('woff');font-weight:700;font-style:italic;font-display:swap;}@font-face{font-family:'Charlie Display';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($jMydS))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($5g6Vg))), ") format('woff');font-weight:normal;font-style:italic;font-display:swap;}@font-face{font-family:'Charlie Display';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($baQdk))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($bUdAl))), ") format('woff');font-weight:300;font-style:italic;font-display:swap;}@font-face{font-family:'Charlie Display';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($faG4I))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($i5kwB))), ") format('woff');font-weight:600;font-style:italic;font-display:swap;}@font-face{font-family:'Charlie Display';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($8IUkd))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($8jHAM))), ") format('woff');font-weight:100;font-style:italic;font-display:swap;}@font-face{font-family:'Charlie Display';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($6lW06))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($3P7ek))), ") format('woff');font-weight:900;font-style:italic;font-display:swap;}@font-face{font-family:'Charlie Text';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($lKGYp))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($7UJnc))), ") format('woff');font-weight:800;font-style:normal;font-display:swap;}@font-face{font-family:'Charlie Text';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($aARDD))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($03uso))), ") format('woff');font-weight:800;font-style:italic;font-display:swap;}@font-face{font-family:'Charlie Text';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($kpojx))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($57f9V))), ") format('woff');font-weight:700;font-style:normal;font-display:swap;}@font-face{font-family:'Charlie Text';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($jTLYp))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($b7byv))), ") format('woff');font-weight:700;font-style:italic;font-display:swap;}@font-face{font-family:'Charlie Text';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($aMRT8))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($6BvPM))), ") format('woff');font-weight:normal;font-style:italic;font-display:swap;}@font-face{font-family:'Charlie Text';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($76MB7))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($6dWDi))), ") format('woff');font-weight:300;font-style:normal;font-display:swap;}@font-face{font-family:'Charlie Text';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($6lpTK))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($Zb2sO))), ") format('woff');font-weight:300;font-style:italic;font-display:swap;}@font-face{font-family:'Charlie Text';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($46IeJ))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($izjuh))), ") format('woff');font-weight:normal;font-style:normal;font-display:swap;}@font-face{font-family:'Charlie Text';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($7kFG2))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($4YJgN))), ") format('woff');font-weight:600;font-style:normal;font-display:swap;}@font-face{font-family:'Charlie Text';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($aGePI))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($186G7))), ") format('woff');font-weight:600;font-style:italic;font-display:swap;}@font-face{font-family:'Charlie Text';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($2Lvcx))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($3anXD))), ") format('woff');font-weight:100;font-style:normal;font-display:swap;}@font-face{font-family:'Charlie Text';src:url(", (0, (/*@__PURE__*/$parcel$interopDefault($2EhU1))), ") format('woff2'),url(", (0, (/*@__PURE__*/$parcel$interopDefault($89CSj))), ") format('woff');font-weight:100;font-style:italic;font-display:swap;}");

});
parcelRegister("ijiK6", function(module, exports) {
module.exports = new URL("Charlie_Display-Black.78320021.woff", import.meta.url).toString();

});

parcelRegister("jsVvg", function(module, exports) {
module.exports = new URL("Charlie_Display-Black.79680ccc.woff2", import.meta.url).toString();

});

parcelRegister("icBxM", function(module, exports) {
module.exports = new URL("Charlie_Display-Black_Italic.c3410f6e.woff", import.meta.url).toString();

});

parcelRegister("cFwN8", function(module, exports) {
module.exports = new URL("Charlie_Display-Black_Italic.f90f54a7.woff2", import.meta.url).toString();

});

parcelRegister("3OhdZ", function(module, exports) {
module.exports = new URL("Charlie_Display-Bold.b68a9488.woff", import.meta.url).toString();

});

parcelRegister("eJfMp", function(module, exports) {
module.exports = new URL("Charlie_Display-Bold.0d294e31.woff2", import.meta.url).toString();

});

parcelRegister("cCTgx", function(module, exports) {
module.exports = new URL("Charlie_Display-Bold_Italic.06a80893.woff", import.meta.url).toString();

});

parcelRegister("cVHv7", function(module, exports) {
module.exports = new URL("Charlie_Display-Bold_Italic.a86c301e.woff2", import.meta.url).toString();

});

parcelRegister("5g6Vg", function(module, exports) {
module.exports = new URL("Charlie_Display-Italic.16ea5e77.woff", import.meta.url).toString();

});

parcelRegister("jMydS", function(module, exports) {
module.exports = new URL("Charlie_Display-Italic.d7f447a7.woff2", import.meta.url).toString();

});

parcelRegister("fdcOq", function(module, exports) {
module.exports = new URL("Charlie_Display-Light.623ad327.woff", import.meta.url).toString();

});

parcelRegister("dubTk", function(module, exports) {
module.exports = new URL("Charlie_Display-Light.3e8a654a.woff2", import.meta.url).toString();

});

parcelRegister("bUdAl", function(module, exports) {
module.exports = new URL("Charlie_Display-Light_Italic.26c12e84.woff", import.meta.url).toString();

});

parcelRegister("baQdk", function(module, exports) {
module.exports = new URL("Charlie_Display-Light_Italic.bf1a7fdc.woff2", import.meta.url).toString();

});

parcelRegister("d2BBz", function(module, exports) {
module.exports = new URL("Charlie_Display-Regular.9706825e.woff", import.meta.url).toString();

});

parcelRegister("2ax4b", function(module, exports) {
module.exports = new URL("Charlie_Display-Regular.7f5225e3.woff2", import.meta.url).toString();

});

parcelRegister("7cflg", function(module, exports) {
module.exports = new URL("Charlie_Display-Semibold.8fc988b4.woff", import.meta.url).toString();

});

parcelRegister("aW17J", function(module, exports) {
module.exports = new URL("Charlie_Display-Semibold.8ae17c79.woff2", import.meta.url).toString();

});

parcelRegister("i5kwB", function(module, exports) {
module.exports = new URL("Charlie_Display-Semibold_Italic.2904d1c1.woff", import.meta.url).toString();

});

parcelRegister("faG4I", function(module, exports) {
module.exports = new URL("Charlie_Display-Semibold_Italic.1ac27bc5.woff2", import.meta.url).toString();

});

parcelRegister("ffmIq", function(module, exports) {
module.exports = new URL("Charlie_Display-Thin.532a259a.woff", import.meta.url).toString();

});

parcelRegister("gJmUS", function(module, exports) {
module.exports = new URL("Charlie_Display-Thin.53f6ff2a.woff2", import.meta.url).toString();

});

parcelRegister("8jHAM", function(module, exports) {
module.exports = new URL("Charlie_Display-Thin_Italic.fa092ec4.woff", import.meta.url).toString();

});

parcelRegister("8IUkd", function(module, exports) {
module.exports = new URL("Charlie_Display-Thin_Italic.b6cf1162.woff2", import.meta.url).toString();

});

parcelRegister("1PL3l", function(module, exports) {
module.exports = new URL("Charlie_Display-Ultra.8ac32164.woff", import.meta.url).toString();

});

parcelRegister("93PZC", function(module, exports) {
module.exports = new URL("Charlie_Display-Ultra.fdc197e1.woff2", import.meta.url).toString();

});

parcelRegister("3P7ek", function(module, exports) {
module.exports = new URL("Charlie_Display-Ultra_Italic.3110ec45.woff", import.meta.url).toString();

});

parcelRegister("6lW06", function(module, exports) {
module.exports = new URL("Charlie_Display-Ultra_Italic.2f7484ec.woff2", import.meta.url).toString();

});

parcelRegister("7UJnc", function(module, exports) {
module.exports = new URL("Charlie_Text-Black.cd881b92.woff", import.meta.url).toString();

});

parcelRegister("lKGYp", function(module, exports) {
module.exports = new URL("Charlie_Text-Black.aa4e8124.woff2", import.meta.url).toString();

});

parcelRegister("03uso", function(module, exports) {
module.exports = new URL("Charlie_Text-Black_Italic.30e41609.woff", import.meta.url).toString();

});

parcelRegister("aARDD", function(module, exports) {
module.exports = new URL("Charlie_Text-Black_Italic.80819fef.woff2", import.meta.url).toString();

});

parcelRegister("57f9V", function(module, exports) {
module.exports = new URL("Charlie_Text-Bold.dc235128.woff", import.meta.url).toString();

});

parcelRegister("kpojx", function(module, exports) {
module.exports = new URL("Charlie_Text-Bold.bbb5e2ba.woff2", import.meta.url).toString();

});

parcelRegister("b7byv", function(module, exports) {
module.exports = new URL("Charlie_Text-Bold_Italic.fe6faba2.woff", import.meta.url).toString();

});

parcelRegister("jTLYp", function(module, exports) {
module.exports = new URL("Charlie_Text-Bold_Italic.da559cbf.woff2", import.meta.url).toString();

});

parcelRegister("6BvPM", function(module, exports) {
module.exports = new URL("Charlie_Text-Italic.cb25c310.woff", import.meta.url).toString();

});

parcelRegister("aMRT8", function(module, exports) {
module.exports = new URL("Charlie_Text-Italic.e9d16d99.woff2", import.meta.url).toString();

});

parcelRegister("6dWDi", function(module, exports) {
module.exports = new URL("Charlie_Text-Light.d208db0b.woff", import.meta.url).toString();

});

parcelRegister("76MB7", function(module, exports) {
module.exports = new URL("Charlie_Text-Light.02cd4b54.woff2", import.meta.url).toString();

});

parcelRegister("Zb2sO", function(module, exports) {
module.exports = new URL("Charlie_Text-Light_Italic.17b349b4.woff", import.meta.url).toString();

});

parcelRegister("6lpTK", function(module, exports) {
module.exports = new URL("Charlie_Text-Light_Italic.72ed72e0.woff2", import.meta.url).toString();

});

parcelRegister("izjuh", function(module, exports) {
module.exports = new URL("Charlie_Text-Regular.5c16e95e.woff", import.meta.url).toString();

});

parcelRegister("46IeJ", function(module, exports) {
module.exports = new URL("Charlie_Text-Regular.c1cc34af.woff2", import.meta.url).toString();

});

parcelRegister("4YJgN", function(module, exports) {
module.exports = new URL("Charlie_Text-Semibold.fef8ece4.woff", import.meta.url).toString();

});

parcelRegister("7kFG2", function(module, exports) {
module.exports = new URL("Charlie_Text-Semibold.81e35e50.woff2", import.meta.url).toString();

});

parcelRegister("186G7", function(module, exports) {
module.exports = new URL("Charlie_Text-Semibold_Italic.e16d6797.woff", import.meta.url).toString();

});

parcelRegister("aGePI", function(module, exports) {
module.exports = new URL("Charlie_Text-Semibold_Italic.e87f5272.woff2", import.meta.url).toString();

});

parcelRegister("3anXD", function(module, exports) {
module.exports = new URL("Charlie_Text-Thin.3ac72da7.woff", import.meta.url).toString();

});

parcelRegister("2Lvcx", function(module, exports) {
module.exports = new URL("Charlie_Text-Thin.342754ac.woff2", import.meta.url).toString();

});

parcelRegister("89CSj", function(module, exports) {
module.exports = new URL("Charlie_Text-Thin_Italic.803474d7.woff", import.meta.url).toString();

});

parcelRegister("2EhU1", function(module, exports) {
module.exports = new URL("Charlie_Text-Thin_Italic.dd27b1a6.woff2", import.meta.url).toString();

});


parcelRegister("4iWU0", function(module, exports) {

$parcel$export(module.exports, "RouteWithContext", () => $322688a5856209be$export$224116ae1100e686);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");
parcelRequire("eUqFw");

var $7QNSj = parcelRequire("7QNSj");

var $2j88s = parcelRequire("2j88s");

var $lHkHI = parcelRequire("lHkHI");
const $322688a5856209be$var$_excluded = [
    "component",
    "render"
];
function $322688a5856209be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $322688a5856209be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $322688a5856209be$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $322688a5856209be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $322688a5856209be$export$224116ae1100e686 = (props)=>{
    const { component: Component, render: _render } = props, rest = (0, $bwPfh.default)(props, $322688a5856209be$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7QNSj.default), $322688a5856209be$var$_objectSpread($322688a5856209be$var$_objectSpread({}, rest), {}, {
        render: (routeProps)=>{
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2j88s.default).Provider, {
                value: {
                    location: routeProps.location,
                    history: routeProps.history,
                    match: routeProps.match
                },
                children: _render ? _render(routeProps) : Component ? /*#__PURE__*/ (0, $lHkHI.jsx)(Component, $322688a5856209be$var$_objectSpread({}, routeProps)) : null
            });
        }
    }));
};

});
parcelRegister("7QNSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b7413dcddcdf29e$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $k43p8 = parcelRequire("k43p8");
var $5b7413dcddcdf29e$export$2e2bcd8739ae039 = (0, $k43p8.default);

});
parcelRegister("k43p8", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9b6d266f4833098$export$2e2bcd8739ae039);

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $1d3eD = parcelRequire("1d3eD");
var $e9b6d266f4833098$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $e9b6d266f4833098$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e9b6d266f4833098$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $e9b6d266f4833098$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var $e9b6d266f4833098$var$isEmptyChildren = function isEmptyChildren(children) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(children) === 0;
};
/**
 * The public API for matching a single path and rendering.
 */ var $e9b6d266f4833098$var$Route = function(_React$Component) {
    $e9b6d266f4833098$var$_inherits(Route, _React$Component);
    function Route() {
        var _temp, _this, _ret;
        $e9b6d266f4833098$var$_classCallCheck(this, Route);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $e9b6d266f4833098$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props, _this.context.router)
        }, _temp), $e9b6d266f4833098$var$_possibleConstructorReturn(_this, _ret);
    }
    Route.prototype.getChildContext = function getChildContext() {
        return {
            router: $e9b6d266f4833098$var$_extends({}, this.context.router, {
                route: {
                    location: this.props.location || this.context.router.route.location,
                    match: this.state.match
                }
            })
        };
    };
    Route.prototype.computeMatch = function computeMatch(_ref, router) {
        var computedMatch = _ref.computedMatch, location = _ref.location, path = _ref.path, strict = _ref.strict, exact = _ref.exact, sensitive = _ref.sensitive;
        if (computedMatch) return computedMatch; // <Switch> already computed the match for us
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(router, "You should not use <Route> or withRouter() outside a <Router>");
        var route = router.route;
        var pathname = (location || route.location).pathname;
        return (0, $1d3eD.default)(pathname, {
            path: path,
            strict: strict,
            exact: exact,
            sensitive: sensitive
        }, route.match);
    };
    Route.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.component && this.props.children && !$e9b6d266f4833098$var$isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(this.props.render && this.props.children && !$e9b6d266f4833098$var$isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
    };
    Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
        this.setState({
            match: this.computeMatch(nextProps, nextContext.router)
        });
    };
    Route.prototype.render = function render() {
        var match = this.state.match;
        var _props = this.props, children = _props.children, component = _props.component, render = _props.render;
        var _context$router = this.context.router, history = _context$router.history, route = _context$router.route, staticContext = _context$router.staticContext;
        var location = this.props.location || route.location;
        var props = {
            match: match,
            location: location,
            history: history,
            staticContext: staticContext
        };
        if (component) return match ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(component, props) : null;
        if (render) return match ? render(props) : null;
        if (typeof children === "function") return children(props);
        if (children && !$e9b6d266f4833098$var$isEmptyChildren(children)) return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(children);
        return null;
    };
    return Route;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$e9b6d266f4833098$var$Route.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    path: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    exact: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    strict: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    sensitive: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    component: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    render: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node
    ]),
    location: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
$e9b6d266f4833098$var$Route.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        route: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
    })
};
$e9b6d266f4833098$var$Route.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
};
var $e9b6d266f4833098$export$2e2bcd8739ae039 = $e9b6d266f4833098$var$Route;

});



parcelRegister("8rirv", function(module, exports) {

$parcel$export(module.exports, "RouterWithContext", () => $624f26a9da48b3df$export$5e664bdd904467d6);
parcelRequire("eUqFw");

var $bqSCJ = parcelRequire("bqSCJ");

var $khN6Q = parcelRequire("khN6Q");

var $lHkHI = parcelRequire("lHkHI");
const $624f26a9da48b3df$export$5e664bdd904467d6 = (props)=>{
    const { children: children, history: history } = props;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqSCJ.default), {
        history: history,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $khN6Q.default), {
            children: children
        })
    });
};

});
parcelRegister("bqSCJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $852c7e8f766e6629$export$2e2bcd8739ae039);
// Written in this round about way for babel-transform-imports

var $aTrRe = parcelRequire("aTrRe");
var $852c7e8f766e6629$export$2e2bcd8739ae039 = (0, $aTrRe.default);

});
parcelRegister("aTrRe", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee4a658adeb8d1a$export$2e2bcd8739ae039);

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");
var $7ee4a658adeb8d1a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $7ee4a658adeb8d1a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $7ee4a658adeb8d1a$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $7ee4a658adeb8d1a$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for putting history on context.
 */ var $7ee4a658adeb8d1a$var$Router = function(_React$Component) {
    $7ee4a658adeb8d1a$var$_inherits(Router, _React$Component);
    function Router() {
        var _temp, _this, _ret;
        $7ee4a658adeb8d1a$var$_classCallCheck(this, Router);
        for(var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return _ret = (_temp = (_this = $7ee4a658adeb8d1a$var$_possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [
            this
        ].concat(args))), _this), _this.state = {
            match: _this.computeMatch(_this.props.history.location.pathname)
        }, _temp), $7ee4a658adeb8d1a$var$_possibleConstructorReturn(_this, _ret);
    }
    Router.prototype.getChildContext = function getChildContext() {
        return {
            router: $7ee4a658adeb8d1a$var$_extends({}, this.context.router, {
                history: this.props.history,
                route: {
                    location: this.props.history.location,
                    match: this.state.match
                }
            })
        };
    };
    Router.prototype.computeMatch = function computeMatch(pathname) {
        return {
            path: "/",
            url: "/",
            params: {},
            isExact: pathname === "/"
        };
    };
    Router.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;
        var _props = this.props, children = _props.children, history = _props.history;
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(children == null || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.count(children) === 1, "A <Router> may have only one child element");
        // Do this here so we can setState when a <Redirect> changes the
        // location in componentWillMount. This happens e.g. when doing
        // server rendering using a <StaticRouter>.
        this.unlisten = history.listen(function() {
            _this2.setState({
                match: _this2.computeMatch(history.location.pathname)
            });
        });
    };
    Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(this.props.history === nextProps.history, "You cannot change <Router history>");
    };
    Router.prototype.componentWillUnmount = function componentWillUnmount() {
        this.unlisten();
    };
    Router.prototype.render = function render() {
        var children = this.props.children;
        return children ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.only(children) : null;
    };
    return Router;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$7ee4a658adeb8d1a$var$Router.propTypes = {
    history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node
};
$7ee4a658adeb8d1a$var$Router.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
$7ee4a658adeb8d1a$var$Router.childContextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
};
var $7ee4a658adeb8d1a$export$2e2bcd8739ae039 = $7ee4a658adeb8d1a$var$Router;

});


parcelRegister("khN6Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec4b7d43e57de1d7$export$2e2bcd8739ae039);

var $1Qivz = parcelRequire("1Qivz");
parcelRequire("eUqFw");

var $2j88s = parcelRequire("2j88s");

var $lHkHI = parcelRequire("lHkHI");
const $ec4b7d43e57de1d7$var$ContextWrapper = (props, context)=>{
    const { history: history, route: { location: location, match: match } = {} } = context.router;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2j88s.default).Provider, {
        value: {
            location: location,
            history: history,
            match: match
        },
        children: props.children
    });
};
// This is required for Legacy Context to work
// https://reactjs.org/docs/legacy-context.html#how-to-use-context
$ec4b7d43e57de1d7$var$ContextWrapper.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        route: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
    })
};
var $ec4b7d43e57de1d7$export$2e2bcd8739ae039 = $ec4b7d43e57de1d7$var$ContextWrapper;

});


parcelRegister("lCIzm", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbdfb81ac488d020$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $gSncF = parcelRequire("gSncF");

var $jCQQ5 = parcelRequire("jCQQ5");
var $fbdfb81ac488d020$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};
function $fbdfb81ac488d020$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $fbdfb81ac488d020$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $fbdfb81ac488d020$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for updating the location programmatically
 * with a component.
 */ var $fbdfb81ac488d020$var$Redirect = function(_React$Component) {
    $fbdfb81ac488d020$var$_inherits(Redirect, _React$Component);
    function Redirect() {
        $fbdfb81ac488d020$var$_classCallCheck(this, Redirect);
        return $fbdfb81ac488d020$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Redirect.prototype.isStatic = function isStatic() {
        return this.context.router && this.context.router.staticContext;
    };
    Redirect.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(this.context.router, "You should not use <Redirect> outside a <Router>");
        if (this.isStatic()) this.perform();
    };
    Redirect.prototype.componentDidMount = function componentDidMount() {
        if (!this.isStatic()) this.perform();
    };
    Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
        var prevTo = (0, $gSncF.createLocation)(prevProps.to);
        var nextTo = (0, $gSncF.createLocation)(this.props.to);
        if ((0, $gSncF.locationsAreEqual)(prevTo, nextTo)) {
            (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
            return;
        }
        this.perform();
    };
    Redirect.prototype.computeTo = function computeTo(_ref) {
        var computedMatch = _ref.computedMatch, to = _ref.to;
        if (computedMatch) {
            if (typeof to === "string") return (0, $jCQQ5.default)(to, computedMatch.params);
            else return $fbdfb81ac488d020$var$_extends({}, to, {
                pathname: (0, $jCQQ5.default)(to.pathname, computedMatch.params)
            });
        }
        return to;
    };
    Redirect.prototype.perform = function perform() {
        var history = this.context.router.history;
        var push = this.props.push;
        var to = this.computeTo(this.props);
        if (push) history.push(to);
        else history.replace(to);
    };
    Redirect.prototype.render = function render() {
        return null;
    };
    return Redirect;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$fbdfb81ac488d020$var$Redirect.propTypes = {
    computedMatch: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object,
    push: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    from: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    to: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOfType([
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
        (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
    ]).isRequired
};
$fbdfb81ac488d020$var$Redirect.defaultProps = {
    push: false
};
$fbdfb81ac488d020$var$Redirect.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        history: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
            push: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired,
            replace: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
        }).isRequired,
        staticContext: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
    }).isRequired
};
var $fbdfb81ac488d020$export$2e2bcd8739ae039 = $fbdfb81ac488d020$var$Redirect;

});
parcelRegister("jCQQ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $e49a8db050a6777e$export$2e2bcd8739ae039);

var $43pB1 = parcelRequire("43pB1");
var $e49a8db050a6777e$var$patternCache = {};
var $e49a8db050a6777e$var$cacheLimit = 10000;
var $e49a8db050a6777e$var$cacheCount = 0;
var $e49a8db050a6777e$var$compileGenerator = function compileGenerator(pattern) {
    var cacheKey = pattern;
    var cache = $e49a8db050a6777e$var$patternCache[cacheKey] || ($e49a8db050a6777e$var$patternCache[cacheKey] = {});
    if (cache[pattern]) return cache[pattern];
    var compiledGenerator = (0, (/*@__PURE__*/$parcel$interopDefault($43pB1))).compile(pattern);
    if ($e49a8db050a6777e$var$cacheCount < $e49a8db050a6777e$var$cacheLimit) {
        cache[pattern] = compiledGenerator;
        $e49a8db050a6777e$var$cacheCount++;
    }
    return compiledGenerator;
};
/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */ var $e49a8db050a6777e$var$generatePath = function generatePath() {
    var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (pattern === "/") return pattern;
    var generator = $e49a8db050a6777e$var$compileGenerator(pattern);
    return generator(params, {
        pretty: true
    });
};
var $e49a8db050a6777e$export$2e2bcd8739ae039 = $e49a8db050a6777e$var$generatePath;

});


parcelRegister("e8LPn", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4b6e9a2b5461b16$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1Qivz = parcelRequire("1Qivz");

var $k6muC = parcelRequire("k6muC");

var $h8TzT = parcelRequire("h8TzT");

var $1d3eD = parcelRequire("1d3eD");
function $a4b6e9a2b5461b16$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $a4b6e9a2b5461b16$var$_possibleConstructorReturn(self, call) {
    if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function $a4b6e9a2b5461b16$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
    if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * The public API for rendering the first <Route> that matches.
 */ var $a4b6e9a2b5461b16$var$Switch = function(_React$Component) {
    $a4b6e9a2b5461b16$var$_inherits(Switch, _React$Component);
    function Switch() {
        $a4b6e9a2b5461b16$var$_classCallCheck(this, Switch);
        return $a4b6e9a2b5461b16$var$_possibleConstructorReturn(this, _React$Component.apply(this, arguments));
    }
    Switch.prototype.componentWillMount = function componentWillMount() {
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(this.context.router, "You should not use <Switch> outside a <Router>");
    };
    Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
        (0, (/*@__PURE__*/$parcel$interopDefault($k6muC)))(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
    };
    Switch.prototype.render = function render() {
        var route = this.context.router.route;
        var children = this.props.children;
        var location = this.props.location || route.location;
        var match = void 0, child = void 0;
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.forEach(children, function(element) {
            if (match == null && (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).isValidElement(element)) {
                var _element$props = element.props, pathProp = _element$props.path, exact = _element$props.exact, strict = _element$props.strict, sensitive = _element$props.sensitive, from = _element$props.from;
                var path = pathProp || from;
                child = element;
                match = (0, $1d3eD.default)(location.pathname, {
                    path: path,
                    exact: exact,
                    strict: strict,
                    sensitive: sensitive
                }, route.match);
            }
        });
        return match ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            location: location,
            computedMatch: match
        }) : null;
    };
    return Switch;
}((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component);
$a4b6e9a2b5461b16$var$Switch.contextTypes = {
    router: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).shape({
        route: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object.isRequired
    }).isRequired
};
$a4b6e9a2b5461b16$var$Switch.propTypes = {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node,
    location: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).object
};
var $a4b6e9a2b5461b16$export$2e2bcd8739ae039 = $a4b6e9a2b5461b16$var$Switch;

});

parcelRegister("40nqT", function(module, exports) {

$parcel$export(module.exports, "discoverRoute", () => $2ea956c07fe86126$export$c99a9931f18128b1);
$parcel$export(module.exports, "discoverAppDetailsRoute", () => $2ea956c07fe86126$export$8bf7f5eeda88b762);
$parcel$export(module.exports, "searchRoute", () => $2ea956c07fe86126$export$5ad8f1ab4ed653ca);
$parcel$export(module.exports, "manageRoute", () => $2ea956c07fe86126$export$e349f564fbf1d9ed);
$parcel$export(module.exports, "manageAppDetailsRoute", () => $2ea956c07fe86126$export$b0ccb067722b100d);
$parcel$export(module.exports, "manageAppRequestsRoute", () => $2ea956c07fe86126$export$ff0abcaf81bc21ac);
$parcel$export(module.exports, "managePromotionsRoute", () => $2ea956c07fe86126$export$13336eab0c29eea0);
$parcel$export(module.exports, "allRoutes", () => $2ea956c07fe86126$export$3ef6d4da8160fa32);

var $g5DHJ = parcelRequire("g5DHJ");

var $gIQkA = parcelRequire("gIQkA");

var $7noAQ = parcelRequire("7noAQ");
const $2ea956c07fe86126$export$c99a9931f18128b1 = (0, $7noAQ.makeRoute)({
    analyticsSourceScreen: (0, $gIQkA.ANALYTICS_SCREEN_DISCOVER),
    path: '/discover'
});
const $2ea956c07fe86126$export$8bf7f5eeda88b762 = (0, $7noAQ.makeRoute)({
    analyticsSourceScreen: (0, $gIQkA.ANALYTICS_SCREEN_APP_LISTING),
    path: '/discover/app/:appKey'
});
const $2ea956c07fe86126$export$5ad8f1ab4ed653ca = (0, $7noAQ.makeRoute)({
    analyticsSourceScreen: (0, $gIQkA.ANALYTICS_SCREEN_SEARCH),
    path: '/discover/search'
});
const $2ea956c07fe86126$export$e349f564fbf1d9ed = (0, $7noAQ.makeRoute)({
    analyticsSourceScreen: (0, $gIQkA.ANALYTICS_SCREEN_MANAGE),
    path: '/manage'
});
const $2ea956c07fe86126$export$b0ccb067722b100d = (0, $7noAQ.makeRoute)({
    analyticsSourceScreen: (0, $gIQkA.ANALYTICS_SCREEN_MANAGE_APP),
    path: '/manage/app/:appKey'
});
const $2ea956c07fe86126$export$ff0abcaf81bc21ac = (0, $7noAQ.makeRoute)({
    analyticsSourceScreen: (0, $gIQkA.ANALYTICS_SCREEN_MANAGE_APP_REQUESTS),
    path: '/manage/app-requests'
});
const $2ea956c07fe86126$export$13336eab0c29eea0 = (0, $7noAQ.makeRoute)({
    analyticsSourceScreen: (0, $gIQkA.ANALYTICS_SCREEN_MANAGE_PROMOTIONS),
    path: '/manage/promotions'
});
const $2ea956c07fe86126$export$3ef6d4da8160fa32 = (0, $g5DHJ.List)([
    $2ea956c07fe86126$export$c99a9931f18128b1,
    $2ea956c07fe86126$export$8bf7f5eeda88b762,
    $2ea956c07fe86126$export$5ad8f1ab4ed653ca,
    $2ea956c07fe86126$export$e349f564fbf1d9ed,
    $2ea956c07fe86126$export$b0ccb067722b100d,
    $2ea956c07fe86126$export$ff0abcaf81bc21ac,
    $2ea956c07fe86126$export$13336eab0c29eea0
]);

});
parcelRegister("gIQkA", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_SCREEN_DISCOVER", () => $c2c959452d1d6b1b$export$24f1b87b13ba61e3);
$parcel$export(module.exports, "ANALYTICS_SCREEN_SEARCH", () => $c2c959452d1d6b1b$export$278ec038bb4ad100);
$parcel$export(module.exports, "ANALYTICS_SCREEN_MANAGE", () => $c2c959452d1d6b1b$export$67243ab0bb3d7e47);
$parcel$export(module.exports, "ANALYTICS_SCREEN_MANAGE_APP", () => $c2c959452d1d6b1b$export$72fb2e30225c98ea);
$parcel$export(module.exports, "ANALYTICS_SCREEN_APP_LISTING", () => $c2c959452d1d6b1b$export$8e7eb5f7cbc03cbf);
$parcel$export(module.exports, "ANALYTICS_SCREEN_MANAGE_APP_REQUESTS", () => $c2c959452d1d6b1b$export$6d0e0ddf2da79435);
$parcel$export(module.exports, "ANALYTICS_SCREEN_MANAGE_PROMOTIONS", () => $c2c959452d1d6b1b$export$29d38ded3cc8a77a);
$parcel$export(module.exports, "ANALYTICS_MODAL_DETERMINING", () => $c2c959452d1d6b1b$export$318fe07bee4f4c7d);
$parcel$export(module.exports, "ANALYTICS_MODAL_INSTALL", () => $c2c959452d1d6b1b$export$a30961778d560f2b);
$parcel$export(module.exports, "ANALYTICS_MODAL_NO_INSTALL_PERMISSION", () => $c2c959452d1d6b1b$export$eec1aa7a61f8149b);
$parcel$export(module.exports, "ANALYTICS_MODAL_CUSTOM_INSTALL", () => $c2c959452d1d6b1b$export$5e00e0e71660e711);
$parcel$export(module.exports, "ANALYTICS_MODAL_CREATE_TOKEN", () => $c2c959452d1d6b1b$export$e4d83c14bb42342d);
$parcel$export(module.exports, "ANALYTICS_MODAL_INSTRUCTIONAL", () => $c2c959452d1d6b1b$export$2f15ba413294aeca);
$parcel$export(module.exports, "ANALYTICS_MODAL_UPGRADE", () => $c2c959452d1d6b1b$export$c9fc5fbc78e644);
$parcel$export(module.exports, "ANALYTICS_MODAL_UNINSTALL_SITE", () => $c2c959452d1d6b1b$export$9aba89b9dc1262de);
$parcel$export(module.exports, "ANALYTICS_MODAL_REQUEST_APP", () => $c2c959452d1d6b1b$export$e128d54ee9d235cf);
$parcel$export(module.exports, "ANALYTICS_MODAL_APPLY_PROMOTIONS", () => $c2c959452d1d6b1b$export$9957d6c8a82195a9);
$parcel$export(module.exports, "ANALYTICS_MODAL_SHOW_TOKEN", () => $c2c959452d1d6b1b$export$aed94a083655c805);
$parcel$export(module.exports, "ANALYTICS_MODAL_APP_REQUEST_COMMENTS_MODAL", () => $c2c959452d1d6b1b$export$dcda41a7b128398);
$parcel$export(module.exports, "ANALYTICS_MODAL_REJECT_REQUEST", () => $c2c959452d1d6b1b$export$3ad5792c5779b5cb);
$parcel$export(module.exports, "ANALYTICS_MODAL_STANDALONE_INSTALL_DETERMINING", () => $c2c959452d1d6b1b$export$3c7698c820ea35b4);
$parcel$export(module.exports, "ANALYTICS_MODAL_STANDALONE_INSTALL", () => $c2c959452d1d6b1b$export$5d5b3d45f5aaffb2);
$parcel$export(module.exports, "ANALYTICS_MODAL_STANDALONE_INSTRUCTIONAL_APP_INSTALL", () => $c2c959452d1d6b1b$export$4bd9df6e7f499a4b);
$parcel$export(module.exports, "ANALYTICS_MODAL_STANDALONE_APP_REQUEST", () => $c2c959452d1d6b1b$export$61e3d8121e1d0224);
$parcel$export(module.exports, "allAnalyticsSources", () => $c2c959452d1d6b1b$export$4765ce0d523b143b);

var $eqVJB = parcelRequire("eqVJB");

var $g5DHJ = parcelRequire("g5DHJ");
const $c2c959452d1d6b1b$export$24f1b87b13ba61e3 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceDiscoverScreen'),
    details: "Front-page 'Marketplace apps' view"
};
const $c2c959452d1d6b1b$export$278ec038bb4ad100 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceSearchScreen'),
    details: 'Search results'
};
const $c2c959452d1d6b1b$export$67243ab0bb3d7e47 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceManageScreen'),
    details: "'Manage apps' view"
};
const $c2c959452d1d6b1b$export$72fb2e30225c98ea = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceManageAppScreen'),
    details: 'Manage permissions etc. for a single app'
};
const $c2c959452d1d6b1b$export$8e7eb5f7cbc03cbf = {
    /* the analytics source value of `embeddedMarketplaceAppListingScreen` is used in vendor-service's Segment integration with partners.
  Any change to this value should be accompanied by a corresponding update in vendor-service.*/ name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceAppListingScreen'),
    details: 'Details for a single app on Marketplace'
};
const $c2c959452d1d6b1b$export$6d0e0ddf2da79435 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceMangeAppRequestsScreen'),
    details: 'A dashboard for the admins to manage the App requests'
};
const $c2c959452d1d6b1b$export$29d38ded3cc8a77a = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceManagePromotionsScreen'),
    details: 'A dashboard for the admins to manage the Promotions'
};
const $c2c959452d1d6b1b$export$cfd261bc93c4dfa = (0, $g5DHJ.Set)([
    $c2c959452d1d6b1b$export$24f1b87b13ba61e3,
    $c2c959452d1d6b1b$export$278ec038bb4ad100,
    $c2c959452d1d6b1b$export$67243ab0bb3d7e47,
    $c2c959452d1d6b1b$export$72fb2e30225c98ea,
    $c2c959452d1d6b1b$export$8e7eb5f7cbc03cbf,
    $c2c959452d1d6b1b$export$6d0e0ddf2da79435,
    $c2c959452d1d6b1b$export$29d38ded3cc8a77a
]);
const $c2c959452d1d6b1b$export$318fe07bee4f4c7d = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceInstallDeterminingModal'),
    details: 'Dialog displayed while determining which install dialog to use'
};
const $c2c959452d1d6b1b$export$a30961778d560f2b = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceInstallModal'),
    details: 'Install dialog for Two Legged apps and deep-linked installs'
};
const $c2c959452d1d6b1b$export$eec1aa7a61f8149b = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceNoInstallPermissionModal'),
    details: 'Install dialog for Two Legged apps and deep-linked installs but the user does not have install permissions'
};
const $c2c959452d1d6b1b$export$5e00e0e71660e711 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceInstallCustomModal'),
    details: "Custom app dialog with the 'Installation URL' tab selected"
};
const $c2c959452d1d6b1b$export$e4d83c14bb42342d = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceCreateTokenModal'),
    details: "Custom app dialog with the 'API tokens' tab selected"
};
const $c2c959452d1d6b1b$export$2f15ba413294aeca = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceInstallInstructionalModal'),
    details: 'Install dialog for Marketplace listings that are just instructions to follow'
};
const $c2c959452d1d6b1b$export$c9fc5fbc78e644 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceUpgradeModal'),
    details: 'Upgrade dialog for Two Legged apps'
};
const $c2c959452d1d6b1b$export$9aba89b9dc1262de = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceUninstallFromSiteConfirmModal'),
    details: 'Dialog confirming if you want to uninstall an app from the whole site'
};
const $c2c959452d1d6b1b$export$e128d54ee9d235cf = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceRequestAppModal'),
    details: 'Request app dialog when the user clicks on request app button'
};
const $c2c959452d1d6b1b$export$9957d6c8a82195a9 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceApplyPromotionModal'),
    details: 'Apply promotions dialog when the user clicks on apply promotions button'
};
const $c2c959452d1d6b1b$export$aed94a083655c805 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceShowTokenModal'),
    details: 'Dialog displaying a token and how to use it'
};
const $c2c959452d1d6b1b$export$dcda41a7b128398 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceAppRequestCommentsModal'),
    details: 'Dialog displaying the request comments from end users to the admin'
};
const $c2c959452d1d6b1b$export$3ad5792c5779b5cb = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('embeddedMarketplaceRejectRequestModal'),
    details: 'Modal when admin replies and rejects requests for an app'
};
const $c2c959452d1d6b1b$export$6ffde31c344c6e55 = (0, $g5DHJ.Set)([
    $c2c959452d1d6b1b$export$318fe07bee4f4c7d,
    $c2c959452d1d6b1b$export$eec1aa7a61f8149b,
    $c2c959452d1d6b1b$export$a30961778d560f2b,
    $c2c959452d1d6b1b$export$5e00e0e71660e711,
    $c2c959452d1d6b1b$export$e4d83c14bb42342d,
    $c2c959452d1d6b1b$export$2f15ba413294aeca,
    $c2c959452d1d6b1b$export$c9fc5fbc78e644,
    $c2c959452d1d6b1b$export$9aba89b9dc1262de,
    $c2c959452d1d6b1b$export$aed94a083655c805,
    $c2c959452d1d6b1b$export$e128d54ee9d235cf,
    $c2c959452d1d6b1b$export$dcda41a7b128398,
    $c2c959452d1d6b1b$export$3ad5792c5779b5cb,
    $c2c959452d1d6b1b$export$9957d6c8a82195a9
]);
const $c2c959452d1d6b1b$export$3c7698c820ea35b4 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('marketplaceInstallDeterminingModal'),
    details: 'Dialog displayed while determining which install dialog to use',
    type: (0, $eqVJB.SCREEN_EVENT_TYPE)
};
const $c2c959452d1d6b1b$export$5d5b3d45f5aaffb2 = {
    /* the analytics source value of `marketplaceInstallModal` is used in vendor-service's Segment integration with partners.
  Any change to this value should be accompanied by a corresponding update in vendor-service.*/ name: (0, $eqVJB.makeAnalyticsSourceID)('marketplaceInstallModal'),
    details: 'Dialog displayed for installable apps with scopes information and other app details',
    type: (0, $eqVJB.SCREEN_EVENT_TYPE)
};
const $c2c959452d1d6b1b$export$4bd9df6e7f499a4b = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('marketplaceInstallInstructionalModal'),
    details: 'Dialog displayed for instructional apps that are just instructions to follow',
    type: (0, $eqVJB.SCREEN_EVENT_TYPE)
};
const $c2c959452d1d6b1b$export$61e3d8121e1d0224 = {
    name: (0, $eqVJB.makeAnalyticsSourceID)('marketplaceAppRequestModal'),
    details: 'Dialog displayed for requestable apps with app details',
    type: (0, $eqVJB.SCREEN_EVENT_TYPE)
};
const $c2c959452d1d6b1b$export$6573b0643eb8f1a4 = (0, $g5DHJ.Set)([
    $c2c959452d1d6b1b$export$3c7698c820ea35b4,
    $c2c959452d1d6b1b$export$5d5b3d45f5aaffb2,
    $c2c959452d1d6b1b$export$4bd9df6e7f499a4b,
    $c2c959452d1d6b1b$export$61e3d8121e1d0224
]);
const $c2c959452d1d6b1b$export$4765ce0d523b143b = $c2c959452d1d6b1b$export$cfd261bc93c4dfa.concat($c2c959452d1d6b1b$export$6ffde31c344c6e55).concat($c2c959452d1d6b1b$export$6573b0643eb8f1a4);

});

parcelRegister("7noAQ", function(module, exports) {

$parcel$export(module.exports, "makeRoute", () => $55edc219c91a8324$export$9267e3c26c007dbc);

var $g5DHJ = parcelRequire("g5DHJ");

var $gIQkA = parcelRequire("gIQkA");
const $55edc219c91a8324$export$9267e3c26c007dbc = (0, $g5DHJ.Record)({
    analyticsSourceScreen: (0, $gIQkA.ANALYTICS_SCREEN_DISCOVER),
    path: ''
});

});


parcelRegister("iEgm6", function(module, exports) {

$parcel$export(module.exports, "preventDefault", () => $d938a645954b3a98$export$fa3b29edae795ef4);
$parcel$export(module.exports, "resolveFieldWithFallback", () => $d938a645954b3a98$export$6a5792c6e27b1800);
$parcel$export(module.exports, "getApplicationConfigForEnv", () => $d938a645954b3a98$export$80d83565c33cd5d6);
$parcel$export(module.exports, "mapBootstrapEnvToDeployEnv", () => $d938a645954b3a98$export$6b882a98975effc4);
/* eslint-disable import/default -- Rule isn't able to locate CJS style exports */ 
var $gz4uF = parcelRequire("gz4uF");

var $lPbX1 = parcelRequire("lPbX1");

var $648aQ = parcelRequire("648aQ");

var $jnh8o = parcelRequire("jnh8o");
function $d938a645954b3a98$export$83358b067e369e2d() {
/* do nothing */ }
function $d938a645954b3a98$export$fa3b29edae795ef4(e) {
    e.preventDefault();
}
function $d938a645954b3a98$export$6a5792c6e27b1800(resolve, maybePrimary, fallback) {
    return resolve(maybePrimary || fallback);
}
const $d938a645954b3a98$export$80d83565c33cd5d6 = (environment)=>{
    switch(environment){
        case 'local':
            return 0, $lPbX1.default;
        case 'dev':
            return 0, $gz4uF.default;
        case 'staging':
            return 0, $jnh8o.default;
        case 'prod':
            return 0, $648aQ.default;
        default:
            throw new Error('Invalid environment provided: ' + environment);
    }
};
const $d938a645954b3a98$export$6b882a98975effc4 = (environment)=>{
    switch(environment){
        case 'local':
            return 'local';
        case 'dev':
            return 'development';
        case 'staging':
            return 'staging';
        case 'prod':
            return 'production';
        default:
            console.error('Invalid environment provided: ' + environment);
            return 'production';
    }
};

});
parcelRegister("gz4uF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0f366942bec1deb$export$2e2bcd8739ae039);

var $9HvFc = parcelRequire("9HvFc");
const $c0f366942bec1deb$var$developmentConfig = {
    feedbackCollectorApiKeys: {
        privacyAndSecurity: {
            entrypointId: 'a1b01fe7-d62a-402c-8523-0d3edd4ffede'
        },
        generalFeedback: {
            entrypointId: '382c9b92-a4ff-45d1-bd4d-237ce0f5ac9f'
        }
    },
    stargateBaseUrl: 'https://api.stg.atlassian.com',
    adminHubBaseUrl: 'https://admin.stg.atlassian.com',
    algolia: {
        applicationId: '7LVR1JKTDF',
        apiKey: 'a341f16064d5bffd0ef8ea56b8099661',
        environment: 'stg'
    },
    analytics: {
        productAnalytics: {
            env: 'dev'
        }
    },
    featureFlags: {
        apiKey: '455fa60a-debf-4a78-8ec0-7fef7a97ae70',
        environment: (0, $9HvFc.EnvironmentType).DEV
    },
    feedbackGatewayBaseUrl: 'https://marketplace.stg.internal.atlassian.com/gateway/api',
    mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    sentry: {
        dsn: 'https://7dffd006b22a440ebf23b41ff691432e@sentry.io/1464982',
        environment: 'development'
    },
    showDevtools: true,
    metal: {
        id: '26e25bc0-12d0-41d7-a9ec-1e080b812477',
        env: 'dev'
    },
    host: 'https://emcee.dev.internal.atlassian.com',
    graphQLGatewayUrl: 'https://api.stg.atlassian.com/graphql',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
    macBaseUrl: 'https://my.stg.internal.atlassian.com',
    wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
    environment: 'dev'
};
var $c0f366942bec1deb$export$2e2bcd8739ae039 = $c0f366942bec1deb$var$developmentConfig;

});
parcelRegister("9HvFc", function(module, exports) {

$parcel$export(module.exports, "Identifiers", () => $13e83a96f17a253c$export$9c27ea27f5856c02);
$parcel$export(module.exports, "EvaluationReason", () => $13e83a96f17a253c$export$c62558b199e46828);
$parcel$export(module.exports, "EvaluationErrorKind", () => $13e83a96f17a253c$export$d7bcec3eec83269a);
$parcel$export(module.exports, "ExposureType", () => $13e83a96f17a253c$export$5cea6b86291cee7a);
$parcel$export(module.exports, "EnvironmentType", () => $13e83a96f17a253c$export$76c40c36845e9385);
$parcel$export(module.exports, "PerimeterType", () => $13e83a96f17a253c$export$c42b7bbc5e7ba555);
$parcel$export(module.exports, "ReadyReason", () => $13e83a96f17a253c$export$efeb3009918d958);
$parcel$export(module.exports, "LogLevel", () => $13e83a96f17a253c$export$243e62d78d3b544d);
var $13e83a96f17a253c$export$9c27ea27f5856c02;
(function(Identifiers) {
    Identifiers["ANALYTICS_ANONYMOUS_ID"] = "analyticsAnonymousId";
    Identifiers["ATLASSIAN_ACCOUNT_ID"] = "atlassianAccountId";
    Identifiers["ATLASSIAN_ORG_ID"] = "atlassianOrgId";
    Identifiers["TENANT_ID"] = "tenantId";
    Identifiers["TRELLO_ANONYMOUS_ID"] = "trelloAnonymousId";
    Identifiers["TRELLO_USER_ID"] = "trelloUserId";
    Identifiers["FF_CLIENT_ANONYMOUS_ID"] = "ffClientAnonymousId";
})($13e83a96f17a253c$export$9c27ea27f5856c02 || ($13e83a96f17a253c$export$9c27ea27f5856c02 = {}));
var $13e83a96f17a253c$export$c62558b199e46828;
(function(EvaluationReason) {
    EvaluationReason["OFF"] = "OFF";
    EvaluationReason["FALLTHROUGH"] = "FALLTHROUGH";
    EvaluationReason["RULE_MATCH"] = "RULE_MATCH";
    EvaluationReason["TARGET_MATCH"] = "TARGET_MATCH";
    EvaluationReason["PREREQUISITE_FAILED"] = "PREREQUISITE_FAILED";
    EvaluationReason["ERROR"] = "ERROR";
    EvaluationReason["INELIGIBLE"] = "INELIGIBLE";
    EvaluationReason["OVERRIDE"] = "OVERRIDE";
})($13e83a96f17a253c$export$c62558b199e46828 || ($13e83a96f17a253c$export$c62558b199e46828 = {}));
var $13e83a96f17a253c$export$d7bcec3eec83269a;
(function(EvaluationErrorKind) {
    EvaluationErrorKind["CLIENT_NOT_READY"] = "CLIENT_NOT_READY";
    EvaluationErrorKind["FLAG_NOT_FOUND"] = "FLAG_NOT_FOUND";
    EvaluationErrorKind["WRONG_TYPE"] = "WRONG_TYPE";
    EvaluationErrorKind["VALIDATION_ERROR"] = "VALIDATION_ERROR";
    EvaluationErrorKind["SERVER_ERROR"] = "SERVER_ERROR";
    EvaluationErrorKind["OTHER"] = "OTHER";
})($13e83a96f17a253c$export$d7bcec3eec83269a || ($13e83a96f17a253c$export$d7bcec3eec83269a = {}));
var $13e83a96f17a253c$export$5cea6b86291cee7a;
(function(ExposureType) {
    // Consumer sets shouldSendExposureEvent to true
    ExposureType["OptIn"] = "optInExposure";
    // Consumer does not pass in shouldSendExposureEvent (fired as part of TAC)
    ExposureType["Automatic"] = "autoExposure";
    // Consumer sent custom attributes along with the request (this is used in addition to the above)
    ExposureType["HasCustomAttributes"] = "hasCustomAttributes";
})($13e83a96f17a253c$export$5cea6b86291cee7a || ($13e83a96f17a253c$export$5cea6b86291cee7a = {}));
var $13e83a96f17a253c$export$76c40c36845e9385;
(function(EnvironmentType) {
    EnvironmentType["LOCAL"] = "local";
    EnvironmentType["DEV"] = "dev";
    EnvironmentType["STAGING"] = "staging";
    EnvironmentType["PROD"] = "prod";
})($13e83a96f17a253c$export$76c40c36845e9385 || ($13e83a96f17a253c$export$76c40c36845e9385 = {}));
var $13e83a96f17a253c$export$c42b7bbc5e7ba555;
(function(PerimeterType) {
    PerimeterType["FEDRAMP_MODERATE"] = "fedramp-moderate";
})($13e83a96f17a253c$export$c42b7bbc5e7ba555 || ($13e83a96f17a253c$export$c42b7bbc5e7ba555 = {}));
var $13e83a96f17a253c$export$efeb3009918d958;
(function(ReadyReason) {
    ReadyReason["CACHE"] = "CACHE";
    ReadyReason["FETCH"] = "FETCH";
    ReadyReason["CLIENT_ERROR"] = "CLIENT_ERROR";
    ReadyReason["SERVER_ERROR"] = "SERVER_ERROR";
})($13e83a96f17a253c$export$efeb3009918d958 || ($13e83a96f17a253c$export$efeb3009918d958 = {}));
var $13e83a96f17a253c$export$243e62d78d3b544d;
(function(LogLevel) {
    // Dont use 0 to prevent falsy values
    LogLevel[LogLevel["DEBUG"] = 1] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 2] = "INFO";
    LogLevel[LogLevel["LOG"] = 3] = "LOG";
    LogLevel[LogLevel["WARN"] = 4] = "WARN";
    LogLevel[LogLevel["ERROR"] = 5] = "ERROR";
})($13e83a96f17a253c$export$243e62d78d3b544d || ($13e83a96f17a253c$export$243e62d78d3b544d = {}));

});


parcelRegister("lPbX1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe37a19d954bf7ce$export$2e2bcd8739ae039);

var $9HvFc = parcelRequire("9HvFc");
var $8z3dZ = parcelRequire("8z3dZ");
const $fe37a19d954bf7ce$var$localConfig = {
    feedbackCollectorApiKeys: {
        privacyAndSecurity: {
            entrypointId: 'a1b01fe7-d62a-402c-8523-0d3edd4ffede'
        },
        generalFeedback: {
            entrypointId: '382c9b92-a4ff-45d1-bd4d-237ce0f5ac9f'
        }
    },
    stargateBaseUrl: 'https://api.stg.atlassian.com',
    adminHubBaseUrl: 'https://admin.stg.atlassian.com',
    algolia: {
        applicationId: '7LVR1JKTDF',
        apiKey: '15f50298dd61ef869dcbf0db33add5fd',
        environment: 'stg'
    },
    sentry: {
        dsn: 'https://7dffd006b22a440ebf23b41ff691432e@sentry.io/1464982',
        environment: 'local'
    },
    analytics: {
        productAnalytics: {
            env: 'local'
        }
    },
    host: '',
    featureFlags: {
        apiKey: '455fa60a-debf-4a78-8ec0-7fef7a97ae70',
        environment: (0, $9HvFc.EnvironmentType).DEV
    },
    statsig: {
        // confluence dev -- 1a9e352b-a0c4-4678-8f09-6a43d1e2b0cc
        // jira dev -- 8da3f751-e5a7-4a9c-8d33-425bf098fbe8
        // compass dev -- a78a83e2-f9e2-46e6-8ac9-046360f8a1ba
        clientKey: '8da3f751-e5a7-4a9c-8d33-425bf098fbe8',
        environment: (0, $8z3dZ.FeatureGateEnvironment).Development,
        targetApp: 'jira_web' // options are jira_web, confluence_web, compass_web
    },
    mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    feedbackGatewayBaseUrl: 'https://marketplace.stg.internal.atlassian.com/gateway/api',
    mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    showDevtools: true,
    metal: {
        id: '26e25bc0-12d0-41d7-a9ec-1e080b812477',
        env: 'local'
    },
    graphQLGatewayUrl: 'https://api.stg.atlassian.com/graphql',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
    macBaseUrl: 'https://my.stg.internal.atlassian.com',
    wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
    environment: 'local'
};
var $fe37a19d954bf7ce$export$2e2bcd8739ae039 = $fe37a19d954bf7ce$var$localConfig;

});

parcelRegister("648aQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $46a974fbd3669134$export$2e2bcd8739ae039);

var $9HvFc = parcelRequire("9HvFc");
const $46a974fbd3669134$var$productionConfig = {
    feedbackCollectorApiKeys: {
        privacyAndSecurity: {
            entrypointId: 'a1b01fe7-d62a-402c-8523-0d3edd4ffede'
        },
        generalFeedback: {
            entrypointId: '382c9b92-a4ff-45d1-bd4d-237ce0f5ac9f'
        }
    },
    stargateBaseUrl: 'https://api.atlassian.com',
    adminHubBaseUrl: 'https://admin.atlassian.com',
    algolia: {
        applicationId: '7LVR1JKTDF',
        apiKey: '7a76648b718415a8c56fb8fa211c9a95',
        environment: 'prod'
    },
    analytics: {
        productAnalytics: {
            env: 'prod'
        }
    },
    featureFlags: {
        apiKey: '1f5d5f93-c052-4372-bc81-a99b00e04bc0',
        environment: (0, $9HvFc.EnvironmentType).PROD
    },
    mpacBaseUrl: 'https://marketplace.atlassian.com',
    feedbackGatewayBaseUrl: 'https://marketplace.atlassian.com/gateway/api',
    mpacCdnBaseUrl: 'https://marketplace.atlassian.com',
    sentry: {
        dsn: 'https://7dffd006b22a440ebf23b41ff691432e@sentry.io/1464982',
        environment: 'production'
    },
    showDevtools: false,
    host: 'https://emcee.atlassian.com',
    metal: {
        id: '26e25bc0-12d0-41d7-a9ec-1e080b812477',
        env: 'prod'
    },
    graphQLGatewayUrl: 'https://api.atlassian.com/graphql',
    atlassianCommunityBaseUrl: 'https://community.atlassian.com',
    macBaseUrl: 'https://my.atlassian.com',
    wacBaseUrl: 'https://www.atlassian.com',
    environment: 'prod'
};
var $46a974fbd3669134$export$2e2bcd8739ae039 = $46a974fbd3669134$var$productionConfig;

});

parcelRegister("jnh8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1ad74d5a9c32760$export$2e2bcd8739ae039);

var $9HvFc = parcelRequire("9HvFc");
const $e1ad74d5a9c32760$var$stagingConfig = {
    feedbackCollectorApiKeys: {
        privacyAndSecurity: {
            entrypointId: 'a1b01fe7-d62a-402c-8523-0d3edd4ffede'
        },
        generalFeedback: {
            entrypointId: '382c9b92-a4ff-45d1-bd4d-237ce0f5ac9f'
        }
    },
    stargateBaseUrl: 'https://api.stg.atlassian.com',
    adminHubBaseUrl: 'https://admin.stg.atlassian.com',
    algolia: {
        applicationId: '7LVR1JKTDF',
        apiKey: 'f12b1855dca7e6694da17dcfd66e90a8',
        environment: 'stg'
    },
    analytics: {
        productAnalytics: {
            env: 'staging'
        }
    },
    featureFlags: {
        apiKey: '3f02f534-555d-43d9-97d2-55ea3802d0d2',
        environment: (0, $9HvFc.EnvironmentType).STAGING
    },
    mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    feedbackGatewayBaseUrl: 'https://marketplace.stg.internal.atlassian.com/gateway/api',
    mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    sentry: {
        dsn: 'https://7dffd006b22a440ebf23b41ff691432e@sentry.io/1464982',
        environment: 'staging'
    },
    showDevtools: Boolean(undefined),
    host: 'https://emcee.stg.internal.atlassian.com',
    metal: {
        id: '26e25bc0-12d0-41d7-a9ec-1e080b812477',
        env: 'staging'
    },
    graphQLGatewayUrl: 'https://api.stg.atlassian.com/graphql',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
    macBaseUrl: 'https://my.stg.internal.atlassian.com',
    wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
    environment: 'staging'
};
var $e1ad74d5a9c32760$export$2e2bcd8739ae039 = $e1ad74d5a9c32760$var$stagingConfig;

});


parcelRegister("bPtM5", function(module, exports) {

$parcel$export(module.exports, "isEmceeConnect", () => $89cb8dc0a88c7bbc$export$ece6f27231ad5967);
$parcel$export(module.exports, "navigateToProductUrl", () => $89cb8dc0a88c7bbc$export$92b2fd45b013ad9a);
$parcel$export(module.exports, "getLocation", () => $89cb8dc0a88c7bbc$export$e7fd20fad3cf4b5f);

var $5zQU9 = parcelRequire("5zQU9");
function $89cb8dc0a88c7bbc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $89cb8dc0a88c7bbc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $89cb8dc0a88c7bbc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $89cb8dc0a88c7bbc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/* global  __EMCEE_CONNECT__ */ const $89cb8dc0a88c7bbc$export$ece6f27231ad5967 = ()=>typeof __EMCEE_CONNECT__ !== 'undefined';
const $89cb8dc0a88c7bbc$export$92b2fd45b013ad9a = (_ref)=>{
    let { url: url, isRelativeUrl: isRelativeUrl } = _ref;
    if ($89cb8dc0a88c7bbc$export$ece6f27231ad5967()) window.AP.navigator.go('site', $89cb8dc0a88c7bbc$var$_objectSpread({}, isRelativeUrl ? {
        relativeUrl: url
    } : {
        absoluteUrl: url
    }));
    else window.location.href = url;
};
const $89cb8dc0a88c7bbc$export$e7fd20fad3cf4b5f = (callback)=>{
    if ($89cb8dc0a88c7bbc$export$ece6f27231ad5967()) window.AP.getLocation((location)=>{
        callback(location);
    });
    else callback(window.location.href);
};

});

parcelRegister("i6Nih", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2ef063f49f9d2ac$export$2e2bcd8739ae039);
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");

var $7jeh2 = parcelRequire("7jeh2");

var $j8dgx = parcelRequire("j8dgx");

var $8bwkw = parcelRequire("8bwkw");

var $i0k4A = parcelRequire("i0k4A");

var $6BOFf = parcelRequire("6BOFf");

var $hNyxl = parcelRequire("hNyxl");

var $2hUUV = parcelRequire("2hUUV");

var $9nPW9 = parcelRequire("9nPW9");
const $d2ef063f49f9d2ac$var$mapStateToProps = (state)=>({
        analyticsLoadResult: state.analytics.analyticsLoadResult,
        contexts: state.contexts.contexts,
        currentUserId: state.users.currentUserId,
        featureFlags: state.configuration.featureFlags,
        hostConfig: state.configuration.hostConfig,
        hostInfo: state.configuration.hostInfo,
        isContextsLoading: state.contexts.isContextsLoading,
        selectedContext: state.contexts.selectedContext,
        hostPricing: state.hostPricing.hostPricing
    });
const $d2ef063f49f9d2ac$var$mapDispatchToProps = (dispatch, ownProps)=>({
        doRetrieveContexts: (filter)=>dispatch((0, $j8dgx.doRetrieveContexts)(filter)),
        initializeBaseData: (props)=>dispatch((0, $7jeh2.doInitializeBaseData)({
                bootstrapConfig: ownProps.bootstrapConfig,
                statsigClientMpac: props.statsigClientMpac
            })),
        onFeedbackSubmit: ()=>dispatch((0, $8bwkw.addFlag)({
                flag: (0, $2hUUV.feedbackSuccessFlag)
            })),
        onSelectedContextChanged: (newContext)=>dispatch((0, $j8dgx.changeContext)(newContext)),
        openAppSpecificPasswordDialog: (_ref)=>{
            let { name: name } = _ref;
            return dispatch((0, $i0k4A.doStartAppSpecificPasswordInstallMode)({
                name: name
            }));
        },
        openInstallDialog: (_ref2)=>{
            let { installableAppId: installableAppId, relayState: relayState, context: context } = _ref2;
            return dispatch((0, $6BOFf.doInitiateInstallModeForIdentifier)({
                mpacBaseUrl: ownProps.bootstrapConfig.mpacBaseUrl,
                installableAppId: installableAppId,
                relayState: relayState,
                context: context
            }));
        },
        retrieveFreshInstalledApps: (_ref3)=>{
            let { context: context, hostConfig: hostConfig, search: search, flags: flags, offset: offset } = _ref3;
            return dispatch((0, $hNyxl.doRetrieveFreshInstalledApps)({
                context: context,
                hostConfig: hostConfig,
                search: search,
                flags: flags,
                offset: offset
            }));
        }
    });
var $d2ef063f49f9d2ac$export$2e2bcd8739ae039 = (0, $94zHK.default)($d2ef063f49f9d2ac$var$mapStateToProps, $d2ef063f49f9d2ac$var$mapDispatchToProps)((0, $9nPW9.default));

});
parcelRegister("7jeh2", function(module, exports) {

$parcel$export(module.exports, "doInitializeBaseData", () => $5525613efd155ac1$export$5bc0d6afdc70b723);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $bTxOd = parcelRequire("bTxOd");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $7YbkQ = parcelRequire("7YbkQ");

var $kC116 = parcelRequire("kC116");

var $c6kEN = parcelRequire("c6kEN");

var $j2ea9 = parcelRequire("j2ea9");

var $j8dgx = parcelRequire("j8dgx");

var $7hvno = parcelRequire("7hvno");

var $ae44r = parcelRequire("ae44r");

var $G8Qov = parcelRequire("G8Qov");
const $5525613efd155ac1$var$_excluded = [
    "icon"
];
function $5525613efd155ac1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5525613efd155ac1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5525613efd155ac1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5525613efd155ac1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5525613efd155ac1$export$5bc0d6afdc70b723 = (_ref)=>{
    let { bootstrapConfig: bootstrapConfig, statsigClientMpac: statsigClientMpac } = _ref;
    return (dispatch)=>{
        $5525613efd155ac1$var$attemptBaseDataInitialization(dispatch)({
            bootstrapConfig: bootstrapConfig,
            statsigClientMpac: statsigClientMpac
        });
        dispatch((0, $ae44r.doRetrieveScopesLookup)({
            bootstrapConfig: bootstrapConfig
        }));
        dispatch((0, $7hvno.doRetrieveHostPricing)());
    };
};
const $5525613efd155ac1$var$attemptBaseDataInitialization = (dispatch)=>async (_ref2)=>{
        let { bootstrapConfig: bootstrapConfig, statsigClientMpac: statsigClientMpac } = _ref2;
        try {
            // init statsig
            const { statsig: statsigConfig } = bootstrapConfig;
            await statsigClientMpac.initWithStatsigGlobalInstance('PRODUCT');
            const currentUserIdPromise = dispatch((0, $G8Qov.doRetrieveCurrentUserId)());
            const hostInfo = await dispatch((0, $j2ea9.doRetrieveHostInfo)());
            const hostConfig = await dispatch((0, $j2ea9.doRetrieveHostConfig)(hostInfo));
            const frontendBootstrap = await dispatch((0, $j2ea9.doRetrieveFrontendBootstrap)());
            const { enableEmceeAetherExperience: enableEmceeAetherExperience, enableAetherAppListingPage: enableAetherAppListingPage, enableNlpSearch: enableNlpSearch } = statsigClientMpac || {};
            (0, $7YbkQ.default).init(bootstrapConfig, hostConfig, hostInfo);
            const analyticsInstance = (0, $7YbkQ.default).get();
            (0, $bTxOd.initUFO)({
                analyticsClient: analyticsInstance,
                additionalConfig: {
                    product: 'emcee'
                },
                featureFlags: {
                    enableEmceeAetherExperience: enableEmceeAetherExperience(),
                    enableAetherAppListingPage: enableAetherAppListingPage(),
                    enableNlpSearch: enableNlpSearch()
                }
            });
            const currentUserId = await currentUserIdPromise;
            dispatch((0, $j2ea9.doRetrieveFeatureFlags)({
                bootstrapConfig: bootstrapConfig,
                hostConfig: hostConfig,
                hostInfo: hostInfo,
                currentUserId: frontendBootstrap.launchDarklyUserKey
            }));
            await $5525613efd155ac1$var$attemptAnalyticsInitialization(dispatch)({
                bootstrapConfig: bootstrapConfig,
                hostConfig: hostConfig,
                hostInfo: hostInfo,
                currentUserId: currentUserId
            });
            if (hostInfo.supports.context) dispatch((0, $j8dgx.doRetrieveDefaultContext)());
            else if (hostInfo.globalContext) {
                const _hostInfo$globalConte = hostInfo.globalContext, { icon: hostInfoIcon } = _hostInfo$globalConte, context = (0, $bwPfh.default)(_hostInfo$globalConte, $5525613efd155ac1$var$_excluded);
                const icon = hostConfig.globalContext.flatMap((gc)=>gc.icon).orElse((0, $bWAru.Option).of(hostInfoIcon).map((0, $kC116.makeUrlContextIcon)));
                dispatch((0, $j8dgx.changeContext)((0, $kC116.makeContext)($5525613efd155ac1$var$_objectSpread($5525613efd155ac1$var$_objectSpread({}, context), {}, {
                    icon: icon
                }))));
            }
        } catch (error) {
            console.error(error);
        }
    };
const $5525613efd155ac1$var$attemptAnalyticsInitialization = (dispatch)=>async (_ref3)=>{
        let { bootstrapConfig: bootstrapConfig, hostConfig: hostConfig, hostInfo: hostInfo, currentUserId: currentUserId } = _ref3;
        try {
            await dispatch(dispatch((0, $c6kEN.doInitializeAnalytics)({
                bootstrapConfig: bootstrapConfig,
                hostConfig: hostConfig,
                hostInfo: hostInfo,
                currentUserId: currentUserId
            })));
        } catch (error) {
            console.error(error);
        }
    };

});
parcelRegister("bTxOd", function(module, exports) {

$parcel$export(module.exports, "initUFO", () => $8a8f0e817025245d$export$af995ee1d7017fea);

var $5zQU9 = parcelRequire("5zQU9");

var $feecd = parcelRequire("feecd");

var $bFmE8 = parcelRequire("bFmE8");

var $dCBMq = parcelRequire("dCBMq");
function $8a8f0e817025245d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8a8f0e817025245d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8a8f0e817025245d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8a8f0e817025245d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8a8f0e817025245d$export$af995ee1d7017fea(_ref) {
    let { analyticsClient: analyticsClient, additionalConfig: additionalConfig, featureFlags: featureFlags } = _ref;
    const config = {
        product: (additionalConfig === null || additionalConfig === void 0 ? void 0 : additionalConfig.product) || 'marketplace',
        region: 'unknown',
        kind: {
            hover: 0,
            legacy: 0,
            page_load: 1,
            press: 1,
            transition: 1,
            typing: 0
        },
        namePrefix: 'ufo-',
        segmentPrefix: 'ufo-',
        capability: {
            feature_flag_access: 1,
            react_profiler: 1
        }
    };
    if (!config) return;
    // Use this cautiously, as this will increase the payload size. So no every flag needs to be passed to react-ufo
    if (featureFlags) Object.entries(featureFlags).forEach((_ref2)=>{
        let [flagKey, flagValue] = _ref2;
        (0, $feecd.addFeatureFlagAccessed)(flagKey, flagValue);
    });
    const getAnalyticsWebClient = ()=>{
        return new Promise((resolve)=>{
            resolve(analyticsClient);
        });
    };
    (0, $bFmE8.init)(getAnalyticsWebClient(), $8a8f0e817025245d$var$_objectSpread({}, config));
    (0, $dCBMq.default)();
}

});
parcelRegister("dCBMq", function(module, exports) {

$parcel$export(module.exports, "default", () => $9eac2150addf3717$export$2e2bcd8739ae039);

var $kKX6l = parcelRequire("kKX6l");
var $9eac2150addf3717$export$2e2bcd8739ae039 = (0, $kKX6l.default);

});


parcelRegister("5jwNO", function(module, exports) {
$parcel$export(module.exports, "Either", () => (parcelRequire("bWAru")).Either);
$parcel$export(module.exports, "Option", () => (parcelRequire("bWAru")).Option);
/*!
 * Copyright (c) 2017-2018 by The Funfix Project Developers.
 * Some rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ parcelRequire("7ARg3");
parcelRequire("4grBR");
parcelRequire("bWAru");

var $iMUUJ = parcelRequire("iMUUJ");

});
parcelRegister("7ARg3", function(module, exports) {

$parcel$export(module.exports, "is", () => $587535221f74d65c$export$226b3eccf92c9ed9);
$parcel$export(module.exports, "hashCode", () => $587535221f74d65c$export$d41d9ab3de2def3d);
/*!
 * Copyright (c) 2017-2018 by The Funfix Project Developers.
 * Some rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Test if the given reference is a value object.
 *
 * Value objects are objects that implement the [[IEquals]]
 * interface.
 *
 * @param ref is the reference to test
 */ function $587535221f74d65c$export$b24f7407c77e5bd(ref) {
    return !!(ref && typeof ref.equals === "function" && typeof ref.hashCode === "function");
}
function $587535221f74d65c$export$226b3eccf92c9ed9(lh, rh) {
    if (lh === rh || lh !== lh && rh !== rh) return true;
    if (!lh || !rh) return false;
    /* istanbul ignore else */ /* tslint:disable-next-line:strict-type-predicates */ if (typeof lh.valueOf === "function" && typeof rh.valueOf === "function") {
        const lh2 = lh.valueOf();
        const rh2 = rh.valueOf();
        if (lh2 === rh2 || lh2 !== lh2 && rh2 !== rh2) return true;
        if (!lh2 || !rh2) return false;
    }
    // noinspection PointlessBooleanExpressionJS
    return !!($587535221f74d65c$export$b24f7407c77e5bd(lh) && lh.equals(rh));
}
function $587535221f74d65c$export$e9bab7fafb253603(lh, rh) {
    return $587535221f74d65c$export$226b3eccf92c9ed9(lh, rh);
}
const $587535221f74d65c$export$280f210877e5565b = {
    equals: $587535221f74d65c$export$e9bab7fafb253603
};
function $587535221f74d65c$export$d41d9ab3de2def3d(ref) {
    if (typeof ref === "number") return ref & ref;
    /* istanbul ignore else */ if (typeof ref.valueOf === "function") {
        const v = ref.valueOf();
        if (v !== ref) return $587535221f74d65c$export$d41d9ab3de2def3d(v);
    }
    if ($587535221f74d65c$export$b24f7407c77e5bd(ref)) return ref.hashCode();
    return $587535221f74d65c$export$39e05520a596a3da(String(ref));
}
function $587535221f74d65c$export$39e05520a596a3da(str) {
    let hash = 0;
    /* tslint:disable-next-line:strict-type-predicates */ if (str == null || str.length === 0) return hash;
    for(let i = 0; i < str.length; i++){
        const character = str.charCodeAt(i);
        hash = (hash << 5) - hash + character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}
function $587535221f74d65c$export$d560c7e4a29451c2(a) {
    return a;
}
function $587535221f74d65c$export$6ccb92ce135089b4(derivedCtor, baseCtors) {
    baseCtors.forEach((baseCtor)=>{
        Object.getOwnPropertyNames(baseCtor.prototype).forEach((name)=>{
            if (!derivedCtor.prototype[name]) derivedCtor.prototype[name] = baseCtor.prototype[name];
        });
    });
}

});

parcelRegister("4grBR", function(module, exports) {

$parcel$export(module.exports, "NoSuchElementError", () => $31ae12baa758f3ba$export$48d368d160387990);
/*!
 * Copyright (c) 2017-2018 by The Funfix Project Developers.
 * Some rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * A composite error represents a list of errors that were caught
 * while executing logic which delays re-throwing of errors.
 */ class $31ae12baa758f3ba$export$6fbeb926bac523c3 extends Error {
    constructor(errors){
        let reasons = "";
        for (const e of errors.slice(0, 2)){
            let message = "";
            if (e instanceof Error) message = `${e.name}(${e.message})`;
            else message = `${e}`;
            reasons += ", " + message;
        }
        reasons = reasons.slice(2);
        if (errors.length > 2) reasons = reasons + ", ...";
        super(reasons);
        this.name = "CompositeError";
        this.errorsRef = errors;
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$6fbeb926bac523c3;
        self.__proto__ = $31ae12baa758f3ba$export$6fbeb926bac523c3.prototype;
    }
    /**
     * Returns the full list of caught errors.
     */ errors() {
        return this.errorsRef.slice();
    }
}
class $31ae12baa758f3ba$export$4a48f57740b5ad1e extends Error {
    constructor(message){
        super(message);
        this.name = "DummyError";
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$4a48f57740b5ad1e;
        self.__proto__ = $31ae12baa758f3ba$export$4a48f57740b5ad1e.prototype;
    }
}
class $31ae12baa758f3ba$export$48d368d160387990 extends Error {
    constructor(message){
        super(message);
        this.name = "NoSuchElementError";
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$48d368d160387990;
        self.__proto__ = $31ae12baa758f3ba$export$48d368d160387990.prototype;
    }
}
class $31ae12baa758f3ba$export$e6c18cacaad31d56 extends Error {
    constructor(message){
        super(message);
        this.name = "IllegalInheritanceError";
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$e6c18cacaad31d56;
        self.__proto__ = $31ae12baa758f3ba$export$e6c18cacaad31d56.prototype;
    }
}
class $31ae12baa758f3ba$export$25b19446f82d7080 extends Error {
    constructor(message){
        super(message);
        this.name = "IllegalStateError";
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$25b19446f82d7080;
        self.__proto__ = $31ae12baa758f3ba$export$25b19446f82d7080.prototype;
    }
}
class $31ae12baa758f3ba$export$10a4c2bfc9c71dbd extends Error {
    constructor(message){
        super(message);
        this.name = "IllegalArgumentError";
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$10a4c2bfc9c71dbd;
        self.__proto__ = $31ae12baa758f3ba$export$10a4c2bfc9c71dbd.prototype;
    }
}
class $31ae12baa758f3ba$export$e162153238934121 extends Error {
    constructor(message){
        super(message);
        this.name = "NotImplementedError";
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$e162153238934121;
        self.__proto__ = $31ae12baa758f3ba$export$e162153238934121.prototype;
    }
}
class $31ae12baa758f3ba$export$66d311bf29d5c89c extends Error {
    constructor(message){
        super(message);
        this.name = "TimeoutError";
        // Workaround to make `instanceof` work in ES5
        const self = this;
        self.constructor = $31ae12baa758f3ba$export$66d311bf29d5c89c;
        self.__proto__ = $31ae12baa758f3ba$export$66d311bf29d5c89c.prototype;
    }
}

});

parcelRegister("bWAru", function(module, exports) {

$parcel$export(module.exports, "Either", () => $8b21612c25971c7b$export$37cbe166bfc81b63);
$parcel$export(module.exports, "Option", () => $8b21612c25971c7b$export$36d18380658d5d20);
/*!
 * Copyright (c) 2017-2018 by The Funfix Project Developers.
 * Some rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ 
var $7ARg3 = parcelRequire("7ARg3");

var $4grBR = parcelRequire("4grBR");

var $iMUUJ = parcelRequire("iMUUJ");
class $8b21612c25971c7b$export$37cbe166bfc81b63 {
    constructor(value, tag){
        this._isRight = tag === "right";
        this.value = value;
    }
    /**
     * Returns `true` if this is a `left`, `false` otherwise.
     *
     * ```typescript
     * Left("hello").isLeft() // true
     * Right(10).isLeft() // false
     * ```
     */ isLeft() {
        return !this._isRight;
    }
    /**
     * Returns `true` if this is a `right`, `false` otherwise.
     *
     * ```typescript
     * Left("hello").isRight() // false
     * Right(10).isRight() // true
     * ```
     */ isRight() {
        return this._isRight;
    }
    /**
     * Returns true if this is a Right and its value is equal to `elem`
     * (as determined by the `equals` protocol), returns `false` otherwise.
     *
     * ```typescript
     * // True
     * Right("something").contains("something")
     *
     * // False because the values are different
     * Right("something").contains("anything") // false
     *
     * // False because the source is a `left`
     * Left("something").contains("something") // false
     * ```
     */ contains(elem) {
        return this._isRight && $7ARg3.is(this.value, elem);
    }
    /**
     * Returns `false` if the source is a `left`, or returns the result
     * of the application of the given predicate to the `right` value.
     *
     * ```typescript
     * // True, because it is a right and predicate holds
     * Right(20).exists(n => n > 10)
     *
     * // False, because the predicate returns false
     * Right(10).exists(n => n % 2 != 0)
     *
     * // False, because it is a left
     * Left(10).exists(n => n == 10)
     * ```
     */ exists(p) {
        return this._isRight && p(this.value);
    }
    /**
     * Filters `right` values with the given predicate, returning
     * the value generated by `zero` in case the source is a `right`
     * value and the predicate doesn't hold.
     *
     * Possible outcomes:
     *
     *  - Returns the existing value of `right` if this is a `right` value and the
     *    given predicate `p` holds for it
     *  - Returns `Left(zero())` if this is a `right` value
     *    and the given predicate `p` does not hold
     *  - Returns the current "left" value, if the source is a `Left`
     *
     * ```typescript
     * Right(12).filterOrElse(x => x > 10, () => -1) // Right(12)
     * Right(7).filterOrElse(x => x > 10, () => -1)  // Left(-1)
     * Left(7).filterOrElse(x => false, () => -1)    // Left(7)
     * ```
     */ filterOrElse(p, zero) {
        return this._isRight ? p(this.value) ? this : $8b21612c25971c7b$export$37c4d04eafdc5515(zero()) : this;
    }
    /**
     * Binds the given function across `right` values.
     *
     * This operation is the monadic "bind" operation.
     * It can be used to *chain* multiple `Either` references.
     */ flatMap(f) {
        return this._isRight ? f(this.value) : this;
    }
    /** Alias for [[flatMap]]. */ chain(f) {
        return this.flatMap(f);
    }
    /**
     * `Applicative` apply operator.
     *
     * Resembles {@link map}, but the passed mapping function is
     * lifted in the `Either` context.
     */ ap(ff) {
        return ff.flatMap((f)=>this.map(f));
    }
    /**
     * Applies the `left` function to [[Left]] values, and the
     * `right` function to [[Right]] values and returns the result.
     *
     * ```typescript
     * const maybeNum: Either<string, number> =
     *   tryParseInt("not a number")
     *
     * const result: string =
     *   maybeNum.fold(
     *     str => `Could not parse string: ${str}`,
     *     num => `Success: ${num}`
     *   )
     * ```
     */ fold(left, right) {
        return this._isRight ? right(this.value) : left(this.value);
    }
    /**
     * Returns true if the source is a `left` or returns
     * the result of the application of the given predicate to the
     * `right` value.
     *
     * ```typescript
     * // True, because it is a `left`
     * Left("hello").forAll(x => x > 10)
     *
     * // True, because the predicate holds
     * Right(20).forAll(x => x > 10)
     *
     * // False, it's a right and the predicate doesn't hold
     * Right(7).forAll(x => x > 10)
     * ```
     */ forAll(p) {
        return !this._isRight || p(this.value);
    }
    /**
     * Returns the `Right` value, if the source has one,
     * otherwise throws an exception.
     *
     * WARNING!
     *
     * This function is partial, the `Either` must be a `Right`, otherwise
     * a runtime exception will get thrown. Use with care.
     *
     * @throws [[NoSuchElementError]] in case the the `Either` is a `Left`
     */ get() {
        if (this._isRight) return this.value;
        throw new (0, $4grBR.NoSuchElementError)("left.get()");
    }
    /**
     * Returns the value from this `right` or the given `fallback`
     * value if this is a `left`.
     *
     * ```typescript
     * Right(10).getOrElse(27) // 10
     * Left(10).getOrElse(27)  // 27
     * ```
     */ getOrElse(fallback) {
        return this._isRight ? this.value : fallback;
    }
    /**
     * Returns the value from this `right` or a value generated
     * by the given `thunk` if this is a `left`.
     *
     * ```typescript
     * Right(10).getOrElseL(() => 27) // 10
     * Left(10).getOrElseL(() => 27)  // 27
     * ```
     */ getOrElseL(thunk) {
        return this._isRight ? this.value : thunk();
    }
    /**
     * Transform the source if it is a `right` with the given
     * mapping function.
     *
     * ```typescript
     * Right(10).map(x => x + 17) // right(27)
     * Left(10).map(x => x + 17)  // left(10)
     * ```
     */ map(f) {
        return this._isRight ? $8b21612c25971c7b$export$19db0165690c701a(f(this.value)) : this;
    }
    /**
     * Executes the given side-effecting function if the
     * source is a `right` value.
     *
     * ```typescript
     * Right(12).forAll(console.log) // prints 12
     * Left(10).forAll(console.log)  // silent
     * ```
     */ forEach(cb) {
        if (this._isRight) cb(this.value);
    }
    /**
     * If this is a `left`, then return the left value as a `right`
     * or vice versa.
     *
     * ```typescript
     * Right(10).swap() // left(10)
     * Left(20).swap()  // right(20)
     * ```
     */ swap() {
        return this._isRight ? $8b21612c25971c7b$export$37c4d04eafdc5515(this.value) : $8b21612c25971c7b$export$19db0165690c701a(this.value);
    }
    /**
     * Returns an `Option.some(right)` if the source is a `right` value,
     * or `Option.none` in case the source is a `left` value.
     */ toOption() {
        return this._isRight ? $8b21612c25971c7b$export$9f9d0139d032da4f(this.value) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Implements {@link IEquals.equals}.
     *
     * @param that is the right hand side of the equality check
     */ equals(that) {
        // tslint:disable-next-line:strict-type-predicates
        if (that == null) return false;
        return this._isRight === that._isRight && $7ARg3.is(this.value, that.value);
    }
    /** Implements {@link IEquals.hashCode}. */ hashCode() {
        return this._isRight ? $7ARg3.hashCode(this.value) << 2 : $7ARg3.hashCode(this.value) << 3;
    }
    /**
     * Builds a pure `Either` value.
     *
     * This operation is the pure `Applicative` operation for lifting
     * a value in the `Either` context.
     */ static pure(value) {
        return new $8b21612c25971c7b$export$8cd6fcff08338c9a(value);
    }
    /**
     * Builds a left value, equivalent with {@link Left}.
     */ static left(value) {
        return $8b21612c25971c7b$export$37c4d04eafdc5515(value);
    }
    /**
     * Builds a right value, equivalent with {@link Right}.
     */ static right(value) {
        return $8b21612c25971c7b$export$19db0165690c701a(value);
    }
    /**
     * Maps 2 `Either` values by the mapping function, returning a new
     * `Either` reference that is a `Right` only if both `Either` values are
     * `Right` values, otherwise it returns the first `Left` value noticed.
     *
     * ```typescript
     * // Yields Right(3)
     * Try.map2(Right(1), Right(2),
     *   (a, b) => a + b
     * )
     *
     * // Yields Left, because the second arg is a Left
     * Try.map2(Right(1), Left("error"),
     *   (a, b) => a + b
     * )
     * ```
     *
     * This operation is the `Applicative.map2`.
     */ static map2(fa1, fa2, f) {
        if (fa1.isLeft()) return fa1;
        if (fa2.isLeft()) return fa2;
        return $8b21612c25971c7b$export$19db0165690c701a(f(fa1.value, fa2.value));
    }
    /**
     * Maps 3 `Either` values by the mapping function, returning a new
     * `Either` reference that is a `Right` only if all 3 `Either` values are
     * `Right` values, otherwise it returns the first `Left` value noticed.
     *
     * ```typescript
     * // Yields Right(6)
     * Try.map3(Right(1), Right(2), Right(3),
     *   (a, b, c) => a + b + c
     * )
     *
     * // Yields Left, because the second arg is a Left
     * Try.map3(Right(1), Left("error"), Right(3),
     *   (a, b, c) => a + b + c
     * )
     * ```
     */ static map3(fa1, fa2, fa3, f) {
        if (fa1.isLeft()) return fa1;
        if (fa2.isLeft()) return fa2;
        if (fa3.isLeft()) return fa3;
        return $8b21612c25971c7b$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value));
    }
    /**
     * Maps 4 `Either` values by the mapping function, returning a new
     * `Either` reference that is a `Right` only if all 4 `Either` values are
     * `Right` values, otherwise it returns the first `Left` value noticed.
     *
     * ```typescript
     * // Yields Right(10)
     * Try.map4(Right(1), Right(2), Right(3), Right(4),
     *   (a, b, c, d) => a + b + c + d
     * )
     *
     * // Yields Left, because the second arg is a Left
     * Try.map4(Right(1), Left("error"), Right(3), Right(4),
     *   (a, b, c, d) => a + b + c + d
     * )
     * ```
     */ static map4(fa1, fa2, fa3, fa4, f) {
        if (fa1.isLeft()) return fa1;
        if (fa2.isLeft()) return fa2;
        if (fa3.isLeft()) return fa3;
        if (fa4.isLeft()) return fa4;
        return $8b21612c25971c7b$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value));
    }
    /**
     * Maps 5 `Either` values by the mapping function, returning a new
     * `Either` reference that is a `Right` only if all 5 `Either` values are
     * `Right` values, otherwise it returns the first `Left` value noticed.
     *
     * ```typescript
     * // Yields Right(15)
     * Try.map5(Right(1), Right(2), Right(3), Right(4), Right(5),
     *   (a, b, c, d, e) => a + b + c + d + e
     * )
     *
     * // Yields Left, because the second arg is a Left
     * Try.map5(Right(1), Left("error"), Right(3), Right(4), Right(5),
     *   (a, b, c, d, e) => a + b + c + d + e
     * )
     * ```
     */ static map5(fa1, fa2, fa3, fa4, fa5, f) {
        if (fa1.isLeft()) return fa1;
        if (fa2.isLeft()) return fa2;
        if (fa3.isLeft()) return fa3;
        if (fa4.isLeft()) return fa4;
        if (fa5.isLeft()) return fa5;
        return $8b21612c25971c7b$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value));
    }
    /**
     * Maps 6 `Either` values by the mapping function, returning a new
     * `Either` reference that is a `Right` only if all 6 `Either` values are
     * `Right` values, otherwise it returns the first `Left` value noticed.
     *
     * ```typescript
     * // Yields Right(21)
     * Try.map5(Right(1), Right(2), Right(3), Right(4), Right(5), Right(6),
     *   (a, b, c, d, e, f) => a + b + c + d + e + f
     * )
     *
     * // Yields Left, because the second arg is a Left
     * Try.map5(Right(1), Left("error"), Right(3), Right(4), Right(5), Right(6),
     *   (a, b, c, d, e, f) => a + b + c + d + e + f
     * )
     * ```
     */ static map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
        if (fa1.isLeft()) return fa1;
        if (fa2.isLeft()) return fa2;
        if (fa3.isLeft()) return fa3;
        if (fa4.isLeft()) return fa4;
        if (fa5.isLeft()) return fa5;
        if (fa6.isLeft()) return fa6;
        return $8b21612c25971c7b$export$19db0165690c701a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value));
    }
    /**
     * Keeps calling `f` until a `Right(b)` is returned.
     *
     * Based on Phil Freeman's
     * [Stack Safety for Free]{@link http://functorial.com/stack-safety-for-free/index.pdf}.
     *
     * Described in `FlatMap.tailRecM`.
     */ static tailRecM(a, f) {
        let cursor = a;
        while(true){
            const result = f(cursor);
            if (!result.isRight()) return result;
            const some = result.value;
            if (some.isRight()) return $8b21612c25971c7b$export$19db0165690c701a(some.value);
            cursor = some.value;
        }
    }
}
class $8b21612c25971c7b$export$500560ce56dda718 extends $8b21612c25971c7b$export$37cbe166bfc81b63 {
    constructor(value){
        super(value, "left");
    }
}
function $8b21612c25971c7b$export$37c4d04eafdc5515(value) {
    return new $8b21612c25971c7b$export$500560ce56dda718(value);
}
class $8b21612c25971c7b$export$8cd6fcff08338c9a extends $8b21612c25971c7b$export$37cbe166bfc81b63 {
    constructor(value){
        super(value, "right");
    }
}
function $8b21612c25971c7b$export$19db0165690c701a(value) {
    return new $8b21612c25971c7b$export$8cd6fcff08338c9a(value);
}
const $8b21612c25971c7b$export$e772b5f99e4d377d = {
    // Setoid
    equals: (x, y)=>x ? x.equals(y) : !y,
    // Functor
    map: (f, fa)=>fa.map(f),
    // Apply
    ap: (ff, fa)=>fa.ap(ff),
    // Applicative
    of: $8b21612c25971c7b$export$37cbe166bfc81b63.pure,
    // Chain
    chain: (f, fa)=>fa.flatMap(f),
    // ChainRec
    chainRec: (f, a)=>$8b21612c25971c7b$export$37cbe166bfc81b63.tailRecM(a, (a)=>f($8b21612c25971c7b$export$37cbe166bfc81b63.left, $8b21612c25971c7b$export$37cbe166bfc81b63.right, a))
};
// Registers Fantasy-Land compatible symbols
(0, $iMUUJ.fantasyLandRegister)($8b21612c25971c7b$export$37cbe166bfc81b63, $8b21612c25971c7b$export$e772b5f99e4d377d, $8b21612c25971c7b$export$e772b5f99e4d377d);
class $8b21612c25971c7b$export$36d18380658d5d20 {
    constructor(ref, isEmpty){
        /* tslint:disable-next-line:strict-type-predicates */ this._isEmpty = isEmpty != null ? isEmpty : ref === null || ref === undefined;
        this.value = ref;
    }
    /**
     * Returns the option's value.
     *
     * WARNING!
     *
     * This function is partial, the option must be non-empty, otherwise
     * a runtime exception will get thrown. Use with care.
     *
     * @throws [[NoSuchElementError]] in case the option is empty
     */ get() {
        if (!this._isEmpty) return this.value;
        throw new (0, $4grBR.NoSuchElementError)("Option.get");
    }
    /**
     * Returns the option's value if the option is nonempty, otherwise
     * return the given `fallback`.
     *
     * See [[Option.getOrElseL]] for a lazy alternative.
     */ getOrElse(fallback) {
        if (!this._isEmpty) return this.value;
        else return fallback;
    }
    /**
     * Returns the option's value if the option is nonempty, otherwise
     * return `null`.
     * ```
     */ orNull() {
        return !this._isEmpty ? this.value : null;
    }
    /**
     * Returns the option's value if the option is nonempty, otherwise
     * return `undefined`.
     */ orUndefined() {
        return !this._isEmpty ? this.value : undefined;
    }
    /**
     * Returns the option's value if the option is nonempty, otherwise
     * return the result of evaluating `thunk`.
     *
     * See [[Option.getOrElse]] for a strict alternative.
     */ getOrElseL(thunk) {
        if (!this._isEmpty) return this.value;
        else return thunk();
    }
    /**
     * Returns this option if it is nonempty, otherwise returns the
     * given `fallback`.
     */ orElse(fallback) {
        if (!this._isEmpty) return this;
        else return fallback;
    }
    /**
     * Returns this option if it is nonempty, otherwise returns the
     * given result of evaluating the given `thunk`.
     *
     * @param thunk a no-params function that gets evaluated and
     *        whose result is returned in case this option is empty
     */ orElseL(thunk) {
        if (!this._isEmpty) return this;
        else return thunk();
    }
    /**
     * Returns `true` if the option is empty, `false` otherwise.
     */ isEmpty() {
        return this._isEmpty;
    }
    /**
     * Returns `true` if the option is not empty, `false` otherwise.
     */ nonEmpty() {
        return !this._isEmpty;
    }
    /**
     * Returns an option containing the result of applying `f` to
     * this option's value, or an empty option if the source is empty.
     *
     * NOTE: this is similar with `flatMap`, except with `map` the
     * result of `f` doesn't need to be wrapped in an `Option`.
     *
     * @param f the mapping function that will transform the value
     *          of this option if nonempty.
     *
     * @return a new option instance containing the value of the
     *         source mapped by the given function
     */ map(f) {
        return this._isEmpty ? $8b21612c25971c7b$export$57ca7e07b341709d : $8b21612c25971c7b$export$9f9d0139d032da4f(f(this.value));
    }
    /**
     * Returns the result of applying `f` to this option's value if
     * the option is nonempty, otherwise returns an empty option.
     *
     * NOTE: this is similar with `map`, except that `flatMap` the
     * result returned by `f` is expected to be boxed in an `Option`
     * already.
     *
     * Example:
     *
     * ```typescript
     * const opt = Option.of(10)
     *
     * opt.flatMap(num => {
     *   if (num % 2 == 0)
     *     Some(num + 1)
     *   else
     *     None
     * })
     * ```
     *
     * @param f the mapping function that will transform the value
     *          of this option if nonempty.
     *
     * @return a new option instance containing the value of the
     *         source mapped by the given function
     */ flatMap(f) {
        if (this._isEmpty) return $8b21612c25971c7b$export$57ca7e07b341709d;
        else return f(this.value);
    }
    /** Alias for [[flatMap]]. */ chain(f) {
        return this.flatMap(f);
    }
    /**
     * `Applicative` apply operator.
     *
     * Resembles {@link map}, but the passed mapping function is
     * lifted in the `Either` context.
     */ ap(ff) {
        return ff.flatMap((f)=>this.map(f));
    }
    filter(p) {
        if (this._isEmpty || !p(this.value)) return $8b21612c25971c7b$export$57ca7e07b341709d;
        else return this;
    }
    /**
     * Returns the result of applying `f` to this option's value,
     * or in case the option is empty, the return the result of
     * evaluating the `fallback` function.
     *
     * This function is equivalent with:
     *
     * ```typescript
     * opt.map(f).getOrElseL(fallback)
     * ```
     *
     * @param fallback is the function to be evaluated in case this
     *        option is empty
     *
     * @param f is the mapping function for transforming this option's
     *        value in case it is nonempty
     */ fold(fallback, f) {
        if (this._isEmpty) return fallback();
        return f(this.value);
    }
    /**
     * Returns true if this option is nonempty and the value it
     * holds is equal to the given `elem`.
     */ contains(elem) {
        return !this._isEmpty && $7ARg3.is(this.value, elem);
    }
    /**
     * Returns `true` if this option is nonempty and the given
     * predicate returns `true` when applied on this option's value.
     *
     * @param p is the predicate function to test
     */ exists(p) {
        return !this._isEmpty && p(this.value);
    }
    /**
     * Returns true if this option is empty or the given predicate
     * returns `true` when applied on this option's value.
     *
     * @param p is the predicate function to test
     */ forAll(p) {
        return this._isEmpty || p(this.value);
    }
    /**
     * Apply the given procedure `cb` to the option's value if
     * this option is nonempty, otherwise do nothing.
     *
     * @param cb the procedure to apply
     */ forEach(cb) {
        if (!this._isEmpty) cb(this.value);
    }
    /**
     * Implements {@link IEquals.equals}.
     *
     * @param that is the right hand side of the equality check
     */ equals(that) {
        // tslint:disable-next-line:strict-type-predicates
        if (that == null) return false;
        if (this.nonEmpty() && that.nonEmpty()) return $7ARg3.is(this.value, that.value);
        return this.isEmpty() && that.isEmpty();
    }
    // Implemented from IEquals
    hashCode() {
        if (this._isEmpty) return 2433880;
        else if (this.value == null) return 9735524;
        else return $7ARg3.hashCode(this.value) << 2;
    }
    /**
     * Builds an [[Option]] reference that contains the given value.
     *
     * If the given value is `null` or `undefined` then the returned
     * option will be empty.
     */ static of(value) {
        return value != null ? $8b21612c25971c7b$export$9f9d0139d032da4f(value) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Builds an [[Option]] reference that contains the given reference.
     *
     * Note that `value` is allowed to be `null` or `undefined`, the
     * returned option will still be non-empty. Use [[Option.of]]
     * if you want to avoid this problem. This means:
     *
     * ```typescript
     * const opt = Some<number | null>(null)
     *
     * opt.isEmpty()
     * //=> false
     *
     * opt.get()
     * //=> null
     * ```
     */ static some(value) {
        return new $8b21612c25971c7b$export$36d18380658d5d20(value, false);
    }
    /**
     * Returns an empty [[Option]].
     *
     * NOTE: Because `Option` is immutable, this function returns the
     * same cached reference is on different calls.
     */ static none() {
        return $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Returns an empty [[Option]].
     *
     * Similar to [[Option.none]], but this one allows specifying a
     * type parameter (in the context of TypeScript or Flow or other
     * type system).
     *
     * NOTE: Because `Option` is immutable, this function returns the
     * same cached reference is on different calls.
     */ static empty() {
        return $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Alias for [[Some]].
     */ static pure(value) {
        return $8b21612c25971c7b$export$9f9d0139d032da4f(value);
    }
    /**
     * Maps 2 optional values by the mapping function, returning a new
     * optional reference that is `Some` only if both option values are
     * `Some`, otherwise it returns a `None`.
     *
     * ```typescript
     * // Yields Some(3)
     * Option.map2(Some(1), Some(2),
     *   (a, b) => a + b
     * )
     *
     * // Yields None, because the second arg is None
     * Option.map2(Some(1), None,
     *   (a, b) => a + b
     * )
     * ```
     *
     * This operation is the `Applicative.map2`.
     */ static map2(fa1, fa2, f) {
        return fa1.nonEmpty() && fa2.nonEmpty() ? $8b21612c25971c7b$export$9f9d0139d032da4f(f(fa1.value, fa2.value)) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Maps 3 optional values by the mapping function, returning a new
     * optional reference that is `Some` only if all 3 option values are
     * `Some`, otherwise it returns a `None`.
     *
     * ```typescript
     * // Yields Some(6)
     * Option.map3(Some(1), Some(2), Some(3),
     *   (a, b, c) => a + b + c
     * )
     *
     * // Yields None, because the second arg is None
     * Option.map3(Some(1), None, Some(3),
     *   (a, b, c) => a + b + c
     * )
     * ```
     */ static map3(fa1, fa2, fa3, f) {
        return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() ? $8b21612c25971c7b$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value)) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Maps 4 optional values by the mapping function, returning a new
     * optional reference that is `Some` only if all 4 option values are
     * `Some`, otherwise it returns a `None`.
     *
     * ```typescript
     * // Yields Some(10)
     * Option.map4(Some(1), Some(2), Some(3), Some(4),
     *   (a, b, c, d) => a + b + c + d
     * )
     *
     * // Yields None, because the second arg is None
     * Option.map4(Some(1), None, Some(3), Some(4),
     *   (a, b, c, d) => a + b + c + d
     * )
     * ```
     */ static map4(fa1, fa2, fa3, fa4, f) {
        return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() ? $8b21612c25971c7b$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value)) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Maps 5 optional values by the mapping function, returning a new
     * optional reference that is `Some` only if all 5 option values are
     * `Some`, otherwise it returns a `None`.
     *
     * ```typescript
     * // Yields Some(15)
     * Option.map5(Some(1), Some(2), Some(3), Some(4), Some(5),
     *   (a, b, c, d, e) => a + b + c + d + e
     * )
     *
     * // Yields None, because the second arg is None
     * Option.map5(Some(1), None, Some(3), Some(4), Some(5),
     *   (a, b, c, d, e) => a + b + c + d + e
     * )
     * ```
     */ static map5(fa1, fa2, fa3, fa4, fa5, f) {
        return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() && fa5.nonEmpty() ? $8b21612c25971c7b$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value)) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Maps 6 optional values by the mapping function, returning a new
     * optional reference that is `Some` only if all 6 option values are
     * `Some`, otherwise it returns a `None`.
     *
     * ```typescript
     * // Yields Some(21)
     * Option.map6(Some(1), Some(2), Some(3), Some(4), Some(5), Some(6),
     *   (a, b, c, d, e, f) => a + b + c + d + e + f
     * )
     *
     * // Yields None, because the second arg is None
     * Option.map6(Some(1), None, Some(3), Some(4), Some(5), Some(6),
     *   (a, b, c, d, e, f) => a + b + c + d + e + f
     * )
     * ```
     */ static map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
        return fa1.nonEmpty() && fa2.nonEmpty() && fa3.nonEmpty() && fa4.nonEmpty() && fa5.nonEmpty() && fa6.nonEmpty() ? $8b21612c25971c7b$export$9f9d0139d032da4f(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value)) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Keeps calling `f` until a `Right(b)` is returned.
     *
     * Based on Phil Freeman's
     * [Stack Safety for Free]{@link http://functorial.com/stack-safety-for-free/index.pdf}.
     *
     * Described in `FlatMap.tailRecM`.
     */ static tailRecM(a, f) {
        let cursor = a;
        while(true){
            const result = f(cursor);
            if (result.nonEmpty()) {
                const some = result.value;
                if (some.isRight()) return $8b21612c25971c7b$export$9f9d0139d032da4f(some.value);
                cursor = some.value;
            } else return $8b21612c25971c7b$export$57ca7e07b341709d;
        }
    }
}
class $8b21612c25971c7b$export$c279cda0429c6dbe extends $8b21612c25971c7b$export$36d18380658d5d20 {
    constructor(value){
        super(value, false);
    }
}
function $8b21612c25971c7b$export$9f9d0139d032da4f(value) {
    return new $8b21612c25971c7b$export$c279cda0429c6dbe(value);
}
class $8b21612c25971c7b$export$ee2288f2b4bc04c4 extends $8b21612c25971c7b$export$36d18380658d5d20 {
    constructor(){
        super(undefined, true);
    }
}
const $8b21612c25971c7b$export$57ca7e07b341709d = new $8b21612c25971c7b$export$ee2288f2b4bc04c4();
const $8b21612c25971c7b$export$dae05fd938c910bc = {
    // Setoid
    equals: (x, y)=>x ? x.equals(y) : !y,
    // Functor
    map: (f, fa)=>fa.map(f),
    // Apply
    ap: (ff, fa)=>fa.ap(ff),
    // Applicative
    of: $8b21612c25971c7b$export$36d18380658d5d20.pure,
    // Chain
    chain: (f, fa)=>fa.flatMap(f),
    // ChainRec
    chainRec: (f, a)=>$8b21612c25971c7b$export$36d18380658d5d20.tailRecM(a, (a)=>f($8b21612c25971c7b$export$37cbe166bfc81b63.left, $8b21612c25971c7b$export$37cbe166bfc81b63.right, a))
};
// Registers Fantasy-Land compatible symbols
(0, $iMUUJ.fantasyLandRegister)($8b21612c25971c7b$export$36d18380658d5d20, $8b21612c25971c7b$export$dae05fd938c910bc, $8b21612c25971c7b$export$dae05fd938c910bc);
class $8b21612c25971c7b$export$fa957d01b0310fd7 {
    constructor(value, tag){
        this._isSuccess = tag === "success";
        this.value = value;
    }
    /**
     * Returns `true` if the source is a [[Success]] result,
     * or `false` in case it is a [[Failure]].
     */ isSuccess() {
        return this._isSuccess;
    }
    /**
     * Returns `true` if the source is a [[Failure]],
     * or `false` in case it is a [[Success]] result.
     */ isFailure() {
        return !this._isSuccess;
    }
    /**
     * Returns a Try's successful value if it's a [[Success]] reference,
     * otherwise throws an exception if it's a [[Failure]].
     *
     * WARNING!
     *
     * This function is partial, the option must be non-empty, otherwise
     * a runtime exception will get thrown. Use with care.
     */ get() {
        if (!this._isSuccess) throw this.value;
        return this.value;
    }
    /**
     * Returns the value from a `Success` or the given `fallback`
     * value if this is a `Failure`.
     *
     * ```typescript
     * Success(10).getOrElse(27) // 10
     * Failure("error").getOrElse(27)  // 27
     * ```
     */ getOrElse(fallback) {
        return this._isSuccess ? this.value : fallback;
    }
    /**
     * Returns the value from a `Success` or the value generated
     * by a given `thunk` in case this is a `Failure`.
     *
     * ```typescript
     * Success(10).getOrElseL(() => 27) // 10
     * Failure("error").getOrElseL(() => 27)  // 27
     * ```
     */ getOrElseL(thunk) {
        return this._isSuccess ? this.value : thunk();
    }
    /**
     * Returns the current value if it's a [[Success]], or
     * if the source is a [[Failure]] then return `null`.
     *
     * ```typescript
     * Success(10).orNull()      // 10
     * Failure("error").orNull() // null
     * ```
     *
     * This can be useful for use-cases such as:
     *
     * ```typescript
     * Try.of(() => dict.user.profile.name).orNull()
     * ```
     */ orNull() {
        return this._isSuccess ? this.value : null;
    }
    /**
     * Returns the current value if it's a [[Success]], or
     * if the source is a [[Failure]] then return `undefined`.
     *
     * ```typescript
     * Success(10).orUndefined()      // 10
     * Failure("error").orUndefined() // undefined
     * ```
     *
     * This can be useful for use-cases such as:
     *
     * ```typescript
     * Try.of(() => dict.user.profile.name).orUndefined()
     * ```
     */ orUndefined() {
        return this._isSuccess ? this.value : undefined;
    }
    /**
     * Returns the current value if it's a [[Success]], or if
     * the source is a [[Failure]] then return the `fallback`.
     *
     * ```typescript
     * Success(10).orElse(Success(17))      // 10
     * Failure("error").orElse(Success(17)) // 17
     * ```
     */ orElse(fallback) {
        if (this._isSuccess) return this;
        return fallback;
    }
    /**
     * Returns the current value if it's a [[Success]], or if the source
     * is a [[Failure]] then return the value generated by the given
     * `thunk`.
     *
     * ```typescript
     * Success(10).orElseL(() => Success(17))      // 10
     * Failure("error").orElseL(() => Success(17)) // 17
     * ```
     */ orElseL(thunk) {
        if (this._isSuccess) return this;
        return thunk();
    }
    /**
     * Inverts this `Try`. If this is a [[Failure]], returns its exception wrapped
     * in a [[Success]]. If this is a `Success`, returns a `Failure` containing a
     * [[NoSuchElementError]].
     */ failed() {
        return this._isSuccess ? $8b21612c25971c7b$export$5ebc9a4af3ac0850(new (0, $4grBR.NoSuchElementError)("try.failed()")) : $8b21612c25971c7b$export$ffa3d9fee6fd705a(this.value);
    }
    /**
     * Applies the `failure` function to [[Failure]] values, and the
     * `success` function to [[Success]] values and returns the result.
     *
     * ```typescript
     * const maybeNum: Try<number> =
     *   tryParseInt("not a number")
     *
     * const result: string =
     *   maybeNum.fold(
     *     error => `Could not parse string: ${error}`,
     *     num => `Success: ${num}`
     *   )
     * ```
     */ fold(failure, success) {
        return this._isSuccess ? success(this.value) : failure(this.value);
    }
    filter(p) {
        if (!this._isSuccess) return this;
        try {
            if (p(this.value)) return this;
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(new (0, $4grBR.NoSuchElementError)(`Predicate does not hold for ${this.value}`));
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /**
     * Returns the given function applied to the value if this is
     * a [[Success]] or returns `this` if this is a [[Failure]].
     *
     * This operation is the monadic "bind" operation.
     * It can be used to *chain* multiple `Try` references.
     *
     * ```typescript
     * Try.of(() => parse(s1)).flatMap(num1 =>
     *   Try.of(() => parse(s2)).map(num2 =>
     *     num1 / num2
     *   ))
     * ```
     */ flatMap(f) {
        if (!this._isSuccess) return this;
        try {
            return f(this.value);
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /** Alias for [[flatMap]]. */ chain(f) {
        return this.flatMap(f);
    }
    /**
     * `Applicative` apply operator.
     *
     * Resembles {@link map}, but the passed mapping function is
     * lifted in the `Either` context.
     */ ap(ff) {
        return ff.flatMap((f)=>this.map(f));
    }
    /**
     * Returns a `Try` containing the result of applying `f` to
     * this option's value, but only if it's a `Success`, or
     * returns the current `Failure` without any modifications.
     *
     * NOTE: this is similar with `flatMap`, except with `map` the
     * result of `f` doesn't need to be wrapped in a `Try`.
     *
     * @param f the mapping function that will transform the value
     *          of this `Try` if successful.
     *
     * @return a new `Try` instance containing the value of the
     *         source mapped by the given function
     */ map(f) {
        return this._isSuccess ? $8b21612c25971c7b$export$fa957d01b0310fd7.of(()=>f(this.value)) : this;
    }
    /**
     * Applies the given function `cb` if this is a [[Success]], otherwise
     * returns `void` if this is a [[Failure]].
     */ forEach(cb) {
        if (this._isSuccess) cb(this.value);
    }
    /**
     * Applies the given function `f` if this is a `Failure`, otherwise
     * returns `this` if this is a `Success`.
     *
     * This is like `map` for the exception.
     *
     * In the following example, if the `user.profile.email` exists,
     * then it is returned as a successful value, otherwise
     *
     * ```typescript
     * Try.of(() => user.profile.email).recover(e => {
     *   // Access error? Default to empty.
     *   if (e instanceof TypeError) return ""
     *   throw e // We don't know what it is, rethrow
     * })
     *
     * Note that on rethrow, the error is being caught in `recover` and
     * it still returns it as a `Failure(e)`.
     * ```
     */ recover(f) {
        return this._isSuccess ? this : $8b21612c25971c7b$export$fa957d01b0310fd7.of(()=>f(this.value));
    }
    /**
     * Applies the given function `f` if this is a `Failure`, otherwise
     * returns `this` if this is a `Success`.
     *
     * This is like `map` for the exception.
     *
     * In the following example, if the `user.profile.email` exists,
     * then it is returned as a successful value, otherwise
     *
     * ```typescript
     * Try.of(() => user.profile.email).recover(e => {
     *   // Access error? Default to empty.
     *   if (e instanceof TypeError) return ""
     *   throw e // We don't know what it is, rethrow
     * })
     *
     * Note that on rethrow, the error is being caught in `recover` and
     * it still returns it as a `Failure(e)`.
     * ```
     */ recoverWith(f) {
        try {
            return this._isSuccess ? this : f(this.value);
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /**
     * Transforms the source into an [[Option]].
     *
     * In case the source is a `Success(v)`, then it gets translated
     * into a `Some(v)`. If the source is a `Failure(e)`, then a `None`
     * value is returned.
     *
     * ```typescript
     * Success("value").toOption() // Some("value")
     * Failure("error").toOption() // None
     * ```
     */ toOption() {
        return this._isSuccess ? $8b21612c25971c7b$export$9f9d0139d032da4f(this.value) : $8b21612c25971c7b$export$57ca7e07b341709d;
    }
    /**
     * Transforms the source into an [[Either]].
     *
     * In case the source is a `Success(v)`, then it gets translated
     * into a `Right(v)`. If the source is a `Failure(e)`, then a `Left(e)`
     * value is returned.
     *
     * ```typescript
     * Success("value").toEither() // Right("value")
     * Failure("error").toEither() // Left("error")
     * ```
     */ toEither() {
        return this._isSuccess ? $8b21612c25971c7b$export$19db0165690c701a(this.value) : $8b21612c25971c7b$export$37c4d04eafdc5515(this.value);
    }
    /**
     * Implements {@link IEquals.equals} with overridable equality for `A`.
     */ equals(that) {
        // tslint:disable-next-line:strict-type-predicates
        if (that == null) return false;
        return this._isSuccess ? that._isSuccess && $7ARg3.is(this.value, that.value) : !that._isSuccess && $7ARg3.is(this.value, that.value);
    }
    // Implemented from IEquals
    hashCode() {
        return this._isSuccess ? $7ARg3.hashCode(this.value) : $7ARg3.hashCode(this.value);
    }
    /**
     * Evaluates the given `thunk` and returns either a [[Success]],
     * in case the evaluation succeeded, or a [[Failure]], in case
     * an exception was thrown.
     *
     * Example:
     *
     * ```typescript
     * let effect = 0
     *
     * const e = Try.of(() => { effect += 1; return effect })
     * e.get() // 1
     * ```
     */ static of(thunk) {
        try {
            return $8b21612c25971c7b$export$ffa3d9fee6fd705a(thunk());
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /** Alias of [[Try.success]]. */ static pure(value) {
        return $8b21612c25971c7b$export$fa957d01b0310fd7.success(value);
    }
    /**
     * Shorthand for `now(undefined as void)`, always returning
     * the same reference as optimization.
     */ static unit() {
        return $8b21612c25971c7b$var$tryUnitRef;
    }
    /**
     * Returns a [[Try]] reference that represents a successful result
     * (i.e. wrapped in [[Success]]).
     */ static success(value) {
        return $8b21612c25971c7b$export$ffa3d9fee6fd705a(value);
    }
    /**
     * Returns a [[Try]] reference that represents a failure
     * (i.e. an exception wrapped in [[Failure]]).
     */ static failure(e) {
        return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
    }
    /**
     * Alias for {@link Try.failure} and {@link Failure},
     * wrapping any throwable into a `Try` value.
     */ static raise(e) {
        return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
    }
    /**
     * Maps 2 `Try` values by the mapping function, returning a new
     * `Try` reference that is a `Success` only if both `Try` values are
     * a `Success`, otherwise it returns the first `Failure` noticed.
     *
     * ```typescript
     * // Yields Success(3)
     * Try.map2(Success(1), Success(2),
     *   (a, b) => a + b
     * )
     *
     * // Yields Failure, because the second arg is a Failure
     * Try.map2(Success(1), Failure("error"),
     *   (a, b) => a + b
     * )
     * ```
     *
     * This operation is the `Applicative.map2`.
     */ static map2(fa1, fa2, f) {
        if (fa1.isFailure()) return fa1;
        if (fa2.isFailure()) return fa2;
        try {
            return $8b21612c25971c7b$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value));
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /**
     * Maps 3 `Try` values by the mapping function, returning a new
     * `Try` reference that is a `Success` only if all 3 `Try` values are
     * a `Success`, otherwise it returns the first `Failure` noticed.
     *
     * ```typescript
     * // Yields Success(6)
     * Try.map3(Success(1), Success(2), Success(3),
     *   (a, b, c) => {
     *     return a + b + c
     *   }
     * )
     *
     * // Yields Failure, because the second arg is a Failure
     * Try.map3(
     *   Success(1),
     *   Failure("error"),
     *   Success(3),
     *
     *   (a, b, c) => {
     *     return a + b + c
     *   }
     * )
     * ```
     */ static map3(fa1, fa2, fa3, f) {
        if (fa1.isFailure()) return fa1;
        if (fa2.isFailure()) return fa2;
        if (fa3.isFailure()) return fa3;
        try {
            return $8b21612c25971c7b$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value));
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /**
     * Maps 4 `Try` values by the mapping function, returning a new
     * `Try` reference that is a `Success` only if all 4 `Try` values are
     * a `Success`, otherwise it returns the first `Failure` noticed.
     *
     * ```typescript
     * // Yields Success(10)
     * Try.map4(Success(1), Success(2), Success(3), Success(4),
     *   (a, b, c, d) => {
     *     return a + b + c + d
     *   }
     * )
     *
     * // Yields Failure, because the second arg is a Failure
     * Try.map3(
     *   Success(1),
     *   Failure("error"),
     *   Success(3),
     *   Success(4),
     *
     *   (a, b, c, d) => {
     *     return a + b + c + d
     *   }
     * )
     * ```
     */ static map4(fa1, fa2, fa3, fa4, f) {
        if (fa1.isFailure()) return fa1;
        if (fa2.isFailure()) return fa2;
        if (fa3.isFailure()) return fa3;
        if (fa4.isFailure()) return fa4;
        try {
            return $8b21612c25971c7b$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value));
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /**
     * Maps 5 `Try` values by the mapping function, returning a new
     * `Try` reference that is a `Success` only if all 5 `Try` values are
     * a `Success`, otherwise it returns the first `Failure` noticed.
     *
     * ```typescript
     * // Yields Success(15)
     * Try.map5(
     *   Success(1),
     *   Success(2),
     *   Success(3),
     *   Success(4),
     *   Success(5),
     *
     *   (a, b, c, d, e) => {
     *     return a + b + c + d + e
     *   }
     * )
     *
     * // Yields Failure, because the second arg is a Failure
     * Try.map5(
     *   Success(1),
     *   Failure("error"),
     *   Success(3),
     *   Success(4),
     *   Success(5),
     *
     *   (a, b, c, d, e) => {
     *     return a + b + c + d + e
     *   }
     * )
     * ```
     */ static map5(fa1, fa2, fa3, fa4, fa5, f) {
        if (fa1.isFailure()) return fa1;
        if (fa2.isFailure()) return fa2;
        if (fa3.isFailure()) return fa3;
        if (fa4.isFailure()) return fa4;
        if (fa5.isFailure()) return fa5;
        try {
            return $8b21612c25971c7b$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value));
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /**
     * Maps 6 `Try` values by the mapping function, returning a new
     * `Try` reference that is a `Success` only if all 6 `Try` values are
     * a `Success`, otherwise it returns the first `Failure` noticed.
     *
     * ```typescript
     * // Yields Success(21)
     * Try.map6(
     *   Success(1),
     *   Success(2),
     *   Success(3),
     *   Success(4),
     *   Success(5),
     *   Success(6),
     *
     *   (a, b, c, d, e, f) => {
     *     return a + b + c + d + e + f
     *   }
     * )
     *
     * // Yields Failure, because the second arg is a Failure
     * Try.map6(
     *   Success(1),
     *   Failure("error"),
     *   Success(3),
     *   Success(4),
     *   Success(5),
     *   Success(6),
     *
     *   (a, b, c, d, e, f) => {
     *     return a + b + c + d + e + f
     *   }
     * )
     * ```
     */ static map6(fa1, fa2, fa3, fa4, fa5, fa6, f) {
        if (fa1.isFailure()) return fa1;
        if (fa2.isFailure()) return fa2;
        if (fa3.isFailure()) return fa3;
        if (fa4.isFailure()) return fa4;
        if (fa5.isFailure()) return fa5;
        if (fa6.isFailure()) return fa6;
        try {
            return $8b21612c25971c7b$export$ffa3d9fee6fd705a(f(fa1.value, fa2.value, fa3.value, fa4.value, fa5.value, fa6.value));
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
    /**
     * Keeps calling `f` until a `Right(b)` is returned.
     *
     * Based on Phil Freeman's
     * [Stack Safety for Free]{@link http://functorial.com/stack-safety-for-free/index.pdf}.
     *
     * Described in `FlatMap.tailRecM`.
     */ static tailRecM(a, f) {
        let cursor = a;
        while(true)try {
            const result = f(cursor);
            if (result.isFailure()) return result;
            const some = result.get();
            if (some.isRight()) return $8b21612c25971c7b$export$ffa3d9fee6fd705a(some.value);
            cursor = some.value;
        } catch (e) {
            return $8b21612c25971c7b$export$5ebc9a4af3ac0850(e);
        }
    }
}
class $8b21612c25971c7b$export$a78bea8ed2ae2fde extends $8b21612c25971c7b$export$fa957d01b0310fd7 {
    constructor(value){
        super(value, "success");
    }
}
function $8b21612c25971c7b$export$ffa3d9fee6fd705a(value) {
    return new $8b21612c25971c7b$export$a78bea8ed2ae2fde(value);
}
class $8b21612c25971c7b$export$a432f16a0795683f extends $8b21612c25971c7b$export$fa957d01b0310fd7 {
    constructor(value){
        super(value, "failure");
    }
}
function $8b21612c25971c7b$export$5ebc9a4af3ac0850(e) {
    return new $8b21612c25971c7b$export$a432f16a0795683f(e);
}
const $8b21612c25971c7b$export$93cc75c33014d88a = {
    // Setoid
    equals: (x, y)=>x ? x.equals(y) : !y,
    // Functor
    map: (f, fa)=>fa.map(f),
    // Apply
    ap: (ff, fa)=>fa.ap(ff),
    // Applicative
    of: $8b21612c25971c7b$export$fa957d01b0310fd7.pure,
    // Chain
    chain: (f, fa)=>fa.flatMap(f),
    // ChainRec
    chainRec: (f, a)=>$8b21612c25971c7b$export$fa957d01b0310fd7.tailRecM(a, (a)=>f($8b21612c25971c7b$export$37cbe166bfc81b63.left, $8b21612c25971c7b$export$37cbe166bfc81b63.right, a))
};
// Registers Fantasy-Land compatible symbols
(0, $iMUUJ.fantasyLandRegister)($8b21612c25971c7b$export$fa957d01b0310fd7, $8b21612c25971c7b$export$93cc75c33014d88a, $8b21612c25971c7b$export$93cc75c33014d88a);
/**
 * Reusable reference, to use in {@link Try.unit}.
 *
 * @private
 * @hidden
 */ const $8b21612c25971c7b$var$tryUnitRef = $8b21612c25971c7b$export$ffa3d9fee6fd705a(undefined);

});
parcelRegister("iMUUJ", function(module, exports) {

$parcel$export(module.exports, "fantasyLandRegister", () => $dad8dba3f9875d28$export$366e3fc13367d41c);
/*!
 * Copyright (c) 2017-2018 by The Funfix Project Developers.
 * Some rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ /**
 * Given a function, converts it into a method where `this` gets
 * passed around as the last argument.
 */ function $dad8dba3f9875d28$export$8532f18845d94af4(f) {
    return function() {
        const args = Array.prototype.slice.call(arguments);
        args.push(this);
        return f.apply(undefined, args);
    };
}
function $dad8dba3f9875d28$export$366e3fc13367d41c(cls, monad, setoid) {
    const c = cls;
    const p = c.prototype;
    const fl = "fantasy-land/";
    const equals = "equals";
    const flEquals = fl + equals;
    const map = "map";
    const flMap = fl + map;
    const ap = "ap";
    const flAp = fl + ap;
    const flOf = fl + "of";
    const chain = "chain";
    const flChain = fl + chain;
    const chainRec = "chainRec";
    const flChainRec = fl + chainRec;
    // Setoid
    if (p[equals]) p[flEquals] = p[equals];
    else /* istanbul ignore else */ if (setoid) p[flEquals] = $dad8dba3f9875d28$export$8532f18845d94af4(setoid.equals);
    // Functor
    if (p[map]) p[flMap] = p[map];
    else /* istanbul ignore else */ if (monad) p[flMap] = $dad8dba3f9875d28$export$8532f18845d94af4(monad.map);
    // Apply
    if (p[ap]) p[flAp] = p[ap];
    else /* istanbul ignore else */ if (monad) p[flAp] = $dad8dba3f9875d28$export$8532f18845d94af4(monad.ap);
    // Applicative
    if (c["pure"]) c[flOf] = c["pure"];
    else /* istanbul ignore else */ if (monad) c[flOf] = monad.of;
    // Chain
    if (p[chain]) p[flChain] = p[chain];
    else /* istanbul ignore else */ if (monad) p[flChain] = $dad8dba3f9875d28$export$8532f18845d94af4(monad.chain);
    // ChainRec
    if (c[chainRec]) c[flChainRec] = c[chainRec];
    else /* istanbul ignore else */ if (monad) c[flChainRec] = monad.chainRec;
}

});



parcelRegister("7YbkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $5cd6edf1c9b232c2$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $glcns = parcelRequire("glcns");
var $lTBkB = parcelRequire("lTBkB");

var $iUPNF = parcelRequire("iUPNF");

var $bPtM5 = parcelRequire("bPtM5");
const $5cd6edf1c9b232c2$var$STARGATE_PROXY_PATH = '/gateway/api/gasv3/api/v1';
class $5cd6edf1c9b232c2$var$AnalyticsClient {
    static init(config, hostConfig, hostInfo) {
        if (this._client) return this._client;
        const origin = navigator.userAgent.includes('Electron/') ? (0, $lTBkB.originType).DESKTOP : (0, $lTBkB.originType).WEB;
        const analyticsWebClientUrl = new URL($5cd6edf1c9b232c2$var$STARGATE_PROXY_PATH, hostInfo.baseUrl);
        this._client = new (0, $glcns.default)({
            env: config.analytics.productAnalytics.env,
            product: hostConfig.analytics.productName,
            version: (0, $iUPNF.default),
            subproduct: hostConfig.analytics.getSubproduct(hostInfo.subproduct),
            origin: origin
        }, {
            useLegacyUrl: config.analytics.productAnalytics.env === 'local' || config.analytics.productAnalytics.env === 'dev',
            /*  RequestURL for GASv3 events is set using window.location.host by default in '@atlassiansox/analytics-web-client'
          This won't work for Emcee Connect as window.location.host doesn't give you the actual hostname.
          apiHost property is passed to override the default behaviour
      */ apiHost: (0, $bPtM5.isEmceeConnect)() ? analyticsWebClientUrl.host + analyticsWebClientUrl.pathname : null
        });
    }
    static get() {
        if (this._client) return this._client;
        throw new Error('Analytics client should be initialised before it is fetched!');
    }
}
(0, $5zQU9.default)($5cd6edf1c9b232c2$var$AnalyticsClient, "_client", null);
var $5cd6edf1c9b232c2$export$2e2bcd8739ae039 = $5cd6edf1c9b232c2$var$AnalyticsClient;

});

parcelRegister("kC116", function(module, exports) {

$parcel$export(module.exports, "makeUrlContextIcon", () => $f01825304d073eff$export$329c7ecbcbbbe7a1);
$parcel$export(module.exports, "makeReactContextIcon", () => $f01825304d073eff$export$935f6f08d22f7bc6);
$parcel$export(module.exports, "makeContext", () => $f01825304d073eff$export$2d2e2a019c76af3);
$parcel$export(module.exports, "makeContextFromSPIContext", () => $f01825304d073eff$export$48a2a4b4b9048dc5);
$parcel$export(module.exports, "defaultContextName", () => $f01825304d073eff$export$81f5421c00c96842);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
const $f01825304d073eff$export$329c7ecbcbbbe7a1 = (urlIcon)=>(0, $bWAru.Either).left(urlIcon);
const $f01825304d073eff$export$935f6f08d22f7bc6 = (reactIcon)=>(0, $bWAru.Either).right(reactIcon);
const $f01825304d073eff$export$2d2e2a019c76af3 = (0, $g5DHJ.Record)({
    id: '',
    icon: (0, $bWAru.Option).none(),
    name: undefined,
    type: undefined
});
const $f01825304d073eff$export$48a2a4b4b9048dc5 = (spiContext)=>$f01825304d073eff$export$2d2e2a019c76af3({
        id: spiContext.id,
        icon: (0, $bWAru.Option).of(spiContext.icon).map($f01825304d073eff$export$329c7ecbcbbbe7a1),
        name: spiContext.name,
        type: spiContext.type
    });
const $f01825304d073eff$export$81f5421c00c96842 = 'Atlassian Marketplace';

});

parcelRegister("c6kEN", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_LOADED_SUCCESS", () => $8cf611a5d1a47b03$export$4ed4141bdc080c7a);
$parcel$export(module.exports, "ANALYTICS_LOADED_ERROR", () => $8cf611a5d1a47b03$export$adb0de127734cace);
$parcel$export(module.exports, "ANALYTICS_SEND_PAGE_VIEW", () => $8cf611a5d1a47b03$export$b08cd33b8056e912);
$parcel$export(module.exports, "ANALYTICS_DONE_PAGE_VIEW", () => $8cf611a5d1a47b03$export$8c80149792b47807);
$parcel$export(module.exports, "ANALYTICS_SCREEN_CHANGED", () => $8cf611a5d1a47b03$export$ce9796014d8479a9);
$parcel$export(module.exports, "ANALYTICS_MODAL_OPENED", () => $8cf611a5d1a47b03$export$d3520a351d43e3c9);
$parcel$export(module.exports, "ANALYTICS_MODAL_CLOSED", () => $8cf611a5d1a47b03$export$90b885232b819407);
$parcel$export(module.exports, "doInitializeAnalytics", () => $8cf611a5d1a47b03$export$1c7f56288344cc4e);
$parcel$export(module.exports, "onModalOpened", () => $8cf611a5d1a47b03$export$3d2484a322f45203);
$parcel$export(module.exports, "onModalClosed", () => $8cf611a5d1a47b03$export$b108f17658ea010f);
$parcel$export(module.exports, "onScreenChanged", () => $8cf611a5d1a47b03$export$43bb061c3fd84f61);

var $7hgtR = parcelRequire("7hgtR");

var $5JCOp = parcelRequire("5JCOp");
const $8cf611a5d1a47b03$export$4ed4141bdc080c7a = 'ANALYTICS_ANALYTICS_LOADED_SUCCESS';
const $8cf611a5d1a47b03$export$adb0de127734cace = 'ANALYTICS_ANALYTICS_LOADED_ERROR';
const $8cf611a5d1a47b03$export$b08cd33b8056e912 = 'ANALYTICS_SEND_PAGE_VIEW';
const $8cf611a5d1a47b03$export$8c80149792b47807 = 'ANALYTICS_DONE_PAGE_VIEW';
const $8cf611a5d1a47b03$export$ce9796014d8479a9 = 'ANALYTICS_SCREEN_CHANGED';
const $8cf611a5d1a47b03$export$d3520a351d43e3c9 = 'ANALYTICS_MODAL_OPENED';
const $8cf611a5d1a47b03$export$90b885232b819407 = 'ANALYTICS_MODAL_CLOSED';
const $8cf611a5d1a47b03$var$analyticsLoadedSuccess = ()=>({
        type: $8cf611a5d1a47b03$export$4ed4141bdc080c7a
    });
const $8cf611a5d1a47b03$var$analyticsLoadedError = (_ref)=>{
    let { dataErrorMessages: dataErrorMessages } = _ref;
    return {
        type: $8cf611a5d1a47b03$export$adb0de127734cace,
        dataErrorMessages: dataErrorMessages
    };
};
const $8cf611a5d1a47b03$var$screenChanged = (_ref2)=>{
    let { screen: screen, attributes: attributes } = _ref2;
    return {
        type: $8cf611a5d1a47b03$export$ce9796014d8479a9,
        screen: screen,
        attributes: attributes
    };
};
const $8cf611a5d1a47b03$var$modalOpened = (_ref3)=>{
    let { modal: modal } = _ref3;
    return {
        type: $8cf611a5d1a47b03$export$d3520a351d43e3c9,
        modal: modal
    };
};
const $8cf611a5d1a47b03$var$modalClosed = (_ref4)=>{
    let { modal: modal } = _ref4;
    return {
        type: $8cf611a5d1a47b03$export$90b885232b819407,
        modal: modal
    };
};
const $8cf611a5d1a47b03$var$pageViewEvent = ()=>({
        type: $8cf611a5d1a47b03$export$b08cd33b8056e912
    });
const $8cf611a5d1a47b03$export$1c7f56288344cc4e = (_ref5)=>{
    let { hostInfo: hostInfo, currentUserId: currentUserId } = _ref5;
    return (dispatch)=>(0, $5JCOp.initializeBackends)(hostInfo, currentUserId).then(()=>{
            dispatch($8cf611a5d1a47b03$var$analyticsLoadedSuccess());
        }, (error)=>{
            dispatch($8cf611a5d1a47b03$var$analyticsLoadedError({
                dataErrorMessages: (0, $7hgtR.makeDataErrorMessages)([
                    error
                ])
            }));
        });
};
const $8cf611a5d1a47b03$export$3d2484a322f45203 = (modal)=>(dispatch)=>{
        dispatch($8cf611a5d1a47b03$var$modalOpened({
            modal: modal
        }));
        dispatch($8cf611a5d1a47b03$var$pageViewEvent());
    };
const $8cf611a5d1a47b03$export$b108f17658ea010f = (modal)=>(dispatch)=>{
        dispatch($8cf611a5d1a47b03$var$modalClosed({
            modal: modal
        }));
        setTimeout(()=>dispatch($8cf611a5d1a47b03$var$pageViewEvent()), 500);
    };
const $8cf611a5d1a47b03$export$43bb061c3fd84f61 = (screen, attributes)=>(dispatch)=>{
        dispatch($8cf611a5d1a47b03$var$screenChanged({
            screen: screen,
            attributes: attributes
        }));
        dispatch($8cf611a5d1a47b03$var$pageViewEvent());
    };

});
parcelRegister("7hgtR", function(module, exports) {

$parcel$export(module.exports, "makeDataErrorMessages", () => $54c6e7a29a9df1d4$export$7772c182a292e2c1);

var $g5DHJ = parcelRequire("g5DHJ");
const $54c6e7a29a9df1d4$export$2b37df4fde88cd52 = (0, $g5DHJ.Record)({
    message: ''
});
function $54c6e7a29a9df1d4$export$7772c182a292e2c1(msgs) {
    return (0, $g5DHJ.List)(msgs).map((msg)=>$54c6e7a29a9df1d4$export$2b37df4fde88cd52({
            message: msg
        }));
}

});

parcelRegister("5JCOp", function(module, exports) {

$parcel$export(module.exports, "initializeBackends", () => $42cf42f9cef2069d$export$8ede10fee0643ed7);
$parcel$export(module.exports, "sendEvent", () => $42cf42f9cef2069d$export$7329bcdc3edcd90e);
$parcel$export(module.exports, "sendPageViewEvent", () => $42cf42f9cef2069d$export$a0769f17975cb672);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $3DsUo = parcelRequire("3DsUo");

var $01SeN = parcelRequire("01SeN");
const $42cf42f9cef2069d$var$BACKENDS = (0, $g5DHJ.List)([
    new (0, $01SeN.default)()
]);
function $42cf42f9cef2069d$export$8ede10fee0643ed7(hostInfo, userId) {
    return Promise.all($42cf42f9cef2069d$var$BACKENDS.map((b)=>(0, $3DsUo.reflect)(b.initialize(hostInfo, userId)).then((r)=>{
            r.swap().map((error)=>{
                console.error('Analytics error', error);
            });
            return r;
        })).toArray()).then((responses)=>{
        const errResponse = (0, $bWAru.Option).of(responses.find((r)=>r.fold((value)=>value, ()=>false)));
        return errResponse.map((er)=>Promise.reject(er)).getOrElseL(()=>Promise.resolve());
    });
}
function $42cf42f9cef2069d$export$7329bcdc3edcd90e(event) {
    $42cf42f9cef2069d$var$BACKENDS.forEach((b)=>b.sendEvent(event));
}
function $42cf42f9cef2069d$export$a0769f17975cb672(pageViewEvent) {
    $42cf42f9cef2069d$var$BACKENDS.forEach((b)=>b.sendPageViewEvent(pageViewEvent));
}

});
parcelRegister("3DsUo", function(module, exports) {

$parcel$export(module.exports, "reflect", () => $2a5b7041164d4a1c$export$9debe8cffacea23);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
function $2a5b7041164d4a1c$export$9debe8cffacea23(promise) {
    return promise.then((data)=>(0, $bWAru.Either).right(data)).catch((error)=>(0, $bWAru.Either).left(error));
}

});

parcelRegister("01SeN", function(module, exports) {

$parcel$export(module.exports, "default", () => $005a2a8f473d4f7f$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $5YKni = parcelRequire("5YKni");

var $lLYAL = parcelRequire("lLYAL");

var $lNaxt = parcelRequire("lNaxt");

var $lTBkB = parcelRequire("lTBkB");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $7YbkQ = parcelRequire("7YbkQ");

var $7Uh51 = parcelRequire("7Uh51");

var $gIQkA = parcelRequire("gIQkA");
class $005a2a8f473d4f7f$export$2e2bcd8739ae039 {
    constructor(){
        (0, $5zQU9.default)(this, "analyticsClient", null);
        (0, $5zQU9.default)(this, "eventsTable", (0, $g5DHJ.Map)());
    }
    initialize(hostInfo, userId) {
        return new Promise((resolve)=>{
            const client = (0, $7YbkQ.default).get();
            const cloudId = (0, $lLYAL.parse)(hostInfo.globalContext.id).cloudId;
            const orgId = hostInfo.globalContext.orgId;
            const workspaceAri = (0, $lLYAL.parse)(hostInfo.globalContext.workspaceAri).toString();
            client.setTenantInfo((0, $lTBkB.tenantType).CLOUD_ID, cloudId);
            client.setOrgInfo(orgId);
            client.setWorkspaceInfo(workspaceAri);
            client.setUserInfo((0, $lTBkB.userType).ATLASSIAN_ACCOUNT, userId);
            this.eventsTable = (0, $7Uh51.allAnalyticsEvents).concat((0, $5YKni.default)).reduce((table, e)=>table.setIn([
                    e.action,
                    e.actionSubject
                ], (0, $lNaxt.foldAnalyticsEventType)(e.type)(()=>client.sendTrackEvent, ()=>client.sendUIEvent, ()=>client.sendOperationalEvent)), this.eventsTable);
            this.analyticsClient = client;
            resolve();
        });
    }
    sendPageViewEvent(pageViewEvent) {
        if (this.analyticsClient) {
            const analyticsClient = this.analyticsClient;
            if (!(0, $gIQkA.allAnalyticsSources).some((source)=>source.name === pageViewEvent.name)) throw new Error("Unregistered source: ".concat(pageViewEvent.name, ". Add to analytics/Sources.js!"));
            analyticsClient.sendScreenEvent({
                name: pageViewEvent.name,
                attributes: pageViewEvent.attributes
            });
        }
    }
    sendEvent(event) {
        if (this.analyticsClient) (0, $bWAru.Option).of(this.eventsTable.getIn([
            event.action,
            event.actionSubject
        ])).map((send)=>send(event)).orElseL(()=>{
            throw new Error("Unregistered event: ".concat(event.actionSubject, " ").concat(event.action, ". Add to analytics/Events.js!"));
        });
    }
}

});
parcelRegister("7Uh51", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_EVENT_CONTAINER_NAV_BAR", () => $5c1b031836ec9da9$export$8155c7a1f67ba4c5);
$parcel$export(module.exports, "ANALYTICS_EVENT_CONTAINER_EMCEE_OVERVIEW_TAB", () => $5c1b031836ec9da9$export$48ad8e05066f53e6);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_ALREADY_INSTALLED_CTA", () => $5c1b031836ec9da9$export$85290fcf2d3d5966);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_DISCOVER", () => $5c1b031836ec9da9$export$f8119b3d88e10685);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE", () => $5c1b031836ec9da9$export$91fe9a96912c98d2);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_NAME", () => $5c1b031836ec9da9$export$efcd5b53aa309a95);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_BYO_TILE", () => $5c1b031836ec9da9$export$7b79d3513c5f83a2);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_CONTEXT_NAME", () => $5c1b031836ec9da9$export$c7dc90e3b66873c9);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_FLAG_ACTION", () => $5c1b031836ec9da9$export$59c18c166acca460);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_INSTALL", () => $5c1b031836ec9da9$export$9e17d36621b76a56);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_INSTALL_CANCEL", () => $5c1b031836ec9da9$export$f0f67d2875e68305);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_INSTALL_CLOSE", () => $5c1b031836ec9da9$export$7b5e03e0c5812a3b);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_TOKEN_DONE", () => $5c1b031836ec9da9$export$270a1e79c00649c);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_UPGRADE", () => $5c1b031836ec9da9$export$6e4e80d1ba540e87);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_LEARN_MORE", () => $5c1b031836ec9da9$export$dec9b5f504a4f005);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_CREATE_TOKEN", () => $5c1b031836ec9da9$export$533aa25b0f64b1ce);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_ACTION_CANCEL", () => $5c1b031836ec9da9$export$e3d2695a26495109);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_ACTION_CONFIRM", () => $5c1b031836ec9da9$export$a5418ae81f0a1efb);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_APPS_ACTION", () => $5c1b031836ec9da9$export$8a82f4124654702f);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_CONFIGURE", () => $5c1b031836ec9da9$export$cfb4d761ccf3da11);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_MENU_OPEN", () => $5c1b031836ec9da9$export$3f3b324e296d8106);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MORE_RESULTS", () => $5c1b031836ec9da9$export$42d84d76d71ca474);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_NAV_BAR_CUSTOM_APP", () => $5c1b031836ec9da9$export$d5d31009a4d09a00);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_NAV_BAR_VIEW_SWITCHER", () => $5c1b031836ec9da9$export$8ac0d3dba7bb30fb);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_PRIVACY_POLICY", () => $5c1b031836ec9da9$export$3fee338e51e0f2b8);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_REVOKE_USER_GRANT", () => $5c1b031836ec9da9$export$67dca9531683d445);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_TERMS_OF_USE", () => $5c1b031836ec9da9$export$6836c15d9fe977bc);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_LOG_ACCESS", () => $5c1b031836ec9da9$export$e83f1d83f40bcc59);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MARKETPLACE_TERMS_OF_USE", () => $5c1b031836ec9da9$export$7e0507c2b4a6497e);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_USER_GRANT_DETAILS", () => $5c1b031836ec9da9$export$f4f54bad79415400);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_VIEW_APP_DETAILS", () => $5c1b031836ec9da9$export$9fa47efaf29714c4);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_VIEW_APP_PRICING_DETAILS", () => $5c1b031836ec9da9$export$424eb23af5705b80);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_DISCOVER_APP_LISTING", () => $5c1b031836ec9da9$export$abbbc55ea1030a15);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_VIEW_MORE_ON_MARKETPLACE_LINK", () => $5c1b031836ec9da9$export$697304b6031576f7);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_FEEDBACK_CLICKED_BUTTON", () => $5c1b031836ec9da9$export$cda08e0ffa558148);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_FEEDBACK_SUBMIT_BUTTON", () => $5c1b031836ec9da9$export$9e97585e2f6f1bc6);
$parcel$export(module.exports, "ANALYTICS_OBJECT_TYPE_APP_LISTING", () => $5c1b031836ec9da9$export$974332797d985e3d);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_EMCEE_APP_LISTING_TAB", () => $5c1b031836ec9da9$export$6a1972228cdc0e40);
$parcel$export(module.exports, "ANALYTICS_OBJECT_TYPE_APP_REQUESTS", () => $5c1b031836ec9da9$export$14952f525b4ec13d);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS", () => $5c1b031836ec9da9$export$e38503968cb69ac4);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_REJECT_REQUEST", () => $5c1b031836ec9da9$export$dfb42288a456d21e);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APPROVE_REQUEST", () => $5c1b031836ec9da9$export$c273006c951aabf8);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_REQUEST_APP", () => $5c1b031836ec9da9$export$1ac89c346c8a29a6);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_REQUEST_APP_CANCELED", () => $5c1b031836ec9da9$export$2b20df3caf0e919d);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_REQUEST_APP_SUBMITTED", () => $5c1b031836ec9da9$export$faca5110ba0e1832);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_REJECT_REQUEST_CANCEL", () => $5c1b031836ec9da9$export$dcc3b1ce5b2be311);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_REJECT_REQUEST_SUBMIT", () => $5c1b031836ec9da9$export$5e3747f5ff311c7f);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_REQUEST_COMMENTS_CANCEL", () => $5c1b031836ec9da9$export$c074bd251be39dd9);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_REQUEST_COMMENTS_VIEW_APP_DETAILS", () => $5c1b031836ec9da9$export$159343082f417408);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APP_REQUEST_COUNT", () => $5c1b031836ec9da9$export$a2e7721e2ee7f217);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS_FILTER", () => $5c1b031836ec9da9$export$3d2cbf0ee048c459);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS_TABLE", () => $5c1b031836ec9da9$export$3db60103da471976);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS_SEARCH", () => $5c1b031836ec9da9$export$bc979781d6e779f3);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_RUSSIAN_USER_BLOCKED", () => $5c1b031836ec9da9$export$98242f7110de4e13);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_APP_PROMOTIONS", () => $5c1b031836ec9da9$export$95630fa5a29d1b5d);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MANAGE_APP_PROMOTIONS_FILTER", () => $5c1b031836ec9da9$export$882d7d784f0faf15);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_TOGGLE_APPS_IN_PROMOTION", () => $5c1b031836ec9da9$export$48950fcdf326d2f3);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_APPLY_PROMOTION", () => $5c1b031836ec9da9$export$cc9ba089edaf63d9);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_EMPTY_VIEW_APPLY_PROMOTION", () => $5c1b031836ec9da9$export$649b2766a433a3ce);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_MISSING_INSTALLED_APPS", () => $5c1b031836ec9da9$export$f9736834cd311afd);
$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_CANCEL_APPLY_PROMOTION_MODAL", () => $5c1b031836ec9da9$export$5b08d2e121390a81);
$parcel$export(module.exports, "ANALYTICS_CATEGORY_INSTALL", () => $5c1b031836ec9da9$export$b29b10ad080cb537);
$parcel$export(module.exports, "ANALYTICS_CATEGORY_UNINSTALL", () => $5c1b031836ec9da9$export$4a1bd1f65c6904a5);
$parcel$export(module.exports, "ANALYTICS_CATEGORY_TOKENS", () => $5c1b031836ec9da9$export$66685693430a26b3);
$parcel$export(module.exports, "ANALYTICS_CATEGORY_NAVIGATION", () => $5c1b031836ec9da9$export$7d3d53f70c302f29);
$parcel$export(module.exports, "ANALYTICS_CATEGORY_MARKETPLACE_APP_INSTALL", () => $5c1b031836ec9da9$export$b1a737d5067f19e4);
$parcel$export(module.exports, "ANALYTICS_CATEGORY_MARKETPLACE_APP_REQUEST", () => $5c1b031836ec9da9$export$b7822b2d343b27ad);
$parcel$export(module.exports, "AppInstalledEvent", () => $5c1b031836ec9da9$export$10ccc4c2817321e0);
$parcel$export(module.exports, "AppInstallFailedEvent", () => $5c1b031836ec9da9$export$e9789ec6a84855e0);
$parcel$export(module.exports, "AppUpgradedEvent", () => $5c1b031836ec9da9$export$c1492a5362b9db64);
$parcel$export(module.exports, "AppUpgradeFailedEvent", () => $5c1b031836ec9da9$export$8b3e30e8c7ba952f);
$parcel$export(module.exports, "AppRemovedEvent", () => $5c1b031836ec9da9$export$c51684a3728317dc);
$parcel$export(module.exports, "AppRemoveFailedEvent", () => $5c1b031836ec9da9$export$5f38461f66654c89);
$parcel$export(module.exports, "ExpandableSectionCollapsedEvent", () => $5c1b031836ec9da9$export$95f46e52463e9417);
$parcel$export(module.exports, "ExpandableSectionExpandedEvent", () => $5c1b031836ec9da9$export$31d0466fabf3f6c6);
$parcel$export(module.exports, "FetchAppDetailsFailedEvent", () => $5c1b031836ec9da9$export$a0290c56305f0d86);
$parcel$export(module.exports, "TokenGeneratedEvent", () => $5c1b031836ec9da9$export$1fcb3a859e45c921);
$parcel$export(module.exports, "TokenGenerateFailedEvent", () => $5c1b031836ec9da9$export$2dc6e288474a47c6);
$parcel$export(module.exports, "TokenRegenerateFailedEvent", () => $5c1b031836ec9da9$export$f388bf878e841bf1);
$parcel$export(module.exports, "TokenRemovedEvent", () => $5c1b031836ec9da9$export$de5f971e01f037e5);
$parcel$export(module.exports, "TokenRemoveFailedEvent", () => $5c1b031836ec9da9$export$c7df4b692c1ea194);
$parcel$export(module.exports, "TokenRegeneratedEvent", () => $5c1b031836ec9da9$export$e6b697718122cfe1);
$parcel$export(module.exports, "UserGrantRemovedEvent", () => $5c1b031836ec9da9$export$29c5fffeda04799f);
$parcel$export(module.exports, "UserGrantRemoveFailedEvent", () => $5c1b031836ec9da9$export$258901979691b2a7);
$parcel$export(module.exports, "DynamicTableSorted", () => $5c1b031836ec9da9$export$e5a796d2dc45d9ce);
$parcel$export(module.exports, "DynamicTablePageChanged", () => $5c1b031836ec9da9$export$435535f2f114ba70);
$parcel$export(module.exports, "AppRequestedEvent", () => $5c1b031836ec9da9$export$e5dd6b4ca35b8111);
$parcel$export(module.exports, "AppRequestFailedEvent", () => $5c1b031836ec9da9$export$45f1a82ef3f0a818);
$parcel$export(module.exports, "AppPromotionValidated", () => $5c1b031836ec9da9$export$bbd19682b12b034);
$parcel$export(module.exports, "AppPromotionRedeemed", () => $5c1b031836ec9da9$export$88567da0815ae8ce);
$parcel$export(module.exports, "AppPromotionRedeemFailedEvent", () => $5c1b031836ec9da9$export$d55434075b08ecbf);
$parcel$export(module.exports, "AppInstallPermissionEvaluationFailed", () => $5c1b031836ec9da9$export$e73b1e241e47726b);
$parcel$export(module.exports, "AppRequestButtonViewed", () => $5c1b031836ec9da9$export$c3fff01552fc8373);
$parcel$export(module.exports, "AppInstallBlockedForRussianUserEvent", () => $5c1b031836ec9da9$export$7cd0941ebba56522);
$parcel$export(module.exports, "allAnalyticsEvents", () => $5c1b031836ec9da9$export$df30d4c85d3bbbeb);

var $gaiog = parcelRequire("gaiog");
var $lNaxt = parcelRequire("lNaxt");

var $g5DHJ = parcelRequire("g5DHJ");
const $5c1b031836ec9da9$export$8155c7a1f67ba4c5 = (0, $gaiog.makeEventContainer)('emceeNavBar');
const $5c1b031836ec9da9$export$48ad8e05066f53e6 = (0, $gaiog.makeEventContainer)('emceeOverviewTab');
// Analytics Actions
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_GENERATED = (0, $gaiog.makeAnalyticsAction)('generated');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_GENERATE_FAILED = (0, $gaiog.makeAnalyticsAction)('generateFailed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_INSTALLED = (0, $gaiog.makeAnalyticsAction)('installed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_INSTALL_FAILED = (0, $gaiog.makeAnalyticsAction)('installFailed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_UPGRADED = (0, $gaiog.makeAnalyticsAction)('upgraded');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_UPGRADE_FAILED = (0, $gaiog.makeAnalyticsAction)('upgradeFailed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_REGENERATED = (0, $gaiog.makeAnalyticsAction)('regenerated');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_REGENERATE_FAILED = (0, $gaiog.makeAnalyticsAction)('regenerateFailed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_FIRST_MEANINGFUL_PAINT_COMPLETED = (0, $gaiog.makeAnalyticsAction)('firstMeaningfulPaintCompleted');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_SORTED = (0, $gaiog.makeAnalyticsAction)('sorted');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_REQUESTED = (0, $gaiog.makeAnalyticsAction)('requested');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_REQUEST_FAILED = (0, $gaiog.makeAnalyticsAction)('requestFailed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_PROMOTION_REDEEMED_FAILED = (0, $gaiog.makeAnalyticsAction)('redeemPromotionFailed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_PROMOTION_REDEEMED = (0, $gaiog.makeAnalyticsAction)('promotionRedeemed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_PROMOTION_VALIDATED = (0, $gaiog.makeAnalyticsAction)('promotionValidated');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_REQUEST_BUTTON_VIEWED = (0, $gaiog.makeAnalyticsAction)('requestButtonViewed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_INSTALL_PERMISSION_EVALUATION_FAILED = (0, $gaiog.makeAnalyticsAction)('installPermissionEvaluationFailed');
const $5c1b031836ec9da9$var$ANALYTICS_ACTION_FEATURE_EXPOSED = (0, $gaiog.makeAnalyticsAction)('exposed');
const $5c1b031836ec9da9$export$db23786aad95018a = (0, $gaiog.makeAnalyticsAction)('viewed');
const $5c1b031836ec9da9$export$cc8e7fae1116fc7b = (0, $gaiog.makeAnalyticsAction)('entered');
const $5c1b031836ec9da9$export$e6ff11761cb083ce = (0, $gaiog.makeAnalyticsAction)('rendered');
// Analytics Action Subjects
const $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_EXPANDABLE_SECTION = (0, $gaiog.makeAnalyticsActionSubject)('expandableSection');
const $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_TOKEN = (0, $gaiog.makeAnalyticsActionSubject)('token');
const $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_USER_GRANT = (0, $gaiog.makeAnalyticsActionSubject)('userGrant');
const $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_DYNAMIC_TABLE = (0, $gaiog.makeAnalyticsActionSubject)('dynamicTable');
const $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_FEATURE = (0, $gaiog.makeAnalyticsActionSubject)('feature');
const $5c1b031836ec9da9$export$85290fcf2d3d5966 = 'alreadyInstalledCTA';
const $5c1b031836ec9da9$export$f8119b3d88e10685 = 'discover';
const $5c1b031836ec9da9$export$91fe9a96912c98d2 = 'manage';
const $5c1b031836ec9da9$export$efcd5b53aa309a95 = 'appName';
const $5c1b031836ec9da9$export$7b79d3513c5f83a2 = 'byoTile';
const $5c1b031836ec9da9$export$c7dc90e3b66873c9 = 'contextName';
const $5c1b031836ec9da9$export$59c18c166acca460 = 'flagAction';
const $5c1b031836ec9da9$export$9e17d36621b76a56 = 'install';
const $5c1b031836ec9da9$export$f0f67d2875e68305 = 'installCancel';
const $5c1b031836ec9da9$export$7b5e03e0c5812a3b = 'installClose';
const $5c1b031836ec9da9$export$270a1e79c00649c = 'tokenDone';
const $5c1b031836ec9da9$export$6e4e80d1ba540e87 = 'upgrade';
const $5c1b031836ec9da9$export$dec9b5f504a4f005 = 'learnMore';
const $5c1b031836ec9da9$export$533aa25b0f64b1ce = 'createToken';
const $5c1b031836ec9da9$export$e3d2695a26495109 = 'manageActionCancel';
const $5c1b031836ec9da9$export$a5418ae81f0a1efb = 'manageActionConfirm';
const $5c1b031836ec9da9$export$8a82f4124654702f = 'manageAppsAction';
const $5c1b031836ec9da9$export$cfb4d761ccf3da11 = 'manageConfigure';
const $5c1b031836ec9da9$export$3f3b324e296d8106 = 'manageMenuOpen';
const $5c1b031836ec9da9$export$42d84d76d71ca474 = 'moreResults';
const $5c1b031836ec9da9$export$d5d31009a4d09a00 = 'navBarCustomApp';
const $5c1b031836ec9da9$export$8ac0d3dba7bb30fb = 'navBarViewSwitcher';
const $5c1b031836ec9da9$export$3fee338e51e0f2b8 = 'privacyPolicy';
const $5c1b031836ec9da9$export$67dca9531683d445 = 'revokeUserGrant';
const $5c1b031836ec9da9$export$6836c15d9fe977bc = 'termsOfUse';
const $5c1b031836ec9da9$export$e83f1d83f40bcc59 = 'manageLogAccess';
const $5c1b031836ec9da9$export$7e0507c2b4a6497e = 'marketplaceTermsOfUse';
const $5c1b031836ec9da9$export$f4f54bad79415400 = 'userGrantDetails';
const $5c1b031836ec9da9$export$9fa47efaf29714c4 = 'viewAppDetails';
const $5c1b031836ec9da9$export$424eb23af5705b80 = 'viewAppPricingDetails';
const $5c1b031836ec9da9$export$a33d9f95d57cad28 = 'partnerName';
const $5c1b031836ec9da9$export$abbbc55ea1030a15 = 'discoverAppListing';
const $5c1b031836ec9da9$export$6020eacd09143189 = 'perfMetrics';
const $5c1b031836ec9da9$export$2c9c5ee2d68b11cb = 'installDeterminingModal';
const $5c1b031836ec9da9$export$91782083c4c1f37b = 'installModal';
const $5c1b031836ec9da9$export$697304b6031576f7 = 'viewMoreOnMarketplaceLink';
const $5c1b031836ec9da9$export$cda08e0ffa558148 = 'emceeFeedbackButton';
const $5c1b031836ec9da9$export$9e97585e2f6f1bc6 = 'emceeFeedbackSubmitButton';
const $5c1b031836ec9da9$export$bcfbaf5a28647621 = (0, $gaiog.makeAnalyticsActionSubject)('searchOverlay');
const $5c1b031836ec9da9$export$f49811924c23f531 = (0, $gaiog.makeAnalyticsActionSubject)('searchEmbedded');
const $5c1b031836ec9da9$export$2c845c02055cfe32 = (0, $gaiog.makeAnalyticsActionSubject)('error');
const $5c1b031836ec9da9$export$2dfd3d1dcf2c7652 = (0, $gaiog.makeAnalyticsActionSubject)('navigationItem');
const $5c1b031836ec9da9$export$292cd545f4464697 = (0, $gaiog.makeAnalyticsActionSubject)('screenViewed');
const $5c1b031836ec9da9$export$8372f7a903a3e882 = (0, $gaiog.makeAnalyticsActionSubject)('filter');
const $5c1b031836ec9da9$export$b5beeddca34af740 = (0, $gaiog.makeAnalyticsActionSubject)('sort');
const $5c1b031836ec9da9$export$84007be1e3689955 = (0, $gaiog.makeAnalyticsActionSubject)('tiles');
const $5c1b031836ec9da9$export$974332797d985e3d = 'appListing';
const $5c1b031836ec9da9$export$6a1972228cdc0e40 = 'emceeAppListingTab';
const $5c1b031836ec9da9$export$14952f525b4ec13d = 'appRequests';
const $5c1b031836ec9da9$export$e38503968cb69ac4 = 'manageAppRequests';
const $5c1b031836ec9da9$export$dfb42288a456d21e = 'rejectRequest';
const $5c1b031836ec9da9$export$c273006c951aabf8 = 'approveRequest';
const $5c1b031836ec9da9$export$1ac89c346c8a29a6 = 'requestApp';
const $5c1b031836ec9da9$export$2b20df3caf0e919d = 'requestAppCancelled';
const $5c1b031836ec9da9$export$faca5110ba0e1832 = 'requestAppSubmitted';
const $5c1b031836ec9da9$export$dcc3b1ce5b2be311 = 'rejectRequestCancelled';
const $5c1b031836ec9da9$export$5e3747f5ff311c7f = 'rejectRequestSubmitted';
const $5c1b031836ec9da9$export$c074bd251be39dd9 = 'appRequestCommentsCancel';
const $5c1b031836ec9da9$export$159343082f417408 = 'viewAppDetails';
const $5c1b031836ec9da9$export$a2e7721e2ee7f217 = 'requestCount';
const $5c1b031836ec9da9$export$3d2cbf0ee048c459 = 'manageAppRequestsFilter';
const $5c1b031836ec9da9$export$3db60103da471976 = 'manageAppRequestsTable';
const $5c1b031836ec9da9$export$bc979781d6e779f3 = 'manageAppRequestsSearch';
const $5c1b031836ec9da9$export$cedc7c71e0f0775d = 'manageAppRequestsPage';
const $5c1b031836ec9da9$export$98242f7110de4e13 = 'blockedRussianUser';
const $5c1b031836ec9da9$export$21b98987e67ce12c = 'appPromotions';
const $5c1b031836ec9da9$export$95630fa5a29d1b5d = 'manageAppPromotions';
const $5c1b031836ec9da9$export$882d7d784f0faf15 = 'manageAppPromotionsFilter';
const $5c1b031836ec9da9$export$48950fcdf326d2f3 = 'toggleAppsInPromotion';
const $5c1b031836ec9da9$export$cc9ba089edaf63d9 = 'applyPromotion';
const $5c1b031836ec9da9$export$649b2766a433a3ce = 'emptyViewApplyPromotion';
const $5c1b031836ec9da9$export$f9736834cd311afd = 'missingInstalledApps';
const $5c1b031836ec9da9$export$5b08d2e121390a81 = 'cancelApplyPromotionModal';
const $5c1b031836ec9da9$export$b29b10ad080cb537 = (0, $gaiog.makeAnalyticsCategory)('EmceeInstall');
const $5c1b031836ec9da9$export$4a1bd1f65c6904a5 = (0, $gaiog.makeAnalyticsCategory)('EmceeUninstall');
const $5c1b031836ec9da9$export$66685693430a26b3 = (0, $gaiog.makeAnalyticsCategory)('EmceeTokens');
const $5c1b031836ec9da9$export$7d3d53f70c302f29 = (0, $gaiog.makeAnalyticsCategory)('EmceeNavigation');
const $5c1b031836ec9da9$export$b1a737d5067f19e4 = (0, $gaiog.makeAnalyticsCategory)('MarketplaceAppInstall');
const $5c1b031836ec9da9$export$b7822b2d343b27ad = (0, $gaiog.makeAnalyticsCategory)('MarketplaceAppRequest');
const $5c1b031836ec9da9$export$ef6019d585de2438 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_FEATURE_EXPOSED,
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_FEATURE,
    details: 'Feature exposed to user',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$10ccc4c2817321e0 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_INSTALLED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'App installation succeeds',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$e9789ec6a84855e0 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_INSTALL_FAILED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'Error occurs while installing an app',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$c1492a5362b9db64 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_UPGRADED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'User upgrades an app in Embedded Marketplace',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$8b3e30e8c7ba952f = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_UPGRADE_FAILED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'Error occurs while upgrading an app in Embedded Marketplace',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$c51684a3728317dc = {
    action: (0, $gaiog.ANALYTICS_ACTION_REMOVED),
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'User uninstalls an app in Embedded Marketplace',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$5f38461f66654c89 = {
    action: (0, $gaiog.ANALYTICS_ACTION_REMOVE_FAILED),
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'Error occurs while uninstalling an app through Embedded Marketplace',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$95f46e52463e9417 = {
    action: (0, $gaiog.ANALYTICS_ACTION_COLLAPSED),
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_EXPANDABLE_SECTION,
    details: 'User collapsed an expandable section',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$31d0466fabf3f6c6 = {
    action: (0, $gaiog.ANALYTICS_ACTION_EXPANDED),
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_EXPANDABLE_SECTION,
    details: 'User expanded an expandable section',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$a0290c56305f0d86 = {
    action: (0, $gaiog.ANALYTICS_ACTION_FETCH_FAILED),
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'Error occurs while fetching app details in Embedded Marketplace install dialog',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$1fcb3a859e45c921 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_GENERATED,
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_TOKEN,
    details: 'A token was generated',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$2dc6e288474a47c6 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_GENERATE_FAILED,
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_TOKEN,
    details: 'An error occurred while generating a token',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$f388bf878e841bf1 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_REGENERATE_FAILED,
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_TOKEN,
    details: 'An error occurred while regenerating a token',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$de5f971e01f037e5 = {
    action: (0, $gaiog.ANALYTICS_ACTION_REMOVED),
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_TOKEN,
    details: 'A token was removed/revoked',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$c7df4b692c1ea194 = {
    action: (0, $gaiog.ANALYTICS_ACTION_REMOVE_FAILED),
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_TOKEN,
    details: 'An error occurred while removing a token',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$e6b697718122cfe1 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_REGENERATED,
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_TOKEN,
    details: 'A token was regenerated',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$29c5fffeda04799f = {
    action: (0, $gaiog.ANALYTICS_ACTION_REMOVED),
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_USER_GRANT,
    details: 'A user grant was successfully revoked',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$258901979691b2a7 = {
    action: (0, $gaiog.ANALYTICS_ACTION_REMOVE_FAILED),
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_USER_GRANT,
    details: 'An error occurred while revoking a user grant',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$7e2ac8c4f8d47a78 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_FIRST_MEANINGFUL_PAINT_COMPLETED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_UI),
    details: 'First meaningful paint completed',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$e5a796d2dc45d9ce = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_SORTED,
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_DYNAMIC_TABLE,
    details: 'When dynamic table is sorted',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$435535f2f114ba70 = {
    action: (0, $gaiog.ANALYTICS_ACTION_CHANGED),
    actionSubject: $5c1b031836ec9da9$var$ANALYTICS_SUBJECT_DYNAMIC_TABLE,
    details: 'Page number changed in a dynamic table',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$e5dd6b4ca35b8111 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_REQUESTED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'End user requests admin to install an app',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$45f1a82ef3f0a818 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_REQUEST_FAILED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'Error occurs while end user requesting admin to install an app',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$bbd19682b12b034 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_PROMOTION_VALIDATED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'When user validated a promo code successfully',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$88567da0815ae8ce = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_PROMOTION_REDEEMED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'When user redeemed a promo code successfully',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$d55434075b08ecbf = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_PROMOTION_REDEEMED_FAILED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'Error occurs while redeeming promotion code',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$e73b1e241e47726b = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_INSTALL_PERMISSION_EVALUATION_FAILED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'When app install permission evaluation is failed',
    type: (0, $lNaxt.OPERATIONAL_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$c3fff01552fc8373 = {
    action: $5c1b031836ec9da9$var$ANALYTICS_ACTION_APP_REQUEST_BUTTON_VIEWED,
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_APP),
    details: 'When app request button is viewed',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$7cd0941ebba56522 = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: (0, $gaiog.ANALYTICS_SUBJECT_BUTTON),
    details: 'Prevented app install for Russia',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$eef4c4c219985794 = {
    action: $5c1b031836ec9da9$export$db23786aad95018a,
    actionSubject: $5c1b031836ec9da9$export$bcfbaf5a28647621,
    details: 'User has viewed the search overlay',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$95c08a8a1d00d5d9 = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: $5c1b031836ec9da9$export$bcfbaf5a28647621,
    details: 'User has selected a suggestion',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$5f2ac52054ff0703 = {
    action: $5c1b031836ec9da9$export$cc8e7fae1116fc7b,
    actionSubject: $5c1b031836ec9da9$export$bcfbaf5a28647621,
    details: 'User pressed an enter key',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$3b5c1a8abac22038 = {
    action: $5c1b031836ec9da9$export$db23786aad95018a,
    actionSubject: $5c1b031836ec9da9$export$f49811924c23f531,
    details: 'User has viewed the search overlay',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$835e2ca6154629af = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: $5c1b031836ec9da9$export$f49811924c23f531,
    details: 'User has selected a suggestion',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$a0ce8ac2d8f9789f = {
    action: $5c1b031836ec9da9$export$e6ff11761cb083ce,
    actionSubject: $5c1b031836ec9da9$export$84007be1e3689955,
    details: 'Marketplace app tiles were rendered and are now visible to the user',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$57e303b46a8f8ad2 = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: $5c1b031836ec9da9$export$2dfd3d1dcf2c7652,
    details: 'User clicked a navbar item',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$f015ff8244e789d5 = {
    action: $5c1b031836ec9da9$export$cc8e7fae1116fc7b,
    actionSubject: $5c1b031836ec9da9$export$f49811924c23f531,
    details: 'User pressed an enter key',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$15a0a93c7224b959 = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: $5c1b031836ec9da9$export$8372f7a903a3e882,
    details: 'User has cleared a selected filter for the app search',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$3024be86a7637e37 = {
    action: $5c1b031836ec9da9$export$e6ff11761cb083ce,
    actionSubject: $5c1b031836ec9da9$export$2c845c02055cfe32,
    details: 'An error state has been rendered',
    type: (0, $lNaxt.TRACK_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$b30d9e3d99fe197b = {
    action: (0, $gaiog.ANALYTICS_ACTION_CLICKED),
    actionSubject: $5c1b031836ec9da9$export$b5beeddca34af740,
    details: 'User has selected a sort option',
    type: (0, $lNaxt.UI_EVENT_TYPE)
};
const $5c1b031836ec9da9$export$df30d4c85d3bbbeb = (0, $g5DHJ.Set)([
    $5c1b031836ec9da9$export$10ccc4c2817321e0,
    $5c1b031836ec9da9$export$e9789ec6a84855e0,
    $5c1b031836ec9da9$export$c1492a5362b9db64,
    $5c1b031836ec9da9$export$8b3e30e8c7ba952f,
    $5c1b031836ec9da9$export$c51684a3728317dc,
    $5c1b031836ec9da9$export$5f38461f66654c89,
    $5c1b031836ec9da9$export$435535f2f114ba70,
    (0, $gaiog.BreadcrumbClickedEvent),
    (0, $gaiog.ButtonClickedEvent),
    (0, $gaiog.ImageClickedEvent),
    $5c1b031836ec9da9$export$95f46e52463e9417,
    $5c1b031836ec9da9$export$31d0466fabf3f6c6,
    $5c1b031836ec9da9$export$ef6019d585de2438,
    $5c1b031836ec9da9$export$a0290c56305f0d86,
    (0, $gaiog.MenuItemClickedEvent),
    (0, $gaiog.TileClickedEvent),
    $5c1b031836ec9da9$export$1fcb3a859e45c921,
    $5c1b031836ec9da9$export$2dc6e288474a47c6,
    $5c1b031836ec9da9$export$e6b697718122cfe1,
    $5c1b031836ec9da9$export$f388bf878e841bf1,
    $5c1b031836ec9da9$export$de5f971e01f037e5,
    $5c1b031836ec9da9$export$c7df4b692c1ea194,
    $5c1b031836ec9da9$export$29c5fffeda04799f,
    $5c1b031836ec9da9$export$258901979691b2a7,
    $5c1b031836ec9da9$export$7e2ac8c4f8d47a78,
    $5c1b031836ec9da9$export$e5a796d2dc45d9ce,
    (0, $gaiog.SearchSubmittedEvent),
    (0, $gaiog.FilterClickedEvent),
    $5c1b031836ec9da9$export$e5dd6b4ca35b8111,
    $5c1b031836ec9da9$export$45f1a82ef3f0a818,
    $5c1b031836ec9da9$export$c3fff01552fc8373,
    $5c1b031836ec9da9$export$e73b1e241e47726b,
    $5c1b031836ec9da9$export$bbd19682b12b034,
    $5c1b031836ec9da9$export$88567da0815ae8ce,
    $5c1b031836ec9da9$export$d55434075b08ecbf,
    $5c1b031836ec9da9$export$7cd0941ebba56522,
    (0, $gaiog.TabClickedEvent),
    (0, $gaiog.LinkClickedEvent),
    $5c1b031836ec9da9$export$eef4c4c219985794,
    $5c1b031836ec9da9$export$95c08a8a1d00d5d9,
    $5c1b031836ec9da9$export$5f2ac52054ff0703,
    $5c1b031836ec9da9$export$3b5c1a8abac22038,
    $5c1b031836ec9da9$export$835e2ca6154629af,
    $5c1b031836ec9da9$export$f015ff8244e789d5,
    $5c1b031836ec9da9$export$a0ce8ac2d8f9789f,
    $5c1b031836ec9da9$export$57e303b46a8f8ad2,
    $5c1b031836ec9da9$export$15a0a93c7224b959,
    $5c1b031836ec9da9$export$3024be86a7637e37,
    $5c1b031836ec9da9$export$b30d9e3d99fe197b
]);

});




parcelRegister("j2ea9", function(module, exports) {

$parcel$export(module.exports, "FETCH_HOST_INFO", () => $ddb930a5e999d8f4$export$acb256f79b282836);
$parcel$export(module.exports, "RECEIVE_HOST_INFO", () => $ddb930a5e999d8f4$export$7d6de1aefb619513);
$parcel$export(module.exports, "RECEIVE_HOST_INFO_ERROR", () => $ddb930a5e999d8f4$export$512b09fa1796081e);
$parcel$export(module.exports, "FETCH_HOST_CONFIG", () => $ddb930a5e999d8f4$export$86ab4ceecb7d652d);
$parcel$export(module.exports, "RECEIVE_HOST_CONFIG", () => $ddb930a5e999d8f4$export$434eebc017a3ac83);
$parcel$export(module.exports, "RECEIVE_HOST_CONFIG_ERROR", () => $ddb930a5e999d8f4$export$f010b7d318b7c401);
$parcel$export(module.exports, "RECEIVE_FEATURE_FLAGS", () => $ddb930a5e999d8f4$export$933390723ab25af2);
$parcel$export(module.exports, "RECEIVE_FEATURE_FLAGS_ERROR", () => $ddb930a5e999d8f4$export$a86d54cac2234b40);
$parcel$export(module.exports, "FETCH_FRONTEND_BOOTSTRAP_CONFIG", () => $ddb930a5e999d8f4$export$8789223b3c0b9d38);
$parcel$export(module.exports, "RECEIVE_FRONTEND_BOOTSTRAP_CONFIG", () => $ddb930a5e999d8f4$export$83dd83b3480d9efd);
$parcel$export(module.exports, "receiveFeatureFlags", () => $ddb930a5e999d8f4$export$c9fd7b8547912b75);
$parcel$export(module.exports, "doRetrieveFeatureFlags", () => $ddb930a5e999d8f4$export$8f69c22eb5c092a);
$parcel$export(module.exports, "doRetrieveHostInfo", () => $ddb930a5e999d8f4$export$8f666219f64d80f0);
$parcel$export(module.exports, "doRetrieveHostConfig", () => $ddb930a5e999d8f4$export$e103faa4b459fd47);
$parcel$export(module.exports, "doRetrieveFrontendBootstrap", () => $ddb930a5e999d8f4$export$f6ec0768e685f23d);

var $7hgtR = parcelRequire("7hgtR");

var $l5Qbn = parcelRequire("l5Qbn");

var $3Sxn2 = parcelRequire("3Sxn2");
var $8a1FM = parcelRequire("8a1FM");

var $bTrQR = parcelRequire("bTrQR");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $7YbkQ = parcelRequire("7YbkQ");

var $7Qsmx = parcelRequire("7Qsmx");

var $iIG3b = parcelRequire("iIG3b");

var $5kxcx = parcelRequire("5kxcx");

var $bSQ4o = parcelRequire("bSQ4o");

var $55gtq = parcelRequire("55gtq");

var $bPtM5 = parcelRequire("bPtM5");
const $ddb930a5e999d8f4$export$acb256f79b282836 = 'CONFIGURATION_FETCH_HOST_INFO';
const $ddb930a5e999d8f4$export$7d6de1aefb619513 = 'CONFIGURATION_RECEIVE_HOST_INFO';
const $ddb930a5e999d8f4$export$512b09fa1796081e = 'CONFIGURATION_RECEIVE_HOST_INFO_ERROR';
const $ddb930a5e999d8f4$export$86ab4ceecb7d652d = 'CONFIGURATION_FETCH_HOST_CONFIG';
const $ddb930a5e999d8f4$export$434eebc017a3ac83 = 'CONFIGURATION_RECEIVE_HOST_CONFIG';
const $ddb930a5e999d8f4$export$f010b7d318b7c401 = 'CONFIGURATION_RECEIVE_HOST_CONFIG_ERROR';
const $ddb930a5e999d8f4$export$933390723ab25af2 = 'CONFIGURATION_RECEIVE_FEATURE_FLAGS';
const $ddb930a5e999d8f4$export$a86d54cac2234b40 = 'CONFIGURATION_RECEIVE_FEATURE_FLAGS_ERROR';
const $ddb930a5e999d8f4$export$8789223b3c0b9d38 = 'CONFIGURATION_FETCH_FRONTEND_BOOTSTRAP';
const $ddb930a5e999d8f4$export$83dd83b3480d9efd = 'CONFIGURATION_RECEIVE_FRONTEND_BOOTSTRAP';
const $ddb930a5e999d8f4$var$fetchHostInfo = ()=>({
        type: $ddb930a5e999d8f4$export$acb256f79b282836
    });
const $ddb930a5e999d8f4$var$receiveHostInfo = (_ref)=>{
    let { hostInfo: hostInfo } = _ref;
    return {
        type: $ddb930a5e999d8f4$export$7d6de1aefb619513,
        hostInfo: hostInfo
    };
};
const $ddb930a5e999d8f4$var$receiveHostInfoError = (_ref2)=>{
    let { dataErrorMessages: dataErrorMessages } = _ref2;
    return {
        type: $ddb930a5e999d8f4$export$512b09fa1796081e,
        dataErrorMessages: dataErrorMessages
    };
};
const $ddb930a5e999d8f4$var$fetchHostConfig = ()=>({
        type: $ddb930a5e999d8f4$export$86ab4ceecb7d652d
    });
const $ddb930a5e999d8f4$var$fetchFrontendBootstrap = ()=>({
        type: $ddb930a5e999d8f4$export$8789223b3c0b9d38
    });
const $ddb930a5e999d8f4$var$receiveFrontendBootstrap = (_ref3)=>{
    let { frontendBootstrap: frontendBootstrap } = _ref3;
    return {
        type: $ddb930a5e999d8f4$export$83dd83b3480d9efd,
        frontendBootstrap: frontendBootstrap
    };
};
const $ddb930a5e999d8f4$var$receiveHostConfig = (_ref4)=>{
    let { hostConfig: hostConfig } = _ref4;
    return {
        type: $ddb930a5e999d8f4$export$434eebc017a3ac83,
        hostConfig: hostConfig
    };
};
const $ddb930a5e999d8f4$var$receiveHostConfigError = (_ref5)=>{
    let { dataErrorMessages: dataErrorMessages } = _ref5;
    return {
        type: $ddb930a5e999d8f4$export$f010b7d318b7c401,
        dataErrorMessages: dataErrorMessages
    };
};
const $ddb930a5e999d8f4$export$c9fd7b8547912b75 = (_ref6)=>{
    let { featureFlags: featureFlags } = _ref6;
    return {
        type: $ddb930a5e999d8f4$export$933390723ab25af2,
        featureFlags: featureFlags
    };
};
const $ddb930a5e999d8f4$var$receiveFeatureFlagsError = (_ref7)=>{
    let { dataErrorMessages: dataErrorMessages } = _ref7;
    return {
        type: $ddb930a5e999d8f4$export$a86d54cac2234b40,
        dataErrorMessages: dataErrorMessages
    };
};
const $ddb930a5e999d8f4$export$8f69c22eb5c092a = (_ref8)=>{
    let { bootstrapConfig: bootstrapConfig, hostInfo: hostInfo, currentUserId: currentUserId } = _ref8;
    return async (dispatch)=>{
        try {
            const customAttributes = {
                emceeVariant: (0, $bPtM5.isEmceeConnect)() ? (0, $iIG3b.EmceeVariant).Connect : (0, $iIG3b.EmceeVariant).Native,
                emceeHostProduct: hostInfo.product,
                marketplaceType: (0, $8a1FM.MarketplaceType).EMCEE
            };
            const featureFlagClient = await (0, $3Sxn2.getFeatureFlagsClient)({
                apiKey: bootstrapConfig.featureFlags.apiKey,
                environment: bootstrapConfig.featureFlags.environment,
                userId: currentUserId,
                additionalIds: {
                    tenantId: (0, $bSQ4o.getCloudIdFromHostInfo)(hostInfo)
                },
                analyticsClient: (0, $7YbkQ.default).get(),
                productKey: hostInfo.product,
                customAttributes: customAttributes
            });
            dispatch($ddb930a5e999d8f4$export$c9fd7b8547912b75({
                featureFlags: featureFlagClient
            }));
            return featureFlagClient;
        } catch (error) {
            dispatch($ddb930a5e999d8f4$var$receiveFeatureFlagsError({
                dataErrorMessages: (0, $7hgtR.makeDataErrorMessages)([
                    error
                ])
            }));
            throw error;
        }
    };
};
const $ddb930a5e999d8f4$export$8f666219f64d80f0 = ()=>(dispatch)=>new Promise((resolve, reject)=>{
            dispatch($ddb930a5e999d8f4$var$fetchHostInfo());
            (0, $55gtq.default)().getHostInfo().then((hostInformation)=>{
                const hostInfo = (0, $5kxcx.makeHostInfo)(hostInformation);
                dispatch($ddb930a5e999d8f4$var$receiveHostInfo({
                    hostInfo: hostInfo
                }));
                resolve(hostInfo);
            }, (error)=>{
                (0, $bTrQR.default).error('Configuration', "failed to retrieve HostInfo : ".concat(error));
                dispatch($ddb930a5e999d8f4$var$receiveHostInfoError({
                    dataErrorMessages: (0, $7hgtR.makeDataErrorMessages)([
                        error
                    ])
                }));
                reject(error);
            });
        });
const $ddb930a5e999d8f4$var$resolveHostConfig = (hostInfo)=>Promise.resolve((0, $bWAru.Option).of((0, $7Qsmx.appConfig).get(hostInfo.product)).getOrElseL(()=>Promise.reject("No configuration present for this product '".concat(hostInfo.product, "'"))));
const $ddb930a5e999d8f4$export$e103faa4b459fd47 = (hostInfo)=>(dispatch)=>new Promise((resolve, reject)=>{
            dispatch($ddb930a5e999d8f4$var$fetchHostConfig());
            $ddb930a5e999d8f4$var$resolveHostConfig(hostInfo).then((hostConfig)=>{
                dispatch($ddb930a5e999d8f4$var$receiveHostConfig({
                    hostConfig: hostConfig
                }));
                resolve(hostConfig);
            }, (error)=>{
                (0, $bTrQR.default).error('Configuration', "failed to retrieve HostConfig : ".concat(error));
                dispatch($ddb930a5e999d8f4$var$receiveHostConfigError({
                    dataErrorMessages: (0, $7hgtR.makeDataErrorMessages)([
                        error
                    ])
                }));
                reject(error);
            });
        });
const $ddb930a5e999d8f4$export$f6ec0768e685f23d = ()=>(dispatch)=>new Promise((resolve)=>{
            dispatch($ddb930a5e999d8f4$var$fetchFrontendBootstrap());
            (0, $l5Qbn.getFrontendBootstrap)().then((frontendBootstrap)=>{
                dispatch($ddb930a5e999d8f4$var$receiveFrontendBootstrap({
                    frontendBootstrap: frontendBootstrap
                }));
                resolve(frontendBootstrap);
            }, ()=>{
            /*
     * The code should never reach here
     * getFrontendBootstrap() catches any exceptions & resolves to a fallback value
     */ });
        });

});
parcelRegister("l5Qbn", function(module, exports) {

$parcel$export(module.exports, "getFrontendBootstrap", () => $f5b28af59e937308$export$6302fa3e0051030);

var $5zQU9 = parcelRequire("5zQU9");

var $dO8LH = parcelRequire("dO8LH");
function $f5b28af59e937308$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f5b28af59e937308$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f5b28af59e937308$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f5b28af59e937308$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f5b28af59e937308$export$b354015228f07f4f = {
    launchDarklyUserKey: 'ANY_USER'
};
const $f5b28af59e937308$export$6302fa3e0051030 = async (headers, isSsr)=>{
    /**
   * Tesseract in S2S auth changes the base URL to hit demand service directly
   * with appropriate asap auth headers, hence CSR would require appropriate prefix which gateway
   * understands while SSR would only need to have the URL which demand service understands
   */ const path = isSsr ? "/frontend/bootstrap" : "/gateway/api/marketplace/internal/demand/frontend/bootstrap";
    const options = $f5b28af59e937308$var$_objectSpread({}, headers && {
        headers: headers
    });
    try {
        const response = await (0, $dO8LH.fetchOk)(path, options);
        const frontendBootstrapResponse = await response.json();
        return $f5b28af59e937308$var$_objectSpread($f5b28af59e937308$var$_objectSpread({}, frontendBootstrapResponse), {}, {
            setCookieHeader: response.headers.get('set-cookie')
        });
    } catch (error) {
        console.error('getFrontendBootstrap', 'Failed to fetch bootstrap, using fallback', error);
        return $f5b28af59e937308$var$_objectSpread({}, $f5b28af59e937308$export$b354015228f07f4f);
    }
};

});

parcelRegister("3Sxn2", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagsClient", () => $2d304cebcbfbe1df$export$3863b24dbf06b0f3);

var $gx5NS = parcelRequire("gx5NS");

var $fyrAH = parcelRequire("fyrAH");

var $fqrjS = parcelRequire("fqrjS");
function $2d304cebcbfbe1df$var$initializeLdClient(productKey, apiKey, environment, user, analyticsClient) {
    const clientOptions = {
        productKey: productKey,
        environment: environment
    };
    return new (0, $gx5NS.default)(apiKey, analyticsClient, user, clientOptions);
}
async function $2d304cebcbfbe1df$export$3863b24dbf06b0f3(_ref) {
    let { apiKey: apiKey, environment: environment, userId: userId, additionalIds: additionalIds, analyticsClient: analyticsClient, productKey: productKey, customAttributes: customAttributes } = _ref;
    const user = (0, $fqrjS.getFeatureFlagUser)(userId, additionalIds, customAttributes);
    const featureFlagsClient = $2d304cebcbfbe1df$var$initializeLdClient(productKey, apiKey, environment, user, analyticsClient);
    await featureFlagsClient.ready();
    return new (0, $fyrAH.MarketplaceFeatureFlagsClient)(featureFlagsClient, user);
}

});
parcelRegister("gx5NS", function(module, exports) {

$parcel$export(module.exports, "default", () => $259d4c3c97821b0a$export$2e2bcd8739ae039);

var $gfc7y = parcelRequire("gfc7y");
class $259d4c3c97821b0a$export$2e2bcd8739ae039 {
    constructor(apiKey, analyticsWebClient, featureFlagUser, options){
        this.client = new (0, $gfc7y.default)(apiKey, analyticsWebClient, featureFlagUser, options);
    }
    ready() {
        return this.client.ready();
    }
    setAutomaticExposuresEnabled(enabled, predicate) {
        this.client.setAutomaticExposuresEnabled(enabled, predicate);
    }
    getFlagValue(flagKey, defaultValue, options) {
        return this.client.getFlagValue(flagKey, defaultValue, options);
    }
    getFlagDetails(flagKey, defaultValue, options) {
        return this.client.getFlagDetails(flagKey, defaultValue, options);
    }
    getFlags() {
        return this.client.getFlags();
    }
    on(flagKey, defaultValue, callback, options) {
        return this.client.on(flagKey, defaultValue, callback, options);
    }
    onAnyFlagUpdated(callback) {
        return this.client.onAnyFlagUpdated(callback);
    }
    updateFeatureFlagUser(featureFlagUser) {
        return this.client.updateFeatureFlagUser(featureFlagUser);
    }
    destroy() {
        this.client.destroy();
    }
}

});
parcelRegister("gfc7y", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c9428473a2e1ddb$export$2e2bcd8739ae039);

var $cGs0N = parcelRequire("cGs0N");

var $9HvFc = parcelRequire("9HvFc");

var $4skSt = parcelRequire("4skSt");

var $1wbko = parcelRequire("1wbko");

var $2HNok = parcelRequire("2HNok");

var $kV2rl = parcelRequire("kV2rl");
var $hbidh = parcelRequire("hbidh");

var $Z4Hnw = parcelRequire("Z4Hnw");

var $1wJk7 = parcelRequire("1wJk7");

var $avqau = parcelRequire("avqau");

var $br2PD = parcelRequire("br2PD");

var $0QdvS = parcelRequire("0QdvS");
const $2c9428473a2e1ddb$export$eb7ed84def39a430 = 10000;
class $2c9428473a2e1ddb$export$2e2bcd8739ae039 {
    constructor(apiKey, analyticsWebClient, originalFeatureFlagUser, options){
        // Should be done ASAP to prevent calls to console before usage
        (0, $1wbko.default)(options?.loggerOptions);
        (0, $0QdvS.validateConstructorArgs)(apiKey, analyticsWebClient, originalFeatureFlagUser, options);
        const featureFlagUser = (0, $Z4Hnw.default)(originalFeatureFlagUser);
        const user = (0, $1wJk7.default).processAnonymousUser(featureFlagUser);
        this.featureFlagUpdateBroadcastHandler = this.featureFlagUpdateBroadcastHandler.bind(this);
        this.featureFlagUpdateHttpHandler = this.featureFlagUpdateHttpHandler.bind(this);
        this.featureFlagUpdateFailedHandler = this.featureFlagUpdateFailedHandler.bind(this);
        this.readyResolver = new (0, $avqau.default)({
            readyTimeoutInMilliseconds: options.readyTimeoutInMilliseconds
        });
        this.exposureEvents = new (0, $4skSt.default)(analyticsWebClient);
        this.storage = new (0, $2HNok.default)(options.environment, options.productKey, apiKey, user);
        this.broadcast = new (0, $kV2rl.default)(apiKey, user, this.featureFlagUpdateBroadcastHandler);
        this.restoreFlagStateFromStorage();
        this.userData = user;
        this.refresh = new (0, $br2PD.default)(apiKey, options.environment, this.userData, this.featureFlagUpdateHttpHandler, {
            interval: options.pollingInterval
        }, this.dataVersion, this.lastUpdatedTimestamp, this.featureFlagUpdateFailedHandler, {}, options.useGatewayURL, options.perimeter);
        this.refresh.start();
        this.subscriptions = new (0, $hbidh.default)();
        // Dont run on startup to prevent slowdown
        setTimeout(()=>this.storage.purgeStaleFlagState(), $2c9428473a2e1ddb$export$eb7ed84def39a430);
    }
    ready() {
        return this.readyResolver.getPromise();
    }
    getFlagValue(flagKey, defaultValue, options) {
        const validatedFlag = this.getFlagDetails(flagKey, defaultValue, options);
        return validatedFlag.value;
    }
    getFlagDetails(flagKey, defaultValue, options) {
        (0, $0QdvS.validateDefaultValue)(defaultValue);
        const flag = this.flags[flagKey];
        const validatedFlag = (0, $0QdvS.validateFlag)(flag, defaultValue, this.refresh.getStatus(), options);
        const shouldSendExposureEvent = options?.shouldSendExposureEvent !== false && !this.shouldIgnoreExposureForMissingFlag(flagKey, validatedFlag);
        if (shouldSendExposureEvent) {
            // If the shouldSendExposureEvent is not defined at all, we may fire an automatic event.
            const isExplicitlyRequested = options?.shouldSendExposureEvent === true;
            this.exposureEvents.sendExposureEvent(flagKey, validatedFlag, isExplicitlyRequested, options?.exposureData);
        }
        return validatedFlag;
    }
    // Skip sending automatic exposure for platform flags as they are often released to a single product,
    // and registering them for all products that consume platform components is costly.
    shouldIgnoreExposureForMissingFlag(flagKey, validatedFlag) {
        if (validatedFlag.evaluationDetail?.errorKind !== (0, $9HvFc.EvaluationErrorKind).FLAG_NOT_FOUND) return false;
        if (!flagKey.startsWith('platform.')) return false;
        return true;
    }
    getFlags() {
        return (0, $Z4Hnw.default)(this.flags);
    }
    on(flagKey, defaultValue, callback, options) {
        (0, $0QdvS.validateDefaultValue)(defaultValue);
        return this.subscriptions.on(flagKey, defaultValue, callback, this.getFlagValue.bind(this), options);
    }
    onAnyFlagUpdated(callback) {
        return this.subscriptions.onAnyFlagUpdated(callback);
    }
    updateFeatureFlagUser(originalFeatureFlagUser) {
        if (!originalFeatureFlagUser) throw new Error('featureFlagUser is missing');
        const featureFlagUser = (0, $Z4Hnw.default)(originalFeatureFlagUser);
        const user = (0, $1wJk7.default).processAnonymousUser(featureFlagUser);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(this.userData) === (0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(user)) return this.ready();
        this.readyResolver.reset();
        this.userData = user;
        this.storage.updateUserContext(user);
        const storedData = this.storage.getFlagsState();
        if (storedData) {
            const changedFlagKeys = this.updateInMemoryFlags((0, $0QdvS.flagStateToFlagUpdate)(this.flags, storedData));
            this.sendSubscriptionUpdates(changedFlagKeys);
            this.readyResolver.triggerReady((0, $avqau.READY_CACHE));
        }
        this.lastUpdatedTimestamp = storedData?.timestamp || 0;
        this.dataVersion = storedData?.version;
        this.refresh.stop();
        this.refresh.updateUserContext(user, this.dataVersion, this.lastUpdatedTimestamp);
        this.refresh.start();
        this.broadcast.updateUserContext(user);
        return this.ready();
    }
    addFlag(flagKey, flag) {
        this.flags[flagKey] = flag;
    }
    // Convenience API, not official
    destroy() {
        this.refresh.stop();
        this.subscriptions.stop();
        this.broadcast.stop();
        this.readyResolver.triggerReady({
            reason: (0, $9HvFc.ReadyReason).CLIENT_ERROR,
            message: 'Client got destroyed.'
        });
    }
    setAutomaticExposuresEnabled(enabled, predicate) {
        this.exposureEvents.setAutomaticExposuresEnabled(enabled, predicate);
    }
    restoreFlagStateFromStorage() {
        const storedData = this.storage.getFlagsState();
        this.flags = storedData?.flags || {};
        this.lastUpdatedTimestamp = storedData?.timestamp || 0;
        this.dataVersion = storedData?.version;
        if (storedData !== null && storedData !== undefined) this.readyResolver.triggerReady((0, $avqau.READY_CACHE));
        else {
            // Attempt to recover old flags
            const oldFlagState = this.storage.getFlagsFromOldState();
            if (oldFlagState) {
                // Do not update lastUpdatedTimestamp or dataVersion
                // to force refresh to run immediately without the cache
                this.flags = oldFlagState.flags;
                this.readyResolver.triggerReady((0, $avqau.READY_CACHE));
            }
        }
    }
    getCurrentFeatureFlagState() {
        return {
            timestamp: this.lastUpdatedTimestamp,
            version: this.dataVersion,
            flags: this.flags
        };
    }
    featureFlagUpdateFailedHandler(statusCode, rawBody) {
        this.readyResolver.triggerReady({
            reason: (0, $0QdvS.getReasonForStatusCode)(statusCode),
            message: (0, $0QdvS.getReadyMessageForStatusCode)(statusCode),
            serverResponse: rawBody
        });
    }
    featureFlagUpdateHttpHandler(update) {
        if (this.dataVersion) this.processFeatureFlagUpdate(update);
        else // If dataVersion is undefined, then the request had no versionData.
        // This would mean that the API cannot tell us what flags to delete,
        // and has just given us every flag available at its latest state.
        // We should replace all flags instead of merging the flags.
        this.processFeatureFlagUpdate((0, $0QdvS.flagStateToFlagUpdate)(this.flags, update));
        // broadcast the flag state to other tabs
        this.broadcast.sendFeatureFlagState(this.getCurrentFeatureFlagState());
    }
    featureFlagUpdateBroadcastHandler(featureFlagState) {
        // return if broadcasted ff state is stale
        if (featureFlagState.timestamp < this.lastUpdatedTimestamp) return;
        this.processFeatureFlagUpdate((0, $0QdvS.flagStateToFlagUpdate)(this.flags, featureFlagState));
    }
    processFeatureFlagUpdate(update) {
        this.lastUpdatedTimestamp = Date.now();
        this.dataVersion = update.versionData || this.dataVersion;
        const changedFlagKeys = this.updateInMemoryFlags(update);
        this.sendSubscriptionUpdates(changedFlagKeys);
        this.refresh.setVersionAndTimestamp(this.dataVersion, this.lastUpdatedTimestamp);
        this.storage.setFlagsState(this.getCurrentFeatureFlagState());
        this.readyResolver.triggerReady((0, $avqau.READY_FETCH));
    }
    updateInMemoryFlags(update) {
        const changedFlags = [];
        update.deletedFlags?.forEach((flagKey)=>{
            if (flagKey in this.flags) {
                delete this.flags[flagKey];
                changedFlags.push(flagKey);
            }
        });
        Object.keys(update.flags).forEach((flagKey)=>{
            if ((0, $0QdvS.hasFlagValueChanged)(this.flags[flagKey], update.flags[flagKey])) changedFlags.push(flagKey);
            this.flags[flagKey] = update.flags[flagKey];
        });
        return changedFlags;
    }
    sendSubscriptionUpdates(changedFlagKeys) {
        if (changedFlagKeys.length > 0) {
            this.subscriptions.anyFlagUpdated();
            changedFlagKeys.forEach((flagKey)=>this.subscriptions.flagValueUpdated(flagKey));
        }
    }
}

});
parcelRegister("4skSt", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e2b2479fb3cb9ea$export$2e2bcd8739ae039);

var $9HvFc = parcelRequire("9HvFc");

var $jA7Xl = parcelRequire("jA7Xl");
const $2e2b2479fb3cb9ea$export$82541edf19e5e3b0 = 3600000;
class $2e2b2479fb3cb9ea$export$2e2bcd8739ae039 {
    constructor(analyticsWebClient){
        this.spamBuster = {};
        this.automaticExposuresEnabled = false;
        this.automaticExposuresPredicate = ()=>true;
        this.analyticsWebClient = analyticsWebClient;
    }
    sendExposureEvent(flagKey, validatedFlag, isExplicitlyRequested, exposureData) {
        const { evaluationDetail: evaluationDetail, trackingInfo: trackingInfo = {
            samplingRate: 0
        } } = validatedFlag;
        // Only attach custom exposure data to opt-in exposure events.
        // This is done because the compression and storage for automatic exposure events do not currently
        // support custom attributes. By intentionally excluding them, we ensure that we are not collecting
        // data that will eventually be dropped further in the pipeline.
        // See https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1316354396/RFC-002+Automatic+exposure+event+collection+in+the+Fx3+web+client for more information.
        const customAttributes = isExplicitlyRequested ? exposureData : {};
        const hasCustomAttributes = customAttributes ? Object.keys(customAttributes).length > 0 : false;
        const exposureAttributes = {
            flagKey: flagKey,
            value: validatedFlag.value,
            reason: evaluationDetail?.reason,
            ruleId: evaluationDetail?.ruleId,
            errorKind: evaluationDetail?.errorKind
        };
        const allAttributes = {
            ...customAttributes,
            ...exposureAttributes
        };
        const shouldSendExposureEvent = this.shouldSendExposureEvent(allAttributes, trackingInfo, isExplicitlyRequested);
        if (shouldSendExposureEvent) {
            const actionSubject = 'feature';
            const action = 'exposed';
            const source = '@atlassiansox/feature-flag-web-client';
            const highPriority = isExplicitlyRequested;
            this.analyticsWebClient.sendOperationalEvent({
                actionSubject: actionSubject,
                action: action,
                attributes: exposureAttributes,
                tags: [
                    'measurement',
                    isExplicitlyRequested ? (0, $9HvFc.ExposureType).OptIn : (0, $9HvFc.ExposureType).Automatic
                ],
                source: source,
                highPriority: highPriority
            });
            // Due to the way we've simplified our pipeline, custom attributes are dropped from exposure
            // events. In order not to break existing users of this feature immediately, we're sending an
            // extra event that won't be consumed by our pipeline, but will end up in the `cloud.*` tables.
            // See: https://hello.atlassian.net/wiki/spaces/MEASURE/pages/1838596497/AtlasKit+TAC
            if (hasCustomAttributes) this.analyticsWebClient.sendOperationalEvent({
                actionSubject: actionSubject,
                action: action,
                attributes: allAttributes,
                tags: [
                    'measurement',
                    (0, $9HvFc.ExposureType).OptIn,
                    (0, $9HvFc.ExposureType).HasCustomAttributes
                ],
                source: source,
                highPriority: highPriority
            });
            this.markExposureAsTracked(exposureAttributes);
        }
    }
    shouldSendExposureEvent(exposureAttributes, trackingInfo, isExplicitlyRequested) {
        if (this.hasAlreadyTrackedExposure(exposureAttributes)) return false;
        if (isExplicitlyRequested) return true;
        const samplingRate = trackingInfo.samplingRate;
        const shouldSendAutomaticEvent = this.automaticExposuresEnabled && samplingRate === 1 && this.automaticExposuresPredicate(exposureAttributes);
        return shouldSendAutomaticEvent;
    }
    hasAlreadyTrackedExposure(attributes) {
        const encode = (0, $jA7Xl.encodeObject)(attributes);
        if (this.spamBuster[encode] === undefined || this.spamBuster[encode] + $2e2b2479fb3cb9ea$export$82541edf19e5e3b0 < Date.now()) return false;
        return true;
    }
    markExposureAsTracked(attributes) {
        const encode = (0, $jA7Xl.encodeObject)(attributes);
        this.spamBuster[encode] = Date.now();
    }
    setAutomaticExposuresEnabled(enabled, predicate = ()=>true) {
        this.automaticExposuresEnabled = enabled;
        this.automaticExposuresPredicate = predicate;
    }
}

});
parcelRegister("jA7Xl", function(module, exports) {

$parcel$export(module.exports, "encodeObject", () => $be0230424b570eb9$export$c57605e441fcb142);

var $cGs0N = parcelRequire("cGs0N");
function $be0230424b570eb9$export$c57605e441fcb142(obj) {
    return btoa((0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(obj));
}

});


parcelRegister("1wbko", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5e4f7cc0e5d7310$export$2e2bcd8739ae039);

var $hMIZG = parcelRequire("hMIZG");
let $c5e4f7cc0e5d7310$var$logger;
var $c5e4f7cc0e5d7310$export$2e2bcd8739ae039 = (options)=>{
    if (!$c5e4f7cc0e5d7310$var$logger) $c5e4f7cc0e5d7310$var$logger = new (0, $hMIZG.default)(options);
    return $c5e4f7cc0e5d7310$var$logger;
};

});
parcelRegister("hMIZG", function(module, exports) {

$parcel$export(module.exports, "default", () => $04f0968ea014fd27$export$2e2bcd8739ae039);

var $42bRZ = parcelRequire("42bRZ");

var $9HvFc = parcelRequire("9HvFc");
const $04f0968ea014fd27$var$getDefaultLogLevel = ()=>(0, $9HvFc.LogLevel).INFO;
const $04f0968ea014fd27$export$7b4b69781b3b411 = `@atlassiansox/feature-flag-web-client@${(0, $42bRZ.version)} -`;
class $04f0968ea014fd27$export$2e2bcd8739ae039 {
    constructor(options = {}){
        this.isEnabled = options.enabled !== undefined ? options.enabled : true;
        this.logger = options.logger || console;
        this.logLevel = options.level || $04f0968ea014fd27$var$getDefaultLogLevel();
    }
    debug(...data) {
        if (this.shouldLog((0, $9HvFc.LogLevel).DEBUG)) this.logger.debug($04f0968ea014fd27$export$7b4b69781b3b411, ...data);
    }
    info(...data) {
        if (this.shouldLog((0, $9HvFc.LogLevel).INFO)) this.logger.info($04f0968ea014fd27$export$7b4b69781b3b411, ...data);
    }
    log(...data) {
        if (this.shouldLog((0, $9HvFc.LogLevel).LOG)) this.logger.log($04f0968ea014fd27$export$7b4b69781b3b411, ...data);
    }
    warn(...data) {
        if (this.shouldLog((0, $9HvFc.LogLevel).WARN)) this.logger.warn($04f0968ea014fd27$export$7b4b69781b3b411, ...data);
    }
    error(...data) {
        if (this.shouldLog((0, $9HvFc.LogLevel).ERROR)) this.logger.error($04f0968ea014fd27$export$7b4b69781b3b411, ...data);
    }
    shouldLog(checkLevel) {
        return this.isEnabled && checkLevel >= this.logLevel;
    }
}

});
parcelRegister("42bRZ", function(module, exports) {

$parcel$export(module.exports, "version", () => $2d59871b6320ea51$export$83d89fbfd8236492);
/// <reference types="node" />
const $2d59871b6320ea51$export$83d89fbfd8236492 = "0.0.0-use.local";

});



parcelRegister("2HNok", function(module, exports) {

$parcel$export(module.exports, "default", () => $5efc5d6442bc67e4$export$2e2bcd8739ae039);

var $9uax1 = parcelRequire("9uax1");

var $ixyl1 = parcelRequire("ixyl1");

var $jA7Xl = parcelRequire("jA7Xl");

var $gyXzn = parcelRequire("gyXzn");
const $5efc5d6442bc67e4$export$9959634951c336e9 = `feature-flags-atl`;
const $5efc5d6442bc67e4$var$VERSIONED_STORAGE_KEY_PREFIX = `${$5efc5d6442bc67e4$export$9959634951c336e9}.${(0, $9uax1.CURRENT_FFS_API_VERSION)}`;
const $5efc5d6442bc67e4$var$STORAGE_KEY_FLAG_STATE_PREFIX = `${$5efc5d6442bc67e4$var$VERSIONED_STORAGE_KEY_PREFIX}.flags`;
const $5efc5d6442bc67e4$var$STORAGE_KEY_USER_LAST_KEY_PREFIX = `${$5efc5d6442bc67e4$var$VERSIONED_STORAGE_KEY_PREFIX}.last-user`;
const $5efc5d6442bc67e4$var$STORAGE_KEY_ANON_ID = `${$5efc5d6442bc67e4$export$9959634951c336e9}.anonId`;
const $5efc5d6442bc67e4$var$STORAGE_KEY_DETECT_SUPPORT = `${$5efc5d6442bc67e4$export$9959634951c336e9}.storage.support`;
let $5efc5d6442bc67e4$var$StorageExceedQuota = false;
const $5efc5d6442bc67e4$export$c0ed3e38b50302b2 = 604800000;
class $5efc5d6442bc67e4$export$2e2bcd8739ae039 {
    constructor(env, product, apiKey, user){
        this.env = env;
        this.product = product;
        this.apiKey = apiKey;
        this.user = user;
        this.key = this.getKey();
        this.lastUserUpdateKey = this.getLastUpdatedKey();
    }
    updateUserContext(user) {
        this.user = user;
        this.key = this.getKey();
        this.lastUserUpdateKey = this.getLastUpdatedKey();
    }
    getFlagsState() {
        return this.getObjectFromLocalstorage(this.key);
    }
    getFlagsFromOldState() {
        const oldKey = this.getObjectFromLocalstorage(this.lastUserUpdateKey);
        if (oldKey) return this.getObjectFromLocalstorage(oldKey.value);
        return null;
    }
    setFlagsState(data) {
        $5efc5d6442bc67e4$export$2e2bcd8739ae039.setItem(this.key, JSON.stringify(data), ()=>this.setLastUpdatedPrimaryKey());
    }
    purgeStaleFlagState() {
        try {
            Object.keys(window.localStorage).filter((key)=>key.startsWith($5efc5d6442bc67e4$export$9959634951c336e9) && key !== this.key && key !== this.lastUserUpdateKey && key !== $5efc5d6442bc67e4$var$STORAGE_KEY_ANON_ID).forEach((key)=>{
                const value = this.getObjectFromLocalstorage(key);
                if (value && Date.now() - value.timestamp >= $5efc5d6442bc67e4$export$c0ed3e38b50302b2) $5efc5d6442bc67e4$export$2e2bcd8739ae039.removeItem(key);
            });
        } catch (error) {
        // This could fail due to localstorage permissions being restricted, in this case do nothing
        }
    }
    getObjectFromLocalstorage(key) {
        const rawData = $5efc5d6442bc67e4$export$2e2bcd8739ae039.getItem(key);
        if (!rawData) return null;
        try {
            return JSON.parse(rawData);
        } catch (error) {
            return null;
        }
    }
    static getAnonymousId() {
        return $5efc5d6442bc67e4$export$2e2bcd8739ae039.getItem($5efc5d6442bc67e4$var$STORAGE_KEY_ANON_ID);
    }
    static setAnonymousId(anonymousId) {
        $5efc5d6442bc67e4$export$2e2bcd8739ae039.setItem($5efc5d6442bc67e4$var$STORAGE_KEY_ANON_ID, anonymousId);
    }
    static setItem(key, value, callbackIfSuccessful) {
        try {
            window.localStorage.setItem(key, value);
            $5efc5d6442bc67e4$var$StorageExceedQuota = false;
            callbackIfSuccessful && callbackIfSuccessful();
        } catch (error) {
            if ($5efc5d6442bc67e4$export$2e2bcd8739ae039.isQuotaExceeded(error)) $5efc5d6442bc67e4$var$StorageExceedQuota = true;
        // This could fail due to localstorage being full or localstorage permissions being restricted.
        // In either case, we do nothing.
        }
    }
    static getItem(key) {
        try {
            return window.localStorage.getItem(key);
        } catch (error) {
            // This could fail due to localstorage permissions being restricted, in this case do nothing
            return null;
        }
    }
    static removeItem(key) {
        try {
            window.localStorage.removeItem(key);
        } catch (error) {
        // This could fail due to localstorage permissions being restricted, in this case do nothing
        }
    }
    setLastUpdatedPrimaryKey() {
        const value = {
            value: this.key,
            timestamp: Date.now()
        };
        $5efc5d6442bc67e4$export$2e2bcd8739ae039.setItem(this.lastUserUpdateKey, JSON.stringify(value));
    }
    getLastUpdatedKey() {
        const partialUser = {
            identifier: this.user.identifier
        };
        return `${$5efc5d6442bc67e4$var$STORAGE_KEY_USER_LAST_KEY_PREFIX}.${this.env}.${this.product}.${(0, $jA7Xl.encodeObject)(partialUser)}`;
    }
    getKey() {
        return `${$5efc5d6442bc67e4$var$STORAGE_KEY_FLAG_STATE_PREFIX}.${this.env}.${this.product}.${this.apiKey}.${(0, $jA7Xl.encodeObject)(this.user)}`;
    }
    static isQuotaExceeded(e) {
        // according to https://developer.mozilla.org/en-US/docs/Web/API/DOMException
        // DOMException.code is deprecated API should no longer be used
        if (e instanceof DOMException) switch(e.name){
            case 'QUOTA_EXCEEDED_ERR':
                // Safari
                return true;
            case 'QuotaExceededError':
                // Chrome
                return true;
            case 'NS_ERROR_DOM_QUOTA_REACHED':
                // Firefox
                return true;
            default:
                return false;
        }
        // Internet Explorer 8
        if (e instanceof (0, $gyXzn.IE8Exception)) return e.number === -2147024882;
        return false;
    }
    static getStorageStatus() {
        const TEST_VALUE = 'test_value';
        try {
            if (!window.localStorage) return (0, $ixyl1.ClientStorageState).NOT_AVAILABLE;
            if ($5efc5d6442bc67e4$var$StorageExceedQuota) return (0, $ixyl1.ClientStorageState).FULL;
            window.localStorage.setItem($5efc5d6442bc67e4$var$STORAGE_KEY_DETECT_SUPPORT, TEST_VALUE);
            const value = window.localStorage.getItem($5efc5d6442bc67e4$var$STORAGE_KEY_DETECT_SUPPORT);
            window.localStorage.removeItem($5efc5d6442bc67e4$var$STORAGE_KEY_DETECT_SUPPORT);
            // handle localStorage silently failing
            return value === TEST_VALUE ? (0, $ixyl1.ClientStorageState).AVAILABLE : (0, $ixyl1.ClientStorageState).ERRORED;
        } catch (e) {
            if ($5efc5d6442bc67e4$export$2e2bcd8739ae039.isQuotaExceeded(e)) return (0, $ixyl1.ClientStorageState).FULL;
            // permission issue or localStorage disabled
            return (0, $ixyl1.ClientStorageState).NOT_AVAILABLE;
        }
    }
}

});
parcelRegister("9uax1", function(module, exports) {

$parcel$export(module.exports, "CURRENT_FFS_API_VERSION", () => $094e8501da5d1e83$export$17f647755de6efe5);

var $5fUyP = parcelRequire("5fUyP");
const $094e8501da5d1e83$export$17f647755de6efe5 = (0, $5fUyP.FeatureFlagServiceApiVersion).V2;

});
parcelRegister("5fUyP", function(module, exports) {

$parcel$export(module.exports, "RefreshStatus", () => $015c553978815808$export$b16e70dacd3d8ec1);
$parcel$export(module.exports, "FeatureFlagServiceApiVersion", () => $015c553978815808$export$af3cbe85f963d434);
var $015c553978815808$export$b16e70dacd3d8ec1;
(function(RefreshStatus) {
    RefreshStatus["INITIALISED"] = "INITIALISED";
    RefreshStatus["SUCCESS"] = "SUCCESS";
    RefreshStatus["ERROR"] = "ERROR";
})($015c553978815808$export$b16e70dacd3d8ec1 || ($015c553978815808$export$b16e70dacd3d8ec1 = {}));
var $015c553978815808$export$af3cbe85f963d434;
(function(FeatureFlagServiceApiVersion) {
    FeatureFlagServiceApiVersion["V1"] = "v1";
    FeatureFlagServiceApiVersion["V2"] = "v2";
})($015c553978815808$export$af3cbe85f963d434 || ($015c553978815808$export$af3cbe85f963d434 = {}));

});


parcelRegister("ixyl1", function(module, exports) {

$parcel$export(module.exports, "ClientCauseReason", () => $7b5ea8a6f379a84b$export$5fecd71898488841);
$parcel$export(module.exports, "ClientStorageState", () => $7b5ea8a6f379a84b$export$4689f45dd8b7804a);
$parcel$export(module.exports, "ClientUserState", () => $7b5ea8a6f379a84b$export$ac0a0bad9c4cb9be);
var $7b5ea8a6f379a84b$export$df576fce7d800dd2;
(function(ClientVisibilityState) {
    ClientVisibilityState["VISIBLE"] = "visible";
    ClientVisibilityState["HIDDEN"] = "hidden";
    ClientVisibilityState["PRERENDER"] = "prerender";
})($7b5ea8a6f379a84b$export$df576fce7d800dd2 || ($7b5ea8a6f379a84b$export$df576fce7d800dd2 = {}));
var $7b5ea8a6f379a84b$export$5fecd71898488841;
(function(ClientCauseReason) {
    ClientCauseReason["INITIALIZATION"] = "initialization";
    ClientCauseReason["POLLING"] = "polling";
    ClientCauseReason["RETRY"] = "retry";
})($7b5ea8a6f379a84b$export$5fecd71898488841 || ($7b5ea8a6f379a84b$export$5fecd71898488841 = {}));
var $7b5ea8a6f379a84b$export$4689f45dd8b7804a;
(function(ClientStorageState) {
    ClientStorageState["AVAILABLE"] = "available";
    ClientStorageState["NOT_AVAILABLE"] = "notAvailable";
    ClientStorageState["FULL"] = "full";
    ClientStorageState["ERRORED"] = "errored";
})($7b5ea8a6f379a84b$export$4689f45dd8b7804a || ($7b5ea8a6f379a84b$export$4689f45dd8b7804a = {}));
var $7b5ea8a6f379a84b$export$ac0a0bad9c4cb9be;
(function(ClientUserState) {
    ClientUserState["NEW"] = "new";
    ClientUserState["SAME"] = "same";
    ClientUserState["SWITCHED"] = "switched";
})($7b5ea8a6f379a84b$export$ac0a0bad9c4cb9be || ($7b5ea8a6f379a84b$export$ac0a0bad9c4cb9be = {}));

});

parcelRegister("gyXzn", function(module, exports) {

$parcel$export(module.exports, "IE8Exception", () => $117d9a64386616c7$export$bde183916164b024);
class $117d9a64386616c7$export$bde183916164b024 extends Error {
    constructor(...args){
        super(...args);
        this.number = 0;
    }
}

});


parcelRegister("kV2rl", function(module, exports) {

$parcel$export(module.exports, "default", () => $df71fdf5045a7422$export$2e2bcd8739ae039);

var $9uax1 = parcelRequire("9uax1");

var $jA7Xl = parcelRequire("jA7Xl");
const $df71fdf5045a7422$export$dce59ee845588a78 = 'flagData';
class $df71fdf5045a7422$export$2e2bcd8739ae039 {
    constructor(apiKey, user, stateUpdateCallback){
        this.apiKey = apiKey;
        this.stateUpdateCallback = stateUpdateCallback;
        this.setupChannel(user);
    }
    updateUserContext(user) {
        this.stop();
        this.setupChannel(user);
    }
    sendFeatureFlagState(featureFlagState) {
        this.channel?.postMessage(featureFlagState);
    }
    stop() {
        this.channel?.close();
    }
    setupChannel(user) {
        try {
            // Keep reference to old channel so we can check the name of the current subscription
            // is the same as the channel we received a message for.
            // Due to a bug in Firefox which events can be recieved after
            // the channel has been closed.
            // eslint-disable-next-line compat/compat
            const channel = new BroadcastChannel(this.createChannelName(user));
            channel.onmessage = (e)=>{
                if (channel.name === this.channel?.name) this.stateUpdateCallback(e.data);
            };
            this.channel = channel;
        } catch (error) {
        // This could fail due to BroadcastChannel not available.
        // In that case, we do nothing.
        }
    }
    createChannelName(user) {
        return `${$df71fdf5045a7422$export$dce59ee845588a78}.${0, $9uax1.CURRENT_FFS_API_VERSION}.${this.apiKey}.${(0, $jA7Xl.encodeObject)(user)}`;
    }
}

});

parcelRegister("hbidh", function(module, exports) {

$parcel$export(module.exports, "default", () => $d37e4553635f1b47$export$2e2bcd8739ae039);

var $b0be6 = parcelRequire("b0be6");
const $d37e4553635f1b47$export$c7a884b40e38e22 = 'flagKey.';
const $d37e4553635f1b47$export$a6fc48f32d426837 = 'allFlags';
class $d37e4553635f1b47$export$2e2bcd8739ae039 {
    constructor(){
        this.emitter = (0, $b0be6.default)();
    }
    on(flagKey, defaultValue, callback, getFlagValue, options) {
        const wrapCallback = ()=>callback(getFlagValue(flagKey, defaultValue, options));
        this.emitter.on($d37e4553635f1b47$export$c7a884b40e38e22 + flagKey, wrapCallback);
        return ()=>this.emitter.off($d37e4553635f1b47$export$c7a884b40e38e22 + flagKey, wrapCallback);
    }
    onAnyFlagUpdated(callback) {
        this.emitter.on($d37e4553635f1b47$export$a6fc48f32d426837, callback);
        return ()=>this.emitter.off($d37e4553635f1b47$export$a6fc48f32d426837, callback);
    }
    anyFlagUpdated() {
        this.emitter.emit($d37e4553635f1b47$export$a6fc48f32d426837);
    }
    flagValueUpdated(flagKey) {
        this.emitter.emit($d37e4553635f1b47$export$c7a884b40e38e22 + flagKey);
    }
    stop() {
        // There is no way to clear the emitter so instead we're creating a new one
        this.emitter = (0, $b0be6.default)();
    }
}

});
parcelRegister("b0be6", function(module, exports) {

$parcel$export(module.exports, "default", () => $8028671e31c24f37$export$2e2bcd8739ae039);
function $8028671e31c24f37$export$2e2bcd8739ae039(n) {
    return {
        all: n = n || new Map,
        on: function(t, e) {
            var i = n.get(t);
            i && i.push(e) || n.set(t, [
                e
            ]);
        },
        off: function(t, e) {
            var i = n.get(t);
            i && i.splice(i.indexOf(e) >>> 0, 1);
        },
        emit: function(t, e) {
            (n.get(t) || []).slice().map(function(n) {
                n(e);
            }), (n.get("*") || []).slice().map(function(n) {
                n(t, e);
            });
        }
    };
}

});


parcelRegister("Z4Hnw", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf7f68428425e86$export$2e2bcd8739ae039);
function $1bf7f68428425e86$export$2e2bcd8739ae039(obj) {
    const str = JSON.stringify(obj);
    return JSON.parse(str);
}

});

parcelRegister("1wJk7", function(module, exports) {

$parcel$export(module.exports, "default", () => $f9056f2326e17044$export$2e2bcd8739ae039);

var $9HvFc = parcelRequire("9HvFc");

var $2HNok = parcelRequire("2HNok");

var $0QdvS = parcelRequire("0QdvS");
class $f9056f2326e17044$export$2e2bcd8739ae039 {
    static processAnonymousUser(featureFlagUser) {
        let { identifier: identifier } = featureFlagUser;
        if (identifier) return {
            ...featureFlagUser,
            identifier: identifier
        };
        identifier = {
            type: (0, $9HvFc.Identifiers).FF_CLIENT_ANONYMOUS_ID,
            value: $f9056f2326e17044$export$2e2bcd8739ae039.generateAnonymousId()
        };
        return {
            ...featureFlagUser,
            isAnonymous: true,
            identifier: identifier
        };
    }
    static generateAnonymousId() {
        const storedAnonymousId = (0, $2HNok.default).getAnonymousId();
        if (storedAnonymousId) return storedAnonymousId;
        const anonymousId = (0, $0QdvS.uuidv4)();
        (0, $2HNok.default).setAnonymousId(anonymousId);
        return anonymousId;
    }
}

});
parcelRegister("0QdvS", function(module, exports) {

$parcel$export(module.exports, "flagResponseToFlagUpdate", () => $6756dca9ec843711$export$dc45e8a94b492900);
$parcel$export(module.exports, "flagStateToFlagUpdate", () => $6756dca9ec843711$export$bc46a39c6aaa1a9f);
$parcel$export(module.exports, "hasFlagValueChanged", () => $6756dca9ec843711$export$9a91a5f34fa368e3);
$parcel$export(module.exports, "validateFlag", () => $6756dca9ec843711$export$d1b582ce55c8d054);
$parcel$export(module.exports, "validateConstructorArgs", () => $6756dca9ec843711$export$722f04998ab00d3e);
$parcel$export(module.exports, "validateDefaultValue", () => $6756dca9ec843711$export$7e12dedaaa5cae0c);
$parcel$export(module.exports, "uuidv4", () => $6756dca9ec843711$export$abe4376e1bf796d6);
$parcel$export(module.exports, "getReadyMessageForStatusCode", () => $6756dca9ec843711$export$3f53053e801279bc);
$parcel$export(module.exports, "getReasonForStatusCode", () => $6756dca9ec843711$export$99195c9b6ce7887);

var $cGs0N = parcelRequire("cGs0N");

var $dFBS3 = parcelRequire("dFBS3");

var $9HvFc = parcelRequire("9HvFc");

var $9HvFc = parcelRequire("9HvFc");

var $1wbko = parcelRequire("1wbko");

var $Z4Hnw = parcelRequire("Z4Hnw");

var $5fUyP = parcelRequire("5fUyP");
function $6756dca9ec843711$export$5216b3b13b0ac716(featureFlag) {
    const rawFlag = {
        value: featureFlag.value,
        trackingInfo: featureFlag.trackingInfo || {
            samplingRate: 0
        }
    };
    if (featureFlag.reason) rawFlag.evaluationDetail = {
        reason: featureFlag.reason,
        ruleId: featureFlag.ruleId
    };
    return rawFlag;
}
function $6756dca9ec843711$export$dc45e8a94b492900(response) {
    const flags = {};
    response.featureFlagValues?.forEach((featureFlag)=>{
        flags[featureFlag.key] = $6756dca9ec843711$export$5216b3b13b0ac716(featureFlag);
    });
    return {
        flags: flags,
        deletedFlags: response.deletedFlags || [],
        versionData: response.versionData
    };
}
function $6756dca9ec843711$export$bc46a39c6aaa1a9f(currentFlags, newFlagState) {
    const newFlags = newFlagState?.flags || {};
    const deletedFlags = Object.keys(currentFlags).filter((flagKey)=>newFlags[flagKey] === undefined);
    const versionData = $6756dca9ec843711$var$getVersionData(newFlagState);
    return {
        flags: newFlags,
        deletedFlags: deletedFlags,
        versionData: versionData
    };
}
const $6756dca9ec843711$var$getVersionData = (flagState)=>{
    if ('version' in flagState) return flagState.version;
    else if ('versionData' in flagState) return flagState.versionData;
    return undefined;
};
function $6756dca9ec843711$export$9a91a5f34fa368e3(oldFlag, newFlag) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(oldFlag?.value) !== (0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(newFlag?.value);
}
function $6756dca9ec843711$export$9ef179a791292774(status) {
    switch(status){
        case (0, $5fUyP.RefreshStatus).INITIALISED:
            return (0, $9HvFc.EvaluationErrorKind).CLIENT_NOT_READY;
        case (0, $5fUyP.RefreshStatus).ERROR:
            return (0, $9HvFc.EvaluationErrorKind).SERVER_ERROR;
        case (0, $5fUyP.RefreshStatus).SUCCESS:
            return (0, $9HvFc.EvaluationErrorKind).FLAG_NOT_FOUND;
        default:
            return (0, $9HvFc.EvaluationErrorKind).OTHER;
    }
}
function $6756dca9ec843711$export$d1b582ce55c8d054(flag, defaultValue, refreshStatus, options) {
    if (!flag) return {
        value: defaultValue,
        evaluationDetail: {
            reason: (0, $9HvFc.EvaluationReason).ERROR,
            errorKind: $6756dca9ec843711$export$9ef179a791292774(refreshStatus)
        }
    };
    if (typeof flag.value !== typeof defaultValue) return {
        value: defaultValue,
        trackingInfo: flag.trackingInfo,
        evaluationDetail: {
            reason: (0, $9HvFc.EvaluationReason).ERROR,
            errorKind: (0, $9HvFc.EvaluationErrorKind).WRONG_TYPE
        }
    };
    if (options?.oneOf?.length && options.oneOf.indexOf(flag.value) < 0) return {
        value: defaultValue,
        trackingInfo: flag.trackingInfo,
        evaluationDetail: {
            reason: (0, $9HvFc.EvaluationReason).ERROR,
            errorKind: (0, $9HvFc.EvaluationErrorKind).VALIDATION_ERROR
        }
    };
    return (0, $Z4Hnw.default)(flag);
}
function $6756dca9ec843711$export$7ee701e290d9865(str) {
    return !str || /^\s*$/.test(str);
}
function $6756dca9ec843711$export$f6e2535fb5126e54(func) {
    return typeof func === 'function';
}
function $6756dca9ec843711$export$722f04998ab00d3e(apiKey, analyticsWebClient, featureFlagUser, options) {
    if ($6756dca9ec843711$export$7ee701e290d9865(apiKey)) throw new Error('apiKey is missing');
    if (!$6756dca9ec843711$export$f6e2535fb5126e54(analyticsWebClient?.sendOperationalEvent)) throw new Error('analyticsWebClient.sendOperationalEvent is missing or not a function');
    if (!featureFlagUser) throw new Error('featureFlagUser is missing');
    if ($6756dca9ec843711$export$7ee701e290d9865(options?.productKey)) throw new Error('options.productKey is missing');
    if (Object.values((0, $9HvFc.EnvironmentType)).indexOf(options?.environment) === -1) throw new Error('options.environment is missing or invalid');
    if (options.pollingInterval !== undefined && options.pollingInterval !== null) {
        const prodMinInterval = 60000;
        const nonProdMinInterval = 1000;
        if (options.pollingInterval <= prodMinInterval) {
            if (options.environment === (0, $9HvFc.EnvironmentType).PROD) {
                // eslint-disable-next-line no-param-reassign
                options.pollingInterval = prodMinInterval;
                (0, $1wbko.default)().log(`options.pollingInterval needs to be greater than ${prodMinInterval}`);
            } else if (options.pollingInterval <= nonProdMinInterval) throw new Error(`options.pollingInterval needs to be greater than ${nonProdMinInterval}`);
            else (0, $1wbko.default)().log(`options.pollingInterval needs to be greater than ${prodMinInterval} in Production`);
        }
    }
}
function $6756dca9ec843711$export$7e12dedaaa5cae0c(value) {
    if (value === undefined || value === null) throw new Error('defaultValue is missing');
}
function $6756dca9ec843711$export$abe4376e1bf796d6() {
    return (0, (/*@__PURE__*/$parcel$interopDefault($dFBS3)))();
}
function $6756dca9ec843711$export$3f53053e801279bc(statusCode) {
    switch(statusCode){
        case 0:
            return 'Request took too long to finish, client aborted the request.';
        case 400:
            return 'Service returned bad request response code. The version data maybe malformed or out of sync with the server.';
        case 401:
            return 'Service returned unauthorized response code. Ensure that the API token is valid for this environment.';
        case 429:
            return 'Service rate limit exceeded.';
        case 500:
        case 502:
        case 503:
        case 504:
            return `Service is unavailable, status code: ${statusCode}`;
        default:
            return `Unsure what went wrong, status code: ${statusCode}`;
    }
}
function $6756dca9ec843711$export$99195c9b6ce7887(statusCode) {
    if (statusCode && statusCode >= 500) return (0, $9HvFc.ReadyReason).SERVER_ERROR;
    return (0, $9HvFc.ReadyReason).CLIENT_ERROR;
}

});


parcelRegister("avqau", function(module, exports) {

$parcel$export(module.exports, "READY_CACHE", () => $988d3256226a3257$export$e9d7d3e7ce9845ce);
$parcel$export(module.exports, "READY_FETCH", () => $988d3256226a3257$export$1adcf19635eea12f);
$parcel$export(module.exports, "default", () => $988d3256226a3257$export$2e2bcd8739ae039);

var $9HvFc = parcelRequire("9HvFc");
const $988d3256226a3257$export$4dcc978f06b5a9ec = 3000;
const $988d3256226a3257$export$afc6624fce981981 = {
    reason: (0, $9HvFc.ReadyReason).CLIENT_ERROR,
    message: 'Client timed out.'
};
const $988d3256226a3257$export$fa405bbf47d510e2 = {
    reason: (0, $9HvFc.ReadyReason).CLIENT_ERROR,
    message: 'Request took too long to finish, client aborted the request.'
};
const $988d3256226a3257$export$e9d7d3e7ce9845ce = {
    reason: (0, $9HvFc.ReadyReason).CACHE
};
const $988d3256226a3257$export$1adcf19635eea12f = {
    reason: (0, $9HvFc.ReadyReason).FETCH
};
class $988d3256226a3257$export$2e2bcd8739ae039 {
    constructor({ readyTimeoutInMilliseconds: readyTimeoutInMilliseconds } = {}){
        this.readyTimeoutInMilliseconds = readyTimeoutInMilliseconds || $988d3256226a3257$export$4dcc978f06b5a9ec;
        this.initialisePromise();
        this.initialiseDefaultPromise(this.readyTimeoutInMilliseconds);
    }
    initialiseDefaultPromise(timeout) {
        this.defaultReadyPromise = new Promise((resolve)=>{
            setTimeout(()=>{
                resolve({
                    reason: (0, $9HvFc.ReadyReason).CLIENT_ERROR,
                    message: 'Client timed out.'
                });
            }, timeout);
        });
    }
    initialisePromise() {
        /*
      A promise can only be resolved by calling the `resolve` function in the constructor callback.
      Since we need resolve the promise by external input, we must save the reference to this resolve function.
      This is safe as the callback function is called synchronously as defined by the ES spec.
    */ this.readyPromise = new Promise((resolve)=>{
            this.resolveReadyPromise = resolve;
        });
    }
    getPromise() {
        return Promise.race([
            this.readyPromise,
            this.defaultReadyPromise
        ]);
    }
    triggerReady(response) {
        if (this.resolveReadyPromise !== undefined) {
            this.resolveReadyPromise(response);
            this.resolveReadyPromise = undefined;
        }
    }
    reset() {
        if (this.resolveReadyPromise === undefined) this.initialisePromise();
        this.initialiseDefaultPromise(this.readyTimeoutInMilliseconds);
    }
}

});

parcelRegister("br2PD", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d35d24db2ae82e4$export$2e2bcd8739ae039);

var $cGs0N = parcelRequire("cGs0N");

var $4hn2t = parcelRequire("4hn2t");

var $bRCHv = parcelRequire("bRCHv");

var $ixyl1 = parcelRequire("ixyl1");

var $1wbko = parcelRequire("1wbko");

var $g2FPo = parcelRequire("g2FPo");

var $5fUyP = parcelRequire("5fUyP");

var $0QdvS = parcelRequire("0QdvS");
const $8d35d24db2ae82e4$export$9f07cc6db84eac61 = {
    minWaitInterval: 300000,
    maxWaitInterval: 1200000,
    backOffFactor: 2,
    backOffJitter: 0.1,
    interval: 300000,
    tabHiddenPollingFactor: 12,
    maxInstantRetryTimes: 0
};
const $8d35d24db2ae82e4$export$2b558311ac69763c = {
    ...$8d35d24db2ae82e4$export$9f07cc6db84eac61,
    minWaitInterval: 500,
    interval: 500,
    maxInstantRetryTimes: 1
};
class $8d35d24db2ae82e4$export$2e2bcd8739ae039 {
    constructor(apiKey, env, user, onFeatureFlagUpdate, pollingConfig, version, lastUpdateTimestamp = 0, onError = ()=>{}, noCachePollingConfig, useGatewayURL = false, perimeter){
        this.failureCount = 0;
        this.logger = (0, $1wbko.default)();
        this.user = user;
        this.onFeatureFlagUpdate = onFeatureFlagUpdate;
        this.version = version;
        this.lastUpdateTimestamp = lastUpdateTimestamp;
        this.pollingConfig = {
            minWaitInterval: pollingConfig?.minWaitInterval || $8d35d24db2ae82e4$export$9f07cc6db84eac61.minWaitInterval,
            maxWaitInterval: pollingConfig?.maxWaitInterval || $8d35d24db2ae82e4$export$9f07cc6db84eac61.maxWaitInterval,
            backOffFactor: pollingConfig?.backOffFactor || $8d35d24db2ae82e4$export$9f07cc6db84eac61.backOffFactor,
            backOffJitter: pollingConfig?.backOffJitter !== undefined ? pollingConfig.backOffJitter : $8d35d24db2ae82e4$export$9f07cc6db84eac61.backOffJitter,
            interval: pollingConfig?.interval || $8d35d24db2ae82e4$export$9f07cc6db84eac61.interval,
            tabHiddenPollingFactor: pollingConfig?.tabHiddenPollingFactor || $8d35d24db2ae82e4$export$9f07cc6db84eac61.tabHiddenPollingFactor,
            maxInstantRetryTimes: 0
        };
        this.noCachePollingConfig = {
            minWaitInterval: noCachePollingConfig?.minWaitInterval || $8d35d24db2ae82e4$export$2b558311ac69763c.minWaitInterval,
            maxWaitInterval: noCachePollingConfig?.maxWaitInterval || $8d35d24db2ae82e4$export$2b558311ac69763c.maxWaitInterval,
            backOffFactor: noCachePollingConfig?.backOffFactor || $8d35d24db2ae82e4$export$2b558311ac69763c.backOffFactor,
            backOffJitter: noCachePollingConfig?.backOffJitter !== undefined ? noCachePollingConfig.backOffJitter : $8d35d24db2ae82e4$export$2b558311ac69763c.backOffJitter,
            interval: noCachePollingConfig?.interval || $8d35d24db2ae82e4$export$2b558311ac69763c.interval,
            tabHiddenPollingFactor: pollingConfig?.tabHiddenPollingFactor || $8d35d24db2ae82e4$export$9f07cc6db84eac61.tabHiddenPollingFactor,
            maxInstantRetryTimes: noCachePollingConfig?.maxInstantRetryTimes !== undefined ? noCachePollingConfig.maxInstantRetryTimes : $8d35d24db2ae82e4$export$2b558311ac69763c.maxInstantRetryTimes
        };
        this.onError = onError;
        this.fetcher = new (0, $4hn2t.default)(apiKey, env, undefined, useGatewayURL, perimeter);
        this.metadataManager = new (0, $g2FPo.default)(this.pollingConfig);
        this.status = (0, $5fUyP.RefreshStatus).INITIALISED;
        this.updateMetadataOnInitialisation();
        this.visibilityChangeHandler = this.visibilityChangeHandler.bind(this);
    }
    // start refresh by fetchAndReschedule
    start() {
        this.stop();
        this.bindVisibilityChange();
        this.fetchAndReschedule();
    }
    // cancel pending schedule
    stop() {
        if (this.timerId) {
            window.clearTimeout(this.timerId);
            this.timerId = undefined;
            this.unbindVisibilityChange();
        }
    }
    // update user, with optional version and timestamp
    updateUserContext(user, version, lastUpdateTimestamp = 0) {
        this.user = user;
        this.version = version;
        this.lastUpdateTimestamp = lastUpdateTimestamp;
        this.failureCount = 0;
        this.updateMetadataOnUserChange();
    }
    // update version and timestamp
    setVersionAndTimestamp(version, lastUpdateTimestamp) {
        this.version = version;
        this.lastUpdateTimestamp = lastUpdateTimestamp;
    }
    getStatus() {
        return this.status;
    }
    visibilityChangeHandler() {
        // cancel existing schedule
        window.clearTimeout(this.timerId);
        this.timerId = undefined;
        // get current tab hidden state (for unsupported browser isTabHidden() will return false), so
        // if isTabHidden true: create a new schedule with a longer interval
        // if isTabHidden false: do a fetchAndReschedule (conditional do a fetch, schedule with normal interval)
        if ($8d35d24db2ae82e4$export$2e2bcd8739ae039.isTabHidden()) this.schedule();
        else this.fetchAndReschedule();
    }
    static isTabHidden() {
        return document.visibilityState === 'hidden';
    }
    // bind tab visibility change callback
    bindVisibilityChange() {
        document.addEventListener('visibilitychange', this.visibilityChangeHandler);
    }
    // unbind tab visibility change callback
    unbindVisibilityChange() {
        document.removeEventListener('visibilitychange', this.visibilityChangeHandler);
    }
    // schedule a fetchAndReschedule
    schedule() {
        this.timerId = window.setTimeout(()=>{
            this.fetchAndReschedule();
        }, this.calculateInterval());
    }
    // conditional fetch ffs via fetcher, and schedule another fetchAndReschedule unless we have 400/401 from ffs
    fetchAndReschedule() {
        const fetchedUser = (0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(this.user);
        if (this.isFetchRequired()) this.fetcher.fetchFeatureFlags(this.user, this.metadataManager.get(), this.version).then((resp)=>{
            if (fetchedUser === (0, (/*@__PURE__*/$parcel$interopDefault($cGs0N)))(this.user)) {
                this.failureCount = 0;
                this.onFeatureFlagUpdate((0, $0QdvS.flagResponseToFlagUpdate)(resp));
                this.schedule();
                this.status = (0, $5fUyP.RefreshStatus).SUCCESS;
            }
            this.updateMetadataOnRequestComplete();
        }).catch((err)=>{
            // 401 means client info or apiKey invalid, will have no retry
            // 400 means version data or request body invalid, will have at most `maxInstantRetryTimes` instant retries
            // other 4xx or 5xx will do `maxInstantRetryTimes` instant retries and continue to do backoff retries
            if (err instanceof (0, $bRCHv.ResponseError) && err.status === 401) {
                // no retry needed
                const message = `Feature flag service returned ${err.status}, "${err.body}". This request will not be retried until the user data has been changed.`;
                this.logger.error(message);
                this.onError(err.status, err.body);
            } else if (err instanceof (0, $bRCHv.ResponseError) && err.status === 400) {
                if (this.version) {
                    // 400 could be caused by corrupted version data, so clear it and schedule a retry
                    this.failureCount += 1;
                    // a user with no cache will retry instantly for maxInstantRetryTimes
                    // onError will be called after all allowed attempts fail
                    if (this.failureCount > this.getPollingConfig().maxInstantRetryTimes) this.onError(err.status, err.body);
                    this.logger.error(`Feature flag service returned ${err.status}, "${err.body}". Clear version data and retry.`);
                    this.setVersionAndTimestamp(undefined, 0);
                    this.schedule();
                } else {
                    // no retry needed
                    const message = `Feature flag service returned ${err.status}, "${err.body}". This request will not be retried until the user data has been changed.`;
                    this.logger.error(message);
                    this.onError(err.status, err.body);
                }
            } else if (err.name === 'AbortError') {
                this.failureCount += 1;
                // a user with no cache will retry instantly for maxInstantRetryTimes
                // onError will be called after all allowed attempts fail or timeout
                if (this.failureCount > this.getPollingConfig().maxInstantRetryTimes) this.onError(0);
                this.schedule();
            } else {
                this.failureCount += 1;
                // a user with no cache will retry instantly for maxInstantRetryTimes
                // onError will be called after all allowed attempts fail or timeout
                if (this.failureCount > this.getPollingConfig().maxInstantRetryTimes) {
                    if (err instanceof (0, $bRCHv.ResponseError)) this.onError(err.status, err.body);
                    else this.onError();
                }
                this.schedule();
            }
            this.status = (0, $5fUyP.RefreshStatus).ERROR;
            this.updateMetadataOnRequestComplete();
        });
        else {
            this.schedule();
            this.status = (0, $5fUyP.RefreshStatus).SUCCESS;
        }
    }
    isFetchRequired() {
        return Date.now() - this.getPollingConfig().interval >= this.lastUpdateTimestamp;
    }
    updateMetadataOnUserChange() {
        // if fetch required, it will be a INITIALIZATION fetch, otherwise it's going to be a delay POLLING fetch
        this.metadataManager.updateClientCauseReason(this.isFetchRequired() ? (0, $ixyl1.ClientCauseReason).INITIALIZATION : (0, $ixyl1.ClientCauseReason).POLLING);
        // always set user state to SWITCHED user for next fetch
        this.metadataManager.updateClientUserState((0, $ixyl1.ClientUserState).SWITCHED);
    }
    updateMetadataOnInitialisation() {
        // if fetch required, it will be a INITIALIZATION fetch, otherwise it's going to be a delay POLLING fetch
        this.metadataManager.updateClientCauseReason(this.isFetchRequired() ? (0, $ixyl1.ClientCauseReason).INITIALIZATION : (0, $ixyl1.ClientCauseReason).POLLING);
        // no cache (lastUpdateTimestamp === 0) means we fetch for NEW user, if we have cache we fetch for SAME user
        this.metadataManager.updateClientUserState(this.lastUpdateTimestamp === 0 ? (0, $ixyl1.ClientUserState).NEW : (0, $ixyl1.ClientUserState).SAME);
    }
    updateMetadataOnRequestComplete() {
        if (this.failureCount) // when current fetch failed, next fetch will be a RETRY
        // the calling user has not changed
        this.metadataManager.updateClientCauseReason((0, $ixyl1.ClientCauseReason).RETRY);
        else {
            // when current fetch success, next fetch will be a POLLING
            // and the calling user will be SAME user
            this.metadataManager.updateClientCauseReason((0, $ixyl1.ClientCauseReason).POLLING);
            this.metadataManager.updateClientUserState((0, $ixyl1.ClientUserState).SAME);
        }
    }
    // calculate wait interval based on failure count
    calculateInterval() {
        const { interval: interval, tabHiddenPollingFactor: tabHiddenPollingFactor, minWaitInterval: minWaitInterval, maxWaitInterval: maxWaitInterval, backOffFactor: backOffFactor, backOffJitter: backOffJitter, maxInstantRetryTimes: maxInstantRetryTimes } = this.getPollingConfig();
        if (maxInstantRetryTimes !== undefined && maxInstantRetryTimes !== 0 && maxInstantRetryTimes >= this.failureCount) return 0;
        if (this.failureCount === 0) return $8d35d24db2ae82e4$export$2e2bcd8739ae039.isTabHidden() ? interval * tabHiddenPollingFactor : interval;
        let ms = minWaitInterval * backOffFactor ** (this.failureCount - 1);
        if (backOffJitter) {
            const rand = Math.random();
            const deviation = Math.floor(rand * backOffJitter * ms);
            if (Math.floor(rand * 10) < 5) ms -= deviation;
            else ms += deviation;
        }
        return Number(Math.min(ms, maxWaitInterval));
    }
    getPollingConfig() {
        if (this.version === undefined && this.lastUpdateTimestamp === 0) return this.noCachePollingConfig;
        return this.pollingConfig;
    }
}

});
parcelRegister("4hn2t", function(module, exports) {

$parcel$export(module.exports, "default", () => $940fa670a2d21fec$export$2e2bcd8739ae039);

var $9uax1 = parcelRequire("9uax1");

var $9HvFc = parcelRequire("9HvFc");

var $bRCHv = parcelRequire("bRCHv");
const $940fa670a2d21fec$var$REQUEST_TIMEOUT = 2000;
const $940fa670a2d21fec$var$PROD_FEDRAMP_BASE_URL = 'https://api.atlassian-us-gov-mod.com/flags';
const $940fa670a2d21fec$var$PROD_BASE_URL = 'https://api.atlassian.com/flags';
const $940fa670a2d21fec$var$STAGING_FEDRAMP_BASE_URL = 'https://api.stg.atlassian-us-gov-mod.com/flags';
const $940fa670a2d21fec$var$STAGING_BASE_URL = 'https://api.stg.atlassian.com/flags';
const $940fa670a2d21fec$var$DEV_BASE_URL = 'https://api.dev.atlassian.com/flags';
const $940fa670a2d21fec$var$GATEWAY_BASE_URL = '/gateway/api/flags';
class $940fa670a2d21fec$export$2e2bcd8739ae039 {
    constructor(apiKey, serviceEnv = (0, $9HvFc.EnvironmentType).PROD, baseUrl, useGatewayURL = false, perimeter){
        this.apiKey = apiKey;
        this.baseUrl = $940fa670a2d21fec$export$2e2bcd8739ae039.buildBaseUrl(serviceEnv, baseUrl, useGatewayURL, perimeter);
    }
    async fetchFeatureFlags(user, metadata, version) {
        const requestBody = {
            apiKey: this.apiKey,
            identifier: user.identifier,
            isAnonymous: user.isAnonymous,
            additionalIdentifiers: user.additionalIdentifiers,
            customAttributes: user.custom,
            versionData: version,
            metadata: metadata
        };
        // in case there are still IE users, check AbortController before init,
        // IE has no timeout applied on fetch since AbortController isn't available
        const controller = typeof AbortController !== 'undefined' ? new AbortController() : null;
        const timeoutId = setTimeout(()=>controller?.abort(), $940fa670a2d21fec$var$REQUEST_TIMEOUT);
        try {
            const response = await fetch(`${this.baseUrl}/api/${(0, $9uax1.CURRENT_FFS_API_VERSION)}/frontend/featureFlagValues`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-Client-Name': metadata.client.name,
                    'X-Client-Version': metadata.client.version,
                    'X-Api-Key': this.apiKey
                },
                body: JSON.stringify(requestBody),
                signal: controller?.signal
            });
            const successfulResponse = await $940fa670a2d21fec$export$2e2bcd8739ae039.handleResponseError(response);
            return $940fa670a2d21fec$export$2e2bcd8739ae039.extractBody(successfulResponse);
        } catch (error) {
            return Promise.reject(error);
        } finally{
            clearTimeout(timeoutId);
        }
    }
    static async handleResponseError(response) {
        if (!response.ok) {
            // Use text() instead of json() as the error body might not be json data
            const body = await response.text();
            throw new (0, $bRCHv.ResponseError)(response.status, body);
        }
        return response;
    }
    static async extractBody(response) {
        if (response.status === 204) return {};
        return response.text().then((text)=>JSON.parse(text || '{}'));
    }
    static buildBaseUrl(serviceEnv, baseUrl, useGatewayURL = false, perimeter) {
        if (baseUrl) return baseUrl;
        if (useGatewayURL) return $940fa670a2d21fec$var$GATEWAY_BASE_URL;
        if (serviceEnv === (0, $9HvFc.EnvironmentType).DEV || serviceEnv === (0, $9HvFc.EnvironmentType).LOCAL) return $940fa670a2d21fec$var$DEV_BASE_URL;
        if (serviceEnv === (0, $9HvFc.EnvironmentType).STAGING) {
            if (perimeter === (0, $9HvFc.PerimeterType).FEDRAMP_MODERATE) return $940fa670a2d21fec$var$STAGING_FEDRAMP_BASE_URL;
            return $940fa670a2d21fec$var$STAGING_BASE_URL;
        }
        if (serviceEnv === (0, $9HvFc.EnvironmentType).PROD && perimeter === (0, $9HvFc.PerimeterType).FEDRAMP_MODERATE) return $940fa670a2d21fec$var$PROD_FEDRAMP_BASE_URL;
        return $940fa670a2d21fec$var$PROD_BASE_URL;
    }
}

});
parcelRegister("bRCHv", function(module, exports) {

$parcel$export(module.exports, "ResponseError", () => $0c2e92f7283bd0f5$export$286baf652d0b1206);
/* eslint-disable no-underscore-dangle */ class $0c2e92f7283bd0f5$export$286baf652d0b1206 extends Error {
    constructor(status, body){
        // Extending error requires this workaround, see https://github.com/Microsoft/TypeScript-wiki/blob/master/Breaking-Changes.md#extending-built-ins-like-error-array-and-map-may-no-longer-work
        super(`Response Error: ${status}`);
        Object.setPrototypeOf(this, $0c2e92f7283bd0f5$export$286baf652d0b1206.prototype);
        this._status = status;
        this._body = body;
    }
    get status() {
        return this._status;
    }
    get body() {
        return this._body;
    }
}

});


parcelRegister("g2FPo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b168920258b3149e$export$2e2bcd8739ae039);

var $2HNok = parcelRequire("2HNok");

var $42bRZ = parcelRequire("42bRZ");
class $b168920258b3149e$export$2e2bcd8739ae039 {
    constructor(pollingConfig){
        this.pollingSeconds = pollingConfig.interval / 1000;
    }
    updateClientCauseReason(reason) {
        this.clientCauseReason = reason;
    }
    updateClientUserState(state) {
        this.clientUserState = state;
    }
    get() {
        const metadata = {
            client: {
                name: 'feature-flag-web-client',
                version: $42bRZ.version
            },
            config: {
                pollingSeconds: this.pollingSeconds
            },
            state: {
                // Need to cast VisibilityState (type) to ClientVisibilityState (enum)
                visibility: document.visibilityState,
                storage: (0, $2HNok.default).getStorageStatus(),
                userContext: this.clientUserState,
                cause: this.clientCauseReason
            }
        };
        return metadata;
    }
}

});




parcelRegister("fyrAH", function(module, exports) {

$parcel$export(module.exports, "MarketplaceFeatureFlagsClient", () => $b52f6ef48532d75e$export$ee88c91f7f1a5d85);

var $5zQU9 = parcelRequire("5zQU9");

var $bTrQR = parcelRequire("bTrQR");

var $9HvFc = parcelRequire("9HvFc");

var $g5DHJ = parcelRequire("g5DHJ");

var $hN9kn = parcelRequire("hN9kn");
function $b52f6ef48532d75e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b52f6ef48532d75e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b52f6ef48532d75e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b52f6ef48532d75e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $b52f6ef48532d75e$export$ee88c91f7f1a5d85 {
    // only used for LD
    constructor(ldClient, userIdentifier){
        // launch darkly
        (0, $5zQU9.default)(this, "_ldClient", void 0);
        (0, $5zQU9.default)(this, "_userIdentifier", void 0);
        // only used for LD
        (0, $5zQU9.default)(this, "_ldFlagNames", void 0);
        // launch darkly
        this._ldClient = ldClient;
        this._userIdentifier = userIdentifier;
        const ldFlags = this._ldClient.getFlags();
        this._ldFlagNames = Object.keys(ldFlags);
        this.logWarningForFallbackValues(ldFlags);
    }
    logWarningForFallbackValues(featureFlags) {
        Object.keys(featureFlags).forEach((key)=>{
            var _featureFlags$key$eva;
            if (((_featureFlags$key$eva = featureFlags[key].evaluationDetail) === null || _featureFlags$key$eva === void 0 ? void 0 : _featureFlags$key$eva.reason) === (0, $9HvFc.EvaluationReason).ERROR) {
                const { value: value, evaluationDetail: evaluationDetail } = featureFlags[key];
                (0, $bTrQR.default).warn('FeatureFlags', 'Error: Serving the fallback value', {
                    extraInfo: {
                        name: key,
                        fallbackValue: value,
                        errorKind: evaluationDetail === null || evaluationDetail === void 0 ? void 0 : evaluationDetail.errorKind
                    }
                });
            }
        });
    }
    getFlag(flagName, defaultValue, options) {
        if (this._ldFlagNames.includes(flagName)) {
            const rawFlag = this._ldClient.getFlagDetails(flagName, defaultValue, options);
            this.logWarningForFallbackValues({
                [flagName]: rawFlag
            });
            return rawFlag.value;
        }
        return defaultValue;
    }
    getAllFlags() {
        const rawFlags = this._ldClient.getFlags();
        const allFlags = (0, $hN9kn.getAllFlagsMap)(rawFlags);
        return (0, $g5DHJ.Map)($b52f6ef48532d75e$var$_objectSpread({}, allFlags));
    }
    changeUserIdentifier(userId) {
        return this._ldClient.updateFeatureFlagUser(userId);
    }
    resetUserIdentifier() {
        return this._ldClient.updateFeatureFlagUser(this._userIdentifier);
    }
}

});
parcelRegister("hN9kn", function(module, exports) {

$parcel$export(module.exports, "getAllFlagsMap", () => $cf3e3f87f05ff898$export$8d2d7a1f04e283bd);

var $5zQU9 = parcelRequire("5zQU9");
function $cf3e3f87f05ff898$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cf3e3f87f05ff898$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cf3e3f87f05ff898$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cf3e3f87f05ff898$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $cf3e3f87f05ff898$export$8d2d7a1f04e283bd = (allFlags)=>{
    return Object.keys(allFlags).reduce((flags, key)=>{
        const { value: value } = allFlags[key];
        return $cf3e3f87f05ff898$var$_objectSpread($cf3e3f87f05ff898$var$_objectSpread({}, flags), {}, {
            [key]: value
        });
    }, {});
};

});


parcelRegister("fqrjS", function(module, exports) {

$parcel$export(module.exports, "getFeatureFlagUser", () => $b3ae79cddc51d92b$export$38754c3b033df81);

var $5zQU9 = parcelRequire("5zQU9");

var $9HvFc = parcelRequire("9HvFc");
function $b3ae79cddc51d92b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b3ae79cddc51d92b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b3ae79cddc51d92b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b3ae79cddc51d92b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $b3ae79cddc51d92b$export$38754c3b033df81 = function getFeatureFlagUser(userId, additionalIds) {
    let customAttributes = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    let user;
    const tenantId = additionalIds === null || additionalIds === void 0 ? void 0 : additionalIds.tenantId;
    if (userId) user = {
        identifier: {
            type: (0, $9HvFc.Identifiers).ATLASSIAN_ACCOUNT_ID,
            value: userId
        },
        isAnonymous: false,
        additionalIdentifiers: {},
        custom: customAttributes
    };
    else user = {
        identifier: {
            type: (0, $9HvFc.Identifiers).FF_CLIENT_ANONYMOUS_ID,
            value: 'marketplace-anonymous'
        },
        isAnonymous: true,
        additionalIdentifiers: {},
        custom: customAttributes
    };
    if (tenantId) user.additionalIdentifiers = $b3ae79cddc51d92b$var$_objectSpread($b3ae79cddc51d92b$var$_objectSpread({}, user.additionalIdentifiers), {}, {
        tenantId: tenantId
    });
    return user;
};

});


parcelRegister("8a1FM", function(module, exports) {

$parcel$export(module.exports, "MarketplaceType", () => $5f108e16e65ab8bb$export$bba2751579270da3);
let $5f108e16e65ab8bb$export$bba2751579270da3 = /*#__PURE__*/ function(MarketplaceType) {
    MarketplaceType["MPAC"] = "MPAC";
    MarketplaceType["EMCEE"] = "EMCEE";
    return MarketplaceType;
}({});

});

parcelRegister("7Qsmx", function(module, exports) {

$parcel$export(module.exports, "appConfig", () => $5b6363e9d01cc8de$export$fd7ad31753ec2ad1);

var $g5DHJ = parcelRequire("g5DHJ");

var $gD0YB = parcelRequire("gD0YB");

var $iP78c = parcelRequire("iP78c");

var $2pr8U = parcelRequire("2pr8U");

var $lQmA1 = parcelRequire("lQmA1");

var $3nH7C = parcelRequire("3nH7C");
const $5b6363e9d01cc8de$export$fd7ad31753ec2ad1 = (0, $g5DHJ.Map)({
    chat: $3nH7C.default,
    jira: $lQmA1.default,
    confluence: $2pr8U.default,
    bitbucket: $gD0YB.default,
    compass: $iP78c.default
});

});
parcelRegister("gD0YB", function(module, exports) {

$parcel$export(module.exports, "default", () => $c1b10bc10eb63600$export$2e2bcd8739ae039);

var $61ksZ = parcelRequire("61ksZ");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
parcelRequire("eUqFw");

var $kC116 = parcelRequire("kC116");

var $bdw66 = parcelRequire("bdw66");

var $ex4uM = parcelRequire("ex4uM");

var $lHkHI = parcelRequire("lHkHI");
var $c1b10bc10eb63600$export$2e2bcd8739ae039 = (0, $ex4uM.makeHostConfig)({
    addonDiscovery: (0, $ex4uM.makeAddonDiscoveryConfig)({
        featuredContentOverride: (0, $bWAru.Option).empty(),
        productKey: 'bitbucket',
        hiddenFilters: (0, $g5DHJ.Map)({
            sort: true,
            moreFilters: (0, $g5DHJ.Set)([
                'free'
            ])
        })
    }),
    analytics: {
        productName: 'bitbucket',
        getSubproduct: (_)=>{
        /* Bitbucket has no subproduct */ }
    },
    errors: (0, $g5DHJ.Map)({
        AddonDefinitionNotFoundError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "It's possible the link to the app is broken."
        }),
        DescriptorFetchError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "We couldn't find an app at that installation URL. Please make sure the URL is correct.",
            validationError: true
        }),
        InstallationConflictError: (0, $bdw66.makeErrorTranslation)({
            title: "We're seeing double!",
            description: 'The app is already installed.'
        }),
        InvalidAddonOriginError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't registered",
            description: 'Please enter the installation URL from your app listing in marketplace.atlassian.com',
            validationError: true
        }),
        InvalidDefinitionDetailsQueryError: (0, $bdw66.makeErrorTranslation)({
            title: "The URL isn't formatted correctly",
            description: 'Please enter a valid installation URL, beginning with http: or https:',
            validationError: true
        }),
        InvalidDescriptorError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't working quite right",
            description: "The app at that installation URL seems to be broken. Please reach out to our Support team, so we can get it fixed.",
            showTID: true
        }),
        default: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: 'It might just be a hiccup. Try again in a bit.',
            showTID: true
        })
    }),
    featureFlags: {
        productName: 'bitbucket'
    },
    globalContext: (0, $bWAru.Option).some({
        icon: (0, $bWAru.Option).some((0, $kC116.makeReactContextIcon)((_ref)=>{
            let { label: label, size: size } = _ref;
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $61ksZ.BitbucketIcon), {
                label: label,
                size: size
            });
        }))
    }),
    name: 'Bitbucket',
    installationLocation: 'Bitbucket',
    isCloseable: false,
    supportsManage: false,
    removeFromSite: {
        actionSummary: (appName)=>"Remove ".concat(appName, " from Bitbucket"),
        confirmation: (appName)=>"You're about to remove ".concat(appName, ".             Are you sure that's what you wanted to do?"),
        successNotification: (appName)=>"".concat(appName, " was removed")
    }
});

});
parcelRegister("61ksZ", function(module, exports) {

$parcel$export(module.exports, "BitbucketIcon", () => $2f3c7f2445fe62a9$export$5fc1066e677788d4);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $8a91X = parcelRequire("8a91X");

var $dcD26 = parcelRequire("dcD26");

var $fd3g8 = parcelRequire("fd3g8");

var $eKb3u = parcelRequire("eKb3u");
const $2f3c7f2445fe62a9$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fd3g8.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill=${colors.iconColor} d="m25.586 15.819-1.618 9.885c-.106.598-.528.95-1.126.95H9.122c-.598 0-1.02-.352-1.126-.95L5.146 8.08c-.105-.598.212-.985.775-.985h20.123c.562 0 .88.387.773.985l-.773 4.644c-.106.668-.493.95-1.126.95H12.816c-.176 0-.282.105-.246.316l.95 5.84c.035.14.14.246.281.246h4.362c.141 0 .246-.105.282-.246l.668-4.222c.07-.527.422-.738.915-.738h4.75c.703 0 .914.351.808.95"/>
    </svg>`;
};
const $2f3c7f2445fe62a9$export$5fc1066e677788d4 = ({ appearance: appearance, label: label = 'Bitbucket', size: size = (0, $dcD26.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $dcD26.defaultLogoParams).iconColor, textColor: textColor = (0, $dcD26.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $8a91X.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eKb3u.default), {
        appearance: appearance,
        label: label,
        svg: $2f3c7f2445fe62a9$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});

parcelRegister("bdw66", function(module, exports) {

$parcel$export(module.exports, "makeErrorTranslation", () => $82a9ce7fbeb321ec$export$684bfd87ebfc9317);

var $g5DHJ = parcelRequire("g5DHJ");
const $82a9ce7fbeb321ec$export$684bfd87ebfc9317 = (0, $g5DHJ.Record)({
    title: '',
    description: '',
    validationError: false,
    showTID: false,
    actions: null
});

});

parcelRegister("ex4uM", function(module, exports) {

$parcel$export(module.exports, "makeAddonDiscoveryConfig", () => $a947a27451f4a42c$export$36f705efe56390c5);
$parcel$export(module.exports, "makeTokenConfig", () => $a947a27451f4a42c$export$9b8082f21d8aa046);
$parcel$export(module.exports, "makeHostConfig", () => $a947a27451f4a42c$export$9742b3e7692ff021);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

const $a947a27451f4a42c$export$36f705efe56390c5 = (0, $g5DHJ.Record)({
    featuredContentOverride: (0, $bWAru.Option).empty(),
    productKey: '',
    hiddenFilters: (0, $g5DHJ.Map)()
});
const $a947a27451f4a42c$export$9b8082f21d8aa046 = (0, $g5DHJ.Record)({
    exampleBody: {},
    exampleEndpoint: ()=>'',
    explanation: '',
    endpointVerb: ''
});
const $a947a27451f4a42c$export$9742b3e7692ff021 = (0, $g5DHJ.Record)({
    addonDiscovery: $a947a27451f4a42c$export$36f705efe56390c5(),
    analytics: {
        productName: '',
        getSubproduct: (_)=>{
        /* no subproduct by default */ }
    },
    contextType: (0, $162f08973e9f5b39$export$e5741ce2a090e5ef),
    errors: (0, $g5DHJ.Map)(),
    featureFlags: {
        productName: ''
    },
    globalContext: (0, $bWAru.Option).empty(),
    installedApps: {
        globallyInstalledApps: {
            sectionHeading: '',
            sectionDescription: ''
        },
        locallyInstalledApps: {
            sectionHeading: ''
        }
    },
    installationLocation: '',
    isCloseable: false,
    name: '',
    removeFromSite: {
        actionSummary: ()=>'',
        confirmation: ()=>'',
        // eslint-disable-line react/display-name
        successNotification: ()=>''
    },
    token: $a947a27451f4a42c$export$9b8082f21d8aa046(),
    supportsManage: false,
    welcomeHeader: '',
    welcomeSubheader: ''
});

});
const $162f08973e9f5b39$export$e5741ce2a090e5ef = 'conversation';
const $162f08973e9f5b39$export$2bf647ebf8f553ef = 'project';
const $162f08973e9f5b39$export$f8af7f4705257c5a = 'space';



parcelRegister("iP78c", function(module, exports) {

$parcel$export(module.exports, "default", () => $db428583914589a7$export$2e2bcd8739ae039);

var $kQKGI = parcelRequire("kQKGI");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
parcelRequire("eUqFw");

var $kC116 = parcelRequire("kC116");

var $bdw66 = parcelRequire("bdw66");

var $ex4uM = parcelRequire("ex4uM");

var $lHkHI = parcelRequire("lHkHI");
var $db428583914589a7$export$2e2bcd8739ae039 = (0, $ex4uM.makeHostConfig)({
    addonDiscovery: (0, $ex4uM.makeAddonDiscoveryConfig)({
        featuredContentOverride: (0, $bWAru.Option).empty(),
        productKey: 'compass',
        hiddenFilters: (0, $g5DHJ.Map)()
    }),
    analytics: {
        productName: 'compass',
        getSubproduct: (_)=>{
        /* Compass has no subproduct */ }
    },
    errors: (0, $g5DHJ.Map)({
        AddonDefinitionNotFoundError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "It's possible the link to the app is broken."
        }),
        DescriptorFetchError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "We couldn't find an app at that installation URL. Please make sure the URL is correct.",
            validationError: true
        }),
        InstallationConflictError: (0, $bdw66.makeErrorTranslation)({
            title: "We're seeing double!",
            description: 'The app is already installed.'
        }),
        InvalidAddonOriginError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't registered",
            description: 'Please enter the installation URL from your app listing in marketplace.atlassian.com',
            validationError: true
        }),
        InvalidDefinitionDetailsQueryError: (0, $bdw66.makeErrorTranslation)({
            title: "The URL isn't formatted correctly",
            description: 'Please enter a valid installation URL, beginning with http: or https:',
            validationError: true
        }),
        InvalidDescriptorError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't working quite right",
            description: "The app at that installation URL seems to be broken. Please reach out to our Support team, so we can get it fixed.",
            showTID: true
        }),
        PaymentFailure: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: 'Please verify that your payment details and license status are correct before trying to install the app again.',
            showTID: false
        }),
        default: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: "Unfortunately, we\u2019re unable to process your request. Please retry again in some time.",
            showTID: true
        })
    }),
    featureFlags: {
        productName: 'compass'
    },
    globalContext: (0, $bWAru.Option).some({
        icon: (0, $bWAru.Option).some((0, $kC116.makeReactContextIcon)((_ref)=>{
            let { label: label, size: size } = _ref;
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kQKGI.CompassIcon), {
                label: label,
                size: size
            });
        }))
    }),
    name: 'Compass',
    installationLocation: 'Compass',
    isCloseable: false,
    supportsManage: false
});

});
parcelRegister("kQKGI", function(module, exports) {

$parcel$export(module.exports, "CompassIcon", () => $95c4b779fba4613a$export$f7857fe64d7161d9);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $8a91X = parcelRequire("8a91X");

var $dcD26 = parcelRequire("dcD26");

var $fd3g8 = parcelRequire("fd3g8");

var $eKb3u = parcelRequire("eKb3u");
const $95c4b779fba4613a$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fd3g8.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M15.667 15.66v5.942H9.713V15.66zV9.722H4.807c-.58.004-1.047.47-1.043 1.04v15.755a1.04 1.04 0 0 0 1.028 1.054h15.771a1.04 1.04 0 0 0 1.042-1.04V15.66zm0-11.88v5.942h5.967v5.938h5.935V4.82a1.04 1.04 0 0 0-1.028-1.053h-.014z"/>
      </svg>
    `;
};
const $95c4b779fba4613a$export$f7857fe64d7161d9 = ({ appearance: appearance, label: label = 'Compass', size: size = (0, $dcD26.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $dcD26.defaultLogoParams).iconColor, textColor: textColor = (0, $dcD26.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $8a91X.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eKb3u.default), {
        appearance: appearance,
        label: label,
        svg: $95c4b779fba4613a$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("2pr8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c12f88d533532b8$export$2e2bcd8739ae039);

var $7lIvy = parcelRequire("7lIvy");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
parcelRequire("eUqFw");

var $kC116 = parcelRequire("kC116");

var $bdw66 = parcelRequire("bdw66");

var $ex4uM = parcelRequire("ex4uM");

var $lHkHI = parcelRequire("lHkHI");
var $1c12f88d533532b8$export$2e2bcd8739ae039 = (0, $ex4uM.makeHostConfig)({
    addonDiscovery: (0, $ex4uM.makeAddonDiscoveryConfig)({
        featuredContentOverride: (0, $bWAru.Option).empty(),
        productKey: 'confluence',
        hiddenFilters: (0, $g5DHJ.Map)()
    }),
    analytics: {
        productName: 'confluence',
        getSubproduct: (_)=>{
        /* Confluence has no subproduct */ }
    },
    errors: (0, $g5DHJ.Map)({
        AddonDefinitionNotFoundError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "It's possible the link to the app is broken."
        }),
        DescriptorFetchError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "We couldn't find an app at that installation URL. Please make sure the URL is correct.",
            validationError: true
        }),
        InstallationConflictError: (0, $bdw66.makeErrorTranslation)({
            title: "We're seeing double!",
            description: 'The app is already installed.'
        }),
        InvalidAddonOriginError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't registered",
            description: 'Please enter the installation URL from your app listing in marketplace.atlassian.com',
            validationError: true
        }),
        InvalidDefinitionDetailsQueryError: (0, $bdw66.makeErrorTranslation)({
            title: "The URL isn't formatted correctly",
            description: 'Please enter a valid installation URL, beginning with http: or https:',
            validationError: true
        }),
        InvalidDescriptorError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't working quite right",
            description: "The app at that installation URL seems to be broken. Please reach out to our Support team, so we can get it fixed.",
            showTID: true
        }),
        PaymentFailure: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: 'Please verify that your payment details and license status are correct before trying to install the app again.',
            showTID: false
        }),
        'connect.install.error.nodefaultgroup': (0, $bdw66.makeErrorTranslation)({
            title: 'App installation failed',
            description: 'We are unable to process your request as there is no default group in Confluence cloud product access. Please review and create a default group for each product.',
            showTID: false,
            actions: [
                {
                    content: 'Learn more about default groups',
                    href: 'https://support.atlassian.com/user-management/docs/create-and-update-groups/',
                    target: '_blank'
                }
            ]
        }),
        default: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: "Unfortunately, we\u2019re unable to process your request. Please retry again in some time.",
            showTID: true
        })
    }),
    featureFlags: {
        productName: 'confluence'
    },
    globalContext: (0, $bWAru.Option).some({
        icon: (0, $bWAru.Option).some((0, $kC116.makeReactContextIcon)((_ref)=>{
            let { label: label, size: size } = _ref;
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7lIvy.ConfluenceIcon), {
                label: label,
                size: size
            });
        }))
    }),
    name: 'Confluence',
    installationLocation: 'Confluence',
    isCloseable: false,
    supportsManage: false,
    removeFromSite: {
        actionSummary: (appName)=>"Remove ".concat(appName, " from Confluence"),
        confirmation: (appName)=>"You're about to remove ".concat(appName, ".             Are you sure that's what you wanted to do?"),
        successNotification: (appName)=>"".concat(appName, " was removed")
    }
});

});
parcelRegister("7lIvy", function(module, exports) {

$parcel$export(module.exports, "ConfluenceIcon", () => $05438cfa83896464$export$68f3db7f6af48bcb);
/* eslint-disable max-len */ 
var $eUqFw = parcelRequire("eUqFw");

var $8a91X = parcelRequire("8a91X");

var $dcD26 = parcelRequire("dcD26");

var $fd3g8 = parcelRequire("fd3g8");

var $eKb3u = parcelRequire("eKb3u");
const $05438cfa83896464$var$svg = ({ appearance: appearance, iconColor: iconColor }, colorMode)=>{
    let colors = {
        iconColor: iconColor
    };
    if (appearance) colors = (0, $fd3g8.getColorsFromAppearance)(appearance, colorMode);
    return `<svg fill="none" height="32" viewBox="0 0 32 32" focusable="false" aria-hidden="true" xmlns="http://www.w3.org/2000/svg">
      <path fill="${colors.iconColor}" d="M25.769 20.234c-6.584-3.183-8.507-3.66-11.282-3.66-3.254 0-6.028 1.355-8.507 5.16l-.406.622c-.333.513-.407.696-.407.915s.11.403.517.659l4.18 2.598c.222.146.407.22.592.22.222 0 .37-.11.592-.44l.665-1.024c1.036-1.574 1.96-2.086 3.144-2.086 1.036 0 2.257.293 3.773 1.025l4.365 2.049c.443.22.924.11 1.146-.403l2.071-4.537c.222-.512.074-.842-.444-1.098M6.572 12.22c6.584 3.184 8.507 3.66 11.281 3.66 3.255 0 6.03-1.354 8.507-5.16l.407-.622c.333-.512.407-.695.407-.915s-.11-.402-.518-.658l-4.18-2.598c-.221-.147-.406-.22-.591-.22-.222 0-.37.11-.592.44l-.666 1.024c-1.035 1.573-1.96 2.086-3.144 2.086-1.035 0-2.256-.293-3.772-1.025L9.346 6.183c-.444-.22-.924-.11-1.146.402l-2.072 4.538c-.222.512-.074.841.444 1.098"/>
    </svg>`;
};
const $05438cfa83896464$export$68f3db7f6af48bcb = ({ appearance: appearance, label: label = 'Confluence', size: size = (0, $dcD26.defaultLogoParams).size, testId: testId, iconColor: iconColor = (0, $dcD26.defaultLogoParams).iconColor, textColor: textColor = (0, $dcD26.defaultLogoParams).textColor })=>{
    const { colorMode: colorMode } = (0, $8a91X.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eKb3u.default), {
        appearance: appearance,
        label: label,
        svg: $05438cfa83896464$var$svg({
            appearance: appearance,
            iconColor: iconColor
        }, colorMode),
        iconColor: iconColor,
        size: size,
        testId: testId,
        textColor: textColor
    });
};

});


parcelRegister("lQmA1", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe6ff83abaf7143b$export$2e2bcd8739ae039);

var $4a98q = parcelRequire("4a98q");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
parcelRequire("eUqFw");

var $kC116 = parcelRequire("kC116");

var $bdw66 = parcelRequire("bdw66");

var $ex4uM = parcelRequire("ex4uM");

var $lHkHI = parcelRequire("lHkHI");
const $fe6ff83abaf7143b$var$subproductTranslationTable = (0, $g5DHJ.Map)({
    'jira-software': 'software',
    'jira-servicedesk': 'serviceDesk',
    'jira-core': 'core',
    'portfolio-for-jira': 'portfolio',
    family: 'platform'
});
var $fe6ff83abaf7143b$export$2e2bcd8739ae039 = (0, $ex4uM.makeHostConfig)({
    addonDiscovery: (0, $ex4uM.makeAddonDiscoveryConfig)({
        featuredContentOverride: (0, $bWAru.Option).empty(),
        productKey: 'jira',
        hiddenFilters: (0, $g5DHJ.Map)()
    }),
    analytics: {
        productName: 'jira',
        getSubproduct: (subproduct)=>subproduct ? $fe6ff83abaf7143b$var$subproductTranslationTable.get(subproduct) : undefined
    },
    errors: (0, $g5DHJ.Map)({
        AddonDefinitionNotFoundError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "It's possible the link to the app is broken."
        }),
        DescriptorFetchError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "We couldn't find an app at that installation URL. Please make sure the URL is correct.",
            validationError: true
        }),
        InstallationConflictError: (0, $bdw66.makeErrorTranslation)({
            title: "We're seeing double!",
            description: 'The app is already installed.'
        }),
        InvalidAddonOriginError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't registered",
            description: 'Please enter the installation URL from your app listing in marketplace.atlassian.com',
            validationError: true
        }),
        InvalidDefinitionDetailsQueryError: (0, $bdw66.makeErrorTranslation)({
            title: "The URL isn't formatted correctly",
            description: 'Please enter a valid installation URL, beginning with http: or https:',
            validationError: true
        }),
        InvalidDescriptorError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't working quite right",
            description: "The app at that installation URL seems to be broken. Please reach out to our Support team, so we can get it fixed.",
            showTID: true
        }),
        PaymentFailure: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: 'Please verify that your payment details and license status are correct before trying to install the app again.',
            showTID: false
        }),
        'connect.install.error.nodefaultgroup': (0, $bdw66.makeErrorTranslation)({
            title: 'App installation failed',
            description: 'We are unable to process your request as there is no default group in Jira cloud product access. Please review and create a default group for each product.',
            showTID: false,
            actions: [
                {
                    content: 'Learn more about default groups',
                    href: 'https://support.atlassian.com/user-management/docs/create-and-update-groups/',
                    target: '_blank'
                }
            ]
        }),
        default: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: "Unfortunately, we\u2019re unable to process your request. Please retry again in some time.",
            showTID: true
        })
    }),
    featureFlags: {
        productName: 'jira'
    },
    globalContext: (0, $bWAru.Option).some({
        icon: (0, $bWAru.Option).some((0, $kC116.makeReactContextIcon)((_ref)=>{
            let { label: label, size: size } = _ref;
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4a98q.JiraIcon), {
                label: label,
                size: size
            });
        }))
    }),
    name: 'Jira',
    installationLocation: 'Jira',
    isCloseable: false,
    supportsManage: false,
    removeFromSite: {
        actionSummary: (appName)=>"Remove ".concat(appName, " from Jira"),
        confirmation: (appName)=>"You're about to remove ".concat(appName, ".             Are you sure that's what you wanted to do?"),
        successNotification: (appName)=>"".concat(appName, " was removed")
    }
});

});

parcelRegister("3nH7C", function(module, exports) {

$parcel$export(module.exports, "default", () => $2764f82bbcd02ad3$export$2e2bcd8739ae039);

var $eMCmH = parcelRequire("eMCmH");

var $lLYAL = parcelRequire("lLYAL");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
parcelRequire("eUqFw");

var $iRzCc = parcelRequire("iRzCc");

var $bdw66 = parcelRequire("bdw66");

var $ex4uM = parcelRequire("ex4uM");


var $4m18f = parcelRequire("4m18f");

var $lHkHI = parcelRequire("lHkHI");
var $2764f82bbcd02ad3$export$2e2bcd8739ae039 = (0, $ex4uM.makeHostConfig)({
    addonDiscovery: (0, $ex4uM.makeAddonDiscoveryConfig)({
        featuredContentOverride: (0, $bWAru.Option).some((_ref)=>{
            let { openAppSpecificPasswordDialog: openAppSpecificPasswordDialog } = _ref;
            return (0, $g5DHJ.List)([
                new (0, $eMCmH.default)({
                    index: 0,
                    // eslint-disable-next-line react/display-name
                    render: ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $iRzCc.default), {
                            openAppSpecificPasswordDialog: openAppSpecificPasswordDialog
                        })
                })
            ]);
        }),
        productKey: 'stride',
        hiddenFilters: (0, $g5DHJ.Map)({
            sort: true,
            moreFilters: (0, $g5DHJ.Set)([
                'free'
            ])
        })
    }),
    analytics: {
        productName: 'stride',
        getSubproduct: (_)=>{
        /* no subproduct */ }
    },
    contextType: (0, $162f08973e9f5b39$export$e5741ce2a090e5ef),
    errors: (0, $g5DHJ.Map)({
        AddonDefinitionNotFoundError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "It's possible the link to the app is broken."
        }),
        DescriptorFetchError: (0, $bdw66.makeErrorTranslation)({
            title: "We couldn't find the app",
            description: "We couldn't find an app at that installation URL. Please make sure the URL is correct.",
            validationError: true
        }),
        InstallationConflictError: (0, $bdw66.makeErrorTranslation)({
            title: "We're seeing double!",
            description: 'The app is already installed in this conversation.'
        }),
        InvalidAddonOriginError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't registered",
            description: 'Please enter the installation URL from your app listing in developer.atlassian.com',
            validationError: true
        }),
        InvalidDefinitionDetailsQueryError: (0, $bdw66.makeErrorTranslation)({
            title: "The URL isn't formatted correctly",
            description: 'Please enter a valid installation URL, beginning with http: or https:',
            validationError: true
        }),
        InvalidDescriptorError: (0, $bdw66.makeErrorTranslation)({
            title: "This app isn't working quite right",
            description: "The app at that installation URL seems to be broken. Please reach out to our Support team, so we can get it fixed.",
            showTID: true
        }),
        default: (0, $bdw66.makeErrorTranslation)({
            title: 'We ran into a little trouble',
            description: 'It might just be a hiccup. Try again in a bit.',
            showTID: true
        })
    }),
    featureFlags: {
        productName: 'stride'
    },
    installedApps: {
        globallyInstalledApps: {
            sectionHeading: 'Apps installed in all conversations',
            sectionDescription: 'Some apps are installed in all public rooms and conversations.'
        },
        locallyInstalledApps: {
            sectionHeading: 'Apps installed in this conversation'
        }
    },
    name: 'Stride',
    installationLocation: 'conversation',
    isCloseable: true,
    removeFromSite: {
        actionSummary: (appName)=>"Remove ".concat(appName, " from all conversations"),
        confirmation: (appName)=>"You're about to remove ".concat(appName, " from multiple conversations.             Participants in these conversations won't be able to use ").concat(appName, " in Stride. This can't be undone."),
        successNotification: (appName)=>"".concat(appName, " was removed from all conversations")
    },
    token: (0, $ex4uM.makeTokenConfig)({
        exampleBody: {
            body: {
                version: 1,
                type: 'doc',
                content: [
                    {
                        type: 'paragraph',
                        content: [
                            {
                                type: 'text',
                                text: 'My first message!'
                            }
                        ]
                    }
                ]
            }
        },
        exampleEndpoint: (context)=>{
            const ari = (0, $lLYAL.parse)(context.id);
            return (0, $4m18f.parse)('https://api.atlassian.com/site/{cloudId}/conversation/{conversationId}/message').expand({
                cloudId: ari.cloudId,
                conversationId: ari.resourceId
            });
        },
        explanation: "API tokens give you a simple way to send messages to a conversation from your own code, without having to build an app.",
        endpointVerb: 'post messages'
    }),
    supportsManage: true,
    welcomeHeader: 'Welcome to Stride!',
    welcomeSubheader: 'Pick a conversation to get going...'
});

});
parcelRegister("iRzCc", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbb8cda164bfaf8e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $ivTMz = parcelRequire("ivTMz");

var $j0gMm = parcelRequire("j0gMm");

var $8gcXz = parcelRequire("8gcXz");
var $gykb8 = parcelRequire("gykb8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $82QIV = parcelRequire("82QIV");

var $lHkHI = parcelRequire("lHkHI");
function $dbb8cda164bfaf8e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dbb8cda164bfaf8e$export$ef5dfe27ad077558 = (0, $3UXZ8.default)("div", {
    target: "e18vh9uh0",
    label: "BYOTileContainer"
})("border-radius:", (0, $ivTMz.borderRadius)(), "px;height:100%;border:2px dashed ", (0, $j0gMm.N400), ";cursor:pointer;display:flex;justify-content:space-around;flex-direction:column;");
const $dbb8cda164bfaf8e$export$bc714d455b135669 = (0, $3UXZ8.default)("div", {
    target: "e18vh9uh1",
    label: "BYOTileContent"
})({
    name: "11u0uwb",
    styles: "padding:15px;margin:auto;"
});
const $dbb8cda164bfaf8e$export$508f9a61eb3c0147 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H3), {
    target: "e18vh9uh2",
    label: "BYOTileHeading"
})("color:", (0, $j0gMm.N800), ";font-size:16px;font-weight:800;margin:0 0 3px;line-height:1.42857143;max-height:42px;");
const $dbb8cda164bfaf8e$export$287fb8a3c895d99c = (0, $3UXZ8.default)("div", {
    target: "e18vh9uh3",
    label: "BYOTileTextContainer"
})({
    name: "z920ed",
    styles: "display:table;"
});
const $dbb8cda164bfaf8e$export$e644168da93dcc51 = (0, $3UXZ8.default)("div", {
    target: "e18vh9uh4",
    label: "BYOTileText"
})("display:table-cell;vertical-align:top;color:", (0, $j0gMm.N500), ";font-size:14px;word-wrap:break-word;overflow:hidden;min-height:35px;line-height:1.26;");
const $dbb8cda164bfaf8e$export$3aa1d1610e7e6799 = (0, $3UXZ8.default)("div", {
    target: "e18vh9uh5",
    label: "BYOTileTextLinkContainer"
})({
    name: "tr0r3x",
    styles: "margin-top:15px;"
});
const $dbb8cda164bfaf8e$export$be96604e57d7eea0 = (0, $3UXZ8.default)("div", {
    target: "e18vh9uh6",
    label: "BYOTileIconWrapper"
})({
    name: "xskcao",
    styles: "margin-left:10px;width:80px;"
});
const $dbb8cda164bfaf8e$export$431e1383ad029b46 = (0, $3UXZ8.default)("img", {
    target: "e18vh9uh7",
    label: "BYOTileIcon"
})({
    name: "v2kfba",
    styles: "height:100%;width:100%;"
});
class $dbb8cda164bfaf8e$export$f8f09afa2391cee9 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ // eslint-disable-next-line styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions
            (0, $lHkHI.jsx)($dbb8cda164bfaf8e$export$ef5dfe27ad077558, {
                onClick: this.openBYODialog,
                children: /*#__PURE__*/ (0, $lHkHI.jsxs)($dbb8cda164bfaf8e$export$bc714d455b135669, {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)($dbb8cda164bfaf8e$export$508f9a61eb3c0147, {
                            children: "Connect your own app"
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsxs)($dbb8cda164bfaf8e$export$287fb8a3c895d99c, {
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsxs)($dbb8cda164bfaf8e$export$e644168da93dcc51, {
                                    children: [
                                        /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                                            children: "If you've built an app, generate a token or add your installation URL to bring your custom app to life."
                                        }),
                                        /*#__PURE__*/ (0, $lHkHI.jsx)($dbb8cda164bfaf8e$export$3aa1d1610e7e6799, {
                                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                                                children: "Connect your app"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)($dbb8cda164bfaf8e$export$be96604e57d7eea0, {
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)($dbb8cda164bfaf8e$export$431e1383ad029b46, {
                                        alt: "",
                                        src: (0, (/*@__PURE__*/$parcel$interopDefault($82QIV)))
                                    })
                                })
                            ]
                        })
                    ]
                })
            }));
        (0, $5zQU9.default)(this, "openBYODialog", ()=>{
            this.props.fireAnalyticsEvent({
                eventType: (0, $gaiog.TileClickedEvent),
                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_BYO_TILE)
            });
            this.props.openAppSpecificPasswordDialog();
        });
    }
}
var $dbb8cda164bfaf8e$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($dbb8cda164bfaf8e$export$f8f09afa2391cee9);

});
parcelRegister("82QIV", function(module, exports) {
module.exports = new URL("BYO.cb08927a.svg", import.meta.url).toString();

});


parcelRegister("4m18f", function(module, exports) {

$parcel$export(module.exports, "parse", () => $32ba184ed6577c5f$export$98e6a39c04603d36);

var $asbhz = parcelRequire("asbhz");
function $32ba184ed6577c5f$export$98e6a39c04603d36(template) {
    const parsedTemplate = (0, (/*@__PURE__*/$parcel$interopDefault($asbhz))).parse(template);
    return {
        expand: (context)=>parsedTemplate.expand(context)
    };
}

});



parcelRegister("iIG3b", function(module, exports) {

$parcel$export(module.exports, "EmceeVariant", () => $da0cf45aec120dd4$export$fa7c4ce45ad3c88);
const $da0cf45aec120dd4$var$EMCEE_CONNECT_VARIANT = 'CONNECT';
const $da0cf45aec120dd4$var$EMCEE_NATIVE_VARIANT = 'NATIVE';
const $da0cf45aec120dd4$export$fa7c4ce45ad3c88 = Object.freeze({
    Connect: $da0cf45aec120dd4$var$EMCEE_CONNECT_VARIANT,
    Native: $da0cf45aec120dd4$var$EMCEE_NATIVE_VARIANT
});

});

parcelRegister("5kxcx", function(module, exports) {

$parcel$export(module.exports, "makeHostInfo", () => $3e1893108a7b2930$export$9ef95f2bba3e6c4d);

var $5zQU9 = parcelRequire("5zQU9");
function $3e1893108a7b2930$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3e1893108a7b2930$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3e1893108a7b2930$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3e1893108a7b2930$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $3e1893108a7b2930$export$108ec03634d71252 = (supports)=>$3e1893108a7b2930$var$_objectSpread({
        context: false,
        accessToken: false,
        enabled: false
    }, supports);
const $3e1893108a7b2930$export$2d2e2a019c76af3 = (context)=>$3e1893108a7b2930$var$_objectSpread({
        id: '',
        orgId: '',
        workspaceAri: ''
    }, context);
const $3e1893108a7b2930$export$9ef95f2bba3e6c4d = (hostInfo)=>$3e1893108a7b2930$var$_objectSpread($3e1893108a7b2930$var$_objectSpread($3e1893108a7b2930$var$_objectSpread({
        product: '',
        baseUrl: ''
    }, hostInfo), hostInfo.supports && {
        supports: $3e1893108a7b2930$export$108ec03634d71252(hostInfo.supports)
    }), hostInfo.globalContext && {
        globalContext: $3e1893108a7b2930$export$2d2e2a019c76af3(hostInfo.globalContext)
    });
const $3e1893108a7b2930$export$48a2a4b4b9048dc5 = (spiContext)=>$3e1893108a7b2930$export$2d2e2a019c76af3({
        id: spiContext.id,
        icon: spiContext.icon,
        name: spiContext.name,
        type: spiContext.type,
        orgId: spiContext.orgId,
        workspaceAri: spiContext.workspaceAri
    });

});

parcelRegister("bSQ4o", function(module, exports) {

$parcel$export(module.exports, "getCloudIdFromHostInfo", () => $8a6d20d73e192b2c$export$f4cda0c22bc54682);

var $lLYAL = parcelRequire("lLYAL");
const $8a6d20d73e192b2c$export$f4cda0c22bc54682 = (hostInfo)=>{
    if (hostInfo) return (0, $lLYAL.parse)(hostInfo.globalContext.id).cloudId;
};

});

parcelRegister("55gtq", function(module, exports) {

$parcel$export(module.exports, "initSPI", () => $3b3a32b16add3d34$export$f5ac63195542f1d4);
$parcel$export(module.exports, "default", () => $3b3a32b16add3d34$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $fUOHe = parcelRequire("fUOHe");

var $f6dG7 = parcelRequire("f6dG7");

var $33x9K = parcelRequire("33x9K");
function $3b3a32b16add3d34$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b3a32b16add3d34$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b3a32b16add3d34$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b3a32b16add3d34$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
let $3b3a32b16add3d34$var$InternalSPI;
function $3b3a32b16add3d34$var$instrumentFn(methodName, successful, duration) {
    (0, $fUOHe.default).task({
        task: (0, $f6dG7.LABEL_CAAS_SPI_METHOD_EXECUTION),
        taskId: methodName,
        successful: successful,
        duration: duration
    });
}
function $3b3a32b16add3d34$var$wrapObjectOfFunctions(stringToFunctionMap) {
    return Object.keys(stringToFunctionMap).reduce((acc, k)=>$3b3a32b16add3d34$var$_objectSpread($3b3a32b16add3d34$var$_objectSpread({}, acc), {}, {
            [k]: (0, $33x9K.instrumentAsync)(stringToFunctionMap[k], $3b3a32b16add3d34$var$instrumentFn, k)
        }), {});
}
function $3b3a32b16add3d34$var$wrapIfPresent(stringToFunctionMap) {
    if (stringToFunctionMap) return $3b3a32b16add3d34$var$wrapObjectOfFunctions(stringToFunctionMap);
    else throw new Error('Unable to find SPI.');
}
function $3b3a32b16add3d34$export$b0f0114b07655e4c() {
    $3b3a32b16add3d34$var$InternalSPI = undefined;
}
function $3b3a32b16add3d34$export$f5ac63195542f1d4(spi) {
    if ($3b3a32b16add3d34$var$InternalSPI) return $3b3a32b16add3d34$var$InternalSPI;
    $3b3a32b16add3d34$var$InternalSPI = $3b3a32b16add3d34$var$wrapIfPresent(spi);
    // For use in pollinator tests
    window.__EMCEE__SPI__ = $3b3a32b16add3d34$var$InternalSPI;
    return $3b3a32b16add3d34$var$InternalSPI;
}
const $3b3a32b16add3d34$var$getSPI = ()=>{
    if ($3b3a32b16add3d34$var$InternalSPI) return $3b3a32b16add3d34$var$InternalSPI;
    else throw new Error('getSPI called before the SPI initializing the SPI using initSPI');
};
var $3b3a32b16add3d34$export$2e2bcd8739ae039 = $3b3a32b16add3d34$var$getSPI;

});
parcelRegister("f6dG7", function(module, exports) {

$parcel$export(module.exports, "LABEL_CAAS_SPI_METHOD_EXECUTION", () => $02d639ea7ac2fa54$export$1473baf6b30e691f);
/**
 * The different tasks (SLI) we track for our SLOs. Each task may have success, error or performance
 * measurements associated with it.
 */ const $02d639ea7ac2fa54$export$cfc9f501e2dafa5 = Object.freeze({
    ViewAppsList: 'view-apps-list'
});
const $02d639ea7ac2fa54$export$1473baf6b30e691f = 'caas-spi-execution';

});

parcelRegister("33x9K", function(module, exports) {

$parcel$export(module.exports, "instrumentAsync", () => $239b5f057b453ebb$export$2194fbfc0b60415d);
/**
 * Instruments a promise returning function,
 * returning time take to execute and success / failure
 */ function $239b5f057b453ebb$export$2194fbfc0b60415d(task, measurementFn, taskName) {
    return function() {
        const start = performance.now();
        let isSuccess = false;
        return task(...arguments).then((results)=>{
            isSuccess = true;
            return results;
        }, (error)=>{
            isSuccess = false;
            throw error;
        }).finally(()=>{
            if (Array.isArray(measurementFn)) measurementFn.forEach((fn)=>fn(taskName, isSuccess, performance.now() - start));
            else measurementFn(taskName, isSuccess, performance.now() - start);
        });
    };
}

});



parcelRegister("j8dgx", function(module, exports) {

$parcel$export(module.exports, "FETCH_CONTEXTS", () => $ded90df627e1beb3$export$53fdb27b3deee9d1);
$parcel$export(module.exports, "RECEIVE_CONTEXTS", () => $ded90df627e1beb3$export$404748ece01b306);
$parcel$export(module.exports, "RECEIVE_DATA_ERROR", () => $ded90df627e1beb3$export$b227c841f9121c9b);
$parcel$export(module.exports, "CHANGE_CONTEXT", () => $ded90df627e1beb3$export$7d5ec91ee5378951);
$parcel$export(module.exports, "changeContext", () => $ded90df627e1beb3$export$ed42c550cf0eec01);
$parcel$export(module.exports, "doRetrieveContexts", () => $ded90df627e1beb3$export$b1484c3141a97679);
$parcel$export(module.exports, "doRetrieveDefaultContext", () => $ded90df627e1beb3$export$af978e618864e986);

var $7hgtR = parcelRequire("7hgtR");

var $lLYAL = parcelRequire("lLYAL");

var $bTrQR = parcelRequire("bTrQR");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $kC116 = parcelRequire("kC116");

var $55gtq = parcelRequire("55gtq");

var $hsaiM = parcelRequire("hsaiM");
const $ded90df627e1beb3$export$53fdb27b3deee9d1 = 'CONTEXTS_FETCH';
const $ded90df627e1beb3$export$404748ece01b306 = 'CONTEXTS_RECEIVE';
const $ded90df627e1beb3$export$b227c841f9121c9b = 'CONTEXTS_RECEIVE_DATA_ERROR';
const $ded90df627e1beb3$export$7d5ec91ee5378951 = 'CONTEXTS_CHANGE_CONTEXT';
function $ded90df627e1beb3$var$fetchContexts(_ref) {
    let { contextSearchId: contextSearchId } = _ref;
    return {
        type: $ded90df627e1beb3$export$53fdb27b3deee9d1,
        contextSearchId: contextSearchId
    };
}
function $ded90df627e1beb3$var$receiveContexts(_ref2) {
    let { contexts: contexts, contextSearchId: contextSearchId } = _ref2;
    return {
        type: $ded90df627e1beb3$export$404748ece01b306,
        contextSearchId: contextSearchId,
        contexts: contexts
    };
}
function $ded90df627e1beb3$export$ed42c550cf0eec01(selectedContext) {
    return {
        type: $ded90df627e1beb3$export$7d5ec91ee5378951,
        selectedContext: selectedContext
    };
}
function $ded90df627e1beb3$export$2930e401632dd369(dataErrorMessages) {
    return {
        type: $ded90df627e1beb3$export$b227c841f9121c9b,
        dataErrorMessages: dataErrorMessages
    };
}
function $ded90df627e1beb3$export$b1484c3141a97679(filter) {
    return (dispatch)=>{
        const contextSearchId = (0, $hsaiM.getRequestId)();
        dispatch($ded90df627e1beb3$var$fetchContexts({
            contextSearchId: contextSearchId
        }));
        (0, $55gtq.default)().getContexts({
            query: {
                search: filter,
                limit: 20
            }
        }).then((paginatedContexts)=>{
            const contexts = (0, $g5DHJ.List)(paginatedContexts.values).map((0, $kC116.makeContextFromSPIContext));
            dispatch($ded90df627e1beb3$var$receiveContexts({
                contexts: contexts,
                contextSearchId: contextSearchId
            }));
        }).catch((error)=>{
            dispatch($ded90df627e1beb3$export$2930e401632dd369((0, $7hgtR.makeDataErrorMessages)([
                error
            ])));
            console.error('getContexts was rejected by the SPI and returned the following error:', error);
        });
    };
}
function $ded90df627e1beb3$export$af978e618864e986() {
    return (dispatch)=>{
        (0, $55gtq.default)().getMostRecentContext().then((0, $bWAru.Option).of).then((oc)=>{
            oc.filter((spiContext)=>{
                const parsedContextId = (0, $lLYAL.parse)(spiContext.id);
                // We only accommodate for non-global contexts for now. The global context has no resourceId
                return !!parsedContextId.resourceId;
            }).map((spiContext)=>{
                dispatch($ded90df627e1beb3$export$ed42c550cf0eec01((0, $kC116.makeContextFromSPIContext)(spiContext)));
            });
        }).catch((error)=>{
            (0, $bTrQR.default).error('actions/Contexts', "'getMostRecentContext was rejected by the SPI and returned the following error", {
                error: error
            });
        });
    };
}

});
parcelRegister("hsaiM", function(module, exports) {

$parcel$export(module.exports, "getRequestId", () => $cb4d0af07cec0c15$export$710171574ebc9a51);
$parcel$export(module.exports, "getErrorDetails", () => $cb4d0af07cec0c15$export$33e83b6fee5d732d);

var $bH0OB = parcelRequire("bH0OB");
function $cb4d0af07cec0c15$export$710171574ebc9a51() {
    return Math.floor(Date.now() / Math.random());
}
function $cb4d0af07cec0c15$export$33e83b6fee5d732d(error, hostConfig, featureFlags) {
    const defaultConfig = hostConfig.errors.get('default');
    if (!defaultConfig) throw new Error('No default config for error messages specified');
    try {
        if (typeof error === 'string') {
            let translatedError;
            if (featureFlags.showCustomBackendErrorsFromUpm) {
                const err = hostConfig.errors.get(error) || defaultConfig;
                return (0, $bH0OB.makeErrorDetails)({
                    translation: err.set('showTID', false),
                    tid: err.tid,
                    type: err.type
                });
            } else {
                const messageJSON = JSON.parse(error);
                translatedError = hostConfig.errors.get(messageJSON.type) || defaultConfig;
                return (0, $bH0OB.makeErrorDetails)({
                    translation: translatedError,
                    tid: messageJSON.tid || 'None',
                    type: messageJSON.type || 'None'
                });
            }
        } else {
            const translatedError = defaultConfig.set('description', error.errorMessage).set('showTID', false);
            return (0, $bH0OB.makeErrorDetails)({
                translation: translatedError,
                tid: 'None',
                type: 'None'
            });
        }
    } catch (_unused) {
        return (0, $bH0OB.makeErrorDetails)({
            translation: defaultConfig.set('showTID', false)
        });
    }
}

});
parcelRegister("bH0OB", function(module, exports) {

$parcel$export(module.exports, "makeErrorDetails", () => $883457b9ef8c9812$export$5db1c49bc5885c4c);

var $g5DHJ = parcelRequire("g5DHJ");

var $bdw66 = parcelRequire("bdw66");
const $883457b9ef8c9812$export$5db1c49bc5885c4c = (0, $g5DHJ.Record)({
    translation: (0, $bdw66.makeErrorTranslation)(),
    tid: undefined,
    type: undefined
});

});



parcelRegister("7hvno", function(module, exports) {

$parcel$export(module.exports, "FETCH_HOST_PRICING", () => $54d2759a905cc167$export$499c3123a5cea5de);
$parcel$export(module.exports, "RECEIVE_HOST_PRICING", () => $54d2759a905cc167$export$2858bdd36b6d6982);
$parcel$export(module.exports, "RECEIVE_HOST_PRICING_ERROR", () => $54d2759a905cc167$export$2a5ca030a0f50662);
$parcel$export(module.exports, "doRetrieveHostPricing", () => $54d2759a905cc167$export$e33c223e2538d794);

var $bTrQR = parcelRequire("bTrQR");

var $55gtq = parcelRequire("55gtq");
const $54d2759a905cc167$export$499c3123a5cea5de = 'HOST_PRICING_FETCH_HOST_PRICING';
const $54d2759a905cc167$export$2858bdd36b6d6982 = 'HOST_PRICING_RECEIVE_HOST_PRICING';
const $54d2759a905cc167$export$2a5ca030a0f50662 = 'HOST_PRICING_RECEIVE_HOST_PRICING_ERROR';
const $54d2759a905cc167$var$fetchHostPricing = ()=>({
        type: $54d2759a905cc167$export$499c3123a5cea5de
    });
const $54d2759a905cc167$var$receiveHostPricing = (_ref)=>{
    let { hostPricing: hostPricing } = _ref;
    return {
        type: $54d2759a905cc167$export$2858bdd36b6d6982,
        hostPricing: hostPricing
    };
};
const $54d2759a905cc167$var$receiveHostPricingError = (_ref2)=>{
    let { error: error } = _ref2;
    return {
        type: $54d2759a905cc167$export$2a5ca030a0f50662,
        error: error
    };
};
const $54d2759a905cc167$export$e33c223e2538d794 = ()=>(dispatch)=>{
        dispatch($54d2759a905cc167$var$fetchHostPricing());
        if (!(0, $55gtq.default)().getHostPricingInfo) return;
        (0, $55gtq.default)().getHostPricingInfo().then((hostPricingInformation)=>{
            dispatch($54d2759a905cc167$var$receiveHostPricing({
                hostPricing: hostPricingInformation
            }));
        }, (error)=>{
            (0, $bTrQR.default).error('HostPricing', "failed to retrieve host pricing : ".concat(error));
            dispatch($54d2759a905cc167$var$receiveHostPricingError({
                error: error
            }));
        });
    };

});

parcelRegister("ae44r", function(module, exports) {

$parcel$export(module.exports, "FETCH_SCOPES_LOOKUP", () => $771e5e8d35e725e9$export$9f6dce3b053fc85c);
$parcel$export(module.exports, "RECEIVE_SCOPES_LOOKUP", () => $771e5e8d35e725e9$export$f5fdf49575516820);
$parcel$export(module.exports, "RECEIVE_SCOPES_LOOKUP_ERROR", () => $771e5e8d35e725e9$export$5f3e646c61ff258a);
$parcel$export(module.exports, "doRetrieveScopesLookup", () => $771e5e8d35e725e9$export$a8852ebbdc2658a7);

var $7hgtR = parcelRequire("7hgtR");

var $kIWPJ = parcelRequire("kIWPJ");
const $771e5e8d35e725e9$export$9f6dce3b053fc85c = 'SCOPES_FETCH_SCOPES_LOOKUP';
const $771e5e8d35e725e9$export$f5fdf49575516820 = 'SCOPES_RECEIVE_SCOPES_LOOKUP';
const $771e5e8d35e725e9$export$5f3e646c61ff258a = 'SCOPES_RECEIVE_SCOPES_LOOKUP_ERROR';
const $771e5e8d35e725e9$var$fetchScopesLookup = ()=>({
        type: $771e5e8d35e725e9$export$9f6dce3b053fc85c
    });
const $771e5e8d35e725e9$var$receiveScopesLookup = (_ref)=>{
    let { scopesLookup: scopesLookup } = _ref;
    return {
        type: $771e5e8d35e725e9$export$f5fdf49575516820,
        scopesLookup: scopesLookup
    };
};
const $771e5e8d35e725e9$var$receiveScopesLookupError = (_ref2)=>{
    let { dataErrorMessages: dataErrorMessages } = _ref2;
    return {
        type: $771e5e8d35e725e9$export$5f3e646c61ff258a,
        dataErrorMessages: dataErrorMessages
    };
};
const $771e5e8d35e725e9$export$a8852ebbdc2658a7 = (_ref3)=>{
    let { bootstrapConfig: bootstrapConfig } = _ref3;
    return (dispatch)=>{
        dispatch($771e5e8d35e725e9$var$fetchScopesLookup());
        (0, $kIWPJ.getScopesLookup)(bootstrapConfig.graphQLGatewayUrl).then((scopesLookup)=>{
            dispatch($771e5e8d35e725e9$var$receiveScopesLookup({
                scopesLookup: scopesLookup
            }));
        }, (error)=>{
            dispatch($771e5e8d35e725e9$var$receiveScopesLookupError({
                dataErrorMessages: (0, $7hgtR.makeDataErrorMessages)('status' in error ? [
                    error.status.toString()
                ] : [
                    error.message
                ])
            }));
        });
    };
};

});
parcelRegister("kIWPJ", function(module, exports) {

$parcel$export(module.exports, "getScopesLookup", () => $f1658dc93697b863$export$2f8049ed764783d2);

var $9D4R7 = parcelRequire("9D4R7");

var $8kbfx = parcelRequire("8kbfx");

var $bTrQR = parcelRequire("bTrQR");

var $g5DHJ = parcelRequire("g5DHJ");
var $f1658dc93697b863$var$GetScopes = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetScopes"
            },
            variableDefinitions: [],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appHostServices"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "scopes"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "Scope"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "Scope"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AppHostServiceScope"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "key"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "description"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 349,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nquery GetScopes {\n  appHostServices {\n    scopes {\n      ...Scope\n    }\n  }\n}\n\nfragment Scope on AppHostServiceScope {\n  key\n  name\n  description\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
const $f1658dc93697b863$export$2f8049ed764783d2 = async (gqlGatewayUrl)=>{
    try {
        var _data$appHostServices;
        const { data: data, errors: errors } = await (0, $9D4R7.graphQLRequest)(gqlGatewayUrl, {
            query: $f1658dc93697b863$var$GetScopes
        });
        if (errors !== null && errors !== void 0 && errors.length) throw new Error(errors[0].message);
        const allScopes = (data === null || data === void 0 ? void 0 : (_data$appHostServices = data.appHostServices) === null || _data$appHostServices === void 0 ? void 0 : _data$appHostServices.reduce((scopes, appHostService)=>appHostService.scopes ? [
                ...scopes,
                ...appHostService.scopes
            ] : scopes, [])) || [];
        return (0, $g5DHJ.Map)(allScopes === null || allScopes === void 0 ? void 0 : allScopes.map((obj)=>[
                (0, $8kbfx.makeScopeKey)(obj.key),
                (0, $8kbfx.makeMarketplaceScope)(obj)
            ]));
    } catch (error) {
        // TODO: Filtering by 401 should be removed once root cause for MC-2004 is found
        if (error.status !== 401) (0, $bTrQR.default).error('mpac-api-client/getScopesLookup', "Failed to retrieve scopes lookup", {
            error: error,
            extraInfo: {
                userAgent: navigator.userAgent
            }
        });
        throw error;
    }
};

});
parcelRegister("9D4R7", function(module, exports) {

$parcel$export(module.exports, "graphQLRequest", () => $702b85d6a08ca5eb$export$9f788458b7bdb55f);

var $2dcSO = parcelRequire("2dcSO");

var $dO8LH = parcelRequire("dO8LH");
const $702b85d6a08ca5eb$export$9f788458b7bdb55f = async (url, request)=>{
    const { query: document, variables: variables = null, operationName: operationName } = request;
    const fetchResponse = await (0, $dO8LH.fetchOk)(url, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
        },
        body: JSON.stringify({
            operationName: operationName,
            query: (0, $2dcSO.print)(document),
            variables: variables
        })
    });
    const response = await fetchResponse.json();
    return response;
};

});
parcelRegister("2dcSO", function(module, exports) {

$parcel$export(module.exports, "print", () => $cced06396f774aa1$export$c2d084dc44961371);

var $30Dau = parcelRequire("30Dau");

var $79FAh = parcelRequire("79FAh");

var $kQCsj = parcelRequire("kQCsj");
function $cced06396f774aa1$export$c2d084dc44961371(ast) {
    return (0, $kQCsj.visit)(ast, $cced06396f774aa1$var$printDocASTReducer);
}
const $cced06396f774aa1$var$MAX_LINE_LENGTH = 80;
const $cced06396f774aa1$var$printDocASTReducer = {
    Name: {
        leave: (node)=>node.value
    },
    Variable: {
        leave: (node)=>'$' + node.name
    },
    // Document
    Document: {
        leave: (node)=>$cced06396f774aa1$var$join(node.definitions, '\n\n')
    },
    OperationDefinition: {
        leave (node) {
            const varDefs = $cced06396f774aa1$var$wrap('(', $cced06396f774aa1$var$join(node.variableDefinitions, ', '), ')');
            const prefix = $cced06396f774aa1$var$join([
                node.operation,
                $cced06396f774aa1$var$join([
                    node.name,
                    varDefs
                ]),
                $cced06396f774aa1$var$join(node.directives, ' ')
            ], ' '); // Anonymous queries with no directives or variable definitions can use
            // the query short form.
            return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
        }
    },
    VariableDefinition: {
        leave: ({ variable: variable, type: type, defaultValue: defaultValue, directives: directives })=>variable + ': ' + type + $cced06396f774aa1$var$wrap(' = ', defaultValue) + $cced06396f774aa1$var$wrap(' ', $cced06396f774aa1$var$join(directives, ' '))
    },
    SelectionSet: {
        leave: ({ selections: selections })=>$cced06396f774aa1$var$block(selections)
    },
    Field: {
        leave ({ alias: alias, name: name, arguments: args, directives: directives, selectionSet: selectionSet }) {
            const prefix = $cced06396f774aa1$var$wrap('', alias, ': ') + name;
            let argsLine = prefix + $cced06396f774aa1$var$wrap('(', $cced06396f774aa1$var$join(args, ', '), ')');
            if (argsLine.length > $cced06396f774aa1$var$MAX_LINE_LENGTH) argsLine = prefix + $cced06396f774aa1$var$wrap('(\n', $cced06396f774aa1$var$indent($cced06396f774aa1$var$join(args, '\n')), '\n)');
            return $cced06396f774aa1$var$join([
                argsLine,
                $cced06396f774aa1$var$join(directives, ' '),
                selectionSet
            ], ' ');
        }
    },
    Argument: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Fragments
    FragmentSpread: {
        leave: ({ name: name, directives: directives })=>'...' + name + $cced06396f774aa1$var$wrap(' ', $cced06396f774aa1$var$join(directives, ' '))
    },
    InlineFragment: {
        leave: ({ typeCondition: typeCondition, directives: directives, selectionSet: selectionSet })=>$cced06396f774aa1$var$join([
                '...',
                $cced06396f774aa1$var$wrap('on ', typeCondition),
                $cced06396f774aa1$var$join(directives, ' '),
                selectionSet
            ], ' ')
    },
    FragmentDefinition: {
        leave: ({ name: name, typeCondition: typeCondition, variableDefinitions: variableDefinitions, directives: directives, selectionSet: selectionSet })=>// or removed in the future.
            `fragment ${name}${$cced06396f774aa1$var$wrap('(', $cced06396f774aa1$var$join(variableDefinitions, ', '), ')')} ` + `on ${typeCondition} ${$cced06396f774aa1$var$wrap('', $cced06396f774aa1$var$join(directives, ' '), ' ')}` + selectionSet
    },
    // Value
    IntValue: {
        leave: ({ value: value })=>value
    },
    FloatValue: {
        leave: ({ value: value })=>value
    },
    StringValue: {
        leave: ({ value: value, block: isBlockString })=>isBlockString ? (0, $30Dau.printBlockString)(value) : (0, $79FAh.printString)(value)
    },
    BooleanValue: {
        leave: ({ value: value })=>value ? 'true' : 'false'
    },
    NullValue: {
        leave: ()=>'null'
    },
    EnumValue: {
        leave: ({ value: value })=>value
    },
    ListValue: {
        leave: ({ values: values })=>'[' + $cced06396f774aa1$var$join(values, ', ') + ']'
    },
    ObjectValue: {
        leave: ({ fields: fields })=>'{' + $cced06396f774aa1$var$join(fields, ', ') + '}'
    },
    ObjectField: {
        leave: ({ name: name, value: value })=>name + ': ' + value
    },
    // Directive
    Directive: {
        leave: ({ name: name, arguments: args })=>'@' + name + $cced06396f774aa1$var$wrap('(', $cced06396f774aa1$var$join(args, ', '), ')')
    },
    // Type
    NamedType: {
        leave: ({ name: name })=>name
    },
    ListType: {
        leave: ({ type: type })=>'[' + type + ']'
    },
    NonNullType: {
        leave: ({ type: type })=>type + '!'
    },
    // Type System Definitions
    SchemaDefinition: {
        leave: ({ description: description, directives: directives, operationTypes: operationTypes })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                'schema',
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(operationTypes)
            ], ' ')
    },
    OperationTypeDefinition: {
        leave: ({ operation: operation, type: type })=>operation + ': ' + type
    },
    ScalarTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                'scalar',
                name,
                $cced06396f774aa1$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                'type',
                name,
                $cced06396f774aa1$var$wrap('implements ', $cced06396f774aa1$var$join(interfaces, ' & ')),
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(fields)
            ], ' ')
    },
    FieldDefinition: {
        leave: ({ description: description, name: name, arguments: args, type: type, directives: directives })=>$cced06396f774aa1$var$wrap('', description, '\n') + name + ($cced06396f774aa1$var$hasMultilineItems(args) ? $cced06396f774aa1$var$wrap('(\n', $cced06396f774aa1$var$indent($cced06396f774aa1$var$join(args, '\n')), '\n)') : $cced06396f774aa1$var$wrap('(', $cced06396f774aa1$var$join(args, ', '), ')')) + ': ' + type + $cced06396f774aa1$var$wrap(' ', $cced06396f774aa1$var$join(directives, ' '))
    },
    InputValueDefinition: {
        leave: ({ description: description, name: name, type: type, defaultValue: defaultValue, directives: directives })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                name + ': ' + type,
                $cced06396f774aa1$var$wrap('= ', defaultValue),
                $cced06396f774aa1$var$join(directives, ' ')
            ], ' ')
    },
    InterfaceTypeDefinition: {
        leave: ({ description: description, name: name, interfaces: interfaces, directives: directives, fields: fields })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                'interface',
                name,
                $cced06396f774aa1$var$wrap('implements ', $cced06396f774aa1$var$join(interfaces, ' & ')),
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(fields)
            ], ' ')
    },
    UnionTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, types: types })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                'union',
                name,
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$wrap('= ', $cced06396f774aa1$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, values: values })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                'enum',
                name,
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(values)
            ], ' ')
    },
    EnumValueDefinition: {
        leave: ({ description: description, name: name, directives: directives })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                name,
                $cced06396f774aa1$var$join(directives, ' ')
            ], ' ')
    },
    InputObjectTypeDefinition: {
        leave: ({ description: description, name: name, directives: directives, fields: fields })=>$cced06396f774aa1$var$wrap('', description, '\n') + $cced06396f774aa1$var$join([
                'input',
                name,
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(fields)
            ], ' ')
    },
    DirectiveDefinition: {
        leave: ({ description: description, name: name, arguments: args, repeatable: repeatable, locations: locations })=>$cced06396f774aa1$var$wrap('', description, '\n') + 'directive @' + name + ($cced06396f774aa1$var$hasMultilineItems(args) ? $cced06396f774aa1$var$wrap('(\n', $cced06396f774aa1$var$indent($cced06396f774aa1$var$join(args, '\n')), '\n)') : $cced06396f774aa1$var$wrap('(', $cced06396f774aa1$var$join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + $cced06396f774aa1$var$join(locations, ' | ')
    },
    SchemaExtension: {
        leave: ({ directives: directives, operationTypes: operationTypes })=>$cced06396f774aa1$var$join([
                'extend schema',
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(operationTypes)
            ], ' ')
    },
    ScalarTypeExtension: {
        leave: ({ name: name, directives: directives })=>$cced06396f774aa1$var$join([
                'extend scalar',
                name,
                $cced06396f774aa1$var$join(directives, ' ')
            ], ' ')
    },
    ObjectTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$cced06396f774aa1$var$join([
                'extend type',
                name,
                $cced06396f774aa1$var$wrap('implements ', $cced06396f774aa1$var$join(interfaces, ' & ')),
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(fields)
            ], ' ')
    },
    InterfaceTypeExtension: {
        leave: ({ name: name, interfaces: interfaces, directives: directives, fields: fields })=>$cced06396f774aa1$var$join([
                'extend interface',
                name,
                $cced06396f774aa1$var$wrap('implements ', $cced06396f774aa1$var$join(interfaces, ' & ')),
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(fields)
            ], ' ')
    },
    UnionTypeExtension: {
        leave: ({ name: name, directives: directives, types: types })=>$cced06396f774aa1$var$join([
                'extend union',
                name,
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$wrap('= ', $cced06396f774aa1$var$join(types, ' | '))
            ], ' ')
    },
    EnumTypeExtension: {
        leave: ({ name: name, directives: directives, values: values })=>$cced06396f774aa1$var$join([
                'extend enum',
                name,
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(values)
            ], ' ')
    },
    InputObjectTypeExtension: {
        leave: ({ name: name, directives: directives, fields: fields })=>$cced06396f774aa1$var$join([
                'extend input',
                name,
                $cced06396f774aa1$var$join(directives, ' '),
                $cced06396f774aa1$var$block(fields)
            ], ' ')
    }
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */ function $cced06396f774aa1$var$join(maybeArray, separator = '') {
    var _maybeArray$filter$jo;
    return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter((x)=>x).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */ function $cced06396f774aa1$var$block(array) {
    return $cced06396f774aa1$var$wrap('{\n', $cced06396f774aa1$var$indent($cced06396f774aa1$var$join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */ function $cced06396f774aa1$var$wrap(start, maybeString, end = '') {
    return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}
function $cced06396f774aa1$var$indent(str) {
    return $cced06396f774aa1$var$wrap('  ', str.replace(/\n/g, '\n  '));
}
function $cced06396f774aa1$var$hasMultilineItems(maybeArray) {
    var _maybeArray$some;
    // FIXME: https://github.com/graphql/graphql-js/issues/2203
    /* c8 ignore next */ return (_maybeArray$some = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.some((str)=>str.includes('\n'))) !== null && _maybeArray$some !== void 0 ? _maybeArray$some : false;
}

});
parcelRegister("30Dau", function(module, exports) {

$parcel$export(module.exports, "printBlockString", () => $d7cee39935718db8$export$adb6ca997eeb1f45);

var $biARw = parcelRequire("biARw");
function $d7cee39935718db8$export$d5ee19b441e8d2ae(lines) {
    var _firstNonEmptyLine2;
    let commonIndent = Number.MAX_SAFE_INTEGER;
    let firstNonEmptyLine = null;
    let lastNonEmptyLine = -1;
    for(let i = 0; i < lines.length; ++i){
        var _firstNonEmptyLine;
        const line = lines[i];
        const indent = $d7cee39935718db8$var$leadingWhitespace(line);
        if (indent === line.length) continue; // skip empty lines
        firstNonEmptyLine = (_firstNonEmptyLine = firstNonEmptyLine) !== null && _firstNonEmptyLine !== void 0 ? _firstNonEmptyLine : i;
        lastNonEmptyLine = i;
        if (i !== 0 && indent < commonIndent) commonIndent = indent;
    }
    return lines // Remove common indentation from all lines but first.
    .map((line, i)=>i === 0 ? line : line.slice(commonIndent)) // Remove leading and trailing blank lines.
    .slice((_firstNonEmptyLine2 = firstNonEmptyLine) !== null && _firstNonEmptyLine2 !== void 0 ? _firstNonEmptyLine2 : 0, lastNonEmptyLine + 1);
}
function $d7cee39935718db8$var$leadingWhitespace(str) {
    let i = 0;
    while(i < str.length && (0, $biARw.isWhiteSpace)(str.charCodeAt(i)))++i;
    return i;
}
function $d7cee39935718db8$export$40862a63ef85e395(value) {
    if (value === '') return true; // empty string is printable
    let isEmptyLine = true;
    let hasIndent = false;
    let hasCommonIndent = true;
    let seenNonEmptyLine = false;
    for(let i = 0; i < value.length; ++i)switch(value.codePointAt(i)){
        case 0x0000:
        case 0x0001:
        case 0x0002:
        case 0x0003:
        case 0x0004:
        case 0x0005:
        case 0x0006:
        case 0x0007:
        case 0x0008:
        case 0x000b:
        case 0x000c:
        case 0x000e:
        case 0x000f:
            return false;
        // Has non-printable characters
        case 0x000d:
            //  \r
            return false;
        // Has \r or \r\n which will be replaced as \n
        case 10:
            //  \n
            if (isEmptyLine && !seenNonEmptyLine) return false; // Has leading new line
            seenNonEmptyLine = true;
            isEmptyLine = true;
            hasIndent = false;
            break;
        case 9:
        case 32:
            //  <space>
            hasIndent || (hasIndent = isEmptyLine);
            break;
        default:
            hasCommonIndent && (hasCommonIndent = hasIndent);
            isEmptyLine = false;
    }
    if (isEmptyLine) return false; // Has trailing empty lines
    if (hasCommonIndent && seenNonEmptyLine) return false; // Has internal indent
    return true;
}
function $d7cee39935718db8$export$adb6ca997eeb1f45(value, options) {
    const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.
    const lines = escapedValue.split(/\r\n|[\n\r]/g);
    const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line
    const forceLeadingNewLine = lines.length > 1 && lines.slice(1).every((line)=>line.length === 0 || (0, $biARw.isWhiteSpace)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line
    const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line
    const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
    const hasTrailingSlash = value.endsWith('\\');
    const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
    const printAsMultipleLines = !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine || value.length > 70 || forceTrailingNewline || forceLeadingNewLine || hasTrailingTripleQuotes);
    let result = ''; // Format a multi-line block quote to account for leading space.
    const skipLeadingNewLine = isSingleLine && (0, $biARw.isWhiteSpace)(value.charCodeAt(0));
    if (printAsMultipleLines && !skipLeadingNewLine || forceLeadingNewLine) result += '\n';
    result += escapedValue;
    if (printAsMultipleLines || forceTrailingNewline) result += '\n';
    return '"""' + result + '"""';
}

});
parcelRegister("biARw", function(module, exports) {

$parcel$export(module.exports, "isWhiteSpace", () => $057505f4cb27f3a7$export$3c52dd84024ae72c);
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */ function $057505f4cb27f3a7$export$3c52dd84024ae72c(code) {
    return code === 0x0009 || code === 0x0020;
}
function $057505f4cb27f3a7$export$727d9dbc4fbb948f(code) {
    return code >= 0x0030 && code <= 0x0039;
}
function $057505f4cb27f3a7$export$79c5d5217943d6a7(code) {
    return code >= 0x0061 && code <= 0x007a || // A-Z
    code >= 0x0041 && code <= 0x005a // a-z
    ;
}
function $057505f4cb27f3a7$export$45a677ea7cb6d5c8(code) {
    return $057505f4cb27f3a7$export$79c5d5217943d6a7(code) || code === 0x005f;
}
function $057505f4cb27f3a7$export$d3f406ff46035894(code) {
    return $057505f4cb27f3a7$export$79c5d5217943d6a7(code) || $057505f4cb27f3a7$export$727d9dbc4fbb948f(code) || code === 0x005f;
}

});


parcelRegister("79FAh", function(module, exports) {

$parcel$export(module.exports, "printString", () => $1206b9d640b5a6c1$export$3cdec7cf614a0ecc);
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */ function $1206b9d640b5a6c1$export$3cdec7cf614a0ecc(str) {
    return `"${str.replace($1206b9d640b5a6c1$var$escapedRegExp, $1206b9d640b5a6c1$var$escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex
const $1206b9d640b5a6c1$var$escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function $1206b9d640b5a6c1$var$escapedReplacer(str) {
    return $1206b9d640b5a6c1$var$escapeSequences[str.charCodeAt(0)];
} // prettier-ignore
const $1206b9d640b5a6c1$var$escapeSequences = [
    '\\u0000',
    '\\u0001',
    '\\u0002',
    '\\u0003',
    '\\u0004',
    '\\u0005',
    '\\u0006',
    '\\u0007',
    '\\b',
    '\\t',
    '\\n',
    '\\u000B',
    '\\f',
    '\\r',
    '\\u000E',
    '\\u000F',
    '\\u0010',
    '\\u0011',
    '\\u0012',
    '\\u0013',
    '\\u0014',
    '\\u0015',
    '\\u0016',
    '\\u0017',
    '\\u0018',
    '\\u0019',
    '\\u001A',
    '\\u001B',
    '\\u001C',
    '\\u001D',
    '\\u001E',
    '\\u001F',
    '',
    '',
    '\\"',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\\\',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '\\u007F',
    '\\u0080',
    '\\u0081',
    '\\u0082',
    '\\u0083',
    '\\u0084',
    '\\u0085',
    '\\u0086',
    '\\u0087',
    '\\u0088',
    '\\u0089',
    '\\u008A',
    '\\u008B',
    '\\u008C',
    '\\u008D',
    '\\u008E',
    '\\u008F',
    '\\u0090',
    '\\u0091',
    '\\u0092',
    '\\u0093',
    '\\u0094',
    '\\u0095',
    '\\u0096',
    '\\u0097',
    '\\u0098',
    '\\u0099',
    '\\u009A',
    '\\u009B',
    '\\u009C',
    '\\u009D',
    '\\u009E',
    '\\u009F'
];

});

parcelRegister("kQCsj", function(module, exports) {

$parcel$export(module.exports, "visit", () => $36a41cb221910af4$export$bf638b60ea8b89b7);

var $9BlDI = parcelRequire("9BlDI");

var $cvyFm = parcelRequire("cvyFm");

var $aCPwB = parcelRequire("aCPwB");

var $3OxC3 = parcelRequire("3OxC3");
const $36a41cb221910af4$export$a89c95c098ac2a58 = Object.freeze({});
function $36a41cb221910af4$export$bf638b60ea8b89b7(root, visitor, visitorKeys = (0, $aCPwB.QueryDocumentKeys)) {
    const enterLeaveMap = new Map();
    for (const kind of Object.values((0, $3OxC3.Kind)))enterLeaveMap.set(kind, $36a41cb221910af4$export$736de8489257458(visitor, kind));
    /* eslint-disable no-undef-init */ let stack = undefined;
    let inArray = Array.isArray(root);
    let keys = [
        root
    ];
    let index = -1;
    let edits = [];
    let node = root;
    let key = undefined;
    let parent = undefined;
    const path = [];
    const ancestors = [];
    /* eslint-enable no-undef-init */ do {
        index++;
        const isLeaving = index === keys.length;
        const isEdited = isLeaving && edits.length !== 0;
        if (isLeaving) {
            key = ancestors.length === 0 ? undefined : path[path.length - 1];
            node = parent;
            parent = ancestors.pop();
            if (isEdited) {
                if (inArray) {
                    node = node.slice();
                    let editOffset = 0;
                    for (const [editKey, editValue] of edits){
                        const arrayKey = editKey - editOffset;
                        if (editValue === null) {
                            node.splice(arrayKey, 1);
                            editOffset++;
                        } else node[arrayKey] = editValue;
                    }
                } else {
                    node = Object.defineProperties({}, Object.getOwnPropertyDescriptors(node));
                    for (const [editKey, editValue] of edits)node[editKey] = editValue;
                }
            }
            index = stack.index;
            keys = stack.keys;
            edits = stack.edits;
            inArray = stack.inArray;
            stack = stack.prev;
        } else if (parent) {
            key = inArray ? index : keys[index];
            node = parent[key];
            if (node === null || node === undefined) continue;
            path.push(key);
        }
        let result;
        if (!Array.isArray(node)) {
            var _enterLeaveMap$get, _enterLeaveMap$get2;
            (0, $aCPwB.isNode)(node) || (0, $9BlDI.devAssert)(false, `Invalid AST Node: ${(0, $cvyFm.inspect)(node)}.`);
            const visitFn = isLeaving ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get === void 0 ? void 0 : _enterLeaveMap$get.leave : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null || _enterLeaveMap$get2 === void 0 ? void 0 : _enterLeaveMap$get2.enter;
            result = visitFn === null || visitFn === void 0 ? void 0 : visitFn.call(visitor, node, key, parent, path, ancestors);
            if (result === $36a41cb221910af4$export$a89c95c098ac2a58) break;
            if (result === false) {
                if (!isLeaving) {
                    path.pop();
                    continue;
                }
            } else if (result !== undefined) {
                edits.push([
                    key,
                    result
                ]);
                if (!isLeaving) {
                    if ((0, $aCPwB.isNode)(result)) node = result;
                    else {
                        path.pop();
                        continue;
                    }
                }
            }
        }
        if (result === undefined && isEdited) edits.push([
            key,
            node
        ]);
        if (isLeaving) path.pop();
        else {
            var _node$kind;
            stack = {
                inArray: inArray,
                index: index,
                keys: keys,
                edits: edits,
                prev: stack
            };
            inArray = Array.isArray(node);
            keys = inArray ? node : (_node$kind = visitorKeys[node.kind]) !== null && _node$kind !== void 0 ? _node$kind : [];
            index = -1;
            edits = [];
            if (parent) ancestors.push(parent);
            parent = node;
        }
    }while (stack !== undefined);
    if (edits.length !== 0) // New root
    return edits[edits.length - 1][1];
    return root;
}
function $36a41cb221910af4$export$728beebeea393478(visitors) {
    const skipping = new Array(visitors.length).fill(null);
    const mergedVisitor = Object.create(null);
    for (const kind of Object.values((0, $3OxC3.Kind))){
        let hasVisitor = false;
        const enterList = new Array(visitors.length).fill(undefined);
        const leaveList = new Array(visitors.length).fill(undefined);
        for(let i = 0; i < visitors.length; ++i){
            const { enter: enter, leave: leave } = $36a41cb221910af4$export$736de8489257458(visitors[i], kind);
            hasVisitor || (hasVisitor = enter != null || leave != null);
            enterList[i] = enter;
            leaveList[i] = leave;
        }
        if (!hasVisitor) continue;
        const mergedEnterLeave = {
            enter (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++)if (skipping[i] === null) {
                    var _enterList$i;
                    const result = (_enterList$i = enterList[i]) === null || _enterList$i === void 0 ? void 0 : _enterList$i.apply(visitors[i], args);
                    if (result === false) skipping[i] = node;
                    else if (result === $36a41cb221910af4$export$a89c95c098ac2a58) skipping[i] = $36a41cb221910af4$export$a89c95c098ac2a58;
                    else if (result !== undefined) return result;
                }
            },
            leave (...args) {
                const node = args[0];
                for(let i = 0; i < visitors.length; i++){
                    if (skipping[i] === null) {
                        var _leaveList$i;
                        const result = (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0 ? void 0 : _leaveList$i.apply(visitors[i], args);
                        if (result === $36a41cb221910af4$export$a89c95c098ac2a58) skipping[i] = $36a41cb221910af4$export$a89c95c098ac2a58;
                        else if (result !== undefined && result !== false) return result;
                    } else if (skipping[i] === node) skipping[i] = null;
                }
            }
        };
        mergedVisitor[kind] = mergedEnterLeave;
    }
    return mergedVisitor;
}
function $36a41cb221910af4$export$736de8489257458(visitor, kind) {
    const kindVisitor = visitor[kind];
    if (typeof kindVisitor === 'object') // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
    else if (typeof kindVisitor === 'function') // { Kind() {} }
    return {
        enter: kindVisitor,
        leave: undefined
    };
     // { enter() {}, leave() {} }
    return {
        enter: visitor.enter,
        leave: visitor.leave
    };
}
function $36a41cb221910af4$export$c9c25cca74db6e70(visitor, kind, isLeaving) {
    const { enter: enter, leave: leave } = $36a41cb221910af4$export$736de8489257458(visitor, kind);
    return isLeaving ? leave : enter;
}

});
parcelRegister("9BlDI", function(module, exports) {

$parcel$export(module.exports, "devAssert", () => $c362a2ae8c1900ae$export$b6cb5906f04696c8);
function $c362a2ae8c1900ae$export$b6cb5906f04696c8(condition, message) {
    const booleanCondition = Boolean(condition);
    if (!booleanCondition) throw new Error(message);
}

});

parcelRegister("cvyFm", function(module, exports) {

$parcel$export(module.exports, "inspect", () => $5bf42893c74e38e6$export$9dec5d1b3b6a130d);
const $5bf42893c74e38e6$var$MAX_ARRAY_LENGTH = 10;
const $5bf42893c74e38e6$var$MAX_RECURSIVE_DEPTH = 2;
function $5bf42893c74e38e6$export$9dec5d1b3b6a130d(value) {
    return $5bf42893c74e38e6$var$formatValue(value, []);
}
function $5bf42893c74e38e6$var$formatValue(value, seenValues) {
    switch(typeof value){
        case 'string':
            return JSON.stringify(value);
        case 'function':
            return value.name ? `[function ${value.name}]` : '[function]';
        case 'object':
            return $5bf42893c74e38e6$var$formatObjectValue(value, seenValues);
        default:
            return String(value);
    }
}
function $5bf42893c74e38e6$var$formatObjectValue(value, previouslySeenValues) {
    if (value === null) return 'null';
    if (previouslySeenValues.includes(value)) return '[Circular]';
    const seenValues = [
        ...previouslySeenValues,
        value
    ];
    if ($5bf42893c74e38e6$var$isJSONable(value)) {
        const jsonValue = value.toJSON(); // check for infinite recursion
        if (jsonValue !== value) return typeof jsonValue === 'string' ? jsonValue : $5bf42893c74e38e6$var$formatValue(jsonValue, seenValues);
    } else if (Array.isArray(value)) return $5bf42893c74e38e6$var$formatArray(value, seenValues);
    return $5bf42893c74e38e6$var$formatObject(value, seenValues);
}
function $5bf42893c74e38e6$var$isJSONable(value) {
    return typeof value.toJSON === 'function';
}
function $5bf42893c74e38e6$var$formatObject(object, seenValues) {
    const entries = Object.entries(object);
    if (entries.length === 0) return '{}';
    if (seenValues.length > $5bf42893c74e38e6$var$MAX_RECURSIVE_DEPTH) return '[' + $5bf42893c74e38e6$var$getObjectTag(object) + ']';
    const properties = entries.map(([key, value])=>key + ': ' + $5bf42893c74e38e6$var$formatValue(value, seenValues));
    return '{ ' + properties.join(', ') + ' }';
}
function $5bf42893c74e38e6$var$formatArray(array, seenValues) {
    if (array.length === 0) return '[]';
    if (seenValues.length > $5bf42893c74e38e6$var$MAX_RECURSIVE_DEPTH) return '[Array]';
    const len = Math.min($5bf42893c74e38e6$var$MAX_ARRAY_LENGTH, array.length);
    const remaining = array.length - len;
    const items = [];
    for(let i = 0; i < len; ++i)items.push($5bf42893c74e38e6$var$formatValue(array[i], seenValues));
    if (remaining === 1) items.push('... 1 more item');
    else if (remaining > 1) items.push(`... ${remaining} more items`);
    return '[' + items.join(', ') + ']';
}
function $5bf42893c74e38e6$var$getObjectTag(object) {
    const tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');
    if (tag === 'Object' && typeof object.constructor === 'function') {
        const name = object.constructor.name;
        if (typeof name === 'string' && name !== '') return name;
    }
    return tag;
}

});

parcelRegister("aCPwB", function(module, exports) {

$parcel$export(module.exports, "QueryDocumentKeys", () => $9e7f6daba17e7622$export$4fcd777a40ccf407);
$parcel$export(module.exports, "isNode", () => $9e7f6daba17e7622$export$8ee0fc9ee280b4ee);
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */ class $9e7f6daba17e7622$export$18a2be9195644f38 {
    /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The Token at which this Node begins.
   */ /**
   * The Token at which this Node ends.
   */ /**
   * The Source document the AST represents.
   */ constructor(startToken, endToken, source){
        this.start = startToken.start;
        this.end = endToken.end;
        this.startToken = startToken;
        this.endToken = endToken;
        this.source = source;
    }
    get [Symbol.toStringTag]() {
        return 'Location';
    }
    toJSON() {
        return {
            start: this.start,
            end: this.end
        };
    }
}
class $9e7f6daba17e7622$export$50792b0e93539fde {
    /**
   * The kind of Token.
   */ /**
   * The character offset at which this Node begins.
   */ /**
   * The character offset at which this Node ends.
   */ /**
   * The 1-indexed line number on which this Token appears.
   */ /**
   * The 1-indexed column number at which this Token begins.
   */ /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */ /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */ constructor(kind, start, end, line, column, value){
        this.kind = kind;
        this.start = start;
        this.end = end;
        this.line = line;
        this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.value = value;
        this.prev = null;
        this.next = null;
    }
    get [Symbol.toStringTag]() {
        return 'Token';
    }
    toJSON() {
        return {
            kind: this.kind,
            value: this.value,
            line: this.line,
            column: this.column
        };
    }
}
const $9e7f6daba17e7622$export$4fcd777a40ccf407 = {
    Name: [],
    Document: [
        'definitions'
    ],
    OperationDefinition: [
        'name',
        'variableDefinitions',
        'directives',
        'selectionSet'
    ],
    VariableDefinition: [
        'variable',
        'type',
        'defaultValue',
        'directives'
    ],
    Variable: [
        'name'
    ],
    SelectionSet: [
        'selections'
    ],
    Field: [
        'alias',
        'name',
        'arguments',
        'directives',
        'selectionSet'
    ],
    Argument: [
        'name',
        'value'
    ],
    FragmentSpread: [
        'name',
        'directives'
    ],
    InlineFragment: [
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    FragmentDefinition: [
        'name',
        'variableDefinitions',
        'typeCondition',
        'directives',
        'selectionSet'
    ],
    IntValue: [],
    FloatValue: [],
    StringValue: [],
    BooleanValue: [],
    NullValue: [],
    EnumValue: [],
    ListValue: [
        'values'
    ],
    ObjectValue: [
        'fields'
    ],
    ObjectField: [
        'name',
        'value'
    ],
    Directive: [
        'name',
        'arguments'
    ],
    NamedType: [
        'name'
    ],
    ListType: [
        'type'
    ],
    NonNullType: [
        'type'
    ],
    SchemaDefinition: [
        'description',
        'directives',
        'operationTypes'
    ],
    OperationTypeDefinition: [
        'type'
    ],
    ScalarTypeDefinition: [
        'description',
        'name',
        'directives'
    ],
    ObjectTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    FieldDefinition: [
        'description',
        'name',
        'arguments',
        'type',
        'directives'
    ],
    InputValueDefinition: [
        'description',
        'name',
        'type',
        'defaultValue',
        'directives'
    ],
    InterfaceTypeDefinition: [
        'description',
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeDefinition: [
        'description',
        'name',
        'directives',
        'types'
    ],
    EnumTypeDefinition: [
        'description',
        'name',
        'directives',
        'values'
    ],
    EnumValueDefinition: [
        'description',
        'name',
        'directives'
    ],
    InputObjectTypeDefinition: [
        'description',
        'name',
        'directives',
        'fields'
    ],
    DirectiveDefinition: [
        'description',
        'name',
        'arguments',
        'locations'
    ],
    SchemaExtension: [
        'directives',
        'operationTypes'
    ],
    ScalarTypeExtension: [
        'name',
        'directives'
    ],
    ObjectTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    InterfaceTypeExtension: [
        'name',
        'interfaces',
        'directives',
        'fields'
    ],
    UnionTypeExtension: [
        'name',
        'directives',
        'types'
    ],
    EnumTypeExtension: [
        'name',
        'directives',
        'values'
    ],
    InputObjectTypeExtension: [
        'name',
        'directives',
        'fields'
    ]
};
const $9e7f6daba17e7622$var$kindValues = new Set(Object.keys($9e7f6daba17e7622$export$4fcd777a40ccf407));
function $9e7f6daba17e7622$export$8ee0fc9ee280b4ee(maybeNode) {
    const maybeKind = maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
    return typeof maybeKind === 'string' && $9e7f6daba17e7622$var$kindValues.has(maybeKind);
}
/** Name */ var $9e7f6daba17e7622$export$f58c50edb4aef9d4;
(function(OperationTypeNode) {
    OperationTypeNode['QUERY'] = 'query';
    OperationTypeNode['MUTATION'] = 'mutation';
    OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})($9e7f6daba17e7622$export$f58c50edb4aef9d4 || ($9e7f6daba17e7622$export$f58c50edb4aef9d4 = {}));

});

parcelRegister("3OxC3", function(module, exports) {

$parcel$export(module.exports, "Kind", () => $da5cd9493a8f02b9$export$a84bdc57c5122798);
/**
 * The set of allowed kind values for AST nodes.
 */ var $da5cd9493a8f02b9$export$a84bdc57c5122798;
(function(Kind) {
    Kind['NAME'] = 'Name';
    Kind['DOCUMENT'] = 'Document';
    Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
    Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
    Kind['SELECTION_SET'] = 'SelectionSet';
    Kind['FIELD'] = 'Field';
    Kind['ARGUMENT'] = 'Argument';
    Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
    Kind['INLINE_FRAGMENT'] = 'InlineFragment';
    Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
    Kind['VARIABLE'] = 'Variable';
    Kind['INT'] = 'IntValue';
    Kind['FLOAT'] = 'FloatValue';
    Kind['STRING'] = 'StringValue';
    Kind['BOOLEAN'] = 'BooleanValue';
    Kind['NULL'] = 'NullValue';
    Kind['ENUM'] = 'EnumValue';
    Kind['LIST'] = 'ListValue';
    Kind['OBJECT'] = 'ObjectValue';
    Kind['OBJECT_FIELD'] = 'ObjectField';
    Kind['DIRECTIVE'] = 'Directive';
    Kind['NAMED_TYPE'] = 'NamedType';
    Kind['LIST_TYPE'] = 'ListType';
    Kind['NON_NULL_TYPE'] = 'NonNullType';
    Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
    Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
    Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
    Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
    Kind['FIELD_DEFINITION'] = 'FieldDefinition';
    Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
    Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
    Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
    Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
    Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
    Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
    Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
    Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
    Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
    Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
    Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
    Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
    Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
    Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})($da5cd9493a8f02b9$export$a84bdc57c5122798 || ($da5cd9493a8f02b9$export$a84bdc57c5122798 = {}));
 /**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */ 
});




parcelRegister("8kbfx", function(module, exports) {

$parcel$export(module.exports, "makeScopeKey", () => $60f8eaeb36e9d466$export$e049bf165fbb6578);
$parcel$export(module.exports, "makeMarketplaceScope", () => $60f8eaeb36e9d466$export$d50933cc710a588);

var $g5DHJ = parcelRequire("g5DHJ");
function $60f8eaeb36e9d466$export$e049bf165fbb6578(scopeKey) {
    return scopeKey;
}
const $60f8eaeb36e9d466$var$MarketplaceScopeConstructor = (0, $g5DHJ.Record)({
    name: '',
    description: ''
});
const $60f8eaeb36e9d466$export$ccf2bd8e90818e80 = $60f8eaeb36e9d466$var$MarketplaceScopeConstructor();
const $60f8eaeb36e9d466$export$d50933cc710a588 = (a)=>$60f8eaeb36e9d466$var$MarketplaceScopeConstructor(a);

});



parcelRegister("G8Qov", function(module, exports) {

$parcel$export(module.exports, "FETCH_CURRENT_USER_ID", () => $07eac89b21631b55$export$1b39a0913e423c54);
$parcel$export(module.exports, "RECEIVE_CURRENT_USER_ID", () => $07eac89b21631b55$export$59163db6ade2a0c8);
$parcel$export(module.exports, "RECEIVE_CURRENT_USER_ID_ERROR", () => $07eac89b21631b55$export$9e385890aaa84464);
$parcel$export(module.exports, "doRetrieveCurrentUserId", () => $07eac89b21631b55$export$fa3ffc76ac0edbd4);

var $7hgtR = parcelRequire("7hgtR");

var $iyohm = parcelRequire("iyohm");

var $55gtq = parcelRequire("55gtq");
const $07eac89b21631b55$export$1b39a0913e423c54 = 'USERS_FETCH_CURRENT_USER_ID';
const $07eac89b21631b55$export$59163db6ade2a0c8 = 'USERS_RECEIVE_CURRENT_USER_ID';
const $07eac89b21631b55$export$9e385890aaa84464 = 'USERS_RECEIVE_CURRENT_USER_ID_ERROR';
const $07eac89b21631b55$var$fetchCurrentUserId = ()=>({
        type: $07eac89b21631b55$export$1b39a0913e423c54
    });
const $07eac89b21631b55$var$receiveCurrentUserId = (_ref)=>{
    let { currentUserId: currentUserId } = _ref;
    return {
        type: $07eac89b21631b55$export$59163db6ade2a0c8,
        currentUserId: currentUserId
    };
};
const $07eac89b21631b55$var$receiveCurrentUserIdError = (_ref2)=>{
    let { dataErrorMessages: dataErrorMessages } = _ref2;
    return {
        type: $07eac89b21631b55$export$9e385890aaa84464,
        dataErrorMessages: dataErrorMessages
    };
};
const $07eac89b21631b55$export$fa3ffc76ac0edbd4 = ()=>(dispatch)=>{
        dispatch($07eac89b21631b55$var$fetchCurrentUserId());
        return new Promise((resolve, reject)=>(0, $55gtq.default)().getCurrentUser().then((currentUser)=>{
                const currentUserId = (0, $iyohm.makeUserId)(currentUser.atlassianAccountId);
                dispatch($07eac89b21631b55$var$receiveCurrentUserId({
                    currentUserId: currentUserId
                }));
                resolve(currentUserId);
            }, (error)=>{
                dispatch($07eac89b21631b55$var$receiveCurrentUserIdError({
                    dataErrorMessages: (0, $7hgtR.makeDataErrorMessages)([
                        error
                    ])
                }));
                reject(error);
            }));
    };

});
parcelRegister("iyohm", function(module, exports) {

$parcel$export(module.exports, "makeUserId", () => $d81e3c4cbde33f2e$export$64cebb1eac286868);
$parcel$export(module.exports, "_makeUser", () => $d81e3c4cbde33f2e$export$9bc63df8e2f0a0c6);
$parcel$export(module.exports, "makeUserFromSPIUser", () => $d81e3c4cbde33f2e$export$41ce4899f8b30dcb);

var $g5DHJ = parcelRequire("g5DHJ");
function $d81e3c4cbde33f2e$export$64cebb1eac286868(userId) {
    return userId;
}
const $d81e3c4cbde33f2e$export$9bc63df8e2f0a0c6 = (0, $g5DHJ.Record)({
    // Casting to any here since it's a bit too much overhead to define a massive default for something we never interact with
    _original: {},
    atlassianAccountId: $d81e3c4cbde33f2e$export$64cebb1eac286868(''),
    avatarUrl: undefined,
    mention: undefined,
    name: ''
});
const $d81e3c4cbde33f2e$export$4e4c41e4152a9f8a = $d81e3c4cbde33f2e$export$9bc63df8e2f0a0c6;
const $d81e3c4cbde33f2e$export$41ce4899f8b30dcb = (spiUser)=>$d81e3c4cbde33f2e$export$4e4c41e4152a9f8a({
        _original: spiUser,
        atlassianAccountId: $d81e3c4cbde33f2e$export$64cebb1eac286868(spiUser.atlassianAccountId),
        avatarUrl: spiUser.avatarUrl,
        mention: spiUser.mention,
        name: spiUser.name
    });

});



parcelRegister("8bwkw", function(module, exports) {

$parcel$export(module.exports, "ADD_FLAG", () => $5f586de674c8dc32$export$8db129480af5aa95);
$parcel$export(module.exports, "REMOVE_FLAG", () => $5f586de674c8dc32$export$f49894fce0f25653);
$parcel$export(module.exports, "addFlag", () => $5f586de674c8dc32$export$820a1da46c7a4303);
$parcel$export(module.exports, "addCaasErrorFlag", () => $5f586de674c8dc32$export$652dc350e6304ac0);
$parcel$export(module.exports, "removeFlag", () => $5f586de674c8dc32$export$f2c4075a13a8b485);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $jC5dB = parcelRequire("jC5dB");

var $hsaiM = parcelRequire("hsaiM");
const $5f586de674c8dc32$export$8db129480af5aa95 = 'FLAGS_ADD_FLAG';
const $5f586de674c8dc32$export$f49894fce0f25653 = 'FLAGS_REMOVE_FLAG';
function $5f586de674c8dc32$export$820a1da46c7a4303(options) {
    return {
        type: $5f586de674c8dc32$export$8db129480af5aa95,
        flag: options.flag
    };
}
function $5f586de674c8dc32$export$652dc350e6304ac0(options) {
    var _options$featureFlags;
    const errorDetails = (0, $hsaiM.getErrorDetails)(options.message, options.hostConfig, {
        showCustomBackendErrorsFromUpm: (_options$featureFlags = options.featureFlags) === null || _options$featureFlags === void 0 ? void 0 : _options$featureFlags.showCustomBackendErrorsFromUpm
    });
    const errorTID = errorDetails.tid ? "TID: ".concat(errorDetails.tid, " ") : '';
    const errorType = errorDetails.type ? "Type: ".concat(errorDetails.type) : '';
    const secondaryDescription = errorDetails.translation.showTID ? errorTID + errorType : undefined;
    return $5f586de674c8dc32$export$820a1da46c7a4303({
        flag: (0, $jC5dB.makeFlag)({
            key: options.key,
            title: errorDetails.translation.title,
            description: (0, $jC5dB.makeFlagDescription)({
                primary: errorDetails.translation.description,
                secondary: secondaryDescription
            }),
            actions: (0, $bWAru.Option).of(options.actions).getOrElse((0, $g5DHJ.List)()),
            appearance: (0, $jC5dB.ERROR_APPEARANCE)
        })
    });
}
function $5f586de674c8dc32$export$f2c4075a13a8b485(key) {
    return {
        type: $5f586de674c8dc32$export$f49894fce0f25653,
        key: key
    };
}

});
parcelRegister("jC5dB", function(module, exports) {

$parcel$export(module.exports, "SUCCESS_APPEARANCE", () => $e4759d31f3d84bd6$export$d538d4924a0704b3);
$parcel$export(module.exports, "ERROR_APPEARANCE", () => $e4759d31f3d84bd6$export$b25a81054afdd0fc);
$parcel$export(module.exports, "INFO_APPEARANCE", () => $e4759d31f3d84bd6$export$95e25e8307cc43a1);
$parcel$export(module.exports, "foldAppearance", () => $e4759d31f3d84bd6$export$4230c263e63219c5);
$parcel$export(module.exports, "makeFlagAction", () => $e4759d31f3d84bd6$export$2827c8934c10366b);
$parcel$export(module.exports, "makeEmceeFlag", () => $e4759d31f3d84bd6$export$dd4c9a2f2b031e3e);
$parcel$export(module.exports, "makeFlag", () => $e4759d31f3d84bd6$export$115925bcaa88a588);
$parcel$export(module.exports, "makeFlagDescription", () => $e4759d31f3d84bd6$export$89885fb2503e60cf);

var $g5DHJ = parcelRequire("g5DHJ");
const $e4759d31f3d84bd6$export$d538d4924a0704b3 = 'success';
const $e4759d31f3d84bd6$export$b25a81054afdd0fc = 'error';
const $e4759d31f3d84bd6$export$95e25e8307cc43a1 = 'info';
const $e4759d31f3d84bd6$export$8495807f04c3701d = 'warning';
function $e4759d31f3d84bd6$export$4230c263e63219c5(appearance, success, error, info, warning) {
    switch(appearance){
        case $e4759d31f3d84bd6$export$d538d4924a0704b3:
            return success();
        case $e4759d31f3d84bd6$export$b25a81054afdd0fc:
            return error();
        case $e4759d31f3d84bd6$export$95e25e8307cc43a1:
            return info();
        case $e4759d31f3d84bd6$export$8495807f04c3701d:
            return warning();
        default:
            throw new Error("foldAppearance is not comprehensive in Appearance: ".concat(appearance));
    }
}
const $e4759d31f3d84bd6$export$2827c8934c10366b = (0, $g5DHJ.Record)({
    callback: ()=>{
    /* do nothing by default */ },
    displayText: '',
    id: '',
    key: '',
    href: '',
    target: ''
});
const $e4759d31f3d84bd6$var$makeFlagActions = (flag)=>{
    if (!flag.actions) return (0, $g5DHJ.List)([]);
    return (0, $g5DHJ.List)(flag.actions.map((action)=>{
        const flagAction = {
            displayText: action.content
        };
        if (action.href) flagAction.href = action.href;
        if (action.onClick) flagAction.callback = action.onClick;
        if (action.target) flagAction.target = action.target;
        return $e4759d31f3d84bd6$export$2827c8934c10366b(flagAction);
    }));
};
const $e4759d31f3d84bd6$export$dd4c9a2f2b031e3e = (flag)=>{
    return $e4759d31f3d84bd6$export$115925bcaa88a588({
        key: flag.id,
        appearance: flag.type,
        title: flag.title,
        description: {
            primary: flag.description
        },
        autoDismiss: flag.isAutoDismiss,
        actions: $e4759d31f3d84bd6$var$makeFlagActions(flag)
    });
};
const $e4759d31f3d84bd6$export$89885fb2503e60cf = (0, $g5DHJ.Record)({
    primary: '',
    secondary: undefined
});
const $e4759d31f3d84bd6$export$115925bcaa88a588 = (0, $g5DHJ.Record)({
    autoDismiss: true,
    actions: (0, $g5DHJ.List)(),
    appearance: $e4759d31f3d84bd6$export$d538d4924a0704b3,
    description: undefined,
    key: '',
    title: ''
});

});


parcelRegister("i0k4A", function(module, exports) {

$parcel$export(module.exports, "SET_APP_SPECIFIC_PASSWORD_NAME", () => $d1b7cc2d67cf70f4$export$5ce8770e865decc3);
$parcel$export(module.exports, "START_GENERATE_APP_SPECIFIC_PASSWORD", () => $d1b7cc2d67cf70f4$export$65f25516262ec915);
$parcel$export(module.exports, "FINISH_GENERATE_APP_SPECIFIC_PASSWORD", () => $d1b7cc2d67cf70f4$export$9b5a8d15aa88c1b);
$parcel$export(module.exports, "GENERATE_APP_SPECIFIC_PASSWORD_ERROR", () => $d1b7cc2d67cf70f4$export$fa77fd266adb3fc7);
$parcel$export(module.exports, "START_REGENERATE_APP_SPECIFIC_PASSWORD", () => $d1b7cc2d67cf70f4$export$ad17f282c9ffd6af);
$parcel$export(module.exports, "FINISH_REGENERATE_APP_SPECIFIC_PASSWORD", () => $d1b7cc2d67cf70f4$export$b2aac2dc881397a8);
$parcel$export(module.exports, "REGENERATE_APP_SPECIFIC_PASSWORD_ERROR", () => $d1b7cc2d67cf70f4$export$72b6f1a36ecde1f4);
$parcel$export(module.exports, "setAppSpecificPasswordName", () => $d1b7cc2d67cf70f4$export$34b95fd659f6e04);
$parcel$export(module.exports, "doStartAppSpecificPasswordInstallMode", () => $d1b7cc2d67cf70f4$export$4f850191f1cfbdff);
$parcel$export(module.exports, "doGenerateAppSpecificPassword", () => $d1b7cc2d67cf70f4$export$c19a0861d3b10a04);
$parcel$export(module.exports, "doRegenerateAppSpecificPassword", () => $d1b7cc2d67cf70f4$export$a9245914b4e857c5);

var $cjFit = parcelRequire("cjFit");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $9Qzgt = parcelRequire("9Qzgt");

var $55gtq = parcelRequire("55gtq");

var $i6Uah = parcelRequire("i6Uah");

var $dSumc = parcelRequire("dSumc");

var $6Xsph = parcelRequire("6Xsph");
const $d1b7cc2d67cf70f4$export$5ce8770e865decc3 = 'INSTALLATION_SET_APP_SPECIFIC_PASSWORD_NAME';
const $d1b7cc2d67cf70f4$export$65f25516262ec915 = 'INSTALLATION_START_GENERATE_APP_SPECIFIC_PASSWORD';
const $d1b7cc2d67cf70f4$export$9b5a8d15aa88c1b = 'INSTALLATION_FINISH_GENERATE_APP_SPECIFIC_PASSWORD';
const $d1b7cc2d67cf70f4$export$fa77fd266adb3fc7 = 'INSTALLATION_GENERATE_APP_SPECIFIC_PASSWORD_ERROR';
const $d1b7cc2d67cf70f4$export$ad17f282c9ffd6af = 'INSTALLATION_START_REGENERATE_APP_SPECIFIC_PASSWORD';
const $d1b7cc2d67cf70f4$export$b2aac2dc881397a8 = 'INSTALLATION_FINISH_REGENERATE_APP_SPECIFIC_PASSWORD';
const $d1b7cc2d67cf70f4$export$72b6f1a36ecde1f4 = 'INSTALLATION_REGENERATE_APP_SPECIFIC_PASSWORD_ERROR';
const $d1b7cc2d67cf70f4$export$34b95fd659f6e04 = (_ref)=>{
    let { name: name } = _ref;
    return {
        type: $d1b7cc2d67cf70f4$export$5ce8770e865decc3,
        name: name
    };
};
const $d1b7cc2d67cf70f4$var$startGenerateAppSpecificPassword = ()=>({
        type: $d1b7cc2d67cf70f4$export$65f25516262ec915
    });
const $d1b7cc2d67cf70f4$var$finishGenerateAppSpecificPassword = (_ref2)=>{
    let { context: context, generatedAppSpecificPassword: generatedAppSpecificPassword } = _ref2;
    return {
        type: $d1b7cc2d67cf70f4$export$9b5a8d15aa88c1b,
        context: context,
        generatedAppSpecificPassword: generatedAppSpecificPassword
    };
};
const $d1b7cc2d67cf70f4$var$generateAppSpecificPasswordError = (_ref3)=>{
    let { context: context, error: error } = _ref3;
    return {
        type: $d1b7cc2d67cf70f4$export$fa77fd266adb3fc7,
        context: context,
        error: error
    };
};
const $d1b7cc2d67cf70f4$var$startRegenerateAppSpecificPassword = (_ref4)=>{
    let { name: name, context: context } = _ref4;
    return {
        type: $d1b7cc2d67cf70f4$export$ad17f282c9ffd6af,
        name: name,
        context: context
    };
};
const $d1b7cc2d67cf70f4$var$finishRegenerateAppSpecificPassword = (_ref5)=>{
    let { context: context, generatedAppSpecificPassword: generatedAppSpecificPassword } = _ref5;
    return {
        type: $d1b7cc2d67cf70f4$export$b2aac2dc881397a8,
        context: context,
        generatedAppSpecificPassword: generatedAppSpecificPassword
    };
};
const $d1b7cc2d67cf70f4$var$regenerateAppSpecificPasswordError = (_ref6)=>{
    let { context: context, error: error } = _ref6;
    return {
        type: $d1b7cc2d67cf70f4$export$72b6f1a36ecde1f4,
        context: context,
        error: error
    };
};
const $d1b7cc2d67cf70f4$export$4f850191f1cfbdff = (_ref7)=>{
    let { name: name } = _ref7;
    return (dispatch)=>{
        dispatch((0, $dSumc.doSetInstallMode)({
            installMode: (0, $9Qzgt.makeAppSpecificPasswordInstallMode)({
                appSpecificPassword: name ? (0, $bWAru.Option).of((0, $9Qzgt.makeAppSpecificPassword)({
                    name: name
                })) : (0, $bWAru.Option).none()
            })
        }));
    };
};
const $d1b7cc2d67cf70f4$export$c19a0861d3b10a04 = (_ref8)=>{
    let { name: name, context: context, hostConfig: hostConfig } = _ref8;
    return (dispatch)=>{
        dispatch($d1b7cc2d67cf70f4$var$startGenerateAppSpecificPassword());
        (0, $55gtq.default)().createContainerToken({
            name: name,
            contextId: context.id
        }).then((tokenDetails)=>{
            dispatch($d1b7cc2d67cf70f4$var$finishGenerateAppSpecificPassword({
                context: context,
                generatedAppSpecificPassword: (0, $i6Uah.makeGeneratedAppSpecificPassword)((0, $bWAru.Option).of(tokenDetails.details.token).getOrElse('Unknown'))
            }));
            (0, $6Xsph.updateInstalledAppsPostInstall)(dispatch, context, hostConfig);
        }, (error)=>{
            dispatch($d1b7cc2d67cf70f4$var$generateAppSpecificPasswordError({
                error: error,
                context: context
            }));
            console.error('createContainerToken was rejected by the SPI and returned the following error:', error);
        });
    };
};
const $d1b7cc2d67cf70f4$export$a9245914b4e857c5 = (_ref9)=>{
    let { installedApp: installedApp, context: context } = _ref9;
    return (dispatch)=>{
        const name = (0, $cjFit.nonEmptyString)(installedApp.details.name);
        if (!name) {
            console.error('Existing app specific password in an invalid state - token name is empty');
            return;
        }
        dispatch($d1b7cc2d67cf70f4$var$startRegenerateAppSpecificPassword({
            name: name,
            context: context
        }));
        (0, $55gtq.default)().rotateContainerToken({
            addon: installedApp._original,
            contextId: context.id
        }).then((tokenDetails)=>{
            dispatch($d1b7cc2d67cf70f4$var$finishRegenerateAppSpecificPassword({
                context: context,
                generatedAppSpecificPassword: (0, $i6Uah.makeGeneratedAppSpecificPassword)(tokenDetails.token)
            }));
        }, (error)=>{
            dispatch($d1b7cc2d67cf70f4$var$regenerateAppSpecificPasswordError({
                context: context,
                error: error
            }));
            console.error('rotateContainerToken was rejected by the SPI and returned the following error:', error);
        });
    };
};

});
parcelRegister("cjFit", function(module, exports) {

$parcel$export(module.exports, "nonEmptyString", () => $8f774b1ea4e8709c$export$cf37a15c1da41d8f);
$parcel$export(module.exports, "emptyString", () => $8f774b1ea4e8709c$export$1643ccb46f49255c);
const $8f774b1ea4e8709c$export$cf37a15c1da41d8f = (s)=>{
    if (!s || !s.length) return $8f774b1ea4e8709c$export$1643ccb46f49255c;
    else return s;
};
const $8f774b1ea4e8709c$export$1643ccb46f49255c = null;

});

parcelRegister("9Qzgt", function(module, exports) {

$parcel$export(module.exports, "APP_SPECIFIC_PASSWORD_INSTALL_MODE", () => $72b45335ac2f6a9a$export$9cb515f69b706cd0);
$parcel$export(module.exports, "makeAppSpecificPassword", () => $72b45335ac2f6a9a$export$fff6f05231d143cd);
$parcel$export(module.exports, "makeAppSpecificPasswordInstallMode", () => $72b45335ac2f6a9a$export$11021b8ea655afdf);

var $cjFit = parcelRequire("cjFit");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $9eIgo = parcelRequire("9eIgo");
const $72b45335ac2f6a9a$export$9cb515f69b706cd0 = 'APP_SPECIFIC_PASSWORD';
const $72b45335ac2f6a9a$export$fff6f05231d143cd = (0, $g5DHJ.Record)({
    name: (0, $cjFit.nonEmptyString)('name'),
    // Invalid, but need a default
    status: (0, $9eIgo.makePendingConfirmationInstallStatus)()
});
const $72b45335ac2f6a9a$export$11021b8ea655afdf = (0, $g5DHJ.Record)({
    type: $72b45335ac2f6a9a$export$9cb515f69b706cd0,
    appSpecificPassword: (0, $bWAru.Option).empty()
});

});
parcelRegister("9eIgo", function(module, exports) {

$parcel$export(module.exports, "IN_PROGRESS_INSTALL_STATUS", () => $6b97c1a45df17aa2$export$2d86fa0e1233e6ff);
$parcel$export(module.exports, "COMPLETE_INSTALL_STATUS", () => $6b97c1a45df17aa2$export$c5d9a2deec84162e);
$parcel$export(module.exports, "makePendingConfirmationInstallStatus", () => $6b97c1a45df17aa2$export$337a1cd9ea7d6721);
$parcel$export(module.exports, "makeInProgressInstallStatus", () => $6b97c1a45df17aa2$export$30eca8cef4b8d8c1);
$parcel$export(module.exports, "makeCompleteInstallStatus", () => $6b97c1a45df17aa2$export$7e1674eb10a9ae8);
$parcel$export(module.exports, "foldInstallStatus", () => $6b97c1a45df17aa2$export$cdd26f446a29d129);
$parcel$export(module.exports, "isInstallStatusLoading", () => $6b97c1a45df17aa2$export$4fc9385e90d58a79);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
const $6b97c1a45df17aa2$export$483f8ecb0166e62f = 'PENDING_ACCEPT';
const $6b97c1a45df17aa2$export$2d86fa0e1233e6ff = 'IN_PROGRESS';
const $6b97c1a45df17aa2$export$c5d9a2deec84162e = 'COMPLETE';
const $6b97c1a45df17aa2$export$337a1cd9ea7d6721 = (0, $g5DHJ.Record)({
    type: $6b97c1a45df17aa2$export$483f8ecb0166e62f
});
const $6b97c1a45df17aa2$export$30eca8cef4b8d8c1 = (0, $g5DHJ.Record)({
    type: $6b97c1a45df17aa2$export$2d86fa0e1233e6ff
});
const $6b97c1a45df17aa2$export$7e1674eb10a9ae8 = (0, $g5DHJ.Record)({
    type: $6b97c1a45df17aa2$export$c5d9a2deec84162e,
    result: (0, $bWAru.Either).left('error') // Not really a valid default, but need to provide one
});
function $6b97c1a45df17aa2$export$cdd26f446a29d129(installStatus, pendingConfirmation, installing, complete) {
    switch(installStatus.type){
        case $6b97c1a45df17aa2$export$483f8ecb0166e62f:
            return pendingConfirmation(installStatus);
        case $6b97c1a45df17aa2$export$2d86fa0e1233e6ff:
            return installing(installStatus);
        case $6b97c1a45df17aa2$export$c5d9a2deec84162e:
            return complete(installStatus);
        default:
            // Flow compile-time validation that we've handled every discover item
            // prettier-ignore
            installStatus;
            return undefined;
    }
}
function $6b97c1a45df17aa2$export$4fc9385e90d58a79(installStatus) {
    return $6b97c1a45df17aa2$export$cdd26f446a29d129(installStatus, ()=>false, ()=>true, ()=>false);
}

});


parcelRegister("i6Uah", function(module, exports) {

$parcel$export(module.exports, "makeGeneratedAppSpecificPassword", () => $d2f45ab721f98357$export$31cb995aae6aaf5);
function $d2f45ab721f98357$export$31cb995aae6aaf5(generatedAppSpecificPassword) {
    return generatedAppSpecificPassword;
}

});

parcelRegister("dSumc", function(module, exports) {

$parcel$export(module.exports, "SET_INSTALL_MODE", () => $a1a7ddc509d76041$export$b5bb2352a4aec916);
$parcel$export(module.exports, "CLEAR_INSTALL_MODE", () => $a1a7ddc509d76041$export$c9dec0e8f9ca7d3f);
$parcel$export(module.exports, "clearInstallMode", () => $a1a7ddc509d76041$export$a0216699bd648ff9);
$parcel$export(module.exports, "NO_SIMULTANEOUS_INSTALLS_FLAG_KEY", () => $a1a7ddc509d76041$export$ebe02ffcffaa47d4);
$parcel$export(module.exports, "doSetInstallMode", () => $a1a7ddc509d76041$export$382bf722466a870c);

var $jC5dB = parcelRequire("jC5dB");

var $i7hUf = parcelRequire("i7hUf");

var $9eIgo = parcelRequire("9eIgo");

var $8bwkw = parcelRequire("8bwkw");
const $a1a7ddc509d76041$export$b5bb2352a4aec916 = 'INSTALLATION_SET_INSTALL_MODE';
const $a1a7ddc509d76041$export$c9dec0e8f9ca7d3f = 'INSTALLATION_CLEAR_INSTALL_MODE';
const $a1a7ddc509d76041$var$setInstallMode = (_ref)=>{
    let { installMode: installMode } = _ref;
    return {
        type: $a1a7ddc509d76041$export$b5bb2352a4aec916,
        installMode: installMode
    };
};
const $a1a7ddc509d76041$export$a0216699bd648ff9 = ()=>({
        type: $a1a7ddc509d76041$export$c9dec0e8f9ca7d3f
    });
const $a1a7ddc509d76041$export$ebe02ffcffaa47d4 = 'no-simultaneous-installs-allowed';
const $a1a7ddc509d76041$export$382bf722466a870c = (_ref2)=>{
    let { installMode: installMode } = _ref2;
    return (dispatch, getState)=>{
        getState().installation.installMode.fold(()=>dispatch($a1a7ddc509d76041$var$setInstallMode({
                installMode: installMode
            })), (cim)=>(0, $i7hUf.foldInstallMode)(cim)(()=>true, (appSpecificPasswordInstallMode)=>appSpecificPasswordInstallMode.appSpecificPassword.forAll((asp)=>!(0, $9eIgo.isInstallStatusLoading)(asp.status)), ()=>true, (installableAppDefaultInstallMode)=>!(0, $9eIgo.isInstallStatusLoading)(installableAppDefaultInstallMode.status), (installableAppByManualUrlInstallMode)=>installableAppByManualUrlInstallMode.installableAppByManualUrl.forAll((asp)=>!(0, $9eIgo.isInstallStatusLoading)(asp.status)), (installableAppUpgradeInstallMode)=>!(0, $9eIgo.isInstallStatusLoading)(installableAppUpgradeInstallMode.status)) ? dispatch($a1a7ddc509d76041$var$setInstallMode({
                installMode: installMode
            })) : dispatch((0, $8bwkw.addFlag)({
                flag: (0, $jC5dB.makeFlag)({
                    key: $a1a7ddc509d76041$export$ebe02ffcffaa47d4,
                    appearance: (0, $jC5dB.INFO_APPEARANCE),
                    autoDismiss: true,
                    description: (0, $jC5dB.makeFlagDescription)({
                        primary: 'Another installation is still in progress... Try again when it is complete.'
                    }),
                    title: 'Hold on!'
                })
            })));
    };
};

});
parcelRegister("i7hUf", function(module, exports) {

$parcel$export(module.exports, "foldInstallMode", () => $d306c544bb56b97c$export$9c5311127f778044);

var $9Qzgt = parcelRequire("9Qzgt");

var $8ZSlI = parcelRequire("8ZSlI");

var $249j9 = parcelRequire("249j9");

var $4s0An = parcelRequire("4s0An");

var $gR0l9 = parcelRequire("gR0l9");

var $k5vUT = parcelRequire("k5vUT");
function $d306c544bb56b97c$export$9c5311127f778044(installMode) {
    return function(determining, asp, instructional, installableAppDefault, installableAppByManualUrl, installableAppUpgrade) {
        switch(installMode.type){
            case 0, $8ZSlI.DETERMINING_INSTALL_MODE:
                return determining(installMode);
            case 0, $9Qzgt.APP_SPECIFIC_PASSWORD_INSTALL_MODE:
                return asp(installMode);
            case 0, $k5vUT.INSTRUCTIONAL_INSTALL_MODE:
                return instructional(installMode);
            case 0, $4s0An.INSTALLABLE_APP_DEFAULT_INSTALL_MODE:
                return installableAppDefault(installMode);
            case 0, $249j9.INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE:
                return installableAppByManualUrl(installMode);
            case 0, $gR0l9.INSTALLABLE_APP_UPGRADE_INSTALL_MODE:
                return installableAppUpgrade(installMode);
            default:
                // Flow compile-time validation that we've handled every discover item
                // prettier-ignore
                installMode;
                return undefined;
        }
    };
}

});
parcelRegister("8ZSlI", function(module, exports) {

$parcel$export(module.exports, "DETERMINING_INSTALL_MODE", () => $68ce2dd850cfe612$export$506414a7e1b36cd3);
$parcel$export(module.exports, "makeDeterminingInstallMode", () => $68ce2dd850cfe612$export$7660d47c48dc9770);

var $g5DHJ = parcelRequire("g5DHJ");
const $68ce2dd850cfe612$export$506414a7e1b36cd3 = 'DETERMINING';
const $68ce2dd850cfe612$export$7660d47c48dc9770 = (0, $g5DHJ.Record)({
    type: $68ce2dd850cfe612$export$506414a7e1b36cd3,
    error: undefined,
    retrievalId: 0
});

});

parcelRegister("249j9", function(module, exports) {

$parcel$export(module.exports, "INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE", () => $18132cdaf7d3c162$export$e8f423240d2d9429);
$parcel$export(module.exports, "makeInstallableAppByManualUrl", () => $18132cdaf7d3c162$export$6542ad248273e702);
$parcel$export(module.exports, "makeInstallableAppByManualUrlInstallMode", () => $18132cdaf7d3c162$export$8a4eafb48d07657);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $ifMZN = parcelRequire("ifMZN");

var $9eIgo = parcelRequire("9eIgo");
const $18132cdaf7d3c162$export$e8f423240d2d9429 = 'INSTALLABLE_APP_BY_MANUAL_URL';
const $18132cdaf7d3c162$export$6542ad248273e702 = (0, $g5DHJ.Record)({
    installableApp: (0, $bWAru.Option).empty(),
    installableAppByUrlId: (0, $ifMZN.makeInstallableAppByUrlIdentifier)(),
    installedApp: (0, $bWAru.Option).empty(),
    retrievalId: 0,
    status: (0, $9eIgo.makePendingConfirmationInstallStatus)()
});
const $18132cdaf7d3c162$export$8a4eafb48d07657 = (0, $g5DHJ.Record)({
    type: $18132cdaf7d3c162$export$e8f423240d2d9429,
    installableAppByManualUrl: (0, $bWAru.Option).empty()
});

});
parcelRegister("ifMZN", function(module, exports) {

$parcel$export(module.exports, "ARI_TYPE", () => $d49fa239b51927ba$export$2c1aa78a79edb5c3);
$parcel$export(module.exports, "makeInstallableAppByKeyIdentifier", () => $d49fa239b51927ba$export$7bc350d6508c98cc);
$parcel$export(module.exports, "makeInstallableAppByAriIdentifier", () => $d49fa239b51927ba$export$c7ac7a03375590c6);
$parcel$export(module.exports, "makeInstallableAppByUrlIdentifier", () => $d49fa239b51927ba$export$b136e6eaf82351b3);
$parcel$export(module.exports, "foldInstallableAppIdentifier", () => $d49fa239b51927ba$export$343702c798450eb0);
$parcel$export(module.exports, "toSPIInstallableAddonIdentifier", () => $d49fa239b51927ba$export$274519655fcb8b0f);

var $cjFit = parcelRequire("cjFit");

var $ly50n = parcelRequire("ly50n");

var $g5DHJ = parcelRequire("g5DHJ");
const $d49fa239b51927ba$export$30af7111f72c7a22 = 'KEY';
const $d49fa239b51927ba$var$URL_TYPE = 'URL';
const $d49fa239b51927ba$export$2c1aa78a79edb5c3 = 'ARI';
const $d49fa239b51927ba$export$7bc350d6508c98cc = (0, $g5DHJ.Record)({
    type: $d49fa239b51927ba$export$30af7111f72c7a22,
    key: (0, $ly50n.makeAppKey)('')
});
const $d49fa239b51927ba$export$c7ac7a03375590c6 = (0, $g5DHJ.Record)({
    type: $d49fa239b51927ba$export$2c1aa78a79edb5c3,
    ari: (0, $ly50n.makeAppKey)(''),
    appKey: (0, $ly50n.makeAppKey)('')
});
const $d49fa239b51927ba$export$b136e6eaf82351b3 = (0, $g5DHJ.Record)({
    type: $d49fa239b51927ba$var$URL_TYPE,
    url: (0, $cjFit.nonEmptyString)('url') // Invalid, but need a default
});
function $d49fa239b51927ba$export$343702c798450eb0(appIdentifier) {
    return function(key, url, ari) {
        switch(appIdentifier.type){
            case $d49fa239b51927ba$export$30af7111f72c7a22:
                return key(appIdentifier);
            case $d49fa239b51927ba$var$URL_TYPE:
                return url(appIdentifier);
            case $d49fa239b51927ba$export$2c1aa78a79edb5c3:
                return ari(appIdentifier);
            default:
                // Flow compile-time validation that we've handled every discover item
                // prettier-ignore
                appIdentifier;
                return undefined;
        }
    };
}
const $d49fa239b51927ba$export$274519655fcb8b0f = (appIdentifier)=>$d49fa239b51927ba$export$343702c798450eb0(appIdentifier)((installableAppByKeyIdentifier)=>({
            key: installableAppByKeyIdentifier.key
        }), (installableAppByUrlIdentifier)=>({
            url: installableAppByUrlIdentifier.url
        }), (installableAppByAriIdentifier)=>({
            ari: installableAppByAriIdentifier.ari,
            appKey: installableAppByAriIdentifier.appKey
        }));

});
parcelRegister("ly50n", function(module, exports) {

$parcel$export(module.exports, "makeAppKey", () => $fb00a7da88133565$export$a7c7d13152440f84);
function $fb00a7da88133565$export$a7c7d13152440f84(key) {
    return key;
}

});



parcelRegister("4s0An", function(module, exports) {

$parcel$export(module.exports, "INSTALLABLE_APP_DEFAULT_INSTALL_MODE", () => $33da3b41923c0162$export$63b88c9b5076aeae);
$parcel$export(module.exports, "makeInstallableAppDefaultInstallMode", () => $33da3b41923c0162$export$ddfcb64563ebca44);

var $eNZVr = parcelRequire("eNZVr");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $hCQtM = parcelRequire("hCQtM");

var $ifMZN = parcelRequire("ifMZN");

var $9eIgo = parcelRequire("9eIgo");
const $33da3b41923c0162$export$63b88c9b5076aeae = 'INSTALLABLE_APP_DEFAULT';
const $33da3b41923c0162$export$ddfcb64563ebca44 = (0, $g5DHJ.Record)({
    type: $33da3b41923c0162$export$63b88c9b5076aeae,
    installableApp: (0, $hCQtM.makeInstallableApp)(),
    installableAppId: (0, $ifMZN.makeInstallableAppByKeyIdentifier)(),
    installPermission: (0, $bWAru.Either).left((0, $eNZVr.makePermissionCheckResultFailure)()),
    installedApp: (0, $bWAru.Option).empty(),
    relayState: undefined,
    status: (0, $9eIgo.makePendingConfirmationInstallStatus)()
});

});
parcelRegister("eNZVr", function(module, exports) {

$parcel$export(module.exports, "makePermissionCheckResultFailure", () => $ac75ad66bec14724$export$635a8be87e249253);
$parcel$export(module.exports, "makePermissionCheckResultFromSPI", () => $ac75ad66bec14724$export$720fec40f8bf8dbe);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $8wTgI = parcelRequire("8wTgI");
const $ac75ad66bec14724$export$635a8be87e249253 = (0, $g5DHJ.Record)({
    allowed: false,
    message: '',
    key: 'noAddonManagePermission'
});
const $ac75ad66bec14724$export$fa307e2d7dba298d = (0, $g5DHJ.Record)({
    allowed: true
});
const $ac75ad66bec14724$export$720fec40f8bf8dbe = (pc)=>(0, $8wTgI.foldSPIPermissionCheckResult)(pc)((s)=>(0, $bWAru.Either).right($ac75ad66bec14724$export$fa307e2d7dba298d(s)), (f)=>(0, $bWAru.Either).left($ac75ad66bec14724$export$635a8be87e249253(f)));

});
parcelRegister("8wTgI", function(module, exports) {

$parcel$export(module.exports, "foldSPIPermissionCheckResult", () => $635c2f1bc8e803d0$export$ef36bc99c71dc4db);
const $635c2f1bc8e803d0$export$ef36bc99c71dc4db = (pc)=>(a, b)=>pc.allowed === true ? a(pc) : b(pc);

});


parcelRegister("hCQtM", function(module, exports) {

$parcel$export(module.exports, "makeInstallableApp", () => $cd4eb18df34cf788$export$13c6497ddb9cd56c);
$parcel$export(module.exports, "makeInstallableAppFromSPIInstallableAddonAndMarketplaceAppData", () => $cd4eb18df34cf788$export$7b9fa3e4886032de);

var $7r0ma = parcelRequire("7r0ma");

var $8kbfx = parcelRequire("8kbfx");

var $g5DHJ = parcelRequire("g5DHJ");
const $cd4eb18df34cf788$export$13c6497ddb9cd56c = (0, $g5DHJ.Record)({
    details: (0, $7r0ma.makeSPIAppDisplayDetails)((0, $7r0ma.makeAppDisplayDetails)()),
    marketplaceAppDetails: (0, $7r0ma.makeMarketplaceAppDisplayDetails)((0, $7r0ma.makeAppDisplayDetails)()),
    scopes: (0, $g5DHJ.List)(),
    eligibleForFreeOnSandbox: false,
    cloudMigrationTrial: {
        isEligible: false
    }
});
const $cd4eb18df34cf788$export$7b9fa3e4886032de = (installableAddon, marketplaceApp, mpacBaseUrl)=>$cd4eb18df34cf788$export$13c6497ddb9cd56c({
        details: (0, $7r0ma.makeSPIAppDisplayDetailsFromSPIAddonDisplayDetails)(installableAddon.details),
        marketplaceAppDetails: (0, $7r0ma.makeMarketplaceAppDisplayDetailsFromMarketplaceApp)({
            marketplaceApp: marketplaceApp,
            mpacBaseUrl: mpacBaseUrl
        }),
        scopes: (0, $g5DHJ.List)(installableAddon.scopes).map((0, $8kbfx.makeScopeKey)),
        eligibleForFreeOnSandbox: installableAddon.eligibleForFreeOnSandbox,
        cloudMigrationTrial: installableAddon.cloudMigrationTrial
    });

});
parcelRegister("7r0ma", function(module, exports) {

$parcel$export(module.exports, "makeAppDisplayDetails", () => $569b54cdbb73178d$export$f0e73010cd102562);
$parcel$export(module.exports, "makeMarketplaceAppDisplayDetails", () => $569b54cdbb73178d$export$8502fd07df5b19ab);
$parcel$export(module.exports, "makeSPIAppDisplayDetails", () => $569b54cdbb73178d$export$b2a5f7b9f9f20a63);
$parcel$export(module.exports, "makeSPIAppDisplayDetailsFromSPIAddonDisplayDetails", () => $569b54cdbb73178d$export$73ca5f8a7e36e64);
$parcel$export(module.exports, "makeMarketplaceAppDisplayDetailsFromMarketplaceApp", () => $569b54cdbb73178d$export$7ff370aec992029a);

var $6UgUw = parcelRequire("6UgUw");
var $ly50n = parcelRequire("ly50n");

var $c9Mth = parcelRequire("c9Mth");

var $g5DHJ = parcelRequire("g5DHJ");
const $569b54cdbb73178d$var$makeAppDistribution = (0, $g5DHJ.Record)({
    downloadCount: 0,
    installationCount: 0,
    isPreinstalled: false,
    isPreinstalledInAnyHosting: false
});
const $569b54cdbb73178d$export$d233a2c59f71a595 = (marketplaceApp)=>{
    var _marketplaceApp$_embe;
    const { downloads: downloads, totalInstalls: totalInstalls, bundled: bundled, bundledCloud: bundledCloud } = ((_marketplaceApp$_embe = marketplaceApp._embedded) === null || _marketplaceApp$_embe === void 0 ? void 0 : _marketplaceApp$_embe.distribution) || {};
    return $569b54cdbb73178d$var$makeAppDistribution({
        downloadCount: downloads,
        installationCount: totalInstalls,
        isPreinstalled: bundledCloud,
        isPreinstalledInAnyHosting: bundledCloud || bundled || false
    });
};
const $569b54cdbb73178d$export$1b7bf106d42aa1ab = (0, $g5DHJ.Record)({
    title: '',
    explanation: '',
    thumbnail: '',
    screenshot: '',
    body: ''
});
const $569b54cdbb73178d$export$b711a51bc42b686f = (0, $g5DHJ.Record)({
    caption: '',
    screenshot: ''
});
const $569b54cdbb73178d$export$f0e73010cd102562 = (0, $g5DHJ.Record)({
    key: (0, $ly50n.makeAppKey)(''),
    icon: undefined,
    metadata: {},
    origin: undefined,
    name: '',
    version: undefined,
    vendor: (0, $6UgUw.makeVendor)(),
    privacyPolicy: undefined,
    eula: undefined,
    tagLine: '',
    youtubeId: undefined,
    heroImage: undefined,
    highlights: [],
    screenshots: [],
    moreDetails: undefined,
    isConnectApp: false,
    paymentModel: undefined,
    ratings: {
        avgStars: 0,
        numRatings: 0
    },
    ecosystemCloudAppId: '',
    programs: undefined,
    distribution: $569b54cdbb73178d$var$makeAppDistribution()
});
const $569b54cdbb73178d$export$8502fd07df5b19ab = (value)=>value;
const $569b54cdbb73178d$export$b2a5f7b9f9f20a63 = (value)=>value;
const $569b54cdbb73178d$var$getImageUrl = (links)=>links && links._links ? (links._links.highRes || links._links.unscaled || links._links.image).href : undefined;
const $569b54cdbb73178d$var$getHighlights = (highlights)=>highlights ? highlights.map((highlight)=>{
        var _highlight$_embedded, _highlight$_embedded2;
        return $569b54cdbb73178d$export$1b7bf106d42aa1ab({
            title: highlight.title,
            explanation: highlight.explanation,
            body: highlight.body,
            thumbnail: $569b54cdbb73178d$var$getImageUrl((_highlight$_embedded = highlight._embedded) === null || _highlight$_embedded === void 0 ? void 0 : _highlight$_embedded.thumbnail),
            screenshot: $569b54cdbb73178d$var$getImageUrl((_highlight$_embedded2 = highlight._embedded) === null || _highlight$_embedded2 === void 0 ? void 0 : _highlight$_embedded2.screenshot)
        });
    }) : [];
const $569b54cdbb73178d$var$getScreenshots = (screenshots)=>screenshots ? screenshots.map((highlight)=>{
        var _highlight$_embedded3;
        return $569b54cdbb73178d$export$b711a51bc42b686f({
            caption: highlight.caption,
            screenshot: $569b54cdbb73178d$var$getImageUrl((_highlight$_embedded3 = highlight._embedded) === null || _highlight$_embedded3 === void 0 ? void 0 : _highlight$_embedded3.image)
        });
    }) : [];
const $569b54cdbb73178d$export$73ca5f8a7e36e64 = (addonDisplayDetails)=>$569b54cdbb73178d$export$f0e73010cd102562({
        key: (0, $ly50n.makeAppKey)(addonDisplayDetails.key),
        icon: addonDisplayDetails.icon,
        metadata: addonDisplayDetails.metadata,
        origin: addonDisplayDetails.origin,
        name: addonDisplayDetails.name,
        version: addonDisplayDetails.version,
        vendor: (0, $6UgUw.makeVendor)({
            name: addonDisplayDetails.vendor,
            link: (0, $c9Mth).validateSafeAbsoluteUrl(addonDisplayDetails.vendorLink),
            // Eventually VendorType should not be optional in SPI AddonDisplayDetails, we should update marketplace-spi after DAC-3300
            vendorType: addonDisplayDetails.vendorType || (0, $6UgUw.defaultVendorType)
        }),
        privacyPolicy: (0, $c9Mth).validateSafeAbsoluteUrl(addonDisplayDetails.privacyPolicy),
        eula: (0, $c9Mth).validateSafeAbsoluteUrl(addonDisplayDetails.eula),
        ecosystemCloudAppId: addonDisplayDetails.ecosystemCloudAppId
    });
const $569b54cdbb73178d$export$7ff370aec992029a = (_ref)=>{
    var _marketplaceApp$_embe2, _marketplaceApp$_embe3, _marketplaceApp$_embe4, _marketplaceApp$_embe5, _marketplaceApp$vendo, _marketplaceApp$_embe6, _marketplaceApp$_embe7, _marketplaceApp$_embe8, _marketplaceApp$_embe9, _marketplaceApp$_embe10, _marketplaceApp$_embe11, _marketplaceApp$_embe12, _marketplaceApp$_embe13, _marketplaceApp$_embe14, _marketplaceApp$_embe15, _marketplaceApp$_embe16, _marketplaceApp$_embe17, _marketplaceApp$_embe18, _marketplaceApp$_embe19, _marketplaceApp$_embe20, _marketplaceApp$_embe21, _marketplaceApp$_embe22, _marketplaceApp$_embe23, _marketplaceApp$_embe24, _marketplaceApp$_embe25, _marketplaceApp$_embe26, _marketplaceApp$_embe27, _marketplaceApp$_embe28, _marketplaceApp$_embe29, _marketplaceApp$_embe30, _marketplaceApp$_embe31, _marketplaceApp$_embe32, _marketplaceApp$_embe33;
    let { mpacBaseUrl: mpacBaseUrl, marketplaceApp: marketplaceApp } = _ref;
    return $569b54cdbb73178d$export$8502fd07df5b19ab($569b54cdbb73178d$export$f0e73010cd102562({
        key: marketplaceApp.key,
        icon: (_marketplaceApp$_embe2 = marketplaceApp._embedded) === null || _marketplaceApp$_embe2 === void 0 ? void 0 : (_marketplaceApp$_embe3 = _marketplaceApp$_embe2.logo) === null || _marketplaceApp$_embe3 === void 0 ? void 0 : _marketplaceApp$_embe3._links.image.href,
        origin: 'marketplace',
        name: marketplaceApp.name,
        vendor: (0, $6UgUw.makeVendorFromMarketplaceApp)({
            marketplaceApp: marketplaceApp,
            mpacBaseUrl: mpacBaseUrl
        }),
        version: (_marketplaceApp$_embe4 = marketplaceApp._embedded) === null || _marketplaceApp$_embe4 === void 0 ? void 0 : (_marketplaceApp$_embe5 = _marketplaceApp$_embe4.version) === null || _marketplaceApp$_embe5 === void 0 ? void 0 : _marketplaceApp$_embe5.name,
        privacyPolicy: (0, $c9Mth).validateSafeAbsoluteUrl((_marketplaceApp$vendo = marketplaceApp.vendorLinks) === null || _marketplaceApp$vendo === void 0 ? void 0 : _marketplaceApp$vendo.privacy),
        eula: (0, $c9Mth).validateSafeAbsoluteUrl((_marketplaceApp$_embe6 = marketplaceApp._embedded) === null || _marketplaceApp$_embe6 === void 0 ? void 0 : (_marketplaceApp$_embe7 = _marketplaceApp$_embe6.version) === null || _marketplaceApp$_embe7 === void 0 ? void 0 : (_marketplaceApp$_embe8 = _marketplaceApp$_embe7.vendorLinks) === null || _marketplaceApp$_embe8 === void 0 ? void 0 : _marketplaceApp$_embe8.eula),
        tagLine: marketplaceApp.tagLine,
        youtubeId: (_marketplaceApp$_embe9 = marketplaceApp._embedded) === null || _marketplaceApp$_embe9 === void 0 ? void 0 : (_marketplaceApp$_embe10 = _marketplaceApp$_embe9.version) === null || _marketplaceApp$_embe10 === void 0 ? void 0 : _marketplaceApp$_embe10.youtubeId,
        heroImage: $569b54cdbb73178d$var$getImageUrl((_marketplaceApp$_embe11 = marketplaceApp._embedded) === null || _marketplaceApp$_embe11 === void 0 ? void 0 : (_marketplaceApp$_embe12 = _marketplaceApp$_embe11.version) === null || _marketplaceApp$_embe12 === void 0 ? void 0 : (_marketplaceApp$_embe13 = _marketplaceApp$_embe12._embedded) === null || _marketplaceApp$_embe13 === void 0 ? void 0 : _marketplaceApp$_embe13.hero),
        highlights: $569b54cdbb73178d$var$getHighlights((_marketplaceApp$_embe14 = marketplaceApp._embedded) === null || _marketplaceApp$_embe14 === void 0 ? void 0 : (_marketplaceApp$_embe15 = _marketplaceApp$_embe14.version) === null || _marketplaceApp$_embe15 === void 0 ? void 0 : (_marketplaceApp$_embe16 = _marketplaceApp$_embe15._embedded) === null || _marketplaceApp$_embe16 === void 0 ? void 0 : _marketplaceApp$_embe16.highlights),
        screenshots: $569b54cdbb73178d$var$getScreenshots((_marketplaceApp$_embe17 = marketplaceApp._embedded) === null || _marketplaceApp$_embe17 === void 0 ? void 0 : (_marketplaceApp$_embe18 = _marketplaceApp$_embe17.version) === null || _marketplaceApp$_embe18 === void 0 ? void 0 : (_marketplaceApp$_embe19 = _marketplaceApp$_embe18._embedded) === null || _marketplaceApp$_embe19 === void 0 ? void 0 : _marketplaceApp$_embe19.screenshots),
        moreDetails: (_marketplaceApp$_embe20 = marketplaceApp._embedded) === null || _marketplaceApp$_embe20 === void 0 ? void 0 : (_marketplaceApp$_embe21 = _marketplaceApp$_embe20.version) === null || _marketplaceApp$_embe21 === void 0 ? void 0 : (_marketplaceApp$_embe22 = _marketplaceApp$_embe21.text) === null || _marketplaceApp$_embe22 === void 0 ? void 0 : _marketplaceApp$_embe22.moreDetails,
        isConnectApp: (_marketplaceApp$_embe23 = marketplaceApp._embedded) === null || _marketplaceApp$_embe23 === void 0 ? void 0 : (_marketplaceApp$_embe24 = _marketplaceApp$_embe23.version) === null || _marketplaceApp$_embe24 === void 0 ? void 0 : _marketplaceApp$_embe24.deployment.connect,
        paymentModel: (_marketplaceApp$_embe25 = marketplaceApp._embedded) === null || _marketplaceApp$_embe25 === void 0 ? void 0 : (_marketplaceApp$_embe26 = _marketplaceApp$_embe25.version) === null || _marketplaceApp$_embe26 === void 0 ? void 0 : _marketplaceApp$_embe26.paymentModel,
        ratings: {
            avgStars: ((_marketplaceApp$_embe27 = marketplaceApp._embedded) === null || _marketplaceApp$_embe27 === void 0 ? void 0 : (_marketplaceApp$_embe28 = _marketplaceApp$_embe27.reviews) === null || _marketplaceApp$_embe28 === void 0 ? void 0 : _marketplaceApp$_embe28.averageStars) || 0,
            numRatings: ((_marketplaceApp$_embe29 = marketplaceApp._embedded) === null || _marketplaceApp$_embe29 === void 0 ? void 0 : (_marketplaceApp$_embe30 = _marketplaceApp$_embe29.reviews) === null || _marketplaceApp$_embe30 === void 0 ? void 0 : _marketplaceApp$_embe30.count) || 0
        },
        ecosystemCloudAppId: (_marketplaceApp$_embe31 = marketplaceApp._embedded) === null || _marketplaceApp$_embe31 === void 0 ? void 0 : (_marketplaceApp$_embe32 = _marketplaceApp$_embe31.version) === null || _marketplaceApp$_embe32 === void 0 ? void 0 : (_marketplaceApp$_embe33 = _marketplaceApp$_embe32.cloud) === null || _marketplaceApp$_embe33 === void 0 ? void 0 : _marketplaceApp$_embe33.appId,
        programs: marketplaceApp.programs,
        distribution: $569b54cdbb73178d$export$d233a2c59f71a595(marketplaceApp)
    }));
};

});
parcelRegister("6UgUw", function(module, exports) {

$parcel$export(module.exports, "defaultVendorType", () => $5075172522147306$export$3e11b43dfede5c7c);
$parcel$export(module.exports, "makeVendor", () => $5075172522147306$export$4549ccc66ac8e089);
$parcel$export(module.exports, "makeVendorFromMarketplaceApp", () => $5075172522147306$export$525bb0a8dc0fe384);

var $c9Mth = parcelRequire("c9Mth");

var $g5DHJ = parcelRequire("g5DHJ");
const $5075172522147306$export$3e11b43dfede5c7c = 'thirdParty';
const $5075172522147306$export$4549ccc66ac8e089 = (0, $g5DHJ.Record)({
    id: 0,
    name: null,
    link: null,
    vendorType: $5075172522147306$export$3e11b43dfede5c7c,
    topVendorStatus: undefined
});
const $5075172522147306$export$525bb0a8dc0fe384 = (_ref)=>{
    var _marketplaceApp$_embe, _vendor$_links$altern, _vendor$_links$self$h, _vendor$_links$self, _marketplaceApp$_embe2, _marketplaceApp$_embe3, _marketplaceApp$_embe4, _marketplaceApp$_embe5, _marketplaceApp$_embe6, _marketplaceApp$_embe7;
    let { marketplaceApp: marketplaceApp, mpacBaseUrl: mpacBaseUrl } = _ref;
    const vendor = (_marketplaceApp$_embe = marketplaceApp._embedded) === null || _marketplaceApp$_embe === void 0 ? void 0 : _marketplaceApp$_embe.vendor;
    const vendorLink = vendor === null || vendor === void 0 ? void 0 : (_vendor$_links$altern = vendor._links.alternate) === null || _vendor$_links$altern === void 0 ? void 0 : _vendor$_links$altern.href;
    const id = (_vendor$_links$self$h = vendor === null || vendor === void 0 ? void 0 : (_vendor$_links$self = vendor._links.self) === null || _vendor$_links$self === void 0 ? void 0 : _vendor$_links$self.href.split('/').pop()) !== null && _vendor$_links$self$h !== void 0 ? _vendor$_links$self$h : '0';
    return $5075172522147306$export$4549ccc66ac8e089({
        id: Number.parseInt(id, 10),
        name: vendor === null || vendor === void 0 ? void 0 : vendor.name,
        link: vendorLink ? (0, $c9Mth).validateSafeAbsoluteUrl(mpacBaseUrl + vendorLink) : null,
        vendorType: (_marketplaceApp$_embe2 = marketplaceApp._embedded) !== null && _marketplaceApp$_embe2 !== void 0 && (_marketplaceApp$_embe3 = _marketplaceApp$_embe2.vendor) !== null && _marketplaceApp$_embe3 !== void 0 && _marketplaceApp$_embe3.isAtlassian ? 'internal' : 'thirdParty',
        topVendorStatus: (_marketplaceApp$_embe4 = marketplaceApp._embedded) === null || _marketplaceApp$_embe4 === void 0 ? void 0 : (_marketplaceApp$_embe5 = _marketplaceApp$_embe4.vendor) === null || _marketplaceApp$_embe5 === void 0 ? void 0 : (_marketplaceApp$_embe6 = _marketplaceApp$_embe5.programs) === null || _marketplaceApp$_embe6 === void 0 ? void 0 : (_marketplaceApp$_embe7 = _marketplaceApp$_embe6.topVendor) === null || _marketplaceApp$_embe7 === void 0 ? void 0 : _marketplaceApp$_embe7.status
    });
};

});




parcelRegister("gR0l9", function(module, exports) {

$parcel$export(module.exports, "INSTALLABLE_APP_UPGRADE_INSTALL_MODE", () => $c451dc250aa0bd01$export$1fd9fc9af34de98e);
$parcel$export(module.exports, "makeInstallableAppUpgradeInstallMode", () => $c451dc250aa0bd01$export$fb25e9237d7af4b4);

var $4gzHi = parcelRequire("4gzHi");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $ifMZN = parcelRequire("ifMZN");

var $9eIgo = parcelRequire("9eIgo");
const $c451dc250aa0bd01$export$1fd9fc9af34de98e = 'INSTALLABLE_APP_UPGRADE';
const $c451dc250aa0bd01$export$fb25e9237d7af4b4 = (0, $g5DHJ.Record)({
    type: $c451dc250aa0bd01$export$1fd9fc9af34de98e,
    installableAppByKeyId: (0, $ifMZN.makeInstallableAppByKeyIdentifier)(),
    installableAppToUpgradeTo: (0, $bWAru.Option).empty(),
    installedApp: (0, $4gzHi._makeInstalledApp)(),
    retrievalId: 0,
    status: (0, $9eIgo.makePendingConfirmationInstallStatus)()
});

});
parcelRegister("4gzHi", function(module, exports) {

$parcel$export(module.exports, "_makeInstalledApp", () => $31b458c829d86ba2$export$8ee10d0985daad93);
$parcel$export(module.exports, "makeInstalledAppFromSPIInstalledApp", () => $31b458c829d86ba2$export$7f8bc2bf680f0db4);

var $lQqqi = parcelRequire("lQqqi");
var $8kbfx = parcelRequire("8kbfx");
var $iyohm = parcelRequire("iyohm");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $7r0ma = parcelRequire("7r0ma");

var $Xg3T7 = parcelRequire("Xg3T7");
const $31b458c829d86ba2$export$de7a72915f1a9a78 = (installationId)=>installationId;
const $31b458c829d86ba2$export$8ee10d0985daad93 = (0, $g5DHJ.Record)({
    // Casting to any here since it's a bit too much overhead to define a massive default for something we never interact with
    _original: {},
    authType: (0, $lQqqi.makeTwoLeggedAuthType)(),
    configureUrl: undefined,
    details: (0, $7r0ma.makeSPIAppDisplayDetails)((0, $7r0ma.makeAppDisplayDetails)()),
    getStartedUrl: undefined,
    installationId: '',
    installTime: new Date(),
    installUser: undefined,
    manageAppUrl: undefined,
    marketplaceAppDetails: undefined,
    scopes: (0, $g5DHJ.List)(),
    uninstallInProgress: false,
    upgradeAvailable: false,
    paymentModel: (0, $bWAru.Either).left((0, $Xg3T7.makeFreePaymentModel)())
});
const $31b458c829d86ba2$export$bc7992b6d64fb144 = $31b458c829d86ba2$export$8ee10d0985daad93;
const $31b458c829d86ba2$export$7f8bc2bf680f0db4 = (installedAddon)=>$31b458c829d86ba2$export$bc7992b6d64fb144({
        _original: installedAddon,
        authType: (0, $lQqqi.makeAuthTypeFromSPIAuthType)(installedAddon.authType),
        configureUrl: installedAddon.configureUrl,
        details: (0, $7r0ma.makeSPIAppDisplayDetailsFromSPIAddonDisplayDetails)(installedAddon.details),
        getStartedUrl: installedAddon.getStartedUrl,
        installationId: installedAddon.installationId,
        installTime: installedAddon.installTime,
        installUser: installedAddon.installUser ? (0, $iyohm.makeUserFromSPIUser)(installedAddon.installUser) : undefined,
        manageAppUrl: installedAddon.manageAppUrl,
        scopes: (0, $g5DHJ.List)(installedAddon.scopes).map((0, $8kbfx.makeScopeKey)),
        uninstallInProgress: false,
        upgradeAvailable: !installedAddon.latestVersion,
        paymentModel: (0, $Xg3T7.makePaymentModelFromSPIPaymentModel)(installedAddon.paymentModel)
    });

});
parcelRegister("lQqqi", function(module, exports) {

$parcel$export(module.exports, "makeTwoLeggedAuthType", () => $fe72f3647b54c516$export$6d29d4c11d9b8376);
$parcel$export(module.exports, "foldAuthType", () => $fe72f3647b54c516$export$8115abb41319a3c8);
$parcel$export(module.exports, "makeAuthTypeFromSPIAuthType", () => $fe72f3647b54c516$export$f8c4efe8924e0819);

var $g5DHJ = parcelRequire("g5DHJ");

var $k0za9 = parcelRequire("k0za9");
const $fe72f3647b54c516$var$ASP_AUTH_TYPE = 'ASP';
const $fe72f3647b54c516$var$TWO_LEGGED_AUTH_TYPE = '2LO';
const $fe72f3647b54c516$var$THREE_LEGGED_AUTH_TYPE = '3LO';
const $fe72f3647b54c516$export$3c87d1b2b0775bd6 = (0, $g5DHJ.Record)({
    type: $fe72f3647b54c516$var$ASP_AUTH_TYPE
});
const $fe72f3647b54c516$export$6d29d4c11d9b8376 = (0, $g5DHJ.Record)({
    type: $fe72f3647b54c516$var$TWO_LEGGED_AUTH_TYPE
});
const $fe72f3647b54c516$export$d5c5ddf1a25c3256 = (0, $g5DHJ.Record)({
    type: $fe72f3647b54c516$var$THREE_LEGGED_AUTH_TYPE,
    grants: (0, $g5DHJ.List)()
});
function $fe72f3647b54c516$export$8115abb41319a3c8(authType) {
    return function(asp, twoLegged, threeLegged) {
        switch(authType.type){
            case $fe72f3647b54c516$var$ASP_AUTH_TYPE:
                return asp(authType);
            case $fe72f3647b54c516$var$TWO_LEGGED_AUTH_TYPE:
                return twoLegged(authType);
            case $fe72f3647b54c516$var$THREE_LEGGED_AUTH_TYPE:
                return threeLegged(authType);
            default:
                authType;
                return undefined;
        }
    };
}
const $fe72f3647b54c516$export$f8c4efe8924e0819 = (spiAuthType)=>{
    switch(spiAuthType.type){
        case 'ASP':
            return $fe72f3647b54c516$export$3c87d1b2b0775bd6();
        case '2LO':
            return $fe72f3647b54c516$export$6d29d4c11d9b8376();
        case '3LO':
            return $fe72f3647b54c516$export$d5c5ddf1a25c3256({
                grants: (0, $g5DHJ.List)(spiAuthType.grants).map((0, $k0za9.makeUserGrantFromSPIUserGrant))
            });
        default:
            spiAuthType; // to check that all cases are covered
            return undefined;
    }
};

});
parcelRegister("k0za9", function(module, exports) {

$parcel$export(module.exports, "makeUserGrantFromSPIUserGrant", () => $e90f154bf5c62f07$export$6c336a743fa72373);

var $g5DHJ = parcelRequire("g5DHJ");

var $8kbfx = parcelRequire("8kbfx");

var $iyohm = parcelRequire("iyohm");
const $e90f154bf5c62f07$export$165a600004d75fa9 = (0, $g5DHJ.Record)({
    scopes: (0, $g5DHJ.List)(),
    revokeInProgress: false,
    time: new Date(),
    user: (0, $iyohm._makeUser)() // Using internal unsafe constructor for default
});
const $e90f154bf5c62f07$export$6c336a743fa72373 = (spiUserGrant)=>$e90f154bf5c62f07$export$165a600004d75fa9({
        user: (0, $iyohm.makeUserFromSPIUser)(spiUserGrant.user),
        scopes: (0, $g5DHJ.List)(spiUserGrant.scopes).map((0, $8kbfx.makeScopeKey)),
        time: spiUserGrant.time
    });

});


parcelRegister("Xg3T7", function(module, exports) {

$parcel$export(module.exports, "makeFreePaymentModel", () => $0b21f852d3fbd4cb$export$685ce76b5d1b91db);
$parcel$export(module.exports, "makePaymentModelFromSPIPaymentModel", () => $0b21f852d3fbd4cb$export$f2061a27ae983327);

var $gC8Po = parcelRequire("gC8Po");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $dWeBB = parcelRequire("dWeBB");

var $668Xv = parcelRequire("668Xv");
const $0b21f852d3fbd4cb$export$685ce76b5d1b91db = (0, $g5DHJ.Record)({
    type: 'free'
});
const $0b21f852d3fbd4cb$export$cf4ca76d2a45cbe5 = (0, $g5DHJ.Record)({
    type: 'paid',
    licenseType: (0, $bWAru.Either).left((0, $668Xv.makeEvaluationLicenseType)())
});
const $0b21f852d3fbd4cb$export$6ca88fe7466617e6 = (a)=>$0b21f852d3fbd4cb$export$cf4ca76d2a45cbe5({
        type: 'paid',
        licenseType: (0, $dWeBB.foldLicenseType)(a.licenseType)((e)=>(0, $bWAru.Either).left((0, $668Xv.makeEvaluationLicenseType)(e)), (s)=>(0, $bWAru.Either).right((0, $668Xv.makeSubscriptionLicenseType)(s)))
    });
const $0b21f852d3fbd4cb$export$f2061a27ae983327 = (a)=>{
    switch(a.type){
        case 'free':
            return (0, $bWAru.Either).left($0b21f852d3fbd4cb$export$685ce76b5d1b91db(a));
        case 'paid':
            return (0, $bWAru.Either).right($0b21f852d3fbd4cb$export$6ca88fe7466617e6(a));
        default:
            throw (0, $gC8Po.default).unexpectedCase(a);
    }
};

});
parcelRegister("dWeBB", function(module, exports) {

$parcel$export(module.exports, "foldLicenseType", () => $a25c057b8af177be$export$485b10ad458c54a3);

var $gC8Po = parcelRequire("gC8Po");
const $a25c057b8af177be$export$485b10ad458c54a3 = (a)=>(evaluation, subscription)=>{
        switch(a.type){
            case 'evaluation':
                return evaluation(a);
            case 'subscription':
                return subscription(a);
            default:
                throw (0, $gC8Po.default).unexpectedCase(a);
        }
    };

});

parcelRegister("668Xv", function(module, exports) {

$parcel$export(module.exports, "makeEvaluationLicenseType", () => $470a40a257b09961$export$5bfcfec195bfaecf);
$parcel$export(module.exports, "makeSubscriptionLicenseType", () => $470a40a257b09961$export$ab7d4d2edd11ac8a);

var $g5DHJ = parcelRequire("g5DHJ");
const $470a40a257b09961$export$5bfcfec195bfaecf = (0, $g5DHJ.Record)({
    type: 'evaluation',
    expiry: -1,
    isAutoRenewal: false
});
const $470a40a257b09961$export$f80f13b77a421a99 = (0, $g5DHJ.Record)({
    isAutoRenewal: true
});
const $470a40a257b09961$export$c7294c35415980d3 = (0, $g5DHJ.Record)({
    isAutoRenewal: false,
    endDate: -1
});
const $470a40a257b09961$export$ab7d4d2edd11ac8a = (0, $g5DHJ.Record)({
    type: 'subscription',
    renewalType: $470a40a257b09961$export$f80f13b77a421a99()
});

});




parcelRegister("k5vUT", function(module, exports) {

$parcel$export(module.exports, "INSTRUCTIONAL_INSTALL_MODE", () => $e9fd084069ae88d2$export$32b60382a8108b14);
$parcel$export(module.exports, "makeInstructionalInstallMode", () => $e9fd084069ae88d2$export$b03b57253a091763);

var $g5DHJ = parcelRequire("g5DHJ");

var $irBem = parcelRequire("irBem");
const $e9fd084069ae88d2$export$32b60382a8108b14 = 'INSTRUCTIONAL';
const $e9fd084069ae88d2$export$b03b57253a091763 = (0, $g5DHJ.Record)({
    type: $e9fd084069ae88d2$export$32b60382a8108b14,
    instructionalApp: (0, $irBem.makeInstructionalApp)()
});

});
parcelRegister("irBem", function(module, exports) {

$parcel$export(module.exports, "makeInstallInstructionsStep", () => $d6d7a0d73be3ed6e$export$47a653b32b096653);
$parcel$export(module.exports, "makeInstructionalApp", () => $d6d7a0d73be3ed6e$export$31c1267eb7789c1e);

var $7r0ma = parcelRequire("7r0ma");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
const $d6d7a0d73be3ed6e$export$47a653b32b096653 = (0, $g5DHJ.Record)({
    image: undefined,
    bodyHTML: ''
});
const $d6d7a0d73be3ed6e$export$31c1267eb7789c1e = (0, $g5DHJ.Record)({
    details: (0, $7r0ma.makeMarketplaceAppDisplayDetails)((0, $7r0ma.makeAppDisplayDetails)()),
    learnMoreLink: (0, $bWAru.Option).empty(),
    steps: (0, $g5DHJ.List)()
});

});




parcelRegister("6Xsph", function(module, exports) {

$parcel$export(module.exports, "updateInstalledAppsPostInstall", () => $510e49c3f7ed5781$export$5ce0e5a9c71d41fa);
$parcel$export(module.exports, "updateAllRequestStatusesPostInstall", () => $510e49c3f7ed5781$export$f5cfffa0ef59e2c7);

var $cjFit = parcelRequire("cjFit");

var $cuo8k = parcelRequire("cuo8k");

var $bTrQR = parcelRequire("bTrQR");

var $gRo3n = parcelRequire("gRo3n");

var $bSQ4o = parcelRequire("bSQ4o");

var $55gtq = parcelRequire("55gtq");

var $hNyxl = parcelRequire("hNyxl");
const $510e49c3f7ed5781$export$5ce0e5a9c71d41fa = (dispatch, context, hostConfig, enableDeprecatedInstallationsGQL)=>{
    dispatch((0, $hNyxl.doRetrieveFreshInstalledApps)({
        context: context,
        hostConfig: hostConfig,
        search: (0, $cjFit.emptyString),
        flags: {
            enableDeprecatedInstallationsGQL: enableDeprecatedInstallationsGQL
        }
    }));
};
async function $510e49c3f7ed5781$export$f5cfffa0ef59e2c7(_ref) {
    let { hostInfo: hostInfo, appKey: appKey, appName: appName } = _ref;
    try {
        const productName = hostInfo.product;
        const cloudId = (0, $bSQ4o.getCloudIdFromHostInfo)(hostInfo);
        const currentUserId = await (0, $55gtq.default)().getCurrentUser().then((currentUser)=>currentUser.atlassianAccountId);
        if (cloudId) try {
            (0, $gRo3n.changeAppRequestStatus)({
                productName: productName,
                cloudId: cloudId,
                appKey: appKey,
                appName: appName,
                userId: currentUserId,
                status: (0, $cuo8k.RequestStatus).INSTALLED
            });
        } catch (error) {
            (0, $bTrQR.default).error('postInstallActions/updateAllRequestStatusesPostInstall', "Failed to update the app request status to installed", {
                error: error
            });
        }
        else (0, $bTrQR.default).error('postInstallActions/updateAllRequestStatusesPostInstall', 'Could not fetch cloudId from hostInfo');
    } catch (error) {
        (0, $bTrQR.default).error('postInstallActions/updateAllRequestStatusesPostInstall', 'failed to get Current User', {
            error: error
        });
    }
}

});
parcelRegister("cuo8k", function(module, exports) {

$parcel$export(module.exports, "RequestStatus", () => $917b01c0f922e64b$export$600e7c1f9e0414e1);
const $917b01c0f922e64b$export$600e7c1f9e0414e1 = Object.freeze({
    OPEN: 'OPEN',
    REJECTED: 'REJECTED',
    INSTALLED: 'INSTALLED'
});

});

parcelRegister("gRo3n", function(module, exports) {

$parcel$export(module.exports, "getAppRequests", () => $c464411bf2ffa8ca$export$f365acffb5fff8e6);
$parcel$export(module.exports, "getAppRequestComments", () => $c464411bf2ffa8ca$export$76363e573e1b4e39);
$parcel$export(module.exports, "requestApp", () => $c464411bf2ffa8ca$export$79b82eb311ec4858);
$parcel$export(module.exports, "getAppRequestedStatus", () => $c464411bf2ffa8ca$export$2a448e1f3708455f);
$parcel$export(module.exports, "changeAppRequestStatus", () => $c464411bf2ffa8ca$export$a72a748ae1ab9096);

var $5zQU9 = parcelRequire("5zQU9");

var $55gtq = parcelRequire("55gtq");
function $c464411bf2ffa8ca$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c464411bf2ffa8ca$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c464411bf2ffa8ca$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c464411bf2ffa8ca$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $c464411bf2ffa8ca$var$demandServicePath = (productName, clouldId)=>"/internal/demand/app-requests/product-name/".concat(productName, "/cloud-id/").concat(clouldId);
// Request for an app
const $c464411bf2ffa8ca$var$requestAppUrl = (productName, cloudId, appKey)=>"".concat($c464411bf2ffa8ca$var$demandServicePath(productName, cloudId), "/app-key/").concat(appKey);
// Get a status of the app request for an app key
const $c464411bf2ffa8ca$var$getAppRequestedStatusUrl = (params)=>"".concat($c464411bf2ffa8ca$var$demandServicePath(params.productName, params.cloudId), "/app-key/").concat(params.appKey, "/status?userId=").concat(params.userId);
// Get all the app requests to render Manage App requests dashboard
const $c464411bf2ffa8ca$var$getAppRequestsUrl = (productName, cloudId)=>"".concat($c464411bf2ffa8ca$var$demandServicePath(productName, cloudId));
// Update the status of an app (for ex: Installed | Rejected)
const $c464411bf2ffa8ca$var$updateAllAppRequestStatusUrl = (productName, cloudId, appKey)=>"".concat($c464411bf2ffa8ca$var$demandServicePath(productName, cloudId), "/app-key/").concat(appKey, "/status");
// Get all the user comments for an app
const $c464411bf2ffa8ca$var$getAppRequestCommentsUrl = (_ref)=>{
    let { productName: productName, cloudId: cloudId, appKey: appKey } = _ref;
    return "".concat($c464411bf2ffa8ca$var$demandServicePath(productName, cloudId), "/app-key/").concat(appKey);
};
const $c464411bf2ffa8ca$var$defaultDemandApiConfig = {
    credentials: 'include',
    headers: {
        'Content-Type': 'application/json'
    }
};
const $c464411bf2ffa8ca$export$f365acffb5fff8e6 = (productName, cloudId)=>(0, $55gtq.default)().fetchOk($c464411bf2ffa8ca$var$getAppRequestsUrl(productName, cloudId), $c464411bf2ffa8ca$var$defaultDemandApiConfig).catch((error)=>{
        if (error.status === 404) return {
            allAppRequestDetails: []
        };
        throw error;
    });
const $c464411bf2ffa8ca$export$76363e573e1b4e39 = (requestParams)=>(0, $55gtq.default)().fetchOk($c464411bf2ffa8ca$var$getAppRequestCommentsUrl(requestParams), $c464411bf2ffa8ca$var$defaultDemandApiConfig);
const $c464411bf2ffa8ca$export$79b82eb311ec4858 = (appRequestDetails)=>(0, $55gtq.default)().fetchOk($c464411bf2ffa8ca$var$requestAppUrl(appRequestDetails.productName, appRequestDetails.cloudId, appRequestDetails.appKey), $c464411bf2ffa8ca$var$_objectSpread({
        method: 'post',
        body: JSON.stringify(appRequestDetails)
    }, $c464411bf2ffa8ca$var$defaultDemandApiConfig));
const $c464411bf2ffa8ca$export$2a448e1f3708455f = (appRequestStatusParams)=>(0, $55gtq.default)().fetchOk($c464411bf2ffa8ca$var$getAppRequestedStatusUrl(appRequestStatusParams), $c464411bf2ffa8ca$var$defaultDemandApiConfig);
const $c464411bf2ffa8ca$export$a72a748ae1ab9096 = (requestParams)=>(0, $55gtq.default)().fetchOk($c464411bf2ffa8ca$var$updateAllAppRequestStatusUrl(requestParams.productName, requestParams.cloudId, requestParams.appKey), $c464411bf2ffa8ca$var$_objectSpread({
        method: 'PATCH',
        body: JSON.stringify(requestParams)
    }, $c464411bf2ffa8ca$var$defaultDemandApiConfig));

});

parcelRegister("hNyxl", function(module, exports) {

$parcel$export(module.exports, "FETCH_FRESH_INSTALLED_APPS", () => $cf51cd89d26a6169$export$f94d5d2020025c33);
$parcel$export(module.exports, "RECEIVE_FRESH_INSTALLED_APPS", () => $cf51cd89d26a6169$export$602325d41825c924);
$parcel$export(module.exports, "RECEIVE_FRESH_INSTALLED_APPS_ERROR", () => $cf51cd89d26a6169$export$b1e9cae60d66071b);
$parcel$export(module.exports, "FETCH_MORE_GLOBALLY_INSTALLED_APPS", () => $cf51cd89d26a6169$export$a9af47175e6062c6);
$parcel$export(module.exports, "RECEIVE_MORE_GLOBALLY_INSTALLED_APPS", () => $cf51cd89d26a6169$export$ba44b5f7008af1e0);
$parcel$export(module.exports, "RECEIVE_MORE_GLOBALLY_INSTALLED_APPS_ERROR", () => $cf51cd89d26a6169$export$78cdc633102b41d1);
$parcel$export(module.exports, "FETCH_MORE_LOCALLY_INSTALLED_APPS", () => $cf51cd89d26a6169$export$76c727ace455cafc);
$parcel$export(module.exports, "RECEIVE_MORE_LOCALLY_INSTALLED_APPS", () => $cf51cd89d26a6169$export$38d89daedb6db675);
$parcel$export(module.exports, "RECEIVE_MORE_LOCALLY_INSTALLED_APPS_ERROR", () => $cf51cd89d26a6169$export$c97ab0be150e8aad);
$parcel$export(module.exports, "START_UNINSTALL_APP_FROM_LOCAL_CONTEXT", () => $cf51cd89d26a6169$export$a84aa5c2bf0e289d);
$parcel$export(module.exports, "FINISH_UNINSTALL_APP_FROM_LOCAL_CONTEXT", () => $cf51cd89d26a6169$export$5d641fb510587124);
$parcel$export(module.exports, "UNINSTALL_APP_FROM_LOCAL_CONTEXT_ERROR", () => $cf51cd89d26a6169$export$d32d2f3592d11353);
$parcel$export(module.exports, "START_UNINSTALL_APP_FROM_SITE", () => $cf51cd89d26a6169$export$b49e541ba3f7faf4);
$parcel$export(module.exports, "FINISH_UNINSTALL_APP_FROM_SITE", () => $cf51cd89d26a6169$export$cf26611269c6bbc8);
$parcel$export(module.exports, "UNINSTALL_APP_FROM_SITE_ERROR", () => $cf51cd89d26a6169$export$b0ab23bc2ba7b70e);
$parcel$export(module.exports, "START_REVOKE_USER_GRANT_GLOBALLY", () => $cf51cd89d26a6169$export$dc1a9cce1a7e635c);
$parcel$export(module.exports, "FINISH_REVOKE_USER_GRANT_GLOBALLY", () => $cf51cd89d26a6169$export$6287bb3b5b48789c);
$parcel$export(module.exports, "REVOKE_USER_GRANT_GLOBALLY_ERROR", () => $cf51cd89d26a6169$export$6ae83f02a19a0d42);
$parcel$export(module.exports, "OPEN_SITE_UNINSTALL_DIALOG", () => $cf51cd89d26a6169$export$cc03d89407fc84c4);
$parcel$export(module.exports, "CLOSE_SITE_UNINSTALL_DIALOG", () => $cf51cd89d26a6169$export$b63e80da36a89f24);
$parcel$export(module.exports, "FINISH_FETCH_MARKETPLACE_APP_DETAILS", () => $cf51cd89d26a6169$export$8ea04bca4304f77f);
$parcel$export(module.exports, "openSiteUninstallDialog", () => $cf51cd89d26a6169$export$cfea668f3edaf3b8);
$parcel$export(module.exports, "closeSiteUninstallDialog", () => $cf51cd89d26a6169$export$4684d3b087e4ecc7);
$parcel$export(module.exports, "doRetrieveFreshInstalledApps", () => $cf51cd89d26a6169$export$4d3fcbaee092b544);
$parcel$export(module.exports, "doRetrieveMoreLocallyInstalledApps", () => $cf51cd89d26a6169$export$769b143b4570de91);
$parcel$export(module.exports, "doRetrieveMoreGloballyInstalledApps", () => $cf51cd89d26a6169$export$9cece8f89675ab20);
$parcel$export(module.exports, "doUninstallAppFromLocalContext", () => $cf51cd89d26a6169$export$51aa0e9638b779d6);
$parcel$export(module.exports, "doUninstallAppFromSite", () => $cf51cd89d26a6169$export$12f5296039a5527);
$parcel$export(module.exports, "doRevokeUserGrantGlobally", () => $cf51cd89d26a6169$export$2a451302a72096fc);
$parcel$export(module.exports, "doFetchMarketplaceAppDetails", () => $cf51cd89d26a6169$export$d3a6b573afaf5c6b);

var $7hgtR = parcelRequire("7hgtR");

var $b9ymN = parcelRequire("b9ymN");

var $4gzHi = parcelRequire("4gzHi");
var $7r0ma = parcelRequire("7r0ma");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $kC116 = parcelRequire("kC116");

var $jC5dB = parcelRequire("jC5dB");

var $bPmK9 = parcelRequire("bPmK9");

var $55gtq = parcelRequire("55gtq");

var $iEgm6 = parcelRequire("iEgm6");

var $hsaiM = parcelRequire("hsaiM");

var $8bwkw = parcelRequire("8bwkw");
const $cf51cd89d26a6169$export$b8e5216e6a55335e = 20;
const $cf51cd89d26a6169$export$f94d5d2020025c33 = 'INSTALLED_APPS_FETCH_FRESH_INSTALLED_APPS';
const $cf51cd89d26a6169$export$602325d41825c924 = 'INSTALLED_APPS_RECEIVE_FRESH_INSTALLED_APPS';
const $cf51cd89d26a6169$export$b1e9cae60d66071b = 'INSTALLED_APPS_RECEIVE_FRESH_INSTALLED_APPS_ERROR';
const $cf51cd89d26a6169$export$a9af47175e6062c6 = 'INSTALLED_APPS_FETCH_MORE_GLOBALLY_INSTALLED_APPS';
const $cf51cd89d26a6169$export$ba44b5f7008af1e0 = 'INSTALLED_APPS_RECEIVE_MORE_GLOBALLY_INSTALLED_APPS';
const $cf51cd89d26a6169$export$78cdc633102b41d1 = 'INSTALLED_APPS_RECEIVE_MORE_GLOBALLY_INSTALLED_APPS_ERROR';
const $cf51cd89d26a6169$export$76c727ace455cafc = 'INSTALLED_APPS_FETCH_MORE_LOCALLY_INSTALLED_APPS';
const $cf51cd89d26a6169$export$38d89daedb6db675 = 'INSTALLED_APPS_RECEIVE_MORE_LOCALLY_INSTALLED_APPS';
const $cf51cd89d26a6169$export$c97ab0be150e8aad = 'INSTALLED_APPS_RECEIVE_MORE_LOCALLY_INSTALLED_APPS_ERROR';
const $cf51cd89d26a6169$export$a84aa5c2bf0e289d = 'INSTALLED_APPS_START_UNINSTALL_APP_FROM_LOCAL_CONTEXT';
const $cf51cd89d26a6169$export$5d641fb510587124 = 'INSTALLED_APPS_FINISH_UNINSTALL_APP_FROM_LOCAL_CONTEXT';
const $cf51cd89d26a6169$export$d32d2f3592d11353 = 'INSTALLED_APPS_UNINSTALL_APP_FROM_LOCAL_CONTEXT_ERROR';
const $cf51cd89d26a6169$export$b49e541ba3f7faf4 = 'INSTALLED_APPS_START_UNINSTALL_APP_FROM_SITE';
const $cf51cd89d26a6169$export$cf26611269c6bbc8 = 'INSTALLED_APPS_FINISH_UNINSTALL_APP_FROM_SITE';
const $cf51cd89d26a6169$export$b0ab23bc2ba7b70e = 'INSTALLED_APPS_UNINSTALL_APP_FROM_SITE_ERROR';
const $cf51cd89d26a6169$export$dc1a9cce1a7e635c = 'INSTALLED_APPS_START_REVOKE_USER_GRANT_GLOBALLY';
const $cf51cd89d26a6169$export$6287bb3b5b48789c = 'INSTALLED_APPS_FINISH_REVOKE_USER_GRANT_GLOBALLY';
const $cf51cd89d26a6169$export$6ae83f02a19a0d42 = 'INSTALLED_APPS_REVOKE_USER_GRANT_GLOBALLY_ERROR';
const $cf51cd89d26a6169$export$cc03d89407fc84c4 = 'INSTALLATION_OPEN_SITE_UNINSTALL_DIALOG';
const $cf51cd89d26a6169$export$b63e80da36a89f24 = 'INSTALLATION_CLOSE_SITE_UNINSTALL_DIALOG';
const $cf51cd89d26a6169$export$8ea04bca4304f77f = 'FINISH_FETCH_MARKETPLACE_APP_DETAILS';
function $cf51cd89d26a6169$var$fetchFreshInstalledApps(_ref) {
    let { requestId: requestId, search: search } = _ref;
    return {
        type: $cf51cd89d26a6169$export$f94d5d2020025c33,
        requestId: requestId,
        search: search
    };
}
function $cf51cd89d26a6169$var$receiveFreshInstalledApps(_ref2) {
    let { requestId: requestId, globallyInstalledAppsPage: globallyInstalledAppsPage, locallyInstalledAppsPage: locallyInstalledAppsPage } = _ref2;
    return {
        type: $cf51cd89d26a6169$export$602325d41825c924,
        requestId: requestId,
        globallyInstalledAppsPage: globallyInstalledAppsPage,
        locallyInstalledAppsPage: locallyInstalledAppsPage
    };
}
function $cf51cd89d26a6169$var$receiveFreshInstalledAppsError(_ref3) {
    let { requestId: requestId, dataErrorMessages: dataErrorMessages } = _ref3;
    return {
        type: $cf51cd89d26a6169$export$b1e9cae60d66071b,
        requestId: requestId,
        dataErrorMessages: dataErrorMessages
    };
}
function $cf51cd89d26a6169$var$fetchMoreGloballyInstalledApps(_ref4) {
    let { requestId: requestId, offset: offset } = _ref4;
    return {
        type: $cf51cd89d26a6169$export$a9af47175e6062c6,
        requestId: requestId,
        offset: offset
    };
}
function $cf51cd89d26a6169$var$receiveMoreGloballyInstalledApps(_ref5) {
    let { requestId: requestId, installedAppsPage: installedAppsPage } = _ref5;
    return {
        type: $cf51cd89d26a6169$export$ba44b5f7008af1e0,
        requestId: requestId,
        globallyInstalledAppsPage: installedAppsPage
    };
}
function $cf51cd89d26a6169$var$receiveMoreGloballyInstalledAppsError(_ref6) {
    let { requestId: requestId, dataErrorMessages: dataErrorMessages } = _ref6;
    return {
        type: $cf51cd89d26a6169$export$78cdc633102b41d1,
        requestId: requestId,
        dataErrorMessages: dataErrorMessages
    };
}
function $cf51cd89d26a6169$var$fetchMoreLocallyInstalledApps(_ref7) {
    let { requestId: requestId, offset: offset } = _ref7;
    return {
        type: $cf51cd89d26a6169$export$76c727ace455cafc,
        requestId: requestId,
        offset: offset
    };
}
function $cf51cd89d26a6169$var$receiveMoreLocallyInstalledApps(_ref8) {
    let { requestId: requestId, installedAppsPage: installedAppsPage } = _ref8;
    return {
        type: $cf51cd89d26a6169$export$38d89daedb6db675,
        requestId: requestId,
        locallyInstalledAppsPage: installedAppsPage
    };
}
function $cf51cd89d26a6169$var$receiveMoreLocallyInstalledAppsError(_ref9) {
    let { requestId: requestId, dataErrorMessages: dataErrorMessages } = _ref9;
    return {
        type: $cf51cd89d26a6169$export$c97ab0be150e8aad,
        requestId: requestId,
        dataErrorMessages: dataErrorMessages
    };
}
function $cf51cd89d26a6169$var$startUninstallAppFromLocalContext(_ref10) {
    let { installedApp: installedApp } = _ref10;
    return {
        type: $cf51cd89d26a6169$export$a84aa5c2bf0e289d,
        installedApp: installedApp
    };
}
function $cf51cd89d26a6169$var$finishUninstallAppFromLocalContext(_ref11) {
    let { installedApp: installedApp, context: context } = _ref11;
    return {
        type: $cf51cd89d26a6169$export$5d641fb510587124,
        installedApp: installedApp,
        context: context
    };
}
function $cf51cd89d26a6169$var$uninstallAppFromLocalContextError(_ref12) {
    let { installedApp: installedApp, context: context, message: message } = _ref12;
    return {
        type: $cf51cd89d26a6169$export$d32d2f3592d11353,
        installedApp: installedApp,
        context: context,
        message: message
    };
}
function $cf51cd89d26a6169$var$startUninstallAppFromSite(_ref13) {
    let { installedApp: installedApp } = _ref13;
    return {
        type: $cf51cd89d26a6169$export$b49e541ba3f7faf4,
        installedApp: installedApp
    };
}
function $cf51cd89d26a6169$var$finishUninstallAppFromSite(_ref14) {
    let { installedApp: installedApp, context: context } = _ref14;
    return {
        type: $cf51cd89d26a6169$export$cf26611269c6bbc8,
        installedApp: installedApp,
        context: context
    };
}
function $cf51cd89d26a6169$var$uninstallAppFromSiteError(_ref15) {
    let { installedApp: installedApp, context: context, message: message } = _ref15;
    return {
        type: $cf51cd89d26a6169$export$b0ab23bc2ba7b70e,
        installedApp: installedApp,
        context: context,
        message: message
    };
}
function $cf51cd89d26a6169$var$startRevokeUserGrantGlobally(_ref16) {
    let { installedApp: installedApp, userGrant: userGrant } = _ref16;
    return {
        type: $cf51cd89d26a6169$export$dc1a9cce1a7e635c,
        installedApp: installedApp,
        userGrant: userGrant
    };
}
function $cf51cd89d26a6169$var$finishRevokeUserGrantGlobally(_ref17) {
    let { installedApp: installedApp, userGrant: userGrant } = _ref17;
    return {
        type: $cf51cd89d26a6169$export$6287bb3b5b48789c,
        installedApp: installedApp,
        userGrant: userGrant
    };
}
function $cf51cd89d26a6169$var$revokeUserGrantGloballyError(_ref18) {
    let { installedApp: installedApp, userGrant: userGrant, message: message } = _ref18;
    return {
        type: $cf51cd89d26a6169$export$6ae83f02a19a0d42,
        installedApp: installedApp,
        userGrant: userGrant,
        message: message
    };
}
function $cf51cd89d26a6169$export$cfea668f3edaf3b8(_ref19) {
    let { installedApp: installedApp } = _ref19;
    return {
        type: $cf51cd89d26a6169$export$cc03d89407fc84c4,
        installedApp: installedApp
    };
}
function $cf51cd89d26a6169$export$4684d3b087e4ecc7(_ref20) {
    let { installedApp: installedApp } = _ref20;
    return {
        type: $cf51cd89d26a6169$export$b63e80da36a89f24,
        installedApp: installedApp
    };
}
const $cf51cd89d26a6169$var$finishFetchMarketplaceAppDetails = (_ref21)=>{
    let { marketplaceAppDetails: marketplaceAppDetails, isGlobalContext: isGlobalContext } = _ref21;
    return {
        type: $cf51cd89d26a6169$export$8ea04bca4304f77f,
        marketplaceAppDetails: marketplaceAppDetails,
        isGlobalContext: isGlobalContext
    };
};
function $cf51cd89d26a6169$var$getInstalledApps(_ref22) {
    let { contextId: contextId, search: search, offset: offset, flags: flags } = _ref22;
    const query = {
        search: search || '',
        offset: offset,
        limit: $cf51cd89d26a6169$export$b8e5216e6a55335e
    };
    const options = flags ? {
        contextId: contextId,
        query: query,
        flags: flags
    } : {
        contextId: contextId,
        query: query
    };
    return (0, $55gtq.default)().getInstalledAddons(options).then((paginatedAddons)=>(0, $bPmK9.makePaginatedValues)({
            values: (0, $g5DHJ.List)(paginatedAddons.values).map((0, $4gzHi.makeInstalledAppFromSPIInstalledApp)),
            nextOffset: (0, $bWAru.Option).of(paginatedAddons.nextOffset),
            totalCount: paginatedAddons.totalCount
        }));
}
const $cf51cd89d26a6169$var$resolveGlobalContextIdFromLocal = (_ref23)=>{
    let { localContext: localContext } = _ref23;
    return localContext.id.substring(0, localContext.id.indexOf('/') + 1);
};
function $cf51cd89d26a6169$export$4d3fcbaee092b544(_ref24) {
    let { hostConfig: hostConfig, context: context, search: search, flags: flags } = _ref24;
    return (dispatch)=>{
        const requestId = (0, $hsaiM.getRequestId)();
        dispatch($cf51cd89d26a6169$var$fetchFreshInstalledApps({
            requestId: requestId,
            search: search
        }));
        const installedAppsPromises = [
            $cf51cd89d26a6169$var$getInstalledApps({
                contextId: context.id,
                search: search,
                offset: 0,
                flags: flags
            })
        ];
        const globalContextId = $cf51cd89d26a6169$var$resolveGlobalContextIdFromLocal({
            localContext: context
        });
        if (globalContextId !== context.id) installedAppsPromises.push($cf51cd89d26a6169$var$getInstalledApps({
            contextId: globalContextId,
            search: search,
            offset: 0,
            flags: flags
        }));
        Promise.all(installedAppsPromises).then((_ref25)=>{
            let [locallyInstalledAppsPage, globalInstalledApps] = _ref25;
            const globallyInstalledAppsPage = globalInstalledApps || (0, $bPmK9.makePaginatedValues)();
            dispatch($cf51cd89d26a6169$var$receiveFreshInstalledApps({
                requestId: requestId,
                search: search,
                locallyInstalledAppsPage: locallyInstalledAppsPage,
                globallyInstalledAppsPage: globallyInstalledAppsPage
            }));
        }, (error)=>{
            dispatch($cf51cd89d26a6169$var$receiveFreshInstalledAppsError({
                requestId: requestId,
                dataErrorMessages: (0, $7hgtR.makeDataErrorMessages)([
                    error
                ])
            }));
            dispatch((0, $8bwkw.addCaasErrorFlag)({
                message: error,
                key: "fetch-fresh-apps-error-".concat(context.id),
                hostConfig: hostConfig
            }));
            console.error('getInstalledAddons call for freshInstalledApps was rejected by the SPI and returned the following message:', error);
        });
    };
}
function $cf51cd89d26a6169$var$retrieveMoreInstalledAppsFactory(_ref26) {
    let { retrieveMoreInstalledApps: retrieveMoreInstalledApps, receiveMoreInstalledApps: receiveMoreInstalledApps, retrieveMoreInstalledAppsError: retrieveMoreInstalledAppsError } = _ref26;
    return (_ref27)=>{
        let { contextId: contextId, hostConfig: hostConfig, search: search, offset: offset } = _ref27;
        return (dispatch)=>{
            const requestId = (0, $hsaiM.getRequestId)();
            dispatch(retrieveMoreInstalledApps({
                requestId: requestId,
                offset: offset
            }));
            $cf51cd89d26a6169$var$getInstalledApps({
                contextId: contextId,
                search: search,
                offset: offset
            }).then((installedAppsPage)=>{
                dispatch(receiveMoreInstalledApps({
                    requestId: requestId,
                    installedAppsPage: installedAppsPage
                }));
            }, (error)=>{
                dispatch(retrieveMoreInstalledAppsError({
                    requestId: requestId,
                    dataErrorMessages: (0, $7hgtR.makeDataErrorMessages)([
                        error
                    ])
                }));
                dispatch((0, $8bwkw.addCaasErrorFlag)({
                    message: error,
                    key: "fetch-more-apps-error-".concat(contextId),
                    hostConfig: hostConfig
                }));
                console.error('getInstalledAddons call for moreInstalledApps was rejected by the SPI and returned the following message:', error);
            });
        };
    };
}
const $cf51cd89d26a6169$var$retrieveLocallyInstalledApps = $cf51cd89d26a6169$var$retrieveMoreInstalledAppsFactory({
    receiveMoreInstalledApps: $cf51cd89d26a6169$var$receiveMoreLocallyInstalledApps,
    retrieveMoreInstalledApps: $cf51cd89d26a6169$var$fetchMoreLocallyInstalledApps,
    retrieveMoreInstalledAppsError: $cf51cd89d26a6169$var$receiveMoreLocallyInstalledAppsError
});
const $cf51cd89d26a6169$export$769b143b4570de91 = (_ref28)=>{
    let { hostConfig: hostConfig, context: context, search: search, offset: offset = 0 } = _ref28;
    return $cf51cd89d26a6169$var$retrieveLocallyInstalledApps({
        contextId: context.id,
        hostConfig: hostConfig,
        search: search,
        offset: offset
    });
};
const $cf51cd89d26a6169$var$retrieveGloballyInstalledApps = $cf51cd89d26a6169$var$retrieveMoreInstalledAppsFactory({
    receiveMoreInstalledApps: $cf51cd89d26a6169$var$receiveMoreGloballyInstalledApps,
    retrieveMoreInstalledApps: $cf51cd89d26a6169$var$fetchMoreGloballyInstalledApps,
    retrieveMoreInstalledAppsError: $cf51cd89d26a6169$var$receiveMoreGloballyInstalledAppsError
});
const $cf51cd89d26a6169$export$9cece8f89675ab20 = (_ref29)=>{
    let { hostConfig: hostConfig, context: context, search: search, offset: offset = 0 } = _ref29;
    return $cf51cd89d26a6169$var$retrieveGloballyInstalledApps({
        contextId: $cf51cd89d26a6169$var$resolveGlobalContextIdFromLocal({
            localContext: context
        }),
        hostConfig: hostConfig,
        search: search,
        offset: offset
    });
};
const $cf51cd89d26a6169$export$51aa0e9638b779d6 = (_ref30)=>{
    let { context: context, installedApp: installedApp, hostConfig: hostConfig } = _ref30;
    return (dispatch)=>{
        const appKey = installedApp.details.key;
        return new Promise((resolve, reject)=>{
            dispatch($cf51cd89d26a6169$var$startUninstallAppFromLocalContext({
                installedApp: installedApp
            }));
            (0, $55gtq.default)().uninstallAddon({
                addon: installedApp._original,
                contextId: context.id
            }).then(()=>{
                dispatch($cf51cd89d26a6169$var$finishUninstallAppFromLocalContext({
                    installedApp: installedApp,
                    context: context
                }));
                const appName = installedApp.details.name;
                const contextName = context.name || (0, $kC116.defaultContextName);
                dispatch((0, $8bwkw.addFlag)({
                    flag: (0, $jC5dB.makeFlag)({
                        key: "".concat(appKey, "-uninstall-from-context-success"),
                        title: "".concat(appName, " was removed from ").concat(contextName),
                        appearance: (0, $jC5dB.SUCCESS_APPEARANCE)
                    })
                }));
                resolve();
            }, (error)=>{
                dispatch((0, $8bwkw.addCaasErrorFlag)({
                    message: error,
                    key: "uninstall-error-".concat(appKey, "-").concat(context.id),
                    hostConfig: hostConfig
                }));
                dispatch($cf51cd89d26a6169$var$uninstallAppFromLocalContextError({
                    installedApp: installedApp,
                    context: context,
                    message: error
                }));
                console.error('uninstallAddon was rejected by the SPI and returned the following message:', error);
                reject();
            });
        });
    };
};
function $cf51cd89d26a6169$export$12f5296039a5527(_ref31) {
    let { installedApp: installedApp, hostConfig: hostConfig, context: context } = _ref31;
    return (dispatch)=>{
        const appKey = installedApp.details.key;
        const appName = (0, $iEgm6.resolveFieldWithFallback)((add)=>add.name, installedApp.marketplaceAppDetails, installedApp.details);
        const successNotification = hostConfig.removeFromSite.successNotification;
        return new Promise((resolve, reject)=>{
            dispatch($cf51cd89d26a6169$var$startUninstallAppFromSite({
                installedApp: installedApp
            }));
            (0, $55gtq.default)().uninstallAddonFromSite({
                addon: installedApp._original
            }).then(()=>{
                dispatch($cf51cd89d26a6169$var$finishUninstallAppFromSite({
                    installedApp: installedApp,
                    context: context
                }));
                dispatch((0, $8bwkw.addFlag)({
                    flag: (0, $jC5dB.makeFlag)({
                        key: "".concat(appKey, "-uninstall-from-site-success"),
                        title: successNotification(appName),
                        appearance: (0, $jC5dB.SUCCESS_APPEARANCE)
                    })
                }));
                resolve();
            }, (error)=>{
                dispatch((0, $8bwkw.addCaasErrorFlag)({
                    message: error,
                    key: "uninstall-error-".concat(appKey),
                    hostConfig: hostConfig
                }));
                dispatch($cf51cd89d26a6169$var$uninstallAppFromSiteError({
                    installedApp: installedApp,
                    context: context,
                    message: error
                }));
                reject();
                console.error('uninstallAddonFromSite was rejected by the SPI and returned the following message:', error);
            });
        });
    };
}
function $cf51cd89d26a6169$export$2a451302a72096fc(_ref32) {
    let { hostConfig: hostConfig, installedApp: installedApp, userGrant: userGrant } = _ref32;
    return (dispatch)=>{
        dispatch($cf51cd89d26a6169$var$startRevokeUserGrantGlobally({
            installedApp: installedApp,
            userGrant: userGrant
        }));
        (0, $55gtq.default)().revokeUserGrant({
            addon: installedApp._original,
            user: userGrant.user._original
        }).then(()=>{
            dispatch($cf51cd89d26a6169$var$finishRevokeUserGrantGlobally({
                installedApp: installedApp,
                userGrant: userGrant
            }));
            dispatch((0, $8bwkw.addFlag)({
                flag: (0, $jC5dB.makeFlag)({
                    key: "".concat(installedApp.details.key, "-revoke-user-grant-success"),
                    title: "".concat((0, $iEgm6.resolveFieldWithFallback)((add)=>add.name, installedApp.marketplaceAppDetails, installedApp.details), " was successfully disconnected"),
                    appearance: (0, $jC5dB.SUCCESS_APPEARANCE)
                })
            }));
        }, (error)=>{
            dispatch((0, $8bwkw.addCaasErrorFlag)({
                message: error,
                key: "revoke-user-grant-error-".concat(installedApp.details.key),
                hostConfig: hostConfig
            }));
            dispatch($cf51cd89d26a6169$var$revokeUserGrantGloballyError({
                installedApp: installedApp,
                userGrant: userGrant,
                message: error
            }));
            console.error('revokeUserGrant was rejected by the SPI and returned the following message:', error);
        });
    };
}
const $cf51cd89d26a6169$export$d3a6b573afaf5c6b = (_ref33)=>{
    let { mpacBaseUrl: mpacBaseUrl, appKey: appKey, isGlobalContext: isGlobalContext } = _ref33;
    return (dispatch)=>(0, $b9ymN.getCloudMarketplaceAppByKey)(mpacBaseUrl, appKey).then((marketplaceApp)=>(0, $7r0ma.makeMarketplaceAppDisplayDetailsFromMarketplaceApp)({
                marketplaceApp: marketplaceApp,
                mpacBaseUrl: mpacBaseUrl
            })).then((marketplaceAppDetails)=>{
            dispatch($cf51cd89d26a6169$var$finishFetchMarketplaceAppDetails({
                marketplaceAppDetails: marketplaceAppDetails,
                isGlobalContext: isGlobalContext
            }));
            return marketplaceAppDetails;
        }, (error)=>{
            console.warn('Failed to fetch App data from Marketplace.', error);
            return error;
        });
};

});
parcelRegister("b9ymN", function(module, exports) {

$parcel$export(module.exports, "getCloudMarketplaceAppByKey", () => $81eb317770d0c6db$export$743d5a58cefe3ad5);

var $dO8LH = parcelRequire("dO8LH");

var $gC9Xo = parcelRequire("gC9Xo");
const $81eb317770d0c6db$export$6b17afb8693d5324 = (mpacBaseUrl, appKey)=>(0, $dO8LH.fetchOk)(mpacBaseUrl + "/rest/2/addons/".concat(appKey, "?hosting=cloud&withVersion=true")).then((response)=>response.json());
const $81eb317770d0c6db$export$743d5a58cefe3ad5 = (mpacBaseUrl, appKey)=>$81eb317770d0c6db$export$6b17afb8693d5324(mpacBaseUrl, appKey).then((0, $gC9Xo.makeMarketplaceApp));
const $81eb317770d0c6db$export$cc4d33cccec79e8d = (mpacBaseUrl, appId)=>(0, $dO8LH.fetchOk)("".concat(mpacBaseUrl, "/rest/internal/apps/").concat(appId, "?hosting=cloud&withVersion=true")).then((response)=>response.json());
const $81eb317770d0c6db$export$a8a38c76dcc74dfa = (mpacBaseUrl, appId)=>$81eb317770d0c6db$export$cc4d33cccec79e8d(mpacBaseUrl, appId).then((0, $gC9Xo.makeMarketplaceApp));

});
parcelRegister("gC9Xo", function(module, exports) {

$parcel$export(module.exports, "makeMarketplaceApp", () => $c187eb2c340792d6$export$dcbc6fb843a92543);

var $g5DHJ = parcelRequire("g5DHJ");

var $ly50n = parcelRequire("ly50n");
const $c187eb2c340792d6$export$dcbc6fb843a92543 = (0, $g5DHJ.Record)({
    key: (0, $ly50n.makeAppKey)(''),
    name: '',
    summary: undefined,
    tagLine: undefined,
    _embedded: undefined,
    legacy: undefined,
    vendorLinks: undefined,
    programs: undefined
});

});


parcelRegister("bPmK9", function(module, exports) {

$parcel$export(module.exports, "makePaginatedValues", () => $89c6198330449895$export$5cc995f119f589d8);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
const $89c6198330449895$export$5cc995f119f589d8 = (0, $g5DHJ.Record)({
    values: (0, $g5DHJ.List)(),
    nextOffset: (0, $bWAru.Option).empty(),
    totalCount: 0
});

});




parcelRegister("6BOFf", function(module, exports) {

$parcel$export(module.exports, "FINISH_DETERMINING_INSTALL_MODE", () => $4cfd7fa604968627$export$cbebb8bc69111133);
$parcel$export(module.exports, "DETERMINING_INSTALL_MODE_ERROR", () => $4cfd7fa604968627$export$1e0840157eac12c);
$parcel$export(module.exports, "parseInstalledAddonResult", () => $4cfd7fa604968627$export$1ad37f4eb25808e2);
$parcel$export(module.exports, "getInstallMode", () => $4cfd7fa604968627$export$a9593d7012654efb);
$parcel$export(module.exports, "doInitiateInstallModeForIdentifier", () => $4cfd7fa604968627$export$9280e5c04d16e3df);

var $5zQU9 = parcelRequire("5zQU9");

var $cjFit = parcelRequire("cjFit");

var $ly50n = parcelRequire("ly50n");

var $4gzHi = parcelRequire("4gzHi");
var $7r0ma = parcelRequire("7r0ma");
var $eNZVr = parcelRequire("eNZVr");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $hCQtM = parcelRequire("hCQtM");

var $ifMZN = parcelRequire("ifMZN");

var $8ZSlI = parcelRequire("8ZSlI");

var $4s0An = parcelRequire("4s0An");

var $9eIgo = parcelRequire("9eIgo");

var $k5vUT = parcelRequire("k5vUT");

var $irBem = parcelRequire("irBem");

var $55gtq = parcelRequire("55gtq");

var $3DsUo = parcelRequire("3DsUo");

var $hsaiM = parcelRequire("hsaiM");

var $38gnU = parcelRequire("38gnU");

var $dSumc = parcelRequire("dSumc");
function $4cfd7fa604968627$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4cfd7fa604968627$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4cfd7fa604968627$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4cfd7fa604968627$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4cfd7fa604968627$export$cbebb8bc69111133 = 'INSTALLATION_FINISH_DETERMINING_INSTALL_MODE';
const $4cfd7fa604968627$export$1e0840157eac12c = 'INSTALLATION_DETERMINING_INSTALL_MODE_ERROR';
const $4cfd7fa604968627$var$finishDeterminingInstallMode = (_ref)=>{
    let { installMode: installMode, retrievalId: retrievalId } = _ref;
    return {
        type: $4cfd7fa604968627$export$cbebb8bc69111133,
        installMode: installMode,
        retrievalId: retrievalId
    };
};
const $4cfd7fa604968627$var$determiningInstallModeError = (_ref2)=>{
    let { error: error, installableAppId: installableAppId, retrievalId: retrievalId } = _ref2;
    return {
        type: $4cfd7fa604968627$export$1e0840157eac12c,
        error: error,
        installableAppId: installableAppId,
        retrievalId: retrievalId
    };
};
const $4cfd7fa604968627$var$attemptInstructionalAppInstallMode = (_ref3)=>{
    var _marketplaceApp$_embe;
    let { mpacBaseUrl: mpacBaseUrl, marketplaceApp: marketplaceApp } = _ref3;
    return (0, $bWAru.Option).of((_marketplaceApp$_embe = marketplaceApp._embedded) === null || _marketplaceApp$_embe === void 0 ? void 0 : _marketplaceApp$_embe.version).map((v)=>{
        var _v$_embedded, _v$vendorLinks, _v$vendorLinks2;
        return v.deployment.connect ? (0, $bWAru.Either).left('Instructional apps cannot be connect apps') : (0, $bWAru.Either).right((0, $k5vUT.makeInstructionalInstallMode)({
            instructionalApp: (0, $irBem.makeInstructionalApp)({
                details: (0, $7r0ma.makeMarketplaceAppDisplayDetailsFromMarketplaceApp)({
                    marketplaceApp: marketplaceApp,
                    mpacBaseUrl: mpacBaseUrl
                }),
                steps: (0, $g5DHJ.List)((_v$_embedded = v._embedded) === null || _v$_embedded === void 0 ? void 0 : _v$_embedded.instructions).map((step)=>{
                    var _step$_embedded;
                    return (0, $irBem.makeInstallInstructionsStep)({
                        image: (_step$_embedded = step._embedded) === null || _step$_embedded === void 0 ? void 0 : _step$_embedded.image._links.image.href,
                        bodyHTML: step.body
                    });
                }),
                learnMoreLink: (0, $cjFit.nonEmptyString)(((_v$vendorLinks = v.vendorLinks) === null || _v$vendorLinks === void 0 ? void 0 : _v$vendorLinks.learnMore) || ((_v$vendorLinks2 = v.vendorLinks) === null || _v$vendorLinks2 === void 0 ? void 0 : _v$vendorLinks2.binary))
            })
        }));
    }).getOrElse((0, $bWAru.Either).left('Cannot resolve data from Marketplace response'));
};
const $4cfd7fa604968627$var$attemptInstallableAppForDefaultInstallMode = (_ref4)=>{
    let { installableAddon: installableAddon, installableAppId: installableAppId, installedAddon: installedAddon, installPermission: installPermission, marketplaceApp: marketplaceApp, mpacBaseUrl: mpacBaseUrl, relayState: relayState } = _ref4;
    return (0, $bWAru.Either).map2(installableAddon.fold((error)=>(0, $bWAru.Either).left("InstallableApp install mode needs a successful installableAddon resolved: ".concat(error)), (r)=>(0, $bWAru.Either).right(r)), installPermission.fold((error)=>(0, $bWAru.Either).left("InstallableApp install mode needs a successful installPermission resolved: ".concat(error)), (r)=>(0, $bWAru.Either).right(r)), (ia, p)=>(0, $4s0An.makeInstallableAppDefaultInstallMode)({
            installableApp: (0, $hCQtM.makeInstallableAppFromSPIInstallableAddonAndMarketplaceAppData)(ia, marketplaceApp, mpacBaseUrl),
            installPermission: (0, $eNZVr.makePermissionCheckResultFromSPI)(p),
            installedApp: installedAddon.toOption().map((0, $4gzHi.makeInstalledAppFromSPIInstalledApp)),
            installableAppId: installableAppId,
            relayState: relayState,
            status: (0, $9eIgo.makePendingConfirmationInstallStatus)()
        }));
};
const $4cfd7fa604968627$export$1ad37f4eb25808e2 = (installedAddonResult)=>{
    if (installedAddonResult.status && installedAddonResult.status === 'NOT_FOUND') throw new Error("Failed to fetch app details while determining install mode");
    const installedAddon = installedAddonResult;
    return installedAddon;
};
const $4cfd7fa604968627$var$handleAriDetermineMode = (mpacBaseUrl, installableAppByARI, relayState, context, flags)=>Promise.all([
        (0, $38gnU.retrieveAppDataByAri)({
            installableAppByARI: installableAppByARI,
            mpacBaseUrl: mpacBaseUrl
        }),
        (0, $3DsUo.reflect)((0, $55gtq.default)().getInstalledAddon({
            contextId: context.id,
            addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)((0, $ifMZN.makeInstallableAppByAriIdentifier)({
                ari: (0, $ly50n.makeAppKey)(installableAppByARI.ari),
                appKey: (0, $ly50n.makeAppKey)(installableAppByARI.appKey)
            })),
            flags: $4cfd7fa604968627$var$_objectSpread($4cfd7fa604968627$var$_objectSpread({}, flags), {}, {
                retryForLicenseDetails: false
            })
        }).then((installedAddonResult)=>$4cfd7fa604968627$export$1ad37f4eb25808e2(installedAddonResult)))
    ]).then((_ref5)=>{
        let [{ installableAddon: installableAddon, installPermission: installPermission, marketplaceApp: marketplaceApp }, installedAddon] = _ref5;
        return $4cfd7fa604968627$var$attemptInstallableAppForDefaultInstallMode({
            installableAddon: installableAddon,
            installableAppId: installableAppByARI,
            installedAddon: installedAddon,
            installPermission: installPermission,
            marketplaceApp: marketplaceApp,
            mpacBaseUrl: mpacBaseUrl,
            relayState: relayState
        }).map((0, $bWAru.Either).right).getOrElseL(()=>$4cfd7fa604968627$var$attemptInstructionalAppInstallMode({
                mpacBaseUrl: mpacBaseUrl,
                marketplaceApp: marketplaceApp
            }));
    }).catch((error)=>(0, $bWAru.Either).left(error));
const $4cfd7fa604968627$export$a9593d7012654efb = (_ref6)=>{
    let { mpacBaseUrl: mpacBaseUrl, installableAppId: installableAppId, relayState: relayState, context: context, flags: flags, hostCmtEnabled: hostCmtEnabled = false } = _ref6;
    const installMode = (0, $ifMZN.foldInstallableAppIdentifier)(installableAppId)((installableAppByKeyId)=>Promise.all([
            (0, $38gnU.retrieveAppDataByKey)({
                installableAppByKeyId: installableAppByKeyId,
                mpacBaseUrl: mpacBaseUrl
            }, hostCmtEnabled),
            (0, $3DsUo.reflect)((0, $55gtq.default)().getInstalledAddon({
                contextId: context.id,
                addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)((0, $ifMZN.makeInstallableAppByKeyIdentifier)({
                    key: (0, $ly50n.makeAppKey)(installableAppByKeyId.key)
                }))
            }).then((installedAddonResult)=>$4cfd7fa604968627$export$1ad37f4eb25808e2(installedAddonResult)))
        ]).then((_ref7)=>{
            let [{ installableAddon: installableAddon, installPermission: installPermission, marketplaceApp: marketplaceApp }, installedAddon] = _ref7;
            return $4cfd7fa604968627$var$attemptInstallableAppForDefaultInstallMode({
                installableAddon: installableAddon,
                installableAppId: installableAppByKeyId,
                installedAddon: installedAddon,
                installPermission: installPermission,
                marketplaceApp: marketplaceApp,
                mpacBaseUrl: mpacBaseUrl,
                relayState: relayState
            }).map((0, $bWAru.Either).right).getOrElseL(()=>$4cfd7fa604968627$var$attemptInstructionalAppInstallMode({
                    mpacBaseUrl: mpacBaseUrl,
                    marketplaceApp: marketplaceApp
                }));
        }).catch((error)=>(0, $bWAru.Either).left(error)), (installableAppByUrlId)=>(0, $38gnU.retrieveAppDataByUrl)({
            installableAppByUrlId: installableAppByUrlId,
            mpacBaseUrl: mpacBaseUrl
        }).then((_ref8)=>{
            let { installableAddon: installableAddon, installPermission: installPermission, marketplaceApp: marketplaceApp } = _ref8;
            const installedAddonPromise = installableAddon.fold(()=>Promise.resolve((0, $bWAru.Either).left('No installableAddon')), (ia)=>(0, $3DsUo.reflect)((0, $55gtq.default)().getInstalledAddon({
                    contextId: context.id,
                    addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)((0, $ifMZN.makeInstallableAppByKeyIdentifier)({
                        key: (0, $ly50n.makeAppKey)(ia.details.key)
                    }))
                }).then((installedAddonResult)=>$4cfd7fa604968627$export$1ad37f4eb25808e2(installedAddonResult))));
            return installedAddonPromise.then((installedAddon)=>$4cfd7fa604968627$var$attemptInstallableAppForDefaultInstallMode({
                    installableAddon: installableAddon,
                    installPermission: installPermission,
                    installableAppId: installableAppByUrlId,
                    installedAddon: installedAddon,
                    marketplaceApp: marketplaceApp,
                    mpacBaseUrl: mpacBaseUrl,
                    relayState: relayState
                }));
        }).catch((error)=>(0, $bWAru.Either).left(error)), (installableAppByARI)=>$4cfd7fa604968627$var$handleAriDetermineMode(mpacBaseUrl, installableAppByARI, relayState, context, flags));
    return installMode;
};
const $4cfd7fa604968627$export$9280e5c04d16e3df = (_ref9)=>{
    let { mpacBaseUrl: mpacBaseUrl, installableAppId: installableAppId, relayState: relayState, context: context } = _ref9;
    return (dispatch)=>{
        const retrievalId = (0, $hsaiM.getRequestId)();
        const flags = {
            enableReactivateForgeAppFromEmcee: false
        };
        dispatch((0, $dSumc.doSetInstallMode)({
            installMode: (0, $8ZSlI.makeDeterminingInstallMode)({
                retrievalId: retrievalId
            })
        }));
        return $4cfd7fa604968627$export$a9593d7012654efb({
            mpacBaseUrl: mpacBaseUrl,
            installableAppId: installableAppId,
            relayState: relayState,
            context: context,
            flags: flags
        }).then((result)=>result.fold((error)=>{
                console.error("Either the SPI's getInstallableAddon returned an error or invalid shape, or MPAC returned an invalid instructional listing: ", error, "installableAppId=".concat(installableAppId.toString()));
                dispatch($4cfd7fa604968627$var$determiningInstallModeError({
                    error: error,
                    installableAppId: installableAppId,
                    retrievalId: retrievalId
                }));
            }, (installMode)=>{
                dispatch($4cfd7fa604968627$var$finishDeterminingInstallMode({
                    installMode: installMode,
                    retrievalId: retrievalId
                }));
            }));
    };
};

});
parcelRegister("38gnU", function(module, exports) {

$parcel$export(module.exports, "retrieveAppDataByKey", () => $247ed41d36312c16$export$e920efe13d7dfa6f);
$parcel$export(module.exports, "retrieveAppDataByUrl", () => $247ed41d36312c16$export$51b206d744e4540c);
$parcel$export(module.exports, "retrieveAppDataByAri", () => $247ed41d36312c16$export$7e0e388244c7e50d);

var $b9ymN = parcelRequire("b9ymN");
var $ly50n = parcelRequire("ly50n");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $ifMZN = parcelRequire("ifMZN");

var $55gtq = parcelRequire("55gtq");

var $3DsUo = parcelRequire("3DsUo");
const $247ed41d36312c16$var$getAppPermission = (ia)=>(0, $55gtq.default)().hasInstallPermission({
        addon: ia
    }).then((pc)=>({
            installableAddon: ia,
            installPermission: (0, $bWAru.Either).right(pc)
        })).catch((error)=>({
            installableAddon: ia,
            installPermission: (0, $bWAru.Either).left(error)
        }));
const $247ed41d36312c16$export$e920efe13d7dfa6f = function retrieveAppDataByKey(_ref) {
    let { installableAppByKeyId: installableAppByKeyId, mpacBaseUrl: mpacBaseUrl } = _ref;
    let hostCmtEnabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return Promise.all([
        (0, $3DsUo.reflect)((0, $55gtq.default)().getInstallableAddon({
            addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)(installableAppByKeyId),
            hostCmtEnabled: hostCmtEnabled
        }).then($247ed41d36312c16$var$getAppPermission)),
        (0, $b9ymN.getCloudMarketplaceAppByKey)(mpacBaseUrl, installableAppByKeyId.key)
    ]).then((_ref2)=>{
        let [appPermission, marketplaceApp] = _ref2;
        return {
            installableAddon: appPermission.map((a)=>a.installableAddon),
            installPermission: appPermission.flatMap((a)=>a.installPermission),
            marketplaceApp: marketplaceApp
        };
    });
};
const $247ed41d36312c16$export$51b206d744e4540c = (_ref3)=>{
    let { installableAppByUrlId: installableAppByUrlId, mpacBaseUrl: mpacBaseUrl } = _ref3;
    return(// Only succeed in install-by-URL case if the SPI request succeeds
    (0, $55gtq.default)().getInstallableAddon({
        addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)(installableAppByUrlId)
    }).then((installableAddon)=>Promise.all([
            (0, $b9ymN.getCloudMarketplaceAppByKey)(mpacBaseUrl, (0, $ly50n.makeAppKey)(installableAddon.details.key)),
            (0, $3DsUo.reflect)($247ed41d36312c16$var$getAppPermission(installableAddon))
        ]).then((_ref4)=>{
            let [marketplaceApp, appPermission] = _ref4;
            return {
                installableAddon: (0, $bWAru.Either).right(installableAddon),
                installPermission: appPermission.flatMap((a)=>a.installPermission),
                marketplaceApp: marketplaceApp
            };
        })));
};
const $247ed41d36312c16$export$7e0e388244c7e50d = (_ref5)=>{
    let { installableAppByARI: installableAppByARI, mpacBaseUrl: mpacBaseUrl } = _ref5;
    return Promise.all([
        (0, $3DsUo.reflect)((0, $55gtq.default)().getInstallableAddon({
            addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)(installableAppByARI)
        }).then($247ed41d36312c16$var$getAppPermission)),
        (0, $b9ymN.getCloudMarketplaceAppByKey)(mpacBaseUrl, installableAppByARI.appKey)
    ]).then((_ref6)=>{
        let [appPermission, marketplaceApp] = _ref6;
        return {
            installableAddon: appPermission.map((a)=>a.installableAddon),
            installPermission: appPermission.flatMap((a)=>a.installPermission),
            marketplaceApp: marketplaceApp
        };
    });
};

});


parcelRegister("2hUUV", function(module, exports) {

$parcel$export(module.exports, "feedbackSuccessFlag", () => $1aa951db2d36c911$export$3168e55c5a2ac19b);
$parcel$export(module.exports, "default", () => $1aa951db2d36c911$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $9oiuL = parcelRequire("9oiuL");

var $AAUd3 = parcelRequire("AAUd3");

var $5sHij = parcelRequire("5sHij");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $9l6Pq = parcelRequire("9l6Pq");

var $cdSID = parcelRequire("cdSID");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $jC5dB = parcelRequire("jC5dB");

var $15DZ6 = parcelRequire("15DZ6");

var $lHkHI = parcelRequire("lHkHI");
// Feedback goes to https://customerfeedback.atlassian.net/projects/EF
const $1aa951db2d36c911$var$ENTRYPOINT_ID = 'ceb31e7f-1c3e-4743-8303-c71a05075c84';
// Aether Feedback goes to https://customerfeedback.atlassian.net/jira/servicedesk/projects/AMMF
const $1aa951db2d36c911$var$AETHER_ENTRYPOINT_ID = '382c9b92-a4ff-45d1-bd4d-237ce0f5ac9f';
class $1aa951db2d36c911$var$FeedbackCollector extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            isOpen: false
        });
        (0, $5zQU9.default)(this, "open", ()=>{
            this.props.fireAnalyticsEvent({
                eventType: (0, $gaiog.ButtonClickedEvent),
                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_FEEDBACK_CLICKED_BUTTON)
            });
            this.setState({
                isOpen: true
            });
        });
        (0, $5zQU9.default)(this, "close", ()=>this.setState({
                isOpen: false
            }));
        (0, $5zQU9.default)(this, "submit", (feedbackValues)=>{
            this.props.fireAnalyticsEvent({
                eventType: (0, $gaiog.ButtonClickedEvent),
                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_FEEDBACK_SUBMIT_BUTTON),
                attributes: {
                    feedbackType: feedbackValues === null || feedbackValues === void 0 ? void 0 : feedbackValues.type,
                    feedbackDescription: feedbackValues === null || feedbackValues === void 0 ? void 0 : feedbackValues.description
                }
            });
            this.props.onFeedbackSubmit();
        });
    }
    render() {
        var _this$props$statsigCl;
        const { isOpen: isOpen } = this.state;
        const entrypointId = (_this$props$statsigCl = this.props.statsigClient) !== null && _this$props$statsigCl !== void 0 && _this$props$statsigCl.enableEmceeAetherExperience() ? $1aa951db2d36c911$var$AETHER_ENTRYPOINT_ID : $1aa951db2d36c911$var$ENTRYPOINT_ID;
        const additionalFields = [
            {
                id: 'customfield_10047',
                value: JSON.stringify({
                    pathname: (0, $15DZ6.getLocationPath)(),
                    context: this.props.selectedContext.id,
                    errorsObj: (0, $cdSID.default).getLastNMinutesErrors()
                }, null, 2)
            }
        ];
        return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
            className: this.props.className,
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                    appearance: "subtle-link",
                    onClick: this.open,
                    iconBefore: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($5sHij))), {
                        label: ""
                    }),
                    children: "Feedback"
                }),
                isOpen && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $AAUd3.default), {
                    onClose: this.close,
                    onSubmit: this.submit,
                    atlassianAccountId: this.props.userId,
                    name: this.props.userId,
                    entrypointId: entrypointId,
                    additionalFields: additionalFields
                })
            ]
        });
    }
}
const $1aa951db2d36c911$export$3168e55c5a2ac19b = (0, $jC5dB.makeFlag)({
    autoDismiss: true,
    appearance: (0, $jC5dB.SUCCESS_APPEARANCE),
    description: (0, $jC5dB.makeFlagDescription)({
        primary: 'Your valuable feedback helps us continually improve our products.'
    }),
    key: 'feedbackSent',
    title: 'Thanks!'
});
var $1aa951db2d36c911$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)((0, $9l6Pq.withStatsig)($1aa951db2d36c911$var$FeedbackCollector));

});
parcelRegister("AAUd3", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d0eda9459b54a30e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "FeedbackFlag", () => (parcelRequire("1zLik")).default);
$parcel$export(module.exports, "FeedbackForm", () => (parcelRequire("aRQ25")).default);
$parcel$export(module.exports, "FeedbackButton", () => (parcelRequire("jH9L4")).default);

var $jH9L4 = parcelRequire("jH9L4");

var $8D076 = parcelRequire("8D076");

var $1zLik = parcelRequire("1zLik");

var $aRQ25 = parcelRequire("aRQ25");
var $d0eda9459b54a30e$export$2e2bcd8739ae039 = (0, $8D076.default);

});
parcelRegister("jH9L4", function(module, exports) {

$parcel$export(module.exports, "default", () => $256994584bd32ea4$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $3BBPm = parcelRequire("3BBPm");

var $6UJyW = parcelRequire("6UJyW");

var $gVSRs = parcelRequire("gVSRs");

var $8NP3j = parcelRequire("8NP3j");

var $8D076 = parcelRequire("8D076");

var $1zLik = parcelRequire("1zLik");

var $c6afX = parcelRequire("c6afX");
/*
 * Standard feedback button with "Give Feedback" as the text and speaker icon on the left of the text
 * */ const $256994584bd32ea4$var$FeedbackButton = (props)=>{
    const [isOpen, setIsOpen] = (0, $eUqFw.useState)(false);
    const [displayFlag, setDisplayFlag] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const { entrypointId: entrypointId, atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails, locale: locale } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3BBPm.default), {
        onClick: ()=>setIsOpen(true),
        iconBefore: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($gVSRs))), {
                LEGACY_size: "small",
                color: "currentColor",
                ...iconProps
            })
    }, formatMessage((0, $8NP3j.messages).giveFeedback)), isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8D076.default), {
        locale: locale,
        onClose: ()=>setIsOpen(false),
        onSubmit: ()=>setDisplayFlag(true),
        atlassianAccountId: atlassianAccountId,
        entrypointId: entrypointId,
        shouldGetEntitlementDetails: shouldGetEntitlementDetails
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6UJyW.default), {
        onDismissed: ()=>setDisplayFlag(false)
    }, displayFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1zLik.default), null)));
};
const $256994584bd32ea4$var$FeedbackButtonWithIntl = (props)=>{
    const { locale: locale } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c6afX.IntlProviderWithResolvedMessages), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($256994584bd32ea4$var$FeedbackButton, props));
};
var $256994584bd32ea4$export$2e2bcd8739ae039 = $256994584bd32ea4$var$FeedbackButtonWithIntl;

});
parcelRegister("gVSRs", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06b2b9eec310f6566d6d86916ad7e234>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c53c867c2bfeb36f$var$_react = $c53c867c2bfeb36f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $c53c867c2bfeb36f$var$_feedback = $c53c867c2bfeb36f$var$_interopRequireDefault((parcelRequire("iA8fE")));

var $c53c867c2bfeb36f$var$_feedback2 = $c53c867c2bfeb36f$var$_interopRequireDefault((parcelRequire("5AMh3")));
function $c53c867c2bfeb36f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c53c867c2bfeb36f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $c53c867c2bfeb36f$var$_react.default.createElement($c53c867c2bfeb36f$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $c53c867c2bfeb36f$var$_feedback2.default
    }, props));
$c53c867c2bfeb36f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $c53c867c2bfeb36f$var$_default = module.exports.default = $c53c867c2bfeb36f$var$FeedbackIcon;

});
parcelRegister("iA8fE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8f50fdbec38c602b5aa9320deba7858>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d871fd5d52c00193$var$_react = $d871fd5d52c00193$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $d871fd5d52c00193$var$_UNSAFE_baseNew = $d871fd5d52c00193$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $d871fd5d52c00193$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d871fd5d52c00193$var$FeedbackIcon = (props)=>/*#__PURE__*/ $d871fd5d52c00193$var$_react.default.createElement($d871fd5d52c00193$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M1.75 9.5V15L6 12.25h7c.69 0 1.25-.56 1.25-1.25V3c0-.69-.56-1.25-1.25-1.25H3c-.69 0-1.25.56-1.25 1.25v2.75C1.75 6.44 2.31 7 3 7h6.75m-2-2.5 2.5 2.5-2.5 2.5"/>`
    }, props));
$d871fd5d52c00193$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $d871fd5d52c00193$var$_default = module.exports.default = $d871fd5d52c00193$var$FeedbackIcon;

});

parcelRegister("5AMh3", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4125c2bfa4bafd46$var$_react = $4125c2bfa4bafd46$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $4125c2bfa4bafd46$var$_feedback = $4125c2bfa4bafd46$var$_interopRequireDefault((parcelRequire("iA8fE")));
function $4125c2bfa4bafd46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4125c2bfa4bafd46$var$FeedbackIcon = (props)=>/*#__PURE__*/ $4125c2bfa4bafd46$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $4125c2bfa4bafd46$var$_feedback.default
    }));
$4125c2bfa4bafd46$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $4125c2bfa4bafd46$var$_default = module.exports.default = $4125c2bfa4bafd46$var$FeedbackIcon;

});


parcelRegister("8NP3j", function(module, exports) {

$parcel$export(module.exports, "messages", () => $8e5f64c13d569cf9$export$defe85febe8b728c);

var $90IgZ = parcelRequire("90IgZ");
const $8e5f64c13d569cf9$export$defe85febe8b728c = (0, $90IgZ.defineMessages)({
    feedbackTitle: {
        id: 'feedback-collector.feedback-title',
        defaultMessage: 'Share your thoughts',
        description: 'The title shown at the top of the feedback form encouraging users to leave feedback'
    },
    enrolInResearchLabel: {
        id: 'feedback-collector.enrol-in-research.label',
        defaultMessage: "I'd like to participate in product research",
        description: 'The checkbox label letting users enrol themselves in future product research interviews'
    },
    canBeContactedLabel: {
        id: 'feedback-collector.can-be-contacted.label',
        defaultMessage: 'Yes, Atlassian teams can contact me to learn about my experiences to improve Atlassian products and services. I acknowledge the <a>Atlassian Privacy Policy</a>.',
        description: 'The checkbox label to give consent to be contacted about their feedback'
    },
    summaryPlaceholder: {
        id: 'feedback-collector.summary-placeholder',
        defaultMessage: "Let us know what's on your mind",
        description: 'The textarea label listing feedback categories (bug, suggestions, questions, comments)'
    },
    formCommentLabel: {
        id: 'feedback-collector.form.comment.label',
        defaultMessage: "Let us know what's on your mind",
        description: 'The textarea label where users can write their comment'
    },
    submitButtonLabel: {
        id: 'feedback-collector.submit-button.label',
        defaultMessage: 'Send feedback',
        description: 'The button to submit the feedback form'
    },
    cancelButtonLabel: {
        id: 'feedback-collector.cancel-button.label',
        defaultMessage: 'Cancel',
        description: 'The button to cancel feedback submission'
    },
    giveFeedback: {
        id: 'proforma-form-builder.give-feedback',
        defaultMessage: 'Give feedback',
        description: 'The button that allows users to give feedback'
    },
    formBugLabel: {
        id: 'feedback-collector.form.bug.label',
        defaultMessage: 'Describe the bug or issue',
        description: 'The textarea label where users can describe the bug or issue they have'
    },
    formSuggestionLabel: {
        id: 'feedback-collector.form.suggestion.label',
        defaultMessage: "Let us know what you'd like to improve",
        description: 'The textarea label where users can write their suggestion'
    },
    formQuestionLabel: {
        id: 'feedback-collector.form.question.label',
        defaultMessage: 'What would you like to know?',
        description: 'The textarea label where users can write their question'
    },
    formEmptyLabel: {
        id: 'feedback-collector.form.empty.label',
        defaultMessage: 'Select an option',
        description: 'The default dropdown list option'
    },
    selectionOptionQuestionLabel: {
        id: 'feedback-collector.option.question.label',
        defaultMessage: 'Ask a question',
        description: 'The feedback dropdown list option to ask a question'
    },
    selectionOptionCommentLabel: {
        id: 'feedback-collector.option.comment.label',
        defaultMessage: 'Leave a comment',
        description: 'The feedback dropdown list option to leave a comment'
    },
    selectionOptionBugLabel: {
        id: 'feedback-collector.option.bug.label',
        defaultMessage: 'Report a bug',
        description: 'The feedback dropdown list option to report a bug'
    },
    selectionOptionSuggestionLabel: {
        id: 'feedback-collector.option.suggestion.label',
        defaultMessage: 'Suggest an improvement',
        description: 'The feedback dropdown list option to suggest an improvement'
    },
    selectionOptionDefaultLabel: {
        id: 'feedback-collector.option.default.label',
        defaultMessage: 'Select feedback',
        description: 'The feedback dropdown list label'
    },
    selectionOptionDefaultPlaceholder: {
        id: 'feedback-collector.option.default.placeholder',
        defaultMessage: 'Choose one',
        description: 'The feedback dropdown list placeholder'
    },
    feedbackIconLabel: {
        id: 'proforma-form-builder.feedback-icon-label',
        defaultMessage: 'Feedback',
        description: 'Accessibility text used for the feedback icon'
    },
    feedbackSuccessFlagDescription: {
        id: 'feedback-collector.success-flag.description',
        defaultMessage: 'Your valuable feedback helps us continually improve our products.',
        description: 'Description shown when feedback is successfully submitted'
    },
    feedbackSuccessFlagTitle: {
        id: 'feedback-collector.success-flag.title',
        defaultMessage: 'Thanks!',
        description: 'Button to dismiss successflag flag after submitting feedback'
    },
    feedbackIsAnonymousTitle: {
        id: 'feedback-collector.anonymous.title',
        defaultMessage: 'Anonymous feedback',
        description: 'Section message title for anonymous feedback'
    },
    feedbackIsAnonymous: {
        id: 'feedback-collector.anonymous',
        defaultMessage: 'This feedback is being submitted anonymously. Atlassian will not be able to contact you directly regarding this feedback',
        description: 'Notice that feedback is anonymous'
    },
    requiredFieldsSummary: {
        id: 'feedback-collector.required.fields.summary',
        defaultMessage: 'Required fields are marked with an asterisk',
        description: 'Summary info of required fields asterisk.'
    },
    defaultCustomTextAreaLabel: {
        id: 'feedback-collector.default.custom.textarea.label',
        defaultMessage: "What's on your mind?",
        description: 'The textarea label where users can write their suggestion for custom feedback collector'
    }
});

});

parcelRegister("8D076", function(module, exports) {

$parcel$export(module.exports, "default", () => $b681e0ff2fbdf138$export$2e2bcd8739ae039);

var $aul3P = parcelRequire("aul3P");

var $eUqFw = parcelRequire("eUqFw");

var $3puyA = parcelRequire("3puyA");

var $j81YY = parcelRequire("j81YY");

var $5oHEl = parcelRequire("5oHEl");

var $aRQ25 = parcelRequire("aRQ25");
const $b681e0ff2fbdf138$var$MAX_SUMMARY_LENGTH_CHARS = 100;
const $b681e0ff2fbdf138$var$singleLineTruncatedText = (text, length = $b681e0ff2fbdf138$var$MAX_SUMMARY_LENGTH_CHARS)=>{
    const singleLineText = text.replace(/\n/g, ' ');
    return (0, $5oHEl.default)(singleLineText, length);
};
class $b681e0ff2fbdf138$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    async componentDidMount() {
        const anonymousFeedback = !await this.shouldShowOptInCheckboxesNew();
        this.setState({
            anonymousFeedback: anonymousFeedback
        });
    }
    static{
        this.defaultProps = {
            locale: 'en',
            url: '/gateway/api',
            shouldGetEntitlementDetails: true,
            canBeContactedFieldId: 'customfield_10043',
            canBeContactedAgreeValue: [
                {
                    id: '10109'
                }
            ],
            canBeContactedDeclineValue: [
                {
                    id: '10111'
                }
            ],
            additionalFields: [],
            customerNameFieldId: 'customfield_10045',
            customerNameDefaultValue: 'unknown',
            descriptionFieldId: 'description',
            descriptionDefaultValue: '',
            enrollInResearchFieldId: 'customfield_10044',
            enrollInResearchAgreeValue: [
                {
                    id: '10110'
                }
            ],
            enrollInResearchDeclineValue: [
                {
                    id: '10112'
                }
            ],
            summaryFieldId: 'summary',
            summaryDefaultValue: '',
            summaryTruncateLength: 100,
            timeoutOnSubmit: 700,
            typeFieldId: 'customfield_10042',
            typeBugDefaultValue: {
                id: '10105'
            },
            typeCommentDefaultValue: {
                id: '10106'
            },
            typeSuggestionDefaultValue: {
                id: '10107'
            },
            typeQuestionDefaultValue: {
                id: '10108'
            },
            typeEmptyDefaultValue: {
                id: 'empty'
            },
            showTypeField: true,
            showDefaultTextFields: true,
            anonymousFeedback: false,
            onClose: ()=>{},
            onSubmit: ()=>{}
        };
    }
    getGatewayUrl() {
        const { customGatewayUrl: customGatewayUrl, url: url } = this.props;
        if (customGatewayUrl) return customGatewayUrl;
        if (url) return url;
        return $b681e0ff2fbdf138$export$2e2bcd8739ae039.defaultProps.url;
    }
    getFeedbackUrl() {
        const { customFeedbackUrl: customFeedbackUrl, url: url } = this.props;
        if (customFeedbackUrl) return customFeedbackUrl;
        if (url) return url;
        return $b681e0ff2fbdf138$export$2e2bcd8739ae039.defaultProps.url;
    }
    getPackageVersion() {
        return "0.0.0-use.local";
    }
    async getEntitlementInformation() {
        const url = this.getGatewayUrl();
        // jira / confluence / bitbucket / trello
        let productName;
        let productEntitlement;
        let entitlementDetails;
        let productKey;
        if (window.location.host.includes('bitbucket.org')) {
            productName = 'Bitbucket';
            productKey = 'bitbucket';
            entitlementDetails = JSON.parse(JSON.stringify(document.querySelector('meta[id="bb-bootstrap"]')?.getAttribute('data-current-user')));
            const hasPremium = entitlementDetails['hasPremium'];
            productEntitlement = hasPremium ? 'PREMIUM' : 'STANDARD';
        } else if ([
            'trellis.coffee',
            'trello.com'
        ].includes(window.location.host)) {
            productName = 'Trello';
            productKey = 'trello';
        } else {
            if (document.querySelector('meta[id="confluence-context-path"]')) {
                productName = 'Confluence';
                productKey = 'pricingplan.confluence.ondemand';
            } else {
                productName = 'Jira';
                productKey = 'jira-software.ondemand';
            }
            try {
                entitlementDetails = await fetch(`${url}/customer-context/entitlements/${window.location.host}`, {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    ...(0, $j81YY.isApiGatewayUrl)(url) ? {
                        credentials: 'include'
                    } : {}
                });
            } catch (e) {
                entitlementDetails = undefined;
            }
        }
        let entitlement;
        const entitlementInformation = [];
        const cloudSiteId = entitlementDetails?.cloudSiteId || '';
        if (entitlementDetails?.children) entitlement = entitlementDetails?.children.find((entitlement)=>{
            return entitlement.key === productKey;
        });
        entitlementInformation.push({
            id: 'product',
            value: productName ? productName?.toLowerCase() : ''
        }, {
            id: 'hostingType',
            value: entitlement?.product ? entitlement.product.hostingType : 'CLOUD'
        }, {
            id: 'entitlementEdition',
            value: productEntitlement ?? ''
        }, {
            id: 'cloudId',
            value: cloudSiteId
        });
        return entitlementInformation;
    }
    getTypeFieldValue(dtype) {
        switch(dtype){
            case 'bug':
                return this.props.typeBugDefaultValue;
            case 'comment':
                return this.props.typeCommentDefaultValue;
            case 'suggestion':
                return this.props.typeSuggestionDefaultValue;
            case 'question':
                return this.props.typeQuestionDefaultValue;
            case 'empty':
            default:
                return this.props.typeEmptyDefaultValue;
        }
    }
    async getAtlassianID() {
        const { atlassianAccountId: atlassianAccountId, shouldGetEntitlementDetails: shouldGetEntitlementDetails } = this.props;
        try {
            if (atlassianAccountId || !shouldGetEntitlementDetails) return atlassianAccountId;
            const url = this.getGatewayUrl();
            const result = await fetch(`${url}/me`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                ...(0, $j81YY.isApiGatewayUrl)(url) ? {
                    credentials: 'include'
                } : {}
            });
            const json = await result.json();
            return json.account_id;
        } catch (e) {
            return undefined;
        }
    }
    shouldShowOptInCheckboxes() {
        if (this.props.anonymousFeedback) return !this.props.anonymousFeedback;
        if (this.props.atlassianAccountId) return true;
        let response;
        this.getAtlassianID().then((result)=>{
            response = result !== undefined;
        }).catch(()=>{
            response = false;
        });
        // @ts-ignore
        return response;
    }
    shouldShowOptInCheckboxesNew() {
        return new Promise((resolve)=>{
            if (this.props.anonymousFeedback) resolve(!this.props.anonymousFeedback);
            if (this.props.atlassianAccountId) resolve(true);
            this.getAtlassianID().then((result)=>{
                resolve(result !== undefined);
            }).catch(()=>{
                resolve(false);
            });
        });
    }
    getDescription(formValues) {
        return formValues.description || this.props.descriptionDefaultValue;
    }
    getSummary(formValues) {
        return $b681e0ff2fbdf138$var$singleLineTruncatedText(formValues.description, this.props.summaryTruncateLength) || this.props.summaryDefaultValue;
    }
    getCustomerName() {
        return this.props.name ?? this.props.customerNameDefaultValue;
    }
    addEmailToContext() {
        const contextField = this.props.additionalFields.find((field)=>{
            return field.id === 'customfield_10047';
        });
        if (contextField) contextField.value = `${contextField.value}
        email: ${this.props.email}`;
        else this.props.additionalFields.push({
            id: 'customfield_10047',
            value: `email: ${this.props.email}`
        });
    }
    addAccountIdToContext(atlassianID) {
        if (atlassianID) {
            const contextField = this.props.additionalFields.find((field)=>{
                return field.id === 'customfield_10047';
            });
            if (contextField) contextField.value = `${contextField.value}
			atlassian-account-id: ${atlassianID}`;
        }
    }
    async mapFormToJSD(formValues) {
        let entitlementInformation = null;
        if (this.props?.shouldGetEntitlementDetails) entitlementInformation = await this.getEntitlementInformation();
        if (this.props?.email) this.addEmailToContext();
        const atlassianID = await this.getAtlassianID();
        if ((0, $3puyA.fg)('jsw_feedback_account_id')) this.addAccountIdToContext(atlassianID);
        return {
            fields: [
                ...entitlementInformation !== null && entitlementInformation || [],
                this.props.showTypeField ? {
                    id: this.props.typeFieldId,
                    value: this.getTypeFieldValue(formValues.type)
                } : undefined,
                {
                    id: this.props.summaryFieldId,
                    value: this.getSummary(formValues)
                },
                {
                    id: this.props.descriptionFieldId,
                    value: this.getDescription(formValues)
                },
                {
                    id: 'aaidOrHash',
                    value: formValues.canBeContacted ? atlassianID : undefined
                },
                {
                    id: this.props.customerNameFieldId,
                    value: this.getCustomerName()
                },
                formValues.canBeContacted ? {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedAgreeValue
                } : {
                    id: this.props.canBeContactedFieldId,
                    value: this.props.canBeContactedDeclineValue
                },
                formValues.enrollInResearchGroup ? {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchAgreeValue
                } : {
                    id: this.props.enrollInResearchFieldId,
                    value: this.props.enrollInResearchDeclineValue
                },
                ...this.props.additionalFields
            ].filter(Boolean)
        };
    }
    render() {
        const anonymousFeedback = !this.shouldShowOptInCheckboxes();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aRQ25.default), {
            customContent: this.props.customContent,
            feedbackTitle: this.props.feedbackTitle,
            feedbackTitleDetails: this.props.feedbackTitleDetails,
            showTypeField: this.props.showTypeField,
            showDefaultTextFields: this.props.showDefaultTextFields,
            hasDescriptionDefaultValue: !!this.props.descriptionDefaultValue,
            canBeContactedLabel: this.props.canBeContactedLabel,
            enrolInResearchLabel: this.props.enrolInResearchLabel,
            summaryPlaceholder: this.props.summaryPlaceholder,
            submitButtonLabel: this.props.submitButtonLabel,
            cancelButtonLabel: this.props.cancelButtonLabel,
            feedbackGroupLabels: this.props.feedbackGroupLabels,
            onSubmit: this.postFeedback,
            onClose: this.props.onClose,
            locale: this.props.locale,
            anonymousFeedback: (0, $3puyA.fg)('platform.proforma-form-builder-feedback_hupaz') ? this.state.anonymousFeedback : anonymousFeedback,
            selectLabel: this.props.selectLabel,
            customTextAreaLabel: this.props.customTextAreaLabel,
            customFeedbackOptions: this.props.customFeedbackOptions,
            shouldReturnFocusRef: this.props.shouldReturnFocusRef
        });
    }
    constructor(...args){
        super(...args);
        this.state = {
            anonymousFeedback: true
        };
        this.postFeedback = async (formValues)=>{
            const entrypointId = this.props.entrypointId;
            let fetchUrl = this.getFeedbackUrl();
            // Don't dispatch unless we have suitable props (allows tests to pass through empty strings and avoid redundant network calls)
            if (entrypointId) {
                const formData = await this.mapFormToJSD(formValues);
                const body = {
                    feedback: {
                        entrypointId: this.props.entrypointId,
                        entrypointUiVersion: this.getPackageVersion(),
                        ...formData
                    }
                };
                if ((0, $j81YY.isApiGatewayUrl)(fetchUrl)) fetchUrl += '/feedback-collector-api';
                else if (!this.props.customFeedbackUrl) fetchUrl = 'https://feedback-collector-api.services.atlassian.com';
                const postData = (0, $aul3P.Buffer).from(JSON.stringify(body)).toString('base64');
                fetch(`${fetchUrl}/v2/feedback`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        data: postData
                    }),
                    credentials: 'include'
                });
            }
            this.props.onClose();
            // slightly delay confirming submit since we don't wait for the REST call to succeed
            //
            // Because `onClose` is invoked prior to this timeout triggering, the `componentWillUnmount`
            // may occur before the `onSubmit` is called. To prevent prematurely cancelling the
            // network request, we deliberately don't clear this timeout inside `componentWillUnmount`.
            //
            setTimeout(()=>this.props.onSubmit(formValues), this.props.timeoutOnSubmit);
        };
    }
}

});
parcelRegister("j81YY", function(module, exports) {

$parcel$export(module.exports, "isApiGatewayUrl", () => $a2043da8a862267c$export$f0f6fc934288a17c);
const $a2043da8a862267c$export$f0f6fc934288a17c = (url)=>[
        '/gateway/api'
    ].includes(url);

});

parcelRegister("5oHEl", function(module, exports) {

$parcel$export(module.exports, "default", () => $26d7dc50e631cf51$export$2e2bcd8739ae039);
function $26d7dc50e631cf51$export$2e2bcd8739ae039(text, maxLength) {
    if (!text || !maxLength) return text;
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + '...';
}

});

parcelRegister("aRQ25", function(module, exports) {

$parcel$export(module.exports, "default", () => $be0a0910ad4404ad$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8uD7Y = parcelRequire("8uD7Y");
var $5JgJ2 = parcelRequire("5JgJ2");

var $8fGGK = parcelRequire("8fGGK");

var $9XKnm = parcelRequire("9XKnm");

var $3k82a = parcelRequire("3k82a");
var $dDESd = parcelRequire("dDESd");
var $igUnt = parcelRequire("igUnt");
var $hGy6A = parcelRequire("hGy6A");

var $639nA = parcelRequire("639nA");

var $gqYUo = parcelRequire("gqYUo");

var $l9NvU = parcelRequire("l9NvU");
var $5o6SH = parcelRequire("5o6SH");
var $jSigD = parcelRequire("jSigD");
var $492R6 = parcelRequire("492R6");
var $gxv5e = parcelRequire("gxv5e");

var $3puyA = parcelRequire("3puyA");

var $8VfNq = parcelRequire("8VfNq");

var $5AdW7 = parcelRequire("5AdW7");

var $2ruhQ = parcelRequire("2ruhQ");


var $8NP3j = parcelRequire("8NP3j");

var $c6afX = parcelRequire("c6afX");
const $be0a0910ad4404ad$var$FeedbackForm = ({ showTypeField: showTypeField = true, showDefaultTextFields: showDefaultTextFields = true, customContent: customContent, onClose: onClose, onSubmit: onSubmit, feedbackTitle: feedbackTitle, feedbackTitleDetails: feedbackTitleDetails, feedbackGroupLabels: feedbackGroupLabels, summaryPlaceholder: summaryPlaceholder, canBeContactedLabel: canBeContactedLabel, enrolInResearchLabel: enrolInResearchLabel, submitButtonLabel: submitButtonLabel, cancelButtonLabel: cancelButtonLabel, anonymousFeedback: anonymousFeedback, hasDescriptionDefaultValue: hasDescriptionDefaultValue, selectLabel: selectLabel, customTextAreaLabel: customTextAreaLabel, customFeedbackOptions: customFeedbackOptions = [], shouldReturnFocusRef: shouldReturnFocusRef })=>{
    const [canBeContacted, setCanBeContacted] = (0, $eUqFw.useState)(false);
    const [description, setDescription] = (0, $eUqFw.useState)('');
    const [enrollInResearchGroup, setEnrollInResearchGroup] = (0, $eUqFw.useState)(false);
    const [type, setType] = (0, $eUqFw.useState)('empty');
    const [isSubmitting, setIsSubmitting] = (0, $eUqFw.useState)(false);
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    const isTypeSelected = ()=>type !== 'empty';
    const canShowTextField = isTypeSelected() || !showTypeField;
    const hasDescription = description || hasDescriptionDefaultValue;
    const isDisabled = showTypeField ? !isTypeSelected() || !hasDescription : !hasDescription;
    const getFieldLabels = (record)=>({
            bug: record?.bug.fieldLabel || formatMessage((0, $8NP3j.messages).formBugLabel),
            comment: record?.comment.fieldLabel || formatMessage((0, $8NP3j.messages).formCommentLabel),
            suggestion: record?.suggestion.fieldLabel || formatMessage((0, $8NP3j.messages).formSuggestionLabel),
            question: record?.question.fieldLabel || formatMessage((0, $8NP3j.messages).formQuestionLabel),
            empty: record?.empty.fieldLabel || formatMessage((0, $8NP3j.messages).formEmptyLabel)
        });
    const getSelectOptions = (record)=>[
            {
                label: record?.question.selectOptionLabel || formatMessage((0, $8NP3j.messages).selectionOptionQuestionLabel),
                value: 'question'
            },
            {
                label: record?.comment.selectOptionLabel || formatMessage((0, $8NP3j.messages).selectionOptionCommentLabel),
                value: 'comment'
            },
            {
                label: record?.bug.selectOptionLabel || formatMessage((0, $8NP3j.messages).selectionOptionBugLabel),
                value: 'bug'
            },
            {
                label: record?.suggestion.selectOptionLabel || formatMessage((0, $8NP3j.messages).selectionOptionSuggestionLabel),
                value: 'suggestion'
            }
        ];
    const getDefaultPlaceholder = (record)=>record?.empty.selectOptionLabel || formatMessage((0, $8NP3j.messages).selectionOptionDefaultPlaceholder);
    const focusRef = (0, $eUqFw.useRef)();
    const selectOptions = customFeedbackOptions.length > 0 ? customFeedbackOptions : getSelectOptions(feedbackGroupLabels);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l9NvU.default), {
        shouldCloseOnOverlayClick: false,
        shouldCloseOnEscapePress: false,
        autoFocus: focusRef,
        onClose: onClose,
        testId: "feedbackCollectorModalDialog",
        shouldReturnFocus: shouldReturnFocusRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3k82a.default), {
        onSubmit: async ()=>{
            setIsSubmitting(true);
            await onSubmit({
                canBeContacted: canBeContacted,
                description: description,
                enrollInResearchGroup: enrollInResearchGroup,
                type: type
            });
            setIsSubmitting(false);
        }
    }, ({ formProps: formProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("form", formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $492R6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gxv5e.default), null, feedbackTitle || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8NP3j.messages).feedbackTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fGGK.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            style: {
                lineHeight: 'normal'
            },
            spacing: 'none',
            onClick: onClose,
            appearance: 'subtle'
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($639nA))), {
            spacing: "spacious",
            label: "Close Modal",
            color: `var(--ds-text-subtle, ${(0, $ab6d6432a4c55680$export$c39c0fe0f26207ae)})`
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5o6SH.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", {
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                color: `var(--ds-text-subtle, ${(0, $ab6d6432a4c55680$export$e2ef2124cf4024b1)})`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                marginBottom: "var(--ds-space-300, 24px)"
            }
        }, formatMessage((0, $8NP3j.messages).requiredFieldsSummary), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hGy6A.default), null)), feedbackTitleDetails, customContent, showTypeField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dDESd.default), {
            name: "topic",
            label: selectLabel || formatMessage((0, $8NP3j.messages).selectionOptionDefaultLabel),
            isRequired: true,
            "aria-required": true
        }, ({ fieldProps: { id: id, ...restProps } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5AdW7.default), {
                ...restProps,
                required: true,
                onChange: (option)=>{
                    if (!option || option instanceof Array) return;
                    setType(option.value);
                },
                menuPortalTarget: document.body,
                styles: {
                    menuPortal: (base)=>({
                            ...base,
                            zIndex: 9999
                        })
                },
                options: selectOptions,
                // @ts-ignore
                ref: focusRef,
                placeholder: getDefaultPlaceholder(feedbackGroupLabels),
                inputId: id
            })) : null, showDefaultTextFields && canShowTextField && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dDESd.default), {
            label: showTypeField ? getFieldLabels(feedbackGroupLabels)[type] : customTextAreaLabel || formatMessage((0, $8NP3j.messages).defaultCustomTextAreaLabel),
            isRequired: true,
            name: "description"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2ruhQ.default), {
                ...fieldProps,
                name: "foo",
                minimumRows: 6,
                placeholder: summaryPlaceholder || undefined,
                onChange: (e)=>setDescription(e.target.value),
                value: description
            })), !anonymousFeedback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $igUnt.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("legend", {
            "aria-hidden": false,
            hidden: true
        }, "Atlassian opt-in options"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dDESd.default), {
            name: "can-be-contacted"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9XKnm.default), {
                ...fieldProps,
                "aria-describedby": undefined,
                label: canBeContactedLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), {
                    ...(0, $8NP3j.messages).canBeContactedLabel,
                    values: {
                        a: (chunks)=>(0, $3puyA.fg)('underlined_iph_links') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gqYUo.default), {
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                target: "_blank"
                            }, chunks) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("a", {
                                href: "https://www.atlassian.com/legal/privacy-policy",
                                target: "_blank"
                            }, chunks)
                    }
                }),
                onChange: (event)=>setCanBeContacted(event.target.checked)
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dDESd.default), {
            name: "enroll-in-research-group"
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9XKnm.default), {
                ...fieldProps,
                "aria-describedby": undefined,
                label: enrolInResearchLabel || formatMessage((0, $8NP3j.messages).enrolInResearchLabel),
                onChange: (event)=>setEnrollInResearchGroup(event.target.checked)
            }))) || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dDESd.default), {
            name: 'anonymousFeedback'
        }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8VfNq.default), {
                title: formatMessage((0, $8NP3j.messages).feedbackIsAnonymousTitle),
                appearance: 'information'
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("p", null, formatMessage((0, $8NP3j.messages).feedbackIsAnonymous))))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $jSigD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fGGK.default), {
            appearance: "subtle",
            onClick: onClose
        }, cancelButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8NP3j.messages).cancelButtonLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fGGK.default), {
            appearance: "primary",
            type: "submit",
            isDisabled: isSubmitting || isDisabled,
            testId: "feedbackCollectorSubmitBtn"
        }, submitButtonLabel || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8uD7Y.default), (0, $8NP3j.messages).submitButtonLabel))))));
};
const $be0a0910ad4404ad$var$FeedbackFormWithIntl = ({ locale: locale, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c6afX.IntlProviderWithResolvedMessages), {
        locale: locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($be0a0910ad4404ad$var$FeedbackForm, props));
};
var $be0a0910ad4404ad$export$2e2bcd8739ae039 = $be0a0910ad4404ad$var$FeedbackFormWithIntl;

});
parcelRegister("9XKnm", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7f3608a8d0e1efd$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2MblP = parcelRequire("2MblP");

var $5zGDY = parcelRequire("5zGDY");


var $au8H1 = parcelRequire("au8H1");
var $hIV0w = parcelRequire("hIV0w");
var $1jjFE = parcelRequire("1jjFE");
var $hry2h = parcelRequire("hry2h");
/* eslint-disable @atlaskit/design-system/no-nested-styles */ const $c7f3608a8d0e1efd$var$checkboxStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: '100%',
    height: '100%',
    margin: "var(--ds-space-0, 0px)",
    appearance: 'none',
    border: 'none',
    gridArea: '1 / 1 / 2 / 2',
    opacity: 0,
    outline: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& + svg': {
        /**
     *  Change the variables --checkbox-background-color, --checkbox-border-color
     *  and --checkbox-tick-color according to user interactions.
     *  All other variables are constant.
     *  All styles from the input target the sibling svg.
     */ '--checkbox-background-color': 'var(--local-background)',
        '--checkbox-border-color': 'var(--local-border)',
        '--checkbox-tick-color': 'var(--local-tick-rest)',
        color: 'var(--checkbox-background-color)',
        fill: 'var(--checkbox-tick-color)',
        gridArea: '1 / 1 / 2 / 2',
        pointerEvents: 'none',
        transition: 'color 0.2s ease-in-out, fill 0.2s ease-in-out',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        'rect:first-of-type': {
            stroke: 'var(--checkbox-border-color)',
            strokeWidth: "var(--ds-border-width, 1px)",
            transition: 'stroke 0.2s ease-in-out'
        }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&&:focus + svg, &&:checked:focus + svg': {
        borderRadius: "var(--ds-border-radius, 0.25rem)",
        outline: `${"var(--ds-border-width-outline, 2px)"} solid ${`var(--ds-border-focused, ${(0, $ab6d6432a4c55680$export$215b7063051591f1)})`}`,
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-hover)',
        '--checkbox-border-color': 'var(--local-border-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:hover + svg': {
        '--checkbox-background-color': 'var(--local-background-checked-hover)',
        '--checkbox-border-color': 'var(--local-border-checked-hover)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked[data-invalid] + svg': {
        '--checkbox-border-color': 'var(--local-border-checked-invalid)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:checked:active + svg': {
        '--checkbox-background-color': 'var(--local-background-active)',
        '--checkbox-border-color': 'var(--local-border-active)',
        '--checkbox-tick-color': 'var(--local-tick-active)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        cursor: 'not-allowed',
        pointerEvents: 'none'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '&:disabled:checked + svg': {
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-checked)',
        '--checkbox-border-color': 'var(--local-border-checked)',
        '--checkbox-tick-color': 'var(--local-tick-checked)'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-19551
    '&:disabled:indeterminate + svg': {
        '--checkbox-background-color': 'var(--local-background-disabled)',
        '--checkbox-border-color': 'var(--local-border-disabled)',
        '--checkbox-tick-color': 'var(--local-tick-disabled)'
    },
    '@media screen and (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked + svg, &:checked:hover + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'CanvasText',
            '--checkbox-tick-color': 'CanvasText'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:focus + svg rect:first-of-type': {
            stroke: 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:checked[data-invalid] + svg': {
            '--checkbox-border-color': 'Highlight'
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&:disabled + svg, &:disabled:hover + svg, &:disabled:focus + svg, &:disabled:active + svg, &:disabled[data-invalid] + svg': {
            '--checkbox-background-color': 'Canvas',
            '--checkbox-border-color': 'GrayText',
            '--checkbox-tick-color': 'GrayText'
        }
    }
});
/* eslint-enable @atlaskit/design-system/no-nested-styles */ /**
 * __Checkbox__
 *
 * A checkbox an input control that allows a user to select one or more options from a number of choices.
 *
 * - [Examples](https://atlassian.design/components/checkbox/examples)
 * - [Code](https://atlassian.design/components/checkbox/code)
 * - [Usage](https://atlassian.design/components/checkbox/usage)
 */ const $c7f3608a8d0e1efd$var$Checkbox = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function Checkbox(props, ref) {
    const { isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, size: size = 'medium', onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, ...rest } = props;
    const [isCheckedState, setIsCheckedState] = (0, $eUqFw.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $2MblP.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $eUqFw.useRef)(null);
    const mergedRefs = (0, $5zGDY.default)([
        internalRef,
        ref
    ]);
    // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $eUqFw.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $hIV0w.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // Currently the rule hasn't been updated to enable "allowed" dynamic pass-throughs.
        // When there is more usage of this pattern we'll update the lint rule.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: xcss
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // It is necessary only for Safari. It allows to render focus styles.
        tabIndex: 0,
        ...rest,
        type: "checkbox",
        ref: mergedRefs,
        disabled: isDisabled,
        checked: isChecked,
        value: value,
        name: name,
        required: isRequired,
        css: $c7f3608a8d0e1efd$var$checkboxStyles,
        onChange: onChangeAnalytics,
        "aria-invalid": isInvalid ? 'true' : undefined,
        "data-testid": testId && `${testId}--hidden-checkbox`,
        "data-invalid": isInvalid ? 'true' : undefined
    }), /*#__PURE__*/ (0, $byn9U.jsx)((0, $au8H1.default), {
        size: size,
        isIndeterminate: isIndeterminate,
        isChecked: isChecked
    }), label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $1jjFE.default), null, label, isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hry2h.default), null)));
}));
$c7f3608a8d0e1efd$var$Checkbox.displayName = 'Checkbox';
var $c7f3608a8d0e1efd$export$2e2bcd8739ae039 = $c7f3608a8d0e1efd$var$Checkbox;

});
parcelRegister("au8H1", function(module, exports) {

$parcel$export(module.exports, "default", () => $5fdc8f976034376a$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $feXUN = parcelRequire("feXUN");
function $5fdc8f976034376a$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) return /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "inherit",
        x: "8",
        y: "11",
        width: "8",
        height: "2",
        rx: "1"
    });
    if (isChecked) return /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
        fill: "inherit"
    });
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $5fdc8f976034376a$var$CheckboxIcon = /*#__PURE__*/ (0, $eUqFw.memo)(({ size: size, isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $eUqFw.useMemo)(()=>$5fdc8f976034376a$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $feXUN.default), {
        label: "",
        size: size,
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("g", {
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, $byn9U.jsx)("rect", {
        fill: "currentColor",
        x: "6",
        y: "6",
        width: "12",
        height: "12",
        rx: "2"
    }), icon));
});
var $5fdc8f976034376a$export$2e2bcd8739ae039 = $5fdc8f976034376a$var$CheckboxIcon;

});

parcelRegister("hIV0w", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bdfde7e90117e9c$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $2bdfde7e90117e9c$var$baseStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'grid',
    gridAutoColumns: '1fr',
    gridAutoRows: 'min-content',
    color: `var(--ds-text, ${(0, $ab6d6432a4c55680$export$fbda843f0a27fe96)})`,
    cursor: 'default',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
});
const $2bdfde7e90117e9c$var$textLabelLayoutStyles = /*#__PURE__*/ (0, $byn9U.css)({
    gap: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"}`,
    gridTemplateColumns: 'min-content auto'
});
const $2bdfde7e90117e9c$var$disabledStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-disabled, ${(0, $ab6d6432a4c55680$export$eaa8c8a70ac22806)})`,
    cursor: 'not-allowed'
});
const $2bdfde7e90117e9c$var$labelStyles = /*#__PURE__*/ (0, $byn9U.css)({
    /**
   * Background
   */ '--local-background': `var(--ds-background-input, ${(0, $ab6d6432a4c55680$export$e655ef011c4aa1a2)})`,
    '--local-background-active': `var(--ds-background-input-pressed, ${(0, $ab6d6432a4c55680$export$226de0355ed012f8)})`,
    '--local-background-checked': `var(--ds-background-selected-bold, ${(0, $ab6d6432a4c55680$export$b3de0ae08da2ce64)})`,
    '--local-background-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $ab6d6432a4c55680$export$e62e8919cca44969)})`,
    '--local-background-disabled': `var(--ds-background-disabled, ${(0, $ab6d6432a4c55680$export$9fdfb749e33cdf97)})`,
    '--local-background-hover': `var(--ds-background-input-hovered, ${(0, $ab6d6432a4c55680$export$3e51e8f1440314ba)})`,
    /**
   * Border
   */ '--local-border': `var(--ds-border-input, ${(0, $ab6d6432a4c55680$export$d6447c357493214f)})`,
    '--local-border-active': `var(--ds-border, ${(0, $ab6d6432a4c55680$export$226de0355ed012f8)})`,
    '--local-border-checked': `var(--ds-background-selected-bold, ${(0, $ab6d6432a4c55680$export$b3de0ae08da2ce64)})`,
    '--local-border-checked-hover': `var(--ds-background-selected-bold-hovered, ${(0, $ab6d6432a4c55680$export$e62e8919cca44969)})`,
    '--local-border-checked-invalid': `var(--ds-border-danger, ${(0, $ab6d6432a4c55680$export$4a7404f376229999)})`,
    '--local-border-disabled': `var(--ds-background-disabled, ${(0, $ab6d6432a4c55680$export$9fdfb749e33cdf97)})`,
    '--local-border-focus': `var(--ds-border-focused, ${(0, $ab6d6432a4c55680$export$215b7063051591f1)})`,
    '--local-border-hover': `var(--ds-border-input, ${(0, $ab6d6432a4c55680$export$d6447c357493214f)})`,
    '--local-border-invalid': `var(--ds-border-danger, ${(0, $ab6d6432a4c55680$export$4a7404f376229999)})`,
    /**
   * Tick
   */ '--local-tick-active': `var(--ds-icon-inverse, ${(0, $ab6d6432a4c55680$export$b3de0ae08da2ce64)})`,
    '--local-tick-checked': `var(--ds-icon-inverse, ${(0, $ab6d6432a4c55680$export$e655ef011c4aa1a2)})`,
    '--local-tick-disabled': `var(--ds-icon-disabled, ${(0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de)})`,
    '--local-tick-rest': 'transparent'
});
function $2bdfde7e90117e9c$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("label", {
        // Because we're using Emotion local jsx namespace we have to coerce xcss prop to a string.
        // When we're fully on Compiled its local jsx namespace accepts the output of xcss prop.
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: xcss,
        css: [
            $2bdfde7e90117e9c$var$baseStyles,
            label && $2bdfde7e90117e9c$var$textLabelLayoutStyles,
            isDisabled && $2bdfde7e90117e9c$var$disabledStyles,
            $2bdfde7e90117e9c$var$labelStyles
        ],
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id
    }, children);
}

});

parcelRegister("1jjFE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c07e60c5e09884df$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
function $c07e60c5e09884df$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c07e60c5e09884df$var$labelTextStyles = {
    name: "12hofyr",
    styles: "align-self:center;grid-area:1 / 2 / 2 / 3"
};
function $c07e60c5e09884df$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $c07e60c5e09884df$var$labelTextStyles
    }, children);
}

});

parcelRegister("hry2h", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1a88c29d8a491b5$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $b1a88c29d8a491b5$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $ab6d6432a4c55680$export$2837b5a1a71d5c02)})`,
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $b1a88c29d8a491b5$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $b1a88c29d8a491b5$var$requiredIndicatorStyles,
        "aria-hidden": true
    }, "*");
}

});


parcelRegister("3k82a", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $845e435ee836431a$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $845e435ee836431a$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $845e435ee836431a$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3DX5R = parcelRequire("3DX5R");

var $519wV = parcelRequire("519wV");

var $a0i0f = parcelRequire("a0i0f");
const $845e435ee836431a$export$c24727297075ec6a = /*#__PURE__*/ (0, $eUqFw.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $845e435ee836431a$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $eUqFw.createContext)(false);
function $845e435ee836431a$export$2e2bcd8739ae039(props) {
    const formRef = (0, $eUqFw.useRef)(null);
    const onSubmitRef = (0, $eUqFw.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $eUqFw.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $3DX5R.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        /* eslint-disable no-param-reassign */ (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($a0i0f)))(values, name, value);
                    /* eslint-enable */ }
                }
            }
        });
        (0, $519wV.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $eUqFw.useState)({
        dirty: false,
        submitting: false
    });
    (0, $eUqFw.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $eUqFw.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $eUqFw.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $eUqFw.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($845e435ee836431a$export$c24727297075ec6a.Provider, {
        value: FormContextValue
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($845e435ee836431a$export$c17cf6b332a82dbc.Provider, {
        value: isDisabled
    }, children({
        formProps: {
            onSubmit: handleSubmit,
            ref: formRef,
            onKeyDown: handleKeyDown
        },
        dirty: dirty,
        reset: handleReset,
        submitting: submitting,
        disabled: isDisabled,
        getState: ()=>form.getState(),
        getValues: ()=>form.getState().values,
        setFieldValue: form.change
    })));
}

});
parcelRegister("3DX5R", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $2a72da5b7ec16659$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $2a72da5b7ec16659$export$97cd7fc25dd32915);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $2a72da5b7ec16659$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $2a72da5b7ec16659$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $2a72da5b7ec16659$export$f681a8129d2e9d28);

var $kU09D = parcelRequire("kU09D");

var $6XgOP = parcelRequire("6XgOP");
//      
var $2a72da5b7ec16659$var$charCodeOfDot = ".".charCodeAt(0);
var $2a72da5b7ec16659$var$reEscapeChar = /\\(\\)?/g;
var $2a72da5b7ec16659$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $2a72da5b7ec16659$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $2a72da5b7ec16659$var$charCodeOfDot) result.push("");
    string.replace($2a72da5b7ec16659$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($2a72da5b7ec16659$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $2a72da5b7ec16659$var$keysCache = {};
var $2a72da5b7ec16659$var$keysRegex = /[.[\]]+/;
var $2a72da5b7ec16659$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($2a72da5b7ec16659$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $2a72da5b7ec16659$var$keysCache[key] = key.split($2a72da5b7ec16659$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $2a72da5b7ec16659$var$keysCache[key] = $2a72da5b7ec16659$var$stringToPath(key);
    }
    return $2a72da5b7ec16659$var$keysCache[key];
};
//      
var $2a72da5b7ec16659$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $2a72da5b7ec16659$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $2a72da5b7ec16659$var$_toPropertyKey(arg) {
    var key = $2a72da5b7ec16659$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $2a72da5b7ec16659$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $2a72da5b7ec16659$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $6XgOP.default)(current, [
                key
            ].map($2a72da5b7ec16659$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $kU09D.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $2a72da5b7ec16659$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $2a72da5b7ec16659$var$setInRecursor(state, 0, $2a72da5b7ec16659$var$toPath(key), value1, destroyArrays);
};
var $2a72da5b7ec16659$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $2a72da5b7ec16659$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $2a72da5b7ec16659$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(values, name);
    var error = $2a72da5b7ec16659$export$c52e5867d5879e24(errors, name);
    if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) error = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
    var submitError = submitErrors && $2a72da5b7ec16659$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $2a72da5b7ec16659$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $2a72da5b7ec16659$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $2a72da5b7ec16659$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $2a72da5b7ec16659$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$2a72da5b7ec16659$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $2a72da5b7ec16659$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $2a72da5b7ec16659$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$41e855cb628c1b55, $2a72da5b7ec16659$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $2a72da5b7ec16659$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $2a72da5b7ec16659$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $2a72da5b7ec16659$var$subscriptionFilter(result, state, previousState, subscription, $2a72da5b7ec16659$export$f1ff97b9d1c7a3c3, $2a72da5b7ec16659$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $2a72da5b7ec16659$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$2a72da5b7ec16659$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $2a72da5b7ec16659$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $2a72da5b7ec16659$export$83d89fbfd8236492 = "4.20.10";
var $2a72da5b7ec16659$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $2a72da5b7ec16659$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $2a72da5b7ec16659$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $2a72da5b7ec16659$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $2a72da5b7ec16659$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $2a72da5b7ec16659$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $2a72da5b7ec16659$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($2a72da5b7ec16659$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $2a72da5b7ec16659$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $kU09D.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $kU09D.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $kU09D.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $kU09D.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $kU09D.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $2a72da5b7ec16659$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $2a72da5b7ec16659$export$e6bdf135a54e021b,
                    shallowEqual: $2a72da5b7ec16659$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $kU09D.default)({}, state.formState.values)); // clone to avoid writing
            if ($2a72da5b7ec16659$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $2a72da5b7ec16659$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $2a72da5b7ec16659$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $kU09D.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $2a72da5b7ec16659$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$2a72da5b7ec16659$export$735bebc8ffabf28a]) {
                    var existing = $2a72da5b7ec16659$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$2a72da5b7ec16659$export$735bebc8ffabf28a] = error[$2a72da5b7ec16659$export$735bebc8ffabf28a];
                    merged = $2a72da5b7ec16659$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$2a72da5b7ec16659$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $2a72da5b7ec16659$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $2a72da5b7ec16659$var$notify(fieldSubscriber, fieldState, lastFieldState, $2a72da5b7ec16659$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $2a72da5b7ec16659$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $kU09D.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$2a72da5b7ec16659$var$hasAnyError(formState.errors) && !(formState.submitErrors && $2a72da5b7ec16659$var$hasAnyError(formState.submitErrors));
        var nextFormState = $2a72da5b7ec16659$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $2a72da5b7ec16659$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $2a72da5b7ec16659$var$notify(state.subscribers, nextFormState, lastFormState, $2a72da5b7ec16659$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $kU09D.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $kU09D.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $kU09D.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key), $2a72da5b7ec16659$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $2a72da5b7ec16659$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $2a72da5b7ec16659$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $2a72da5b7ec16659$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.values, name) === $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $2a72da5b7ec16659$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $2a72da5b7ec16659$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $kU09D.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $2a72da5b7ec16659$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$2a72da5b7ec16659$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $kU09D.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $2a72da5b7ec16659$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $2a72da5b7ec16659$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $2a72da5b7ec16659$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $2a72da5b7ec16659$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("519wV", function(module, exports) {

$parcel$export(module.exports, "default", () => $3a747034649a7960$export$2e2bcd8739ae039);

var $3DX5R = parcelRequire("3DX5R");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $3a747034649a7960$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $3a747034649a7960$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $3a747034649a7960$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $3DX5R.getIn)(errors, input.name);
    });
};
//      
var $3a747034649a7960$var$noop = function noop() {};
var $3a747034649a7960$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $3a747034649a7960$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $3a747034649a7960$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $3a747034649a7960$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $3a747034649a7960$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($3a747034649a7960$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$3a747034649a7960$export$2e2bcd8739ae039 = $3a747034649a7960$var$createDecorator;

});


parcelRegister("dDESd", function(module, exports) {

$parcel$export(module.exports, "default", () => $e068743d45d697f3$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");
parcelRequire("8ynlC");

var $474Xg = parcelRequire("474Xg");

var $3k82a = parcelRequire("3k82a");

var $7xzQn = parcelRequire("7xzQn");

var $hGy6A = parcelRequire("hGy6A");

var $2fFJv = parcelRequire("2fFJv");
function $e068743d45d697f3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e068743d45d697f3$var$fieldWrapperStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
function $e068743d45d697f3$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $e068743d45d697f3$var$isFunction(x) {
    return typeof x === 'function';
}
function $e068743d45d697f3$var$usePreviousRef(current) {
    const ref = (0, $eUqFw.useRef)(current);
    // will be updated on the next render
    (0, $eUqFw.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $e068743d45d697f3$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $e068743d45d697f3$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $eUqFw.useContext)((0, $3k82a.FormContext));
    const isDisabled = (0, $eUqFw.useContext)((0, $3k82a.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $e068743d45d697f3$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $e068743d45d697f3$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$e068743d45d697f3$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $eUqFw.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explictly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $e068743d45d697f3$var$usePreviousRef(state);
    (0, $eUqFw.useEffect)(()=>{
        typeof $2fFJv;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $e068743d45d697f3$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($e068743d45d697f3$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const fieldId = (0, $eUqFw.useMemo)(// eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    ()=>props.id ? props.id : `${props.name}-${(0, $tkrFt.uid)({
            id: props.name
        })}`, [
        props.id,
        props.name
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $e068743d45d697f3$var$fieldWrapperStyles,
        "data-testid": props.testId
    }, props.label && /*#__PURE__*/ (0, $byn9U.jsx)((0, $7xzQn.Label), {
        htmlFor: fieldId,
        id: `${fieldId}-label`,
        testId: props.testId && `${props.testId}--label`
    }, props.label, props.isRequired && /*#__PURE__*/ (0, $byn9U.jsx)((0, $hGy6A.default), null), props.elementAfterLabel), /*#__PURE__*/ (0, $byn9U.jsx)((0, $474Xg.FieldId).Provider, {
        value: fieldId
    }, props.children({
        fieldProps: extendedFieldProps,
        error: state.error,
        valid: state.valid,
        meta: state.meta
    })));
}

});
parcelRegister("474Xg", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $7e805ca71aafc526$export$3c4232819458a302);

var $eUqFw = parcelRequire("eUqFw");
const $7e805ca71aafc526$export$3c4232819458a302 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);

});

parcelRegister("7xzQn", function(module, exports) {

$parcel$export(module.exports, "Label", () => $0bae301338f86720$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $0bae301338f86720$export$ed247974535929c7);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $0bae301338f86720$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0bae301338f86720$var$fieldsetLabelStyles = {
    name: "zjewl9",
    styles: "display:inline-block;color:var(--ds-text-subtle, #44546F);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);font-weight:var(--ds-font-weight-bold, 700);margin-block-end:var(--ds-space-050, 4px);margin-block-start:var(--ds-space-0, 0px)"
};
const $0bae301338f86720$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)("label", {
        css: $0bae301338f86720$var$fieldsetLabelStyles,
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId
    }, children);
const $0bae301338f86720$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("legend", {
        css: $0bae301338f86720$var$fieldsetLabelStyles
    }, children);
};
var $0bae301338f86720$export$2e2bcd8739ae039 = $0bae301338f86720$export$b04be29aa201d4f5;

});

parcelRegister("hGy6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f000c8a4e77bd5d$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

const $1f000c8a4e77bd5d$var$requiredIndicatorStyles = /*#__PURE__*/ (0, $byn9U.css)({
    color: `var(--ds-text-danger, ${(0, $ab6d6432a4c55680$export$2010d0fb4295b346)})`,
    fontFamily: "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingInlineStart: "var(--ds-space-025, 2px)"
});
function $1f000c8a4e77bd5d$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $1f000c8a4e77bd5d$var$requiredIndicatorStyles,
        "aria-hidden": "true",
        title: "required"
    }, "*");
}

});


parcelRegister("igUnt", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec347330e236cae1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $7xzQn = parcelRequire("7xzQn");
function $ec347330e236cae1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ec347330e236cae1$var$fieldSetStyles = {
    name: "wkpnc",
    styles: "margin-block-start:var(--ds-space-100, 8px)"
};
/**
 * __Fieldset__
 *
 * A fieldset groups a number of fields together. For example, when multiple CheckboxFields share the same name,
 * a fieldset can be used to group them together. This makes the form more accessible.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/fields)
 */ const $ec347330e236cae1$var$Fieldset = ({ children: children, legend: legend })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("fieldset", {
        css: $ec347330e236cae1$var$fieldSetStyles
    }, legend && /*#__PURE__*/ (0, $byn9U.jsx)((0, $7xzQn.Legend), null, legend), children);
};
var $ec347330e236cae1$export$2e2bcd8739ae039 = $ec347330e236cae1$var$Fieldset;

});

parcelRegister("639nA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e966e44e10d4af587c95b714fe3851cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $467a4c6dacd0aab0$var$_react = $467a4c6dacd0aab0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $467a4c6dacd0aab0$var$_close = $467a4c6dacd0aab0$var$_interopRequireDefault((parcelRequire("gaTP1")));

var $467a4c6dacd0aab0$var$_close2 = $467a4c6dacd0aab0$var$_interopRequireDefault((parcelRequire("eWXWl")));
function $467a4c6dacd0aab0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $467a4c6dacd0aab0$var$CloseIcon = (props)=>/*#__PURE__*/ $467a4c6dacd0aab0$var$_react.default.createElement($467a4c6dacd0aab0$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $467a4c6dacd0aab0$var$_close2.default
    }, props));
$467a4c6dacd0aab0$var$CloseIcon.Name = 'CloseIconMigration';
var $467a4c6dacd0aab0$var$_default = module.exports.default = $467a4c6dacd0aab0$var$CloseIcon;

});

parcelRegister("5AdW7", function(module, exports) {

$parcel$export(module.exports, "SelectWithoutAnalytics", () => $c894caa354b638c6$export$d1de3b251ccaa8a3);
$parcel$export(module.exports, "default", () => $c894caa354b638c6$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $lzpNt = parcelRequire("lzpNt");
var $dki1H = parcelRequire("dki1H");
var $dY3D1 = parcelRequire("dY3D1");

var $lSQyx = parcelRequire("lSQyx");

var $1kHVI = parcelRequire("1kHVI");
const $c894caa354b638c6$var$packageName = "platform-pkg";
const $c894caa354b638c6$var$packageVersion = "0.0.0-use.local";
const $c894caa354b638c6$export$d1de3b251ccaa8a3 = (0, $1kHVI.default)((0, $lSQyx.default));
const $c894caa354b638c6$var$createAndFireEventOnAtlaskit = (0, $lzpNt.default)('atlaskit');
const $c894caa354b638c6$var$Select = (0, $dki1H.default)({
    componentName: 'select',
    packageName: $c894caa354b638c6$var$packageName,
    packageVersion: $c894caa354b638c6$var$packageVersion
})((0, $dY3D1.default)({
    onChange: $c894caa354b638c6$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $c894caa354b638c6$var$packageName,
            packageVersion: $c894caa354b638c6$var$packageVersion
        }
    })
})($c894caa354b638c6$export$d1de3b251ccaa8a3));
var $c894caa354b638c6$export$2e2bcd8739ae039 = $c894caa354b638c6$var$Select;

});
parcelRegister("lSQyx", function(module, exports) {

$parcel$export(module.exports, "default", () => $289c17e801996fb7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $gWDyy = parcelRequire("gWDyy");

var $7BCqJ = parcelRequire("7BCqJ");
const $289c17e801996fb7$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const baseSelectProps = (0, $7BCqJ.default)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gWDyy.default), {
        ref: ref,
        ...baseSelectProps
    });
});
var $289c17e801996fb7$export$2e2bcd8739ae039 = $289c17e801996fb7$var$StateManagedSelect;

});
parcelRegister("gWDyy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0ea50a0860166ab7$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $j7g8z = parcelRequire("j7g8z");

var $hrbuT = parcelRequire("hrbuT");

var $wXYoy = parcelRequire("wXYoy");

var $43BmN = parcelRequire("43BmN");
var $416RO = parcelRequire("416RO");
var $3zafO = parcelRequire("3zafO");

var $gG6Yp = parcelRequire("gG6Yp");

var $2D1Id = parcelRequire("2D1Id");

var $5tacV = parcelRequire("5tacV");

var $avJlG = parcelRequire("avJlG");

var $4j05e = parcelRequire("4j05e");

var $lOf1W = parcelRequire("lOf1W");
const $0ea50a0860166ab7$export$9c21a3269931e1e6 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $lOf1W.isTouchCapable)(),
    captureMenuScroll: !(0, $lOf1W.isTouchCapable)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: (0, $5tacV.createFilter)(),
    formatGroupLabel: (0, $hrbuT.formatGroupLabel),
    getOptionLabel: (0, $hrbuT.getOptionLabel),
    getOptionValue: (0, $hrbuT.getOptionValue),
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: (0, $hrbuT.isOptionDisabled),
    loadingMessage: ()=>'Loading...',
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $lOf1W.isMobileDevice)(),
    noOptionsMessage: ()=>'No options',
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: ({ count: count })=>`${count} result${count !== 1 ? 's' : ''} available`,
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $0ea50a0860166ab7$var$toCategorizedOption(props, option, selectValue, index) {
    const isDisabled = $0ea50a0860166ab7$var$isOptionDisabled(props, option, selectValue);
    const isSelected = $0ea50a0860166ab7$var$isOptionSelected(props, option, selectValue);
    const label = $0ea50a0860166ab7$var$getOptionLabel(props, option);
    const value = $0ea50a0860166ab7$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $0ea50a0860166ab7$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map((groupOrOption, groupOrOptionIndex)=>{
        //@ts-ignore
        if ('options' in groupOrOption) {
            const categorizedOptions = groupOrOption.options.map((option, optionIndex)=>$0ea50a0860166ab7$var$toCategorizedOption(props, option, selectValue, optionIndex)).filter((categorizedOption)=>$0ea50a0860166ab7$var$isFocusable(props, categorizedOption));
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        const categorizedOption = $0ea50a0860166ab7$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $0ea50a0860166ab7$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $lOf1W.notNullish));
}
function $0ea50a0860166ab7$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>option.data));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $0ea50a0860166ab7$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce((optionsAccumulator, categorizedOption)=>{
        if (categorizedOption.type === 'group') optionsAccumulator.push(...categorizedOption.options.map((option)=>({
                data: option.data,
                id: `${optionId}-${categorizedOption.index}-${option.index}`
            })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: `${optionId}-${categorizedOption.index}`
        });
        return optionsAccumulator;
    }, []);
}
function $0ea50a0860166ab7$var$buildFocusableOptions(props, selectValue) {
    return $0ea50a0860166ab7$var$buildFocusableOptionsFromCategorizedOptions($0ea50a0860166ab7$var$buildCategorizedOptions(props, selectValue));
}
function $0ea50a0860166ab7$var$isFocusable(props, categorizedOption) {
    const { inputValue: inputValue = '' } = props;
    const { data: data, isSelected: isSelected, label: label, value: value } = categorizedOption;
    return (!$0ea50a0860166ab7$var$shouldHideSelectedOptions(props) || !isSelected) && $0ea50a0860166ab7$var$filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $0ea50a0860166ab7$var$getNextFocusedValue(state, nextSelectValue) {
    const { focusedValue: focusedValue, selectValue: lastSelectValue } = state;
    const lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        const nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $0ea50a0860166ab7$var$getNextFocusedOption(state, options) {
    const { focusedOption: lastFocusedOption } = state;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
const $0ea50a0860166ab7$var$getFocusedOptionId = (focusableOptionsWithIds, focusedOption)=>{
    const focusedOptionId = focusableOptionsWithIds.find((option)=>option.data === focusedOption)?.id;
    return focusedOptionId || null;
};
const $0ea50a0860166ab7$var$getOptionLabel = (props, data)=>{
    return props.getOptionLabel(data);
};
const $0ea50a0860166ab7$var$getOptionValue = (props, data)=>{
    return props.getOptionValue(data);
};
function $0ea50a0860166ab7$var$isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $0ea50a0860166ab7$var$isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    const candidate = $0ea50a0860166ab7$var$getOptionValue(props, option);
    return selectValue.some((i)=>$0ea50a0860166ab7$var$getOptionValue(props, i) === candidate);
}
function $0ea50a0860166ab7$var$filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
const $0ea50a0860166ab7$var$shouldHideSelectedOptions = (props)=>{
    const { hideSelectedOptions: hideSelectedOptions, isMulti: isMulti } = props;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
let $0ea50a0860166ab7$var$instanceId = 1;
class $0ea50a0860166ab7$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    static{
        this.defaultProps = $0ea50a0860166ab7$export$9c21a3269931e1e6;
    }
    // Lifecycle
    // ------------------------------
    constructor(props){
        super(props);
        this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        // Misc. Instance Properties
        // ------------------------------
        this.blockOptionHover = false;
        this.isComposing = false;
        this.initialTouchX = 0;
        this.initialTouchY = 0;
        this.openAfterFocus = false;
        this.scrollToFocusedOptionOnUpdate = false;
        this.isAppleDevice = (0, $j7g8z.isAppleDevice)();
        // Refs
        // ------------------------------
        this.controlRef = null;
        this.getControlRef = (ref)=>{
            this.controlRef = ref;
        };
        this.focusedOptionRef = null;
        this.getFocusedOptionRef = (ref)=>{
            this.focusedOptionRef = ref;
        };
        this.menuListRef = null;
        this.getMenuListRef = (ref)=>{
            this.menuListRef = ref;
        };
        this.inputRef = null;
        this.getInputRef = (ref)=>{
            this.inputRef = ref;
        };
        // aliased for consumers
        this.focus = this.focusInput;
        this.blur = this.blurInput;
        this.onChange = (newValue, actionMeta)=>{
            const { onChange: onChange, name: name } = this.props;
            actionMeta.name = name;
            this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        this.setValue = (newValue, action, option)=>{
            const { closeMenuOnSelect: closeMenuOnSelect, isMulti: isMulti, inputValue: inputValue } = this.props;
            this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            this.setState({
                clearFocusValueOnUpdate: true
            });
            this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        this.selectOption = (newValue)=>{
            const { blurInputOnSelect: blurInputOnSelect, isMulti: isMulti, name: name } = this.props;
            const { selectValue: selectValue } = this.state;
            const deselected = isMulti && this.isOptionSelected(newValue, selectValue);
            const isDisabled = this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                const candidate = this.getOptionValue(newValue);
                this.setValue((0, $lOf1W.multiValueAsValue)(selectValue.filter((i)=>this.getOptionValue(i) !== candidate)), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) this.setValue((0, $lOf1W.multiValueAsValue)([
                    ...selectValue,
                    newValue
                ]), 'select-option', newValue);
                else this.setValue((0, $lOf1W.singleValueAsValue)(newValue), 'select-option');
            } else {
                this.ariaOnChange((0, $lOf1W.singleValueAsValue)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) this.blurInput();
        };
        this.removeValue = (removedValue)=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const candidate = this.getOptionValue(removedValue);
            const newValueArray = selectValue.filter((i)=>this.getOptionValue(i) !== candidate);
            const newValue = (0, $lOf1W.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            this.focusInput();
        };
        this.clearValue = ()=>{
            const { selectValue: selectValue } = this.state;
            this.onChange((0, $lOf1W.valueTernary)(this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        this.popValue = ()=>{
            const { isMulti: isMulti } = this.props;
            const { selectValue: selectValue } = this.state;
            const lastSelectedValue = selectValue[selectValue.length - 1];
            const newValueArray = selectValue.slice(0, selectValue.length - 1);
            const newValue = (0, $lOf1W.valueTernary)(isMulti, newValueArray, newValueArray[0] || null);
            this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        this.getFocusedOptionId = (focusedOption)=>{
            return $0ea50a0860166ab7$var$getFocusedOptionId(this.state.focusableOptionsWithIds, focusedOption);
        };
        this.getFocusableOptionsWithIds = ()=>{
            return $0ea50a0860166ab7$var$buildFocusableOptionsWithIds($0ea50a0860166ab7$var$buildCategorizedOptions(this.props, this.state.selectValue), this.getElementId('option'));
        };
        this.getValue = ()=>this.state.selectValue;
        this.cx = (...args)=>(0, $lOf1W.classNames)(this.props.classNamePrefix, ...args);
        this.getOptionLabel = (data)=>{
            return $0ea50a0860166ab7$var$getOptionLabel(this.props, data);
        };
        this.getOptionValue = (data)=>{
            return $0ea50a0860166ab7$var$getOptionValue(this.props, data);
        };
        this.getStyles = (key, props)=>{
            const { unstyled: unstyled } = this.props;
            const base = (0, $avJlG.defaultStyles)[key](props, unstyled);
            base.boxSizing = 'border-box';
            const custom = this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        this.getClassNames = (key, props)=>this.props.classNames[key]?.(props);
        this.getElementId = (element)=>{
            return `${this.state.instancePrefix}-${element}`;
        };
        this.getComponents = ()=>{
            return (0, $wXYoy.defaultComponents)(this.props);
        };
        this.buildCategorizedOptions = ()=>$0ea50a0860166ab7$var$buildCategorizedOptions(this.props, this.state.selectValue);
        this.getCategorizedOptions = ()=>this.props.menuIsOpen ? this.buildCategorizedOptions() : [];
        this.buildFocusableOptions = ()=>$0ea50a0860166ab7$var$buildFocusableOptionsFromCategorizedOptions(this.buildCategorizedOptions());
        this.getFocusableOptions = ()=>this.props.menuIsOpen ? this.buildFocusableOptions() : [];
        // ==============================
        // Helpers
        // ==============================
        this.ariaOnChange = (value, actionMeta)=>{
            this.setState({
                ariaSelection: {
                    value: value,
                    ...actionMeta
                }
            });
        };
        // ==============================
        // Mouse Handlers
        // ==============================
        this.onMenuMouseDown = (event)=>{
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            this.focusInput();
        };
        this.onMenuMouseMove = (event)=>{
            this.blockOptionHover = false;
        };
        this.onControlMouseDown = (event)=>{
            // Event captured by dropdown indicator
            if (event.defaultPrevented) {
                // react-dnd will fire preventDefault in mouseDown, which make select is not clickable.
                // temp workaround to check if select is within dnd, we don't do the early return.
                if (!this.controlRef?.closest('[data-rbd-draggable-context-id]')) return;
            }
            const { openMenuOnClick: openMenuOnClick } = this.props;
            if (!this.state.isFocused) {
                if (openMenuOnClick) this.openAfterFocus = true;
                this.focusInput();
            } else if (!this.props.menuIsOpen) {
                if (openMenuOnClick) this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        this.onDropdownIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (this.props.isDisabled) return;
            const { isMulti: isMulti, menuIsOpen: menuIsOpen } = this.props;
            this.focusInput();
            if (menuIsOpen) {
                this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                this.onMenuClose();
            } else this.openMenu('first');
            event.preventDefault();
        };
        this.onClearIndicatorMouseDown = (event)=>{
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            this.clearValue();
            event.preventDefault();
            this.openAfterFocus = false;
            if (event.type === 'touchend') this.focusInput();
            else setTimeout(()=>this.focusInput());
        };
        this.onScroll = (event)=>{
            if (typeof this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $lOf1W.isDocumentElement)(event.target)) this.props.onMenuClose();
            } else if (typeof this.props.closeMenuOnScroll === 'function') {
                if (this.props.closeMenuOnScroll(event)) this.props.onMenuClose();
            }
        };
        this.onCompositionStart = ()=>{
            this.isComposing = true;
        };
        this.onCompositionEnd = ()=>{
            this.isComposing = false;
        };
        this.onTouchStart = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            this.initialTouchX = touch.clientX;
            this.initialTouchY = touch.clientY;
            this.userIsDragging = false;
        };
        this.onTouchMove = ({ touches: touches })=>{
            const touch = touches && touches.item(0);
            if (!touch) return;
            const deltaX = Math.abs(touch.clientX - this.initialTouchX);
            const deltaY = Math.abs(touch.clientY - this.initialTouchY);
            const moveThreshold = 5;
            this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        this.onTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (this.controlRef && !this.controlRef.contains(event.target) && this.menuListRef && !this.menuListRef.contains(event.target)) this.blurInput();
            // reset move vars
            this.initialTouchX = 0;
            this.initialTouchY = 0;
        };
        this.onControlTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onControlMouseDown(event);
        };
        this.onClearIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onClearIndicatorMouseDown(event);
        };
        this.onDropdownIndicatorTouchEnd = (event)=>{
            if (this.userIsDragging) return;
            this.onDropdownIndicatorMouseDown(event);
        };
        // ==============================
        // Focus Handlers
        // ==============================
        this.handleInputChange = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            const inputValue = event.currentTarget.value;
            this.setState({
                inputIsHiddenAfterUpdate: false
            });
            this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!this.props.menuIsOpen) this.onMenuOpen();
        };
        this.onInputFocus = (event)=>{
            if (this.props.onFocus) this.props.onFocus(event);
            this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (this.openAfterFocus || this.props.openMenuOnFocus) this.openMenu('first');
            this.openAfterFocus = false;
        };
        this.onInputBlur = (event)=>{
            const { inputValue: prevInputValue } = this.props;
            if (this.menuListRef && this.menuListRef.contains(document.activeElement)) {
                this.inputRef.focus();
                return;
            }
            if (this.props.onBlur) this.props.onBlur(event);
            this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            this.onMenuClose();
            this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        this.onOptionHover = (focusedOption)=>{
            if (this.blockOptionHover || this.state.focusedOption === focusedOption) return;
            const options = this.getFocusableOptions();
            const focusedOptionIndex = options.indexOf(focusedOption);
            this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? this.getFocusedOptionId(focusedOption) : null
            });
        };
        this.shouldHideSelectedOptions = ()=>{
            return $0ea50a0860166ab7$var$shouldHideSelectedOptions(this.props);
        };
        // If the hidden input gets focus through form submit,
        // redirect focus to focusable input.
        this.onValueInputFocus = (e)=>{
            e.preventDefault();
            e.stopPropagation();
            this.focus();
        };
        // ==============================
        // Keyboard Handlers
        // ==============================
        this.onKeyDown = (event)=>{
            const { isMulti: isMulti, backspaceRemovesValue: backspaceRemovesValue, escapeClearsValue: escapeClearsValue, inputValue: inputValue, isClearable: isClearable, isDisabled: isDisabled, menuIsOpen: menuIsOpen, onKeyDown: onKeyDown, tabSelectsValue: tabSelectsValue, openMenuOnFocus: openMenuOnFocus } = this.props;
            const { focusedOption: focusedOption, focusedValue: focusedValue, selectValue: selectValue } = this.state;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) this.popValue();
                        else if (isClearable) this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && this.isOptionSelected(focusedOption, selectValue)) return;
                    this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (this.isComposing) return;
                        this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) this.clearValue();
                    break;
                case ' ':
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) this.focusOption('up');
                    else this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) this.focusOption('down');
                    else this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        this.state.instancePrefix = 'react-select-' + (this.props.instanceId || ++$0ea50a0860166ab7$var$instanceId);
        //@ts-ignore
        this.state.selectValue = (0, $lOf1W.cleanValue)(props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (props.menuIsOpen && this.state.selectValue.length) {
            const focusableOptionsWithIds = this.getFocusableOptionsWithIds();
            const focusableOptions = this.buildFocusableOptions();
            const optionIndex = focusableOptions.indexOf(this.state.selectValue[0]);
            this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            this.state.focusedOption = focusableOptions[optionIndex];
            this.state.focusedOptionId = $0ea50a0860166ab7$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
    }
    static getDerivedStateFromProps(props, state) {
        const { prevProps: prevProps, clearFocusValueOnUpdate: clearFocusValueOnUpdate, inputIsHiddenAfterUpdate: inputIsHiddenAfterUpdate, ariaSelection: ariaSelection, isFocused: isFocused, prevWasFocused: prevWasFocused, instancePrefix: instancePrefix } = state;
        const { options: options, value: value, menuIsOpen: menuIsOpen, inputValue: inputValue, isMulti: isMulti } = props;
        //@ts-ignore
        const selectValue = (0, $lOf1W.cleanValue)(value);
        let newMenuOptionsState = {};
        if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
            const focusableOptions = menuIsOpen ? $0ea50a0860166ab7$var$buildFocusableOptions(props, selectValue) : [];
            const focusableOptionsWithIds = menuIsOpen ? $0ea50a0860166ab7$var$buildFocusableOptionsWithIds($0ea50a0860166ab7$var$buildCategorizedOptions(props, selectValue), `${instancePrefix}-option`) : [];
            const focusedValue = clearFocusValueOnUpdate ? $0ea50a0860166ab7$var$getNextFocusedValue(state, selectValue) : null;
            const focusedOption = $0ea50a0860166ab7$var$getNextFocusedOption(state, focusableOptions);
            const focusedOptionId = $0ea50a0860166ab7$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
            newMenuOptionsState = {
                selectValue: selectValue,
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionId,
                focusableOptionsWithIds: focusableOptionsWithIds,
                focusedValue: focusedValue,
                clearFocusValueOnUpdate: false
            };
        }
        // some updates should toggle the state of the input visibility
        const newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
            inputIsHidden: inputIsHiddenAfterUpdate,
            inputIsHiddenAfterUpdate: undefined
        } : {};
        let newAriaSelection = ariaSelection;
        let hasKeptFocus = isFocused && prevWasFocused;
        if (isFocused && !hasKeptFocus) {
            // If `value` or `defaultValue` props are not empty then announce them
            // when the Select is initially focused
            newAriaSelection = {
                value: (0, $lOf1W.valueTernary)(isMulti, selectValue, selectValue[0] || null),
                options: selectValue,
                action: 'initial-input-focus'
            };
            hasKeptFocus = !prevWasFocused;
        }
        // If the 'initial-input-focus' action has been set already
        // then reset the ariaSelection to null
        if (ariaSelection?.action === 'initial-input-focus') newAriaSelection = null;
        return {
            ...newMenuOptionsState,
            ...newInputIsHiddenState,
            prevProps: props,
            ariaSelection: newAriaSelection,
            prevWasFocused: hasKeptFocus
        };
    }
    componentDidMount() {
        this.startListeningComposition();
        this.startListeningToTouch();
        if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.addEventListener('scroll', this.onScroll, true);
        if (this.props.autoFocus) this.focusInput();
        // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
        if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $lOf1W.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
    }
    componentDidUpdate(prevProps) {
        const { isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        if (// ensure focus is restored correctly when the control becomes enabled
        isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
        isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
        if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: false
        }, this.onMenuClose);
        else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
            isFocused: true
        });
        // scroll the focused option into view if necessary
        if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
            (0, $lOf1W.scrollIntoView)(this.menuListRef, this.focusedOptionRef);
            this.scrollToFocusedOptionOnUpdate = false;
        }
    }
    componentWillUnmount() {
        this.stopListeningComposition();
        this.stopListeningToTouch();
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        document.removeEventListener('scroll', this.onScroll, true);
    }
    // ==============================
    // Consumer Handlers
    // ==============================
    onMenuOpen() {
        this.props.onMenuOpen();
    }
    onMenuClose() {
        this.onInputChange('', {
            action: 'menu-close',
            prevInputValue: this.props.inputValue
        });
        this.props.onMenuClose();
    }
    onInputChange(newValue, actionMeta) {
        this.props.onInputChange(newValue, actionMeta);
    }
    // ==============================
    // Methods
    // ==============================
    focusInput() {
        if (!this.inputRef) return;
        this.inputRef.focus();
    }
    blurInput() {
        if (!this.inputRef) return;
        this.inputRef.blur();
    }
    openMenu(focusOption) {
        const { selectValue: selectValue, isFocused: isFocused } = this.state;
        const focusableOptions = this.buildFocusableOptions();
        let openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
        if (!this.props.isMulti) {
            const selectedIndex = focusableOptions.indexOf(selectValue[0]);
            if (selectedIndex > -1) openAtIndex = selectedIndex;
        }
        // only scroll if the menu isn't already open
        this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
        this.setState({
            inputIsHiddenAfterUpdate: false,
            focusedValue: null,
            focusedOption: focusableOptions[openAtIndex],
            focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
        }, ()=>this.onMenuOpen());
    }
    focusValue(direction) {
        const { selectValue: selectValue, focusedValue: focusedValue } = this.state;
        // Only multiselects support value focusing
        if (!this.props.isMulti) return;
        this.setState({
            focusedOption: null
        });
        let focusedIndex = selectValue.indexOf(focusedValue);
        if (!focusedValue) focusedIndex = -1;
        const lastIndex = selectValue.length - 1;
        let nextFocus = -1;
        if (!selectValue.length) return;
        switch(direction){
            case 'previous':
                if (focusedIndex === 0) // don't cycle from the start to the end
                nextFocus = 0;
                else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                nextFocus = lastIndex;
                else nextFocus = focusedIndex - 1;
                break;
            case 'next':
                if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                break;
        }
        this.setState({
            inputIsHidden: nextFocus !== -1,
            focusedValue: selectValue[nextFocus]
        });
    }
    focusOption(direction = 'first') {
        const { pageSize: pageSize } = this.props;
        const { focusedOption: focusedOption } = this.state;
        const options = this.getFocusableOptions();
        if (!options.length) return;
        let nextFocus = 0; // handles 'first'
        let focusedIndex = options.indexOf(focusedOption);
        if (!focusedOption) focusedIndex = -1;
        if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
        else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
        else if (direction === 'pageup') {
            nextFocus = focusedIndex - pageSize;
            if (nextFocus < 0) nextFocus = 0;
        } else if (direction === 'pagedown') {
            nextFocus = focusedIndex + pageSize;
            if (nextFocus > options.length - 1) nextFocus = options.length - 1;
        } else if (direction === 'last') nextFocus = options.length - 1;
        this.scrollToFocusedOptionOnUpdate = true;
        this.setState({
            focusedOption: options[nextFocus],
            focusedValue: null,
            focusedOptionId: this.getFocusedOptionId(options[nextFocus])
        });
    }
    // ==============================
    // Getters
    // ==============================
    getTheme() {
        // Use the default theme if there are no customisations.
        if (!this.props.theme) return 0, $4j05e.defaultTheme;
        // If the theme prop is a function, assume the function
        // knows how to merge the passed-in default theme with
        // its own modifications.
        if (typeof this.props.theme === 'function') return this.props.theme((0, $4j05e.defaultTheme));
        // Otherwise, if a plain theme object was passed in,
        // overlay it with the default theme.
        return {
            ...(0, $4j05e.defaultTheme),
            ...this.props.theme
        };
    }
    getCommonProps() {
        const { clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, selectOption: selectOption, setValue: setValue, props: props } = this;
        const { isMulti: isMulti, isRtl: isRtl, options: options } = props;
        const hasValue = this.hasValue();
        return {
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getClassNames: getClassNames,
            getValue: getValue,
            hasValue: hasValue,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: props,
            setValue: setValue,
            theme: this.getTheme()
        };
    }
    hasValue() {
        const { selectValue: selectValue } = this.state;
        return selectValue.length > 0;
    }
    hasOptions() {
        return !!this.getFocusableOptions().length;
    }
    isClearable() {
        const { isClearable: isClearable, isMulti: isMulti } = this.props;
        // single select, by default, IS NOT clearable
        // multi select, by default, IS clearable
        if (isClearable === undefined) return isMulti;
        return isClearable;
    }
    isOptionDisabled(option, selectValue) {
        return $0ea50a0860166ab7$var$isOptionDisabled(this.props, option, selectValue);
    }
    isOptionSelected(option, selectValue) {
        return $0ea50a0860166ab7$var$isOptionSelected(this.props, option, selectValue);
    }
    filterOption(option, inputValue) {
        return $0ea50a0860166ab7$var$filterOption(this.props, option, inputValue);
    }
    formatOptionLabel(data, context) {
        if (typeof this.props.formatOptionLabel === 'function') {
            const { inputValue: inputValue } = this.props;
            const { selectValue: selectValue } = this.state;
            return this.props.formatOptionLabel(data, {
                context: context,
                inputValue: inputValue,
                selectValue: selectValue
            });
        } else return this.getOptionLabel(data);
    }
    formatGroupLabel(data) {
        return this.props.formatGroupLabel(data);
    }
    // ==============================
    // Composition Handlers
    // ==============================
    startListeningComposition() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionstart', this.onCompositionStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('compositionend', this.onCompositionEnd, false);
        }
    }
    stopListeningComposition() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionstart', this.onCompositionStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('compositionend', this.onCompositionEnd);
        }
    }
    // ==============================
    // Touch Handlers
    // ==============================
    startListeningToTouch() {
        if (document && document.addEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchstart', this.onTouchStart, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchmove', this.onTouchMove, false);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.addEventListener('touchend', this.onTouchEnd, false);
        }
    }
    stopListeningToTouch() {
        if (document && document.removeEventListener) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchstart', this.onTouchStart);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchmove', this.onTouchMove);
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            document.removeEventListener('touchend', this.onTouchEnd);
        }
    }
    // ==============================
    // Renderers
    // ==============================
    renderInput() {
        const { descriptionId: descriptionId, form: form, inputId: inputId, inputValue: inputValue, isDisabled: isDisabled, isInvalid: isInvalid, isRequired: isRequired, isSearchable: isSearchable, label: label, labelId: labelId, menuIsOpen: menuIsOpen, required: required, tabIndex: tabIndex } = this.props;
        const { Input: Input } = this.getComponents();
        const { inputIsHidden: inputIsHidden, ariaSelection: ariaSelection } = this.state;
        const { commonProps: commonProps } = this;
        const id = inputId || this.getElementId('input');
        const description = this.props['aria-describedby'] || descriptionId;
        // aria attributes makes the JSX "noisy", separated for clarity
        const ariaAttributes = {
            'aria-autocomplete': 'list',
            'aria-errormessage': this.props['aria-errormessage'],
            'aria-expanded': menuIsOpen,
            'aria-haspopup': 'listbox',
            'aria-describedby': description,
            'aria-invalid': this.props['aria-invalid'] || isInvalid,
            'aria-label': this.props['aria-label'] || label,
            'aria-labelledby': this.props['aria-labelledby'] || labelId,
            'aria-required': required || isRequired,
            role: 'combobox',
            'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId,
            ...menuIsOpen && {
                'aria-controls': this.getElementId('listbox')
            },
            ...!isSearchable && {
                'aria-readonly': true
            },
            ...this.hasValue() ? ariaSelection?.action === 'initial-input-focus' && {
                'aria-describedby': description ? [
                    description,
                    this.getElementId('live-region')
                ].join(' ') : this.getElementId('live-region')
            } : {
                'aria-describedby': description ? [
                    description,
                    this.getElementId('placeholder')
                ].join(' ') : this.getElementId('placeholder')
            }
        };
        if (!isSearchable) // use a dummy input to maintain focus/blur functionality
        return(//@ts-ignore
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $43BmN.default), {
            id: id,
            innerRef: this.getInputRef,
            onBlur: this.onInputBlur,
            onChange: (0, $lOf1W.noop),
            onFocus: this.onInputFocus,
            disabled: isDisabled,
            tabIndex: tabIndex,
            inputMode: "none",
            form: form,
            value: "",
            ...ariaAttributes
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Input, {
            ...commonProps,
            autoCapitalize: "none",
            autoComplete: "off",
            autoCorrect: "off",
            id: id,
            innerRef: this.getInputRef,
            isDisabled: isDisabled,
            isHidden: inputIsHidden,
            onBlur: this.onInputBlur,
            onChange: this.handleInputChange,
            onFocus: this.onInputFocus,
            spellCheck: "false",
            tabIndex: tabIndex,
            form: form,
            type: "text",
            value: inputValue,
            ...ariaAttributes
        });
    }
    renderPlaceholderOrValue() {
        const { MultiValue: MultiValue, MultiValueContainer: MultiValueContainer, MultiValueLabel: MultiValueLabel, MultiValueRemove: MultiValueRemove, SingleValue: SingleValue, Placeholder: Placeholder } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { controlShouldRenderValue: controlShouldRenderValue, isDisabled: isDisabled, isMulti: isMulti, inputValue: inputValue, placeholder: placeholder } = this.props;
        const { selectValue: selectValue, focusedValue: focusedValue, isFocused: isFocused } = this.state;
        if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Placeholder, {
            ...commonProps,
            key: "placeholder",
            isDisabled: isDisabled,
            isFocused: isFocused,
            innerProps: {
                id: this.getElementId('placeholder')
            }
        }, placeholder);
        if (isMulti) return selectValue.map((opt, index)=>{
            const isOptionFocused = opt === focusedValue;
            const key = `${this.getOptionLabel(opt)}-${this.getOptionValue(opt)}`;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MultiValue, {
                ...commonProps,
                components: {
                    Container: MultiValueContainer,
                    Label: MultiValueLabel,
                    Remove: MultiValueRemove
                },
                isFocused: isOptionFocused,
                isDisabled: isDisabled,
                key: key,
                index: index,
                removeProps: {
                    onClick: ()=>this.removeValue(opt),
                    onTouchEnd: ()=>this.removeValue(opt),
                    onMouseDown: (e)=>{
                        e.preventDefault();
                    }
                },
                data: opt
            }, this.formatOptionLabel(opt, 'value'));
        });
        if (inputValue) return null;
        const singleValue = selectValue[0];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SingleValue, {
            ...commonProps,
            data: singleValue,
            isDisabled: isDisabled
        }, this.formatOptionLabel(singleValue, 'value'));
    }
    renderClearIndicator() {
        const { ClearIndicator: ClearIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
        const innerProps = {
            onMouseDown: this.onClearIndicatorMouseDown,
            onTouchEnd: this.onClearIndicatorTouchEnd,
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ClearIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isFocused: isFocused
        });
    }
    renderLoadingIndicator() {
        const { LoadingIndicator: LoadingIndicator } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled, isLoading: isLoading } = this.props;
        const { isFocused: isFocused } = this.state;
        if (!LoadingIndicator || !isLoading) return null;
        const innerProps = {
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadingIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderIndicatorSeparator() {
        const { DropdownIndicator: DropdownIndicator, IndicatorSeparator: IndicatorSeparator } = this.getComponents();
        // separator doesn't make sense without the dropdown indicator
        if (!DropdownIndicator || !IndicatorSeparator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled } = this.props;
        const { isFocused: isFocused } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IndicatorSeparator, {
            ...commonProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderDropdownIndicator() {
        const { DropdownIndicator: DropdownIndicator } = this.getComponents();
        if (!DropdownIndicator) return null;
        const { commonProps: commonProps } = this;
        const { isDisabled: isDisabled } = this.props;
        const { isFocused: isFocused } = this.state;
        const innerProps = {
            onMouseDown: this.onDropdownIndicatorMouseDown,
            onTouchEnd: this.onDropdownIndicatorTouchEnd,
            'aria-hidden': 'true'
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(DropdownIndicator, {
            ...commonProps,
            innerProps: innerProps,
            isDisabled: isDisabled,
            isFocused: isFocused
        });
    }
    renderMenu() {
        const { Group: Group, GroupHeading: GroupHeading, Menu: Menu, MenuList: MenuList, MenuPortal: MenuPortal, LoadingMessage: LoadingMessage, NoOptionsMessage: NoOptionsMessage, Option: Option } = this.getComponents();
        const { commonProps: commonProps } = this;
        const { focusedOption: focusedOption } = this.state;
        const { captureMenuScroll: captureMenuScroll, inputValue: inputValue, isLoading: isLoading, loadingMessage: loadingMessage, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuIsOpen: menuIsOpen, menuPlacement: menuPlacement, menuPosition: menuPosition, menuPortalTarget: menuPortalTarget, menuShouldBlockScroll: menuShouldBlockScroll, menuShouldScrollIntoView: menuShouldScrollIntoView, noOptionsMessage: noOptionsMessage, onMenuScrollToTop: onMenuScrollToTop, onMenuScrollToBottom: onMenuScrollToBottom } = this.props;
        if (!menuIsOpen) return null;
        // TODO: Internal Option Type here
        const render = (props, id)=>{
            const { type: type, data: data, isDisabled: isDisabled, isSelected: isSelected, label: label, value: value } = props;
            const isFocused = focusedOption === data;
            const onHover = isDisabled ? undefined : ()=>this.onOptionHover(data);
            const onSelect = isDisabled ? undefined : ()=>this.selectOption(data);
            const optionId = `${this.getElementId('option')}-${id}`;
            const innerProps = {
                id: optionId,
                onClick: onSelect,
                onMouseMove: onHover,
                onMouseOver: onHover,
                role: 'option',
                'aria-selected': this.isAppleDevice ? undefined : isSelected
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Option, {
                ...commonProps,
                innerProps: innerProps,
                data: data,
                isDisabled: isDisabled,
                isSelected: isSelected,
                key: optionId,
                label: label,
                type: type,
                value: value,
                isFocused: isFocused,
                innerRef: isFocused ? this.getFocusedOptionRef : undefined
            }, this.formatOptionLabel(props.data, 'menu'));
        };
        let menuUI;
        if (this.hasOptions()) menuUI = this.getCategorizedOptions().map((item)=>{
            if (item.type === 'group') {
                const { data: data, options: options, index: groupIndex } = item;
                const groupId = `${this.getElementId('group')}-${groupIndex}`;
                const headingId = `${groupId}-heading`;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Group, {
                    ...commonProps,
                    key: groupId,
                    data: data,
                    options: options,
                    Heading: GroupHeading,
                    headingProps: {
                        id: headingId,
                        data: item.data
                    },
                    label: this.formatGroupLabel(item.data)
                }, item.options.map((option)=>render(option, `${groupIndex}-${option.index}`)));
            } else if (item.type === 'option') return render(item, `${item.index}`);
        });
        else if (isLoading) {
            const message = loadingMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(LoadingMessage, commonProps, message);
        } else {
            const message = noOptionsMessage({
                inputValue: inputValue
            });
            if (message === null) return null;
            menuUI = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(NoOptionsMessage, commonProps, message);
        }
        const menuPlacementProps = {
            minMenuHeight: minMenuHeight,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView
        };
        const menuElement = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2D1Id.MenuPlacer), {
            ...commonProps,
            ...menuPlacementProps
        }, ({ ref: ref, placerProps: { placement: placement, maxHeight: maxHeight } })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Menu, {
                ...commonProps,
                ...menuPlacementProps,
                innerRef: ref,
                innerProps: {
                    onMouseDown: this.onMenuMouseDown,
                    onMouseMove: this.onMenuMouseMove,
                    id: this.props.components.Menu ? this.getElementId('listbox') : undefined
                },
                isLoading: isLoading,
                placement: placement
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3zafO.default), {
                captureEnabled: captureMenuScroll,
                onTopArrive: onMenuScrollToTop,
                onBottomArrive: onMenuScrollToBottom,
                lockEnabled: menuShouldBlockScroll
            }, (scrollTargetRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuList, {
                    ...commonProps,
                    innerRef: (instance)=>{
                        this.getMenuListRef(instance);
                        scrollTargetRef(instance);
                    },
                    innerProps: {
                        role: 'listbox',
                        'aria-multiselectable': commonProps.isMulti,
                        id: this.getElementId('listbox')
                    },
                    isLoading: isLoading,
                    maxHeight: maxHeight,
                    focusedOption: focusedOption
                }, menuUI))));
        // positioning behaviour is almost identical for portalled and fixed,
        // so we use the same component. the actual portalling logic is forked
        // within the component based on `menuPosition`
        return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(MenuPortal, {
            ...commonProps,
            appendTo: menuPortalTarget,
            controlElement: this.controlRef,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition
        }, menuElement) : menuElement;
    }
    renderFormField() {
        const { delimiter: delimiter, isDisabled: isDisabled, isMulti: isMulti, required: required, name: name } = this.props;
        const { selectValue: selectValue } = this.state;
        if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $416RO.default), {
            name: name,
            onFocus: this.onValueInputFocus
        });
        if (!name || isDisabled) return;
        if (isMulti) {
            if (delimiter) {
                const value = selectValue.map((opt)=>this.getOptionValue(opt)).join(delimiter);
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: value
                });
            } else {
                const input = selectValue.length > 0 ? selectValue.map((opt, i)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                        key: `i-${i}`,
                        name: name,
                        type: "hidden",
                        value: this.getOptionValue(opt)
                    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                    name: name,
                    type: "hidden",
                    value: ""
                });
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("div", null, input);
            }
        } else {
            const value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("input", {
                name: name,
                type: "hidden",
                value: value
            });
        }
    }
    renderLiveRegion() {
        const { commonProps: commonProps } = this;
        const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, isFocused: isFocused, selectValue: selectValue } = this.state;
        const focusableOptions = this.getFocusableOptions();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gG6Yp.default), {
            ...commonProps,
            id: this.getElementId('live-region'),
            ariaSelection: ariaSelection,
            focusedOption: focusedOption,
            focusedValue: focusedValue,
            isFocused: isFocused,
            selectValue: selectValue,
            focusableOptions: focusableOptions,
            isAppleDevice: this.isAppleDevice
        });
    }
    render() {
        const { Control: Control, IndicatorsContainer: IndicatorsContainer, SelectContainer: SelectContainer, ValueContainer: ValueContainer } = this.getComponents();
        const { className: className, id: id, isDisabled: isDisabled, menuIsOpen: menuIsOpen } = this.props;
        const { isFocused: isFocused } = this.state;
        const commonProps = this.commonProps = this.getCommonProps();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(SelectContainer, {
            ...commonProps,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            innerProps: {
                id: id,
                onKeyDown: this.onKeyDown
            },
            isDisabled: isDisabled,
            isFocused: isFocused
        }, this.renderLiveRegion(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Control, {
            ...commonProps,
            innerRef: this.getControlRef,
            innerProps: {
                onMouseDown: this.onControlMouseDown,
                onTouchEnd: this.onControlTouchEnd
            },
            isDisabled: isDisabled,
            isFocused: isFocused,
            menuIsOpen: menuIsOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(ValueContainer, {
            ...commonProps,
            isDisabled: isDisabled
        }, this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(IndicatorsContainer, {
            ...commonProps,
            isDisabled: isDisabled
        }, this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
    }
}

});
parcelRegister("j7g8z", function(module, exports) {

$parcel$export(module.exports, "isAppleDevice", () => $6b015578c4b20e6b$export$e1865c3bedcd822b);
function $6b015578c4b20e6b$var$testPlatform(re) {
    return typeof window !== 'undefined' && window.navigator != null ? re.test(window.navigator['userAgentData']?.platform || window.navigator.platform) : false;
}
function $6b015578c4b20e6b$export$186c6964ca17d99() {
    return $6b015578c4b20e6b$var$testPlatform(/^iPhone/i);
}
function $6b015578c4b20e6b$export$9ac100e40613ea10() {
    return $6b015578c4b20e6b$var$testPlatform(/^Mac/i);
}
function $6b015578c4b20e6b$export$7bef049ce92e4224() {
    return $6b015578c4b20e6b$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    // eslint-disable-next-line compat/compat
    $6b015578c4b20e6b$export$9ac100e40613ea10() && navigator.maxTouchPoints > 1;
}
function $6b015578c4b20e6b$export$fedb369cb70207f1() {
    return $6b015578c4b20e6b$export$186c6964ca17d99() || $6b015578c4b20e6b$export$7bef049ce92e4224();
}
function $6b015578c4b20e6b$export$e1865c3bedcd822b() {
    return $6b015578c4b20e6b$export$9ac100e40613ea10() || $6b015578c4b20e6b$export$fedb369cb70207f1();
}

});

parcelRegister("hrbuT", function(module, exports) {

$parcel$export(module.exports, "formatGroupLabel", () => $27c122a701104641$export$f4da216a6ca54656);
$parcel$export(module.exports, "getOptionLabel", () => $27c122a701104641$export$dac6ace3020563ca);
$parcel$export(module.exports, "getOptionValue", () => $27c122a701104641$export$40be908210c5a79c);
$parcel$export(module.exports, "isOptionDisabled", () => $27c122a701104641$export$56bd0c8d90db075);
/* eslint-disable @repo/internal/fs/filename-pattern-match */ const $27c122a701104641$export$f4da216a6ca54656 = (group)=>group.label;
const $27c122a701104641$export$dac6ace3020563ca = (option)=>option.label;
const $27c122a701104641$export$40be908210c5a79c = (option)=>option.value;
const $27c122a701104641$export$56bd0c8d90db075 = (option)=>!!option.isDisabled;

});

parcelRegister("wXYoy", function(module, exports) {

$parcel$export(module.exports, "components", () => $92906756254d7ad0$export$9b5ac10f59f76296);
$parcel$export(module.exports, "defaultComponents", () => $92906756254d7ad0$export$71abc632aa29e6fe);

var $dAcDB = parcelRequire("dAcDB");

var $cuwnQ = parcelRequire("cuwnQ");

var $hnzsB = parcelRequire("hnzsB");

var $32G5A = parcelRequire("32G5A");

var $4iUjk = parcelRequire("4iUjk");

var $2D1Id = parcelRequire("2D1Id");

var $4thND = parcelRequire("4thND");

var $87IA6 = parcelRequire("87IA6");

var $ju14b = parcelRequire("ju14b");

var $1ffr4 = parcelRequire("1ffr4");
const $92906756254d7ad0$export$9b5ac10f59f76296 = {
    ClearIndicator: (0, $32G5A.ClearIndicator),
    Control: (0, $cuwnQ.default),
    DropdownIndicator: (0, $32G5A.DropdownIndicator),
    DownChevron: (0, $32G5A.DownChevron),
    CrossIcon: (0, $32G5A.CrossIcon),
    Group: (0, $hnzsB.default),
    GroupHeading: (0, $hnzsB.GroupHeading),
    IndicatorsContainer: (0, $dAcDB.IndicatorsContainer),
    IndicatorSeparator: (0, $32G5A.IndicatorSeparator),
    Input: (0, $4iUjk.default),
    LoadingIndicator: (0, $32G5A.LoadingIndicator),
    Menu: (0, $2D1Id.default),
    MenuList: (0, $2D1Id.MenuList),
    MenuPortal: (0, $2D1Id.MenuPortal),
    LoadingMessage: (0, $2D1Id.LoadingMessage),
    NoOptionsMessage: (0, $2D1Id.NoOptionsMessage),
    MultiValue: (0, $4thND.default),
    MultiValueContainer: (0, $4thND.MultiValueContainer),
    MultiValueLabel: (0, $4thND.MultiValueLabel),
    MultiValueRemove: (0, $4thND.MultiValueRemove),
    Option: (0, $87IA6.default),
    Placeholder: (0, $ju14b.default),
    SelectContainer: (0, $dAcDB.SelectContainer),
    SingleValue: (0, $1ffr4.default),
    ValueContainer: (0, $dAcDB.ValueContainer)
};
const $92906756254d7ad0$export$71abc632aa29e6fe = (props)=>({
        ...$92906756254d7ad0$export$9b5ac10f59f76296,
        ...props.components
    });

});
parcelRegister("dAcDB", function(module, exports) {

$parcel$export(module.exports, "containerCSS", () => $0edb6ef16d035212$export$949392aeaf7d2e3a);
$parcel$export(module.exports, "SelectContainer", () => $0edb6ef16d035212$export$446eebadefe1123b);
$parcel$export(module.exports, "valueContainerCSS", () => $0edb6ef16d035212$export$47aec73c7aa6b9aa);
$parcel$export(module.exports, "ValueContainer", () => $0edb6ef16d035212$export$4dc9f58ad9a1a000);
$parcel$export(module.exports, "indicatorsContainerCSS", () => $0edb6ef16d035212$export$9d74e3c8b5868ad7);
$parcel$export(module.exports, "IndicatorsContainer", () => $0edb6ef16d035212$export$d0ffd7e649cab6f);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $lOf1W = parcelRequire("lOf1W");
const $0edb6ef16d035212$export$949392aeaf7d2e3a = ({ isDisabled: isDisabled, isRtl: isRtl })=>({
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    });
const $0edb6ef16d035212$export$446eebadefe1123b = (props)=>{
    const { children: children, innerProps: innerProps, isDisabled: isDisabled, isRtl: isRtl } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)(props, 'container', {
            '--is-disabled': isDisabled,
            '--is-rtl': isRtl
        }),
        ...innerProps
    }, children);
};
const $0edb6ef16d035212$export$47aec73c7aa6b9aa = ({ theme: { spacing: spacing }, isMulti: isMulti, hasValue: hasValue, selectProps: { controlShouldRenderValue: controlShouldRenderValue } }, unstyled)=>({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden',
        ...unstyled ? {} : {
            padding: `${spacing.baseUnit / 2}px ${spacing.baseUnit * 2}px`
        }
    });
const $0edb6ef16d035212$export$4dc9f58ad9a1a000 = (props)=>{
    const { children: children, innerProps: innerProps, isMulti: isMulti, hasValue: hasValue } = props;
    const styles = (0, $lOf1W.getStyleProps)(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    });
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: styles.css,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: styles.className || 'value-container',
        ...innerProps
    }, children);
};
const $0edb6ef16d035212$export$9d74e3c8b5868ad7 = ()=>({
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    });
const $0edb6ef16d035212$export$d0ffd7e649cab6f = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)(props, 'indicatorsContainer', {
            indicators: true
        }),
        ...innerProps
    }, children);
};

});
parcelRegister("lOf1W", function(module, exports) {

$parcel$export(module.exports, "noop", () => $b505883495bd154d$export$8793edee2d425525);
$parcel$export(module.exports, "classNames", () => $b505883495bd154d$export$ce4ab0c55987d1ff);
$parcel$export(module.exports, "cleanValue", () => $b505883495bd154d$export$33f062f47f21a01);
$parcel$export(module.exports, "cleanCommonProps", () => $b505883495bd154d$export$8e9fd4287627890c);
$parcel$export(module.exports, "getStyleProps", () => $b505883495bd154d$export$26417cabd806a658);
$parcel$export(module.exports, "handleInputChange", () => $b505883495bd154d$export$2096bae78ecda911);
$parcel$export(module.exports, "isDocumentElement", () => $b505883495bd154d$export$d8a62a489b442872);
$parcel$export(module.exports, "normalizedHeight", () => $b505883495bd154d$export$2e0654fad740d2e4);
$parcel$export(module.exports, "getScrollTop", () => $b505883495bd154d$export$c4a223a8ba9e4ea5);
$parcel$export(module.exports, "scrollTo", () => $b505883495bd154d$export$3f99968195accfaf);
$parcel$export(module.exports, "getScrollParent", () => $b505883495bd154d$export$cfa2225e87938781);
$parcel$export(module.exports, "animatedScrollTo", () => $b505883495bd154d$export$858c30343199f3af);
$parcel$export(module.exports, "scrollIntoView", () => $b505883495bd154d$export$53a0910f038337bd);
$parcel$export(module.exports, "getBoundingClientObj", () => $b505883495bd154d$export$7807c2a424c2f6d1);
$parcel$export(module.exports, "isTouchCapable", () => $b505883495bd154d$export$56963d77dbffdde7);
$parcel$export(module.exports, "isMobileDevice", () => $b505883495bd154d$export$44f917bf91becd01);
$parcel$export(module.exports, "supportsPassiveEvents", () => $b505883495bd154d$export$b0622a6911dbeaf5);
$parcel$export(module.exports, "notNullish", () => $b505883495bd154d$export$aedb69ff3e31596c);
$parcel$export(module.exports, "valueTernary", () => $b505883495bd154d$export$40fb9515c784cc3b);
$parcel$export(module.exports, "singleValueAsValue", () => $b505883495bd154d$export$dea4763e29237f4c);
$parcel$export(module.exports, "multiValueAsValue", () => $b505883495bd154d$export$d1ca752ec761b95b);
$parcel$export(module.exports, "removeProps", () => $b505883495bd154d$export$4213b25a1c4e877);
const $b505883495bd154d$export$8793edee2d425525 = ()=>{};
const $b505883495bd154d$export$1643ccb46f49255c = ()=>'';
// ==============================
// Class Name Prefixer
// ==============================
/**
 * String representation of component state for styling with class names.
 *
 * Expects an array of strings OR a string/object pair:
 * - className(['comp', 'comp-arg', 'comp-arg-2'])
 * @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 * - className('comp', { some: true, state: false })
 * @returns 'react-select__comp react-select__comp--some'
 */ function $b505883495bd154d$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $b505883495bd154d$export$ce4ab0c55987d1ff(prefix, state, ...classNameList) {
    const arr = [
        ...classNameList
    ];
    if (state && prefix) {
        for(let key in state)if (state.hasOwnProperty(key) && state[key]) arr.push(`${$b505883495bd154d$var$applyPrefixToName(prefix, key)}`);
    }
    return arr.filter((i)=>i).map((i)=>String(i).trim()).join(' ');
}
const $b505883495bd154d$export$33f062f47f21a01 = (value)=>{
    if ($b505883495bd154d$export$43bee75e5e14138e(value)) return value.filter(Boolean);
    if (typeof value === 'object' && value !== null) return [
        value
    ];
    return [];
};
const $b505883495bd154d$export$8e9fd4287627890c = (props)=>{
    //className
    const { className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getClassNames: getClassNames, getValue: getValue, hasValue: hasValue, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, theme: theme, ...innerProps } = props;
    return {
        ...innerProps
    };
};
const $b505883495bd154d$export$26417cabd806a658 = (props, name, classNamesState)=>{
    const { cx: cx, getStyles: getStyles, getClassNames: getClassNames, className: className } = props;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState ?? {}, getClassNames(name, props), className)
    };
};
function $b505883495bd154d$export$2096bae78ecda911(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        const newValue = onInputChange(inputValue, actionMeta);
        if (typeof newValue === 'string') return newValue;
    }
    return inputValue;
}
function $b505883495bd154d$export$d8a62a489b442872(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
function $b505883495bd154d$export$2e0654fad740d2e4(el) {
    if ($b505883495bd154d$export$d8a62a489b442872(el)) return window.innerHeight;
    return el.clientHeight;
}
function $b505883495bd154d$export$c4a223a8ba9e4ea5(el) {
    if ($b505883495bd154d$export$d8a62a489b442872(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $b505883495bd154d$export$3f99968195accfaf(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($b505883495bd154d$export$d8a62a489b442872(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
function $b505883495bd154d$export$cfa2225e87938781(element) {
    let style = getComputedStyle(element);
    const excludeStaticParent = style.position === 'absolute';
    const overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(let parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
 * @param t: time (elapsed)
 * @param b: initial value
 * @param c: amount of change
 * @param d: duration
 */ function $b505883495bd154d$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $b505883495bd154d$export$858c30343199f3af(element, to, duration = 200, callback = $b505883495bd154d$export$8793edee2d425525) {
    const start = $b505883495bd154d$export$c4a223a8ba9e4ea5(element);
    const change = to - start;
    const increment = 10;
    let currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        const val = $b505883495bd154d$var$easeOutCubic(currentTime, start, change, duration);
        $b505883495bd154d$export$3f99968195accfaf(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
function $b505883495bd154d$export$53a0910f038337bd(menuEl, focusedEl) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $b505883495bd154d$export$3f99968195accfaf(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $b505883495bd154d$export$3f99968195accfaf(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
function $b505883495bd154d$export$7807c2a424c2f6d1(element) {
    const rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
function $b505883495bd154d$export$c0d0115e766e14c3(str) {
    return str.replace(/\W/g, '-');
}
function $b505883495bd154d$export$56963d77dbffdde7() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
function $b505883495bd154d$export$44f917bf91becd01() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
let $b505883495bd154d$var$passiveOptionAccessed = false;
const $b505883495bd154d$var$options = {
    get passive () {
        return $b505883495bd154d$var$passiveOptionAccessed = true;
    }
};
// check for SSR
const $b505883495bd154d$var$w = typeof window !== 'undefined' ? window : {};
if ($b505883495bd154d$var$w.addEventListener && $b505883495bd154d$var$w.removeEventListener) {
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $b505883495bd154d$var$w.addEventListener('p', $b505883495bd154d$export$8793edee2d425525, $b505883495bd154d$var$options);
    // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
    $b505883495bd154d$var$w.removeEventListener('p', $b505883495bd154d$export$8793edee2d425525, false);
}
const $b505883495bd154d$export$b0622a6911dbeaf5 = $b505883495bd154d$var$passiveOptionAccessed;
function $b505883495bd154d$export$aedb69ff3e31596c(item) {
    return item != null;
}
function $b505883495bd154d$export$43bee75e5e14138e(arg) {
    return Array.isArray(arg);
}
function $b505883495bd154d$export$40fb9515c784cc3b(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $b505883495bd154d$export$dea4763e29237f4c(singleValue) {
    return singleValue;
}
function $b505883495bd154d$export$d1ca752ec761b95b(multiValue) {
    return multiValue;
}
const $b505883495bd154d$export$4213b25a1c4e877 = (propsObj, ...properties)=>{
    let propsMap = Object.entries(propsObj).filter(([key])=>!properties.includes(key));
    return propsMap.reduce((newProps, [key, val])=>{
        newProps[key] = val;
        return newProps;
    }, {});
};

});


parcelRegister("cuwnQ", function(module, exports) {

$parcel$export(module.exports, "css", () => $758d7df0066fb30b$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $758d7df0066fb30b$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $lOf1W = parcelRequire("lOf1W");
const $758d7df0066fb30b$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, isFocused: isFocused, theme: { colors: colors, borderRadius: borderRadius, spacing: spacing } }, unstyled)=>({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms',
        ...unstyled ? {} : {
            backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
            borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
            borderRadius: borderRadius,
            borderStyle: 'solid',
            borderWidth: 1,
            boxShadow: isFocused ? `0 0 0 1px ${colors.primary}` : undefined,
            '&:hover': {
                borderColor: isFocused ? colors.primary : colors.neutral30
            }
        }
    });
const $758d7df0066fb30b$var$Control = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, innerRef: innerRef, innerProps: innerProps, menuIsOpen: menuIsOpen } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: innerRef,
        ...(0, $lOf1W.getStyleProps)(props, 'control', {
            control: true,
            'control--is-disabled': isDisabled,
            'control--is-focused': isFocused,
            'control--menu-is-open': menuIsOpen
        }),
        ...innerProps,
        "aria-disabled": isDisabled || undefined
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$758d7df0066fb30b$export$2e2bcd8739ae039 = $758d7df0066fb30b$var$Control;

});

parcelRegister("hnzsB", function(module, exports) {

$parcel$export(module.exports, "groupCSS", () => $b08a364db6613ab1$export$b6794329c1460634);
$parcel$export(module.exports, "groupHeadingCSS", () => $b08a364db6613ab1$export$e5a7fbb542efcb7d);
$parcel$export(module.exports, "GroupHeading", () => $b08a364db6613ab1$export$85c8b41a3cd87edc);
$parcel$export(module.exports, "default", () => $b08a364db6613ab1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $lOf1W = parcelRequire("lOf1W");
const $b08a364db6613ab1$export$b6794329c1460634 = ({ theme: { spacing: spacing } }, unstyled)=>unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
const $b08a364db6613ab1$var$Group = (props)=>{
    const { children: children, cx: cx, getStyles: getStyles, getClassNames: getClassNames, Heading: Heading, headingProps: headingProps, innerProps: innerProps, label: label, theme: theme, selectProps: selectProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)(props, 'group', {
            group: true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Heading, {
        ...headingProps,
        selectProps: selectProps,
        // eslint-disable-next-line @repo/internal/react/no-unsafe-overrides
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }, label), /*#__PURE__*/ (0, $byn9U.jsx)("div", null, children));
};
const $b08a364db6613ab1$export$e5a7fbb542efcb7d = ({ theme: { colors: colors, spacing: spacing } }, unstyled)=>({
        label: 'group',
        cursor: 'default',
        display: 'block',
        ...unstyled ? {} : {
            color: colors.neutral40,
            fontSize: '75%',
            fontWeight: 500,
            marginBottom: '0.25em',
            paddingLeft: spacing.baseUnit * 3,
            paddingRight: spacing.baseUnit * 3,
            textTransform: 'uppercase'
        }
    });
const $b08a364db6613ab1$export$85c8b41a3cd87edc = (props)=>{
    const { data: data, ...innerProps } = (0, $lOf1W.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)(props, 'groupHeading', {
            'group-heading': true
        }),
        ...innerProps
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b08a364db6613ab1$export$2e2bcd8739ae039 = $b08a364db6613ab1$var$Group;

});

parcelRegister("32G5A", function(module, exports) {

$parcel$export(module.exports, "CrossIcon", () => $b64974d533316391$export$3b621d86b1566b2);
$parcel$export(module.exports, "DownChevron", () => $b64974d533316391$export$c5cbe1656ba71e6c);
$parcel$export(module.exports, "dropdownIndicatorCSS", () => $b64974d533316391$export$e1687335805e1230);
$parcel$export(module.exports, "DropdownIndicator", () => $b64974d533316391$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "clearIndicatorCSS", () => $b64974d533316391$export$9c0419fd944c1def);
$parcel$export(module.exports, "ClearIndicator", () => $b64974d533316391$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "indicatorSeparatorCSS", () => $b64974d533316391$export$ec39646155d07fdd);
$parcel$export(module.exports, "IndicatorSeparator", () => $b64974d533316391$export$bd638c2ba7915668);
$parcel$export(module.exports, "loadingIndicatorCSS", () => $b64974d533316391$export$1d3f24cde248e6b5);
$parcel$export(module.exports, "LoadingIndicator", () => $b64974d533316391$export$7c20be4c1d342248);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $lOf1W = parcelRequire("lOf1W");
function $b64974d533316391$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
const $b64974d533316391$var$styles = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
const $b64974d533316391$var$Svg = ({ size: size, ...props })=>/*#__PURE__*/ (0, $byn9U.jsx)("svg", {
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $b64974d533316391$var$styles,
        ...props
    });
const $b64974d533316391$export$3b621d86b1566b2 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($b64974d533316391$var$Svg, {
        size: 20,
        ...props
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
const $b64974d533316391$export$c5cbe1656ba71e6c = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)($b64974d533316391$var$Svg, {
        size: 20,
        ...props
    }, /*#__PURE__*/ (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
const $b64974d533316391$var$baseCSS = ({ isFocused: isFocused, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms',
        ...unstyled ? {} : {
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2,
            ':hover': {
                color: isFocused ? colors.neutral80 : colors.neutral40
            }
        }
    });
const $b64974d533316391$export$e1687335805e1230 = $b64974d533316391$var$baseCSS;
const $b64974d533316391$export$ec98719d3db7f2e4 = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)(props, 'dropdownIndicator', {
            indicator: true,
            'dropdown-indicator': true
        }),
        ...innerProps
    }, children || /*#__PURE__*/ (0, $byn9U.jsx)($b64974d533316391$export$c5cbe1656ba71e6c, null));
};
const $b64974d533316391$export$9c0419fd944c1def = $b64974d533316391$var$baseCSS;
const $b64974d533316391$export$ecf9cf59142dd54a = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)(props, 'clearIndicator', {
            indicator: true,
            'clear-indicator': true
        }),
        ...innerProps
    }, children || /*#__PURE__*/ (0, $byn9U.jsx)($b64974d533316391$export$3b621d86b1566b2, null));
};
const $b64974d533316391$export$ec39646155d07fdd = ({ isDisabled: isDisabled, theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1,
        ...unstyled ? {} : {
            backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
            marginBottom: baseUnit * 2,
            marginTop: baseUnit * 2
        }
    });
const $b64974d533316391$export$bd638c2ba7915668 = (props)=>{
    const { innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        ...innerProps,
        ...(0, $lOf1W.getStyleProps)(props, 'indicatorSeparator', {
            'indicator-separator': true
        })
    });
};
// ==============================
// Loading
// ==============================
const $b64974d533316391$var$loadingDotAnimations = (0, $byn9U.keyframes)({
    '0%, 80%, 100%': {
        opacity: 0
    },
    '40%': {
        opacity: 1
    }
});
const $b64974d533316391$export$1d3f24cde248e6b5 = ({ isFocused: isFocused, size: size, theme: { colors: colors, spacing: { baseUnit: baseUnit } } }, unstyled)=>({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle',
        ...unstyled ? {} : {
            color: isFocused ? colors.neutral60 : colors.neutral20,
            padding: baseUnit * 2
        }
    });
const $b64974d533316391$var$LoadingDot = ({ delay: delay, offset: offset })=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: (0, $byn9U.css)({
            animation: `${$b64974d533316391$var$loadingDotAnimations} 1s ease-in-out ${delay}ms infinite;`,
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        })
    });
const $b64974d533316391$export$7c20be4c1d342248 = ({ innerProps: innerProps, isRtl: isRtl, size: size = 4, ...restProps })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)({
            ...restProps,
            innerProps: innerProps,
            isRtl: isRtl,
            size: size
        }, 'loadingIndicator', {
            indicator: true,
            'loading-indicator': true
        }),
        ...innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)($b64974d533316391$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), /*#__PURE__*/ (0, $byn9U.jsx)($b64974d533316391$var$LoadingDot, {
        delay: 160,
        offset: true
    }), /*#__PURE__*/ (0, $byn9U.jsx)($b64974d533316391$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};

});

parcelRegister("4iUjk", function(module, exports) {

$parcel$export(module.exports, "inputCSS", () => $915d3d9d01b678cc$export$14a7781d0ca7abea);
$parcel$export(module.exports, "default", () => $915d3d9d01b678cc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $lOf1W = parcelRequire("lOf1W");
const $915d3d9d01b678cc$export$14a7781d0ca7abea = ({ isDisabled: isDisabled, value: value, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : '',
        ...$915d3d9d01b678cc$var$containerStyle,
        ...unstyled ? {} : {
            margin: spacing.baseUnit / 2,
            paddingBottom: spacing.baseUnit / 2,
            paddingTop: spacing.baseUnit / 2,
            color: colors.neutral80
        }
    });
const $915d3d9d01b678cc$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
const $915d3d9d01b678cc$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': {
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre',
        ...$915d3d9d01b678cc$var$spacingStyle
    }
};
const $915d3d9d01b678cc$var$inputStyle = (isHidden)=>({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%',
        ...$915d3d9d01b678cc$var$spacingStyle
    });
const $915d3d9d01b678cc$var$Input = (props)=>{
    const { cx: cx, value: value } = props;
    const { innerRef: innerRef, isDisabled: isDisabled, isHidden: isHidden, inputClassName: inputClassName, ...innerProps } = (0, $lOf1W.cleanCommonProps)(props);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)(props, 'input', {
            'input-container': true
        }),
        "data-value": value || ''
    }, /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $915d3d9d01b678cc$var$inputStyle(isHidden),
        disabled: isDisabled,
        ...innerProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$915d3d9d01b678cc$export$2e2bcd8739ae039 = $915d3d9d01b678cc$var$Input;

});

parcelRegister("2D1Id", function(module, exports) {

$parcel$export(module.exports, "menuCSS", () => $5c9aba91b3b2ce56$export$a228922d5ca42a79);
$parcel$export(module.exports, "MenuPlacer", () => $5c9aba91b3b2ce56$export$f32337f3a7617699);
$parcel$export(module.exports, "default", () => $5c9aba91b3b2ce56$export$2e2bcd8739ae039);
$parcel$export(module.exports, "menuListCSS", () => $5c9aba91b3b2ce56$export$abafed69cff95d5e);
$parcel$export(module.exports, "MenuList", () => $5c9aba91b3b2ce56$export$d4c4e98c5044dc8);
$parcel$export(module.exports, "noOptionsMessageCSS", () => $5c9aba91b3b2ce56$export$cf0e22534d8b0074);
$parcel$export(module.exports, "loadingMessageCSS", () => $5c9aba91b3b2ce56$export$98ec46397a8cb3cd);
$parcel$export(module.exports, "NoOptionsMessage", () => $5c9aba91b3b2ce56$export$d58b72b7d3c4072c);
$parcel$export(module.exports, "LoadingMessage", () => $5c9aba91b3b2ce56$export$e928a71d039d3102);
$parcel$export(module.exports, "menuPortalCSS", () => $5c9aba91b3b2ce56$export$1dbbeb9648d1fdc9);
$parcel$export(module.exports, "MenuPortal", () => $5c9aba91b3b2ce56$export$793392f970497feb);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5O3G9 = parcelRequire("5O3G9");

var $lEfVV = parcelRequire("lEfVV");

var $k286k = parcelRequire("k286k");

var $lOf1W = parcelRequire("lOf1W");
function $5c9aba91b3b2ce56$export$bd649b913ec78e4a({ maxHeight: preferredMaxHeight, menuEl: menuEl, minHeight: minHeight, placement: preferredPlacement, shouldScroll: shouldScroll, isFixedPosition: isFixedPosition, controlHeight: controlHeight }) {
    const scrollParent = (0, $lOf1W.getScrollParent)(menuEl);
    const defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    const { height: scrollHeight } = scrollParent.getBoundingClientRect();
    const { bottom: menuBottom, height: menuHeight, top: menuTop } = menuEl.getBoundingClientRect();
    const { top: containerTop } = menuEl.offsetParent.getBoundingClientRect();
    const viewHeight = isFixedPosition ? window.innerHeight : (0, $lOf1W.normalizedHeight)(scrollParent);
    const scrollTop = (0, $lOf1W.getScrollTop)(scrollParent);
    const marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    const marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    const viewSpaceAbove = containerTop - marginTop;
    const viewSpaceBelow = viewHeight - menuTop;
    const scrollSpaceAbove = viewSpaceAbove + scrollTop;
    const scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    const scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    const scrollUp = scrollTop + menuTop - marginTop;
    const scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $lOf1W.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) (0, $lOf1W.animatedScrollTo)(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                const constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                let constrainedHeight = preferredMaxHeight;
                const spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) (0, $lOf1W.scrollTo)(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) (0, $lOf1W.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                let constrainedHeight = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) constrainedHeight = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) (0, $lOf1W.animatedScrollTo)(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: constrainedHeight
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error(`Invalid placement provided "${preferredPlacement}".`);
    }
    return defaultState;
}
function $5c9aba91b3b2ce56$var$alignToControl(placement) {
    const placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
const $5c9aba91b3b2ce56$var$coercePlacement = (p)=>p === 'auto' ? 'bottom' : p;
const $5c9aba91b3b2ce56$export$a228922d5ca42a79 = ({ placement: placement, theme: { borderRadius: borderRadius, spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'menu',
        [$5c9aba91b3b2ce56$var$alignToControl(placement)]: '100%',
        position: 'absolute',
        width: '100%',
        zIndex: 1,
        ...unstyled ? {} : {
            backgroundColor: colors.neutral0,
            borderRadius: borderRadius,
            boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
            marginBottom: spacing.menuGutter,
            marginTop: spacing.menuGutter
        }
    });
const $5c9aba91b3b2ce56$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $5c9aba91b3b2ce56$export$f32337f3a7617699 = (props)=>{
    const { children: children, minMenuHeight: minMenuHeight, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, theme: theme } = props;
    const { setPortalPlacement: setPortalPlacement } = (0, $eUqFw.useContext)($5c9aba91b3b2ce56$var$PortalPlacementContext) || {};
    const ref = (0, $eUqFw.useRef)(null);
    const [maxHeight, setMaxHeight] = (0, $eUqFw.useState)(maxMenuHeight);
    const [placement, setPlacement] = (0, $eUqFw.useState)(null);
    const { controlHeight: controlHeight } = theme.spacing;
    (0, $k286k.default)(()=>{
        const menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        const isFixedPosition = menuPosition === 'fixed';
        const shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        const state = $5c9aba91b3b2ce56$export$bd649b913ec78e4a({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement?.(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: {
            ...props,
            placement: placement || $5c9aba91b3b2ce56$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        }
    });
};
const $5c9aba91b3b2ce56$var$Menu = (props)=>{
    const { children: children, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)(props, 'menu', {
            menu: true
        }),
        ref: innerRef,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$5c9aba91b3b2ce56$export$2e2bcd8739ae039 = $5c9aba91b3b2ce56$var$Menu;
const $5c9aba91b3b2ce56$export$abafed69cff95d5e = ({ maxHeight: maxHeight, theme: { spacing: { baseUnit: baseUnit } } }, unstyled)=>({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch',
        ...unstyled ? {} : {
            paddingBottom: baseUnit,
            paddingTop: baseUnit
        }
    });
const $5c9aba91b3b2ce56$export$d4c4e98c5044dc8 = (props)=>{
    const { children: children, innerProps: innerProps, innerRef: innerRef, isMulti: isMulti } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)(props, 'menuList', {
            'menu-list': true,
            'menu-list--is-multi': isMulti
        }),
        //@ts-ignore
        ref: innerRef,
        ...innerProps
    }, children);
};
// ==============================
// Menu Notices
// ==============================
const $5c9aba91b3b2ce56$var$noticeCSS = ({ theme: { spacing: { baseUnit: baseUnit }, colors: colors } }, unstyled)=>({
        textAlign: 'center',
        ...unstyled ? {} : {
            color: colors.neutral40,
            padding: `${baseUnit * 2}px ${baseUnit * 3}px`
        }
    });
const $5c9aba91b3b2ce56$export$cf0e22534d8b0074 = $5c9aba91b3b2ce56$var$noticeCSS;
const $5c9aba91b3b2ce56$export$98ec46397a8cb3cd = $5c9aba91b3b2ce56$var$noticeCSS;
const $5c9aba91b3b2ce56$export$d58b72b7d3c4072c = ({ children: children = 'No options', innerProps: innerProps, ...restProps })=>{
    return(//@ts-ignore
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'noOptionsMessage', {
            'menu-notice': true,
            'menu-notice--no-options': true
        }),
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option",
        ...innerProps
    }, children));
};
const $5c9aba91b3b2ce56$export$e928a71d039d3102 = ({ children: children = 'Loading...', innerProps: innerProps, ...restProps })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)({
            ...restProps,
            children: children,
            innerProps: innerProps
        }, 'loadingMessage', {
            'menu-notice': true,
            'menu-notice--loading': true
        }),
        ...innerProps,
        // eslint-disable-next-line jsx-a11y/role-has-required-aria-props
        role: "option"
    }, children);
};
const $5c9aba91b3b2ce56$export$1dbbeb9648d1fdc9 = ({ rect: rect, offset: offset, position: position })=>({
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    });
const $5c9aba91b3b2ce56$export$793392f970497feb = (props)=>{
    const { appendTo: appendTo, children: children, controlElement: controlElement, innerProps: innerProps, menuPlacement: menuPlacement, menuPosition: menuPosition } = props;
    const menuPortalRef = (0, $eUqFw.useRef)(null);
    const cleanupRef = (0, $eUqFw.useRef)(null);
    const [placement, setPortalPlacement] = (0, $eUqFw.useState)($5c9aba91b3b2ce56$var$coercePlacement(menuPlacement));
    const portalPlacementContext = (0, $eUqFw.useMemo)(()=>({
            setPortalPlacement: setPortalPlacement
        }), []);
    const [computedPosition, setComputedPosition] = (0, $eUqFw.useState)(null);
    const updateComputedPosition = (0, $eUqFw.useCallback)(()=>{
        if (!controlElement) return;
        const rect = (0, $lOf1W.getBoundingClientObj)(controlElement);
        const scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        const offset = rect[placement] + scrollDistance;
        if (offset !== computedPosition?.offset || rect.left !== computedPosition?.rect.left || rect.width !== computedPosition?.rect.width) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition?.offset,
        computedPosition?.rect.left,
        computedPosition?.rect.width
    ]);
    (0, $k286k.default)(()=>{
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    const runAutoUpdate = (0, $eUqFw.useCallback)(()=>{
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(()=>{
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    const setMenuPortalElement = (0, $eUqFw.useCallback)((menuPortalElement)=>{
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    const menuWrapper = /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ref: setMenuPortalElement,
        ...(0, $lOf1W.getStyleProps)({
            ...props,
            offset: computedPosition.offset,
            position: menuPosition,
            rect: computedPosition.rect
        }, 'menuPortal', {
            'menu-portal': true
        }),
        ...innerProps
    }, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)($5c9aba91b3b2ce56$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};

});
parcelRegister("5O3G9", function(module, exports) {

$parcel$export(module.exports, "autoUpdate", () => $023d07731ce8610f$export$deee3a793edee05f);

var $7MIdi = parcelRequire("7MIdi");
function $023d07731ce8610f$var$n(t) {
    var e;
    return (null == (e = t.ownerDocument) ? void 0 : e.defaultView) || window;
}
function $023d07731ce8610f$var$o(t) {
    return $023d07731ce8610f$var$n(t).getComputedStyle(t);
}
function $023d07731ce8610f$var$i(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Node;
}
function $023d07731ce8610f$var$r(t) {
    return $023d07731ce8610f$var$i(t) ? (t.nodeName || "").toLowerCase() : "";
}
let $023d07731ce8610f$var$l;
function $023d07731ce8610f$var$c() {
    if ($023d07731ce8610f$var$l) return $023d07731ce8610f$var$l;
    const t = navigator.userAgentData;
    return t && Array.isArray(t.brands) ? ($023d07731ce8610f$var$l = t.brands.map((t)=>t.brand + "/" + t.version).join(" "), $023d07731ce8610f$var$l) : navigator.userAgent;
}
function $023d07731ce8610f$var$s(t) {
    return t instanceof $023d07731ce8610f$var$n(t).HTMLElement;
}
function $023d07731ce8610f$var$f(t) {
    return t instanceof $023d07731ce8610f$var$n(t).Element;
}
function $023d07731ce8610f$var$u(t) {
    if ("undefined" == typeof ShadowRoot) return !1;
    return t instanceof $023d07731ce8610f$var$n(t).ShadowRoot || t instanceof ShadowRoot;
}
function $023d07731ce8610f$var$a(t) {
    const { overflow: e, overflowX: n, overflowY: i, display: r } = $023d07731ce8610f$var$o(t);
    return /auto|scroll|overlay|hidden|clip/.test(e + i + n) && ![
        "inline",
        "contents"
    ].includes(r);
}
function $023d07731ce8610f$var$d(t) {
    return [
        "table",
        "td",
        "th"
    ].includes($023d07731ce8610f$var$r(t));
}
function $023d07731ce8610f$var$h(t) {
    const e = /firefox/i.test($023d07731ce8610f$var$c()), n = $023d07731ce8610f$var$o(t), i = n.backdropFilter || n.WebkitBackdropFilter;
    return "none" !== n.transform || "none" !== n.perspective || !!i && "none" !== i || e && "filter" === n.willChange || e && !!n.filter && "none" !== n.filter || [
        "transform",
        "perspective"
    ].some((t)=>n.willChange.includes(t)) || [
        "paint",
        "layout",
        "strict",
        "content"
    ].some((t)=>{
        const e = n.contain;
        return null != e && e.includes(t);
    });
}
function $023d07731ce8610f$var$p() {
    return /^((?!chrome|android).)*safari/i.test($023d07731ce8610f$var$c());
}
function $023d07731ce8610f$var$g(t) {
    return [
        "html",
        "body",
        "#document"
    ].includes($023d07731ce8610f$var$r(t));
}
const $023d07731ce8610f$var$m = Math.min, $023d07731ce8610f$var$y = Math.max, $023d07731ce8610f$var$x = Math.round;
function $023d07731ce8610f$var$w(t) {
    const e = $023d07731ce8610f$var$o(t);
    let n = parseFloat(e.width), i = parseFloat(e.height);
    const r = $023d07731ce8610f$var$s(t), l = r ? t.offsetWidth : n, c = r ? t.offsetHeight : i, f = $023d07731ce8610f$var$x(n) !== l || $023d07731ce8610f$var$x(i) !== c;
    return f && (n = l, i = c), {
        width: n,
        height: i,
        fallback: f
    };
}
function $023d07731ce8610f$var$v(t) {
    return $023d07731ce8610f$var$f(t) ? t : t.contextElement;
}
const $023d07731ce8610f$var$b = {
    x: 1,
    y: 1
};
function $023d07731ce8610f$var$L(t) {
    const e = $023d07731ce8610f$var$v(t);
    if (!$023d07731ce8610f$var$s(e)) return $023d07731ce8610f$var$b;
    const n = e.getBoundingClientRect(), { width: o, height: i, fallback: r } = $023d07731ce8610f$var$w(e);
    let l = (r ? $023d07731ce8610f$var$x(n.width) : n.width) / o, c = (r ? $023d07731ce8610f$var$x(n.height) : n.height) / i;
    return l && Number.isFinite(l) || (l = 1), c && Number.isFinite(c) || (c = 1), {
        x: l,
        y: c
    };
}
function $023d07731ce8610f$var$E(e, o, i, r) {
    var l, c;
    void 0 === o && (o = !1), void 0 === i && (i = !1);
    const s = e.getBoundingClientRect(), u = $023d07731ce8610f$var$v(e);
    let a = $023d07731ce8610f$var$b;
    o && (r ? $023d07731ce8610f$var$f(r) && (a = $023d07731ce8610f$var$L(r)) : a = $023d07731ce8610f$var$L(e));
    const d = u ? $023d07731ce8610f$var$n(u) : window, h = $023d07731ce8610f$var$p() && i;
    let g = (s.left + (h && (null == (l = d.visualViewport) ? void 0 : l.offsetLeft) || 0)) / a.x, m = (s.top + (h && (null == (c = d.visualViewport) ? void 0 : c.offsetTop) || 0)) / a.y, y = s.width / a.x, x = s.height / a.y;
    if (u) {
        const t = $023d07731ce8610f$var$n(u), e = r && $023d07731ce8610f$var$f(r) ? $023d07731ce8610f$var$n(r) : r;
        let o = t.frameElement;
        for(; o && r && e !== t;){
            const t = $023d07731ce8610f$var$L(o), e = o.getBoundingClientRect(), i = getComputedStyle(o);
            e.x += (o.clientLeft + parseFloat(i.paddingLeft)) * t.x, e.y += (o.clientTop + parseFloat(i.paddingTop)) * t.y, g *= t.x, m *= t.y, y *= t.x, x *= t.y, g += e.x, m += e.y, o = $023d07731ce8610f$var$n(o).frameElement;
        }
    }
    return (0, $7MIdi.rectToClientRect)({
        width: y,
        height: x,
        x: g,
        y: m
    });
}
function $023d07731ce8610f$var$T(t) {
    return (($023d07731ce8610f$var$i(t) ? t.ownerDocument : t.document) || window.document).documentElement;
}
function $023d07731ce8610f$var$R(t) {
    return $023d07731ce8610f$var$f(t) ? {
        scrollLeft: t.scrollLeft,
        scrollTop: t.scrollTop
    } : {
        scrollLeft: t.pageXOffset,
        scrollTop: t.pageYOffset
    };
}
function $023d07731ce8610f$var$C(t) {
    return $023d07731ce8610f$var$E($023d07731ce8610f$var$T(t)).left + $023d07731ce8610f$var$R(t).scrollLeft;
}
function $023d07731ce8610f$var$F(t) {
    if ("html" === $023d07731ce8610f$var$r(t)) return t;
    const e = t.assignedSlot || t.parentNode || $023d07731ce8610f$var$u(t) && t.host || $023d07731ce8610f$var$T(t);
    return $023d07731ce8610f$var$u(e) ? e.host : e;
}
function $023d07731ce8610f$var$W(t) {
    const e = $023d07731ce8610f$var$F(t);
    return $023d07731ce8610f$var$g(e) ? e.ownerDocument.body : $023d07731ce8610f$var$s(e) && $023d07731ce8610f$var$a(e) ? e : $023d07731ce8610f$var$W(e);
}
function $023d07731ce8610f$export$3b57c1601291186b(t, e) {
    var o;
    void 0 === e && (e = []);
    const i = $023d07731ce8610f$var$W(t), r = i === (null == (o = t.ownerDocument) ? void 0 : o.body), l = $023d07731ce8610f$var$n(i);
    return r ? e.concat(l, l.visualViewport || [], $023d07731ce8610f$var$a(i) ? i : []) : e.concat(i, $023d07731ce8610f$export$3b57c1601291186b(i));
}
function $023d07731ce8610f$var$S(e, i, r) {
    let l;
    if ("viewport" === i) l = function(t, e) {
        const o = $023d07731ce8610f$var$n(t), i = $023d07731ce8610f$var$T(t), r = o.visualViewport;
        let l = i.clientWidth, c = i.clientHeight, s = 0, f = 0;
        if (r) {
            l = r.width, c = r.height;
            const t = $023d07731ce8610f$var$p();
            (!t || t && "fixed" === e) && (s = r.offsetLeft, f = r.offsetTop);
        }
        return {
            width: l,
            height: c,
            x: s,
            y: f
        };
    }(e, r);
    else if ("document" === i) l = function(t) {
        const e = $023d07731ce8610f$var$T(t), n = $023d07731ce8610f$var$R(t), i = t.ownerDocument.body, r = $023d07731ce8610f$var$y(e.scrollWidth, e.clientWidth, i.scrollWidth, i.clientWidth), l = $023d07731ce8610f$var$y(e.scrollHeight, e.clientHeight, i.scrollHeight, i.clientHeight);
        let c = -n.scrollLeft + $023d07731ce8610f$var$C(t);
        const s = -n.scrollTop;
        return "rtl" === $023d07731ce8610f$var$o(i).direction && (c += $023d07731ce8610f$var$y(e.clientWidth, i.clientWidth) - r), {
            width: r,
            height: l,
            x: c,
            y: s
        };
    }($023d07731ce8610f$var$T(e));
    else if ($023d07731ce8610f$var$f(i)) l = function(t, e) {
        const n = $023d07731ce8610f$var$E(t, !0, "fixed" === e), o = n.top + t.clientTop, i = n.left + t.clientLeft, r = $023d07731ce8610f$var$s(t) ? $023d07731ce8610f$var$L(t) : {
            x: 1,
            y: 1
        };
        return {
            width: t.clientWidth * r.x,
            height: t.clientHeight * r.y,
            x: i * r.x,
            y: o * r.y
        };
    }(i, r);
    else {
        const t = {
            ...i
        };
        if ($023d07731ce8610f$var$p()) {
            var c, u;
            const o = $023d07731ce8610f$var$n(e);
            t.x -= (null == (c = o.visualViewport) ? void 0 : c.offsetLeft) || 0, t.y -= (null == (u = o.visualViewport) ? void 0 : u.offsetTop) || 0;
        }
        l = t;
    }
    return (0, $7MIdi.rectToClientRect)(l);
}
function $023d07731ce8610f$var$A(t, e) {
    return $023d07731ce8610f$var$s(t) && "fixed" !== $023d07731ce8610f$var$o(t).position ? e ? e(t) : t.offsetParent : null;
}
function $023d07731ce8610f$var$H(t, e) {
    const i = $023d07731ce8610f$var$n(t);
    if (!$023d07731ce8610f$var$s(t)) return i;
    let l = $023d07731ce8610f$var$A(t, e);
    for(; l && $023d07731ce8610f$var$d(l) && "static" === $023d07731ce8610f$var$o(l).position;)l = $023d07731ce8610f$var$A(l, e);
    return l && ("html" === $023d07731ce8610f$var$r(l) || "body" === $023d07731ce8610f$var$r(l) && "static" === $023d07731ce8610f$var$o(l).position && !$023d07731ce8610f$var$h(l)) ? i : l || function(t) {
        let e = $023d07731ce8610f$var$F(t);
        for(; $023d07731ce8610f$var$s(e) && !$023d07731ce8610f$var$g(e);){
            if ($023d07731ce8610f$var$h(e)) return e;
            e = $023d07731ce8610f$var$F(e);
        }
        return null;
    }(t) || i;
}
function $023d07731ce8610f$var$V(t, e, n) {
    const o = $023d07731ce8610f$var$s(e), i = $023d07731ce8610f$var$T(e), l = $023d07731ce8610f$var$E(t, !0, "fixed" === n, e);
    let c = {
        scrollLeft: 0,
        scrollTop: 0
    };
    const f = {
        x: 0,
        y: 0
    };
    if (o || !o && "fixed" !== n) {
        if (("body" !== $023d07731ce8610f$var$r(e) || $023d07731ce8610f$var$a(i)) && (c = $023d07731ce8610f$var$R(e)), $023d07731ce8610f$var$s(e)) {
            const t = $023d07731ce8610f$var$E(e, !0);
            f.x = t.x + e.clientLeft, f.y = t.y + e.clientTop;
        } else i && (f.x = $023d07731ce8610f$var$C(i));
    }
    return {
        x: l.left + c.scrollLeft - f.x,
        y: l.top + c.scrollTop - f.y,
        width: l.width,
        height: l.height
    };
}
const $023d07731ce8610f$export$722a64dea1b767dc = {
    getClippingRect: function(t) {
        let { element: e, boundary: n, rootBoundary: i, strategy: l } = t;
        const c = "clippingAncestors" === n ? function(t, e) {
            const n = e.get(t);
            if (n) return n;
            let i = $023d07731ce8610f$export$3b57c1601291186b(t).filter((t)=>$023d07731ce8610f$var$f(t) && "body" !== $023d07731ce8610f$var$r(t)), l = null;
            const c = "fixed" === $023d07731ce8610f$var$o(t).position;
            let s = c ? $023d07731ce8610f$var$F(t) : t;
            for(; $023d07731ce8610f$var$f(s) && !$023d07731ce8610f$var$g(s);){
                const t = $023d07731ce8610f$var$o(s), e = $023d07731ce8610f$var$h(s);
                "fixed" === t.position ? l = null : (c ? e || l : e || "static" !== t.position || !l || ![
                    "absolute",
                    "fixed"
                ].includes(l.position)) ? l = t : i = i.filter((t)=>t !== s), s = $023d07731ce8610f$var$F(s);
            }
            return e.set(t, i), i;
        }(e, this._c) : [].concat(n), s = [
            ...c,
            i
        ], u = s[0], a = s.reduce((t, n)=>{
            const o = $023d07731ce8610f$var$S(e, n, l);
            return t.top = $023d07731ce8610f$var$y(o.top, t.top), t.right = $023d07731ce8610f$var$m(o.right, t.right), t.bottom = $023d07731ce8610f$var$m(o.bottom, t.bottom), t.left = $023d07731ce8610f$var$y(o.left, t.left), t;
        }, $023d07731ce8610f$var$S(e, u, l));
        return {
            width: a.right - a.left,
            height: a.bottom - a.top,
            x: a.left,
            y: a.top
        };
    },
    convertOffsetParentRelativeRectToViewportRelativeRect: function(t) {
        let { rect: e, offsetParent: n, strategy: o } = t;
        const i = $023d07731ce8610f$var$s(n), l = $023d07731ce8610f$var$T(n);
        if (n === l) return e;
        let c = {
            scrollLeft: 0,
            scrollTop: 0
        }, f = {
            x: 1,
            y: 1
        };
        const u = {
            x: 0,
            y: 0
        };
        if ((i || !i && "fixed" !== o) && (("body" !== $023d07731ce8610f$var$r(n) || $023d07731ce8610f$var$a(l)) && (c = $023d07731ce8610f$var$R(n)), $023d07731ce8610f$var$s(n))) {
            const t = $023d07731ce8610f$var$E(n);
            f = $023d07731ce8610f$var$L(n), u.x = t.x + n.clientLeft, u.y = t.y + n.clientTop;
        }
        return {
            width: e.width * f.x,
            height: e.height * f.y,
            x: e.x * f.x - c.scrollLeft * f.x + u.x,
            y: e.y * f.y - c.scrollTop * f.y + u.y
        };
    },
    isElement: $023d07731ce8610f$var$f,
    getDimensions: function(t) {
        return $023d07731ce8610f$var$w(t);
    },
    getOffsetParent: $023d07731ce8610f$var$H,
    getDocumentElement: $023d07731ce8610f$var$T,
    getScale: $023d07731ce8610f$var$L,
    async getElementRects (t) {
        let { reference: e, floating: n, strategy: o } = t;
        const i = this.getOffsetParent || $023d07731ce8610f$var$H, r = this.getDimensions;
        return {
            reference: $023d07731ce8610f$var$V(e, await i(n), o),
            floating: {
                x: 0,
                y: 0,
                ...await r(n)
            }
        };
    },
    getClientRects: (t)=>Array.from(t.getClientRects()),
    isRTL: (t)=>"rtl" === $023d07731ce8610f$var$o(t).direction
};
function $023d07731ce8610f$export$deee3a793edee05f(t, e, n, o) {
    void 0 === o && (o = {});
    const { ancestorScroll: i = !0, ancestorResize: r = !0, elementResize: l = !0, animationFrame: c = !1 } = o, s = i && !c, u = s || r ? [
        ...$023d07731ce8610f$var$f(t) ? $023d07731ce8610f$export$3b57c1601291186b(t) : t.contextElement ? $023d07731ce8610f$export$3b57c1601291186b(t.contextElement) : [],
        ...$023d07731ce8610f$export$3b57c1601291186b(e)
    ] : [];
    u.forEach((t)=>{
        s && t.addEventListener("scroll", n, {
            passive: !0
        }), r && t.addEventListener("resize", n);
    });
    let a, d = null;
    l && (d = new ResizeObserver(()=>{
        n();
    }), $023d07731ce8610f$var$f(t) && !c && d.observe(t), $023d07731ce8610f$var$f(t) || !t.contextElement || c || d.observe(t.contextElement), d.observe(e));
    let h = c ? $023d07731ce8610f$var$E(t) : null;
    return c && function e() {
        const o = $023d07731ce8610f$var$E(t);
        !h || o.x === h.x && o.y === h.y && o.width === h.width && o.height === h.height || n();
        h = o, a = requestAnimationFrame(e);
    }(), n(), ()=>{
        var t;
        u.forEach((t)=>{
            s && t.removeEventListener("scroll", n), r && t.removeEventListener("resize", n);
        }), null == (t = d) || t.disconnect(), d = null, c && cancelAnimationFrame(a);
    };
}
const $023d07731ce8610f$export$48a53dcb22e581d0 = (t, n, o)=>{
    const i = new Map, r = {
        platform: $023d07731ce8610f$export$722a64dea1b767dc,
        ...o
    }, l = {
        ...r.platform,
        _c: i
    };
    return (0, $7MIdi.computePosition)(t, n, {
        ...r,
        platform: l
    });
};

});
parcelRegister("7MIdi", function(module, exports) {

$parcel$export(module.exports, "computePosition", () => $4dacbd6c81f90f16$export$48a53dcb22e581d0);
$parcel$export(module.exports, "rectToClientRect", () => $4dacbd6c81f90f16$export$ee05aea0aeecbad4);
function $4dacbd6c81f90f16$var$t(t) {
    return t.split("-")[1];
}
function $4dacbd6c81f90f16$var$e(t) {
    return "y" === t ? "height" : "width";
}
function $4dacbd6c81f90f16$var$n(t) {
    return t.split("-")[0];
}
function $4dacbd6c81f90f16$var$o(t) {
    return [
        "top",
        "bottom"
    ].includes($4dacbd6c81f90f16$var$n(t)) ? "x" : "y";
}
function $4dacbd6c81f90f16$var$i(i, r, a) {
    let { reference: l, floating: s } = i;
    const c = l.x + l.width / 2 - s.width / 2, f = l.y + l.height / 2 - s.height / 2, m = $4dacbd6c81f90f16$var$o(r), u = $4dacbd6c81f90f16$var$e(m), g = l[u] / 2 - s[u] / 2, d = "x" === m;
    let p;
    switch($4dacbd6c81f90f16$var$n(r)){
        case "top":
            p = {
                x: c,
                y: l.y - s.height
            };
            break;
        case "bottom":
            p = {
                x: c,
                y: l.y + l.height
            };
            break;
        case "right":
            p = {
                x: l.x + l.width,
                y: f
            };
            break;
        case "left":
            p = {
                x: l.x - s.width,
                y: f
            };
            break;
        default:
            p = {
                x: l.x,
                y: l.y
            };
    }
    switch($4dacbd6c81f90f16$var$t(r)){
        case "start":
            p[m] -= g * (a && d ? -1 : 1);
            break;
        case "end":
            p[m] += g * (a && d ? -1 : 1);
    }
    return p;
}
const $4dacbd6c81f90f16$export$48a53dcb22e581d0 = async (t, e, n)=>{
    const { placement: o = "bottom", strategy: r = "absolute", middleware: a = [], platform: l } = n, s = a.filter(Boolean), c = await (null == l.isRTL ? void 0 : l.isRTL(e));
    let f = await l.getElementRects({
        reference: t,
        floating: e,
        strategy: r
    }), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, o, c), g = o, d = {}, p = 0;
    for(let n = 0; n < s.length; n++){
        const { name: a, fn: h } = s[n], { x: y, y: x, data: w, reset: v } = await h({
            x: m,
            y: u,
            initialPlacement: o,
            placement: g,
            strategy: r,
            middlewareData: d,
            rects: f,
            platform: l,
            elements: {
                reference: t,
                floating: e
            }
        });
        m = null != y ? y : m, u = null != x ? x : u, d = {
            ...d,
            [a]: {
                ...d[a],
                ...w
            }
        }, v && p <= 50 && (p++, "object" == typeof v && (v.placement && (g = v.placement), v.rects && (f = !0 === v.rects ? await l.getElementRects({
            reference: t,
            floating: e,
            strategy: r
        }) : v.rects), { x: m, y: u } = $4dacbd6c81f90f16$var$i(f, g, c)), n = -1);
    }
    return {
        x: m,
        y: u,
        placement: g,
        strategy: r,
        middlewareData: d
    };
};
function $4dacbd6c81f90f16$var$a(t) {
    return "number" != typeof t ? function(t) {
        return {
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            ...t
        };
    }(t) : {
        top: t,
        right: t,
        bottom: t,
        left: t
    };
}
function $4dacbd6c81f90f16$export$ee05aea0aeecbad4(t) {
    return {
        ...t,
        top: t.y,
        left: t.x,
        right: t.x + t.width,
        bottom: t.y + t.height
    };
}
async function $4dacbd6c81f90f16$export$37b6bde19b108ecc(t, e) {
    var n;
    void 0 === e && (e = {});
    const { x: o, y: i, platform: r, rects: s, elements: c, strategy: f } = t, { boundary: m = "clippingAncestors", rootBoundary: u = "viewport", elementContext: g = "floating", altBoundary: d = !1, padding: p = 0 } = e, h = $4dacbd6c81f90f16$var$a(p), y = c[d ? "floating" === g ? "reference" : "floating" : g], x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(await r.getClippingRect({
        element: null == (n = await (null == r.isElement ? void 0 : r.isElement(y))) || n ? y : y.contextElement || await (null == r.getDocumentElement ? void 0 : r.getDocumentElement(c.floating)),
        boundary: m,
        rootBoundary: u,
        strategy: f
    })), w = "floating" === g ? {
        ...s.floating,
        x: o,
        y: i
    } : s.reference, v = await (null == r.getOffsetParent ? void 0 : r.getOffsetParent(c.floating)), b = await (null == r.isElement ? void 0 : r.isElement(v)) && await (null == r.getScale ? void 0 : r.getScale(v)) || {
        x: 1,
        y: 1
    }, A = $4dacbd6c81f90f16$export$ee05aea0aeecbad4(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
        rect: w,
        offsetParent: v,
        strategy: f
    }) : w);
    return {
        top: (x.top - A.top + h.top) / b.y,
        bottom: (A.bottom - x.bottom + h.bottom) / b.y,
        left: (x.left - A.left + h.left) / b.x,
        right: (A.right - x.right + h.right) / b.x
    };
}
const $4dacbd6c81f90f16$var$c = Math.min, $4dacbd6c81f90f16$var$f = Math.max;
function $4dacbd6c81f90f16$var$m(t, e, n) {
    return $4dacbd6c81f90f16$var$f(t, $4dacbd6c81f90f16$var$c(e, n));
}
const $4dacbd6c81f90f16$export$f2120bbfa5450bd2 = (n)=>({
        name: "arrow",
        options: n,
        async fn (i) {
            const { element: r, padding: l = 0 } = n || {}, { x: s, y: c, placement: f, rects: u, platform: g, elements: d } = i;
            if (null == r) return {};
            const p = $4dacbd6c81f90f16$var$a(l), h = {
                x: s,
                y: c
            }, y = $4dacbd6c81f90f16$var$o(f), x = $4dacbd6c81f90f16$var$e(y), w = await g.getDimensions(r), v = "y" === y, b = v ? "top" : "left", A = v ? "bottom" : "right", R = v ? "clientHeight" : "clientWidth", P = u.reference[x] + u.reference[y] - h[y] - u.floating[x], E = h[y] - u.reference[y], T = await (null == g.getOffsetParent ? void 0 : g.getOffsetParent(r));
            let D = T ? T[R] : 0;
            D && await (null == g.isElement ? void 0 : g.isElement(T)) || (D = d.floating[R] || u.floating[x]);
            const L = P / 2 - E / 2, k = p[b], O = D - w[x] - p[A], B = D / 2 - w[x] / 2 + L, C = $4dacbd6c81f90f16$var$m(k, B, O), H = null != $4dacbd6c81f90f16$var$t(f) && B != C && u.reference[x] / 2 - (B < k ? p[b] : p[A]) - w[x] / 2 < 0;
            return {
                [y]: h[y] - (H ? B < k ? k - B : O - B : 0),
                data: {
                    [y]: C,
                    centerOffset: B - C
                }
            };
        }
    }), $4dacbd6c81f90f16$var$g = [
    "top",
    "right",
    "bottom",
    "left"
], $4dacbd6c81f90f16$var$d = $4dacbd6c81f90f16$var$g.reduce((t, e)=>t.concat(e, e + "-start", e + "-end"), []), $4dacbd6c81f90f16$var$p = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $4dacbd6c81f90f16$var$h(t) {
    return t.replace(/left|right|bottom|top/g, (t)=>$4dacbd6c81f90f16$var$p[t]);
}
function $4dacbd6c81f90f16$var$y(n, i, r) {
    void 0 === r && (r = !1);
    const a = $4dacbd6c81f90f16$var$t(n), l = $4dacbd6c81f90f16$var$o(n), s = $4dacbd6c81f90f16$var$e(l);
    let c = "x" === l ? a === (r ? "end" : "start") ? "right" : "left" : "start" === a ? "bottom" : "top";
    return i.reference[s] > i.floating[s] && (c = $4dacbd6c81f90f16$var$h(c)), {
        main: c,
        cross: $4dacbd6c81f90f16$var$h(c)
    };
}
const $4dacbd6c81f90f16$var$x = {
    start: "end",
    end: "start"
};
function $4dacbd6c81f90f16$var$w(t) {
    return t.replace(/start|end/g, (t)=>$4dacbd6c81f90f16$var$x[t]);
}
const $4dacbd6c81f90f16$export$91fb6ecbd551914 = function(e) {
    return void 0 === e && (e = {}), {
        name: "autoPlacement",
        options: e,
        async fn (o) {
            var i, r, a;
            const { rects: l, middlewareData: c, placement: f, platform: m, elements: u } = o, { crossAxis: g = !1, alignment: p, allowedPlacements: h = $4dacbd6c81f90f16$var$d, autoAlignment: x = !0, ...v } = e, b = void 0 !== p || h === $4dacbd6c81f90f16$var$d ? function(e, o, i) {
                return (e ? [
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) === e),
                    ...i.filter((n)=>$4dacbd6c81f90f16$var$t(n) !== e)
                ] : i.filter((t)=>$4dacbd6c81f90f16$var$n(t) === t)).filter((n)=>!e || $4dacbd6c81f90f16$var$t(n) === e || !!o && $4dacbd6c81f90f16$var$w(n) !== n);
            }(p || null, x, h) : h, A = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, v), R = (null == (i = c.autoPlacement) ? void 0 : i.index) || 0, P = b[R];
            if (null == P) return {};
            const { main: E, cross: T } = $4dacbd6c81f90f16$var$y(P, l, await (null == m.isRTL ? void 0 : m.isRTL(u.floating)));
            if (f !== P) return {
                reset: {
                    placement: b[0]
                }
            };
            const D = [
                A[$4dacbd6c81f90f16$var$n(P)],
                A[E],
                A[T]
            ], L = [
                ...(null == (r = c.autoPlacement) ? void 0 : r.overflows) || [],
                {
                    placement: P,
                    overflows: D
                }
            ], k = b[R + 1];
            if (k) return {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: k
                }
            };
            const O = L.map((e)=>{
                const n = $4dacbd6c81f90f16$var$t(e.placement);
                return [
                    e.placement,
                    n && g ? e.overflows.slice(0, 2).reduce((t, e)=>t + e, 0) : e.overflows[0],
                    e.overflows
                ];
            }).sort((t, e)=>t[1] - e[1]), B = (null == (a = O.filter((e)=>e[2].slice(0, $4dacbd6c81f90f16$var$t(e[0]) ? 2 : 3).every((t)=>t <= 0))[0]) ? void 0 : a[0]) || O[0][0];
            return B !== f ? {
                data: {
                    index: R + 1,
                    overflows: L
                },
                reset: {
                    placement: B
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$8a83211c878a3f1f = function(e) {
    return void 0 === e && (e = {}), {
        name: "flip",
        options: e,
        async fn (o) {
            var i;
            const { placement: r, middlewareData: a, rects: l, initialPlacement: c, platform: f, elements: m } = o, { mainAxis: u = !0, crossAxis: g = !0, fallbackPlacements: d, fallbackStrategy: p = "bestFit", fallbackAxisSideDirection: x = "none", flipAlignment: v = !0, ...b } = e, A = $4dacbd6c81f90f16$var$n(r), R = $4dacbd6c81f90f16$var$n(c) === c, P = await (null == f.isRTL ? void 0 : f.isRTL(m.floating)), E = d || (R || !v ? [
                $4dacbd6c81f90f16$var$h(c)
            ] : function(t) {
                const e = $4dacbd6c81f90f16$var$h(t);
                return [
                    $4dacbd6c81f90f16$var$w(t),
                    e,
                    $4dacbd6c81f90f16$var$w(e)
                ];
            }(c));
            d || "none" === x || E.push(...function(e, o, i, r) {
                const a = $4dacbd6c81f90f16$var$t(e);
                let l = function(t, e, n) {
                    const o = [
                        "left",
                        "right"
                    ], i = [
                        "right",
                        "left"
                    ], r = [
                        "top",
                        "bottom"
                    ], a = [
                        "bottom",
                        "top"
                    ];
                    switch(t){
                        case "top":
                        case "bottom":
                            return n ? e ? i : o : e ? o : i;
                        case "left":
                        case "right":
                            return e ? r : a;
                        default:
                            return [];
                    }
                }($4dacbd6c81f90f16$var$n(e), "start" === i, r);
                return a && (l = l.map((t)=>t + "-" + a), o && (l = l.concat(l.map($4dacbd6c81f90f16$var$w)))), l;
            }(c, v, x, P));
            const T = [
                c,
                ...E
            ], D = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(o, b), L = [];
            let k = (null == (i = a.flip) ? void 0 : i.overflows) || [];
            if (u && L.push(D[A]), g) {
                const { main: t, cross: e } = $4dacbd6c81f90f16$var$y(r, l, P);
                L.push(D[t], D[e]);
            }
            if (k = [
                ...k,
                {
                    placement: r,
                    overflows: L
                }
            ], !L.every((t)=>t <= 0)) {
                var O, B;
                const t = ((null == (O = a.flip) ? void 0 : O.index) || 0) + 1, e = T[t];
                if (e) return {
                    data: {
                        index: t,
                        overflows: k
                    },
                    reset: {
                        placement: e
                    }
                };
                let n = null == (B = k.filter((t)=>t.overflows[0] <= 0).sort((t, e)=>t.overflows[1] - e.overflows[1])[0]) ? void 0 : B.placement;
                if (!n) switch(p){
                    case "bestFit":
                        {
                            var C;
                            const t = null == (C = k.map((t)=>[
                                    t.placement,
                                    t.overflows.filter((t)=>t > 0).reduce((t, e)=>t + e, 0)
                                ]).sort((t, e)=>t[1] - e[1])[0]) ? void 0 : C[0];
                            t && (n = t);
                            break;
                        }
                    case "initialPlacement":
                        n = c;
                }
                if (r !== n) return {
                    reset: {
                        placement: n
                    }
                };
            }
            return {};
        }
    };
};
function $4dacbd6c81f90f16$var$A(t, e) {
    return {
        top: t.top - e.height,
        right: t.right - e.width,
        bottom: t.bottom - e.height,
        left: t.left - e.width
    };
}
function $4dacbd6c81f90f16$var$R(t) {
    return $4dacbd6c81f90f16$var$g.some((e)=>t[e] >= 0);
}
const $4dacbd6c81f90f16$export$fe8985bb6374093c = function(t) {
    return void 0 === t && (t = {}), {
        name: "hide",
        options: t,
        async fn (e) {
            const { strategy: n = "referenceHidden", ...o } = t, { rects: i } = e;
            switch(n){
                case "referenceHidden":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            elementContext: "reference"
                        }), i.reference);
                        return {
                            data: {
                                referenceHiddenOffsets: t,
                                referenceHidden: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                case "escaped":
                    {
                        const t = $4dacbd6c81f90f16$var$A(await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, {
                            ...o,
                            altBoundary: !0
                        }), i.floating);
                        return {
                            data: {
                                escapedOffsets: t,
                                escaped: $4dacbd6c81f90f16$var$R(t)
                            }
                        };
                    }
                default:
                    return {};
            }
        }
    };
};
function $4dacbd6c81f90f16$var$E(t) {
    const e = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.left)), n = $4dacbd6c81f90f16$var$c(...t.map((t)=>t.top));
    return {
        x: e,
        y: n,
        width: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.right)) - e,
        height: $4dacbd6c81f90f16$var$f(...t.map((t)=>t.bottom)) - n
    };
}
const $4dacbd6c81f90f16$export$18c8ad048e32c7d5 = function(t) {
    return void 0 === t && (t = {}), {
        name: "inline",
        options: t,
        async fn (e) {
            const { placement: i, elements: r, rects: s, platform: m, strategy: u } = e, { padding: g = 2, x: d, y: p } = t, h = Array.from(await (null == m.getClientRects ? void 0 : m.getClientRects(r.reference)) || []), y = function(t) {
                const e = t.slice().sort((t, e)=>t.y - e.y), n = [];
                let o = null;
                for(let t = 0; t < e.length; t++){
                    const i = e[t];
                    !o || i.y - o.y > o.height / 2 ? n.push([
                        i
                    ]) : n[n.length - 1].push(i), o = i;
                }
                return n.map((t)=>$4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(t)));
            }(h), x = $4dacbd6c81f90f16$export$ee05aea0aeecbad4($4dacbd6c81f90f16$var$E(h)), w = $4dacbd6c81f90f16$var$a(g);
            const v = await m.getElementRects({
                reference: {
                    getBoundingClientRect: function() {
                        if (2 === y.length && y[0].left > y[1].right && null != d && null != p) return y.find((t)=>d > t.left - w.left && d < t.right + w.right && p > t.top - w.top && p < t.bottom + w.bottom) || x;
                        if (y.length >= 2) {
                            if ("x" === $4dacbd6c81f90f16$var$o(i)) {
                                const t = y[0], e = y[y.length - 1], o = "top" === $4dacbd6c81f90f16$var$n(i), r = t.top, a = e.bottom, l = o ? t.left : e.left, s = o ? t.right : e.right;
                                return {
                                    top: r,
                                    bottom: a,
                                    left: l,
                                    right: s,
                                    width: s - l,
                                    height: a - r,
                                    x: l,
                                    y: r
                                };
                            }
                            const t = "left" === $4dacbd6c81f90f16$var$n(i), e = $4dacbd6c81f90f16$var$f(...y.map((t)=>t.right)), r = $4dacbd6c81f90f16$var$c(...y.map((t)=>t.left)), a = y.filter((n)=>t ? n.left === r : n.right === e), l = a[0].top, s = a[a.length - 1].bottom;
                            return {
                                top: l,
                                bottom: s,
                                left: r,
                                right: e,
                                width: e - r,
                                height: s - l,
                                x: r,
                                y: l
                            };
                        }
                        return x;
                    }
                },
                floating: r.floating,
                strategy: u
            });
            return s.reference.x !== v.reference.x || s.reference.y !== v.reference.y || s.reference.width !== v.reference.width || s.reference.height !== v.reference.height ? {
                reset: {
                    rects: v
                }
            } : {};
        }
    };
};
const $4dacbd6c81f90f16$export$cc800923e997bb8 = function(e) {
    return void 0 === e && (e = 0), {
        name: "offset",
        options: e,
        async fn (i) {
            const { x: r, y: a } = i, l = await async function(e, i) {
                const { placement: r, platform: a, elements: l } = e, s = await (null == a.isRTL ? void 0 : a.isRTL(l.floating)), c = $4dacbd6c81f90f16$var$n(r), f = $4dacbd6c81f90f16$var$t(r), m = "x" === $4dacbd6c81f90f16$var$o(r), u = [
                    "left",
                    "top"
                ].includes(c) ? -1 : 1, g = s && m ? -1 : 1, d = "function" == typeof i ? i(e) : i;
                let { mainAxis: p, crossAxis: h, alignmentAxis: y } = "number" == typeof d ? {
                    mainAxis: d,
                    crossAxis: 0,
                    alignmentAxis: null
                } : {
                    mainAxis: 0,
                    crossAxis: 0,
                    alignmentAxis: null,
                    ...d
                };
                return f && "number" == typeof y && (h = "end" === f ? -1 * y : y), m ? {
                    x: h * g,
                    y: p * u
                } : {
                    x: p * u,
                    y: h * g
                };
            }(i, e);
            return {
                x: r + l.x,
                y: a + l.y,
                data: l
            };
        }
    };
};
function $4dacbd6c81f90f16$var$L(t) {
    return "x" === t ? "y" : "x";
}
const $4dacbd6c81f90f16$export$fba63a578e423eb = function(t) {
    return void 0 === t && (t = {}), {
        name: "shift",
        options: t,
        async fn (e) {
            const { x: i, y: r, placement: a } = e, { mainAxis: l = !0, crossAxis: c = !1, limiter: f = {
                fn: (t)=>{
                    let { x: e, y: n } = t;
                    return {
                        x: e,
                        y: n
                    };
                }
            }, ...u } = t, g = {
                x: i,
                y: r
            }, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(e, u), p = $4dacbd6c81f90f16$var$o($4dacbd6c81f90f16$var$n(a)), h = $4dacbd6c81f90f16$var$L(p);
            let y = g[p], x = g[h];
            if (l) {
                const t = "y" === p ? "bottom" : "right";
                y = $4dacbd6c81f90f16$var$m(y + d["y" === p ? "top" : "left"], y, y - d[t]);
            }
            if (c) {
                const t = "y" === h ? "bottom" : "right";
                x = $4dacbd6c81f90f16$var$m(x + d["y" === h ? "top" : "left"], x, x - d[t]);
            }
            const w = f.fn({
                ...e,
                [p]: y,
                [h]: x
            });
            return {
                ...w,
                data: {
                    x: w.x - i,
                    y: w.y - r
                }
            };
        }
    };
}, $4dacbd6c81f90f16$export$7bf07e38f3dc4b69 = function(t) {
    return void 0 === t && (t = {}), {
        options: t,
        fn (e) {
            const { x: i, y: r, placement: a, rects: l, middlewareData: s } = e, { offset: c = 0, mainAxis: f = !0, crossAxis: m = !0 } = t, u = {
                x: i,
                y: r
            }, g = $4dacbd6c81f90f16$var$o(a), d = $4dacbd6c81f90f16$var$L(g);
            let p = u[g], h = u[d];
            const y = "function" == typeof c ? c(e) : c, x = "number" == typeof y ? {
                mainAxis: y,
                crossAxis: 0
            } : {
                mainAxis: 0,
                crossAxis: 0,
                ...y
            };
            if (f) {
                const t = "y" === g ? "height" : "width", e = l.reference[g] - l.floating[t] + x.mainAxis, n = l.reference[g] + l.reference[t] - x.mainAxis;
                p < e ? p = e : p > n && (p = n);
            }
            if (m) {
                var w, v;
                const t = "y" === g ? "width" : "height", e = [
                    "top",
                    "left"
                ].includes($4dacbd6c81f90f16$var$n(a)), o = l.reference[d] - l.floating[t] + (e && (null == (w = s.offset) ? void 0 : w[d]) || 0) + (e ? 0 : x.crossAxis), i = l.reference[d] + l.reference[t] + (e ? 0 : (null == (v = s.offset) ? void 0 : v[d]) || 0) - (e ? x.crossAxis : 0);
                h < o ? h = o : h > i && (h = i);
            }
            return {
                [g]: p,
                [d]: h
            };
        }
    };
}, $4dacbd6c81f90f16$export$346677f925de839c = function(e) {
    return void 0 === e && (e = {}), {
        name: "size",
        options: e,
        async fn (i) {
            const { placement: r, rects: a, platform: l, elements: m } = i, { apply: u = ()=>{}, ...g } = e, d = await $4dacbd6c81f90f16$export$37b6bde19b108ecc(i, g), p = $4dacbd6c81f90f16$var$n(r), h = $4dacbd6c81f90f16$var$t(r), y = "x" === $4dacbd6c81f90f16$var$o(r), { width: x, height: w } = a.floating;
            let v, b;
            "top" === p || "bottom" === p ? (v = p, b = h === (await (null == l.isRTL ? void 0 : l.isRTL(m.floating)) ? "start" : "end") ? "left" : "right") : (b = p, v = "end" === h ? "top" : "bottom");
            const A = w - d[v], R = x - d[b];
            let P = A, E = R;
            if (y ? E = $4dacbd6c81f90f16$var$c(x - d.right - d.left, R) : P = $4dacbd6c81f90f16$var$c(w - d.bottom - d.top, A), !i.middlewareData.shift && !h) {
                const t = $4dacbd6c81f90f16$var$f(d.left, 0), e = $4dacbd6c81f90f16$var$f(d.right, 0), n = $4dacbd6c81f90f16$var$f(d.top, 0), o = $4dacbd6c81f90f16$var$f(d.bottom, 0);
                y ? E = x - 2 * (0 !== t || 0 !== e ? t + e : $4dacbd6c81f90f16$var$f(d.left, d.right)) : P = w - 2 * (0 !== n || 0 !== o ? n + o : $4dacbd6c81f90f16$var$f(d.top, d.bottom));
            }
            await u({
                ...i,
                availableWidth: E,
                availableHeight: P
            });
            const T = await l.getDimensions(m.floating);
            return x !== T.width || w !== T.height ? {
                reset: {
                    rects: !0
                }
            } : {};
        }
    };
};

});


parcelRegister("k286k", function(module, exports) {

$parcel$export(module.exports, "default", () => $e95a473d1e65c2a9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $e95a473d1e65c2a9$var$index = (0, $eUqFw.useLayoutEffect);
var $e95a473d1e65c2a9$export$2e2bcd8739ae039 = $e95a473d1e65c2a9$var$index;

});


parcelRegister("4thND", function(module, exports) {

$parcel$export(module.exports, "multiValueCSS", () => $9e3a992ba25ca4ce$export$23c213f7717186af);
$parcel$export(module.exports, "multiValueLabelCSS", () => $9e3a992ba25ca4ce$export$f40612612e0af964);
$parcel$export(module.exports, "multiValueRemoveCSS", () => $9e3a992ba25ca4ce$export$283467f6c4ac142b);
$parcel$export(module.exports, "MultiValueContainer", () => $9e3a992ba25ca4ce$export$cf9cf2a30a59265c);
$parcel$export(module.exports, "MultiValueLabel", () => $9e3a992ba25ca4ce$export$544aeea2a5ce08ee);
$parcel$export(module.exports, "MultiValueRemove", () => $9e3a992ba25ca4ce$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "default", () => $9e3a992ba25ca4ce$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $lOf1W = parcelRequire("lOf1W");

var $32G5A = parcelRequire("32G5A");
const $9e3a992ba25ca4ce$export$23c213f7717186af = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors } }, unstyled)=>({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0,
        // resolves flex/text-overflow bug
        ...unstyled ? {} : {
            backgroundColor: colors.neutral10,
            borderRadius: borderRadius / 2,
            margin: spacing.baseUnit / 2
        }
    });
const $9e3a992ba25ca4ce$export$f40612612e0af964 = ({ theme: { borderRadius: borderRadius, colors: colors }, cropWithEllipsis: cropWithEllipsis }, unstyled)=>({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap',
        ...unstyled ? {} : {
            borderRadius: borderRadius / 2,
            color: colors.neutral80,
            fontSize: '85%',
            padding: 3,
            paddingLeft: 6
        }
    });
const $9e3a992ba25ca4ce$export$283467f6c4ac142b = ({ theme: { spacing: spacing, borderRadius: borderRadius, colors: colors }, isFocused: isFocused }, unstyled)=>({
        alignItems: 'center',
        display: 'flex',
        ...unstyled ? {} : {
            borderRadius: borderRadius / 2,
            backgroundColor: isFocused ? colors.dangerLight : undefined,
            paddingLeft: spacing.baseUnit,
            paddingRight: spacing.baseUnit,
            ':hover': {
                backgroundColor: colors.dangerLight,
                color: colors.danger
            }
        }
    });
const $9e3a992ba25ca4ce$export$e1de505c1242dc1a = ({ children: children, innerProps: innerProps })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", innerProps, children);
const $9e3a992ba25ca4ce$export$cf9cf2a30a59265c = $9e3a992ba25ca4ce$export$e1de505c1242dc1a;
const $9e3a992ba25ca4ce$export$544aeea2a5ce08ee = $9e3a992ba25ca4ce$export$e1de505c1242dc1a;
function $9e3a992ba25ca4ce$export$8e1fd1a40e7a2f4a({ children: children, innerProps: innerProps }) {
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "button",
        ...innerProps
    }, children || /*#__PURE__*/ (0, $byn9U.jsx)((0, $32G5A.CrossIcon), {
        size: 14
    }));
}
const $9e3a992ba25ca4ce$var$MultiValue = (props)=>{
    const { children: children, components: components, data: data, innerProps: innerProps, isDisabled: isDisabled, removeProps: removeProps, selectProps: selectProps } = props;
    const { Container: Container, Label: Label, Remove: Remove } = components;
    return /*#__PURE__*/ (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: {
            ...(0, $lOf1W.getStyleProps)(props, 'multiValue', {
                'multi-value': true,
                'multi-value--is-disabled': isDisabled
            }),
            ...innerProps
        },
        selectProps: selectProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: {
            ...(0, $lOf1W.getStyleProps)(props, 'multiValueLabel', {
                'multi-value__label': true
            })
        },
        selectProps: selectProps
    }, children), /*#__PURE__*/ (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: {
            ...(0, $lOf1W.getStyleProps)(props, 'multiValueRemove', {
                'multi-value__remove': true
            }),
            'aria-label': `Remove ${children || 'option'}`,
            ...removeProps
        },
        selectProps: selectProps
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$9e3a992ba25ca4ce$export$2e2bcd8739ae039 = $9e3a992ba25ca4ce$var$MultiValue;

});

parcelRegister("87IA6", function(module, exports) {

$parcel$export(module.exports, "optionCSS", () => $a5461f3c7b7e0f88$export$ef897119b7e920ba);
$parcel$export(module.exports, "default", () => $a5461f3c7b7e0f88$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $lOf1W = parcelRequire("lOf1W");
const $a5461f3c7b7e0f88$export$ef897119b7e920ba = ({ isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        ...unstyled ? {} : {
            backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
            color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
            padding: `${spacing.baseUnit * 2}px ${spacing.baseUnit * 3}px`,
            // provide some affordance on touch devices
            ':active': {
                backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
            }
        }
    });
const $a5461f3c7b7e0f88$var$Option = (props)=>{
    const { children: children, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected, innerRef: innerRef, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)(props, 'option', {
            option: true,
            'option--is-disabled': isDisabled,
            'option--is-focused': isFocused,
            'option--is-selected': isSelected
        }),
        //@ts-ignore
        ref: innerRef,
        "aria-disabled": isDisabled,
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$a5461f3c7b7e0f88$export$2e2bcd8739ae039 = $a5461f3c7b7e0f88$var$Option;

});

parcelRegister("ju14b", function(module, exports) {

$parcel$export(module.exports, "placeholderCSS", () => $821bca98ea54dd44$export$5f3ffacd6594d90f);
$parcel$export(module.exports, "default", () => $821bca98ea54dd44$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $lOf1W = parcelRequire("lOf1W");
const $821bca98ea54dd44$export$5f3ffacd6594d90f = ({ theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3',
        ...unstyled ? {} : {
            color: colors.neutral50,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        }
    });
const $821bca98ea54dd44$var$Placeholder = (props)=>{
    const { children: children, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)(props, 'placeholder', {
            placeholder: true
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$821bca98ea54dd44$export$2e2bcd8739ae039 = $821bca98ea54dd44$var$Placeholder;

});

parcelRegister("1ffr4", function(module, exports) {

$parcel$export(module.exports, "css", () => $6d7d72d0538294ce$export$dbf350e5966cf602);
$parcel$export(module.exports, "default", () => $6d7d72d0538294ce$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $lOf1W = parcelRequire("lOf1W");
const $6d7d72d0538294ce$export$dbf350e5966cf602 = ({ isDisabled: isDisabled, theme: { spacing: spacing, colors: colors } }, unstyled)=>({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        ...unstyled ? {} : {
            color: isDisabled ? colors.neutral40 : colors.neutral80,
            marginLeft: spacing.baseUnit / 2,
            marginRight: spacing.baseUnit / 2
        }
    });
const $6d7d72d0538294ce$var$SingleValue = (props)=>{
    const { children: children, isDisabled: isDisabled, innerProps: innerProps } = props;
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        ...(0, $lOf1W.getStyleProps)(props, 'singleValue', {
            'single-value': true,
            'single-value--is-disabled': isDisabled
        }),
        ...innerProps
    }, children);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6d7d72d0538294ce$export$2e2bcd8739ae039 = $6d7d72d0538294ce$var$SingleValue;

});


parcelRegister("43BmN", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fa174ddc12b9813$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $lOf1W = parcelRequire("lOf1W");
const $4fa174ddc12b9813$var$dummyInputStyles = /*#__PURE__*/ (0, $byn9U.css)({
    width: 1,
    padding: 0,
    position: 'relative',
    background: 0,
    border: 0,
    caretColor: 'transparent',
    color: 'transparent',
    fontSize: 'inherit',
    gridArea: '1 / 1 / 2 / 3',
    insetInlineStart: -100,
    label: 'dummyInput',
    opacity: 0,
    outline: 0,
    transform: 'scale(.01)'
});
function $4fa174ddc12b9813$export$2e2bcd8739ae039({ innerRef: innerRef, ...props }) {
    // Remove animation props not meant for HTML elements
    const filteredProps = (0, $lOf1W.removeProps)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return /*#__PURE__*/ (0, $byn9U.jsx)("input", {
        ref: innerRef,
        ...filteredProps,
        css: $4fa174ddc12b9813$var$dummyInputStyles
    });
}

});

parcelRegister("416RO", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bc7fe7904f1f615$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");

var $hRu1S = parcelRequire("hRu1S");
function $8bc7fe7904f1f615$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8bc7fe7904f1f615$var$styles = {
    name: "1fj9brw-requiredInput",
    styles: "width:100%;position:absolute;inset-block-end:0;inset-inline-end:0;inset-inline-start:0;label:requiredInput;opacity:0;pointer-events:none"
};
const $8bc7fe7904f1f615$var$RequiredInput = ({ name: name, onFocus: onFocus })=>/*#__PURE__*/ (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $8bc7fe7904f1f615$var$styles,
        // Prevent `Switching from uncontrolled to controlled` error
        value: "",
        onChange: (0, $hRu1S.default)
    });
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$8bc7fe7904f1f615$export$2e2bcd8739ae039 = $8bc7fe7904f1f615$var$RequiredInput;

});

parcelRegister("3zafO", function(module, exports) {

$parcel$export(module.exports, "default", () => $e032df77e4c3ebe6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $d3Ty1 = parcelRequire("d3Ty1");

var $cTcTm = parcelRequire("cTcTm");
function $e032df77e4c3ebe6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e032df77e4c3ebe6$var$styles = {
    name: "qzxev8",
    styles: "position:fixed;inset-block-end:0;inset-block-start:0;inset-inline-end:0;inset-inline-start:0"
};
const $e032df77e4c3ebe6$var$blurSelectInput = (event)=>{
    const element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
function $e032df77e4c3ebe6$export$2e2bcd8739ae039({ children: children, lockEnabled: lockEnabled, captureEnabled: captureEnabled = true, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const setScrollCaptureTarget = (0, $d3Ty1.default)({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    const setScrollLockTarget = (0, $cTcTm.default)({
        isEnabled: lockEnabled
    });
    const targetRef = (element)=>{
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        onClick: $e032df77e4c3ebe6$var$blurSelectInput,
        css: $e032df77e4c3ebe6$var$styles
    }), children(targetRef));
}

});
parcelRegister("d3Ty1", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e5a60ddbb482141$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lOf1W = parcelRequire("lOf1W");
const $1e5a60ddbb482141$var$cancelScroll = (event)=>{
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $1e5a60ddbb482141$export$2e2bcd8739ae039({ isEnabled: isEnabled, onBottomArrive: onBottomArrive, onBottomLeave: onBottomLeave, onTopArrive: onTopArrive, onTopLeave: onTopLeave }) {
    const isBottom = (0, $eUqFw.useRef)(false);
    const isTop = (0, $eUqFw.useRef)(false);
    const touchStart = (0, $eUqFw.useRef)(0);
    const scrollTarget = (0, $eUqFw.useRef)(null);
    const handleEventDelta = (0, $eUqFw.useCallback)((event, delta)=>{
        if (scrollTarget.current === null) return;
        const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = scrollTarget.current;
        const target = scrollTarget.current;
        const isDeltaPositive = delta > 0;
        const availableScroll = scrollHeight - clientHeight - scrollTop;
        let shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $1e5a60ddbb482141$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    const onWheel = (0, $eUqFw.useCallback)((event)=>{
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    const onTouchStart = (0, $eUqFw.useCallback)((event)=>{
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    const onTouchMove = (0, $eUqFw.useCallback)((event)=>{
        const deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    const startListening = (0, $eUqFw.useCallback)((el)=>{
        // bail early if no element is available to attach to
        if (!el) return;
        const notPassive = (0, $lOf1W.supportsPassiveEvents) ? {
            passive: false
        } : false;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('wheel', onWheel, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchstart', onTouchStart, notPassive);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    const stopListening = (0, $eUqFw.useCallback)((el)=>{
        // bail early if no element is available to detach from
        if (!el) return;
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('wheel', onWheel, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchstart', onTouchStart, false);
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        startListening(element);
        return ()=>{
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});

parcelRegister("cTcTm", function(module, exports) {

$parcel$export(module.exports, "default", () => $cef53ee7c7f583d9$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
const $cef53ee7c7f583d9$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
const $cef53ee7c7f583d9$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $cef53ee7c7f583d9$var$preventTouchMove(e) {
    e.preventDefault();
}
function $cef53ee7c7f583d9$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $cef53ee7c7f583d9$var$preventInertiaScroll() {
    const top = this.scrollTop;
    const totalScroll = this.scrollHeight;
    const currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $cef53ee7c7f583d9$var$isTouchDevice() {
    // eslint-disable-next-line compat/compat
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
const $cef53ee7c7f583d9$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
let $cef53ee7c7f583d9$var$activeScrollLocks = 0;
const $cef53ee7c7f583d9$var$listenerOptions = {
    capture: false,
    passive: false
};
function $cef53ee7c7f583d9$export$2e2bcd8739ae039({ isEnabled: isEnabled, accountForScrollbars: accountForScrollbars = true }) {
    const originalStyles = (0, $eUqFw.useRef)({});
    const scrollTarget = (0, $eUqFw.useRef)(null);
    const addScrollLock = (0, $eUqFw.useCallback)((touchScrollTarget)=>{
        if (!$cef53ee7c7f583d9$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $cef53ee7c7f583d9$var$STYLE_KEYS.forEach((key)=>{
            const val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $cef53ee7c7f583d9$var$activeScrollLocks < 1) {
            const currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            const clientWidth = document.body ? document.body.clientWidth : 0;
            const adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($cef53ee7c7f583d9$var$LOCK_STYLES).forEach((key)=>{
                const val = $cef53ee7c7f583d9$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = `${adjustedPadding}px`;
        }
        // account for touch devices
        if (target && $cef53ee7c7f583d9$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.addEventListener('touchmove', $cef53ee7c7f583d9$var$preventTouchMove, $cef53ee7c7f583d9$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchstart', $cef53ee7c7f583d9$var$preventInertiaScroll, $cef53ee7c7f583d9$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.addEventListener('touchmove', $cef53ee7c7f583d9$var$allowTouchMove, $cef53ee7c7f583d9$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $cef53ee7c7f583d9$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    const removeScrollLock = (0, $eUqFw.useCallback)((touchScrollTarget)=>{
        if (!$cef53ee7c7f583d9$var$canUseDOM) return;
        const target = document.body;
        const targetStyle = target && target.style;
        // safely decrement active scroll locks
        $cef53ee7c7f583d9$var$activeScrollLocks = Math.max($cef53ee7c7f583d9$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $cef53ee7c7f583d9$var$activeScrollLocks < 1) $cef53ee7c7f583d9$var$STYLE_KEYS.forEach((key)=>{
            const val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $cef53ee7c7f583d9$var$isTouchDevice()) {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            target.removeEventListener('touchmove', $cef53ee7c7f583d9$var$preventTouchMove, $cef53ee7c7f583d9$var$listenerOptions);
            if (touchScrollTarget) {
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchstart', $cef53ee7c7f583d9$var$preventInertiaScroll, $cef53ee7c7f583d9$var$listenerOptions);
                // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
                touchScrollTarget.removeEventListener('touchmove', $cef53ee7c7f583d9$var$allowTouchMove, $cef53ee7c7f583d9$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isEnabled) return;
        const element = scrollTarget.current;
        addScrollLock(element);
        return ()=>{
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return (element)=>{
        scrollTarget.current = element;
    };
}

});


parcelRegister("gG6Yp", function(module, exports) {

$parcel$export(module.exports, "default", () => $b08b1d28afb7dad6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $eCLBe = parcelRequire("eCLBe");

var $5Fvji = parcelRequire("5Fvji");
// eslint-disable-next-line @repo/internal/react/require-jsdoc
const $b08b1d28afb7dad6$var$LiveRegion = (props)=>{
    const { ariaSelection: ariaSelection, focusedOption: focusedOption, focusedValue: focusedValue, focusableOptions: focusableOptions, isFocused: isFocused, selectValue: selectValue, selectProps: selectProps, id: id, isAppleDevice: isAppleDevice } = props;
    const { ariaLiveMessages: ariaLiveMessages, getOptionLabel: getOptionLabel, inputValue: inputValue, isMulti: isMulti, isOptionDisabled: isOptionDisabled, isSearchable: isSearchable, label: label, menuIsOpen: menuIsOpen, options: options, screenReaderStatus: screenReaderStatus, tabSelectsValue: tabSelectsValue, isLoading: isLoading } = selectProps;
    const ariaLabel = selectProps['aria-label'] || label;
    const ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    const messages = (0, $eUqFw.useMemo)(()=>({
            ...(0, $eCLBe.defaultAriaLiveMessages),
            ...ariaLiveMessages || {}
        }), [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    const ariaSelected = (0, $eUqFw.useMemo)(()=>{
        let message = '';
        if (ariaSelection && messages.onChange) {
            const { option: option, options: selectedOptions, removedValue: removedValue, removedValues: removedValues, value: value } = ariaSelection;
            // select-option when !isMulti does not return option so we assume selected option is value
            const asOption = (val)=>!Array.isArray(val) ? val : null;
            // If there is just one item from the action then get its label
            const selected = removedValue || option || asOption(value);
            const label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            const multiSelected = selectedOptions || removedValues || undefined;
            const labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            const onChangeProps = {
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels,
                ...ariaSelection
            };
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    const ariaFocused = (0, $eUqFw.useMemo)(()=>{
        let focusMsg = '';
        const focused = focusedOption || focusedValue;
        const isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            const onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    const ariaResults = (0, $eUqFw.useMemo)(()=>{
        let resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            const resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    const isInitialFocus = ariaSelection?.action === 'initial-input-focus';
    const ariaGuidance = (0, $eUqFw.useMemo)(()=>{
        let guidanceMsg = '';
        if (messages.guidance) {
            const context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    const ScreenReaderText = /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-results"
    }, ariaResults), /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $5Fvji.default), {
        id: id
    }, isInitialFocus && ScreenReaderText), /*#__PURE__*/ (0, $byn9U.jsx)((0, $5Fvji.default), {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b08b1d28afb7dad6$export$2e2bcd8739ae039 = $b08b1d28afb7dad6$var$LiveRegion;

});
parcelRegister("eCLBe", function(module, exports) {

$parcel$export(module.exports, "defaultAriaLiveMessages", () => $5a22301569da2786$export$a7265767c78f9bae);
const $5a22301569da2786$export$a7265767c78f9bae = {
    guidance: (props)=>{
        const { isSearchable: isSearchable, isMulti: isMulti, tabSelectsValue: tabSelectsValue, context: context, isInitialFocus: isInitialFocus } = props;
        switch(context){
            case 'menu':
                return `Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu${tabSelectsValue ? ', press Tab to select the option and exit the menu' : ''}.`;
            case 'input':
                return isInitialFocus ? `${props['aria-label'] || 'Select'} is focused ${isSearchable ? ',type to refine list' : ''}, press Down to open the menu, ${isMulti ? ' press left to focus selected values' : ''}` : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: (props)=>{
        const { action: action, label: label = '', labels: labels, isDisabled: isDisabled } = props;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return `option ${label}, deselected.`;
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return `option${labels.length > 1 ? 's' : ''} ${labels.join(',')}, selected.`;
            case 'select-option':
                return isDisabled ? `option ${label} is disabled. Select another option.` : `option ${label}, selected.`;
            default:
                return '';
        }
    },
    onFocus: (props)=>{
        const { context: context, focused: focused, options: options, label: label = '', selectValue: selectValue, isDisabled: isDisabled, isSelected: isSelected, isAppleDevice: isAppleDevice } = props;
        const getArrayIndex = (arr, item)=>arr && arr.length ? `${arr.indexOf(item) + 1} of ${arr.length}` : '';
        if (context === 'value' && selectValue) return `value ${label} focused, ${getArrayIndex(selectValue, focused)}.`;
        if (context === 'menu' && isAppleDevice) {
            const disabled = isDisabled ? ' disabled' : '';
            const status = `${isSelected ? ' selected' : ''}${disabled}`;
            return `${label}${status}, ${getArrayIndex(options, focused)}.`;
        }
        return '';
    },
    onFilter: (props)=>{
        const { inputValue: inputValue, resultsMessage: resultsMessage } = props;
        return `${resultsMessage}${inputValue ? ' for search term ' + inputValue : ''}.`;
    }
};

});

parcelRegister("5Fvji", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b317d75014012e7$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $byn9U = parcelRequire("byn9U");
function $6b317d75014012e7$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
const $6b317d75014012e7$var$styles = {
    name: "1j8j4w4-a11yText",
    styles: "width:1px;height:1px;padding:0;position:absolute;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);label:a11yText;overflow:hidden;white-space:nowrap"
};
const $6b317d75014012e7$var$A11yText = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $6b317d75014012e7$var$styles,
        ...props
    });
var $6b317d75014012e7$export$2e2bcd8739ae039 = $6b317d75014012e7$var$A11yText;

});


parcelRegister("5tacV", function(module, exports) {

$parcel$export(module.exports, "createFilter", () => $302a26c71faa0b7f$export$5d81789ff4aeccdf);

var $5iWql = parcelRequire("5iWql");

var $i0evv = parcelRequire("i0evv");
const $302a26c71faa0b7f$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)((0, $i0evv.stripDiacritics));
const $302a26c71faa0b7f$var$trimString = (str)=>str.replace(/^\s+|\s+$/g, '');
const $302a26c71faa0b7f$var$defaultStringify = (option)=>`${option.label} ${option.value}`;
const $302a26c71faa0b7f$export$5d81789ff4aeccdf = (config)=>(option, rawInput)=>{
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        const { ignoreCase: ignoreCase, ignoreAccents: ignoreAccents, stringify: stringify, trim: trim, matchFrom: matchFrom } = {
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $302a26c71faa0b7f$var$defaultStringify,
            trim: true,
            matchFrom: 'any',
            ...config
        };
        let input = trim ? $302a26c71faa0b7f$var$trimString(rawInput) : rawInput;
        let candidate = trim ? $302a26c71faa0b7f$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $302a26c71faa0b7f$var$memoizedStripDiacriticsForInput(input);
            candidate = (0, $i0evv.stripDiacritics)(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };

});
parcelRegister("i0evv", function(module, exports) {

$parcel$export(module.exports, "stripDiacritics", () => $011f29af16ad3254$export$b5bee4b27048330b);
const $011f29af16ad3254$var$diacritics = [
    {
        base: 'A',
        letters: '\u0041\u24B6\uFF21\u00C0\u00C1\u00C2\u1EA6\u1EA4\u1EAA\u1EA8\u00C3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\u00C4\u01DE\u1EA2\u00C5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F'
    },
    {
        base: 'AA',
        letters: '\uA732'
    },
    {
        base: 'AE',
        letters: '\u00C6\u01FC\u01E2'
    },
    {
        base: 'AO',
        letters: '\uA734'
    },
    {
        base: 'AU',
        letters: '\uA736'
    },
    {
        base: 'AV',
        letters: '\uA738\uA73A'
    },
    {
        base: 'AY',
        letters: '\uA73C'
    },
    {
        base: 'B',
        letters: '\u0042\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181'
    },
    {
        base: 'C',
        letters: '\u0043\u24B8\uFF23\u0106\u0108\u010A\u010C\u00C7\u1E08\u0187\u023B\uA73E'
    },
    {
        base: 'D',
        letters: '\u0044\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779'
    },
    {
        base: 'DZ',
        letters: '\u01F1\u01C4'
    },
    {
        base: 'Dz',
        letters: '\u01F2\u01C5'
    },
    {
        base: 'E',
        letters: '\u0045\u24BA\uFF25\u00C8\u00C9\u00CA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\u00CB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E'
    },
    {
        base: 'F',
        letters: '\u0046\u24BB\uFF26\u1E1E\u0191\uA77B'
    },
    {
        base: 'G',
        letters: '\u0047\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E'
    },
    {
        base: 'H',
        letters: '\u0048\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D'
    },
    {
        base: 'I',
        letters: '\u0049\u24BE\uFF29\u00CC\u00CD\u00CE\u0128\u012A\u012C\u0130\u00CF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197'
    },
    {
        base: 'J',
        letters: '\u004A\u24BF\uFF2A\u0134\u0248'
    },
    {
        base: 'K',
        letters: '\u004B\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2'
    },
    {
        base: 'L',
        letters: '\u004C\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780'
    },
    {
        base: 'LJ',
        letters: '\u01C7'
    },
    {
        base: 'Lj',
        letters: '\u01C8'
    },
    {
        base: 'M',
        letters: '\u004D\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C'
    },
    {
        base: 'N',
        letters: '\u004E\u24C3\uFF2E\u01F8\u0143\u00D1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4'
    },
    {
        base: 'NJ',
        letters: '\u01CA'
    },
    {
        base: 'Nj',
        letters: '\u01CB'
    },
    {
        base: 'O',
        letters: '\u004F\u24C4\uFF2F\u00D2\u00D3\u00D4\u1ED2\u1ED0\u1ED6\u1ED4\u00D5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\u00D6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\u00D8\u01FE\u0186\u019F\uA74A\uA74C'
    },
    {
        base: 'OI',
        letters: '\u01A2'
    },
    {
        base: 'OO',
        letters: '\uA74E'
    },
    {
        base: 'OU',
        letters: '\u0222'
    },
    {
        base: 'P',
        letters: '\u0050\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754'
    },
    {
        base: 'Q',
        letters: '\u0051\u24C6\uFF31\uA756\uA758\u024A'
    },
    {
        base: 'R',
        letters: '\u0052\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782'
    },
    {
        base: 'S',
        letters: '\u0053\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784'
    },
    {
        base: 'T',
        letters: '\u0054\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786'
    },
    {
        base: 'TZ',
        letters: '\uA728'
    },
    {
        base: 'U',
        letters: '\u0055\u24CA\uFF35\u00D9\u00DA\u00DB\u0168\u1E78\u016A\u1E7A\u016C\u00DC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244'
    },
    {
        base: 'V',
        letters: '\u0056\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245'
    },
    {
        base: 'VY',
        letters: '\uA760'
    },
    {
        base: 'W',
        letters: '\u0057\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72'
    },
    {
        base: 'X',
        letters: '\u0058\u24CD\uFF38\u1E8A\u1E8C'
    },
    {
        base: 'Y',
        letters: '\u0059\u24CE\uFF39\u1EF2\u00DD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE'
    },
    {
        base: 'Z',
        letters: '\u005A\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762'
    },
    {
        base: 'a',
        letters: '\u0061\u24D0\uFF41\u1E9A\u00E0\u00E1\u00E2\u1EA7\u1EA5\u1EAB\u1EA9\u00E3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\u00E4\u01DF\u1EA3\u00E5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250'
    },
    {
        base: 'aa',
        letters: '\uA733'
    },
    {
        base: 'ae',
        letters: '\u00E6\u01FD\u01E3'
    },
    {
        base: 'ao',
        letters: '\uA735'
    },
    {
        base: 'au',
        letters: '\uA737'
    },
    {
        base: 'av',
        letters: '\uA739\uA73B'
    },
    {
        base: 'ay',
        letters: '\uA73D'
    },
    {
        base: 'b',
        letters: '\u0062\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253'
    },
    {
        base: 'c',
        letters: '\u0063\u24D2\uFF43\u0107\u0109\u010B\u010D\u00E7\u1E09\u0188\u023C\uA73F\u2184'
    },
    {
        base: 'd',
        letters: '\u0064\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A'
    },
    {
        base: 'dz',
        letters: '\u01F3\u01C6'
    },
    {
        base: 'e',
        letters: '\u0065\u24D4\uFF45\u00E8\u00E9\u00EA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\u00EB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD'
    },
    {
        base: 'f',
        letters: '\u0066\u24D5\uFF46\u1E1F\u0192\uA77C'
    },
    {
        base: 'g',
        letters: '\u0067\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F'
    },
    {
        base: 'h',
        letters: '\u0068\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265'
    },
    {
        base: 'hv',
        letters: '\u0195'
    },
    {
        base: 'i',
        letters: '\u0069\u24D8\uFF49\u00EC\u00ED\u00EE\u0129\u012B\u012D\u00EF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131'
    },
    {
        base: 'j',
        letters: '\u006A\u24D9\uFF4A\u0135\u01F0\u0249'
    },
    {
        base: 'k',
        letters: '\u006B\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3'
    },
    {
        base: 'l',
        letters: '\u006C\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747'
    },
    {
        base: 'lj',
        letters: '\u01C9'
    },
    {
        base: 'm',
        letters: '\u006D\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F'
    },
    {
        base: 'n',
        letters: '\u006E\u24DD\uFF4E\u01F9\u0144\u00F1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5'
    },
    {
        base: 'nj',
        letters: '\u01CC'
    },
    {
        base: 'o',
        letters: '\u006F\u24DE\uFF4F\u00F2\u00F3\u00F4\u1ED3\u1ED1\u1ED7\u1ED5\u00F5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\u00F6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\u00F8\u01FF\u0254\uA74B\uA74D\u0275'
    },
    {
        base: 'oi',
        letters: '\u01A3'
    },
    {
        base: 'ou',
        letters: '\u0223'
    },
    {
        base: 'oo',
        letters: '\uA74F'
    },
    {
        base: 'p',
        letters: '\u0070\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755'
    },
    {
        base: 'q',
        letters: '\u0071\u24E0\uFF51\u024B\uA757\uA759'
    },
    {
        base: 'r',
        letters: '\u0072\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783'
    },
    {
        base: 's',
        letters: '\u0073\u24E2\uFF53\u00DF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B'
    },
    {
        base: 't',
        letters: '\u0074\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787'
    },
    {
        base: 'tz',
        letters: '\uA729'
    },
    {
        base: 'u',
        letters: '\u0075\u24E4\uFF55\u00F9\u00FA\u00FB\u0169\u1E79\u016B\u1E7B\u016D\u00FC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289'
    },
    {
        base: 'v',
        letters: '\u0076\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C'
    },
    {
        base: 'vy',
        letters: '\uA761'
    },
    {
        base: 'w',
        letters: '\u0077\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73'
    },
    {
        base: 'x',
        letters: '\u0078\u24E7\uFF58\u1E8B\u1E8D'
    },
    {
        base: 'y',
        letters: '\u0079\u24E8\uFF59\u1EF3\u00FD\u0177\u1EF9\u0233\u1E8F\u00FF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF'
    },
    {
        base: 'z',
        letters: '\u007A\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763'
    }
];
const $011f29af16ad3254$var$anyDiacritic = new RegExp('[' + $011f29af16ad3254$var$diacritics.map((d)=>d.letters).join('') + ']', 'g');
const $011f29af16ad3254$var$diacriticToBase = {};
for(let i = 0; i < $011f29af16ad3254$var$diacritics.length; i++){
    let diacritic = $011f29af16ad3254$var$diacritics[i];
    for(let j = 0; j < diacritic.letters.length; j++)$011f29af16ad3254$var$diacriticToBase[diacritic.letters[j]] = diacritic.base;
}
const $011f29af16ad3254$export$b5bee4b27048330b = (str)=>{
    return str.replace($011f29af16ad3254$var$anyDiacritic, (match)=>$011f29af16ad3254$var$diacriticToBase[match]);
};

});


parcelRegister("avJlG", function(module, exports) {

$parcel$export(module.exports, "defaultStyles", () => $cb2c237bd380f04d$export$214b055320e0bf32);
$parcel$export(module.exports, "mergeStyles", () => $cb2c237bd380f04d$export$e618dc39ac9ad607);

var $dAcDB = parcelRequire("dAcDB");

var $cuwnQ = parcelRequire("cuwnQ");

var $hnzsB = parcelRequire("hnzsB");

var $32G5A = parcelRequire("32G5A");

var $4iUjk = parcelRequire("4iUjk");

var $2D1Id = parcelRequire("2D1Id");

var $4thND = parcelRequire("4thND");

var $87IA6 = parcelRequire("87IA6");

var $ju14b = parcelRequire("ju14b");

var $1ffr4 = parcelRequire("1ffr4");
const $cb2c237bd380f04d$export$214b055320e0bf32 = {
    clearIndicator: (0, $32G5A.clearIndicatorCSS),
    container: (0, $dAcDB.containerCSS),
    control: (0, $cuwnQ.css),
    dropdownIndicator: (0, $32G5A.dropdownIndicatorCSS),
    group: (0, $hnzsB.groupCSS),
    groupHeading: (0, $hnzsB.groupHeadingCSS),
    indicatorsContainer: (0, $dAcDB.indicatorsContainerCSS),
    indicatorSeparator: (0, $32G5A.indicatorSeparatorCSS),
    input: (0, $4iUjk.inputCSS),
    loadingIndicator: (0, $32G5A.loadingIndicatorCSS),
    loadingMessage: (0, $2D1Id.loadingMessageCSS),
    menu: (0, $2D1Id.menuCSS),
    menuList: (0, $2D1Id.menuListCSS),
    menuPortal: (0, $2D1Id.menuPortalCSS),
    multiValue: (0, $4thND.multiValueCSS),
    multiValueLabel: (0, $4thND.multiValueLabelCSS),
    multiValueRemove: (0, $4thND.multiValueRemoveCSS),
    noOptionsMessage: (0, $2D1Id.noOptionsMessageCSS),
    option: (0, $87IA6.optionCSS),
    placeholder: (0, $ju14b.placeholderCSS),
    singleValue: (0, $1ffr4.css),
    valueContainer: (0, $dAcDB.valueContainerCSS)
};
function $cb2c237bd380f04d$export$e618dc39ac9ad607(source, target = {}) {
    // initialize with source styles
    const styles = {
        ...source
    };
    // massage in target styles
    Object.keys(target).forEach((keyAsString)=>{
        const key = keyAsString;
        if (source[key]) styles[key] = (rsCss, props)=>{
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}

});

parcelRegister("4j05e", function(module, exports) {

$parcel$export(module.exports, "defaultTheme", () => $b0dde4f729f874b4$export$164de7ab8df77ef0);
const $b0dde4f729f874b4$export$8f45430ccf837300 = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
const $b0dde4f729f874b4$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
const $b0dde4f729f874b4$var$baseUnit = 4;
// The minimum height of the control
const $b0dde4f729f874b4$var$controlHeight = 38;
// The amount of space between the control and menu */
const $b0dde4f729f874b4$var$menuGutter = $b0dde4f729f874b4$var$baseUnit * 2;
const $b0dde4f729f874b4$export$5458b64234d1333c = {
    baseUnit: $b0dde4f729f874b4$var$baseUnit,
    controlHeight: $b0dde4f729f874b4$var$controlHeight,
    menuGutter: $b0dde4f729f874b4$var$menuGutter
};
const $b0dde4f729f874b4$export$164de7ab8df77ef0 = {
    borderRadius: $b0dde4f729f874b4$var$borderRadius,
    colors: $b0dde4f729f874b4$export$8f45430ccf837300,
    spacing: $b0dde4f729f874b4$export$5458b64234d1333c
};

});


parcelRegister("7BCqJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b853fec0bb70fcb$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $6b853fec0bb70fcb$export$2e2bcd8739ae039({ defaultInputValue: defaultInputValue = '', defaultMenuIsOpen: defaultMenuIsOpen = false, defaultValue: defaultValue = null, inputValue: propsInputValue, menuIsOpen: propsMenuIsOpen, onChange: propsOnChange, onInputChange: propsOnInputChange, onMenuClose: propsOnMenuClose, onMenuOpen: propsOnMenuOpen, value: propsValue, ...restSelectProps }) {
    const [stateInputValue, setStateInputValue] = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue);
    const [stateMenuIsOpen, setStateMenuIsOpen] = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen);
    const [stateValue, setStateValue] = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue);
    const onChange = (0, $eUqFw.useCallback)((value, actionMeta)=>{
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    const onInputChange = (0, $eUqFw.useCallback)((value, actionMeta)=>{
        let newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    const onMenuOpen = (0, $eUqFw.useCallback)(()=>{
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    const onMenuClose = (0, $eUqFw.useCallback)(()=>{
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    const inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    const menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    const value = propsValue !== undefined ? propsValue : stateValue;
    //@ts-ignore react-select unsupported props
    return {
        ...restSelectProps,
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    };
}

});


parcelRegister("1kHVI", function(module, exports) {

$parcel$export(module.exports, "default", () => $69b3d8d7e3f71bfb$export$2e2bcd8739ae039);
// eslint-disable-next-line @repo/internal/fs/filename-pattern-match

var $eUqFw = parcelRequire("eUqFw");

var $avJlG = parcelRequire("avJlG");

var $fthsX = parcelRequire("fthsX");
var $lFmcK = parcelRequire("lFmcK");

var $bmmeu = parcelRequire("bmmeu");

var $lGsh5 = parcelRequire("lGsh5");

var $lWLGw = parcelRequire("lWLGw");

var $bvM1C = parcelRequire("bvM1C");
function $69b3d8d7e3f71bfb$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $fthsX.ClearIndicator,
                DropdownIndicator: $fthsX.DropdownIndicator,
                LoadingIndicator: $fthsX.LoadingIndicator,
                MultiValueRemove: $lFmcK.MultiValueRemove,
                IndicatorSeparator: $lFmcK.IndicatorSeparator,
                Input: $bmmeu.Input,
                NoOptionsMessage: $lGsh5.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = internalSelectRef.current?.inputRef;
                const ariaDescribedby = input?.getAttribute('aria-describedby');
                if (!ariaDescribedby?.includes(descriptionId)) input?.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
		 * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
		 * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
		 * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
		 * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
		 * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
		 */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>internalSelectRef.current?.focus(),
                blur: ()=>internalSelectRef.current?.blur()
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, {
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $bvM1C.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $bvM1C.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault,
            ...restProps,
            components: components,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            styles: (0, $avJlG.mergeStyles)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $lWLGw.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        });
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("fthsX", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $cb0ce44acc629cc6$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $cb0ce44acc629cc6$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $cb0ce44acc629cc6$export$7c20be4c1d342248);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $1FyL9 = parcelRequire("1FyL9");

var $6jhKL = parcelRequire("6jhKL");

var $c6J9g = parcelRequire("c6J9g");
var $7iUNK = parcelRequire("7iUNK");
var $gv7Ek = parcelRequire("gv7Ek");

var $wXYoy = parcelRequire("wXYoy");

var $hvCdF = parcelRequire("hvCdF");
const $cb0ce44acc629cc6$var$iconContainerStyles = (0, $gv7Ek.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $cb0ce44acc629cc6$var$dropdownWrapperStyles = (0, $gv7Ek.xcss)({
    padding: 'space.075'
});
const $cb0ce44acc629cc6$export$ecf9cf59142dd54a = (props)=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $wXYoy.components).ClearIndicator, {
        ...props,
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $7iUNK.default), {
        xcss: $cb0ce44acc629cc6$var$iconContainerStyles,
        tabIndex: -1
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6jhKL))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $cb0ce44acc629cc6$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $wXYoy.components).DropdownIndicator, props, /*#__PURE__*/ (0, $byn9U.jsx)((0, $c6J9g.default), {
        as: "span",
        xcss: $cb0ce44acc629cc6$var$dropdownWrapperStyles
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1FyL9))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $cb0ce44acc629cc6$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = /*#__PURE__*/ (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: loadingStyles,
        ...props.innerProps
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $hvCdF.default), {
        size: "small"
    })));
};

});
parcelRegister("6jhKL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::35e97232317682a60395e2ccf8df4ad7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $498249dca276b0f0$var$_react = $498249dca276b0f0$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $498249dca276b0f0$var$_crossCircle = $498249dca276b0f0$var$_interopRequireDefault((parcelRequire("dQCA1")));

var $498249dca276b0f0$var$_selectClear = $498249dca276b0f0$var$_interopRequireDefault((parcelRequire("2Nahn")));
function $498249dca276b0f0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for CrossCircleIcon.
 * This component is CrossCircleIcon, with `UNSAFE_fallbackIcon` set to "SelectClearIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $498249dca276b0f0$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $498249dca276b0f0$var$_react.default.createElement($498249dca276b0f0$var$_crossCircle.default, Object.assign({
        LEGACY_fallbackIcon: $498249dca276b0f0$var$_selectClear.default
    }, props));
$498249dca276b0f0$var$CrossCircleIcon.Name = 'CrossCircleIconMigration';
var $498249dca276b0f0$var$_default = module.exports.default = $498249dca276b0f0$var$CrossCircleIcon;

});
parcelRegister("dQCA1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::bc42d217064fbe3eaef70b43f6c007b6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a14e0ee0d262c0a2$var$_react = $a14e0ee0d262c0a2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a14e0ee0d262c0a2$var$_UNSAFE_baseNew = $a14e0ee0d262c0a2$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $a14e0ee0d262c0a2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CrossCircle".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a14e0ee0d262c0a2$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $a14e0ee0d262c0a2$var$_react.default.createElement($a14e0ee0d262c0a2$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 12A6 6 0 1 0 6 0a6 6 0 0 0 0 12m3.28-8.22L7.06 6l2.22 2.22-1.06 1.06L6 7.06 3.78 9.28 2.72 8.22 4.94 6 2.72 3.78l1.06-1.06L6 4.94l2.22-2.22z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$a14e0ee0d262c0a2$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $a14e0ee0d262c0a2$var$_default = module.exports.default = $a14e0ee0d262c0a2$var$CrossCircleIcon;

});



parcelRegister("lFmcK", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $0d3bdaa206bf5782$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $0d3bdaa206bf5782$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $2Nahn = parcelRequire("2Nahn");

var $a4PmP = parcelRequire("a4PmP");

var $3puyA = parcelRequire("3puyA");

var $c6J9g = parcelRequire("c6J9g");
var $gv7Ek = parcelRequire("gv7Ek");

var $wXYoy = parcelRequire("wXYoy");

var $fthsX = parcelRequire("fthsX");
function $0d3bdaa206bf5782$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0d3bdaa206bf5782$var$disabledStyles = {
    name: "eivff4",
    styles: "display:none"
};
const $0d3bdaa206bf5782$var$enabledStyles = {
    name: "ck88l6",
    styles: "display:inherit"
};
const $0d3bdaa206bf5782$var$iconWrapperStyles = (0, $gv7Ek.xcss)({
    padding: 'space.025'
});
const $0d3bdaa206bf5782$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $3puyA.fg)('platform-component-visual-refresh')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a4PmP))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $3puyA.fg)('platform-visual-refresh-icons-legacy-facade')) return /*#__PURE__*/ (0, $byn9U.jsx)((0, $c6J9g.default), {
            xcss: $0d3bdaa206bf5782$var$iconWrapperStyles
        }, /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a4PmP))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Nahn))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $byn9U.jsx)((0, $wXYoy.components).MultiValueRemove, props, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: isDisabled ? $0d3bdaa206bf5782$var$disabledStyles : $0d3bdaa206bf5782$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $0d3bdaa206bf5782$export$bd638c2ba7915668 = null;

});

parcelRegister("bmmeu", function(module, exports) {

$parcel$export(module.exports, "Input", () => $4d293d4dababdbc3$export$f5b8910cec6cf069);

var $eUqFw = parcelRequire("eUqFw");

var $wXYoy = parcelRequire("wXYoy");
function $4d293d4dababdbc3$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute = props['aria-describedby'];
    const passed_describedby = props.selectProps['aria-describedby'] || props.selectProps.descriptionId;
    if (passed_describedby && !ariaDescribedByAttribute?.includes(passed_describedby)) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $wXYoy.components).Input, {
        ...props,
        "aria-describedby": ariaDescribedByAttribute
    });
}

});

parcelRegister("lGsh5", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $7b80e4543194c152$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $ixqNN = parcelRequire("ixqNN");

var $wXYoy = parcelRequire("wXYoy");
const $7b80e4543194c152$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $wXYoy.components).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ixqNN.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("lWLGw", function(module, exports) {

$parcel$export(module.exports, "default", () => $690ad1ff0736eb5e$export$2e2bcd8739ae039);

var $3puyA = parcelRequire("3puyA");

function $690ad1ff0736eb5e$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $ab6d6432a4c55680$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $ab6d6432a4c55680$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $ab6d6432a4c55680$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $ab6d6432a4c55680$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $ab6d6432a4c55680$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $ab6d6432a4c55680$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $ab6d6432a4c55680$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $ab6d6432a4c55680$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $ab6d6432a4c55680$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $ab6d6432a4c55680$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $ab6d6432a4c55680$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $ab6d6432a4c55680$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $ab6d6432a4c55680$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $ab6d6432a4c55680$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $ab6d6432a4c55680$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $ab6d6432a4c55680$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $ab6d6432a4c55680$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $ab6d6432a4c55680$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $ab6d6432a4c55680$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $ab6d6432a4c55680$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $ab6d6432a4c55680$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $ab6d6432a4c55680$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $ab6d6432a4c55680$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $ab6d6432a4c55680$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $ab6d6432a4c55680$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $ab6d6432a4c55680$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $ab6d6432a4c55680$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $ab6d6432a4c55680$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $ab6d6432a4c55680$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $ab6d6432a4c55680$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $ab6d6432a4c55680$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $ab6d6432a4c55680$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $ab6d6432a4c55680$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $3puyA.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $ab6d6432a4c55680$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $3puyA.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $3puyA.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $ab6d6432a4c55680$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $ab6d6432a4c55680$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $ab6d6432a4c55680$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $3puyA.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $ab6d6432a4c55680$export$f563ee71e9ee74cd})`,
                fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                textTransform: 'none'
            })
    };
}

});

parcelRegister("bvM1C", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $373091421b87ad75$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $373091421b87ad75$export$d2756249f53f9f8);
$parcel$export(module.exports, "countAllOptions", () => $373091421b87ad75$export$8ee33f304118fce4);
function $373091421b87ad75$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions?.find((option)=>{
        return option.options?.some(isOptionFocused);
    });
    const groupOptionIndex = groupData?.options.findIndex(isOptionFocused) ?? 0;
    return `Option ${focused.label}, ${groupData?.label} group, item ${groupOptionIndex + 1} out of ${groupData?.options.length}. All in all `;
}
const $373091421b87ad75$export$d2756249f53f9f8 = (arr)=>{
    return arr?.every((obj)=>obj.hasOwnProperty('options'));
};
const $373091421b87ad75$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray?.reduce((acc, currentGroup)=>{
        const group = currentGroup;
        acc += group?.options?.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("2ruhQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab4fbdba711828d6$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2MblP = parcelRequire("2MblP");

var $aLDbf = parcelRequire("aLDbf");
const $ab4fbdba711828d6$var$packageName = "platform-pkg";
const $ab4fbdba711828d6$var$packageVersion = "0.0.0-use.local";
const $ab4fbdba711828d6$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $ab4fbdba711828d6$var$packageName,
    packageVersion: $ab4fbdba711828d6$var$packageVersion
};
const $ab4fbdba711828d6$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = (0, $aLDbf.borderWidth);
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $ab4fbdba711828d6$var$InnerTextArea = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const ourRef = (0, $eUqFw.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, ...rest } = props;
    (0, $eUqFw.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $ab4fbdba711828d6$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $2MblP.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$ab4fbdba711828d6$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $2MblP.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$ab4fbdba711828d6$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $eUqFw.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $ab4fbdba711828d6$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const baseStyles = (0, $eUqFw.useMemo)(()=>(0, $aLDbf.getBaseStyles)({
            minimumRows: minimumRows,
            resize: resize,
            appearance: appearance,
            isMonospaced: isMonospaced,
            maxHeight: maxHeight
        }), [
        minimumRows,
        resize,
        appearance,
        isMonospaced,
        maxHeight
    ]);
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-array-arguments, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    const textAreaStyles = /*#__PURE__*/ (0, $byn9U.css)([
        baseStyles,
        (0, $aLDbf.dynamicStyles)(appearance)
    ]);
    return /*#__PURE__*/ (0, $byn9U.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        // TODO refactor to follow emotion styling rules
        // see: https://product-fabric.atlassian.net/browse/DSP-6060
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: textAreaStyles,
        ...rest
    });
});
/**
 * __Text area__
 *
 * A text area lets users enter long form text which spans over multiple lines.
 *
 * - [Examples](https://atlassian.design/components/textarea/examples)
 * - [Code](https://atlassian.design/components/textarea/code)
 * - [Usage](https://atlassian.design/components/textarea/usage)
 */ const $ab4fbdba711828d6$var$TextArea = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $byn9U.jsx)($ab4fbdba711828d6$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$ab4fbdba711828d6$var$TextArea.displayName = 'TextArea';
var $ab4fbdba711828d6$export$2e2bcd8739ae039 = $ab4fbdba711828d6$var$TextArea;

});
parcelRegister("aLDbf", function(module, exports) {

$parcel$export(module.exports, "borderWidth", () => $1d41bdd6d4af3ac2$export$12879c7697ed953d);
$parcel$export(module.exports, "getBaseStyles", () => $1d41bdd6d4af3ac2$export$bff8031d86bb089);
$parcel$export(module.exports, "dynamicStyles", () => $1d41bdd6d4af3ac2$export$98856a888ef36079);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $fv5VI = parcelRequire("fv5VI");
function $1d41bdd6d4af3ac2$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1d41bdd6d4af3ac2$var$disabledRules = {
    backgroundColor: $fv5VI.disabledBackground,
    backgroundColorFocus: $fv5VI.disabledBackground,
    backgroundColorHover: $fv5VI.disabledBackground,
    borderColor: $fv5VI.disabledBorder,
    borderColorFocus: $fv5VI.defaultBorderColorFocus,
    textColor: $fv5VI.disabledTextColor
};
const $1d41bdd6d4af3ac2$var$invalidRules = {
    borderColor: $fv5VI.invalidBorderColor,
    borderColorFocus: $fv5VI.defaultBorderColorFocus,
    backgroundColor: $fv5VI.defaultBackgroundColor,
    backgroundColorFocus: $fv5VI.defaultBackgroundColorFocus,
    backgroundColorHover: $fv5VI.defaultBackgroundColorHover
};
const $1d41bdd6d4af3ac2$var$backgroundColor = {
    standard: $fv5VI.defaultBackgroundColor,
    subtle: $fv5VI.transparent,
    none: $fv5VI.transparent
};
const $1d41bdd6d4af3ac2$var$backgroundColorFocus = {
    standard: $fv5VI.defaultBackgroundColorFocus,
    subtle: $fv5VI.defaultBackgroundColorFocus,
    none: $fv5VI.transparent
};
const $1d41bdd6d4af3ac2$var$backgroundColorHover = {
    standard: $fv5VI.defaultBackgroundColorHover,
    subtle: $fv5VI.defaultBackgroundColorHover,
    none: $fv5VI.transparent
};
const $1d41bdd6d4af3ac2$var$borderColor = {
    standard: $fv5VI.defaultBorderColor,
    subtle: $fv5VI.transparent,
    none: $fv5VI.transparent
};
const $1d41bdd6d4af3ac2$var$borderColorFocus = {
    standard: $fv5VI.defaultBorderColorFocus,
    subtle: $fv5VI.defaultBorderColorFocus,
    none: $fv5VI.transparent
};
const $1d41bdd6d4af3ac2$var$borderColorHover = {
    standard: $fv5VI.defaultBorderColor,
    subtle: $fv5VI.subtleBorderColorHover,
    none: $fv5VI.transparent
};
const $1d41bdd6d4af3ac2$var$lineHeightBase = 20;
const $1d41bdd6d4af3ac2$var$lineHeightCompact = 16;
const $1d41bdd6d4af3ac2$var$compactVerticalPadding = 2;
const $1d41bdd6d4af3ac2$var$verticalPadding = 6;
const $1d41bdd6d4af3ac2$var$horizontalPadding = 8;
const $1d41bdd6d4af3ac2$var$transitionDuration = '0.2s';
const $1d41bdd6d4af3ac2$var$fontFamily = "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)";
const $1d41bdd6d4af3ac2$var$codeFontFamily = "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)";
const $1d41bdd6d4af3ac2$export$12879c7697ed953d = 2;
// Safari puts on some difficult to remove styles, mainly for disabled inputs
// but we want full control so need to override them in all cases
const $1d41bdd6d4af3ac2$var$overrideSafariDisabledStyles = {
    WebkitTextFillColor: 'unset',
    WebkitOpacity: '1'
};
const $1d41bdd6d4af3ac2$var$borderBoxMinHeight = (minimumRows, borderHeight)=>{
    const contentHeight = $1d41bdd6d4af3ac2$var$lineHeightBase * minimumRows;
    return contentHeight + $1d41bdd6d4af3ac2$var$verticalPadding * 2 + borderHeight * 2;
};
const $1d41bdd6d4af3ac2$var$borderBoxMinHeightCompact = (minimumRows, borderHeight)=>{
    const contentHeightCompact = $1d41bdd6d4af3ac2$var$lineHeightCompact * minimumRows;
    return contentHeightCompact + $1d41bdd6d4af3ac2$var$compactVerticalPadding * 2 + borderHeight * 2;
};
const $1d41bdd6d4af3ac2$var$bgAndBorderColorStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        '&:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $1d41bdd6d4af3ac2$var$backgroundColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $1d41bdd6d4af3ac2$var$borderColorFocus[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$1d41bdd6d4af3ac2$var$borderColorFocus[appearance]}`
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $1d41bdd6d4af3ac2$var$backgroundColor[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $1d41bdd6d4af3ac2$var$borderColor[appearance]
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:focus': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $1d41bdd6d4af3ac2$var$invalidRules.backgroundColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $1d41bdd6d4af3ac2$var$invalidRules.borderColorFocus,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$1d41bdd6d4af3ac2$var$invalidRules.borderColorFocus}`
        },
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&[data-invalid]:not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $1d41bdd6d4af3ac2$var$invalidRules.backgroundColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $1d41bdd6d4af3ac2$var$invalidRules.borderColor,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$1d41bdd6d4af3ac2$var$invalidRules.borderColor}`
        },
        // Disabled background and border styles should not be applied to components that
        // have either no background or transparent background to begin with
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...appearance === 'standard' ? {
            '&:disabled:focus': {
                backgroundColor: $1d41bdd6d4af3ac2$var$disabledRules.backgroundColorFocus,
                borderColor: $1d41bdd6d4af3ac2$var$disabledRules.borderColorFocus
            },
            '&:disabled:not(:focus)': {
                backgroundColor: $1d41bdd6d4af3ac2$var$disabledRules.backgroundColor,
                borderColor: $1d41bdd6d4af3ac2$var$disabledRules.borderColor
            }
        } : {}
    });
const $1d41bdd6d4af3ac2$var$placeholderStyles = /*#__PURE__*/ (0, $byn9U.css)({
    '&::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $fv5VI.placeholderTextColor
    },
    '&:disabled::placeholder': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $1d41bdd6d4af3ac2$var$disabledRules.textColor
    }
});
const $1d41bdd6d4af3ac2$var$hoverBackgroundAndBorderStyles = (appearance)=>appearance && /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:hover:not(:read-only):not(:focus)': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: $1d41bdd6d4af3ac2$var$backgroundColorHover[appearance],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderColor: $1d41bdd6d4af3ac2$var$borderColorHover[appearance],
            '&:disabled': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $1d41bdd6d4af3ac2$var$disabledRules.backgroundColorHover
            },
            // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
            '&[data-invalid]': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                backgroundColor: $1d41bdd6d4af3ac2$var$invalidRules.backgroundColorHover,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderColor: $1d41bdd6d4af3ac2$var$invalidRules.borderColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${$1d41bdd6d4af3ac2$var$invalidRules.borderColor}`
            }
        }
    });
var $1d41bdd6d4af3ac2$var$_ref = {
    name: "utehjx",
    styles: "resize:none"
};
var $1d41bdd6d4af3ac2$var$_ref2 = {
    name: "bolgb9",
    styles: "resize:both"
};
const $1d41bdd6d4af3ac2$var$resizeStyle = (resize)=>{
    if (resize === 'horizontal' || resize === 'vertical') // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    return /*#__PURE__*/ (0, $byn9U.css)({
        resize: resize
    });
    if (resize === 'auto') return $1d41bdd6d4af3ac2$var$_ref2;
    return $1d41bdd6d4af3ac2$var$_ref;
};
const $1d41bdd6d4af3ac2$var$borderStyle = (appearance)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderStyle: appearance === 'none' ? 'none' : 'solid'
    });
const $1d41bdd6d4af3ac2$var$fontFamilyStyle = (isMonospaced)=>/*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        fontFamily: isMonospaced ? $1d41bdd6d4af3ac2$var$codeFontFamily : $1d41bdd6d4af3ac2$var$fontFamily
    });
const $1d41bdd6d4af3ac2$var$borderPaddingAndHeightStyles = (minimumRows = 1, appearance)=>{
    const borderWidth = appearance !== 'none' ? 1 : 2;
    const horizontalPaddingWithoutBorderWidth = $1d41bdd6d4af3ac2$var$horizontalPadding - borderWidth;
    const borderHeight = borderWidth;
    return /*#__PURE__*/ (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '&[data-compact]': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $1d41bdd6d4af3ac2$var$borderBoxMinHeightCompact(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$1d41bdd6d4af3ac2$var$compactVerticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $1d41bdd6d4af3ac2$var$lineHeightCompact / 14
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
        '&:not([data-compact])': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            minHeight: $1d41bdd6d4af3ac2$var$borderBoxMinHeight(minimumRows, borderHeight),
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            padding: `${$1d41bdd6d4af3ac2$var$verticalPadding}px ${horizontalPaddingWithoutBorderWidth}px`,
            // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage, @atlaskit/ui-styling-standard/no-unsafe-values
            lineHeight: $1d41bdd6d4af3ac2$var$lineHeightBase / 14
        }
    });
};
const $1d41bdd6d4af3ac2$var$staticStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'block',
    boxSizing: 'border-box',
    width: '100%',
    minWidth: 0,
    maxWidth: '100%',
    margin: 0,
    position: 'relative',
    flex: '1 1 100%',
    borderRadius: "var(--ds-border-radius, 3px)",
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    borderWidth: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    outline: 'none',
    overflow: 'auto',
    transition: `background-color ${$1d41bdd6d4af3ac2$var$transitionDuration} ease-in-out,
               border-color ${$1d41bdd6d4af3ac2$var$transitionDuration} ease-in-out`,
    wordWrap: 'break-word',
    '&:disabled': {
        cursor: 'not-allowed',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...$1d41bdd6d4af3ac2$var$overrideSafariDisabledStyles
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&::-ms-clear': {
        display: 'none'
    },
    '&:invalid': {
        boxShadow: 'none'
    }
});
const $1d41bdd6d4af3ac2$export$bff8031d86bb089 = ({ minimumRows: minimumRows, resize: resize, appearance: appearance, isMonospaced: isMonospaced, maxHeight: maxHeight })=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $1d41bdd6d4af3ac2$var$staticStyles, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $1d41bdd6d4af3ac2$var$borderPaddingAndHeightStyles(minimumRows, appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $1d41bdd6d4af3ac2$var$resizeStyle(resize), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $1d41bdd6d4af3ac2$var$borderStyle(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $1d41bdd6d4af3ac2$var$fontFamilyStyle(isMonospaced), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    {
        maxHeight: maxHeight
    });
const $1d41bdd6d4af3ac2$export$98856a888ef36079 = (appearance)=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $1d41bdd6d4af3ac2$var$bgAndBorderColorStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $1d41bdd6d4af3ac2$var$hoverBackgroundAndBorderStyles(appearance), // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    $1d41bdd6d4af3ac2$var$placeholderStyles, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        color: $fv5VI.textColor,
        '&:disabled': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            color: $1d41bdd6d4af3ac2$var$disabledRules.textColor
        }
    });

});
parcelRegister("fv5VI", function(module, exports) {

$parcel$export(module.exports, "disabledBackground", () => $35619dad3634ae4d$export$ae3cba7672df0890);
$parcel$export(module.exports, "disabledBorder", () => $35619dad3634ae4d$export$fe505fe3c5edbdf6);
$parcel$export(module.exports, "invalidBorderColor", () => $35619dad3634ae4d$export$7f333bbf7ddab792);
$parcel$export(module.exports, "defaultBorderColor", () => $35619dad3634ae4d$export$dafd83031c202ca8);
$parcel$export(module.exports, "defaultBorderColorFocus", () => $35619dad3634ae4d$export$e8320c09dc1e4012);
$parcel$export(module.exports, "defaultBackgroundColor", () => $35619dad3634ae4d$export$b13414ee9ac9cae6);
$parcel$export(module.exports, "defaultBackgroundColorHover", () => $35619dad3634ae4d$export$bca15982c103d57b);
$parcel$export(module.exports, "defaultBackgroundColorFocus", () => $35619dad3634ae4d$export$21287e4b7f134f09);
$parcel$export(module.exports, "subtleBorderColorHover", () => $35619dad3634ae4d$export$a87538d56ee366ec);
$parcel$export(module.exports, "placeholderTextColor", () => $35619dad3634ae4d$export$5e076b2557ef7bbb);
$parcel$export(module.exports, "textColor", () => $35619dad3634ae4d$export$32f78bffcd82ff28);
$parcel$export(module.exports, "disabledTextColor", () => $35619dad3634ae4d$export$eb4a7d363eec53c8);
$parcel$export(module.exports, "transparent", () => $35619dad3634ae4d$export$f4d082c200a4b4b8);

const $35619dad3634ae4d$export$ae3cba7672df0890 = `var(--ds-background-disabled, ${(0, $ab6d6432a4c55680$export$9fdfb749e33cdf97)})`;
const $35619dad3634ae4d$export$fe505fe3c5edbdf6 = `var(--ds-border-disabled, ${(0, $ab6d6432a4c55680$export$1ce2d1575d444ceb)})`;
const $35619dad3634ae4d$export$7f333bbf7ddab792 = `var(--ds-border-danger, ${(0, $ab6d6432a4c55680$export$2010d0fb4295b346)})`;
const $35619dad3634ae4d$export$dafd83031c202ca8 = `var(--ds-border-input, ${(0, $ab6d6432a4c55680$export$d6447c357493214f)})`;
const $35619dad3634ae4d$export$e8320c09dc1e4012 = `var(--ds-border-focused, ${(0, $ab6d6432a4c55680$export$215b7063051591f1)})`;
const $35619dad3634ae4d$export$b13414ee9ac9cae6 = `var(--ds-background-input, ${(0, $ab6d6432a4c55680$export$e655ef011c4aa1a2)})`;
const $35619dad3634ae4d$export$bca15982c103d57b = `var(--ds-background-input-hovered, ${(0, $ab6d6432a4c55680$export$3e51e8f1440314ba)})`;
const $35619dad3634ae4d$export$21287e4b7f134f09 = `var(--ds-background-input-pressed, ${(0, $ab6d6432a4c55680$export$29a4f05edc054374)})`;
const $35619dad3634ae4d$export$a87538d56ee366ec = "var(--ds-border-input, transparent)";
const $35619dad3634ae4d$export$5e076b2557ef7bbb = `var(--ds-text-subtlest, ${(0, $ab6d6432a4c55680$export$f563ee71e9ee74cd)})`;
const $35619dad3634ae4d$export$32f78bffcd82ff28 = `var(--ds-text, ${(0, $ab6d6432a4c55680$export$fbda843f0a27fe96)})`;
const $35619dad3634ae4d$export$eb4a7d363eec53c8 = `var(--ds-text-disabled, ${(0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de)})`;
const $35619dad3634ae4d$export$f4d082c200a4b4b8 = 'transparent';

});



parcelRegister("c6afX", function(module, exports) {

$parcel$export(module.exports, "IntlProviderWithResolvedMessages", () => $fd678167d0056e01$export$f793de1293176fe6);

var $eUqFw = parcelRequire("eUqFw");

var $3dpxL = parcelRequire("3dpxL");

var $ljYj9 = parcelRequire("ljYj9");
const $fd678167d0056e01$export$f793de1293176fe6 = ({ children: children, locale: locale })=>{
    const [resolvedMessagesForLocale, setResolvedMessagesForLocale] = (0, $eUqFw.useState)();
    (0, $eUqFw.useEffect)(()=>{
        const fetchMessageLocale = async ()=>{
            if (locale) {
                const messages = await (0, $ljYj9.getMessagesForLocale)(locale);
                setResolvedMessagesForLocale(messages);
            }
        };
        fetchMessageLocale();
    }, [
        locale
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $3dpxL.default), {
        locale: locale || 'en',
        defaultLocale: "en",
        messages: resolvedMessagesForLocale
    }, children);
};

});
parcelRegister("ljYj9", function(module, exports) {

$parcel$export(module.exports, "getMessagesForLocale", () => $aff76e6abbd86eae$export$d0a3169680473b6c);
/**
 * Tries to get the most specific messages bundle for a given locale.
 *
 * Strategy:
 * 1. Try to find messages with the exact string (i.e. 'fr_FR')
 * 2. If that doesn't work, try to find messages for the country locale (i.e. 'fr')
 * 3. If that doesn't work, return english messages as a fallback.
 *
 * @param locale string specifying the locale like 'en_GB', or 'fr'.
 */ const $aff76e6abbd86eae$export$d0a3169680473b6c = async (locale)=>{
    locale = locale.replace('-', '_');
    try {
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${locale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
    try {
        const parentLocale = locale.split(/[-_]/)[0];
        const messages = await import(/* webpackChunkName: "@atlaskit-internal_feedback-collector/i18n-tranlations" */ `../i18n/${parentLocale}`);
        return messages.default;
    } catch (e) {
    // ignore
    }
};

});




parcelRegister("1zLik", function(module, exports) {

$parcel$export(module.exports, "default", () => $28959ac0cd1828d6$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $5JgJ2 = parcelRequire("5JgJ2");

var $b720H = parcelRequire("b720H");

var $1ipEC = parcelRequire("1ipEC");


var $8NP3j = parcelRequire("8NP3j");

var $c6afX = parcelRequire("c6afX");
const $28959ac0cd1828d6$var$FeedbackFlag = ({ description: description, title: title })=>{
    const { formatMessage: formatMessage } = (0, $5JgJ2.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $b720H.default), {
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1ipEC))), {
            spacing: "spacious",
            color: `var(--ds-icon-success, ${(0, $ab6d6432a4c55680$export$940e1f69e873f202)})`,
            label: "Success"
        }),
        id: "feedbackSent",
        description: description || formatMessage((0, $8NP3j.messages).feedbackSuccessFlagDescription),
        title: title || formatMessage((0, $8NP3j.messages).feedbackSuccessFlagTitle)
    });
};
const $28959ac0cd1828d6$var$FeedbackFlagWithIntl = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c6afX.IntlProviderWithResolvedMessages), {
        locale: props.locale
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($28959ac0cd1828d6$var$FeedbackFlag, props));
var $28959ac0cd1828d6$export$2e2bcd8739ae039 = $28959ac0cd1828d6$var$FeedbackFlagWithIntl;

});
parcelRegister("1ipEC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9b4b1d8f8ae82590ab9e3b231233297b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0f1b5f41105ac9c2$var$_react = $0f1b5f41105ac9c2$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $0f1b5f41105ac9c2$var$_success = $0f1b5f41105ac9c2$var$_interopRequireDefault((parcelRequire("iMOte")));

var $0f1b5f41105ac9c2$var$_checkCircle = $0f1b5f41105ac9c2$var$_interopRequireDefault((parcelRequire("3XolV")));
function $0f1b5f41105ac9c2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "CheckCircleIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single-purpose - Reserved for success section messages and form validation messages.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0f1b5f41105ac9c2$var$SuccessIcon = (props)=>/*#__PURE__*/ $0f1b5f41105ac9c2$var$_react.default.createElement($0f1b5f41105ac9c2$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $0f1b5f41105ac9c2$var$_checkCircle.default
    }, props));
$0f1b5f41105ac9c2$var$SuccessIcon.Name = 'SuccessIconMigration';
var $0f1b5f41105ac9c2$var$_default = module.exports.default = $0f1b5f41105ac9c2$var$SuccessIcon;

});




parcelRegister("15DZ6", function(module, exports) {

$parcel$export(module.exports, "getMatchPath", () => $0cb54630b299b6cd$export$d2c621fc69413375);
$parcel$export(module.exports, "resolveCurrentRoute", () => $0cb54630b299b6cd$export$bb371194713ec10c);
$parcel$export(module.exports, "getUrlParams", () => $0cb54630b299b6cd$export$1061071041ba84d4);
$parcel$export(module.exports, "getLocationPath", () => $0cb54630b299b6cd$export$3cb209e120f6c244);

var $kt9Cs = parcelRequire("kt9Cs");

var $1d3eD = parcelRequire("1d3eD");

var $40nqT = parcelRequire("40nqT");

var $bPtM5 = parcelRequire("bPtM5");
const $0cb54630b299b6cd$var$ensureLeadingSlashOnly = (path)=>"/".concat(path.split('/').filter((fragment)=>!!fragment).join('/'));
const $0cb54630b299b6cd$var$stripMountPath = (path, mountPath)=>$0cb54630b299b6cd$var$ensureLeadingSlashOnly(path.replace(mountPath, '/'));
const $0cb54630b299b6cd$export$d2c621fc69413375 = (_ref)=>{
    let { locationPath: locationPath, routePath: routePath, mountPath: mountPath } = _ref;
    return (0, $1d3eD.default)($0cb54630b299b6cd$var$stripMountPath(locationPath, mountPath), {
        path: routePath,
        exact: true,
        strict: false
    });
};
const $0cb54630b299b6cd$export$bb371194713ec10c = (currentPath, mountPath)=>(0, $40nqT.allRoutes).find((r)=>$0cb54630b299b6cd$export$d2c621fc69413375({
            locationPath: currentPath,
            routePath: r.path,
            mountPath: mountPath
        }));
const $0cb54630b299b6cd$export$1061071041ba84d4 = ()=>(0, (/*@__PURE__*/$parcel$interopDefault($kt9Cs))).parse((0, $bPtM5.isEmceeConnect)() ? window.location.hash.split('?')[1] : window.location.search);
const $0cb54630b299b6cd$export$3cb209e120f6c244 = ()=>(0, $bPtM5.isEmceeConnect)() ? window.location.hash.split('#')[1].split('?')[0] : window.location.pathname.split('/marketplace').pop();

});


parcelRegister("9nPW9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d4e8ca19584484a$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $jqNEH = parcelRequire("jqNEH");

var $3UXZ8 = parcelRequire("3UXZ8");

var $4tYgg = parcelRequire("4tYgg");

var $fyH4h = parcelRequire("fyH4h");

var $9l6Pq = parcelRequire("9l6Pq");

var $6FLom = parcelRequire("6FLom");
var $5R3bL = parcelRequire("5R3bL");
var $lbqa4 = parcelRequire("lbqa4");

var $kwzYh = parcelRequire("kwzYh");
var $eibaj = parcelRequire("eibaj");

var $fUOHe = parcelRequire("fUOHe");

var $beqRW = parcelRequire("beqRW");
var $eGn88 = parcelRequire("eGn88");

var $kO6Ah = parcelRequire("kO6Ah");

var $9fEFB = parcelRequire("9fEFB");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $aaXr0 = parcelRequire("aaXr0");

var $119Qg = parcelRequire("119Qg");

var $15DZ6 = parcelRequire("15DZ6");

var $jHg79 = parcelRequire("jHg79");

var $fwA2m = parcelRequire("fwA2m");

var $lHkHI = parcelRequire("lHkHI");
var $6d4e8ca19584484a$var$_templateObject;
const $6d4e8ca19584484a$export$5c385d8f38f3e0c0 = (0, $3UXZ8.default)("div", {
    target: "esyxap20",
    label: "AppContainerContainer"
})("max-width:990px;width:100%;margin:11px auto 0;", (0, $kO6Ah.mediaBreakpoints).largeDown($6d4e8ca19584484a$var$_templateObject || ($6d4e8ca19584484a$var$_templateObject = (0, $jqNEH.default)([
    "padding: 0 25px;"
]))), "");
class $6d4e8ca19584484a$export$866c4507748cc3ad extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            receivedParameters: (0, $bWAru.Option).empty()
        });
        (0, $5zQU9.default)(this, "apolloClient", void 0);
        (0, $5zQU9.default)(this, "onRendered", ()=>{
            (0, $fUOHe.default).timeToFirstMeaningfulPaint(performance.now());
        });
        (0, $5zQU9.default)(this, "getRouteName", (pathname)=>{
            var _resolveCurrentRoute;
            return (_resolveCurrentRoute = (0, $15DZ6.resolveCurrentRoute)(pathname, this.props.mountPath)) === null || _resolveCurrentRoute === void 0 ? void 0 : _resolveCurrentRoute.analyticsSourceScreen.name;
        });
        (0, $5zQU9.default)(this, "getRouteParams", (pathname)=>{
            var _getMatchPath;
            const currentRoute = (0, $15DZ6.resolveCurrentRoute)(pathname, this.props.mountPath);
            return currentRoute !== null && currentRoute !== void 0 && currentRoute.path ? (_getMatchPath = (0, $15DZ6.getMatchPath)({
                locationPath: pathname,
                routePath: currentRoute.path,
                mountPath: this.props.mountPath
            })) === null || _getMatchPath === void 0 ? void 0 : _getMatchPath.params : null;
        });
        (0, $5zQU9.default)(this, "getApolloClient", (bootstrapConfig, statsigClient, featureFlags)=>{
            // do not create every time component renders
            if (!this.apolloClient) {
                this.apolloClient = (0, $eibaj.createApolloClient)({
                    uri: this.props.bootstrapConfig.graphQLGatewayUrl,
                    name: 'marketplace-emcee',
                    version: this.props.bootstrapConfig.releaseVersion,
                    cache: (0, $kwzYh.createApolloCache)(),
                    typeDefs: (0, $5R3bL.ClientSchema),
                    gqlOrchestratorLinkOptions: {
                        isEnabled: statsigClient.enableEmceeAetherExperience(),
                        config: (0, $lbqa4.orchestrationEmceeConfig)({
                            statsigClient: statsigClient,
                            mpacBaseUrl: bootstrapConfig.mpacBaseUrl,
                            macBaseUrl: bootstrapConfig.macBaseUrl,
                            wacBaseUrl: bootstrapConfig.wacBaseUrl,
                            stargateBaseUrl: bootstrapConfig.stargateBaseUrl,
                            featureFlags: featureFlags.getAllFlags().toJS(),
                            algoliaConfig: bootstrapConfig.algolia
                        }),
                        middlewares: [
                            new (0, $6FLom.CacheMiddleware)()
                        ]
                    }
                });
                console.log('Apollo client created');
            }
            return this.apolloClient;
        });
        // eslint-disable-next-line max-lines-per-function
        (0, $5zQU9.default)(this, "render", ()=>{
            const { bootstrapConfig: bootstrapConfig, statsigClient: statsigClient } = this.props;
            const isAetherExp = statsigClient.enableEmceeAetherExperience();
            const Wrapper = isAetherExp ? (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment : $6d4e8ca19584484a$export$5c385d8f38f3e0c0;
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $beqRW.default), {
                fallback: /*#__PURE__*/ (0, $lHkHI.jsx)("h1", {
                    children: "Something went wrong"
                }),
                boundaryName: "App",
                children: /*#__PURE__*/ (0, $lHkHI.jsx)(Wrapper, {
                    children: (0, $bWAru.Option).map5(this.props.analyticsLoadResult, this.props.hostConfig, this.props.hostInfo, this.props.featureFlags, this.props.currentUserId, (_, ehc, ehi, eff, ecuid)=>(0, $bWAru.Either).map4(ehc, ehi, eff, ecuid, (hc, hi, ff, cuid)=>{
                            const apolloClient = this.getApolloClient(bootstrapConfig, statsigClient, ff);
                            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9l6Pq.StatsigContext).Provider, {
                                value: {
                                    statsigClient: statsigClient
                                },
                                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4tYgg.ApolloProvider), {
                                    client: apolloClient,
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fyH4h.default), {
                                        loading: false,
                                        dataError: false,
                                        dataErrorMessages: (0, $g5DHJ.List)(),
                                        optimisticLoadTime: 1000,
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eGn88.default), {
                                            getRouteName: this.getRouteName,
                                            getRouteParams: this.getRouteParams,
                                            children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $aaXr0.default), {
                                                location: this.props.location,
                                                featureFlags: ff,
                                                children: [
                                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $119Qg.default), {
                                                        getRouteName: this.getRouteName
                                                    }),
                                                    /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                                                        children: this.props.selectedContext.map((sc)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
                                                            (0, $lHkHI.jsx)((0, $fwA2m.default), {
                                                                algoliaClient: this.props.algoliaClient,
                                                                bootstrapConfig: this.props.bootstrapConfig,
                                                                component: this.props.component,
                                                                currentUserId: cuid,
                                                                featureFlags: ff,
                                                                history: this.props.history,
                                                                hostConfig: hc,
                                                                hostInfo: hi,
                                                                hostPricing: this.props.hostPricing,
                                                                links: (0, $9fEFB.linkTemplates)({
                                                                    adminHubBaseUrl: this.props.bootstrapConfig.adminHubBaseUrl,
                                                                    mpacBaseUrl: this.props.bootstrapConfig.mpacBaseUrl,
                                                                    mpacCdnBaseUrl: this.props.bootstrapConfig.mpacCdnBaseUrl,
                                                                    macBaseUrl: this.props.bootstrapConfig.macBaseUrl,
                                                                    wacBaseUrl: this.props.bootstrapConfig.wacBaseUrl,
                                                                    atlassianCommunityBaseUrl: this.props.bootstrapConfig.atlassianCommunityBaseUrl
                                                                }),
                                                                onFeedbackSubmit: this.props.onFeedbackSubmit,
                                                                onRendered: this.onRendered,
                                                                openAppSpecificPasswordDialog: this.props.openAppSpecificPasswordDialog,
                                                                openInstallDialog: this.props.openInstallDialog,
                                                                receivedParameters: this.state.receivedParameters,
                                                                retrieveFreshInstalledApps: this.props.retrieveFreshInstalledApps,
                                                                selectedContext: sc,
                                                                onBootstrapConfigChange: this.props.onBootstrapConfigChange
                                                            })).orNull()
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            });
                        }).fold((errs)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $fyH4h.default), {
                                loading: false,
                                dataError: true,
                                dataErrorMessages: errs,
                                optimisticLoadTime: 1000,
                                children: null
                            }), (value)=>value)).getOrElseL(()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $fyH4h.default), {
                            loading: true,
                            dataError: false,
                            dataErrorMessages: (0, $g5DHJ.List)(),
                            optimisticLoadTime: 1000,
                            children: null
                        }))
                })
            });
        });
    }
    componentDidMount() {
        this.props.initializeBaseData({
            statsigClientMpac: this.props.statsigClient
        });
    }
}
var $6d4e8ca19584484a$export$2e2bcd8739ae039 = (0, $jHg79.withMountPath)($6d4e8ca19584484a$export$866c4507748cc3ad);

});
parcelRegister("4tYgg", function(module, exports) {

$parcel$export(module.exports, "ApolloProvider", () => $34389d85a7585d5d$export$c16b04c8a9956446);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("4cpTA");
var $4FQap = parcelRequire("4FQap");

var $a1fq9 = parcelRequire("a1fq9");

var $ktrpW = parcelRequire("ktrpW");
var $34389d85a7585d5d$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = (0, $ktrpW.getApolloContext)();
    var parentContext = $a1fq9.useContext(ApolloContext);
    var context = $a1fq9.useMemo(function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, parentContext), {
            client: client || parentContext.client
        });
    }, [
        parentContext,
        client
    ]);
    (0, $4FQap.invariant)(context.client, 46);
    return $a1fq9.createElement(ApolloContext.Provider, {
        value: context
    }, children);
};

});
parcelRegister("4cpTA", function(module, exports) {

$parcel$export(module.exports, "maybe", () => (parcelRequire("6f3A1")).maybe);
$parcel$export(module.exports, "global", () => (parcelRequire("8Pk3B")).default);
$parcel$export(module.exports, "invariant", () => (parcelRequire("4FQap")).invariant);

var $4FQap = parcelRequire("4FQap");

var $6f3A1 = parcelRequire("6f3A1");

var $8Pk3B = parcelRequire("8Pk3B");
var $30ec5eb9775d05b9$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;

});
parcelRegister("4FQap", function(module, exports) {

$parcel$export(module.exports, "invariant", () => $367374ffd8f75c0d$export$f5708dca728d7177);

var $bMXb2 = parcelRequire("bMXb2");

var $6HcCA = parcelRequire("6HcCA");

var $8Pk3B = parcelRequire("8Pk3B");

var $alhYa = parcelRequire("alhYa");
function $367374ffd8f75c0d$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = $367374ffd8f75c0d$var$getHandledErrorMsg(arg0);
            if (!message) {
                message = $367374ffd8f75c0d$var$getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var $367374ffd8f75c0d$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $bMXb2.invariant)(condition, $367374ffd8f75c0d$var$getHandledErrorMsg(message, args) || $367374ffd8f75c0d$var$getFallbackErrorMsg(message, args));
}, {
    debug: $367374ffd8f75c0d$var$wrap((0, $bMXb2.invariant).debug),
    log: $367374ffd8f75c0d$var$wrap((0, $bMXb2.invariant).log),
    warn: $367374ffd8f75c0d$var$wrap((0, $bMXb2.invariant).warn),
    error: $367374ffd8f75c0d$var$wrap((0, $bMXb2.invariant).error)
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */ function $367374ffd8f75c0d$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $bMXb2.InvariantError)($367374ffd8f75c0d$var$getHandledErrorMsg(message, optionalParams) || $367374ffd8f75c0d$var$getFallbackErrorMsg(message, optionalParams));
}
var $367374ffd8f75c0d$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $6HcCA.version));
function $367374ffd8f75c0d$var$stringify(arg) {
    return typeof arg == "string" ? arg : (0, $alhYa.stringifyForDisplay)(arg, 2).slice(0, 1000);
}
function $367374ffd8f75c0d$var$getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, $8Pk3B.default)[$367374ffd8f75c0d$export$b8ca975fa04efdf3] && (0, $8Pk3B.default)[$367374ffd8f75c0d$export$b8ca975fa04efdf3](message, messageArgs.map($367374ffd8f75c0d$var$stringify));
}
function $367374ffd8f75c0d$var$getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $6HcCA.version),
        message: message,
        args: messageArgs.map($367374ffd8f75c0d$var$stringify)
    })));
}

});
parcelRegister("bMXb2", function(module, exports) {

$parcel$export(module.exports, "InvariantError", () => $895214b787ac8534$export$cea12affaee22fe8);
$parcel$export(module.exports, "invariant", () => $895214b787ac8534$export$f5708dca728d7177);

var $fKE23 = parcelRequire("fKE23");
var $895214b787ac8534$var$genericMessage = "Invariant Violation";
var $895214b787ac8534$var$_a = Object.setPrototypeOf, $895214b787ac8534$var$setPrototypeOf = $895214b787ac8534$var$_a === void 0 ? function(obj, proto) {
    obj.__proto__ = proto;
    return obj;
} : $895214b787ac8534$var$_a;
var $895214b787ac8534$export$cea12affaee22fe8 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(InvariantError, _super);
    function InvariantError(message) {
        if (message === void 0) message = $895214b787ac8534$var$genericMessage;
        var _this = _super.call(this, typeof message === "number" ? $895214b787ac8534$var$genericMessage + ": " + message + " (see https://github.com/apollographql/invariant-packages)" : message) || this;
        _this.framesToPop = 1;
        _this.name = $895214b787ac8534$var$genericMessage;
        $895214b787ac8534$var$setPrototypeOf(_this, InvariantError.prototype);
        return _this;
    }
    return InvariantError;
}(Error);
function $895214b787ac8534$export$f5708dca728d7177(condition, message) {
    if (!condition) throw new $895214b787ac8534$export$cea12affaee22fe8(message);
}
var $895214b787ac8534$var$verbosityLevels = [
    "debug",
    "log",
    "warn",
    "error",
    "silent"
];
var $895214b787ac8534$var$verbosityLevel = $895214b787ac8534$var$verbosityLevels.indexOf("log");
function $895214b787ac8534$var$wrapConsoleMethod(name) {
    return function() {
        if ($895214b787ac8534$var$verbosityLevels.indexOf(name) >= $895214b787ac8534$var$verbosityLevel) {
            // Default to console.log if this host environment happens not to provide
            // all the console.* methods we need.
            var method = console[name] || console.log;
            return method.apply(console, arguments);
        }
    };
}
(function(invariant) {
    invariant.debug = $895214b787ac8534$var$wrapConsoleMethod("debug");
    invariant.log = $895214b787ac8534$var$wrapConsoleMethod("log");
    invariant.warn = $895214b787ac8534$var$wrapConsoleMethod("warn");
    invariant.error = $895214b787ac8534$var$wrapConsoleMethod("error");
})($895214b787ac8534$export$f5708dca728d7177 || ($895214b787ac8534$export$f5708dca728d7177 = {}));
function $895214b787ac8534$export$a80e09f2cd325fb8(level) {
    var old = $895214b787ac8534$var$verbosityLevels[$895214b787ac8534$var$verbosityLevel];
    $895214b787ac8534$var$verbosityLevel = Math.max(0, $895214b787ac8534$var$verbosityLevels.indexOf(level));
    return old;
}
var $895214b787ac8534$export$2e2bcd8739ae039 = $895214b787ac8534$export$f5708dca728d7177;

});

parcelRegister("6HcCA", function(module, exports) {

$parcel$export(module.exports, "version", () => $4e008c91aabebd2b$export$83d89fbfd8236492);
var $4e008c91aabebd2b$export$83d89fbfd8236492 = "3.9.7";

});

parcelRegister("8Pk3B", function(module, exports) {

$parcel$export(module.exports, "default", () => $66d2a50e183290a7$export$2e2bcd8739ae039);

var $6f3A1 = parcelRequire("6f3A1");
var $66d2a50e183290a7$export$2e2bcd8739ae039 = (0, $6f3A1.maybe)(function() {
    return globalThis;
}) || (0, $6f3A1.maybe)(function() {
    return window;
}) || (0, $6f3A1.maybe)(function() {
    return self;
}) || (0, $6f3A1.maybe)(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, $6f3A1.maybe)(function() {
    return (0, $6f3A1.maybe).constructor("return this")();
});

});
parcelRegister("6f3A1", function(module, exports) {

$parcel$export(module.exports, "maybe", () => $48b6ebb4a928a193$export$f8b8b9ce72e9ccbf);
function $48b6ebb4a928a193$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}

});


parcelRegister("alhYa", function(module, exports) {

$parcel$export(module.exports, "stringifyForDisplay", () => $7879cded44181f61$export$f341b4883239463f);

var $4SIui = parcelRequire("4SIui");
function $7879cded44181f61$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $4SIui.makeUniqueId)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}

});
parcelRegister("4SIui", function(module, exports) {

$parcel$export(module.exports, "makeUniqueId", () => $38deb6e105712402$export$d0c8ec0fe1b18b70);
var $38deb6e105712402$var$prefixCounts = new Map();
function $38deb6e105712402$export$d0c8ec0fe1b18b70(prefix) {
    var count = $38deb6e105712402$var$prefixCounts.get(prefix) || 1;
    $38deb6e105712402$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}

});




parcelRegister("a1fq9", function(module, exports) {
"use strict";

module.exports = (parcelRequire("eUqFw"));

});

parcelRegister("ktrpW", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $ee7bc8a1bd0ebeaf$export$a47505d961ee3a1);

var $a1fq9 = parcelRequire("a1fq9");

var $bSld1 = parcelRequire("bSld1");
parcelRequire("4cpTA");
var $4FQap = parcelRequire("4FQap");
// To make sure Apollo Client doesn't create more than one React context
// (which can lead to problems like having an Apollo Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Apollo context is created and tracked in global state.
var $ee7bc8a1bd0ebeaf$var$contextKey = (0, $bSld1.canUseSymbol) ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function $ee7bc8a1bd0ebeaf$export$a47505d961ee3a1() {
    (0, $4FQap.invariant)("createContext" in $a1fq9, 45);
    var context = $a1fq9.createContext[$ee7bc8a1bd0ebeaf$var$contextKey];
    if (!context) {
        Object.defineProperty($a1fq9.createContext, $ee7bc8a1bd0ebeaf$var$contextKey, {
            value: context = $a1fq9.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
var $ee7bc8a1bd0ebeaf$export$c2ee824bcc89ca6a = $ee7bc8a1bd0ebeaf$export$a47505d961ee3a1;

});
parcelRegister("bSld1", function(module, exports) {

$parcel$export(module.exports, "canUseWeakMap", () => $8a553089317201df$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "canUseSymbol", () => $8a553089317201df$export$23ba675b4b838b92);
$parcel$export(module.exports, "canUseLayoutEffect", () => $8a553089317201df$export$4001f6cd4a62405b);
parcelRequire("4cpTA");
var $6f3A1 = parcelRequire("6f3A1");
var $8a553089317201df$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && !(0, $6f3A1.maybe)(function() {
    return navigator.product == "ReactNative" && !$parcel$global.HermesInternal;
});
var $8a553089317201df$export$7293b8a0b474028d = typeof WeakSet === "function";
var $8a553089317201df$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $8a553089317201df$export$c34f882e9f1c1637 = $8a553089317201df$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $8a553089317201df$export$71594e8a50f746f4 = typeof (0, $6f3A1.maybe)(function() {
    return window.document.createElement;
}) === "function";
var $8a553089317201df$var$usingJSDOM = // Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0, $6f3A1.maybe)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $8a553089317201df$export$4001f6cd4a62405b = $8a553089317201df$export$71594e8a50f746f4 && !$8a553089317201df$var$usingJSDOM;

});



parcelRegister("6FLom", function(module, exports) {

$parcel$export(module.exports, "CacheMiddleware", () => $4dbb55728959cfd5$export$4da5bc5d057d8dc1);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("eayTI");
var $8E6bd = parcelRequire("8E6bd");

var $hm1yd = parcelRequire("hm1yd");
var $fFpaQ = parcelRequire("fFpaQ");
// Middleware configuration
/**
 * null means cache is not set
 * false means cache is set but data was fetched from somewhere
 * true means cache is set and data is served from the cache.
 */ class $4dbb55728959cfd5$export$4da5bc5d057d8dc1 extends (0, $hm1yd.BaseMiddleware) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "cacheMap", new Map());
        (0, $5zQU9.default)(this, "cacheStatusMap", new WeakMap());
    }
    static isDataFromCache(context, operation) {
        const cacheMiddlewareContext = context[$4dbb55728959cfd5$export$4da5bc5d057d8dc1.key];
        return cacheMiddlewareContext.cacheStatusMap.get(operation);
    }
    init(context) {
        this.cacheMap = new Map();
        context[this.getKey()] = {
            cacheMap: this.cacheMap,
            cacheStatusMap: this.cacheStatusMap
        };
    }
    getKey() {
        return $4dbb55728959cfd5$export$4da5bc5d057d8dc1.key;
    }
    withCache(onCacheHit, onCacheMiss, defaultHandling, config, operation, path) {
        // after cleanup only ttlMs compliant data would be left
        this.cleanup();
        this.setCacheStatus(operation, path);
        if (config && typeof config.ttlMs === 'number' && typeof config.cacheKey === 'function') {
            const { cacheKey: cacheKey } = config;
            const key = this.getCacheKey(operation, cacheKey, path);
            const cachedStore = this.cache.get(key);
            if (cachedStore) {
                // cache hit
                this.setCacheStatus(operation, path, true);
                return onCacheHit(cachedStore, key, config);
            }
            // cache miss
            this.setCacheStatus(operation, path, false);
            return onCacheMiss(undefined, key, config);
        }
        return defaultHandling();
    }
    onFetchPrimary(args, callbackFn, _context, middlewareConfig) {
        const { primary: primary } = middlewareConfig;
        const [operation] = args;
        return this.withCache(// on cache hit
        (cachedStore)=>(0, $8E6bd.Observable).of(cachedStore === null || cachedStore === void 0 ? void 0 : cachedStore.primaryData), // on cache miss
        (_, key, config)=>{
            const observable = callbackFn(...args);
            return new (0, $8E6bd.Observable)((observer)=>{
                observable.subscribe({
                    // evict own and custom cache on API failure.
                    error: (err)=>{
                        this.forceCleanRelatedCache(operation, middlewareConfig);
                        observer.error(err);
                    },
                    next: (primaryData)=>{
                        this.cache.set(key, {
                            primaryData: primaryData,
                            endTime: Date.now() + config.ttlMs
                        });
                        observer.next(primaryData);
                    },
                    complete () {
                        observer.complete();
                    }
                });
            });
        }, // default handling
        ()=>callbackFn(...args), primary, operation, (0, $fFpaQ.Path).PRIMARY);
    }
    onFetchCustom(args, callbackFn, _context, middlewareConfig) {
        const { custom: custom } = middlewareConfig;
        const [operation] = args;
        return this.withCache(// on cache hit
        (cachedStore)=>Promise.resolve(cachedStore === null || cachedStore === void 0 ? void 0 : cachedStore.customData), // on cache miss
        (_, key, config)=>{
            const promise = callbackFn(...args);
            promise.then((customData)=>{
                this.cache.set(key, {
                    customData: customData,
                    endTime: Date.now() + config.ttlMs
                });
                return customData;
            }, ()=>this.forceCleanRelatedCache(operation, middlewareConfig));
            return promise;
        }, // default handling
        ()=>callbackFn(...args), custom, operation, (0, $fFpaQ.Path).CUSTOM);
    }
    get cache() {
        return this.cacheMap;
    }
    forceCleanRelatedCache(operation, middlewareConfig) {
        const primary = middlewareConfig.primary;
        if (primary && typeof primary.ttlMs === 'number' && typeof primary.cacheKey === 'function') {
            const key = this.getCacheKey(operation, primary.cacheKey, (0, $fFpaQ.Path).PRIMARY);
            this.cache.delete(key);
        }
        const custom = middlewareConfig.custom;
        if (custom && typeof custom.ttlMs === 'number' && typeof custom.cacheKey === 'function') {
            const key = this.getCacheKey(operation, custom.cacheKey, (0, $fFpaQ.Path).CUSTOM);
            this.cache.delete(key);
        }
    }
    setCacheStatus(operation, type) {
        let status = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
        let statusMap = this.cacheStatusMap.get(operation);
        if (!statusMap) statusMap = {
            [(0, $fFpaQ.Path).PRIMARY]: null,
            [(0, $fFpaQ.Path).CUSTOM]: null
        };
        statusMap[type] = status;
        this.cacheStatusMap.set(operation, statusMap);
    }
    cleanup() {
        if (this.cache.size === 0) return;
        const toBeDeleted = [];
        this.cache.forEach((value, key)=>{
            if (value.endTime < Date.now()) toBeDeleted.push(key);
        });
        toBeDeleted.forEach((key)=>this.cache.delete(key));
    }
    getCacheKey(operation, cacheKey, type) {
        return "".concat(operation.operationName, "_:").concat(type, ":_").concat(cacheKey(operation));
    }
}
(0, $5zQU9.default)($4dbb55728959cfd5$export$4da5bc5d057d8dc1, "key", 'cache');

});
parcelRegister("eayTI", function(module, exports) {

$parcel$export(module.exports, "Observable", () => (parcelRequire("8E6bd")).Observable);

var $8E6bd = parcelRequire("8E6bd");
parcelRequire("iLvoZ");
// The zen-observable package defines Observable.prototype[Symbol.observable]
// when Symbol is supported, but RxJS interop depends on also setting this fake
// '@@observable' string as a polyfill for Symbol.observable.
var $a50d11d396d979db$var$prototype = (0, $8E6bd.Observable).prototype;
var $a50d11d396d979db$var$fakeObsSymbol = "@@observable";
if (!$a50d11d396d979db$var$prototype[$a50d11d396d979db$var$fakeObsSymbol]) // @ts-expect-error
$a50d11d396d979db$var$prototype[$a50d11d396d979db$var$fakeObsSymbol] = function() {
    return this;
};

});
parcelRegister("8E6bd", function(module, exports) {

$parcel$export(module.exports, "Observable", () => $64b6da5ce8a710a6$export$77cea355fa80b5f4);
function $64b6da5ce8a710a6$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $64b6da5ce8a710a6$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $64b6da5ce8a710a6$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $64b6da5ce8a710a6$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $64b6da5ce8a710a6$var$_arrayLikeToArray(o, minLen);
}
function $64b6da5ce8a710a6$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $64b6da5ce8a710a6$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $64b6da5ce8a710a6$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $64b6da5ce8a710a6$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $64b6da5ce8a710a6$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
// === Symbol Support ===
var $64b6da5ce8a710a6$var$hasSymbols = function() {
    return typeof Symbol === 'function';
};
var $64b6da5ce8a710a6$var$hasSymbol = function(name) {
    return $64b6da5ce8a710a6$var$hasSymbols() && Boolean(Symbol[name]);
};
var $64b6da5ce8a710a6$var$getSymbol = function(name) {
    return $64b6da5ce8a710a6$var$hasSymbol(name) ? Symbol[name] : '@@' + name;
};
if ($64b6da5ce8a710a6$var$hasSymbols() && !$64b6da5ce8a710a6$var$hasSymbol('observable')) Symbol.observable = Symbol('observable');
var $64b6da5ce8a710a6$var$SymbolIterator = $64b6da5ce8a710a6$var$getSymbol('iterator');
var $64b6da5ce8a710a6$var$SymbolObservable = $64b6da5ce8a710a6$var$getSymbol('observable');
var $64b6da5ce8a710a6$var$SymbolSpecies = $64b6da5ce8a710a6$var$getSymbol('species'); // === Abstract Operations ===
function $64b6da5ce8a710a6$var$getMethod(obj, key) {
    var value = obj[key];
    if (value == null) return undefined;
    if (typeof value !== 'function') throw new TypeError(value + ' is not a function');
    return value;
}
function $64b6da5ce8a710a6$var$getSpecies(obj) {
    var ctor = obj.constructor;
    if (ctor !== undefined) {
        ctor = ctor[$64b6da5ce8a710a6$var$SymbolSpecies];
        if (ctor === null) ctor = undefined;
    }
    return ctor !== undefined ? ctor : $64b6da5ce8a710a6$export$77cea355fa80b5f4;
}
function $64b6da5ce8a710a6$var$isObservable(x) {
    return x instanceof $64b6da5ce8a710a6$export$77cea355fa80b5f4; // SPEC: Brand check
}
function $64b6da5ce8a710a6$var$hostReportError(e) {
    if ($64b6da5ce8a710a6$var$hostReportError.log) $64b6da5ce8a710a6$var$hostReportError.log(e);
    else setTimeout(function() {
        throw e;
    });
}
function $64b6da5ce8a710a6$var$enqueue(fn) {
    Promise.resolve().then(function() {
        try {
            fn();
        } catch (e) {
            $64b6da5ce8a710a6$var$hostReportError(e);
        }
    });
}
function $64b6da5ce8a710a6$var$cleanupSubscription(subscription) {
    var cleanup = subscription._cleanup;
    if (cleanup === undefined) return;
    subscription._cleanup = undefined;
    if (!cleanup) return;
    try {
        if (typeof cleanup === 'function') cleanup();
        else {
            var unsubscribe = $64b6da5ce8a710a6$var$getMethod(cleanup, 'unsubscribe');
            if (unsubscribe) unsubscribe.call(cleanup);
        }
    } catch (e) {
        $64b6da5ce8a710a6$var$hostReportError(e);
    }
}
function $64b6da5ce8a710a6$var$closeSubscription(subscription) {
    subscription._observer = undefined;
    subscription._queue = undefined;
    subscription._state = 'closed';
}
function $64b6da5ce8a710a6$var$flushSubscription(subscription) {
    var queue = subscription._queue;
    if (!queue) return;
    subscription._queue = undefined;
    subscription._state = 'ready';
    for(var i = 0; i < queue.length; ++i){
        $64b6da5ce8a710a6$var$notifySubscription(subscription, queue[i].type, queue[i].value);
        if (subscription._state === 'closed') break;
    }
}
function $64b6da5ce8a710a6$var$notifySubscription(subscription, type, value) {
    subscription._state = 'running';
    var observer = subscription._observer;
    try {
        var m = $64b6da5ce8a710a6$var$getMethod(observer, type);
        switch(type){
            case 'next':
                if (m) m.call(observer, value);
                break;
            case 'error':
                $64b6da5ce8a710a6$var$closeSubscription(subscription);
                if (m) m.call(observer, value);
                else throw value;
                break;
            case 'complete':
                $64b6da5ce8a710a6$var$closeSubscription(subscription);
                if (m) m.call(observer);
                break;
        }
    } catch (e) {
        $64b6da5ce8a710a6$var$hostReportError(e);
    }
    if (subscription._state === 'closed') $64b6da5ce8a710a6$var$cleanupSubscription(subscription);
    else if (subscription._state === 'running') subscription._state = 'ready';
}
function $64b6da5ce8a710a6$var$onNotify(subscription, type, value) {
    if (subscription._state === 'closed') return;
    if (subscription._state === 'buffering') {
        subscription._queue.push({
            type: type,
            value: value
        });
        return;
    }
    if (subscription._state !== 'ready') {
        subscription._state = 'buffering';
        subscription._queue = [
            {
                type: type,
                value: value
            }
        ];
        $64b6da5ce8a710a6$var$enqueue(function() {
            return $64b6da5ce8a710a6$var$flushSubscription(subscription);
        });
        return;
    }
    $64b6da5ce8a710a6$var$notifySubscription(subscription, type, value);
}
var $64b6da5ce8a710a6$var$Subscription = /*#__PURE__*/ function() {
    function Subscription(observer, subscriber) {
        // ASSERT: observer is an object
        // ASSERT: subscriber is callable
        this._cleanup = undefined;
        this._observer = observer;
        this._queue = undefined;
        this._state = 'initializing';
        var subscriptionObserver = new $64b6da5ce8a710a6$var$SubscriptionObserver(this);
        try {
            this._cleanup = subscriber.call(undefined, subscriptionObserver);
        } catch (e) {
            subscriptionObserver.error(e);
        }
        if (this._state === 'initializing') this._state = 'ready';
    }
    var _proto = Subscription.prototype;
    _proto.unsubscribe = function unsubscribe() {
        if (this._state !== 'closed') {
            $64b6da5ce8a710a6$var$closeSubscription(this);
            $64b6da5ce8a710a6$var$cleanupSubscription(this);
        }
    };
    $64b6da5ce8a710a6$var$_createClass(Subscription, [
        {
            key: "closed",
            get: function() {
                return this._state === 'closed';
            }
        }
    ]);
    return Subscription;
}();
var $64b6da5ce8a710a6$var$SubscriptionObserver = /*#__PURE__*/ function() {
    function SubscriptionObserver(subscription) {
        this._subscription = subscription;
    }
    var _proto2 = SubscriptionObserver.prototype;
    _proto2.next = function next(value) {
        $64b6da5ce8a710a6$var$onNotify(this._subscription, 'next', value);
    };
    _proto2.error = function error(value) {
        $64b6da5ce8a710a6$var$onNotify(this._subscription, 'error', value);
    };
    _proto2.complete = function complete() {
        $64b6da5ce8a710a6$var$onNotify(this._subscription, 'complete');
    };
    $64b6da5ce8a710a6$var$_createClass(SubscriptionObserver, [
        {
            key: "closed",
            get: function() {
                return this._subscription._state === 'closed';
            }
        }
    ]);
    return SubscriptionObserver;
}();
var $64b6da5ce8a710a6$export$77cea355fa80b5f4 = /*#__PURE__*/ function() {
    function Observable(subscriber) {
        if (!(this instanceof Observable)) throw new TypeError('Observable cannot be called as a function');
        if (typeof subscriber !== 'function') throw new TypeError('Observable initializer must be a function');
        this._subscriber = subscriber;
    }
    var _proto3 = Observable.prototype;
    _proto3.subscribe = function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) observer = {
            next: observer,
            error: arguments[1],
            complete: arguments[2]
        };
        return new $64b6da5ce8a710a6$var$Subscription(observer, this._subscriber);
    };
    _proto3.forEach = function forEach(fn) {
        var _this = this;
        return new Promise(function(resolve, reject) {
            if (typeof fn !== 'function') {
                reject(new TypeError(fn + ' is not a function'));
                return;
            }
            function done() {
                subscription.unsubscribe();
                resolve();
            }
            var subscription = _this.subscribe({
                next: function(value) {
                    try {
                        fn(value, done);
                    } catch (e) {
                        reject(e);
                        subscription.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
        });
    };
    _proto3.map = function map(fn) {
        var _this2 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $64b6da5ce8a710a6$var$getSpecies(this);
        return new C(function(observer) {
            return _this2.subscribe({
                next: function(value) {
                    try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.filter = function filter(fn) {
        var _this3 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $64b6da5ce8a710a6$var$getSpecies(this);
        return new C(function(observer) {
            return _this3.subscribe({
                next: function(value) {
                    try {
                        if (!fn(value)) return;
                    } catch (e) {
                        return observer.error(e);
                    }
                    observer.next(value);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    observer.complete();
                }
            });
        });
    };
    _proto3.reduce = function reduce(fn) {
        var _this4 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $64b6da5ce8a710a6$var$getSpecies(this);
        var hasSeed = arguments.length > 1;
        var hasValue = false;
        var seed = arguments[1];
        var acc = seed;
        return new C(function(observer) {
            return _this4.subscribe({
                next: function(value) {
                    var first = !hasValue;
                    hasValue = true;
                    if (!first || hasSeed) try {
                        acc = fn(acc, value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    else acc = value;
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    if (!hasValue && !hasSeed) return observer.error(new TypeError('Cannot reduce an empty sequence'));
                    observer.next(acc);
                    observer.complete();
                }
            });
        });
    };
    _proto3.concat = function concat() {
        var _this5 = this;
        for(var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++)sources[_key] = arguments[_key];
        var C = $64b6da5ce8a710a6$var$getSpecies(this);
        return new C(function(observer) {
            var subscription;
            var index = 0;
            function startNext(next) {
                subscription = next.subscribe({
                    next: function(v) {
                        observer.next(v);
                    },
                    error: function(e) {
                        observer.error(e);
                    },
                    complete: function() {
                        if (index === sources.length) {
                            subscription = undefined;
                            observer.complete();
                        } else startNext(C.from(sources[index++]));
                    }
                });
            }
            startNext(_this5);
            return function() {
                if (subscription) {
                    subscription.unsubscribe();
                    subscription = undefined;
                }
            };
        });
    };
    _proto3.flatMap = function flatMap(fn) {
        var _this6 = this;
        if (typeof fn !== 'function') throw new TypeError(fn + ' is not a function');
        var C = $64b6da5ce8a710a6$var$getSpecies(this);
        return new C(function(observer) {
            var subscriptions = [];
            var outer = _this6.subscribe({
                next: function(value) {
                    if (fn) try {
                        value = fn(value);
                    } catch (e) {
                        return observer.error(e);
                    }
                    var inner = C.from(value).subscribe({
                        next: function(value) {
                            observer.next(value);
                        },
                        error: function(e) {
                            observer.error(e);
                        },
                        complete: function() {
                            var i = subscriptions.indexOf(inner);
                            if (i >= 0) subscriptions.splice(i, 1);
                            completeIfDone();
                        }
                    });
                    subscriptions.push(inner);
                },
                error: function(e) {
                    observer.error(e);
                },
                complete: function() {
                    completeIfDone();
                }
            });
            function completeIfDone() {
                if (outer.closed && subscriptions.length === 0) observer.complete();
            }
            return function() {
                subscriptions.forEach(function(s) {
                    return s.unsubscribe();
                });
                outer.unsubscribe();
            };
        });
    };
    _proto3[$64b6da5ce8a710a6$var$SymbolObservable] = function() {
        return this;
    };
    Observable.from = function from(x) {
        var C = typeof this === 'function' ? this : Observable;
        if (x == null) throw new TypeError(x + ' is not an object');
        var method = $64b6da5ce8a710a6$var$getMethod(x, $64b6da5ce8a710a6$var$SymbolObservable);
        if (method) {
            var observable = method.call(x);
            if (Object(observable) !== observable) throw new TypeError(observable + ' is not an object');
            if ($64b6da5ce8a710a6$var$isObservable(observable) && observable.constructor === C) return observable;
            return new C(function(observer) {
                return observable.subscribe(observer);
            });
        }
        if ($64b6da5ce8a710a6$var$hasSymbol('iterator')) {
            method = $64b6da5ce8a710a6$var$getMethod(x, $64b6da5ce8a710a6$var$SymbolIterator);
            if (method) return new C(function(observer) {
                $64b6da5ce8a710a6$var$enqueue(function() {
                    if (observer.closed) return;
                    for(var _iterator = $64b6da5ce8a710a6$var$_createForOfIteratorHelperLoose(method.call(x)), _step; !(_step = _iterator()).done;){
                        var item = _step.value;
                        observer.next(item);
                        if (observer.closed) return;
                    }
                    observer.complete();
                });
            });
        }
        if (Array.isArray(x)) return new C(function(observer) {
            $64b6da5ce8a710a6$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < x.length; ++i){
                    observer.next(x[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
        throw new TypeError(x + ' is not observable');
    };
    Observable.of = function of() {
        for(var _len2 = arguments.length, items = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)items[_key2] = arguments[_key2];
        var C = typeof this === 'function' ? this : Observable;
        return new C(function(observer) {
            $64b6da5ce8a710a6$var$enqueue(function() {
                if (observer.closed) return;
                for(var i = 0; i < items.length; ++i){
                    observer.next(items[i]);
                    if (observer.closed) return;
                }
                observer.complete();
            });
        });
    };
    $64b6da5ce8a710a6$var$_createClass(Observable, null, [
        {
            key: $64b6da5ce8a710a6$var$SymbolSpecies,
            get: function() {
                return this;
            }
        }
    ]);
    return Observable;
}();
if ($64b6da5ce8a710a6$var$hasSymbols()) Object.defineProperty($64b6da5ce8a710a6$export$77cea355fa80b5f4, Symbol('extensions'), {
    value: {
        symbol: $64b6da5ce8a710a6$var$SymbolObservable,
        hostReportError: $64b6da5ce8a710a6$var$hostReportError
    },
    configurable: true
});

});

parcelRegister("iLvoZ", function(module, exports) {
/* global window */ 
var $eXCAx = parcelRequire("eXCAx");
var root;
if (typeof self !== 'undefined') root = self;
else if (typeof window !== 'undefined') root = window;
else if (typeof $parcel$global !== 'undefined') root = $parcel$global;
else root = module;
var result = (0, $eXCAx.default)(root);
var $da94f992a09e1731$export$2e2bcd8739ae039 = result;

});
parcelRegister("eXCAx", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae44823a2a69390f$export$2e2bcd8739ae039);
function $ae44823a2a69390f$export$2e2bcd8739ae039(root) {
    var result;
    var Symbol = root.Symbol;
    if (typeof Symbol === 'function') {
        if (Symbol.observable) result = Symbol.observable;
        else {
            if (typeof Symbol.for === 'function') // This just needs to be something that won't trample other user's Symbol.for use
            // It also will guide people to the source of their issues, if this is problematic.
            // META: It's a resource locator!
            result = Symbol.for('https://github.com/benlesh/symbol-observable');
            else // Symbol.for didn't exist! The best we can do at this point is a totally 
            // unique symbol. Note that the string argument here is a descriptor, not
            // an identifier. This symbol is unique.
            result = Symbol('https://github.com/benlesh/symbol-observable');
            try {
                Symbol.observable = result;
            } catch (err) {
            // Do nothing. In some environments, users have frozen `Symbol` for security reasons,
            // if it is frozen assigning to it will throw. In this case, we don't care, because
            // they will need to use the returned value from the ponyfill.
            }
        }
    } else result = '@@observable';
    return result;
}

});



parcelRegister("hm1yd", function(module, exports) {

$parcel$export(module.exports, "BaseMiddleware", () => $ca25b1b4d51fe159$export$97bc8a51ccbbfa64);
/**
 * =======================
 *    BaseMiddleware
 * =======================
 *
 * Provides smart defaults for middlewares, all middlewares should
 * implement `getKey` method and should return a unique key.
 */ class $ca25b1b4d51fe159$export$97bc8a51ccbbfa64 {
    onRequestTransformer(args, callbackFn, _context, _middlewareConfig) {
        return callbackFn(...args);
    }
    onFetchPrimary(args, callbackFn, _context, _middlewareConfig) {
        return callbackFn(...args);
    }
    onFetchCustom(args, callbackFn, _context, _middlewareConfig) {
        return callbackFn(...args);
    }
    onResponseTransformer(args, callbackFn, _context, _middlewareConfig) {
        return callbackFn(...args);
    }
}

});

parcelRegister("fFpaQ", function(module, exports) {

$parcel$export(module.exports, "SequenceTypes", () => $b67e3656e85b21da$export$88e53662731c09b5);
$parcel$export(module.exports, "Path", () => $b67e3656e85b21da$export$4b2950bdac9b6ee9);
/**
 * Qrchestration `Sequence Types` decides in which sequence the given GQL call is resolved.
 *
 * Paths:
 * `Primary` path: means for the `GQL call` fired from the `view`, we want to pass it to the server(BFF in our case) with or without request modification.
 * `CUSTOM` path: means for the `GQL call` fired from the `view`, we don't want to pass it to the server(BFF in our case) and do some custom handling for it.
 *
 * Both of the above path can be combined in different ways to create different orchestration sequences.
 */ var $b67e3656e85b21da$export$88e53662731c09b5 = /*#__PURE__*/ function(SequenceTypes) {
    SequenceTypes["PRIMARY_ONLY"] = "PRIMARY_ONLY";
    SequenceTypes["PRIMARY_FIRST"] = "PRIMARY_FIRST";
    SequenceTypes["CUSTOM_FIRST"] = "CUSTOM_FIRST";
    SequenceTypes["PARALLEL"] = "PARALLEL";
    SequenceTypes["CUSTOM_ONLY"] = "CUSTOM_ONLY";
    return SequenceTypes;
}($b67e3656e85b21da$export$88e53662731c09b5 || {});
/**
 * IOrchestratorHandler:
 * Defines how `primary` and `custom` datas are fetched and how it is stitched together.
 */ var $b67e3656e85b21da$export$4b2950bdac9b6ee9 = /*#__PURE__*/ function(Path) {
    Path["PRIMARY"] = "PRIMARY";
    Path["CUSTOM"] = "CUSTOM";
    return Path;
}($b67e3656e85b21da$export$4b2950bdac9b6ee9 || {});

});


parcelRegister("5R3bL", function(module, exports) {
$parcel$export(module.exports, "GetMarketplaceFilters", () => (parcelRequire("et3oR")).GetMarketplaceFilters);
$parcel$export(module.exports, "GetMarketplaceSearch", () => (parcelRequire("8RqyI")).GetMarketplaceSearch);
$parcel$export(module.exports, "CacheMiddleware", () => (parcelRequire("6FLom")).CacheMiddleware);
$parcel$export(module.exports, "AppInstallPermission", () => (parcelRequire("c0UlX")).AppInstallPermission);
$parcel$export(module.exports, "isCompatibleMarketplaceProduct", () => (parcelRequire("1oMwC")).isCompatibleMarketplaceProduct);

$parcel$export(module.exports, "ClientSchema", () => $4434603ae7d98986$export$bf57708a85b8c0a4);


var $lbqa4 = parcelRequire("lbqa4");
parcelRequire("et3oR");parcelRequire("8RqyI");
parcelRequire("6FLom");


var $6u78H = parcelRequire("6u78H");
parcelRequire("c0UlX");
parcelRequire("1oMwC");

var $4434603ae7d98986$export$bf57708a85b8c0a4 = "\"\"\"\nClient Side GQL schema:\nGQL Schema targeted for DLA is defined in this file.\n\"\"\"\nscalar FormData\nscalar BooleanOrString\n\ninterface Error {\n  message: String!\n}\n\ntype Programs {\n  cloudFortified: CloudFortified\n  bugBountyParticipant: BugBountyParticipant\n}\n\ntype CloudFortified {\n  status: String\n}\n\ntype BugBountyParticipant {\n  cloud: BugBountyStatus\n  server: BugBountyStatus\n  dataCenter: BugBountyStatus\n}\n\ntype BugBountyStatus {\n  status: String\n}\n\ntype Vendor {\n  id: Int!\n  name: String!\n  partnerTier: PartnerTier\n}\n\ntype PartnerTier {\n  type: String\n}\n\n# eslint-disable-next-line @graphql-eslint/strict-id-in-types\ntype MarketingTags {\n  marketingLabels: [String]\n}\n\ntype AppTile {\n  id: ID!\n  addonId: Int!\n  addonKey: String\n  name: String\n  tagLine: String\n  deployments: [String]\n  documentType: String\n  marketingLabels: [String]\n  tags: MarketingTags\n  logo: Logo\n  releaseDate: Int\n  ratings: Ratings\n  distribution: Distribution\n  programs: Programs\n  vendor: Vendor\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  _highlightResult: _HighlightResult\n}\n\n# eslint-disable-next-line @graphql-eslint/naming-convention\ntype _HighlightResult {\n  name: HighlightResult\n  tokenizedName: [HighlightResult]\n  tagLine: HighlightResult\n  tokenizedTagLine: [HighlightResult]\n}\n\ntype HighlightResult {\n  value: String\n  matchLevel: String\n}\n\ntype Logo {\n  highRes: String\n  image: String\n}\n\ntype Ratings {\n  avgStars: Float\n  numRatings: Float\n}\n\ntype Distribution {\n  activeInstalls: Int\n  downloads: Int\n  bundled: Boolean\n}\n\ntype AppTileEdge {\n  node: AppTile!\n}\n\ntype AppConnectionPageInfo {\n  hasNextPage: Boolean!\n  totalCount: Int!\n}\n\ntype AppsConnection {\n  edges: [AppTileEdge!]\n  pageInfo: AppConnectionPageInfo!\n}\n\n# eslint-disable-next-line @graphql-eslint/strict-id-in-types\ntype TitleLogo {\n  imageUrl: String\n  selfImageHref: String\n}\n\nenum FilterId {\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  product\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  hosting\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  price\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  trustSignals\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  categories\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  useCases\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  other\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  versionHistoryHosting\n}\n\ntype MarketplaceFilterOption {\n  id: ID!\n  label: String!\n  value: String!\n  description: String\n  resultsCount: Int\n}\n\n# eslint-disable-next-line @graphql-eslint/strict-id-in-types\ntype MarketplaceFilterOptions {\n  filterId: FilterId!\n  options: [MarketplaceFilterOption!]!\n}\n\ntype MarketplaceSearchFilterError implements Error {\n  filterId: FilterId!\n  message: String!\n}\n\nunion MarketplaceFilterOptionResult = MarketplaceFilterOptions | MarketplaceSearchFilterError\n\ninput FilterOptionsInput {\n  label: String!\n  id: String\n  value: String!\n  description: String\n  resultsCount: Int\n  # icon?: React.ReactNode;\n}\n\ninput FiltersInput {\n  product: [FilterOptionsInput]\n  hosting: [FilterOptionsInput]\n  price: [FilterOptionsInput]\n  trustSignals: [FilterOptionsInput]\n  categories: [FilterOptionsInput]\n  useCases: [FilterOptionsInput]\n  other: [FilterOptionsInput]\n  versionHistoryHosting: [FilterOptionsInput]\n}\n\ninput AdditionalFiltersInput {\n  vendorId: String\n  product: String\n  hosting: String\n}\n\ntype MarketplaceCategory {\n  category: MarketplaceStoreCategoryResponse!\n  apps: AppsConnection!\n}\n\ntype MarketplaceCollection {\n  id: ID!\n  collection: MarketplaceStoreCollectionResponse!\n  apps: AppsConnection\n}\n\n# eslint-disable-next-line @graphql-eslint/strict-id-in-types\ntype MarketplaceStorePartner {\n  apps: AppsConnection!\n  partner: MarketplaceStorePartnerResponse!\n  currentUser: MarketplaceStoreCurrentUserResponse\n}\n\ntype MarketplaceVersionHistory {\n  id: ID!\n  app: MarketplaceVersionHistoryApp!\n  watchersInfo: MarketplaceVersionHistoryAppWatchersInfo!\n  versions(filters: FiltersInput, after: String, first: Int!): MarketplaceVersionHistoryVersions!\n}\n\ntype MarketplaceVersionHistoryApp {\n  id: ID!\n  key: String!\n  name: String!\n  logoURL: URL!\n  slug: String!\n  productHostingOptions: [AtlassianProductHostingType!]!\n}\n\n# eslint-disable-next-line @graphql-eslint/strict-id-in-types\ntype MarketplaceVersionHistoryAppWatchersInfo {\n  isUserWatchingApp: Boolean!\n  canUserWatchApp: Boolean!\n}\n\n# eslint-disable-next-line @graphql-eslint/strict-id-in-types\ntype MarketplaceVersionHistoryVersions {\n  edges: [MarketplaceVersionHistoryVersionEdge!]!\n  pageInfo: PageInfo!\n  totalCount: Int!\n}\n\n# eslint-disable-next-line @graphql-eslint/strict-id-in-types\ntype MarketplaceVersionHistoryVersionEdge {\n  node: MarketplaceVersionHistoryVersion!\n}\n\ntype MarketplaceVersionHistoryMedia {\n  id: ID!\n  title: String\n  url: URL!\n}\n\n# eslint-disable-next-line @graphql-eslint/strict-id-in-types\ntype MarketplaceLicenseType {\n  type: String!\n  url: URL\n}\n\ntype MarketplaceVersionHistoryVersion {\n  id: ID!\n  version: String!\n  releaseDate: String!\n  releaseSummary: String\n  compatibilities: [String!]!\n  releaseNotes: String!\n  media: [MarketplaceVersionHistoryMedia!]\n  paymentModel: String!\n  license: MarketplaceLicenseType\n  supportDetail: String!\n  downloadUrl: URL\n  tryUrl: URL\n  buyUrl: URL\n}\n\ninterface MarketplaceStoreSection {\n  id: ID!\n  title: String!\n  description: String!\n  navigationUrl: String!\n  apps: [AppTile!]!\n}\ntype MarketplaceStoreHomePageEnterpriseSection implements MarketplaceStoreSection {\n  id: ID!\n  title: String!\n  description: String!\n  navigationUrl: String!\n  apps: [AppTile!]!\n}\ntype MarketplaceStoreHomePageRegularSection implements MarketplaceStoreSection {\n  id: ID!\n  title: String!\n  description: String!\n  navigationUrl: String!\n  apps: [AppTile!]!\n  appsFetchCount: Int!\n  screenSpecificProperties: MarketplaceStoreHomePageSectionScreenSpecificProperties!\n}\ntype MarketplaceStoreHomePageHighlightedSection implements MarketplaceStoreSection {\n  id: ID!\n  title: String!\n  description: String!\n  navigationUrl: String!\n  apps: [AppTile!]!\n  appsFetchCount: Int!\n  screenSpecificProperties: MarketplaceStoreHomePageSectionScreenSpecificProperties!\n  highlightVariation: MarketplaceStoreHomePageHighlightedSectionVariation!\n}\nunion MarketplaceHomeSection =\n    MarketplaceStoreHomePageEnterpriseSection\n  | MarketplaceStoreHomePageRegularSection\n  | MarketplaceStoreHomePageHighlightedSection\ntype MarketplaceHome {\n  id: ID!\n  sections: [MarketplaceHomeSection!]!\n}\n\nenum MarketplaceConsoleAppDistributionsGroupByKey {\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  none\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  app_version\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  parent_major_version\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  parent_minor_version\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  parent_all_versions\n}\n\n# eslint-disable-next-line @graphql-eslint/strict-id-in-types\ntype MarketplaceConsoleAppDistributionCountResponse {\n  groupByKey: String!\n  count: Int!\n}\n\n# eslint-disable-next-line @graphql-eslint/strict-id-in-types\ntype MarketplaceConsoleAppDistributionsResponse {\n  date: String!\n  groupedBy: MarketplaceConsoleAppDistributionsGroupByKey!\n  distributions: [MarketplaceConsoleAppDistributionCountResponse!]!\n}\n\nenum MarketplaceConsoleManageAppsAdminPaymentModel {\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  free\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  atlassian\n  # eslint-disable-next-line @graphql-eslint/naming-convention\n  vendor\n}\n\n# eslint-disable-next-line @graphql-eslint/strict-id-in-types\ntype MarketplaceConsoleAdminSectionResponse {\n  availableOnDemand: Boolean\n  onDemandPaymentModel: MarketplaceConsoleManageAppsAdminPaymentModel\n  versionBanner: String\n  titleLogoUrl: TitleLogo\n  distributionProductKey: String\n}\n\n# eslint-disable-next-line @graphql-eslint/strict-id-in-types\ntype MarketplaceAdminTitleLogoUploadResponse {\n  success: Boolean!\n  titleLogo: String!\n  selfImageHref: String!\n}\n\n# eslint-disable-next-line @graphql-eslint/strict-id-in-types\ntype MarketplaceAdminSubmitFormResponse {\n  success: Boolean!\n}\n\ninput MarketplaceAdminFormFieldOperation {\n  op: String!\n  path: String!\n  value: BooleanOrString\n}\n\ntype MarketplaceStoreAppPartner {\n  id: ID!\n  name: String!\n  enrollments: [MarketplaceStorePartnerEnrollment]!\n}\n\ntype MarketplaceStoreApp {\n  id: ID!\n  name: String!\n  logoURL: URL!\n  slug: String!\n  partner: MarketplaceStoreAppPartner\n  editions: [MarketplaceStoreEdition!]!\n}\n\nextend type Query {\n  marketplaceSearch(\n    query: String!\n    filters: FiltersInput!\n    sort: String!\n    after: Int!\n    first: Int!\n    additionalFilters: AdditionalFiltersInput\n    enableNLPSearch: Boolean\n  ): AppsConnection\n\n  marketplaceFilters(filterIds: [FilterId!]!): [MarketplaceFilterOptionResult!]\n\n  marketplaceCollection(\n    slug: String!\n    after: Int!\n    first: Int!\n    sort: String!\n    skipCollection: Boolean = false\n  ): MarketplaceCollection\n\n  marketplaceCategory(\n    slug: String!\n    filters: FiltersInput!\n    sort: String!\n    after: Int!\n    first: Int!\n    skipCategory: Boolean!\n  ): MarketplaceCategory\n\n  marketplaceAppVersionHistory(\n    appId: ID!\n    skipAppDetails: Boolean = false\n    includeHiddenVersions: Boolean = false\n  ): MarketplaceVersionHistory\n\n  marketplaceStorePartner(vendorId: ID!, after: Int!, first: Int!): MarketplaceStorePartner\n\n  marketplaceHome(productId: String, after: Int, first: Int): MarketplaceHome\n\n  marketplaceStoreAppWithEditions(appId: ID!): MarketplaceStoreApp\n\n  marketplaceConsoleAppActiveInstalls(\n    appKey: String!\n    startDate: String!\n    endDate: String!\n    groupBy: MarketplaceConsoleAppDistributionsGroupByKey\n    partnerId: String!\n  ): [MarketplaceConsoleAppDistributionsResponse!]!\n\n  marketplaceConsoleAppDownloads(\n    appKey: String!\n    startDate: String!\n    endDate: String!\n    partnerId: String!\n  ): [MarketplaceConsoleAppDistributionsResponse!]!\n\n  marketplaceConsoleManageAppAdmin(appKey: String!): MarketplaceConsoleAdminSectionResponse\n}\n\nextend type Mutation {\n  marketplaceConsoleAdminTitleLogo(logo: FormData): MarketplaceAdminTitleLogoUploadResponse!\n\n  marketplaceConsoleAdminSaveForm(\n    appKey: String!\n    payload: [MarketplaceAdminFormFieldOperation]\n  ): MarketplaceAdminSubmitFormResponse\n}\n";

});
parcelRegister("lbqa4", function(module, exports) {

$parcel$export(module.exports, "orchestrationEmceeConfig", () => $f6beeb29b9c3e7ec$export$227181ee6ab6a354);

var $iExms = parcelRequire("iExms");

var $3yqTQ = parcelRequire("3yqTQ");
var $kok63 = parcelRequire("kok63");
var $92iHj = parcelRequire("92iHj");
var $7ME9W = parcelRequire("7ME9W");
var $5wwE8 = parcelRequire("5wwE8");

var $fFpaQ = parcelRequire("fFpaQ");
const $f6beeb29b9c3e7ec$var$getConfig = (config)=>config;
/**
 * Orchestration configuration for DLA
 *
 * `config` accepts both a config and a function returning config. This can be used for returning
 *  configuration based on some feature flag or some custom logic.
 */ // eslint-disable-next-line max-lines-per-function
const $f6beeb29b9c3e7ec$export$227181ee6ab6a354 = (configProps)=>{
    const algoliaConfig = (0, $iExms.getAlgoliaConfig)(configProps.algoliaConfig, configProps.featureFlags, true // all aether pages need v2 index
    );
    const homeHandler = new (0, $92iHj.HomeHandler)(algoliaConfig);
    return $f6beeb29b9c3e7ec$var$getConfig({
        GetMarketplaceSearch: {
            config: ()=>({
                    sequence: (0, $fFpaQ.SequenceTypes).CUSTOM_ONLY,
                    handler: new (0, $5wwE8.SearchResultHandler)(algoliaConfig)
                })
        },
        GetMarketplaceFilters: {
            config: ()=>({
                    sequence: (0, $fFpaQ.SequenceTypes).CUSTOM_ONLY,
                    handler: new (0, $7ME9W.SearchFiltersHandler)(configProps.stargateBaseUrl, configProps.featureFlags, configProps.statsigClient)
                })
        },
        GetCollection: {
            middlewaresConfig: {
                cache: {
                    primary: {
                        ttlMs: 60000,
                        cacheKey: (_ref)=>{
                            let { variables: variables } = _ref;
                            return variables.slug;
                        }
                    }
                }
            },
            config: ()=>({
                    sequence: (0, $fFpaQ.SequenceTypes).PRIMARY_FIRST,
                    handler: new (0, $kok63.CollectionHandler)(algoliaConfig)
                })
        },
        GetMarketplaceCategory: {
            middlewaresConfig: {
                cache: {
                    primary: {
                        ttlMs: 60000,
                        // todo: update TTL
                        cacheKey: (_ref2)=>{
                            let { variables: variables } = _ref2;
                            return variables.slug;
                        }
                    }
                }
            },
            config: {
                sequence: (0, $fFpaQ.SequenceTypes).PRIMARY_FIRST,
                handler: new (0, $3yqTQ.CategoryHandler)(algoliaConfig)
            }
        },
        GetMarketplaceHome: {
            middlewaresConfig: {
                cache: {
                    primary: {
                        ttlMs: 60000,
                        cacheKey: (_ref3)=>{
                            let { variables: variables } = _ref3;
                            return variables.productId;
                        }
                    }
                }
            },
            config: (_ref4)=>{
                let { variables: variables } = _ref4;
                return {
                    sequence: variables.first === 1 ? (0, $fFpaQ.SequenceTypes).CUSTOM_ONLY : (0, $fFpaQ.SequenceTypes).PRIMARY_FIRST,
                    handler: homeHandler
                };
            }
        }
    });
};

});
parcelRegister("iExms", function(module, exports) {

$parcel$export(module.exports, "getAlgoliaConfig", () => $d945d745ea63769f$export$6539cb8bcc94280c);

var $fBO3c = parcelRequire("fBO3c");
const $d945d745ea63769f$export$6539cb8bcc94280c = (algoliaConfig, featureFlags, setV2SearchIndex)=>{
    const searchIndex = (0, $fBO3c.resolveAlgoliaSearchIndex)(algoliaConfig.environment, setV2SearchIndex || featureFlags.enableV2SearchIndex);
    return {
        algoliaApiKey: algoliaConfig.apiKey,
        algoliaAppId: algoliaConfig.applicationId,
        algoliaSearchIndex: searchIndex
    };
};

});
parcelRegister("fBO3c", function(module, exports) {

$parcel$export(module.exports, "resolveAlgoliaSearchIndex", () => $02eeba5de57cfa2c$export$7b251f7b2bf1fd0a);

var $cZdP1 = parcelRequire("cZdP1");
function $02eeba5de57cfa2c$export$7b251f7b2bf1fd0a(environment) {
    let enableV2SearchIndex = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let indexSuffix = arguments.length > 2 ? arguments[2] : undefined;
    const index = enableV2SearchIndex ? (0, $cZdP1.searchIndicesV2) : (0, $cZdP1.searchIndicesV1);
    return "".concat(index[environment].indexName).concat(indexSuffix ? "_".concat(indexSuffix) : '');
}

});
parcelRegister("cZdP1", function(module, exports) {

$parcel$export(module.exports, "searchIndicesV1", () => $9745e74503740f1b$export$1cce0c12da2f23c3);
$parcel$export(module.exports, "searchIndicesV2", () => $9745e74503740f1b$export$ba433f7d838a8998);

var $1fIAX = parcelRequire("1fIAX");
const $9745e74503740f1b$export$1cce0c12da2f23c3 = {
    [(0, $1fIAX.AlgoliaEnvironment).DEV]: {
        indexName: 'marketplace_plugins_dev'
    },
    [(0, $1fIAX.AlgoliaEnvironment).STG]: {
        indexName: 'marketplace_plugins_stg'
    },
    [(0, $1fIAX.AlgoliaEnvironment).PROD]: {
        indexName: 'marketplace_plugins_prod'
    }
};
const $9745e74503740f1b$export$ba433f7d838a8998 = {
    [(0, $1fIAX.AlgoliaEnvironment).DEV]: {
        indexName: 'marketplace_plugins_dev_v2'
    },
    [(0, $1fIAX.AlgoliaEnvironment).STG]: {
        indexName: 'marketplace_plugins_stg_v2'
    },
    [(0, $1fIAX.AlgoliaEnvironment).PROD]: {
        indexName: 'marketplace_plugins_prod_v2'
    }
};

});



parcelRegister("3yqTQ", function(module, exports) {

$parcel$export(module.exports, "CategoryHandler", () => $296969c85ee760cd$export$8a6fd8fdf68b2eb6);

var $5zQU9 = parcelRequire("5zQU9");

var $er4rv = parcelRequire("er4rv");

var $kBH4t = parcelRequire("kBH4t");

var $4SnSg = parcelRequire("4SnSg");
var $fucQH = parcelRequire("fucQH");

var $jnsaq = parcelRequire("jnsaq");

var $6zrAO = parcelRequire("6zrAO");

var $5gt1S = parcelRequire("5gt1S");

var $kPBTo = parcelRequire("kPBTo");
var $296969c85ee760cd$var$GetCategory = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetCategory"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "slug"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceStore"
                        },
                        arguments: [],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "optIn"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "to"
                                        },
                                        value: {
                                            kind: "ListValue",
                                            values: [
                                                {
                                                    kind: "StringValue",
                                                    value: "MarketplaceStoreCategory",
                                                    block: false
                                                }
                                            ]
                                        }
                                    }
                                ]
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "category"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "slug"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "slug"
                                                }
                                            }
                                        }
                                    ],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "name"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "slug"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "heroSection"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "description"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "image"
                                                            },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "url"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "altText"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "title"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "algoliaQueryMetadata"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "filters"
                                                            },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "key"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "value"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "searchIndex"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "sort"
                                                            },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "criteria"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 449,
        source: {
            body: "query GetCategory($slug: String!) {\n  marketplaceStore @optIn(to: [\"MarketplaceStoreCategory\"]) {\n    category(slug: $slug) {\n      id\n      name\n      slug\n\n      heroSection {\n        description\n        image {\n          url\n          altText\n        }\n        title\n      }\n      algoliaQueryMetadata {\n        filters {\n          key\n          value\n        }\n        searchIndex\n        sort {\n          criteria\n        }\n      }\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
class $296969c85ee760cd$export$8a6fd8fdf68b2eb6 extends (0, $4SnSg.BaseHandler) {
    constructor(algoliaConfig){
        super();
        (0, $5zQU9.default)(this, "algoliaConfig", void 0);
        this.algoliaConfig = algoliaConfig;
    }
    requestTransformer(operation, _sequenceConfigValue) {
        const newOperation = (0, $fucQH.copyToNewQueryOperation)(operation, $296969c85ee760cd$var$GetCategory, (_ref)=>{
            let { slug: slug } = _ref;
            return {
                slug: slug
            };
        });
        return newOperation;
    }
    async fetchCustom(operation, _transformedOperation, _sequenceConfigValue, _primaryResponse) {
        var _primaryResponse$mark, _primaryResponse$mark2, _primaryResponse$mark3, _primaryResponse$mark4, _primaryResponse$mark5;
        const category = _primaryResponse === null || _primaryResponse === void 0 ? void 0 : _primaryResponse.marketplaceStore.category;
        if (!category) throw new Error('NOT_FOUND');
        if (!(category !== null && category !== void 0 && category.algoliaQueryMetadata)) throw new Error('Algolia query metadata not found');
        const { first: first, after: after, filters: filters, sort: sort } = operation.variables;
        const { transformedAlgoliaIndex: transformedAlgoliaIndex, sortFilters: sortFilters } = (0, $6zrAO.resolveAlgoliaSortIndexAndFilters)((_primaryResponse$mark = _primaryResponse === null || _primaryResponse === void 0 ? void 0 : (_primaryResponse$mark2 = _primaryResponse.marketplaceStore.category) === null || _primaryResponse$mark2 === void 0 ? void 0 : (_primaryResponse$mark3 = _primaryResponse$mark2.algoliaQueryMetadata) === null || _primaryResponse$mark3 === void 0 ? void 0 : _primaryResponse$mark3.searchIndex) !== null && _primaryResponse$mark !== void 0 ? _primaryResponse$mark : '', sort, filters);
        const facetFilters = [
            _primaryResponse !== null && _primaryResponse !== void 0 && (_primaryResponse$mark4 = _primaryResponse.marketplaceStore) !== null && _primaryResponse$mark4 !== void 0 && (_primaryResponse$mark5 = _primaryResponse$mark4.category) !== null && _primaryResponse$mark5 !== void 0 && _primaryResponse$mark5.algoliaQueryMetadata ? (0, $er4rv.createAlgoliaFacetFiltersFromQueryMetaData)(_primaryResponse.marketplaceStore.category.algoliaQueryMetadata) : [],
            ...(0, $jnsaq.transformFilters)(filters, sortFilters)
        ];
        const response = await (0, $kBH4t.AlgoliaSearch)({
            applicationId: this.algoliaConfig.algoliaAppId,
            apiKey: this.algoliaConfig.algoliaApiKey,
            indexName: transformedAlgoliaIndex,
            facetFilters: facetFilters,
            after: after,
            first: first
        });
        return response;
    }
    responseTransformer(operation, _transformedOperation, _sequenceConfigValue, primaryResponse, customResponse) {
        var _primaryResponse$mark6;
        const category = primaryResponse === null || primaryResponse === void 0 ? void 0 : primaryResponse.marketplaceStore.category;
        const { filters: filters } = operation.variables;
        if (!category) throw new Error('Category not found');
        if (!Object.keys(filters).length && (!customResponse || (customResponse === null || customResponse === void 0 ? void 0 : customResponse.results[0].hits.length) === 0)) throw new Error('No apps found for the category');
        const newResponse = {
            marketplaceCategory: {
                __typename: 'MarketplaceCategory',
                category: (0, $kPBTo.transposeCategory)(primaryResponse === null || primaryResponse === void 0 ? void 0 : (_primaryResponse$mark6 = primaryResponse.marketplaceStore) === null || _primaryResponse$mark6 === void 0 ? void 0 : _primaryResponse$mark6.category),
                apps: customResponse ? (0, $5gt1S.transposeAppsConnection)({
                    customResponse: customResponse,
                    query: operation.variables.query
                }) : null
            }
        };
        return newResponse;
    }
}

});
parcelRegister("er4rv", function(module, exports) {

$parcel$export(module.exports, "createAlgoliaFacetFiltersFromQueryMetaData", () => $a8270880b12ead24$export$5f133cca5eb0b197);
function $a8270880b12ead24$export$5f133cca5eb0b197(algoliaQueryMetaData) {
    const { filters: filters } = algoliaQueryMetaData;
    return filters.flatMap((filter)=>filter.value.map((item)=>"".concat(filter.key, ":").concat(item)));
}

});

parcelRegister("kBH4t", function(module, exports) {

$parcel$export(module.exports, "AlgoliaSearch", () => $f008ac66cd91f401$export$baf6d31db6f5c008);
$parcel$export(module.exports, "AlgoliaSearchV2", () => $f008ac66cd91f401$export$e05d70d176bf6214);
$parcel$export(module.exports, "AlgoliaSearchV3", () => $f008ac66cd91f401$export$e7688217aa0319b);

var $5zQU9 = parcelRequire("5zQU9");

var $er4rv = parcelRequire("er4rv");

var $f2Nkd = parcelRequire("f2Nkd");

var $jnsaq = parcelRequire("jnsaq");

var $6zrAO = parcelRequire("6zrAO");
function $f008ac66cd91f401$export$baf6d31db6f5c008(_ref) {
    let { applicationId: applicationId, apiKey: apiKey, indexName: indexName, query: query, facetFilters: facetFilters, after: after, first: first } = _ref;
    const client = (0, (/*@__PURE__*/$parcel$interopDefault($f2Nkd)))(applicationId, apiKey);
    return client.search([
        {
            indexName: indexName,
            query: query ? query : '',
            params: {
                hitsPerPage: first,
                page: Math.floor(after / first),
                facetFilters: facetFilters
            }
        }
    ]);
}
class $f008ac66cd91f401$export$e05d70d176bf6214 {
    constructor(algoliaSearchConfig){
        (0, $5zQU9.default)(this, "applicationId", void 0);
        (0, $5zQU9.default)(this, "apiKey", void 0);
        (0, $5zQU9.default)(this, "facetFilters", (0, $jnsaq.getDefaultFacetFilters)());
        (0, $5zQU9.default)(this, "indexName", void 0);
        this.applicationId = algoliaSearchConfig.algoliaAppId;
        this.apiKey = algoliaSearchConfig.algoliaApiKey;
        this.indexName = algoliaSearchConfig.algoliaSearchIndex;
    }
    setSortIndexAndFilters(sortKey, filters) {
        const { sortFilters: sortFilters, transformedAlgoliaIndex: transformedAlgoliaIndex } = (0, $6zrAO.resolveAlgoliaSortIndexAndFilters)(this.indexName, sortKey, filters);
        this.indexName = transformedAlgoliaIndex;
        this.facetFilters.push((0, $jnsaq.transformSortToFacetFilters)(sortFilters));
        return this;
    }
    setAlgoliaMetaDataIndexAndFilters(algoliaQueryMetaData) {
        if (algoliaQueryMetaData.searchIndex) this.indexName = algoliaQueryMetaData.searchIndex;
        this.facetFilters.push((0, $er4rv.createAlgoliaFacetFiltersFromQueryMetaData)(algoliaQueryMetaData));
        return this;
    }
    appendFacetFiltersFromUIFilters(filters) {
        this.facetFilters.push(...(0, $jnsaq.transformFilters)(filters));
        return this;
    }
    async search(_ref2) {
        let { after: after, first: first, query: query } = _ref2;
        return $f008ac66cd91f401$export$baf6d31db6f5c008({
            applicationId: this.applicationId,
            apiKey: this.apiKey,
            indexName: this.indexName,
            query: query,
            facetFilters: this.facetFilters,
            after: after,
            first: first
        });
    }
}
function $f008ac66cd91f401$export$e7688217aa0319b(_ref3) {
    let { applicationId: applicationId, apiKey: apiKey, indexName: indexName, attributesToHighlight: attributesToHighlight, attributesToRetrieve: attributesToRetrieve, facetFilters: facetFilters, hitsPerPage: hitsPerPage } = _ref3;
    const client = (0, (/*@__PURE__*/$parcel$interopDefault($f2Nkd)))(applicationId, apiKey);
    return client.search([
        {
            indexName: indexName,
            params: {
                attributesToHighlight: attributesToHighlight,
                attributesToRetrieve: attributesToRetrieve,
                facetFilters: facetFilters,
                hitsPerPage: hitsPerPage
            }
        }
    ]);
}

});
parcelRegister("jnsaq", function(module, exports) {

$parcel$export(module.exports, "algoliaFacetMap", () => $e1b603b6bd7f9e59$export$d5ed941a15ae50a5);
$parcel$export(module.exports, "transformFilters", () => $e1b603b6bd7f9e59$export$6b801750e47278fe);
$parcel$export(module.exports, "getDefaultFacetFilters", () => $e1b603b6bd7f9e59$export$60c0bc150bccade1);
$parcel$export(module.exports, "transformSortToFacetFilters", () => $e1b603b6bd7f9e59$export$cb36096e804292b8);

var $9qqD0 = parcelRequire("9qqD0");

var $7lvGB = parcelRequire("7lvGB");
const $e1b603b6bd7f9e59$export$d5ed941a15ae50a5 = {
    [(0, $9qqD0.FILTER_KEYS).PRODUCT]: 'version.compatibilities.applicationKey',
    [(0, $9qqD0.FILTER_KEYS).PRICE]: {
        [(0, $9qqD0.FILTER_KEYS).PAID]: 'version.paid',
        [(0, $9qqD0.FILTER_KEYS).FREE_STARTER_TIER]: 'freeStarterTierStatus'
    },
    [(0, $9qqD0.FILTER_KEYS).HOSTING]: 'version.compatibilities.hosting',
    [(0, $9qqD0.FILTER_KEYS).TRUST_SIGNALS]: {
        [(0, $9qqD0.FILTER_KEYS).CLOUD_FORTIFIED]: 'programs.cloudFortified.status',
        [(0, $9qqD0.FILTER_KEYS).BUG_BOUNTY_PARTICIPANT]: 'programs.bugBountyParticipant.cloud.status'
    },
    // // has to be added as direct numericFilters instead of facetFilter (numericFilters: ['ratings.avgStars >= 3'])
    // // https://www.algolia.com/doc/api-reference/api-parameters/numericFilters/
    // ratings: {
    //   '3StarAbove': 'ratings.avgStars >= 3',
    //   '2StarAbove': 'ratings.avgStars >= 2',
    //   '1StarAbove': 'ratings.avgStars >= 1',
    //   noRating: 'ratings.avgStars = 0',
    // },
    [(0, $9qqD0.FILTER_KEYS).OTHER]: {
        [(0, $9qqD0.FILTER_KEYS).STABLE]: 'version.stable',
        [(0, $9qqD0.FILTER_KEYS).VENDOR_SUPPORTED]: 'version.supported'
    },
    [(0, $9qqD0.FILTER_KEYS).CATEGORIES]: 'tags.searchTerm',
    [(0, $9qqD0.FILTER_KEYS).USE_CASES]: 'tags.searchTerm',
    [(0, $9qqD0.FILTER_KEYS).HIDDEN]: 'hidden',
    [(0, $9qqD0.FILTER_KEYS).CANONICAL_VERSION]: 'version.canonicalVersion',
    [(0, $9qqD0.FILTER_KEYS).DEPLOYMENTS]: 'deployments',
    [(0, $9qqD0.FILTER_KEYS).TOP_VENDOR]: 'vendor.isTopVendor',
    [(0, $9qqD0.FILTER_KEYS).LATEST_OF_HOSTING]: 'version.latestOfHosting',
    [(0, $9qqD0.FILTER_KEYS).IS_ATLASSIAN]: 'vendor.isAtlassian',
    [(0, $9qqD0.FILTER_KEYS).MARKETPLACE_TYPE]: 'version.marketplaceType',
    [(0, $9qqD0.FILTER_KEYS).MARKETING_LABELS]: 'marketingLabels',
    [(0, $9qqD0.FILTER_KEYS).PLUGIN_SYSTEM_VERSION]: 'version.pluginSystemVersion'
};
const $e1b603b6bd7f9e59$var$defaultFacetsValues = {
    [$e1b603b6bd7f9e59$export$d5ed941a15ae50a5[(0, $9qqD0.FILTER_KEYS).HIDDEN]]: 'notHidden',
    [$e1b603b6bd7f9e59$export$d5ed941a15ae50a5[(0, $9qqD0.FILTER_KEYS).CANONICAL_VERSION]]: 'true'
};
const $e1b603b6bd7f9e59$export$6b801750e47278fe = function transformFilters() {
    let filters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    let sortFilters = arguments.length > 1 ? arguments[1] : undefined;
    let additionalFilters = arguments.length > 2 ? arguments[2] : undefined;
    // Transform each filter option
    const transformedFilters = Object.entries(filters).map((_ref)=>{
        let [filterId, filterOptions] = _ref;
        const filterOptionsValue = Array.isArray(filterOptions) ? filterOptions : [
            filterOptions
        ];
        return filterOptionsValue.map((filterOption)=>(0, $7lvGB.isPlainObject)($e1b603b6bd7f9e59$export$d5ed941a15ae50a5[filterId]) ? "".concat($e1b603b6bd7f9e59$export$d5ed941a15ae50a5[filterId][filterOption.id], ":").concat(filterOption.value === 'bugBountyApproved' ? 'approved' : filterOption.value) : "".concat($e1b603b6bd7f9e59$export$d5ed941a15ae50a5[filterId], ":").concat(filterOption.value));
    });
    // Add default facet filtering
    transformedFilters.push(...$e1b603b6bd7f9e59$export$60c0bc150bccade1());
    if (sortFilters && Object.keys(sortFilters).length > 0) transformedFilters.push($e1b603b6bd7f9e59$export$cb36096e804292b8(sortFilters));
    if (additionalFilters !== null && additionalFilters !== void 0 && additionalFilters.vendorId) transformedFilters.push([
        "vendor.id:".concat(additionalFilters.vendorId)
    ]);
    if (additionalFilters !== null && additionalFilters !== void 0 && additionalFilters.product) transformedFilters.push([
        "version.compatibilities.applicationKey:".concat(additionalFilters.product)
    ]);
    if (additionalFilters !== null && additionalFilters !== void 0 && additionalFilters.hosting) transformedFilters.push([
        "version.compatibilities.hosting:".concat(additionalFilters.hosting)
    ]);
    return transformedFilters;
};
const $e1b603b6bd7f9e59$export$cb36096e804292b8 = (sortFilters)=>Object.entries(sortFilters).map((_ref2)=>{
        let [filterId, value] = _ref2;
        return "".concat(filterId, ":").concat(value);
    });
const $e1b603b6bd7f9e59$export$60c0bc150bccade1 = ()=>Object.entries($e1b603b6bd7f9e59$var$defaultFacetsValues).map((_ref3)=>{
        let [filterId, value] = _ref3;
        return [
            "".concat(filterId, ":").concat(value)
        ];
    });

});

parcelRegister("6zrAO", function(module, exports) {

$parcel$export(module.exports, "resolveAlgoliaSortIndexAndFilters", () => $4c8b6a4cfd62736e$export$2dc6ea74cb728c7f);

var $9qqD0 = parcelRequire("9qqD0");

var $6Gtik = parcelRequire("6Gtik");

var $jnsaq = parcelRequire("jnsaq");
const $4c8b6a4cfd62736e$var$sortOptionIndexConfig = [
    {
        key: 'topRated',
        indexSuffix: ()=>{
            return 'desc_ratings.ratingsScore';
        }
    },
    {
        key: 'trending',
        indexSuffix: ()=>{
            return 'desc_distribution.deltaInstalls';
        },
        applyOverrides: ()=>({
                [(0, $jnsaq.algoliaFacetMap)[(0, $9qqD0.FILTER_KEYS).IS_ATLASSIAN]]: 'false'
            })
    },
    {
        key: 'topSelling',
        indexSuffix: (filters)=>{
            const hostingFilter = filters === null || filters === void 0 ? void 0 : filters.hosting;
            if (hostingFilter && hostingFilter.length) switch(hostingFilter[0].value){
                case (0, $6Gtik.HostingTypes).CLOUD:
                    return 'desc_sales.recentGrossCloud';
                case (0, $6Gtik.HostingTypes).SERVER:
                    return 'desc_sales.recentGrossServer';
                case (0, $6Gtik.HostingTypes).DATA_CENTER:
                    return 'desc_sales.recentGrossServer';
                default:
                    return 'desc_sales.recentGrossTotal';
            }
            return 'desc_sales.recentGrossTotal';
        },
        applyOverrides: ()=>({
                [(0, $jnsaq.algoliaFacetMap)[(0, $9qqD0.FILTER_KEYS).IS_ATLASSIAN]]: 'false',
                [(0, $jnsaq.algoliaFacetMap)[(0, $9qqD0.FILTER_KEYS).MARKETPLACE_TYPE]]: 'Paid via Atlassian'
            })
    },
    {
        key: 'newest',
        indexSuffix: ()=>{
            return 'desc_releaseDate';
        }
    }
];
const $4c8b6a4cfd62736e$export$2dc6ea74cb728c7f = (index, sortKey, filters)=>{
    const sortOption = $4c8b6a4cfd62736e$var$sortOptionIndexConfig.find((option)=>option.key === sortKey);
    let newIndex = index;
    let sortFilters = {};
    if (sortOption) {
        newIndex = index + "_".concat(sortOption === null || sortOption === void 0 ? void 0 : sortOption.indexSuffix(filters));
        if (sortOption.applyOverrides) sortFilters = sortOption.applyOverrides();
    }
    return {
        transformedAlgoliaIndex: newIndex,
        sortFilters: sortFilters
    };
};

});
parcelRegister("6Gtik", function(module, exports) {

$parcel$export(module.exports, "HostingTypes", () => $4ddd639e4b267151$export$c38dc1a73c29d598);
$parcel$export(module.exports, "HostingFilters", () => $4ddd639e4b267151$export$e3895077b2a5252);
const $4ddd639e4b267151$export$c38dc1a73c29d598 = {
    CLOUD: 'cloud',
    DATA_CENTER: 'dataCenter',
    SERVER: 'server'
};
const $4ddd639e4b267151$export$e3895077b2a5252 = ()=>{
    return [
        {
            label: 'Cloud',
            id: $4ddd639e4b267151$export$c38dc1a73c29d598.CLOUD,
            value: $4ddd639e4b267151$export$c38dc1a73c29d598.CLOUD
        },
        {
            label: 'Data Center',
            id: $4ddd639e4b267151$export$c38dc1a73c29d598.DATA_CENTER,
            value: $4ddd639e4b267151$export$c38dc1a73c29d598.DATA_CENTER
        },
        {
            label: 'Server',
            id: $4ddd639e4b267151$export$c38dc1a73c29d598.SERVER,
            value: $4ddd639e4b267151$export$c38dc1a73c29d598.SERVER
        }
    ];
};

});



parcelRegister("4SnSg", function(module, exports) {

$parcel$export(module.exports, "BaseHandler", () => $38ceb97db144b000$export$33e90ef771361e37);
class $38ceb97db144b000$export$33e90ef771361e37 {
    requestTransformer(operation, _sequenceConfigValue) {
        return operation;
    }
    responseTransformer(_operation, _transformedOperation, _sequenceConfigValue, primaryResponse, _customResponse) {
        return primaryResponse;
    }
    fetchPrimary(operation, forward) {
        return forward(operation);
    }
    fetchCustom(_operation, _transformedOperation, _sequenceConfigValue, _primaryResponse) {
        return Promise.resolve(void 0);
    }
}

});

parcelRegister("fucQH", function(module, exports) {

$parcel$export(module.exports, "copyToNewQueryOperation", () => $b4639fe817de3cc7$export$686ed363855a05b8);

var $iX694 = parcelRequire("iX694");
function $b4639fe817de3cc7$export$686ed363855a05b8(oldOperation, newGQLDocument, mapVariables) {
    var _newGQLDocument$loc;
    const newGQLOperationName = (0, $iX694.getOperationName)(newGQLDocument);
    if (!newGQLOperationName) throw new Error("OperationName not defined for given new query: ".concat((_newGQLDocument$loc = newGQLDocument.loc) === null || _newGQLDocument$loc === void 0 ? void 0 : _newGQLDocument$loc.source));
    return Object.assign(Object.create(oldOperation), {
        query: oldOperation.getContext().getClient().documentTransform.transformDocument(newGQLDocument),
        operationName: newGQLOperationName,
        variables: mapVariables ? mapVariables(oldOperation.variables) : oldOperation.variables
    });
}

});
parcelRegister("iX694", function(module, exports) {

$parcel$export(module.exports, "checkDocument", () => $dcc280fef6bf3747$export$a7d0d8111d2386df);
$parcel$export(module.exports, "getOperationDefinition", () => $dcc280fef6bf3747$export$7a5b1fa979d2c158);
$parcel$export(module.exports, "getOperationName", () => $dcc280fef6bf3747$export$41bca9dc6871dd4e);
$parcel$export(module.exports, "getFragmentDefinitions", () => $dcc280fef6bf3747$export$5320a7ba9466a3df);
$parcel$export(module.exports, "getQueryDefinition", () => $dcc280fef6bf3747$export$d96b2213c1b9d3a9);
$parcel$export(module.exports, "getFragmentDefinition", () => $dcc280fef6bf3747$export$772111caef41b3f5);
$parcel$export(module.exports, "getMainDefinition", () => $dcc280fef6bf3747$export$f431198736b7f96d);
$parcel$export(module.exports, "getDefaultValues", () => $dcc280fef6bf3747$export$84c19026e616569e);
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $6dwmd = parcelRequire("6dwmd");
function $dcc280fef6bf3747$export$a7d0d8111d2386df(doc) {
    (0, $kL4FQ.invariant)(doc && doc.kind === "Document", 74);
    var operations = doc.definitions.filter(function(d) {
        return d.kind !== "FragmentDefinition";
    }).map(function(definition) {
        if (definition.kind !== "OperationDefinition") throw (0, $kL4FQ.newInvariantError)(75, definition.kind);
        return definition;
    });
    (0, $kL4FQ.invariant)(operations.length <= 1, 76, operations.length);
    return doc;
}
function $dcc280fef6bf3747$export$7a5b1fa979d2c158(doc) {
    $dcc280fef6bf3747$export$a7d0d8111d2386df(doc);
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition";
    })[0];
}
function $dcc280fef6bf3747$export$41bca9dc6871dd4e(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "OperationDefinition" && !!definition.name;
    }).map(function(x) {
        return x.name.value;
    })[0] || null;
}
function $dcc280fef6bf3747$export$5320a7ba9466a3df(doc) {
    return doc.definitions.filter(function(definition) {
        return definition.kind === "FragmentDefinition";
    });
}
function $dcc280fef6bf3747$export$d96b2213c1b9d3a9(doc) {
    var queryDef = $dcc280fef6bf3747$export$7a5b1fa979d2c158(doc);
    (0, $kL4FQ.invariant)(queryDef && queryDef.operation === "query", 77);
    return queryDef;
}
function $dcc280fef6bf3747$export$772111caef41b3f5(doc) {
    (0, $kL4FQ.invariant)(doc.kind === "Document", 78);
    (0, $kL4FQ.invariant)(doc.definitions.length <= 1, 79);
    var fragmentDef = doc.definitions[0];
    (0, $kL4FQ.invariant)(fragmentDef.kind === "FragmentDefinition", 80);
    return fragmentDef;
}
function $dcc280fef6bf3747$export$f431198736b7f96d(queryDoc) {
    $dcc280fef6bf3747$export$a7d0d8111d2386df(queryDoc);
    var fragmentDefinition;
    for(var _i = 0, _a = queryDoc.definitions; _i < _a.length; _i++){
        var definition = _a[_i];
        if (definition.kind === "OperationDefinition") {
            var operation = definition.operation;
            if (operation === "query" || operation === "mutation" || operation === "subscription") return definition;
        }
        if (definition.kind === "FragmentDefinition" && !fragmentDefinition) // we do this because we want to allow multiple fragment definitions
        // to precede an operation definition.
        fragmentDefinition = definition;
    }
    if (fragmentDefinition) return fragmentDefinition;
    throw (0, $kL4FQ.newInvariantError)(81);
}
function $dcc280fef6bf3747$export$84c19026e616569e(definition) {
    var defaultValues = Object.create(null);
    var defs = definition && definition.variableDefinitions;
    if (defs && defs.length) defs.forEach(function(def) {
        if (def.defaultValue) (0, $6dwmd.valueToObjectRepresentation)(defaultValues, def.variable.name, def.defaultValue);
    });
    return defaultValues;
}

});
parcelRegister("aJBWo", function(module, exports) {

$parcel$export(module.exports, "maybe", () => (parcelRequire("krE5f")).maybe);
$parcel$export(module.exports, "global", () => (parcelRequire("6DBa1")).default);
$parcel$export(module.exports, "invariant", () => (parcelRequire("kL4FQ")).invariant);
$parcel$export(module.exports, "newInvariantError", () => (parcelRequire("kL4FQ")).newInvariantError);

var $kL4FQ = parcelRequire("kL4FQ");

var $krE5f = parcelRequire("krE5f");

var $6DBa1 = parcelRequire("6DBa1");
var $7d0b89a21cfc9e97$export$404582bc18fe4d9e = globalThis.__DEV__ !== false;

});
parcelRegister("kL4FQ", function(module, exports) {

$parcel$export(module.exports, "invariant", () => $f1cbd292d27c29fd$export$f5708dca728d7177);
$parcel$export(module.exports, "newInvariantError", () => $f1cbd292d27c29fd$export$3991762405098ea);

var $bMXb2 = parcelRequire("bMXb2");

var $76T0U = parcelRequire("76T0U");

var $6DBa1 = parcelRequire("6DBa1");

var $dRSFQ = parcelRequire("dRSFQ");
function $f1cbd292d27c29fd$var$wrap(fn) {
    return function(message) {
        var args = [];
        for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
        if (typeof message === "number") {
            var arg0 = message;
            message = $f1cbd292d27c29fd$var$getHandledErrorMsg(arg0);
            if (!message) {
                message = $f1cbd292d27c29fd$var$getFallbackErrorMsg(arg0, args);
                args = [];
            }
        }
        fn.apply(void 0, [
            message
        ].concat(args));
    };
}
var $f1cbd292d27c29fd$export$f5708dca728d7177 = Object.assign(function invariant(condition, message) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (!condition) (0, $bMXb2.invariant)(condition, $f1cbd292d27c29fd$var$getHandledErrorMsg(message, args) || $f1cbd292d27c29fd$var$getFallbackErrorMsg(message, args));
}, {
    debug: $f1cbd292d27c29fd$var$wrap((0, $bMXb2.invariant).debug),
    log: $f1cbd292d27c29fd$var$wrap((0, $bMXb2.invariant).log),
    warn: $f1cbd292d27c29fd$var$wrap((0, $bMXb2.invariant).warn),
    error: $f1cbd292d27c29fd$var$wrap((0, $bMXb2.invariant).error)
});
/**
 * Returns an InvariantError.
 *
 * `message` can only be a string, a concatenation of strings, or a ternary statement
 * that results in a string. This will be enforced on build, where the message will
 * be replaced with a message number.
 * String substitutions with %s are supported and will also return
 * pretty-stringified objects.
 * Excess `optionalParams` will be swallowed.
 */ function $f1cbd292d27c29fd$export$3991762405098ea(message) {
    var optionalParams = [];
    for(var _i = 1; _i < arguments.length; _i++)optionalParams[_i - 1] = arguments[_i];
    return new (0, $bMXb2.InvariantError)($f1cbd292d27c29fd$var$getHandledErrorMsg(message, optionalParams) || $f1cbd292d27c29fd$var$getFallbackErrorMsg(message, optionalParams));
}
var $f1cbd292d27c29fd$export$b8ca975fa04efdf3 = Symbol.for("ApolloErrorMessageHandler_" + (0, $76T0U.version));
function $f1cbd292d27c29fd$var$stringify(arg) {
    return typeof arg == "string" ? arg : (0, $dRSFQ.stringifyForDisplay)(arg, 2).slice(0, 1000);
}
function $f1cbd292d27c29fd$var$getHandledErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return (0, $6DBa1.default)[$f1cbd292d27c29fd$export$b8ca975fa04efdf3] && (0, $6DBa1.default)[$f1cbd292d27c29fd$export$b8ca975fa04efdf3](message, messageArgs.map($f1cbd292d27c29fd$var$stringify));
}
function $f1cbd292d27c29fd$var$getFallbackErrorMsg(message, messageArgs) {
    if (messageArgs === void 0) messageArgs = [];
    if (!message) return;
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
        version: (0, $76T0U.version),
        message: message,
        args: messageArgs.map($f1cbd292d27c29fd$var$stringify)
    })));
}

});
parcelRegister("76T0U", function(module, exports) {

$parcel$export(module.exports, "version", () => $52d3c48204ed6f7b$export$83d89fbfd8236492);
var $52d3c48204ed6f7b$export$83d89fbfd8236492 = "3.9.7";

});

parcelRegister("6DBa1", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d5335ea08031d5a$export$2e2bcd8739ae039);

var $krE5f = parcelRequire("krE5f");
var $4d5335ea08031d5a$export$2e2bcd8739ae039 = (0, $krE5f.maybe)(function() {
    return globalThis;
}) || (0, $krE5f.maybe)(function() {
    return window;
}) || (0, $krE5f.maybe)(function() {
    return self;
}) || (0, $krE5f.maybe)(function() {
    return $parcel$global;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
(0, $krE5f.maybe)(function() {
    return (0, $krE5f.maybe).constructor("return this")();
});

});
parcelRegister("krE5f", function(module, exports) {

$parcel$export(module.exports, "maybe", () => $ee256c06b8ecc7cd$export$f8b8b9ce72e9ccbf);
function $ee256c06b8ecc7cd$export$f8b8b9ce72e9ccbf(thunk) {
    try {
        return thunk();
    } catch (_a) {}
}

});


parcelRegister("dRSFQ", function(module, exports) {

$parcel$export(module.exports, "stringifyForDisplay", () => $a18aa2b11d8817a9$export$f341b4883239463f);

var $d9sqa = parcelRequire("d9sqa");
function $a18aa2b11d8817a9$export$f341b4883239463f(value, space) {
    if (space === void 0) space = 0;
    var undefId = (0, $d9sqa.makeUniqueId)("stringifyForDisplay");
    return JSON.stringify(value, function(key, value) {
        return value === void 0 ? undefId : value;
    }, space).split(JSON.stringify(undefId)).join("<undefined>");
}

});
parcelRegister("d9sqa", function(module, exports) {

$parcel$export(module.exports, "makeUniqueId", () => $993229712cdcf2bc$export$d0c8ec0fe1b18b70);
var $993229712cdcf2bc$var$prefixCounts = new Map();
function $993229712cdcf2bc$export$d0c8ec0fe1b18b70(prefix) {
    var count = $993229712cdcf2bc$var$prefixCounts.get(prefix) || 1;
    $993229712cdcf2bc$var$prefixCounts.set(prefix, count + 1);
    return "".concat(prefix, ":").concat(count, ":").concat(Math.random().toString(36).slice(2));
}

});




parcelRegister("6dwmd", function(module, exports) {

$parcel$export(module.exports, "makeReference", () => $486d0e72e514830e$export$634ae0e932e9be99);
$parcel$export(module.exports, "isReference", () => $486d0e72e514830e$export$fa99cac1c0883c47);
$parcel$export(module.exports, "isDocumentNode", () => $486d0e72e514830e$export$540432d49fcec6c9);
$parcel$export(module.exports, "valueToObjectRepresentation", () => $486d0e72e514830e$export$a1dab82d368d6525);
$parcel$export(module.exports, "storeKeyNameFromField", () => $486d0e72e514830e$export$54be8689c65f3b56);
$parcel$export(module.exports, "getStoreKeyName", () => $486d0e72e514830e$export$3cdb6c178b88cabe);
$parcel$export(module.exports, "argumentsObjectFromField", () => $486d0e72e514830e$export$3f5a60fb6a781b4f);
$parcel$export(module.exports, "resultKeyNameFromField", () => $486d0e72e514830e$export$7d1ad22471852218);
$parcel$export(module.exports, "getTypenameFromResult", () => $486d0e72e514830e$export$cf7bf7e4f289cc26);
$parcel$export(module.exports, "isField", () => $486d0e72e514830e$export$fb56ad75dd311c12);
$parcel$export(module.exports, "isInlineFragment", () => $486d0e72e514830e$export$22a1cdafaf27bcff);
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $1MCRf = parcelRequire("1MCRf");

var $iB2lh = parcelRequire("iB2lh");

var $5bIMC = parcelRequire("5bIMC");
function $486d0e72e514830e$export$634ae0e932e9be99(id) {
    return {
        __ref: String(id)
    };
}
function $486d0e72e514830e$export$fa99cac1c0883c47(obj) {
    return Boolean(obj && typeof obj === "object" && typeof obj.__ref === "string");
}
function $486d0e72e514830e$export$540432d49fcec6c9(value) {
    return (0, $1MCRf.isNonNullObject)(value) && value.kind === "Document" && Array.isArray(value.definitions);
}
function $486d0e72e514830e$var$isStringValue(value) {
    return value.kind === "StringValue";
}
function $486d0e72e514830e$var$isBooleanValue(value) {
    return value.kind === "BooleanValue";
}
function $486d0e72e514830e$var$isIntValue(value) {
    return value.kind === "IntValue";
}
function $486d0e72e514830e$var$isFloatValue(value) {
    return value.kind === "FloatValue";
}
function $486d0e72e514830e$var$isVariable(value) {
    return value.kind === "Variable";
}
function $486d0e72e514830e$var$isObjectValue(value) {
    return value.kind === "ObjectValue";
}
function $486d0e72e514830e$var$isListValue(value) {
    return value.kind === "ListValue";
}
function $486d0e72e514830e$var$isEnumValue(value) {
    return value.kind === "EnumValue";
}
function $486d0e72e514830e$var$isNullValue(value) {
    return value.kind === "NullValue";
}
function $486d0e72e514830e$export$a1dab82d368d6525(argObj, name, value, variables) {
    if ($486d0e72e514830e$var$isIntValue(value) || $486d0e72e514830e$var$isFloatValue(value)) argObj[name.value] = Number(value.value);
    else if ($486d0e72e514830e$var$isBooleanValue(value) || $486d0e72e514830e$var$isStringValue(value)) argObj[name.value] = value.value;
    else if ($486d0e72e514830e$var$isObjectValue(value)) {
        var nestedArgObj_1 = {};
        value.fields.map(function(obj) {
            return $486d0e72e514830e$export$a1dab82d368d6525(nestedArgObj_1, obj.name, obj.value, variables);
        });
        argObj[name.value] = nestedArgObj_1;
    } else if ($486d0e72e514830e$var$isVariable(value)) {
        var variableValue = (variables || {})[value.name.value];
        argObj[name.value] = variableValue;
    } else if ($486d0e72e514830e$var$isListValue(value)) argObj[name.value] = value.values.map(function(listValue) {
        var nestedArgArrayObj = {};
        $486d0e72e514830e$export$a1dab82d368d6525(nestedArgArrayObj, name, listValue, variables);
        return nestedArgArrayObj[name.value];
    });
    else if ($486d0e72e514830e$var$isEnumValue(value)) argObj[name.value] = value.value;
    else if ($486d0e72e514830e$var$isNullValue(value)) argObj[name.value] = null;
    else throw (0, $kL4FQ.newInvariantError)(82, name.value, value.kind);
}
function $486d0e72e514830e$export$54be8689c65f3b56(field, variables) {
    var directivesObj = null;
    if (field.directives) {
        directivesObj = {};
        field.directives.forEach(function(directive) {
            directivesObj[directive.name.value] = {};
            if (directive.arguments) directive.arguments.forEach(function(_a) {
                var name = _a.name, value = _a.value;
                return $486d0e72e514830e$export$a1dab82d368d6525(directivesObj[directive.name.value], name, value, variables);
            });
        });
    }
    var argObj = null;
    if (field.arguments && field.arguments.length) {
        argObj = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $486d0e72e514830e$export$a1dab82d368d6525(argObj, name, value, variables);
        });
    }
    return $486d0e72e514830e$export$3cdb6c178b88cabe(field.name.value, argObj, directivesObj);
}
var $486d0e72e514830e$var$KNOWN_DIRECTIVES = [
    "connection",
    "include",
    "skip",
    "client",
    "rest",
    "export",
    "nonreactive"
];
// Default stable JSON.stringify implementation used by getStoreKeyName. Can be
// updated/replaced with something better by calling
// getStoreKeyName.setStringify(newStringifyFunction).
var $486d0e72e514830e$var$storeKeyNameStringify = (0, $5bIMC.canonicalStringify);
var $486d0e72e514830e$export$3cdb6c178b88cabe = Object.assign(function(fieldName, args, directives) {
    if (args && directives && directives["connection"] && directives["connection"]["key"]) {
        if (directives["connection"]["filter"] && directives["connection"]["filter"].length > 0) {
            var filterKeys = directives["connection"]["filter"] ? directives["connection"]["filter"] : [];
            filterKeys.sort();
            var filteredArgs_1 = {};
            filterKeys.forEach(function(key) {
                filteredArgs_1[key] = args[key];
            });
            return "".concat(directives["connection"]["key"], "(").concat($486d0e72e514830e$var$storeKeyNameStringify(filteredArgs_1), ")");
        } else return directives["connection"]["key"];
    }
    var completeFieldName = fieldName;
    if (args) {
        // We can't use `JSON.stringify` here since it's non-deterministic,
        // and can lead to different store key names being created even though
        // the `args` object used during creation has the same properties/values.
        var stringifiedArgs = $486d0e72e514830e$var$storeKeyNameStringify(args);
        completeFieldName += "(".concat(stringifiedArgs, ")");
    }
    if (directives) Object.keys(directives).forEach(function(key) {
        if ($486d0e72e514830e$var$KNOWN_DIRECTIVES.indexOf(key) !== -1) return;
        if (directives[key] && Object.keys(directives[key]).length) completeFieldName += "@".concat(key, "(").concat($486d0e72e514830e$var$storeKeyNameStringify(directives[key]), ")");
        else completeFieldName += "@".concat(key);
    });
    return completeFieldName;
}, {
    setStringify: function(s) {
        var previous = $486d0e72e514830e$var$storeKeyNameStringify;
        $486d0e72e514830e$var$storeKeyNameStringify = s;
        return previous;
    }
});
function $486d0e72e514830e$export$3f5a60fb6a781b4f(field, variables) {
    if (field.arguments && field.arguments.length) {
        var argObj_1 = {};
        field.arguments.forEach(function(_a) {
            var name = _a.name, value = _a.value;
            return $486d0e72e514830e$export$a1dab82d368d6525(argObj_1, name, value, variables);
        });
        return argObj_1;
    }
    return null;
}
function $486d0e72e514830e$export$7d1ad22471852218(field) {
    return field.alias ? field.alias.value : field.name.value;
}
function $486d0e72e514830e$export$cf7bf7e4f289cc26(result, selectionSet, fragmentMap) {
    var fragments;
    for(var _i = 0, _a = selectionSet.selections; _i < _a.length; _i++){
        var selection = _a[_i];
        if ($486d0e72e514830e$export$fb56ad75dd311c12(selection)) {
            if (selection.name.value === "__typename") return result[$486d0e72e514830e$export$7d1ad22471852218(selection)];
        } else if (fragments) fragments.push(selection);
        else fragments = [
            selection
        ];
    }
    if (typeof result.__typename === "string") return result.__typename;
    if (fragments) for(var _b = 0, fragments_1 = fragments; _b < fragments_1.length; _b++){
        var selection = fragments_1[_b];
        var typename = $486d0e72e514830e$export$cf7bf7e4f289cc26(result, (0, $iB2lh.getFragmentFromSelection)(selection, fragmentMap).selectionSet, fragmentMap);
        if (typeof typename === "string") return typename;
    }
}
function $486d0e72e514830e$export$fb56ad75dd311c12(selection) {
    return selection.kind === "Field";
}
function $486d0e72e514830e$export$22a1cdafaf27bcff(selection) {
    return selection.kind === "InlineFragment";
}

});
parcelRegister("1MCRf", function(module, exports) {

$parcel$export(module.exports, "isNonNullObject", () => $14c86a848a7f87a7$export$417207af72fad9c9);
function $14c86a848a7f87a7$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $14c86a848a7f87a7$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}

});

parcelRegister("iB2lh", function(module, exports) {

$parcel$export(module.exports, "getFragmentQueryDocument", () => $d89d7fd01d11c446$export$abbf37c7cf644e41);
$parcel$export(module.exports, "createFragmentMap", () => $d89d7fd01d11c446$export$193789b4c8246dd4);
$parcel$export(module.exports, "getFragmentFromSelection", () => $d89d7fd01d11c446$export$f80bdb85f299186);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");
function $d89d7fd01d11c446$export$abbf37c7cf644e41(document, fragmentName) {
    var actualFragmentName = fragmentName;
    // Build an array of all our fragment definitions that will be used for
    // validations. We also do some validations on the other definitions in the
    // document while building this list.
    var fragments = [];
    document.definitions.forEach(function(definition) {
        // Throw an error if we encounter an operation definition because we will
        // define our own operation definition later on.
        if (definition.kind === "OperationDefinition") throw (0, $kL4FQ.newInvariantError)(71, definition.operation, definition.name ? " named '".concat(definition.name.value, "'") : "");
        // Add our definition to the fragments array if it is a fragment
        // definition.
        if (definition.kind === "FragmentDefinition") fragments.push(definition);
    });
    // If the user did not give us a fragment name then let us try to get a
    // name from a single fragment in the definition.
    if (typeof actualFragmentName === "undefined") {
        (0, $kL4FQ.invariant)(fragments.length === 1, 72, fragments.length);
        actualFragmentName = fragments[0].name.value;
    }
    // Generate a query document with an operation that simply spreads the
    // fragment inside of it.
    var query = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, document), {
        definitions: (0, $fKE23.__spreadArray)([
            {
                kind: "OperationDefinition",
                // OperationTypeNode is an enum
                operation: "query",
                selectionSet: {
                    kind: "SelectionSet",
                    selections: [
                        {
                            kind: "FragmentSpread",
                            name: {
                                kind: "Name",
                                value: actualFragmentName
                            }
                        }
                    ]
                }
            }
        ], document.definitions, true)
    });
    return query;
}
function $d89d7fd01d11c446$export$193789b4c8246dd4(fragments) {
    if (fragments === void 0) fragments = [];
    var symTable = {};
    fragments.forEach(function(fragment) {
        symTable[fragment.name.value] = fragment;
    });
    return symTable;
}
function $d89d7fd01d11c446$export$f80bdb85f299186(selection, fragmentMap) {
    switch(selection.kind){
        case "InlineFragment":
            return selection;
        case "FragmentSpread":
            var fragmentName = selection.name.value;
            if (typeof fragmentMap === "function") return fragmentMap(fragmentName);
            var fragment = fragmentMap && fragmentMap[fragmentName];
            (0, $kL4FQ.invariant)(fragment, 73, fragmentName);
            return fragment || null;
        default:
            return null;
    }
}

});

parcelRegister("5bIMC", function(module, exports) {

$parcel$export(module.exports, "canonicalStringify", () => $3c70b7dc051e3c82$export$88a0ad9b6f961b51);

var $czLrN = parcelRequire("czLrN");
var $7MpZC = parcelRequire("7MpZC");

var $7XZ8S = parcelRequire("7XZ8S");
var $3c70b7dc051e3c82$export$88a0ad9b6f961b51 = Object.assign(function canonicalStringify(value) {
    return JSON.stringify(value, $3c70b7dc051e3c82$var$stableObjectReplacer);
}, {
    reset: function() {
        // Clearing the sortingMap will reclaim all cached memory, without
        // affecting the logical results of canonicalStringify, but potentially
        // sacrificing performance until the cache is refilled.
        $3c70b7dc051e3c82$var$sortingMap = new (0, $czLrN.AutoCleanedStrongCache)((0, $7MpZC.cacheSizes).canonicalStringify || 1000 /* defaultCacheSizes.canonicalStringify */ );
    }
});
if (globalThis.__DEV__ !== false) (0, $7XZ8S.registerGlobalCache)("canonicalStringify", function() {
    return $3c70b7dc051e3c82$var$sortingMap.size;
});
// Values are JSON-serialized arrays of object keys (in any order), and values
// are sorted arrays of the same keys.
var $3c70b7dc051e3c82$var$sortingMap;
$3c70b7dc051e3c82$export$88a0ad9b6f961b51.reset();
// The JSON.stringify function takes an optional second argument called a
// replacer function. This function is called for each key-value pair in the
// object being stringified, and its return value is used instead of the
// original value. If the replacer function returns a new value, that value is
// stringified as JSON instead of the original value of the property.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/JSON/stringify#the_replacer_parameter
function $3c70b7dc051e3c82$var$stableObjectReplacer(key, value) {
    if (value && typeof value === "object") {
        var proto = Object.getPrototypeOf(value);
        // We don't want to mess with objects that are not "plain" objects, which
        // means their prototype is either Object.prototype or null. This check also
        // prevents needlessly rearranging the indices of arrays.
        if (proto === Object.prototype || proto === null) {
            var keys = Object.keys(value);
            // If keys is already sorted, let JSON.stringify serialize the original
            // value instead of creating a new object with keys in the same order.
            if (keys.every($3c70b7dc051e3c82$var$everyKeyInOrder)) return value;
            var unsortedKey = JSON.stringify(keys);
            var sortedKeys = $3c70b7dc051e3c82$var$sortingMap.get(unsortedKey);
            if (!sortedKeys) {
                keys.sort();
                var sortedKey = JSON.stringify(keys);
                // Checking for sortedKey in the sortingMap allows us to share the same
                // sorted array reference for all permutations of the same set of keys.
                sortedKeys = $3c70b7dc051e3c82$var$sortingMap.get(sortedKey) || keys;
                $3c70b7dc051e3c82$var$sortingMap.set(unsortedKey, sortedKeys);
                $3c70b7dc051e3c82$var$sortingMap.set(sortedKey, sortedKeys);
            }
            var sortedObject_1 = Object.create(proto);
            // Reassigning the keys in sorted order will cause JSON.stringify to
            // serialize them in sorted order.
            sortedKeys.forEach(function(key) {
                sortedObject_1[key] = value[key];
            });
            return sortedObject_1;
        }
    }
    return value;
}
// Since everything that happens in stableObjectReplacer benefits from being as
// efficient as possible, we use a static function as the callback for
// keys.every in order to test if the provided keys are already sorted without
// allocating extra memory for a callback.
function $3c70b7dc051e3c82$var$everyKeyInOrder(key, i, keys) {
    return i === 0 || keys[i - 1] <= key;
}

});
parcelRegister("czLrN", function(module, exports) {

$parcel$export(module.exports, "AutoCleanedWeakCache", () => $927d8ef842e4526d$export$8dbad6f439bb2331);
$parcel$export(module.exports, "AutoCleanedStrongCache", () => $927d8ef842e4526d$export$5b4f745137d91413);

var $16Gah = parcelRequire("16Gah");
var $kIv0I = parcelRequire("kIv0I");
var $927d8ef842e4526d$var$scheduledCleanup = new WeakSet();
function $927d8ef842e4526d$var$schedule(cache) {
    if (!$927d8ef842e4526d$var$scheduledCleanup.has(cache)) {
        $927d8ef842e4526d$var$scheduledCleanup.add(cache);
        setTimeout(function() {
            cache.clean();
            $927d8ef842e4526d$var$scheduledCleanup.delete(cache);
        }, 100);
    }
}
var $927d8ef842e4526d$export$8dbad6f439bb2331 = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $kIv0I.WeakCache)(max, dispose);
    cache.set = function(key, value) {
        $927d8ef842e4526d$var$schedule(this);
        return (0, $kIv0I.WeakCache).prototype.set.call(this, key, value);
    };
    return cache;
};
var $927d8ef842e4526d$export$5b4f745137d91413 = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $16Gah.StrongCache)(max, dispose);
    cache.set = function(key, value) {
        $927d8ef842e4526d$var$schedule(this);
        return (0, $16Gah.StrongCache).prototype.set.call(this, key, value);
    };
    return cache;
};

});
parcelRegister("16Gah", function(module, exports) {

$parcel$export(module.exports, "StrongCache", () => $0ce70f0c1c701074$export$d3a0331d2c286dc8);
function $0ce70f0c1c701074$var$defaultDispose() {}
class $0ce70f0c1c701074$export$d3a0331d2c286dc8 {
    constructor(max = Infinity, dispose = $0ce70f0c1c701074$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    get size() {
        return this.map.size;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.map.set(key, node);
        return node.value;
    }
    clean() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            if (node === this.newest) this.newest = node.older;
            if (node === this.oldest) this.oldest = node.newer;
            if (node.newer) node.newer.older = node.older;
            if (node.older) node.older.newer = node.newer;
            this.map.delete(key);
            this.dispose(node.value, key);
            return true;
        }
        return false;
    }
}

});

parcelRegister("kIv0I", function(module, exports) {

$parcel$export(module.exports, "WeakCache", () => $f14ff8c0b763f2b6$export$87b462129af3b7d4);
function $f14ff8c0b763f2b6$var$noop() {}
const $f14ff8c0b763f2b6$var$defaultDispose = $f14ff8c0b763f2b6$var$noop;
const $f14ff8c0b763f2b6$var$_WeakRef = typeof WeakRef !== "undefined" ? WeakRef : function(value) {
    return {
        deref: ()=>value
    };
};
const $f14ff8c0b763f2b6$var$_WeakMap = typeof WeakMap !== "undefined" ? WeakMap : Map;
const $f14ff8c0b763f2b6$var$_FinalizationRegistry = typeof FinalizationRegistry !== "undefined" ? FinalizationRegistry : function() {
    return {
        register: $f14ff8c0b763f2b6$var$noop,
        unregister: $f14ff8c0b763f2b6$var$noop
    };
};
const $f14ff8c0b763f2b6$var$finalizationBatchSize = 10024;
class $f14ff8c0b763f2b6$export$87b462129af3b7d4 {
    constructor(max = Infinity, dispose = $f14ff8c0b763f2b6$var$defaultDispose){
        this.max = max;
        this.dispose = dispose;
        this.map = new $f14ff8c0b763f2b6$var$_WeakMap();
        this.newest = null;
        this.oldest = null;
        this.unfinalizedNodes = new Set();
        this.finalizationScheduled = false;
        this.size = 0;
        this.finalize = ()=>{
            const iterator = this.unfinalizedNodes.values();
            for(let i = 0; i < $f14ff8c0b763f2b6$var$finalizationBatchSize; i++){
                const node = iterator.next().value;
                if (!node) break;
                this.unfinalizedNodes.delete(node);
                const key = node.key;
                delete node.key;
                node.keyRef = new $f14ff8c0b763f2b6$var$_WeakRef(key);
                this.registry.register(key, node, node);
            }
            if (this.unfinalizedNodes.size > 0) queueMicrotask(this.finalize);
            else this.finalizationScheduled = false;
        };
        this.registry = new $f14ff8c0b763f2b6$var$_FinalizationRegistry(this.deleteNode.bind(this));
    }
    has(key) {
        return this.map.has(key);
    }
    get(key) {
        const node = this.getNode(key);
        return node && node.value;
    }
    getNode(key) {
        const node = this.map.get(key);
        if (node && node !== this.newest) {
            const { older: older, newer: newer } = node;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            node.older = this.newest;
            node.older.newer = node;
            node.newer = null;
            this.newest = node;
            if (node === this.oldest) this.oldest = newer;
        }
        return node;
    }
    set(key, value) {
        let node = this.getNode(key);
        if (node) return node.value = value;
        node = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = node;
        this.newest = node;
        this.oldest = this.oldest || node;
        this.scheduleFinalization(node);
        this.map.set(key, node);
        this.size++;
        return node.value;
    }
    clean() {
        while(this.oldest && this.size > this.max)this.deleteNode(this.oldest);
    }
    deleteNode(node) {
        if (node === this.newest) this.newest = node.older;
        if (node === this.oldest) this.oldest = node.newer;
        if (node.newer) node.newer.older = node.older;
        if (node.older) node.older.newer = node.newer;
        this.size--;
        const key = node.key || node.keyRef && node.keyRef.deref();
        this.dispose(node.value, key);
        if (!node.keyRef) this.unfinalizedNodes.delete(node);
        else this.registry.unregister(node);
        if (key) this.map.delete(key);
    }
    delete(key) {
        const node = this.map.get(key);
        if (node) {
            this.deleteNode(node);
            return true;
        }
        return false;
    }
    scheduleFinalization(node) {
        this.unfinalizedNodes.add(node);
        if (!this.finalizationScheduled) {
            this.finalizationScheduled = true;
            queueMicrotask(this.finalize);
        }
    }
}

});


parcelRegister("7MpZC", function(module, exports) {

$parcel$export(module.exports, "cacheSizes", () => $5aa12dbafd6b8414$export$f29926b23b28936b);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");
var $6DBa1 = parcelRequire("6DBa1");
var $5aa12dbafd6b8414$var$cacheSizeSymbol = Symbol.for("apollo.cacheSize");
var $5aa12dbafd6b8414$export$f29926b23b28936b = (0, $fKE23.__assign)({}, (0, $6DBa1.default)[$5aa12dbafd6b8414$var$cacheSizeSymbol]);

});

parcelRegister("7XZ8S", function(module, exports) {

$parcel$export(module.exports, "registerGlobalCache", () => $5ccd78ad0c8037e6$export$a8fcd406d9e37621);
$parcel$export(module.exports, "getApolloClientMemoryInternals", () => $5ccd78ad0c8037e6$export$dfdba94ce46d2ea5);
$parcel$export(module.exports, "getInMemoryCacheMemoryInternals", () => $5ccd78ad0c8037e6$export$e95a5a2210e62466);
$parcel$export(module.exports, "getApolloCacheMemoryInternals", () => $5ccd78ad0c8037e6$export$e7ed438e82606689);

var $fKE23 = parcelRequire("fKE23");

var $7MpZC = parcelRequire("7MpZC");
var $5ccd78ad0c8037e6$var$globalCaches = {};
function $5ccd78ad0c8037e6$export$a8fcd406d9e37621(name, getSize) {
    $5ccd78ad0c8037e6$var$globalCaches[name] = getSize;
}
var $5ccd78ad0c8037e6$export$dfdba94ce46d2ea5 = globalThis.__DEV__ !== false ? $5ccd78ad0c8037e6$var$_getApolloClientMemoryInternals : undefined;
var $5ccd78ad0c8037e6$export$e95a5a2210e62466 = globalThis.__DEV__ !== false ? $5ccd78ad0c8037e6$var$_getInMemoryCacheMemoryInternals : undefined;
var $5ccd78ad0c8037e6$export$e7ed438e82606689 = globalThis.__DEV__ !== false ? $5ccd78ad0c8037e6$var$_getApolloCacheMemoryInternals : undefined;
function $5ccd78ad0c8037e6$var$getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */ ,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            (0, $7MpZC.cacheSizes)[k] || v
        ];
    }));
}
function $5ccd78ad0c8037e6$var$_getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false)) throw new Error("only supported in development mode");
    return {
        limits: $5ccd78ad0c8037e6$var$getCurrentCacheSizes(),
        sizes: (0, $fKE23.__assign)({
            print: (_a = $5ccd78ad0c8037e6$var$globalCaches.print) === null || _a === void 0 ? void 0 : _a.call($5ccd78ad0c8037e6$var$globalCaches),
            parser: (_b = $5ccd78ad0c8037e6$var$globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call($5ccd78ad0c8037e6$var$globalCaches),
            canonicalStringify: (_c = $5ccd78ad0c8037e6$var$globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call($5ccd78ad0c8037e6$var$globalCaches),
            links: $5ccd78ad0c8037e6$var$linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: $5ccd78ad0c8037e6$var$transformInfo(this["queryManager"].documentTransform)
            }
        }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d))
    };
}
function $5ccd78ad0c8037e6$var$_getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: $5ccd78ad0c8037e6$var$getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function $5ccd78ad0c8037e6$var$_getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $5ccd78ad0c8037e6$var$_getApolloCacheMemoryInternals.apply(this)), {
        addTypenameDocumentTransform: $5ccd78ad0c8037e6$var$transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: $5ccd78ad0c8037e6$var$getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: $5ccd78ad0c8037e6$var$getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: $5ccd78ad0c8037e6$var$getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: $5ccd78ad0c8037e6$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: $5ccd78ad0c8037e6$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: $5ccd78ad0c8037e6$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform)
        }
    });
}
function $5ccd78ad0c8037e6$var$isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function $5ccd78ad0c8037e6$var$getWrapperInformation(f) {
    return $5ccd78ad0c8037e6$var$isWrapper(f) ? f.size : undefined;
}
function $5ccd78ad0c8037e6$var$isDefined(value) {
    return value != null;
}
function $5ccd78ad0c8037e6$var$transformInfo(transform) {
    return $5ccd78ad0c8037e6$var$recurseTransformInfo(transform).map(function(cache) {
        return {
            cache: cache
        };
    });
}
function $5ccd78ad0c8037e6$var$recurseTransformInfo(transform) {
    return transform ? (0, $fKE23.__spreadArray)((0, $fKE23.__spreadArray)([
        $5ccd78ad0c8037e6$var$getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
    ], $5ccd78ad0c8037e6$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), $5ccd78ad0c8037e6$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter($5ccd78ad0c8037e6$var$isDefined) : [];
}
function $5ccd78ad0c8037e6$var$linkInfo(link) {
    var _a;
    return link ? (0, $fKE23.__spreadArray)((0, $fKE23.__spreadArray)([
        (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
    ], $5ccd78ad0c8037e6$var$linkInfo(link === null || link === void 0 ? void 0 : link.left), true), $5ccd78ad0c8037e6$var$linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter($5ccd78ad0c8037e6$var$isDefined) : [];
}

});





parcelRegister("5gt1S", function(module, exports) {

$parcel$export(module.exports, "transposeAppsConnection", () => $3d54f6fb5ba1208b$export$7c07b700b892c476);

var $5zQU9 = parcelRequire("5zQU9");
function $3d54f6fb5ba1208b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3d54f6fb5ba1208b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3d54f6fb5ba1208b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3d54f6fb5ba1208b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $3d54f6fb5ba1208b$var$transposeHighlightResult = (highlightResult)=>{
    return {
        __typename: '_HighlightResult',
        name: {
            __typename: 'HighlightResult',
            matchLevel: (highlightResult === null || highlightResult === void 0 ? void 0 : highlightResult.name.matchLevel) || '',
            value: (highlightResult === null || highlightResult === void 0 ? void 0 : highlightResult.name.value) || ''
        },
        tokenizedName: (highlightResult === null || highlightResult === void 0 ? void 0 : highlightResult.tokenizedName.map((item)=>({
                __typename: 'HighlightResult',
                matchLevel: item.matchLevel || '',
                value: item.value || ''
            }))) || [],
        tagLine: {
            __typename: 'HighlightResult',
            matchLevel: (highlightResult === null || highlightResult === void 0 ? void 0 : highlightResult.tagLine.matchLevel) || '',
            value: (highlightResult === null || highlightResult === void 0 ? void 0 : highlightResult.tagLine.value) || ''
        },
        tokenizedTagLine: (highlightResult === null || highlightResult === void 0 ? void 0 : highlightResult.tokenizedTagLine.map((item)=>({
                __typename: 'HighlightResult',
                matchLevel: item.matchLevel || '',
                value: item.value || ''
            }))) || []
    };
};
const $3d54f6fb5ba1208b$var$transposeAlgoliaHit = (_ref)=>{
    var _hit$tags, _hit$programs, _hit$programs$cloudFo, _hit$programs2, _hit$programs2$bugBou, _hit$programs2$bugBou2, _hit$programs3, _hit$programs3$bugBou, _hit$programs3$bugBou2, _hit$programs4, _hit$programs4$bugBou, _hit$programs4$bugBou2, _hit$vendor, _hit$vendor2, _hit$vendor3, _hit$vendor3$partnerT;
    let { hit: hit, query: query = '' } = _ref;
    return {
        __typename: 'AppTileEdge',
        node: $3d54f6fb5ba1208b$var$_objectSpread($3d54f6fb5ba1208b$var$_objectSpread({
            id: hit.addonId.toString() + query,
            __typename: 'AppTile'
        }, hit), {}, {
            logo: $3d54f6fb5ba1208b$var$_objectSpread({
                __typename: 'Logo',
                highRes: hit.logo.highRes || ''
            }, hit.logo),
            releaseDate: hit.releaseDate || null,
            tags: {
                __typename: 'MarketingTags',
                marketingLabels: ((_hit$tags = hit.tags) === null || _hit$tags === void 0 ? void 0 : _hit$tags.marketingLabels) || []
            },
            ratings: $3d54f6fb5ba1208b$var$_objectSpread({
                __typename: 'Ratings'
            }, hit.ratings),
            distribution: {
                __typename: 'Distribution',
                activeInstalls: hit.distribution.activeInstalls || 0,
                downloads: hit.distribution.downloads,
                bundled: hit.distribution.bundled
            },
            programs: {
                __typename: 'Programs',
                cloudFortified: {
                    __typename: 'CloudFortified',
                    status: ((_hit$programs = hit.programs) === null || _hit$programs === void 0 ? void 0 : (_hit$programs$cloudFo = _hit$programs.cloudFortified) === null || _hit$programs$cloudFo === void 0 ? void 0 : _hit$programs$cloudFo.status) || ''
                },
                bugBountyParticipant: {
                    __typename: 'BugBountyParticipant',
                    cloud: {
                        __typename: 'BugBountyStatus',
                        status: ((_hit$programs2 = hit.programs) === null || _hit$programs2 === void 0 ? void 0 : (_hit$programs2$bugBou = _hit$programs2.bugBountyParticipant) === null || _hit$programs2$bugBou === void 0 ? void 0 : (_hit$programs2$bugBou2 = _hit$programs2$bugBou.cloud) === null || _hit$programs2$bugBou2 === void 0 ? void 0 : _hit$programs2$bugBou2.status) || ''
                    },
                    server: {
                        __typename: 'BugBountyStatus',
                        status: ((_hit$programs3 = hit.programs) === null || _hit$programs3 === void 0 ? void 0 : (_hit$programs3$bugBou = _hit$programs3.bugBountyParticipant) === null || _hit$programs3$bugBou === void 0 ? void 0 : (_hit$programs3$bugBou2 = _hit$programs3$bugBou.server) === null || _hit$programs3$bugBou2 === void 0 ? void 0 : _hit$programs3$bugBou2.status) || ''
                    },
                    dataCenter: {
                        __typename: 'BugBountyStatus',
                        status: ((_hit$programs4 = hit.programs) === null || _hit$programs4 === void 0 ? void 0 : (_hit$programs4$bugBou = _hit$programs4.bugBountyParticipant) === null || _hit$programs4$bugBou === void 0 ? void 0 : (_hit$programs4$bugBou2 = _hit$programs4$bugBou.dataCenter) === null || _hit$programs4$bugBou2 === void 0 ? void 0 : _hit$programs4$bugBou2.status) || ''
                    }
                }
            },
            vendor: {
                __typename: 'Vendor',
                id: (_hit$vendor = hit.vendor) === null || _hit$vendor === void 0 ? void 0 : _hit$vendor.id,
                name: (_hit$vendor2 = hit.vendor) === null || _hit$vendor2 === void 0 ? void 0 : _hit$vendor2.name,
                partnerTier: {
                    __typename: 'PartnerTier',
                    type: ((_hit$vendor3 = hit.vendor) === null || _hit$vendor3 === void 0 ? void 0 : (_hit$vendor3$partnerT = _hit$vendor3.partnerTier) === null || _hit$vendor3$partnerT === void 0 ? void 0 : _hit$vendor3$partnerT.type) || ''
                }
            },
            _highlightResult: $3d54f6fb5ba1208b$var$transposeHighlightResult(hit._highlightResult)
        })
    };
};
const $3d54f6fb5ba1208b$export$7c07b700b892c476 = (_ref2)=>{
    let { customResponse: customResponse, query: query } = _ref2;
    const hits = customResponse === null || customResponse === void 0 ? void 0 : customResponse.results[0].hits;
    const currentPage = (customResponse === null || customResponse === void 0 ? void 0 : customResponse.results[0].page) || 0;
    const totalPages = (customResponse === null || customResponse === void 0 ? void 0 : customResponse.results[0].nbPages) || 0;
    const totalHits = (customResponse === null || customResponse === void 0 ? void 0 : customResponse.results[0].nbHits) || 0;
    return {
        __typename: 'AppsConnection',
        pageInfo: {
            __typename: 'AppConnectionPageInfo',
            totalCount: totalHits,
            hasNextPage: currentPage + 1 < totalPages
        },
        edges: hits === null || hits === void 0 ? void 0 : hits.map((hit)=>$3d54f6fb5ba1208b$var$transposeAlgoliaHit({
                hit: hit,
                query: query
            }))
    };
};

});

parcelRegister("kPBTo", function(module, exports) {

$parcel$export(module.exports, "transposeCategory", () => $f2a5f6bbb05de9d7$export$1d609f261d7d1136);
const $f2a5f6bbb05de9d7$export$1d609f261d7d1136 = (category)=>{
    return {
        __typename: 'MarketplaceStoreCategoryResponse',
        id: category === null || category === void 0 ? void 0 : category.id,
        slug: category === null || category === void 0 ? void 0 : category.slug,
        name: category === null || category === void 0 ? void 0 : category.name,
        heroSection: {
            __typename: 'MarketplaceStoreCategoryHeroSection',
            description: category === null || category === void 0 ? void 0 : category.heroSection.description,
            title: category === null || category === void 0 ? void 0 : category.heroSection.title,
            image: {
                __typename: 'MarketplaceStoreCategoryHeroSectionImage',
                altText: category === null || category === void 0 ? void 0 : category.heroSection.image.altText,
                url: category === null || category === void 0 ? void 0 : category.heroSection.image.url
            }
        }
    };
};

});


parcelRegister("kok63", function(module, exports) {

$parcel$export(module.exports, "CollectionHandler", () => $ed85a34dc0235314$export$322776df45aab62c);

var $5zQU9 = parcelRequire("5zQU9");

var $kBH4t = parcelRequire("kBH4t");

var $4SnSg = parcelRequire("4SnSg");
var $fucQH = parcelRequire("fucQH");

var $5gt1S = parcelRequire("5gt1S");
var $ed85a34dc0235314$var$GetCollectionBffQuery = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetCollectionBff"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "slug"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceStore"
                        },
                        arguments: [],
                        directives: [
                            {
                                kind: "Directive",
                                name: {
                                    kind: "Name",
                                    value: "optIn"
                                },
                                arguments: [
                                    {
                                        kind: "Argument",
                                        name: {
                                            kind: "Name",
                                            value: "to"
                                        },
                                        value: {
                                            kind: "ListValue",
                                            values: [
                                                {
                                                    kind: "StringValue",
                                                    value: "MarketplaceStoreCollection",
                                                    block: false
                                                }
                                            ]
                                        }
                                    }
                                ]
                            }
                        ],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "collection"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "slug"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "slug"
                                                }
                                            }
                                        }
                                    ],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "name"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "slug"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "heroSection"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "description"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "backgroundColor"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "image"
                                                            },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "url"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "altText"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "title"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "useCases"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "heading"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "values"
                                                            },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "description"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "title"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "algoliaQueryMetadata"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "filters"
                                                            },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "key"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "value"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "searchIndex"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "sort"
                                                            },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "criteria"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 590,
        source: {
            body: "query GetCollectionBff($slug: String!) {\n  marketplaceStore @optIn(to: [\"MarketplaceStoreCollection\"]) {\n    collection(slug: $slug) {\n      id\n      name\n      slug\n\n      heroSection {\n        description\n        backgroundColor\n        image {\n          url\n          altText\n        }\n        title\n      }\n\n      useCases {\n        heading\n        values {\n          description\n          title\n        }\n      }\n\n      algoliaQueryMetadata {\n        filters {\n          key\n          value\n        }\n        searchIndex\n        sort {\n          criteria\n        }\n      }\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
class $ed85a34dc0235314$export$322776df45aab62c extends (0, $4SnSg.BaseHandler) {
    constructor(algoliaSearchConfig){
        super();
        (0, $5zQU9.default)(this, "algoliaSearch", void 0);
        this.algoliaSearch = new (0, $kBH4t.AlgoliaSearchV2)(algoliaSearchConfig);
    }
    requestTransformer(operation, _sequenceConfigValue) {
        // TODO: type the variables properly
        const newOperation = (0, $fucQH.copyToNewQueryOperation)(operation, $ed85a34dc0235314$var$GetCollectionBffQuery, (_ref)=>{
            let { slug: slug } = _ref;
            return {
                slug: slug
            };
        });
        return newOperation;
    }
    fetchCustom(operation, _transformedOperation, _sequenceConfigValue, primaryResponse) {
        const collection = primaryResponse === null || primaryResponse === void 0 ? void 0 : primaryResponse.marketplaceStore.collection;
        if (!collection) throw new Error('NOT_FOUND');
        if (!(collection !== null && collection !== void 0 && collection.algoliaQueryMetadata)) throw new Error('Algolia query metadata not found');
        const { first: first, after: after, sort: sort } = operation.variables;
        return this.algoliaSearch.setAlgoliaMetaDataIndexAndFilters(collection.algoliaQueryMetadata).setSortIndexAndFilters(sort).search({
            after: after,
            first: first
        });
    }
    responseTransformer(operation, _transformedOperation, _sequenceConfigValue, primaryResponse, customResponse) {
        const { skipCollection: skipCollection } = operation.variables;
        const collection = primaryResponse === null || primaryResponse === void 0 ? void 0 : primaryResponse.marketplaceStore.collection;
        if (!collection) throw new Error('Collection not found');
        if (!customResponse || (customResponse === null || customResponse === void 0 ? void 0 : customResponse.results[0].hits.length) === 0) throw new Error('No apps found for the collection');
        return {
            marketplaceCollection: {
                id: collection.id,
                collection: skipCollection ? undefined : collection,
                apps: (0, $5gt1S.transposeAppsConnection)({
                    customResponse: customResponse
                })
            }
        };
    }
}

});

parcelRegister("92iHj", function(module, exports) {

$parcel$export(module.exports, "HomeHandler", () => $6942cdeb16de852f$export$c0221190ab01acd4);

var $5zQU9 = parcelRequire("5zQU9");

var $9qqD0 = parcelRequire("9qqD0");

var $kBH4t = parcelRequire("kBH4t");

var $4SnSg = parcelRequire("4SnSg");
var $fucQH = parcelRequire("fucQH");

var $lSGqE = parcelRequire("lSGqE");

var $eojWH = parcelRequire("eojWH");
var $6942cdeb16de852f$var$GetHomePageSections = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetHomePageSections"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "productId"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "String"
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceStore"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "homePage"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "productId"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "productId"
                                                }
                                            }
                                        }
                                    ],
                                    directives: [
                                        {
                                            kind: "Directive",
                                            name: {
                                                kind: "Name",
                                                value: "optIn"
                                            },
                                            arguments: [
                                                {
                                                    kind: "Argument",
                                                    name: {
                                                        kind: "Name",
                                                        value: "to"
                                                    },
                                                    value: {
                                                        kind: "StringValue",
                                                        value: "MarketplaceStoreHomePage",
                                                        block: false
                                                    }
                                                }
                                            ]
                                        }
                                    ],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "sections"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "__typename"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "InlineFragment",
                                                            typeCondition: {
                                                                kind: "NamedType",
                                                                name: {
                                                                    kind: "Name",
                                                                    value: "MarketplaceStoreHomePageRegularSection"
                                                                }
                                                            },
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "title"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "description"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "navigationUrl"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "appsFetchCount"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "screenSpecificProperties"
                                                                        },
                                                                        arguments: [],
                                                                        directives: [],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "lg"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "appsCount"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "hideDescription"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "md"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "appsCount"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "hideDescription"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "sm"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "appsCount"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "hideDescription"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "algoliaQueryMetadata"
                                                                        },
                                                                        arguments: [],
                                                                        directives: [],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "searchIndex"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: []
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "filter"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "marketingLabels"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "filters"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "key"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "value"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "sort"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "criteria"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        },
                                                        {
                                                            kind: "InlineFragment",
                                                            typeCondition: {
                                                                kind: "NamedType",
                                                                name: {
                                                                    kind: "Name",
                                                                    value: "MarketplaceStoreHomePageHighlightedSection"
                                                                }
                                                            },
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "title"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "description"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "navigationUrl"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "appsFetchCount"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "screenSpecificProperties"
                                                                        },
                                                                        arguments: [],
                                                                        directives: [],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "lg"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "appsCount"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "hideDescription"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "md"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "appsCount"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "hideDescription"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "sm"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "appsCount"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "hideDescription"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "algoliaQueryMetadata"
                                                                        },
                                                                        arguments: [],
                                                                        directives: [],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "searchIndex"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: []
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "filter"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "marketingLabels"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "filters"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "key"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            },
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "value"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                },
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "sort"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "criteria"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "highlightVariation"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 1703,
        source: {
            body: "query GetHomePageSections($productId: String) {\n  marketplaceStore {\n    homePage(productId: $productId) @optIn(to: \"MarketplaceStoreHomePage\") {\n      sections {\n        __typename\n        ... on MarketplaceStoreHomePageRegularSection {\n          id\n          title\n          description\n          navigationUrl\n          appsFetchCount\n          screenSpecificProperties {\n            lg {\n              appsCount\n              hideDescription\n            }\n            md {\n              appsCount\n              hideDescription\n            }\n            sm {\n              appsCount\n              hideDescription\n            }\n          }\n          algoliaQueryMetadata {\n            searchIndex\n            filter {\n              marketingLabels\n            }\n            filters {\n              key\n              value\n            }\n            sort {\n              criteria\n            }\n          }\n        }\n        ... on MarketplaceStoreHomePageHighlightedSection {\n          id\n          title\n          description\n          navigationUrl\n          appsFetchCount\n          screenSpecificProperties {\n            lg {\n              appsCount\n              hideDescription\n            }\n            md {\n              appsCount\n              hideDescription\n            }\n            sm {\n              appsCount\n              hideDescription\n            }\n          }\n          algoliaQueryMetadata {\n            searchIndex\n            filter {\n              marketingLabels\n            }\n            filters {\n              key\n              value\n            }\n            sort {\n              criteria\n            }\n          }\n          highlightVariation\n        }\n      }\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
class $6942cdeb16de852f$export$c0221190ab01acd4 extends (0, $4SnSg.BaseHandler) {
    constructor(algoliaConfig){
        super();
        (0, $5zQU9.default)(this, "algoliaConfig", void 0);
        (0, $5zQU9.default)(this, "enterpriseAppsSection", void 0);
        this.algoliaConfig = algoliaConfig;
        this.enterpriseAppsSection = Promise.resolve({
            results: []
        });
    }
    requestTransformer(operation, _sequenceConfigValue) {
        const newOperation = (0, $fucQH.copyToNewQueryOperation)(operation, $6942cdeb16de852f$var$GetHomePageSections, (_ref)=>{
            let { productId: productId } = _ref;
            return {
                productId: productId
            };
        });
        return newOperation;
    }
    // we are using first as 1 to fetch the enterprise apps section and after as 1 to fetch the rest of the sections
    async fetchCustom(operation, _transformedOperation, _sequenceConfigValue, primaryResponse) {
        let newResponse = [];
        const { productId: productId, after: after, first: first } = operation.variables;
        if (first === 1) {
            const productFilter = productId ? [
                "version.compatibilities.applicationKey:".concat((0, $9qqD0.COMPATIBLE_PRODUCT_FILTER_VALUES)[productId])
            ] : [];
            this.enterpriseAppsSection = (0, $kBH4t.AlgoliaSearchV3)({
                applicationId: this.algoliaConfig.algoliaAppId,
                apiKey: this.algoliaConfig.algoliaApiKey,
                indexName: this.algoliaConfig.algoliaSearchIndex,
                attributesToHighlight: [],
                attributesToRetrieve: (0, $lSGqE.AttributesToRetrieve),
                facetFilters: [
                    'programs.cloudFortified.status:approved',
                    ...productFilter
                ],
                hitsPerPage: 6
            });
            const enterpriseAppsResponse = await this.enterpriseAppsSection;
            if (!enterpriseAppsResponse) throw new Error('ENTERPRISE_APPS_NOT_FOUND');
            const { hits: hits } = enterpriseAppsResponse.results[0];
            if (hits && hits.length > 0) newResponse = [
                (0, $eojWH.transformEnterpriseAppsSection)(enterpriseAppsResponse, productId)
            ];
        } else if (after === 1) {
            var _response$results$;
            const response = await this.enterpriseAppsSection;
            const additionalFilters = (_response$results$ = response.results[0]) === null || _response$results$ === void 0 ? void 0 : _response$results$.hits.map((app)=>"addonKey:-".concat(app.addonKey));
            newResponse = await (0, $eojWH.getTransformSectionsApps)({
                primaryResponse: primaryResponse,
                additionalFilters: additionalFilters,
                algoliaConfig: this.algoliaConfig,
                productId: productId
            });
            if (newResponse.length === 0) throw new Error('SECTIONS_APPS_NOT_FOUND');
        }
        return newResponse;
    }
    responseTransformer(operation, _transformedOperation, _sequenceConfigValue, _primaryResponse, customResponse) {
        const { productId: productId = 'home', first: first } = operation.variables;
        const newResponse = {
            marketplaceHome: {
                id: first === 1 ? "enterpriseAppsSection__".concat(productId) : "sectionsApps__".concat(productId),
                sections: customResponse
            }
        };
        return newResponse;
    }
}

});
parcelRegister("lSGqE", function(module, exports) {

$parcel$export(module.exports, "AttributesToRetrieve", () => $fedf8d9eb4bbf5f4$export$9babc0b927491b64);
$parcel$export(module.exports, "EnterpriseAppsSectionMetaData", () => $fedf8d9eb4bbf5f4$export$787d944f27db5663);
const $fedf8d9eb4bbf5f4$export$9babc0b927491b64 = [
    '*',
    '-tokenizedName',
    '-tokenizedTagLine',
    '-summary'
];
const $fedf8d9eb4bbf5f4$export$787d944f27db5663 = {
    id: 'enterpriseAppsSection',
    title: 'Cloud Fortified apps',
    description: "Cloud apps with additional security, reliability, and support to meet your organization's needs."
};

});

parcelRegister("eojWH", function(module, exports) {

$parcel$export(module.exports, "transformEnterpriseAppsSection", () => $a7a2c766ca7fd0be$export$7afb2a7f7c7653f5);
$parcel$export(module.exports, "getTransformSectionsApps", () => $a7a2c766ca7fd0be$export$13898e2308cca6f3);

var $5zQU9 = parcelRequire("5zQU9");

var $9qqD0 = parcelRequire("9qqD0");
var $er4rv = parcelRequire("er4rv");

var $aqjZk = parcelRequire("aqjZk");

var $kBH4t = parcelRequire("kBH4t");

var $5gt1S = parcelRequire("5gt1S");

var $lSGqE = parcelRequire("lSGqE");
function $a7a2c766ca7fd0be$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a7a2c766ca7fd0be$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a7a2c766ca7fd0be$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a7a2c766ca7fd0be$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a7a2c766ca7fd0be$export$7afb2a7f7c7653f5 = (sectionResponse, productId)=>{
    var _transposeAppsConnect, _transposeAppsConnect2;
    let navigationUrl = "/search?".concat((0, $9qqD0.FILTER_KEYS).TRUST_SIGNALS, "=").concat((0, $9qqD0.FILTER_KEYS).CLOUD_FORTIFIED);
    if (productId) navigationUrl += "&".concat((0, $9qqD0.FILTER_KEYS).PRODUCT, "=").concat((0, $9qqD0.COMPATIBLE_PRODUCT_FILTER_VALUES)[productId]);
    const enterpriseAppsSection = $a7a2c766ca7fd0be$var$_objectSpread($a7a2c766ca7fd0be$var$_objectSpread({}, (0, $lSGqE.EnterpriseAppsSectionMetaData)), {}, {
        __typename: 'MarketplaceStoreHomePageEnterpriseSection',
        id: "".concat((0, $lSGqE.EnterpriseAppsSectionMetaData).id, "__").concat(productId || 'home'),
        navigationUrl: navigationUrl,
        apps: ((_transposeAppsConnect = (0, $5gt1S.transposeAppsConnection)({
            customResponse: sectionResponse
        })) === null || _transposeAppsConnect === void 0 ? void 0 : (_transposeAppsConnect2 = _transposeAppsConnect.edges) === null || _transposeAppsConnect2 === void 0 ? void 0 : _transposeAppsConnect2.map((edge)=>edge.node)) || []
    });
    return enterpriseAppsSection;
};
const $a7a2c766ca7fd0be$export$51944fe5eadcb13a = (_ref)=>{
    let { sectionsMetaInfo: sectionsMetaInfo, sectionsAppsData: sectionsAppsData, productId: productId } = _ref;
    const sectionsApps = [];
    sectionsMetaInfo.forEach((section, index)=>{
        const sectionResponse = sectionsAppsData[index];
        const { hits: hits } = sectionResponse.results[0];
        if (hits && hits.length > 0) {
            var _transposeAppsConnect3, _transposeAppsConnect4;
            sectionsApps.push($a7a2c766ca7fd0be$var$_objectSpread($a7a2c766ca7fd0be$var$_objectSpread({}, section), {}, {
                id: "".concat(section.id, "__").concat(productId || 'home'),
                apps: (0, (/*@__PURE__*/$parcel$interopDefault($aqjZk)))((_transposeAppsConnect3 = (0, $5gt1S.transposeAppsConnection)({
                    customResponse: sectionResponse
                })) === null || _transposeAppsConnect3 === void 0 ? void 0 : (_transposeAppsConnect4 = _transposeAppsConnect3.edges) === null || _transposeAppsConnect4 === void 0 ? void 0 : _transposeAppsConnect4.map((edge)=>edge.node)) || []
            }));
        }
    });
    return sectionsApps;
};
const $a7a2c766ca7fd0be$export$13898e2308cca6f3 = async (_ref2)=>{
    var _primaryResponse$mark, _primaryResponse$mark2;
    let { primaryResponse: primaryResponse, additionalFilters: additionalFilters, algoliaConfig: algoliaConfig, productId: productId } = _ref2;
    const sectionsMetaInfo = primaryResponse === null || primaryResponse === void 0 ? void 0 : (_primaryResponse$mark = primaryResponse.marketplaceStore) === null || _primaryResponse$mark === void 0 ? void 0 : (_primaryResponse$mark2 = _primaryResponse$mark.homePage) === null || _primaryResponse$mark2 === void 0 ? void 0 : _primaryResponse$mark2.sections.filter((section)=>section.__typename !== 'MarketplaceStoreHomePageFeaturedSection');
    let sectionsApps = [];
    if (sectionsMetaInfo && sectionsMetaInfo.length > 0) {
        const sectionsAppsData = await Promise.all(sectionsMetaInfo.map((section)=>{
            let facetFilters = [];
            facetFilters = (0, $er4rv.createAlgoliaFacetFiltersFromQueryMetaData)(section.algoliaQueryMetadata);
            if (additionalFilters && additionalFilters.length > 0) facetFilters.push(...additionalFilters);
            return (0, $kBH4t.AlgoliaSearchV3)({
                applicationId: algoliaConfig.algoliaAppId,
                apiKey: algoliaConfig.algoliaApiKey,
                indexName: section.algoliaQueryMetadata.searchIndex,
                attributesToHighlight: [],
                attributesToRetrieve: (0, $lSGqE.AttributesToRetrieve),
                facetFilters: facetFilters,
                hitsPerPage: section.appsFetchCount
            });
        }));
        sectionsApps = $a7a2c766ca7fd0be$export$51944fe5eadcb13a({
            sectionsMetaInfo: sectionsMetaInfo,
            sectionsAppsData: sectionsAppsData,
            productId: productId
        });
    }
    return sectionsApps;
};

});


parcelRegister("7ME9W", function(module, exports) {

$parcel$export(module.exports, "SearchFiltersHandler", () => $5aac2aec7d0bb912$export$fcbbac134fd701b9);

var $5zQU9 = parcelRequire("5zQU9");

var $4SnSg = parcelRequire("4SnSg");

var $ar42P = parcelRequire("ar42P");

var $9PBoU = parcelRequire("9PBoU");
class $5aac2aec7d0bb912$export$fcbbac134fd701b9 extends (0, $4SnSg.BaseHandler) {
    constructor(stargateBaseUrl, ldFeatureFlags, statsigClient){
        super();
        (0, $5zQU9.default)(this, "stargateBaseUrl", void 0);
        (0, $5zQU9.default)(this, "statsigClient", void 0);
        (0, $5zQU9.default)(this, "ldFeatureFlags", void 0);
        this.stargateBaseUrl = stargateBaseUrl;
        this.ldFeatureFlags = ldFeatureFlags;
        this.statsigClient = statsigClient;
    }
    async getFilterById(filterId) {
        try {
            const options = await (0, $ar42P.default)({
                ldFeatureFlags: this.ldFeatureFlags,
                filterId: filterId,
                stargateBaseUrl: this.stargateBaseUrl,
                statsigClient: this.statsigClient
            });
            return (0, $9PBoU.transposeFilterOptions)({
                options: options,
                filterId: filterId
            });
        } catch (error) {
            return (0, $9PBoU.transposeFilterError)({
                message: error.messsage,
                filterId: filterId
            });
        }
    }
    async fetchCustom(operation, _transformedOperation, _sequenceConfigValue, _primaryResponse) {
        const variables = operation.variables;
        if (typeof variables.filterIds === 'string') {
            const filter = await this.getFilterById(variables.filterIds);
            return [
                filter
            ];
        }
        const filters = await Promise.all(variables.filterIds.map((filterId)=>this.getFilterById(filterId)));
        return filters;
    }
    responseTransformer(_operation, _transformedOperation, _sequenceConfigValue, _primaryResponse, customResponse) {
        return {
            marketplaceFilters: customResponse
        };
    }
}

});
parcelRegister("ar42P", function(module, exports) {

$parcel$export(module.exports, "default", () => $798f902dee607718$export$2e2bcd8739ae039);

var $8oBsT = parcelRequire("8oBsT");

var $6Gtik = parcelRequire("6Gtik");

var $iRKDr = parcelRequire("iRKDr");

var $aHkyP = parcelRequire("aHkyP");

var $7GyLv = parcelRequire("7GyLv");

var $fwkB5 = parcelRequire("fwkB5");

var $aH4yQ = parcelRequire("aH4yQ");
const $798f902dee607718$var$SearchFilters = async (filterParams)=>{
    switch(filterParams.filterId){
        case 'product':
            return (0, $7GyLv.ProductFilters)(filterParams);
        case 'hosting':
            return (0, $6Gtik.HostingFilters)();
        case 'price':
            return (0, $aHkyP.PricingFilters)();
        case 'trustSignals':
            return (0, $fwkB5.TrustFilters)();
        case 'other':
            return (0, $iRKDr.OtherFilters)();
        case 'useCases':
        case 'categories':
            {
                const response = await (0, $8oBsT.CategoriesUsecasesFilter)(filterParams.stargateBaseUrl);
                if (filterParams.filterId === 'useCases') return response.useCases.options;
                else return response.categories.options;
            }
        case 'versionHistoryHosting':
            return (0, $aH4yQ.VersionHistoryHostingFilters)();
        default:
            throw new Error("Unknown filterId");
    }
};
var $798f902dee607718$export$2e2bcd8739ae039 = $798f902dee607718$var$SearchFilters;

});
parcelRegister("8oBsT", function(module, exports) {

$parcel$export(module.exports, "CategoriesUsecasesFilter", () => $61cda060a6afc229$export$647f90ea4aad35bb);

var $jqvCZ = parcelRequire("jqvCZ");

var $ePBWS = parcelRequire("ePBWS");

var $d0lX0 = parcelRequire("d0lX0");
const $61cda060a6afc229$export$8215956e5bebe7d3 = (0, (/*@__PURE__*/$parcel$interopDefault($jqvCZ)))(async (stargateBaseUrl)=>{
    try {
        const serviceResponse = await (0, $ePBWS.GetProductCategoryAndKeywords)({
            stargateBaseUrl: stargateBaseUrl
        });
        return (0, $d0lX0.transposeProductTagsToFilters)({
            data: serviceResponse
        });
    } catch (error) {
        throw new Error('Error in SearchFiltersHandler');
    }
});
const $61cda060a6afc229$export$647f90ea4aad35bb = async (stargateBaseUrl)=>{
    try {
        return await $61cda060a6afc229$export$8215956e5bebe7d3(stargateBaseUrl);
    } catch (error) {
        $61cda060a6afc229$export$8215956e5bebe7d3.cache.delete(stargateBaseUrl);
        throw error;
    }
};

});
parcelRegister("ePBWS", function(module, exports) {

$parcel$export(module.exports, "GetProductCategoryAndKeywords", () => $acc343e79470b6bc$export$2f10ec6ba2a43efd);

var $dO8LH = parcelRequire("dO8LH");
const $acc343e79470b6bc$export$2f10ec6ba2a43efd = async (_ref)=>{
    let { stargateBaseUrl: stargateBaseUrl } = _ref;
    const response = await (0, $dO8LH.fetchOk)("".concat(stargateBaseUrl, "/marketplace/rest/1/product-tags"));
    return response.json();
};

});

parcelRegister("d0lX0", function(module, exports) {

$parcel$export(module.exports, "transposeProductTagsToFilters", () => $977c4d658c4eef77$export$cb7ff140709fbc42);
/**
 * Transposes product tags into filters.
 *
 * This function groups product tags by their types and constructs filter options for each type.
 * Each filter option includes the name of the tag as the label, and the id of the tag as the optionId and value.
 *
 * @returns {Object} groupedByTagType - An object where each property is a tag type, and the value is an array of filter options corresponding to that tag type.
 */ function $977c4d658c4eef77$export$cb7ff140709fbc42(_ref) {
    let { data: data } = _ref;
    // Reduce function is used to transform the array of tags into an object where keys are tag types and values are arrays of corresponding filter options.
    const groupedByTagType = data.values.reduce((accumulator, _ref2)=>{
        let { tagType: tagType, name: name, id: id } = _ref2;
        const option = {
            label: name,
            id: name,
            value: id
        };
        // If the accumulator object doesn't have a property corresponding to the current tag type, create it and assign an empty array as its value.
        if (!accumulator[tagType]) accumulator[tagType] = {
            options: [
                option
            ]
        };
        else // Push a new filter option into the array corresponding to the current tag type.
        accumulator[tagType].options.push({
            label: name,
            id: name,
            value: id
        });
        return accumulator;
    }, {});
    return {
        categories: groupedByTagType.CATEGORY,
        useCases: groupedByTagType.KEYWORDS
    };
}

});


parcelRegister("iRKDr", function(module, exports) {

$parcel$export(module.exports, "OtherFilters", () => $dbc159fc85e6610f$export$1b999e79b041f5e2);
const $dbc159fc85e6610f$export$1b999e79b041f5e2 = ()=>{
    return [
        {
            label: 'Beta',
            id: 'stable',
            value: 'false'
        },
        {
            label: 'Partner supported',
            id: 'vendorSupported',
            value: 'true'
        }
    ];
};

});

parcelRegister("aHkyP", function(module, exports) {

$parcel$export(module.exports, "PricingFilters", () => $7c9dde761a684211$export$d6c27998c3c23b05);
const $7c9dde761a684211$export$d6c27998c3c23b05 = ()=>{
    return [
        {
            label: 'Free for all teams',
            id: 'paid',
            value: 'false'
        },
        {
            label: 'Free up to 10 users',
            id: 'freeStarterTier',
            value: 'enabled'
        }
    ];
};

});

parcelRegister("7GyLv", function(module, exports) {

$parcel$export(module.exports, "ProductFilters", () => $59876c5153d8ce9b$export$9c2d185d31b92d37);
const $59876c5153d8ce9b$export$9c2d185d31b92d37 = (_ref)=>{
    let { statsigClient: statsigClient } = _ref;
    const response = [
        {
            label: 'Jira',
            id: 'jira',
            value: 'jira'
        },
        {
            label: 'Jira Service Management',
            id: 'jira-service-desk',
            value: 'jira-service-desk'
        },
        {
            label: 'Confluence',
            id: 'confluence',
            value: 'confluence'
        },
        {
            label: 'Bitbucket',
            id: 'bitbucket',
            value: 'bitbucket'
        },
        {
            label: 'Fisheye/Crucible',
            id: 'fecru',
            value: 'fecru'
        },
        {
            label: 'Bamboo',
            id: 'bamboo',
            value: 'bamboo'
        },
        {
            label: 'Crowd',
            id: 'crowd',
            value: 'crowd'
        }
    ];
    if (statsigClient.showCompassApps()) response.push({
        label: 'Compass',
        id: 'compass',
        value: 'compass'
    });
    return response;
};

});

parcelRegister("fwkB5", function(module, exports) {

$parcel$export(module.exports, "TrustFilters", () => $02ea7b227619668f$export$a070d59bf76885f8);
const $02ea7b227619668f$export$a070d59bf76885f8 = ()=>{
    return [
        {
            label: 'Cloud Fortified',
            id: 'cloudFortified',
            value: 'approved'
        },
        {
            label: 'Cloud Security Participant',
            id: 'bugBountyParticipant',
            value: 'bugBountyApproved'
        }
    ];
};

});

parcelRegister("aH4yQ", function(module, exports) {

$parcel$export(module.exports, "VersionHistoryHostingFilters", () => $7c91753b9fc563c5$export$8c75c05ee3dc11d8);

var $7R7Sq = parcelRequire("7R7Sq");

var $6Gtik = parcelRequire("6Gtik");
const $7c91753b9fc563c5$export$8c75c05ee3dc11d8 = ()=>{
    return [
        {
            label: 'Data Center',
            id: (0, $6Gtik.HostingTypes).DATA_CENTER,
            value: (0, $7R7Sq.AtlassianProductHostingType).DataCenter
        },
        {
            label: 'Server',
            id: (0, $6Gtik.HostingTypes).SERVER,
            value: (0, $7R7Sq.AtlassianProductHostingType).Server
        }
    ];
};

});
parcelRegister("7R7Sq", function(module, exports) {

$parcel$export(module.exports, "AtlassianProductHostingType", () => $5b8397cef71e8614$export$38d407d6909984c2);
$parcel$export(module.exports, "MarketplaceAppPaymentModel", () => $5b8397cef71e8614$export$f25ba44b203e3645);
$parcel$export(module.exports, "MarketplaceEntityStatus", () => $5b8397cef71e8614$export$8b7b15f5e0317b5a);
$parcel$export(module.exports, "MarketplaceListingStatus", () => $5b8397cef71e8614$export$1a1d4383d2498aa8);
/**
 *   This file is auto-generated.
 *   Any manual changes done could be lost.
 **/ /** All built-in and custom scalars, mapped to their actual values */ let $5b8397cef71e8614$export$1798210ae1009578 = /*#__PURE__*/ function(AcceptableResponse) {
    AcceptableResponse["False"] = "FALSE";
    AcceptableResponse["NotApplicable"] = "NOT_APPLICABLE";
    AcceptableResponse["True"] = "TRUE";
    return AcceptableResponse;
}({}); /**
 * "
 * The lifecycle status of the account
 */ 
let $5b8397cef71e8614$export$3693f74db10d5f88 = /*#__PURE__*/ function(AccountStatus) {
    AccountStatus["Active"] = "active";
    AccountStatus["Closed"] = "closed";
    AccountStatus["Inactive"] = "inactive";
    return AccountStatus;
}({}); /** An action that an app implements */  /** A type of action that an app can implement */  /** An app and the actions it supports */ 
let $5b8397cef71e8614$export$db8ac507a39ab8b4 = /*#__PURE__*/ function(ActionsAuthType) {
    ActionsAuthType["ThreeLegged"] = "THREE_LEGGED";
    ActionsAuthType["TwoLegged"] = "TWO_LEGGED";
    return ActionsAuthType;
}({}); /** Description for the action or action input */  /** --------------------------------------- activity_api_v2.graphqls */  /** --------------------------------------- activity_api_v2.graphqls */  /** --------------------------------------- activity_api_v2.graphqls */  /** Extension of ActivitiesEvent, is a part of ActivitiesEventExtension union */ 
let $5b8397cef71e8614$export$d36a88022706d185 = /*#__PURE__*/ function(ActivitiesContainerType) {
    ActivitiesContainerType["Project"] = "PROJECT";
    ActivitiesContainerType["Site"] = "SITE";
    ActivitiesContainerType["Space"] = "SPACE";
    ActivitiesContainerType["Workspace"] = "WORKSPACE";
    return ActivitiesContainerType;
}({});
let $5b8397cef71e8614$export$c1fb1f213efc1d1a = /*#__PURE__*/ function(ActivitiesFilterType) {
    ActivitiesFilterType["And"] = "AND";
    ActivitiesFilterType["Or"] = "OR";
    return ActivitiesFilterType;
}({}); /** Extension of ActivitiesObject, is a part of ActivitiesObjectExtension union */ 
let $5b8397cef71e8614$export$4edf00fad4b97379 = /*#__PURE__*/ function(ActivitiesObjectType) {
    ActivitiesObjectType["Blogpost"] = "BLOGPOST";
    ActivitiesObjectType["Database"] = "DATABASE";
    ActivitiesObjectType["Embed"] = "EMBED";
    ActivitiesObjectType["Goal"] = "GOAL";
    ActivitiesObjectType["Issue"] = "ISSUE";
    ActivitiesObjectType["Page"] = "PAGE";
    ActivitiesObjectType["Project"] = "PROJECT";
    ActivitiesObjectType["Whiteboard"] = "WHITEBOARD";
    return ActivitiesObjectType;
}({}); /** Extension of ActivitiesEvent, is a part of ActivitiesEventExtension union */  /** --------------------------------------- activity_api_v3 */  /** --------------------------------------- activity_api_v3 */  /** --------------------------------------- activity_api_v3 */ 
let $5b8397cef71e8614$export$132f858337fea016 = /*#__PURE__*/ function(ActivityEventType) {
    ActivityEventType["Assigned"] = "ASSIGNED";
    ActivityEventType["Commented"] = "COMMENTED";
    ActivityEventType["Created"] = "CREATED";
    ActivityEventType["Edited"] = "EDITED";
    ActivityEventType["Liked"] = "LIKED";
    ActivityEventType["Published"] = "PUBLISHED";
    ActivityEventType["Transitioned"] = "TRANSITIONED";
    ActivityEventType["Unassigned"] = "UNASSIGNED";
    ActivityEventType["Updated"] = "UPDATED";
    ActivityEventType["Viewed"] = "VIEWED";
    return ActivityEventType;
}({});
let $5b8397cef71e8614$export$d02a56686be43f69 = /*#__PURE__*/ function(ActivityObjectType) {
    ActivityObjectType["Blogpost"] = "BLOGPOST";
    ActivityObjectType["Comment"] = "COMMENT";
    ActivityObjectType["Database"] = "DATABASE";
    ActivityObjectType["Embed"] = "EMBED";
    ActivityObjectType["Goal"] = "GOAL";
    ActivityObjectType["Issue"] = "ISSUE";
    ActivityObjectType["Page"] = "PAGE";
    ActivityObjectType["Project"] = "PROJECT";
    ActivityObjectType["Site"] = "SITE";
    ActivityObjectType["Space"] = "SPACE";
    ActivityObjectType["Task"] = "TASK";
    ActivityObjectType["Whiteboard"] = "WHITEBOARD";
    return ActivityObjectType;
}({});
let $5b8397cef71e8614$export$3ca4051c67b8ec7b = /*#__PURE__*/ function(ActivityProduct) {
    ActivityProduct["Confluence"] = "CONFLUENCE";
    ActivityProduct["Jira"] = "JIRA";
    ActivityProduct["JiraBusiness"] = "JIRA_BUSINESS";
    ActivityProduct["JiraOps"] = "JIRA_OPS";
    ActivityProduct["JiraServiceDesk"] = "JIRA_SERVICE_DESK";
    ActivityProduct["JiraSoftware"] = "JIRA_SOFTWARE";
    ActivityProduct["Townsquare"] = "TOWNSQUARE";
    return ActivityProduct;
}({}); /**
 * Represents arbitrary transition,
 * e.g. in case of TRANSITIONED event type it could be `from: "inprogress" to: "done"`.
 */ 
let $5b8397cef71e8614$export$276a961098f2db01 = /*#__PURE__*/ function(AlertEventStatus) {
    AlertEventStatus["Acknowledged"] = "ACKNOWLEDGED";
    AlertEventStatus["Closed"] = "CLOSED";
    AlertEventStatus["Opened"] = "OPENED";
    AlertEventStatus["Snoozed"] = "SNOOZED";
    return AlertEventStatus;
}({});
let $5b8397cef71e8614$export$232eaa1effb46fa2 = /*#__PURE__*/ function(AlertPriority) {
    AlertPriority["P1"] = "P1";
    AlertPriority["P2"] = "P2";
    AlertPriority["P3"] = "P3";
    AlertPriority["P4"] = "P4";
    AlertPriority["P5"] = "P5";
    return AlertPriority;
}({}); /** Only used for inside the schema to mark the context for generic types */ 
let $5b8397cef71e8614$export$f6d52655da4aa77d = /*#__PURE__*/ function(ApiContext) {
    ApiContext["Devops"] = "DEVOPS";
    return ApiContext;
}({}); /**
 * This enum is the names of API groupings within the total Atlassian API.
 *
 * This is used by our documentation tooling to group together types and fields into logical groups
 */ 
let $5b8397cef71e8614$export$8145658f3946b657 = /*#__PURE__*/ function(ApiGroup) {
    ApiGroup["Actions"] = "ACTIONS";
    ApiGroup["AppRecommendations"] = "APP_RECOMMENDATIONS";
    ApiGroup["Caas"] = "CAAS";
    ApiGroup["CloudAdmin"] = "CLOUD_ADMIN";
    ApiGroup["CollaborationGraph"] = "COLLABORATION_GRAPH";
    ApiGroup["CommerceCcp"] = "COMMERCE_CCP";
    ApiGroup["CommerceHams"] = "COMMERCE_HAMS";
    ApiGroup["CommerceSharedApi"] = "COMMERCE_SHARED_API";
    ApiGroup["Compass"] = "COMPASS";
    ApiGroup["Confluence"] = "CONFLUENCE";
    ApiGroup["ConfluenceAnalytics"] = "CONFLUENCE_ANALYTICS";
    ApiGroup["ConfluenceLegacy"] = "CONFLUENCE_LEGACY";
    ApiGroup["ConfluenceMutations"] = "CONFLUENCE_MUTATIONS";
    ApiGroup["ConfluencePages"] = "CONFLUENCE_PAGES";
    ApiGroup["ConfluencePageTree"] = "CONFLUENCE_PAGE_TREE";
    ApiGroup["ConfluenceSmarts"] = "CONFLUENCE_SMARTS";
    ApiGroup["ConfluenceTenant"] = "CONFLUENCE_TENANT";
    ApiGroup["ConfluenceUser"] = "CONFLUENCE_USER";
    ApiGroup["ConfluenceV2"] = "CONFLUENCE_V2";
    ApiGroup["ContentPlatformApi"] = "CONTENT_PLATFORM_API";
    ApiGroup["CustomerService"] = "CUSTOMER_SERVICE";
    ApiGroup["DevopsAriGraph"] = "DEVOPS_ARI_GRAPH";
    ApiGroup["DevopsContainerRelationship"] = "DEVOPS_CONTAINER_RELATIONSHIP";
    ApiGroup["DevopsService"] = "DEVOPS_SERVICE";
    ApiGroup["DevopsThirdParty"] = "DEVOPS_THIRD_PARTY";
    ApiGroup["DevopsToolchain"] = "DEVOPS_TOOLCHAIN";
    ApiGroup["FeatureReleaseQuery"] = "FEATURE_RELEASE_QUERY";
    ApiGroup["Forge"] = "FORGE";
    ApiGroup["Help"] = "HELP";
    ApiGroup["Identity"] = "IDENTITY";
    ApiGroup["InsightsXperienceService"] = "INSIGHTS_XPERIENCE_SERVICE";
    ApiGroup["Jira"] = "JIRA";
    ApiGroup["Papi"] = "PAPI";
    ApiGroup["Polaris"] = "POLARIS";
    ApiGroup["SurfacePlatform"] = "SURFACE_PLATFORM";
    ApiGroup["Teams"] = "TEAMS";
    ApiGroup["VirtualAgent"] = "VIRTUAL_AGENT";
    ApiGroup["WebTriggers"] = "WEB_TRIGGERS";
    ApiGroup["XenInvocationService"] = "XEN_INVOCATION_SERVICE";
    ApiGroup["XenLogsApi"] = "XEN_LOGS_API";
    return ApiGroup;
}({});
let $5b8397cef71e8614$export$50693beeb92df79c = /*#__PURE__*/ function(AppContributorRole) {
    AppContributorRole["Admin"] = "ADMIN";
    AppContributorRole["Deployer"] = "DEPLOYER";
    AppContributorRole["Developer"] = "DEVELOPER";
    AppContributorRole["Viewer"] = "VIEWER";
    AppContributorRole["ViewerAdvanced"] = "VIEWER_ADVANCED";
    return AppContributorRole;
}({});
let $5b8397cef71e8614$export$2f94efde4452c4e8 = /*#__PURE__*/ function(AppDeploymentEventLogLevel) {
    AppDeploymentEventLogLevel["Error"] = "ERROR";
    AppDeploymentEventLogLevel["Info"] = "INFO";
    AppDeploymentEventLogLevel["Warning"] = "WARNING";
    return AppDeploymentEventLogLevel;
}({});
let $5b8397cef71e8614$export$df989df2cca988a2 = /*#__PURE__*/ function(AppDeploymentStatus) {
    AppDeploymentStatus["Done"] = "DONE";
    AppDeploymentStatus["Failed"] = "FAILED";
    AppDeploymentStatus["InProgress"] = "IN_PROGRESS";
    return AppDeploymentStatus;
}({});
let $5b8397cef71e8614$export$aa4fe8ce66c067b1 = /*#__PURE__*/ function(AppDeploymentStepStatus) {
    AppDeploymentStepStatus["Done"] = "DONE";
    AppDeploymentStepStatus["Failed"] = "FAILED";
    AppDeploymentStepStatus["Started"] = "STARTED";
    return AppDeploymentStepStatus;
}({}); /** Used to uniquely identify an environment, when being used as an input. */ 
let $5b8397cef71e8614$export$bbec072c9916131d = /*#__PURE__*/ function(AppEnvironmentType) {
    AppEnvironmentType["Development"] = "DEVELOPMENT";
    AppEnvironmentType["Production"] = "PRODUCTION";
    AppEnvironmentType["Staging"] = "STAGING";
    return AppEnvironmentType;
}({}); /** The input needed to create or update an environment variable. */  /**
 * Represents a major version of an AppEnvironment.
 * A major version is one that requires consent from end users before upgrading installations, typically a change in
 * the permissions an App requires.
 * Other changes do not trigger a new major version to be created and are instead applied to the latest major version
 */ 
let $5b8397cef71e8614$export$cb9e000131989fd = /*#__PURE__*/ function(AppNetworkPermissionType) {
    AppNetworkPermissionType["FetchBackendSide"] = "FETCH_BACKEND_SIDE";
    AppNetworkPermissionType["FetchClientSide"] = "FETCH_CLIENT_SIDE";
    AppNetworkPermissionType["Fonts"] = "FONTS";
    AppNetworkPermissionType["Frames"] = "FRAMES";
    AppNetworkPermissionType["Images"] = "IMAGES";
    AppNetworkPermissionType["Media"] = "MEDIA";
    AppNetworkPermissionType["Navigation"] = "NAVIGATION";
    AppNetworkPermissionType["Scripts"] = "SCRIPTS";
    AppNetworkPermissionType["Styles"] = "STYLES";
    return AppNetworkPermissionType;
}({});
let $5b8397cef71e8614$export$46aa181a404c6a14 = /*#__PURE__*/ function(AppNetworkPermissionTypeExtension) {
    AppNetworkPermissionTypeExtension["FetchBackendSide"] = "FETCH_BACKEND_SIDE";
    AppNetworkPermissionTypeExtension["FetchClientSide"] = "FETCH_CLIENT_SIDE";
    AppNetworkPermissionTypeExtension["Fonts"] = "FONTS";
    AppNetworkPermissionTypeExtension["Frames"] = "FRAMES";
    AppNetworkPermissionTypeExtension["Images"] = "IMAGES";
    AppNetworkPermissionTypeExtension["Media"] = "MEDIA";
    AppNetworkPermissionTypeExtension["Navigation"] = "NAVIGATION";
    AppNetworkPermissionTypeExtension["Scripts"] = "SCRIPTS";
    AppNetworkPermissionTypeExtension["Styles"] = "STYLES";
    return AppNetworkPermissionTypeExtension;
}({}); /** Permissions that relate to the App's interaction with supported APIs and supported network egress */  /**
 * The context object provides essential insights into the users' current experience and operations.
 *
 * The supported product and subproduct keys can be found at https://hello.atlassian.net/wiki/spaces/ECON/pages/2339030895/App+Identifiers
 */ 
let $5b8397cef71e8614$export$1618aa24ce40e8c9 = /*#__PURE__*/ function(AppSecurityPoliciesPermissionType) {
    AppSecurityPoliciesPermissionType["Scripts"] = "SCRIPTS";
    AppSecurityPoliciesPermissionType["Styles"] = "STYLES";
    return AppSecurityPoliciesPermissionType;
}({});
let $5b8397cef71e8614$export$3397fdc734564301 = /*#__PURE__*/ function(AppSecurityPoliciesPermissionTypeExtension) {
    AppSecurityPoliciesPermissionTypeExtension["Scripts"] = "SCRIPTS";
    AppSecurityPoliciesPermissionTypeExtension["Styles"] = "STYLES";
    return AppSecurityPoliciesPermissionTypeExtension;
}({});
let $5b8397cef71e8614$export$abe79a166182d5dd = /*#__PURE__*/ function(AppStoredCustomEntityFilterCondition) {
    AppStoredCustomEntityFilterCondition["BeginsWith"] = "BEGINS_WITH";
    AppStoredCustomEntityFilterCondition["Between"] = "BETWEEN";
    AppStoredCustomEntityFilterCondition["Contains"] = "CONTAINS";
    AppStoredCustomEntityFilterCondition["EqualTo"] = "EQUAL_TO";
    AppStoredCustomEntityFilterCondition["Exists"] = "EXISTS";
    AppStoredCustomEntityFilterCondition["GreaterThan"] = "GREATER_THAN";
    AppStoredCustomEntityFilterCondition["GreaterThanEqualTo"] = "GREATER_THAN_EQUAL_TO";
    AppStoredCustomEntityFilterCondition["LessThan"] = "LESS_THAN";
    AppStoredCustomEntityFilterCondition["LessThanEqualTo"] = "LESS_THAN_EQUAL_TO";
    AppStoredCustomEntityFilterCondition["NotContains"] = "NOT_CONTAINS";
    AppStoredCustomEntityFilterCondition["NotEqualTo"] = "NOT_EQUAL_TO";
    AppStoredCustomEntityFilterCondition["NotExists"] = "NOT_EXISTS";
    return AppStoredCustomEntityFilterCondition;
}({});
let $5b8397cef71e8614$export$8c6210489e377c93 = /*#__PURE__*/ function(AppStoredCustomEntityRangeCondition) {
    AppStoredCustomEntityRangeCondition["BeginsWith"] = "BEGINS_WITH";
    AppStoredCustomEntityRangeCondition["Between"] = "BETWEEN";
    AppStoredCustomEntityRangeCondition["EqualTo"] = "EQUAL_TO";
    AppStoredCustomEntityRangeCondition["GreaterThan"] = "GREATER_THAN";
    AppStoredCustomEntityRangeCondition["GreaterThanEqualTo"] = "GREATER_THAN_EQUAL_TO";
    AppStoredCustomEntityRangeCondition["LessThan"] = "LESS_THAN";
    AppStoredCustomEntityRangeCondition["LessThanEqualTo"] = "LESS_THAN_EQUAL_TO";
    return AppStoredCustomEntityRangeCondition;
}({});
let $5b8397cef71e8614$export$6c1157c4fc1b51c4 = /*#__PURE__*/ function(AppStoredEntityCondition) {
    AppStoredEntityCondition["In"] = "IN";
    AppStoredEntityCondition["NotEqualTo"] = "NOT_EQUAL_TO";
    AppStoredEntityCondition["StartsWith"] = "STARTS_WITH";
    return AppStoredEntityCondition;
}({}); /**
 * The identifier for this entity
 *
 * where condition to filter
 */ 
let $5b8397cef71e8614$export$63fbd5015391964b = /*#__PURE__*/ function(AppTaskState) {
    AppTaskState["Complete"] = "COMPLETE";
    AppTaskState["Failed"] = "FAILED";
    AppTaskState["Pending"] = "PENDING";
    AppTaskState["Running"] = "RUNNING";
    return AppTaskState;
}({}); /** App trust information state */ 
let $5b8397cef71e8614$export$5b9c3b8406b5cf1a = /*#__PURE__*/ function(AppTrustInformationState) {
    AppTrustInformationState["Draft"] = "DRAFT";
    AppTrustInformationState["Live"] = "LIVE";
    return AppTrustInformationState;
}({}); /** Input payload for the app environment uninstall mutation */  /** The response from the uninstallation of an app environment */  /**
 * This does not represent a real person but rather the identity that backs an installed application
 *
 * See the documentation on the `User` for more details
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */ 
let $5b8397cef71e8614$export$c8ae3a8e8f57359f = /*#__PURE__*/ function(ArchivedMode) {
    ArchivedMode["ActiveOnly"] = "ACTIVE_ONLY";
    ArchivedMode["All"] = "ALL";
    ArchivedMode["ArchivedOnly"] = "ARCHIVED_ONLY";
    return ArchivedMode;
}({}); /**
 * At least 'from' or 'to' must be specified. If both are specified, then 'type' is required.
 *
 * If only one side of the relationship is provided, and no type is provided,
 * then every relationship (where that side of the relationship equals the provided ARI)
 * for every applicable relationship type will be deleted.
 */ 
let $5b8397cef71e8614$export$207a81844461bdb0 = /*#__PURE__*/ function(AriGraphRelationshipsSortDirection) {
    AriGraphRelationshipsSortDirection["Asc"] = "ASC";
    AriGraphRelationshipsSortDirection["Desc"] = "DESC";
    return AriGraphRelationshipsSortDirection;
}({}); /**
 * This represents a real person that has an account in a wide range of Atlassian products
 *
 * See the documentation on the `User` and `LocalizationContext` for more details
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */ 
let $5b8397cef71e8614$export$38d407d6909984c2 = /*#__PURE__*/ function(AtlassianProductHostingType) {
    AtlassianProductHostingType["Cloud"] = "CLOUD";
    AtlassianProductHostingType["DataCenter"] = "DATA_CENTER";
    AtlassianProductHostingType["Server"] = "SERVER";
    return AtlassianProductHostingType;
}({}); /** Accepts input to attach a data manager to a component. */  /** The payload returned from attaching a data manager to a component. */  /** This type contains information about the currently logged in user */  /** Entry point for auto-suggestion search */  /** Entry point for auto-suggestion search */  /** Payload to invoke an AUX Effect */  /** A response to an aux invocation */  /** The input for a Avatar for a Third Party Repository */  /** Bitbucket Permission Enum */ 
let $5b8397cef71e8614$export$a3fe6fe047d6ad5c = /*#__PURE__*/ function(BitbucketPermission) {
    BitbucketPermission["Admin"] = "ADMIN";
    return BitbucketPermission;
}({}); /** Relay connection definition for a list of board features */  /** Relay edge definition for a board feature */  /** Relay connection definition for a list of board feature groups */  /** Relay edge definition for a board feature group */ 
let $5b8397cef71e8614$export$dd75b3db211b43be = /*#__PURE__*/ function(BoardFeatureStatus) {
    BoardFeatureStatus["ComingSoon"] = "COMING_SOON";
    BoardFeatureStatus["Disabled"] = "DISABLED";
    BoardFeatureStatus["Enabled"] = "ENABLED";
    return BoardFeatureStatus;
}({});
let $5b8397cef71e8614$export$c0a71a6782116cff = /*#__PURE__*/ function(BoardFeatureToggleStatus) {
    BoardFeatureToggleStatus["Disabled"] = "DISABLED";
    BoardFeatureToggleStatus["Enabled"] = "ENABLED";
    return BoardFeatureToggleStatus;
}({}); /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Root node for queries about simple / agility / nextgen boards. */  /** Available strategies for grouping issues into swimlanes for a classic board */ 
let $5b8397cef71e8614$export$19baf80f4562d4e3 = /*#__PURE__*/ function(BoardSwimlaneStrategy) {
    BoardSwimlaneStrategy["AssigneeUnassignedFirst"] = "ASSIGNEE_UNASSIGNED_FIRST";
    BoardSwimlaneStrategy["AssigneeUnassignedLast"] = "ASSIGNEE_UNASSIGNED_LAST";
    BoardSwimlaneStrategy["Custom"] = "CUSTOM";
    BoardSwimlaneStrategy["Epic"] = "EPIC";
    BoardSwimlaneStrategy["IssueChildren"] = "ISSUE_CHILDREN";
    BoardSwimlaneStrategy["IssueParent"] = "ISSUE_PARENT";
    BoardSwimlaneStrategy["None"] = "NONE";
    BoardSwimlaneStrategy["ParentChild"] = "PARENT_CHILD";
    BoardSwimlaneStrategy["Project"] = "PROJECT";
    BoardSwimlaneStrategy["RequestType"] = "REQUEST_TYPE";
    return BoardSwimlaneStrategy;
}({});
let $5b8397cef71e8614$export$52d25977f4eeeb6 = /*#__PURE__*/ function(BuiltinPolarisIdeaField) {
    BuiltinPolarisIdeaField["Archived"] = "ARCHIVED";
    BuiltinPolarisIdeaField["ArchivedBy"] = "ARCHIVED_BY";
    BuiltinPolarisIdeaField["ArchivedOn"] = "ARCHIVED_ON";
    BuiltinPolarisIdeaField["Assignee"] = "ASSIGNEE";
    BuiltinPolarisIdeaField["AtlasGoal"] = "ATLAS_GOAL";
    BuiltinPolarisIdeaField["AtlasProject"] = "ATLAS_PROJECT";
    BuiltinPolarisIdeaField["AtlasProjectStatus"] = "ATLAS_PROJECT_STATUS";
    BuiltinPolarisIdeaField["AtlasProjectTarget"] = "ATLAS_PROJECT_TARGET";
    BuiltinPolarisIdeaField["Created"] = "CREATED";
    BuiltinPolarisIdeaField["Creator"] = "CREATOR";
    BuiltinPolarisIdeaField["DeliveryProgress"] = "DELIVERY_PROGRESS";
    BuiltinPolarisIdeaField["DeliveryStatus"] = "DELIVERY_STATUS";
    BuiltinPolarisIdeaField["Description"] = "DESCRIPTION";
    BuiltinPolarisIdeaField["IssueComments"] = "ISSUE_COMMENTS";
    BuiltinPolarisIdeaField["IssueId"] = "ISSUE_ID";
    BuiltinPolarisIdeaField["IssueType"] = "ISSUE_TYPE";
    BuiltinPolarisIdeaField["Key"] = "KEY";
    BuiltinPolarisIdeaField["Labels"] = "LABELS";
    BuiltinPolarisIdeaField["LinkedIssues"] = "LINKED_ISSUES";
    BuiltinPolarisIdeaField["NumDataPoints"] = "NUM_DATA_POINTS";
    BuiltinPolarisIdeaField["Reporter"] = "REPORTER";
    BuiltinPolarisIdeaField["Status"] = "STATUS";
    BuiltinPolarisIdeaField["Summary"] = "SUMMARY";
    BuiltinPolarisIdeaField["Updated"] = "UPDATED";
    BuiltinPolarisIdeaField["Votes"] = "VOTES";
    return BuiltinPolarisIdeaField;
}({}); /** Accepts input for deleting multiple existing components. */  /** The payload returned from deleting existing components. */  /**
 * ###################################################################################################################
 *  COMPASS MUTATION RESPONSES
 * ###################################################################################################################
 */ 
let $5b8397cef71e8614$export$184db778f5e78171 = /*#__PURE__*/ function(CapabilitySet) {
    CapabilitySet["CapabilityAdvanced"] = "capabilityAdvanced";
    CapabilitySet["CapabilityStandard"] = "capabilityStandard";
    return CapabilitySet;
}({});
let $5b8397cef71e8614$export$805b6160e3efc186 = /*#__PURE__*/ function(CardHierarchyLevelEnumType) {
    CardHierarchyLevelEnumType["Base"] = "BASE";
    CardHierarchyLevelEnumType["Child"] = "CHILD";
    CardHierarchyLevelEnumType["Parent"] = "PARENT";
    return CardHierarchyLevelEnumType;
}({});
let $5b8397cef71e8614$export$ee2a5f4674ed5b8d = /*#__PURE__*/ function(CcpActivationReason) {
    CcpActivationReason["AdvantagePricing"] = "ADVANTAGE_PRICING";
    CcpActivationReason["DefaultPricing"] = "DEFAULT_PRICING";
    CcpActivationReason["ExperimentalPricing"] = "EXPERIMENTAL_PRICING";
    return CcpActivationReason;
}({}); /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $5b8397cef71e8614$export$dd06bd5976bfc6e3 = /*#__PURE__*/ function(CcpBillingInterval) {
    CcpBillingInterval["Day"] = "DAY";
    CcpBillingInterval["Month"] = "MONTH";
    CcpBillingInterval["Week"] = "WEEK";
    CcpBillingInterval["Year"] = "YEAR";
    return CcpBillingInterval;
}({}); /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $5b8397cef71e8614$export$f1663167a1dfb133 = /*#__PURE__*/ function(CcpChargeType) {
    CcpChargeType["AutoScaling"] = "AUTO_SCALING";
    CcpChargeType["Licensed"] = "LICENSED";
    CcpChargeType["Metered"] = "METERED";
    return CcpChargeType;
}({}); /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $5b8397cef71e8614$export$c0b393797b8a5dd1 = /*#__PURE__*/ function(CcpCurrency) {
    CcpCurrency["Jpy"] = "JPY";
    CcpCurrency["Usd"] = "USD";
    return CcpCurrency;
}({});
let $5b8397cef71e8614$export$5f9edcd77bf8a9b9 = /*#__PURE__*/ function(CcpDuration) {
    CcpDuration["Forever"] = "FOREVER";
    CcpDuration["Once"] = "ONCE";
    CcpDuration["Repeating"] = "REPEATING";
    return CcpDuration;
}({}); /**
 * An effective uncollectible action represents the action that an offering will
 * undergo in the event of non-payment
 */ 
let $5b8397cef71e8614$export$57f8dd5442590d31 = /*#__PURE__*/ function(CcpEntitlementPreDunningStatus) {
    CcpEntitlementPreDunningStatus["InPreDunning"] = "IN_PRE_DUNNING";
    CcpEntitlementPreDunningStatus["NotInPreDunning"] = "NOT_IN_PRE_DUNNING";
    return CcpEntitlementPreDunningStatus;
}({});
let $5b8397cef71e8614$export$21652ca36153879b = /*#__PURE__*/ function(CcpEntitlementStatus) {
    CcpEntitlementStatus["Active"] = "ACTIVE";
    CcpEntitlementStatus["Inactive"] = "INACTIVE";
    return CcpEntitlementStatus;
}({}); /** A type of product usage as it relates to an entitlement */  /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $5b8397cef71e8614$export$e9dd9659ef9f0fb5 = /*#__PURE__*/ function(CcpOfferingHostingType) {
    CcpOfferingHostingType["Cloud"] = "CLOUD";
    return CcpOfferingHostingType;
}({});
let $5b8397cef71e8614$export$a6e9989b075a8458 = /*#__PURE__*/ function(CcpOfferingStatus) {
    CcpOfferingStatus["Active"] = "ACTIVE";
    CcpOfferingStatus["AtNotice"] = "AT_NOTICE";
    CcpOfferingStatus["Draft"] = "DRAFT";
    CcpOfferingStatus["Expired"] = "EXPIRED";
    return CcpOfferingStatus;
}({});
let $5b8397cef71e8614$export$2ec95e801b135b6a = /*#__PURE__*/ function(CcpOfferingType) {
    CcpOfferingType["Child"] = "CHILD";
    CcpOfferingType["Parent"] = "PARENT";
    return CcpOfferingType;
}({});
let $5b8397cef71e8614$export$60c062217a56cebb = /*#__PURE__*/ function(CcpOfferingUncollectibleActionType) {
    CcpOfferingUncollectibleActionType["Cancel"] = "CANCEL";
    CcpOfferingUncollectibleActionType["Downgrade"] = "DOWNGRADE";
    CcpOfferingUncollectibleActionType["NoAction"] = "NO_ACTION";
    return CcpOfferingUncollectibleActionType;
}({}); /** An order from a transaction account. */  /** A pricing plan represents the way to charge for a subscription. */ 
let $5b8397cef71e8614$export$b1c315941e36715 = /*#__PURE__*/ function(CcpPricingPlanStatus) {
    CcpPricingPlanStatus["Active"] = "ACTIVE";
    CcpPricingPlanStatus["AtNotice"] = "AT_NOTICE";
    CcpPricingPlanStatus["Draft"] = "DRAFT";
    CcpPricingPlanStatus["Expired"] = "EXPIRED";
    return CcpPricingPlanStatus;
}({});
let $5b8397cef71e8614$export$c9b826d15992706b = /*#__PURE__*/ function(CcpPricingType) {
    CcpPricingType["External"] = "EXTERNAL";
    CcpPricingType["Free"] = "FREE";
    CcpPricingType["LimitedFree"] = "LIMITED_FREE";
    CcpPricingType["Paid"] = "PAID";
    return CcpPricingType;
}({});
let $5b8397cef71e8614$export$2b3bbef813bc7ddb = /*#__PURE__*/ function(CcpProrateOnUsageChange) {
    CcpProrateOnUsageChange["AlwaysInvoice"] = "ALWAYS_INVOICE";
    CcpProrateOnUsageChange["CreateProrations"] = "CREATE_PRORATIONS";
    CcpProrateOnUsageChange["None"] = "NONE";
    return CcpProrateOnUsageChange;
}({}); /**
 * Commerce Cloud Platform is Atlassian's commerce platform and replaces the legacy platform HAMS.
 * Some of the types in this schema implement interfaces defined in commerce_schema to provide CCP entitlements data for common commerce API.
 */ 
let $5b8397cef71e8614$export$bec7023af534df98 = /*#__PURE__*/ function(CcpRelationshipPricingType) {
    CcpRelationshipPricingType["AdvantagePricing"] = "ADVANTAGE_PRICING";
    CcpRelationshipPricingType["CurrencyGenerated"] = "CURRENCY_GENERATED";
    CcpRelationshipPricingType["NextPricing"] = "NEXT_PRICING";
    CcpRelationshipPricingType["SyntheticGenerated"] = "SYNTHETIC_GENERATED";
    return CcpRelationshipPricingType;
}({});
let $5b8397cef71e8614$export$1597d868ca01d69 = /*#__PURE__*/ function(CcpSubscriptionScheduleAction) {
    CcpSubscriptionScheduleAction["Cancel"] = "CANCEL";
    CcpSubscriptionScheduleAction["Update"] = "UPDATE";
    return CcpSubscriptionScheduleAction;
}({});
let $5b8397cef71e8614$export$dcee3eda38daaeab = /*#__PURE__*/ function(CcpSubscriptionStatus) {
    CcpSubscriptionStatus["Active"] = "ACTIVE";
    CcpSubscriptionStatus["Cancelled"] = "CANCELLED";
    CcpSubscriptionStatus["Processing"] = "PROCESSING";
    return CcpSubscriptionStatus;
}({});
let $5b8397cef71e8614$export$30c9d4dfd26087be = /*#__PURE__*/ function(CcpSupportedBillingSystems) {
    CcpSupportedBillingSystems["Ccp"] = "CCP";
    CcpSupportedBillingSystems["Hams"] = "HAMS";
    CcpSupportedBillingSystems["Opsgenie"] = "OPSGENIE";
    return CcpSupportedBillingSystems;
}({});
let $5b8397cef71e8614$export$55c02debb712e2db = /*#__PURE__*/ function(CcpTiersMode) {
    CcpTiersMode["Graduated"] = "GRADUATED";
    CcpTiersMode["Volume"] = "VOLUME";
    return CcpTiersMode;
}({}); /**
 * A CCP transaction account represents a customer,
 * i.e. the legal entity with which Atlassian is doing business.
 * It may be an individual, a business, etc.
 */ 
let $5b8397cef71e8614$export$cec1fe9fa75edecd = /*#__PURE__*/ function(Classification) {
    Classification["Other"] = "other";
    Classification["Pii"] = "pii";
    Classification["Ugc"] = "ugc";
    return Classification;
}({}); /** Level of access to an Atlassian product that a cloud app can request */  /**
 * A Version Control System object
 * Eg. Bitbucket, GitHub, GitLab
 */ 
let $5b8397cef71e8614$export$998d732c1030d8c = /*#__PURE__*/ function(CompassBuildEventState) {
    CompassBuildEventState["Cancelled"] = "CANCELLED";
    CompassBuildEventState["Error"] = "ERROR";
    CompassBuildEventState["Failed"] = "FAILED";
    CompassBuildEventState["InProgress"] = "IN_PROGRESS";
    CompassBuildEventState["Successful"] = "SUCCESSFUL";
    CompassBuildEventState["TimedOut"] = "TIMED_OUT";
    CompassBuildEventState["Unknown"] = "UNKNOWN";
    return CompassBuildEventState;
}({}); /**
 * ###################################################################################################################
 *  COMPASS Campaign configuration
 * ###################################################################################################################
 */ 
let $5b8397cef71e8614$export$b18beaf85a2196b5 = /*#__PURE__*/ function(CompassCampaignQuerySortOrder) {
    CompassCampaignQuerySortOrder["Asc"] = "ASC";
    CompassCampaignQuerySortOrder["Desc"] = "DESC";
    return CompassCampaignQuerySortOrder;
}({}); /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** The top level wrapper for the Compass Mutations API. */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Top level wrapper for Compass Query API */  /** Metadata about who created or updated the object and when. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** A component represents a software development artifact tracked in Compass. */  /** An external integration that manages data for a particular component. */  /** A label provides additional contextual information about a component. */  /** A connection that returns a paginated collection of metric sources. */  /** The query to get the metric sources of a component. */  /** A component scorecard relationship. */  /** A component scorecard relationship. */  /** A component scorecard relationship. */  /** A component scorecard relationship. */  /** Scorecard score on a component for a scorecard. */  /** A tier provides additional contextual information about a component. */  /** Identifies the type of component. */ 
let $5b8397cef71e8614$export$dbf96ee31a2e1415 = /*#__PURE__*/ function(CompassComponentType) {
    CompassComponentType["Application"] = "APPLICATION";
    CompassComponentType["Library"] = "LIBRARY";
    CompassComponentType["Other"] = "OTHER";
    CompassComponentType["Service"] = "SERVICE";
    return CompassComponentType;
}({}); /** Represents a type of software component that is distinguishable from other types.  Service vs Library, for example */  /** Input for querying Compass component types */  /** An alert event. */  /** Accepts input for creating a component announcement. */  /** The payload returned after creating a component announcement. */  /** The payload returned from sending a question to have an answer created. */  /** A build event. */  /** Accepts input for creating a component scorecard Jira issue. */  /** The payload returned from creating a component scorecard Jira issue. */  /** Input for creating a component subscription. */  /** The payload returned from creating a component subscription. */  /** Accepts input for creating a custom boolean field definition. */  /** A custom event. */  /** Accepts input for creating a custom field definition. You must provide exactly one of the fields in this input type. */  /** The payload returned from creating a custom field definition. */  /** Accepts input for creating a custom multi select field definition. */  /** Accepts input for creating a custom number field definition. */  /** Accepts input for creating a custom single select field definition. */  /** Accepts input for creating a custom text field definition. */  /** Accepts input for creating a custom user field definition. */  /** A deployment event. */  /** The list of properties of the deployment event. */  /** A flag event. */  /** The list of properties of the flag event. */  /** Accepts input to create a scorecard criterion checking the value of a specified custom boolean field. */  /** Accepts input to create a scorecard criterion checking the value of a specified custom number field. */  /** Accepts input to create a scorecard criterion checking the value of a specified custom text field. */  /** An incident event. */  /** The list of properties of the incident event. */  /** The user-provided input to create an incoming webhook */  /** The payload returned from sending an incoming webhook to be created */  /** A lifecycle event. */  /** The input for creating a metric definition. */  /** The payload returned from creating a metric definition. */  /** The input to create a metric source. */  /** The payload returned from creating a metric source. */  /** A pull request event. */ 
let $5b8397cef71e8614$export$ad2a5e42be992de9 = /*#__PURE__*/ function(CompassCreatePullRequestStatus) {
    CompassCreatePullRequestStatus["Created"] = "CREATED";
    CompassCreatePullRequestStatus["InReview"] = "IN_REVIEW";
    CompassCreatePullRequestStatus["Merged"] = "MERGED";
    CompassCreatePullRequestStatus["Rejected"] = "REJECTED";
    return CompassCreatePullRequestStatus;
}({}); /** A push event. */  /** Accepts input for creating team checkin's action item. */  /** Accepts input for creating a checkin. */  /** The payload returned after creating a component announcement. */  /** Accepts input for creating team checkin responses with rich text. */ 
let $5b8397cef71e8614$export$ec0d5c1fa3218a83 = /*#__PURE__*/ function(CompassCriteriaBooleanComparatorOptions) {
    CompassCriteriaBooleanComparatorOptions["Equals"] = "EQUALS";
    return CompassCriteriaBooleanComparatorOptions;
}({});
let $5b8397cef71e8614$export$e387eb9a14a2773b = /*#__PURE__*/ function(CompassCriteriaCollectionComparatorOptions) {
    CompassCriteriaCollectionComparatorOptions["AllOf"] = "ALL_OF";
    CompassCriteriaCollectionComparatorOptions["AnyOf"] = "ANY_OF";
    CompassCriteriaCollectionComparatorOptions["NoneOf"] = "NONE_OF";
    return CompassCriteriaCollectionComparatorOptions;
}({});
let $5b8397cef71e8614$export$9597031f08feb1bc = /*#__PURE__*/ function(CompassCriteriaMembershipComparatorOptions) {
    CompassCriteriaMembershipComparatorOptions["In"] = "IN";
    CompassCriteriaMembershipComparatorOptions["NotIn"] = "NOT_IN";
    return CompassCriteriaMembershipComparatorOptions;
}({});
let $5b8397cef71e8614$export$8a8b436a51cf3b62 = /*#__PURE__*/ function(CompassCriteriaNumberComparatorOptions) {
    CompassCriteriaNumberComparatorOptions["Equals"] = "EQUALS";
    CompassCriteriaNumberComparatorOptions["GreaterThan"] = "GREATER_THAN";
    CompassCriteriaNumberComparatorOptions["GreaterThanOrEqualTo"] = "GREATER_THAN_OR_EQUAL_TO";
    CompassCriteriaNumberComparatorOptions["LessThan"] = "LESS_THAN";
    CompassCriteriaNumberComparatorOptions["LessThanOrEqualTo"] = "LESS_THAN_OR_EQUAL_TO";
    return CompassCriteriaNumberComparatorOptions;
}({});
let $5b8397cef71e8614$export$b7f3ac0d38937afa = /*#__PURE__*/ function(CompassCriteriaTextComparatorOptions) {
    CompassCriteriaTextComparatorOptions["IsPresent"] = "IS_PRESENT";
    CompassCriteriaTextComparatorOptions["MatchesRegex"] = "MATCHES_REGEX";
    return CompassCriteriaTextComparatorOptions;
}({}); /** A custom field containing a boolean value. */  /** The definition of a custom field containing a boolean value. */  /** Accepts input for setting a boolean value on a custom field. */ 
let $5b8397cef71e8614$export$ce4ce86422cc81d0 = /*#__PURE__*/ function(CompassCustomEventIcon) {
    CompassCustomEventIcon["Checkpoint"] = "CHECKPOINT";
    CompassCustomEventIcon["Info"] = "INFO";
    CompassCustomEventIcon["Warning"] = "WARNING";
    return CompassCustomEventIcon;
}({}); /** Properties specific to Custom events */  /** The list of properties of the custom event. */  /** A custom field contains data about the component. */  /** Annotation for a custom field value */  /** Annotatation input for a custom field value */  /** Defines a custom field that may be applied to multiple component types. A custom field must be applied to at least one component type. */  /** An edge that contains a custom field definition and a cursor. */  /** The query for retrieving a custom field definition by id on a Compass site. */  /** A connection that returns a paginated collection of custom field definitions. */  /** The query for retrieving custom field definitions on a Compass site. */  /** Accepts input for setting a custom field value. You must provide exactly one of the fields in this input type. */  /** A custom multi-select field. */  /** The definition of a custom multi-select field. */  /** Accepts input for setting options for a multi-select field. */  /** A custom field containing a number. */  /** The definition of a custom field containing a number. */  /** Accepts input for setting a number on a custom field. */  /** Preset options to update custom permission configs, either open to all teams/roles or restricted to product admins and owners. */ 
let $5b8397cef71e8614$export$43cacf9c2c9c2a10 = /*#__PURE__*/ function(CompassCustomPermissionPreset) {
    CompassCustomPermissionPreset["AdminsAndOwners"] = "ADMINS_AND_OWNERS";
    CompassCustomPermissionPreset["Default"] = "DEFAULT";
    return CompassCustomPermissionPreset;
}({}); /** The option of a single-select or multi-select custom field. */  /** A custom single-select field. */  /** The definition of a custom single-select field. */  /** Accepts input for setting an option for single-select field. */  /** A custom field containing a text string. */  /** The definition of a custom field containing a text string. */  /** Accepts input for setting a text string on a custom field. */  /** A custom field containing a user. */  /** The definition of a custom field containing a user. */  /** Accepts input for setting a user on a custom field. */  /** The payload returned from deactivating a scorecard for a component. */  /** Accepts input for deleting a component announcement. */  /** The payload returned after deleting a component announcement. */  /** Accepts input for delete a subscription. */  /** Payload returned from stop watching a component. */  /** Accepts input for deleting a custom field definition, along with all values associated with the definition. */  /** The payload returned from deleting a custom field definition. */  /** The user-provided input to delete an incoming webhook */  /** The payload returned from deleting an incoming webhook */  /** The input to delete a metric definition. */  /** The payload returned from updating a metric definition. */  /** The input to delete a metric source. */  /** The payload returned from deleting a metric source. */  /** Accepts input for deleting a team checkin. */  /** Accepts input for deleting a team checkin. */  /** The payload returned after deleting a team checkin. */ 
let $5b8397cef71e8614$export$15c39df7a190a18a = /*#__PURE__*/ function(CompassDeploymentEventEnvironmentCategory) {
    CompassDeploymentEventEnvironmentCategory["Development"] = "DEVELOPMENT";
    CompassDeploymentEventEnvironmentCategory["Production"] = "PRODUCTION";
    CompassDeploymentEventEnvironmentCategory["Staging"] = "STAGING";
    CompassDeploymentEventEnvironmentCategory["Testing"] = "TESTING";
    CompassDeploymentEventEnvironmentCategory["Unmapped"] = "UNMAPPED";
    return CompassDeploymentEventEnvironmentCategory;
}({}); /** The environment where the deployment event has occurred. */  /** Filters for deployment events. */  /** The deployment event pipeline. */  /** Compass Deployment Event */ 
let $5b8397cef71e8614$export$43d1deedebbbaa4e = /*#__PURE__*/ function(CompassDeploymentEventState) {
    CompassDeploymentEventState["Cancelled"] = "CANCELLED";
    CompassDeploymentEventState["Failed"] = "FAILED";
    CompassDeploymentEventState["InProgress"] = "IN_PROGRESS";
    CompassDeploymentEventState["Pending"] = "PENDING";
    CompassDeploymentEventState["RolledBack"] = "ROLLED_BACK";
    CompassDeploymentEventState["Successful"] = "SUCCESSFUL";
    CompassDeploymentEventState["Unknown"] = "UNKNOWN";
    return CompassDeploymentEventState;
}({}); /** Stores the categories that various pieces of documentation will be grouped under */  /** Filters for events sent to Compass. */  /** The type of event. One and only one of the fields in this input type must be provided. */ 
let $5b8397cef71e8614$export$155351532e5d1b9f = /*#__PURE__*/ function(CompassEventType) {
    CompassEventType["Alert"] = "ALERT";
    CompassEventType["Build"] = "BUILD";
    CompassEventType["Custom"] = "CUSTOM";
    CompassEventType["Deployment"] = "DEPLOYMENT";
    CompassEventType["Flag"] = "FLAG";
    CompassEventType["Incident"] = "INCIDENT";
    CompassEventType["Lifecycle"] = "LIFECYCLE";
    CompassEventType["PullRequest"] = "PULL_REQUEST";
    CompassEventType["Push"] = "PUSH";
    return CompassEventType;
}({}); /** An alias of the component in an external system. */  /** A field represents data about a component. */  /** The schema of a field. */  /** Specifies the type of value for a field. */ 
let $5b8397cef71e8614$export$5ba534b6379276b = /*#__PURE__*/ function(CompassFieldType) {
    CompassFieldType["Date"] = "DATE";
    CompassFieldType["Enum"] = "ENUM";
    CompassFieldType["Number"] = "NUMBER";
    CompassFieldType["Text"] = "TEXT";
    return CompassFieldType;
}({}); /** Accepts input to find filtered components count */  /** Properties specific to Flag events */  /** A user-defined parameter containing a string value. */  /** The configuration for a scorecard criterion checking the value of a specified custom boolean field. */  /** The configuration for a scorecard criterion checking the value of a specified custom boolean field. */  /** The configuration for a scorecard criterion checking the value of a specified custom number field. */  /** The configuration for a scorecard criterion checking the value of a specified custom number field. */  /** The configuration for a scorecard criterion checking the value of a specified custom text field. */  /** The configuration for a scorecard criterion checking the value of a specified custom text field. */  /** The configuration for a scorecard criterion representing the presence of a description. */  /** The configuration for a scorecard criterion representing the presence of a description. */  /** The configuration for a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */  /** The configuration for a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */  /** The configuration for a scorecard criterion representing the presence of a link, for example, 'Has Repository', or 'Has Documentation'. */  /** The configuration for a scorecard criterion representing the presence of a link, for example, 'Has Repository', or 'Has Documentation'. */  /** The configuration for a scorecard criterion checking the value of a specified metric name. */  /** The configuration for a scorecard criterion checking the value of a specified metric name. */  /** Configuration for a scorecard criteria representing the presence of an owner */  /** Configuration for a scorecard criteria representing the presence of an owner */  /** Properties specific to Incident events */  /** The severity of an incident */  /** The severity of an incident */ 
let $5b8397cef71e8614$export$9a02db1f2decc63 = /*#__PURE__*/ function(CompassIncidentEventSeverityLevel) {
    CompassIncidentEventSeverityLevel["Five"] = "FIVE";
    CompassIncidentEventSeverityLevel["Four"] = "FOUR";
    CompassIncidentEventSeverityLevel["One"] = "ONE";
    CompassIncidentEventSeverityLevel["Three"] = "THREE";
    CompassIncidentEventSeverityLevel["Two"] = "TWO";
    return CompassIncidentEventSeverityLevel;
}({});
let $5b8397cef71e8614$export$f8b82012c65b70c9 = /*#__PURE__*/ function(CompassIncidentEventState) {
    CompassIncidentEventState["Deleted"] = "DELETED";
    CompassIncidentEventState["Open"] = "OPEN";
    CompassIncidentEventState["Resolved"] = "RESOLVED";
    return CompassIncidentEventState;
}({}); /** Represents a user-defined incoming webhook for creating events in Compass */  /**
 * ###################################################################################################################
 *  COMPASS INCOMING WEBHOOKS
 * ###################################################################################################################
 */ 
let $5b8397cef71e8614$export$4366f17562f80ce7 = /*#__PURE__*/ function(CompassLifecycleEventStage) {
    CompassLifecycleEventStage["Deprecation"] = "DEPRECATION";
    CompassLifecycleEventStage["EndOfLife"] = "END_OF_LIFE";
    CompassLifecycleEventStage["PreRelease"] = "PRE_RELEASE";
    CompassLifecycleEventStage["Production"] = "PRODUCTION";
    return CompassLifecycleEventStage;
}({}); /** A link to an entity or resource on the internet. */  /** The types used to identify the intent of the link. */ 
let $5b8397cef71e8614$export$56307b64f049eb43 = /*#__PURE__*/ function(CompassLinkType) {
    CompassLinkType["ChatChannel"] = "CHAT_CHANNEL";
    CompassLinkType["Dashboard"] = "DASHBOARD";
    CompassLinkType["Document"] = "DOCUMENT";
    CompassLinkType["OnCall"] = "ON_CALL";
    CompassLinkType["OtherLink"] = "OTHER_LINK";
    CompassLinkType["Project"] = "PROJECT";
    CompassLinkType["Repository"] = "REPOSITORY";
    return CompassLinkType;
}({}); /** A metric definition defines a metric across multiple components. */  /** A metric definition defines a metric across multiple components. */  /** An edge that contains a metric definition and a cursor. */  /** The format option to append a plain-text suffix to metric values. */  /** The format option to append a plain-text suffix to metric values. */  /** Used to identify the type for the metric */ 
let $5b8397cef71e8614$export$270abbff10f02537 = /*#__PURE__*/ function(CompassMetricDefinitionType) {
    CompassMetricDefinitionType["BuiltIn"] = "BUILT_IN";
    CompassMetricDefinitionType["Custom"] = "CUSTOM";
    return CompassMetricDefinitionType;
}({}); /** A connection that returns a paginated collection of metric definitions. */  /** The query to get the metric definitions on a Compass site. */  /** A metric source contains values that provide numerical data about the component. */  /** A metric source contains values that provide numerical data about the component. */  /** An edge that contains a metric source and a cursor. */  /** A base for different scopes of metrics. Future metric sources can implement this and add their scope specific fields */  /** A connection that returns a paginated collection of metric values. */  /** The query to get the metric values from a component's metric source. */  /** A metric value stores the numerical data relating to the component. */  /** An edge that contains a metric value and a cursor. */  /** A metric value to be inserted. */  /** A list of bucketed, ordered, metric values */  /** The details of a Compass pull request. */  /** A pull request event. */  /** The list of properties of the pull request event. */  /** The list of properties of the pull event. */ 
let $5b8397cef71e8614$export$7a6755e08e21a7bd = /*#__PURE__*/ function(CompassPullRequestQuerySortName) {
    CompassPullRequestQuerySortName["CycleTime"] = "CYCLE_TIME";
    CompassPullRequestQuerySortName["OpenToFirstReview"] = "OPEN_TO_FIRST_REVIEW";
    CompassPullRequestQuerySortName["PrClosedTime"] = "PR_CLOSED_TIME";
    CompassPullRequestQuerySortName["PrCreatedTime"] = "PR_CREATED_TIME";
    CompassPullRequestQuerySortName["ReviewTime"] = "REVIEW_TIME";
    return CompassPullRequestQuerySortName;
}({});
let $5b8397cef71e8614$export$d5ddc46f2d03ff56 = /*#__PURE__*/ function(CompassPullRequestStatus) {
    CompassPullRequestStatus["Created"] = "CREATED";
    CompassPullRequestStatus["FirstReviewed"] = "FIRST_REVIEWED";
    CompassPullRequestStatus["Merged"] = "MERGED";
    CompassPullRequestStatus["Overdue"] = "OVERDUE";
    CompassPullRequestStatus["Rejected"] = "REJECTED";
    return CompassPullRequestStatus;
}({}); /** The pull request status used in the StatusInTimeRangeFilter query. */ 
let $5b8397cef71e8614$export$6a1e195288b23c05 = /*#__PURE__*/ function(CompassPullRequestStatusForStatusInTimeRangeFilter) {
    CompassPullRequestStatusForStatusInTimeRangeFilter["Created"] = "CREATED";
    CompassPullRequestStatusForStatusInTimeRangeFilter["FirstReviewed"] = "FIRST_REVIEWED";
    CompassPullRequestStatusForStatusInTimeRangeFilter["Merged"] = "MERGED";
    CompassPullRequestStatusForStatusInTimeRangeFilter["Rejected"] = "REJECTED";
    return CompassPullRequestStatusForStatusInTimeRangeFilter;
}({}); /** Accepts input to find pull requests. */  /** Accepts input for querying pull requests. */  /** A push event. */  /** The author who made the push */  /** The list of properties of the push event. */  /** The list of properties of the push event. */  /** A filter to apply to the search results. */ 
let $5b8397cef71e8614$export$94d43384cf172d05 = /*#__PURE__*/ function(CompassQuerySortOrder) {
    CompassQuerySortOrder["Asc"] = "ASC";
    CompassQuerySortOrder["Desc"] = "DESC";
    return CompassQuerySortOrder;
}({}); /** The payload returned from reactivating a scorecard for a component. */  /** A relationship between two components. The startNode and endNode depends on the direction of the relationship. */  /** Defines the possible relationship directions between components. */ 
let $5b8397cef71e8614$export$c8e6de4296189e26 = /*#__PURE__*/ function(CompassRelationshipDirection) {
    CompassRelationshipDirection["Inward"] = "INWARD";
    CompassRelationshipDirection["Outward"] = "OUTWARD";
    return CompassRelationshipDirection;
}({}); /** Accepts input for finding component relationships. */  /** Defines the relationship types. A relationship must be one of these types. */ 
let $5b8397cef71e8614$export$2a274d082ac90bb0 = /*#__PURE__*/ function(CompassRelationshipType) {
    CompassRelationshipType["DependsOn"] = "DEPENDS_ON";
    return CompassRelationshipType;
}({}); /** Accepts input for removing labels from a team. */  /** The payload returned after removing labels from a team. */  /** An object containing rich text versions of a string. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** The configuration for a scorecard that can be used by components. */  /** Contains the application rules for how a scorecard will apply to components. */  /** Accepts input to find components a scorecard is applied to and their scores */  /** Accepts input to sort the applied components by. */  /** The configuration for a scorecard criterion that can be shared across components. */  /** The configuration for a scorecard criterion that can be shared across components. */  /** Contains the calculated score for each scorecard criteria that is associated with a specific component. */  /** Historical criteria scores. */  /** Specifies the periodicity (regular repetition at fixed intervals) of the criteria score history data. */ 
let $5b8397cef71e8614$export$854cc3c30987ee51 = /*#__PURE__*/ function(CompassScorecardCriteriaScoreHistoryPeriodicity) {
    CompassScorecardCriteriaScoreHistoryPeriodicity["Daily"] = "DAILY";
    CompassScorecardCriteriaScoreHistoryPeriodicity["Weekly"] = "WEEKLY";
    return CompassScorecardCriteriaScoreHistoryPeriodicity;
}({}); /** Accepts input for querying criteria score history. */  /** Accepts input for filtering when querying criteria score history. */  /** Represents a historical breakdown of scorecard criteria score. */  /** Accepts input to filter the scorecard criteria statistics history. */ 
let $5b8397cef71e8614$export$742385f55bd1cd4c = /*#__PURE__*/ function(CompassScorecardCriteriaScoringStrategyRuleAction) {
    CompassScorecardCriteriaScoringStrategyRuleAction["MarkAsFailed"] = "MARK_AS_FAILED";
    CompassScorecardCriteriaScoringStrategyRuleAction["MarkAsPassed"] = "MARK_AS_PASSED";
    CompassScorecardCriteriaScoringStrategyRuleAction["MarkAsSkipped"] = "MARK_AS_SKIPPED";
    return CompassScorecardCriteriaScoringStrategyRuleAction;
}({}); /** Represents a statistical breakdown of scorecard criteria. */  /** Represents a count of components with the given score status for a scorecard criterion. */  /** COMPASS SCORECARD DEACTIVATION TYPES */  /** Accepts input to sort the deactivated components by. */  /** The types used to identify the importance of the scorecard. */ 
let $5b8397cef71e8614$export$8f487531178b2612 = /*#__PURE__*/ function(CompassScorecardImportance) {
    CompassScorecardImportance["Recommended"] = "RECOMMENDED";
    CompassScorecardImportance["Required"] = "REQUIRED";
    CompassScorecardImportance["UserDefined"] = "USER_DEFINED";
    return CompassScorecardImportance;
}({}); /** Accepts input to filter the scorecards by. */  /** Accepts input to sort the scorecards by. */  /** Sort scorecards in ascending or descending order of specified field. */ 
let $5b8397cef71e8614$export$edfe0f1e34848d09 = /*#__PURE__*/ function(CompassScorecardQuerySortOrder) {
    CompassScorecardQuerySortOrder["Asc"] = "ASC";
    CompassScorecardQuerySortOrder["Desc"] = "DESC";
    return CompassScorecardQuerySortOrder;
}({}); /** Contains the calculated score for a component. Each component has one calculated score per scorecard. */  /** Accepts input to filter the scorecard score durations statistics. */  /** A historical scorecard score. */  /** SCORE HISTORY */  /** Specifies the periodicity (regular repetition at fixed intervals) of the scorecard score history data. */ 
let $5b8397cef71e8614$export$ac226c775361dae9 = /*#__PURE__*/ function(CompassScorecardScoreHistoryPeriodicity) {
    CompassScorecardScoreHistoryPeriodicity["Daily"] = "DAILY";
    CompassScorecardScoreHistoryPeriodicity["Weekly"] = "WEEKLY";
    return CompassScorecardScoreHistoryPeriodicity;
}({}); /** Accepts input for querying scorecard score history. */  /** Accepts input for filtering when querying scorecard score history. */  /** Scorecard score on a scorecard for a component. */  /** Represents a count of components with the given score status for a scorecard. */  /** Represents a historical breakdown of scorecard score. */  /** SCORE STATISTICS HISTORY */  /** Accepts input to filter the scorecard score statistics history. */  /** Represents a scorecard score status. */ 
let $5b8397cef71e8614$export$f073cd3745c42272 = /*#__PURE__*/ function(CompassScorecardScoringStrategyType) {
    CompassScorecardScoringStrategyType["PointBased"] = "POINT_BASED";
    CompassScorecardScoringStrategyType["WeightBased"] = "WEIGHT_BASED";
    return CompassScorecardScoringStrategyType;
}({}); /** Accepts input to find available scorecards, optionally filtered and/or sorted. */  /** The query to find component labels within Compass. */  /** The query to find components. */  /** A connection that returns a paginated collection of team labels. */  /** An edge that contains a team label and a cursor. */  /** Accepts input for searching team labels. */  /** A connection that returns a paginated collection of teams */  /** The details of a Pull request's timestamps. */  /** A team checkin communicates checkin for a team. */  /** An action item of a team checkin. */  /** Accepts input for creating/updating/deleting team checkin's action item. */  /** Accepts input for deleting a team checkin. */  /** The payload returned when querying for Compass-specific team data. */  /** The payload returned when querying for Compass-specific team data. */  /** The payload returned when querying for Compass-specific team data. */  /** Accepts input for viewing Compass-specific data about a team. */  /** A label provides additional contextual information about a team. */  /** A metric source scoped to a Team */  /** A metric source scoped to a Team */  /** Accepts input for updating a component announcement. */  /** The payload returned after updating a component announcement. */  /** Accepts input for updating a Component Scorecard Jira issue. */  /** The payload returned after updating a Compass Component Scorecard Jira issue. */  /** Accepts input for updating a custom boolean field definition. */  /** Accepts input for updating a custom field definition. You must provide exactly one of the fields in this input type. */  /** The payload returned from updating a custom field definition. */  /** Accepts input for updating a custom multi select field definition. */  /** Accepts input for updating a custom number field definition. */  /** Accepts input for updating a custom single select field definition. */  /** Accepts input for updating a custom text field definition. */  /** Accepts input for updating a custom user field definition. */  /** Accepts input to update a scorecard criterion checking the value of a specified custom boolean field. */  /** Accepts input to update a scorecard criterion checking the value of a specified custom number field. */  /** Accepts input to update a scorecard criterion checking the value of a specified custom text field. */  /** The input to update a metric definition. */  /** The payload returned from updating a metric definition. */  /** The payload returned after updating the custom permission configs. */  /** Accepts input for updating a team checkin action. */  /** Accepts input for updating a team checkin. */  /** The payload returned after updating a team checkin. */  /** Accepts input for updating team checkin responses with rich text. */  /** Definition of a parameter that enables users to input data */  /** Viewer's subscription. */  /** A webhook that is invoked after a component is created from a template. */  /** All Atlassian Cloud Products an app version is compatible with */  /** All Atlassian DataCenter Products an app version is compatible with */  /** All Atlassian Products an app version is compatible with */  /** All Atlassian Server Products an app version is compatible with */  /** Complete sprint */  /** Event data corresponding to a dataManager updating a component. */  /** Details on the result of the last component sync. */  /** Status types of a data manager sync event. */ 
let $5b8397cef71e8614$export$f1221e641dc6f3ef = /*#__PURE__*/ function(ComponentSyncEventStatus) {
    ComponentSyncEventStatus["ServerError"] = "SERVER_ERROR";
    ComponentSyncEventStatus["Success"] = "SUCCESS";
    ComponentSyncEventStatus["UserError"] = "USER_ERROR";
    return ComponentSyncEventStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:blogpost:confluence__
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$f2d20e136929adb = /*#__PURE__*/ function(ConfluenceBlogPostStatus) {
    ConfluenceBlogPostStatus["Archived"] = "ARCHIVED";
    ConfluenceBlogPostStatus["Current"] = "CURRENT";
    ConfluenceBlogPostStatus["Deleted"] = "DELETED";
    ConfluenceBlogPostStatus["Draft"] = "DRAFT";
    ConfluenceBlogPostStatus["Historical"] = "HISTORICAL";
    ConfluenceBlogPostStatus["Trashed"] = "TRASHED";
    return ConfluenceBlogPostStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$92fbeeae7bfc11f8 = /*#__PURE__*/ function(ConfluenceBodyRepresentation) {
    ConfluenceBodyRepresentation["AnonymousExportView"] = "ANONYMOUS_EXPORT_VIEW";
    ConfluenceBodyRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceBodyRepresentation["Dynamic"] = "DYNAMIC";
    ConfluenceBodyRepresentation["Editor"] = "EDITOR";
    ConfluenceBodyRepresentation["Editor2"] = "EDITOR2";
    ConfluenceBodyRepresentation["ExportView"] = "EXPORT_VIEW";
    ConfluenceBodyRepresentation["Storage"] = "STORAGE";
    ConfluenceBodyRepresentation["StyledView"] = "STYLED_VIEW";
    ConfluenceBodyRepresentation["View"] = "VIEW";
    return ConfluenceBodyRepresentation;
}({});
let $5b8397cef71e8614$export$c0eb639b68d4388a = /*#__PURE__*/ function(ConfluenceCollaborativeEditingService) {
    ConfluenceCollaborativeEditingService["Ncs"] = "NCS";
    ConfluenceCollaborativeEditingService["Synchrony"] = "SYNCHRONY";
    return ConfluenceCollaborativeEditingService;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:comment:confluence__
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$33f6fe4ae00b4df5 = /*#__PURE__*/ function(ConfluenceCommentStatus) {
    ConfluenceCommentStatus["Current"] = "CURRENT";
    ConfluenceCommentStatus["Draft"] = "DRAFT";
    return ConfluenceCommentStatus;
}({});
let $5b8397cef71e8614$export$6fc7e2bddad2dec7 = /*#__PURE__*/ function(ConfluenceCommentType) {
    ConfluenceCommentType["Footer"] = "FOOTER";
    ConfluenceCommentType["Inline"] = "INLINE";
    return ConfluenceCommentType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$7ba61dc1e5005a2 = /*#__PURE__*/ function(ConfluenceContentRepresentation) {
    ConfluenceContentRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceContentRepresentation["Editor"] = "EDITOR";
    ConfluenceContentRepresentation["Editor2"] = "EDITOR2";
    ConfluenceContentRepresentation["ExportView"] = "EXPORT_VIEW";
    ConfluenceContentRepresentation["Plain"] = "PLAIN";
    ConfluenceContentRepresentation["Raw"] = "RAW";
    ConfluenceContentRepresentation["Storage"] = "STORAGE";
    ConfluenceContentRepresentation["StyledView"] = "STYLED_VIEW";
    ConfluenceContentRepresentation["View"] = "VIEW";
    ConfluenceContentRepresentation["Wiki"] = "WIKI";
    return ConfluenceContentRepresentation;
}({});
let $5b8397cef71e8614$export$98ac9eece9e68319 = /*#__PURE__*/ function(ConfluenceContentType) {
    ConfluenceContentType["Attachment"] = "ATTACHMENT";
    ConfluenceContentType["BlogPost"] = "BLOG_POST";
    ConfluenceContentType["Comment"] = "COMMENT";
    ConfluenceContentType["Page"] = "PAGE";
    ConfluenceContentType["Whiteboard"] = "WHITEBOARD";
    return ConfluenceContentType;
}({});
let $5b8397cef71e8614$export$353a51d90d6c94b7 = /*#__PURE__*/ function(ConfluenceContributionStatus) {
    ConfluenceContributionStatus["Current"] = "CURRENT";
    ConfluenceContributionStatus["Draft"] = "DRAFT";
    ConfluenceContributionStatus["Unknown"] = "UNKNOWN";
    ConfluenceContributionStatus["Unpublished"] = "UNPUBLISHED";
    return ConfluenceContributionStatus;
}({}); /** The result of a successful copy page Long Task. */  /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$d9c59fb36f888de3 = /*#__PURE__*/ function(ConfluenceInlineCommentResolutionStatus) {
    ConfluenceInlineCommentResolutionStatus["Resolved"] = "RESOLVED";
    ConfluenceInlineCommentResolutionStatus["Unresolved"] = "UNRESOLVED";
    return ConfluenceInlineCommentResolutionStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:inlinetask:confluence__
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$d6dc66c7e58b1f27 = /*#__PURE__*/ function(ConfluenceInlineTaskStatus) {
    ConfluenceInlineTaskStatus["Complete"] = "COMPLETE";
    ConfluenceInlineTaskStatus["Incomplete"] = "INCOMPLETE";
    return ConfluenceInlineTaskStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:label:confluence__
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$55cdc784c43406a6 = /*#__PURE__*/ function(ConfluenceLegacyAccessStatus) {
    ConfluenceLegacyAccessStatus["AnonymousAccess"] = "ANONYMOUS_ACCESS";
    ConfluenceLegacyAccessStatus["ExternalCollaboratorAccess"] = "EXTERNAL_COLLABORATOR_ACCESS";
    ConfluenceLegacyAccessStatus["ExternalShareAccess"] = "EXTERNAL_SHARE_ACCESS";
    ConfluenceLegacyAccessStatus["LicensedAdminAccess"] = "LICENSED_ADMIN_ACCESS";
    ConfluenceLegacyAccessStatus["LicensedUseAccess"] = "LICENSED_USE_ACCESS";
    ConfluenceLegacyAccessStatus["NotPermitted"] = "NOT_PERMITTED";
    ConfluenceLegacyAccessStatus["UnlicensedAuthenticatedAccess"] = "UNLICENSED_AUTHENTICATED_ACCESS";
    return ConfluenceLegacyAccessStatus;
}({});
let $5b8397cef71e8614$export$6fb100d84dc744ee = /*#__PURE__*/ function(ConfluenceLegacyAccessType) {
    ConfluenceLegacyAccessType["Edit"] = "EDIT";
    ConfluenceLegacyAccessType["View"] = "VIEW";
    return ConfluenceLegacyAccessType;
}({});
let $5b8397cef71e8614$export$f94f4d758ab56d24 = /*#__PURE__*/ function(ConfluenceLegacyAccountType) {
    ConfluenceLegacyAccountType["App"] = "APP";
    ConfluenceLegacyAccountType["Atlassian"] = "ATLASSIAN";
    ConfluenceLegacyAccountType["Customer"] = "CUSTOMER";
    ConfluenceLegacyAccountType["Unknown"] = "UNKNOWN";
    return ConfluenceLegacyAccountType;
}({}); /** --------------------------------------------------------------------------------------------- */  /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$67a1e2571d1b8f49 = /*#__PURE__*/ function(ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder) {
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["Default"] = "DEFAULT";
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["ScheduledEndDate"] = "SCHEDULED_END_DATE";
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["ScheduledStartDate"] = "SCHEDULED_START_DATE";
    ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder["Visibility"] = "VISIBILITY";
    return ConfluenceLegacyAdminAnnouncementBannerSettingsByCriteriaOrder;
}({});
let $5b8397cef71e8614$export$abe83d18892e131e = /*#__PURE__*/ function(ConfluenceLegacyAdminAnnouncementBannerStatusType) {
    ConfluenceLegacyAdminAnnouncementBannerStatusType["Published"] = "PUBLISHED";
    ConfluenceLegacyAdminAnnouncementBannerStatusType["Saved"] = "SAVED";
    ConfluenceLegacyAdminAnnouncementBannerStatusType["Scheduled"] = "SCHEDULED";
    return ConfluenceLegacyAdminAnnouncementBannerStatusType;
}({});
let $5b8397cef71e8614$export$6ea4d7ff878e1fa7 = /*#__PURE__*/ function(ConfluenceLegacyAdminAnnouncementBannerVisibilityType) {
    ConfluenceLegacyAdminAnnouncementBannerVisibilityType["All"] = "ALL";
    ConfluenceLegacyAdminAnnouncementBannerVisibilityType["Authorized"] = "AUTHORIZED";
    return ConfluenceLegacyAdminAnnouncementBannerVisibilityType;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $5b8397cef71e8614$export$592845e9ae5bd115 = /*#__PURE__*/ function(ConfluenceLegacyAllUpdatesFeedEventType) {
    ConfluenceLegacyAllUpdatesFeedEventType["Comment"] = "COMMENT";
    ConfluenceLegacyAllUpdatesFeedEventType["Create"] = "CREATE";
    ConfluenceLegacyAllUpdatesFeedEventType["Edit"] = "EDIT";
    return ConfluenceLegacyAllUpdatesFeedEventType;
}({});
let $5b8397cef71e8614$export$4f7b2d728c929a44 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsCommentType) {
    ConfluenceLegacyAnalyticsCommentType["Inline"] = "inline";
    ConfluenceLegacyAnalyticsCommentType["Page"] = "page";
    return ConfluenceLegacyAnalyticsCommentType;
}({});
let $5b8397cef71e8614$export$e30f067708a78859 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsContentType) {
    ConfluenceLegacyAnalyticsContentType["Blogpost"] = "blogpost";
    ConfluenceLegacyAnalyticsContentType["Page"] = "page";
    return ConfluenceLegacyAnalyticsContentType;
}({}); /** Events to gather analytics for */ 
let $5b8397cef71e8614$export$974cb55686fb4ebc = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsEventName) {
    ConfluenceLegacyAnalyticsEventName["AnalyticsPageModalViewed"] = "analyticsPageModal_viewed";
    ConfluenceLegacyAnalyticsEventName["AutomationRuleTrackCreated"] = "automationRuleTrack_created";
    ConfluenceLegacyAnalyticsEventName["CalendarCreated"] = "calendar_created";
    ConfluenceLegacyAnalyticsEventName["CommentCreated"] = "comment_created";
    ConfluenceLegacyAnalyticsEventName["DatabaseCreated"] = "database_created";
    ConfluenceLegacyAnalyticsEventName["DatabaseViewed"] = "database_viewed";
    ConfluenceLegacyAnalyticsEventName["InspectPermissionsDialogViewed"] = "inspectPermissionsDialog_viewed";
    ConfluenceLegacyAnalyticsEventName["InstanceAnalyticsViewed"] = "instanceAnalytics_viewed";
    ConfluenceLegacyAnalyticsEventName["PageAnalyticsViewed"] = "pageAnalytics_viewed";
    ConfluenceLegacyAnalyticsEventName["PageCreated"] = "page_created";
    ConfluenceLegacyAnalyticsEventName["PageUpdated"] = "page_updated";
    ConfluenceLegacyAnalyticsEventName["PageViewed"] = "page_viewed";
    ConfluenceLegacyAnalyticsEventName["PubliclinkPageViewed"] = "publiclink_page_viewed";
    ConfluenceLegacyAnalyticsEventName["SpaceAnalyticsViewed"] = "spaceAnalytics_viewed";
    ConfluenceLegacyAnalyticsEventName["TeamCalendarsViewed"] = "teamCalendars_viewed";
    ConfluenceLegacyAnalyticsEventName["WhiteboardCreated"] = "whiteboard_created";
    ConfluenceLegacyAnalyticsEventName["WhiteboardViewed"] = "whiteboard_viewed";
    return ConfluenceLegacyAnalyticsEventName;
}({}); /** Events to gather measure analytics for */ 
let $5b8397cef71e8614$export$9dc60e43906fc093 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsMeasuresEventName) {
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentBlogpostCountSitestateMeasured"] = "currentBlogpostCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentBlogpostCountSpacestateMeasured"] = "currentBlogpostCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentDatabaseCountSitestateMeasured"] = "currentDatabaseCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentDatabaseCountSpacestateMeasured"] = "currentDatabaseCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentPageCountSitestateMeasured"] = "currentPageCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentPageCountSpacestateMeasured"] = "currentPageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentWhiteboardCountSitestateMeasured"] = "currentWhiteboardCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["CurrentWhiteboardCountSpacestateMeasured"] = "currentWhiteboardCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["InactivePageCountSitestateMeasured"] = "inactivePageCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["InactivePageCountSpacestateMeasured"] = "inactivePageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActiveCommunalSpacesSitestateMeasured"] = "totalActiveCommunalSpaces_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActivePersonalSpacesSitestateMeasured"] = "totalActivePersonalSpaces_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActivePublicLinksSitestateMeasured"] = "totalActivePublicLinks_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActivePublicLinksSpacestateMeasured"] = "totalActivePublicLinks_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalActiveSpacesSitestateMeasured"] = "totalActiveSpaces_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentBlogpostCountSitestateMeasured"] = "totalCurrentBlogpostCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentDatabaseCountSitestateMeasured"] = "totalCurrentDatabaseCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentPageCountSitestateMeasured"] = "totalCurrentPageCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalCurrentWhiteboardCountSitestateMeasured"] = "totalCurrentWhiteboardCount_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalPagesDeactivatedOwnerSitestateMeasured"] = "totalPagesDeactivatedOwner_sitestate_measured";
    ConfluenceLegacyAnalyticsMeasuresEventName["TotalPagesDeactivatedOwnerSpacestateMeasured"] = "totalPagesDeactivatedOwner_spacestate_measured";
    return ConfluenceLegacyAnalyticsMeasuresEventName;
}({}); /** Events to gather measure analytics space state */ 
let $5b8397cef71e8614$export$529a0a3fc89fb460 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsMeasuresSpaceEventName) {
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentBlogpostCountSpacestateMeasured"] = "currentBlogpostCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentDatabaseCountSpacestateMeasured"] = "currentDatabaseCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentPageCountSpacestateMeasured"] = "currentPageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["CurrentWhiteboardCountSpacestateMeasured"] = "currentWhiteboardCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["InactivePageCountSpacestateMeasured"] = "inactivePageCount_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["TotalActivePublicLinksSpacestateMeasured"] = "totalActivePublicLinks_spacestate_measured";
    ConfluenceLegacyAnalyticsMeasuresSpaceEventName["TotalPagesDeactivatedOwnerSpacestateMeasured"] = "totalPagesDeactivatedOwner_spacestate_measured";
    return ConfluenceLegacyAnalyticsMeasuresSpaceEventName;
}({}); /** Events to gather search analytics for */ 
let $5b8397cef71e8614$export$5a62729781e5150 = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsSearchEventName) {
    ConfluenceLegacyAnalyticsSearchEventName["AdvancedSearchResultLinkClicked"] = "advancedSearchResultLink_clicked";
    ConfluenceLegacyAnalyticsSearchEventName["AdvancedSearchResultsShown"] = "advancedSearchResults_shown";
    ConfluenceLegacyAnalyticsSearchEventName["QuickSearchRequestCompleted"] = "quickSearchRequest_completed";
    ConfluenceLegacyAnalyticsSearchEventName["QuickSearchResultSelected"] = "quickSearchResult_selected";
    return ConfluenceLegacyAnalyticsSearchEventName;
}({}); /** Granularity to group events by */ 
let $5b8397cef71e8614$export$cd1f6d32ed31f38f = /*#__PURE__*/ function(ConfluenceLegacyAnalyticsTimeseriesGranularity) {
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Day"] = "DAY";
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Hour"] = "HOUR";
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Month"] = "MONTH";
    ConfluenceLegacyAnalyticsTimeseriesGranularity["Week"] = "WEEK";
    return ConfluenceLegacyAnalyticsTimeseriesGranularity;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $5b8397cef71e8614$export$84cc0985ee5132c3 = /*#__PURE__*/ function(ConfluenceLegacyBackendExperiment) {
    ConfluenceLegacyBackendExperiment["Einstein"] = "EINSTEIN";
    return ConfluenceLegacyBackendExperiment;
}({});
let $5b8397cef71e8614$export$72d2271493719cd9 = /*#__PURE__*/ function(ConfluenceLegacyBillingSourceSystem) {
    ConfluenceLegacyBillingSourceSystem["Ccp"] = "CCP";
    ConfluenceLegacyBillingSourceSystem["Hams"] = "HAMS";
    return ConfluenceLegacyBillingSourceSystem;
}({}); /** Represents a block-rendered smart-link on a page */ 
let $5b8397cef71e8614$export$1d6c7c01499dab = /*#__PURE__*/ function(ConfluenceLegacyBodyFormatType) {
    ConfluenceLegacyBodyFormatType["AnonymousExportView"] = "ANONYMOUS_EXPORT_VIEW";
    ConfluenceLegacyBodyFormatType["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceLegacyBodyFormatType["Editor"] = "EDITOR";
    ConfluenceLegacyBodyFormatType["Editor2"] = "EDITOR2";
    ConfluenceLegacyBodyFormatType["ExportView"] = "EXPORT_VIEW";
    ConfluenceLegacyBodyFormatType["Storage"] = "STORAGE";
    ConfluenceLegacyBodyFormatType["StyledView"] = "STYLED_VIEW";
    ConfluenceLegacyBodyFormatType["View"] = "VIEW";
    return ConfluenceLegacyBodyFormatType;
}({});
let $5b8397cef71e8614$export$808cc4b811411528 = /*#__PURE__*/ function(ConfluenceLegacyBulkSetSpacePermissionSpaceType) {
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["Collaboration"] = "COLLABORATION";
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["Global"] = "GLOBAL";
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["KnowledgeBase"] = "KNOWLEDGE_BASE";
    ConfluenceLegacyBulkSetSpacePermissionSpaceType["Personal"] = "PERSONAL";
    return ConfluenceLegacyBulkSetSpacePermissionSpaceType;
}({});
let $5b8397cef71e8614$export$7537b52b3e1ca17f = /*#__PURE__*/ function(ConfluenceLegacyBulkSetSpacePermissionSubjectType) {
    ConfluenceLegacyBulkSetSpacePermissionSubjectType["Group"] = "GROUP";
    ConfluenceLegacyBulkSetSpacePermissionSubjectType["User"] = "USER";
    return ConfluenceLegacyBulkSetSpacePermissionSubjectType;
}({});
let $5b8397cef71e8614$export$c274657b6ae8c08b = /*#__PURE__*/ function(ConfluenceLegacyCatchupContentType) {
    ConfluenceLegacyCatchupContentType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacyCatchupContentType["Page"] = "PAGE";
    return ConfluenceLegacyCatchupContentType;
}({});
let $5b8397cef71e8614$export$d3260cc27acb2273 = /*#__PURE__*/ function(ConfluenceLegacyCatchupUpdateType) {
    ConfluenceLegacyCatchupUpdateType["TopN"] = "TOP_N";
    return ConfluenceLegacyCatchupUpdateType;
}({});
let $5b8397cef71e8614$export$fbf27f279c195cfd = /*#__PURE__*/ function(ConfluenceLegacyCommentCreationLocation) {
    ConfluenceLegacyCommentCreationLocation["Editor"] = "EDITOR";
    ConfluenceLegacyCommentCreationLocation["Live"] = "LIVE";
    ConfluenceLegacyCommentCreationLocation["Renderer"] = "RENDERER";
    ConfluenceLegacyCommentCreationLocation["Whiteboard"] = "WHITEBOARD";
    return ConfluenceLegacyCommentCreationLocation;
}({});
let $5b8397cef71e8614$export$68d0cd998b71f75b = /*#__PURE__*/ function(ConfluenceLegacyCommentDeletionLocation) {
    ConfluenceLegacyCommentDeletionLocation["Live"] = "LIVE";
    return ConfluenceLegacyCommentDeletionLocation;
}({});
let $5b8397cef71e8614$export$e2f309d5fad312d0 = /*#__PURE__*/ function(ConfluenceLegacyCommentReplyType) {
    ConfluenceLegacyCommentReplyType["Emoji"] = "EMOJI";
    ConfluenceLegacyCommentReplyType["Prompt"] = "PROMPT";
    ConfluenceLegacyCommentReplyType["QuickReply"] = "QUICK_REPLY";
    return ConfluenceLegacyCommentReplyType;
}({});
let $5b8397cef71e8614$export$2dfdca1bacc36231 = /*#__PURE__*/ function(ConfluenceLegacyCommentType) {
    ConfluenceLegacyCommentType["Footer"] = "FOOTER";
    ConfluenceLegacyCommentType["Inline"] = "INLINE";
    ConfluenceLegacyCommentType["Resolved"] = "RESOLVED";
    ConfluenceLegacyCommentType["Unresolved"] = "UNRESOLVED";
    return ConfluenceLegacyCommentType;
}({});
let $5b8397cef71e8614$export$b6d21fe6703a2599 = /*#__PURE__*/ function(ConfluenceLegacyCommentsType) {
    ConfluenceLegacyCommentsType["Footer"] = "FOOTER";
    ConfluenceLegacyCommentsType["Inline"] = "INLINE";
    return ConfluenceLegacyCommentsType;
}({});
let $5b8397cef71e8614$export$83d2156f88d87d3c = /*#__PURE__*/ function(ConfluenceLegacyContactAdminPageDisabledReason) {
    ConfluenceLegacyContactAdminPageDisabledReason["ConfigOff"] = "CONFIG_OFF";
    ConfluenceLegacyContactAdminPageDisabledReason["NoAdminEmails"] = "NO_ADMIN_EMAILS";
    ConfluenceLegacyContactAdminPageDisabledReason["NoMailServer"] = "NO_MAIL_SERVER";
    ConfluenceLegacyContactAdminPageDisabledReason["NoRecaptcha"] = "NO_RECAPTCHA";
    return ConfluenceLegacyContactAdminPageDisabledReason;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $5b8397cef71e8614$export$dc0b3486b6d302da = /*#__PURE__*/ function(ConfluenceLegacyContainerType) {
    ConfluenceLegacyContainerType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacyContainerType["Page"] = "PAGE";
    ConfluenceLegacyContainerType["Space"] = "SPACE";
    ConfluenceLegacyContainerType["Whiteboard"] = "WHITEBOARD";
    return ConfluenceLegacyContainerType;
}({});
let $5b8397cef71e8614$export$14a0d7c84f79aebf = /*#__PURE__*/ function(ConfluenceLegacyContentAccessInputType) {
    ConfluenceLegacyContentAccessInputType["EveryoneCanEdit"] = "EVERYONE_CAN_EDIT";
    ConfluenceLegacyContentAccessInputType["EveryoneCanView"] = "EVERYONE_CAN_VIEW";
    ConfluenceLegacyContentAccessInputType["EveryoneNoAccess"] = "EVERYONE_NO_ACCESS";
    ConfluenceLegacyContentAccessInputType["Private"] = "PRIVATE";
    return ConfluenceLegacyContentAccessInputType;
}({});
let $5b8397cef71e8614$export$cf8f2171d823bde = /*#__PURE__*/ function(ConfluenceLegacyContentAccessType) {
    ConfluenceLegacyContentAccessType["EveryoneCanEdit"] = "EVERYONE_CAN_EDIT";
    ConfluenceLegacyContentAccessType["EveryoneCanView"] = "EVERYONE_CAN_VIEW";
    ConfluenceLegacyContentAccessType["EveryoneNoAccess"] = "EVERYONE_NO_ACCESS";
    return ConfluenceLegacyContentAccessType;
}({});
let $5b8397cef71e8614$export$1c8c23d711ae773e = /*#__PURE__*/ function(ConfluenceLegacyContentAction) {
    ConfluenceLegacyContentAction["Created"] = "created";
    ConfluenceLegacyContentAction["Updated"] = "updated";
    ConfluenceLegacyContentAction["Viewed"] = "viewed";
    return ConfluenceLegacyContentAction;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$a78e2be628bf0936 = /*#__PURE__*/ function(ConfluenceLegacyContentDataClassificationMutationContentStatus) {
    ConfluenceLegacyContentDataClassificationMutationContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyContentDataClassificationMutationContentStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyContentDataClassificationMutationContentStatus;
}({});
let $5b8397cef71e8614$export$8294e4a5584cdafb = /*#__PURE__*/ function(ConfluenceLegacyContentDataClassificationQueryContentStatus) {
    ConfluenceLegacyContentDataClassificationQueryContentStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyContentDataClassificationQueryContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyContentDataClassificationQueryContentStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyContentDataClassificationQueryContentStatus;
}({});
let $5b8397cef71e8614$export$11a7365bbd55a2c3 = /*#__PURE__*/ function(ConfluenceLegacyContentDeleteActionType) {
    ConfluenceLegacyContentDeleteActionType["DeleteDraft"] = "DELETE_DRAFT";
    ConfluenceLegacyContentDeleteActionType["DeleteDraftIfBlank"] = "DELETE_DRAFT_IF_BLANK";
    ConfluenceLegacyContentDeleteActionType["MoveToTrash"] = "MOVE_TO_TRASH";
    ConfluenceLegacyContentDeleteActionType["PurgeFromTrash"] = "PURGE_FROM_TRASH";
    return ConfluenceLegacyContentDeleteActionType;
}({});
let $5b8397cef71e8614$export$e4765167602a01a4 = /*#__PURE__*/ function(ConfluenceLegacyContentPermissionType) {
    ConfluenceLegacyContentPermissionType["Edit"] = "EDIT";
    ConfluenceLegacyContentPermissionType["View"] = "VIEW";
    return ConfluenceLegacyContentPermissionType;
}({});
let $5b8397cef71e8614$export$52bfd28e9d78a168 = /*#__PURE__*/ function(ConfluenceLegacyContentRendererMode) {
    ConfluenceLegacyContentRendererMode["Editor"] = "EDITOR";
    ConfluenceLegacyContentRendererMode["Pdf"] = "PDF";
    ConfluenceLegacyContentRendererMode["Renderer"] = "RENDERER";
    return ConfluenceLegacyContentRendererMode;
}({});
let $5b8397cef71e8614$export$9f48a780e64ab98d = /*#__PURE__*/ function(ConfluenceLegacyContentRepresentation) {
    ConfluenceLegacyContentRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceLegacyContentRepresentation["Editor"] = "EDITOR";
    ConfluenceLegacyContentRepresentation["Editor2"] = "EDITOR2";
    ConfluenceLegacyContentRepresentation["ExportView"] = "EXPORT_VIEW";
    ConfluenceLegacyContentRepresentation["Plain"] = "PLAIN";
    ConfluenceLegacyContentRepresentation["Raw"] = "RAW";
    ConfluenceLegacyContentRepresentation["Storage"] = "STORAGE";
    ConfluenceLegacyContentRepresentation["StyledView"] = "STYLED_VIEW";
    ConfluenceLegacyContentRepresentation["View"] = "VIEW";
    ConfluenceLegacyContentRepresentation["Wiki"] = "WIKI";
    return ConfluenceLegacyContentRepresentation;
}({});
let $5b8397cef71e8614$export$22638a777276bf91 = /*#__PURE__*/ function(ConfluenceLegacyContentRole) {
    ConfluenceLegacyContentRole["Default"] = "DEFAULT";
    ConfluenceLegacyContentRole["Editor"] = "EDITOR";
    ConfluenceLegacyContentRole["Viewer"] = "VIEWER";
    return ConfluenceLegacyContentRole;
}({});
let $5b8397cef71e8614$export$962cbd35615f4fff = /*#__PURE__*/ function(ConfluenceLegacyContentStateRestrictionLevel) {
    ConfluenceLegacyContentStateRestrictionLevel["None"] = "NONE";
    ConfluenceLegacyContentStateRestrictionLevel["PageOwner"] = "PAGE_OWNER";
    return ConfluenceLegacyContentStateRestrictionLevel;
}({});
let $5b8397cef71e8614$export$c24d6a3d72599268 = /*#__PURE__*/ function(ConfluenceLegacyContentStatus) {
    ConfluenceLegacyContentStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyContentStatus["Deleted"] = "DELETED";
    ConfluenceLegacyContentStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyContentStatus;
}({});
let $5b8397cef71e8614$export$492d1092720944e9 = /*#__PURE__*/ function(ConfluenceLegacyContentTemplateType) {
    ConfluenceLegacyContentTemplateType["Blueprint"] = "BLUEPRINT";
    ConfluenceLegacyContentTemplateType["Page"] = "PAGE";
    return ConfluenceLegacyContentTemplateType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$1ead28a8886cdf4e = /*#__PURE__*/ function(ConfluenceLegacyDataSecurityPolicyAction) {
    ConfluenceLegacyDataSecurityPolicyAction["AppAccess"] = "APP_ACCESS";
    ConfluenceLegacyDataSecurityPolicyAction["PageExport"] = "PAGE_EXPORT";
    ConfluenceLegacyDataSecurityPolicyAction["PublicLinks"] = "PUBLIC_LINKS";
    return ConfluenceLegacyDataSecurityPolicyAction;
}({});
let $5b8397cef71e8614$export$d97f1f6b89a9dab8 = /*#__PURE__*/ function(ConfluenceLegacyDataSecurityPolicyCoverageType) {
    ConfluenceLegacyDataSecurityPolicyCoverageType["ClassificationLevel"] = "CLASSIFICATION_LEVEL";
    ConfluenceLegacyDataSecurityPolicyCoverageType["Container"] = "CONTAINER";
    ConfluenceLegacyDataSecurityPolicyCoverageType["None"] = "NONE";
    ConfluenceLegacyDataSecurityPolicyCoverageType["Workspace"] = "WORKSPACE";
    return ConfluenceLegacyDataSecurityPolicyCoverageType;
}({});
let $5b8397cef71e8614$export$b8ebe8bcbe0edcc9 = /*#__PURE__*/ function(ConfluenceLegacyDataSecurityPolicyDecidableContentStatus) {
    ConfluenceLegacyDataSecurityPolicyDecidableContentStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyDataSecurityPolicyDecidableContentStatus["Current"] = "CURRENT";
    ConfluenceLegacyDataSecurityPolicyDecidableContentStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyDataSecurityPolicyDecidableContentStatus;
}({});
let $5b8397cef71e8614$export$8f82f21f1f98a966 = /*#__PURE__*/ function(ConfluenceLegacyDateFormat) {
    ConfluenceLegacyDateFormat["Global"] = "GLOBAL";
    ConfluenceLegacyDateFormat["Millis"] = "MILLIS";
    ConfluenceLegacyDateFormat["User"] = "USER";
    ConfluenceLegacyDateFormat["UserFriendly"] = "USER_FRIENDLY";
    return ConfluenceLegacyDateFormat;
}({});
let $5b8397cef71e8614$export$1c761a9499909678 = /*#__PURE__*/ function(ConfluenceLegacyDeactivatedPageOwnerUserType) {
    ConfluenceLegacyDeactivatedPageOwnerUserType["FormerUsers"] = "FORMER_USERS";
    ConfluenceLegacyDeactivatedPageOwnerUserType["NonFormerUsers"] = "NON_FORMER_USERS";
    return ConfluenceLegacyDeactivatedPageOwnerUserType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$477e85946b13cfd1 = /*#__PURE__*/ function(ConfluenceLegacyDepth) {
    ConfluenceLegacyDepth["All"] = "ALL";
    ConfluenceLegacyDepth["Root"] = "ROOT";
    return ConfluenceLegacyDepth;
}({});
let $5b8397cef71e8614$export$8ca8fdccfce3b6b2 = /*#__PURE__*/ function(ConfluenceLegacyDescendantsNoteApplicationOption) {
    ConfluenceLegacyDescendantsNoteApplicationOption["All"] = "ALL";
    ConfluenceLegacyDescendantsNoteApplicationOption["None"] = "NONE";
    ConfluenceLegacyDescendantsNoteApplicationOption["Roots"] = "ROOTS";
    return ConfluenceLegacyDescendantsNoteApplicationOption;
}({});
let $5b8397cef71e8614$export$9e676a15531fad10 = /*#__PURE__*/ function(ConfluenceLegacyDocumentRepresentation) {
    ConfluenceLegacyDocumentRepresentation["AtlasDocFormat"] = "ATLAS_DOC_FORMAT";
    ConfluenceLegacyDocumentRepresentation["Html"] = "HTML";
    ConfluenceLegacyDocumentRepresentation["Storage"] = "STORAGE";
    ConfluenceLegacyDocumentRepresentation["View"] = "VIEW";
    return ConfluenceLegacyDocumentRepresentation;
}({});
let $5b8397cef71e8614$export$c54c52e1dab26d52 = /*#__PURE__*/ function(ConfluenceLegacyEdition) {
    ConfluenceLegacyEdition["Free"] = "FREE";
    ConfluenceLegacyEdition["Premium"] = "PREMIUM";
    ConfluenceLegacyEdition["Standard"] = "STANDARD";
    return ConfluenceLegacyEdition;
}({});
let $5b8397cef71e8614$export$42d27343a8b84fc8 = /*#__PURE__*/ function(ConfluenceLegacyEditorConversionSetting) {
    ConfluenceLegacyEditorConversionSetting["None"] = "NONE";
    ConfluenceLegacyEditorConversionSetting["Supported"] = "SUPPORTED";
    return ConfluenceLegacyEditorConversionSetting;
}({}); /** Represents a smart-link rendered as embedded on a page */  /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$fb03d9af47277a3d = /*#__PURE__*/ function(ConfluenceLegacyEnvironment) {
    ConfluenceLegacyEnvironment["Development"] = "DEVELOPMENT";
    ConfluenceLegacyEnvironment["Production"] = "PRODUCTION";
    ConfluenceLegacyEnvironment["Staging"] = "STAGING";
    return ConfluenceLegacyEnvironment;
}({}); /** The default space assigned to new Confluence Guests on role assignment. */ 
let $5b8397cef71e8614$export$4e6002c4c65764d4 = /*#__PURE__*/ function(ConfluenceLegacyExternalCollaboratorsSortField) {
    ConfluenceLegacyExternalCollaboratorsSortField["Name"] = "NAME";
    return ConfluenceLegacyExternalCollaboratorsSortField;
}({});
let $5b8397cef71e8614$export$a828ec9b508a2266 = /*#__PURE__*/ function(ConfluenceLegacyFeedEventType) {
    ConfluenceLegacyFeedEventType["Comment"] = "COMMENT";
    ConfluenceLegacyFeedEventType["Create"] = "CREATE";
    ConfluenceLegacyFeedEventType["Edit"] = "EDIT";
    return ConfluenceLegacyFeedEventType;
}({});
let $5b8397cef71e8614$export$13866e2e9da2ea4b = /*#__PURE__*/ function(ConfluenceLegacyFeedItemSourceType) {
    ConfluenceLegacyFeedItemSourceType["Person"] = "PERSON";
    ConfluenceLegacyFeedItemSourceType["Space"] = "SPACE";
    return ConfluenceLegacyFeedItemSourceType;
}({});
let $5b8397cef71e8614$export$2e72a60396e89995 = /*#__PURE__*/ function(ConfluenceLegacyFeedType) {
    ConfluenceLegacyFeedType["Direct"] = "DIRECT";
    ConfluenceLegacyFeedType["Following"] = "FOLLOWING";
    ConfluenceLegacyFeedType["Popular"] = "POPULAR";
    return ConfluenceLegacyFeedType;
}({});
let $5b8397cef71e8614$export$25f79122cd5df609 = /*#__PURE__*/ function(ConfluenceLegacyFrontCoverState) {
    ConfluenceLegacyFrontCoverState["Hidden"] = "HIDDEN";
    ConfluenceLegacyFrontCoverState["Shown"] = "SHOWN";
    ConfluenceLegacyFrontCoverState["Transition"] = "TRANSITION";
    ConfluenceLegacyFrontCoverState["Unset"] = "UNSET";
    return ConfluenceLegacyFrontCoverState;
}({});
let $5b8397cef71e8614$export$a19da40648493053 = /*#__PURE__*/ function(ConfluenceLegacyHomeWidgetState) {
    ConfluenceLegacyHomeWidgetState["Collapsed"] = "COLLAPSED";
    ConfluenceLegacyHomeWidgetState["Expanded"] = "EXPANDED";
    return ConfluenceLegacyHomeWidgetState;
}({});
let $5b8397cef71e8614$export$5f0193f955ef0cb1 = /*#__PURE__*/ function(ConfluenceLegacyInitialPermissionOptions) {
    ConfluenceLegacyInitialPermissionOptions["CopyFromSpace"] = "COPY_FROM_SPACE";
    ConfluenceLegacyInitialPermissionOptions["Default"] = "DEFAULT";
    ConfluenceLegacyInitialPermissionOptions["Private"] = "PRIVATE";
    return ConfluenceLegacyInitialPermissionOptions;
}({}); /** Represents an inline-rendered smart-link on a page */  /** The date range for an Inline Tasks Query Date. Start dates and end dates can be null-able to represent no specified boundary. */ 
let $5b8397cef71e8614$export$df2ab38c891954c2 = /*#__PURE__*/ function(ConfluenceLegacyInlineTasksQuerySortColumn) {
    ConfluenceLegacyInlineTasksQuerySortColumn["Assignee"] = "ASSIGNEE";
    ConfluenceLegacyInlineTasksQuerySortColumn["DueDate"] = "DUE_DATE";
    ConfluenceLegacyInlineTasksQuerySortColumn["PageTitle"] = "PAGE_TITLE";
    return ConfluenceLegacyInlineTasksQuerySortColumn;
}({});
let $5b8397cef71e8614$export$cba96ef83f91f0df = /*#__PURE__*/ function(ConfluenceLegacyInlineTasksQuerySortOrder) {
    ConfluenceLegacyInlineTasksQuerySortOrder["Ascending"] = "ASCENDING";
    ConfluenceLegacyInlineTasksQuerySortOrder["Descending"] = "DESCENDING";
    return ConfluenceLegacyInlineTasksQuerySortOrder;
}({});
let $5b8397cef71e8614$export$b2bba2f5e2a7ff3e = /*#__PURE__*/ function(ConfluenceLegacyInspectPermissions) {
    ConfluenceLegacyInspectPermissions["Comment"] = "COMMENT";
    ConfluenceLegacyInspectPermissions["Edit"] = "EDIT";
    ConfluenceLegacyInspectPermissions["View"] = "VIEW";
    return ConfluenceLegacyInspectPermissions;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$56cd0576b91fa37a = /*#__PURE__*/ function(ConfluenceLegacyLabelSortDirection) {
    ConfluenceLegacyLabelSortDirection["Ascending"] = "ASCENDING";
    ConfluenceLegacyLabelSortDirection["Descending"] = "DESCENDING";
    return ConfluenceLegacyLabelSortDirection;
}({});
let $5b8397cef71e8614$export$c05dc088e940cc05 = /*#__PURE__*/ function(ConfluenceLegacyLabelSortField) {
    ConfluenceLegacyLabelSortField["LabellingCreationdate"] = "LABELLING_CREATIONDATE";
    ConfluenceLegacyLabelSortField["LabellingId"] = "LABELLING_ID";
    return ConfluenceLegacyLabelSortField;
}({});
let $5b8397cef71e8614$export$33f17291ac91a786 = /*#__PURE__*/ function(ConfluenceLegacyLicenseStatus) {
    ConfluenceLegacyLicenseStatus["Active"] = "ACTIVE";
    ConfluenceLegacyLicenseStatus["Suspended"] = "SUSPENDED";
    ConfluenceLegacyLicenseStatus["Unlicensed"] = "UNLICENSED";
    return ConfluenceLegacyLicenseStatus;
}({});
let $5b8397cef71e8614$export$662bb1896031bf06 = /*#__PURE__*/ function(ConfluenceLegacyLoomUserStatus) {
    ConfluenceLegacyLoomUserStatus["Linked"] = "LINKED";
    ConfluenceLegacyLoomUserStatus["Mastered"] = "MASTERED";
    ConfluenceLegacyLoomUserStatus["NotFound"] = "NOT_FOUND";
    return ConfluenceLegacyLoomUserStatus;
}({});
let $5b8397cef71e8614$export$fd5adc8aad00cb78 = /*#__PURE__*/ function(ConfluenceLegacyMobilePlatform) {
    ConfluenceLegacyMobilePlatform["Android"] = "ANDROID";
    ConfluenceLegacyMobilePlatform["Ios"] = "IOS";
    return ConfluenceLegacyMobilePlatform;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$728d574e7c9f150a = /*#__PURE__*/ function(ConfluenceLegacyOperation) {
    ConfluenceLegacyOperation["Assigned"] = "ASSIGNED";
    ConfluenceLegacyOperation["Complete"] = "COMPLETE";
    ConfluenceLegacyOperation["Deleted"] = "DELETED";
    ConfluenceLegacyOperation["InComplete"] = "IN_COMPLETE";
    ConfluenceLegacyOperation["Reworded"] = "REWORDED";
    ConfluenceLegacyOperation["Unassigned"] = "UNASSIGNED";
    return ConfluenceLegacyOperation;
}({});
let $5b8397cef71e8614$export$42875c45c64c8240 = /*#__PURE__*/ function(ConfluenceLegacyOutputDeviceType) {
    ConfluenceLegacyOutputDeviceType["Desktop"] = "DESKTOP";
    ConfluenceLegacyOutputDeviceType["Email"] = "EMAIL";
    ConfluenceLegacyOutputDeviceType["Mobile"] = "MOBILE";
    return ConfluenceLegacyOutputDeviceType;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $5b8397cef71e8614$export$938d9fc91bf189e3 = /*#__PURE__*/ function(ConfluenceLegacyPtGraphQlPageStatus) {
    ConfluenceLegacyPtGraphQlPageStatus["Current"] = "CURRENT";
    ConfluenceLegacyPtGraphQlPageStatus["Draft"] = "DRAFT";
    ConfluenceLegacyPtGraphQlPageStatus["Historical"] = "HISTORICAL";
    ConfluenceLegacyPtGraphQlPageStatus["Trashed"] = "TRASHED";
    return ConfluenceLegacyPtGraphQlPageStatus;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$32601201a16f0b5d = /*#__PURE__*/ function(ConfluenceLegacyPageActivityAction) {
    ConfluenceLegacyPageActivityAction["Created"] = "created";
    ConfluenceLegacyPageActivityAction["Updated"] = "updated";
    return ConfluenceLegacyPageActivityAction;
}({});
let $5b8397cef71e8614$export$768747d8a19c91ab = /*#__PURE__*/ function(ConfluenceLegacyPageActivityActionSubject) {
    ConfluenceLegacyPageActivityActionSubject["Comment"] = "comment";
    ConfluenceLegacyPageActivityActionSubject["Page"] = "page";
    return ConfluenceLegacyPageActivityActionSubject;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$47389b8ef7f23bf3 = /*#__PURE__*/ function(ConfluenceLegacyPageAnalyticsCountType) {
    ConfluenceLegacyPageAnalyticsCountType["All"] = "ALL";
    ConfluenceLegacyPageAnalyticsCountType["User"] = "USER";
    return ConfluenceLegacyPageAnalyticsCountType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$1a9b6173c3040cc0 = /*#__PURE__*/ function(ConfluenceLegacyPageAnalyticsTimeseriesCountType) {
    ConfluenceLegacyPageAnalyticsTimeseriesCountType["All"] = "ALL";
    return ConfluenceLegacyPageAnalyticsTimeseriesCountType;
}({});
let $5b8397cef71e8614$export$aa202cd8cef6b1c2 = /*#__PURE__*/ function(ConfluenceLegacyPageCardInPageTreeHoverPreference) {
    ConfluenceLegacyPageCardInPageTreeHoverPreference["NoOptionSelected"] = "NO_OPTION_SELECTED";
    ConfluenceLegacyPageCardInPageTreeHoverPreference["NoShowPagecard"] = "NO_SHOW_PAGECARD";
    ConfluenceLegacyPageCardInPageTreeHoverPreference["ShowPagecard"] = "SHOW_PAGECARD";
    return ConfluenceLegacyPageCardInPageTreeHoverPreference;
}({});
let $5b8397cef71e8614$export$865c06c6ecba3931 = /*#__PURE__*/ function(ConfluenceLegacyPageCopyRestrictionValidationStatus) {
    ConfluenceLegacyPageCopyRestrictionValidationStatus["InvalidMultiple"] = "INVALID_MULTIPLE";
    ConfluenceLegacyPageCopyRestrictionValidationStatus["InvalidSingle"] = "INVALID_SINGLE";
    ConfluenceLegacyPageCopyRestrictionValidationStatus["Valid"] = "VALID";
    return ConfluenceLegacyPageCopyRestrictionValidationStatus;
}({});
let $5b8397cef71e8614$export$29a013f0158561e = /*#__PURE__*/ function(ConfluenceLegacyPageStatus) {
    ConfluenceLegacyPageStatus["Current"] = "CURRENT";
    ConfluenceLegacyPageStatus["Draft"] = "DRAFT";
    ConfluenceLegacyPageStatus["Historical"] = "HISTORICAL";
    ConfluenceLegacyPageStatus["Trashed"] = "TRASHED";
    return ConfluenceLegacyPageStatus;
}({});
let $5b8397cef71e8614$export$cb32a82a68eac3ea = /*#__PURE__*/ function(ConfluenceLegacyPageStatusInput) {
    ConfluenceLegacyPageStatusInput["Current"] = "CURRENT";
    ConfluenceLegacyPageStatusInput["Draft"] = "DRAFT";
    return ConfluenceLegacyPageStatusInput;
}({});
let $5b8397cef71e8614$export$88e74ffbe5a7ddc7 = /*#__PURE__*/ function(ConfluenceLegacyPageUpdateTrigger) {
    ConfluenceLegacyPageUpdateTrigger["CreatePage"] = "CREATE_PAGE";
    ConfluenceLegacyPageUpdateTrigger["DiscardChanges"] = "DISCARD_CHANGES";
    ConfluenceLegacyPageUpdateTrigger["EditPage"] = "EDIT_PAGE";
    ConfluenceLegacyPageUpdateTrigger["LinkRefactoring"] = "LINK_REFACTORING";
    ConfluenceLegacyPageUpdateTrigger["MigratePageCollab"] = "MIGRATE_PAGE_COLLAB";
    ConfluenceLegacyPageUpdateTrigger["OwnerChange"] = "OWNER_CHANGE";
    ConfluenceLegacyPageUpdateTrigger["PageRename"] = "PAGE_RENAME";
    ConfluenceLegacyPageUpdateTrigger["PersonalTasklist"] = "PERSONAL_TASKLIST";
    ConfluenceLegacyPageUpdateTrigger["Revert"] = "REVERT";
    ConfluenceLegacyPageUpdateTrigger["SpaceCreate"] = "SPACE_CREATE";
    ConfluenceLegacyPageUpdateTrigger["Unknown"] = "UNKNOWN";
    ConfluenceLegacyPageUpdateTrigger["ViewPage"] = "VIEW_PAGE";
    return ConfluenceLegacyPageUpdateTrigger;
}({});
let $5b8397cef71e8614$export$e9c8dbdf7b225312 = /*#__PURE__*/ function(ConfluenceLegacyPagesDisplayPersistenceOption) {
    ConfluenceLegacyPagesDisplayPersistenceOption["Cards"] = "CARDS";
    ConfluenceLegacyPagesDisplayPersistenceOption["CompactList"] = "COMPACT_LIST";
    ConfluenceLegacyPagesDisplayPersistenceOption["List"] = "LIST";
    return ConfluenceLegacyPagesDisplayPersistenceOption;
}({});
let $5b8397cef71e8614$export$aaf6c229cce2f3b3 = /*#__PURE__*/ function(ConfluenceLegacyPagesSortField) {
    ConfluenceLegacyPagesSortField["LastModifiedDate"] = "LAST_MODIFIED_DATE";
    ConfluenceLegacyPagesSortField["Relevant"] = "RELEVANT";
    ConfluenceLegacyPagesSortField["Title"] = "TITLE";
    return ConfluenceLegacyPagesSortField;
}({});
let $5b8397cef71e8614$export$318b7a7639914e93 = /*#__PURE__*/ function(ConfluenceLegacyPagesSortOrder) {
    ConfluenceLegacyPagesSortOrder["Asc"] = "ASC";
    ConfluenceLegacyPagesSortOrder["Desc"] = "DESC";
    return ConfluenceLegacyPagesSortOrder;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$c7738cb0d3dab26f = /*#__PURE__*/ function(ConfluenceLegacyPathType) {
    ConfluenceLegacyPathType["Absolute"] = "ABSOLUTE";
    ConfluenceLegacyPathType["Relative"] = "RELATIVE";
    ConfluenceLegacyPathType["RelativeNoContext"] = "RELATIVE_NO_CONTEXT";
    return ConfluenceLegacyPathType;
}({});
let $5b8397cef71e8614$export$45c5982866ef3f86 = /*#__PURE__*/ function(ConfluenceLegacyPaywallStatus) {
    ConfluenceLegacyPaywallStatus["Active"] = "ACTIVE";
    ConfluenceLegacyPaywallStatus["Deactivated"] = "DEACTIVATED";
    ConfluenceLegacyPaywallStatus["Unset"] = "UNSET";
    return ConfluenceLegacyPaywallStatus;
}({});
let $5b8397cef71e8614$export$bdd86c404514bf5e = /*#__PURE__*/ function(ConfluenceLegacyPermissionDisplayType) {
    ConfluenceLegacyPermissionDisplayType["Anonymous"] = "ANONYMOUS";
    ConfluenceLegacyPermissionDisplayType["Group"] = "GROUP";
    ConfluenceLegacyPermissionDisplayType["GuestUser"] = "GUEST_USER";
    ConfluenceLegacyPermissionDisplayType["LicensedUser"] = "LICENSED_USER";
    return ConfluenceLegacyPermissionDisplayType;
}({});
let $5b8397cef71e8614$export$5e661380a2aa4206 = /*#__PURE__*/ function(ConfluenceLegacyPlatform) {
    ConfluenceLegacyPlatform["Android"] = "ANDROID";
    ConfluenceLegacyPlatform["Ios"] = "IOS";
    ConfluenceLegacyPlatform["Web"] = "WEB";
    return ConfluenceLegacyPlatform;
}({});
let $5b8397cef71e8614$export$b8313f5a464cf0ed = /*#__PURE__*/ function(ConfluenceLegacyPremiumToolsDropdownStatus) {
    ConfluenceLegacyPremiumToolsDropdownStatus["Collapsed"] = "COLLAPSED";
    ConfluenceLegacyPremiumToolsDropdownStatus["Expanded"] = "EXPANDED";
    ConfluenceLegacyPremiumToolsDropdownStatus["Unset"] = "UNSET";
    return ConfluenceLegacyPremiumToolsDropdownStatus;
}({});
let $5b8397cef71e8614$export$44790dd8acc73dd6 = /*#__PURE__*/ function(ConfluenceLegacyPrincipalType) {
    ConfluenceLegacyPrincipalType["Group"] = "GROUP";
    ConfluenceLegacyPrincipalType["User"] = "USER";
    return ConfluenceLegacyPrincipalType;
}({});
let $5b8397cef71e8614$export$132f1b98364f7846 = /*#__PURE__*/ function(ConfluenceLegacyProduct) {
    ConfluenceLegacyProduct["Confluence"] = "CONFLUENCE";
    return ConfluenceLegacyProduct;
}({});
let $5b8397cef71e8614$export$baf22e4384c384d6 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkAdminAction) {
    ConfluenceLegacyPublicLinkAdminAction["Block"] = "BLOCK";
    ConfluenceLegacyPublicLinkAdminAction["Off"] = "OFF";
    ConfluenceLegacyPublicLinkAdminAction["On"] = "ON";
    ConfluenceLegacyPublicLinkAdminAction["Unblock"] = "UNBLOCK";
    return ConfluenceLegacyPublicLinkAdminAction;
}({});
let $5b8397cef71e8614$export$6c27a44327a1685c = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkDefaultSpaceStatus) {
    ConfluenceLegacyPublicLinkDefaultSpaceStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkDefaultSpaceStatus["On"] = "ON";
    return ConfluenceLegacyPublicLinkDefaultSpaceStatus;
}({});
let $5b8397cef71e8614$export$882b105854002ad0 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPageStatus) {
    ConfluenceLegacyPublicLinkPageStatus["BlockedByClassificationLevel"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    ConfluenceLegacyPublicLinkPageStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkPageStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkPageStatus["BlockedBySpace"] = "BLOCKED_BY_SPACE";
    ConfluenceLegacyPublicLinkPageStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkPageStatus["On"] = "ON";
    ConfluenceLegacyPublicLinkPageStatus["SiteBlocked"] = "SITE_BLOCKED";
    ConfluenceLegacyPublicLinkPageStatus["SiteDisabled"] = "SITE_DISABLED";
    ConfluenceLegacyPublicLinkPageStatus["SpaceBlocked"] = "SPACE_BLOCKED";
    ConfluenceLegacyPublicLinkPageStatus["SpaceDisabled"] = "SPACE_DISABLED";
    return ConfluenceLegacyPublicLinkPageStatus;
}({});
let $5b8397cef71e8614$export$e1e4b830a0825f2b = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPageStatusFilter) {
    ConfluenceLegacyPublicLinkPageStatusFilter["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkPageStatusFilter["BlockedBySpace"] = "BLOCKED_BY_SPACE";
    ConfluenceLegacyPublicLinkPageStatusFilter["Off"] = "OFF";
    ConfluenceLegacyPublicLinkPageStatusFilter["On"] = "ON";
    return ConfluenceLegacyPublicLinkPageStatusFilter;
}({});
let $5b8397cef71e8614$export$9acef11a8ce6e3c6 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPagesByCriteriaOrder) {
    ConfluenceLegacyPublicLinkPagesByCriteriaOrder["DateEnabled"] = "DATE_ENABLED";
    ConfluenceLegacyPublicLinkPagesByCriteriaOrder["Status"] = "STATUS";
    ConfluenceLegacyPublicLinkPagesByCriteriaOrder["Title"] = "TITLE";
    return ConfluenceLegacyPublicLinkPagesByCriteriaOrder;
}({});
let $5b8397cef71e8614$export$892bc471a65769c0 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPermissionsObjectType) {
    ConfluenceLegacyPublicLinkPermissionsObjectType["Content"] = "CONTENT";
    return ConfluenceLegacyPublicLinkPermissionsObjectType;
}({});
let $5b8397cef71e8614$export$353b2d93c5c6cf5c = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkPermissionsType) {
    ConfluenceLegacyPublicLinkPermissionsType["Edit"] = "EDIT";
    return ConfluenceLegacyPublicLinkPermissionsType;
}({});
let $5b8397cef71e8614$export$1363899e44b2229b = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkSiteStatus) {
    ConfluenceLegacyPublicLinkSiteStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkSiteStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkSiteStatus["On"] = "ON";
    return ConfluenceLegacyPublicLinkSiteStatus;
}({});
let $5b8397cef71e8614$export$6344a7355e3086d1 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkSpaceStatus) {
    ConfluenceLegacyPublicLinkSpaceStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkSpaceStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkSpaceStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkSpaceStatus["On"] = "ON";
    return ConfluenceLegacyPublicLinkSpaceStatus;
}({});
let $5b8397cef71e8614$export$24ea1c3cc5ac9e7d = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkSpacesByCriteriaOrder) {
    ConfluenceLegacyPublicLinkSpacesByCriteriaOrder["ActiveLinks"] = "ACTIVE_LINKS";
    ConfluenceLegacyPublicLinkSpacesByCriteriaOrder["Name"] = "NAME";
    ConfluenceLegacyPublicLinkSpacesByCriteriaOrder["Status"] = "STATUS";
    return ConfluenceLegacyPublicLinkSpacesByCriteriaOrder;
}({});
let $5b8397cef71e8614$export$fde6c5e19eaa1054 = /*#__PURE__*/ function(ConfluenceLegacyPublicLinkStatus) {
    ConfluenceLegacyPublicLinkStatus["BlockedByClassificationLevel"] = "BLOCKED_BY_CLASSIFICATION_LEVEL";
    ConfluenceLegacyPublicLinkStatus["BlockedByOrg"] = "BLOCKED_BY_ORG";
    ConfluenceLegacyPublicLinkStatus["BlockedByProduct"] = "BLOCKED_BY_PRODUCT";
    ConfluenceLegacyPublicLinkStatus["BlockedBySpace"] = "BLOCKED_BY_SPACE";
    ConfluenceLegacyPublicLinkStatus["Off"] = "OFF";
    ConfluenceLegacyPublicLinkStatus["On"] = "ON";
    ConfluenceLegacyPublicLinkStatus["SiteBlocked"] = "SITE_BLOCKED";
    ConfluenceLegacyPublicLinkStatus["SiteDisabled"] = "SITE_DISABLED";
    ConfluenceLegacyPublicLinkStatus["SpaceBlocked"] = "SPACE_BLOCKED";
    ConfluenceLegacyPublicLinkStatus["SpaceDisabled"] = "SPACE_DISABLED";
    return ConfluenceLegacyPublicLinkStatus;
}({});
let $5b8397cef71e8614$export$9b956743b565355b = /*#__PURE__*/ function(ConfluenceLegacyPublicLinksByCriteriaOrder) {
    ConfluenceLegacyPublicLinksByCriteriaOrder["DateEnabled"] = "DATE_ENABLED";
    ConfluenceLegacyPublicLinksByCriteriaOrder["Status"] = "STATUS";
    ConfluenceLegacyPublicLinksByCriteriaOrder["Title"] = "TITLE";
    return ConfluenceLegacyPublicLinksByCriteriaOrder;
}({});
let $5b8397cef71e8614$export$9e74ac381de41243 = /*#__PURE__*/ function(ConfluenceLegacyPushNotificationGroupInputType) {
    ConfluenceLegacyPushNotificationGroupInputType["None"] = "NONE";
    ConfluenceLegacyPushNotificationGroupInputType["Quiet"] = "QUIET";
    ConfluenceLegacyPushNotificationGroupInputType["Standard"] = "STANDARD";
    return ConfluenceLegacyPushNotificationGroupInputType;
}({});
let $5b8397cef71e8614$export$4b9d765e6088e3c4 = /*#__PURE__*/ function(ConfluenceLegacyPushNotificationSettingGroup) {
    ConfluenceLegacyPushNotificationSettingGroup["Custom"] = "CUSTOM";
    ConfluenceLegacyPushNotificationSettingGroup["None"] = "NONE";
    ConfluenceLegacyPushNotificationSettingGroup["Quiet"] = "QUIET";
    ConfluenceLegacyPushNotificationSettingGroup["Standard"] = "STANDARD";
    return ConfluenceLegacyPushNotificationSettingGroup;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$4490245889e26dee = /*#__PURE__*/ function(ConfluenceLegacyReactionContentType) {
    ConfluenceLegacyReactionContentType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacyReactionContentType["Comment"] = "COMMENT";
    ConfluenceLegacyReactionContentType["Page"] = "PAGE";
    return ConfluenceLegacyReactionContentType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$74f0035aff7ea1c0 = /*#__PURE__*/ function(ConfluenceLegacyRecentFilter) {
    ConfluenceLegacyRecentFilter["All"] = "ALL";
    ConfluenceLegacyRecentFilter["Created"] = "CREATED";
    ConfluenceLegacyRecentFilter["WorkedOn"] = "WORKED_ON";
    return ConfluenceLegacyRecentFilter;
}({});
let $5b8397cef71e8614$export$6875c90eb8212aba = /*#__PURE__*/ function(ConfluenceLegacyRecommendedPagesSpaceBehavior) {
    ConfluenceLegacyRecommendedPagesSpaceBehavior["Hidden"] = "HIDDEN";
    ConfluenceLegacyRecommendedPagesSpaceBehavior["Shown"] = "SHOWN";
    return ConfluenceLegacyRecommendedPagesSpaceBehavior;
}({});
let $5b8397cef71e8614$export$c3e45d6c8873afa5 = /*#__PURE__*/ function(ConfluenceLegacyRelationSourceType) {
    ConfluenceLegacyRelationSourceType["User"] = "user";
    return ConfluenceLegacyRelationSourceType;
}({});
let $5b8397cef71e8614$export$9cbd9eca53d8233e = /*#__PURE__*/ function(ConfluenceLegacyRelationTargetType) {
    ConfluenceLegacyRelationTargetType["Content"] = "content";
    ConfluenceLegacyRelationTargetType["Space"] = "space";
    return ConfluenceLegacyRelationTargetType;
}({});
let $5b8397cef71e8614$export$b7e6e1a18c840b8f = /*#__PURE__*/ function(ConfluenceLegacyRelationType) {
    ConfluenceLegacyRelationType["Collaborator"] = "collaborator";
    ConfluenceLegacyRelationType["Favourite"] = "favourite";
    ConfluenceLegacyRelationType["Touched"] = "touched";
    return ConfluenceLegacyRelationType;
}({});
let $5b8397cef71e8614$export$367b84a88c23075f = /*#__PURE__*/ function(ConfluenceLegacyRelevantUserFilter) {
    ConfluenceLegacyRelevantUserFilter["Collaborators"] = "collaborators";
    return ConfluenceLegacyRelevantUserFilter;
}({});
let $5b8397cef71e8614$export$8b22f13531a8344e = /*#__PURE__*/ function(ConfluenceLegacyRelevantUsersSortOrder) {
    ConfluenceLegacyRelevantUsersSortOrder["Asc"] = "asc";
    ConfluenceLegacyRelevantUsersSortOrder["Desc"] = "desc";
    return ConfluenceLegacyRelevantUsersSortOrder;
}({});
let $5b8397cef71e8614$export$376441298d996eee = /*#__PURE__*/ function(ConfluenceLegacyResponseType) {
    ConfluenceLegacyResponseType["BulletListAdf"] = "BULLET_LIST_ADF";
    ConfluenceLegacyResponseType["BulletListMarkdown"] = "BULLET_LIST_MARKDOWN";
    ConfluenceLegacyResponseType["ParagraphPlaintext"] = "PARAGRAPH_PLAINTEXT";
    return ConfluenceLegacyResponseType;
}({});
let $5b8397cef71e8614$export$7f316768f979019e = /*#__PURE__*/ function(ConfluenceLegacyReverseTrialCohort) {
    ConfluenceLegacyReverseTrialCohort["Control"] = "CONTROL";
    ConfluenceLegacyReverseTrialCohort["Enrolled"] = "ENROLLED";
    ConfluenceLegacyReverseTrialCohort["NotEnrolled"] = "NOT_ENROLLED";
    ConfluenceLegacyReverseTrialCohort["Unassigned"] = "UNASSIGNED";
    ConfluenceLegacyReverseTrialCohort["Unknown"] = "UNKNOWN";
    ConfluenceLegacyReverseTrialCohort["Variant"] = "VARIANT";
    return ConfluenceLegacyReverseTrialCohort;
}({});
let $5b8397cef71e8614$export$3bf4e8049523f596 = /*#__PURE__*/ function(ConfluenceLegacyRevertToLegacyEditorResult) {
    ConfluenceLegacyRevertToLegacyEditorResult["NotReverted"] = "NOT_REVERTED";
    ConfluenceLegacyRevertToLegacyEditorResult["Reverted"] = "REVERTED";
    return ConfluenceLegacyRevertToLegacyEditorResult;
}({});
let $5b8397cef71e8614$export$ef682e8bdb6dbe2e = /*#__PURE__*/ function(ConfluenceLegacyRoleAssignmentPrincipalType) {
    ConfluenceLegacyRoleAssignmentPrincipalType["AccessClass"] = "ACCESS_CLASS";
    ConfluenceLegacyRoleAssignmentPrincipalType["Group"] = "GROUP";
    ConfluenceLegacyRoleAssignmentPrincipalType["Team"] = "TEAM";
    ConfluenceLegacyRoleAssignmentPrincipalType["User"] = "USER";
    return ConfluenceLegacyRoleAssignmentPrincipalType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$e1172c4cec191be2 = /*#__PURE__*/ function(ConfluenceLegacySearchesByTermColumns) {
    ConfluenceLegacySearchesByTermColumns["PageViewedPercentage"] = "pageViewedPercentage";
    ConfluenceLegacySearchesByTermColumns["SearchClickCount"] = "searchClickCount";
    ConfluenceLegacySearchesByTermColumns["SearchSessionCount"] = "searchSessionCount";
    ConfluenceLegacySearchesByTermColumns["SearchTerm"] = "searchTerm";
    ConfluenceLegacySearchesByTermColumns["Total"] = "total";
    ConfluenceLegacySearchesByTermColumns["UniqueUsers"] = "uniqueUsers";
    return ConfluenceLegacySearchesByTermColumns;
}({});
let $5b8397cef71e8614$export$e7d6f21793433a06 = /*#__PURE__*/ function(ConfluenceLegacySearchesByTermPeriod) {
    ConfluenceLegacySearchesByTermPeriod["Day"] = "day";
    ConfluenceLegacySearchesByTermPeriod["Month"] = "month";
    ConfluenceLegacySearchesByTermPeriod["Week"] = "week";
    return ConfluenceLegacySearchesByTermPeriod;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$a199f440cd936cc = /*#__PURE__*/ function(ConfluenceLegacyShareType) {
    ConfluenceLegacyShareType["InviteToEdit"] = "INVITE_TO_EDIT";
    ConfluenceLegacyShareType["SharePage"] = "SHARE_PAGE";
    return ConfluenceLegacyShareType;
}({});
let $5b8397cef71e8614$export$5f5a76dd02b1e8f0 = /*#__PURE__*/ function(ConfluenceLegacySitePermissionOperationType) {
    ConfluenceLegacySitePermissionOperationType["AdministerConfluence"] = "ADMINISTER_CONFLUENCE";
    ConfluenceLegacySitePermissionOperationType["AdministerSystem"] = "ADMINISTER_SYSTEM";
    ConfluenceLegacySitePermissionOperationType["CreateProfileattachment"] = "CREATE_PROFILEATTACHMENT";
    ConfluenceLegacySitePermissionOperationType["CreateSpace"] = "CREATE_SPACE";
    ConfluenceLegacySitePermissionOperationType["ExternalCollaborator"] = "EXTERNAL_COLLABORATOR";
    ConfluenceLegacySitePermissionOperationType["LimitedUseConfluence"] = "LIMITED_USE_CONFLUENCE";
    ConfluenceLegacySitePermissionOperationType["ReadUserprofile"] = "READ_USERPROFILE";
    ConfluenceLegacySitePermissionOperationType["UpdateUserstatus"] = "UPDATE_USERSTATUS";
    ConfluenceLegacySitePermissionOperationType["UseConfluence"] = "USE_CONFLUENCE";
    ConfluenceLegacySitePermissionOperationType["UsePersonalspace"] = "USE_PERSONALSPACE";
    return ConfluenceLegacySitePermissionOperationType;
}({});
let $5b8397cef71e8614$export$c0dc9e525f1888d7 = /*#__PURE__*/ function(ConfluenceLegacySitePermissionType) {
    ConfluenceLegacySitePermissionType["Anonymous"] = "ANONYMOUS";
    ConfluenceLegacySitePermissionType["App"] = "APP";
    ConfluenceLegacySitePermissionType["External"] = "EXTERNAL";
    ConfluenceLegacySitePermissionType["Internal"] = "INTERNAL";
    ConfluenceLegacySitePermissionType["Jsd"] = "JSD";
    return ConfluenceLegacySitePermissionType;
}({});
let $5b8397cef71e8614$export$cacd2625b0eb5c10 = /*#__PURE__*/ function(ConfluenceLegacySitePermissionTypeFilter) {
    ConfluenceLegacySitePermissionTypeFilter["All"] = "ALL";
    ConfluenceLegacySitePermissionTypeFilter["Externalcollaborator"] = "EXTERNALCOLLABORATOR";
    ConfluenceLegacySitePermissionTypeFilter["None"] = "NONE";
    return ConfluenceLegacySitePermissionTypeFilter;
}({}); /** Represents a smart-link on a page */ 
let $5b8397cef71e8614$export$3427a291ccf5b35f = /*#__PURE__*/ function(ConfluenceLegacySpaceAssignmentType) {
    ConfluenceLegacySpaceAssignmentType["Assigned"] = "ASSIGNED";
    ConfluenceLegacySpaceAssignmentType["Unassigned"] = "UNASSIGNED";
    return ConfluenceLegacySpaceAssignmentType;
}({});
let $5b8397cef71e8614$export$66c6ff50e2fe5ded = /*#__PURE__*/ function(ConfluenceLegacySpacePermissionType) {
    ConfluenceLegacySpacePermissionType["AdministerSpace"] = "ADMINISTER_SPACE";
    ConfluenceLegacySpacePermissionType["ArchivePage"] = "ARCHIVE_PAGE";
    ConfluenceLegacySpacePermissionType["Comment"] = "COMMENT";
    ConfluenceLegacySpacePermissionType["CreateAttachment"] = "CREATE_ATTACHMENT";
    ConfluenceLegacySpacePermissionType["CreateEditPage"] = "CREATE_EDIT_PAGE";
    ConfluenceLegacySpacePermissionType["EditBlog"] = "EDIT_BLOG";
    ConfluenceLegacySpacePermissionType["ExportPage"] = "EXPORT_PAGE";
    ConfluenceLegacySpacePermissionType["ExportSpace"] = "EXPORT_SPACE";
    ConfluenceLegacySpacePermissionType["RemoveAttachment"] = "REMOVE_ATTACHMENT";
    ConfluenceLegacySpacePermissionType["RemoveBlog"] = "REMOVE_BLOG";
    ConfluenceLegacySpacePermissionType["RemoveComment"] = "REMOVE_COMMENT";
    ConfluenceLegacySpacePermissionType["RemoveMail"] = "REMOVE_MAIL";
    ConfluenceLegacySpacePermissionType["RemoveOwnContent"] = "REMOVE_OWN_CONTENT";
    ConfluenceLegacySpacePermissionType["RemovePage"] = "REMOVE_PAGE";
    ConfluenceLegacySpacePermissionType["SetPagePermissions"] = "SET_PAGE_PERMISSIONS";
    ConfluenceLegacySpacePermissionType["ViewSpace"] = "VIEW_SPACE";
    return ConfluenceLegacySpacePermissionType;
}({});
let $5b8397cef71e8614$export$f324862e9abce9a4 = /*#__PURE__*/ function(ConfluenceLegacySpaceRoleType) {
    ConfluenceLegacySpaceRoleType["Custom"] = "CUSTOM";
    ConfluenceLegacySpaceRoleType["System"] = "SYSTEM";
    return ConfluenceLegacySpaceRoleType;
}({});
let $5b8397cef71e8614$export$a816519a4452de22 = /*#__PURE__*/ function(ConfluenceLegacySpaceSidebarLinkType) {
    ConfluenceLegacySpaceSidebarLinkType["ExternalLink"] = "EXTERNAL_LINK";
    ConfluenceLegacySpaceSidebarLinkType["Forge"] = "FORGE";
    ConfluenceLegacySpaceSidebarLinkType["PinnedAttachment"] = "PINNED_ATTACHMENT";
    ConfluenceLegacySpaceSidebarLinkType["PinnedBlogPost"] = "PINNED_BLOG_POST";
    ConfluenceLegacySpaceSidebarLinkType["PinnedPage"] = "PINNED_PAGE";
    ConfluenceLegacySpaceSidebarLinkType["PinnedSpace"] = "PINNED_SPACE";
    ConfluenceLegacySpaceSidebarLinkType["PinnedUserInfo"] = "PINNED_USER_INFO";
    ConfluenceLegacySpaceSidebarLinkType["WebItem"] = "WEB_ITEM";
    return ConfluenceLegacySpaceSidebarLinkType;
}({});
let $5b8397cef71e8614$export$4f08231b454021a7 = /*#__PURE__*/ function(ConfluenceLegacySpaceViewsPersistenceOption) {
    ConfluenceLegacySpaceViewsPersistenceOption["Popularity"] = "POPULARITY";
    ConfluenceLegacySpaceViewsPersistenceOption["RecentlyModified"] = "RECENTLY_MODIFIED";
    ConfluenceLegacySpaceViewsPersistenceOption["RecentlyViewed"] = "RECENTLY_VIEWED";
    ConfluenceLegacySpaceViewsPersistenceOption["TitleAz"] = "TITLE_AZ";
    ConfluenceLegacySpaceViewsPersistenceOption["Tree"] = "TREE";
    return ConfluenceLegacySpaceViewsPersistenceOption;
}({});
let $5b8397cef71e8614$export$b1fc899dd9dab99c = /*#__PURE__*/ function(ConfluenceLegacyStalePageStatus) {
    ConfluenceLegacyStalePageStatus["Archived"] = "ARCHIVED";
    ConfluenceLegacyStalePageStatus["Current"] = "CURRENT";
    ConfluenceLegacyStalePageStatus["Draft"] = "DRAFT";
    return ConfluenceLegacyStalePageStatus;
}({});
let $5b8397cef71e8614$export$52d6eaeb13b767d7 = /*#__PURE__*/ function(ConfluenceLegacyStalePagesSortingType) {
    ConfluenceLegacyStalePagesSortingType["Asc"] = "ASC";
    ConfluenceLegacyStalePagesSortingType["Desc"] = "DESC";
    return ConfluenceLegacyStalePagesSortingType;
}({});
let $5b8397cef71e8614$export$2ef0672a533512e5 = /*#__PURE__*/ function(ConfluenceLegacySummaryType) {
    ConfluenceLegacySummaryType["Blogpost"] = "BLOGPOST";
    ConfluenceLegacySummaryType["Page"] = "PAGE";
    return ConfluenceLegacySummaryType;
}({});
let $5b8397cef71e8614$export$ac9323de0f6ac2f9 = /*#__PURE__*/ function(ConfluenceLegacySystemSpaceHomepageTemplate) {
    ConfluenceLegacySystemSpaceHomepageTemplate["Eap"] = "EAP";
    ConfluenceLegacySystemSpaceHomepageTemplate["Minimal"] = "MINIMAL";
    ConfluenceLegacySystemSpaceHomepageTemplate["Visual"] = "VISUAL";
    return ConfluenceLegacySystemSpaceHomepageTemplate;
}({});
let $5b8397cef71e8614$export$d926f0433bfa5cfe = /*#__PURE__*/ function(ConfluenceLegacyTaskStatus) {
    ConfluenceLegacyTaskStatus["Checked"] = "CHECKED";
    ConfluenceLegacyTaskStatus["Unchecked"] = "UNCHECKED";
    return ConfluenceLegacyTaskStatus;
}({});
let $5b8397cef71e8614$export$e59d52222a05db4a = /*#__PURE__*/ function(ConfluenceLegacyTeamCalendarDayOfWeek) {
    ConfluenceLegacyTeamCalendarDayOfWeek["Friday"] = "FRIDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Monday"] = "MONDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Saturday"] = "SATURDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Sunday"] = "SUNDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Thursday"] = "THURSDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Tuesday"] = "TUESDAY";
    ConfluenceLegacyTeamCalendarDayOfWeek["Wednesday"] = "WEDNESDAY";
    return ConfluenceLegacyTeamCalendarDayOfWeek;
}({});
let $5b8397cef71e8614$export$6fa4f21ea723a4cf = /*#__PURE__*/ function(ConfluenceLegacyTemplateContentAppearance) {
    ConfluenceLegacyTemplateContentAppearance["Default"] = "DEFAULT";
    ConfluenceLegacyTemplateContentAppearance["FullWidth"] = "FULL_WIDTH";
    return ConfluenceLegacyTemplateContentAppearance;
}({}); /** Provides template information. Useful for in - editor template gallery and more in the future. */  /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$a883f3365032d0b5 = /*#__PURE__*/ function(ConfluenceMutationContentStatus) {
    ConfluenceMutationContentStatus["Current"] = "CURRENT";
    ConfluenceMutationContentStatus["Draft"] = "DRAFT";
    return ConfluenceMutationContentStatus;
}({});
let $5b8397cef71e8614$export$629c17cb184cb2f = /*#__PURE__*/ function(ConfluenceOperationName) {
    ConfluenceOperationName["Administer"] = "ADMINISTER";
    ConfluenceOperationName["Archive"] = "ARCHIVE";
    ConfluenceOperationName["Copy"] = "COPY";
    ConfluenceOperationName["Create"] = "CREATE";
    ConfluenceOperationName["CreateSpace"] = "CREATE_SPACE";
    ConfluenceOperationName["Delete"] = "DELETE";
    ConfluenceOperationName["Export"] = "EXPORT";
    ConfluenceOperationName["Move"] = "MOVE";
    ConfluenceOperationName["Purge"] = "PURGE";
    ConfluenceOperationName["PurgeVersion"] = "PURGE_VERSION";
    ConfluenceOperationName["Read"] = "READ";
    ConfluenceOperationName["Restore"] = "RESTORE";
    ConfluenceOperationName["RestrictContent"] = "RESTRICT_CONTENT";
    ConfluenceOperationName["Update"] = "UPDATE";
    ConfluenceOperationName["Use"] = "USE";
    return ConfluenceOperationName;
}({});
let $5b8397cef71e8614$export$406af9bbda9174f7 = /*#__PURE__*/ function(ConfluenceOperationTarget) {
    ConfluenceOperationTarget["Application"] = "APPLICATION";
    ConfluenceOperationTarget["Attachment"] = "ATTACHMENT";
    ConfluenceOperationTarget["BlogPost"] = "BLOG_POST";
    ConfluenceOperationTarget["Comment"] = "COMMENT";
    ConfluenceOperationTarget["Page"] = "PAGE";
    ConfluenceOperationTarget["Space"] = "SPACE";
    ConfluenceOperationTarget["UserProfile"] = "USER_PROFILE";
    return ConfluenceOperationTarget;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:page:confluence__
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$b9563c27e132ecf3 = /*#__PURE__*/ function(ConfluencePageStatus) {
    ConfluencePageStatus["Archived"] = "ARCHIVED";
    ConfluencePageStatus["Current"] = "CURRENT";
    ConfluencePageStatus["Deleted"] = "DELETED";
    ConfluencePageStatus["Draft"] = "DRAFT";
    ConfluencePageStatus["Historical"] = "HISTORICAL";
    ConfluencePageStatus["Trashed"] = "TRASHED";
    return ConfluencePageStatus;
}({});
let $5b8397cef71e8614$export$c5ec0cc4d455d1c8 = /*#__PURE__*/ function(ConfluencePageSubType) {
    ConfluencePageSubType["Live"] = "LIVE";
    return ConfluencePageSubType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:content.metadata:confluence__
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$d939b611ae8d039c = /*#__PURE__*/ function(ConfluenceSpaceSettingEditorVersion) {
    ConfluenceSpaceSettingEditorVersion["V1"] = "V1";
    ConfluenceSpaceSettingEditorVersion["V2"] = "V2";
    return ConfluenceSpaceSettingEditorVersion;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:space.setting:confluence__
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$2607d60870895ed3 = /*#__PURE__*/ function(ConfluenceSpaceStatus) {
    ConfluenceSpaceStatus["Archived"] = "ARCHIVED";
    ConfluenceSpaceStatus["Current"] = "CURRENT";
    return ConfluenceSpaceStatus;
}({});
let $5b8397cef71e8614$export$2fabe69f8125d5a7 = /*#__PURE__*/ function(ConfluenceSpaceType) {
    ConfluenceSpaceType["Global"] = "GLOBAL";
    ConfluenceSpaceType["Personal"] = "PERSONAL";
    return ConfluenceSpaceType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:user:confluence__
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$5053ac532e22e9b7 = /*#__PURE__*/ function(ConfluenceUserType) {
    ConfluenceUserType["Anonymous"] = "ANONYMOUS";
    ConfluenceUserType["Known"] = "KNOWN";
    return ConfluenceUserType;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __read:space:confluence__
 * * __confluence:atlassian-external__
 */ 
let $5b8397cef71e8614$export$62c53e2e83119144 = /*#__PURE__*/ function(ContentPlatformBooleanOperators) {
    ContentPlatformBooleanOperators["And"] = "AND";
    ContentPlatformBooleanOperators["Or"] = "OR";
    return ContentPlatformBooleanOperators;
}({});
let $5b8397cef71e8614$export$70152384a4eb0e06 = /*#__PURE__*/ function(ContentPlatformFieldNames) {
    ContentPlatformFieldNames["Description"] = "DESCRIPTION";
    ContentPlatformFieldNames["Title"] = "TITLE";
    return ContentPlatformFieldNames;
}({});
let $5b8397cef71e8614$export$c05e625f37f1df6a = /*#__PURE__*/ function(ContentPlatformOperators) {
    ContentPlatformOperators["All"] = "ALL";
    ContentPlatformOperators["Any"] = "ANY";
    return ContentPlatformOperators;
}({});
let $5b8397cef71e8614$export$e4bac19bb31c7d1 = /*#__PURE__*/ function(ContentPlatformSearchTypes) {
    ContentPlatformSearchTypes["Contains"] = "CONTAINS";
    ContentPlatformSearchTypes["ExactMatch"] = "EXACT_MATCH";
    return ContentPlatformSearchTypes;
}({}); /** Response from creating a deployment */  /** Response from creating an app deployment url */  /** Response from creating an app environment */  /** Response from creating an app */  /** A response to a tunnel creation request */  /**
 * Establish tunnels for a specific environment of an app.
 *
 * This will redirect all function calls to the provided faas url. This URL must implement the same
 * invocation contract that is used elsewhere in Xen.
 *
 * This will also be used to redirect Custom UI product rendering to the custom ui urls. We separate
 * them by extension key.
 */ 
let $5b8397cef71e8614$export$2f3f99f16bab5cdf = /*#__PURE__*/ function(CustomEntityAttributeType) {
    CustomEntityAttributeType["Any"] = "any";
    CustomEntityAttributeType["Boolean"] = "boolean";
    CustomEntityAttributeType["Float"] = "float";
    CustomEntityAttributeType["Integer"] = "integer";
    CustomEntityAttributeType["String"] = "string";
    return CustomEntityAttributeType;
}({}); /** Definition of an existing custom entity when queried */  /** Definition of an existing custom entity index when queried */ 
let $5b8397cef71e8614$export$54f78149dae8a06c = /*#__PURE__*/ function(CustomEntityIndexStatus) {
    CustomEntityIndexStatus["Active"] = "ACTIVE";
    CustomEntityIndexStatus["Creating"] = "CREATING";
    CustomEntityIndexStatus["Inactive"] = "INACTIVE";
    CustomEntityIndexStatus["Pending"] = "PENDING";
    return CustomEntityIndexStatus;
}({}); /** Generic implementation of MutationResponse for responses that don't need any extra data */ 
let $5b8397cef71e8614$export$aecc53098eb55beb = /*#__PURE__*/ function(CustomEntityStatus) {
    CustomEntityStatus["Active"] = "ACTIVE";
    CustomEntityStatus["Inactive"] = "INACTIVE";
    return CustomEntityStatus;
}({}); /**
 * The customer service organization attribute
 * DEPRECATED: use CustomerServiceCustomDetail instead.
 */ 
let $5b8397cef71e8614$export$17ade050935780b6 = /*#__PURE__*/ function(CustomerServiceAttributeTypeName) {
    CustomerServiceAttributeTypeName["Boolean"] = "BOOLEAN";
    CustomerServiceAttributeTypeName["Date"] = "DATE";
    CustomerServiceAttributeTypeName["Email"] = "EMAIL";
    CustomerServiceAttributeTypeName["Multiselect"] = "MULTISELECT";
    CustomerServiceAttributeTypeName["Number"] = "NUMBER";
    CustomerServiceAttributeTypeName["Phone"] = "PHONE";
    CustomerServiceAttributeTypeName["Select"] = "SELECT";
    CustomerServiceAttributeTypeName["Text"] = "TEXT";
    CustomerServiceAttributeTypeName["Url"] = "URL";
    CustomerServiceAttributeTypeName["User"] = "USER";
    return CustomerServiceAttributeTypeName;
}({}); /** DEPRECATED: use CustomerServiceCustomDetailUpdateInput instead. */  /** DEPRECATED: use CustomerServiceCustomDetailUpdatePayload instead. */  /** DEPRECATED: use CustomerServiceCustomDetailUpdateTypeInput instead. */  /**
 * The customer service organization attribute with a value
 * DEPRECATED: use CustomerServiceCustomDetailValue instead.
 */ 
let $5b8397cef71e8614$export$98afe1d41a26dd3b = /*#__PURE__*/ function(CustomerServiceContextType) {
    CustomerServiceContextType["Default"] = "DEFAULT";
    CustomerServiceContextType["Issue"] = "ISSUE";
    return CustomerServiceContextType;
}({}); /** The customer service entity custom detail */  /** Config metadata for a custom detail */ 
let $5b8397cef71e8614$export$65378626fab83b8 = /*#__PURE__*/ function(CustomerServiceCustomDetailCreateErrorCode) {
    CustomerServiceCustomDetailCreateErrorCode["ColorNotSaved"] = "COLOR_NOT_SAVED";
    return CustomerServiceCustomDetailCreateErrorCode;
}({}); /**
 * #########################
 *  Error extensions
 * #########################
 */ 
let $5b8397cef71e8614$export$b39410ef8fd0f614 = /*#__PURE__*/ function(CustomerServiceCustomDetailTypeName) {
    CustomerServiceCustomDetailTypeName["Boolean"] = "BOOLEAN";
    CustomerServiceCustomDetailTypeName["Date"] = "DATE";
    CustomerServiceCustomDetailTypeName["Email"] = "EMAIL";
    CustomerServiceCustomDetailTypeName["Multiselect"] = "MULTISELECT";
    CustomerServiceCustomDetailTypeName["Number"] = "NUMBER";
    CustomerServiceCustomDetailTypeName["Phone"] = "PHONE";
    CustomerServiceCustomDetailTypeName["Select"] = "SELECT";
    CustomerServiceCustomDetailTypeName["Text"] = "TEXT";
    CustomerServiceCustomDetailTypeName["Url"] = "URL";
    CustomerServiceCustomDetailTypeName["User"] = "USER";
    return CustomerServiceCustomDetailTypeName;
}({}); /** The customer service organization attribute with a value */  /** The customer service custom details defined on an entity */  /** The available entities */ 
let $5b8397cef71e8614$export$c8c77ee10baacd37 = /*#__PURE__*/ function(CustomerServiceCustomDetailsEntityType) {
    CustomerServiceCustomDetailsEntityType["Customer"] = "CUSTOMER";
    CustomerServiceCustomDetailsEntityType["Entitlement"] = "ENTITLEMENT";
    CustomerServiceCustomDetailsEntityType["Organization"] = "ORGANIZATION";
    return CustomerServiceCustomDetailsEntityType;
}({}); /**
 * #########################
 *  Query Responses
 * #########################
 */ 
let $5b8397cef71e8614$export$c982791253b48a4e = /*#__PURE__*/ function(CustomerServiceLinkEntityType) {
    CustomerServiceLinkEntityType["Customer"] = "CUSTOMER";
    CustomerServiceLinkEntityType["Organization"] = "ORGANIZATION";
    return CustomerServiceLinkEntityType;
}({}); /**
 * #########################
 *  Query Responses
 * #########################
 */ 
let $5b8397cef71e8614$export$beae497f7881e8b9 = /*#__PURE__*/ function(CustomerServiceNoteEntity) {
    CustomerServiceNoteEntity["Customer"] = "CUSTOMER";
    CustomerServiceNoteEntity["Organization"] = "ORGANIZATION";
    return CustomerServiceNoteEntity;
}({}); /**
 * ###############################
 *  Base objects for notes
 * ###############################
 */ 
let $5b8397cef71e8614$export$950a886e1d68d5 = /*#__PURE__*/ function(CustomerServicePermissionGroupType) {
    CustomerServicePermissionGroupType["Admins"] = "ADMINS";
    CustomerServicePermissionGroupType["AdminsAgents"] = "ADMINS_AGENTS";
    CustomerServicePermissionGroupType["AdminsAgentsCollaborators"] = "ADMINS_AGENTS_COLLABORATORS";
    return CustomerServicePermissionGroupType;
}({}); /**
 * ###############################
 *  Base objects for platform values
 * ###############################
 *  Note: Add any additional platform values to this union
 */ 
let $5b8397cef71e8614$export$94dacf0afef67abf = /*#__PURE__*/ function(DataClassificationPolicyDecisionStatus) {
    DataClassificationPolicyDecisionStatus["Allowed"] = "ALLOWED";
    DataClassificationPolicyDecisionStatus["Blocked"] = "BLOCKED";
    return DataClassificationPolicyDecisionStatus;
}({});
let $5b8397cef71e8614$export$e3d8cf42d600c426 = /*#__PURE__*/ function(DataResidencyResponse) {
    DataResidencyResponse["AppDoesNotSupportDr"] = "APP_DOES_NOT_SUPPORT_DR";
    DataResidencyResponse["NotApplicable"] = "NOT_APPLICABLE";
    DataResidencyResponse["StoredExternalToAtlassian"] = "STORED_EXTERNAL_TO_ATLASSIAN";
    DataResidencyResponse["StoredInAtlassianAndDrNotSupported"] = "STORED_IN_ATLASSIAN_AND_DR_NOT_SUPPORTED";
    DataResidencyResponse["StoredInAtlassianAndDrSupported"] = "STORED_IN_ATLASSIAN_AND_DR_SUPPORTED";
    return DataResidencyResponse;
}({}); /** Time ranges of invocation date. */  /** Response from deleting an app */  /** Generic implementation of MutationResponse for responses that don't need any extra data */  /** Accepts input to delete an external alias. */  /** The payload returned from deleting the external alias of a component. */  /** Accepts input for deleting an existing component. */  /** Accepts input to delete a component link. */  /** The payload retuned after deleting a component link. */  /** The payload returned from deleting an existing component. */  /** Input to delete a component type. */  /** The payload returned after deleting the component type. */  /** Accepts input for deleting an existing relationship between two components. */  /** The payload returned from deleting an existing component. */  /** The payload returned from deleting a scorecard criterion. */  /** Accepts input for deleting a starred component. */  /** Payload returned from deleting a starred component. */  /** Input to delete an individual user defined parameter. */  /** The request input for deleting relationship properties */  /** The response payload of deleting DevOps Service Entity Properties */  /** The request input for deleting a relationship between a DevOps Service and a Jira Project */  /** The request input for deleting a relationship between a DevOps Service and an Opsgenie Team */  /** The response payload of deleting a relationship between a DevOps Service and an Opsgenie Team */  /** The request input for deleting a relationship between a DevOps Service and a Repository */  /** The request input for deleting DevOps Service Entity Properties */  /** The response payload of deleting DevOps Service Entity Properties */  /** The request input for deleting a DevOps Service */  /** The response payload of deleting a DevOps Service */  /** The request input for deleting a DevOps Service Relationship */  /** The request input for deleting a relationship between a Jira project and a repository */  /** Delete sprint */  /** Response from creating an webtrigger url */  /**
 * This object models the Continuous Delivery (CD) Pipeline concept, an automated process (usually comprised of multiple stages)
 * for getting software from version control right through to the production environment.
 */ 
let $5b8397cef71e8614$export$a12a01ce2571070a = /*#__PURE__*/ function(DeploymentState) {
    DeploymentState["Cancelled"] = "CANCELLED";
    DeploymentState["Failed"] = "FAILED";
    DeploymentState["InProgress"] = "IN_PROGRESS";
    DeploymentState["Pending"] = "PENDING";
    DeploymentState["RolledBack"] = "ROLLED_BACK";
    DeploymentState["Successful"] = "SUCCESSFUL";
    DeploymentState["Unknown"] = "UNKNOWN";
    return DeploymentState;
}({}); /**
 * This object models a deployment in the Continuous Delivery (CD) Pipeline concept, an automated process (usually comprised of
 * multiple stages) for getting software from version control right through to the production environment.
 */ 
let $5b8397cef71e8614$export$63bd3fb0666e773f = /*#__PURE__*/ function(DevAiAutofixScanSortField) {
    DevAiAutofixScanSortField["StartDate"] = "START_DATE";
    return DevAiAutofixScanSortField;
}({});
let $5b8397cef71e8614$export$f25325441f229f64 = /*#__PURE__*/ function(DevAiAutofixScanStatus) {
    DevAiAutofixScanStatus["Completed"] = "COMPLETED";
    DevAiAutofixScanStatus["Failed"] = "FAILED";
    DevAiAutofixScanStatus["InProgress"] = "IN_PROGRESS";
    return DevAiAutofixScanStatus;
}({});
let $5b8397cef71e8614$export$d09e4c4b79589a66 = /*#__PURE__*/ function(DevAiAutofixTaskSortField) {
    DevAiAutofixTaskSortField["CreatedAt"] = "CREATED_AT";
    DevAiAutofixTaskSortField["Filename"] = "FILENAME";
    DevAiAutofixTaskSortField["NewCoveragePercentage"] = "NEW_COVERAGE_PERCENTAGE";
    DevAiAutofixTaskSortField["PreviousCoveragePercentage"] = "PREVIOUS_COVERAGE_PERCENTAGE";
    DevAiAutofixTaskSortField["PrimaryLanguage"] = "PRIMARY_LANGUAGE";
    DevAiAutofixTaskSortField["Status"] = "STATUS";
    DevAiAutofixTaskSortField["UpdatedAt"] = "UPDATED_AT";
    return DevAiAutofixTaskSortField;
}({});
let $5b8397cef71e8614$export$265f04bd9f283d5d = /*#__PURE__*/ function(DevAiAutofixTaskStatus) {
    DevAiAutofixTaskStatus["PrDeclined"] = "PR_DECLINED";
    DevAiAutofixTaskStatus["PrMerged"] = "PR_MERGED";
    DevAiAutofixTaskStatus["PrOpened"] = "PR_OPENED";
    DevAiAutofixTaskStatus["WorkflowCancelled"] = "WORKFLOW_CANCELLED";
    DevAiAutofixTaskStatus["WorkflowCompleted"] = "WORKFLOW_COMPLETED";
    DevAiAutofixTaskStatus["WorkflowInprogress"] = "WORKFLOW_INPROGRESS";
    DevAiAutofixTaskStatus["WorkflowPending"] = "WORKFLOW_PENDING";
    return DevAiAutofixTaskStatus;
}({});
let $5b8397cef71e8614$export$e81a3fe0d2b413f = /*#__PURE__*/ function(DevAiScanIntervalUnit) {
    DevAiScanIntervalUnit["Days"] = "DAYS";
    DevAiScanIntervalUnit["Months"] = "MONTHS";
    DevAiScanIntervalUnit["Weeks"] = "WEEKS";
    return DevAiScanIntervalUnit;
}({}); /** Input to enable/disable Autofix for a repository. */ 
let $5b8397cef71e8614$export$bfbfde65991aaecf = /*#__PURE__*/ function(DevAiSupportedRepoFilterOption) {
    DevAiSupportedRepoFilterOption["All"] = "ALL";
    DevAiSupportedRepoFilterOption["DisabledOnly"] = "DISABLED_ONLY";
    DevAiSupportedRepoFilterOption["EnabledOnly"] = "ENABLED_ONLY";
    return DevAiSupportedRepoFilterOption;
}({}); /** Input to trigger an autofix scan of a repository */  /** The return payload for triggering an Autofix repository Scan */  /** Data-Depot Build Provider details. */  /** Data-Depot Build Provider details. */  /** The state of a build. */ 
let $5b8397cef71e8614$export$38ae85b0603265fc = /*#__PURE__*/ function(DevOpsBuildState) {
    DevOpsBuildState["Cancelled"] = "CANCELLED";
    DevOpsBuildState["Failed"] = "FAILED";
    DevOpsBuildState["InProgress"] = "IN_PROGRESS";
    DevOpsBuildState["Pending"] = "PENDING";
    DevOpsBuildState["Successful"] = "SUCCESSFUL";
    DevOpsBuildState["Unknown"] = "UNKNOWN";
    return DevOpsBuildState;
}({});
let $5b8397cef71e8614$export$e81f0008646134d2 = /*#__PURE__*/ function(DevOpsComponentTier) {
    DevOpsComponentTier["Tier_1"] = "TIER_1";
    DevOpsComponentTier["Tier_2"] = "TIER_2";
    DevOpsComponentTier["Tier_3"] = "TIER_3";
    DevOpsComponentTier["Tier_4"] = "TIER_4";
    return DevOpsComponentTier;
}({});
let $5b8397cef71e8614$export$1ecef45184e0481 = /*#__PURE__*/ function(DevOpsComponentType) {
    DevOpsComponentType["Application"] = "APPLICATION";
    DevOpsComponentType["Capability"] = "CAPABILITY";
    DevOpsComponentType["CloudResource"] = "CLOUD_RESOURCE";
    DevOpsComponentType["DataPipeline"] = "DATA_PIPELINE";
    DevOpsComponentType["Library"] = "LIBRARY";
    DevOpsComponentType["MachineLearningModel"] = "MACHINE_LEARNING_MODEL";
    DevOpsComponentType["Other"] = "OTHER";
    DevOpsComponentType["Service"] = "SERVICE";
    DevOpsComponentType["UiElement"] = "UI_ELEMENT";
    DevOpsComponentType["Website"] = "WEBSITE";
    return DevOpsComponentType;
}({}); /** Data-Depot Component Provider details. */  /** Data-Depot Component Provider details. */  /** Data-Depot Component Provider details. */  /** Data-Depot Deployment Provider details. */  /** Data-Depot Deployment Provider details. */  /** ## Data Depot Designs ### */  /** ## Data Depot Designs ### */  /** ## Data Depot Designs ### */  /** Data-Depot Design Provider details. */  /** Data-Depot Design Provider details. */ 
let $5b8397cef71e8614$export$8e9c2240003b2ba6 = /*#__PURE__*/ function(DevOpsDesignStatus) {
    DevOpsDesignStatus["None"] = "NONE";
    DevOpsDesignStatus["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    DevOpsDesignStatus["Unknown"] = "UNKNOWN";
    return DevOpsDesignStatus;
}({});
let $5b8397cef71e8614$export$279a4200dae77ac6 = /*#__PURE__*/ function(DevOpsDesignType) {
    DevOpsDesignType["Canvas"] = "CANVAS";
    DevOpsDesignType["File"] = "FILE";
    DevOpsDesignType["Group"] = "GROUP";
    DevOpsDesignType["Node"] = "NODE";
    DevOpsDesignType["Other"] = "OTHER";
    DevOpsDesignType["Prototype"] = "PROTOTYPE";
    return DevOpsDesignType;
}({}); /** Data-Depot Dev Info Provider details. */  /** Data-Depot Dev Info Provider details. */  /** Data-Depot Dev Info Provider details. */  /** Document Category */ 
let $5b8397cef71e8614$export$eeb884a29ae659e4 = /*#__PURE__*/ function(DevOpsDocumentCategory) {
    DevOpsDocumentCategory["Archive"] = "ARCHIVE";
    DevOpsDocumentCategory["Audio"] = "AUDIO";
    DevOpsDocumentCategory["Code"] = "CODE";
    DevOpsDocumentCategory["Document"] = "DOCUMENT";
    DevOpsDocumentCategory["Folder"] = "FOLDER";
    DevOpsDocumentCategory["Form"] = "FORM";
    DevOpsDocumentCategory["Image"] = "IMAGE";
    DevOpsDocumentCategory["Other"] = "OTHER";
    DevOpsDocumentCategory["Pdf"] = "PDF";
    DevOpsDocumentCategory["Presentation"] = "PRESENTATION";
    DevOpsDocumentCategory["Shortcut"] = "SHORTCUT";
    DevOpsDocumentCategory["Spreadsheet"] = "SPREADSHEET";
    DevOpsDocumentCategory["Video"] = "VIDEO";
    return DevOpsDocumentCategory;
}({}); /** Data-Depot Documentation Provider details. */  /** Data-Depot Documentation Provider details. */  /** Data-Depot Documentation Provider details. */  /**
 * An environment that a code change can be released to.
 *
 * The release may be via a code deployment or via a feature flag change.
 */ 
let $5b8397cef71e8614$export$d897dc8d29fd16eb = /*#__PURE__*/ function(DevOpsEnvironmentCategory) {
    DevOpsEnvironmentCategory["Development"] = "DEVELOPMENT";
    DevOpsEnvironmentCategory["Production"] = "PRODUCTION";
    DevOpsEnvironmentCategory["Staging"] = "STAGING";
    DevOpsEnvironmentCategory["Testing"] = "TESTING";
    DevOpsEnvironmentCategory["Unmapped"] = "UNMAPPED";
    return DevOpsEnvironmentCategory;
}({});
let $5b8397cef71e8614$export$651219dc3d44cf93 = /*#__PURE__*/ function(DevOpsJiraProjectType) {
    DevOpsJiraProjectType["JiraCore"] = "JIRA_CORE";
    DevOpsJiraProjectType["JiraServicedesk"] = "JIRA_SERVICEDESK";
    DevOpsJiraProjectType["JiraSoftware"] = "JIRA_SOFTWARE";
    return DevOpsJiraProjectType;
}({});
let $5b8397cef71e8614$export$18fde50976ec82dd = /*#__PURE__*/ function(DevOpsMetricsCycleTimePhase) {
    DevOpsMetricsCycleTimePhase["CommitToDeployment"] = "COMMIT_TO_DEPLOYMENT";
    DevOpsMetricsCycleTimePhase["CommitToPr"] = "COMMIT_TO_PR";
    return DevOpsMetricsCycleTimePhase;
}({}); /** #### Response ##### */  /** No results will be returned unless an association type is specified. Currently only 'jiraProjectIds' association type is supported. */  /** No results will be returned unless an association type is specified. Currently only 'jiraProjectIds' association type is supported. */  /** No results will be returned unless an association type is specified. Currently only 'jiraProjectIds' association type is supported. */  /** Unit for specified resolution value. */ 
let $5b8397cef71e8614$export$1f082d6bdd7f11d5 = /*#__PURE__*/ function(DevOpsMetricsResolutionUnit) {
    DevOpsMetricsResolutionUnit["Day"] = "DAY";
    DevOpsMetricsResolutionUnit["Hour"] = "HOUR";
    DevOpsMetricsResolutionUnit["Week"] = "WEEK";
    return DevOpsMetricsResolutionUnit;
}({});
let $5b8397cef71e8614$export$fdde013eb4eeffed = /*#__PURE__*/ function(DevOpsMetricsRollupOption) {
    DevOpsMetricsRollupOption["Mean"] = "MEAN";
    DevOpsMetricsRollupOption["Percentile"] = "PERCENTILE";
    return DevOpsMetricsRollupOption;
}({});
let $5b8397cef71e8614$export$ab7231643ddbb509 = /*#__PURE__*/ function(DevOpsOperationsIncidentSeverity) {
    DevOpsOperationsIncidentSeverity["P1"] = "P1";
    DevOpsOperationsIncidentSeverity["P2"] = "P2";
    DevOpsOperationsIncidentSeverity["P3"] = "P3";
    DevOpsOperationsIncidentSeverity["P4"] = "P4";
    DevOpsOperationsIncidentSeverity["P5"] = "P5";
    DevOpsOperationsIncidentSeverity["Pending"] = "PENDING";
    DevOpsOperationsIncidentSeverity["Unknown"] = "UNKNOWN";
    return DevOpsOperationsIncidentSeverity;
}({});
let $5b8397cef71e8614$export$3ef3f18ee7a943de = /*#__PURE__*/ function(DevOpsOperationsIncidentStatus) {
    DevOpsOperationsIncidentStatus["Open"] = "OPEN";
    DevOpsOperationsIncidentStatus["Resolved"] = "RESOLVED";
    DevOpsOperationsIncidentStatus["Unknown"] = "UNKNOWN";
    return DevOpsOperationsIncidentStatus;
}({}); /** Data-Depot Operations Provider details. */  /** Data-Depot Operations Provider details. */  /** Data-Depot Operations Provider details. */ 
let $5b8397cef71e8614$export$1c5eb757d029c7d0 = /*#__PURE__*/ function(DevOpsPostIncidentReviewStatus) {
    DevOpsPostIncidentReviewStatus["Completed"] = "COMPLETED";
    DevOpsPostIncidentReviewStatus["InProgress"] = "IN_PROGRESS";
    DevOpsPostIncidentReviewStatus["Todo"] = "TODO";
    return DevOpsPostIncidentReviewStatus;
}({});
let $5b8397cef71e8614$export$8fd61af3426661d5 = /*#__PURE__*/ function(DevOpsProjectStatus) {
    DevOpsProjectStatus["Cancelled"] = "CANCELLED";
    DevOpsProjectStatus["Completed"] = "COMPLETED";
    DevOpsProjectStatus["InProgress"] = "IN_PROGRESS";
    DevOpsProjectStatus["Paused"] = "PAUSED";
    DevOpsProjectStatus["Pending"] = "PENDING";
    DevOpsProjectStatus["Unknown"] = "UNKNOWN";
    return DevOpsProjectStatus;
}({});
let $5b8397cef71e8614$export$3ba9c1ac88495bed = /*#__PURE__*/ function(DevOpsProjectTargetDateType) {
    DevOpsProjectTargetDateType["Day"] = "DAY";
    DevOpsProjectTargetDateType["Month"] = "MONTH";
    DevOpsProjectTargetDateType["Quarter"] = "QUARTER";
    DevOpsProjectTargetDateType["Unknown"] = "UNKNOWN";
    return DevOpsProjectTargetDateType;
}({}); /** A provider that a deployment has been done with. */  /** A type to group various URLs of Provider */ 
let $5b8397cef71e8614$export$2190b10e3dc81d80 = /*#__PURE__*/ function(DevOpsProviderNamespace) {
    DevOpsProviderNamespace["Asap"] = "ASAP";
    DevOpsProviderNamespace["Classic"] = "CLASSIC";
    DevOpsProviderNamespace["Forge"] = "FORGE";
    DevOpsProviderNamespace["Oauth"] = "OAUTH";
    return DevOpsProviderNamespace;
}({}); /**
 * Type of a data-depot provider.
 * A provider may belongs to multiple types (e.g an connect-app can send both build and deployment info).
 */ 
let $5b8397cef71e8614$export$e0671d592d4ff2a3 = /*#__PURE__*/ function(DevOpsProviderType) {
    DevOpsProviderType["Build"] = "BUILD";
    DevOpsProviderType["Deployment"] = "DEPLOYMENT";
    DevOpsProviderType["Design"] = "DESIGN";
    DevOpsProviderType["DevopsComponents"] = "DEVOPS_COMPONENTS";
    DevOpsProviderType["DevInfo"] = "DEV_INFO";
    DevOpsProviderType["Documentation"] = "DOCUMENTATION";
    DevOpsProviderType["FeatureFlag"] = "FEATURE_FLAG";
    DevOpsProviderType["Operations"] = "OPERATIONS";
    DevOpsProviderType["Project"] = "PROJECT";
    DevOpsProviderType["RemoteLinks"] = "REMOTE_LINKS";
    DevOpsProviderType["Security"] = "SECURITY";
    return DevOpsProviderType;
}({});
let $5b8397cef71e8614$export$4ccf930134e74702 = /*#__PURE__*/ function(DevOpsPullRequestApprovalStatus) {
    DevOpsPullRequestApprovalStatus["Approved"] = "APPROVED";
    DevOpsPullRequestApprovalStatus["Needswork"] = "NEEDSWORK";
    DevOpsPullRequestApprovalStatus["Unapproved"] = "UNAPPROVED";
    return DevOpsPullRequestApprovalStatus;
}({});
let $5b8397cef71e8614$export$4dec602c1ab1d95e = /*#__PURE__*/ function(DevOpsPullRequestStatus) {
    DevOpsPullRequestStatus["Declined"] = "DECLINED";
    DevOpsPullRequestStatus["Draft"] = "DRAFT";
    DevOpsPullRequestStatus["Merged"] = "MERGED";
    DevOpsPullRequestStatus["Open"] = "OPEN";
    DevOpsPullRequestStatus["Unknown"] = "UNKNOWN";
    return DevOpsPullRequestStatus;
}({});
let $5b8397cef71e8614$export$13a31923d75e3a27 = /*#__PURE__*/ function(DevOpsRelationshipCertainty) {
    DevOpsRelationshipCertainty["Explicit"] = "EXPLICIT";
    DevOpsRelationshipCertainty["Implicit"] = "IMPLICIT";
    return DevOpsRelationshipCertainty;
}({});
let $5b8397cef71e8614$export$c5657a9969e35205 = /*#__PURE__*/ function(DevOpsRelationshipCertaintyFilter) {
    DevOpsRelationshipCertaintyFilter["All"] = "ALL";
    DevOpsRelationshipCertaintyFilter["Explicit"] = "EXPLICIT";
    DevOpsRelationshipCertaintyFilter["Implicit"] = "IMPLICIT";
    return DevOpsRelationshipCertaintyFilter;
}({}); /** Data-Depot Remote Links Provider details. */  /** Data-Depot Remote Links Provider details. */ 
let $5b8397cef71e8614$export$15a0db675256459b = /*#__PURE__*/ function(DevOpsRepositoryHostingProviderFilter) {
    DevOpsRepositoryHostingProviderFilter["All"] = "ALL";
    DevOpsRepositoryHostingProviderFilter["BitbucketCloud"] = "BITBUCKET_CLOUD";
    DevOpsRepositoryHostingProviderFilter["ThirdParty"] = "THIRD_PARTY";
    return DevOpsRepositoryHostingProviderFilter;
}({}); /** Data-Depot Security Provider details. */  /** Data-Depot Security Provider details. */  /** Data-Depot Security Provider details. */  /** Data-Depot Security Provider details. */  /** Data-Depot Security Provider details. */  /** ## Data Depot Security Vulnerabilities ### */  /** ## Data Depot Security Vulnerabilities ### */ 
let $5b8397cef71e8614$export$24e732e98f25b4d9 = /*#__PURE__*/ function(DevOpsSecurityVulnerabilitySeverity) {
    DevOpsSecurityVulnerabilitySeverity["Critical"] = "CRITICAL";
    DevOpsSecurityVulnerabilitySeverity["High"] = "HIGH";
    DevOpsSecurityVulnerabilitySeverity["Low"] = "LOW";
    DevOpsSecurityVulnerabilitySeverity["Medium"] = "MEDIUM";
    DevOpsSecurityVulnerabilitySeverity["Unknown"] = "UNKNOWN";
    return DevOpsSecurityVulnerabilitySeverity;
}({});
let $5b8397cef71e8614$export$a1202d25589419a7 = /*#__PURE__*/ function(DevOpsSecurityVulnerabilityStatus) {
    DevOpsSecurityVulnerabilityStatus["Closed"] = "CLOSED";
    DevOpsSecurityVulnerabilityStatus["Ignored"] = "IGNORED";
    DevOpsSecurityVulnerabilityStatus["Open"] = "OPEN";
    DevOpsSecurityVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return DevOpsSecurityVulnerabilityStatus;
}({}); /** A relationship between DevOps Service and Jira Project Team */  /** A relationship between DevOps Service and Jira Project Team */ 
let $5b8397cef71e8614$export$82bbaba9292627e1 = /*#__PURE__*/ function(DevOpsServiceAndJiraProjectRelationshipType) {
    DevOpsServiceAndJiraProjectRelationshipType["ChangeManagement"] = "CHANGE_MANAGEMENT";
    DevOpsServiceAndJiraProjectRelationshipType["Default"] = "DEFAULT";
    return DevOpsServiceAndJiraProjectRelationshipType;
}({}); /** A relationship between DevOps Service and Opsgenie Team */  /** A relationship between DevOps Service and Opsgenie Team */  /** A relationship between a DevOps Service and a Repository */  /** A relationship between a DevOps Service and a Repository */ 
let $5b8397cef71e8614$export$c3e0b3161314e204 = /*#__PURE__*/ function(DevOpsServiceAndRepositoryRelationshipSortBy) {
    DevOpsServiceAndRepositoryRelationshipSortBy["LastInferredAt"] = "LAST_INFERRED_AT";
    return DevOpsServiceAndRepositoryRelationshipSortBy;
}({}); /** The connection object for a collection of Services. */  /** The request input for DevOps Service Entity Property */  /** The connection object for a collection of DevOps Service relationships. */  /** #################### Enums ##################### */ 
let $5b8397cef71e8614$export$cd3c7b586cbb9da5 = /*#__PURE__*/ function(DevOpsServiceRelationshipType) {
    DevOpsServiceRelationshipType["Contains"] = "CONTAINS";
    DevOpsServiceRelationshipType["DependsOn"] = "DEPENDS_ON";
    return DevOpsServiceRelationshipType;
}({}); /** The filtering input for retrieving services. tierLevelIn must not be empty if provided. */  /** Summary of the builds associated with an entity. */  /** #################### Supporting Types ##################### */  /** Represents a product or tool in a DevOps suite */  /** Represents a product or tool in a DevOps suite */  /** Represents a product or tool in a DevOps suite */  /** Represents a product or tool in a DevOps suite */  /** ######################################### Mutations ########################################## */  /** The integration details for the DevOps tool */  /** A marketplace app integration */  /** An Atlassian product integration */ 
let $5b8397cef71e8614$export$b4d01a63edd297ec = /*#__PURE__*/ function(DevOpsToolIntegrationType) {
    DevOpsToolIntegrationType["Any"] = "ANY";
    DevOpsToolIntegrationType["App"] = "APP";
    DevOpsToolIntegrationType["Exists"] = "EXISTS";
    DevOpsToolIntegrationType["None"] = "NONE";
    DevOpsToolIntegrationType["Product"] = "PRODUCT";
    return DevOpsToolIntegrationType;
}({});
let $5b8397cef71e8614$export$1371117f8b853f61 = /*#__PURE__*/ function(DevOpsToolSortOrder) {
    DevOpsToolSortOrder["Asc"] = "ASC";
    DevOpsToolSortOrder["Desc"] = "DESC";
    return DevOpsToolSortOrder;
}({}); /**
 * A user that could tie to a first-party user and/or a third-party user.
 *
 * - "user" is supplied if it is a first-party user
 * - "thirdPartyUser" is supplied if it is a third-party user
 * - Both "user" and "thirdPartyUser" could be supplied if a user matches both a first-party user and a third-party user
 * - Neither "user" nor "thirdPartyUser" is supplied if the user is not found, but they exist. For example, a Pull Request might have a user, but we just don't know who that user is.
 */ 
let $5b8397cef71e8614$export$861966f1b6eab176 = /*#__PURE__*/ function(DevStatusActivity) {
    DevStatusActivity["BranchOpen"] = "BRANCH_OPEN";
    DevStatusActivity["Commit"] = "COMMIT";
    DevStatusActivity["Deployment"] = "DEPLOYMENT";
    DevStatusActivity["Design"] = "DESIGN";
    DevStatusActivity["PrDeclined"] = "PR_DECLINED";
    DevStatusActivity["PrMerged"] = "PR_MERGED";
    DevStatusActivity["PrOpen"] = "PR_OPEN";
    return DevStatusActivity;
}({});
let $5b8397cef71e8614$export$250c76f3771f8949 = /*#__PURE__*/ function(EcosystemAppNetworkPermissionType) {
    EcosystemAppNetworkPermissionType["Connect"] = "CONNECT";
    return EcosystemAppNetworkPermissionType;
}({});
let $5b8397cef71e8614$export$f432b7347a6f0100 = /*#__PURE__*/ function(EcosystemAppsInstalledInContextsFilterType) {
    EcosystemAppsInstalledInContextsFilterType["Name"] = "NAME";
    EcosystemAppsInstalledInContextsFilterType["OnlyAppIds"] = "ONLY_APP_IDS";
    return EcosystemAppsInstalledInContextsFilterType;
}({});
let $5b8397cef71e8614$export$123dfeb539fdf7e4 = /*#__PURE__*/ function(EcosystemAppsInstalledInContextsSortKey) {
    EcosystemAppsInstalledInContextsSortKey["Name"] = "NAME";
    EcosystemAppsInstalledInContextsSortKey["RelatedApps"] = "RELATED_APPS";
    return EcosystemAppsInstalledInContextsSortKey;
}({}); /** Edit sprint */  /** Estimate object which contains an estimate for a card when it exists */ 
let $5b8397cef71e8614$export$38fe23235d685c0d = /*#__PURE__*/ function(EstimationType) {
    EstimationType["CustomNumberField"] = "CUSTOM_NUMBER_FIELD";
    EstimationType["IssueCount"] = "ISSUE_COUNT";
    EstimationType["OriginalEstimate"] = "ORIGINAL_ESTIMATE";
    EstimationType["StoryPoints"] = "STORY_POINTS";
    return EstimationType;
}({}); /** Compass Events */  /** Compass Events */  /** An arbitrary extension definition as defined by the Ecosystem */  /** An arbitrary extension definition as defined by the Ecosystem */  /** The context in which an extension exists */  /** The context in which an extension exists */  /** The context in which an extension exists */  /** The context in which an extension exists */  /** The context in which an extension exists */  /** The context in which an extension exists */ 
let $5b8397cef71e8614$export$f7fc910e99a97ad = /*#__PURE__*/ function(ExtensionContextsFilterType) {
    ExtensionContextsFilterType["AppIdEnvironmentId"] = "APP_ID_ENVIRONMENT_ID";
    ExtensionContextsFilterType["DataClassificationTag"] = "DATA_CLASSIFICATION_TAG";
    ExtensionContextsFilterType["DefinitionId"] = "DEFINITION_ID";
    ExtensionContextsFilterType["ExtensionType"] = "EXTENSION_TYPE";
    ExtensionContextsFilterType["PrincipalType"] = "PRINCIPAL_TYPE";
    return ExtensionContextsFilterType;
}({}); /**
 * Details about an extension.
 *
 * This information is used to look up the extension within CaaS so that the
 * correct function can be resolved.
 *
 * This will eventually be superseded by an Id.
 */ 
let $5b8397cef71e8614$export$d11f0d213b47454b = /*#__PURE__*/ function(ExternalApprovalStatus) {
    ExternalApprovalStatus["Approved"] = "APPROVED";
    ExternalApprovalStatus["Needswork"] = "NEEDSWORK";
    ExternalApprovalStatus["Unapproved"] = "UNAPPROVED";
    return ExternalApprovalStatus;
}({}); /**
 * Supported associations ATIs in Data Depot
 *   Implemented for hydration
 *     * GRAPH_SERVICE
 *     * JIRA_ISSUE
 *     * JIRA_DOCUMENT
 *     * JIRA_PROJECT
 *     * JIRA_VERSION
 *     * THIRD_PARTY_USER
 *   To be implemented
 *     * COMPASS_EVENT_SOURCE
 *     * COMPASS_COMPONENT
 *     * MERCURY_FOCUS_AREA
 *     * THIRD_PARTY_GROUP
 */ 
let $5b8397cef71e8614$export$a529a83fbd574a83 = /*#__PURE__*/ function(ExternalBuildState) {
    ExternalBuildState["Cancelled"] = "CANCELLED";
    ExternalBuildState["Failed"] = "FAILED";
    ExternalBuildState["InProgress"] = "IN_PROGRESS";
    ExternalBuildState["Pending"] = "PENDING";
    ExternalBuildState["Successful"] = "SUCCESSFUL";
    ExternalBuildState["Unknown"] = "UNKNOWN";
    return ExternalBuildState;
}({});
let $5b8397cef71e8614$export$21df421064bf3919 = /*#__PURE__*/ function(ExternalChangeType) {
    ExternalChangeType["Added"] = "ADDED";
    ExternalChangeType["Copied"] = "COPIED";
    ExternalChangeType["Deleted"] = "DELETED";
    ExternalChangeType["Modified"] = "MODIFIED";
    ExternalChangeType["Moved"] = "MOVED";
    ExternalChangeType["Unknown"] = "UNKNOWN";
    return ExternalChangeType;
}({});
let $5b8397cef71e8614$export$6759ac6277d955dd = /*#__PURE__*/ function(ExternalCommitFlags) {
    ExternalCommitFlags["MergeCommit"] = "MERGE_COMMIT";
    return ExternalCommitFlags;
}({});
let $5b8397cef71e8614$export$bbf4ad4fb3d17b4c = /*#__PURE__*/ function(ExternalConversationType) {
    ExternalConversationType["Channel"] = "CHANNEL";
    ExternalConversationType["DirectMessage"] = "DIRECT_MESSAGE";
    ExternalConversationType["GroupDirectMessage"] = "GROUP_DIRECT_MESSAGE";
    return ExternalConversationType;
}({});
let $5b8397cef71e8614$export$2b3de6bf362bc793 = /*#__PURE__*/ function(ExternalDeploymentState) {
    ExternalDeploymentState["Cancelled"] = "CANCELLED";
    ExternalDeploymentState["Failed"] = "FAILED";
    ExternalDeploymentState["InProgress"] = "IN_PROGRESS";
    ExternalDeploymentState["Pending"] = "PENDING";
    ExternalDeploymentState["RolledBack"] = "ROLLED_BACK";
    ExternalDeploymentState["Successful"] = "SUCCESSFUL";
    ExternalDeploymentState["Unknown"] = "UNKNOWN";
    return ExternalDeploymentState;
}({});
let $5b8397cef71e8614$export$b3dbc3bb1f3d376e = /*#__PURE__*/ function(ExternalDesignStatus) {
    ExternalDesignStatus["None"] = "NONE";
    ExternalDesignStatus["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    ExternalDesignStatus["Unknown"] = "UNKNOWN";
    return ExternalDesignStatus;
}({});
let $5b8397cef71e8614$export$697e56d9e72094e7 = /*#__PURE__*/ function(ExternalDesignType) {
    ExternalDesignType["Canvas"] = "CANVAS";
    ExternalDesignType["File"] = "FILE";
    ExternalDesignType["Group"] = "GROUP";
    ExternalDesignType["Node"] = "NODE";
    ExternalDesignType["Other"] = "OTHER";
    ExternalDesignType["Prototype"] = "PROTOTYPE";
    return ExternalDesignType;
}({});
let $5b8397cef71e8614$export$febd917fd954ad28 = /*#__PURE__*/ function(ExternalDocumentCategory) {
    ExternalDocumentCategory["Archive"] = "ARCHIVE";
    ExternalDocumentCategory["Audio"] = "AUDIO";
    ExternalDocumentCategory["Code"] = "CODE";
    ExternalDocumentCategory["Document"] = "DOCUMENT";
    ExternalDocumentCategory["Folder"] = "FOLDER";
    ExternalDocumentCategory["Form"] = "FORM";
    ExternalDocumentCategory["Image"] = "IMAGE";
    ExternalDocumentCategory["Other"] = "OTHER";
    ExternalDocumentCategory["Pdf"] = "PDF";
    ExternalDocumentCategory["Presentation"] = "PRESENTATION";
    ExternalDocumentCategory["Shortcut"] = "SHORTCUT";
    ExternalDocumentCategory["Spreadsheet"] = "SPREADSHEET";
    ExternalDocumentCategory["Video"] = "VIDEO";
    ExternalDocumentCategory["WebPage"] = "WEB_PAGE";
    return ExternalDocumentCategory;
}({}); /** Return one or the supported model */ 
let $5b8397cef71e8614$export$58380f2014542325 = /*#__PURE__*/ function(ExternalEnvironmentType) {
    ExternalEnvironmentType["Development"] = "DEVELOPMENT";
    ExternalEnvironmentType["Production"] = "PRODUCTION";
    ExternalEnvironmentType["Staging"] = "STAGING";
    ExternalEnvironmentType["Testing"] = "TESTING";
    ExternalEnvironmentType["Unmapped"] = "UNMAPPED";
    return ExternalEnvironmentType;
}({});
let $5b8397cef71e8614$export$7fbe6f4fd7f8b720 = /*#__PURE__*/ function(ExternalMembershipType) {
    ExternalMembershipType["Private"] = "PRIVATE";
    ExternalMembershipType["Public"] = "PUBLIC";
    ExternalMembershipType["Shared"] = "SHARED";
    return ExternalMembershipType;
}({});
let $5b8397cef71e8614$export$589c937a173b601d = /*#__PURE__*/ function(ExternalPullRequestStatus) {
    ExternalPullRequestStatus["Declined"] = "DECLINED";
    ExternalPullRequestStatus["Draft"] = "DRAFT";
    ExternalPullRequestStatus["Merged"] = "MERGED";
    ExternalPullRequestStatus["Open"] = "OPEN";
    ExternalPullRequestStatus["Unknown"] = "UNKNOWN";
    return ExternalPullRequestStatus;
}({});
let $5b8397cef71e8614$export$6935f9834af32b63 = /*#__PURE__*/ function(ExternalVulnerabilitySeverityLevel) {
    ExternalVulnerabilitySeverityLevel["Critical"] = "CRITICAL";
    ExternalVulnerabilitySeverityLevel["High"] = "HIGH";
    ExternalVulnerabilitySeverityLevel["Low"] = "LOW";
    ExternalVulnerabilitySeverityLevel["Medium"] = "MEDIUM";
    ExternalVulnerabilitySeverityLevel["Unknown"] = "UNKNOWN";
    return ExternalVulnerabilitySeverityLevel;
}({});
let $5b8397cef71e8614$export$4e05add33b7916dd = /*#__PURE__*/ function(ExternalVulnerabilityStatus) {
    ExternalVulnerabilityStatus["Closed"] = "CLOSED";
    ExternalVulnerabilityStatus["Ignored"] = "IGNORED";
    ExternalVulnerabilityStatus["Open"] = "OPEN";
    ExternalVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return ExternalVulnerabilityStatus;
}({});
let $5b8397cef71e8614$export$fe6bc7391e35d6c7 = /*#__PURE__*/ function(ExternalVulnerabilityType) {
    ExternalVulnerabilityType["Dast"] = "DAST";
    ExternalVulnerabilityType["Sast"] = "SAST";
    ExternalVulnerabilityType["Sca"] = "SCA";
    ExternalVulnerabilityType["Unknown"] = "UNKNOWN";
    return ExternalVulnerabilityType;
}({});
let $5b8397cef71e8614$export$7db809f6d9dd8b8 = /*#__PURE__*/ function(FilterId) {
    FilterId["Categories"] = "categories";
    FilterId["Hosting"] = "hosting";
    FilterId["Other"] = "other";
    FilterId["Price"] = "price";
    FilterId["Product"] = "product";
    FilterId["TrustSignals"] = "trustSignals";
    FilterId["UseCases"] = "useCases";
    FilterId["VersionHistoryHosting"] = "versionHistoryHosting";
    return FilterId;
}({});
let $5b8397cef71e8614$export$2494f7bfd7b17cbf = /*#__PURE__*/ function(ForgeAlertsActivityType) {
    ForgeAlertsActivityType["AlertCreated"] = "ALERT_CREATED";
    ForgeAlertsActivityType["AlertMuted"] = "ALERT_MUTED";
    ForgeAlertsActivityType["AlertOpened"] = "ALERT_OPENED";
    ForgeAlertsActivityType["AlertResolved"] = "ALERT_RESOLVED";
    ForgeAlertsActivityType["AlertSentFiring"] = "ALERT_SENT_FIRING";
    ForgeAlertsActivityType["AlertSentResolved"] = "ALERT_SENT_RESOLVED";
    ForgeAlertsActivityType["AlertUnmuted"] = "ALERT_UNMUTED";
    ForgeAlertsActivityType["AlertUpdated"] = "ALERT_UPDATED";
    return ForgeAlertsActivityType;
}({});
let $5b8397cef71e8614$export$7abb09aca3d3224b = /*#__PURE__*/ function(ForgeAlertsAlertActivityType) {
    ForgeAlertsAlertActivityType["AlertClosed"] = "ALERT_CLOSED";
    ForgeAlertsAlertActivityType["AlertOpen"] = "ALERT_OPEN";
    ForgeAlertsAlertActivityType["EmailSent"] = "EMAIL_SENT";
    ForgeAlertsAlertActivityType["SeverityUpdated"] = "SEVERITY_UPDATED";
    return ForgeAlertsAlertActivityType;
}({});
let $5b8397cef71e8614$export$33c67579a8081e2a = /*#__PURE__*/ function(ForgeAlertsListOrderByColumns) {
    ForgeAlertsListOrderByColumns["AlertId"] = "alertId";
    ForgeAlertsListOrderByColumns["ClosedAt"] = "closedAt";
    ForgeAlertsListOrderByColumns["CreatedAt"] = "createdAt";
    ForgeAlertsListOrderByColumns["Duration"] = "duration";
    ForgeAlertsListOrderByColumns["Severity"] = "severity";
    return ForgeAlertsListOrderByColumns;
}({});
let $5b8397cef71e8614$export$9d3bb71d891b531d = /*#__PURE__*/ function(ForgeAlertsListOrderOptions) {
    ForgeAlertsListOrderOptions["Asc"] = "ASC";
    ForgeAlertsListOrderOptions["Desc"] = "DESC";
    return ForgeAlertsListOrderOptions;
}({});
let $5b8397cef71e8614$export$e762242ac801905f = /*#__PURE__*/ function(ForgeAlertsMetricsDataType) {
    ForgeAlertsMetricsDataType["DateTime"] = "DATE_TIME";
    return ForgeAlertsMetricsDataType;
}({});
let $5b8397cef71e8614$export$84db9ee3d9e00674 = /*#__PURE__*/ function(ForgeAlertsMetricsResolutionUnit) {
    ForgeAlertsMetricsResolutionUnit["Day"] = "DAY";
    ForgeAlertsMetricsResolutionUnit["Hours"] = "HOURS";
    ForgeAlertsMetricsResolutionUnit["Minutes"] = "MINUTES";
    return ForgeAlertsMetricsResolutionUnit;
}({});
let $5b8397cef71e8614$export$804cf64af4f1f8ef = /*#__PURE__*/ function(ForgeAlertsRuleActivityAction) {
    ForgeAlertsRuleActivityAction["Created"] = "CREATED";
    ForgeAlertsRuleActivityAction["Deleted"] = "DELETED";
    ForgeAlertsRuleActivityAction["Disabled"] = "DISABLED";
    ForgeAlertsRuleActivityAction["Enabled"] = "ENABLED";
    ForgeAlertsRuleActivityAction["Updated"] = "UPDATED";
    return ForgeAlertsRuleActivityAction;
}({});
let $5b8397cef71e8614$export$a8eb586b92cbde1f = /*#__PURE__*/ function(ForgeAlertsRuleFilterActions) {
    ForgeAlertsRuleFilterActions["Exclude"] = "EXCLUDE";
    ForgeAlertsRuleFilterActions["Include"] = "INCLUDE";
    return ForgeAlertsRuleFilterActions;
}({});
let $5b8397cef71e8614$export$b8a26accb92dade4 = /*#__PURE__*/ function(ForgeAlertsRuleFilterDimensions) {
    ForgeAlertsRuleFilterDimensions["ErrorTypes"] = "ERROR_TYPES";
    ForgeAlertsRuleFilterDimensions["Functions"] = "FUNCTIONS";
    ForgeAlertsRuleFilterDimensions["Sites"] = "SITES";
    ForgeAlertsRuleFilterDimensions["Versions"] = "VERSIONS";
    return ForgeAlertsRuleFilterDimensions;
}({});
let $5b8397cef71e8614$export$3cd0507df3412180 = /*#__PURE__*/ function(ForgeAlertsRuleMetricType) {
    ForgeAlertsRuleMetricType["InvocationCount"] = "INVOCATION_COUNT";
    ForgeAlertsRuleMetricType["InvocationErrors"] = "INVOCATION_ERRORS";
    ForgeAlertsRuleMetricType["InvocationLatency"] = "INVOCATION_LATENCY";
    ForgeAlertsRuleMetricType["InvocationSuccessRate"] = "INVOCATION_SUCCESS_RATE";
    return ForgeAlertsRuleMetricType;
}({});
let $5b8397cef71e8614$export$49e1bdac0115b9c = /*#__PURE__*/ function(ForgeAlertsRuleSeverity) {
    ForgeAlertsRuleSeverity["Critical"] = "CRITICAL";
    ForgeAlertsRuleSeverity["Major"] = "MAJOR";
    ForgeAlertsRuleSeverity["Minor"] = "MINOR";
    return ForgeAlertsRuleSeverity;
}({});
let $5b8397cef71e8614$export$c665fabcc544b3e1 = /*#__PURE__*/ function(ForgeAlertsRuleWhenConditions) {
    ForgeAlertsRuleWhenConditions["Above"] = "ABOVE";
    ForgeAlertsRuleWhenConditions["AboveOrEqualTo"] = "ABOVE_OR_EQUAL_TO";
    ForgeAlertsRuleWhenConditions["Below"] = "BELOW";
    ForgeAlertsRuleWhenConditions["BelowOrEqualTo"] = "BELOW_OR_EQUAL_TO";
    return ForgeAlertsRuleWhenConditions;
}({});
let $5b8397cef71e8614$export$767f8584da7588f6 = /*#__PURE__*/ function(ForgeAlertsStatus) {
    ForgeAlertsStatus["Closed"] = "CLOSED";
    ForgeAlertsStatus["Firing"] = "FIRING";
    ForgeAlertsStatus["Open"] = "OPEN";
    ForgeAlertsStatus["Resolved"] = "RESOLVED";
    return ForgeAlertsStatus;
}({});
let $5b8397cef71e8614$export$d43e1fd1dac905d1 = /*#__PURE__*/ function(ForgeAuditLogsActionType) {
    ForgeAuditLogsActionType["ContributorAdded"] = "CONTRIBUTOR_ADDED";
    ForgeAuditLogsActionType["ContributorRemoved"] = "CONTRIBUTOR_REMOVED";
    ForgeAuditLogsActionType["ContributorRoleUpdated"] = "CONTRIBUTOR_ROLE_UPDATED";
    ForgeAuditLogsActionType["OwnershipTransferred"] = "OWNERSHIP_TRANSFERRED";
    return ForgeAuditLogsActionType;
}({});
let $5b8397cef71e8614$export$f0a3a970a16c79ec = /*#__PURE__*/ function(ForgeMetricsApiRequestGroupByDimensions) {
    ForgeMetricsApiRequestGroupByDimensions["ContextAri"] = "CONTEXT_ARI";
    ForgeMetricsApiRequestGroupByDimensions["Status"] = "STATUS";
    ForgeMetricsApiRequestGroupByDimensions["Url"] = "URL";
    return ForgeMetricsApiRequestGroupByDimensions;
}({});
let $5b8397cef71e8614$export$ff830a2670c6e0f4 = /*#__PURE__*/ function(ForgeMetricsApiRequestStatus) {
    ForgeMetricsApiRequestStatus["2Xx"] = "_2XX";
    ForgeMetricsApiRequestStatus["4Xx"] = "_4XX";
    ForgeMetricsApiRequestStatus["5Xx"] = "_5XX";
    return ForgeMetricsApiRequestStatus;
}({});
let $5b8397cef71e8614$export$67826916f2c41941 = /*#__PURE__*/ function(ForgeMetricsApiRequestType) {
    ForgeMetricsApiRequestType["Cache"] = "CACHE";
    ForgeMetricsApiRequestType["External"] = "EXTERNAL";
    ForgeMetricsApiRequestType["Product"] = "PRODUCT";
    ForgeMetricsApiRequestType["Sql"] = "SQL";
    return ForgeMetricsApiRequestType;
}({});
let $5b8397cef71e8614$export$6854d9ebadef3813 = /*#__PURE__*/ function(ForgeMetricsChartName) {
    ForgeMetricsChartName["ApiRequestCount_2Xx"] = "API_REQUEST_COUNT_2XX";
    ForgeMetricsChartName["ApiRequestCount_4Xx"] = "API_REQUEST_COUNT_4XX";
    ForgeMetricsChartName["ApiRequestCount_5Xx"] = "API_REQUEST_COUNT_5XX";
    ForgeMetricsChartName["ApiRequestLatency"] = "API_REQUEST_LATENCY";
    ForgeMetricsChartName["InvocationCount"] = "INVOCATION_COUNT";
    ForgeMetricsChartName["InvocationError"] = "INVOCATION_ERROR";
    ForgeMetricsChartName["InvocationLatency"] = "INVOCATION_LATENCY";
    ForgeMetricsChartName["InvocationSuccessRate"] = "INVOCATION_SUCCESS_RATE";
    return ForgeMetricsChartName;
}({});
let $5b8397cef71e8614$export$8220077afa4e34ce = /*#__PURE__*/ function(ForgeMetricsDataType) {
    ForgeMetricsDataType["Category"] = "CATEGORY";
    ForgeMetricsDataType["DateTime"] = "DATE_TIME";
    ForgeMetricsDataType["Numeric"] = "NUMERIC";
    return ForgeMetricsDataType;
}({});
let $5b8397cef71e8614$export$81745303cdddd39e = /*#__PURE__*/ function(ForgeMetricsGroupByDimensions) {
    ForgeMetricsGroupByDimensions["ContextAri"] = "CONTEXT_ARI";
    ForgeMetricsGroupByDimensions["EnvironmentId"] = "ENVIRONMENT_ID";
    ForgeMetricsGroupByDimensions["ErrorType"] = "ERROR_TYPE";
    ForgeMetricsGroupByDimensions["Function"] = "FUNCTION";
    ForgeMetricsGroupByDimensions["UserTier"] = "USER_TIER";
    ForgeMetricsGroupByDimensions["Version"] = "VERSION";
    return ForgeMetricsGroupByDimensions;
}({});
let $5b8397cef71e8614$export$2afbe872edd7ae25 = /*#__PURE__*/ function(ForgeMetricsLabels) {
    ForgeMetricsLabels["ForgeApiRequestCount"] = "FORGE_API_REQUEST_COUNT";
    ForgeMetricsLabels["ForgeApiRequestLatency"] = "FORGE_API_REQUEST_LATENCY";
    ForgeMetricsLabels["ForgeBackendInvocationCount"] = "FORGE_BACKEND_INVOCATION_COUNT";
    ForgeMetricsLabels["ForgeBackendInvocationErrors"] = "FORGE_BACKEND_INVOCATION_ERRORS";
    ForgeMetricsLabels["ForgeBackendInvocationLatency"] = "FORGE_BACKEND_INVOCATION_LATENCY";
    return ForgeMetricsLabels;
}({});
let $5b8397cef71e8614$export$bf91b1fbb61e5286 = /*#__PURE__*/ function(ForgeMetricsResolutionUnit) {
    ForgeMetricsResolutionUnit["Hours"] = "HOURS";
    ForgeMetricsResolutionUnit["Minutes"] = "MINUTES";
    return ForgeMetricsResolutionUnit;
}({});
let $5b8397cef71e8614$export$923266f2817195b3 = /*#__PURE__*/ function(ForgeMetricsSiteFilterCategory) {
    ForgeMetricsSiteFilterCategory["All"] = "ALL";
    ForgeMetricsSiteFilterCategory["HighestInvocationCount"] = "HIGHEST_INVOCATION_COUNT";
    ForgeMetricsSiteFilterCategory["HighestNumberOfErrors"] = "HIGHEST_NUMBER_OF_ERRORS";
    ForgeMetricsSiteFilterCategory["HighestNumberOfUsers"] = "HIGHEST_NUMBER_OF_USERS";
    ForgeMetricsSiteFilterCategory["LowestSuccessRate"] = "LOWEST_SUCCESS_RATE";
    return ForgeMetricsSiteFilterCategory;
}({});
let $5b8397cef71e8614$export$fc8a1cc6d4fd1a88 = /*#__PURE__*/ function(FormStatus) {
    FormStatus["Approved"] = "APPROVED";
    FormStatus["Rejected"] = "REJECTED";
    FormStatus["Saved"] = "SAVED";
    FormStatus["Submitted"] = "SUBMITTED";
    return FormStatus;
}({});
let $5b8397cef71e8614$export$6dc536fb03c01261 = /*#__PURE__*/ function(FortifiedMetricsResolutionUnit) {
    FortifiedMetricsResolutionUnit["Hours"] = "HOURS";
    FortifiedMetricsResolutionUnit["Minutes"] = "MINUTES";
    return FortifiedMetricsResolutionUnit;
}({}); /** The data describing a function invocation. */  /** Which type of trigger */ 
let $5b8397cef71e8614$export$c11461c8b46bd7da = /*#__PURE__*/ function(FunctionTriggerType) {
    FunctionTriggerType["Frontend"] = "FRONTEND";
    FunctionTriggerType["Manual"] = "MANUAL";
    FunctionTriggerType["Product"] = "PRODUCT";
    FunctionTriggerType["Web"] = "WEB";
    return FunctionTriggerType;
}({}); /** Concrete version of MutationErrorExtension that does not include any extra fields */  /** Generic implementation of MutationResponse for responses that don't need any extra data */  /** Concrete version of QueryErrorExtension that does not include any extra fields */  /**
 * Card Creation fields.
 * Only getting used by "jsw-adapted-issue-create-trigger" package
 */ 
let $5b8397cef71e8614$export$7cf25e310e0549b9 = /*#__PURE__*/ function(GrantCheckProduct) {
    GrantCheckProduct["Compass"] = "COMPASS";
    GrantCheckProduct["Confluence"] = "CONFLUENCE";
    GrantCheckProduct["Jira"] = "JIRA";
    GrantCheckProduct["JiraServicedesk"] = "JIRA_SERVICEDESK";
    GrantCheckProduct["Mercury"] = "MERCURY";
    GrantCheckProduct["NoGrantChecks"] = "NO_GRANT_CHECKS";
    GrantCheckProduct["Townsquare"] = "TOWNSQUARE";
    return GrantCheckProduct;
}({}); /** Represents an ati:cloud:confluence:page. Returned by relationship queries */ 
let $5b8397cef71e8614$export$e257ff6d0ceabf65 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum) {
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedBuildJiraBuildOutputBuildStateEnum;
}({});
let $5b8397cef71e8614$export$d67cf8c91eee6c78 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum) {
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum;
}({});
let $5b8397cef71e8614$export$ee2e640b413dd384 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum) {
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Development"] = "DEVELOPMENT";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Production"] = "PRODUCTION";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Staging"] = "STAGING";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Testing"] = "TESTING";
    GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum["Unmapped"] = "UNMAPPED";
    return GraphCreateMetadataProjectAssociatedDeploymentJiraDeploymentOutputEnvironmentTypeEnum;
}({});
let $5b8397cef71e8614$export$c50c7062a9ebe6be = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum) {
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Merged"] = "MERGED";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputPullRequestStatusEnum;
}({});
let $5b8397cef71e8614$export$a79d08c6a74f2aa7 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum) {
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
    return GraphCreateMetadataProjectAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum;
}({});
let $5b8397cef71e8614$export$6f687fc24be8932d = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum) {
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum;
}({});
let $5b8397cef71e8614$export$49ff7d43116f0b34 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum) {
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum;
}({});
let $5b8397cef71e8614$export$e818e0de20808583 = /*#__PURE__*/ function(GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum) {
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Dast"] = "DAST";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Sast"] = "SAST";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Sca"] = "SCA";
    GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataProjectAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityTypeEnum;
}({});
let $5b8397cef71e8614$export$712746aa2988ba08 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum) {
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedBuildJiraBuildOutputBuildStateEnum;
}({});
let $5b8397cef71e8614$export$f69c5a9b8fd498a0 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum) {
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Failed"] = "FAILED";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Pending"] = "PENDING";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedDeploymentJiraDeploymentOutputDeploymentStateEnum;
}({});
let $5b8397cef71e8614$export$ae5cb07efff2d516 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum) {
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Merged"] = "MERGED";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputPullRequestStatusEnum;
}({});
let $5b8397cef71e8614$export$784f60349b367f9b = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum) {
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
    return GraphCreateMetadataSprintAssociatedPrJiraPullRequestOutputReviewerReviewerStatusEnum;
}({});
let $5b8397cef71e8614$export$e37d41f18a90ba53 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum) {
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilitySeverityEnum;
}({});
let $5b8397cef71e8614$export$f53fed6636725b64 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum) {
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["NotSet"] = "NOT_SET";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphCreateMetadataSprintAssociatedVulnerabilityJiraVulnerabilityOutputVulnerabilityStatusEnum;
}({});
let $5b8397cef71e8614$export$aa057f51e7ce3c82 = /*#__PURE__*/ function(GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum) {
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["Done"] = "DONE";
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["New"] = "NEW";
    GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphCreateMetadataSprintAssociatedVulnerabilityOutputStatusCategoryEnum;
}({});
let $5b8397cef71e8614$export$28a810288577486f = /*#__PURE__*/ function(GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum) {
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["Done"] = "DONE";
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["New"] = "NEW";
    GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphCreateMetadataSprintContainsIssueJiraIssueInputStatusCategoryEnum;
}({});
let $5b8397cef71e8614$export$f863dc0cdc1e6a3 = /*#__PURE__*/ function(GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum) {
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["Done"] = "DONE";
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["New"] = "NEW";
    GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphCreateMetadataSprintContainsIssueJiraIssueOutputStatusCategoryEnum;
}({}); /** Represents an Generic implementing the Node interface. */  /** Represents an Generic implementing the Node interface. */  /** Represents an ati:cloud:jira:issue. Returned by relationship queries */  /** Represents an ati:cloud:jira:post-incident-review-link implementing the Node interface. */  /** Represents an ati:cloud:jira:post-incident-review-link implementing the Node interface. */  /** Represents an ati:cloud:jira:project implementing the Node interface. */  /** Represents an ati:cloud:jira:security-container implementing the Node interface. */  /** Represents an ati:cloud:jira:sprint. Returned by relationship queries */  /** Represents an ati:cloud:jira:vulnerability implementing the Node interface. */ 
let $5b8397cef71e8614$export$506c56cd93325d6f = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum) {
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedBuildInputToBuildStateEnum;
}({});
let $5b8397cef71e8614$export$7ea6916b52f9a466 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum) {
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedDeploymentInputToDeploymentStateEnum;
}({});
let $5b8397cef71e8614$export$4a73bb7047a59c43 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum) {
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Development"] = "DEVELOPMENT";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Production"] = "PRODUCTION";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Staging"] = "STAGING";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Testing"] = "TESTING";
    GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum["Unmapped"] = "UNMAPPED";
    return GraphQueryMetadataProjectAssociatedDeploymentInputToEnvironmentTypeEnum;
}({});
let $5b8397cef71e8614$export$13841098b50a1391 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum) {
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Merged"] = "MERGED";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedPrInputToPullRequestStatusEnum;
}({});
let $5b8397cef71e8614$export$b79540fc1cf58152 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum) {
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
    return GraphQueryMetadataProjectAssociatedPrInputToReviewerReviewerStatusEnum;
}({});
let $5b8397cef71e8614$export$f73a51516debfebb = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum) {
    GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum["All"] = "ALL";
    GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum["Any"] = "ANY";
    GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum["None"] = "NONE";
    return GraphQueryMetadataProjectAssociatedPrInputToReviewermatchTypeEnum;
}({});
let $5b8397cef71e8614$export$ffa68ad6c069c08 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum) {
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilitySeverityEnum;
}({});
let $5b8397cef71e8614$export$d9c8a38d7a3c7cc8 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum) {
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityStatusEnum;
}({});
let $5b8397cef71e8614$export$5a8ffaaa2ad7aed0 = /*#__PURE__*/ function(GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum) {
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Dast"] = "DAST";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Sast"] = "SAST";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Sca"] = "SCA";
    GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataProjectAssociatedVulnerabilityInputToVulnerabilityTypeEnum;
}({});
let $5b8397cef71e8614$export$806eaced01bf01a = /*#__PURE__*/ function(GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum) {
    GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum["All"] = "ALL";
    GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum["Any"] = "ANY";
    GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum["None"] = "NONE";
    return GraphQueryMetadataProjectHasIssueInputRelationshipArimatchTypeEnum;
}({});
let $5b8397cef71e8614$export$6ca61b0e0124327a = /*#__PURE__*/ function(GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum) {
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilitySeverityEnum;
}({});
let $5b8397cef71e8614$export$f5a38573abf93209 = /*#__PURE__*/ function(GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum) {
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityStatusEnum;
}({});
let $5b8397cef71e8614$export$e78de564c39ba63a = /*#__PURE__*/ function(GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum) {
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Dast"] = "DAST";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Sast"] = "SAST";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Sca"] = "SCA";
    GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSecurityContainerAssociatedToVulnerabilityInputToVulnerabilityTypeEnum;
}({});
let $5b8397cef71e8614$export$84e173808cf3fbd = /*#__PURE__*/ function(GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum) {
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P1"] = "P1";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P2"] = "P2";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P3"] = "P3";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P4"] = "P4";
    GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum["P5"] = "P5";
    return GraphQueryMetadataServiceLinkedIncidentInputToJiraServiceManagementIncidentPriorityEnum;
}({});
let $5b8397cef71e8614$export$9b119abe5b87afc8 = /*#__PURE__*/ function(GraphQueryMetadataSortEnum) {
    GraphQueryMetadataSortEnum["Asc"] = "ASC";
    GraphQueryMetadataSortEnum["Desc"] = "DESC";
    return GraphQueryMetadataSortEnum;
}({});
let $5b8397cef71e8614$export$c4247d75f3bd62d6 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum) {
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedBuildInputToBuildStateEnum;
}({});
let $5b8397cef71e8614$export$251196d62f47dadc = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum) {
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Cancelled"] = "CANCELLED";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Failed"] = "FAILED";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["InProgress"] = "IN_PROGRESS";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Pending"] = "PENDING";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["RolledBack"] = "ROLLED_BACK";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Successful"] = "SUCCESSFUL";
    GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedDeploymentInputToDeploymentStateEnum;
}({});
let $5b8397cef71e8614$export$ecfd24ecd1c4c396 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum) {
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Development"] = "DEVELOPMENT";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Production"] = "PRODUCTION";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Staging"] = "STAGING";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Testing"] = "TESTING";
    GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum["Unmapped"] = "UNMAPPED";
    return GraphQueryMetadataSprintAssociatedDeploymentInputToEnvironmentTypeEnum;
}({});
let $5b8397cef71e8614$export$2b200e1b05f9a91 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum) {
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Declined"] = "DECLINED";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Merged"] = "MERGED";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedPrInputToPullRequestStatusEnum;
}({});
let $5b8397cef71e8614$export$3782643d0ae02abe = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum) {
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["Approved"] = "APPROVED";
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["Needswork"] = "NEEDSWORK";
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum["Unapproved"] = "UNAPPROVED";
    return GraphQueryMetadataSprintAssociatedPrInputToReviewerReviewerStatusEnum;
}({});
let $5b8397cef71e8614$export$522af156c9a19c25 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum) {
    GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum["All"] = "ALL";
    GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum["Any"] = "ANY";
    GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum["None"] = "NONE";
    return GraphQueryMetadataSprintAssociatedPrInputToReviewermatchTypeEnum;
}({});
let $5b8397cef71e8614$export$67557b0182f33b6 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum) {
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["Done"] = "DONE";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["New"] = "NEW";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphQueryMetadataSprintAssociatedVulnerabilityInputRelationshipStatusCategoryEnum;
}({});
let $5b8397cef71e8614$export$46a86c882ece79a0 = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum) {
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Critical"] = "CRITICAL";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["High"] = "HIGH";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Low"] = "LOW";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Medium"] = "MEDIUM";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilitySeverityEnum;
}({});
let $5b8397cef71e8614$export$7fc2bf7b37a3a03c = /*#__PURE__*/ function(GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum) {
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Closed"] = "CLOSED";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Ignored"] = "IGNORED";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["NotSet"] = "NOT_SET";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Open"] = "OPEN";
    GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum["Unknown"] = "UNKNOWN";
    return GraphQueryMetadataSprintAssociatedVulnerabilityInputToVulnerabilityStatusEnum;
}({});
let $5b8397cef71e8614$export$39763c846aa96176 = /*#__PURE__*/ function(GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum) {
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["Done"] = "DONE";
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["Indeterminate"] = "INDETERMINATE";
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["New"] = "NEW";
    GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum["Undefined"] = "UNDEFINED";
    return GraphQueryMetadataSprintContainsIssueInputToStatusCategoryEnum;
}({}); /** A relationship edge for the relationship type content-referenced-entity */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, CompassComponent] */  /** A relationship inner edge for the relationship type content-referenced-entity */  /** A node representing a content-referenced-entity relationship, with all metadata (if available) */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage] */  /** A relationship edge for the relationship type focus-area-associated-to-project */  /** A union of the possible hydration types for focus-area-associated-to-project: [DevOpsProjectDetails] */  /** A relationship inner edge for the relationship type focus-area-associated-to-project */  /** A node representing a focus-area-associated-to-project relationship, with all metadata (if available) */  /** A union of the possible hydration types for focus-area-associated-to-project: [MercuryFocusArea] */  /** A relationship edge for the relationship type focus-area-has-atlas-goal */  /** A union of the possible hydration types for focus-area-has-atlas-goal: [TownsquareGoal] */  /** A relationship inner edge for the relationship type focus-area-has-atlas-goal */  /** A node representing a focus-area-has-atlas-goal relationship, with all metadata (if available) */  /** A union of the possible hydration types for focus-area-has-atlas-goal: [MercuryFocusArea] */  /** A relationship edge for the relationship type focus-area-has-focus-area */  /** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */  /** A relationship inner edge for the relationship type focus-area-has-focus-area */  /** A node representing a focus-area-has-focus-area relationship, with all metadata (if available) */  /** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */  /** A relationship edge for the relationship type focus-area-has-project */  /** A union of the possible hydration types for focus-area-has-project: [TownsquareProject, JiraIssue] */  /** A relationship inner edge for the relationship type focus-area-has-project */  /** A node representing a focus-area-has-project relationship, with all metadata (if available) */  /** A union of the possible hydration types for focus-area-has-project: [MercuryFocusArea] */  /** A relationship edge for the relationship type incident-associated-post-incident-review */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A relationship inner edge for the relationship type incident-associated-post-incident-review */  /** A relationship edge for the relationship type incident-associated-post-incident-review-link */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, JiraPostIncidentReviewLink, DevOpsOperationsPostIncidentReviewDetails] */  /** A relationship inner edge for the relationship type incident-associated-post-incident-review-link */  /** A node representing a incident-associated-post-incident-review-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A node representing a incident-associated-post-incident-review relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A relationship edge for the relationship type incident-has-action-item */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue] */  /** A relationship inner edge for the relationship type incident-has-action-item */  /** A node representing a incident-has-action-item relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A relationship edge for the relationship type incident-linked-jsw-issue */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue] */  /** A relationship inner edge for the relationship type incident-linked-jsw-issue */  /** A node representing a incident-linked-jsw-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A relationship edge for the relationship type issue-associated-build */  /** A relationship inner edge for the relationship type issue-associated-build */  /** A node representing a issue-associated-build relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-build: [JiraIssue] */  /** A relationship edge for the relationship type issue-associated-deployment */  /** A union of the possible hydration types for issue-associated-deployment: [DeploymentSummary] */  /** A relationship inner edge for the relationship type issue-associated-deployment */  /** A node representing a issue-associated-deployment relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-deployment: [JiraIssue] */  /** A relationship edge for the relationship type issue-associated-issue-remote-link */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink] */  /** A relationship inner edge for the relationship type issue-associated-issue-remote-link */  /** A node representing a issue-associated-issue-remote-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssue] */  /** A relationship edge for the relationship type jsm-project-associated-service */  /** A union of the possible hydration types for jsm-project-associated-service: [DevOpsService] */  /** A relationship inner edge for the relationship type jsm-project-associated-service */  /** A node representing a jsm-project-associated-service relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsm-project-associated-service: [JiraProject] */  /** A relationship edge for the relationship type media-attached-to-content */  /** A union of the possible hydration types for media-attached-to-content: [JiraIssue, ConfluencePage] */  /** A relationship inner edge for the relationship type media-attached-to-content */  /** A node representing a media-attached-to-content relationship, with all metadata (if available) */  /** A relationship edge for the relationship type security-container-associated-to-vulnerability */  /** A union of the possible hydration types for security-container-associated-to-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A relationship inner edge for the relationship type security-container-associated-to-vulnerability */  /** A node representing a security-container-associated-to-vulnerability relationship, with all metadata (if available) */ 
let $5b8397cef71e8614$export$fb0f42f72b340ab0 = /*#__PURE__*/ function(GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput) {
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["NotSet"] = "NOT_SET";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P1"] = "P1";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P2"] = "P2";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P3"] = "P3";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P4"] = "P4";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["P5"] = "P5";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["Pending"] = "PENDING";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput["Unknown"] = "UNKNOWN";
    return GraphStoreCreateComponentImpactedByIncidentJiraIncidentPriorityInput;
}({});
let $5b8397cef71e8614$export$621f4c3ec3f34f6d = /*#__PURE__*/ function(GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput) {
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["Done"] = "DONE";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["Indeterminate"] = "INDETERMINATE";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["New"] = "NEW";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["NotSet"] = "NOT_SET";
    GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput["Undefined"] = "UNDEFINED";
    return GraphStoreCreateComponentImpactedByIncidentJiraIncidentStatusInput;
}({});
let $5b8397cef71e8614$export$2cb64a720d855b98 = /*#__PURE__*/ function(GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput) {
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Critical"] = "CRITICAL";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["High"] = "HIGH";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Low"] = "LOW";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Medium"] = "MEDIUM";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["NotSet"] = "NOT_SET";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput["Unknown"] = "UNKNOWN";
    return GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilitySeverityInput;
}({});
let $5b8397cef71e8614$export$996ea6ee34911f99 = /*#__PURE__*/ function(GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput) {
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Closed"] = "CLOSED";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Ignored"] = "IGNORED";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["NotSet"] = "NOT_SET";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Open"] = "OPEN";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput["Unknown"] = "UNKNOWN";
    return GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityStatusInput;
}({});
let $5b8397cef71e8614$export$7db5c45cbd7a8d6a = /*#__PURE__*/ function(GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput) {
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Dast"] = "DAST";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["NotSet"] = "NOT_SET";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Sast"] = "SAST";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Sca"] = "SCA";
    GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput["Unknown"] = "UNKNOWN";
    return GraphStoreCreateVulnerabilityAssociatedIssueVulnerabilityTypeInput;
}({}); /** A full relationship edge for the relationship type app-installation-associated-to-operations-workspace */  /** A node representing a app-installation-associated-to-operations-workspace relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type app-installation-associated-to-security-workspace */  /** A node representing a app-installation-associated-to-security-workspace relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type atlas-project-contributes-to-atlas-goal */  /** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareGoal] */  /** A node representing a atlas-project-contributes-to-atlas-goal relationship, with all metadata (if available) */  /** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareProject] */  /** A full relationship edge for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [JiraIssue] */  /** A node representing a atlas-project-is-tracked-on-jira-epic relationship, with all metadata (if available) */  /** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [TownsquareProject] */  /** A full relationship edge for the relationship type component-impacted-by-incident */  /** A union of the possible hydration types for component-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */ 
let $5b8397cef71e8614$export$9887284bd91c5bd3 = /*#__PURE__*/ function(GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput) {
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P1"] = "P1";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P2"] = "P2";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P3"] = "P3";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P4"] = "P4";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["P5"] = "P5";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["Pending"] = "PENDING";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullComponentImpactedByIncidentJiraIncidentPriorityOutput;
}({});
let $5b8397cef71e8614$export$753e474d0e2d3bcb = /*#__PURE__*/ function(GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput) {
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["Done"] = "DONE";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["New"] = "NEW";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullComponentImpactedByIncidentJiraIncidentStatusOutput;
}({}); /** A node representing a component-impacted-by-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for component-impacted-by-incident: [CompassComponent, DevOpsOperationsComponentDetails] */  /** A full relationship edge for the relationship type component-linked-jsw-issue */  /** A union of the possible hydration types for component-linked-jsw-issue: [JiraIssue] */  /** A node representing a component-linked-jsw-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for component-linked-jsw-issue: [CompassComponent, DevOpsService, DevOpsOperationsComponentDetails] */  /** A full relationship edge for the relationship type content-referenced-entity */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, CompassComponent] */  /** A node representing a content-referenced-entity relationship, with all metadata (if available) */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage] */  /** A full relationship edge for the relationship type incident-associated-post-incident-review */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A full relationship edge for the relationship type incident-associated-post-incident-review-link */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, JiraPostIncidentReviewLink, DevOpsOperationsPostIncidentReviewDetails] */  /** A node representing a incident-associated-post-incident-review-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A node representing a incident-associated-post-incident-review relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A full relationship edge for the relationship type incident-has-action-item */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue] */  /** A node representing a incident-has-action-item relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A full relationship edge for the relationship type incident-linked-jsw-issue */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue] */  /** A node representing a incident-linked-jsw-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A full relationship edge for the relationship type issue-associated-branch */  /** A node representing a issue-associated-branch relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-branch: [JiraIssue] */ 
let $5b8397cef71e8614$export$983eeb7eafc088a9 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedBuildBuildStateOutput) {
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Failed"] = "FAILED";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Pending"] = "PENDING";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullIssueAssociatedBuildBuildStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullIssueAssociatedBuildBuildStateOutput;
}({}); /** A full relationship edge for the relationship type issue-associated-build */  /** A node representing a issue-associated-build relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-build: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-commit */  /** A node representing a issue-associated-commit relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-commit: [JiraIssue] */ 
let $5b8397cef71e8614$export$6707759160f13c4c = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput) {
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Failed"] = "FAILED";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Pending"] = "PENDING";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["RolledBack"] = "ROLLED_BACK";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullIssueAssociatedDeploymentDeploymentStateOutput;
}({}); /** A full relationship edge for the relationship type issue-associated-deployment */  /** A union of the possible hydration types for issue-associated-deployment: [DeploymentSummary] */ 
let $5b8397cef71e8614$export$62f69bc9834c2852 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput) {
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Development"] = "DEVELOPMENT";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Production"] = "PRODUCTION";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Staging"] = "STAGING";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Testing"] = "TESTING";
    GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput["Unmapped"] = "UNMAPPED";
    return GraphStoreFullIssueAssociatedDeploymentEnvironmentTypeOutput;
}({}); /** A node representing a issue-associated-deployment relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-deployment: [JiraIssue] */ 
let $5b8397cef71e8614$export$a3ef183d8c6ea7f8 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedDesignDesignStatusOutput) {
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["None"] = "NONE";
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    GraphStoreFullIssueAssociatedDesignDesignStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullIssueAssociatedDesignDesignStatusOutput;
}({});
let $5b8397cef71e8614$export$e0814c7e8e75c569 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedDesignDesignTypeOutput) {
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Canvas"] = "CANVAS";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["File"] = "FILE";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Group"] = "GROUP";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Node"] = "NODE";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Other"] = "OTHER";
    GraphStoreFullIssueAssociatedDesignDesignTypeOutput["Prototype"] = "PROTOTYPE";
    return GraphStoreFullIssueAssociatedDesignDesignTypeOutput;
}({}); /** A full relationship edge for the relationship type issue-associated-design */  /** A union of the possible hydration types for issue-associated-design: [DevOpsDesign] */  /** A node representing a issue-associated-design relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-design: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-feature-flag */  /** A union of the possible hydration types for issue-associated-feature-flag: [DevOpsFeatureFlag] */  /** A node representing a issue-associated-feature-flag relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-feature-flag: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-issue-remote-link */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink] */ 
let $5b8397cef71e8614$export$f82857e2145c8247 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput) {
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Bamboo"] = "BAMBOO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["BbPrComment"] = "BB_PR_COMMENT";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["ConfluencePage"] = "CONFLUENCE_PAGE";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Jira"] = "JIRA";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Snyk"] = "SNYK";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["Trello"] = "TRELLO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput["WebLink"] = "WEB_LINK";
    return GraphStoreFullIssueAssociatedIssueRemoteLinkLinkApplicationTypeOutput;
}({});
let $5b8397cef71e8614$export$90175675ed9a274f = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput) {
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["AddedToIdea"] = "ADDED_TO_IDEA";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Blocks"] = "BLOCKS";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Causes"] = "CAUSES";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Clones"] = "CLONES";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["CreatedFrom"] = "CREATED_FROM";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Duplicates"] = "DUPLICATES";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Implements"] = "IMPLEMENTS";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsBlockedBy"] = "IS_BLOCKED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsCausedBy"] = "IS_CAUSED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsClonedBy"] = "IS_CLONED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsDuplicatedBy"] = "IS_DUPLICATED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsIdeaFor"] = "IS_IDEA_FOR";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsImplementedBy"] = "IS_IMPLEMENTED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["IsReviewedBy"] = "IS_REVIEWED_BY";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["MentionedIn"] = "MENTIONED_IN";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["MergedFrom"] = "MERGED_FROM";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["MergedInto"] = "MERGED_INTO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["RelatesTo"] = "RELATES_TO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["Reviews"] = "REVIEWS";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["SplitFrom"] = "SPLIT_FROM";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["SplitTo"] = "SPLIT_TO";
    GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput["WikiPage"] = "WIKI_PAGE";
    return GraphStoreFullIssueAssociatedIssueRemoteLinkLinkRelationshipOutput;
}({}); /** A node representing a issue-associated-issue-remote-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-pr */  /** A union of the possible hydration types for issue-associated-pr: [DevOpsPullRequestDetails] */  /** A node representing a issue-associated-pr relationship, with all metadata (if available) */ 
let $5b8397cef71e8614$export$947d4abb5daf138e = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedPrPullRequestStatusOutput) {
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Declined"] = "DECLINED";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Merged"] = "MERGED";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Open"] = "OPEN";
    GraphStoreFullIssueAssociatedPrPullRequestStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullIssueAssociatedPrPullRequestStatusOutput;
}({});
let $5b8397cef71e8614$export$e353d7be2a12f0f2 = /*#__PURE__*/ function(GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput) {
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["Approved"] = "APPROVED";
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["Needswork"] = "NEEDSWORK";
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput["Unapproved"] = "UNAPPROVED";
    return GraphStoreFullIssueAssociatedPrReviewerReviewerStatusOutput;
}({}); /** A union of the possible hydration types for issue-associated-pr: [JiraIssue] */  /** A full relationship edge for the relationship type issue-associated-remote-link */  /** A node representing a issue-associated-remote-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-associated-remote-link: [JiraIssue] */  /** A full relationship edge for the relationship type issue-changes-component */  /** A union of the possible hydration types for issue-changes-component: [CompassComponent] */  /** A node representing a issue-changes-component relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-changes-component: [JiraIssue] */  /** A full relationship edge for the relationship type issue-recursive-associated-pr */  /** A union of the possible hydration types for issue-recursive-associated-pr: [DevOpsPullRequestDetails] */  /** A node representing a issue-recursive-associated-pr relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-recursive-associated-pr: [JiraIssue] */  /** A full relationship edge for the relationship type issue-to-whiteboard */  /** A union of the possible hydration types for issue-to-whiteboard: [ConfluenceWhiteboard] */  /** A node representing a issue-to-whiteboard relationship, with all metadata (if available) */  /** A union of the possible hydration types for issue-to-whiteboard: [JiraIssue] */  /** A full relationship edge for the relationship type jira-epic-contributes-to-atlas-goal */  /** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [TownsquareGoal] */  /** A node representing a jira-epic-contributes-to-atlas-goal relationship, with all metadata (if available) */  /** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [JiraIssue] */  /** A full relationship edge for the relationship type jira-project-associated-atlas-goal */  /** A union of the possible hydration types for jira-project-associated-atlas-goal: [TownsquareGoal] */  /** A node representing a jira-project-associated-atlas-goal relationship, with all metadata (if available) */  /** A union of the possible hydration types for jira-project-associated-atlas-goal: [JiraProject] */  /** A full relationship edge for the relationship type jsm-project-associated-service */  /** A union of the possible hydration types for jsm-project-associated-service: [DevOpsService] */  /** A node representing a jsm-project-associated-service relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsm-project-associated-service: [JiraProject] */  /** A full relationship edge for the relationship type jsw-project-associated-component */  /** A union of the possible hydration types for jsw-project-associated-component: [DevOpsService, CompassComponent, DevOpsOperationsComponentDetails] */  /** A node representing a jsw-project-associated-component relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsw-project-associated-component: [JiraProject] */  /** A full relationship edge for the relationship type jsw-project-associated-incident */  /** A union of the possible hydration types for jsw-project-associated-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */ 
let $5b8397cef71e8614$export$e336ee68867d9184 = /*#__PURE__*/ function(GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput) {
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P1"] = "P1";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P2"] = "P2";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P3"] = "P3";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P4"] = "P4";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["P5"] = "P5";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["Pending"] = "PENDING";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullJswProjectAssociatedIncidentJiraIncidentPriorityOutput;
}({});
let $5b8397cef71e8614$export$8a57dccf86b2a6de = /*#__PURE__*/ function(GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput) {
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["Done"] = "DONE";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["New"] = "NEW";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullJswProjectAssociatedIncidentJiraIncidentStatusOutput;
}({}); /** A node representing a jsw-project-associated-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsw-project-associated-incident: [JiraProject] */  /** A full relationship edge for the relationship type jsw-project-shares-component-with-jsm-project */  /** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */  /** A node representing a jsw-project-shares-component-with-jsm-project relationship, with all metadata (if available) */  /** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */  /** A full relationship edge for the relationship type linked-project-has-version */  /** A union of the possible hydration types for linked-project-has-version: [JiraVersion] */  /** A node representing a linked-project-has-version relationship, with all metadata (if available) */  /** A union of the possible hydration types for linked-project-has-version: [JiraProject] */  /** A full relationship edge for the relationship type operations-container-impacted-by-incident */  /** A union of the possible hydration types for operations-container-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A node representing a operations-container-impacted-by-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for operations-container-impacted-by-incident: [DevOpsService] */  /** A full relationship edge for the relationship type operations-container-improved-by-action-item */  /** A union of the possible hydration types for operations-container-improved-by-action-item: [JiraIssue] */  /** A node representing a operations-container-improved-by-action-item relationship, with all metadata (if available) */  /** A union of the possible hydration types for operations-container-improved-by-action-item: [DevOpsService] */ 
let $5b8397cef71e8614$export$d781aa0d3a6bc4bd = /*#__PURE__*/ function(GraphStoreFullParentDocumentHasChildDocumentCategoryOutput) {
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Archive"] = "ARCHIVE";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Audio"] = "AUDIO";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Code"] = "CODE";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Document"] = "DOCUMENT";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Folder"] = "FOLDER";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Form"] = "FORM";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Image"] = "IMAGE";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["NotSet"] = "NOT_SET";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Other"] = "OTHER";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Pdf"] = "PDF";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Presentation"] = "PRESENTATION";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Shortcut"] = "SHORTCUT";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Spreadsheet"] = "SPREADSHEET";
    GraphStoreFullParentDocumentHasChildDocumentCategoryOutput["Video"] = "VIDEO";
    return GraphStoreFullParentDocumentHasChildDocumentCategoryOutput;
}({}); /** A full relationship edge for the relationship type parent-document-has-child-document */  /** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument] */  /** A node representing a parent-document-has-child-document relationship, with all metadata (if available) */  /** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument] */  /** A full relationship edge for the relationship type parent-issue-has-child-issue */  /** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */  /** A node representing a parent-issue-has-child-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */  /** A full relationship edge for the relationship type pr-in-repo */  /** A union of the possible hydration types for pr-in-repo: [DevOpsRepository] */  /** A node representing a pr-in-repo relationship, with all metadata (if available) */  /** A union of the possible hydration types for pr-in-repo: [DevOpsPullRequestDetails] */  /** A full relationship edge for the relationship type project-associated-branch */  /** A node representing a project-associated-branch relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-branch: [JiraProject] */ 
let $5b8397cef71e8614$export$12686f8906883b4d = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedBuildBuildStateOutput) {
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Failed"] = "FAILED";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Pending"] = "PENDING";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullProjectAssociatedBuildBuildStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedBuildBuildStateOutput;
}({}); /** A full relationship edge for the relationship type project-associated-build */  /** A node representing a project-associated-build relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-build: [JiraProject] */ 
let $5b8397cef71e8614$export$1a6794f56a498d8 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput) {
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Failed"] = "FAILED";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Pending"] = "PENDING";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["RolledBack"] = "ROLLED_BACK";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedDeploymentDeploymentStateOutput;
}({}); /** A full relationship edge for the relationship type project-associated-deployment */  /** A union of the possible hydration types for project-associated-deployment: [DeploymentSummary] */ 
let $5b8397cef71e8614$export$757f321f826d4b9f = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput) {
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Development"] = "DEVELOPMENT";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Production"] = "PRODUCTION";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Staging"] = "STAGING";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Testing"] = "TESTING";
    GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput["Unmapped"] = "UNMAPPED";
    return GraphStoreFullProjectAssociatedDeploymentEnvironmentTypeOutput;
}({}); /** A node representing a project-associated-deployment relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-deployment: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-feature-flag */  /** A union of the possible hydration types for project-associated-feature-flag: [DevOpsFeatureFlag] */  /** A node representing a project-associated-feature-flag relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-feature-flag: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-incident */  /** A union of the possible hydration types for project-associated-incident: [JiraIssue] */  /** A node representing a project-associated-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-incident: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-opsgenie-team */  /** A union of the possible hydration types for project-associated-opsgenie-team: [OpsgenieTeam] */  /** A node representing a project-associated-opsgenie-team relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-opsgenie-team: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-pr */  /** A union of the possible hydration types for project-associated-pr: [DevOpsPullRequestDetails] */  /** A node representing a project-associated-pr relationship, with all metadata (if available) */ 
let $5b8397cef71e8614$export$bed7454cabd50a99 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedPrPullRequestStatusOutput) {
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Declined"] = "DECLINED";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Merged"] = "MERGED";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Open"] = "OPEN";
    GraphStoreFullProjectAssociatedPrPullRequestStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedPrPullRequestStatusOutput;
}({});
let $5b8397cef71e8614$export$e0795a56969d3929 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput) {
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["Approved"] = "APPROVED";
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["Needswork"] = "NEEDSWORK";
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput["Unapproved"] = "UNAPPROVED";
    return GraphStoreFullProjectAssociatedPrReviewerReviewerStatusOutput;
}({}); /** A union of the possible hydration types for project-associated-pr: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-repo */  /** A union of the possible hydration types for project-associated-repo: [DevOpsRepository] */  /** A node representing a project-associated-repo relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-repo: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-service */  /** A union of the possible hydration types for project-associated-service: [DevOpsService] */  /** A node representing a project-associated-service relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-service: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-to-incident */  /** A union of the possible hydration types for project-associated-to-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A node representing a project-associated-to-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-to-incident: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-to-operations-container */  /** A union of the possible hydration types for project-associated-to-operations-container: [DevOpsService] */  /** A node representing a project-associated-to-operations-container relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-to-operations-container: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-to-security-container */  /** A node representing a project-associated-to-security-container relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-to-security-container: [JiraProject] */  /** A full relationship edge for the relationship type project-associated-vulnerability */  /** A union of the possible hydration types for project-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A node representing a project-associated-vulnerability relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-associated-vulnerability: [JiraProject] */ 
let $5b8397cef71e8614$export$c56f5d7588a02f34 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput) {
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedVulnerabilityVulnerabilitySeverityOutput;
}({});
let $5b8397cef71e8614$export$9406f481f6c79a5d = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput) {
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityStatusOutput;
}({});
let $5b8397cef71e8614$export$d307e59860de1336 = /*#__PURE__*/ function(GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput) {
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Dast"] = "DAST";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Sast"] = "SAST";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Sca"] = "SCA";
    GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullProjectAssociatedVulnerabilityVulnerabilityTypeOutput;
}({}); /** A full relationship edge for the relationship type project-disassociated-repo */  /** A union of the possible hydration types for project-disassociated-repo: [DevOpsRepository] */  /** A node representing a project-disassociated-repo relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-disassociated-repo: [JiraProject] */  /** A full relationship edge for the relationship type project-documentation-entity */  /** A union of the possible hydration types for project-documentation-entity: [ConfluenceSpace, ConfluencePage, DevOpsDocument] */  /** A node representing a project-documentation-entity relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-documentation-entity: [JiraProject] */  /** A full relationship edge for the relationship type project-documentation-page */  /** A union of the possible hydration types for project-documentation-page: [ConfluencePage] */  /** A node representing a project-documentation-page relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-documentation-page: [JiraProject] */  /** A full relationship edge for the relationship type project-documentation-space */  /** A union of the possible hydration types for project-documentation-space: [ConfluenceSpace] */  /** A node representing a project-documentation-space relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-documentation-space: [JiraProject] */  /** A full relationship edge for the relationship type project-explicitly-associated-repo */  /** A union of the possible hydration types for project-explicitly-associated-repo: [DevOpsRepository] */  /** A node representing a project-explicitly-associated-repo relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-explicitly-associated-repo: [JiraProject] */  /** A full relationship edge for the relationship type project-has-issue */  /** A union of the possible hydration types for project-has-issue: [JiraIssue] */  /** A node representing a project-has-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-has-issue: [JiraProject] */  /** A full relationship edge for the relationship type project-has-shared-version-with */  /** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */  /** A node representing a project-has-shared-version-with relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */  /** A full relationship edge for the relationship type project-has-version */  /** A union of the possible hydration types for project-has-version: [JiraVersion] */  /** A node representing a project-has-version relationship, with all metadata (if available) */  /** A union of the possible hydration types for project-has-version: [JiraProject] */  /** A full relationship edge for the relationship type security-container-associated-to-vulnerability */  /** A union of the possible hydration types for security-container-associated-to-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A node representing a security-container-associated-to-vulnerability relationship, with all metadata (if available) */ 
let $5b8397cef71e8614$export$ec0309648167c01f = /*#__PURE__*/ function(GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput) {
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilitySeverityOutput;
}({});
let $5b8397cef71e8614$export$55ab07a5fac6a121 = /*#__PURE__*/ function(GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput) {
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityStatusOutput;
}({});
let $5b8397cef71e8614$export$93214a30dc67e249 = /*#__PURE__*/ function(GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput) {
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Dast"] = "DAST";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Sast"] = "SAST";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Sca"] = "SCA";
    GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSecurityContainerAssociatedToVulnerabilityVulnerabilityTypeOutput;
}({}); /** A full relationship edge for the relationship type service-linked-incident */  /** A union of the possible hydration types for service-linked-incident: [JiraIssue] */ 
let $5b8397cef71e8614$export$cb34d20b583b9880 = /*#__PURE__*/ function(GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput) {
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P1"] = "P1";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P2"] = "P2";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P3"] = "P3";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P4"] = "P4";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput["P5"] = "P5";
    return GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentPriorityOutput;
}({});
let $5b8397cef71e8614$export$4f97d0efb46b21d7 = /*#__PURE__*/ function(GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput) {
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["Done"] = "DONE";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["New"] = "NEW";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullServiceLinkedIncidentJiraServiceManagementIncidentStatusOutput;
}({}); /** A node representing a service-linked-incident relationship, with all metadata (if available) */  /** A union of the possible hydration types for service-linked-incident: [DevOpsService] */ 
let $5b8397cef71e8614$export$1faf908d1ac6334b = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedBuildBuildStateOutput) {
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Failed"] = "FAILED";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Pending"] = "PENDING";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullSprintAssociatedBuildBuildStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedBuildBuildStateOutput;
}({}); /** A full relationship edge for the relationship type sprint-associated-build */  /** A node representing a sprint-associated-build relationship, with all metadata (if available) */ 
let $5b8397cef71e8614$export$5bab79a51fe84df7 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput) {
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Cancelled"] = "CANCELLED";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Failed"] = "FAILED";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["InProgress"] = "IN_PROGRESS";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Pending"] = "PENDING";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["RolledBack"] = "ROLLED_BACK";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Successful"] = "SUCCESSFUL";
    GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedDeploymentDeploymentStateOutput;
}({}); /** A full relationship edge for the relationship type sprint-associated-deployment */  /** A union of the possible hydration types for sprint-associated-deployment: [DeploymentSummary] */ 
let $5b8397cef71e8614$export$c8f81b6916886c13 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput) {
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Development"] = "DEVELOPMENT";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Production"] = "PRODUCTION";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Staging"] = "STAGING";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Testing"] = "TESTING";
    GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput["Unmapped"] = "UNMAPPED";
    return GraphStoreFullSprintAssociatedDeploymentEnvironmentTypeOutput;
}({}); /** A node representing a sprint-associated-deployment relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type sprint-associated-pr */  /** A union of the possible hydration types for sprint-associated-pr: [DevOpsPullRequestDetails] */  /** A node representing a sprint-associated-pr relationship, with all metadata (if available) */ 
let $5b8397cef71e8614$export$889f8821445073a8 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedPrPullRequestStatusOutput) {
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Declined"] = "DECLINED";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Merged"] = "MERGED";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Open"] = "OPEN";
    GraphStoreFullSprintAssociatedPrPullRequestStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedPrPullRequestStatusOutput;
}({});
let $5b8397cef71e8614$export$25d6205b4517999 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput) {
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["Approved"] = "APPROVED";
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["Needswork"] = "NEEDSWORK";
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput["Unapproved"] = "UNAPPROVED";
    return GraphStoreFullSprintAssociatedPrReviewerReviewerStatusOutput;
}({}); /** A full relationship edge for the relationship type sprint-associated-vulnerability */  /** A union of the possible hydration types for sprint-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A node representing a sprint-associated-vulnerability relationship, with all metadata (if available) */ 
let $5b8397cef71e8614$export$f128313c5c33553a = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput) {
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["Done"] = "DONE";
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["New"] = "NEW";
    GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullSprintAssociatedVulnerabilityStatusCategoryOutput;
}({});
let $5b8397cef71e8614$export$987cd4ea5561fc8e = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput) {
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedVulnerabilityVulnerabilitySeverityOutput;
}({});
let $5b8397cef71e8614$export$bf865dbaf78a8d95 = /*#__PURE__*/ function(GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput) {
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullSprintAssociatedVulnerabilityVulnerabilityStatusOutput;
}({}); /** A full relationship edge for the relationship type sprint-contains-issue */  /** A union of the possible hydration types for sprint-contains-issue: [JiraIssue] */  /** A node representing a sprint-contains-issue relationship, with all metadata (if available) */ 
let $5b8397cef71e8614$export$5296991171ff0fcb = /*#__PURE__*/ function(GraphStoreFullSprintContainsIssueStatusCategoryOutput) {
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["Done"] = "DONE";
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["Indeterminate"] = "INDETERMINATE";
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["New"] = "NEW";
    GraphStoreFullSprintContainsIssueStatusCategoryOutput["Undefined"] = "UNDEFINED";
    return GraphStoreFullSprintContainsIssueStatusCategoryOutput;
}({}); /** A full relationship edge for the relationship type sprint-retrospective-page */  /** A union of the possible hydration types for sprint-retrospective-page: [ConfluencePage] */  /** A node representing a sprint-retrospective-page relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type sprint-retrospective-whiteboard */  /** A union of the possible hydration types for sprint-retrospective-whiteboard: [ConfluenceWhiteboard] */  /** A node representing a sprint-retrospective-whiteboard relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type team-works-on-project */  /** A union of the possible hydration types for team-works-on-project: [JiraProject] */  /** A node representing a team-works-on-project relationship, with all metadata (if available) */  /** A full relationship edge for the relationship type version-associated-branch */  /** A node representing a version-associated-branch relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-branch: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-build */  /** A node representing a version-associated-build relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-build: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-commit */  /** A node representing a version-associated-commit relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-commit: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-deployment */  /** A union of the possible hydration types for version-associated-deployment: [DeploymentSummary] */  /** A node representing a version-associated-deployment relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-deployment: [JiraVersion] */ 
let $5b8397cef71e8614$export$50919f92f150f4c2 = /*#__PURE__*/ function(GraphStoreFullVersionAssociatedDesignDesignStatusOutput) {
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["None"] = "NONE";
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    GraphStoreFullVersionAssociatedDesignDesignStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullVersionAssociatedDesignDesignStatusOutput;
}({});
let $5b8397cef71e8614$export$a1b88d68d1f49808 = /*#__PURE__*/ function(GraphStoreFullVersionAssociatedDesignDesignTypeOutput) {
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Canvas"] = "CANVAS";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["File"] = "FILE";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Group"] = "GROUP";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Node"] = "NODE";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Other"] = "OTHER";
    GraphStoreFullVersionAssociatedDesignDesignTypeOutput["Prototype"] = "PROTOTYPE";
    return GraphStoreFullVersionAssociatedDesignDesignTypeOutput;
}({}); /** A full relationship edge for the relationship type version-associated-design */  /** A union of the possible hydration types for version-associated-design: [DevOpsDesign] */  /** A node representing a version-associated-design relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-design: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-feature-flag */  /** A union of the possible hydration types for version-associated-feature-flag: [DevOpsFeatureFlag] */  /** A node representing a version-associated-feature-flag relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-feature-flag: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-issue */  /** A union of the possible hydration types for version-associated-issue: [JiraIssue] */  /** A node representing a version-associated-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-issue: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-pull-request */  /** A union of the possible hydration types for version-associated-pull-request: [DevOpsPullRequestDetails] */  /** A node representing a version-associated-pull-request relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-pull-request: [JiraVersion] */  /** A full relationship edge for the relationship type version-associated-remote-link */  /** A node representing a version-associated-remote-link relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-associated-remote-link: [JiraVersion] */  /** A full relationship edge for the relationship type version-user-associated-feature-flag */  /** A union of the possible hydration types for version-user-associated-feature-flag: [DevOpsFeatureFlag] */  /** A node representing a version-user-associated-feature-flag relationship, with all metadata (if available) */  /** A union of the possible hydration types for version-user-associated-feature-flag: [JiraVersion] */  /** A full relationship edge for the relationship type vulnerability-associated-issue */  /** A union of the possible hydration types for vulnerability-associated-issue: [JiraIssue] */  /** A node representing a vulnerability-associated-issue relationship, with all metadata (if available) */  /** A union of the possible hydration types for vulnerability-associated-issue: [DevOpsSecurityVulnerabilityDetails] */ 
let $5b8397cef71e8614$export$fabcab228e2ed9c7 = /*#__PURE__*/ function(GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput) {
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Critical"] = "CRITICAL";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["High"] = "HIGH";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Low"] = "LOW";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Medium"] = "MEDIUM";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullVulnerabilityAssociatedIssueVulnerabilitySeverityOutput;
}({});
let $5b8397cef71e8614$export$6e4f0b0ee9bb1b2b = /*#__PURE__*/ function(GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput) {
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Closed"] = "CLOSED";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Ignored"] = "IGNORED";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Open"] = "OPEN";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityStatusOutput;
}({});
let $5b8397cef71e8614$export$4ec664baba8498fa = /*#__PURE__*/ function(GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput) {
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Dast"] = "DAST";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["NotSet"] = "NOT_SET";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Sast"] = "SAST";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Sca"] = "SCA";
    GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput["Unknown"] = "UNKNOWN";
    return GraphStoreFullVulnerabilityAssociatedIssueVulnerabilityTypeOutput;
}({});
let $5b8397cef71e8614$export$ca58efde64d86f94 = /*#__PURE__*/ function(GraphStoreIssueAssociatedDeploymentDeploymentState) {
    GraphStoreIssueAssociatedDeploymentDeploymentState["Cancelled"] = "CANCELLED";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Failed"] = "FAILED";
    GraphStoreIssueAssociatedDeploymentDeploymentState["InProgress"] = "IN_PROGRESS";
    GraphStoreIssueAssociatedDeploymentDeploymentState["NotSet"] = "NOT_SET";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Pending"] = "PENDING";
    GraphStoreIssueAssociatedDeploymentDeploymentState["RolledBack"] = "ROLLED_BACK";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Successful"] = "SUCCESSFUL";
    GraphStoreIssueAssociatedDeploymentDeploymentState["Unknown"] = "UNKNOWN";
    return GraphStoreIssueAssociatedDeploymentDeploymentState;
}({});
let $5b8397cef71e8614$export$3ad8a7711584b9be = /*#__PURE__*/ function(GraphStoreIssueAssociatedDeploymentEnvironmentType) {
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["NotSet"] = "NOT_SET";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Production"] = "PRODUCTION";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Staging"] = "STAGING";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Testing"] = "TESTING";
    GraphStoreIssueAssociatedDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
    return GraphStoreIssueAssociatedDeploymentEnvironmentType;
}({}); /** Conditional selection for filter field of issue-associated-deployment relationship queries */  /** Conditional selection for filter field of jsw-project-associated-incident relationship queries */ 
let $5b8397cef71e8614$export$a79c5b827301ce70 = /*#__PURE__*/ function(GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority) {
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["NotSet"] = "NOT_SET";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P1"] = "P1";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P2"] = "P2";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P3"] = "P3";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P4"] = "P4";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["P5"] = "P5";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["Pending"] = "PENDING";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority["Unknown"] = "UNKNOWN";
    return GraphStoreJswProjectAssociatedIncidentJiraIncidentPriority;
}({});
let $5b8397cef71e8614$export$bb923b67e7b3c5a3 = /*#__PURE__*/ function(GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus) {
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["Done"] = "DONE";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["Indeterminate"] = "INDETERMINATE";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["New"] = "NEW";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["NotSet"] = "NOT_SET";
    GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus["Undefined"] = "UNDEFINED";
    return GraphStoreJswProjectAssociatedIncidentJiraIncidentStatus;
}({});
let $5b8397cef71e8614$export$f153746befb8db60 = /*#__PURE__*/ function(GraphStoreProjectAssociatedBuildBuildState) {
    GraphStoreProjectAssociatedBuildBuildState["Cancelled"] = "CANCELLED";
    GraphStoreProjectAssociatedBuildBuildState["Failed"] = "FAILED";
    GraphStoreProjectAssociatedBuildBuildState["InProgress"] = "IN_PROGRESS";
    GraphStoreProjectAssociatedBuildBuildState["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedBuildBuildState["Pending"] = "PENDING";
    GraphStoreProjectAssociatedBuildBuildState["Successful"] = "SUCCESSFUL";
    GraphStoreProjectAssociatedBuildBuildState["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedBuildBuildState;
}({}); /** Conditional selection for filter field of project-associated-build relationship queries */ 
let $5b8397cef71e8614$export$3d406ab6bd989229 = /*#__PURE__*/ function(GraphStoreProjectAssociatedDeploymentDeploymentState) {
    GraphStoreProjectAssociatedDeploymentDeploymentState["Cancelled"] = "CANCELLED";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Failed"] = "FAILED";
    GraphStoreProjectAssociatedDeploymentDeploymentState["InProgress"] = "IN_PROGRESS";
    GraphStoreProjectAssociatedDeploymentDeploymentState["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Pending"] = "PENDING";
    GraphStoreProjectAssociatedDeploymentDeploymentState["RolledBack"] = "ROLLED_BACK";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Successful"] = "SUCCESSFUL";
    GraphStoreProjectAssociatedDeploymentDeploymentState["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedDeploymentDeploymentState;
}({});
let $5b8397cef71e8614$export$1e042c9b11303649 = /*#__PURE__*/ function(GraphStoreProjectAssociatedDeploymentEnvironmentType) {
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Production"] = "PRODUCTION";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Staging"] = "STAGING";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Testing"] = "TESTING";
    GraphStoreProjectAssociatedDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
    return GraphStoreProjectAssociatedDeploymentEnvironmentType;
}({}); /** Conditional selection for filter field of project-associated-deployment relationship queries */  /** Conditional selection for filter field of project-associated-pr relationship queries */ 
let $5b8397cef71e8614$export$4d0f434df5bd5f5d = /*#__PURE__*/ function(GraphStoreProjectAssociatedPrPullRequestStatus) {
    GraphStoreProjectAssociatedPrPullRequestStatus["Declined"] = "DECLINED";
    GraphStoreProjectAssociatedPrPullRequestStatus["Merged"] = "MERGED";
    GraphStoreProjectAssociatedPrPullRequestStatus["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedPrPullRequestStatus["Open"] = "OPEN";
    GraphStoreProjectAssociatedPrPullRequestStatus["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedPrPullRequestStatus;
}({});
let $5b8397cef71e8614$export$7b819b5db45ec714 = /*#__PURE__*/ function(GraphStoreProjectAssociatedPrReviewerReviewerStatus) {
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["Approved"] = "APPROVED";
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["Needswork"] = "NEEDSWORK";
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedPrReviewerReviewerStatus["Unapproved"] = "UNAPPROVED";
    return GraphStoreProjectAssociatedPrReviewerReviewerStatus;
}({}); /** Conditional selection for filter field of project-associated-repo relationship queries */  /** Conditional selection for filter field of project-associated-vulnerability relationship queries */ 
let $5b8397cef71e8614$export$8960ee08b61499ff = /*#__PURE__*/ function(GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity) {
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Critical"] = "CRITICAL";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["High"] = "HIGH";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Low"] = "LOW";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Medium"] = "MEDIUM";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedVulnerabilityVulnerabilitySeverity;
}({});
let $5b8397cef71e8614$export$4079472ae478c8b5 = /*#__PURE__*/ function(GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus) {
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Closed"] = "CLOSED";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Ignored"] = "IGNORED";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Open"] = "OPEN";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedVulnerabilityVulnerabilityStatus;
}({});
let $5b8397cef71e8614$export$52c8ce54b5f1ece6 = /*#__PURE__*/ function(GraphStoreProjectAssociatedVulnerabilityVulnerabilityType) {
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Dast"] = "DAST";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["NotSet"] = "NOT_SET";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Sast"] = "SAST";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Sca"] = "SCA";
    GraphStoreProjectAssociatedVulnerabilityVulnerabilityType["Unknown"] = "UNKNOWN";
    return GraphStoreProjectAssociatedVulnerabilityVulnerabilityType;
}({}); /** Conditional selection for filter field of project-has-issue relationship queries */  /** Conditional selection for filter field of service-linked-incident relationship queries */ 
let $5b8397cef71e8614$export$50ace2d33df76dc8 = /*#__PURE__*/ function(GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority) {
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["NotSet"] = "NOT_SET";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P1"] = "P1";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P2"] = "P2";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P3"] = "P3";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P4"] = "P4";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority["P5"] = "P5";
    return GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentPriority;
}({});
let $5b8397cef71e8614$export$b9597115770809a4 = /*#__PURE__*/ function(GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus) {
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["Done"] = "DONE";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["Indeterminate"] = "INDETERMINATE";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["New"] = "NEW";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["NotSet"] = "NOT_SET";
    GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus["Undefined"] = "UNDEFINED";
    return GraphStoreServiceLinkedIncidentJiraServiceManagementIncidentStatus;
}({}); /** A simplified connection for the relationship type atlas-project-contributes-to-atlas-goal */  /** A simplified edge for the relationship type atlas-project-contributes-to-atlas-goal */  /** A simplified connection for the relationship type atlas-project-contributes-to-atlas-goal */  /** A simplified edge for the relationship type atlas-project-contributes-to-atlas-goal */  /** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareProject] */  /** A union of the possible hydration types for atlas-project-contributes-to-atlas-goal: [TownsquareGoal] */  /** A simplified connection for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A simplified edge for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A simplified connection for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A simplified edge for the relationship type atlas-project-is-tracked-on-jira-epic */  /** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [TownsquareProject] */  /** A union of the possible hydration types for atlas-project-is-tracked-on-jira-epic: [JiraIssue] */  /** A simplified connection for the relationship type component-impacted-by-incident */  /** A simplified edge for the relationship type component-impacted-by-incident */  /** A simplified connection for the relationship type component-impacted-by-incident */  /** A simplified edge for the relationship type component-impacted-by-incident */  /** A union of the possible hydration types for component-impacted-by-incident: [CompassComponent, DevOpsOperationsComponentDetails] */  /** A union of the possible hydration types for component-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A simplified connection for the relationship type component-link-is-jira-project */  /** A simplified edge for the relationship type component-link-is-jira-project */  /** A union of the possible hydration types for component-link-is-jira-project: [JiraProject] */  /** A simplified connection for the relationship type component-linked-jsw-issue */  /** A simplified edge for the relationship type component-linked-jsw-issue */  /** A simplified connection for the relationship type component-linked-jsw-issue */  /** A simplified edge for the relationship type component-linked-jsw-issue */  /** A union of the possible hydration types for component-linked-jsw-issue: [CompassComponent, DevOpsService, DevOpsOperationsComponentDetails] */  /** A union of the possible hydration types for component-linked-jsw-issue: [JiraIssue] */  /** A simplified connection for the relationship type content-referenced-entity */  /** A simplified edge for the relationship type content-referenced-entity */  /** A simplified connection for the relationship type content-referenced-entity */  /** A simplified edge for the relationship type content-referenced-entity */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage] */  /** A union of the possible hydration types for content-referenced-entity: [JiraIssue, ConfluencePage, CompassComponent] */  /** A simplified connection for the relationship type focus-area-associated-to-project */  /** A simplified edge for the relationship type focus-area-associated-to-project */  /** A simplified connection for the relationship type focus-area-associated-to-project */  /** A simplified edge for the relationship type focus-area-associated-to-project */  /** A union of the possible hydration types for focus-area-associated-to-project: [MercuryFocusArea] */  /** A union of the possible hydration types for focus-area-associated-to-project: [DevOpsProjectDetails] */  /** A simplified connection for the relationship type focus-area-has-atlas-goal */  /** A simplified edge for the relationship type focus-area-has-atlas-goal */  /** A simplified connection for the relationship type focus-area-has-atlas-goal */  /** A simplified edge for the relationship type focus-area-has-atlas-goal */  /** A union of the possible hydration types for focus-area-has-atlas-goal: [MercuryFocusArea] */  /** A union of the possible hydration types for focus-area-has-atlas-goal: [TownsquareGoal] */  /** A simplified connection for the relationship type focus-area-has-focus-area */  /** A simplified edge for the relationship type focus-area-has-focus-area */  /** A simplified connection for the relationship type focus-area-has-focus-area */  /** A simplified edge for the relationship type focus-area-has-focus-area */  /** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */  /** A union of the possible hydration types for focus-area-has-focus-area: [MercuryFocusArea] */  /** A simplified connection for the relationship type focus-area-has-project */  /** A simplified edge for the relationship type focus-area-has-project */  /** A simplified connection for the relationship type focus-area-has-project */  /** A simplified edge for the relationship type focus-area-has-project */  /** A union of the possible hydration types for focus-area-has-project: [MercuryFocusArea] */  /** A union of the possible hydration types for focus-area-has-project: [TownsquareProject, JiraIssue] */  /** A simplified connection for the relationship type incident-associated-post-incident-review */  /** A simplified edge for the relationship type incident-associated-post-incident-review */  /** A simplified connection for the relationship type incident-associated-post-incident-review */  /** A simplified edge for the relationship type incident-associated-post-incident-review */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A simplified connection for the relationship type incident-associated-post-incident-review-link */  /** A simplified edge for the relationship type incident-associated-post-incident-review-link */  /** A simplified connection for the relationship type incident-associated-post-incident-review-link */  /** A simplified edge for the relationship type incident-associated-post-incident-review-link */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A union of the possible hydration types for incident-associated-post-incident-review-link: [JiraIssue, JiraPostIncidentReviewLink, DevOpsOperationsPostIncidentReviewDetails] */  /** A union of the possible hydration types for incident-associated-post-incident-review: [JiraIssue] */  /** A simplified connection for the relationship type incident-has-action-item */  /** A simplified edge for the relationship type incident-has-action-item */  /** A simplified connection for the relationship type incident-has-action-item */  /** A simplified edge for the relationship type incident-has-action-item */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A union of the possible hydration types for incident-has-action-item: [JiraIssue] */  /** A simplified connection for the relationship type incident-linked-jsw-issue */  /** A simplified edge for the relationship type incident-linked-jsw-issue */  /** A simplified connection for the relationship type incident-linked-jsw-issue */  /** A simplified edge for the relationship type incident-linked-jsw-issue */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A union of the possible hydration types for incident-linked-jsw-issue: [JiraIssue] */  /** A simplified connection for the relationship type issue-associated-branch */  /** A simplified edge for the relationship type issue-associated-branch */  /** A union of the possible hydration types for issue-associated-branch: [JiraIssue] */  /** A simplified connection for the relationship type issue-associated-build */  /** A simplified edge for the relationship type issue-associated-build */  /** A union of the possible hydration types for issue-associated-build: [JiraIssue] */  /** A simplified connection for the relationship type issue-associated-commit */  /** A simplified edge for the relationship type issue-associated-commit */  /** A union of the possible hydration types for issue-associated-commit: [JiraIssue] */  /** A simplified connection for the relationship type issue-associated-deployment */  /** A simplified edge for the relationship type issue-associated-deployment */  /** A simplified connection for the relationship type issue-associated-deployment */  /** A simplified edge for the relationship type issue-associated-deployment */  /** A union of the possible hydration types for issue-associated-deployment: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type issue-associated-design */  /** A simplified edge for the relationship type issue-associated-design */  /** A simplified connection for the relationship type issue-associated-design */  /** A simplified edge for the relationship type issue-associated-design */  /** A union of the possible hydration types for issue-associated-design: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-design: [DevOpsDesign] */  /** A simplified connection for the relationship type issue-associated-feature-flag */  /** A simplified edge for the relationship type issue-associated-feature-flag */  /** A simplified connection for the relationship type issue-associated-feature-flag */  /** A simplified edge for the relationship type issue-associated-feature-flag */  /** A union of the possible hydration types for issue-associated-feature-flag: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-feature-flag: [DevOpsFeatureFlag] */  /** A simplified connection for the relationship type issue-associated-issue-remote-link */  /** A simplified edge for the relationship type issue-associated-issue-remote-link */  /** A simplified connection for the relationship type issue-associated-issue-remote-link */  /** A simplified edge for the relationship type issue-associated-issue-remote-link */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-issue-remote-link: [JiraIssueRemoteIssueLink, JiraConfluenceRemoteIssueLink, JiraWebRemoteIssueLink, JiraCustomRemoteIssueLink] */  /** A simplified connection for the relationship type issue-associated-pr */  /** A simplified edge for the relationship type issue-associated-pr */  /** A simplified connection for the relationship type issue-associated-pr */  /** A simplified edge for the relationship type issue-associated-pr */  /** A union of the possible hydration types for issue-associated-pr: [JiraIssue] */  /** A union of the possible hydration types for issue-associated-pr: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type issue-associated-remote-link */  /** A simplified edge for the relationship type issue-associated-remote-link */  /** A union of the possible hydration types for issue-associated-remote-link: [JiraIssue] */  /** A simplified connection for the relationship type issue-changes-component */  /** A simplified edge for the relationship type issue-changes-component */  /** A simplified connection for the relationship type issue-changes-component */  /** A simplified edge for the relationship type issue-changes-component */  /** A union of the possible hydration types for issue-changes-component: [JiraIssue] */  /** A union of the possible hydration types for issue-changes-component: [CompassComponent] */  /** A simplified connection for the relationship type issue-recursive-associated-pr */  /** A simplified edge for the relationship type issue-recursive-associated-pr */  /** A simplified connection for the relationship type issue-recursive-associated-pr */  /** A simplified edge for the relationship type issue-recursive-associated-pr */  /** A union of the possible hydration types for issue-recursive-associated-pr: [JiraIssue] */  /** A union of the possible hydration types for issue-recursive-associated-pr: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type issue-to-whiteboard */  /** A simplified edge for the relationship type issue-to-whiteboard */  /** A simplified connection for the relationship type issue-to-whiteboard */  /** A simplified edge for the relationship type issue-to-whiteboard */  /** A union of the possible hydration types for issue-to-whiteboard: [JiraIssue] */  /** A union of the possible hydration types for issue-to-whiteboard: [ConfluenceWhiteboard] */  /** A simplified connection for the relationship type jira-epic-contributes-to-atlas-goal */  /** A simplified edge for the relationship type jira-epic-contributes-to-atlas-goal */  /** A simplified connection for the relationship type jira-epic-contributes-to-atlas-goal */  /** A simplified edge for the relationship type jira-epic-contributes-to-atlas-goal */  /** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [JiraIssue] */  /** A union of the possible hydration types for jira-epic-contributes-to-atlas-goal: [TownsquareGoal] */  /** A simplified connection for the relationship type jira-project-associated-atlas-goal */  /** A simplified edge for the relationship type jira-project-associated-atlas-goal */  /** A simplified connection for the relationship type jira-project-associated-atlas-goal */  /** A simplified edge for the relationship type jira-project-associated-atlas-goal */  /** A union of the possible hydration types for jira-project-associated-atlas-goal: [JiraProject] */  /** A union of the possible hydration types for jira-project-associated-atlas-goal: [TownsquareGoal] */  /** A simplified connection for the relationship type jsm-project-associated-service */  /** A simplified edge for the relationship type jsm-project-associated-service */  /** A simplified connection for the relationship type jsm-project-associated-service */  /** A simplified edge for the relationship type jsm-project-associated-service */  /** A union of the possible hydration types for jsm-project-associated-service: [JiraProject] */  /** A union of the possible hydration types for jsm-project-associated-service: [DevOpsService] */  /** A simplified connection for the relationship type jsw-project-associated-component */  /** A simplified edge for the relationship type jsw-project-associated-component */  /** A simplified connection for the relationship type jsw-project-associated-component */  /** A simplified edge for the relationship type jsw-project-associated-component */  /** A union of the possible hydration types for jsw-project-associated-component: [JiraProject] */  /** A union of the possible hydration types for jsw-project-associated-component: [DevOpsService, CompassComponent, DevOpsOperationsComponentDetails] */  /** A simplified connection for the relationship type jsw-project-associated-incident */  /** A simplified edge for the relationship type jsw-project-associated-incident */  /** A simplified connection for the relationship type jsw-project-associated-incident */  /** A simplified edge for the relationship type jsw-project-associated-incident */  /** A union of the possible hydration types for jsw-project-associated-incident: [JiraProject] */  /** A union of the possible hydration types for jsw-project-associated-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A simplified connection for the relationship type jsw-project-shares-component-with-jsm-project */  /** A simplified edge for the relationship type jsw-project-shares-component-with-jsm-project */  /** A simplified connection for the relationship type jsw-project-shares-component-with-jsm-project */  /** A simplified edge for the relationship type jsw-project-shares-component-with-jsm-project */  /** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */  /** A union of the possible hydration types for jsw-project-shares-component-with-jsm-project: [JiraProject] */  /** A simplified connection for the relationship type linked-project-has-version */  /** A simplified edge for the relationship type linked-project-has-version */  /** A simplified connection for the relationship type linked-project-has-version */  /** A simplified edge for the relationship type linked-project-has-version */  /** A union of the possible hydration types for linked-project-has-version: [JiraProject] */  /** A union of the possible hydration types for linked-project-has-version: [JiraVersion] */  /** A simplified connection for the relationship type media-attached-to-content */  /** A simplified edge for the relationship type media-attached-to-content */  /** A union of the possible hydration types for media-attached-to-content: [JiraIssue, ConfluencePage] */  /** A simplified connection for the relationship type operations-container-impacted-by-incident */  /** A simplified edge for the relationship type operations-container-impacted-by-incident */  /** A simplified connection for the relationship type operations-container-impacted-by-incident */  /** A simplified edge for the relationship type operations-container-impacted-by-incident */  /** A union of the possible hydration types for operations-container-impacted-by-incident: [DevOpsService] */  /** A union of the possible hydration types for operations-container-impacted-by-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A simplified connection for the relationship type operations-container-improved-by-action-item */  /** A simplified edge for the relationship type operations-container-improved-by-action-item */  /** A simplified connection for the relationship type operations-container-improved-by-action-item */  /** A simplified edge for the relationship type operations-container-improved-by-action-item */  /** A union of the possible hydration types for operations-container-improved-by-action-item: [DevOpsService] */  /** A union of the possible hydration types for operations-container-improved-by-action-item: [JiraIssue] */  /** A simplified connection for the relationship type parent-document-has-child-document */  /** A simplified edge for the relationship type parent-document-has-child-document */  /** A simplified connection for the relationship type parent-document-has-child-document */  /** A simplified edge for the relationship type parent-document-has-child-document */  /** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument] */  /** A union of the possible hydration types for parent-document-has-child-document: [DevOpsDocument] */  /** A simplified connection for the relationship type parent-issue-has-child-issue */  /** A simplified edge for the relationship type parent-issue-has-child-issue */  /** A simplified connection for the relationship type parent-issue-has-child-issue */  /** A simplified edge for the relationship type parent-issue-has-child-issue */  /** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */  /** A union of the possible hydration types for parent-issue-has-child-issue: [JiraIssue] */  /** A simplified connection for the relationship type pr-in-repo */  /** A simplified edge for the relationship type pr-in-repo */  /** A simplified connection for the relationship type pr-in-repo */  /** A simplified edge for the relationship type pr-in-repo */  /** A union of the possible hydration types for pr-in-repo: [DevOpsPullRequestDetails] */  /** A union of the possible hydration types for pr-in-repo: [DevOpsRepository] */  /** A simplified connection for the relationship type project-associated-branch */  /** A simplified edge for the relationship type project-associated-branch */  /** A union of the possible hydration types for project-associated-branch: [JiraProject] */  /** A simplified connection for the relationship type project-associated-build */  /** A simplified edge for the relationship type project-associated-build */  /** A union of the possible hydration types for project-associated-build: [JiraProject] */  /** A simplified connection for the relationship type project-associated-deployment */  /** A simplified edge for the relationship type project-associated-deployment */  /** A simplified connection for the relationship type project-associated-deployment */  /** A simplified edge for the relationship type project-associated-deployment */  /** A union of the possible hydration types for project-associated-deployment: [JiraProject] */  /** A union of the possible hydration types for project-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type project-associated-feature-flag */  /** A simplified edge for the relationship type project-associated-feature-flag */  /** A simplified connection for the relationship type project-associated-feature-flag */  /** A simplified edge for the relationship type project-associated-feature-flag */  /** A union of the possible hydration types for project-associated-feature-flag: [JiraProject] */  /** A union of the possible hydration types for project-associated-feature-flag: [DevOpsFeatureFlag] */  /** A simplified connection for the relationship type project-associated-incident */  /** A simplified edge for the relationship type project-associated-incident */  /** A simplified connection for the relationship type project-associated-incident */  /** A simplified edge for the relationship type project-associated-incident */  /** A union of the possible hydration types for project-associated-incident: [JiraProject] */  /** A union of the possible hydration types for project-associated-incident: [JiraIssue] */  /** A simplified connection for the relationship type project-associated-opsgenie-team */  /** A simplified edge for the relationship type project-associated-opsgenie-team */  /** A simplified connection for the relationship type project-associated-opsgenie-team */  /** A simplified edge for the relationship type project-associated-opsgenie-team */  /** A union of the possible hydration types for project-associated-opsgenie-team: [JiraProject] */  /** A union of the possible hydration types for project-associated-opsgenie-team: [OpsgenieTeam] */  /** A simplified connection for the relationship type project-associated-pr */  /** A simplified edge for the relationship type project-associated-pr */  /** A simplified connection for the relationship type project-associated-pr */  /** A simplified edge for the relationship type project-associated-pr */  /** A union of the possible hydration types for project-associated-pr: [JiraProject] */  /** A union of the possible hydration types for project-associated-pr: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type project-associated-repo */  /** A simplified edge for the relationship type project-associated-repo */  /** A simplified connection for the relationship type project-associated-repo */  /** A simplified edge for the relationship type project-associated-repo */  /** A union of the possible hydration types for project-associated-repo: [JiraProject] */  /** A union of the possible hydration types for project-associated-repo: [DevOpsRepository] */  /** A simplified connection for the relationship type project-associated-service */  /** A simplified edge for the relationship type project-associated-service */  /** A simplified connection for the relationship type project-associated-service */  /** A simplified edge for the relationship type project-associated-service */  /** A union of the possible hydration types for project-associated-service: [JiraProject] */  /** A union of the possible hydration types for project-associated-service: [DevOpsService] */  /** A simplified connection for the relationship type project-associated-to-incident */  /** A simplified edge for the relationship type project-associated-to-incident */  /** A simplified connection for the relationship type project-associated-to-incident */  /** A simplified edge for the relationship type project-associated-to-incident */  /** A union of the possible hydration types for project-associated-to-incident: [JiraProject] */  /** A union of the possible hydration types for project-associated-to-incident: [JiraIssue, DevOpsOperationsIncidentDetails] */  /** A simplified connection for the relationship type project-associated-to-operations-container */  /** A simplified edge for the relationship type project-associated-to-operations-container */  /** A simplified connection for the relationship type project-associated-to-operations-container */  /** A simplified edge for the relationship type project-associated-to-operations-container */  /** A union of the possible hydration types for project-associated-to-operations-container: [JiraProject] */  /** A union of the possible hydration types for project-associated-to-operations-container: [DevOpsService] */  /** A simplified connection for the relationship type project-associated-to-security-container */  /** A simplified edge for the relationship type project-associated-to-security-container */  /** A union of the possible hydration types for project-associated-to-security-container: [JiraProject] */  /** A simplified connection for the relationship type project-associated-vulnerability */  /** A simplified edge for the relationship type project-associated-vulnerability */  /** A simplified connection for the relationship type project-associated-vulnerability */  /** A simplified edge for the relationship type project-associated-vulnerability */  /** A union of the possible hydration types for project-associated-vulnerability: [JiraProject] */  /** A union of the possible hydration types for project-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A simplified connection for the relationship type project-disassociated-repo */  /** A simplified edge for the relationship type project-disassociated-repo */  /** A simplified connection for the relationship type project-disassociated-repo */  /** A simplified edge for the relationship type project-disassociated-repo */  /** A union of the possible hydration types for project-disassociated-repo: [JiraProject] */  /** A union of the possible hydration types for project-disassociated-repo: [DevOpsRepository] */  /** A simplified connection for the relationship type project-documentation-entity */  /** A simplified edge for the relationship type project-documentation-entity */  /** A simplified connection for the relationship type project-documentation-entity */  /** A simplified edge for the relationship type project-documentation-entity */  /** A union of the possible hydration types for project-documentation-entity: [JiraProject] */  /** A union of the possible hydration types for project-documentation-entity: [ConfluenceSpace, ConfluencePage, DevOpsDocument] */  /** A simplified connection for the relationship type project-documentation-page */  /** A simplified edge for the relationship type project-documentation-page */  /** A simplified connection for the relationship type project-documentation-page */  /** A simplified edge for the relationship type project-documentation-page */  /** A union of the possible hydration types for project-documentation-page: [JiraProject] */  /** A union of the possible hydration types for project-documentation-page: [ConfluencePage] */  /** A simplified connection for the relationship type project-documentation-space */  /** A simplified edge for the relationship type project-documentation-space */  /** A simplified connection for the relationship type project-documentation-space */  /** A simplified edge for the relationship type project-documentation-space */  /** A union of the possible hydration types for project-documentation-space: [JiraProject] */  /** A union of the possible hydration types for project-documentation-space: [ConfluenceSpace] */  /** A simplified connection for the relationship type project-explicitly-associated-repo */  /** A simplified edge for the relationship type project-explicitly-associated-repo */  /** A simplified connection for the relationship type project-explicitly-associated-repo */  /** A simplified edge for the relationship type project-explicitly-associated-repo */  /** A union of the possible hydration types for project-explicitly-associated-repo: [JiraProject] */  /** A union of the possible hydration types for project-explicitly-associated-repo: [DevOpsRepository] */  /** A simplified connection for the relationship type project-has-issue */  /** A simplified edge for the relationship type project-has-issue */  /** A simplified connection for the relationship type project-has-issue */  /** A simplified edge for the relationship type project-has-issue */  /** A union of the possible hydration types for project-has-issue: [JiraProject] */  /** A union of the possible hydration types for project-has-issue: [JiraIssue] */  /** A simplified connection for the relationship type project-has-related-work-with-project */  /** A simplified edge for the relationship type project-has-related-work-with-project */  /** A simplified connection for the relationship type project-has-related-work-with-project */  /** A simplified edge for the relationship type project-has-related-work-with-project */  /** A union of the possible hydration types for project-has-related-work-with-project: [JiraProject] */  /** A union of the possible hydration types for project-has-related-work-with-project: [JiraProject] */  /** A simplified connection for the relationship type project-has-shared-version-with */  /** A simplified edge for the relationship type project-has-shared-version-with */  /** A simplified connection for the relationship type project-has-shared-version-with */  /** A simplified edge for the relationship type project-has-shared-version-with */  /** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */  /** A union of the possible hydration types for project-has-shared-version-with: [JiraProject] */  /** A simplified connection for the relationship type project-has-version */  /** A simplified edge for the relationship type project-has-version */  /** A simplified connection for the relationship type project-has-version */  /** A simplified edge for the relationship type project-has-version */  /** A union of the possible hydration types for project-has-version: [JiraProject] */  /** A union of the possible hydration types for project-has-version: [JiraVersion] */  /** A simplified connection for the relationship type project-linked-to-compass-component */  /** A simplified edge for the relationship type project-linked-to-compass-component */  /** A simplified connection for the relationship type project-linked-to-compass-component */  /** A simplified edge for the relationship type project-linked-to-compass-component */  /** A union of the possible hydration types for project-linked-to-compass-component: [JiraProject] */  /** A union of the possible hydration types for project-linked-to-compass-component: [CompassComponent] */  /** A simplified connection for the relationship type security-container-associated-to-vulnerability */  /** A simplified edge for the relationship type security-container-associated-to-vulnerability */  /** A union of the possible hydration types for security-container-associated-to-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A simplified connection for the relationship type service-associated-deployment */  /** A simplified edge for the relationship type service-associated-deployment */  /** A simplified connection for the relationship type service-associated-deployment */  /** A simplified edge for the relationship type service-associated-deployment */  /** A union of the possible hydration types for service-associated-deployment: [DevOpsService] */  /** A union of the possible hydration types for service-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type service-linked-incident */  /** A simplified edge for the relationship type service-linked-incident */  /** A simplified connection for the relationship type service-linked-incident */  /** A simplified edge for the relationship type service-linked-incident */  /** A union of the possible hydration types for service-linked-incident: [DevOpsService] */  /** A union of the possible hydration types for service-linked-incident: [JiraIssue] */  /** A simplified connection for the relationship type space-associated-with-project */  /** A simplified edge for the relationship type space-associated-with-project */  /** A simplified connection for the relationship type space-associated-with-project */  /** A simplified edge for the relationship type space-associated-with-project */  /** A union of the possible hydration types for space-associated-with-project: [ConfluenceSpace] */  /** A union of the possible hydration types for space-associated-with-project: [JiraProject] */  /** A simplified connection for the relationship type sprint-associated-deployment */  /** A simplified edge for the relationship type sprint-associated-deployment */  /** A union of the possible hydration types for sprint-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type sprint-associated-pr */  /** A simplified edge for the relationship type sprint-associated-pr */  /** A union of the possible hydration types for sprint-associated-pr: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type sprint-associated-vulnerability */  /** A simplified edge for the relationship type sprint-associated-vulnerability */  /** A union of the possible hydration types for sprint-associated-vulnerability: [DevOpsSecurityVulnerabilityDetails] */  /** A simplified connection for the relationship type sprint-contains-issue */  /** A simplified edge for the relationship type sprint-contains-issue */  /** A union of the possible hydration types for sprint-contains-issue: [JiraIssue] */  /** A simplified connection for the relationship type sprint-retrospective-page */  /** A simplified edge for the relationship type sprint-retrospective-page */  /** A union of the possible hydration types for sprint-retrospective-page: [ConfluencePage] */  /** A simplified connection for the relationship type sprint-retrospective-whiteboard */  /** A simplified edge for the relationship type sprint-retrospective-whiteboard */  /** A union of the possible hydration types for sprint-retrospective-whiteboard: [ConfluenceWhiteboard] */  /** A simplified connection for the relationship type team-owns-component */  /** A simplified edge for the relationship type team-owns-component */  /** A union of the possible hydration types for team-owns-component: [CompassComponent] */  /** A simplified connection for the relationship type team-works-on-project */  /** A simplified edge for the relationship type team-works-on-project */  /** A union of the possible hydration types for team-works-on-project: [JiraProject] */  /** A simplified connection for the relationship type user-owns-component */  /** A simplified edge for the relationship type user-owns-component */  /** A union of the possible hydration types for user-owns-component: [CompassComponent] */  /** A simplified connection for the relationship type version-associated-branch */  /** A simplified edge for the relationship type version-associated-branch */  /** A union of the possible hydration types for version-associated-branch: [JiraVersion] */  /** A simplified connection for the relationship type version-associated-build */  /** A simplified edge for the relationship type version-associated-build */  /** A union of the possible hydration types for version-associated-build: [JiraVersion] */  /** A simplified connection for the relationship type version-associated-commit */  /** A simplified edge for the relationship type version-associated-commit */  /** A union of the possible hydration types for version-associated-commit: [JiraVersion] */  /** A simplified connection for the relationship type version-associated-deployment */  /** A simplified edge for the relationship type version-associated-deployment */  /** A simplified connection for the relationship type version-associated-deployment */  /** A simplified edge for the relationship type version-associated-deployment */  /** A union of the possible hydration types for version-associated-deployment: [JiraVersion] */  /** A union of the possible hydration types for version-associated-deployment: [DeploymentSummary] */  /** A simplified connection for the relationship type version-associated-design */  /** A simplified edge for the relationship type version-associated-design */  /** A simplified connection for the relationship type version-associated-design */  /** A simplified edge for the relationship type version-associated-design */  /** A union of the possible hydration types for version-associated-design: [JiraVersion] */  /** A union of the possible hydration types for version-associated-design: [DevOpsDesign] */  /** A simplified connection for the relationship type version-associated-feature-flag */  /** A simplified edge for the relationship type version-associated-feature-flag */  /** A simplified connection for the relationship type version-associated-feature-flag */  /** A simplified edge for the relationship type version-associated-feature-flag */  /** A union of the possible hydration types for version-associated-feature-flag: [JiraVersion] */  /** A union of the possible hydration types for version-associated-feature-flag: [DevOpsFeatureFlag] */  /** A simplified connection for the relationship type version-associated-issue */  /** A simplified edge for the relationship type version-associated-issue */  /** A simplified connection for the relationship type version-associated-issue */  /** A simplified edge for the relationship type version-associated-issue */  /** A union of the possible hydration types for version-associated-issue: [JiraVersion] */  /** A union of the possible hydration types for version-associated-issue: [JiraIssue] */  /** A simplified connection for the relationship type version-associated-pull-request */  /** A simplified edge for the relationship type version-associated-pull-request */  /** A simplified connection for the relationship type version-associated-pull-request */  /** A simplified edge for the relationship type version-associated-pull-request */  /** A union of the possible hydration types for version-associated-pull-request: [JiraVersion] */  /** A union of the possible hydration types for version-associated-pull-request: [DevOpsPullRequestDetails] */  /** A simplified connection for the relationship type version-associated-remote-link */  /** A simplified edge for the relationship type version-associated-remote-link */  /** A union of the possible hydration types for version-associated-remote-link: [JiraVersion] */  /** A simplified connection for the relationship type version-user-associated-feature-flag */  /** A simplified edge for the relationship type version-user-associated-feature-flag */  /** A simplified connection for the relationship type version-user-associated-feature-flag */  /** A simplified edge for the relationship type version-user-associated-feature-flag */  /** A union of the possible hydration types for version-user-associated-feature-flag: [JiraVersion] */  /** A union of the possible hydration types for version-user-associated-feature-flag: [DevOpsFeatureFlag] */  /** A simplified connection for the relationship type vulnerability-associated-issue */  /** A simplified edge for the relationship type vulnerability-associated-issue */  /** A simplified connection for the relationship type vulnerability-associated-issue */  /** A simplified edge for the relationship type vulnerability-associated-issue */  /** A union of the possible hydration types for vulnerability-associated-issue: [DevOpsSecurityVulnerabilityDetails] */  /** A union of the possible hydration types for vulnerability-associated-issue: [JiraIssue] */ 
let $5b8397cef71e8614$export$f295a95cd0626a8f = /*#__PURE__*/ function(GraphStoreSprintAssociatedBuildBuildState) {
    GraphStoreSprintAssociatedBuildBuildState["Cancelled"] = "CANCELLED";
    GraphStoreSprintAssociatedBuildBuildState["Failed"] = "FAILED";
    GraphStoreSprintAssociatedBuildBuildState["InProgress"] = "IN_PROGRESS";
    GraphStoreSprintAssociatedBuildBuildState["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedBuildBuildState["Pending"] = "PENDING";
    GraphStoreSprintAssociatedBuildBuildState["Successful"] = "SUCCESSFUL";
    GraphStoreSprintAssociatedBuildBuildState["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedBuildBuildState;
}({}); /** Conditional selection for filter field of sprint-associated-build relationship queries */ 
let $5b8397cef71e8614$export$6df900849642cd1c = /*#__PURE__*/ function(GraphStoreSprintAssociatedDeploymentDeploymentState) {
    GraphStoreSprintAssociatedDeploymentDeploymentState["Cancelled"] = "CANCELLED";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Failed"] = "FAILED";
    GraphStoreSprintAssociatedDeploymentDeploymentState["InProgress"] = "IN_PROGRESS";
    GraphStoreSprintAssociatedDeploymentDeploymentState["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Pending"] = "PENDING";
    GraphStoreSprintAssociatedDeploymentDeploymentState["RolledBack"] = "ROLLED_BACK";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Successful"] = "SUCCESSFUL";
    GraphStoreSprintAssociatedDeploymentDeploymentState["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedDeploymentDeploymentState;
}({});
let $5b8397cef71e8614$export$9f4efa40f1a0faae = /*#__PURE__*/ function(GraphStoreSprintAssociatedDeploymentEnvironmentType) {
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Production"] = "PRODUCTION";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Staging"] = "STAGING";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Testing"] = "TESTING";
    GraphStoreSprintAssociatedDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
    return GraphStoreSprintAssociatedDeploymentEnvironmentType;
}({}); /** Conditional selection for filter field of sprint-associated-deployment relationship queries */  /** Conditional selection for filter field of sprint-associated-pr relationship queries */ 
let $5b8397cef71e8614$export$5ffbe3a12bdc5b6c = /*#__PURE__*/ function(GraphStoreSprintAssociatedPrPullRequestStatus) {
    GraphStoreSprintAssociatedPrPullRequestStatus["Declined"] = "DECLINED";
    GraphStoreSprintAssociatedPrPullRequestStatus["Merged"] = "MERGED";
    GraphStoreSprintAssociatedPrPullRequestStatus["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedPrPullRequestStatus["Open"] = "OPEN";
    GraphStoreSprintAssociatedPrPullRequestStatus["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedPrPullRequestStatus;
}({});
let $5b8397cef71e8614$export$b397a81d3b3345af = /*#__PURE__*/ function(GraphStoreSprintAssociatedPrReviewerReviewerStatus) {
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["Approved"] = "APPROVED";
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["Needswork"] = "NEEDSWORK";
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedPrReviewerReviewerStatus["Unapproved"] = "UNAPPROVED";
    return GraphStoreSprintAssociatedPrReviewerReviewerStatus;
}({}); /** Conditional selection for filter field of sprint-associated-vulnerability relationship queries */ 
let $5b8397cef71e8614$export$9ee1edc61daf0f8a = /*#__PURE__*/ function(GraphStoreSprintAssociatedVulnerabilityStatusCategory) {
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["Done"] = "DONE";
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["Indeterminate"] = "INDETERMINATE";
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["New"] = "NEW";
    GraphStoreSprintAssociatedVulnerabilityStatusCategory["Undefined"] = "UNDEFINED";
    return GraphStoreSprintAssociatedVulnerabilityStatusCategory;
}({});
let $5b8397cef71e8614$export$67d1797c0aa2ad19 = /*#__PURE__*/ function(GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity) {
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Critical"] = "CRITICAL";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["High"] = "HIGH";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Low"] = "LOW";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Medium"] = "MEDIUM";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedVulnerabilityVulnerabilitySeverity;
}({});
let $5b8397cef71e8614$export$e55dd9ead99d6d9f = /*#__PURE__*/ function(GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus) {
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Closed"] = "CLOSED";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Ignored"] = "IGNORED";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["NotSet"] = "NOT_SET";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Open"] = "OPEN";
    GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return GraphStoreSprintAssociatedVulnerabilityVulnerabilityStatus;
}({}); /** Conditional selection for filter field of sprint-contains-issue relationship queries */ 
let $5b8397cef71e8614$export$296e777b040fe873 = /*#__PURE__*/ function(GraphStoreSprintContainsIssueStatusCategory) {
    GraphStoreSprintContainsIssueStatusCategory["Done"] = "DONE";
    GraphStoreSprintContainsIssueStatusCategory["Indeterminate"] = "INDETERMINATE";
    GraphStoreSprintContainsIssueStatusCategory["New"] = "NEW";
    GraphStoreSprintContainsIssueStatusCategory["Undefined"] = "UNDEFINED";
    return GraphStoreSprintContainsIssueStatusCategory;
}({});
let $5b8397cef71e8614$export$318f148359ce1fb1 = /*#__PURE__*/ function(GraphStoreVersionAssociatedDesignDesignStatus) {
    GraphStoreVersionAssociatedDesignDesignStatus["None"] = "NONE";
    GraphStoreVersionAssociatedDesignDesignStatus["NotSet"] = "NOT_SET";
    GraphStoreVersionAssociatedDesignDesignStatus["ReadyForDevelopment"] = "READY_FOR_DEVELOPMENT";
    GraphStoreVersionAssociatedDesignDesignStatus["Unknown"] = "UNKNOWN";
    return GraphStoreVersionAssociatedDesignDesignStatus;
}({});
let $5b8397cef71e8614$export$c81e290110aa4fde = /*#__PURE__*/ function(GraphStoreVersionAssociatedDesignDesignType) {
    GraphStoreVersionAssociatedDesignDesignType["Canvas"] = "CANVAS";
    GraphStoreVersionAssociatedDesignDesignType["File"] = "FILE";
    GraphStoreVersionAssociatedDesignDesignType["Group"] = "GROUP";
    GraphStoreVersionAssociatedDesignDesignType["Node"] = "NODE";
    GraphStoreVersionAssociatedDesignDesignType["NotSet"] = "NOT_SET";
    GraphStoreVersionAssociatedDesignDesignType["Other"] = "OTHER";
    GraphStoreVersionAssociatedDesignDesignType["Prototype"] = "PROTOTYPE";
    return GraphStoreVersionAssociatedDesignDesignType;
}({}); /** Conditional selection for filter field of version-associated-design relationship queries */  /**
 * The context object provides essential insights into the users' current experience and operations.
 *
 * The supported product and subproduct keys can be found at https://hello.atlassian.net/wiki/spaces/ECON/pages/2339030895/App+Identifiers
 */ 
let $5b8397cef71e8614$export$b5409d01f4236473 = /*#__PURE__*/ function(GrowthUnifiedProfileAnchorType) {
    GrowthUnifiedProfileAnchorType["Pfm"] = "PFM";
    GrowthUnifiedProfileAnchorType["Seo"] = "SEO";
    return GrowthUnifiedProfileAnchorType;
}({}); /**
 * Channel type, this information will be extracted from the query parameters and other sources, such as ML
 * mapping file
 */ 
let $5b8397cef71e8614$export$d608f92bd278cb63 = /*#__PURE__*/ function(GrowthUnifiedProfileChannelName) {
    GrowthUnifiedProfileChannelName["Comarketing"] = "COMARKETING";
    GrowthUnifiedProfileChannelName["Direct"] = "DIRECT";
    GrowthUnifiedProfileChannelName["Email"] = "EMAIL";
    GrowthUnifiedProfileChannelName["EngagementEngine"] = "ENGAGEMENT_ENGINE";
    GrowthUnifiedProfileChannelName["InProductReferral"] = "IN_PRODUCT_REFERRAL";
    GrowthUnifiedProfileChannelName["Organic"] = "ORGANIC";
    GrowthUnifiedProfileChannelName["Other"] = "OTHER";
    GrowthUnifiedProfileChannelName["PaidAffiliate"] = "PAID_AFFILIATE";
    GrowthUnifiedProfileChannelName["PaidDisplay"] = "PAID_DISPLAY";
    GrowthUnifiedProfileChannelName["PaidReviewSites"] = "PAID_REVIEW_SITES";
    GrowthUnifiedProfileChannelName["PaidSearchBranded"] = "PAID_SEARCH_BRANDED";
    GrowthUnifiedProfileChannelName["PaidSearchNonBranded"] = "PAID_SEARCH_NON_BRANDED";
    GrowthUnifiedProfileChannelName["PaidSocial"] = "PAID_SOCIAL";
    GrowthUnifiedProfileChannelName["ReferralExternal"] = "REFERRAL_EXTERNAL";
    GrowthUnifiedProfileChannelName["ReferralInternal"] = "REFERRAL_INTERNAL";
    GrowthUnifiedProfileChannelName["SelfReferral"] = "SELF_REFERRAL";
    GrowthUnifiedProfileChannelName["SlackAppDirectory"] = "SLACK_APP_DIRECTORY";
    GrowthUnifiedProfileChannelName["Suppress"] = "SUPPRESS";
    GrowthUnifiedProfileChannelName["UnpaidSocial"] = "UNPAID_SOCIAL";
    GrowthUnifiedProfileChannelName["UnpaidVideo"] = "UNPAID_VIDEO";
    return GrowthUnifiedProfileChannelName;
}({});
let $5b8397cef71e8614$export$eb044d0d19d592c7 = /*#__PURE__*/ function(GrowthUnifiedProfileCompanySize) {
    GrowthUnifiedProfileCompanySize["Large"] = "LARGE";
    GrowthUnifiedProfileCompanySize["Medium"] = "MEDIUM";
    GrowthUnifiedProfileCompanySize["Small"] = "SMALL";
    GrowthUnifiedProfileCompanySize["Unknown"] = "UNKNOWN";
    return GrowthUnifiedProfileCompanySize;
}({});
let $5b8397cef71e8614$export$4582f4191dc3bb0e = /*#__PURE__*/ function(GrowthUnifiedProfileCompanyType) {
    GrowthUnifiedProfileCompanyType["Private"] = "PRIVATE";
    GrowthUnifiedProfileCompanyType["Public"] = "PUBLIC";
    return GrowthUnifiedProfileCompanyType;
}({});
let $5b8397cef71e8614$export$28880b034aa5dc30 = /*#__PURE__*/ function(GrowthUnifiedProfileEnrichmentStatus) {
    GrowthUnifiedProfileEnrichmentStatus["Complete"] = "COMPLETE";
    GrowthUnifiedProfileEnrichmentStatus["Error"] = "ERROR";
    GrowthUnifiedProfileEnrichmentStatus["InProgress"] = "IN_PROGRESS";
    GrowthUnifiedProfileEnrichmentStatus["Pending"] = "PENDING";
    return GrowthUnifiedProfileEnrichmentStatus;
}({});
let $5b8397cef71e8614$export$8d96e2c494b1d62c = /*#__PURE__*/ function(GrowthUnifiedProfileEnterpriseAccountStatus) {
    GrowthUnifiedProfileEnterpriseAccountStatus["Bronze"] = "BRONZE";
    GrowthUnifiedProfileEnterpriseAccountStatus["Gam"] = "GAM";
    GrowthUnifiedProfileEnterpriseAccountStatus["Gold"] = "GOLD";
    GrowthUnifiedProfileEnterpriseAccountStatus["Platimun"] = "PLATIMUN";
    GrowthUnifiedProfileEnterpriseAccountStatus["Silver"] = "SILVER";
    return GrowthUnifiedProfileEnterpriseAccountStatus;
}({});
let $5b8397cef71e8614$export$71e2332d6e22a291 = /*#__PURE__*/ function(GrowthUnifiedProfileEntityType) {
    GrowthUnifiedProfileEntityType["AjsAnonymousUser"] = "AJS_ANONYMOUS_USER";
    GrowthUnifiedProfileEntityType["AtlassianAccount"] = "ATLASSIAN_ACCOUNT";
    GrowthUnifiedProfileEntityType["Org"] = "ORG";
    GrowthUnifiedProfileEntityType["Site"] = "SITE";
    return GrowthUnifiedProfileEntityType;
}({});
let $5b8397cef71e8614$export$c49017e7afc08542 = /*#__PURE__*/ function(GrowthUnifiedProfileJtbd) {
    GrowthUnifiedProfileJtbd["Budgets"] = "BUDGETS";
    GrowthUnifiedProfileJtbd["CdWrtng"] = "CD_WRTNG";
    GrowthUnifiedProfileJtbd["ImproveWorkflow"] = "IMPROVE_WORKFLOW";
    GrowthUnifiedProfileJtbd["LaunchCampaigns"] = "LAUNCH_CAMPAIGNS";
    GrowthUnifiedProfileJtbd["MarketingContent"] = "MARKETING_CONTENT";
    GrowthUnifiedProfileJtbd["PlanAndManage"] = "PLAN_AND_MANAGE";
    GrowthUnifiedProfileJtbd["ProjectPlanning"] = "PROJECT_PLANNING";
    GrowthUnifiedProfileJtbd["ProjectProgress"] = "PROJECT_PROGRESS";
    GrowthUnifiedProfileJtbd["Stakeholders"] = "STAKEHOLDERS";
    GrowthUnifiedProfileJtbd["StrategiesAndGoals"] = "STRATEGIES_AND_GOALS";
    GrowthUnifiedProfileJtbd["TrackingRprtng"] = "TRACKING_RPRTNG";
    GrowthUnifiedProfileJtbd["UseKanbanBoard"] = "USE_KANBAN_BOARD";
    return GrowthUnifiedProfileJtbd;
}({});
let $5b8397cef71e8614$export$5990898c79cc1feb = /*#__PURE__*/ function(GrowthUnifiedProfileJiraFamiliarity) {
    GrowthUnifiedProfileJiraFamiliarity["Experience"] = "EXPERIENCE";
    GrowthUnifiedProfileJiraFamiliarity["Middle"] = "MIDDLE";
    GrowthUnifiedProfileJiraFamiliarity["New"] = "NEW";
    return GrowthUnifiedProfileJiraFamiliarity;
}({}); /** onboarding context input for jira */  /** onboarding context type for jira or confluence */  /** onboarding context input for jira or confluence */ 
let $5b8397cef71e8614$export$110930cf5e2a2eff = /*#__PURE__*/ function(GrowthUnifiedProfileTeamType) {
    GrowthUnifiedProfileTeamType["CustomerService"] = "CUSTOMER_SERVICE";
    GrowthUnifiedProfileTeamType["Design"] = "DESIGN";
    GrowthUnifiedProfileTeamType["Finance"] = "FINANCE";
    GrowthUnifiedProfileTeamType["HumanResources"] = "HUMAN_RESOURCES";
    GrowthUnifiedProfileTeamType["ItSupport"] = "IT_SUPPORT";
    GrowthUnifiedProfileTeamType["Legal"] = "LEGAL";
    GrowthUnifiedProfileTeamType["Marketing"] = "MARKETING";
    GrowthUnifiedProfileTeamType["Operations"] = "OPERATIONS";
    GrowthUnifiedProfileTeamType["Other"] = "OTHER";
    GrowthUnifiedProfileTeamType["Sales"] = "SALES";
    GrowthUnifiedProfileTeamType["SoftwareDevelopment"] = "SOFTWARE_DEVELOPMENT";
    return GrowthUnifiedProfileTeamType;
}({}); /** Utm typr will be extracted from the url query parameters */  /**
 * An experience flow that can be presented to a user so that they can perform a given task.
 * The flow never redirects or returns control to the caller, so it should be opened in a new
 * tab if it is desired that the user returns to the referring experience.
 */ 
let $5b8397cef71e8614$export$a4bd4d15a9a3d3f1 = /*#__PURE__*/ function(HelpCenterDescriptionType) {
    HelpCenterDescriptionType["PlainText"] = "PLAIN_TEXT";
    HelpCenterDescriptionType["RichText"] = "RICH_TEXT";
    HelpCenterDescriptionType["WikiMarkup"] = "WIKI_MARKUP";
    return HelpCenterDescriptionType;
}({}); /** Media config provides auth credentials and relevant information to upload images for media related elements. */  /** This describes the type of operation for which mediaConfig needs to be generated */ 
let $5b8397cef71e8614$export$9f54202027f49420 = /*#__PURE__*/ function(HelpCenterMediaConfigOperationType) {
    HelpCenterMediaConfigOperationType["BannerUpload"] = "BANNER_UPLOAD";
    HelpCenterMediaConfigOperationType["LogoUpload"] = "LOGO_UPLOAD";
    return HelpCenterMediaConfigOperationType;
}({});
let $5b8397cef71e8614$export$de6d4d4c47123061 = /*#__PURE__*/ function(HelpCenterPortalsSortOrder) {
    HelpCenterPortalsSortOrder["NameAscending"] = "NAME_ASCENDING";
    HelpCenterPortalsSortOrder["Popularity"] = "POPULARITY";
    return HelpCenterPortalsSortOrder;
}({});
let $5b8397cef71e8614$export$10df61f732f39a6d = /*#__PURE__*/ function(HelpCenterPortalsType) {
    HelpCenterPortalsType["Featured"] = "FEATURED";
    HelpCenterPortalsType["Hidden"] = "HIDDEN";
    HelpCenterPortalsType["Visible"] = "VISIBLE";
    return HelpCenterPortalsType;
}({});
let $5b8397cef71e8614$export$bf41d3d919083034 = /*#__PURE__*/ function(HelpCenterProjectMappingOperationType) {
    HelpCenterProjectMappingOperationType["MapProjects"] = "MAP_PROJECTS";
    HelpCenterProjectMappingOperationType["UnmapProjects"] = "UNMAP_PROJECTS";
    return HelpCenterProjectMappingOperationType;
}({});
let $5b8397cef71e8614$export$98ecf93df3b75669 = /*#__PURE__*/ function(HelpCenterProjectType) {
    HelpCenterProjectType["CustomerService"] = "CUSTOMER_SERVICE";
    HelpCenterProjectType["ServiceDesk"] = "SERVICE_DESK";
    return HelpCenterProjectType;
}({}); /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /** All available queries on help center service */  /**
 * #########################
 *  Base objects for help-center
 * #########################
 */ 
let $5b8397cef71e8614$export$db18c35dcd3a9e38 = /*#__PURE__*/ function(HelpCenterSortOrder) {
    HelpCenterSortOrder["CreatedDateAscending"] = "CREATED_DATE_ASCENDING";
    HelpCenterSortOrder["CreatedDateDescending"] = "CREATED_DATE_DESCENDING";
    return HelpCenterSortOrder;
}({});
let $5b8397cef71e8614$export$404b16ab15b3352c = /*#__PURE__*/ function(HelpCenterType) {
    HelpCenterType["Advanced"] = "ADVANCED";
    HelpCenterType["Basic"] = "BASIC";
    HelpCenterType["CustomerService"] = "CUSTOMER_SERVICE";
    HelpCenterType["Unified"] = "UNIFIED";
    return HelpCenterType;
}({});
let $5b8397cef71e8614$export$25877d5a420a6e71 = /*#__PURE__*/ function(HelpExternalResourceLinkResourceType) {
    HelpExternalResourceLinkResourceType["Channel"] = "CHANNEL";
    HelpExternalResourceLinkResourceType["Knowledge"] = "KNOWLEDGE";
    HelpExternalResourceLinkResourceType["RequestForm"] = "REQUEST_FORM";
    return HelpExternalResourceLinkResourceType;
}({}); /** Mutation */  /** Mutation */  /** Mutation */  /** Mutation */  /** Query Types */  /** Query Types */  /** Represents a layout in the system. */  /** Represents a layout in the system. */  /** Announcement Atomic Element */  /** Portals List Input */  /** This union represents all the atomic elements. */  /**
 * This input type will be used to mutate Atomic Elements inside Composite Elements.
 * This type is used only inside a Composite Element
 */ 
let $5b8397cef71e8614$export$4f955d957799126e = /*#__PURE__*/ function(HelpLayoutAtomicElementKey) {
    HelpLayoutAtomicElementKey["Announcement"] = "ANNOUNCEMENT";
    HelpLayoutAtomicElementKey["Connect"] = "CONNECT";
    HelpLayoutAtomicElementKey["Editor"] = "EDITOR";
    HelpLayoutAtomicElementKey["Forge"] = "FORGE";
    HelpLayoutAtomicElementKey["Heading"] = "HEADING";
    HelpLayoutAtomicElementKey["Hero"] = "HERO";
    HelpLayoutAtomicElementKey["Image"] = "IMAGE";
    HelpLayoutAtomicElementKey["NoContent"] = "NO_CONTENT";
    HelpLayoutAtomicElementKey["Paragraph"] = "PARAGRAPH";
    HelpLayoutAtomicElementKey["PortalsList"] = "PORTALS_LIST";
    HelpLayoutAtomicElementKey["Search"] = "SEARCH";
    HelpLayoutAtomicElementKey["SuggestedRequestFormsList"] = "SUGGESTED_REQUEST_FORMS_LIST";
    HelpLayoutAtomicElementKey["TopicsList"] = "TOPICS_LIST";
    return HelpLayoutAtomicElementKey;
}({}); /** Represents Atomic Element Types. They are fetched while rendering the catalogue. */  /** Represents Atomic Element Types. They are fetched while rendering the catalogue. */  /** This interface is implemented by all composite elements. */  /** This enum represents all the composite element keys. */ 
let $5b8397cef71e8614$export$576a5650ed3956e9 = /*#__PURE__*/ function(HelpLayoutCompositeElementKey) {
    HelpLayoutCompositeElementKey["LinkCard"] = "LINK_CARD";
    return HelpLayoutCompositeElementKey;
}({}); /** Represents Composite Element Types. They are fetched while rendering the catalogue. */  /** Connect App Element */ 
let $5b8397cef71e8614$export$d614d14eebc9034e = /*#__PURE__*/ function(HelpLayoutConnectElementPages) {
    HelpLayoutConnectElementPages["Approvals"] = "APPROVALS";
    HelpLayoutConnectElementPages["CreateRequest"] = "CREATE_REQUEST";
    HelpLayoutConnectElementPages["HelpCenter"] = "HELP_CENTER";
    HelpLayoutConnectElementPages["MyRequest"] = "MY_REQUEST";
    HelpLayoutConnectElementPages["Portal"] = "PORTAL";
    HelpLayoutConnectElementPages["Profile"] = "PROFILE";
    HelpLayoutConnectElementPages["ViewRequest"] = "VIEW_REQUEST";
    return HelpLayoutConnectElementPages;
}({});
let $5b8397cef71e8614$export$13477f5de7466343 = /*#__PURE__*/ function(HelpLayoutConnectElementType) {
    HelpLayoutConnectElementType["DetailsPanels"] = "detailsPanels";
    HelpLayoutConnectElementType["FooterPanels"] = "footerPanels";
    HelpLayoutConnectElementType["HeaderAndSubheaderPanels"] = "headerAndSubheaderPanels";
    HelpLayoutConnectElementType["HeaderPanels"] = "headerPanels";
    HelpLayoutConnectElementType["OptionPanels"] = "optionPanels";
    HelpLayoutConnectElementType["ProfilePagePanel"] = "profilePagePanel";
    HelpLayoutConnectElementType["PropertyPanels"] = "propertyPanels";
    HelpLayoutConnectElementType["RequestCreatePanel"] = "requestCreatePanel";
    HelpLayoutConnectElementType["SubheaderPanels"] = "subheaderPanels";
    return HelpLayoutConnectElementType;
}({}); /** Connect App Input */  /** Editor Element */  /** Editor Input */  /** This union represents all elements, atomic and composite. */  /** This enum represents all the element category. */ 
let $5b8397cef71e8614$export$66fddc1b3eb3d42f = /*#__PURE__*/ function(HelpLayoutElementCategory) {
    HelpLayoutElementCategory["Basic"] = "BASIC";
    HelpLayoutElementCategory["Navigation"] = "NAVIGATION";
    return HelpLayoutElementCategory;
}({}); /**
 * This input type can mutate both atomic and composite elements. Since there is no polymorphism in input types in graphql.
 * Client will have to send the Key to the element they are mutating and respective config.
 * Only one of the config fields will be specified. "elementTypeKey" should match the config provided.
 */ 
let $5b8397cef71e8614$export$7e4f0d562642895e = /*#__PURE__*/ function(HelpLayoutElementKey) {
    HelpLayoutElementKey["Announcement"] = "ANNOUNCEMENT";
    HelpLayoutElementKey["Connect"] = "CONNECT";
    HelpLayoutElementKey["Editor"] = "EDITOR";
    HelpLayoutElementKey["Forge"] = "FORGE";
    HelpLayoutElementKey["Heading"] = "HEADING";
    HelpLayoutElementKey["Hero"] = "HERO";
    HelpLayoutElementKey["Image"] = "IMAGE";
    HelpLayoutElementKey["LinkCard"] = "LINK_CARD";
    HelpLayoutElementKey["NoContent"] = "NO_CONTENT";
    HelpLayoutElementKey["Paragraph"] = "PARAGRAPH";
    HelpLayoutElementKey["PortalsList"] = "PORTALS_LIST";
    HelpLayoutElementKey["Search"] = "SEARCH";
    HelpLayoutElementKey["SuggestedRequestFormsList"] = "SUGGESTED_REQUEST_FORMS_LIST";
    HelpLayoutElementKey["TopicsList"] = "TOPICS_LIST";
    return HelpLayoutElementKey;
}({}); /** This interface represents all the element types which are supported by this schema. */  /** Forge App Element */ 
let $5b8397cef71e8614$export$443851e78d175634 = /*#__PURE__*/ function(HelpLayoutForgeElementPages) {
    HelpLayoutForgeElementPages["Approvals"] = "approvals";
    HelpLayoutForgeElementPages["CreateRequest"] = "create_request";
    HelpLayoutForgeElementPages["HelpCenter"] = "help_center";
    HelpLayoutForgeElementPages["MyRequests"] = "my_requests";
    HelpLayoutForgeElementPages["Portal"] = "portal";
    HelpLayoutForgeElementPages["Profile"] = "profile";
    HelpLayoutForgeElementPages["ViewRequest"] = "view_request";
    return HelpLayoutForgeElementPages;
}({});
let $5b8397cef71e8614$export$fd51ac42041cdcaa = /*#__PURE__*/ function(HelpLayoutForgeElementType) {
    HelpLayoutForgeElementType["Footer"] = "FOOTER";
    HelpLayoutForgeElementType["HeaderAndSubheader"] = "HEADER_AND_SUBHEADER";
    return HelpLayoutForgeElementType;
}({}); /** Forge App Input */  /** Heading Atomic Element */  /** Heading Input */ 
let $5b8397cef71e8614$export$ddbaabbc700bfb0f = /*#__PURE__*/ function(HelpLayoutHeadingType) {
    HelpLayoutHeadingType["H1"] = "h1";
    HelpLayoutHeadingType["H2"] = "h2";
    HelpLayoutHeadingType["H3"] = "h3";
    HelpLayoutHeadingType["H4"] = "h4";
    HelpLayoutHeadingType["H5"] = "h5";
    HelpLayoutHeadingType["H6"] = "h6";
    return HelpLayoutHeadingType;
}({}); /** Hero Element */  /** Hero Element Input */ 
let $5b8397cef71e8614$export$dc0242f9aced7a72 = /*#__PURE__*/ function(HelpLayoutHorizontalAlignment) {
    HelpLayoutHorizontalAlignment["Center"] = "CENTER";
    HelpLayoutHorizontalAlignment["Left"] = "LEFT";
    HelpLayoutHorizontalAlignment["Right"] = "RIGHT";
    return HelpLayoutHorizontalAlignment;
}({}); /** Image Atomic Element */  /** Image Input */  /** Link card Composite Element */  /** Link card input */  /** Media config provides auth credentials and relevant information to upload images for media related elements. */  /**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */ 
let $5b8397cef71e8614$export$da6edd2e84621f40 = /*#__PURE__*/ function(HelpLayoutProjectType) {
    HelpLayoutProjectType["CustomerService"] = "CUSTOMER_SERVICE";
    HelpLayoutProjectType["ServiceDesk"] = "SERVICE_DESK";
    return HelpLayoutProjectType;
}({}); /**
 * Namespace top-level field that contain all the mutations available in the schema.
 * https://developer.atlassian.com/platform/graphql-gateway/standards/synthetic-fields/
 */ 
let $5b8397cef71e8614$export$29b8c6e9ec83845e = /*#__PURE__*/ function(HelpLayoutVerticalAlignment) {
    HelpLayoutVerticalAlignment["Bottom"] = "BOTTOM";
    HelpLayoutVerticalAlignment["Middle"] = "MIDDLE";
    HelpLayoutVerticalAlignment["Top"] = "TOP";
    return HelpLayoutVerticalAlignment;
}({}); /** This represents the visual properties */  /** This represents the visual config input required during mutation */  /**
 * Any element or type that implements visualEntity will get visual config as a field which contains visual properties.
 * Think of this as visual config provider used to provide config such as border, bg-color and so on.
 */ 
let $5b8397cef71e8614$export$fca880a7c8a28341 = /*#__PURE__*/ function(HelpObjectStoreHelpObjectType) {
    HelpObjectStoreHelpObjectType["Article"] = "ARTICLE";
    HelpObjectStoreHelpObjectType["Channel"] = "CHANNEL";
    HelpObjectStoreHelpObjectType["Portal"] = "PORTAL";
    HelpObjectStoreHelpObjectType["RequestForm"] = "REQUEST_FORM";
    return HelpObjectStoreHelpObjectType;
}({});
let $5b8397cef71e8614$export$5a6a464de3389453 = /*#__PURE__*/ function(HelpObjectStoreJsmEntityType) {
    HelpObjectStoreJsmEntityType["Article"] = "ARTICLE";
    HelpObjectStoreJsmEntityType["Channel"] = "CHANNEL";
    HelpObjectStoreJsmEntityType["Portal"] = "PORTAL";
    HelpObjectStoreJsmEntityType["RequestForm"] = "REQUEST_FORM";
    return HelpObjectStoreJsmEntityType;
}({});
let $5b8397cef71e8614$export$714c6e1043f92681 = /*#__PURE__*/ function(HelpObjectStoreSearchAlgorithm) {
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnIssues"] = "KEYWORD_SEARCH_ON_ISSUES";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnPortalsBm25"] = "KEYWORD_SEARCH_ON_PORTALS_BM25";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnPortalsExactMatch"] = "KEYWORD_SEARCH_ON_PORTALS_EXACT_MATCH";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnRequestTypesBm25"] = "KEYWORD_SEARCH_ON_REQUEST_TYPES_BM25";
    HelpObjectStoreSearchAlgorithm["KeywordSearchOnRequestTypesExactMatch"] = "KEYWORD_SEARCH_ON_REQUEST_TYPES_EXACT_MATCH";
    return HelpObjectStoreSearchAlgorithm;
}({});
let $5b8397cef71e8614$export$82309e1a4e81fdbf = /*#__PURE__*/ function(HelpObjectStoreSearchBackend) {
    HelpObjectStoreSearchBackend["Jira"] = "JIRA";
    HelpObjectStoreSearchBackend["SearchPlatform"] = "SEARCH_PLATFORM";
    return HelpObjectStoreSearchBackend;
}({});
let $5b8397cef71e8614$export$3cd8bacd120e7d23 = /*#__PURE__*/ function(HelpObjectStoreSearchEntityType) {
    HelpObjectStoreSearchEntityType["Article"] = "ARTICLE";
    HelpObjectStoreSearchEntityType["Channel"] = "CHANNEL";
    HelpObjectStoreSearchEntityType["Portal"] = "PORTAL";
    HelpObjectStoreSearchEntityType["RequestForm"] = "REQUEST_FORM";
    return HelpObjectStoreSearchEntityType;
}({});
let $5b8397cef71e8614$export$78a7af08ea3c76ad = /*#__PURE__*/ function(HelpObjectStoreSearchableEntityType) {
    HelpObjectStoreSearchableEntityType["Article"] = "ARTICLE";
    HelpObjectStoreSearchableEntityType["RequestForm"] = "REQUEST_FORM";
    return HelpObjectStoreSearchableEntityType;
}({}); /** Call-to-action link where the notification is directed to. */ 
let $5b8397cef71e8614$export$add9b70bcde2a1e5 = /*#__PURE__*/ function(InfluentsNotificationAppearance) {
    InfluentsNotificationAppearance["Danger"] = "DANGER";
    InfluentsNotificationAppearance["Default"] = "DEFAULT";
    InfluentsNotificationAppearance["Link"] = "LINK";
    InfluentsNotificationAppearance["Primary"] = "PRIMARY";
    InfluentsNotificationAppearance["Subtle"] = "SUBTLE";
    InfluentsNotificationAppearance["Warning"] = "WARNING";
    return InfluentsNotificationAppearance;
}({}); /**
 * A body item can be sent with two types of appearances, PRIMARY and QUOTED.
 * The latter can be used to for sending comment reply style notifications.
 */ 
let $5b8397cef71e8614$export$3f759331ea860587 = /*#__PURE__*/ function(InfluentsNotificationCategory) {
    InfluentsNotificationCategory["Direct"] = "direct";
    InfluentsNotificationCategory["Watching"] = "watching";
    return InfluentsNotificationCategory;
}({}); /**
 * The Entity is what the notification relates to –
 * in most cases it’s the object (page, issue, pull request) that has been interacted with.
 * Clicking the title takes the user to the entity.
 * An entity can have a related icon.
 */ 
let $5b8397cef71e8614$export$d50fb347f614347c = /*#__PURE__*/ function(InfluentsNotificationReadState) {
    InfluentsNotificationReadState["Read"] = "read";
    InfluentsNotificationReadState["Unread"] = "unread";
    return InfluentsNotificationReadState;
}({}); /** Input for the mutation operations (snooze and remove). */ 
let $5b8397cef71e8614$export$2fe6ad0d43104840 = /*#__PURE__*/ function(InsightsApprovalStatus) {
    InsightsApprovalStatus["Approved"] = "APPROVED";
    InsightsApprovalStatus["Needswork"] = "NEEDSWORK";
    InsightsApprovalStatus["Unapproved"] = "UNAPPROVED";
    InsightsApprovalStatus["Unknown"] = "UNKNOWN";
    return InsightsApprovalStatus;
}({}); /** A context of either sprint or project Ari */ 
let $5b8397cef71e8614$export$2aa37f5a6634dc51 = /*#__PURE__*/ function(InsightsEnvironmentType) {
    InsightsEnvironmentType["Development"] = "DEVELOPMENT";
    InsightsEnvironmentType["Production"] = "PRODUCTION";
    InsightsEnvironmentType["Staging"] = "STAGING";
    InsightsEnvironmentType["Testing"] = "TESTING";
    InsightsEnvironmentType["Unmapped"] = "UNMAPPED";
    return InsightsEnvironmentType;
}({}); /** Input for the onboarding mutation operations (purge / snooze / remove). */ 
let $5b8397cef71e8614$export$32b11fa8a4db8f2e = /*#__PURE__*/ function(InsightsNextBestTaskAction) {
    InsightsNextBestTaskAction["Remove"] = "REMOVE";
    InsightsNextBestTaskAction["Snooze"] = "SNOOZE";
    return InsightsNextBestTaskAction;
}({}); /**
 * Defines whether we show the github onboarding UX
 * VISIBLE means JFE should render the onboarding UX
 * HIDDEN means user is already onboarded, do not show UX
 * SNOOZED means user snoozed the recommendation
 * REMOVED means user explicitly hid the recommendation
 */ 
let $5b8397cef71e8614$export$a20071bd470d2580 = /*#__PURE__*/ function(InsightsRecommendationVisibility) {
    InsightsRecommendationVisibility["Hidden"] = "HIDDEN";
    InsightsRecommendationVisibility["Removed"] = "REMOVED";
    InsightsRecommendationVisibility["Snoozed"] = "SNOOZED";
    InsightsRecommendationVisibility["Visible"] = "VISIBLE";
    return InsightsRecommendationVisibility;
}({});
let $5b8397cef71e8614$export$ef229f124986e5a0 = /*#__PURE__*/ function(InsightsTaskType) {
    InsightsTaskType["BlockingIssue"] = "BLOCKING_ISSUE";
    InsightsTaskType["BuildFailed"] = "BUILD_FAILED";
    InsightsTaskType["CritVuln"] = "CRIT_VULN";
    InsightsTaskType["DeploymentFailed"] = "DEPLOYMENT_FAILED";
    InsightsTaskType["PrNeedsWork"] = "PR_NEEDS_WORK";
    InsightsTaskType["PrReview"] = "PR_REVIEW";
    return InsightsTaskType;
}({}); /** Action object stored in the database for the actions snooze/remove task. */ 
let $5b8397cef71e8614$export$8efcfbc5b7f2cb2f = /*#__PURE__*/ function(InsightsVulnerabilityStatus) {
    InsightsVulnerabilityStatus["Closed"] = "CLOSED";
    InsightsVulnerabilityStatus["Ignored"] = "IGNORED";
    InsightsVulnerabilityStatus["Open"] = "OPEN";
    InsightsVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return InsightsVulnerabilityStatus;
}({}); /** The metrics returned on each invocation */  /** The data returned from a function invocation */  /** Input payload for the invoke aux mutation */  /** The response from an AUX effects invocation */  /** Input payload for the invoke mutation */  /** The response from a function invocation */  /** Detailed information of a repository's branch */  /** Short description of a pull request associated with a branch */  /** Detailed information about a build tied to a provider */  /** A build pipeline provider */  /** Information that links a build to a version control system (commits, branches, etc.) */ 
let $5b8397cef71e8614$export$338894d2bcfa1c6c = /*#__PURE__*/ function(IssueDevOpsCommitChangeType) {
    IssueDevOpsCommitChangeType["Added"] = "ADDED";
    IssueDevOpsCommitChangeType["Copied"] = "COPIED";
    IssueDevOpsCommitChangeType["Deleted"] = "DELETED";
    IssueDevOpsCommitChangeType["Modified"] = "MODIFIED";
    IssueDevOpsCommitChangeType["Modify"] = "MODIFY";
    IssueDevOpsCommitChangeType["Moved"] = "MOVED";
    IssueDevOpsCommitChangeType["Unknown"] = "UNKNOWN";
    return IssueDevOpsCommitChangeType;
}({}); /** Detailed information of a commit in a repository */  /** Information of a file modified in a commit */  /** Detailed information of a deployment */ 
let $5b8397cef71e8614$export$99413405dc72cb24 = /*#__PURE__*/ function(IssueDevOpsDeploymentEnvironmentType) {
    IssueDevOpsDeploymentEnvironmentType["Development"] = "DEVELOPMENT";
    IssueDevOpsDeploymentEnvironmentType["Production"] = "PRODUCTION";
    IssueDevOpsDeploymentEnvironmentType["Staging"] = "STAGING";
    IssueDevOpsDeploymentEnvironmentType["Testing"] = "TESTING";
    IssueDevOpsDeploymentEnvironmentType["Unmapped"] = "UNMAPPED";
    return IssueDevOpsDeploymentEnvironmentType;
}({}); /**
 * This object witholds deployment providers essential information,
 * as well as its list of latest deployments per pipeline.
 * A provider without deployments related to the asked issueId will not be returned.
 */ 
let $5b8397cef71e8614$export$df40bbb79dc09c24 = /*#__PURE__*/ function(IssueDevOpsDeploymentState) {
    IssueDevOpsDeploymentState["Cancelled"] = "CANCELLED";
    IssueDevOpsDeploymentState["Failed"] = "FAILED";
    IssueDevOpsDeploymentState["InProgress"] = "IN_PROGRESS";
    IssueDevOpsDeploymentState["Pending"] = "PENDING";
    IssueDevOpsDeploymentState["RolledBack"] = "ROLLED_BACK";
    IssueDevOpsDeploymentState["Successful"] = "SUCCESSFUL";
    IssueDevOpsDeploymentState["Unknown"] = "UNKNOWN";
    return IssueDevOpsDeploymentState;
}({}); /** Aggregates all the instance types (bitbucket, stash, github) and its development information */  /** Information related to the development process of an issue */  /** Information related to the development process of an issue */  /**
 * A set of booleans that indicate if the embedded marketplace
 * should be shown if a user does not have installed providers
 */ 
let $5b8397cef71e8614$export$93807e2ffddb6d99 = /*#__PURE__*/ function(IssueDevOpsPullRequestStatus) {
    IssueDevOpsPullRequestStatus["Declined"] = "DECLINED";
    IssueDevOpsPullRequestStatus["Draft"] = "DRAFT";
    IssueDevOpsPullRequestStatus["Merged"] = "MERGED";
    IssueDevOpsPullRequestStatus["Open"] = "OPEN";
    IssueDevOpsPullRequestStatus["Unknown"] = "UNKNOWN";
    return IssueDevOpsPullRequestStatus;
}({}); /** Detailed information of a VCS repository */  /** Short description of the parent repository from which the fork was made */  /** Short desciption of a review associated with a branch or commit */  /** A summary for the tests results for a particular build */  /** Represents a JSM Incident. */ 
let $5b8397cef71e8614$export$7aab904fe49fa56e = /*#__PURE__*/ function(JsmIncidentLinkDirection) {
    JsmIncidentLinkDirection["Inward"] = "INWARD";
    JsmIncidentLinkDirection["Outward"] = "OUTWARD";
    return JsmIncidentLinkDirection;
}({});
let $5b8397cef71e8614$export$cd35cf091a6250bb = /*#__PURE__*/ function(JsmMajorIncident) {
    JsmMajorIncident["MajorIncident"] = "MAJOR_INCIDENT";
    return JsmMajorIncident;
}({}); /** Represents the Atlassian Document Format content in JSON format. */  /** Represents the Atlassian Document Format content in JSON format. */  /** Input type for ADF values on fields */  /** Shows the Atlassian Intelligence feature to the end user. */  /** The different action types that a user can perform on a global level */ 
let $5b8397cef71e8614$export$b40f2294e83c8458 = /*#__PURE__*/ function(JiraActionType) {
    JiraActionType["CreateCompanyManagedProject"] = "CREATE_COMPANY_MANAGED_PROJECT";
    JiraActionType["CreateProject"] = "CREATE_PROJECT";
    JiraActionType["CreateTeamManagedProject"] = "CREATE_TEAM_MANAGED_PROJECT";
    return JiraActionType;
}({}); /** The input to associate issues with a fix version. */  /** The return payload of associating issues with a fix version. */  /** Input to create a new related work item and associated with a version. */  /** The return payload of creating a new related work item and associating it with a version. */  /** Operations that can be performed on fields like attachments and issuelinks etc. */ 
let $5b8397cef71e8614$export$7dab5913fedb74fb = /*#__PURE__*/ function(JiraAddValueFieldOperations) {
    JiraAddValueFieldOperations["Add"] = "ADD";
    return JiraAddValueFieldOperations;
}({}); /** The list of values for supported fields for the issue */  /** The connection type for JiraAdditionalIssueFields including the pagination information */  /** Represents ADF converted to plain text. */  /** Attributes of user configurations specific to richText field */  /** Attributes of user configurations specific to richText field */  /** Navigation information for the currently logged in user regarding Advanced Roadmaps for Jira */  /**
 * Represents an affected service entity for a Jira Issue.
 * AffectedService provides context on what has been changed.
 */ 
let $5b8397cef71e8614$export$35561b7f9e1f55e5 = /*#__PURE__*/ function(JiraAnnouncementBannerVisibility) {
    JiraAnnouncementBannerVisibility["Private"] = "PRIVATE";
    JiraAnnouncementBannerVisibility["Public"] = "PUBLIC";
    return JiraAnnouncementBannerVisibility;
}({}); /** The approval decision input */  /** Config states for an app with a specific id */  /** Config states for an app with a specific id */  /** Connection object representing config state for a set of jira apps */  /** Connection edge representing config state for one jira app */  /** Represent the config information required for a connect/forge app navigation item or nested link */  /** Represents a connect/forge app top-level navigation item */  /** Represents a connect/forge app nested navigation item */  /** Represents the navigation item type for a specific Connect or Forge app. */  /**
 * Represents a nested section for connect/forge apps
 * A collection of orphan/non-sectioned links will also be grouped as a section without a label
 */ 
let $5b8397cef71e8614$export$ce082fc9df0d76d9 = /*#__PURE__*/ function(JiraAppType) {
    JiraAppType["Connect"] = "CONNECT";
    JiraAppType["Forge"] = "FORGE";
    return JiraAppType;
}({}); /** A list of all UI modifications for an app and environment */  /** Representation of each Jira application/sub-product. */ 
let $5b8397cef71e8614$export$3041ba651e0f5411 = /*#__PURE__*/ function(JiraApplicationKey) {
    JiraApplicationKey["JiraCore"] = "JIRA_CORE";
    JiraApplicationKey["JiraProductDiscovery"] = "JIRA_PRODUCT_DISCOVERY";
    JiraApplicationKey["JiraServiceDesk"] = "JIRA_SERVICE_DESK";
    JiraApplicationKey["JiraSoftware"] = "JIRA_SOFTWARE";
    return JiraApplicationKey;
}({}); /**
 * Jira application properties is effectively a key/value store scoped to a Jira instance. A JiraApplicationProperty
 * represents one of these key/value pairs, along with associated metadata about the property.
 */ 
let $5b8397cef71e8614$export$b45afd01a571a7c3 = /*#__PURE__*/ function(JiraApprovalDecision) {
    JiraApprovalDecision["Approved"] = "APPROVED";
    JiraApprovalDecision["Rejected"] = "REJECTED";
    return JiraApprovalDecision;
}({}); /** The input type to approve access request of connected workspace(organization in Jira term) */  /** The response payload to approve access request of connected workspace(organization in Jira term) */  /** Input type to filter archived issues */  /** Field Options for filter by fields for getting archived issues */  /** Field Options for filter by fields for getting archived issues */  /** Field Options for filter by fields for getting archived issues */  /** Field Options for filter by fields for getting archived issues */  /** Input type for archival date range */  /** Represents a single option value for an asset field. */  /** The connection type for JiraAsset. */  /** An edge in a JiraAsset connection. */  /** Represents the Asset field on a Jira Issue. */  /** Represents the Asset field on a Jira Issue. */  /** Input type for asset field */  /** Input type for asset value */  /**
 * DEPRECATED: Superseded by issue linking
 *
 * Input to assign/unassign a related work item to a user.
 */ 
let $5b8397cef71e8614$export$ff923d46af5bc866 = /*#__PURE__*/ function(JiraAtlassianIntelligenceFeatureEnum) {
    JiraAtlassianIntelligenceFeatureEnum["AiMate"] = "AI_MATE";
    JiraAtlassianIntelligenceFeatureEnum["NaturalLanguageToJql"] = "NATURAL_LANGUAGE_TO_JQL";
    return JiraAtlassianIntelligenceFeatureEnum;
}({}); /** Input used to specify which product or feature to check for Atlassian Intelligence. */  /** Deprecated type. Please use `JiraTeamView` instead. */  /** Deprecated type. */  /** Deprecated type. */  /** Represents the Atlassian team field on a Jira Issue. Allows you to select a team to be associated with an issue. */  /** Represents the Atlassian team field on a Jira Issue. Allows you to select a team to be associated with an issue. */  /** Input type for Atlassian team field */  /** Input type for Atlassian team data */  /** An interface shared across all attachment types. */  /** An interface shared across all attachment types. */  /** A Jira Attachment Background, used only when the entity is of Issue type */  /** The connection type for JiraAttachment. */  /** An edge in a JiraAttachment connection. */  /** Input type for defining the operation on the Attachment field of a Jira issue. */  /** The payload type returned after updating the IssueType field of a Jira issue. */  /** Represents a fixed set of attachments' parents */ 
let $5b8397cef71e8614$export$e58d203181411860 = /*#__PURE__*/ function(JiraAttachmentParentName) {
    JiraAttachmentParentName["Comment"] = "COMMENT";
    JiraAttachmentParentName["Customfield"] = "CUSTOMFIELD";
    JiraAttachmentParentName["Description"] = "DESCRIPTION";
    JiraAttachmentParentName["Environment"] = "ENVIRONMENT";
    JiraAttachmentParentName["Form"] = "FORM";
    JiraAttachmentParentName["Issue"] = "ISSUE";
    JiraAttachmentParentName["Worklog"] = "WORKLOG";
    return JiraAttachmentParentName;
}({}); /** The field for sorting attachments. */ 
let $5b8397cef71e8614$export$4452eb40a75908b1 = /*#__PURE__*/ function(JiraAttachmentSortField) {
    JiraAttachmentSortField["Created"] = "CREATED";
    return JiraAttachmentSortField;
}({}); /** Deprecated type. Please use `attachments` field under `JiraIssue` instead. */  /** Deprecated type. Please use `attachments` field under `JiraIssue` instead. */ 
let $5b8397cef71e8614$export$add469b410e3b948 = /*#__PURE__*/ function(JiraAttachmentsPermissions) {
    JiraAttachmentsPermissions["CreateAttachments"] = "CREATE_ATTACHMENTS";
    JiraAttachmentsPermissions["DeleteOwnAttachments"] = "DELETE_OWN_ATTACHMENTS";
    return JiraAttachmentsPermissions;
}({}); /** The payload response for basic autodev mutations */  /** JiraAutodevCodeChange represents a code change associated with the Autodev Job */  /** JiraAutodevCodeChangeConnection represents the connection object for Code changes associated with the Autodev Job */  /** JiraAutodevCodeChangeEdge represents the code change edge object associated with the Autodev Job */  /** Renamed to JiraAutodevCodeChangeEnumType to be compatible with jira/gira prefix validation */ 
let $5b8397cef71e8614$export$20cf66312c009d2a = /*#__PURE__*/ function(JiraAutodevCodeChangeEnumType) {
    JiraAutodevCodeChangeEnumType["Add"] = "ADD";
    JiraAutodevCodeChangeEnumType["Delete"] = "DELETE";
    JiraAutodevCodeChangeEnumType["Edit"] = "EDIT";
    JiraAutodevCodeChangeEnumType["Other"] = "OTHER";
    return JiraAutodevCodeChangeEnumType;
}({}); /** The payload response for the create an autofix job mutation */  /** Autodev job response */  /** Autodev/acra job connection */  /** Connection edge representing autodev job */  /** Autodev job state */ 
let $5b8397cef71e8614$export$7c2c34d9bc1709c = /*#__PURE__*/ function(JiraAutodevPhase) {
    JiraAutodevPhase["CodeGenerating"] = "CODE_GENERATING";
    JiraAutodevPhase["CodeReview"] = "CODE_REVIEW";
    JiraAutodevPhase["CodeReGenerating"] = "CODE_RE_GENERATING";
    JiraAutodevPhase["PlanGenerating"] = "PLAN_GENERATING";
    JiraAutodevPhase["PlanReview"] = "PLAN_REVIEW";
    JiraAutodevPhase["PlanReGenerating"] = "PLAN_RE_GENERATING";
    return JiraAutodevPhase;
}({}); /** Autodev Job Plan */  /** JiraAutodevPlannedChange represents a planned code change associated with the Autodev Job */  /** JiraAutodevPullRequest represents one pull request associated with the Autodev Job */  /** JiraAutodevPullRequestConnection represents the connection object for Pull requests associated with the Autodev Job */  /** JiraAutodevPullRequestEdge represents the pull request edge object associated with the Autodev Job */  /** Autodev job state */ 
let $5b8397cef71e8614$export$9d46e21e99abf4d9 = /*#__PURE__*/ function(JiraAutodevState) {
    JiraAutodevState["Cancelled"] = "CANCELLED";
    JiraAutodevState["CodeGenerating"] = "CODE_GENERATING";
    JiraAutodevState["CodeGenerationFail"] = "CODE_GENERATION_FAIL";
    JiraAutodevState["CodeGenerationReady"] = "CODE_GENERATION_READY";
    JiraAutodevState["CodeGenerationSuccess"] = "CODE_GENERATION_SUCCESS";
    JiraAutodevState["Created"] = "CREATED";
    JiraAutodevState["PlanGenerating"] = "PLAN_GENERATING";
    JiraAutodevState["PlanGenerationFail"] = "PLAN_GENERATION_FAIL";
    JiraAutodevState["PlanGenerationSuccess"] = "PLAN_GENERATION_SUCCESS";
    JiraAutodevState["PullrequestCreating"] = "PULLREQUEST_CREATING";
    JiraAutodevState["PullrequestCreationFail"] = "PULLREQUEST_CREATION_FAIL";
    JiraAutodevState["PullrequestCreationSuccess"] = "PULLREQUEST_CREATION_SUCCESS";
    JiraAutodevState["Unknown"] = "UNKNOWN";
    return JiraAutodevState;
}({}); /** Autodev job status */ 
let $5b8397cef71e8614$export$b45cf8febb3440fe = /*#__PURE__*/ function(JiraAutodevStatus) {
    JiraAutodevStatus["Cancelled"] = "CANCELLED";
    JiraAutodevStatus["Completed"] = "COMPLETED";
    JiraAutodevStatus["Failed"] = "FAILED";
    JiraAutodevStatus["InProgress"] = "IN_PROGRESS";
    JiraAutodevStatus["Pending"] = "PENDING";
    return JiraAutodevStatus;
}({}); /** JiraAutodevStatusHistoryItem represents one status history item associated with the Autodev Job */  /** JiraAutodevStatusHistoryItemConnection represents the connection object for status history items associated with the Autodev Job */  /** JiraAutodevStatusHistoryItemEdge represents the status history item edge object associated with the Autodev Job */  /** JiraAutodevTaskConnection represents the connection object for individual tasks in the plan for the Autodev Job */  /** Response from creating an autofix job */  /** The input type to create an autofix job */  /** Autofix job response */  /** Autofix job connection */  /** Connection edge representing autofix job */  /** Type of autofix job */ 
let $5b8397cef71e8614$export$ffe042497b182587 = /*#__PURE__*/ function(JiraAutofixJobType) {
    JiraAutofixJobType["InternalRemoveFeatureFlag"] = "INTERNAL_REMOVE_FEATURE_FLAG";
    return JiraAutofixJobType;
}({}); /** Autofix job status */ 
let $5b8397cef71e8614$export$9bc56f5589387f27 = /*#__PURE__*/ function(JiraAutofixStatus) {
    JiraAutofixStatus["Completed"] = "COMPLETED";
    JiraAutofixStatus["Failed"] = "FAILED";
    JiraAutofixStatus["InProgress"] = "IN_PROGRESS";
    JiraAutofixStatus["Pending"] = "PENDING";
    return JiraAutofixStatus;
}({}); /** Represents the four avatar sizes' url. */  /** Interface for backgrounds */  /** The supported background types */ 
let $5b8397cef71e8614$export$2c2631a0fafec4d2 = /*#__PURE__*/ function(JiraBackgroundType) {
    JiraBackgroundType["Attachment"] = "ATTACHMENT";
    JiraBackgroundType["Color"] = "COLOR";
    JiraBackgroundType["Custom"] = "CUSTOM";
    JiraBackgroundType["Gradient"] = "GRADIENT";
    JiraBackgroundType["Unsplash"] = "UNSPLASH";
    return JiraBackgroundType;
}({}); /** Type to hold Jira Background upload token auth details */ 
let $5b8397cef71e8614$export$a91e934e29660252 = /*#__PURE__*/ function(JiraBatchWindowPreference) {
    JiraBatchWindowPreference["DefaultBatching"] = "DEFAULT_BATCHING";
    JiraBatchWindowPreference["FifteenMinutes"] = "FIFTEEN_MINUTES";
    JiraBatchWindowPreference["FiveMinutes"] = "FIVE_MINUTES";
    JiraBatchWindowPreference["NoBatching"] = "NO_BATCHING";
    JiraBatchWindowPreference["OncePerDay"] = "ONCE_PER_DAY";
    JiraBatchWindowPreference["OneDay"] = "ONE_DAY";
    JiraBatchWindowPreference["OneHour"] = "ONE_HOUR";
    JiraBatchWindowPreference["TenMinutes"] = "TEN_MINUTES";
    JiraBatchWindowPreference["ThirtyMinutes"] = "THIRTY_MINUTES";
    return JiraBatchWindowPreference;
}({}); /**
 * The internal BB app which provides devOps capabilities
 * This provider will be filtered out from the list of providers if BB SCM is not installed
 */ 
let $5b8397cef71e8614$export$fffb97f85a99dcd3 = /*#__PURE__*/ function(JiraBitbucketWorkspaceApprovalState) {
    JiraBitbucketWorkspaceApprovalState["Approved"] = "APPROVED";
    JiraBitbucketWorkspaceApprovalState["PendingApproval"] = "PENDING_APPROVAL";
    return JiraBitbucketWorkspaceApprovalState;
}({}); /** Represents a Jira Board */  /** The connection type for JiraBoard */  /** An edge in a JiraBoard connection */  /** Types of containers that boards can be located in */ 
let $5b8397cef71e8614$export$4dc98413456458b = /*#__PURE__*/ function(JiraBoardLocationType) {
    JiraBoardLocationType["Project"] = "PROJECT";
    JiraBoardLocationType["User"] = "USER";
    return JiraBoardLocationType;
}({}); /** A union type representing Jira boards within a Jira project */  /** Types of Jira boards */ 
let $5b8397cef71e8614$export$97a2fe75628224ea = /*#__PURE__*/ function(JiraBoardType) {
    JiraBoardType["Kanban"] = "KANBAN";
    JiraBoardType["Scrum"] = "SCRUM";
    return JiraBoardType;
}({}); /** Represents a generic boolean field for an Issue. E.g. JSM alert linking. */  /** The input type for scheduling the execution of project cleanup recommendations */  /** The payload type for bulk project archiving and trashing */  /** Retrieves a field which can be bulk edited */  /** Retrieves a connection of fields which can be bulk edited */  /** An edge in a BulkEditFields connection. */  /** Specifies inputs for search on fields and a boolean to override them */  /** Specified bulk edit operation input */  /**
 * Contains all options available for fields with multi select options available
 * This field is required only for 4 system field: Fix Versions, Affects Versions, Label and Component
 */ 
let $5b8397cef71e8614$export$8dcaa522c00e0bea = /*#__PURE__*/ function(JiraBulkEditMultiSelectFieldOptions) {
    JiraBulkEditMultiSelectFieldOptions["Add"] = "ADD";
    JiraBulkEditMultiSelectFieldOptions["Remove"] = "REMOVE";
    JiraBulkEditMultiSelectFieldOptions["RemoveAll"] = "REMOVE_ALL";
    JiraBulkEditMultiSelectFieldOptions["Replace"] = "REPLACE";
    return JiraBulkEditMultiSelectFieldOptions;
}({}); /** Specified bulk operation input */  /** Specified the type of bulk operation */ 
let $5b8397cef71e8614$export$65634ab0c72ca58 = /*#__PURE__*/ function(JiraBulkOperationType) {
    JiraBulkOperationType["BulkEdit"] = "BULK_EDIT";
    JiraBulkOperationType["BulkTransition"] = "BULK_TRANSITION";
    return JiraBulkOperationType;
}({}); /** Retrives a list of transitions for given issues */  /** Retrives a list of transitions for given issues */  /** Retrives a list of transitions for given issues */  /** Retrieves a connection of transitions applicable for a given list of issues */  /** An edge in a bulk transition connection. */  /** Represents the screen layout for a transition and set of issues. */  /** Represents the screen layout for a transition and set of issues. */  /** Input type for bulk transition */  /** Represents CMDB (Configuration Management Database) field on a Jira Issue. */  /** Represents CMDB (Configuration Management Database) field on a Jira Issue. */ 
let $5b8397cef71e8614$export$598ca3e7e63eeac3 = /*#__PURE__*/ function(JiraCalendarMode) {
    JiraCalendarMode["Day"] = "DAY";
    JiraCalendarMode["Month"] = "MONTH";
    JiraCalendarMode["Week"] = "WEEK";
    return JiraCalendarMode;
}({}); /** An edge in a JiraProjectPermission connection. */ 
let $5b8397cef71e8614$export$80636f9ce4ef8927 = /*#__PURE__*/ function(JiraCalendarPermissionKey) {
    JiraCalendarPermissionKey["ManageSprintsPermission"] = "MANAGE_SPRINTS_PERMISSION";
    return JiraCalendarPermissionKey;
}({}); /** View settings for Jira Calendar */ 
let $5b8397cef71e8614$export$56103bfe65fcf045 = /*#__PURE__*/ function(JiraCalendarWeekStart) {
    JiraCalendarWeekStart["Monday"] = "MONDAY";
    JiraCalendarWeekStart["Saturday"] = "SATURDAY";
    JiraCalendarWeekStart["Sunday"] = "SUNDAY";
    return JiraCalendarWeekStart;
}({}); /** Canned response entity created against a project with defined scope. */  /**
 * #########################
 *  Mutation Inputs
 * #########################
 */ 
let $5b8397cef71e8614$export$ce8ee5a026b40f80 = /*#__PURE__*/ function(JiraCannedResponseScope) {
    JiraCannedResponseScope["Personal"] = "PERSONAL";
    JiraCannedResponseScope["Project"] = "PROJECT";
    return JiraCannedResponseScope;
}({});
let $5b8397cef71e8614$export$c55b15b4975ca485 = /*#__PURE__*/ function(JiraCannedResponseSortOrder) {
    JiraCannedResponseSortOrder["Asc"] = "ASC";
    JiraCannedResponseSortOrder["Desc"] = "DESC";
    return JiraCannedResponseSortOrder;
}({}); /**
 * Represents the pair of values (parent & child combination) in a cascading select.
 * This type is used to represent a selected cascading field value on a Jira Issue.
 * Since this is 2 level hierarchy, it is not possible to represent the same underlying
 * type for both single cascadingOption and list of cascadingOptions. Thus, we have created different types.
 */ 
let $5b8397cef71e8614$export$95ff254e6924dc6f = /*#__PURE__*/ function(JiraCascadingSelectOptionType) {
    JiraCascadingSelectOptionType["All"] = "ALL";
    JiraCascadingSelectOptionType["Child"] = "CHILD";
    JiraCascadingSelectOptionType["Parent"] = "PARENT";
    return JiraCascadingSelectOptionType;
}({}); /** An input filter used to specify the cascading options returned. */  /** Represents the check boxes field on a Jira Issue. */  /** Represents the check boxes field on a Jira Issue. */  /** Represents the check boxes field on a Jira Issue. */  /** Input type for defining the operation on the Checkboxes field of a Jira issue. */  /** The payload type returned after updating the Checkboxes field of a Jira issue. */  /**
 * A union type representing childIssues available within a Jira Issue.
 * The *WithinLimit type is used for childIssues with a count that is within a limit specified by the server.
 * The *ExceedsLimit type is used for childIssues with a count that exceeds a limit specified by the server.
 */ 
let $5b8397cef71e8614$export$f34d058fb688acaf = /*#__PURE__*/ function(JiraClassificationLevelSource) {
    JiraClassificationLevelSource["Issue"] = "ISSUE";
    JiraClassificationLevelSource["Project"] = "PROJECT";
    return JiraClassificationLevelSource;
}({}); /** Enum to define the classification level status. */ 
let $5b8397cef71e8614$export$608cba47cc506457 = /*#__PURE__*/ function(JiraClassificationLevelStatus) {
    JiraClassificationLevelStatus["Archived"] = "ARCHIVED";
    JiraClassificationLevelStatus["Draft"] = "DRAFT";
    JiraClassificationLevelStatus["Published"] = "PUBLISHED";
    return JiraClassificationLevelStatus;
}({}); /** Enum to define the classification level type. */ 
let $5b8397cef71e8614$export$a6a7c946782bf432 = /*#__PURE__*/ function(JiraClassificationLevelType) {
    JiraClassificationLevelType["System"] = "SYSTEM";
    JiraClassificationLevelType["User"] = "USER";
    return JiraClassificationLevelType;
}({}); /** Input type for a clearable number field */  /** Represents the attribute associated with the CMDB object. */  /** Represents the attribute associated with the CMDB object. */  /** The connection type for JiraCmdbAttribute. */  /** An edge in a JiraCmdbAttribute connection. */  /** The category of the CMDB attribute that can be created. */ 
let $5b8397cef71e8614$export$aafda693b12c4a20 = /*#__PURE__*/ function(JiraCmdbAttributeType) {
    JiraCmdbAttributeType["BitbucketRepo"] = "BITBUCKET_REPO";
    JiraCmdbAttributeType["Confluence"] = "CONFLUENCE";
    JiraCmdbAttributeType["Default"] = "DEFAULT";
    JiraCmdbAttributeType["Group"] = "GROUP";
    JiraCmdbAttributeType["OpsgenieTeam"] = "OPSGENIE_TEAM";
    JiraCmdbAttributeType["Project"] = "PROJECT";
    JiraCmdbAttributeType["ReferencedObject"] = "REFERENCED_OBJECT";
    JiraCmdbAttributeType["Status"] = "STATUS";
    JiraCmdbAttributeType["User"] = "USER";
    JiraCmdbAttributeType["Version"] = "VERSION";
    return JiraCmdbAttributeType;
}({}); /** Represents a CMDB avatar. */  /** Represents the CMDB Bitbucket Repository. */  /** The connection type for CMDB config attributes. */  /** An edge in a JiraCmdbConfigAttributeConnection. */  /**
 * Represents the CMDB default type.
 * This contains information about what type of default attribute this is.
 * The possible id: name values are as follows:
 *     0: Text
 *     1: Integer
 *     2: Boolean
 *     3: Float
 *     4: Date
 *     6: DateTime
 *     7: URL
 *     8: Email
 *     9: Textarea
 *     10: Select
 *     11: IP Address
 */ 
let $5b8397cef71e8614$export$7341e48e3db8f8f0 = /*#__PURE__*/ function(JiraColorSchemeThemeSetting) {
    JiraColorSchemeThemeSetting["Automatic"] = "AUTOMATIC";
    JiraColorSchemeThemeSetting["Dark"] = "DARK";
    JiraColorSchemeThemeSetting["Light"] = "LIGHT";
    return JiraColorSchemeThemeSetting;
}({}); /** An interface shared across all comment types. */  /** The connection type for JiraComment. */  /** An edge in a JiraComment connection. */  /** The field for sorting comments. */ 
let $5b8397cef71e8614$export$67f08e20644f2173 = /*#__PURE__*/ function(JiraCommentSortField) {
    JiraCommentSortField["Created"] = "CREATED";
    return JiraCommentSortField;
}({}); /**
 * Jira component defines two kinds of Components:
 *     1. Project Components, sub-selection of a project.
 *     2. Global Components, which span across multiple projects.
 * One of the Global Components type is Compass Components.
 */ 
let $5b8397cef71e8614$export$6f50c8d504c17c7a = /*#__PURE__*/ function(JiraConfigFieldType) {
    JiraConfigFieldType["CustomCascadingSelect"] = "CUSTOM_CASCADING_SELECT";
    JiraConfigFieldType["CustomDatetime"] = "CUSTOM_DATETIME";
    JiraConfigFieldType["CustomDatePicker"] = "CUSTOM_DATE_PICKER";
    JiraConfigFieldType["CustomFloat"] = "CUSTOM_FLOAT";
    JiraConfigFieldType["CustomGroupPicker"] = "CUSTOM_GROUP_PICKER";
    JiraConfigFieldType["CustomImportId"] = "CUSTOM_IMPORT_ID";
    JiraConfigFieldType["CustomLabels"] = "CUSTOM_LABELS";
    JiraConfigFieldType["CustomMultiCheckboxes"] = "CUSTOM_MULTI_CHECKBOXES";
    JiraConfigFieldType["CustomMultiGroupPicker"] = "CUSTOM_MULTI_GROUP_PICKER";
    JiraConfigFieldType["CustomMultiSelect"] = "CUSTOM_MULTI_SELECT";
    JiraConfigFieldType["CustomMultiUserPicker"] = "CUSTOM_MULTI_USER_PICKER";
    JiraConfigFieldType["CustomMultiVersion"] = "CUSTOM_MULTI_VERSION";
    JiraConfigFieldType["CustomProject"] = "CUSTOM_PROJECT";
    JiraConfigFieldType["CustomRadioButtons"] = "CUSTOM_RADIO_BUTTONS";
    JiraConfigFieldType["CustomReadonlyField"] = "CUSTOM_READONLY_FIELD";
    JiraConfigFieldType["CustomSelect"] = "CUSTOM_SELECT";
    JiraConfigFieldType["CustomTextarea"] = "CUSTOM_TEXTAREA";
    JiraConfigFieldType["CustomTextField"] = "CUSTOM_TEXT_FIELD";
    JiraConfigFieldType["CustomUrl"] = "CUSTOM_URL";
    JiraConfigFieldType["CustomUserPicker"] = "CUSTOM_USER_PICKER";
    JiraConfigFieldType["CustomVersion"] = "CUSTOM_VERSION";
    JiraConfigFieldType["ServicedeskApprovals"] = "SERVICEDESK_APPROVALS";
    JiraConfigFieldType["ServicedeskCmdbField"] = "SERVICEDESK_CMDB_FIELD";
    JiraConfigFieldType["ServicedeskCustomerOrganizations"] = "SERVICEDESK_CUSTOMER_ORGANIZATIONS";
    JiraConfigFieldType["ServicedeskRequestFeedback"] = "SERVICEDESK_REQUEST_FEEDBACK";
    JiraConfigFieldType["ServicedeskRequestFeedbackDate"] = "SERVICEDESK_REQUEST_FEEDBACK_DATE";
    JiraConfigFieldType["ServicedeskRequestLanguage"] = "SERVICEDESK_REQUEST_LANGUAGE";
    JiraConfigFieldType["ServicedeskRequestParticipants"] = "SERVICEDESK_REQUEST_PARTICIPANTS";
    JiraConfigFieldType["ServicedeskSlaField"] = "SERVICEDESK_SLA_FIELD";
    JiraConfigFieldType["ServicedeskVpOrigin"] = "SERVICEDESK_VP_ORIGIN";
    JiraConfigFieldType["SoftwareEpicColor"] = "SOFTWARE_EPIC_COLOR";
    JiraConfigFieldType["SoftwareEpicIssueColor"] = "SOFTWARE_EPIC_ISSUE_COLOR";
    JiraConfigFieldType["SoftwareEpicLabel"] = "SOFTWARE_EPIC_LABEL";
    JiraConfigFieldType["SoftwareEpicLexoRank"] = "SOFTWARE_EPIC_LEXO_RANK";
    JiraConfigFieldType["SoftwareEpicLink"] = "SOFTWARE_EPIC_LINK";
    JiraConfigFieldType["SoftwareEpicSprint"] = "SOFTWARE_EPIC_SPRINT";
    JiraConfigFieldType["SoftwareEpicStatus"] = "SOFTWARE_EPIC_STATUS";
    JiraConfigFieldType["StandardAffectedVersions"] = "STANDARD_AFFECTED_VERSIONS";
    JiraConfigFieldType["StandardAggregateProgress"] = "STANDARD_AGGREGATE_PROGRESS";
    JiraConfigFieldType["StandardAggregateTimeEstimate"] = "STANDARD_AGGREGATE_TIME_ESTIMATE";
    JiraConfigFieldType["StandardAggregateTimeOriginalEstimate"] = "STANDARD_AGGREGATE_TIME_ORIGINAL_ESTIMATE";
    JiraConfigFieldType["StandardAggregateTimeSpent"] = "STANDARD_AGGREGATE_TIME_SPENT";
    JiraConfigFieldType["StandardAssignee"] = "STANDARD_ASSIGNEE";
    JiraConfigFieldType["StandardAttachment"] = "STANDARD_ATTACHMENT";
    JiraConfigFieldType["StandardComment"] = "STANDARD_COMMENT";
    JiraConfigFieldType["StandardComponents"] = "STANDARD_COMPONENTS";
    JiraConfigFieldType["StandardCreated"] = "STANDARD_CREATED";
    JiraConfigFieldType["StandardCreator"] = "STANDARD_CREATOR";
    JiraConfigFieldType["StandardDescription"] = "STANDARD_DESCRIPTION";
    JiraConfigFieldType["StandardDueDate"] = "STANDARD_DUE_DATE";
    JiraConfigFieldType["StandardEnvironment"] = "STANDARD_ENVIRONMENT";
    JiraConfigFieldType["StandardFixForVersions"] = "STANDARD_FIX_FOR_VERSIONS";
    JiraConfigFieldType["StandardFormToken"] = "STANDARD_FORM_TOKEN";
    JiraConfigFieldType["StandardIssueKey"] = "STANDARD_ISSUE_KEY";
    JiraConfigFieldType["StandardIssueLinks"] = "STANDARD_ISSUE_LINKS";
    JiraConfigFieldType["StandardIssueNumber"] = "STANDARD_ISSUE_NUMBER";
    JiraConfigFieldType["StandardIssueType"] = "STANDARD_ISSUE_TYPE";
    JiraConfigFieldType["StandardLabels"] = "STANDARD_LABELS";
    JiraConfigFieldType["StandardLastViewed"] = "STANDARD_LAST_VIEWED";
    JiraConfigFieldType["StandardParent"] = "STANDARD_PARENT";
    JiraConfigFieldType["StandardPriority"] = "STANDARD_PRIORITY";
    JiraConfigFieldType["StandardProgress"] = "STANDARD_PROGRESS";
    JiraConfigFieldType["StandardProject"] = "STANDARD_PROJECT";
    JiraConfigFieldType["StandardProjectKey"] = "STANDARD_PROJECT_KEY";
    JiraConfigFieldType["StandardReporter"] = "STANDARD_REPORTER";
    JiraConfigFieldType["StandardResolution"] = "STANDARD_RESOLUTION";
    JiraConfigFieldType["StandardResolutionDate"] = "STANDARD_RESOLUTION_DATE";
    JiraConfigFieldType["StandardSecurity"] = "STANDARD_SECURITY";
    JiraConfigFieldType["StandardStatus"] = "STANDARD_STATUS";
    JiraConfigFieldType["StandardSubtasks"] = "STANDARD_SUBTASKS";
    JiraConfigFieldType["StandardSummary"] = "STANDARD_SUMMARY";
    JiraConfigFieldType["StandardThumbnail"] = "STANDARD_THUMBNAIL";
    JiraConfigFieldType["StandardTimetracking"] = "STANDARD_TIMETRACKING";
    JiraConfigFieldType["StandardTimeEstimate"] = "STANDARD_TIME_ESTIMATE";
    JiraConfigFieldType["StandardTimeOriginalEstimate"] = "STANDARD_TIME_ORIGINAL_ESTIMATE";
    JiraConfigFieldType["StandardTimeSpent"] = "STANDARD_TIME_SPENT";
    JiraConfigFieldType["StandardUpdated"] = "STANDARD_UPDATED";
    JiraConfigFieldType["StandardVoters"] = "STANDARD_VOTERS";
    JiraConfigFieldType["StandardVotes"] = "STANDARD_VOTES";
    JiraConfigFieldType["StandardWatchers"] = "STANDARD_WATCHERS";
    JiraConfigFieldType["StandardWatches"] = "STANDARD_WATCHES";
    JiraConfigFieldType["StandardWorklog"] = "STANDARD_WORKLOG";
    JiraConfigFieldType["StandardWorkratio"] = "STANDARD_WORKRATIO";
    JiraConfigFieldType["Unsupported"] = "UNSUPPORTED";
    return JiraConfigFieldType;
}({}); /** JiraConfigState represents the configured status for a workspace for a jira app */  /** Enum representing the configured status for a jira app/workspace */ 
let $5b8397cef71e8614$export$9d90b408b08d33b7 = /*#__PURE__*/ function(JiraConfigStateConfigurationStatus) {
    JiraConfigStateConfigurationStatus["Configured"] = "CONFIGURED";
    JiraConfigStateConfigurationStatus["NotConfigured"] = "NOT_CONFIGURED";
    JiraConfigStateConfigurationStatus["NotInstalled"] = "NOT_INSTALLED";
    JiraConfigStateConfigurationStatus["NotSet"] = "NOT_SET";
    JiraConfigStateConfigurationStatus["PartiallyConfigured"] = "PARTIALLY_CONFIGURED";
    JiraConfigStateConfigurationStatus["ProviderActionConfigured"] = "PROVIDER_ACTION_CONFIGURED";
    JiraConfigStateConfigurationStatus["ProviderActionNotConfigured"] = "PROVIDER_ACTION_NOT_CONFIGURED";
    return JiraConfigStateConfigurationStatus;
}({}); /** Connection object representing config state for a set of jira app workspaces */  /** Connection edge representing config state for one jira app workspace */  /** Enum representing Provider Type of App for Config State Service */ 
let $5b8397cef71e8614$export$227a4b9b7e3c43f7 = /*#__PURE__*/ function(JiraConfigStateProviderType) {
    JiraConfigStateProviderType["Builds"] = "BUILDS";
    JiraConfigStateProviderType["Deployments"] = "DEPLOYMENTS";
    JiraConfigStateProviderType["Designs"] = "DESIGNS";
    JiraConfigStateProviderType["DevelopmentInfo"] = "DEVELOPMENT_INFO";
    JiraConfigStateProviderType["FeatureFlags"] = "FEATURE_FLAGS";
    JiraConfigStateProviderType["RemoteLinks"] = "REMOTE_LINKS";
    JiraConfigStateProviderType["Security"] = "SECURITY";
    JiraConfigStateProviderType["Unknown"] = "UNKNOWN";
    return JiraConfigStateProviderType;
}({}); /** Each individual nav item that is configurable by the user. */  /** Each individual nav item that is configurable by the user. */  /** Represents a datetime field created by Connect App. Note that a connect field's type dynamic. Consumers can use the schema type to determine this is a connect field */  /** Represents a multi-select field created by Connect App. */  /** Represents a multi-select field created by Connect App. */  /** Represents a multi-select field created by Connect App. */  /** Represents a multi-select field created by Connect App. */  /** Represents a multi-select field created by Connect App. */  /** Represents a number field created by Connect App. */  /**
 * Deprecated. Use JiraConnectTextField | JiraConnectNumberField | JiraConnectDateTimeField + isEditable instead
 * Represents a read only field created by Connect App.
 */ 
let $5b8397cef71e8614$export$2eccc11159f64a0b = /*#__PURE__*/ function(JiraContactOrgAdminToEnableAtlassianIntelligenceState) {
    JiraContactOrgAdminToEnableAtlassianIntelligenceState["Available"] = "AVAILABLE";
    JiraContactOrgAdminToEnableAtlassianIntelligenceState["Unavailable"] = "UNAVAILABLE";
    return JiraContactOrgAdminToEnableAtlassianIntelligenceState;
}({}); /** Represents the details of a navigation for a specific container. */  /** Represents the details of a navigation for a specific container. */  /** Represents the details of a navigation for a specific container. */  /** Represents the details of a navigation for a specific container. */  /** Input to query the navigation of a container scoped to a project by its key. */  /**
 * Input to retrieve the navigation details of a container. As per the `@oneOf` directive, Only one of the fields
 * `byScopeId` or `byProjectKey` must be provided.
 */ 
let $5b8397cef71e8614$export$ab94fb316a642cad = /*#__PURE__*/ function(JiraCustomIssueSearchErrorType) {
    JiraCustomIssueSearchErrorType["CustomImplementationError"] = "CUSTOM_IMPLEMENTATION_ERROR";
    JiraCustomIssueSearchErrorType["CustomSearchDisabled"] = "CUSTOM_SEARCH_DISABLED";
    JiraCustomIssueSearchErrorType["InvalidAri"] = "INVALID_ARI";
    JiraCustomIssueSearchErrorType["UnsupportedAri"] = "UNSUPPORTED_ARI";
    return JiraCustomIssueSearchErrorType;
}({}); /** Represents a Jira dashboard */  /**
 * Represents aggregated DataClassification for an issue. Data Classification for Jira provides Jira users and admins with
 * the capability to assign pre-existing classification tags to all Content levels.
 */ 
let $5b8397cef71e8614$export$2ed4618f2653768 = /*#__PURE__*/ function(JiraDeploymentsFeaturePrecondition) {
    JiraDeploymentsFeaturePrecondition["AllSatisfied"] = "ALL_SATISFIED";
    JiraDeploymentsFeaturePrecondition["DeploymentsEmptyState"] = "DEPLOYMENTS_EMPTY_STATE";
    JiraDeploymentsFeaturePrecondition["NotAvailable"] = "NOT_AVAILABLE";
    return JiraDeploymentsFeaturePrecondition;
}({}); /** User actionable error details. */  /** The possible config error type with a provider that feed devinfo details. */ 
let $5b8397cef71e8614$export$956b9378bb62ef88 = /*#__PURE__*/ function(JiraDevInfoConfigErrorType) {
    JiraDevInfoConfigErrorType["Incapable"] = "INCAPABLE";
    JiraDevInfoConfigErrorType["NotConfigured"] = "NOT_CONFIGURED";
    JiraDevInfoConfigErrorType["Unauthorized"] = "UNAUTHORIZED";
    JiraDevInfoConfigErrorType["UnknownConfigError"] = "UNKNOWN_CONFIG_ERROR";
    return JiraDevInfoConfigErrorType;
}({}); /** The input type for a devOps association */  /** The payload type for a devOps association */  /** Details of a created SCM branch associated with a Jira issue. */  /** The types of capabilities a devOps provider can support */ 
let $5b8397cef71e8614$export$35269253edf4bd98 = /*#__PURE__*/ function(JiraDevOpsCapability) {
    JiraDevOpsCapability["Branch"] = "BRANCH";
    JiraDevOpsCapability["Build"] = "BUILD";
    JiraDevOpsCapability["Commit"] = "COMMIT";
    JiraDevOpsCapability["Deployment"] = "DEPLOYMENT";
    JiraDevOpsCapability["FeatureFlag"] = "FEATURE_FLAG";
    JiraDevOpsCapability["PullRequest"] = "PULL_REQUEST";
    JiraDevOpsCapability["Review"] = "REVIEW";
    return JiraDevOpsCapability;
}({}); /** Details of a SCM commit associated with a Jira issue. */  /** The input type for devOps entity associations */  /** Basic person information who created a SCM entity (Pull-request, Branches, or Commit) */ 
let $5b8397cef71e8614$export$62ac5d058da58a8 = /*#__PURE__*/ function(JiraDevOpsInContextConfigPromptLocation) {
    JiraDevOpsInContextConfigPromptLocation["DevelopmentPanel"] = "DEVELOPMENT_PANEL";
    JiraDevOpsInContextConfigPromptLocation["ReleasesPanel"] = "RELEASES_PANEL";
    JiraDevOpsInContextConfigPromptLocation["SecurityPanel"] = "SECURITY_PANEL";
    return JiraDevOpsInContextConfigPromptLocation;
}({}); /** Container for all DevOps data for an issue, to be displayed in the DevOps Panel of an issue */ 
let $5b8397cef71e8614$export$ab235556283af700 = /*#__PURE__*/ function(JiraDevOpsIssuePanelBannerType) {
    JiraDevOpsIssuePanelBannerType["IssueKeyOnboarding"] = "ISSUE_KEY_ONBOARDING";
    return JiraDevOpsIssuePanelBannerType;
}({}); /** The possible States the DevOps Issue Panel can be in */ 
let $5b8397cef71e8614$export$9deab4622c89c42 = /*#__PURE__*/ function(JiraDevOpsIssuePanelState) {
    JiraDevOpsIssuePanelState["DevSummary"] = "DEV_SUMMARY";
    JiraDevOpsIssuePanelState["Hidden"] = "HIDDEN";
    JiraDevOpsIssuePanelState["NotConnected"] = "NOT_CONNECTED";
    return JiraDevOpsIssuePanelState;
}({}); /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Container for all DevOps related mutations in Jira */  /** Details of a SCM Pull-request associated with a Jira issue */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */  /** Container for all DevOps related queries in Jira */ 
let $5b8397cef71e8614$export$f72ad11cc7a7d264 = /*#__PURE__*/ function(JiraDevOpsUpdateAssociationsEntityType) {
    JiraDevOpsUpdateAssociationsEntityType["Vulnerability"] = "VULNERABILITY";
    return JiraDevOpsUpdateAssociationsEntityType;
}({}); /** The input type for updating devOps associations */  /** The payload type for updating devOps associations */  /** Represents dev summary for an issue. The identifier for this field is devSummary */  /** The response payload to dismiss the banner that displays workspaces that are pending acceptance of access requests */  /** The response payload to dismiss the banner that displays workspaces that are pending acceptance of access requests */  /** The input type for devops panel banner dismissal */  /** The response payload for devops panel banner dismissal */  /** The response payload to dismiss in-context configuration prompt that is per user setting */  /** The response payload to dismiss in-context configuration prompt that is per user setting */  /** Represents a duration. Typically used for time tracking fields. */  /** Input for OriginalEstimate field */  /** Represents the possible email MIME types. */ 
let $5b8397cef71e8614$export$309a4c314bc40eda = /*#__PURE__*/ function(JiraEmailMimeType) {
    JiraEmailMimeType["Html"] = "HTML";
    JiraEmailMimeType["Text"] = "TEXT";
    return JiraEmailMimeType;
}({}); /** Represents the reason why a connection is empty. */  /** Link to send org admins to enable Atlassian Intelligence. */  /** Input type for Entitlement field */  /** Input type representing a single entitlement */  /** An interface for the return type of any Entity Property */  /** The generic Boolean type for any entity property */  /** The generic integer type for any entity property */  /** The generic JSON type for any entity property, use of this interface is NOT recommended as per https://hello.atlassian.net/wiki/spaces/GT3/pages/2567211252/Avoid+using+JSON+as+a+field+type */  /** The generic String type for any entity property */  /** Scope of values for the Entity (Ex: Field) */ 
let $5b8397cef71e8614$export$2d42aa6ed58ded25 = /*#__PURE__*/ function(JiraEntityScope) {
    JiraEntityScope["Global"] = "GLOBAL";
    JiraEntityScope["Project"] = "PROJECT";
    return JiraEntityScope;
}({}); /** Represents an epic. */  /** The connection type for JiraEpic. */  /** An edge in a JiraEpic connection. */  /** Represents epic link field on a Jira Issue. */  /** Represents epic link field on a Jira Issue. */  /** Input type for epic link field */  /** Input type for epic link field */  /** Represents the Jira time tracking estimate type. */  /**
 * Context where the extensions are supposed to be shown.
 *
 * Provide only the most specific entity. For example, there is no need to provide the project if an issue is given; the project will be inferred from the issue automatically.
 */ 
let $5b8397cef71e8614$export$5c4322ab4b397354 = /*#__PURE__*/ function(JiraFavouriteType) {
    JiraFavouriteType["Board"] = "BOARD";
    JiraFavouriteType["Dashboard"] = "DASHBOARD";
    JiraFavouriteType["Filter"] = "FILTER";
    JiraFavouriteType["Plan"] = "PLAN";
    JiraFavouriteType["Project"] = "PROJECT";
    JiraFavouriteType["Queue"] = "QUEUE";
    return JiraFavouriteType;
}({}); /** Favourite Node which is unique to a favouritable entity and a user and returns if the favourite value is true or false. */  /** Represents a Jira field which includes system fields and custom fields */  /** Represents Association of fields with IssueTypes */  /** The connection type for JiraFieldAssociationWithIssueTypes. */  /** An edge in a JiraFieldAssociationWithIssueTypes connection. */  /** Attributes of field configuration. */  /** A connection to a list of FieldConfigs. */  /** An edge in a JiraIssueFieldConfig connection. */  /** The connection type for JiraProjectAssociatedFields. */  /** An edge in a JiraProjectAssociatedFields connection. */  /** Represents the information for a field being non-editable on Issue screens. */  /** Represents operations allowed on a JiraField */  /** Represents argument input type for `fieldOptions` query to provide capability to filter field options by list of IDs */  /** Enum to define a filter operation on the optionIds in input JiraFieldOptionIdsFilterInput */ 
let $5b8397cef71e8614$export$18f16315d2f9166d = /*#__PURE__*/ function(JiraFieldOptionIdsFilterOperation) {
    JiraFieldOptionIdsFilterOperation["Allow"] = "ALLOW";
    JiraFieldOptionIdsFilterOperation["Exclude"] = "EXCLUDE";
    return JiraFieldOptionIdsFilterOperation;
}({}); /** The representation of fieldset preferences. */  /** The payload returned when a User fieldset preferences has been updated. */  /**
 * The representation of a Jira field-type.
 *
 * E.g. `Short Text`, `Number`, `Version Picker`, `Team` etc.
 */ 
let $5b8397cef71e8614$export$8947915968eda69f = /*#__PURE__*/ function(JiraForgeEnvironmentType) {
    JiraForgeEnvironmentType["Development"] = "DEVELOPMENT";
    JiraForgeEnvironmentType["Production"] = "PRODUCTION";
    JiraForgeEnvironmentType["Staging"] = "STAGING";
    return JiraForgeEnvironmentType;
}({}); /** The definition of a Forge extension in Jira. */  /** Represents a Group field created by Forge App. */  /** Represents a Group field created by Forge App. */  /** Represents a Groups field created by Forge App. */  /** Represents a Groups field created by Forge App. */  /** Represents a Groups field created by Forge App. */  /** Represents a number field created by Forge App. */  /** Represents a object field created by Forge App. */  /** Represents a string field created by Forge App. */  /** Represents a strings field created by Forge App. */  /** Represents a strings field created by Forge App. */  /** Represents a strings field created by Forge App. */  /** Represents a User field created by Forge App. */  /** Represents a User field created by Forge App. */  /** Represents a Users field created by Forge App. */  /** Represents a Users field created by Forge App. */  /** Represents a Users field created by Forge App. */ 
let $5b8397cef71e8614$export$a84cede14c0af3e6 = /*#__PURE__*/ function(JiraFormattingArea) {
    JiraFormattingArea["Cell"] = "CELL";
    JiraFormattingArea["Row"] = "ROW";
    return JiraFormattingArea;
}({});
let $5b8397cef71e8614$export$ac68c28f8148831f = /*#__PURE__*/ function(JiraFormattingColor) {
    JiraFormattingColor["Blue"] = "BLUE";
    JiraFormattingColor["Green"] = "GREEN";
    JiraFormattingColor["Red"] = "RED";
    return JiraFormattingColor;
}({}); /** Rule is evaluated against multiple values. Values order does not matter in this condition. */ 
let $5b8397cef71e8614$export$efa4d82804592bca = /*#__PURE__*/ function(JiraFormattingMultipleValueOperator) {
    JiraFormattingMultipleValueOperator["Contains"] = "CONTAINS";
    JiraFormattingMultipleValueOperator["DoesNotContain"] = "DOES_NOT_CONTAIN";
    JiraFormattingMultipleValueOperator["HasAnyOf"] = "HAS_ANY_OF";
    return JiraFormattingMultipleValueOperator;
}({}); /** Rule doesn't require value. */ 
let $5b8397cef71e8614$export$eca120e5a19089a1 = /*#__PURE__*/ function(JiraFormattingNoValueOperator) {
    JiraFormattingNoValueOperator["IsEmpty"] = "IS_EMPTY";
    JiraFormattingNoValueOperator["IsNotEmpty"] = "IS_NOT_EMPTY";
    return JiraFormattingNoValueOperator;
}({}); /** Rule is evaluated against one value */ 
let $5b8397cef71e8614$export$545873d4d5fe4917 = /*#__PURE__*/ function(JiraFormattingSingleValueOperator) {
    JiraFormattingSingleValueOperator["Contains"] = "CONTAINS";
    JiraFormattingSingleValueOperator["DoesNotContain"] = "DOES_NOT_CONTAIN";
    JiraFormattingSingleValueOperator["DoesNotEqual"] = "DOES_NOT_EQUAL";
    JiraFormattingSingleValueOperator["Equals"] = "EQUALS";
    JiraFormattingSingleValueOperator["GreaterThan"] = "GREATER_THAN";
    JiraFormattingSingleValueOperator["GreaterThanOrEquals"] = "GREATER_THAN_OR_EQUALS";
    JiraFormattingSingleValueOperator["Is"] = "IS";
    JiraFormattingSingleValueOperator["IsAfter"] = "IS_AFTER";
    JiraFormattingSingleValueOperator["IsBefore"] = "IS_BEFORE";
    JiraFormattingSingleValueOperator["IsNot"] = "IS_NOT";
    JiraFormattingSingleValueOperator["IsOnOrAfter"] = "IS_ON_OR_AFTER";
    JiraFormattingSingleValueOperator["IsOnOrBefore"] = "IS_ON_OR_BEFORE";
    JiraFormattingSingleValueOperator["LessThan"] = "LESS_THAN";
    JiraFormattingSingleValueOperator["LessThanOrEquals"] = "LESS_THAN_OR_EQUALS";
    return JiraFormattingSingleValueOperator;
}({}); /** Rule is evaluated against two values. Value order does matter in this condition. */ 
let $5b8397cef71e8614$export$7a46afffd251b41d = /*#__PURE__*/ function(JiraFormattingTwoValueOperator) {
    JiraFormattingTwoValueOperator["IsBetween"] = "IS_BETWEEN";
    JiraFormattingTwoValueOperator["IsNotBetween"] = "IS_NOT_BETWEEN";
    return JiraFormattingTwoValueOperator;
}({}); /** The representation for an generic error when the generated JQL was invalid. */  /** WARNING: This type is deprecated and will be removed in the future. DO NOT USE */  /** The global issue create modal view types. */ 
let $5b8397cef71e8614$export$4a2c19fd597ee77f = /*#__PURE__*/ function(JiraGlobalIssueCreateView) {
    JiraGlobalIssueCreateView["FullModal"] = "FULL_MODAL";
    JiraGlobalIssueCreateView["MiniModal"] = "MINI_MODAL";
    return JiraGlobalIssueCreateView;
}({}); /** A global permission in Jira */  /** All the grants given to a global permission */  /** Different Global permissions that the user can have */ 
let $5b8397cef71e8614$export$c30f06fc4059f363 = /*#__PURE__*/ function(JiraGlobalPermissionType) {
    JiraGlobalPermissionType["Administer"] = "ADMINISTER";
    JiraGlobalPermissionType["UserPicker"] = "USER_PICKER";
    return JiraGlobalPermissionType;
}({}); /** Represents a goal in Jira */  /** The connection type for JiraGoal. */  /** An edge in a JiraGoal connection. */ 
let $5b8397cef71e8614$export$6d47154a1de14240 = /*#__PURE__*/ function(JiraGoalStatus) {
    JiraGoalStatus["Archived"] = "ARCHIVED";
    JiraGoalStatus["AtRisk"] = "AT_RISK";
    JiraGoalStatus["Cancelled"] = "CANCELLED";
    JiraGoalStatus["Completed"] = "COMPLETED";
    JiraGoalStatus["Done"] = "DONE";
    JiraGoalStatus["OffTrack"] = "OFF_TRACK";
    JiraGoalStatus["OnTrack"] = "ON_TRACK";
    JiraGoalStatus["Paused"] = "PAUSED";
    JiraGoalStatus["Pending"] = "PENDING";
    return JiraGoalStatus;
}({}); /** Represents the Goals field on a Jira Issue. */  /** Represents the Goals field on a Jira Issue. */  /** A Jira Background which is a gradient type */  /** The unique key of the grant type such as PROJECT_ROLE. */  /**
 * The grant type key enum represents all the possible grant types available in Jira.
 * A grant type may take an optional parameter value.
 * For example: PROJECT_ROLE grant type takes project role id as parameter. And, PROJECT_LEAD grant type do not.
 *
 * The actual ARI formats are documented on the various concrete grant type values.
 */ 
let $5b8397cef71e8614$export$60b5a68a2a59a819 = /*#__PURE__*/ function(JiraGrantTypeKeyEnum) {
    JiraGrantTypeKeyEnum["AnonymousAccess"] = "ANONYMOUS_ACCESS";
    JiraGrantTypeKeyEnum["AnyLoggedinUserApplicationRole"] = "ANY_LOGGEDIN_USER_APPLICATION_ROLE";
    JiraGrantTypeKeyEnum["ApplicationRole"] = "APPLICATION_ROLE";
    JiraGrantTypeKeyEnum["Assignee"] = "ASSIGNEE";
    JiraGrantTypeKeyEnum["Group"] = "GROUP";
    JiraGrantTypeKeyEnum["MultiGroupPicker"] = "MULTI_GROUP_PICKER";
    JiraGrantTypeKeyEnum["MultiUserPicker"] = "MULTI_USER_PICKER";
    JiraGrantTypeKeyEnum["ProjectLead"] = "PROJECT_LEAD";
    JiraGrantTypeKeyEnum["ProjectRole"] = "PROJECT_ROLE";
    JiraGrantTypeKeyEnum["Reporter"] = "REPORTER";
    JiraGrantTypeKeyEnum["ServiceProjectCustomerPortalAccess"] = "SERVICE_PROJECT_CUSTOMER_PORTAL_ACCESS";
    JiraGrantTypeKeyEnum["User"] = "USER";
    return JiraGrantTypeKeyEnum;
}({}); /** The JiraGrantTypeValue union resolves to one of the concrete types such as JiraDefaultGrantTypeValue, JiraProjectRoleGrantTypeValue. */  /** A type to represent one or more paginated list of one or more permission grant values available for a given grant type. */  /** An edge object representing grant type value information used within connection object. */  /** Represents a Jira Group. */  /** The connection type for JiraGroup. */  /** An edge in a JiraGroupConnection connection. */  /** The GROUP grant type value where group data is provided by identity service. */  /** Input for Groups values on fields */  /** The types of Contexts supported by Groups field. */ 
let $5b8397cef71e8614$export$ebb3bfffea31943a = /*#__PURE__*/ function(JiraGroupsContext) {
    JiraGroupsContext["Group"] = "GROUP";
    JiraGroupsContext["User"] = "USER";
    return JiraGroupsContext;
}({}); /** Represents a multiple selected value on a field. */  /** Represents a multiple selected value on a field. */  /** Represent a selectable options that can be selected on an Issue or a field. */  /** Represent a selectable options that can be selected on an Issue or a field. */  /** Represents a single selected value on a field. */  /** The Jira Home Page that a user can be directed to. */  /** The different home page types a user can be directed to. */ 
let $5b8397cef71e8614$export$42ed5df1bdc10783 = /*#__PURE__*/ function(JiraHomePageType) {
    JiraHomePageType["Dashboards"] = "DASHBOARDS";
    JiraHomePageType["LoginRedirect"] = "LOGIN_REDIRECT";
    JiraHomePageType["ProjectsDirectory"] = "PROJECTS_DIRECTORY";
    JiraHomePageType["YourWork"] = "YOUR_WORK";
    return JiraHomePageType;
}({}); /** The JSM incident priority values */ 
let $5b8397cef71e8614$export$f1e981f4a82c46b7 = /*#__PURE__*/ function(JiraIncidentPriority) {
    JiraIncidentPriority["P1"] = "P1";
    JiraIncidentPriority["P2"] = "P2";
    JiraIncidentPriority["P3"] = "P3";
    JiraIncidentPriority["P4"] = "P4";
    JiraIncidentPriority["P5"] = "P5";
    return JiraIncidentPriority;
}({}); /** This is the input argument for initializing the project notification preferences. */  /** The response for the mutation to update the project notification preferences. */  /**
 * DEPRECATED: Banner experiment is no longer active
 *
 * The precondition state of the install-deployments banner for a particular project and user.
 */ 
let $5b8397cef71e8614$export$c8c1ed3f290ea5bf = /*#__PURE__*/ function(JiraInstallDeploymentsBannerPrecondition) {
    JiraInstallDeploymentsBannerPrecondition["DeploymentsEmptyState"] = "DEPLOYMENTS_EMPTY_STATE";
    JiraInstallDeploymentsBannerPrecondition["FeatureNotEnabled"] = "FEATURE_NOT_ENABLED";
    JiraInstallDeploymentsBannerPrecondition["NotAvailable"] = "NOT_AVAILABLE";
    return JiraInstallDeploymentsBannerPrecondition;
}({}); /**
 * The representation for an invalid JQL error.
 * E.g. 'project = TMP' where 'TMP' has been deleted.
 */ 
let $5b8397cef71e8614$export$ca26010eaa3c3804 = /*#__PURE__*/ function(JiraIssueDeploymentEnvironmentState) {
    JiraIssueDeploymentEnvironmentState["Deployed"] = "DEPLOYED";
    JiraIssueDeploymentEnvironmentState["NotDeployed"] = "NOT_DEPLOYED";
    return JiraIssueDeploymentEnvironmentState;
}({}); /** The SCM entities (pullrequest, branches or commits) associated with a Jira issue. */  /** Lists the summaries available for each type of dev info, for a given issue */  /** Aggregates the `count` of entities for a given provider */  /** Error when querying the JiraIssueDevSummary */  /** Basic information on a provider that triggered an error */  /** Container for the Dev Summary of an issue */  /** An edge in a JiraIssue connection. */  /** Indicates an error occurring during submission or execution of an export task. */  /** The types of events published to the onIssueExported subscription. */  /** Input for the onIssueExported subscription. */  /** A Jira issue export task */  /** Indicates a successful completion of a Jira issue export task. */  /** The progress of a Jira issue export task. */  /** Indicates a successful export task submission. */  /**
 * Represents an export task that was terminated due to an error, cancellation, or dead state.
 * The export result would not be available.
 */ 
let $5b8397cef71e8614$export$55363ce84d2e39d7 = /*#__PURE__*/ function(JiraIssueExportType) {
    JiraIssueExportType["CsvAllFields"] = "CSV_ALL_FIELDS";
    JiraIssueExportType["CsvCurrentFields"] = "CSV_CURRENT_FIELDS";
    JiraIssueExportType["CsvWithBomAllFields"] = "CSV_WITH_BOM_ALL_FIELDS";
    JiraIssueExportType["CsvWithBomCurrentFields"] = "CSV_WITH_BOM_CURRENT_FIELDS";
    return JiraIssueExportType;
}({}); /** Represents the common structure across Issue fields. */  /** Represents the configurations associated with an Issue field. */  /** The connection type for JiraIssueField. */  /** An edge in a JiraIssueField connection. */  /**
 * The issue field grant type used to represent field of an issue.
 * Grant types such as ASSIGNEE, REPORTER, MULTI USER PICKER, and MULTI GROUP PICKER use this grant type value.
 */ 
let $5b8397cef71e8614$export$f02f8d5666a4ac9b = /*#__PURE__*/ function(JiraIssueItemLayoutItemLocationRuleType) {
    JiraIssueItemLayoutItemLocationRuleType["Dates"] = "DATES";
    JiraIssueItemLayoutItemLocationRuleType["MultilineText"] = "MULTILINE_TEXT";
    JiraIssueItemLayoutItemLocationRuleType["Other"] = "OTHER";
    JiraIssueItemLayoutItemLocationRuleType["People"] = "PEOPLE";
    JiraIssueItemLayoutItemLocationRuleType["Timetracking"] = "TIMETRACKING";
    return JiraIssueItemLayoutItemLocationRuleType;
}({}); /** Represents a reference to a panel by panel ID, used for laying out panels on an issue. */  /** The system container types that are available for placing items. */ 
let $5b8397cef71e8614$export$697c16cbeca9bb08 = /*#__PURE__*/ function(JiraIssueItemSystemContainerType) {
    JiraIssueItemSystemContainerType["Content"] = "CONTENT";
    JiraIssueItemSystemContainerType["Context"] = "CONTEXT";
    JiraIssueItemSystemContainerType["HiddenItems"] = "HIDDEN_ITEMS";
    JiraIssueItemSystemContainerType["Primary"] = "PRIMARY";
    JiraIssueItemSystemContainerType["Request"] = "REQUEST";
    JiraIssueItemSystemContainerType["RequestPortal"] = "REQUEST_PORTAL";
    JiraIssueItemSystemContainerType["Secondary"] = "SECONDARY";
    return JiraIssueItemSystemContainerType;
}({}); /** Represents a collection of system container types to be fetched by passing in an issue id. */  /** Represents a collection of system container types to be fetched by passing in an issue key and a cloud id. */  /** Represents a collection of items that are held in a tab container. */  /** Represents the items that can be placed in any tab container. */  /** The connection type for `JiraIssueItemTabContainerItem`. */  /** An edge in a `JiraIssueItemTabContainerItem` connection. */  /** This class contains all the possible states an Issue can be in. */ 
let $5b8397cef71e8614$export$be9310abc07a1404 = /*#__PURE__*/ function(JiraIssueLifecycleState) {
    JiraIssueLifecycleState["Active"] = "ACTIVE";
    JiraIssueLifecycleState["Archived"] = "ARCHIVED";
    return JiraIssueLifecycleState;
}({}); /**
 * Represents a single Issue link containing the link id, link type and destination Issue.
 *
 * For Issue create, JiraIssueLink will be populated with
 * the default IssueLink types in the relatedBy field.
 * The issueLinkId and Issue fields will be null.
 *
 * For Issue view, JiraIssueLink will be populated with
 * the Issue link data available on the Issue.
 * The Issue field will contain a nested JiraIssue that is atmost 1 level deep.
 * The nested JiraIssue will not contain fields that can contain further nesting.
 */ 
let $5b8397cef71e8614$export$230ec0d260fcf9aa = /*#__PURE__*/ function(JiraIssueLinkDirection) {
    JiraIssueLinkDirection["Inward"] = "INWARD";
    JiraIssueLinkDirection["Outward"] = "OUTWARD";
    return JiraIssueLinkDirection;
}({}); /** An edge in a JiraIssueLink connection. */  /** Represents linked issues field on a Jira Issue. */  /** Represents linked issues field on a Jira Issue. */  /** Represents linked issues field on a Jira Issue. */  /** Represents linked issues field on a Jira Issue. */  /** Input type for defining the operation on the IssueLink field of a Jira issue. */  /**
 * Represents the issue link type which includes both inwards and outwards relation names
 * For example: blocks, is blocked by, duplicates, is duplicated by, clones, is cloned by.
 */ 
let $5b8397cef71e8614$export$339e1af59c6eefd6 = /*#__PURE__*/ function(JiraIssueNavigatorSearchLayout) {
    JiraIssueNavigatorSearchLayout["Detail"] = "DETAIL";
    JiraIssueNavigatorSearchLayout["List"] = "LIST";
    return JiraIssueNavigatorSearchLayout;
}({}); /** Summary of the Pull Requests attached to the issue */  /** Container for the summary of the Pull Requests attached to the issue */  /** The container of SCM pull requests info associated with a Jira issue. */  /** Represents issue restriction field on an issue for next gen projects. */  /** Represents issue restriction field on an issue for next gen projects. */  /** Represents issue restriction field on an issue for next gen projects. */  /** Summary of the Reviews attached to the issue */  /** Container for the summary of the Reviews attached to the issue */  /** Represents an issue search result when querying with a JiraFilter. */  /** Represents an issue search result when querying with a JiraFilter. */  /** Represents an issue search result when querying with a JiraFilter. */  /** Represents an issue search result when querying with a set of issue ids. */  /** Represents an issue search result when querying with a set of issue ids. */  /** Represents an issue search result when querying with a set of issue ids. */  /** Represents an issue search result when querying with a Jira Query Language (JQL) string. */  /** Represents an issue search result when querying with a Jira Query Language (JQL) string. */  /** Represents an issue search result when querying with a Jira Query Language (JQL) string. */  /**
 * Represents the contextless content for an issue search result in Jira.
 * There is no JiraIssueSearchView associated with this content and is therefore contextless.
 */ 
let $5b8397cef71e8614$export$7ca831dd5735cc4c = /*#__PURE__*/ function(JiraIssueSearchFieldSetSelectedState) {
    JiraIssueSearchFieldSetSelectedState["All"] = "ALL";
    JiraIssueSearchFieldSetSelectedState["NonSelected"] = "NON_SELECTED";
    JiraIssueSearchFieldSetSelectedState["Selected"] = "SELECTED";
    return JiraIssueSearchFieldSetSelectedState;
}({}); /**
 * A filter for the JiraIssueSearchFieldSet connections.
 * By default, if no fieldSetSelectedState is specified, only SELECTED fields are returned.
 */ 
let $5b8397cef71e8614$export$2df7420a9bb23332 = /*#__PURE__*/ function(JiraIssueTransitionCommentType) {
    JiraIssueTransitionCommentType["InternalNote"] = "INTERNAL_NOTE";
    JiraIssueTransitionCommentType["ReplyToCustomer"] = "REPLY_TO_CUSTOMER";
    return JiraIssueTransitionCommentType;
}({}); /** Input type for field level inputs, which may be required to perform a transition for the issue */  /** Enum representing different types of messages to be shown on modal load screen */ 
let $5b8397cef71e8614$export$dafe05b7c43936e0 = /*#__PURE__*/ function(JiraIssueTransitionLayoutMessageType) {
    JiraIssueTransitionLayoutMessageType["Error"] = "ERROR";
    JiraIssueTransitionLayoutMessageType["Info"] = "INFO";
    JiraIssueTransitionLayoutMessageType["Success"] = "SUCCESS";
    JiraIssueTransitionLayoutMessageType["Warn"] = "WARN";
    return JiraIssueTransitionLayoutMessageType;
}({}); /** Represents the messages to be shown on the Transition Modal Load screen */  /** Represents the issue transition modal load screen */  /** The type for response payload, to be returned after making a transition for the issue */  /** Represents an Issue type, e.g. story, task, bug. */  /** The connection type for JiraIssueType. */  /** An edge in a JiraCommentConnection connection. */  /** Represents an issue type field on a Jira Issue. */  /** Represents an issue type field on a Jira Issue. */  /** Represents an issue type field on a Jira Issue. */  /** Input type for defining the operation on the IssueType field of a Jira issue. */  /** The payload type returned after updating the IssueType field of a Jira issue. */  /** Return only issue types that match this filter */  /**
 * The Jira IssueType hierarchy level.
 * Hierarchy levels represent Issue parent-child relationships using an integer scale.
 */ 
let $5b8397cef71e8614$export$8aef47d2eef7b927 = /*#__PURE__*/ function(JiraIssueViewActivityFeedSortOrder) {
    JiraIssueViewActivityFeedSortOrder["NewestFirst"] = "NEWEST_FIRST";
    JiraIssueViewActivityFeedSortOrder["OldestFirst"] = "OLDEST_FIRST";
    return JiraIssueViewActivityFeedSortOrder;
}({}); /** The options for the selected attachment view. */ 
let $5b8397cef71e8614$export$db6a595e3239346 = /*#__PURE__*/ function(JiraIssueViewAttachmentPanelViewMode) {
    JiraIssueViewAttachmentPanelViewMode["ListView"] = "LIST_VIEW";
    JiraIssueViewAttachmentPanelViewMode["StripView"] = "STRIP_VIEW";
    return JiraIssueViewAttachmentPanelViewMode;
}({}); /** The options for displaying timestamps. */ 
let $5b8397cef71e8614$export$c5dd6014d53eac27 = /*#__PURE__*/ function(JiraIssueViewTimestampDisplayMode) {
    JiraIssueViewTimestampDisplayMode["Absolute"] = "ABSOLUTE";
    JiraIssueViewTimestampDisplayMode["Relative"] = "RELATIVE";
    return JiraIssueViewTimestampDisplayMode;
}({});
let $5b8397cef71e8614$export$ab2f34f07eb5e4b6 = /*#__PURE__*/ function(JiraIteration) {
    JiraIteration["Iteration_1"] = "ITERATION_1";
    JiraIteration["Iteration_2"] = "ITERATION_2";
    JiraIteration["IterationDynamic"] = "ITERATION_DYNAMIC";
    return JiraIteration;
}({}); /** The options for jql builder search mode. */ 
let $5b8397cef71e8614$export$3b5b236cf36c7f9a = /*#__PURE__*/ function(JiraJqlBuilderSearchMode) {
    JiraJqlBuilderSearchMode["Advanced"] = "ADVANCED";
    JiraJqlBuilderSearchMode["Basic"] = "BASIC";
    return JiraJqlBuilderSearchMode;
}({}); /** The representation for Natural Language to JQL generation response */  /** The possible errors that can occur during a JQL generation. */  /** JQL History Node. Includes the jql. */  /** The connection to a list of JQL History. */  /** An edge in a JQL History connection. */  /**
 * The autocomplete types available for Jira fields in the context of the Jira Query Language.
 *
 * This enum also describes which fields have field-value support from this schema.
 */ 
let $5b8397cef71e8614$export$fd281481162cf736 = /*#__PURE__*/ function(JiraJqlAutocompleteType) {
    JiraJqlAutocompleteType["Basic"] = "BASIC";
    JiraJqlAutocompleteType["Cascadingoption"] = "CASCADINGOPTION";
    JiraJqlAutocompleteType["Component"] = "COMPONENT";
    JiraJqlAutocompleteType["Group"] = "GROUP";
    JiraJqlAutocompleteType["Issue"] = "ISSUE";
    JiraJqlAutocompleteType["Issuetype"] = "ISSUETYPE";
    JiraJqlAutocompleteType["JwmCategory"] = "JWM_CATEGORY";
    JiraJqlAutocompleteType["Labels"] = "LABELS";
    JiraJqlAutocompleteType["None"] = "NONE";
    JiraJqlAutocompleteType["Option"] = "OPTION";
    JiraJqlAutocompleteType["Organization"] = "ORGANIZATION";
    JiraJqlAutocompleteType["Priority"] = "PRIORITY";
    JiraJqlAutocompleteType["Project"] = "PROJECT";
    JiraJqlAutocompleteType["Requesttype"] = "REQUESTTYPE";
    JiraJqlAutocompleteType["Resolution"] = "RESOLUTION";
    JiraJqlAutocompleteType["Sprint"] = "SPRINT";
    JiraJqlAutocompleteType["Status"] = "STATUS";
    JiraJqlAutocompleteType["Statuscategory"] = "STATUSCATEGORY";
    JiraJqlAutocompleteType["TicketCategory"] = "TICKET_CATEGORY";
    JiraJqlAutocompleteType["User"] = "USER";
    JiraJqlAutocompleteType["Version"] = "VERSION";
    return JiraJqlAutocompleteType;
}({}); /**
 * Encapsulates queries and fields necessary to power the JQL builder.
 *
 * It also exposes generic JQL capabilities that can be leveraged to power other experiences.
 */ 
let $5b8397cef71e8614$export$4b728896d4330036 = /*#__PURE__*/ function(JiraJqlBuilderMode) {
    JiraJqlBuilderMode["Basic"] = "BASIC";
    JiraJqlBuilderMode["Jql"] = "JQL";
    return JiraJqlBuilderMode;
}({}); /** Represents a field-value for a JQL cascading option field. */  /** Represents a connection of field-values for a JQL cascading option field. */  /** Represents a field-value edge for a JQL cascading option field. */  /** The types of JQL clauses supported by Jira. */ 
let $5b8397cef71e8614$export$cbea312143ae44f9 = /*#__PURE__*/ function(JiraJqlClauseType) {
    JiraJqlClauseType["Any"] = "ANY";
    JiraJqlClauseType["OrderBy"] = "ORDER_BY";
    JiraJqlClauseType["Where"] = "WHERE";
    return JiraJqlClauseType;
}({}); /** Represents a field-value for a JQL component field. */  /** The representation of a Jira field within the context of the Jira Query Language. */  /** Represents a connection of Jira JQL fields. */  /** A union of a Jira JQL field connection and a GraphQL query error. */  /** Represents a Jira JQL field edge. */  /**
 * The representation of a Jira JQL field-type in the context of the Jira Query Language.
 *
 * E.g. `Short Text`, `Number`, `Version Picker`, `Team` etc.
 *
 * Important note: This information only exists for collapsed fields.
 */ 
let $5b8397cef71e8614$export$c4f30303e8f1794 = /*#__PURE__*/ function(JiraJqlFunctionStatus) {
    JiraJqlFunctionStatus["Finished"] = "FINISHED";
    JiraJqlFunctionStatus["Processing"] = "PROCESSING";
    JiraJqlFunctionStatus["Unknown"] = "UNKNOWN";
    return JiraJqlFunctionStatus;
}({}); /** Represents a field-value for a JQL goals field. */  /** Represents a field-value for a JQL group field. */  /** Represents a connection of field-values for a JQL group field. */  /** Represents a field-value edge for a JQL group field. */  /** Represents a JQL query with hydrated fields and field-values. */  /** A union of a Jira JQL hydrated query and a GraphQL query error. */  /** Represents a field-value for a JQL Issue field. */  /** Represents a field-value for a JQL issue type field. */  /** Represents a connection of field-values for a JQL issue type field. */  /** Represents a field-value edge for a JQL issue type field. */  /** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */  /** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */  /** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */  /** A variation of the fieldValues query for retrieving specifically Jira issue type field-values. */  /** Represents a field-value for a JQL label field. */  /**
 * The types of JQL operators supported by Jira.
 *
 * An operator in JQL is one or more symbols or words,which compares the value of a field on its left with one or more values (or functions) on its right,
 * such that only true results are retrieved by the clause.
 *
 * For more information on JQL operators please visit: https://support.atlassian.com/jira-software-cloud/docs/advanced-search-reference-jql-operators.
 */ 
let $5b8397cef71e8614$export$d3fe59ef06ef4fb4 = /*#__PURE__*/ function(JiraJqlOperator) {
    JiraJqlOperator["Changed"] = "CHANGED";
    JiraJqlOperator["Contains"] = "CONTAINS";
    JiraJqlOperator["Equals"] = "EQUALS";
    JiraJqlOperator["GreaterThan"] = "GREATER_THAN";
    JiraJqlOperator["GreaterThanOrEqual"] = "GREATER_THAN_OR_EQUAL";
    JiraJqlOperator["In"] = "IN";
    JiraJqlOperator["Is"] = "IS";
    JiraJqlOperator["IsNot"] = "IS_NOT";
    JiraJqlOperator["LessThan"] = "LESS_THAN";
    JiraJqlOperator["LessThanOrEqual"] = "LESS_THAN_OR_EQUAL";
    JiraJqlOperator["NotContains"] = "NOT_CONTAINS";
    JiraJqlOperator["NotEquals"] = "NOT_EQUALS";
    JiraJqlOperator["NotIn"] = "NOT_IN";
    JiraJqlOperator["Was"] = "WAS";
    JiraJqlOperator["WasIn"] = "WAS_IN";
    JiraJqlOperator["WasNot"] = "WAS_NOT";
    JiraJqlOperator["WasNotIn"] = "WAS_NOT_IN";
    return JiraJqlOperator;
}({}); /** Represents a field-value for a JQL option field. */  /** Represents a connection of field-values for a JQL option field. */  /** Represents a field-value edge for a JQL option field. */  /** Represents a field-value for a JQL plain text field (as opposed to a rich text one) such as summary. */  /** Represents a field-value for a JQL priority field. */  /** Represents a field-value for a JQL project field. */  /** Represents a connection of field-values for a JQL project field. */  /** Represents a field-value edge for a JQL project field. */  /** Represents an error for a JQL query hydration. */  /** Represents a hydrated field for a JQL query. */  /** A union of a JQL query hydrated field and a GraphQL query error. */  /** Represents a hydrated field-value for a given field in the JQL query. */  /** A union of a JQL query hydrated field-value and a GraphQL query error. */  /** Represents a field-value for a JQL resolution field. */  /** The representation of a Jira field in the basic search mode of the JQL builder. */  /** Represents a field-value for a JQL sprint field. */  /** Represents a connection of field-values for a JQL sprint field. */  /** Represents a field-value edge for a JQL sprint field. */  /** Represents a field-value for a JQL status category field. */  /** Represents a field-value for a JQL status field. */ 
let $5b8397cef71e8614$export$b4868a7397b1d1a3 = /*#__PURE__*/ function(JiraJqlSyntaxError) {
    JiraJqlSyntaxError["BadFieldId"] = "BAD_FIELD_ID";
    JiraJqlSyntaxError["BadFunctionArgument"] = "BAD_FUNCTION_ARGUMENT";
    JiraJqlSyntaxError["BadOperator"] = "BAD_OPERATOR";
    JiraJqlSyntaxError["BadPropertyId"] = "BAD_PROPERTY_ID";
    JiraJqlSyntaxError["EmptyField"] = "EMPTY_FIELD";
    JiraJqlSyntaxError["EmptyFunction"] = "EMPTY_FUNCTION";
    JiraJqlSyntaxError["EmptyFunctionArgument"] = "EMPTY_FUNCTION_ARGUMENT";
    JiraJqlSyntaxError["IllegalCharacter"] = "ILLEGAL_CHARACTER";
    JiraJqlSyntaxError["IllegalEscape"] = "ILLEGAL_ESCAPE";
    JiraJqlSyntaxError["IllegalNumber"] = "ILLEGAL_NUMBER";
    JiraJqlSyntaxError["MissingFieldName"] = "MISSING_FIELD_NAME";
    JiraJqlSyntaxError["MissingLogicalOperator"] = "MISSING_LOGICAL_OPERATOR";
    JiraJqlSyntaxError["NoOperator"] = "NO_OPERATOR";
    JiraJqlSyntaxError["NoOrder"] = "NO_ORDER";
    JiraJqlSyntaxError["OperandUnsupported"] = "OPERAND_UNSUPPORTED";
    JiraJqlSyntaxError["PredicateUnsupported"] = "PREDICATE_UNSUPPORTED";
    JiraJqlSyntaxError["ReservedCharacter"] = "RESERVED_CHARACTER";
    JiraJqlSyntaxError["ReservedWord"] = "RESERVED_WORD";
    JiraJqlSyntaxError["UnexpectedText"] = "UNEXPECTED_TEXT";
    JiraJqlSyntaxError["UnfinishedString"] = "UNFINISHED_STRING";
    JiraJqlSyntaxError["Unknown"] = "UNKNOWN";
    return JiraJqlSyntaxError;
}({}); /** Represents a field-value for a JQL user field. */  /** Represents a connection of field-values for a JQL user field. */  /** Represents a field-value edge for a JQL user field. */  /** Represents a field-value for a JQL version field. */  /** Represents a connection of field-values for a JQL version field. */  /** Represents a field-value edge for a JQL version field. */  /**
 * A variation of the fieldValues query for retrieving specifically Jira version field-values.
 *
 * This type provides the capability to retrieve connections of released, unreleased and archived versions.
 *
 * Important note: that released and unreleased versions can be archived and vice versa.
 */ 
let $5b8397cef71e8614$export$586b6450ae834916 = /*#__PURE__*/ function(JiraJqlViewContext) {
    JiraJqlViewContext["JswPlans"] = "JSW_PLANS";
    JiraJqlViewContext["Jwm"] = "JWM";
    JiraJqlViewContext["ShadowRequest"] = "SHADOW_REQUEST";
    return JiraJqlViewContext;
}({}); /** Represents the label of a custom label field. */  /** The connection type for JiraLabel. */  /** An edge in a Jiralabel connection. */  /** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */  /** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */  /** Represents a labels field on a Jira Issue. Both system & custom field can be represented by this type. */  /** Input type for labels field */  /** Represents the data of a single Label */  /** Input type for defining the operation on the Team field of a Jira issue. */  /** The payload type returned after updating the Team field of a Jira issue. */  /** Input to link/unlink an issue to/from a related work item. */  /** The return payload for linking and unlinking an issue to and from a related work item. */ 
let $5b8397cef71e8614$export$29e67496c83af6d9 = /*#__PURE__*/ function(JiraLinkIssuesToIncidentIssueLinkTypeName) {
    JiraLinkIssuesToIncidentIssueLinkTypeName["PostIncidentReviews"] = "POST_INCIDENT_REVIEWS";
    JiraLinkIssuesToIncidentIssueLinkTypeName["Relates"] = "RELATES";
    return JiraLinkIssuesToIncidentIssueLinkTypeName;
}({}); /** Represents the current state of a long running task. */ 
let $5b8397cef71e8614$export$aad956212e1cffd3 = /*#__PURE__*/ function(JiraLongRunningTaskStatus) {
    JiraLongRunningTaskStatus["Cancelled"] = "CANCELLED";
    JiraLongRunningTaskStatus["CancelRequested"] = "CANCEL_REQUESTED";
    JiraLongRunningTaskStatus["Complete"] = "COMPLETE";
    JiraLongRunningTaskStatus["Dead"] = "DEAD";
    JiraLongRunningTaskStatus["Enqueued"] = "ENQUEUED";
    JiraLongRunningTaskStatus["Failed"] = "FAILED";
    JiraLongRunningTaskStatus["Running"] = "RUNNING";
    return JiraLongRunningTaskStatus;
}({}); /** Description of a single file attachment definition. */  /** A connection for JiraMediaAttachmentFile. */  /** An edge in a JiraMediaAttachmentFile connection. */  /** A Jira Background Media, containing a reference to a custom background */  /** Represents a media context used for file uploads. */  /** Contains the information needed for reading uploaded media content in jira on issue create/view screens. */  /** Contains the information needed for reading uploaded media content in jira on issue create/view screens. */  /** Entry of an attachment read token with its respective files accessible. */  /** Entry of an attachment read token with its respective files accessible. */  /** A connection for JiraMediaTokenWithFiles. */  /** An edge in a JiraMediaTokenWithFiles connection. */  /** Contains the information needed for uploading a media content in jira on issue create/view screens. */  /** Contains either the successful fetched media token information or an error. */  /**
 * The input to merge one version with another, which deletes the source version and moves
 * all issues from the source version to the target version.
 */ 
let $5b8397cef71e8614$export$283b57df1581f83e = /*#__PURE__*/ function(JiraMultiValueFieldOperations) {
    JiraMultiValueFieldOperations["Add"] = "ADD";
    JiraMultiValueFieldOperations["Remove"] = "REMOVE";
    JiraMultiValueFieldOperations["Set"] = "SET";
    return JiraMultiValueFieldOperations;
}({}); /** Represents a multiple group picker field on a Jira Issue. */  /** Represents a multiple group picker field on a Jira Issue. */  /** Represents a multiple group picker field on a Jira Issue. */  /** Input type for multiple group picker field */  /** Input type for defining the operation on the MultipleGroupPicker field of a Jira issue. */  /** The payload type returned after updating the MultipleGroupPicker field of a Jira issue. */  /** Input type for multiple select clearable user picker fields */  /** Represents the multi-select field on a Jira Issue. */  /** Represents the multi-select field on a Jira Issue. */  /** Represents the multi-select field on a Jira Issue. */  /** Represents the multi-select field on a Jira Issue. */  /** Represents the multi-select field on a Jira Issue. */  /** Input type for multi select field */  /** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */  /** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */  /** Represents a multi select user picker field on a Jira Issue. E.g. custom user picker */  /** Input type for multiple select user picker fields */  /** Input type for defining the operation on MultipleSelectUserPicker field of a Jira issue. */  /** The payload type returned after updating MultipleSelectUserPicker field of a Jira issue. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Represents a multi version picker field on a Jira Issue. E.g. fixVersions and multi version custom field. */  /** Input type for multiple select version picker fields */  /** Input type for defining the operation on Multiple Version Picker field of a Jira issue. */  /** The payload type returned after updating Multiple Version Picker field of a Jira issue. */  /** The input used for an natural language to JQL conversion */  /** The most general interface for a navigation item. Represents pages a user can navigate to within a scope. */  /** The connection type for navigation items. */  /** The edge type for navigation items. */  /** GraphQL does not allow interfaces inside unions, need to list every implementation explicitly. */  /** General interface to represent a type of navigation item, identified by its `JiraNavigationItemTypeKey`. */  /** Connection of navigation item types. */  /** The edge type for navigation item types. */  /**
 * List of values identifying the known navigation item types. This list is shared between
 * business and software projects but only some are supported by one or the other.
 */ 
let $5b8397cef71e8614$export$36f79c8a08b4e752 = /*#__PURE__*/ function(JiraNavigationItemTypeKey) {
    JiraNavigationItemTypeKey["App"] = "APP";
    JiraNavigationItemTypeKey["Approvals"] = "APPROVALS";
    JiraNavigationItemTypeKey["Apps"] = "APPS";
    JiraNavigationItemTypeKey["ArchivedIssues"] = "ARCHIVED_ISSUES";
    JiraNavigationItemTypeKey["Attachments"] = "ATTACHMENTS";
    JiraNavigationItemTypeKey["Backlog"] = "BACKLOG";
    JiraNavigationItemTypeKey["Board"] = "BOARD";
    JiraNavigationItemTypeKey["Calendar"] = "CALENDAR";
    JiraNavigationItemTypeKey["Code"] = "CODE";
    JiraNavigationItemTypeKey["Components"] = "COMPONENTS";
    JiraNavigationItemTypeKey["Deployments"] = "DEPLOYMENTS";
    JiraNavigationItemTypeKey["Development"] = "DEVELOPMENT";
    JiraNavigationItemTypeKey["Forms"] = "FORMS";
    JiraNavigationItemTypeKey["Goals"] = "GOALS";
    JiraNavigationItemTypeKey["Incidents"] = "INCIDENTS";
    JiraNavigationItemTypeKey["Issues"] = "ISSUES";
    JiraNavigationItemTypeKey["List"] = "LIST";
    JiraNavigationItemTypeKey["OnCall"] = "ON_CALL";
    JiraNavigationItemTypeKey["Pages"] = "PAGES";
    JiraNavigationItemTypeKey["Releases"] = "RELEASES";
    JiraNavigationItemTypeKey["Reports"] = "REPORTS";
    JiraNavigationItemTypeKey["Requests"] = "REQUESTS";
    JiraNavigationItemTypeKey["Security"] = "SECURITY";
    JiraNavigationItemTypeKey["Shortcut"] = "SHORTCUT";
    JiraNavigationItemTypeKey["Shortcuts"] = "SHORTCUTS";
    JiraNavigationItemTypeKey["Summary"] = "SUMMARY";
    JiraNavigationItemTypeKey["Timeline"] = "TIMELINE";
    return JiraNavigationItemTypeKey;
}({}); /** The navigation UI state of the left sidebar and right panels user property */  /** The navigation UI state of the left sidebar and right panels user property */  /** Represents the possible notification categories for notification types. */ 
let $5b8397cef71e8614$export$b4137b99365f6ad8 = /*#__PURE__*/ function(JiraNotificationCategoryType) {
    JiraNotificationCategoryType["CommentChanges"] = "COMMENT_CHANGES";
    JiraNotificationCategoryType["IssueAssigned"] = "ISSUE_ASSIGNED";
    JiraNotificationCategoryType["IssueChanges"] = "ISSUE_CHANGES";
    JiraNotificationCategoryType["IssueMentioned"] = "ISSUE_MENTIONED";
    JiraNotificationCategoryType["IssueMiscellaneous"] = "ISSUE_MISCELLANEOUS";
    JiraNotificationCategoryType["IssueWorklogChanges"] = "ISSUE_WORKLOG_CHANGES";
    return JiraNotificationCategoryType;
}({}); /** Represents a preference for a particular notification channel. */  /** Represents the possible types notification channels. */ 
let $5b8397cef71e8614$export$ec1ac0705bb7ee00 = /*#__PURE__*/ function(JiraNotificationChannelType) {
    JiraNotificationChannelType["Email"] = "EMAIL";
    JiraNotificationChannelType["InProduct"] = "IN_PRODUCT";
    JiraNotificationChannelType["MobilePush"] = "MOBILE_PUSH";
    return JiraNotificationChannelType;
}({}); /** Represents notification preferences across all projects. */  /** Represents options for notifications that don't fit in with the recipient calculation oriented preferences in JiraNotificationPreferences. */  /** Represents a notification preference for a particular notification type. */  /** Represents a notification preferences to be updated. */  /** Represents notification preferences by notification type. */  /** The connection type for JiraNotificationProjectPreferences. */  /** Represents a project's notification preferences. */  /** Represents the possible types of notifications. */ 
let $5b8397cef71e8614$export$6e621da855f29918 = /*#__PURE__*/ function(JiraNotificationType) {
    JiraNotificationType["CommentCreated"] = "COMMENT_CREATED";
    JiraNotificationType["CommentDeleted"] = "COMMENT_DELETED";
    JiraNotificationType["CommentEdited"] = "COMMENT_EDITED";
    JiraNotificationType["IssueAssigned"] = "ISSUE_ASSIGNED";
    JiraNotificationType["IssueCreated"] = "ISSUE_CREATED";
    JiraNotificationType["IssueDeleted"] = "ISSUE_DELETED";
    JiraNotificationType["IssueMoved"] = "ISSUE_MOVED";
    JiraNotificationType["IssueUpdated"] = "ISSUE_UPDATED";
    JiraNotificationType["MentionsCombined"] = "MENTIONS_COMBINED";
    JiraNotificationType["MiscellaneousIssueEventCombined"] = "MISCELLANEOUS_ISSUE_EVENT_COMBINED";
    JiraNotificationType["WorklogCombined"] = "WORKLOG_COMBINED";
    return JiraNotificationType;
}({}); /** Represents a number field on a Jira Issue. E.g. float, story points. */  /** Input type for a number field */  /** An OAuth app which may have permissions to push/read extension data from issues */  /** Mutations */  /** An oauth app which provides devOps capabilities. */  /** The types of events published by the onSuggestedChildIssue subscription. */  /** Represents Jira OpsgenieTeam. */  /** Represents a single option value in a select operation. */  /** The connection type for JiraOption. */  /** An edge in a JiraOption connection. */  /** The input type for opting out of the Not Connected state in the DevOpsPanel */  /** The response payload for opting out of the Not Connected state in the DevOpsPanel */  /** Response for the order formatting rule mutation. */  /** Response for the order formatting rule mutation. */ 
let $5b8397cef71e8614$export$59148652a7cacd91 = /*#__PURE__*/ function(JiraOrganizationApprovalLocation) {
    JiraOrganizationApprovalLocation["DuringInstallationFlow"] = "DURING_INSTALLATION_FLOW";
    JiraOrganizationApprovalLocation["DuringProvisioning"] = "DURING_PROVISIONING";
    JiraOrganizationApprovalLocation["OnAdminScreen"] = "ON_ADMIN_SCREEN";
    JiraOrganizationApprovalLocation["RemindBitbucketApprovalBanner"] = "REMIND_BITBUCKET_APPROVAL_BANNER";
    JiraOrganizationApprovalLocation["Unknown"] = "UNKNOWN";
    return JiraOrganizationApprovalLocation;
}({}); /** Input type for an organization field */  /** Input type for an organization value */  /**
 * Represents the original time estimate field on Jira issue screens. Note that this is the same value as the originalEstimate from JiraTimeTrackingField
 * This field should only be used on issue view because issue view hasn't deprecated the original estimation as a standalone field
 */ 
let $5b8397cef71e8614$export$22ca33290808aca8 = /*#__PURE__*/ function(JiraOverviewPlanMigrationChangeboardingStatus) {
    JiraOverviewPlanMigrationChangeboardingStatus["Completed"] = "COMPLETED";
    JiraOverviewPlanMigrationChangeboardingStatus["Triggered"] = "TRIGGERED";
    return JiraOverviewPlanMigrationChangeboardingStatus;
}({}); /** Describe the state of the overview-plan migration for the calling user. */  /** Result type for the jwmOverviewPlanMigrationState field */  /** The base type cursor data necessary for random access pagination. */  /** This encapsulates all the necessary cursors for random access pagination. */  /** Input type for the parent field of an issue */  /** Input type for defining the operation on the Parent field of a Jira issue. */  /** The payload type returned after updating the Parent field of a Jira issue. */  /** Represents Parent field on a Jira Issue. E.g. JSW Parent, JPO Parent (to be unified). */  /** Represents Parent field on a Jira Issue. E.g. JSW Parent, JPO Parent (to be unified). */  /** The connection type for JiraParentOption. */  /** An edge in a JiraParentOption connection. */  /** Represents flags required to determine parent field visibility */  /** Represents a people picker field on a Jira Issue. */  /** Represents a people picker field on a Jira Issue. */  /** Represents a people picker field on a Jira Issue. */  /** Input type for people field */  /** Input type for defining the operation on People field of a Jira issue. */  /** The payload type returned after updating People field of a Jira issue. */  /**
 * This represents Jira Permission with all Permission level details (To be added)
 * and can be used to determine whether a User has certain permissions.
 * Note: This entity only returns `hasPermission`
 * but in future, it should contain more permission level details like ID, description etc.
 */ 
let $5b8397cef71e8614$export$edf2fc589cbdc = /*#__PURE__*/ function(JiraPermissionMessageTypeEnum) {
    JiraPermissionMessageTypeEnum["Information"] = "INFORMATION";
    JiraPermissionMessageTypeEnum["Warning"] = "WARNING";
    return JiraPermissionMessageTypeEnum;
}({}); /** A permission scheme is a collection of permission grants. */  /** The input type to add new permission grants to the given permission scheme. */  /** The response payload for add permission grants mutation operation for a given permission scheme. */  /** The JiraPermissionSchemeConfiguration represents additional configuration information regarding the permission scheme such as its editability. */  /**
 * The JiraPermissionSchemeGrantGroup is an association between project permission category information and a bounded list of one or more
 * associated permission grant holder. A grant holder represents project permission information and its associated permission grants.
 */ 
let $5b8397cef71e8614$export$a7ab8f3606c74f1 = /*#__PURE__*/ function(JiraPermissionTagEnum) {
    JiraPermissionTagEnum["Deprecated"] = "DEPRECATED";
    JiraPermissionTagEnum["Enterprise"] = "ENTERPRISE";
    JiraPermissionTagEnum["New"] = "NEW";
    return JiraPermissionTagEnum;
}({}); /** The different permission types that a user can perform on a global level */ 
let $5b8397cef71e8614$export$b91894fc36442fca = /*#__PURE__*/ function(JiraPermissionType) {
    JiraPermissionType["BrowseProjects"] = "BROWSE_PROJECTS";
    JiraPermissionType["BulkChange"] = "BULK_CHANGE";
    return JiraPermissionType;
}({}); /** Represents a Jira Plan */  /** The status of a Jira Plan */ 
let $5b8397cef71e8614$export$39bfd317df87a9c = /*#__PURE__*/ function(JiraPlanStatus) {
    JiraPlanStatus["Active"] = "ACTIVE";
    JiraPlanStatus["Archived"] = "ARCHIVED";
    JiraPlanStatus["Trashed"] = "TRASHED";
    return JiraPlanStatus;
}({}); /** Represents a Jira platform attachment. */  /** Represents a Jira platform attachment. */  /** Represents a Jira platform attachment. */  /** Represents a Jira platform attachment. */  /** Represents a Jira platform comment. */  /** A link to a post-incident review (also known as a postmortem). */  /** Represents an issue's priority field */  /** The connection type for JiraPriority. */  /** An edge in a JiraPriority connection. */  /** Represents a priority field on a Jira Issue. */  /** Represents a priority field on a Jira Issue. */  /** Input type for priority field */  /** Representation of each Jira product offering. */ 
let $5b8397cef71e8614$export$62abc5008715ef4b = /*#__PURE__*/ function(JiraProductEnum) {
    JiraProductEnum["JiraProductDiscovery"] = "JIRA_PRODUCT_DISCOVERY";
    JiraProductEnum["JiraServiceManagement"] = "JIRA_SERVICE_MANAGEMENT";
    JiraProductEnum["JiraSoftware"] = "JIRA_SOFTWARE";
    JiraProductEnum["JiraWorkManagement"] = "JIRA_WORK_MANAGEMENT";
    return JiraProductEnum;
}({}); /** Represents proforma-forms. */  /** Represents the proforma-forms field for an Issue. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents a Jira project. */  /** Represents whether the user has the specific project permission or not */  /** The different action types that a user can perform on a project */ 
let $5b8397cef71e8614$export$456e2c6faf3dd3d9 = /*#__PURE__*/ function(JiraProjectActionType) {
    JiraProjectActionType["CreateIssues"] = "CREATE_ISSUES";
    JiraProjectActionType["DeleteIssues"] = "DELETE_ISSUES";
    JiraProjectActionType["EditIssues"] = "EDIT_ISSUES";
    JiraProjectActionType["EditProjectConfig"] = "EDIT_PROJECT_CONFIG";
    JiraProjectActionType["LinkIssues"] = "LINK_ISSUES";
    JiraProjectActionType["ScheduleIssues"] = "SCHEDULE_ISSUES";
    JiraProjectActionType["TransitionIssues"] = "TRANSITION_ISSUES";
    JiraProjectActionType["ViewIssues"] = "VIEW_ISSUES";
    JiraProjectActionType["ViewProjectConfig"] = "VIEW_PROJECT_CONFIG";
    return JiraProjectActionType;
}({}); /** A relationship between a Jira Project and Opsgenie Team */  /** A relationship between a Jira Project and Opsgenie Team */  /** A relationship between a Jira project and a repository (Bitbucket or third party). */  /** A relationship between a Jira project and a repository (Bitbucket or third party). */  /** The connection object for a collection of Jira project and repository relationships. */  /** #################### Filtering and Sorting Inputs ##################### */  /** #################### Enums ##################### */ 
let $5b8397cef71e8614$export$6867a13128bb4266 = /*#__PURE__*/ function(JiraProjectAndRepositoryRelationshipSortBy) {
    JiraProjectAndRepositoryRelationshipSortBy["LastInferredAt"] = "LAST_INFERRED_AT";
    return JiraProjectAndRepositoryRelationshipSortBy;
}({}); /** An entry in the activity log table for project role actors. */  /** Connection type for JiraProjectCleanupLogTableEntry. */  /** An edge in a JiraProjectCleanupLogTableEntryConnection. */  /** Project cleanup recommendation. */  /** Recommendation action for a project cleanup. */ 
let $5b8397cef71e8614$export$a2f8423691ae525a = /*#__PURE__*/ function(JiraProjectCleanupRecommendationAction) {
    JiraProjectCleanupRecommendationAction["Archive"] = "ARCHIVE";
    JiraProjectCleanupRecommendationAction["Trash"] = "TRASH";
    return JiraProjectCleanupRecommendationAction;
}({}); /** Connection type for JiraProjectCleanupRecommendation. */  /** An edge in a JiraProjectCleanupRecommendation connection. */  /** A period of time since the project was found stale. */ 
let $5b8397cef71e8614$export$9c0ded90f678acb6 = /*#__PURE__*/ function(JiraProjectCleanupRecommendationStaleSince) {
    JiraProjectCleanupRecommendationStaleSince["OneYear"] = "ONE_YEAR";
    JiraProjectCleanupRecommendationStaleSince["SixMonths"] = "SIX_MONTHS";
    JiraProjectCleanupRecommendationStaleSince["TwoYears"] = "TWO_YEARS";
    return JiraProjectCleanupRecommendationStaleSince;
}({}); /** The status of the project cleanup task. */ 
let $5b8397cef71e8614$export$b2cfde8b20600ddf = /*#__PURE__*/ function(JiraProjectCleanupTaskStatusType) {
    JiraProjectCleanupTaskStatusType["Complete"] = "COMPLETE";
    JiraProjectCleanupTaskStatusType["Error"] = "ERROR";
    JiraProjectCleanupTaskStatusType["InProgress"] = "IN_PROGRESS";
    JiraProjectCleanupTaskStatusType["Pending"] = "PENDING";
    JiraProjectCleanupTaskStatusType["TerminalError"] = "TERMINAL_ERROR";
    return JiraProjectCleanupTaskStatusType;
}({}); /** The connection type for JiraProject. */  /**
 * String formats for DateTime in JiraProject, the format is in the value of the jira.date.time.picker.java.format property
 * Please refer to the "Change date and time formats" section of the "Configure the look and feel of Jira applications" page
 * https://support.atlassian.com/jira-cloud-administration/docs/configure-the-look-and-feel-of-jira-applications/
 */ 
let $5b8397cef71e8614$export$8e4f09e2e6362630 = /*#__PURE__*/ function(JiraProjectDateTimeFormat) {
    JiraProjectDateTimeFormat["CompleteDatetimeFormat"] = "COMPLETE_DATETIME_FORMAT";
    JiraProjectDateTimeFormat["DayFormat"] = "DAY_FORMAT";
    JiraProjectDateTimeFormat["DayMonthYearFormat"] = "DAY_MONTH_YEAR_FORMAT";
    JiraProjectDateTimeFormat["Relative"] = "RELATIVE";
    JiraProjectDateTimeFormat["TimeFormat"] = "TIME_FORMAT";
    return JiraProjectDateTimeFormat;
}({}); /** An edge in a JiraProject connection. */  /**
 * Represents a project field on a Jira Issue.
 * Both the system & custom project field can be represented by this type.
 */ 
let $5b8397cef71e8614$export$341e76c920e0710f = /*#__PURE__*/ function(JiraProjectListRightPanelState) {
    JiraProjectListRightPanelState["Closed"] = "CLOSED";
    JiraProjectListRightPanelState["Open"] = "OPEN";
    return JiraProjectListRightPanelState;
}({}); /** A connection that returns a paginated collection of project template */  /** An edge that contains a project template and a cursor. */  /** Simplified version of a project template. */  /** Whether or not the user has configured notification preferences for the project. */ 
let $5b8397cef71e8614$export$6e766e8806e1db62 = /*#__PURE__*/ function(JiraProjectNotificationConfigurationState) {
    JiraProjectNotificationConfigurationState["Configured"] = "CONFIGURED";
    JiraProjectNotificationConfigurationState["Default"] = "DEFAULT";
    return JiraProjectNotificationConfigurationState;
}({}); /** An edge in a JiraNotificationProjectPreferences connection. */  /** Options to filter based on project properties */  /** The project permission in Jira and it is scoped to projects. */  /**
 * The category of the project permission.
 * The category information is typically seen in the permission scheme Admin UI.
 * It is used to group the project permissions in general and available for connect app developers when registering new project permissions.
 */ 
let $5b8397cef71e8614$export$ecfca2e8f1d416c9 = /*#__PURE__*/ function(JiraProjectPermissionCategoryEnum) {
    JiraProjectPermissionCategoryEnum["Attachments"] = "ATTACHMENTS";
    JiraProjectPermissionCategoryEnum["Comments"] = "COMMENTS";
    JiraProjectPermissionCategoryEnum["Issues"] = "ISSUES";
    JiraProjectPermissionCategoryEnum["Other"] = "OTHER";
    JiraProjectPermissionCategoryEnum["Projects"] = "PROJECTS";
    JiraProjectPermissionCategoryEnum["TimeTracking"] = "TIME_TRACKING";
    JiraProjectPermissionCategoryEnum["VotersAndWatchers"] = "VOTERS_AND_WATCHERS";
    return JiraProjectPermissionCategoryEnum;
}({}); /** The different permissions that the user can have for a project */ 
let $5b8397cef71e8614$export$5b73c005b9475dcb = /*#__PURE__*/ function(JiraProjectPermissionType) {
    JiraProjectPermissionType["AddComments"] = "ADD_COMMENTS";
    JiraProjectPermissionType["AdministerProjects"] = "ADMINISTER_PROJECTS";
    JiraProjectPermissionType["ArchiveIssues"] = "ARCHIVE_ISSUES";
    JiraProjectPermissionType["AssignableUser"] = "ASSIGNABLE_USER";
    JiraProjectPermissionType["AssignIssues"] = "ASSIGN_ISSUES";
    JiraProjectPermissionType["BrowseProjects"] = "BROWSE_PROJECTS";
    JiraProjectPermissionType["CloseIssues"] = "CLOSE_ISSUES";
    JiraProjectPermissionType["CreateAttachments"] = "CREATE_ATTACHMENTS";
    JiraProjectPermissionType["CreateIssues"] = "CREATE_ISSUES";
    JiraProjectPermissionType["DeleteAllAttachments"] = "DELETE_ALL_ATTACHMENTS";
    JiraProjectPermissionType["DeleteAllComments"] = "DELETE_ALL_COMMENTS";
    JiraProjectPermissionType["DeleteAllWorklogs"] = "DELETE_ALL_WORKLOGS";
    JiraProjectPermissionType["DeleteIssues"] = "DELETE_ISSUES";
    JiraProjectPermissionType["DeleteOwnAttachments"] = "DELETE_OWN_ATTACHMENTS";
    JiraProjectPermissionType["DeleteOwnComments"] = "DELETE_OWN_COMMENTS";
    JiraProjectPermissionType["DeleteOwnWorklogs"] = "DELETE_OWN_WORKLOGS";
    JiraProjectPermissionType["EditAllComments"] = "EDIT_ALL_COMMENTS";
    JiraProjectPermissionType["EditAllWorklogs"] = "EDIT_ALL_WORKLOGS";
    JiraProjectPermissionType["EditIssues"] = "EDIT_ISSUES";
    JiraProjectPermissionType["EditIssueLayout"] = "EDIT_ISSUE_LAYOUT";
    JiraProjectPermissionType["EditOwnComments"] = "EDIT_OWN_COMMENTS";
    JiraProjectPermissionType["EditOwnWorklogs"] = "EDIT_OWN_WORKLOGS";
    JiraProjectPermissionType["EditWorkflow"] = "EDIT_WORKFLOW";
    JiraProjectPermissionType["LinkIssues"] = "LINK_ISSUES";
    JiraProjectPermissionType["ManageWatchers"] = "MANAGE_WATCHERS";
    JiraProjectPermissionType["ModifyReporter"] = "MODIFY_REPORTER";
    JiraProjectPermissionType["MoveIssues"] = "MOVE_ISSUES";
    JiraProjectPermissionType["ResolveIssues"] = "RESOLVE_ISSUES";
    JiraProjectPermissionType["ScheduleIssues"] = "SCHEDULE_ISSUES";
    JiraProjectPermissionType["SetIssueSecurity"] = "SET_ISSUE_SECURITY";
    JiraProjectPermissionType["TransitionIssues"] = "TRANSITION_ISSUES";
    JiraProjectPermissionType["UnarchiveIssues"] = "UNARCHIVE_ISSUES";
    JiraProjectPermissionType["ViewDevTools"] = "VIEW_DEV_TOOLS";
    JiraProjectPermissionType["ViewReadonlyWorkflow"] = "VIEW_READONLY_WORKFLOW";
    JiraProjectPermissionType["ViewVotersAndWatchers"] = "VIEW_VOTERS_AND_WATCHERS";
    JiraProjectPermissionType["WorkOnIssues"] = "WORK_ON_ISSUES";
    return JiraProjectPermissionType;
}({}); /** An entry in the activity log table for project role actors. */  /** Connection type for JiraProjectRoleActorLogTableEntry. */  /** An edge in a JiraProjectRoleActorLogTableEntryConnection. */  /** Project role actor recommendation. */  /** Recommendation action for a project role actor. */ 
let $5b8397cef71e8614$export$efb7762c97861711 = /*#__PURE__*/ function(JiraProjectRoleActorRecommendationAction) {
    JiraProjectRoleActorRecommendationAction["Trash"] = "TRASH";
    return JiraProjectRoleActorRecommendationAction;
}({}); /** Connection type for JiraProjectRoleActorRecommendation. */  /** An edge in a JiraProjectRoleActorRecommendation connection. */  /** User status for a project role actor. */ 
let $5b8397cef71e8614$export$b44a05ea54d6beba = /*#__PURE__*/ function(JiraProjectRoleActorUserStatus) {
    JiraProjectRoleActorUserStatus["Deleted"] = "DELETED";
    JiraProjectRoleActorUserStatus["Inactive"] = "INACTIVE";
    return JiraProjectRoleActorUserStatus;
}({}); /** The project role grant type value having the project role information. */  /** The Jira Project Shortcut that can be either a repo or basic shortcut link */  /** The supported different shortcut types */ 
let $5b8397cef71e8614$export$15a3b3ba6d4cada1 = /*#__PURE__*/ function(JiraProjectShortcutType) {
    JiraProjectShortcutType["Repository"] = "REPOSITORY";
    JiraProjectShortcutType["ShortcutLink"] = "SHORTCUT_LINK";
    JiraProjectShortcutType["Unknown"] = "UNKNOWN";
    return JiraProjectShortcutType;
}({});
let $5b8397cef71e8614$export$f4b615b47854d356 = /*#__PURE__*/ function(JiraProjectSortField) {
    JiraProjectSortField["Category"] = "CATEGORY";
    JiraProjectSortField["Favourite"] = "FAVOURITE";
    JiraProjectSortField["Key"] = "KEY";
    JiraProjectSortField["LastIssueUpdatedTime"] = "LAST_ISSUE_UPDATED_TIME";
    JiraProjectSortField["Lead"] = "LEAD";
    JiraProjectSortField["Name"] = "NAME";
    return JiraProjectSortField;
}({}); /** Jira Project statuses. */ 
let $5b8397cef71e8614$export$f24d023940410bd2 = /*#__PURE__*/ function(JiraProjectStatus) {
    JiraProjectStatus["Active"] = "ACTIVE";
    JiraProjectStatus["Archived"] = "ARCHIVED";
    JiraProjectStatus["Deleted"] = "DELETED";
    return JiraProjectStatus;
}({}); /** Jira Project Styles. */ 
let $5b8397cef71e8614$export$7108cef8ee0b9c1d = /*#__PURE__*/ function(JiraProjectStyle) {
    JiraProjectStyle["CompanyManagedProject"] = "COMPANY_MANAGED_PROJECT";
    JiraProjectStyle["TeamManagedProject"] = "TEAM_MANAGED_PROJECT";
    return JiraProjectStyle;
}({}); /** Jira Project types. */ 
let $5b8397cef71e8614$export$af05362339233870 = /*#__PURE__*/ function(JiraProjectType) {
    JiraProjectType["Business"] = "BUSINESS";
    JiraProjectType["CustomerService"] = "CUSTOMER_SERVICE";
    JiraProjectType["ProductDiscovery"] = "PRODUCT_DISCOVERY";
    JiraProjectType["ServiceDesk"] = "SERVICE_DESK";
    JiraProjectType["Software"] = "SOFTWARE";
    return JiraProjectType;
}({}); /**
 * This represents Jira Project Type, for instance, software, business. Details can be
 * found here: https://confluence.atlassian.com/adminjiraserver/jira-applications-and-project-types-overview-938846805.html
 */ 
let $5b8397cef71e8614$export$a8cdf7bc23c30cb9 = /*#__PURE__*/ function(JiraProjectsHelpCenterMappingStatus) {
    JiraProjectsHelpCenterMappingStatus["All"] = "ALL";
    JiraProjectsHelpCenterMappingStatus["Linked"] = "LINKED";
    JiraProjectsHelpCenterMappingStatus["Unlinked"] = "UNLINKED";
    return JiraProjectsHelpCenterMappingStatus;
}({}); /** Basic person information who reviews a pull-request. */  /** Possible states for Pull Requests */ 
let $5b8397cef71e8614$export$e4cb38caa605881 = /*#__PURE__*/ function(JiraPullRequestState) {
    JiraPullRequestState["Declined"] = "DECLINED";
    JiraPullRequestState["Draft"] = "DRAFT";
    JiraPullRequestState["Merged"] = "MERGED";
    JiraPullRequestState["Open"] = "OPEN";
    return JiraPullRequestState;
}({}); /** Represents the radio select field on a Jira Issue. */  /** Represents the radio select field on a Jira Issue. */  /** Represents a direction in the ranking of two issues. */ 
let $5b8397cef71e8614$export$ba97d7c27eb56d75 = /*#__PURE__*/ function(JiraRankMutationEdge) {
    JiraRankMutationEdge["Bottom"] = "BOTTOM";
    JiraRankMutationEdge["Top"] = "TOP";
    return JiraRankMutationEdge;
}({}); /** Input for ranking issues against one another using a rank field. */  /** Payload returned when `rankIssues` responds. */  /** Input for ranking a navigation item. Only pass one of beforeItemId or afterItemId. */  /** Response for the rank navigation item mutation. */  /** Response for the rank navigation item mutation. */  /** Input type for the recentItems' filter. */  /** Category of recommendation */ 
let $5b8397cef71e8614$export$8b4c07c95d919811 = /*#__PURE__*/ function(JiraRecommendationCategory) {
    JiraRecommendationCategory["CustomField"] = "CUSTOM_FIELD";
    JiraRecommendationCategory["IssueArchival"] = "ISSUE_ARCHIVAL";
    JiraRecommendationCategory["ProjectCleanup"] = "PROJECT_CLEANUP";
    JiraRecommendationCategory["ProjectRoleActor"] = "PROJECT_ROLE_ACTOR";
    return JiraRecommendationCategory;
}({}); /**
 * The release notes configuration for a version describing how to display properties,
 * types and keys for an issue
 *
 * This configuration is typically saved whenever a new release note is generated on a
 * per version basis.
 */ 
let $5b8397cef71e8614$export$88911ff8dc5ac51b = /*#__PURE__*/ function(JiraReleaseNotesIssueKeyConfig) {
    JiraReleaseNotesIssueKeyConfig["Linked"] = "LINKED";
    JiraReleaseNotesIssueKeyConfig["None"] = "NONE";
    JiraReleaseNotesIssueKeyConfig["Unlinked"] = "UNLINKED";
    return JiraReleaseNotesIssueKeyConfig;
}({}); /**
 * Used for specifying whether or not epics that haven't been released should be included
 * in the results.
 *
 * For an epic to be considered as released, at least one of the issues or subtasks within
 * it must have been released.
 */ 
let $5b8397cef71e8614$export$bb6f763ecaab7945 = /*#__PURE__*/ function(JiraReleasesEpicReleaseStatusFilter) {
    JiraReleasesEpicReleaseStatusFilter["Released"] = "RELEASED";
    JiraReleasesEpicReleaseStatusFilter["ReleasedAndUnreleased"] = "RELEASED_AND_UNRELEASED";
    return JiraReleasesEpicReleaseStatusFilter;
}({}); /**
 * Used for specifying whether or not issues that haven't been released should be included
 * in the results.
 */ 
let $5b8397cef71e8614$export$fe2e4a5cf13d7781 = /*#__PURE__*/ function(JiraReleasesIssueReleaseStatusFilter) {
    JiraReleasesIssueReleaseStatusFilter["Released"] = "RELEASED";
    JiraReleasesIssueReleaseStatusFilter["ReleasedAndUnreleased"] = "RELEASED_AND_UNRELEASED";
    JiraReleasesIssueReleaseStatusFilter["Unreleased"] = "UNRELEASED";
    return JiraReleasesIssueReleaseStatusFilter;
}({}); /**
 * Represents the remaining time estimate field on Jira issue screens and in the time tracking modal. Note that this is the same value as the remainingEstimate
 * from JiraTimeTrackingField.
 */ 
let $5b8397cef71e8614$export$d0483c6fd1bb3a85 = /*#__PURE__*/ function(JiraResourceUsageCustomFieldRecommendationAction) {
    JiraResourceUsageCustomFieldRecommendationAction["Trash"] = "TRASH";
    return JiraResourceUsageCustomFieldRecommendationAction;
}({}); /** Connection type for JiraResourceUsageCustomFieldRecommendation. */  /** An edge in a JiraResourceUsageCustomFieldRecommendation connection. */  /**
 * A resource usage metric is a measurement of a resource that may cause
 * performance degradation.
 */ 
let $5b8397cef71e8614$export$6b943f296ac5a6bd = /*#__PURE__*/ function(JiraResourceUsageRecommendationStatus) {
    JiraResourceUsageRecommendationStatus["Archived"] = "ARCHIVED";
    JiraResourceUsageRecommendationStatus["Executed"] = "EXECUTED";
    JiraResourceUsageRecommendationStatus["New"] = "NEW";
    JiraResourceUsageRecommendationStatus["Obsolete"] = "OBSOLETE";
    JiraResourceUsageRecommendationStatus["Trashed"] = "TRASHED";
    return JiraResourceUsageRecommendationStatus;
}({}); /** Possible states for Reviews */ 
let $5b8397cef71e8614$export$daac6ca3443a8579 = /*#__PURE__*/ function(JiraReviewState) {
    JiraReviewState["Approval"] = "APPROVAL";
    JiraReviewState["Closed"] = "CLOSED";
    JiraReviewState["Dead"] = "DEAD";
    JiraReviewState["Draft"] = "DRAFT";
    JiraReviewState["Rejected"] = "REJECTED";
    JiraReviewState["Review"] = "REVIEW";
    JiraReviewState["Summarize"] = "SUMMARIZE";
    JiraReviewState["Unknown"] = "UNKNOWN";
    return JiraReviewState;
}({}); /** Represents the rich text format of a rich text field. */  /** Represents a rich text field on a Jira Issue. E.g. description, environment. */  /** Input type for rich text fields. Supports both text area and wiki text fields */  /** Input type for rich text field */  /** The state information for a Jira right panel */  /** The connection type for JiraRightPanelState. */  /** An edge in a JiraRightPanelState connection. */  /** Represents a Jira ProjectRole. */  /** The connection type for JiraRole. */  /** An edge in a JiraRoleConnection connection. */  /** Represents a Jira Scenario */  /** Jira Plan ScenarioIssue node. */  /** Jira Plan ScenarioIssue node. */  /** The connection type for JiraScenarioIssueLike. */  /** The connection type for JiraScenarioIssueLike. */  /** An edge in a JiraScenarioIssueLike connection. */  /** Plan scenario data for the issue. */  /** Plan scenario data for the issue. */  /** Types of scenarios that can be an issue. */ 
let $5b8397cef71e8614$export$ac4d9d3c50ca05e6 = /*#__PURE__*/ function(JiraScenarioType) {
    JiraScenarioType["Added"] = "ADDED";
    JiraScenarioType["Deleted"] = "DELETED";
    JiraScenarioType["Deletedfromjira"] = "DELETEDFROMJIRA";
    JiraScenarioType["Updated"] = "UPDATED";
    return JiraScenarioType;
}({}); /** Response for ScheduleCalendarIssue mutation. */  /** Response for ScheduleCalendarIssueV2 mutation. */  /** Repository information provided by data-providers. */  /** Represents the abstraction over list of tabs shown on the Transition modal */  /** Represents the abstraction over list of tabs shown on the Transition modal */  /** Represents the field level details or error received */  /** Represents the contents of the tab */  /** Represent the field in context of the tabs in Issue Transition modal */  /** Represents tab of an Issue Transition Screen */  /** Represents tab of an Issue Transition Screen */  /** Represents list of tabs for transition modal */  /** Type contains information about the tab and its position */  /** Currently supported searchable entities in Jira. */  /** The connection type for JiraSearchableEntity. */  /** An edge in a JiraSearchableEntityConnection connection. */  /** The entity types of searchable items. */ 
let $5b8397cef71e8614$export$fd023c605588471d = /*#__PURE__*/ function(JiraSearchableEntityType) {
    JiraSearchableEntityType["Board"] = "BOARD";
    JiraSearchableEntityType["Dashboard"] = "DASHBOARD";
    JiraSearchableEntityType["Filter"] = "FILTER";
    JiraSearchableEntityType["Issue"] = "ISSUE";
    JiraSearchableEntityType["Plan"] = "PLAN";
    JiraSearchableEntityType["Project"] = "PROJECT";
    JiraSearchableEntityType["Queue"] = "QUEUE";
    return JiraSearchableEntityType;
}({}); /** Represents the security levels on an Issue. */  /** The connection type for JiraSecurityLevel. */  /** An edge in a JiraSecurityLevel connection. */  /** Represents security level field on a Jira Issue. Issue Security allows you to control who can and cannot view issues. */  /** Represents security level field on a Jira Issue. Issue Security allows you to control who can and cannot view issues. */  /** Input type for defining the operation on the Security Level field of a Jira issue. */  /** The payload type returned after updating the Security Level field of a Jira issue. */  /** Input type for security level field */  /** The connection type for JiraHasSelectableValue. */  /** An edge in a JiraHasSelectableValueOptions connection. */  /** Input type for selected option */  /**
 * The representation for a server error
 * E.g. database connection exception.
 */ 
let $5b8397cef71e8614$export$40c351d91e581267 = /*#__PURE__*/ function(JiraServiceManagementApprovalDecisionResponseType) {
    JiraServiceManagementApprovalDecisionResponseType["Approved"] = "approved";
    JiraServiceManagementApprovalDecisionResponseType["Declined"] = "declined";
    JiraServiceManagementApprovalDecisionResponseType["Pending"] = "pending";
    return JiraServiceManagementApprovalDecisionResponseType;
}({}); /** Represents the Approval custom field on an Issue in a JSM project. */  /** Represents the Approval custom field on an Issue in a JSM project. */  /** Represent whether approval can be achieved or not. */ 
let $5b8397cef71e8614$export$f2800242314330d1 = /*#__PURE__*/ function(JiraServiceManagementApprovalState) {
    JiraServiceManagementApprovalState["InsufficientApprovers"] = "INSUFFICIENT_APPROVERS";
    JiraServiceManagementApprovalState["Ok"] = "OK";
    return JiraServiceManagementApprovalState;
}({}); /** Represents details of the approval status. */  /** The user and decision that approved the approval. */  /** The connection type for JiraServiceManagementApprover. */  /** An edge in a JiraServiceManagementApprover connection. */  /** Approver principals are either users or groups that may decide on an approval. */  /** The connection type for JiraServiceManagementApproverPrincipal. */  /** An edge in a JiraServiceManagementApproverPrincipal connection. */  /** Represents the configuration details of the users providing approval. */  /**
 * Represents an attachment within a JiraServiceManagement project.
 * @deprecated: This type is unused as JSM Attachments has no distinct field attributes from the common type JiraAttachment
 */ 
let $5b8397cef71e8614$export$9c65915394dd59bf = /*#__PURE__*/ function(JiraServiceManagementCommentVisibility) {
    JiraServiceManagementCommentVisibility["Internal"] = "INTERNAL";
    JiraServiceManagementCommentVisibility["VisibleToHelpseeker"] = "VISIBLE_TO_HELPSEEKER";
    return JiraServiceManagementCommentVisibility;
}({}); /** Represents an approval that is completed. */  /** Represents an approval that is completed. */  /** The connection type for JiraServiceManagementCompletedApproval. */  /** An edge in a JiraServiceManagementCompletedApproval connection. */  /** Represent the input data for create workflow and associate it to the issue type. */  /** Represents payload of create and associate workflow mutation. */  /** Input for FORM_TEMPLATE_REFERENCE or REQUEST_TYPE_TEMPLATE_REFERENCE JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType. */  /** This enum represents different input variation for the "request form" part of the new request type to be created. */ 
let $5b8397cef71e8614$export$bd4a236d84b2f605 = /*#__PURE__*/ function(JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType) {
    JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType["FormTemplateReference"] = "FORM_TEMPLATE_REFERENCE";
    JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType["RequestTypeTemplateReference"] = "REQUEST_TYPE_TEMPLATE_REFERENCE";
    return JiraServiceManagementCreateRequestTypeFromTemplateRequestFormInputType;
}({}); /** This enum represent different action variation for workflow. */ 
let $5b8397cef71e8614$export$f35e6061c0db2138 = /*#__PURE__*/ function(JiraServiceManagementCreateRequestTypeFromTemplateWorkflowAction) {
    JiraServiceManagementCreateRequestTypeFromTemplateWorkflowAction["Share"] = "SHARE";
    return JiraServiceManagementCreateRequestTypeFromTemplateWorkflowAction;
}({}); /** This enum represent different input variation for workflow which will be associated with the new request type to be created. */ 
let $5b8397cef71e8614$export$bfa88ab509b645e1 = /*#__PURE__*/ function(JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInputType) {
    JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInputType["ReferenceThroughIssueType"] = "REFERENCE_THROUGH_ISSUE_TYPE";
    return JiraServiceManagementCreateRequestTypeFromTemplateWorkflowInputType;
}({}); /** Input for CreateRequestTypeFromTemplateWorkflowInputType.REFERENCE_THROUGH_ISSUE_TYPE . */  /** Date Preview Field */  /**
 * Represents a datetime field on an Issue in a JSM project.
 * Deprecated: Please use `JiraDateTimePickerField`.
 */ 
let $5b8397cef71e8614$export$ddab2c249424d3a2 = /*#__PURE__*/ function(JiraServiceManagementMajorIncident) {
    JiraServiceManagementMajorIncident["MajorIncident"] = "MAJOR_INCIDENT";
    return JiraServiceManagementMajorIncident;
}({}); /** Represents the major incident field for an Issue in a JSM project. */  /** MultiCheckboxes Field */  /**
 * Multiselect Preview Field
 * Allows users to select more than one option from a list.
 */ 
let $5b8397cef71e8614$export$e93d85fe60017d05 = /*#__PURE__*/ function(JiraServiceManagementPractice) {
    JiraServiceManagementPractice["ChangeManagement"] = "CHANGE_MANAGEMENT";
    JiraServiceManagementPractice["DeveloperEscalation"] = "DEVELOPER_ESCALATION";
    JiraServiceManagementPractice["IncidentManagement"] = "INCIDENT_MANAGEMENT";
    JiraServiceManagementPractice["PostIncidentReview"] = "POST_INCIDENT_REVIEW";
    JiraServiceManagementPractice["ProblemManagement"] = "PROBLEM_MANAGEMENT";
    JiraServiceManagementPractice["ServiceRequest"] = "SERVICE_REQUEST";
    return JiraServiceManagementPractice;
}({}); /**
 * Preview Option
 * Represents a single option in a drop-down list
 */ 
let $5b8397cef71e8614$export$3292ab1fe1c3cdee = /*#__PURE__*/ function(JiraServiceManagementRendererType) {
    JiraServiceManagementRendererType["AtlassianWikiRendererType"] = "ATLASSIAN_WIKI_RENDERER_TYPE";
    JiraServiceManagementRendererType["JiraTextRendererType"] = "JIRA_TEXT_RENDERER_TYPE";
    return JiraServiceManagementRendererType;
}({}); /** Represents the Request Feedback custom field on an Issue in a JSM project. */  /** Represents the Request Language field on an Issue in a JSM project. */  /** Requests the request type structure on an Issue. */  /** The connection type for JiraServiceManagementRequestType. */  /** An edge in a JiraServiceManagementIssueType connection. */  /** Represents the request type field for an Issue in a JSM project. */  /** Represents the request type field for an Issue in a JSM project. */  /**
 * Request Type Field Common
 * These are properties common to each request form field.
 */ 
let $5b8397cef71e8614$export$34d7d8d807e96acf = /*#__PURE__*/ function(JiraShareableEntityGrant) {
    JiraShareableEntityGrant["AnonymousAccess"] = "ANONYMOUS_ACCESS";
    JiraShareableEntityGrant["AnyLoggedinUserApplicationRole"] = "ANY_LOGGEDIN_USER_APPLICATION_ROLE";
    JiraShareableEntityGrant["Group"] = "GROUP";
    JiraShareableEntityGrant["Project"] = "PROJECT";
    JiraShareableEntityGrant["ProjectRole"] = "PROJECT_ROLE";
    JiraShareableEntityGrant["ProjectUnknown"] = "PROJECT_UNKNOWN";
    JiraShareableEntityGrant["User"] = "USER";
    return JiraShareableEntityGrant;
}({}); /** GROUP grant type. */  /** Input for the group that will be granted permission. */  /** PROJECT grant type. */  /** Input for the project ID, members of which will be granted permission. */  /** PROJECT_ROLE grant type. */  /**
 * Input for the id of the role.
 * Users with the specified role will be granted permission.
 */ 
let $5b8397cef71e8614$export$1f76696f6d16d0a3 = /*#__PURE__*/ function(JiraSingleValueFieldOperations) {
    JiraSingleValueFieldOperations["Set"] = "SET";
    return JiraSingleValueFieldOperations;
}({}); /** Represents a version field on a Jira Issue. E.g. custom version picker field. */  /** Represents a version field on a Jira Issue. E.g. custom version picker field. */  /** Represents a version field on a Jira Issue. E.g. custom version picker field. */  /** Input type for single select version picker fields */  /** Input type for defining the operation on the SingleVersionPicker field of a Jira issue. */  /** The payload type returned after updating the SingleVersionPicker field of a Jira issue. */  /** Board and project scope navigation items in JSW. */  /** Custom input definition for Jira Software issue search. */  /**
 * Additional context for Jira Software custom issue search, optionally constraining the search
 * by adding additional clauses to the search query.
 */ 
let $5b8397cef71e8614$export$8da1ba7785d00ed1 = /*#__PURE__*/ function(JiraSoftwareIssueSearchCustomInputContext) {
    JiraSoftwareIssueSearchCustomInputContext["Backlog"] = "BACKLOG";
    JiraSoftwareIssueSearchCustomInputContext["Board"] = "BOARD";
    JiraSoftwareIssueSearchCustomInputContext["None"] = "NONE";
    return JiraSoftwareIssueSearchCustomInputContext;
}({}); /** Types of Jira built in jira pages available for navigation */ 
let $5b8397cef71e8614$export$50c12a2a3005ac54 = /*#__PURE__*/ function(JiraSoftwareSimpleNavigationItemEnum) {
    JiraSoftwareSimpleNavigationItemEnum["JswBacklog"] = "JSW_BACKLOG";
    JiraSoftwareSimpleNavigationItemEnum["JswBoard"] = "JSW_BOARD";
    JiraSoftwareSimpleNavigationItemEnum["JswCalendar"] = "JSW_CALENDAR";
    JiraSoftwareSimpleNavigationItemEnum["JswCode"] = "JSW_CODE";
    JiraSoftwareSimpleNavigationItemEnum["JswComponents"] = "JSW_COMPONENTS";
    JiraSoftwareSimpleNavigationItemEnum["JswDeployments"] = "JSW_DEPLOYMENTS";
    JiraSoftwareSimpleNavigationItemEnum["JswGoals"] = "JSW_GOALS";
    JiraSoftwareSimpleNavigationItemEnum["JswIncidents"] = "JSW_INCIDENTS";
    JiraSoftwareSimpleNavigationItemEnum["JswIssues"] = "JSW_ISSUES";
    JiraSoftwareSimpleNavigationItemEnum["JswList"] = "JSW_LIST";
    JiraSoftwareSimpleNavigationItemEnum["JswOnCall"] = "JSW_ON_CALL";
    JiraSoftwareSimpleNavigationItemEnum["JswPages"] = "JSW_PAGES";
    JiraSoftwareSimpleNavigationItemEnum["JswReleases"] = "JSW_RELEASES";
    JiraSoftwareSimpleNavigationItemEnum["JswReports"] = "JSW_REPORTS";
    JiraSoftwareSimpleNavigationItemEnum["JswRequests"] = "JSW_REQUESTS";
    JiraSoftwareSimpleNavigationItemEnum["JswSecurity"] = "JSW_SECURITY";
    JiraSoftwareSimpleNavigationItemEnum["JswShortcuts"] = "JSW_SHORTCUTS";
    JiraSoftwareSimpleNavigationItemEnum["JswTimeline"] = "JSW_TIMELINE";
    return JiraSoftwareSimpleNavigationItemEnum;
}({}); /** Represents the sprint field of an issue. */  /** Represents the sprint field of an issue. */  /** The connection type for JiraSprint. */  /** An edge in a JiraSprint connection. */  /** Represents sprint field on a Jira Issue. */  /** Represents sprint field on a Jira Issue. */  /** Represents sprint field on a Jira Issue. */  /** Input type for sprint field */  /** Input type for sprints */  /** Represents progress of a sprint */  /** Represents progress of a sprint */  /** Represents the state of the sprint. */ 
let $5b8397cef71e8614$export$4b13eb4595f55ffa = /*#__PURE__*/ function(JiraSprintState) {
    JiraSprintState["Active"] = "ACTIVE";
    JiraSprintState["Closed"] = "CLOSED";
    JiraSprintState["Future"] = "FUTURE";
    return JiraSprintState;
}({}); /** Represents the status field of an issue. */  /** Represents the category of a status. */  /** Color of the status category. */ 
let $5b8397cef71e8614$export$539cfae207f2a8d6 = /*#__PURE__*/ function(JiraStatusCategoryColor) {
    JiraStatusCategoryColor["BlueGray"] = "BLUE_GRAY";
    JiraStatusCategoryColor["Brown"] = "BROWN";
    JiraStatusCategoryColor["Green"] = "GREEN";
    JiraStatusCategoryColor["MediumGray"] = "MEDIUM_GRAY";
    JiraStatusCategoryColor["WarmRed"] = "WARM_RED";
    JiraStatusCategoryColor["Yellow"] = "YELLOW";
    return JiraStatusCategoryColor;
}({}); /** Represents Status Category field. */  /** Represents the status category wise estimate counts */  /** The connection type for JiraStatusCategoryProgress. */  /** An edge in a JiraStatusCategoryProgress connection. */  /** Represents Status field. */  /** Represents Status field. */  /** This is an input argument client will have to give in order to perform bulk edit submit */  /** Response returned by the backend to client after performing bulk operation */  /** Progress object containing taskId for the submitted bulk operation */  /** Deprecated type. Please use `childIssues` field under `JiraIssue` instead. */  /** Deprecated type. Please use `childIssues` field under `JiraIssue` instead. */  /** Represents an error that occurred during the suggest child issues feature */  /** Represents the status of the suggest child issues feature */  /** The type representing the status of the suggest child issues feature */ 
let $5b8397cef71e8614$export$f61057e011c8c809 = /*#__PURE__*/ function(JiraSuggestedChildIssueStatusType) {
    JiraSuggestedChildIssueStatusType["Complete"] = "COMPLETE";
    JiraSuggestedChildIssueStatusType["RefiningSuggestedIssues"] = "REFINING_SUGGESTED_ISSUES";
    JiraSuggestedChildIssueStatusType["ReformattingIssues"] = "REFORMATTING_ISSUES";
    JiraSuggestedChildIssueStatusType["RemovingDuplicateIssues"] = "REMOVING_DUPLICATE_ISSUES";
    JiraSuggestedChildIssueStatusType["RetrievingSourceContext"] = "RETRIEVING_SOURCE_CONTEXT";
    JiraSuggestedChildIssueStatusType["SuggestingInitialIssues"] = "SUGGESTING_INITIAL_ISSUES";
    return JiraSuggestedChildIssueStatusType;
}({}); /** Represents a suggested child issue */  /** Represents the different types of errors that will be returned by the suggest child issues feature */ 
let $5b8397cef71e8614$export$f7abe62a0ee830d = /*#__PURE__*/ function(JiraSuggestedIssueErrorType) {
    JiraSuggestedIssueErrorType["CommunicationsError"] = "COMMUNICATIONS_ERROR";
    JiraSuggestedIssueErrorType["NotEnoughInformation"] = "NOT_ENOUGH_INFORMATION";
    JiraSuggestedIssueErrorType["NoFurtherSuggestions"] = "NO_FURTHER_SUGGESTIONS";
    JiraSuggestedIssueErrorType["Unclassified"] = "UNCLASSIFIED";
    JiraSuggestedIssueErrorType["UnethicalContent"] = "UNETHICAL_CONTENT";
    return JiraSuggestedIssueErrorType;
}({}); /** Represents the common structure across Issue fields value suggestion. */ 
let $5b8397cef71e8614$export$6edac7c7d2e8c8c9 = /*#__PURE__*/ function(JiraSuggestedIssueFieldValueError) {
    JiraSuggestedIssueFieldValueError["HaveRequiredField"] = "HAVE_REQUIRED_FIELD";
    JiraSuggestedIssueFieldValueError["IsSubTask"] = "IS_SUB_TASK";
    JiraSuggestedIssueFieldValueError["NotEnoughInformation"] = "NOT_ENOUGH_INFORMATION";
    JiraSuggestedIssueFieldValueError["NoFurtherSuggestions"] = "NO_FURTHER_SUGGESTIONS";
    JiraSuggestedIssueFieldValueError["SuggestionIsNotEnabled"] = "SUGGESTION_IS_NOT_ENABLED";
    JiraSuggestedIssueFieldValueError["Unclassified"] = "UNCLASSIFIED";
    return JiraSuggestedIssueFieldValueError;
}({}); /** The result of a suggested issue field value query */  /**
 * Represents an issue supplied to the suggest child issues feature to prevent semantically similar issues from being
 * suggested
 */ 
let $5b8397cef71e8614$export$edaa045cf8e612c1 = /*#__PURE__*/ function(JiraTimeFormat) {
    JiraTimeFormat["Days"] = "DAYS";
    JiraTimeFormat["Hours"] = "HOURS";
    JiraTimeFormat["Pretty"] = "PRETTY";
    return JiraTimeFormat;
}({}); /** Represents the time tracking field on Jira issue screens. */  /** Input for TimeTracking field */  /** Represents the type for representing global time tracking settings. */  /**
 * Different time units supported for entering & displaying time tracking related data.
 * Get the currently configured default duration to use when parsing duration string for time tracking.
 */ 
let $5b8397cef71e8614$export$98bcea6c013bc229 = /*#__PURE__*/ function(JiraTimeUnit) {
    JiraTimeUnit["Day"] = "DAY";
    JiraTimeUnit["Hour"] = "HOUR";
    JiraTimeUnit["Minute"] = "MINUTE";
    JiraTimeUnit["Week"] = "WEEK";
    return JiraTimeUnit;
}({}); /** The connection type for JiraTransition. */  /** An edge in a JiraTransition connection. */  /** Input type for transition screen when fields have to be edited */  /** Enum representing different sort options for transitions. */ 
let $5b8397cef71e8614$export$f68bbce1273585a7 = /*#__PURE__*/ function(JiraTransitionSortOption) {
    JiraTransitionSortOption["OpsBar"] = "OPS_BAR";
    JiraTransitionSortOption["OpsBarThenStatusCategory"] = "OPS_BAR_THEN_STATUS_CATEGORY";
    return JiraTransitionSortOption;
}({}); /** The representation for an error message that can be exposed to the UI. */ 
let $5b8397cef71e8614$export$8cb0419b0b598690 = /*#__PURE__*/ function(JiraUiModificationsViewType) {
    JiraUiModificationsViewType["Gic"] = "GIC";
    JiraUiModificationsViewType["IssueTransition"] = "IssueTransition";
    JiraUiModificationsViewType["IssueView"] = "IssueView";
    JiraUiModificationsViewType["JsmRequestCreate"] = "JSMRequestCreate";
    return JiraUiModificationsViewType;
}({}); /** Input for attributing Unsplash images */  /** The response for the attributeUnsplashImage mutation */  /** The result of an Unsplash image search */  /**
 * The input for searching Unsplash images. Uses Unsplash's API definition for pagination
 * https://unsplash.com/documentation#parameters-16
 */ 
let $5b8397cef71e8614$export$5e761940e4c8e671 = /*#__PURE__*/ function(JiraVersionApproverStatus) {
    JiraVersionApproverStatus["Approved"] = "APPROVED";
    JiraVersionApproverStatus["Declined"] = "DECLINED";
    JiraVersionApproverStatus["Pending"] = "PENDING";
    return JiraVersionApproverStatus;
}({}); /**
 * Marketplace connect app iframe data for Version details page's top right corner extension
 * point(location: atl.jira.releasereport.top.right.panels)
 * If options is null, parsing string json into json object failed while mapping.
 */ 
let $5b8397cef71e8614$export$ec4fbd90ada48f79 = /*#__PURE__*/ function(JiraVersionDetailsCollapsedUi) {
    JiraVersionDetailsCollapsedUi["Description"] = "DESCRIPTION";
    JiraVersionDetailsCollapsedUi["Issues"] = "ISSUES";
    JiraVersionDetailsCollapsedUi["IssueAssociatedDesigns"] = "ISSUE_ASSOCIATED_DESIGNS";
    JiraVersionDetailsCollapsedUi["ProgressCard"] = "PROGRESS_CARD";
    JiraVersionDetailsCollapsedUi["RelatedWork"] = "RELATED_WORK";
    JiraVersionDetailsCollapsedUi["RichTextSection"] = "RICH_TEXT_SECTION";
    JiraVersionDetailsCollapsedUi["RightSidebar"] = "RIGHT_SIDEBAR";
    return JiraVersionDetailsCollapsedUi;
}({}); /** The connection type for JiraVersionDriver. */  /** An edge in a JiraVersionDriver connection. */  /** An edge in a JiraVersion connection. */  /** Input for Versions values on fields */  /** The table column enum of version details page. */ 
let $5b8397cef71e8614$export$41dca0c2bc0964ff = /*#__PURE__*/ function(JiraVersionIssueTableColumn) {
    JiraVersionIssueTableColumn["BuildStatus"] = "BUILD_STATUS";
    JiraVersionIssueTableColumn["DeploymentStatus"] = "DEPLOYMENT_STATUS";
    JiraVersionIssueTableColumn["DevelopmentStatus"] = "DEVELOPMENT_STATUS";
    JiraVersionIssueTableColumn["FeatureFlagStatus"] = "FEATURE_FLAG_STATUS";
    JiraVersionIssueTableColumn["IssueAssignee"] = "ISSUE_ASSIGNEE";
    JiraVersionIssueTableColumn["IssuePriority"] = "ISSUE_PRIORITY";
    JiraVersionIssueTableColumn["IssueStatus"] = "ISSUE_STATUS";
    JiraVersionIssueTableColumn["MoreAction"] = "MORE_ACTION";
    JiraVersionIssueTableColumn["Warnings"] = "WARNINGS";
    return JiraVersionIssueTableColumn;
}({}); /** Type for the result of an update operation to an issue in a version */  /** The filter for a version's issues */ 
let $5b8397cef71e8614$export$2f70e0a7311bc8e6 = /*#__PURE__*/ function(JiraVersionIssuesFilter) {
    JiraVersionIssuesFilter["All"] = "ALL";
    JiraVersionIssuesFilter["Done"] = "DONE";
    JiraVersionIssuesFilter["FailingBuild"] = "FAILING_BUILD";
    JiraVersionIssuesFilter["InProgress"] = "IN_PROGRESS";
    JiraVersionIssuesFilter["OpenPullRequest"] = "OPEN_PULL_REQUEST";
    JiraVersionIssuesFilter["OpenReview"] = "OPEN_REVIEW";
    JiraVersionIssuesFilter["Todo"] = "TODO";
    JiraVersionIssuesFilter["UnreviewedCode"] = "UNREVIEWED_CODE";
    return JiraVersionIssuesFilter;
}({}); /** Fields that can be used to sort issues returned on the version. */ 
let $5b8397cef71e8614$export$70909551a8657943 = /*#__PURE__*/ function(JiraVersionIssuesSortField) {
    JiraVersionIssuesSortField["Assignee"] = "ASSIGNEE";
    JiraVersionIssuesSortField["Created"] = "CREATED";
    JiraVersionIssuesSortField["Key"] = "KEY";
    JiraVersionIssuesSortField["Priority"] = "PRIORITY";
    JiraVersionIssuesSortField["Status"] = "STATUS";
    JiraVersionIssuesSortField["Type"] = "TYPE";
    return JiraVersionIssuesSortField;
}({}); /** The sort criteria used for a version's issues */ 
let $5b8397cef71e8614$export$e857541964b7b4a4 = /*#__PURE__*/ function(JiraVersionIssuesStatusCategories) {
    JiraVersionIssuesStatusCategories["Done"] = "DONE";
    JiraVersionIssuesStatusCategories["InProgress"] = "IN_PROGRESS";
    JiraVersionIssuesStatusCategories["Todo"] = "TODO";
    return JiraVersionIssuesStatusCategories;
}({}); /** Type representing cross project version changes in a plan scenario */  /** Jira version related work type, which is used to associate "smart links" with a given Jira version. */  /** The connection type for JiraVersionRelatedWork. */  /** An edge in a JiraVersionRelatedWork connection. */  /** Jira version related work type, which is used to associate "smart links" with a given Jira version. */  /** Jira version related work type, which is used to associate "smart links" with a given Jira version. */  /** Enumeration of the kinds of Jira version related work items. */ 
let $5b8397cef71e8614$export$df98b03ce20f1d71 = /*#__PURE__*/ function(JiraVersionRelatedWorkType) {
    JiraVersionRelatedWorkType["ConfluenceReleaseNotes"] = "CONFLUENCE_RELEASE_NOTES";
    JiraVersionRelatedWorkType["GenericLink"] = "GENERIC_LINK";
    JiraVersionRelatedWorkType["NativeReleaseNotes"] = "NATIVE_RELEASE_NOTES";
    return JiraVersionRelatedWorkType;
}({}); /** Jira version related work type, which is used to associate "smart links" with a given Jira version. */  /** The connection type for JiraVersionRelatedWork. */  /** An edge in a JiraVersionRelatedWork connection. */  /** The input for fetching a preview of the release notes */  /** Types of Release Notes that are available */ 
let $5b8397cef71e8614$export$f1ccce3810e15115 = /*#__PURE__*/ function(JiraVersionReleaseNotesType) {
    JiraVersionReleaseNotesType["ConfluenceReleaseNote"] = "CONFLUENCE_RELEASE_NOTE";
    JiraVersionReleaseNotesType["NativeReleaseNote"] = "NATIVE_RELEASE_NOTE";
    return JiraVersionReleaseNotesType;
}({}); /** Contains either the successful fetched version information or an error. */  /** Version rich text section */  /** The argument for sorting project versions. */ 
let $5b8397cef71e8614$export$14819bc3909a411 = /*#__PURE__*/ function(JiraVersionSortField) {
    JiraVersionSortField["Description"] = "DESCRIPTION";
    JiraVersionSortField["Name"] = "NAME";
    JiraVersionSortField["ReleaseDate"] = "RELEASE_DATE";
    JiraVersionSortField["Sequence"] = "SEQUENCE";
    JiraVersionSortField["StartDate"] = "START_DATE";
    return JiraVersionSortField;
}({}); /** The status of a version field. */ 
let $5b8397cef71e8614$export$661a9c551e5e752c = /*#__PURE__*/ function(JiraVersionStatus) {
    JiraVersionStatus["Archived"] = "ARCHIVED";
    JiraVersionStatus["Released"] = "RELEASED";
    JiraVersionStatus["Unreleased"] = "UNRELEASED";
    return JiraVersionStatus;
}({}); /** The connection type for Jira Version approver suggestion */  /** The edge type for Jira Version approver suggestion */  /** The input to update approval description */  /** The return payload of updating an approval description */  /** The input to update approval status */  /** The return payload of updating an approval description */  /** GraphQL input shape for updating an entire(all fields) version object */  /**
 * The warning configuration to be updated for version details page warning report.
 * Applicable values will have their value updated. Null values will default to true.
 */ 
let $5b8397cef71e8614$export$fc74821556ba9086 = /*#__PURE__*/ function(JiraVersionWarningCategories) {
    JiraVersionWarningCategories["FailingBuild"] = "FAILING_BUILD";
    JiraVersionWarningCategories["OpenPullRequest"] = "OPEN_PULL_REQUEST";
    JiraVersionWarningCategories["OpenReview"] = "OPEN_REVIEW";
    JiraVersionWarningCategories["UnreviewedCode"] = "UNREVIEWED_CODE";
    return JiraVersionWarningCategories;
}({}); /** The warning configuration to generate version details page warning report. */  /** The warning config for version details page to generate warning report. Depending on tenant settings and providers installed, some warning config could be in NOT_APPLICABLE state. */ 
let $5b8397cef71e8614$export$953aa8fa6e3444b5 = /*#__PURE__*/ function(JiraVersionWarningConfigState) {
    JiraVersionWarningConfigState["Disabled"] = "DISABLED";
    JiraVersionWarningConfigState["Enabled"] = "ENABLED";
    JiraVersionWarningConfigState["NotApplicable"] = "NOT_APPLICABLE";
    return JiraVersionWarningConfigState;
}({}); /** Input for the view that can be shared across multiple products, i.e., Jira Calendar */  /** The reason why an extension shouldn't be visible in the given context. */ 
let $5b8397cef71e8614$export$d93e6e69204ae0db = /*#__PURE__*/ function(JiraVisibilityControlMechanism) {
    JiraVisibilityControlMechanism["AppAccessRules"] = "AppAccessRules";
    JiraVisibilityControlMechanism["DisplayConditions"] = "DisplayConditions";
    return JiraVisibilityControlMechanism;
}({}); /** Represents the votes information of an Issue. */  /** Represents a votes field on a Jira Issue. */  /** Represents a votes field on a Jira Issue. */  /** Operations that can be performed on vote field. */ 
let $5b8397cef71e8614$export$b1636d2c563ea928 = /*#__PURE__*/ function(JiraVotesOperations) {
    JiraVotesOperations["Add"] = "ADD";
    JiraVotesOperations["Remove"] = "REMOVE";
    return JiraVotesOperations;
}({}); /** Represents the watches information. */  /** Represents the Watches system field. */  /** Represents the Watches system field. */  /** Represents the Watches system field. */  /** Operations that can be performed on watches field. */ 
let $5b8397cef71e8614$export$859195aa80d24a0e = /*#__PURE__*/ function(JiraWatchesOperations) {
    JiraWatchesOperations["Add"] = "ADD";
    JiraWatchesOperations["Remove"] = "REMOVE";
    return JiraWatchesOperations;
}({}); /** Represents a WorkCategory. */  /** Represents the WorkCategory field on an Issue. */  /** The connection type for JiraWorklog. */  /** An edge in a JiraWorkLog connection. */  /** Represents the log work field on jira issue screens. Used to log time while working on issues */  /** A Jira Work Management Attachment Background, used only when the entity is of Issue type */  /** Interface for backgrounds in JWM */  /** The supported background types */ 
let $5b8397cef71e8614$export$bba45fb1219c9de3 = /*#__PURE__*/ function(JiraWorkManagementBackgroundType) {
    JiraWorkManagementBackgroundType["Attachment"] = "ATTACHMENT";
    JiraWorkManagementBackgroundType["Color"] = "COLOR";
    JiraWorkManagementBackgroundType["Custom"] = "CUSTOM";
    JiraWorkManagementBackgroundType["Gradient"] = "GRADIENT";
    return JiraWorkManagementBackgroundType;
}({}); /** Type to hold Jira Work Management Background upload token auth details */  /** A Jira Work Management Background which is a solid color type */  /** Input for creating a Jira Work Management Custom Background */  /** The response for the jwmCreateCustomBackground mutation */  /** Represents the input data required for JWM issue creation. */  /** Represents the payload of the JWM Create Issue mutation. */  /** Input for creating a Jira Work Management Overview. */  /** Input for creating a saved view. */  /** Response for the create saved view mutation. */  /** The type for a Jira Work Management Custom Background, which is associated with a Media API file */  /** The type for a Jira Work Management Custom Background, which is associated with a Media API file */  /** The connection type for Jira Work Management Custom Background. */  /** The edge type for Jira Work Management Custom Background. */  /** Represents the input data required for Jwm Delete Attachment mutation. */  /** Represents the payload of the Jwm Delete Attachment mutation. */  /** The input for deleting a custom background */  /** The response for the jwmDeleteCustomBackground mutation */  /** Input for deleting a Jira Work Management Overview. */  /** A node that represents a Jira Work Management form and all the configuration associated with it. */  /** Represents a Jira Issue Field and its alias within the form. */  /** Response for the create Jira Work Management Overview mutation. */  /** Response for the delete Jira Work Management Overview mutation. */  /** Represents a Jira Work Management Overview. This is currently used in Jira Work Management as a collection of Projects. */  /** Represents a Jira Work Management Overview. This is currently used in Jira Work Management as a collection of Projects. */  /** Represents a Jira Work Management Overview. This is currently used in Jira Work Management as a collection of Projects. */  /** The connection type for Jira Work Management Overview. */  /** The edge type for Jira Work Management Overview. */  /** Response for the update Jira Work Management Overview mutation. */  /** A Jira Work Management Background which is a gradient type */  /** A Jira Work Management Media Background Media, containing a reference to a custom background */  /** Represents the input data to rank an issue upon creation. */  /** The input for deleting an active background */  /** The response for the jwmRemoveActiveBackground mutation */  /** The general concrete type for navigation items in JWM. Represents a saved view in the horizontal navigation. */  /** Represents a type of saved view, identified by its `JiraNavigationItemTypeKey`. */  /** The connection type for saved view types. */  /** The edge type for saved view types. */  /** The response for the jwmUpdateActiveBackground mutation */  /** The input for updating a Jira Work Management Background */  /** The input for updating a custom background */  /** The returned payload when updating a custom background */  /** Input for updating a Jira Work Management Overview. */ 
let $5b8397cef71e8614$export$2eb64d234500f795 = /*#__PURE__*/ function(JiraWorkManagementUserLicenseSeatEdition) {
    JiraWorkManagementUserLicenseSeatEdition["Free"] = "FREE";
    JiraWorkManagementUserLicenseSeatEdition["Premium"] = "PREMIUM";
    JiraWorkManagementUserLicenseSeatEdition["Standard"] = "STANDARD";
    return JiraWorkManagementUserLicenseSeatEdition;
}({}); /** Represents a Jira worklog. */  /** Accepted Worklog adjustments */ 
let $5b8397cef71e8614$export$6ff2b5b641c7145c = /*#__PURE__*/ function(JiraWorklogAdjustmentEstimateOperation) {
    JiraWorklogAdjustmentEstimateOperation["Auto"] = "AUTO";
    JiraWorklogAdjustmentEstimateOperation["Leave"] = "LEAVE";
    JiraWorklogAdjustmentEstimateOperation["Manual"] = "MANUAL";
    JiraWorklogAdjustmentEstimateOperation["New"] = "NEW";
    return JiraWorklogAdjustmentEstimateOperation;
}({}); /** Input type for defining the operation on the Worklog field of a Jira issue. */ 
let $5b8397cef71e8614$export$becc47419f149198 = /*#__PURE__*/ function(JsmChatChannelType) {
    JsmChatChannelType["Agent"] = "AGENT";
    JsmChatChannelType["Request"] = "REQUEST";
    return JsmChatChannelType;
}({});
let $5b8397cef71e8614$export$a89b8ac8c955a6b8 = /*#__PURE__*/ function(JsmChatConnectedApps) {
    JsmChatConnectedApps["Slack"] = "SLACK";
    JsmChatConnectedApps["Teams"] = "TEAMS";
    return JsmChatConnectedApps;
}({});
let $5b8397cef71e8614$export$80c78efe35efe1e8 = /*#__PURE__*/ function(JsmChatConversationMessageContentType) {
    JsmChatConversationMessageContentType["Adf"] = "ADF";
    return JsmChatConversationMessageContentType;
}({});
let $5b8397cef71e8614$export$b48e72793880c81d = /*#__PURE__*/ function(JsmChatConversationUserRole) {
    JsmChatConversationUserRole["JsmAgent"] = "JSM_Agent";
    JsmChatConversationUserRole["Participant"] = "Participant";
    JsmChatConversationUserRole["Reporter"] = "Reporter";
    JsmChatConversationUserRole["VirtualAgent"] = "VirtualAgent";
    return JsmChatConversationUserRole;
}({});
let $5b8397cef71e8614$export$f209cecbea0db715 = /*#__PURE__*/ function(JsmChatMessageSource) {
    JsmChatMessageSource["Email"] = "EMAIL";
    return JsmChatMessageSource;
}({});
let $5b8397cef71e8614$export$6c33ffba63a39eab = /*#__PURE__*/ function(JsmChatMessageType) {
    JsmChatMessageType["Adf"] = "ADF";
    return JsmChatMessageType;
}({}); /** The response when a subscription is established. */ 
let $5b8397cef71e8614$export$c9816db2d5d28541 = /*#__PURE__*/ function(KnowledgeBaseSpacePermissionType) {
    KnowledgeBaseSpacePermissionType["AnonymousUsers"] = "ANONYMOUS_USERS";
    KnowledgeBaseSpacePermissionType["ConfluenceLicensedUsers"] = "CONFLUENCE_LICENSED_USERS";
    KnowledgeBaseSpacePermissionType["ConfluenceUnlicensedUsers"] = "CONFLUENCE_UNLICENSED_USERS";
    return KnowledgeBaseSpacePermissionType;
}({});
let $5b8397cef71e8614$export$237aec910e197d97 = /*#__PURE__*/ function(KnowledgeDiscoveryDefinitionScope) {
    KnowledgeDiscoveryDefinitionScope["Blogpost"] = "BLOGPOST";
    KnowledgeDiscoveryDefinitionScope["Organization"] = "ORGANIZATION";
    KnowledgeDiscoveryDefinitionScope["Page"] = "PAGE";
    KnowledgeDiscoveryDefinitionScope["Project"] = "PROJECT";
    KnowledgeDiscoveryDefinitionScope["Space"] = "SPACE";
    return KnowledgeDiscoveryDefinitionScope;
}({});
let $5b8397cef71e8614$export$d2d7439a14c13cac = /*#__PURE__*/ function(KnowledgeDiscoveryEntityType) {
    KnowledgeDiscoveryEntityType["ConfluenceBlogpost"] = "CONFLUENCE_BLOGPOST";
    KnowledgeDiscoveryEntityType["ConfluenceDocument"] = "CONFLUENCE_DOCUMENT";
    KnowledgeDiscoveryEntityType["ConfluencePage"] = "CONFLUENCE_PAGE";
    KnowledgeDiscoveryEntityType["ConfluenceSpace"] = "CONFLUENCE_SPACE";
    KnowledgeDiscoveryEntityType["JiraProject"] = "JIRA_PROJECT";
    KnowledgeDiscoveryEntityType["KeyPhrase"] = "KEY_PHRASE";
    KnowledgeDiscoveryEntityType["Topic"] = "TOPIC";
    KnowledgeDiscoveryEntityType["User"] = "USER";
    return KnowledgeDiscoveryEntityType;
}({});
let $5b8397cef71e8614$export$4c5402ac41e05bd0 = /*#__PURE__*/ function(KnowledgeDiscoveryKeyPhraseCategory) {
    KnowledgeDiscoveryKeyPhraseCategory["Acronym"] = "ACRONYM";
    KnowledgeDiscoveryKeyPhraseCategory["Other"] = "OTHER";
    KnowledgeDiscoveryKeyPhraseCategory["Project"] = "PROJECT";
    KnowledgeDiscoveryKeyPhraseCategory["Team"] = "TEAM";
    return KnowledgeDiscoveryKeyPhraseCategory;
}({});
let $5b8397cef71e8614$export$5fc610914b028d97 = /*#__PURE__*/ function(KnowledgeDiscoveryKeyPhraseInputTextFormat) {
    KnowledgeDiscoveryKeyPhraseInputTextFormat["Adf"] = "ADF";
    KnowledgeDiscoveryKeyPhraseInputTextFormat["Plain"] = "PLAIN";
    return KnowledgeDiscoveryKeyPhraseInputTextFormat;
}({});
let $5b8397cef71e8614$export$be3a90b14f5b3f96 = /*#__PURE__*/ function(KnowledgeDiscoverySearchQueryClassification) {
    KnowledgeDiscoverySearchQueryClassification["KeywordOrAcronym"] = "KEYWORD_OR_ACRONYM";
    KnowledgeDiscoverySearchQueryClassification["NaturalLanguageQuery"] = "NATURAL_LANGUAGE_QUERY";
    KnowledgeDiscoverySearchQueryClassification["None"] = "NONE";
    KnowledgeDiscoverySearchQueryClassification["Person"] = "PERSON";
    KnowledgeDiscoverySearchQueryClassification["Team"] = "TEAM";
    return KnowledgeDiscoverySearchQueryClassification;
}({});
let $5b8397cef71e8614$export$3b6332b650771b7c = /*#__PURE__*/ function(KnowledgeDiscoverySummaryLength) {
    KnowledgeDiscoverySummaryLength["Large"] = "LARGE";
    KnowledgeDiscoverySummaryLength["Medium"] = "MEDIUM";
    KnowledgeDiscoverySummaryLength["Small"] = "SMALL";
    return KnowledgeDiscoverySummaryLength;
}({});
let $5b8397cef71e8614$export$476bafd4888ee246 = /*#__PURE__*/ function(KnowledgeDiscoveryTopicType) {
    KnowledgeDiscoveryTopicType["Area"] = "AREA";
    KnowledgeDiscoveryTopicType["Company"] = "COMPANY";
    KnowledgeDiscoveryTopicType["Event"] = "EVENT";
    KnowledgeDiscoveryTopicType["Process"] = "PROCESS";
    KnowledgeDiscoveryTopicType["Program"] = "PROGRAM";
    KnowledgeDiscoveryTopicType["Team"] = "TEAM";
    return KnowledgeDiscoveryTopicType;
}({});
let $5b8397cef71e8614$export$522f238043d058cb = /*#__PURE__*/ function(LicenseOverrideState) {
    LicenseOverrideState["Active"] = "ACTIVE";
    LicenseOverrideState["Advanced"] = "ADVANCED";
    LicenseOverrideState["Inactive"] = "INACTIVE";
    LicenseOverrideState["Standard"] = "STANDARD";
    LicenseOverrideState["Trial"] = "TRIAL";
    return LicenseOverrideState;
}({}); /**
 * See https://developer.atlassian.com/platform/graphql-gateway/schemas/lifecycle-support/#lifecycle-stages for more
 * information on how to use these stages and what they mean in detail.
 * | Lifecycle            | Visible in Prod | Needs `@optIn` directive |                     Allow third parties                       |
 * |----------------------|:---------------:|:------------------------:|:-------------------------------------------------------------:|
 * | STAGING              |       No        |            No            | By default no. Can enable via `allowThirdParties` directive   |
 * | EXPERIMENTAL         |       Yes       |           Yes            | By default no. Can enable via `allowThirdParties` directive   |
 * | BETA                 |       Yes       |           Yes            |                       Always                                  |
 * | PRODUCTION (default) |       Yes       |            No            |                       Always                                  |
 */ 
let $5b8397cef71e8614$export$3b3519737999098f = /*#__PURE__*/ function(LifecycleStage) {
    LifecycleStage["Beta"] = "BETA";
    LifecycleStage["Experimental"] = "EXPERIMENTAL";
    LifecycleStage["Production"] = "PRODUCTION";
    LifecycleStage["Staging"] = "STAGING";
    return LifecycleStage;
}({}); /**
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */ 
let $5b8397cef71e8614$export$f02742739c4d10 = /*#__PURE__*/ function(LpCertSortField) {
    LpCertSortField["ActiveDate"] = "ACTIVE_DATE";
    LpCertSortField["ExpireDate"] = "EXPIRE_DATE";
    LpCertSortField["Id"] = "ID";
    LpCertSortField["ImageUrl"] = "IMAGE_URL";
    LpCertSortField["Name"] = "NAME";
    LpCertSortField["NameAbbr"] = "NAME_ABBR";
    LpCertSortField["PublicUrl"] = "PUBLIC_URL";
    LpCertSortField["Status"] = "STATUS";
    LpCertSortField["Type"] = "TYPE";
    return LpCertSortField;
}({});
let $5b8397cef71e8614$export$a8eb0a5903a5312c = /*#__PURE__*/ function(LpCertStatus) {
    LpCertStatus["Active"] = "ACTIVE";
    LpCertStatus["Expired"] = "EXPIRED";
    return LpCertStatus;
}({});
let $5b8397cef71e8614$export$9999af1e50a41e44 = /*#__PURE__*/ function(LpCertType) {
    LpCertType["Badge"] = "BADGE";
    LpCertType["Certification"] = "CERTIFICATION";
    LpCertType["Standing"] = "STANDING";
    return LpCertType;
}({}); /** Certmetrics credentials: certifications/badges/standings */  /** Course progress: Information of courses progress */ 
let $5b8397cef71e8614$export$a8f04761d618cfe2 = /*#__PURE__*/ function(LpCourseSortField) {
    LpCourseSortField["CompletedDate"] = "COMPLETED_DATE";
    LpCourseSortField["CourseId"] = "COURSE_ID";
    LpCourseSortField["Id"] = "ID";
    LpCourseSortField["Status"] = "STATUS";
    LpCourseSortField["Title"] = "TITLE";
    LpCourseSortField["Url"] = "URL";
    return LpCourseSortField;
}({});
let $5b8397cef71e8614$export$b2608a9d91a1b256 = /*#__PURE__*/ function(LpCourseStatus) {
    LpCourseStatus["Completed"] = "COMPLETED";
    LpCourseStatus["InProgress"] = "IN_PROGRESS";
    return LpCourseStatus;
}({}); /** Learner/atlassian user */  /** Learner/atlassian user */  /** Learner/atlassian user */  /** Lesson progress: Information of lessons progress */ 
let $5b8397cef71e8614$export$dcfe2c64979f9e2c = /*#__PURE__*/ function(LpSortOrder) {
    LpSortOrder["Asc"] = "ASC";
    LpSortOrder["Desc"] = "DESC";
    return LpSortOrder;
}({}); /** A piece of code that modifies the functionality or look and feel of Atlassian products */  /** A piece of code that modifies the functionality or look and feel of Atlassian products */  /** A piece of code that modifies the functionality or look and feel of Atlassian products */  /** Category associated with an app */  /** A connection providing cursor-based pagination for a list of apps. */  /** An entry in a paginated list of apps. */  /** All deployment related properties for an app version */  /** Step for installing the instructional app */  /** Marketplace app's distribution information */  /** Payment model for integrating an app with an Atlassian product. */ 
let $5b8397cef71e8614$export$f25ba44b203e3645 = /*#__PURE__*/ function(MarketplaceAppPaymentModel) {
    MarketplaceAppPaymentModel["Free"] = "FREE";
    MarketplaceAppPaymentModel["PaidViaAtlassian"] = "PAID_VIA_ATLASSIAN";
    MarketplaceAppPaymentModel["PaidViaPartner"] = "PAID_VIA_PARTNER";
    return MarketplaceAppPaymentModel;
}({}); /** Marketplace App Programs that this Marketplace App has enrolled into. */  /** Summary of the reviews for an app */  /** App trust information for a marketplace entity */  /** App trust information or associated error in querying */  /** Version of App in Marketplace system */  /** License type for an app version */  /** Visibility of the Marketplace app's version */ 
let $5b8397cef71e8614$export$6e069b93ed3dba5f = /*#__PURE__*/ function(MarketplaceAppVersionVisibility) {
    MarketplaceAppVersionVisibility["Private"] = "PRIVATE";
    MarketplaceAppVersionVisibility["Public"] = "PUBLIC";
    return MarketplaceAppVersionVisibility;
}({}); /** Information of watchers of a Marketplace app */  /** Filters to apply when querying for my apps. */  /** Billing cycle for which pricing plan applies */ 
let $5b8397cef71e8614$export$dafb60ab7ab08188 = /*#__PURE__*/ function(MarketplaceBillingCycle) {
    MarketplaceBillingCycle["Annual"] = "ANNUAL";
    MarketplaceBillingCycle["Monthly"] = "MONTHLY";
    return MarketplaceBillingCycle;
}({}); /** Details of Bug bounty program */  /** Cloud app deployment properties */  /** Details of Cloud fortified program. */ 
let $5b8397cef71e8614$export$468594da24feab1 = /*#__PURE__*/ function(MarketplaceCloudFortifiedStatus) {
    MarketplaceCloudFortifiedStatus["Applied"] = "APPLIED";
    MarketplaceCloudFortifiedStatus["Approved"] = "APPROVED";
    MarketplaceCloudFortifiedStatus["NotAParticipant"] = "NOT_A_PARTICIPANT";
    MarketplaceCloudFortifiedStatus["Rejected"] = "REJECTED";
    return MarketplaceCloudFortifiedStatus;
}({}); /** Connect app deployment properties */ 
let $5b8397cef71e8614$export$989a25c7b3e6f0c8 = /*#__PURE__*/ function(MarketplaceConsoleAppDistributionsGroupByKey) {
    MarketplaceConsoleAppDistributionsGroupByKey["AppVersion"] = "app_version";
    MarketplaceConsoleAppDistributionsGroupByKey["None"] = "none";
    MarketplaceConsoleAppDistributionsGroupByKey["ParentAllVersions"] = "parent_all_versions";
    MarketplaceConsoleAppDistributionsGroupByKey["ParentMajorVersion"] = "parent_major_version";
    MarketplaceConsoleAppDistributionsGroupByKey["ParentMinorVersion"] = "parent_minor_version";
    return MarketplaceConsoleAppDistributionsGroupByKey;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $5b8397cef71e8614$export$c1efd3e80d58f939 = /*#__PURE__*/ function(MarketplaceConsoleAppSoftwareVersionLicenseTypeId) {
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Asl"] = "ASL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["AtlassianClosedSource"] = "ATLASSIAN_CLOSED_SOURCE";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Bsd"] = "BSD";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Commercial"] = "COMMERCIAL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["CommercialFree"] = "COMMERCIAL_FREE";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Epl"] = "EPL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Gpl"] = "GPL";
    MarketplaceConsoleAppSoftwareVersionLicenseTypeId["Lgpl"] = "LGPL";
    return MarketplaceConsoleAppSoftwareVersionLicenseTypeId;
}({}); /** This file defines the GQL type definition for the AppSoftwareVersionListing used in the marketplace console */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $5b8397cef71e8614$export$fb9cecbbd253ebc0 = /*#__PURE__*/ function(MarketplaceConsoleAppSoftwareVersionState) {
    MarketplaceConsoleAppSoftwareVersionState["Active"] = "ACTIVE";
    MarketplaceConsoleAppSoftwareVersionState["Approved"] = "APPROVED";
    MarketplaceConsoleAppSoftwareVersionState["Archived"] = "ARCHIVED";
    MarketplaceConsoleAppSoftwareVersionState["AutoApproved"] = "AUTO_APPROVED";
    MarketplaceConsoleAppSoftwareVersionState["Draft"] = "DRAFT";
    MarketplaceConsoleAppSoftwareVersionState["Rejected"] = "REJECTED";
    MarketplaceConsoleAppSoftwareVersionState["Submitted"] = "SUBMITTED";
    return MarketplaceConsoleAppSoftwareVersionState;
}({}); /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Represents an artifact which was uploaded from local file system or remote URL */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $5b8397cef71e8614$export$9de5cbe727291181 = /*#__PURE__*/ function(MarketplaceConsoleDevSpaceProgram) {
    MarketplaceConsoleDevSpaceProgram["AtlassianParter"] = "ATLASSIAN_PARTER";
    MarketplaceConsoleDevSpaceProgram["FreeLicense"] = "FREE_LICENSE";
    MarketplaceConsoleDevSpaceProgram["MarketplacePartner"] = "MARKETPLACE_PARTNER";
    MarketplaceConsoleDevSpaceProgram["SolutionPartner"] = "SOLUTION_PARTNER";
    return MarketplaceConsoleDevSpaceProgram;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $5b8397cef71e8614$export$2f6a1d40840e6e7a = /*#__PURE__*/ function(MarketplaceConsoleDevSpaceTier) {
    MarketplaceConsoleDevSpaceTier["Gold"] = "GOLD";
    MarketplaceConsoleDevSpaceTier["Platinum"] = "PLATINUM";
    MarketplaceConsoleDevSpaceTier["Silver"] = "SILVER";
    return MarketplaceConsoleDevSpaceTier;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $5b8397cef71e8614$export$63c7f04a210975b2 = /*#__PURE__*/ function(MarketplaceConsoleEditionType) {
    MarketplaceConsoleEditionType["Advanced"] = "ADVANCED";
    MarketplaceConsoleEditionType["Standard"] = "STANDARD";
    return MarketplaceConsoleEditionType;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */ 
let $5b8397cef71e8614$export$26ce6a16987d908d = /*#__PURE__*/ function(MarketplaceConsoleEditionsActivationStatus) {
    MarketplaceConsoleEditionsActivationStatus["Approved"] = "APPROVED";
    MarketplaceConsoleEditionsActivationStatus["Pending"] = "PENDING";
    MarketplaceConsoleEditionsActivationStatus["Rejected"] = "REJECTED";
    return MarketplaceConsoleEditionsActivationStatus;
}({}); /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * The file contains the common types that are used across
 * different parts of the Marketplace Console BFF GQL schema.
 */ 
let $5b8397cef71e8614$export$14f32a11a50ded19 = /*#__PURE__*/ function(MarketplaceConsoleHosting) {
    MarketplaceConsoleHosting["Cloud"] = "CLOUD";
    MarketplaceConsoleHosting["DataCenter"] = "DATA_CENTER";
    MarketplaceConsoleHosting["Server"] = "SERVER";
    return MarketplaceConsoleHosting;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Ref: https://hello.atlassian.net/wiki/spaces/~549868828/pages/2204917928/Rollout+Plan+Blocking+RuBy+partners+access+to+Marketplace */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $5b8397cef71e8614$export$5636d960d9fd9d0a = /*#__PURE__*/ function(MarketplaceConsoleLegacyMongoPluginHiddenIn) {
    MarketplaceConsoleLegacyMongoPluginHiddenIn["HiddenInSiteAndAppMarketplace"] = "HIDDEN_IN_SITE_AND_APP_MARKETPLACE";
    MarketplaceConsoleLegacyMongoPluginHiddenIn["HiddenInSiteOnly"] = "HIDDEN_IN_SITE_ONLY";
    return MarketplaceConsoleLegacyMongoPluginHiddenIn;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $5b8397cef71e8614$export$b16d3f44b490e152 = /*#__PURE__*/ function(MarketplaceConsoleLegacyMongoStatus) {
    MarketplaceConsoleLegacyMongoStatus["Notassigned"] = "NOTASSIGNED";
    MarketplaceConsoleLegacyMongoStatus["Private"] = "PRIVATE";
    MarketplaceConsoleLegacyMongoStatus["Public"] = "PUBLIC";
    MarketplaceConsoleLegacyMongoStatus["Readytolaunch"] = "READYTOLAUNCH";
    MarketplaceConsoleLegacyMongoStatus["Rejected"] = "REJECTED";
    MarketplaceConsoleLegacyMongoStatus["Submitted"] = "SUBMITTED";
    return MarketplaceConsoleLegacyMongoStatus;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Represents details of a link */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $5b8397cef71e8614$export$1bedd4c08d029277 = /*#__PURE__*/ function(MarketplaceConsoleManageAppsAdminPaymentModel) {
    MarketplaceConsoleManageAppsAdminPaymentModel["Atlassian"] = "atlassian";
    MarketplaceConsoleManageAppsAdminPaymentModel["Free"] = "free";
    MarketplaceConsoleManageAppsAdminPaymentModel["Vendor"] = "vendor";
    return MarketplaceConsoleManageAppsAdminPaymentModel;
}({}); /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** Namespace for Console related mutations */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */ 
let $5b8397cef71e8614$export$a3c494bbbdf25ee3 = /*#__PURE__*/ function(MarketplaceConsoleParentSoftwareState) {
    MarketplaceConsoleParentSoftwareState["Active"] = "ACTIVE";
    MarketplaceConsoleParentSoftwareState["Archived"] = "ARCHIVED";
    MarketplaceConsoleParentSoftwareState["Draft"] = "DRAFT";
    return MarketplaceConsoleParentSoftwareState;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */ 
let $5b8397cef71e8614$export$1393796fd66f6532 = /*#__PURE__*/ function(MarketplaceConsolePaymentModel) {
    MarketplaceConsolePaymentModel["Free"] = "FREE";
    MarketplaceConsolePaymentModel["PaidViaAtlassian"] = "PAID_VIA_ATLASSIAN";
    MarketplaceConsolePaymentModel["PaidViaVendor"] = "PAID_VIA_VENDOR";
    return MarketplaceConsolePaymentModel;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $5b8397cef71e8614$export$e1c43740a06d58bb = /*#__PURE__*/ function(MarketplaceConsolePluginFrameworkType) {
    MarketplaceConsolePluginFrameworkType["P1"] = "P1";
    MarketplaceConsolePluginFrameworkType["P2"] = "P2";
    return MarketplaceConsolePluginFrameworkType;
}({});
let $5b8397cef71e8614$export$7e092f87e8d91044 = /*#__PURE__*/ function(MarketplaceConsolePricingCurrency) {
    MarketplaceConsolePricingCurrency["Jpy"] = "JPY";
    MarketplaceConsolePricingCurrency["Usd"] = "USD";
    return MarketplaceConsolePricingCurrency;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $5b8397cef71e8614$export$4c5c05b960837cad = /*#__PURE__*/ function(MarketplaceConsolePricingPlanStatus) {
    MarketplaceConsolePricingPlanStatus["Draft"] = "DRAFT";
    MarketplaceConsolePricingPlanStatus["Live"] = "LIVE";
    MarketplaceConsolePricingPlanStatus["Pending"] = "PENDING";
    return MarketplaceConsolePricingPlanStatus;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Namespace for Console related fields */  /** Represents links pertaining to a remotely fetched artifact */  /** Represents an artifact which was fetched from a remote URL */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** --------------------------------------------------------------------------------------------- */  /** --------------------------------------------------------------------------------------------- */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** Status of an entity in Marketplace system */ 
let $5b8397cef71e8614$export$8b7b15f5e0317b5a = /*#__PURE__*/ function(MarketplaceEntityStatus) {
    MarketplaceEntityStatus["Active"] = "ACTIVE";
    MarketplaceEntityStatus["Archived"] = "ARCHIVED";
    return MarketplaceEntityStatus;
}({}); /** An image file in Atlassian Marketplace system */  /** Instructional app deployment properties */  /** Image to be displayed on a listing in Marketplace */  /** Status of app’s listing in Marketplace. */ 
let $5b8397cef71e8614$export$1a1d4383d2498aa8 = /*#__PURE__*/ function(MarketplaceListingStatus) {
    MarketplaceListingStatus["Private"] = "PRIVATE";
    MarketplaceListingStatus["Public"] = "PUBLIC";
    MarketplaceListingStatus["ReadyToLaunch"] = "READY_TO_LAUNCH";
    MarketplaceListingStatus["Rejected"] = "REJECTED";
    MarketplaceListingStatus["Submitted"] = "SUBMITTED";
    return MarketplaceListingStatus;
}({}); /** Marketplace location */ 
let $5b8397cef71e8614$export$25ad001a38719422 = /*#__PURE__*/ function(MarketplaceLocation) {
    MarketplaceLocation["InProduct"] = "IN_PRODUCT";
    MarketplaceLocation["Website"] = "WEBSITE";
    return MarketplaceLocation;
}({}); /** Marketplace Partners provide apps and integrations available for purchase on the Atlassian Marketplace that extend the power of Atlassian products. */  /** Marketplace Partner's address */  /** Marketplace Partner's contact information */  /** Marketplace Programs that this Marketplace Partner has participated in. */  /** Marketplace Partner's support information. */  /** Marketplace Partner's support availability information */  /** Marketplace Partner's support contact information */  /** Marketplace Partner's support holiday */  /** Tells whether support is on holiday only one time or if it repeats annually. */ 
let $5b8397cef71e8614$export$96bfc8c3eec61fd0 = /*#__PURE__*/ function(MarketplacePartnerSupportHolidayFrequency) {
    MarketplacePartnerSupportHolidayFrequency["Annual"] = "ANNUAL";
    MarketplacePartnerSupportHolidayFrequency["OneTime"] = "ONE_TIME";
    return MarketplacePartnerSupportHolidayFrequency;
}({}); /** Marketplace Partner's tier */ 
let $5b8397cef71e8614$export$4f999921e3690a15 = /*#__PURE__*/ function(MarketplacePartnerTierType) {
    MarketplacePartnerTierType["Gold"] = "GOLD";
    MarketplacePartnerTierType["Platinum"] = "PLATINUM";
    MarketplacePartnerTierType["Silver"] = "SILVER";
    return MarketplacePartnerTierType;
}({}); /** Tells if the Marketplace partner is an Atlassian’s internal one. */ 
let $5b8397cef71e8614$export$8fec59d6f9a79101 = /*#__PURE__*/ function(MarketplacePartnerType) {
    MarketplacePartnerType["AtlassianInternal"] = "ATLASSIAN_INTERNAL";
    return MarketplacePartnerType;
}({}); /** Plugins1 app deployment properties */  /** Plugins2 app deployment properties */  /** Pricing items based on tiers */  /** Pricing plan for a marketplace entity */  /** Option parameters to fetch pricing plan for a marketplace entity */  /** Status of the plan : LIVE, PENDING or DRAFT */ 
let $5b8397cef71e8614$export$72afefd58b6b80d0 = /*#__PURE__*/ function(MarketplacePricingPlanStatus) {
    MarketplacePricingPlanStatus["Draft"] = "DRAFT";
    MarketplacePricingPlanStatus["Live"] = "LIVE";
    MarketplacePricingPlanStatus["Pending"] = "PENDING";
    return MarketplacePricingPlanStatus;
}({}); /** Mode of the tier : GRADUATED (progressive PUP), VOLUME (constant for all users) */ 
let $5b8397cef71e8614$export$3c578ff2609d82d7 = /*#__PURE__*/ function(MarketplacePricingTierMode) {
    MarketplacePricingTierMode["Graduated"] = "GRADUATED";
    MarketplacePricingTierMode["Volume"] = "VOLUME";
    return MarketplacePricingTierMode;
}({}); /** Policy of the tier : BLOCK (FLAT) or PER_UNIT (PUP) */ 
let $5b8397cef71e8614$export$7edcca7ce5991948 = /*#__PURE__*/ function(MarketplacePricingTierPolicy) {
    MarketplacePricingTierPolicy["Block"] = "BLOCK";
    MarketplacePricingTierPolicy["PerUnit"] = "PER_UNIT";
    return MarketplacePricingTierPolicy;
}({}); /** Type of the tier */ 
let $5b8397cef71e8614$export$645f0980d82252ac = /*#__PURE__*/ function(MarketplacePricingTierType) {
    MarketplacePricingTierType["RemoteAgentTiered"] = "REMOTE_AGENT_TIERED";
    MarketplacePricingTierType["UserTiered"] = "USER_TIERED";
    return MarketplacePricingTierType;
}({});
let $5b8397cef71e8614$export$2cbd5d0207702c5 = /*#__PURE__*/ function(MarketplaceProgramStatus) {
    MarketplaceProgramStatus["Applied"] = "APPLIED";
    MarketplaceProgramStatus["Approved"] = "APPROVED";
    MarketplaceProgramStatus["NotAParticipant"] = "NOT_A_PARTICIPANT";
    MarketplaceProgramStatus["Rejected"] = "REJECTED";
    return MarketplaceProgramStatus;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * Metadata for algolia which can be used by the UI to fetch
 * app tiles data corresponding to a collection, category etc.
 *
 * Will be deprecated when search service starts providing app tiles data
 * in which case, BFF should integrate with search service to return the app tiles
 * data directly
 */ 
let $5b8397cef71e8614$export$da28f7301ad006a5 = /*#__PURE__*/ function(MarketplaceStoreDeveloperSpaceStatus) {
    MarketplaceStoreDeveloperSpaceStatus["Active"] = "ACTIVE";
    MarketplaceStoreDeveloperSpaceStatus["Archived"] = "ARCHIVED";
    MarketplaceStoreDeveloperSpaceStatus["Inactive"] = "INACTIVE";
    return MarketplaceStoreDeveloperSpaceStatus;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $5b8397cef71e8614$export$fe42024bf862f826 = /*#__PURE__*/ function(MarketplaceStoreEditionType) {
    MarketplaceStoreEditionType["Advanced"] = "ADVANCED";
    MarketplaceStoreEditionType["Standard"] = "STANDARD";
    return MarketplaceStoreEditionType;
}({}); /** --------------------------------------------------------------------------------------------- */ 
let $5b8397cef71e8614$export$b36f406ff2fbbafe = /*#__PURE__*/ function(MarketplaceStoreHomePageHighlightedSectionVariation) {
    MarketplaceStoreHomePageHighlightedSectionVariation["Prominent"] = "PROMINENT";
    return MarketplaceStoreHomePageHighlightedSectionVariation;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * These breakpoints map to the breakpoints on the client
 * eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required
 */ 
let $5b8397cef71e8614$export$f6c61b63a81bc74a = /*#__PURE__*/ function(MarketplaceStoreInstallAppStatus) {
    MarketplaceStoreInstallAppStatus["InProgress"] = "IN_PROGRESS";
    MarketplaceStoreInstallAppStatus["Pending"] = "PENDING";
    MarketplaceStoreInstallAppStatus["ProvisioningFailure"] = "PROVISIONING_FAILURE";
    MarketplaceStoreInstallAppStatus["Success"] = "SUCCESS";
    MarketplaceStoreInstallAppStatus["TimedOut"] = "TIMED_OUT";
    return MarketplaceStoreInstallAppStatus;
}({}); /** Input for specifying the target or "site" of an app installation. */  /** Products onto which an app can be installed */ 
let $5b8397cef71e8614$export$36ca2010d8fa9f9a = /*#__PURE__*/ function(MarketplaceStoreInstallationTargetProduct) {
    MarketplaceStoreInstallationTargetProduct["Compass"] = "COMPASS";
    MarketplaceStoreInstallationTargetProduct["Confluence"] = "CONFLUENCE";
    MarketplaceStoreInstallationTargetProduct["Jira"] = "JIRA";
    return MarketplaceStoreInstallationTargetProduct;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * This is a top level mutation type under which all of Marketplace Store's supported mutations
 * will reside. It is namespaced to avoid conflicts with other Atlassian mutations.
 */ 
let $5b8397cef71e8614$export$ebb4384456a718fc = /*#__PURE__*/ function(MarketplaceStorePartnerEnrollmentProgram) {
    MarketplaceStorePartnerEnrollmentProgram["MarketplacePartner"] = "MARKETPLACE_PARTNER";
    MarketplaceStorePartnerEnrollmentProgram["SolutionPartner"] = "SOLUTION_PARTNER";
    return MarketplaceStorePartnerEnrollmentProgram;
}({});
let $5b8397cef71e8614$export$e29b364dec316f58 = /*#__PURE__*/ function(MarketplaceStorePartnerEnrollmentProgramValue) {
    MarketplaceStorePartnerEnrollmentProgramValue["Gold"] = "GOLD";
    MarketplaceStorePartnerEnrollmentProgramValue["Platinum"] = "PLATINUM";
    MarketplaceStorePartnerEnrollmentProgramValue["Silver"] = "SILVER";
    return MarketplaceStorePartnerEnrollmentProgramValue;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $5b8397cef71e8614$export$9f0778caa5aa9129 = /*#__PURE__*/ function(MarketplaceStorePartnerSupportAvailabilityDay) {
    MarketplaceStorePartnerSupportAvailabilityDay["Friday"] = "FRIDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Monday"] = "MONDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Saturday"] = "SATURDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Sunday"] = "SUNDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Thursday"] = "THURSDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Tuesday"] = "TUESDAY";
    MarketplaceStorePartnerSupportAvailabilityDay["Wednesday"] = "WEDNESDAY";
    return MarketplaceStorePartnerSupportAvailabilityDay;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */ 
let $5b8397cef71e8614$export$81bd7d703c9c9b4c = /*#__PURE__*/ function(MarketplaceStorePricingCurrency) {
    MarketplaceStorePricingCurrency["Jpy"] = "JPY";
    MarketplaceStorePricingCurrency["Usd"] = "USD";
    return MarketplaceStorePricingCurrency;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types -- id is not required */  /**
 * This is a top level query "namespace" under which all of Marketplace Store's supported queries
 * will reside. The namespace allows us to avoid conflicts with other Atlassian queries.
 * Only queries within this namespace will be available on the Atlassian GraphQL Gateway.
 */ 
let $5b8397cef71e8614$export$2dd83c49139620d1 = /*#__PURE__*/ function(MembershipRole) {
    MembershipRole["Admin"] = "ADMIN";
    MembershipRole["Regular"] = "REGULAR";
    return MembershipRole;
}({}); /** The settings which a team can have describing how members are added to the team */ 
let $5b8397cef71e8614$export$86e062496769357c = /*#__PURE__*/ function(MembershipSetting) {
    MembershipSetting["MemberInvite"] = "MEMBER_INVITE";
    MembershipSetting["Open"] = "OPEN";
    return MembershipSetting;
}({}); /** The states that a member can have within a team */ 
let $5b8397cef71e8614$export$74cd14b61afb55b0 = /*#__PURE__*/ function(MembershipState) {
    MembershipState["Alumni"] = "ALUMNI";
    MembershipState["FullMember"] = "FULL_MEMBER";
    MembershipState["Invited"] = "INVITED";
    MembershipState["RequestingToJoin"] = "REQUESTING_TO_JOIN";
    return MembershipState;
}({}); /**
 * ------------------------------------------------------
 *  Watch/Unwatch Focus Area mutations
 * ------------------------------------------------------
 */ 
let $5b8397cef71e8614$export$973400a550f738ec = /*#__PURE__*/ function(MercuryAggregatedHeadcountSortField) {
    MercuryAggregatedHeadcountSortField["FilledPositions"] = "FILLED_POSITIONS";
    MercuryAggregatedHeadcountSortField["OpenPositions"] = "OPEN_POSITIONS";
    MercuryAggregatedHeadcountSortField["TotalHeadcount"] = "TOTAL_HEADCOUNT";
    return MercuryAggregatedHeadcountSortField;
}({}); /** Counts by Focus Area Status at the level of a Portfolio */  /**
 * ------------------------------------------------------
 *  Focus Area
 * ------------------------------------------------------
 */ 
let $5b8397cef71e8614$export$bc3e48f4065d763e = /*#__PURE__*/ function(MercuryEntityType) {
    MercuryEntityType["Comment"] = "COMMENT";
    MercuryEntityType["FocusArea"] = "FOCUS_AREA";
    MercuryEntityType["FocusAreaStatusUpdate"] = "FOCUS_AREA_STATUS_UPDATE";
    MercuryEntityType["Program"] = "PROGRAM";
    MercuryEntityType["ProgramStatusUpdate"] = "PROGRAM_STATUS_UPDATE";
    return MercuryEntityType;
}({}); /** ADF holding the about content within the editor */ 
let $5b8397cef71e8614$export$b8aac8b3d4a5c526 = /*#__PURE__*/ function(MercuryFocusAreaHealthColor) {
    MercuryFocusAreaHealthColor["Green"] = "GREEN";
    MercuryFocusAreaHealthColor["Red"] = "RED";
    MercuryFocusAreaHealthColor["Yellow"] = "YELLOW";
    return MercuryFocusAreaHealthColor;
}({});
let $5b8397cef71e8614$export$aabad147dc044911 = /*#__PURE__*/ function(MercuryFocusAreaHierarchySortField) {
    MercuryFocusAreaHierarchySortField["HierarchyLevel"] = "HIERARCHY_LEVEL";
    MercuryFocusAreaHierarchySortField["Name"] = "NAME";
    return MercuryFocusAreaHierarchySortField;
}({});
let $5b8397cef71e8614$export$a1abf0dad11e643b = /*#__PURE__*/ function(MercuryFocusAreaSortField) {
    MercuryFocusAreaSortField["Budget"] = "BUDGET";
    MercuryFocusAreaSortField["FocusAreaType"] = "FOCUS_AREA_TYPE";
    MercuryFocusAreaSortField["HasParent"] = "HAS_PARENT";
    MercuryFocusAreaSortField["HierarchyLevel"] = "HIERARCHY_LEVEL";
    MercuryFocusAreaSortField["LastUpdated"] = "LAST_UPDATED";
    MercuryFocusAreaSortField["Name"] = "NAME";
    MercuryFocusAreaSortField["Spend"] = "SPEND";
    MercuryFocusAreaSortField["Status"] = "STATUS";
    MercuryFocusAreaSortField["TargetDate"] = "TARGET_DATE";
    MercuryFocusAreaSortField["Watching"] = "WATCHING";
    return MercuryFocusAreaSortField;
}({}); /** Counts by different Focus Area status */  /**
 * ------------------------------------------------------
 *  Atlassian Intelligence
 * ------------------------------------------------------
 */ 
let $5b8397cef71e8614$export$64e01af19826bbd8 = /*#__PURE__*/ function(MercuryFocusAreaTeamAllocationAggregationSortField) {
    MercuryFocusAreaTeamAllocationAggregationSortField["FilledPositions"] = "FILLED_POSITIONS";
    MercuryFocusAreaTeamAllocationAggregationSortField["OpenPositions"] = "OPEN_POSITIONS";
    MercuryFocusAreaTeamAllocationAggregationSortField["TeamName"] = "TEAM_NAME";
    MercuryFocusAreaTeamAllocationAggregationSortField["TotalPositions"] = "TOTAL_POSITIONS";
    return MercuryFocusAreaTeamAllocationAggregationSortField;
}({}); /** Aggregation of headcount and positions for a focus area and its children. */  /**
 * ------------------------------------------------------
 *  Focus Area links
 * ------------------------------------------------------
 */ 
let $5b8397cef71e8614$export$ae3bb205c58a2aef = /*#__PURE__*/ function(MercuryProviderConfigurationStatus) {
    MercuryProviderConfigurationStatus["Connected"] = "CONNECTED";
    MercuryProviderConfigurationStatus["SignUp"] = "SIGN_UP";
    return MercuryProviderConfigurationStatus;
}({}); /**
 * ----------------------------------------
 *  Provider Pagination
 * ----------------------------------------
 */ 
let $5b8397cef71e8614$export$3733411202b02987 = /*#__PURE__*/ function(MercuryProviderWorkErrorType) {
    MercuryProviderWorkErrorType["Invalid"] = "INVALID";
    MercuryProviderWorkErrorType["NotFound"] = "NOT_FOUND";
    MercuryProviderWorkErrorType["NoPermissions"] = "NO_PERMISSIONS";
    return MercuryProviderWorkErrorType;
}({});
let $5b8397cef71e8614$export$9f4b40ce69c1d6a5 = /*#__PURE__*/ function(MercuryProviderWorkStatusColor) {
    MercuryProviderWorkStatusColor["Blue"] = "BLUE";
    MercuryProviderWorkStatusColor["Gray"] = "GRAY";
    MercuryProviderWorkStatusColor["Green"] = "GREEN";
    MercuryProviderWorkStatusColor["Red"] = "RED";
    MercuryProviderWorkStatusColor["Yellow"] = "YELLOW";
    return MercuryProviderWorkStatusColor;
}({});
let $5b8397cef71e8614$export$26be07f0f07696ad = /*#__PURE__*/ function(MercuryProviderWorkTargetDateType) {
    MercuryProviderWorkTargetDateType["Day"] = "DAY";
    MercuryProviderWorkTargetDateType["Month"] = "MONTH";
    MercuryProviderWorkTargetDateType["Quarter"] = "QUARTER";
    return MercuryProviderWorkTargetDateType;
}({}); /**
 * ----------------------------------------
 *  Preference Mutations
 * ----------------------------------------
 */ 
let $5b8397cef71e8614$export$5615eb511c3f7b44 = /*#__PURE__*/ function(MercuryTargetDateType) {
    MercuryTargetDateType["Day"] = "DAY";
    MercuryTargetDateType["Month"] = "MONTH";
    MercuryTargetDateType["Quarter"] = "QUARTER";
    return MercuryTargetDateType;
}({}); /** Team's capacity for allocation to a focus area. */ 
let $5b8397cef71e8614$export$6eb0d144e13a497b = /*#__PURE__*/ function(MercuryTeamFocusAreaAllocationSortField) {
    MercuryTeamFocusAreaAllocationSortField["FilledPositions"] = "FILLED_POSITIONS";
    MercuryTeamFocusAreaAllocationSortField["OpenPositions"] = "OPEN_POSITIONS";
    return MercuryTeamFocusAreaAllocationSortField;
}({}); /**
 * ------------------------------------------------------
 *  Team
 * ------------------------------------------------------
 */ 
let $5b8397cef71e8614$export$8c8ab86a3ad574d9 = /*#__PURE__*/ function(MercuryTeamSortField) {
    MercuryTeamSortField["Name"] = "NAME";
    return MercuryTeamSortField;
}({}); /**
 * ----------------------------------------
 *  Focus Area workflow mutations
 * ----------------------------------------
 */ 
let $5b8397cef71e8614$export$e5ba5b8b5f2756a8 = /*#__PURE__*/ function(MigrationEventStatus) {
    MigrationEventStatus["Cancelled"] = "CANCELLED";
    MigrationEventStatus["Cancelling"] = "CANCELLING";
    MigrationEventStatus["Failed"] = "FAILED";
    MigrationEventStatus["Incomplete"] = "INCOMPLETE";
    MigrationEventStatus["InProgress"] = "IN_PROGRESS";
    MigrationEventStatus["Paused"] = "PAUSED";
    MigrationEventStatus["Ready"] = "READY";
    MigrationEventStatus["Skipped"] = "SKIPPED";
    MigrationEventStatus["Success"] = "SUCCESS";
    MigrationEventStatus["TimedOut"] = "TIMED_OUT";
    return MigrationEventStatus;
}({}); /** An enum of the possible types of a migration event. */ 
let $5b8397cef71e8614$export$6b9f180c97bd81c9 = /*#__PURE__*/ function(MigrationEventType) {
    MigrationEventType["Container"] = "CONTAINER";
    MigrationEventType["Migration"] = "MIGRATION";
    MigrationEventType["Transfer"] = "TRANSFER";
    return MigrationEventType;
}({}); /** A type that represents a migrationPlanningService event. */  /** The top-level migrationPlanningService subscription type. */  /** The top-level migrationPlanningService subscription type. */  /** A type that represents a migration progress event. */  /** The top-level migration query type. */  /** The top-level migration query type. */  /** The top-level migration subscription type. */  /** The top-level migration subscription type. */  /** The top-level migration subscription type. */  /** Card mutations response */  /** Move sprint down */  /** Move sprint up */  /** An error that has occurred in response to a mutation */  /**
 * A error type that can be returned in response to a failed mutation
 *
 * This extension carries additional categorisation information about the error
 */ 
let $5b8397cef71e8614$export$a7e8a9c9b5c9e259 = /*#__PURE__*/ function(NadelHydrationTemplate) {
    NadelHydrationTemplate["NadelPlaceholder"] = "NADEL_PLACEHOLDER";
    return NadelHydrationTemplate;
}({}); /** Minimal details required to create a new card (as opposed to Card which is everything). */ 
let $5b8397cef71e8614$export$e129faa8dbff76aa = /*#__PURE__*/ function(NlpDisclaimer) {
    NlpDisclaimer["WhoQuestion"] = "WHO_QUESTION";
    return NlpDisclaimer;
}({});
let $5b8397cef71e8614$export$c5b04a82c748b9bd = /*#__PURE__*/ function(NlpErrorState) {
    NlpErrorState["AcceptableUseViolations"] = "ACCEPTABLE_USE_VIOLATIONS";
    NlpErrorState["AiDisabled"] = "AI_DISABLED";
    NlpErrorState["NoAnswer"] = "NO_ANSWER";
    NlpErrorState["NoAnswerHydration"] = "NO_ANSWER_HYDRATION";
    NlpErrorState["NoAnswerKeywords"] = "NO_ANSWER_KEYWORDS";
    NlpErrorState["NoAnswerOpenAiResponseErr"] = "NO_ANSWER_OPEN_AI_RESPONSE_ERR";
    NlpErrorState["NoAnswerRelevantContent"] = "NO_ANSWER_RELEVANT_CONTENT";
    NlpErrorState["NoAnswerSearchResults"] = "NO_ANSWER_SEARCH_RESULTS";
    NlpErrorState["NoAnswerWhoQuestion"] = "NO_ANSWER_WHO_QUESTION";
    NlpErrorState["OpenaiRateLimitUserAbuse"] = "OPENAI_RATE_LIMIT_USER_ABUSE";
    NlpErrorState["SubjectiveQuery"] = "SUBJECTIVE_QUERY";
    return NlpErrorState;
}({}); /** For Reading Aids */ 
let $5b8397cef71e8614$export$db433339b7e07571 = /*#__PURE__*/ function(NlpGetKeywordsTextFormat) {
    NlpGetKeywordsTextFormat["Adf"] = "ADF";
    NlpGetKeywordsTextFormat["PlainText"] = "PLAIN_TEXT";
    return NlpGetKeywordsTextFormat;
}({}); /** Result for Q&A Searches */ 
let $5b8397cef71e8614$export$b1971cd5d32db392 = /*#__PURE__*/ function(NlpSearchResultFormat) {
    NlpSearchResultFormat["Adf"] = "ADF";
    NlpSearchResultFormat["Json"] = "JSON";
    NlpSearchResultFormat["Markdown"] = "MARKDOWN";
    NlpSearchResultFormat["PlainText"] = "PLAIN_TEXT";
    return NlpSearchResultFormat;
}({});
let $5b8397cef71e8614$export$3f22e424998acb73 = /*#__PURE__*/ function(NlpSearchResultType) {
    NlpSearchResultType["Blogpost"] = "blogpost";
    NlpSearchResultType["Page"] = "page";
    NlpSearchResultType["User"] = "user";
    return NlpSearchResultType;
}({}); /**
 * From the [relay Node specification](https://relay.dev/graphql/objectidentification.htm#sec-Node-Interface)
 *
 * The server must provide an interface called `Node`. That interface must include exactly one field, called `id` that returns a non-null `ID`.
 *
 * This `id` should be a globally unique identifier for this object, and given just this `id`, the server should be able to refetch the object.
 */ 
let $5b8397cef71e8614$export$d197034e0ce6cbfa = /*#__PURE__*/ function(PeapProgramStatus) {
    PeapProgramStatus["Abandoned"] = "ABANDONED";
    PeapProgramStatus["Active"] = "ACTIVE";
    PeapProgramStatus["Ended"] = "ENDED";
    PeapProgramStatus["New"] = "NEW";
    PeapProgramStatus["Planned"] = "PLANNED";
    return PeapProgramStatus;
}({}); /** Query Parameters when looking for EAPs */  /**
 * input PEAPUserSiteEnrollmentMutationInput {
 *   programId: ID!
 *   cloudId: ID! #@ARI(....)
 *   desiredStatus: Boolean!
 * }
 * input PEAPOrgEnrollmentMutationInput {
 *   programId: ID!
 *   orgId: ID! @ARI(type: "org", owner: "platform")
 *   desiredStatus: Boolean!
 * }
 * input PEAPOrgUserEnrollmentMutationInput {
 *   programId: ID!
 *   orgId: ID! @ARI(type: "org", owner: "platform")
 *   desiredStatus: Boolean!
 * }
 */ 
let $5b8397cef71e8614$export$20d511023e79b2f8 = /*#__PURE__*/ function(PartnerBtfLicenseType) {
    PartnerBtfLicenseType["Academic"] = "ACADEMIC";
    PartnerBtfLicenseType["Commercial"] = "COMMERCIAL";
    PartnerBtfLicenseType["Evaluation"] = "EVALUATION";
    PartnerBtfLicenseType["Starter"] = "STARTER";
    return PartnerBtfLicenseType;
}({});
let $5b8397cef71e8614$export$d8bdcda0cbd9a410 = /*#__PURE__*/ function(PartnerCloudLicenseType) {
    PartnerCloudLicenseType["Academic"] = "ACADEMIC";
    PartnerCloudLicenseType["Commercial"] = "COMMERCIAL";
    PartnerCloudLicenseType["Community"] = "COMMUNITY";
    PartnerCloudLicenseType["Demonstration"] = "DEMONSTRATION";
    PartnerCloudLicenseType["Developer"] = "DEVELOPER";
    PartnerCloudLicenseType["Evaluation"] = "EVALUATION";
    PartnerCloudLicenseType["Free"] = "FREE";
    PartnerCloudLicenseType["OpenSource"] = "OPEN_SOURCE";
    PartnerCloudLicenseType["Starter"] = "STARTER";
    return PartnerCloudLicenseType;
}({});
let $5b8397cef71e8614$export$f0c4b6a2f4cddbe1 = /*#__PURE__*/ function(PartnerCurrency) {
    PartnerCurrency["Jpy"] = "JPY";
    PartnerCurrency["Usd"] = "USD";
    return PartnerCurrency;
}({});
let $5b8397cef71e8614$export$e141851b33100510 = /*#__PURE__*/ function(PartnerInvoiceJsonCurrency) {
    PartnerInvoiceJsonCurrency["Aud"] = "AUD";
    PartnerInvoiceJsonCurrency["Eur"] = "EUR";
    PartnerInvoiceJsonCurrency["Gbp"] = "GBP";
    PartnerInvoiceJsonCurrency["Jpy"] = "JPY";
    PartnerInvoiceJsonCurrency["Usd"] = "USD";
    return PartnerInvoiceJsonCurrency;
}({}); /** --------------------------------------------------------------------------------------------- */  /** Search for available product offerings */  /** The general shape of a mutation response. */  /** ## Plan mode create cards ### */ 
let $5b8397cef71e8614$export$f2dc2b898b108911 = /*#__PURE__*/ function(PlanModeDestination) {
    PlanModeDestination["Backlog"] = "BACKLOG";
    PlanModeDestination["Board"] = "BOARD";
    PlanModeDestination["Sprint"] = "SPRINT";
    return PlanModeDestination;
}({}); /** # Types */ 
let $5b8397cef71e8614$export$2cbcdf3f71413e2f = /*#__PURE__*/ function(PolarisCommentKind) {
    PolarisCommentKind["PlayContribution"] = "PLAY_CONTRIBUTION";
    PolarisCommentKind["View"] = "VIEW";
    return PolarisCommentKind;
}({}); /** # Types */ 
let $5b8397cef71e8614$export$fb5683d231e089bf = /*#__PURE__*/ function(PolarisFieldType) {
    PolarisFieldType["PolarisIdeaDateField"] = "PolarisIdeaDateField";
    PolarisFieldType["PolarisIdeaDateTimeField"] = "PolarisIdeaDateTimeField";
    PolarisFieldType["PolarisIdeaExternalReferenceField"] = "PolarisIdeaExternalReferenceField";
    PolarisFieldType["PolarisIdeaExternalReferencePropertyField"] = "PolarisIdeaExternalReferencePropertyField";
    PolarisFieldType["PolarisIdeaIntervalField"] = "PolarisIdeaIntervalField";
    PolarisFieldType["PolarisIdeaLabelsField"] = "PolarisIdeaLabelsField";
    PolarisFieldType["PolarisIdeaNumberField"] = "PolarisIdeaNumberField";
    PolarisFieldType["PolarisIdeaOptionField"] = "PolarisIdeaOptionField";
    PolarisFieldType["PolarisIdeaOptionsField"] = "PolarisIdeaOptionsField";
    PolarisFieldType["PolarisIdeaPlayField"] = "PolarisIdeaPlayField";
    PolarisFieldType["PolarisIdeaReactionsField"] = "PolarisIdeaReactionsField";
    PolarisFieldType["PolarisIdeaStringField"] = "PolarisIdeaStringField";
    PolarisFieldType["PolarisIdeaUserField"] = "PolarisIdeaUserField";
    PolarisFieldType["PolarisIdeaUsersField"] = "PolarisIdeaUsersField";
    PolarisFieldType["PolarisJiraField"] = "PolarisJiraField";
    return PolarisFieldType;
}({}); /** # Types */  /**
 * An PolarisIdeaField is a unit of information that can be instantiated
 * for an PolarisIdea.
 */ 
let $5b8397cef71e8614$export$123c361c0586acd4 = /*#__PURE__*/ function(PolarisPlayKind) {
    PolarisPlayKind["PolarisBudgetAllocationPlay"] = "PolarisBudgetAllocationPlay";
    return PolarisPlayKind;
}({}); /**
 * ======================================
 *   _____             _    _
 *  |  __ \           | |  (_)
 *  | |__) |__ _ _ __ | | ___ _ __   __ _
 *  |  _  // _` | '_ \| |/ / | '_ \ / _` |
 *  | | \ \ (_| | | | |   <| | | | | (_| |
 *  |_|  \_\__,_|_| |_|_|\_\_|_| |_|\__, |
 *                                   __/ |
 *                                  |___/
 *  Mutations
 */ 
let $5b8397cef71e8614$export$ec111ec92c0d7d70 = /*#__PURE__*/ function(PolarisRefreshError) {
    PolarisRefreshError["InternalError"] = "INTERNAL_ERROR";
    PolarisRefreshError["InvalidSnippet"] = "INVALID_SNIPPET";
    PolarisRefreshError["NeedAuth"] = "NEED_AUTH";
    PolarisRefreshError["NotFound"] = "NOT_FOUND";
    return PolarisRefreshError;
}({}); /** # Types */ 
let $5b8397cef71e8614$export$f3e14b5f4d20c3d5 = /*#__PURE__*/ function(PolarisResolvedObjectAuthType) {
    PolarisResolvedObjectAuthType["ApiKey"] = "API_KEY";
    PolarisResolvedObjectAuthType["Oauth2"] = "OAUTH2";
    return PolarisResolvedObjectAuthType;
}({}); /** # Types */ 
let $5b8397cef71e8614$export$57783d255575ae4b = /*#__PURE__*/ function(PolarisSnippetPropertyKind) {
    PolarisSnippetPropertyKind["Labels"] = "LABELS";
    PolarisSnippetPropertyKind["Number"] = "NUMBER";
    PolarisSnippetPropertyKind["Rating"] = "RATING";
    return PolarisSnippetPropertyKind;
}({});
let $5b8397cef71e8614$export$bda785e7d71f1240 = /*#__PURE__*/ function(PolarisSortOrder) {
    PolarisSortOrder["Asc"] = "ASC";
    PolarisSortOrder["Desc"] = "DESC";
    return PolarisSortOrder;
}({});
let $5b8397cef71e8614$export$14a23e97810cf04b = /*#__PURE__*/ function(PolarisTimelineMode) {
    PolarisTimelineMode["Months"] = "MONTHS";
    PolarisTimelineMode["Quarters"] = "QUARTERS";
    PolarisTimelineMode["Years"] = "YEARS";
    return PolarisTimelineMode;
}({});
let $5b8397cef71e8614$export$2b6d541a0ba09b1f = /*#__PURE__*/ function(PolarisValueOperator) {
    PolarisValueOperator["Eq"] = "EQ";
    PolarisValueOperator["Gt"] = "GT";
    PolarisValueOperator["Gte"] = "GTE";
    PolarisValueOperator["Lt"] = "LT";
    PolarisValueOperator["Lte"] = "LTE";
    return PolarisValueOperator;
}({});
let $5b8397cef71e8614$export$dbd70c8a392059ec = /*#__PURE__*/ function(PolarisViewFieldRollupType) {
    PolarisViewFieldRollupType["Avg"] = "AVG";
    PolarisViewFieldRollupType["Count"] = "COUNT";
    PolarisViewFieldRollupType["Empty"] = "EMPTY";
    PolarisViewFieldRollupType["Filled"] = "FILLED";
    PolarisViewFieldRollupType["Max"] = "MAX";
    PolarisViewFieldRollupType["Median"] = "MEDIAN";
    PolarisViewFieldRollupType["Min"] = "MIN";
    PolarisViewFieldRollupType["Range"] = "RANGE";
    PolarisViewFieldRollupType["Sum"] = "SUM";
    return PolarisViewFieldRollupType;
}({}); /** # Types */ 
let $5b8397cef71e8614$export$54183e329a6730fd = /*#__PURE__*/ function(PolarisViewFilterKind) {
    PolarisViewFilterKind["FieldIdentity"] = "FIELD_IDENTITY";
    PolarisViewFilterKind["FieldNumeric"] = "FIELD_NUMERIC";
    PolarisViewFilterKind["Interval"] = "INTERVAL";
    PolarisViewFilterKind["Text"] = "TEXT";
    return PolarisViewFilterKind;
}({});
let $5b8397cef71e8614$export$d6c8f262b1709692 = /*#__PURE__*/ function(PolarisViewFilterOperator) {
    PolarisViewFilterOperator["EndAfterNow"] = "END_AFTER_NOW";
    PolarisViewFilterOperator["EndBeforeNow"] = "END_BEFORE_NOW";
    PolarisViewFilterOperator["Eq"] = "EQ";
    PolarisViewFilterOperator["Gt"] = "GT";
    PolarisViewFilterOperator["Gte"] = "GTE";
    PolarisViewFilterOperator["Lt"] = "LT";
    PolarisViewFilterOperator["Lte"] = "LTE";
    PolarisViewFilterOperator["Neq"] = "NEQ";
    PolarisViewFilterOperator["StartAfterNow"] = "START_AFTER_NOW";
    PolarisViewFilterOperator["StartBeforeNow"] = "START_BEFORE_NOW";
    return PolarisViewFilterOperator;
}({});
let $5b8397cef71e8614$export$2503fee82ee05536 = /*#__PURE__*/ function(PolarisViewLayoutType) {
    PolarisViewLayoutType["Compact"] = "COMPACT";
    PolarisViewLayoutType["Detailed"] = "DETAILED";
    PolarisViewLayoutType["Summary"] = "SUMMARY";
    return PolarisViewLayoutType;
}({}); /** # Types */ 
let $5b8397cef71e8614$export$975689d1b7b4351b = /*#__PURE__*/ function(PolarisViewSetType) {
    PolarisViewSetType["Capture"] = "CAPTURE";
    PolarisViewSetType["Custom"] = "CUSTOM";
    PolarisViewSetType["Deliver"] = "DELIVER";
    PolarisViewSetType["Prioritize"] = "PRIORITIZE";
    PolarisViewSetType["Section"] = "SECTION";
    PolarisViewSetType["Single"] = "SINGLE";
    PolarisViewSetType["System"] = "SYSTEM";
    return PolarisViewSetType;
}({});
let $5b8397cef71e8614$export$6d557cf9ccdcf3b3 = /*#__PURE__*/ function(PolarisViewSortMode) {
    PolarisViewSortMode["FieldsSort"] = "FIELDS_SORT";
    PolarisViewSortMode["ProjectRank"] = "PROJECT_RANK";
    PolarisViewSortMode["ViewRank"] = "VIEW_RANK";
    return PolarisViewSortMode;
}({});
let $5b8397cef71e8614$export$9dec0b77614b677b = /*#__PURE__*/ function(PolarisVisualizationType) {
    PolarisVisualizationType["Board"] = "BOARD";
    PolarisVisualizationType["Matrix"] = "MATRIX";
    PolarisVisualizationType["Table"] = "TABLE";
    PolarisVisualizationType["Timeline"] = "TIMELINE";
    PolarisVisualizationType["Twoxtwo"] = "TWOXTWO";
    return PolarisVisualizationType;
}({}); /**
 * Principals types that App can allow for unlicensed access. This maps to different type of users in product.
 * For example - in case of JSM users can be UNLICENSED, CUSTOMER and ANONYMOUS.
 * UNLICENSED is Atlassian Account users who do not have a license on the underlying product where the extension is rendering
 * CUSTOMER - A site-specific Customer Account (accountId in format qm:{uuid}:{uuid} see https://developer.atlassian.com/platform/identity/rest/v1/))
 * ANONYMOUS - An invocation by a user that is not authenticated i.e. a Public JSM Portal/Confluence Space/Jira Project etc
 */ 
let $5b8397cef71e8614$export$39adac38571da5a2 = /*#__PURE__*/ function(PrincipalType) {
    PrincipalType["Anonymous"] = "ANONYMOUS";
    PrincipalType["Customer"] = "CUSTOMER";
    PrincipalType["Unlicensed"] = "UNLICENSED";
    return PrincipalType;
}({}); /** Listing data for a product */  /** Listing data for a product */  /** Listing data for a product */  /** Product Listing Information or associated error in querying */  /** Accepts input to find pull requests based on the status and time range. */  /** Entry point for query suggestion */  /** Entry point for query suggestion */  /** Metadata on any analytics related fields, these do not affect the search */  /** Filters to apply to query suggestions */ 
let $5b8397cef71e8614$export$e0affd64059d9f82 = /*#__PURE__*/ function(RateLimitingCurrency) {
    RateLimitingCurrency["CannedResponseMutationCurrency"] = "CANNED_RESPONSE_MUTATION_CURRENCY";
    RateLimitingCurrency["CannedResponseQueryCurrency"] = "CANNED_RESPONSE_QUERY_CURRENCY";
    RateLimitingCurrency["CompassSynchronizeLinkAssociationsCurrency"] = "COMPASS_SYNCHRONIZE_LINK_ASSOCIATIONS_CURRENCY";
    RateLimitingCurrency["DevopsContainerRelationshipsReadCurrency"] = "DEVOPS_CONTAINER_RELATIONSHIPS_READ_CURRENCY";
    RateLimitingCurrency["DevopsContainerRelationshipsWriteCurrency"] = "DEVOPS_CONTAINER_RELATIONSHIPS_WRITE_CURRENCY";
    RateLimitingCurrency["DevopsServiceReadCurrency"] = "DEVOPS_SERVICE_READ_CURRENCY";
    RateLimitingCurrency["DevopsServiceWriteCurrency"] = "DEVOPS_SERVICE_WRITE_CURRENCY";
    RateLimitingCurrency["ExportMetricsCurrency"] = "EXPORT_METRICS_CURRENCY";
    RateLimitingCurrency["ForgeAlertsCurrency"] = "FORGE_ALERTS_CURRENCY";
    RateLimitingCurrency["ForgeAppContributorCurrency"] = "FORGE_APP_CONTRIBUTOR_CURRENCY";
    RateLimitingCurrency["ForgeAuditLogsCurrency"] = "FORGE_AUDIT_LOGS_CURRENCY";
    RateLimitingCurrency["ForgeMetricsCurrency"] = "FORGE_METRICS_CURRENCY";
    RateLimitingCurrency["HelpCenterCurrency"] = "HELP_CENTER_CURRENCY";
    RateLimitingCurrency["HelpLayoutCurrency"] = "HELP_LAYOUT_CURRENCY";
    RateLimitingCurrency["HelpObjectStoreCurrency"] = "HELP_OBJECT_STORE_CURRENCY";
    RateLimitingCurrency["KnowledgeBaseCurrency"] = "KNOWLEDGE_BASE_CURRENCY";
    RateLimitingCurrency["PolarisBetaUserCurrency"] = "POLARIS_BETA_USER_CURRENCY";
    RateLimitingCurrency["PolarisCollabTokenQueryCurrency"] = "POLARIS_COLLAB_TOKEN_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisCommentCurrency"] = "POLARIS_COMMENT_CURRENCY";
    RateLimitingCurrency["PolarisCurrency"] = "POLARIS_CURRENCY";
    RateLimitingCurrency["PolarisFieldCurrency"] = "POLARIS_FIELD_CURRENCY";
    RateLimitingCurrency["PolarisIdeaCurrency"] = "POLARIS_IDEA_CURRENCY";
    RateLimitingCurrency["PolarisIdeaTemplatesQueryCurrency"] = "POLARIS_IDEA_TEMPLATES_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisIdeaTemplateCurrency"] = "POLARIS_IDEA_TEMPLATE_CURRENCY";
    RateLimitingCurrency["PolarisInsightsQueryCurrency"] = "POLARIS_INSIGHTS_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisInsightsWithErrorsQueryCurrency"] = "POLARIS_INSIGHTS_WITH_ERRORS_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisInsightCurrency"] = "POLARIS_INSIGHT_CURRENCY";
    RateLimitingCurrency["PolarisInsightQueryCurrency"] = "POLARIS_INSIGHT_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisLabelsQueryCurrency"] = "POLARIS_LABELS_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisOnboardingCurrency"] = "POLARIS_ONBOARDING_CURRENCY";
    RateLimitingCurrency["PolarisPlayCurrency"] = "POLARIS_PLAY_CURRENCY";
    RateLimitingCurrency["PolarisProjectConfigCurrency"] = "POLARIS_PROJECT_CONFIG_CURRENCY";
    RateLimitingCurrency["PolarisProjectQueryCurrency"] = "POLARIS_PROJECT_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisRankingCurrency"] = "POLARIS_RANKING_CURRENCY";
    RateLimitingCurrency["PolarisReactionCurrency"] = "POLARIS_REACTION_CURRENCY";
    RateLimitingCurrency["PolarisSnippetCurrency"] = "POLARIS_SNIPPET_CURRENCY";
    RateLimitingCurrency["PolarisSnippetPropertiesConfigQueryCurrency"] = "POLARIS_SNIPPET_PROPERTIES_CONFIG_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisTermsConsentQueryCurrency"] = "POLARIS_TERMS_CONSENT_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisUnfurlCurrency"] = "POLARIS_UNFURL_CURRENCY";
    RateLimitingCurrency["PolarisViewsetCurrency"] = "POLARIS_VIEWSET_CURRENCY";
    RateLimitingCurrency["PolarisViewArrangementInfoQueryCurrency"] = "POLARIS_VIEW_ARRANGEMENT_INFO_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisViewCurrency"] = "POLARIS_VIEW_CURRENCY";
    RateLimitingCurrency["PolarisViewQueryCurrency"] = "POLARIS_VIEW_QUERY_CURRENCY";
    RateLimitingCurrency["PolarisWriteCurrency"] = "POLARIS_WRITE_CURRENCY";
    RateLimitingCurrency["ShepherdDefaultCurrency"] = "SHEPHERD_DEFAULT_CURRENCY";
    RateLimitingCurrency["ShepherdMultipleReadsCurrency"] = "SHEPHERD_MULTIPLE_READS_CURRENCY";
    RateLimitingCurrency["ShepherdReadAlertCurrency"] = "SHEPHERD_READ_ALERT_CURRENCY";
    RateLimitingCurrency["TeamsCurrency"] = "TEAMS_CURRENCY";
    RateLimitingCurrency["TeamMembersCurrency"] = "TEAM_MEMBERS_CURRENCY";
    RateLimitingCurrency["TeamMembersV2Currency"] = "TEAM_MEMBERS_V2_CURRENCY";
    RateLimitingCurrency["TeamRoleGrantsMutatePrincipalsCurrency"] = "TEAM_ROLE_GRANTS_MUTATE_PRINCIPALS_CURRENCY";
    RateLimitingCurrency["TeamRoleGrantsQueryPrincipalsCurrency"] = "TEAM_ROLE_GRANTS_QUERY_PRINCIPALS_CURRENCY";
    RateLimitingCurrency["TeamSearchCurrency"] = "TEAM_SEARCH_CURRENCY";
    RateLimitingCurrency["TeamSearchV2Currency"] = "TEAM_SEARCH_V2_CURRENCY";
    RateLimitingCurrency["TeamV2Currency"] = "TEAM_V2_CURRENCY";
    RateLimitingCurrency["TestingService"] = "TESTING_SERVICE";
    RateLimitingCurrency["TrelloCurrency"] = "TRELLO_CURRENCY";
    RateLimitingCurrency["TrelloMutationCurrency"] = "TRELLO_MUTATION_CURRENCY";
    return RateLimitingCurrency;
}({}); /** Represents a status object from a workflow in Jira without any calculcated fields */  /**
 * Establish tunnels for a specific environment of an app.
 *
 * This will create a cloudflare tunnel for forge app debugging
 */ 
let $5b8397cef71e8614$export$4df1ed283b73df16 = /*#__PURE__*/ function(RoadmapChildIssuePlanningMode) {
    RoadmapChildIssuePlanningMode["Date"] = "DATE";
    RoadmapChildIssuePlanningMode["Disabled"] = "DISABLED";
    RoadmapChildIssuePlanningMode["Sprint"] = "SPRINT";
    return RoadmapChildIssuePlanningMode;
}({}); /** Relay connection definition for a roadmap item */  /** Relay edge definition for a roadmap item */  /** Details of a component */  /** Content of a valid roadmap */  /** Content of a valid roadmap */  /** Content of a valid roadmap */  /** Details of a custom filter */  /** Details about dependency configuration for roadmaps */  /** Details of a roadmap */  /** View settings for epics on the roadmap */ 
let $5b8397cef71e8614$export$1c9f5b28aa44f22d = /*#__PURE__*/ function(RoadmapEpicView) {
    RoadmapEpicView["All"] = "ALL";
    RoadmapEpicView["Completed"] = "COMPLETED";
    RoadmapEpicView["Incomplete"] = "INCOMPLETE";
    return RoadmapEpicView;
}({}); /** Configuration values for the external system(s) behind the roadmap data */  /** Details of a field derived from JQL */  /** Field configuration */  /** Details about filter configuration for roadmaps */  /** Describes a problem with the roadmaps that needs to be resolved in order to successfully fetch the content */  /** Link to a documentation page relevant to the healthcheck */  /** Healthcheck resolution action */  /** Details about hierarchy configuration for roadmaps */  /** The roadmap item data */  /** Relay connection definition for a roadmap item */  /** Relay edge definition for a roadmap item */  /** Details of the status an item has */  /** Details of the category that a status belongs to */  /** Information about the type of a roadmap Item */  /** Relay connection definition for a roadmap item */  /** Relay edge definition for a roadmap item */  /** View settings for hierarchy level one items on the roadmap */ 
let $5b8397cef71e8614$export$7f14fc5a386166cb = /*#__PURE__*/ function(RoadmapLevelOneView) {
    RoadmapLevelOneView["Complete1M"] = "COMPLETE1M";
    RoadmapLevelOneView["Complete3M"] = "COMPLETE3M";
    RoadmapLevelOneView["Complete6M"] = "COMPLETE6M";
    RoadmapLevelOneView["Complete9M"] = "COMPLETE9M";
    RoadmapLevelOneView["Complete12M"] = "COMPLETE12M";
    RoadmapLevelOneView["Incomplete"] = "INCOMPLETE";
    return RoadmapLevelOneView;
}({}); /**
 * ###########################################################################
 * ####################### END ROADMAP QUERIES TYPES #########################
 * ###########################################################################
 * ###########################################################################
 * ######### BELOW HERE ARE THE TYPES SUPPORTING ROADMAPS MUTATIONS ##########
 * ###########################################################################
 */ 
let $5b8397cef71e8614$export$6df418813509b448 = /*#__PURE__*/ function(RoadmapPaletteColor) {
    RoadmapPaletteColor["Blue"] = "BLUE";
    RoadmapPaletteColor["DarkBlue"] = "DARK_BLUE";
    RoadmapPaletteColor["DarkGreen"] = "DARK_GREEN";
    RoadmapPaletteColor["DarkGrey"] = "DARK_GREY";
    RoadmapPaletteColor["DarkOrange"] = "DARK_ORANGE";
    RoadmapPaletteColor["DarkPurple"] = "DARK_PURPLE";
    RoadmapPaletteColor["DarkTeal"] = "DARK_TEAL";
    RoadmapPaletteColor["DarkYellow"] = "DARK_YELLOW";
    RoadmapPaletteColor["Green"] = "GREEN";
    RoadmapPaletteColor["Grey"] = "GREY";
    RoadmapPaletteColor["Orange"] = "ORANGE";
    RoadmapPaletteColor["Purple"] = "PURPLE";
    RoadmapPaletteColor["Teal"] = "TEAL";
    RoadmapPaletteColor["Yellow"] = "YELLOW";
    return RoadmapPaletteColor;
}({}); /** Aggregated progress of child issues */  /** Details of a project for a roadmap */  /** Configuration details specific to a project */  /** Information about the permissions available for the roadmap project for the current user */  /** Details about how valid the roadmap project is */  /** Details of a quick filter */ 
let $5b8397cef71e8614$export$718224d6d55ce2e9 = /*#__PURE__*/ function(RoadmapRankPosition) {
    RoadmapRankPosition["After"] = "AFTER";
    RoadmapRankPosition["Before"] = "BEFORE";
    return RoadmapRankPosition;
}({}); /** Input for setting up a project with a roadmap */  /** Input for a single roadmap schedule item. */  /** Input of a roadmap schedule items mutation. */  /** Details of a roadmap sprint */  /** States that a sprint can be in */ 
let $5b8397cef71e8614$export$8fd1e37e60920853 = /*#__PURE__*/ function(RoadmapSprintState) {
    RoadmapSprintState["Active"] = "ACTIVE";
    RoadmapSprintState["Closed"] = "CLOSED";
    RoadmapSprintState["Future"] = "FUTURE";
    return RoadmapSprintState;
}({}); /** Details of the roadmap status category */  /** Subtask issues */  /** Subtask issues and its status category details */  /** Defines the available timeline modes */ 
let $5b8397cef71e8614$export$d1eb62afe3c5898c = /*#__PURE__*/ function(RoadmapTimelineMode) {
    RoadmapTimelineMode["Months"] = "MONTHS";
    RoadmapTimelineMode["Quarters"] = "QUARTERS";
    RoadmapTimelineMode["Weeks"] = "WEEKS";
    return RoadmapTimelineMode;
}({}); /** Input of a roadmap update item mutation. */  /** Input for updating roadmap settings */  /** Any user specific configuration for the roadmap */  /** Details of a version */  /** Avaliable version statuses */ 
let $5b8397cef71e8614$export$e12a64c0aae94c50 = /*#__PURE__*/ function(RoadmapVersionStatus) {
    RoadmapVersionStatus["Archived"] = "ARCHIVED";
    RoadmapVersionStatus["Released"] = "RELEASED";
    RoadmapVersionStatus["Unreleased"] = "UNRELEASED";
    return RoadmapVersionStatus;
}({}); /** View settings for items on the roadmap */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** Top level grouping of potential roadmap queries */  /** A type that represents a sandbox product. */  /** A type that represents a sandbox event. */  /** An enum of the possible values of a sandbox event result. */ 
let $5b8397cef71e8614$export$74a8f61d42003686 = /*#__PURE__*/ function(SandboxEventResult) {
    SandboxEventResult["Failed"] = "failed";
    SandboxEventResult["Incomplete"] = "incomplete";
    SandboxEventResult["Successful"] = "successful";
    SandboxEventResult["Unknown"] = "unknown";
    return SandboxEventResult;
}({}); /** An enum of the possible values of a sandbox event source. */ 
let $5b8397cef71e8614$export$fc03b8f4df65e1a2 = /*#__PURE__*/ function(SandboxEventSource) {
    SandboxEventSource["Admin"] = "admin";
    SandboxEventSource["System"] = "system";
    SandboxEventSource["User"] = "user";
    return SandboxEventSource;
}({}); /** An enum of the possible values of a sandbox event status. */ 
let $5b8397cef71e8614$export$c4acd5ebccb10941 = /*#__PURE__*/ function(SandboxEventStatus) {
    SandboxEventStatus["AwaitingReplay"] = "awaiting_replay";
    SandboxEventStatus["Cancelled"] = "cancelled";
    SandboxEventStatus["Completed"] = "completed";
    SandboxEventStatus["Started"] = "started";
    return SandboxEventStatus;
}({}); /** An enum of the possible values of a sandbox event type. */ 
let $5b8397cef71e8614$export$e370ebae241bc22f = /*#__PURE__*/ function(SandboxEventType) {
    SandboxEventType["Create"] = "create";
    SandboxEventType["DataClone"] = "data_clone";
    SandboxEventType["DataCloneSelective"] = "data_clone_selective";
    SandboxEventType["HardDelete"] = "hard_delete";
    SandboxEventType["Reset"] = "reset";
    SandboxEventType["Reshard"] = "reshard";
    SandboxEventType["Rollback"] = "rollback";
    SandboxEventType["SoftDelete"] = "soft_delete";
    return SandboxEventType;
}({}); /** The top-level sandbox query type. */  /** The top-level sandbox query type. */  /** The top-level sandbox subscription type. */  /** The top-level sandbox subscription type. */ 
let $5b8397cef71e8614$export$775b6bb06e53a214 = /*#__PURE__*/ function(Scope) {
    Scope["AdminContainer"] = "ADMIN_CONTAINER";
    Scope["ApiAccess"] = "API_ACCESS";
    Scope["ApplicationRoleRead"] = "APPLICATION_ROLE_READ";
    Scope["AsyncTaskDelete"] = "ASYNC_TASK_DELETE";
    Scope["AttachmentDelete"] = "ATTACHMENT_DELETE";
    Scope["AttachmentRead"] = "ATTACHMENT_READ";
    Scope["AttachmentWrite"] = "ATTACHMENT_WRITE";
    Scope["AuditLogRead"] = "AUDIT_LOG_READ";
    Scope["AuthConfluenceUser"] = "AUTH_CONFLUENCE_USER";
    Scope["AvatarDelete"] = "AVATAR_DELETE";
    Scope["AvatarRead"] = "AVATAR_READ";
    Scope["AvatarWrite"] = "AVATAR_WRITE";
    Scope["CatalogRead"] = "CATALOG_READ";
    Scope["CommentDelete"] = "COMMENT_DELETE";
    Scope["CommentPropertyDelete"] = "COMMENT_PROPERTY_DELETE";
    Scope["CommentPropertyRead"] = "COMMENT_PROPERTY_READ";
    Scope["CommentPropertyWrite"] = "COMMENT_PROPERTY_WRITE";
    Scope["CommentRead"] = "COMMENT_READ";
    Scope["CommentWrite"] = "COMMENT_WRITE";
    Scope["CompassAtlassianExternal"] = "COMPASS_ATLASSIAN_EXTERNAL";
    Scope["ConfluenceAtlassianExternal"] = "CONFLUENCE_ATLASSIAN_EXTERNAL";
    Scope["CustomFieldContextualConfigurationRead"] = "CUSTOM_FIELD_CONTEXTUAL_CONFIGURATION_READ";
    Scope["CustomFieldContextualConfigurationWrite"] = "CUSTOM_FIELD_CONTEXTUAL_CONFIGURATION_WRITE";
    Scope["DashboardDelete"] = "DASHBOARD_DELETE";
    Scope["DashboardPropertyDelete"] = "DASHBOARD_PROPERTY_DELETE";
    Scope["DashboardPropertyRead"] = "DASHBOARD_PROPERTY_READ";
    Scope["DashboardPropertyWrite"] = "DASHBOARD_PROPERTY_WRITE";
    Scope["DashboardRead"] = "DASHBOARD_READ";
    Scope["DashboardWrite"] = "DASHBOARD_WRITE";
    Scope["DeleteConfluenceAttachment"] = "DELETE_CONFLUENCE_ATTACHMENT";
    Scope["DeleteConfluenceBlogpost"] = "DELETE_CONFLUENCE_BLOGPOST";
    Scope["DeleteConfluenceComment"] = "DELETE_CONFLUENCE_COMMENT";
    Scope["DeleteConfluenceCustomContent"] = "DELETE_CONFLUENCE_CUSTOM_CONTENT";
    Scope["DeleteConfluencePage"] = "DELETE_CONFLUENCE_PAGE";
    Scope["DeleteConfluenceSpace"] = "DELETE_CONFLUENCE_SPACE";
    Scope["DeleteJswBoardScopeAdmin"] = "DELETE_JSW_BOARD_SCOPE_ADMIN";
    Scope["DeleteJswSprint"] = "DELETE_JSW_SPRINT";
    Scope["DeleteOrganization"] = "DELETE_ORGANIZATION";
    Scope["DeleteOrganizationProperty"] = "DELETE_ORGANIZATION_PROPERTY";
    Scope["DeleteOrganizationUser"] = "DELETE_ORGANIZATION_USER";
    Scope["DeleteRequesttypeProperty"] = "DELETE_REQUESTTYPE_PROPERTY";
    Scope["DeleteRequestFeedback"] = "DELETE_REQUEST_FEEDBACK";
    Scope["DeleteRequestNotification"] = "DELETE_REQUEST_NOTIFICATION";
    Scope["DeleteRequestParticipant"] = "DELETE_REQUEST_PARTICIPANT";
    Scope["DeleteServicedeskCustomer"] = "DELETE_SERVICEDESK_CUSTOMER";
    Scope["DeleteServicedeskOrganization"] = "DELETE_SERVICEDESK_ORGANIZATION";
    Scope["DeleteServicedeskProperty"] = "DELETE_SERVICEDESK_PROPERTY";
    Scope["FieldConfigurationDelete"] = "FIELD_CONFIGURATION_DELETE";
    Scope["FieldConfigurationRead"] = "FIELD_CONFIGURATION_READ";
    Scope["FieldConfigurationSchemeDelete"] = "FIELD_CONFIGURATION_SCHEME_DELETE";
    Scope["FieldConfigurationSchemeRead"] = "FIELD_CONFIGURATION_SCHEME_READ";
    Scope["FieldConfigurationSchemeWrite"] = "FIELD_CONFIGURATION_SCHEME_WRITE";
    Scope["FieldConfigurationWrite"] = "FIELD_CONFIGURATION_WRITE";
    Scope["FieldDefaultValueRead"] = "FIELD_DEFAULT_VALUE_READ";
    Scope["FieldDefaultValueWrite"] = "FIELD_DEFAULT_VALUE_WRITE";
    Scope["FieldDelete"] = "FIELD_DELETE";
    Scope["FieldOptionsRead"] = "FIELD_OPTIONS_READ";
    Scope["FieldOptionDelete"] = "FIELD_OPTION_DELETE";
    Scope["FieldOptionRead"] = "FIELD_OPTION_READ";
    Scope["FieldOptionWrite"] = "FIELD_OPTION_WRITE";
    Scope["FieldRead"] = "FIELD_READ";
    Scope["FieldWrite"] = "FIELD_WRITE";
    Scope["FilterColumnDelete"] = "FILTER_COLUMN_DELETE";
    Scope["FilterColumnRead"] = "FILTER_COLUMN_READ";
    Scope["FilterColumnWrite"] = "FILTER_COLUMN_WRITE";
    Scope["FilterDefaultShareScopeRead"] = "FILTER_DEFAULT_SHARE_SCOPE_READ";
    Scope["FilterDefaultShareScopeWrite"] = "FILTER_DEFAULT_SHARE_SCOPE_WRITE";
    Scope["FilterDelete"] = "FILTER_DELETE";
    Scope["FilterRead"] = "FILTER_READ";
    Scope["FilterWrite"] = "FILTER_WRITE";
    Scope["GroupDelete"] = "GROUP_DELETE";
    Scope["GroupRead"] = "GROUP_READ";
    Scope["GroupWrite"] = "GROUP_WRITE";
    Scope["IdentityAtlassianExternal"] = "IDENTITY_ATLASSIAN_EXTERNAL";
    Scope["InstanceConfigurationRead"] = "INSTANCE_CONFIGURATION_READ";
    Scope["InstanceConfigurationWrite"] = "INSTANCE_CONFIGURATION_WRITE";
    Scope["IssueAdjustmentsDelete"] = "ISSUE_ADJUSTMENTS_DELETE";
    Scope["IssueAdjustmentsRead"] = "ISSUE_ADJUSTMENTS_READ";
    Scope["IssueAdjustmentsWrite"] = "ISSUE_ADJUSTMENTS_WRITE";
    Scope["IssueChangelogRead"] = "ISSUE_CHANGELOG_READ";
    Scope["IssueDelete"] = "ISSUE_DELETE";
    Scope["IssueDetailsRead"] = "ISSUE_DETAILS_READ";
    Scope["IssueEventRead"] = "ISSUE_EVENT_READ";
    Scope["IssueFieldValuesRead"] = "ISSUE_FIELD_VALUES_READ";
    Scope["IssueLinkDelete"] = "ISSUE_LINK_DELETE";
    Scope["IssueLinkRead"] = "ISSUE_LINK_READ";
    Scope["IssueLinkTypeDelete"] = "ISSUE_LINK_TYPE_DELETE";
    Scope["IssueLinkTypeRead"] = "ISSUE_LINK_TYPE_READ";
    Scope["IssueLinkTypeWrite"] = "ISSUE_LINK_TYPE_WRITE";
    Scope["IssueLinkWrite"] = "ISSUE_LINK_WRITE";
    Scope["IssueMetaRead"] = "ISSUE_META_READ";
    Scope["IssuePropertyDelete"] = "ISSUE_PROPERTY_DELETE";
    Scope["IssuePropertyRead"] = "ISSUE_PROPERTY_READ";
    Scope["IssuePropertyWrite"] = "ISSUE_PROPERTY_WRITE";
    Scope["IssueRead"] = "ISSUE_READ";
    Scope["IssueRemoteLinkDelete"] = "ISSUE_REMOTE_LINK_DELETE";
    Scope["IssueRemoteLinkRead"] = "ISSUE_REMOTE_LINK_READ";
    Scope["IssueRemoteLinkWrite"] = "ISSUE_REMOTE_LINK_WRITE";
    Scope["IssueSecurityLevelRead"] = "ISSUE_SECURITY_LEVEL_READ";
    Scope["IssueSecuritySchemeRead"] = "ISSUE_SECURITY_SCHEME_READ";
    Scope["IssueStatusRead"] = "ISSUE_STATUS_READ";
    Scope["IssueTimeTrackingRead"] = "ISSUE_TIME_TRACKING_READ";
    Scope["IssueTimeTrackingWrite"] = "ISSUE_TIME_TRACKING_WRITE";
    Scope["IssueTransitionRead"] = "ISSUE_TRANSITION_READ";
    Scope["IssueTypeDelete"] = "ISSUE_TYPE_DELETE";
    Scope["IssueTypeHierarchyRead"] = "ISSUE_TYPE_HIERARCHY_READ";
    Scope["IssueTypePropertyDelete"] = "ISSUE_TYPE_PROPERTY_DELETE";
    Scope["IssueTypePropertyRead"] = "ISSUE_TYPE_PROPERTY_READ";
    Scope["IssueTypePropertyWrite"] = "ISSUE_TYPE_PROPERTY_WRITE";
    Scope["IssueTypeRead"] = "ISSUE_TYPE_READ";
    Scope["IssueTypeSchemeDelete"] = "ISSUE_TYPE_SCHEME_DELETE";
    Scope["IssueTypeSchemeRead"] = "ISSUE_TYPE_SCHEME_READ";
    Scope["IssueTypeSchemeWrite"] = "ISSUE_TYPE_SCHEME_WRITE";
    Scope["IssueTypeScreenSchemeDelete"] = "ISSUE_TYPE_SCREEN_SCHEME_DELETE";
    Scope["IssueTypeScreenSchemeRead"] = "ISSUE_TYPE_SCREEN_SCHEME_READ";
    Scope["IssueTypeScreenSchemeWrite"] = "ISSUE_TYPE_SCREEN_SCHEME_WRITE";
    Scope["IssueTypeWrite"] = "ISSUE_TYPE_WRITE";
    Scope["IssueVotesRead"] = "ISSUE_VOTES_READ";
    Scope["IssueVoteRead"] = "ISSUE_VOTE_READ";
    Scope["IssueVoteWrite"] = "ISSUE_VOTE_WRITE";
    Scope["IssueWatcherRead"] = "ISSUE_WATCHER_READ";
    Scope["IssueWatcherWrite"] = "ISSUE_WATCHER_WRITE";
    Scope["IssueWorklogDelete"] = "ISSUE_WORKLOG_DELETE";
    Scope["IssueWorklogPropertyDelete"] = "ISSUE_WORKLOG_PROPERTY_DELETE";
    Scope["IssueWorklogPropertyRead"] = "ISSUE_WORKLOG_PROPERTY_READ";
    Scope["IssueWorklogPropertyWrite"] = "ISSUE_WORKLOG_PROPERTY_WRITE";
    Scope["IssueWorklogRead"] = "ISSUE_WORKLOG_READ";
    Scope["IssueWorklogWrite"] = "ISSUE_WORKLOG_WRITE";
    Scope["IssueWrite"] = "ISSUE_WRITE";
    Scope["JiraAtlassianExternal"] = "JIRA_ATLASSIAN_EXTERNAL";
    Scope["JiraExpressionsRead"] = "JIRA_EXPRESSIONS_READ";
    Scope["JqlRead"] = "JQL_READ";
    Scope["JqlValidate"] = "JQL_VALIDATE";
    Scope["LabelRead"] = "LABEL_READ";
    Scope["LicenseRead"] = "LICENSE_READ";
    Scope["ManageApp"] = "MANAGE_APP";
    Scope["ManageDirectory"] = "MANAGE_DIRECTORY";
    Scope["ManageJiraConfiguration"] = "MANAGE_JIRA_CONFIGURATION";
    Scope["ManageJiraDataProvider"] = "MANAGE_JIRA_DATA_PROVIDER";
    Scope["ManageJiraProject"] = "MANAGE_JIRA_PROJECT";
    Scope["ManageJiraWebhook"] = "MANAGE_JIRA_WEBHOOK";
    Scope["ManageOrg"] = "MANAGE_ORG";
    Scope["ManageOrgPublicApis"] = "MANAGE_ORG_PUBLIC_APIS";
    Scope["ManageServicedeskCustomer"] = "MANAGE_SERVICEDESK_CUSTOMER";
    Scope["MigrateConfluence"] = "MIGRATE_CONFLUENCE";
    Scope["NotificationSchemeRead"] = "NOTIFICATION_SCHEME_READ";
    Scope["NotificationSend"] = "NOTIFICATION_SEND";
    Scope["PermissionDelete"] = "PERMISSION_DELETE";
    Scope["PermissionRead"] = "PERMISSION_READ";
    Scope["PermissionSchemeDelete"] = "PERMISSION_SCHEME_DELETE";
    Scope["PermissionSchemeRead"] = "PERMISSION_SCHEME_READ";
    Scope["PermissionSchemeWrite"] = "PERMISSION_SCHEME_WRITE";
    Scope["PermissionWrite"] = "PERMISSION_WRITE";
    Scope["PriorityRead"] = "PRIORITY_READ";
    Scope["ProjectAvatarDelete"] = "PROJECT_AVATAR_DELETE";
    Scope["ProjectAvatarRead"] = "PROJECT_AVATAR_READ";
    Scope["ProjectAvatarWrite"] = "PROJECT_AVATAR_WRITE";
    Scope["ProjectCategoryDelete"] = "PROJECT_CATEGORY_DELETE";
    Scope["ProjectCategoryRead"] = "PROJECT_CATEGORY_READ";
    Scope["ProjectCategoryWrite"] = "PROJECT_CATEGORY_WRITE";
    Scope["ProjectComponentDelete"] = "PROJECT_COMPONENT_DELETE";
    Scope["ProjectComponentRead"] = "PROJECT_COMPONENT_READ";
    Scope["ProjectComponentWrite"] = "PROJECT_COMPONENT_WRITE";
    Scope["ProjectDelete"] = "PROJECT_DELETE";
    Scope["ProjectEmailRead"] = "PROJECT_EMAIL_READ";
    Scope["ProjectEmailWrite"] = "PROJECT_EMAIL_WRITE";
    Scope["ProjectFeatureRead"] = "PROJECT_FEATURE_READ";
    Scope["ProjectFeatureWrite"] = "PROJECT_FEATURE_WRITE";
    Scope["ProjectPropertyDelete"] = "PROJECT_PROPERTY_DELETE";
    Scope["ProjectPropertyRead"] = "PROJECT_PROPERTY_READ";
    Scope["ProjectPropertyWrite"] = "PROJECT_PROPERTY_WRITE";
    Scope["ProjectRead"] = "PROJECT_READ";
    Scope["ProjectRoleDelete"] = "PROJECT_ROLE_DELETE";
    Scope["ProjectRoleRead"] = "PROJECT_ROLE_READ";
    Scope["ProjectRoleWrite"] = "PROJECT_ROLE_WRITE";
    Scope["ProjectTypeRead"] = "PROJECT_TYPE_READ";
    Scope["ProjectVersionDelete"] = "PROJECT_VERSION_DELETE";
    Scope["ProjectVersionRead"] = "PROJECT_VERSION_READ";
    Scope["ProjectVersionWrite"] = "PROJECT_VERSION_WRITE";
    Scope["ProjectWrite"] = "PROJECT_WRITE";
    Scope["PullRequest"] = "PULL_REQUEST";
    Scope["PullRequestWrite"] = "PULL_REQUEST_WRITE";
    Scope["ReadAccount"] = "READ_ACCOUNT";
    Scope["ReadCompassAttentionItem"] = "READ_COMPASS_ATTENTION_ITEM";
    Scope["ReadCompassComponent"] = "READ_COMPASS_COMPONENT";
    Scope["ReadCompassEvent"] = "READ_COMPASS_EVENT";
    Scope["ReadCompassMetric"] = "READ_COMPASS_METRIC";
    Scope["ReadCompassScorecard"] = "READ_COMPASS_SCORECARD";
    Scope["ReadConfluenceAttachment"] = "READ_CONFLUENCE_ATTACHMENT";
    Scope["ReadConfluenceAuditLog"] = "READ_CONFLUENCE_AUDIT_LOG";
    Scope["ReadConfluenceBlogpost"] = "READ_CONFLUENCE_BLOGPOST";
    Scope["ReadConfluenceComment"] = "READ_CONFLUENCE_COMMENT";
    Scope["ReadConfluenceConfiguration"] = "READ_CONFLUENCE_CONFIGURATION";
    Scope["ReadConfluenceContentAnalytics"] = "READ_CONFLUENCE_CONTENT_ANALYTICS";
    Scope["ReadConfluenceContentMetadata"] = "READ_CONFLUENCE_CONTENT_METADATA";
    Scope["ReadConfluenceContentPermission"] = "READ_CONFLUENCE_CONTENT_PERMISSION";
    Scope["ReadConfluenceContentProperty"] = "READ_CONFLUENCE_CONTENT_PROPERTY";
    Scope["ReadConfluenceContentRestriction"] = "READ_CONFLUENCE_CONTENT_RESTRICTION";
    Scope["ReadConfluenceCustomContent"] = "READ_CONFLUENCE_CUSTOM_CONTENT";
    Scope["ReadConfluenceGroup"] = "READ_CONFLUENCE_GROUP";
    Scope["ReadConfluenceInlineTask"] = "READ_CONFLUENCE_INLINE_TASK";
    Scope["ReadConfluenceLabel"] = "READ_CONFLUENCE_LABEL";
    Scope["ReadConfluencePage"] = "READ_CONFLUENCE_PAGE";
    Scope["ReadConfluenceRelation"] = "READ_CONFLUENCE_RELATION";
    Scope["ReadConfluenceSpace"] = "READ_CONFLUENCE_SPACE";
    Scope["ReadConfluenceSpacePermission"] = "READ_CONFLUENCE_SPACE_PERMISSION";
    Scope["ReadConfluenceSpaceProperty"] = "READ_CONFLUENCE_SPACE_PROPERTY";
    Scope["ReadConfluenceSpaceSetting"] = "READ_CONFLUENCE_SPACE_SETTING";
    Scope["ReadConfluenceTemplate"] = "READ_CONFLUENCE_TEMPLATE";
    Scope["ReadConfluenceUser"] = "READ_CONFLUENCE_USER";
    Scope["ReadConfluenceUserProperty"] = "READ_CONFLUENCE_USER_PROPERTY";
    Scope["ReadConfluenceWatcher"] = "READ_CONFLUENCE_WATCHER";
    Scope["ReadContainer"] = "READ_CONTAINER";
    Scope["ReadCustomer"] = "READ_CUSTOMER";
    Scope["ReadDesign"] = "READ_DESIGN";
    Scope["ReadJiraUser"] = "READ_JIRA_USER";
    Scope["ReadJiraWork"] = "READ_JIRA_WORK";
    Scope["ReadJswBoardScope"] = "READ_JSW_BOARD_SCOPE";
    Scope["ReadJswBoardScopeAdmin"] = "READ_JSW_BOARD_SCOPE_ADMIN";
    Scope["ReadJswBuild"] = "READ_JSW_BUILD";
    Scope["ReadJswDeployment"] = "READ_JSW_DEPLOYMENT";
    Scope["ReadJswEpic"] = "READ_JSW_EPIC";
    Scope["ReadJswFeatureFlag"] = "READ_JSW_FEATURE_FLAG";
    Scope["ReadJswIssue"] = "READ_JSW_ISSUE";
    Scope["ReadJswRemoteLink"] = "READ_JSW_REMOTE_LINK";
    Scope["ReadJswSourceCode"] = "READ_JSW_SOURCE_CODE";
    Scope["ReadJswSprint"] = "READ_JSW_SPRINT";
    Scope["ReadKnowledgebase"] = "READ_KNOWLEDGEBASE";
    Scope["ReadMe"] = "READ_ME";
    Scope["ReadMercury"] = "READ_MERCURY";
    Scope["ReadNotifications"] = "READ_NOTIFICATIONS";
    Scope["ReadOrganization"] = "READ_ORGANIZATION";
    Scope["ReadOrganizationProperty"] = "READ_ORGANIZATION_PROPERTY";
    Scope["ReadOrganizationUser"] = "READ_ORGANIZATION_USER";
    Scope["ReadQueue"] = "READ_QUEUE";
    Scope["ReadRequest"] = "READ_REQUEST";
    Scope["ReadRequesttype"] = "READ_REQUESTTYPE";
    Scope["ReadRequesttypeProperty"] = "READ_REQUESTTYPE_PROPERTY";
    Scope["ReadRequestAction"] = "READ_REQUEST_ACTION";
    Scope["ReadRequestApproval"] = "READ_REQUEST_APPROVAL";
    Scope["ReadRequestAttachment"] = "READ_REQUEST_ATTACHMENT";
    Scope["ReadRequestComment"] = "READ_REQUEST_COMMENT";
    Scope["ReadRequestFeedback"] = "READ_REQUEST_FEEDBACK";
    Scope["ReadRequestNotification"] = "READ_REQUEST_NOTIFICATION";
    Scope["ReadRequestParticipant"] = "READ_REQUEST_PARTICIPANT";
    Scope["ReadRequestSla"] = "READ_REQUEST_SLA";
    Scope["ReadRequestStatus"] = "READ_REQUEST_STATUS";
    Scope["ReadServicedesk"] = "READ_SERVICEDESK";
    Scope["ReadServicedeskCustomer"] = "READ_SERVICEDESK_CUSTOMER";
    Scope["ReadServicedeskOrganization"] = "READ_SERVICEDESK_ORGANIZATION";
    Scope["ReadServicedeskProperty"] = "READ_SERVICEDESK_PROPERTY";
    Scope["ReadServicedeskRequest"] = "READ_SERVICEDESK_REQUEST";
    Scope["ReadTeam"] = "READ_TEAM";
    Scope["ReadTeamMembers"] = "READ_TEAM_MEMBERS";
    Scope["ReadTownsquareComment"] = "READ_TOWNSQUARE_COMMENT";
    Scope["ReadTownsquareGoal"] = "READ_TOWNSQUARE_GOAL";
    Scope["ReadTownsquareProject"] = "READ_TOWNSQUARE_PROJECT";
    Scope["ReadTownsquareWorkspace"] = "READ_TOWNSQUARE_WORKSPACE";
    Scope["ResolutionRead"] = "RESOLUTION_READ";
    Scope["ScreenableFieldDelete"] = "SCREENABLE_FIELD_DELETE";
    Scope["ScreenableFieldRead"] = "SCREENABLE_FIELD_READ";
    Scope["ScreenableFieldWrite"] = "SCREENABLE_FIELD_WRITE";
    Scope["ScreenDelete"] = "SCREEN_DELETE";
    Scope["ScreenFieldRead"] = "SCREEN_FIELD_READ";
    Scope["ScreenRead"] = "SCREEN_READ";
    Scope["ScreenSchemeDelete"] = "SCREEN_SCHEME_DELETE";
    Scope["ScreenSchemeRead"] = "SCREEN_SCHEME_READ";
    Scope["ScreenSchemeWrite"] = "SCREEN_SCHEME_WRITE";
    Scope["ScreenTabDelete"] = "SCREEN_TAB_DELETE";
    Scope["ScreenTabRead"] = "SCREEN_TAB_READ";
    Scope["ScreenTabWrite"] = "SCREEN_TAB_WRITE";
    Scope["ScreenWrite"] = "SCREEN_WRITE";
    Scope["StatusRead"] = "STATUS_READ";
    Scope["StorageApp"] = "STORAGE_APP";
    Scope["TrelloAtlassianExternal"] = "TRELLO_ATLASSIAN_EXTERNAL";
    Scope["UserColumnsRead"] = "USER_COLUMNS_READ";
    Scope["UserConfigurationDelete"] = "USER_CONFIGURATION_DELETE";
    Scope["UserConfigurationRead"] = "USER_CONFIGURATION_READ";
    Scope["UserConfigurationWrite"] = "USER_CONFIGURATION_WRITE";
    Scope["UserPropertyDelete"] = "USER_PROPERTY_DELETE";
    Scope["UserPropertyRead"] = "USER_PROPERTY_READ";
    Scope["UserPropertyWrite"] = "USER_PROPERTY_WRITE";
    Scope["UserRead"] = "USER_READ";
    Scope["ViewUserprofile"] = "VIEW_USERPROFILE";
    Scope["WebhookDelete"] = "WEBHOOK_DELETE";
    Scope["WebhookRead"] = "WEBHOOK_READ";
    Scope["WebhookWrite"] = "WEBHOOK_WRITE";
    Scope["WorkflowDelete"] = "WORKFLOW_DELETE";
    Scope["WorkflowPropertyDelete"] = "WORKFLOW_PROPERTY_DELETE";
    Scope["WorkflowPropertyRead"] = "WORKFLOW_PROPERTY_READ";
    Scope["WorkflowPropertyWrite"] = "WORKFLOW_PROPERTY_WRITE";
    Scope["WorkflowRead"] = "WORKFLOW_READ";
    Scope["WorkflowSchemeDelete"] = "WORKFLOW_SCHEME_DELETE";
    Scope["WorkflowSchemeRead"] = "WORKFLOW_SCHEME_READ";
    Scope["WorkflowSchemeWrite"] = "WORKFLOW_SCHEME_WRITE";
    Scope["WorkflowWrite"] = "WORKFLOW_WRITE";
    Scope["WriteCompassComponent"] = "WRITE_COMPASS_COMPONENT";
    Scope["WriteCompassEvent"] = "WRITE_COMPASS_EVENT";
    Scope["WriteCompassMetric"] = "WRITE_COMPASS_METRIC";
    Scope["WriteCompassScorecard"] = "WRITE_COMPASS_SCORECARD";
    Scope["WriteConfluenceAttachment"] = "WRITE_CONFLUENCE_ATTACHMENT";
    Scope["WriteConfluenceAuditLog"] = "WRITE_CONFLUENCE_AUDIT_LOG";
    Scope["WriteConfluenceBlogpost"] = "WRITE_CONFLUENCE_BLOGPOST";
    Scope["WriteConfluenceComment"] = "WRITE_CONFLUENCE_COMMENT";
    Scope["WriteConfluenceConfiguration"] = "WRITE_CONFLUENCE_CONFIGURATION";
    Scope["WriteConfluenceContentProperty"] = "WRITE_CONFLUENCE_CONTENT_PROPERTY";
    Scope["WriteConfluenceContentRestriction"] = "WRITE_CONFLUENCE_CONTENT_RESTRICTION";
    Scope["WriteConfluenceCustomContent"] = "WRITE_CONFLUENCE_CUSTOM_CONTENT";
    Scope["WriteConfluenceGroup"] = "WRITE_CONFLUENCE_GROUP";
    Scope["WriteConfluenceInlineTask"] = "WRITE_CONFLUENCE_INLINE_TASK";
    Scope["WriteConfluenceLabel"] = "WRITE_CONFLUENCE_LABEL";
    Scope["WriteConfluencePage"] = "WRITE_CONFLUENCE_PAGE";
    Scope["WriteConfluenceRelation"] = "WRITE_CONFLUENCE_RELATION";
    Scope["WriteConfluenceSpace"] = "WRITE_CONFLUENCE_SPACE";
    Scope["WriteConfluenceSpacePermission"] = "WRITE_CONFLUENCE_SPACE_PERMISSION";
    Scope["WriteConfluenceSpaceProperty"] = "WRITE_CONFLUENCE_SPACE_PROPERTY";
    Scope["WriteConfluenceSpaceSetting"] = "WRITE_CONFLUENCE_SPACE_SETTING";
    Scope["WriteConfluenceTemplate"] = "WRITE_CONFLUENCE_TEMPLATE";
    Scope["WriteConfluenceUserProperty"] = "WRITE_CONFLUENCE_USER_PROPERTY";
    Scope["WriteConfluenceWatcher"] = "WRITE_CONFLUENCE_WATCHER";
    Scope["WriteContainer"] = "WRITE_CONTAINER";
    Scope["WriteCustomer"] = "WRITE_CUSTOMER";
    Scope["WriteDesign"] = "WRITE_DESIGN";
    Scope["WriteJiraWork"] = "WRITE_JIRA_WORK";
    Scope["WriteJswBoardScope"] = "WRITE_JSW_BOARD_SCOPE";
    Scope["WriteJswBoardScopeAdmin"] = "WRITE_JSW_BOARD_SCOPE_ADMIN";
    Scope["WriteJswBuild"] = "WRITE_JSW_BUILD";
    Scope["WriteJswDeployment"] = "WRITE_JSW_DEPLOYMENT";
    Scope["WriteJswEpic"] = "WRITE_JSW_EPIC";
    Scope["WriteJswFeatureFlag"] = "WRITE_JSW_FEATURE_FLAG";
    Scope["WriteJswIssue"] = "WRITE_JSW_ISSUE";
    Scope["WriteJswRemoteLink"] = "WRITE_JSW_REMOTE_LINK";
    Scope["WriteJswSourceCode"] = "WRITE_JSW_SOURCE_CODE";
    Scope["WriteJswSprint"] = "WRITE_JSW_SPRINT";
    Scope["WriteMercury"] = "WRITE_MERCURY";
    Scope["WriteNotifications"] = "WRITE_NOTIFICATIONS";
    Scope["WriteOrganization"] = "WRITE_ORGANIZATION";
    Scope["WriteOrganizationProperty"] = "WRITE_ORGANIZATION_PROPERTY";
    Scope["WriteOrganizationUser"] = "WRITE_ORGANIZATION_USER";
    Scope["WriteRequest"] = "WRITE_REQUEST";
    Scope["WriteRequesttype"] = "WRITE_REQUESTTYPE";
    Scope["WriteRequesttypeProperty"] = "WRITE_REQUESTTYPE_PROPERTY";
    Scope["WriteRequestApproval"] = "WRITE_REQUEST_APPROVAL";
    Scope["WriteRequestAttachment"] = "WRITE_REQUEST_ATTACHMENT";
    Scope["WriteRequestComment"] = "WRITE_REQUEST_COMMENT";
    Scope["WriteRequestFeedback"] = "WRITE_REQUEST_FEEDBACK";
    Scope["WriteRequestNotification"] = "WRITE_REQUEST_NOTIFICATION";
    Scope["WriteRequestParticipant"] = "WRITE_REQUEST_PARTICIPANT";
    Scope["WriteRequestStatus"] = "WRITE_REQUEST_STATUS";
    Scope["WriteServicedesk"] = "WRITE_SERVICEDESK";
    Scope["WriteServicedeskCustomer"] = "WRITE_SERVICEDESK_CUSTOMER";
    Scope["WriteServicedeskOrganization"] = "WRITE_SERVICEDESK_ORGANIZATION";
    Scope["WriteServicedeskProperty"] = "WRITE_SERVICEDESK_PROPERTY";
    Scope["WriteServicedeskRequest"] = "WRITE_SERVICEDESK_REQUEST";
    Scope["WriteTownsquareGoal"] = "WRITE_TOWNSQUARE_GOAL";
    Scope["WriteTownsquareProject"] = "WRITE_TOWNSQUARE_PROJECT";
    Scope["WriteTownsquareRelationship"] = "WRITE_TOWNSQUARE_RELATIONSHIP";
    return Scope;
}({}); /** The AB test context that can be associated to a specific principal/scope. */  /** Metadata on any analytics related fields, these do not affect the search */ 
let $5b8397cef71e8614$export$58320bdd6b26937a = /*#__PURE__*/ function(SearchBoardProductType) {
    SearchBoardProductType["Business"] = "BUSINESS";
    SearchBoardProductType["Software"] = "SOFTWARE";
    return SearchBoardProductType;
}({});
let $5b8397cef71e8614$export$75fb70288e44d634 = /*#__PURE__*/ function(SearchConfluenceDocumentStatus) {
    SearchConfluenceDocumentStatus["Archived"] = "ARCHIVED";
    SearchConfluenceDocumentStatus["Current"] = "CURRENT";
    SearchConfluenceDocumentStatus["Draft"] = "DRAFT";
    return SearchConfluenceDocumentStatus;
}({}); /**
 * Add only product specific properties below. Generic properties must be in the SearchResult
 *
 * CONFLUENCE
 */ 
let $5b8397cef71e8614$export$641731d7c91b88de = /*#__PURE__*/ function(SearchConfluenceRangeField) {
    SearchConfluenceRangeField["Created"] = "CREATED";
    SearchConfluenceRangeField["Lastmodified"] = "LASTMODIFIED";
    return SearchConfluenceRangeField;
}({});
let $5b8397cef71e8614$export$3646d7b76c420c42 = /*#__PURE__*/ function(SearchContainerStatus) {
    SearchContainerStatus["Archived"] = "ARCHIVED";
    SearchContainerStatus["Current"] = "CURRENT";
    return SearchContainerStatus;
}({}); /** Context for the search experiment */  /** Filters to apply to a search */ 
let $5b8397cef71e8614$export$981cf94add4585a6 = /*#__PURE__*/ function(SearchIssueStatusCategory) {
    SearchIssueStatusCategory["Done"] = "DONE";
    SearchIssueStatusCategory["Open"] = "OPEN";
    return SearchIssueStatusCategory;
}({}); /** L2 Feature Provider */ 
let $5b8397cef71e8614$export$395d337d64b9f57f = /*#__PURE__*/ function(SearchProjectType) {
    SearchProjectType["Business"] = "business";
    SearchProjectType["ProductDiscovery"] = "product_discovery";
    SearchProjectType["ServiceDesk"] = "service_desk";
    SearchProjectType["Software"] = "software";
    return SearchProjectType;
}({}); /** Entry point for all searches */  /** Entry point for all searches */  /** Entry point for all searches */  /** Filters to apply to recent query */  /** Search Result type */  /** Atlas */  /** Bitbucket */  /** Compass */  /** Google */  /** TeamworkGraph type search results */  /** Jira */  /** Jira */  /** Microsoft Document */  /** Slack */  /** Trello */ 
let $5b8397cef71e8614$export$95cacd63dfd98bee = /*#__PURE__*/ function(SearchResultType) {
    SearchResultType["Attachment"] = "attachment";
    SearchResultType["Blogpost"] = "blogpost";
    SearchResultType["Board"] = "board";
    SearchResultType["Comment"] = "comment";
    SearchResultType["Component"] = "component";
    SearchResultType["Dashboard"] = "dashboard";
    SearchResultType["Database"] = "database";
    SearchResultType["Document"] = "document";
    SearchResultType["Embed"] = "embed";
    SearchResultType["Filter"] = "filter";
    SearchResultType["Folder"] = "folder";
    SearchResultType["Goal"] = "goal";
    SearchResultType["Issue"] = "issue";
    SearchResultType["Learning"] = "learning";
    SearchResultType["Message"] = "message";
    SearchResultType["Page"] = "page";
    SearchResultType["Plan"] = "plan";
    SearchResultType["Presentation"] = "presentation";
    SearchResultType["Project"] = "project";
    SearchResultType["Question"] = "question";
    SearchResultType["Repository"] = "repository";
    SearchResultType["Space"] = "space";
    SearchResultType["Spreadsheet"] = "spreadsheet";
    SearchResultType["Tag"] = "tag";
    SearchResultType["Unrecognised"] = "unrecognised";
    SearchResultType["Whiteboard"] = "whiteboard";
    return SearchResultType;
}({}); /** Fields used to sort the query */  /** SearchSortOrder describes the sorting order of the query. */ 
let $5b8397cef71e8614$export$3cf9b6ba26bc95c6 = /*#__PURE__*/ function(SearchSortOrder) {
    SearchSortOrder["Asc"] = "ASC";
    SearchSortOrder["Desc"] = "DESC";
    return SearchSortOrder;
}({});
let $5b8397cef71e8614$export$1eed0ec46c1a7935 = /*#__PURE__*/ function(SearchThirdPartyRangeField) {
    SearchThirdPartyRangeField["Created"] = "CREATED";
    SearchThirdPartyRangeField["Lastmodified"] = "LASTMODIFIED";
    return SearchThirdPartyRangeField;
}({}); /** Generic implementation of MutationResponse for responses that don't need any extra data */  /** Generic implementation of MutationResponse for responses that don't need any extra data */  /** Estimation Mutation */  /** Swimlane Mutations */  /** The kind of action that was performed and caused or contributed to an alert */ 
let $5b8397cef71e8614$export$34f9eb005ab98ff7 = /*#__PURE__*/ function(ShepherdActionType) {
    ShepherdActionType["Activate"] = "ACTIVATE";
    ShepherdActionType["Archive"] = "ARCHIVE";
    ShepherdActionType["Crawl"] = "CRAWL";
    ShepherdActionType["Create"] = "CREATE";
    ShepherdActionType["Deactivate"] = "DEACTIVATE";
    ShepherdActionType["Delete"] = "DELETE";
    ShepherdActionType["Download"] = "DOWNLOAD";
    ShepherdActionType["Export"] = "EXPORT";
    ShepherdActionType["Grant"] = "GRANT";
    ShepherdActionType["Install"] = "INSTALL";
    ShepherdActionType["Login"] = "LOGIN";
    ShepherdActionType["LoginAs"] = "LOGIN_AS";
    ShepherdActionType["Publish"] = "PUBLISH";
    ShepherdActionType["Read"] = "READ";
    ShepherdActionType["Revoke"] = "REVOKE";
    ShepherdActionType["Search"] = "SEARCH";
    ShepherdActionType["Uninstall"] = "UNINSTALL";
    ShepherdActionType["Update"] = "UPDATE";
    return ShepherdActionType;
}({}); /** Represents the pertinent fields of specific events (from the Audit Log, for example) matching given search criteria. */  /** ShepherdActivityHighlight captures a pointer to some user activity that is relevant for an alert. */  /** Contextual information about the activity that originated the alert. */  /** Single data point about distribution of numerical data related to the activity */  /** Represents an actor in the Shepherd system. */  /** Represents an actor in the Shepherd system. */ 
let $5b8397cef71e8614$export$54f03cbb2a3e778f = /*#__PURE__*/ function(ShepherdActorOrgStatus) {
    ShepherdActorOrgStatus["Active"] = "ACTIVE";
    ShepherdActorOrgStatus["Deactivated"] = "DEACTIVATED";
    ShepherdActorOrgStatus["Suspended"] = "SUSPENDED";
    return ShepherdActorOrgStatus;
}({}); /** Represents access to a product for an actor in the Shepherd system. */  /** #### Types: Alert ##### */ 
let $5b8397cef71e8614$export$467ce4c000663710 = /*#__PURE__*/ function(ShepherdAlertAction) {
    ShepherdAlertAction["AddLabel"] = "ADD_LABEL";
    ShepherdAlertAction["Redact"] = "REDACT";
    ShepherdAlertAction["Restrict"] = "RESTRICT";
    ShepherdAlertAction["UpdateDataClassification"] = "UPDATE_DATA_CLASSIFICATION";
    return ShepherdAlertAction;
}({});
let $5b8397cef71e8614$export$ec1710c62a266610 = /*#__PURE__*/ function(ShepherdAlertDetectionCategory) {
    ShepherdAlertDetectionCategory["Data"] = "DATA";
    ShepherdAlertDetectionCategory["Threat"] = "THREAT";
    return ShepherdAlertDetectionCategory;
}({}); /** Represents metadata that adds context to the alert */ 
let $5b8397cef71e8614$export$48343fd5997afd49 = /*#__PURE__*/ function(ShepherdAlertStatus) {
    ShepherdAlertStatus["InProgress"] = "IN_PROGRESS";
    ShepherdAlertStatus["Triaged"] = "TRIAGED";
    ShepherdAlertStatus["TriagedExpectedActivity"] = "TRIAGED_EXPECTED_ACTIVITY";
    ShepherdAlertStatus["TriagedTruePositive"] = "TRIAGED_TRUE_POSITIVE";
    ShepherdAlertStatus["Untriaged"] = "UNTRIAGED";
    return ShepherdAlertStatus;
}({}); /**
 * Contains supporting information useful for evaluating an alert.
 * Today it attaches the concept of a "highlight" to alerts. It can be extended to hold additional highlights or
 * other types of information.
 */ 
let $5b8397cef71e8614$export$78b33ffe8847c025 = /*#__PURE__*/ function(ShepherdAlertTemplateType) {
    ShepherdAlertTemplateType["AddedConfluenceGlobalPermission"] = "ADDED_CONFLUENCE_GLOBAL_PERMISSION";
    ShepherdAlertTemplateType["AddedConfluenceSpacePermission"] = "ADDED_CONFLUENCE_SPACE_PERMISSION";
    ShepherdAlertTemplateType["AddedDomain"] = "ADDED_DOMAIN";
    ShepherdAlertTemplateType["AddedJiraGlobalPermission"] = "ADDED_JIRA_GLOBAL_PERMISSION";
    ShepherdAlertTemplateType["AddedOrgadmin"] = "ADDED_ORGADMIN";
    ShepherdAlertTemplateType["BitbucketRepositoryPrivacy"] = "BITBUCKET_REPOSITORY_PRIVACY";
    ShepherdAlertTemplateType["BitbucketWorkspacePrivacy"] = "BITBUCKET_WORKSPACE_PRIVACY";
    ShepherdAlertTemplateType["ClassificationLevelArchived"] = "CLASSIFICATION_LEVEL_ARCHIVED";
    ShepherdAlertTemplateType["ClassificationLevelPublished"] = "CLASSIFICATION_LEVEL_PUBLISHED";
    ShepherdAlertTemplateType["ConfluenceCustomDetection"] = "CONFLUENCE_CUSTOM_DETECTION";
    ShepherdAlertTemplateType["ConfluenceDataDiscovery"] = "CONFLUENCE_DATA_DISCOVERY";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryAtlassianToken"] = "CONFLUENCE_DATA_DISCOVERY_ATLASSIAN_TOKEN";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryAuTfn"] = "CONFLUENCE_DATA_DISCOVERY_AU_TFN";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryAwsKeys"] = "CONFLUENCE_DATA_DISCOVERY_AWS_KEYS";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryCreditCard"] = "CONFLUENCE_DATA_DISCOVERY_CREDIT_CARD";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryCrypto"] = "CONFLUENCE_DATA_DISCOVERY_CRYPTO";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryIban"] = "CONFLUENCE_DATA_DISCOVERY_IBAN";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryJwtKey"] = "CONFLUENCE_DATA_DISCOVERY_JWT_KEY";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryPassword"] = "CONFLUENCE_DATA_DISCOVERY_PASSWORD";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryPrivateKey"] = "CONFLUENCE_DATA_DISCOVERY_PRIVATE_KEY";
    ShepherdAlertTemplateType["ConfluenceDataDiscoveryUsSsn"] = "CONFLUENCE_DATA_DISCOVERY_US_SSN";
    ShepherdAlertTemplateType["ConfluencePageCrawling"] = "CONFLUENCE_PAGE_CRAWLING";
    ShepherdAlertTemplateType["ConfluencePageExports"] = "CONFLUENCE_PAGE_EXPORTS";
    ShepherdAlertTemplateType["ConfluenceSiteBackupDownloaded"] = "CONFLUENCE_SITE_BACKUP_DOWNLOADED";
    ShepherdAlertTemplateType["ConfluenceSpaceExports"] = "CONFLUENCE_SPACE_EXPORTS";
    ShepherdAlertTemplateType["ConfluenceSuspiciousSearch"] = "CONFLUENCE_SUSPICIOUS_SEARCH";
    ShepherdAlertTemplateType["CreatedAuthPolicy"] = "CREATED_AUTH_POLICY";
    ShepherdAlertTemplateType["CreatedPolicy"] = "CREATED_POLICY";
    ShepherdAlertTemplateType["CreatedSamlConfig"] = "CREATED_SAML_CONFIG";
    ShepherdAlertTemplateType["CreatedTunnel"] = "CREATED_TUNNEL";
    ShepherdAlertTemplateType["CreatedUserProvisioning"] = "CREATED_USER_PROVISIONING";
    ShepherdAlertTemplateType["DataSecurityPolicyActivated"] = "DATA_SECURITY_POLICY_ACTIVATED";
    ShepherdAlertTemplateType["DataSecurityPolicyDeactivated"] = "DATA_SECURITY_POLICY_DEACTIVATED";
    ShepherdAlertTemplateType["DataSecurityPolicyDeleted"] = "DATA_SECURITY_POLICY_DELETED";
    ShepherdAlertTemplateType["DataSecurityPolicyUpdated"] = "DATA_SECURITY_POLICY_UPDATED";
    ShepherdAlertTemplateType["Default"] = "DEFAULT";
    ShepherdAlertTemplateType["DeletedAuthPolicy"] = "DELETED_AUTH_POLICY";
    ShepherdAlertTemplateType["DeletedDomain"] = "DELETED_DOMAIN";
    ShepherdAlertTemplateType["DeletedPolicy"] = "DELETED_POLICY";
    ShepherdAlertTemplateType["DeletedTunnel"] = "DELETED_TUNNEL";
    ShepherdAlertTemplateType["EcosystemAuditLogInstallationCreated"] = "ECOSYSTEM_AUDIT_LOG_INSTALLATION_CREATED";
    ShepherdAlertTemplateType["EcosystemAuditLogInstallationDeleted"] = "ECOSYSTEM_AUDIT_LOG_INSTALLATION_DELETED";
    ShepherdAlertTemplateType["EcosystemAuditLogUserGrantCreated"] = "ECOSYSTEM_AUDIT_LOG_USER_GRANT_CREATED";
    ShepherdAlertTemplateType["EducationalAlert"] = "EDUCATIONAL_ALERT";
    ShepherdAlertTemplateType["EnableScimSync"] = "ENABLE_SCIM_SYNC";
    ShepherdAlertTemplateType["ExportedOrgeventscsv"] = "EXPORTED_ORGEVENTSCSV";
    ShepherdAlertTemplateType["GrantAssignedJiraPermissionScheme"] = "GRANT_ASSIGNED_JIRA_PERMISSION_SCHEME";
    ShepherdAlertTemplateType["IdentityPasswordResetCompletedUser"] = "IDENTITY_PASSWORD_RESET_COMPLETED_USER";
    ShepherdAlertTemplateType["ImpossibleTravel"] = "IMPOSSIBLE_TRAVEL";
    ShepherdAlertTemplateType["InitiatedGsyncConnection"] = "INITIATED_GSYNC_CONNECTION";
    ShepherdAlertTemplateType["JiraCustomDetection"] = "JIRA_CUSTOM_DETECTION";
    ShepherdAlertTemplateType["JiraDataDiscoveryAtlassianToken"] = "JIRA_DATA_DISCOVERY_ATLASSIAN_TOKEN";
    ShepherdAlertTemplateType["JiraDataDiscoveryAuTfn"] = "JIRA_DATA_DISCOVERY_AU_TFN";
    ShepherdAlertTemplateType["JiraDataDiscoveryAwsKeys"] = "JIRA_DATA_DISCOVERY_AWS_KEYS";
    ShepherdAlertTemplateType["JiraDataDiscoveryCreditCard"] = "JIRA_DATA_DISCOVERY_CREDIT_CARD";
    ShepherdAlertTemplateType["JiraDataDiscoveryCrypto"] = "JIRA_DATA_DISCOVERY_CRYPTO";
    ShepherdAlertTemplateType["JiraDataDiscoveryIban"] = "JIRA_DATA_DISCOVERY_IBAN";
    ShepherdAlertTemplateType["JiraDataDiscoveryJwtKey"] = "JIRA_DATA_DISCOVERY_JWT_KEY";
    ShepherdAlertTemplateType["JiraDataDiscoveryPassword"] = "JIRA_DATA_DISCOVERY_PASSWORD";
    ShepherdAlertTemplateType["JiraDataDiscoveryPrivateKey"] = "JIRA_DATA_DISCOVERY_PRIVATE_KEY";
    ShepherdAlertTemplateType["JiraDataDiscoveryUsSsn"] = "JIRA_DATA_DISCOVERY_US_SSN";
    ShepherdAlertTemplateType["JiraIssueCrawling"] = "JIRA_ISSUE_CRAWLING";
    ShepherdAlertTemplateType["LoginFromMaliciousIpAddress"] = "LOGIN_FROM_MALICIOUS_IP_ADDRESS";
    ShepherdAlertTemplateType["LoginFromTorExitNode"] = "LOGIN_FROM_TOR_EXIT_NODE";
    ShepherdAlertTemplateType["OrgLoggedInAsUser"] = "ORG_LOGGED_IN_AS_USER";
    ShepherdAlertTemplateType["ProjectClassificationLevelDecreased"] = "PROJECT_CLASSIFICATION_LEVEL_DECREASED";
    ShepherdAlertTemplateType["ProjectClassificationLevelIncreased"] = "PROJECT_CLASSIFICATION_LEVEL_INCREASED";
    ShepherdAlertTemplateType["RotateScimDirectoryToken"] = "ROTATE_SCIM_DIRECTORY_TOKEN";
    ShepherdAlertTemplateType["SpaceClassificationLevelDecreased"] = "SPACE_CLASSIFICATION_LEVEL_DECREASED";
    ShepherdAlertTemplateType["SpaceClassificationLevelIncreased"] = "SPACE_CLASSIFICATION_LEVEL_INCREASED";
    ShepherdAlertTemplateType["TestAlert"] = "TEST_ALERT";
    ShepherdAlertTemplateType["TokenCreated"] = "TOKEN_CREATED";
    ShepherdAlertTemplateType["TokenRevoked"] = "TOKEN_REVOKED";
    ShepherdAlertTemplateType["UpdatedAuthPolicy"] = "UPDATED_AUTH_POLICY";
    ShepherdAlertTemplateType["UpdatedPolicy"] = "UPDATED_POLICY";
    ShepherdAlertTemplateType["UpdatedSamlConfig"] = "UPDATED_SAML_CONFIG";
    ShepherdAlertTemplateType["UserAddedToBeacon"] = "USER_ADDED_TO_BEACON";
    ShepherdAlertTemplateType["UserGrantedRole"] = "USER_GRANTED_ROLE";
    ShepherdAlertTemplateType["UserRemovedFromBeacon"] = "USER_REMOVED_FROM_BEACON";
    ShepherdAlertTemplateType["UserRevokedRole"] = "USER_REVOKED_ROLE";
    ShepherdAlertTemplateType["VerifiedDomainVerification"] = "VERIFIED_DOMAIN_VERIFICATION";
    return ShepherdAlertTemplateType;
}({}); /** Placeholder type to enable eventually adding pagination via the relay connection pattern (https://relay.dev/graphql/connections.htm). */  /** #### Types: Query Results ##### */ 
let $5b8397cef71e8614$export$9dd0637f1b429aee = /*#__PURE__*/ function(ShepherdAtlassianProduct) {
    ShepherdAtlassianProduct["AdminHub"] = "ADMIN_HUB";
    ShepherdAtlassianProduct["Bitbucket"] = "BITBUCKET";
    ShepherdAtlassianProduct["Confluence"] = "CONFLUENCE";
    ShepherdAtlassianProduct["GuardDetect"] = "GUARD_DETECT";
    ShepherdAtlassianProduct["JiraSoftware"] = "JIRA_SOFTWARE";
    ShepherdAtlassianProduct["Marketplace"] = "MARKETPLACE";
    return ShepherdAtlassianProduct;
}({}); /** Represent metadata for the alert grouped by category */ 
let $5b8397cef71e8614$export$4ee416f20f5a941a = /*#__PURE__*/ function(ShepherdClassificationLevelColor) {
    ShepherdClassificationLevelColor["Blue"] = "BLUE";
    ShepherdClassificationLevelColor["BlueBold"] = "BLUE_BOLD";
    ShepherdClassificationLevelColor["Green"] = "GREEN";
    ShepherdClassificationLevelColor["Grey"] = "GREY";
    ShepherdClassificationLevelColor["Lime"] = "LIME";
    ShepherdClassificationLevelColor["Navy"] = "NAVY";
    ShepherdClassificationLevelColor["None"] = "NONE";
    ShepherdClassificationLevelColor["Orange"] = "ORANGE";
    ShepherdClassificationLevelColor["Purple"] = "PURPLE";
    ShepherdClassificationLevelColor["Red"] = "RED";
    ShepherdClassificationLevelColor["RedBold"] = "RED_BOLD";
    ShepherdClassificationLevelColor["Teal"] = "TEAL";
    ShepherdClassificationLevelColor["Yellow"] = "YELLOW";
    return ShepherdClassificationLevelColor;
}({});
let $5b8397cef71e8614$export$dddaf5557f82edf7 = /*#__PURE__*/ function(ShepherdClassificationStatus) {
    ShepherdClassificationStatus["Archived"] = "ARCHIVED";
    ShepherdClassificationStatus["Draft"] = "DRAFT";
    ShepherdClassificationStatus["Published"] = "PUBLISHED";
    return ShepherdClassificationStatus;
}({}); /** ##### Input ###### */  /** #### Payload ##### */  /** Represents the current user in the Shepherd system. */  /** Configuration for a custom content scanning detection. A list of rules that will be matched against content. */  /** A user created detection. Currently only custom content scanning is supported. */ 
let $5b8397cef71e8614$export$f961d21a5cd3eed7 = /*#__PURE__*/ function(ShepherdCustomScanningMatchType) {
    ShepherdCustomScanningMatchType["Regex"] = "REGEX";
    ShepherdCustomScanningMatchType["String"] = "STRING";
    ShepherdCustomScanningMatchType["Word"] = "WORD";
    return ShepherdCustomScanningMatchType;
}({}); /** GraphQL doesn't allow unions in input types so this is to allow for different rule types in the future. */  /** A rule to match against content. Contains a term an whether it's a string match or word match. */  /** Input type for a rule to match against content. Contains a term an whether it's a string match or word match. */  /** This would represent a detection in beacon, each detection possibly containing a set of settings */  /** Represents an individual exclusion. */  /** Setting that contains exclusion configuration so that a detection can filter out unwanted alerts for customers. */  /** An individual resource exclusion */ 
let $5b8397cef71e8614$export$db4af14fade5e4e5 = /*#__PURE__*/ function(ShepherdDetectionScanningFrequency) {
    ShepherdDetectionScanningFrequency["RealTime"] = "REAL_TIME";
    ShepherdDetectionScanningFrequency["Scheduled"] = "SCHEDULED";
    return ShepherdDetectionScanningFrequency;
}({}); /** Describes the data the setting can hold. */  /** Represents specific metadata that adds context to DSP list changes */  /** A highlight contains contextual information produced by the detection that created the alert. */  /**
 * A highlight contains contextual information produced by the detection that created the alert.
 * One field is required and only one can be informed at a time.
 */ 
let $5b8397cef71e8614$export$2f9e73ea31c391f3 = /*#__PURE__*/ function(ShepherdLoginDeviceType) {
    ShepherdLoginDeviceType["Computer"] = "COMPUTER";
    ShepherdLoginDeviceType["Console"] = "CONSOLE";
    ShepherdLoginDeviceType["Embedded"] = "EMBEDDED";
    ShepherdLoginDeviceType["Mobile"] = "MOBILE";
    ShepherdLoginDeviceType["SmartTv"] = "SMART_TV";
    ShepherdLoginDeviceType["Tablet"] = "TABLET";
    ShepherdLoginDeviceType["Wearable"] = "WEARABLE";
    return ShepherdLoginDeviceType;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** #### Types: Mutation ##### */ 
let $5b8397cef71e8614$export$c8dd2e548b70194f = /*#__PURE__*/ function(ShepherdMutationErrorType) {
    ShepherdMutationErrorType["BadRequest"] = "BAD_REQUEST";
    ShepherdMutationErrorType["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    ShepherdMutationErrorType["NoProductAccess"] = "NO_PRODUCT_ACCESS";
    ShepherdMutationErrorType["Unauthorized"] = "UNAUTHORIZED";
    return ShepherdMutationErrorType;
}({}); /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** eslint-disable-next-line @graphql-eslint/strict-id-in-types */  /** #### Types: Query ##### */ 
let $5b8397cef71e8614$export$60854452710d481b = /*#__PURE__*/ function(ShepherdQueryErrorType) {
    ShepherdQueryErrorType["BadRequest"] = "BAD_REQUEST";
    ShepherdQueryErrorType["InternalServerError"] = "INTERNAL_SERVER_ERROR";
    ShepherdQueryErrorType["NoProductAccess"] = "NO_PRODUCT_ACCESS";
    ShepherdQueryErrorType["Unauthorized"] = "UNAUTHORIZED";
    return ShepherdQueryErrorType;
}({}); /** A rate type detection has 3 modes, LOW will produce the most alerts, HIGH will product the least alerts */ 
let $5b8397cef71e8614$export$359aa80f049e8938 = /*#__PURE__*/ function(ShepherdRateThresholdValue) {
    ShepherdRateThresholdValue["High"] = "HIGH";
    ShepherdRateThresholdValue["Low"] = "LOW";
    ShepherdRateThresholdValue["Medium"] = "MEDIUM";
    return ShepherdRateThresholdValue;
}({});
let $5b8397cef71e8614$export$8bcebd025de2c46b = /*#__PURE__*/ function(ShepherdRemediationActionType) {
    ShepherdRemediationActionType["AnonAccessDspRemediation"] = "ANON_ACCESS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ApplyClassificationRemediation"] = "APPLY_CLASSIFICATION_REMEDIATION";
    ShepherdRemediationActionType["AppsAccessDspRemediation"] = "APPS_ACCESS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ArchiveRestoreClassificationRemediation"] = "ARCHIVE_RESTORE_CLASSIFICATION_REMEDIATION";
    ShepherdRemediationActionType["BlockchainExplorerRemediation"] = "BLOCKCHAIN_EXPLORER_REMEDIATION";
    ShepherdRemediationActionType["BlockIpAllowlistRemediation"] = "BLOCK_IP_ALLOWLIST_REMEDIATION";
    ShepherdRemediationActionType["ClassificationLevelChangeRemediation"] = "CLASSIFICATION_LEVEL_CHANGE_REMEDIATION";
    ShepherdRemediationActionType["ConfluenceAnonAccessRemediation"] = "CONFLUENCE_ANON_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["DeleteDataRemediation"] = "DELETE_DATA_REMEDIATION";
    ShepherdRemediationActionType["DeleteFilesRemediation"] = "DELETE_FILES_REMEDIATION";
    ShepherdRemediationActionType["EditCustomDetectionRemediation"] = "EDIT_CUSTOM_DETECTION_REMEDIATION";
    ShepherdRemediationActionType["ExcludePageRemediation"] = "EXCLUDE_PAGE_REMEDIATION";
    ShepherdRemediationActionType["ExcludeUserRemediation"] = "EXCLUDE_USER_REMEDIATION";
    ShepherdRemediationActionType["ExportsDspRemediation"] = "EXPORTS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ExportDspRemediation"] = "EXPORT_DSP_REMEDIATION";
    ShepherdRemediationActionType["ExportSpacePermissionsRemediation"] = "EXPORT_SPACE_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["JiraGlobalPermissionsRemediation"] = "JIRA_GLOBAL_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["KeyOwnerRemediation"] = "KEY_OWNER_REMEDIATION";
    ShepherdRemediationActionType["LimitJiraPermissionsRemediation"] = "LIMIT_JIRA_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["ManageAppsRemediation"] = "MANAGE_APPS_REMEDIATION";
    ShepherdRemediationActionType["ManageDomainRemediation"] = "MANAGE_DOMAIN_REMEDIATION";
    ShepherdRemediationActionType["ManageDspRemediation"] = "MANAGE_DSP_REMEDIATION";
    ShepherdRemediationActionType["PublicAccessDspRemediation"] = "PUBLIC_ACCESS_DSP_REMEDIATION";
    ShepherdRemediationActionType["ResetAccountPasswordRemediation"] = "RESET_ACCOUNT_PASSWORD_REMEDIATION";
    ShepherdRemediationActionType["RestoreAccessRemediation"] = "RESTORE_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["ReviewAccessRemediation"] = "REVIEW_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["ReviewApiKeysRemediation"] = "REVIEW_API_KEYS_REMEDIATION";
    ShepherdRemediationActionType["ReviewApiTokensRemediation"] = "REVIEW_API_TOKENS_REMEDIATION";
    ShepherdRemediationActionType["ReviewAuditLogRemediation"] = "REVIEW_AUDIT_LOG_REMEDIATION";
    ShepherdRemediationActionType["ReviewAuthPolicyRemediation"] = "REVIEW_AUTH_POLICY_REMEDIATION";
    ShepherdRemediationActionType["ReviewGsyncRemediation"] = "REVIEW_GSYNC_REMEDIATION";
    ShepherdRemediationActionType["ReviewIpAllowlistRemediation"] = "REVIEW_IP_ALLOWLIST_REMEDIATION";
    ShepherdRemediationActionType["ReviewIssueRemediation"] = "REVIEW_ISSUE_REMEDIATION";
    ShepherdRemediationActionType["ReviewOtherAuthPoliciesRemediation"] = "REVIEW_OTHER_AUTH_POLICIES_REMEDIATION";
    ShepherdRemediationActionType["ReviewOtherIpAllowlistRemediation"] = "REVIEW_OTHER_IP_ALLOWLIST_REMEDIATION";
    ShepherdRemediationActionType["ReviewPageRemediation"] = "REVIEW_PAGE_REMEDIATION";
    ShepherdRemediationActionType["ReviewSamlRemediation"] = "REVIEW_SAML_REMEDIATION";
    ShepherdRemediationActionType["ReviewScimRemediation"] = "REVIEW_SCIM_REMEDIATION";
    ShepherdRemediationActionType["ReviewTunnelsConfigurationRemediation"] = "REVIEW_TUNNELS_CONFIGURATION_REMEDIATION";
    ShepherdRemediationActionType["ReviewTunnelsRemediation"] = "REVIEW_TUNNELS_REMEDIATION";
    ShepherdRemediationActionType["RevokeAccessRemediation"] = "REVOKE_ACCESS_REMEDIATION";
    ShepherdRemediationActionType["RevokeApiKeyRemediation"] = "REVOKE_API_KEY_REMEDIATION";
    ShepherdRemediationActionType["RevokeApiTokensRemediation"] = "REVOKE_API_TOKENS_REMEDIATION";
    ShepherdRemediationActionType["SpacePermissionsRemediation"] = "SPACE_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["SuspendActorRemediation"] = "SUSPEND_ACTOR_REMEDIATION";
    ShepherdRemediationActionType["SuspendSubjectRemediation"] = "SUSPEND_SUBJECT_REMEDIATION";
    ShepherdRemediationActionType["TurnOffJiraPermissionsRemediation"] = "TURN_OFF_JIRA_PERMISSIONS_REMEDIATION";
    ShepherdRemediationActionType["TwoStepPolicyRemediation"] = "TWO_STEP_POLICY_REMEDIATION";
    ShepherdRemediationActionType["ViewSpacePermissionsRemediation"] = "VIEW_SPACE_PERMISSIONS_REMEDIATION";
    return ShepherdRemediationActionType;
}({}); /** Represents a resource that was acted upon at a specific time */ 
let $5b8397cef71e8614$export$e0c4be2f8b0999ce = /*#__PURE__*/ function(ShepherdSearchOrigin) {
    ShepherdSearchOrigin["AdvancedSearch"] = "ADVANCED_SEARCH";
    ShepherdSearchOrigin["Ai"] = "AI";
    ShepherdSearchOrigin["QuickSearch"] = "QUICK_SEARCH";
    return ShepherdSearchOrigin;
}({}); /** Provides all necessary metadata about a search query */  /** Represents a slack subscription in the Shepherd system. */  /** The resource was acted on */  /** The resource was acted on */  /** Common interface for all subscriptions. */  /**
 * Use a type instead of an interface.
 *
 * "Edge type must be an Object type."
 * See: https://github.com/B2o5T/graphql-eslint/blob/master/docs/rules/relay-edge-types.md
 */ 
let $5b8397cef71e8614$export$8f5af6e8802c488 = /*#__PURE__*/ function(ShepherdSubscriptionStatus) {
    ShepherdSubscriptionStatus["Active"] = "ACTIVE";
    ShepherdSubscriptionStatus["Inactive"] = "INACTIVE";
    return ShepherdSubscriptionStatus;
}({}); /** Represents a point in time or an interval (when `end` is present) */  /** Time or interval */  /** Represents a user in the Shepherd system. */  /** Represents the possible vortexMode values for a workspace. */ 
let $5b8397cef71e8614$export$80ad4b94a728f2e2 = /*#__PURE__*/ function(ShepherdVortexModeStatus) {
    ShepherdVortexModeStatus["Disabled"] = "DISABLED";
    ShepherdVortexModeStatus["Enabled"] = "ENABLED";
    return ShepherdVortexModeStatus;
}({}); /** Represents type of Webhook payload */ 
let $5b8397cef71e8614$export$cfc31900765a3ba4 = /*#__PURE__*/ function(ShepherdWebhookDestinationType) {
    ShepherdWebhookDestinationType["Default"] = "DEFAULT";
    ShepherdWebhookDestinationType["MicrosoftTeams"] = "MICROSOFT_TEAMS";
    return ShepherdWebhookDestinationType;
}({}); /** Represents a webhook subscription in the Shepherd system. */  /**
 * Represents type of Webhook
 * DEPRECATED: Use destinationType instead.
 */ 
let $5b8397cef71e8614$export$2e013066679d73f8 = /*#__PURE__*/ function(ShepherdWebhookType) {
    ShepherdWebhookType["Custom"] = "CUSTOM";
    ShepherdWebhookType["MicrosoftTeams"] = "MICROSOFT_TEAMS";
    ShepherdWebhookType["Slack"] = "SLACK";
    return ShepherdWebhookType;
}({}); /** Represents a workspace in the Shepherd system. */  /** Represents a workspace in the Shepherd system. */  /** Represents a workspace in the Shepherd system. */  /**
 * Contains the setting value for a detection
 * While we currently only have one detection type (threshold), if we add more in the future there would be more fields
 * on this type, only one of which should be populated at a time.
 */ 
let $5b8397cef71e8614$export$c32ed3061693e3f1 = /*#__PURE__*/ function(SoftwareCardsDestinationEnum) {
    SoftwareCardsDestinationEnum["Backlog"] = "BACKLOG";
    SoftwareCardsDestinationEnum["ExistingSprint"] = "EXISTING_SPRINT";
    SoftwareCardsDestinationEnum["NewSprint"] = "NEW_SPRINT";
    return SoftwareCardsDestinationEnum;
}({}); /** Node for querying any report page's data */  /** The sort direction of the collection */ 
let $5b8397cef71e8614$export$79e2d9500680dd96 = /*#__PURE__*/ function(SortDirection) {
    SortDirection["Asc"] = "ASC";
    SortDirection["Desc"] = "DESC";
    return SortDirection;
}({});
let $5b8397cef71e8614$export$7ae723045d45777a = /*#__PURE__*/ function(SortOrder) {
    SortOrder["Asc"] = "ASC";
    SortOrder["Desc"] = "DESC";
    return SortOrder;
}({});
let $5b8397cef71e8614$export$88ef8388f421e95e = /*#__PURE__*/ function(SprintReportsEstimationStatisticType) {
    SprintReportsEstimationStatisticType["IssueCount"] = "ISSUE_COUNT";
    SprintReportsEstimationStatisticType["OriginalEstimate"] = "ORIGINAL_ESTIMATE";
    SprintReportsEstimationStatisticType["StoryPoints"] = "STORY_POINTS";
    return SprintReportsEstimationStatisticType;
}({});
let $5b8397cef71e8614$export$f37cb7e02dc42251 = /*#__PURE__*/ function(SprintState) {
    SprintState["Active"] = "ACTIVE";
    SprintState["Closed"] = "CLOSED";
    SprintState["Future"] = "FUTURE";
    return SprintState;
}({}); /** Start sprint */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** The top level wrapper for the CSP Support Request Mutations API. */  /** Top level wrapper for CSP Support Request queries API */  /** Top level wrapper for CSP Support Request queries API */  /** A comment for the request. These are non-hierarchical comments and are only linked to a single request. */  /** A DateTime type for the request, this contains multiple formats of datetime */  /** Enum that specify the data type of the field. */ 
let $5b8397cef71e8614$export$db58b0fec288f2d5 = /*#__PURE__*/ function(SupportRequestFieldDataType) {
    SupportRequestFieldDataType["Boolean"] = "BOOLEAN";
    SupportRequestFieldDataType["Date"] = "DATE";
    SupportRequestFieldDataType["Number"] = "NUMBER";
    SupportRequestFieldDataType["String"] = "STRING";
    return SupportRequestFieldDataType;
}({}); /** The value of the field. This has been kept as a seperate type for extensibility, such as including icons. */  /** Query parameter for how this user has access to the request, e.g. they were the reporter or added as a participant. */ 
let $5b8397cef71e8614$export$5d395d1469cf6904 = /*#__PURE__*/ function(SupportRequestNamedContactOperation) {
    SupportRequestNamedContactOperation["Add"] = "ADD";
    SupportRequestNamedContactOperation["Remove"] = "REMOVE";
    return SupportRequestNamedContactOperation;
}({}); /** A user (customer or agent) of the support system. */  /** A user (customer or agent) of the support system. */  /** A user (customer or agent) of the support system. */  /** Query parameter for how this user has access to the request, e.g. they were the reporter or added as a participant. */ 
let $5b8397cef71e8614$export$15d04aa1faaca584 = /*#__PURE__*/ function(SupportRequestQueryOwnership) {
    SupportRequestQueryOwnership["Participant"] = "PARTICIPANT";
    SupportRequestQueryOwnership["Reporter"] = "REPORTER";
    return SupportRequestQueryOwnership;
}({}); /** The general category for the status of the ticket. */ 
let $5b8397cef71e8614$export$cf9ba11854f7cb39 = /*#__PURE__*/ function(SupportRequestQueryStatusCategory) {
    SupportRequestQueryStatusCategory["Done"] = "DONE";
    SupportRequestQueryStatusCategory["Open"] = "OPEN";
    return SupportRequestQueryStatusCategory;
}({}); /** The general category for the status of the ticket. */ 
let $5b8397cef71e8614$export$21de27a5998af787 = /*#__PURE__*/ function(SupportRequestStatusCategory) {
    SupportRequestStatusCategory["Done"] = "DONE";
    SupportRequestStatusCategory["InProgress"] = "IN_PROGRESS";
    SupportRequestStatusCategory["Open"] = "OPEN";
    return SupportRequestStatusCategory;
}({}); /** The supported usertype of user in system */ 
let $5b8397cef71e8614$export$4e3e0500b62d4705 = /*#__PURE__*/ function(SupportRequestUserType) {
    SupportRequestUserType["Customer"] = "CUSTOMER";
    SupportRequestUserType["Partner"] = "PARTNER";
    return SupportRequestUserType;
}({}); /** How to group cards on the board into swimlanes */ 
let $5b8397cef71e8614$export$39b890c79449a0 = /*#__PURE__*/ function(SwimlaneStrategy) {
    SwimlaneStrategy["Assignee"] = "ASSIGNEE";
    SwimlaneStrategy["Issuechildren"] = "ISSUECHILDREN";
    SwimlaneStrategy["Issueparent"] = "ISSUEPARENT";
    SwimlaneStrategy["None"] = "NONE";
    return SwimlaneStrategy;
}({}); /** Team returned in a team query */  /** Team returned in a team query */  /** Returns the details of the team member and details about their membership within a team */  /** The connection entity for the members of a team for pagination */  /** The connection entity for the members of a team for pagination */  /** Returns the details of the team member and details about their membership within a team */  /** Member filter used as input on team search filter */  /** The roles that a member can have within a team */ 
let $5b8397cef71e8614$export$6a422ea3acdf9d9b = /*#__PURE__*/ function(TeamMembershipRole) {
    TeamMembershipRole["Admin"] = "ADMIN";
    TeamMembershipRole["Regular"] = "REGULAR";
    return TeamMembershipRole;
}({}); /** The settings which a team can have describing how members are added to the team */ 
let $5b8397cef71e8614$export$93b1c6cf9d16dce6 = /*#__PURE__*/ function(TeamMembershipSettings) {
    TeamMembershipSettings["External"] = "EXTERNAL";
    TeamMembershipSettings["MemberInvite"] = "MEMBER_INVITE";
    TeamMembershipSettings["Open"] = "OPEN";
    return TeamMembershipSettings;
}({}); /** The states that a member can have within a team */ 
let $5b8397cef71e8614$export$f627e98535fb8637 = /*#__PURE__*/ function(TeamMembershipState) {
    TeamMembershipState["Alumni"] = "ALUMNI";
    TeamMembershipState["FullMember"] = "FULL_MEMBER";
    TeamMembershipState["RequestingToJoin"] = "REQUESTING_TO_JOIN";
    return TeamMembershipState;
}({});
let $5b8397cef71e8614$export$76b040ede9e99a0e = /*#__PURE__*/ function(TeamRole) {
    TeamRole["TeamsAdmin"] = "TEAMS_ADMIN";
    TeamRole["TeamsObserver"] = "TEAMS_OBSERVER";
    TeamRole["TeamsUser"] = "TEAMS_USER";
    return TeamRole;
}({}); /** Enum representing the search fields for teams. */ 
let $5b8397cef71e8614$export$3d32048696128045 = /*#__PURE__*/ function(TeamSearchField) {
    TeamSearchField["Description"] = "DESCRIPTION";
    TeamSearchField["Name"] = "NAME";
    return TeamSearchField;
}({}); /** Team filter used as input on team search */  /** Team returned in search */  /** The result of the search for teams. */  /** The result of the search for teams. */  /** An edge from a team search */  /** An edge from a team search */  /** Team returned in search */  /** Team sort used as input on team search */  /** Team sort fields */ 
let $5b8397cef71e8614$export$c701f1c8ac34f3b8 = /*#__PURE__*/ function(TeamSortField) {
    TeamSortField["DisplayName"] = "DISPLAY_NAME";
    TeamSortField["Id"] = "ID";
    TeamSortField["State"] = "STATE";
    return TeamSortField;
}({}); /** Team Sort Order */ 
let $5b8397cef71e8614$export$cecdee868554f386 = /*#__PURE__*/ function(TeamSortOrder) {
    TeamSortOrder["Asc"] = "ASC";
    TeamSortOrder["Desc"] = "DESC";
    return TeamSortOrder;
}({}); /** The states that a team can have */ 
let $5b8397cef71e8614$export$c5c56131401e0716 = /*#__PURE__*/ function(TeamState) {
    TeamState["Active"] = "ACTIVE";
    TeamState["Disbanded"] = "DISBANDED";
    TeamState["Purged"] = "PURGED";
    return TeamState;
}({}); /** The states that a team can have */ 
let $5b8397cef71e8614$export$15fa8968cce33b6 = /*#__PURE__*/ function(TeamStateV2) {
    TeamStateV2["Active"] = "ACTIVE";
    TeamStateV2["Purged"] = "PURGED";
    return TeamStateV2;
}({}); /** Team returned in a team query */  /** Team returned in a team query */  /** The input for a Third Party Repository */  /**
 * This represent a third party user
 *
 * ### OAuth Scopes
 *
 * One of the following scopes will need to be present on OAuth requests to get data from this field
 *
 * * __identity:atlassian-external__
 * * __read:account__
 */ 
let $5b8397cef71e8614$export$be996b3d78d87257 = /*#__PURE__*/ function(ToolchainAssociateEntitiesErrorCode) {
    ToolchainAssociateEntitiesErrorCode["EntityRejected"] = "ENTITY_REJECTED";
    ToolchainAssociateEntitiesErrorCode["EntityUrlInvalid"] = "ENTITY_URL_INVALID";
    ToolchainAssociateEntitiesErrorCode["ProviderEntityFetchForbidden"] = "PROVIDER_ENTITY_FETCH_FORBIDDEN";
    ToolchainAssociateEntitiesErrorCode["ProviderEntityNotFound"] = "PROVIDER_ENTITY_NOT_FOUND";
    ToolchainAssociateEntitiesErrorCode["ProviderError"] = "PROVIDER_ERROR";
    ToolchainAssociateEntitiesErrorCode["ProviderInputInvalid"] = "PROVIDER_INPUT_INVALID";
    return ToolchainAssociateEntitiesErrorCode;
}({}); /** This is a union of all the consumer schemas supported by the associate container API */  /** This is a union of all the consumer schemas supported by the associate entity API */ 
let $5b8397cef71e8614$export$96ad634185a48695 = /*#__PURE__*/ function(ToolchainCheckAuthErrorCode) {
    ToolchainCheckAuthErrorCode["ProviderError"] = "PROVIDER_ERROR";
    return ToolchainCheckAuthErrorCode;
}({}); /** This is a union of all the auth types supported by the check auth API and query error if check auth is unsuccessful */ 
let $5b8397cef71e8614$export$a675cf96020918d = /*#__PURE__*/ function(ToolchainCreateContainerErrorCode) {
    ToolchainCreateContainerErrorCode["ProviderContainerAlreadyExists"] = "PROVIDER_CONTAINER_ALREADY_EXISTS";
    ToolchainCreateContainerErrorCode["ProviderContainerCreateForbidden"] = "PROVIDER_CONTAINER_CREATE_FORBIDDEN";
    ToolchainCreateContainerErrorCode["ProviderError"] = "PROVIDER_ERROR";
    ToolchainCreateContainerErrorCode["ProviderInputInvalid"] = "PROVIDER_INPUT_INVALID";
    ToolchainCreateContainerErrorCode["ProviderWorkspaceNotFound"] = "PROVIDER_WORKSPACE_NOT_FOUND";
    return ToolchainCreateContainerErrorCode;
}({}); /** Either both `cloudId` and 'providerId', or 'workspaceId' must be specified. */ 
let $5b8397cef71e8614$export$911f961eae9c7bb3 = /*#__PURE__*/ function(ToolchainDisassociateEntitiesErrorCode) {
    ToolchainDisassociateEntitiesErrorCode["UnknownAssociation"] = "UNKNOWN_ASSOCIATION";
    return ToolchainDisassociateEntitiesErrorCode;
}({}); /**
 * Type of a data-depot provider.
 * A provider may belongs to multiple types (e.g an connect-app can send both build and deployment info).
 */ 
let $5b8397cef71e8614$export$a76864a49f160fd1 = /*#__PURE__*/ function(ToolchainProviderType) {
    ToolchainProviderType["Build"] = "BUILD";
    ToolchainProviderType["Deployment"] = "DEPLOYMENT";
    ToolchainProviderType["Design"] = "DESIGN";
    ToolchainProviderType["DevopsComponents"] = "DEVOPS_COMPONENTS";
    ToolchainProviderType["DevInfo"] = "DEV_INFO";
    ToolchainProviderType["Documentation"] = "DOCUMENTATION";
    ToolchainProviderType["FeatureFlag"] = "FEATURE_FLAG";
    ToolchainProviderType["Operations"] = "OPERATIONS";
    ToolchainProviderType["RemoteLinks"] = "REMOTE_LINKS";
    ToolchainProviderType["Security"] = "SECURITY";
    return ToolchainProviderType;
}({});
let $5b8397cef71e8614$export$358b14067bcbe24d = /*#__PURE__*/ function(ToolchainSyncState) {
    ToolchainSyncState["Complete"] = "COMPLETE";
    ToolchainSyncState["Error"] = "ERROR";
    ToolchainSyncState["InProgress"] = "IN_PROGRESS";
    return ToolchainSyncState;
}({});
let $5b8397cef71e8614$export$74b7a9159262d2e = /*#__PURE__*/ function(ToolchainWorkspaceConnectionErrorCode) {
    ToolchainWorkspaceConnectionErrorCode["ProviderActionError"] = "PROVIDER_ACTION_ERROR";
    ToolchainWorkspaceConnectionErrorCode["ProviderNotSupported"] = "PROVIDER_NOT_SUPPORTED";
    return ToolchainWorkspaceConnectionErrorCode;
}({});
let $5b8397cef71e8614$export$e2d891f9dd055fc4 = /*#__PURE__*/ function(TownsquareGoalSortEnum) {
    TownsquareGoalSortEnum["CreationDateAsc"] = "CREATION_DATE_ASC";
    TownsquareGoalSortEnum["CreationDateDesc"] = "CREATION_DATE_DESC";
    TownsquareGoalSortEnum["HierarchyAsc"] = "HIERARCHY_ASC";
    TownsquareGoalSortEnum["HierarchyDesc"] = "HIERARCHY_DESC";
    TownsquareGoalSortEnum["HierarchyLevelAsc"] = "HIERARCHY_LEVEL_ASC";
    TownsquareGoalSortEnum["HierarchyLevelDesc"] = "HIERARCHY_LEVEL_DESC";
    TownsquareGoalSortEnum["IdAsc"] = "ID_ASC";
    TownsquareGoalSortEnum["IdDesc"] = "ID_DESC";
    TownsquareGoalSortEnum["LatestUpdateDateAsc"] = "LATEST_UPDATE_DATE_ASC";
    TownsquareGoalSortEnum["LatestUpdateDateDesc"] = "LATEST_UPDATE_DATE_DESC";
    TownsquareGoalSortEnum["NameAsc"] = "NAME_ASC";
    TownsquareGoalSortEnum["NameDesc"] = "NAME_DESC";
    TownsquareGoalSortEnum["ProjectCountAsc"] = "PROJECT_COUNT_ASC";
    TownsquareGoalSortEnum["ProjectCountDesc"] = "PROJECT_COUNT_DESC";
    TownsquareGoalSortEnum["ScoreAsc"] = "SCORE_ASC";
    TownsquareGoalSortEnum["ScoreDesc"] = "SCORE_DESC";
    TownsquareGoalSortEnum["TargetDateAsc"] = "TARGET_DATE_ASC";
    TownsquareGoalSortEnum["TargetDateDesc"] = "TARGET_DATE_DESC";
    TownsquareGoalSortEnum["WatchingAsc"] = "WATCHING_ASC";
    TownsquareGoalSortEnum["WatchingDesc"] = "WATCHING_DESC";
    return TownsquareGoalSortEnum;
}({});
let $5b8397cef71e8614$export$114cd33b2bd21562 = /*#__PURE__*/ function(TownsquareGoalStateValue) {
    TownsquareGoalStateValue["Archived"] = "archived";
    TownsquareGoalStateValue["AtRisk"] = "at_risk";
    TownsquareGoalStateValue["Cancelled"] = "cancelled";
    TownsquareGoalStateValue["Done"] = "done";
    TownsquareGoalStateValue["OffTrack"] = "off_track";
    TownsquareGoalStateValue["OnTrack"] = "on_track";
    TownsquareGoalStateValue["Paused"] = "paused";
    TownsquareGoalStateValue["Pending"] = "pending";
    return TownsquareGoalStateValue;
}({});
let $5b8397cef71e8614$export$d857eec43cac6124 = /*#__PURE__*/ function(TownsquareGoalTypeState) {
    TownsquareGoalTypeState["Disabled"] = "DISABLED";
    TownsquareGoalTypeState["Enabled"] = "ENABLED";
    return TownsquareGoalTypeState;
}({});
let $5b8397cef71e8614$export$8aa4fdb7ade2bdbb = /*#__PURE__*/ function(TownsquareProjectSortEnum) {
    TownsquareProjectSortEnum["CreationDateAsc"] = "CREATION_DATE_ASC";
    TownsquareProjectSortEnum["CreationDateDesc"] = "CREATION_DATE_DESC";
    TownsquareProjectSortEnum["IdAsc"] = "ID_ASC";
    TownsquareProjectSortEnum["IdDesc"] = "ID_DESC";
    TownsquareProjectSortEnum["LatestUpdateDateAsc"] = "LATEST_UPDATE_DATE_ASC";
    TownsquareProjectSortEnum["LatestUpdateDateDesc"] = "LATEST_UPDATE_DATE_DESC";
    TownsquareProjectSortEnum["NameAsc"] = "NAME_ASC";
    TownsquareProjectSortEnum["NameDesc"] = "NAME_DESC";
    TownsquareProjectSortEnum["StartDateAsc"] = "START_DATE_ASC";
    TownsquareProjectSortEnum["StartDateDesc"] = "START_DATE_DESC";
    TownsquareProjectSortEnum["StatusAsc"] = "STATUS_ASC";
    TownsquareProjectSortEnum["StatusDesc"] = "STATUS_DESC";
    TownsquareProjectSortEnum["TargetDateAsc"] = "TARGET_DATE_ASC";
    TownsquareProjectSortEnum["TargetDateDesc"] = "TARGET_DATE_DESC";
    TownsquareProjectSortEnum["WatchingAsc"] = "WATCHING_ASC";
    TownsquareProjectSortEnum["WatchingDesc"] = "WATCHING_DESC";
    return TownsquareProjectSortEnum;
}({});
let $5b8397cef71e8614$export$ee344fc0997809d6 = /*#__PURE__*/ function(TownsquareProjectStateValue) {
    TownsquareProjectStateValue["Archived"] = "archived";
    TownsquareProjectStateValue["AtRisk"] = "at_risk";
    TownsquareProjectStateValue["Cancelled"] = "cancelled";
    TownsquareProjectStateValue["Done"] = "done";
    TownsquareProjectStateValue["OffTrack"] = "off_track";
    TownsquareProjectStateValue["OnTrack"] = "on_track";
    TownsquareProjectStateValue["Paused"] = "paused";
    TownsquareProjectStateValue["Pending"] = "pending";
    return TownsquareProjectStateValue;
}({}); /**
 * These are the currently supported relationships. The relationships are directional in the ARI Graph Store, so the order of "from" and "to" does matter.
 *
 *
 * | From           |   | To         |
 * |----------------|---|------------|
 * | Atlas Project  | → | Jira Issue |
 * | Jira Issue     | → | Atlas Goal |
 */ 
let $5b8397cef71e8614$export$84f5d3c1f2497f3c = /*#__PURE__*/ function(TownsquareTargetDateType) {
    TownsquareTargetDateType["Day"] = "DAY";
    TownsquareTargetDateType["Month"] = "MONTH";
    TownsquareTargetDateType["Quarter"] = "QUARTER";
    return TownsquareTargetDateType;
}({}); /** Collection of AI preferences */  /** An Attachment on a Trello Card */  /** Trello attachment connection */  /** Trello attachment edge */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** The primary board component which contains lists and cards. */  /** Attachment limits for the board */  /** Collection of attributes representing the board background. */  /** Limits that apply to the board itself */  /** Card limits for the board */  /** CheckItem limits for the board */  /** Checklist limits for the board */  /** CustomFieldOption limits for the board */  /** CustomField limits for the board */  /** Represents a basic relationship between a node and a TrelloBoard. */  /** Label limits for the board */  /** Collection of limits that apply to a TrelloBoard */  /** List limits for the board */  /** Represents a relationship between a board and a member */  /** Filter input for TrelloBoard.members */  /** Metadata about a relationship between a member and a board */  /** Membership types for a TrelloBoard */ 
let $5b8397cef71e8614$export$532fae07bf79d169 = /*#__PURE__*/ function(TrelloBoardMembershipType) {
    TrelloBoardMembershipType["Admin"] = "ADMIN";
    TrelloBoardMembershipType["Normal"] = "NORMAL";
    TrelloBoardMembershipType["Observer"] = "OBSERVER";
    return TrelloBoardMembershipType;
}({}); /** Connection type to represent board memberships */  /** Connection type between a board and its powerUps */  /**
 * Represents a basic relationship between a node and a TrelloPowerUp.
 * The fields promotional, objectId, and memberId are null if the
 * powerUp is not enabled on the board
 */ 
let $5b8397cef71e8614$export$e19d69c6b75aa26f = /*#__PURE__*/ function(TrelloCardCoverBrightness) {
    TrelloCardCoverBrightness["Dark"] = "DARK";
    TrelloCardCoverBrightness["Light"] = "LIGHT";
    return TrelloCardCoverBrightness;
}({}); /** TrelloCardCover color */ 
let $5b8397cef71e8614$export$b1a4da8c2172956c = /*#__PURE__*/ function(TrelloCardCoverColor) {
    TrelloCardCoverColor["Black"] = "BLACK";
    TrelloCardCoverColor["Blue"] = "BLUE";
    TrelloCardCoverColor["Green"] = "GREEN";
    TrelloCardCoverColor["Lime"] = "LIME";
    TrelloCardCoverColor["Orange"] = "ORANGE";
    TrelloCardCoverColor["Pink"] = "PINK";
    TrelloCardCoverColor["Purple"] = "PURPLE";
    TrelloCardCoverColor["Red"] = "RED";
    TrelloCardCoverColor["Sky"] = "SKY";
    TrelloCardCoverColor["Yellow"] = "YELLOW";
    return TrelloCardCoverColor;
}({}); /** TrelloCardCover size */ 
let $5b8397cef71e8614$export$17aa2e5fc86f2e30 = /*#__PURE__*/ function(TrelloCardCoverSize) {
    TrelloCardCoverSize["Full"] = "FULL";
    TrelloCardCoverSize["Normal"] = "NORMAL";
    return TrelloCardCoverSize;
}({}); /** The cover of a trello card. */  /** Information about the due property of a TrelloCard */  /** Represents a basic relationship between a node and a TrelloCard. */  /** TrelloCard external sources, from which cards can be generated */ 
let $5b8397cef71e8614$export$a209f50d5cb5f744 = /*#__PURE__*/ function(TrelloCardExternalSource) {
    TrelloCardExternalSource["Email"] = "EMAIL";
    return TrelloCardExternalSource;
}({}); /** Trello Card Limit */  /** Limits for a card */  /** TrelloCard location information */  /** Special TrelloCard roles */ 
let $5b8397cef71e8614$export$3246e4d5604c366a = /*#__PURE__*/ function(TrelloCardRole) {
    TrelloCardRole["Board"] = "BOARD";
    TrelloCardRole["Link"] = "LINK";
    TrelloCardRole["Mirror"] = "MIRROR";
    TrelloCardRole["Separator"] = "SEPARATOR";
    return TrelloCardRole;
}({}); /** The updated card fields within a TrelloBoardUpdated event. */  /** Connection type emulating relay-style paging for list data on TrelloBoardUpdated events */  /** Trello card viewer for card front badges */  /** A Trello checklist */  /** Connection type between a container and its checklists. */  /** Represents a basic relationship between a node and a TrelloChecklist. */  /** A Trello Custom Field */  /** Custom field connection */  /** Display options for the custom field. */  /** Custom field edge. */  /** A Trello Custom Field item */  /** Connection type between an entity and its Custom Field items. */  /** Represents a basic relationship between a node and a TrelloCustomFieldItem. */  /** Information describing the value of a Custom Field item. */  /** An option for a custom field (e.g. a dropdown option) */  /** The value of the custom field option. */  /** User-generated description of a Trello entity */  /** The data required to render custom emoji in description fields on Trello entities */  /** Connection type between a description data and its set of custom emojis */  /** Represents a basic relationship between a node and a TrelloDescriptionCustomEmoji. */  /** Custom data used to render the description of certain Trello entities */  /** Custom data used to render the description of certain Trello entities */  /** A Trello Enterprise. */  /** Collection of preferences for the enterprise */  /** A Trello Image Preview */  /** Connection type between an object that contains an image and its previews. */  /** Represents a basic relationship between a node and a TrelloImagePreview. */  /**
 * Connection type between an object that contains an image and its previews, modified
 * for subscriptions
 */ 
let $5b8397cef71e8614$export$d6da0c6d5fb213f0 = /*#__PURE__*/ function(TrelloPowerUpDataAccess) {
    TrelloPowerUpDataAccess["Private"] = "PRIVATE";
    TrelloPowerUpDataAccess["Shared"] = "SHARED";
    return TrelloPowerUpDataAccess;
}({}); /** Connection type between an entity and its powerUpData entries. */  /** Represents a basic relationship between a node and a TrelloPowerUpData. */  /** Filters to apply when querying powerUpData. */  /** TrelloPowerUpData scope */ 
let $5b8397cef71e8614$export$bc6cfd4fe0c319ad = /*#__PURE__*/ function(TrelloPowerUpDataScope) {
    TrelloPowerUpDataScope["Board"] = "BOARD";
    TrelloPowerUpDataScope["Card"] = "CARD";
    TrelloPowerUpDataScope["Organization"] = "ORGANIZATION";
    return TrelloPowerUpDataScope;
}({}); /** Represents the icon for this powerUp */  /** The updated powerUp ID on the card */  /**
 * This is a top level query type under which all of Trello's supported queries
 * are under. It is used to group Trello's GraphQL queries from other Atlassian
 * queries.
 */ 
let $5b8397cef71e8614$export$1ee95821123803e6 = /*#__PURE__*/ function(TrelloSupportedPlannerProviders) {
    TrelloSupportedPlannerProviders["Google"] = "GOOGLE";
    return TrelloSupportedPlannerProviders;
}({}); /** Information for which switcher views are enabled for this board. */  /** Tag (or Collection). Used to group related entities in a workspace. */  /** A generic connection type to related Tags. */  /** A generic edge between an entity and a related Tag. */  /** The categories for the Trello template gallery. */  /** Connection type between the Template Gallery and the related Board Templates. */  /** Filters to apply when querying the Template Gallery. */  /** Information about a Template Gallery Item. */  /**
 * Statistics of the template gallery item such as view count and number of times
 * it's been copied.
 */ 
let $5b8397cef71e8614$export$d563dba18e915a44 = /*#__PURE__*/ function(TrelloWorkspaceMembershipType) {
    TrelloWorkspaceMembershipType["Admin"] = "ADMIN";
    TrelloWorkspaceMembershipType["Normal"] = "NORMAL";
    return TrelloWorkspaceMembershipType;
}({}); /** Connection type to represent workspace memberships */  /** Collection of preferences for the workspace. */  /** Product tiers for a TrelloWorkspace */ 
let $5b8397cef71e8614$export$c8c804aa42adf4e6 = /*#__PURE__*/ function(TrelloWorkspaceTier) {
    TrelloWorkspaceTier["Paid"] = "PAID";
    return TrelloWorkspaceTier;
}({}); /** Handles detaching a dataManager from a Component */  /** Response from editing an app contributor role */  /** Input payload for enrolling scopes to an app environment */  /** Response from enrolling scopes into an app environment */  /** Input payload for updating an Atlassian OAuth Client mutation */  /** Response from updating an oauth client */  /** Accepts input to update a data manager on a component. */  /** The payload returned from updating a data manager of a component. */  /** Accepts input for updating an existing component. */  /** Accepts input for updating a component link. */  /** The payload returned after updating a component link. */  /** The payload returned from updating an existing component. */  /** Accepts input for updating an existing component's type. */  /** Input to update the metadata for a component type. */  /** The result from updating the metadata for a component type. */  /** The payload returned from updating a component's type. */  /** Accepts input to update a field. */  /** Accepts input to a update a scorecard criterion representing the presence of a description. */  /** Accepts input to update a scorecard criterion representing the presence of a field, for example, 'Has Tier'. */  /** Accepts input to update a scorecard criterion representing the presence of a link, for example, 'Has Repository' or 'Has Documentation'. */  /** Accepts input to update a scorecard criterion checking the value of a specified metric ID. */  /** Accepts input to a update a scorecard criterion representing the presence of an owner. */  /** Accepts details of the link to be updated. */  /** The payload returned from updating a scorecard criterion. */  /** The input sent when updating user defined parameters. */  /** The payload returned from updating user defined parameters. */  /**
 * ###################################################################################################################
 *  COMPASS API SPEC
 * ###################################################################################################################
 */ 
let $5b8397cef71e8614$export$8808d536a6b2ef88 = /*#__PURE__*/ function(UserInstallationRuleValue) {
    UserInstallationRuleValue["Allow"] = "allow";
    UserInstallationRuleValue["Deny"] = "deny";
    return UserInstallationRuleValue;
}({});
let $5b8397cef71e8614$export$4789b44fbe86836 = /*#__PURE__*/ function(VirtualAgentConversationActionType) {
    VirtualAgentConversationActionType["AiAnswered"] = "AI_ANSWERED";
    VirtualAgentConversationActionType["Matched"] = "MATCHED";
    VirtualAgentConversationActionType["Unhandled"] = "UNHANDLED";
    return VirtualAgentConversationActionType;
}({});
let $5b8397cef71e8614$export$e372c28ac4fddc25 = /*#__PURE__*/ function(VirtualAgentConversationCsatOptionType) {
    VirtualAgentConversationCsatOptionType["CsatOption_1"] = "CSAT_OPTION_1";
    VirtualAgentConversationCsatOptionType["CsatOption_2"] = "CSAT_OPTION_2";
    VirtualAgentConversationCsatOptionType["CsatOption_3"] = "CSAT_OPTION_3";
    VirtualAgentConversationCsatOptionType["CsatOption_4"] = "CSAT_OPTION_4";
    VirtualAgentConversationCsatOptionType["CsatOption_5"] = "CSAT_OPTION_5";
    return VirtualAgentConversationCsatOptionType;
}({});
let $5b8397cef71e8614$export$620fe609179029be = /*#__PURE__*/ function(VirtualAgentConversationState) {
    VirtualAgentConversationState["Closed"] = "CLOSED";
    VirtualAgentConversationState["Escalated"] = "ESCALATED";
    VirtualAgentConversationState["Open"] = "OPEN";
    VirtualAgentConversationState["Resolved"] = "RESOLVED";
    return VirtualAgentConversationState;
}({}); /** Accepts input for creating a VirtualAgent Configuration. */  /**
 * A temporary type for VirtualAgentIntentProjection until it's properly migrated over to Verbena
 * Do not diverge it from the original
 */ 
let $5b8397cef71e8614$export$68d524b762f21460 = /*#__PURE__*/ function(VirtualAgentIntentTemplateType) {
    VirtualAgentIntentTemplateType["Discovered"] = "DISCOVERED";
    VirtualAgentIntentTemplateType["Shared"] = "SHARED";
    VirtualAgentIntentTemplateType["Standard"] = "STANDARD";
    return VirtualAgentIntentTemplateType;
}({}); /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Mutation API. */  /** The top level wrapper for the Virtual Agent Query API. */  /** The top level wrapper for the Virtual Agent Query API. */  /** The top level wrapper for the Virtual Agent Query API. */  /** Accepts input for updating an existing VirtualAgent Configuration. */  /** User facing validation error. On the FE this mutation error will not go to Sentry */ 
let $5b8397cef71e8614$export$f794720beec52585 = /*#__PURE__*/ function(WorkSuggestionsAction) {
    WorkSuggestionsAction["Remove"] = "REMOVE";
    WorkSuggestionsAction["Snooze"] = "SNOOZE";
    return WorkSuggestionsAction;
}({}); /** Input for the mutation operations (snooze and remove). */ 
let $5b8397cef71e8614$export$fcfd01bc876454f4 = /*#__PURE__*/ function(WorkSuggestionsApprovalStatus) {
    WorkSuggestionsApprovalStatus["Approved"] = "APPROVED";
    WorkSuggestionsApprovalStatus["Needswork"] = "NEEDSWORK";
    WorkSuggestionsApprovalStatus["Unapproved"] = "UNAPPROVED";
    WorkSuggestionsApprovalStatus["Unknown"] = "UNKNOWN";
    return WorkSuggestionsApprovalStatus;
}({});
let $5b8397cef71e8614$export$4dffae97a15618f = /*#__PURE__*/ function(WorkSuggestionsAutoDevJobState) {
    WorkSuggestionsAutoDevJobState["Cancelled"] = "CANCELLED";
    WorkSuggestionsAutoDevJobState["CodeGenerating"] = "CODE_GENERATING";
    WorkSuggestionsAutoDevJobState["CodeGenerationFail"] = "CODE_GENERATION_FAIL";
    WorkSuggestionsAutoDevJobState["CodeGenerationReady"] = "CODE_GENERATION_READY";
    WorkSuggestionsAutoDevJobState["CodeGenerationSuccess"] = "CODE_GENERATION_SUCCESS";
    WorkSuggestionsAutoDevJobState["Created"] = "CREATED";
    WorkSuggestionsAutoDevJobState["PlanGenerating"] = "PLAN_GENERATING";
    WorkSuggestionsAutoDevJobState["PlanGenerationFail"] = "PLAN_GENERATION_FAIL";
    WorkSuggestionsAutoDevJobState["PlanGenerationSuccess"] = "PLAN_GENERATION_SUCCESS";
    WorkSuggestionsAutoDevJobState["PullrequestCreating"] = "PULLREQUEST_CREATING";
    WorkSuggestionsAutoDevJobState["PullrequestCreationFail"] = "PULLREQUEST_CREATION_FAIL";
    WorkSuggestionsAutoDevJobState["PullrequestCreationSuccess"] = "PULLREQUEST_CREATION_SUCCESS";
    WorkSuggestionsAutoDevJobState["Unknown"] = "UNKNOWN";
    return WorkSuggestionsAutoDevJobState;
}({}); /** projectAri is always required, but sprintAri can also be specified */ 
let $5b8397cef71e8614$export$4f315a2279163c82 = /*#__PURE__*/ function(WorkSuggestionsEnvironmentType) {
    WorkSuggestionsEnvironmentType["Development"] = "DEVELOPMENT";
    WorkSuggestionsEnvironmentType["Production"] = "PRODUCTION";
    WorkSuggestionsEnvironmentType["Staging"] = "STAGING";
    WorkSuggestionsEnvironmentType["Testing"] = "TESTING";
    WorkSuggestionsEnvironmentType["Unmapped"] = "UNMAPPED";
    return WorkSuggestionsEnvironmentType;
}({}); /** An interface for all suggestion types supported by Periscope page */  /** Response for the recent pull requests suggestions */  /** Input for the mutation operations (save user profile). */ 
let $5b8397cef71e8614$export$bf7ed014c948227 = /*#__PURE__*/ function(WorkSuggestionsTargetAudience) {
    WorkSuggestionsTargetAudience["Me"] = "ME";
    WorkSuggestionsTargetAudience["Team"] = "TEAM";
    return WorkSuggestionsTargetAudience;
}({}); /** Action object stored in the database for the actions snooze/remove task. */  /**
 * Persona for the user profile.
 * For example: DEVELOPER
 */ 
let $5b8397cef71e8614$export$6d0f92f77f50b1c2 = /*#__PURE__*/ function(WorkSuggestionsUserPersona) {
    WorkSuggestionsUserPersona["Developer"] = "DEVELOPER";
    return WorkSuggestionsUserPersona;
}({}); /** User profile type for the user */ 
let $5b8397cef71e8614$export$88e2a9ce86b144d3 = /*#__PURE__*/ function(WorkSuggestionsVulnerabilityStatus) {
    WorkSuggestionsVulnerabilityStatus["Closed"] = "CLOSED";
    WorkSuggestionsVulnerabilityStatus["Ignored"] = "IGNORED";
    WorkSuggestionsVulnerabilityStatus["Open"] = "OPEN";
    WorkSuggestionsVulnerabilityStatus["Unknown"] = "UNKNOWN";
    return WorkSuggestionsVulnerabilityStatus;
}({}); /** An Applied Directive is an instances of a directive as applied to a schema element. This type is NOT specified by the graphql specification presently. */  /** Directive arguments can have names and values.  The values are in graphql SDL syntax printed as a string. This type is NOT specified by the graphql specification presently. */ 
let $5b8397cef71e8614$export$32baded4868555f5 = /*#__PURE__*/ function(SourceBillingType) {
    SourceBillingType["Ccp"] = "CCP";
    SourceBillingType["Hams"] = "HAMS";
    return SourceBillingType;
}({});

});



parcelRegister("9PBoU", function(module, exports) {

$parcel$export(module.exports, "transposeFilterOptions", () => $7285e381fb1fc0fa$export$a47f62012349939c);
$parcel$export(module.exports, "transposeFilterError", () => $7285e381fb1fc0fa$export$6d295fcd64dd56b2);

var $5zQU9 = parcelRequire("5zQU9");
function $7285e381fb1fc0fa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7285e381fb1fc0fa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7285e381fb1fc0fa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7285e381fb1fc0fa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $7285e381fb1fc0fa$export$a47f62012349939c = (filterOptions)=>$7285e381fb1fc0fa$var$_objectSpread($7285e381fb1fc0fa$var$_objectSpread({}, filterOptions), {}, {
        __typename: 'MarketplaceFilterOptions',
        options: filterOptions.options.map((option)=>$7285e381fb1fc0fa$var$_objectSpread($7285e381fb1fc0fa$var$_objectSpread({}, option), {}, {
                __typename: 'MarketplaceFilterOption',
                description: option.description || null
            }))
    });
const $7285e381fb1fc0fa$export$6d295fcd64dd56b2 = (filterError)=>$7285e381fb1fc0fa$var$_objectSpread($7285e381fb1fc0fa$var$_objectSpread({}, filterError), {}, {
        __typename: 'MarketplaceSearchFilterError'
    });

});


parcelRegister("5wwE8", function(module, exports) {

$parcel$export(module.exports, "SearchResultHandler", () => $405943c685de3f08$export$bb5b577370345838);

var $5zQU9 = parcelRequire("5zQU9");

var $kBH4t = parcelRequire("kBH4t");

var $4SnSg = parcelRequire("4SnSg");

var $jnsaq = parcelRequire("jnsaq");

var $6zrAO = parcelRequire("6zrAO");

var $5gt1S = parcelRequire("5gt1S");
class $405943c685de3f08$export$bb5b577370345838 extends (0, $4SnSg.BaseHandler) {
    constructor(algoliaConfig){
        super();
        (0, $5zQU9.default)(this, "algoliaConfig", void 0);
        this.algoliaConfig = algoliaConfig;
    }
    async fetchCustom(operation, _transformedOperation, _sequenceConfigValue, _primaryResponse) {
        const { query: query, filters: filters, sort: sort, after: after, first: first, additionalFilters: additionalFilters } = operation.variables;
        const { transformedAlgoliaIndex: transformedAlgoliaIndex, sortFilters: sortFilters } = (0, $6zrAO.resolveAlgoliaSortIndexAndFilters)(this.algoliaConfig.algoliaSearchIndex, sort, filters);
        const facetFilters = (0, $jnsaq.transformFilters)(filters, sortFilters, additionalFilters);
        const response = await (0, $kBH4t.AlgoliaSearch)({
            applicationId: this.algoliaConfig.algoliaAppId,
            apiKey: this.algoliaConfig.algoliaApiKey,
            indexName: transformedAlgoliaIndex,
            query: query,
            facetFilters: facetFilters,
            after: after,
            first: first
        });
        return response;
    }
    responseTransformer(operation, _transformedOperation, _sequenceConfigValue, _primaryResponse, customResponse) {
        const newResponse = {
            marketplaceSearch: customResponse ? (0, $5gt1S.transposeAppsConnection)({
                customResponse: customResponse,
                query: operation.variables.query
            }) : null
        };
        return newResponse;
    }
}

});


parcelRegister("et3oR", function(module, exports) {

$parcel$export(module.exports, "GetMarketplaceFilters", () => $a8866945c555cd73$export$a3abf44cbe4f70cd);


var $7ME9W = parcelRequire("7ME9W");
var $a8866945c555cd73$export$a3abf44cbe4f70cd = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetMarketplaceFilters"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filterIds"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "ListType",
                            type: {
                                kind: "NonNullType",
                                type: {
                                    kind: "NamedType",
                                    name: {
                                        kind: "Name",
                                        value: "FilterId"
                                    }
                                }
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceFilters"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filterIds"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filterIds"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                        kind: "NamedType",
                                        name: {
                                            kind: "Name",
                                            value: "MarketplaceFilterOptions"
                                        }
                                    },
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "filterId"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "options"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "label"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "id"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "value"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        },
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "description"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                        kind: "NamedType",
                                        name: {
                                            kind: "Name",
                                            value: "MarketplaceSearchFilterError"
                                        }
                                    },
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "filterId"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "message"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 328,
        source: {
            body: "query GetMarketplaceFilters($filterIds: [FilterId!]!) {\n  marketplaceFilters(filterIds: $filterIds) {\n    ... on MarketplaceFilterOptions {\n      filterId\n      options {\n        label\n        id\n        value\n        description\n      }\n    }\n\n    ... on MarketplaceSearchFilterError {\n      filterId\n      message\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};

});

parcelRegister("8RqyI", function(module, exports) {

$parcel$export(module.exports, "GetMarketplaceSearch", () => $6737e002794aad3b$export$b6fe595eaf5757b9);

var $5wwE8 = parcelRequire("5wwE8");
var $6737e002794aad3b$export$b6fe595eaf5757b9 = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetMarketplaceSearch"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "query"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "filters"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "FiltersInput"
                            }
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "sort"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "after"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "first"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Int"
                            }
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "additionalFilters"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "AdditionalFiltersInput"
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "enableNLPSearch"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "Boolean"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceSearch"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "query"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "query"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filters"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "filters"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "sort"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "sort"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "after"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "after"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "first"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "additionalFilters"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "additionalFilters"
                                    }
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "enableNLPSearch"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "enableNLPSearch"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppsConnection"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppsConnection"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AppsConnection"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "pageInfo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hasNextPage"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AppTile"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppTile"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "AppTile"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "addonId"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "addonKey"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "tagLine"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deployments"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "documentType"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketingLabels"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "tags"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "marketingLabels"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "logo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "highRes"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "image"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "releaseDate"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "ratings"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "avgStars"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "numRatings"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "distribution"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "activeInstalls"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "downloads"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "bundled"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "programs"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "cloudFortified"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "bugBountyParticipant"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "cloud"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "status"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "server"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "status"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "dataCenter"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "status"
                                                            },
                                                            arguments: [],
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "vendor"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "partnerTier"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "type"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "_highlightResult"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "value"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "matchLevel"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "tokenizedName"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "value"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "matchLevel"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "tagLine"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "value"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "matchLevel"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "tokenizedTagLine"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "value"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "matchLevel"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 462,
        source: {
            body: "#import \"./AppsFragment.view.graphql\"\nquery GetMarketplaceSearch(\n  $query: String!\n  $filters: FiltersInput!\n  $sort: String!\n  $after: Int!\n  $first: Int!\n  $additionalFilters: AdditionalFiltersInput\n  $enableNLPSearch: Boolean!\n) {\n  marketplaceSearch(\n    query: $query\n    filters: $filters\n    sort: $sort\n    after: $after\n    first: $first\n    additionalFilters: $additionalFilters\n    enableNLPSearch: $enableNLPSearch\n  ) {\n    ...AppsConnection\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};

});


parcelRegister("kwzYh", function(module, exports) {

$parcel$export(module.exports, "createApolloCache", () => $ef12b2f93c3d4adc$export$de0b6bef2c8595ce);

var $189aA = parcelRequire("189aA");

var $5mKRV = parcelRequire("5mKRV");

var $3jAGt = parcelRequire("3jAGt");

var $4cJK4 = parcelRequire("4cJK4");

var $eVoxO = parcelRequire("eVoxO");

var $jaY4q = parcelRequire("jaY4q");

var $egIIy = parcelRequire("egIIy");

var $lVYdZ = parcelRequire("lVYdZ");
const $ef12b2f93c3d4adc$export$de0b6bef2c8595ce = (initialState)=>{
    const cache = new (0, $189aA.InMemoryCache)({
        possibleTypes: (0, (/*@__PURE__*/$parcel$interopDefault($3jAGt))),
        typePolicies: {
            // Workaround for this apollo bug: https://github.com/apollographql/apollo-client/issues/7636
            // by disabling caching for this field (https://bit.ly/371l02H)
            CompatibleAtlassianProduct: {
                keyFields: false
            },
            MarketplaceStoreQueryApi: {
                keyFields: ()=>'marketplaceStore'
            },
            MarketplaceConsoleQueryApi: {
                keyFields: ()=>'marketplaceConsole'
            },
            Query: {
                fields: {
                    marketplaceStorePartner: {
                        keyArgs: [
                            'vendorId'
                        ],
                        merge: (0, $jaY4q.partnerProfileMergePolicy)
                    },
                    marketplaceSearch: {
                        keyArgs: [
                            'query',
                            'filters',
                            'sort'
                        ],
                        merge: (0, $egIIy.appSearchMergePolicy)
                    },
                    marketplaceCategory: {
                        keyArgs: [
                            'slug',
                            'filters',
                            'sort'
                        ],
                        merge: (0, $4cJK4.categoryMergePolicy)
                    },
                    marketplaceCollection: {
                        keyArgs: [
                            'slug',
                            'sort'
                        ],
                        merge: (0, $eVoxO.collectionMergePolicy)
                    },
                    marketplaceAppVersionHistory: {
                        /**
             * marketplaceAppVersionHistory query only accept "appId" as args, by default
             * the caching would be based on "appId" only, & we need to consider
             * filters within caching as well, which is part of the query variables
             */ keyArgs: (args, _ref)=>{
                            let { variables: variables } = _ref;
                            const { filters: filters } = variables;
                            const hostingFilter = (0, $lVYdZ.getHostingFilterValue)(filters);
                            if (!args) return false;
                            return (0, $lVYdZ.getVersionHistoryCacheKey)(args.appId, hostingFilter);
                        }
                    },
                    marketplaceHome: {
                        keyArgs: [
                            'productId',
                            'first',
                            'after'
                        ]
                    }
                }
            },
            MarketplaceVersionHistory: {
                fields: {
                    // Note: for relayStylePagination to work appropriately the args like 'after' etc.
                    // should be a part of this 'MarketplaceVersionHistory' type
                    // & NOT the top level parent 'marketplaceAppVersionHistory' schema type
                    // https://www.apollographql.com/docs/react/pagination/cursor-based/#relay-style-cursor-pagination
                    versions: (0, $5mKRV.relayStylePagination)()
                }
            }
        }
    });
    if (typeof initialState !== 'undefined') cache.restore(initialState);
    return cache;
};

});
parcelRegister("189aA", function(module, exports) {

$parcel$export(module.exports, "InMemoryCache", () => $0d2da6b850ac2144$export$467265324939f47f);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");


var $bDsPx = parcelRequire("bDsPx");

var $hr8gD = parcelRequire("hr8gD");

var $6OPmm = parcelRequire("6OPmm");

var $jANkB = parcelRequire("jANkB");

var $1CBce = parcelRequire("1CBce");
var $7MpZC = parcelRequire("7MpZC");
var $5bIMC = parcelRequire("5bIMC");
var $fzShn = parcelRequire("fzShn");
var $6dwmd = parcelRequire("6dwmd");
var $aaMYp = parcelRequire("aaMYp");

var $6KfMt = parcelRequire("6KfMt");

var $7D3jO = parcelRequire("7D3jO");

var $eDlCq = parcelRequire("eDlCq");

var $5alB9 = parcelRequire("5alB9");

var $9FSTq = parcelRequire("9FSTq");

var $eiege = parcelRequire("eiege");

var $7XZ8S = parcelRequire("7XZ8S");
var $0d2da6b850ac2144$export$467265324939f47f = /** @class */ function(_super) {
    (0, $fKE23.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.addTypenameTransform = new (0, $fzShn.DocumentTransform)((0, $1CBce.addTypenameToDocument));
        // Override the default value, since InMemoryCache result objects are frozen
        // in development and expected to remain logically immutable in production.
        _this.assumeImmutableResults = true;
        _this.makeVar = (0, $5alB9.makeVar);
        _this.txCount = 0;
        _this.config = (0, $eiege.normalizeConfig)(config);
        _this.addTypename = !!_this.config.addTypename;
        _this.policies = new (0, $9FSTq.Policies)({
            cache: _this,
            dataIdFromObject: _this.config.dataIdFromObject,
            possibleTypes: _this.config.possibleTypes,
            typePolicies: _this.config.typePolicies
        });
        _this.init();
        return _this;
    }
    InMemoryCache.prototype.init = function() {
        // Passing { resultCaching: false } in the InMemoryCache constructor options
        // will completely disable dependency tracking, which will improve memory
        // usage but worsen the performance of repeated reads.
        var rootStore = this.data = new (0, $eDlCq.EntityStore).Root({
            policies: this.policies,
            resultCaching: this.config.resultCaching
        });
        // When no optimistic writes are currently active, cache.optimisticData ===
        // cache.data, so there are no additional layers on top of the actual data.
        // When an optimistic update happens, this.optimisticData will become a
        // linked list of EntityStore Layer objects that terminates with the
        // original this.data cache object.
        this.optimisticData = rootStore.stump;
        this.resetResultCache();
    };
    InMemoryCache.prototype.resetResultCache = function(resetResultIdentities) {
        var _this = this;
        var previousReader = this.storeReader;
        var fragments = this.config.fragments;
        // The StoreWriter is mostly stateless and so doesn't really need to be
        // reset, but it does need to have its writer.storeReader reference updated,
        // so it's simpler to update this.storeWriter as well.
        this.storeWriter = new (0, $7D3jO.StoreWriter)(this, this.storeReader = new (0, $6KfMt.StoreReader)({
            cache: this,
            addTypename: this.addTypename,
            resultCacheMaxSize: this.config.resultCacheMaxSize,
            canonizeResults: (0, $eiege.shouldCanonizeResults)(this.config),
            canon: resetResultIdentities ? void 0 : previousReader && previousReader.canon,
            fragments: fragments
        }), fragments);
        this.maybeBroadcastWatch = (0, $bDsPx.wrap)(function(c, options) {
            return _this.broadcastWatch(c, options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $7MpZC.cacheSizes)["inMemoryCache.maybeBroadcastWatch"] || 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
            makeCacheKey: function(c) {
                // Return a cache key (thus enabling result caching) only if we're
                // currently using a data store that can track cache dependencies.
                var store = c.optimistic ? _this.optimisticData : _this.data;
                if ((0, $eDlCq.supportsResultCaching)(store)) {
                    var optimistic = c.optimistic, id = c.id, variables = c.variables;
                    return store.makeCacheKey(c.query, // Different watches can have the same query, optimistic
                    // status, rootId, and variables, but if their callbacks are
                    // different, the (identical) result needs to be delivered to
                    // each distinct callback. The easiest way to achieve that
                    // separation is to include c.callback in the cache key for
                    // maybeBroadcastWatch calls. See issue #5733.
                    c.callback, (0, $5bIMC.canonicalStringify)({
                        optimistic: optimistic,
                        id: id,
                        variables: variables
                    }));
                }
            }
        });
        // Since we have thrown away all the cached functions that depend on the
        // CacheGroup dependencies maintained by EntityStore, we should also reset
        // all CacheGroup dependency information.
        new Set([
            this.data.group,
            this.optimisticData.group
        ]).forEach(function(group) {
            return group.resetCaching();
        });
    };
    InMemoryCache.prototype.restore = function(data) {
        this.init();
        // Since calling this.init() discards/replaces the entire StoreReader, along
        // with the result caches it maintains, this.data.replace(data) won't have
        // to bother deleting the old data.
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).extract();
    };
    InMemoryCache.prototype.read = function(options) {
        var // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        _a = options.returnPartialData, // Since read returns data or null, without any additional metadata
        // about whether/where there might have been missing fields, the
        // default behavior cannot be returnPartialData = true (like it is
        // for the diff method), since defaulting to true would violate the
        // integrity of the T in the return type. However, partial data may
        // be useful in some cases, so returnPartialData:true may be
        // specified explicitly.
        returnPartialData = _a === void 0 ? false : _a;
        try {
            return this.storeReader.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                store: options.optimistic ? this.optimisticData : this.data,
                config: this.config,
                returnPartialData: returnPartialData
            })).result || null;
        } catch (e) {
            if (e instanceof (0, $jANkB.MissingFieldError)) // Swallow MissingFieldError and return null, so callers do not need to
            // worry about catching "normal" exceptions resulting from incomplete
            // cache data. Unexpected errors will be re-thrown. If you need more
            // information about which fields were missing, use cache.diff instead,
            // and examine diffResult.missing.
            return null;
            throw e;
        }
    };
    InMemoryCache.prototype.write = function(options) {
        try {
            ++this.txCount;
            return this.storeWriter.writeToStore(this.data, options);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.modify = function(options) {
        if ((0, $eiege.hasOwn).call(options, "id") && !options.id) // To my knowledge, TypeScript does not currently provide a way to
        // enforce that an optional property?:type must *not* be undefined
        // when present. That ability would be useful here, because we want
        // options.id to default to ROOT_QUERY only when no options.id was
        // provided. If the caller attempts to pass options.id with a
        // falsy/undefined value (perhaps because cache.identify failed), we
        // should not assume the goal was to modify the ROOT_QUERY object.
        // We could throw, but it seems natural to return false to indicate
        // that nothing was modified.
        return false;
        var store = options.optimistic // Defaults to false.
         ? this.optimisticData : this.data;
        try {
            ++this.txCount;
            return store.modify(options.id || "ROOT_QUERY", options.fields);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.diff = function(options) {
        return this.storeReader.diffQueryAgainstStore((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            store: options.optimistic ? this.optimisticData : this.data,
            rootId: options.id || "ROOT_QUERY",
            config: this.config
        }));
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        if (!this.watches.size) // In case we previously called forgetCache(this) because
        // this.watches became empty (see below), reattach this cache to any
        // reactive variables on which it previously depended. It might seem
        // paradoxical that we're able to recall something we supposedly
        // forgot, but the point of calling forgetCache(this) is to silence
        // useless broadcasts while this.watches is empty, and to allow the
        // cache to be garbage collected. If, however, we manage to call
        // recallCache(this) here, this cache object must not have been
        // garbage collected yet, and should resume receiving updates from
        // reactive variables, now that it has a watcher to notify.
        (0, $5alB9.recallCache)(this);
        this.watches.add(watch);
        if (watch.immediate) this.maybeBroadcastWatch(watch);
        return function() {
            // Once we remove the last watch from this.watches, cache.broadcastWatches
            // no longer does anything, so we preemptively tell the reactive variable
            // system to exclude this cache from future broadcasts.
            if (_this.watches.delete(watch) && !_this.watches.size) (0, $5alB9.forgetCache)(_this);
            // Remove this watch from the LRU cache managed by the
            // maybeBroadcastWatch OptimisticWrapperFunction, to prevent memory
            // leaks involving the closure of watch.callback.
            _this.maybeBroadcastWatch.forget(watch);
        };
    };
    InMemoryCache.prototype.gc = function(options) {
        var _a;
        (0, $5bIMC.canonicalStringify).reset();
        (0, $aaMYp.print).reset();
        this.addTypenameTransform.resetCache();
        (_a = this.config.fragments) === null || _a === void 0 || _a.resetCaches();
        var ids = this.optimisticData.gc();
        if (options && !this.txCount) {
            if (options.resetResultCache) this.resetResultCache(options.resetResultIdentities);
            else if (options.resetResultIdentities) this.storeReader.resetCanon();
        }
        return ids;
    };
    // Call this method to ensure the given root ID remains in the cache after
    // garbage collection, along with its transitive child entities. Note that
    // the cache automatically retains all directly written entities. By default,
    // the retainment persists after optimistic updates are removed. Pass true
    // for the optimistic argument if you would prefer for the retainment to be
    // discarded when the top-most optimistic layer is removed. Returns the
    // resulting (non-negative) retainment count.
    InMemoryCache.prototype.retain = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).retain(rootId);
    };
    // Call this method to undo the effect of the retain method, above. Once the
    // retainment count falls to zero, the given ID will no longer be preserved
    // during garbage collection, though it may still be preserved by other safe
    // entities that refer to it. Returns the resulting (non-negative) retainment
    // count, in case that's useful.
    InMemoryCache.prototype.release = function(rootId, optimistic) {
        return (optimistic ? this.optimisticData : this.data).release(rootId);
    };
    // Returns the canonical ID for a given StoreObject, obeying typePolicies
    // and keyFields (and dataIdFromObject, if you still use that). At minimum,
    // the object must contain a __typename and any primary key fields required
    // to identify entities of that type. If you pass a query result object, be
    // sure that none of the primary key fields have been renamed by aliasing.
    // If you pass a Reference object, its __ref ID string will be returned.
    InMemoryCache.prototype.identify = function(object) {
        if ((0, $6dwmd.isReference)(object)) return object.__ref;
        try {
            return this.policies.identify(object)[0];
        } catch (e) {
            globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).warn(e);
        }
    };
    InMemoryCache.prototype.evict = function(options) {
        if (!options.id) {
            if ((0, $eiege.hasOwn).call(options, "id")) // See comment in modify method about why we return false when
            // options.id exists but is falsy/undefined.
            return false;
            options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                id: "ROOT_QUERY"
            });
        }
        try {
            // It's unlikely that the eviction will end up invoking any other
            // cache update operations while it's running, but {in,de}crementing
            // this.txCount still seems like a good idea, for uniformity with
            // the other update methods.
            ++this.txCount;
            // Pass this.data as a limit on the depth of the eviction, so evictions
            // during optimistic updates (when this.data is temporarily set equal to
            // this.optimisticData) do not escape their optimistic Layer.
            return this.optimisticData.evict(options, this.data);
        } finally{
            if (!--this.txCount && options.broadcast !== false) this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.reset = function(options) {
        var _this = this;
        this.init();
        (0, $5bIMC.canonicalStringify).reset();
        if (options && options.discardWatches) {
            // Similar to what happens in the unsubscribe function returned by
            // cache.watch, applied to all current watches.
            this.watches.forEach(function(watch) {
                return _this.maybeBroadcastWatch.forget(watch);
            });
            this.watches.clear();
            (0, $5alB9.forgetCache)(this);
        } else // Calling this.init() above unblocks all maybeBroadcastWatch caching, so
        // this.broadcastWatches() triggers a broadcast to every current watcher
        // (letting them know their data is now missing). This default behavior is
        // convenient because it means the watches do not have to be manually
        // reestablished after resetting the cache. To prevent this broadcast and
        // cancel all watches, pass true for options.discardWatches.
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var newOptimisticData = this.optimisticData.removeLayer(idToRemove);
        if (newOptimisticData !== this.optimisticData) {
            this.optimisticData = newOptimisticData;
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.batch = function(options) {
        var _this = this;
        var update = options.update, _a = options.optimistic, optimistic = _a === void 0 ? true : _a, removeOptimistic = options.removeOptimistic, onWatchUpdated = options.onWatchUpdated;
        var updateResult;
        var perform = function(layer) {
            var _a = _this, data = _a.data, optimisticData = _a.optimisticData;
            ++_this.txCount;
            if (layer) _this.data = _this.optimisticData = layer;
            try {
                return updateResult = update(_this);
            } finally{
                --_this.txCount;
                _this.data = data;
                _this.optimisticData = optimisticData;
            }
        };
        var alreadyDirty = new Set();
        if (onWatchUpdated && !this.txCount) // If an options.onWatchUpdated callback is provided, we want to call it
        // with only the Cache.WatchOptions objects affected by options.update,
        // but there might be dirty watchers already waiting to be broadcast that
        // have nothing to do with the update. To prevent including those watchers
        // in the post-update broadcast, we perform this initial broadcast to
        // collect the dirty watchers, so we can re-dirty them later, after the
        // post-update broadcast, allowing them to receive their pending
        // broadcasts the next time broadcastWatches is called, just as they would
        // if we never called cache.batch.
        this.broadcastWatches((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            onWatchUpdated: function(watch) {
                alreadyDirty.add(watch);
                return false;
            }
        }));
        if (typeof optimistic === "string") // Note that there can be multiple layers with the same optimistic ID.
        // When removeOptimistic(id) is called for that id, all matching layers
        // will be removed, and the remaining layers will be reapplied.
        this.optimisticData = this.optimisticData.addLayer(optimistic, perform);
        else if (optimistic === false) // Ensure both this.data and this.optimisticData refer to the root
        // (non-optimistic) layer of the cache during the update. Note that
        // this.data could be a Layer if we are currently executing an optimistic
        // update function, but otherwise will always be an EntityStore.Root
        // instance.
        perform(this.data);
        else // Otherwise, leave this.data and this.optimisticData unchanged and run
        // the update with broadcast batching.
        perform();
        if (typeof removeOptimistic === "string") this.optimisticData = this.optimisticData.removeLayer(removeOptimistic);
        // Note: if this.txCount > 0, then alreadyDirty.size === 0, so this code
        // takes the else branch and calls this.broadcastWatches(options), which
        // does nothing when this.txCount > 0.
        if (onWatchUpdated && alreadyDirty.size) {
            this.broadcastWatches((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                onWatchUpdated: function(watch, diff) {
                    var result = onWatchUpdated.call(this, watch, diff);
                    if (result !== false) // Since onWatchUpdated did not return false, this diff is
                    // about to be broadcast to watch.callback, so we don't need
                    // to re-dirty it with the other alreadyDirty watches below.
                    alreadyDirty.delete(watch);
                    return result;
                }
            }));
            // Silently re-dirty any watches that were already dirty before the update
            // was performed, and were not broadcast just now.
            if (alreadyDirty.size) alreadyDirty.forEach(function(watch) {
                return _this.maybeBroadcastWatch.dirty(watch);
            });
        } else // If alreadyDirty is empty or we don't have an onWatchUpdated
        // function, we don't need to go to the trouble of wrapping
        // options.onWatchUpdated.
        this.broadcastWatches(options);
        return updateResult;
    };
    InMemoryCache.prototype.performTransaction = function(update, optimisticId) {
        return this.batch({
            update: update,
            optimistic: optimisticId || optimisticId !== null
        });
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        return this.addTypenameToDocument(this.addFragmentsToDocument(document));
    };
    InMemoryCache.prototype.broadcastWatches = function(options) {
        var _this = this;
        if (!this.txCount) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c, options);
        });
    };
    InMemoryCache.prototype.addFragmentsToDocument = function(document) {
        var fragments = this.config.fragments;
        return fragments ? fragments.transform(document) : document;
    };
    InMemoryCache.prototype.addTypenameToDocument = function(document) {
        if (this.addTypename) return this.addTypenameTransform.transformDocument(document);
        return document;
    };
    // This method is wrapped by maybeBroadcastWatch, which is called by
    // broadcastWatches, so that we compute and broadcast results only when
    // the data that would be broadcast might have changed. It would be
    // simpler to check for changes after recomputing a result but before
    // broadcasting it, but this wrapping approach allows us to skip both
    // the recomputation and the broadcast, in most cases.
    InMemoryCache.prototype.broadcastWatch = function(c, options) {
        var lastDiff = c.lastDiff;
        // Both WatchOptions and DiffOptions extend ReadOptions, and DiffOptions
        // currently requires no additional properties, so we can use c (a
        // WatchOptions object) as DiffOptions, without having to allocate a new
        // object, and without having to enumerate the relevant properties (query,
        // variables, etc.) explicitly. There will be some additional properties
        // (lastDiff, callback, etc.), but cache.diff ignores them.
        var diff = this.diff(c);
        if (options) {
            if (c.optimistic && typeof options.optimistic === "string") diff.fromOptimisticTransaction = true;
            if (options.onWatchUpdated && options.onWatchUpdated.call(this, c, diff, lastDiff) === false) // Returning false from the onWatchUpdated callback will prevent
            // calling c.callback(diff) for this watcher.
            return;
        }
        if (!lastDiff || !(0, $hr8gD.equal)(lastDiff.result, diff.result)) c.callback(c.lastDiff = diff, lastDiff);
    };
    return InMemoryCache;
}((0, $6OPmm.ApolloCache));
if (globalThis.__DEV__ !== false) $0d2da6b850ac2144$export$467265324939f47f.prototype.getMemoryInternals = (0, $7XZ8S.getInMemoryCacheMemoryInternals);

});
parcelRegister("bDsPx", function(module, exports) {

$parcel$export(module.exports, "wrap", () => $8789b3519f6707ef$export$4997ffc0176396a6);
$parcel$export(module.exports, "Slot", () => (parcelRequire("bE236")).Slot);
$parcel$export(module.exports, "dep", () => (parcelRequire("aFBFG")).dep);

var $jXc9l = parcelRequire("jXc9l");

var $16Gah = parcelRequire("16Gah");

var $8Xrfl = parcelRequire("8Xrfl");

var $5vbCU = parcelRequire("5vbCU");
var $bE236 = parcelRequire("bE236");

var $aFBFG = parcelRequire("aFBFG");
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
let $8789b3519f6707ef$var$defaultKeyTrie;
function $8789b3519f6707ef$export$cd3144f8dd136006(...args) {
    const trie = $8789b3519f6707ef$var$defaultKeyTrie || ($8789b3519f6707ef$var$defaultKeyTrie = new (0, $jXc9l.Trie)(typeof WeakMap === "function"));
    return trie.lookupArray(args);
}
const $8789b3519f6707ef$var$caches = new Set();
function $8789b3519f6707ef$export$4997ffc0176396a6(originalFunction, { max: max = Math.pow(2, 16), keyArgs: keyArgs, makeCacheKey: makeCacheKey = $8789b3519f6707ef$export$cd3144f8dd136006, normalizeResult: normalizeResult, subscribe: subscribe, cache: cacheOption = (0, $16Gah.StrongCache) } = Object.create(null)) {
    const cache = typeof cacheOption === "function" ? new cacheOption(max, (entry)=>entry.dispose()) : cacheOption;
    const optimistic = function() {
        const key = makeCacheKey.apply(null, keyArgs ? keyArgs.apply(null, arguments) : arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        let entry = cache.get(key);
        if (!entry) {
            cache.set(key, entry = new (0, $8Xrfl.Entry)(originalFunction));
            entry.normalizeResult = normalizeResult;
            entry.subscribe = subscribe;
            // Give the Entry the ability to trigger cache.delete(key), even though
            // the Entry itself does not know about key or cache.
            entry.forget = ()=>cache.delete(key);
        }
        const value = entry.recompute(Array.prototype.slice.call(arguments));
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $8789b3519f6707ef$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!(0, $5vbCU.parentEntrySlot).hasValue()) {
            $8789b3519f6707ef$var$caches.forEach((cache)=>cache.clean());
            $8789b3519f6707ef$var$caches.clear();
        }
        return value;
    };
    Object.defineProperty(optimistic, "size", {
        get: ()=>cache.size,
        configurable: false,
        enumerable: false
    });
    Object.freeze(optimistic.options = {
        max: max,
        keyArgs: keyArgs,
        makeCacheKey: makeCacheKey,
        normalizeResult: normalizeResult,
        subscribe: subscribe,
        cache: cache
    });
    function dirtyKey(key) {
        const entry = key && cache.get(key);
        if (entry) entry.setDirty();
    }
    optimistic.dirtyKey = dirtyKey;
    optimistic.dirty = function dirty() {
        dirtyKey(makeCacheKey.apply(null, arguments));
    };
    function peekKey(key) {
        const entry = key && cache.get(key);
        if (entry) return entry.peek();
    }
    optimistic.peekKey = peekKey;
    optimistic.peek = function peek() {
        return peekKey(makeCacheKey.apply(null, arguments));
    };
    function forgetKey(key) {
        return key ? cache.delete(key) : false;
    }
    optimistic.forgetKey = forgetKey;
    optimistic.forget = function forget() {
        return forgetKey(makeCacheKey.apply(null, arguments));
    };
    optimistic.makeCacheKey = makeCacheKey;
    optimistic.getKey = keyArgs ? function getKey() {
        return makeCacheKey.apply(null, keyArgs.apply(null, arguments));
    } : makeCacheKey;
    return Object.freeze(optimistic);
}

});
parcelRegister("jXc9l", function(module, exports) {

$parcel$export(module.exports, "Trie", () => $e86cf3acccac8cc7$export$73571c50d0f2507e);
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $e86cf3acccac8cc7$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $e86cf3acccac8cc7$var$forEach, slice: $e86cf3acccac8cc7$var$slice } = Array.prototype;
const { hasOwnProperty: $e86cf3acccac8cc7$var$hasOwnProperty } = Object.prototype;
class $e86cf3acccac8cc7$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $e86cf3acccac8cc7$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup(...array) {
        return this.lookupArray(array);
    }
    lookupArray(array) {
        let node = this;
        $e86cf3acccac8cc7$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $e86cf3acccac8cc7$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($e86cf3acccac8cc7$var$slice.call(array));
    }
    peek(...array) {
        return this.peekArray(array);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = this.weakness && $e86cf3acccac8cc7$var$isObjRef(array[i]) ? node.weak : node.strong;
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    getChildTrie(key) {
        const map = this.weakness && $e86cf3acccac8cc7$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        let child = map.get(key);
        if (!child) map.set(key, child = new $e86cf3acccac8cc7$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
}
function $e86cf3acccac8cc7$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

});

parcelRegister("8Xrfl", function(module, exports) {

$parcel$export(module.exports, "Entry", () => $6858f80306105528$export$3bb977b3ba9d3b59);

var $5vbCU = parcelRequire("5vbCU");

var $hfsk6 = parcelRequire("hfsk6");
const $6858f80306105528$var$emptySetPool = [];
const $6858f80306105528$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $6858f80306105528$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $6858f80306105528$var$valueIs(a, b) {
    const len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $6858f80306105528$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $6858f80306105528$var$valueCopy(value) {
    return value.slice(0);
}
class $6858f80306105528$export$3bb977b3ba9d3b59 {
    constructor(fn){
        this.fn = fn;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        this.deps = null;
        ++$6858f80306105528$export$3bb977b3ba9d3b59.count;
    }
    peek() {
        if (this.value.length === 1 && !$6858f80306105528$var$mightBeDirty(this)) {
            $6858f80306105528$var$rememberParent(this);
            return this.value[0];
        }
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    recompute(args) {
        $6858f80306105528$var$assert(!this.recomputing, "already recomputing");
        $6858f80306105528$var$rememberParent(this);
        return $6858f80306105528$var$mightBeDirty(this) ? $6858f80306105528$var$reallyRecompute(this, args) : $6858f80306105528$var$valueGet(this.value);
    }
    setDirty() {
        if (this.dirty) return;
        this.dirty = true;
        $6858f80306105528$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        (0, $hfsk6.maybeUnsubscribe)(this);
    }
    dispose() {
        this.setDirty();
        // Sever any dependency relationships with our own children, so those
        // children don't retain this parent Entry in their child.parents sets,
        // thereby preventing it from being fully garbage collected.
        $6858f80306105528$var$forgetChildren(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        $6858f80306105528$var$eachParent(this, (parent, child)=>{
            parent.setDirty();
            $6858f80306105528$var$forgetChild(parent, this);
        });
    }
    forget() {
        // The code that creates Entry objects in index.ts will replace this method
        // with one that actually removes the Entry from the cache, which will also
        // trigger the entry.dispose method.
        this.dispose();
    }
    dependOn(dep) {
        dep.add(this);
        if (!this.deps) this.deps = $6858f80306105528$var$emptySetPool.pop() || new Set();
        this.deps.add(dep);
    }
    forgetDeps() {
        if (this.deps) {
            (0, $hfsk6.arrayFromSet)(this.deps).forEach((dep)=>dep.delete(this));
            this.deps.clear();
            $6858f80306105528$var$emptySetPool.push(this.deps);
            this.deps = null;
        }
    }
}
$6858f80306105528$export$3bb977b3ba9d3b59.count = 0;
function $6858f80306105528$var$rememberParent(child) {
    const parent = (0, $5vbCU.parentEntrySlot).getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($6858f80306105528$var$mightBeDirty(child)) $6858f80306105528$var$reportDirtyChild(parent, child);
        else $6858f80306105528$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $6858f80306105528$var$reallyRecompute(entry, args) {
    $6858f80306105528$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    (0, $5vbCU.parentEntrySlot).withValue(entry, $6858f80306105528$var$recomputeNewValue, [
        entry,
        args
    ]);
    if ($6858f80306105528$var$maybeSubscribe(entry, args)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $6858f80306105528$var$setClean(entry);
    return $6858f80306105528$var$valueGet(entry.value);
}
function $6858f80306105528$var$recomputeNewValue(entry, args) {
    entry.recomputing = true;
    const { normalizeResult: normalizeResult } = entry;
    let oldValueCopy;
    if (normalizeResult && entry.value.length === 1) oldValueCopy = $6858f80306105528$var$valueCopy(entry.value);
    // Make entry.value an empty array, representing an unknown value.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, args);
        // If we have a viable oldValueCopy to compare with the (successfully
        // recomputed) new entry.value, and they are not already === identical, give
        // normalizeResult a chance to pick/choose/reuse parts of oldValueCopy[0]
        // and/or entry.value[0] to determine the final cached entry.value.
        if (normalizeResult && oldValueCopy && !$6858f80306105528$var$valueIs(oldValueCopy, entry.value)) try {
            entry.value[0] = normalizeResult(entry.value[0], oldValueCopy[0]);
        } catch (_a) {
        // If normalizeResult throws, just use the newer value, rather than
        // saving the exception as entry.value[1].
        }
    } catch (e) {
        // If entry.fn throws, entry.value will hold that exception.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $6858f80306105528$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $6858f80306105528$var$setClean(entry) {
    entry.dirty = false;
    if ($6858f80306105528$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $6858f80306105528$var$reportClean(entry);
}
function $6858f80306105528$var$reportDirty(child) {
    $6858f80306105528$var$eachParent(child, $6858f80306105528$var$reportDirtyChild);
}
function $6858f80306105528$var$reportClean(child) {
    $6858f80306105528$var$eachParent(child, $6858f80306105528$var$reportCleanChild);
}
function $6858f80306105528$var$eachParent(child, callback) {
    const parentCount = child.parents.size;
    if (parentCount) {
        const parents = (0, $hfsk6.arrayFromSet)(child.parents);
        for(let i = 0; i < parentCount; ++i)callback(parents[i], child);
    }
}
// Let a parent Entry know that one of its children may be dirty.
function $6858f80306105528$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $6858f80306105528$var$assert(parent.childValues.has(child));
    $6858f80306105528$var$assert($6858f80306105528$var$mightBeDirty(child));
    const parentWasClean = !$6858f80306105528$var$mightBeDirty(parent);
    if (!parent.dirtyChildren) parent.dirtyChildren = $6858f80306105528$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    // If parent was clean before, it just became (possibly) dirty (according to
    // mightBeDirty), since we just added child to parent.dirtyChildren.
    if (parentWasClean) $6858f80306105528$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $6858f80306105528$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $6858f80306105528$var$assert(parent.childValues.has(child));
    $6858f80306105528$var$assert(!$6858f80306105528$var$mightBeDirty(child));
    const childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $6858f80306105528$var$valueCopy(child.value));
    else if (!$6858f80306105528$var$valueIs(childValue, child.value)) parent.setDirty();
    $6858f80306105528$var$removeDirtyChild(parent, child);
    if ($6858f80306105528$var$mightBeDirty(parent)) return;
    $6858f80306105528$var$reportClean(parent);
}
function $6858f80306105528$var$removeDirtyChild(parent, child) {
    const dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($6858f80306105528$var$emptySetPool.length < $6858f80306105528$var$POOL_TARGET_SIZE) $6858f80306105528$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// Removes all children from this entry and returns an array of the
// removed children.
function $6858f80306105528$var$forgetChildren(parent) {
    if (parent.childValues.size > 0) parent.childValues.forEach((_value, child)=>{
        $6858f80306105528$var$forgetChild(parent, child);
    });
    // Remove this parent Entry from any sets to which it was added by the
    // addToSet method.
    parent.forgetDeps();
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $6858f80306105528$var$assert(parent.dirtyChildren === null);
}
function $6858f80306105528$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $6858f80306105528$var$removeDirtyChild(parent, child);
}
function $6858f80306105528$var$maybeSubscribe(entry, args) {
    if (typeof entry.subscribe === "function") try {
        (0, $hfsk6.maybeUnsubscribe)(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}

});
parcelRegister("5vbCU", function(module, exports) {

$parcel$export(module.exports, "parentEntrySlot", () => $4018ddcb4b7b26c5$export$11fa9682b6ba79b1);
$parcel$export(module.exports, "Slot", () => (parcelRequire("bE236")).Slot);
parcelRequire("4PqAg");
var $bE236 = parcelRequire("bE236");
const $4018ddcb4b7b26c5$export$11fa9682b6ba79b1 = new (0, $bE236.Slot)();
function $4018ddcb4b7b26c5$export$d906efd39458576(fn) {
    return $4018ddcb4b7b26c5$export$11fa9682b6ba79b1.withValue(void 0, fn);
}

});
parcelRegister("4PqAg", function(module, exports) {

$parcel$export(module.exports, "Slot", () => (parcelRequire("bE236")).Slot);

var $bE236 = parcelRequire("bE236");
const { bind: $38408bdf3696b968$export$2385a24977818dd0, noContext: $38408bdf3696b968$export$9fa6f2e300a97f8 } = (0, $bE236.Slot);
function $38408bdf3696b968$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($38408bdf3696b968$export$2385a24977818dd0(callback), delay);
}
function $38408bdf3696b968$export$d5d7536e965c82da(genFn) {
    return function() {
        const gen = genFn.apply(this, arguments);
        const boundNext = $38408bdf3696b968$export$2385a24977818dd0(gen.next);
        const boundThrow = $38408bdf3696b968$export$2385a24977818dd0(gen.throw);
        return new Promise((resolve, reject)=>{
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                const next = result.done ? resolve : invokeNext;
                if ($38408bdf3696b968$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            const invokeNext = (value)=>invoke(boundNext, value);
            const invokeThrow = (error)=>invoke(boundThrow, error);
            invokeNext();
        });
    };
}
function $38408bdf3696b968$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
const $38408bdf3696b968$var$wrappedFibers = [];
function $38408bdf3696b968$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($38408bdf3696b968$var$wrappedFibers.indexOf(Fiber) < 0) {
        const wrap = (obj, method)=>{
            const fn = obj[method];
            obj[method] = function() {
                return $38408bdf3696b968$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $38408bdf3696b968$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});
parcelRegister("bE236", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $87a5050e42059e89$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
let $87a5050e42059e89$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
const $87a5050e42059e89$var$MISSING_VALUE = {};
let $87a5050e42059e89$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
const $87a5050e42059e89$var$makeSlotClass = ()=>class Slot {
        constructor(){
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $87a5050e42059e89$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        hasValue() {
            for(let context = $87a5050e42059e89$var$currentContext; context; context = context.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context.slots) {
                const value = context.slots[this.id];
                if (value === $87a5050e42059e89$var$MISSING_VALUE) break;
                if (context !== $87a5050e42059e89$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $87a5050e42059e89$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($87a5050e42059e89$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $87a5050e42059e89$var$currentContext.slots[this.id] = $87a5050e42059e89$var$MISSING_VALUE;
            return false;
        }
        getValue() {
            if (this.hasValue()) return $87a5050e42059e89$var$currentContext.slots[this.id];
        }
        withValue(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            const slots = {
                __proto__: null,
                [this.id]: value
            };
            const parent = $87a5050e42059e89$var$currentContext;
            $87a5050e42059e89$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $87a5050e42059e89$var$currentContext = parent;
            }
        }
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        static bind(callback) {
            const context = $87a5050e42059e89$var$currentContext;
            return function() {
                const saved = $87a5050e42059e89$var$currentContext;
                try {
                    $87a5050e42059e89$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $87a5050e42059e89$var$currentContext = saved;
                }
            };
        }
        // Immediately run a callback function without any captured context.
        static noContext(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($87a5050e42059e89$var$currentContext) {
                const saved = $87a5050e42059e89$var$currentContext;
                try {
                    $87a5050e42059e89$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $87a5050e42059e89$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        }
    };
function $87a5050e42059e89$var$maybe(fn) {
    try {
        return fn();
    } catch (ignored) {}
}
// We store a single global implementation of the Slot class as a permanent
// non-enumerable property of the globalThis object. This obfuscation does
// nothing to prevent access to the Slot class, but at least it ensures the
// implementation (i.e. currentContext) cannot be tampered with, and all copies
// of the @wry/context package (hopefully just one) will share the same Slot
// implementation. Since the first copy of the @wry/context package to be
// imported wins, this technique imposes a steep cost for any future breaking
// changes to the Slot class.
const $87a5050e42059e89$var$globalKey = "@wry/context:Slot";
const $87a5050e42059e89$var$host = // Prefer globalThis when available.
// https://github.com/benjamn/wryware/issues/347
$87a5050e42059e89$var$maybe(()=>globalThis) || // Fall back to global, which works in Node.js and may be converted by some
// bundlers to the appropriate identifier (window, self, ...) depending on the
// bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
$87a5050e42059e89$var$maybe(()=>$parcel$global) || // Otherwise, use a dummy host that's local to this module. We used to fall
// back to using the Array constructor as a namespace, but that was flagged in
// https://github.com/benjamn/wryware/issues/347, and can be avoided.
Object.create(null);
// Whichever globalHost we're using, make TypeScript happy about the additional
// globalKey property.
const $87a5050e42059e89$var$globalHost = $87a5050e42059e89$var$host;
const $87a5050e42059e89$export$8c6ed5c666ac1360 = $87a5050e42059e89$var$globalHost[$87a5050e42059e89$var$globalKey] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[$87a5050e42059e89$var$globalKey] || function(Slot) {
    try {
        Object.defineProperty($87a5050e42059e89$var$globalHost, $87a5050e42059e89$var$globalKey, {
            value: Slot,
            enumerable: false,
            writable: false,
            // When it was possible for globalHost to be the Array constructor (a
            // legacy Slot dedup strategy), it was important for the property to be
            // configurable:true so it could be deleted. That does not seem to be as
            // important when globalHost is the global object, but I don't want to
            // cause similar problems again, and configurable:true seems safest.
            // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
            configurable: true
        });
    } finally{
        return Slot;
    }
}($87a5050e42059e89$var$makeSlotClass());

});



parcelRegister("hfsk6", function(module, exports) {

$parcel$export(module.exports, "hasOwnProperty", () => $c8e9cec48f801c24$export$5a15a386532a5ea4);
$parcel$export(module.exports, "arrayFromSet", () => $c8e9cec48f801c24$export$1eb72f2488cedd93);
$parcel$export(module.exports, "maybeUnsubscribe", () => $c8e9cec48f801c24$export$50527b97338c0f71);
const { hasOwnProperty: $c8e9cec48f801c24$export$5a15a386532a5ea4 } = Object.prototype;
const $c8e9cec48f801c24$export$1eb72f2488cedd93 = Array.from || function(set) {
    const array = [];
    set.forEach((item)=>array.push(item));
    return array;
};
function $c8e9cec48f801c24$export$50527b97338c0f71(entryOrDep) {
    const { unsubscribe: unsubscribe } = entryOrDep;
    if (typeof unsubscribe === "function") {
        entryOrDep.unsubscribe = void 0;
        unsubscribe();
    }
}

});


parcelRegister("aFBFG", function(module, exports) {

$parcel$export(module.exports, "dep", () => $7c4af472b3cd119f$export$c723b7eff9d8f870);

var $5vbCU = parcelRequire("5vbCU");

var $hfsk6 = parcelRequire("hfsk6");
const $7c4af472b3cd119f$var$EntryMethods = {
    setDirty: true,
    dispose: true,
    forget: true
};
function $7c4af472b3cd119f$export$c723b7eff9d8f870(options) {
    const depsByKey = new Map();
    const subscribe = options && options.subscribe;
    function depend(key) {
        const parent = (0, $5vbCU.parentEntrySlot).getValue();
        if (parent) {
            let dep = depsByKey.get(key);
            if (!dep) depsByKey.set(key, dep = new Set);
            parent.dependOn(dep);
            if (typeof subscribe === "function") {
                (0, $hfsk6.maybeUnsubscribe)(dep);
                dep.unsubscribe = subscribe(key);
            }
        }
    }
    depend.dirty = function dirty(key, entryMethodName) {
        const dep = depsByKey.get(key);
        if (dep) {
            const m = entryMethodName && (0, $hfsk6.hasOwnProperty).call($7c4af472b3cd119f$var$EntryMethods, entryMethodName) ? entryMethodName : "setDirty";
            // We have to use arrayFromSet(dep).forEach instead of dep.forEach,
            // because modifying a Set while iterating over it can cause elements in
            // the Set to be removed from the Set before they've been iterated over.
            (0, $hfsk6.arrayFromSet)(dep).forEach((entry)=>entry[m]());
            depsByKey.delete(key);
            (0, $hfsk6.maybeUnsubscribe)(dep);
        }
    };
    return depend;
}

});


parcelRegister("hr8gD", function(module, exports) {

$parcel$export(module.exports, "equal", () => $cb1b5efb8d28e7f9$export$411ce8e5a71e3069);
$parcel$export(module.exports, "default", () => $cb1b5efb8d28e7f9$export$2e2bcd8739ae039);
const { toString: $cb1b5efb8d28e7f9$var$toString, hasOwnProperty: $cb1b5efb8d28e7f9$var$hasOwnProperty } = Object.prototype;
const $cb1b5efb8d28e7f9$var$fnToStr = Function.prototype.toString;
const $cb1b5efb8d28e7f9$var$previousComparisons = new Map();
function $cb1b5efb8d28e7f9$export$411ce8e5a71e3069(a, b) {
    try {
        return $cb1b5efb8d28e7f9$var$check(a, b);
    } finally{
        $cb1b5efb8d28e7f9$var$previousComparisons.clear();
    }
}
var // Allow default imports as well.
$cb1b5efb8d28e7f9$export$2e2bcd8739ae039 = $cb1b5efb8d28e7f9$export$411ce8e5a71e3069;
function $cb1b5efb8d28e7f9$var$check(a, b) {
    // If the two values are strictly equal, our job is easy.
    if (a === b) return true;
    // Object.prototype.toString returns a representation of the runtime type of
    // the given value that is considerably more precise than typeof.
    const aTag = $cb1b5efb8d28e7f9$var$toString.call(a);
    const bTag = $cb1b5efb8d28e7f9$var$toString.call(b);
    // If the runtime types of a and b are different, they could maybe be equal
    // under some interpretation of equality, but for simplicity and performance
    // we just return false instead.
    if (aTag !== bTag) return false;
    switch(aTag){
        case '[object Array]':
            // Arrays are a lot like other objects, but we can cheaply compare their
            // lengths as a short-cut before comparing their elements.
            if (a.length !== b.length) return false;
        // Fall through to object case...
        case '[object Object]':
            {
                if ($cb1b5efb8d28e7f9$var$previouslyCompared(a, b)) return true;
                const aKeys = $cb1b5efb8d28e7f9$var$definedKeys(a);
                const bKeys = $cb1b5efb8d28e7f9$var$definedKeys(b);
                // If `a` and `b` have a different number of enumerable keys, they
                // must be different.
                const keyCount = aKeys.length;
                if (keyCount !== bKeys.length) return false;
                // Now make sure they have the same keys.
                for(let k = 0; k < keyCount; ++k){
                    if (!$cb1b5efb8d28e7f9$var$hasOwnProperty.call(b, aKeys[k])) return false;
                }
                // Finally, check deep equality of all child properties.
                for(let k = 0; k < keyCount; ++k){
                    const key = aKeys[k];
                    if (!$cb1b5efb8d28e7f9$var$check(a[key], b[key])) return false;
                }
                return true;
            }
        case '[object Error]':
            return a.name === b.name && a.message === b.message;
        case '[object Number]':
            // Handle NaN, which is !== itself.
            if (a !== a) return b !== b;
        // Fall through to shared +a === +b case...
        case '[object Boolean]':
        case '[object Date]':
            return +a === +b;
        case '[object RegExp]':
        case '[object String]':
            return a == `${b}`;
        case '[object Map]':
        case '[object Set]':
            {
                if (a.size !== b.size) return false;
                if ($cb1b5efb8d28e7f9$var$previouslyCompared(a, b)) return true;
                const aIterator = a.entries();
                const isMap = aTag === '[object Map]';
                while(true){
                    const info = aIterator.next();
                    if (info.done) break;
                    // If a instanceof Set, aValue === aKey.
                    const [aKey, aValue] = info.value;
                    // So this works the same way for both Set and Map.
                    if (!b.has(aKey)) return false;
                    // However, we care about deep equality of values only when dealing
                    // with Map structures.
                    if (isMap && !$cb1b5efb8d28e7f9$var$check(aValue, b.get(aKey))) return false;
                }
                return true;
            }
        case '[object Uint16Array]':
        case '[object Uint8Array]':
        case '[object Uint32Array]':
        case '[object Int32Array]':
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object ArrayBuffer]':
            // DataView doesn't need these conversions, but the equality check is
            // otherwise the same.
            a = new Uint8Array(a);
            b = new Uint8Array(b);
        // Fall through...
        case '[object DataView]':
            {
                let len = a.byteLength;
                if (len === b.byteLength) {
                    while(len-- && a[len] === b[len]);
                }
                return len === -1;
            }
        case '[object AsyncFunction]':
        case '[object GeneratorFunction]':
        case '[object AsyncGeneratorFunction]':
        case '[object Function]':
            {
                const aCode = $cb1b5efb8d28e7f9$var$fnToStr.call(a);
                if (aCode !== $cb1b5efb8d28e7f9$var$fnToStr.call(b)) return false;
                // We consider non-native functions equal if they have the same code
                // (native functions require === because their code is censored).
                // Note that this behavior is not entirely sound, since !== function
                // objects with the same code can behave differently depending on
                // their closure scope. However, any function can behave differently
                // depending on the values of its input arguments (including this)
                // and its calling context (including its closure scope), even
                // though the function object is === to itself; and it is entirely
                // possible for functions that are not === to behave exactly the
                // same under all conceivable circumstances. Because none of these
                // factors are statically decidable in JavaScript, JS function
                // equality is not well-defined. This ambiguity allows us to
                // consider the best possible heuristic among various imperfect
                // options, and equating non-native functions that have the same
                // code has enormous practical benefits, such as when comparing
                // functions that are repeatedly passed as fresh function
                // expressions within objects that are otherwise deeply equal. Since
                // any function created from the same syntactic expression (in the
                // same code location) will always stringify to the same code
                // according to fnToStr.call, we can reasonably expect these
                // repeatedly passed function expressions to have the same code, and
                // thus behave "the same" (with all the caveats mentioned above),
                // even though the runtime function objects are !== to one another.
                return !$cb1b5efb8d28e7f9$var$endsWith(aCode, $cb1b5efb8d28e7f9$var$nativeCodeSuffix);
            }
    }
    // Otherwise the values are not equal.
    return false;
}
function $cb1b5efb8d28e7f9$var$definedKeys(obj) {
    // Remember that the second argument to Array.prototype.filter will be
    // used as `this` within the callback function.
    return Object.keys(obj).filter($cb1b5efb8d28e7f9$var$isDefinedKey, obj);
}
function $cb1b5efb8d28e7f9$var$isDefinedKey(key) {
    return this[key] !== void 0;
}
const $cb1b5efb8d28e7f9$var$nativeCodeSuffix = "{ [native code] }";
function $cb1b5efb8d28e7f9$var$endsWith(full, suffix) {
    const fromIndex = full.length - suffix.length;
    return fromIndex >= 0 && full.indexOf(suffix, fromIndex) === fromIndex;
}
function $cb1b5efb8d28e7f9$var$previouslyCompared(a, b) {
    // Though cyclic references can make an object graph appear infinite from the
    // perspective of a depth-first traversal, the graph still contains a finite
    // number of distinct object references. We use the previousComparisons cache
    // to avoid comparing the same pair of object references more than once, which
    // guarantees termination (even if we end up comparing every object in one
    // graph to every object in the other graph, which is extremely unlikely),
    // while still allowing weird isomorphic structures (like rings with different
    // lengths) a chance to pass the equality test.
    let bSet = $cb1b5efb8d28e7f9$var$previousComparisons.get(a);
    if (bSet) {
        // Return true here because we can be sure false will be returned somewhere
        // else if the objects are not equivalent.
        if (bSet.has(b)) return true;
    } else $cb1b5efb8d28e7f9$var$previousComparisons.set(a, bSet = new Set);
    bSet.add(b);
    return false;
}

});

parcelRegister("6OPmm", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $4f6f40867ada8d0c$export$5fc74f25506aa9c);

var $fKE23 = parcelRequire("fKE23");

var $bDsPx = parcelRequire("bDsPx");

var $7MpZC = parcelRequire("7MpZC");
var $iB2lh = parcelRequire("iB2lh");

var $kIv0I = parcelRequire("kIv0I");

var $7XZ8S = parcelRequire("7XZ8S");
var $4f6f40867ada8d0c$export$5fc74f25506aa9c = /** @class */ function() {
    function ApolloCache() {
        this.assumeImmutableResults = false;
        // Make sure we compute the same (===) fragment query document every
        // time we receive the same fragment in readFragment.
        this.getFragmentDoc = (0, $bDsPx.wrap)((0, $iB2lh.getFragmentQueryDocument), {
            max: (0, $7MpZC.cacheSizes)["cache.fragmentQueryDocuments"] || 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
            cache: (0, $kIv0I.WeakCache)
        });
    }
    // Transactional API
    // The batch method is intended to replace/subsume both performTransaction
    // and recordOptimisticTransaction, but performTransaction came first, so we
    // provide a default batch implementation that's just another way of calling
    // performTransaction. Subclasses of ApolloCache (such as InMemoryCache) can
    // override the batch method to do more interesting things with its options.
    ApolloCache.prototype.batch = function(options) {
        var _this = this;
        var optimisticId = typeof options.optimistic === "string" ? options.optimistic : options.optimistic === false ? null : void 0;
        var updateResult;
        this.performTransaction(function() {
            return updateResult = options.update(_this);
        }, optimisticId);
        return updateResult;
    };
    ApolloCache.prototype.recordOptimisticTransaction = function(transaction, optimisticId) {
        this.performTransaction(transaction, optimisticId);
    };
    // Optional API
    // Called once per input document, allowing the cache to make static changes
    // to the query, such as adding __typename fields.
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    // Called before each ApolloLink request, allowing the cache to make dynamic
    // changes to the query, such as filling in missing fragment definitions.
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.identify = function(object) {
        return;
    };
    ApolloCache.prototype.gc = function() {
        return [];
    };
    ApolloCache.prototype.modify = function(options) {
        return false;
    };
    // DataProxy API
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            rootId: options.id || "ROOT_QUERY",
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = !!options.optimistic;
        return this.read((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            query: this.getFragmentDoc(options.fragment, options.fragmentName),
            rootId: options.id,
            optimistic: optimistic
        }));
    };
    ApolloCache.prototype.writeQuery = function(_a) {
        var id = _a.id, data = _a.data, options = (0, $fKE23.__rest)(_a, [
            "id",
            "data"
        ]);
        return this.write(Object.assign(options, {
            dataId: id || "ROOT_QUERY",
            result: data
        }));
    };
    ApolloCache.prototype.writeFragment = function(_a) {
        var id = _a.id, data = _a.data, fragment = _a.fragment, fragmentName = _a.fragmentName, options = (0, $fKE23.__rest)(_a, [
            "id",
            "data",
            "fragment",
            "fragmentName"
        ]);
        return this.write(Object.assign(options, {
            query: this.getFragmentDoc(fragment, fragmentName),
            dataId: id,
            result: data
        }));
    };
    ApolloCache.prototype.updateQuery = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readQuery(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeQuery((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    ApolloCache.prototype.updateFragment = function(options, update) {
        return this.batch({
            update: function(cache) {
                var value = cache.readFragment(options);
                var data = update(value);
                if (data === void 0 || data === null) return value;
                cache.writeFragment((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                    data: data
                }));
                return data;
            }
        });
    };
    return ApolloCache;
}();
if (globalThis.__DEV__ !== false) $4f6f40867ada8d0c$export$5fc74f25506aa9c.prototype.getMemoryInternals = (0, $7XZ8S.getApolloCacheMemoryInternals);

});

parcelRegister("jANkB", function(module, exports) {

$parcel$export(module.exports, "MissingFieldError", () => $e437a54482f9f8d5$export$257c68286583b0f9);

var $fKE23 = parcelRequire("fKE23");
var $e437a54482f9f8d5$export$257c68286583b0f9 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(MissingFieldError, _super);
    function MissingFieldError(message, path, query, variables) {
        var _a;
        // 'Error' breaks prototype chain here
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.path = path;
        _this.query = query;
        _this.variables = variables;
        if (Array.isArray(_this.path)) {
            _this.missing = _this.message;
            for(var i = _this.path.length - 1; i >= 0; --i)_this.missing = (_a = {}, _a[_this.path[i]] = _this.missing, _a);
        } else _this.missing = _this.path;
        // We're not using `Object.setPrototypeOf` here as it isn't fully supported
        // on Android (see issue #3236).
        _this.__proto__ = MissingFieldError.prototype;
        return _this;
    }
    return MissingFieldError;
}(Error);

});

parcelRegister("1CBce", function(module, exports) {

$parcel$export(module.exports, "removeDirectivesFromDocument", () => $12e63173ed1dd24f$export$e5ae0530da5fe96c);
$parcel$export(module.exports, "addTypenameToDocument", () => $12e63173ed1dd24f$export$43b332f87950a467);
$parcel$export(module.exports, "buildQueryFromSelectionSet", () => $12e63173ed1dd24f$export$57c368c23873f32b);
$parcel$export(module.exports, "removeClientSetsFromDocument", () => $12e63173ed1dd24f$export$8eae69e876ee321e);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $1c4hI = parcelRequire("1c4hI");
var $961BR = parcelRequire("961BR");

var $iX694 = parcelRequire("iX694");

var $6dwmd = parcelRequire("6dwmd");

var $iB2lh = parcelRequire("iB2lh");

var $kxw1Y = parcelRequire("kxw1Y");
var $12e63173ed1dd24f$var$TYPENAME_FIELD = {
    kind: (0, $1c4hI.Kind).FIELD,
    name: {
        kind: (0, $1c4hI.Kind).NAME,
        value: "__typename"
    }
};
function $12e63173ed1dd24f$var$isEmpty(op, fragmentMap) {
    return !op || op.selectionSet.selections.every(function(selection) {
        return selection.kind === (0, $1c4hI.Kind).FRAGMENT_SPREAD && $12e63173ed1dd24f$var$isEmpty(fragmentMap[selection.name.value], fragmentMap);
    });
}
function $12e63173ed1dd24f$var$nullIfDocIsEmpty(doc) {
    return $12e63173ed1dd24f$var$isEmpty((0, $iX694.getOperationDefinition)(doc) || (0, $iX694.getFragmentDefinition)(doc), (0, $iB2lh.createFragmentMap)((0, $iX694.getFragmentDefinitions)(doc))) ? null : doc;
}
function $12e63173ed1dd24f$var$getDirectiveMatcher(configs) {
    var names = new Map();
    var tests = new Map();
    configs.forEach(function(directive) {
        if (directive) {
            if (directive.name) names.set(directive.name, directive);
            else if (directive.test) tests.set(directive.test, directive);
        }
    });
    return function(directive) {
        var config = names.get(directive.name.value);
        if (!config && tests.size) tests.forEach(function(testConfig, test) {
            if (test(directive)) config = testConfig;
        });
        return config;
    };
}
function $12e63173ed1dd24f$var$makeInUseGetterFunction(defaultKey) {
    var map = new Map();
    return function inUseGetterFunction(key) {
        if (key === void 0) key = defaultKey;
        var inUse = map.get(key);
        if (!inUse) map.set(key, inUse = {
            // Variable and fragment spread names used directly within this
            // operation or fragment definition, as identified by key. These sets
            // will be populated during the first traversal of the document in
            // removeDirectivesFromDocument below.
            variables: new Set(),
            fragmentSpreads: new Set()
        });
        return inUse;
    };
}
function $12e63173ed1dd24f$export$e5ae0530da5fe96c(directives, doc) {
    (0, $iX694.checkDocument)(doc);
    // Passing empty strings to makeInUseGetterFunction means we handle anonymous
    // operations as if their names were "". Anonymous fragment definitions are
    // not supposed to be possible, but the same default naming strategy seems
    // appropriate for that case as well.
    var getInUseByOperationName = $12e63173ed1dd24f$var$makeInUseGetterFunction("");
    var getInUseByFragmentName = $12e63173ed1dd24f$var$makeInUseGetterFunction("");
    var getInUse = function(ancestors) {
        for(var p = 0, ancestor = void 0; p < ancestors.length && (ancestor = ancestors[p]); ++p){
            if ((0, $kxw1Y.isArray)(ancestor)) continue;
            if (ancestor.kind === (0, $1c4hI.Kind).OPERATION_DEFINITION) // If an operation is anonymous, we use the empty string as its key.
            return getInUseByOperationName(ancestor.name && ancestor.name.value);
            if (ancestor.kind === (0, $1c4hI.Kind).FRAGMENT_DEFINITION) return getInUseByFragmentName(ancestor.name.value);
        }
        globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).error(83);
        return null;
    };
    var operationCount = 0;
    for(var i = doc.definitions.length - 1; i >= 0; --i)if (doc.definitions[i].kind === (0, $1c4hI.Kind).OPERATION_DEFINITION) ++operationCount;
    var directiveMatcher = $12e63173ed1dd24f$var$getDirectiveMatcher(directives);
    var shouldRemoveField = function(nodeDirectives) {
        return (0, $kxw1Y.isNonEmptyArray)(nodeDirectives) && nodeDirectives.map(directiveMatcher).some(function(config) {
            return config && config.remove;
        });
    };
    var originalFragmentDefsByPath = new Map();
    // Any time the first traversal of the document below makes a change like
    // removing a fragment (by returning null), this variable should be set to
    // true. Once it becomes true, it should never be set to false again. If this
    // variable remains false throughout the traversal, then we can return the
    // original doc immediately without any modifications.
    var firstVisitMadeChanges = false;
    var fieldOrInlineFragmentVisitor = {
        enter: function(node) {
            if (shouldRemoveField(node.directives)) {
                firstVisitMadeChanges = true;
                return null;
            }
        }
    };
    var docWithoutDirectiveSubtrees = (0, $961BR.visit)(doc, {
        // These two AST node types share the same implementation, defined above.
        Field: fieldOrInlineFragmentVisitor,
        InlineFragment: fieldOrInlineFragmentVisitor,
        VariableDefinition: {
            enter: function() {
                // VariableDefinition nodes do not count as variables in use, though
                // they do contain Variable nodes that might be visited below. To avoid
                // counting variable declarations as usages, we skip visiting the
                // contents of this VariableDefinition node by returning false.
                return false;
            }
        },
        Variable: {
            enter: function(node, _key, _parent, _path, ancestors) {
                var inUse = getInUse(ancestors);
                if (inUse) inUse.variables.add(node.name.value);
            }
        },
        FragmentSpread: {
            enter: function(node, _key, _parent, _path, ancestors) {
                if (shouldRemoveField(node.directives)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
                var inUse = getInUse(ancestors);
                if (inUse) inUse.fragmentSpreads.add(node.name.value);
            // We might like to remove this FragmentSpread by returning null here if
            // the corresponding FragmentDefinition node is also going to be removed
            // by the logic below, but we can't control the relative order of those
            // events, so we have to postpone the removal of dangling FragmentSpread
            // nodes until after the current visit of the document has finished.
            }
        },
        FragmentDefinition: {
            enter: function(node, _key, _parent, path) {
                originalFragmentDefsByPath.set(JSON.stringify(path), node);
            },
            leave: function(node, _key, _parent, path) {
                var originalNode = originalFragmentDefsByPath.get(JSON.stringify(path));
                if (node === originalNode) // If the FragmentNode received by this leave function is identical to
                // the one received by the corresponding enter function (above), then
                // the visitor must not have made any changes within this
                // FragmentDefinition node. This fragment definition may still be
                // removed if there are no ...spread references to it, but it won't be
                // removed just because it has only a __typename field.
                return node;
                if (// This logic applies only if the document contains one or more
                // operations, since removing all fragments from a document containing
                // only fragments makes the document useless.
                operationCount > 0 && node.selectionSet.selections.every(function(selection) {
                    return selection.kind === (0, $1c4hI.Kind).FIELD && selection.name.value === "__typename";
                })) {
                    // This is a somewhat opinionated choice: if a FragmentDefinition ends
                    // up having no fields other than __typename, we remove the whole
                    // fragment definition, and later prune ...spread references to it.
                    getInUseByFragmentName(node.name.value).removed = true;
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        },
        Directive: {
            leave: function(node) {
                // If a matching directive is found, remove the directive itself. Note
                // that this does not remove the target (field, argument, etc) of the
                // directive, but only the directive itself.
                if (directiveMatcher(node)) {
                    firstVisitMadeChanges = true;
                    return null;
                }
            }
        }
    });
    if (!firstVisitMadeChanges) // If our first pass did not change anything about the document, then there
    // is no cleanup we need to do, and we can return the original doc.
    return doc;
    // Utility for making sure inUse.transitiveVars is recursively populated.
    // Because this logic assumes inUse.fragmentSpreads has been completely
    // populated and inUse.removed has been set if appropriate,
    // populateTransitiveVars must be called after that information has been
    // collected by the first traversal of the document.
    var populateTransitiveVars = function(inUse) {
        if (!inUse.transitiveVars) {
            inUse.transitiveVars = new Set(inUse.variables);
            if (!inUse.removed) inUse.fragmentSpreads.forEach(function(childFragmentName) {
                populateTransitiveVars(getInUseByFragmentName(childFragmentName)).transitiveVars.forEach(function(varName) {
                    inUse.transitiveVars.add(varName);
                });
            });
        }
        return inUse;
    };
    // Since we've been keeping track of fragment spreads used by particular
    // operations and fragment definitions, we now need to compute the set of all
    // spreads used (transitively) by any operations in the document.
    var allFragmentNamesUsed = new Set();
    docWithoutDirectiveSubtrees.definitions.forEach(function(def) {
        if (def.kind === (0, $1c4hI.Kind).OPERATION_DEFINITION) populateTransitiveVars(getInUseByOperationName(def.name && def.name.value)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
        else if (def.kind === (0, $1c4hI.Kind).FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
        // definitions count as usages of their own fragment names. This heuristic
        // prevents accidentally removing all fragment definitions from the
        // document just because it contains no operations that use the fragments.
        operationCount === 0 && !getInUseByFragmentName(def.name.value).removed) allFragmentNamesUsed.add(def.name.value);
    });
    // Now that we have added all fragment spreads used by operations to the
    // allFragmentNamesUsed set, we can complete the set by transitively adding
    // all fragment spreads used by those fragments, and so on.
    allFragmentNamesUsed.forEach(function(fragmentName) {
        // Once all the childFragmentName strings added here have been seen already,
        // the top-level allFragmentNamesUsed.forEach loop will terminate.
        populateTransitiveVars(getInUseByFragmentName(fragmentName)).fragmentSpreads.forEach(function(childFragmentName) {
            allFragmentNamesUsed.add(childFragmentName);
        });
    });
    var fragmentWillBeRemoved = function(fragmentName) {
        return !!// A fragment definition will be removed if there are no spreads that refer
        // to it, or the fragment was explicitly removed because it had no fields
        // other than __typename.
        (!allFragmentNamesUsed.has(fragmentName) || getInUseByFragmentName(fragmentName).removed);
    };
    var enterVisitor = {
        enter: function(node) {
            if (fragmentWillBeRemoved(node.name.value)) return null;
        }
    };
    return $12e63173ed1dd24f$var$nullIfDocIsEmpty((0, $961BR.visit)(docWithoutDirectiveSubtrees, {
        // If the fragment is going to be removed, then leaving any dangling
        // FragmentSpread nodes with the same name would be a mistake.
        FragmentSpread: enterVisitor,
        // This is where the fragment definition is actually removed.
        FragmentDefinition: enterVisitor,
        OperationDefinition: {
            leave: function(node) {
                // Upon leaving each operation in the depth-first AST traversal, prune
                // any variables that are declared by the operation but unused within.
                if (node.variableDefinitions) {
                    var usedVariableNames_1 = populateTransitiveVars(// If an operation is anonymous, we use the empty string as its key.
                    getInUseByOperationName(node.name && node.name.value)).transitiveVars;
                    // According to the GraphQL spec, all variables declared by an
                    // operation must either be used by that operation or used by some
                    // fragment included transitively into that operation:
                    // https://spec.graphql.org/draft/#sec-All-Variables-Used
                    //
                    // To stay on the right side of this validation rule, if/when we
                    // remove the last $var references from an operation or its fragments,
                    // we must also remove the corresponding $var declaration from the
                    // enclosing operation. This pruning applies only to operations and
                    // not fragment definitions, at the moment. Fragments may be able to
                    // declare variables eventually, but today they can only consume them.
                    if (usedVariableNames_1.size < node.variableDefinitions.length) return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                        variableDefinitions: node.variableDefinitions.filter(function(varDef) {
                            return usedVariableNames_1.has(varDef.variable.name.value);
                        })
                    });
                }
            }
        }
    }));
}
var $12e63173ed1dd24f$export$43b332f87950a467 = Object.assign(function(doc) {
    return (0, $961BR.visit)(doc, {
        SelectionSet: {
            enter: function(node, _key, parent) {
                // Don't add __typename to OperationDefinitions.
                if (parent && parent.kind === (0, $1c4hI.Kind).OPERATION_DEFINITION) return;
                // No changes if no selections.
                var selections = node.selections;
                if (!selections) return;
                // If selections already have a __typename, or are part of an
                // introspection query, do nothing.
                var skip = selections.some(function(selection) {
                    return (0, $6dwmd.isField)(selection) && (selection.name.value === "__typename" || selection.name.value.lastIndexOf("__", 0) === 0);
                });
                if (skip) return;
                // If this SelectionSet is @export-ed as an input variable, it should
                // not have a __typename field (see issue #4691).
                var field = parent;
                if ((0, $6dwmd.isField)(field) && field.directives && field.directives.some(function(d) {
                    return d.name.value === "export";
                })) return;
                // Create and return a new SelectionSet with a __typename Field.
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    selections: (0, $fKE23.__spreadArray)((0, $fKE23.__spreadArray)([], selections, true), [
                        $12e63173ed1dd24f$var$TYPENAME_FIELD
                    ], false)
                });
            }
        }
    });
}, {
    added: function(field) {
        return field === $12e63173ed1dd24f$var$TYPENAME_FIELD;
    }
});
var $12e63173ed1dd24f$var$connectionRemoveConfig = {
    test: function(directive) {
        var willRemove = directive.name.value === "connection";
        if (willRemove) {
            if (!directive.arguments || !directive.arguments.some(function(arg) {
                return arg.name.value === "key";
            })) globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).warn(84);
        }
        return willRemove;
    }
};
function $12e63173ed1dd24f$export$74985f3324559867(doc) {
    return $12e63173ed1dd24f$export$e5ae0530da5fe96c([
        $12e63173ed1dd24f$var$connectionRemoveConfig
    ], (0, $iX694.checkDocument)(doc));
}
function $12e63173ed1dd24f$var$hasDirectivesInSelectionSet(directives, selectionSet, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    return !!selectionSet && selectionSet.selections && selectionSet.selections.some(function(selection) {
        return $12e63173ed1dd24f$var$hasDirectivesInSelection(directives, selection, nestedCheck);
    });
}
function $12e63173ed1dd24f$var$hasDirectivesInSelection(directives, selection, nestedCheck) {
    if (nestedCheck === void 0) nestedCheck = true;
    if (!(0, $6dwmd.isField)(selection)) return true;
    if (!selection.directives) return false;
    return selection.directives.some($12e63173ed1dd24f$var$getDirectiveMatcher(directives)) || nestedCheck && $12e63173ed1dd24f$var$hasDirectivesInSelectionSet(directives, selection.selectionSet, nestedCheck);
}
function $12e63173ed1dd24f$var$getArgumentMatcher(config) {
    return function argumentMatcher(argument) {
        return config.some(function(aConfig) {
            return argument.value && argument.value.kind === (0, $1c4hI.Kind).VARIABLE && argument.value.name && (aConfig.name === argument.value.name.value || aConfig.test && aConfig.test(argument));
        });
    };
}
function $12e63173ed1dd24f$export$ecd5bb739c4a8b38(config, doc) {
    var argMatcher = $12e63173ed1dd24f$var$getArgumentMatcher(config);
    return $12e63173ed1dd24f$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    // Remove matching top level variables definitions.
                    variableDefinitions: node.variableDefinitions ? node.variableDefinitions.filter(function(varDef) {
                        return !config.some(function(arg) {
                            return arg.name === varDef.variable.name.value;
                        });
                    }) : []
                });
            }
        },
        Field: {
            enter: function(node) {
                // If `remove` is set to true for an argument, and an argument match
                // is found for a field, remove the field as well.
                var shouldRemoveField = config.some(function(argConfig) {
                    return argConfig.remove;
                });
                if (shouldRemoveField) {
                    var argMatchCount_1 = 0;
                    if (node.arguments) node.arguments.forEach(function(arg) {
                        if (argMatcher(arg)) argMatchCount_1 += 1;
                    });
                    if (argMatchCount_1 === 1) return null;
                }
            }
        },
        Argument: {
            enter: function(node) {
                // Remove all matching arguments.
                if (argMatcher(node)) return null;
            }
        }
    }));
}
function $12e63173ed1dd24f$export$7c9d17c333033c13(config, doc) {
    function enter(node) {
        if (config.some(function(def) {
            return def.name === node.name.value;
        })) return null;
    }
    return $12e63173ed1dd24f$var$nullIfDocIsEmpty((0, $961BR.visit)(doc, {
        FragmentSpread: {
            enter: enter
        },
        FragmentDefinition: {
            enter: enter
        }
    }));
}
function $12e63173ed1dd24f$export$57c368c23873f32b(document) {
    var definition = (0, $iX694.getMainDefinition)(document);
    var definitionOperation = definition.operation;
    if (definitionOperation === "query") // Already a query, so return the existing document.
    return document;
    // Build a new query using the selection set of the main operation.
    var modifiedDoc = (0, $961BR.visit)(document, {
        OperationDefinition: {
            enter: function(node) {
                return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, node), {
                    operation: "query"
                });
            }
        }
    });
    return modifiedDoc;
}
function $12e63173ed1dd24f$export$8eae69e876ee321e(document) {
    (0, $iX694.checkDocument)(document);
    var modifiedDoc = $12e63173ed1dd24f$export$e5ae0530da5fe96c([
        {
            test: function(directive) {
                return directive.name.value === "client";
            },
            remove: true
        }
    ], document);
    return modifiedDoc;
}

});
parcelRegister("kxw1Y", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $ef3fbc5e4ce8ab00$export$43bee75e5e14138e);
$parcel$export(module.exports, "isNonEmptyArray", () => $ef3fbc5e4ce8ab00$export$d307f5934e447d0e);
// A version of Array.isArray that works better with readonly arrays.
var $ef3fbc5e4ce8ab00$export$43bee75e5e14138e = Array.isArray;
function $ef3fbc5e4ce8ab00$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}

});


parcelRegister("fzShn", function(module, exports) {

$parcel$export(module.exports, "DocumentTransform", () => $b5743aa57f5fcf66$export$f887060e48e5dc1b);

var $6CRCP = parcelRequire("6CRCP");

var $7X1wJ = parcelRequire("7X1wJ");

var $iX694 = parcelRequire("iX694");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $kIv0I = parcelRequire("kIv0I");

var $bDsPx = parcelRequire("bDsPx");

var $7MpZC = parcelRequire("7MpZC");
function $b5743aa57f5fcf66$var$identity(document) {
    return document;
}
var $b5743aa57f5fcf66$export$f887060e48e5dc1b = /** @class */ function() {
    function DocumentTransform(transform, options) {
        if (options === void 0) options = Object.create(null);
        this.resultCache = (0, $7X1wJ.canUseWeakSet) ? new WeakSet() : new Set();
        this.transform = transform;
        if (options.getCacheKey) // Override default `getCacheKey` function, which returns [document].
        this.getCacheKey = options.getCacheKey;
        this.cached = options.cache !== false;
        this.resetCache();
    }
    // This default implementation of getCacheKey can be overridden by providing
    // options.getCacheKey to the DocumentTransform constructor. In general, a
    // getCacheKey function may either return an array of keys (often including
    // the document) to be used as a cache key, or undefined to indicate the
    // transform for this document should not be cached.
    DocumentTransform.prototype.getCacheKey = function(document) {
        return [
            document
        ];
    };
    DocumentTransform.identity = function() {
        // No need to cache this transform since it just returns the document
        // unchanged. This should save a bit of memory that would otherwise be
        // needed to populate the `documentCache` of this transform.
        return new DocumentTransform($b5743aa57f5fcf66$var$identity, {
            cache: false
        });
    };
    DocumentTransform.split = function(predicate, left, right) {
        if (right === void 0) right = DocumentTransform.identity();
        return Object.assign(new DocumentTransform(function(document) {
            var documentTransform = predicate(document) ? left : right;
            return documentTransform.transformDocument(document);
        }, // Reasonably assume both `left` and `right` transforms handle their own caching
        {
            cache: false
        }), {
            left: left,
            right: right
        });
    };
    /**
     * Resets the internal cache of this transform, if it has one.
     */ DocumentTransform.prototype.resetCache = function() {
        var _this = this;
        if (this.cached) {
            var stableCacheKeys_1 = new (0, $6CRCP.Trie)((0, $7X1wJ.canUseWeakMap));
            this.performWork = (0, $bDsPx.wrap)(DocumentTransform.prototype.performWork.bind(this), {
                makeCacheKey: function(document) {
                    var cacheKeys = _this.getCacheKey(document);
                    if (cacheKeys) {
                        (0, $kL4FQ.invariant)(Array.isArray(cacheKeys), 66);
                        return stableCacheKeys_1.lookupArray(cacheKeys);
                    }
                },
                max: (0, $7MpZC.cacheSizes)["documentTransform.cache"],
                cache: (0, $kIv0I.WeakCache)
            });
        }
    };
    DocumentTransform.prototype.performWork = function(document) {
        (0, $iX694.checkDocument)(document);
        return this.transform(document);
    };
    DocumentTransform.prototype.transformDocument = function(document) {
        // If a user passes an already transformed result back to this function,
        // immediately return it.
        if (this.resultCache.has(document)) return document;
        var transformedDocument = this.performWork(document);
        this.resultCache.add(transformedDocument);
        return transformedDocument;
    };
    DocumentTransform.prototype.concat = function(otherTransform) {
        var _this = this;
        return Object.assign(new DocumentTransform(function(document) {
            return otherTransform.transformDocument(_this.transformDocument(document));
        }, // Reasonably assume both transforms handle their own caching
        {
            cache: false
        }), {
            left: this,
            right: otherTransform
        });
    };
    return DocumentTransform;
}();

});
parcelRegister("6CRCP", function(module, exports) {

$parcel$export(module.exports, "Trie", () => $4d2fe3900d363184$export$73571c50d0f2507e);
// A [trie](https://en.wikipedia.org/wiki/Trie) data structure that holds
// object keys weakly, yet can also hold non-object keys, unlike the
// native `WeakMap`.
// If no makeData function is supplied, the looked-up data will be an empty,
// null-prototype Object.
const $4d2fe3900d363184$var$defaultMakeData = ()=>Object.create(null);
// Useful for processing arguments objects as well as arrays.
const { forEach: $4d2fe3900d363184$var$forEach, slice: $4d2fe3900d363184$var$slice } = Array.prototype;
const { hasOwnProperty: $4d2fe3900d363184$var$hasOwnProperty } = Object.prototype;
class $4d2fe3900d363184$export$73571c50d0f2507e {
    constructor(weakness = true, makeData = $4d2fe3900d363184$var$defaultMakeData){
        this.weakness = weakness;
        this.makeData = makeData;
    }
    lookup() {
        return this.lookupArray(arguments);
    }
    lookupArray(array) {
        let node = this;
        $4d2fe3900d363184$var$forEach.call(array, (key)=>node = node.getChildTrie(key));
        return $4d2fe3900d363184$var$hasOwnProperty.call(node, "data") ? node.data : node.data = this.makeData($4d2fe3900d363184$var$slice.call(array));
    }
    peek() {
        return this.peekArray(arguments);
    }
    peekArray(array) {
        let node = this;
        for(let i = 0, len = array.length; node && i < len; ++i){
            const map = node.mapFor(array[i], false);
            node = map && map.get(array[i]);
        }
        return node && node.data;
    }
    remove() {
        return this.removeArray(arguments);
    }
    removeArray(array) {
        let data;
        if (array.length) {
            const head = array[0];
            const map = this.mapFor(head, false);
            const child = map && map.get(head);
            if (child) {
                data = child.removeArray($4d2fe3900d363184$var$slice.call(array, 1));
                if (!child.data && !child.weak && !(child.strong && child.strong.size)) map.delete(head);
            }
        } else {
            data = this.data;
            delete this.data;
        }
        return data;
    }
    getChildTrie(key) {
        const map = this.mapFor(key, true);
        let child = map.get(key);
        if (!child) map.set(key, child = new $4d2fe3900d363184$export$73571c50d0f2507e(this.weakness, this.makeData));
        return child;
    }
    mapFor(key, create) {
        return this.weakness && $4d2fe3900d363184$var$isObjRef(key) ? this.weak || (create ? this.weak = new WeakMap : void 0) : this.strong || (create ? this.strong = new Map : void 0);
    }
}
function $4d2fe3900d363184$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}

});

parcelRegister("7X1wJ", function(module, exports) {

$parcel$export(module.exports, "canUseWeakMap", () => $5c9f3a52cfc29138$export$772fbc04a0ad4ce9);
$parcel$export(module.exports, "canUseWeakSet", () => $5c9f3a52cfc29138$export$7293b8a0b474028d);
$parcel$export(module.exports, "canUseSymbol", () => $5c9f3a52cfc29138$export$23ba675b4b838b92);
$parcel$export(module.exports, "canUseAsyncIteratorSymbol", () => $5c9f3a52cfc29138$export$c34f882e9f1c1637);
$parcel$export(module.exports, "canUseLayoutEffect", () => $5c9f3a52cfc29138$export$4001f6cd4a62405b);
parcelRequire("aJBWo");
var $krE5f = parcelRequire("krE5f");
var $5c9f3a52cfc29138$export$772fbc04a0ad4ce9 = typeof WeakMap === "function" && !(0, $krE5f.maybe)(function() {
    return navigator.product == "ReactNative" && !$parcel$global.HermesInternal;
});
var $5c9f3a52cfc29138$export$7293b8a0b474028d = typeof WeakSet === "function";
var $5c9f3a52cfc29138$export$23ba675b4b838b92 = typeof Symbol === "function" && typeof Symbol.for === "function";
var $5c9f3a52cfc29138$export$c34f882e9f1c1637 = $5c9f3a52cfc29138$export$23ba675b4b838b92 && Symbol.asyncIterator;
var $5c9f3a52cfc29138$export$71594e8a50f746f4 = typeof (0, $krE5f.maybe)(function() {
    return window.document.createElement;
}) === "function";
var $5c9f3a52cfc29138$var$usingJSDOM = // Following advice found in this comment from @domenic (maintainer of jsdom):
// https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
//
// Since we control the version of Jest and jsdom used when running Apollo
// Client tests, and that version is recent enought to include " jsdom/x.y.z"
// at the end of the user agent string, I believe this case is all we need to
// check. Testing for "Node.js" was recommended for backwards compatibility
// with older version of jsdom, but we don't have that problem.
(0, $krE5f.maybe)(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
}) || false;
var $5c9f3a52cfc29138$export$4001f6cd4a62405b = $5c9f3a52cfc29138$export$71594e8a50f746f4 && !$5c9f3a52cfc29138$var$usingJSDOM;

});


parcelRegister("aaMYp", function(module, exports) {

$parcel$export(module.exports, "print", () => $7680d3a352eda050$export$c2d084dc44961371);

var $aKlnM = parcelRequire("aKlnM");

var $czLrN = parcelRequire("czLrN");
var $7MpZC = parcelRequire("7MpZC");

var $7XZ8S = parcelRequire("7XZ8S");
var $7680d3a352eda050$var$printCache;
var $7680d3a352eda050$export$c2d084dc44961371 = Object.assign(function(ast) {
    var result = $7680d3a352eda050$var$printCache.get(ast);
    if (!result) {
        result = (0, $aKlnM.print)(ast);
        $7680d3a352eda050$var$printCache.set(ast, result);
    }
    return result;
}, {
    reset: function() {
        $7680d3a352eda050$var$printCache = new (0, $czLrN.AutoCleanedWeakCache)((0, $7MpZC.cacheSizes).print || 2000 /* defaultCacheSizes.print */ );
    }
});
$7680d3a352eda050$export$c2d084dc44961371.reset();
if (globalThis.__DEV__ !== false) (0, $7XZ8S.registerGlobalCache)("print", function() {
    return $7680d3a352eda050$var$printCache ? $7680d3a352eda050$var$printCache.size : 0;
});

});

parcelRegister("6KfMt", function(module, exports) {

$parcel$export(module.exports, "StoreReader", () => $4e9347b1dad94e13$export$628ef07ba8965f12);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $1c4hI = parcelRequire("1c4hI");

var $bDsPx = parcelRequire("bDsPx");

var $1CBce = parcelRequire("1CBce");
var $7MpZC = parcelRequire("7MpZC");
var $5bIMC = parcelRequire("5bIMC");
var $7X1wJ = parcelRequire("7X1wJ");
var $jZIxU = parcelRequire("jZIxU");
var $64d3o = parcelRequire("64d3o");
var $iX694 = parcelRequire("iX694");
var $iB2lh = parcelRequire("iB2lh");
var $6dwmd = parcelRequire("6dwmd");
var $1MCRf = parcelRequire("1MCRf");
var $jxMus = parcelRequire("jxMus");
var $jHSHK = parcelRequire("jHSHK");

var $eDlCq = parcelRequire("eDlCq");

var $eiege = parcelRequire("eiege");
var $kxw1Y = parcelRequire("kxw1Y");

var $jANkB = parcelRequire("jANkB");

var $31wLM = parcelRequire("31wLM");
function $4e9347b1dad94e13$var$execSelectionSetKeyArgs(options) {
    return [
        options.selectionSet,
        options.objectOrReference,
        options.context,
        // We split out this property so we can pass different values
        // independently without modifying options.context itself.
        options.context.canonizeResults
    ];
}
var $4e9347b1dad94e13$export$628ef07ba8965f12 = /** @class */ function() {
    function StoreReader(config) {
        var _this = this;
        this.knownResults = new ((0, $7X1wJ.canUseWeakMap) ? WeakMap : Map)();
        this.config = (0, $jZIxU.compact)(config, {
            addTypename: config.addTypename !== false,
            canonizeResults: (0, $eiege.shouldCanonizeResults)(config)
        });
        this.canon = config.canon || new (0, $31wLM.ObjectCanon)();
        // memoized functions in this class will be "garbage-collected"
        // by recreating the whole `StoreReader` in
        // `InMemoryCache.resetResultsCache`
        // (triggered from `InMemoryCache.gc` with `resetResultCache: true`)
        this.executeSelectionSet = (0, $bDsPx.wrap)(function(options) {
            var _a;
            var canonizeResults = options.context.canonizeResults;
            var peekArgs = $4e9347b1dad94e13$var$execSelectionSetKeyArgs(options);
            // Negate this boolean option so we can find out if we've already read
            // this result using the other boolean value.
            peekArgs[3] = !canonizeResults;
            var other = (_a = _this.executeSelectionSet).peek.apply(_a, peekArgs);
            if (other) {
                if (canonizeResults) return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, other), {
                    // If we previously read this result without canonizing it, we can
                    // reuse that result simply by canonizing it now.
                    result: _this.canon.admit(other.result)
                });
                // If we previously read this result with canonization enabled, we can
                // return that canonized result as-is.
                return other;
            }
            (0, $eDlCq.maybeDependOnExistenceOfEntity)(options.context.store, options.enclosingRef.__ref);
            // Finally, if we didn't find any useful previous results, run the real
            // execSelectionSetImpl method with the given options.
            return _this.execSelectionSetImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $7MpZC.cacheSizes)["inMemoryCache.executeSelectionSet"] || 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
            keyArgs: $4e9347b1dad94e13$var$execSelectionSetKeyArgs,
            // Note that the parameters of makeCacheKey are determined by the
            // array returned by keyArgs.
            makeCacheKey: function(selectionSet, parent, context, canonizeResults) {
                if ((0, $eDlCq.supportsResultCaching)(context.store)) return context.store.makeCacheKey(selectionSet, (0, $6dwmd.isReference)(parent) ? parent.__ref : parent, context.varString, canonizeResults);
            }
        });
        this.executeSubSelectedArray = (0, $bDsPx.wrap)(function(options) {
            (0, $eDlCq.maybeDependOnExistenceOfEntity)(options.context.store, options.enclosingRef.__ref);
            return _this.execSubSelectedArrayImpl(options);
        }, {
            max: this.config.resultCacheMaxSize || (0, $7MpZC.cacheSizes)["inMemoryCache.executeSubSelectedArray"] || 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ ,
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, context = _a.context;
                if ((0, $eDlCq.supportsResultCaching)(context.store)) return context.store.makeCacheKey(field, array, context.varString);
            }
        });
    }
    StoreReader.prototype.resetCanon = function() {
        this.canon = new (0, $31wLM.ObjectCanon)();
    };
    /**
     * Given a store and a query, return as much of the result as possible and
     * identify if any data was missing from the store.
     */ StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, _b = _a.rootId, rootId = _b === void 0 ? "ROOT_QUERY" : _b, variables = _a.variables, _c = _a.returnPartialData, returnPartialData = _c === void 0 ? true : _c, _d = _a.canonizeResults, canonizeResults = _d === void 0 ? this.config.canonizeResults : _d;
        var policies = this.config.cache.policies;
        variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, (0, $iX694.getDefaultValues)((0, $iX694.getQueryDefinition)(query))), variables);
        var rootRef = (0, $6dwmd.makeReference)(rootId);
        var execResult = this.executeSelectionSet({
            selectionSet: (0, $iX694.getMainDefinition)(query).selectionSet,
            objectOrReference: rootRef,
            enclosingRef: rootRef,
            context: (0, $fKE23.__assign)({
                store: store,
                query: query,
                policies: policies,
                variables: variables,
                varString: (0, $5bIMC.canonicalStringify)(variables),
                canonizeResults: canonizeResults
            }, (0, $eiege.extractFragmentContext)(query, this.config.fragments))
        });
        var missing;
        if (execResult.missing) {
            // For backwards compatibility we still report an array of
            // MissingFieldError objects, even though there will only ever be at most
            // one of them, now that all missing field error messages are grouped
            // together in the execResult.missing tree.
            missing = [
                new (0, $jANkB.MissingFieldError)($4e9347b1dad94e13$var$firstMissing(execResult.missing), execResult.missing, query, variables)
            ];
            if (!returnPartialData) throw missing[0];
        }
        return {
            result: execResult.result,
            complete: !missing,
            missing: missing
        };
    };
    StoreReader.prototype.isFresh = function(result, parent, selectionSet, context) {
        if ((0, $eDlCq.supportsResultCaching)(context.store) && this.knownResults.get(result) === selectionSet) {
            var latest = this.executeSelectionSet.peek(selectionSet, parent, context, // If result is canonical, then it could only have been previously
            // cached by the canonizing version of executeSelectionSet, so we can
            // avoid checking both possibilities here.
            this.canon.isKnown(result));
            if (latest && result === latest.result) return true;
        }
        return false;
    };
    // Uncached version of executeSelectionSet.
    StoreReader.prototype.execSelectionSetImpl = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, objectOrReference = _a.objectOrReference, enclosingRef = _a.enclosingRef, context = _a.context;
        if ((0, $6dwmd.isReference)(objectOrReference) && !context.policies.rootTypenamesById[objectOrReference.__ref] && !context.store.has(objectOrReference.__ref)) return {
            result: this.canon.empty,
            missing: "Dangling reference to missing ".concat(objectOrReference.__ref, " object")
        };
        var variables = context.variables, policies = context.policies, store = context.store;
        var typename = store.getFieldValue(objectOrReference, "__typename");
        var objectsToMerge = [];
        var missing;
        var missingMerger = new (0, $64d3o.DeepMerger)();
        if (this.config.addTypename && typeof typename === "string" && !policies.rootIdsByTypename[typename]) // Ensure we always include a default value for the __typename
        // field, if we have one, and this.config.addTypename is true. Note
        // that this field can be overridden by other merged objects.
        objectsToMerge.push({
            __typename: typename
        });
        function handleMissing(result, resultName) {
            var _a;
            if (result.missing) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = result.missing, _a));
            return result.result;
        }
        var workSet = new Set(selectionSet.selections);
        workSet.forEach(function(selection) {
            var _a, _b;
            // Omit fields with directives @skip(if: <truthy value>) or
            // @include(if: <falsy value>).
            if (!(0, $jHSHK.shouldInclude)(selection, variables)) return;
            if ((0, $6dwmd.isField)(selection)) {
                var fieldValue = policies.readField({
                    fieldName: selection.name.value,
                    field: selection,
                    variables: context.variables,
                    from: objectOrReference
                }, context);
                var resultName = (0, $6dwmd.resultKeyNameFromField)(selection);
                if (fieldValue === void 0) {
                    if (!(0, $1CBce.addTypenameToDocument).added(selection)) missing = missingMerger.merge(missing, (_a = {}, _a[resultName] = "Can't find field '".concat(selection.name.value, "' on ").concat((0, $6dwmd.isReference)(objectOrReference) ? objectOrReference.__ref + " object" : "object " + JSON.stringify(objectOrReference, null, 2)), _a));
                } else if ((0, $kxw1Y.isArray)(fieldValue)) fieldValue = handleMissing(_this.executeSubSelectedArray({
                    field: selection,
                    array: fieldValue,
                    enclosingRef: enclosingRef,
                    context: context
                }), resultName);
                else if (!selection.selectionSet) // If the field does not have a selection set, then we handle it
                // as a scalar value. To keep this.canon from canonicalizing
                // this value, we use this.canon.pass to wrap fieldValue in a
                // Pass object that this.canon.admit will later unwrap as-is.
                {
                    if (context.canonizeResults) fieldValue = _this.canon.pass(fieldValue);
                } else if (fieldValue != null) // In this case, because we know the field has a selection set,
                // it must be trying to query a GraphQLObjectType, which is why
                // fieldValue must be != null.
                fieldValue = handleMissing(_this.executeSelectionSet({
                    selectionSet: selection.selectionSet,
                    objectOrReference: fieldValue,
                    enclosingRef: (0, $6dwmd.isReference)(fieldValue) ? fieldValue : enclosingRef,
                    context: context
                }), resultName);
                if (fieldValue !== void 0) objectsToMerge.push((_b = {}, _b[resultName] = fieldValue, _b));
            } else {
                var fragment = (0, $iB2lh.getFragmentFromSelection)(selection, context.lookupFragment);
                if (!fragment && selection.kind === (0, $1c4hI.Kind).FRAGMENT_SPREAD) throw (0, $kL4FQ.newInvariantError)(9, selection.name.value);
                if (fragment && policies.fragmentMatches(fragment, typename)) fragment.selectionSet.selections.forEach(workSet.add, workSet);
            }
        });
        var result = (0, $64d3o.mergeDeepArray)(objectsToMerge);
        var finalResult = {
            result: result,
            missing: missing
        };
        var frozen = context.canonizeResults ? this.canon.admit(finalResult) : (0, $jxMus.maybeDeepFreeze)(finalResult);
        // Store this result with its selection set so that we can quickly
        // recognize it again in the StoreReader#isFresh method.
        if (frozen.result) this.knownResults.set(frozen.result, selectionSet);
        return frozen;
    };
    // Uncached version of executeSubSelectedArray.
    StoreReader.prototype.execSubSelectedArrayImpl = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, enclosingRef = _a.enclosingRef, context = _a.context;
        var missing;
        var missingMerger = new (0, $64d3o.DeepMerger)();
        function handleMissing(childResult, i) {
            var _a;
            if (childResult.missing) missing = missingMerger.merge(missing, (_a = {}, _a[i] = childResult.missing, _a));
            return childResult.result;
        }
        if (field.selectionSet) array = array.filter(context.store.canRead);
        array = array.map(function(item, i) {
            // null value in array
            if (item === null) return null;
            // This is a nested array, recurse
            if ((0, $kxw1Y.isArray)(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                enclosingRef: enclosingRef,
                context: context
            }), i);
            // This is an object, run the selection set on it
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                objectOrReference: item,
                enclosingRef: (0, $6dwmd.isReference)(item) ? item : enclosingRef,
                context: context
            }), i);
            if (globalThis.__DEV__ !== false) $4e9347b1dad94e13$var$assertSelectionSetForIdValue(context.store, field, item);
            return item;
        });
        return {
            result: context.canonizeResults ? this.canon.admit(array) : array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $4e9347b1dad94e13$var$firstMissing(tree) {
    try {
        JSON.stringify(tree, function(_, value) {
            if (typeof value === "string") throw value;
            return value;
        });
    } catch (result) {
        return result;
    }
}
function $4e9347b1dad94e13$var$assertSelectionSetForIdValue(store, field, fieldValue) {
    if (!field.selectionSet) {
        var workSet_1 = new Set([
            fieldValue
        ]);
        workSet_1.forEach(function(value) {
            if ((0, $1MCRf.isNonNullObject)(value)) {
                (0, $kL4FQ.invariant)(!(0, $6dwmd.isReference)(value), 10, (0, $eiege.getTypenameFromStoreObject)(store, value), field.name.value);
                Object.values(value).forEach(workSet_1.add, workSet_1);
            }
        });
    }
}

});
parcelRegister("jZIxU", function(module, exports) {

$parcel$export(module.exports, "compact", () => $e8e644b50492b709$export$8e16b83750b44988);
/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */ function $e8e644b50492b709$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}

});

parcelRegister("64d3o", function(module, exports) {

$parcel$export(module.exports, "mergeDeep", () => $46ad3dfc1d6cda37$export$dd702b3c8240390c);
$parcel$export(module.exports, "mergeDeepArray", () => $46ad3dfc1d6cda37$export$160070228be94b08);
$parcel$export(module.exports, "DeepMerger", () => $46ad3dfc1d6cda37$export$509e11c221f576c0);

var $fKE23 = parcelRequire("fKE23");

var $1MCRf = parcelRequire("1MCRf");
var $46ad3dfc1d6cda37$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $46ad3dfc1d6cda37$export$dd702b3c8240390c() {
    var sources = [];
    for(var _i = 0; _i < arguments.length; _i++)sources[_i] = arguments[_i];
    return $46ad3dfc1d6cda37$export$160070228be94b08(sources);
}
function $46ad3dfc1d6cda37$export$160070228be94b08(sources) {
    var target = sources[0] || {};
    var count = sources.length;
    if (count > 1) {
        var merger = new $46ad3dfc1d6cda37$export$509e11c221f576c0();
        for(var i = 1; i < count; ++i)target = merger.merge(target, sources[i]);
    }
    return target;
}
var $46ad3dfc1d6cda37$var$defaultReconciler = function(target, source, property) {
    return this.merge(target[property], source[property]);
};
var $46ad3dfc1d6cda37$export$509e11c221f576c0 = /** @class */ function() {
    function DeepMerger(reconciler) {
        if (reconciler === void 0) reconciler = $46ad3dfc1d6cda37$var$defaultReconciler;
        this.reconciler = reconciler;
        this.isObject = (0, $1MCRf.isNonNullObject);
        this.pastCopies = new Set();
    }
    DeepMerger.prototype.merge = function(target, source) {
        var _this = this;
        var context = [];
        for(var _i = 2; _i < arguments.length; _i++)context[_i - 2] = arguments[_i];
        if ((0, $1MCRf.isNonNullObject)(source) && (0, $1MCRf.isNonNullObject)(target)) {
            Object.keys(source).forEach(function(sourceKey) {
                if ($46ad3dfc1d6cda37$var$hasOwnProperty.call(target, sourceKey)) {
                    var targetValue = target[sourceKey];
                    if (source[sourceKey] !== targetValue) {
                        var result = _this.reconciler.apply(_this, (0, $fKE23.__spreadArray)([
                            target,
                            source,
                            sourceKey
                        ], context, false));
                        // A well-implemented reconciler may return targetValue to indicate
                        // the merge changed nothing about the structure of the target.
                        if (result !== targetValue) {
                            target = _this.shallowCopyForMerge(target);
                            target[sourceKey] = result;
                        }
                    }
                } else {
                    // If there is no collision, the target can safely share memory with
                    // the source, and the recursion can terminate here.
                    target = _this.shallowCopyForMerge(target);
                    target[sourceKey] = source[sourceKey];
                }
            });
            return target;
        }
        // If source (or target) is not an object, let source replace target.
        return source;
    };
    DeepMerger.prototype.shallowCopyForMerge = function(value) {
        if ((0, $1MCRf.isNonNullObject)(value)) {
            if (!this.pastCopies.has(value)) {
                if (Array.isArray(value)) value = value.slice(0);
                else value = (0, $fKE23.__assign)({
                    __proto__: Object.getPrototypeOf(value)
                }, value);
                this.pastCopies.add(value);
            }
        }
        return value;
    };
    return DeepMerger;
}();

});

parcelRegister("jxMus", function(module, exports) {

$parcel$export(module.exports, "maybeDeepFreeze", () => $e3a6b690dcbed04e$export$7f9c177735b71f18);

var $1MCRf = parcelRequire("1MCRf");
function $e3a6b690dcbed04e$var$deepFreeze(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $1MCRf.isNonNullObject)(obj) && $e3a6b690dcbed04e$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $1MCRf.isNonNullObject)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $e3a6b690dcbed04e$var$shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
        // they all throw a TypeError when you try, so we re-throw any exceptions
        // that are not TypeErrors, since that would be unexpected.
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $e3a6b690dcbed04e$export$7f9c177735b71f18(obj) {
    if (globalThis.__DEV__ !== false) $e3a6b690dcbed04e$var$deepFreeze(obj);
    return obj;
}

});

parcelRegister("jHSHK", function(module, exports) {

$parcel$export(module.exports, "shouldInclude", () => $e58c77b1d7c9a1bd$export$3dc388a5f013b4a5);
$parcel$export(module.exports, "hasDirectives", () => $e58c77b1d7c9a1bd$export$2dafb573e282fe8d);
$parcel$export(module.exports, "hasClientExports", () => $e58c77b1d7c9a1bd$export$8d1e9e5bbfa5d09a);
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $961BR = parcelRequire("961BR");
function $e58c77b1d7c9a1bd$export$3dc388a5f013b4a5(_a, variables) {
    var directives = _a.directives;
    if (!directives || !directives.length) return true;
    return $e58c77b1d7c9a1bd$export$b7bdffb7e6f1ef53(directives).every(function(_a) {
        var directive = _a.directive, ifArgument = _a.ifArgument;
        var evaledValue = false;
        if (ifArgument.value.kind === "Variable") {
            evaledValue = variables && variables[ifArgument.value.name.value];
            (0, $kL4FQ.invariant)(evaledValue !== void 0, 67, directive.name.value);
        } else evaledValue = ifArgument.value.value;
        return directive.name.value === "skip" ? !evaledValue : evaledValue;
    });
}
function $e58c77b1d7c9a1bd$export$1b217de6ce18b9a(root) {
    var names = [];
    (0, $961BR.visit)(root, {
        Directive: function(node) {
            names.push(node.name.value);
        }
    });
    return names;
}
var $e58c77b1d7c9a1bd$export$528b5e7d8ba07fbf = function(names, root) {
    return $e58c77b1d7c9a1bd$export$2dafb573e282fe8d(names, root, false);
};
var $e58c77b1d7c9a1bd$export$ad1b63b26c1a9b76 = function(names, root) {
    return $e58c77b1d7c9a1bd$export$2dafb573e282fe8d(names, root, true);
};
function $e58c77b1d7c9a1bd$export$2dafb573e282fe8d(names, root, all) {
    var nameSet = new Set(names);
    var uniqueCount = nameSet.size;
    (0, $961BR.visit)(root, {
        Directive: function(node) {
            if (nameSet.delete(node.name.value) && (!all || !nameSet.size)) return 0, $961BR.BREAK;
        }
    });
    // If we found all the names, nameSet will be empty. If we only care about
    // finding some of them, the < condition is sufficient.
    return all ? !nameSet.size : nameSet.size < uniqueCount;
}
function $e58c77b1d7c9a1bd$export$8d1e9e5bbfa5d09a(document) {
    return document && $e58c77b1d7c9a1bd$export$2dafb573e282fe8d([
        "client",
        "export"
    ], document, true);
}
function $e58c77b1d7c9a1bd$var$isInclusionDirective(_a) {
    var value = _a.name.value;
    return value === "skip" || value === "include";
}
function $e58c77b1d7c9a1bd$export$b7bdffb7e6f1ef53(directives) {
    var result = [];
    if (directives && directives.length) directives.forEach(function(directive) {
        if (!$e58c77b1d7c9a1bd$var$isInclusionDirective(directive)) return;
        var directiveArguments = directive.arguments;
        var directiveName = directive.name.value;
        (0, $kL4FQ.invariant)(directiveArguments && directiveArguments.length === 1, 68, directiveName);
        var ifArgument = directiveArguments[0];
        (0, $kL4FQ.invariant)(ifArgument.name && ifArgument.name.value === "if", 69, directiveName);
        var ifValue = ifArgument.value;
        // means it has to be a variable value if this is a valid @skip or @include directive
        (0, $kL4FQ.invariant)(ifValue && (ifValue.kind === "Variable" || ifValue.kind === "BooleanValue"), 70, directiveName);
        result.push({
            directive: directive,
            ifArgument: ifArgument
        });
    });
    return result;
}

});

parcelRegister("eDlCq", function(module, exports) {

$parcel$export(module.exports, "EntityStore", () => $aa757a3b4e915492$export$cb507f57054c7321);
$parcel$export(module.exports, "maybeDependOnExistenceOfEntity", () => $aa757a3b4e915492$export$f8068a30967ddc18);
$parcel$export(module.exports, "supportsResultCaching", () => $aa757a3b4e915492$export$488c0743feab3d61);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");
parcelRequire("bDsPx");
var $aFBFG = parcelRequire("aFBFG");

var $hr8gD = parcelRequire("hr8gD");

var $6CRCP = parcelRequire("6CRCP");

var $7X1wJ = parcelRequire("7X1wJ");
var $64d3o = parcelRequire("64d3o");
var $1MCRf = parcelRequire("1MCRf");
var $6dwmd = parcelRequire("6dwmd");
var $jxMus = parcelRequire("jxMus");

var $eiege = parcelRequire("eiege");
var $aa757a3b4e915492$var$DELETE = Object.create(null);
var $aa757a3b4e915492$var$delModifier = function() {
    return $aa757a3b4e915492$var$DELETE;
};
var $aa757a3b4e915492$var$INVALIDATE = Object.create(null);
var $aa757a3b4e915492$export$cb507f57054c7321 = /** @class */ function() {
    function EntityStore(policies, group) {
        var _this = this;
        this.policies = policies;
        this.group = group;
        this.data = Object.create(null);
        // Maps root entity IDs to the number of times they have been retained, minus
        // the number of times they have been released. Retained entities keep other
        // entities they reference (even indirectly) from being garbage collected.
        this.rootIds = Object.create(null);
        // Lazily tracks { __ref: <dataId> } strings contained by this.data[dataId].
        this.refs = Object.create(null);
        // Bound function that can be passed around to provide easy access to fields
        // of Reference objects as well as ordinary objects.
        this.getFieldValue = function(objectOrReference, storeFieldName) {
            return (0, $jxMus.maybeDeepFreeze)((0, $6dwmd.isReference)(objectOrReference) ? _this.get(objectOrReference.__ref, storeFieldName) : objectOrReference && objectOrReference[storeFieldName]);
        };
        // Returns true for non-normalized StoreObjects and non-dangling
        // References, indicating that readField(name, objOrRef) has a chance of
        // working. Useful for filtering out dangling references from lists.
        this.canRead = function(objOrRef) {
            return (0, $6dwmd.isReference)(objOrRef) ? _this.has(objOrRef.__ref) : typeof objOrRef === "object";
        };
        // Bound function that converts an id or an object with a __typename and
        // primary key fields to a Reference object. If called with a Reference object,
        // that same Reference object is returned. Pass true for mergeIntoStore to persist
        // an object into the store.
        this.toReference = function(objOrIdOrRef, mergeIntoStore) {
            if (typeof objOrIdOrRef === "string") return (0, $6dwmd.makeReference)(objOrIdOrRef);
            if ((0, $6dwmd.isReference)(objOrIdOrRef)) return objOrIdOrRef;
            var id = _this.policies.identify(objOrIdOrRef)[0];
            if (id) {
                var ref = (0, $6dwmd.makeReference)(id);
                if (mergeIntoStore) _this.merge(id, objOrIdOrRef);
                return ref;
            }
        };
    }
    // Although the EntityStore class is abstract, it contains concrete
    // implementations of the various NormalizedCache interface methods that
    // are inherited by the Root and Layer subclasses.
    EntityStore.prototype.toObject = function() {
        return (0, $fKE23.__assign)({}, this.data);
    };
    EntityStore.prototype.has = function(dataId) {
        return this.lookup(dataId, true) !== void 0;
    };
    EntityStore.prototype.get = function(dataId, fieldName) {
        this.group.depend(dataId, fieldName);
        if ((0, $eiege.hasOwn).call(this.data, dataId)) {
            var storeObject = this.data[dataId];
            if (storeObject && (0, $eiege.hasOwn).call(storeObject, fieldName)) return storeObject[fieldName];
        }
        if (fieldName === "__typename" && (0, $eiege.hasOwn).call(this.policies.rootTypenamesById, dataId)) return this.policies.rootTypenamesById[dataId];
        if (this instanceof $aa757a3b4e915492$var$Layer) return this.parent.get(dataId, fieldName);
    };
    EntityStore.prototype.lookup = function(dataId, dependOnExistence) {
        // The has method (above) calls lookup with dependOnExistence = true, so
        // that it can later be invalidated when we add or remove a StoreObject for
        // this dataId. Any consumer who cares about the contents of the StoreObject
        // should not rely on this dependency, since the contents could change
        // without the object being added or removed.
        if (dependOnExistence) this.group.depend(dataId, "__exists");
        if ((0, $eiege.hasOwn).call(this.data, dataId)) return this.data[dataId];
        if (this instanceof $aa757a3b4e915492$var$Layer) return this.parent.lookup(dataId, dependOnExistence);
        if (this.policies.rootTypenamesById[dataId]) return Object.create(null);
    };
    EntityStore.prototype.merge = function(older, newer) {
        var _this = this;
        var dataId;
        // Convert unexpected references to ID strings.
        if ((0, $6dwmd.isReference)(older)) older = older.__ref;
        if ((0, $6dwmd.isReference)(newer)) newer = newer.__ref;
        var existing = typeof older === "string" ? this.lookup(dataId = older) : older;
        var incoming = typeof newer === "string" ? this.lookup(dataId = newer) : newer;
        // If newer was a string ID, but that ID was not defined in this store,
        // then there are no fields to be merged, so we're done.
        if (!incoming) return;
        (0, $kL4FQ.invariant)(typeof dataId === "string", 1);
        var merged = new (0, $64d3o.DeepMerger)($aa757a3b4e915492$var$storeObjectReconciler).merge(existing, incoming);
        // Even if merged === existing, existing may have come from a lower
        // layer, so we always need to set this.data[dataId] on this level.
        this.data[dataId] = merged;
        if (merged !== existing) {
            delete this.refs[dataId];
            if (this.group.caching) {
                var fieldsToDirty_1 = Object.create(null);
                // If we added a new StoreObject where there was previously none, dirty
                // anything that depended on the existence of this dataId, such as the
                // EntityStore#has method.
                if (!existing) fieldsToDirty_1.__exists = 1;
                // Now invalidate dependents who called getFieldValue for any fields
                // that are changing as a result of this merge.
                Object.keys(incoming).forEach(function(storeFieldName) {
                    if (!existing || existing[storeFieldName] !== merged[storeFieldName]) {
                        // Always dirty the full storeFieldName, which may include
                        // serialized arguments following the fieldName prefix.
                        fieldsToDirty_1[storeFieldName] = 1;
                        // Also dirty fieldNameFromStoreName(storeFieldName) if it's
                        // different from storeFieldName and this field does not have
                        // keyArgs configured, because that means the cache can't make
                        // any assumptions about how field values with the same field
                        // name but different arguments might be interrelated, so it
                        // must err on the side of invalidating all field values that
                        // share the same short fieldName, regardless of arguments.
                        var fieldName = (0, $eiege.fieldNameFromStoreName)(storeFieldName);
                        if (fieldName !== storeFieldName && !_this.policies.hasKeyArgs(merged.__typename, fieldName)) fieldsToDirty_1[fieldName] = 1;
                        // If merged[storeFieldName] has become undefined, and this is the
                        // Root layer, actually delete the property from the merged object,
                        // which is guaranteed to have been created fresh in this method.
                        if (merged[storeFieldName] === void 0 && !(_this instanceof $aa757a3b4e915492$var$Layer)) delete merged[storeFieldName];
                    }
                });
                if (fieldsToDirty_1.__typename && !(existing && existing.__typename) && // Since we return default root __typename strings
                // automatically from store.get, we don't need to dirty the
                // ROOT_QUERY.__typename field if merged.__typename is equal
                // to the default string (usually "Query").
                this.policies.rootTypenamesById[dataId] === merged.__typename) delete fieldsToDirty_1.__typename;
                Object.keys(fieldsToDirty_1).forEach(function(fieldName) {
                    return _this.group.dirty(dataId, fieldName);
                });
            }
        }
    };
    EntityStore.prototype.modify = function(dataId, fields) {
        var _this = this;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var changedFields_1 = Object.create(null);
            var needToMerge_1 = false;
            var allDeleted_1 = true;
            var sharedDetails_1 = {
                DELETE: $aa757a3b4e915492$var$DELETE,
                INVALIDATE: $aa757a3b4e915492$var$INVALIDATE,
                isReference: (0, $6dwmd.isReference),
                toReference: this.toReference,
                canRead: this.canRead,
                readField: function(fieldNameOrOptions, from) {
                    return _this.policies.readField(typeof fieldNameOrOptions === "string" ? {
                        fieldName: fieldNameOrOptions,
                        from: from || (0, $6dwmd.makeReference)(dataId)
                    } : fieldNameOrOptions, {
                        store: _this
                    });
                }
            };
            Object.keys(storeObject).forEach(function(storeFieldName) {
                var fieldName = (0, $eiege.fieldNameFromStoreName)(storeFieldName);
                var fieldValue = storeObject[storeFieldName];
                if (fieldValue === void 0) return;
                var modify = typeof fields === "function" ? fields : fields[storeFieldName] || fields[fieldName];
                if (modify) {
                    var newValue = modify === $aa757a3b4e915492$var$delModifier ? $aa757a3b4e915492$var$DELETE : modify((0, $jxMus.maybeDeepFreeze)(fieldValue), (0, $fKE23.__assign)((0, $fKE23.__assign)({}, sharedDetails_1), {
                        fieldName: fieldName,
                        storeFieldName: storeFieldName,
                        storage: _this.getStorage(dataId, storeFieldName)
                    }));
                    if (newValue === $aa757a3b4e915492$var$INVALIDATE) _this.group.dirty(dataId, storeFieldName);
                    else {
                        if (newValue === $aa757a3b4e915492$var$DELETE) newValue = void 0;
                        if (newValue !== fieldValue) {
                            changedFields_1[storeFieldName] = newValue;
                            needToMerge_1 = true;
                            fieldValue = newValue;
                            if (globalThis.__DEV__ !== false) {
                                var checkReference = function(ref) {
                                    if (_this.lookup(ref.__ref) === undefined) {
                                        globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).warn(2, ref);
                                        return true;
                                    }
                                };
                                if ((0, $6dwmd.isReference)(newValue)) checkReference(newValue);
                                else if (Array.isArray(newValue)) {
                                    // Warn about writing "mixed" arrays of Reference and non-Reference objects
                                    var seenReference = false;
                                    var someNonReference = void 0;
                                    for(var _i = 0, newValue_1 = newValue; _i < newValue_1.length; _i++){
                                        var value = newValue_1[_i];
                                        if ((0, $6dwmd.isReference)(value)) {
                                            seenReference = true;
                                            if (checkReference(value)) break;
                                        } else // Do not warn on primitive values, since those could never be represented
                                        // by a reference. This is a valid (albeit uncommon) use case.
                                        if (typeof value === "object" && !!value) {
                                            var id = _this.policies.identify(value)[0];
                                            // check if object could even be referenced, otherwise we are not interested in it for this warning
                                            if (id) someNonReference = value;
                                        }
                                        if (seenReference && someNonReference !== undefined) {
                                            globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).warn(3, someNonReference);
                                            break;
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
                if (fieldValue !== void 0) allDeleted_1 = false;
            });
            if (needToMerge_1) {
                this.merge(dataId, changedFields_1);
                if (allDeleted_1) {
                    if (this instanceof $aa757a3b4e915492$var$Layer) this.data[dataId] = void 0;
                    else delete this.data[dataId];
                    this.group.dirty(dataId, "__exists");
                }
                return true;
            }
        }
        return false;
    };
    // If called with only one argument, removes the entire entity
    // identified by dataId. If called with a fieldName as well, removes all
    // fields of that entity whose names match fieldName according to the
    // fieldNameFromStoreName helper function. If called with a fieldName
    // and variables, removes all fields of that entity whose names match fieldName
    // and whose arguments when cached exactly match the variables passed.
    EntityStore.prototype.delete = function(dataId, fieldName, args) {
        var _a;
        var storeObject = this.lookup(dataId);
        if (storeObject) {
            var typename = this.getFieldValue(storeObject, "__typename");
            var storeFieldName = fieldName && args ? this.policies.getStoreFieldName({
                typename: typename,
                fieldName: fieldName,
                args: args
            }) : fieldName;
            return this.modify(dataId, storeFieldName ? (_a = {}, _a[storeFieldName] = $aa757a3b4e915492$var$delModifier, _a) : $aa757a3b4e915492$var$delModifier);
        }
        return false;
    };
    EntityStore.prototype.evict = function(options, limit) {
        var evicted = false;
        if (options.id) {
            if ((0, $eiege.hasOwn).call(this.data, options.id)) evicted = this.delete(options.id, options.fieldName, options.args);
            if (this instanceof $aa757a3b4e915492$var$Layer && this !== limit) evicted = this.parent.evict(options, limit) || evicted;
            // Always invalidate the field to trigger rereading of watched
            // queries, even if no cache data was modified by the eviction,
            // because queries may depend on computed fields with custom read
            // functions, whose values are not stored in the EntityStore.
            if (options.fieldName || evicted) this.group.dirty(options.id, options.fieldName || "__exists");
        }
        return evicted;
    };
    EntityStore.prototype.clear = function() {
        this.replace(null);
    };
    EntityStore.prototype.extract = function() {
        var _this = this;
        var obj = this.toObject();
        var extraRootIds = [];
        this.getRootIdSet().forEach(function(id) {
            if (!(0, $eiege.hasOwn).call(_this.policies.rootTypenamesById, id)) extraRootIds.push(id);
        });
        if (extraRootIds.length) obj.__META = {
            extraRootIds: extraRootIds.sort()
        };
        return obj;
    };
    EntityStore.prototype.replace = function(newData) {
        var _this = this;
        Object.keys(this.data).forEach(function(dataId) {
            if (!(newData && (0, $eiege.hasOwn).call(newData, dataId))) _this.delete(dataId);
        });
        if (newData) {
            var __META = newData.__META, rest_1 = (0, $fKE23.__rest)(newData, [
                "__META"
            ]);
            Object.keys(rest_1).forEach(function(dataId) {
                _this.merge(dataId, rest_1[dataId]);
            });
            if (__META) __META.extraRootIds.forEach(this.retain, this);
        }
    };
    EntityStore.prototype.retain = function(rootId) {
        return this.rootIds[rootId] = (this.rootIds[rootId] || 0) + 1;
    };
    EntityStore.prototype.release = function(rootId) {
        if (this.rootIds[rootId] > 0) {
            var count = --this.rootIds[rootId];
            if (!count) delete this.rootIds[rootId];
            return count;
        }
        return 0;
    };
    // Return a Set<string> of all the ID strings that have been retained by
    // this layer/root *and* any layers/roots beneath it.
    EntityStore.prototype.getRootIdSet = function(ids) {
        if (ids === void 0) ids = new Set();
        Object.keys(this.rootIds).forEach(ids.add, ids);
        if (this instanceof $aa757a3b4e915492$var$Layer) this.parent.getRootIdSet(ids);
        else // Official singleton IDs like ROOT_QUERY and ROOT_MUTATION are
        // always considered roots for garbage collection, regardless of
        // their retainment counts in this.rootIds.
        Object.keys(this.policies.rootTypenamesById).forEach(ids.add, ids);
        return ids;
    };
    // The goal of garbage collection is to remove IDs from the Root layer of the
    // store that are no longer reachable starting from any IDs that have been
    // explicitly retained (see retain and release, above). Returns an array of
    // dataId strings that were removed from the store.
    EntityStore.prototype.gc = function() {
        var _this = this;
        var ids = this.getRootIdSet();
        var snapshot = this.toObject();
        ids.forEach(function(id) {
            if ((0, $eiege.hasOwn).call(snapshot, id)) {
                // Because we are iterating over an ECMAScript Set, the IDs we add here
                // will be visited in later iterations of the forEach loop only if they
                // were not previously contained by the Set.
                Object.keys(_this.findChildRefIds(id)).forEach(ids.add, ids);
                // By removing IDs from the snapshot object here, we protect them from
                // getting removed from the root store layer below.
                delete snapshot[id];
            }
        });
        var idsToRemove = Object.keys(snapshot);
        if (idsToRemove.length) {
            var root_1 = this;
            while(root_1 instanceof $aa757a3b4e915492$var$Layer)root_1 = root_1.parent;
            idsToRemove.forEach(function(id) {
                return root_1.delete(id);
            });
        }
        return idsToRemove;
    };
    EntityStore.prototype.findChildRefIds = function(dataId) {
        if (!(0, $eiege.hasOwn).call(this.refs, dataId)) {
            var found_1 = this.refs[dataId] = Object.create(null);
            var root = this.data[dataId];
            if (!root) return found_1;
            var workSet_1 = new Set([
                root
            ]);
            // Within the store, only arrays and objects can contain child entity
            // references, so we can prune the traversal using this predicate:
            workSet_1.forEach(function(obj) {
                if ((0, $6dwmd.isReference)(obj)) found_1[obj.__ref] = true;
                if ((0, $1MCRf.isNonNullObject)(obj)) Object.keys(obj).forEach(function(key) {
                    var child = obj[key];
                    // No need to add primitive values to the workSet, since they cannot
                    // contain reference objects.
                    if ((0, $1MCRf.isNonNullObject)(child)) workSet_1.add(child);
                });
            });
        }
        return this.refs[dataId];
    };
    EntityStore.prototype.makeCacheKey = function() {
        return this.group.keyMaker.lookupArray(arguments);
    };
    return EntityStore;
}();
// A single CacheGroup represents a set of one or more EntityStore objects,
// typically the Root store in a CacheGroup by itself, and all active Layer
// stores in a group together. A single EntityStore object belongs to only
// one CacheGroup, store.group. The CacheGroup is responsible for tracking
// dependencies, so store.group is helpful for generating unique keys for
// cached results that need to be invalidated when/if those dependencies
// change. If we used the EntityStore objects themselves as cache keys (that
// is, store rather than store.group), the cache would become unnecessarily
// fragmented by all the different Layer objects. Instead, the CacheGroup
// approach allows all optimistic Layer objects in the same linked list to
// belong to one CacheGroup, with the non-optimistic Root object belonging
// to another CacheGroup, allowing resultCaching dependencies to be tracked
// separately for optimistic and non-optimistic entity data.
var $aa757a3b4e915492$var$CacheGroup = /** @class */ function() {
    function CacheGroup(caching, parent) {
        if (parent === void 0) parent = null;
        this.caching = caching;
        this.parent = parent;
        this.d = null;
        this.resetCaching();
    }
    CacheGroup.prototype.resetCaching = function() {
        this.d = this.caching ? (0, $aFBFG.dep)() : null;
        this.keyMaker = new (0, $6CRCP.Trie)((0, $7X1wJ.canUseWeakMap));
    };
    CacheGroup.prototype.depend = function(dataId, storeFieldName) {
        if (this.d) {
            this.d($aa757a3b4e915492$var$makeDepKey(dataId, storeFieldName));
            var fieldName = (0, $eiege.fieldNameFromStoreName)(storeFieldName);
            if (fieldName !== storeFieldName) // Fields with arguments that contribute extra identifying
            // information to the fieldName (thus forming the storeFieldName)
            // depend not only on the full storeFieldName but also on the
            // short fieldName, so the field can be invalidated using either
            // level of specificity.
            this.d($aa757a3b4e915492$var$makeDepKey(dataId, fieldName));
            if (this.parent) this.parent.depend(dataId, storeFieldName);
        }
    };
    CacheGroup.prototype.dirty = function(dataId, storeFieldName) {
        if (this.d) this.d.dirty($aa757a3b4e915492$var$makeDepKey(dataId, storeFieldName), // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        storeFieldName === "__exists" ? "forget" : "setDirty");
    };
    return CacheGroup;
}();
function $aa757a3b4e915492$var$makeDepKey(dataId, storeFieldName) {
    // Since field names cannot have '#' characters in them, this method
    // of joining the field name and the ID should be unambiguous, and much
    // cheaper than JSON.stringify([dataId, fieldName]).
    return storeFieldName + "#" + dataId;
}
function $aa757a3b4e915492$export$f8068a30967ddc18(store, entityId) {
    if ($aa757a3b4e915492$export$488c0743feab3d61(store)) // We use this pseudo-field __exists elsewhere in the EntityStore code to
    // represent changes in the existence of the entity object identified by
    // entityId. This dependency gets reliably dirtied whenever an object with
    // this ID is deleted (or newly created) within this group, so any result
    // cache entries (for example, StoreReader#executeSelectionSet results) that
    // depend on __exists for this entityId will get dirtied as well, leading to
    // the eventual recomputation (instead of reuse) of those result objects the
    // next time someone reads them from the cache.
    store.group.depend(entityId, "__exists");
}
(function(EntityStore) {
    // Refer to this class as EntityStore.Root outside this namespace.
    var Root = /** @class */ function(_super) {
        (0, $fKE23.__extends)(Root, _super);
        function Root(_a) {
            var policies = _a.policies, _b = _a.resultCaching, resultCaching = _b === void 0 ? true : _b, seed = _a.seed;
            var _this = _super.call(this, policies, new $aa757a3b4e915492$var$CacheGroup(resultCaching)) || this;
            _this.stump = new $aa757a3b4e915492$var$Stump(_this);
            _this.storageTrie = new (0, $6CRCP.Trie)((0, $7X1wJ.canUseWeakMap));
            if (seed) _this.replace(seed);
            return _this;
        }
        Root.prototype.addLayer = function(layerId, replay) {
            // Adding an optimistic Layer on top of the Root actually adds the Layer
            // on top of the Stump, so the Stump always comes between the Root and
            // any Layer objects that we've added.
            return this.stump.addLayer(layerId, replay);
        };
        Root.prototype.removeLayer = function() {
            // Never remove the root layer.
            return this;
        };
        Root.prototype.getStorage = function() {
            return this.storageTrie.lookupArray(arguments);
        };
        return Root;
    }(EntityStore);
    EntityStore.Root = Root;
})($aa757a3b4e915492$export$cb507f57054c7321 || ($aa757a3b4e915492$export$cb507f57054c7321 = {}));
// Not exported, since all Layer instances are created by the addLayer method
// of the EntityStore.Root class.
var $aa757a3b4e915492$var$Layer = /** @class */ function(_super) {
    (0, $fKE23.__extends)(Layer, _super);
    function Layer(id, parent, replay, group) {
        var _this = _super.call(this, parent.policies, group) || this;
        _this.id = id;
        _this.parent = parent;
        _this.replay = replay;
        _this.group = group;
        replay(_this);
        return _this;
    }
    Layer.prototype.addLayer = function(layerId, replay) {
        return new Layer(layerId, this, replay, this.group);
    };
    Layer.prototype.removeLayer = function(layerId) {
        var _this = this;
        // Remove all instances of the given id, not just the first one.
        var parent = this.parent.removeLayer(layerId);
        if (layerId === this.id) {
            if (this.group.caching) // Dirty every ID we're removing. Technically we might be able to avoid
            // dirtying fields that have values in higher layers, but we don't have
            // easy access to higher layers here, and we're about to recreate those
            // layers anyway (see parent.addLayer below).
            Object.keys(this.data).forEach(function(dataId) {
                var ownStoreObject = _this.data[dataId];
                var parentStoreObject = parent["lookup"](dataId);
                if (!parentStoreObject) // The StoreObject identified by dataId was defined in this layer
                // but will be undefined in the parent layer, so we can delete the
                // whole entity using this.delete(dataId). Since we're about to
                // throw this layer away, the only goal of this deletion is to dirty
                // the removed fields.
                _this.delete(dataId);
                else if (!ownStoreObject) {
                    // This layer had an entry for dataId but it was undefined, which
                    // means the entity was deleted in this layer, and it's about to
                    // become undeleted when we remove this layer, so we need to dirty
                    // all fields that are about to be reexposed.
                    _this.group.dirty(dataId, "__exists");
                    Object.keys(parentStoreObject).forEach(function(storeFieldName) {
                        _this.group.dirty(dataId, storeFieldName);
                    });
                } else if (ownStoreObject !== parentStoreObject) // If ownStoreObject is not exactly the same as parentStoreObject,
                // dirty any fields whose values will change as a result of this
                // removal.
                Object.keys(ownStoreObject).forEach(function(storeFieldName) {
                    if (!(0, $hr8gD.equal)(ownStoreObject[storeFieldName], parentStoreObject[storeFieldName])) _this.group.dirty(dataId, storeFieldName);
                });
            });
            return parent;
        }
        // No changes are necessary if the parent chain remains identical.
        if (parent === this.parent) return this;
        // Recreate this layer on top of the new parent.
        return parent.addLayer(this.id, this.replay);
    };
    Layer.prototype.toObject = function() {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.parent.toObject()), this.data);
    };
    Layer.prototype.findChildRefIds = function(dataId) {
        var fromParent = this.parent.findChildRefIds(dataId);
        return (0, $eiege.hasOwn).call(this.data, dataId) ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fromParent), _super.prototype.findChildRefIds.call(this, dataId)) : fromParent;
    };
    Layer.prototype.getStorage = function() {
        var p = this.parent;
        while(p.parent)p = p.parent;
        return p.getStorage.apply(p, // @ts-expect-error
        arguments);
    };
    return Layer;
}($aa757a3b4e915492$export$cb507f57054c7321);
// Represents a Layer permanently installed just above the Root, which allows
// reading optimistically (and registering optimistic dependencies) even when
// no optimistic layers are currently active. The stump.group CacheGroup object
// is shared by any/all Layer objects added on top of the Stump.
var $aa757a3b4e915492$var$Stump = /** @class */ function(_super) {
    (0, $fKE23.__extends)(Stump, _super);
    function Stump(root) {
        return _super.call(this, "EntityStore.Stump", root, function() {}, new $aa757a3b4e915492$var$CacheGroup(root.group.caching, root.group)) || this;
    }
    Stump.prototype.removeLayer = function() {
        // Never remove the Stump layer.
        return this;
    };
    Stump.prototype.merge = function(older, newer) {
        // We never want to write any data into the Stump, so we forward any merge
        // calls to the Root instead. Another option here would be to throw an
        // exception, but the toReference(object, true) function can sometimes
        // trigger Stump writes (which used to be Root writes, before the Stump
        // concept was introduced).
        return this.parent.merge(older, newer);
    };
    return Stump;
}($aa757a3b4e915492$var$Layer);
function $aa757a3b4e915492$var$storeObjectReconciler(existingObject, incomingObject, property) {
    var existingValue = existingObject[property];
    var incomingValue = incomingObject[property];
    // Wherever there is a key collision, prefer the incoming value, unless
    // it is deeply equal to the existing value. It's worth checking deep
    // equality here (even though blindly returning incoming would be
    // logically correct) because preserving the referential identity of
    // existing data can prevent needless rereading and rerendering.
    return (0, $hr8gD.equal)(existingValue, incomingValue) ? existingValue : incomingValue;
}
function $aa757a3b4e915492$export$488c0743feab3d61(store) {
    // When result caching is disabled, store.depend will be null.
    return !!(store instanceof $aa757a3b4e915492$export$cb507f57054c7321 && store.group.caching);
}

});
parcelRegister("eiege", function(module, exports) {

$parcel$export(module.exports, "hasOwn", () => $a67dcf0af63981dd$export$b5a638e9b3fff9f3);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $a67dcf0af63981dd$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "normalizeConfig", () => $a67dcf0af63981dd$export$fa542f9ee3f7f4e2);
$parcel$export(module.exports, "shouldCanonizeResults", () => $a67dcf0af63981dd$export$3ac2a95fbd99c479);
$parcel$export(module.exports, "getTypenameFromStoreObject", () => $a67dcf0af63981dd$export$fdef206c83ff2c09);
$parcel$export(module.exports, "TypeOrFieldNameRegExp", () => $a67dcf0af63981dd$export$6ed54d4784f1ce28);
$parcel$export(module.exports, "fieldNameFromStoreName", () => $a67dcf0af63981dd$export$37874422037b6029);
$parcel$export(module.exports, "selectionSetMatchesResult", () => $a67dcf0af63981dd$export$60bd1cbb09c1a4a2);
$parcel$export(module.exports, "storeValueIsStoreObject", () => $a67dcf0af63981dd$export$4f39afca21bd938e);
$parcel$export(module.exports, "makeProcessedFieldsMerger", () => $a67dcf0af63981dd$export$b874a818f7a2fa6d);
$parcel$export(module.exports, "extractFragmentContext", () => $a67dcf0af63981dd$export$3a33c00f0ae4a480);
$parcel$export(module.exports, "isArray", () => (parcelRequire("kxw1Y")).isArray);

var $jZIxU = parcelRequire("jZIxU");
var $iB2lh = parcelRequire("iB2lh");
var $64d3o = parcelRequire("64d3o");
var $iX694 = parcelRequire("iX694");
var $kxw1Y = parcelRequire("kxw1Y");
var $6dwmd = parcelRequire("6dwmd");
var $1MCRf = parcelRequire("1MCRf");
var $jHSHK = parcelRequire("jHSHK");
var $a67dcf0af63981dd$export$b5a638e9b3fff9f3 = Object.prototype.hasOwnProperty;
function $a67dcf0af63981dd$export$b931b78cbb3caf86(value) {
    return value === null || value === void 0;
}
function $a67dcf0af63981dd$export$bd03c5a9c99d6bce(_a, context) {
    var __typename = _a.__typename, id = _a.id, _id = _a._id;
    if (typeof __typename === "string") {
        if (context) context.keyObject = !$a67dcf0af63981dd$export$b931b78cbb3caf86(id) ? {
            id: id
        } : !$a67dcf0af63981dd$export$b931b78cbb3caf86(_id) ? {
            _id: _id
        } : void 0;
        // If there is no object.id, fall back to object._id.
        if ($a67dcf0af63981dd$export$b931b78cbb3caf86(id) && !$a67dcf0af63981dd$export$b931b78cbb3caf86(_id)) id = _id;
        if (!$a67dcf0af63981dd$export$b931b78cbb3caf86(id)) return "".concat(__typename, ":").concat(typeof id === "number" || typeof id === "string" ? id : JSON.stringify(id));
    }
}
var $a67dcf0af63981dd$var$defaultConfig = {
    dataIdFromObject: $a67dcf0af63981dd$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    // Thanks to the shouldCanonizeResults helper, this should be the only line
    // you have to change to reenable canonization by default in the future.
    canonizeResults: false
};
function $a67dcf0af63981dd$export$fa542f9ee3f7f4e2(config) {
    return (0, $jZIxU.compact)($a67dcf0af63981dd$var$defaultConfig, config);
}
function $a67dcf0af63981dd$export$3ac2a95fbd99c479(config) {
    var value = config.canonizeResults;
    return value === void 0 ? $a67dcf0af63981dd$var$defaultConfig.canonizeResults : value;
}
function $a67dcf0af63981dd$export$fdef206c83ff2c09(store, objectOrReference) {
    return (0, $6dwmd.isReference)(objectOrReference) ? store.get(objectOrReference.__ref, "__typename") : objectOrReference && objectOrReference.__typename;
}
var $a67dcf0af63981dd$export$6ed54d4784f1ce28 = /^[_a-z][_0-9a-z]*/i;
function $a67dcf0af63981dd$export$37874422037b6029(storeFieldName) {
    var match = storeFieldName.match($a67dcf0af63981dd$export$6ed54d4784f1ce28);
    return match ? match[0] : storeFieldName;
}
function $a67dcf0af63981dd$export$60bd1cbb09c1a4a2(selectionSet, result, variables) {
    if ((0, $1MCRf.isNonNullObject)(result)) return (0, $kxw1Y.isArray)(result) ? result.every(function(item) {
        return $a67dcf0af63981dd$export$60bd1cbb09c1a4a2(selectionSet, item, variables);
    }) : selectionSet.selections.every(function(field) {
        if ((0, $6dwmd.isField)(field) && (0, $jHSHK.shouldInclude)(field, variables)) {
            var key = (0, $6dwmd.resultKeyNameFromField)(field);
            return $a67dcf0af63981dd$export$b5a638e9b3fff9f3.call(result, key) && (!field.selectionSet || $a67dcf0af63981dd$export$60bd1cbb09c1a4a2(field.selectionSet, result[key], variables));
        }
        // If the selection has been skipped with @skip(true) or
        // @include(false), it should not count against the matching. If
        // the selection is not a field, it must be a fragment (inline or
        // named). We will determine if selectionSetMatchesResult for that
        // fragment when we get to it, so for now we return true.
        return true;
    });
    return false;
}
function $a67dcf0af63981dd$export$4f39afca21bd938e(value) {
    return (0, $1MCRf.isNonNullObject)(value) && !(0, $6dwmd.isReference)(value) && !(0, $kxw1Y.isArray)(value);
}
function $a67dcf0af63981dd$export$b874a818f7a2fa6d() {
    return new (0, $64d3o.DeepMerger)();
}
function $a67dcf0af63981dd$export$3a33c00f0ae4a480(document, fragments) {
    // FragmentMap consisting only of fragments defined directly in document, not
    // including other fragments registered in the FragmentRegistry.
    var fragmentMap = (0, $iB2lh.createFragmentMap)((0, $iX694.getFragmentDefinitions)(document));
    return {
        fragmentMap: fragmentMap,
        lookupFragment: function(name) {
            var def = fragmentMap[name];
            if (!def && fragments) def = fragments.lookup(name);
            return def || null;
        }
    };
}

});


parcelRegister("31wLM", function(module, exports) {

$parcel$export(module.exports, "ObjectCanon", () => $233ae27167bbc96a$export$c2e7fdd82233f4a4);

var $fKE23 = parcelRequire("fKE23");

var $6CRCP = parcelRequire("6CRCP");

var $7X1wJ = parcelRequire("7X1wJ");
var $1MCRf = parcelRequire("1MCRf");
parcelRequire("eiege");
var $kxw1Y = parcelRequire("kxw1Y");
function $233ae27167bbc96a$var$shallowCopy(value) {
    if ((0, $1MCRf.isNonNullObject)(value)) return (0, $kxw1Y.isArray)(value) ? value.slice(0) : (0, $fKE23.__assign)({
        __proto__: Object.getPrototypeOf(value)
    }, value);
    return value;
}
// When programmers talk about the "canonical form" of an object, they
// usually have the following meaning in mind, which I've copied from
// https://en.wiktionary.org/wiki/canonical_form:
//
// 1. A standard or normal presentation of a mathematical entity [or
//    object]. A canonical form is an element of a set of representatives
//    of equivalence classes of forms such that there is a function or
//    procedure which projects every element of each equivalence class
//    onto that one element, the canonical form of that equivalence
//    class. The canonical form is expected to be simpler than the rest of
//    the forms in some way.
//
// That's a long-winded way of saying any two objects that have the same
// canonical form may be considered equivalent, even if they are !==,
// which usually means the objects are structurally equivalent (deeply
// equal), but don't necessarily use the same memory.
//
// Like a literary or musical canon, this ObjectCanon class represents a
// collection of unique canonical items (JavaScript objects), with the
// important property that canon.admit(a) === canon.admit(b) if a and b
// are deeply equal to each other. In terms of the definition above, the
// canon.admit method is the "function or procedure which projects every"
// object "onto that one element, the canonical form."
//
// In the worst case, the canonicalization process may involve looking at
// every property in the provided object tree, so it takes the same order
// of time as deep equality checking. Fortunately, already-canonicalized
// objects are returned immediately from canon.admit, so the presence of
// canonical subtrees tends to speed up canonicalization.
//
// Since consumers of canonical objects can check for deep equality in
// constant time, canonicalizing cache results can massively improve the
// performance of application code that skips re-rendering unchanged
// results, such as "pure" UI components in a framework like React.
//
// Of course, since canonical objects may be shared widely between
// unrelated consumers, it's important to think of them as immutable, even
// though they are not actually frozen with Object.freeze in production,
// due to the extra performance overhead that comes with frozen objects.
//
// Custom scalar objects whose internal class name is neither Array nor
// Object can be included safely in the admitted tree, but they will not
// be replaced with a canonical version (to put it another way, they are
// assumed to be canonical already).
//
// If we ignore custom objects, no detection of cycles or repeated object
// references is currently required by the StoreReader class, since
// GraphQL result objects are JSON-serializable trees (and thus contain
// neither cycles nor repeated subtrees), so we can avoid the complexity
// of keeping track of objects we've already seen during the recursion of
// the admit method.
//
// In the future, we may consider adding additional cases to the switch
// statement to handle other common object types, such as "[object Date]"
// objects, as needed.
var $233ae27167bbc96a$export$c2e7fdd82233f4a4 = /** @class */ function() {
    function ObjectCanon() {
        // Set of all canonical objects this ObjectCanon has admitted, allowing
        // canon.admit to return previously-canonicalized objects immediately.
        this.known = new ((0, $7X1wJ.canUseWeakSet) ? WeakSet : Set)();
        // Efficient storage/lookup structure for canonical objects.
        this.pool = new (0, $6CRCP.Trie)((0, $7X1wJ.canUseWeakMap));
        // Make the ObjectCanon assume this value has already been
        // canonicalized.
        this.passes = new WeakMap();
        // Arrays that contain the same elements in a different order can share
        // the same SortedKeysInfo object, to save memory.
        this.keysByJSON = new Map();
        // This has to come last because it depends on keysByJSON.
        this.empty = this.admit({});
    }
    ObjectCanon.prototype.isKnown = function(value) {
        return (0, $1MCRf.isNonNullObject)(value) && this.known.has(value);
    };
    ObjectCanon.prototype.pass = function(value) {
        if ((0, $1MCRf.isNonNullObject)(value)) {
            var copy = $233ae27167bbc96a$var$shallowCopy(value);
            this.passes.set(copy, value);
            return copy;
        }
        return value;
    };
    ObjectCanon.prototype.admit = function(value) {
        var _this = this;
        if ((0, $1MCRf.isNonNullObject)(value)) {
            var original = this.passes.get(value);
            if (original) return original;
            var proto = Object.getPrototypeOf(value);
            switch(proto){
                case Array.prototype:
                    if (this.known.has(value)) return value;
                    var array = value.map(this.admit, this);
                    // Arrays are looked up in the Trie using their recursively
                    // canonicalized elements, and the known version of the array is
                    // preserved as node.array.
                    var node = this.pool.lookupArray(array);
                    if (!node.array) {
                        this.known.add(node.array = array);
                        // Since canonical arrays may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(array);
                    }
                    return node.array;
                case null:
                case Object.prototype:
                    if (this.known.has(value)) return value;
                    var proto_1 = Object.getPrototypeOf(value);
                    var array_1 = [
                        proto_1
                    ];
                    var keys = this.sortedKeys(value);
                    array_1.push(keys.json);
                    var firstValueIndex_1 = array_1.length;
                    keys.sorted.forEach(function(key) {
                        array_1.push(_this.admit(value[key]));
                    });
                    // Objects are looked up in the Trie by their prototype (which
                    // is *not* recursively canonicalized), followed by a JSON
                    // representation of their (sorted) keys, followed by the
                    // sequence of recursively canonicalized values corresponding to
                    // those keys. To keep the final results unambiguous with other
                    // sequences (such as arrays that just happen to contain [proto,
                    // keys.json, value1, value2, ...]), the known version of the
                    // object is stored as node.object.
                    var node = this.pool.lookupArray(array_1);
                    if (!node.object) {
                        var obj_1 = node.object = Object.create(proto_1);
                        this.known.add(obj_1);
                        keys.sorted.forEach(function(key, i) {
                            obj_1[key] = array_1[firstValueIndex_1 + i];
                        });
                        // Since canonical objects may be shared widely between
                        // unrelated consumers, it's important to regard them as
                        // immutable, even if they are not frozen in production.
                        if (globalThis.__DEV__ !== false) Object.freeze(obj_1);
                    }
                    return node.object;
            }
        }
        return value;
    };
    // It's worthwhile to cache the sorting of arrays of strings, since the
    // same initial unsorted arrays tend to be encountered many times.
    // Fortunately, we can reuse the Trie machinery to look up the sorted
    // arrays in linear time (which is faster than sorting large arrays).
    ObjectCanon.prototype.sortedKeys = function(obj) {
        var keys = Object.keys(obj);
        var node = this.pool.lookupArray(keys);
        if (!node.keys) {
            keys.sort();
            var json = JSON.stringify(keys);
            if (!(node.keys = this.keysByJSON.get(json))) this.keysByJSON.set(json, node.keys = {
                sorted: keys,
                json: json
            });
        }
        return node.keys;
    };
    return ObjectCanon;
}();

});


parcelRegister("7D3jO", function(module, exports) {

$parcel$export(module.exports, "StoreWriter", () => $58debfe6f26331cf$export$eb8361c5d132fb8f);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $hr8gD = parcelRequire("hr8gD");

var $6CRCP = parcelRequire("6CRCP");

var $1c4hI = parcelRequire("1c4hI");

var $1CBce = parcelRequire("1CBce");
var $6dwmd = parcelRequire("6dwmd");
var $5bIMC = parcelRequire("5bIMC");
var $awPNv = parcelRequire("awPNv");
var $iX694 = parcelRequire("iX694");
var $iB2lh = parcelRequire("iB2lh");
var $kxw1Y = parcelRequire("kxw1Y");
var $jHSHK = parcelRequire("jHSHK");

var $eiege = parcelRequire("eiege");
var $kxw1Y = parcelRequire("kxw1Y");

var $9FSTq = parcelRequire("9FSTq");
// Since there are only four possible combinations of context.clientOnly and
// context.deferred values, we should need at most four "flavors" of any given
// WriteContext. To avoid creating multiple copies of the same context, we cache
// the contexts in the context.flavors Map (shared by all flavors) according to
// their clientOnly and deferred values (always in that order).
function $58debfe6f26331cf$var$getContextFlavor(context, clientOnly, deferred) {
    var key = "".concat(clientOnly).concat(deferred);
    var flavored = context.flavors.get(key);
    if (!flavored) context.flavors.set(key, flavored = context.clientOnly === clientOnly && context.deferred === deferred ? context : (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
        clientOnly: clientOnly,
        deferred: deferred
    }));
    return flavored;
}
var $58debfe6f26331cf$export$eb8361c5d132fb8f = /** @class */ function() {
    function StoreWriter(cache, reader, fragments) {
        this.cache = cache;
        this.reader = reader;
        this.fragments = fragments;
    }
    StoreWriter.prototype.writeToStore = function(store, _a) {
        var _this = this;
        var query = _a.query, result = _a.result, dataId = _a.dataId, variables = _a.variables, overwrite = _a.overwrite;
        var operationDefinition = (0, $iX694.getOperationDefinition)(query);
        var merger = (0, $eiege.makeProcessedFieldsMerger)();
        variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, (0, $iX694.getDefaultValues)(operationDefinition)), variables);
        var context = (0, $fKE23.__assign)((0, $fKE23.__assign)({
            store: store,
            written: Object.create(null),
            merge: function(existing, incoming) {
                return merger.merge(existing, incoming);
            },
            variables: variables,
            varString: (0, $5bIMC.canonicalStringify)(variables)
        }, (0, $eiege.extractFragmentContext)(query, this.fragments)), {
            overwrite: !!overwrite,
            incomingById: new Map(),
            clientOnly: false,
            deferred: false,
            flavors: new Map()
        });
        var ref = this.processSelectionSet({
            result: result || Object.create(null),
            dataId: dataId,
            selectionSet: operationDefinition.selectionSet,
            mergeTree: {
                map: new Map()
            },
            context: context
        });
        if (!(0, $6dwmd.isReference)(ref)) throw (0, $kL4FQ.newInvariantError)(11, result);
        // So far, the store has not been modified, so now it's time to process
        // context.incomingById and merge those incoming fields into context.store.
        context.incomingById.forEach(function(_a, dataId) {
            var storeObject = _a.storeObject, mergeTree = _a.mergeTree, fieldNodeSet = _a.fieldNodeSet;
            var entityRef = (0, $6dwmd.makeReference)(dataId);
            if (mergeTree && mergeTree.map.size) {
                var applied = _this.applyMerges(mergeTree, entityRef, storeObject, context);
                if ((0, $6dwmd.isReference)(applied)) // Assume References returned by applyMerges have already been merged
                // into the store. See makeMergeObjectsFunction in policies.ts for an
                // example of how this can happen.
                return;
                // Otherwise, applyMerges returned a StoreObject, whose fields we should
                // merge into the store (see store.merge statement below).
                storeObject = applied;
            }
            if (globalThis.__DEV__ !== false && !context.overwrite) {
                var fieldsWithSelectionSets_1 = Object.create(null);
                fieldNodeSet.forEach(function(field) {
                    if (field.selectionSet) fieldsWithSelectionSets_1[field.name.value] = true;
                });
                var hasSelectionSet_1 = function(storeFieldName) {
                    return fieldsWithSelectionSets_1[(0, $eiege.fieldNameFromStoreName)(storeFieldName)] === true;
                };
                var hasMergeFunction_1 = function(storeFieldName) {
                    var childTree = mergeTree && mergeTree.map.get(storeFieldName);
                    return Boolean(childTree && childTree.info && childTree.info.merge);
                };
                Object.keys(storeObject).forEach(function(storeFieldName) {
                    // If a merge function was defined for this field, trust that it
                    // did the right thing about (not) clobbering data. If the field
                    // has no selection set, it's a scalar field, so it doesn't need
                    // a merge function (even if it's an object, like JSON data).
                    if (hasSelectionSet_1(storeFieldName) && !hasMergeFunction_1(storeFieldName)) $58debfe6f26331cf$var$warnAboutDataLoss(entityRef, storeObject, storeFieldName, context.store);
                });
            }
            store.merge(dataId, storeObject);
        });
        // Any IDs written explicitly to the cache will be retained as
        // reachable root IDs for garbage collection purposes. Although this
        // logic includes root IDs like ROOT_QUERY and ROOT_MUTATION, their
        // retainment counts are effectively ignored because cache.gc() always
        // includes them in its root ID set.
        store.retain(ref.__ref);
        return ref;
    };
    StoreWriter.prototype.processSelectionSet = function(_a) {
        var _this = this;
        var dataId = _a.dataId, result = _a.result, selectionSet = _a.selectionSet, context = _a.context, // This object allows processSelectionSet to report useful information
        // to its callers without explicitly returning that information.
        mergeTree = _a.mergeTree;
        var policies = this.cache.policies;
        // This variable will be repeatedly updated using context.merge to
        // accumulate all fields that need to be written into the store.
        var incoming = Object.create(null);
        // If typename was not passed in, infer it. Note that typename is
        // always passed in for tricky-to-infer cases such as "Query" for
        // ROOT_QUERY.
        var typename = dataId && policies.rootTypenamesById[dataId] || (0, $6dwmd.getTypenameFromResult)(result, selectionSet, context.fragmentMap) || dataId && context.store.get(dataId, "__typename");
        if ("string" === typeof typename) incoming.__typename = typename;
        // This readField function will be passed as context.readField in the
        // KeyFieldsContext object created within policies.identify (called below).
        // In addition to reading from the existing context.store (thanks to the
        // policies.readField(options, context) line at the very bottom), this
        // version of readField can read from Reference objects that are currently
        // pending in context.incomingById, which is important whenever keyFields
        // need to be extracted from a child object that processSelectionSet has
        // turned into a Reference.
        var readField = function() {
            var options = (0, $9FSTq.normalizeReadFieldOptions)(arguments, incoming, context.variables);
            if ((0, $6dwmd.isReference)(options.from)) {
                var info = context.incomingById.get(options.from.__ref);
                if (info) {
                    var result_1 = policies.readField((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                        from: info.storeObject
                    }), context);
                    if (result_1 !== void 0) return result_1;
                }
            }
            return policies.readField(options, context);
        };
        var fieldNodeSet = new Set();
        this.flattenFields(selectionSet, result, // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        context, typename).forEach(function(context, field) {
            var _a;
            var resultFieldKey = (0, $6dwmd.resultKeyNameFromField)(field);
            var value = result[resultFieldKey];
            fieldNodeSet.add(field);
            if (value !== void 0) {
                var storeFieldName = policies.getStoreFieldName({
                    typename: typename,
                    fieldName: field.name.value,
                    field: field,
                    variables: context.variables
                });
                var childTree = $58debfe6f26331cf$var$getChildMergeTree(mergeTree, storeFieldName);
                var incomingValue = _this.processFieldValue(value, field, // Reset context.clientOnly and context.deferred to their default
                // values before processing nested selection sets.
                field.selectionSet ? $58debfe6f26331cf$var$getContextFlavor(context, false, false) : context, childTree);
                // To determine if this field holds a child object with a merge function
                // defined in its type policy (see PR #7070), we need to figure out the
                // child object's __typename.
                var childTypename = void 0;
                // The field's value can be an object that has a __typename only if the
                // field has a selection set. Otherwise incomingValue is scalar.
                if (field.selectionSet && ((0, $6dwmd.isReference)(incomingValue) || (0, $eiege.storeValueIsStoreObject)(incomingValue))) childTypename = readField("__typename", incomingValue);
                var merge = policies.getMergeFunction(typename, field.name.value, childTypename);
                if (merge) childTree.info = {
                    // TODO Check compatibility against any existing childTree.field?
                    field: field,
                    typename: typename,
                    merge: merge
                };
                else $58debfe6f26331cf$var$maybeRecycleChildMergeTree(mergeTree, storeFieldName);
                incoming = context.merge(incoming, (_a = {}, _a[storeFieldName] = incomingValue, _a));
            } else if (globalThis.__DEV__ !== false && !context.clientOnly && !context.deferred && !(0, $1CBce.addTypenameToDocument).added(field) && // If the field has a read function, it may be a synthetic field or
            // provide a default value, so its absence from the written data should
            // not be cause for alarm.
            !policies.getReadFunction(typename, field.name.value)) globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).error(12, (0, $6dwmd.resultKeyNameFromField)(field), result);
        });
        // Identify the result object, even if dataId was already provided,
        // since we always need keyObject below.
        try {
            var _b = policies.identify(result, {
                typename: typename,
                selectionSet: selectionSet,
                fragmentMap: context.fragmentMap,
                storeObject: incoming,
                readField: readField
            }), id = _b[0], keyObject = _b[1];
            // If dataId was not provided, fall back to the id just generated by
            // policies.identify.
            dataId = dataId || id;
            // Write any key fields that were used during identification, even if
            // they were not mentioned in the original query.
            if (keyObject) // TODO Reverse the order of the arguments?
            incoming = context.merge(incoming, keyObject);
        } catch (e) {
            // If dataId was provided, tolerate failure of policies.identify.
            if (!dataId) throw e;
        }
        if ("string" === typeof dataId) {
            var dataRef = (0, $6dwmd.makeReference)(dataId);
            // Avoid processing the same entity object using the same selection
            // set more than once. We use an array instead of a Set since most
            // entity IDs will be written using only one selection set, so the
            // size of this array is likely to be very small, meaning indexOf is
            // likely to be faster than Set.prototype.has.
            var sets = context.written[dataId] || (context.written[dataId] = []);
            if (sets.indexOf(selectionSet) >= 0) return dataRef;
            sets.push(selectionSet);
            // If we're about to write a result object into the store, but we
            // happen to know that the exact same (===) result object would be
            // returned if we were to reread the result with the same inputs,
            // then we can skip the rest of the processSelectionSet work for
            // this object, and immediately return a Reference to it.
            if (this.reader && this.reader.isFresh(result, dataRef, selectionSet, context)) return dataRef;
            var previous_1 = context.incomingById.get(dataId);
            if (previous_1) {
                previous_1.storeObject = context.merge(previous_1.storeObject, incoming);
                previous_1.mergeTree = $58debfe6f26331cf$var$mergeMergeTrees(previous_1.mergeTree, mergeTree);
                fieldNodeSet.forEach(function(field) {
                    return previous_1.fieldNodeSet.add(field);
                });
            } else context.incomingById.set(dataId, {
                storeObject: incoming,
                // Save a reference to mergeTree only if it is not empty, because
                // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
                // reused for entirely different parts of the result tree.
                mergeTree: $58debfe6f26331cf$var$mergeTreeIsEmpty(mergeTree) ? void 0 : mergeTree,
                fieldNodeSet: fieldNodeSet
            });
            return dataRef;
        }
        return incoming;
    };
    StoreWriter.prototype.processFieldValue = function(value, field, context, mergeTree) {
        var _this = this;
        if (!field.selectionSet || value === null) // In development, we need to clone scalar values so that they can be
        // safely frozen with maybeDeepFreeze in readFromStore.ts. In production,
        // it's cheaper to store the scalar values directly in the cache.
        return globalThis.__DEV__ !== false ? (0, $awPNv.cloneDeep)(value) : value;
        if ((0, $kxw1Y.isArray)(value)) return value.map(function(item, i) {
            var value = _this.processFieldValue(item, field, context, $58debfe6f26331cf$var$getChildMergeTree(mergeTree, i));
            $58debfe6f26331cf$var$maybeRecycleChildMergeTree(mergeTree, i);
            return value;
        });
        return this.processSelectionSet({
            result: value,
            selectionSet: field.selectionSet,
            context: context,
            mergeTree: mergeTree
        });
    };
    // Implements https://spec.graphql.org/draft/#sec-Field-Collection, but with
    // some additions for tracking @client and @defer directives.
    StoreWriter.prototype.flattenFields = function(selectionSet, result, context, typename) {
        if (typename === void 0) typename = (0, $6dwmd.getTypenameFromResult)(result, selectionSet, context.fragmentMap);
        var fieldMap = new Map();
        var policies = this.cache.policies;
        var limitingTrie = new (0, $6CRCP.Trie)(false); // No need for WeakMap, since limitingTrie does not escape.
        (function flatten(selectionSet, inheritedContext) {
            var visitedNode = limitingTrie.lookup(selectionSet, // Because we take inheritedClientOnly and inheritedDeferred into
            // consideration here (in addition to selectionSet), it's possible for
            // the same selection set to be flattened more than once, if it appears
            // in the query with different @client and/or @directive configurations.
            inheritedContext.clientOnly, inheritedContext.deferred);
            if (visitedNode.visited) return;
            visitedNode.visited = true;
            selectionSet.selections.forEach(function(selection) {
                if (!(0, $jHSHK.shouldInclude)(selection, context.variables)) return;
                var clientOnly = inheritedContext.clientOnly, deferred = inheritedContext.deferred;
                if (// Since the presence of @client or @defer on this field can only
                // cause clientOnly or deferred to become true, we can skip the
                // forEach loop if both clientOnly and deferred are already true.
                !(clientOnly && deferred) && (0, $kxw1Y.isNonEmptyArray)(selection.directives)) selection.directives.forEach(function(dir) {
                    var name = dir.name.value;
                    if (name === "client") clientOnly = true;
                    if (name === "defer") {
                        var args = (0, $6dwmd.argumentsObjectFromField)(dir, context.variables);
                        // The @defer directive takes an optional args.if boolean
                        // argument, similar to @include(if: boolean). Note that
                        // @defer(if: false) does not make context.deferred false, but
                        // instead behaves as if there was no @defer directive.
                        if (!args || args.if !== false) deferred = true;
                    // TODO In the future, we may want to record args.label using
                    // context.deferred, if a label is specified.
                    }
                });
                if ((0, $6dwmd.isField)(selection)) {
                    var existing = fieldMap.get(selection);
                    if (existing) {
                        // If this field has been visited along another recursive path
                        // before, the final context should have clientOnly or deferred set
                        // to true only if *all* paths have the directive (hence the &&).
                        clientOnly = clientOnly && existing.clientOnly;
                        deferred = deferred && existing.deferred;
                    }
                    fieldMap.set(selection, $58debfe6f26331cf$var$getContextFlavor(context, clientOnly, deferred));
                } else {
                    var fragment = (0, $iB2lh.getFragmentFromSelection)(selection, context.lookupFragment);
                    if (!fragment && selection.kind === (0, $1c4hI.Kind).FRAGMENT_SPREAD) throw (0, $kL4FQ.newInvariantError)(13, selection.name.value);
                    if (fragment && policies.fragmentMatches(fragment, typename, result, context.variables)) flatten(fragment.selectionSet, $58debfe6f26331cf$var$getContextFlavor(context, clientOnly, deferred));
                }
            });
        })(selectionSet, context);
        return fieldMap;
    };
    StoreWriter.prototype.applyMerges = function(mergeTree, existing, incoming, context, getStorageArgs) {
        var _a;
        var _this = this;
        if (mergeTree.map.size && !(0, $6dwmd.isReference)(incoming)) {
            var e_1 = // Items in the same position in different arrays are not
            // necessarily related to each other, so when incoming is an array
            // we process its elements as if there was no existing data.
            !(0, $kxw1Y.isArray)(incoming) && // Likewise, existing must be either a Reference or a StoreObject
            // in order for its fields to be safe to merge with the fields of
            // the incoming object.
            ((0, $6dwmd.isReference)(existing) || (0, $eiege.storeValueIsStoreObject)(existing)) ? existing : void 0;
            // This narrowing is implied by mergeTree.map.size > 0 and
            // !isReference(incoming), though TypeScript understandably cannot
            // hope to infer this type.
            var i_1 = incoming;
            // The options.storage objects provided to read and merge functions
            // are derived from the identity of the parent object plus a
            // sequence of storeFieldName strings/numbers identifying the nested
            // field name path of each field value to be merged.
            if (e_1 && !getStorageArgs) getStorageArgs = [
                (0, $6dwmd.isReference)(e_1) ? e_1.__ref : e_1
            ];
            // It's possible that applying merge functions to this subtree will
            // not change the incoming data, so this variable tracks the fields
            // that did change, so we can create a new incoming object when (and
            // only when) at least one incoming field has changed. We use a Map
            // to preserve the type of numeric keys.
            var changedFields_1;
            var getValue_1 = function(from, name) {
                return (0, $kxw1Y.isArray)(from) ? typeof name === "number" ? from[name] : void 0 : context.store.getFieldValue(from, String(name));
            };
            mergeTree.map.forEach(function(childTree, storeFieldName) {
                var eVal = getValue_1(e_1, storeFieldName);
                var iVal = getValue_1(i_1, storeFieldName);
                // If we have no incoming data, leave any existing data untouched.
                if (void 0 === iVal) return;
                if (getStorageArgs) getStorageArgs.push(storeFieldName);
                var aVal = _this.applyMerges(childTree, eVal, iVal, context, getStorageArgs);
                if (aVal !== iVal) {
                    changedFields_1 = changedFields_1 || new Map();
                    changedFields_1.set(storeFieldName, aVal);
                }
                if (getStorageArgs) (0, $kL4FQ.invariant)(getStorageArgs.pop() === storeFieldName);
            });
            if (changedFields_1) {
                // Shallow clone i so we can add changed fields to it.
                incoming = (0, $kxw1Y.isArray)(i_1) ? i_1.slice(0) : (0, $fKE23.__assign)({}, i_1);
                changedFields_1.forEach(function(value, name) {
                    incoming[name] = value;
                });
            }
        }
        if (mergeTree.info) return this.cache.policies.runMergeFunction(existing, incoming, mergeTree.info, context, getStorageArgs && (_a = context.store).getStorage.apply(_a, getStorageArgs));
        return incoming;
    };
    return StoreWriter;
}();
var $58debfe6f26331cf$var$emptyMergeTreePool = [];
function $58debfe6f26331cf$var$getChildMergeTree(_a, name) {
    var map = _a.map;
    if (!map.has(name)) map.set(name, $58debfe6f26331cf$var$emptyMergeTreePool.pop() || {
        map: new Map()
    });
    return map.get(name);
}
function $58debfe6f26331cf$var$mergeMergeTrees(left, right) {
    if (left === right || !right || $58debfe6f26331cf$var$mergeTreeIsEmpty(right)) return left;
    if (!left || $58debfe6f26331cf$var$mergeTreeIsEmpty(left)) return right;
    var info = left.info && right.info ? (0, $fKE23.__assign)((0, $fKE23.__assign)({}, left.info), right.info) : left.info || right.info;
    var needToMergeMaps = left.map.size && right.map.size;
    var map = needToMergeMaps ? new Map() : left.map.size ? left.map : right.map;
    var merged = {
        info: info,
        map: map
    };
    if (needToMergeMaps) {
        var remainingRightKeys_1 = new Set(right.map.keys());
        left.map.forEach(function(leftTree, key) {
            merged.map.set(key, $58debfe6f26331cf$var$mergeMergeTrees(leftTree, right.map.get(key)));
            remainingRightKeys_1.delete(key);
        });
        remainingRightKeys_1.forEach(function(key) {
            merged.map.set(key, $58debfe6f26331cf$var$mergeMergeTrees(right.map.get(key), left.map.get(key)));
        });
    }
    return merged;
}
function $58debfe6f26331cf$var$mergeTreeIsEmpty(tree) {
    return !tree || !(tree.info || tree.map.size);
}
function $58debfe6f26331cf$var$maybeRecycleChildMergeTree(_a, name) {
    var map = _a.map;
    var childTree = map.get(name);
    if (childTree && $58debfe6f26331cf$var$mergeTreeIsEmpty(childTree)) {
        $58debfe6f26331cf$var$emptyMergeTreePool.push(childTree);
        map.delete(name);
    }
}
var $58debfe6f26331cf$var$warnings = new Set();
// Note that this function is unused in production, and thus should be
// pruned by any well-configured minifier.
function $58debfe6f26331cf$var$warnAboutDataLoss(existingRef, incomingObj, storeFieldName, store) {
    var getChild = function(objOrRef) {
        var child = store.getFieldValue(objOrRef, storeFieldName);
        return typeof child === "object" && child;
    };
    var existing = getChild(existingRef);
    if (!existing) return;
    var incoming = getChild(incomingObj);
    if (!incoming) return;
    // It's always safe to replace a reference, since it refers to data
    // safely stored elsewhere.
    if ((0, $6dwmd.isReference)(existing)) return;
    // If the values are structurally equivalent, we do not need to worry
    // about incoming replacing existing.
    if ((0, $hr8gD.equal)(existing, incoming)) return;
    // If we're replacing every key of the existing object, then the
    // existing data would be overwritten even if the objects were
    // normalized, so warning would not be helpful here.
    if (Object.keys(existing).every(function(key) {
        return store.getFieldValue(incoming, key) !== void 0;
    })) return;
    var parentType = store.getFieldValue(existingRef, "__typename") || store.getFieldValue(incomingObj, "__typename");
    var fieldName = (0, $eiege.fieldNameFromStoreName)(storeFieldName);
    var typeDotName = "".concat(parentType, ".").concat(fieldName);
    // Avoid warning more than once for the same type and field name.
    if ($58debfe6f26331cf$var$warnings.has(typeDotName)) return;
    $58debfe6f26331cf$var$warnings.add(typeDotName);
    var childTypenames = [];
    // Arrays do not have __typename fields, and always need a custom merge
    // function, even if their elements are normalized entities.
    if (!(0, $kxw1Y.isArray)(existing) && !(0, $kxw1Y.isArray)(incoming)) [
        existing,
        incoming
    ].forEach(function(child) {
        var typename = store.getFieldValue(child, "__typename");
        if (typeof typename === "string" && !childTypenames.includes(typename)) childTypenames.push(typename);
    });
    globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).warn(14, fieldName, parentType, childTypenames.length ? "either ensure all objects of type " + childTypenames.join(" and ") + " have an ID or a custom merge function, or " : "", typeDotName, existing, incoming);
}

});
parcelRegister("awPNv", function(module, exports) {

$parcel$export(module.exports, "cloneDeep", () => $01fa6785e804b49e$export$629a2bd3f5a49ecc);
var $01fa6785e804b49e$var$toString = Object.prototype.toString;
function $01fa6785e804b49e$export$629a2bd3f5a49ecc(value) {
    return $01fa6785e804b49e$var$cloneDeepHelper(value);
}
function $01fa6785e804b49e$var$cloneDeepHelper(val, seen) {
    switch($01fa6785e804b49e$var$toString.call(val)){
        case "[object Array]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            var copy_1 = val.slice(0);
            seen.set(val, copy_1);
            copy_1.forEach(function(child, i) {
                copy_1[i] = $01fa6785e804b49e$var$cloneDeepHelper(child, seen);
            });
            return copy_1;
        case "[object Object]":
            seen = seen || new Map();
            if (seen.has(val)) return seen.get(val);
            // High fidelity polyfills of Object.create and Object.getPrototypeOf are
            // possible in all JS environments, so we will assume they exist/work.
            var copy_2 = Object.create(Object.getPrototypeOf(val));
            seen.set(val, copy_2);
            Object.keys(val).forEach(function(key) {
                copy_2[key] = $01fa6785e804b49e$var$cloneDeepHelper(val[key], seen);
            });
            return copy_2;
        default:
            return val;
    }
}

});

parcelRegister("9FSTq", function(module, exports) {

$parcel$export(module.exports, "Policies", () => $70b285fce88e0aaf$export$e9859ad90648930b);
$parcel$export(module.exports, "normalizeReadFieldOptions", () => $70b285fce88e0aaf$export$1ad7a877581bdf2e);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $6dwmd = parcelRequire("6dwmd");
var $1MCRf = parcelRequire("1MCRf");
var $dRSFQ = parcelRequire("dRSFQ");

var $eiege = parcelRequire("eiege");
var $kxw1Y = parcelRequire("kxw1Y");

var $5alB9 = parcelRequire("5alB9");

var $9lc9g = parcelRequire("9lc9g");
function $70b285fce88e0aaf$var$argsFromFieldSpecifier(spec) {
    return spec.args !== void 0 ? spec.args : spec.field ? (0, $6dwmd.argumentsObjectFromField)(spec.field, spec.variables) : null;
}
var $70b285fce88e0aaf$var$nullKeyFieldsFn = function() {
    return void 0;
};
var $70b285fce88e0aaf$var$simpleKeyArgsFn = function(_args, context) {
    return context.fieldName;
};
// These merge functions can be selected by specifying merge:true or
// merge:false in a field policy.
var $70b285fce88e0aaf$var$mergeTrueFn = function(existing, incoming, _a) {
    var mergeObjects = _a.mergeObjects;
    return mergeObjects(existing, incoming);
};
var $70b285fce88e0aaf$var$mergeFalseFn = function(_, incoming) {
    return incoming;
};
var $70b285fce88e0aaf$export$e9859ad90648930b = /** @class */ function() {
    function Policies(config) {
        this.config = config;
        this.typePolicies = Object.create(null);
        this.toBeAdded = Object.create(null);
        // Map from subtype names to sets of supertype names. Note that this
        // representation inverts the structure of possibleTypes (whose keys are
        // supertypes and whose values are arrays of subtypes) because it tends
        // to be much more efficient to search upwards than downwards.
        this.supertypeMap = new Map();
        // Any fuzzy subtypes specified by possibleTypes will be converted to
        // RegExp objects and recorded here. Every key of this map can also be
        // found in supertypeMap. In many cases this Map will be empty, which
        // means no fuzzy subtype checking will happen in fragmentMatches.
        this.fuzzySubtypes = new Map();
        this.rootIdsByTypename = Object.create(null);
        this.rootTypenamesById = Object.create(null);
        this.usingPossibleTypes = false;
        this.config = (0, $fKE23.__assign)({
            dataIdFromObject: (0, $eiege.defaultDataIdFromObject)
        }, config);
        this.cache = this.config.cache;
        this.setRootTypename("Query");
        this.setRootTypename("Mutation");
        this.setRootTypename("Subscription");
        if (config.possibleTypes) this.addPossibleTypes(config.possibleTypes);
        if (config.typePolicies) this.addTypePolicies(config.typePolicies);
    }
    Policies.prototype.identify = function(object, partialContext) {
        var _a;
        var policies = this;
        var typename = partialContext && (partialContext.typename || ((_a = partialContext.storeObject) === null || _a === void 0 ? void 0 : _a.__typename)) || object.__typename;
        // It should be possible to write root Query fields with writeFragment,
        // using { __typename: "Query", ... } as the data, but it does not make
        // sense to allow the same identification behavior for the Mutation and
        // Subscription types, since application code should never be writing
        // directly to (or reading directly from) those root objects.
        if (typename === this.rootTypenamesById.ROOT_QUERY) return [
            "ROOT_QUERY"
        ];
        // Default context.storeObject to object if not otherwise provided.
        var storeObject = partialContext && partialContext.storeObject || object;
        var context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, partialContext), {
            typename: typename,
            storeObject: storeObject,
            readField: partialContext && partialContext.readField || function() {
                var options = $70b285fce88e0aaf$export$1ad7a877581bdf2e(arguments, storeObject);
                return policies.readField(options, {
                    store: policies.cache["data"],
                    variables: options.variables
                });
            }
        });
        var id;
        var policy = typename && this.getTypePolicy(typename);
        var keyFn = policy && policy.keyFn || this.config.dataIdFromObject;
        while(keyFn){
            var specifierOrId = keyFn((0, $fKE23.__assign)((0, $fKE23.__assign)({}, object), storeObject), context);
            if ((0, $kxw1Y.isArray)(specifierOrId)) keyFn = (0, $9lc9g.keyFieldsFnFromSpecifier)(specifierOrId);
            else {
                id = specifierOrId;
                break;
            }
        }
        id = id ? String(id) : void 0;
        return context.keyObject ? [
            id,
            context.keyObject
        ] : [
            id
        ];
    };
    Policies.prototype.addTypePolicies = function(typePolicies) {
        var _this = this;
        Object.keys(typePolicies).forEach(function(typename) {
            var _a = typePolicies[typename], queryType = _a.queryType, mutationType = _a.mutationType, subscriptionType = _a.subscriptionType, incoming = (0, $fKE23.__rest)(_a, [
                "queryType",
                "mutationType",
                "subscriptionType"
            ]);
            // Though {query,mutation,subscription}Type configurations are rare,
            // it's important to call setRootTypename as early as possible,
            // since these configurations should apply consistently for the
            // entire lifetime of the cache. Also, since only one __typename can
            // qualify as one of these root types, these three properties cannot
            // be inherited, unlike the rest of the incoming properties. That
            // restriction is convenient, because the purpose of this.toBeAdded
            // is to delay the processing of type/field policies until the first
            // time they're used, allowing policies to be added in any order as
            // long as all relevant policies (including policies for supertypes)
            // have been added by the time a given policy is used for the first
            // time. In other words, since inheritance doesn't matter for these
            // properties, there's also no need to delay their processing using
            // the this.toBeAdded queue.
            if (queryType) _this.setRootTypename("Query", typename);
            if (mutationType) _this.setRootTypename("Mutation", typename);
            if (subscriptionType) _this.setRootTypename("Subscription", typename);
            if ((0, $eiege.hasOwn).call(_this.toBeAdded, typename)) _this.toBeAdded[typename].push(incoming);
            else _this.toBeAdded[typename] = [
                incoming
            ];
        });
    };
    Policies.prototype.updateTypePolicy = function(typename, incoming) {
        var _this = this;
        var existing = this.getTypePolicy(typename);
        var keyFields = incoming.keyFields, fields = incoming.fields;
        function setMerge(existing, merge) {
            existing.merge = typeof merge === "function" ? merge : merge === true ? $70b285fce88e0aaf$var$mergeTrueFn : merge === false ? $70b285fce88e0aaf$var$mergeFalseFn : existing.merge;
        }
        // Type policies can define merge functions, as an alternative to
        // using field policies to merge child objects.
        setMerge(existing, incoming.merge);
        existing.keyFn = // Pass false to disable normalization for this typename.
        keyFields === false ? $70b285fce88e0aaf$var$nullKeyFieldsFn : (0, $kxw1Y.isArray)(keyFields) ? (0, $9lc9g.keyFieldsFnFromSpecifier)(keyFields) : typeof keyFields === "function" ? keyFields : existing.keyFn;
        if (fields) Object.keys(fields).forEach(function(fieldName) {
            var existing = _this.getFieldPolicy(typename, fieldName, true);
            var incoming = fields[fieldName];
            if (typeof incoming === "function") existing.read = incoming;
            else {
                var keyArgs = incoming.keyArgs, read = incoming.read, merge = incoming.merge;
                existing.keyFn = // Pass false to disable argument-based differentiation of
                // field identities.
                keyArgs === false ? $70b285fce88e0aaf$var$simpleKeyArgsFn : (0, $kxw1Y.isArray)(keyArgs) ? (0, $9lc9g.keyArgsFnFromSpecifier)(keyArgs) : typeof keyArgs === "function" ? keyArgs : existing.keyFn;
                if (typeof read === "function") existing.read = read;
                setMerge(existing, merge);
            }
            if (existing.read && existing.merge) // If we have both a read and a merge function, assume
            // keyArgs:false, because read and merge together can take
            // responsibility for interpreting arguments in and out. This
            // default assumption can always be overridden by specifying
            // keyArgs explicitly in the FieldPolicy.
            existing.keyFn = existing.keyFn || $70b285fce88e0aaf$var$simpleKeyArgsFn;
        });
    };
    Policies.prototype.setRootTypename = function(which, typename) {
        if (typename === void 0) typename = which;
        var rootId = "ROOT_" + which.toUpperCase();
        var old = this.rootTypenamesById[rootId];
        if (typename !== old) {
            (0, $kL4FQ.invariant)(!old || old === which, 5, which);
            // First, delete any old __typename associated with this rootId from
            // rootIdsByTypename.
            if (old) delete this.rootIdsByTypename[old];
            // Now make this the only __typename that maps to this rootId.
            this.rootIdsByTypename[typename] = rootId;
            // Finally, update the __typename associated with this rootId.
            this.rootTypenamesById[rootId] = typename;
        }
    };
    Policies.prototype.addPossibleTypes = function(possibleTypes) {
        var _this = this;
        this.usingPossibleTypes = true;
        Object.keys(possibleTypes).forEach(function(supertype) {
            // Make sure all types have an entry in this.supertypeMap, even if
            // their supertype set is empty, so we can return false immediately
            // from policies.fragmentMatches for unknown supertypes.
            _this.getSupertypeSet(supertype, true);
            possibleTypes[supertype].forEach(function(subtype) {
                _this.getSupertypeSet(subtype, true).add(supertype);
                var match = subtype.match((0, $eiege.TypeOrFieldNameRegExp));
                if (!match || match[0] !== subtype) // TODO Don't interpret just any invalid typename as a RegExp.
                _this.fuzzySubtypes.set(subtype, new RegExp(subtype));
            });
        });
    };
    Policies.prototype.getTypePolicy = function(typename) {
        var _this = this;
        if (!(0, $eiege.hasOwn).call(this.typePolicies, typename)) {
            var policy_1 = this.typePolicies[typename] = Object.create(null);
            policy_1.fields = Object.create(null);
            // When the TypePolicy for typename is first accessed, instead of
            // starting with an empty policy object, inherit any properties or
            // fields from the type policies of the supertypes of typename.
            //
            // Any properties or fields defined explicitly within the TypePolicy
            // for typename will take precedence, and if there are multiple
            // supertypes, the properties of policies whose types were added
            // later via addPossibleTypes will take precedence over those of
            // earlier supertypes. TODO Perhaps we should warn about these
            // conflicts in development, and recommend defining the property
            // explicitly in the subtype policy?
            //
            // Field policy inheritance is atomic/shallow: you can't inherit a
            // field policy and then override just its read function, since read
            // and merge functions often need to cooperate, so changing only one
            // of them would be a recipe for inconsistency.
            //
            // Once the TypePolicy for typename has been accessed, its properties can
            // still be updated directly using addTypePolicies, but future changes to
            // inherited supertype policies will not be reflected in this subtype
            // policy, because this code runs at most once per typename.
            var supertypes_1 = this.supertypeMap.get(typename);
            if (!supertypes_1 && this.fuzzySubtypes.size) {
                // To make the inheritance logic work for unknown typename strings that
                // may have fuzzy supertypes, we give this typename an empty supertype
                // set and then populate it with any fuzzy supertypes that match.
                supertypes_1 = this.getSupertypeSet(typename, true);
                // This only works for typenames that are directly matched by a fuzzy
                // supertype. What if there is an intermediate chain of supertypes?
                // While possible, that situation can only be solved effectively by
                // specifying the intermediate relationships via possibleTypes, manually
                // and in a non-fuzzy way.
                this.fuzzySubtypes.forEach(function(regExp, fuzzy) {
                    if (regExp.test(typename)) {
                        // The fuzzy parameter is just the original string version of regExp
                        // (not a valid __typename string), but we can look up the
                        // associated supertype(s) in this.supertypeMap.
                        var fuzzySupertypes = _this.supertypeMap.get(fuzzy);
                        if (fuzzySupertypes) fuzzySupertypes.forEach(function(supertype) {
                            return supertypes_1.add(supertype);
                        });
                    }
                });
            }
            if (supertypes_1 && supertypes_1.size) supertypes_1.forEach(function(supertype) {
                var _a = _this.getTypePolicy(supertype), fields = _a.fields, rest = (0, $fKE23.__rest)(_a, [
                    "fields"
                ]);
                Object.assign(policy_1, rest);
                Object.assign(policy_1.fields, fields);
            });
        }
        var inbox = this.toBeAdded[typename];
        if (inbox && inbox.length) // Merge the pending policies into this.typePolicies, in the order they
        // were originally passed to addTypePolicy.
        inbox.splice(0).forEach(function(policy) {
            _this.updateTypePolicy(typename, policy);
        });
        return this.typePolicies[typename];
    };
    Policies.prototype.getFieldPolicy = function(typename, fieldName, createIfMissing) {
        if (typename) {
            var fieldPolicies = this.getTypePolicy(typename).fields;
            return fieldPolicies[fieldName] || createIfMissing && (fieldPolicies[fieldName] = Object.create(null));
        }
    };
    Policies.prototype.getSupertypeSet = function(subtype, createIfMissing) {
        var supertypeSet = this.supertypeMap.get(subtype);
        if (!supertypeSet && createIfMissing) this.supertypeMap.set(subtype, supertypeSet = new Set());
        return supertypeSet;
    };
    Policies.prototype.fragmentMatches = function(fragment, typename, result, variables) {
        var _this = this;
        if (!fragment.typeCondition) return true;
        // If the fragment has a type condition but the object we're matching
        // against does not have a __typename, the fragment cannot match.
        if (!typename) return false;
        var supertype = fragment.typeCondition.name.value;
        // Common case: fragment type condition and __typename are the same.
        if (typename === supertype) return true;
        if (this.usingPossibleTypes && this.supertypeMap.has(supertype)) {
            var typenameSupertypeSet = this.getSupertypeSet(typename, true);
            var workQueue_1 = [
                typenameSupertypeSet
            ];
            var maybeEnqueue_1 = function(subtype) {
                var supertypeSet = _this.getSupertypeSet(subtype, false);
                if (supertypeSet && supertypeSet.size && workQueue_1.indexOf(supertypeSet) < 0) workQueue_1.push(supertypeSet);
            };
            // We need to check fuzzy subtypes only if we encountered fuzzy
            // subtype strings in addPossibleTypes, and only while writing to
            // the cache, since that's when selectionSetMatchesResult gives a
            // strong signal of fragment matching. The StoreReader class calls
            // policies.fragmentMatches without passing a result object, so
            // needToCheckFuzzySubtypes is always false while reading.
            var needToCheckFuzzySubtypes = !!(result && this.fuzzySubtypes.size);
            var checkingFuzzySubtypes = false;
            // It's important to keep evaluating workQueue.length each time through
            // the loop, because the queue can grow while we're iterating over it.
            for(var i = 0; i < workQueue_1.length; ++i){
                var supertypeSet = workQueue_1[i];
                if (supertypeSet.has(supertype)) {
                    if (!typenameSupertypeSet.has(supertype)) {
                        if (checkingFuzzySubtypes) globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).warn(6, typename, supertype);
                        // Record positive results for faster future lookup.
                        // Unfortunately, we cannot safely cache negative results,
                        // because new possibleTypes data could always be added to the
                        // Policies class.
                        typenameSupertypeSet.add(supertype);
                    }
                    return true;
                }
                supertypeSet.forEach(maybeEnqueue_1);
                if (needToCheckFuzzySubtypes && // Start checking fuzzy subtypes only after exhausting all
                // non-fuzzy subtypes (after the final iteration of the loop).
                i === workQueue_1.length - 1 && // We could wait to compare fragment.selectionSet to result
                // after we verify the supertype, but this check is often less
                // expensive than that search, and we will have to do the
                // comparison anyway whenever we find a potential match.
                (0, $eiege.selectionSetMatchesResult)(fragment.selectionSet, result, variables)) {
                    // We don't always need to check fuzzy subtypes (if no result
                    // was provided, or !this.fuzzySubtypes.size), but, when we do,
                    // we only want to check them once.
                    needToCheckFuzzySubtypes = false;
                    checkingFuzzySubtypes = true;
                    // If we find any fuzzy subtypes that match typename, extend the
                    // workQueue to search through the supertypes of those fuzzy
                    // subtypes. Otherwise the for-loop will terminate and we'll
                    // return false below.
                    this.fuzzySubtypes.forEach(function(regExp, fuzzyString) {
                        var match = typename.match(regExp);
                        if (match && match[0] === typename) maybeEnqueue_1(fuzzyString);
                    });
                }
            }
        }
        return false;
    };
    Policies.prototype.hasKeyArgs = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return !!(policy && policy.keyFn);
    };
    Policies.prototype.getStoreFieldName = function(fieldSpec) {
        var typename = fieldSpec.typename, fieldName = fieldSpec.fieldName;
        var policy = this.getFieldPolicy(typename, fieldName, false);
        var storeFieldName;
        var keyFn = policy && policy.keyFn;
        if (keyFn && typename) {
            var context = {
                typename: typename,
                fieldName: fieldName,
                field: fieldSpec.field || null,
                variables: fieldSpec.variables
            };
            var args = $70b285fce88e0aaf$var$argsFromFieldSpecifier(fieldSpec);
            while(keyFn){
                var specifierOrString = keyFn(args, context);
                if ((0, $kxw1Y.isArray)(specifierOrString)) keyFn = (0, $9lc9g.keyArgsFnFromSpecifier)(specifierOrString);
                else {
                    // If the custom keyFn returns a falsy value, fall back to
                    // fieldName instead.
                    storeFieldName = specifierOrString || fieldName;
                    break;
                }
            }
        }
        if (storeFieldName === void 0) storeFieldName = fieldSpec.field ? (0, $6dwmd.storeKeyNameFromField)(fieldSpec.field, fieldSpec.variables) : (0, $6dwmd.getStoreKeyName)(fieldName, $70b285fce88e0aaf$var$argsFromFieldSpecifier(fieldSpec));
        // Returning false from a keyArgs function is like configuring
        // keyArgs: false, but more dynamic.
        if (storeFieldName === false) return fieldName;
        // Make sure custom field names start with the actual field.name.value
        // of the field, so we can always figure out which properties of a
        // StoreObject correspond to which original field names.
        return fieldName === (0, $eiege.fieldNameFromStoreName)(storeFieldName) ? storeFieldName : fieldName + ":" + storeFieldName;
    };
    Policies.prototype.readField = function(options, context) {
        var objectOrReference = options.from;
        if (!objectOrReference) return;
        var nameOrField = options.field || options.fieldName;
        if (!nameOrField) return;
        if (options.typename === void 0) {
            var typename = context.store.getFieldValue(objectOrReference, "__typename");
            if (typename) options.typename = typename;
        }
        var storeFieldName = this.getStoreFieldName(options);
        var fieldName = (0, $eiege.fieldNameFromStoreName)(storeFieldName);
        var existing = context.store.getFieldValue(objectOrReference, storeFieldName);
        var policy = this.getFieldPolicy(options.typename, fieldName, false);
        var read = policy && policy.read;
        if (read) {
            var readOptions = $70b285fce88e0aaf$var$makeFieldFunctionOptions(this, objectOrReference, options, context, context.store.getStorage((0, $6dwmd.isReference)(objectOrReference) ? objectOrReference.__ref : objectOrReference, storeFieldName));
            // Call read(existing, readOptions) with cacheSlot holding this.cache.
            return (0, $5alB9.cacheSlot).withValue(this.cache, read, [
                existing,
                readOptions
            ]);
        }
        return existing;
    };
    Policies.prototype.getReadFunction = function(typename, fieldName) {
        var policy = this.getFieldPolicy(typename, fieldName, false);
        return policy && policy.read;
    };
    Policies.prototype.getMergeFunction = function(parentTypename, fieldName, childTypename) {
        var policy = this.getFieldPolicy(parentTypename, fieldName, false);
        var merge = policy && policy.merge;
        if (!merge && childTypename) {
            policy = this.getTypePolicy(childTypename);
            merge = policy && policy.merge;
        }
        return merge;
    };
    Policies.prototype.runMergeFunction = function(existing, incoming, _a, context, storage) {
        var field = _a.field, typename = _a.typename, merge = _a.merge;
        if (merge === $70b285fce88e0aaf$var$mergeTrueFn) // Instead of going to the trouble of creating a full
        // FieldFunctionOptions object and calling mergeTrueFn, we can
        // simply call mergeObjects, as mergeTrueFn would.
        return $70b285fce88e0aaf$var$makeMergeObjectsFunction(context.store)(existing, incoming);
        if (merge === $70b285fce88e0aaf$var$mergeFalseFn) // Likewise for mergeFalseFn, whose implementation is even simpler.
        return incoming;
        // If cache.writeQuery or cache.writeFragment was called with
        // options.overwrite set to true, we still call merge functions, but
        // the existing data is always undefined, so the merge function will
        // not attempt to combine the incoming data with the existing data.
        if (context.overwrite) existing = void 0;
        return merge(existing, incoming, $70b285fce88e0aaf$var$makeFieldFunctionOptions(this, // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0, {
            typename: typename,
            fieldName: field.name.value,
            field: field,
            variables: context.variables
        }, context, storage || Object.create(null)));
    };
    return Policies;
}();
function $70b285fce88e0aaf$var$makeFieldFunctionOptions(policies, objectOrReference, fieldSpec, context, storage) {
    var storeFieldName = policies.getStoreFieldName(fieldSpec);
    var fieldName = (0, $eiege.fieldNameFromStoreName)(storeFieldName);
    var variables = fieldSpec.variables || context.variables;
    var _a = context.store, toReference = _a.toReference, canRead = _a.canRead;
    return {
        args: $70b285fce88e0aaf$var$argsFromFieldSpecifier(fieldSpec),
        field: fieldSpec.field || null,
        fieldName: fieldName,
        storeFieldName: storeFieldName,
        variables: variables,
        isReference: (0, $6dwmd.isReference),
        toReference: toReference,
        storage: storage,
        cache: policies.cache,
        canRead: canRead,
        readField: function() {
            return policies.readField($70b285fce88e0aaf$export$1ad7a877581bdf2e(arguments, objectOrReference, variables), context);
        },
        mergeObjects: $70b285fce88e0aaf$var$makeMergeObjectsFunction(context.store)
    };
}
function $70b285fce88e0aaf$export$1ad7a877581bdf2e(readFieldArgs, objectOrReference, variables) {
    var fieldNameOrOptions = readFieldArgs[0], from = readFieldArgs[1], argc = readFieldArgs.length;
    var options;
    if (typeof fieldNameOrOptions === "string") options = {
        fieldName: fieldNameOrOptions,
        // Default to objectOrReference only when no second argument was
        // passed for the from parameter, not when undefined is explicitly
        // passed as the second argument.
        from: argc > 1 ? from : objectOrReference
    };
    else {
        options = (0, $fKE23.__assign)({}, fieldNameOrOptions);
        // Default to objectOrReference only when fieldNameOrOptions.from is
        // actually omitted, rather than just undefined.
        if (!(0, $eiege.hasOwn).call(options, "from")) options.from = objectOrReference;
    }
    if (globalThis.__DEV__ !== false && options.from === void 0) globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).warn(7, (0, $dRSFQ.stringifyForDisplay)(Array.from(readFieldArgs)));
    if (void 0 === options.variables) options.variables = variables;
    return options;
}
function $70b285fce88e0aaf$var$makeMergeObjectsFunction(store) {
    return function mergeObjects(existing, incoming) {
        if ((0, $kxw1Y.isArray)(existing) || (0, $kxw1Y.isArray)(incoming)) throw (0, $kL4FQ.newInvariantError)(8);
        // These dynamic checks are necessary because the parameters of a
        // custom merge function can easily have the any type, so the type
        // system cannot always enforce the StoreObject | Reference parameter
        // types of options.mergeObjects.
        if ((0, $1MCRf.isNonNullObject)(existing) && (0, $1MCRf.isNonNullObject)(incoming)) {
            var eType = store.getFieldValue(existing, "__typename");
            var iType = store.getFieldValue(incoming, "__typename");
            var typesDiffer = eType && iType && eType !== iType;
            if (typesDiffer) return incoming;
            if ((0, $6dwmd.isReference)(existing) && (0, $eiege.storeValueIsStoreObject)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // existing.__ref, preferring/overwriting any fields contributed by the
                // newer incoming StoreObject.
                store.merge(existing.__ref, incoming);
                return existing;
            }
            if ((0, $eiege.storeValueIsStoreObject)(existing) && (0, $6dwmd.isReference)(incoming)) {
                // Update the normalized EntityStore for the entity identified by
                // incoming.__ref, taking fields from the older existing object only if
                // those fields are not already present in the newer StoreObject
                // identified by incoming.__ref.
                store.merge(existing, incoming.__ref);
                return incoming;
            }
            if ((0, $eiege.storeValueIsStoreObject)(existing) && (0, $eiege.storeValueIsStoreObject)(incoming)) return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, existing), incoming);
        }
        return incoming;
    };
}

});
parcelRegister("5alB9", function(module, exports) {

$parcel$export(module.exports, "cacheSlot", () => $3c2ea3deac0acf7c$export$ac9723609f5c76c2);
$parcel$export(module.exports, "forgetCache", () => $3c2ea3deac0acf7c$export$cbe12faed7725318);
$parcel$export(module.exports, "recallCache", () => $3c2ea3deac0acf7c$export$f342bdd61b3e9412);
$parcel$export(module.exports, "makeVar", () => $3c2ea3deac0acf7c$export$5345c8ac69b4a9db);
parcelRequire("bDsPx");
var $aFBFG = parcelRequire("aFBFG");
var $bE236 = parcelRequire("bE236");
var $3c2ea3deac0acf7c$export$ac9723609f5c76c2 = new (0, $bE236.Slot)();
var $3c2ea3deac0acf7c$var$cacheInfoMap = new WeakMap();
function $3c2ea3deac0acf7c$var$getCacheInfo(cache) {
    var info = $3c2ea3deac0acf7c$var$cacheInfoMap.get(cache);
    if (!info) $3c2ea3deac0acf7c$var$cacheInfoMap.set(cache, info = {
        vars: new Set(),
        dep: (0, $aFBFG.dep)()
    });
    return info;
}
function $3c2ea3deac0acf7c$export$cbe12faed7725318(cache) {
    $3c2ea3deac0acf7c$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.forgetCache(cache);
    });
}
function $3c2ea3deac0acf7c$export$f342bdd61b3e9412(cache) {
    $3c2ea3deac0acf7c$var$getCacheInfo(cache).vars.forEach(function(rv) {
        return rv.attachCache(cache);
    });
}
function $3c2ea3deac0acf7c$export$5345c8ac69b4a9db(value) {
    var caches = new Set();
    var listeners = new Set();
    var rv = function(newValue) {
        if (arguments.length > 0) {
            if (value !== newValue) {
                value = newValue;
                caches.forEach(function(cache) {
                    // Invalidate any fields with custom read functions that
                    // consumed this variable, so query results involving those
                    // fields will be recomputed the next time we read them.
                    $3c2ea3deac0acf7c$var$getCacheInfo(cache).dep.dirty(rv);
                    // Broadcast changes to any caches that have previously read
                    // from this variable.
                    $3c2ea3deac0acf7c$var$broadcast(cache);
                });
                // Finally, notify any listeners added via rv.onNextChange.
                var oldListeners = Array.from(listeners);
                listeners.clear();
                oldListeners.forEach(function(listener) {
                    return listener(value);
                });
            }
        } else {
            // When reading from the variable, obtain the current cache from
            // context via cacheSlot. This isn't entirely foolproof, but it's
            // the same system that powers varDep.
            var cache = $3c2ea3deac0acf7c$export$ac9723609f5c76c2.getValue();
            if (cache) {
                attach(cache);
                $3c2ea3deac0acf7c$var$getCacheInfo(cache).dep(rv);
            }
        }
        return value;
    };
    rv.onNextChange = function(listener) {
        listeners.add(listener);
        return function() {
            listeners.delete(listener);
        };
    };
    var attach = rv.attachCache = function(cache) {
        caches.add(cache);
        $3c2ea3deac0acf7c$var$getCacheInfo(cache).vars.add(rv);
        return rv;
    };
    rv.forgetCache = function(cache) {
        return caches.delete(cache);
    };
    return rv;
}
function $3c2ea3deac0acf7c$var$broadcast(cache) {
    if (cache.broadcastWatches) cache.broadcastWatches();
}

});

parcelRegister("9lc9g", function(module, exports) {

$parcel$export(module.exports, "keyFieldsFnFromSpecifier", () => $6ccf7fa9770e99d3$export$f1953a0407594d2c);
$parcel$export(module.exports, "keyArgsFnFromSpecifier", () => $6ccf7fa9770e99d3$export$550737ee0cc371ac);
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $6dwmd = parcelRequire("6dwmd");
var $64d3o = parcelRequire("64d3o");
var $kxw1Y = parcelRequire("kxw1Y");
var $1MCRf = parcelRequire("1MCRf");

var $eiege = parcelRequire("eiege");
var $kxw1Y = parcelRequire("kxw1Y");
// Mapping from JSON-encoded KeySpecifier strings to associated information.
var $6ccf7fa9770e99d3$var$specifierInfoCache = Object.create(null);
function $6ccf7fa9770e99d3$var$lookupSpecifierInfo(spec) {
    // It's safe to encode KeySpecifier arrays with JSON.stringify, since they're
    // just arrays of strings or nested KeySpecifier arrays, and the order of the
    // array elements is important (and suitably preserved by JSON.stringify).
    var cacheKey = JSON.stringify(spec);
    return $6ccf7fa9770e99d3$var$specifierInfoCache[cacheKey] || ($6ccf7fa9770e99d3$var$specifierInfoCache[cacheKey] = Object.create(null));
}
function $6ccf7fa9770e99d3$export$f1953a0407594d2c(specifier) {
    var info = $6ccf7fa9770e99d3$var$lookupSpecifierInfo(specifier);
    return info.keyFieldsFn || (info.keyFieldsFn = function(object, context) {
        var extract = function(from, key) {
            return context.readField(key, from);
        };
        var keyObject = context.keyObject = $6ccf7fa9770e99d3$export$2db31da99613c21f(specifier, function(schemaKeyPath) {
            var extracted = $6ccf7fa9770e99d3$export$e8f64f7a025887d3(context.storeObject, schemaKeyPath, // Using context.readField to extract paths from context.storeObject
            // allows the extraction to see through Reference objects and respect
            // custom read functions.
            extract);
            if (extracted === void 0 && object !== context.storeObject && (0, $eiege.hasOwn).call(object, schemaKeyPath[0])) // If context.storeObject fails to provide a value for the requested
            // path, fall back to the raw result object, if it has a top-level key
            // matching the first key in the path (schemaKeyPath[0]). This allows
            // key fields included in the written data to be saved in the cache
            // even if they are not selected explicitly in context.selectionSet.
            // Not being mentioned by context.selectionSet is convenient here,
            // since it means these extra fields cannot be affected by field
            // aliasing, which is why we can use extractKey instead of
            // context.readField for this extraction.
            extracted = $6ccf7fa9770e99d3$export$e8f64f7a025887d3(object, schemaKeyPath, $6ccf7fa9770e99d3$var$extractKey);
            (0, $kL4FQ.invariant)(extracted !== void 0, 4, schemaKeyPath.join("."), object);
            return extracted;
        });
        return "".concat(context.typename, ":").concat(JSON.stringify(keyObject));
    });
}
function $6ccf7fa9770e99d3$export$550737ee0cc371ac(specifier) {
    var info = $6ccf7fa9770e99d3$var$lookupSpecifierInfo(specifier);
    return info.keyArgsFn || (info.keyArgsFn = function(args, _a) {
        var field = _a.field, variables = _a.variables, fieldName = _a.fieldName;
        var collected = $6ccf7fa9770e99d3$export$2db31da99613c21f(specifier, function(keyPath) {
            var firstKey = keyPath[0];
            var firstChar = firstKey.charAt(0);
            if (firstChar === "@") {
                if (field && (0, $kxw1Y.isNonEmptyArray)(field.directives)) {
                    var directiveName_1 = firstKey.slice(1);
                    // If the directive appears multiple times, only the first
                    // occurrence's arguments will be used. TODO Allow repetition?
                    // TODO Cache this work somehow, a la aliasMap?
                    var d = field.directives.find(function(d) {
                        return d.name.value === directiveName_1;
                    });
                    // Fortunately argumentsObjectFromField works for DirectiveNode!
                    var directiveArgs = d && (0, $6dwmd.argumentsObjectFromField)(d, variables);
                    // For directives without arguments (d defined, but directiveArgs ===
                    // null), the presence or absence of the directive still counts as
                    // part of the field key, so we return null in those cases. If no
                    // directive with this name was found for this field (d undefined and
                    // thus directiveArgs undefined), we return undefined, which causes
                    // this value to be omitted from the key object returned by
                    // collectSpecifierPaths.
                    return directiveArgs && $6ccf7fa9770e99d3$export$e8f64f7a025887d3(directiveArgs, // If keyPath.length === 1, this code calls extractKeyPath with an
                    // empty path, which works because it uses directiveArgs as the
                    // extracted value.
                    keyPath.slice(1));
                }
                // If the key started with @ but there was no corresponding directive,
                // we want to omit this value from the key object, not fall through to
                // treating @whatever as a normal argument name.
                return;
            }
            if (firstChar === "$") {
                var variableName = firstKey.slice(1);
                if (variables && (0, $eiege.hasOwn).call(variables, variableName)) {
                    var varKeyPath = keyPath.slice(0);
                    varKeyPath[0] = variableName;
                    return $6ccf7fa9770e99d3$export$e8f64f7a025887d3(variables, varKeyPath);
                }
                // If the key started with $ but there was no corresponding variable, we
                // want to omit this value from the key object, not fall through to
                // treating $whatever as a normal argument name.
                return;
            }
            if (args) return $6ccf7fa9770e99d3$export$e8f64f7a025887d3(args, keyPath);
        });
        var suffix = JSON.stringify(collected);
        // If no arguments were passed to this field, and it didn't have any other
        // field key contributions from directives or variables, hide the empty
        // :{} suffix from the field key. However, a field passed no arguments can
        // still end up with a non-empty :{...} suffix if its key configuration
        // refers to directives or variables.
        if (args || suffix !== "{}") fieldName += ":" + suffix;
        return fieldName;
    });
}
function $6ccf7fa9770e99d3$export$2db31da99613c21f(specifier, extractor) {
    // For each path specified by specifier, invoke the extractor, and repeatedly
    // merge the results together, with appropriate ancestor context.
    var merger = new (0, $64d3o.DeepMerger)();
    return $6ccf7fa9770e99d3$export$eca459f173e85801(specifier).reduce(function(collected, path) {
        var _a;
        var toMerge = extractor(path);
        if (toMerge !== void 0) {
            // This path is not expected to contain array indexes, so the toMerge
            // reconstruction will not contain arrays. TODO Fix this?
            for(var i = path.length - 1; i >= 0; --i)toMerge = (_a = {}, _a[path[i]] = toMerge, _a);
            collected = merger.merge(collected, toMerge);
        }
        return collected;
    }, Object.create(null));
}
function $6ccf7fa9770e99d3$export$eca459f173e85801(spec) {
    var info = $6ccf7fa9770e99d3$var$lookupSpecifierInfo(spec);
    if (!info.paths) {
        var paths_1 = info.paths = [];
        var currentPath_1 = [];
        spec.forEach(function(s, i) {
            if ((0, $kxw1Y.isArray)(s)) {
                $6ccf7fa9770e99d3$export$eca459f173e85801(s).forEach(function(p) {
                    return paths_1.push(currentPath_1.concat(p));
                });
                currentPath_1.length = 0;
            } else {
                currentPath_1.push(s);
                if (!(0, $kxw1Y.isArray)(spec[i + 1])) {
                    paths_1.push(currentPath_1.slice(0));
                    currentPath_1.length = 0;
                }
            }
        });
    }
    return info.paths;
}
function $6ccf7fa9770e99d3$var$extractKey(object, key) {
    return object[key];
}
function $6ccf7fa9770e99d3$export$e8f64f7a025887d3(object, path, extract) {
    // For each key in path, extract the corresponding child property from obj,
    // flattening arrays if encountered (uncommon for keyFields and keyArgs, but
    // possible). The final result of path.reduce is normalized so unexpected leaf
    // objects have their keys safely sorted. That final result is difficult to
    // type as anything other than any. You're welcome to try to improve the
    // return type, but keep in mind extractKeyPath is not a public function
    // (exported only for testing), so the effort may not be worthwhile unless the
    // limited set of actual callers (see above) pass arguments that TypeScript
    // can statically type. If we know only that path is some array of strings
    // (and not, say, a specific tuple of statically known strings), any (or
    // possibly unknown) is the honest answer.
    extract = extract || $6ccf7fa9770e99d3$var$extractKey;
    return $6ccf7fa9770e99d3$var$normalize(path.reduce(function reducer(obj, key) {
        return (0, $kxw1Y.isArray)(obj) ? obj.map(function(child) {
            return reducer(child, key);
        }) : obj && extract(obj, key);
    }, object));
}
function $6ccf7fa9770e99d3$var$normalize(value) {
    // Usually the extracted value will be a scalar value, since most primary
    // key fields are scalar, but just in case we get an object or an array, we
    // need to do some normalization of the order of (nested) keys.
    if ((0, $1MCRf.isNonNullObject)(value)) {
        if ((0, $kxw1Y.isArray)(value)) return value.map($6ccf7fa9770e99d3$var$normalize);
        return $6ccf7fa9770e99d3$export$2db31da99613c21f(Object.keys(value).sort(), function(path) {
            return $6ccf7fa9770e99d3$export$e8f64f7a025887d3(value, path);
        });
    }
    return value;
}

});




parcelRegister("5mKRV", function(module, exports) {

$parcel$export(module.exports, "relayStylePagination", () => $3e835cfbd53060c1$export$e16db2cef93d81f6);

var $fKE23 = parcelRequire("fKE23");

var $64d3o = parcelRequire("64d3o");
function $3e835cfbd53060c1$export$e243c4ad6f76d660(keyArgs) {
    if (keyArgs === void 0) keyArgs = false;
    return {
        keyArgs: keyArgs,
        merge: function(existing, incoming) {
            return existing ? (0, $fKE23.__spreadArray)((0, $fKE23.__spreadArray)([], existing, true), incoming, true) : incoming;
        }
    };
}
function $3e835cfbd53060c1$export$8888432c2a216040(keyArgs) {
    if (keyArgs === void 0) keyArgs = false;
    return {
        keyArgs: keyArgs,
        merge: function(existing, incoming, _a) {
            var args = _a.args;
            var merged = existing ? existing.slice(0) : [];
            if (incoming) {
                if (args) {
                    // Assume an offset of 0 if args.offset omitted.
                    var _b = args.offset, offset = _b === void 0 ? 0 : _b;
                    for(var i = 0; i < incoming.length; ++i)merged[offset + i] = incoming[i];
                } else // It's unusual (probably a mistake) for a paginated field not
                // to receive any arguments, so you might prefer to throw an
                // exception here, instead of recovering by appending incoming
                // onto the existing array.
                merged.push.apply(merged, incoming);
            }
            return merged;
        }
    };
}
function $3e835cfbd53060c1$export$e16db2cef93d81f6(keyArgs) {
    if (keyArgs === void 0) keyArgs = false;
    return {
        keyArgs: keyArgs,
        read: function(existing, _a) {
            var canRead = _a.canRead, readField = _a.readField;
            if (!existing) return existing;
            var edges = [];
            var firstEdgeCursor = "";
            var lastEdgeCursor = "";
            existing.edges.forEach(function(edge) {
                // Edges themselves could be Reference objects, so it's important
                // to use readField to access the edge.edge.node property.
                if (canRead(readField("node", edge))) {
                    edges.push(edge);
                    if (edge.cursor) {
                        firstEdgeCursor = firstEdgeCursor || edge.cursor || "";
                        lastEdgeCursor = edge.cursor || lastEdgeCursor;
                    }
                }
            });
            if (edges.length > 1 && firstEdgeCursor === lastEdgeCursor) firstEdgeCursor = "";
            var _b = existing.pageInfo || {}, startCursor = _b.startCursor, endCursor = _b.endCursor;
            return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $3e835cfbd53060c1$var$getExtras(existing)), {
                edges: edges,
                pageInfo: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, existing.pageInfo), {
                    // If existing.pageInfo.{start,end}Cursor are undefined or "", default
                    // to firstEdgeCursor and/or lastEdgeCursor.
                    startCursor: startCursor || firstEdgeCursor,
                    endCursor: endCursor || lastEdgeCursor
                })
            });
        },
        merge: function(existing, incoming, _a) {
            var args = _a.args, isReference = _a.isReference, readField = _a.readField;
            if (!existing) existing = $3e835cfbd53060c1$var$makeEmptyData();
            if (!incoming) return existing;
            var incomingEdges = incoming.edges ? incoming.edges.map(function(edge) {
                if (isReference(edge = (0, $fKE23.__assign)({}, edge))) // In case edge is a Reference, we read out its cursor field and
                // store it as an extra property of the Reference object.
                edge.cursor = readField("cursor", edge);
                return edge;
            }) : [];
            if (incoming.pageInfo) {
                var pageInfo_1 = incoming.pageInfo;
                var startCursor = pageInfo_1.startCursor, endCursor = pageInfo_1.endCursor;
                var firstEdge = incomingEdges[0];
                var lastEdge = incomingEdges[incomingEdges.length - 1];
                // In case we did not request the cursor field for edges in this
                // query, we can still infer cursors from pageInfo.
                if (firstEdge && startCursor) firstEdge.cursor = startCursor;
                if (lastEdge && endCursor) lastEdge.cursor = endCursor;
                // Cursors can also come from edges, so we default
                // pageInfo.{start,end}Cursor to {first,last}Edge.cursor.
                var firstCursor = firstEdge && firstEdge.cursor;
                if (firstCursor && !startCursor) incoming = (0, $64d3o.mergeDeep)(incoming, {
                    pageInfo: {
                        startCursor: firstCursor
                    }
                });
                var lastCursor = lastEdge && lastEdge.cursor;
                if (lastCursor && !endCursor) incoming = (0, $64d3o.mergeDeep)(incoming, {
                    pageInfo: {
                        endCursor: lastCursor
                    }
                });
            }
            var prefix = existing.edges;
            var suffix = [];
            if (args && args.after) {
                // This comparison does not need to use readField("cursor", edge),
                // because we stored the cursor field of any Reference edges as an
                // extra property of the Reference object.
                var index = prefix.findIndex(function(edge) {
                    return edge.cursor === args.after;
                });
                if (index >= 0) prefix = prefix.slice(0, index + 1);
            } else if (args && args.before) {
                var index = prefix.findIndex(function(edge) {
                    return edge.cursor === args.before;
                });
                suffix = index < 0 ? prefix : prefix.slice(index);
                prefix = [];
            } else if (incoming.edges) // If we have neither args.after nor args.before, the incoming
            // edges cannot be spliced into the existing edges, so they must
            // replace the existing edges. See #6592 for a motivating example.
            prefix = [];
            var edges = (0, $fKE23.__spreadArray)((0, $fKE23.__spreadArray)((0, $fKE23.__spreadArray)([], prefix, true), incomingEdges, true), suffix, true);
            var pageInfo = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, incoming.pageInfo), existing.pageInfo);
            if (incoming.pageInfo) {
                var _b = incoming.pageInfo, hasPreviousPage = _b.hasPreviousPage, hasNextPage = _b.hasNextPage, startCursor = _b.startCursor, endCursor = _b.endCursor, extras = (0, $fKE23.__rest)(_b, [
                    "hasPreviousPage",
                    "hasNextPage",
                    "startCursor",
                    "endCursor"
                ]);
                // If incoming.pageInfo had any extra non-standard properties,
                // assume they should take precedence over any existing properties
                // of the same name, regardless of where this page falls with
                // respect to the existing data.
                Object.assign(pageInfo, extras);
                // Keep existing.pageInfo.has{Previous,Next}Page unless the
                // placement of the incoming edges means incoming.hasPreviousPage
                // or incoming.hasNextPage should become the new values for those
                // properties in existing.pageInfo. Note that these updates are
                // only permitted when the beginning or end of the incoming page
                // coincides with the beginning or end of the existing data, as
                // determined using prefix.length and suffix.length.
                if (!prefix.length) {
                    if (void 0 !== hasPreviousPage) pageInfo.hasPreviousPage = hasPreviousPage;
                    if (void 0 !== startCursor) pageInfo.startCursor = startCursor;
                }
                if (!suffix.length) {
                    if (void 0 !== hasNextPage) pageInfo.hasNextPage = hasNextPage;
                    if (void 0 !== endCursor) pageInfo.endCursor = endCursor;
                }
            }
            return (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, $3e835cfbd53060c1$var$getExtras(existing)), $3e835cfbd53060c1$var$getExtras(incoming)), {
                edges: edges,
                pageInfo: pageInfo
            });
        }
    };
}
// Returns any unrecognized properties of the given object.
var $3e835cfbd53060c1$var$getExtras = function(obj) {
    return (0, $fKE23.__rest)(obj, $3e835cfbd53060c1$var$notExtras);
};
var $3e835cfbd53060c1$var$notExtras = [
    "edges",
    "pageInfo"
];
function $3e835cfbd53060c1$var$makeEmptyData() {
    return {
        edges: [],
        pageInfo: {
            hasPreviousPage: false,
            hasNextPage: true,
            startCursor: "",
            endCursor: ""
        }
    };
}

});

parcelRegister("3jAGt", function(module, exports) {
module.exports = JSON.parse("{\"CompatibleAtlassianProduct\":[\"CompatibleAtlassianCloudProduct\",\"CompatibleAtlassianDataCenterProduct\",\"CompatibleAtlassianServerProduct\"],\"MarketplaceAppDeployment\":[\"MarketplaceCloudAppDeployment\",\"MarketplaceConnectAppDeployment\",\"MarketplaceInstructionalAppDeployment\",\"MarketplacePlugins1AppDeployment\",\"MarketplacePlugins2AppDeployment\",\"MarketplaceWorkflowAppDeployment\"],\"MarketplaceAppTrustInformationResult\":[\"MarketplaceAppTrustInformation\",\"QueryError\"],\"MarketplaceConsoleEditionResponse\":[\"MarketplaceConsoleEdition\",\"MarketplaceConsoleEditionPricingKnownError\"],\"MarketplaceConsoleEditionsActivationResponse\":[\"MarketplaceConsoleEditionsActivation\",\"MarketplaceConsoleKnownError\"],\"MarketplaceConsoleError\":[\"MarketplaceConsoleEditionPricingKnownError\",\"MarketplaceConsoleGenericError\",\"MarketplaceConsoleKnownError\"],\"MarketplaceStoreCurrentUserResponse\":[\"MarketplaceStoreAnonymousUser\",\"MarketplaceStoreLoggedInUser\"],\"MarketplaceStoreHomePageSection\":[\"MarketplaceStoreHomePageFeaturedSection\",\"MarketplaceStoreHomePageHighlightedSection\",\"MarketplaceStoreHomePageRegularSection\"],\"MarketplaceStorePricingTier\":[\"MarketplaceStorePricingTierAnnual\",\"MarketplaceStorePricingTierMonthly\"]}");

});

parcelRegister("4cJK4", function(module, exports) {

$parcel$export(module.exports, "categoryMergePolicy", () => $30fbc3d9c3248a1a$export$95d59ff3b0a50441);

var $5zQU9 = parcelRequire("5zQU9");

var $egIIy = parcelRequire("egIIy");
function $30fbc3d9c3248a1a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $30fbc3d9c3248a1a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $30fbc3d9c3248a1a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $30fbc3d9c3248a1a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $30fbc3d9c3248a1a$export$95d59ff3b0a50441 = (existing, incoming, _ref)=>{
    let { args: args } = _ref;
    if ((args === null || args === void 0 ? void 0 : args.after) === 0) return incoming;
    return $30fbc3d9c3248a1a$var$_objectSpread($30fbc3d9c3248a1a$var$_objectSpread({}, existing), {}, {
        apps: (0, $egIIy.appSearchMergePolicy)(existing === null || existing === void 0 ? void 0 : existing.apps, incoming === null || incoming === void 0 ? void 0 : incoming.apps, {
            args: args
        })
    });
};

});
parcelRegister("egIIy", function(module, exports) {

$parcel$export(module.exports, "appSearchMergePolicy", () => $a6353f4e5d0ba652$export$eaa9dbdfbe936666);

var $5zQU9 = parcelRequire("5zQU9");
function $a6353f4e5d0ba652$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a6353f4e5d0ba652$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a6353f4e5d0ba652$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a6353f4e5d0ba652$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a6353f4e5d0ba652$export$eaa9dbdfbe936666 = (existing, incoming, _ref)=>{
    let { args: args } = _ref;
    if ((args === null || args === void 0 ? void 0 : args.after) === 0) return incoming;
    return $a6353f4e5d0ba652$var$_objectSpread($a6353f4e5d0ba652$var$_objectSpread({}, incoming), {}, {
        edges: [
            ...existing !== null && existing !== void 0 && existing.edges ? existing.edges : [],
            ...incoming !== null && incoming !== void 0 && incoming.edges ? incoming.edges : []
        ]
    });
};

});


parcelRegister("eVoxO", function(module, exports) {

$parcel$export(module.exports, "collectionMergePolicy", () => $add96d8e9927902c$export$d00bb2e5eb98cc6e);

var $5zQU9 = parcelRequire("5zQU9");

var $egIIy = parcelRequire("egIIy");
function $add96d8e9927902c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $add96d8e9927902c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $add96d8e9927902c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $add96d8e9927902c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $add96d8e9927902c$export$d00bb2e5eb98cc6e = (existing, incoming, _ref)=>{
    let { args: args } = _ref;
    if ((args === null || args === void 0 ? void 0 : args.after) === 0) return incoming;
    return $add96d8e9927902c$var$_objectSpread($add96d8e9927902c$var$_objectSpread({}, existing), {}, {
        apps: (0, $egIIy.appSearchMergePolicy)(existing === null || existing === void 0 ? void 0 : existing.apps, incoming === null || incoming === void 0 ? void 0 : incoming.apps, {
            args: args
        })
    });
};

});

parcelRegister("jaY4q", function(module, exports) {

$parcel$export(module.exports, "partnerProfileMergePolicy", () => $df5d8c32caa8237d$export$ded12f351f4e9327);

var $5zQU9 = parcelRequire("5zQU9");

var $egIIy = parcelRequire("egIIy");
function $df5d8c32caa8237d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $df5d8c32caa8237d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $df5d8c32caa8237d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $df5d8c32caa8237d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $df5d8c32caa8237d$export$ded12f351f4e9327 = (existing, incoming, _ref)=>{
    let { args: args } = _ref;
    if ((args === null || args === void 0 ? void 0 : args.after) === 0) return incoming;
    return $df5d8c32caa8237d$var$_objectSpread($df5d8c32caa8237d$var$_objectSpread($df5d8c32caa8237d$var$_objectSpread({}, existing), incoming), {}, {
        apps: (0, $egIIy.appSearchMergePolicy)(existing === null || existing === void 0 ? void 0 : existing.apps, incoming === null || incoming === void 0 ? void 0 : incoming.apps, {
            args: args
        })
    });
};

});

parcelRegister("lVYdZ", function(module, exports) {

$parcel$export(module.exports, "getVersionHistoryCacheKey", () => $ff7da32fbd7130a4$export$e133a864ff7d5e83);
$parcel$export(module.exports, "getHostingFilterValue", () => $ff7da32fbd7130a4$export$6a11a38ef8ffec02);

var $7R7Sq = parcelRequire("7R7Sq");

var $76fzC = parcelRequire("76fzC");
var $9fEFB = parcelRequire("9fEFB");
var $kVbx1 = parcelRequire("kVbx1");
const $ff7da32fbd7130a4$var$getMedia = (highlights, screenshots)=>{
    const media = [];
    if (highlights) media.push(...highlights.map((highlight)=>({
            __typename: 'MarketplaceVersionHistoryMedia',
            id: highlight.screenshot.image.original.id,
            title: highlight.title,
            url: (0, $9fEFB.mediaImageLink)().expand({
                imageId: highlight.screenshot.image.original.id
            })
        })));
    if (screenshots) media.push(...screenshots.map((screenshot)=>({
            __typename: 'MarketplaceVersionHistoryMedia',
            id: screenshot.image.original.id,
            title: screenshot.caption,
            url: (0, $9fEFB.mediaImageLink)().expand({
                imageId: screenshot.image.original.id
            })
        })));
    return media;
};
const $ff7da32fbd7130a4$var$shouldShowTryBuy = (options)=>{
    const { compatibleProduct: compatibleProduct, paymentModel: paymentModel, listingStatus: listingStatus, entityStatus: entityStatus } = options;
    return compatibleProduct.__typename === 'CompatibleAtlassianDataCenterProduct' && paymentModel === (0, $7R7Sq.MarketplaceAppPaymentModel).PaidViaAtlassian && $ff7da32fbd7130a4$export$4bf91ffd0334d8e0(listingStatus, entityStatus);
};
const $ff7da32fbd7130a4$export$4bf91ffd0334d8e0 = (listingStatus, entityStatus)=>listingStatus === (0, $7R7Sq.MarketplaceListingStatus).Public && entityStatus === (0, $7R7Sq.MarketplaceEntityStatus).Active;
const $ff7da32fbd7130a4$var$getTryUrl = (macBaseUrl, appKey, options)=>{
    const { compatibleProduct: compatibleProduct } = options;
    return $ff7da32fbd7130a4$var$shouldShowTryBuy(options) ? "".concat(macBaseUrl, "/addon/try/").concat(appKey, ".").concat($ff7da32fbd7130a4$var$getAppKeySuffix(compatibleProduct)) : null;
};
const $ff7da32fbd7130a4$var$getBuyUrl = (wacBaseUrl, appKey, options)=>{
    const { compatibleProduct: compatibleProduct } = options;
    return $ff7da32fbd7130a4$var$shouldShowTryBuy(options) ? "".concat(wacBaseUrl, "/purchase/addon/").concat(appKey, ".").concat($ff7da32fbd7130a4$var$getAppKeySuffix(compatibleProduct)) : null;
};
const $ff7da32fbd7130a4$export$db62e9ed3bc748bb = (app, macBaseUrl, mpacBaseUrl, wacBaseUrl)=>{
    var _versions$edges;
    const { versions: versions, appId: appId, appKey: appKey, partner: partner, listingStatus: listingStatus, entityStatus: entityStatus } = app;
    const versionNodes = versions === null || versions === void 0 ? void 0 : (_versions$edges = versions.edges) === null || _versions$edges === void 0 ? void 0 : _versions$edges.map((edge)=>edge === null || edge === void 0 ? void 0 : edge.node).filter(Boolean);
    if (!versionNodes || versionNodes.length === 0) throw new Error('No versions found');
    return {
        __typename: 'MarketplaceVersionHistoryVersions',
        edges: versionNodes.map((node)=>{
            var _node$highlights, _node$screenshots, _node$releaseNotes;
            return {
                __typename: 'MarketplaceVersionHistoryVersionEdge',
                node: {
                    __typename: 'MarketplaceVersionHistoryVersion',
                    // Build numbers are a unique way to identify a version,
                    // staging data has duplicate versions, but build numbers
                    // are always unique across those same versions
                    id: node.buildNumber,
                    // Same version may be compatible with diff products
                    // Currently the API may also return 'CLOUD', although we're passing a
                    // productHostingOptions filter without CLOUD, such values shall be filtered here
                    // Sample staging URL: https://marketplace.stg.internal.atlassian.com/apps/1221613/opsgenie-incident-timeline-lab/version-history?versionHistoryHosting=dataCenter
                    compatibilities: node.deployment.compatibleProducts.map($ff7da32fbd7130a4$var$getCompatibility).filter(Boolean),
                    releaseDate: (0, $76fzC).ISOFormatHyphenatedDate(node.releaseDate),
                    releaseSummary: node.releaseSummary,
                    version: node.version,
                    media: $ff7da32fbd7130a4$var$getMedia((_node$highlights = node.highlights) !== null && _node$highlights !== void 0 ? _node$highlights : [], (_node$screenshots = node.screenshots) !== null && _node$screenshots !== void 0 ? _node$screenshots : []),
                    releaseNotes: (_node$releaseNotes = node.releaseNotes) !== null && _node$releaseNotes !== void 0 ? _node$releaseNotes : 'No release notes',
                    paymentModel: (0, $kVbx1).mapPaymentModelToDisplayValue(node.paymentModel),
                    license: node.licenseType ? {
                        type: node.licenseType.name,
                        url: node.licenseType.link
                    } : null,
                    supportDetail: node.isSupported ? "Supported".concat(partner !== null && partner !== void 0 && partner.name ? " by ".concat(partner === null || partner === void 0 ? void 0 : partner.name) : '') : 'Not Supported',
                    downloadUrl: $ff7da32fbd7130a4$export$4bf91ffd0334d8e0(listingStatus, entityStatus) ? "".concat(mpacBaseUrl, "/download/apps/").concat(appId, "/version/").concat(node.buildNumber) : null,
                    tryUrl: $ff7da32fbd7130a4$var$getTryUrl(macBaseUrl, appKey, {
                        compatibleProduct: node.deployment.compatibleProducts[0],
                        paymentModel: node.paymentModel,
                        listingStatus: listingStatus,
                        entityStatus: entityStatus
                    }),
                    buyUrl: $ff7da32fbd7130a4$var$getBuyUrl(wacBaseUrl, appKey, {
                        compatibleProduct: node.deployment.compatibleProducts[0],
                        paymentModel: node.paymentModel,
                        listingStatus: listingStatus,
                        entityStatus: entityStatus
                    })
                }
            };
        }),
        pageInfo: versions.pageInfo,
        totalCount: versions.totalCount
    };
};
const $ff7da32fbd7130a4$var$getAppKeySuffix = (compatibleProduct)=>{
    switch(compatibleProduct.__typename){
        case 'CompatibleAtlassianServerProduct':
            return 'server';
        case 'CompatibleAtlassianDataCenterProduct':
            return 'data-center';
        default:
            return '';
    }
};
const $ff7da32fbd7130a4$var$getCompatibility = (compatibleProduct)=>{
    switch(compatibleProduct.__typename){
        case 'CompatibleAtlassianServerProduct':
        case 'CompatibleAtlassianDataCenterProduct':
            {
                var _compatibleProduct$at;
                const product = (_compatibleProduct$at = compatibleProduct.atlassianProduct) === null || _compatibleProduct$at === void 0 ? void 0 : _compatibleProduct$at.name;
                const hosting = compatibleProduct.__typename === 'CompatibleAtlassianDataCenterProduct' ? 'Data Center' : 'Server';
                const minVersion = compatibleProduct.minimumVersion;
                const maxVersion = compatibleProduct.maximumVersion;
                const versionRange = minVersion === maxVersion ? minVersion : "".concat(minVersion, " - ").concat(maxVersion);
                return "".concat(product, " ").concat(hosting, " ").concat(versionRange);
            }
        default:
            return null;
    }
};
const $ff7da32fbd7130a4$export$e133a864ff7d5e83 = (appId, hostingFilter)=>"".concat(appId).concat(hostingFilter ? "-".concat(hostingFilter) : '');
const $ff7da32fbd7130a4$export$6a11a38ef8ffec02 = (filters)=>{
    var _filters$versionHisto;
    if (!(filters !== null && filters !== void 0 && (_filters$versionHisto = filters.versionHistoryHosting) !== null && _filters$versionHisto !== void 0 && _filters$versionHisto[0])) return null;
    return filters.versionHistoryHosting[0].value;
};

});
parcelRegister("kVbx1", function(module, exports) {

$parcel$export(module.exports, "mapPaymentModelToDisplayValue", () => $f3b21373907556a1$export$7904242669e83651);

var $ammkg = parcelRequire("ammkg");
const $f3b21373907556a1$var$PaymentModelToDisplayNameMapping = {
    [(0, $ammkg.MarketplaceAppPaymentModel).Free]: 'Free',
    [(0, $ammkg.MarketplaceAppPaymentModel).PaidViaAtlassian]: 'Paid via Atlassian',
    [(0, $ammkg.MarketplaceAppPaymentModel).PaidViaPartner]: 'Paid via Vendor'
};
const $f3b21373907556a1$export$7904242669e83651 = (paymentModel)=>{
    return $f3b21373907556a1$var$PaymentModelToDisplayNameMapping[paymentModel];
};

});



parcelRegister("eibaj", function(module, exports) {

$parcel$export(module.exports, "createApolloClient", () => $a67b684ed92b18ac$export$67100df7b1079985);

var $9kaar = parcelRequire("9kaar");

var $8t43A = parcelRequire("8t43A");
const $a67b684ed92b18ac$var$appendAggParametersForDev = (uri)=>{
    return uri;
};
const $a67b684ed92b18ac$export$67100df7b1079985 = (options)=>{
    const { uri: uri, name: name, version: version, ssrMode: ssrMode = false, cache: cache, gqlOrchestratorLinkOptions: gqlOrchestratorLinkOptions, typeDefs: typeDefs } = options;
    const getClient = ()=>client;
    const client = new (0, $9kaar.ApolloClient)({
        cache: cache,
        ssrMode: ssrMode,
        typeDefs: typeDefs,
        link: (0, $8t43A.createApolloLinks)({
            uri: $a67b684ed92b18ac$var$appendAggParametersForDev(uri),
            name: name,
            version: version,
            getClient: getClient,
            gqlOrchestratorLinkOptions: gqlOrchestratorLinkOptions
        })
    });
    return client;
};

});
parcelRegister("9kaar", function(module, exports) {

$parcel$export(module.exports, "ApolloClient", () => $6c9dde5a08d3df9c$export$13f5a5f0f1dbab88);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $3l0mk = parcelRequire("3l0mk");
var $5kEJu = parcelRequire("5kEJu");

var $76T0U = parcelRequire("76T0U");

var $1jqOV = parcelRequire("1jqOV");

var $jCuxd = parcelRequire("jCuxd");

var $6bzG9 = parcelRequire("6bzG9");

var $hcvqr = parcelRequire("hcvqr");

var $7XZ8S = parcelRequire("7XZ8S");
var $6c9dde5a08d3df9c$var$hasSuggestedDevtools = false;
/**
 * This is the primary Apollo Client class. It is used to send GraphQL documents (i.e. queries
 * and mutations) to a GraphQL spec-compliant server over an {@link ApolloLink} instance,
 * receive results from the server and cache the results in a store. It also delivers updates
 * to GraphQL queries through {@link Observable} instances.
 */ var $6c9dde5a08d3df9c$export$13f5a5f0f1dbab88 = /** @class */ function() {
    /**
     * Constructs an instance of {@link ApolloClient}.
     *
     * @example
     * ```js
     * import { ApolloClient, InMemoryCache } from '@apollo/client';
     *
     * const cache = new InMemoryCache();
     *
     * const client = new ApolloClient({
     *   // Provide required constructor fields
     *   cache: cache,
     *   uri: 'http://localhost:4000/',
     *
     *   // Provide some optional constructor fields
     *   name: 'react-web-client',
     *   version: '1.3',
     *   queryDeduplication: false,
     *   defaultOptions: {
     *     watchQuery: {
     *       fetchPolicy: 'cache-and-network',
     *     },
     *   },
     * });
     * ```
     */ function ApolloClient(options) {
        var _this = this;
        this.resetStoreCallbacks = [];
        this.clearStoreCallbacks = [];
        if (!options.cache) throw (0, $kL4FQ.newInvariantError)(15);
        var uri = options.uri, credentials = options.credentials, headers = options.headers, cache = options.cache, documentTransform = options.documentTransform, _a = options.ssrMode, ssrMode = _a === void 0 ? false : _a, _b = options.ssrForceFetchDelay, ssrForceFetchDelay = _b === void 0 ? 0 : _b, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        _c = options.connectToDevTools, // Expose the client instance as window.__APOLLO_CLIENT__ and call
        // onBroadcast in queryManager.broadcastQueries to enable browser
        // devtools, but disable them by default in production.
        connectToDevTools = _c === void 0 ? typeof window === "object" && !window.__APOLLO_CLIENT__ && globalThis.__DEV__ !== false : _c, _d = options.queryDeduplication, queryDeduplication = _d === void 0 ? true : _d, defaultOptions = options.defaultOptions, defaultContext = options.defaultContext, _e = options.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? cache.assumeImmutableResults : _e, resolvers = options.resolvers, typeDefs = options.typeDefs, fragmentMatcher = options.fragmentMatcher, clientAwarenessName = options.name, clientAwarenessVersion = options.version;
        var link = options.link;
        if (!link) link = uri ? new (0, $1jqOV.HttpLink)({
            uri: uri,
            credentials: credentials,
            headers: headers
        }) : (0, $3l0mk.ApolloLink).empty();
        this.link = link;
        this.cache = cache;
        this.disableNetworkFetches = ssrMode || ssrForceFetchDelay > 0;
        this.queryDeduplication = queryDeduplication;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.typeDefs = typeDefs;
        if (ssrForceFetchDelay) setTimeout(function() {
            return _this.disableNetworkFetches = false;
        }, ssrForceFetchDelay);
        this.watchQuery = this.watchQuery.bind(this);
        this.query = this.query.bind(this);
        this.mutate = this.mutate.bind(this);
        this.resetStore = this.resetStore.bind(this);
        this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this);
        this.version = (0, $76T0U.version);
        this.localState = new (0, $6bzG9.LocalState)({
            cache: cache,
            client: this,
            resolvers: resolvers,
            fragmentMatcher: fragmentMatcher
        });
        this.queryManager = new (0, $jCuxd.QueryManager)({
            cache: this.cache,
            link: this.link,
            defaultOptions: this.defaultOptions,
            defaultContext: defaultContext,
            documentTransform: documentTransform,
            queryDeduplication: queryDeduplication,
            ssrMode: ssrMode,
            clientAwareness: {
                name: clientAwarenessName,
                version: clientAwarenessVersion
            },
            localState: this.localState,
            assumeImmutableResults: assumeImmutableResults,
            onBroadcast: connectToDevTools ? function() {
                if (_this.devToolsHookCb) _this.devToolsHookCb({
                    action: {},
                    state: {
                        queries: _this.queryManager.getQueryStore(),
                        mutations: _this.queryManager.mutationStore || {}
                    },
                    dataWithOptimisticResults: _this.cache.extract(true)
                });
            } : void 0
        });
        if (connectToDevTools) this.connectToDevTools();
    }
    ApolloClient.prototype.connectToDevTools = function() {
        if (typeof window === "object") {
            var windowWithDevTools = window;
            var devtoolsSymbol = Symbol.for("apollo.devtools");
            (windowWithDevTools[devtoolsSymbol] = windowWithDevTools[devtoolsSymbol] || []).push(this);
            windowWithDevTools.__APOLLO_CLIENT__ = this;
        }
        /**
         * Suggest installing the devtools for developers who don't have them
         */ if (!$6c9dde5a08d3df9c$var$hasSuggestedDevtools && globalThis.__DEV__ !== false) {
            $6c9dde5a08d3df9c$var$hasSuggestedDevtools = true;
            setTimeout(function() {
                if (typeof window !== "undefined" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
                    var nav = window.navigator;
                    var ua = nav && nav.userAgent;
                    var url = void 0;
                    if (typeof ua === "string") {
                        if (ua.indexOf("Chrome/") > -1) url = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm";
                        else if (ua.indexOf("Firefox/") > -1) url = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/";
                    }
                    if (url) globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).log("Download the Apollo DevTools for a better development experience: %s", url);
                }
            }, 10000);
        }
    };
    Object.defineProperty(ApolloClient.prototype, "documentTransform", {
        /**
         * The `DocumentTransform` used to modify GraphQL documents before a request
         * is made. If a custom `DocumentTransform` is not provided, this will be the
         * default document transform.
         */ get: function() {
            return this.queryManager.documentTransform;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Call this method to terminate any active client processes, making it safe
     * to dispose of this `ApolloClient` instance.
     */ ApolloClient.prototype.stop = function() {
        this.queryManager.stop();
    };
    /**
     * This watches the cache store of the query according to the options specified and
     * returns an {@link ObservableQuery}. We can subscribe to this {@link ObservableQuery} and
     * receive updated results through a GraphQL observer when the cache store changes.
     *
     * Note that this method is not an implementation of GraphQL subscriptions. Rather,
     * it uses Apollo's store in order to reactively deliver updates to your query results.
     *
     * For example, suppose you call watchQuery on a GraphQL query that fetches a person's
     * first and last name and this person has a particular object identifier, provided by
     * dataIdFromObject. Later, a different query fetches that same person's
     * first and last name and the first name has now changed. Then, any observers associated
     * with the results of the first query will be updated with a new result object.
     *
     * Note that if the cache does not change, the subscriber will *not* be notified.
     *
     * See [here](https://medium.com/apollo-stack/the-concepts-of-graphql-bc68bd819be3#.3mb0cbcmc) for
     * a description of store reactivity.
     */ ApolloClient.prototype.watchQuery = function(options) {
        if (this.defaultOptions.watchQuery) options = (0, $hcvqr.mergeOptions)(this.defaultOptions.watchQuery, options);
        // XXX Overwriting options is probably not the best way to do this long term...
        if (this.disableNetworkFetches && (options.fetchPolicy === "network-only" || options.fetchPolicy === "cache-and-network")) options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.watchQuery(options);
    };
    /**
     * This resolves a single query according to the options specified and
     * returns a `Promise` which is either resolved with the resulting data
     * or rejected with an error.
     *
     * @param options - An object of type {@link QueryOptions} that allows us to
     * describe how this query should be treated e.g. whether it should hit the
     * server at all or just resolve from the cache, etc.
     */ ApolloClient.prototype.query = function(options) {
        if (this.defaultOptions.query) options = (0, $hcvqr.mergeOptions)(this.defaultOptions.query, options);
        (0, $kL4FQ.invariant)(options.fetchPolicy !== "cache-and-network", 16);
        if (this.disableNetworkFetches && options.fetchPolicy === "network-only") options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            fetchPolicy: "cache-first"
        });
        return this.queryManager.query(options);
    };
    /**
     * This resolves a single mutation according to the options specified and returns a
     * Promise which is either resolved with the resulting data or rejected with an
     * error. In some cases both `data` and `errors` might be undefined, for example
     * when `errorPolicy` is set to `'ignore'`.
     *
     * It takes options as an object with the following keys and values:
     */ ApolloClient.prototype.mutate = function(options) {
        if (this.defaultOptions.mutate) options = (0, $hcvqr.mergeOptions)(this.defaultOptions.mutate, options);
        return this.queryManager.mutate(options);
    };
    /**
     * This subscribes to a graphql subscription according to the options specified and returns an
     * {@link Observable} which either emits received data or an error.
     */ ApolloClient.prototype.subscribe = function(options) {
        return this.queryManager.startGraphQLSubscription(options);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL query without making a network request. This method will start at
     * the root query. To start at a specific id returned by `dataIdFromObject`
     * use `readFragment`.
     *
     * @param optimistic - Set to `true` to allow `readQuery` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readQuery(options, optimistic);
    };
    /**
     * Tries to read some data from the store in the shape of the provided
     * GraphQL fragment without making a network request. This method will read a
     * GraphQL fragment from any arbitrary id that is currently cached, unlike
     * `readQuery` which will only read from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are reading. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     *
     * @param optimistic - Set to `true` to allow `readFragment` to return
     * optimistic results. Is `false` by default.
     */ ApolloClient.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.cache.readFragment(options, optimistic);
    };
    /**
     * Writes some data in the shape of the provided GraphQL query directly to
     * the store. This method will start at the root query. To start at a
     * specific id returned by `dataIdFromObject` then use `writeFragment`.
     */ ApolloClient.prototype.writeQuery = function(options) {
        var ref = this.cache.writeQuery(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    /**
     * Writes some data in the shape of the provided GraphQL fragment directly to
     * the store. This method will write to a GraphQL fragment from any arbitrary
     * id that is currently cached, unlike `writeQuery` which will only write
     * from the root query.
     *
     * You must pass in a GraphQL document with a single fragment or a document
     * with multiple fragments that represent what you are writing. If you pass
     * in a document with multiple fragments then you must also specify a
     * `fragmentName`.
     */ ApolloClient.prototype.writeFragment = function(options) {
        var ref = this.cache.writeFragment(options);
        if (options.broadcast !== false) this.queryManager.broadcastQueries();
        return ref;
    };
    ApolloClient.prototype.__actionHookForDevTools = function(cb) {
        this.devToolsHookCb = cb;
    };
    ApolloClient.prototype.__requestRaw = function(payload) {
        return (0, $5kEJu.execute)(this.link, payload);
    };
    /**
     * Resets your entire store by clearing out your cache and then re-executing
     * all of your active queries. This makes it so that you may guarantee that
     * there is no data left in your store from a time before you called this
     * method.
     *
     * `resetStore()` is useful when your user just logged out. You’ve removed the
     * user session, and you now want to make sure that any references to data you
     * might have fetched while the user session was active is gone.
     *
     * It is important to remember that `resetStore()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.resetStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: false
            });
        }).then(function() {
            return Promise.all(_this.resetStoreCallbacks.map(function(fn) {
                return fn();
            }));
        }).then(function() {
            return _this.reFetchObservableQueries();
        });
    };
    /**
     * Remove all data from the store. Unlike `resetStore`, `clearStore` will
     * not refetch any active queries.
     */ ApolloClient.prototype.clearStore = function() {
        var _this = this;
        return Promise.resolve().then(function() {
            return _this.queryManager.clearStore({
                discardWatches: true
            });
        }).then(function() {
            return Promise.all(_this.clearStoreCallbacks.map(function(fn) {
                return fn();
            }));
        });
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * reset. `onResetStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onResetStore = function(cb) {
        var _this = this;
        this.resetStoreCallbacks.push(cb);
        return function() {
            _this.resetStoreCallbacks = _this.resetStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Allows callbacks to be registered that are executed when the store is
     * cleared. `onClearStore` returns an unsubscribe function that can be used
     * to remove registered callbacks.
     */ ApolloClient.prototype.onClearStore = function(cb) {
        var _this = this;
        this.clearStoreCallbacks.push(cb);
        return function() {
            _this.clearStoreCallbacks = _this.clearStoreCallbacks.filter(function(c) {
                return c !== cb;
            });
        };
    };
    /**
     * Refetches all of your active queries.
     *
     * `reFetchObservableQueries()` is useful if you want to bring the client back to proper state in case of a network outage
     *
     * It is important to remember that `reFetchObservableQueries()` *will* refetch any active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     * Takes optional parameter `includeStandby` which will include queries in standby-mode when refetching.
     */ ApolloClient.prototype.reFetchObservableQueries = function(includeStandby) {
        return this.queryManager.reFetchObservableQueries(includeStandby);
    };
    /**
     * Refetches specified active queries. Similar to "reFetchObservableQueries()" but with a specific list of queries.
     *
     * `refetchQueries()` is useful for use cases to imperatively refresh a selection of queries.
     *
     * It is important to remember that `refetchQueries()` *will* refetch specified active
     * queries. This means that any components that might be mounted will execute
     * their queries again using your network interface. If you do not want to
     * re-execute any queries then you should make sure to stop watching any
     * active queries.
     */ ApolloClient.prototype.refetchQueries = function(options) {
        var map = this.queryManager.refetchQueries(options);
        var queries = [];
        var results = [];
        map.forEach(function(result, obsQuery) {
            queries.push(obsQuery);
            results.push(result);
        });
        var result = Promise.all(results);
        // In case you need the raw results immediately, without awaiting
        // Promise.all(results):
        result.queries = queries;
        result.results = results;
        // If you decide to ignore the result Promise because you're using
        // result.queries and result.results instead, you shouldn't have to worry
        // about preventing uncaught rejections for the Promise.all result.
        result.catch(function(error) {
            globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).debug(17, error);
        });
        return result;
    };
    /**
     * Get all currently active `ObservableQuery` objects, in a `Map` keyed by
     * query ID strings.
     *
     * An "active" query is one that has observers and a `fetchPolicy` other than
     * "standby" or "cache-only".
     *
     * You can include all `ObservableQuery` objects (including the inactive ones)
     * by passing "all" instead of "active", or you can include just a subset of
     * active queries by passing an array of query names or DocumentNode objects.
     */ ApolloClient.prototype.getObservableQueries = function(include) {
        if (include === void 0) include = "active";
        return this.queryManager.getObservableQueries(include);
    };
    /**
     * Exposes the cache's complete state, in a serializable format for later restoration.
     */ ApolloClient.prototype.extract = function(optimistic) {
        return this.cache.extract(optimistic);
    };
    /**
     * Replaces existing state in the cache (if any) with the values expressed by
     * `serializedState`.
     *
     * Called when hydrating a cache (server side rendering, or offline storage),
     * and also (potentially) during hot reloads.
     */ ApolloClient.prototype.restore = function(serializedState) {
        return this.cache.restore(serializedState);
    };
    /**
     * Add additional local resolvers.
     */ ApolloClient.prototype.addResolvers = function(resolvers) {
        this.localState.addResolvers(resolvers);
    };
    /**
     * Set (override existing) local resolvers.
     */ ApolloClient.prototype.setResolvers = function(resolvers) {
        this.localState.setResolvers(resolvers);
    };
    /**
     * Get all registered local resolvers.
     */ ApolloClient.prototype.getResolvers = function() {
        return this.localState.getResolvers();
    };
    /**
     * Set a custom local state fragment matcher.
     */ ApolloClient.prototype.setLocalStateFragmentMatcher = function(fragmentMatcher) {
        this.localState.setFragmentMatcher(fragmentMatcher);
    };
    /**
     * Define a new ApolloLink (or link chain) that Apollo Client will use.
     */ ApolloClient.prototype.setLink = function(newLink) {
        this.link = this.queryManager.link = newLink;
    };
    Object.defineProperty(ApolloClient.prototype, "defaultContext", {
        get: function() {
            return this.queryManager.defaultContext;
        },
        enumerable: false,
        configurable: true
    });
    return ApolloClient;
}();
if (globalThis.__DEV__ !== false) $6c9dde5a08d3df9c$export$13f5a5f0f1dbab88.prototype.getMemoryInternals = (0, $7XZ8S.getApolloClientMemoryInternals);

});
parcelRegister("3l0mk", function(module, exports) {

$parcel$export(module.exports, "ApolloLink", () => $26e39c92bdf3eb59$export$2fed3d61f740bc7f);
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");
parcelRequire("eayTI");
var $8E6bd = parcelRequire("8E6bd");

var $5kNGm = parcelRequire("5kNGm");
var $lP9bY = parcelRequire("lP9bY");
var $f1Ltd = parcelRequire("f1Ltd");
function $26e39c92bdf3eb59$var$passthrough(op, forward) {
    return forward ? forward(op) : (0, $8E6bd.Observable).of();
}
function $26e39c92bdf3eb59$var$toLink(handler) {
    return typeof handler === "function" ? new $26e39c92bdf3eb59$export$2fed3d61f740bc7f(handler) : handler;
}
function $26e39c92bdf3eb59$var$isTerminating(link) {
    return link.request.length <= 1;
}
var $26e39c92bdf3eb59$export$2fed3d61f740bc7f = /** @class */ function() {
    function ApolloLink(request) {
        if (request) this.request = request;
    }
    ApolloLink.empty = function() {
        return new ApolloLink(function() {
            return (0, $8E6bd.Observable).of();
        });
    };
    ApolloLink.from = function(links) {
        if (links.length === 0) return ApolloLink.empty();
        return links.map($26e39c92bdf3eb59$var$toLink).reduce(function(x, y) {
            return x.concat(y);
        });
    };
    ApolloLink.split = function(test, left, right) {
        var leftLink = $26e39c92bdf3eb59$var$toLink(left);
        var rightLink = $26e39c92bdf3eb59$var$toLink(right || new ApolloLink($26e39c92bdf3eb59$var$passthrough));
        var ret;
        if ($26e39c92bdf3eb59$var$isTerminating(leftLink) && $26e39c92bdf3eb59$var$isTerminating(rightLink)) ret = new ApolloLink(function(operation) {
            return test(operation) ? leftLink.request(operation) || (0, $8E6bd.Observable).of() : rightLink.request(operation) || (0, $8E6bd.Observable).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return test(operation) ? leftLink.request(operation, forward) || (0, $8E6bd.Observable).of() : rightLink.request(operation, forward) || (0, $8E6bd.Observable).of();
        });
        return Object.assign(ret, {
            left: leftLink,
            right: rightLink
        });
    };
    ApolloLink.execute = function(link, operation) {
        return link.request((0, $5kNGm.createOperation)(operation.context, (0, $lP9bY.transformOperation)((0, $f1Ltd.validateOperation)(operation)))) || (0, $8E6bd.Observable).of();
    };
    ApolloLink.concat = function(first, second) {
        var firstLink = $26e39c92bdf3eb59$var$toLink(first);
        if ($26e39c92bdf3eb59$var$isTerminating(firstLink)) {
            globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).warn(35, firstLink);
            return firstLink;
        }
        var nextLink = $26e39c92bdf3eb59$var$toLink(second);
        var ret;
        if ($26e39c92bdf3eb59$var$isTerminating(nextLink)) ret = new ApolloLink(function(operation) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op) || (0, $8E6bd.Observable).of();
            }) || (0, $8E6bd.Observable).of();
        });
        else ret = new ApolloLink(function(operation, forward) {
            return firstLink.request(operation, function(op) {
                return nextLink.request(op, forward) || (0, $8E6bd.Observable).of();
            }) || (0, $8E6bd.Observable).of();
        });
        return Object.assign(ret, {
            left: firstLink,
            right: nextLink
        });
    };
    ApolloLink.prototype.split = function(test, left, right) {
        return this.concat(ApolloLink.split(test, left, right || new ApolloLink($26e39c92bdf3eb59$var$passthrough)));
    };
    ApolloLink.prototype.concat = function(next) {
        return ApolloLink.concat(this, next);
    };
    ApolloLink.prototype.request = function(operation, forward) {
        throw (0, $kL4FQ.newInvariantError)(36);
    };
    ApolloLink.prototype.onError = function(error, observer) {
        if (observer && observer.error) {
            observer.error(error);
            // Returning false indicates that observer.error does not need to be
            // called again, since it was already called (on the previous line).
            // Calling observer.error again would not cause any real problems,
            // since only the first call matters, but custom onError functions
            // might have other reasons for wanting to prevent the default
            // behavior by returning false.
            return false;
        }
        // Throw errors will be passed to observer.error.
        throw error;
    };
    ApolloLink.prototype.setOnError = function(fn) {
        this.onError = fn;
        return this;
    };
    return ApolloLink;
}();

});
parcelRegister("5kNGm", function(module, exports) {

$parcel$export(module.exports, "createOperation", () => $3e255bdc6d75e48d$export$f29bedd62f56fcb2);

var $fKE23 = parcelRequire("fKE23");
function $3e255bdc6d75e48d$export$f29bedd62f56fcb2(starting, operation) {
    var context = (0, $fKE23.__assign)({}, starting);
    var setContext = function(next) {
        if (typeof next === "function") context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), next(context));
        else context = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), next);
    };
    var getContext = function() {
        return (0, $fKE23.__assign)({}, context);
    };
    Object.defineProperty(operation, "setContext", {
        enumerable: false,
        value: setContext
    });
    Object.defineProperty(operation, "getContext", {
        enumerable: false,
        value: getContext
    });
    return operation;
}

});

parcelRegister("lP9bY", function(module, exports) {

$parcel$export(module.exports, "transformOperation", () => $fe357dbc10a02274$export$4f3f7df1b558c729);

var $iX694 = parcelRequire("iX694");
function $fe357dbc10a02274$export$4f3f7df1b558c729(operation) {
    var transformedOperation = {
        variables: operation.variables || {},
        extensions: operation.extensions || {},
        operationName: operation.operationName,
        query: operation.query
    };
    // Best guess at an operation name
    if (!transformedOperation.operationName) transformedOperation.operationName = typeof transformedOperation.query !== "string" ? (0, $iX694.getOperationName)(transformedOperation.query) || undefined : "";
    return transformedOperation;
}

});

parcelRegister("f1Ltd", function(module, exports) {

$parcel$export(module.exports, "validateOperation", () => $af0bc59a10951299$export$a92a48117d546c9);
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");
function $af0bc59a10951299$export$a92a48117d546c9(operation) {
    var OPERATION_FIELDS = [
        "query",
        "operationName",
        "variables",
        "extensions",
        "context"
    ];
    for(var _i = 0, _a = Object.keys(operation); _i < _a.length; _i++){
        var key = _a[_i];
        if (OPERATION_FIELDS.indexOf(key) < 0) throw (0, $kL4FQ.newInvariantError)(43, key);
    }
    return operation;
}

});


parcelRegister("5kEJu", function(module, exports) {

$parcel$export(module.exports, "execute", () => $3e1e6aad93290903$export$51396ec711da548b);

var $3l0mk = parcelRequire("3l0mk");
var $3e1e6aad93290903$export$51396ec711da548b = (0, $3l0mk.ApolloLink).execute;

});

parcelRegister("1jqOV", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $0f4c5ec621519bf4$export$f4bbf1aec241cc1);

var $fKE23 = parcelRequire("fKE23");

var $3l0mk = parcelRequire("3l0mk");

var $5aRM1 = parcelRequire("5aRM1");
var $0f4c5ec621519bf4$export$f4bbf1aec241cc1 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(HttpLink, _super);
    function HttpLink(options) {
        if (options === void 0) options = {};
        var _this = _super.call(this, (0, $5aRM1.createHttpLink)(options).request) || this;
        _this.options = options;
        return _this;
    }
    return HttpLink;
}((0, $3l0mk.ApolloLink));

});
parcelRegister("5aRM1", function(module, exports) {

$parcel$export(module.exports, "createHttpLink", () => $3c47993b91cd58b2$export$95180a16573d6675);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $3l0mk = parcelRequire("3l0mk");

var $iX694 = parcelRequire("iX694");
var $jHSHK = parcelRequire("jHSHK");parcelRequire("aJBWo");
var $krE5f = parcelRequire("krE5f");parcelRequire("eayTI");
var $8E6bd = parcelRequire("8E6bd");
var $1CBce = parcelRequire("1CBce");

var $f2A0H = parcelRequire("f2A0H");

var $fRf2C = parcelRequire("fRf2C");

var $9JtAF = parcelRequire("9JtAF");

var $6PeMF = parcelRequire("6PeMF");

var $4cBEf = parcelRequire("4cBEf");

var $6WFFl = parcelRequire("6WFFl");

var $7a3PP = parcelRequire("7a3PP");
var $3oJi2 = parcelRequire("3oJi2");
var $3c47993b91cd58b2$var$backupFetch = (0, $krE5f.maybe)(function() {
    return fetch;
});
var $3c47993b91cd58b2$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? "/graphql" : _a, // use default global fetch if nothing passed in
    preferredFetch = linkOptions.fetch, _b = linkOptions.print, print = _b === void 0 ? (0, $4cBEf.defaultPrinter) : _b, includeExtensions = linkOptions.includeExtensions, preserveHeaderCase = linkOptions.preserveHeaderCase, useGETForQueries = linkOptions.useGETForQueries, _c = linkOptions.includeUnusedVariables, includeUnusedVariables = _c === void 0 ? false : _c, requestOptions = (0, $fKE23.__rest)(linkOptions, [
        "uri",
        "fetch",
        "print",
        "includeExtensions",
        "preserveHeaderCase",
        "useGETForQueries",
        "includeUnusedVariables"
    ]);
    if (globalThis.__DEV__ !== false) // Make sure at least one of preferredFetch, window.fetch, or backupFetch is
    // defined, so requests won't fail at runtime.
    (0, $6PeMF.checkFetcher)(preferredFetch || $3c47993b91cd58b2$var$backupFetch);
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions,
            preserveHeaderCase: preserveHeaderCase
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $3l0mk.ApolloLink)(function(operation) {
        var chosenURI = (0, $fRf2C.selectURI)(operation, uri);
        var context = operation.getContext();
        // `apollographql-client-*` headers are automatically set if a
        // `clientAwareness` object is found in the context. These headers are
        // set first, followed by the rest of the headers pulled from
        // `context.headers`. If desired, `apollographql-client-*` headers set by
        // the `clientAwareness` object can be overridden by
        // `apollographql-client-*` headers set in `context.headers`.
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders["apollographql-client-name"] = name_1;
            if (version) clientAwarenessHeaders["apollographql-client-version"] = version;
        }
        var contextHeaders = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, clientAwarenessHeaders), context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        if ((0, $jHSHK.hasDirectives)([
            "client"
        ], operation.query)) {
            var transformedQuery = (0, $1CBce.removeClientSetsFromDocument)(operation.query);
            if (!transformedQuery) return (0, $3oJi2.fromError)(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
            operation.query = transformedQuery;
        }
        //uses fallback, link, and then context to build options
        var _b = (0, $4cBEf.selectHttpOptionsAndBodyInternal)(operation, print, (0, $4cBEf.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        if (body.variables && !includeUnusedVariables) body.variables = (0, $7a3PP.filterOperationVariables)(body.variables, operation.query);
        var controller;
        if (!options.signal && typeof AbortController !== "undefined") {
            controller = new AbortController();
            options.signal = controller.signal;
        }
        // If requested, set method to GET if there are no mutations.
        var definitionIsMutation = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "mutation";
        };
        var definitionIsSubscription = function(d) {
            return d.kind === "OperationDefinition" && d.operation === "subscription";
        };
        var isSubscription = definitionIsSubscription((0, $iX694.getMainDefinition)(operation.query));
        // does not match custom directives beginning with @defer
        var hasDefer = (0, $jHSHK.hasDirectives)([
            "defer"
        ], operation.query);
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = "GET";
        if (hasDefer || isSubscription) {
            options.headers = options.headers || {};
            var acceptHeader = "multipart/mixed;";
            // Omit defer-specific headers if the user attempts to defer a selection
            // set on a subscription and log a warning.
            if (isSubscription && hasDefer) globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).warn(38);
            if (isSubscription) acceptHeader += "boundary=graphql;subscriptionSpec=1.0,application/json";
            else if (hasDefer) acceptHeader += "deferSpec=20220824,application/json";
            options.headers.accept = acceptHeader;
        }
        if (options.method === "GET") {
            var _c = (0, $6WFFl.rewriteURIForGET)(chosenURI, body), newURI = _c.newURI, parseError = _c.parseError;
            if (parseError) return (0, $3oJi2.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $f2A0H.serializeFetchParameter)(body, "Payload");
        } catch (parseError) {
            return (0, $3oJi2.fromError)(parseError);
        }
        return new (0, $8E6bd.Observable)(function(observer) {
            // Prefer linkOptions.fetch (preferredFetch) if provided, and otherwise
            // fall back to the *current* global window.fetch function (see issue
            // #7832), or (if all else fails) the backupFetch function we saved when
            // this module was first evaluated. This last option protects against the
            // removal of window.fetch, which is unlikely but not impossible.
            var currentFetch = preferredFetch || (0, $krE5f.maybe)(function() {
                return fetch;
            }) || $3c47993b91cd58b2$var$backupFetch;
            var observerNext = observer.next.bind(observer);
            currentFetch(chosenURI, options).then(function(response) {
                var _a;
                operation.setContext({
                    response: response
                });
                var ctype = (_a = response.headers) === null || _a === void 0 ? void 0 : _a.get("content-type");
                if (ctype !== null && /^multipart\/mixed/i.test(ctype)) return (0, $9JtAF.readMultipartBody)(response, observerNext);
                else return (0, $9JtAF.parseAndCheckHttpResponse)(operation)(response).then(observerNext);
            }).then(function() {
                controller = undefined;
                observer.complete();
            }).catch(function(err) {
                controller = undefined;
                (0, $9JtAF.handleError)(err, observer);
            });
            return function() {
                // XXX support canceling this request
                // https://developers.google.com/web/updates/2017/09/abortable-fetch
                if (controller) controller.abort();
            };
        });
    });
};

});
parcelRegister("f2A0H", function(module, exports) {

$parcel$export(module.exports, "serializeFetchParameter", () => $af32f9cff33bfe25$export$5f8e80ac52052e28);
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");
var $af32f9cff33bfe25$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = (0, $kL4FQ.newInvariantError)(39, label, e.message);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};

});

parcelRegister("fRf2C", function(module, exports) {

$parcel$export(module.exports, "selectURI", () => $b8b7791d6e211b13$export$63ccc2571850f81a);
var $b8b7791d6e211b13$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === "function") return fallbackURI(operation);
    else return fallbackURI || "/graphql";
};

});

parcelRegister("9JtAF", function(module, exports) {

$parcel$export(module.exports, "readMultipartBody", () => $715f45118885a354$export$ccb60864026baf09);
$parcel$export(module.exports, "handleError", () => $715f45118885a354$export$d3da1ecaf1206c58);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $715f45118885a354$export$d4051215bea0639f);

var $fKE23 = parcelRequire("fKE23");

var $4ylXW = parcelRequire("4ylXW");

var $1rXZG = parcelRequire("1rXZG");

var $7BIXz = parcelRequire("7BIXz");

var $dajVc = parcelRequire("dajVc");
var $715f45118885a354$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $715f45118885a354$export$ccb60864026baf09(response, nextValue) {
    return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
        var decoder, contentType, delimiter, boundaryVal, boundary, buffer, iterator, running, _a, value, done, chunk, searchFrom, bi, message, i, headers, contentType_1, body, result, next;
        var _b, _c;
        var _d;
        return (0, $fKE23.__generator)(this, function(_e) {
            switch(_e.label){
                case 0:
                    if (TextDecoder === undefined) throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
                    decoder = new TextDecoder("utf-8");
                    contentType = (_d = response.headers) === null || _d === void 0 ? void 0 : _d.get("content-type");
                    delimiter = "boundary=";
                    boundaryVal = (contentType === null || contentType === void 0 ? void 0 : contentType.includes(delimiter)) ? contentType === null || contentType === void 0 ? void 0 : contentType.substring((contentType === null || contentType === void 0 ? void 0 : contentType.indexOf(delimiter)) + delimiter.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-";
                    boundary = "\r\n--".concat(boundaryVal);
                    buffer = "";
                    iterator = (0, $4ylXW.responseIterator)(response);
                    running = true;
                    _e.label = 1;
                case 1:
                    if (!running) return [
                        3 /*break*/ ,
                        3
                    ];
                    return [
                        4 /*yield*/ ,
                        iterator.next()
                    ];
                case 2:
                    _a = _e.sent(), value = _a.value, done = _a.done;
                    chunk = typeof value === "string" ? value : decoder.decode(value);
                    searchFrom = buffer.length - boundary.length + 1;
                    running = !done;
                    buffer += chunk;
                    bi = buffer.indexOf(boundary, searchFrom);
                    while(bi > -1){
                        message = void 0;
                        _b = [
                            buffer.slice(0, bi),
                            buffer.slice(bi + boundary.length)
                        ], message = _b[0], buffer = _b[1];
                        i = message.indexOf("\r\n\r\n");
                        headers = $715f45118885a354$export$eea2c1c5e1a37e50(message.slice(0, i));
                        contentType_1 = headers["content-type"];
                        if (contentType_1 && contentType_1.toLowerCase().indexOf("application/json") === -1) throw new Error("Unsupported patch content type: application/json is required.");
                        body = message.slice(i);
                        if (body) {
                            result = $715f45118885a354$export$759bcb35b0d1bf81(response, body);
                            if (Object.keys(result).length > 1 || "data" in result || "incremental" in result || "errors" in result || "payload" in result) {
                                if ((0, $dajVc.isApolloPayloadResult)(result)) {
                                    next = {};
                                    if ("payload" in result) {
                                        if (Object.keys(result).length === 1 && result.payload === null) return [
                                            2 /*return*/ 
                                        ];
                                        next = (0, $fKE23.__assign)({}, result.payload);
                                    }
                                    if ("errors" in result) next = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, next), {
                                        extensions: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, "extensions" in next ? next.extensions : null), (_c = {}, _c[0, $7BIXz.PROTOCOL_ERRORS_SYMBOL] = result.errors, _c))
                                    });
                                    nextValue(next);
                                } else // for the last chunk with only `hasNext: false`
                                // we don't need to call observer.next as there is no data/errors
                                nextValue(result);
                            } else if (// If the chunk contains only a "hasNext: false", we can call
                            // observer.complete() immediately.
                            Object.keys(result).length === 1 && "hasNext" in result && !result.hasNext) return [
                                2 /*return*/ 
                            ];
                        }
                        bi = buffer.indexOf(boundary);
                    }
                    return [
                        3 /*break*/ ,
                        1
                    ];
                case 3:
                    return [
                        2 /*return*/ 
                    ];
            }
        });
    });
}
function $715f45118885a354$export$eea2c1c5e1a37e50(headerText) {
    var headersInit = {};
    headerText.split("\n").forEach(function(line) {
        var i = line.indexOf(":");
        if (i > -1) {
            // normalize headers to lowercase
            var name_1 = line.slice(0, i).trim().toLowerCase();
            var value = line.slice(i + 1).trim();
            headersInit[name_1] = value;
        }
    });
    return headersInit;
}
function $715f45118885a354$export$759bcb35b0d1bf81(response, bodyText) {
    if (response.status >= 300) {
        // Network error
        var getResult = function() {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                return bodyText;
            }
        };
        (0, $1rXZG.throwServerError)(response, getResult(), "Response not successful: Received status code ".concat(response.status));
    }
    try {
        return JSON.parse(bodyText);
    } catch (err) {
        var parseError = err;
        parseError.name = "ServerParseError";
        parseError.response = response;
        parseError.statusCode = response.status;
        parseError.bodyText = bodyText;
        throw parseError;
    }
}
function $715f45118885a354$export$d3da1ecaf1206c58(err, observer) {
    // if it is a network error, BUT there is graphql result info fire
    // the next observer before calling error this gives apollo-client
    // (and react-apollo) the `graphqlErrors` and `networkErrors` to
    // pass to UI this should only happen if we *also* have data as
    // part of the response key per the spec
    if (err.result && err.result.errors && err.result.data) // if we don't call next, the UI can only show networkError
    // because AC didn't get any graphqlErrors this is graphql
    // execution result info (i.e errors and possibly data) this is
    // because there is no formal spec how errors should translate to
    // http status codes. So an auth error (401) could have both data
    // from a public field, errors from a private field, and a status
    // of 401
    // {
    //  user { // this will have errors
    //    firstName
    //  }
    //  products { // this is public so will have data
    //    cost
    //  }
    // }
    //
    // the result of above *could* look like this:
    // {
    //   data: { products: [{ cost: "$10" }] },
    //   errors: [{
    //      message: 'your session has timed out',
    //      path: []
    //   }]
    // }
    // status code of above would be a 401
    // in the UI you want to show data where you can, errors as data where you can
    // and use correct http status codes
    observer.next(err.result);
    observer.error(err);
}
function $715f45118885a354$export$d4051215bea0639f(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            return $715f45118885a354$export$759bcb35b0d1bf81(response, bodyText);
        }).then(function(result) {
            if (!Array.isArray(result) && !$715f45118885a354$var$hasOwnProperty.call(result, "data") && !$715f45118885a354$var$hasOwnProperty.call(result, "errors")) // Data error
            (0, $1rXZG.throwServerError)(response, result, "Server response was missing for query '".concat(Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName, "'."));
            return result;
        });
    };
}

});
parcelRegister("4ylXW", function(module, exports) {

$parcel$export(module.exports, "responseIterator", () => $350b605e7b3e41c3$export$7e4ac9ed9577f145);
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/index.ts
 */ 
var $7X1wJ = parcelRequire("7X1wJ");

var $hYoEN = parcelRequire("hYoEN");

var $bJYRb = parcelRequire("bJYRb");

var $9DY6Y = parcelRequire("9DY6Y");

var $k1KnB = parcelRequire("k1KnB");
function $350b605e7b3e41c3$var$isNodeResponse(value) {
    return !!value.body;
}
function $350b605e7b3e41c3$var$isReadableStream(value) {
    return !!value.getReader;
}
function $350b605e7b3e41c3$var$isAsyncIterableIterator(value) {
    return !!((0, $7X1wJ.canUseAsyncIteratorSymbol) && value[Symbol.asyncIterator]);
}
function $350b605e7b3e41c3$var$isStreamableBlob(value) {
    return !!value.stream;
}
function $350b605e7b3e41c3$var$isBlob(value) {
    return !!value.arrayBuffer;
}
function $350b605e7b3e41c3$var$isNodeReadableStream(value) {
    return !!value.pipe;
}
function $350b605e7b3e41c3$export$7e4ac9ed9577f145(response) {
    var body = response;
    if ($350b605e7b3e41c3$var$isNodeResponse(response)) body = response.body;
    if ($350b605e7b3e41c3$var$isAsyncIterableIterator(body)) return (0, $hYoEN.default)(body);
    if ($350b605e7b3e41c3$var$isReadableStream(body)) return (0, $k1KnB.default)(body.getReader());
    // this errors without casting to ReadableStream<T>
    // because Blob.stream() returns a NodeJS ReadableStream
    if ($350b605e7b3e41c3$var$isStreamableBlob(body)) return (0, $k1KnB.default)(body.stream().getReader());
    if ($350b605e7b3e41c3$var$isBlob(body)) return (0, $9DY6Y.default)(body.arrayBuffer());
    if ($350b605e7b3e41c3$var$isNodeReadableStream(body)) return (0, $bJYRb.default)(body);
    throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}

});
parcelRegister("hYoEN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d15b2a9cb83618ea$export$2e2bcd8739ae039);
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/async.ts
 */ function $d15b2a9cb83618ea$export$2e2bcd8739ae039(source) {
    var _a;
    var iterator = source[Symbol.asyncIterator]();
    return _a = {
        next: function() {
            return iterator.next();
        }
    }, _a[Symbol.asyncIterator] = function() {
        return this;
    }, _a;
}

});

parcelRegister("bJYRb", function(module, exports) {

$parcel$export(module.exports, "default", () => $88c31a91720e2527$export$2e2bcd8739ae039);
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/nodeStream.ts
 */ 
var $7X1wJ = parcelRequire("7X1wJ");
function $88c31a91720e2527$export$2e2bcd8739ae039(stream) {
    var cleanup = null;
    var error = null;
    var done = false;
    var data = [];
    var waiting = [];
    function onData(chunk) {
        if (error) return;
        if (waiting.length) {
            var shiftedArr = waiting.shift();
            if (Array.isArray(shiftedArr) && shiftedArr[0]) return shiftedArr[0]({
                value: chunk,
                done: false
            });
        }
        data.push(chunk);
    }
    function onError(err) {
        error = err;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[1](err);
        });
        !cleanup || cleanup();
    }
    function onEnd() {
        done = true;
        var all = waiting.slice();
        all.forEach(function(pair) {
            pair[0]({
                value: undefined,
                done: true
            });
        });
        !cleanup || cleanup();
    }
    cleanup = function() {
        cleanup = null;
        stream.removeListener("data", onData);
        stream.removeListener("error", onError);
        stream.removeListener("end", onEnd);
        stream.removeListener("finish", onEnd);
        stream.removeListener("close", onEnd);
    };
    stream.on("data", onData);
    stream.on("error", onError);
    stream.on("end", onEnd);
    stream.on("finish", onEnd);
    stream.on("close", onEnd);
    function getNext() {
        return new Promise(function(resolve, reject) {
            if (error) return reject(error);
            if (data.length) return resolve({
                value: data.shift(),
                done: false
            });
            if (done) return resolve({
                value: undefined,
                done: true
            });
            waiting.push([
                resolve,
                reject
            ]);
        });
    }
    var iterator = {
        next: function() {
            return getNext();
        }
    };
    if (0, $7X1wJ.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});

parcelRegister("9DY6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $7056627737be67fa$export$2e2bcd8739ae039);
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/promise.ts
 */ 
var $7X1wJ = parcelRequire("7X1wJ");
function $7056627737be67fa$export$2e2bcd8739ae039(promise) {
    var resolved = false;
    var iterator = {
        next: function() {
            if (resolved) return Promise.resolve({
                value: undefined,
                done: true
            });
            resolved = true;
            return new Promise(function(resolve, reject) {
                promise.then(function(value) {
                    resolve({
                        value: value,
                        done: false
                    });
                }).catch(reject);
            });
        }
    };
    if (0, $7X1wJ.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});

parcelRegister("k1KnB", function(module, exports) {

$parcel$export(module.exports, "default", () => $e947e0ab7704da28$export$2e2bcd8739ae039);
/**
 * Original source:
 * https://github.com/kmalakoff/response-iterator/blob/master/src/iterators/reader.ts
 */ 
var $7X1wJ = parcelRequire("7X1wJ");
function $e947e0ab7704da28$export$2e2bcd8739ae039(reader) {
    var iterator = {
        next: function() {
            return reader.read();
        }
    };
    if (0, $7X1wJ.canUseAsyncIteratorSymbol) iterator[Symbol.asyncIterator] = function() {
        return this;
    };
    return iterator;
}

});


parcelRegister("1rXZG", function(module, exports) {

$parcel$export(module.exports, "throwServerError", () => $10e6d9978150519a$export$c33ef9219f27efd7);
var $10e6d9978150519a$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = "ServerError";
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};

});

parcelRegister("7BIXz", function(module, exports) {

$parcel$export(module.exports, "PROTOCOL_ERRORS_SYMBOL", () => $589edd3592548237$export$4995664c1b49842e);
$parcel$export(module.exports, "graphQLResultHasProtocolErrors", () => $589edd3592548237$export$345f95cc6b6b9b0b);
$parcel$export(module.exports, "isApolloError", () => $589edd3592548237$export$17f5e6bd290bb15d);
$parcel$export(module.exports, "ApolloError", () => $589edd3592548237$export$26a337512320b8c6);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");

var $1MCRf = parcelRequire("1MCRf");
var $589edd3592548237$export$4995664c1b49842e = Symbol();
function $589edd3592548237$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$589edd3592548237$export$4995664c1b49842e]);
    return false;
}
function $589edd3592548237$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var $589edd3592548237$var$generateErrorMessage = function(err) {
    var errors = (0, $fKE23.__spreadArray)((0, $fKE23.__spreadArray)((0, $fKE23.__spreadArray)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors// The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
    .map(function(err) {
        return (0, $1MCRf.isNonNullObject)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $589edd3592548237$export$26a337512320b8c6 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ApolloError, _super);
    // Constructs an instance of ApolloError given a GraphQLError
    // or a network error. Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $589edd3592548237$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);

});

parcelRegister("dajVc", function(module, exports) {

$parcel$export(module.exports, "isExecutionPatchIncrementalResult", () => $995ba98b9c764cfd$export$879767c5cdf33cb3);
$parcel$export(module.exports, "isExecutionPatchResult", () => $995ba98b9c764cfd$export$f90dc0a3531b8b83);
$parcel$export(module.exports, "isApolloPayloadResult", () => $995ba98b9c764cfd$export$3f32b6369f408f33);
$parcel$export(module.exports, "mergeIncrementalData", () => $995ba98b9c764cfd$export$9a905f57d6393874);

var $1MCRf = parcelRequire("1MCRf");

var $kxw1Y = parcelRequire("kxw1Y");

var $64d3o = parcelRequire("64d3o");
function $995ba98b9c764cfd$export$879767c5cdf33cb3(value) {
    return "incremental" in value;
}
function $995ba98b9c764cfd$export$6c17a45d8c64ff02(value) {
    return "hasNext" in value && "data" in value;
}
function $995ba98b9c764cfd$export$f90dc0a3531b8b83(value) {
    return $995ba98b9c764cfd$export$879767c5cdf33cb3(value) || $995ba98b9c764cfd$export$6c17a45d8c64ff02(value);
}
function $995ba98b9c764cfd$export$3f32b6369f408f33(value) {
    return (0, $1MCRf.isNonNullObject)(value) && "payload" in value;
}
function $995ba98b9c764cfd$export$9a905f57d6393874(prevResult, result) {
    var mergedData = prevResult;
    var merger = new (0, $64d3o.DeepMerger)();
    if ($995ba98b9c764cfd$export$879767c5cdf33cb3(result) && (0, $kxw1Y.isNonEmptyArray)(result.incremental)) result.incremental.forEach(function(_a) {
        var data = _a.data, path = _a.path;
        for(var i = path.length - 1; i >= 0; --i){
            var key = path[i];
            var isNumericKey = !isNaN(+key);
            var parent_1 = isNumericKey ? [] : {};
            parent_1[key] = data;
            data = parent_1;
        }
        mergedData = merger.merge(mergedData, data);
    });
    return mergedData;
}

});


parcelRegister("6PeMF", function(module, exports) {

$parcel$export(module.exports, "checkFetcher", () => $4f82f94e7ceffd86$export$8423f0cd3773115e);
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");
var $4f82f94e7ceffd86$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === "undefined") throw (0, $kL4FQ.newInvariantError)(37);
};

});

parcelRegister("4cBEf", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $30f57c91cb1df9cd$export$dd86f00dc866e75d);
$parcel$export(module.exports, "defaultPrinter", () => $30f57c91cb1df9cd$export$e88934976ca4fd65);
$parcel$export(module.exports, "selectHttpOptionsAndBodyInternal", () => $30f57c91cb1df9cd$export$12d90ccf75844275);

var $fKE23 = parcelRequire("fKE23");

var $aaMYp = parcelRequire("aaMYp");
var $30f57c91cb1df9cd$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false,
    preserveHeaderCase: false
};
var $30f57c91cb1df9cd$var$defaultHeaders = {
    // headers are case insensitive (https://stackoverflow.com/a/5259004)
    accept: "*/*",
    // The content-type header describes the type of the body of the request, and
    // so it typically only is sent with requests that actually have bodies. One
    // could imagine that Apollo Client would remove this header when constructing
    // a GET request (which has no body), but we historically have not done that.
    // This means that browsers will preflight all Apollo Client requests (even
    // GET requests). Apollo Server's CSRF prevention feature (introduced in
    // AS3.7) takes advantage of this fact and does not block requests with this
    // header. If you want to drop this header from GET requests, then you should
    // probably replace it with a `apollo-require-preflight` header, or servers
    // with CSRF prevention enabled might block your GET request. See
    // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
    // for more details.
    "content-type": "application/json"
};
var $30f57c91cb1df9cd$var$defaultOptions = {
    method: "POST"
};
var $30f57c91cb1df9cd$export$dd86f00dc866e75d = {
    http: $30f57c91cb1df9cd$var$defaultHttpOptions,
    headers: $30f57c91cb1df9cd$var$defaultHeaders,
    options: $30f57c91cb1df9cd$var$defaultOptions
};
var $30f57c91cb1df9cd$export$e88934976ca4fd65 = function(ast, printer) {
    return printer(ast);
};
function $30f57c91cb1df9cd$export$a00ebfd5f1eebfb1(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    configs.unshift(fallbackConfig);
    return $30f57c91cb1df9cd$export$12d90ccf75844275.apply(void 0, (0, $fKE23.__spreadArray)([
        operation,
        $30f57c91cb1df9cd$export$e88934976ca4fd65
    ], configs, false));
}
function $30f57c91cb1df9cd$export$12d90ccf75844275(operation, printer) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = {};
    var http = {};
    configs.forEach(function(config) {
        options = (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), config.options), {
            headers: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options.headers), config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, http), config.http);
    });
    if (options.headers) options.headers = $30f57c91cb1df9cd$var$removeDuplicateHeaders(options.headers, http.preserveHeaderCase);
    //The body depends on the http options
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    // not sending the query (i.e persisted queries)
    if (http.includeQuery) body.query = printer(query, (0, $aaMYp.print));
    return {
        options: options,
        body: body
    };
}
// Remove potential duplicate header names, preserving last (by insertion order).
// This is done to prevent unintentionally duplicating a header instead of
// overwriting it (See #8447 and #8449).
function $30f57c91cb1df9cd$var$removeDuplicateHeaders(headers, preserveHeaderCase) {
    // If we're not preserving the case, just remove duplicates w/ normalization.
    if (!preserveHeaderCase) {
        var normalizedHeaders_1 = Object.create(null);
        Object.keys(Object(headers)).forEach(function(name) {
            normalizedHeaders_1[name.toLowerCase()] = headers[name];
        });
        return normalizedHeaders_1;
    }
    // If we are preserving the case, remove duplicates w/ normalization,
    // preserving the original name.
    // This allows for non-http-spec-compliant servers that expect intentionally
    // capitalized header names (See #6741).
    var headerData = Object.create(null);
    Object.keys(Object(headers)).forEach(function(name) {
        headerData[name.toLowerCase()] = {
            originalName: name,
            value: headers[name]
        };
    });
    var normalizedHeaders = Object.create(null);
    Object.keys(headerData).forEach(function(name) {
        normalizedHeaders[headerData[name].originalName] = headerData[name].value;
    });
    return normalizedHeaders;
}

});

parcelRegister("6WFFl", function(module, exports) {

$parcel$export(module.exports, "rewriteURIForGET", () => $50e87ad3015a7f6c$export$fb82bb094b6f76b5);

var $f2A0H = parcelRequire("f2A0H");
function $50e87ad3015a7f6c$export$fb82bb094b6f76b5(chosenURI, body) {
    // Implement the standard HTTP GET serialization, plus 'extensions'. Note
    // the extra level of JSON serialization!
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push("".concat(key, "=").concat(encodeURIComponent(value)));
    };
    if ("query" in body) addQueryParam("query", body.query);
    if (body.operationName) addQueryParam("operationName", body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $f2A0H.serializeFetchParameter)(body.variables, "Variables map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("variables", serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $f2A0H.serializeFetchParameter)(body.extensions, "Extensions map");
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam("extensions", serializedExtensions);
    }
    // Reconstruct the URI with added query params.
    // XXX This assumes that the URI is well-formed and that it doesn't
    //     already contain any of these query params. We could instead use the
    //     URL API and take a polyfill (whatwg-url@6) for older browsers that
    //     don't support URLSearchParams. Note that some browsers (and
    //     versions of whatwg-url) support URL but not URLSearchParams!
    var fragment = "", preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf("#");
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf("?") === -1 ? "?" : "&";
    var newURI = preFragment + queryParamsPrefix + queryParams.join("&") + fragment;
    return {
        newURI: newURI
    };
}

});

parcelRegister("7a3PP", function(module, exports) {

$parcel$export(module.exports, "filterOperationVariables", () => $536c71185db60cb9$export$de246493ae27fe3f);

var $fKE23 = parcelRequire("fKE23");

var $961BR = parcelRequire("961BR");
function $536c71185db60cb9$export$de246493ae27fe3f(variables, query) {
    var result = (0, $fKE23.__assign)({}, variables);
    var unusedNames = new Set(Object.keys(variables));
    (0, $961BR.visit)(query, {
        Variable: function(node, _key, parent) {
            // A variable type definition at the top level of a query is not
            // enough to silence server-side errors about the variable being
            // unused, so variable definitions do not count as usage.
            // https://spec.graphql.org/draft/#sec-All-Variables-Used
            if (parent && parent.kind !== "VariableDefinition") unusedNames.delete(node.name.value);
        }
    });
    unusedNames.forEach(function(name) {
        delete result[name];
    });
    return result;
}

});

parcelRegister("3oJi2", function(module, exports) {

$parcel$export(module.exports, "fromError", () => $2796be9ea228d31a$export$4fd972edbe7450d3);
parcelRequire("eayTI");
var $8E6bd = parcelRequire("8E6bd");
function $2796be9ea228d31a$export$4fd972edbe7450d3(errorValue) {
    return new (0, $8E6bd.Observable)(function(observer) {
        observer.error(errorValue);
    });
}

});



parcelRegister("jCuxd", function(module, exports) {

$parcel$export(module.exports, "QueryManager", () => $e489407ff833bb03$export$b986383a50b53ea4);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $hr8gD = parcelRequire("hr8gD");

var $5kEJu = parcelRequire("5kEJu");

var $25dOT = parcelRequire("25dOT");
var $czLrN = parcelRequire("czLrN");
var $7MpZC = parcelRequire("7MpZC");
var $ccOlh = parcelRequire("ccOlh");
var $fzShn = parcelRequire("fzShn");
var $iX694 = parcelRequire("iX694");
var $bLhqY = parcelRequire("bLhqY");
var $jHSHK = parcelRequire("jHSHK");
var $6dwmd = parcelRequire("6dwmd");
var $dajVc = parcelRequire("dajVc");
var $kxw1Y = parcelRequire("kxw1Y");
var $1MCRf = parcelRequire("1MCRf");
var $d9sqa = parcelRequire("d9sqa");parcelRequire("eayTI");
var $8E6bd = parcelRequire("8E6bd");
var $aaMYp = parcelRequire("aaMYp");
var $1CBce = parcelRequire("1CBce");

var $5bIMC = parcelRequire("5bIMC");

var $dajVc = parcelRequire("dajVc");

var $7BIXz = parcelRequire("7BIXz");

var $4PfqZ = parcelRequire("4PfqZ");

var $4YvCN = parcelRequire("4YvCN");

var $6bzG9 = parcelRequire("6bzG9");

var $bEGCk = parcelRequire("bEGCk");

var $6CRCP = parcelRequire("6CRCP");
var $e489407ff833bb03$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $e489407ff833bb03$var$IGNORE = Object.create(null);
var $e489407ff833bb03$export$b986383a50b53ea4 = /** @class */ function() {
    function QueryManager(_a) {
        var cache = _a.cache, link = _a.link, defaultOptions = _a.defaultOptions, documentTransform = _a.documentTransform, _b = _a.queryDeduplication, queryDeduplication = _b === void 0 ? false : _b, onBroadcast = _a.onBroadcast, _c = _a.ssrMode, ssrMode = _c === void 0 ? false : _c, _d = _a.clientAwareness, clientAwareness = _d === void 0 ? {} : _d, localState = _a.localState, _e = _a.assumeImmutableResults, assumeImmutableResults = _e === void 0 ? !!cache.assumeImmutableResults : _e, defaultContext = _a.defaultContext;
        var _this = this;
        this.clientAwareness = {};
        // All the queries that the QueryManager is currently managing (not
        // including mutations and subscriptions).
        this.queries = new Map();
        // Maps from queryId strings to Promise rejection functions for
        // currently active queries and fetches.
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.fetchCancelFns = new Map();
        this.transformCache = new (0, $czLrN.AutoCleanedWeakCache)((0, $7MpZC.cacheSizes)["queryManager.getDocumentInfo"] || 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ );
        this.queryIdCounter = 1;
        this.requestIdCounter = 1;
        this.mutationIdCounter = 1;
        // Use protected instead of private field so
        // @apollo/experimental-nextjs-app-support can access type info.
        this.inFlightLinkObservables = new (0, $6CRCP.Trie)(false);
        var defaultDocumentTransform = new (0, $fzShn.DocumentTransform)(function(document) {
            return _this.cache.transformDocument(document);
        }, // Allow the apollo cache to manage its own transform caches
        {
            cache: false
        });
        this.cache = cache;
        this.link = link;
        this.defaultOptions = defaultOptions || Object.create(null);
        this.queryDeduplication = queryDeduplication;
        this.clientAwareness = clientAwareness;
        this.localState = localState || new (0, $6bzG9.LocalState)({
            cache: cache
        });
        this.ssrMode = ssrMode;
        this.assumeImmutableResults = assumeImmutableResults;
        this.documentTransform = documentTransform ? defaultDocumentTransform.concat(documentTransform)// The custom document transform may add new fragment spreads or new
        // field selections, so we want to give the cache a chance to run
        // again. For example, the InMemoryCache adds __typename to field
        // selections and fragments from the fragment registry.
        .concat(defaultDocumentTransform) : defaultDocumentTransform;
        this.defaultContext = defaultContext || Object.create(null);
        if (this.onBroadcast = onBroadcast) this.mutationStore = Object.create(null);
    }
    /**
     * Call this method to terminate any active query processes, making it safe
     * to dispose of this QueryManager instance.
     */ QueryManager.prototype.stop = function() {
        var _this = this;
        this.queries.forEach(function(_info, queryId) {
            _this.stopQueryNoBroadcast(queryId);
        });
        this.cancelPendingFetches((0, $kL4FQ.newInvariantError)(25));
    };
    QueryManager.prototype.cancelPendingFetches = function(error) {
        this.fetchCancelFns.forEach(function(cancel) {
            return cancel(error);
        });
        this.fetchCancelFns.clear();
    };
    QueryManager.prototype.mutate = function(_a) {
        return (0, $fKE23.__awaiter)(this, arguments, void 0, function(_b) {
            var mutationId, hasClientExports, mutationStoreValue, isOptimistic, self;
            var _c, _d;
            var mutation = _b.mutation, variables = _b.variables, optimisticResponse = _b.optimisticResponse, updateQueries = _b.updateQueries, _e = _b.refetchQueries, refetchQueries = _e === void 0 ? [] : _e, _f = _b.awaitRefetchQueries, awaitRefetchQueries = _f === void 0 ? false : _f, updateWithProxyFn = _b.update, onQueryUpdated = _b.onQueryUpdated, _g = _b.fetchPolicy, fetchPolicy = _g === void 0 ? ((_c = this.defaultOptions.mutate) === null || _c === void 0 ? void 0 : _c.fetchPolicy) || "network-only" : _g, _h = _b.errorPolicy, errorPolicy = _h === void 0 ? ((_d = this.defaultOptions.mutate) === null || _d === void 0 ? void 0 : _d.errorPolicy) || "none" : _h, keepRootFields = _b.keepRootFields, context = _b.context;
            return (0, $fKE23.__generator)(this, function(_j) {
                switch(_j.label){
                    case 0:
                        (0, $kL4FQ.invariant)(mutation, 26);
                        (0, $kL4FQ.invariant)(fetchPolicy === "network-only" || fetchPolicy === "no-cache", 27);
                        mutationId = this.generateMutationId();
                        mutation = this.cache.transformForLink(this.transform(mutation));
                        hasClientExports = this.getDocumentInfo(mutation).hasClientExports;
                        variables = this.getVariables(mutation, variables);
                        if (!hasClientExports) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.localState.addExportedVariables(mutation, variables, context)
                        ];
                    case 1:
                        variables = _j.sent();
                        _j.label = 2;
                    case 2:
                        mutationStoreValue = this.mutationStore && (this.mutationStore[mutationId] = {
                            mutation: mutation,
                            variables: variables,
                            loading: true,
                            error: null
                        });
                        isOptimistic = optimisticResponse && this.markMutationOptimistic(optimisticResponse, {
                            mutationId: mutationId,
                            document: mutation,
                            variables: variables,
                            fetchPolicy: fetchPolicy,
                            errorPolicy: errorPolicy,
                            context: context,
                            updateQueries: updateQueries,
                            update: updateWithProxyFn,
                            keepRootFields: keepRootFields
                        });
                        this.broadcastQueries();
                        self = this;
                        return [
                            2 /*return*/ ,
                            new Promise(function(resolve, reject) {
                                return (0, $25dOT.asyncMap)(self.getObservableFromLink(mutation, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                                    optimisticResponse: isOptimistic ? optimisticResponse : void 0
                                }), variables, false), function(result) {
                                    if ((0, $bLhqY.graphQLResultHasError)(result) && errorPolicy === "none") throw new (0, $7BIXz.ApolloError)({
                                        graphQLErrors: (0, $bLhqY.getGraphQLErrorsFromResult)(result)
                                    });
                                    if (mutationStoreValue) {
                                        mutationStoreValue.loading = false;
                                        mutationStoreValue.error = null;
                                    }
                                    var storeResult = (0, $fKE23.__assign)({}, result);
                                    if (typeof refetchQueries === "function") refetchQueries = refetchQueries(storeResult);
                                    if (errorPolicy === "ignore" && (0, $bLhqY.graphQLResultHasError)(storeResult)) delete storeResult.errors;
                                    return self.markMutationResult({
                                        mutationId: mutationId,
                                        result: storeResult,
                                        document: mutation,
                                        variables: variables,
                                        fetchPolicy: fetchPolicy,
                                        errorPolicy: errorPolicy,
                                        context: context,
                                        update: updateWithProxyFn,
                                        updateQueries: updateQueries,
                                        awaitRefetchQueries: awaitRefetchQueries,
                                        refetchQueries: refetchQueries,
                                        removeOptimistic: isOptimistic ? mutationId : void 0,
                                        onQueryUpdated: onQueryUpdated,
                                        keepRootFields: keepRootFields
                                    });
                                }).subscribe({
                                    next: function(storeResult) {
                                        self.broadcastQueries();
                                        // Since mutations might receive multiple payloads from the
                                        // ApolloLink chain (e.g. when used with @defer),
                                        // we resolve with a SingleExecutionResult or after the final
                                        // ExecutionPatchResult has arrived and we have assembled the
                                        // multipart response into a single result.
                                        if (!("hasNext" in storeResult) || storeResult.hasNext === false) resolve(storeResult);
                                    },
                                    error: function(err) {
                                        if (mutationStoreValue) {
                                            mutationStoreValue.loading = false;
                                            mutationStoreValue.error = err;
                                        }
                                        if (isOptimistic) self.cache.removeOptimistic(mutationId);
                                        self.broadcastQueries();
                                        reject(err instanceof (0, $7BIXz.ApolloError) ? err : new (0, $7BIXz.ApolloError)({
                                            networkError: err
                                        }));
                                    }
                                });
                            })
                        ];
                }
            });
        });
    };
    QueryManager.prototype.markMutationResult = function(mutation, cache) {
        var _this = this;
        if (cache === void 0) cache = this.cache;
        var result = mutation.result;
        var cacheWrites = [];
        var skipCache = mutation.fetchPolicy === "no-cache";
        if (!skipCache && (0, $bEGCk.shouldWriteResult)(result, mutation.errorPolicy)) {
            if (!(0, $dajVc.isExecutionPatchIncrementalResult)(result)) cacheWrites.push({
                result: result.data,
                dataId: "ROOT_MUTATION",
                query: mutation.document,
                variables: mutation.variables
            });
            if ((0, $dajVc.isExecutionPatchIncrementalResult)(result) && (0, $kxw1Y.isNonEmptyArray)(result.incremental)) {
                var diff = cache.diff({
                    id: "ROOT_MUTATION",
                    // The cache complains if passed a mutation where it expects a
                    // query, so we transform mutations and subscriptions to queries
                    // (only once, thanks to this.transformCache).
                    query: this.getDocumentInfo(mutation.document).asQuery,
                    variables: mutation.variables,
                    optimistic: false,
                    returnPartialData: true
                });
                var mergedData = void 0;
                if (diff.result) mergedData = (0, $dajVc.mergeIncrementalData)(diff.result, result);
                if (typeof mergedData !== "undefined") {
                    // cast the ExecutionPatchResult to FetchResult here since
                    // ExecutionPatchResult never has `data` when returned from the server
                    result.data = mergedData;
                    cacheWrites.push({
                        result: mergedData,
                        dataId: "ROOT_MUTATION",
                        query: mutation.document,
                        variables: mutation.variables
                    });
                }
            }
            var updateQueries_1 = mutation.updateQueries;
            if (updateQueries_1) this.queries.forEach(function(_a, queryId) {
                var observableQuery = _a.observableQuery;
                var queryName = observableQuery && observableQuery.queryName;
                if (!queryName || !$e489407ff833bb03$var$hasOwnProperty.call(updateQueries_1, queryName)) return;
                var updater = updateQueries_1[queryName];
                var _b = _this.queries.get(queryId), document = _b.document, variables = _b.variables;
                // Read the current query result from the store.
                var _c = cache.diff({
                    query: document,
                    variables: variables,
                    returnPartialData: true,
                    optimistic: false
                }), currentQueryResult = _c.result, complete = _c.complete;
                if (complete && currentQueryResult) {
                    // Run our reducer using the current query result and the mutation result.
                    var nextQueryResult = updater(currentQueryResult, {
                        mutationResult: result,
                        queryName: document && (0, $iX694.getOperationName)(document) || void 0,
                        queryVariables: variables
                    });
                    // Write the modified result back into the store if we got a new result.
                    if (nextQueryResult) cacheWrites.push({
                        result: nextQueryResult,
                        dataId: "ROOT_QUERY",
                        query: document,
                        variables: variables
                    });
                }
            });
        }
        if (cacheWrites.length > 0 || (mutation.refetchQueries || "").length > 0 || mutation.update || mutation.onQueryUpdated || mutation.removeOptimistic) {
            var results_1 = [];
            this.refetchQueries({
                updateCache: function(cache) {
                    if (!skipCache) cacheWrites.forEach(function(write) {
                        return cache.write(write);
                    });
                    // If the mutation has some writes associated with it then we need to
                    // apply those writes to the store by running this reducer again with
                    // a write action.
                    var update = mutation.update;
                    // Determine whether result is a SingleExecutionResult,
                    // or the final ExecutionPatchResult.
                    var isFinalResult = !(0, $dajVc.isExecutionPatchResult)(result) || (0, $dajVc.isExecutionPatchIncrementalResult)(result) && !result.hasNext;
                    if (update) {
                        if (!skipCache) {
                            // Re-read the ROOT_MUTATION data we just wrote into the cache
                            // (the first cache.write call in the cacheWrites.forEach loop
                            // above), so field read functions have a chance to run for
                            // fields within mutation result objects.
                            var diff = cache.diff({
                                id: "ROOT_MUTATION",
                                // The cache complains if passed a mutation where it expects a
                                // query, so we transform mutations and subscriptions to queries
                                // (only once, thanks to this.transformCache).
                                query: _this.getDocumentInfo(mutation.document).asQuery,
                                variables: mutation.variables,
                                optimistic: false,
                                returnPartialData: true
                            });
                            if (diff.complete) {
                                result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, result), {
                                    data: diff.result
                                });
                                if ("incremental" in result) delete result.incremental;
                                if ("hasNext" in result) delete result.hasNext;
                            }
                        }
                        // If we've received the whole response,
                        // either a SingleExecutionResult or the final ExecutionPatchResult,
                        // call the update function.
                        if (isFinalResult) update(cache, result, {
                            context: mutation.context,
                            variables: mutation.variables
                        });
                    }
                    // TODO Do this with cache.evict({ id: 'ROOT_MUTATION' }) but make it
                    // shallow to allow rolling back optimistic evictions.
                    if (!skipCache && !mutation.keepRootFields && isFinalResult) cache.modify({
                        id: "ROOT_MUTATION",
                        fields: function(value, _a) {
                            var fieldName = _a.fieldName, DELETE = _a.DELETE;
                            return fieldName === "__typename" ? value : DELETE;
                        }
                    });
                },
                include: mutation.refetchQueries,
                // Write the final mutation.result to the root layer of the cache.
                optimistic: false,
                // Remove the corresponding optimistic layer at the same time as we
                // write the final non-optimistic result.
                removeOptimistic: mutation.removeOptimistic,
                // Let the caller of client.mutate optionally determine the refetching
                // behavior for watched queries after the mutation.update function runs.
                // If no onQueryUpdated function was provided for this mutation, pass
                // null instead of undefined to disable the default refetching behavior.
                onQueryUpdated: mutation.onQueryUpdated || null
            }).forEach(function(result) {
                return results_1.push(result);
            });
            if (mutation.awaitRefetchQueries || mutation.onQueryUpdated) // Returning a promise here makes the mutation await that promise, so we
            // include results in that promise's work if awaitRefetchQueries or an
            // onQueryUpdated function was specified.
            return Promise.all(results_1).then(function() {
                return result;
            });
        }
        return Promise.resolve(result);
    };
    QueryManager.prototype.markMutationOptimistic = function(optimisticResponse, mutation) {
        var _this = this;
        var data = typeof optimisticResponse === "function" ? optimisticResponse(mutation.variables, {
            IGNORE: $e489407ff833bb03$var$IGNORE
        }) : optimisticResponse;
        if (data === $e489407ff833bb03$var$IGNORE) return false;
        this.cache.recordOptimisticTransaction(function(cache) {
            try {
                _this.markMutationResult((0, $fKE23.__assign)((0, $fKE23.__assign)({}, mutation), {
                    result: {
                        data: data
                    }
                }), cache);
            } catch (error) {
                globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).error(error);
            }
        }, mutation.mutationId);
        return true;
    };
    QueryManager.prototype.fetchQuery = function(queryId, options, networkStatus) {
        return this.fetchConcastWithInfo(queryId, options, networkStatus).concast.promise;
    };
    QueryManager.prototype.getQueryStore = function() {
        var store = Object.create(null);
        this.queries.forEach(function(info, queryId) {
            store[queryId] = {
                variables: info.variables,
                networkStatus: info.networkStatus,
                networkError: info.networkError,
                graphQLErrors: info.graphQLErrors
            };
        });
        return store;
    };
    QueryManager.prototype.resetErrors = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) {
            queryInfo.networkError = undefined;
            queryInfo.graphQLErrors = [];
        }
    };
    QueryManager.prototype.transform = function(document) {
        return this.documentTransform.transformDocument(document);
    };
    QueryManager.prototype.getDocumentInfo = function(document) {
        var transformCache = this.transformCache;
        if (!transformCache.has(document)) {
            var cacheEntry = {
                // TODO These three calls (hasClientExports, shouldForceResolvers, and
                // usesNonreactiveDirective) are performing independent full traversals
                // of the transformed document. We should consider merging these
                // traversals into a single pass in the future, though the work is
                // cached after the first time.
                hasClientExports: (0, $jHSHK.hasClientExports)(document),
                hasForcedResolvers: this.localState.shouldForceResolvers(document),
                hasNonreactiveDirective: (0, $jHSHK.hasDirectives)([
                    "nonreactive"
                ], document),
                clientQuery: this.localState.clientQuery(document),
                serverQuery: (0, $1CBce.removeDirectivesFromDocument)([
                    {
                        name: "client",
                        remove: true
                    },
                    {
                        name: "connection"
                    },
                    {
                        name: "nonreactive"
                    }
                ], document),
                defaultVars: (0, $iX694.getDefaultValues)((0, $iX694.getOperationDefinition)(document)),
                // Transform any mutation or subscription operations to query operations
                // so we can read/write them from/to the cache.
                asQuery: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, document), {
                    definitions: document.definitions.map(function(def) {
                        if (def.kind === "OperationDefinition" && def.operation !== "query") return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, def), {
                            operation: "query"
                        });
                        return def;
                    })
                })
            };
            transformCache.set(document, cacheEntry);
        }
        return transformCache.get(document);
    };
    QueryManager.prototype.getVariables = function(document, variables) {
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.getDocumentInfo(document).defaultVars), variables);
    };
    QueryManager.prototype.watchQuery = function(options) {
        var query = this.transform(options.query);
        // assign variable default values if supplied
        // NOTE: We don't modify options.query here with the transformed query to
        // ensure observable.options.query is set to the raw untransformed query.
        options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            variables: this.getVariables(query, options.variables)
        });
        if (typeof options.notifyOnNetworkStatusChange === "undefined") options.notifyOnNetworkStatusChange = false;
        var queryInfo = new (0, $bEGCk.QueryInfo)(this);
        var observable = new (0, $4PfqZ.ObservableQuery)({
            queryManager: this,
            queryInfo: queryInfo,
            options: options
        });
        observable["lastQuery"] = query;
        this.queries.set(observable.queryId, queryInfo);
        // We give queryInfo the transformed query to ensure the first cache diff
        // uses the transformed query instead of the raw query
        queryInfo.init({
            document: query,
            observableQuery: observable,
            variables: observable.variables
        });
        return observable;
    };
    QueryManager.prototype.query = function(options, queryId) {
        var _this = this;
        if (queryId === void 0) queryId = this.generateQueryId();
        (0, $kL4FQ.invariant)(options.query, 28);
        (0, $kL4FQ.invariant)(options.query.kind === "Document", 29);
        (0, $kL4FQ.invariant)(!options.returnPartialData, 30);
        (0, $kL4FQ.invariant)(!options.pollInterval, 31);
        return this.fetchQuery(queryId, (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            query: this.transform(options.query)
        })).finally(function() {
            return _this.stopQuery(queryId);
        });
    };
    QueryManager.prototype.generateQueryId = function() {
        return String(this.queryIdCounter++);
    };
    QueryManager.prototype.generateRequestId = function() {
        return this.requestIdCounter++;
    };
    QueryManager.prototype.generateMutationId = function() {
        return String(this.mutationIdCounter++);
    };
    QueryManager.prototype.stopQueryInStore = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryInStoreNoBroadcast = function(queryId) {
        var queryInfo = this.queries.get(queryId);
        if (queryInfo) queryInfo.stop();
    };
    QueryManager.prototype.clearStore = function(options) {
        if (options === void 0) options = {
            discardWatches: true
        };
        // Before we have sent the reset action to the store, we can no longer
        // rely on the results returned by in-flight requests since these may
        // depend on values that previously existed in the data portion of the
        // store. So, we cancel the promises and observers that we have issued
        // so far and not yet resolved (in the case of queries).
        this.cancelPendingFetches((0, $kL4FQ.newInvariantError)(32));
        this.queries.forEach(function(queryInfo) {
            if (queryInfo.observableQuery) // Set loading to true so listeners don't trigger unless they want
            // results with partial data.
            queryInfo.networkStatus = (0, $4YvCN.NetworkStatus).loading;
            else queryInfo.stop();
        });
        if (this.mutationStore) this.mutationStore = Object.create(null);
        // begin removing data from the store
        return this.cache.reset(options);
    };
    QueryManager.prototype.getObservableQueries = function(include) {
        var _this = this;
        if (include === void 0) include = "active";
        var queries = new Map();
        var queryNamesAndDocs = new Map();
        var legacyQueryOptions = new Set();
        if (Array.isArray(include)) include.forEach(function(desc) {
            if (typeof desc === "string") queryNamesAndDocs.set(desc, false);
            else if ((0, $6dwmd.isDocumentNode)(desc)) queryNamesAndDocs.set(_this.transform(desc), false);
            else if ((0, $1MCRf.isNonNullObject)(desc) && desc.query) legacyQueryOptions.add(desc);
        });
        this.queries.forEach(function(_a, queryId) {
            var oq = _a.observableQuery, document = _a.document;
            if (oq) {
                if (include === "all") {
                    queries.set(queryId, oq);
                    return;
                }
                var queryName = oq.queryName, fetchPolicy = oq.options.fetchPolicy;
                if (fetchPolicy === "standby" || include === "active" && !oq.hasObservers()) return;
                if (include === "active" || queryName && queryNamesAndDocs.has(queryName) || document && queryNamesAndDocs.has(document)) {
                    queries.set(queryId, oq);
                    if (queryName) queryNamesAndDocs.set(queryName, true);
                    if (document) queryNamesAndDocs.set(document, true);
                }
            }
        });
        if (legacyQueryOptions.size) legacyQueryOptions.forEach(function(options) {
            // We will be issuing a fresh network request for this query, so we
            // pre-allocate a new query ID here, using a special prefix to enable
            // cleaning up these temporary queries later, after fetching.
            var queryId = (0, $d9sqa.makeUniqueId)("legacyOneTimeQuery");
            var queryInfo = _this.getQuery(queryId).init({
                document: options.query,
                variables: options.variables
            });
            var oq = new (0, $4PfqZ.ObservableQuery)({
                queryManager: _this,
                queryInfo: queryInfo,
                options: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
                    fetchPolicy: "network-only"
                })
            });
            (0, $kL4FQ.invariant)(oq.queryId === queryId);
            queryInfo.setObservableQuery(oq);
            queries.set(queryId, oq);
        });
        if (globalThis.__DEV__ !== false && queryNamesAndDocs.size) queryNamesAndDocs.forEach(function(included, nameOrDoc) {
            if (!included) globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).warn(typeof nameOrDoc === "string" ? 33 : 34, nameOrDoc);
        });
        return queries;
    };
    QueryManager.prototype.reFetchObservableQueries = function(includeStandby) {
        var _this = this;
        if (includeStandby === void 0) includeStandby = false;
        var observableQueryPromises = [];
        this.getObservableQueries(includeStandby ? "all" : "active").forEach(function(observableQuery, queryId) {
            var fetchPolicy = observableQuery.options.fetchPolicy;
            observableQuery.resetLastResults();
            if (includeStandby || fetchPolicy !== "standby" && fetchPolicy !== "cache-only") observableQueryPromises.push(observableQuery.refetch());
            _this.getQuery(queryId).setDiff(null);
        });
        this.broadcastQueries();
        return Promise.all(observableQueryPromises);
    };
    QueryManager.prototype.setObservableQuery = function(observableQuery) {
        this.getQuery(observableQuery.queryId).setObservableQuery(observableQuery);
    };
    QueryManager.prototype.startGraphQLSubscription = function(_a) {
        var _this = this;
        var query = _a.query, fetchPolicy = _a.fetchPolicy, _b = _a.errorPolicy, errorPolicy = _b === void 0 ? "none" : _b, variables = _a.variables, _c = _a.context, context = _c === void 0 ? {} : _c;
        query = this.transform(query);
        variables = this.getVariables(query, variables);
        var makeObservable = function(variables) {
            return _this.getObservableFromLink(query, context, variables).map(function(result) {
                if (fetchPolicy !== "no-cache") {
                    // the subscription interface should handle not sending us results we no longer subscribe to.
                    // XXX I don't think we ever send in an object with errors, but we might in the future...
                    if ((0, $bEGCk.shouldWriteResult)(result, errorPolicy)) _this.cache.write({
                        query: query,
                        result: result.data,
                        dataId: "ROOT_SUBSCRIPTION",
                        variables: variables
                    });
                    _this.broadcastQueries();
                }
                var hasErrors = (0, $bLhqY.graphQLResultHasError)(result);
                var hasProtocolErrors = (0, $7BIXz.graphQLResultHasProtocolErrors)(result);
                if (hasErrors || hasProtocolErrors) {
                    var errors = {};
                    if (hasErrors) errors.graphQLErrors = result.errors;
                    if (hasProtocolErrors) errors.protocolErrors = result.extensions[0, $7BIXz.PROTOCOL_ERRORS_SYMBOL];
                    // `errorPolicy` is a mechanism for handling GraphQL errors, according
                    // to our documentation, so we throw protocol errors regardless of the
                    // set error policy.
                    if (errorPolicy === "none" || hasProtocolErrors) throw new (0, $7BIXz.ApolloError)(errors);
                }
                if (errorPolicy === "ignore") delete result.errors;
                return result;
            });
        };
        if (this.getDocumentInfo(query).hasClientExports) {
            var observablePromise_1 = this.localState.addExportedVariables(query, variables, context).then(makeObservable);
            return new (0, $8E6bd.Observable)(function(observer) {
                var sub = null;
                observablePromise_1.then(function(observable) {
                    return sub = observable.subscribe(observer);
                }, observer.error);
                return function() {
                    return sub && sub.unsubscribe();
                };
            });
        }
        return makeObservable(variables);
    };
    QueryManager.prototype.stopQuery = function(queryId) {
        this.stopQueryNoBroadcast(queryId);
        this.broadcastQueries();
    };
    QueryManager.prototype.stopQueryNoBroadcast = function(queryId) {
        this.stopQueryInStoreNoBroadcast(queryId);
        this.removeQuery(queryId);
    };
    QueryManager.prototype.removeQuery = function(queryId) {
        // teardown all links
        // Both `QueryManager.fetchRequest` and `QueryManager.query` create separate promises
        // that each add their reject functions to fetchCancelFns.
        // A query created with `QueryManager.query()` could trigger a `QueryManager.fetchRequest`.
        // The same queryId could have two rejection fns for two promises
        this.fetchCancelFns.delete(queryId);
        if (this.queries.has(queryId)) {
            this.getQuery(queryId).stop();
            this.queries.delete(queryId);
        }
    };
    QueryManager.prototype.broadcastQueries = function() {
        if (this.onBroadcast) this.onBroadcast();
        this.queries.forEach(function(info) {
            return info.notify();
        });
    };
    QueryManager.prototype.getLocalState = function() {
        return this.localState;
    };
    QueryManager.prototype.getObservableFromLink = function(query, context, variables, // Prefer context.queryDeduplication if specified.
    deduplication) {
        var _this = this;
        var _a;
        if (deduplication === void 0) deduplication = (_a = context === null || context === void 0 ? void 0 : context.queryDeduplication) !== null && _a !== void 0 ? _a : this.queryDeduplication;
        var observable;
        var _b = this.getDocumentInfo(query), serverQuery = _b.serverQuery, clientQuery = _b.clientQuery;
        if (serverQuery) {
            var _c = this, inFlightLinkObservables_1 = _c.inFlightLinkObservables, link = _c.link;
            var operation = {
                query: serverQuery,
                variables: variables,
                operationName: (0, $iX694.getOperationName)(serverQuery) || void 0,
                context: this.prepareContext((0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                    forceFetch: !deduplication
                }))
            };
            context = operation.context;
            if (deduplication) {
                var printedServerQuery_1 = (0, $aaMYp.print)(serverQuery);
                var varJson_1 = (0, $5bIMC.canonicalStringify)(variables);
                var entry = inFlightLinkObservables_1.lookup(printedServerQuery_1, varJson_1);
                observable = entry.observable;
                if (!observable) {
                    var concast = new (0, $ccOlh.Concast)([
                        (0, $5kEJu.execute)(link, operation)
                    ]);
                    observable = entry.observable = concast;
                    concast.beforeNext(function() {
                        inFlightLinkObservables_1.remove(printedServerQuery_1, varJson_1);
                    });
                }
            } else observable = new (0, $ccOlh.Concast)([
                (0, $5kEJu.execute)(link, operation)
            ]);
        } else {
            observable = new (0, $ccOlh.Concast)([
                (0, $8E6bd.Observable).of({
                    data: {}
                })
            ]);
            context = this.prepareContext(context);
        }
        if (clientQuery) observable = (0, $25dOT.asyncMap)(observable, function(result) {
            return _this.localState.runResolvers({
                document: clientQuery,
                remoteResult: result,
                context: context,
                variables: variables
            });
        });
        return observable;
    };
    QueryManager.prototype.getResultsFromLink = function(queryInfo, cacheWriteBehavior, options) {
        var requestId = queryInfo.lastRequestId = this.generateRequestId();
        // Performing transformForLink here gives this.cache a chance to fill in
        // missing fragment definitions (for example) before sending this document
        // through the link chain.
        var linkDocument = this.cache.transformForLink(options.query);
        return (0, $25dOT.asyncMap)(this.getObservableFromLink(linkDocument, options.context, options.variables), function(result) {
            var graphQLErrors = (0, $bLhqY.getGraphQLErrorsFromResult)(result);
            var hasErrors = graphQLErrors.length > 0;
            // If we interrupted this request by calling getResultsFromLink again
            // with the same QueryInfo object, we ignore the old results.
            if (requestId >= queryInfo.lastRequestId) {
                if (hasErrors && options.errorPolicy === "none") // Throwing here effectively calls observer.error.
                throw queryInfo.markError(new (0, $7BIXz.ApolloError)({
                    graphQLErrors: graphQLErrors
                }));
                // Use linkDocument rather than queryInfo.document so the
                // operation/fragments used to write the result are the same as the
                // ones used to obtain it from the link.
                queryInfo.markResult(result, linkDocument, options, cacheWriteBehavior);
                queryInfo.markReady();
            }
            var aqr = {
                data: result.data,
                loading: false,
                networkStatus: (0, $4YvCN.NetworkStatus).ready
            };
            if (hasErrors && options.errorPolicy !== "ignore") {
                aqr.errors = graphQLErrors;
                aqr.networkStatus = (0, $4YvCN.NetworkStatus).error;
            }
            return aqr;
        }, function(networkError) {
            var error = (0, $7BIXz.isApolloError)(networkError) ? networkError : new (0, $7BIXz.ApolloError)({
                networkError: networkError
            });
            // Avoid storing errors from older interrupted queries.
            if (requestId >= queryInfo.lastRequestId) queryInfo.markError(error);
            throw error;
        });
    };
    QueryManager.prototype.fetchConcastWithInfo = function(queryId, options, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus, query) {
        var _this = this;
        if (networkStatus === void 0) networkStatus = (0, $4YvCN.NetworkStatus).loading;
        if (query === void 0) query = options.query;
        var variables = this.getVariables(query, options.variables);
        var queryInfo = this.getQuery(queryId);
        var defaults = this.defaultOptions.watchQuery;
        var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? defaults && defaults.fetchPolicy || "cache-first" : _a, _b = options.errorPolicy, errorPolicy = _b === void 0 ? defaults && defaults.errorPolicy || "none" : _b, _c = options.returnPartialData, returnPartialData = _c === void 0 ? false : _c, _d = options.notifyOnNetworkStatusChange, notifyOnNetworkStatusChange = _d === void 0 ? false : _d, _e = options.context, context = _e === void 0 ? {} : _e;
        var normalized = Object.assign({}, options, {
            query: query,
            variables: variables,
            fetchPolicy: fetchPolicy,
            errorPolicy: errorPolicy,
            returnPartialData: returnPartialData,
            notifyOnNetworkStatusChange: notifyOnNetworkStatusChange,
            context: context
        });
        var fromVariables = function(variables) {
            // Since normalized is always a fresh copy of options, it's safe to
            // modify its properties here, rather than creating yet another new
            // WatchQueryOptions object.
            normalized.variables = variables;
            var sourcesWithInfo = _this.fetchQueryByPolicy(queryInfo, normalized, networkStatus);
            if (// If we're in standby, postpone advancing options.fetchPolicy using
            // applyNextFetchPolicy.
            normalized.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
            // this is another way to detect when nothing was done/fetched.
            sourcesWithInfo.sources.length > 0 && queryInfo.observableQuery) queryInfo.observableQuery["applyNextFetchPolicy"]("after-fetch", options);
            return sourcesWithInfo;
        };
        // This cancel function needs to be set before the concast is created,
        // in case concast creation synchronously cancels the request.
        var cleanupCancelFn = function() {
            return _this.fetchCancelFns.delete(queryId);
        };
        this.fetchCancelFns.set(queryId, function(reason) {
            cleanupCancelFn();
            // This delay ensures the concast variable has been initialized.
            setTimeout(function() {
                return concast.cancel(reason);
            });
        });
        var concast, containsDataFromLink;
        // If the query has @export(as: ...) directives, then we need to
        // process those directives asynchronously. When there are no
        // @export directives (the common case), we deliberately avoid
        // wrapping the result of this.fetchQueryByPolicy in a Promise,
        // since the timing of result delivery is (unfortunately) important
        // for backwards compatibility. TODO This code could be simpler if
        // we deprecated and removed LocalState.
        if (this.getDocumentInfo(normalized.query).hasClientExports) {
            concast = new (0, $ccOlh.Concast)(this.localState.addExportedVariables(normalized.query, normalized.variables, normalized.context).then(fromVariables).then(function(sourcesWithInfo) {
                return sourcesWithInfo.sources;
            }));
            // there is just no way we can synchronously get the *right* value here,
            // so we will assume `true`, which is the behaviour before the bug fix in
            // #10597. This means that bug is not fixed in that case, and is probably
            // un-fixable with reasonable effort for the edge case of @export as
            // directives.
            containsDataFromLink = true;
        } else {
            var sourcesWithInfo = fromVariables(normalized.variables);
            containsDataFromLink = sourcesWithInfo.fromLink;
            concast = new (0, $ccOlh.Concast)(sourcesWithInfo.sources);
        }
        concast.promise.then(cleanupCancelFn, cleanupCancelFn);
        return {
            concast: concast,
            fromLink: containsDataFromLink
        };
    };
    QueryManager.prototype.refetchQueries = function(_a) {
        var _this = this;
        var updateCache = _a.updateCache, include = _a.include, _b = _a.optimistic, optimistic = _b === void 0 ? false : _b, _c = _a.removeOptimistic, removeOptimistic = _c === void 0 ? optimistic ? (0, $d9sqa.makeUniqueId)("refetchQueries") : void 0 : _c, onQueryUpdated = _a.onQueryUpdated;
        var includedQueriesById = new Map();
        if (include) this.getObservableQueries(include).forEach(function(oq, queryId) {
            includedQueriesById.set(queryId, {
                oq: oq,
                lastDiff: _this.getQuery(queryId).getDiff()
            });
        });
        var results = new Map();
        if (updateCache) this.cache.batch({
            update: updateCache,
            // Since you can perform any combination of cache reads and/or writes in
            // the cache.batch update function, its optimistic option can be either
            // a boolean or a string, representing three distinct modes of
            // operation:
            //
            // * false: read/write only the root layer
            // * true: read/write the topmost layer
            // * string: read/write a fresh optimistic layer with that ID string
            //
            // When typeof optimistic === "string", a new optimistic layer will be
            // temporarily created within cache.batch with that string as its ID. If
            // we then pass that same string as the removeOptimistic option, we can
            // make cache.batch immediately remove the optimistic layer after
            // running the updateCache function, triggering only one broadcast.
            //
            // However, the refetchQueries method accepts only true or false for its
            // optimistic option (not string). We interpret true to mean a temporary
            // optimistic layer should be created, to allow efficiently rolling back
            // the effect of the updateCache function, which involves passing a
            // string instead of true as the optimistic option to cache.batch, when
            // refetchQueries receives optimistic: true.
            //
            // In other words, we are deliberately not supporting the use case of
            // writing to an *existing* optimistic layer (using the refetchQueries
            // updateCache function), since that would potentially interfere with
            // other optimistic updates in progress. Instead, you can read/write
            // only the root layer by passing optimistic: false to refetchQueries,
            // or you can read/write a brand new optimistic layer that will be
            // automatically removed by passing optimistic: true.
            optimistic: optimistic && removeOptimistic || false,
            // The removeOptimistic option can also be provided by itself, even if
            // optimistic === false, to remove some previously-added optimistic
            // layer safely and efficiently, like we do in markMutationResult.
            //
            // If an explicit removeOptimistic string is provided with optimistic:
            // true, the removeOptimistic string will determine the ID of the
            // temporary optimistic layer, in case that ever matters.
            removeOptimistic: removeOptimistic,
            onWatchUpdated: function(watch, diff, lastDiff) {
                var oq = watch.watcher instanceof (0, $bEGCk.QueryInfo) && watch.watcher.observableQuery;
                if (oq) {
                    if (onQueryUpdated) {
                        // Since we're about to handle this query now, remove it from
                        // includedQueriesById, in case it was added earlier because of
                        // options.include.
                        includedQueriesById.delete(oq.queryId);
                        var result = onQueryUpdated(oq, diff, lastDiff);
                        if (result === true) // The onQueryUpdated function requested the default refetching
                        // behavior by returning true.
                        result = oq.refetch();
                        // Record the result in the results Map, as long as onQueryUpdated
                        // did not return false to skip/ignore this result.
                        if (result !== false) results.set(oq, result);
                        // Allow the default cache broadcast to happen, except when
                        // onQueryUpdated returns false.
                        return result;
                    }
                    if (onQueryUpdated !== null) // If we don't have an onQueryUpdated function, and onQueryUpdated
                    // was not disabled by passing null, make sure this query is
                    // "included" like any other options.include-specified query.
                    includedQueriesById.set(oq.queryId, {
                        oq: oq,
                        lastDiff: lastDiff,
                        diff: diff
                    });
                }
            }
        });
        if (includedQueriesById.size) includedQueriesById.forEach(function(_a, queryId) {
            var oq = _a.oq, lastDiff = _a.lastDiff, diff = _a.diff;
            var result;
            // If onQueryUpdated is provided, we want to use it for all included
            // queries, even the QueryOptions ones.
            if (onQueryUpdated) {
                if (!diff) {
                    var info = oq["queryInfo"];
                    info.reset(); // Force info.getDiff() to read from cache.
                    diff = info.getDiff();
                }
                result = onQueryUpdated(oq, diff, lastDiff);
            }
            // Otherwise, we fall back to refetching.
            if (!onQueryUpdated || result === true) result = oq.refetch();
            if (result !== false) results.set(oq, result);
            if (queryId.indexOf("legacyOneTimeQuery") >= 0) _this.stopQueryNoBroadcast(queryId);
        });
        if (removeOptimistic) // In case no updateCache callback was provided (so cache.batch was not
        // called above, and thus did not already remove the optimistic layer),
        // remove it here. Since this is a no-op when the layer has already been
        // removed, we do it even if we called cache.batch above, since it's
        // possible this.cache is an instance of some ApolloCache subclass other
        // than InMemoryCache, and does not fully support the removeOptimistic
        // option for cache.batch.
        this.cache.removeOptimistic(removeOptimistic);
        return results;
    };
    QueryManager.prototype.fetchQueryByPolicy = function(queryInfo, _a, // The initial networkStatus for this fetch, most often
    // NetworkStatus.loading, but also possibly fetchMore, poll, refetch,
    // or setVariables.
    networkStatus) {
        var _this = this;
        var query = _a.query, variables = _a.variables, fetchPolicy = _a.fetchPolicy, refetchWritePolicy = _a.refetchWritePolicy, errorPolicy = _a.errorPolicy, returnPartialData = _a.returnPartialData, context = _a.context, notifyOnNetworkStatusChange = _a.notifyOnNetworkStatusChange;
        var oldNetworkStatus = queryInfo.networkStatus;
        queryInfo.init({
            document: query,
            variables: variables,
            networkStatus: networkStatus
        });
        var readCache = function() {
            return queryInfo.getDiff();
        };
        var resultsFromCache = function(diff, networkStatus) {
            if (networkStatus === void 0) networkStatus = queryInfo.networkStatus || (0, $4YvCN.NetworkStatus).loading;
            var data = diff.result;
            if (globalThis.__DEV__ !== false && !returnPartialData && !(0, $hr8gD.equal)(data, {})) (0, $4PfqZ.logMissingFieldErrors)(diff.missing);
            var fromData = function(data) {
                return (0, $8E6bd.Observable).of((0, $fKE23.__assign)({
                    data: data,
                    loading: (0, $4YvCN.isNetworkRequestInFlight)(networkStatus),
                    networkStatus: networkStatus
                }, diff.complete ? null : {
                    partial: true
                }));
            };
            if (data && _this.getDocumentInfo(query).hasForcedResolvers) return _this.localState.runResolvers({
                document: query,
                remoteResult: {
                    data: data
                },
                context: context,
                variables: variables,
                onlyRunForcedResolvers: true
            }).then(function(resolved) {
                return fromData(resolved.data || void 0);
            });
            // Resolves https://github.com/apollographql/apollo-client/issues/10317.
            // If errorPolicy is 'none' and notifyOnNetworkStatusChange is true,
            // data was incorrectly returned from the cache on refetch:
            // if diff.missing exists, we should not return cache data.
            if (errorPolicy === "none" && networkStatus === (0, $4YvCN.NetworkStatus).refetch && Array.isArray(diff.missing)) return fromData(void 0);
            return fromData(data);
        };
        var cacheWriteBehavior = fetchPolicy === "no-cache" ? 0 /* CacheWriteBehavior.FORBID */  : networkStatus === (0, $4YvCN.NetworkStatus).refetch && refetchWritePolicy !== "merge" ? 1 /* CacheWriteBehavior.OVERWRITE */  : 2 /* CacheWriteBehavior.MERGE */ ;
        var resultsFromLink = function() {
            return _this.getResultsFromLink(queryInfo, cacheWriteBehavior, {
                query: query,
                variables: variables,
                context: context,
                fetchPolicy: fetchPolicy,
                errorPolicy: errorPolicy
            });
        };
        var shouldNotify = notifyOnNetworkStatusChange && typeof oldNetworkStatus === "number" && oldNetworkStatus !== networkStatus && (0, $4YvCN.isNetworkRequestInFlight)(networkStatus);
        switch(fetchPolicy){
            default:
            case "cache-first":
                var diff = readCache();
                if (diff.complete) return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(diff, queryInfo.markReady())
                    ]
                };
                if (returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-and-network":
                var diff = readCache();
                if (diff.complete || returnPartialData || shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(diff),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "cache-only":
                return {
                    fromLink: false,
                    sources: [
                        resultsFromCache(readCache(), queryInfo.markReady())
                    ]
                };
            case "network-only":
                if (shouldNotify) return {
                    fromLink: true,
                    sources: [
                        resultsFromCache(readCache()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "no-cache":
                if (shouldNotify) return {
                    fromLink: true,
                    // Note that queryInfo.getDiff() for no-cache queries does not call
                    // cache.diff, but instead returns a { complete: false } stub result
                    // when there is no queryInfo.diff already defined.
                    sources: [
                        resultsFromCache(queryInfo.getDiff()),
                        resultsFromLink()
                    ]
                };
                return {
                    fromLink: true,
                    sources: [
                        resultsFromLink()
                    ]
                };
            case "standby":
                return {
                    fromLink: false,
                    sources: []
                };
        }
    };
    QueryManager.prototype.getQuery = function(queryId) {
        if (queryId && !this.queries.has(queryId)) this.queries.set(queryId, new (0, $bEGCk.QueryInfo)(this, queryId));
        return this.queries.get(queryId);
    };
    QueryManager.prototype.prepareContext = function(context) {
        if (context === void 0) context = {};
        var newContext = this.localState.prepareContext(context);
        return (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.defaultContext), newContext), {
            clientAwareness: this.clientAwareness
        });
    };
    return QueryManager;
}();

});
parcelRegister("25dOT", function(module, exports) {

$parcel$export(module.exports, "asyncMap", () => $1846c4bc1fd2039e$export$707ee4c4c95d39e3);
parcelRequire("eayTI");
var $8E6bd = parcelRequire("8E6bd");
function $1846c4bc1fd2039e$export$707ee4c4c95d39e3(observable, mapFn, catchFn) {
    return new (0, $8E6bd.Observable)(function(observer) {
        var promiseQueue = {
            // Normally we would initialize promiseQueue to Promise.resolve(), but
            // in this case, for backwards compatibility, we need to be careful to
            // invoke the first callback synchronously.
            then: function(callback) {
                return new Promise(function(resolve) {
                    return resolve(callback());
                });
            }
        };
        function makeCallback(examiner, key) {
            return function(arg) {
                if (examiner) {
                    var both = function() {
                        // If the observer is closed, we don't want to continue calling the
                        // mapping function - it's result will be swallowed anyways.
                        return observer.closed ? /* will be swallowed */ 0 : examiner(arg);
                    };
                    promiseQueue = promiseQueue.then(both, both).then(function(result) {
                        return observer.next(result);
                    }, function(error) {
                        return observer.error(error);
                    });
                } else observer[key](arg);
            };
        }
        var handler = {
            next: makeCallback(mapFn, "next"),
            error: makeCallback(catchFn, "error"),
            complete: function() {
                // no need to reassign `promiseQueue`, after `observer.complete`,
                // the observer will be closed and short-circuit everything anyways
                /*promiseQueue = */ promiseQueue.then(function() {
                    return observer.complete();
                });
            }
        };
        var sub = observable.subscribe(handler);
        return function() {
            return sub.unsubscribe();
        };
    });
}

});

parcelRegister("ccOlh", function(module, exports) {

$parcel$export(module.exports, "Concast", () => $8e2da7f1c53ecace$export$ae0cf2ec7a6fa78e);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("eayTI");
var $8E6bd = parcelRequire("8E6bd");

var $cHs5P = parcelRequire("cHs5P");

var $2d78H = parcelRequire("2d78H");
function $8e2da7f1c53ecace$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// A Concast<T> observable concatenates the given sources into a single
// non-overlapping sequence of Ts, automatically unwrapping any promises,
// and broadcasts the T elements of that sequence to any number of
// subscribers, all without creating a bunch of intermediary Observable
// wrapper objects.
//
// Even though any number of observers can subscribe to the Concast, each
// source observable is guaranteed to receive at most one subscribe call,
// and the results are multicast to all observers.
//
// In addition to broadcasting every next/error message to this.observers,
// the Concast stores the most recent message using this.latest, so any
// new observers can immediately receive the latest message, even if it
// was originally delivered in the past. This behavior means we can assume
// every active observer in this.observers has received the same most
// recent message.
//
// With the exception of this.latest replay, a Concast is a "hot"
// observable in the sense that it does not replay past results from the
// beginning of time for each new observer.
//
// Could we have used some existing RxJS class instead? Concast<T> is
// similar to a BehaviorSubject<T>, because it is multicast and redelivers
// the latest next/error message to new subscribers. Unlike Subject<T>,
// Concast<T> does not expose an Observer<T> interface (this.handlers is
// intentionally private), since Concast<T> gets its inputs from the
// concatenated sources. If we ever switch to RxJS, there may be some
// value in reusing their code, but for now we use zen-observable, which
// does not contain any Subject implementations.
var $8e2da7f1c53ecace$export$ae0cf2ec7a6fa78e = /** @class */ function(_super) {
    (0, $fKE23.__extends)(Concast, _super);
    // Not only can the individual elements of the iterable be promises, but
    // also the iterable itself can be wrapped in a promise.
    function Concast(sources) {
        var _this = _super.call(this, function(observer) {
            _this.addObserver(observer);
            return function() {
                return _this.removeObserver(observer);
            };
        }) || this;
        // Active observers receiving broadcast messages. Thanks to this.latest,
        // we can assume all observers in this Set have received the same most
        // recent message, though possibly at different times in the past.
        _this.observers = new Set();
        _this.promise = new Promise(function(resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        // Bound handler functions that can be reused for every internal
        // subscription.
        _this.handlers = {
            next: function(result) {
                if (_this.sub !== null) {
                    _this.latest = [
                        "next",
                        result
                    ];
                    _this.notify("next", result);
                    (0, $cHs5P.iterateObserversSafely)(_this.observers, "next", result);
                }
            },
            error: function(error) {
                var sub = _this.sub;
                if (sub !== null) {
                    // Delay unsubscribing from the underlying subscription slightly,
                    // so that immediately subscribing another observer can keep the
                    // subscription active.
                    if (sub) setTimeout(function() {
                        return sub.unsubscribe();
                    });
                    _this.sub = null;
                    _this.latest = [
                        "error",
                        error
                    ];
                    _this.reject(error);
                    _this.notify("error", error);
                    (0, $cHs5P.iterateObserversSafely)(_this.observers, "error", error);
                }
            },
            complete: function() {
                var _a = _this, sub = _a.sub, _b = _a.sources, sources = _b === void 0 ? [] : _b;
                if (sub !== null) {
                    // If complete is called before concast.start, this.sources may be
                    // undefined, so we use a default value of [] for sources. That works
                    // here because it falls into the if (!value) {...} block, which
                    // appropriately terminates the Concast, even if this.sources might
                    // eventually have been initialized to a non-empty array.
                    var value = sources.shift();
                    if (!value) {
                        if (sub) setTimeout(function() {
                            return sub.unsubscribe();
                        });
                        _this.sub = null;
                        if (_this.latest && _this.latest[0] === "next") _this.resolve(_this.latest[1]);
                        else _this.resolve();
                        _this.notify("complete");
                        // We do not store this.latest = ["complete"], because doing so
                        // discards useful information about the previous next (or
                        // error) message. Instead, if new observers subscribe after
                        // this Concast has completed, they will receive the final
                        // 'next' message (unless there was an error) immediately
                        // followed by a 'complete' message (see addObserver).
                        (0, $cHs5P.iterateObserversSafely)(_this.observers, "complete");
                    } else if ($8e2da7f1c53ecace$var$isPromiseLike(value)) value.then(function(obs) {
                        return _this.sub = obs.subscribe(_this.handlers);
                    }, _this.handlers.error);
                    else _this.sub = value.subscribe(_this.handlers);
                }
            }
        };
        _this.nextResultListeners = new Set();
        // A public way to abort observation and broadcast.
        _this.cancel = function(reason) {
            _this.reject(reason);
            _this.sources = [];
            _this.handlers.complete();
        };
        // Suppress rejection warnings for this.promise, since it's perfectly
        // acceptable to pay no attention to this.promise if you're consuming
        // the results through the normal observable API.
        _this.promise.catch(function(_) {});
        // If someone accidentally tries to create a Concast using a subscriber
        // function, recover by creating an Observable from that subscriber and
        // using it as the source.
        if (typeof sources === "function") sources = [
            new (0, $8E6bd.Observable)(sources)
        ];
        if ($8e2da7f1c53ecace$var$isPromiseLike(sources)) sources.then(function(iterable) {
            return _this.start(iterable);
        }, _this.handlers.error);
        else _this.start(sources);
        return _this;
    }
    Concast.prototype.start = function(sources) {
        if (this.sub !== void 0) return;
        // In practice, sources is most often simply an Array of observables.
        // TODO Consider using sources[Symbol.iterator]() to take advantage
        // of the laziness of non-Array iterables.
        this.sources = Array.from(sources);
        // Calling this.handlers.complete() kicks off consumption of the first
        // source observable. It's tempting to do this step lazily in
        // addObserver, but this.promise can be accessed without calling
        // addObserver, so consumption needs to begin eagerly.
        this.handlers.complete();
    };
    Concast.prototype.deliverLastMessage = function(observer) {
        if (this.latest) {
            var nextOrError = this.latest[0];
            var method = observer[nextOrError];
            if (method) method.call(observer, this.latest[1]);
            // If the subscription is already closed, and the last message was
            // a 'next' message, simulate delivery of the final 'complete'
            // message again.
            if (this.sub === null && nextOrError === "next" && observer.complete) observer.complete();
        }
    };
    Concast.prototype.addObserver = function(observer) {
        if (!this.observers.has(observer)) {
            // Immediately deliver the most recent message, so we can always
            // be sure all observers have the latest information.
            this.deliverLastMessage(observer);
            this.observers.add(observer);
        }
    };
    Concast.prototype.removeObserver = function(observer) {
        if (this.observers.delete(observer) && this.observers.size < 1) // In case there are still any listeners in this.nextResultListeners, and
        // no error or completion has been broadcast yet, make sure those
        // observers have a chance to run and then remove themselves from
        // this.observers.
        this.handlers.complete();
    };
    Concast.prototype.notify = function(method, arg) {
        var nextResultListeners = this.nextResultListeners;
        if (nextResultListeners.size) {
            // Replacing this.nextResultListeners first ensures it does not grow while
            // we are iterating over it, potentially leading to infinite loops.
            this.nextResultListeners = new Set();
            nextResultListeners.forEach(function(listener) {
                return listener(method, arg);
            });
        }
    };
    // We need a way to run callbacks just *before* the next result (or error or
    // completion) is delivered by this Concast, so we can be sure any code that
    // runs as a result of delivering that result/error observes the effects of
    // running the callback(s). It was tempting to reuse the Observer type instead
    // of introducing NextResultListener, but that messes with the sizing and
    // maintenance of this.observers, and ends up being more code overall.
    Concast.prototype.beforeNext = function(callback) {
        var called = false;
        this.nextResultListeners.add(function(method, arg) {
            if (!called) {
                called = true;
                callback(method, arg);
            }
        });
    };
    return Concast;
}((0, $8E6bd.Observable));
// Necessary because the Concast constructor has a different signature
// than the Observable constructor.
(0, $2d78H.fixObservableSubclass)($8e2da7f1c53ecace$export$ae0cf2ec7a6fa78e);

});
parcelRegister("cHs5P", function(module, exports) {

$parcel$export(module.exports, "iterateObserversSafely", () => $93ef4ae34f0130da$export$9f6c99ae166dbeca);
function $93ef4ae34f0130da$export$9f6c99ae166dbeca(observers, method, argument) {
    // In case observers is modified during iteration, we need to commit to the
    // original elements, which also provides an opportunity to filter them down
    // to just the observers with the given method.
    var observersWithMethod = [];
    observers.forEach(function(obs) {
        return obs[method] && observersWithMethod.push(obs);
    });
    observersWithMethod.forEach(function(obs) {
        return obs[method](argument);
    });
}

});

parcelRegister("2d78H", function(module, exports) {

$parcel$export(module.exports, "fixObservableSubclass", () => $19c2555f47dd025f$export$33c8bd820eece9b2);
parcelRequire("eayTI");
var $8E6bd = parcelRequire("8E6bd");

var $7X1wJ = parcelRequire("7X1wJ");
function $19c2555f47dd025f$export$33c8bd820eece9b2(subclass) {
    function set(key) {
        // Object.defineProperty is necessary because the Symbol.species
        // property is a getter by default in modern JS environments, so we
        // can't assign to it with a normal assignment expression.
        Object.defineProperty(subclass, key, {
            value: (0, $8E6bd.Observable)
        });
    }
    if ((0, $7X1wJ.canUseSymbol) && Symbol.species) set(Symbol.species);
    // The "@@species" string is used as a fake Symbol.species value in some
    // polyfill systems (including the SymbolSpecies variable used by
    // zen-observable), so we should set it as well, to be safe.
    set("@@species");
    return subclass;
}

});


parcelRegister("bLhqY", function(module, exports) {

$parcel$export(module.exports, "graphQLResultHasError", () => $89019b8400ada2bf$export$b4df399e879e53ab);
$parcel$export(module.exports, "getGraphQLErrorsFromResult", () => $89019b8400ada2bf$export$a163557155188b6e);

var $kxw1Y = parcelRequire("kxw1Y");

var $dajVc = parcelRequire("dajVc");
function $89019b8400ada2bf$export$b4df399e879e53ab(result) {
    var errors = $89019b8400ada2bf$export$a163557155188b6e(result);
    return (0, $kxw1Y.isNonEmptyArray)(errors);
}
function $89019b8400ada2bf$export$a163557155188b6e(result) {
    var graphQLErrors = (0, $kxw1Y.isNonEmptyArray)(result.errors) ? result.errors.slice(0) : [];
    if ((0, $dajVc.isExecutionPatchIncrementalResult)(result) && (0, $kxw1Y.isNonEmptyArray)(result.incremental)) result.incremental.forEach(function(incrementalResult) {
        if (incrementalResult.errors) graphQLErrors.push.apply(graphQLErrors, incrementalResult.errors);
    });
    return graphQLErrors;
}

});

parcelRegister("4PfqZ", function(module, exports) {

$parcel$export(module.exports, "ObservableQuery", () => $3837e5c4f22b95ed$export$6c1b56eac59c9584);
$parcel$export(module.exports, "logMissingFieldErrors", () => $3837e5c4f22b95ed$export$b7e1973aacac3ae7);
$parcel$export(module.exports, "reobserveCacheFirst", () => $3837e5c4f22b95ed$export$419171d60552792a);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $hr8gD = parcelRequire("hr8gD");

var $4YvCN = parcelRequire("4YvCN");

var $awPNv = parcelRequire("awPNv");
var $jZIxU = parcelRequire("jZIxU");
var $2d78H = parcelRequire("2d78H");
var $iX694 = parcelRequire("iX694");
var $cHs5P = parcelRequire("cHs5P");parcelRequire("eayTI");
var $8E6bd = parcelRequire("8E6bd");

var $ab1J9 = parcelRequire("ab1J9");
var $3837e5c4f22b95ed$var$assign = Object.assign, $3837e5c4f22b95ed$var$hasOwnProperty = Object.hasOwnProperty;
var $3837e5c4f22b95ed$export$6c1b56eac59c9584 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ObservableQuery, _super);
    function ObservableQuery(_a) {
        var queryManager = _a.queryManager, queryInfo = _a.queryInfo, options = _a.options;
        var _this = _super.call(this, function(observer) {
            // Zen Observable has its own error function, so in order to log correctly
            // we need to provide a custom error callback.
            try {
                var subObserver = observer._subscription._observer;
                if (subObserver && !subObserver.error) subObserver.error = $3837e5c4f22b95ed$var$defaultSubscriptionObserverErrorCallback;
            } catch (_a) {}
            var first = !_this.observers.size;
            _this.observers.add(observer);
            // Deliver most recent error or result.
            var last = _this.last;
            if (last && last.error) observer.error && observer.error(last.error);
            else if (last && last.result) observer.next && observer.next(last.result);
            // Initiate observation of this query if it hasn't been reported to
            // the QueryManager yet.
            if (first) // Blindly catching here prevents unhandled promise rejections,
            // and is safe because the ObservableQuery handles this error with
            // this.observer.error, so we're not just swallowing the error by
            // ignoring it here.
            _this.reobserve().catch(function() {});
            return function() {
                if (_this.observers.delete(observer) && !_this.observers.size) _this.tearDownQuery();
            };
        }) || this;
        _this.observers = new Set();
        _this.subscriptions = new Set();
        // related classes
        _this.queryInfo = queryInfo;
        _this.queryManager = queryManager;
        // active state
        _this.waitForOwnResult = $3837e5c4f22b95ed$var$skipCacheDataFor(options.fetchPolicy);
        _this.isTornDown = false;
        var _b = queryManager.defaultOptions.watchQuery, _c = _b === void 0 ? {} : _b, _d = _c.fetchPolicy, defaultFetchPolicy = _d === void 0 ? "cache-first" : _d;
        var _e = options.fetchPolicy, fetchPolicy = _e === void 0 ? defaultFetchPolicy : _e, // Make sure we don't store "standby" as the initialFetchPolicy.
        _f = options.initialFetchPolicy, // Make sure we don't store "standby" as the initialFetchPolicy.
        initialFetchPolicy = _f === void 0 ? fetchPolicy === "standby" ? defaultFetchPolicy : fetchPolicy : _f;
        _this.options = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, options), {
            // Remember the initial options.fetchPolicy so we can revert back to this
            // policy when variables change. This information can also be specified
            // (or overridden) by providing options.initialFetchPolicy explicitly.
            initialFetchPolicy: initialFetchPolicy,
            // This ensures this.options.fetchPolicy always has a string value, in
            // case options.fetchPolicy was not provided.
            fetchPolicy: fetchPolicy
        });
        _this.queryId = queryInfo.queryId || queryManager.generateQueryId();
        var opDef = (0, $iX694.getOperationDefinition)(_this.query);
        _this.queryName = opDef && opDef.name && opDef.name.value;
        return _this;
    }
    Object.defineProperty(ObservableQuery.prototype, "query", {
        // The `query` computed property will always reflect the document transformed
        // by the last run query. `this.options.query` will always reflect the raw
        // untransformed query to ensure document transforms with runtime conditionals
        // are run on the original document.
        get: function() {
            return this.lastQuery || this.options.query;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObservableQuery.prototype, "variables", {
        // Computed shorthand for this.options.variables, preserved for
        // backwards compatibility.
        /**
         * An object containing the variables that were provided for the query.
         */ get: function() {
            return this.options.variables;
        },
        enumerable: false,
        configurable: true
    });
    ObservableQuery.prototype.result = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            // TODO: this code doesn’t actually make sense insofar as the observer
            // will never exist in this.observers due how zen-observable wraps observables.
            // https://github.com/zenparsing/zen-observable/blob/master/src/Observable.js#L169
            var observer = {
                next: function(result) {
                    resolve(result);
                    // Stop the query within the QueryManager if we can before
                    // this function returns.
                    //
                    // We do this in order to prevent observers piling up within
                    // the QueryManager. Notice that we only fully unsubscribe
                    // from the subscription in a setTimeout(..., 0)  call. This call can
                    // actually be handled by the browser at a much later time. If queries
                    // are fired in the meantime, observers that should have been removed
                    // from the QueryManager will continue to fire, causing an unnecessary
                    // performance hit.
                    _this.observers.delete(observer);
                    if (!_this.observers.size) _this.queryManager.removeQuery(_this.queryId);
                    setTimeout(function() {
                        subscription.unsubscribe();
                    }, 0);
                },
                error: reject
            };
            var subscription = _this.subscribe(observer);
        });
    };
    /** @internal */ ObservableQuery.prototype.resetDiff = function() {
        this.queryInfo.resetDiff();
    };
    ObservableQuery.prototype.getCurrentResult = function(saveAsLastResult) {
        if (saveAsLastResult === void 0) saveAsLastResult = true;
        // Use the last result as long as the variables match this.variables.
        var lastResult = this.getLastResult(true);
        var networkStatus = this.queryInfo.networkStatus || lastResult && lastResult.networkStatus || (0, $4YvCN.NetworkStatus).ready;
        var result = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, lastResult), {
            loading: (0, $4YvCN.isNetworkRequestInFlight)(networkStatus),
            networkStatus: networkStatus
        });
        var _a = this.options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a;
        if (// These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        $3837e5c4f22b95ed$var$skipCacheDataFor(fetchPolicy) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers) ;
        else if (this.waitForOwnResult) // This would usually be a part of `QueryInfo.getDiff()`.
        // which we skip in the waitForOwnResult case since we are not
        // interested in the diff.
        this.queryInfo["updateWatch"]();
        else {
            var diff = this.queryInfo.getDiff();
            if (diff.complete || this.options.returnPartialData) result.data = diff.result;
            if ((0, $hr8gD.equal)(result.data, {})) result.data = void 0;
            if (diff.complete) {
                // Similar to setting result.partial to false, but taking advantage of the
                // falsiness of missing fields.
                delete result.partial;
                // If the diff is complete, and we're using a FetchPolicy that
                // terminates after a complete cache read, we can assume the next result
                // we receive will have NetworkStatus.ready and !loading.
                if (diff.complete && result.networkStatus === (0, $4YvCN.NetworkStatus).loading && (fetchPolicy === "cache-first" || fetchPolicy === "cache-only")) {
                    result.networkStatus = (0, $4YvCN.NetworkStatus).ready;
                    result.loading = false;
                }
            } else result.partial = true;
            if (globalThis.__DEV__ !== false && !diff.complete && !this.options.partialRefetch && !result.loading && !result.data && !result.error) $3837e5c4f22b95ed$export$b7e1973aacac3ae7(diff.missing);
        }
        if (saveAsLastResult) this.updateLastResult(result);
        return result;
    };
    // Compares newResult to the snapshot we took of this.lastResult when it was
    // first received.
    ObservableQuery.prototype.isDifferentFromLastResult = function(newResult, variables) {
        if (!this.last) return true;
        var resultIsDifferent = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ? !(0, $ab1J9.equalByQuery)(this.query, this.last.result, newResult, this.variables) : !(0, $hr8gD.equal)(this.last.result, newResult);
        return resultIsDifferent || variables && !(0, $hr8gD.equal)(this.last.variables, variables);
    };
    ObservableQuery.prototype.getLast = function(key, variablesMustMatch) {
        var last = this.last;
        if (last && last[key] && (!variablesMustMatch || (0, $hr8gD.equal)(last.variables, this.variables))) return last[key];
    };
    ObservableQuery.prototype.getLastResult = function(variablesMustMatch) {
        return this.getLast("result", variablesMustMatch);
    };
    ObservableQuery.prototype.getLastError = function(variablesMustMatch) {
        return this.getLast("error", variablesMustMatch);
    };
    ObservableQuery.prototype.resetLastResults = function() {
        delete this.last;
        this.isTornDown = false;
    };
    ObservableQuery.prototype.resetQueryStoreErrors = function() {
        this.queryManager.resetErrors(this.queryId);
    };
    /**
     * Update the variables of this observable query, and fetch the new results.
     * This method should be preferred over `setVariables` in most use cases.
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.refetch = function(variables) {
        var _a;
        var reobserveOptions = {
            // Always disable polling for refetches.
            pollInterval: 0
        };
        // Unless the provided fetchPolicy always consults the network
        // (no-cache, network-only, or cache-and-network), override it with
        // network-only to force the refetch for this fetchQuery call.
        var fetchPolicy = this.options.fetchPolicy;
        if (fetchPolicy === "cache-and-network") reobserveOptions.fetchPolicy = fetchPolicy;
        else if (fetchPolicy === "no-cache") reobserveOptions.fetchPolicy = "no-cache";
        else reobserveOptions.fetchPolicy = "network-only";
        if (globalThis.__DEV__ !== false && variables && $3837e5c4f22b95ed$var$hasOwnProperty.call(variables, "variables")) {
            var queryDef = (0, $iX694.getQueryDefinition)(this.query);
            var vars = queryDef.variableDefinitions;
            if (!vars || !vars.some(function(v) {
                return v.variable.name.value === "variables";
            })) globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).warn(20, variables, ((_a = queryDef.name) === null || _a === void 0 ? void 0 : _a.value) || queryDef);
        }
        if (variables && !(0, $hr8gD.equal)(this.options.variables, variables)) // Update the existing options with new variables
        reobserveOptions.variables = this.options.variables = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), variables);
        this.queryInfo.resetLastWrite();
        return this.reobserve(reobserveOptions, (0, $4YvCN.NetworkStatus).refetch);
    };
    /**
     * A function that helps you fetch the next set of results for a [paginated list field](https://www.apollographql.com/docs/react/pagination/core-api/).
     */ ObservableQuery.prototype.fetchMore = function(fetchMoreOptions) {
        var _this = this;
        var combinedOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, fetchMoreOptions.query ? fetchMoreOptions : (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options), {
            query: this.options.query
        }), fetchMoreOptions), {
            variables: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.options.variables), fetchMoreOptions.variables)
        })), {
            // The fetchMore request goes immediately to the network and does
            // not automatically write its result to the cache (hence no-cache
            // instead of network-only), because we allow the caller of
            // fetchMore to provide an updateQuery callback that determines how
            // the data gets written to the cache.
            fetchPolicy: "no-cache"
        });
        combinedOptions.query = this.transformDocument(combinedOptions.query);
        var qid = this.queryManager.generateQueryId();
        // If a temporary query is passed to `fetchMore`, we don't want to store
        // it as the last query result since it may be an optimized query for
        // pagination. We will however run the transforms on the original document
        // as well as the document passed in `fetchMoreOptions` to ensure the cache
        // uses the most up-to-date document which may rely on runtime conditionals.
        this.lastQuery = fetchMoreOptions.query ? this.transformDocument(this.options.query) : combinedOptions.query;
        // Simulate a loading result for the original query with
        // result.networkStatus === NetworkStatus.fetchMore.
        var queryInfo = this.queryInfo;
        var originalNetworkStatus = queryInfo.networkStatus;
        queryInfo.networkStatus = (0, $4YvCN.NetworkStatus).fetchMore;
        if (combinedOptions.notifyOnNetworkStatusChange) this.observe();
        var updatedQuerySet = new Set();
        return this.queryManager.fetchQuery(qid, combinedOptions, (0, $4YvCN.NetworkStatus).fetchMore).then(function(fetchMoreResult) {
            _this.queryManager.removeQuery(qid);
            if (queryInfo.networkStatus === (0, $4YvCN.NetworkStatus).fetchMore) queryInfo.networkStatus = originalNetworkStatus;
            // Performing this cache update inside a cache.batch transaction ensures
            // any affected cache.watch watchers are notified at most once about any
            // updates. Most watchers will be using the QueryInfo class, which
            // responds to notifications by calling reobserveCacheFirst to deliver
            // fetchMore cache results back to this ObservableQuery.
            _this.queryManager.cache.batch({
                update: function(cache) {
                    var updateQuery = fetchMoreOptions.updateQuery;
                    if (updateQuery) cache.updateQuery({
                        query: _this.query,
                        variables: _this.variables,
                        returnPartialData: true,
                        optimistic: false
                    }, function(previous) {
                        return updateQuery(previous, {
                            fetchMoreResult: fetchMoreResult.data,
                            variables: combinedOptions.variables
                        });
                    });
                    else // If we're using a field policy instead of updateQuery, the only
                    // thing we need to do is write the new data to the cache using
                    // combinedOptions.variables (instead of this.variables, which is
                    // what this.updateQuery uses, because it works by abusing the
                    // original field value, keyed by the original variables).
                    cache.writeQuery({
                        query: combinedOptions.query,
                        variables: combinedOptions.variables,
                        data: fetchMoreResult.data
                    });
                },
                onWatchUpdated: function(watch) {
                    // Record the DocumentNode associated with any watched query whose
                    // data were updated by the cache writes above.
                    updatedQuerySet.add(watch.query);
                }
            });
            return fetchMoreResult;
        }).finally(function() {
            // In case the cache writes above did not generate a broadcast
            // notification (which would have been intercepted by onWatchUpdated),
            // likely because the written data were the same as what was already in
            // the cache, we still want fetchMore to deliver its final loading:false
            // result with the unchanged data.
            if (!updatedQuerySet.has(_this.query)) $3837e5c4f22b95ed$export$419171d60552792a(_this);
        });
    };
    // XXX the subscription variables are separate from the query variables.
    // if you want to update subscription variables, right now you have to do that separately,
    // and you can only do it by stopping the subscription and then subscribing again with new variables.
    /**
     * A function that enables you to execute a [subscription](https://www.apollographql.com/docs/react/data/subscriptions/), usually to subscribe to specific fields that were included in the query.
     *
     * This function returns _another_ function that you can call to terminate the subscription.
     */ ObservableQuery.prototype.subscribeToMore = function(options) {
        var _this = this;
        var subscription = this.queryManager.startGraphQLSubscription({
            query: options.document,
            variables: options.variables,
            context: options.context
        }).subscribe({
            next: function(subscriptionData) {
                var updateQuery = options.updateQuery;
                if (updateQuery) _this.updateQuery(function(previous, _a) {
                    var variables = _a.variables;
                    return updateQuery(previous, {
                        subscriptionData: subscriptionData,
                        variables: variables
                    });
                });
            },
            error: function(err) {
                if (options.onError) {
                    options.onError(err);
                    return;
                }
                globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).error(21, err);
            }
        });
        this.subscriptions.add(subscription);
        return function() {
            if (_this.subscriptions.delete(subscription)) subscription.unsubscribe();
        };
    };
    ObservableQuery.prototype.setOptions = function(newOptions) {
        return this.reobserve(newOptions);
    };
    ObservableQuery.prototype.silentSetOptions = function(newOptions) {
        var mergedOptions = (0, $jZIxU.compact)(this.options, newOptions || {});
        $3837e5c4f22b95ed$var$assign(this.options, mergedOptions);
    };
    /**
     * Update the variables of this observable query, and fetch the new results
     * if they've changed. Most users should prefer `refetch` instead of
     * `setVariables` in order to to be properly notified of results even when
     * they come from the cache.
     *
     * Note: the `next` callback will *not* fire if the variables have not changed
     * or if the result is coming from cache.
     *
     * Note: the promise will return the old results immediately if the variables
     * have not changed.
     *
     * Note: the promise will return null immediately if the query is not active
     * (there are no subscribers).
     *
     * @param variables - The new set of variables. If there are missing variables,
     * the previous values of those variables will be used.
     */ ObservableQuery.prototype.setVariables = function(variables) {
        if ((0, $hr8gD.equal)(this.variables, variables)) // If we have no observers, then we don't actually want to make a network
        // request. As soon as someone observes the query, the request will kick
        // off. For now, we just store any changes. (See #1077)
        return this.observers.size ? this.result() : Promise.resolve();
        this.options.variables = variables;
        // See comment above
        if (!this.observers.size) return Promise.resolve();
        return this.reobserve({
            // Reset options.fetchPolicy to its original value.
            fetchPolicy: this.options.initialFetchPolicy,
            variables: variables
        }, (0, $4YvCN.NetworkStatus).setVariables);
    };
    /**
     * A function that enables you to update the query's cached result without executing a followup GraphQL operation.
     *
     * See [using updateQuery and updateFragment](https://www.apollographql.com/docs/react/caching/cache-interaction/#using-updatequery-and-updatefragment) for additional information.
     */ ObservableQuery.prototype.updateQuery = function(mapFn) {
        var queryManager = this.queryManager;
        var result = queryManager.cache.diff({
            query: this.options.query,
            variables: this.variables,
            returnPartialData: true,
            optimistic: false
        }).result;
        var newResult = mapFn(result, {
            variables: this.variables
        });
        if (newResult) {
            queryManager.cache.writeQuery({
                query: this.options.query,
                data: newResult,
                variables: this.variables
            });
            queryManager.broadcastQueries();
        }
    };
    /**
     * A function that instructs the query to begin re-executing at a specified interval (in milliseconds).
     */ ObservableQuery.prototype.startPolling = function(pollInterval) {
        this.options.pollInterval = pollInterval;
        this.updatePolling();
    };
    /**
     * A function that instructs the query to stop polling after a previous call to `startPolling`.
     */ ObservableQuery.prototype.stopPolling = function() {
        this.options.pollInterval = 0;
        this.updatePolling();
    };
    // Update options.fetchPolicy according to options.nextFetchPolicy.
    ObservableQuery.prototype.applyNextFetchPolicy = function(reason, // It's possible to use this method to apply options.nextFetchPolicy to
    // options.fetchPolicy even if options !== this.options, though that happens
    // most often when the options are temporary, used for only one request and
    // then thrown away, so nextFetchPolicy may not end up mattering.
    options) {
        if (options.nextFetchPolicy) {
            var _a = options.fetchPolicy, fetchPolicy = _a === void 0 ? "cache-first" : _a, _b = options.initialFetchPolicy, initialFetchPolicy = _b === void 0 ? fetchPolicy : _b;
            if (fetchPolicy === "standby") ;
            else if (typeof options.nextFetchPolicy === "function") // When someone chooses "cache-and-network" or "network-only" as their
            // initial FetchPolicy, they often do not want future cache updates to
            // trigger unconditional network requests, which is what repeatedly
            // applying the "cache-and-network" or "network-only" policies would
            // seem to imply. Instead, when the cache reports an update after the
            // initial network request, it may be desirable for subsequent network
            // requests to be triggered only if the cache result is incomplete. To
            // that end, the options.nextFetchPolicy option provides an easy way to
            // update options.fetchPolicy after the initial network request, without
            // having to call observableQuery.setOptions.
            options.fetchPolicy = options.nextFetchPolicy(fetchPolicy, {
                reason: reason,
                options: options,
                observable: this,
                initialFetchPolicy: initialFetchPolicy
            });
            else if (reason === "variables-changed") options.fetchPolicy = initialFetchPolicy;
            else options.fetchPolicy = options.nextFetchPolicy;
        }
        return options.fetchPolicy;
    };
    ObservableQuery.prototype.fetch = function(options, newNetworkStatus, query) {
        // TODO Make sure we update the networkStatus (and infer fetchVariables)
        // before actually committing to the fetch.
        this.queryManager.setObservableQuery(this);
        return this.queryManager["fetchConcastWithInfo"](this.queryId, options, newNetworkStatus, query);
    };
    // Turns polling on or off based on this.options.pollInterval.
    ObservableQuery.prototype.updatePolling = function() {
        var _this = this;
        // Avoid polling in SSR mode
        if (this.queryManager.ssrMode) return;
        var _a = this, pollingInfo = _a.pollingInfo, pollInterval = _a.options.pollInterval;
        if (!pollInterval) {
            if (pollingInfo) {
                clearTimeout(pollingInfo.timeout);
                delete this.pollingInfo;
            }
            return;
        }
        if (pollingInfo && pollingInfo.interval === pollInterval) return;
        (0, $kL4FQ.invariant)(pollInterval, 22);
        var info = pollingInfo || (this.pollingInfo = {});
        info.interval = pollInterval;
        var maybeFetch = function() {
            var _a, _b;
            if (_this.pollingInfo) {
                if (!(0, $4YvCN.isNetworkRequestInFlight)(_this.queryInfo.networkStatus) && !((_b = (_a = _this.options).skipPollAttempt) === null || _b === void 0 ? void 0 : _b.call(_a))) _this.reobserve({
                    // Most fetchPolicy options don't make sense to use in a polling context, as
                    // users wouldn't want to be polling the cache directly. However, network-only and
                    // no-cache are both useful for when the user wants to control whether or not the
                    // polled results are written to the cache.
                    fetchPolicy: _this.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
                }, (0, $4YvCN.NetworkStatus).poll).then(poll, poll);
                else poll();
            }
        };
        var poll = function() {
            var info = _this.pollingInfo;
            if (info) {
                clearTimeout(info.timeout);
                info.timeout = setTimeout(maybeFetch, info.interval);
            }
        };
        poll();
    };
    ObservableQuery.prototype.updateLastResult = function(newResult, variables) {
        if (variables === void 0) variables = this.variables;
        var error = this.getLastError();
        // Preserve this.last.error unless the variables have changed.
        if (error && this.last && !(0, $hr8gD.equal)(variables, this.last.variables)) error = void 0;
        return this.last = (0, $fKE23.__assign)({
            result: this.queryManager.assumeImmutableResults ? newResult : (0, $awPNv.cloneDeep)(newResult),
            variables: variables
        }, error ? {
            error: error
        } : null);
    };
    ObservableQuery.prototype.reobserveAsConcast = function(newOptions, newNetworkStatus) {
        var _this = this;
        this.isTornDown = false;
        var useDisposableConcast = // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        newNetworkStatus === (0, $4YvCN.NetworkStatus).refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        newNetworkStatus === (0, $4YvCN.NetworkStatus).fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        newNetworkStatus === (0, $4YvCN.NetworkStatus).poll;
        // Save the old variables, since Object.assign may modify them below.
        var oldVariables = this.options.variables;
        var oldFetchPolicy = this.options.fetchPolicy;
        var mergedOptions = (0, $jZIxU.compact)(this.options, newOptions || {});
        var options = useDisposableConcast ? // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        mergedOptions : $3837e5c4f22b95ed$var$assign(this.options, mergedOptions);
        // Don't update options.query with the transformed query to avoid
        // overwriting this.options.query when we aren't using a disposable concast.
        // We want to ensure we can re-run the custom document transforms the next
        // time a request is made against the original query.
        var query = this.transformDocument(options.query);
        this.lastQuery = query;
        if (!useDisposableConcast) {
            // We can skip calling updatePolling if we're not changing this.options.
            this.updatePolling();
            // Reset options.fetchPolicy to its original value when variables change,
            // unless a new fetchPolicy was provided by newOptions.
            if (newOptions && newOptions.variables && !(0, $hr8gD.equal)(newOptions.variables, oldVariables) && // Don't mess with the fetchPolicy if it's currently "standby".
            options.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
            // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
            options.fetchPolicy === oldFetchPolicy) {
                this.applyNextFetchPolicy("variables-changed", options);
                if (newNetworkStatus === void 0) newNetworkStatus = (0, $4YvCN.NetworkStatus).setVariables;
            }
        }
        this.waitForOwnResult && (this.waitForOwnResult = $3837e5c4f22b95ed$var$skipCacheDataFor(options.fetchPolicy));
        var finishWaitingForOwnResult = function() {
            if (_this.concast === concast) _this.waitForOwnResult = false;
        };
        var variables = options.variables && (0, $fKE23.__assign)({}, options.variables);
        var _a = this.fetch(options, newNetworkStatus, query), concast = _a.concast, fromLink = _a.fromLink;
        var observer = {
            next: function(result) {
                if ((0, $hr8gD.equal)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportResult(result, variables);
                }
            },
            error: function(error) {
                if ((0, $hr8gD.equal)(_this.variables, variables)) {
                    finishWaitingForOwnResult();
                    _this.reportError(error, variables);
                }
            }
        };
        if (!useDisposableConcast && (fromLink || !this.concast)) {
            // We use the {add,remove}Observer methods directly to avoid wrapping
            // observer with an unnecessary SubscriptionObserver object.
            if (this.concast && this.observer) this.concast.removeObserver(this.observer);
            this.concast = concast;
            this.observer = observer;
        }
        concast.addObserver(observer);
        return concast;
    };
    ObservableQuery.prototype.reobserve = function(newOptions, newNetworkStatus) {
        return this.reobserveAsConcast(newOptions, newNetworkStatus).promise;
    };
    ObservableQuery.prototype.resubscribeAfterError = function() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        // If `lastError` is set in the current when the subscription is re-created,
        // the subscription will immediately receive the error, which will
        // cause it to terminate again. To avoid this, we first clear
        // the last error/result from the `observableQuery` before re-starting
        // the subscription, and restore the last value afterwards so that the
        // subscription has a chance to stay open.
        var last = this.last;
        this.resetLastResults();
        var subscription = this.subscribe.apply(this, args);
        this.last = last;
        return subscription;
    };
    // (Re)deliver the current result to this.observers without applying fetch
    // policies or making network requests.
    ObservableQuery.prototype.observe = function() {
        this.reportResult(// Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentResult(false), this.variables);
    };
    ObservableQuery.prototype.reportResult = function(result, variables) {
        var lastError = this.getLastError();
        var isDifferent = this.isDifferentFromLastResult(result, variables);
        // Update the last result even when isDifferentFromLastResult returns false,
        // because the query may be using the @nonreactive directive, and we want to
        // save the the latest version of any nonreactive subtrees (in case
        // getCurrentResult is called), even though we skip broadcasting changes.
        if (lastError || !result.partial || this.options.returnPartialData) this.updateLastResult(result, variables);
        if (lastError || isDifferent) (0, $cHs5P.iterateObserversSafely)(this.observers, "next", result);
    };
    ObservableQuery.prototype.reportError = function(error, variables) {
        // Since we don't get the current result on errors, only the error, we
        // must mirror the updates that occur in QueryStore.markQueryError here
        var errorResult = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.getLastResult()), {
            error: error,
            errors: error.graphQLErrors,
            networkStatus: (0, $4YvCN.NetworkStatus).error,
            loading: false
        });
        this.updateLastResult(errorResult, variables);
        (0, $cHs5P.iterateObserversSafely)(this.observers, "error", this.last.error = error);
    };
    ObservableQuery.prototype.hasObservers = function() {
        return this.observers.size > 0;
    };
    ObservableQuery.prototype.tearDownQuery = function() {
        if (this.isTornDown) return;
        if (this.concast && this.observer) {
            this.concast.removeObserver(this.observer);
            delete this.concast;
            delete this.observer;
        }
        this.stopPolling();
        // stop all active GraphQL subscriptions
        this.subscriptions.forEach(function(sub) {
            return sub.unsubscribe();
        });
        this.subscriptions.clear();
        this.queryManager.stopQuery(this.queryId);
        this.observers.clear();
        this.isTornDown = true;
    };
    ObservableQuery.prototype.transformDocument = function(document) {
        return this.queryManager.transform(document);
    };
    return ObservableQuery;
}((0, $8E6bd.Observable));
// Necessary because the ObservableQuery constructor has a different
// signature than the Observable constructor.
(0, $2d78H.fixObservableSubclass)($3837e5c4f22b95ed$export$6c1b56eac59c9584);
function $3837e5c4f22b95ed$export$419171d60552792a(obsQuery) {
    var _a = obsQuery.options, fetchPolicy = _a.fetchPolicy, nextFetchPolicy = _a.nextFetchPolicy;
    if (fetchPolicy === "cache-and-network" || fetchPolicy === "network-only") return obsQuery.reobserve({
        fetchPolicy: "cache-first",
        // Use a temporary nextFetchPolicy function that replaces itself with the
        // previous nextFetchPolicy value and returns the original fetchPolicy.
        nextFetchPolicy: function(currentFetchPolicy, context) {
            // Replace this nextFetchPolicy function in the options object with the
            // original this.options.nextFetchPolicy value.
            this.nextFetchPolicy = nextFetchPolicy;
            // If the original nextFetchPolicy value was a function, give it a
            // chance to decide what happens here.
            if (typeof this.nextFetchPolicy === "function") return this.nextFetchPolicy(currentFetchPolicy, context);
            // Otherwise go back to the original this.options.fetchPolicy.
            return fetchPolicy;
        }
    });
    return obsQuery.reobserve();
}
function $3837e5c4f22b95ed$var$defaultSubscriptionObserverErrorCallback(error) {
    globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).error(23, error.message, error.stack);
}
function $3837e5c4f22b95ed$export$b7e1973aacac3ae7(missing) {
    if (globalThis.__DEV__ !== false && missing) globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).debug(24, missing);
}
function $3837e5c4f22b95ed$var$skipCacheDataFor(fetchPolicy /* `undefined` would mean `"cache-first"` */ ) {
    return fetchPolicy === "network-only" || fetchPolicy === "no-cache" || fetchPolicy === "standby";
}

});
parcelRegister("4YvCN", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $39f54c06a321fa96$export$bd096ddbd246c79c);
$parcel$export(module.exports, "isNetworkRequestInFlight", () => $39f54c06a321fa96$export$37509604341a3464);
/**
 * The current status of a query’s execution in our system.
 */ var $39f54c06a321fa96$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */ NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */ NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */ NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */ NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */ NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */ NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */ NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($39f54c06a321fa96$export$bd096ddbd246c79c || ($39f54c06a321fa96$export$bd096ddbd246c79c = {}));
function $39f54c06a321fa96$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
function $39f54c06a321fa96$export$427e8a52ef0f96e2(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}

});

parcelRegister("ab1J9", function(module, exports) {

$parcel$export(module.exports, "equalByQuery", () => $768c457200a16dd4$export$5e40714c5ad44445);

var $fKE23 = parcelRequire("fKE23");

var $hr8gD = parcelRequire("hr8gD");

var $iB2lh = parcelRequire("iB2lh");
var $iX694 = parcelRequire("iX694");
var $6dwmd = parcelRequire("6dwmd");
var $jHSHK = parcelRequire("jHSHK");
function $768c457200a16dd4$export$5e40714c5ad44445(query, _a, _b, variables) {
    var aData = _a.data, aRest = (0, $fKE23.__rest)(_a, [
        "data"
    ]);
    var bData = _b.data, bRest = (0, $fKE23.__rest)(_b, [
        "data"
    ]);
    return (0, $hr8gD.default)(aRest, bRest) && $768c457200a16dd4$var$equalBySelectionSet((0, $iX694.getMainDefinition)(query).selectionSet, aData, bData, {
        fragmentMap: (0, $iB2lh.createFragmentMap)((0, $iX694.getFragmentDefinitions)(query)),
        variables: variables
    });
}
function $768c457200a16dd4$var$equalBySelectionSet(selectionSet, aResult, bResult, context) {
    if (aResult === bResult) return true;
    var seenSelections = new Set();
    // Returning true from this Array.prototype.every callback function skips the
    // current field/subtree. Returning false aborts the entire traversal
    // immediately, causing equalBySelectionSet to return false.
    return selectionSet.selections.every(function(selection) {
        // Avoid re-processing the same selection at the same level of recursion, in
        // case the same field gets included via multiple indirect fragment spreads.
        if (seenSelections.has(selection)) return true;
        seenSelections.add(selection);
        // Ignore @skip(if: true) and @include(if: false) fields.
        if (!(0, $jHSHK.shouldInclude)(selection, context.variables)) return true;
        // If the field or (named) fragment spread has a @nonreactive directive on
        // it, we don't care if it's different, so we pretend it's the same.
        if ($768c457200a16dd4$var$selectionHasNonreactiveDirective(selection)) return true;
        if ((0, $6dwmd.isField)(selection)) {
            var resultKey = (0, $6dwmd.resultKeyNameFromField)(selection);
            var aResultChild = aResult && aResult[resultKey];
            var bResultChild = bResult && bResult[resultKey];
            var childSelectionSet = selection.selectionSet;
            if (!childSelectionSet) // These are scalar values, so we can compare them with deep equal
            // without redoing the main recursive work.
            return (0, $hr8gD.default)(aResultChild, bResultChild);
            var aChildIsArray = Array.isArray(aResultChild);
            var bChildIsArray = Array.isArray(bResultChild);
            if (aChildIsArray !== bChildIsArray) return false;
            if (aChildIsArray && bChildIsArray) {
                var length_1 = aResultChild.length;
                if (bResultChild.length !== length_1) return false;
                for(var i = 0; i < length_1; ++i){
                    if (!$768c457200a16dd4$var$equalBySelectionSet(childSelectionSet, aResultChild[i], bResultChild[i], context)) return false;
                }
                return true;
            }
            return $768c457200a16dd4$var$equalBySelectionSet(childSelectionSet, aResultChild, bResultChild, context);
        } else {
            var fragment = (0, $iB2lh.getFragmentFromSelection)(selection, context.fragmentMap);
            if (fragment) {
                // The fragment might === selection if it's an inline fragment, but
                // could be !== if it's a named fragment ...spread.
                if ($768c457200a16dd4$var$selectionHasNonreactiveDirective(fragment)) return true;
                return $768c457200a16dd4$var$equalBySelectionSet(fragment.selectionSet, // Notice that we reuse the same aResult and bResult values here,
                // since the fragment ...spread does not specify a field name, but
                // consists of multiple fields (within the fragment's selection set)
                // that should be applied to the current result value(s).
                aResult, bResult, context);
            }
        }
    });
}
function $768c457200a16dd4$var$selectionHasNonreactiveDirective(selection) {
    return !!selection.directives && selection.directives.some($768c457200a16dd4$var$directiveIsNonreactive);
}
function $768c457200a16dd4$var$directiveIsNonreactive(dir) {
    return dir.name.value === "nonreactive";
}

});


parcelRegister("6bzG9", function(module, exports) {

$parcel$export(module.exports, "LocalState", () => $480f7240dcb6e87f$export$19901bcd339c3ded);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $961BR = parcelRequire("961BR");
var $9nArG = parcelRequire("9nArG");

var $6dwmd = parcelRequire("6dwmd");
var $1CBce = parcelRequire("1CBce");
var $iB2lh = parcelRequire("iB2lh");
var $iX694 = parcelRequire("iX694");
var $jHSHK = parcelRequire("jHSHK");
var $64d3o = parcelRequire("64d3o");

var $5alB9 = parcelRequire("5alB9");
var $480f7240dcb6e87f$export$19901bcd339c3ded = /** @class */ function() {
    function LocalState(_a) {
        var cache = _a.cache, client = _a.client, resolvers = _a.resolvers, fragmentMatcher = _a.fragmentMatcher;
        this.selectionsToResolveCache = new WeakMap();
        this.cache = cache;
        if (client) this.client = client;
        if (resolvers) this.addResolvers(resolvers);
        if (fragmentMatcher) this.setFragmentMatcher(fragmentMatcher);
    }
    LocalState.prototype.addResolvers = function(resolvers) {
        var _this = this;
        this.resolvers = this.resolvers || {};
        if (Array.isArray(resolvers)) resolvers.forEach(function(resolverGroup) {
            _this.resolvers = (0, $64d3o.mergeDeep)(_this.resolvers, resolverGroup);
        });
        else this.resolvers = (0, $64d3o.mergeDeep)(this.resolvers, resolvers);
    };
    LocalState.prototype.setResolvers = function(resolvers) {
        this.resolvers = {};
        this.addResolvers(resolvers);
    };
    LocalState.prototype.getResolvers = function() {
        return this.resolvers || {};
    };
    // Run local client resolvers against the incoming query and remote data.
    // Locally resolved field values are merged with the incoming remote data,
    // and returned. Note that locally resolved fields will overwrite
    // remote data using the same field name.
    LocalState.prototype.runResolvers = function(_a) {
        return (0, $fKE23.__awaiter)(this, arguments, void 0, function(_b) {
            var document = _b.document, remoteResult = _b.remoteResult, context = _b.context, variables = _b.variables, _c = _b.onlyRunForcedResolvers, onlyRunForcedResolvers = _c === void 0 ? false : _c;
            return (0, $fKE23.__generator)(this, function(_d) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, remoteResult.data, context, variables, this.fragmentMatcher, onlyRunForcedResolvers).then(function(localResult) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, remoteResult), {
                            data: localResult.result
                        });
                    })
                ];
                return [
                    2 /*return*/ ,
                    remoteResult
                ];
            });
        });
    };
    LocalState.prototype.setFragmentMatcher = function(fragmentMatcher) {
        this.fragmentMatcher = fragmentMatcher;
    };
    LocalState.prototype.getFragmentMatcher = function() {
        return this.fragmentMatcher;
    };
    // Client queries contain everything in the incoming document (if a @client
    // directive is found).
    LocalState.prototype.clientQuery = function(document) {
        if ((0, $jHSHK.hasDirectives)([
            "client"
        ], document)) {
            if (this.resolvers) return document;
        }
        return null;
    };
    // Server queries are stripped of all @client based selection sets.
    LocalState.prototype.serverQuery = function(document) {
        return (0, $1CBce.removeClientSetsFromDocument)(document);
    };
    LocalState.prototype.prepareContext = function(context) {
        var cache = this.cache;
        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
            cache: cache,
            // Getting an entry's cache key is useful for local state resolvers.
            getCacheKey: function(obj) {
                return cache.identify(obj);
            }
        });
    };
    // To support `@client @export(as: "someVar")` syntax, we'll first resolve
    // @client @export fields locally, then pass the resolved values back to be
    // used alongside the original operation variables.
    LocalState.prototype.addExportedVariables = function(document_1) {
        return (0, $fKE23.__awaiter)(this, arguments, void 0, function(document, variables, context) {
            if (variables === void 0) variables = {};
            if (context === void 0) context = {};
            return (0, $fKE23.__generator)(this, function(_a) {
                if (document) return [
                    2 /*return*/ ,
                    this.resolveDocument(document, this.buildRootValueFromCache(document, variables) || {}, this.prepareContext(context), variables).then(function(data) {
                        return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, variables), data.exportedVariables);
                    })
                ];
                return [
                    2 /*return*/ ,
                    (0, $fKE23.__assign)({}, variables)
                ];
            });
        });
    };
    LocalState.prototype.shouldForceResolvers = function(document) {
        var forceResolvers = false;
        (0, $961BR.visit)(document, {
            Directive: {
                enter: function(node) {
                    if (node.name.value === "client" && node.arguments) {
                        forceResolvers = node.arguments.some(function(arg) {
                            return arg.name.value === "always" && arg.value.kind === "BooleanValue" && arg.value.value === true;
                        });
                        if (forceResolvers) return 0, $961BR.BREAK;
                    }
                }
            }
        });
        return forceResolvers;
    };
    // Query the cache and return matching data.
    LocalState.prototype.buildRootValueFromCache = function(document, variables) {
        return this.cache.diff({
            query: (0, $1CBce.buildQueryFromSelectionSet)(document),
            variables: variables,
            returnPartialData: true,
            optimistic: false
        }).result;
    };
    LocalState.prototype.resolveDocument = function(document_1, rootValue_1) {
        return (0, $fKE23.__awaiter)(this, arguments, void 0, function(document, rootValue, context, variables, fragmentMatcher, onlyRunForcedResolvers) {
            var mainDefinition, fragments, fragmentMap, selectionsToResolve, definitionOperation, defaultOperationType, _a, cache, client, execContext, isClientFieldDescendant;
            if (context === void 0) context = {};
            if (variables === void 0) variables = {};
            if (fragmentMatcher === void 0) fragmentMatcher = function() {
                return true;
            };
            if (onlyRunForcedResolvers === void 0) onlyRunForcedResolvers = false;
            return (0, $fKE23.__generator)(this, function(_b) {
                mainDefinition = (0, $iX694.getMainDefinition)(document);
                fragments = (0, $iX694.getFragmentDefinitions)(document);
                fragmentMap = (0, $iB2lh.createFragmentMap)(fragments);
                selectionsToResolve = this.collectSelectionsToResolve(mainDefinition, fragmentMap);
                definitionOperation = mainDefinition.operation;
                defaultOperationType = definitionOperation ? definitionOperation.charAt(0).toUpperCase() + definitionOperation.slice(1) : "Query";
                _a = this, cache = _a.cache, client = _a.client;
                execContext = {
                    fragmentMap: fragmentMap,
                    context: (0, $fKE23.__assign)((0, $fKE23.__assign)({}, context), {
                        cache: cache,
                        client: client
                    }),
                    variables: variables,
                    fragmentMatcher: fragmentMatcher,
                    defaultOperationType: defaultOperationType,
                    exportedVariables: {},
                    selectionsToResolve: selectionsToResolve,
                    onlyRunForcedResolvers: onlyRunForcedResolvers
                };
                isClientFieldDescendant = false;
                return [
                    2 /*return*/ ,
                    this.resolveSelectionSet(mainDefinition.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(result) {
                        return {
                            result: result,
                            exportedVariables: execContext.exportedVariables
                        };
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSelectionSet = function(selectionSet, isClientFieldDescendant, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var fragmentMap, context, variables, resultsToMerge, execute;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                fragmentMap = execContext.fragmentMap, context = execContext.context, variables = execContext.variables;
                resultsToMerge = [
                    rootValue
                ];
                execute = function(selection) {
                    return (0, $fKE23.__awaiter)(_this, void 0, void 0, function() {
                        var fragment, typeCondition;
                        return (0, $fKE23.__generator)(this, function(_a) {
                            if (!isClientFieldDescendant && !execContext.selectionsToResolve.has(selection)) // Skip selections without @client directives
                            // (still processing if one of the ancestors or one of the child fields has @client directive)
                            return [
                                2 /*return*/ 
                            ];
                            if (!(0, $jHSHK.shouldInclude)(selection, variables)) // Skip this entirely.
                            return [
                                2 /*return*/ 
                            ];
                            if ((0, $6dwmd.isField)(selection)) return [
                                2 /*return*/ ,
                                this.resolveField(selection, isClientFieldDescendant, rootValue, execContext).then(function(fieldResult) {
                                    var _a;
                                    if (typeof fieldResult !== "undefined") resultsToMerge.push((_a = {}, _a[(0, $6dwmd.resultKeyNameFromField)(selection)] = fieldResult, _a));
                                })
                            ];
                            if ((0, $6dwmd.isInlineFragment)(selection)) fragment = selection;
                            else {
                                // This is a named fragment.
                                fragment = fragmentMap[selection.name.value];
                                (0, $kL4FQ.invariant)(fragment, 18, selection.name.value);
                            }
                            if (fragment && fragment.typeCondition) {
                                typeCondition = fragment.typeCondition.name.value;
                                if (execContext.fragmentMatcher(rootValue, typeCondition, context)) return [
                                    2 /*return*/ ,
                                    this.resolveSelectionSet(fragment.selectionSet, isClientFieldDescendant, rootValue, execContext).then(function(fragmentResult) {
                                        resultsToMerge.push(fragmentResult);
                                    })
                                ];
                            }
                            return [
                                2 /*return*/ 
                            ];
                        });
                    });
                };
                return [
                    2 /*return*/ ,
                    Promise.all(selectionSet.selections.map(execute)).then(function() {
                        return (0, $64d3o.mergeDeepArray)(resultsToMerge);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveField = function(field, isClientFieldDescendant, rootValue, execContext) {
        return (0, $fKE23.__awaiter)(this, void 0, void 0, function() {
            var variables, fieldName, aliasedFieldName, aliasUsed, defaultResult, resultPromise, resolverType, resolverMap, resolve;
            var _this = this;
            return (0, $fKE23.__generator)(this, function(_a) {
                if (!rootValue) return [
                    2 /*return*/ ,
                    null
                ];
                variables = execContext.variables;
                fieldName = field.name.value;
                aliasedFieldName = (0, $6dwmd.resultKeyNameFromField)(field);
                aliasUsed = fieldName !== aliasedFieldName;
                defaultResult = rootValue[aliasedFieldName] || rootValue[fieldName];
                resultPromise = Promise.resolve(defaultResult);
                // Usually all local resolvers are run when passing through here, but
                // if we've specifically identified that we only want to run forced
                // resolvers (that is, resolvers for fields marked with
                // `@client(always: true)`), then we'll skip running non-forced resolvers.
                if (!execContext.onlyRunForcedResolvers || this.shouldForceResolvers(field)) {
                    resolverType = rootValue.__typename || execContext.defaultOperationType;
                    resolverMap = this.resolvers && this.resolvers[resolverType];
                    if (resolverMap) {
                        resolve = resolverMap[aliasUsed ? fieldName : aliasedFieldName];
                        if (resolve) resultPromise = Promise.resolve(// In case the resolve function accesses reactive variables,
                        // set cacheSlot to the current cache instance.
                        (0, $5alB9.cacheSlot).withValue(this.cache, resolve, [
                            rootValue,
                            (0, $6dwmd.argumentsObjectFromField)(field, variables),
                            execContext.context,
                            {
                                field: field,
                                fragmentMap: execContext.fragmentMap
                            }
                        ]));
                    }
                }
                return [
                    2 /*return*/ ,
                    resultPromise.then(function(result) {
                        var _a, _b;
                        if (result === void 0) result = defaultResult;
                        // If an @export directive is associated with the current field, store
                        // the `as` export variable name and current result for later use.
                        if (field.directives) field.directives.forEach(function(directive) {
                            if (directive.name.value === "export" && directive.arguments) directive.arguments.forEach(function(arg) {
                                if (arg.name.value === "as" && arg.value.kind === "StringValue") execContext.exportedVariables[arg.value.value] = result;
                            });
                        });
                        // Handle all scalar types here.
                        if (!field.selectionSet) return result;
                        // From here down, the field has a selection set, which means it's trying
                        // to query a GraphQLObjectType.
                        if (result == null) // Basically any field in a GraphQL response can be null, or missing
                        return result;
                        var isClientField = (_b = (_a = field.directives) === null || _a === void 0 ? void 0 : _a.some(function(d) {
                            return d.name.value === "client";
                        })) !== null && _b !== void 0 ? _b : false;
                        if (Array.isArray(result)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant || isClientField, result, execContext);
                        // Returned value is an object, and the query has a sub-selection. Recurse.
                        if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant || isClientField, result, execContext);
                    })
                ];
            });
        });
    };
    LocalState.prototype.resolveSubSelectedArray = function(field, isClientFieldDescendant, result, execContext) {
        var _this = this;
        return Promise.all(result.map(function(item) {
            if (item === null) return null;
            // This is a nested array, recurse.
            if (Array.isArray(item)) return _this.resolveSubSelectedArray(field, isClientFieldDescendant, item, execContext);
            // This is an object, run the selection set on it.
            if (field.selectionSet) return _this.resolveSelectionSet(field.selectionSet, isClientFieldDescendant, item, execContext);
        }));
    };
    // Collect selection nodes on paths from document root down to all @client directives.
    // This function takes into account transitive fragment spreads.
    // Complexity equals to a single `visit` over the full document.
    LocalState.prototype.collectSelectionsToResolve = function(mainDefinition, fragmentMap) {
        var isSingleASTNode = function(node) {
            return !Array.isArray(node);
        };
        var selectionsToResolveCache = this.selectionsToResolveCache;
        function collectByDefinition(definitionNode) {
            if (!selectionsToResolveCache.has(definitionNode)) {
                var matches_1 = new Set();
                selectionsToResolveCache.set(definitionNode, matches_1);
                (0, $961BR.visit)(definitionNode, {
                    Directive: function(node, _, __, ___, ancestors) {
                        if (node.name.value === "client") ancestors.forEach(function(node) {
                            if (isSingleASTNode(node) && (0, $9nArG.isSelectionNode)(node)) matches_1.add(node);
                        });
                    },
                    FragmentSpread: function(spread, _, __, ___, ancestors) {
                        var fragment = fragmentMap[spread.name.value];
                        (0, $kL4FQ.invariant)(fragment, 19, spread.name.value);
                        var fragmentSelections = collectByDefinition(fragment);
                        if (fragmentSelections.size > 0) {
                            // Fragment for this spread contains @client directive (either directly or transitively)
                            // Collect selection nodes on paths from the root down to fields with the @client directive
                            ancestors.forEach(function(node) {
                                if (isSingleASTNode(node) && (0, $9nArG.isSelectionNode)(node)) matches_1.add(node);
                            });
                            matches_1.add(spread);
                            fragmentSelections.forEach(function(selection) {
                                matches_1.add(selection);
                            });
                        }
                    }
                });
            }
            return selectionsToResolveCache.get(definitionNode);
        }
        return collectByDefinition(mainDefinition);
    };
    return LocalState;
}();

});
parcelRegister("9nArG", function(module, exports) {

$parcel$export(module.exports, "isExecutableDefinitionNode", () => $6727414c23a41723$export$4cedd8740794bd78);
$parcel$export(module.exports, "isTypeSystemDefinitionNode", () => $6727414c23a41723$export$b05c7141ec7770ba);
$parcel$export(module.exports, "isTypeSystemExtensionNode", () => $6727414c23a41723$export$fbc18e88163d676d);
$parcel$export(module.exports, "isSelectionNode", () => $6727414c23a41723$export$65772b71e1d017ba);
$parcel$export(module.exports, "isTypeDefinitionNode", () => $6727414c23a41723$export$a3584bba04f5bfe0);
$parcel$export(module.exports, "isTypeExtensionNode", () => $6727414c23a41723$export$d7907721b241e11f);

var $1c4hI = parcelRequire("1c4hI");
function $6727414c23a41723$export$e7ecd7c16613ccfd(node) {
    return $6727414c23a41723$export$4cedd8740794bd78(node) || $6727414c23a41723$export$b05c7141ec7770ba(node) || $6727414c23a41723$export$fbc18e88163d676d(node);
}
function $6727414c23a41723$export$4cedd8740794bd78(node) {
    return node.kind === (0, $1c4hI.Kind).OPERATION_DEFINITION || node.kind === (0, $1c4hI.Kind).FRAGMENT_DEFINITION;
}
function $6727414c23a41723$export$65772b71e1d017ba(node) {
    return node.kind === (0, $1c4hI.Kind).FIELD || node.kind === (0, $1c4hI.Kind).FRAGMENT_SPREAD || node.kind === (0, $1c4hI.Kind).INLINE_FRAGMENT;
}
function $6727414c23a41723$export$ab65b54ec7cbe9e4(node) {
    return node.kind === (0, $1c4hI.Kind).VARIABLE || node.kind === (0, $1c4hI.Kind).INT || node.kind === (0, $1c4hI.Kind).FLOAT || node.kind === (0, $1c4hI.Kind).STRING || node.kind === (0, $1c4hI.Kind).BOOLEAN || node.kind === (0, $1c4hI.Kind).NULL || node.kind === (0, $1c4hI.Kind).ENUM || node.kind === (0, $1c4hI.Kind).LIST || node.kind === (0, $1c4hI.Kind).OBJECT;
}
function $6727414c23a41723$export$26e8a4730f4310f4(node) {
    return node.kind === (0, $1c4hI.Kind).NAMED_TYPE || node.kind === (0, $1c4hI.Kind).LIST_TYPE || node.kind === (0, $1c4hI.Kind).NON_NULL_TYPE;
}
function $6727414c23a41723$export$b05c7141ec7770ba(node) {
    return node.kind === (0, $1c4hI.Kind).SCHEMA_DEFINITION || $6727414c23a41723$export$a3584bba04f5bfe0(node) || node.kind === (0, $1c4hI.Kind).DIRECTIVE_DEFINITION;
}
function $6727414c23a41723$export$a3584bba04f5bfe0(node) {
    return node.kind === (0, $1c4hI.Kind).SCALAR_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).OBJECT_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).INTERFACE_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).UNION_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).ENUM_TYPE_DEFINITION || node.kind === (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_DEFINITION;
}
function $6727414c23a41723$export$fbc18e88163d676d(node) {
    return node.kind === (0, $1c4hI.Kind).SCHEMA_EXTENSION || $6727414c23a41723$export$d7907721b241e11f(node);
}
function $6727414c23a41723$export$d7907721b241e11f(node) {
    return node.kind === (0, $1c4hI.Kind).SCALAR_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).OBJECT_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).INTERFACE_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).UNION_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).ENUM_TYPE_EXTENSION || node.kind === (0, $1c4hI.Kind).INPUT_OBJECT_TYPE_EXTENSION;
}

});


parcelRegister("bEGCk", function(module, exports) {

$parcel$export(module.exports, "QueryInfo", () => $87c47d09d143d15b$export$79a6120a39c90b6a);
$parcel$export(module.exports, "shouldWriteResult", () => $87c47d09d143d15b$export$5f47a9fb9a521654);

var $fKE23 = parcelRequire("fKE23");

var $hr8gD = parcelRequire("hr8gD");

var $7X1wJ = parcelRequire("7X1wJ");
var $64d3o = parcelRequire("64d3o");
var $bLhqY = parcelRequire("bLhqY");
var $kxw1Y = parcelRequire("kxw1Y");
var $dajVc = parcelRequire("dajVc");

var $4PfqZ = parcelRequire("4PfqZ");

var $4YvCN = parcelRequire("4YvCN");
var $87c47d09d143d15b$var$destructiveMethodCounts = new ((0, $7X1wJ.canUseWeakMap) ? WeakMap : Map)();
function $87c47d09d143d15b$var$wrapDestructiveCacheMethod(cache, methodName) {
    var original = cache[methodName];
    if (typeof original === "function") // @ts-expect-error this is just too generic to be typed correctly
    cache[methodName] = function() {
        $87c47d09d143d15b$var$destructiveMethodCounts.set(cache, // The %1e15 allows the count to wrap around to 0 safely every
        // quadrillion evictions, so there's no risk of overflow. To be
        // clear, this is more of a pedantic principle than something
        // that matters in any conceivable practical scenario.
        ($87c47d09d143d15b$var$destructiveMethodCounts.get(cache) + 1) % 1e15);
        // @ts-expect-error this is just too generic to be typed correctly
        return original.apply(this, arguments);
    };
}
function $87c47d09d143d15b$var$cancelNotifyTimeout(info) {
    if (info["notifyTimeout"]) {
        clearTimeout(info["notifyTimeout"]);
        info["notifyTimeout"] = void 0;
    }
}
// A QueryInfo object represents a single query managed by the
// QueryManager, which tracks all QueryInfo objects by queryId in its
// this.queries Map. QueryInfo objects store the latest results and errors
// for the given query, and are responsible for reporting those results to
// the corresponding ObservableQuery, via the QueryInfo.notify method.
// Results are reported asynchronously whenever setDiff marks the
// QueryInfo object as dirty, though a call to the QueryManager's
// broadcastQueries method may trigger the notification before it happens
// automatically. This class used to be a simple interface type without
// any field privacy or meaningful methods, which is why it still has so
// many public fields. The effort to lock down and simplify the QueryInfo
// interface is ongoing, and further improvements are welcome.
var $87c47d09d143d15b$export$79a6120a39c90b6a = /** @class */ function() {
    function QueryInfo(queryManager, queryId) {
        if (queryId === void 0) queryId = queryManager.generateQueryId();
        this.queryId = queryId;
        this.listeners = new Set();
        this.document = null;
        this.lastRequestId = 1;
        this.stopped = false;
        this.dirty = false;
        this.observableQuery = null;
        var cache = this.cache = queryManager.cache;
        // Track how often cache.evict is called, since we want eviction to
        // override the feud-stopping logic in the markResult method, by
        // causing shouldWrite to return true. Wrapping the cache.evict method
        // is a bit of a hack, but it saves us from having to make eviction
        // counting an official part of the ApolloCache API.
        if (!$87c47d09d143d15b$var$destructiveMethodCounts.has(cache)) {
            $87c47d09d143d15b$var$destructiveMethodCounts.set(cache, 0);
            $87c47d09d143d15b$var$wrapDestructiveCacheMethod(cache, "evict");
            $87c47d09d143d15b$var$wrapDestructiveCacheMethod(cache, "modify");
            $87c47d09d143d15b$var$wrapDestructiveCacheMethod(cache, "reset");
        }
    }
    QueryInfo.prototype.init = function(query) {
        var networkStatus = query.networkStatus || (0, $4YvCN.NetworkStatus).loading;
        if (this.variables && this.networkStatus !== (0, $4YvCN.NetworkStatus).loading && !(0, $hr8gD.equal)(this.variables, query.variables)) networkStatus = (0, $4YvCN.NetworkStatus).setVariables;
        if (!(0, $hr8gD.equal)(query.variables, this.variables)) this.lastDiff = void 0;
        Object.assign(this, {
            document: query.document,
            variables: query.variables,
            networkError: null,
            graphQLErrors: this.graphQLErrors || [],
            networkStatus: networkStatus
        });
        if (query.observableQuery) this.setObservableQuery(query.observableQuery);
        if (query.lastRequestId) this.lastRequestId = query.lastRequestId;
        return this;
    };
    QueryInfo.prototype.reset = function() {
        $87c47d09d143d15b$var$cancelNotifyTimeout(this);
        this.dirty = false;
    };
    QueryInfo.prototype.resetDiff = function() {
        this.lastDiff = void 0;
    };
    QueryInfo.prototype.getDiff = function() {
        var options = this.getDiffOptions();
        if (this.lastDiff && (0, $hr8gD.equal)(options, this.lastDiff.options)) return this.lastDiff.diff;
        this.updateWatch(this.variables);
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return {
            complete: false
        };
        var diff = this.cache.diff(options);
        this.updateLastDiff(diff, options);
        return diff;
    };
    QueryInfo.prototype.updateLastDiff = function(diff, options) {
        this.lastDiff = diff ? {
            diff: diff,
            options: options || this.getDiffOptions()
        } : void 0;
    };
    QueryInfo.prototype.getDiffOptions = function(variables) {
        var _a;
        if (variables === void 0) variables = this.variables;
        return {
            query: this.document,
            variables: variables,
            returnPartialData: true,
            optimistic: true,
            canonizeResults: (_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.canonizeResults
        };
    };
    QueryInfo.prototype.setDiff = function(diff) {
        var _this = this;
        var _a;
        var oldDiff = this.lastDiff && this.lastDiff.diff;
        // If we do not tolerate partial results, skip this update to prevent it
        // from being reported. This prevents a situtuation where a query that
        // errors and another succeeds with overlapping data does not report the
        // partial data result to the errored query.
        //
        // See https://github.com/apollographql/apollo-client/issues/11400 for more
        // information on this issue.
        if (diff && !diff.complete && !((_a = this.observableQuery) === null || _a === void 0 ? void 0 : _a.options.returnPartialData) && // In the case of a cache eviction, the diff will become partial so we
        // schedule a notification to send a network request (this.oqListener) to
        // go and fetch the missing data.
        !(oldDiff && oldDiff.complete)) return;
        this.updateLastDiff(diff);
        if (!this.dirty && !(0, $hr8gD.equal)(oldDiff && oldDiff.result, diff && diff.result)) {
            this.dirty = true;
            if (!this.notifyTimeout) this.notifyTimeout = setTimeout(function() {
                return _this.notify();
            }, 0);
        }
    };
    QueryInfo.prototype.setObservableQuery = function(oq) {
        var _this = this;
        if (oq === this.observableQuery) return;
        if (this.oqListener) this.listeners.delete(this.oqListener);
        this.observableQuery = oq;
        if (oq) {
            oq["queryInfo"] = this;
            this.listeners.add(this.oqListener = function() {
                var diff = _this.getDiff();
                if (diff.fromOptimisticTransaction) // If this diff came from an optimistic transaction, deliver the
                // current cache data to the ObservableQuery, but don't perform a
                // reobservation, since oq.reobserveCacheFirst might make a network
                // request, and we never want to trigger network requests in the
                // middle of optimistic updates.
                oq["observe"]();
                else // Otherwise, make the ObservableQuery "reobserve" the latest data
                // using a temporary fetch policy of "cache-first", so complete cache
                // results have a chance to be delivered without triggering additional
                // network requests, even when options.fetchPolicy is "network-only"
                // or "cache-and-network". All other fetch policies are preserved by
                // this method, and are handled by calling oq.reobserve(). If this
                // reobservation is spurious, isDifferentFromLastResult still has a
                // chance to catch it before delivery to ObservableQuery subscribers.
                (0, $4PfqZ.reobserveCacheFirst)(oq);
            });
        } else delete this.oqListener;
    };
    QueryInfo.prototype.notify = function() {
        var _this = this;
        $87c47d09d143d15b$var$cancelNotifyTimeout(this);
        if (this.shouldNotify()) this.listeners.forEach(function(listener) {
            return listener(_this);
        });
        this.dirty = false;
    };
    QueryInfo.prototype.shouldNotify = function() {
        if (!this.dirty || !this.listeners.size) return false;
        if ((0, $4YvCN.isNetworkRequestInFlight)(this.networkStatus) && this.observableQuery) {
            var fetchPolicy = this.observableQuery.options.fetchPolicy;
            if (fetchPolicy !== "cache-only" && fetchPolicy !== "cache-and-network") return false;
        }
        return true;
    };
    QueryInfo.prototype.stop = function() {
        if (!this.stopped) {
            this.stopped = true;
            // Cancel the pending notify timeout
            this.reset();
            this.cancel();
            // Revert back to the no-op version of cancel inherited from
            // QueryInfo.prototype.
            this.cancel = QueryInfo.prototype.cancel;
            var oq = this.observableQuery;
            if (oq) oq.stopPolling();
        }
    };
    // This method is a no-op by default, until/unless overridden by the
    // updateWatch method.
    QueryInfo.prototype.cancel = function() {};
    QueryInfo.prototype.updateWatch = function(variables) {
        var _this = this;
        if (variables === void 0) variables = this.variables;
        var oq = this.observableQuery;
        if (oq && oq.options.fetchPolicy === "no-cache") return;
        var watchOptions = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.getDiffOptions(variables)), {
            watcher: this,
            callback: function(diff) {
                return _this.setDiff(diff);
            }
        });
        if (!this.lastWatch || !(0, $hr8gD.equal)(watchOptions, this.lastWatch)) {
            this.cancel();
            this.cancel = this.cache.watch(this.lastWatch = watchOptions);
        }
    };
    QueryInfo.prototype.resetLastWrite = function() {
        this.lastWrite = void 0;
    };
    QueryInfo.prototype.shouldWrite = function(result, variables) {
        var lastWrite = this.lastWrite;
        return !(lastWrite && // If cache.evict has been called since the last time we wrote this
        // data into the cache, there's a chance writing this result into
        // the cache will repair what was evicted.
        lastWrite.dmCount === $87c47d09d143d15b$var$destructiveMethodCounts.get(this.cache) && (0, $hr8gD.equal)(variables, lastWrite.variables) && (0, $hr8gD.equal)(result.data, lastWrite.result.data));
    };
    QueryInfo.prototype.markResult = function(result, document, options, cacheWriteBehavior) {
        var _this = this;
        var merger = new (0, $64d3o.DeepMerger)();
        var graphQLErrors = (0, $kxw1Y.isNonEmptyArray)(result.errors) ? result.errors.slice(0) : [];
        // Cancel the pending notify timeout (if it exists) to prevent extraneous network
        // requests. To allow future notify timeouts, diff and dirty are reset as well.
        this.reset();
        if ("incremental" in result && (0, $kxw1Y.isNonEmptyArray)(result.incremental)) {
            var mergedData = (0, $dajVc.mergeIncrementalData)(this.getDiff().result, result);
            result.data = mergedData;
        // Detect the first chunk of a deferred query and merge it with existing
        // cache data. This ensures a `cache-first` fetch policy that returns
        // partial cache data or a `cache-and-network` fetch policy that already
        // has full data in the cache does not complain when trying to merge the
        // initial deferred server data with existing cache data.
        } else if ("hasNext" in result && result.hasNext) {
            var diff = this.getDiff();
            result.data = merger.merge(diff.result, result.data);
        }
        this.graphQLErrors = graphQLErrors;
        if (options.fetchPolicy === "no-cache") this.updateLastDiff({
            result: result.data,
            complete: true
        }, this.getDiffOptions(options.variables));
        else if (cacheWriteBehavior !== 0 /* CacheWriteBehavior.FORBID */ ) {
            if ($87c47d09d143d15b$export$5f47a9fb9a521654(result, options.errorPolicy)) // Using a transaction here so we have a chance to read the result
            // back from the cache before the watch callback fires as a result
            // of writeQuery, so we can store the new diff quietly and ignore
            // it when we receive it redundantly from the watch callback.
            this.cache.performTransaction(function(cache) {
                if (_this.shouldWrite(result, options.variables)) {
                    cache.writeQuery({
                        query: document,
                        data: result.data,
                        variables: options.variables,
                        overwrite: cacheWriteBehavior === 1 /* CacheWriteBehavior.OVERWRITE */ 
                    });
                    _this.lastWrite = {
                        result: result,
                        variables: options.variables,
                        dmCount: $87c47d09d143d15b$var$destructiveMethodCounts.get(_this.cache)
                    };
                } else // If result is the same as the last result we received from
                // the network (and the variables match too), avoid writing
                // result into the cache again. The wisdom of skipping this
                // cache write is far from obvious, since any cache write
                // could be the one that puts the cache back into a desired
                // state, fixing corruption or missing data. However, if we
                // always write every network result into the cache, we enable
                // feuds between queries competing to update the same data in
                // incompatible ways, which can lead to an endless cycle of
                // cache broadcasts and useless network requests. As with any
                // feud, eventually one side must step back from the brink,
                // letting the other side(s) have the last word(s). There may
                // be other points where we could break this cycle, such as
                // silencing the broadcast for cache.writeQuery (not a good
                // idea, since it just delays the feud a bit) or somehow
                // avoiding the network request that just happened (also bad,
                // because the server could return useful new data). All
                // options considered, skipping this cache write seems to be
                // the least damaging place to break the cycle, because it
                // reflects the intuition that we recently wrote this exact
                // result into the cache, so the cache *should* already/still
                // contain this data. If some other query has clobbered that
                // data in the meantime, that's too bad, but there will be no
                // winners if every query blindly reverts to its own version
                // of the data. This approach also gives the network a chance
                // to return new data, which will be written into the cache as
                // usual, notifying only those queries that are directly
                // affected by the cache updates, as usual. In the future, an
                // even more sophisticated cache could perhaps prevent or
                // mitigate the clobbering somehow, but that would make this
                // particular cache write even less important, and thus
                // skipping it would be even safer than it is today.
                if (_this.lastDiff && _this.lastDiff.diff.complete) {
                    // Reuse data from the last good (complete) diff that we
                    // received, when possible.
                    result.data = _this.lastDiff.diff.result;
                    return;
                }
                var diffOptions = _this.getDiffOptions(options.variables);
                var diff = cache.diff(diffOptions);
                // In case the QueryManager stops this QueryInfo before its
                // results are delivered, it's important to avoid restarting the
                // cache watch when markResult is called. We also avoid updating
                // the watch if we are writing a result that doesn't match the current
                // variables to avoid race conditions from broadcasting the wrong
                // result.
                if (!_this.stopped && (0, $hr8gD.equal)(_this.variables, options.variables)) // Any time we're about to update this.diff, we need to make
                // sure we've started watching the cache.
                _this.updateWatch(options.variables);
                // If we're allowed to write to the cache, and we can read a
                // complete result from the cache, update result.data to be the
                // result from the cache, rather than the raw network result.
                // Set without setDiff to avoid triggering a notify call, since
                // we have other ways of notifying for this result.
                _this.updateLastDiff(diff, diffOptions);
                if (diff.complete) result.data = diff.result;
            });
            else this.lastWrite = void 0;
        }
    };
    QueryInfo.prototype.markReady = function() {
        this.networkError = null;
        return this.networkStatus = (0, $4YvCN.NetworkStatus).ready;
    };
    QueryInfo.prototype.markError = function(error) {
        this.networkStatus = (0, $4YvCN.NetworkStatus).error;
        this.lastWrite = void 0;
        this.reset();
        if (error.graphQLErrors) this.graphQLErrors = error.graphQLErrors;
        if (error.networkError) this.networkError = error.networkError;
        return error;
    };
    return QueryInfo;
}();
function $87c47d09d143d15b$export$5f47a9fb9a521654(result, errorPolicy) {
    if (errorPolicy === void 0) errorPolicy = "none";
    var ignoreErrors = errorPolicy === "ignore" || errorPolicy === "all";
    var writeWithErrors = !(0, $bLhqY.graphQLResultHasError)(result);
    if (!writeWithErrors && ignoreErrors && result.data) writeWithErrors = true;
    return writeWithErrors;
}

});


parcelRegister("hcvqr", function(module, exports) {

$parcel$export(module.exports, "mergeOptions", () => $c85bef1c2b79194f$export$235b7fc70b9fc359);

var $fKE23 = parcelRequire("fKE23");

var $jZIxU = parcelRequire("jZIxU");
function $c85bef1c2b79194f$export$235b7fc70b9fc359(defaults, options) {
    return (0, $jZIxU.compact)(defaults, options, options.variables && {
        variables: (0, $jZIxU.compact)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, defaults && defaults.variables), options.variables))
    });
}

});


parcelRegister("8t43A", function(module, exports) {

$parcel$export(module.exports, "createApolloLinks", () => $62a42dbefa8c1bf3$export$ef02294c49970827);

var $5zQU9 = parcelRequire("5zQU9");

var $3l0mk = parcelRequire("3l0mk");
var $dDYbn = parcelRequire("dDYbn");

var $hg3Jm = parcelRequire("hg3Jm");

var $1jqOV = parcelRequire("1jqOV");

var $bTrQR = parcelRequire("bTrQR");
var $7lvGB = parcelRequire("7lvGB");

var $hHHBz = parcelRequire("hHHBz");
function $62a42dbefa8c1bf3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $62a42dbefa8c1bf3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $62a42dbefa8c1bf3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $62a42dbefa8c1bf3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $62a42dbefa8c1bf3$var$ERROR_LINK_LOG_PREFIX = '[Apollo GraphQL]';
/**
 * Create an error link to capture & report errors from a single place.
 * @see https://www.apollographql.com/docs/react/api/link/apollo-link-error/
 **/ const $62a42dbefa8c1bf3$var$createErrorLink = ()=>{
    // get details from the base fetch response error
    const getNetworkErrorDetails = (networkError)=>{
        if ('response' in networkError) {
            var _ref, _serverError$statusCo, _serverError$response;
            const serverError = networkError;
            return {
                message: networkError.message,
                statusCode: (_ref = (_serverError$statusCo = serverError.statusCode) !== null && _serverError$statusCo !== void 0 ? _serverError$statusCo : (_serverError$response = serverError.response) === null || _serverError$response === void 0 ? void 0 : _serverError$response.status) !== null && _ref !== void 0 ? _ref : 'unknown',
                // only populated in same-origin requests, or if 'Access-Control-Expose-Headers' is specified
                requestId: serverError === null || serverError === void 0 ? void 0 : serverError.response.headers.get('x-request-id'),
                traceId: serverError === null || serverError === void 0 ? void 0 : serverError.response.headers.get('x-trace-id')
            };
        }
        networkError;
        return {
            message: networkError.message
        };
    };
    // GraphQL errors are populated directly from the GraphQL response's "errors" field. This may contain
    // a list of errors from various sources - gateway, service etc.
    const getGraphQLErrorDetails = (graphQLErrors)=>{
        return (0, $7lvGB.objectToPathValuePair)({
            graphQLErrors: graphQLErrors.map((_ref2)=>{
                let { message: message, extensions: extensions } = _ref2;
                return {
                    message: message,
                    extensions: // Extensions are populated by the service
                    // See https://developer.atlassian.com/platform/graphql-gateway/standards/error-categorisation/#graphql-error-categorization
                    extensions
                };
            })
        });
    };
    // response is only populated when the body is a parseable GraphQL response
    const getErrorLinkResponseDetails = (response)=>{
        var _extensions$gateway$r, _extensions, _extensions$gateway;
        return {
            // https://developer.atlassian.com/platform/graphql-gateway/devloop/debugging-page/#using-request-ids
            gatewayRequestId: (_extensions$gateway$r = response === null || response === void 0 ? void 0 : (_extensions = response.extensions) === null || _extensions === void 0 ? void 0 : (_extensions$gateway = _extensions.gateway) === null || _extensions$gateway === void 0 ? void 0 : _extensions$gateway.request_id) !== null && _extensions$gateway$r !== void 0 ? _extensions$gateway$r : 'unknown'
        };
    };
    return (0, $hg3Jm.onError)((_ref3)=>{
        let { graphQLErrors: graphQLErrors, networkError: networkError, operation: operation, response: response } = _ref3;
        if (graphQLErrors) (0, $bTrQR.default).error($62a42dbefa8c1bf3$var$ERROR_LINK_LOG_PREFIX, "Operation \"".concat(operation.operationName, "\" failed"), $62a42dbefa8c1bf3$var$_objectSpread($62a42dbefa8c1bf3$var$_objectSpread($62a42dbefa8c1bf3$var$_objectSpread({}, getErrorLinkResponseDetails(response)), getGraphQLErrorDetails(graphQLErrors)), {}, {
            variables: operation.variables
        }));
        if (networkError) (0, $bTrQR.default).error($62a42dbefa8c1bf3$var$ERROR_LINK_LOG_PREFIX, "Network error in operation \"".concat(operation.operationName, "\""), $62a42dbefa8c1bf3$var$_objectSpread($62a42dbefa8c1bf3$var$_objectSpread($62a42dbefa8c1bf3$var$_objectSpread({}, getErrorLinkResponseDetails(response)), getNetworkErrorDetails(networkError)), {}, {
            variables: operation.variables
        }));
    });
};
/**
 * Creates a context link:
 */ const $62a42dbefa8c1bf3$var$createContextLink = (_ref4)=>{
    let { getClient: getClient } = _ref4;
    return new (0, $3l0mk.ApolloLink)((operation, forward)=>{
        operation.setContext({
            getClient: getClient
        });
        return forward(operation);
    });
};
const $62a42dbefa8c1bf3$export$ef02294c49970827 = (_ref5)=>{
    let { uri: uri, name: name, version: version, gqlOrchestratorLinkOptions: gqlOrchestratorLinkOptions, getClient: getClient } = _ref5;
    return (0, $dDYbn.from)([
        $62a42dbefa8c1bf3$var$createContextLink({
            getClient: getClient
        }),
        $62a42dbefa8c1bf3$var$createErrorLink(),
        (0, $hHHBz.createGQLOrchestrationLink)(gqlOrchestratorLinkOptions),
        // httpLink must be the last link, since it is a terminating link
        new (0, $1jqOV.HttpLink)({
            uri: uri,
            credentials: 'include',
            headers: {
                'atl-client-name': name,
                'atl-client-version': version
            }
        })
    ]);
};

});
parcelRegister("dDYbn", function(module, exports) {

$parcel$export(module.exports, "from", () => $9eed99dc5b8d8768$export$6788812c4e6611e6);

var $3l0mk = parcelRequire("3l0mk");
var $9eed99dc5b8d8768$export$6788812c4e6611e6 = (0, $3l0mk.ApolloLink).from;

});

parcelRegister("hg3Jm", function(module, exports) {

$parcel$export(module.exports, "onError", () => $c906d323823e131f$export$2288787135a8f66e);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("eayTI");
var $8E6bd = parcelRequire("8E6bd");

var $3l0mk = parcelRequire("3l0mk");
function $c906d323823e131f$export$2288787135a8f66e(errorHandler) {
    return new (0, $3l0mk.ApolloLink)(function(operation, forward) {
        return new (0, $8E6bd.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            //Network errors can return GraphQL errors on for example a 403
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        // disable the previous sub from calling complete on observable
                        // if retry is in flight.
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $c906d323823e131f$export$d2c8415987899609 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $c906d323823e131f$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $3l0mk.ApolloLink));

});

parcelRegister("hHHBz", function(module, exports) {

$parcel$export(module.exports, "createGQLOrchestrationLink", () => $ce3846da87ae250b$export$e3ab2d1de677caf6);

var $3l0mk = parcelRequire("3l0mk");

var $3vWjg = parcelRequire("3vWjg");
/**
 * Return a GQLOrchestrator Link or a NOOP Link based on if the isEnabled is true/false.
 * In case for any GQL call if configuration is NOT provided then `default` configuration
 * would be used.
 *
 * EG: Sample configuration:
 * {
 *  isEnabled: true,
 *  config: { // DLA orchestration configuration
 *    GetMarketplaceAppListingById: { // GQL call for which handling needs to be done.
 *      config: {
 *        sequence: SequenceTypes.PRIMARY_ONLY, // type of sequence to use out of the given 5 sequece types.
 *        handler: new BaseHandler(), // handler to handle the given GQL call
 *      }
 *    }
 *  }
 * }
 *
 *
 * `Default` DLA orchestration Configuration:
 * {
 *   default: {
 *       operationName: 'default'
 *       config: {
 *         sequence: SequenceTypes.PRIMARY_ONLY,
 *         handler: new BaseHandler(),
 *       }
 *     }
 * }
 *
 *
 *
 * @param options isEnabled + DLA orchestration configuration
 * @returns ApolloLink
 */ function $ce3846da87ae250b$export$e3ab2d1de677caf6(options) {
    if (options && options.isEnabled) {
        const gqlOrchestratorInstance = new (0, $3vWjg.GQLOrchestrator)(options.config, options.middlewares || []);
        return new (0, $3l0mk.ApolloLink)((operation, forward)=>{
            return gqlOrchestratorInstance.orchestrate(operation, forward);
        });
    }
    return new (0, $3l0mk.ApolloLink)((operation, forward)=>forward(operation));
}

});
parcelRegister("3vWjg", function(module, exports) {

$parcel$export(module.exports, "GQLOrchestrator", () => $28f17f6ae4a7a4a2$export$ec2e40411fad64b9);

var $5zQU9 = parcelRequire("5zQU9");

var $4SnSg = parcelRequire("4SnSg");
var $30IzH = parcelRequire("30IzH");

var $fgqGG = parcelRequire("fgqGG");
var $drkuP = parcelRequire("drkuP");
var $9oddy = parcelRequire("9oddy");
var $46puT = parcelRequire("46puT");
var $2zP4I = parcelRequire("2zP4I");

var $fFpaQ = parcelRequire("fFpaQ");
function $28f17f6ae4a7a4a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $28f17f6ae4a7a4a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $28f17f6ae4a7a4a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $28f17f6ae4a7a4a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * GQLOrchestrator:
 * Intercepts the GQL call and resolves the call based on the given sequence and Handler.
 */ class $28f17f6ae4a7a4a2$export$ec2e40411fad64b9 {
    constructor(config){
        let middlewares = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        (0, $5zQU9.default)(this, "config", void 0);
        (0, $5zQU9.default)(this, "context", {});
        (0, $5zQU9.default)(this, "middlewares", void 0);
        (0, $5zQU9.default)(this, "DEFAULT_OPERATION", 'default');
        this.config = $28f17f6ae4a7a4a2$var$_objectSpread({
            [this.DEFAULT_OPERATION]: {
                config: {
                    sequence: (0, $fFpaQ.SequenceTypes).PRIMARY_ONLY,
                    handler: new (0, $4SnSg.BaseHandler)()
                }
            }
        }, config);
        this.middlewares = middlewares;
        this.initializeMiddlewares();
    }
    initializeMiddlewares() {
        const uniqueConfigKeys = new Set();
        this.middlewares.forEach((middleware)=>uniqueConfigKeys.add(middleware.getKey()));
        // validate diff config keys
        if (uniqueConfigKeys.size !== this.middlewares.length) throw new Error('GQL Orchestrator: duplicate config keys');
        else this.middlewares.forEach((middleware)=>{
            var _middleware$init;
            return (_middleware$init = middleware.init) === null || _middleware$init === void 0 ? void 0 : _middleware$init.call(middleware, this.context);
        });
    }
    getConfig(key) {
        return this.config[key] || this.config[this.DEFAULT_OPERATION];
    }
    orchestrate(operation, forward) {
        const operationName = operation.operationName;
        const selectedConfig = this.getConfig(operationName);
        selectedConfig.operationName = operation.operationName;
        const orchestrationConfig = typeof selectedConfig.config === 'function' ? selectedConfig.config(operation) : selectedConfig.config;
        let selectedSequence;
        switch(orchestrationConfig.sequence){
            case (0, $fFpaQ.SequenceTypes).PRIMARY_FIRST:
                selectedSequence = (0, $46puT.primaryFirstSequence);
                break;
            case (0, $fFpaQ.SequenceTypes).CUSTOM_FIRST:
                selectedSequence = (0, $fgqGG.customFirstSequence);
                break;
            case (0, $fFpaQ.SequenceTypes).PRIMARY_ONLY:
                selectedSequence = (0, $2zP4I.primaryOnlySequence);
                break;
            case (0, $fFpaQ.SequenceTypes).CUSTOM_ONLY:
                selectedSequence = (0, $drkuP.customOnlySequence);
                break;
            case (0, $fFpaQ.SequenceTypes).PARALLEL:
                selectedSequence = (0, $9oddy.parallelSequence);
                break;
            default:
                selectedSequence = (0, $2zP4I.primaryOnlySequence);
        }
        let handler = orchestrationConfig.handler;
        if (this.middlewares.length) {
            var _selectedConfig$middl;
            // wraps the given handler with provided middlewares
            handler = new (0, $30IzH.MiddlewareHandler)(orchestrationConfig.handler, this.middlewares, this.context, (_selectedConfig$middl = selectedConfig.middlewaresConfig) !== null && _selectedConfig$middl !== void 0 ? _selectedConfig$middl : {});
        }
        return selectedSequence(operation, forward, selectedConfig, handler);
    }
}

});
parcelRegister("30IzH", function(module, exports) {

$parcel$export(module.exports, "MiddlewareHandler", () => $2313f2cb8e9f15fc$export$5c8a4b21799313ac);

var $4SnSg = parcelRequire("4SnSg");
/**
 * ===================================
 *        Middleware Handler
 * ===================================
 * Wraps the given handler with middleware functionality.
 */ class $2313f2cb8e9f15fc$export$5c8a4b21799313ac extends (0, $4SnSg.BaseHandler) {
    constructor(handlerInstance, middlewares, context, middlewareConfig){
        super();
        this.handlerInstance = handlerInstance;
        this.middlewares = middlewares;
        this.context = context;
        this.middlewareConfig = middlewareConfig;
        this.context = context;
        this.handlerInstance = handlerInstance;
        this.middlewares = middlewares;
        this.middlewareConfig = middlewareConfig;
    }
    applyMiddlewares(// Deliberately keeping it wide, with narrow types, TS gets confused and is unable
    // to map a relationship b/w a handler fn and a middleware fn.
    // eslint-disable-next-line @typescript-eslint/ban-types
    getMiddlewareFn, originalMethod) {
        var _this = this;
        return this.middlewares.reduceRight((result, nextMiddleware)=>function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                return getMiddlewareFn(nextMiddleware).apply(nextMiddleware, [
                    args,
                    result,
                    _this.context,
                    _this.middlewareConfig[nextMiddleware.getKey()] || {}
                ]);
            }, originalMethod.bind(this.handlerInstance));
    }
    requestTransformer(operation, sequenceConfigValue, customResponse) {
        const withMiddleware = this.applyMiddlewares((middleware)=>middleware.onRequestTransformer, this.handlerInstance.requestTransformer);
        return withMiddleware(operation, sequenceConfigValue, customResponse);
    }
    fetchPrimary(operation, forward) {
        const withMiddleware = this.applyMiddlewares((middleware)=>middleware.onFetchPrimary, this.handlerInstance.fetchPrimary);
        return withMiddleware(operation, forward);
    }
    fetchCustom(operation, transformedOperation, sequenceConfigValue, primaryResponse) {
        const withMiddleware = this.applyMiddlewares((middleware)=>middleware.onFetchCustom, this.handlerInstance.fetchCustom);
        return withMiddleware(operation, transformedOperation, sequenceConfigValue, primaryResponse);
    }
    responseTransformer(operation, transformedOperation, sequenceConfigValue, primaryResponse, customResponse) {
        const withMiddleware = this.applyMiddlewares((middleware)=>middleware.onResponseTransformer, this.handlerInstance.responseTransformer);
        return withMiddleware(operation, transformedOperation, sequenceConfigValue, primaryResponse, customResponse);
    }
}

});

parcelRegister("fgqGG", function(module, exports) {

$parcel$export(module.exports, "customFirstSequence", () => $b1cd0d38660b98a4$export$3ba9d86643ffc73e);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("eayTI");
var $8E6bd = parcelRequire("8E6bd");
function $b1cd0d38660b98a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b1cd0d38660b98a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b1cd0d38660b98a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b1cd0d38660b98a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Details:
 * First `custom` data is fetched and then based on custom data, we can modify the `primary` query using `transformRequest` fn.
 * The result of both primary and custom calls are passed back to the `transformResponse` function for data massaging.
 *
 * Usecase:
 * When our call to endpoint(BFF in our case(`primary`)) is dependant on getting some data from some other service(`custom`).
 *
 * Call sequence:
 * fetchCustom -> transformRequest -> fetchPrimary -> transformResponse
 */ function $b1cd0d38660b98a4$export$3ba9d86643ffc73e(operation, forward, sequenceConfig, handler) {
    return new (0, $8E6bd.Observable)((observer)=>{
        handler.fetchCustom(operation, null, sequenceConfig, null).then((customFetchResponse)=>{
            const newOperation = handler.requestTransformer(operation, sequenceConfig, customFetchResponse);
            handler.fetchPrimary(newOperation, forward).subscribe({
                next (data) {
                    const primaryResponse = data.data;
                    const queryResponse = handler.responseTransformer(operation, newOperation, sequenceConfig, primaryResponse, customFetchResponse);
                    observer.next($b1cd0d38660b98a4$var$_objectSpread($b1cd0d38660b98a4$var$_objectSpread({}, data), {}, {
                        data: queryResponse
                    }));
                    observer.complete();
                },
                error (err) {
                    observer.error(err);
                }
            });
        }).catch((err)=>{
            observer.error(err);
        });
    });
}

});

parcelRegister("drkuP", function(module, exports) {

$parcel$export(module.exports, "customOnlySequence", () => $9c8db21e04668870$export$2da62b767a268855);
parcelRequire("eayTI");
var $8E6bd = parcelRequire("8E6bd");
/**
 * Details:
 * Only `Custom` data is fetched. `Primary` call is ignored.
 * The result of primary call is passed back to the `transformResponse` function for data massaging.
 *
 * Usecase:
 * Mainly for cases when we want to do `custom` handling for the given GQL call without making a `primary` call.
 *
 * Call sequence:
 * fetchCustom -> transformResponse
 */ function $9c8db21e04668870$export$2da62b767a268855(operation, _forward, sequenceConfig, handler) {
    return new (0, $8E6bd.Observable)((observer)=>{
        handler.fetchCustom(operation, null, sequenceConfig, null).then((customFetchResponse)=>{
            const queryResponse = handler.responseTransformer(operation, null, sequenceConfig, null, customFetchResponse);
            observer.next({
                data: queryResponse
            });
            observer.complete();
        }).catch((err)=>{
            observer.error(err);
        });
    });
}

});

parcelRegister("9oddy", function(module, exports) {

$parcel$export(module.exports, "parallelSequence", () => $6d609baee8bb2c9b$export$d25480062a9825de);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("eayTI");
var $8E6bd = parcelRequire("8E6bd");
function $6d609baee8bb2c9b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6d609baee8bb2c9b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6d609baee8bb2c9b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6d609baee8bb2c9b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Details:
 * Both `primary`(after optionally transforming the given request) and `custom` calls are made together, we wait for both the calls to resolve before calling the
 * `transformResponse` fn with both the data.
 * The result of both primary and custom calls are passed back to the `transformResponse` function for data massaging.
 *
 * Usecase:
 * When `primary` and `custom` calls are independent of each other and can be made in parallel but data needs to be
 * returned in a joined(primary + custom) fashion.
 *
 * Call sequence:
 *                      fetchCustom->
 *                                    | -> transformResponse
 * transformRequest -> fetchPrimary ->
 */ function $6d609baee8bb2c9b$export$d25480062a9825de(operation, forward, sequenceConfig, handler) {
    return new (0, $8E6bd.Observable)((observer)=>{
        const newOperation = handler.requestTransformer(operation, sequenceConfig);
        const fetchCustomPromise = handler.fetchCustom(operation, newOperation, sequenceConfig, null);
        // In case the fetchCustomPromise rejects earlier than fetchPrimary.
        fetchCustomPromise.catch((err)=>{
            observer.error(err);
            // stop listening for response from fetchPrimary
            handler$.unsubscribe();
        });
        const handler$ = handler.fetchPrimary(newOperation, forward).subscribe({
            async next (data) {
                const primaryResponse = data.data;
                try {
                    const customResponse = await fetchCustomPromise;
                    const queryResponse = handler.responseTransformer(operation, newOperation, sequenceConfig, primaryResponse, customResponse);
                    observer.next($6d609baee8bb2c9b$var$_objectSpread($6d609baee8bb2c9b$var$_objectSpread({}, data), {}, {
                        data: queryResponse
                    }));
                    observer.complete();
                } catch (err) {
                    observer.error(err);
                }
            },
            error (err) {
                observer.error(err);
            }
        });
        return ()=>{
            handler$.unsubscribe();
        };
    });
}

});

parcelRegister("46puT", function(module, exports) {

$parcel$export(module.exports, "primaryFirstSequence", () => $2fcb802ccea9f09f$export$5cf98ae892591e5b);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("eayTI");
var $8E6bd = parcelRequire("8E6bd");
function $2fcb802ccea9f09f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2fcb802ccea9f09f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2fcb802ccea9f09f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2fcb802ccea9f09f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Details:
 * First `primary` data is fetched(after optionally transforming the given request) and then for primary data
 * some `custom data`(or dependent data) is fetched.
 * The result of both primary and custom calls are passed back to the `transformResponse` function for data massaging.
 *
 * Use case:
 * When the endpoint service(BFF in our case(primary)) is not able to return the full data and we are dependant of
 * other services(like Algolia(custom)) for fetching the dependant data.
 *
 * Call sequence:
 * transformRequest -> fetchPrimary -> fetchCustom -> transformResponse
 */ function $2fcb802ccea9f09f$export$5cf98ae892591e5b(operation, forward, sequenceConfig, handler) {
    const newOperation = handler.requestTransformer(operation, sequenceConfig);
    return new (0, $8E6bd.Observable)((observer)=>{
        const handler$ = handler.fetchPrimary(newOperation, forward).subscribe({
            async next (data) {
                const primaryResponse = data.data;
                try {
                    const customResponse = await handler.fetchCustom(operation, newOperation, sequenceConfig, primaryResponse);
                    const queryResponse = handler.responseTransformer(operation, newOperation, sequenceConfig, primaryResponse, customResponse);
                    observer.next($2fcb802ccea9f09f$var$_objectSpread($2fcb802ccea9f09f$var$_objectSpread({}, data), {}, {
                        data: queryResponse
                    }));
                    observer.complete();
                } catch (err) {
                    observer.error(err);
                }
            },
            error (err) {
                observer.error(err);
            }
        });
        return ()=>{
            handler$.unsubscribe();
        };
    });
}

});

parcelRegister("2zP4I", function(module, exports) {

$parcel$export(module.exports, "primaryOnlySequence", () => $1e067818d6ed2c8f$export$3db12939f371773b);

var $5zQU9 = parcelRequire("5zQU9");
function $1e067818d6ed2c8f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1e067818d6ed2c8f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1e067818d6ed2c8f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1e067818d6ed2c8f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
/**
 * Details:
 * This is the default sequence. Only `primary` data is fetched(after optionally transforming the given request).
 * `Custom` call is ignored.
 * The result of primary call is passed back to the `transformResponse` function for data massaging.
 *
 * Use case:
 * Mainly for cases when we don't want to fetch any `dependant` data for primary data.
 *
 * Call sequence:
 * transformRequest -> fetchPrimary -> transformResponse
 */ function $1e067818d6ed2c8f$export$3db12939f371773b(operation, forward, sequenceConfig, handler) {
    const newOperation = handler.requestTransformer(operation, sequenceConfig);
    return handler.fetchPrimary(newOperation, forward).map((data)=>{
        const primaryResponse = data.data;
        const queryResponse = handler.responseTransformer(operation, newOperation, sequenceConfig, primaryResponse);
        return $1e067818d6ed2c8f$var$_objectSpread($1e067818d6ed2c8f$var$_objectSpread({}, data), {}, {
            data: queryResponse
        });
    });
}

});





parcelRegister("beqRW", function(module, exports) {

$parcel$export(module.exports, "default", () => $82d5d8254d40bc01$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $fUOHe = parcelRequire("fUOHe");

var $bTrQR = parcelRequire("bTrQR");

var $eUqFw = parcelRequire("eUqFw");
class $82d5d8254d40bc01$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            hasError: false
        });
    }
    static getDerivedStateFromError() {
        return {
            hasError: true
        };
    }
    componentDidCatch(error, errorInfo) {
        (0, $bTrQR.default).error("".concat(this.props.boundaryName, " Error Boundary"), 'Error in render', {
            error: error,
            extraInfo: {
                componentStack: errorInfo.componentStack
            }
        });
        (0, $fUOHe.default).fireComponentBoundaryError(this.props.boundaryName, error);
    }
    render() {
        if (this.state.hasError) return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("eGn88", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab06ee1eaccdc2f1$export$2e2bcd8739ae039);

var $d4wjA = parcelRequire("d4wjA");

var $ighTk = parcelRequire("ighTk");

var $eUqFw = parcelRequire("eUqFw");

var $dM9ZW = parcelRequire("dM9ZW");

var $lHkHI = parcelRequire("lHkHI");
const $ab06ee1eaccdc2f1$var$isKnownGASv3UIEvent = (event)=>event.payload.eventType && event.payload.eventType.type === 'ui' && event.payload.eventType.action && event.payload.actionSubjectId;
/**
 * See https://develop.sentry.dev/sdk/event-payloads/breadcrumbs/#breadcrumb-types
 */ const $ab06ee1eaccdc2f1$var$addBreadcrumb = (action, actionSubjectId, description)=>{
    var _getSentryClient;
    (_getSentryClient = (0, $ighTk.default)()) === null || _getSentryClient === void 0 || _getSentryClient.addBreadcrumb({
        category: "ui.".concat(action),
        message: "".concat(description, " ").concat(actionSubjectId) || "User performed ".concat(action, " on ").concat(actionSubjectId),
        level: 'info'
    });
};
const $ab06ee1eaccdc2f1$var$useSentryPageParamTag = (getRouteName, getRouteParams)=>{
    const { pathname: pathname } = (0, $dM9ZW.useLocation)();
    const currentPageParams = (0, $eUqFw.useRef)(getRouteParams(pathname) || {});
    (0, $eUqFw.useEffect)(()=>{
        var _getSentryClient3;
        // Tags once set, live for the lifecycle of the application. We need to unset
        // them between SPA transitions. See https://github.com/getsentry/sentry-javascript/issues/2218
        Object.keys(currentPageParams.current).forEach((key)=>{
            var _getSentryClient2;
            (_getSentryClient2 = (0, $ighTk.default)()) === null || _getSentryClient2 === void 0 || _getSentryClient2.setTag(key, undefined);
        });
        // And new params are set
        currentPageParams.current = getRouteParams(pathname) || {};
        (_getSentryClient3 = (0, $ighTk.default)()) === null || _getSentryClient3 === void 0 || _getSentryClient3.setTag('pageName', getRouteName(pathname));
        Object.entries(currentPageParams.current).forEach((_ref)=>{
            var _getSentryClient4;
            let [key, value] = _ref;
            (_getSentryClient4 = (0, $ighTk.default)()) === null || _getSentryClient4 === void 0 || _getSentryClient4.setTag(key, value);
        });
    }, [
        pathname
    ]);
};
const $ab06ee1eaccdc2f1$var$SentryGASv3Listener = (_ref2)=>{
    let { children: children, getRouteName: getRouteName, getRouteParams: getRouteParams } = _ref2;
    // Our top level analytics listener can catch a heterogeneous mix
    // of events, not all of which we might be interested in
    const handleAnalyticsEvent = (e)=>{
        if ($ab06ee1eaccdc2f1$var$isKnownGASv3UIEvent(e)) $ab06ee1eaccdc2f1$var$addBreadcrumb(e.payload.eventType.action, e.payload.actionSubjectId, e.payload.eventType.details);
    };
    $ab06ee1eaccdc2f1$var$useSentryPageParamTag(getRouteName, getRouteParams);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $d4wjA.default), {
        channel: "*",
        onEvent: handleAnalyticsEvent,
        children: children
    });
};
var $ab06ee1eaccdc2f1$export$2e2bcd8739ae039 = $ab06ee1eaccdc2f1$var$SentryGASv3Listener;

});

parcelRegister("aaXr0", function(module, exports) {

$parcel$export(module.exports, "default", () => $7688f1086fb41ca8$export$2e2bcd8739ae039);
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");

var $c6kEN = parcelRequire("c6kEN");

var $a5uQr = parcelRequire("a5uQr");

var $eGvPT = parcelRequire("eGvPT");
const $7688f1086fb41ca8$var$mapStateToProps = (state)=>{
    return {
        analytics: state.analytics,
        launchDarklyUserKey: (0, $a5uQr.selectLaunchDarklyUserKey)(state.configuration)
    };
};
const $7688f1086fb41ca8$var$mapDispatchToProps = (dispatch)=>{
    return {
        onScreenChanged: (source, attributes)=>dispatch((0, $c6kEN.onScreenChanged)(source, attributes))
    };
};
var $7688f1086fb41ca8$export$2e2bcd8739ae039 = (0, $94zHK.default)($7688f1086fb41ca8$var$mapStateToProps, $7688f1086fb41ca8$var$mapDispatchToProps)((0, $eGvPT.default));

});
parcelRegister("a5uQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $75824c2520a93620$export$2e2bcd8739ae039);
$parcel$export(module.exports, "selectLaunchDarklyUserKey", () => $75824c2520a93620$export$c2c7b26a63f4e63f);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $j2ea9 = parcelRequire("j2ea9");
const $75824c2520a93620$export$c0fdb33f925d509f = (0, $g5DHJ.Record)({
    hostConfig: (0, $bWAru.Option).empty(),
    hostInfo: (0, $bWAru.Option).empty(),
    featureFlags: (0, $bWAru.Option).empty(),
    frontendBootstrap: (0, $bWAru.Option).empty()
});
function $75824c2520a93620$export$2e2bcd8739ae039() {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $75824c2520a93620$export$c0fdb33f925d509f();
    let action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $j2ea9.FETCH_HOST_INFO:
            return state.set('hostInfo', (0, $bWAru.Option).empty());
        case 0, $j2ea9.RECEIVE_HOST_INFO:
            return state.set('hostInfo', (0, $bWAru.Option).some((0, $bWAru.Either).right(action.hostInfo)));
        case 0, $j2ea9.RECEIVE_HOST_INFO_ERROR:
            return state.set('hostInfo', (0, $bWAru.Option).some((0, $bWAru.Either).left(action.dataErrorMessages)));
        case 0, $j2ea9.FETCH_HOST_CONFIG:
            return state.set('hostConfig', (0, $bWAru.Option).empty());
        case 0, $j2ea9.RECEIVE_HOST_CONFIG:
            return state.set('hostConfig', (0, $bWAru.Option).some((0, $bWAru.Either).right(action.hostConfig)));
        case 0, $j2ea9.RECEIVE_HOST_CONFIG_ERROR:
            return state.set('hostConfig', (0, $bWAru.Option).some((0, $bWAru.Either).left(action.dataErrorMessages)));
        case 0, $j2ea9.RECEIVE_FEATURE_FLAGS_ERROR:
            return state.set('featureFlags', (0, $bWAru.Option).some((0, $bWAru.Either).left(action.dataErrorMessages)));
        case 0, $j2ea9.RECEIVE_FEATURE_FLAGS:
            return state.set('featureFlags', (0, $bWAru.Option).some((0, $bWAru.Either).right(action.featureFlags)));
        case 0, $j2ea9.FETCH_FRONTEND_BOOTSTRAP_CONFIG:
            return state.set('frontendBootstrap', (0, $bWAru.Option).empty());
        case 0, $j2ea9.RECEIVE_FRONTEND_BOOTSTRAP_CONFIG:
            return state.set('frontendBootstrap', (0, $bWAru.Option).some((0, $bWAru.Either).right(action.frontendBootstrap)));
        default:
            // Flow compile-time validation that we've handled every action
            // prettier-ignore
            action;
            return state;
    }
}
const $75824c2520a93620$export$c2c7b26a63f4e63f = (state)=>state.frontendBootstrap.fold(()=>{
    /* frontend bootstrap does not exist */ }, (frontendBootstrapRes)=>frontendBootstrapRes.fold(()=>{
        /* fetching frontend bootstrap had errors */ }, (frontendBootstrap)=>frontendBootstrap.launchDarklyUserKey));

});

parcelRegister("eGvPT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ab0daee3298a840c$export$2e2bcd8739ae039);

var $cnkdy = parcelRequire("cnkdy");
var $ab0daee3298a840c$export$2e2bcd8739ae039 = (0, $cnkdy.default);

});
parcelRegister("cnkdy", function(module, exports) {

$parcel$export(module.exports, "default", () => $902750d715924d4d$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $d4wjA = parcelRequire("d4wjA");

var $46iLW = parcelRequire("46iLW");
var $eqVJB = parcelRequire("eqVJB");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $jHg79 = parcelRequire("jHg79");

var $iIG3b = parcelRequire("iIG3b");

var $cMIj9 = parcelRequire("cMIj9");

var $bwjZm = parcelRequire("bwjZm");

var $bPtM5 = parcelRequire("bPtM5");

var $15DZ6 = parcelRequire("15DZ6");

var $efw6o = parcelRequire("efw6o");

var $5JCOp = parcelRequire("5JCOp");

var $lHkHI = parcelRequire("lHkHI");
function $902750d715924d4d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $902750d715924d4d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $902750d715924d4d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $902750d715924d4d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $902750d715924d4d$export$3ab626b13e803edd = new Set([
    'addonDiscovery',
    'marketplace'
]);
class $902750d715924d4d$export$1acebda72be013db extends $eUqFw.Component {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onEvent", (event, channel)=>{
            const gasEvent = event;
            if (channel && $902750d715924d4d$export$3ab626b13e803edd.has(channel)) {
                const { payload: payload, context: context } = gasEvent;
                const source = (0, $bWAru.Option).of(this.props.analytics.modalStack.last()).getOrElse(this.props.analytics.currentScreen);
                const marketplaceContext = (0, $46iLW.getMergedMarketplaceContext)(context);
                const emceeVariant = (0, $bPtM5.isEmceeConnect)() ? (0, $iIG3b.EmceeVariant).Connect : (0, $iIG3b.EmceeVariant).Native;
                (0, $cMIj9.getExtensionIDFromURL)((extensionID)=>{
                    const featureFlags = this.props.featureFlags.getAllFlags().toJS();
                    const sourceUrlParam = (0, $efw6o.getAnalyticsSourceParam)();
                    const baseAttributes = {
                        featureFlags: featureFlags,
                        source: sourceUrlParam,
                        extensionID: extensionID,
                        emceeVariant: emceeVariant,
                        launchDarklyUserKey: this.props.launchDarklyUserKey
                    };
                    const tags = (payload.tags || []).concat([
                        'emcee'
                    ]);
                    const updatedPayload = $902750d715924d4d$var$_objectSpread($902750d715924d4d$var$_objectSpread({}, payload), {}, {
                        tags: tags
                    });
                    if (payload.eventType.type === (0, $eqVJB.SCREEN_EVENT_TYPE)) {
                        const analyticsRouteParams = (0, $efw6o.getAnalyticsRouteParams)({
                            mountPath: this.props.mountPath
                        });
                        const eventArgs = {
                            marketplaceContext: marketplaceContext,
                            payload: updatedPayload,
                            analyticsRouteParams: analyticsRouteParams
                        };
                        const finalEvent = (0, $bwjZm.getScreenViewEvent)(eventArgs);
                        return (0, $5JCOp.sendPageViewEvent)(finalEvent);
                    }
                    // all other events
                    const eventArgs = {
                        marketplaceContext: marketplaceContext,
                        payload: updatedPayload,
                        source: source,
                        baseAttributes: baseAttributes
                    };
                    const finalEvent = (0, $bwjZm.getNonScreenEvent)(eventArgs);
                    (0, $5JCOp.sendEvent)(finalEvent);
                });
            }
        });
    }
    onScreenChanged(currentPath) {
        const currentRoute = (0, $15DZ6.resolveCurrentRoute)(currentPath, this.props.mountPath);
        if (currentRoute) this.props.onScreenChanged(currentRoute.analyticsSourceScreen, {
            mountPath: this.props.mountPath
        });
        else throw new Error("Must register a route in Routes.js for: ".concat(currentPath));
    }
    componentDidMount() {
        this.onScreenChanged(this.props.location.pathname);
    }
    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) this.onScreenChanged(this.props.location.pathname);
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $d4wjA.default), {
            channel: "*",
            onEvent: this.onEvent,
            children: this.props.children
        });
    }
}
var $902750d715924d4d$export$2e2bcd8739ae039 = (0, $jHg79.withMountPath)($902750d715924d4d$export$1acebda72be013db);

});
parcelRegister("46iLW", function(module, exports) {

$parcel$export(module.exports, "getMergedMarketplaceContext", () => $2fc648bcf8033ef2$export$df9eeec778c4dbf4);

var $7IZKi = parcelRequire("7IZKi");

var $f2QOW = parcelRequire("f2QOW");
const $2fc648bcf8033ef2$export$6d214f22a21009c2 = (analyticsContext)=>{
    return analyticsContext.map((contextItem)=>{
        return contextItem[0, $f2QOW.MARKETPLACE_ANALYTICS_CONTEXT_NAMESPACE]; // contextItem[MARKETPLACE_ANALYTICS_CONTEXT_NAMESPACE] should always be of MarketplaceAnalyticsContextItem type.
    }).filter(Boolean);
};
const $2fc648bcf8033ef2$export$df9eeec778c4dbf4 = (analyticsContext)=>{
    const allContexts = $2fc648bcf8033ef2$export$6d214f22a21009c2(analyticsContext);
    return (0, (/*@__PURE__*/$parcel$interopDefault($7IZKi)))([
        {
            attributes: {},
            properties: {}
        },
        ...allContexts
    ]);
};

});
parcelRegister("7IZKi", function(module, exports) {

var $jFIrw = parcelRequire("jFIrw");

var $59fc89db827939ef$var$func = $jFIrw('mergeAll', (parcelRequire("2vzCR")));

$59fc89db827939ef$var$func.placeholder = (parcelRequire("l6Yg9"));
module.exports = $59fc89db827939ef$var$func;

});


parcelRegister("jHg79", function(module, exports) {

$parcel$export(module.exports, "AppContextProvider", () => $e56e88747335bc59$export$20d2b7652facc723);
$parcel$export(module.exports, "withMountPath", () => $e56e88747335bc59$export$3fa38dc22c8a442c);
$parcel$export(module.exports, "useMountPath", () => $e56e88747335bc59$export$4987786278697d67);
$parcel$export(module.exports, "useEnvironment", () => $e56e88747335bc59$export$ea7ed2425832167d);
$parcel$export(module.exports, "useAlgoliaConfig", () => $e56e88747335bc59$export$3cc557c49a8fd7f0);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $e56e88747335bc59$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e56e88747335bc59$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e56e88747335bc59$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e56e88747335bc59$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e56e88747335bc59$var$AppContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    mountPath: '',
    bootstrapConfig: undefined
});
const $e56e88747335bc59$export$20d2b7652facc723 = (_ref)=>{
    let { children: children, mountPath: mountPath, bootstrapConfig: bootstrapConfig } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsx)($e56e88747335bc59$var$AppContext.Provider, {
        value: {
            mountPath: mountPath,
            bootstrapConfig: bootstrapConfig
        },
        children: children
    });
};
const $e56e88747335bc59$var$useAppContext = ()=>{
    return (0, $eUqFw.useContext)($e56e88747335bc59$var$AppContext);
};
function $e56e88747335bc59$export$3fa38dc22c8a442c(WrappedComponent) {
    return function AppContextHOC(props) {
        return /*#__PURE__*/ (0, $lHkHI.jsx)($e56e88747335bc59$var$AppContext.Consumer, {
            children: (appContext)=>{
                return /*#__PURE__*/ (0, $lHkHI.jsx)(WrappedComponent, $e56e88747335bc59$var$_objectSpread({
                    mountPath: appContext.mountPath
                }, props));
            }
        });
    };
}
const $e56e88747335bc59$export$4987786278697d67 = ()=>{
    const { mountPath: mountPath } = $e56e88747335bc59$var$useAppContext();
    return mountPath;
};
const $e56e88747335bc59$export$4f7e8f2feb52f178 = ()=>{
    const { bootstrapConfig: bootstrapConfig } = $e56e88747335bc59$var$useAppContext();
    return bootstrapConfig;
};
const $e56e88747335bc59$export$ea7ed2425832167d = ()=>{
    const { bootstrapConfig: { environment: environment } } = $e56e88747335bc59$var$useAppContext();
    return environment;
};
const $e56e88747335bc59$export$3cc557c49a8fd7f0 = ()=>{
    const { bootstrapConfig: { algolia: algolia } } = $e56e88747335bc59$var$useAppContext();
    return algolia;
};

});

parcelRegister("cMIj9", function(module, exports) {

$parcel$export(module.exports, "getExtensionIDFromURL", () => $94ec565a129b34fb$export$56db6c2b9d9c4d80);
$parcel$export(module.exports, "getEmceeLocation", () => $94ec565a129b34fb$export$78429c57b8adcb20);

var $bPtM5 = parcelRequire("bPtM5");
function $94ec565a129b34fb$export$56db6c2b9d9c4d80(callback) {
    (0, $bPtM5.getLocation)((location)=>{
        // for ex: 'com.atlassian.jira.emcee__admin-discover' will retrieved from url in case of Admin find new apps link
        const extensionID = location.split('?')[0].split('#')[0].split('/').slice(-2).join('__');
        callback(extensionID);
    });
}
function $94ec565a129b34fb$export$78429c57b8adcb20(callback, mountPath) {
    // sample location = https://marketplace.atlassian.net/plugins/servlet/ac/com.atlassian.jira.emcee/app-requests?s=com.atlassian.jira.emcee__discover#!/discover
    // which should return
    // base = https://marketplace.atlassian.net/plugins/servlet/ac/com.atlassian.jira.emcee
    // fullURL = https://marketplace.atlassian.net/plugins/servlet/ac/com.atlassian.jira.emcee/app-requests
    (0, $bPtM5.getLocation)((location)=>{
        const fullURL = location.split('?')[0].split('#')[0];
        const baseURL = (0, $bPtM5.isEmceeConnect)() ? fullURL.split('/').slice(0, -1).join('/') : window.location.origin + mountPath;
        callback({
            fullURL: fullURL,
            baseURL: baseURL
        });
    });
}

});

parcelRegister("bwjZm", function(module, exports) {

$parcel$export(module.exports, "getScreenViewEvent", () => $86323032c7595c38$export$8378d1ba108f66d1);
$parcel$export(module.exports, "getNonScreenEvent", () => $86323032c7595c38$export$2cedbd7eb17ed333);

var $2vzCR = parcelRequire("2vzCR");

var $7Uh51 = parcelRequire("7Uh51");
const $86323032c7595c38$export$8378d1ba108f66d1 = (_ref)=>{
    let { marketplaceContext: marketplaceContext, payload: payload, baseAttributes: baseAttributes = {}, analyticsRouteParams: analyticsRouteParams = {} } = _ref;
    const { attributes: payloadAttributes, eventType: { name: name, details: details } } = payload;
    const { attributes: contextAttributes } = marketplaceContext;
    const attributes = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, analyticsRouteParams, baseAttributes, contextAttributes, payloadAttributes);
    return {
        name: name,
        details: details,
        attributes: attributes
    };
};
const $86323032c7595c38$export$2cedbd7eb17ed333 = (_ref2)=>{
    let { marketplaceContext: marketplaceContext, payload: payload, source: source, baseAttributes: baseAttributes = {} } = _ref2;
    const { tags: tags = [], eventType: { actionSubject: actionSubject, action: action }, actionSubjectId: actionSubjectId, objectId: objectId, objectType: objectType, source: payloadSource, attributes: payloadAttributes } = payload;
    const { attributes: contextAttributes, properties: contextProperties } = marketplaceContext;
    const attributes = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, baseAttributes, contextAttributes, payloadAttributes);
    const baseProperties = {
        category: (0, $7Uh51.ANALYTICS_CATEGORY_NAVIGATION),
        source: (payloadSource === null || payloadSource === void 0 ? void 0 : payloadSource.name) || (source === null || source === void 0 ? void 0 : source.name) || contextProperties.source,
        tags: tags
    };
    // containerId, containerType, source cannot be overridden by the payload
    const payloadProperties = {
        action: action,
        actionSubject: actionSubject,
        actionSubjectId: actionSubjectId,
        objectId: objectId,
        objectType: objectType
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))({}, baseProperties, contextProperties, payloadProperties, // attributes were previously merged
    {
        attributes: attributes
    });
};

});

parcelRegister("efw6o", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsRouteParams", () => $a5fb5e3d727576f2$export$100f686b119e9e1);
$parcel$export(module.exports, "getAnalyticsSourceParam", () => $a5fb5e3d727576f2$export$3f6cbfeb449f2bb0);
$parcel$export(module.exports, "getPageAttributes", () => $a5fb5e3d727576f2$export$fd98e1df3bc81198);

var $15DZ6 = parcelRequire("15DZ6");
const $a5fb5e3d727576f2$var$ALLOWED_PARAMS = new Set([
    'appKey'
]);
const $a5fb5e3d727576f2$export$100f686b119e9e1 = (analyticsAttributes)=>{
    const locationPath = (0, $15DZ6.getLocationPath)();
    const { mountPath: mountPath } = analyticsAttributes;
    const currentRoute = (0, $15DZ6.resolveCurrentRoute)(locationPath, mountPath);
    const routeParams = {};
    if (!currentRoute) return routeParams;
    const pathMatched = (0, $15DZ6.getMatchPath)({
        locationPath: locationPath,
        routePath: currentRoute.path,
        mountPath: mountPath
    });
    if (!pathMatched) return routeParams;
    for(const key in pathMatched.params)if ($a5fb5e3d727576f2$var$ALLOWED_PARAMS.has(key) && Object.prototype.hasOwnProperty.call(pathMatched.params, key) && pathMatched.params[key]) routeParams[key] = pathMatched.params[key];
    return routeParams;
};
const $a5fb5e3d727576f2$export$3f6cbfeb449f2bb0 = ()=>{
    const { source: source } = (0, $15DZ6.getUrlParams)();
    if (Array.isArray(source) && source.length) return source[0].toString();
    if (typeof source === 'string') return source;
};
const $a5fb5e3d727576f2$export$fd98e1df3bc81198 = (windowHref, documentReferrer)=>{
    const page = windowHref ? new URL(windowHref) : null;
    const page_url = page ? page.href : '';
    const page_referrer = documentReferrer ? new URL(documentReferrer) : null;
    const pageAtrributes = {
        page_url: page_url,
        page_domain: page ? page.hostname : '',
        page_subdomain: page ? page.hostname : '',
        page_path: page ? page.pathname : '',
        page_url_parameters: page ? page.search : '',
        page_referrer_url: page_referrer ? page_referrer.href : '',
        page_referrer_domain: page_referrer ? page_referrer.hostname : '',
        page_referrer_subdomain: page_referrer ? page_referrer.hostname : '',
        page_referrer_path: page_referrer ? page_referrer.pathname : '',
        // EMCEE is in product experience, therefore `isMarketingEvent:false`, thread to follow for more clarity -> https://atlassian.slack.com/archives/C01U0UGBZJB/p1671134181487119
        isMarketingEvent: false
    };
    return pageAtrributes;
};

});




parcelRegister("119Qg", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bdd84d8e57df959$export$2e2bcd8739ae039);

var $fUOHe = parcelRequire("fUOHe");

var $dM9ZW = parcelRequire("dM9ZW");

var $eUqFw = parcelRequire("eUqFw");
function $0bdd84d8e57df959$var$TelemetryNavigationListener(_ref) {
    let { getRouteName: getRouteName } = _ref;
    const { pathname: pathname } = (0, $dM9ZW.useLocation)();
    const routeName = getRouteName(pathname) || 'unknown';
    (0, $fUOHe.default).setPage(routeName);
    const history = (0, $dM9ZW.useHistory)();
    (0, $eUqFw.useEffect)(()=>{
        // Trace Page load on initial load
        (0, $fUOHe.default).traceUFOPageLoad(routeName);
        history.listen((location)=>{
            const pageName = getRouteName(location.pathname) || 'unknown';
            (0, $fUOHe.default).setPage(pageName);
            // Trace page transition
            (0, $fUOHe.default).traceUFOPageLoad(pageName);
        });
    }, []);
    return null;
}
var $0bdd84d8e57df959$export$2e2bcd8739ae039 = $0bdd84d8e57df959$var$TelemetryNavigationListener;

});

parcelRegister("fwA2m", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4d5cc5f826e7427$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $cjFit = parcelRequire("cjFit");

var $f2QOW = parcelRequire("f2QOW");

var $d5mip = parcelRequire("d5mip");
var $inwKI = parcelRequire("inwKI");
var $9l6Pq = parcelRequire("9l6Pq");

var $b37sc = parcelRequire("b37sc");
var $eEKFN = parcelRequire("eEKFN");

var $tGPnp = parcelRequire("tGPnp");

var $i0EDR = parcelRequire("i0EDR");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $kC116 = parcelRequire("kC116");

var $fQWJT = parcelRequire("fQWJT");

var $2hUUV = parcelRequire("2hUUV");

var $bjCXH = parcelRequire("bjCXH");

var $m6EiQ = parcelRequire("m6EiQ");

var $jwE5W = parcelRequire("jwE5W");

var $lHkHI = parcelRequire("lHkHI");
function $b4d5cc5f826e7427$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b4d5cc5f826e7427$export$e7c037e828f00a48 = (0, $3UXZ8.default)("img", {
    target: "e1d1iot30",
    label: "BreadcrumbUrlIconContainer"
})((props)=>({
        borderRadius: props.circle ? '50%' : '3px',
        height: '20px',
        width: '20px',
        marginRight: '5px'
    }), "");
const $b4d5cc5f826e7427$export$cae9f2805ae04af9 = (0, $3UXZ8.default)("span", {
    target: "e1d1iot31",
    label: "BreadcrumbReactIconContainer"
})({
    name: "26abus",
    styles: "margin-right:var(--ds-space-025, 2px);"
});
const $b4d5cc5f826e7427$export$6ce170286acaa8d3 = (0, $3UXZ8.default)("div", {
    target: "e1d1iot32",
    label: "ContentWrapper"
})({
    name: "89aa4j",
    styles: "min-height:calc(100vh - 168px);margin-top:var(--ds-space-500, 40px);margin-bottom:var(--ds-space-250, 20px);& > div{min-height:inherit;}"
});
const $b4d5cc5f826e7427$export$3a335ce174926026 = (0, $3UXZ8.default)("div", {
    target: "e1d1iot33",
    label: "HeaderRightContainer"
})("float:", (props)=>props.isAetherEnabled ? 'none' : 'right', ";clear:both;content:' ';display:inline-flex;align-items:center;margin-top:", (props)=>props.isAetherEnabled ? '16' : '0', "px;");
const $b4d5cc5f826e7427$export$c84ae777e0a32768 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $b37sc.default), {
    target: "e1d1iot34",
    label: "BreadcrumbsContainerStyled"
})("display:inline-block;margin-top:", (props)=>props.isAetherEnabled ? '16' : '5', "px;");
const $b4d5cc5f826e7427$export$6af4131492a1e6d7 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $tGPnp.FluidContainer), {
    target: "e1d1iot35",
    label: "FluidContainerStyled"
})({
    name: "1c8ux76",
    styles: "display:flex;flex-wrap:wrap;align-items:center;justify-content:space-between;"
});
const $b4d5cc5f826e7427$var$MaintenanceBannerWrapper = (0, $3UXZ8.default)("div", {
    target: "e1d1iot36",
    label: "MaintenanceBannerWrapper"
})({
    name: "1f2khbb",
    styles: "margin-top:var(--ds-space-500, 40px);"
});
class $b4d5cc5f826e7427$export$2053565dae02b922 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "processParameters", ()=>this.props.receivedParameters.forEach((ps)=>ps.target.forEach((target)=>(0, $fQWJT.foldTarget)(target)(()=>this.props.history.push({
                            pathname: this.props.emceeLinks.discoverHome.getRelative()
                        }), ()=>this.props.history.push({
                            pathname: this.props.emceeLinks.manageHome.getRelative()
                        }), (installTarget)=>{
                        this.props.openInstallDialog({
                            context: this.props.selectedContext,
                            installableAppId: installTarget.installableAppId,
                            relayState: ps.relayState
                        });
                    }, (tokenTarget)=>{
                        this.props.openAppSpecificPasswordDialog({
                            name: tokenTarget.tokenName
                        });
                    }))));
        (0, $5zQU9.default)(this, "rightHeaderContent", ()=>{
            var _this$props$statsigCl;
            const isAetherEnabled = (_this$props$statsigCl = this.props.statsigClient) === null || _this$props$statsigCl === void 0 ? void 0 : _this$props$statsigCl.enableEmceeAetherExperience();
            return /*#__PURE__*/ (0, $lHkHI.jsxs)($b4d5cc5f826e7427$export$3a335ce174926026, {
                "data-testid": "feedback-collector",
                isAetherEnabled: isAetherEnabled,
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2hUUV.default), {
                        onFeedbackSubmit: this.props.onFeedbackSubmit,
                        userId: this.props.currentUserId,
                        selectedContext: this.props.selectedContext
                    }),
                    this.props.bootstrapConfig.showDevtools && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $m6EiQ.default), {
                        featureFlags: this.props.featureFlags.getAllFlags().toJS(),
                        bootstrapConfig: this.props.bootstrapConfig,
                        onBootstrapConfigChange: this.props.onBootstrapConfigChange
                    })
                ]
            });
        });
        (0, $5zQU9.default)(this, "render", ()=>{
            var _this$props$statsigCl2;
            const Component = this.props.component;
            const isAetherEnabled = (_this$props$statsigCl2 = this.props.statsigClient) === null || _this$props$statsigCl2 === void 0 ? void 0 : _this$props$statsigCl2.enableEmceeAetherExperience();
            const breadcrumbWrapper = isAetherEnabled ? $b4d5cc5f826e7427$export$6af4131492a1e6d7 : (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment;
            const featureFlags = this.props.featureFlags.getAllFlags().toJS();
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $inwKI.FeatureFlagsProvider), {
                value: // provide default values for feature flags if none are present
                Object.keys(featureFlags).length !== 0 ? featureFlags : (0, $d5mip.DEFAULT_MARKETPLACE_FEATURE_FLAGS),
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $f2QOW.default), {
                    properties: {
                        containerType: 'context',
                        containerId: this.props.selectedContext.id
                    },
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)($b4d5cc5f826e7427$export$c84ae777e0a32768, {
                        isAetherEnabled: isAetherEnabled,
                        isExpanded: true,
                        wrapper: breadcrumbWrapper,
                        rightContent: this.rightHeaderContent(),
                        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eEKFN.default), {
                            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_CONTEXT_NAME),
                            href: this.props.hostInfo.product === (0, $i0EDR.CompatibleProductId).COMPASS ? "".concat(this.props.hostInfo.baseUrl, "/compass") : this.props.hostInfo.baseUrl,
                            target: "_parent",
                            text: this.props.selectedContext.name || (0, $kC116.defaultContextName),
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)($b4d5cc5f826e7427$var$MaintenanceBannerWrapper, {
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bjCXH.default), {})
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)($b4d5cc5f826e7427$export$6ce170286acaa8d3, {
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)(Component, {
                                        algoliaClient: this.props.algoliaClient,
                                        bootstrapConfig: this.props.bootstrapConfig,
                                        currentUserId: this.props.currentUserId,
                                        featureFlags: this.props.featureFlags,
                                        hostConfig: this.props.hostConfig,
                                        hostInfo: this.props.hostInfo,
                                        hostPricing: this.props.hostPricing,
                                        links: this.props.links,
                                        onRendered: this.props.onRendered,
                                        receivedParameters: this.props.receivedParameters,
                                        selectedContext: this.props.selectedContext
                                    })
                                })
                            ]
                        })
                    })
                })
            });
        });
    }
    componentDidMount() {
        this.props.retrieveFreshInstalledApps({
            context: this.props.selectedContext,
            hostConfig: this.props.hostConfig,
            search: (0, $cjFit.emptyString),
            flags: {
                enableReactivateForgeAppFromEmcee: this.props.featureFlags.getFlag('enableReactivateForgeAppFromEmcee', false),
                enableDeprecatedInstallationsGQL: this.props.featureFlags.getFlag('enableDeprecatedInstallationsGQL', false)
            }
        });
        this.processParameters();
    }
    componentDidUpdate(prevProps) {
        if (!prevProps.receivedParameters.equals(this.props.receivedParameters)) this.processParameters();
    }
}
var $b4d5cc5f826e7427$export$2e2bcd8739ae039 = (0, $jwE5W.withEmceeLinks)((0, $9l6Pq.withStatsig)($b4d5cc5f826e7427$export$2053565dae02b922));

});
parcelRegister("b37sc", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b5c1ad1d2f34c2$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $6a7WY = parcelRequire("6a7WY");
var $czBq9 = parcelRequire("czBq9");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $ctXof = parcelRequire("ctXof");

var $lHkHI = parcelRequire("lHkHI");
function $80b5c1ad1d2f34c2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $80b5c1ad1d2f34c2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $80b5c1ad1d2f34c2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $80b5c1ad1d2f34c2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $80b5c1ad1d2f34c2$var$isEqual = (a, b)=>{
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (!a[i].equals(b[i])) return false;
    }
    return true;
};
class $80b5c1ad1d2f34c2$export$d56d1ad95af91ccb extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            breadcrumbItems: [],
            isExpanded: false
        });
        (0, $5zQU9.default)(this, "expand", ()=>{
            this.setState({
                isExpanded: true
            });
        });
        (0, $5zQU9.default)(this, "clearBreadcrumbItems", ()=>{
            this.setState({
                breadcrumbItems: []
            });
        });
        (0, $5zQU9.default)(this, "updateBreadcrumbItems", (breadcrumbItems)=>{
            if (!$80b5c1ad1d2f34c2$var$isEqual(breadcrumbItems, this.state.breadcrumbItems)) this.setState({
                breadcrumbItems: breadcrumbItems,
                isExpanded: false
            });
        });
        (0, $5zQU9.default)(this, "onBreadcrumbItemClick", (breadcrumbItem)=>(e)=>{
                this.props.fireAnalyticsEvent({
                    eventType: (0, $gaiog.BreadcrumbClickedEvent),
                    actionSubjectId: breadcrumbItem.actionSubjectId
                });
                if (breadcrumbItem.onClick) breadcrumbItem.onClick(e);
            });
        (0, $5zQU9.default)(this, "render", ()=>{
            const Wrapper = this.props.wrapper || (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment;
            return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $ctXof.default).Provider, {
                value: {
                    clearBreadcrumbItems: this.clearBreadcrumbItems,
                    updateBreadcrumbItems: this.updateBreadcrumbItems
                },
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsxs)(Wrapper, {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                                className: this.props.className,
                                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $czBq9.default), {
                                    isExpanded: this.props.isExpanded || this.state.isExpanded,
                                    onExpand: this.expand,
                                    children: this.state.breadcrumbItems.map((b, i)=>/*#__PURE__*/ (0, $eUqFw.createElement)((0, $6a7WY.default), $80b5c1ad1d2f34c2$var$_objectSpread($80b5c1ad1d2f34c2$var$_objectSpread({}, b.toObject()), {}, {
                                            key: "".concat(i, "-").concat(b.text),
                                            onClick: this.onBreadcrumbItemClick(b)
                                        })))
                                })
                            }),
                            this.props.rightContent ? this.props.rightContent : null
                        ]
                    }),
                    this.props.children
                ]
            });
        });
    }
}
(0, $5zQU9.default)($80b5c1ad1d2f34c2$export$d56d1ad95af91ccb, "defaultProps", {
    isExpanded: false
});
var $80b5c1ad1d2f34c2$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($80b5c1ad1d2f34c2$export$d56d1ad95af91ccb);

});
parcelRegister("6a7WY", function(module, exports) {

$parcel$export(module.exports, "default", () => $47c9d7f87f5d540e$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $l2WWm = parcelRequire("l2WWm");

var $q7YhJ = parcelRequire("q7YhJ");

var $diIB9 = parcelRequire("diIB9");
const $47c9d7f87f5d540e$var$itemWrapperStyles = (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    maxWidth: '100%',
    height: `${24 / 14}em`,
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    flexDirection: 'row',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:not(:last-child)::after': {
        width: '8px',
        flexShrink: 0,
        content: '"/"',
        paddingBlock: "var(--ds-space-025, 2px)",
        paddingInline: "var(--ds-space-100, 8px)",
        textAlign: 'center'
    }
});
const $47c9d7f87f5d540e$var$VAR_STEP_TRUNCATION_WIDTH = '--max-width';
const $47c9d7f87f5d540e$var$ICON_WIDTH_ESTIMATE = 24;
const $47c9d7f87f5d540e$var$staticItemStyles = (0, $byn9U.css)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingBlock: "var(--ds-space-025, 2px)"
});
const $47c9d7f87f5d540e$var$staticItemWithTruncationStyles = (0, $byn9U.css)({
    maxWidth: `var(${$47c9d7f87f5d540e$var$VAR_STEP_TRUNCATION_WIDTH})`
});
const $47c9d7f87f5d540e$var$staticItemWithoutTruncationStyles = (0, $byn9U.css)({
    minWidth: 0,
    flexShrink: 1
});
const $47c9d7f87f5d540e$var$BreadcrumbsItem = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const buttonRef = (0, $eUqFw.useRef)(null);
    const { truncationWidth: truncationWidth, text: text, onTooltipShown: onTooltipShown, ...restButtonProps } = props;
    // If icons are provided we include their width in the truncation calculation to ensure we're as accurate as possible.
    // Note: this assumes icons are 24px wide which should be almost always.
    // Not really an issue if the icons are smaller, just that truncation occurs slightly earlier than you may want.
    let iconWidthAllowance = 0;
    if (props.iconBefore) iconWidthAllowance += $47c9d7f87f5d540e$var$ICON_WIDTH_ESTIMATE;
    if (props.iconAfter) iconWidthAllowance += $47c9d7f87f5d540e$var$ICON_WIDTH_ESTIMATE;
    const [hasOverflow, showTooltip] = (0, $diIB9.default)(truncationWidth, buttonRef.current, iconWidthAllowance);
    const buttonProps = {
        ...restButtonProps,
        ref: buttonRef,
        hasOverflow: hasOverflow
    };
    // Note: cast to `any` is required to type verification - see https://github.com/frenic/csstype#what-should-i-do-when-i-get-type-errors
    const dynamicItemStyles = {
        [$47c9d7f87f5d540e$var$VAR_STEP_TRUNCATION_WIDTH]: typeof truncationWidth !== 'undefined' && `${truncationWidth}px`
    };
    const step = truncationWidth ? (0, $byn9U.jsx)((0, $q7YhJ.default), (0, $kU09D.default)({}, buttonProps, {
        css: [
            $47c9d7f87f5d540e$var$staticItemStyles,
            $47c9d7f87f5d540e$var$staticItemWithTruncationStyles
        ],
        style: dynamicItemStyles
    }), text) : (0, $byn9U.jsx)((0, $q7YhJ.default), (0, $kU09D.default)({}, buttonProps, {
        css: [
            $47c9d7f87f5d540e$var$staticItemStyles,
            $47c9d7f87f5d540e$var$staticItemWithoutTruncationStyles
        ]
    }), text);
    return (0, $byn9U.jsx)("li", {
        css: $47c9d7f87f5d540e$var$itemWrapperStyles
    }, showTooltip ? (0, $byn9U.jsx)((0, $l2WWm.default), {
        content: text,
        position: "bottom",
        onShow: onTooltipShown
    }, step) : step);
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$47c9d7f87f5d540e$export$2e2bcd8739ae039 = $47c9d7f87f5d540e$var$BreadcrumbsItem;

});
parcelRegister("q7YhJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $04e89cc3a7066204$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $2MblP = parcelRequire("2MblP");

var $8fGGK = parcelRequire("8fGGK");

var $eiQBT = parcelRequire("eiQBT");
const $04e89cc3a7066204$var$analyticsAttributes = {
    componentName: 'breadcrumbsItem',
    packageName: "@atlaskit/breadcrumbs",
    packageVersion: "12.5.3"
};
const $04e89cc3a7066204$var$noop = (0, $eiQBT.default);
/**
 * __Step__
 *
 * A button that represents a single step in a breadcrumbs component.
 */ const $04e89cc3a7066204$var$Step = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(({ hasOverflow: hasOverflow = true, href: href = '#', onClick: onClickProvided = $04e89cc3a7066204$var$noop, analyticsContext: analyticsContext, iconBefore: iconBefore, iconAfter: iconAfter, ...props }, ref)=>{
    const handleClicked = (0, $2MblP.usePlatformLeafEventHandler)({
        fn: onClickProvided,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$04e89cc3a7066204$var$analyticsAttributes
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fGGK.default), (0, $kU09D.default)({
        appearance: "subtle-link",
        spacing: "none",
        iconAfter: hasOverflow ? undefined : iconAfter,
        iconBefore: hasOverflow ? undefined : iconBefore,
        onClick: handleClicked,
        ref: ref,
        href: href
    }, props));
});
var $04e89cc3a7066204$export$2e2bcd8739ae039 = $04e89cc3a7066204$var$Step;

});

parcelRegister("diIB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9aef8d177aaa219f$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $9aef8d177aaa219f$export$2e2bcd8739ae039(truncationWidth, buttonRefCurrent, iconWidthAllowance) {
    // Default to true to match hasOverflow = true default in Step component.
    // This should ensure the icon never appears and then quickly disappears
    const [hasOverflow, setOverflow] = (0, $eUqFw.useState)(true);
    const [showTooltip, setShowTooltip] = (0, $eUqFw.useState)(false);
    // Need to recalculate on every render cycle as text/icons/width changing will change the outcome
    (0, $eUqFw.useEffect)(()=>{
        if (truncationWidth && buttonRefCurrent) {
            // Calculate if the button width will be larger than the truncation width after allowing for icon widths.
            // The button having a width greater than the truncationWidth, with icons, indicates the icons should be hidden to avoid going over the width limit
            const shouldOverflow = buttonRefCurrent.clientWidth + iconWidthAllowance > truncationWidth;
            // The button width can already be equal to the truncationWidth which is an indicator that truncation is occurring and a tooltip should be displayed
            const shouldShowTooltip = buttonRefCurrent.clientWidth + iconWidthAllowance >= truncationWidth;
            setOverflow(shouldOverflow);
            setShowTooltip(shouldShowTooltip);
        } else {
            setOverflow(false);
            setShowTooltip(false);
        }
    }, [
        truncationWidth,
        buttonRefCurrent,
        iconWidthAllowance
    ]);
    return [
        hasOverflow,
        showTooltip
    ];
}

});


parcelRegister("czBq9", function(module, exports) {

$parcel$export(module.exports, "default", () => $025cbd07e7e167e4$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2MblP = parcelRequire("2MblP");

var $2lroc = parcelRequire("2lroc");

var $eiQBT = parcelRequire("eiQBT");


var $ib6eO = parcelRequire("ib6eO");

var $cIXcq = parcelRequire("cIXcq");
const $025cbd07e7e167e4$var$defaultMaxItems = 8;
const $025cbd07e7e167e4$var$defaultBreadcrumbsLabel = 'Breadcrumbs';
const $025cbd07e7e167e4$var$defaultEllipsisLabel = 'Show more breadcrumbs';
const { toArray: $025cbd07e7e167e4$var$toArray } = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children;
const $025cbd07e7e167e4$var$analyticsAttributes = {
    componentName: 'breadcrumbs',
    packageName: "@atlaskit/breadcrumbs",
    packageVersion: "12.5.3"
};
const $025cbd07e7e167e4$var$noop = (0, $eiQBT.default);
const $025cbd07e7e167e4$var$interactiveElementSelector = 'a, button, [tabindex]:not([tabindex="-1"])';
const $025cbd07e7e167e4$var$breadcrumbStyles = (0, $byn9U.css)({
    display: 'flex',
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    flexWrap: 'wrap'
});
const $025cbd07e7e167e4$var$InnerBreadcrumbs = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { defaultExpanded: defaultExpanded = false, isExpanded: isExpanded, isNavigation: isNavigation = true, maxItems: maxItems = $025cbd07e7e167e4$var$defaultMaxItems, itemsBeforeCollapse: itemsBeforeCollapse = 1, itemsAfterCollapse: itemsAfterCollapse = 1, children: children = [], testId: testId, onExpand: providedExpanse = $025cbd07e7e167e4$var$noop, analyticsContext: analyticsContext, label: label = $025cbd07e7e167e4$var$defaultBreadcrumbsLabel, ellipsisLabel: ellipsisLabel = $025cbd07e7e167e4$var$defaultEllipsisLabel } = props;
    const [expanded, setExpanse] = (0, $eUqFw.useState)(defaultExpanded);
    const [isClickedBySpace, setExpansionTrigger] = (0, $eUqFw.useState)(false);
    const wrapperRef = (0, $eUqFw.useRef)(null);
    const isControlled = typeof isExpanded !== 'undefined';
    const isExpansionHandled = providedExpanse !== $025cbd07e7e167e4$var$noop;
    const shouldExpand = isControlled ? isExpanded : expanded;
    const focusFirstRevealed = ()=>{
        if (wrapperRef.current) {
            const listItems = Array.from(wrapperRef.current.querySelectorAll('li'));
            const interactiveElements = listItems.map((li)=>li.querySelector($025cbd07e7e167e4$var$interactiveElementSelector));
            const elementToFocus = interactiveElements[itemsBeforeCollapse];
            const firstInteractiveElement = interactiveElements[0];
            if (elementToFocus) elementToFocus.focus && elementToFocus.focus();
            else if (firstInteractiveElement) firstInteractiveElement.focus && firstInteractiveElement.focus();
            else wrapperRef.current.focus();
        }
        setExpansionTrigger(false);
    };
    (0, $cIXcq.useOnRevealed)(focusFirstRevealed, {
        isExpanded: shouldExpand,
        isDisabled: !isClickedBySpace
    });
    const handleExpansion = (0, $2MblP.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isControlled) setExpanse((expanded)=>!expanded);
            if (isExpansionHandled && isControlled || !isControlled) setExpansionTrigger(event.target === document.activeElement);
            return providedExpanse(event, analyticsEvent);
        },
        action: 'expanded',
        analyticsData: analyticsContext,
        ...$025cbd07e7e167e4$var$analyticsAttributes
    });
    const childrenArray = $025cbd07e7e167e4$var$toArray(children);
    const breadcrumbsArray = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map(childrenArray, (child, index)=>{
        //To avoid error if child is a string
        if (typeof child === 'string') return child;
        return childrenArray.length - 1 === index ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            'aria-current': 'page'
        }) : child;
    });
    const renderItemsWithEllipsis = ()=>{
        const allItems = breadcrumbsArray;
        // This defends against someone passing weird data, to ensure that if all
        // items would be shown anyway, we just show all items without the EllipsisItem
        if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) return allItems;
        const beforeItems = allItems.slice(0, itemsBeforeCollapse);
        const afterItems = allItems.slice(allItems.length - itemsAfterCollapse, allItems.length);
        return [
            ...beforeItems,
            (0, $byn9U.jsx)((0, $ib6eO.default), {
                key: "ellipsis",
                testId: testId && `${testId}--breadcrumb-ellipsis`,
                onClick: handleExpansion,
                label: ellipsisLabel
            }),
            ...afterItems
        ];
    };
    const shouldDisplayItems = shouldExpand || maxItems && breadcrumbsArray.length <= maxItems;
    const breadcrumbsItems = shouldDisplayItems ? breadcrumbsArray : renderItemsWithEllipsis();
    const Component = isNavigation ? 'nav' : 'div';
    return (0, $byn9U.jsx)(Component, {
        "aria-label": label,
        ref: (0, $2lroc.default)([
            ref,
            wrapperRef
        ]),
        tabIndex: -1
    }, (0, $byn9U.jsx)("ol", {
        "data-testid": testId,
        css: $025cbd07e7e167e4$var$breadcrumbStyles,
        style: {
            color: `var(--ds-text-subtlest, ${(0, $ab6d6432a4c55680$export$f563ee71e9ee74cd)})`
        }
    }, breadcrumbsItems));
});
const $025cbd07e7e167e4$var$Breadcrumbs = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    return (0, $byn9U.jsx)($025cbd07e7e167e4$var$InnerBreadcrumbs, (0, $kU09D.default)({}, props, {
        ref: ref
    }));
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$025cbd07e7e167e4$export$2e2bcd8739ae039 = $025cbd07e7e167e4$var$Breadcrumbs;

});
parcelRegister("ib6eO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3be17c778dffd40$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8fGGK = parcelRequire("8fGGK");

var $eiQBT = parcelRequire("eiQBT");
const $d3be17c778dffd40$var$noop = (0, $eiQBT.default);
const $d3be17c778dffd40$var$itemWrapperStyles = (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box',
    maxWidth: '100%',
    height: `${24 / 14}em`,
    margin: "var(--ds-space-0, 0px)",
    padding: "var(--ds-space-0, 0px)",
    flexDirection: 'row',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:not(:last-child)::after': {
        width: "var(--ds-space-100, 8px)",
        flexShrink: 0,
        content: '"/"',
        paddingBlock: "var(--ds-space-025, 2px)",
        paddingInline: "var(--ds-space-100, 8px)",
        textAlign: 'center'
    }
});
const $d3be17c778dffd40$var$staticItemStyles = (0, $byn9U.css)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    paddingBlock: "var(--ds-space-025, 2px)"
});
const $d3be17c778dffd40$var$EllipsisItem = /*#__PURE__*/ (0, $eUqFw.memo)((props)=>{
    const { onClick: onClick = $d3be17c778dffd40$var$noop, testId: testId, label: label } = props;
    return (0, $byn9U.jsx)("li", {
        css: $d3be17c778dffd40$var$itemWrapperStyles
    }, (0, $byn9U.jsx)((0, $8fGGK.default), {
        appearance: "subtle-link",
        spacing: "none",
        testId: testId,
        onClick: onClick,
        "aria-label": label,
        css: $d3be17c778dffd40$var$staticItemStyles
    }, "\u2026"));
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d3be17c778dffd40$export$2e2bcd8739ae039 = $d3be17c778dffd40$var$EllipsisItem;

});

parcelRegister("cIXcq", function(module, exports) {

$parcel$export(module.exports, "useOnRevealed", () => $943783dc5d440d33$export$e9c4922b2ecf808a);

var $eUqFw = parcelRequire("eUqFw");

var $fUWZn = parcelRequire("fUWZn");
function $943783dc5d440d33$export$e9c4922b2ecf808a(callback, { isExpanded: isExpanded, isDisabled: isDisabled }) {
    const prevExtended = (0, $fUWZn.default)(isExpanded);
    (0, $eUqFw.useEffect)(()=>{
        const hasBeenRevealed = !prevExtended && isExpanded;
        if (!isDisabled && hasBeenRevealed) callback();
    }, [
        isExpanded,
        isDisabled,
        callback,
        prevExtended
    ]);
}

});
parcelRegister("fUWZn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b969d7ef3f14c12d$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $b969d7ef3f14c12d$export$2e2bcd8739ae039(value) {
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
}

});



parcelRegister("ctXof", function(module, exports) {

$parcel$export(module.exports, "default", () => $916643180dbc1abc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
var $916643180dbc1abc$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext({
    clearBreadcrumbItems: ()=>{
    /* do nothing by default */ },
    updateBreadcrumbItems: ()=>{
    /* do nothing by default */ }
});

});


parcelRegister("eEKFN", function(module, exports) {

$parcel$export(module.exports, "default", () => $aab9017073beb6e9$export$2e2bcd8739ae039);

var $bwPfh = parcelRequire("bwPfh");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $ctXof = parcelRequire("ctXof");

var $9WhqC = parcelRequire("9WhqC");

var $lHkHI = parcelRequire("lHkHI");
const $aab9017073beb6e9$var$_excluded = [
    "children"
];
function $aab9017073beb6e9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $aab9017073beb6e9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $aab9017073beb6e9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $aab9017073beb6e9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $aab9017073beb6e9$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>{
            const _this$props = this.props, { children: _children } = _this$props, breadcrumbItemProps = (0, $bwPfh.default)(_this$props, $aab9017073beb6e9$var$_excluded);
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ctXof.default).Consumer, {
                children: (_ref)=>{
                    let { clearBreadcrumbItems: clearBreadcrumbItems, updateBreadcrumbItems: updateBreadcrumbItems } = _ref;
                    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9WhqC.default), $aab9017073beb6e9$var$_objectSpread($aab9017073beb6e9$var$_objectSpread({}, breadcrumbItemProps), {}, {
                        clearBreadcrumbItems: clearBreadcrumbItems,
                        updateBreadcrumbItems: updateBreadcrumbItems,
                        children: _children
                    }));
                }
            });
        });
    }
}

});
parcelRegister("9WhqC", function(module, exports) {

$parcel$export(module.exports, "default", () => $73c70cbd0b3f177a$export$2e2bcd8739ae039);

var $bwPfh = parcelRequire("bwPfh");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $4T13V = parcelRequire("4T13V");

var $ctXof = parcelRequire("ctXof");

var $lHkHI = parcelRequire("lHkHI");
const $73c70cbd0b3f177a$var$_excluded = [
    "children",
    "updateBreadcrumbItems"
];
class $73c70cbd0b3f177a$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "self", null);
        (0, $5zQU9.default)(this, "subBreadcrumbItems", []);
        (0, $5zQU9.default)(this, "clearSubBreadcrumbItems", ()=>{
            this.subBreadcrumbItems = [];
            this.updateParent();
        });
        (0, $5zQU9.default)(this, "updateSubBreadcrumbItems", (subBreadcrumbItems)=>{
            this.subBreadcrumbItems = subBreadcrumbItems;
            this.updateParent();
        });
        (0, $5zQU9.default)(this, "render", ()=>{
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ctXof.default).Provider, {
                value: {
                    clearBreadcrumbItems: this.clearSubBreadcrumbItems,
                    updateBreadcrumbItems: this.updateSubBreadcrumbItems
                },
                children: this.props.children
            });
        });
    }
    componentDidMount() {
        this.updateSelf();
        this.updateParent();
    }
    componentDidUpdate() {
        this.updateSelf();
        this.updateParent();
    }
    componentWillUnmount() {
        this.self = null;
        this.props.clearBreadcrumbItems();
    }
    updateSelf() {
        const _this$props = this.props, { children: children, updateBreadcrumbItems: updateBreadcrumbItems } = _this$props, breadcrumbItemProps = (0, $bwPfh.default)(_this$props, $73c70cbd0b3f177a$var$_excluded);
        this.self = (0, $4T13V.makeBreadcrumbItemData)(breadcrumbItemProps);
    }
    updateParent() {
        if (this.self) this.props.updateBreadcrumbItems([
            this.self,
            ...this.subBreadcrumbItems
        ]);
    }
}

});
parcelRegister("4T13V", function(module, exports) {

$parcel$export(module.exports, "makeBreadcrumbItemData", () => $38ed1f6f72db2995$export$4f0c0a3331686855);

var $g5DHJ = parcelRequire("g5DHJ");
const $38ed1f6f72db2995$export$4f0c0a3331686855 = (0, $g5DHJ.Record)({
    actionSubjectId: '',
    hasSeparator: undefined,
    href: undefined,
    iconBefore: undefined,
    iconAfter: undefined,
    onClick: undefined,
    text: '',
    truncationWidth: undefined,
    target: undefined,
    component: undefined
});

});



parcelRegister("tGPnp", function(module, exports) {

$parcel$export(module.exports, "FluidContainer", () => $0593ee3a4cdba92e$export$a2f482ed96094427);
/* FluidContainer.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $c0qPT = parcelRequire("c0qPT");

var $lHkHI = parcelRequire("lHkHI");
const $0593ee3a4cdba92e$var$_excluded = [
    "as",
    "style"
], $0593ee3a4cdba92e$var$_excluded2 = [
    "as",
    "style"
];
function $0593ee3a4cdba92e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0593ee3a4cdba92e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0593ee3a4cdba92e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0593ee3a4cdba92e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $0593ee3a4cdba92e$export$5f4bb8586a5d0256 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $0593ee3a4cdba92e$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $0593ee3a4cdba92e$var$_objectSpread($0593ee3a4cdba92e$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s81e2i _1letfkly _33c5zdiv _ue5g1408 _1b2sidpf _2dx01jdh _nkieidpf _1yoq1jdh _djbmidpf _17dq31sa _1ohsidpf _106s31sa _10zuidpf _11jr1wug _1mxjidpf _5dk01wug _1t461jt6",
            __cmplp.className
        ])
    }));
});
const $0593ee3a4cdba92e$export$4fdba919e9f26f0a = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $0593ee3a4cdba92e$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $0593ee3a4cdba92e$var$_objectSpread($0593ee3a4cdba92e$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbsz3t _vchhusvi _19pkidpf _2hwx1wug _otyridpf _18u01wug _p12f16ka",
            __cmplp.className
        ])
    }));
});
const $0593ee3a4cdba92e$export$a2f482ed96094427 = (_ref3)=>{
    let { children: children, className: className, style: style } = _ref3;
    const source = (0, $c0qPT.useSource)();
    const Container = source === 'MPAC' ? $0593ee3a4cdba92e$export$5f4bb8586a5d0256 : $0593ee3a4cdba92e$export$4fdba919e9f26f0a;
    const testId = source === 'MPAC' ? 'mpac-fluid-container' : 'emcee-fluid-container';
    return /*#__PURE__*/ (0, $lHkHI.jsx)(Container, {
        "data-testid": testId,
        className: className,
        style: style,
        children: children
    });
};

});

parcelRegister("fQWJT", function(module, exports) {

$parcel$export(module.exports, "foldTarget", () => $b8a946b3b5e6dcbe$export$d9e14dcc29ef09d3);

var $cjFit = parcelRequire("cjFit");

var $ly50n = parcelRequire("ly50n");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $cXi89 = parcelRequire("cXi89");

var $ifMZN = parcelRequire("ifMZN");
const $b8a946b3b5e6dcbe$var$DISCOVER_TARGET = 'DISCOVER';
const $b8a946b3b5e6dcbe$var$MANAGE_TARGET = 'MANAGE';
const $b8a946b3b5e6dcbe$var$INSTALL_TARGET = 'INSTALL';
const $b8a946b3b5e6dcbe$var$TOKEN_TARGET = 'TOKEN';
const $b8a946b3b5e6dcbe$export$1f619cf9eecc77f9 = (0, $g5DHJ.Record)({
    type: $b8a946b3b5e6dcbe$var$DISCOVER_TARGET
});
const $b8a946b3b5e6dcbe$export$237e92f5aca586c7 = (0, $g5DHJ.Record)({
    type: $b8a946b3b5e6dcbe$var$MANAGE_TARGET
});
const $b8a946b3b5e6dcbe$export$2d1cbc8efbe5654f = (0, $g5DHJ.Record)({
    type: $b8a946b3b5e6dcbe$var$INSTALL_TARGET,
    installableAppId: (0, $ifMZN.makeInstallableAppByKeyIdentifier)()
});
const $b8a946b3b5e6dcbe$export$179a4f3dd538d220 = (0, $g5DHJ.Record)({
    type: $b8a946b3b5e6dcbe$var$TOKEN_TARGET,
    tokenName: null
});
function $b8a946b3b5e6dcbe$export$d9e14dcc29ef09d3(target) {
    return function foldTargetInner(discover, manage, install, token) {
        switch(target.type){
            case $b8a946b3b5e6dcbe$var$DISCOVER_TARGET:
                return discover(target);
            case $b8a946b3b5e6dcbe$var$MANAGE_TARGET:
                return manage(target);
            case $b8a946b3b5e6dcbe$var$INSTALL_TARGET:
                return install(target);
            case $b8a946b3b5e6dcbe$var$TOKEN_TARGET:
                return token(target);
            default:
                // Flow compile-time validation that we've handled every discover item
                // prettier-ignore
                target;
                return undefined;
        }
    };
}
const $b8a946b3b5e6dcbe$export$22352873a2c275d6 = (0, $g5DHJ.Record)({
    target: (0, $bWAru.Option).none(),
    relayState: undefined
});
const $b8a946b3b5e6dcbe$var$resolveTargetFromRaw = (rawReceivedParameters)=>(0, $bWAru.Option).of(rawReceivedParameters.target).map((rawTarget)=>rawTarget.toLowerCase().trim()).flatMap((rawTarget)=>{
        switch(rawTarget){
            case 'discover':
                return (0, $bWAru.Option).some($b8a946b3b5e6dcbe$export$1f619cf9eecc77f9());
            case 'manage':
                return (0, $bWAru.Option).some($b8a946b3b5e6dcbe$export$237e92f5aca586c7());
            case 'install':
                return ((0, $cjFit.nonEmptyString)(rawReceivedParameters.app_url) ? (0, $bWAru.Option).of((0, $ifMZN.makeInstallableAppByUrlIdentifier)({
                    url: (0, $cjFit.nonEmptyString)(rawReceivedParameters.app_url)
                })) : (0, $bWAru.Option).of(rawReceivedParameters.key).map((key)=>(0, $ifMZN.makeInstallableAppByKeyIdentifier)({
                        key: (0, $ly50n.makeAppKey)(key)
                    }))).map((installableAppId)=>$b8a946b3b5e6dcbe$export$2d1cbc8efbe5654f({
                        installableAppId: installableAppId
                    }));
            case 'token':
                return (0, $bWAru.Option).some($b8a946b3b5e6dcbe$export$179a4f3dd538d220({
                    tokenName: (0, $cjFit.nonEmptyString)(rawReceivedParameters.tokenName)
                }));
            default:
                return (0, $bWAru.Option).none();
        }
    });
const $b8a946b3b5e6dcbe$export$4c589f678b537755 = (rawReceivedParameters)=>$b8a946b3b5e6dcbe$export$22352873a2c275d6({
        relayState: rawReceivedParameters.relayState ? (0, $cXi89.makeRelayState)(rawReceivedParameters.relayState) : undefined,
        target: $b8a946b3b5e6dcbe$var$resolveTargetFromRaw(rawReceivedParameters)
    });

});
parcelRegister("cXi89", function(module, exports) {

$parcel$export(module.exports, "makeRelayState", () => $96e90f0c069fdae2$export$d91555be7ff8ed3a);
const $96e90f0c069fdae2$export$d91555be7ff8ed3a = (relayState)=>relayState;

});


parcelRegister("bjCXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $83cfb11a576204cf$export$2e2bcd8739ae039);

var $8VfNq = parcelRequire("8VfNq");

var $inwKI = parcelRequire("inwKI");

var $1lmYm = parcelRequire("1lmYm");

var $hvzDU = parcelRequire("hvzDU");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $83cfb11a576204cf$export$fc8c0be6ec095c1b = 'marketplace-maintenance-banner';
function $83cfb11a576204cf$export$2e2bcd8739ae039() {
    const { maintenanceBannerConfiguration: maintenanceBannerConfiguration } = (0, $inwKI.useFeatureFlags)();
    if (!maintenanceBannerConfiguration) return null;
    if ((maintenanceBannerConfiguration === null || maintenanceBannerConfiguration === void 0 ? void 0 : maintenanceBannerConfiguration.type) === (0, $1lmYm.MAINTENANCE_TYPE).NONE || (maintenanceBannerConfiguration === null || maintenanceBannerConfiguration === void 0 ? void 0 : maintenanceBannerConfiguration.targetPages) === (0, $1lmYm.MAINTENANCE_BANNER_TARGET_PAGES).MARKETPLACE_PARTNER_PORTAL) return null;
    let appearance = 'information';
    if ((maintenanceBannerConfiguration === null || maintenanceBannerConfiguration === void 0 ? void 0 : maintenanceBannerConfiguration.type) === (0, $1lmYm.MAINTENANCE_TYPE).WITH_CAPABILITIES_DISRUPTION && (maintenanceBannerConfiguration === null || maintenanceBannerConfiguration === void 0 ? void 0 : maintenanceBannerConfiguration.state) === (0, $1lmYm.MAINTENANCE_STATE).IN_PROGRESS) appearance = 'warning';
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8VfNq.default), {
        appearance: appearance,
        testId: $83cfb11a576204cf$export$fc8c0be6ec095c1b,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hvzDU.default), {
            dangerousHtml: maintenanceBannerConfiguration === null || maintenanceBannerConfiguration === void 0 ? void 0 : maintenanceBannerConfiguration.content,
            extraStyle: {
                fontSize: '14px',
                lineHeight: '20px'
            }
        })
    });
}

});
parcelRegister("hvzDU", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbf0facdd2da4996$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $3UXZ8 = parcelRequire("3UXZ8");

var $hvUUg = parcelRequire("hvUUg");
var $6YChr = parcelRequire("6YChr");

var $kfRpm = parcelRequire("kfRpm");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $cbf0facdd2da4996$var$_excluded = [
    "dangerousHtml",
    "extraStyle"
];
function $cbf0facdd2da4996$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cbf0facdd2da4996$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cbf0facdd2da4996$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cbf0facdd2da4996$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $cbf0facdd2da4996$export$929c06907e214cc8 = (0, $3UXZ8.default)("div", {
    target: "e5n0qpn0",
    label: "ContentDiv"
})((0, $hvUUg.baseMediumFontSize), " line-height:24px;ul{margin-top:5px;li{margin:0 0 5px;}}");
/**
 * @deprecated Use UserGeneratedHtml from "@atlassian/mpac-primitives" instead
 */ const $cbf0facdd2da4996$var$UserGeneratedHtml = (_ref)=>{
    let { dangerousHtml: dangerousHtml, extraStyle: extraStyle } = _ref, otherProps = (0, $bwPfh.default)(_ref, $cbf0facdd2da4996$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6YChr.default), {
        target: "_blank",
        extraStyle: extraStyle,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)($cbf0facdd2da4996$export$929c06907e214cc8, $cbf0facdd2da4996$var$_objectSpread($cbf0facdd2da4996$var$_objectSpread({
            style: extraStyle
        }, otherProps), {}, {
            /* eslint-disable-next-line marketplace-frontend/no-dangerous-html -- This is the common component to be used for all dangerouslySetInnerHTML required cases*/ dangerouslySetInnerHTML: {
                __html: (0, (/*@__PURE__*/$parcel$interopDefault($kfRpm))).sanitize(dangerousHtml)
            }
        }))
    });
};
var $cbf0facdd2da4996$export$2e2bcd8739ae039 = $cbf0facdd2da4996$var$UserGeneratedHtml;

});
parcelRegister("6YChr", function(module, exports) {

$parcel$export(module.exports, "default", () => $51460a5b5163a1dc$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $9rIMC = parcelRequire("9rIMC");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
class $51460a5b5163a1dc$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "linksContainerEle", void 0);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                ref: (linksContainerEle)=>this.linksContainerEle = linksContainerEle,
                style: this.props.extraStyle,
                children: this.props.children
            }));
    }
    componentDidMount() {
        (0, $9rIMC).setTargetForAllLinks(this.linksContainerEle, this.props.target);
    }
    componentDidUpdate() {
        (0, $9rIMC).setTargetForAllLinks(this.linksContainerEle, this.props.target);
    }
}

});

parcelRegister("kfRpm", function(module, exports) {
/*! @license DOMPurify 2.5.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.7/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.7';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});



parcelRegister("m6EiQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0427368d01e8e3d2$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $iOSA9 = parcelRequire("iOSA9");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $0427368d01e8e3d2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0427368d01e8e3d2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0427368d01e8e3d2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0427368d01e8e3d2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}

function $0427368d01e8e3d2$export$2e2bcd8739ae039(_ref) {
    let props = Object.assign({}, ((0, $iOSA9.default)(_ref), _ref));
    const EmceeDevtools = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).lazy(()=>(parcelRequire("WhE2x")));
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eUqFw.Suspense), {
        fallback: "\u2026",
        children: /*#__PURE__*/ (0, $lHkHI.jsx)(EmceeDevtools, $0427368d01e8e3d2$var$_objectSpread({}, props))
    });
}

});
parcelRegister("iOSA9", function(module, exports) {

$parcel$export(module.exports, "default", () => $db373c5bfa918383$export$2e2bcd8739ae039);
function $db373c5bfa918383$export$2e2bcd8739ae039(t) {
    if (null == t) throw new TypeError("Cannot destructure " + t);
}

});

parcelRegister("WhE2x", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("kSUXg")
]).then(()=>parcelRequire('aj04k'));

});


parcelRegister("jwE5W", function(module, exports) {

$parcel$export(module.exports, "withEmceeLinks", () => $e3701b7b04f3e65c$export$2ef813f2257bcab2);
$parcel$export(module.exports, "default", () => $e3701b7b04f3e65c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $c9Mth = parcelRequire("c9Mth");

var $eUqFw = parcelRequire("eUqFw");

var $40nqT = parcelRequire("40nqT");

var $cMIj9 = parcelRequire("cMIj9");

var $bPtM5 = parcelRequire("bPtM5");

var $jHg79 = parcelRequire("jHg79");

var $lHkHI = parcelRequire("lHkHI");
function $e3701b7b04f3e65c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e3701b7b04f3e65c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e3701b7b04f3e65c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e3701b7b04f3e65c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e3701b7b04f3e65c$var$enduserDiscoverPath = '/enduser-discover';
const $e3701b7b04f3e65c$var$adminDiscoverPath = '/discover';
/**
 * Central utility for constructing internal links to Emcee pages from anywhere, to anywhere
 */ const $e3701b7b04f3e65c$var$useEmceeLinks = ()=>{
    const mountPath = (0, $jHg79.useMountPath)();
    const [emceeUrl, setEmceeUrl] = (0, $eUqFw.useState)({
        baseURL: '',
        fullURL: ''
    });
    const resolvePathFromRoute = function resolvePathFromRoute(route, params) {
        let routeMountPath = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
        return (0, $c9Mth).resolveUrlFromTemplateAndParameters({
            template: (0, $c9Mth).transformRoutePathToUriTemplate({
                routePath: (0, $c9Mth).joinPathNames([
                    routeMountPath,
                    route.path
                ])
            }),
            parameters: params
        });
    };
    const resolveRelativePathFromRoute = (route, params)=>resolvePathFromRoute(route, params, mountPath);
    (0, $eUqFw.useEffect)(()=>{
        (0, $cMIj9.getEmceeLocation)((_ref)=>{
            let { baseURL: baseURL, fullURL: fullURL } = _ref;
            return setEmceeUrl({
                baseURL: baseURL,
                fullURL: fullURL
            });
        }, mountPath);
    }, []);
    const isOnEndUserRoute = emceeUrl.fullURL.endsWith($e3701b7b04f3e65c$var$enduserDiscoverPath);
    const discoverPath = isOnEndUserRoute ? $e3701b7b04f3e65c$var$enduserDiscoverPath : $e3701b7b04f3e65c$var$adminDiscoverPath;
    return {
        discoverHome: {
            getRelative: ()=>resolveRelativePathFromRoute((0, $40nqT.discoverRoute)),
            getAbsolute: ()=>(0, $bPtM5.isEmceeConnect)() ? "".concat(emceeUrl.baseURL).concat(discoverPath, "#!").concat(resolvePathFromRoute((0, $40nqT.discoverRoute))) : "".concat(emceeUrl.baseURL).concat(resolvePathFromRoute((0, $40nqT.discoverRoute)))
        },
        search: {
            getRelative: ()=>resolveRelativePathFromRoute((0, $40nqT.searchRoute)),
            getAbsolute: ()=>(0, $bPtM5.isEmceeConnect)() ? "".concat(emceeUrl.baseURL).concat(discoverPath, "#!").concat(resolvePathFromRoute((0, $40nqT.searchRoute))) : "".concat(emceeUrl.baseURL).concat(resolvePathFromRoute((0, $40nqT.searchRoute)))
        },
        appListing: {
            getRelative: (_ref2)=>{
                let { appKey: appKey } = _ref2;
                return resolveRelativePathFromRoute((0, $40nqT.discoverAppDetailsRoute), {
                    appKey: appKey
                });
            },
            getAbsolute: (_ref3)=>{
                let { appKey: appKey } = _ref3;
                return (0, $bPtM5.isEmceeConnect)() ? "".concat(emceeUrl.baseURL).concat(discoverPath, "#!").concat(resolvePathFromRoute((0, $40nqT.discoverAppDetailsRoute), {
                    appKey: appKey
                })) : "".concat(emceeUrl.baseURL).concat(resolvePathFromRoute((0, $40nqT.discoverAppDetailsRoute), {
                    appKey: appKey
                }));
            }
        },
        manageHome: {
            getRelative: ()=>resolveRelativePathFromRoute((0, $40nqT.manageRoute)),
            getAbsolute: ()=>(0, $bPtM5.isEmceeConnect)() ? "".concat(emceeUrl.baseURL, "/discover#!").concat(resolvePathFromRoute((0, $40nqT.manageRoute))) : "".concat(emceeUrl.baseURL).concat(resolvePathFromRoute((0, $40nqT.manageRoute)))
        },
        manageAppDetails: {
            getRelative: (_ref4)=>{
                let { appKey: appKey } = _ref4;
                return resolveRelativePathFromRoute((0, $40nqT.manageAppDetailsRoute), {
                    appKey: appKey
                });
            },
            getAbsolute: (_ref5)=>{
                let { appKey: appKey } = _ref5;
                return (0, $bPtM5.isEmceeConnect)() ? "".concat(emceeUrl.baseURL, "/discover#!").concat(resolvePathFromRoute((0, $40nqT.manageAppDetailsRoute), {
                    appKey: appKey
                })) : "".concat(emceeUrl.baseURL).concat(resolvePathFromRoute((0, $40nqT.manageAppDetailsRoute), {
                    appKey: appKey
                }));
            }
        },
        manageAppRequests: {
            getRelative: ()=>resolveRelativePathFromRoute((0, $40nqT.manageAppRequestsRoute)),
            getAbsolute: ()=>(0, $bPtM5.isEmceeConnect)() ? "".concat(emceeUrl.baseURL, "/app-requests#!").concat(resolvePathFromRoute((0, $40nqT.manageAppRequestsRoute))) : "".concat(emceeUrl.baseURL).concat(resolvePathFromRoute((0, $40nqT.manageAppRequestsRoute)))
        },
        managePromotions: {
            getRelative: ()=>resolveRelativePathFromRoute((0, $40nqT.managePromotionsRoute)),
            getAbsolute: ()=>(0, $bPtM5.isEmceeConnect)() ? "".concat(emceeUrl.baseURL, "/promotions#!").concat(resolvePathFromRoute((0, $40nqT.managePromotionsRoute))) : "".concat(emceeUrl.baseURL).concat(resolvePathFromRoute((0, $40nqT.managePromotionsRoute)))
        }
    };
};
function $e3701b7b04f3e65c$export$2ef813f2257bcab2(BaseComponent) {
    function HOCComponent(props) {
        const links = $e3701b7b04f3e65c$var$useEmceeLinks();
        return /*#__PURE__*/ (0, $lHkHI.jsx)(BaseComponent, $e3701b7b04f3e65c$var$_objectSpread($e3701b7b04f3e65c$var$_objectSpread({}, props), {}, {
            emceeLinks: links
        }));
    }
    return HOCComponent;
}
var $e3701b7b04f3e65c$export$2e2bcd8739ae039 = $e3701b7b04f3e65c$var$useEmceeLinks;

});




parcelRegister("c7npB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8d284c9d243a759f$export$2e2bcd8739ae039);

var $9l6Pq = parcelRequire("9l6Pq");

var $tGPnp = parcelRequire("tGPnp");

var $6LpFI = parcelRequire("6LpFI");
var $4iWU0 = parcelRequire("4iWU0");

var $c9Mth = parcelRequire("c9Mth");

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("jJs3W");
var $6N2vY = parcelRequire("6N2vY");

var $e8LPn = parcelRequire("e8LPn");

var $8bwkw = parcelRequire("8bwkw");

var $40nqT = parcelRequire("40nqT");

var $jC5dB = parcelRequire("jC5dB");

var $jHg79 = parcelRequire("jHg79");

var $86P2q = parcelRequire("86P2q");
var $iGb88 = parcelRequire("iGb88");

var $8au7m = parcelRequire("8au7m");

var $be8uv = parcelRequire("be8uv");

var $lmbZg = parcelRequire("lmbZg");

var $lHkHI = parcelRequire("lHkHI");
function $8d284c9d243a759f$export$2e2bcd8739ae039(props) {
    const mountPath = (0, $jHg79.useMountPath)();
    const dispatch = (0, $6N2vY.useDispatch)();
    const { enableEmceeAetherExperience: enableEmceeAetherExperience } = (0, $9l6Pq.useStatsig)();
    const isAetherExp = enableEmceeAetherExperience();
    return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6LpFI.FlagsImplementationProvider), {
                value: {
                    showFlag: (flag)=>dispatch((0, $8bwkw.addFlag)({
                            flag: (0, $jC5dB.makeEmceeFlag)(flag)
                        })),
                    dismissFlag: (key)=>dispatch((0, $8bwkw.removeFlag)(key))
                },
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $be8uv.default), {
                    bootstrapConfig: props.bootstrapConfig,
                    context: props.selectedContext,
                    hostConfig: props.hostConfig,
                    hostInfo: props.hostInfo,
                    links: props.links,
                    selectedContext: props.selectedContext
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8au7m.default), {
                hostConfig: props.hostConfig
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $iGb88.EmceeInstallationLock), {
                hostConfig: props.hostConfig,
                hostInfo: props.hostInfo,
                children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $e8LPn.default), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4iWU0.RouteWithContext), {
                            path: (0, $c9Mth).joinPathNames([
                                mountPath,
                                (0, $40nqT.discoverRoute).path
                            ]),
                            render: (routeProps)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $86P2q.default), {
                                    algoliaClient: props.algoliaClient,
                                    bootstrapConfig: props.bootstrapConfig,
                                    featureFlags: props.featureFlags,
                                    history: routeProps.history,
                                    hostConfig: props.hostConfig,
                                    links: props.links,
                                    onRendered: props.onRendered,
                                    selectedContext: props.selectedContext,
                                    hostInfo: props.hostInfo
                                })
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4iWU0.RouteWithContext), {
                            path: (0, $c9Mth).joinPathNames([
                                mountPath,
                                (0, $40nqT.manageRoute).path
                            ]),
                            render: (routeProps)=>{
                                const Wrapper = isAetherExp ? (0, $tGPnp.FluidContainer) : (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment;
                                return /*#__PURE__*/ (0, $lHkHI.jsx)(Wrapper, {
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lmbZg.default), {
                                        bootstrapConfig: props.bootstrapConfig,
                                        algoliaClient: props.algoliaClient,
                                        currentUserId: props.currentUserId,
                                        history: routeProps.history,
                                        hostConfig: props.hostConfig,
                                        links: props.links,
                                        onRendered: props.onRendered,
                                        selectedContext: props.selectedContext,
                                        hostInfo: props.hostInfo,
                                        hostPricing: props.hostPricing
                                    })
                                });
                            }
                        })
                    ]
                })
            })
        ]
    });
}

});
parcelRegister("6LpFI", function(module, exports) {

$parcel$export(module.exports, "FlagsImplementationProvider", () => $4ecb0bc6f10c5668$export$26190d5d9037bc62);
$parcel$export(module.exports, "useFlagsImplementation", () => $4ecb0bc6f10c5668$export$91364bd08a3bf2df);

var $eUqFw = parcelRequire("eUqFw");
const $4ecb0bc6f10c5668$var$FlagsImplementationContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
const $4ecb0bc6f10c5668$export$26190d5d9037bc62 = $4ecb0bc6f10c5668$var$FlagsImplementationContext.Provider;
function $4ecb0bc6f10c5668$export$91364bd08a3bf2df() {
    const context = (0, $eUqFw.useContext)($4ecb0bc6f10c5668$var$FlagsImplementationContext);
    if (context === undefined) throw new Error('useFlagsImplementation must be used within a FlagsImplementationProvider');
    return context;
}

});

parcelRegister("86P2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e76795bf36cfa4b$export$2e2bcd8739ae039);
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");

var $i0k4A = parcelRequire("i0k4A");

var $bIPRw = parcelRequire("bIPRw");
const $5e76795bf36cfa4b$var$mapStateToProps = (state)=>({
        locallyInstalledApps: state.installedApps.locallyInstalledApps,
        globallyInstalledApps: state.installedApps.globallyInstalledApps
    });
const $5e76795bf36cfa4b$var$mapDispatchToProps = (dispatch)=>({
        openAppSpecificPasswordDialog: (_ref)=>{
            let { name: name } = _ref;
            return dispatch((0, $i0k4A.doStartAppSpecificPasswordInstallMode)({
                name: name
            }));
        }
    });
var $5e76795bf36cfa4b$export$2e2bcd8739ae039 = (0, $94zHK.default)($5e76795bf36cfa4b$var$mapStateToProps, $5e76795bf36cfa4b$var$mapDispatchToProps)((0, $bIPRw.default));

});
parcelRegister("bIPRw", function(module, exports) {

$parcel$export(module.exports, "default", () => $888c088601fadb79$export$2e2bcd8739ae039);

var $9l6Pq = parcelRequire("9l6Pq");

var $eEKFN = parcelRequire("eEKFN");

var $tGPnp = parcelRequire("tGPnp");

var $5OEFh = parcelRequire("5OEFh");

var $4iWU0 = parcelRequire("4iWU0");

var $c9Mth = parcelRequire("c9Mth");

var $eUqFw = parcelRequire("eUqFw");

var $e8LPn = parcelRequire("e8LPn");

var $7Uh51 = parcelRequire("7Uh51");


var $40nqT = parcelRequire("40nqT");

var $i0SXo = parcelRequire("i0SXo");

var $jHg79 = parcelRequire("jHg79");

var $dQaud = parcelRequire("dQaud");

var $dGXGE = parcelRequire("dGXGE");

var $lHkHI = parcelRequire("lHkHI");
// eslint-disable-next-line max-lines-per-function
const $888c088601fadb79$var$Discover = (props)=>{
    const mountPath = (0, $jHg79.useMountPath)();
    const { enableEmceeAetherExperience: enableEmceeAetherExperience } = (0, $9l6Pq.useStatsig)();
    const resolveDiscoverHref = ()=>(0, $c9Mth).resolveUrlFromTemplateAndParameters({
            template: (0, $c9Mth).transformRoutePathToUriTemplate({
                routePath: (0, $c9Mth).joinPathNames([
                    mountPath,
                    (0, $40nqT.discoverRoute).path
                ])
            })
        });
    const onBreadcrumbsItemClick = (e)=>{
        e.preventDefault();
        props.history.push({
            pathname: resolveDiscoverHref()
        });
    };
    const isAppInstalled = ()=>{
        const installedAppsMap = (0, $i0SXo.default)(props.locallyInstalledApps, props.globallyInstalledApps);
        return (addonKey)=>installedAppsMap.has(addonKey);
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eEKFN.default), {
        actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_DISCOVER),
        onClick: onBreadcrumbsItemClick,
        href: resolveDiscoverHref(),
        text: "Marketplace apps",
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $e8LPn.default), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4iWU0.RouteWithContext), {
                    exact: true,
                    path: (0, $c9Mth).joinPathNames([
                        mountPath,
                        (0, $40nqT.discoverRoute).path
                    ]),
                    render: (routeProps)=>{
                        if (enableEmceeAetherExperience()) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5OEFh.default), {
                            isAppInstalled: isAppInstalled()
                        });
                        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dGXGE.default), {
                            algoliaClient: props.algoliaClient,
                            bootstrapConfig: props.bootstrapConfig,
                            featureFlags: props.featureFlags,
                            history: routeProps.history,
                            hostConfig: props.hostConfig,
                            links: props.links,
                            location: routeProps.location,
                            onRendered: props.onRendered,
                            hostInfo: props.hostInfo,
                            openAppSpecificPasswordDialog: props.openAppSpecificPasswordDialog,
                            perspectiveKey: (0, $583fdbfa91c3ce4b$export$22afc385744fe064),
                            locallyInstalledApps: props.locallyInstalledApps,
                            globallyInstalledApps: props.globallyInstalledApps
                        });
                    }
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4iWU0.RouteWithContext), {
                    exact: true,
                    path: (0, $c9Mth).joinPathNames([
                        mountPath,
                        (0, $40nqT.searchRoute).path
                    ]),
                    render: (routeProps)=>{
                        if (enableEmceeAetherExperience()) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5OEFh.default), {
                            isAppInstalled: isAppInstalled()
                        });
                        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dGXGE.default), {
                            algoliaClient: props.algoliaClient,
                            bootstrapConfig: props.bootstrapConfig,
                            featureFlags: props.featureFlags,
                            history: routeProps.history,
                            hostConfig: props.hostConfig,
                            hostInfo: props.hostInfo,
                            links: props.links,
                            location: routeProps.location,
                            onRendered: props.onRendered,
                            openAppSpecificPasswordDialog: props.openAppSpecificPasswordDialog,
                            perspectiveKey: (0, $583fdbfa91c3ce4b$export$22afc385744fe064),
                            locallyInstalledApps: props.locallyInstalledApps,
                            globallyInstalledApps: props.globallyInstalledApps
                        });
                    }
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4iWU0.RouteWithContext), {
                    exact: true,
                    path: (0, $c9Mth).joinPathNames([
                        mountPath,
                        (0, $40nqT.discoverAppDetailsRoute).path
                    ]),
                    render: (routeProps)=>{
                        const Wrapper = enableEmceeAetherExperience() ? (0, $tGPnp.FluidContainer) : (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment;
                        return /*#__PURE__*/ (0, $lHkHI.jsx)(Wrapper, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dQaud.default), {
                                appKey: routeProps.match.params.appKey,
                                mpacBaseUrl: props.bootstrapConfig.mpacBaseUrl,
                                atlassianCommunityBaseUrl: props.bootstrapConfig.atlassianCommunityBaseUrl,
                                selectedContext: props.selectedContext,
                                links: props.links,
                                history: routeProps.history,
                                location: routeProps.location,
                                onRendered: props.onRendered,
                                featureFlags: props.featureFlags
                            })
                        });
                    }
                })
            ]
        })
    });
};
var $888c088601fadb79$export$2e2bcd8739ae039 = $888c088601fadb79$var$Discover;

});
parcelRegister("5OEFh", function(module, exports) {

$parcel$export(module.exports, "default", () => $43c12a70f11e88d3$export$2e2bcd8739ae039);
/* SearchResultPage.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dT5ry = parcelRequire("dT5ry");
var $8Gr97 = parcelRequire("8Gr97");
var $ap6tQ = parcelRequire("ap6tQ");
var $tGPnp = parcelRequire("tGPnp");
var $eYGD7 = parcelRequire("eYGD7");
var $5rIEI = parcelRequire("5rIEI");

var $fUOHe = parcelRequire("fUOHe");

var $i0EDR = parcelRequire("i0EDR");

var $dM9ZW = parcelRequire("dM9ZW");

var $7lvGB = parcelRequire("7lvGB");
var $c0qPT = parcelRequire("c0qPT");

var $9AuiZ = parcelRequire("9AuiZ");

var $cHuSy = parcelRequire("cHuSy");

var $9zYxS = parcelRequire("9zYxS");
var $ltRHi = parcelRequire("ltRHi");

var $jiZH7 = parcelRequire("jiZH7");

var $1LMe1 = parcelRequire("1LMe1");

var $5kA21 = parcelRequire("5kA21");

var $25eiI = parcelRequire("25eiI");

var $9FaXf = parcelRequire("9FaXf");

var $k5bWu = parcelRequire("k5bWu");

var $g5bjF = parcelRequire("g5bjF");

var $lHkHI = parcelRequire("lHkHI");
const $43c12a70f11e88d3$var$_excluded = [
    "as",
    "style"
], $43c12a70f11e88d3$var$_excluded2 = [
    "as",
    "style"
], $43c12a70f11e88d3$var$_excluded3 = [
    "as",
    "style"
], $43c12a70f11e88d3$var$_excluded4 = [
    "as",
    "style"
], $43c12a70f11e88d3$var$_excluded5 = [
    "as",
    "style"
];
function $43c12a70f11e88d3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $43c12a70f11e88d3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $43c12a70f11e88d3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $43c12a70f11e88d3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $43c12a70f11e88d3$var$SearchPageContainer = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = (0, $tGPnp.FluidContainer), style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $43c12a70f11e88d3$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $43c12a70f11e88d3$var$_objectSpread($43c12a70f11e88d3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt48dri _1e0c1txw _2lx21bp4 _1tke1kw7",
            __cmplp.className
        ])
    }));
});
const $43c12a70f11e88d3$var$SearchPageEMCEEContainer = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = $43c12a70f11e88d3$var$SearchPageContainer, style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $43c12a70f11e88d3$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $43c12a70f11e88d3$var$_objectSpread($43c12a70f11e88d3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt48b2c",
            __cmplp.className
        ])
    }));
});
const $43c12a70f11e88d3$export$9d37679217a8f7f5 = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $43c12a70f11e88d3$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $43c12a70f11e88d3$var$_objectSpread($43c12a70f11e88d3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1tke1kw7 _1yt419si",
            __cmplp.className
        ])
    }));
});
const $43c12a70f11e88d3$var$EmbeddedFilterWrapper = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $43c12a70f11e88d3$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $43c12a70f11e88d3$var$_objectSpread($43c12a70f11e88d3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulp1eps",
            __cmplp.className
        ])
    }));
});
const $43c12a70f11e88d3$var$SearchEmbeddedWrapper = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $43c12a70f11e88d3$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $43c12a70f11e88d3$var$_objectSpread($43c12a70f11e88d3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1k7l _p12f1osq",
            __cmplp.className
        ])
    }));
});
// eslint-disable-next-line max-lines-per-function
const $43c12a70f11e88d3$var$SearchResultPage = (props)=>{
    var _commitOptions$produc, _commitOptions$produc2;
    const [showPageError, setShowPageError] = (0, $eUqFw.useState)(false);
    const { query: query, categories: categories, useCases: useCases } = (0, $dM9ZW.useQueryParams)();
    const searchQuery = query ? Array.isArray(query) ? query[0] : query : '';
    const searchInputRef = (0, $eUqFw.useRef)(null);
    const { handleErrorStateAnalytics: handleErrorStateAnalytics } = (0, $5kA21.useSearchPageAnalytics)();
    const source = (0, $c0qPT.useSource)();
    const appConfig = (0, $c0qPT.useApplicationConfig)();
    const { filterDefinitions: filterDefinitions, additionalFilters: additionalFilters } = (0, $eUqFw.useMemo)(()=>(0, $k5bWu.getOverridesByHostProduct)({
            hostProductId: appConfig === null || appConfig === void 0 ? void 0 : appConfig.hostProductId
        }), [
        appConfig === null || appConfig === void 0 ? void 0 : appConfig.hostProductId
    ]);
    const { allFilterDefinitions: // states
    allFilterDefinitions, filterOptions: filterOptions, selectedOptions: selectedOptions, filterStatus: filterStatus, sortOptions: sortOptions, commitSortKey: commitSortKey, commitOptions: commitOptions, selectedMobileSortOption: selectedMobileSortOption, showAllFilters: // booleans
    showAllFilters, isFiltersFetchPending: isFiltersFetchPending, setShowAllFilters: // set states
    setShowAllFilters, onClearFilter: // functionality
    onClearFilter, onClearAllFilters: onClearAllFilters, onSelectedOptionsChange: onSelectedOptionsChange, onApplyFilters: onApplyFilters, onSelectedSortOptionChange: onSelectedSortOptionChange, onCloseMobileDialog: onCloseMobileDialog, onCommitSortOptionSelect: onCommitSortOptionSelect, handleClearFilters: handleClearFilters } = (0, $1LMe1.useSearchFilters)(filterDefinitions, source);
    const { gridProps: gridProps, analyticsFilters: analyticsFilters } = (0, $9FaXf.useSearchResults)(searchQuery, commitOptions, isFiltersFetchPending, commitSortKey, showPageError, additionalFilters);
    const isSearchQueryActive = !!searchQuery;
    const areFiltersActive = (0, $7lvGB.isOptionSelected)(selectedOptions);
    (0, $25eiI.useSearchPageTelemetry)({
        gridProps: gridProps,
        searchQuery: searchQuery,
        commitOptions: commitOptions,
        commitSortKey: commitSortKey
    });
    (0, $eUqFw.useEffect)(()=>{
        if ((filterStatus.categories === 'error' || filterStatus.useCases === 'error') && (categories || useCases)) setShowPageError(true);
    }, [
        categories,
        filterStatus,
        useCases
    ]);
    (0, $eUqFw.useLayoutEffect)(()=>{
        (0, $fUOHe.default).timeToFirstMeaningfulPaint(performance.now());
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        // HANDLE ANALYTICS
        if (showPageError) handleErrorStateAnalytics({
            actionSubjectId: 'SearchPageErrorRendered',
            errorType: (0, $9AuiZ.ANALYTICS).GLOBAL
        });
    }, [
        showPageError
    ]);
    if (showPageError) return /*#__PURE__*/ (0, $lHkHI.jsx)($43c12a70f11e88d3$export$9d37679217a8f7f5, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5rIEI.PartialOutageError), {
            level: "global"
        })
    });
    const ContainerComponent = source === 'MPAC' ? $43c12a70f11e88d3$var$SearchPageContainer : $43c12a70f11e88d3$var$SearchPageEMCEEContainer;
    const productName = appConfig !== null && appConfig !== void 0 && appConfig.hostProductId ? (0, $i0EDR.CompatibleProductName)[appConfig === null || appConfig === void 0 ? void 0 : appConfig.hostProductId] : undefined;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dT5ry.AetherBenefitsModal), {}),
            /*#__PURE__*/ (0, $lHkHI.jsxs)(ContainerComponent, {
                "data-testid": "".concat(source, "-fluid-container"),
                children: [
                    source === 'MPAC' && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eYGD7.default), {
                                description: (0, $g5bjF.resolveMetaDescription)(commitOptions === null || commitOptions === void 0 ? void 0 : (_commitOptions$produc = commitOptions.product) === null || _commitOptions$produc === void 0 ? void 0 : (_commitOptions$produc2 = _commitOptions$produc[0]) === null || _commitOptions$produc2 === void 0 ? void 0 : _commitOptions$produc2.label, commitSortKey),
                                title: "Search Results"
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9zYxS.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ltRHi.default), {
                        isSearchQueryActive: isSearchQueryActive,
                        areFiltersActive: areFiltersActive,
                        productName: productName
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($43c12a70f11e88d3$var$EmbeddedFilterWrapper, {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)($43c12a70f11e88d3$var$SearchEmbeddedWrapper, {
                                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cHuSy.SearchEmbedded), {
                                    searchInputRef: searchInputRef
                                })
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ap6tQ.Filters), {
                                filterOptions: filterOptions,
                                filterDefinitions: allFilterDefinitions,
                                filterStatus: filterStatus,
                                showAllFilters: showAllFilters,
                                onShowAllFilters: ()=>setShowAllFilters(!showAllFilters),
                                selectedOptions: selectedOptions,
                                onSelectedOptionsChange: onSelectedOptionsChange,
                                sortOptions: sortOptions,
                                selectedSortOption: selectedMobileSortOption,
                                onSelectedSortOptionChange: onSelectedSortOptionChange,
                                onClearFilter: onClearFilter,
                                onClearAllFilters: onClearAllFilters,
                                onApplyFilters: onApplyFilters,
                                onCloseMobileDialog: onCloseMobileDialog
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jiZH7.SearchResults), {
                        searchInputRef: searchInputRef,
                        gridProps: gridProps,
                        isSearchQueryActive: isSearchQueryActive,
                        onSortOptionSelect: onCommitSortOptionSelect,
                        areFiltersActive: areFiltersActive,
                        handleClearAllFilters: handleClearFilters,
                        selectedSortKey: commitSortKey,
                        analyticsFilters: analyticsFilters,
                        isAppInstalled: props.isAppInstalled
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8Gr97.BackToTopButton), {})
                ]
            })
        ]
    });
};
var $43c12a70f11e88d3$export$2e2bcd8739ae039 = $43c12a70f11e88d3$var$SearchResultPage;

});
parcelRegister("dT5ry", function(module, exports) {

$parcel$export(module.exports, "AetherBenefitsModal", () => $a1c4a26397f44e41$export$d73b5a621e9bfcde);

var $jqs1K = parcelRequire("jqs1K");
var $fHOFY = parcelRequire("fHOFY");

var $9l6Pq = parcelRequire("9l6Pq");

var $1Novb = parcelRequire("1Novb");
var $ebb1z = parcelRequire("ebb1z");

var $eUqFw = parcelRequire("eUqFw");

var $cCrLo = parcelRequire("cCrLo");

var $iBbMi = parcelRequire("iBbMi");

var $lHkHI = parcelRequire("lHkHI");
const $a1c4a26397f44e41$export$6da19a24bf249f17 = (_ref)=>{
    let { dismissModalHandler: dismissModalHandler } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jqs1K.default), {
        actions: [
            {
                onClick: dismissModalHandler,
                text: 'Got it'
            }
        ],
        heading: "Say hello to a new Marketplace",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($iBbMi))),
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.BodyNormal), {
            children: "We've improved the discovery of apps for your team with enhanced search and updated app categories. Share your thoughts and help us improve."
        })
    }, "aether-benefits-modal");
};
const $a1c4a26397f44e41$export$d73b5a621e9bfcde = ()=>{
    const [showModal, setShowModal] = (0, $eUqFw.useState)(false);
    const { enableAetherBenefitsModal: enableAetherBenefitsModal } = (0, $9l6Pq.useStatsig)();
    (0, $eUqFw.useEffect)(()=>{
        const isBot = (0, $1Novb).isCrawler(window.navigator.userAgent) || (0, $1Novb).isSynthetic();
        if (enableAetherBenefitsModal() && !isBot && !(0, $ebb1z).getFromStorage('displayed-aether-benefits-modal')) setShowModal(true);
    }, [
        enableAetherBenefitsModal
    ]);
    const dismissModalHandler = ()=>{
        (0, $ebb1z).writeStorage('displayed-aether-benefits-modal', true);
        setShowModal(false);
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fHOFY.default), {
        children: showModal && /*#__PURE__*/ (0, $lHkHI.jsx)($a1c4a26397f44e41$export$6da19a24bf249f17, {
            dismissModalHandler: dismissModalHandler
        })
    });
};

});
parcelRegister("jqs1K", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccd25638347b37ee$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $9L6wX = parcelRequire("9L6wX");
var $8LXOK = parcelRequire("8LXOK");

var $l9NvU = parcelRequire("l9NvU");
var $5o6SH = parcelRequire("5o6SH");
var $icTZO = parcelRequire("icTZO");

var $lELif = parcelRequire("lELif");

var $7WWdd = parcelRequire("7WWdd");
class $ccd25638347b37ee$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    render() {
        const { actions: actions, children: children, heading: heading, ...props } = this.props;
        const Header = this.headerComponent(this.props);
        const Footer = this.footerComponent(this.props);
        const CustomHeader = ()=>{
            const { titleId: titleId } = (0, $icTZO.useModal)();
            return /*#__PURE__*/ (0, $byn9U.jsx)((0, $lELif.ModalHeading), {
                id: titleId
            }, heading);
        };
        return /*#__PURE__*/ (0, $byn9U.jsx)((0, $l9NvU.default), {
            autoFocus: true,
            shouldScrollInViewport: true,
            shouldCloseOnOverlayClick: false,
            shouldCloseOnEscapePress: false,
            ...props
        }, /*#__PURE__*/ (0, $byn9U.jsx)(Header, null), /*#__PURE__*/ (0, $byn9U.jsx)((0, $5o6SH.default), null, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lELif.ModalBody), null, heading && /*#__PURE__*/ (0, $byn9U.jsx)(CustomHeader, null), children)), /*#__PURE__*/ (0, $byn9U.jsx)(Footer, null));
    }
    constructor(...args){
        super(...args);
        this.headerComponent = (props)=>{
            const { header: HeaderElement, image: src } = props;
            const ImageElement = ()=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $lELif.ModalImage), {
                    src: src,
                    alt: ""
                });
            return HeaderElement || ImageElement;
        };
        this.footerComponent = (props)=>{
            const { footer: FooterElement, actions: actionList, experimental_shouldShowPrimaryButtonOnRight: experimental_shouldShowPrimaryButtonOnRight = false } = props;
            const ActionsElement = ()=>actionList ? /*#__PURE__*/ (0, $byn9U.jsx)((0, $8LXOK.default).Provider, {
                    value: (0, $7WWdd.modalButtonTheme)
                }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $lELif.ModalActionContainer), {
                    shouldReverseButtonOrder: experimental_shouldShowPrimaryButtonOnRight
                }, actionList.map(({ text: text, key: key, ...rest }, idx)=>{
                    const variant = idx ? 'subtle-link' : 'primary';
                    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $lELif.ModalActionItem), {
                        key: key || (typeof text === 'string' ? text : `${idx}`)
                    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $9L6wX.default), {
                        appearance: variant,
                        autoFocus: !idx,
                        ...rest
                    }, text));
                }))) : null;
            return FooterElement || ActionsElement;
        };
    }
}

});
parcelRegister("lELif", function(module, exports) {

$parcel$export(module.exports, "ModalBody", () => $b7628333b59e72a1$export$cb540d8b0ef7906c);
$parcel$export(module.exports, "ModalHeading", () => $b7628333b59e72a1$export$9af27c346834c182);
$parcel$export(module.exports, "ModalImage", () => $b7628333b59e72a1$export$1355685fd5f8d257);
$parcel$export(module.exports, "ModalActionContainer", () => $b7628333b59e72a1$export$633dda6b40ac1ac3);
$parcel$export(module.exports, "ModalActionItem", () => $b7628333b59e72a1$export$c245e9f76e3299b1);
/* eslint-disable @atlaskit/design-system/no-nested-styles */ /**
                                                               * @jsxRuntime classic
                                                               * @jsx jsx
                                                               */ 
var $byn9U = parcelRequire("byn9U");

var $9oC7u = parcelRequire("9oC7u");
function $b7628333b59e72a1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b7628333b59e72a1$var$modalBodyStyles = /*#__PURE__*/ (0, $byn9U.css)({
    padding: `${"var(--ds-space-500, 40px)"} ${"var(--ds-space-200, 16px)"}`,
    textAlign: 'center'
});
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-array-arguments -- Ignored via go/DSP-18766
const $b7628333b59e72a1$var$modalHeadingStyles = /*#__PURE__*/ (0, $byn9U.css)([
    /*#__PURE__*/ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    (0, $byn9U.css)((0, $9oC7u.h600)({
        theme: {
            mode: 'light'
        }
    })),
    {
        marginBottom: "var(--ds-space-100, 8px)",
        color: 'inherit'
    }
]);
const $b7628333b59e72a1$var$modalImageStyles = {
    name: "1e6i37z",
    styles: "width:100%;height:auto;border-start-end-radius:var(--ds-border-radius, 3px);border-start-start-radius:var(--ds-border-radius, 3px);@media (min-width: 320px) and (max-width: 480px){border-radius:0;}"
};
const $b7628333b59e72a1$var$modalActionContainerStyles = /*#__PURE__*/ (0, $byn9U.css)({
    display: 'flex',
    padding: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-500, 40px)"} 36px`,
    justifyContent: 'center',
    flexDirection: 'row',
    flexFlow: 'wrap'
});
const $b7628333b59e72a1$var$modalActionContainerReversedStyles = {
    name: "2b8jyz",
    styles: "flex-direction:row-reverse"
};
const $b7628333b59e72a1$var$modalActionItemStyles = /*#__PURE__*/ (0, $byn9U.css)({
    margin: `${"var(--ds-space-0, 0px)"} ${"var(--ds-space-050, 4px)"} ${"var(--ds-space-050, 4px)"}`
});
const $b7628333b59e72a1$export$cb540d8b0ef7906c = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $b7628333b59e72a1$var$modalBodyStyles
    }, children);
const $b7628333b59e72a1$export$9af27c346834c182 = ({ children: children, id: id })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("h1", {
        css: $b7628333b59e72a1$var$modalHeadingStyles,
        id: id
    }, children);
};
const $b7628333b59e72a1$export$1355685fd5f8d257 = ({ alt: alt, src: src })=>/*#__PURE__*/ (0, $byn9U.jsx)("img", {
        css: $b7628333b59e72a1$var$modalImageStyles,
        alt: alt,
        src: src
    });
const $b7628333b59e72a1$export$633dda6b40ac1ac3 = ({ children: children, shouldReverseButtonOrder: shouldReverseButtonOrder })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $b7628333b59e72a1$var$modalActionContainerStyles,
            shouldReverseButtonOrder && $b7628333b59e72a1$var$modalActionContainerReversedStyles
        ]
    }, children);
const $b7628333b59e72a1$export$c245e9f76e3299b1 = ({ children: children })=>/*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: $b7628333b59e72a1$var$modalActionItemStyles
    }, children);

});


parcelRegister("1Novb", function(module, exports) {

$parcel$export(module.exports, "scrollToAndFocusElement", () => $14ed5fa31447868f$export$a70b8101fad7fb86);
$parcel$export(module.exports, "getElementBySelector", () => $14ed5fa31447868f$export$fc78f7611624a0dd);
$parcel$export(module.exports, "scrollToDocumentTop", () => $14ed5fa31447868f$export$db491adce70d3dba);
$parcel$export(module.exports, "scrollWindowToTop", () => $14ed5fa31447868f$export$2ad67cbf64123ce8);
$parcel$export(module.exports, "getQueryParamsFromLocation", () => $14ed5fa31447868f$export$64e10b7795da4eeb);
$parcel$export(module.exports, "isSynthetic", () => $14ed5fa31447868f$export$947749d756ccb0a);
$parcel$export(module.exports, "isCrawler", () => $14ed5fa31447868f$export$6f42a9592782e130);

var $j0gMm = parcelRequire("j0gMm");

var $kt9Cs = parcelRequire("kt9Cs");

var $bTrQR = parcelRequire("bTrQR");
function $14ed5fa31447868f$export$a70b8101fad7fb86(selector) {
    const element = document.querySelector(selector);
    if (!element) {
        (0, $bTrQR.default).warn('scrollToAndFocusElement', 'Could not find element to scroll to with selector: ' + selector);
        return;
    }
    element.scrollIntoView({
        behavior: 'smooth'
    });
    // Web Animations should be supported in all major browsers
    // But older versions might be of concern
    if (!('animate' in element)) return;
    element.animate([
        {
            background: (0, $j0gMm.B50)
        },
        {
            background: 'initial'
        }
    ], {
        duration: 1500,
        delay: 700,
        // allow for the smooth scroll to complete
        iterations: 1,
        easing: 'ease-in'
    });
}
const $14ed5fa31447868f$export$fc78f7611624a0dd = (selector)=>{
    const element = document.querySelector(selector);
    if (!element) {
        (0, $bTrQR.default).warn('getElementBySelector', 'Could not find element to scroll to with selector: ' + selector);
        return;
    }
    return element;
};
const $14ed5fa31447868f$export$db491adce70d3dba = ()=>{
    if (document.body) document.body.scrollTop = 0;
};
const $14ed5fa31447868f$export$2ad67cbf64123ce8 = ()=>{
    window.scrollTo({
        top: 0
    });
};
const $14ed5fa31447868f$export$64e10b7795da4eeb = ()=>{
    return (0, (/*@__PURE__*/$parcel$interopDefault($kt9Cs))).parse(window.location.search || '');
};
const $14ed5fa31447868f$export$947749d756ccb0a = ()=>new URLSearchParams(window.location.search).get('source') === 'pollinator';
const $14ed5fa31447868f$export$6f42a9592782e130 = function isCrawler() {
    let userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return /bot|spider|webscraper|Acunetix|crawl|slurp|curl|wget|^facebook/i.test(userAgent);
};

});

parcelRegister("iBbMi", function(module, exports) {
module.exports = new URL("AetherBenefitsModalHero.f5157d0b.svg", import.meta.url).toString();

});


parcelRegister("8Gr97", function(module, exports) {

$parcel$export(module.exports, "BackToTopButton", () => $65274da45a60c30d$export$ae7fc98dd74dea15);
/* BackToTopButton.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $a576Y = parcelRequire("a576Y");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4DGX0 = parcelRequire("4DGX0");

var $l5PRC = parcelRequire("l5PRC");
var $e2VTq = parcelRequire("e2VTq");

var $eu8X4 = parcelRequire("eu8X4");

var $lHkHI = parcelRequire("lHkHI");
const $65274da45a60c30d$var$_excluded = [
    "as",
    "style"
], $65274da45a60c30d$var$_excluded2 = [
    "as",
    "style"
];
function $65274da45a60c30d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $65274da45a60c30d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $65274da45a60c30d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $65274da45a60c30d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $65274da45a60c30d$var$getScrollParent(node) {
    var _window;
    if (node == null || !(node instanceof Element)) return null;
    let overflowY;
    if ((_window = window) !== null && _window !== void 0 && _window.getComputedStyle) overflowY = window.getComputedStyle(node).overflowY;
    const isScrollable = overflowY === 'auto' || overflowY === 'scroll';
    if (isScrollable && node.scrollHeight > node.clientHeight) return node;
    else return $65274da45a60c30d$var$getScrollParent(node.parentNode);
}
const $65274da45a60c30d$export$260bb228dedc7e4f = (_ref)=>{
    let { backToTopClickHandler: backToTopClickHandler } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsx)($65274da45a60c30d$var$BackToTopWrapper, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eu8X4.Button), {
            onClick: backToTopClickHandler,
            iconAfter: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4DGX0))), {
                label: ""
            }),
            children: "Back to top"
        })
    });
};
const $65274da45a60c30d$var$BackToTopWrapper = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $65274da45a60c30d$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $65274da45a60c30d$var$_objectSpread($65274da45a60c30d$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1n9t _94n51ejb _1xi21ejb _bfhk6ota _16qs12fg _2rko1y44",
            __cmplp.className
        ])
    }));
});
const $65274da45a60c30d$var$TransitionGroupContainer = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $65274da45a60c30d$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $65274da45a60c30d$var$_objectSpread($65274da45a60c30d$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_voz2idpf _1k27kb7n _s1aw1kr1 _1jlakb7n _1qahidpf _1in31kr1",
            __cmplp.className
        ])
    }));
});
let $65274da45a60c30d$var$scrollTimeout;
const $65274da45a60c30d$export$ae7fc98dd74dea15 = ()=>{
    const [showBackToTopBtn, setShowBackToTopBtn] = (0, $eUqFw.useState)(false);
    const prevScrollPosRef = (0, $eUqFw.useRef)(0);
    const scrollParentRef = (0, $eUqFw.useRef)(null);
    const componentRef = (0, $eUqFw.useRef)(null);
    const handleScroll = (0, $eUqFw.useCallback)(()=>{
        const scrollParent = scrollParentRef.current;
        if (!scrollParent) return;
        const currScrollPos = scrollParent.scrollTop;
        const prevScrollPos = prevScrollPosRef.current;
        prevScrollPosRef.current = currScrollPos;
        const isScrollingUp = currScrollPos < prevScrollPos;
        const isScrollWithinThreshold = currScrollPos < window.innerHeight * 4;
        const isScrollInFirstFold = currScrollPos === 0;
        if (!showBackToTopBtn && !isScrollWithinThreshold && isScrollingUp) setShowBackToTopBtn(true);
        else if (showBackToTopBtn && (!isScrollingUp || isScrollInFirstFold)) setShowBackToTopBtn(false);
        hideAfterTimeout(isScrollingUp);
    }, [
        showBackToTopBtn
    ]);
    const hideAfterTimeout = (isScrollingUp)=>{
        clearTimeout($65274da45a60c30d$var$scrollTimeout);
        if (isScrollingUp) $65274da45a60c30d$var$scrollTimeout = setTimeout(()=>{
            setShowBackToTopBtn(false);
        }, 7000);
    };
    (0, $eUqFw.useEffect)(()=>{
        const node = componentRef.current;
        const scrollParent = $65274da45a60c30d$var$getScrollParent(node);
        scrollParentRef.current = scrollParent;
        if (scrollParent) {
            const throttledHandleScroll = (0, (/*@__PURE__*/$parcel$interopDefault($a576Y)))(handleScroll, 500);
            scrollParent.addEventListener('scroll', throttledHandleScroll);
            return ()=>{
                clearTimeout($65274da45a60c30d$var$scrollTimeout);
                scrollParent.removeEventListener('scroll', throttledHandleScroll);
            };
        }
    }, [
        handleScroll
    ]);
    const backToTopClickHandler = ()=>{
        const scrollParent = scrollParentRef.current;
        if (scrollParent) scrollParent.scrollTo({
            left: 0,
            top: 0,
            behavior: 'smooth'
        });
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
        ref: componentRef,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)($65274da45a60c30d$var$TransitionGroupContainer, {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $e2VTq.default), {
                children: showBackToTopBtn && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l5PRC.default), {
                    classNames: {
                        appear: 'backToTopButtonFadeIn',
                        appearActive: 'backToTopButtonFadeInActive',
                        enter: 'backToTopButtonFadeIn',
                        enterActive: 'backToTopButtonFadeInActive',
                        exit: 'backToTopButtonFadeOut',
                        exitActive: 'backToTopButtonFadeOutActive'
                    },
                    appear: true,
                    exit: true,
                    timeout: 500,
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)($65274da45a60c30d$export$260bb228dedc7e4f, {
                        backToTopClickHandler: backToTopClickHandler
                    })
                })
            })
        })
    });
};

});
parcelRegister("4DGX0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $360c1f14cb1fa34f$var$_react = $360c1f14cb1fa34f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $360c1f14cb1fa34f$var$_arrowUp = $360c1f14cb1fa34f$var$_interopRequireDefault((parcelRequire("biWso")));
function $360c1f14cb1fa34f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $360c1f14cb1fa34f$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $360c1f14cb1fa34f$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m11.293 5.293-5.5 5.499a1 1 0 0 0 0 1.415 1 1 0 0 0 1.414 0L11 8.414V18a1 1 0 0 0 2 0V8.414l3.793 3.793a1 1 0 1 0 1.414-1.415l-5.5-5.499A1 1 0 0 0 12 5a1 1 0 0 0-.707.293"/></svg>`
    }, props, {
        newIcon: $360c1f14cb1fa34f$var$_arrowUp.default
    }));
$360c1f14cb1fa34f$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $360c1f14cb1fa34f$var$_default = module.exports.default = $360c1f14cb1fa34f$var$ArrowUpIcon;

});
parcelRegister("biWso", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f57cdfdfff00f4122214ded49823394f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83aeb88019a6fb0b$var$_react = $83aeb88019a6fb0b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $83aeb88019a6fb0b$var$_UNSAFE_baseNew = $83aeb88019a6fb0b$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $83aeb88019a6fb0b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: back to top.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83aeb88019a6fb0b$var$ArrowUpIcon = (props)=>/*#__PURE__*/ $83aeb88019a6fb0b$var$_react.default.createElement($83aeb88019a6fb0b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M8 15V2.25m-5 4.5 5-5 5 5"/>`
    }, props));
$83aeb88019a6fb0b$var$ArrowUpIcon.displayName = 'ArrowUpIcon';
var $83aeb88019a6fb0b$var$_default = module.exports.default = $83aeb88019a6fb0b$var$ArrowUpIcon;

});



parcelRegister("ap6tQ", function(module, exports) {

$parcel$export(module.exports, "Filters", () => $7931440862f83cbf$export$92a576f896a9bf72);

var $379fO = parcelRequire("379fO");
var $d4qUE = parcelRequire("d4qUE");

var $kBUpw = parcelRequire("kBUpw");
parcelRequire("eUqFw");

var $3DYxj = parcelRequire("3DYxj");

var $b3jCJ = parcelRequire("b3jCJ");

var $bvXdy = parcelRequire("bvXdy");

var $lHkHI = parcelRequire("lHkHI");
const $7931440862f83cbf$var$wrapperStyles = (0, $d4qUE.xcss)((0, $3DYxj.charlieTextFontFamily));
const $7931440862f83cbf$export$92a576f896a9bf72 = (_ref)=>{
    let { filterOptions: filterOptions, filterDefinitions: filterDefinitions, filterStatus: filterStatus = {}, selectedOptions: selectedOptions = {}, selectedSortOption: selectedSortOption, showAllFilters: showAllFilters = false, sortOptions: sortOptions, onClearFilter: onClearFilter, onClearAllFilters: onClearAllFilters, onShowAllFilters: onShowAllFilters, onSelectedOptionsChange: onSelectedOptionsChange, onSelectedSortOptionChange: onSelectedSortOptionChange, onApplyFilters: onApplyFilters, onCloseMobileDialog: onCloseMobileDialog } = _ref;
    if (!filterDefinitions.length) return null;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $379fO.default), {
        xcss: $7931440862f83cbf$var$wrapperStyles,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kBUpw.Show), {
                below: "sm",
                as: "span",
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bvXdy.MobileFilters), {
                    filterDefinitions: filterDefinitions,
                    filterOptions: filterOptions,
                    selectedOptions: selectedOptions,
                    sortOptions: sortOptions,
                    selectedSortOption: selectedSortOption,
                    filterStatus: filterStatus,
                    onClearAllFilters: onClearAllFilters,
                    onSelectedOptionsChange: onSelectedOptionsChange,
                    onSelectedSortOptionChange: onSelectedSortOptionChange,
                    onApplyFilters: onApplyFilters,
                    onCloseMobileDialog: onCloseMobileDialog
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kBUpw.Show), {
                above: "sm",
                as: "span",
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $b3jCJ.DesktopFilters), {
                    filterDefinitions: filterDefinitions,
                    filterOptions: filterOptions,
                    filterStatus: filterStatus,
                    selectedOptions: selectedOptions,
                    onClearFilter: onClearFilter,
                    onClearAllFilters: onClearAllFilters,
                    onSelectedOptionsChange: onSelectedOptionsChange,
                    showAllFilters: showAllFilters,
                    onShowAllFilters: onShowAllFilters
                })
            })
        ]
    });
};

});
parcelRegister("379fO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2449343452db694b$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $g35uP = parcelRequire("g35uP");

var $d4qUE = parcelRequire("d4qUE");

var $YfW8q = parcelRequire("YfW8q");
const $2449343452db694b$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const Component = as;
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const className = xcss && (0, $d4qUE.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $byn9U.jsx)(Component, (0, $kU09D.default)({
        style: style,
        ref: ref
    }, safeHtmlAttributes, {
        css: [
            $2449343452db694b$var$baseStyles,
            backgroundColor && (0, $g35uP.backgroundColorStylesMap)[backgroundColor],
            (0, $g35uP.isSurfaceColorToken)(backgroundColor) && (0, $g35uP.surfaceColorStylesMap)[backgroundColor],
            padding && (0, $g35uP.paddingStylesMap).padding[padding],
            paddingBlock && (0, $g35uP.paddingStylesMap).paddingBlock[paddingBlock],
            paddingBlockStart && (0, $g35uP.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            paddingBlockEnd && (0, $g35uP.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            paddingInline && (0, $g35uP.paddingStylesMap).paddingInline[paddingInline],
            paddingInlineStart && (0, $g35uP.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            paddingInlineEnd && (0, $g35uP.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            className
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $byn9U.jsx)((0, $YfW8q.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $2449343452db694b$export$2e2bcd8739ae039 = $2449343452db694b$export$e71c4d32a2263218;
const $2449343452db694b$var$baseStyles = (0, $byn9U.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("g35uP", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", () => $baf130922324c09a$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $baf130922324c09a$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $baf130922324c09a$export$632685d741f3dbbf);
$parcel$export(module.exports, "inverseColorMap", () => $baf130922324c09a$export$2185ce37f9bdd963);
$parcel$export(module.exports, "opacityMap", () => $baf130922324c09a$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $baf130922324c09a$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $baf130922324c09a$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $baf130922324c09a$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $baf130922324c09a$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $baf130922324c09a$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $baf130922324c09a$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $baf130922324c09a$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "paddingStylesMap", () => $baf130922324c09a$export$e615f061ca585a6c);
$parcel$export(module.exports, "spaceStylesMap", () => $baf130922324c09a$export$bf46c3f9eeafc71f);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $baf130922324c09a$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "textColorStylesMap", () => $baf130922324c09a$export$3a1bcba60b23d7f0);
$parcel$export(module.exports, "fontWeightStylesMap", () => $baf130922324c09a$export$45f3f4fe16f9f7d5);
$parcel$export(module.exports, "bodyTextStylesMap", () => $baf130922324c09a$export$a1962444bbf058e);
$parcel$export(module.exports, "uiTextStylesMap", () => $baf130922324c09a$export$ca3e246f24657bd6);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $baf130922324c09a$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $baf130922324c09a$export$5e65a44e5b6ecadb);

var $byn9U = parcelRequire("byn9U");

var $axYky = parcelRequire("axYky");
const $baf130922324c09a$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $baf130922324c09a$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $baf130922324c09a$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $baf130922324c09a$export$632685d741f3dbbf = {
    ...$baf130922324c09a$export$958d0ae7f2977ae4,
    ...$baf130922324c09a$export$d2dc61f58390201c
};
const $baf130922324c09a$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $baf130922324c09a$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $baf130922324c09a$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
const $baf130922324c09a$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
const $baf130922324c09a$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
const $baf130922324c09a$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $baf130922324c09a$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)"
};
const $baf130922324c09a$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
const $baf130922324c09a$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $baf130922324c09a$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
const $baf130922324c09a$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
const $baf130922324c09a$export$6cc560b4dedf3816 = {
    'font.size.050': "var(--ds-font-size-050, 11px)",
    'font.size.075': "var(--ds-font-size-075, 12px)",
    'font.size.100': "var(--ds-font-size-100, 14px)",
    'font.size.200': "var(--ds-font-size-200, 16px)",
    'font.size.300': "var(--ds-font-size-300, 20px)",
    'font.size.400': "var(--ds-font-size-400, 24px)",
    'font.size.500': "var(--ds-font-size-500, 29px)",
    'font.size.600': "var(--ds-font-size-600, 35px)"
};
const $baf130922324c09a$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $baf130922324c09a$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand': "var(--ds-font-family-brand, Charlie Sans)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.monospace': "var(--ds-font-family-monospace, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.sans': "var(--ds-font-family-sans, -apple-system, BlinkMacSystemFont, \"Segoe UI\", \"Roboto\", \"Oxygen\", \"Ubuntu\", \"Fira Sans\", \"Droid Sans\", \"Helvetica Neue\", sans-serif)"
};
const $baf130922324c09a$export$360c29a380c1a34 = {
    'font.lineHeight.1': "var(--ds-font-lineHeight-1, 1)",
    'font.lineHeight.100': "var(--ds-font-lineHeight-100, 16px)",
    'font.lineHeight.200': "var(--ds-font-lineHeight-200, 20px)",
    'font.lineHeight.300': "var(--ds-font-lineHeight-300, 24px)",
    'font.lineHeight.400': "var(--ds-font-lineHeight-400, 28px)",
    'font.lineHeight.500': "var(--ds-font-lineHeight-500, 32px)",
    'font.lineHeight.600': "var(--ds-font-lineHeight-600, 40px)"
};
const $baf130922324c09a$export$b5bac06d7d8fd0d1 = {
    body: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'body.large': "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'body.small': "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $baf130922324c09a$export$b27166c9cf2c9f74 = {
    ui: "var(--ds-font-ui, normal 500 14px/1 ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'ui.small': "var(--ds-font-ui-small, normal 400 11px/1 ui-sans-serif, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Generate maps for Box props. backgroundColor, padding, etc
const $baf130922324c09a$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $baf130922324c09a$var$getSerializedStylesMap = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        emotionSpacingMap[token] = (0, $byn9U.css)({
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $baf130922324c09a$export$e615f061ca585a6c = $baf130922324c09a$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $baf130922324c09a$var$getSerializedStylesMap(spacingProperty, $baf130922324c09a$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $baf130922324c09a$export$bf46c3f9eeafc71f = $baf130922324c09a$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $baf130922324c09a$var$getSerializedStylesMap(spacingProperty, $baf130922324c09a$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $baf130922324c09a$export$e7af83bafe7f9e63 = $baf130922324c09a$var$getSerializedStylesMap('backgroundColor', $baf130922324c09a$export$d1d79bf68ac056bd);
const $baf130922324c09a$export$3a1bcba60b23d7f0 = $baf130922324c09a$var$getSerializedStylesMap('color', $baf130922324c09a$export$8473307aa00d6ea1);
const $baf130922324c09a$export$f7183c9e2dbc2543 = $baf130922324c09a$var$getSerializedStylesMap('fontSize', $baf130922324c09a$export$6cc560b4dedf3816);
const $baf130922324c09a$export$45f3f4fe16f9f7d5 = $baf130922324c09a$var$getSerializedStylesMap('fontWeight', $baf130922324c09a$export$303e322c6b1ed114);
const $baf130922324c09a$export$68cc305da27dbaa4 = $baf130922324c09a$var$getSerializedStylesMap('fontFamily', $baf130922324c09a$export$3c7e9587132614b4);
const $baf130922324c09a$export$8be4a21014f48eb1 = $baf130922324c09a$var$getSerializedStylesMap('lineHeight', $baf130922324c09a$export$360c29a380c1a34);
const $baf130922324c09a$export$a1962444bbf058e = $baf130922324c09a$var$getSerializedStylesMap('font', $baf130922324c09a$export$b5bac06d7d8fd0d1);
const $baf130922324c09a$export$ca3e246f24657bd6 = $baf130922324c09a$var$getSerializedStylesMap('font', $baf130922324c09a$export$b27166c9cf2c9f74);
const $baf130922324c09a$export$ff257d957d48c421 = $baf130922324c09a$var$getSerializedStylesMap((0, $axYky.CURRENT_SURFACE_CSS_VAR), $baf130922324c09a$export$41a358c9c2356760);
const $baf130922324c09a$export$5e65a44e5b6ecadb = (color)=>$baf130922324c09a$export$41a358c9c2356760[color] !== undefined;

});

parcelRegister("d4qUE", function(module, exports) {

$parcel$export(module.exports, "parseXcss", () => $9840866a5e434d98$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $9840866a5e434d98$export$f6c783d06584602c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ 
var $byn9U = parcelRequire("byn9U");

var $g35uP = parcelRequire("g35uP");

var $2fFJv = parcelRequire("2fFJv");
const $9840866a5e434d98$export$9a199fbafee0014e = {
    backgroundColor: (0, $g35uP.backgroundColorMap),
    blockSize: (0, $g35uP.dimensionMap),
    borderBlockColor: (0, $g35uP.borderColorMap),
    borderBlockEndColor: (0, $g35uP.borderColorMap),
    borderBlockEndWidth: (0, $g35uP.borderWidthMap),
    borderBlockStartColor: (0, $g35uP.borderColorMap),
    borderBlockStartWidth: (0, $g35uP.borderWidthMap),
    borderBlockWidth: (0, $g35uP.borderWidthMap),
    borderBottomColor: (0, $g35uP.borderColorMap),
    borderBottomLeftRadius: (0, $g35uP.borderRadiusMap),
    borderBottomRightRadius: (0, $g35uP.borderRadiusMap),
    borderBottomWidth: (0, $g35uP.borderWidthMap),
    borderColor: (0, $g35uP.borderColorMap),
    borderEndEndRadius: (0, $g35uP.borderRadiusMap),
    borderEndStartRadius: (0, $g35uP.borderRadiusMap),
    borderInlineColor: (0, $g35uP.borderColorMap),
    borderInlineEndColor: (0, $g35uP.borderColorMap),
    borderInlineEndWidth: (0, $g35uP.borderWidthMap),
    borderInlineStartColor: (0, $g35uP.borderColorMap),
    borderInlineStartWidth: (0, $g35uP.borderWidthMap),
    borderInlineWidth: (0, $g35uP.borderWidthMap),
    borderLeftColor: (0, $g35uP.borderColorMap),
    borderLeftWidth: (0, $g35uP.borderWidthMap),
    borderRadius: (0, $g35uP.borderRadiusMap),
    borderRightColor: (0, $g35uP.borderColorMap),
    borderRightWidth: (0, $g35uP.borderWidthMap),
    borderStartEndRadius: (0, $g35uP.borderRadiusMap),
    borderStartStartRadius: (0, $g35uP.borderRadiusMap),
    borderTopColor: (0, $g35uP.borderColorMap),
    borderTopLeftRadius: (0, $g35uP.borderRadiusMap),
    borderTopRightRadius: (0, $g35uP.borderRadiusMap),
    borderTopWidth: (0, $g35uP.borderWidthMap),
    borderWidth: (0, $g35uP.borderWidthMap),
    bottom: (0, $g35uP.allSpaceMap),
    boxShadow: (0, $g35uP.shadowMap),
    color: (0, $g35uP.textColorMap),
    columnGap: (0, $g35uP.positiveSpaceMap),
    gap: (0, $g35uP.positiveSpaceMap),
    height: (0, $g35uP.dimensionMap),
    inlineSize: (0, $g35uP.dimensionMap),
    inset: (0, $g35uP.allSpaceMap),
    insetBlock: (0, $g35uP.allSpaceMap),
    insetBlockEnd: (0, $g35uP.allSpaceMap),
    insetBlockStart: (0, $g35uP.allSpaceMap),
    insetInline: (0, $g35uP.allSpaceMap),
    insetInlineEnd: (0, $g35uP.allSpaceMap),
    insetInlineStart: (0, $g35uP.allSpaceMap),
    left: (0, $g35uP.allSpaceMap),
    margin: (0, $g35uP.allSpaceMap),
    marginBlock: (0, $g35uP.allSpaceMap),
    marginBlockEnd: (0, $g35uP.allSpaceMap),
    marginBlockStart: (0, $g35uP.allSpaceMap),
    marginBottom: (0, $g35uP.allSpaceMap),
    marginInline: (0, $g35uP.allSpaceMap),
    marginInlineEnd: (0, $g35uP.allSpaceMap),
    marginInlineStart: (0, $g35uP.allSpaceMap),
    marginLeft: (0, $g35uP.allSpaceMap),
    marginRight: (0, $g35uP.allSpaceMap),
    marginTop: (0, $g35uP.allSpaceMap),
    maxBlockSize: (0, $g35uP.dimensionMap),
    maxHeight: (0, $g35uP.dimensionMap),
    maxInlineSize: (0, $g35uP.dimensionMap),
    maxWidth: (0, $g35uP.dimensionMap),
    minBlockSize: (0, $g35uP.dimensionMap),
    minHeight: (0, $g35uP.dimensionMap),
    minInlineSize: (0, $g35uP.dimensionMap),
    minWidth: (0, $g35uP.dimensionMap),
    opacity: (0, $g35uP.opacityMap),
    outlineColor: (0, $g35uP.borderColorMap),
    outlineOffset: (0, $g35uP.positiveSpaceMap),
    outlineWidth: (0, $g35uP.borderWidthMap),
    padding: (0, $g35uP.positiveSpaceMap),
    paddingBlock: (0, $g35uP.positiveSpaceMap),
    paddingBlockEnd: (0, $g35uP.positiveSpaceMap),
    paddingBlockStart: (0, $g35uP.positiveSpaceMap),
    paddingBottom: (0, $g35uP.positiveSpaceMap),
    paddingInline: (0, $g35uP.positiveSpaceMap),
    paddingInlineEnd: (0, $g35uP.positiveSpaceMap),
    paddingInlineStart: (0, $g35uP.positiveSpaceMap),
    paddingLeft: (0, $g35uP.positiveSpaceMap),
    paddingRight: (0, $g35uP.positiveSpaceMap),
    paddingTop: (0, $g35uP.positiveSpaceMap),
    right: (0, $g35uP.allSpaceMap),
    rowGap: (0, $g35uP.positiveSpaceMap),
    top: (0, $g35uP.allSpaceMap),
    width: (0, $g35uP.dimensionMap),
    zIndex: (0, $g35uP.layerMap)
};
const $9840866a5e434d98$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $9840866a5e434d98$var$isSafeEnvToThrow = ()=>typeof $2fFJv === 'object' && typeof $2fFJv.env === 'object' && false;
const $9840866a5e434d98$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $9840866a5e434d98$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $9840866a5e434d98$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($9840866a5e434d98$var$transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $9840866a5e434d98$var$safeSelectors.test(key)) {
            styleObj[key] = $9840866a5e434d98$var$transformStyles(value);
            return;
        }
        if ($9840866a5e434d98$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($9840866a5e434d98$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $9840866a5e434d98$export$9a199fbafee0014e)) return;
        const tokenValue = $9840866a5e434d98$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
const $9840866a5e434d98$var$baseXcss = (style)=>{
    const transformedStyles = $9840866a5e434d98$var$transformStyles(style);
    return {
        [$9840866a5e434d98$var$uniqueSymbol]: (0, $byn9U.css)(transformedStyles)
    };
};
const $9840866a5e434d98$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) return args.map((x)=>x && $9840866a5e434d98$export$a9c84988c8f81f2d(x)).filter(Boolean);
    const { [$9840866a5e434d98$var$uniqueSymbol]: styles } = args;
    typeof $2fFJv;
    return styles;
};
function $9840866a5e434d98$export$f6c783d06584602c(style) {
    return $9840866a5e434d98$var$baseXcss(style);
}

});

parcelRegister("YfW8q", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", () => $0b51f76679a8e589$export$1ca2a26fecb070ae);
$parcel$export(module.exports, "useSurface", () => $0b51f76679a8e589$export$1aeb4f6b93c4540d);

var $eUqFw = parcelRequire("eUqFw");
const $0b51f76679a8e589$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $eUqFw.createContext)('elevation.surface');
const $0b51f76679a8e589$export$1aeb4f6b93c4540d = ()=>{
    return (0, $eUqFw.useContext)($0b51f76679a8e589$export$1ca2a26fecb070ae);
};
$0b51f76679a8e589$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});


parcelRegister("kBUpw", function(module, exports) {

$parcel$export(module.exports, "Show", () => $f01305541cbcc9ff$export$f6a3d19be20f5819);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $aokGA = parcelRequire("aokGA");
const $f01305541cbcc9ff$var$showAboveQueries = (0, $aokGA.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'revert'
});
const $f01305541cbcc9ff$var$showBelowQueries = (0, $aokGA.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'revert'
});
const $f01305541cbcc9ff$var$defaultHiddenStyles = (0, $byn9U.css)({
    display: 'none'
});
const $f01305541cbcc9ff$export$f6a3d19be20f5819 = ({ above: above, below: below, children: children, as: AsElement = 'div' })=>{
    return (0, $byn9U.jsx)(AsElement, {
        css: [
            $f01305541cbcc9ff$var$defaultHiddenStyles,
            above && $f01305541cbcc9ff$var$showAboveQueries[above],
            below && $f01305541cbcc9ff$var$showBelowQueries[below]
        ]
    }, children);
};

});
parcelRegister("aokGA", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_buildAboveMediaQueryCSS", () => $790c310db9873a98$export$918f8818cfbbeb2c);
$parcel$export(module.exports, "UNSAFE_buildBelowMediaQueryCSS", () => $790c310db9873a98$export$b2a4e2b0c6417297);

var $byn9U = parcelRequire("byn9U");

var $iVK5n = parcelRequire("iVK5n");

var $8oBYp = parcelRequire("8oBYp");
const $790c310db9873a98$export$918f8818cfbbeb2c = (input)=>{
    return (0, $iVK5n.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>({
            ...acc,
            [breakpoint]: (0, $byn9U.css)({
                [(0, $8oBYp.media).above[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        }), {});
};
const $790c310db9873a98$export$b2a4e2b0c6417297 = (input)=>{
    return (0, $iVK5n.UNSAFE_BREAKPOINTS_ORDERED_LIST).reduce((acc, breakpoint)=>{
        if (breakpoint === 'xxs') return acc;
        return {
            ...acc,
            [breakpoint]: (0, $byn9U.css)({
                // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                [(0, $8oBYp.UNSAFE_media).below[breakpoint]]: typeof input === 'function' ? input(breakpoint) : input
            })
        };
    }, {});
};

});
parcelRegister("iVK5n", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_BREAKPOINTS_ORDERED_LIST", () => $dc814c86c76c6737$export$2d293d9871c38e91);
/**
 * Our internal configuration for breakpoints configuration.
 *
 * We explicitly use `-0.01rem` for "max" values to both ensure we do not overlap our media queries, but also don't skip any fractional pixels.  There is a chance this is not safe in some browsers, eg. Safari has weird rounding.
 * @see: https://tzi.fr/css/prevent-double-breakpoint/
 *
 * @experimental Unsafe for direct consumption outside of the design system itself; please use our `media` export instead for media queries.
 */ const $dc814c86c76c6737$export$e5ee4fe8b989fd09 = {
    // mobile
    xxs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '0rem',
        max: '29.99rem'
    },
    // phablet
    xs: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-200, 16px)",
        min: '30rem',
        max: '47.99rem'
    },
    // tablet
    sm: {
        gridItemGutter: "var(--ds-space-200, 16px)",
        gridMargin: "var(--ds-space-300, 24px)",
        min: '48rem',
        max: '63.99rem'
    },
    // laptop desktop
    md: {
        gridItemGutter: "var(--ds-space-300, 24px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '64rem',
        max: '89.99rem'
    },
    // monitor
    lg: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-400, 32px)",
        min: '90rem',
        max: '109.99rem'
    },
    // large high res
    xl: {
        gridItemGutter: "var(--ds-space-400, 32px)",
        gridMargin: "var(--ds-space-500, 40px)",
        min: '110rem',
        max: null
    }
}; //TODO: This `as const` should really be `satisfies Record<Breakpoint, BreakpointConfig>`, but that's not possible in our shipped TypeScript version yet.
const $dc814c86c76c6737$export$2d293d9871c38e91 = Object.keys($dc814c86c76c6737$export$e5ee4fe8b989fd09);
const $dc814c86c76c6737$export$b7ed752a57b4177b = $dc814c86c76c6737$export$2d293d9871c38e91[0];

});

parcelRegister("8oBYp", function(module, exports) {

$parcel$export(module.exports, "media", () => $61ce05535b72c208$export$987d49ffe1b0900f);
$parcel$export(module.exports, "UNSAFE_media", () => $61ce05535b72c208$export$c881183ca713c214);
/**
 * This is an object of usable media query helpers using our internal breakpoints configuration.
 *
 * When using Compiled CSS-in-JS, please ensure that only a single declaration can take effect at a time.
 * This means that you should avoid multiple breakpoints taking effect at the same time,
 * eg. ```{ [media.above.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * Instead, make sure that only one breakpoint can take effect at a time,
 * e.g, ```{ [media.only.xs]: { color: 'red' }, [media.above.sm]: { color: 'green' }}```.
 * For more details, please see https://compiledcssinjs.com/docs/atomic-css#selector-specificity
 */ const $61ce05535b72c208$export$987d49ffe1b0900f = {
    above: {
        xxs: '@media all',
        xs: '@media (min-width: 30rem)',
        sm: '@media (min-width: 48rem)',
        md: '@media (min-width: 64rem)',
        lg: '@media (min-width: 90rem)',
        xl: '@media (min-width: 110rem)'
    },
    only: {
        xxs: '@media (min-width: 0rem) and (max-width: 29.99rem)',
        xs: '@media (min-width: 30rem) and (max-width: 47.99rem)',
        sm: '@media (min-width: 48rem) and (max-width: 63.99rem)',
        md: '@media (min-width: 64rem) and (max-width: 89.99rem)',
        lg: '@media (min-width: 90rem) and (max-width: 109.99rem)',
        xl: '@media (min-width: 110rem)'
    },
    below: {
        xs: '@media not all and (min-width: 30rem)',
        sm: '@media not all and (min-width: 48rem)',
        md: '@media not all and (min-width: 64rem)',
        lg: '@media not all and (min-width: 90rem)',
        xl: '@media not all and (min-width: 110rem)'
    }
};
const $61ce05535b72c208$export$c881183ca713c214 = $61ce05535b72c208$export$987d49ffe1b0900f;

});



parcelRegister("b3jCJ", function(module, exports) {

$parcel$export(module.exports, "DesktopFilters", () => $80bf3265cd24d479$export$1b945ce14f8b4a74);

var $40fTF = parcelRequire("40fTF");

var $379fO = parcelRequire("379fO");
var $4xAW3 = parcelRequire("4xAW3");
var $d4qUE = parcelRequire("d4qUE");

var $eUqFw = parcelRequire("eUqFw");

var $9kLPX = parcelRequire("9kLPX");

var $1iS0A = parcelRequire("1iS0A");

var $lHkHI = parcelRequire("lHkHI");
const $80bf3265cd24d479$var$clearFiltersButtonTextStyles = (0, $d4qUE.xcss)({
    color: 'color.text.brand'
});
const $80bf3265cd24d479$export$1b945ce14f8b4a74 = (_ref)=>{
    let { filterDefinitions: filterDefinitions, filterOptions: filterOptions, filterStatus: filterStatus = {}, onClearFilter: _onClearFilter, onClearAllFilters: onClearAllFilters, onShowAllFilters: onShowAllFilters, onSelectedOptionsChange: onSelectedOptionsChange, selectedOptions: selectedOptions = {}, showAllFilters: showAllFilters } = _ref;
    const isMobile = (0, $1iS0A.useIsMobile)();
    const [isAnyFilterOpen, setIsAnyFilterOpen] = (0, $eUqFw.useState)(false);
    const visibleFilters = showAllFilters ? filterDefinitions : filterDefinitions.filter((_ref2)=>{
        let { hiddenByDefault: hiddenByDefault } = _ref2;
        return !hiddenByDefault;
    });
    const hasHiddenFilters = filterDefinitions.length > visibleFilters.length;
    const hasSelectedFilters = Object.keys(selectedOptions).some((filterId)=>{
        var _selectedOptions$filt;
        return (_selectedOptions$filt = selectedOptions[filterId]) === null || _selectedOptions$filt === void 0 ? void 0 : _selectedOptions$filt.length;
    });
    const handleClearAllFilters = ()=>{
        onClearAllFilters === null || onClearAllFilters === void 0 || onClearAllFilters({
            location: 'desktop'
        });
        setIsAnyFilterOpen(false);
    };
    const onPopupToggle = (0, $eUqFw.useCallback)((isOpen)=>{
        if (isOpen) setIsAnyFilterOpen(true);
    }, [
        setIsAnyFilterOpen
    ]);
    // isAnyFilterOpen -> false; when clear all filters is clicked
    // Close any open filter popup when clear all filters is clicked
    // else don't do anything
    const filterPopupState = !isAnyFilterOpen ? false : undefined;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4xAW3.default), {
        space: "space.100",
        rowSpace: "space.100",
        shouldWrap: true,
        children: [
            visibleFilters.map((_ref3)=>{
                let { filterId: filterId, label: label, isMulti: isMulti, isSearchable: isSearchable, hasClearSelectionButton: hasClearSelectionButton, groupSelectedItems: groupSelectedItems } = _ref3;
                return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9kLPX.FilterPicker), {
                    label: label,
                    isMulti: isMulti,
                    isPopupOpen: isMobile ? false : filterPopupState,
                    isSearchable: isSearchable,
                    hasClearSelectionButton: hasClearSelectionButton,
                    onPopupToggle: onPopupToggle,
                    onChange: (options)=>onSelectedOptionsChange({
                            filterId: filterId,
                            options: options,
                            location: 'desktop'
                        }),
                    onClearFilter: ()=>_onClearFilter(filterId),
                    options: filterOptions[filterId] || [],
                    selectedOptions: selectedOptions[filterId] || [],
                    status: filterStatus[filterId] || 'default',
                    groupSelectedItems: groupSelectedItems
                }, filterId);
            }),
            hasHiddenFilters && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $40fTF.default), {
                appearance: "subtle",
                onClick: onShowAllFilters,
                children: "Show more filters"
            }),
            hasSelectedFilters && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $40fTF.default), {
                appearance: "subtle",
                onClick: handleClearAllFilters,
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
                    as: "span",
                    xcss: $80bf3265cd24d479$var$clearFiltersButtonTextStyles,
                    children: "Clear filters"
                })
            })
        ]
    });
};

});
parcelRegister("40fTF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ea37e4de0e33139$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $3puyA = parcelRequire("3puyA");

var $24o1N = parcelRequire("24o1N");

var $2RJuk = parcelRequire("2RJuk");
/**
 * __Button__
 *
 * A button triggers an event or action.
 *
 * - [Examples](https://atlassian.design/components/button/examples)
 * - [Code](https://atlassian.design/components/button/code)
 * - [Usage](https://atlassian.design/components/button/usage)
 */ const $2ea37e4de0e33139$var$Button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, type: type = 'button', UNSAFE_iconAfter_size: UNSAFE_iconAfter_size, UNSAFE_iconBefore_size: UNSAFE_iconBefore_size, ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const rest = (0, $3puyA.getBooleanFF)('platform.design-system-team.remove-unsafe-spread-from-new-button_a2xhw') ? saferRest : unsafeRest;
    const baseProps = (0, $2RJuk.default)({
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        buttonType: 'button',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        UNSAFE_iconAfter_size: UNSAFE_iconAfter_size,
        UNSAFE_iconBefore_size: UNSAFE_iconBefore_size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $24o1N.default), (0, $kU09D.default)({}, rest, {
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "Button"
    }), baseProps.children);
}));
$2ea37e4de0e33139$var$Button.displayName = 'Button';
var $2ea37e4de0e33139$export$2e2bcd8739ae039 = $2ea37e4de0e33139$var$Button;

});
parcelRegister("24o1N", function(module, exports) {

$parcel$export(module.exports, "default", () => $181e97f69c4749cd$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2MblP = parcelRequire("2MblP");

var $eiQBT = parcelRequire("eiQBT");

var $7R4Cu = parcelRequire("7R4Cu");

var $bHLFn = parcelRequire("bHLFn");

var $344PY = parcelRequire("344PY");
// This duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $181e97f69c4749cd$var$focusRingStyles = (0, $byn9U.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $bHLFn.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $bHLFn.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $bHLFn.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $181e97f69c4749cd$var$baseStyles = (0, $byn9U.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});
const $181e97f69c4749cd$var$enabledStyles = (0, $byn9U.css)({
    cursor: 'pointer'
});
const $181e97f69c4749cd$var$disabledStyles = (0, $byn9U.css)({
    cursor: 'not-allowed'
});
/**
 * __Pressable__
 *
 * A primitive for building custom buttons.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $181e97f69c4749cd$var$Pressable = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', onClick: providedOnClick = (0, $eiQBT.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $eUqFw.useContext)((0, $7R4Cu.default));
    const handleClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    const onClick = (0, $2MblP.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Pressable',
        packageName: "@atlaskit/primitives",
        packageVersion: "11.1.2",
        analyticsData: analyticsContext,
        actionSubject: 'button'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $344PY.parseXcss)(xcss);
    return(// eslint-disable-next-line @atlaskit/design-system/no-html-button
    (0, $byn9U.jsx)("button", (0, $kU09D.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // eslint-disable-next-line react/button-has-type
        type: type,
        onClick: onClick,
        disabled: isDisabled,
        css: [
            $181e97f69c4749cd$var$baseStyles,
            $181e97f69c4749cd$var$focusRingStyles,
            isDisabled ? $181e97f69c4749cd$var$disabledStyles : $181e97f69c4749cd$var$enabledStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $bHLFn.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $bHLFn.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $bHLFn.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $bHLFn.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $bHLFn.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $bHLFn.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $bHLFn.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $bHLFn.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children));
});
var $181e97f69c4749cd$export$2e2bcd8739ae039 = $181e97f69c4749cd$var$Pressable;

});
parcelRegister("bHLFn", function(module, exports) {

$parcel$export(module.exports, "dimensionMap", () => $8858af6ec9f32788$export$6ccdbebca2ee545f);
$parcel$export(module.exports, "positiveSpaceMap", () => $8858af6ec9f32788$export$958d0ae7f2977ae4);
$parcel$export(module.exports, "allSpaceMap", () => $8858af6ec9f32788$export$632685d741f3dbbf);
$parcel$export(module.exports, "opacityMap", () => $8858af6ec9f32788$export$daf94a976c798b4f);
$parcel$export(module.exports, "shadowMap", () => $8858af6ec9f32788$export$7aff6e7ba39bb774);
$parcel$export(module.exports, "borderColorMap", () => $8858af6ec9f32788$export$1531ad5bb3fbedac);
$parcel$export(module.exports, "backgroundColorMap", () => $8858af6ec9f32788$export$d1d79bf68ac056bd);
$parcel$export(module.exports, "textColorMap", () => $8858af6ec9f32788$export$8473307aa00d6ea1);
$parcel$export(module.exports, "layerMap", () => $8858af6ec9f32788$export$b5f31a7e431d2eab);
$parcel$export(module.exports, "borderWidthMap", () => $8858af6ec9f32788$export$e1b83c5210c471b8);
$parcel$export(module.exports, "borderRadiusMap", () => $8858af6ec9f32788$export$3c0a6c3e64bb180d);
$parcel$export(module.exports, "paddingStylesMap", () => $8858af6ec9f32788$export$e615f061ca585a6c);
$parcel$export(module.exports, "backgroundColorStylesMap", () => $8858af6ec9f32788$export$e7af83bafe7f9e63);
$parcel$export(module.exports, "surfaceColorStylesMap", () => $8858af6ec9f32788$export$ff257d957d48c421);
$parcel$export(module.exports, "isSurfaceColorToken", () => $8858af6ec9f32788$export$5e65a44e5b6ecadb);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $axYky = parcelRequire("axYky");
const $8858af6ec9f32788$export$6ccdbebca2ee545f = {
    '100%': '100%',
    'size.100': '1rem',
    'size.200': '1.5rem',
    'size.300': '2rem',
    'size.400': '2.5rem',
    'size.500': '3rem',
    'size.600': '6rem',
    'size.1000': '12rem'
};
const $8858af6ec9f32788$export$958d0ae7f2977ae4 = {
    'space.0': "var(--ds-space-0, 0px)",
    'space.025': "var(--ds-space-025, 2px)",
    'space.050': "var(--ds-space-050, 4px)",
    'space.075': "var(--ds-space-075, 6px)",
    'space.100': "var(--ds-space-100, 8px)",
    'space.150': "var(--ds-space-150, 12px)",
    'space.200': "var(--ds-space-200, 16px)",
    'space.250': "var(--ds-space-250, 20px)",
    'space.300': "var(--ds-space-300, 24px)",
    'space.400': "var(--ds-space-400, 32px)",
    'space.500': "var(--ds-space-500, 40px)",
    'space.600': "var(--ds-space-600, 48px)",
    'space.800': "var(--ds-space-800, 64px)",
    'space.1000': "var(--ds-space-1000, 80px)"
};
const $8858af6ec9f32788$export$d2dc61f58390201c = {
    'space.negative.025': "var(--ds-space-negative-025, -2px)",
    'space.negative.050': "var(--ds-space-negative-050, -4px)",
    'space.negative.075': "var(--ds-space-negative-075, -6px)",
    'space.negative.100': "var(--ds-space-negative-100, -8px)",
    'space.negative.150': "var(--ds-space-negative-150, -12px)",
    'space.negative.200': "var(--ds-space-negative-200, -16px)",
    'space.negative.250': "var(--ds-space-negative-250, -20px)",
    'space.negative.300': "var(--ds-space-negative-300, -24px)",
    'space.negative.400': "var(--ds-space-negative-400, -32px)"
};
const $8858af6ec9f32788$export$632685d741f3dbbf = {
    ...$8858af6ec9f32788$export$958d0ae7f2977ae4,
    ...$8858af6ec9f32788$export$d2dc61f58390201c
};
const $8858af6ec9f32788$export$2185ce37f9bdd963 = {
    'color.background.neutral.bold': 'color.text.inverse',
    'color.background.neutral.bold.hovered': 'color.text.inverse',
    'color.background.neutral.bold.pressed': 'color.text.inverse',
    'color.background.selected.bold': 'color.text.inverse',
    'color.background.selected.bold.hovered': 'color.text.inverse',
    'color.background.selected.bold.pressed': 'color.text.inverse',
    'color.background.brand.bold': 'color.text.inverse',
    'color.background.brand.bold.hovered': 'color.text.inverse',
    'color.background.brand.bold.pressed': 'color.text.inverse',
    'color.background.brand.boldest': 'color.text.inverse',
    'color.background.brand.boldest.hovered': 'color.text.inverse',
    'color.background.brand.boldest.pressed': 'color.text.inverse',
    'color.background.danger.bold': 'color.text.inverse',
    'color.background.danger.bold.hovered': 'color.text.inverse',
    'color.background.danger.bold.pressed': 'color.text.inverse',
    'color.background.warning.bold': 'color.text.warning.inverse',
    'color.background.warning.bold.hovered': 'color.text.warning.inverse',
    'color.background.warning.bold.pressed': 'color.text.warning.inverse',
    'color.background.success.bold': 'color.text.inverse',
    'color.background.success.bold.hovered': 'color.text.inverse',
    'color.background.success.bold.pressed': 'color.text.inverse',
    'color.background.discovery.bold': 'color.text.inverse',
    'color.background.discovery.bold.hovered': 'color.text.inverse',
    'color.background.discovery.bold.pressed': 'color.text.inverse',
    'color.background.information.bold': 'color.text.inverse',
    'color.background.information.bold.hovered': 'color.text.inverse',
    'color.background.information.bold.pressed': 'color.text.inverse'
};
const $8858af6ec9f32788$export$daf94a976c798b4f = {
    'opacity.disabled': "var(--ds-opacity-disabled, 0.4)",
    'opacity.loading': "var(--ds-opacity-loading, 0.2)"
};
const $8858af6ec9f32788$export$7aff6e7ba39bb774 = {
    'elevation.shadow.overflow': "var(--ds-shadow-overflow, 0px 0px 8px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.overflow.perimeter': "var(--ds-shadow-overflow-perimeter, #091e421f)",
    'elevation.shadow.overflow.spread': "var(--ds-shadow-overflow-spread, #091e4229)",
    'elevation.shadow.overlay': "var(--ds-shadow-overlay, 0px 8px 12px #091e423f, 0px 0px 1px #091e424f)",
    'elevation.shadow.raised': "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)"
};
const $8858af6ec9f32788$export$41a358c9c2356760 = {
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)"
};
const $8858af6ec9f32788$export$1531ad5bb3fbedac = {
    'color.border': "var(--ds-border, #091e4221)",
    'color.border.accent.lime': "var(--ds-border-accent-lime, #6A9A23)",
    'color.border.accent.red': "var(--ds-border-accent-red, #FF5630)",
    'color.border.accent.orange': "var(--ds-border-accent-orange, #D94008)",
    'color.border.accent.yellow': "var(--ds-border-accent-yellow, #FFAB00)",
    'color.border.accent.green': "var(--ds-border-accent-green, #36B37E)",
    'color.border.accent.teal': "var(--ds-border-accent-teal, #00B8D9)",
    'color.border.accent.blue': "var(--ds-border-accent-blue, #0065FF)",
    'color.border.accent.purple': "var(--ds-border-accent-purple, #6554C0)",
    'color.border.accent.magenta': "var(--ds-border-accent-magenta, #CD519D)",
    'color.border.accent.gray': "var(--ds-border-accent-gray, #5E6C84)",
    'color.border.disabled': "var(--ds-border-disabled, #FAFBFC)",
    'color.border.focused': "var(--ds-border-focused, #2684FF)",
    'color.border.input': "var(--ds-border-input, #FAFBFC)",
    'color.border.inverse': "var(--ds-border-inverse, #FFFFFF)",
    'color.border.selected': "var(--ds-border-selected, #0052CC)",
    'color.border.brand': "var(--ds-border-brand, #0052CC)",
    'color.border.danger': "var(--ds-border-danger, #FF5630)",
    'color.border.warning': "var(--ds-border-warning, #FFC400)",
    'color.border.success': "var(--ds-border-success, #00875A)",
    'color.border.discovery': "var(--ds-border-discovery, #998DD9)",
    'color.border.information': "var(--ds-border-information, #0065FF)",
    'color.border.bold': "var(--ds-border-bold, #344563)"
};
const $8858af6ec9f32788$export$d1d79bf68ac056bd = {
    'color.background.accent.lime.subtlest': "var(--ds-background-accent-lime-subtlest, #EEFBDA)",
    'color.background.accent.lime.subtlest.hovered': "var(--ds-background-accent-lime-subtlest-hovered, #D3F1A7)",
    'color.background.accent.lime.subtlest.pressed': "var(--ds-background-accent-lime-subtlest-pressed, #B3DF72)",
    'color.background.accent.lime.subtler': "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    'color.background.accent.lime.subtler.hovered': "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    'color.background.accent.lime.subtler.pressed': "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    'color.background.accent.lime.subtle': "var(--ds-background-accent-lime-subtle, #94C748)",
    'color.background.accent.lime.subtle.hovered': "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    'color.background.accent.lime.subtle.pressed': "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    'color.background.accent.lime.bolder': "var(--ds-background-accent-lime-bolder, #5B7F24)",
    'color.background.accent.lime.bolder.hovered': "var(--ds-background-accent-lime-bolder-hovered, #37471F)",
    'color.background.accent.lime.bolder.pressed': "var(--ds-background-accent-lime-bolder-pressed, #37471F)",
    'color.background.accent.red.subtlest': "var(--ds-background-accent-red-subtlest, #FF8F73)",
    'color.background.accent.red.subtlest.hovered': "var(--ds-background-accent-red-subtlest-hovered, #FF7452)",
    'color.background.accent.red.subtlest.pressed': "var(--ds-background-accent-red-subtlest-pressed, #FF5630)",
    'color.background.accent.red.subtler': "var(--ds-background-accent-red-subtler, #FF7452)",
    'color.background.accent.red.subtler.hovered': "var(--ds-background-accent-red-subtler-hovered, #FF5630)",
    'color.background.accent.red.subtler.pressed': "var(--ds-background-accent-red-subtler-pressed, #DE350B)",
    'color.background.accent.red.subtle': "var(--ds-background-accent-red-subtle, #DE350B)",
    'color.background.accent.red.subtle.hovered': "var(--ds-background-accent-red-subtle-hovered, #FF5630)",
    'color.background.accent.red.subtle.pressed': "var(--ds-background-accent-red-subtle-pressed, #FF7452)",
    'color.background.accent.red.bolder': "var(--ds-background-accent-red-bolder, #DE350B)",
    'color.background.accent.red.bolder.hovered': "var(--ds-background-accent-red-bolder-hovered, #FF5630)",
    'color.background.accent.red.bolder.pressed': "var(--ds-background-accent-red-bolder-pressed, #FF7452)",
    'color.background.accent.orange.subtlest': "var(--ds-background-accent-orange-subtlest, #F18D13)",
    'color.background.accent.orange.subtlest.hovered': "var(--ds-background-accent-orange-subtlest-hovered, #FEC57B)",
    'color.background.accent.orange.subtlest.pressed': "var(--ds-background-accent-orange-subtlest-pressed, #FFE2BD)",
    'color.background.accent.orange.subtler': "var(--ds-background-accent-orange-subtler, #B65C02)",
    'color.background.accent.orange.subtler.hovered': "var(--ds-background-accent-orange-subtler-hovered, #F18D13)",
    'color.background.accent.orange.subtler.pressed': "var(--ds-background-accent-orange-subtler-pressed, #FEC57B)",
    'color.background.accent.orange.subtle': "var(--ds-background-accent-orange-subtle, #5F3811)",
    'color.background.accent.orange.subtle.hovered': "var(--ds-background-accent-orange-subtle-hovered, #974F0C)",
    'color.background.accent.orange.subtle.pressed': "var(--ds-background-accent-orange-subtle-pressed, #B65C02)",
    'color.background.accent.orange.bolder': "var(--ds-background-accent-orange-bolder, #43290F)",
    'color.background.accent.orange.bolder.hovered': "var(--ds-background-accent-orange-bolder-hovered, #5F3811)",
    'color.background.accent.orange.bolder.pressed': "var(--ds-background-accent-orange-bolder-pressed, #974F0C)",
    'color.background.accent.yellow.subtlest': "var(--ds-background-accent-yellow-subtlest, #FFE380)",
    'color.background.accent.yellow.subtlest.hovered': "var(--ds-background-accent-yellow-subtlest-hovered, #FFC400)",
    'color.background.accent.yellow.subtlest.pressed': "var(--ds-background-accent-yellow-subtlest-pressed, #FFAB00)",
    'color.background.accent.yellow.subtler': "var(--ds-background-accent-yellow-subtler, #FFC400)",
    'color.background.accent.yellow.subtler.hovered': "var(--ds-background-accent-yellow-subtler-hovered, #FFAB00)",
    'color.background.accent.yellow.subtler.pressed': "var(--ds-background-accent-yellow-subtler-pressed, #FF991F)",
    'color.background.accent.yellow.subtle': "var(--ds-background-accent-yellow-subtle, #FF991F)",
    'color.background.accent.yellow.subtle.hovered': "var(--ds-background-accent-yellow-subtle-hovered, #FFAB00)",
    'color.background.accent.yellow.subtle.pressed': "var(--ds-background-accent-yellow-subtle-pressed, #FFC400)",
    'color.background.accent.yellow.bolder': "var(--ds-background-accent-yellow-bolder, #FF991F)",
    'color.background.accent.yellow.bolder.hovered': "var(--ds-background-accent-yellow-bolder-hovered, #FFAB00)",
    'color.background.accent.yellow.bolder.pressed': "var(--ds-background-accent-yellow-bolder-pressed, #FFC400)",
    'color.background.accent.green.subtlest': "var(--ds-background-accent-green-subtlest, #79F2C0)",
    'color.background.accent.green.subtlest.hovered': "var(--ds-background-accent-green-subtlest-hovered, #57D9A3)",
    'color.background.accent.green.subtlest.pressed': "var(--ds-background-accent-green-subtlest-pressed, #36B37E)",
    'color.background.accent.green.subtler': "var(--ds-background-accent-green-subtler, #57D9A3)",
    'color.background.accent.green.subtler.hovered': "var(--ds-background-accent-green-subtler-hovered, #36B37E)",
    'color.background.accent.green.subtler.pressed': "var(--ds-background-accent-green-subtler-pressed, #00875A)",
    'color.background.accent.green.subtle': "var(--ds-background-accent-green-subtle, #00875A)",
    'color.background.accent.green.subtle.hovered': "var(--ds-background-accent-green-subtle-hovered, #36B37E)",
    'color.background.accent.green.subtle.pressed': "var(--ds-background-accent-green-subtle-pressed, #57D9A3)",
    'color.background.accent.green.bolder': "var(--ds-background-accent-green-bolder, #00875A)",
    'color.background.accent.green.bolder.hovered': "var(--ds-background-accent-green-bolder-hovered, #36B37E)",
    'color.background.accent.green.bolder.pressed': "var(--ds-background-accent-green-bolder-pressed, #57D9A3)",
    'color.background.accent.teal.subtlest': "var(--ds-background-accent-teal-subtlest, #79E2F2)",
    'color.background.accent.teal.subtlest.hovered': "var(--ds-background-accent-teal-subtlest-hovered, #00C7E6)",
    'color.background.accent.teal.subtlest.pressed': "var(--ds-background-accent-teal-subtlest-pressed, #00B8D9)",
    'color.background.accent.teal.subtler': "var(--ds-background-accent-teal-subtler, #00C7E6)",
    'color.background.accent.teal.subtler.hovered': "var(--ds-background-accent-teal-subtler-hovered, #00B8D9)",
    'color.background.accent.teal.subtler.pressed': "var(--ds-background-accent-teal-subtler-pressed, #00A3BF)",
    'color.background.accent.teal.subtle': "var(--ds-background-accent-teal-subtle, #00A3BF)",
    'color.background.accent.teal.subtle.hovered': "var(--ds-background-accent-teal-subtle-hovered, #00B8D9)",
    'color.background.accent.teal.subtle.pressed': "var(--ds-background-accent-teal-subtle-pressed, #00C7E6)",
    'color.background.accent.teal.bolder': "var(--ds-background-accent-teal-bolder, #00A3BF)",
    'color.background.accent.teal.bolder.hovered': "var(--ds-background-accent-teal-bolder-hovered, #00B8D9)",
    'color.background.accent.teal.bolder.pressed': "var(--ds-background-accent-teal-bolder-pressed, #00C7E6)",
    'color.background.accent.blue.subtlest': "var(--ds-background-accent-blue-subtlest, #4C9AFF)",
    'color.background.accent.blue.subtlest.hovered': "var(--ds-background-accent-blue-subtlest-hovered, #2684FF)",
    'color.background.accent.blue.subtlest.pressed': "var(--ds-background-accent-blue-subtlest-pressed, #0065FF)",
    'color.background.accent.blue.subtler': "var(--ds-background-accent-blue-subtler, #2684FF)",
    'color.background.accent.blue.subtler.hovered': "var(--ds-background-accent-blue-subtler-hovered, #0065FF)",
    'color.background.accent.blue.subtler.pressed': "var(--ds-background-accent-blue-subtler-pressed, #0052CC)",
    'color.background.accent.blue.subtle': "var(--ds-background-accent-blue-subtle, #0052CC)",
    'color.background.accent.blue.subtle.hovered': "var(--ds-background-accent-blue-subtle-hovered, #0065FF)",
    'color.background.accent.blue.subtle.pressed': "var(--ds-background-accent-blue-subtle-pressed, #2684FF)",
    'color.background.accent.blue.bolder': "var(--ds-background-accent-blue-bolder, #0052CC)",
    'color.background.accent.blue.bolder.hovered': "var(--ds-background-accent-blue-bolder-hovered, #0065FF)",
    'color.background.accent.blue.bolder.pressed': "var(--ds-background-accent-blue-bolder-pressed, #2684FF)",
    'color.background.accent.purple.subtlest': "var(--ds-background-accent-purple-subtlest, #998DD9)",
    'color.background.accent.purple.subtlest.hovered': "var(--ds-background-accent-purple-subtlest-hovered, #8777D9)",
    'color.background.accent.purple.subtlest.pressed': "var(--ds-background-accent-purple-subtlest-pressed, #6554C0)",
    'color.background.accent.purple.subtler': "var(--ds-background-accent-purple-subtler, #8777D9)",
    'color.background.accent.purple.subtler.hovered': "var(--ds-background-accent-purple-subtler-hovered, #6554C0)",
    'color.background.accent.purple.subtler.pressed': "var(--ds-background-accent-purple-subtler-pressed, #5243AA)",
    'color.background.accent.purple.subtle': "var(--ds-background-accent-purple-subtle, #5243AA)",
    'color.background.accent.purple.subtle.hovered': "var(--ds-background-accent-purple-subtle-hovered, #6554C0)",
    'color.background.accent.purple.subtle.pressed': "var(--ds-background-accent-purple-subtle-pressed, #8777D9)",
    'color.background.accent.purple.bolder': "var(--ds-background-accent-purple-bolder, #5243AA)",
    'color.background.accent.purple.bolder.hovered': "var(--ds-background-accent-purple-bolder-hovered, #6554C0)",
    'color.background.accent.purple.bolder.pressed': "var(--ds-background-accent-purple-bolder-pressed, #8777D9)",
    'color.background.accent.magenta.subtlest': "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    'color.background.accent.magenta.subtlest.hovered': "var(--ds-background-accent-magenta-subtlest-hovered, #FDD0EC)",
    'color.background.accent.magenta.subtlest.pressed': "var(--ds-background-accent-magenta-subtlest-pressed, #F797D2)",
    'color.background.accent.magenta.subtler': "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    'color.background.accent.magenta.subtler.hovered': "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    'color.background.accent.magenta.subtler.pressed': "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    'color.background.accent.magenta.subtle': "var(--ds-background-accent-magenta-subtle, #E774BB)",
    'color.background.accent.magenta.subtle.hovered': "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    'color.background.accent.magenta.subtle.pressed': "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    'color.background.accent.magenta.bolder': "var(--ds-background-accent-magenta-bolder, #AE4787)",
    'color.background.accent.magenta.bolder.hovered': "var(--ds-background-accent-magenta-bolder-hovered, #943D73)",
    'color.background.accent.magenta.bolder.pressed': "var(--ds-background-accent-magenta-bolder-pressed, #50253F)",
    'color.background.accent.gray.subtlest': "var(--ds-background-accent-gray-subtlest, #6B778C)",
    'color.background.accent.gray.subtlest.hovered': "var(--ds-background-accent-gray-subtlest-hovered, #5E6C84)",
    'color.background.accent.gray.subtlest.pressed': "var(--ds-background-accent-gray-subtlest-pressed, #505F79)",
    'color.background.accent.gray.subtler': "var(--ds-background-accent-gray-subtler, #5E6C84)",
    'color.background.accent.gray.subtler.hovered': "var(--ds-background-accent-gray-subtler-hovered, #505F79)",
    'color.background.accent.gray.subtler.pressed': "var(--ds-background-accent-gray-subtler-pressed, #42526E)",
    'color.background.accent.gray.subtle': "var(--ds-background-accent-gray-subtle, #505F79)",
    'color.background.accent.gray.subtle.hovered': "var(--ds-background-accent-gray-subtle-hovered, #5E6C84)",
    'color.background.accent.gray.subtle.pressed': "var(--ds-background-accent-gray-subtle-pressed, #6B778C)",
    'color.background.accent.gray.bolder': "var(--ds-background-accent-gray-bolder, #42526E)",
    'color.background.accent.gray.bolder.hovered': "var(--ds-background-accent-gray-bolder-hovered, #344563)",
    'color.background.accent.gray.bolder.pressed': "var(--ds-background-accent-gray-bolder-pressed, #253858)",
    'color.background.disabled': "var(--ds-background-disabled, #091e4289)",
    'color.background.input': "var(--ds-background-input, #FAFBFC)",
    'color.background.input.hovered': "var(--ds-background-input-hovered, #EBECF0)",
    'color.background.input.pressed': "var(--ds-background-input-pressed, #FFFFFF)",
    'color.background.inverse.subtle': "var(--ds-background-inverse-subtle, #00000029)",
    'color.background.inverse.subtle.hovered': "var(--ds-background-inverse-subtle-hovered, #0000003D)",
    'color.background.inverse.subtle.pressed': "var(--ds-background-inverse-subtle-pressed, #00000052)",
    'color.background.neutral': "var(--ds-background-neutral, #DFE1E6)",
    'color.background.neutral.hovered': "var(--ds-background-neutral-hovered, #091e4214)",
    'color.background.neutral.pressed': "var(--ds-background-neutral-pressed, #B3D4FF)",
    'color.background.neutral.subtle': "var(--ds-background-neutral-subtle, transparent)",
    'color.background.neutral.subtle.hovered': "var(--ds-background-neutral-subtle-hovered, #091e4214)",
    'color.background.neutral.subtle.pressed': "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
    'color.background.neutral.bold': "var(--ds-background-neutral-bold, #42526E)",
    'color.background.neutral.bold.hovered': "var(--ds-background-neutral-bold-hovered, #505F79)",
    'color.background.neutral.bold.pressed': "var(--ds-background-neutral-bold-pressed, #344563)",
    'color.background.selected': "var(--ds-background-selected, #DEEBFF)",
    'color.background.selected.hovered': "var(--ds-background-selected-hovered, #B3D4FF)",
    'color.background.selected.pressed': "var(--ds-background-selected-pressed, #4C9AFF)",
    'color.background.selected.bold': "var(--ds-background-selected-bold, #0052CC)",
    'color.background.selected.bold.hovered': "var(--ds-background-selected-bold-hovered, #2684FF)",
    'color.background.selected.bold.pressed': "var(--ds-background-selected-bold-pressed, #0052CC)",
    'color.background.brand.subtlest': "var(--ds-background-brand-subtlest, #B3D4FF)",
    'color.background.brand.subtlest.hovered': "var(--ds-background-brand-subtlest-hovered, #DEEBFF)",
    'color.background.brand.subtlest.pressed': "var(--ds-background-brand-subtlest-pressed, #4C9AFF)",
    'color.background.brand.bold': "var(--ds-background-brand-bold, #0052CC)",
    'color.background.brand.bold.hovered': "var(--ds-background-brand-bold-hovered, #0065FF)",
    'color.background.brand.bold.pressed': "var(--ds-background-brand-bold-pressed, #0747A6)",
    'color.background.brand.boldest': "var(--ds-background-brand-boldest, #0747A6)",
    'color.background.brand.boldest.hovered': "var(--ds-background-brand-boldest-hovered, #0052CC)",
    'color.background.brand.boldest.pressed': "var(--ds-background-brand-boldest-pressed, #0747A6)",
    'color.background.danger': "var(--ds-background-danger, #FFEBE6)",
    'color.background.danger.hovered': "var(--ds-background-danger-hovered, #FFBDAD)",
    'color.background.danger.pressed': "var(--ds-background-danger-pressed, #FF8F73)",
    'color.background.danger.bold': "var(--ds-background-danger-bold, #DE350B)",
    'color.background.danger.bold.hovered': "var(--ds-background-danger-bold-hovered, #FF5630)",
    'color.background.danger.bold.pressed': "var(--ds-background-danger-bold-pressed, #BF2600)",
    'color.background.warning': "var(--ds-background-warning, #FFFAE6)",
    'color.background.warning.hovered': "var(--ds-background-warning-hovered, #FFF0B3)",
    'color.background.warning.pressed': "var(--ds-background-warning-pressed, #FFE380)",
    'color.background.warning.bold': "var(--ds-background-warning-bold, #FFAB00)",
    'color.background.warning.bold.hovered': "var(--ds-background-warning-bold-hovered, #FFC400)",
    'color.background.warning.bold.pressed': "var(--ds-background-warning-bold-pressed, #FF991F)",
    'color.background.success': "var(--ds-background-success, #E3FCEF)",
    'color.background.success.hovered': "var(--ds-background-success-hovered, #ABF5D1)",
    'color.background.success.pressed': "var(--ds-background-success-pressed, #79F2C0)",
    'color.background.success.bold': "var(--ds-background-success-bold, #00875A)",
    'color.background.success.bold.hovered': "var(--ds-background-success-bold-hovered, #57D9A3)",
    'color.background.success.bold.pressed': "var(--ds-background-success-bold-pressed, #00875A)",
    'color.background.discovery': "var(--ds-background-discovery, #EAE6FF)",
    'color.background.discovery.hovered': "var(--ds-background-discovery-hovered, #C0B6F2)",
    'color.background.discovery.pressed': "var(--ds-background-discovery-pressed, #998DD9)",
    'color.background.discovery.bold': "var(--ds-background-discovery-bold, #5243AA)",
    'color.background.discovery.bold.hovered': "var(--ds-background-discovery-bold-hovered, #8777D9)",
    'color.background.discovery.bold.pressed': "var(--ds-background-discovery-bold-pressed, #5243AA)",
    'color.background.information': "var(--ds-background-information, #DEEBFF)",
    'color.background.information.hovered': "var(--ds-background-information-hovered, #B3D4FF)",
    'color.background.information.pressed': "var(--ds-background-information-pressed, #4C9AFF)",
    'color.background.information.bold': "var(--ds-background-information-bold, #0052CC)",
    'color.background.information.bold.hovered': "var(--ds-background-information-bold-hovered, #2684FF)",
    'color.background.information.bold.pressed': "var(--ds-background-information-bold-pressed, #0052CC)",
    'color.blanket': "var(--ds-blanket, #091e4289)",
    'color.blanket.selected': "var(--ds-blanket-selected, #388BFF14)",
    'color.blanket.danger': "var(--ds-blanket-danger, #EF5C4814)",
    'color.skeleton': "var(--ds-skeleton, #F4F5F7)",
    'color.skeleton.subtle': "var(--ds-skeleton-subtle, #091e420a)",
    'elevation.surface': "var(--ds-surface, #FFFFFF)",
    'elevation.surface.hovered': "var(--ds-surface-hovered, #FAFBFC)",
    'elevation.surface.pressed': "var(--ds-surface-pressed, #F4F5F7)",
    'elevation.surface.overlay': "var(--ds-surface-overlay, #FFFFFF)",
    'elevation.surface.overlay.hovered': "var(--ds-surface-overlay-hovered, #FAFBFC)",
    'elevation.surface.overlay.pressed': "var(--ds-surface-overlay-pressed, #F4F5F7)",
    'elevation.surface.raised': "var(--ds-surface-raised, #FFFFFF)",
    'elevation.surface.raised.hovered': "var(--ds-surface-raised-hovered, #FAFBFC)",
    'elevation.surface.raised.pressed': "var(--ds-surface-raised-pressed, #F4F5F7)",
    'elevation.surface.sunken': "var(--ds-surface-sunken, #F4F5F7)",
    'utility.elevation.surface.current': "var(--ds-elevation-surface-current, #FFFFFF)"
};
const $8858af6ec9f32788$export$8473307aa00d6ea1 = {
    'color.text': "var(--ds-text, #172B4D)",
    'color.text.accent.lime': "var(--ds-text-accent-lime, #4C6B1F)",
    'color.text.accent.lime.bolder': "var(--ds-text-accent-lime-bolder, #37471F)",
    'color.text.accent.red': "var(--ds-text-accent-red, #DE350B)",
    'color.text.accent.red.bolder': "var(--ds-text-accent-red-bolder, #BF2600)",
    'color.text.accent.orange': "var(--ds-text-accent-orange, #F18D13)",
    'color.text.accent.orange.bolder': "var(--ds-text-accent-orange-bolder, #B65C02)",
    'color.text.accent.yellow': "var(--ds-text-accent-yellow, #FF991F)",
    'color.text.accent.yellow.bolder': "var(--ds-text-accent-yellow-bolder, #FF8B00)",
    'color.text.accent.green': "var(--ds-text-accent-green, #00875A)",
    'color.text.accent.green.bolder': "var(--ds-text-accent-green-bolder, #006644)",
    'color.text.accent.teal': "var(--ds-text-accent-teal, #00A3BF)",
    'color.text.accent.teal.bolder': "var(--ds-text-accent-teal-bolder, #008DA6)",
    'color.text.accent.blue': "var(--ds-text-accent-blue, #0052CC)",
    'color.text.accent.blue.bolder': "var(--ds-text-accent-blue-bolder, #0747A6)",
    'color.text.accent.purple': "var(--ds-text-accent-purple, #5243AA)",
    'color.text.accent.purple.bolder': "var(--ds-text-accent-purple-bolder, #403294)",
    'color.text.accent.magenta': "var(--ds-text-accent-magenta, #E774BB)",
    'color.text.accent.magenta.bolder': "var(--ds-text-accent-magenta-bolder, #DA62AC)",
    'color.text.accent.gray': "var(--ds-text-accent-gray, #505F79)",
    'color.text.accent.gray.bolder': "var(--ds-text-accent-gray-bolder, #172B4D)",
    'color.text.disabled': "var(--ds-text-disabled, #A5ADBA)",
    'color.text.inverse': "var(--ds-text-inverse, #FFFFFF)",
    'color.text.selected': "var(--ds-text-selected, #0052CC)",
    'color.text.brand': "var(--ds-text-brand, #0065FF)",
    'color.text.danger': "var(--ds-text-danger, #DE350B)",
    'color.text.warning': "var(--ds-text-warning, #974F0C)",
    'color.text.warning.inverse': "var(--ds-text-warning-inverse, #172B4D)",
    'color.text.success': "var(--ds-text-success, #006644)",
    'color.text.discovery': "var(--ds-text-discovery, #403294)",
    'color.text.information': "var(--ds-text-information, #0052CC)",
    'color.text.subtlest': "var(--ds-text-subtlest, #7A869A)",
    'color.text.subtle': "var(--ds-text-subtle, #42526E)",
    'color.link': "var(--ds-link, #0052CC)",
    'color.link.pressed': "var(--ds-link-pressed, #0747A6)",
    'color.link.visited': "var(--ds-link-visited, #403294)",
    'color.link.visited.pressed': "var(--ds-link-visited-pressed, #403294)"
};
const $8858af6ec9f32788$export$498780f74be9af68 = {
    'color.icon': "var(--ds-icon, #505F79)",
    'color.icon.accent.lime': "var(--ds-icon-accent-lime, #6A9A23)",
    'color.icon.accent.red': "var(--ds-icon-accent-red, #FF5630)",
    'color.icon.accent.orange': "var(--ds-icon-accent-orange, #D94008)",
    'color.icon.accent.yellow': "var(--ds-icon-accent-yellow, #FFAB00)",
    'color.icon.accent.green': "var(--ds-icon-accent-green, #36B37E)",
    'color.icon.accent.teal': "var(--ds-icon-accent-teal, #00B8D9)",
    'color.icon.accent.blue': "var(--ds-icon-accent-blue, #0065FF)",
    'color.icon.accent.purple': "var(--ds-icon-accent-purple, #6554C0)",
    'color.icon.accent.magenta': "var(--ds-icon-accent-magenta, #CD519D)",
    'color.icon.accent.gray': "var(--ds-icon-accent-gray, #5E6C84)",
    'color.icon.disabled': "var(--ds-icon-disabled, #8993A4)",
    'color.icon.inverse': "var(--ds-icon-inverse, #FFFFFF)",
    'color.icon.selected': "var(--ds-icon-selected, #0052CC)",
    'color.icon.brand': "var(--ds-icon-brand, #0065FF)",
    'color.icon.danger': "var(--ds-icon-danger, #DE350B)",
    'color.icon.warning': "var(--ds-icon-warning, #FFC400)",
    'color.icon.warning.inverse': "var(--ds-icon-warning-inverse, #253858)",
    'color.icon.success': "var(--ds-icon-success, #00875A)",
    'color.icon.discovery': "var(--ds-icon-discovery, #8777D9)",
    'color.icon.information': "var(--ds-icon-information, #0747A6)",
    'color.icon.subtle': "var(--ds-icon-subtle, #6B778C)"
};
const $8858af6ec9f32788$export$b5f31a7e431d2eab = {
    card: 100,
    navigation: 200,
    dialog: 300,
    layer: 400,
    blanket: 500,
    modal: 510,
    flag: 600,
    spotlight: 700,
    tooltip: 800
};
const $8858af6ec9f32788$export$e1b83c5210c471b8 = {
    'border.width': "var(--ds-border-width, 1px)",
    'border.width.0': "var(--ds-border-width-0, 0px)",
    'border.width.indicator': "var(--ds-border-width-indicator, 3px)",
    'border.width.outline': "var(--ds-border-width-outline, 2px)"
};
const $8858af6ec9f32788$export$3c0a6c3e64bb180d = {
    'border.radius.050': "var(--ds-border-radius-050, 2px)",
    'border.radius': "var(--ds-border-radius, 3px)",
    'border.radius.100': "var(--ds-border-radius-100, 3px)",
    'border.radius.200': "var(--ds-border-radius-200, 8px)",
    'border.radius.300': "var(--ds-border-radius-300, 12px)",
    'border.radius.400': "var(--ds-border-radius-400, 16px)",
    'border.radius.circle': "var(--ds-border-radius-circle, 32032px)"
};
const $8858af6ec9f32788$export$6cc560b4dedf3816 = {
    medium: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    UNSAFE_small: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    large: "var(--ds-font-body-large, normal 400 16px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    small: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
const $8858af6ec9f32788$export$303e322c6b1ed114 = {
    bold: "var(--ds-font-weight-bold, 700)",
    medium: "var(--ds-font-weight-medium, 500)",
    regular: "var(--ds-font-weight-regular, 400)",
    semibold: "var(--ds-font-weight-semibold, 600)"
};
const $8858af6ec9f32788$export$3c7e9587132614b4 = {
    'font.family.body': "var(--ds-font-family-body, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.body': "var(--ds-font-family-brand-body, \"Charlie Text\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.brand.heading': "var(--ds-font-family-brand-heading, \"Charlie Display\", ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    'font.family.code': "var(--ds-font-family-code, ui-monospace, Menlo, \"Segoe UI Mono\", \"Ubuntu Mono\", monospace)",
    'font.family.heading': "var(--ds-font-family-heading, ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)"
};
/**
 * @codegenEnd
 */ // Margin needs some bespoke types: https://atlassian.slack.com/archives/CKRHB23K8/p1712623192772909
// Generate maps for Box props. backgroundColor, padding, etc
const $8858af6ec9f32788$var$spacingProperties = [
    // Used by Box
    'padding',
    'paddingBlock',
    'paddingBlockStart',
    'paddingBlockEnd',
    'paddingInline',
    'paddingInlineStart',
    'paddingInlineEnd',
    // Used by Inline and Stack
    'gap',
    'rowGap',
    'columnGap'
];
const $8858af6ec9f32788$var$getSerializedStylesMap = (cssProperty, tokenMap)=>{
    return Object.keys(tokenMap).reduce((emotionSpacingMap, token)=>{
        emotionSpacingMap[token] = (0, $byn9U.css)({
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            [cssProperty]: tokenMap[token]
        });
        return emotionSpacingMap;
    }, {});
};
const $8858af6ec9f32788$export$e615f061ca585a6c = $8858af6ec9f32788$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $8858af6ec9f32788$var$getSerializedStylesMap(spacingProperty, $8858af6ec9f32788$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $8858af6ec9f32788$export$bf46c3f9eeafc71f = $8858af6ec9f32788$var$spacingProperties.reduce((styleMap, spacingProperty)=>{
    styleMap[spacingProperty] = $8858af6ec9f32788$var$getSerializedStylesMap(spacingProperty, $8858af6ec9f32788$export$958d0ae7f2977ae4);
    return styleMap;
}, {});
const $8858af6ec9f32788$export$e7af83bafe7f9e63 = $8858af6ec9f32788$var$getSerializedStylesMap('backgroundColor', $8858af6ec9f32788$export$d1d79bf68ac056bd);
const $8858af6ec9f32788$export$3a1bcba60b23d7f0 = $8858af6ec9f32788$var$getSerializedStylesMap('color', $8858af6ec9f32788$export$8473307aa00d6ea1);
const $8858af6ec9f32788$export$45f3f4fe16f9f7d5 = $8858af6ec9f32788$var$getSerializedStylesMap('fontWeight', $8858af6ec9f32788$export$303e322c6b1ed114);
const $8858af6ec9f32788$export$68cc305da27dbaa4 = $8858af6ec9f32788$var$getSerializedStylesMap('fontFamily', $8858af6ec9f32788$export$3c7e9587132614b4);
const $8858af6ec9f32788$export$128f10c238242f83 = $8858af6ec9f32788$var$getSerializedStylesMap('font', $8858af6ec9f32788$export$6cc560b4dedf3816);
const $8858af6ec9f32788$export$ff257d957d48c421 = $8858af6ec9f32788$var$getSerializedStylesMap((0, $axYky.CURRENT_SURFACE_CSS_VAR), $8858af6ec9f32788$export$41a358c9c2356760);
const $8858af6ec9f32788$export$5e65a44e5b6ecadb = (color)=>$8858af6ec9f32788$export$41a358c9c2356760[color] !== undefined;

});

parcelRegister("344PY", function(module, exports) {

$parcel$export(module.exports, "parseXcss", () => $23b57f67d37a74c8$export$a9c84988c8f81f2d);
$parcel$export(module.exports, "xcss", () => $23b57f67d37a74c8$export$f6c783d06584602c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $bHLFn = parcelRequire("bHLFn");

var $2fFJv = parcelRequire("2fFJv");
const $23b57f67d37a74c8$export$9a199fbafee0014e = {
    backgroundColor: (0, $bHLFn.backgroundColorMap),
    blockSize: (0, $bHLFn.dimensionMap),
    borderBlockColor: (0, $bHLFn.borderColorMap),
    borderBlockEndColor: (0, $bHLFn.borderColorMap),
    borderBlockEndWidth: (0, $bHLFn.borderWidthMap),
    borderBlockStartColor: (0, $bHLFn.borderColorMap),
    borderBlockStartWidth: (0, $bHLFn.borderWidthMap),
    borderBlockWidth: (0, $bHLFn.borderWidthMap),
    borderBottomColor: (0, $bHLFn.borderColorMap),
    borderBottomLeftRadius: (0, $bHLFn.borderRadiusMap),
    borderBottomRightRadius: (0, $bHLFn.borderRadiusMap),
    borderBottomWidth: (0, $bHLFn.borderWidthMap),
    borderColor: (0, $bHLFn.borderColorMap),
    borderEndEndRadius: (0, $bHLFn.borderRadiusMap),
    borderEndStartRadius: (0, $bHLFn.borderRadiusMap),
    borderInlineColor: (0, $bHLFn.borderColorMap),
    borderInlineEndColor: (0, $bHLFn.borderColorMap),
    borderInlineEndWidth: (0, $bHLFn.borderWidthMap),
    borderInlineStartColor: (0, $bHLFn.borderColorMap),
    borderInlineStartWidth: (0, $bHLFn.borderWidthMap),
    borderInlineWidth: (0, $bHLFn.borderWidthMap),
    borderLeftColor: (0, $bHLFn.borderColorMap),
    borderLeftWidth: (0, $bHLFn.borderWidthMap),
    borderRadius: (0, $bHLFn.borderRadiusMap),
    borderRightColor: (0, $bHLFn.borderColorMap),
    borderRightWidth: (0, $bHLFn.borderWidthMap),
    borderStartEndRadius: (0, $bHLFn.borderRadiusMap),
    borderStartStartRadius: (0, $bHLFn.borderRadiusMap),
    borderTopColor: (0, $bHLFn.borderColorMap),
    borderTopLeftRadius: (0, $bHLFn.borderRadiusMap),
    borderTopRightRadius: (0, $bHLFn.borderRadiusMap),
    borderTopWidth: (0, $bHLFn.borderWidthMap),
    borderWidth: (0, $bHLFn.borderWidthMap),
    bottom: (0, $bHLFn.allSpaceMap),
    boxShadow: (0, $bHLFn.shadowMap),
    color: (0, $bHLFn.textColorMap),
    columnGap: (0, $bHLFn.positiveSpaceMap),
    gap: (0, $bHLFn.positiveSpaceMap),
    height: (0, $bHLFn.dimensionMap),
    inlineSize: (0, $bHLFn.dimensionMap),
    inset: (0, $bHLFn.allSpaceMap),
    insetBlock: (0, $bHLFn.allSpaceMap),
    insetBlockEnd: (0, $bHLFn.allSpaceMap),
    insetBlockStart: (0, $bHLFn.allSpaceMap),
    insetInline: (0, $bHLFn.allSpaceMap),
    insetInlineEnd: (0, $bHLFn.allSpaceMap),
    insetInlineStart: (0, $bHLFn.allSpaceMap),
    left: (0, $bHLFn.allSpaceMap),
    margin: (0, $bHLFn.allSpaceMap),
    marginBlock: (0, $bHLFn.allSpaceMap),
    marginBlockEnd: (0, $bHLFn.allSpaceMap),
    marginBlockStart: (0, $bHLFn.allSpaceMap),
    marginBottom: (0, $bHLFn.allSpaceMap),
    marginInline: (0, $bHLFn.allSpaceMap),
    marginInlineEnd: (0, $bHLFn.allSpaceMap),
    marginInlineStart: (0, $bHLFn.allSpaceMap),
    marginLeft: (0, $bHLFn.allSpaceMap),
    marginRight: (0, $bHLFn.allSpaceMap),
    marginTop: (0, $bHLFn.allSpaceMap),
    maxBlockSize: (0, $bHLFn.dimensionMap),
    maxHeight: (0, $bHLFn.dimensionMap),
    maxInlineSize: (0, $bHLFn.dimensionMap),
    maxWidth: (0, $bHLFn.dimensionMap),
    minBlockSize: (0, $bHLFn.dimensionMap),
    minHeight: (0, $bHLFn.dimensionMap),
    minInlineSize: (0, $bHLFn.dimensionMap),
    minWidth: (0, $bHLFn.dimensionMap),
    opacity: (0, $bHLFn.opacityMap),
    outlineColor: (0, $bHLFn.borderColorMap),
    outlineOffset: (0, $bHLFn.positiveSpaceMap),
    outlineWidth: (0, $bHLFn.borderWidthMap),
    padding: (0, $bHLFn.positiveSpaceMap),
    paddingBlock: (0, $bHLFn.positiveSpaceMap),
    paddingBlockEnd: (0, $bHLFn.positiveSpaceMap),
    paddingBlockStart: (0, $bHLFn.positiveSpaceMap),
    paddingBottom: (0, $bHLFn.positiveSpaceMap),
    paddingInline: (0, $bHLFn.positiveSpaceMap),
    paddingInlineEnd: (0, $bHLFn.positiveSpaceMap),
    paddingInlineStart: (0, $bHLFn.positiveSpaceMap),
    paddingLeft: (0, $bHLFn.positiveSpaceMap),
    paddingRight: (0, $bHLFn.positiveSpaceMap),
    paddingTop: (0, $bHLFn.positiveSpaceMap),
    right: (0, $bHLFn.allSpaceMap),
    rowGap: (0, $bHLFn.positiveSpaceMap),
    top: (0, $bHLFn.allSpaceMap),
    width: (0, $bHLFn.dimensionMap),
    zIndex: (0, $bHLFn.layerMap)
};
const $23b57f67d37a74c8$var$uniqueSymbol = Symbol('UNSAFE_INTERNAL_styles');
const $23b57f67d37a74c8$var$isSafeEnvToThrow = ()=>typeof $2fFJv === 'object' && typeof $2fFJv.env === 'object' && false;
const $23b57f67d37a74c8$var$reNestedSelectors = /(\.|\s|&+|\*\>|#|\[.*\])/;
const $23b57f67d37a74c8$var$safeSelectors = /^@media .*$|^::?.*$|^@supports .*$/;
const $23b57f67d37a74c8$var$transformStyles = (styleObj)=>{
    if (!styleObj || typeof styleObj !== 'object') return styleObj;
    // If styles are defined as a CSSObject[], recursively call on each element until we reach CSSObject
    if (Array.isArray(styleObj)) return styleObj.map($23b57f67d37a74c8$var$transformStyles);
    // Modifies styleObj in place. Be careful.
    Object.entries(styleObj).forEach(([key, value])=>{
        // If key is a pseudo class or a pseudo element, then value should be an object.
        // So, call transformStyles on the value
        if (typeof value === 'object' && $23b57f67d37a74c8$var$safeSelectors.test(key)) {
            styleObj[key] = $23b57f67d37a74c8$var$transformStyles(value);
            return;
        }
        if ($23b57f67d37a74c8$var$isSafeEnvToThrow()) {
            // We don't support `.class`, `[data-testid]`, `> *`, `#some-id`
            if ($23b57f67d37a74c8$var$reNestedSelectors.test(key)) throw new Error(`Styles not supported for key '${key}'.`);
        }
        // We have now dealt with all the special cases, so,
        // check whether what remains is a style property
        // that can be transformed.
        if (!(key in $23b57f67d37a74c8$export$9a199fbafee0014e)) return;
        const tokenValue = $23b57f67d37a74c8$export$9a199fbafee0014e[key][value];
        styleObj[key] = tokenValue !== null && tokenValue !== void 0 ? tokenValue : value;
    });
    return styleObj;
};
const $23b57f67d37a74c8$var$baseXcss = (style)=>{
    const transformedStyles = $23b57f67d37a74c8$var$transformStyles(style);
    return {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        [$23b57f67d37a74c8$var$uniqueSymbol]: (0, $byn9U.css)(transformedStyles)
    };
};
const $23b57f67d37a74c8$export$a9c84988c8f81f2d = (args)=>{
    if (Array.isArray(args)) {
        const emotion = [];
        const staticArr = [];
        for (const arg of args){
            const result = $23b57f67d37a74c8$export$a9c84988c8f81f2d(arg);
            if (result.emotion) emotion.push(...result.emotion);
            if (result.static) staticArr.push(result.static);
        }
        return {
            emotion: emotion,
            static: staticArr.join(' ')
        };
    }
    const objArgs = args;
    const { [$23b57f67d37a74c8$var$uniqueSymbol]: styles } = objArgs || {};
    if (styles) return {
        emotion: [
            styles
        ]
    };
    if (args) {
        // We use string interpolation here instead of .toString() just
        // in case the resulting object doesn't have the method available.
        const stringifiedArgs = `${args}`;
        if (stringifiedArgs) return {
            static: stringifiedArgs
        };
    }
    return {};
};
function $23b57f67d37a74c8$export$f6c783d06584602c(style) {
    return $23b57f67d37a74c8$var$baseXcss(style);
}

});


parcelRegister("2RJuk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2163d0fe444199c1$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $6HLik = parcelRequire("6HLik");

var $5rSKK = parcelRequire("5rSKK");

var $j6alF = parcelRequire("j6alF");
/**
 * __Use default button base__
 *
 * A React hook that accepts a set of default Button props,
 * and processes them to return consistent base props for usage
 * across Button and LinkButton variants.
 *
 * @private
 */ const $2163d0fe444199c1$var$useDefaultButton = ({ analyticsContext: analyticsContext, appearance: appearance, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, autoFocus: autoFocus, buttonType: buttonType, children: children, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, ref: ref, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, UNSAFE_iconAfter_size: UNSAFE_iconAfter_size, UNSAFE_iconBefore_size: UNSAFE_iconBefore_size })=>{
    const baseProps = (0, $j6alF.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, iconBefore && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HLik.default), {
            type: "icon",
            position: "before",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5rSKK.default), {
            icon: iconBefore,
            size: UNSAFE_iconBefore_size
        })), children && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HLik.default), {
            isLoading: isLoading
        }, children), iconAfter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HLik.default), {
            type: "icon",
            position: "after",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5rSKK.default), {
            icon: iconAfter,
            size: UNSAFE_iconAfter_size
        }))),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        hasIconBefore: Boolean(iconBefore),
        hasIconAfter: Boolean(iconAfter)
    });
    return baseProps;
};
var $2163d0fe444199c1$export$2e2bcd8739ae039 = $2163d0fe444199c1$var$useDefaultButton;

});
parcelRegister("6HLik", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e1b71f2fa8a7ac0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $adisG = parcelRequire("adisG");
var $344PY = parcelRequire("344PY");
const $4e1b71f2fa8a7ac0$var$textStyles = (0, $344PY.xcss)({
    // content can grow and shrink
    flexGrow: 1,
    flexShrink: 1,
    // ellipsis for overflow text
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $4e1b71f2fa8a7ac0$var$iconStyles = (0, $344PY.xcss)({
    display: 'flex',
    // icon size cannot grow and shrink
    flexGrow: 0,
    flexShrink: 0,
    alignSelf: 'center',
    fontSize: 0,
    lineHeight: 0,
    userSelect: 'none'
});
const $4e1b71f2fa8a7ac0$var$commonStyles = (0, $344PY.xcss)({
    transition: 'opacity 0.3s'
});
const $4e1b71f2fa8a7ac0$var$fadeStyles = (0, $344PY.xcss)({
    opacity: 0
});
/**
 * These CSS variables consumed by the new icons, to allow them to have appropriate
 * padding inside Button while also maintaining spacing for the existing icons.
 *
 * These styles can be removed once the new icons are fully rolled out, feature flag
 * platform.design-system-team.enable-new-icons is cleaned up,
 * and we bump Button to set padding based on the new icons.
 */ const $4e1b71f2fa8a7ac0$var$beforeIconStyles = (0, $344PY.xcss)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-050, 4px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-025, 2px)"
});
const $4e1b71f2fa8a7ac0$var$afterIconStyles = (0, $344PY.xcss)({
    // @ts-ignore
    '--ds--button--new-icon-padding-start': "var(--ds-space-025, 2px)",
    // @ts-ignore
    '--ds--button--new-icon-padding-end': "var(--ds-space-050, 4px)"
});
/**
 * __Content__
 *
 * Used for slots within a Button, including icons and text content.
 */ const $4e1b71f2fa8a7ac0$var$Content = ({ children: children, type: type = 'text', isLoading: isLoading, position: position })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adisG.default), {
        as: "span",
        xcss: [
            $4e1b71f2fa8a7ac0$var$commonStyles,
            ...type === 'text' ? [
                $4e1b71f2fa8a7ac0$var$textStyles
            ] : [
                $4e1b71f2fa8a7ac0$var$iconStyles
            ],
            ...isLoading ? [
                $4e1b71f2fa8a7ac0$var$fadeStyles
            ] : [],
            ...position === 'before' ? [
                $4e1b71f2fa8a7ac0$var$beforeIconStyles
            ] : [],
            ...position === 'after' ? [
                $4e1b71f2fa8a7ac0$var$afterIconStyles
            ] : []
        ]
    }, children);
};
var $4e1b71f2fa8a7ac0$export$2e2bcd8739ae039 = $4e1b71f2fa8a7ac0$var$Content;

});
parcelRegister("adisG", function(module, exports) {

$parcel$export(module.exports, "default", () => $76f97062049ba634$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $bHLFn = parcelRequire("bHLFn");

var $344PY = parcelRequire("344PY");

var $4Xwgf = parcelRequire("4Xwgf");
const $76f97062049ba634$export$e71c4d32a2263218 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'div', children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, style: style, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $344PY.parseXcss)(xcss);
    const node = // @ts-expect-error Expression produces a union type that is too complex to represent. I think this is unavoidable
    (0, $byn9U.jsx)(Component, (0, $kU09D.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        css: [
            $76f97062049ba634$var$baseStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $bHLFn.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $bHLFn.isSurfaceColorToken)(backgroundColor) && (0, $bHLFn.surfaceColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $bHLFn.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $bHLFn.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $bHLFn.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $bHLFn.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $bHLFn.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $bHLFn.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $bHLFn.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId
    }), children);
    return backgroundColor ? (0, $byn9U.jsx)((0, $4Xwgf.SurfaceContext).Provider, {
        value: backgroundColor
    }, node) : node;
});
var $76f97062049ba634$export$2e2bcd8739ae039 = $76f97062049ba634$export$e71c4d32a2263218;
const $76f97062049ba634$var$baseStyles = (0, $byn9U.css)({
    boxSizing: 'border-box',
    appearance: 'none',
    border: 'none'
});

});
parcelRegister("4Xwgf", function(module, exports) {

$parcel$export(module.exports, "SurfaceContext", () => $39c5b27f2bd1b869$export$1ca2a26fecb070ae);

var $eUqFw = parcelRequire("eUqFw");
const $39c5b27f2bd1b869$export$1ca2a26fecb070ae = /*#__PURE__*/ (0, $eUqFw.createContext)('elevation.surface');
const $39c5b27f2bd1b869$export$1aeb4f6b93c4540d = ()=>{
    return (0, $eUqFw.useContext)($39c5b27f2bd1b869$export$1ca2a26fecb070ae);
};
$39c5b27f2bd1b869$export$1ca2a26fecb070ae.displayName = 'SurfaceProvider';

});



parcelRegister("5rSKK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f79f23104c7ce9c$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");
function $3f79f23104c7ce9c$var$isIconRenderProp(func) {
    return !func.displayName && // most function components and class components have a displayName, negate them
    !func.render && // forwardRef doesn't require a display name, however it does include a render function, negate them
    typeof func === 'function' // at the very least we need to be a function
    ;
}
/**
 * __Icon renderer__
 *
 * Used to support render props with icons.
 *
 */ const $3f79f23104c7ce9c$var$IconRenderer = ({ icon: Icon, size: size })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, $3f79f23104c7ce9c$var$isIconRenderProp(Icon) ? Icon({
        label: '',
        size: size,
        color: 'currentColor'
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Icon, {
        label: "",
        size: size,
        color: 'currentColor'
    }));
};
var $3f79f23104c7ce9c$export$2e2bcd8739ae039 = $3f79f23104c7ce9c$var$IconRenderer;

});

parcelRegister("j6alF", function(module, exports) {

$parcel$export(module.exports, "default", () => $de769ad53acd95ab$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $tkrFt = parcelRequire("tkrFt");

var $2lroc = parcelRequire("2lroc");

var $fogbu = parcelRequire("fogbu");

var $3puyA = parcelRequire("3puyA");

var $adisG = parcelRequire("adisG");
var $344PY = parcelRequire("344PY");

var $j0gMm = parcelRequire("j0gMm");

var $lWrn5 = parcelRequire("lWrn5");

var $kJNpV = parcelRequire("kJNpV");

var $23NoQ = parcelRequire("23NoQ");


var $i07Qb = parcelRequire("i07Qb");
const $de769ad53acd95ab$var$buttonStyles = (0, $344PY.xcss)({
    display: 'inline-flex',
    boxSizing: 'border-box',
    width: 'auto',
    maxWidth: '100%',
    position: 'relative',
    alignItems: 'baseline',
    justifyContent: 'center',
    columnGap: 'space.050',
    borderRadius: 'border.radius.100',
    borderWidth: 'border.width.0',
    flexShrink: 0,
    height: `${32 / 14}em`,
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    textAlign: 'center',
    transition: 'background 0.1s ease-out',
    verticalAlign: 'middle',
    '::after': {
        borderRadius: 'inherit',
        inset: 'space.0',
        borderStyle: 'solid',
        borderWidth: "var(--ds-border-width, 1px)",
        pointerEvents: 'none',
        position: 'absolute'
    }
});
const $de769ad53acd95ab$var$hardCodedButtonStyles = (0, $344PY.xcss)({
    fontFamily: 'inherit',
    fontSize: 'inherit',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: `${32 / 14}em`,
    paddingBlock: 'space.0'
});
const $de769ad53acd95ab$var$tokenizedButtonStyles = (0, $344PY.xcss)({
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-medium, 500)",
    paddingBlock: 'space.075'
});
const $de769ad53acd95ab$var$defaultInteractiveStyles = (0, $344PY.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-hovered, #091e4214)",
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text, ${$j0gMm.N500})`
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-neutral-pressed, ${$j0gMm.B75})`,
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text, ${$j0gMm.B400})`
    }
});
const $de769ad53acd95ab$var$defaultInteractiveRefreshedStyles = (0, $344PY.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #091E4224)",
        color: 'color.text.subtle'
    }
});
const $de769ad53acd95ab$var$defaultStyles = (0, $344PY.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values
    background: `var(--ds-background-neutral, ${$j0gMm.N20A})`,
    // @ts-expect-error — using tokens for explicit fallback usage.
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values --  -- Ignored via go/DSP-18766
    color: `var(--ds-text, ${$j0gMm.N500})`,
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text, ${$j0gMm.N500})`
    }
});
const $de769ad53acd95ab$var$defaultRefreshedStyles = (0, $344PY.xcss)({
    background: "var(--ds-background-neutral-subtle, #00000000)",
    color: 'color.text.subtle',
    '::after': {
        content: '""',
        borderColor: 'color.border'
    },
    ':visited': {
        color: 'color.text.subtle'
    }
});
const $de769ad53acd95ab$var$primaryStyles = (0, $344PY.xcss)({
    background: "var(--ds-background-brand-bold, #0052CC)",
    // @ts-expect-error
    color: "var(--ds-text-inverse, #FFFFFF)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)"
    }
});
const $de769ad53acd95ab$var$primaryInteractiveStyles = (0, $344PY.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-hovered, #0065FF)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-inverse, #FFFFFF)",
        background: "var(--ds-background-brand-bold-pressed, #0747A6)"
    }
});
const $de769ad53acd95ab$var$warningStyles = (0, $344PY.xcss)({
    background: "var(--ds-background-warning-bold, #FFAB00)",
    // @ts-expect-error
    color: "var(--ds-text-warning-inverse, #172B4D)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)"
    }
});
const $de769ad53acd95ab$var$warningInteractiveStyles = (0, $344PY.xcss)({
    ':hover': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-hovered, #FFC400)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-text-warning-inverse, #172B4D)",
        background: "var(--ds-background-warning-bold-pressed, #FF991F)"
    }
});
const $de769ad53acd95ab$var$dangerStyles = (0, $344PY.xcss)({
    background: "var(--ds-background-danger-bold, #DE350B)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
const $de769ad53acd95ab$var$dangerInteractiveStyles = (0, $344PY.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-hovered, #FF5630)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-danger-bold-pressed, #BF2600)"
    }
});
const $de769ad53acd95ab$var$discoveryStyles = (0, $344PY.xcss)({
    background: "var(--ds-background-discovery-bold, #5243AA)",
    color: 'color.text.inverse',
    ':visited': {
        color: 'color.text.inverse'
    }
});
const $de769ad53acd95ab$var$discoveryInteractiveStyles = (0, $344PY.xcss)({
    ':hover': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-hovered, #8777D9)"
    },
    ':active': {
        color: 'color.text.inverse',
        background: "var(--ds-background-discovery-bold-pressed, #5243AA)"
    }
});
const $de769ad53acd95ab$var$subtleStyles = (0, $344PY.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    // @ts-expect-error
    color: "var(--ds-text, #42526E)",
    ':visited': {
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
const $de769ad53acd95ab$var$subtleRefreshedStyles = (0, $344PY.xcss)({
    background: "var(--ds-background-neutral-subtle, transparent)",
    color: 'color.text.subtle',
    ':visited': {
        color: 'color.text.subtle'
    }
});
const $de769ad53acd95ab$var$subtleInteractiveStyles = (0, $344PY.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        // @ts-expect-error
        color: "var(--ds-text, #42526E)"
    }
});
const $de769ad53acd95ab$var$subtleInteractiveRefreshedStyles = (0, $344PY.xcss)({
    ':hover': {
        background: "var(--ds-background-neutral-subtle-hovered, #091e4214)",
        color: 'color.text.subtle'
    },
    ':active': {
        background: "var(--ds-background-neutral-subtle-pressed, #B3D4FF)",
        color: 'color.text.subtle'
    }
});
const $de769ad53acd95ab$var$linkStyles = (0, $344PY.xcss)({
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-link, ${$j0gMm.B400})`,
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: 'none',
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-link, ${$j0gMm.B300})`,
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':active': {
        // @ts-expect-error
        color: "var(--ds-link-pressed, #0055CC)",
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-link, ${$j0gMm.B400})`
    }
});
const $de769ad53acd95ab$var$subtleLinkStyles = (0, $344PY.xcss)({
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-subtle, ${$j0gMm.N200})`,
    background: "var(--ds-background-neutral-subtle, transparent)",
    textDecoration: 'none',
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-subtle, ${$j0gMm.N90})`,
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text, ${$j0gMm.N400})`,
        background: "var(--ds-background-neutral-subtle, transparent)"
    },
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-subtle, ${$j0gMm.N200})`
    }
});
// Required due to Jira's AUI CSS reset: https://product-fabric.atlassian.net/browse/DSP-15687
const $de769ad53acd95ab$var$linkDecorationUnsetStyles = (0, $344PY.xcss)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'none'
    },
    ':active': {
        textDecoration: 'none'
    },
    ':focus': {
        textDecoration: 'none'
    }
});
const $de769ad53acd95ab$var$linkDecorationStyles = (0, $344PY.xcss)({
    ':hover': {
        textDecoration: 'underline'
    },
    ':focus': {
        textDecoration: 'underline'
    }
});
const $de769ad53acd95ab$var$disabledStyles = (0, $344PY.xcss)({
    cursor: 'not-allowed',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-disabled, ${$j0gMm.N20A})`,
    // @ts-expect-error
    color: "var(--ds-text-disabled, #091E424F)",
    ':hover': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-disabled, ${$j0gMm.N20A})`,
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    ':active': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-disabled, ${$j0gMm.N20A})`,
        // @ts-expect-error
        color: "var(--ds-text-disabled, #091E424F)"
    },
    '::after': {
        content: 'none'
    }
});
const $de769ad53acd95ab$var$selectedStyles = (0, $344PY.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-selected, ${$j0gMm.N700})`,
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-selected, ${$j0gMm.N20})`,
    ':visited': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$j0gMm.N20})`
    }
});
const $de769ad53acd95ab$var$selectedRefreshedStyles = (0, $344PY.xcss)({
    background: "var(--ds-background-selected, #E9F2FF)",
    color: 'color.text.selected',
    '::after': {
        content: '""',
        borderColor: 'color.border.selected'
    },
    ':visited': {
        color: 'color.text.selected'
    }
});
const $de769ad53acd95ab$var$selectedInsideSplitButtonStyles = (0, $344PY.xcss)({
    // This is 2 so it appears above the split button divider when selected.
    // See split-button.tsx.
    // @ts-expect-error — We need a local zindex just for button.
    zIndex: 2
});
const $de769ad53acd95ab$var$selectedInteractiveStyles = (0, $344PY.xcss)({
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$j0gMm.N20})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected-hovered, ${$j0gMm.N700})`
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$j0gMm.N20})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected-pressed, ${$j0gMm.N700})`
    }
});
// TODO: Remove me once we kill color fallbacks
const $de769ad53acd95ab$var$selectedWarningStyles = (0, $344PY.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-selected, ${$j0gMm.Y400})`,
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-selected, ${$j0gMm.N800})`,
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$j0gMm.N20})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected, ${$j0gMm.Y400})`
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$j0gMm.N20})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected, ${$j0gMm.Y400})`
    }
});
// TODO: Remove me once we kill color fallbacks
const $de769ad53acd95ab$var$selectedDangerStyles = (0, $344PY.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    background: `var(--ds-background-selected, ${$j0gMm.R500})`,
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-selected, ${$j0gMm.N20})`,
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$j0gMm.N20})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected, ${$j0gMm.R500})`
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$j0gMm.N20})`,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        background: `var(--ds-background-selected, ${$j0gMm.R500})`
    }
});
// TODO: Remove me once we kill color fallbacks
const $de769ad53acd95ab$var$selectedDiscoveryStyles = (0, $344PY.xcss)({
    background: "var(--ds-background-selected, #403294)",
    // @ts-expect-error
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    color: `var(--ds-text-selected, ${$j0gMm.N20})`,
    ':hover': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$j0gMm.N20})`,
        background: "var(--ds-background-selected, #403294)"
    },
    ':active': {
        // @ts-expect-error
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        color: `var(--ds-text-selected, ${$j0gMm.N20})`,
        background: "var(--ds-background-selected, #403294)"
    }
});
const $de769ad53acd95ab$var$spacingCompactStyles = (0, $344PY.xcss)({
    columnGap: 'space.050',
    height: `${24 / 14}em`,
    paddingInlineEnd: 'space.150',
    paddingInlineStart: 'space.150',
    verticalAlign: 'middle'
});
const $de769ad53acd95ab$var$baseSpacingCompactStyles = (0, $344PY.xcss)({
    lineHeight: `${24 / 14}em`
});
const $de769ad53acd95ab$var$tokenizedSpacingCompactStyles = (0, $344PY.xcss)({
    paddingBlock: 'space.025'
});
const $de769ad53acd95ab$var$spacingNoneStyles = (0, $344PY.xcss)({
    columnGap: 'space.0',
    height: 'auto',
    lineHeight: 'inherit',
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0',
    verticalAlign: 'baseline'
});
const $de769ad53acd95ab$var$tokenizedSpacingNoneStyles = (0, $344PY.xcss)({
    paddingBlock: 'space.0'
});
const $de769ad53acd95ab$var$circleStyles = (0, $344PY.xcss)({
    borderRadius: 'border.radius.circle'
});
const $de769ad53acd95ab$var$fullWidthStyles = (0, $344PY.xcss)({
    width: '100%'
});
const $de769ad53acd95ab$var$loadingStyles = (0, $344PY.xcss)({
    cursor: 'progress'
});
const $de769ad53acd95ab$var$iconButtonStyles = (0, $344PY.xcss)({
    height: `${32 / 14}em`,
    width: `${32 / 14}em`,
    paddingInlineEnd: 'space.0',
    paddingInlineStart: 'space.0'
});
const $de769ad53acd95ab$var$iconButtonCompactStyles = (0, $344PY.xcss)({
    width: `${24 / 14}em`,
    height: `${24 / 14}em`
});
const $de769ad53acd95ab$var$buttonIconBeforeStyles = (0, $344PY.xcss)({
    paddingInlineStart: 'space.100'
});
const $de769ad53acd95ab$var$buttonIconAfterStyles = (0, $344PY.xcss)({
    paddingInlineEnd: 'space.100'
});
const $de769ad53acd95ab$var$splitButtonStyles = (0, $344PY.xcss)({
    ':focus-visible': {
        zIndex: 'card'
    }
});
const $de769ad53acd95ab$var$navigationSplitButtonStyles = (0, $344PY.xcss)({
    width: '24px',
    backgroundColor: 'color.background.neutral.subtle',
    paddingInlineEnd: 'space.075',
    paddingInlineStart: 'space.075'
});
const $de769ad53acd95ab$var$loadingOverlayStyles = (0, $344PY.xcss)({
    display: 'flex',
    position: 'absolute',
    alignItems: 'center',
    justifyContent: 'center',
    insetBlockEnd: 'space.0',
    insetBlockStart: 'space.0',
    insetInlineEnd: 'space.0',
    insetInlineStart: 'space.0'
});
/**
 * __Use button base__
 *
 * A React hook that accepts a set of common Button props,
 * and processes them to return consistent base props for usage
 * across various Button components.
 *
 * It also:
 * - Implements auto focus when enabled.
 * - Appends the `onClick` event with UFO analytics tracking.
 *
 * @private
 */ const $de769ad53acd95ab$var$useButtonBase = ({ appearance: propAppearance = 'default', autoFocus: autoFocus = false, isDisabled: propIsDisabled = false, isLoading: isLoading = false, isSelected: propIsSelected = false, isIconButton: // TODO: Separate Icon Button styling from button base
isIconButton = false, isCircle: isCircle = false, hasIconBefore: // TODO: Separate icon slot styling from button base
hasIconBefore = false, hasIconAfter: hasIconAfter = false, children: children, onClick: onClick, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onTouchStartCapture: onTouchStartCapture, onTouchEndCapture: onTouchEndCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onClickCapture: onClickCapture, ref: ref, shouldFitContainer: shouldFitContainer = false, spacing: propSpacing = 'default', testId: testId, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy })=>{
    const localRef = (0, $eUqFw.useRef)(null);
    const splitButtonContext = (0, $kJNpV.useSplitButtonContext)();
    // TODO: Use React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    const loadingLabelId = (0, $tkrFt.uid)({
        ariaLabelledBy: ariaLabelledBy
    });
    const isSplitButton = Boolean(splitButtonContext);
    const isNavigationSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isNavigationSplitButton) || false;
    const isDefaultAppearanceSplitButton = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) === 'default';
    const appearance = isDefaultAppearanceSplitButton && (0, $3puyA.fg)('platform.design-system-team.component-visual-refresh_t8zbo') ? 'subtle' : (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.appearance) || propAppearance;
    const spacing = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.spacing) || propSpacing;
    const isDisabled = (splitButtonContext === null || splitButtonContext === void 0 ? void 0 : splitButtonContext.isDisabled) || propIsDisabled;
    const isInteractive = !isDisabled && !isLoading;
    // Also treat loading buttons as disabled
    const isEffectivelyDisabled = isDisabled || isLoading;
    const isSelected = propIsSelected && !isDisabled;
    (0, $fogbu.default)(localRef, autoFocus);
    return {
        ref: (0, $2lroc.default)([
            localRef,
            ref
        ]),
        xcss: [
            (0, $3puyA.fg)('platform.design-system-team.button-tokenised-typography-styles') ? $de769ad53acd95ab$var$tokenizedButtonStyles : $de769ad53acd95ab$var$hardCodedButtonStyles,
            $de769ad53acd95ab$var$buttonStyles,
            appearance === 'default' && ((0, $3puyA.fg)('platform.design-system-team.component-visual-refresh_t8zbo') ? $de769ad53acd95ab$var$defaultRefreshedStyles : $de769ad53acd95ab$var$defaultStyles),
            appearance === 'default' && isInteractive && ((0, $3puyA.fg)('platform.design-system-team.component-visual-refresh_t8zbo') ? $de769ad53acd95ab$var$defaultInteractiveRefreshedStyles : $de769ad53acd95ab$var$defaultInteractiveStyles),
            appearance === 'primary' && $de769ad53acd95ab$var$primaryStyles,
            appearance === 'primary' && isInteractive && $de769ad53acd95ab$var$primaryInteractiveStyles,
            appearance === 'warning' && $de769ad53acd95ab$var$warningStyles,
            appearance === 'warning' && isInteractive && $de769ad53acd95ab$var$warningInteractiveStyles,
            appearance === 'danger' && $de769ad53acd95ab$var$dangerStyles,
            appearance === 'danger' && isInteractive && $de769ad53acd95ab$var$dangerInteractiveStyles,
            appearance === 'discovery' && $de769ad53acd95ab$var$discoveryStyles,
            appearance === 'discovery' && isInteractive && $de769ad53acd95ab$var$discoveryInteractiveStyles,
            appearance === 'subtle' && ((0, $3puyA.fg)('platform.design-system-team.component-visual-refresh_t8zbo') ? $de769ad53acd95ab$var$subtleRefreshedStyles : $de769ad53acd95ab$var$subtleStyles),
            appearance === 'subtle' && isInteractive && ((0, $3puyA.fg)('platform.design-system-team.component-visual-refresh_t8zbo') ? $de769ad53acd95ab$var$subtleInteractiveRefreshedStyles : $de769ad53acd95ab$var$subtleInteractiveStyles),
            appearance === 'link' && $de769ad53acd95ab$var$linkStyles,
            appearance === 'subtle-link' && $de769ad53acd95ab$var$subtleLinkStyles,
            !isSelected && (appearance === 'link' || appearance === 'subtle-link') ? $de769ad53acd95ab$var$linkDecorationStyles : $de769ad53acd95ab$var$linkDecorationUnsetStyles,
            isSelected && ((0, $3puyA.fg)('platform.design-system-team.component-visual-refresh_t8zbo') ? $de769ad53acd95ab$var$selectedRefreshedStyles : $de769ad53acd95ab$var$selectedStyles),
            isSelected && isSplitButton && $de769ad53acd95ab$var$selectedInsideSplitButtonStyles,
            isSelected && isInteractive && $de769ad53acd95ab$var$selectedInteractiveStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'danger' && $de769ad53acd95ab$var$selectedDangerStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'warning' && $de769ad53acd95ab$var$selectedWarningStyles,
            // TODO: remove me once we kill color fallbacks
            isSelected && appearance === 'discovery' && $de769ad53acd95ab$var$selectedDiscoveryStyles,
            isDisabled && $de769ad53acd95ab$var$disabledStyles,
            isCircle && !isSplitButton && $de769ad53acd95ab$var$circleStyles,
            spacing === 'compact' && $de769ad53acd95ab$var$spacingCompactStyles,
            spacing === 'compact' && ((0, $3puyA.fg)('platform.design-system-team.button-tokenised-typography-styles') ? $de769ad53acd95ab$var$tokenizedSpacingCompactStyles : $de769ad53acd95ab$var$baseSpacingCompactStyles),
            spacing === 'none' && $de769ad53acd95ab$var$spacingNoneStyles,
            spacing === 'none' && (0, $3puyA.fg)('platform.design-system-team.button-tokenised-typography-styles') && $de769ad53acd95ab$var$tokenizedSpacingNoneStyles,
            spacing !== 'none' && hasIconBefore && $de769ad53acd95ab$var$buttonIconBeforeStyles,
            spacing !== 'none' && hasIconAfter && $de769ad53acd95ab$var$buttonIconAfterStyles,
            isIconButton && $de769ad53acd95ab$var$iconButtonStyles,
            isIconButton && spacing === 'compact' && $de769ad53acd95ab$var$iconButtonCompactStyles,
            shouldFitContainer && $de769ad53acd95ab$var$fullWidthStyles,
            isLoading && $de769ad53acd95ab$var$loadingStyles,
            isSplitButton && $de769ad53acd95ab$var$splitButtonStyles,
            isNavigationSplitButton && $de769ad53acd95ab$var$navigationSplitButtonStyles
        ],
        isDisabled: isEffectivelyDisabled,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Fragment), null, children, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $adisG.default), {
            as: "span",
            xcss: $de769ad53acd95ab$var$loadingOverlayStyles
        }, (0, $i07Qb.default)({
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected,
            testId: testId
        })) : null, isLoading && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWrn5.default), {
            id: loadingLabelId
        }, (0, $c1c0cf53543233ce$export$d4c5499dc806c969))),
        'aria-label': isLoading && ariaLabel && !ariaLabelledBy ? `${ariaLabel} ${0, $c1c0cf53543233ce$export$d4c5499dc806c969}` : ariaLabel,
        'aria-labelledby': isLoading && ariaLabelledBy ? `${ariaLabelledBy} ${loadingLabelId}` : ariaLabelledBy,
        ...(0, $23NoQ.default)(isEffectivelyDisabled, {
            onClick: onClick,
            onMouseDownCapture: onMouseDownCapture,
            onMouseUpCapture: onMouseUpCapture,
            onKeyDownCapture: onKeyDownCapture,
            onKeyUpCapture: onKeyUpCapture,
            onTouchStartCapture: onTouchStartCapture,
            onTouchEndCapture: onTouchEndCapture,
            onPointerDownCapture: onPointerDownCapture,
            onPointerUpCapture: onPointerUpCapture,
            onClickCapture: onClickCapture
        })
    };
};
var $de769ad53acd95ab$export$2e2bcd8739ae039 = $de769ad53acd95ab$var$useButtonBase;

});
parcelRegister("kJNpV", function(module, exports) {

$parcel$export(module.exports, "useSplitButtonContext", () => $f18e57d8c555f145$export$47e2c6fdb142d947);

var $eUqFw = parcelRequire("eUqFw");
const $f18e57d8c555f145$export$4b86304b2c0d7e71 = /*#__PURE__*/ (0, $eUqFw.createContext)(undefined);
const $f18e57d8c555f145$export$47e2c6fdb142d947 = ()=>{
    const context = (0, $eUqFw.useContext)($f18e57d8c555f145$export$4b86304b2c0d7e71);
    if (!context) return undefined;
    if (context.appearance === 'navigation') {
        const newContext = {
            spacing: 'default',
            appearance: 'subtle',
            isDisabled: false,
            isActiveOverSelected: false,
            isNavigationSplitButton: true,
            isHighlighted: context.isHighlighted
        };
        return newContext;
    }
    const splitButtonContext = {
        spacing: context.spacing,
        appearance: context.appearance,
        isDisabled: context.isDisabled,
        isActiveOverSelected: true,
        isNavigationSplitButton: false,
        isHighlighted: false
    };
    return splitButtonContext;
};

});

parcelRegister("23NoQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $18022e5b85ded6af$export$2e2bcd8739ae039);
function $18022e5b85ded6af$var$abort(event) {
    event.preventDefault();
    event.stopPropagation();
}
const $18022e5b85ded6af$var$tabKeyCode = 9;
function $18022e5b85ded6af$var$onKey(event) {
    // Allowing tab so that a user can move focus away
    if (event.keyCode === $18022e5b85ded6af$var$tabKeyCode) return;
    $18022e5b85ded6af$var$abort(event);
}
function $18022e5b85ded6af$export$2e2bcd8739ae039(shouldBlockEvents, events) {
    return shouldBlockEvents ? {
        onMouseDownCapture: $18022e5b85ded6af$var$abort,
        onMouseUpCapture: $18022e5b85ded6af$var$abort,
        onKeyDownCapture: $18022e5b85ded6af$var$onKey,
        onKeyUpCapture: $18022e5b85ded6af$var$onKey,
        onTouchStartCapture: $18022e5b85ded6af$var$abort,
        onTouchEndCapture: $18022e5b85ded6af$var$abort,
        onPointerDownCapture: $18022e5b85ded6af$var$abort,
        onPointerUpCapture: $18022e5b85ded6af$var$abort,
        onClickCapture: $18022e5b85ded6af$var$abort,
        // Just smashing the existing onClick for good measure
        onClick: $18022e5b85ded6af$var$abort
    } : events;
}

});

const $c1c0cf53543233ce$export$d4c5499dc806c969 = ', Loading';

parcelRegister("i07Qb", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1ae4f0efb1b6614$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $hvCdF = parcelRequire("hvCdF");
function $d1ae4f0efb1b6614$var$getIconSpacing(spacing) {
    switch(spacing){
        case 'compact':
            return 'small';
        case 'none':
            return 'xsmall';
        default:
            return 'medium';
    }
}
function $d1ae4f0efb1b6614$var$getSpinnerAppearance({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected }) {
    if (isDisabled || isSelected) return 'inherit';
    if (appearance === 'primary' || appearance === 'danger' || appearance === 'discovery') return 'invert';
    return 'inherit';
}
function $d1ae4f0efb1b6614$export$2e2bcd8739ae039({ appearance: appearance, spacing: spacing, isDisabled: isDisabled, isSelected: isSelected, testId: testId }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hvCdF.default), {
        size: $d1ae4f0efb1b6614$var$getIconSpacing(spacing),
        appearance: $d1ae4f0efb1b6614$var$getSpinnerAppearance({
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }),
        testId: testId ? `${testId}--loading-spinner` : undefined
    });
}

});




parcelRegister("4xAW3", function(module, exports) {

$parcel$export(module.exports, "default", () => $34e6e514f574148c$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/styles/no-exported-styles */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $d4qUE = parcelRequire("d4qUE");

var $5QEVY = parcelRequire("5QEVY");
const $34e6e514f574148c$var$flexGrowMap = {
    hug: (0, $d4qUE.xcss)({
        flexGrow: 0
    }),
    fill: (0, $d4qUE.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
const $34e6e514f574148c$var$separatorStyles = (0, $byn9U.css)({
    color: "var(--ds-text-subtle, #42526E)",
    marginBlock: "var(--ds-space-0, 0px)",
    marginInline: `${"var(--ds-space-negative-025, -2px)"}`,
    pointerEvents: 'none',
    userSelect: 'none'
});
const $34e6e514f574148c$var$Separator = ({ children: children })=>(0, $byn9U.jsx)("span", {
        css: $34e6e514f574148c$var$separatorStyles
    }, children);
/**
 * __Inline__
 *
 * Inline is a primitive component based on CSS Flexbox that manages the horizontal layout of direct children.
 *
 * @example
 * ```tsx
 *  <Inline>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Inline>
 * ```
 *
 */ const $34e6e514f574148c$var$Inline = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, alignInline: alignInline, alignBlock: alignItems = 'start', shouldWrap: shouldWrap = false, spread: spread, grow: grow, space: space, rowSpace: rowSpace, separator: separator, xcss: xcss, testId: testId, role: role, children: rawChildren }, ref)=>{
    const separatorComponent = typeof separator === 'string' ? (0, $byn9U.jsx)($34e6e514f574148c$var$Separator, null, separator) : separator;
    const children = separatorComponent ? (0, $eUqFw.Children).toArray(rawChildren).filter(Boolean).map((child, index)=>{
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), {
            key: index
        }, separator && index > 0 ? separatorComponent : null, child);
    }) : rawChildren;
    const justifyContent = spread || alignInline;
    return (0, $byn9U.jsx)((0, $5QEVY.default), {
        as: as,
        role: role,
        alignItems: alignItems,
        justifyContent: justifyContent,
        direction: "row",
        gap: space,
        rowGap: rowSpace,
        wrap: shouldWrap ? 'wrap' : undefined,
        xcss: grow ? [
            $34e6e514f574148c$var$flexGrowMap[grow],
            ...Array.isArray(xcss) ? xcss : [
                xcss
            ]
        ] : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$34e6e514f574148c$var$Inline.displayName = 'Inline';
var $34e6e514f574148c$export$2e2bcd8739ae039 = $34e6e514f574148c$var$Inline;

});
parcelRegister("5QEVY", function(module, exports) {

$parcel$export(module.exports, "default", () => $44218fc023384c51$export$2e2bcd8739ae039);
/** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $g35uP = parcelRequire("g35uP");

var $d4qUE = parcelRequire("d4qUE");
const $44218fc023384c51$var$justifyContentMap = {
    start: (0, $byn9U.css)({
        justifyContent: 'start'
    }),
    center: (0, $byn9U.css)({
        justifyContent: 'center'
    }),
    end: (0, $byn9U.css)({
        justifyContent: 'end'
    }),
    'space-between': (0, $byn9U.css)({
        justifyContent: 'space-between'
    }),
    'space-around': (0, $byn9U.css)({
        justifyContent: 'space-around'
    }),
    'space-evenly': (0, $byn9U.css)({
        justifyContent: 'space-evenly'
    }),
    stretch: (0, $byn9U.css)({
        justifyContent: 'stretch'
    })
};
const $44218fc023384c51$var$flexDirectionMap = {
    column: (0, $byn9U.css)({
        flexDirection: 'column'
    }),
    row: (0, $byn9U.css)({
        flexDirection: 'row'
    })
};
const $44218fc023384c51$var$flexWrapMap = {
    wrap: (0, $byn9U.css)({
        flexWrap: 'wrap'
    }),
    nowrap: (0, $byn9U.css)({
        flexWrap: 'nowrap'
    })
};
const $44218fc023384c51$var$alignItemsMap = {
    start: (0, $byn9U.css)({
        alignItems: 'start'
    }),
    center: (0, $byn9U.css)({
        alignItems: 'center'
    }),
    baseline: (0, $byn9U.css)({
        alignItems: 'baseline'
    }),
    end: (0, $byn9U.css)({
        alignItems: 'end'
    }),
    stretch: (0, $byn9U.css)({
        alignItems: 'stretch'
    })
};
const $44218fc023384c51$var$baseStyles = (0, $byn9U.css)({
    display: 'flex',
    boxSizing: 'border-box'
});
/**
 * __Flex__
 *
 * `Flex` is a primitive component that implements the CSS Flexbox API.
 *
 * - [Examples](https://atlassian.design/components/primitives/flex/examples)
 * - [Code](https://atlassian.design/components/primitives/flex/code)
 *
 * @example
 * ```tsx
 * import { Flex, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Flex direction="column">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Flex>
 * )
 * ```
 */ const $44218fc023384c51$var$Flex = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: Component = 'div', role: role, alignItems: alignItems, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, testId: testId, direction: direction, wrap: wrap, xcss: xcss }, ref)=>{
    const xcssClassName = xcss && (0, $d4qUE.parseXcss)(xcss);
    return (0, $byn9U.jsx)(Component, {
        role: role,
        css: [
            $44218fc023384c51$var$baseStyles,
            gap && (0, $g35uP.spaceStylesMap).gap[gap],
            columnGap && (0, $g35uP.spaceStylesMap).columnGap[columnGap],
            rowGap && (0, $g35uP.spaceStylesMap).rowGap[rowGap],
            alignItems && $44218fc023384c51$var$alignItemsMap[alignItems],
            direction && $44218fc023384c51$var$flexDirectionMap[direction],
            justifyContent && $44218fc023384c51$var$justifyContentMap[justifyContent],
            wrap && $44218fc023384c51$var$flexWrapMap[wrap],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
            xcssClassName && xcssClassName
        ],
        "data-testid": testId,
        ref: ref
    }, children);
}));
$44218fc023384c51$var$Flex.displayName = 'Flex';
var $44218fc023384c51$export$2e2bcd8739ae039 = $44218fc023384c51$var$Flex;

});


parcelRegister("9kLPX", function(module, exports) {

$parcel$export(module.exports, "FilterPicker", () => $6cbb16c06231e631$export$34d80e8f7a481f89);

var $5zQU9 = parcelRequire("5zQU9");

var $4J2zX = parcelRequire("4J2zX");

var $eUqFw = parcelRequire("eUqFw");

var $UVwUc = parcelRequire("UVwUc");

var $i6Rym = parcelRequire("i6Rym");

var $2xDeC = parcelRequire("2xDeC");

var $lHkHI = parcelRequire("lHkHI");
function $6cbb16c06231e631$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6cbb16c06231e631$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6cbb16c06231e631$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6cbb16c06231e631$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $6cbb16c06231e631$export$34d80e8f7a481f89 = (_ref)=>{
    let { label: label, options: options, status: status, selectedOptions: selectedOptions = [], isMulti: isMulti = false, isPopupOpen: controlledIsPopupOpen, isSearchable: isSearchable = false, hasClearSelectionButton: hasClearSelectionButton = false, groupSelectedItems: groupSelectedItems = false, onPopupToggle: onPopupToggle, onChange: onChange, onClearFilter: onClearFilter } = _ref;
    const [isPopupOpen, setIsPopupOpen] = (0, $eUqFw.useState)(false);
    const [searchInputValue, setSearchInputValue] = (0, $eUqFw.useState)('');
    const triggerRef = (0, $eUqFw.useRef)(null);
    // Managing our own state for the options, to support displaying the selected options at the top of the list
    const [groupedOptions, setGroupedOptions] = (0, $eUqFw.useState)((0, $2xDeC.getGroupedOptions)({
        options: options,
        selectedOptions: selectedOptions,
        addSelectedFirst: groupSelectedItems
    }));
    // Synchronize internal popup open state with controlled prop
    (0, $eUqFw.useEffect)(()=>{
        if (controlledIsPopupOpen !== undefined) setIsPopupOpen(controlledIsPopupOpen);
    }, [
        controlledIsPopupOpen
    ]);
    (0, $eUqFw.useEffect)(()=>{
        onPopupToggle === null || onPopupToggle === void 0 || onPopupToggle(isPopupOpen);
    }, [
        isPopupOpen,
        onPopupToggle
    ]);
    const resetPopupState = (0, $eUqFw.useCallback)(()=>{
        setIsPopupOpen(false);
        setSearchInputValue('');
    }, []);
    const focusOnTriggerButton = (0, $eUqFw.useCallback)(()=>{
        // We need a timeout to apply the focus after other event handlers, otherwise the focus can be lost
        setTimeout(()=>{
            var _triggerRef$current;
            return (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.focus();
        });
    }, []);
    const handlePopupClose = (0, $eUqFw.useCallback)((event)=>{
        // If the user presses the escape key to close the popup, place focus back onto the trigger button
        if (event.key === 'Escape') focusOnTriggerButton();
        resetPopupState();
    }, [
        focusOnTriggerButton,
        resetPopupState
    ]);
    const handlePopupTriggerClick = (0, $eUqFw.useCallback)(()=>{
        // if the popup is being closed, clear the search input value
        if (isPopupOpen) resetPopupState();
        else {
            // If the popup is being opened, update the `grouped` options
            setGroupedOptions((0, $2xDeC.getGroupedOptions)({
                options: options,
                selectedOptions: selectedOptions,
                addSelectedFirst: groupSelectedItems
            }));
            setIsPopupOpen(true);
        }
    }, [
        isPopupOpen,
        resetPopupState,
        options,
        selectedOptions,
        groupSelectedItems
    ]);
    const handleChange = (0, $eUqFw.useCallback)((newOptionOrOptions)=>{
        if ((0, $2xDeC.isMultiSelectOptions)(newOptionOrOptions)) onChange(newOptionOrOptions);
        else {
            onChange(newOptionOrOptions ? [
                newOptionOrOptions
            ] : []);
            resetPopupState();
        }
    }, [
        onChange,
        resetPopupState
    ]);
    const handleClearSelection = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        if ('code' in event && [
            'Enter',
            'NumpadEnter',
            'Space'
        ].includes(event.code) || event.nativeEvent instanceof MouseEvent) {
            onClearFilter === null || onClearFilter === void 0 || onClearFilter();
            resetPopupState();
            // When clear selection button is clicked by keyboard, place focus on the trigger button
            if ('code' in event && [
                'Enter',
                'NumpadEnter',
                'Space'
            ].includes(event.code)) focusOnTriggerButton();
        }
    }, [
        focusOnTriggerButton,
        onClearFilter,
        resetPopupState
    ]);
    // When single select, place focus on the trigger button when the select is closed by keyboard interaction
    const handleSelectKeyDown = (0, $eUqFw.useCallback)((event)=>{
        if (!isMulti && 'code' in event && [
            'Enter',
            'NumpadEnter',
            'Space'
        ].includes(event.code)) focusOnTriggerButton();
    }, [
        focusOnTriggerButton,
        isMulti
    ]);
    const handleFocus = ()=>{
        //Only setting the focus to first element when nothing is selected.
        if (!selectedOptions.length) setGroupedOptions((menuOptions)=>menuOptions.map((option, index)=>$6cbb16c06231e631$var$_objectSpread($6cbb16c06231e631$var$_objectSpread({}, option), {}, {
                    isFocused: index == 0
                })));
    };
    const handleSearchInputChange = (0, $eUqFw.useCallback)((newInputValue, meta)=>{
        if (meta.action === 'input-change') setSearchInputValue(newInputValue);
    }, []);
    const numberOfSelections = selectedOptions.length;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4J2zX.Popup), {
        isOpen: isPopupOpen,
        onClose: handlePopupClose,
        placement: "bottom-start",
        autoFocus: false,
        trigger: (triggerProps)=>{
            var _selectedOptions$;
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $i6Rym.SelectTrigger), {
                ref: triggerRef,
                triggerProps: triggerProps,
                filterLabel: label,
                firstSelectedOptionLabel: (_selectedOptions$ = selectedOptions[0]) === null || _selectedOptions$ === void 0 ? void 0 : _selectedOptions$.label,
                isSelected: isPopupOpen || numberOfSelections > 0,
                isExpanded: isPopupOpen,
                numberOfSelections: numberOfSelections,
                onClick: handlePopupTriggerClick
            });
        },
        content: ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $UVwUc.FilterPickerSelect), {
                testId: "filter-picker.select.".concat(label),
                options: groupedOptions,
                selectedOptions: selectedOptions,
                status: status,
                isMulti: isMulti,
                isSearchable: isSearchable,
                hasClearSelectionButton: hasClearSelectionButton,
                searchInputValue: searchInputValue,
                onSelectionChange: handleChange,
                onClearSelection: handleClearSelection,
                onSearchInputChange: handleSearchInputChange,
                onSelectKeyDown: handleSelectKeyDown,
                onHandleFocus: handleFocus
            })
    });
};

});
parcelRegister("UVwUc", function(module, exports) {

$parcel$export(module.exports, "FilterPickerSelect", () => $0ab1db489e1535c0$export$1ba510feb9693a96);

var $5zQU9 = parcelRequire("5zQU9");

var $379fO = parcelRequire("379fO");
var $d4qUE = parcelRequire("d4qUE");

var $dzIcn = parcelRequire("dzIcn");
parcelRequire("eUqFw");

var $3DYxj = parcelRequire("3DYxj");

var $aCWZ7 = parcelRequire("aCWZ7");

var $kUvoe = parcelRequire("kUvoe");

var $6Z68J = parcelRequire("6Z68J");

var $dWSYG = parcelRequire("dWSYG");

var $9nseh = parcelRequire("9nseh");

var $97C27 = parcelRequire("97C27");

var $lHkHI = parcelRequire("lHkHI");
function $0ab1db489e1535c0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0ab1db489e1535c0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0ab1db489e1535c0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0ab1db489e1535c0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $0ab1db489e1535c0$var$customSelectStyles = {
    control: (base)=>$0ab1db489e1535c0$var$_objectSpread($0ab1db489e1535c0$var$_objectSpread({}, base), {}, {
            border: 0 // Removing the default border around the select control
        })
};
const $0ab1db489e1535c0$var$customComponents = {
    Option: (0, $97C27.CustomOption),
    DropdownIndicator: (0, $kUvoe.CustomDropdownIndicator),
    Menu: (0, $dWSYG.CustomMenu),
    Control: (0, $aCWZ7.CustomControl),
    NoOptionsMessage: (0, $9nseh.CustomNoOptionsMessage)
};
const $0ab1db489e1535c0$var$selectWrapperStyles = (0, $d4qUE.xcss)($0ab1db489e1535c0$var$_objectSpread($0ab1db489e1535c0$var$_objectSpread({}, (0, $3DYxj.charlieTextFontFamily)), {}, {
    width: '280px'
}));
const $0ab1db489e1535c0$export$1ba510feb9693a96 = (_ref)=>{
    let { testId: testId, options: options, selectedOptions: selectedOptions, status: status, searchInputValue: searchInputValue, isMulti: isMulti = false, isSearchable: isSearchable = false, hasClearSelectionButton: hasClearSelectionButton = false, onSelectionChange: onSelectionChange, onClearSelection: onClearSelection, onSearchInputChange: onSearchInputChange, onSelectKeyDown: onSelectKeyDown, onHandleFocus: onHandleFocus } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $379fO.default), {
        xcss: $0ab1db489e1535c0$var$selectWrapperStyles,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dzIcn.default), {
                placeholder: "Search",
                testId: testId,
                options: options,
                value: selectedOptions,
                isMulti: isMulti,
                onChange: onSelectionChange,
                inputValue: searchInputValue,
                onInputChange: onSearchInputChange,
                components: $0ab1db489e1535c0$var$customComponents,
                styles: $0ab1db489e1535c0$var$customSelectStyles,
                autoFocus: true,
                menuIsOpen: true,
                blurInputOnSelect: !isMulti,
                closeMenuOnSelect: false,
                hideSelectedOptions: false,
                controlShouldRenderValue: false,
                menuShouldScrollIntoView: false,
                tabSelectsValue: false,
                defaultOptions: false,
                isClearable: false,
                escapeClearsValue: false,
                isSearchable: isSearchable,
                status: status,
                onKeyDown: onSelectKeyDown,
                onFocus: onHandleFocus
            }),
            status === 'default' && hasClearSelectionButton && onClearSelection && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6Z68J.Footer), {
                isClearSelectionDisabled: selectedOptions.length === 0,
                onClearSelection: onClearSelection
            })
        ]
    });
};

});
parcelRegister("dzIcn", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e20d42eb883f98a$export$2e2bcd8739ae039);

var $hOLnS = parcelRequire("hOLnS");

var $lzpNt = parcelRequire("lzpNt");
var $dki1H = parcelRequire("dki1H");
var $dY3D1 = parcelRequire("dY3D1");

var $6MMPK = parcelRequire("6MMPK");
const $9e20d42eb883f98a$var$packageName = "@atlaskit/select";
const $9e20d42eb883f98a$var$packageVersion = "17.19.3";
const $9e20d42eb883f98a$export$d1de3b251ccaa8a3 = (0, $6MMPK.default)((0, $hOLnS.default));
const $9e20d42eb883f98a$var$createAndFireEventOnAtlaskit = (0, $lzpNt.default)('atlaskit');
const $9e20d42eb883f98a$var$Select = (0, $dki1H.default)({
    componentName: 'select',
    packageName: $9e20d42eb883f98a$var$packageName,
    packageVersion: $9e20d42eb883f98a$var$packageVersion
})((0, $dY3D1.default)({
    onChange: $9e20d42eb883f98a$var$createAndFireEventOnAtlaskit({
        action: 'changed',
        actionSubject: 'option',
        attributes: {
            componentName: 'select',
            packageName: $9e20d42eb883f98a$var$packageName,
            packageVersion: $9e20d42eb883f98a$var$packageVersion
        }
    })
})($9e20d42eb883f98a$export$d1de3b251ccaa8a3));
var $9e20d42eb883f98a$export$2e2bcd8739ae039 = $9e20d42eb883f98a$var$Select;

});
parcelRegister("hOLnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf8bdca71ec4c4b4$export$2e2bcd8739ae039);

var $7IqRg = parcelRequire("7IqRg");

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $i4w9L = parcelRequire("i4w9L");

var $4WmDP = parcelRequire("4WmDP");

var $i4xqP = parcelRequire("i4xqP");

var $6Wmpx = parcelRequire("6Wmpx");
parcelRequire("1Xn5q");
parcelRequire("aKcqM");
parcelRequire("bwPfh");
parcelRequire("lDSrn");
parcelRequire("lIEGP");
parcelRequire("eT4IF");
parcelRequire("7Dzgl");
parcelRequire("fVK4C");

parcelRequire("5sKOb");
parcelRequire("jqNEH");
parcelRequire("5zQU9");
parcelRequire("lEfVV");

parcelRequire("k286k");
var $cf8bdca71ec4c4b4$var$StateManagedSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function(props, ref) {
    var baseSelectProps = (0, $7IqRg.u)(props);
    return /*#__PURE__*/ $eUqFw.createElement((0, $i4w9L.S), (0, $kU09D.default)({
        ref: ref
    }, baseSelectProps));
});
var $cf8bdca71ec4c4b4$export$2e2bcd8739ae039 = $cf8bdca71ec4c4b4$var$StateManagedSelect;
var $cf8bdca71ec4c4b4$export$a7deb1594c5ce10e = function(_ref) {
    var nonce = _ref.nonce, children = _ref.children, cacheKey = _ref.cacheKey;
    var emotionCache = (0, $eUqFw.useMemo)(function() {
        return (0, $i4xqP.default)({
            key: cacheKey,
            nonce: nonce
        });
    }, [
        cacheKey,
        nonce
    ]);
    return /*#__PURE__*/ $eUqFw.createElement((0, $4WmDP.C), {
        value: emotionCache
    }, children);
};

});
parcelRegister("7IqRg", function(module, exports) {

$parcel$export(module.exports, "u", () => $59e179ee89746bd6$export$3b14a55fb2447963);

var $1Xn5q = parcelRequire("1Xn5q");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
var $59e179ee89746bd6$var$_excluded = [
    "defaultInputValue",
    "defaultMenuIsOpen",
    "defaultValue",
    "inputValue",
    "menuIsOpen",
    "onChange",
    "onInputChange",
    "onMenuClose",
    "onMenuOpen",
    "value"
];
function $59e179ee89746bd6$export$3b14a55fb2447963(_ref) {
    var _ref$defaultInputValu = _ref.defaultInputValue, defaultInputValue = _ref$defaultInputValu === void 0 ? '' : _ref$defaultInputValu, _ref$defaultMenuIsOpe = _ref.defaultMenuIsOpen, defaultMenuIsOpen = _ref$defaultMenuIsOpe === void 0 ? false : _ref$defaultMenuIsOpe, _ref$defaultValue = _ref.defaultValue, defaultValue = _ref$defaultValue === void 0 ? null : _ref$defaultValue, propsInputValue = _ref.inputValue, propsMenuIsOpen = _ref.menuIsOpen, propsOnChange = _ref.onChange, propsOnInputChange = _ref.onInputChange, propsOnMenuClose = _ref.onMenuClose, propsOnMenuOpen = _ref.onMenuOpen, propsValue = _ref.value, restSelectProps = (0, $bwPfh.default)(_ref, $59e179ee89746bd6$var$_excluded);
    var _useState = (0, $eUqFw.useState)(propsInputValue !== undefined ? propsInputValue : defaultInputValue), _useState2 = (0, $aKcqM.default)(_useState, 2), stateInputValue = _useState2[0], setStateInputValue = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(propsMenuIsOpen !== undefined ? propsMenuIsOpen : defaultMenuIsOpen), _useState4 = (0, $aKcqM.default)(_useState3, 2), stateMenuIsOpen = _useState4[0], setStateMenuIsOpen = _useState4[1];
    var _useState5 = (0, $eUqFw.useState)(propsValue !== undefined ? propsValue : defaultValue), _useState6 = (0, $aKcqM.default)(_useState5, 2), stateValue = _useState6[0], setStateValue = _useState6[1];
    var onChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        if (typeof propsOnChange === 'function') propsOnChange(value, actionMeta);
        setStateValue(value);
    }, [
        propsOnChange
    ]);
    var onInputChange = (0, $eUqFw.useCallback)(function(value, actionMeta) {
        var newValue;
        if (typeof propsOnInputChange === 'function') newValue = propsOnInputChange(value, actionMeta);
        setStateInputValue(newValue !== undefined ? newValue : value);
    }, [
        propsOnInputChange
    ]);
    var onMenuOpen = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuOpen === 'function') propsOnMenuOpen();
        setStateMenuIsOpen(true);
    }, [
        propsOnMenuOpen
    ]);
    var onMenuClose = (0, $eUqFw.useCallback)(function() {
        if (typeof propsOnMenuClose === 'function') propsOnMenuClose();
        setStateMenuIsOpen(false);
    }, [
        propsOnMenuClose
    ]);
    var inputValue = propsInputValue !== undefined ? propsInputValue : stateInputValue;
    var menuIsOpen = propsMenuIsOpen !== undefined ? propsMenuIsOpen : stateMenuIsOpen;
    var value = propsValue !== undefined ? propsValue : stateValue;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, restSelectProps), {}, {
        inputValue: inputValue,
        menuIsOpen: menuIsOpen,
        onChange: onChange,
        onInputChange: onInputChange,
        onMenuClose: onMenuClose,
        onMenuOpen: onMenuOpen,
        value: value
    });
}

});
parcelRegister("aKcqM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d27d7cb7c770f64$export$2e2bcd8739ae039);

var $kcDiK = parcelRequire("kcDiK");

var $61Jn4 = parcelRequire("61Jn4");

var $e5SQy = parcelRequire("e5SQy");

var $gP5fl = parcelRequire("gP5fl");
function $7d27d7cb7c770f64$export$2e2bcd8739ae039(r, e) {
    return (0, $kcDiK.default)(r) || (0, $61Jn4.default)(r, e) || (0, $e5SQy.default)(r, e) || (0, $gP5fl.default)();
}

});
parcelRegister("kcDiK", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb536a1805ce1726$export$2e2bcd8739ae039);
function $eb536a1805ce1726$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return r;
}

});

parcelRegister("61Jn4", function(module, exports) {

$parcel$export(module.exports, "default", () => $463607d84fb47652$export$2e2bcd8739ae039);
function $463607d84fb47652$export$2e2bcd8739ae039(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}

});

parcelRegister("e5SQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $a42c13bbb83e195c$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $a42c13bbb83e195c$export$2e2bcd8739ae039(r, a) {
    if (r) {
        if ("string" == typeof r) return (0, $aLrjs.default)(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? (0, $aLrjs.default)(r, a) : void 0;
    }
}

});
parcelRegister("aLrjs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d637af256120630$export$2e2bcd8739ae039);
function $7d637af256120630$export$2e2bcd8739ae039(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}

});


parcelRegister("gP5fl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3f57a97be8f63bf$export$2e2bcd8739ae039);
function $c3f57a97be8f63bf$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});



parcelRegister("i4w9L", function(module, exports) {

$parcel$export(module.exports, "b", () => $d2818b570f093c78$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "g", () => $d2818b570f093c78$export$39b482c5e57630a8);
$parcel$export(module.exports, "m", () => $d2818b570f093c78$export$953cecd6e717a553);
$parcel$export(module.exports, "S", () => $d2818b570f093c78$export$25ce5a424b770e84);

var $kU09D = parcelRequire("kU09D");

var $1Xn5q = parcelRequire("1Xn5q");

var $lDSrn = parcelRequire("lDSrn");

var $lIEGP = parcelRequire("lIEGP");

var $eT4IF = parcelRequire("eT4IF");

var $7Dzgl = parcelRequire("7Dzgl");

var $fVK4C = parcelRequire("fVK4C");

var $eUqFw = parcelRequire("eUqFw");

var $6Wmpx = parcelRequire("6Wmpx");

var $byn9U = parcelRequire("byn9U");

var $5iWql = parcelRequire("5iWql");

var $bwPfh = parcelRequire("bwPfh");
function $d2818b570f093c78$var$_EMOTION_STRINGIFIED_CSS_ERROR__$2() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// Assistive text to describe visual elements. Hidden for sighted users.
var $d2818b570f093c78$var$_ref = {
    name: "7pg0cj-a11yText",
    styles: "label:a11yText;z-index:9999;border:0;clip:rect(1px, 1px, 1px, 1px);height:1px;width:1px;position:absolute;overflow:hidden;padding:0;white-space:nowrap"
};
var $d2818b570f093c78$var$A11yText = function A11yText(props) {
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({
        css: $d2818b570f093c78$var$_ref
    }, props));
};
var $d2818b570f093c78$var$A11yText$1 = $d2818b570f093c78$var$A11yText;
var $d2818b570f093c78$var$defaultAriaLiveMessages = {
    guidance: function guidance(props) {
        var isSearchable = props.isSearchable, isMulti = props.isMulti, tabSelectsValue = props.tabSelectsValue, context = props.context, isInitialFocus = props.isInitialFocus;
        switch(context){
            case 'menu':
                return "Use Up and Down to choose options, press Enter to select the currently focused option, press Escape to exit the menu".concat(tabSelectsValue ? ', press Tab to select the option and exit the menu' : '', ".");
            case 'input':
                return isInitialFocus ? "".concat(props['aria-label'] || 'Select', " is focused ").concat(isSearchable ? ',type to refine list' : '', ", press Down to open the menu, ").concat(isMulti ? ' press left to focus selected values' : '') : '';
            case 'value':
                return 'Use left and right to toggle between focused values, press Backspace to remove the currently focused value';
            default:
                return '';
        }
    },
    onChange: function onChange(props) {
        var action = props.action, _props$label = props.label, label = _props$label === void 0 ? '' : _props$label, labels = props.labels, isDisabled = props.isDisabled;
        switch(action){
            case 'deselect-option':
            case 'pop-value':
            case 'remove-value':
                return "option ".concat(label, ", deselected.");
            case 'clear':
                return 'All selected options have been cleared.';
            case 'initial-input-focus':
                return "option".concat(labels.length > 1 ? 's' : '', " ").concat(labels.join(','), ", selected.");
            case 'select-option':
                return isDisabled ? "option ".concat(label, " is disabled. Select another option.") : "option ".concat(label, ", selected.");
            default:
                return '';
        }
    },
    onFocus: function onFocus(props) {
        var context = props.context, focused = props.focused, options = props.options, _props$label2 = props.label, label = _props$label2 === void 0 ? '' : _props$label2, selectValue = props.selectValue, isDisabled = props.isDisabled, isSelected = props.isSelected, isAppleDevice = props.isAppleDevice;
        var getArrayIndex = function getArrayIndex(arr, item) {
            return arr && arr.length ? "".concat(arr.indexOf(item) + 1, " of ").concat(arr.length) : '';
        };
        if (context === 'value' && selectValue) return "value ".concat(label, " focused, ").concat(getArrayIndex(selectValue, focused), ".");
        if (context === 'menu' && isAppleDevice) {
            var disabled = isDisabled ? ' disabled' : '';
            var status = "".concat(isSelected ? ' selected' : '').concat(disabled);
            return "".concat(label).concat(status, ", ").concat(getArrayIndex(options, focused), ".");
        }
        return '';
    },
    onFilter: function onFilter(props) {
        var inputValue = props.inputValue, resultsMessage = props.resultsMessage;
        return "".concat(resultsMessage).concat(inputValue ? ' for search term ' + inputValue : '', ".");
    }
};
var $d2818b570f093c78$var$LiveRegion = function LiveRegion(props) {
    var ariaSelection = props.ariaSelection, focusedOption = props.focusedOption, focusedValue = props.focusedValue, focusableOptions = props.focusableOptions, isFocused = props.isFocused, selectValue = props.selectValue, selectProps = props.selectProps, id = props.id, isAppleDevice = props.isAppleDevice;
    var ariaLiveMessages = selectProps.ariaLiveMessages, getOptionLabel = selectProps.getOptionLabel, inputValue = selectProps.inputValue, isMulti = selectProps.isMulti, isOptionDisabled = selectProps.isOptionDisabled, isSearchable = selectProps.isSearchable, menuIsOpen = selectProps.menuIsOpen, options = selectProps.options, screenReaderStatus = selectProps.screenReaderStatus, tabSelectsValue = selectProps.tabSelectsValue, isLoading = selectProps.isLoading;
    var ariaLabel = selectProps['aria-label'];
    var ariaLive = selectProps['aria-live'];
    // Update aria live message configuration when prop changes
    var messages = (0, $eUqFw.useMemo)(function() {
        return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $d2818b570f093c78$var$defaultAriaLiveMessages), ariaLiveMessages || {});
    }, [
        ariaLiveMessages
    ]);
    // Update aria live selected option when prop changes
    var ariaSelected = (0, $eUqFw.useMemo)(function() {
        var message = '';
        if (ariaSelection && messages.onChange) {
            var option = ariaSelection.option, selectedOptions = ariaSelection.options, removedValue = ariaSelection.removedValue, removedValues = ariaSelection.removedValues, value = ariaSelection.value;
            // select-option when !isMulti does not return option so we assume selected option is value
            var asOption = function asOption(val) {
                return !Array.isArray(val) ? val : null;
            };
            // If there is just one item from the action then get its label
            var selected = removedValue || option || asOption(value);
            var label = selected ? getOptionLabel(selected) : '';
            // If there are multiple items from the action then return an array of labels
            var multiSelected = selectedOptions || removedValues || undefined;
            var labels = multiSelected ? multiSelected.map(getOptionLabel) : [];
            var onChangeProps = (0, $1Xn5q.default)({
                // multiSelected items are usually items that have already been selected
                // or set by the user as a default value so we assume they are not disabled
                isDisabled: selected && isOptionDisabled(selected, selectValue),
                label: label,
                labels: labels
            }, ariaSelection);
            message = messages.onChange(onChangeProps);
        }
        return message;
    }, [
        ariaSelection,
        messages,
        isOptionDisabled,
        selectValue,
        getOptionLabel
    ]);
    var ariaFocused = (0, $eUqFw.useMemo)(function() {
        var focusMsg = '';
        var focused = focusedOption || focusedValue;
        var isSelected = !!(focusedOption && selectValue && selectValue.includes(focusedOption));
        if (focused && messages.onFocus) {
            var onFocusProps = {
                focused: focused,
                label: getOptionLabel(focused),
                isDisabled: isOptionDisabled(focused, selectValue),
                isSelected: isSelected,
                options: focusableOptions,
                context: focused === focusedOption ? 'menu' : 'value',
                selectValue: selectValue,
                isAppleDevice: isAppleDevice
            };
            focusMsg = messages.onFocus(onFocusProps);
        }
        return focusMsg;
    }, [
        focusedOption,
        focusedValue,
        getOptionLabel,
        isOptionDisabled,
        messages,
        focusableOptions,
        selectValue,
        isAppleDevice
    ]);
    var ariaResults = (0, $eUqFw.useMemo)(function() {
        var resultsMsg = '';
        if (menuIsOpen && options.length && !isLoading && messages.onFilter) {
            var resultsMessage = screenReaderStatus({
                count: focusableOptions.length
            });
            resultsMsg = messages.onFilter({
                inputValue: inputValue,
                resultsMessage: resultsMessage
            });
        }
        return resultsMsg;
    }, [
        focusableOptions,
        inputValue,
        menuIsOpen,
        messages,
        options,
        screenReaderStatus,
        isLoading
    ]);
    var isInitialFocus = (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus';
    var ariaGuidance = (0, $eUqFw.useMemo)(function() {
        var guidanceMsg = '';
        if (messages.guidance) {
            var context = focusedValue ? 'value' : menuIsOpen ? 'menu' : 'input';
            guidanceMsg = messages.guidance({
                'aria-label': ariaLabel,
                context: context,
                isDisabled: focusedOption && isOptionDisabled(focusedOption, selectValue),
                isMulti: isMulti,
                isSearchable: isSearchable,
                tabSelectsValue: tabSelectsValue,
                isInitialFocus: isInitialFocus
            });
        }
        return guidanceMsg;
    }, [
        ariaLabel,
        focusedOption,
        focusedValue,
        isMulti,
        isOptionDisabled,
        isSearchable,
        menuIsOpen,
        messages,
        selectValue,
        tabSelectsValue,
        isInitialFocus
    ]);
    var ScreenReaderText = (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)("span", {
        id: "aria-selection"
    }, ariaSelected), (0, $byn9U.jsx)("span", {
        id: "aria-focused"
    }, ariaFocused), (0, $byn9U.jsx)("span", {
        id: "aria-results"
    }, ariaResults), (0, $byn9U.jsx)("span", {
        id: "aria-guidance"
    }, ariaGuidance));
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, (0, $byn9U.jsx)($d2818b570f093c78$var$A11yText$1, {
        id: id
    }, isInitialFocus && ScreenReaderText), (0, $byn9U.jsx)($d2818b570f093c78$var$A11yText$1, {
        "aria-live": ariaLive,
        "aria-atomic": "false",
        "aria-relevant": "additions text",
        role: "log"
    }, isFocused && !isInitialFocus && ScreenReaderText));
};
var $d2818b570f093c78$var$LiveRegion$1 = $d2818b570f093c78$var$LiveRegion;
var $d2818b570f093c78$var$diacritics = [
    {
        base: 'A',
        letters: "A\u24B6\uFF21\xC0\xC1\xC2\u1EA6\u1EA4\u1EAA\u1EA8\xC3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xC4\u01DE\u1EA2\xC5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
    },
    {
        base: 'AA',
        letters: "\uA732"
    },
    {
        base: 'AE',
        letters: "\xC6\u01FC\u01E2"
    },
    {
        base: 'AO',
        letters: "\uA734"
    },
    {
        base: 'AU',
        letters: "\uA736"
    },
    {
        base: 'AV',
        letters: "\uA738\uA73A"
    },
    {
        base: 'AY',
        letters: "\uA73C"
    },
    {
        base: 'B',
        letters: "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
    },
    {
        base: 'C',
        letters: "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xC7\u1E08\u0187\u023B\uA73E"
    },
    {
        base: 'D',
        letters: "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779"
    },
    {
        base: 'DZ',
        letters: "\u01F1\u01C4"
    },
    {
        base: 'Dz',
        letters: "\u01F2\u01C5"
    },
    {
        base: 'E',
        letters: "E\u24BA\uFF25\xC8\xC9\xCA\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xCB\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
    },
    {
        base: 'F',
        letters: "F\u24BB\uFF26\u1E1E\u0191\uA77B"
    },
    {
        base: 'G',
        letters: "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
    },
    {
        base: 'H',
        letters: "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
    },
    {
        base: 'I',
        letters: "I\u24BE\uFF29\xCC\xCD\xCE\u0128\u012A\u012C\u0130\xCF\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
    },
    {
        base: 'J',
        letters: "J\u24BF\uFF2A\u0134\u0248"
    },
    {
        base: 'K',
        letters: "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
    },
    {
        base: 'L',
        letters: "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
    },
    {
        base: 'LJ',
        letters: "\u01C7"
    },
    {
        base: 'Lj',
        letters: "\u01C8"
    },
    {
        base: 'M',
        letters: "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
    },
    {
        base: 'N',
        letters: "N\u24C3\uFF2E\u01F8\u0143\xD1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
    },
    {
        base: 'NJ',
        letters: "\u01CA"
    },
    {
        base: 'Nj',
        letters: "\u01CB"
    },
    {
        base: 'O',
        letters: "O\u24C4\uFF2F\xD2\xD3\xD4\u1ED2\u1ED0\u1ED6\u1ED4\xD5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xD6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xD8\u01FE\u0186\u019F\uA74A\uA74C"
    },
    {
        base: 'OI',
        letters: "\u01A2"
    },
    {
        base: 'OO',
        letters: "\uA74E"
    },
    {
        base: 'OU',
        letters: "\u0222"
    },
    {
        base: 'P',
        letters: "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
    },
    {
        base: 'Q',
        letters: "Q\u24C6\uFF31\uA756\uA758\u024A"
    },
    {
        base: 'R',
        letters: "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
    },
    {
        base: 'S',
        letters: "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
    },
    {
        base: 'T',
        letters: "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
    },
    {
        base: 'TZ',
        letters: "\uA728"
    },
    {
        base: 'U',
        letters: "U\u24CA\uFF35\xD9\xDA\xDB\u0168\u1E78\u016A\u1E7A\u016C\xDC\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
    },
    {
        base: 'V',
        letters: "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
    },
    {
        base: 'VY',
        letters: "\uA760"
    },
    {
        base: 'W',
        letters: "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
    },
    {
        base: 'X',
        letters: "X\u24CD\uFF38\u1E8A\u1E8C"
    },
    {
        base: 'Y',
        letters: "Y\u24CE\uFF39\u1EF2\xDD\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
    },
    {
        base: 'Z',
        letters: "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
    },
    {
        base: 'a',
        letters: "a\u24D0\uFF41\u1E9A\xE0\xE1\xE2\u1EA7\u1EA5\u1EAB\u1EA9\xE3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xE4\u01DF\u1EA3\xE5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
    },
    {
        base: 'aa',
        letters: "\uA733"
    },
    {
        base: 'ae',
        letters: "\xE6\u01FD\u01E3"
    },
    {
        base: 'ao',
        letters: "\uA735"
    },
    {
        base: 'au',
        letters: "\uA737"
    },
    {
        base: 'av',
        letters: "\uA739\uA73B"
    },
    {
        base: 'ay',
        letters: "\uA73D"
    },
    {
        base: 'b',
        letters: "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
    },
    {
        base: 'c',
        letters: "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xE7\u1E09\u0188\u023C\uA73F\u2184"
    },
    {
        base: 'd',
        letters: "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
    },
    {
        base: 'dz',
        letters: "\u01F3\u01C6"
    },
    {
        base: 'e',
        letters: "e\u24D4\uFF45\xE8\xE9\xEA\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xEB\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
    },
    {
        base: 'f',
        letters: "f\u24D5\uFF46\u1E1F\u0192\uA77C"
    },
    {
        base: 'g',
        letters: "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
    },
    {
        base: 'h',
        letters: "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
    },
    {
        base: 'hv',
        letters: "\u0195"
    },
    {
        base: 'i',
        letters: "i\u24D8\uFF49\xEC\xED\xEE\u0129\u012B\u012D\xEF\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
    },
    {
        base: 'j',
        letters: "j\u24D9\uFF4A\u0135\u01F0\u0249"
    },
    {
        base: 'k',
        letters: "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
    },
    {
        base: 'l',
        letters: "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
    },
    {
        base: 'lj',
        letters: "\u01C9"
    },
    {
        base: 'm',
        letters: "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
    },
    {
        base: 'n',
        letters: "n\u24DD\uFF4E\u01F9\u0144\xF1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
    },
    {
        base: 'nj',
        letters: "\u01CC"
    },
    {
        base: 'o',
        letters: "o\u24DE\uFF4F\xF2\xF3\xF4\u1ED3\u1ED1\u1ED7\u1ED5\xF5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xF6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xF8\u01FF\u0254\uA74B\uA74D\u0275"
    },
    {
        base: 'oi',
        letters: "\u01A3"
    },
    {
        base: 'ou',
        letters: "\u0223"
    },
    {
        base: 'oo',
        letters: "\uA74F"
    },
    {
        base: 'p',
        letters: "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
    },
    {
        base: 'q',
        letters: "q\u24E0\uFF51\u024B\uA757\uA759"
    },
    {
        base: 'r',
        letters: "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
    },
    {
        base: 's',
        letters: "s\u24E2\uFF53\xDF\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
    },
    {
        base: 't',
        letters: "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
    },
    {
        base: 'tz',
        letters: "\uA729"
    },
    {
        base: 'u',
        letters: "u\u24E4\uFF55\xF9\xFA\xFB\u0169\u1E79\u016B\u1E7B\u016D\xFC\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
    },
    {
        base: 'v',
        letters: "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
    },
    {
        base: 'vy',
        letters: "\uA761"
    },
    {
        base: 'w',
        letters: "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
    },
    {
        base: 'x',
        letters: "x\u24E7\uFF58\u1E8B\u1E8D"
    },
    {
        base: 'y',
        letters: "y\u24E8\uFF59\u1EF3\xFD\u0177\u1EF9\u0233\u1E8F\xFF\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
    },
    {
        base: 'z',
        letters: "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
    }
];
var $d2818b570f093c78$var$anyDiacritic = new RegExp('[' + $d2818b570f093c78$var$diacritics.map(function(d) {
    return d.letters;
}).join('') + ']', 'g');
var $d2818b570f093c78$var$diacriticToBase = {};
for(var $d2818b570f093c78$var$i = 0; $d2818b570f093c78$var$i < $d2818b570f093c78$var$diacritics.length; $d2818b570f093c78$var$i++){
    var $d2818b570f093c78$var$diacritic = $d2818b570f093c78$var$diacritics[$d2818b570f093c78$var$i];
    for(var $d2818b570f093c78$var$j = 0; $d2818b570f093c78$var$j < $d2818b570f093c78$var$diacritic.letters.length; $d2818b570f093c78$var$j++)$d2818b570f093c78$var$diacriticToBase[$d2818b570f093c78$var$diacritic.letters[$d2818b570f093c78$var$j]] = $d2818b570f093c78$var$diacritic.base;
}
var $d2818b570f093c78$var$stripDiacritics = function stripDiacritics(str) {
    return str.replace($d2818b570f093c78$var$anyDiacritic, function(match) {
        return $d2818b570f093c78$var$diacriticToBase[match];
    });
};
var $d2818b570f093c78$var$memoizedStripDiacriticsForInput = (0, $5iWql.default)($d2818b570f093c78$var$stripDiacritics);
var $d2818b570f093c78$var$trimString = function trimString(str) {
    return str.replace(/^\s+|\s+$/g, '');
};
var $d2818b570f093c78$var$defaultStringify = function defaultStringify(option) {
    return "".concat(option.label, " ").concat(option.value);
};
var $d2818b570f093c78$export$db3b6bfb95261072 = function createFilter(config) {
    return function(option, rawInput) {
        // eslint-disable-next-line no-underscore-dangle
        if (option.data.__isNew__) return true;
        var _ignoreCase$ignoreAcc = (0, $1Xn5q.default)({
            ignoreCase: true,
            ignoreAccents: true,
            stringify: $d2818b570f093c78$var$defaultStringify,
            trim: true,
            matchFrom: 'any'
        }, config), ignoreCase = _ignoreCase$ignoreAcc.ignoreCase, ignoreAccents = _ignoreCase$ignoreAcc.ignoreAccents, stringify = _ignoreCase$ignoreAcc.stringify, trim = _ignoreCase$ignoreAcc.trim, matchFrom = _ignoreCase$ignoreAcc.matchFrom;
        var input = trim ? $d2818b570f093c78$var$trimString(rawInput) : rawInput;
        var candidate = trim ? $d2818b570f093c78$var$trimString(stringify(option)) : stringify(option);
        if (ignoreCase) {
            input = input.toLowerCase();
            candidate = candidate.toLowerCase();
        }
        if (ignoreAccents) {
            input = $d2818b570f093c78$var$memoizedStripDiacriticsForInput(input);
            candidate = $d2818b570f093c78$var$stripDiacritics(candidate);
        }
        return matchFrom === 'start' ? candidate.substr(0, input.length) === input : candidate.indexOf(input) > -1;
    };
};
var $d2818b570f093c78$var$_excluded = [
    "innerRef"
];
function $d2818b570f093c78$var$DummyInput(_ref) {
    var innerRef = _ref.innerRef, props = (0, $bwPfh.default)(_ref, $d2818b570f093c78$var$_excluded);
    // Remove animation props not meant for HTML elements
    var filteredProps = (0, $6Wmpx.r)(props, 'onExited', 'in', 'enter', 'exit', 'appear');
    return (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        ref: innerRef
    }, filteredProps, {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            label: 'dummyInput',
            // get rid of any default styles
            background: 0,
            border: 0,
            // important! this hides the flashing cursor
            caretColor: 'transparent',
            fontSize: 'inherit',
            gridArea: '1 / 1 / 2 / 3',
            outline: 0,
            padding: 0,
            // important! without `width` browsers won't allow focus
            width: 1,
            // remove cursor on desktop
            color: 'transparent',
            // remove cursor on mobile whilst maintaining "scroll into view" behaviour
            left: -100,
            opacity: 0,
            position: 'relative',
            transform: 'scale(.01)'
        }, "", "")
    }));
}
var $d2818b570f093c78$var$cancelScroll = function cancelScroll(event) {
    if (event.cancelable) event.preventDefault();
    event.stopPropagation();
};
function $d2818b570f093c78$var$useScrollCapture(_ref) {
    var isEnabled = _ref.isEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var isBottom = (0, $eUqFw.useRef)(false);
    var isTop = (0, $eUqFw.useRef)(false);
    var touchStart = (0, $eUqFw.useRef)(0);
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var handleEventDelta = (0, $eUqFw.useCallback)(function(event, delta) {
        if (scrollTarget.current === null) return;
        var _scrollTarget$current = scrollTarget.current, scrollTop = _scrollTarget$current.scrollTop, scrollHeight = _scrollTarget$current.scrollHeight, clientHeight = _scrollTarget$current.clientHeight;
        var target = scrollTarget.current;
        var isDeltaPositive = delta > 0;
        var availableScroll = scrollHeight - clientHeight - scrollTop;
        var shouldCancelScroll = false;
        // reset bottom/top flags
        if (availableScroll > delta && isBottom.current) {
            if (onBottomLeave) onBottomLeave(event);
            isBottom.current = false;
        }
        if (isDeltaPositive && isTop.current) {
            if (onTopLeave) onTopLeave(event);
            isTop.current = false;
        }
        // bottom limit
        if (isDeltaPositive && delta > availableScroll) {
            if (onBottomArrive && !isBottom.current) onBottomArrive(event);
            target.scrollTop = scrollHeight;
            shouldCancelScroll = true;
            isBottom.current = true;
        // top limit
        } else if (!isDeltaPositive && -delta > scrollTop) {
            if (onTopArrive && !isTop.current) onTopArrive(event);
            target.scrollTop = 0;
            shouldCancelScroll = true;
            isTop.current = true;
        }
        // cancel scroll
        if (shouldCancelScroll) $d2818b570f093c78$var$cancelScroll(event);
    }, [
        onBottomArrive,
        onBottomLeave,
        onTopArrive,
        onTopLeave
    ]);
    var onWheel = (0, $eUqFw.useCallback)(function(event) {
        handleEventDelta(event, event.deltaY);
    }, [
        handleEventDelta
    ]);
    var onTouchStart = (0, $eUqFw.useCallback)(function(event) {
        // set touch start so we can calculate touchmove delta
        touchStart.current = event.changedTouches[0].clientY;
    }, []);
    var onTouchMove = (0, $eUqFw.useCallback)(function(event) {
        var deltaY = touchStart.current - event.changedTouches[0].clientY;
        handleEventDelta(event, deltaY);
    }, [
        handleEventDelta
    ]);
    var startListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to attach to
        if (!el) return;
        var notPassive = (0, $6Wmpx.s) ? {
            passive: false
        } : false;
        el.addEventListener('wheel', onWheel, notPassive);
        el.addEventListener('touchstart', onTouchStart, notPassive);
        el.addEventListener('touchmove', onTouchMove, notPassive);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    var stopListening = (0, $eUqFw.useCallback)(function(el) {
        // bail early if no element is available to detach from
        if (!el) return;
        el.removeEventListener('wheel', onWheel, false);
        el.removeEventListener('touchstart', onTouchStart, false);
        el.removeEventListener('touchmove', onTouchMove, false);
    }, [
        onTouchMove,
        onTouchStart,
        onWheel
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        startListening(element);
        return function() {
            stopListening(element);
        };
    }, [
        isEnabled,
        startListening,
        stopListening
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
var $d2818b570f093c78$var$STYLE_KEYS = [
    'boxSizing',
    'height',
    'overflow',
    'paddingRight',
    'position'
];
var $d2818b570f093c78$var$LOCK_STYLES = {
    boxSizing: 'border-box',
    // account for possible declaration `width: 100%;` on body
    overflow: 'hidden',
    position: 'relative',
    height: '100%'
};
function $d2818b570f093c78$var$preventTouchMove(e) {
    e.preventDefault();
}
function $d2818b570f093c78$var$allowTouchMove(e) {
    e.stopPropagation();
}
function $d2818b570f093c78$var$preventInertiaScroll() {
    var top = this.scrollTop;
    var totalScroll = this.scrollHeight;
    var currentScroll = top + this.offsetHeight;
    if (top === 0) this.scrollTop = 1;
    else if (currentScroll === totalScroll) this.scrollTop = top - 1;
}
// `ontouchstart` check works on most browsers
// `maxTouchPoints` works on IE10/11 and Surface
function $d2818b570f093c78$var$isTouchDevice() {
    return 'ontouchstart' in window || navigator.maxTouchPoints;
}
var $d2818b570f093c78$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $d2818b570f093c78$var$activeScrollLocks = 0;
var $d2818b570f093c78$var$listenerOptions = {
    capture: false,
    passive: false
};
function $d2818b570f093c78$var$useScrollLock(_ref) {
    var isEnabled = _ref.isEnabled, _ref$accountForScroll = _ref.accountForScrollbars, accountForScrollbars = _ref$accountForScroll === void 0 ? true : _ref$accountForScroll;
    var originalStyles = (0, $eUqFw.useRef)({});
    var scrollTarget = (0, $eUqFw.useRef)(null);
    var addScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$d2818b570f093c78$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        if (accountForScrollbars) // store any styles already applied to the body
        $d2818b570f093c78$var$STYLE_KEYS.forEach(function(key) {
            var val = targetStyle && targetStyle[key];
            originalStyles.current[key] = val;
        });
        // apply the lock styles and padding if this is the first scroll lock
        if (accountForScrollbars && $d2818b570f093c78$var$activeScrollLocks < 1) {
            var currentPadding = parseInt(originalStyles.current.paddingRight, 10) || 0;
            var clientWidth = document.body ? document.body.clientWidth : 0;
            var adjustedPadding = window.innerWidth - clientWidth + currentPadding || 0;
            Object.keys($d2818b570f093c78$var$LOCK_STYLES).forEach(function(key) {
                var val = $d2818b570f093c78$var$LOCK_STYLES[key];
                if (targetStyle) targetStyle[key] = val;
            });
            if (targetStyle) targetStyle.paddingRight = "".concat(adjustedPadding, "px");
        }
        // account for touch devices
        if (target && $d2818b570f093c78$var$isTouchDevice()) {
            // Mobile Safari ignores { overflow: hidden } declaration on the body.
            target.addEventListener('touchmove', $d2818b570f093c78$var$preventTouchMove, $d2818b570f093c78$var$listenerOptions);
            // Allow scroll on provided target
            if (touchScrollTarget) {
                touchScrollTarget.addEventListener('touchstart', $d2818b570f093c78$var$preventInertiaScroll, $d2818b570f093c78$var$listenerOptions);
                touchScrollTarget.addEventListener('touchmove', $d2818b570f093c78$var$allowTouchMove, $d2818b570f093c78$var$listenerOptions);
            }
        }
        // increment active scroll locks
        $d2818b570f093c78$var$activeScrollLocks += 1;
    }, [
        accountForScrollbars
    ]);
    var removeScrollLock = (0, $eUqFw.useCallback)(function(touchScrollTarget) {
        if (!$d2818b570f093c78$var$canUseDOM) return;
        var target = document.body;
        var targetStyle = target && target.style;
        // safely decrement active scroll locks
        $d2818b570f093c78$var$activeScrollLocks = Math.max($d2818b570f093c78$var$activeScrollLocks - 1, 0);
        // reapply original body styles, if any
        if (accountForScrollbars && $d2818b570f093c78$var$activeScrollLocks < 1) $d2818b570f093c78$var$STYLE_KEYS.forEach(function(key) {
            var val = originalStyles.current[key];
            if (targetStyle) targetStyle[key] = val;
        });
        // remove touch listeners
        if (target && $d2818b570f093c78$var$isTouchDevice()) {
            target.removeEventListener('touchmove', $d2818b570f093c78$var$preventTouchMove, $d2818b570f093c78$var$listenerOptions);
            if (touchScrollTarget) {
                touchScrollTarget.removeEventListener('touchstart', $d2818b570f093c78$var$preventInertiaScroll, $d2818b570f093c78$var$listenerOptions);
                touchScrollTarget.removeEventListener('touchmove', $d2818b570f093c78$var$allowTouchMove, $d2818b570f093c78$var$listenerOptions);
            }
        }
    }, [
        accountForScrollbars
    ]);
    (0, $eUqFw.useEffect)(function() {
        if (!isEnabled) return;
        var element = scrollTarget.current;
        addScrollLock(element);
        return function() {
            removeScrollLock(element);
        };
    }, [
        isEnabled,
        addScrollLock,
        removeScrollLock
    ]);
    return function(element) {
        scrollTarget.current = element;
    };
}
function $d2818b570f093c78$var$_EMOTION_STRINGIFIED_CSS_ERROR__$1() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d2818b570f093c78$var$blurSelectInput = function blurSelectInput(event) {
    var element = event.target;
    return element.ownerDocument.activeElement && element.ownerDocument.activeElement.blur();
};
var $d2818b570f093c78$var$_ref2$1 = {
    name: "1kfdb0e",
    styles: "position:fixed;left:0;bottom:0;right:0;top:0"
};
function $d2818b570f093c78$var$ScrollManager(_ref) {
    var children = _ref.children, lockEnabled = _ref.lockEnabled, _ref$captureEnabled = _ref.captureEnabled, captureEnabled = _ref$captureEnabled === void 0 ? true : _ref$captureEnabled, onBottomArrive = _ref.onBottomArrive, onBottomLeave = _ref.onBottomLeave, onTopArrive = _ref.onTopArrive, onTopLeave = _ref.onTopLeave;
    var setScrollCaptureTarget = $d2818b570f093c78$var$useScrollCapture({
        isEnabled: captureEnabled,
        onBottomArrive: onBottomArrive,
        onBottomLeave: onBottomLeave,
        onTopArrive: onTopArrive,
        onTopLeave: onTopLeave
    });
    var setScrollLockTarget = $d2818b570f093c78$var$useScrollLock({
        isEnabled: lockEnabled
    });
    var targetRef = function targetRef(element) {
        setScrollCaptureTarget(element);
        setScrollLockTarget(element);
    };
    return (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, lockEnabled && (0, $byn9U.jsx)("div", {
        onClick: $d2818b570f093c78$var$blurSelectInput,
        css: $d2818b570f093c78$var$_ref2$1
    }), children(targetRef));
}
function $d2818b570f093c78$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
var $d2818b570f093c78$var$_ref2 = {
    name: "1a0ro4n-requiredInput",
    styles: "label:requiredInput;opacity:0;pointer-events:none;position:absolute;bottom:0;left:0;right:0;width:100%"
};
var $d2818b570f093c78$var$RequiredInput = function RequiredInput(_ref) {
    var name = _ref.name, onFocus = _ref.onFocus;
    return (0, $byn9U.jsx)("input", {
        required: true,
        name: name,
        tabIndex: -1,
        "aria-hidden": "true",
        onFocus: onFocus,
        css: $d2818b570f093c78$var$_ref2,
        value: "",
        onChange: function onChange() {}
    });
};
var $d2818b570f093c78$var$RequiredInput$1 = $d2818b570f093c78$var$RequiredInput;
/// <reference types="user-agent-data-types" />
function $d2818b570f093c78$var$testPlatform(re) {
    var _window$navigator$use;
    return typeof window !== 'undefined' && window.navigator != null ? re.test(((_window$navigator$use = window.navigator['userAgentData']) === null || _window$navigator$use === void 0 ? void 0 : _window$navigator$use.platform) || window.navigator.platform) : false;
}
function $d2818b570f093c78$var$isIPhone() {
    return $d2818b570f093c78$var$testPlatform(/^iPhone/i);
}
function $d2818b570f093c78$var$isMac() {
    return $d2818b570f093c78$var$testPlatform(/^Mac/i);
}
function $d2818b570f093c78$var$isIPad() {
    return $d2818b570f093c78$var$testPlatform(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
    $d2818b570f093c78$var$isMac() && navigator.maxTouchPoints > 1;
}
function $d2818b570f093c78$var$isIOS() {
    return $d2818b570f093c78$var$isIPhone() || $d2818b570f093c78$var$isIPad();
}
function $d2818b570f093c78$var$isAppleDevice() {
    return $d2818b570f093c78$var$isMac() || $d2818b570f093c78$var$isIOS();
}
var $d2818b570f093c78$var$formatGroupLabel = function formatGroupLabel(group) {
    return group.label;
};
var $d2818b570f093c78$export$8b22cf2602fb60ce = function getOptionLabel(option) {
    return option.label;
};
var $d2818b570f093c78$export$39b482c5e57630a8 = function getOptionValue(option) {
    return option.value;
};
var $d2818b570f093c78$var$isOptionDisabled = function isOptionDisabled(option) {
    return !!option.isDisabled;
};
var $d2818b570f093c78$var$defaultStyles = {
    clearIndicator: (0, $6Wmpx.a),
    container: (0, $6Wmpx.b),
    control: (0, $6Wmpx.d),
    dropdownIndicator: (0, $6Wmpx.e),
    group: (0, $6Wmpx.g),
    groupHeading: (0, $6Wmpx.f),
    indicatorsContainer: (0, $6Wmpx.i),
    indicatorSeparator: (0, $6Wmpx.h),
    input: (0, $6Wmpx.j),
    loadingIndicator: (0, $6Wmpx.l),
    loadingMessage: (0, $6Wmpx.k),
    menu: (0, $6Wmpx.m),
    menuList: (0, $6Wmpx.n),
    menuPortal: (0, $6Wmpx.o),
    multiValue: (0, $6Wmpx.p),
    multiValueLabel: (0, $6Wmpx.q),
    multiValueRemove: (0, $6Wmpx.t),
    noOptionsMessage: (0, $6Wmpx.u),
    option: (0, $6Wmpx.v),
    placeholder: (0, $6Wmpx.w),
    singleValue: (0, $6Wmpx.x),
    valueContainer: (0, $6Wmpx.y)
};
// Merge Utility
// Allows consumers to extend a base Select with additional styles
function $d2818b570f093c78$export$953cecd6e717a553(source) {
    var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    // initialize with source styles
    var styles = (0, $1Xn5q.default)({}, source);
    // massage in target styles
    Object.keys(target).forEach(function(keyAsString) {
        var key = keyAsString;
        if (source[key]) styles[key] = function(rsCss, props) {
            return target[key](source[key](rsCss, props), props);
        };
        else styles[key] = target[key];
    });
    return styles;
}
var $d2818b570f093c78$var$colors = {
    primary: '#2684FF',
    primary75: '#4C9AFF',
    primary50: '#B2D4FF',
    primary25: '#DEEBFF',
    danger: '#DE350B',
    dangerLight: '#FFBDAD',
    neutral0: 'hsl(0, 0%, 100%)',
    neutral5: 'hsl(0, 0%, 95%)',
    neutral10: 'hsl(0, 0%, 90%)',
    neutral20: 'hsl(0, 0%, 80%)',
    neutral30: 'hsl(0, 0%, 70%)',
    neutral40: 'hsl(0, 0%, 60%)',
    neutral50: 'hsl(0, 0%, 50%)',
    neutral60: 'hsl(0, 0%, 40%)',
    neutral70: 'hsl(0, 0%, 30%)',
    neutral80: 'hsl(0, 0%, 20%)',
    neutral90: 'hsl(0, 0%, 10%)'
};
var $d2818b570f093c78$var$borderRadius = 4;
// Used to calculate consistent margin/padding on elements
var $d2818b570f093c78$var$baseUnit = 4;
// The minimum height of the control
var $d2818b570f093c78$var$controlHeight = 38;
// The amount of space between the control and menu */
var $d2818b570f093c78$var$menuGutter = $d2818b570f093c78$var$baseUnit * 2;
var $d2818b570f093c78$var$spacing = {
    baseUnit: $d2818b570f093c78$var$baseUnit,
    controlHeight: $d2818b570f093c78$var$controlHeight,
    menuGutter: $d2818b570f093c78$var$menuGutter
};
var $d2818b570f093c78$export$4368d992c4eafac0 = {
    borderRadius: $d2818b570f093c78$var$borderRadius,
    colors: $d2818b570f093c78$var$colors,
    spacing: $d2818b570f093c78$var$spacing
};
var $d2818b570f093c78$export$407448d2b89b1813 = {
    'aria-live': 'polite',
    backspaceRemovesValue: true,
    blurInputOnSelect: (0, $6Wmpx.z)(),
    captureMenuScroll: !(0, $6Wmpx.z)(),
    classNames: {},
    closeMenuOnSelect: true,
    closeMenuOnScroll: false,
    components: {},
    controlShouldRenderValue: true,
    escapeClearsValue: false,
    filterOption: $d2818b570f093c78$export$db3b6bfb95261072(),
    formatGroupLabel: $d2818b570f093c78$var$formatGroupLabel,
    getOptionLabel: $d2818b570f093c78$export$8b22cf2602fb60ce,
    getOptionValue: $d2818b570f093c78$export$39b482c5e57630a8,
    isDisabled: false,
    isLoading: false,
    isMulti: false,
    isRtl: false,
    isSearchable: true,
    isOptionDisabled: $d2818b570f093c78$var$isOptionDisabled,
    loadingMessage: function loadingMessage() {
        return 'Loading...';
    },
    maxMenuHeight: 300,
    minMenuHeight: 140,
    menuIsOpen: false,
    menuPlacement: 'bottom',
    menuPosition: 'absolute',
    menuShouldBlockScroll: false,
    menuShouldScrollIntoView: !(0, $6Wmpx.A)(),
    noOptionsMessage: function noOptionsMessage() {
        return 'No options';
    },
    openMenuOnFocus: false,
    openMenuOnClick: true,
    options: [],
    pageSize: 5,
    placeholder: 'Select...',
    screenReaderStatus: function screenReaderStatus(_ref) {
        var count = _ref.count;
        return "".concat(count, " result").concat(count !== 1 ? 's' : '', " available");
    },
    styles: {},
    tabIndex: 0,
    tabSelectsValue: true,
    unstyled: false
};
function $d2818b570f093c78$var$toCategorizedOption(props, option, selectValue, index) {
    var isDisabled = $d2818b570f093c78$var$_isOptionDisabled(props, option, selectValue);
    var isSelected = $d2818b570f093c78$var$_isOptionSelected(props, option, selectValue);
    var label = $d2818b570f093c78$var$getOptionLabel(props, option);
    var value = $d2818b570f093c78$var$getOptionValue(props, option);
    return {
        type: 'option',
        data: option,
        isDisabled: isDisabled,
        isSelected: isSelected,
        label: label,
        value: value,
        index: index
    };
}
function $d2818b570f093c78$var$buildCategorizedOptions(props, selectValue) {
    return props.options.map(function(groupOrOption, groupOrOptionIndex) {
        if ('options' in groupOrOption) {
            var categorizedOptions = groupOrOption.options.map(function(option, optionIndex) {
                return $d2818b570f093c78$var$toCategorizedOption(props, option, selectValue, optionIndex);
            }).filter(function(categorizedOption) {
                return $d2818b570f093c78$var$isFocusable(props, categorizedOption);
            });
            return categorizedOptions.length > 0 ? {
                type: 'group',
                data: groupOrOption,
                options: categorizedOptions,
                index: groupOrOptionIndex
            } : undefined;
        }
        var categorizedOption = $d2818b570f093c78$var$toCategorizedOption(props, groupOrOption, selectValue, groupOrOptionIndex);
        return $d2818b570f093c78$var$isFocusable(props, categorizedOption) ? categorizedOption : undefined;
    }).filter((0, $6Wmpx.K));
}
function $d2818b570f093c78$var$buildFocusableOptionsFromCategorizedOptions(categorizedOptions) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return option.data;
        })));
        else optionsAccumulator.push(categorizedOption.data);
        return optionsAccumulator;
    }, []);
}
function $d2818b570f093c78$var$buildFocusableOptionsWithIds(categorizedOptions, optionId) {
    return categorizedOptions.reduce(function(optionsAccumulator, categorizedOption) {
        if (categorizedOption.type === 'group') optionsAccumulator.push.apply(optionsAccumulator, (0, $fVK4C.default)(categorizedOption.options.map(function(option) {
            return {
                data: option.data,
                id: "".concat(optionId, "-").concat(categorizedOption.index, "-").concat(option.index)
            };
        })));
        else optionsAccumulator.push({
            data: categorizedOption.data,
            id: "".concat(optionId, "-").concat(categorizedOption.index)
        });
        return optionsAccumulator;
    }, []);
}
function $d2818b570f093c78$var$buildFocusableOptions(props, selectValue) {
    return $d2818b570f093c78$var$buildFocusableOptionsFromCategorizedOptions($d2818b570f093c78$var$buildCategorizedOptions(props, selectValue));
}
function $d2818b570f093c78$var$isFocusable(props, categorizedOption) {
    var _props$inputValue = props.inputValue, inputValue = _props$inputValue === void 0 ? '' : _props$inputValue;
    var data = categorizedOption.data, isSelected = categorizedOption.isSelected, label = categorizedOption.label, value = categorizedOption.value;
    return (!$d2818b570f093c78$var$shouldHideSelectedOptions(props) || !isSelected) && $d2818b570f093c78$var$_filterOption(props, {
        label: label,
        value: value,
        data: data
    }, inputValue);
}
function $d2818b570f093c78$var$getNextFocusedValue(state, nextSelectValue) {
    var focusedValue = state.focusedValue, lastSelectValue = state.selectValue;
    var lastFocusedIndex = lastSelectValue.indexOf(focusedValue);
    if (lastFocusedIndex > -1) {
        var nextFocusedIndex = nextSelectValue.indexOf(focusedValue);
        if (nextFocusedIndex > -1) // the focused value is still in the selectValue, return it
        return focusedValue;
        else if (lastFocusedIndex < nextSelectValue.length) // the focusedValue is not present in the next selectValue array by
        // reference, so return the new value at the same index
        return nextSelectValue[lastFocusedIndex];
    }
    return null;
}
function $d2818b570f093c78$var$getNextFocusedOption(state, options) {
    var lastFocusedOption = state.focusedOption;
    return lastFocusedOption && options.indexOf(lastFocusedOption) > -1 ? lastFocusedOption : options[0];
}
var $d2818b570f093c78$var$getFocusedOptionId = function getFocusedOptionId(focusableOptionsWithIds, focusedOption) {
    var _focusableOptionsWith;
    var focusedOptionId = (_focusableOptionsWith = focusableOptionsWithIds.find(function(option) {
        return option.data === focusedOption;
    })) === null || _focusableOptionsWith === void 0 ? void 0 : _focusableOptionsWith.id;
    return focusedOptionId || null;
};
var $d2818b570f093c78$var$getOptionLabel = function getOptionLabel(props, data) {
    return props.getOptionLabel(data);
};
var $d2818b570f093c78$var$getOptionValue = function getOptionValue(props, data) {
    return props.getOptionValue(data);
};
function $d2818b570f093c78$var$_isOptionDisabled(props, option, selectValue) {
    return typeof props.isOptionDisabled === 'function' ? props.isOptionDisabled(option, selectValue) : false;
}
function $d2818b570f093c78$var$_isOptionSelected(props, option, selectValue) {
    if (selectValue.indexOf(option) > -1) return true;
    if (typeof props.isOptionSelected === 'function') return props.isOptionSelected(option, selectValue);
    var candidate = $d2818b570f093c78$var$getOptionValue(props, option);
    return selectValue.some(function(i) {
        return $d2818b570f093c78$var$getOptionValue(props, i) === candidate;
    });
}
function $d2818b570f093c78$var$_filterOption(props, option, inputValue) {
    return props.filterOption ? props.filterOption(option, inputValue) : true;
}
var $d2818b570f093c78$var$shouldHideSelectedOptions = function shouldHideSelectedOptions(props) {
    var hideSelectedOptions = props.hideSelectedOptions, isMulti = props.isMulti;
    if (hideSelectedOptions === undefined) return isMulti;
    return hideSelectedOptions;
};
var $d2818b570f093c78$var$instanceId = 1;
var $d2818b570f093c78$export$25ce5a424b770e84 = /*#__PURE__*/ function(_Component) {
    (0, $eT4IF.default)(Select, _Component);
    var _super = (0, $7Dzgl.default)(Select);
    // Misc. Instance Properties
    // ------------------------------
    // TODO
    // Refs
    // ------------------------------
    // Lifecycle
    // ------------------------------
    function Select(_props) {
        var _this;
        (0, $lDSrn.default)(this, Select);
        _this = _super.call(this, _props);
        _this.state = {
            ariaSelection: null,
            focusedOption: null,
            focusedOptionId: null,
            focusableOptionsWithIds: [],
            focusedValue: null,
            inputIsHidden: false,
            isFocused: false,
            selectValue: [],
            clearFocusValueOnUpdate: false,
            prevWasFocused: false,
            inputIsHiddenAfterUpdate: undefined,
            prevProps: undefined,
            instancePrefix: ''
        };
        _this.blockOptionHover = false;
        _this.isComposing = false;
        _this.commonProps = void 0;
        _this.initialTouchX = 0;
        _this.initialTouchY = 0;
        _this.openAfterFocus = false;
        _this.scrollToFocusedOptionOnUpdate = false;
        _this.userIsDragging = void 0;
        _this.isAppleDevice = $d2818b570f093c78$var$isAppleDevice();
        _this.controlRef = null;
        _this.getControlRef = function(ref) {
            _this.controlRef = ref;
        };
        _this.focusedOptionRef = null;
        _this.getFocusedOptionRef = function(ref) {
            _this.focusedOptionRef = ref;
        };
        _this.menuListRef = null;
        _this.getMenuListRef = function(ref) {
            _this.menuListRef = ref;
        };
        _this.inputRef = null;
        _this.getInputRef = function(ref) {
            _this.inputRef = ref;
        };
        _this.focus = _this.focusInput;
        _this.blur = _this.blurInput;
        _this.onChange = function(newValue, actionMeta) {
            var _this$props = _this.props, onChange = _this$props.onChange, name = _this$props.name;
            actionMeta.name = name;
            _this.ariaOnChange(newValue, actionMeta);
            onChange(newValue, actionMeta);
        };
        _this.setValue = function(newValue, action, option) {
            var _this$props2 = _this.props, closeMenuOnSelect = _this$props2.closeMenuOnSelect, isMulti = _this$props2.isMulti, inputValue = _this$props2.inputValue;
            _this.onInputChange('', {
                action: 'set-value',
                prevInputValue: inputValue
            });
            if (closeMenuOnSelect) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            }
            // when the select value should change, we should reset focusedValue
            _this.setState({
                clearFocusValueOnUpdate: true
            });
            _this.onChange(newValue, {
                action: action,
                option: option
            });
        };
        _this.selectOption = function(newValue) {
            var _this$props3 = _this.props, blurInputOnSelect = _this$props3.blurInputOnSelect, isMulti = _this$props3.isMulti, name = _this$props3.name;
            var selectValue = _this.state.selectValue;
            var deselected = isMulti && _this.isOptionSelected(newValue, selectValue);
            var isDisabled = _this.isOptionDisabled(newValue, selectValue);
            if (deselected) {
                var candidate = _this.getOptionValue(newValue);
                _this.setValue((0, $6Wmpx.B)(selectValue.filter(function(i) {
                    return _this.getOptionValue(i) !== candidate;
                })), 'deselect-option', newValue);
            } else if (!isDisabled) {
                // Select option if option is not disabled
                if (isMulti) _this.setValue((0, $6Wmpx.B)([].concat((0, $fVK4C.default)(selectValue), [
                    newValue
                ])), 'select-option', newValue);
                else _this.setValue((0, $6Wmpx.C)(newValue), 'select-option');
            } else {
                _this.ariaOnChange((0, $6Wmpx.C)(newValue), {
                    action: 'select-option',
                    option: newValue,
                    name: name
                });
                return;
            }
            if (blurInputOnSelect) _this.blurInput();
        };
        _this.removeValue = function(removedValue) {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var candidate = _this.getOptionValue(removedValue);
            var newValueArray = selectValue.filter(function(i) {
                return _this.getOptionValue(i) !== candidate;
            });
            var newValue = (0, $6Wmpx.D)(isMulti, newValueArray, newValueArray[0] || null);
            _this.onChange(newValue, {
                action: 'remove-value',
                removedValue: removedValue
            });
            _this.focusInput();
        };
        _this.clearValue = function() {
            var selectValue = _this.state.selectValue;
            _this.onChange((0, $6Wmpx.D)(_this.props.isMulti, [], null), {
                action: 'clear',
                removedValues: selectValue
            });
        };
        _this.popValue = function() {
            var isMulti = _this.props.isMulti;
            var selectValue = _this.state.selectValue;
            var lastSelectedValue = selectValue[selectValue.length - 1];
            var newValueArray = selectValue.slice(0, selectValue.length - 1);
            var newValue = (0, $6Wmpx.D)(isMulti, newValueArray, newValueArray[0] || null);
            if (lastSelectedValue) _this.onChange(newValue, {
                action: 'pop-value',
                removedValue: lastSelectedValue
            });
        };
        _this.getFocusedOptionId = function(focusedOption) {
            return $d2818b570f093c78$var$getFocusedOptionId(_this.state.focusableOptionsWithIds, focusedOption);
        };
        _this.getFocusableOptionsWithIds = function() {
            return $d2818b570f093c78$var$buildFocusableOptionsWithIds($d2818b570f093c78$var$buildCategorizedOptions(_this.props, _this.state.selectValue), _this.getElementId('option'));
        };
        _this.getValue = function() {
            return _this.state.selectValue;
        };
        _this.cx = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            return (0, $6Wmpx.E).apply(void 0, [
                _this.props.classNamePrefix
            ].concat(args));
        };
        _this.getOptionLabel = function(data) {
            return $d2818b570f093c78$var$getOptionLabel(_this.props, data);
        };
        _this.getOptionValue = function(data) {
            return $d2818b570f093c78$var$getOptionValue(_this.props, data);
        };
        _this.getStyles = function(key, props) {
            var unstyled = _this.props.unstyled;
            var base = $d2818b570f093c78$var$defaultStyles[key](props, unstyled);
            base.boxSizing = 'border-box';
            var custom = _this.props.styles[key];
            return custom ? custom(base, props) : base;
        };
        _this.getClassNames = function(key, props) {
            var _this$props$className, _this$props$className2;
            return (_this$props$className = (_this$props$className2 = _this.props.classNames)[key]) === null || _this$props$className === void 0 ? void 0 : _this$props$className.call(_this$props$className2, props);
        };
        _this.getElementId = function(element) {
            return "".concat(_this.state.instancePrefix, "-").concat(element);
        };
        _this.getComponents = function() {
            return (0, $6Wmpx.F)(_this.props);
        };
        _this.buildCategorizedOptions = function() {
            return $d2818b570f093c78$var$buildCategorizedOptions(_this.props, _this.state.selectValue);
        };
        _this.getCategorizedOptions = function() {
            return _this.props.menuIsOpen ? _this.buildCategorizedOptions() : [];
        };
        _this.buildFocusableOptions = function() {
            return $d2818b570f093c78$var$buildFocusableOptionsFromCategorizedOptions(_this.buildCategorizedOptions());
        };
        _this.getFocusableOptions = function() {
            return _this.props.menuIsOpen ? _this.buildFocusableOptions() : [];
        };
        _this.ariaOnChange = function(value, actionMeta) {
            _this.setState({
                ariaSelection: (0, $1Xn5q.default)({
                    value: value
                }, actionMeta)
            });
        };
        _this.onMenuMouseDown = function(event) {
            if (event.button !== 0) return;
            event.stopPropagation();
            event.preventDefault();
            _this.focusInput();
        };
        _this.onMenuMouseMove = function(event) {
            _this.blockOptionHover = false;
        };
        _this.onControlMouseDown = function(event) {
            // Event captured by dropdown indicator
            if (event.defaultPrevented) return;
            var openMenuOnClick = _this.props.openMenuOnClick;
            if (!_this.state.isFocused) {
                if (openMenuOnClick) _this.openAfterFocus = true;
                _this.focusInput();
            } else if (!_this.props.menuIsOpen) {
                if (openMenuOnClick) _this.openMenu('first');
            } else if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') _this.onMenuClose();
            if (event.target.tagName !== 'INPUT' && event.target.tagName !== 'TEXTAREA') event.preventDefault();
        };
        _this.onDropdownIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            if (_this.props.isDisabled) return;
            var _this$props4 = _this.props, isMulti = _this$props4.isMulti, menuIsOpen = _this$props4.menuIsOpen;
            _this.focusInput();
            if (menuIsOpen) {
                _this.setState({
                    inputIsHiddenAfterUpdate: !isMulti
                });
                _this.onMenuClose();
            } else _this.openMenu('first');
            event.preventDefault();
        };
        _this.onClearIndicatorMouseDown = function(event) {
            // ignore mouse events that weren't triggered by the primary button
            if (event && event.type === 'mousedown' && event.button !== 0) return;
            _this.clearValue();
            event.preventDefault();
            _this.openAfterFocus = false;
            if (event.type === 'touchend') _this.focusInput();
            else setTimeout(function() {
                return _this.focusInput();
            });
        };
        _this.onScroll = function(event) {
            if (typeof _this.props.closeMenuOnScroll === 'boolean') {
                if (event.target instanceof HTMLElement && (0, $6Wmpx.G)(event.target)) _this.props.onMenuClose();
            } else if (typeof _this.props.closeMenuOnScroll === 'function') {
                if (_this.props.closeMenuOnScroll(event)) _this.props.onMenuClose();
            }
        };
        _this.onCompositionStart = function() {
            _this.isComposing = true;
        };
        _this.onCompositionEnd = function() {
            _this.isComposing = false;
        };
        _this.onTouchStart = function(_ref2) {
            var touches = _ref2.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            _this.initialTouchX = touch.clientX;
            _this.initialTouchY = touch.clientY;
            _this.userIsDragging = false;
        };
        _this.onTouchMove = function(_ref3) {
            var touches = _ref3.touches;
            var touch = touches && touches.item(0);
            if (!touch) return;
            var deltaX = Math.abs(touch.clientX - _this.initialTouchX);
            var deltaY = Math.abs(touch.clientY - _this.initialTouchY);
            var moveThreshold = 5;
            _this.userIsDragging = deltaX > moveThreshold || deltaY > moveThreshold;
        };
        _this.onTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            // close the menu if the user taps outside
            // we're checking on event.target here instead of event.currentTarget, because we want to assert information
            // on events on child elements, not the document (which we've attached this handler to).
            if (_this.controlRef && !_this.controlRef.contains(event.target) && _this.menuListRef && !_this.menuListRef.contains(event.target)) _this.blurInput();
            // reset move vars
            _this.initialTouchX = 0;
            _this.initialTouchY = 0;
        };
        _this.onControlTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onControlMouseDown(event);
        };
        _this.onClearIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onClearIndicatorMouseDown(event);
        };
        _this.onDropdownIndicatorTouchEnd = function(event) {
            if (_this.userIsDragging) return;
            _this.onDropdownIndicatorMouseDown(event);
        };
        _this.handleInputChange = function(event) {
            var prevInputValue = _this.props.inputValue;
            var inputValue = event.currentTarget.value;
            _this.setState({
                inputIsHiddenAfterUpdate: false
            });
            _this.onInputChange(inputValue, {
                action: 'input-change',
                prevInputValue: prevInputValue
            });
            if (!_this.props.menuIsOpen) _this.onMenuOpen();
        };
        _this.onInputFocus = function(event) {
            if (_this.props.onFocus) _this.props.onFocus(event);
            _this.setState({
                inputIsHiddenAfterUpdate: false,
                isFocused: true
            });
            if (_this.openAfterFocus || _this.props.openMenuOnFocus) _this.openMenu('first');
            _this.openAfterFocus = false;
        };
        _this.onInputBlur = function(event) {
            var prevInputValue = _this.props.inputValue;
            if (_this.menuListRef && _this.menuListRef.contains(document.activeElement)) {
                _this.inputRef.focus();
                return;
            }
            if (_this.props.onBlur) _this.props.onBlur(event);
            _this.onInputChange('', {
                action: 'input-blur',
                prevInputValue: prevInputValue
            });
            _this.onMenuClose();
            _this.setState({
                focusedValue: null,
                isFocused: false
            });
        };
        _this.onOptionHover = function(focusedOption) {
            if (_this.blockOptionHover || _this.state.focusedOption === focusedOption) return;
            var options = _this.getFocusableOptions();
            var focusedOptionIndex = options.indexOf(focusedOption);
            _this.setState({
                focusedOption: focusedOption,
                focusedOptionId: focusedOptionIndex > -1 ? _this.getFocusedOptionId(focusedOption) : null
            });
        };
        _this.shouldHideSelectedOptions = function() {
            return $d2818b570f093c78$var$shouldHideSelectedOptions(_this.props);
        };
        _this.onValueInputFocus = function(e) {
            e.preventDefault();
            e.stopPropagation();
            _this.focus();
        };
        _this.onKeyDown = function(event) {
            var _this$props5 = _this.props, isMulti = _this$props5.isMulti, backspaceRemovesValue = _this$props5.backspaceRemovesValue, escapeClearsValue = _this$props5.escapeClearsValue, inputValue = _this$props5.inputValue, isClearable = _this$props5.isClearable, isDisabled = _this$props5.isDisabled, menuIsOpen = _this$props5.menuIsOpen, onKeyDown = _this$props5.onKeyDown, tabSelectsValue = _this$props5.tabSelectsValue, openMenuOnFocus = _this$props5.openMenuOnFocus;
            var _this$state = _this.state, focusedOption = _this$state.focusedOption, focusedValue = _this$state.focusedValue, selectValue = _this$state.selectValue;
            if (isDisabled) return;
            if (typeof onKeyDown === 'function') {
                onKeyDown(event);
                if (event.defaultPrevented) return;
            }
            // Block option hover events when the user has just pressed a key
            _this.blockOptionHover = true;
            switch(event.key){
                case 'ArrowLeft':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('previous');
                    break;
                case 'ArrowRight':
                    if (!isMulti || inputValue) return;
                    _this.focusValue('next');
                    break;
                case 'Delete':
                case 'Backspace':
                    if (inputValue) return;
                    if (focusedValue) _this.removeValue(focusedValue);
                    else {
                        if (!backspaceRemovesValue) return;
                        if (isMulti) _this.popValue();
                        else if (isClearable) _this.clearValue();
                    }
                    break;
                case 'Tab':
                    if (_this.isComposing) return;
                    if (event.shiftKey || !menuIsOpen || !tabSelectsValue || !focusedOption || // don't capture the event if the menu opens on focus and the focused
                    // option is already selected; it breaks the flow of navigation
                    openMenuOnFocus && _this.isOptionSelected(focusedOption, selectValue)) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'Enter':
                    if (event.keyCode === 229) break;
                    if (menuIsOpen) {
                        if (!focusedOption) return;
                        if (_this.isComposing) return;
                        _this.selectOption(focusedOption);
                        break;
                    }
                    return;
                case 'Escape':
                    if (menuIsOpen) {
                        _this.setState({
                            inputIsHiddenAfterUpdate: false
                        });
                        _this.onInputChange('', {
                            action: 'menu-close',
                            prevInputValue: inputValue
                        });
                        _this.onMenuClose();
                    } else if (isClearable && escapeClearsValue) _this.clearValue();
                    break;
                case ' ':
                    // space
                    if (inputValue) return;
                    if (!menuIsOpen) {
                        _this.openMenu('first');
                        break;
                    }
                    if (!focusedOption) return;
                    _this.selectOption(focusedOption);
                    break;
                case 'ArrowUp':
                    if (menuIsOpen) _this.focusOption('up');
                    else _this.openMenu('last');
                    break;
                case 'ArrowDown':
                    if (menuIsOpen) _this.focusOption('down');
                    else _this.openMenu('first');
                    break;
                case 'PageUp':
                    if (!menuIsOpen) return;
                    _this.focusOption('pageup');
                    break;
                case 'PageDown':
                    if (!menuIsOpen) return;
                    _this.focusOption('pagedown');
                    break;
                case 'Home':
                    if (!menuIsOpen) return;
                    _this.focusOption('first');
                    break;
                case 'End':
                    if (!menuIsOpen) return;
                    _this.focusOption('last');
                    break;
                default:
                    return;
            }
            event.preventDefault();
        };
        _this.state.instancePrefix = 'react-select-' + (_this.props.instanceId || ++$d2818b570f093c78$var$instanceId);
        _this.state.selectValue = (0, $6Wmpx.H)(_props.value);
        // Set focusedOption if menuIsOpen is set on init (e.g. defaultMenuIsOpen)
        if (_props.menuIsOpen && _this.state.selectValue.length) {
            var focusableOptionsWithIds = _this.getFocusableOptionsWithIds();
            var focusableOptions = _this.buildFocusableOptions();
            var optionIndex = focusableOptions.indexOf(_this.state.selectValue[0]);
            _this.state.focusableOptionsWithIds = focusableOptionsWithIds;
            _this.state.focusedOption = focusableOptions[optionIndex];
            _this.state.focusedOptionId = $d2818b570f093c78$var$getFocusedOptionId(focusableOptionsWithIds, focusableOptions[optionIndex]);
        }
        return _this;
    }
    (0, $lIEGP.default)(Select, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.startListeningComposition();
                this.startListeningToTouch();
                if (this.props.closeMenuOnScroll && document && document.addEventListener) // Listen to all scroll events, and filter them out inside of 'onScroll'
                document.addEventListener('scroll', this.onScroll, true);
                if (this.props.autoFocus) this.focusInput();
                // Scroll focusedOption into view if menuIsOpen is set on mount (e.g. defaultMenuIsOpen)
                if (this.props.menuIsOpen && this.state.focusedOption && this.menuListRef && this.focusedOptionRef) (0, $6Wmpx.I)(this.menuListRef, this.focusedOptionRef);
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                var _this$props6 = this.props, isDisabled = _this$props6.isDisabled, menuIsOpen = _this$props6.menuIsOpen;
                var isFocused = this.state.isFocused;
                if (// ensure focus is restored correctly when the control becomes enabled
                isFocused && !isDisabled && prevProps.isDisabled || // ensure focus is on the Input when the menu opens
                isFocused && menuIsOpen && !prevProps.menuIsOpen) this.focusInput();
                if (isFocused && isDisabled && !prevProps.isDisabled) // ensure select state gets blurred in case Select is programmatically disabled while focused
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: false
                }, this.onMenuClose);
                else if (!isFocused && !isDisabled && prevProps.isDisabled && this.inputRef === document.activeElement) // ensure select state gets focused in case Select is programatically re-enabled while focused (Firefox)
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({
                    isFocused: true
                });
                // scroll the focused option into view if necessary
                if (this.menuListRef && this.focusedOptionRef && this.scrollToFocusedOptionOnUpdate) {
                    (0, $6Wmpx.I)(this.menuListRef, this.focusedOptionRef);
                    this.scrollToFocusedOptionOnUpdate = false;
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                this.stopListeningComposition();
                this.stopListeningToTouch();
                document.removeEventListener('scroll', this.onScroll, true);
            }
        },
        {
            key: "onMenuOpen",
            value: function onMenuOpen() {
                this.props.onMenuOpen();
            }
        },
        {
            key: "onMenuClose",
            value: function onMenuClose() {
                this.onInputChange('', {
                    action: 'menu-close',
                    prevInputValue: this.props.inputValue
                });
                this.props.onMenuClose();
            }
        },
        {
            key: "onInputChange",
            value: function onInputChange(newValue, actionMeta) {
                this.props.onInputChange(newValue, actionMeta);
            }
        },
        {
            key: "focusInput",
            value: function focusInput() {
                if (!this.inputRef) return;
                this.inputRef.focus();
            }
        },
        {
            key: "blurInput",
            value: function blurInput() {
                if (!this.inputRef) return;
                this.inputRef.blur();
            }
        },
        {
            key: "openMenu",
            value: function openMenu(focusOption) {
                var _this2 = this;
                var _this$state2 = this.state, selectValue = _this$state2.selectValue, isFocused = _this$state2.isFocused;
                var focusableOptions = this.buildFocusableOptions();
                var openAtIndex = focusOption === 'first' ? 0 : focusableOptions.length - 1;
                if (!this.props.isMulti) {
                    var selectedIndex = focusableOptions.indexOf(selectValue[0]);
                    if (selectedIndex > -1) openAtIndex = selectedIndex;
                }
                // only scroll if the menu isn't already open
                this.scrollToFocusedOptionOnUpdate = !(isFocused && this.menuListRef);
                this.setState({
                    inputIsHiddenAfterUpdate: false,
                    focusedValue: null,
                    focusedOption: focusableOptions[openAtIndex],
                    focusedOptionId: this.getFocusedOptionId(focusableOptions[openAtIndex])
                }, function() {
                    return _this2.onMenuOpen();
                });
            }
        },
        {
            key: "focusValue",
            value: function focusValue(direction) {
                var _this$state3 = this.state, selectValue = _this$state3.selectValue, focusedValue = _this$state3.focusedValue;
                // Only multiselects support value focusing
                if (!this.props.isMulti) return;
                this.setState({
                    focusedOption: null
                });
                var focusedIndex = selectValue.indexOf(focusedValue);
                if (!focusedValue) focusedIndex = -1;
                var lastIndex = selectValue.length - 1;
                var nextFocus = -1;
                if (!selectValue.length) return;
                switch(direction){
                    case 'previous':
                        if (focusedIndex === 0) // don't cycle from the start to the end
                        nextFocus = 0;
                        else if (focusedIndex === -1) // if nothing is focused, focus the last value first
                        nextFocus = lastIndex;
                        else nextFocus = focusedIndex - 1;
                        break;
                    case 'next':
                        if (focusedIndex > -1 && focusedIndex < lastIndex) nextFocus = focusedIndex + 1;
                        break;
                }
                this.setState({
                    inputIsHidden: nextFocus !== -1,
                    focusedValue: selectValue[nextFocus]
                });
            }
        },
        {
            key: "focusOption",
            value: function focusOption() {
                var direction = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'first';
                var pageSize = this.props.pageSize;
                var focusedOption = this.state.focusedOption;
                var options = this.getFocusableOptions();
                if (!options.length) return;
                var nextFocus = 0; // handles 'first'
                var focusedIndex = options.indexOf(focusedOption);
                if (!focusedOption) focusedIndex = -1;
                if (direction === 'up') nextFocus = focusedIndex > 0 ? focusedIndex - 1 : options.length - 1;
                else if (direction === 'down') nextFocus = (focusedIndex + 1) % options.length;
                else if (direction === 'pageup') {
                    nextFocus = focusedIndex - pageSize;
                    if (nextFocus < 0) nextFocus = 0;
                } else if (direction === 'pagedown') {
                    nextFocus = focusedIndex + pageSize;
                    if (nextFocus > options.length - 1) nextFocus = options.length - 1;
                } else if (direction === 'last') nextFocus = options.length - 1;
                this.scrollToFocusedOptionOnUpdate = true;
                this.setState({
                    focusedOption: options[nextFocus],
                    focusedValue: null,
                    focusedOptionId: this.getFocusedOptionId(options[nextFocus])
                });
            }
        },
        {
            key: "getTheme",
            value: // ==============================
            // Getters
            // ==============================
            function getTheme() {
                // Use the default theme if there are no customisations.
                if (!this.props.theme) return $d2818b570f093c78$export$4368d992c4eafac0;
                // If the theme prop is a function, assume the function
                // knows how to merge the passed-in default theme with
                // its own modifications.
                if (typeof this.props.theme === 'function') return this.props.theme($d2818b570f093c78$export$4368d992c4eafac0);
                // Otherwise, if a plain theme object was passed in,
                // overlay it with the default theme.
                return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $d2818b570f093c78$export$4368d992c4eafac0), this.props.theme);
            }
        },
        {
            key: "getCommonProps",
            value: function getCommonProps() {
                var clearValue = this.clearValue, cx = this.cx, getStyles = this.getStyles, getClassNames = this.getClassNames, getValue = this.getValue, selectOption = this.selectOption, setValue = this.setValue, props = this.props;
                var isMulti = props.isMulti, isRtl = props.isRtl, options = props.options;
                var hasValue = this.hasValue();
                return {
                    clearValue: clearValue,
                    cx: cx,
                    getStyles: getStyles,
                    getClassNames: getClassNames,
                    getValue: getValue,
                    hasValue: hasValue,
                    isMulti: isMulti,
                    isRtl: isRtl,
                    options: options,
                    selectOption: selectOption,
                    selectProps: props,
                    setValue: setValue,
                    theme: this.getTheme()
                };
            }
        },
        {
            key: "hasValue",
            value: function hasValue() {
                var selectValue = this.state.selectValue;
                return selectValue.length > 0;
            }
        },
        {
            key: "hasOptions",
            value: function hasOptions() {
                return !!this.getFocusableOptions().length;
            }
        },
        {
            key: "isClearable",
            value: function isClearable() {
                var _this$props7 = this.props, isClearable = _this$props7.isClearable, isMulti = _this$props7.isMulti;
                // single select, by default, IS NOT clearable
                // multi select, by default, IS clearable
                if (isClearable === undefined) return isMulti;
                return isClearable;
            }
        },
        {
            key: "isOptionDisabled",
            value: function isOptionDisabled(option, selectValue) {
                return $d2818b570f093c78$var$_isOptionDisabled(this.props, option, selectValue);
            }
        },
        {
            key: "isOptionSelected",
            value: function isOptionSelected(option, selectValue) {
                return $d2818b570f093c78$var$_isOptionSelected(this.props, option, selectValue);
            }
        },
        {
            key: "filterOption",
            value: function filterOption(option, inputValue) {
                return $d2818b570f093c78$var$_filterOption(this.props, option, inputValue);
            }
        },
        {
            key: "formatOptionLabel",
            value: function formatOptionLabel(data, context) {
                if (typeof this.props.formatOptionLabel === 'function') {
                    var _inputValue = this.props.inputValue;
                    var _selectValue = this.state.selectValue;
                    return this.props.formatOptionLabel(data, {
                        context: context,
                        inputValue: _inputValue,
                        selectValue: _selectValue
                    });
                } else return this.getOptionLabel(data);
            }
        },
        {
            key: "formatGroupLabel",
            value: function formatGroupLabel(data) {
                return this.props.formatGroupLabel(data);
            }
        },
        {
            key: "startListeningComposition",
            value: // ==============================
            // Composition Handlers
            // ==============================
            function startListeningComposition() {
                if (document && document.addEventListener) {
                    document.addEventListener('compositionstart', this.onCompositionStart, false);
                    document.addEventListener('compositionend', this.onCompositionEnd, false);
                }
            }
        },
        {
            key: "stopListeningComposition",
            value: function stopListeningComposition() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('compositionstart', this.onCompositionStart);
                    document.removeEventListener('compositionend', this.onCompositionEnd);
                }
            }
        },
        {
            key: "startListeningToTouch",
            value: // ==============================
            // Touch Handlers
            // ==============================
            function startListeningToTouch() {
                if (document && document.addEventListener) {
                    document.addEventListener('touchstart', this.onTouchStart, false);
                    document.addEventListener('touchmove', this.onTouchMove, false);
                    document.addEventListener('touchend', this.onTouchEnd, false);
                }
            }
        },
        {
            key: "stopListeningToTouch",
            value: function stopListeningToTouch() {
                if (document && document.removeEventListener) {
                    document.removeEventListener('touchstart', this.onTouchStart);
                    document.removeEventListener('touchmove', this.onTouchMove);
                    document.removeEventListener('touchend', this.onTouchEnd);
                }
            }
        },
        {
            key: "renderInput",
            value: // ==============================
            // Renderers
            // ==============================
            function renderInput() {
                var _this$props8 = this.props, isDisabled = _this$props8.isDisabled, isSearchable = _this$props8.isSearchable, inputId = _this$props8.inputId, inputValue = _this$props8.inputValue, tabIndex = _this$props8.tabIndex, form = _this$props8.form, menuIsOpen = _this$props8.menuIsOpen, required = _this$props8.required;
                var _this$getComponents = this.getComponents(), Input = _this$getComponents.Input;
                var _this$state4 = this.state, inputIsHidden = _this$state4.inputIsHidden, ariaSelection = _this$state4.ariaSelection;
                var commonProps = this.commonProps;
                var id = inputId || this.getElementId('input');
                // aria attributes makes the JSX "noisy", separated for clarity
                var ariaAttributes = (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({
                    'aria-autocomplete': 'list',
                    'aria-expanded': menuIsOpen,
                    'aria-haspopup': true,
                    'aria-errormessage': this.props['aria-errormessage'],
                    'aria-invalid': this.props['aria-invalid'],
                    'aria-label': this.props['aria-label'],
                    'aria-labelledby': this.props['aria-labelledby'],
                    'aria-required': required,
                    role: 'combobox',
                    'aria-activedescendant': this.isAppleDevice ? undefined : this.state.focusedOptionId || ''
                }, menuIsOpen && {
                    'aria-controls': this.getElementId('listbox')
                }), !isSearchable && {
                    'aria-readonly': true
                }), this.hasValue() ? (ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus' && {
                    'aria-describedby': this.getElementId('live-region')
                } : {
                    'aria-describedby': this.getElementId('placeholder')
                });
                if (!isSearchable) // use a dummy input to maintain focus/blur functionality
                return /*#__PURE__*/ $eUqFw.createElement($d2818b570f093c78$var$DummyInput, (0, $kU09D.default)({
                    id: id,
                    innerRef: this.getInputRef,
                    onBlur: this.onInputBlur,
                    onChange: (0, $6Wmpx.J),
                    onFocus: this.onInputFocus,
                    disabled: isDisabled,
                    tabIndex: tabIndex,
                    inputMode: "none",
                    form: form,
                    value: ""
                }, ariaAttributes));
                return /*#__PURE__*/ $eUqFw.createElement(Input, (0, $kU09D.default)({}, commonProps, {
                    autoCapitalize: "none",
                    autoComplete: "off",
                    autoCorrect: "off",
                    id: id,
                    innerRef: this.getInputRef,
                    isDisabled: isDisabled,
                    isHidden: inputIsHidden,
                    onBlur: this.onInputBlur,
                    onChange: this.handleInputChange,
                    onFocus: this.onInputFocus,
                    spellCheck: "false",
                    tabIndex: tabIndex,
                    form: form,
                    type: "text",
                    value: inputValue
                }, ariaAttributes));
            }
        },
        {
            key: "renderPlaceholderOrValue",
            value: function renderPlaceholderOrValue() {
                var _this3 = this;
                var _this$getComponents2 = this.getComponents(), MultiValue = _this$getComponents2.MultiValue, MultiValueContainer = _this$getComponents2.MultiValueContainer, MultiValueLabel = _this$getComponents2.MultiValueLabel, MultiValueRemove = _this$getComponents2.MultiValueRemove, SingleValue = _this$getComponents2.SingleValue, Placeholder = _this$getComponents2.Placeholder;
                var commonProps = this.commonProps;
                var _this$props9 = this.props, controlShouldRenderValue = _this$props9.controlShouldRenderValue, isDisabled = _this$props9.isDisabled, isMulti = _this$props9.isMulti, inputValue = _this$props9.inputValue, placeholder = _this$props9.placeholder;
                var _this$state5 = this.state, selectValue = _this$state5.selectValue, focusedValue = _this$state5.focusedValue, isFocused = _this$state5.isFocused;
                if (!this.hasValue() || !controlShouldRenderValue) return inputValue ? null : /*#__PURE__*/ $eUqFw.createElement(Placeholder, (0, $kU09D.default)({}, commonProps, {
                    key: "placeholder",
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    innerProps: {
                        id: this.getElementId('placeholder')
                    }
                }), placeholder);
                if (isMulti) return selectValue.map(function(opt, index) {
                    var isOptionFocused = opt === focusedValue;
                    var key = "".concat(_this3.getOptionLabel(opt), "-").concat(_this3.getOptionValue(opt));
                    return /*#__PURE__*/ $eUqFw.createElement(MultiValue, (0, $kU09D.default)({}, commonProps, {
                        components: {
                            Container: MultiValueContainer,
                            Label: MultiValueLabel,
                            Remove: MultiValueRemove
                        },
                        isFocused: isOptionFocused,
                        isDisabled: isDisabled,
                        key: key,
                        index: index,
                        removeProps: {
                            onClick: function onClick() {
                                return _this3.removeValue(opt);
                            },
                            onTouchEnd: function onTouchEnd() {
                                return _this3.removeValue(opt);
                            },
                            onMouseDown: function onMouseDown(e) {
                                e.preventDefault();
                            }
                        },
                        data: opt
                    }), _this3.formatOptionLabel(opt, 'value'));
                });
                if (inputValue) return null;
                var singleValue = selectValue[0];
                return /*#__PURE__*/ $eUqFw.createElement(SingleValue, (0, $kU09D.default)({}, commonProps, {
                    data: singleValue,
                    isDisabled: isDisabled
                }), this.formatOptionLabel(singleValue, 'value'));
            }
        },
        {
            key: "renderClearIndicator",
            value: function renderClearIndicator() {
                var _this$getComponents3 = this.getComponents(), ClearIndicator = _this$getComponents3.ClearIndicator;
                var commonProps = this.commonProps;
                var _this$props10 = this.props, isDisabled = _this$props10.isDisabled, isLoading = _this$props10.isLoading;
                var isFocused = this.state.isFocused;
                if (!this.isClearable() || !ClearIndicator || isDisabled || !this.hasValue() || isLoading) return null;
                var innerProps = {
                    onMouseDown: this.onClearIndicatorMouseDown,
                    onTouchEnd: this.onClearIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(ClearIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderLoadingIndicator",
            value: function renderLoadingIndicator() {
                var _this$getComponents4 = this.getComponents(), LoadingIndicator = _this$getComponents4.LoadingIndicator;
                var commonProps = this.commonProps;
                var _this$props11 = this.props, isDisabled = _this$props11.isDisabled, isLoading = _this$props11.isLoading;
                var isFocused = this.state.isFocused;
                if (!LoadingIndicator || !isLoading) return null;
                var innerProps = {
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(LoadingIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderIndicatorSeparator",
            value: function renderIndicatorSeparator() {
                var _this$getComponents5 = this.getComponents(), DropdownIndicator = _this$getComponents5.DropdownIndicator, IndicatorSeparator = _this$getComponents5.IndicatorSeparator;
                // separator doesn't make sense without the dropdown indicator
                if (!DropdownIndicator || !IndicatorSeparator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                return /*#__PURE__*/ $eUqFw.createElement(IndicatorSeparator, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderDropdownIndicator",
            value: function renderDropdownIndicator() {
                var _this$getComponents6 = this.getComponents(), DropdownIndicator = _this$getComponents6.DropdownIndicator;
                if (!DropdownIndicator) return null;
                var commonProps = this.commonProps;
                var isDisabled = this.props.isDisabled;
                var isFocused = this.state.isFocused;
                var innerProps = {
                    onMouseDown: this.onDropdownIndicatorMouseDown,
                    onTouchEnd: this.onDropdownIndicatorTouchEnd,
                    'aria-hidden': 'true'
                };
                return /*#__PURE__*/ $eUqFw.createElement(DropdownIndicator, (0, $kU09D.default)({}, commonProps, {
                    innerProps: innerProps,
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }));
            }
        },
        {
            key: "renderMenu",
            value: function renderMenu() {
                var _this4 = this;
                var _this$getComponents7 = this.getComponents(), Group = _this$getComponents7.Group, GroupHeading = _this$getComponents7.GroupHeading, Menu = _this$getComponents7.Menu, MenuList = _this$getComponents7.MenuList, MenuPortal = _this$getComponents7.MenuPortal, LoadingMessage = _this$getComponents7.LoadingMessage, NoOptionsMessage = _this$getComponents7.NoOptionsMessage, Option = _this$getComponents7.Option;
                var commonProps = this.commonProps;
                var focusedOption = this.state.focusedOption;
                var _this$props12 = this.props, captureMenuScroll = _this$props12.captureMenuScroll, inputValue = _this$props12.inputValue, isLoading = _this$props12.isLoading, loadingMessage = _this$props12.loadingMessage, minMenuHeight = _this$props12.minMenuHeight, maxMenuHeight = _this$props12.maxMenuHeight, menuIsOpen = _this$props12.menuIsOpen, menuPlacement = _this$props12.menuPlacement, menuPosition = _this$props12.menuPosition, menuPortalTarget = _this$props12.menuPortalTarget, menuShouldBlockScroll = _this$props12.menuShouldBlockScroll, menuShouldScrollIntoView = _this$props12.menuShouldScrollIntoView, noOptionsMessage = _this$props12.noOptionsMessage, onMenuScrollToTop = _this$props12.onMenuScrollToTop, onMenuScrollToBottom = _this$props12.onMenuScrollToBottom;
                if (!menuIsOpen) return null;
                // TODO: Internal Option Type here
                var render = function render(props, id) {
                    var type = props.type, data = props.data, isDisabled = props.isDisabled, isSelected = props.isSelected, label = props.label, value = props.value;
                    var isFocused = focusedOption === data;
                    var onHover = isDisabled ? undefined : function() {
                        return _this4.onOptionHover(data);
                    };
                    var onSelect = isDisabled ? undefined : function() {
                        return _this4.selectOption(data);
                    };
                    var optionId = "".concat(_this4.getElementId('option'), "-").concat(id);
                    var innerProps = {
                        id: optionId,
                        onClick: onSelect,
                        onMouseMove: onHover,
                        onMouseOver: onHover,
                        tabIndex: -1,
                        role: 'option',
                        'aria-selected': _this4.isAppleDevice ? undefined : isSelected // is not supported on Apple devices
                    };
                    return /*#__PURE__*/ $eUqFw.createElement(Option, (0, $kU09D.default)({}, commonProps, {
                        innerProps: innerProps,
                        data: data,
                        isDisabled: isDisabled,
                        isSelected: isSelected,
                        key: optionId,
                        label: label,
                        type: type,
                        value: value,
                        isFocused: isFocused,
                        innerRef: isFocused ? _this4.getFocusedOptionRef : undefined
                    }), _this4.formatOptionLabel(props.data, 'menu'));
                };
                var menuUI;
                if (this.hasOptions()) menuUI = this.getCategorizedOptions().map(function(item) {
                    if (item.type === 'group') {
                        var _data = item.data, options = item.options, groupIndex = item.index;
                        var groupId = "".concat(_this4.getElementId('group'), "-").concat(groupIndex);
                        var headingId = "".concat(groupId, "-heading");
                        return /*#__PURE__*/ $eUqFw.createElement(Group, (0, $kU09D.default)({}, commonProps, {
                            key: groupId,
                            data: _data,
                            options: options,
                            Heading: GroupHeading,
                            headingProps: {
                                id: headingId,
                                data: item.data
                            },
                            label: _this4.formatGroupLabel(item.data)
                        }), item.options.map(function(option) {
                            return render(option, "".concat(groupIndex, "-").concat(option.index));
                        }));
                    } else if (item.type === 'option') return render(item, "".concat(item.index));
                });
                else if (isLoading) {
                    var message = loadingMessage({
                        inputValue: inputValue
                    });
                    if (message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(LoadingMessage, commonProps, message);
                } else {
                    var _message = noOptionsMessage({
                        inputValue: inputValue
                    });
                    if (_message === null) return null;
                    menuUI = /*#__PURE__*/ $eUqFw.createElement(NoOptionsMessage, commonProps, _message);
                }
                var menuPlacementProps = {
                    minMenuHeight: minMenuHeight,
                    maxMenuHeight: maxMenuHeight,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition,
                    menuShouldScrollIntoView: menuShouldScrollIntoView
                };
                var menuElement = /*#__PURE__*/ $eUqFw.createElement((0, $6Wmpx.M), (0, $kU09D.default)({}, commonProps, menuPlacementProps), function(_ref4) {
                    var ref = _ref4.ref, _ref4$placerProps = _ref4.placerProps, placement = _ref4$placerProps.placement, maxHeight = _ref4$placerProps.maxHeight;
                    return /*#__PURE__*/ $eUqFw.createElement(Menu, (0, $kU09D.default)({}, commonProps, menuPlacementProps, {
                        innerRef: ref,
                        innerProps: {
                            onMouseDown: _this4.onMenuMouseDown,
                            onMouseMove: _this4.onMenuMouseMove
                        },
                        isLoading: isLoading,
                        placement: placement
                    }), /*#__PURE__*/ $eUqFw.createElement($d2818b570f093c78$var$ScrollManager, {
                        captureEnabled: captureMenuScroll,
                        onTopArrive: onMenuScrollToTop,
                        onBottomArrive: onMenuScrollToBottom,
                        lockEnabled: menuShouldBlockScroll
                    }, function(scrollTargetRef) {
                        return /*#__PURE__*/ $eUqFw.createElement(MenuList, (0, $kU09D.default)({}, commonProps, {
                            innerRef: function innerRef(instance) {
                                _this4.getMenuListRef(instance);
                                scrollTargetRef(instance);
                            },
                            innerProps: {
                                role: 'listbox',
                                'aria-multiselectable': commonProps.isMulti,
                                id: _this4.getElementId('listbox')
                            },
                            isLoading: isLoading,
                            maxHeight: maxHeight,
                            focusedOption: focusedOption
                        }), menuUI);
                    }));
                });
                // positioning behaviour is almost identical for portalled and fixed,
                // so we use the same component. the actual portalling logic is forked
                // within the component based on `menuPosition`
                return menuPortalTarget || menuPosition === 'fixed' ? /*#__PURE__*/ $eUqFw.createElement(MenuPortal, (0, $kU09D.default)({}, commonProps, {
                    appendTo: menuPortalTarget,
                    controlElement: this.controlRef,
                    menuPlacement: menuPlacement,
                    menuPosition: menuPosition
                }), menuElement) : menuElement;
            }
        },
        {
            key: "renderFormField",
            value: function renderFormField() {
                var _this5 = this;
                var _this$props13 = this.props, delimiter = _this$props13.delimiter, isDisabled = _this$props13.isDisabled, isMulti = _this$props13.isMulti, name = _this$props13.name, required = _this$props13.required;
                var selectValue = this.state.selectValue;
                if (required && !this.hasValue() && !isDisabled) return /*#__PURE__*/ $eUqFw.createElement($d2818b570f093c78$var$RequiredInput$1, {
                    name: name,
                    onFocus: this.onValueInputFocus
                });
                if (!name || isDisabled) return;
                if (isMulti) {
                    if (delimiter) {
                        var value = selectValue.map(function(opt) {
                            return _this5.getOptionValue(opt);
                        }).join(delimiter);
                        return /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: value
                        });
                    } else {
                        var input = selectValue.length > 0 ? selectValue.map(function(opt, i) {
                            return /*#__PURE__*/ $eUqFw.createElement("input", {
                                key: "i-".concat(i),
                                name: name,
                                type: "hidden",
                                value: _this5.getOptionValue(opt)
                            });
                        }) : /*#__PURE__*/ $eUqFw.createElement("input", {
                            name: name,
                            type: "hidden",
                            value: ""
                        });
                        return /*#__PURE__*/ $eUqFw.createElement("div", null, input);
                    }
                } else {
                    var _value = selectValue[0] ? this.getOptionValue(selectValue[0]) : '';
                    return /*#__PURE__*/ $eUqFw.createElement("input", {
                        name: name,
                        type: "hidden",
                        value: _value
                    });
                }
            }
        },
        {
            key: "renderLiveRegion",
            value: function renderLiveRegion() {
                var commonProps = this.commonProps;
                var _this$state6 = this.state, ariaSelection = _this$state6.ariaSelection, focusedOption = _this$state6.focusedOption, focusedValue = _this$state6.focusedValue, isFocused = _this$state6.isFocused, selectValue = _this$state6.selectValue;
                var focusableOptions = this.getFocusableOptions();
                return /*#__PURE__*/ $eUqFw.createElement($d2818b570f093c78$var$LiveRegion$1, (0, $kU09D.default)({}, commonProps, {
                    id: this.getElementId('live-region'),
                    ariaSelection: ariaSelection,
                    focusedOption: focusedOption,
                    focusedValue: focusedValue,
                    isFocused: isFocused,
                    selectValue: selectValue,
                    focusableOptions: focusableOptions,
                    isAppleDevice: this.isAppleDevice
                }));
            }
        },
        {
            key: "render",
            value: function render() {
                var _this$getComponents8 = this.getComponents(), Control = _this$getComponents8.Control, IndicatorsContainer = _this$getComponents8.IndicatorsContainer, SelectContainer = _this$getComponents8.SelectContainer, ValueContainer = _this$getComponents8.ValueContainer;
                var _this$props14 = this.props, className = _this$props14.className, id = _this$props14.id, isDisabled = _this$props14.isDisabled, menuIsOpen = _this$props14.menuIsOpen;
                var isFocused = this.state.isFocused;
                var commonProps = this.commonProps = this.getCommonProps();
                return /*#__PURE__*/ $eUqFw.createElement(SelectContainer, (0, $kU09D.default)({}, commonProps, {
                    className: className,
                    innerProps: {
                        id: id,
                        onKeyDown: this.onKeyDown
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused
                }), this.renderLiveRegion(), /*#__PURE__*/ $eUqFw.createElement(Control, (0, $kU09D.default)({}, commonProps, {
                    innerRef: this.getControlRef,
                    innerProps: {
                        onMouseDown: this.onControlMouseDown,
                        onTouchEnd: this.onControlTouchEnd
                    },
                    isDisabled: isDisabled,
                    isFocused: isFocused,
                    menuIsOpen: menuIsOpen
                }), /*#__PURE__*/ $eUqFw.createElement(ValueContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderPlaceholderOrValue(), this.renderInput()), /*#__PURE__*/ $eUqFw.createElement(IndicatorsContainer, (0, $kU09D.default)({}, commonProps, {
                    isDisabled: isDisabled
                }), this.renderClearIndicator(), this.renderLoadingIndicator(), this.renderIndicatorSeparator(), this.renderDropdownIndicator())), this.renderMenu(), this.renderFormField());
            }
        }
    ], [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                var prevProps = state.prevProps, clearFocusValueOnUpdate = state.clearFocusValueOnUpdate, inputIsHiddenAfterUpdate = state.inputIsHiddenAfterUpdate, ariaSelection = state.ariaSelection, isFocused = state.isFocused, prevWasFocused = state.prevWasFocused, instancePrefix = state.instancePrefix;
                var options = props.options, value = props.value, menuIsOpen = props.menuIsOpen, inputValue = props.inputValue, isMulti = props.isMulti;
                var selectValue = (0, $6Wmpx.H)(value);
                var newMenuOptionsState = {};
                if (prevProps && (value !== prevProps.value || options !== prevProps.options || menuIsOpen !== prevProps.menuIsOpen || inputValue !== prevProps.inputValue)) {
                    var focusableOptions = menuIsOpen ? $d2818b570f093c78$var$buildFocusableOptions(props, selectValue) : [];
                    var focusableOptionsWithIds = menuIsOpen ? $d2818b570f093c78$var$buildFocusableOptionsWithIds($d2818b570f093c78$var$buildCategorizedOptions(props, selectValue), "".concat(instancePrefix, "-option")) : [];
                    var focusedValue = clearFocusValueOnUpdate ? $d2818b570f093c78$var$getNextFocusedValue(state, selectValue) : null;
                    var focusedOption = $d2818b570f093c78$var$getNextFocusedOption(state, focusableOptions);
                    var focusedOptionId = $d2818b570f093c78$var$getFocusedOptionId(focusableOptionsWithIds, focusedOption);
                    newMenuOptionsState = {
                        selectValue: selectValue,
                        focusedOption: focusedOption,
                        focusedOptionId: focusedOptionId,
                        focusableOptionsWithIds: focusableOptionsWithIds,
                        focusedValue: focusedValue,
                        clearFocusValueOnUpdate: false
                    };
                }
                // some updates should toggle the state of the input visibility
                var newInputIsHiddenState = inputIsHiddenAfterUpdate != null && props !== prevProps ? {
                    inputIsHidden: inputIsHiddenAfterUpdate,
                    inputIsHiddenAfterUpdate: undefined
                } : {};
                var newAriaSelection = ariaSelection;
                var hasKeptFocus = isFocused && prevWasFocused;
                if (isFocused && !hasKeptFocus) {
                    // If `value` or `defaultValue` props are not empty then announce them
                    // when the Select is initially focused
                    newAriaSelection = {
                        value: (0, $6Wmpx.D)(isMulti, selectValue, selectValue[0] || null),
                        options: selectValue,
                        action: 'initial-input-focus'
                    };
                    hasKeptFocus = !prevWasFocused;
                }
                // If the 'initial-input-focus' action has been set already
                // then reset the ariaSelection to null
                if ((ariaSelection === null || ariaSelection === void 0 ? void 0 : ariaSelection.action) === 'initial-input-focus') newAriaSelection = null;
                return (0, $1Xn5q.default)((0, $1Xn5q.default)((0, $1Xn5q.default)({}, newMenuOptionsState), newInputIsHiddenState), {}, {
                    prevProps: props,
                    ariaSelection: newAriaSelection,
                    prevWasFocused: hasKeptFocus
                });
            }
        }
    ]);
    return Select;
}((0, $eUqFw.Component));
$d2818b570f093c78$export$25ce5a424b770e84.defaultProps = $d2818b570f093c78$export$407448d2b89b1813;

});
parcelRegister("lDSrn", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc177843783b087f$export$2e2bcd8739ae039);
function $fc177843783b087f$export$2e2bcd8739ae039(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("lIEGP", function(module, exports) {

$parcel$export(module.exports, "default", () => $fcfd452a83bb612a$export$2e2bcd8739ae039);

var $aM0Ke = parcelRequire("aM0Ke");
function $fcfd452a83bb612a$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (0, $aM0Ke.default)(o.key), o);
    }
}
function $fcfd452a83bb612a$export$2e2bcd8739ae039(e, r, t) {
    return r && $fcfd452a83bb612a$var$_defineProperties(e.prototype, r), t && $fcfd452a83bb612a$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}

});

parcelRegister("eT4IF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad69dceb97fc37d0$export$2e2bcd8739ae039);

var $c2pQl = parcelRequire("c2pQl");
function $ad69dceb97fc37d0$export$2e2bcd8739ae039(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && (0, $c2pQl.default)(t, e);
}

});

parcelRegister("7Dzgl", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f7875a71af82f1$export$2e2bcd8739ae039);

var $i3rTN = parcelRequire("i3rTN");

var $8c5pC = parcelRequire("8c5pC");

var $4mIeV = parcelRequire("4mIeV");
function $58f7875a71af82f1$export$2e2bcd8739ae039(t) {
    var r = (0, $8c5pC.default)();
    return function() {
        var e, o = (0, $i3rTN.default)(t);
        if (r) {
            var s = (0, $i3rTN.default)(this).constructor;
            e = Reflect.construct(o, arguments, s);
        } else e = o.apply(this, arguments);
        return (0, $4mIeV.default)(this, e);
    };
}

});
parcelRegister("i3rTN", function(module, exports) {

$parcel$export(module.exports, "default", () => $d24e25f7bdedc6a7$export$2e2bcd8739ae039);
function $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t) {
    return $d24e25f7bdedc6a7$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, $d24e25f7bdedc6a7$export$2e2bcd8739ae039(t);
}

});

parcelRegister("8c5pC", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f73a47aa7a9581c$export$2e2bcd8739ae039);
function $5f73a47aa7a9581c$export$2e2bcd8739ae039() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return ($5f73a47aa7a9581c$export$2e2bcd8739ae039 = function _isNativeReflectConstruct() {
        return !!t;
    })();
}

});

parcelRegister("4mIeV", function(module, exports) {

$parcel$export(module.exports, "default", () => $32db889076b63d40$export$2e2bcd8739ae039);

var $5sKOb = parcelRequire("5sKOb");

var $aCdHv = parcelRequire("aCdHv");
function $32db889076b63d40$export$2e2bcd8739ae039(t, e) {
    if (e && ("object" == (0, $5sKOb.default)(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return (0, $aCdHv.default)(t);
}

});


parcelRegister("fVK4C", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98feb1d5dd86921$export$2e2bcd8739ae039);

var $b7OIr = parcelRequire("b7OIr");

var $2B3l3 = parcelRequire("2B3l3");

var $e5SQy = parcelRequire("e5SQy");

var $csAMF = parcelRequire("csAMF");
function $b98feb1d5dd86921$export$2e2bcd8739ae039(r) {
    return (0, $b7OIr.default)(r) || (0, $2B3l3.default)(r) || (0, $e5SQy.default)(r) || (0, $csAMF.default)();
}

});
parcelRegister("b7OIr", function(module, exports) {

$parcel$export(module.exports, "default", () => $8197b040df4187a0$export$2e2bcd8739ae039);

var $aLrjs = parcelRequire("aLrjs");
function $8197b040df4187a0$export$2e2bcd8739ae039(r) {
    if (Array.isArray(r)) return (0, $aLrjs.default)(r);
}

});

parcelRegister("2B3l3", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e41a0710a3b4a62$export$2e2bcd8739ae039);
function $1e41a0710a3b4a62$export$2e2bcd8739ae039(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

});

parcelRegister("csAMF", function(module, exports) {

$parcel$export(module.exports, "default", () => $9124a21752235a23$export$2e2bcd8739ae039);
function $9124a21752235a23$export$2e2bcd8739ae039() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("6Wmpx", function(module, exports) {

$parcel$export(module.exports, "J", () => $50d98b340287446c$export$b4171a6734a65d42);
$parcel$export(module.exports, "E", () => $50d98b340287446c$export$a9c23c6ac3fc3eca);
$parcel$export(module.exports, "H", () => $50d98b340287446c$export$7f8ddf7c7c20b3cd);
$parcel$export(module.exports, "L", () => $50d98b340287446c$export$61196ced6d74a310);
$parcel$export(module.exports, "G", () => $50d98b340287446c$export$2329c99376c9d0a4);
$parcel$export(module.exports, "I", () => $50d98b340287446c$export$9bb611d729802a56);
$parcel$export(module.exports, "z", () => $50d98b340287446c$export$df995fae86a55f06);
$parcel$export(module.exports, "A", () => $50d98b340287446c$export$ebd11618f299a286);
$parcel$export(module.exports, "s", () => $50d98b340287446c$export$2408f22a0fab9ae5);
$parcel$export(module.exports, "K", () => $50d98b340287446c$export$3466f893ebf79586);
$parcel$export(module.exports, "D", () => $50d98b340287446c$export$96f57966bedc81b4);
$parcel$export(module.exports, "C", () => $50d98b340287446c$export$e7094788287c5e9b);
$parcel$export(module.exports, "B", () => $50d98b340287446c$export$ef35774e6d314e91);
$parcel$export(module.exports, "r", () => $50d98b340287446c$export$43caf9889c228507);
$parcel$export(module.exports, "m", () => $50d98b340287446c$export$953cecd6e717a553);
$parcel$export(module.exports, "M", () => $50d98b340287446c$export$3a1a48c8f6ef640e);
$parcel$export(module.exports, "n", () => $50d98b340287446c$export$7ccc53e8f1e7dfc5);
$parcel$export(module.exports, "u", () => $50d98b340287446c$export$3b14a55fb2447963);
$parcel$export(module.exports, "k", () => $50d98b340287446c$export$342063e11d6c3cad);
$parcel$export(module.exports, "o", () => $50d98b340287446c$export$ae1af26003f05816);
$parcel$export(module.exports, "b", () => $50d98b340287446c$export$8b22cf2602fb60ce);
$parcel$export(module.exports, "y", () => $50d98b340287446c$export$4a5767248b18ef41);
$parcel$export(module.exports, "i", () => $50d98b340287446c$export$23f2a1d2818174ef);
$parcel$export(module.exports, "e", () => $50d98b340287446c$export$f1e1789686576879);
$parcel$export(module.exports, "a", () => $50d98b340287446c$export$407448d2b89b1813);
$parcel$export(module.exports, "h", () => $50d98b340287446c$export$dda1d9f60106f0e9);
$parcel$export(module.exports, "l", () => $50d98b340287446c$export$882b5998b3b9117c);
$parcel$export(module.exports, "d", () => $50d98b340287446c$export$4368d992c4eafac0);
$parcel$export(module.exports, "g", () => $50d98b340287446c$export$39b482c5e57630a8);
$parcel$export(module.exports, "f", () => $50d98b340287446c$export$2d1720544b23b823);
$parcel$export(module.exports, "j", () => $50d98b340287446c$export$35e795649ee09318);
$parcel$export(module.exports, "p", () => $50d98b340287446c$export$ffb5f4729a158638);
$parcel$export(module.exports, "q", () => $50d98b340287446c$export$9e5f44173e64f162);
$parcel$export(module.exports, "t", () => $50d98b340287446c$export$625550452a3fa3ec);
$parcel$export(module.exports, "v", () => $50d98b340287446c$export$90a7f3efeed30595);
$parcel$export(module.exports, "w", () => $50d98b340287446c$export$efccba1c4a2ef57b);
$parcel$export(module.exports, "x", () => $50d98b340287446c$export$d141bba7fdc215a3);
$parcel$export(module.exports, "c", () => $50d98b340287446c$export$db3b6bfb95261072);
$parcel$export(module.exports, "F", () => $50d98b340287446c$export$d66501df72047452);

var $1Xn5q = parcelRequire("1Xn5q");

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $aKcqM = parcelRequire("aKcqM");

var $bwPfh = parcelRequire("bwPfh");

var $5sKOb = parcelRequire("5sKOb");

var $jqNEH = parcelRequire("jqNEH");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $lEfVV = parcelRequire("lEfVV");

var $5O3G9 = parcelRequire("5O3G9");

var $k286k = parcelRequire("k286k");
var $50d98b340287446c$var$_excluded$4 = [
    "className",
    "clearValue",
    "cx",
    "getStyles",
    "getClassNames",
    "getValue",
    "hasValue",
    "isMulti",
    "isRtl",
    "options",
    "selectOption",
    "selectProps",
    "setValue",
    "theme"
];
// ==============================
// NO OP
// ==============================
var $50d98b340287446c$export$b4171a6734a65d42 = function noop() {};
// ==============================
// Class Name Prefixer
// ==============================
/**
 String representation of component state for styling with class names.

 Expects an array of strings OR a string/object pair:
 - className(['comp', 'comp-arg', 'comp-arg-2'])
   @returns 'react-select__comp react-select__comp-arg react-select__comp-arg-2'
 - className('comp', { some: true, state: false })
   @returns 'react-select__comp react-select__comp--some'
*/ function $50d98b340287446c$var$applyPrefixToName(prefix, name) {
    if (!name) return prefix;
    else if (name[0] === '-') return prefix + name;
    else return prefix + '__' + name;
}
function $50d98b340287446c$export$a9c23c6ac3fc3eca(prefix, state) {
    for(var _len = arguments.length, classNameList = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)classNameList[_key - 2] = arguments[_key];
    var arr = [].concat(classNameList);
    if (state && prefix) {
        for(var key in state)if (state.hasOwnProperty(key) && state[key]) arr.push("".concat($50d98b340287446c$var$applyPrefixToName(prefix, key)));
    }
    return arr.filter(function(i) {
        return i;
    }).map(function(i) {
        return String(i).trim();
    }).join(' ');
}
// ==============================
// Clean Value
// ==============================
var $50d98b340287446c$export$7f8ddf7c7c20b3cd = function cleanValue(value) {
    if ($50d98b340287446c$var$isArray(value)) return value.filter(Boolean);
    if ((0, $5sKOb.default)(value) === 'object' && value !== null) return [
        value
    ];
    return [];
};
// ==============================
// Clean Common Props
// ==============================
var $50d98b340287446c$var$cleanCommonProps = function cleanCommonProps(props) {
    //className
    props.className;
    props.clearValue;
    props.cx;
    props.getStyles;
    props.getClassNames;
    props.getValue;
    props.hasValue;
    props.isMulti;
    props.isRtl;
    props.options;
    props.selectOption;
    props.selectProps;
    props.setValue;
    props.theme;
    var innerProps = (0, $bwPfh.default)(props, $50d98b340287446c$var$_excluded$4);
    return (0, $1Xn5q.default)({}, innerProps);
};
// ==============================
// Get Style Props
// ==============================
var $50d98b340287446c$var$getStyleProps = function getStyleProps(props, name, classNamesState) {
    var cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, className = props.className;
    return {
        css: getStyles(name, props),
        className: cx(classNamesState !== null && classNamesState !== void 0 ? classNamesState : {}, getClassNames(name, props), className)
    };
};
// ==============================
// Handle Input Change
// ==============================
function $50d98b340287446c$export$61196ced6d74a310(inputValue, actionMeta, onInputChange) {
    if (onInputChange) {
        var _newValue = onInputChange(inputValue, actionMeta);
        if (typeof _newValue === 'string') return _newValue;
    }
    return inputValue;
}
// ==============================
// Scroll Helpers
// ==============================
function $50d98b340287446c$export$2329c99376c9d0a4(el) {
    return [
        document.documentElement,
        document.body,
        window
    ].indexOf(el) > -1;
}
// Normalized Scroll Top
// ------------------------------
function $50d98b340287446c$var$normalizedHeight(el) {
    if ($50d98b340287446c$export$2329c99376c9d0a4(el)) return window.innerHeight;
    return el.clientHeight;
}
// Normalized scrollTo & scrollTop
// ------------------------------
function $50d98b340287446c$var$getScrollTop(el) {
    if ($50d98b340287446c$export$2329c99376c9d0a4(el)) return window.pageYOffset;
    return el.scrollTop;
}
function $50d98b340287446c$var$scrollTo(el, top) {
    // with a scroll distance, we perform scroll on the element
    if ($50d98b340287446c$export$2329c99376c9d0a4(el)) {
        window.scrollTo(0, top);
        return;
    }
    el.scrollTop = top;
}
// Get Scroll Parent
// ------------------------------
function $50d98b340287446c$var$getScrollParent(element) {
    var style = getComputedStyle(element);
    var excludeStaticParent = style.position === 'absolute';
    var overflowRx = /(auto|scroll)/;
    if (style.position === 'fixed') return document.documentElement;
    for(var parent = element; parent = parent.parentElement;){
        style = getComputedStyle(parent);
        if (excludeStaticParent && style.position === 'static') continue;
        if (overflowRx.test(style.overflow + style.overflowY + style.overflowX)) return parent;
    }
    return document.documentElement;
}
// Animated Scroll To
// ------------------------------
/**
  @param t: time (elapsed)
  @param b: initial value
  @param c: amount of change
  @param d: duration
*/ function $50d98b340287446c$var$easeOutCubic(t, b, c, d) {
    return c * ((t = t / d - 1) * t * t + 1) + b;
}
function $50d98b340287446c$var$animatedScrollTo(element, to) {
    var duration = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 200;
    var callback = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : $50d98b340287446c$export$b4171a6734a65d42;
    var start = $50d98b340287446c$var$getScrollTop(element);
    var change = to - start;
    var increment = 10;
    var currentTime = 0;
    function animateScroll() {
        currentTime += increment;
        var val = $50d98b340287446c$var$easeOutCubic(currentTime, start, change, duration);
        $50d98b340287446c$var$scrollTo(element, val);
        if (currentTime < duration) window.requestAnimationFrame(animateScroll);
        else callback(element);
    }
    animateScroll();
}
// Scroll Into View
// ------------------------------
function $50d98b340287446c$export$9bb611d729802a56(menuEl, focusedEl) {
    var menuRect = menuEl.getBoundingClientRect();
    var focusedRect = focusedEl.getBoundingClientRect();
    var overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom) $50d98b340287446c$var$scrollTo(menuEl, Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + overScroll, menuEl.scrollHeight));
    else if (focusedRect.top - overScroll < menuRect.top) $50d98b340287446c$var$scrollTo(menuEl, Math.max(focusedEl.offsetTop - overScroll, 0));
}
// ==============================
// Get bounding client object
// ==============================
// cannot get keys using array notation with DOMRect
function $50d98b340287446c$var$getBoundingClientObj(element) {
    var rect = element.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width
    };
}
// ==============================
// Touch Capability Detector
// ==============================
function $50d98b340287446c$export$df995fae86a55f06() {
    try {
        document.createEvent('TouchEvent');
        return true;
    } catch (e) {
        return false;
    }
}
// ==============================
// Mobile Device Detector
// ==============================
function $50d98b340287446c$export$ebd11618f299a286() {
    try {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    } catch (e) {
        return false;
    }
}
// ==============================
// Passive Event Detector
// ==============================
// https://github.com/rafgraph/detect-it/blob/main/src/index.ts#L19-L36
var $50d98b340287446c$var$passiveOptionAccessed = false;
var $50d98b340287446c$var$options = {
    get passive () {
        return $50d98b340287446c$var$passiveOptionAccessed = true;
    }
};
// check for SSR
var $50d98b340287446c$var$w = typeof window !== 'undefined' ? window : {};
if ($50d98b340287446c$var$w.addEventListener && $50d98b340287446c$var$w.removeEventListener) {
    $50d98b340287446c$var$w.addEventListener('p', $50d98b340287446c$export$b4171a6734a65d42, $50d98b340287446c$var$options);
    $50d98b340287446c$var$w.removeEventListener('p', $50d98b340287446c$export$b4171a6734a65d42, false);
}
var $50d98b340287446c$export$2408f22a0fab9ae5 = $50d98b340287446c$var$passiveOptionAccessed;
function $50d98b340287446c$export$3466f893ebf79586(item) {
    return item != null;
}
function $50d98b340287446c$var$isArray(arg) {
    return Array.isArray(arg);
}
function $50d98b340287446c$export$96f57966bedc81b4(isMulti, multiValue, singleValue) {
    return isMulti ? multiValue : singleValue;
}
function $50d98b340287446c$export$e7094788287c5e9b(singleValue) {
    return singleValue;
}
function $50d98b340287446c$export$ef35774e6d314e91(multiValue) {
    return multiValue;
}
var $50d98b340287446c$export$43caf9889c228507 = function removeProps(propsObj) {
    for(var _len2 = arguments.length, properties = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)properties[_key2 - 1] = arguments[_key2];
    var propsMap = Object.entries(propsObj).filter(function(_ref) {
        var _ref2 = (0, $aKcqM.default)(_ref, 1), key = _ref2[0];
        return !properties.includes(key);
    });
    return propsMap.reduce(function(newProps, _ref3) {
        var _ref4 = (0, $aKcqM.default)(_ref3, 2), key = _ref4[0], val = _ref4[1];
        newProps[key] = val;
        return newProps;
    }, {});
};
var $50d98b340287446c$var$_excluded$3 = [
    "children",
    "innerProps"
], $50d98b340287446c$var$_excluded2$1 = [
    "children",
    "innerProps"
];
function $50d98b340287446c$var$getMenuPlacement(_ref) {
    var preferredMaxHeight = _ref.maxHeight, menuEl = _ref.menuEl, minHeight = _ref.minHeight, preferredPlacement = _ref.placement, shouldScroll = _ref.shouldScroll, isFixedPosition = _ref.isFixedPosition, controlHeight = _ref.controlHeight;
    var scrollParent = $50d98b340287446c$var$getScrollParent(menuEl);
    var defaultState = {
        placement: 'bottom',
        maxHeight: preferredMaxHeight
    };
    // something went wrong, return default state
    if (!menuEl || !menuEl.offsetParent) return defaultState;
    // we can't trust `scrollParent.scrollHeight` --> it may increase when
    // the menu is rendered
    var _scrollParent$getBoun = scrollParent.getBoundingClientRect(), scrollHeight = _scrollParent$getBoun.height;
    var _menuEl$getBoundingCl = menuEl.getBoundingClientRect(), menuBottom = _menuEl$getBoundingCl.bottom, menuHeight = _menuEl$getBoundingCl.height, menuTop = _menuEl$getBoundingCl.top;
    var _menuEl$offsetParent$ = menuEl.offsetParent.getBoundingClientRect(), containerTop = _menuEl$offsetParent$.top;
    var viewHeight = isFixedPosition ? window.innerHeight : $50d98b340287446c$var$normalizedHeight(scrollParent);
    var scrollTop = $50d98b340287446c$var$getScrollTop(scrollParent);
    var marginBottom = parseInt(getComputedStyle(menuEl).marginBottom, 10);
    var marginTop = parseInt(getComputedStyle(menuEl).marginTop, 10);
    var viewSpaceAbove = containerTop - marginTop;
    var viewSpaceBelow = viewHeight - menuTop;
    var scrollSpaceAbove = viewSpaceAbove + scrollTop;
    var scrollSpaceBelow = scrollHeight - scrollTop - menuTop;
    var scrollDown = menuBottom - viewHeight + scrollTop + marginBottom;
    var scrollUp = scrollTop + menuTop - marginTop;
    var scrollDuration = 160;
    switch(preferredPlacement){
        case 'auto':
        case 'bottom':
            // 1: the menu will fit, do nothing
            if (viewSpaceBelow >= menuHeight) return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceBelow >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $50d98b340287446c$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceBelow >= minHeight || isFixedPosition && viewSpaceBelow >= minHeight) {
                if (shouldScroll) $50d98b340287446c$var$animatedScrollTo(scrollParent, scrollDown, scrollDuration);
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                var constrainedHeight = isFixedPosition ? viewSpaceBelow - marginBottom : scrollSpaceBelow - marginBottom;
                return {
                    placement: 'bottom',
                    maxHeight: constrainedHeight
                };
            }
            // 4. Forked beviour when there isn't enough space below
            // AUTO: flip the menu, render above
            if (preferredPlacement === 'auto' || isFixedPosition) {
                // may need to be constrained after flipping
                var _constrainedHeight = preferredMaxHeight;
                var spaceAbove = isFixedPosition ? viewSpaceAbove : scrollSpaceAbove;
                if (spaceAbove >= minHeight) _constrainedHeight = Math.min(spaceAbove - marginBottom - controlHeight, preferredMaxHeight);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight
                };
            }
            // BOTTOM: allow browser to increase scrollable area and immediately set scroll
            if (preferredPlacement === 'bottom') {
                if (shouldScroll) $50d98b340287446c$var$scrollTo(scrollParent, scrollDown);
                return {
                    placement: 'bottom',
                    maxHeight: preferredMaxHeight
                };
            }
            break;
        case 'top':
            // 1: the menu will fit, do nothing
            if (viewSpaceAbove >= menuHeight) return {
                placement: 'top',
                maxHeight: preferredMaxHeight
            };
            // 2: the menu will fit, if scrolled
            if (scrollSpaceAbove >= menuHeight && !isFixedPosition) {
                if (shouldScroll) $50d98b340287446c$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: preferredMaxHeight
                };
            }
            // 3: the menu will fit, if constrained
            if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) {
                var _constrainedHeight2 = preferredMaxHeight;
                // we want to provide as much of the menu as possible to the user,
                // so give them whatever is available below rather than the minHeight.
                if (!isFixedPosition && scrollSpaceAbove >= minHeight || isFixedPosition && viewSpaceAbove >= minHeight) _constrainedHeight2 = isFixedPosition ? viewSpaceAbove - marginTop : scrollSpaceAbove - marginTop;
                if (shouldScroll) $50d98b340287446c$var$animatedScrollTo(scrollParent, scrollUp, scrollDuration);
                return {
                    placement: 'top',
                    maxHeight: _constrainedHeight2
                };
            }
            // 4. not enough space, the browser WILL NOT increase scrollable area when
            // absolutely positioned element rendered above the viewport (only below).
            // Flip the menu, render below
            return {
                placement: 'bottom',
                maxHeight: preferredMaxHeight
            };
        default:
            throw new Error("Invalid placement provided \"".concat(preferredPlacement, "\"."));
    }
    return defaultState;
}
// Menu Component
// ------------------------------
function $50d98b340287446c$var$alignToControl(placement) {
    var placementToCSSProp = {
        bottom: 'top',
        top: 'bottom'
    };
    return placement ? placementToCSSProp[placement] : 'bottom';
}
var $50d98b340287446c$var$coercePlacement = function coercePlacement(p) {
    return p === 'auto' ? 'bottom' : p;
};
var $50d98b340287446c$export$953cecd6e717a553 = function menuCSS(_ref2, unstyled) {
    var _objectSpread2;
    var placement = _ref2.placement, _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, spacing = _ref2$theme.spacing, colors = _ref2$theme.colors;
    return (0, $1Xn5q.default)((_objectSpread2 = {
        label: 'menu'
    }, (0, $5zQU9.default)(_objectSpread2, $50d98b340287446c$var$alignToControl(placement), '100%'), (0, $5zQU9.default)(_objectSpread2, "position", 'absolute'), (0, $5zQU9.default)(_objectSpread2, "width", '100%'), (0, $5zQU9.default)(_objectSpread2, "zIndex", 1), _objectSpread2), unstyled ? {} : {
        backgroundColor: colors.neutral0,
        borderRadius: borderRadius,
        boxShadow: '0 0 0 1px hsla(0, 0%, 0%, 0.1), 0 4px 11px hsla(0, 0%, 0%, 0.1)',
        marginBottom: spacing.menuGutter,
        marginTop: spacing.menuGutter
    });
};
var $50d98b340287446c$var$PortalPlacementContext = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
// NOTE: internal only
var $50d98b340287446c$export$3a1a48c8f6ef640e = function MenuPlacer(props) {
    var children = props.children, minMenuHeight = props.minMenuHeight, maxMenuHeight = props.maxMenuHeight, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition, menuShouldScrollIntoView = props.menuShouldScrollIntoView, theme = props.theme;
    var _ref3 = (0, $eUqFw.useContext)($50d98b340287446c$var$PortalPlacementContext) || {}, setPortalPlacement = _ref3.setPortalPlacement;
    var ref = (0, $eUqFw.useRef)(null);
    var _useState = (0, $eUqFw.useState)(maxMenuHeight), _useState2 = (0, $aKcqM.default)(_useState, 2), maxHeight = _useState2[0], setMaxHeight = _useState2[1];
    var _useState3 = (0, $eUqFw.useState)(null), _useState4 = (0, $aKcqM.default)(_useState3, 2), placement = _useState4[0], setPlacement = _useState4[1];
    var controlHeight = theme.spacing.controlHeight;
    (0, $k286k.default)(function() {
        var menuEl = ref.current;
        if (!menuEl) return;
        // DO NOT scroll if position is fixed
        var isFixedPosition = menuPosition === 'fixed';
        var shouldScroll = menuShouldScrollIntoView && !isFixedPosition;
        var state = $50d98b340287446c$var$getMenuPlacement({
            maxHeight: maxMenuHeight,
            menuEl: menuEl,
            minHeight: minMenuHeight,
            placement: menuPlacement,
            shouldScroll: shouldScroll,
            isFixedPosition: isFixedPosition,
            controlHeight: controlHeight
        });
        setMaxHeight(state.maxHeight);
        setPlacement(state.placement);
        setPortalPlacement === null || setPortalPlacement === void 0 || setPortalPlacement(state.placement);
    }, [
        maxMenuHeight,
        menuPlacement,
        menuPosition,
        menuShouldScrollIntoView,
        minMenuHeight,
        setPortalPlacement,
        controlHeight
    ]);
    return children({
        ref: ref,
        placerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
            placement: placement || $50d98b340287446c$var$coercePlacement(menuPlacement),
            maxHeight: maxHeight
        })
    });
};
var $50d98b340287446c$var$Menu = function Menu(props) {
    var children = props.children, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps(props, 'menu', {
        menu: true
    }), {
        ref: innerRef
    }, innerProps), children);
};
var $50d98b340287446c$var$Menu$1 = $50d98b340287446c$var$Menu;
// ==============================
// Menu List
// ==============================
var $50d98b340287446c$export$7ccc53e8f1e7dfc5 = function menuListCSS(_ref4, unstyled) {
    var maxHeight = _ref4.maxHeight, baseUnit = _ref4.theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        maxHeight: maxHeight,
        overflowY: 'auto',
        position: 'relative',
        // required for offset[Height, Top] > keyboard scroll
        WebkitOverflowScrolling: 'touch'
    }, unstyled ? {} : {
        paddingBottom: baseUnit,
        paddingTop: baseUnit
    });
};
var $50d98b340287446c$var$MenuList = function MenuList(props) {
    var children = props.children, innerProps = props.innerProps, innerRef = props.innerRef, isMulti = props.isMulti;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps(props, 'menuList', {
        'menu-list': true,
        'menu-list--is-multi': isMulti
    }), {
        ref: innerRef
    }, innerProps), children);
};
// ==============================
// Menu Notices
// ==============================
var $50d98b340287446c$var$noticeCSS = function noticeCSS(_ref5, unstyled) {
    var _ref5$theme = _ref5.theme, baseUnit = _ref5$theme.spacing.baseUnit, colors = _ref5$theme.colors;
    return (0, $1Xn5q.default)({
        textAlign: 'center'
    }, unstyled ? {} : {
        color: colors.neutral40,
        padding: "".concat(baseUnit * 2, "px ").concat(baseUnit * 3, "px")
    });
};
var $50d98b340287446c$export$3b14a55fb2447963 = $50d98b340287446c$var$noticeCSS;
var $50d98b340287446c$export$342063e11d6c3cad = $50d98b340287446c$var$noticeCSS;
var $50d98b340287446c$var$NoOptionsMessage = function NoOptionsMessage(_ref6) {
    var _ref6$children = _ref6.children, children = _ref6$children === void 0 ? 'No options' : _ref6$children, innerProps = _ref6.innerProps, restProps = (0, $bwPfh.default)(_ref6, $50d98b340287446c$var$_excluded$3);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'noOptionsMessage', {
        'menu-notice': true,
        'menu-notice--no-options': true
    }), innerProps), children);
};
var $50d98b340287446c$var$LoadingMessage = function LoadingMessage(_ref7) {
    var _ref7$children = _ref7.children, children = _ref7$children === void 0 ? 'Loading...' : _ref7$children, innerProps = _ref7.innerProps, restProps = (0, $bwPfh.default)(_ref7, $50d98b340287446c$var$_excluded2$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, restProps), {}, {
        children: children,
        innerProps: innerProps
    }), 'loadingMessage', {
        'menu-notice': true,
        'menu-notice--loading': true
    }), innerProps), children);
};
// ==============================
// Menu Portal
// ==============================
var $50d98b340287446c$export$ae1af26003f05816 = function menuPortalCSS(_ref8) {
    var rect = _ref8.rect, offset = _ref8.offset, position = _ref8.position;
    return {
        left: rect.left,
        position: position,
        top: offset,
        width: rect.width,
        zIndex: 1
    };
};
var $50d98b340287446c$var$MenuPortal = function MenuPortal(props) {
    var appendTo = props.appendTo, children = props.children, controlElement = props.controlElement, innerProps = props.innerProps, menuPlacement = props.menuPlacement, menuPosition = props.menuPosition;
    var menuPortalRef = (0, $eUqFw.useRef)(null);
    var cleanupRef = (0, $eUqFw.useRef)(null);
    var _useState5 = (0, $eUqFw.useState)($50d98b340287446c$var$coercePlacement(menuPlacement)), _useState6 = (0, $aKcqM.default)(_useState5, 2), placement = _useState6[0], setPortalPlacement = _useState6[1];
    var portalPlacementContext = (0, $eUqFw.useMemo)(function() {
        return {
            setPortalPlacement: setPortalPlacement
        };
    }, []);
    var _useState7 = (0, $eUqFw.useState)(null), _useState8 = (0, $aKcqM.default)(_useState7, 2), computedPosition = _useState8[0], setComputedPosition = _useState8[1];
    var updateComputedPosition = (0, $eUqFw.useCallback)(function() {
        if (!controlElement) return;
        var rect = $50d98b340287446c$var$getBoundingClientObj(controlElement);
        var scrollDistance = menuPosition === 'fixed' ? 0 : window.pageYOffset;
        var offset = rect[placement] + scrollDistance;
        if (offset !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset) || rect.left !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left) || rect.width !== (computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width)) setComputedPosition({
            offset: offset,
            rect: rect
        });
    }, [
        controlElement,
        menuPosition,
        placement,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.offset,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.left,
        computedPosition === null || computedPosition === void 0 ? void 0 : computedPosition.rect.width
    ]);
    (0, $k286k.default)(function() {
        updateComputedPosition();
    }, [
        updateComputedPosition
    ]);
    var runAutoUpdate = (0, $eUqFw.useCallback)(function() {
        if (typeof cleanupRef.current === 'function') {
            cleanupRef.current();
            cleanupRef.current = null;
        }
        if (controlElement && menuPortalRef.current) cleanupRef.current = (0, $5O3G9.autoUpdate)(controlElement, menuPortalRef.current, updateComputedPosition, {
            elementResize: 'ResizeObserver' in window
        });
    }, [
        controlElement,
        updateComputedPosition
    ]);
    (0, $k286k.default)(function() {
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    var setMenuPortalElement = (0, $eUqFw.useCallback)(function(menuPortalElement) {
        menuPortalRef.current = menuPortalElement;
        runAutoUpdate();
    }, [
        runAutoUpdate
    ]);
    // bail early if required elements aren't present
    if (!appendTo && menuPosition !== 'fixed' || !computedPosition) return null;
    // same wrapper element whether fixed or portalled
    var menuWrapper = (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: setMenuPortalElement
    }, $50d98b340287446c$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, props), {}, {
        offset: computedPosition.offset,
        position: menuPosition,
        rect: computedPosition.rect
    }), 'menuPortal', {
        'menu-portal': true
    }), innerProps), children);
    return (0, $byn9U.jsx)($50d98b340287446c$var$PortalPlacementContext.Provider, {
        value: portalPlacementContext
    }, appendTo ? /*#__PURE__*/ (0, $lEfVV.createPortal)(menuWrapper, appendTo) : menuWrapper);
};
// ==============================
// Root Container
// ==============================
var $50d98b340287446c$export$8b22cf2602fb60ce = function containerCSS(_ref) {
    var isDisabled = _ref.isDisabled, isRtl = _ref.isRtl;
    return {
        label: 'container',
        direction: isRtl ? 'rtl' : undefined,
        pointerEvents: isDisabled ? 'none' : undefined,
        // cancel mouse events when disabled
        position: 'relative'
    };
};
var $50d98b340287446c$var$SelectContainer = function SelectContainer(props) {
    var children = props.children, innerProps = props.innerProps, isDisabled = props.isDisabled, isRtl = props.isRtl;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps(props, 'container', {
        '--is-disabled': isDisabled,
        '--is-rtl': isRtl
    }), innerProps), children);
};
// ==============================
// Value Container
// ==============================
var $50d98b340287446c$export$4a5767248b18ef41 = function valueContainerCSS(_ref2, unstyled) {
    var spacing = _ref2.theme.spacing, isMulti = _ref2.isMulti, hasValue = _ref2.hasValue, controlShouldRenderValue = _ref2.selectProps.controlShouldRenderValue;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: isMulti && hasValue && controlShouldRenderValue ? 'flex' : 'grid',
        flex: 1,
        flexWrap: 'wrap',
        WebkitOverflowScrolling: 'touch',
        position: 'relative',
        overflow: 'hidden'
    }, unstyled ? {} : {
        padding: "".concat(spacing.baseUnit / 2, "px ").concat(spacing.baseUnit * 2, "px")
    });
};
var $50d98b340287446c$var$ValueContainer = function ValueContainer(props) {
    var children = props.children, innerProps = props.innerProps, isMulti = props.isMulti, hasValue = props.hasValue;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps(props, 'valueContainer', {
        'value-container': true,
        'value-container--is-multi': isMulti,
        'value-container--has-value': hasValue
    }), innerProps), children);
};
// ==============================
// Indicator Container
// ==============================
var $50d98b340287446c$export$23f2a1d2818174ef = function indicatorsContainerCSS() {
    return {
        alignItems: 'center',
        alignSelf: 'stretch',
        display: 'flex',
        flexShrink: 0
    };
};
var $50d98b340287446c$var$IndicatorsContainer = function IndicatorsContainer(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps(props, 'indicatorsContainer', {
        indicators: true
    }), innerProps), children);
};
var $50d98b340287446c$var$_templateObject;
var $50d98b340287446c$var$_excluded$2 = [
    "size"
], $50d98b340287446c$var$_excluded2 = [
    "innerProps",
    "isRtl",
    "size"
];
function $50d98b340287446c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
// ==============================
// Dropdown & Clear Icons
// ==============================
var $50d98b340287446c$var$_ref2 = {
    name: "8mmkcg",
    styles: "display:inline-block;fill:currentColor;line-height:1;stroke:currentColor;stroke-width:0"
};
var $50d98b340287446c$var$Svg = function Svg(_ref) {
    var size = _ref.size, props = (0, $bwPfh.default)(_ref, $50d98b340287446c$var$_excluded$2);
    return (0, $byn9U.jsx)("svg", (0, $kU09D.default)({
        height: size,
        width: size,
        viewBox: "0 0 20 20",
        "aria-hidden": "true",
        focusable: "false",
        css: $50d98b340287446c$var$_ref2
    }, props));
};
var $50d98b340287446c$var$CrossIcon = function CrossIcon(props) {
    return (0, $byn9U.jsx)($50d98b340287446c$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M14.348 14.849c-0.469 0.469-1.229 0.469-1.697 0l-2.651-3.030-2.651 3.029c-0.469 0.469-1.229 0.469-1.697 0-0.469-0.469-0.469-1.229 0-1.697l2.758-3.15-2.759-3.152c-0.469-0.469-0.469-1.228 0-1.697s1.228-0.469 1.697 0l2.652 3.031 2.651-3.031c0.469-0.469 1.228-0.469 1.697 0s0.469 1.229 0 1.697l-2.758 3.152 2.758 3.15c0.469 0.469 0.469 1.229 0 1.698z"
    }));
};
var $50d98b340287446c$var$DownChevron = function DownChevron(props) {
    return (0, $byn9U.jsx)($50d98b340287446c$var$Svg, (0, $kU09D.default)({
        size: 20
    }, props), (0, $byn9U.jsx)("path", {
        d: "M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z"
    }));
};
// ==============================
// Dropdown & Clear Buttons
// ==============================
var $50d98b340287446c$var$baseCSS = function baseCSS(_ref3, unstyled) {
    var isFocused = _ref3.isFocused, _ref3$theme = _ref3.theme, baseUnit = _ref3$theme.spacing.baseUnit, colors = _ref3$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorContainer',
        display: 'flex',
        transition: 'color 150ms'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2,
        ':hover': {
            color: isFocused ? colors.neutral80 : colors.neutral40
        }
    });
};
var $50d98b340287446c$export$f1e1789686576879 = $50d98b340287446c$var$baseCSS;
var $50d98b340287446c$var$DropdownIndicator = function DropdownIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps(props, 'dropdownIndicator', {
        indicator: true,
        'dropdown-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($50d98b340287446c$var$DownChevron, null));
};
var $50d98b340287446c$export$407448d2b89b1813 = $50d98b340287446c$var$baseCSS;
var $50d98b340287446c$var$ClearIndicator = function ClearIndicator(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps(props, 'clearIndicator', {
        indicator: true,
        'clear-indicator': true
    }), innerProps), children || (0, $byn9U.jsx)($50d98b340287446c$var$CrossIcon, null));
};
// ==============================
// Separator
// ==============================
var $50d98b340287446c$export$dda1d9f60106f0e9 = function indicatorSeparatorCSS(_ref4, unstyled) {
    var isDisabled = _ref4.isDisabled, _ref4$theme = _ref4.theme, baseUnit = _ref4$theme.spacing.baseUnit, colors = _ref4$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'indicatorSeparator',
        alignSelf: 'stretch',
        width: 1
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral10 : colors.neutral20,
        marginBottom: baseUnit * 2,
        marginTop: baseUnit * 2
    });
};
var $50d98b340287446c$var$IndicatorSeparator = function IndicatorSeparator(props) {
    var innerProps = props.innerProps;
    return (0, $byn9U.jsx)("span", (0, $kU09D.default)({}, innerProps, $50d98b340287446c$var$getStyleProps(props, 'indicatorSeparator', {
        'indicator-separator': true
    })));
};
// ==============================
// Loading
// ==============================
var $50d98b340287446c$var$loadingDotAnimations = (0, $byn9U.keyframes)($50d98b340287446c$var$_templateObject || ($50d98b340287446c$var$_templateObject = (0, $jqNEH.default)([
    "\n  0%, 80%, 100% { opacity: 0; }\n  40% { opacity: 1; }\n"
])));
var $50d98b340287446c$export$882b5998b3b9117c = function loadingIndicatorCSS(_ref5, unstyled) {
    var isFocused = _ref5.isFocused, size = _ref5.size, _ref5$theme = _ref5.theme, colors = _ref5$theme.colors, baseUnit = _ref5$theme.spacing.baseUnit;
    return (0, $1Xn5q.default)({
        label: 'loadingIndicator',
        display: 'flex',
        transition: 'color 150ms',
        alignSelf: 'center',
        fontSize: size,
        lineHeight: 1,
        marginRight: size,
        textAlign: 'center',
        verticalAlign: 'middle'
    }, unstyled ? {} : {
        color: isFocused ? colors.neutral60 : colors.neutral20,
        padding: baseUnit * 2
    });
};
var $50d98b340287446c$var$LoadingDot = function LoadingDot(_ref6) {
    var delay = _ref6.delay, offset = _ref6.offset;
    return (0, $byn9U.jsx)("span", {
        css: /*#__PURE__*/ (0, $byn9U.css)({
            animation: "".concat($50d98b340287446c$var$loadingDotAnimations, " 1s ease-in-out ").concat(delay, "ms infinite;"),
            backgroundColor: 'currentColor',
            borderRadius: '1em',
            display: 'inline-block',
            marginLeft: offset ? '1em' : undefined,
            height: '1em',
            verticalAlign: 'top',
            width: '1em'
        }, "", "")
    });
};
var $50d98b340287446c$var$LoadingIndicator = function LoadingIndicator(_ref7) {
    var innerProps = _ref7.innerProps, isRtl = _ref7.isRtl, _ref7$size = _ref7.size, size = _ref7$size === void 0 ? 4 : _ref7$size, restProps = (0, $bwPfh.default)(_ref7, $50d98b340287446c$var$_excluded2);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps((0, $1Xn5q.default)((0, $1Xn5q.default)({}, restProps), {}, {
        innerProps: innerProps,
        isRtl: isRtl,
        size: size
    }), 'loadingIndicator', {
        indicator: true,
        'loading-indicator': true
    }), innerProps), (0, $byn9U.jsx)($50d98b340287446c$var$LoadingDot, {
        delay: 0,
        offset: isRtl
    }), (0, $byn9U.jsx)($50d98b340287446c$var$LoadingDot, {
        delay: 160,
        offset: true
    }), (0, $byn9U.jsx)($50d98b340287446c$var$LoadingDot, {
        delay: 320,
        offset: !isRtl
    }));
};
var $50d98b340287446c$export$4368d992c4eafac0 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, _ref$theme = _ref.theme, colors = _ref$theme.colors, borderRadius = _ref$theme.borderRadius, spacing = _ref$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'control',
        alignItems: 'center',
        cursor: 'default',
        display: 'flex',
        flexWrap: 'wrap',
        justifyContent: 'space-between',
        minHeight: spacing.controlHeight,
        outline: '0 !important',
        position: 'relative',
        transition: 'all 100ms'
    }, unstyled ? {} : {
        backgroundColor: isDisabled ? colors.neutral5 : colors.neutral0,
        borderColor: isDisabled ? colors.neutral10 : isFocused ? colors.primary : colors.neutral20,
        borderRadius: borderRadius,
        borderStyle: 'solid',
        borderWidth: 1,
        boxShadow: isFocused ? "0 0 0 1px ".concat(colors.primary) : undefined,
        '&:hover': {
            borderColor: isFocused ? colors.primary : colors.neutral30
        }
    });
};
var $50d98b340287446c$var$Control = function Control(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, innerRef = props.innerRef, innerProps = props.innerProps, menuIsOpen = props.menuIsOpen;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        ref: innerRef
    }, $50d98b340287446c$var$getStyleProps(props, 'control', {
        control: true,
        'control--is-disabled': isDisabled,
        'control--is-focused': isFocused,
        'control--menu-is-open': menuIsOpen
    }), innerProps, {
        "aria-disabled": isDisabled || undefined
    }), children);
};
var $50d98b340287446c$var$Control$1 = $50d98b340287446c$var$Control;
var $50d98b340287446c$var$_excluded$1 = [
    "data"
];
var $50d98b340287446c$export$39b482c5e57630a8 = function groupCSS(_ref, unstyled) {
    var spacing = _ref.theme.spacing;
    return unstyled ? {} : {
        paddingBottom: spacing.baseUnit * 2,
        paddingTop: spacing.baseUnit * 2
    };
};
var $50d98b340287446c$var$Group = function Group(props) {
    var children = props.children, cx = props.cx, getStyles = props.getStyles, getClassNames = props.getClassNames, Heading = props.Heading, headingProps = props.headingProps, innerProps = props.innerProps, label = props.label, theme = props.theme, selectProps = props.selectProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps(props, 'group', {
        group: true
    }), innerProps), (0, $byn9U.jsx)(Heading, (0, $kU09D.default)({}, headingProps, {
        selectProps: selectProps,
        theme: theme,
        getStyles: getStyles,
        getClassNames: getClassNames,
        cx: cx
    }), label), (0, $byn9U.jsx)("div", null, children));
};
var $50d98b340287446c$export$2d1720544b23b823 = function groupHeadingCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, colors = _ref2$theme.colors, spacing = _ref2$theme.spacing;
    return (0, $1Xn5q.default)({
        label: 'group',
        cursor: 'default',
        display: 'block'
    }, unstyled ? {} : {
        color: colors.neutral40,
        fontSize: '75%',
        fontWeight: 500,
        marginBottom: '0.25em',
        paddingLeft: spacing.baseUnit * 3,
        paddingRight: spacing.baseUnit * 3,
        textTransform: 'uppercase'
    });
};
var $50d98b340287446c$var$GroupHeading = function GroupHeading(props) {
    var _cleanCommonProps = $50d98b340287446c$var$cleanCommonProps(props);
    _cleanCommonProps.data;
    var innerProps = (0, $bwPfh.default)(_cleanCommonProps, $50d98b340287446c$var$_excluded$1);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps(props, 'groupHeading', {
        'group-heading': true
    }), innerProps));
};
var $50d98b340287446c$var$Group$1 = $50d98b340287446c$var$Group;
var $50d98b340287446c$var$_excluded = [
    "innerRef",
    "isDisabled",
    "isHidden",
    "inputClassName"
];
var $50d98b340287446c$export$35e795649ee09318 = function inputCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, value = _ref.value, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({
        visibility: isDisabled ? 'hidden' : 'visible',
        // force css to recompute when value change due to @emotion bug.
        // We can remove it whenever the bug is fixed.
        transform: value ? 'translateZ(0)' : ''
    }, $50d98b340287446c$var$containerStyle), unstyled ? {} : {
        margin: spacing.baseUnit / 2,
        paddingBottom: spacing.baseUnit / 2,
        paddingTop: spacing.baseUnit / 2,
        color: colors.neutral80
    });
};
var $50d98b340287446c$var$spacingStyle = {
    gridArea: '1 / 2',
    font: 'inherit',
    minWidth: '2px',
    border: 0,
    margin: 0,
    outline: 0,
    padding: 0
};
var $50d98b340287446c$var$containerStyle = {
    flex: '1 1 auto',
    display: 'inline-grid',
    gridArea: '1 / 1 / 2 / 3',
    gridTemplateColumns: '0 min-content',
    '&:after': (0, $1Xn5q.default)({
        content: 'attr(data-value) " "',
        visibility: 'hidden',
        whiteSpace: 'pre'
    }, $50d98b340287446c$var$spacingStyle)
};
var $50d98b340287446c$var$inputStyle = function inputStyle(isHidden) {
    return (0, $1Xn5q.default)({
        label: 'input',
        color: 'inherit',
        background: 0,
        opacity: isHidden ? 0 : 1,
        width: '100%'
    }, $50d98b340287446c$var$spacingStyle);
};
var $50d98b340287446c$var$Input = function Input(props) {
    var cx = props.cx, value = props.value;
    var _cleanCommonProps = $50d98b340287446c$var$cleanCommonProps(props), innerRef = _cleanCommonProps.innerRef, isDisabled = _cleanCommonProps.isDisabled, isHidden = _cleanCommonProps.isHidden, inputClassName = _cleanCommonProps.inputClassName, innerProps = (0, $bwPfh.default)(_cleanCommonProps, $50d98b340287446c$var$_excluded);
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps(props, 'input', {
        'input-container': true
    }), {
        "data-value": value || ''
    }), (0, $byn9U.jsx)("input", (0, $kU09D.default)({
        className: cx({
            input: true
        }, inputClassName),
        ref: innerRef,
        style: $50d98b340287446c$var$inputStyle(isHidden),
        disabled: isDisabled
    }, innerProps)));
};
var $50d98b340287446c$var$Input$1 = $50d98b340287446c$var$Input;
var $50d98b340287446c$export$ffb5f4729a158638 = function multiValueCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, borderRadius = _ref$theme.borderRadius, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'multiValue',
        display: 'flex',
        minWidth: 0
    }, unstyled ? {} : {
        backgroundColor: colors.neutral10,
        borderRadius: borderRadius / 2,
        margin: spacing.baseUnit / 2
    });
};
var $50d98b340287446c$export$9e5f44173e64f162 = function multiValueLabelCSS(_ref2, unstyled) {
    var _ref2$theme = _ref2.theme, borderRadius = _ref2$theme.borderRadius, colors = _ref2$theme.colors, cropWithEllipsis = _ref2.cropWithEllipsis;
    return (0, $1Xn5q.default)({
        overflow: 'hidden',
        textOverflow: cropWithEllipsis || cropWithEllipsis === undefined ? 'ellipsis' : undefined,
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        color: colors.neutral80,
        fontSize: '85%',
        padding: 3,
        paddingLeft: 6
    });
};
var $50d98b340287446c$export$625550452a3fa3ec = function multiValueRemoveCSS(_ref3, unstyled) {
    var _ref3$theme = _ref3.theme, spacing = _ref3$theme.spacing, borderRadius = _ref3$theme.borderRadius, colors = _ref3$theme.colors, isFocused = _ref3.isFocused;
    return (0, $1Xn5q.default)({
        alignItems: 'center',
        display: 'flex'
    }, unstyled ? {} : {
        borderRadius: borderRadius / 2,
        backgroundColor: isFocused ? colors.dangerLight : undefined,
        paddingLeft: spacing.baseUnit,
        paddingRight: spacing.baseUnit,
        ':hover': {
            backgroundColor: colors.dangerLight,
            color: colors.danger
        }
    });
};
var $50d98b340287446c$var$MultiValueGeneric = function MultiValueGeneric(_ref4) {
    var children = _ref4.children, innerProps = _ref4.innerProps;
    return (0, $byn9U.jsx)("div", innerProps, children);
};
var $50d98b340287446c$var$MultiValueContainer = $50d98b340287446c$var$MultiValueGeneric;
var $50d98b340287446c$var$MultiValueLabel = $50d98b340287446c$var$MultiValueGeneric;
function $50d98b340287446c$var$MultiValueRemove(_ref5) {
    var children = _ref5.children, innerProps = _ref5.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        role: "button"
    }, innerProps), children || (0, $byn9U.jsx)($50d98b340287446c$var$CrossIcon, {
        size: 14
    }));
}
var $50d98b340287446c$var$MultiValue = function MultiValue(props) {
    var children = props.children, components = props.components, data = props.data, innerProps = props.innerProps, isDisabled = props.isDisabled, removeProps = props.removeProps, selectProps = props.selectProps;
    var Container = components.Container, Label = components.Label, Remove = components.Remove;
    return (0, $byn9U.jsx)(Container, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $50d98b340287446c$var$getStyleProps(props, 'multiValue', {
            'multi-value': true,
            'multi-value--is-disabled': isDisabled
        })), innerProps),
        selectProps: selectProps
    }, (0, $byn9U.jsx)(Label, {
        data: data,
        innerProps: (0, $1Xn5q.default)({}, $50d98b340287446c$var$getStyleProps(props, 'multiValueLabel', {
            'multi-value__label': true
        })),
        selectProps: selectProps
    }, children), (0, $byn9U.jsx)(Remove, {
        data: data,
        innerProps: (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $50d98b340287446c$var$getStyleProps(props, 'multiValueRemove', {
            'multi-value__remove': true
        })), {}, {
            'aria-label': "Remove ".concat(children || 'option')
        }, removeProps),
        selectProps: selectProps
    }));
};
var $50d98b340287446c$var$MultiValue$1 = $50d98b340287446c$var$MultiValue;
var $50d98b340287446c$export$90a7f3efeed30595 = function optionCSS(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, isFocused = _ref.isFocused, isSelected = _ref.isSelected, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'option',
        cursor: 'default',
        display: 'block',
        fontSize: 'inherit',
        width: '100%',
        userSelect: 'none',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)'
    }, unstyled ? {} : {
        backgroundColor: isSelected ? colors.primary : isFocused ? colors.primary25 : 'transparent',
        color: isDisabled ? colors.neutral20 : isSelected ? colors.neutral0 : 'inherit',
        padding: "".concat(spacing.baseUnit * 2, "px ").concat(spacing.baseUnit * 3, "px"),
        // provide some affordance on touch devices
        ':active': {
            backgroundColor: !isDisabled ? isSelected ? colors.primary : colors.primary50 : undefined
        }
    });
};
var $50d98b340287446c$var$Option = function Option(props) {
    var children = props.children, isDisabled = props.isDisabled, isFocused = props.isFocused, isSelected = props.isSelected, innerRef = props.innerRef, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps(props, 'option', {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    }), {
        ref: innerRef,
        "aria-disabled": isDisabled
    }, innerProps), children);
};
var $50d98b340287446c$var$Option$1 = $50d98b340287446c$var$Option;
var $50d98b340287446c$export$efccba1c4a2ef57b = function placeholderCSS(_ref, unstyled) {
    var _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'placeholder',
        gridArea: '1 / 1 / 2 / 3'
    }, unstyled ? {} : {
        color: colors.neutral50,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $50d98b340287446c$var$Placeholder = function Placeholder(props) {
    var children = props.children, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps(props, 'placeholder', {
        placeholder: true
    }), innerProps), children);
};
var $50d98b340287446c$var$Placeholder$1 = $50d98b340287446c$var$Placeholder;
var $50d98b340287446c$export$d141bba7fdc215a3 = function css(_ref, unstyled) {
    var isDisabled = _ref.isDisabled, _ref$theme = _ref.theme, spacing = _ref$theme.spacing, colors = _ref$theme.colors;
    return (0, $1Xn5q.default)({
        label: 'singleValue',
        gridArea: '1 / 1 / 2 / 3',
        maxWidth: '100%',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
    }, unstyled ? {} : {
        color: isDisabled ? colors.neutral40 : colors.neutral80,
        marginLeft: spacing.baseUnit / 2,
        marginRight: spacing.baseUnit / 2
    });
};
var $50d98b340287446c$var$SingleValue = function SingleValue(props) {
    var children = props.children, isDisabled = props.isDisabled, innerProps = props.innerProps;
    return (0, $byn9U.jsx)("div", (0, $kU09D.default)({}, $50d98b340287446c$var$getStyleProps(props, 'singleValue', {
        'single-value': true,
        'single-value--is-disabled': isDisabled
    }), innerProps), children);
};
var $50d98b340287446c$var$SingleValue$1 = $50d98b340287446c$var$SingleValue;
var $50d98b340287446c$export$db3b6bfb95261072 = {
    ClearIndicator: $50d98b340287446c$var$ClearIndicator,
    Control: $50d98b340287446c$var$Control$1,
    DropdownIndicator: $50d98b340287446c$var$DropdownIndicator,
    DownChevron: $50d98b340287446c$var$DownChevron,
    CrossIcon: $50d98b340287446c$var$CrossIcon,
    Group: $50d98b340287446c$var$Group$1,
    GroupHeading: $50d98b340287446c$var$GroupHeading,
    IndicatorsContainer: $50d98b340287446c$var$IndicatorsContainer,
    IndicatorSeparator: $50d98b340287446c$var$IndicatorSeparator,
    Input: $50d98b340287446c$var$Input$1,
    LoadingIndicator: $50d98b340287446c$var$LoadingIndicator,
    Menu: $50d98b340287446c$var$Menu$1,
    MenuList: $50d98b340287446c$var$MenuList,
    MenuPortal: $50d98b340287446c$var$MenuPortal,
    LoadingMessage: $50d98b340287446c$var$LoadingMessage,
    NoOptionsMessage: $50d98b340287446c$var$NoOptionsMessage,
    MultiValue: $50d98b340287446c$var$MultiValue$1,
    MultiValueContainer: $50d98b340287446c$var$MultiValueContainer,
    MultiValueLabel: $50d98b340287446c$var$MultiValueLabel,
    MultiValueRemove: $50d98b340287446c$var$MultiValueRemove,
    Option: $50d98b340287446c$var$Option$1,
    Placeholder: $50d98b340287446c$var$Placeholder$1,
    SelectContainer: $50d98b340287446c$var$SelectContainer,
    SingleValue: $50d98b340287446c$var$SingleValue$1,
    ValueContainer: $50d98b340287446c$var$ValueContainer
};
var $50d98b340287446c$export$d66501df72047452 = function defaultComponents(props) {
    return (0, $1Xn5q.default)((0, $1Xn5q.default)({}, $50d98b340287446c$export$db3b6bfb95261072), props.components);
};

});



parcelRegister("6MMPK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f0d1b1b62371a65$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $i4w9L = parcelRequire("i4w9L");

var $dZ0sJ = parcelRequire("dZ0sJ");
var $1itFq = parcelRequire("1itFq");

var $j1u07 = parcelRequire("j1u07");

var $9X6B9 = parcelRequire("9X6B9");

var $gHipn = parcelRequire("gHipn");

var $kgFCf = parcelRequire("kgFCf");
function $4f0d1b1b62371a65$export$2e2bcd8739ae039(WrappedComponent) {
    const AtlaskitSelect = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function AtlaskitSelect(props, forwardedRef) {
        const { appearance: appearance, ariaLiveMessages: ariaLiveMessages, components: componentsProp, isInvalid: isInvalid, onClickPreventDefault: // TODO: set to true when cleaning up validationState prop so it has a default value
        onClickPreventDefault = true, spacing: spacing = 'default', styles: styles = {}, tabSelectsValue: tabSelectsValue = false, validationState: validationState = 'default', ...restProps } = props;
        const internalSelectRef = (0, $eUqFw.useRef)(null);
        const components = (0, $eUqFw.useMemo)(()=>({
                ClearIndicator: $dZ0sJ.ClearIndicator,
                DropdownIndicator: $dZ0sJ.DropdownIndicator,
                LoadingIndicator: $dZ0sJ.LoadingIndicator,
                MultiValueRemove: $1itFq.MultiValueRemove,
                IndicatorSeparator: $1itFq.IndicatorSeparator,
                Input: $j1u07.Input,
                NoOptionsMessage: $9X6B9.NoOptionsMessage,
                ...componentsProp
            }), [
            componentsProp
        ]);
        const descriptionId = props['aria-describedby'];
        const isSearchable = props.isSearchable;
        (0, $eUqFw.useEffect)(()=>{
            if (!isSearchable && descriptionId) {
                var _internalSelectRef$cu;
                // when isSearchable is false, react-select will create its own dummy input instead of using ours,
                // so we need to manually add the additional aria-describedby using ref.
                const input = (_internalSelectRef$cu = internalSelectRef.current) === null || _internalSelectRef$cu === void 0 ? void 0 : _internalSelectRef$cu.inputRef;
                const ariaDescribedby = input === null || input === void 0 ? void 0 : input.getAttribute('aria-describedby');
                if (!(ariaDescribedby !== null && ariaDescribedby !== void 0 && ariaDescribedby.includes(descriptionId))) input === null || input === void 0 || input.setAttribute('aria-describedby', `${ariaDescribedby} ${descriptionId}`);
            }
        }, [
            descriptionId,
            isSearchable
        ]);
        const isCompact = spacing === 'compact';
        /**
     * The following `useImperativeHandle` hook exists for the sake of backwards compatibility.
     * This component used to be a class component which set the value of the `ref` prop to object with the properties and value as below.
     * This has lead to slightly odd usage of refs with this component, e.g. `myRef.current.select.select.controlRef` instead of just `myRef.current.select.controlRef`
     * In the next major release, this should removed and the ref should be passed directly to the wrapped component (given users have updated usage)
     * More info https://stash.atlassian.com/projects/ATLASSIAN/repos/atlassian-frontend-monorepo/pull-requests/88021/overview
     */ (0, $eUqFw.useImperativeHandle)(forwardedRef, ()=>({
                select: internalSelectRef.current,
                focus: ()=>{
                    var _internalSelectRef$cu2;
                    return (_internalSelectRef$cu2 = internalSelectRef.current) === null || _internalSelectRef$cu2 === void 0 ? void 0 : _internalSelectRef$cu2.focus();
                },
                blur: ()=>{
                    var _internalSelectRef$cu3;
                    return (_internalSelectRef$cu3 = internalSelectRef.current) === null || _internalSelectRef$cu3 === void 0 ? void 0 : _internalSelectRef$cu3.blur();
                }
            }), []);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, (0, $kU09D.default)({
            ref: internalSelectRef,
            "aria-live": "assertive",
            ariaLiveMessages: (0, $kgFCf.isOptionsGrouped)(props.options) ? {
                onFocus: (data)=>(0, $kgFCf.onFocus)(data, props.options),
                ...ariaLiveMessages
            } : {
                ...ariaLiveMessages
            },
            tabSelectsValue: tabSelectsValue,
            onClickPreventDefault: onClickPreventDefault
        }, restProps, {
            components: components,
            styles: (0, $i4w9L.m)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $gHipn.default)(// This will cover both props for invalid state while giving priority to isInvalid. When cleaning up validationState, we can just keep the inner condition.
            typeof isInvalid !== 'undefined' ? isInvalid ? 'error' : 'default' : validationState, isCompact, appearance || 'default'), styles)
        }));
    });
    AtlaskitSelect.displayName = 'AtlaskitSelect';
    return AtlaskitSelect;
}

});
parcelRegister("dZ0sJ", function(module, exports) {

$parcel$export(module.exports, "ClearIndicator", () => $a2e154b3108a8ce3$export$ecf9cf59142dd54a);
$parcel$export(module.exports, "DropdownIndicator", () => $a2e154b3108a8ce3$export$ec98719d3db7f2e4);
$parcel$export(module.exports, "LoadingIndicator", () => $a2e154b3108a8ce3$export$7c20be4c1d342248);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $6Wmpx = parcelRequire("6Wmpx");

var $1FyL9 = parcelRequire("1FyL9");

var $6jhKL = parcelRequire("6jhKL");

var $c6J9g = parcelRequire("c6J9g");
var $7iUNK = parcelRequire("7iUNK");
var $gv7Ek = parcelRequire("gv7Ek");

var $hvCdF = parcelRequire("hvCdF");
const $a2e154b3108a8ce3$var$iconContainerStyles = (0, $gv7Ek.xcss)({
    all: 'unset',
    outline: 'revert',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'space.025'
});
const $a2e154b3108a8ce3$var$dropdownWrapperStyles = (0, $gv7Ek.xcss)({
    padding: 'space.075'
});
const $a2e154b3108a8ce3$export$ecf9cf59142dd54a = (props)=>(0, $byn9U.jsx)((0, $6Wmpx.c).ClearIndicator, (0, $kU09D.default)({}, props, {
        innerProps: {
            ...props.innerProps,
            'aria-hidden': 'false'
        }
    }), (0, $byn9U.jsx)((0, $7iUNK.default), {
        xcss: $a2e154b3108a8ce3$var$iconContainerStyles,
        tabIndex: -1
    }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6jhKL))), {
        label: "clear",
        color: "currentColor",
        LEGACY_size: "small",
        LEGACY_margin: "var(--ds-space-negative-025, -0.125rem)"
    })));
const $a2e154b3108a8ce3$export$ec98719d3db7f2e4 = (props)=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $byn9U.jsx)((0, $6Wmpx.c).DropdownIndicator, props, (0, $byn9U.jsx)((0, $c6J9g.default), {
        as: "span",
        xcss: $a2e154b3108a8ce3$var$dropdownWrapperStyles
    }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1FyL9))), {
        color: "currentColor",
        label: "open",
        LEGACY_margin: "var(--ds-space-negative-075, -0.375rem)"
    })));
const $a2e154b3108a8ce3$export$7c20be4c1d342248 = (props)=>{
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    const loadingStyles = (0, $byn9U.css)(props.getStyles('loadingIndicator', props));
    return(// This *must* be constructed this way because this is being consumed by
    // `react-select` and we don't control what it wants.
    // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
    (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        css: loadingStyles
    }, props.innerProps), (0, $byn9U.jsx)((0, $hvCdF.default), {
        size: "small"
    })));
};

});

parcelRegister("1itFq", function(module, exports) {

$parcel$export(module.exports, "MultiValueRemove", () => $0f1e7c2a49f66d72$export$8e1fd1a40e7a2f4a);
$parcel$export(module.exports, "IndicatorSeparator", () => $0f1e7c2a49f66d72$export$bd638c2ba7915668);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $6Wmpx = parcelRequire("6Wmpx");

var $2Nahn = parcelRequire("2Nahn");

var $a4PmP = parcelRequire("a4PmP");

var $3puyA = parcelRequire("3puyA");

var $c6J9g = parcelRequire("c6J9g");
var $gv7Ek = parcelRequire("gv7Ek");

var $dZ0sJ = parcelRequire("dZ0sJ");
const $0f1e7c2a49f66d72$var$disabledStyles = (0, $byn9U.css)({
    display: 'none'
});
const $0f1e7c2a49f66d72$var$enabledStyles = (0, $byn9U.css)({
    display: 'inherit'
});
const $0f1e7c2a49f66d72$var$iconWrapperStyles = (0, $gv7Ek.xcss)({
    padding: 'space.025'
});
const $0f1e7c2a49f66d72$export$8e1fd1a40e7a2f4a = (props)=>{
    const { isDisabled: isDisabled } = props.selectProps;
    const renderIcon = ()=>{
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $3puyA.fg)('platform-component-visual-refresh')) return (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a4PmP))), {
            label: "Clear",
            color: "currentColor"
        });
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $3puyA.fg)('platform-visual-refresh-icons-legacy-facade')) return (0, $byn9U.jsx)((0, $c6J9g.default), {
            xcss: $0f1e7c2a49f66d72$var$iconWrapperStyles
        }, (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($a4PmP))), {
            label: "Clear",
            color: "currentColor"
        }));
        return(// eslint-disable-next-line @atlaskit/design-system/no-legacy-icons
        (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2Nahn))), {
            label: "Clear",
            primaryColor: "transparent",
            size: "small",
            secondaryColor: "inherit"
        }));
    };
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $byn9U.jsx)((0, $6Wmpx.c).MultiValueRemove, props, (0, $byn9U.jsx)("div", {
        css: isDisabled ? $0f1e7c2a49f66d72$var$disabledStyles : $0f1e7c2a49f66d72$var$enabledStyles,
        "data-testid": isDisabled ? 'hide-clear-icon' : 'show-clear-icon'
    }, renderIcon())));
};
const $0f1e7c2a49f66d72$export$bd638c2ba7915668 = null;

});

parcelRegister("j1u07", function(module, exports) {

$parcel$export(module.exports, "Input", () => $dd9561e45fde6b29$export$f5b8910cec6cf069);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $6Wmpx = parcelRequire("6Wmpx");
function $dd9561e45fde6b29$export$f5b8910cec6cf069(props) {
    let ariaDescribedByAttribute;
    const passed_describedby = props.selectProps['aria-describedby'];
    if (props['aria-describedby'] && passed_describedby) ariaDescribedByAttribute = props['aria-describedby'] + ' ' + passed_describedby;
    else ariaDescribedByAttribute = props['aria-describedby'] || passed_describedby;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Wmpx.c).Input, (0, $kU09D.default)({}, props, {
        "aria-describedby": ariaDescribedByAttribute
    }));
}

});

parcelRegister("9X6B9", function(module, exports) {

$parcel$export(module.exports, "NoOptionsMessage", () => $73eebdfe45376855$export$d58b72b7d3c4072c);

var $eUqFw = parcelRequire("eUqFw");

var $6Wmpx = parcelRequire("6Wmpx");

var $ixqNN = parcelRequire("ixqNN");
const $73eebdfe45376855$export$d58b72b7d3c4072c = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Wmpx.c).NoOptionsMessage, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("span", {
        id: "no-options",
        role: "alert"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ixqNN.default), {
        color: "color.text.subtle"
    }, props.children || `No options`)));
};

});

parcelRegister("gHipn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c27ef0fda0f91a84$export$2e2bcd8739ae039);

var $3puyA = parcelRequire("3puyA");

function $c27ef0fda0f91a84$export$2e2bcd8739ae039(validationState, isCompact = false, appearance) {
    return {
        container: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                // react-select disables pointer events when isDisabled is true.
                // We override this and make the inner container turn it off instead.
                pointerEvents: 'all',
                cursor: isDisabled ? 'not-allowed' : css.cursor
            }),
        input: (css)=>({
                ...css,
                color: "var(--ds-text, hsl(0, 0%, 20%))"
            }),
        control: (css, { isFocused: isFocused, isDisabled: isDisabled })=>{
            let borderColor = isFocused ? `var(--ds-border-focused, ${0, $ab6d6432a4c55680$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $ab6d6432a4c55680$export$d6447c357493214f})`;
            let backgroundColor = isFocused ? `var(--ds-background-input-pressed, ${0, $ab6d6432a4c55680$export$29a4f05edc054374})` : `var(--ds-background-input, ${0, $ab6d6432a4c55680$export$9fdfb749e33cdf97})`;
            let backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $ab6d6432a4c55680$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $ab6d6432a4c55680$export$3e51e8f1440314ba})`;
            if (isDisabled) {
                backgroundColor = `var(--ds-background-disabled, ${0, $ab6d6432a4c55680$export$9fdfb749e33cdf97})`;
                borderColor = `var(--ds-background-disabled, ${0, $ab6d6432a4c55680$export$9fdfb749e33cdf97})`;
            }
            if (validationState === 'error') borderColor = `var(--ds-border-danger, ${0, $ab6d6432a4c55680$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColor = `var(--ds-border-success, ${0, $ab6d6432a4c55680$export$a49394138f7b8e85})`;
            let borderColorHover = isFocused ? `var(--ds-border-focused, ${0, $ab6d6432a4c55680$export$ecfc1dff386a3e7a})` : `var(--ds-border-input, ${0, $ab6d6432a4c55680$export$d6447c357493214f})`;
            if (validationState === 'error') borderColorHover = `var(--ds-border-danger, ${0, $ab6d6432a4c55680$export$2010d0fb4295b346})`;
            if (validationState === 'success') borderColorHover = `var(--ds-border-success, ${0, $ab6d6432a4c55680$export$a49394138f7b8e85})`;
            const transitionDuration = '200ms';
            if (appearance === 'subtle') {
                borderColor = isFocused ? `var(--ds-border-focused, ${0, $ab6d6432a4c55680$export$ecfc1dff386a3e7a})` : 'transparent';
                backgroundColor = isFocused ? `var(--ds-surface, ${0, $ab6d6432a4c55680$export$29a4f05edc054374})` : 'transparent';
                backgroundColorHover = isFocused ? `var(--ds-background-input-pressed, ${0, $ab6d6432a4c55680$export$29a4f05edc054374})` : `var(--ds-background-input-hovered, ${0, $ab6d6432a4c55680$export$3e51e8f1440314ba})`;
            }
            if (appearance === 'none') {
                borderColor = 'transparent';
                backgroundColor = 'transparent';
                backgroundColorHover = 'transparent';
                borderColorHover = 'transparent';
            }
            return {
                ...css,
                // Turn pointer events off when disabled - this makes it so hover etc don't work.
                pointerEvents: isDisabled ? 'none' : undefined,
                backgroundColor: backgroundColor,
                borderColor: borderColor,
                borderStyle: 'solid',
                borderRadius: "var(--ds-border-radius-100, 3px)",
                borderWidth: "var(--ds-border-width, 1px)",
                boxShadow: validationState === 'error' ? `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}` : 'none',
                '&:focus-within': {
                    boxShadow: `inset 0 0 0 ${"var(--ds-border-width, 1px)"} ${borderColor}`
                },
                minHeight: isCompact ? 32 : 40,
                padding: 0,
                transition: `background-color ${transitionDuration} ease-in-out,
        border-color ${transitionDuration} ease-in-out`,
                '::-webkit-scrollbar': {
                    height: 8,
                    width: 8
                },
                '::-webkit-scrollbar-corner': {
                    display: 'none'
                },
                ':hover': {
                    '::-webkit-scrollbar-thumb': {
                        // scrollbars occur only if the user passes in a custom component with overflow: scroll
                        backgroundColor: 'rgba(0,0,0,0.2)'
                    },
                    cursor: 'pointer',
                    backgroundColor: backgroundColorHover,
                    borderColor: borderColorHover
                },
                '::-webkit-scrollbar-thumb:hover': {
                    backgroundColor: 'rgba(0,0,0,0.4)'
                }
            };
        },
        valueContainer: (css)=>({
                ...css,
                paddingLeft: "var(--ds-space-075, 6px)",
                paddingRight: "var(--ds-space-075, 6px)",
                paddingBottom: isCompact ? 0 : 2,
                paddingTop: isCompact ? 0 : 2
            }),
        clearIndicator: (css)=>({
                ...css,
                color: `var(--ds-text-subtlest, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})`,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $ab6d6432a4c55680$export$c39c0fe0f26207ae})`
                }
            }),
        loadingIndicator: (css)=>({
                ...css,
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6
            }),
        dropdownIndicator: (css, { isDisabled: isDisabled })=>{
            let color = `var(--ds-text-subtle, ${(0, $ab6d6432a4c55680$export$c39c0fe0f26207ae)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})`;
            return {
                ...css,
                color: color,
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                paddingBottom: isCompact ? 0 : 6,
                paddingTop: isCompact ? 0 : 6,
                ':hover': {
                    color: `var(--ds-text-subtle, ${0, $ab6d6432a4c55680$export$f563ee71e9ee74cd})`
                }
            };
        },
        indicatorsContainer: (css)=>({
                ...css,
                paddingRight: "var(--ds-space-050, 4px)"
            }),
        option: (css, { isFocused: isFocused, isSelected: isSelected, isDisabled: isDisabled })=>{
            let color = `var(--ds-text, ${(0, $ab6d6432a4c55680$export$7d61b15e0da132af)})`;
            if (isDisabled) color = `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})`;
            else if (isSelected) color = `var(--ds-text-selected, ${0, $ab6d6432a4c55680$export$b3de0ae08da2ce64})`;
            let boxShadow;
            let backgroundColor;
            if (isDisabled) backgroundColor = undefined;
            else if (isSelected && isFocused) backgroundColor = `var(--ds-background-selected-hovered, ${0, $ab6d6432a4c55680$export$226de0355ed012f8})`;
            else if (isSelected) backgroundColor = `var(--ds-background-selected, ${0, $ab6d6432a4c55680$export$226de0355ed012f8})`;
            else if (isFocused) backgroundColor = `var(--ds-background-neutral-subtle-hovered, ${0, $ab6d6432a4c55680$export$9fdfb749e33cdf97})`;
            if (!isDisabled && (isFocused || isSelected)) boxShadow = `inset 2px 0px 0px ${`var(--ds-border-selected, ${0, $ab6d6432a4c55680$export$b3de0ae08da2ce64})`}`;
            const cursor = isDisabled ? 'not-allowed' : css.cursor;
            return {
                ...css,
                padding: '6px 12px',
                backgroundColor: backgroundColor,
                color: color,
                cursor: cursor,
                boxShadow: boxShadow,
                ':active': {
                    backgroundColor: !isDisabled ? isSelected ? `var(--ds-background-selected-pressed, ${0, $ab6d6432a4c55680$export$9fdfb749e33cdf97})` : `var(--ds-background-neutral-subtle-pressed, ${0, $ab6d6432a4c55680$export$3e51e8f1440314ba})` : undefined
                },
                '@media screen and (-ms-high-contrast: active)': {
                    borderLeft: !isDisabled && (isFocused || isSelected) ? '2px solid transparent' : ''
                }
            };
        },
        placeholder: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$e2ef2124cf4024b1})` : `var(--ds-text-subtlest, ${0, $ab6d6432a4c55680$export$f563ee71e9ee74cd})`
            }),
        singleValue: (css, { isDisabled: isDisabled })=>({
                ...css,
                color: isDisabled ? `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})` : `var(--ds-text, ${0, $ab6d6432a4c55680$export$7d61b15e0da132af})`
            }),
        menu: (css)=>({
                ...css,
                backgroundColor: "var(--ds-surface-overlay, white)",
                boxShadow: "var(--ds-shadow-overlay, 0 0 0 1px hsl(0deg 0% 0% / 10%), 0 4px 11px hsl(0deg 0% 0% / 10%))"
            }),
        menuList: (css)=>({
                ...css,
                paddingTop: "var(--ds-space-100, 8px)",
                paddingBottom: "var(--ds-space-100, 8px)"
            }),
        multiValue: (css, { isDisabled: isDisabled, isFocused: isFocused })=>{
            let backgroundColor;
            let color;
            if (isDisabled) {
                // Use the basic neutral background so it is slightly separate from the
                // field's background
                backgroundColor = `var(--ds-background-neutral, ${0, $ab6d6432a4c55680$export$1ce2d1575d444ceb})`;
                color = `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})`;
            } else if (isFocused) {
                backgroundColor = `var(--ds-background-selected, ${0, $ab6d6432a4c55680$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text-selected, hsl(0, 0%, 20%))";
            } else {
                backgroundColor = (0, $3puyA.fg)('platform-component-visual-refresh') ? "var(--ds-background-neutral-subtle-hovered, #091E420F)" : `var(--ds-background-neutral, ${0, $ab6d6432a4c55680$export$1ce2d1575d444ceb})`;
                color = "var(--ds-text, hsl(0, 0%, 20%))";
            }
            return {
                ...css,
                borderRadius: "var(--ds-border-radius-050, 2px)",
                backgroundColor: backgroundColor,
                boxShadow: isFocused ? `0 0 0 2px ${"var(--ds-surface, transparent)"}, 0 0 0 4px ${"var(--ds-border-focused, transparent)"}` : 'none',
                maxWidth: '100%',
                '@media screen and (-ms-high-contrast: active)': {
                    border: isFocused ? '1px solid transparent' : 'none'
                },
                color: color,
                ...(0, $3puyA.fg)('platform-component-visual-refresh') && {
                    borderRadius: "var(--ds-border-radius-100, 4px)",
                    // Hardcode this color for visual refresh as there is no token color yet
                    borderColor: '#B7B9BE',
                    borderWidth: "var(--ds-border-width, 1px)",
                    borderStyle: 'solid',
                    backgroundColor: "var(--ds-background-input, #FFFFFF)"
                }
            };
        },
        multiValueLabel: (css, { isDisabled: isDisabled })=>({
                ...css,
                font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                padding: "var(--ds-space-025, 2px)",
                color: isDisabled ? `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})` : 'inherit',
                paddingRight: "var(--ds-space-025, 2px)",
                ...(0, $3puyA.fg)('platform-component-visual-refresh') && {
                    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                    paddingTop: 0,
                    paddingBottom: 0,
                    paddingLeft: "var(--ds-space-050, 4px)"
                }
            }),
        multiValueRemove: (css, { isFocused: isFocused })=>({
                ...css,
                backgroundColor: isFocused ? `var(--ds-UNSAFE-transparent, ${0, $ab6d6432a4c55680$export$b34b069eff244586})` : undefined,
                fill: isFocused ? "var(--ds-text-selected, #000)" : "var(--ds-text, #000)",
                paddingLeft: "var(--ds-space-025, 2px)",
                paddingRight: "var(--ds-space-025, 2px)",
                borderRadius: '0px 2px 2px 0px',
                // DSP-6470 we should style like Tag once we have the :has selector
                ':hover': {
                    backgroundColor: `var(--ds-background-danger-hovered, ${0, $ab6d6432a4c55680$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ':active': {
                    backgroundColor: `var(--ds-background-danger-pressed, ${0, $ab6d6432a4c55680$export$b34b069eff244586})`,
                    fill: "var(--ds-text-danger, #000)"
                },
                ...(0, $3puyA.fg)('platform-component-visual-refresh') && {
                    backgroundColor: "var(--ds-background-neutral-subtle, #00000000)",
                    border: 'none',
                    alignItems: 'center',
                    justifyContent: 'center',
                    alignSelf: 'center',
                    appearance: 'none',
                    borderRadius: "var(--ds-border-radius, 4px)",
                    color: "var(--ds-text, #172B4D)",
                    padding: "var(--ds-space-025, 2px)",
                    marginRight: "var(--ds-space-025, 2px)",
                    ':focus-visible': {
                        outlineOffset: "var(--ds-space-negative-025, -2px)"
                    },
                    ':hover': {
                        backgroundColor: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
                    },
                    ':active': {
                        backgroundColor: "var(--ds-background-neutral-subtle-pressed, #091E4224)"
                    }
                }
            }),
        groupHeading: (css)=>({
                ...css,
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
                color: `var(--ds-text-subtle, ${0, $ab6d6432a4c55680$export$f563ee71e9ee74cd})`,
                ...(0, $3puyA.fg)('platform_design_system_team_select_typography') && {
                    fontWeight: `${"var(--ds-font-weight-bold, 700)"} !important`,
                    textTransform: 'none'
                }
            })
    };
}

});

parcelRegister("kgFCf", function(module, exports) {

$parcel$export(module.exports, "onFocus", () => $ec15955334bd2dd2$export$ecf9bf35ad97eb74);
$parcel$export(module.exports, "isOptionsGrouped", () => $ec15955334bd2dd2$export$d2756249f53f9f8);
// Used for overwriting ariaLiveMessages builtin onFocus method.
// Returns custom built string while focusing each group option. This string is used for screen reader announcement.
function $ec15955334bd2dd2$export$ecf9bf35ad97eb74(onFocusProps, defaultOptions) {
    var _groupData$options$fi;
    const { focused: focused } = onFocusProps;
    const isOptionFocused = (option)=>{
        return option.label === focused.label;
    };
    const groupData = defaultOptions === null || defaultOptions === void 0 ? void 0 : defaultOptions.find((option)=>{
        var _option$options;
        return (_option$options = option.options) === null || _option$options === void 0 ? void 0 : _option$options.some(isOptionFocused);
    });
    const groupOptionIndex = (_groupData$options$fi = groupData === null || groupData === void 0 ? void 0 : groupData.options.findIndex(isOptionFocused)) !== null && _groupData$options$fi !== void 0 ? _groupData$options$fi : 0;
    return `Option ${focused.label}, ${groupData === null || groupData === void 0 ? void 0 : groupData.label} group, item ${groupOptionIndex + 1} out of ${groupData === null || groupData === void 0 ? void 0 : groupData.options.length}. All in all `;
}
const $ec15955334bd2dd2$export$d2756249f53f9f8 = (arr)=>{
    return arr === null || arr === void 0 ? void 0 : arr.every((obj)=>obj.hasOwnProperty('options'));
};
const $ec15955334bd2dd2$export$8ee33f304118fce4 = (groupsArray)=>{
    const totalLength = groupsArray === null || groupsArray === void 0 ? void 0 : groupsArray.reduce((acc, currentGroup)=>{
        var _group$options;
        const group = currentGroup;
        acc += group === null || group === void 0 ? void 0 : (_group$options = group.options) === null || _group$options === void 0 ? void 0 : _group$options.length;
        return acc;
    }, 0);
    return totalLength;
};

});



parcelRegister("aCWZ7", function(module, exports) {

$parcel$export(module.exports, "CustomControl", () => $7bcb352acfa89abe$export$b0c082086b5fac02);
$parcel$export(module.exports, "CustomControlMobile", () => $7bcb352acfa89abe$export$69537265c8e51652);
/* CustomControl.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $6Wmpx = parcelRequire("6Wmpx");

var $lWrn5 = parcelRequire("lWrn5");


var $lHkHI = parcelRequire("lHkHI");
const $7bcb352acfa89abe$var$_excluded = [
    "as",
    "style"
], $7bcb352acfa89abe$var$_excluded2 = [
    "as",
    "style"
];
function $7bcb352acfa89abe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7bcb352acfa89abe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7bcb352acfa89abe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7bcb352acfa89abe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $7bcb352acfa89abe$export$3c097c517393fbe5 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $7bcb352acfa89abe$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7bcb352acfa89abe$var$_objectSpread($7bcb352acfa89abe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect41sdi _1e0c1txw _1yt4h461 _n7zl13y5",
            __cmplp.className
        ])
    }));
});
const $7bcb352acfa89abe$export$b0c082086b5fac02 = (props)=>{
    return props.selectProps.isSearchable ? /*#__PURE__*/ (0, $lHkHI.jsx)($7bcb352acfa89abe$export$3c097c517393fbe5, $7bcb352acfa89abe$var$_objectSpread($7bcb352acfa89abe$var$_objectSpread({
        ref: props.innerRef
    }, props.innerProps), {}, {
        children: props.children
    })) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lWrn5.default), {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6Wmpx.c).Control, $7bcb352acfa89abe$var$_objectSpread({}, props))
    });
};
const $7bcb352acfa89abe$export$6baa5dae8161e2be = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $7bcb352acfa89abe$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7bcb352acfa89abe$var$_objectSpread($7bcb352acfa89abe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect41sdi _1e0c1txw _18s8xjmg _19it13y5 _2rkojs4s _1wyb1j6v",
            __cmplp.className
        ])
    }));
});
const $7bcb352acfa89abe$export$69537265c8e51652 = (props)=>{
    return props.selectProps.isSearchable ? /*#__PURE__*/ (0, $lHkHI.jsx)($7bcb352acfa89abe$export$6baa5dae8161e2be, $7bcb352acfa89abe$var$_objectSpread($7bcb352acfa89abe$var$_objectSpread({
        ref: props.innerRef
    }, props.innerProps), {}, {
        children: props.children
    })) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lWrn5.default), {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6Wmpx.c).Control, $7bcb352acfa89abe$var$_objectSpread({}, props))
    });
};

});

parcelRegister("kUvoe", function(module, exports) {

$parcel$export(module.exports, "CustomDropdownIndicator", () => $f39162f71533ba09$export$801accd538d219b5);

var $5zQU9 = parcelRequire("5zQU9");

var $1jAT8 = parcelRequire("1jAT8");

var $4nnbD = parcelRequire("4nnbD");

var $hXNHP = parcelRequire("hXNHP");

var $4xAW3 = parcelRequire("4xAW3");
var $d4qUE = parcelRequire("d4qUE");

var $6Wmpx = parcelRequire("6Wmpx");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $f39162f71533ba09$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f39162f71533ba09$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f39162f71533ba09$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f39162f71533ba09$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f39162f71533ba09$var$wrapperStyles = (0, $d4qUE.xcss)({
    marginRight: 'space.025',
    textAlign: 'center',
    width: 'size.400',
    height: 'size.200'
});
const $f39162f71533ba09$var$ClearSearchIcon = ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4nnbD))), {
        size: "small",
        primaryColor: "var(--ds-icon)",
        label: ""
    });
const $f39162f71533ba09$export$296b2660edd12fea = (_ref)=>{
    let { searchInputValue: searchInputValue, testIdPrefix: testIdPrefix, onClearSearchButtonClick: onClearSearchButtonClick } = _ref;
    const handleClick = (0, $eUqFw.useCallback)((event)=>{
        event.preventDefault();
        onClearSearchButtonClick();
    }, [
        onClearSearchButtonClick
    ]);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4xAW3.default), {
        xcss: $f39162f71533ba09$var$wrapperStyles,
        alignBlock: "center",
        alignInline: "center",
        children: searchInputValue ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1jAT8.default), {
            label: "Clear search text",
            icon: $f39162f71533ba09$var$ClearSearchIcon,
            shape: "circle",
            appearance: "subtle",
            spacing: "compact",
            testId: "".concat(testIdPrefix, ".clear-search-text-button"),
            onClick: handleClick
        }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hXNHP))), {
            size: "small",
            label: ""
        })
    });
};
const $f39162f71533ba09$export$801accd538d219b5 = (props)=>{
    const { inputValue: inputValue, onInputChange: onInputChange } = props.selectProps;
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onInputChange('', {
            action: 'input-change',
            prevInputValue: inputValue
        });
    }, [
        inputValue,
        onInputChange
    ]);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6Wmpx.c).DropdownIndicator, $f39162f71533ba09$var$_objectSpread($f39162f71533ba09$var$_objectSpread({}, props), {}, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)($f39162f71533ba09$export$296b2660edd12fea, {
            searchInputValue: props.selectProps.inputValue,
            testIdPrefix: props.selectProps.testId,
            onClearSearchButtonClick: handleClick
        })
    }));
};

});
parcelRegister("1jAT8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f542e03a647e22e$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $3puyA = parcelRequire("3puyA");

var $24o1N = parcelRequire("24o1N");

var $l2WWm = parcelRequire("l2WWm");

var $lUIXH = parcelRequire("lUIXH");
/**
 * __Icon Button__
 *
 * TODO: Description
 *
 * - [Examples](https://atlassian.design/components/icon-button/examples)
 * - [Code](https://atlassian.design/components/icon-button/code)
 * - [Usage](https://atlassian.design/components/icon-button/usage)
 */ const $0f542e03a647e22e$var$IconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function Button({ // Prevent duplicate labels being added.
'aria-label': preventedAriaLabel, 'aria-labelledby': ariaLabelledBy, analyticsContext: analyticsContext, appearance: appearance, autoFocus: autoFocus, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading, isSelected: isSelected, isTooltipDisabled: isTooltipDisabled = true, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shape: shape, spacing: spacing, testId: testId, tooltip: tooltip, type: type = 'button', UNSAFE_size: UNSAFE_size, ...unsafeRest }, ref) {
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const rest = (0, $3puyA.getBooleanFF)('platform.design-system-team.remove-unsafe-spread-from-new-button_a2xhw') ? saferRest : unsafeRest;
    /**
   * TODO: At some stage I'll look into re-using more logic across 'default' and 'icon'
   * buttons. It's currently duplicated and mostly the same.
   */ const baseProps = (0, $lUIXH.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'button',
        icon: icon,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        label: label,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shape: shape,
        spacing: spacing,
        testId: testId,
        UNSAFE_size: UNSAFE_size
    });
    if (!isTooltipDisabled) {
        var _tooltip$content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $l2WWm.default), {
            content: (_tooltip$content = tooltip === null || tooltip === void 0 ? void 0 : tooltip.content) !== null && _tooltip$content !== void 0 ? _tooltip$content : label,
            testId: tooltip === null || tooltip === void 0 ? void 0 : tooltip.testId,
            position: tooltip === null || tooltip === void 0 ? void 0 : tooltip.position,
            delay: tooltip === null || tooltip === void 0 ? void 0 : tooltip.delay,
            onShow: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onShow,
            onHide: tooltip === null || tooltip === void 0 ? void 0 : tooltip.onHide,
            mousePosition: tooltip === null || tooltip === void 0 ? void 0 : tooltip.mousePosition,
            analyticsContext: tooltip === null || tooltip === void 0 ? void 0 : tooltip.analyticsContext,
            strategy: tooltip === null || tooltip === void 0 ? void 0 : tooltip.strategy,
            tag: tooltip === null || tooltip === void 0 ? void 0 : tooltip.tag,
            truncate: tooltip === null || tooltip === void 0 ? void 0 : tooltip.truncate,
            component: tooltip === null || tooltip === void 0 ? void 0 : tooltip.component,
            hideTooltipOnClick: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnClick,
            hideTooltipOnMouseDown: tooltip === null || tooltip === void 0 ? void 0 : tooltip.hideTooltipOnMouseDown
        }, (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $24o1N.default), (0, $kU09D.default)({}, rest, {
                // Top level props
                "aria-labelledby": baseProps['aria-labelledby'],
                type: type,
                testId: testId,
                componentName: "IconButton",
                analyticsContext: analyticsContext,
                interactionName: interactionName,
                onMouseOver: (e)=>{
                    var _triggerProps$onMouse, _rest$onMouseOver;
                    (_triggerProps$onMouse = triggerProps.onMouseOver) === null || _triggerProps$onMouse === void 0 || _triggerProps$onMouse.call(triggerProps, e);
                    (_rest$onMouseOver = rest.onMouseOver) === null || _rest$onMouseOver === void 0 || _rest$onMouseOver.call(rest, e);
                },
                onMouseOut: (e)=>{
                    var _triggerProps$onMouse2, _rest$onMouseOut;
                    (_triggerProps$onMouse2 = triggerProps.onMouseOut) === null || _triggerProps$onMouse2 === void 0 || _triggerProps$onMouse2.call(triggerProps, e);
                    (_rest$onMouseOut = rest.onMouseOut) === null || _rest$onMouseOut === void 0 || _rest$onMouseOut.call(rest, e);
                },
                onMouseMove: (e)=>{
                    var _triggerProps$onMouse3, _rest$onMouseMove;
                    (_triggerProps$onMouse3 = triggerProps.onMouseMove) === null || _triggerProps$onMouse3 === void 0 || _triggerProps$onMouse3.call(triggerProps, e);
                    (_rest$onMouseMove = rest.onMouseMove) === null || _rest$onMouseMove === void 0 || _rest$onMouseMove.call(rest, e);
                },
                onMouseDown: (e)=>{
                    var _triggerProps$onMouse4, _rest$onMouseDown;
                    (_triggerProps$onMouse4 = triggerProps.onMouseDown) === null || _triggerProps$onMouse4 === void 0 || _triggerProps$onMouse4.call(triggerProps, e);
                    (_rest$onMouseDown = rest.onMouseDown) === null || _rest$onMouseDown === void 0 || _rest$onMouseDown.call(rest, e);
                },
                onFocus: (e)=>{
                    var _triggerProps$onFocus, _rest$onFocus;
                    (_triggerProps$onFocus = triggerProps.onFocus) === null || _triggerProps$onFocus === void 0 || _triggerProps$onFocus.call(triggerProps, e);
                    (_rest$onFocus = rest.onFocus) === null || _rest$onFocus === void 0 || _rest$onFocus.call(rest, e);
                },
                onBlur: (e)=>{
                    var _triggerProps$onBlur, _rest$onBlur;
                    (_triggerProps$onBlur = triggerProps.onBlur) === null || _triggerProps$onBlur === void 0 || _triggerProps$onBlur.call(triggerProps, e);
                    (_rest$onBlur = rest.onBlur) === null || _rest$onBlur === void 0 || _rest$onBlur.call(rest, e);
                },
                onClick: (event, analyticsEvent)=>{
                    var _baseProps$onClick, _triggerProps$onClick;
                    baseProps === null || baseProps === void 0 || (_baseProps$onClick = baseProps.onClick) === null || _baseProps$onClick === void 0 || _baseProps$onClick.call(baseProps, event, analyticsEvent);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$onClick = triggerProps.onClick) === null || _triggerProps$onClick === void 0 || _triggerProps$onClick.call(triggerProps, event);
                },
                ref: (ref)=>{
                    var _triggerProps$ref;
                    baseProps.ref(ref);
                    triggerProps === null || triggerProps === void 0 || (_triggerProps$ref = triggerProps.ref) === null || _triggerProps$ref === void 0 || _triggerProps$ref.call(triggerProps, ref);
                },
                xcss: baseProps.xcss,
                isDisabled: baseProps.isDisabled,
                onMouseDownCapture: baseProps.onMouseDownCapture,
                onMouseUpCapture: baseProps.onMouseUpCapture,
                onKeyDownCapture: baseProps.onKeyDownCapture,
                onKeyUpCapture: baseProps.onKeyUpCapture,
                onTouchStartCapture: baseProps.onTouchStartCapture,
                onTouchEndCapture: baseProps.onTouchEndCapture,
                onPointerDownCapture: baseProps.onPointerDownCapture,
                onPointerUpCapture: baseProps.onPointerUpCapture,
                onClickCapture: baseProps.onClickCapture
            }), baseProps.children));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $24o1N.default), (0, $kU09D.default)({}, rest, {
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        isDisabled: baseProps.isDisabled,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        type: type,
        testId: testId,
        componentName: "IconButton",
        analyticsContext: analyticsContext,
        interactionName: interactionName
    }), baseProps.children);
}));
$0f542e03a647e22e$var$IconButton.displayName = 'IconButton';
var $0f542e03a647e22e$export$2e2bcd8739ae039 = $0f542e03a647e22e$var$IconButton;

});
parcelRegister("lUIXH", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff41b46abc21f3dc$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $lWrn5 = parcelRequire("lWrn5");

var $6HLik = parcelRequire("6HLik");

var $5rSKK = parcelRequire("5rSKK");

var $j6alF = parcelRequire("j6alF");
/**
 * __Use icon button__
 *
 * A React hook that accepts a set of icon Button props,
 * and processes them to return consistent base props for usage
 * across IconButton and LinkIconButton variants.
 *
 * @private
 */ const $ff41b46abc21f3dc$var$useIconButton = ({ analyticsContext: analyticsContext, appearance: appearance, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, autoFocus: autoFocus, buttonType: buttonType, icon: icon, interactionName: interactionName, isDisabled: isDisabled, isLoading: isLoading = false, isSelected: isSelected, label: label, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, ref: ref, shape: shape, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, UNSAFE_size: UNSAFE_size })=>{
    const isCircle = shape === 'circle';
    const baseProps = (0, $j6alF.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        autoFocus: autoFocus,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        buttonType: buttonType,
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6HLik.default), {
            type: "icon",
            isLoading: isLoading
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5rSKK.default), {
            icon: icon,
            size: UNSAFE_size
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWrn5.default), null, label)),
        interactionName: interactionName,
        isDisabled: isDisabled,
        isLoading: isLoading,
        isSelected: isSelected,
        isIconButton: true,
        isCircle: isCircle,
        onClick: onClick,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onTouchStartCapture: onTouchStartCapture,
        onTouchEndCapture: onTouchEndCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onClickCapture: onClickCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId
    });
    return baseProps;
};
var $ff41b46abc21f3dc$export$2e2bcd8739ae039 = $ff41b46abc21f3dc$var$useIconButton;

});


parcelRegister("4nnbD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32fb4bc819316bfe$var$_react = $32fb4bc819316bfe$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $32fb4bc819316bfe$var$_crossCircle = $32fb4bc819316bfe$var$_interopRequireDefault((parcelRequire("evEgf")));
function $32fb4bc819316bfe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $32fb4bc819316bfe$var$CrossCircleIcon = (props)=>/*#__PURE__*/ $32fb4bc819316bfe$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m13.477 9.113-4.36 4.386a1 1 0 1 0 1.418 1.41l4.36-4.386a1 1 0 0 0-1.418-1.41"/><path fill="inherit" d="m9.084 10.501 4.358 4.377a1 1 0 1 0 1.418-1.411L10.5 9.09a1 1 0 0 0-1.417 1.411"/></g></svg>`
    }, props, {
        newIcon: $32fb4bc819316bfe$var$_crossCircle.default
    }));
$32fb4bc819316bfe$var$CrossCircleIcon.displayName = 'CrossCircleIcon';
var $32fb4bc819316bfe$var$_default = module.exports.default = $32fb4bc819316bfe$var$CrossCircleIcon;

});


parcelRegister("6Z68J", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $515d33cf876ef6be$export$a06f1c675e846f6f);

var $379fO = parcelRequire("379fO");
var $d4qUE = parcelRequire("d4qUE");
parcelRequire("eUqFw");

var $c7oRQ = parcelRequire("c7oRQ");

var $lHkHI = parcelRequire("lHkHI");
const $515d33cf876ef6be$var$footerWrapperStyles = (0, $d4qUE.xcss)({
    borderTopColor: 'color.border',
    borderTopWidth: 'border.width',
    borderTopStyle: 'solid'
});
const $515d33cf876ef6be$export$a06f1c675e846f6f = (_ref)=>{
    let { isClearSelectionDisabled: isClearSelectionDisabled, onClearSelection: onClearSelection } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
        xcss: $515d33cf876ef6be$var$footerWrapperStyles,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $c7oRQ.ClearSelectionButton), {
            onClick: onClearSelection,
            isDisabled: isClearSelectionDisabled
        })
    });
};

});
parcelRegister("c7oRQ", function(module, exports) {

$parcel$export(module.exports, "ClearSelectionButton", () => $8d296d9f6de482c7$export$bbfc8ae83c2d15c2);

var $d4qUE = parcelRequire("d4qUE");

var $FHhXl = parcelRequire("FHhXl");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $8d296d9f6de482c7$var$buttonStyles = (0, $d4qUE.xcss)({
    width: '100%',
    color: 'color.text.subtle',
    fontSize: '0.875rem',
    fontWeight: 400,
    paddingBlock: 'space.150',
    paddingInline: 'space.200',
    textAlign: 'left',
    backgroundColor: 'elevation.surface',
    /**
   * Using `border` directly instead of separate properties for width, style, and color so we
   * can set the border color to transparent when not focused.
   * Otherwise, the element will shift when the border is added.
   */ border: "var(--ds-border-width-outline, 2px)".concat(" solid transparent"),
    ':focus-visible': {
        outline: 'none',
        borderWidth: 'border.width.outline',
        borderStyle: 'solid',
        borderColor: 'color.border.focused'
    },
    ':disabled': {
        color: 'color.text.disabled'
    }
});
const $8d296d9f6de482c7$var$buttonEnabledStyles = (0, $d4qUE.xcss)({
    ':hover': {
        backgroundColor: 'elevation.surface.hovered'
    },
    ':active': {
        backgroundColor: 'elevation.surface.pressed'
    }
});
const $8d296d9f6de482c7$export$bbfc8ae83c2d15c2 = (_ref)=>{
    let { isDisabled: isDisabled, onClick: onClick } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $FHhXl.default), {
        onClick: onClick,
        onKeyDown: onClick,
        isDisabled: isDisabled,
        xcss: [
            $8d296d9f6de482c7$var$buttonStyles,
            !isDisabled && $8d296d9f6de482c7$var$buttonEnabledStyles
        ],
        children: "Clear selection"
    });
};

});
parcelRegister("FHhXl", function(module, exports) {

$parcel$export(module.exports, "default", () => $07d568aac57b1030$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $d4qUE = parcelRequire("d4qUE");

var $379fO = parcelRequire("379fO");
// TODO: Duplicated FocusRing styles due to lack of `xcss` support
// and to prevent additional dependency
const $07d568aac57b1030$var$baseFocusRingStyles = {
    outlineColor: 'color.border.focused',
    outlineWidth: 'border.width.outline',
    outlineStyle: 'solid',
    outlineOffset: 'space.025'
};
const $07d568aac57b1030$var$focusRingStyles = (0, $d4qUE.xcss)({
    ':focus-visible': $07d568aac57b1030$var$baseFocusRingStyles,
    '@supports not selector(*:focus-visible)': {
        ':focus': $07d568aac57b1030$var$baseFocusRingStyles
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        ':focus-visible': {
            outline: '1px solid'
        }
    }
});
/**
 * __UNSAFE_PRESSABLE__
 *
 * @internal Still under development. Do not use.
 *
 * A Pressable is a primitive component that renders a `<button>`.
 *
 * - [Examples](https://atlassian.design/components/primitives/pressable/examples)
 * - [Code](https://atlassian.design/components/primitives/pressable/code)
 * - [Usage](https://atlassian.design/components/primitives/pressable/usage)
 */ const $07d568aac57b1030$var$UNSAFE_PRESSABLE = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children, backgroundColor: backgroundColor, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, isDisabled: isDisabled, type: type = 'button', testId: testId, xcss: xcssStyles, ...htmlAttributes }, ref)=>{
    // Combine default styles with supplied styles. XCSS does not support deep nested arrays
    let styles = [
        (0, $d4qUE.xcss)({
            cursor: isDisabled ? 'not-allowed' : 'pointer'
        }),
        $07d568aac57b1030$var$focusRingStyles
    ];
    styles = Array.isArray(xcssStyles) ? [
        ...styles,
        ...xcssStyles
    ] : [
        ...styles,
        xcssStyles
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $379fO.default), (0, $kU09D.default)({}, htmlAttributes, {
        as: "button",
        ref: ref,
        testId: testId,
        type: type,
        backgroundColor: backgroundColor,
        padding: padding,
        paddingBlock: paddingBlock,
        paddingBlockStart: paddingBlockStart,
        paddingBlockEnd: paddingBlockEnd,
        paddingInline: paddingInline,
        paddingInlineStart: paddingInlineStart,
        paddingInlineEnd: paddingInlineEnd,
        xcss: styles,
        disabled: isDisabled
    }), children);
});
var $07d568aac57b1030$export$2e2bcd8739ae039 = $07d568aac57b1030$var$UNSAFE_PRESSABLE;

});



parcelRegister("dWSYG", function(module, exports) {

$parcel$export(module.exports, "CustomMenu", () => $a27b568f7784a2d9$export$4664e7a657286474);

var $5zQU9 = parcelRequire("5zQU9");

var $379fO = parcelRequire("379fO");
var $d4qUE = parcelRequire("d4qUE");
parcelRequire("eUqFw");

var $3DYxj = parcelRequire("3DYxj");

var $guy21 = parcelRequire("guy21");

var $7uxb7 = parcelRequire("7uxb7");

var $lHkHI = parcelRequire("lHkHI");
function $a27b568f7784a2d9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a27b568f7784a2d9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a27b568f7784a2d9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a27b568f7784a2d9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a27b568f7784a2d9$export$2f50339a3051f2f1 = (_ref)=>{
    let { status: status, children: children } = _ref;
    if (status === 'error') return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $guy21.ErrorState), {});
    if (status === 'loading') return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7uxb7.LoadingSpinner), {});
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: children
    });
};
const $a27b568f7784a2d9$var$customMenuStyles = (0, $d4qUE.xcss)((0, $3DYxj.charlieTextFontFamily));
const $a27b568f7784a2d9$export$4664e7a657286474 = (_ref2)=>{
    let { innerRef: innerRef, innerProps: innerProps, selectProps: { status: status }, children: children } = _ref2;
    return /*#__PURE__*/ (0, $lHkHI.jsx)("div", $a27b568f7784a2d9$var$_objectSpread($a27b568f7784a2d9$var$_objectSpread({
        ref: innerRef
    }, innerProps), {}, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
            xcss: $a27b568f7784a2d9$var$customMenuStyles,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)($a27b568f7784a2d9$export$2f50339a3051f2f1, {
                status: status,
                children: children
            })
        })
    }));
};

});
parcelRegister("guy21", function(module, exports) {

$parcel$export(module.exports, "ErrorState", () => $c019d8a4b2c8236d$export$c1ed4f415b9e7023);

var $379fO = parcelRequire("379fO");
var $5cJpv = parcelRequire("5cJpv");
var $d4qUE = parcelRequire("d4qUE");
parcelRequire("eUqFw");

var $ejlaX = parcelRequire("ejlaX");

var $lHkHI = parcelRequire("lHkHI");
const $c019d8a4b2c8236d$var$wrapperStyles = (0, $d4qUE.xcss)({
    paddingTop: 'space.400',
    paddingBottom: 'space.600'
});
const $c019d8a4b2c8236d$var$loadingTextStyles = (0, $d4qUE.xcss)({
    fontSize: '1rem',
    fontWeight: 600,
    textAlign: 'center'
});
const $c019d8a4b2c8236d$export$c1ed4f415b9e7023 = ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)((0, $5cJpv.default), {
        alignBlock: "center",
        alignInline: "center",
        space: "space.200",
        xcss: $c019d8a4b2c8236d$var$wrapperStyles,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($ejlaX))),
                alt: "",
                width: "120px"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
                xcss: $c019d8a4b2c8236d$var$loadingTextStyles,
                paddingInline: "space.400",
                children: "We're having trouble loading, refresh to try again."
            })
        ]
    });

});
parcelRegister("5cJpv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ca14c45c100e79f$export$2e2bcd8739ae039);
/* eslint-disable @repo/internal/styles/no-exported-styles */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $d4qUE = parcelRequire("d4qUE");

var $5QEVY = parcelRequire("5QEVY");
const $3ca14c45c100e79f$var$flexGrowMap = {
    hug: (0, $d4qUE.xcss)({
        flexGrow: 0
    }),
    fill: (0, $d4qUE.xcss)({
        width: '100%',
        flexGrow: 1
    })
};
/**
 * __Stack__
 *
 * Stack is a primitive component based on flexbox that manages the block layout of direct children.
 *
 * @example
 * ```tsx
 *  <Stack>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *    <Box padding="space.100" backgroundColor="neutral"></Box>
 *  </Stack>
 * ```
 *
 */ const $3ca14c45c100e79f$var$Stack = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)(({ as: as, alignInline: alignItems, alignBlock: alignBlock = 'stretch', spread: spread, grow: grow, space: space, children: children, testId: testId, xcss: xcss, role: role }, ref)=>{
    const justifyContent = spread || alignBlock;
    return (0, $byn9U.jsx)((0, $5QEVY.default), {
        as: as,
        role: role,
        gap: space,
        direction: "column",
        alignItems: alignItems,
        justifyContent: justifyContent,
        xcss: grow ? [
            $3ca14c45c100e79f$var$flexGrowMap[grow],
            ...Array.isArray(xcss) ? xcss : [
                xcss
            ]
        ] : // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss,
        testId: testId,
        ref: ref
    }, children);
}));
$3ca14c45c100e79f$var$Stack.displayName = 'Stack';
var $3ca14c45c100e79f$export$2e2bcd8739ae039 = $3ca14c45c100e79f$var$Stack;

});

parcelRegister("ejlaX", function(module, exports) {
module.exports = new URL("ErrorIcon.12961569.svg", import.meta.url).toString();

});


parcelRegister("7uxb7", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $57451242ed9fb2ac$export$b08b517936747730);

var $379fO = parcelRequire("379fO");
var $5cJpv = parcelRequire("5cJpv");
var $d4qUE = parcelRequire("d4qUE");

var $hvCdF = parcelRequire("hvCdF");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $57451242ed9fb2ac$var$spinnerWrapperStyles = (0, $d4qUE.xcss)({
    height: 'size.1000'
});
const $57451242ed9fb2ac$var$loadingTextStyles = (0, $d4qUE.xcss)({
    fontSize: '1rem',
    color: 'color.text.subtle'
});
const $57451242ed9fb2ac$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)((0, $5cJpv.default), {
        alignBlock: "center",
        alignInline: "center",
        space: "space.200",
        xcss: $57451242ed9fb2ac$var$spinnerWrapperStyles,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hvCdF.default), {
                size: "large"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
                xcss: $57451242ed9fb2ac$var$loadingTextStyles,
                children: "Loading..."
            })
        ]
    });

});


parcelRegister("9nseh", function(module, exports) {

$parcel$export(module.exports, "CustomNoOptionsMessage", () => $6d3c28c906065e8c$export$3090afcd3ab1284d);

var $379fO = parcelRequire("379fO");
var $5cJpv = parcelRequire("5cJpv");
var $d4qUE = parcelRequire("d4qUE");
parcelRequire("eUqFw");

var $akqqP = parcelRequire("akqqP");

var $lHkHI = parcelRequire("lHkHI");
const $6d3c28c906065e8c$var$wrapperStyles = (0, $d4qUE.xcss)({
    paddingBlock: 'space.500'
});
const $6d3c28c906065e8c$var$mainTextStyles = (0, $d4qUE.xcss)({
    fontSize: '1rem',
    fontWeight: 600,
    textAlign: 'center',
    color: 'color.text'
});
const $6d3c28c906065e8c$var$secondaryTextStyles = (0, $d4qUE.xcss)({
    fontSize: '0.875rem',
    fontWeight: 400,
    color: 'color.text.subtle'
});
const $6d3c28c906065e8c$export$bd3100ca46300401 = (_ref)=>{
    let { showNoSearchResultsText: showNoSearchResultsText } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $5cJpv.default), {
        alignBlock: "center",
        alignInline: "center",
        space: "space.250",
        xcss: $6d3c28c906065e8c$var$wrapperStyles,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)("img", {
                src: (0, (/*@__PURE__*/$parcel$interopDefault($akqqP))),
                alt: "",
                width: "120px"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $5cJpv.default), {
                space: "space.100",
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
                        xcss: $6d3c28c906065e8c$var$mainTextStyles,
                        children: "No options found"
                    }),
                    showNoSearchResultsText && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
                        xcss: $6d3c28c906065e8c$var$secondaryTextStyles,
                        children: "Try searching for another"
                    })
                ]
            })
        ]
    });
};
const $6d3c28c906065e8c$export$3090afcd3ab1284d = (_ref2)=>{
    let { selectProps: { options: options } } = _ref2;
    // Only display secondary no options text when there are dropdown options (option 2 above)
    const showNoSearchResultsText = options.length > 0;
    return /*#__PURE__*/ (0, $lHkHI.jsx)($6d3c28c906065e8c$export$bd3100ca46300401, {
        showNoSearchResultsText: showNoSearchResultsText
    });
};

});
parcelRegister("akqqP", function(module, exports) {
module.exports = new URL("SearchIcon.be9252ea.svg", import.meta.url).toString();

});


parcelRegister("97C27", function(module, exports) {

$parcel$export(module.exports, "CustomOption", () => $6a42451dad506dc6$export$bf9b4e708cea1760);
$parcel$export(module.exports, "CustomOptionMobile", () => $6a42451dad506dc6$export$5dc49a6dd2436e4e);

var $5zQU9 = parcelRequire("5zQU9");

var $379fO = parcelRequire("379fO");
var $4xAW3 = parcelRequire("4xAW3");
var $5cJpv = parcelRequire("5cJpv");
var $d4qUE = parcelRequire("d4qUE");

var $cXxSf = parcelRequire("cXxSf");
var $6Wmpx = parcelRequire("6Wmpx");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $6a42451dad506dc6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6a42451dad506dc6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6a42451dad506dc6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6a42451dad506dc6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $6a42451dad506dc6$var$resultsCountTextStyles = (0, $d4qUE.xcss)({
    color: 'color.text.subtlest',
    fontSize: '0.75rem'
});
const $6a42451dad506dc6$var$descriptionTextStyles = (0, $d4qUE.xcss)({
    color: 'color.text.subtlest',
    fontSize: '0.75rem'
});
const $6a42451dad506dc6$var$optionWrapperStyles = (0, $d4qUE.xcss)({
    // Enable wrapping text within the option container
    whiteSpace: 'normal',
    color: 'color.text'
});
const $6a42451dad506dc6$var$optionSelectedStyles = (0, $d4qUE.xcss)({
    color: 'color.text.selected'
});
const $6a42451dad506dc6$var$iconBeforeStyles = (0, $d4qUE.xcss)({
    // Prevent the icon from shrinking when the sibling flex items are too wide
    flexShrink: 0
});
const $6a42451dad506dc6$var$iconAfterStyles = (0, $d4qUE.xcss)({
    // Allow flex item to grow so we align it in the center of the remaining space
    flexGrow: 1
});
const $6a42451dad506dc6$export$d4f91bf0d7ad43a0 = (_ref)=>{
    let { label: label, resultsCount: resultsCount, description: description, iconBefore: iconBefore, iconAfter: iconAfter, isSelected: isSelected } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4xAW3.default), {
        spread: "space-between",
        space: "space.100",
        alignBlock: "center",
        xcss: [
            $6a42451dad506dc6$var$optionWrapperStyles,
            isSelected && $6a42451dad506dc6$var$optionSelectedStyles
        ],
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4xAW3.default), {
                space: "space.100",
                alignBlock: "center",
                grow: "fill",
                children: [
                    iconBefore && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4xAW3.default), {
                        xcss: $6a42451dad506dc6$var$iconBeforeStyles,
                        children: iconBefore
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $5cJpv.default), {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
                                children: label
                            }),
                            description && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
                                xcss: $6a42451dad506dc6$var$descriptionTextStyles,
                                children: description
                            })
                        ]
                    }),
                    iconAfter && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4xAW3.default), {
                        alignInline: "center",
                        xcss: $6a42451dad506dc6$var$iconAfterStyles,
                        children: iconAfter
                    })
                ]
            }),
            resultsCount !== undefined && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $379fO.default), {
                xcss: $6a42451dad506dc6$var$resultsCountTextStyles,
                children: [
                    "[",
                    resultsCount,
                    "]"
                ]
            })
        ]
    });
};
const $6a42451dad506dc6$var$multiSelectDesktopStyles = (0, $d4qUE.xcss)({
    paddingBlock: 'space.075'
});
const $6a42451dad506dc6$var$singleSelectDesktopStyles = (0, $d4qUE.xcss)({
    paddingBlock: 'space.050'
});
const $6a42451dad506dc6$var$mobileWrapperStyles = (0, $d4qUE.xcss)({
    paddingBlock: 'space.150'
});
const $6a42451dad506dc6$var$isMulti = (props)=>props.selectProps.isMulti;
const $6a42451dad506dc6$export$bf9b4e708cea1760 = (props)=>$6a42451dad506dc6$var$isMulti(props) ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cXxSf.CheckboxOption), $6a42451dad506dc6$var$_objectSpread($6a42451dad506dc6$var$_objectSpread({}, props), {}, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
            xcss: $6a42451dad506dc6$var$multiSelectDesktopStyles,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)($6a42451dad506dc6$export$d4f91bf0d7ad43a0, $6a42451dad506dc6$var$_objectSpread({}, props.data))
        })
    })) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6Wmpx.c).Option, $6a42451dad506dc6$var$_objectSpread($6a42451dad506dc6$var$_objectSpread({}, props), {}, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
            xcss: $6a42451dad506dc6$var$singleSelectDesktopStyles,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)($6a42451dad506dc6$export$d4f91bf0d7ad43a0, $6a42451dad506dc6$var$_objectSpread($6a42451dad506dc6$var$_objectSpread({}, props.data), {}, {
                isSelected: props.isSelected
            }))
        })
    }));
const $6a42451dad506dc6$export$5dc49a6dd2436e4e = (props)=>$6a42451dad506dc6$var$isMulti(props) ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cXxSf.CheckboxOption), $6a42451dad506dc6$var$_objectSpread($6a42451dad506dc6$var$_objectSpread({}, props), {}, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
            xcss: $6a42451dad506dc6$var$mobileWrapperStyles,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)($6a42451dad506dc6$export$d4f91bf0d7ad43a0, $6a42451dad506dc6$var$_objectSpread({}, props.data))
        })
    })) : /*#__PURE__*/ /**
 * Type cast is required as RadioOption doesn't support generic types in the current version of @atlaskit/select
 * This will be cleaned up in DSP-17354, once @atlaskit/select is bumped
 */ (0, $lHkHI.jsx)((0, $cXxSf.RadioOption), $6a42451dad506dc6$var$_objectSpread($6a42451dad506dc6$var$_objectSpread({}, props), {}, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
            xcss: $6a42451dad506dc6$var$mobileWrapperStyles,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)($6a42451dad506dc6$export$d4f91bf0d7ad43a0, $6a42451dad506dc6$var$_objectSpread({}, props.data))
        })
    }));

});
parcelRegister("cXxSf", function(module, exports) {

$parcel$export(module.exports, "CheckboxOption", () => $96f5455f1fde1c33$export$d40cc97ecda916f9);
$parcel$export(module.exports, "RadioOption", () => $96f5455f1fde1c33$export$82ab7168879267a7);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $68W6z = parcelRequire("68W6z");

var $hI2Zj = parcelRequire("hI2Zj");

const $96f5455f1fde1c33$var$getPrimitiveStyles = (props)=>{
    const { cx: cx, className: className, getStyles: getStyles, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected } = props;
    const baseStyles = {
        alignItems: 'center',
        backgroundColor: isFocused ? `var(--ds-background-neutral-subtle-hovered, ${0, $ab6d6432a4c55680$export$9fdfb749e33cdf97})` : 'transparent',
        color: isDisabled ? "var(--ds-text-disabled, inherit)" : 'inherit',
        display: 'flex ',
        paddingBottom: "var(--ds-space-050, 4px)",
        paddingLeft: "var(--ds-space-200, 16px)",
        paddingTop: "var(--ds-space-050, 4px)",
        // This 'none' needs to be present to ensure that style is not applied when
        // the option is selected but not focused.
        boxShadow: isFocused ? `inset 2px 0px 0px ${`var(--ds-border-focused, ${0, $ab6d6432a4c55680$export$b3de0ae08da2ce64})`}` : 'none',
        ':active': {
            backgroundColor: `var(--ds-background-neutral-subtle-pressed, ${(0, $ab6d6432a4c55680$export$3e51e8f1440314ba)})`
        },
        '@media screen and (-ms-high-contrast: active)': {
            borderLeft: isFocused ? '2px solid transparent' : ''
        }
    };
    const augmentedStyles = (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...getStyles('option', props),
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        ...baseStyles
    });
    const bemClasses = {
        option: true,
        'option--is-disabled': isDisabled,
        'option--is-focused': isFocused,
        'option--is-selected': isSelected
    };
    // maintain react-select API
    return [
        augmentedStyles,
        cx(bemClasses, className)
    ];
};
// state of the parent option
// the primary color represents the outer or background element
const $96f5455f1fde1c33$var$getPrimaryColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $ab6d6432a4c55680$export$8c13c2ee36917869})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $ab6d6432a4c55680$export$8d43898f60b96a82})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $ab6d6432a4c55680$export$8c13c2ee36917869})`;
    else if (isActive) return `var(--ds-background-selected-pressed, ${0, $ab6d6432a4c55680$export$8c13c2ee36917869})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $ab6d6432a4c55680$export$e62e8919cca44969})`;
    else if (isFocused) return `var(--ds-surface, ${0, $ab6d6432a4c55680$export$29a4f05edc054374})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $ab6d6432a4c55680$export$b3de0ae08da2ce64})`;
    return `var(--ds-background-neutral, ${0, $ab6d6432a4c55680$export$29a4f05edc054374})`;
};
// the secondary color represents the radio dot or checkmark
const $96f5455f1fde1c33$var$getSecondaryColor = ({ isActive: isActive, isDisabled: isDisabled, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-text-disabled, ${0, $ab6d6432a4c55680$export$5f71e19f3a7ad9de})`;
    else if (isActive && isSelected && !isDisabled) return `var(--ds-surface, ${0, $ab6d6432a4c55680$export$b3de0ae08da2ce64})`;
    else if (!isSelected) return 'transparent';
    return `var(--ds-surface, ${0, $ab6d6432a4c55680$export$29a4f05edc054374})`;
};
// the border color surrounds the checkbox/radio
const $96f5455f1fde1c33$var$getBorderColor = ({ isActive: isActive, isDisabled: isDisabled, isFocused: isFocused, isSelected: isSelected })=>{
    if (isDisabled && isSelected) return `var(--ds-background-disabled, ${0, $ab6d6432a4c55680$export$b3de0ae08da2ce64})`;
    else if (isDisabled) return `var(--ds-background-disabled, ${0, $ab6d6432a4c55680$export$d6447c357493214f})`;
    else if (isSelected && isActive) return `var(--ds-background-selected-bold-pressed, ${0, $ab6d6432a4c55680$export$b3de0ae08da2ce64})`;
    else if (isActive) return `var(--ds-background-selected-bold, ${0, $ab6d6432a4c55680$export$b3de0ae08da2ce64})`;
    else if (isFocused && isSelected) return `var(--ds-background-selected-bold-hovered, ${0, $ab6d6432a4c55680$export$b3de0ae08da2ce64})`;
    else if (isFocused) return `var(--ds-border-input, ${0, $ab6d6432a4c55680$export$d6447c357493214f})`;
    else if (isSelected) return `var(--ds-background-selected-bold, ${0, $ab6d6432a4c55680$export$b3de0ae08da2ce64})`;
    return `var(--ds-border-input, ${0, $ab6d6432a4c55680$export$d6447c357493214f})`;
};
const $96f5455f1fde1c33$var$baseIconStyles = (0, $byn9U.css)({
    display: 'flex ',
    alignItems: 'center',
    flexShrink: 0,
    paddingInlineEnd: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-unsafe-selectors
    '& svg rect, & svg circle:first-of-type': {
        strokeLinejoin: 'round',
        strokeWidth: "var(--ds-border-width, 1px)"
    }
});
const $96f5455f1fde1c33$var$baseOptionStyles = (0, $byn9U.css)({
    flexGrow: 1,
    overflowX: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
// eslint-disable-next-line @repo/internal/react/no-class-components
class $96f5455f1fde1c33$var$ControlOption extends (0, $eUqFw.Component) {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            isActive: false
        });
        (0, $5zQU9.default)(this, "onMouseDown", ()=>this.setState({
                isActive: true
            }));
        (0, $5zQU9.default)(this, "onMouseUp", ()=>this.setState({
                isActive: false
            }));
        (0, $5zQU9.default)(this, "onMouseLeave", ()=>this.setState({
                isActive: false
            }));
    }
    render() {
        const { getStyles: getStyles, Icon: Icon, children: children, innerProps: innerProps, innerRef: innerRef, ...rest } = this.props;
        // prop assignment
        const props = {
            ...innerProps,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseLeave: this.onMouseLeave
        };
        const [styles, classes] = $96f5455f1fde1c33$var$getPrimitiveStyles({
            getStyles: getStyles,
            ...rest
        });
        return(// These need to remain this way because `react-select` passes props with
        // styles inside, and that must be done dynamically.
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage, @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        (0, $byn9U.jsx)("div", (0, $kU09D.default)({
            css: styles,
            className: classes,
            ref: innerRef
        }, props), (0, $byn9U.jsx)("div", {
            css: [
                $96f5455f1fde1c33$var$baseIconStyles,
                // Here we are adding a border to the Checkbox and Radio SVG icons
                // This is an a11y fix for Select only for now but it may be rolled
                // into the `@atlaskit/icon` package's Checkbox and Radio SVGs later
                // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                {
                    // This can eventually be changed to static styles that are
                    // applied conditionally (e.g. `isActive && activeBorderStyles`),
                    // but considering there are multiple instances of `react-select`
                    // requiring styles to be generated dynamically, it seemed like a
                    // low priority.
                    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles
                    '& svg rect, & svg circle:first-of-type': {
                        stroke: $96f5455f1fde1c33$var$getBorderColor({
                            ...this.props,
                            ...this.state
                        })
                    }
                }
            ]
        }, !!Icon ? (0, $byn9U.jsx)(Icon, {
            label: "",
            primaryColor: $96f5455f1fde1c33$var$getPrimaryColor({
                ...this.props,
                ...this.state
            }),
            secondaryColor: $96f5455f1fde1c33$var$getSecondaryColor({
                ...this.props,
                ...this.state
            }),
            isFacadeDisabled: true
        }) : null), (0, $byn9U.jsx)("div", {
            css: $96f5455f1fde1c33$var$baseOptionStyles
        }, children)));
    }
}
const $96f5455f1fde1c33$export$d40cc97ecda916f9 = (props)=>(0, $byn9U.jsx)($96f5455f1fde1c33$var$ControlOption, (0, $kU09D.default)({
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($68W6z)))
    }, props));
const $96f5455f1fde1c33$export$82ab7168879267a7 = (props)=>// TODO https://product-fabric.atlassian.net/browse/DSP-20769
    // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons, @repo/internal/react/no-unsafe-spread-props
    (0, $byn9U.jsx)($96f5455f1fde1c33$var$ControlOption, (0, $kU09D.default)({
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hI2Zj)))
    }, props));

});
parcelRegister("68W6z", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $47908fdf81541ed9$var$_react = $47908fdf81541ed9$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $47908fdf81541ed9$var$_checkboxChecked = $47908fdf81541ed9$var$_interopRequireDefault((parcelRequire("6kh14")));
function $47908fdf81541ed9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $47908fdf81541ed9$var$CheckboxIcon = (props)=>/*#__PURE__*/ $47908fdf81541ed9$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="12" height="12" x="6" y="6" fill="currentcolor" rx="2"/><path fill="inherit" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $47908fdf81541ed9$var$_checkboxChecked.default
    }));
$47908fdf81541ed9$var$CheckboxIcon.displayName = 'CheckboxIcon';
var $47908fdf81541ed9$var$_default = module.exports.default = $47908fdf81541ed9$var$CheckboxIcon;

});
parcelRegister("6kh14", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d440225cc59c6a59918c0efc489d2095>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $49b1cf6ba662a05d$var$_react = $49b1cf6ba662a05d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $49b1cf6ba662a05d$var$_UNSAFE_baseNew = $49b1cf6ba662a05d$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $49b1cf6ba662a05d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckboxChecked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Reserved for interactive checkbox experiences. Consider using the checkbox component.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $49b1cf6ba662a05d$var$CheckboxCheckedIcon = (props)=>/*#__PURE__*/ $49b1cf6ba662a05d$var$_react.default.createElement($49b1cf6ba662a05d$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3 1a2 2 0 0 0-2 2v10a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2zm9.326 4.48-1.152-.96L6.75 9.828 4.826 7.52l-1.152.96 2.5 3a.75.75 0 0 0 1.152 0z" clip-rule="evenodd"/>`
    }, props));
$49b1cf6ba662a05d$var$CheckboxCheckedIcon.displayName = 'CheckboxCheckedIcon';
var $49b1cf6ba662a05d$var$_default = module.exports.default = $49b1cf6ba662a05d$var$CheckboxCheckedIcon;

});


parcelRegister("hI2Zj", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ce48dd0ef52f3d83$var$_react = $ce48dd0ef52f3d83$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $ce48dd0ef52f3d83$var$_radioChecked = $ce48dd0ef52f3d83$var$_interopRequireDefault((parcelRequire("jMWt5")));
function $ce48dd0ef52f3d83$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ce48dd0ef52f3d83$var$RadioIcon = (props)=>/*#__PURE__*/ $ce48dd0ef52f3d83$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="6" fill="currentcolor"/><circle cx="12" cy="12" r="2" fill="inherit"/></g></svg>`
    }, props, {
        newIcon: $ce48dd0ef52f3d83$var$_radioChecked.default
    }));
$ce48dd0ef52f3d83$var$RadioIcon.displayName = 'RadioIcon';
var $ce48dd0ef52f3d83$var$_default = module.exports.default = $ce48dd0ef52f3d83$var$RadioIcon;

});
parcelRegister("jMWt5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::aa46e6d801ee3a3fb5cceaf32be49fab>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e67fda95bfbafb15$var$_react = $e67fda95bfbafb15$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e67fda95bfbafb15$var$_UNSAFE_baseNew = $e67fda95bfbafb15$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $e67fda95bfbafb15$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "RadioChecked".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for the selected state of radio controls.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e67fda95bfbafb15$var$RadioCheckedIcon = (props)=>/*#__PURE__*/ $e67fda95bfbafb15$var$_react.default.createElement($e67fda95bfbafb15$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 5a3 3 0 1 0 0 6 3 3 0 0 0 0-6" clip-rule="evenodd"/>`
    }, props));
$e67fda95bfbafb15$var$RadioCheckedIcon.displayName = 'RadioCheckedIcon';
var $e67fda95bfbafb15$var$_default = module.exports.default = $e67fda95bfbafb15$var$RadioCheckedIcon;

});





parcelRegister("i6Rym", function(module, exports) {

$parcel$export(module.exports, "SelectTrigger", () => $d2f2541a3e41b88e$export$3ac1e88a1c0b9f1);

var $5zQU9 = parcelRequire("5zQU9");

var $drftW = parcelRequire("drftW");

var $4xAW3 = parcelRequire("4xAW3");
var $d4qUE = parcelRequire("d4qUE");

var $FHhXl = parcelRequire("FHhXl");

var $eUqFw = parcelRequire("eUqFw");

var $64ZkH = parcelRequire("64ZkH");

var $lMIGT = parcelRequire("lMIGT");

var $lHkHI = parcelRequire("lHkHI");
function $d2f2541a3e41b88e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d2f2541a3e41b88e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d2f2541a3e41b88e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d2f2541a3e41b88e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $d2f2541a3e41b88e$var$buttonStyles = (0, $d4qUE.xcss)({
    cursor: 'pointer',
    paddingInlineStart: 'space.150',
    paddingInlineEnd: 'space.050',
    paddingBlock: 'space.050',
    borderRadius: 'border.radius',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    color: 'color.text',
    backgroundColor: 'color.background.neutral',
    fontSize: '0.875rem',
    fontWeight: '400',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.pressed'
    }
});
const $d2f2541a3e41b88e$var$selectedStyles = (0, $d4qUE.xcss)({
    color: 'color.text.selected',
    backgroundColor: 'color.background.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $d2f2541a3e41b88e$var$flipIconStyles = (0, $d4qUE.xcss)({
    transform: 'rotate(180deg)'
});
const $d2f2541a3e41b88e$var$SelectTriggerInternal = (_ref, ref)=>{
    let { triggerProps: triggerProps, filterLabel: filterLabel, isSelected: isSelected, isExpanded: isExpanded, numberOfSelections: numberOfSelections, firstSelectedOptionLabel: firstSelectedOptionLabel, onClick: onClick } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $FHhXl.default), $d2f2541a3e41b88e$var$_objectSpread($d2f2541a3e41b88e$var$_objectSpread({}, triggerProps), {}, {
        ref: (0, $64ZkH.mergeRefs)(ref, triggerProps.ref),
        onClick: onClick,
        "data-testId": (0, $lMIGT.TEST_IDS).FACET_DROPDOWN_TRIGGERS,
        xcss: [
            $d2f2541a3e41b88e$var$buttonStyles,
            isSelected && $d2f2541a3e41b88e$var$selectedStyles
        ],
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
                children: [
                    firstSelectedOptionLabel || filterLabel,
                    numberOfSelections > 1 && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                        children: [
                            ', ',
                            /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                                children: "+".concat(numberOfSelections - 1)
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4xAW3.default), {
                xcss: isExpanded ? $d2f2541a3e41b88e$var$flipIconStyles : undefined,
                as: "span",
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($drftW))), {
                    label: ""
                })
            })
        ]
    }));
};
const $d2f2541a3e41b88e$export$3ac1e88a1c0b9f1 = /*#__PURE__*/ (0, $eUqFw.forwardRef)($d2f2541a3e41b88e$var$SelectTriggerInternal);

});
parcelRegister("64ZkH", function(module, exports) {

$parcel$export(module.exports, "mergeRefs", () => $46d2b136008755d3$export$c9058316764c140e);
/**
 * Assigns the node to all the refs passed in the argument.
 *
 * Overview + use case: https://www.loom.com/share/b6a77cda2fad46be9641187e18c820ea
 *
 * @param refs: An array of refs (as function or ref object)
 */ const $46d2b136008755d3$export$c9058316764c140e = function mergeRefs() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++)refs[_key] = arguments[_key];
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === 'function') ref(value);
            else if (ref !== null && ref !== undefined) ref.current = value;
        });
    };
};

});


parcelRegister("2xDeC", function(module, exports) {

$parcel$export(module.exports, "isMultiSelectOptions", () => $1d9d1907a3093ef8$export$535c9d690f790b0a);
$parcel$export(module.exports, "getGroupedOptions", () => $1d9d1907a3093ef8$export$721c3d9226425f9c);

var $5zQU9 = parcelRequire("5zQU9");
function $1d9d1907a3093ef8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1d9d1907a3093ef8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1d9d1907a3093ef8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1d9d1907a3093ef8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $1d9d1907a3093ef8$export$535c9d690f790b0a = (optionOrOptions)=>Array.isArray(optionOrOptions);
const $1d9d1907a3093ef8$export$8793edee2d425525 = ()=>{};
const $1d9d1907a3093ef8$var$isOptionGroup = (option)=>Object.hasOwn(option, 'options');
const $1d9d1907a3093ef8$export$721c3d9226425f9c = (_ref)=>{
    let { options: options, selectedOptions: selectedOptions, addSelectedFirst: addSelectedFirst } = _ref;
    // If there are no selections, return the options as they are
    if (!selectedOptions.length || !addSelectedFirst) return options;
    const newOptions = [];
    // Using a Set to efficiently check if the option was already added to `newOptions`
    const selectedOptionKeys = new Set(selectedOptions.map((option)=>option.value));
    // New group for the selected options
    const selectedOptionsGroup = {
        label: 'SELECTED',
        options: selectedOptions
    };
    // The `ALL` option group to display at the end
    const catchAllOptionGroup = {
        label: 'ALL',
        options: []
    };
    // Add the selected options first
    newOptions.push(selectedOptionsGroup);
    // Add the rest of the options, excluding the selected options
    options.forEach((optionOrOptionGroup)=>{
        if ($1d9d1907a3093ef8$var$isOptionGroup(optionOrOptionGroup)) newOptions.push($1d9d1907a3093ef8$var$_objectSpread($1d9d1907a3093ef8$var$_objectSpread({}, optionOrOptionGroup), {}, {
            options: optionOrOptionGroup.options.filter((opt)=>!selectedOptionKeys.has(opt.value))
        }));
        else if (!selectedOptionKeys.has(optionOrOptionGroup.value)) catchAllOptionGroup.options.push(optionOrOptionGroup);
    });
    if (catchAllOptionGroup.options.length > 0) newOptions.push(catchAllOptionGroup);
    return newOptions;
};
const $1d9d1907a3093ef8$export$81a09248846b5536 = (selectedFilterId, filterDefinitions)=>{
    return filterDefinitions.find((filterDefinition)=>filterDefinition.filterId === selectedFilterId);
};
const $1d9d1907a3093ef8$export$4a504102488599aa = (filterId, filterOptions)=>{
    var _filterOptions$filter;
    return filterId ? (_filterOptions$filter = filterOptions === null || filterOptions === void 0 ? void 0 : filterOptions[filterId]) !== null && _filterOptions$filter !== void 0 ? _filterOptions$filter : [] : [];
};

});


parcelRegister("1iS0A", function(module, exports) {

$parcel$export(module.exports, "useIsMobile", () => $0f315dd2b679199f$export$2b96349243a56116);

var $clKQE = parcelRequire("clKQE");

var $eUqFw = parcelRequire("eUqFw");
const $0f315dd2b679199f$export$2b96349243a56116 = ()=>{
    var _mq$matches;
    const mq = (0, $clKQE.UNSAFE_useMediaQuery)('below.sm', (event)=>setIsMobile(event.matches));
    const [isMobile, setIsMobile] = (0, $eUqFw.useState)((_mq$matches = mq === null || mq === void 0 ? void 0 : mq.matches) !== null && _mq$matches !== void 0 ? _mq$matches : false);
    return isMobile;
};

});
parcelRegister("clKQE", function(module, exports) {

$parcel$export(module.exports, "UNSAFE_useMediaQuery", () => $8fdbc9482aadcb23$export$49e55ae2c03d6045);

var $eUqFw = parcelRequire("eUqFw");

var $7Ihxv = parcelRequire("7Ihxv");

var $8oBYp = parcelRequire("8oBYp");
var $8fdbc9482aadcb23$var$_window, $8fdbc9482aadcb23$var$_window$matchMedia, $8fdbc9482aadcb23$var$_window2, $8fdbc9482aadcb23$var$_window2$matchMedia, $8fdbc9482aadcb23$var$_window3, $8fdbc9482aadcb23$var$_window3$matchMedia, $8fdbc9482aadcb23$var$_window4, $8fdbc9482aadcb23$var$_window4$matchMedia, $8fdbc9482aadcb23$var$_window5, $8fdbc9482aadcb23$var$_window5$matchMedia, $8fdbc9482aadcb23$var$_window6, $8fdbc9482aadcb23$var$_window6$matchMedia, $8fdbc9482aadcb23$var$_window7, $8fdbc9482aadcb23$var$_window7$matchMedia, $8fdbc9482aadcb23$var$_window8, $8fdbc9482aadcb23$var$_window8$matchMedia, $8fdbc9482aadcb23$var$_window9, $8fdbc9482aadcb23$var$_window9$matchMedia, $8fdbc9482aadcb23$var$_window10, $8fdbc9482aadcb23$var$_window10$matchMedia, $8fdbc9482aadcb23$var$_window11, $8fdbc9482aadcb23$var$_window11$matchMedia;
const $8fdbc9482aadcb23$var$queries = {
    'above.xxs': typeof window === 'undefined' ? undefined : ($8fdbc9482aadcb23$var$_window = window) === null || $8fdbc9482aadcb23$var$_window === void 0 ? void 0 : ($8fdbc9482aadcb23$var$_window$matchMedia = $8fdbc9482aadcb23$var$_window.matchMedia) === null || $8fdbc9482aadcb23$var$_window$matchMedia === void 0 ? void 0 : $8fdbc9482aadcb23$var$_window$matchMedia.call($8fdbc9482aadcb23$var$_window, (0, $8oBYp.UNSAFE_media).above.xxs.replace('@media ', '').trim()),
    'above.xs': typeof window === 'undefined' ? undefined : ($8fdbc9482aadcb23$var$_window2 = window) === null || $8fdbc9482aadcb23$var$_window2 === void 0 ? void 0 : ($8fdbc9482aadcb23$var$_window2$matchMedia = $8fdbc9482aadcb23$var$_window2.matchMedia) === null || $8fdbc9482aadcb23$var$_window2$matchMedia === void 0 ? void 0 : $8fdbc9482aadcb23$var$_window2$matchMedia.call($8fdbc9482aadcb23$var$_window2, (0, $8oBYp.UNSAFE_media).above.xs.replace('@media ', '').trim()),
    'above.sm': typeof window === 'undefined' ? undefined : ($8fdbc9482aadcb23$var$_window3 = window) === null || $8fdbc9482aadcb23$var$_window3 === void 0 ? void 0 : ($8fdbc9482aadcb23$var$_window3$matchMedia = $8fdbc9482aadcb23$var$_window3.matchMedia) === null || $8fdbc9482aadcb23$var$_window3$matchMedia === void 0 ? void 0 : $8fdbc9482aadcb23$var$_window3$matchMedia.call($8fdbc9482aadcb23$var$_window3, (0, $8oBYp.UNSAFE_media).above.sm.replace('@media ', '').trim()),
    'above.md': typeof window === 'undefined' ? undefined : ($8fdbc9482aadcb23$var$_window4 = window) === null || $8fdbc9482aadcb23$var$_window4 === void 0 ? void 0 : ($8fdbc9482aadcb23$var$_window4$matchMedia = $8fdbc9482aadcb23$var$_window4.matchMedia) === null || $8fdbc9482aadcb23$var$_window4$matchMedia === void 0 ? void 0 : $8fdbc9482aadcb23$var$_window4$matchMedia.call($8fdbc9482aadcb23$var$_window4, (0, $8oBYp.UNSAFE_media).above.md.replace('@media ', '').trim()),
    'above.lg': typeof window === 'undefined' ? undefined : ($8fdbc9482aadcb23$var$_window5 = window) === null || $8fdbc9482aadcb23$var$_window5 === void 0 ? void 0 : ($8fdbc9482aadcb23$var$_window5$matchMedia = $8fdbc9482aadcb23$var$_window5.matchMedia) === null || $8fdbc9482aadcb23$var$_window5$matchMedia === void 0 ? void 0 : $8fdbc9482aadcb23$var$_window5$matchMedia.call($8fdbc9482aadcb23$var$_window5, (0, $8oBYp.UNSAFE_media).above.lg.replace('@media ', '').trim()),
    'above.xl': typeof window === 'undefined' ? undefined : ($8fdbc9482aadcb23$var$_window6 = window) === null || $8fdbc9482aadcb23$var$_window6 === void 0 ? void 0 : ($8fdbc9482aadcb23$var$_window6$matchMedia = $8fdbc9482aadcb23$var$_window6.matchMedia) === null || $8fdbc9482aadcb23$var$_window6$matchMedia === void 0 ? void 0 : $8fdbc9482aadcb23$var$_window6$matchMedia.call($8fdbc9482aadcb23$var$_window6, (0, $8oBYp.UNSAFE_media).above.xl.replace('@media ', '').trim()),
    'below.xs': typeof window === 'undefined' ? undefined : ($8fdbc9482aadcb23$var$_window7 = window) === null || $8fdbc9482aadcb23$var$_window7 === void 0 ? void 0 : ($8fdbc9482aadcb23$var$_window7$matchMedia = $8fdbc9482aadcb23$var$_window7.matchMedia) === null || $8fdbc9482aadcb23$var$_window7$matchMedia === void 0 ? void 0 : $8fdbc9482aadcb23$var$_window7$matchMedia.call($8fdbc9482aadcb23$var$_window7, (0, $8oBYp.UNSAFE_media).below.xs.replace('@media ', '').trim()),
    'below.sm': typeof window === 'undefined' ? undefined : ($8fdbc9482aadcb23$var$_window8 = window) === null || $8fdbc9482aadcb23$var$_window8 === void 0 ? void 0 : ($8fdbc9482aadcb23$var$_window8$matchMedia = $8fdbc9482aadcb23$var$_window8.matchMedia) === null || $8fdbc9482aadcb23$var$_window8$matchMedia === void 0 ? void 0 : $8fdbc9482aadcb23$var$_window8$matchMedia.call($8fdbc9482aadcb23$var$_window8, (0, $8oBYp.UNSAFE_media).below.sm.replace('@media ', '').trim()),
    'below.md': typeof window === 'undefined' ? undefined : ($8fdbc9482aadcb23$var$_window9 = window) === null || $8fdbc9482aadcb23$var$_window9 === void 0 ? void 0 : ($8fdbc9482aadcb23$var$_window9$matchMedia = $8fdbc9482aadcb23$var$_window9.matchMedia) === null || $8fdbc9482aadcb23$var$_window9$matchMedia === void 0 ? void 0 : $8fdbc9482aadcb23$var$_window9$matchMedia.call($8fdbc9482aadcb23$var$_window9, (0, $8oBYp.UNSAFE_media).below.md.replace('@media ', '').trim()),
    'below.lg': typeof window === 'undefined' ? undefined : ($8fdbc9482aadcb23$var$_window10 = window) === null || $8fdbc9482aadcb23$var$_window10 === void 0 ? void 0 : ($8fdbc9482aadcb23$var$_window10$matchMedia = $8fdbc9482aadcb23$var$_window10.matchMedia) === null || $8fdbc9482aadcb23$var$_window10$matchMedia === void 0 ? void 0 : $8fdbc9482aadcb23$var$_window10$matchMedia.call($8fdbc9482aadcb23$var$_window10, (0, $8oBYp.UNSAFE_media).below.lg.replace('@media ', '').trim()),
    'below.xl': typeof window === 'undefined' ? undefined : ($8fdbc9482aadcb23$var$_window11 = window) === null || $8fdbc9482aadcb23$var$_window11 === void 0 ? void 0 : ($8fdbc9482aadcb23$var$_window11$matchMedia = $8fdbc9482aadcb23$var$_window11.matchMedia) === null || $8fdbc9482aadcb23$var$_window11$matchMedia === void 0 ? void 0 : $8fdbc9482aadcb23$var$_window11$matchMedia.call($8fdbc9482aadcb23$var$_window11, (0, $8oBYp.UNSAFE_media).below.xl.replace('@media ', '').trim())
};
const $8fdbc9482aadcb23$export$49e55ae2c03d6045 = (queryString, listener)=>{
    const listenerRef = (0, $eUqFw.useRef)(listener);
    (0, $eUqFw.useEffect)(()=>{
        // Bind the listener if changed so it's called on the next change event; no guarantee on timing.
        listenerRef.current = listener;
    }, [
        listener
    ]);
    /**
   * We explicitly only react to boolean changes for binding our listener
   * Changes to the functional reference are ignored.
   */ const hasListener = !!listener;
    /**
   * The `matchMedia(…)` return value for our breakpoint query.
   */ const mq = $8fdbc9482aadcb23$var$queries[queryString];
    (0, $eUqFw.useLayoutEffect)(()=>{
        listenerRef.current = listener; // Bind the listener now in case the `useEffect` hasn't fired above yet
        if (!mq || !hasListener || !listenerRef.current) return;
        return (0, $7Ihxv.bind)(mq, {
            type: 'change',
            listener: (event)=>{
                // We explicitly call the current version of the function
                return listenerRef.current(event);
            }
        });
    }, // eslint-disable-next-line react-hooks/exhaustive-deps -- explicitly do not trigger the effect on `listener` reference change, only on a boolean representation of it.
    [
        mq,
        hasListener
    ]);
    return mq || null;
};

});
parcelRegister("7Ihxv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = module.exports.bind = void 0;

var $96mhw = parcelRequire("96mhw");
Object.defineProperty(module.exports, "bind", {
    enumerable: true,
    get: function() {
        return $96mhw.bind;
    }
});

var $jpLDT = parcelRequire("jpLDT");
Object.defineProperty(module.exports, "bindAll", {
    enumerable: true,
    get: function() {
        return $jpLDT.bindAll;
    }
});

});
parcelRegister("96mhw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bind = void 0;
function $6a05f5484b034349$var$bind(target, _a) {
    var type = _a.type, listener = _a.listener, options = _a.options;
    target.addEventListener(type, listener, options);
    return function unbind() {
        target.removeEventListener(type, listener, options);
    };
}
module.exports.bind = $6a05f5484b034349$var$bind;

});

parcelRegister("jpLDT", function(module, exports) {
"use strict";
var $e2254ee91521b387$var$__assign = module.exports && module.exports.__assign || function() {
    $e2254ee91521b387$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $e2254ee91521b387$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bindAll = void 0;

var $96mhw = parcelRequire("96mhw");
function $e2254ee91521b387$var$toOptions(value) {
    if (typeof value === 'undefined') return undefined;
    if (typeof value === 'boolean') return {
        capture: value
    };
    return value;
}
function $e2254ee91521b387$var$getBinding(original, sharedOptions) {
    if (sharedOptions == null) return original;
    var binding = $e2254ee91521b387$var$__assign($e2254ee91521b387$var$__assign({}, original), {
        options: $e2254ee91521b387$var$__assign($e2254ee91521b387$var$__assign({}, $e2254ee91521b387$var$toOptions(sharedOptions)), $e2254ee91521b387$var$toOptions(original.options))
    });
    return binding;
}
function $e2254ee91521b387$var$bindAll(target, bindings, sharedOptions) {
    var unbinds = bindings.map(function(original) {
        var binding = $e2254ee91521b387$var$getBinding(original, sharedOptions);
        return (0, $96mhw.bind)(target, binding);
    });
    return function unbindAll() {
        unbinds.forEach(function(unbind) {
            return unbind();
        });
    };
}
module.exports.bindAll = $e2254ee91521b387$var$bindAll;

});





parcelRegister("bvXdy", function(module, exports) {

$parcel$export(module.exports, "MobileFilters", () => $862086535339cf3a$export$37c812733548ec0c);

var $3yJNH = parcelRequire("3yJNH");

var $eUqFw = parcelRequire("eUqFw");

var $cwrgT = parcelRequire("cwrgT");

var $1iS0A = parcelRequire("1iS0A");

var $hoPHw = parcelRequire("hoPHw");

var $ccuBL = parcelRequire("ccuBL");

var $lHkHI = parcelRequire("lHkHI");
const $862086535339cf3a$export$37c812733548ec0c = (_ref)=>{
    var _sortOptions$;
    let { filterDefinitions: filterDefinitions, filterOptions: filterOptions, selectedOptions: selectedOptions, filterStatus: filterStatus, sortOptions: sortOptions, selectedSortOption: selectedSortOption, onSelectedOptionsChange: onSelectedOptionsChange, onSelectedSortOptionChange: onSelectedSortOptionChange, onClearAllFilters: onClearAllFilters, onApplyFilters: onApplyFilters, onCloseMobileDialog: onCloseMobileDialog } = _ref;
    const isMobile = (0, $1iS0A.useIsMobile)();
    const [isFilterDialogOpen, setIsFilterDialogOpen] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (!isMobile) setIsFilterDialogOpen(false);
    }, [
        isMobile
    ]);
    (0, $cwrgT.useScrollLock)(isFilterDialogOpen);
    const handleShowFiltersClicked = (0, $eUqFw.useCallback)(()=>{
        setIsFilterDialogOpen(true);
    }, []);
    const handleCloseDialog = (0, $eUqFw.useCallback)(()=>{
        setIsFilterDialogOpen(false);
        onCloseMobileDialog === null || onCloseMobileDialog === void 0 || onCloseMobileDialog();
    }, [
        onCloseMobileDialog
    ]);
    const handleApplyFiltersClick = (0, $eUqFw.useCallback)(()=>{
        onApplyFilters === null || onApplyFilters === void 0 || onApplyFilters();
        setIsFilterDialogOpen(false);
    }, [
        onApplyFilters
    ]);
    const numberOfSelections = Object.values(selectedOptions !== null && selectedOptions !== void 0 ? selectedOptions : {}).reduce((acc, options)=>acc + options.length, 0) + ((selectedSortOption === null || selectedSortOption === void 0 ? void 0 : selectedSortOption.value) === ((_sortOptions$ = sortOptions[0]) === null || _sortOptions$ === void 0 ? void 0 : _sortOptions$.value) ? 0 : 1);
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ccuBL.ShowFiltersButton), {
                enableSort: sortOptions.length > 0,
                numberOfSelections: numberOfSelections,
                onClick: handleShowFiltersClicked
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3yJNH.default), {
                appear: true,
                children: isFilterDialogOpen && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hoPHw.MobileFilterDialog), {
                    filterDefinitions: filterDefinitions,
                    filterOptions: filterOptions,
                    selectedOptions: selectedOptions,
                    sortOptions: sortOptions,
                    selectedSortOption: selectedSortOption,
                    filterStatus: filterStatus,
                    onClose: handleCloseDialog,
                    onSelectedOptionsChange: onSelectedOptionsChange,
                    onSelectedSortOptionChange: onSelectedSortOptionChange,
                    onClearAllFilters: onClearAllFilters,
                    onApplyFilters: handleApplyFiltersClick
                })
            })
        ]
    });
};

});
parcelRegister("cwrgT", function(module, exports) {

$parcel$export(module.exports, "useScrollLock", () => $91dda0b9659725a5$export$e47ba1b900da5d3b);

var $eUqFw = parcelRequire("eUqFw");
const $91dda0b9659725a5$export$e47ba1b900da5d3b = (isLocked)=>{
    (0, $eUqFw.useEffect)(()=>{
        if (isLocked) {
            const scrollBarWidth = window.innerWidth - document.body.clientWidth;
            // Disable scrolling, but keep space for scrollbar
            document.documentElement.style.overflow = 'hidden';
            document.body.style.overflow = 'hidden';
            document.body.style.paddingRight = "".concat(scrollBarWidth, "px");
            document.body.style.position = 'fixed';
        } else {
            // Re-enable scrolling and remove the reserved space for the scrollbar
            document.documentElement.style.overflow = 'auto';
            document.body.style.overflow = 'auto';
            document.body.style.paddingRight = '0px';
            document.body.style.position = 'static';
        }
    }, [
        isLocked
    ]);
};

});

parcelRegister("hoPHw", function(module, exports) {

$parcel$export(module.exports, "MobileFilterDialog", () => $caacc8509df028cf$export$c6d5badae66b17a6);
/* MobileFilterDialog.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bsLlv = parcelRequire("bsLlv");

var $dkVdA = parcelRequire("dkVdA");

var $asp7r = parcelRequire("asp7r");

var $wRkHA = parcelRequire("wRkHA");

var $6Pq2D = parcelRequire("6Pq2D");


var $jQdk2 = parcelRequire("jQdk2");


var $e5fGH = parcelRequire("e5fGH");

var $iGLLj = parcelRequire("iGLLj");

var $lHkHI = parcelRequire("lHkHI");
const $caacc8509df028cf$var$_excluded = [
    "as",
    "style"
];
function $caacc8509df028cf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $caacc8509df028cf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $caacc8509df028cf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $caacc8509df028cf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// We're not using an @atlaskit/primitives component here as we need to pass the
// className prop to animate the dialog, which is not supported by primitives.
const $caacc8509df028cf$var$DialogWrapper = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "dialog", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $caacc8509df028cf$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $caacc8509df028cf$var$_objectSpread($caacc8509df028cf$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect41sdi _kqsw1n9t _1bsbauwl _4t3i1h89 _94n5idpf _1e0c1txw _2lx21bp4 _19itglyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _13li1koz _qrwq1koz _bfhk6ota",
            __cmplp.className
        ])
    }));
});
const $caacc8509df028cf$export$c6d5badae66b17a6 = (_ref2)=>{
    let { filterDefinitions: filterDefinitions, filterOptions: filterOptions, selectedOptions: selectedOptions = {}, sortOptions: sortOptions, selectedSortOption: selectedSortOption, filterStatus: filterStatus = {}, onSelectedOptionsChange: onSelectedOptionsChange, onSelectedSortOptionChange: onSelectedSortOptionChange, onClose: onClose, onClearAllFilters: _onClearAllFilters, onApplyFilters: onApplyFilters } = _ref2;
    (0, $dkVdA.useCloseOnEscapePress)({
        onClose: onClose
    });
    return(/*#__PURE__*/ // Setting z-index to 500 to match the recommended z-index for Blanket
    // https://atlassian.design/foundations/elevation#z-index
    (0, $lHkHI.jsx)((0, $wRkHA.default), {
        zIndex: 500,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bsLlv.default), {
            isTinted: true,
            onBlanketClicked: onClose,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $asp7r.default), {
                enterFrom: "bottom",
                fade: "in",
                children: (_ref3)=>{
                    let { className: className, ref: ref } = _ref3;
                    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6Pq2D.default), {
                        children: /*#__PURE__*/ (0, $lHkHI.jsxs)($caacc8509df028cf$var$DialogWrapper, {
                            className: className,
                            ref: ref,
                            open: true,
                            "aria-modal": true,
                            "aria-labelledby": (0, $cc783837ce69c797$export$1621c4af050a10c2),
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $iGLLj.TopPanel), {
                                    onClose: onClose,
                                    enableSort: sortOptions.length > 0
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $e5fGH.FiltersPanel), {
                                    filterDefinitions: filterDefinitions,
                                    filterOptions: filterOptions,
                                    selectedOptions: selectedOptions,
                                    selectedSortOption: selectedSortOption,
                                    sortOptions: sortOptions,
                                    filterStatus: filterStatus,
                                    onSelectedOptionsChange: onSelectedOptionsChange,
                                    onSelectedSortOptionChange: onSelectedSortOptionChange
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jQdk2.BottomPanel), {
                                    onApplyFilters: onApplyFilters,
                                    onClearAllFilters: ()=>_onClearAllFilters === null || _onClearAllFilters === void 0 ? void 0 : _onClearAllFilters({
                                            location: 'mobile'
                                        })
                                })
                            ]
                        })
                    });
                }
            })
        })
    }));
};

});
parcelRegister("dkVdA", function(module, exports) {

$parcel$export(module.exports, "useCloseOnEscapePress", () => $9b5986f84aefcc61$export$4a4bf067ea9e7886);

var $eUqFw = parcelRequire("eUqFw");

var $7Ihxv = parcelRequire("7Ihxv");

var $l93vw = parcelRequire("l93vw");
const $9b5986f84aefcc61$var$ESCAPE = 'Escape';
function $9b5986f84aefcc61$export$4a4bf067ea9e7886({ onClose: onClose, isDisabled: isDisabled }) {
    const escapePressed = (0, $eUqFw.useRef)(false);
    const { isLayerDisabled: isLayerDisabled } = $9b5986f84aefcc61$export$cec37b93989366d4();
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        const isDisabledLayer = isLayerDisabled();
        if (isDisabled || escapePressed.current || e.key !== $9b5986f84aefcc61$var$ESCAPE || isDisabledLayer) // We're either already handling the key down event or it's not escape or disabled.
        // Bail early!
        return;
        escapePressed.current = true;
        onClose(e);
    }, [
        onClose,
        isDisabled,
        isLayerDisabled
    ]);
    const onKeyUp = (0, $eUqFw.useCallback)(()=>{
        escapePressed.current = false;
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        return (0, $7Ihxv.bindAll)(document, [
            {
                type: 'keydown',
                listener: onKeyDown
            },
            {
                type: 'keyup',
                listener: onKeyUp
            }
        ], {
            capture: false
        });
    }, [
        onKeyDown,
        onKeyUp
    ]);
}
function $9b5986f84aefcc61$export$cec37b93989366d4() {
    const currentLevel = (0, $eUqFw.useContext)((0, $l93vw.LevelContext));
    const { topLevelRef: topLevelRef } = (0, $eUqFw.useContext)((0, $l93vw.TopLevelContext));
    const isLayerDisabled = (0, $eUqFw.useCallback)(()=>{
        return !!topLevelRef.current && currentLevel !== topLevelRef.current;
    }, [
        currentLevel,
        topLevelRef
    ]);
    return {
        currentLevel: currentLevel,
        topLevelRef: topLevelRef,
        isLayerDisabled: isLayerDisabled
    };
}

});
parcelRegister("l93vw", function(module, exports) {

$parcel$export(module.exports, "LevelContext", () => $f64d28c1dcf621a9$export$650d12d3c2ddb8fc);
$parcel$export(module.exports, "TopLevelContext", () => $f64d28c1dcf621a9$export$48b383b280e20440);
$parcel$export(module.exports, "UNSAFE_LAYERING", () => $f64d28c1dcf621a9$export$a183686c3f6f4ea8);

var $eUqFw = parcelRequire("eUqFw");

var $eiQBT = parcelRequire("eiQBT");
const $f64d28c1dcf621a9$export$650d12d3c2ddb8fc = /*#__PURE__*/ (0, $eUqFw.createContext)(0);
const $f64d28c1dcf621a9$export$48b383b280e20440 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    topLevelRef: {
        current: null
    },
    setTopLevel: (0, $eiQBT.default)
});
/**
 *
 *  @internal
 * Context Provider Component which provider the current level of nested layers
 * It handles level management when it mounts and unmounts
 *
 */ const $f64d28c1dcf621a9$var$LevelProvider = ({ children: children, currentLevel: currentLevel })=>{
    const { setTopLevel: setTopLevel } = (0, $eUqFw.useContext)($f64d28c1dcf621a9$export$48b383b280e20440);
    setTopLevel(currentLevel);
    (0, $eUqFw.useEffect)(()=>{
        // avoid immediate cleanup using setTimeout when component unmount
        // this will make sure non-top layer components can get the correct top level value
        // when multiple layers trigger onClose in sequence.
        // From React 17, the useEffect cleanup functions are delayed till the commit phase is completed. In other words, the useEffect cleanup functions run asynchronously - for example, if the component is unmounting, the cleanup runs after the screen has been updated.
        // TODO revisit after we migrate to react 18. https://product-fabric.atlassian.net/browse/DSP-13139
        return ()=>{
            setTimeout(()=>{
                setTopLevel(currentLevel - 1);
            }, 0);
        };
    }, [
        setTopLevel,
        currentLevel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f64d28c1dcf621a9$export$650d12d3c2ddb8fc.Provider, {
        value: currentLevel
    }, children);
};
/**
 *
 *  @internal
 * Context Provider Component which provides the top level of all nested layers
 * It provides initial top level ref value as 0 and set top level method
 *
 */ const $f64d28c1dcf621a9$var$LayeringProvider = ({ children: children })=>{
    const topLevelRef = (0, $eUqFw.useRef)(0);
    const value = (0, $eUqFw.useMemo)(()=>({
            topLevelRef: topLevelRef,
            setTopLevel: (level)=>{
                topLevelRef.current = level;
            }
        }), [
        topLevelRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f64d28c1dcf621a9$export$48b383b280e20440.Provider, {
        value: value
    }, children);
};
const $f64d28c1dcf621a9$export$a183686c3f6f4ea8 = ({ children: children, isDisabled: isDisabled = true })=>{
    const currentLevel = (0, $eUqFw.useContext)($f64d28c1dcf621a9$export$650d12d3c2ddb8fc);
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, children);
    const isNested = currentLevel > 0;
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f64d28c1dcf621a9$var$LevelProvider, {
        currentLevel: currentLevel + 1
    }, children);
    return isNested ? content : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($f64d28c1dcf621a9$var$LayeringProvider, null, content);
};

});


parcelRegister("jQdk2", function(module, exports) {

$parcel$export(module.exports, "BottomPanel", () => $e71d35237092d660$export$1facaeb58ab65ca);
/* BottomPanel.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4xAW3 = parcelRequire("4xAW3");
var $d4qUE = parcelRequire("d4qUE");

var $FHhXl = parcelRequire("FHhXl");

var $lHkHI = parcelRequire("lHkHI");
const $e71d35237092d660$var$_excluded = [
    "as",
    "style"
];
function $e71d35237092d660$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e71d35237092d660$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e71d35237092d660$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e71d35237092d660$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e71d35237092d660$var$bottomPanelStyles = (0, $d4qUE.xcss)({
    flex: 0,
    padding: 'space.200',
    borderTopColor: 'color.border',
    borderTopWidth: 'border.width',
    borderTopStyle: 'solid',
    boxShadow: 'elevation.shadow.overflow'
});
// Using styled button instead of Pressable so we can use hover media query
const $e71d35237092d660$var$ClearAllButton = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "button", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $e71d35237092d660$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $e71d35237092d660$var$_objectSpread($e71d35237092d660$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkuzmt _syaz1blv _4t3igosd _1wyb1j6v _vwz41k92 _2rko1sit _1bsb1osq _80omtlke _19itglyw _1di6fqd3 _1rjn1eg3 _13khfqd3",
            __cmplp.className
        ])
    }));
});
const $e71d35237092d660$var$applyButtonStyles = (0, $d4qUE.xcss)({
    backgroundColor: 'color.background.brand.bold',
    color: 'color.text.inverse',
    height: 'size.400',
    fontSize: '1rem',
    lineHeight: '1.25rem',
    borderRadius: 'border.radius',
    width: '100%',
    ':hover': {
        backgroundColor: 'color.background.brand.bold.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.brand.bold.pressed'
    }
});
const $e71d35237092d660$export$1facaeb58ab65ca = (_ref2)=>{
    let { onApplyFilters: onApplyFilters, onClearAllFilters: onClearAllFilters } = _ref2;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4xAW3.default), {
        spread: "space-between",
        xcss: $e71d35237092d660$var$bottomPanelStyles,
        space: "space.200",
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($e71d35237092d660$var$ClearAllButton, {
                onClick: onClearAllFilters,
                children: "Clear all"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $FHhXl.default), {
                onClick: onApplyFilters,
                xcss: $e71d35237092d660$var$applyButtonStyles,
                children: "Apply"
            })
        ]
    });
};

});

const $cc783837ce69c797$export$1621c4af050a10c2 = 'filter-dialog-heading';

parcelRegister("e5fGH", function(module, exports) {

$parcel$export(module.exports, "FiltersPanel", () => $a40db3949dd5c99c$export$4c73d84060e37d);

var $4xAW3 = parcelRequire("4xAW3");
var $d4qUE = parcelRequire("d4qUE");

var $eUqFw = parcelRequire("eUqFw");

var $i2FFi = parcelRequire("i2FFi");

var $gpMNI = parcelRequire("gpMNI");

var $7bAoh = parcelRequire("7bAoh");

var $lHkHI = parcelRequire("lHkHI");
const $a40db3949dd5c99c$var$wrapperStyles = (0, $d4qUE.xcss)({
    flex: 1,
    minHeight: '0'
});
const $a40db3949dd5c99c$export$4c73d84060e37d = (_ref)=>{
    var _filterDefinitions$, _filterOptions$select, _selectedOptions$sele;
    let { filterDefinitions: filterDefinitions, filterOptions: filterOptions, selectedOptions: selectedOptions = {}, sortOptions: sortOptions, selectedSortOption: selectedSortOption, filterStatus: filterStatus = {}, onSelectedOptionsChange: onSelectedOptionsChange, onSelectedSortOptionChange: onSelectedSortOptionChange } = _ref;
    const defaultSelectedOptionId = sortOptions.length > 0 ? 'sort-by' : (_filterDefinitions$ = filterDefinitions[0]) === null || _filterDefinitions$ === void 0 ? void 0 : _filterDefinitions$.filterId;
    const [selectedSidebarOptionId, setSelectedSidebarOptionId] = (0, $eUqFw.useState)(defaultSelectedOptionId);
    const selectedFilterDefinition = filterDefinitions.find((filterDefinition)=>filterDefinition.filterId === selectedSidebarOptionId);
    const handleSidebarOptionClick = (0, $eUqFw.useCallback)((id)=>{
        if (id !== selectedSidebarOptionId) setSelectedSidebarOptionId(id);
    }, [
        selectedSidebarOptionId
    ]);
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4xAW3.default), {
        xcss: $a40db3949dd5c99c$var$wrapperStyles,
        alignBlock: "stretch",
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $i2FFi.Sidebar), {
                filterDefinitions: filterDefinitions,
                selectedSidebarOptionId: selectedSidebarOptionId,
                selectedOptions: selectedOptions,
                onSidebarOptionClick: handleSidebarOptionClick,
                enableSort: sortOptions.length > 0
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eUqFw.Fragment), {
                children: selectedSidebarOptionId === 'sort-by' ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7bAoh.SortSelect), {
                    options: sortOptions,
                    selectedOption: selectedSortOption !== null && selectedSortOption !== void 0 ? selectedSortOption : sortOptions[0],
                    onSelectedOptionChange: onSelectedSortOptionChange
                }) : selectedFilterDefinition && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gpMNI.FiltersSelect), {
                    filterDefinition: selectedFilterDefinition,
                    filterStatus: selectedSidebarOptionId ? filterStatus[selectedSidebarOptionId] : 'default',
                    options: (_filterOptions$select = filterOptions[selectedSidebarOptionId]) !== null && _filterOptions$select !== void 0 ? _filterOptions$select : [],
                    selectedOptions: (_selectedOptions$sele = selectedOptions[selectedSidebarOptionId]) !== null && _selectedOptions$sele !== void 0 ? _selectedOptions$sele : [],
                    onSelectedOptionsChange: onSelectedOptionsChange
                })
            }, selectedSidebarOptionId)
        ]
    });
};

});
parcelRegister("i2FFi", function(module, exports) {

$parcel$export(module.exports, "Sidebar", () => $d228bbb083910554$export$1ba59dacbcbf90fe);

var $5cJpv = parcelRequire("5cJpv");
var $d4qUE = parcelRequire("d4qUE");
parcelRequire("eUqFw");

var $7qt8X = parcelRequire("7qt8X");

var $lHkHI = parcelRequire("lHkHI");
const $d228bbb083910554$var$sidebarWrapperStyles = (0, $d4qUE.xcss)({
    borderRightWidth: 'border.width',
    borderRightColor: 'color.border',
    borderRightStyle: 'solid',
    height: '100%',
    maxWidth: '50%',
    // Prevent the sidebar from growing larger than 50% of the screen, in case of long sidebar option names
    overflow: 'auto'
});
const $d228bbb083910554$export$1ba59dacbcbf90fe = (_ref)=>{
    let { filterDefinitions: filterDefinitions, selectedSidebarOptionId: selectedSidebarOptionId, selectedOptions: selectedOptions, onSidebarOptionClick: onSidebarOptionClick, enableSort: enableSort = false } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $5cJpv.default), {
        role: "tablist",
        xcss: $d228bbb083910554$var$sidebarWrapperStyles,
        children: [
            enableSort && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7qt8X.SidebarOption), {
                id: "sort-by",
                label: "Sort by",
                isSelected: selectedSidebarOptionId === 'sort-by',
                numberOfSelections: 0,
                onClick: onSidebarOptionClick
            }),
            filterDefinitions.map((filterDefinition)=>{
                var _selectedOptions$filt, _selectedOptions$filt2;
                return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7qt8X.SidebarOption), {
                    id: filterDefinition.filterId,
                    label: filterDefinition.label,
                    isSelected: filterDefinition.filterId === selectedSidebarOptionId,
                    numberOfSelections: (_selectedOptions$filt = selectedOptions === null || selectedOptions === void 0 ? void 0 : (_selectedOptions$filt2 = selectedOptions[filterDefinition.filterId]) === null || _selectedOptions$filt2 === void 0 ? void 0 : _selectedOptions$filt2.length) !== null && _selectedOptions$filt !== void 0 ? _selectedOptions$filt : 0,
                    onClick: onSidebarOptionClick
                }, filterDefinition.filterId);
            })
        ]
    });
};

});
parcelRegister("7qt8X", function(module, exports) {

$parcel$export(module.exports, "SidebarOption", () => $5681916c7ffe5ef1$export$e95c65c040070fdf);
/* SidebarOption.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $379fO = parcelRequire("379fO");
var $4xAW3 = parcelRequire("4xAW3");
var $d4qUE = parcelRequire("d4qUE");

var $lHkHI = parcelRequire("lHkHI");
const $5681916c7ffe5ef1$var$_excluded = [
    "as",
    "style"
], $5681916c7ffe5ef1$var$_excluded2 = [
    "isSelected"
];
function $5681916c7ffe5ef1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5681916c7ffe5ef1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5681916c7ffe5ef1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5681916c7ffe5ef1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
// Using styled button instead of Pressable so we can use hover media query
const $5681916c7ffe5ef1$var$OptionButton = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "button", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $5681916c7ffe5ef1$var$_excluded);
    const { isSelected: isSelected } = __cmplp, __cmpldp = (0, $bwPfh.default)(__cmplp, $5681916c7ffe5ef1$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $5681916c7ffe5ef1$var$_objectSpread($5681916c7ffe5ef1$var$_objectSpread({}, __cmpldp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_80omtlke _ca0qoxav _n3tdoxav _19bvxjmg _u5f3xjmg _bfhkipex _syaz1blv _1wyboxwj _y3gn1e5h _19it66vy _1di618nh _1rjn6224 _13kh18nh",
            __cmplp.isSelected && "_bfhka7cx _syaztmrq _t6vd1bk5 _1p3lnqa1 _5wra1oj9 _1di61514 _1rjn3ht5 _13kh1514",
            __cmplp.className
        ])
    }));
});
const $5681916c7ffe5ef1$var$optionLabelStyles = (0, $d4qUE.xcss)({
    flex: '2 1 auto',
    maxWidth: '90%',
    wordWrap: 'break-word'
});
const $5681916c7ffe5ef1$var$numberOfSelectionsStyles = (0, $d4qUE.xcss)({
    flex: '1 1 auto',
    minWidth: 'size.100',
    // Reserving space for this component to prevent shifting the sidebar when the first selection is made
    textAlign: 'right'
});
const $5681916c7ffe5ef1$export$e95c65c040070fdf = (_ref2)=>{
    let { id: id, isSelected: isSelected, label: label, numberOfSelections: numberOfSelections, onClick: onClick } = _ref2;
    const handleClick = (0, $eUqFw.useCallback)(()=>{
        onClick(id);
    }, [
        id,
        onClick
    ]);
    return /*#__PURE__*/ (0, $lHkHI.jsx)($5681916c7ffe5ef1$var$OptionButton, {
        role: "tab",
        "aria-selected": isSelected,
        onClick: handleClick,
        isSelected: isSelected,
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4xAW3.default), {
            spread: "space-between",
            space: "space.100",
            as: "span",
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
                    xcss: $5681916c7ffe5ef1$var$optionLabelStyles,
                    children: label
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
                    xcss: $5681916c7ffe5ef1$var$numberOfSelectionsStyles,
                    children: numberOfSelections > 0 && numberOfSelections
                })
            ]
        })
    });
};

});


parcelRegister("gpMNI", function(module, exports) {

$parcel$export(module.exports, "FiltersSelect", () => $bf34d5f603fe59b9$export$8b92c26a6a671926);

var $eUqFw = parcelRequire("eUqFw");

var $jAR5j = parcelRequire("jAR5j");

var $8Iyrm = parcelRequire("8Iyrm");

var $2xDeC = parcelRequire("2xDeC");

var $lHkHI = parcelRequire("lHkHI");
const $bf34d5f603fe59b9$export$8b92c26a6a671926 = (_ref)=>{
    let { filterDefinition: filterDefinition, filterStatus: filterStatus, options: options, selectedOptions: selectedOptions, onSelectedOptionsChange: onSelectedOptionsChange } = _ref;
    const { filterId: filterId, groupSelectedItems: groupSelectedItems, isMulti: isMulti, isSearchable: isSearchable } = filterDefinition;
    const previousFilterIdRef = (0, $eUqFw.useRef)();
    const [searchInputValue, setSearchInputValue] = (0, $eUqFw.useState)('');
    const [groupedOptions, setGroupedOptions] = (0, $eUqFw.useState)((0, $2xDeC.getGroupedOptions)({
        options: options,
        selectedOptions: selectedOptions,
        addSelectedFirst: groupSelectedItems
    }));
    (0, $eUqFw.useEffect)(()=>{
        // Using a ref to compare the previous filterId with the current filterId
        // as we only want to update the grouped options when the filterId changes,
        // and not when the other dependencies used in this effect change.
        if (previousFilterIdRef.current !== filterId) setGroupedOptions((0, $2xDeC.getGroupedOptions)({
            options: options,
            selectedOptions: selectedOptions,
            addSelectedFirst: groupSelectedItems
        }));
        previousFilterIdRef.current = filterId;
    }, [
        filterId,
        groupSelectedItems,
        options,
        selectedOptions
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // When the filterId changes, reset the search input value
        setSearchInputValue('');
    }, [
        filterId
    ]);
    const handleSearchInputChange = (0, $eUqFw.useCallback)((newInputValue, meta)=>{
        if (meta.action === 'input-change') setSearchInputValue(newInputValue);
    }, []);
    const handleChange = (0, $eUqFw.useCallback)((newOptionOrOptions)=>{
        if ((0, $2xDeC.isMultiSelectOptions)(newOptionOrOptions)) onSelectedOptionsChange({
            filterId: filterId,
            options: newOptionOrOptions,
            location: 'mobile'
        });
        else {
            const optionsWithFallback = newOptionOrOptions ? [
                newOptionOrOptions
            ] : [];
            onSelectedOptionsChange({
                filterId: filterId,
                // If the default `All` radio option is selected, we want to specify that no option is selected
                options: (newOptionOrOptions === null || newOptionOrOptions === void 0 ? void 0 : newOptionOrOptions.value) === (0, $jAR5j.DEFAULT_RADIO_OPTION).value ? [] : optionsWithFallback,
                location: 'mobile'
            });
        }
    }, [
        filterId,
        onSelectedOptionsChange
    ]);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8Iyrm.MobileSelect), {
        testId: "mobile-filter-picker-select",
        options: !isMulti && options.length > 0 ? [
            (0, $jAR5j.DEFAULT_RADIO_OPTION),
            ...groupedOptions
        ] : groupedOptions,
        selectedOptions: !isMulti && selectedOptions.length === 0 ? [
            (0, $jAR5j.DEFAULT_RADIO_OPTION)
        ] : selectedOptions,
        status: filterStatus,
        isMulti: isMulti,
        isSearchable: isSearchable,
        searchInputValue: searchInputValue,
        onSelectionChange: handleChange,
        onSearchInputChange: handleSearchInputChange
    });
};

});
parcelRegister("jAR5j", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_RADIO_OPTION", () => $e43a8ea63a4908d3$export$79f1844e85dbf592);
// The default option for single select (radio) filters in mobile.
// Used when the user has made no filter option selection
const $e43a8ea63a4908d3$export$79f1844e85dbf592 = {
    label: 'All',
    value: ''
};

});

parcelRegister("8Iyrm", function(module, exports) {

$parcel$export(module.exports, "MobileSelect", () => $658d25ef30642a96$export$309d76cb1c17f415);

var $5zQU9 = parcelRequire("5zQU9");

var $379fO = parcelRequire("379fO");
var $d4qUE = parcelRequire("d4qUE");

var $dzIcn = parcelRequire("dzIcn");
parcelRequire("eUqFw");

var $3DYxj = parcelRequire("3DYxj");

var $aCWZ7 = parcelRequire("aCWZ7");

var $kUvoe = parcelRequire("kUvoe");

var $dWSYG = parcelRequire("dWSYG");

var $ipYHU = parcelRequire("ipYHU");

var $9nseh = parcelRequire("9nseh");

var $97C27 = parcelRequire("97C27");

var $lHkHI = parcelRequire("lHkHI");
function $658d25ef30642a96$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $658d25ef30642a96$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $658d25ef30642a96$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $658d25ef30642a96$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $658d25ef30642a96$var$customSelectStyles = {
    control: (base)=>$658d25ef30642a96$var$_objectSpread($658d25ef30642a96$var$_objectSpread({}, base), {}, {
            border: 0 // Removing the default border around the select control
        })
};
const $658d25ef30642a96$var$customComponents = {
    Option: (0, $97C27.CustomOptionMobile),
    DropdownIndicator: (0, $kUvoe.CustomDropdownIndicator),
    Menu: (0, $dWSYG.CustomMenu),
    Control: (0, $aCWZ7.CustomControlMobile),
    NoOptionsMessage: (0, $9nseh.CustomNoOptionsMessage),
    MenuList: (0, $ipYHU.CustomMenuList)
};
const $658d25ef30642a96$var$wrapperStyles = (0, $d4qUE.xcss)($658d25ef30642a96$var$_objectSpread($658d25ef30642a96$var$_objectSpread({}, (0, $3DYxj.charlieTextFontFamily)), {}, {
    flex: '1',
    width: '100%',
    overflow: 'auto'
}));
const $658d25ef30642a96$export$309d76cb1c17f415 = (_ref)=>{
    let { testId: testId, options: options, selectedOptions: selectedOptions, status: status = 'default', searchInputValue: searchInputValue = '', isMulti: isMulti = false, isSearchable: isSearchable = false, onSelectionChange: onSelectionChange, onSearchInputChange: onSearchInputChange } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
        xcss: $658d25ef30642a96$var$wrapperStyles,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dzIcn.default), {
            placeholder: "Search",
            testId: testId,
            options: options,
            value: selectedOptions,
            isMulti: isMulti,
            onChange: onSelectionChange,
            inputValue: searchInputValue,
            onInputChange: onSearchInputChange,
            components: $658d25ef30642a96$var$customComponents,
            styles: $658d25ef30642a96$var$customSelectStyles,
            menuIsOpen: true,
            autoFocus: true,
            blurInputOnSelect: true,
            closeMenuOnSelect: false,
            hideSelectedOptions: false,
            controlShouldRenderValue: false,
            menuShouldScrollIntoView: false,
            tabSelectsValue: false,
            defaultOptions: false,
            isClearable: false,
            escapeClearsValue: false,
            isSearchable: isSearchable,
            status: status
        })
    });
};

});
parcelRegister("ipYHU", function(module, exports) {

$parcel$export(module.exports, "CustomMenuList", () => $d689a6f9712a451a$export$999dcaa9eb540e19);

var $379fO = parcelRequire("379fO");
var $d4qUE = parcelRequire("d4qUE");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $d689a6f9712a451a$var$wrapperStyles = (0, $d4qUE.xcss)({
    display: 'flex',
    flexDirection: 'column'
});
const $d689a6f9712a451a$export$999dcaa9eb540e19 = (_ref)=>{
    let { children: children } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
        xcss: $d689a6f9712a451a$var$wrapperStyles,
        children: children
    });
};

});



parcelRegister("7bAoh", function(module, exports) {

$parcel$export(module.exports, "SortSelect", () => $53b5c9e834d615e6$export$705dab00dd666814);

var $eUqFw = parcelRequire("eUqFw");

var $8Iyrm = parcelRequire("8Iyrm");

var $2xDeC = parcelRequire("2xDeC");

var $lHkHI = parcelRequire("lHkHI");
const $53b5c9e834d615e6$export$705dab00dd666814 = (_ref)=>{
    let { options: options, selectedOption: selectedOption, onSelectedOptionChange: onSelectedOptionChange } = _ref;
    const handleChange = (0, $eUqFw.useCallback)((newOptionOrOptions)=>{
        if (newOptionOrOptions && !(0, $2xDeC.isMultiSelectOptions)(newOptionOrOptions)) onSelectedOptionChange({
            option: newOptionOrOptions,
            location: 'mobile'
        });
    }, [
        onSelectedOptionChange
    ]);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8Iyrm.MobileSelect), {
        testId: "mobile-sort-picker-select",
        options: options,
        selectedOptions: [
            selectedOption
        ],
        status: "default",
        onSelectionChange: handleChange
    });
};

});


parcelRegister("iGLLj", function(module, exports) {

$parcel$export(module.exports, "TopPanel", () => $d9b132cb843dd2f6$export$42d18e13b35290c3);

var $1jAT8 = parcelRequire("1jAT8");

var $bxKuG = parcelRequire("bxKuG");

var $379fO = parcelRequire("379fO");
var $4xAW3 = parcelRequire("4xAW3");
var $d4qUE = parcelRequire("d4qUE");
parcelRequire("eUqFw");


var $lHkHI = parcelRequire("lHkHI");
const $d9b132cb843dd2f6$var$topPanelStyles = (0, $d4qUE.xcss)({
    flex: 0,
    paddingTop: 'space.200',
    paddingBottom: 'space.200',
    paddingLeft: 'space.300',
    paddingRight: 'space.300',
    borderBottomColor: 'color.border',
    borderBottomWidth: 'border.width',
    borderBottomStyle: 'solid'
});
const $d9b132cb843dd2f6$var$headingTextStyles = (0, $d4qUE.xcss)({
    fontSize: '1.25rem',
    fontWeight: '600'
});
const $d9b132cb843dd2f6$export$42d18e13b35290c3 = (_ref)=>{
    let { onClose: onClose, enableSort: enableSort } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4xAW3.default), {
        spread: "space-between",
        xcss: $d9b132cb843dd2f6$var$topPanelStyles,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
                xcss: $d9b132cb843dd2f6$var$headingTextStyles,
                as: "h2",
                id: (0, $cc783837ce69c797$export$1621c4af050a10c2),
                children: enableSort ? 'Sort & filter' : 'Filter'
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1jAT8.default), {
                appearance: "subtle",
                icon: (0, (/*@__PURE__*/$parcel$interopDefault($bxKuG))),
                label: "Close filters",
                onClick: onClose
            })
        ]
    });
};

});


parcelRegister("ccuBL", function(module, exports) {

$parcel$export(module.exports, "ShowFiltersButton", () => $8e1e592a73e34138$export$b79854f7ecbf74e9);

var $k3yE3 = parcelRequire("k3yE3");

var $6Vuv2 = parcelRequire("6Vuv2");

var $4xAW3 = parcelRequire("4xAW3");
var $d4qUE = parcelRequire("d4qUE");

var $FHhXl = parcelRequire("FHhXl");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $8e1e592a73e34138$var$buttonStyles = (0, $d4qUE.xcss)({
    width: '100%',
    borderRadius: 'border.radius.200',
    height: 'size.400',
    backgroundColor: 'color.background.neutral',
    color: 'color.text',
    fontSize: '0.875rem',
    fontWeight: 500,
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.pressed'
    }
});
const $8e1e592a73e34138$var$buttonSelectedStyles = (0, $d4qUE.xcss)({
    backgroundColor: 'color.background.selected',
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $8e1e592a73e34138$export$b79854f7ecbf74e9 = (_ref)=>{
    let { numberOfSelections: numberOfSelections, onClick: onClick, enableSort: enableSort = false } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $FHhXl.default), {
        onClick: onClick,
        xcss: [
            $8e1e592a73e34138$var$buttonStyles,
            numberOfSelections > 0 && $8e1e592a73e34138$var$buttonSelectedStyles
        ],
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4xAW3.default), {
            alignInline: "center",
            alignBlock: "center",
            space: "space.050",
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6Vuv2))), {
                    label: ""
                }),
                enableSort ? 'Sort & filter' : 'Filter',
                numberOfSelections > 0 && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $k3yE3.default), {
                    appearance: "primary",
                    children: numberOfSelections
                })
            ]
        })
    });
};

});



parcelRegister("eYGD7", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae77bcba90d7f1b8$export$2e2bcd8739ae039);
parcelRequire("eUqFw");

var $ggcyB = parcelRequire("ggcyB");

var $i7JBv = parcelRequire("i7JBv");

var $hveJS = parcelRequire("hveJS");

var $lHkHI = parcelRequire("lHkHI");
const $ae77bcba90d7f1b8$var$BASE_TITLE = 'Atlassian Marketplace';
const $ae77bcba90d7f1b8$var$Meta = (_ref)=>{
    let { canonicalUrl: canonicalUrl, description: description, image: image, openGraphImage: openGraphImage, title: title, twitterImage: twitterImage } = _ref;
    const GeneratedTitle = title ? "".concat(title, " | ").concat($ae77bcba90d7f1b8$var$BASE_TITLE) : $ae77bcba90d7f1b8$var$BASE_TITLE;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ggcyB.default), {
                canonicalUrl: canonicalUrl,
                description: description,
                title: GeneratedTitle
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $i7JBv.default), {
                canonicalUrl: canonicalUrl,
                description: description,
                image: openGraphImage || image,
                title: GeneratedTitle
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hveJS.default), {
                description: description,
                image: twitterImage || image,
                title: GeneratedTitle
            })
        ]
    });
};
var $ae77bcba90d7f1b8$export$2e2bcd8739ae039 = $ae77bcba90d7f1b8$var$Meta;

});
parcelRegister("ggcyB", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd67e18e342f0b6a$export$2e2bcd8739ae039);
parcelRequire("eUqFw");

var $2kTjx = parcelRequire("2kTjx");

var $lHkHI = parcelRequire("lHkHI");
const $bd67e18e342f0b6a$var$BaseMeta = (_ref)=>{
    let { title: title, canonicalUrl: canonicalUrl, description: description } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $2kTjx.Helmet), {
        prioritizeSeoTags: true,
        children: [
            title ? /*#__PURE__*/ (0, $lHkHI.jsx)("title", {
                children: title
            }) : null,
            canonicalUrl ? /*#__PURE__*/ (0, $lHkHI.jsx)("link", {
                rel: "canonical",
                href: canonicalUrl
            }) : null,
            description ? /*#__PURE__*/ (0, $lHkHI.jsx)("meta", {
                name: "description",
                content: description
            }) : null
        ]
    });
};
var $bd67e18e342f0b6a$export$2e2bcd8739ae039 = $bd67e18e342f0b6a$var$BaseMeta;

});
parcelRegister("2kTjx", function(module, exports) {

$parcel$export(module.exports, "Helmet", () => $1b385b3e3b54f286$export$dcef8f9bb9a41431);
// src/index.tsx

var $eUqFw = parcelRequire("eUqFw");

var $an8Qp = parcelRequire("an8Qp");

var $h8TzT = parcelRequire("h8TzT");

var $h295B = parcelRequire("h295B");
// src/constants.ts
var $1b385b3e3b54f286$var$TAG_NAMES = /* @__PURE__ */ ((TAG_NAMES2)=>{
    TAG_NAMES2["BASE"] = "base";
    TAG_NAMES2["BODY"] = "body";
    TAG_NAMES2["HEAD"] = "head";
    TAG_NAMES2["HTML"] = "html";
    TAG_NAMES2["LINK"] = "link";
    TAG_NAMES2["META"] = "meta";
    TAG_NAMES2["NOSCRIPT"] = "noscript";
    TAG_NAMES2["SCRIPT"] = "script";
    TAG_NAMES2["STYLE"] = "style";
    TAG_NAMES2["TITLE"] = "title";
    TAG_NAMES2["FRAGMENT"] = "Symbol(react.fragment)";
    return TAG_NAMES2;
})($1b385b3e3b54f286$var$TAG_NAMES || {});
var $1b385b3e3b54f286$var$SEO_PRIORITY_TAGS = {
    link: {
        rel: [
            "amphtml",
            "canonical",
            "alternate"
        ]
    },
    script: {
        type: [
            "application/ld+json"
        ]
    },
    meta: {
        charset: "",
        name: [
            "generator",
            "robots",
            "description"
        ],
        property: [
            "og:type",
            "og:title",
            "og:url",
            "og:image",
            "og:image:alt",
            "og:description",
            "twitter:url",
            "twitter:title",
            "twitter:description",
            "twitter:image",
            "twitter:image:alt",
            "twitter:card",
            "twitter:site"
        ]
    }
};
var $1b385b3e3b54f286$var$VALID_TAG_NAMES = Object.values($1b385b3e3b54f286$var$TAG_NAMES);
var $1b385b3e3b54f286$var$REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};
var $1b385b3e3b54f286$var$HTML_TAG_MAP = Object.entries($1b385b3e3b54f286$var$REACT_TAG_MAP).reduce((carry, [key, value])=>{
    carry[value] = key;
    return carry;
}, {});
var $1b385b3e3b54f286$var$HELMET_ATTRIBUTE = "data-rh";
// src/utils.ts
var $1b385b3e3b54f286$var$HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate",
    PRIORITIZE_SEO_TAGS: "prioritizeSeoTags"
};
var $1b385b3e3b54f286$var$getInnermostProperty = (propsList, property)=>{
    for(let i = propsList.length - 1; i >= 0; i -= 1){
        const props = propsList[i];
        if (Object.prototype.hasOwnProperty.call(props, property)) return props[property];
    }
    return null;
};
var $1b385b3e3b54f286$var$getTitleFromPropsList = (propsList)=>{
    let innermostTitle = $1b385b3e3b54f286$var$getInnermostProperty(propsList, "title" /* TITLE */ );
    const innermostTemplate = $1b385b3e3b54f286$var$getInnermostProperty(propsList, $1b385b3e3b54f286$var$HELMET_PROPS.TITLE_TEMPLATE);
    if (Array.isArray(innermostTitle)) innermostTitle = innermostTitle.join("");
    if (innermostTemplate && innermostTitle) return innermostTemplate.replace(/%s/g, ()=>innermostTitle);
    const innermostDefaultTitle = $1b385b3e3b54f286$var$getInnermostProperty(propsList, $1b385b3e3b54f286$var$HELMET_PROPS.DEFAULT_TITLE);
    return innermostTitle || innermostDefaultTitle || void 0;
};
var $1b385b3e3b54f286$var$getOnChangeClientState = (propsList)=>$1b385b3e3b54f286$var$getInnermostProperty(propsList, $1b385b3e3b54f286$var$HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || (()=>{});
var $1b385b3e3b54f286$var$getAttributesFromPropsList = (tagType, propsList)=>propsList.filter((props)=>typeof props[tagType] !== "undefined").map((props)=>props[tagType]).reduce((tagAttrs, current)=>({
            ...tagAttrs,
            ...current
        }), {});
var $1b385b3e3b54f286$var$getBaseTagFromPropsList = (primaryAttributes, propsList)=>propsList.filter((props)=>typeof props["base" /* BASE */ ] !== "undefined").map((props)=>props["base" /* BASE */ ]).reverse().reduce((innermostBaseTag, tag)=>{
        if (!innermostBaseTag.length) {
            const keys = Object.keys(tag);
            for(let i = 0; i < keys.length; i += 1){
                const attributeKey = keys[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) return innermostBaseTag.concat(tag);
            }
        }
        return innermostBaseTag;
    }, []);
var $1b385b3e3b54f286$var$warn = (msg)=>console && typeof console.warn === "function" && console.warn(msg);
var $1b385b3e3b54f286$var$getTagsFromPropsList = (tagName, primaryAttributes, propsList)=>{
    const approvedSeenTags = {};
    return propsList.filter((props)=>{
        if (Array.isArray(props[tagName])) return true;
        if (typeof props[tagName] !== "undefined") $1b385b3e3b54f286$var$warn(`Helmet: ${tagName} should be of type "Array". Instead found type "${typeof props[tagName]}"`);
        return false;
    }).map((props)=>props[tagName]).reverse().reduce((approvedTags, instanceTags)=>{
        const instanceSeenTags = {};
        instanceTags.filter((tag)=>{
            let primaryAttributeKey;
            const keys2 = Object.keys(tag);
            for(let i = 0; i < keys2.length; i += 1){
                const attributeKey = keys2[i];
                const lowerCaseAttributeKey = attributeKey.toLowerCase();
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === "rel" /* REL */  && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === "rel" /* REL */  && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) primaryAttributeKey = lowerCaseAttributeKey;
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === "innerHTML" /* INNER_HTML */  || attributeKey === "cssText" /* CSS_TEXT */  || attributeKey === "itemprop" /* ITEM_PROP */ )) primaryAttributeKey = attributeKey;
            }
            if (!primaryAttributeKey || !tag[primaryAttributeKey]) return false;
            const value = tag[primaryAttributeKey].toLowerCase();
            if (!approvedSeenTags[primaryAttributeKey]) approvedSeenTags[primaryAttributeKey] = {};
            if (!instanceSeenTags[primaryAttributeKey]) instanceSeenTags[primaryAttributeKey] = {};
            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }
            return false;
        }).reverse().forEach((tag)=>approvedTags.push(tag));
        const keys = Object.keys(instanceSeenTags);
        for(let i = 0; i < keys.length; i += 1){
            const attributeKey = keys[i];
            const tagUnion = {
                ...approvedSeenTags[attributeKey],
                ...instanceSeenTags[attributeKey]
            };
            approvedSeenTags[attributeKey] = tagUnion;
        }
        return approvedTags;
    }, []).reverse();
};
var $1b385b3e3b54f286$var$getAnyTrueFromPropsList = (propsList, checkedTag)=>{
    if (Array.isArray(propsList) && propsList.length) for(let index = 0; index < propsList.length; index += 1){
        const prop = propsList[index];
        if (prop[checkedTag]) return true;
    }
    return false;
};
var $1b385b3e3b54f286$var$reducePropsToState = (propsList)=>({
        baseTag: $1b385b3e3b54f286$var$getBaseTagFromPropsList([
            "href" /* HREF */ 
        ], propsList),
        bodyAttributes: $1b385b3e3b54f286$var$getAttributesFromPropsList("bodyAttributes" /* BODY */ , propsList),
        defer: $1b385b3e3b54f286$var$getInnermostProperty(propsList, $1b385b3e3b54f286$var$HELMET_PROPS.DEFER),
        encode: $1b385b3e3b54f286$var$getInnermostProperty(propsList, $1b385b3e3b54f286$var$HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: $1b385b3e3b54f286$var$getAttributesFromPropsList("htmlAttributes" /* HTML */ , propsList),
        linkTags: $1b385b3e3b54f286$var$getTagsFromPropsList("link" /* LINK */ , [
            "rel" /* REL */ ,
            "href" /* HREF */ 
        ], propsList),
        metaTags: $1b385b3e3b54f286$var$getTagsFromPropsList("meta" /* META */ , [
            "name" /* NAME */ ,
            "charset" /* CHARSET */ ,
            "http-equiv" /* HTTPEQUIV */ ,
            "property" /* PROPERTY */ ,
            "itemprop" /* ITEM_PROP */ 
        ], propsList),
        noscriptTags: $1b385b3e3b54f286$var$getTagsFromPropsList("noscript" /* NOSCRIPT */ , [
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        onChangeClientState: $1b385b3e3b54f286$var$getOnChangeClientState(propsList),
        scriptTags: $1b385b3e3b54f286$var$getTagsFromPropsList("script" /* SCRIPT */ , [
            "src" /* SRC */ ,
            "innerHTML" /* INNER_HTML */ 
        ], propsList),
        styleTags: $1b385b3e3b54f286$var$getTagsFromPropsList("style" /* STYLE */ , [
            "cssText" /* CSS_TEXT */ 
        ], propsList),
        title: $1b385b3e3b54f286$var$getTitleFromPropsList(propsList),
        titleAttributes: $1b385b3e3b54f286$var$getAttributesFromPropsList("titleAttributes" /* TITLE */ , propsList),
        prioritizeSeoTags: $1b385b3e3b54f286$var$getAnyTrueFromPropsList(propsList, $1b385b3e3b54f286$var$HELMET_PROPS.PRIORITIZE_SEO_TAGS)
    });
var $1b385b3e3b54f286$var$flattenArray = (possibleArray)=>Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
var $1b385b3e3b54f286$var$checkIfPropsMatch = (props, toMatch)=>{
    const keys = Object.keys(props);
    for(let i = 0; i < keys.length; i += 1){
        if (toMatch[keys[i]] && toMatch[keys[i]].includes(props[keys[i]])) return true;
    }
    return false;
};
var $1b385b3e3b54f286$var$prioritizer = (elementsList, propsToMatch)=>{
    if (Array.isArray(elementsList)) return elementsList.reduce((acc, elementAttrs)=>{
        if ($1b385b3e3b54f286$var$checkIfPropsMatch(elementAttrs, propsToMatch)) acc.priority.push(elementAttrs);
        else acc.default.push(elementAttrs);
        return acc;
    }, {
        priority: [],
        default: []
    });
    return {
        default: elementsList,
        priority: []
    };
};
var $1b385b3e3b54f286$var$without = (obj, key)=>{
    return {
        ...obj,
        [key]: void 0
    };
};
// src/server.ts
var $1b385b3e3b54f286$var$SELF_CLOSING_TAGS = [
    "noscript" /* NOSCRIPT */ ,
    "script" /* SCRIPT */ ,
    "style" /* STYLE */ 
];
var $1b385b3e3b54f286$var$encodeSpecialCharacters = (str, encode = true)=>{
    if (encode === false) return String(str);
    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};
var $1b385b3e3b54f286$var$generateElementAttributesAsString = (attributes)=>Object.keys(attributes).reduce((str, key)=>{
        const attr = typeof attributes[key] !== "undefined" ? `${key}="${attributes[key]}"` : `${key}`;
        return str ? `${str} ${attr}` : attr;
    }, "");
var $1b385b3e3b54f286$var$generateTitleAsString = (type, title, attributes, encode)=>{
    const attributeString = $1b385b3e3b54f286$var$generateElementAttributesAsString(attributes);
    const flattenedTitle = $1b385b3e3b54f286$var$flattenArray(title);
    return attributeString ? `<${type} ${$1b385b3e3b54f286$var$HELMET_ATTRIBUTE}="true" ${attributeString}>${$1b385b3e3b54f286$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>` : `<${type} ${$1b385b3e3b54f286$var$HELMET_ATTRIBUTE}="true">${$1b385b3e3b54f286$var$encodeSpecialCharacters(flattenedTitle, encode)}</${type}>`;
};
var $1b385b3e3b54f286$var$generateTagsAsString = (type, tags, encode = true)=>tags.reduce((str, t)=>{
        const tag = t;
        const attributeHtml = Object.keys(tag).filter((attribute)=>!(attribute === "innerHTML" /* INNER_HTML */  || attribute === "cssText" /* CSS_TEXT */ )).reduce((string, attribute)=>{
            const attr = typeof tag[attribute] === "undefined" ? attribute : `${attribute}="${$1b385b3e3b54f286$var$encodeSpecialCharacters(tag[attribute], encode)}"`;
            return string ? `${string} ${attr}` : attr;
        }, "");
        const tagContent = tag.innerHTML || tag.cssText || "";
        const isSelfClosing = $1b385b3e3b54f286$var$SELF_CLOSING_TAGS.indexOf(type) === -1;
        return `${str}<${type} ${$1b385b3e3b54f286$var$HELMET_ATTRIBUTE}="true" ${attributeHtml}${isSelfClosing ? `/>` : `>${tagContent}</${type}>`}`;
    }, "");
var $1b385b3e3b54f286$var$convertElementAttributesToReactProps = (attributes, initProps = {})=>Object.keys(attributes).reduce((obj, key)=>{
        const mapped = $1b385b3e3b54f286$var$REACT_TAG_MAP[key];
        obj[mapped || key] = attributes[key];
        return obj;
    }, initProps);
var $1b385b3e3b54f286$var$generateTitleAsReactComponent = (_type, title, attributes)=>{
    const initProps = {
        key: title,
        [$1b385b3e3b54f286$var$HELMET_ATTRIBUTE]: true
    };
    const props = $1b385b3e3b54f286$var$convertElementAttributesToReactProps(attributes, initProps);
    return [
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("title" /* TITLE */ , props, title)
    ];
};
var $1b385b3e3b54f286$var$generateTagsAsReactComponent = (type, tags)=>tags.map((tag, i)=>{
        const mappedTag = {
            key: i,
            [$1b385b3e3b54f286$var$HELMET_ATTRIBUTE]: true
        };
        Object.keys(tag).forEach((attribute)=>{
            const mapped = $1b385b3e3b54f286$var$REACT_TAG_MAP[attribute];
            const mappedAttribute = mapped || attribute;
            if (mappedAttribute === "innerHTML" /* INNER_HTML */  || mappedAttribute === "cssText" /* CSS_TEXT */ ) {
                const content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = {
                    __html: content
                };
            } else mappedTag[mappedAttribute] = tag[attribute];
        });
        return (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(type, mappedTag);
    });
var $1b385b3e3b54f286$var$getMethodsForTag = (type, tags, encode = true)=>{
    switch(type){
        case "title" /* TITLE */ :
            return {
                toComponent: ()=>$1b385b3e3b54f286$var$generateTitleAsReactComponent(type, tags.title, tags.titleAttributes),
                toString: ()=>$1b385b3e3b54f286$var$generateTitleAsString(type, tags.title, tags.titleAttributes, encode)
            };
        case "bodyAttributes" /* BODY */ :
        case "htmlAttributes" /* HTML */ :
            return {
                toComponent: ()=>$1b385b3e3b54f286$var$convertElementAttributesToReactProps(tags),
                toString: ()=>$1b385b3e3b54f286$var$generateElementAttributesAsString(tags)
            };
        default:
            return {
                toComponent: ()=>$1b385b3e3b54f286$var$generateTagsAsReactComponent(type, tags),
                toString: ()=>$1b385b3e3b54f286$var$generateTagsAsString(type, tags, encode)
            };
    }
};
var $1b385b3e3b54f286$var$getPriorityMethods = ({ metaTags: metaTags, linkTags: linkTags, scriptTags: scriptTags, encode: encode })=>{
    const meta = $1b385b3e3b54f286$var$prioritizer(metaTags, $1b385b3e3b54f286$var$SEO_PRIORITY_TAGS.meta);
    const link = $1b385b3e3b54f286$var$prioritizer(linkTags, $1b385b3e3b54f286$var$SEO_PRIORITY_TAGS.link);
    const script = $1b385b3e3b54f286$var$prioritizer(scriptTags, $1b385b3e3b54f286$var$SEO_PRIORITY_TAGS.script);
    const priorityMethods = {
        toComponent: ()=>[
                ...$1b385b3e3b54f286$var$generateTagsAsReactComponent("meta" /* META */ , meta.priority),
                ...$1b385b3e3b54f286$var$generateTagsAsReactComponent("link" /* LINK */ , link.priority),
                ...$1b385b3e3b54f286$var$generateTagsAsReactComponent("script" /* SCRIPT */ , script.priority)
            ],
        toString: ()=>// generate all the tags as strings and concatenate them
            `${$1b385b3e3b54f286$var$getMethodsForTag("meta" /* META */ , meta.priority, encode)} ${$1b385b3e3b54f286$var$getMethodsForTag("link" /* LINK */ , link.priority, encode)} ${$1b385b3e3b54f286$var$getMethodsForTag("script" /* SCRIPT */ , script.priority, encode)}`
    };
    return {
        priorityMethods: priorityMethods,
        metaTags: meta.default,
        linkTags: link.default,
        scriptTags: script.default
    };
};
var $1b385b3e3b54f286$var$mapStateOnServer = (props)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, encode: encode = true, htmlAttributes: htmlAttributes, noscriptTags: noscriptTags, styleTags: styleTags, title: title = "", titleAttributes: titleAttributes, prioritizeSeoTags: prioritizeSeoTags } = props;
    let { linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = props;
    let priorityMethods = {
        toComponent: ()=>{},
        toString: ()=>""
    };
    if (prioritizeSeoTags) ({ priorityMethods: priorityMethods, linkTags: linkTags, metaTags: metaTags, scriptTags: scriptTags } = $1b385b3e3b54f286$var$getPriorityMethods(props));
    return {
        priority: priorityMethods,
        base: $1b385b3e3b54f286$var$getMethodsForTag("base" /* BASE */ , baseTag, encode),
        bodyAttributes: $1b385b3e3b54f286$var$getMethodsForTag("bodyAttributes" /* BODY */ , bodyAttributes, encode),
        htmlAttributes: $1b385b3e3b54f286$var$getMethodsForTag("htmlAttributes" /* HTML */ , htmlAttributes, encode),
        link: $1b385b3e3b54f286$var$getMethodsForTag("link" /* LINK */ , linkTags, encode),
        meta: $1b385b3e3b54f286$var$getMethodsForTag("meta" /* META */ , metaTags, encode),
        noscript: $1b385b3e3b54f286$var$getMethodsForTag("noscript" /* NOSCRIPT */ , noscriptTags, encode),
        script: $1b385b3e3b54f286$var$getMethodsForTag("script" /* SCRIPT */ , scriptTags, encode),
        style: $1b385b3e3b54f286$var$getMethodsForTag("style" /* STYLE */ , styleTags, encode),
        title: $1b385b3e3b54f286$var$getMethodsForTag("title" /* TITLE */ , {
            title: title,
            titleAttributes: titleAttributes
        }, encode)
    };
};
var $1b385b3e3b54f286$var$server_default = $1b385b3e3b54f286$var$mapStateOnServer;
// src/HelmetData.ts
var $1b385b3e3b54f286$var$instances = [];
var $1b385b3e3b54f286$var$isDocument = !!(typeof window !== "undefined" && window.document && window.document.createElement);
var $1b385b3e3b54f286$export$a9cf6990c9c7feb9 = class {
    instances = [];
    canUseDOM = $1b385b3e3b54f286$var$isDocument;
    context;
    value = {
        setHelmet: (serverState)=>{
            this.context.helmet = serverState;
        },
        helmetInstances: {
            get: ()=>this.canUseDOM ? $1b385b3e3b54f286$var$instances : this.instances,
            add: (instance)=>{
                (this.canUseDOM ? $1b385b3e3b54f286$var$instances : this.instances).push(instance);
            },
            remove: (instance)=>{
                const index = (this.canUseDOM ? $1b385b3e3b54f286$var$instances : this.instances).indexOf(instance);
                (this.canUseDOM ? $1b385b3e3b54f286$var$instances : this.instances).splice(index, 1);
            }
        }
    };
    constructor(context, canUseDOM){
        this.context = context;
        this.canUseDOM = canUseDOM || false;
        if (!canUseDOM) context.helmet = $1b385b3e3b54f286$var$server_default({
            baseTag: [],
            bodyAttributes: {},
            encodeSpecialCharacters: true,
            htmlAttributes: {},
            linkTags: [],
            metaTags: [],
            noscriptTags: [],
            scriptTags: [],
            styleTags: [],
            title: "",
            titleAttributes: {}
        });
    }
};
// src/Provider.tsx
var $1b385b3e3b54f286$var$defaultValue = {};
var $1b385b3e3b54f286$var$Context = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext($1b385b3e3b54f286$var$defaultValue);
var $1b385b3e3b54f286$export$4719288a8f5f7e71 = class _HelmetProvider extends (0, $eUqFw.Component) {
    static canUseDOM = $1b385b3e3b54f286$var$isDocument;
    helmetData;
    constructor(props){
        super(props);
        this.helmetData = new $1b385b3e3b54f286$export$a9cf6990c9c7feb9(this.props.context || {}, _HelmetProvider.canUseDOM);
    }
    render() {
        return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b385b3e3b54f286$var$Context.Provider, {
            value: this.helmetData.value
        }, this.props.children);
    }
};
// src/client.ts
var $1b385b3e3b54f286$var$updateTags = (type, tags)=>{
    const headElement = document.head || document.querySelector("head" /* HEAD */ );
    const tagNodes = headElement.querySelectorAll(`${type}[${$1b385b3e3b54f286$var$HELMET_ATTRIBUTE}]`);
    const oldTags = [].slice.call(tagNodes);
    const newTags = [];
    let indexToDelete;
    if (tags && tags.length) tags.forEach((tag)=>{
        const newElement = document.createElement(type);
        for(const attribute in tag)if (Object.prototype.hasOwnProperty.call(tag, attribute)) {
            if (attribute === "innerHTML" /* INNER_HTML */ ) newElement.innerHTML = tag.innerHTML;
            else if (attribute === "cssText" /* CSS_TEXT */ ) {
                if (newElement.styleSheet) newElement.styleSheet.cssText = tag.cssText;
                else newElement.appendChild(document.createTextNode(tag.cssText));
            } else {
                const attr = attribute;
                const value = typeof tag[attr] === "undefined" ? "" : tag[attr];
                newElement.setAttribute(attribute, value);
            }
        }
        newElement.setAttribute($1b385b3e3b54f286$var$HELMET_ATTRIBUTE, "true");
        if (oldTags.some((existingTag, index)=>{
            indexToDelete = index;
            return newElement.isEqualNode(existingTag);
        })) oldTags.splice(indexToDelete, 1);
        else newTags.push(newElement);
    });
    oldTags.forEach((tag)=>tag.parentNode?.removeChild(tag));
    newTags.forEach((tag)=>headElement.appendChild(tag));
    return {
        oldTags: oldTags,
        newTags: newTags
    };
};
var $1b385b3e3b54f286$var$updateAttributes = (tagName, attributes)=>{
    const elementTag = document.getElementsByTagName(tagName)[0];
    if (!elementTag) return;
    const helmetAttributeString = elementTag.getAttribute($1b385b3e3b54f286$var$HELMET_ATTRIBUTE);
    const helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    const attributesToRemove = [
        ...helmetAttributes
    ];
    const attributeKeys = Object.keys(attributes);
    for (const attribute of attributeKeys){
        const value = attributes[attribute] || "";
        if (elementTag.getAttribute(attribute) !== value) elementTag.setAttribute(attribute, value);
        if (helmetAttributes.indexOf(attribute) === -1) helmetAttributes.push(attribute);
        const indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) attributesToRemove.splice(indexToSave, 1);
    }
    for(let i = attributesToRemove.length - 1; i >= 0; i -= 1)elementTag.removeAttribute(attributesToRemove[i]);
    if (helmetAttributes.length === attributesToRemove.length) elementTag.removeAttribute($1b385b3e3b54f286$var$HELMET_ATTRIBUTE);
    else if (elementTag.getAttribute($1b385b3e3b54f286$var$HELMET_ATTRIBUTE) !== attributeKeys.join(",")) elementTag.setAttribute($1b385b3e3b54f286$var$HELMET_ATTRIBUTE, attributeKeys.join(","));
};
var $1b385b3e3b54f286$var$updateTitle = (title, attributes)=>{
    if (typeof title !== "undefined" && document.title !== title) document.title = $1b385b3e3b54f286$var$flattenArray(title);
    $1b385b3e3b54f286$var$updateAttributes("title" /* TITLE */ , attributes);
};
var $1b385b3e3b54f286$var$commitTagChanges = (newState, cb)=>{
    const { baseTag: baseTag, bodyAttributes: bodyAttributes, htmlAttributes: htmlAttributes, linkTags: linkTags, metaTags: metaTags, noscriptTags: noscriptTags, onChangeClientState: onChangeClientState, scriptTags: scriptTags, styleTags: styleTags, title: title, titleAttributes: titleAttributes } = newState;
    $1b385b3e3b54f286$var$updateAttributes("body" /* BODY */ , bodyAttributes);
    $1b385b3e3b54f286$var$updateAttributes("html" /* HTML */ , htmlAttributes);
    $1b385b3e3b54f286$var$updateTitle(title, titleAttributes);
    const tagUpdates = {
        baseTag: $1b385b3e3b54f286$var$updateTags("base" /* BASE */ , baseTag),
        linkTags: $1b385b3e3b54f286$var$updateTags("link" /* LINK */ , linkTags),
        metaTags: $1b385b3e3b54f286$var$updateTags("meta" /* META */ , metaTags),
        noscriptTags: $1b385b3e3b54f286$var$updateTags("noscript" /* NOSCRIPT */ , noscriptTags),
        scriptTags: $1b385b3e3b54f286$var$updateTags("script" /* SCRIPT */ , scriptTags),
        styleTags: $1b385b3e3b54f286$var$updateTags("style" /* STYLE */ , styleTags)
    };
    const addedTags = {};
    const removedTags = {};
    Object.keys(tagUpdates).forEach((tagType)=>{
        const { newTags: newTags, oldTags: oldTags } = tagUpdates[tagType];
        if (newTags.length) addedTags[tagType] = newTags;
        if (oldTags.length) removedTags[tagType] = tagUpdates[tagType].oldTags;
    });
    if (cb) cb();
    onChangeClientState(newState, addedTags, removedTags);
};
var $1b385b3e3b54f286$var$_helmetCallback = null;
var $1b385b3e3b54f286$var$handleStateChangeOnClient = (newState)=>{
    if ($1b385b3e3b54f286$var$_helmetCallback) cancelAnimationFrame($1b385b3e3b54f286$var$_helmetCallback);
    if (newState.defer) $1b385b3e3b54f286$var$_helmetCallback = requestAnimationFrame(()=>{
        $1b385b3e3b54f286$var$commitTagChanges(newState, ()=>{
            $1b385b3e3b54f286$var$_helmetCallback = null;
        });
    });
    else {
        $1b385b3e3b54f286$var$commitTagChanges(newState);
        $1b385b3e3b54f286$var$_helmetCallback = null;
    }
};
var $1b385b3e3b54f286$var$client_default = $1b385b3e3b54f286$var$handleStateChangeOnClient;
// src/Dispatcher.tsx
var $1b385b3e3b54f286$var$HelmetDispatcher = class extends (0, $eUqFw.Component) {
    rendered = false;
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($h295B)))(nextProps, this.props);
    }
    componentDidUpdate() {
        this.emitChange();
    }
    componentWillUnmount() {
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.remove(this);
        this.emitChange();
    }
    emitChange() {
        const { helmetInstances: helmetInstances, setHelmet: setHelmet } = this.props.context;
        let serverState = null;
        const state = $1b385b3e3b54f286$var$reducePropsToState(helmetInstances.get().map((instance)=>{
            const props = {
                ...instance.props
            };
            delete props.context;
            return props;
        }));
        if ($1b385b3e3b54f286$export$4719288a8f5f7e71.canUseDOM) $1b385b3e3b54f286$var$client_default(state);
        else if ($1b385b3e3b54f286$var$server_default) serverState = $1b385b3e3b54f286$var$server_default(state);
        setHelmet(serverState);
    }
    // componentWillMount will be deprecated
    // for SSR, initialize on first render
    // constructor is also unsafe in StrictMode
    init() {
        if (this.rendered) return;
        this.rendered = true;
        const { helmetInstances: helmetInstances } = this.props.context;
        helmetInstances.add(this);
        this.emitChange();
    }
    render() {
        this.init();
        return null;
    }
};
// src/index.tsx
var $1b385b3e3b54f286$export$dcef8f9bb9a41431 = class extends (0, $eUqFw.Component) {
    static defaultProps = {
        defer: true,
        encodeSpecialCharacters: true,
        prioritizeSeoTags: false
    };
    shouldComponentUpdate(nextProps) {
        return !(0, (/*@__PURE__*/$parcel$interopDefault($an8Qp)))($1b385b3e3b54f286$var$without(this.props, "helmetData"), $1b385b3e3b54f286$var$without(nextProps, "helmetData"));
    }
    mapNestedChildrenToProps(child, nestedChildren) {
        if (!nestedChildren) return null;
        switch(child.type){
            case "script" /* SCRIPT */ :
            case "noscript" /* NOSCRIPT */ :
                return {
                    innerHTML: nestedChildren
                };
            case "style" /* STYLE */ :
                return {
                    cssText: nestedChildren
                };
            default:
                throw new Error(`<${child.type} /> elements are self-closing and can not contain children. Refer to our API for more information.`);
        }
    }
    flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren) {
        return {
            ...arrayTypeChildren,
            [child.type]: [
                ...arrayTypeChildren[child.type] || [],
                {
                    ...newChildProps,
                    ...this.mapNestedChildrenToProps(child, nestedChildren)
                }
            ]
        };
    }
    mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren) {
        switch(child.type){
            case "title" /* TITLE */ :
                return {
                    ...newProps,
                    [child.type]: nestedChildren,
                    titleAttributes: {
                        ...newChildProps
                    }
                };
            case "body" /* BODY */ :
                return {
                    ...newProps,
                    bodyAttributes: {
                        ...newChildProps
                    }
                };
            case "html" /* HTML */ :
                return {
                    ...newProps,
                    htmlAttributes: {
                        ...newChildProps
                    }
                };
            default:
                return {
                    ...newProps,
                    [child.type]: {
                        ...newChildProps
                    }
                };
        }
    }
    mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
        let newFlattenedProps = {
            ...newProps
        };
        Object.keys(arrayTypeChildren).forEach((arrayChildName)=>{
            newFlattenedProps = {
                ...newFlattenedProps,
                [arrayChildName]: arrayTypeChildren[arrayChildName]
            };
        });
        return newFlattenedProps;
    }
    warnOnInvalidChildren(child, nestedChildren) {
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))($1b385b3e3b54f286$var$VALID_TAG_NAMES.some((name)=>child.type === name), typeof child.type === "function" ? `You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.` : `Only elements types ${$1b385b3e3b54f286$var$VALID_TAG_NAMES.join(", ")} are allowed. Helmet does not support rendering <${child.type}> elements. Refer to our API for more information.`);
        (0, (/*@__PURE__*/$parcel$interopDefault($h8TzT)))(!nestedChildren || typeof nestedChildren === "string" || Array.isArray(nestedChildren) && !nestedChildren.some((nestedChild)=>typeof nestedChild !== "string"), `Helmet expects a string as a child of <${child.type}>. Did you forget to wrap your children in braces? ( <${child.type}>{\`\`}</${child.type}> ) Refer to our API for more information.`);
        return true;
    }
    mapChildrenToProps(children, newProps) {
        let arrayTypeChildren = {};
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.forEach(children, (child)=>{
            if (!child || !child.props) return;
            const { children: nestedChildren, ...childProps } = child.props;
            const newChildProps = Object.keys(childProps).reduce((obj, key)=>{
                obj[$1b385b3e3b54f286$var$HTML_TAG_MAP[key] || key] = childProps[key];
                return obj;
            }, {});
            let { type: type } = child;
            if (typeof type === "symbol") type = type.toString();
            else this.warnOnInvalidChildren(child, nestedChildren);
            switch(type){
                case "Symbol(react.fragment)" /* FRAGMENT */ :
                    newProps = this.mapChildrenToProps(nestedChildren, newProps);
                    break;
                case "link" /* LINK */ :
                case "meta" /* META */ :
                case "noscript" /* NOSCRIPT */ :
                case "script" /* SCRIPT */ :
                case "style" /* STYLE */ :
                    arrayTypeChildren = this.flattenArrayTypeChildren(child, arrayTypeChildren, newChildProps, nestedChildren);
                    break;
                default:
                    newProps = this.mapObjectTypeChildren(child, newProps, newChildProps, nestedChildren);
                    break;
            }
        });
        return this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
    }
    render() {
        const { children: children, ...props } = this.props;
        let newProps = {
            ...props
        };
        let { helmetData: helmetData } = props;
        if (children) newProps = this.mapChildrenToProps(children, newProps);
        if (helmetData && !(helmetData instanceof $1b385b3e3b54f286$export$a9cf6990c9c7feb9)) {
            const data = helmetData;
            helmetData = new $1b385b3e3b54f286$export$a9cf6990c9c7feb9(data.context, true);
            delete newProps.helmetData;
        }
        return helmetData ? /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b385b3e3b54f286$var$HelmetDispatcher, {
            ...newProps,
            context: helmetData.value
        }) : /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b385b3e3b54f286$var$Context.Consumer, null, (context)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($1b385b3e3b54f286$var$HelmetDispatcher, {
                ...newProps,
                context: context
            }));
    }
};

});
parcelRegister("h295B", function(module, exports) {
//
module.exports = function shallowEqual(objA, objB, compare, compareContext) {
    var ret = compare ? compare.call(compareContext, objA, objB) : void 0;
    if (ret !== void 0) return !!ret;
    if (objA === objB) return true;
    if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) return false;
    var keysA = Object.keys(objA);
    var keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);
    // Test for A's keys different from B.
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key)) return false;
        var valueA = objA[key];
        var valueB = objB[key];
        ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;
        if (ret === false || ret === void 0 && valueA !== valueB) return false;
    }
    return true;
};

});



parcelRegister("i7JBv", function(module, exports) {

$parcel$export(module.exports, "default", () => $d31c4168f286ae1c$export$2e2bcd8739ae039);
parcelRequire("eUqFw");

var $2kTjx = parcelRequire("2kTjx");

var $lHkHI = parcelRequire("lHkHI");
const $d31c4168f286ae1c$var$OpenGraphMeta = (_ref)=>{
    let { canonicalUrl: canonicalUrl, description: description, image: image, title: title } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $2kTjx.Helmet), {
        prioritizeSeoTags: true,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)("meta", {
                property: "og:site_name",
                content: "Atlassian Marketplace"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            description ? /*#__PURE__*/ (0, $lHkHI.jsx)("meta", {
                property: "og:description",
                content: description
            }) : null,
            image ? /*#__PURE__*/ (0, $lHkHI.jsx)("meta", {
                property: "og:image",
                content: image
            }) : null,
            title ? /*#__PURE__*/ (0, $lHkHI.jsx)("meta", {
                property: "og:title",
                content: title
            }) : null,
            canonicalUrl ? /*#__PURE__*/ (0, $lHkHI.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }) : null
        ]
    });
};
var $d31c4168f286ae1c$export$2e2bcd8739ae039 = $d31c4168f286ae1c$var$OpenGraphMeta;

});

parcelRegister("hveJS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbe0c3c4ad7f20e2$export$2e2bcd8739ae039);
parcelRequire("eUqFw");

var $2kTjx = parcelRequire("2kTjx");

var $lHkHI = parcelRequire("lHkHI");
const $cbe0c3c4ad7f20e2$var$TwitterMeta = (_ref)=>{
    let { description: description, image: image, title: title } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $2kTjx.Helmet), {
        prioritizeSeoTags: true,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)("meta", {
                name: "twitter:card",
                content: "summary"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)("meta", {
                name: "twitter:site",
                content: "@AtlassianMarket"
            }),
            description ? /*#__PURE__*/ (0, $lHkHI.jsx)("meta", {
                name: "twitter:description",
                content: description
            }) : null,
            image ? /*#__PURE__*/ (0, $lHkHI.jsx)("meta", {
                name: "twitter:image",
                content: image
            }) : null,
            title ? /*#__PURE__*/ (0, $lHkHI.jsx)("meta", {
                name: "twitter:title",
                content: title
            }) : null
        ]
    });
};
var $cbe0c3c4ad7f20e2$export$2e2bcd8739ae039 = $cbe0c3c4ad7f20e2$var$TwitterMeta;

});


parcelRegister("5rIEI", function(module, exports) {

$parcel$export(module.exports, "PartialOutageError", () => $3f721d0fdb12546d$export$ad5e0589c09dff5f);
parcelRequire("eUqFw");

var $dWuJB = parcelRequire("dWuJB");

var $4UyA8 = parcelRequire("4UyA8");

var $Dk1Cu = parcelRequire("Dk1Cu");

var $2oo7z = parcelRequire("2oo7z");

var $lHkHI = parcelRequire("lHkHI");
const $3f721d0fdb12546d$var$getErrorContext = (level)=>{
    if (level === 'global') return {
        heading: (0, $4UyA8.locale).partialOutage.heading,
        errorMessage: (0, $4UyA8.locale).partialOutage.globalErrorMessage
    };
    if (level === 'tile') return {
        heading: (0, $4UyA8.locale).partialOutage.tileHeading,
        errorMessage: (0, $4UyA8.locale).partialOutage.errorMessage
    };
    return {
        heading: (0, $4UyA8.locale).partialOutage.sectionHeading,
        errorMessage: (0, $4UyA8.locale).partialOutage.errorMessage
    };
};
const $3f721d0fdb12546d$export$ad5e0589c09dff5f = (_ref)=>{
    let { level: level, heading: heading, errorMessage: errorMessage, children: children } = _ref;
    const contextError = $3f721d0fdb12546d$var$getErrorContext(level);
    const isGlobal = level === 'global';
    const finalHeading = level === 'component' ? null : heading || contextError.heading;
    const finalErrorMessage = errorMessage || contextError.errorMessage;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $dWuJB.ErrorTemplate), {
        heading: finalHeading,
        image: (0, (/*@__PURE__*/$parcel$interopDefault($2oo7z))),
        level: level,
        children: [
            finalErrorMessage,
            children,
            isGlobal && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    ' ',
                    (0, $4UyA8.locale).partialOutage.issuePersists,
                    " ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $Dk1Cu.StatusLink), {}),
                    " for updates."
                ]
            })
        ]
    });
};

});
parcelRegister("dWuJB", function(module, exports) {

$parcel$export(module.exports, "ErrorTemplate", () => $a268885fd2821a44$export$b79d80d2f37f30ae);
parcelRequire("eUqFw");

var $eu8X4 = parcelRequire("eu8X4");

var $ec1eM = parcelRequire("ec1eM");

var $lHkHI = parcelRequire("lHkHI");
function $a268885fd2821a44$export$14586f56bdd269d8(_ref) {
    let { onClick: onClick, label: label, children: children } = _ref;
    return label || children ? /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $ec1eM.ErrorFooterStyled), {
        children: [
            onClick && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eu8X4.Button), {
                onClick: onClick,
                children: [
                    " ",
                    label,
                    " "
                ]
            }),
            children
        ]
    }) : null;
}
const $a268885fd2821a44$var$levelToIconSize = {
    global: 'medium',
    section: 'medium',
    tile: 'small',
    component: 'small'
};
function $a268885fd2821a44$export$b79d80d2f37f30ae(props) {
    const imageAltText = props.imageAltText ? props.imageAltText : 'photo depicting an error';
    const iconSize = props.level ? $a268885fd2821a44$var$levelToIconSize[props.level] : 'medium';
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ec1eM.ErrorTemplateStyled), {
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $ec1eM.ErrorViewInner), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ec1eM.ErrorViewImage), {
                    src: props.image,
                    alt: imageAltText,
                    size: iconSize
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $ec1eM.TextContainer), {
                    children: [
                        props.heading && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ec1eM.Heading), {
                            children: props.heading
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ec1eM.Body), {
                            children: props.children
                        })
                    ]
                })
            ]
        })
    });
}

});
parcelRegister("ec1eM", function(module, exports) {

$parcel$export(module.exports, "ErrorTemplateStyled", () => $a5532567b1f0dab9$export$4065bb0633dfb5fb);
$parcel$export(module.exports, "ErrorViewInner", () => $a5532567b1f0dab9$export$ebb2cb6de4a13a5f);
$parcel$export(module.exports, "ErrorViewImage", () => $a5532567b1f0dab9$export$ee242488893edc6d);
$parcel$export(module.exports, "Heading", () => $a5532567b1f0dab9$export$a8a3e93435678ff9);
$parcel$export(module.exports, "Body", () => $a5532567b1f0dab9$export$4b2c32e08f77ff18);
$parcel$export(module.exports, "TextContainer", () => $a5532567b1f0dab9$export$762240c6611b6ed2);
$parcel$export(module.exports, "ErrorFooterStyled", () => $a5532567b1f0dab9$export$98265d61839cf424);
/* ErrorTemplate.styles.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cCrLo = parcelRequire("cCrLo");

var $lHkHI = parcelRequire("lHkHI");
const $a5532567b1f0dab9$var$_excluded = [
    "as",
    "style"
], $a5532567b1f0dab9$var$_excluded2 = [
    "as",
    "style"
], $a5532567b1f0dab9$var$_excluded3 = [
    "as",
    "style"
], $a5532567b1f0dab9$var$_excluded4 = [
    "as",
    "style"
], $a5532567b1f0dab9$var$_excluded5 = [
    "as",
    "style"
], $a5532567b1f0dab9$var$_excluded6 = [
    "as",
    "style"
], $a5532567b1f0dab9$var$_excluded7 = [
    "as",
    "style"
];
function $a5532567b1f0dab9$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a5532567b1f0dab9$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a5532567b1f0dab9$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a5532567b1f0dab9$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a5532567b1f0dab9$export$4065bb0633dfb5fb = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $a5532567b1f0dab9$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $a5532567b1f0dab9$var$_objectSpread($a5532567b1f0dab9$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _4t3i1osq _1e0c1txw _1bah1h6o _4cvr1h6o _2lx21bp4 _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    }));
});
const $a5532567b1f0dab9$export$ebb2cb6de4a13a5f = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $a5532567b1f0dab9$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $a5532567b1f0dab9$var$_objectSpread($a5532567b1f0dab9$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1wug _2hwx1wug _otyr1wug _18u01wug _y3gn1h6o _p12f1ba3",
            __cmplp.className
        ])
    }));
});
const $a5532567b1f0dab9$export$ee242488893edc6d = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "img", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $a5532567b1f0dab9$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $a5532567b1f0dab9$var$_objectSpread($a5532567b1f0dab9$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "",
            __cmplp.size === 'small' ? "_4t3i68cl" : "_4t3i1lit",
            __cmplp.className
        ])
    }));
});
const $a5532567b1f0dab9$export$a8a3e93435678ff9 = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = (0, $cCrLo.H5), style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $a5532567b1f0dab9$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $a5532567b1f0dab9$var$_objectSpread($a5532567b1f0dab9$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1dyznl7k _ca0q1bcc _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    }));
});
const $a5532567b1f0dab9$export$4b2c32e08f77ff18 = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $a5532567b1f0dab9$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $a5532567b1f0dab9$var$_objectSpread($a5532567b1f0dab9$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0q1eps _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    }));
});
const $a5532567b1f0dab9$export$762240c6611b6ed2 = (0, $eUqFw.forwardRef)((_ref6, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref6, __cmplp = (0, $bwPfh.default)(_ref6, $a5532567b1f0dab9$var$_excluded6);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $a5532567b1f0dab9$var$_objectSpread($a5532567b1f0dab9$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _1wyb1j6v",
            __cmplp.className
        ])
    }));
});
const $a5532567b1f0dab9$export$98265d61839cf424 = (0, $eUqFw.forwardRef)((_ref7, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref7, __cmplp = (0, $bwPfh.default)(_ref7, $a5532567b1f0dab9$var$_excluded7);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $a5532567b1f0dab9$var$_objectSpread($a5532567b1f0dab9$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkv47k",
            __cmplp.className
        ])
    }));
});

});


parcelRegister("4UyA8", function(module, exports) {

$parcel$export(module.exports, "locale", () => $3937379fc5158783$export$162ce11d62a1ca51);
const $3937379fc5158783$export$162ce11d62a1ca51 = {
    or: 'or',
    youCan: 'You can',
    goBack: 'go back',
    goToHome: 'Go to home',
    goToOur: 'go to our',
    contactSupport: 'contact support',
    statusPage: 'status page',
    homePage: 'home page',
    forUpdates: 'for updates',
    supportTeam: 'support team',
    notFound: {
        title: "We couldn\u2019t find the page you\u2019re looking for",
        heading: "We couldn\u2019t find the page you\u2019re looking for",
        pageNotExist: 'Refresh the page or return to the',
        contactSupportTeam: 'contact our support team'
    },
    outage: {
        title: "We\u2019re experiencing an outage",
        heading: "We\u2019re experiencing an outage",
        teamInvestigatingIssue: "Our team is already on it. We\u2019re investigating the issue. Please find more information from the ",
        urgentAssistance: 'If you need urgent assistance,'
    },
    partialOutage: {
        title: "We\u2019re experiencing an issue",
        heading: "We\u2019re experiencing an issue",
        sectionHeading: "We\u2019re unable to load this section",
        tileHeading: "We\u2019re unable to load more apps",
        errorMessage: 'Refresh the page or try again in some time.',
        issuePersists: 'If the issue persists, check the ',
        urgentAssistance: 'If you need urgent assistance,',
        globalErrorMessage: 'Refreshing the page may help.'
    }
};

});

parcelRegister("Dk1Cu", function(module, exports) {

$parcel$export(module.exports, "StatusLink", () => $07632d34aaec437c$export$669119613bd206da);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("eUqFw");

var $lMIGT = parcelRequire("lMIGT");

var $4UyA8 = parcelRequire("4UyA8");

var $bp2pr = parcelRequire("bp2pr");

var $lHkHI = parcelRequire("lHkHI");
function $07632d34aaec437c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $07632d34aaec437c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $07632d34aaec437c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $07632d34aaec437c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $07632d34aaec437c$export$669119613bd206da = (props)=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bp2pr.RedirectLink), $07632d34aaec437c$var$_objectSpread($07632d34aaec437c$var$_objectSpread({
        href: "https://developer.status.atlassian.com",
        "data-testid": (0, $lMIGT.TEST_IDS).APP_STATUS_LINK,
        target: "_blank"
    }, props), {}, {
        children: props.children || (0, $4UyA8.locale).statusPage
    }));
};

});
parcelRegister("bp2pr", function(module, exports) {

$parcel$export(module.exports, "RedirectLink", () => $84d3e5f372b99f64$export$d2bd83038dbd12d3);
/* RedirectLink.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ixQHh = parcelRequire("ixQHh");

var $lHkHI = parcelRequire("lHkHI");
const $84d3e5f372b99f64$var$_excluded = [
    "as",
    "style"
];
function $84d3e5f372b99f64$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $84d3e5f372b99f64$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $84d3e5f372b99f64$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $84d3e5f372b99f64$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $84d3e5f372b99f64$export$e36a9335ac215bfc = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = (0, $ixQHh.Link), style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $84d3e5f372b99f64$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $84d3e5f372b99f64$var$_objectSpread($84d3e5f372b99f64$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_vwz41tcg _k48p1nn1",
            __cmplp.className
        ])
    }));
});
const $84d3e5f372b99f64$export$d2bd83038dbd12d3 = (props)=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)($84d3e5f372b99f64$export$e36a9335ac215bfc, $84d3e5f372b99f64$var$_objectSpread($84d3e5f372b99f64$var$_objectSpread({
        size: "medium",
        rel: "noopener noreferrer"
    }, props), {}, {
        children: props.children
    }));
};

});


parcelRegister("2oo7z", function(module, exports) {
module.exports = new URL("PartialOutageError.fd67bc0a.svg", import.meta.url).toString();

});


parcelRegister("cHuSy", function(module, exports) {

$parcel$export(module.exports, "SearchEmbedded", () => $93f1741b79be2939$export$a724344e7f28253d);
/* SearchEmbedded.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $9AuiZ = parcelRequire("9AuiZ");

var $DtoqF = parcelRequire("DtoqF");
var $ag464 = parcelRequire("ag464");

var $lHkHI = parcelRequire("lHkHI");
const $93f1741b79be2939$var$_excluded = [
    "as",
    "style"
], $93f1741b79be2939$var$_excluded2 = [
    "as",
    "style"
];
function $93f1741b79be2939$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $93f1741b79be2939$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $93f1741b79be2939$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $93f1741b79be2939$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $93f1741b79be2939$var$SearchEmbeddedWrapper = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $93f1741b79be2939$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $93f1741b79be2939$var$_objectSpread($93f1741b79be2939$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1y6m _zulp1b66 _kqswh2mm",
            __cmplp.className
        ])
    }));
});
const $93f1741b79be2939$var$FullWidthSearchDropdown = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $93f1741b79be2939$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $93f1741b79be2939$var$_objectSpread($93f1741b79be2939$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_kqsw1n9t _154iidpf _1ltvidpf _1bsb1osq _4t3i1osq _1pbyjbo9 _11q76ota",
            __cmplp.className
        ])
    }));
});
const $93f1741b79be2939$export$a724344e7f28253d = (_ref3)=>{
    let { searchInputRef: searchInputRef, additionalQueryParams: additionalQueryParams = {}, searchPlaceholder: searchPlaceholder } = _ref3;
    const [searchOverlayVisible, setSearchOverlayVisible] = (0, $eUqFw.useState)(false);
    const searchDropdownOverlayref = (0, $eUqFw.useRef)(null);
    const backButtonRef = (0, $eUqFw.useRef)(null);
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const handleViewedAnalytics = (_ref4)=>{
        let { query: query, suggestionSource: suggestionSource, count: count } = _ref4;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.SearchEmbeddedViewEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).SEARCH_EMBEDDED_VIEW,
            attributes: {
                query: query,
                suggestionSource: suggestionSource,
                count: count
            }
        });
    };
    const handleSearchItemSelectionAnalytics = (_ref5)=>{
        let { query: query, position: position, popularity: popularity, suggestionSource: suggestionSource, count: count } = _ref5;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.SearchEmbeddedSuggestionClickEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).SEARCH_EMBEDDED_ITEM_SELECTED,
            attributes: {
                query: query,
                position: position,
                popularity: popularity,
                suggestionSource: suggestionSource,
                count: count
            }
        });
    };
    const handleEnterKeyPressAnalytics = (_ref6)=>{
        let { query: query, suggestionSource: suggestionSource, count: count } = _ref6;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.SearchEmbeddedEnterKeyEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).SEARCH_EMBEDDED_ENTER_KEY_PRESSED,
            attributes: {
                query: query,
                position: -1,
                suggestionSource: suggestionSource,
                count: count
            }
        });
    };
    const onBlur = (e)=>{
        if (searchDropdownOverlayref.current && !searchDropdownOverlayref.current.contains(e.relatedTarget) && backButtonRef.current) backButtonRef.current.focus();
    };
    const searchInput = /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ag464.SearchDropdownOverlay), {
        onViewed: handleViewedAnalytics,
        closeOverlay: ()=>{
            setSearchOverlayVisible(false);
        },
        onSuggestionSelection: handleSearchItemSelectionAnalytics,
        onEnterKeyPress: handleEnterKeyPressAnalytics,
        backButtonRef: backButtonRef,
        additionalQueryParams: additionalQueryParams
    });
    if (searchOverlayVisible) return /*#__PURE__*/ (0, $lHkHI.jsx)($93f1741b79be2939$var$FullWidthSearchDropdown, {
        ref: searchDropdownOverlayref,
        onBlur: onBlur,
        children: searchInput
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)($93f1741b79be2939$var$SearchEmbeddedWrapper, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $DtoqF.SearchDropdownEmbedded), {
            onViewed: handleViewedAnalytics,
            onSuggestionSelection: handleSearchItemSelectionAnalytics,
            onEnterKeyPress: handleEnterKeyPressAnalytics,
            searchInputRef: searchInputRef,
            onInputFocus: ()=>{
                setSearchOverlayVisible(true);
            },
            searchPlaceholder: searchPlaceholder,
            additionalQueryParams: additionalQueryParams
        })
    });
};

});
parcelRegister("DtoqF", function(module, exports) {

$parcel$export(module.exports, "SearchDropdownEmbedded", () => $076a71794994d815$export$5c0db4cc89df6d80);
/* SearchDropdownEmbedded.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hXNHP = parcelRequire("hXNHP");


var $lMOk7 = parcelRequire("lMOk7");
var $cpR7D = parcelRequire("cpR7D");

var $dM9ZW = parcelRequire("dM9ZW");

var $c0qPT = parcelRequire("c0qPT");

var $ai7SS = parcelRequire("ai7SS");

var $hCl9L = parcelRequire("hCl9L");

var $9AuiZ = parcelRequire("9AuiZ");

var $gCUJI = parcelRequire("gCUJI");

var $118My = parcelRequire("118My");

var $fItra = parcelRequire("fItra");

var $POywL = parcelRequire("POywL");

var $7RGla = parcelRequire("7RGla");

var $ks7ft = parcelRequire("ks7ft");

var $8qFnR = parcelRequire("8qFnR");

var $eEXJs = parcelRequire("eEXJs");

var $lHkHI = parcelRequire("lHkHI");
const $076a71794994d815$var$_excluded = [
    "as",
    "style"
], $076a71794994d815$var$_excluded2 = [
    "showFocused"
], $076a71794994d815$var$_excluded3 = [
    "as",
    "style"
], $076a71794994d815$var$_excluded4 = [
    "as",
    "style"
], $076a71794994d815$var$_excluded5 = [
    "as",
    "style"
], $076a71794994d815$var$_excluded6 = [
    "isPlaceHolder"
];
function $076a71794994d815$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $076a71794994d815$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $076a71794994d815$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $076a71794994d815$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $076a71794994d815$var$Header = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $076a71794994d815$var$_excluded);
    const { showFocused: showFocused } = __cmplp, __cmpldp = (0, $bwPfh.default)(__cmplp, $076a71794994d815$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $076a71794994d815$var$_objectSpread($076a71794994d815$var$_objectSpread({}, __cmpldp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1ylp _1yt41eps _1e0c1txw _vchhusvi _zulp1eps _syaz1jij _2rkoi2wt _19it1axk _bfhk6ota _4cvr1h6o _1yag1dzv",
            __cmplp.showFocused ? "_1h6d1oj9" : "_1h6d4emh",
            __cmplp.className
        ])
    }));
});
const $076a71794994d815$var$SearchBodyWrapper = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $076a71794994d815$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $076a71794994d815$var$_objectSpread($076a71794994d815$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_bfhkipex _1bsb1osq _2rkoftgi _kqswstnw _154i1ady _1pbykb7n _16qs1402",
            __cmplp.className
        ])
    }));
});
const $076a71794994d815$var$SearchEmbeddedDropdown = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $076a71794994d815$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $076a71794994d815$var$_objectSpread($076a71794994d815$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    }));
});
const $076a71794994d815$var$SearchButtonMobile = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "button", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $076a71794994d815$var$_excluded5);
    const { isPlaceHolder: isPlaceHolder } = __cmplp, __cmpldp = (0, $bwPfh.default)(__cmplp, $076a71794994d815$var$_excluded6);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $076a71794994d815$var$_objectSpread($076a71794994d815$var$_objectSpread({}, __cmpldp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4t3i1ylp _1bsb1osq _ect48q0o _vwz41j6v _1wyb1j6v _zulp1eps _2rkoi2wt _19it1vvc _11q71xnl _4cvr1h6o _1yt41val _1ygb4suz",
            __cmplp.isPlaceHolder ? "_syaz1jij" : "_syaz1kw7",
            __cmplp.className
        ])
    }));
});
const $076a71794994d815$var$recentSearch = new (0, $gCUJI.RecentSearch)(5, 'mpac-search-recent-searches');
function $076a71794994d815$export$5c0db4cc89df6d80(_ref5) {
    var _searchPlaceholder$de;
    let { searchInputRef: searchInputRef, onInputFocus: onInputFocus, onViewed: onViewed, onSuggestionSelection: onSuggestionSelection, onEnterKeyPress: onEnterKeyPress, additionalQueryParams: additionalQueryParams, searchPlaceholder: searchPlaceholder } = _ref5;
    const searchembeddedRef = (0, $eUqFw.useRef)(null);
    const [showSuggestionPopup, setShowSuggestionPopup] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(false);
    const [showFocused, setShowFocused] = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useState(false);
    const searchSuggestionCountRef = (0, $eUqFw.useRef)(0);
    const hasFiredViewedAnalyticsRef = (0, $eUqFw.useRef)(false);
    const source = (0, $c0qPT.useSource)();
    const mountPath = (0, $c0qPT.useMountPath)();
    // LOCATION HANDLINGS
    const { query: queryFromUrl } = (0, $dM9ZW.useQueryParams)();
    const locationHref = (0, $dM9ZW.useLocationHref)();
    const history = (0, $dM9ZW.useHistory)();
    // AUTOCOMPLETE HANDLINGS
    const ref = (0, $eUqFw.useRef)(null);
    const inputRef = searchInputRef !== null && searchInputRef !== void 0 ? searchInputRef : ref;
    const handleNewSearch = (0, $eUqFw.useCallback)((hit)=>{
        var _inputRef$current, _hit$__autocomplete_i, _inputRef$current2;
        const inputValue = (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.value;
        onSuggestionSelection({
            query: hit.query,
            position: ((_hit$__autocomplete_i = hit.__autocomplete_id) !== null && _hit$__autocomplete_i !== void 0 ? _hit$__autocomplete_i : 0) + 1,
            popularity: hit.popularity,
            suggestionSource: (0, $hCl9L.getSuggestionSource)(!!inputValue),
            count: inputValue ? searchSuggestionCountRef.current : $076a71794994d815$var$recentSearch.count()
        });
        $076a71794994d815$var$recentSearch.push(hit);
        // The following code resolves a bug experienced in SRP. Previously, when the input field text was cleared,
        // reselecting the same text from the recent search list did not repopulate the input field.
        // The function setQuery() is used to set the selected hit in the autocomplete object.
        autocomplete.setQuery(hit.query);
        (0, $118My.redirectToNewQuery)({
            query: hit.query,
            locationHref: locationHref,
            history: history,
            additionalQueryParams: additionalQueryParams,
            source: source,
            mountPath: mountPath
        });
        setShowSuggestionPopup(false);
        inputRef === null || inputRef === void 0 || (_inputRef$current2 = inputRef.current) === null || _inputRef$current2 === void 0 || _inputRef$current2.blur();
    }, [
        onSuggestionSelection,
        locationHref,
        history,
        additionalQueryParams
    ]);
    const { value: breakpoint } = (0, $cpR7D.useResponsiveBreakpoint)();
    const isMobile = breakpoint < (0, $lMOk7.breakpointValues).md;
    const showFullScreenComponent = breakpoint <= (0, $lMOk7.breakpointValues).sm;
    const { autocomplete: autocomplete, autocompleteState: autocompleteState } = (0, $ai7SS.useAlgoliaAutocomplete)(inputRef, // we only need to set the placeholder for the desktop view using Algolia Client SDK,
    // for mobile view a button is rendered which opens SearchDropdownOverlay Component
    source === 'PRODUCT' ? (0, $9AuiZ.inProductPlaceholder) : (_searchPlaceholder$de = searchPlaceholder === null || searchPlaceholder === void 0 ? void 0 : searchPlaceholder.desktop) !== null && _searchPlaceholder$de !== void 0 ? _searchPlaceholder$de : (0, $9AuiZ.embeddedPlaceholder), queryFromUrl, handleNewSearch, $076a71794994d815$var$recentSearch);
    // hide suggestions on clicking outside search embedded component
    (0, $ks7ft.useOutsideClick)(searchembeddedRef, ()=>setShowSuggestionPopup(false));
    const { handleAppend: handleAppend, handleEnterKeyPress: handleEnterKeyPress, clearRecentSearches: clearRecentSearches, clearSearchInput: clearSearchInput } = (0, $8qFnR.useSearchDropdown)({
        inputRef: inputRef,
        autocomplete: autocomplete,
        autocompleteState: autocompleteState,
        recentSearch: $076a71794994d815$var$recentSearch,
        onEnterKeyPress: onEnterKeyPress,
        additionalQueryParams: additionalQueryParams
    });
    // BODY STATE HANDLINGS
    const { bodyState: bodyState } = (0, $7RGla.useAutocompleteState)({
        autocompleteState: autocompleteState
    });
    const searchSuggestionProps = {
        hits: autocompleteState.collections,
        autocomplete: autocomplete,
        onAppend: handleAppend
    };
    (0, $eUqFw.useEffect)(()=>{
        var _autocompleteState$co, _autocompleteState$co2, _autocompleteState$co3;
        searchSuggestionCountRef.current = (_autocompleteState$co = (_autocompleteState$co2 = autocompleteState.collections[0]) === null || _autocompleteState$co2 === void 0 ? void 0 : (_autocompleteState$co3 = _autocompleteState$co2.items) === null || _autocompleteState$co3 === void 0 ? void 0 : _autocompleteState$co3.length) !== null && _autocompleteState$co !== void 0 ? _autocompleteState$co : 0;
    }, [
        bodyState,
        autocompleteState
    ]);
    (0, $eEXJs.useSearchViewAnalytics)({
        showSuggestionPopup: showSuggestionPopup,
        inputRef: inputRef,
        isQueryFromUrl: !!queryFromUrl,
        onViewed: onViewed,
        recentSearch: $076a71794994d815$var$recentSearch,
        hasFiredViewedAnalyticsRef: hasFiredViewedAnalyticsRef,
        autocompleteState: autocompleteState,
        bodyState: bodyState
    });
    const showSuggestionView = (0, $eUqFw.useCallback)(()=>{
        hasFiredViewedAnalyticsRef.current = false;
        setShowSuggestionPopup(true);
        setShowFocused(true);
        if (showFullScreenComponent) onInputFocus();
    }, [
        onInputFocus,
        showFullScreenComponent
    ]);
    const onKeyDown = (e)=>{
        if (e.key === 'Tab' && e.shiftKey) {
            var _inputRef$current3;
            setShowSuggestionPopup(false);
            (_inputRef$current3 = inputRef.current) === null || _inputRef$current3 === void 0 || _inputRef$current3.blur();
        }
        if (e.key === 'ArrowDown') showSuggestionView();
    };
    const onKeyDownHandler = (e)=>{
        if (e.key === 'Tab') {
            var _inputRef$current4;
            setShowSuggestionPopup(false);
            (_inputRef$current4 = inputRef.current) === null || _inputRef$current4 === void 0 || _inputRef$current4.blur();
        }
    };
    const onFocus = ()=>{
        if (!isMobile) showSuggestionView();
    };
    const onBlur = (e)=>{
        if (searchembeddedRef.current && !searchembeddedRef.current.contains(e.relatedTarget)) setShowSuggestionPopup(false);
    };
    const onFormSubmit = (query)=>{
        handleEnterKeyPress(query);
        setShowSuggestionPopup(false);
    };
    const { value: searchText } = autocomplete.getInputProps({
        inputElement: inputRef === null || inputRef === void 0 ? void 0 : inputRef.current
    });
    if (isMobile) return /*#__PURE__*/ (0, $lHkHI.jsxs)($076a71794994d815$var$SearchButtonMobile, {
        onClick: showSuggestionView,
        "aria-label": "Search",
        isPlaceHolder: !searchText,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hXNHP))), {
                label: "search"
            }),
            searchText || (searchPlaceholder === null || searchPlaceholder === void 0 ? void 0 : searchPlaceholder.mobile) || (0, $9AuiZ.mobilePlaceholder)
        ]
    });
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($076a71794994d815$var$SearchEmbeddedDropdown, {
        ref: searchembeddedRef,
        onBlur: onBlur,
        tabIndex: -1,
        onKeyDown: onKeyDown,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($076a71794994d815$var$Header, {
                showFocused: showFocused,
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $POywL.SearchHeader), {
                    autocomplete: autocomplete,
                    ref: inputRef,
                    handleEnterKeyPress: onFormSubmit,
                    clearSearchInput: clearSearchInput,
                    onBlur: ()=>setShowFocused(false),
                    onFocus: onFocus,
                    isEmbedded: true,
                    showFullScreenComponent: showFullScreenComponent,
                    onClearTextKeyDown: onKeyDownHandler
                })
            }),
            showSuggestionPopup && /*#__PURE__*/ (0, $lHkHI.jsx)($076a71794994d815$var$SearchBodyWrapper, {
                role: "status",
                "aria-live": "assertive",
                "aria-relevant": "additions",
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fItra.SearchBodyFactory), {
                    type: bodyState,
                    searchQuerySuggestionsBodyProps: $076a71794994d815$var$_objectSpread({
                        query: autocompleteState.query
                    }, searchSuggestionProps),
                    searchLoadingProps: {
                        query: autocompleteState.query
                    },
                    recentSearchBodyProps: $076a71794994d815$var$_objectSpread({
                        onClearAll: clearRecentSearches,
                        onKeyDown: onKeyDownHandler
                    }, searchSuggestionProps),
                    noSuggestionsBodyProps: {
                        query: autocompleteState.query
                    }
                })
            })
        ]
    });
}

});
parcelRegister("ks7ft", function(module, exports) {

$parcel$export(module.exports, "useOutsideClick", () => $ee3c0b9d3b441fc6$export$71b2224f1ce5e08e);

var $eUqFw = parcelRequire("eUqFw");
const $ee3c0b9d3b441fc6$export$71b2224f1ce5e08e = (ref, onOutsideClickCallback)=>{
    (0, $eUqFw.useEffect)(()=>{
        function handleClickOutside(event) {
            if (ref.current && !ref.current.contains(event.target)) onOutsideClickCallback();
        }
        document.addEventListener('mousedown', handleClickOutside);
        return ()=>{
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [
        ref
    ]);
};

});



parcelRegister("9zYxS", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f9658f8f0347cb6$export$2e2bcd8739ae039);

var $jFYgO = parcelRequire("jFYgO");
var $6a7WY = parcelRequire("6a7WY");

var $dM9ZW = parcelRequire("dM9ZW");
parcelRequire("eUqFw");

var $5aU0h = parcelRequire("5aU0h");

var $lHkHI = parcelRequire("lHkHI");
const $6f9658f8f0347cb6$var$SearchBreadcrumbs = ()=>{
    const history = (0, $dM9ZW.useHistory)();
    const handleBreadcrumbsClick = (event)=>{
        event.preventDefault();
        history === null || history === void 0 || history.push('/');
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $jFYgO.Breadcrumbs), {
        testId: (0, $5aU0h.TEST_IDS).SEARCH_PAGE_BREADCRUMBS,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6a7WY.default), {
                href: "/",
                onClick: handleBreadcrumbsClick,
                text: "Marketplace"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6a7WY.default), {
                text: "Search",
                onClick: (e)=>e.preventDefault()
            })
        ]
    });
};
var $6f9658f8f0347cb6$export$2e2bcd8739ae039 = $6f9658f8f0347cb6$var$SearchBreadcrumbs;

});
parcelRegister("jFYgO", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $e5309909ce6ac51f$export$2dc68d50d56fbbd);
/* Breadcrumbs.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $6a7WY = parcelRequire("6a7WY");
var $czBq9 = parcelRequire("czBq9");


var $lHkHI = parcelRequire("lHkHI");
const $e5309909ce6ac51f$var$_excluded = [
    "as",
    "style"
], $e5309909ce6ac51f$var$_excluded2 = [
    "textColor"
];
function $e5309909ce6ac51f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e5309909ce6ac51f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e5309909ce6ac51f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e5309909ce6ac51f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e5309909ce6ac51f$var$BreadcrumbsWrapper = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $e5309909ce6ac51f$var$_excluded);
    const { textColor: textColor } = __cmplp, __cmpldp = (0, $bwPfh.default)(__cmplp, $e5309909ce6ac51f$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $e5309909ce6ac51f$var$_objectSpread($e5309909ce6ac51f$var$_objectSpread({}, __cmpldp), {}, {
        style: $e5309909ce6ac51f$var$_objectSpread($e5309909ce6ac51f$var$_objectSpread({}, __cmpls), {}, {
            "--_93wphf": (0, $9t7rW.default)(__cmplp.textColor || "var(--ds-text-subtle)")
        }),
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1dzo18uv _gxv518uv _ij3o1sdi _1tjqgfg7 _1uq94jg8 _1kd31nn1 _nzz5oxwj _13t31tcg",
            __cmplp.className
        ])
    }));
});
const $e5309909ce6ac51f$export$2dc68d50d56fbbd = (props)=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)($e5309909ce6ac51f$var$BreadcrumbsWrapper, {
        textColor: props.textColor,
        className: props.className,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $czBq9.default), $e5309909ce6ac51f$var$_objectSpread({}, props))
    });
};

});

parcelRegister("5aU0h", function(module, exports) {

$parcel$export(module.exports, "TEST_IDS", () => $3c49540aa4e0217a$export$a2b4f255152a6585);
const $3c49540aa4e0217a$export$a2b4f255152a6585 = {
    SEARCH_PAGE_BREADCRUMBS: 'search-page-breadcrumbs'
};

});


parcelRegister("ltRHi", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa35f5993d5f0599$export$2e2bcd8739ae039);
/* SearchHeading.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cCrLo = parcelRequire("cCrLo");

var $lHkHI = parcelRequire("lHkHI");
const $fa35f5993d5f0599$var$_excluded = [
    "children"
], $fa35f5993d5f0599$var$_excluded2 = [
    "as",
    "style"
];
function $fa35f5993d5f0599$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fa35f5993d5f0599$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fa35f5993d5f0599$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fa35f5993d5f0599$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $fa35f5993d5f0599$var$H1 = (_ref)=>{
    let { children: children } = _ref, props = (0, $bwPfh.default)(_ref, $fa35f5993d5f0599$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.H3), $fa35f5993d5f0599$var$_objectSpread($fa35f5993d5f0599$var$_objectSpread({
        as: "h1"
    }, props), {}, {
        children: children
    }));
};
const $fa35f5993d5f0599$var$Heading = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = $fa35f5993d5f0599$var$H1, style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $fa35f5993d5f0599$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $fa35f5993d5f0599$var$_objectSpread($fa35f5993d5f0599$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1mou1fhj",
            __cmplp.className
        ])
    }));
});
const $fa35f5993d5f0599$var$toCapitalCase = (str)=>str.charAt(0).toUpperCase() + str.slice(1);
const $fa35f5993d5f0599$var$SearchHeading = (_ref3)=>{
    let { isSearchQueryActive: isSearchQueryActive, areFiltersActive: areFiltersActive, productName: productName } = _ref3;
    if (productName) return /*#__PURE__*/ (0, $lHkHI.jsx)($fa35f5993d5f0599$var$Heading, {
        children: isSearchQueryActive || areFiltersActive ? "Search results for ".concat($fa35f5993d5f0599$var$toCapitalCase(productName)) : "Explore apps for ".concat($fa35f5993d5f0599$var$toCapitalCase(productName))
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)($fa35f5993d5f0599$var$Heading, {
        children: isSearchQueryActive || areFiltersActive ? 'Search results' : 'Search for apps'
    });
};
var $fa35f5993d5f0599$export$2e2bcd8739ae039 = $fa35f5993d5f0599$var$SearchHeading;

});

parcelRegister("jiZH7", function(module, exports) {

$parcel$export(module.exports, "SearchResults", () => $e0df8e04f3e1beb6$export$aee53da69e9839be);

var $bwPfh = parcelRequire("bwPfh");

var $14GMt = parcelRequire("14GMt");
var $upfHx = parcelRequire("upfHx");
var $iADnD = parcelRequire("iADnD");
var $kGAO3 = parcelRequire("kGAO3");

var $lMOk7 = parcelRequire("lMOk7");
var $7ELm9 = parcelRequire("7ELm9");
var $ctw0C = parcelRequire("ctw0C");
var $cpR7D = parcelRequire("cpR7D");

var $dM9ZW = parcelRequire("dM9ZW");

var $c0qPT = parcelRequire("c0qPT");

var $eUqFw = parcelRequire("eUqFw");

var $5kA21 = parcelRequire("5kA21");

var $fHQub = parcelRequire("fHQub");

var $kZkyb = parcelRequire("kZkyb");
var $2yXdH = parcelRequire("2yXdH");

var $lHkHI = parcelRequire("lHkHI");
const $e0df8e04f3e1beb6$var$_excluded = [
    "sort",
    "query"
];
function $e0df8e04f3e1beb6$export$aee53da69e9839be(_ref) {
    let { searchInputRef: searchInputRef, gridProps: gridProps, isSearchQueryActive: isSearchQueryActive, onSortOptionSelect: onSortOptionSelect, areFiltersActive: areFiltersActive, handleClearAllFilters: handleClearAllFilters, selectedSortKey: selectedSortKey, analyticsFilters: analyticsFilters, isAppInstalled: isAppInstalled } = _ref;
    const { totalCount: totalCount, appList: appList, isLoading: isLoading, isLoadingMore: isLoadingMore, showLoadMoreButton: showLoadMoreButton, fetchMoreApps: fetchMoreApps, initialFetchError: initialFetchError, fetchMoreError: fetchMoreError, rawData: rawData } = gridProps;
    // we need to show loading
    // - when query is waiting to be fetched (!rawData && !initialFetchError)
    // - being fetched (isLoading)
    const showInitialLoading = isLoading || !rawData && !initialFetchError;
    const showEndReachedLabel = !showInitialLoading && !initialFetchError && totalCount > 0;
    const showNoResultView = !showInitialLoading && !initialFetchError && totalCount === 0;
    const [tileToFocusIndex, setTileToFocusIndex] = (0, $eUqFw.useState)(-1);
    const hostUrl = (0, $c0qPT.useHostUrl)();
    const source = (0, $c0qPT.useSource)();
    const mountPath = (0, $c0qPT.useMountPath)();
    const environment = (0, $c0qPT.useEnvironment)();
    const history = (0, $dM9ZW.useHistory)();
    const { value: breakpoint } = (0, $cpR7D.useResponsiveBreakpoint)();
    const isMobile = breakpoint < (0, $lMOk7.breakpointValues).sm;
    const { handleTileClickAnalytics: handleTileClickAnalytics, handleLoadMoreClickAnalytics: handleLoadMoreClickAnalytics, handleClearAllFiltersAnalytics: handleClearAllFiltersAnalytics, handleFilterSelectionAnalytics: handleFilterSelectionAnalytics, handleYourSearchQueryClickAnalytics: handleYourSearchQueryClickAnalytics } = (0, $5kA21.useSearchPageAnalytics)();
    const handleOnTileClick = (tileData, index)=>{
        (0, $upfHx.onTileClick)(tileData, source, hostUrl, mountPath, history);
        handleTileClickAnalytics({
            tileData: tileData,
            hitRank: index + 1,
            filters: analyticsFilters
        });
    };
    const handleLoadMoreClick = async (event)=>{
        handleLoadMoreClickAnalytics({
            pageNumber: appList.length / (0, $iADnD.PAGINATED_APP_GRID_CONFIG).fetchMoreCount,
            filters: analyticsFilters
        });
        await fetchMoreApps(event);
        // if load more is triggered via keypress, focus first newly loaded tile
        if (event.detail === 0) setTileToFocusIndex(appList.length);
    };
    const onClearFiltersClick = ()=>{
        handleClearAllFilters === null || handleClearAllFilters === void 0 || handleClearAllFilters();
        const { sort: sort, query: query } = analyticsFilters, filters = (0, $bwPfh.default)(analyticsFilters, $e0df8e04f3e1beb6$var$_excluded);
        handleClearAllFiltersAnalytics({
            filters: filters
        });
    };
    const handleSortOptionSelect = (sortOption)=>{
        onSortOptionSelect(sortOption);
        handleFilterSelectionAnalytics({
            filterType: 'sort',
            filterValue: sortOption.label
        });
    };
    const handleLinkClick = ()=>{
        var _searchInputRef$curre, _searchInputRef$curre2;
        (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 || _searchInputRef$curre.focus();
        handleYourSearchQueryClickAnalytics({
            query: (_searchInputRef$curre2 = searchInputRef.current) === null || _searchInputRef$curre2 === void 0 ? void 0 : _searchInputRef$curre2.value
        });
    };
    const handleTileToFocus = (0, $eUqFw.useCallback)((ref)=>{
        if (ref) {
            ref.focus();
            setTileToFocusIndex(-1);
        }
    }, []);
    if (showNoResultView) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7ELm9.default), {
        showClearFilterButton: areFiltersActive,
        onClearFiltersClick: onClearFiltersClick,
        title: "We couldn't find a match for your query!",
        description: areFiltersActive ? 'Try rephrasing or changing your selection of filters' : 'Try rephrasing or search with another query'
    });
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            !initialFetchError && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fHQub.GridHeader), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2yXdH.default), {
                        isSearchQueryActive: isSearchQueryActive,
                        totalCount: totalCount,
                        isLoading: showInitialLoading,
                        areFiltersActive: areFiltersActive
                    }),
                    !isMobile && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ctw0C.SortDropdown), {
                        onSortOptionSelect: handleSortOptionSelect,
                        selectedSortKey: selectedSortKey
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kGAO3.PaginatedAppGrid), {
                isLoading: showInitialLoading,
                isLoadingMore: isLoadingMore,
                onLoadMoreClick: handleLoadMoreClick,
                showLoadMoreButton: showLoadMoreButton,
                renderGrid: ()=>appList.map((app, index)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $14GMt.AppTile), {
                            tileData: app,
                            environment: environment,
                            source: source,
                            onTileClick: ()=>handleOnTileClick(app, index),
                            tileRef: index === tileToFocusIndex ? handleTileToFocus : undefined,
                            isAppInstalled: isAppInstalled
                        }, index)),
                fetchMoreError: fetchMoreError,
                initialFetchError: initialFetchError
            }),
            showEndReachedLabel && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kZkyb.default), {
                onLinkClick: handleLinkClick
            })
        ]
    });
}

});
parcelRegister("14GMt", function(module, exports) {

$parcel$export(module.exports, "AppTile", () => $0c87598a4d19514c$export$2a298f46c8d3fd05);

var $5zQU9 = parcelRequire("5zQU9");

var $j8E8v = parcelRequire("j8E8v");

var $gwoWU = parcelRequire("gwoWU");

var $j0vr1 = parcelRequire("j0vr1");

var $kafab = parcelRequire("kafab");

var $ammkg = parcelRequire("ammkg");

var $3BBSQ = parcelRequire("3BBSQ");

var $76fzC = parcelRequire("76fzC");
var $c0qPT = parcelRequire("c0qPT");
parcelRequire("eUqFw");

var $1TCPZ = parcelRequire("1TCPZ");

var $hnWN5 = parcelRequire("hnWN5");

var $6Zbi4 = parcelRequire("6Zbi4");

var $hz1aR = parcelRequire("hz1aR");

var $7QIJX = parcelRequire("7QIJX");

var $2Untv = parcelRequire("2Untv");

var $dELVR = parcelRequire("dELVR");

var $fBw9h = parcelRequire("fBw9h");

var $iLNsZ = parcelRequire("iLNsZ");

var $upfHx = parcelRequire("upfHx");

var $3cvCV = parcelRequire("3cvCV");

var $lHkHI = parcelRequire("lHkHI");
function $0c87598a4d19514c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0c87598a4d19514c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0c87598a4d19514c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0c87598a4d19514c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0c87598a4d19514c$export$2a298f46c8d3fd05(_ref) {
    let { tileData: tileData, environment: environment, source: source, hideTagline: hideTagline = false, hidePartnerDetails: hidePartnerDetails = false, onTileClick: onTileClick, tileRef: tileRef, isAppInstalled: isAppInstalled } = _ref;
    const links = (0, $1TCPZ.getBootstrapLinks)(environment);
    const appLogoUrl = getAppLogoUrl();
    const appName = getAppName();
    const tagLine = getTagLine();
    const certification = getCertification();
    const tileBadgeVariant = getTileBadgeVariant();
    const hostUrl = (0, $c0qPT.useHostUrl)();
    const mountPath = (0, $c0qPT.useMountPath)();
    const { downloads: downloads, activeInstalls: installs, bundled: bundled } = tileData.distribution;
    const partner = tileData.vendor;
    const partnerDetailProps = getPartnerDetailProps();
    function getAppLogoUrl() {
        const imageId = tileData.logo.highRes || tileData.logo.image;
        return links.mediaFile.expand({
            imageId: imageId
        });
    }
    function getAppName() {
        if (tileData._highlightResult) {
            const highlightedText = (0, $6Zbi4.createTileHighlights)(tileData._highlightResult, 'name', 'tokenizedName');
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3BBSQ.AppTileHighlightedText), {
                highlightedText: highlightedText,
                originalText: tileData.name,
                overrideStyles: {
                    color: "var(--ds-text)",
                    fontWeight: 700
                }
            });
        } else return tileData.name;
    }
    function getTagLine() {
        if (tileData._highlightResult) {
            const highlightedText = (0, $6Zbi4.createTileHighlights)(tileData._highlightResult, 'tagLine', 'tokenizedTagLine');
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3BBSQ.AppTileHighlightedText), {
                highlightedText: highlightedText,
                originalText: tileData.tagLine,
                overrideStyles: {
                    color: "var(--ds-text)",
                    fontWeight: 600
                }
            });
        } else return tileData.tagLine;
    }
    function getTileBadgeVariant() {
        var _tileData$tags;
        let badgeVariant;
        const marketingLabels = ((_tileData$tags = tileData.tags) === null || _tileData$tags === void 0 ? void 0 : _tileData$tags.marketingLabels) || [];
        if (marketingLabels.includes('Spotlight')) badgeVariant = (0, $iLNsZ.BadgeVariant).SPOTLIGHT;
        else if (marketingLabels.includes('Bestseller')) badgeVariant = (0, $iLNsZ.BadgeVariant).BESTSELLER;
        else if (marketingLabels.includes('Rising Star')) badgeVariant = (0, $iLNsZ.BadgeVariant).RISINGSTAR;
        else {
            const releaseDate = tileData.releaseDate;
            if (releaseDate) badgeVariant = Math.abs((0, $76fzC).differenceInDaysToNow(releaseDate)) < 14 ? (0, $iLNsZ.BadgeVariant).NEW : undefined;
        }
        return badgeVariant;
    }
    function getPartnerDetailProps() {
        var _partner$partnerTier;
        const partnerPageUrl = links.partnerDetails.expand({
            id: partner.id
        });
        return {
            name: partner.name,
            link: partnerPageUrl,
            partnerTier: (_partner$partnerTier = partner.partnerTier) === null || _partner$partnerTier === void 0 ? void 0 : _partner$partnerTier.type.toUpperCase(),
            source: source
        };
    }
    function getCertification() {
        var _tileData$programs, _tileData$programs$cl, _tileData$programs2;
        const isCloudFortifiedApp = ((_tileData$programs = tileData.programs) === null || _tileData$programs === void 0 ? void 0 : (_tileData$programs$cl = _tileData$programs.cloudFortified) === null || _tileData$programs$cl === void 0 ? void 0 : _tileData$programs$cl.status) === (0, $kafab.CloudFortifiedStatusValues).Approved;
        const isCloudSecurityParticipantApp = (0, $gwoWU.isBugBountyParticipant)((0, $ammkg.AtlassianProductHostingType).Cloud, (_tileData$programs2 = tileData.programs) === null || _tileData$programs2 === void 0 ? void 0 : _tileData$programs2.bugBountyParticipant) && tileData.deployments.includes('cloud');
        let certificationType;
        if (isCloudFortifiedApp) certificationType = (0, $iLNsZ.Certification).CLOUD_FORTIFIED;
        else if (isCloudSecurityParticipantApp) certificationType = (0, $iLNsZ.Certification).CLOUD_SECURITY_PARTICIPANT;
        return certificationType;
    }
    function onTileClickHandler(e) {
        e.preventDefault();
        onTileClick === null || onTileClick === void 0 || onTileClick(tileData);
    }
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fBw9h.AppTileContainer), {
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fBw9h.AppTileButton), {
            href: (0, $upfHx.getAppListingUrl)(source, hostUrl, tileData, mountPath),
            onClick: onTileClickHandler,
            "data-testid": (0, $hnWN5.TEST_IDS).APP_TILE,
            ref: tileRef,
            target: "_blank",
            children: [
                tileBadgeVariant && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3cvCV.AppTileBadge), {
                    variant: tileBadgeVariant
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fBw9h.AppTileMainContentWrapper), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fBw9h.AppTileHeader), {
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fBw9h.AppLogoWrapper), {
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dELVR.AppLogo), {
                                        alt: tileData.name,
                                        loading: "lazy",
                                        src: appLogoUrl,
                                        "aria-hidden": "true"
                                    })
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fBw9h.AppNameWrapper), {
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fBw9h.Heading), {
                                        children: appName
                                    })
                                })
                            ]
                        }),
                        !hidePartnerDetails && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fBw9h.PartnerDetailsWrapper), {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2Untv.PartnerDetails), $0c87598a4d19514c$var$_objectSpread({}, partnerDetailProps))
                        }),
                        !hideTagline && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fBw9h.Tagline), {
                            children: tagLine
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fBw9h.RatingsAndInstallsContainer), {
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j0vr1.Ratings), {
                                    testId: (0, $hnWN5.TEST_IDS).RATINGS,
                                    ratings: tileData.ratings
                                }),
                                isAppInstalled !== null && isAppInstalled !== void 0 && isAppInstalled(tileData.addonKey) ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j8E8v.default), {
                                    isBold: true,
                                    children: "Added"
                                }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7QIJX.InstallDownloadMetrics), {
                                    appName: tileData.name,
                                    installs: installs,
                                    downloads: downloads,
                                    isPreinstalled: bundled
                                })
                            ]
                        }),
                        certification ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hz1aR.CertificationBadge), {
                            certification: certification
                        }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fBw9h.NoCertification), {})
                    ]
                })
            ]
        })
    });
}

});
parcelRegister("j0vr1", function(module, exports) {

$parcel$export(module.exports, "Ratings", () => $dd6666b6da9b622a$export$63624e0823f82b87);

var $lpjDh = parcelRequire("lpjDh");
parcelRequire("eUqFw");

var $eFxr4 = parcelRequire("eFxr4");

var $7XETd = parcelRequire("7XETd");

var $dtVo5 = parcelRequire("dtVo5");

var $6AmUQ = parcelRequire("6AmUQ");

var $lHkHI = parcelRequire("lHkHI");
const $dd6666b6da9b622a$var$NumericRating = (_ref)=>{
    let { avgStars: avgStars, boldAverageStars: boldAverageStars } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $7XETd.NumericRatingStyled), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7XETd.AverageStars), {
                isBold: boldAverageStars,
                children: avgStars
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $7XETd.TotalStars), {
                children: [
                    "/",
                    (0, $eFxr4.TOTAL_STARS)
                ]
            })
        ]
    });
};
const $dd6666b6da9b622a$var$StarRating = (_ref2)=>{
    let { ratings: ratings, size: size = 'medium' } = _ref2;
    const stars = (0, $dtVo5.getStarVariations)(ratings);
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6AmUQ.StarGradients), {}),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7XETd.StarRatingStyled), {
                children: stars.map((variation, index)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $7XETd.StarIconContainer), {
                        "data-testid": "star-rating-".concat(variation),
                        variation: variation,
                        size: size,
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lpjDh))), {
                            label: "Star rating",
                            size: size
                        })
                    }, index))
            })
        ]
    });
};
const $dd6666b6da9b622a$var$RatingsCount = (_ref3)=>{
    let { numRatings: numRatings } = _ref3;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $7XETd.RatingsCountStyled), {
        children: [
            "(",
            numRatings,
            ")"
        ]
    });
};
const $dd6666b6da9b622a$export$a981e6ce19d71083 = (_ref4)=>{
    let { testId: testId, size: size = 'medium' } = _ref4;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $7XETd.NoRatingContainer), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7XETd.StarIconContainer), {
                "data-testid": testId,
                variation: (0, $eFxr4.EMPTY_STAR),
                size: size,
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lpjDh))), {
                    label: "No star rating yet",
                    size: size
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7XETd.NoRatingText), {
                children: "No reviews yet"
            })
        ]
    });
};
const $dd6666b6da9b622a$export$63624e0823f82b87 = (_ref5)=>{
    let { testId: testId, ratings: ratings, size: size, showNumberRatings: showNumberRatings = true, showNoRatingsMessage: showNoRatingsMessage = false, boldAverageStars: boldAverageStars = false } = _ref5;
    const { avgStars: avgStars, numRatings: numRatings } = ratings;
    const roundRating = (0, $dtVo5.roundRatingToOneDecimal)(avgStars || 0);
    return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
        role: "img",
        "data-testid": testId,
        "aria-label": "Rating of ".concat(roundRating, " out of ").concat((0, $eFxr4.TOTAL_STARS), " stars based on ").concat(numRatings, " reviews"),
        children: showNoRatingsMessage && !numRatings ? /*#__PURE__*/ (0, $lHkHI.jsx)($dd6666b6da9b622a$export$a981e6ce19d71083, {
            testId: testId,
            size: size
        }) : /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $7XETd.RatingsContainer), {
            "aria-hidden": "true",
            children: [
                showNumberRatings && !!numRatings && /*#__PURE__*/ (0, $lHkHI.jsx)($dd6666b6da9b622a$var$NumericRating, {
                    boldAverageStars: boldAverageStars,
                    avgStars: roundRating
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($dd6666b6da9b622a$var$StarRating, {
                    ratings: ratings,
                    size: size
                }),
                showNumberRatings && !!numRatings && /*#__PURE__*/ (0, $lHkHI.jsx)($dd6666b6da9b622a$var$RatingsCount, {
                    numRatings: numRatings
                })
            ]
        })
    });
};

});
parcelRegister("eFxr4", function(module, exports) {

$parcel$export(module.exports, "TOTAL_STARS", () => $aaded4aaceb5dbb0$export$8cb47a0365023893);
$parcel$export(module.exports, "FULL_STAR", () => $aaded4aaceb5dbb0$export$cddb236a3f07ccae);
$parcel$export(module.exports, "EMPTY_STAR", () => $aaded4aaceb5dbb0$export$3fe9f96ae4e9046);
$parcel$export(module.exports, "QUARTER_STAR", () => $aaded4aaceb5dbb0$export$5ba14a4123b4d7e7);
$parcel$export(module.exports, "HALF_STAR", () => $aaded4aaceb5dbb0$export$c0557090bfd42e78);
$parcel$export(module.exports, "THREE_QUARTER_STAR", () => $aaded4aaceb5dbb0$export$a908142c7b579a36);
$parcel$export(module.exports, "NO_RATING_STAR", () => $aaded4aaceb5dbb0$export$d02fa2cb21ed23bd);
$parcel$export(module.exports, "STAR_FILL_MAP", () => $aaded4aaceb5dbb0$export$fe8acbce00b8388b);

var $j0gMm = parcelRequire("j0gMm");
const $aaded4aaceb5dbb0$export$8cb47a0365023893 = 4;
const $aaded4aaceb5dbb0$export$cddb236a3f07ccae = 'fullStar';
const $aaded4aaceb5dbb0$export$3fe9f96ae4e9046 = 'emptyStar';
const $aaded4aaceb5dbb0$export$5ba14a4123b4d7e7 = 'quarterStar';
const $aaded4aaceb5dbb0$export$c0557090bfd42e78 = 'halfStar';
const $aaded4aaceb5dbb0$export$a908142c7b579a36 = 'threeQuarterStar';
const $aaded4aaceb5dbb0$export$d02fa2cb21ed23bd = 'noRatingStar';
const $aaded4aaceb5dbb0$export$fe8acbce00b8388b = {
    [$aaded4aaceb5dbb0$export$cddb236a3f07ccae]: {
        fill: "var(--ds-icon-accent-orange, ".concat((0, $j0gMm.R300), ")")
    },
    [$aaded4aaceb5dbb0$export$3fe9f96ae4e9046]: {
        fill: "var(--ds-background-accent-gray-subtle, ".concat((0, $j0gMm.N500), ")")
    },
    [$aaded4aaceb5dbb0$export$5ba14a4123b4d7e7]: {
        fill: "url(#".concat($aaded4aaceb5dbb0$export$5ba14a4123b4d7e7, ")")
    },
    [$aaded4aaceb5dbb0$export$c0557090bfd42e78]: {
        fill: "url(#".concat($aaded4aaceb5dbb0$export$c0557090bfd42e78, ")")
    },
    [$aaded4aaceb5dbb0$export$a908142c7b579a36]: {
        fill: "url(#".concat($aaded4aaceb5dbb0$export$a908142c7b579a36, ")")
    },
    [$aaded4aaceb5dbb0$export$d02fa2cb21ed23bd]: {
        fill: "var(--ds-icon-disabled)"
    }
};

});

parcelRegister("7XETd", function(module, exports) {

$parcel$export(module.exports, "RatingsContainer", () => $5cbdc2e5b40195e3$export$508a6a934eaeeb30);
$parcel$export(module.exports, "StarIconContainer", () => $5cbdc2e5b40195e3$export$a6a73f636a2683f4);
$parcel$export(module.exports, "AverageStars", () => $5cbdc2e5b40195e3$export$1c7edfe1a6f80b9c);
$parcel$export(module.exports, "TotalStars", () => $5cbdc2e5b40195e3$export$7a0aad1834050ae3);
$parcel$export(module.exports, "RatingsCountStyled", () => $5cbdc2e5b40195e3$export$ddfb77fae3956ff7);
$parcel$export(module.exports, "StarRatingStyled", () => $5cbdc2e5b40195e3$export$e7481638283f6b25);
$parcel$export(module.exports, "StarGradientContainer", () => $5cbdc2e5b40195e3$export$aff3f8e463c240a6);
$parcel$export(module.exports, "NumericRatingStyled", () => $5cbdc2e5b40195e3$export$9d085bd035d1362a);
$parcel$export(module.exports, "NoRatingContainer", () => $5cbdc2e5b40195e3$export$8494e7ff3c135992);
$parcel$export(module.exports, "NoRatingText", () => $5cbdc2e5b40195e3$export$88ec7b3ea06dee1f);
/* Ratings.styles.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");

var $cCrLo = parcelRequire("cCrLo");

var $eFxr4 = parcelRequire("eFxr4");

var $lHkHI = parcelRequire("lHkHI");
const $5cbdc2e5b40195e3$var$_excluded = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded2 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded3 = [
    "variation"
], $5cbdc2e5b40195e3$var$_excluded4 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded5 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded6 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded7 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded8 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded9 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded10 = [
    "as",
    "style"
], $5cbdc2e5b40195e3$var$_excluded11 = [
    "as",
    "style"
];
function $5cbdc2e5b40195e3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5cbdc2e5b40195e3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5cbdc2e5b40195e3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5cbdc2e5b40195e3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5cbdc2e5b40195e3$export$508a6a934eaeeb30 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $5cbdc2e5b40195e3$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $5cbdc2e5b40195e3$var$_objectSpread($5cbdc2e5b40195e3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_zulph461 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$a6a73f636a2683f4 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $5cbdc2e5b40195e3$var$_excluded2);
    const { variation: variation } = __cmplp, __cmpldp = (0, $bwPfh.default)(__cmplp, $5cbdc2e5b40195e3$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $5cbdc2e5b40195e3$var$_objectSpread($5cbdc2e5b40195e3$var$_objectSpread({}, __cmpldp), {}, {
        style: $5cbdc2e5b40195e3$var$_objectSpread($5cbdc2e5b40195e3$var$_objectSpread({}, __cmpls), {}, {
            "--_l74hby": (0, $9t7rW.default)((0, $eFxr4.STAR_FILL_MAP)[__cmplp.variation].fill)
        }),
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1axpun14",
            __cmplp.size === 'large' ? "_1bsbzwfg" : "_1bsb1tcg",
            __cmplp.size === 'large' ? "_4t3izwfg" : "_4t3i1tcg",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$1c7edfe1a6f80b9c = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $5cbdc2e5b40195e3$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $5cbdc2e5b40195e3$var$_objectSpread($5cbdc2e5b40195e3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf",
            __cmplp.isBold ? "_k48p1fw0" : "_k48p1nn1",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$7a0aad1834050ae3 = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $5cbdc2e5b40195e3$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $5cbdc2e5b40195e3$var$_objectSpread($5cbdc2e5b40195e3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _syaz1k3w _k48p1nn1",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$ddfb77fae3956ff7 = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $5cbdc2e5b40195e3$var$_excluded6);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $5cbdc2e5b40195e3$var$_objectSpread($5cbdc2e5b40195e3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _syaz1k3w _k48p1nn1",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$e7481638283f6b25 = (0, $eUqFw.forwardRef)((_ref6, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref6, __cmplp = (0, $bwPfh.default)(_ref6, $5cbdc2e5b40195e3$var$_excluded7);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $5cbdc2e5b40195e3$var$_objectSpread($5cbdc2e5b40195e3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$aff3f8e463c240a6 = (0, $eUqFw.forwardRef)((_ref7, __cmplr)=>{
    let { as: C = "svg", style: __cmpls } = _ref7, __cmplp = (0, $bwPfh.default)(_ref7, $5cbdc2e5b40195e3$var$_excluded8);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $5cbdc2e5b40195e3$var$_objectSpread($5cbdc2e5b40195e3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbidpf _4t3iidpf _kqswstnw",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$9d085bd035d1362a = (0, $eUqFw.forwardRef)((_ref8, __cmplr)=>{
    let { as: C = "p", style: __cmpls } = _ref8, __cmplp = (0, $bwPfh.default)(_ref8, $5cbdc2e5b40195e3$var$_excluded9);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $5cbdc2e5b40195e3$var$_objectSpread($5cbdc2e5b40195e3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulp1fcb _4cvr1h6o",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$8494e7ff3c135992 = (0, $eUqFw.forwardRef)((_ref9, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref9, __cmplp = (0, $bwPfh.default)(_ref9, $5cbdc2e5b40195e3$var$_excluded10);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $5cbdc2e5b40195e3$var$_objectSpread($5cbdc2e5b40195e3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _gy1ph461",
            __cmplp.className
        ])
    }));
});
const $5cbdc2e5b40195e3$export$88ec7b3ea06dee1f = (0, $eUqFw.forwardRef)((_ref10, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref10, __cmplp = (0, $bwPfh.default)(_ref10, $5cbdc2e5b40195e3$var$_excluded11);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $5cbdc2e5b40195e3$var$_objectSpread($5cbdc2e5b40195e3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf",
            __cmplp.className
        ])
    }));
});

});

parcelRegister("dtVo5", function(module, exports) {

$parcel$export(module.exports, "getStarVariations", () => $9d0a7fbeead10ef6$export$2463346a7bf59173);
$parcel$export(module.exports, "roundRatingToOneDecimal", () => $9d0a7fbeead10ef6$export$9641f1f2cc762aeb);

var $5zQU9 = parcelRequire("5zQU9");

var $eFxr4 = parcelRequire("eFxr4");
function $9d0a7fbeead10ef6$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9d0a7fbeead10ef6$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9d0a7fbeead10ef6$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9d0a7fbeead10ef6$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $9d0a7fbeead10ef6$export$d1d41317c3f0fae = (val)=>{
    if (val >= 0.875) return 1;
    else if (val >= 0.625) return 0.75;
    else if (val >= 0.375) return 0.5;
    else if (val >= 0.125) return 0.25;
    return 0;
};
const $9d0a7fbeead10ef6$export$e7373081cdd0df48 = (averageStars)=>{
    const integer = Math.trunc(averageStars);
    const decimal = averageStars % 1;
    return integer + $9d0a7fbeead10ef6$export$d1d41317c3f0fae(decimal);
};
const $9d0a7fbeead10ef6$export$c3b5857cf6a23fc = {
    0: {},
    0.25: {
        quarterStarsCount: 1
    },
    0.5: {
        halfStarsCount: 1
    },
    0.75: {
        threeQuarterStarsCount: 1
    }
};
const $9d0a7fbeead10ef6$export$a00beb5a07c70ef1 = (averageStars)=>{
    const discreteRating = $9d0a7fbeead10ef6$export$e7373081cdd0df48(averageStars);
    const fullStarsCount = Math.trunc(discreteRating);
    const partiallyFilledStarsCount = Math.ceil(discreteRating % 1);
    const partiallyFilledStars = $9d0a7fbeead10ef6$export$c3b5857cf6a23fc[discreteRating % 1];
    const emptyStarsCount = (0, $eFxr4.TOTAL_STARS) - fullStarsCount - partiallyFilledStarsCount;
    return $9d0a7fbeead10ef6$var$_objectSpread({
        fullStarsCount: fullStarsCount,
        emptyStarsCount: emptyStarsCount
    }, partiallyFilledStars);
};
const $9d0a7fbeead10ef6$export$2463346a7bf59173 = (ratings)=>{
    if (!ratings.numRatings) return [
        ...new Array((0, $eFxr4.TOTAL_STARS)).fill((0, $eFxr4.NO_RATING_STAR))
    ];
    const { fullStarsCount: fullStarsCount = 0, quarterStarsCount: quarterStarsCount = 0, halfStarsCount: halfStarsCount = 0, threeQuarterStarsCount: threeQuarterStarsCount = 0, emptyStarsCount: emptyStarsCount = 0 } = $9d0a7fbeead10ef6$export$a00beb5a07c70ef1(ratings.avgStars);
    return [
        ...new Array(fullStarsCount).fill((0, $eFxr4.FULL_STAR)),
        ...new Array(quarterStarsCount).fill((0, $eFxr4.QUARTER_STAR)),
        ...new Array(halfStarsCount).fill((0, $eFxr4.HALF_STAR)),
        ...new Array(threeQuarterStarsCount).fill((0, $eFxr4.THREE_QUARTER_STAR)),
        ...new Array(emptyStarsCount).fill((0, $eFxr4.EMPTY_STAR))
    ];
};
const $9d0a7fbeead10ef6$export$9641f1f2cc762aeb = (rating)=>Number(rating.toFixed(1));

});

parcelRegister("6AmUQ", function(module, exports) {

$parcel$export(module.exports, "StarGradients", () => $4cb7e17e20c28b6a$export$9e5638a6deed949e);
parcelRequire("eUqFw");

var $eFxr4 = parcelRequire("eFxr4");

var $7XETd = parcelRequire("7XETd");

var $lHkHI = parcelRequire("lHkHI");
const $4cb7e17e20c28b6a$var$STAR_GRADIENT_CONFIG = [
    {
        id: (0, $eFxr4.QUARTER_STAR),
        offset: '25%'
    },
    {
        id: (0, $eFxr4.HALF_STAR),
        offset: '50%'
    },
    {
        id: (0, $eFxr4.THREE_QUARTER_STAR),
        offset: '75%'
    }
];
const $4cb7e17e20c28b6a$export$9e5638a6deed949e = ()=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: $4cb7e17e20c28b6a$var$STAR_GRADIENT_CONFIG.map((_ref, index)=>{
            let { id: id, offset: offset } = _ref;
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7XETd.StarGradientContainer), {
                children: /*#__PURE__*/ (0, $lHkHI.jsxs)("linearGradient", {
                    id: id,
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)("stop", {
                            offset: offset,
                            stopColor: (0, $eFxr4.STAR_FILL_MAP)[0, $eFxr4.FULL_STAR].fill
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)("stop", {
                            offset: offset,
                            stopColor: (0, $eFxr4.STAR_FILL_MAP)[0, $eFxr4.EMPTY_STAR].fill
                        })
                    ]
                })
            }, index);
        })
    });
};

});


parcelRegister("1TCPZ", function(module, exports) {

$parcel$export(module.exports, "getBootstrapLinks", () => $16190dd8657cd9eb$export$3d864922fd35c3f);

var $9fEFB = parcelRequire("9fEFB");
const $16190dd8657cd9eb$var$prodEnv = {
    adminHubBaseUrl: 'https://admin.atlassian.com',
    mpacBaseUrl: 'https://marketplace.atlassian.com',
    mpacCdnBaseUrl: 'https://marketplace.atlassian.com',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com',
    macBaseUrl: 'https://my.atlassian.com',
    wacBaseUrl: 'https://www.atlassian.com'
};
const $16190dd8657cd9eb$var$stagingEnv = {
    adminHubBaseUrl: 'https://admin.stg.atlassian.com',
    mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    macBaseUrl: 'https://my.stg.internal.atlassian.com',
    wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com'
};
const $16190dd8657cd9eb$var$developmentEnv = {
    adminHubBaseUrl: 'https://admin.stg.atlassian.com',
    mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    macBaseUrl: 'https://my.stg.internal.atlassian.com',
    wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com'
};
const $16190dd8657cd9eb$var$localEnv = {
    adminHubBaseUrl: 'https://admin.stg.atlassian.com',
    mpacBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    mpacCdnBaseUrl: 'https://marketplace.stg.internal.atlassian.com',
    macBaseUrl: 'https://my.stg.internal.atlassian.com',
    wacBaseUrl: 'https://qa-wac.internal.atlassian.com',
    atlassianCommunityBaseUrl: 'https://community.stg.atlassian.com'
};
const $16190dd8657cd9eb$export$3d864922fd35c3f = (env)=>{
    switch(env){
        case 'production':
            return (0, $9fEFB.linkTemplates)($16190dd8657cd9eb$var$prodEnv);
        case 'staging':
            return (0, $9fEFB.linkTemplates)($16190dd8657cd9eb$var$stagingEnv);
        case 'development':
            return (0, $9fEFB.linkTemplates)($16190dd8657cd9eb$var$developmentEnv);
        case 'local':
            return (0, $9fEFB.linkTemplates)($16190dd8657cd9eb$var$localEnv);
        default:
            console.error('Marketplace App Tile: Unable to configure marketplace env:', +env);
            return (0, $9fEFB.linkTemplates)($16190dd8657cd9eb$var$prodEnv);
    }
};

});

parcelRegister("hnWN5", function(module, exports) {

$parcel$export(module.exports, "TEST_IDS", () => $ca823045bb271b4d$export$a2b4f255152a6585);
const $ca823045bb271b4d$export$a2b4f255152a6585 = {
    APP_TILE: 'app-tile',
    CERTIFICATION_BADGE: 'app-tile__certification-badge',
    RATINGS: 'app-tile__ratings',
    TILE_BADGE: 'app-tile__tile-badge',
    APP_TILE_SKELETON: 'app-tile-skeleton'
};

});

parcelRegister("6Zbi4", function(module, exports) {

$parcel$export(module.exports, "createTileHighlights", () => $516132a12f8fd6e5$export$72485177c805d267);
function $516132a12f8fd6e5$export$72485177c805d267(highlightResult, fieldName, tokensFieldName) {
    const tokensHighlights = highlightResult[tokensFieldName];
    if (tokensHighlights) {
        const matchedTokenHighlights = tokensHighlights.filter((highlight)=>highlight.matchLevel !== 'none').map((highlight)=>highlight.value);
        matchedTokenHighlights.push(highlightResult[fieldName].value);
        return matchedTokenHighlights.join(' ');
    }
    return highlightResult[fieldName].value;
}

});

parcelRegister("hz1aR", function(module, exports) {

$parcel$export(module.exports, "CertificationBadge", () => $cc969dbe22a39f9d$export$240603c58e88f157);

var $3UXZ8 = parcelRequire("3UXZ8");

var $l2WWm = parcelRequire("l2WWm");

var $8PT8s = parcelRequire("8PT8s");
var $f9qVk = parcelRequire("f9qVk");
parcelRequire("eUqFw");

var $hnWN5 = parcelRequire("hnWN5");

var $lHkHI = parcelRequire("lHkHI");
function $cc969dbe22a39f9d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cc969dbe22a39f9d$var$CertificationBadgeContainer = (0, $3UXZ8.default)("div", {
    target: "e1w36kog0",
    label: "CertificationBadgeContainer"
})({
    name: "r8orim",
    styles: "display:flex;padding:var(--ds-space-050) var(--ds-space-0);gap:var(--ds-space-025);align-items:center;line-height:1;"
});
const $cc969dbe22a39f9d$var$Text = (0, $3UXZ8.default)("span", {
    target: "e1w36kog1",
    label: "Text"
})({
    name: "10rkg43",
    styles: "color:var(--ds-text-subtle);font-weight:600;font-size:0.75rem;"
});
const $cc969dbe22a39f9d$var$badge = {
    CLOUD_FORTIFIED: {
        icon: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8PT8s.default), {
            label: "Cloud Fortified App Badge",
            size: "small"
        }),
        text: 'CLOUD FORTIFIED',
        tooltip: 'Apps that meet all cloud security and reliability requirements'
    },
    CLOUD_SECURITY_PARTICIPANT: {
        icon: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $f9qVk.default), {
            label: "Cloud Security Participant App Badge",
            primaryColor: "var(--ds-icon-brand)",
            size: "small"
        }),
        text: 'CLOUD SECURITY PARTICIPANT',
        tooltip: 'App is enrolled in the Marketplace Bug Bounty Program'
    }
};
const $cc969dbe22a39f9d$export$240603c58e88f157 = (props)=>{
    const { icon: icon, text: text, tooltip: tooltip } = $cc969dbe22a39f9d$var$badge[props.certification];
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l2WWm.default), {
        content: tooltip,
        position: "bottom-start",
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)($cc969dbe22a39f9d$var$CertificationBadgeContainer, {
            "data-testid": (0, $hnWN5.TEST_IDS).CERTIFICATION_BADGE,
            children: [
                icon,
                /*#__PURE__*/ (0, $lHkHI.jsx)($cc969dbe22a39f9d$var$Text, {
                    children: text
                })
            ]
        })
    });
};

});

parcelRegister("7QIJX", function(module, exports) {

$parcel$export(module.exports, "InstallDownloadMetrics", () => $5b7018326f581cf5$export$96f92f015cf1dddc);

var $3UXZ8 = parcelRequire("3UXZ8");

var $ilkNu = parcelRequire("ilkNu");

var $l2WWm = parcelRequire("l2WWm");

var $f7YGc = parcelRequire("f7YGc");

var $cCrLo = parcelRequire("cCrLo");
parcelRequire("eUqFw");

var $jBsVD = parcelRequire("jBsVD");

var $lHkHI = parcelRequire("lHkHI");
function $5b7018326f581cf5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5b7018326f581cf5$var$InstallDownloadMetricsContainer = (0, $3UXZ8.default)("div", {
    target: "eyzsfj70",
    label: "InstallDownloadMetricsContainer"
})({
    name: "1mon3mz",
    styles: "display:flex;align-items:center;gap:var(--ds-space-025);"
});
const $5b7018326f581cf5$var$InstallDownloadText = /*#__PURE__*/ (0, $3UXZ8.default)((0, $cCrLo.BodyNormal), {
    target: "eyzsfj71",
    label: "InstallDownloadText"
})({
    name: "eox2st",
    styles: "color:var(--ds-text-subtle);font-weight:400;"
});
const $5b7018326f581cf5$var$InstallDownloadIcon = ()=>/*#__PURE__*/ (0, $lHkHI.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        fill: "none",
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)("g", {
            fill: "currentColor",
            fillRule: "evenodd",
            clipRule: "evenodd",
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
                    d: "M21 12h-2v7H5v-7H3v7.006C3 20.106 3.893 21 4.995 21h14.01A1.994 1.994 0 0 0 21 19.006V12Z"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
                    d: "M13 3.977A.99.99 0 0 0 11.999 3a.988.988 0 0 0-.999.977v11.047a.988.988 0 0 0 .999.976.99.99 0 0 0 1.001-.976V3.977Z"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
                    d: "M15.695 12.303a1.053 1.053 0 0 0-1.478 0L12 14.5l-2.217-2.197a1.05 1.05 0 0 0-1.476 0 1.028 1.028 0 0 0 0 1.465l2.955 2.93a1.055 1.055 0 0 0 1.477 0l2.956-2.93a1.035 1.035 0 0 0 0-1.465Z"
                })
            ]
        })
    });
const $5b7018326f581cf5$export$96f92f015cf1dddc = (_ref)=>{
    let { appName: appName, installs: installs = 0, downloads: downloads = 0, isPreinstalled: isPreinstalled } = _ref;
    if (isPreinstalled) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jBsVD.InstallSignal), {
        children: "Preinstalled"
    });
    if (!installs && !downloads) return null;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($5b7018326f581cf5$var$InstallDownloadMetricsContainer, {
        role: "img",
        "aria-label": installs ? "".concat((0, $f7YGc).shortFormat(installs), " installs for ").concat(appName) : "".concat((0, $f7YGc).shortFormat(downloads), " downloads for ").concat(appName),
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ilkNu.Icon), {
                glyph: $5b7018326f581cf5$var$InstallDownloadIcon,
                primaryColor: "var(--ds-icon-subtle)",
                label: "",
                testId: "install-download-icon"
            }),
            installs ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l2WWm.default), {
                content: "Number of active installs across all hosting types",
                children: /*#__PURE__*/ (0, $lHkHI.jsx)($5b7018326f581cf5$var$InstallDownloadText, {
                    children: (0, $f7YGc).shortFormat(installs)
                })
            }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l2WWm.default), {
                content: "Number of jar downloads across all hosting types",
                children: /*#__PURE__*/ (0, $lHkHI.jsx)($5b7018326f581cf5$var$InstallDownloadText, {
                    children: (0, $f7YGc).shortFormat(downloads)
                })
            })
        ]
    });
};

});
parcelRegister("jBsVD", function(module, exports) {

$parcel$export(module.exports, "InstallSignal", () => $e457e9a38d462135$export$a5f7acad51987345);

var $3UXZ8 = parcelRequire("3UXZ8");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $e457e9a38d462135$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e457e9a38d462135$var$InstallSignalLozenge = (0, $3UXZ8.default)("span", {
    target: "e1pp1o890",
    label: "InstallSignalLozenge"
})({
    name: "1o4qo7a",
    styles: "border-radius:3px;background:var(--ds-background-neutral);color:var(--ds-text-subtle);padding:var(--ds-space-050);font-size:0.75rem;font-weight:700;text-transform:uppercase;font-family:'system-ui';"
});
const $e457e9a38d462135$export$a5f7acad51987345 = (props)=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)($e457e9a38d462135$var$InstallSignalLozenge, {
        children: props.children
    });
};

});


parcelRegister("2Untv", function(module, exports) {

$parcel$export(module.exports, "PartnerDetails", () => $21e305588789278b$export$b3e8b67d9de4f3ca);

var $3UXZ8 = parcelRequire("3UXZ8");

var $l2WWm = parcelRequire("l2WWm");

var $cCrLo = parcelRequire("cCrLo");

var $l501X = parcelRequire("l501X");
var $8xfj9 = parcelRequire("8xfj9");

var $jdjb1 = parcelRequire("jdjb1");

var $9LXG4 = parcelRequire("9LXG4");
parcelRequire("eUqFw");

var $cmZSX = parcelRequire("cmZSX");

var $lHkHI = parcelRequire("lHkHI");
function $21e305588789278b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $21e305588789278b$var$PartnerDetailsContainer = (0, $3UXZ8.default)("div", {
    target: "eiyw7wy0",
    label: "PartnerDetailsContainer"
})({
    name: "1cdsa5s",
    styles: "display:flex;align-items:center;gap:var(--ds-space-050);"
});
const $21e305588789278b$var$PartnerBadgeImage = (0, $3UXZ8.default)("img", {
    target: "eiyw7wy1",
    label: "PartnerBadgeImage"
})({
    name: "1kpp6qu",
    styles: "height:1.5rem;width:1.5rem;"
});
const $21e305588789278b$var$PartnerLink = (0, $3UXZ8.default)("span", {
    target: "eiyw7wy2",
    label: "PartnerLink"
})((0, $jdjb1.ellipsis), " a{color:var(--ds-link);font-size:0.875rem;font-weight:600;line-height:1.25rem;&:focus-visible{outline:var(--ds-space-025) solid var(--ds-border-focused);outline-offset:0;border-radius:var(--ds-border-radius-100, 3px);}}");
const $21e305588789278b$var$HelperText = /*#__PURE__*/ (0, $3UXZ8.default)((0, $cCrLo.BodyNormal), {
    target: "eiyw7wy3",
    label: "HelperText"
})({
    name: "536yzl",
    styles: "margin-top:0;font-weight:400;"
});
const $21e305588789278b$var$PartnerBadgeImageContainer = (0, $3UXZ8.default)("div", {
    target: "eiyw7wy4",
    label: "PartnerBadgeImageContainer"
})({
    name: "1fru31a",
    styles: "width:1.5rem;height:1.5rem;"
});
const $21e305588789278b$var$PartnerName = /*#__PURE__*/ (0, $3UXZ8.default)((0, $cCrLo.BodyNormal), {
    target: "eiyw7wy5",
    label: "PartnerName"
})((0, $jdjb1.ellipsis), "margin-top:0;font-weight:400;");
const $21e305588789278b$var$PartnerBadge = (props)=>{
    const partnerTierType = (0, $8xfj9.resolvePartnerTier)(props.partnerTier);
    if (!partnerTierType) return null;
    const tooltipText = "".concat((0, (/*@__PURE__*/$parcel$interopDefault($9LXG4)))(partnerTierType.label.toLowerCase()), " partner");
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l2WWm.default), {
        content: tooltipText,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)($21e305588789278b$var$PartnerBadgeImageContainer, {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)($21e305588789278b$var$PartnerBadgeImage, {
                alt: "".concat(partnerTierType.label, " Marketplace Partner"),
                src: partnerTierType.badge
            })
        })
    });
};
const $21e305588789278b$export$b3e8b67d9de4f3ca = (props)=>{
    const { name: name, link: link, partnerTier: partnerTier, source: source } = props;
    const path = new URL(link).pathname;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($21e305588789278b$var$PartnerDetailsContainer, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($21e305588789278b$var$HelperText, {
                children: "by"
            }),
            source === 'MPAC' ? /*#__PURE__*/ (0, $lHkHI.jsx)($21e305588789278b$var$PartnerLink, {
                children: link ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                    href: link,
                    onClick: (e)=>e.stopPropagation(),
                    children: name
                }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cmZSX.default), {
                    to: path,
                    onClick: (e)=>e.stopPropagation(),
                    children: name
                })
            }) : /*#__PURE__*/ (0, $lHkHI.jsx)($21e305588789278b$var$PartnerName, {
                children: name
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($21e305588789278b$var$PartnerBadge, {
                partnerTier: partnerTier
            })
        ]
    });
};

});

parcelRegister("dELVR", function(module, exports) {

$parcel$export(module.exports, "AppLogo", () => $9f14311c6d35871c$export$113a612889e1565d);

var $5zQU9 = parcelRequire("5zQU9");

var $bbkU5 = parcelRequire("bbkU5");

var $eUqFw = parcelRequire("eUqFw");

var $fBw9h = parcelRequire("fBw9h");

var $lHkHI = parcelRequire("lHkHI");
function $9f14311c6d35871c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9f14311c6d35871c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9f14311c6d35871c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9f14311c6d35871c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9f14311c6d35871c$export$113a612889e1565d(props) {
    const [imgLoadError, setImgLoadError] = (0, $eUqFw.useState)(false);
    function onError() {
        setImgLoadError(true);
    }
    if (imgLoadError) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fBw9h.AddOnIconCover), {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bbkU5))), {
            label: "",
            size: "xlarge"
        })
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fBw9h.AppLogoStyle), $9f14311c6d35871c$var$_objectSpread($9f14311c6d35871c$var$_objectSpread({}, props), {}, {
        onError: onError
    }));
}

});
parcelRegister("fBw9h", function(module, exports) {

$parcel$export(module.exports, "AppTileContainer", () => $b5c33fc0f40ade6a$export$202be679b06572fc);
$parcel$export(module.exports, "AppTileButton", () => $b5c33fc0f40ade6a$export$19e05024cc793c80);
$parcel$export(module.exports, "AppTileMainContentWrapper", () => $b5c33fc0f40ade6a$export$13924606088f661c);
$parcel$export(module.exports, "AppTileHeader", () => $b5c33fc0f40ade6a$export$d9d81dde435f2043);
$parcel$export(module.exports, "AppLogoWrapper", () => $b5c33fc0f40ade6a$export$2f5632a611e64195);
$parcel$export(module.exports, "Heading", () => $b5c33fc0f40ade6a$export$a8a3e93435678ff9);
$parcel$export(module.exports, "Tagline", () => $b5c33fc0f40ade6a$export$a1e4cc4b271f5d6e);
$parcel$export(module.exports, "AppLogoStyle", () => $b5c33fc0f40ade6a$export$523bf55cc981f5ac);
$parcel$export(module.exports, "AddOnIconCover", () => $b5c33fc0f40ade6a$export$353b0eaa64e1c016);
$parcel$export(module.exports, "AppNameWrapper", () => $b5c33fc0f40ade6a$export$41e96702a81eb03a);
$parcel$export(module.exports, "PartnerDetailsWrapper", () => $b5c33fc0f40ade6a$export$2db9b366e750f7c2);
$parcel$export(module.exports, "RatingsAndInstallsContainer", () => $b5c33fc0f40ade6a$export$31614bd958e74a83);
$parcel$export(module.exports, "NoCertification", () => $b5c33fc0f40ade6a$export$d5b3055423fa11c2);
/* AppTile.styles.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");



var $cCrLo = parcelRequire("cCrLo");

var $lHkHI = parcelRequire("lHkHI");
const $b5c33fc0f40ade6a$var$_excluded = [
    "as",
    "style"
], $b5c33fc0f40ade6a$var$_excluded2 = [
    "as",
    "style"
], $b5c33fc0f40ade6a$var$_excluded3 = [
    "as",
    "style"
], $b5c33fc0f40ade6a$var$_excluded4 = [
    "as",
    "style"
], $b5c33fc0f40ade6a$var$_excluded5 = [
    "as",
    "style"
], $b5c33fc0f40ade6a$var$_excluded6 = [
    "children"
], $b5c33fc0f40ade6a$var$_excluded7 = [
    "as",
    "style"
], $b5c33fc0f40ade6a$var$_excluded8 = [
    "as",
    "style"
], $b5c33fc0f40ade6a$var$_excluded9 = [
    "as",
    "style"
], $b5c33fc0f40ade6a$var$_excluded10 = [
    "as",
    "style"
], $b5c33fc0f40ade6a$var$_excluded11 = [
    "as",
    "style"
], $b5c33fc0f40ade6a$var$_excluded12 = [
    "as",
    "style"
], $b5c33fc0f40ade6a$var$_excluded13 = [
    "as",
    "style"
], $b5c33fc0f40ade6a$var$_excluded14 = [
    "as",
    "style"
];
function $b5c33fc0f40ade6a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b5c33fc0f40ade6a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b5c33fc0f40ade6a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b5c33fc0f40ade6a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $b5c33fc0f40ade6a$export$202be679b06572fc = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "li", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $b5c33fc0f40ade6a$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b5c33fc0f40ade6a$var$_objectSpread($b5c33fc0f40ade6a$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f1dfx _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    }));
});
const $b5c33fc0f40ade6a$export$19e05024cc793c80 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "a", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $b5c33fc0f40ade6a$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b5c33fc0f40ade6a$var$_objectSpread($b5c33fc0f40ade6a$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1yt4sili _2rkooqnp _vchhusvi _11q7143w _19it3e1a _kqswh2mm _k48powjs _ect41sdi _80omtlke _1e0c1txw _2lx21bp4 _1bah1yb4 _1bsb1osq _4t3i1osq _v56416gf _4bfu18uv _1hmsglyw _ajmmnqa1 _1ygb4suz _1ejj1qw3 _vjfr18uv _10xfglyw _1w0vnqa1 _1dbz1qw3 _9oik18uv _1bnxglyw _jf4cnqa1 _j6xt17i0 _180d1qw3 _1nrm18uv _c2waglyw _1iohnqa1",
            __cmplp.className
        ])
    }));
});
const $b5c33fc0f40ade6a$export$13924606088f661c = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $b5c33fc0f40ade6a$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b5c33fc0f40ade6a$var$_objectSpread($b5c33fc0f40ade6a$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrxjmg",
            __cmplp.className
        ])
    }));
});
const $b5c33fc0f40ade6a$export$d9d81dde435f2043 = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $b5c33fc0f40ade6a$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b5c33fc0f40ade6a$var$_objectSpread($b5c33fc0f40ade6a$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _zulpxjmg",
            __cmplp.className
        ])
    }));
});
const $b5c33fc0f40ade6a$export$2f5632a611e64195 = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $b5c33fc0f40ade6a$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b5c33fc0f40ade6a$var$_objectSpread($b5c33fc0f40ade6a$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f12bs _c71l12bs _1yt41fcb _1reo15vq _18m915vq _vchhusvi _bfhku67f _2rkoebcm _8fz61k7u _1ckq1k7u",
            __cmplp.className
        ])
    }));
});
const $b5c33fc0f40ade6a$var$H3 = (_ref6)=>{
    let { children: children } = _ref6, props = (0, $bwPfh.default)(_ref6, $b5c33fc0f40ade6a$var$_excluded6);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.H5), $b5c33fc0f40ade6a$var$_objectSpread($b5c33fc0f40ade6a$var$_objectSpread({
        as: "h3"
    }, props), {}, {
        children: children
    }));
};
const $b5c33fc0f40ade6a$export$a8a3e93435678ff9 = (0, $eUqFw.forwardRef)((_ref7, __cmplr)=>{
    let { as: C = $b5c33fc0f40ade6a$var$H3, style: __cmpls } = _ref7, __cmplp = (0, $bwPfh.default)(_ref7, $b5c33fc0f40ade6a$var$_excluded7);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b5c33fc0f40ade6a$var$_objectSpread($b5c33fc0f40ade6a$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _1bto1l2s _1dyznl7k _1e0ccj1k _1yyjcs5v _5nh5cs5v _sudp1e54 _aetr6qu5 _18postnw _1qdgt94y _z0ait94y _1ebm15vq _bsxv15vq",
            __cmplp.className
        ])
    }));
});
const $b5c33fc0f40ade6a$export$a1e4cc4b271f5d6e = (0, $eUqFw.forwardRef)((_ref8, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref8, __cmplp = (0, $bwPfh.default)(_ref8, $b5c33fc0f40ade6a$var$_excluded8);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b5c33fc0f40ade6a$var$_objectSpread($b5c33fc0f40ade6a$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _syaz1k3w _1bto1l2s _k48p1nn1 _1i4q1hna _19pk1eps",
            __cmplp.className
        ])
    }));
});
const $b5c33fc0f40ade6a$export$523bf55cc981f5ac = (0, $eUqFw.forwardRef)((_ref9, __cmplr)=>{
    let { as: C = "img", style: __cmpls } = _ref9, __cmplp = (0, $bwPfh.default)(_ref9, $b5c33fc0f40ade6a$var$_excluded9);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b5c33fc0f40ade6a$var$_objectSpread($b5c33fc0f40ade6a$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1b9w _4t3i1b9w _2rkoebcm _1s4pqf5o _1kneqf5o",
            __cmplp.className
        ])
    }));
});
const $b5c33fc0f40ade6a$export$353b0eaa64e1c016 = (0, $eUqFw.forwardRef)((_ref10, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref10, __cmplp = (0, $bwPfh.default)(_ref10, $b5c33fc0f40ade6a$var$_excluded10);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b5c33fc0f40ade6a$var$_objectSpread($b5c33fc0f40ade6a$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _1bsb1b9w _4t3i1b9w _2rkoebcm _1s4pqf5o _1kneqf5o",
            __cmplp.className
        ])
    }));
});
const $b5c33fc0f40ade6a$export$41e96702a81eb03a = (0, $eUqFw.forwardRef)((_ref11, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref11, __cmplp = (0, $bwPfh.default)(_ref11, $b5c33fc0f40ade6a$var$_excluded11);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b5c33fc0f40ade6a$var$_objectSpread($b5c33fc0f40ade6a$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    }));
});
const $b5c33fc0f40ade6a$export$2db9b366e750f7c2 = (0, $eUqFw.forwardRef)((_ref12, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref12, __cmplp = (0, $bwPfh.default)(_ref12, $b5c33fc0f40ade6a$var$_excluded12);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b5c33fc0f40ade6a$var$_objectSpread($b5c33fc0f40ade6a$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1eps",
            __cmplp.className
        ])
    }));
});
const $b5c33fc0f40ade6a$export$31614bd958e74a83 = (0, $eUqFw.forwardRef)((_ref13, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref13, __cmplp = (0, $bwPfh.default)(_ref13, $b5c33fc0f40ade6a$var$_excluded13);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b5c33fc0f40ade6a$var$_objectSpread($b5c33fc0f40ade6a$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1n261g80 _otyr1eps",
            __cmplp.className
        ])
    }));
});
const $b5c33fc0f40ade6a$export$d5b3055423fa11c2 = (0, $eUqFw.forwardRef)((_ref14, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref14, __cmplp = (0, $bwPfh.default)(_ref14, $b5c33fc0f40ade6a$var$_excluded14);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b5c33fc0f40ade6a$var$_objectSpread($b5c33fc0f40ade6a$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1k8s",
            __cmplp.className
        ])
    }));
});

});


parcelRegister("iLNsZ", function(module, exports) {

$parcel$export(module.exports, "Certification", () => $daa2fcceab9278ba$export$409e27430e3f12cc);
$parcel$export(module.exports, "BadgeVariant", () => $daa2fcceab9278ba$export$18bf8be90b102439);
let $daa2fcceab9278ba$export$bde6b447e5f1bd7d = /*#__PURE__*/ function(AppTileSource) {
    AppTileSource["MPAC"] = "MPAC";
    AppTileSource["PRODUCT"] = "PRODUCT";
    return AppTileSource;
}({});
let $daa2fcceab9278ba$export$409e27430e3f12cc = /*#__PURE__*/ function(Certification) {
    Certification["CLOUD_FORTIFIED"] = "CLOUD_FORTIFIED";
    Certification["CLOUD_SECURITY_PARTICIPANT"] = "CLOUD_SECURITY_PARTICIPANT";
    return Certification;
}({});
let $daa2fcceab9278ba$export$18bf8be90b102439 = /*#__PURE__*/ function(BadgeVariant) {
    BadgeVariant["SPOTLIGHT"] = "SPOTLIGHT";
    BadgeVariant["BESTSELLER"] = "BESTSELLER";
    BadgeVariant["RISINGSTAR"] = "RISINGSTAR";
    BadgeVariant["NEW"] = "NEW";
    return BadgeVariant;
}({});

});

parcelRegister("upfHx", function(module, exports) {

$parcel$export(module.exports, "getAppListingUrl", () => $05b66406bab682c2$export$378460c9dfeda4e2);
$parcel$export(module.exports, "onTileClick", () => $05b66406bab682c2$export$daa50b7e16832a34);

var $1fIAX = parcelRequire("1fIAX");

var $9fEFB = parcelRequire("9fEFB");
var $hEKtR = parcelRequire("hEKtR");
const $05b66406bab682c2$export$41b0b24c2596115c = (hosting)=>{
    switch(hosting){
        case 'cloud':
            return 'cloud';
        case 'server':
            return 'server';
        case 'dataCenter':
            return 'datacenter';
        default:
            console.error('Invalid hosting provided : ' + hosting);
            return '';
    }
};
const $05b66406bab682c2$export$4b0bcae8b77fab89 = (tileData)=>{
    const { deployments: deployments, documentType: documentType } = tileData;
    if (!deployments.includes('cloud')) return $05b66406bab682c2$export$41b0b24c2596115c(documentType);
    return 'cloud';
};
const $05b66406bab682c2$export$378460c9dfeda4e2 = (source, hostUrl, tileData, mountPath)=>{
    // In case of source as PRODUCT, mountPath can have values like '/jira/marketplace'.
    if (source === (0, $1fIAX.Source).PRODUCT) return "".concat(mountPath, "/discover/app/").concat(tileData.addonKey);
    const url = (0, $9fEFB.appListingLink)(hostUrl).expand({
        appId: tileData.addonId.toString(),
        slug: (0, $hEKtR.encodeAppName)(tileData.name),
        hosting: $05b66406bab682c2$export$4b0bcae8b77fab89(tileData),
        tab: 'overview'
    });
    return url;
};
const $05b66406bab682c2$export$daa50b7e16832a34 = (tileData, source, hostUrl, mountPath, history)=>{
    const appListingUrl = $05b66406bab682c2$export$378460c9dfeda4e2(source, hostUrl, tileData, mountPath);
    // If the source is PRODUCT, navigate to the app listing URL within the same tab using history.push.
    // Otherwise, open the app listing URL in a new browser tab.
    if (source === (0, $1fIAX.Source).PRODUCT) history === null || history === void 0 || history.push(appListingUrl);
    else window.open(appListingUrl);
};

});
parcelRegister("hEKtR", function(module, exports) {

$parcel$export(module.exports, "encodeAppName", () => $cdaa3a2dd00c5821$export$24344ca15b9a3bb5);
function $cdaa3a2dd00c5821$export$24344ca15b9a3bb5(name) {
    return name.replace(/['`´‘’]/g, '').replace(/<\/?.*?>/g, ' ').split(/\W/).filter((s)=>s && s.trim() !== '').map((s)=>s.toLowerCase().trim()).join('-');
}

});


parcelRegister("3cvCV", function(module, exports) {

$parcel$export(module.exports, "AppTileBadge", () => $254b067e49944f4a$export$1c1e7bab86784a56);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");
parcelRequire("eUqFw");

var $hnWN5 = parcelRequire("hnWN5");

var $iLNsZ = parcelRequire("iLNsZ");

var $lHkHI = parcelRequire("lHkHI");
function $254b067e49944f4a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $254b067e49944f4a$var$AppTileBadgeContainer = (0, $3UXZ8.default)("div", {
    target: "e5ii3kz0",
    label: "AppTileBadgeContainer"
})({
    name: "o3nee2",
    styles: "position:absolute;right:var(--ds-space-200, 16px);top:-5px;box-shadow:0px 1px 4px 0px rgba(0,0,0,0.25);border-radius:0px 1px 4px 4px;display:flex;font-family:inherit;"
});
const $254b067e49944f4a$var$Ribbon = (0, $3UXZ8.default)("div", {
    target: "e5ii3kz1",
    label: "Ribbon"
})("position:absolute;top:0px;left:-7px;width:7px;height:4px;&::after{content:'';position:absolute;width:100%;height:100%;clip-path:polygon(100% 0%,0% 100%,100% 100%);background:", (props)=>props.ribbonGradient, ";}");
const $254b067e49944f4a$var$Badge = (0, $3UXZ8.default)("div", {
    target: "e5ii3kz2",
    label: "Badge"
})("border-radius:0px 1px 4px 4px;padding:var(--ds-space-025) var(--ds-space-050);color:", (props)=>props.textColor, ";font-weight:600;font-size:0.688rem;background-color:", (props)=>props.badgeBackground, ";");
const $254b067e49944f4a$var$badge = {
    [(0, $iLNsZ.BadgeVariant).SPOTLIGHT]: {
        text: 'SPOTLIGHT',
        textColor: "var(--ds-text-inverse)",
        badgeBackground: "var(--ds-background-discovery-bold)",
        ribbonGradient: "linear-gradient(to left bottom, ".concat((0, $j0gMm.P500), ", ").concat((0, $j0gMm.P300), ")")
    },
    [(0, $iLNsZ.BadgeVariant).BESTSELLER]: {
        text: 'BESTSELLER',
        textColor: "var(--ds-text-inverse)",
        badgeBackground: "var(--ds-background-accent-green-bolder)",
        ribbonGradient: "linear-gradient(to left bottom, ".concat((0, $j0gMm.G500), ", ").concat((0, $j0gMm.G300), ")")
    },
    [(0, $iLNsZ.BadgeVariant).RISINGSTAR]: {
        text: 'RISING STAR',
        textColor: "var(--ds-text-inverse)",
        badgeBackground: "var(--ds-background-information-bold)",
        ribbonGradient: "linear-gradient(to left bottom, ".concat((0, $j0gMm.B500), ", ").concat((0, $j0gMm.B300), ")")
    },
    [(0, $iLNsZ.BadgeVariant).NEW]: {
        text: 'NEW',
        textColor: "var(--ds-text-discovery)",
        badgeBackground: "var(--ds-background-discovery)",
        ribbonGradient: "linear-gradient(to left bottom, ".concat((0, $j0gMm.P500), ", ").concat((0, $j0gMm.P300), ")")
    }
};
function $254b067e49944f4a$export$1c1e7bab86784a56(_ref) {
    let { variant: variant } = _ref;
    const { text: text, textColor: textColor, badgeBackground: badgeBackground, ribbonGradient: ribbonGradient } = $254b067e49944f4a$var$badge[variant];
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($254b067e49944f4a$var$AppTileBadgeContainer, {
        "data-testid": (0, $hnWN5.TEST_IDS).TILE_BADGE,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($254b067e49944f4a$var$Ribbon, {
                ribbonGradient: ribbonGradient
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($254b067e49944f4a$var$Badge, {
                badgeBackground: badgeBackground,
                textColor: textColor,
                children: text
            })
        ]
    });
}

});


parcelRegister("iADnD", function(module, exports) {

$parcel$export(module.exports, "PAGINATED_APP_GRID_CONFIG", () => $d88a22e1eef991a0$export$9b67686bd6f80b34);
$parcel$export(module.exports, "usePaginatedAppGrid", () => $d88a22e1eef991a0$export$30746765cdba3eea);

var $5zQU9 = parcelRequire("5zQU9");

var $blcHM = parcelRequire("blcHM");

var $eUqFw = parcelRequire("eUqFw");
function $d88a22e1eef991a0$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d88a22e1eef991a0$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d88a22e1eef991a0$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d88a22e1eef991a0$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $d88a22e1eef991a0$var$INITIAL_FETCH_MORE_STATE = {
    fetchMoreError: null,
    fetchMoreLoading: false
};
const $d88a22e1eef991a0$export$9b67686bd6f80b34 = {
    initialFetchCount: 24,
    fetchMoreCount: 12
};
function $d88a22e1eef991a0$export$30746765cdba3eea(_ref) {
    let { query: query, queryOptions: queryOptions, parseResponse: parseResponse } = _ref;
    // Note: Apollo Client's `useLazyQuery` and `useQuery` does not return errors for `fetchMore` calls.
    // Also, unless `notifyOnNetworkStatusChange` is set, it doesn't return loading state either for `fetchMore`.
    // We manage `fetchMoreState` state explicitly to handle these cases.
    // https://github.com/apollographql/react-apollo/issues/2759
    const [fetchMoreState, setFetchMoreState] = (0, $eUqFw.useState)($d88a22e1eef991a0$var$INITIAL_FETCH_MORE_STATE);
    const { data: data, error: error, loading: loading, fetchMore: fetchMore } = (0, $blcHM.useQuery)(query, queryOptions);
    const { appList: appList, hasNextPage: hasNextPage, totalCount: totalCount } = parseResponse(data);
    const showLoadMoreButton = !error && hasNextPage;
    (0, $eUqFw.useLayoutEffect)(()=>{
        if (loading && fetchMoreState.fetchMoreError) setFetchMoreState($d88a22e1eef991a0$var$INITIAL_FETCH_MORE_STATE);
    }, [
        loading,
        fetchMoreState.fetchMoreError
    ]);
    const fetchMoreApps = (0, $eUqFw.useCallback)(async (_ref2)=>{
        let { first: first = $d88a22e1eef991a0$export$9b67686bd6f80b34.fetchMoreCount, variables: variables = {} } = _ref2;
        if (!fetchMore || !hasNextPage) return; // no-op
        setFetchMoreState({
            fetchMoreError: null,
            fetchMoreLoading: true
        });
        try {
            await fetchMore({
                variables: $d88a22e1eef991a0$var$_objectSpread({
                    after: appList.length,
                    first: // how many elements do you want to skip
                    first
                }, variables)
            });
            setFetchMoreState($d88a22e1eef991a0$var$INITIAL_FETCH_MORE_STATE);
        } catch (err) {
            setFetchMoreState({
                fetchMoreError: err,
                fetchMoreLoading: false
            });
        }
    }, [
        fetchMore,
        appList.length,
        hasNextPage
    ]);
    return (0, $eUqFw.useMemo)(()=>({
            appList: appList,
            totalCount: totalCount,
            isLoading: loading,
            isLoadingMore: fetchMoreState.fetchMoreLoading,
            showLoadMoreButton: showLoadMoreButton,
            fetchMoreApps: fetchMoreApps,
            rawData: data,
            initialFetchError: error,
            fetchMoreError: fetchMoreState.fetchMoreError
        }), [
        appList,
        totalCount,
        loading,
        fetchMoreState.fetchMoreLoading,
        showLoadMoreButton,
        fetchMoreApps,
        data,
        error,
        fetchMoreState.fetchMoreError
    ]);
}

});
parcelRegister("blcHM", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $841b82d568969729$export$dd0a697e1782aedd);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $a1fq9 = parcelRequire("a1fq9");

var $14VzF = parcelRequire("14VzF");

var $hr8gD = parcelRequire("hr8gD");

var $7X1wJ = parcelRequire("7X1wJ");
var $jZIxU = parcelRequire("jZIxU");
var $kxw1Y = parcelRequire("kxw1Y");
var $jxMus = parcelRequire("jxMus");
var $hcvqr = parcelRequire("hcvqr");

var $hkiUo = parcelRequire("hkiUo");

var $7BIXz = parcelRequire("7BIXz");

var $4YvCN = parcelRequire("4YvCN");

var $55wNp = parcelRequire("55wNp");

var $bxDwC = parcelRequire("bxDwC");

var $hJ5J9 = parcelRequire("hJ5J9");
var $841b82d568969729$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $841b82d568969729$export$dd0a697e1782aedd(query, options) {
    if (options === void 0) options = Object.create(null);
    return (0, $hJ5J9.wrapHook)("useQuery", $841b82d568969729$var$_useQuery, (0, $bxDwC.useApolloClient)(options && options.client))(query, options);
}
function $841b82d568969729$var$_useQuery(query, options) {
    return $841b82d568969729$export$6342ea8c555e49e5((0, $bxDwC.useApolloClient)(options.client), query).useQuery(options);
}
function $841b82d568969729$export$6342ea8c555e49e5(client, query) {
    var stateRef = $a1fq9.useRef();
    if (!stateRef.current || client !== stateRef.current.client || query !== stateRef.current.query) stateRef.current = new $841b82d568969729$var$InternalState(client, query, stateRef.current);
    var state = stateRef.current;
    // By default, InternalState.prototype.forceUpdate is an empty function, but
    // we replace it here (before anyone has had a chance to see this state yet)
    // with a function that unconditionally forces an update, using the latest
    // setTick function. Updating this state by calling state.forceUpdate is the
    // only way we trigger React component updates (no other useState calls within
    // the InternalState class).
    state.forceUpdateState = $a1fq9.useReducer(function(tick) {
        return tick + 1;
    }, 0)[1];
    return state;
}
var $841b82d568969729$var$InternalState = /** @class */ function() {
    function InternalState(client, query, previous) {
        var _this = this;
        this.client = client;
        this.query = query;
        /**
         * Will be overwritten by the `useSyncExternalStore` "force update" method
         * whenever it is available and reset to `forceUpdateState` when it isn't.
         */ this.forceUpdate = function() {
            return _this.forceUpdateState();
        };
        this.ssrDisabledResult = (0, $jxMus.maybeDeepFreeze)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: (0, $4YvCN.NetworkStatus).loading
        });
        this.skipStandbyResult = (0, $jxMus.maybeDeepFreeze)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: (0, $4YvCN.NetworkStatus).ready
        });
        // This cache allows the referential stability of this.result (as returned by
        // getCurrentResult) to translate into referential stability of the resulting
        // QueryResult object returned by toQueryResult.
        this.toQueryResultCache = new ((0, $7X1wJ.canUseWeakMap) ? WeakMap : Map)();
        (0, $55wNp.verifyDocumentType)(query, (0, $55wNp.DocumentType).Query);
        // Reuse previousData from previous InternalState (if any) to provide
        // continuity of previousData even if/when the query or client changes.
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) this.previousData = previousData;
    }
    /**
     * Forces an update using local component state.
     * As this is not batched with `useSyncExternalStore` updates,
     * this is only used as a fallback if the `useSyncExternalStore` "force update"
     * method is not registered at the moment.
     * See https://github.com/facebook/react/issues/25191
     *  */ InternalState.prototype.forceUpdateState = function() {
        // Replaced (in useInternalState) with a method that triggers an update.
        globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).warn(51);
    };
    InternalState.prototype.executeQuery = function(options) {
        var _this = this;
        var _a;
        if (options.query) Object.assign(this, {
            query: options.query
        });
        this.watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var concast = this.observable.reobserveAsConcast(this.getObsQueryOptions());
        // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
        // but save the current data as this.previousData, just like setResult
        // usually does.
        this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
        this.result = void 0;
        this.forceUpdate();
        return new Promise(function(resolve) {
            var result;
            // Subscribe to the concast independently of the ObservableQuery in case
            // the component gets unmounted before the promise resolves. This prevents
            // the concast from terminating early and resolving with `undefined` when
            // there are no more subscribers for the concast.
            concast.subscribe({
                next: function(value) {
                    result = value;
                },
                error: function() {
                    resolve(_this.toQueryResult(_this.observable.getCurrentResult()));
                },
                complete: function() {
                    resolve(_this.toQueryResult(result));
                }
            });
        });
    };
    // Methods beginning with use- should be called according to the standard
    // rules of React hooks: only at the top level of the calling function, and
    // without any dynamic conditional logic.
    InternalState.prototype.useQuery = function(options) {
        var _this = this;
        // The renderPromises field gets initialized here in the useQuery method, at
        // the beginning of everything (for a given component rendering, at least),
        // so we can safely use this.renderPromises in other/later InternalState
        // methods without worrying it might be uninitialized. Even after
        // initialization, this.renderPromises is usually undefined (unless SSR is
        // happening), but that's fine as long as it has been initialized that way,
        // rather than left uninitialized.
        this.renderPromises = $a1fq9.useContext((0, $hkiUo.getApolloContext)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = (0, $14VzF.useSyncExternalStore)($a1fq9.useCallback(function(handleStoreChange) {
            if (_this.renderPromises) return function() {};
            _this.forceUpdate = handleStoreChange;
            var onNext = function() {
                var previousResult = _this.result;
                // We use `getCurrentResult()` instead of the onNext argument because
                // the values differ slightly. Specifically, loading results will have
                // an empty object for data instead of `undefined` for some reason.
                var result = obsQuery.getCurrentResult();
                // Make sure we're not attempting to re-render similar results
                if (previousResult && previousResult.loading === result.loading && previousResult.networkStatus === result.networkStatus && (0, $hr8gD.equal)(previousResult.data, result.data)) return;
                _this.setResult(result);
            };
            var onError = function(error) {
                subscription.unsubscribe();
                subscription = obsQuery.resubscribeAfterError(onNext, onError);
                if (!$841b82d568969729$var$hasOwnProperty.call(error, "graphQLErrors")) // The error is not a GraphQL error
                throw error;
                var previousResult = _this.result;
                if (!previousResult || previousResult && previousResult.loading || !(0, $hr8gD.equal)(error, previousResult.error)) _this.setResult({
                    data: previousResult && previousResult.data,
                    error: error,
                    loading: false,
                    networkStatus: (0, $4YvCN.NetworkStatus).error
                });
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            // Do the "unsubscribe" with a short delay.
            // This way, an existing subscription can be reused without an additional
            // request if "unsubscribe"  and "resubscribe" to the same ObservableQuery
            // happen in very fast succession.
            return function() {
                setTimeout(function() {
                    return subscription.unsubscribe();
                });
                _this.forceUpdate = function() {
                    return _this.forceUpdateState();
                };
            };
        }, [
            // We memoize the subscribe function using useCallback and the following
            // dependency keys, because the subscribe function reference is all that
            // useSyncExternalStore uses internally as a dependency key for the
            // useEffect ultimately responsible for the subscription, so we are
            // effectively passing this dependency array to that useEffect buried
            // inside useSyncExternalStore, as desired.
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches
        ]), function() {
            return _this.getCurrentResult();
        }, function() {
            return _this.getCurrentResult();
        });
        // TODO Remove this method when we remove support for options.partialRefetch.
        this.unsafeHandlePartialRefetch(result);
        return this.toQueryResult(result);
    };
    InternalState.prototype.useOptions = function(options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        // Update this.watchQueryOptions, but only when they have changed, which
        // allows us to depend on the referential stability of
        // this.watchQueryOptions elsewhere.
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (!(0, $hr8gD.equal)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                // Though it might be tempting to postpone this reobserve call to the
                // useEffect block, we need getCurrentResult to return an appropriate
                // loading:true result synchronously (later within the same call to
                // useQuery). Since we already have this.observable here (not true for
                // the very first call to useQuery), we are not initiating any new
                // subscriptions, though it does feel less than ideal that reobserve
                // (potentially) kicks off a network request (for example, when the
                // variables have changed), which is technically a side-effect.
                this.observable.reobserve(this.getObsQueryOptions());
                // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
                // but save the current data as this.previousData, just like setResult
                // usually does.
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        // Make sure state.onCompleted and state.onError always reflect the latest
        // options.onCompleted and options.onError callbacks provided to useQuery,
        // since those functions are often recreated every time useQuery is called.
        // Like the forceUpdate method, the versions of these methods inherited from
        // InternalState.prototype are empty no-ops, but we can override them on the
        // base state object (without modifying the prototype).
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) && this.queryHookOptions.ssr === false && !this.queryHookOptions.skip) // If SSR has been explicitly disabled, and this function has been called
        // on the server side, return the default loading state.
        this.result = this.ssrDisabledResult;
        else if (this.queryHookOptions.skip || this.watchQueryOptions.fetchPolicy === "standby") // When skipping a query (ie. we're not querying for data but still want to
        // render children), make sure the `data` is cleared out and `loading` is
        // set to `false` (since we aren't loading anything).
        //
        // NOTE: We no longer think this is the correct behavior. Skipping should
        // not automatically set `data` to `undefined`, but instead leave the
        // previous data in place. In other words, skipping should not mandate that
        // previously received data is all of a sudden removed. Unfortunately,
        // changing this is breaking, so we'll have to wait until Apollo Client 4.0
        // to address this.
        this.result = this.skipStandbyResult;
        else if (this.result === this.ssrDisabledResult || this.result === this.skipStandbyResult) this.result = void 0;
    };
    InternalState.prototype.getObsQueryOptions = function() {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults) toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) toMerge.push(this.queryHookOptions.defaultOptions);
        // We use compact rather than mergeOptions for this part of the merge,
        // because we want watchQueryOptions.variables (if defined) to replace
        // this.observable.options.variables whole. This replacement allows
        // removing variables by removing them from the variables input to
        // useQuery. If the variables were always merged together (rather than
        // replaced), there would be no way to remove existing variables.
        // However, the variables from options.defaultOptions and globalDefaults
        // (if provided) should be merged, to ensure individual defaulted
        // variables always have values, if not otherwise defined in
        // observable.options or watchQueryOptions.
        toMerge.push((0, $jZIxU.compact)(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce((0, $hcvqr.mergeOptions));
    };
    // A function to massage options before passing them to ObservableQuery.
    InternalState.prototype.createWatchQueryOptions = function(_a) {
        var _b;
        if (_a === void 0) _a = {};
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, // The above options are useQuery-specific, so this ...otherOptions spread
        // makes otherOptions almost a WatchQueryOptions object, except for the
        // query property that we add below.
        otherOptions = (0, $fKE23.__rest)(_a, [
            "skip",
            "ssr",
            "onCompleted",
            "onError",
            "defaultOptions"
        ]);
        // This Object.assign is safe because otherOptions is a fresh ...rest object
        // that did not exist until just now, so modifications are still allowed.
        var watchQueryOptions = Object.assign(otherOptions, {
            query: this.query
        });
        if (this.renderPromises && (watchQueryOptions.fetchPolicy === "network-only" || watchQueryOptions.fetchPolicy === "cache-and-network")) // this behavior was added to react-apollo without explanation in this PR
        // https://github.com/apollographql/react-apollo/pull/1579
        watchQueryOptions.fetchPolicy = "cache-first";
        if (!watchQueryOptions.variables) watchQueryOptions.variables = {};
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            // When skipping, we set watchQueryOptions.fetchPolicy initially to
            // "standby", but we also need/want to preserve the initial non-standby
            // fetchPolicy that would have been used if not skipping.
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: "standby"
            });
        } else if (!watchQueryOptions.fetchPolicy) watchQueryOptions.fetchPolicy = ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) || this.getDefaultFetchPolicy();
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function() {
        var _a, _b;
        return ((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "cache-first";
    };
    // Defining these methods as no-ops on the prototype allows us to call
    // state.onCompleted and/or state.onError without worrying about whether a
    // callback was provided.
    InternalState.prototype.onCompleted = function(data) {};
    InternalState.prototype.onError = function(error) {};
    InternalState.prototype.useObservableQuery = function() {
        // See if there is an existing observable that was used to fetch the same
        // data and if so, use it instead since it will contain the proper queryId
        // to fetch the result set. This is used during SSR.
        var obsQuery = this.observable = this.renderPromises && this.renderPromises.getSSRObservable(this.watchQueryOptions) || this.observable || // Reuse this.observable if possible (and not SSR)
        this.client.watchQuery(this.getObsQueryOptions());
        this.obsQueryFields = $a1fq9.useMemo(function() {
            return {
                refetch: obsQuery.refetch.bind(obsQuery),
                reobserve: obsQuery.reobserve.bind(obsQuery),
                fetchMore: obsQuery.fetchMore.bind(obsQuery),
                updateQuery: obsQuery.updateQuery.bind(obsQuery),
                startPolling: obsQuery.startPolling.bind(obsQuery),
                stopPolling: obsQuery.stopPolling.bind(obsQuery),
                subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery)
            };
        }, [
            obsQuery
        ]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false || this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) // TODO: This is a legacy API which could probably be cleaned up
            this.renderPromises.addObservableQueryPromise(obsQuery);
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function(nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) this.previousData = previousResult.data;
        this.result = nextResult;
        // Calling state.setResult always triggers an update, though some call sites
        // perform additional equality checks before committing to an update.
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult, previousResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function(result, previousResult) {
        var _this = this;
        if (!result.loading) {
            var error_1 = this.toApolloError(result);
            // wait a tick in case we are in the middle of rendering a component
            Promise.resolve().then(function() {
                if (error_1) _this.onError(error_1);
                else if (result.data && (previousResult === null || previousResult === void 0 ? void 0 : previousResult.networkStatus) !== result.networkStatus && result.networkStatus === (0, $4YvCN.NetworkStatus).ready) _this.onCompleted(result.data);
            }).catch(function(error) {
                globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).warn(error);
            });
        }
    };
    InternalState.prototype.toApolloError = function(result) {
        return (0, $kxw1Y.isNonEmptyArray)(result.errors) ? new (0, $7BIXz.ApolloError)({
            graphQLErrors: result.errors
        }) : result.error;
    };
    InternalState.prototype.getCurrentResult = function() {
        // Using this.result as a cache ensures getCurrentResult continues returning
        // the same (===) result object, unless state.setResult has been called, or
        // we're doing server rendering and therefore override the result below.
        if (!this.result) this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        return this.result;
    };
    InternalState.prototype.toQueryResult = function(result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult) return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0, $fKE23.__rest)(result, [
            "data",
            "partial"
        ]);
        this.toQueryResultCache.set(result, queryResult = (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({
            data: data
        }, resultWithoutPartial), this.obsQueryFields), {
            client: this.client,
            observable: this.observable,
            variables: this.observable.variables,
            called: !this.queryHookOptions.skip,
            previousData: this.previousData
        }));
        if (!queryResult.error && (0, $kxw1Y.isNonEmptyArray)(result.errors)) // Until a set naming convention for networkError and graphQLErrors is
        // decided upon, we map errors (graphQLErrors) to the error options.
        // TODO: Is it possible for both result.error and result.errors to be
        // defined here?
        queryResult.error = new (0, $7BIXz.ApolloError)({
            graphQLErrors: result.errors
        });
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function(result) {
        // WARNING: SIDE-EFFECTS IN THE RENDER FUNCTION
        //
        // TODO: This code should be removed when the partialRefetch option is
        // removed. I was unable to get this hook to behave reasonably in certain
        // edge cases when this block was put in an effect.
        if (result.partial && this.queryHookOptions.partialRefetch && !result.loading && (!result.data || Object.keys(result.data).length === 0) && this.observable.options.fetchPolicy !== "cache-only") {
            Object.assign(result, {
                loading: true,
                networkStatus: (0, $4YvCN.NetworkStatus).refetch
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}();

});
parcelRegister("14VzF", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $0c92d333413b5574$export$306c0aa65ff9ec16);
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $a1fq9 = parcelRequire("a1fq9");

var $7X1wJ = parcelRequire("7X1wJ");
var $0c92d333413b5574$var$didWarnUncachedGetSnapshot = false;
// Prevent webpack from complaining about our feature detection of the
// useSyncExternalStore property of the React namespace, which is expected not
// to exist when using React 17 and earlier, and that's fine.
var $0c92d333413b5574$var$uSESKey = "useSyncExternalStore";
var $0c92d333413b5574$var$realHook = $a1fq9[$0c92d333413b5574$var$uSESKey];
var $0c92d333413b5574$export$306c0aa65ff9ec16 = $0c92d333413b5574$var$realHook || function(subscribe, getSnapshot, getServerSnapshot) {
    // Read the current snapshot from the store on every render. Again, this
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    var value = getSnapshot();
    if (// DEVIATION: Using __DEV__
    globalThis.__DEV__ !== false && !$0c92d333413b5574$var$didWarnUncachedGetSnapshot && // DEVIATION: Not using Object.is because we know our snapshots will never
    // be exotic primitive values like NaN, which is !== itself.
    value !== getSnapshot()) {
        $0c92d333413b5574$var$didWarnUncachedGetSnapshot = true;
        // DEVIATION: Using invariant.error instead of console.error directly.
        globalThis.__DEV__ !== false && (0, $kL4FQ.invariant).error(58);
    }
    // Because updates are synchronous, we don't queue them. Instead we force a
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    var _a = $a1fq9.useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _a[0].inst, forceUpdate = _a[1];
    // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    if (0, $7X1wJ.canUseLayoutEffect) // DEVIATION: We avoid calling useLayoutEffect when !canUseLayoutEffect,
    // which may seem like a conditional hook, but this code ends up behaving
    // unconditionally (one way or the other) because canUseLayoutEffect is
    // constant.
    $a1fq9.useLayoutEffect(function() {
        Object.assign(inst, {
            value: value,
            getSnapshot: getSnapshot
        });
        // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($0c92d333413b5574$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    else Object.assign(inst, {
        value: value,
        getSnapshot: getSnapshot
    });
    $a1fq9.useEffect(function() {
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($0c92d333413b5574$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        // Subscribe to the store and return a clean-up function.
        return subscribe(function handleStoreChange() {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($0c92d333413b5574$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    return value;
};
function $0c92d333413b5574$var$checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    } catch (_b) {
        return true;
    }
}

});

parcelRegister("hkiUo", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $c9d2f8c1fa3b3f9f$export$a47505d961ee3a1);

var $a1fq9 = parcelRequire("a1fq9");

var $7X1wJ = parcelRequire("7X1wJ");
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");
// To make sure Apollo Client doesn't create more than one React context
// (which can lead to problems like having an Apollo Client instance added
// in one context, then attempting to retrieve it from another different
// context), a single Apollo context is created and tracked in global state.
var $c9d2f8c1fa3b3f9f$var$contextKey = (0, $7X1wJ.canUseSymbol) ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function $c9d2f8c1fa3b3f9f$export$a47505d961ee3a1() {
    (0, $kL4FQ.invariant)("createContext" in $a1fq9, 45);
    var context = $a1fq9.createContext[$c9d2f8c1fa3b3f9f$var$contextKey];
    if (!context) {
        Object.defineProperty($a1fq9.createContext, $c9d2f8c1fa3b3f9f$var$contextKey, {
            value: context = $a1fq9.createContext({}),
            enumerable: false,
            writable: false,
            configurable: true
        });
        context.displayName = "ApolloContext";
    }
    return context;
}
var $c9d2f8c1fa3b3f9f$export$c2ee824bcc89ca6a = $c9d2f8c1fa3b3f9f$export$a47505d961ee3a1;

});

parcelRegister("55wNp", function(module, exports) {

$parcel$export(module.exports, "DocumentType", () => $3b46dbf39f733332$export$d1d99cf900472499);
$parcel$export(module.exports, "verifyDocumentType", () => $3b46dbf39f733332$export$6dfb8732f737404c);
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $czLrN = parcelRequire("czLrN");
var $7MpZC = parcelRequire("7MpZC");

var $7XZ8S = parcelRequire("7XZ8S");
var $3b46dbf39f733332$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($3b46dbf39f733332$export$d1d99cf900472499 || ($3b46dbf39f733332$export$d1d99cf900472499 = {}));
var $3b46dbf39f733332$var$cache;
function $3b46dbf39f733332$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $3b46dbf39f733332$export$d1d99cf900472499.Query:
            name = "Query";
            break;
        case $3b46dbf39f733332$export$d1d99cf900472499.Mutation:
            name = "Mutation";
            break;
        case $3b46dbf39f733332$export$d1d99cf900472499.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
function $3b46dbf39f733332$export$8f49e4af10703ce3(document) {
    if (!$3b46dbf39f733332$var$cache) $3b46dbf39f733332$var$cache = new (0, $czLrN.AutoCleanedWeakCache)((0, $7MpZC.cacheSizes).parser || 1000 /* defaultCacheSizes.parser */ );
    var cached = $3b46dbf39f733332$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $kL4FQ.invariant)(!!document && !!document.kind, 59, document);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for(var _i = 0, _a = document.definitions; _i < _a.length; _i++){
        var x = _a[_i];
        if (x.kind === "FragmentDefinition") {
            fragments.push(x);
            continue;
        }
        if (x.kind === "OperationDefinition") switch(x.operation){
            case "query":
                queries.push(x);
                break;
            case "mutation":
                mutations.push(x);
                break;
            case "subscription":
                subscriptions.push(x);
                break;
        }
    }
    (0, $kL4FQ.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 60);
    (0, $kL4FQ.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 61, document, queries.length, subscriptions.length, mutations.length);
    type = queries.length ? $3b46dbf39f733332$export$d1d99cf900472499.Query : $3b46dbf39f733332$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $3b46dbf39f733332$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $kL4FQ.invariant)(definitions.length === 1, 62, document, definitions.length);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") name = definition.name.value;
    else name = "data"; // fallback to using data if no name
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $3b46dbf39f733332$var$cache.set(document, payload);
    return payload;
}
$3b46dbf39f733332$export$8f49e4af10703ce3.resetCache = function() {
    $3b46dbf39f733332$var$cache = undefined;
};
if (globalThis.__DEV__ !== false) (0, $7XZ8S.registerGlobalCache)("parser", function() {
    return $3b46dbf39f733332$var$cache ? $3b46dbf39f733332$var$cache.size : 0;
});
function $3b46dbf39f733332$export$6dfb8732f737404c(document, type) {
    var operation = $3b46dbf39f733332$export$8f49e4af10703ce3(document);
    var requiredOperationName = $3b46dbf39f733332$export$5db520940cf00715(type);
    var usedOperationName = $3b46dbf39f733332$export$5db520940cf00715(operation.type);
    (0, $kL4FQ.invariant)(operation.type === type, 63, requiredOperationName, requiredOperationName, usedOperationName);
}

});

parcelRegister("bxDwC", function(module, exports) {

$parcel$export(module.exports, "useApolloClient", () => $86716fa43d771583$export$eb9a56e7a29e494);
parcelRequire("aJBWo");
var $kL4FQ = parcelRequire("kL4FQ");

var $a1fq9 = parcelRequire("a1fq9");

var $hkiUo = parcelRequire("hkiUo");
function $86716fa43d771583$export$eb9a56e7a29e494(override) {
    var context = $a1fq9.useContext((0, $hkiUo.getApolloContext)());
    var client = override || context.client;
    (0, $kL4FQ.invariant)(!!client, 49);
    return client;
}

});

parcelRegister("hJ5J9", function(module, exports) {

$parcel$export(module.exports, "wrapHook", () => $ce7b14ee7e0f1cd6$export$7f12579c79e39619);
var $ce7b14ee7e0f1cd6$var$wrapperSymbol = Symbol.for("apollo.hook.wrappers");
function $ce7b14ee7e0f1cd6$export$7f12579c79e39619(hookName, useHook, clientOrObsQuery) {
    var queryManager = clientOrObsQuery["queryManager"];
    var wrappers = queryManager && queryManager[$ce7b14ee7e0f1cd6$var$wrapperSymbol];
    var wrapper = wrappers && wrappers[hookName];
    return wrapper ? wrapper(useHook) : useHook;
}

});



parcelRegister("kGAO3", function(module, exports) {

$parcel$export(module.exports, "PaginatedAppGrid", () => $f0f447db4a91b3d4$export$b938f3e715a1d974);

var $lMOk7 = parcelRequire("lMOk7");
var $eu8X4 = parcelRequire("eu8X4");
var $5rIEI = parcelRequire("5rIEI");
var $cpR7D = parcelRequire("cpR7D");

var $edD3H = parcelRequire("edD3H");
parcelRequire("eUqFw");

var $7bXbK = parcelRequire("7bXbK");
var $74bg7 = parcelRequire("74bg7");

var $8WfP8 = parcelRequire("8WfP8");

var $lHkHI = parcelRequire("lHkHI");
// TODO: Replace with actual error UI
const $f0f447db4a91b3d4$var$InitialFetchError = ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $8WfP8.InitialFetchErrorContainer), {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5rIEI.PartialOutageError), {})
    });
const $f0f447db4a91b3d4$var$FetchMoreError = ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $8WfP8.ErrorContainer), {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5rIEI.PartialOutageError), {
            level: "tile"
        })
    });
const $f0f447db4a91b3d4$export$b938f3e715a1d974 = (_ref)=>{
    let { renderGrid: renderGrid, isLoading: isLoading, isLoadingMore: isLoadingMore, onLoadMoreClick: onLoadMoreClick, showLoadMoreButton: showLoadMoreButton, fetchMoreError: fetchMoreError, initialFetchError: initialFetchError, desktopColumns: desktopColumns = 3, tabletColumns: tabletColumns = 2, mobileColumns: mobileColumns = 1 } = _ref;
    const { value: breakpoint } = (0, $cpR7D.useResponsiveBreakpoint)();
    const loadingMoreTileCount = breakpoint < (0, $lMOk7.breakpointValues).md ? tabletColumns : desktopColumns;
    if (initialFetchError) return /*#__PURE__*/ (0, $lHkHI.jsx)($f0f447db4a91b3d4$var$InitialFetchError, {});
    return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $74bg7.AppTilesGridContainer), {
                desktopColumns: desktopColumns,
                tabletColumns: tabletColumns,
                mobileColumns: mobileColumns,
                children: [
                    isLoading ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $edD3H.default), {
                        name: "app-tile",
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7bXbK.AppTileGridSkeleton), {
                            tileCount: desktopColumns * 2
                        })
                    }) : renderGrid(),
                    isLoadingMore && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7bXbK.AppTileGridSkeleton), {
                        tileCount: loadingMoreTileCount
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $8WfP8.GridFooterContainer), {
                children: [
                    fetchMoreError && /*#__PURE__*/ (0, $lHkHI.jsx)($f0f447db4a91b3d4$var$FetchMoreError, {}),
                    showLoadMoreButton && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8WfP8.ButtonContainer), {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eu8X4.Button), {
                            isLoading: isLoadingMore,
                            onClick: onLoadMoreClick,
                            "aria-label": "Load more apps",
                            children: "Load more"
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("edD3H", function(module, exports) {

$parcel$export(module.exports, "default", () => $3801ad6a9e7560f3$export$2e2bcd8739ae039);

var $e2aPv = parcelRequire("e2aPv");
var $3801ad6a9e7560f3$export$2e2bcd8739ae039 = (0, $e2aPv.default);

});

parcelRegister("7bXbK", function(module, exports) {

$parcel$export(module.exports, "AppTileGridSkeleton", () => $53c7791273a9c123$export$36b2a9a604a416f2);
/* Skeleton.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $bqcaO = parcelRequire("bqcaO");

var $hnWN5 = parcelRequire("hnWN5");

var $lHkHI = parcelRequire("lHkHI");
const $53c7791273a9c123$var$_excluded = [
    "as",
    "style"
];
function $53c7791273a9c123$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $53c7791273a9c123$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $53c7791273a9c123$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $53c7791273a9c123$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $53c7791273a9c123$export$98d442b3e57e24f4 = {
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large'
};
const $53c7791273a9c123$export$710b3a0939ba0810 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = (0, $bqcaO.Skeleton), style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $53c7791273a9c123$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $53c7791273a9c123$var$_objectSpread($53c7791273a9c123$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rko1q77 _p12f1lk4",
            __cmplp.size === $53c7791273a9c123$export$98d442b3e57e24f4.SMALL ? "_4t3imhvn" : __cmplp.size === $53c7791273a9c123$export$98d442b3e57e24f4.MEDIUM ? "_4t3intd2" : "_4t3i124j",
            __cmplp.className
        ])
    }));
});
const $53c7791273a9c123$export$36b2a9a604a416f2 = (_ref2)=>{
    let { tileCount: tileCount = 6, size: size = $53c7791273a9c123$export$98d442b3e57e24f4.LARGE } = _ref2;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: Array.from({
            length: tileCount
        }, (_, index)=>/*#__PURE__*/ (0, $lHkHI.jsx)($53c7791273a9c123$export$710b3a0939ba0810, {
                "data-testid": (0, $hnWN5.TEST_IDS).APP_TILE_SKELETON,
                size: size
            }, index))
    });
};

});
parcelRegister("bqcaO", function(module, exports) {

$parcel$export(module.exports, "Skeleton", () => $850b90d1da6073df$export$8f31e4c4a37b8e9c);
$parcel$export(module.exports, "MatchingLabelSkeleton", () => $850b90d1da6073df$export$310b762e4d9bd182);
$parcel$export(module.exports, "Stripe", () => $850b90d1da6073df$export$3c7919ca4c48cda4);
$parcel$export(module.exports, "AppListing2LineSkeleton", () => $850b90d1da6073df$export$7073bd4814843a30);
/* Skeletons.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $4V4Mb = parcelRequire("4V4Mb");
var $kBUpw = parcelRequire("kBUpw");

var $ivTMz = parcelRequire("ivTMz");

var $lHkHI = parcelRequire("lHkHI");
const $850b90d1da6073df$var$_excluded = [
    "as",
    "style"
], $850b90d1da6073df$var$_excluded2 = [
    "as",
    "style"
], $850b90d1da6073df$var$_excluded3 = [
    "as",
    "style"
], $850b90d1da6073df$var$_excluded4 = [
    "as",
    "style"
], $850b90d1da6073df$var$_excluded5 = [
    "as",
    "style"
];
function $850b90d1da6073df$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $850b90d1da6073df$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $850b90d1da6073df$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $850b90d1da6073df$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $850b90d1da6073df$var$shimmer = (0, $ivTMz.skeletonShimmer)();
const $850b90d1da6073df$export$8f31e4c4a37b8e9c = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $850b90d1da6073df$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $850b90d1da6073df$var$_objectSpread($850b90d1da6073df$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_j7hq19hg _bfhk1mnh _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8",
            __cmplp.className
        ])
    }));
});
const $850b90d1da6073df$export$310b762e4d9bd182 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = $850b90d1da6073df$export$8f31e4c4a37b8e9c, style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $850b90d1da6073df$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $850b90d1da6073df$var$_objectSpread($850b90d1da6073df$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2rkoi2wt _1bsb1178 _4t3i1crf _bfhk1mnh _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8 _1kkm1y44 _14b5r4m3 _1xloftgi _2oz41v6z _10jx33sj _15ri163w _glte1osq _165tdlk8",
            __cmplp.className
        ])
    }));
});
const $850b90d1da6073df$export$3c7919ca4c48cda4 = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    var _cmplp$width, _cmplp$height, _cmplp$borderRadius, _cmplp$marginTop, _cmplp$marginBottom;
    let { as: C = $850b90d1da6073df$export$8f31e4c4a37b8e9c, style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $850b90d1da6073df$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $850b90d1da6073df$var$_objectSpread($850b90d1da6073df$var$_objectSpread({}, __cmplp), {}, {
        style: $850b90d1da6073df$var$_objectSpread($850b90d1da6073df$var$_objectSpread({}, __cmpls), {}, {
            "--_pcenyd": (0, $9t7rW.default)((_cmplp$width = __cmplp.width) !== null && _cmplp$width !== void 0 ? _cmplp$width : '100%'),
            "--_16reqip": (0, $9t7rW.default)((_cmplp$height = __cmplp.height) !== null && _cmplp$height !== void 0 ? _cmplp$height : '16px'),
            "--_6bkswh": (0, $9t7rW.default)((_cmplp$borderRadius = __cmplp.borderRadius) !== null && _cmplp$borderRadius !== void 0 ? _cmplp$borderRadius : "var(--ds-border-radius-200, 8px)"),
            "--_xpa7ji": (0, $9t7rW.default)((_cmplp$marginTop = __cmplp.marginTop) !== null && _cmplp$marginTop !== void 0 ? _cmplp$marginTop : "var(--ds-space-0)"),
            "--_1rp2pwe": (0, $9t7rW.default)((_cmplp$marginBottom = __cmplp.marginBottom) !== null && _cmplp$marginBottom !== void 0 ? _cmplp$marginBottom : "var(--ds-space-0)"),
            "--_1m0m4uv": (0, $9t7rW.default)(__cmplp.maxWidth)
        }),
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbn9jh _4t3i10e5 _2rko1lfe _19pkyt99 _otyr1jhp _p12foqa0",
            __cmplp.className
        ])
    }));
});
const $850b90d1da6073df$var$Container = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $850b90d1da6073df$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $850b90d1da6073df$var$_objectSpread($850b90d1da6073df$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    }));
});
const $850b90d1da6073df$export$3d85b21940800888 = (_ref5)=>{
    let { testId: testId } = _ref5;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($850b90d1da6073df$var$Container, {
        "data-testId": testId,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($850b90d1da6073df$export$3c7919ca4c48cda4, {
                width: "60%"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kBUpw.Show), {
                above: "sm",
                children: /*#__PURE__*/ (0, $lHkHI.jsx)($850b90d1da6073df$export$3c7919ca4c48cda4, {
                    height: "14px",
                    width: "90%",
                    marginTop: "var(--ds-space-300)"
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4V4Mb.Hide), {
                above: "sm",
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($850b90d1da6073df$export$3c7919ca4c48cda4, {
                        height: "14px",
                        marginTop: "var(--ds-space-250)"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($850b90d1da6073df$export$3c7919ca4c48cda4, {
                        height: "14px",
                        marginTop: "var(--ds-space-250)"
                    })
                ]
            })
        ]
    });
};
const $850b90d1da6073df$var$AppListing2LineSkeletonContainer = (0, $eUqFw.forwardRef)((_ref6, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref6, __cmplp = (0, $bwPfh.default)(_ref6, $850b90d1da6073df$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $850b90d1da6073df$var$_objectSpread($850b90d1da6073df$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1tke1414 _1bsbhv4l _1qwo1osq",
            __cmplp.className
        ])
    }));
});
const $850b90d1da6073df$export$7073bd4814843a30 = (_ref7)=>{
    let { testId: testId } = _ref7;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($850b90d1da6073df$var$AppListing2LineSkeletonContainer, {
        "data-testid": testId,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($850b90d1da6073df$export$3c7919ca4c48cda4, {
                width: "55%",
                height: "1rem",
                marginTop: "var(--ds-space-500)"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($850b90d1da6073df$export$3c7919ca4c48cda4, {
                width: "100%",
                height: "1rem",
                marginTop: "var(--ds-space-300)"
            })
        ]
    });
};

});
parcelRegister("4V4Mb", function(module, exports) {

$parcel$export(module.exports, "Hide", () => $395030ba9d3389ad$export$bed28288a051538);
/** @jsx jsx */ 
var $byn9U = parcelRequire("byn9U");

var $aokGA = parcelRequire("aokGA");
const $395030ba9d3389ad$var$hideAboveQueries = (0, $aokGA.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $395030ba9d3389ad$var$hideBelowQueries = (0, $aokGA.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $395030ba9d3389ad$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div' })=>{
    return (0, $byn9U.jsx)(AsElement, {
        css: [
            above && $395030ba9d3389ad$var$hideAboveQueries[above],
            below && $395030ba9d3389ad$var$hideBelowQueries[below]
        ]
    }, children);
};

});



parcelRegister("74bg7", function(module, exports) {

$parcel$export(module.exports, "AppTilesGridContainer", () => $5251a3eab437bb41$export$858347a1edadcd27);
/* AppTilesGridContainer.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $lHkHI = parcelRequire("lHkHI");
const $5251a3eab437bb41$var$_excluded = [
    "as",
    "style"
], $5251a3eab437bb41$var$_excluded2 = [
    "mobileColumns",
    "tabletColumns",
    "desktopColumns"
];
function $5251a3eab437bb41$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5251a3eab437bb41$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5251a3eab437bb41$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5251a3eab437bb41$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5251a3eab437bb41$export$858347a1edadcd27 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    var _cmplp$mobileColumns, _cmplp$tabletColumns, _cmplp$desktopColumn, _cmplp$desktopColumn2;
    let { as: C = "ul", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $5251a3eab437bb41$var$_excluded);
    const { mobileColumns: mobileColumns, tabletColumns: tabletColumns, desktopColumns: desktopColumns } = __cmplp, __cmpldp = (0, $bwPfh.default)(__cmplp, $5251a3eab437bb41$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $5251a3eab437bb41$var$_objectSpread($5251a3eab437bb41$var$_objectSpread({}, __cmpldp), {}, {
        style: $5251a3eab437bb41$var$_objectSpread($5251a3eab437bb41$var$_objectSpread({}, __cmpls), {}, {
            "--_18ukq9a": (0, $9t7rW.default)("repeat(".concat((_cmplp$mobileColumns = __cmplp.mobileColumns) !== null && _cmplp$mobileColumns !== void 0 ? _cmplp$mobileColumns : 1, ", minmax(0, 1fr))")),
            "--_861wfr": (0, $9t7rW.default)("repeat(".concat((_cmplp$tabletColumns = __cmplp.tabletColumns) !== null && _cmplp$tabletColumns !== void 0 ? _cmplp$tabletColumns : 2, ", minmax(0, 1fr))")),
            "--_bnc5jk": (0, $9t7rW.default)("repeat(auto-fill, minmax(max(272px, calc((100% - ".concat((((_cmplp$desktopColumn = __cmplp.desktopColumns) !== null && _cmplp$desktopColumn !== void 0 ? _cmplp$desktopColumn : 3) - 1) * 32, "px)/").concat((_cmplp$desktopColumn2 = __cmplp.desktopColumns) !== null && _cmplp$desktopColumn2 !== void 0 ? _cmplp$desktopColumn2 : 3, ")), 1fr))"))
        }),
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c11p5 _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _qtt8glyw _yv0e1gma _1p57xjmg _1da7pg39 _1gzvl6l0 _1rqt8llh _pdlmhiv4",
            __cmplp.className
        ])
    }));
});

});

parcelRegister("8WfP8", function(module, exports) {

$parcel$export(module.exports, "GridFooterContainer", () => $682003c86a1ff29c$export$dc81d5e0847a9805);
$parcel$export(module.exports, "ButtonContainer", () => $682003c86a1ff29c$export$eddf54ea3db8d0f0);
$parcel$export(module.exports, "InitialFetchErrorContainer", () => $682003c86a1ff29c$export$cb5077916bbd811e);
$parcel$export(module.exports, "ErrorContainer", () => $682003c86a1ff29c$export$97bdf39f6b82bb0);
/* PaginatedAppGrid.styles.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lHkHI = parcelRequire("lHkHI");
const $682003c86a1ff29c$var$_excluded = [
    "as",
    "style"
], $682003c86a1ff29c$var$_excluded2 = [
    "as",
    "style"
], $682003c86a1ff29c$var$_excluded3 = [
    "as",
    "style"
], $682003c86a1ff29c$var$_excluded4 = [
    "as",
    "style"
];
function $682003c86a1ff29c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $682003c86a1ff29c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $682003c86a1ff29c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $682003c86a1ff29c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $682003c86a1ff29c$export$dc81d5e0847a9805 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $682003c86a1ff29c$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $682003c86a1ff29c$var$_objectSpread($682003c86a1ff29c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    }));
});
const $682003c86a1ff29c$export$eddf54ea3db8d0f0 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $682003c86a1ff29c$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $682003c86a1ff29c$var$_objectSpread($682003c86a1ff29c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pka5zd",
            __cmplp.className
        ])
    }));
});
const $682003c86a1ff29c$export$cb5077916bbd811e = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $682003c86a1ff29c$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $682003c86a1ff29c$var$_objectSpread($682003c86a1ff29c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    }));
});
const $682003c86a1ff29c$export$97bdf39f6b82bb0 = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $682003c86a1ff29c$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $682003c86a1ff29c$var$_objectSpread($682003c86a1ff29c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkap9k",
            __cmplp.className
        ])
    }));
});

});


parcelRegister("7ELm9", function(module, exports) {

$parcel$export(module.exports, "default", () => $593100d260bf79cc$export$2e2bcd8739ae039);
parcelRequire("eUqFw");

var $eu8X4 = parcelRequire("eu8X4");

var $cCrLo = parcelRequire("cCrLo");

var $ausID = parcelRequire("ausID");

var $V46Tp = parcelRequire("V46Tp");

var $lHkHI = parcelRequire("lHkHI");
const $593100d260bf79cc$var$NoResultView = (_ref)=>{
    let { title: title, description: description, showClearFilterButton: showClearFilterButton, onClearFiltersClick: onClearFiltersClick } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $ausID.NoResultViewContainer), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $ausID.NoResultViewContent), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ausID.SearchErrorImageContainer), {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ausID.SearchErrorImage), {
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($V46Tp))),
                            alt: "search-error-icon"
                        })
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $ausID.TextContainer), {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.H5), {
                                as: "h3",
                                children: title
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.BodyNormal), {
                                children: description
                            })
                        ]
                    })
                ]
            }),
            showClearFilterButton && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eu8X4.Button), {
                onClick: onClearFiltersClick,
                children: "Clear filters"
            })
        ]
    });
};
var $593100d260bf79cc$export$2e2bcd8739ae039 = $593100d260bf79cc$var$NoResultView;

});
parcelRegister("ausID", function(module, exports) {

$parcel$export(module.exports, "NoResultViewContainer", () => $7a32fbae5bbdeef7$export$fea8babdbb364fca);
$parcel$export(module.exports, "NoResultViewContent", () => $7a32fbae5bbdeef7$export$a5e6f6f80e4d2e21);
$parcel$export(module.exports, "SearchErrorImageContainer", () => $7a32fbae5bbdeef7$export$25f1adcac4f5b44c);
$parcel$export(module.exports, "SearchErrorImage", () => $7a32fbae5bbdeef7$export$d689645a972509c2);
$parcel$export(module.exports, "TextContainer", () => $7a32fbae5bbdeef7$export$762240c6611b6ed2);
/* NoResultViewStyles.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $lHkHI = parcelRequire("lHkHI");
const $7a32fbae5bbdeef7$var$_excluded = [
    "as",
    "style"
], $7a32fbae5bbdeef7$var$_excluded2 = [
    "as",
    "style"
], $7a32fbae5bbdeef7$var$_excluded3 = [
    "as",
    "style"
], $7a32fbae5bbdeef7$var$_excluded4 = [
    "as",
    "style"
], $7a32fbae5bbdeef7$var$_excluded5 = [
    "as",
    "style"
];
function $7a32fbae5bbdeef7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7a32fbae5bbdeef7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7a32fbae5bbdeef7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7a32fbae5bbdeef7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $7a32fbae5bbdeef7$export$fea8babdbb364fca = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $7a32fbae5bbdeef7$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7a32fbae5bbdeef7$var$_objectSpread($7a32fbae5bbdeef7$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulpl6l0 _1yt4i1hg _1yag172p _pdlm1bcc",
            __cmplp.className
        ])
    }));
});
const $7a32fbae5bbdeef7$export$a5e6f6f80e4d2e21 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $7a32fbae5bbdeef7$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7a32fbae5bbdeef7$var$_objectSpread($7a32fbae5bbdeef7$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulpv47k _19wg1bcc",
            __cmplp.className
        ])
    }));
});
const $7a32fbae5bbdeef7$export$25f1adcac4f5b44c = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $7a32fbae5bbdeef7$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7a32fbae5bbdeef7$var$_objectSpread($7a32fbae5bbdeef7$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1h6o _4t3i1lit _1bsb1osq",
            __cmplp.className
        ])
    }));
});
const $7a32fbae5bbdeef7$export$d689645a972509c2 = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "img", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $7a32fbae5bbdeef7$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7a32fbae5bbdeef7$var$_objectSpread($7a32fbae5bbdeef7$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1osq _1bsb1wug",
            __cmplp.className
        ])
    }));
});
const $7a32fbae5bbdeef7$export$762240c6611b6ed2 = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $7a32fbae5bbdeef7$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7a32fbae5bbdeef7$var$_objectSpread($7a32fbae5bbdeef7$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    }));
});

});

parcelRegister("V46Tp", function(module, exports) {
module.exports = new URL("SearchError.27457269.svg", import.meta.url).toString();

});


parcelRegister("ctw0C", function(module, exports) {

$parcel$export(module.exports, "SortDropdown", () => $915105c908d92baf$export$a1dacc7d85bcff8f);

var $5zQU9 = parcelRequire("5zQU9");

var $drftW = parcelRequire("drftW");

var $1VibC = parcelRequire("1VibC");

var $4J2zX = parcelRequire("4J2zX");

var $8oBYp = parcelRequire("8oBYp");
var $d4qUE = parcelRequire("d4qUE");

var $FHhXl = parcelRequire("FHhXl");

var $dzIcn = parcelRequire("dzIcn");

var $eUqFw = parcelRequire("eUqFw");

var $lMOk7 = parcelRequire("lMOk7");

var $3DYxj = parcelRequire("3DYxj");

var $cpR7D = parcelRequire("cpR7D");

var $64ZkH = parcelRequire("64ZkH");

var $cvjHw = parcelRequire("cvjHw");

var $hF54A = parcelRequire("hF54A");

var $04WXo = parcelRequire("04WXo");

var $4RRFh = parcelRequire("4RRFh");

var $lHkHI = parcelRequire("lHkHI");
function $915105c908d92baf$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $915105c908d92baf$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $915105c908d92baf$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $915105c908d92baf$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $915105c908d92baf$var$buttonStyles = (0, $d4qUE.xcss)($915105c908d92baf$var$_objectSpread($915105c908d92baf$var$_objectSpread({}, (0, $3DYxj.charlieTextFontFamily)), {}, {
    cursor: 'pointer',
    paddingInlineStart: 'space.150',
    paddingInlineEnd: 'space.050',
    paddingBlock: 'space.050',
    borderRadius: 'border.radius',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'color.text',
    fontSize: '0.875rem',
    fontWeight: '400',
    background: 'none',
    ':hover': {
        backgroundColor: 'color.background.neutral.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.pressed'
    }
}));
const $915105c908d92baf$var$buttonMobileStyles = (0, $d4qUE.xcss)({
    width: '100%',
    backgroundColor: 'color.background.neutral',
    height: '40px'
});
const $915105c908d92baf$var$customComponents = {
    Option: (0, $04WXo.CustomOption),
    Menu: (0, $hF54A.CustomMenu),
    Control: (0, $cvjHw.CustomControl)
};
const $915105c908d92baf$var$subtleSelectedStyles = (0, $d4qUE.xcss)({
    color: 'color.text.selected',
    ':hover': {
        backgroundColor: 'color.background.selected.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.selected.pressed'
    }
});
const $915105c908d92baf$var$customSelectStyles = {
    container: (base)=>$915105c908d92baf$var$_objectSpread($915105c908d92baf$var$_objectSpread({}, base), {}, {
            width: '180px',
            [(0, $8oBYp.media).below.sm]: {
                width: "calc(".concat(window.innerWidth, "px - (", "var(--ds-space-400)", " * 2))")
            },
            [(0, $8oBYp.media).below.xs]: {
                width: "calc(".concat(window.innerWidth, "px - (", "var(--ds-space-300)", " * 2))")
            }
        }),
    control: (base)=>$915105c908d92baf$var$_objectSpread($915105c908d92baf$var$_objectSpread({}, base), {}, {
            border: 0 // Removing the default border around the select control
        }),
    option: (base)=>$915105c908d92baf$var$_objectSpread($915105c908d92baf$var$_objectSpread({}, base), {}, {
            minHeight: '40px',
            padding: "var(--ds-space-100)".concat(" ", "var(--ds-space-200)")
        })
};
const $915105c908d92baf$export$a1dacc7d85bcff8f = (_ref)=>{
    let { onSortOptionSelect: onSortOptionSelect, selectedSortKey: selectedSortKey, sortOptions: sortOptions = (0, $4RRFh.sortOptionsConfig) } = _ref;
    const { value: breakpoint } = (0, $cpR7D.useResponsiveBreakpoint)();
    const isMobile = breakpoint < (0, $lMOk7.breakpointValues).sm;
    const [isPopupOpen, setIsPopupOpen] = (0, $eUqFw.useState)(false);
    const [selectedOption, setSelectedOption] = (0, $eUqFw.useState)();
    const triggerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        setSelectedOption(sortOptions.find((option)=>option.value === selectedSortKey) || sortOptions[0]);
    }, [
        selectedSortKey
    ]);
    const onSelectionChange = (option)=>{
        setIsPopupOpen(false);
        setSelectedOption(option);
        if (onSortOptionSelect) onSortOptionSelect(option);
    };
    const focusOnTriggerButton = (0, $eUqFw.useCallback)(()=>{
        setTimeout(()=>{
            var _triggerRef$current;
            return (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.focus();
        });
    }, []);
    const handlePopupClose = (event)=>{
        if (event.key === 'Escape') focusOnTriggerButton();
        setIsPopupOpen(false);
    };
    const handleSelectKeyDown = (event)=>{
        if (event.key === 'Enter') focusOnTriggerButton();
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4J2zX.Popup), {
        isOpen: isPopupOpen,
        onClose: handlePopupClose,
        placement: "bottom-start",
        autoFocus: false,
        trigger: (triggerProps)=>/*#__PURE__*/ (0, $lHkHI.jsxs)((0, $FHhXl.default), $915105c908d92baf$var$_objectSpread($915105c908d92baf$var$_objectSpread({}, triggerProps), {}, {
                ref: (0, $64ZkH.mergeRefs)(triggerRef, triggerProps.ref),
                onClick: ()=>setIsPopupOpen((prevState)=>!prevState),
                xcss: [
                    $915105c908d92baf$var$buttonStyles,
                    isMobile && $915105c908d92baf$var$buttonMobileStyles,
                    isPopupOpen && $915105c908d92baf$var$subtleSelectedStyles
                ],
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
                        children: [
                            "Sort by: ",
                            selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label
                        ]
                    }),
                    isPopupOpen ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($1VibC))), {
                        label: ""
                    }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($drftW))), {
                        label: ""
                    })
                ]
            })),
        content: ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $dzIcn.default), {
                testId: "sort-dropdown.select",
                options: sortOptions,
                value: selectedOption,
                onChange: onSelectionChange,
                components: $915105c908d92baf$var$customComponents,
                styles: $915105c908d92baf$var$customSelectStyles,
                menuIsOpen: true,
                autoFocus: true,
                blurInputOnSelect: true,
                closeMenuOnSelect: false,
                hideSelectedOptions: false,
                controlShouldRenderValue: false,
                menuShouldScrollIntoView: false,
                tabSelectsValue: false,
                isClearable: false,
                escapeClearsValue: false,
                isSearchable: false,
                onKeyDown: handleSelectKeyDown
            })
    });
};

});
parcelRegister("cvjHw", function(module, exports) {

$parcel$export(module.exports, "CustomControl", () => $91a7a981207137e5$export$b0c082086b5fac02);

var $5zQU9 = parcelRequire("5zQU9");

var $6Wmpx = parcelRequire("6Wmpx");

var $lWrn5 = parcelRequire("lWrn5");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $91a7a981207137e5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $91a7a981207137e5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $91a7a981207137e5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $91a7a981207137e5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $91a7a981207137e5$export$b0c082086b5fac02 = (props)=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lWrn5.default), {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6Wmpx.c).Control, $91a7a981207137e5$var$_objectSpread({}, props))
    });
};

});

parcelRegister("hF54A", function(module, exports) {

$parcel$export(module.exports, "CustomMenu", () => $cdba336803431d4d$export$4664e7a657286474);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $cdba336803431d4d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cdba336803431d4d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cdba336803431d4d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cdba336803431d4d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $cdba336803431d4d$export$2f50339a3051f2f1 = (_ref)=>{
    let { children: children } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: children
    });
};
const $cdba336803431d4d$export$4664e7a657286474 = (_ref2)=>{
    let { innerRef: innerRef, innerProps: innerProps, children: children } = _ref2;
    return /*#__PURE__*/ (0, $lHkHI.jsx)("div", $cdba336803431d4d$var$_objectSpread($cdba336803431d4d$var$_objectSpread({
        ref: innerRef
    }, innerProps), {}, {
        children: children
    }));
};

});

parcelRegister("04WXo", function(module, exports) {

$parcel$export(module.exports, "CustomOption", () => $00ee1b7c8b974f7d$export$bf9b4e708cea1760);

var $5zQU9 = parcelRequire("5zQU9");

var $379fO = parcelRequire("379fO");
var $4xAW3 = parcelRequire("4xAW3");
var $5cJpv = parcelRequire("5cJpv");
var $d4qUE = parcelRequire("d4qUE");

var $6Wmpx = parcelRequire("6Wmpx");
parcelRequire("eUqFw");

var $3DYxj = parcelRequire("3DYxj");

var $lHkHI = parcelRequire("lHkHI");
function $00ee1b7c8b974f7d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $00ee1b7c8b974f7d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $00ee1b7c8b974f7d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $00ee1b7c8b974f7d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $00ee1b7c8b974f7d$var$optionWrapperStyles = (0, $d4qUE.xcss)({
    // Enable wrapping text within the option container
    whiteSpace: 'normal'
});
const $00ee1b7c8b974f7d$var$optionStyles = (0, $d4qUE.xcss)($00ee1b7c8b974f7d$var$_objectSpread({}, (0, $3DYxj.charlieTextFontFamily)));
const $00ee1b7c8b974f7d$export$d4f91bf0d7ad43a0 = (_ref)=>{
    let { label: label } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4xAW3.default), {
        space: "space.100",
        alignBlock: "center",
        grow: "fill",
        xcss: $00ee1b7c8b974f7d$var$optionWrapperStyles,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5cJpv.default), {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $379fO.default), {
                xcss: $00ee1b7c8b974f7d$var$optionStyles,
                children: label
            })
        })
    });
};
const $00ee1b7c8b974f7d$export$bf9b4e708cea1760 = (props)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $6Wmpx.c).Option, $00ee1b7c8b974f7d$var$_objectSpread($00ee1b7c8b974f7d$var$_objectSpread({}, props), {}, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)($00ee1b7c8b974f7d$export$d4f91bf0d7ad43a0, $00ee1b7c8b974f7d$var$_objectSpread({}, props.data))
    }));

});

parcelRegister("4RRFh", function(module, exports) {

$parcel$export(module.exports, "sortOptionsConfig", () => $38b5bd59e476fac9$export$ffdef18cb4426d05);
const $38b5bd59e476fac9$export$ffdef18cb4426d05 = [
    {
        value: 'relevance',
        label: 'Relevance'
    },
    {
        value: 'topRated',
        label: 'Top rated'
    },
    {
        value: 'trending',
        label: 'Popularity'
    },
    {
        value: 'topSelling',
        label: 'Top selling'
    },
    {
        value: 'newest',
        label: 'Newest'
    }
];

});


parcelRegister("5kA21", function(module, exports) {

$parcel$export(module.exports, "useSearchPageAnalytics", () => $3e1ac5218e276d76$export$9e57c01767ef6d73);

var $gwoWU = parcelRequire("gwoWU");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $ammkg = parcelRequire("ammkg");
var $kafab = parcelRequire("kafab");

var $hCl9L = parcelRequire("hCl9L");

var $9AuiZ = parcelRequire("9AuiZ");
const $3e1ac5218e276d76$export$58d3020a1a1fe6b = (app)=>{
    var _app$programs;
    return (0, $gwoWU.isBugBountyParticipant)((0, $ammkg.AtlassianProductHostingType).Cloud, app === null || app === void 0 ? void 0 : (_app$programs = app.programs) === null || _app$programs === void 0 ? void 0 : _app$programs.bugBountyParticipant) && app.deployments.includes('cloud');
};
const $3e1ac5218e276d76$export$c88d72b90811f5dc = (app)=>{
    var _app$programs2, _app$programs2$cloudF;
    return ((_app$programs2 = app.programs) === null || _app$programs2 === void 0 ? void 0 : (_app$programs2$cloudF = _app$programs2.cloudFortified) === null || _app$programs2$cloudF === void 0 ? void 0 : _app$programs2$cloudF.status) === (0, $kafab.CloudFortifiedStatusValues).Approved;
};
const $3e1ac5218e276d76$export$9e57c01767ef6d73 = ()=>{
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const handleErrorStateAnalytics = (_ref)=>{
        let { actionSubjectId: actionSubjectId, errorType: errorType } = _ref;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.ErrorStateEvent),
            actionSubjectId: actionSubjectId,
            attributes: {
                errorType: errorType
            }
        });
    };
    const handleFilterSelectionAnalytics = (_ref2)=>{
        let { filterType: filterType, filterValue: filterValue } = _ref2;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.FilterClickedEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).FILTER_OPTION_SELECTED,
            attributes: {
                filterType: filterType,
                filterValue: (0, $hCl9L.getAnalyticsFilterOption)(filterValue)
            }
        });
    };
    const handleClearSelectionAnalytics = (_ref3)=>{
        let { filterType: filterType } = _ref3;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.ClearFilterEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).CLEAR_FILTER_CLICKED,
            attributes: {
                filterType: filterType
            }
        });
    };
    const handleClearAllFiltersAnalytics = (_ref4)=>{
        let { filters: filters } = _ref4;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).CLEAR_ALL_FILTERS_CLICKED,
            attributes: {
                filters: (0, $hCl9L.getAnalyticsFilters)(filters)
            }
        });
    };
    const handleTilesRenderedAnalytics = (_ref5)=>{
        let { filters: filters, count: count } = _ref5;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.TilesRenderedEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).SEARCH_TILES_RENDERED,
            attributes: {
                filters: (0, $hCl9L.getAnalyticsFilters)(filters),
                count: count
            }
        });
    };
    const handleTileClickAnalytics = (_ref6)=>{
        let { tileData: tileData, hitRank: hitRank, filters: filters } = _ref6;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.TileClickedEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).SEARCH_TILE_CLICKED,
            attributes: {
                label: tileData.addonKey,
                appName: tileData.name,
                hitRank: hitRank,
                filters: (0, $hCl9L.getAnalyticsFilters)(filters),
                currentPerspective: 'search',
                hitSize: 'large',
                hasCloudSecurityBadge: $3e1ac5218e276d76$export$58d3020a1a1fe6b(tileData),
                hasCloudFortifiedBadge: $3e1ac5218e276d76$export$c88d72b90811f5dc(tileData)
            }
        });
    };
    const handleLoadMoreClickAnalytics = (_ref7)=>{
        let { pageNumber: pageNumber, filters: filters } = _ref7;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).LOAD_MORE_CLICKED,
            attributes: {
                pageNumber: pageNumber,
                filters: (0, $hCl9L.getAnalyticsFilters)(filters)
            }
        });
    };
    const handleApplyFiltersClickAnalytics = (_ref8)=>{
        let { filters: filters } = _ref8;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).APPLY_FILTERS_CLICKED,
            attributes: {
                filters: (0, $hCl9L.getAnalyticsFilters)(filters)
            }
        });
    };
    const handleYourSearchQueryClickAnalytics = (_ref9)=>{
        let { query: query } = _ref9;
        fireAnalyticsEvent({
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).YOUR_SEARCH_QUERY_CLICKED,
            attributes: {
                query: query
            }
        });
    };
    const handleFilterErrorStateAnalytics = (_ref10)=>{
        let { currentFilterState: currentFilterState } = _ref10;
        const filterTypes = Object.keys(currentFilterState).filter((filterId)=>currentFilterState[filterId] === 'error');
        if (filterTypes.length) fireAnalyticsEvent({
            eventType: (0, $gaiog.ErrorStateEvent),
            actionSubjectId: (0, $9AuiZ.ANALYTICS_ACTION_SUBJECT_ID).FILTER_OPTIONS_ERROR_RENDERED,
            attributes: {
                filterTypes: filterTypes
            }
        });
    };
    return {
        handleErrorStateAnalytics: handleErrorStateAnalytics,
        handleFilterSelectionAnalytics: handleFilterSelectionAnalytics,
        handleClearSelectionAnalytics: handleClearSelectionAnalytics,
        handleClearAllFiltersAnalytics: handleClearAllFiltersAnalytics,
        handleTilesRenderedAnalytics: handleTilesRenderedAnalytics,
        handleTileClickAnalytics: handleTileClickAnalytics,
        handleLoadMoreClickAnalytics: handleLoadMoreClickAnalytics,
        handleApplyFiltersClickAnalytics: handleApplyFiltersClickAnalytics,
        handleYourSearchQueryClickAnalytics: handleYourSearchQueryClickAnalytics,
        handleFilterErrorStateAnalytics: handleFilterErrorStateAnalytics
    };
};

});

parcelRegister("fHQub", function(module, exports) {

$parcel$export(module.exports, "GridHeader", () => $b6f395bf7e88ea9b$export$74ac40502a3200d3);
/* SearchResultPage.styles.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $lHkHI = parcelRequire("lHkHI");
const $b6f395bf7e88ea9b$var$_excluded = [
    "as",
    "style"
];
function $b6f395bf7e88ea9b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b6f395bf7e88ea9b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b6f395bf7e88ea9b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b6f395bf7e88ea9b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $b6f395bf7e88ea9b$export$74ac40502a3200d3 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $b6f395bf7e88ea9b$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b6f395bf7e88ea9b$var$_objectSpread($b6f395bf7e88ea9b$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _1n261g80 _1p571eps _1mou5k6p _u5gg1f09",
            __cmplp.className
        ])
    }));
});

});

parcelRegister("kZkyb", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4797203b66006b3$export$2e2bcd8739ae039);
/* EndPageLabel.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cCrLo = parcelRequire("cCrLo");

var $lHkHI = parcelRequire("lHkHI");
const $f4797203b66006b3$var$_excluded = [
    "as",
    "style"
], $f4797203b66006b3$var$_excluded2 = [
    "as",
    "style"
];
function $f4797203b66006b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f4797203b66006b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f4797203b66006b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f4797203b66006b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f4797203b66006b3$var$Label = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $f4797203b66006b3$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $f4797203b66006b3$var$_objectSpread($f4797203b66006b3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _19pkoahv",
            __cmplp.className
        ])
    }));
});
const $f4797203b66006b3$var$BackToSearchButton = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "button", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $f4797203b66006b3$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $f4797203b66006b3$var$_objectSpread($f4797203b66006b3$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1qtk _11q7glyw _19itglyw _1wyb1j6v _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _80omtlke",
            __cmplp.className
        ])
    }));
});
const $f4797203b66006b3$var$EndPageLabel = (_ref3)=>{
    let { onLinkClick: onLinkClick } = _ref3;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($f4797203b66006b3$var$Label, {
        children: [
            "Couldn\u2019t find what you were looking for? Try rephrasing",
            ' ',
            /*#__PURE__*/ (0, $lHkHI.jsx)($f4797203b66006b3$var$BackToSearchButton, {
                onClick: onLinkClick,
                children: "your search query"
            }),
            "."
        ]
    });
};
var $f4797203b66006b3$export$2e2bcd8739ae039 = $f4797203b66006b3$var$EndPageLabel;

});

parcelRegister("2yXdH", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ddcb1967139eb90$export$2e2bcd8739ae039);
/* MatchingResultLabel.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cCrLo = parcelRequire("cCrLo");
var $bqcaO = parcelRequire("bqcaO");

var $hgNMk = parcelRequire("hgNMk");

var $ldS4g = parcelRequire("ldS4g");

var $lHkHI = parcelRequire("lHkHI");
const $1ddcb1967139eb90$var$_excluded = [
    "children"
], $1ddcb1967139eb90$var$_excluded2 = [
    "as",
    "style"
];
function $1ddcb1967139eb90$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $1ddcb1967139eb90$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $1ddcb1967139eb90$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $1ddcb1967139eb90$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $1ddcb1967139eb90$var$H2 = (_ref)=>{
    let { children: children } = _ref, props = (0, $bwPfh.default)(_ref, $1ddcb1967139eb90$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.BodyNormal), $1ddcb1967139eb90$var$_objectSpread($1ddcb1967139eb90$var$_objectSpread({
        as: "h2"
    }, props), {}, {
        children: children
    }));
};
const $1ddcb1967139eb90$var$BodyStyled = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = $1ddcb1967139eb90$var$H2, style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $1ddcb1967139eb90$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $1ddcb1967139eb90$var$_objectSpread($1ddcb1967139eb90$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1 _vwz41k8s _19pkidpf",
            __cmplp.className
        ])
    }));
});
const $1ddcb1967139eb90$export$1051fb1821141370 = (count)=>count > 1000 ? 'over 1,000' : count;
const $1ddcb1967139eb90$var$MatchingResultLabel = (_ref3)=>{
    let { isSearchQueryActive: isSearchQueryActive, totalCount: totalCount, isLoading: isLoading, areFiltersActive: areFiltersActive } = _ref3;
    if (isLoading) return /*#__PURE__*/ (0, $lHkHI.jsx)($1ddcb1967139eb90$var$BodyStyled, {
        "data-testId": (0, $ldS4g.TEST_IDS).MATCHING_LABEL_SKELETON,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqcaO.MatchingLabelSkeleton), {})
    });
    if (!isSearchQueryActive && !areFiltersActive) return /*#__PURE__*/ (0, $lHkHI.jsxs)($1ddcb1967139eb90$var$BodyStyled, {
        children: [
            "Showing ",
            $1ddcb1967139eb90$export$1051fb1821141370(totalCount),
            " apps"
        ]
    });
    if (totalCount === 0 && !areFiltersActive) return null;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($1ddcb1967139eb90$var$BodyStyled, {
        children: [
            totalCount === 0 ? 'No' : "Showing ".concat($1ddcb1967139eb90$export$1051fb1821141370(totalCount)),
            ' ',
            (0, $hgNMk.pluralize)('match', totalCount, false, 'matches'),
            " for your query"
        ]
    });
};
var $1ddcb1967139eb90$export$2e2bcd8739ae039 = $1ddcb1967139eb90$var$MatchingResultLabel;

});
parcelRegister("ldS4g", function(module, exports) {

$parcel$export(module.exports, "TEST_IDS", () => $f734c095f5e61e36$export$a2b4f255152a6585);
const $f734c095f5e61e36$export$a2b4f255152a6585 = {
    MATCHING_LABEL_SKELETON: 'matching-label-skeleton'
};

});



parcelRegister("1LMe1", function(module, exports) {

$parcel$export(module.exports, "useSearchFilters", () => $149f96b8d166db97$export$22204aef785f0850);

var $5zQU9 = parcelRequire("5zQU9");

var $4RRFh = parcelRequire("4RRFh");
var $7uaHG = parcelRequire("7uaHG");

var $eUqFw = parcelRequire("eUqFw");

var $yEDmI = parcelRequire("yEDmI");

var $8rC8F = parcelRequire("8rC8F");

var $d5kuV = parcelRequire("d5kuV");
var $26ZRe = parcelRequire("26ZRe");
var $9UTpL = parcelRequire("9UTpL");

var $5kA21 = parcelRequire("5kA21");

var $cd1RW = parcelRequire("cd1RW");
function $149f96b8d166db97$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $149f96b8d166db97$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $149f96b8d166db97$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $149f96b8d166db97$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $149f96b8d166db97$export$22204aef785f0850 = function useSearchFilters() {
    let allFilterDefinitions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, $yEDmI.defaultFilterDefinitions);
    let source = arguments.length > 1 ? arguments[1] : undefined;
    // UI Filters Setup
    const { filterOptions: filterOptions, setFilterOptions: setFilterOptions, selectedOptions: selectedOptions, setSelectedOptions: setSelectedOptions, clearFilter: clearFilter, clearAllFilters: clearAllFilters, showAllFilters: showAllFilters, setShowAllFilters: setShowAllFilters, filterStatus: filterStatus, setFilterStatus: setFilterStatus } = (0, $7uaHG.useFilters)({
        defaultFilterOptions: {},
        defaultShowAllFilters: source === 'PRODUCT'
    });
    /**
   * Committed Options for filters
   * @summary
   * 1. selectedOptions: Options that are selected by the user on UI
   * 2. commitOptions: Options that are committed to the URL and fetched
   *
   * on Desktop, they both are kept in sync.
   *
   * on Mobile, selectedOptions are used for UI changes and
   * commitOptions are used and updated when 'apply' is clicked.
   */ const { commitOptions: commitOptions, setCommitOptions: setCommitOptions } = (0, $d5kuV.useCommitOptions)(filterOptions, setSelectedOptions, setShowAllFilters);
    /**
   * Sorting Options
   * @summary
   * 1. commitSortKey: Sort key that are committed to the URL and applied
   * 1. selectedMobileSortOption: Sort Option used only in Mobile dialog that is selected by the user
   *
   * on Desktop, only commitSortKey is used.
   *
   * on Mobile, selectedMobileSortOption is used for UI changes and
   * commitSortKey is used and updated when 'apply' is clicked.
   */ const { commitSortKey: commitSortKey, setCommitSortKey: setCommitSortKey, onCommitSortOptionSelect: onCommitSortOptionSelect, selectedMobileSortOption: selectedMobileSortOption, setSelectedMobileSortOption: setSelectedMobileSortOption } = (0, $9UTpL.useSortFilter)();
    const { handleFilterErrorStateAnalytics: handleFilterErrorStateAnalytics, handleFilterSelectionAnalytics: handleFilterSelectionAnalytics, handleClearSelectionAnalytics: handleClearSelectionAnalytics, handleClearAllFiltersAnalytics: handleClearAllFiltersAnalytics, handleApplyFiltersClickAnalytics: handleApplyFiltersClickAnalytics } = (0, $5kA21.useSearchPageAnalytics)();
    // Functions to handle changes in URL params
    const { setQueryParams: setQueryParams, clearFilterFromQueryParam: clearFilterFromQueryParam } = (0, $cd1RW.useSyncQueryParamsWithFilters)({
        filterOptions: filterOptions
    });
    // ----------------------------------------------------------------------------------------
    // Fetching Filter Options from backend Section
    const [isFiltersFetchPending, setIsFiltersFetchPending] = (0, $eUqFw.useState)(true);
    // Fetching the filter options and status from DLA
    const { currentFilterOptions: currentFilterOptions, currentFilterState: currentFilterState } = (0, $26ZRe.useFetchFilters)(allFilterDefinitions, setIsFiltersFetchPending);
    // Updating the filter status and options when they are loaded from DLA
    (0, $eUqFw.useEffect)(()=>{
        setFilterStatus(currentFilterState);
        setFilterOptions(currentFilterOptions);
    }, [
        setFilterStatus,
        setFilterOptions,
        currentFilterState,
        currentFilterOptions
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // HANDLE ANALYTICS FOR FILTER OPTIONS ERROR
        if (!isFiltersFetchPending) handleFilterErrorStateAnalytics({
            currentFilterState: currentFilterState
        });
    }, [
        isFiltersFetchPending
    ]);
    // ----------------------------------------------------------------------------------------
    // Callback function that handles handle changes in selected options
    const onSelectedOptionsChange = (0, $eUqFw.useCallback)((_ref)=>{
        let { filterId: filterId, options: options, location: location } = _ref;
        const newOptions = $149f96b8d166db97$var$_objectSpread($149f96b8d166db97$var$_objectSpread({}, selectedOptions), {}, {
            [filterId]: options
        });
        setSelectedOptions(newOptions);
        if (location !== 'mobile') {
            // commit to option changes on desktop
            setQueryParams(newOptions, commitSortKey);
            handleFilterSelectionAnalytics({
                filterType: filterId,
                filterValue: newOptions[filterId]
            });
        }
    }, [
        selectedOptions,
        setSelectedOptions,
        setQueryParams,
        commitSortKey
    ]);
    // to handle clearing of all filters when 'clear filters' button within filters is clicked
    const onClearAllFilters = (0, $eUqFw.useCallback)((_ref2)=>{
        let { location: location } = _ref2;
        clearAllFilters();
        if (location === 'desktop') {
            // not clearing sort key as it is not part of filters on desktop
            setQueryParams({}, commitSortKey);
            handleClearAllFiltersAnalytics({
                filters: selectedOptions
            });
        }
        if (location === 'mobile') // resetting mobile sort option to default when clearing filters on mobile
        setSelectedMobileSortOption((0, $4RRFh.sortOptionsConfig)[0]);
    }, [
        clearAllFilters,
        commitSortKey,
        setQueryParams,
        setSelectedMobileSortOption
    ]);
    // to handle clearing of individual filter
    const onClearFilter = (0, $eUqFw.useCallback)((id)=>{
        clearFilter(id);
        clearFilterFromQueryParam(id);
        handleClearSelectionAnalytics({
            filterType: id
        });
    }, [
        clearFilter,
        clearFilterFromQueryParam
    ]);
    // Function to handle closing of mobile dialog
    const onCloseMobileDialog = (0, $eUqFw.useCallback)(()=>{
        // reset selected options to committed options
        setSelectedOptions(commitOptions);
        setSelectedMobileSortOption((0, $8rC8F.getSortFilter)(commitSortKey) || selectedMobileSortOption);
    }, [
        commitOptions,
        commitSortKey,
        selectedMobileSortOption,
        setSelectedMobileSortOption,
        setSelectedOptions
    ]);
    // to handle applying of filters in mobile dialog
    const onApplyFilters = (0, $eUqFw.useCallback)(()=>{
        setCommitSortKey(selectedMobileSortOption.value);
        setQueryParams(selectedOptions, selectedMobileSortOption.value);
        const filters = $149f96b8d166db97$var$_objectSpread({
            sort: selectedMobileSortOption.label
        }, selectedOptions !== null && selectedOptions !== void 0 ? selectedOptions : {});
        handleApplyFiltersClickAnalytics({
            filters: filters
        });
    }, [
        setCommitSortKey,
        selectedMobileSortOption.value,
        setQueryParams,
        selectedOptions
    ]);
    // Function to handle changes in selected sort option
    const onSelectedSortOptionChange = (0, $eUqFw.useCallback)((_ref3)=>{
        let { option: option } = _ref3;
        return setSelectedMobileSortOption(option);
    }, [
        setSelectedMobileSortOption
    ]);
    // ----------------------------------------------------------------------------------------
    // Function to handle clearing of filters when no hits are found and 'clear filters' button is clicked on page level
    const handleClearFilters = (0, $eUqFw.useCallback)(()=>{
        clearAllFilters();
        setSelectedMobileSortOption((0, $4RRFh.sortOptionsConfig)[0]);
        setQueryParams({});
    }, [
        clearAllFilters,
        setSelectedMobileSortOption,
        setQueryParams
    ]);
    return {
        allFilterDefinitions: allFilterDefinitions,
        filterOptions: filterOptions,
        sortOptions: (0, $4RRFh.sortOptionsConfig),
        selectedOptions: selectedOptions,
        commitOptions: commitOptions,
        commitSortKey: commitSortKey,
        selectedMobileSortOption: selectedMobileSortOption,
        isFiltersFetchPending: isFiltersFetchPending,
        filterStatus: filterStatus,
        showAllFilters: showAllFilters,
        onSelectedOptionsChange: onSelectedOptionsChange,
        onClearFilter: onClearFilter,
        onClearAllFilters: onClearAllFilters,
        onApplyFilters: onApplyFilters,
        onSelectedSortOptionChange: onSelectedSortOptionChange,
        onCloseMobileDialog: onCloseMobileDialog,
        onCommitSortOptionSelect: onCommitSortOptionSelect,
        handleClearFilters: handleClearFilters,
        setShowAllFilters: setShowAllFilters,
        setCommitOptions: setCommitOptions
    };
};

});
parcelRegister("7uaHG", function(module, exports) {

$parcel$export(module.exports, "useFilters", () => $5733a345f4f68125$export$973ca22476b0e05f);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");
function $5733a345f4f68125$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5733a345f4f68125$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5733a345f4f68125$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5733a345f4f68125$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5733a345f4f68125$export$973ca22476b0e05f = (_ref)=>{
    let { defaultFilterOptions: defaultFilterOptions, defaultSelectedOptions: defaultSelectedOptions = {}, defaultShowAllFilters: defaultShowAllFilters = false, defaultFilterStatus: defaultFilterStatus = {} } = _ref;
    const [filterOptions, setFilterOptions] = (0, $eUqFw.useState)(defaultFilterOptions);
    const [selectedOptions, setSelectedOptions] = (0, $eUqFw.useState)(defaultSelectedOptions);
    const [filterStatus, setFilterStatus] = (0, $eUqFw.useState)(defaultFilterStatus);
    const [showAllFilters, setShowAllFilters] = (0, $eUqFw.useState)(defaultShowAllFilters);
    const clearFilter = (0, $eUqFw.useCallback)((id)=>{
        setSelectedOptions($5733a345f4f68125$var$_objectSpread($5733a345f4f68125$var$_objectSpread({}, selectedOptions), {}, {
            [id]: []
        }));
    }, [
        selectedOptions
    ]);
    const clearAllFilters = (0, $eUqFw.useCallback)(()=>{
        setSelectedOptions({});
    }, []);
    return {
        filterOptions: filterOptions,
        setFilterOptions: setFilterOptions,
        selectedOptions: selectedOptions,
        setSelectedOptions: setSelectedOptions,
        showAllFilters: showAllFilters,
        setShowAllFilters: setShowAllFilters,
        clearFilter: clearFilter,
        clearAllFilters: clearAllFilters,
        filterStatus: filterStatus,
        setFilterStatus: setFilterStatus
    };
};

});

parcelRegister("yEDmI", function(module, exports) {

$parcel$export(module.exports, "defaultFilterDefinitions", () => $0682b2243da30dfe$export$58952f99934fc4a5);
const $0682b2243da30dfe$export$58952f99934fc4a5 = [
    {
        filterId: 'product',
        label: 'Product',
        isMulti: false,
        isSearchable: false,
        hiddenByDefault: false,
        hasClearSelectionButton: true,
        groupSelectedItems: false
    },
    {
        filterId: 'hosting',
        label: 'Hosting',
        isMulti: false,
        isSearchable: false,
        hiddenByDefault: false,
        hasClearSelectionButton: true,
        groupSelectedItems: false
    },
    {
        filterId: 'price',
        label: 'Pricing',
        isMulti: true,
        isSearchable: false,
        hiddenByDefault: false,
        hasClearSelectionButton: true,
        groupSelectedItems: true
    },
    {
        filterId: 'trustSignals',
        label: 'Trust signals',
        isMulti: true,
        isSearchable: false,
        hiddenByDefault: false,
        hasClearSelectionButton: true,
        groupSelectedItems: true
    },
    {
        filterId: 'categories',
        label: 'Categories',
        isMulti: false,
        isSearchable: true,
        hiddenByDefault: true,
        hasClearSelectionButton: true,
        groupSelectedItems: false
    },
    {
        filterId: 'useCases',
        label: 'Use cases',
        isMulti: true,
        isSearchable: true,
        hiddenByDefault: true,
        hasClearSelectionButton: true,
        groupSelectedItems: true
    },
    {
        filterId: 'other',
        label: 'More filters',
        isMulti: true,
        isSearchable: false,
        hiddenByDefault: true,
        hasClearSelectionButton: true,
        groupSelectedItems: true
    }
];

});

parcelRegister("8rC8F", function(module, exports) {

$parcel$export(module.exports, "getSelectedFiltersUrl", () => $625e6de5803c45eb$export$a1996884e04fb07b);
$parcel$export(module.exports, "getFilterOptionsFromUrl", () => $625e6de5803c45eb$export$91e76eae2b2235ba);
$parcel$export(module.exports, "removeQueryParam", () => $625e6de5803c45eb$export$e1ea1fbf111a14fe);
$parcel$export(module.exports, "getSortFilter", () => $625e6de5803c45eb$export$50632048923da4c1);

var $4RRFh = parcelRequire("4RRFh");
function $625e6de5803c45eb$var$convertQueryParamsToSelectedOptions(queryString) {
    const selectedOptions = {};
    const queryParams = new URLSearchParams(queryString);
    for (const [key, value] of queryParams)if (selectedOptions[key]) selectedOptions[key].push(value.toLowerCase());
    else selectedOptions[key] = [
        value.toLowerCase()
    ];
    return selectedOptions;
}
function $625e6de5803c45eb$export$a1996884e04fb07b(filterOptions, selectedOptions, search) {
    const selectedQueryParams = {};
    for(const key in selectedOptions)if (selectedOptions[key]) selectedQueryParams[key] = selectedOptions[key].map((option)=>option.id);
    const existingParams = new URLSearchParams(search);
    Object.keys(filterOptions).forEach((filterId)=>{
        existingParams.delete(filterId);
        if (filterId in selectedQueryParams) selectedQueryParams[filterId].forEach((value)=>{
            existingParams.append(filterId, value);
        });
    });
    return existingParams.toString();
}
function $625e6de5803c45eb$export$91e76eae2b2235ba(_ref) {
    let { filterOptions: filterOptions, search: search } = _ref;
    const selectedQueryFilters = $625e6de5803c45eb$var$convertQueryParamsToSelectedOptions(search);
    const selectedOptions = {};
    for(const key in selectedQueryFilters)if (Object.hasOwnProperty.call(filterOptions, key)) selectedOptions[key] = filterOptions[key].filter((option)=>selectedQueryFilters[key].includes(option.id.toLowerCase()));
    return selectedOptions;
}
function $625e6de5803c45eb$export$e1ea1fbf111a14fe(existingQueryString, key) {
    const existingParams = new URLSearchParams(existingQueryString);
    existingParams.delete(key);
    return existingParams.toString();
}
const $625e6de5803c45eb$export$50632048923da4c1 = (selectedSortKey)=>{
    return (0, $4RRFh.sortOptionsConfig).find((option)=>option.value === selectedSortKey);
};

});

parcelRegister("d5kuV", function(module, exports) {

$parcel$export(module.exports, "useCommitOptions", () => $986ba46aa927067d$export$149db4e89e8efea6);

var $dM9ZW = parcelRequire("dM9ZW");

var $eUqFw = parcelRequire("eUqFw");

var $yEDmI = parcelRequire("yEDmI");

var $8rC8F = parcelRequire("8rC8F");
const $986ba46aa927067d$export$149db4e89e8efea6 = (filterOptions, setSelectedOptions, setShowAllFilters)=>{
    const { search: search } = (0, $dM9ZW.useLocation)();
    const [commitOptions, setCommitOptions] = (0, $eUqFw.useState)({});
    (0, $eUqFw.useEffect)(()=>{
        const selectedOptionsFromURL = (0, $8rC8F.getFilterOptionsFromUrl)({
            filterOptions: filterOptions,
            search: search
        });
        if (Object.keys(selectedOptionsFromURL).length > 0) {
            // check if the filter id is hidden by default in defaultFilterDefinitions
            const hiddenFilterIds = (0, $yEDmI.defaultFilterDefinitions).map((filterConfig)=>filterConfig.hiddenByDefault ? filterConfig.filterId : null);
            const selectedFilterIds = Object.keys(selectedOptionsFromURL);
            // if any of filterId in selectedFilterIds is present in hiddenFilterIds, then show all filters
            const toShowAllFilters = selectedFilterIds.some((filterId)=>hiddenFilterIds.includes(filterId));
            // if previous state is already true, then don't change it
            setShowAllFilters((prevState)=>prevState || toShowAllFilters);
        }
        setSelectedOptions(selectedOptionsFromURL);
        setCommitOptions(selectedOptionsFromURL);
    }, [
        filterOptions,
        search,
        setSelectedOptions,
        setShowAllFilters
    ]);
    return {
        commitOptions: commitOptions,
        setCommitOptions: setCommitOptions
    };
};

});

parcelRegister("26ZRe", function(module, exports) {

$parcel$export(module.exports, "useFetchFilters", () => $189c1fe939723101$export$a8b4d2977603745a);

var $5zQU9 = parcelRequire("5zQU9");

var $blcHM = parcelRequire("blcHM");

var $et3oR = parcelRequire("et3oR");

var $7lvGB = parcelRequire("7lvGB");

var $eUqFw = parcelRequire("eUqFw");

var $98ub3 = parcelRequire("98ub3");
function $189c1fe939723101$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $189c1fe939723101$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $189c1fe939723101$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $189c1fe939723101$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $189c1fe939723101$export$a8b4d2977603745a = (allFilterDefinitions, setIsFiltersFetchPending)=>{
    const { loading: loading, error: error, data: filterOptionsData } = (0, $blcHM.useQuery)((0, $et3oR.GetMarketplaceFilters), {
        variables: {
            filterIds: allFilterDefinitions.map((filter)=>filter.filterId)
        },
        onCompleted: ()=>{
            setIsFiltersFetchPending(false);
        },
        onError: ()=>{
            setIsFiltersFetchPending(false);
        }
    });
    const getFilterById = (filters, filterId)=>filters.find((filter)=>filter.filterId === filterId);
    // Generating the currentFilterState using useMemo
    // this state will be used to check the status of each filter
    const currentFilterState = (0, $eUqFw.useMemo)(()=>allFilterDefinitions.reduce((acc, item)=>{
            var _getFilterById;
            if (loading) {
                (0, $98ub3.ViewFilters).start();
                acc[item.filterId] = 'loading';
            } else if (error) {
                (0, $98ub3.ViewFilters).failed(error);
                acc[item.filterId] = 'error';
            } else if (filterOptionsData !== null && filterOptionsData !== void 0 && filterOptionsData.marketplaceFilters && ((_getFilterById = getFilterById(filterOptionsData.marketplaceFilters, item.filterId)) === null || _getFilterById === void 0 ? void 0 : _getFilterById.__typename) === 'MarketplaceSearchFilterError') {
                (0, $98ub3.ViewFilters).failed(new Error('No Filter Option Data'));
                acc[item.filterId] = 'error';
            } else {
                (0, $98ub3.ViewFilters).succeeded();
                acc[item.filterId] = 'default';
            }
            return acc;
        }, {}), [
        allFilterDefinitions,
        loading,
        error,
        filterOptionsData
    ]);
    const currentFilterOptions = (0, $eUqFw.useMemo)(()=>{
        if (!(filterOptionsData !== null && filterOptionsData !== void 0 && filterOptionsData.marketplaceFilters)) return {};
        const filters = filterOptionsData.marketplaceFilters;
        const options = filters.reduce((acc, filter)=>{
            return $189c1fe939723101$var$_objectSpread($189c1fe939723101$var$_objectSpread({}, acc), {}, {
                [filter.filterId]: filter.__typename === 'MarketplaceFilterOptions' ? filter.options : []
            });
        }, {});
        return (0, $7lvGB.removeAttributes)(options, [
            '__typename'
        ]);
    }, [
        filterOptionsData
    ]);
    return {
        currentFilterOptions: currentFilterOptions,
        currentFilterState: currentFilterState
    };
};

});
parcelRegister("98ub3", function(module, exports) {

$parcel$export(module.exports, "viewSearchResultsTask", () => $6a6c4501cd425234$export$1407b44f3081ded8);
$parcel$export(module.exports, "ViewSearchResult", () => $6a6c4501cd425234$export$4454467577ecb5fc);
$parcel$export(module.exports, "ViewFilters", () => $6a6c4501cd425234$export$daa9a1fa37eea074);
$parcel$export(module.exports, "SearchResultPageTask", () => $6a6c4501cd425234$export$70bfece62390abef);

var $fUOHe = parcelRequire("fUOHe");
const $6a6c4501cd425234$export$1407b44f3081ded8 = 'view-search-results';
const $6a6c4501cd425234$export$4454467577ecb5fc = (0, $fUOHe.default).createGenericTask($6a6c4501cd425234$export$1407b44f3081ded8);
const $6a6c4501cd425234$export$daa9a1fa37eea074 = (0, $fUOHe.default).createGenericTask('view-filters');
const $6a6c4501cd425234$export$70bfece62390abef = (0, $fUOHe.default).createPageViewTask('view-search-results-page').dependsOn([
    $6a6c4501cd425234$export$4454467577ecb5fc,
    $6a6c4501cd425234$export$daa9a1fa37eea074
]);

});


parcelRegister("9UTpL", function(module, exports) {

$parcel$export(module.exports, "useSortFilter", () => $7384543779f57d6b$export$c26f6af8d3b7301e);

var $4RRFh = parcelRequire("4RRFh");

var $eUqFw = parcelRequire("eUqFw");

var $8rC8F = parcelRequire("8rC8F");

var $1xupX = parcelRequire("1xupX");
const $7384543779f57d6b$export$c26f6af8d3b7301e = ()=>{
    const [selectedMobileSortOption, setSelectedMobileSortOption] = (0, $eUqFw.useState)((0, $4RRFh.sortOptionsConfig)[0]);
    const { selectedSortKey: commitSortKey, onSortOptionSelect: onCommitSortOptionSelect, setSelectedSortKey: setCommitSortKey } = (0, $1xupX.useSort)();
    // set selected sort option when it is loaded from URL params
    // only need to run twice for initial load (first initial render = "", second render selectedSortKey is populated from URL params)
    const runCount = (0, $eUqFw.useRef)(0);
    (0, $eUqFw.useEffect)(()=>{
        if (commitSortKey && runCount.current < 1) {
            setSelectedMobileSortOption((0, $8rC8F.getSortFilter)(commitSortKey) || selectedMobileSortOption);
            runCount.current++;
        }
    }, [
        commitSortKey,
        selectedMobileSortOption
    ]);
    return {
        commitSortKey: commitSortKey,
        setCommitSortKey: setCommitSortKey,
        onCommitSortOptionSelect: onCommitSortOptionSelect,
        selectedMobileSortOption: selectedMobileSortOption,
        setSelectedMobileSortOption: setSelectedMobileSortOption
    };
};

});
parcelRegister("1xupX", function(module, exports) {

$parcel$export(module.exports, "sortQueryParamKey", () => $11f077d0405ac312$export$857ee710b80d4be4);
$parcel$export(module.exports, "useSort", () => $11f077d0405ac312$export$6292515ceca0b297);

var $dM9ZW = parcelRequire("dM9ZW");

var $eUqFw = parcelRequire("eUqFw");
const $11f077d0405ac312$export$857ee710b80d4be4 = 'sort';
const $11f077d0405ac312$export$6292515ceca0b297 = ()=>{
    const history = (0, $dM9ZW.useHistory)();
    const { pathname: pathname, search: search } = (0, $dM9ZW.useLocation)();
    const [selectedSortKey, setSelectedSortKey] = (0, $eUqFw.useState)('');
    const updateQueryParam = (0, $eUqFw.useCallback)((sortKey)=>{
        const queryParams = new URLSearchParams(search);
        queryParams.set($11f077d0405ac312$export$857ee710b80d4be4, sortKey);
        history === null || history === void 0 || history.push("".concat(pathname, "?").concat(queryParams));
    }, [
        history,
        pathname,
        search
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const queryParams = new URLSearchParams(search);
        const sortKey = queryParams.get($11f077d0405ac312$export$857ee710b80d4be4);
        if (sortKey) setSelectedSortKey(sortKey);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        const queryParams = new URLSearchParams(search);
        const sortKey = queryParams.get($11f077d0405ac312$export$857ee710b80d4be4);
        if (sortKey !== selectedSortKey) setSelectedSortKey(sortKey || '');
    }, [
        search
    ]);
    const onSortOptionSelect = (0, $eUqFw.useCallback)((sortOption)=>{
        updateQueryParam(sortOption.value);
        setSelectedSortKey(sortOption.value);
    }, [
        updateQueryParam
    ]);
    return {
        selectedSortKey: selectedSortKey,
        onSortOptionSelect: onSortOptionSelect,
        setSelectedSortKey: setSelectedSortKey
    };
};

});


parcelRegister("cd1RW", function(module, exports) {

$parcel$export(module.exports, "useSyncQueryParamsWithFilters", () => $8e3826141a367595$export$d5cc163e92756aee);

var $dM9ZW = parcelRequire("dM9ZW");

var $eUqFw = parcelRequire("eUqFw");

var $8rC8F = parcelRequire("8rC8F");

var $1xupX = parcelRequire("1xupX");
const $8e3826141a367595$export$d5cc163e92756aee = (_ref)=>{
    let { filterOptions: filterOptions } = _ref;
    const history = (0, $dM9ZW.useHistory)();
    const { pathname: pathname, search: search } = (0, $dM9ZW.useLocation)();
    const setQueryParams = (0, $eUqFw.useCallback)(function(newOptions) {
        let sortKey = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        const mergedQueryString = (0, $8rC8F.getSelectedFiltersUrl)(filterOptions, newOptions, search || '');
        const mergedParams = new URLSearchParams(mergedQueryString);
        if (sortKey) mergedParams.set((0, $1xupX.sortQueryParamKey), sortKey);
        history === null || history === void 0 || history.push("".concat(pathname, "?").concat(mergedParams));
    }, [
        filterOptions,
        history,
        pathname,
        search
    ]);
    const clearFilterFromQueryParam = (0, $eUqFw.useCallback)((filterId)=>{
        const newSearch = (0, $8rC8F.removeQueryParam)(search || '', filterId);
        history === null || history === void 0 || history.push("".concat(pathname, "?").concat(newSearch));
    }, [
        history,
        search,
        pathname
    ]);
    return {
        setQueryParams: setQueryParams,
        clearFilterFromQueryParam: clearFilterFromQueryParam
    };
};

});


parcelRegister("25eiI", function(module, exports) {

$parcel$export(module.exports, "useSearchPageTelemetry", () => $1847243fbbacaf55$export$32bfd089003e2d92);

var $fUOHe = parcelRequire("fUOHe");

var $eUqFw = parcelRequire("eUqFw");

var $98ub3 = parcelRequire("98ub3");
const $1847243fbbacaf55$export$32bfd089003e2d92 = (_ref)=>{
    let { gridProps: gridProps, searchQuery: searchQuery, commitOptions: commitOptions, commitSortKey: commitSortKey } = _ref;
    (0, $eUqFw.useEffect)(()=>{
        (0, $98ub3.SearchResultPageTask).start();
    }, []);
    (0, $eUqFw.useEffect)(()=>{
        (0, $98ub3.ViewSearchResult).start();
    }, [
        searchQuery,
        commitOptions,
        commitSortKey
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (gridProps.fetchMoreError || gridProps.initialFetchError) {
            const err = gridProps.initialFetchError || gridProps.fetchMoreError || new Error('No Search Result Data');
            (0, $fUOHe.default).setUFOInteractionError({
                name: (0, $98ub3.viewSearchResultsTask),
                errorMessage: err
            });
            (0, $98ub3.ViewSearchResult).failed(err);
        } else if (gridProps.rawData) (0, $98ub3.ViewSearchResult).succeeded();
    }, [
        gridProps.fetchMoreError,
        gridProps.initialFetchError,
        gridProps.rawData
    ]);
};

});

parcelRegister("9FaXf", function(module, exports) {

$parcel$export(module.exports, "useSearchResults", () => $709070bd3d40c949$export$deb5cc6ef1318024);

var $5zQU9 = parcelRequire("5zQU9");

var $iADnD = parcelRequire("iADnD");

var $9l6Pq = parcelRequire("9l6Pq");

var $8RqyI = parcelRequire("8RqyI");

var $eUqFw = parcelRequire("eUqFw");

var $9AuiZ = parcelRequire("9AuiZ");

var $5kA21 = parcelRequire("5kA21");
function $709070bd3d40c949$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $709070bd3d40c949$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $709070bd3d40c949$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $709070bd3d40c949$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $709070bd3d40c949$export$deb5cc6ef1318024 = (searchQuery, commitSelectedOptions, skip, sortKey, showPageError, additionalFilters)=>{
    const { handleTilesRenderedAnalytics: handleTilesRenderedAnalytics, handleErrorStateAnalytics: handleErrorStateAnalytics } = (0, $5kA21.useSearchPageAnalytics)();
    const { enableNlpSearch: enableNlpSearch } = (0, $9l6Pq.useStatsig)();
    const enableNLPSearchFlag = enableNlpSearch({
        fireExperimentExposure: true
    });
    // For aether we need to make request to search v2 index, hence the hardcoding 'true' is done here.
    const gridProps = (0, $iADnD.usePaginatedAppGrid)({
        query: (0, $8RqyI.GetMarketplaceSearch),
        queryOptions: {
            variables: {
                query: searchQuery,
                filters: commitSelectedOptions,
                sort: sortKey,
                after: 0,
                first: (0, $iADnD.PAGINATED_APP_GRID_CONFIG).initialFetchCount,
                additionalFilters: additionalFilters,
                enableNLPSearch: enableNLPSearchFlag
            },
            skip: skip
        },
        parseResponse: (data)=>{
            var _data$marketplaceSear, _data$marketplaceSear2, _data$marketplaceSear3, _data$marketplaceSear4;
            return {
                appList: (data === null || data === void 0 ? void 0 : (_data$marketplaceSear = data.marketplaceSearch) === null || _data$marketplaceSear === void 0 ? void 0 : (_data$marketplaceSear2 = _data$marketplaceSear.edges) === null || _data$marketplaceSear2 === void 0 ? void 0 : _data$marketplaceSear2.map((edge)=>edge.node)) || [],
                hasNextPage: Boolean(data === null || data === void 0 ? void 0 : (_data$marketplaceSear3 = data.marketplaceSearch) === null || _data$marketplaceSear3 === void 0 ? void 0 : _data$marketplaceSear3.pageInfo.hasNextPage),
                totalCount: (data === null || data === void 0 ? void 0 : (_data$marketplaceSear4 = data.marketplaceSearch) === null || _data$marketplaceSear4 === void 0 ? void 0 : _data$marketplaceSear4.pageInfo.totalCount) || 0
            };
        }
    });
    const { appList: appList, isLoading: isLoading, isLoadingMore: isLoadingMore, initialFetchError: initialFetchError, fetchMoreError: fetchMoreError, rawData: rawData } = gridProps;
    const analyticsFilters = $709070bd3d40c949$var$_objectSpread($709070bd3d40c949$var$_objectSpread($709070bd3d40c949$var$_objectSpread({}, searchQuery ? {
        query: searchQuery
    } : {}), sortKey ? {
        sort: sortKey
    } : {}), commitSelectedOptions !== null && commitSelectedOptions !== void 0 ? commitSelectedOptions : {});
    (0, $eUqFw.useEffect)(()=>{
        // HANDLE ANALYTICS
        if (rawData && !showPageError && !isLoading && !isLoadingMore && !initialFetchError && !fetchMoreError) handleTilesRenderedAnalytics({
            filters: analyticsFilters,
            count: appList.length
        });
    }, [
        rawData,
        isLoadingMore
    ]);
    (0, $eUqFw.useEffect)(()=>{
        // HANDLE ANALYTICS
        if (!showPageError && (initialFetchError || fetchMoreError)) handleErrorStateAnalytics({
            actionSubjectId: 'AppTileGridErrorRendered',
            errorType: initialFetchError ? (0, $9AuiZ.ANALYTICS).INITIAL : (0, $9AuiZ.ANALYTICS).LOAD_MORE
        });
    }, [
        initialFetchError,
        fetchMoreError
    ]);
    return {
        gridProps: gridProps,
        analyticsFilters: analyticsFilters
    };
};

});

parcelRegister("k5bWu", function(module, exports) {

$parcel$export(module.exports, "getOverridesByHostProduct", () => $e9ed89cd474d6754$export$4601eb10b6cea904);

var $yEDmI = parcelRequire("yEDmI");
function $e9ed89cd474d6754$export$4601eb10b6cea904(_ref) {
    let { hostProductId: hostProductId } = _ref;
    if (!hostProductId) return {
        filterDefinitions: (0, $yEDmI.defaultFilterDefinitions),
        additionalFilters: {}
    };
    return {
        // for EMCEE we are not showing hosting and product filters
        filterDefinitions: (0, $yEDmI.defaultFilterDefinitions).filter((filter)=>filter.filterId !== 'hosting' && filter.filterId !== 'product'),
        // for EMCEE we are filtering only cloud products for the host product
        additionalFilters: {
            product: hostProductId,
            hosting: 'cloud'
        }
    };
}

});

parcelRegister("g5bjF", function(module, exports) {

$parcel$export(module.exports, "resolveMetaDescription", () => $bb55e4272e197c26$export$53652442cfea8829);

var $8rC8F = parcelRequire("8rC8F");
const $bb55e4272e197c26$export$53652442cfea8829 = (productLabel, sortOption)=>{
    var _getSortFilter;
    const products = productLabel ? "Atlassian ".concat(productLabel) : 'Jira, Confluence, Bitbucket & other Atlassian products';
    const currentSort = (_getSortFilter = (0, $8rC8F.getSortFilter)(sortOption)) === null || _getSortFilter === void 0 ? void 0 : _getSortFilter.label;
    const filterPrefix = currentSort ? "Find the ".concat(currentSort) : 'Find';
    return "".concat(filterPrefix, " apps, add-ons, plugins & integrations for ").concat(products, ". Free 30-day trial for all apps.");
};

});


const $583fdbfa91c3ce4b$export$d53414cc8d220f0b = 'discover';
const $583fdbfa91c3ce4b$export$22afc385744fe064 = 'search';

parcelRegister("i0SXo", function(module, exports) {

$parcel$export(module.exports, "default", () => $d1d2db681866636c$export$2e2bcd8739ae039);

var $3RTYU = parcelRequire("3RTYU");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
const $d1d2db681866636c$var$formatInstalledAppsToMap = (locallyInstalledApps, globallyInstalledApps)=>{
    const installedApps = (0, $bWAru.Option).map2(locallyInstalledApps.result.flatMap((a)=>a.toOption()), globallyInstalledApps.result.flatMap((a)=>a.toOption()), (locallyInstalledAppsResult, globallyInstalledAppsResult)=>locallyInstalledAppsResult.installedApps.concat(globallyInstalledAppsResult.installedApps)).getOrElse((0, $g5DHJ.List)());
    // TODO https://ecosystem.atlassian.net/browse/FMI-550
    return (0, $3RTYU).listToMap(installedApps, (app)=>app.details.key ? app.details.key : app.details.ecosystemCloudAppId || '');
};
var $d1d2db681866636c$export$2e2bcd8739ae039 = $d1d2db681866636c$var$formatInstalledAppsToMap;

});

parcelRegister("dQaud", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1384414ac51d4a2$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");

var $8bwkw = parcelRequire("8bwkw");

var $6BOFf = parcelRequire("6BOFf");

var $jC5dB = parcelRequire("jC5dB");

var $i0SXo = parcelRequire("i0SXo");

var $jiykS = parcelRequire("jiykS");

var $fQHYP = parcelRequire("fQHYP");

var $lHkHI = parcelRequire("lHkHI");
const $a1384414ac51d4a2$var$_excluded = [
    "hostPricing",
    "scopesLookup",
    "children"
];
function $a1384414ac51d4a2$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a1384414ac51d4a2$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a1384414ac51d4a2$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a1384414ac51d4a2$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a1384414ac51d4a2$var$mapStateToProps = (state, ownProps)=>{
    const installedAppsMap = (0, $i0SXo.default)(state.installedApps.locallyInstalledApps, state.installedApps.globallyInstalledApps);
    const { appKey: appKey } = ownProps;
    return {
        installedApp: appKey && installedAppsMap.has(appKey) ? installedAppsMap.get(appKey) : undefined,
        hostPricing: state.hostPricing.hostPricing,
        scopesLookup: state.scopes.scopesLookup
    };
};
const $a1384414ac51d4a2$var$mapDispatchToProps = (dispatch, ownProps)=>({
        openInstallDialog: (_ref)=>{
            let { installableAppId: installableAppId, relayState: relayState, context: context } = _ref;
            return dispatch((0, $6BOFf.doInitiateInstallModeForIdentifier)({
                mpacBaseUrl: ownProps.mpacBaseUrl,
                installableAppId: installableAppId,
                relayState: relayState,
                context: context
            }));
        },
        addFlag: (flag)=>{
            dispatch((0, $8bwkw.addFlag)({
                flag: (0, $jC5dB.makeEmceeFlag)(flag)
            }));
        },
        removeFlag: (key)=>dispatch((0, $8bwkw.removeFlag)(key))
    });
function $a1384414ac51d4a2$var$AppInstallCacheProvider(_ref2) {
    let { hostPricing: hostPricing, scopesLookup: scopesLookup, children: children } = _ref2, props = (0, $bwPfh.default)(_ref2, $a1384414ac51d4a2$var$_excluded);
    const [appInstallCache, setAppInstallCache] = (0, $eUqFw.useState)({
        pending: true,
        error: null,
        result: null
    });
    (0, $eUqFw.useEffect)(()=>{
        if (hostPricing.pending || scopesLookup.isEmpty()) return;
        const cacheContent = {
            pending: false,
            result: null,
            error: null
        };
        if (hostPricing.error || scopesLookup.value.isLeft()) cacheContent.error = $a1384414ac51d4a2$var$_objectSpread($a1384414ac51d4a2$var$_objectSpread({}, hostPricing.error && {
            hostLicense: hostPricing.error
        }), scopesLookup.value.isLeft() && {
            scopesLookup: scopesLookup
        });
        else cacheContent.result = {
            hostLicense: hostPricing.result,
            scopesLookup: scopesLookup
        };
        setAppInstallCache(cacheContent);
    }, [
        hostPricing,
        scopesLookup
    ]);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jiykS.EmceeAppInstallCache).Provider, {
        value: appInstallCache,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fQHYP.default), $a1384414ac51d4a2$var$_objectSpread({
            hostPricing: hostPricing
        }, props))
    });
}
var $a1384414ac51d4a2$export$2e2bcd8739ae039 = (0, $94zHK.default)($a1384414ac51d4a2$var$mapStateToProps, $a1384414ac51d4a2$var$mapDispatchToProps)($a1384414ac51d4a2$var$AppInstallCacheProvider);

});
parcelRegister("jiykS", function(module, exports) {

$parcel$export(module.exports, "EmceeAppInstallCache", () => $e0ca5521a3c2dded$export$965f8f8a05e2bd95);
$parcel$export(module.exports, "useEmceeAppInstallCache", () => $e0ca5521a3c2dded$export$92706f754038ea7b);

var $eUqFw = parcelRequire("eUqFw");
const $e0ca5521a3c2dded$export$965f8f8a05e2bd95 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
const $e0ca5521a3c2dded$export$92706f754038ea7b = ()=>{
    const cache = (0, $eUqFw.useContext)($e0ca5521a3c2dded$export$965f8f8a05e2bd95);
    if (cache && Object.keys(cache).length) return cache;
    return null;
};

});

parcelRegister("fQHYP", function(module, exports) {

$parcel$export(module.exports, "default", () => $b89dd3e3c2981504$export$2e2bcd8739ae039);
/* DiscoverAppDetails.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ddHQW = parcelRequire("ddHQW");

var $gykb8 = parcelRequire("gykb8");
var $kU8RF = parcelRequire("kU8RF");

var $gaiog = parcelRequire("gaiog");
var $f2QOW = parcelRequire("f2QOW");
var $9osuT = parcelRequire("9osuT");

var $4z8FQ = parcelRequire("4z8FQ");
var $ar8rL = parcelRequire("ar8rL");
var $c1ZLO = parcelRequire("c1ZLO");
var $eQxeh = parcelRequire("eQxeh");
var $9e16A = parcelRequire("9e16A");

var $inwKI = parcelRequire("inwKI");
var $9l6Pq = parcelRequire("9l6Pq");

var $eEKFN = parcelRequire("eEKFN");

var $ecc6Y = parcelRequire("ecc6Y");

var $kafab = parcelRequire("kafab");
var $cVLrH = parcelRequire("cVLrH");

var $ammkg = parcelRequire("ammkg");

var $dM9ZW = parcelRequire("dM9ZW");

var $9c9Gu = parcelRequire("9c9Gu");

var $9LXG4 = parcelRequire("9LXG4");

var $7Uh51 = parcelRequire("7Uh51");

var $55gtq = parcelRequire("55gtq");

var $3lzNh = parcelRequire("3lzNh");

var $iEgm6 = parcelRequire("iEgm6");

var $jHg79 = parcelRequire("jHg79");

var $1nC6Q = parcelRequire("1nC6Q");
var $hdXYz = parcelRequire("hdXYz");
var $5E4rM = parcelRequire("5E4rM");
var $lOrRB = parcelRequire("lOrRB");

var $kNokf = parcelRequire("kNokf");

var $7p31F = parcelRequire("7p31F");

var $jwE5W = parcelRequire("jwE5W");

var $aV0yp = parcelRequire("aV0yp");

var $euYek = parcelRequire("euYek");

var $5C3fV = parcelRequire("5C3fV");

var $j5L3j = parcelRequire("j5L3j");

var $lHkHI = parcelRequire("lHkHI");
const $b89dd3e3c2981504$var$_excluded = [
    "as",
    "style"
], $b89dd3e3c2981504$var$_excluded2 = [
    "as",
    "style"
];
function $b89dd3e3c2981504$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b89dd3e3c2981504$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b89dd3e3c2981504$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b89dd3e3c2981504$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const { usePrevious: $b89dd3e3c2981504$var$usePrevious } = (0, $9c9Gu);
const $b89dd3e3c2981504$export$7883ebfcd4d2a85d = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = (0, $gykb8.default), style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $b89dd3e3c2981504$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b89dd3e3c2981504$var$_objectSpread($b89dd3e3c2981504$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyra5zd _1e0c1ule _y3gn1h6o",
            __cmplp.className
        ])
    }));
});
const $b89dd3e3c2981504$var$NotFoundContainer = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $b89dd3e3c2981504$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b89dd3e3c2981504$var$_objectSpread($b89dd3e3c2981504$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1tkem8rl",
            __cmplp.className
        ])
    }));
});
const $b89dd3e3c2981504$export$5d2606a9a2b8350e = (_ref3)=>{
    let { showAetherAppListingPage: showAetherAppListingPage, history: history } = _ref3;
    return showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)($b89dd3e3c2981504$var$NotFoundContainer, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ecc6Y.NotFound), {})
    }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aV0yp.default), {
        history: history
    });
};
function $b89dd3e3c2981504$export$921a140a0ab7df5b(props) {
    var _props$hostPricing$re, _props$hostPricing$re2, _props$hostPricing$re3, _appListingResult$clo, _appListingResult$clo2;
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const { enableEmceeAetherExperience: enableEmceeAetherExperience, enableAetherAppListingPage: enableAetherAppListingPage } = (0, $9l6Pq.useStatsig)();
    const isAetherExp = enableEmceeAetherExperience();
    const showAetherAppListingPage = enableAetherAppListingPage();
    const { appListing: appListing } = (0, $jwE5W.default)();
    const environment = (0, $jHg79.useEnvironment)();
    const applicationConfig = (0, $iEgm6.getApplicationConfigForEnv)(environment);
    const currentUser = (0, $kNokf.useCurrentUser)();
    const appListingUser = {
        isMpacAdmin: false,
        isLoggedIn: !!currentUser,
        avatarUrl: currentUser === null || currentUser === void 0 ? void 0 : currentUser.avatarUrl,
        userId: currentUser === null || currentUser === void 0 ? void 0 : currentUser.atlassianAccountId
    };
    const { installDialogOpen: installDialogOpenInitially, requestDialogOpen: requestDialogOpenInitially } = (0, $dM9ZW.useQueryParams)();
    const history = (0, $dM9ZW.useHistory)();
    const { enableDeprecatedInstallationsGQL: enableDeprecatedInstallationsGQL, enableReactivateForgeAppFromEmcee: enableReactivateForgeAppFromEmcee, enableReactivateForgeAppFromEmceeForHAMS: enableReactivateForgeAppFromEmceeForHAMS } = (0, $inwKI.useFeatureFlags)();
    const [selectedTab, setSelectedTab] = (0, $eUqFw.useState)((0, $c1ZLO.AppListingTab).Overview);
    (0, $eUqFw.useEffect)(()=>{
        /* this should only run once on mount, and before the useAppListingByKey */ (0, $3lzNh.AppListingPageTask).start();
    }, []);
    const { data: appListingResult, loading: appListingPending } = (0, $eQxeh.useAppListingByKey)({
        appKey: props.appKey,
        location: (0, $ammkg.MarketplaceLocation).InProduct,
        showOnlyPublic: true
    });
    const algoliaConfig = (0, $jHg79.useAlgoliaConfig)();
    const appDetailsFromSearchResponse = (0, $9e16A.useGetAppDetailsFromSearch)({
        appKey: props.appKey,
        algoliaConfig: algoliaConfig
    });
    const { installationState: installationState } = (0, $5E4rM.useInstallationLock)();
    const shouldEnableReactivateForgeAppFromEmcee = enableReactivateForgeAppFromEmcee && ((_props$hostPricing$re = props.hostPricing.result) === null || _props$hostPricing$re === void 0 ? void 0 : _props$hostPricing$re.billingSystem) === (0, $cVLrH.BillingSystem).CCP || enableReactivateForgeAppFromEmceeForHAMS && ((_props$hostPricing$re2 = props.hostPricing.result) === null || _props$hostPricing$re2 === void 0 ? void 0 : _props$hostPricing$re2.billingSystem) === (0, $cVLrH.BillingSystem).HAMS;
    const hostCmtEnabled = Boolean((_props$hostPricing$re3 = props.hostPricing.result) === null || _props$hostPricing$re3 === void 0 ? void 0 : _props$hostPricing$re3.hostCmtEnabled);
    const { result: appDetailsResult, pending: appDetailsPending } = (0, $5C3fV.useMarketplaceAppDetails)({
        appKey: props.appKey,
        fetchInstalledApp: !props.installedApp,
        contextId: props.selectedContext.id,
        deploymentType: appListingResult ? (0, $j5L3j.getAppDeploymentType)(appListingResult) : undefined,
        marketplaceApp: appListingResult,
        flags: {
            enableReactivateForgeAppFromEmcee: shouldEnableReactivateForgeAppFromEmcee,
            enableDeprecatedInstallationsGQL: enableDeprecatedInstallationsGQL
        },
        hostCmtEnabled: hostCmtEnabled
    });
    const vendorSupportTicketUrl = appListingResult ? (appListingResult === null || appListingResult === void 0 ? void 0 : appListingResult.supportTicketSystemUrl) || (appListingResult === null || appListingResult === void 0 ? void 0 : appListingResult.issueTrackerUrl) : '';
    const { installerElement: installerElement, installAppByInstallableIdentifier: installAppByInstallableIdentifier } = (0, $lOrRB.useMarketplaceAppInstall)((0, $55gtq.default)(), (0, $hdXYz.getAppInstallConfigForEnv)(environment), (0, $1nC6Q.AppInstallLocation).EmbeddedMarketplaceAppListing, vendorSupportTicketUrl);
    const appVersion = appListingResult === null || appListingResult === void 0 ? void 0 : (_appListingResult$clo = appListingResult.cloudAppVersions.edges) === null || _appListingResult$clo === void 0 ? void 0 : (_appListingResult$clo2 = _appListingResult$clo[0]) === null || _appListingResult$clo2 === void 0 ? void 0 : _appListingResult$clo2.node;
    const appDeployment = appVersion === null || appVersion === void 0 ? void 0 : appVersion.deployment;
    const paymentModel = (0, $j5L3j.mapAppListingPaymentModel)(appVersion === null || appVersion === void 0 ? void 0 : appVersion.paymentModel);
    const isConnectApp = appListingResult ? (0, $j5L3j.getAppDeploymentType)(appListingResult) === (0, $kafab.AppDeployment).CONNECT : false;
    const isEcosystemCloudApp = appListingResult ? (0, $j5L3j.getAppDeploymentType)(appListingResult) === (0, $kafab.AppDeployment).ECOSYSTEM_CLOUD : false;
    const marketplaceAppLink = props.links.appDetails.expand({
        appKey: props.appKey
    });
    const hasInstallPermission = (0, $5C3fV.useInstallPermission)({
        appKey: props.appKey,
        isPermissionCheckNeeded: isEcosystemCloudApp || isConnectApp,
        installPermissionResult: appDetailsResult === null || appDetailsResult === void 0 ? void 0 : appDetailsResult.installPermission
    });
    const ecosystemCloudAppId = appDeployment === null || appDeployment === void 0 ? void 0 : appDeployment.cloudAppId;
    const installedApp = props.installedApp || (appDetailsResult === null || appDetailsResult === void 0 ? void 0 : appDetailsResult.installedApp);
    const installationInProgressAppKey = installationState.installationInProgressAppKey;
    // event handlers
    const handleTabSelect = (newTab)=>{
        var _appListingResult$par;
        setSelectedTab(newTab);
        fireAnalyticsEvent({
            eventType: (0, $gaiog.TabClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_EMCEE_APP_LISTING_TAB),
            source: (0, $7Uh51.ANALYTICS_EVENT_CONTAINER_NAV_BAR),
            attributes: $b89dd3e3c2981504$var$_objectSpread({
                label: (0, (/*@__PURE__*/$parcel$interopDefault($9LXG4)))(newTab),
                partnerId: appListingResult === null || appListingResult === void 0 ? void 0 : (_appListingResult$par = appListingResult.partner) === null || _appListingResult$par === void 0 ? void 0 : _appListingResult$par.id,
                appId: appListingResult === null || appListingResult === void 0 ? void 0 : appListingResult.appId,
                appListingTabKey: newTab
            }, analyticsContextAttributes)
        });
    };
    const openInstallDialog = ()=>{
        installAppByInstallableIdentifier((0, $j5L3j.getInstallableAddon)(appDeployment, props.appKey), {
            flags: {
                show: (flag)=>props.addFlag(flag),
                dismiss: (key)=>props.removeFlag(key)
            }
        });
    };
    const handleBreadcrumbsItemClick = (e)=>{
        e.preventDefault();
        history.push({
            pathname: appListing.getRelative({
                appKey: props.appKey
            })
        });
    };
    const analyticsContextAttributes = {
        appKey: props.appKey,
        isEcosystemCloudApp: isEcosystemCloudApp,
        paymentModel: paymentModel === (0, $ammkg.MarketplaceAppPaymentModel).Free ? 'free' : 'paid'
    };
    const handleViewMoreOnMarketplaceLinkClick = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.LinkClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_VIEW_MORE_ON_MARKETPLACE_LINK),
            source: (0, $7Uh51.ANALYTICS_EVENT_CONTAINER_EMCEE_OVERVIEW_TAB),
            attributes: $b89dd3e3c2981504$var$_objectSpread({}, analyticsContextAttributes)
        });
    };
    const getSpinnerState = ()=>{
        if (appListingPending) return true;
        if (appListingResult && appDetailsPending) return true;
        return false;
    };
    const pending = getSpinnerState();
    const previouslyPending = $b89dd3e3c2981504$var$usePrevious(pending);
    if (previouslyPending && !pending && appDetailsResult && appListingResult) props.onRendered();
    // effects
    (0, $eUqFw.useEffect)(()=>{
        if (appListingResult && installDialogOpenInitially) openInstallDialog();
    }, [
        appListingResult
    ]);
    const renderAfterHeader = ()=>{
        if (!installedApp && appDetailsResult !== null && appDetailsResult !== void 0 && appDetailsResult.cloudMigrationTrial.isEligible) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $euYek.default), {});
        return null;
    };
    if (showAetherAppListingPage && pending) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ar8rL.AppListingPageSkeleton), {
        selectedHosting: (0, $ammkg.AtlassianProductHostingType).Cloud,
        isEMCEE: true
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kU8RF.default), {
        active: pending,
        delay: 1000,
        size: 50,
        children: appDetailsResult && appListingResult ? /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $f2QOW.default), {
            attributes: analyticsContextAttributes,
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eEKFN.default), {
                    actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_DISCOVER_APP_LISTING),
                    onClick: handleBreadcrumbsItemClick,
                    href: appListing.getRelative({
                        appKey: props.appKey
                    }),
                    text: appListingResult.name,
                    children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                        children: [
                            hostCmtEnabled && isEcosystemCloudApp && hasInstallPermission && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $euYek.default), {
                                isEcosystemCloudApp: isEcosystemCloudApp
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4z8FQ.default), {
                                links: props.links,
                                appDetails: appListingResult,
                                appDetailsFromSearchResponse: appDetailsFromSearchResponse,
                                components: {
                                    afterHeader: renderAfterHeader()
                                },
                                user: appListingUser,
                                cloudMigration: null,
                                selectedTab: selectedTab,
                                showIntegrationsDetailsSection: false,
                                showResourcesSection: false,
                                mpacBaseUrl: props.mpacBaseUrl,
                                mpacCdnBaseUrl: applicationConfig.mpacCdnBaseUrl,
                                feedbackCollectorApiKeys: isAetherExp ? applicationConfig.feedbackCollectorApiKeys : undefined,
                                feedbackGatewayBaseUrl: isAetherExp ? applicationConfig.feedbackGatewayBaseUrl : undefined,
                                atlassianCommunityBaseUrl: props.atlassianCommunityBaseUrl,
                                onTabSelect: handleTabSelect,
                                showInstallationCount: true,
                                loginHref: "/login?redirect=".concat(encodeURIComponent(window.location.href)),
                                headerInjection: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7p31F.default), $b89dd3e3c2981504$var$_objectSpread({
                                    links: props.links,
                                    hostPricing: props.hostPricing,
                                    installedApp: installedApp,
                                    onInstallClick: openInstallDialog,
                                    installationInProgressAppKey: installationInProgressAppKey,
                                    hasInstallPermission: hasInstallPermission,
                                    featureFlags: props.featureFlags,
                                    appKey: appListingResult.appKey,
                                    appName: appListingResult.name,
                                    paymentModel: paymentModel,
                                    mpacBaseUrl: props.mpacBaseUrl,
                                    isRequestDialogOpen: !!requestDialogOpenInitially,
                                    eligibleForFreeOnSandbox: appDetailsResult.eligibleForFreeOnSandbox,
                                    cloudMigrationTrial: appDetailsResult.cloudMigrationTrial
                                }, ecosystemCloudAppId && {
                                    ecosystemCloudAppId: ecosystemCloudAppId
                                })),
                                selectedHosting: (0, $ammkg.AtlassianProductHostingType).Cloud
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsxs)($b89dd3e3c2981504$export$7883ebfcd4d2a85d, {
                                target: "_blank",
                                href: marketplaceAppLink,
                                "data-testid": "app-listing__view-more-link",
                                onClick: handleViewMoreOnMarketplaceLinkClick,
                                children: [
                                    "View all info on marketplace",
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ddHQW))), {
                                        size: "small"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                installerElement
            ]
        }) : /*#__PURE__*/ (0, $lHkHI.jsx)($b89dd3e3c2981504$export$5d2606a9a2b8350e, {
            history: history,
            showAetherAppListingPage: showAetherAppListingPage
        })
    });
}
function $b89dd3e3c2981504$export$2e2bcd8739ae039(props) {
    const { appKey: appKey } = props;
    if (!appKey) // TODO: Add the commonized error page from MC-463
    return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
        children: "An invalid app ID was provided"
    });
    else return /*#__PURE__*/ (0, $lHkHI.jsx)($b89dd3e3c2981504$export$921a140a0ab7df5b, $b89dd3e3c2981504$var$_objectSpread($b89dd3e3c2981504$var$_objectSpread({}, props), {}, {
        appKey: appKey
    }));
}

});
parcelRegister("4z8FQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $353128bf650e6c19$export$2e2bcd8739ae039);

var $f2QOW = parcelRequire("f2QOW");

var $inwKI = parcelRequire("inwKI");
var $9l6Pq = parcelRequire("9l6Pq");

var $ammkg = parcelRequire("ammkg");

var $aosfp = parcelRequire("aosfp");
var $cSibF = parcelRequire("cSibF");

var $ebXHa = parcelRequire("ebXHa");
var $c9Mth = parcelRequire("c9Mth");
parcelRequire("eUqFw");

var $c1ZLO = parcelRequire("c1ZLO");

var $h6uOD = parcelRequire("h6uOD");

var $5y7Bn = parcelRequire("5y7Bn");

var $8dnmP = parcelRequire("8dnmP");

var $dcnzE = parcelRequire("dcnzE");

var $lC7IO = parcelRequire("lC7IO");

var $iXji1 = parcelRequire("iXji1");
var $jrrQv = parcelRequire("jrrQv");

var $9fHbR = parcelRequire("9fHbR");

var $cXrEd = parcelRequire("cXrEd");
var $jd8Av = parcelRequire("jd8Av");

var $aTte8 = parcelRequire("aTte8");

var $5V6US = parcelRequire("5V6US");

var $lHkHI = parcelRequire("lHkHI");
const $353128bf650e6c19$export$d886c0f5078e3afc = (tabs, selectedTab, onTabSelect)=>{
    const tabSelected = tabs.find((tab)=>tab.key === selectedTab);
    // If we didn't find the selected tab key in the current list of available
    // tabs, fallback to the first tab, and notify that tab has changed
    if (!tabSelected) {
        onTabSelect(tabs[0].key);
        return tabs[0];
    }
    return tabSelected;
};
/* eslint-disable complexity */ // eslint-disable-next-line max-lines-per-function
const $353128bf650e6c19$var$AppListing = (props)=>{
    var _appListing$programs, _appListing$programs$, _props$components, _props$components2, _appListing$programs2, _appListing$programs3, _props$components3;
    const { enableMpacServerEolWarning: enableMpacServerEolWarning } = (0, $inwKI.useFeatureFlags)();
    const { enableStaffPickOnAppListing: enableStaffPickOnAppListing, showAppListingTrustTab: showAppListingTrustTab, showNewJiraSoftwareLabel: showNewJiraSoftwareLabel, enableAetherAppListingPage: enableAetherAppListingPage } = (0, $9l6Pq.useStatsig)();
    const enableStaffPickOnAppListingFlag = enableStaffPickOnAppListing();
    const showNewJiraSoftwareLabelFlag = showNewJiraSoftwareLabel();
    const showAetherAppListingPage = enableAetherAppListingPage();
    if (!props.appDetails) return null;
    const { appDetails: appDetails, appDetailsFromSearchResponse: appDetailsFromSearchResponse, links: links, headerInjection: headerInjection, selectedHosting: selectedHosting, selectedTab: selectedTab, onTabSelect: onTabSelect, mpacBaseUrl: mpacBaseUrl, mpacCdnBaseUrl: mpacCdnBaseUrl, atlassianCommunityBaseUrl: atlassianCommunityBaseUrl, cloudMigration: cloudMigration, loginHref: loginHref, user: user, onHostingSelectOpen: onHostingSelectOpen, onHostingOptionClick: onHostingOptionClick, onSupportLinkClick: onSupportLinkClick = ()=>null, onMediaViewerOpen: onMediaViewerOpen = ()=>null, onWatchAppToggle: onWatchAppToggle = ()=>null, onSeeMoreReviewsClick: onSeeMoreReviewsClick = ()=>null, onArtifactDownloadClick: onArtifactDownloadClick = ()=>null, onContactPartnerClick: onContactPartnerClick = ()=>null, onCloudMigrationResourceLinksClick: onCloudMigrationResourceLinksClick = ()=>null, onMigrationLozengeClick: onMigrationLozengeClick = ()=>null, onPricingCalculatorInstallCTAClick: onPricingCalculatorInstallCTAClick = ()=>null, showHeaderLozenges: showHeaderLozenges = false, showHeaderProductCompatibilities: showHeaderProductCompatibilities = false, showInstallationCount: showInstallationCount = false, showInstallationTab: showInstallationTab = false, serverEolStartDate: serverEolStartDate = '', showIntegrationsDetailsSection: showIntegrationsDetailsSection = false, showPricingTab: showPricingTab = false, showResourcesSection: showResourcesSection = false, showReviewsTab: showReviewsTab = false, showVersionsTab: showVersionsTab = false, showCloudMigrationLozenge: showCloudMigrationLozenge = false, openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab = true, feedbackGatewayBaseUrl: feedbackGatewayBaseUrl, feedbackCollectorApiKeys: feedbackCollectorApiKeys, isServerAppEos: isServerAppEos } = props;
    const appListing = (0, $8dnmP.default)({
        appDetails: appDetails,
        appDataFromSearch: appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : appDetailsFromSearchResponse.appData,
        mediaImageLink: links.mediaImage,
        partnerDetailsLink: links.partnerDetails,
        appVersionHistoryLink: links.appVersionHistory,
        artifactDownloadLink: links.artifactDownload,
        descriptorDownloadLink: links.descriptorDownload,
        licensePurchaseLink: links.licensePurchase,
        trialLicenseActivationLink: links.trialLicenseActivation,
        appIconLink: links.appIcon,
        hosting: selectedHosting
    });
    const appCompatibleWithDcEnabledProduct = (0, $ebXHa).maybeDCCompatible(appListing.productHostingOptions, appListing.serverCompatibleProducts);
    const appCompatibleWithCloudSupportedProduct = (0, $dcnzE.compatibleWithCloudSupportedProduct)(appListing.compatibleProducts);
    const showServerEolMessage = enableMpacServerEolWarning && selectedHosting === (0, $ammkg.AtlassianProductHostingType).Server && !(0, $ebXHa).isExcludedServerApp(appListing.compatibleProducts);
    const alternateCloudListingLink = cloudMigration !== null && cloudMigration !== void 0 && cloudMigration.alternateCloudAppKey ? links.appDetails.expand({
        appKey: cloudMigration.alternateCloudAppKey
    }) : null;
    let hostingSelect;
    if (props.showHostingSelect) {
        if (showAetherAppListingPage) hostingSelect = /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5y7Bn.HostingSelectContainerV2), {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jrrQv.default), {
                productHostingOptions: appListing.productHostingOptions,
                selected: props.selectedHosting,
                appCompatibleWithDcEnabledProduct: appCompatibleWithDcEnabledProduct,
                appCompatibleWithCloudSupportedProduct: appCompatibleWithCloudSupportedProduct,
                onChange: props.onHostingChange,
                partnerSupportUrl: appListing.partner.support.url,
                alternateCloudListingLink: alternateCloudListingLink,
                onContactPartnerClick: onContactPartnerClick,
                onOpen: onHostingSelectOpen,
                onHostingOptionClick: onHostingOptionClick
            })
        });
        else hostingSelect = /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5y7Bn.HostingSelectContainerV1), {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $iXji1.default), {
                productHostingOptions: appListing.productHostingOptions,
                selected: props.selectedHosting,
                appCompatibleWithDcEnabledProduct: appCompatibleWithDcEnabledProduct,
                appCompatibleWithCloudSupportedProduct: appCompatibleWithCloudSupportedProduct,
                onChange: props.onHostingChange,
                partnerSupportUrl: appListing.partner.support.url,
                alternateCloudListingLink: alternateCloudListingLink,
                onContactPartnerClick: onContactPartnerClick,
                onOpen: onHostingSelectOpen,
                onHostingOptionClick: onHostingOptionClick
            })
        });
    }
    const handleTabChange = (tabData)=>{
        const tabKey = tabData && tabData.key;
        if (typeof onTabSelect === 'function') onTabSelect(tabKey);
    };
    const isAppCloudFortified = !!((_appListing$programs = appListing.programs) !== null && _appListing$programs !== void 0 && (_appListing$programs$ = _appListing$programs.cloudFortified) !== null && _appListing$programs$ !== void 0 && _appListing$programs$.isStatusApproved);
    const hasCloudFortifiedBadge = isAppCloudFortified;
    const appHeaderDetails = (0, $h6uOD.makeAppHeaderProps)(appListing, appDetailsFromSearchResponse);
    const appRating = appHeaderDetails.ratings;
    const isAppStaffPick = appListing.marketingLabels.includes('Featured');
    const tabs = (0, $9fHbR.makeAppListingTabs)({
        appListing: appListing,
        selectedHosting: selectedHosting,
        showAetherAppListingPage: showAetherAppListingPage,
        showInstallationTab: showInstallationTab,
        showIntegrationsDetailsSection: showIntegrationsDetailsSection,
        showResourcesSection: showResourcesSection,
        showCertificationSection: hasCloudFortifiedBadge,
        showReviewsTab: showReviewsTab,
        showVersionsTab: showVersionsTab,
        showPricingTab: showPricingTab,
        mpacBaseUrl: mpacBaseUrl,
        mpacCdnBaseUrl: mpacCdnBaseUrl,
        atlassianCommunityBaseUrl: atlassianCommunityBaseUrl,
        loginHref: loginHref,
        user: user,
        onSupportLinkClick: onSupportLinkClick,
        onMediaViewerOpen: onMediaViewerOpen,
        onWatchAppToggle: onWatchAppToggle,
        onSeeMoreReviewsClick: onSeeMoreReviewsClick,
        onArtifactDownloadClick: onArtifactDownloadClick,
        cloudMigration: cloudMigration,
        onCloudMigrationResourceLinksClick: onCloudMigrationResourceLinksClick,
        onPricingCalculatorInstallCTAClick: onPricingCalculatorInstallCTAClick,
        showAppListingTrustTab: showAppListingTrustTab() || showAetherAppListingPage,
        appRating: appRating,
        showServerEolMessage: !!showServerEolMessage,
        serverEolStartDate: serverEolStartDate,
        feedbackCollectorApiKeys: feedbackCollectorApiKeys,
        feedbackGatewayBaseUrl: feedbackGatewayBaseUrl,
        isServerAppEos: isServerAppEos,
        onTabSelect: onTabSelect
    });
    const tabSelected = $353128bf650e6c19$export$d886c0f5078e3afc(tabs, selectedTab, onTabSelect);
    const supportTabLink = (0, $c9Mth).updateQueryParam(window.location.href, 'tab', (0, $c1ZLO.AppListingTab).Support);
    const iconLink = {
        expand: ()=>appListing.logo
    };
    const Container = showAetherAppListingPage ? (0, $5y7Bn.ListingContainer) : 'div';
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $f2QOW.default), {
        properties: {
            source: 'appListingScreen'
        },
        attributes: {
            deploymentType: appListing.deploymentType,
            hasCloudFortifiedBadge: hasCloudFortifiedBadge
        },
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)(Container, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5y7Bn.AnimationContainer), {
                    children: (_props$components = props.components) === null || _props$components === void 0 ? void 0 : _props$components.beforeHeader
                }),
                showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5V6US.default), {
                    appHeaderDetails: appHeaderDetails,
                    appRatingLink: links.appRating,
                    appIconLink: iconLink,
                    bottomSeparator: false,
                    headerInjection: headerInjection,
                    hostingSelect: hostingSelect,
                    afterHeader: (_props$components2 = props.components) === null || _props$components2 === void 0 ? void 0 : _props$components2.afterHeader,
                    isAppCloudFortified: isAppCloudFortified,
                    showStaffPickBadge: enableStaffPickOnAppListingFlag && isAppStaffPick,
                    showInstallationCount: showInstallationCount,
                    openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
                    bugBountyParticipant: (_appListing$programs2 = appListing.programs) === null || _appListing$programs2 === void 0 ? void 0 : _appListing$programs2.bugBountyParticipant,
                    compatibilitySummary: showHeaderProductCompatibilities ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jd8Av.default), {
                        cloudCompatibleProducts: appListing.cloudCompatibleProducts,
                        serverCompatibleProducts: appListing.serverCompatibleProducts,
                        dataCenterCompatibleProducts: appListing.dataCenterCompatibleProducts,
                        totalVersionCount: appListing.totalVersionCount,
                        versionHistoryUrl: appListing.versionHistoryUrl
                    }) : null,
                    lozenges: showHeaderLozenges ? (0, $lC7IO.makeHeaderLozenges)({
                        supportDetails: appListing.supportDetails,
                        partnerName: appListing.partner.name,
                        supportLink: supportTabLink,
                        categories: appListing.categories,
                        marketingLabels: appListing.marketingLabels,
                        onMigrationLozengeClick: onMigrationLozengeClick,
                        cloudMigration: cloudMigration,
                        showCloudMigrationLozenge: showCloudMigrationLozenge,
                        isServerAppEos: isServerAppEos,
                        showNewJiraSoftwareLabelFlag: showNewJiraSoftwareLabelFlag,
                        showAetherAppListingPage: showAetherAppListingPage
                    }) : [],
                    selectedTab: tabSelected.key,
                    onTabChange: handleTabChange,
                    tabsData: tabs
                }) : /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aosfp.default), {
                            appHeaderDetails: appHeaderDetails,
                            appRatingLink: links.appRating,
                            appIconLink: iconLink,
                            bottomSeparator: false,
                            headerInjection: headerInjection,
                            isAppCloudFortified: isAppCloudFortified,
                            showStaffPickBadge: enableStaffPickOnAppListingFlag && isAppStaffPick,
                            showInstallationCount: showInstallationCount,
                            openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
                            bugBountyParticipant: (_appListing$programs3 = appListing.programs) === null || _appListing$programs3 === void 0 ? void 0 : _appListing$programs3.bugBountyParticipant,
                            compatibilitySummary: showHeaderProductCompatibilities ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cXrEd.default), {
                                cloudCompatibleProducts: appListing.cloudCompatibleProducts,
                                serverCompatibleProducts: appListing.serverCompatibleProducts,
                                dataCenterCompatibleProducts: appListing.dataCenterCompatibleProducts,
                                totalVersionCount: appListing.totalVersionCount,
                                versionHistoryUrl: appListing.versionHistoryUrl
                            }) : null,
                            lozenges: showHeaderLozenges ? (0, $lC7IO.makeHeaderLozenges)({
                                supportDetails: appListing.supportDetails,
                                partnerName: appListing.partner.name,
                                supportLink: supportTabLink,
                                categories: appListing.categories,
                                marketingLabels: appListing.marketingLabels,
                                onMigrationLozengeClick: onMigrationLozengeClick,
                                cloudMigration: cloudMigration,
                                showCloudMigrationLozenge: showCloudMigrationLozenge,
                                isServerAppEos: isServerAppEos,
                                showNewJiraSoftwareLabelFlag: showNewJiraSoftwareLabelFlag
                            }) : []
                        }),
                        (_props$components3 = props.components) === null || _props$components3 === void 0 ? void 0 : _props$components3.afterHeader,
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cSibF.default), {
                            id: (0, $c1ZLO.ELEMENT_ID).APP_LISTING_TABS,
                            selected: tabSelected.key,
                            maxVisibleTabs: (0, $c1ZLO.MAX_VISIBLE_TABS_CONFIG),
                            onChange: handleTabChange,
                            afterTabs: hostingSelect,
                            tabs: tabs
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aTte8.default), {
                    name: appListing.name,
                    createdAt: appListing.createdAt,
                    description: appListing.summary,
                    icon: appListing.logo,
                    partner: {
                        name: appListing.partner.name,
                        url: appListing.partner.url
                    },
                    review: {
                        rating: appListing.reviewSummary.rating,
                        count: appListing.reviewSummary.count
                    },
                    compatibleProducts: appListing.compatibleProducts
                })
            ]
        })
    });
};
var $353128bf650e6c19$export$2e2bcd8739ae039 = $353128bf650e6c19$var$AppListing;

});
parcelRegister("aosfp", function(module, exports) {

$parcel$export(module.exports, "default", () => $79120ea206464009$export$2e2bcd8739ae039);
parcelRequire("eUqFw");

var $7BUhe = parcelRequire("7BUhe");

var $8xfj9 = parcelRequire("8xfj9");

var $iKF5E = parcelRequire("iKF5E");

var $94W0i = parcelRequire("94W0i");

var $lHuB6 = parcelRequire("lHuB6");

var $aFbzH = parcelRequire("aFbzH");

var $j7LzR = parcelRequire("j7LzR");

var $fm8vZ = parcelRequire("fm8vZ");

var $fmcsZ = parcelRequire("fmcsZ");

var $eoMJc = parcelRequire("eoMJc");

var $lHkHI = parcelRequire("lHkHI");
function $79120ea206464009$var$AppHeader(_ref) {
    var _appHeaderDetails$com;
    let { appHeaderDetails: appHeaderDetails, appIconLink: appIconLink, appIconSize: appIconSize = 'large', appRatingLink: appRatingLink, bottomSeparator: bottomSeparator = true, compatibilitySummary: compatibilitySummary = null, headerInjection: headerInjection, isAppCloudFortified: isAppCloudFortified = false, lozenges: lozenges = [], openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab = true, showInstallationCount: showInstallationCount = false, bugBountyParticipant: bugBountyParticipant = null, showStaffPickBadge: showStaffPickBadge = false } = _ref;
    const showNewAppMessage = $lHuB6.showNewAppMessage(appHeaderDetails);
    const { tooltipMessage: installTooltipMessage, installCountMessage: installCountMessage, showDownloadIcon: showDownloadIcon, isLoading: isInstallMessageLoading } = (0, $iKF5E.useInstallMessage)({
        distribution: appHeaderDetails.distribution,
        showNewAppMessage: showNewAppMessage,
        compatibleProducts: (_appHeaderDetails$com = appHeaderDetails.compatibleProducts) !== null && _appHeaderDetails$com !== void 0 ? _appHeaderDetails$com : [],
        showAetherAppListingPage: false
    });
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $94W0i.HeaderContainer), {
        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER,
        bottomSeparator: bottomSeparator,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $94W0i.IconContainer), {
                "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_ICON,
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aFbzH.default), {
                    size: appIconSize,
                    origin: appHeaderDetails.origin,
                    icon: appHeaderDetails.icon,
                    appKey: appHeaderDetails.key,
                    appIconLink: appIconLink
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $94W0i.AppDetailsContainer), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $94W0i.AppName), {
                        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_APP_NAME,
                        children: [
                            appHeaderDetails.name,
                            " ",
                            showStaffPickBadge && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eoMJc.default), {})
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8xfj9.default), {
                        name: appHeaderDetails.partner.name,
                        link: appHeaderDetails.partner.link,
                        partnerTierType: appHeaderDetails.partner.partnerTierType
                    }),
                    compatibilitySummary && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $94W0i.CompatibilitiesContainer), {
                        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_COMPATIBILITIES,
                        children: compatibilitySummary
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $94W0i.TrustSignalsContainer), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $94W0i.TrustSignalsRow), {
                        children: [
                            !showNewAppMessage && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $94W0i.RatingsContainer), {
                                "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_RATINGS,
                                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fmcsZ.default), {
                                    appKey: appHeaderDetails.key,
                                    appRatingLink: appRatingLink,
                                    openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
                                    ratings: appHeaderDetails.ratings
                                })
                            }),
                            showInstallationCount && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $94W0i.InstallCountContainer), {
                                "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_INSTALL_COUNT,
                                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $iKF5E.InstallCount), {
                                    tooltipMessage: installTooltipMessage,
                                    installCountMessage: installCountMessage,
                                    showDownloadIcon: showDownloadIcon,
                                    isLoading: isInstallMessageLoading
                                })
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $94W0i.CertificationContainer), {
                                "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_CERTIFICATION,
                                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j7LzR.default), {
                                    isAppCloudFortified: isAppCloudFortified,
                                    bugBountyParticipant: bugBountyParticipant
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fm8vZ.default), {
                            lozenges: lozenges
                        })
                    })
                ]
            }),
            !!headerInjection && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $94W0i.HeaderInjectionContainer), {
                children: headerInjection
            })
        ]
    });
}
$79120ea206464009$var$AppHeader.getAppIcon = (0, $aFbzH.getAppIcon);
var $79120ea206464009$export$2e2bcd8739ae039 = $79120ea206464009$var$AppHeader;

});
parcelRegister("iKF5E", function(module, exports) {

$parcel$export(module.exports, "useInstallMessage", () => $da6c658928d2b927$export$29fe0f9bc7becfdc);
$parcel$export(module.exports, "InstallCount", () => $da6c658928d2b927$export$626438f97f0aeb8d);

var $j0gMm = parcelRequire("j0gMm");

var $l2WWm = parcelRequire("l2WWm");

var $hgNMk = parcelRequire("hgNMk");
parcelRequire("eUqFw");

var $bZbjp = parcelRequire("bZbjp");

var $lHkHI = parcelRequire("lHkHI");
const $da6c658928d2b927$var$getPreinstalledMessage = (isPreinstalled, compatibleProducts)=>{
    if (!isPreinstalled) return null;
    let tooltipMessage = '';
    if (compatibleProducts.length === 1) tooltipMessage = "This app comes preinstalled in ".concat(compatibleProducts[0], " instances");
    else if (compatibleProducts.length === 2) tooltipMessage = "This app comes preinstalled in ".concat(compatibleProducts[0], " and ").concat(compatibleProducts[1], " instances");
    else if (compatibleProducts.length >= 3) tooltipMessage = "This app comes preinstalled in ".concat(compatibleProducts[0], ", ").concat(compatibleProducts[1], " and other products");
    return {
        tooltipMessage: tooltipMessage,
        showDownloadIcon: false,
        installCountMessage: 'Preinstalled',
        title: 'INSTALLS'
    };
};
const $da6c658928d2b927$var$getNewAppMessage = (showNewAppMessage, showAetherAppListingPage)=>{
    if (!showNewAppMessage) return null;
    return {
        tooltipMessage: null,
        installCountMessage: showAetherAppListingPage ? 'No installs yet' : 'New!',
        showDownloadIcon: false,
        title: 'INSTALLS'
    };
};
const $da6c658928d2b927$var$getInstallCountMessage = (installCount, isPreinstalledInAnyHosting, isError, showAetherAppListingPage)=>{
    if (!installCount || isPreinstalledInAnyHosting || isError) return null;
    const countInLocaleString = installCount.toLocaleString();
    return {
        tooltipMessage: "Customers have installed this app in at least ".concat(countInLocaleString, " active ").concat((0, $hgNMk.pluralize)('instance', installCount)),
        installCountMessage: "".concat(countInLocaleString, " ").concat(showAetherAppListingPage ? '' : (0, $hgNMk.pluralize)('install', installCount)),
        showDownloadIcon: true,
        title: 'INSTALLS'
    };
};
const $da6c658928d2b927$var$getDownloadCountMessage = (downloadCount, isPreinstalledInAnyHosting, isError, showAetherAppListingPage)=>{
    if (!downloadCount || isPreinstalledInAnyHosting || isError) return null;
    const countInLocaleString = downloadCount.toLocaleString();
    return {
        tooltipMessage: "Customers have downloaded this app in at least ".concat(countInLocaleString, " active ").concat((0, $hgNMk.pluralize)('instance', downloadCount)),
        installCountMessage: "".concat(countInLocaleString, " ").concat(showAetherAppListingPage ? '' : (0, $hgNMk.pluralize)('download', downloadCount)),
        showDownloadIcon: true,
        title: 'DOWNLOADS'
    };
};
const $da6c658928d2b927$export$29fe0f9bc7becfdc = (_ref)=>{
    let { distribution: distribution, showNewAppMessage: showNewAppMessage, compatibleProducts: compatibleProducts, showAetherAppListingPage: showAetherAppListingPage } = _ref;
    const { installationCount: installationCount, downloadCount: downloadCount, isPreinstalled: isPreinstalled, isPreinstalledInAnyHosting: isPreinstalledInAnyHosting, isLoading: isLoading, isError: isError } = distribution || {};
    const { tooltipMessage: tooltipMessage, installCountMessage: installCountMessage, showDownloadIcon: showDownloadIcon, title: title } = $da6c658928d2b927$var$getPreinstalledMessage(isPreinstalled, compatibleProducts) || $da6c658928d2b927$var$getNewAppMessage(showNewAppMessage, showAetherAppListingPage) || $da6c658928d2b927$var$getInstallCountMessage(installationCount, isPreinstalledInAnyHosting, isError, showAetherAppListingPage) || $da6c658928d2b927$var$getDownloadCountMessage(downloadCount, isPreinstalledInAnyHosting, isError, showAetherAppListingPage) || {};
    return {
        tooltipMessage: tooltipMessage,
        installCountMessage: installCountMessage,
        showDownloadIcon: showDownloadIcon,
        isLoading: isLoading,
        isError: isError,
        title: title
    };
};
const $da6c658928d2b927$export$626438f97f0aeb8d = (_ref2)=>{
    let { showAetherAppListingPage: showAetherAppListingPage, tooltipMessage: tooltipMessage, installCountMessage: installCountMessage, showDownloadIcon: showDownloadIcon, isLoading: isLoading } = _ref2;
    if (installCountMessage == null) return null;
    if (isLoading) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bZbjp.InstallCountWrapper), {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bZbjp.InstallCountLoader), {
            "data-testid": "install-count-loader"
        })
    });
    const InstallCountText = showAetherAppListingPage ? (0, $bZbjp.InstallCountTextV2) : (0, $bZbjp.InstallCountTextV1);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l2WWm.default), {
        content: tooltipMessage,
        position: "bottom",
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $bZbjp.InstallCountWrapper), {
            children: [
                showDownloadIcon && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bZbjp.DownloadIcon), {
                    label: installCountMessage,
                    primaryColor: "var(--ds-icon-subtle, ".concat((0, $j0gMm.N500), ")"),
                    size: showAetherAppListingPage ? 'medium' : 'small'
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)(InstallCountText, {
                    children: installCountMessage
                })
            ]
        })
    });
};
var $da6c658928d2b927$export$2e2bcd8739ae039 = $da6c658928d2b927$export$626438f97f0aeb8d;

});
parcelRegister("bZbjp", function(module, exports) {

$parcel$export(module.exports, "InstallCountWrapper", () => $8b9e2a90b55de629$export$f329876cedabef0e);
$parcel$export(module.exports, "InstallCountTextV1", () => $8b9e2a90b55de629$export$9c80158bd602821a);
$parcel$export(module.exports, "InstallCountTextV2", () => $8b9e2a90b55de629$export$66b3865e75d9d5e5);
$parcel$export(module.exports, "DownloadIcon", () => $8b9e2a90b55de629$export$4e54df4252b4a99c);
$parcel$export(module.exports, "InstallCountLoader", () => $8b9e2a90b55de629$export$e10c0592dd92a5bc);
/* InstallCount.styles.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $elcRV = parcelRequire("elcRV");

var $ivTMz = parcelRequire("ivTMz");


var $cCrLo = parcelRequire("cCrLo");

var $lHkHI = parcelRequire("lHkHI");
const $8b9e2a90b55de629$var$_excluded = [
    "as",
    "style"
], $8b9e2a90b55de629$var$_excluded2 = [
    "as",
    "style"
], $8b9e2a90b55de629$var$_excluded3 = [
    "as",
    "style"
], $8b9e2a90b55de629$var$_excluded4 = [
    "as",
    "style"
], $8b9e2a90b55de629$var$_excluded5 = [
    "as",
    "style"
];
function $8b9e2a90b55de629$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8b9e2a90b55de629$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8b9e2a90b55de629$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8b9e2a90b55de629$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $8b9e2a90b55de629$var$shimmer = (0, $ivTMz.skeletonShimmer)();
const $8b9e2a90b55de629$export$f329876cedabef0e = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $8b9e2a90b55de629$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $8b9e2a90b55de629$var$_objectSpread($8b9e2a90b55de629$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _4cvr1h6o _syazjjyb _1n261q9c",
            __cmplp.className
        ])
    }));
});
const $8b9e2a90b55de629$export$8d3100b53fd67df2 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $8b9e2a90b55de629$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $8b9e2a90b55de629$var$_objectSpread($8b9e2a90b55de629$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _2hwx1b66 _12hn14w8",
            __cmplp.className
        ])
    }));
});
const $8b9e2a90b55de629$export$9c80158bd602821a = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $8b9e2a90b55de629$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $8b9e2a90b55de629$var$_objectSpread($8b9e2a90b55de629$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _o5721q9c",
            __cmplp.className
        ])
    }));
});
const $8b9e2a90b55de629$export$66b3865e75d9d5e5 = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $8b9e2a90b55de629$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $8b9e2a90b55de629$var$_objectSpread($8b9e2a90b55de629$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c116y _o5721q9c _19pkidpf",
            __cmplp.className
        ])
    }));
});
const $8b9e2a90b55de629$export$4e54df4252b4a99c = (props)=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)($8b9e2a90b55de629$export$8d3100b53fd67df2, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($elcRV))), $8b9e2a90b55de629$var$_objectSpread($8b9e2a90b55de629$var$_objectSpread({}, props), {}, {
            label: "Download Icon"
        }))
    });
};
const $8b9e2a90b55de629$export$e10c0592dd92a5bc = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $8b9e2a90b55de629$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $8b9e2a90b55de629$var$_objectSpread($8b9e2a90b55de629$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsbcmky _4t3idlk8 _2rkoftgi _j7hq19hg _bfhk1mnh _5sag12o8 _tip812c5 _1pglp3kn _7hjf1yy8",
            __cmplp.className
        ])
    }));
});

});


parcelRegister("94W0i", function(module, exports) {

$parcel$export(module.exports, "AppName", () => $69c17b20eff48a93$export$e3fa2c64115299cc);
$parcel$export(module.exports, "HeaderContainer", () => $69c17b20eff48a93$export$1e86fd0e1db89578);
$parcel$export(module.exports, "IconContainer", () => $69c17b20eff48a93$export$8f314e512d92575f);
$parcel$export(module.exports, "AppDetailsContainer", () => $69c17b20eff48a93$export$66089487c21dd717);
$parcel$export(module.exports, "CompatibilitiesContainer", () => $69c17b20eff48a93$export$a3e5b8c63bd057f3);
$parcel$export(module.exports, "TrustSignalsContainer", () => $69c17b20eff48a93$export$4ce2a3945be9a02f);
$parcel$export(module.exports, "HeaderInjectionContainer", () => $69c17b20eff48a93$export$22d7f11e7dcd0a91);
$parcel$export(module.exports, "TrustSignalsRow", () => $69c17b20eff48a93$export$b0a56f686f741d77);
$parcel$export(module.exports, "RatingsContainer", () => $69c17b20eff48a93$export$508a6a934eaeeb30);
$parcel$export(module.exports, "InstallCountContainer", () => $69c17b20eff48a93$export$88744b1ccb2b55c9);
$parcel$export(module.exports, "CertificationContainer", () => $69c17b20eff48a93$export$d3fc906e2447136e);

var $jqNEH = parcelRequire("jqNEH");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $62cXe = parcelRequire("62cXe");

var $8gcXz = parcelRequire("8gcXz");

var $kO6Ah = parcelRequire("kO6Ah");

var $1JvFV = parcelRequire("1JvFV");
var $69c17b20eff48a93$var$_templateObject;
function $69c17b20eff48a93$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $69c17b20eff48a93$export$e3fa2c64115299cc = (0, $3UXZ8.default)("h1", {
    target: "elk6fai0",
    label: "AppName"
})((0, $8gcXz.baseHeadingsCss), " font-size:20px;line-height:", (0, $62cXe.headingSizes).h100.lineHeight / (0, $62cXe.headingSizes).h100.size, ";margin:0 0 var(--ds-space-025, 2px);display:inline-block;");
const $69c17b20eff48a93$export$1e86fd0e1db89578 = (0, $3UXZ8.default)("div", {
    target: "elk6fai1",
    label: "HeaderContainer"
})("display:grid;font-size:14px;line-height:1.42857143;grid-gap:var(--ds-space-150, 12px);grid-template-columns:max-content 1fr;grid-template-areas:'icon app-details' 'trust-signals trust-signals' 'header-injection header-injection';margin-bottom:var(--ds-space-200, 16px);@media screen and (min-width:", (0, $1JvFV.APP_HEADER_MOBILE_BREAKPOINT), "px){line-height:var(--ds-space-300, 24px);grid-gap:0 var(--ds-space-300, 24px);grid-template-columns:max-content 1fr max-content;grid-template-areas:'icon app-details header-injection' 'icon trust-signals header-injection';margin-bottom:var(--ds-space-400, 32px);}", (props)=>props.bottomSeparator && "\n    padding-bottom: ".concat("var(--ds-space-150, 12px)", ";\n    border-bottom: 1px solid ", "var(--ds-border, ".concat((0, $j0gMm.N30), ")"), ";\n  "), "");
const $69c17b20eff48a93$export$8f314e512d92575f = (0, $3UXZ8.default)("div", {
    target: "elk6fai2",
    label: "IconContainer"
})({
    name: "374ojd",
    styles: "grid-area:icon;"
});
const $69c17b20eff48a93$export$66089487c21dd717 = (0, $3UXZ8.default)("div", {
    target: "elk6fai3",
    label: "AppDetailsContainer"
})({
    name: "107ws4u",
    styles: "grid-area:app-details;"
});
const $69c17b20eff48a93$export$a3e5b8c63bd057f3 = (0, $3UXZ8.default)("div", {
    target: "elk6fai4",
    label: "CompatibilitiesContainer"
})("display:none;color:", "var(--ds-text, ".concat((0, $j0gMm.N300), ")"), ";margin-bottom:var(--ds-space-050, 4px);", (0, $kO6Ah.mediaBreakpoints).smallUp($69c17b20eff48a93$var$_templateObject || ($69c17b20eff48a93$var$_templateObject = (0, $jqNEH.default)([
    "\n    display: block\n  "
]))), "");
const $69c17b20eff48a93$export$4ce2a3945be9a02f = (0, $3UXZ8.default)("div", {
    target: "elk6fai5",
    label: "TrustSignalsContainer"
})({
    name: "b0c1oy",
    styles: "grid-area:trust-signals;"
});
const $69c17b20eff48a93$export$22d7f11e7dcd0a91 = (0, $3UXZ8.default)("div", {
    target: "elk6fai6",
    label: "HeaderInjectionContainer"
})("grid-area:header-injection;@media screen and (min-width:", (0, $1JvFV.APP_HEADER_MOBILE_BREAKPOINT), "px){display:flex;flex-direction:column;justify-content:center;}");
const $69c17b20eff48a93$export$b0a56f686f741d77 = (0, $3UXZ8.default)("div", {
    target: "elk6fai7",
    label: "TrustSignalsRow"
})({
    name: "1tjvj5q",
    styles: "display:flex;grid-column-gap:var(--ds-space-200, 16px);flex-wrap:wrap;margin-bottom:var(--ds-space-050, 4px);"
});
const $69c17b20eff48a93$export$508a6a934eaeeb30 = (0, $3UXZ8.default)("div", {
    target: "elk6fai8",
    label: "RatingsContainer"
})("@media screen and (max-width:", (0, $1JvFV.APP_HEADER_MOBILE_BREAKPOINT) - 1, "px){order:2;}");
const $69c17b20eff48a93$export$88744b1ccb2b55c9 = (0, $3UXZ8.default)("div", {
    target: "elk6fai9",
    label: "InstallCountContainer"
})("@media screen and (max-width:", (0, $1JvFV.APP_HEADER_MOBILE_BREAKPOINT) - 1, "px){order:2;}");
const $69c17b20eff48a93$export$d3fc906e2447136e = (0, $3UXZ8.default)("div", {
    target: "elk6fai10",
    label: "CertificationContainer"
})("@media screen and (max-width:", (0, $1JvFV.APP_HEADER_MOBILE_BREAKPOINT) - 1, "px){order:1;width:100%;}");

});
parcelRegister("1JvFV", function(module, exports) {

$parcel$export(module.exports, "ANALYTICS_SUBJECT_ID_RATINGS", () => $1432906e0def8423$export$59c88dd19625276f);
$parcel$export(module.exports, "APP_HEADER_MOBILE_BREAKPOINT", () => $1432906e0def8423$export$55ea70f9dd0a382c);

var $kO6Ah = parcelRequire("kO6Ah");
const $1432906e0def8423$export$1a92a405aaa81c31 = 'appHeader';
const $1432906e0def8423$export$59c88dd19625276f = 'ratings';
const $1432906e0def8423$export$55ea70f9dd0a382c = (0, $kO6Ah.gridBreakpoints).sm;

});


parcelRegister("lHuB6", function(module, exports) {

$parcel$export(module.exports, "showNewAppMessage", () => $fcc5591ec19d8770$export$3c3e3248d680e3a0);

var $d2wNG = parcelRequire("d2wNG");
const $fcc5591ec19d8770$export$3c3e3248d680e3a0 = (appHeaderDetails)=>{
    const { createdAt: createdAt, distribution: distribution, ratings: ratings } = appHeaderDetails;
    const { installationCount: installationCount, downloadCount: downloadCount, isPreinstalledInAnyHosting: isPreinstalledInAnyHosting, isPreinstalled: isPreinstalled } = distribution || {};
    const isNewApp = !!createdAt && (0, $d2wNG.default)(new Date(), createdAt) <= 30;
    return isNewApp && !isPreinstalled && !isPreinstalledInAnyHosting && !downloadCount && !installationCount && !ratings.numRatings;
};

});

parcelRegister("aFbzH", function(module, exports) {

$parcel$export(module.exports, "getAppIcon", () => $7c36b63fc0d9c5ec$export$68e78e52e6d2f064);
$parcel$export(module.exports, "default", () => $7c36b63fc0d9c5ec$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $8oBYp = parcelRequire("8oBYp");

var $c0qPT = parcelRequire("c0qPT");
parcelRequire("eUqFw");

var $8U0Ec = parcelRequire("8U0Ec");

var $8RTbO = parcelRequire("8RTbO");

var $1JvFV = parcelRequire("1JvFV");

var $7GLYA = parcelRequire("7GLYA");

var $lHkHI = parcelRequire("lHkHI");
const $7c36b63fc0d9c5ec$export$3c3e0c6096dd55ef = (0, $3UXZ8.default)("div", {
    target: "e17jj8wx0",
    label: "IconContainerV1"
})("width:", (props)=>props.size === 'large' ? '64px' : '48px', ";height:", (props)=>props.size === 'large' ? '64px' : '48px', ";@media (min-width:", (0, $1JvFV.APP_HEADER_MOBILE_BREAKPOINT), "px){width:", (props)=>props.size === 'large' ? '104px' : '48px', ";height:", (props)=>props.size === 'large' ? '104px' : '48px', ";}");
const $7c36b63fc0d9c5ec$export$427da3f28943b1da = (0, $3UXZ8.default)("div", {
    target: "e17jj8wx1",
    label: "IconContainerMPACV2"
})({
    width: '3.5rem',
    height: '3.5rem',
    [(0, $8oBYp.media).above.sm]: {
        width: '5.875rem',
        height: '5.875rem'
    }
}, "");
const $7c36b63fc0d9c5ec$export$444e98ac03abbe0 = (0, $3UXZ8.default)("div", {
    target: "e17jj8wx2",
    label: "IconContainerEMCEEV2"
})({
    width: '3.5rem',
    height: '3.5rem',
    [(0, $8oBYp.media).above.sm]: {
        width: '4rem',
        height: '4rem'
    }
}, "");
const $7c36b63fc0d9c5ec$export$68e78e52e6d2f064 = (origin, appKey, icon, appIconLink)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $8RTbO.default), {
        uniqueKey: appKey,
        iconUrl: (0, $7GLYA.getIconUrl)({
            origin: origin,
            appKey: appKey,
            appIconLink: appIconLink
        }),
        fallbackIconUrl: (0, $7GLYA.getFallbackIconUrl)(origin, icon),
        iconType: (0, $7GLYA.getIconType)(origin)
    });
const $7c36b63fc0d9c5ec$export$a2795a58007caf5a = (_ref)=>{
    let { isMPAC: isMPAC, showAetherAppListingPage: showAetherAppListingPage } = _ref;
    if (showAetherAppListingPage) {
        if (isMPAC) return $7c36b63fc0d9c5ec$export$427da3f28943b1da;
        else return $7c36b63fc0d9c5ec$export$444e98ac03abbe0;
    }
    return $7c36b63fc0d9c5ec$export$3c3e0c6096dd55ef;
};
const $7c36b63fc0d9c5ec$var$HeaderAppIcon = (props)=>{
    const { appKey: appKey, origin: origin, appIconLink: appIconLink, icon: icon, size: size = 'large', showAetherAppListingPage: showAetherAppListingPage } = props;
    const source = (0, $c0qPT.useSource)();
    const isMPAC = source === 'MPAC';
    const IconContainer = $7c36b63fc0d9c5ec$export$a2795a58007caf5a({
        showAetherAppListingPage: showAetherAppListingPage,
        isMPAC: isMPAC
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)(IconContainer, {
        size: size,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8U0Ec.default), {
            children: $7c36b63fc0d9c5ec$export$68e78e52e6d2f064(origin, appKey, icon, appIconLink)
        })
    });
};
var $7c36b63fc0d9c5ec$export$2e2bcd8739ae039 = $7c36b63fc0d9c5ec$var$HeaderAppIcon;

});
parcelRegister("8RTbO", function(module, exports) {

$parcel$export(module.exports, "default", () => $674e157355a70f21$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $gC8Po = parcelRequire("gC8Po");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $674e157355a70f21$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $674e157355a70f21$var$ICON_COLORS = [
    (0, $j0gMm.R300),
    (0, $j0gMm.Y300),
    (0, $j0gMm.G300),
    (0, $j0gMm.T300),
    (0, $j0gMm.P300)
];
const $674e157355a70f21$var$KEY_ICON = '<path d="M36.7340089,18.0415853 L38.6479513,16.1276428 L35.4580473,12.9377388 L37.3719897,11.0237963 C38.0766839,10.3191022 38.0766839,9.17656721 37.3719897,8.47187306 C36.6672956,7.76717891 35.5247606,7.76717891 34.8200664,8.47187306 L20.4654981,22.8264414 C17.4100825,21.0528024 13.5130975,21.8208178 11.3591119,24.6211223 C9.20512621,27.4214269 9.46257344,31.3850187 11.9607087,33.883154 C14.458844,36.3812893 18.4224359,36.6387366 21.2227404,34.4847509 C24.023045,32.3307652 24.7910604,28.4337803 23.0174214,25.3783647 L29.7082452,18.6875409 L32.2601684,21.2394641 L34.1741109,19.3255217 L31.6221876,16.7735984 L33.5361301,14.859656 L36.7340089,18.0415853 Z M16.9566036,32.0771632 C15.1948682,32.0771632 13.7666995,30.6489945 13.7666995,28.8872592 C13.7666995,27.1255238 15.1948682,25.6973551 16.9566036,25.6973551 C18.718339,25.6973551 20.1465077,27.1255238 20.1465077,28.8872592 C20.1465077,30.6489945 18.718339,32.0771632 16.9566036,32.0771632 Z" fill="#FFFFFF"></path>';
const $674e157355a70f21$var$APP_ICON = '<g transform="translate(5.000000, 5.000000)" fill="#FFFFFF">\n<path d="M8.06370103,9.68214963 L15.936299,5.02597189 C17.124057,4.32348301 18.879979,4.32587008 20.063701,5.02597189 L27.936299,9.68214963 C29.124057,10.3846385 30,11.9436186 30,13.3438223 L30,22.6561777 C30,24.0611555 29.120021,25.6177486 27.936299,26.3178504 L20.063701,30.9740281 C18.875943,31.676517 17.120021,31.6741299 15.936299,30.9740281 L8.06370103,26.3178504 C6.87594301,25.6153615 6,24.0563814 6,22.6561777 L6,13.3438223 C6,11.9388445 6.87997902,10.3822514 8.06370103,9.68214963 Z M18.5501172,7.71155875 C18.3016811,7.56462341 17.6997026,7.56380505 17.4498828,7.71155875 L9.57728483,12.3677365 C9.32884867,12.5146718 9.02716761,13.0483149 9.02716761,13.3438223 L9.02716761,22.6561777 C9.02716761,22.9500484 9.32746501,23.4845098 9.57728483,23.6322635 L17.4498828,28.2884412 C17.6983189,28.4353766 18.3002974,28.4361949 18.5501172,28.2884412 L26.4227152,23.6322635 C26.6711513,23.4853282 26.9728324,22.9516851 26.9728324,22.6561777 L26.9728324,13.3438223 C26.9728324,13.0499516 26.672535,12.5154902 26.4227152,12.3677365 L18.5501172,7.71155875 Z"></path>\n<path d="M18,24 C14.6862915,24 12,21.3137085 12,18 C12,14.6862915 14.6862915,12 18,12 C21.3137085,12 24,14.6862915 24,18 C24,21.3137085 21.3137085,24 18,24 Z M18,21 C19.6568542,21 21,19.6568542 21,18 C21,16.3431458 19.6568542,15 18,15 C16.3431458,15 15,16.3431458 15,18 C15,19.6568542 16.3431458,21 18,21 Z"></path>\n</g>';
const $674e157355a70f21$var$IconContainer = (0, $3UXZ8.default)("div", {
    target: "e1ow4rfu0",
    label: "IconContainer"
})({
    name: "b7jmoi",
    styles: "width:100%;height:100%;position:relative;"
});
const $674e157355a70f21$var$IconImg = (0, $3UXZ8.default)("img", {
    target: "e1ow4rfu1",
    label: "IconImg"
})({
    name: "mtxokv",
    styles: "width:auto;height:auto;max-width:100%;max-height:100%;margin:auto;position:absolute;top:0;left:0;bottom:0;right:0;"
});
class $674e157355a70f21$export$2e2bcd8739ae039 extends $eUqFw.PureComponent {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            icon: null
        });
        (0, $5zQU9.default)(this, "handleError", (currentUrl)=>()=>{
                this.setState({
                    icon: this.props.fallbackIconUrl !== currentUrl ? this.props.fallbackIconUrl : this.generateDefaultIcon(this.props)
                });
            });
    }
    componentDidUpdate(prevProps) {
        if (!(this.props.uniqueKey === prevProps.uniqueKey && this.props.iconUrl === prevProps.iconUrl && this.props.fallbackIconUrl === prevProps.fallbackIconUrl && this.props.iconType === prevProps.iconType)) this.setState({
            icon: null
        });
    }
    generateDefaultIcon(props) {
        const innerEl = $674e157355a70f21$export$f89e53ba6fc8a5c5(this.props.iconType)((_)=>$674e157355a70f21$var$KEY_ICON, (_)=>$674e157355a70f21$var$APP_ICON);
        // Deterministically generate a color from the unique key
        const color = (0, $g5DHJ.List)(props.uniqueKey.split('')).reduce((acc, c)=>(acc + c.charCodeAt(0)) % $674e157355a70f21$var$ICON_COLORS.length, 0);
        const result = '<?xml version="1.0" encoding="UTF-8"?>\n<svg width="46px" height="46px" viewBox="0 0 46 46" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">\n<rect fill="' + $674e157355a70f21$var$ICON_COLORS[color] + '" x="0" y="0" width="46" height="46" rx="3"></rect>\n' + innerEl + '</svg>';
        return 'data:image/svg+xml;base64,' + window.btoa(result);
    }
    render() {
        const iconUrl = this.state.icon || this.props.iconUrl || this.props.fallbackIconUrl || this.generateDefaultIcon(this.props);
        return /*#__PURE__*/ (0, $lHkHI.jsx)($674e157355a70f21$var$IconContainer, {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)($674e157355a70f21$var$IconImg, {
                alt: "",
                draggable: false,
                onError: this.handleError(iconUrl),
                src: iconUrl
            })
        });
    }
}
const $674e157355a70f21$export$f89e53ba6fc8a5c5 = (a)=>(key, app)=>{
        switch(a){
            case 'key':
                return key();
            case 'app':
                return app();
            default:
                throw (0, $gC8Po.default).unexpectedCase(a);
        }
    };

});

parcelRegister("7GLYA", function(module, exports) {

$parcel$export(module.exports, "getIconUrl", () => $5991abbeb1b19d28$export$89d1c740383224f4);
$parcel$export(module.exports, "getFallbackIconUrl", () => $5991abbeb1b19d28$export$4170fc8c398d9d2c);
$parcel$export(module.exports, "getIconType", () => $5991abbeb1b19d28$export$6fa311f7baf2e348);
const $5991abbeb1b19d28$export$89d1c740383224f4 = (_ref)=>{
    let { origin: origin, appKey: appKey, appIconLink: appIconLink } = _ref;
    if (origin === 'token') return null;
    return appIconLink.expand({
        appKey: appKey
    });
};
const $5991abbeb1b19d28$export$4170fc8c398d9d2c = (origin, icon)=>origin === 'token' ? null : icon;
const $5991abbeb1b19d28$export$6fa311f7baf2e348 = (origin)=>origin === 'token' ? 'key' : 'app';

});


parcelRegister("j7LzR", function(module, exports) {

$parcel$export(module.exports, "default", () => $dec393a580e7f403$export$2e2bcd8739ae039);

var $gwoWU = parcelRequire("gwoWU");

var $ammkg = parcelRequire("ammkg");
parcelRequire("eUqFw");

var $5YcrV = parcelRequire("5YcrV");

var $3ihpf = parcelRequire("3ihpf");

var $lHkHI = parcelRequire("lHkHI");
/**
 * Renders either the "Cloud Fortified" or "Cloud Security Participant" badge,
 * whichever is applicable, with preference to the former when both are applicable.
 */ const $dec393a580e7f403$var$HeaderCertificationBadge = (props)=>{
    if (props.isAppCloudFortified) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5YcrV.default), {
        showLabel: true,
        source: (0, $5YcrV.CloudFortifiedAppBadgeSources).AppListing,
        showAetherAppListingPage: props.showAetherAppListingPage
    });
    if ((0, $gwoWU.isBugBountyParticipant)((0, $ammkg.AtlassianProductHostingType).Cloud, props.bugBountyParticipant)) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3ihpf.default), {
        showLabel: true,
        showAetherAppListingPage: props.showAetherAppListingPage
    });
    return null;
};
var $dec393a580e7f403$export$2e2bcd8739ae039 = $dec393a580e7f403$var$HeaderCertificationBadge;

});

parcelRegister("fm8vZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2df83f853b691f7$export$2e2bcd8739ae039);
/* HeaderLozenges.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $j8E8v = parcelRequire("j8E8v");

var $9l6Pq = parcelRequire("9l6Pq");

var $4lmb9 = parcelRequire("4lmb9");

var $7BUhe = parcelRequire("7BUhe");

var $6B6gX = parcelRequire("6B6gX");

var $lHkHI = parcelRequire("lHkHI");
const $b2df83f853b691f7$var$_excluded = [
    "as",
    "style"
];
function $b2df83f853b691f7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b2df83f853b691f7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b2df83f853b691f7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b2df83f853b691f7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $b2df83f853b691f7$var$heightReveal = null;
const $b2df83f853b691f7$export$279fee4a49024e55 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "li", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $b2df83f853b691f7$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b2df83f853b691f7$var$_objectSpread($b2df83f853b691f7$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _kqswh2mm _y44v1bgx",
            __cmplp.className
        ])
    }));
});
const $b2df83f853b691f7$export$135bdaed9fa67b45 = (_ref2)=>{
    let { lozenge: lozenge } = _ref2;
    const { label: label, isBold: isBold = false, appearance: appearance = 'default', tooltipContent: tooltipContent = null } = lozenge;
    const { enableAetherAppListingPage: enableAetherAppListingPage } = (0, $9l6Pq.useStatsig)();
    const showAetherAppListingPage = enableAetherAppListingPage();
    const ListItem = showAetherAppListingPage && !window.__INITIAL_STATE__ ? $b2df83f853b691f7$export$279fee4a49024e55 : 'li';
    const lozengeContent = /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j8E8v.default), {
        appearance: appearance,
        isBold: isBold,
        children: label
    });
    if (tooltipContent) return /*#__PURE__*/ (0, $lHkHI.jsx)(ListItem, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4lmb9.default), {
            content: tooltipContent,
            children: lozengeContent
        })
    }, label);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(ListItem, {
        children: lozengeContent
    }, label);
};
const $b2df83f853b691f7$var$HeaderLozenges = (_ref3)=>{
    let { lozenges: lozenges } = _ref3;
    if (!lozenges.length) return null;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6B6gX.LozengeList), {
        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_LOZENGES,
        children: lozenges.map((lozenge)=>/*#__PURE__*/ (0, $lHkHI.jsx)($b2df83f853b691f7$export$135bdaed9fa67b45, {
                lozenge: lozenge
            }, lozenge.label))
    });
};
var $b2df83f853b691f7$export$2e2bcd8739ae039 = $b2df83f853b691f7$var$HeaderLozenges;

});
parcelRegister("6B6gX", function(module, exports) {

$parcel$export(module.exports, "LozengeList", () => $4cdb105806814b10$export$949aeb67ba4cfcde);
/* HeaderLozenges.styles.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lHkHI = parcelRequire("lHkHI");
const $4cdb105806814b10$var$_excluded = [
    "as",
    "style"
];
function $4cdb105806814b10$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4cdb105806814b10$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4cdb105806814b10$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4cdb105806814b10$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4cdb105806814b10$export$949aeb67ba4cfcde = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "ul", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $4cdb105806814b10$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $4cdb105806814b10$var$_objectSpread($4cdb105806814b10$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_qtt8glyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _4cvr1h6o _1bahv2br _1n261g80 _qwjmweh0 _1az0idpf",
            __cmplp.className
        ])
    }));
});

});


parcelRegister("fmcsZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2e294b495c93414$export$2e2bcd8739ae039);

var $d4qUE = parcelRequire("d4qUE");

var $FHhXl = parcelRequire("FHhXl");

var $KC0XU = parcelRequire("KC0XU");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $j0vr1 = parcelRequire("j0vr1");

var $c9Mth = parcelRequire("c9Mth");
var $g01ln = parcelRequire("g01ln");
parcelRequire("eUqFw");

var $dM9ZW = parcelRequire("dM9ZW");

var $1JvFV = parcelRequire("1JvFV");

var $lHkHI = parcelRequire("lHkHI");
const $b2e294b495c93414$var$pressableStyles = (0, $d4qUE.xcss)({
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered'
    },
    ':active': {
        backgroundColor: 'color.background.neutral.subtle.pressed'
    },
    borderRadius: 'border.radius.100',
    paddingLeft: 'space.0',
    paddingRight: 'space.0'
});
const $b2e294b495c93414$var$HeaderRatings = (props)=>{
    const history = (0, $dM9ZW.useHistory)();
    const { appRatingLink: appRatingLink, openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab, appKey: appKey, ratings: ratings, showAetherAppListingPage: showAetherAppListingPage } = props;
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const onRatingsClick = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.LinkClickedEvent),
            actionSubjectId: (0, $1JvFV.ANALYTICS_SUBJECT_ID_RATINGS)
        });
        if (openMarketplaceLinksInNewTab) {
            const appReviewsUrl = appRatingLink.expand({
                appKey: appKey
            });
            (0, $g01ln).openPage(appReviewsUrl, '_blank');
        } else history === null || history === void 0 || history.push((0, $c9Mth).updateQueryParam(window.location.href, 'tab', 'reviews'));
    };
    if (showAetherAppListingPage) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $FHhXl.default), {
        xcss: $b2e294b495c93414$var$pressableStyles,
        backgroundColor: "color.background.neutral.subtle",
        onClick: onRatingsClick,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j0vr1.Ratings), {
            ratings: ratings,
            testId: "app-header-ratings",
            showNoRatingsMessage: true,
            boldAverageStars: true
        })
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $KC0XU.default), {
        ratings: ratings,
        onClick: ratings.numRatings ? onRatingsClick : undefined
    });
};
var $b2e294b495c93414$export$2e2bcd8739ae039 = $b2e294b495c93414$var$HeaderRatings;

});
parcelRegister("g01ln", function(module, exports) {

$parcel$export(module.exports, "TOP_WINDOW", () => $ba5db0425d554fd3$export$f90ae0252d3d8848);
$parcel$export(module.exports, "BLANK_WINDOW", () => $ba5db0425d554fd3$export$ccc35a87fa5a77);
$parcel$export(module.exports, "SELF_WINDOW", () => $ba5db0425d554fd3$export$96ffa9b89b9d7be1);
$parcel$export(module.exports, "PARENT_WINDOW", () => $ba5db0425d554fd3$export$b8a3742426ce0d81);
$parcel$export(module.exports, "openPage", () => $ba5db0425d554fd3$export$af53621bd3f7dae0);
$parcel$export(module.exports, "redirectTo", () => $ba5db0425d554fd3$export$2d47ce6f15e624e5);
const $ba5db0425d554fd3$export$f90ae0252d3d8848 = '_top';
const $ba5db0425d554fd3$export$ccc35a87fa5a77 = '_blank';
const $ba5db0425d554fd3$export$96ffa9b89b9d7be1 = '_self';
const $ba5db0425d554fd3$export$b8a3742426ce0d81 = '_parent';
function $ba5db0425d554fd3$export$af53621bd3f7dae0(url, windowName) {
    window.open(url, windowName);
}
const $ba5db0425d554fd3$export$2d47ce6f15e624e5 = (url)=>{
    window.location.href = url;
};

});


parcelRegister("eoMJc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a7b91af0690e0cd9$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $ivTMz = parcelRequire("ivTMz");

var $j0gMm = parcelRequire("j0gMm");

var $l2WWm = parcelRequire("l2WWm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");
parcelRequire("eUqFw");

var $7BUhe = parcelRequire("7BUhe");

var $lHkHI = parcelRequire("lHkHI");
function $a7b91af0690e0cd9$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a7b91af0690e0cd9$export$9ad0f767bf8dc483 = 'staffPickTooltip';
const $a7b91af0690e0cd9$export$1d0daa2d189cdf35 = (0, $3UXZ8.default)("div", {
    target: "e17z47mm0",
    label: "StaffPickBadgeText"
})("box-sizing:border-box;font-family:", (0, $ivTMz.fontFamily)(), ";font-size:10px;font-style:normal;font-weight:600;line-height:14px;padding:0px var(--ds-space-050, 4px);margin:1px 0px;border-radius:3px;white-space:nowrap;background:var(--ds-background-accent-purple-bolder, #6E5DC6);color:", "var(--ds-text-inverse, ".concat((0, $j0gMm.N0), ")"), ";");
const $a7b91af0690e0cd9$export$b4d75f17f7229fb1 = (0, $3UXZ8.default)("div", {
    target: "e17z47mm1",
    label: "StaffPickBadgeContainer"
})({
    name: "18e8814",
    styles: "display:inline-block;position:absolute;transform:translate(0,50%);margin-left:var(--ds-space-100, 8px);"
});
const $a7b91af0690e0cd9$var$StaffPickBadge = ()=>{
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const onToolTipShow = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.TooltipViewedEvent),
            actionSubjectId: $a7b91af0690e0cd9$export$9ad0f767bf8dc483
        });
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)($a7b91af0690e0cd9$export$b4d75f17f7229fb1, {
        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_STAFF_PICK,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l2WWm.default), {
            onShow: onToolTipShow,
            content: "Apps picked quarterly to suit your dynamic needs",
            children: /*#__PURE__*/ (0, $lHkHI.jsx)($a7b91af0690e0cd9$export$1d0daa2d189cdf35, {
                children: "STAFF PICK"
            })
        })
    });
};
var $a7b91af0690e0cd9$export$2e2bcd8739ae039 = $a7b91af0690e0cd9$var$StaffPickBadge;

});


parcelRegister("cSibF", function(module, exports) {

$parcel$export(module.exports, "default", () => $95f8a2cb2d9a9d4c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $j8E8v = parcelRequire("j8E8v");

var $7zMlx = parcelRequire("7zMlx");
var $bQ6DK = parcelRequire("bQ6DK");
var $gtpta = parcelRequire("gtpta");
var $ewzHc = parcelRequire("ewzHc");
parcelRequire("eUqFw");

var $fj13L = parcelRequire("fj13L");

var $lHkHI = parcelRequire("lHkHI");
function $95f8a2cb2d9a9d4c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $95f8a2cb2d9a9d4c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $95f8a2cb2d9a9d4c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $95f8a2cb2d9a9d4c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $95f8a2cb2d9a9d4c$export$3e41faf802a29e71 = (_ref)=>{
    let { children: children, testId: testId } = _ref;
    const tabAttributes = (0, $ewzHc.useTab)();
    return /*#__PURE__*/ (0, $lHkHI.jsx)("div", $95f8a2cb2d9a9d4c$var$_objectSpread($95f8a2cb2d9a9d4c$var$_objectSpread({}, tabAttributes), {}, {
        "data-testid": testId,
        children: children
    }));
};
const $95f8a2cb2d9a9d4c$var$TabLozenge = (_ref2)=>{
    let { appearance: appearance, label: label } = _ref2;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fj13L.StyledLozenge), {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j8E8v.default), {
            appearance: appearance,
            children: label
        })
    });
};
function $95f8a2cb2d9a9d4c$export$2e2bcd8739ae039(props) {
    const openTabs = props.tabs;
    const selectedTabIndex = typeof props.selected === 'number' ? props.selected : props.tabs.findIndex((tab)=>tab.key === props.selected);
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            props === null || props === void 0 ? void 0 : props.afterTabs,
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fj13L.HorizontalScrollShadow), {}),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $7zMlx.default), {
                id: props.id,
                testId: props.testId,
                selected: selectedTabIndex,
                onChange: (tabIndex)=>props.onChange(props.tabs[tabIndex]),
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fj13L.TabListContainer), {
                        showAetherAppListingPage: props.showAetherAppListingPage,
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bQ6DK.default), {
                            children: openTabs.map((tab)=>/*#__PURE__*/ (0, $lHkHI.jsxs)($95f8a2cb2d9a9d4c$export$3e41faf802a29e71, {
                                    testId: tab.testId,
                                    children: [
                                        tab.label,
                                        !!tab.lozenge && /*#__PURE__*/ (0, $lHkHI.jsx)($95f8a2cb2d9a9d4c$var$TabLozenge, $95f8a2cb2d9a9d4c$var$_objectSpread({}, tab.lozenge))
                                    ]
                                }, tab.key))
                        })
                    }),
                    props.tabs.map((tab)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $gtpta.default), {
                            children: tab.content
                        }, tab.key))
                ]
            })
        ]
    });
}

});
parcelRegister("7zMlx", function(module, exports) {

$parcel$export(module.exports, "default", () => $7346fedb0a424fbc$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $2MblP = parcelRequire("2MblP");

var $4I1uG = parcelRequire("4I1uG");

var $MHj67 = parcelRequire("MHj67");
function $7346fedb0a424fbc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $7346fedb0a424fbc$var$baseStyles = {
    name: "7i0hsw",
    styles: "display:flex;max-width:100%;min-height:0%;flex-basis:100%;flex-direction:column;flex-grow:1"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $7346fedb0a424fbc$var$tabsStyles = (0, $MHj67.getTabsStyles)();
const $7346fedb0a424fbc$var$analyticsAttributes = {
    componentName: 'tabs',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $7346fedb0a424fbc$var$getTabPanelWithContext = ({ tabPanel: tabPanel, index: index, isSelected: isSelected, tabsId: tabsId })=>// Ensure tabPanel exists in case it has been removed
    tabPanel && /*#__PURE__*/ (0, $byn9U.jsx)((0, $4I1uG.TabPanelContext).Provider, {
        value: {
            role: 'tabpanel',
            id: `${tabsId}-${index}-tab`,
            hidden: isSelected ? undefined : true,
            'aria-labelledby': `${tabsId}-${index}`,
            tabIndex: isSelected ? 0 : -1
        },
        key: index
    }, tabPanel);
/**
 * __Tabs__
 *
 * Tabs acts as a container for all Tab components.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $7346fedb0a424fbc$var$Tabs = (props)=>{
    const { shouldUnmountTabPanelOnChange: shouldUnmountTabPanelOnChange = false, selected: SelectedType, defaultSelected: defaultSelected, onChange: onChangeProp, id: id, analyticsContext: analyticsContext, children: children, testId: testId } = props;
    const [selectedState, setSelected] = (0, $eUqFw.useState)(SelectedType || defaultSelected || 0);
    const selected = SelectedType === undefined ? selectedState : SelectedType;
    const childrenArray = (0, $eUqFw.Children).toArray(children)// Don't include any conditional children
    .filter((child)=>Boolean(child));
    // First child should be a tabList followed by tab panels
    const [tabList, ...tabPanels] = childrenArray;
    // Keep track of visited and add to a set
    const visited = (0, $eUqFw.useRef)(new Set([
        selected
    ]));
    if (!visited.current.has(selected)) visited.current.add(selected);
    const onChange = (0, $eUqFw.useCallback)((index, analyticsEvent)=>{
        if (onChangeProp) onChangeProp(index, analyticsEvent);
        setSelected(index);
    }, [
        onChangeProp
    ]);
    const onChangeAnalytics = (0, $2MblP.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'clicked',
        analyticsData: analyticsContext,
        ...$7346fedb0a424fbc$var$analyticsAttributes
    });
    const tabPanelsWithContext = shouldUnmountTabPanelOnChange ? $7346fedb0a424fbc$var$getTabPanelWithContext({
        tabPanel: tabPanels[selected],
        index: selected,
        isSelected: true,
        tabsId: id
    }) : // If a panel has already been visited, don't unmount it
    Array.from(visited.current).map((tabIndex)=>$7346fedb0a424fbc$var$getTabPanelWithContext({
            tabPanel: tabPanels[tabIndex],
            index: tabIndex,
            isSelected: tabIndex === selected,
            tabsId: id
        }));
    return(// Only styles that affect the Tabs container itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTabPanel(),
    // which applies accessibility attributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $7346fedb0a424fbc$var$baseStyles,
            $7346fedb0a424fbc$var$tabsStyles
        ]
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $4I1uG.TabListContext).Provider, {
        value: {
            selected: selected,
            onChange: onChangeAnalytics,
            tabsId: id
        }
    }, tabList), /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, tabPanelsWithContext)));
};
var $7346fedb0a424fbc$export$2e2bcd8739ae039 = $7346fedb0a424fbc$var$Tabs;

});
parcelRegister("4I1uG", function(module, exports) {

$parcel$export(module.exports, "TabContext", () => $a740d1e059b0717c$export$5a5d356ca5f10a0a);
$parcel$export(module.exports, "TabListContext", () => $a740d1e059b0717c$export$aa6907f9fd69e93b);
$parcel$export(module.exports, "TabPanelContext", () => $a740d1e059b0717c$export$2054129d247c3102);
/* eslint-disable @repo/internal/react/require-jsdoc */ 
var $eUqFw = parcelRequire("eUqFw");
const $a740d1e059b0717c$export$5a5d356ca5f10a0a = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $a740d1e059b0717c$export$aa6907f9fd69e93b = /*#__PURE__*/ (0, $eUqFw.createContext)(null);
const $a740d1e059b0717c$export$2054129d247c3102 = /*#__PURE__*/ (0, $eUqFw.createContext)(null);

});

parcelRegister("MHj67", function(module, exports) {

$parcel$export(module.exports, "getTabsStyles", () => $895458f0e27b90a1$export$dd5afd2190fb792c);
$parcel$export(module.exports, "getTabListStyles", () => $895458f0e27b90a1$export$42a3c683c377bcb2);
$parcel$export(module.exports, "getTabListStylesOld", () => $895458f0e27b90a1$export$f208f8acf591dbc2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");

var $khDqy = parcelRequire("khDqy");
const $895458f0e27b90a1$var$tabInlinePadding = "var(--ds-space-100, 8px)";
const $895458f0e27b90a1$var$tabBlockPadding = "var(--ds-space-075, 6px)";
const $895458f0e27b90a1$var$tabInlineMargin = "var(--ds-space-negative-100, -8px)";
// TODO this should probably be `border.width.indicator`
const $895458f0e27b90a1$var$underlineHeight = "var(--ds-border-width-outline, 2px)";
const $895458f0e27b90a1$var$getTabPanelStyles = ()=>({
        flexGrow: 1,
        /*
     NOTE min-height set to 0% because of Firefox bug
     FF http://stackoverflow.com/questions/28636832/firefox-overflow-y-not-working-with-nested-flexbox
   */ minHeight: '0%',
        display: 'flex'
    });
const $895458f0e27b90a1$export$dd5afd2190fb792c = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tabpanel"]': $895458f0e27b90a1$var$getTabPanelStyles(),
        // The hidden attribute doesn't work on flex elements
        // Change display to be none
        // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > [hidden]': {
            display: 'none'
        }
    });
const $895458f0e27b90a1$var$tabLineStyles = {
    content: '""',
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $895458f0e27b90a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $895458f0e27b90a1$export$42a3c683c377bcb2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $895458f0e27b90a1$export$916c8b0fccbb37d2(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $895458f0e27b90a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$895458f0e27b90a1$var$tabLineStyles,
            height: "var(--ds-border-width, 1px)",
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $khDqy.tabLineColors).lineColor
        }
    });
const $895458f0e27b90a1$export$916c8b0fccbb37d2 = ()=>{
    const colors = (0, $khDqy.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$895458f0e27b90a1$var$tabBlockPadding} ${$895458f0e27b90a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$895458f0e27b90a1$var$tabLineStyles,
                insetInlineEnd: $895458f0e27b90a1$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $khDqy.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$895458f0e27b90a1$var$tabLineStyles,
                insetInlineEnd: $895458f0e27b90a1$var$tabInlinePadding,
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $khDqy.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$895458f0e27b90a1$var$tabLineStyles,
                insetInlineEnd: $895458f0e27b90a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${"var(--ds-border-width-indicator, 3px)"} solid ${(0, $khDqy.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};
const $895458f0e27b90a1$var$tabLineStylesOld = {
    content: '""',
    borderRadius: "var(--ds-border-radius-050, 2px)",
    bottom: 0,
    margin: 0,
    position: 'absolute',
    width: 'inherit',
    insetInlineStart: $895458f0e27b90a1$var$tabInlinePadding,
    insetInlineEnd: 0
};
const $895458f0e27b90a1$export$f208f8acf591dbc2 = ()=>/*#__PURE__*/ // eslint-disable-next-line @repo/internal/styles/no-exported-styles
    (0, $byn9U.css)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        '& [role="tab"]': $895458f0e27b90a1$export$442d081208938078(),
        fontWeight: "var(--ds-font-weight-medium, 500)",
        marginInlineStart: $895458f0e27b90a1$var$tabInlineMargin,
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            ...$895458f0e27b90a1$var$tabLineStylesOld,
            height: $895458f0e27b90a1$var$underlineHeight,
            // This line is not a border so the selected line is visible in high contrast mode
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $khDqy.tabLineColors).lineColor
        }
    });
const $895458f0e27b90a1$export$442d081208938078 = ()=>{
    const colors = (0, $khDqy.tabColors);
    return {
        color: colors.labelColor,
        cursor: 'pointer',
        margin: 0,
        padding: `${$895458f0e27b90a1$var$tabBlockPadding} ${$895458f0e27b90a1$var$tabInlinePadding}`,
        position: 'relative',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        '&:hover': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.hoverLabelColor,
            '&::after': {
                ...$895458f0e27b90a1$var$tabLineStylesOld,
                insetInlineEnd: $895458f0e27b90a1$var$tabInlinePadding,
                borderBottom: `${$895458f0e27b90a1$var$underlineHeight} solid ${(0, $khDqy.tabLineColors).hoveredColor}`,
                height: 0
            }
        },
        '&:active': {
            // TODO: interaction states will be reviewed in DSP-1438
            color: colors.activeLabelColor,
            '&::after': {
                ...$895458f0e27b90a1$var$tabLineStylesOld,
                insetInlineEnd: $895458f0e27b90a1$var$tabInlinePadding,
                borderBottom: `${$895458f0e27b90a1$var$underlineHeight} solid ${(0, $khDqy.tabLineColors).activeColor}`,
                height: 0
            }
        },
        '&[aria-selected="true"]': {
            color: colors.selectedColor,
            '&::after': {
                ...$895458f0e27b90a1$var$tabLineStylesOld,
                insetInlineEnd: $895458f0e27b90a1$var$tabInlinePadding,
                // This line is a border so it is visible in high contrast mode
                borderBottom: `${$895458f0e27b90a1$var$underlineHeight} solid ${(0, $khDqy.tabLineColors).selectedColor}`,
                height: 0
            }
        }
    };
};

});
parcelRegister("khDqy", function(module, exports) {

$parcel$export(module.exports, "tabColors", () => $5f6b4f29507ba977$export$5159a1ad8efe50bc);
$parcel$export(module.exports, "tabLineColors", () => $5f6b4f29507ba977$export$6be6fa4649b31472);

const $5f6b4f29507ba977$export$5159a1ad8efe50bc = {
    labelColor: `var(--ds-text-subtle, ${(0, $ab6d6432a4c55680$export$c39c0fe0f26207ae)})`,
    activeLabelColor: `var(--ds-text, ${(0, $ab6d6432a4c55680$export$a6ee3d71bc067634)})`,
    hoverLabelColor: `var(--ds-text-subtle, ${(0, $ab6d6432a4c55680$export$b3de0ae08da2ce64)})`,
    selectedColor: `var(--ds-text-selected, ${(0, $ab6d6432a4c55680$export$b3de0ae08da2ce64)})`,
    focusBorderColor: `var(--ds-border-focused, ${(0, $ab6d6432a4c55680$export$ecfc1dff386a3e7a)})`
};
const $5f6b4f29507ba977$export$6be6fa4649b31472 = {
    lineColor: `var(--ds-border, ${(0, $ab6d6432a4c55680$export$3e51e8f1440314ba)})`,
    hoveredColor: "var(--ds-border, transparent)",
    activeColor: "var(--ds-border, transparent)",
    selectedColor: `var(--ds-border-selected, ${(0, $ab6d6432a4c55680$export$b3de0ae08da2ce64)})`
};

});



parcelRegister("bQ6DK", function(module, exports) {

$parcel$export(module.exports, "default", () => $2061ce9079605ea4$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $3puyA = parcelRequire("3puyA");

var $ewzHc = parcelRequire("ewzHc");

var $4I1uG = parcelRequire("4I1uG");

var $MHj67 = parcelRequire("MHj67");
function $2061ce9079605ea4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2061ce9079605ea4$var$baseStyles = {
    name: "g0wsdz",
    styles: "display:flex;padding:var(--ds-space-0, 0px);position:relative"
};
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $2061ce9079605ea4$var$tabListStyles = (0, $MHj67.getTabListStyles)();
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
const $2061ce9079605ea4$var$tabListStylesOld = (0, $MHj67.getTabListStylesOld)();
/**
 * __TabList__
 *
 * A TabList groups `Tab` components together.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $2061ce9079605ea4$var$TabList = ({ children: children })=>{
    const { tabsId: tabsId, selected: selected, onChange: onChange } = (0, $ewzHc.useTabList)();
    const ref = /*#__PURE__*/ (0, $eUqFw.createRef)();
    // Don't include any conditional children
    const childrenArray = (0, $eUqFw.Children).toArray(children).filter(Boolean);
    const length = childrenArray.length;
    const selectTabByIndex = (0, $eUqFw.useCallback)((index)=>{
        const newSelectedNode = ref.current?.querySelector(`[id='${tabsId}-${index}']`);
        if (newSelectedNode) newSelectedNode.focus();
        onChange(index);
    }, [
        tabsId,
        ref,
        onChange
    ]);
    const onKeyDown = (0, $eUqFw.useCallback)((e)=>{
        if (![
            'ArrowRight',
            'ArrowLeft',
            'Home',
            'End'
        ].includes(e.key)) return;
        // preventing horizontal or vertical scroll
        e.preventDefault();
        const lastTabIndex = length - 1;
        if ([
            'Home',
            'End'
        ].includes(e.key)) {
            const newSelected = e.key === 'Home' ? 0 : lastTabIndex;
            selectTabByIndex(newSelected);
            return;
        }
        // We use aria-posinset so we don't rely on the selected variable
        // If we used the selected variable this would regenerate each time
        // and create an unstable reference
        const selectedIndex = parseInt(e.currentTarget.getAttribute('aria-posinset') || '0') - 1;
        const modifier = e.key === 'ArrowRight' ? 1 : -1;
        let newSelected = selectedIndex + modifier;
        if (newSelected < 0 || newSelected >= length) // Cycling focus to move from last to first and from first to last
        newSelected = newSelected < 0 ? lastTabIndex : 0;
        selectTabByIndex(newSelected);
    }, [
        length,
        selectTabByIndex
    ]);
    // Memoized so the function isn't recreated each time
    const getTabWithContext = (0, $eUqFw.useCallback)(({ tab: tab, isSelected: isSelected, index: index })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $4I1uG.TabContext).Provider, {
            value: {
                onClick: ()=>onChange(index),
                onKeyDown: onKeyDown,
                'aria-setsize': length,
                role: 'tab',
                id: `${tabsId}-${index}`,
                'aria-posinset': index + 1,
                'aria-selected': isSelected,
                'aria-controls': `${tabsId}-${index}-tab`,
                tabIndex: isSelected ? 0 : -1
            },
            key: index
        }, tab), [
        length,
        onKeyDown,
        onChange,
        tabsId
    ]);
    return(// Only styles that affect the TabList itself have been applied via primitives.
    // The other styles applied through the CSS prop are there for styling children
    // through inheritance. This is important for custom cases that use the useTab(),
    // which applies accessibility atributes that we use as a styling hook.
    /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        role: "tablist",
        ref: ref,
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        css: [
            $2061ce9079605ea4$var$baseStyles,
            (0, $3puyA.fg)('platform-component-visual-refresh') ? $2061ce9079605ea4$var$tabListStyles : $2061ce9079605ea4$var$tabListStylesOld
        ]
    }, childrenArray.map((child, index)=>getTabWithContext({
            tab: child,
            index: index,
            isSelected: index === selected
        }))));
};
var $2061ce9079605ea4$export$2e2bcd8739ae039 = $2061ce9079605ea4$var$TabList;

});
parcelRegister("ewzHc", function(module, exports) {

$parcel$export(module.exports, "useTab", () => $41e4e74f188485f4$export$fdf4756d5b8ef90a);
$parcel$export(module.exports, "useTabList", () => $41e4e74f188485f4$export$773e389e644c5874);
$parcel$export(module.exports, "useTabPanel", () => $41e4e74f188485f4$export$fae0121b5afe572d);

var $eUqFw = parcelRequire("eUqFw");

var $4I1uG = parcelRequire("4I1uG");
const $41e4e74f188485f4$export$fdf4756d5b8ef90a = ()=>{
    const tabData = (0, $eUqFw.useContext)((0, $4I1uG.TabContext));
    if (tabData == null || typeof tabData === 'undefined') throw Error('@atlaskit/tabs: A Tab must have a TabList parent.');
    return tabData;
};
const $41e4e74f188485f4$export$773e389e644c5874 = ()=>{
    const tabListData = (0, $eUqFw.useContext)((0, $4I1uG.TabListContext));
    if (tabListData === null || typeof tabListData === 'undefined') throw Error('@atlaskit/tabs: A TabList must have a Tabs parent.');
    return tabListData;
};
const $41e4e74f188485f4$export$fae0121b5afe572d = ()=>{
    const tabPanelData = (0, $eUqFw.useContext)((0, $4I1uG.TabPanelContext));
    if (tabPanelData === null || typeof tabPanelData === 'undefined') throw Error('@atlaskit/tabs:  A TabPanel must have a Tabs parent.');
    return tabPanelData;
};

});


parcelRegister("gtpta", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a3992bd8b0499d1$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jljCj = parcelRequire("jljCj");

var $ewzHc = parcelRequire("ewzHc");
// Note this is not being memoized as children is an unstable reference
/**
 * __TabPanel__
 *
 * A TabPanel houses the contents of a Tab.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $1a3992bd8b0499d1$var$TabPanel = ({ children: children, testId: testId })=>{
    const { role: role, id: id, hidden: hidden, 'aria-labelledby': ariaLabelledBy, tabIndex: tabIndex } = (0, $ewzHc.useTabPanel)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jljCj.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        role: role,
        id: id,
        hidden: hidden,
        "aria-labelledby": ariaLabelledBy,
        tabIndex: tabIndex
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $eUqFw.Fragment), null, children)));
};
var $1a3992bd8b0499d1$export$2e2bcd8739ae039 = $1a3992bd8b0499d1$var$TabPanel;

});

parcelRegister("fj13L", function(module, exports) {

$parcel$export(module.exports, "TabListContainer", () => $b24973cdedbc9508$export$7b1df4f82882d011);
$parcel$export(module.exports, "HorizontalScrollShadow", () => $b24973cdedbc9508$export$5d6c88ddd8cbd2ce);
$parcel$export(module.exports, "StyledLozenge", () => $b24973cdedbc9508$export$fb418b53e6535057);
/* ResponsiveTabs.styles.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $9wSVK = parcelRequire("9wSVK");

var $lHkHI = parcelRequire("lHkHI");
const $b24973cdedbc9508$var$_excluded = [
    "as",
    "style"
], $b24973cdedbc9508$var$_excluded2 = [
    "showAetherAppListingPage"
], $b24973cdedbc9508$var$_excluded3 = [
    "as",
    "style"
], $b24973cdedbc9508$var$_excluded4 = [
    "as",
    "style"
];
function $b24973cdedbc9508$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b24973cdedbc9508$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b24973cdedbc9508$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b24973cdedbc9508$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $b24973cdedbc9508$export$7b1df4f82882d011 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $b24973cdedbc9508$var$_excluded);
    const { showAetherAppListingPage: showAetherAppListingPage } = __cmplp, __cmpldp = (0, $bwPfh.default)(__cmplp, $b24973cdedbc9508$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b24973cdedbc9508$var$_objectSpread($b24973cdedbc9508$var$_objectSpread({}, __cmpldp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo1wug _8am5i4x0 _1fjgglyw _15peidpf _1f6t1ns9 _xvmwljao _ux2c1txw _vz1a1h6o",
            __cmplp.showAetherAppListingPage ? "_tr9o1k92" : "_tr9oo1fv",
            __cmplp.showAetherAppListingPage ? "_rwqn1akh" : "_rwqn1inc",
            __cmplp.showAetherAppListingPage ? "_j67zyn4p" : "_j67z1wug",
            __cmplp.showAetherAppListingPage ? "_121z1pd9" : "_121zi7a9",
            __cmplp.showAetherAppListingPage ? "_1jru1akh" : "_1jru1fhj",
            __cmplp.showAetherAppListingPage ? "_ibqn1eps" : "_ibqnidpf",
            __cmplp.showAetherAppListingPage ? "_eonrhiv4" : "_eonridpf",
            __cmplp.showAetherAppListingPage ? "_5f8cxjmg" : "_5f8cidpf",
            __cmplp.className
        ])
    }));
});
const $b24973cdedbc9508$export$5d6c88ddd8cbd2ce = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $b24973cdedbc9508$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b24973cdedbc9508$var$_objectSpread($b24973cdedbc9508$var$_objectSpread({}, __cmplp), {}, {
        style: $b24973cdedbc9508$var$_objectSpread($b24973cdedbc9508$var$_objectSpread({}, __cmpls), {}, {
            "--_ux5vp5": (0, $9t7rW.default)((0, $9wSVK.default)('color.background.input') + 40)
        }),
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_11q71915 _4t3i8pqr _1bsb8pqr _lcxvglyw _kqswstnw _1xi2idpf _1pbycs5v _dm25glyw",
            __cmplp.className
        ])
    }));
});
const $b24973cdedbc9508$export$fb418b53e6535057 = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $b24973cdedbc9508$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $b24973cdedbc9508$var$_objectSpread($b24973cdedbc9508$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18u01eps _1e0c116y",
            __cmplp.className
        ])
    }));
});

});
parcelRegister("9wSVK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f01b6407b5f7a66$export$2e2bcd8739ae039);



var $eKiTB = parcelRequire("eKiTB");

var $2fFJv = parcelRequire("2fFJv");
/**
 * Takes a dot-separated token name and and an optional fallback, and returns the current computed CSS value for the
 * resulting CSS Custom Property.
 * This should be used for when the CSS cascade isn't available, eg. `<canvas>` elements, JS charting libraries, etc.
 *
 * Note: these values change depending on the theme so consider pairing them with `useThemeObserver` in React, or the
 * `ThemeMutationObserver` class elsewhere.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * const theme = useThemeObserver();
 *
 * useEffect(() => {
 *  const lineColor = getTokenValue('color.background.accent.blue.subtle', B400);
 * }, [theme]);
 * ```
 *
 */ function $6f01b6407b5f7a66$var$getTokenValue(tokenId, fallback = '') {
    let token = (0, $eKiTB.default)[tokenId];
    let tokenValue = fallback;
    typeof $2fFJv;
    if (typeof window === 'undefined') return tokenValue;
    tokenValue = window.getComputedStyle(document.documentElement).getPropertyValue(token).trim();
    tokenValue = tokenValue || fallback;
    return tokenValue;
}
var $6f01b6407b5f7a66$export$2e2bcd8739ae039 = $6f01b6407b5f7a66$var$getTokenValue;

});
parcelRegister("eKiTB", function(module, exports) {

$parcel$export(module.exports, "default", () => $abc404e82cd59cca$export$2e2bcd8739ae039);
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::db26fca19e3969bcba2e77bc6fe6eb89>>
 * @codegenCommand yarn build tokens
 */ const $abc404e82cd59cca$var$tokens = {
    'color.text': '--ds-text',
    'color.text.accent.lime': '--ds-text-accent-lime',
    'color.text.accent.lime.bolder': '--ds-text-accent-lime-bolder',
    'color.text.accent.red': '--ds-text-accent-red',
    'color.text.accent.red.bolder': '--ds-text-accent-red-bolder',
    'color.text.accent.orange': '--ds-text-accent-orange',
    'color.text.accent.orange.bolder': '--ds-text-accent-orange-bolder',
    'color.text.accent.yellow': '--ds-text-accent-yellow',
    'color.text.accent.yellow.bolder': '--ds-text-accent-yellow-bolder',
    'color.text.accent.green': '--ds-text-accent-green',
    'color.text.accent.green.bolder': '--ds-text-accent-green-bolder',
    'color.text.accent.teal': '--ds-text-accent-teal',
    'color.text.accent.teal.bolder': '--ds-text-accent-teal-bolder',
    'color.text.accent.blue': '--ds-text-accent-blue',
    'color.text.accent.blue.bolder': '--ds-text-accent-blue-bolder',
    'color.text.accent.purple': '--ds-text-accent-purple',
    'color.text.accent.purple.bolder': '--ds-text-accent-purple-bolder',
    'color.text.accent.magenta': '--ds-text-accent-magenta',
    'color.text.accent.magenta.bolder': '--ds-text-accent-magenta-bolder',
    'color.text.accent.gray': '--ds-text-accent-gray',
    'color.text.accent.gray.bolder': '--ds-text-accent-gray-bolder',
    'color.text.disabled': '--ds-text-disabled',
    'color.text.inverse': '--ds-text-inverse',
    'color.text.selected': '--ds-text-selected',
    'color.text.brand': '--ds-text-brand',
    'color.text.danger': '--ds-text-danger',
    'color.text.warning': '--ds-text-warning',
    'color.text.warning.inverse': '--ds-text-warning-inverse',
    'color.text.success': '--ds-text-success',
    'color.text.discovery': '--ds-text-discovery',
    'color.text.information': '--ds-text-information',
    'color.text.subtlest': '--ds-text-subtlest',
    'color.text.subtle': '--ds-text-subtle',
    'color.link': '--ds-link',
    'color.link.pressed': '--ds-link-pressed',
    'color.link.visited': '--ds-link-visited',
    'color.link.visited.pressed': '--ds-link-visited-pressed',
    'color.icon': '--ds-icon',
    'color.icon.accent.lime': '--ds-icon-accent-lime',
    'color.icon.accent.red': '--ds-icon-accent-red',
    'color.icon.accent.orange': '--ds-icon-accent-orange',
    'color.icon.accent.yellow': '--ds-icon-accent-yellow',
    'color.icon.accent.green': '--ds-icon-accent-green',
    'color.icon.accent.teal': '--ds-icon-accent-teal',
    'color.icon.accent.blue': '--ds-icon-accent-blue',
    'color.icon.accent.purple': '--ds-icon-accent-purple',
    'color.icon.accent.magenta': '--ds-icon-accent-magenta',
    'color.icon.accent.gray': '--ds-icon-accent-gray',
    'color.icon.disabled': '--ds-icon-disabled',
    'color.icon.inverse': '--ds-icon-inverse',
    'color.icon.selected': '--ds-icon-selected',
    'color.icon.brand': '--ds-icon-brand',
    'color.icon.danger': '--ds-icon-danger',
    'color.icon.warning': '--ds-icon-warning',
    'color.icon.warning.inverse': '--ds-icon-warning-inverse',
    'color.icon.success': '--ds-icon-success',
    'color.icon.discovery': '--ds-icon-discovery',
    'color.icon.information': '--ds-icon-information',
    'color.icon.subtlest': '--ds-icon-subtlest',
    'color.icon.subtle': '--ds-icon-subtle',
    'color.border': '--ds-border',
    'color.border.accent.lime': '--ds-border-accent-lime',
    'color.border.accent.red': '--ds-border-accent-red',
    'color.border.accent.orange': '--ds-border-accent-orange',
    'color.border.accent.yellow': '--ds-border-accent-yellow',
    'color.border.accent.green': '--ds-border-accent-green',
    'color.border.accent.teal': '--ds-border-accent-teal',
    'color.border.accent.blue': '--ds-border-accent-blue',
    'color.border.accent.purple': '--ds-border-accent-purple',
    'color.border.accent.magenta': '--ds-border-accent-magenta',
    'color.border.accent.gray': '--ds-border-accent-gray',
    'color.border.disabled': '--ds-border-disabled',
    'color.border.focused': '--ds-border-focused',
    'color.border.input': '--ds-border-input',
    'color.border.inverse': '--ds-border-inverse',
    'color.border.selected': '--ds-border-selected',
    'color.border.brand': '--ds-border-brand',
    'color.border.danger': '--ds-border-danger',
    'color.border.warning': '--ds-border-warning',
    'color.border.success': '--ds-border-success',
    'color.border.discovery': '--ds-border-discovery',
    'color.border.information': '--ds-border-information',
    'color.border.bold': '--ds-border-bold',
    'color.background.accent.lime.subtlest': '--ds-background-accent-lime-subtlest',
    'color.background.accent.lime.subtlest.hovered': '--ds-background-accent-lime-subtlest-hovered',
    'color.background.accent.lime.subtlest.pressed': '--ds-background-accent-lime-subtlest-pressed',
    'color.background.accent.lime.subtler': '--ds-background-accent-lime-subtler',
    'color.background.accent.lime.subtler.hovered': '--ds-background-accent-lime-subtler-hovered',
    'color.background.accent.lime.subtler.pressed': '--ds-background-accent-lime-subtler-pressed',
    'color.background.accent.lime.subtle': '--ds-background-accent-lime-subtle',
    'color.background.accent.lime.subtle.hovered': '--ds-background-accent-lime-subtle-hovered',
    'color.background.accent.lime.subtle.pressed': '--ds-background-accent-lime-subtle-pressed',
    'color.background.accent.lime.bolder': '--ds-background-accent-lime-bolder',
    'color.background.accent.lime.bolder.hovered': '--ds-background-accent-lime-bolder-hovered',
    'color.background.accent.lime.bolder.pressed': '--ds-background-accent-lime-bolder-pressed',
    'color.background.accent.red.subtlest': '--ds-background-accent-red-subtlest',
    'color.background.accent.red.subtlest.hovered': '--ds-background-accent-red-subtlest-hovered',
    'color.background.accent.red.subtlest.pressed': '--ds-background-accent-red-subtlest-pressed',
    'color.background.accent.red.subtler': '--ds-background-accent-red-subtler',
    'color.background.accent.red.subtler.hovered': '--ds-background-accent-red-subtler-hovered',
    'color.background.accent.red.subtler.pressed': '--ds-background-accent-red-subtler-pressed',
    'color.background.accent.red.subtle': '--ds-background-accent-red-subtle',
    'color.background.accent.red.subtle.hovered': '--ds-background-accent-red-subtle-hovered',
    'color.background.accent.red.subtle.pressed': '--ds-background-accent-red-subtle-pressed',
    'color.background.accent.red.bolder': '--ds-background-accent-red-bolder',
    'color.background.accent.red.bolder.hovered': '--ds-background-accent-red-bolder-hovered',
    'color.background.accent.red.bolder.pressed': '--ds-background-accent-red-bolder-pressed',
    'color.background.accent.orange.subtlest': '--ds-background-accent-orange-subtlest',
    'color.background.accent.orange.subtlest.hovered': '--ds-background-accent-orange-subtlest-hovered',
    'color.background.accent.orange.subtlest.pressed': '--ds-background-accent-orange-subtlest-pressed',
    'color.background.accent.orange.subtler': '--ds-background-accent-orange-subtler',
    'color.background.accent.orange.subtler.hovered': '--ds-background-accent-orange-subtler-hovered',
    'color.background.accent.orange.subtler.pressed': '--ds-background-accent-orange-subtler-pressed',
    'color.background.accent.orange.subtle': '--ds-background-accent-orange-subtle',
    'color.background.accent.orange.subtle.hovered': '--ds-background-accent-orange-subtle-hovered',
    'color.background.accent.orange.subtle.pressed': '--ds-background-accent-orange-subtle-pressed',
    'color.background.accent.orange.bolder': '--ds-background-accent-orange-bolder',
    'color.background.accent.orange.bolder.hovered': '--ds-background-accent-orange-bolder-hovered',
    'color.background.accent.orange.bolder.pressed': '--ds-background-accent-orange-bolder-pressed',
    'color.background.accent.yellow.subtlest': '--ds-background-accent-yellow-subtlest',
    'color.background.accent.yellow.subtlest.hovered': '--ds-background-accent-yellow-subtlest-hovered',
    'color.background.accent.yellow.subtlest.pressed': '--ds-background-accent-yellow-subtlest-pressed',
    'color.background.accent.yellow.subtler': '--ds-background-accent-yellow-subtler',
    'color.background.accent.yellow.subtler.hovered': '--ds-background-accent-yellow-subtler-hovered',
    'color.background.accent.yellow.subtler.pressed': '--ds-background-accent-yellow-subtler-pressed',
    'color.background.accent.yellow.subtle': '--ds-background-accent-yellow-subtle',
    'color.background.accent.yellow.subtle.hovered': '--ds-background-accent-yellow-subtle-hovered',
    'color.background.accent.yellow.subtle.pressed': '--ds-background-accent-yellow-subtle-pressed',
    'color.background.accent.yellow.bolder': '--ds-background-accent-yellow-bolder',
    'color.background.accent.yellow.bolder.hovered': '--ds-background-accent-yellow-bolder-hovered',
    'color.background.accent.yellow.bolder.pressed': '--ds-background-accent-yellow-bolder-pressed',
    'color.background.accent.green.subtlest': '--ds-background-accent-green-subtlest',
    'color.background.accent.green.subtlest.hovered': '--ds-background-accent-green-subtlest-hovered',
    'color.background.accent.green.subtlest.pressed': '--ds-background-accent-green-subtlest-pressed',
    'color.background.accent.green.subtler': '--ds-background-accent-green-subtler',
    'color.background.accent.green.subtler.hovered': '--ds-background-accent-green-subtler-hovered',
    'color.background.accent.green.subtler.pressed': '--ds-background-accent-green-subtler-pressed',
    'color.background.accent.green.subtle': '--ds-background-accent-green-subtle',
    'color.background.accent.green.subtle.hovered': '--ds-background-accent-green-subtle-hovered',
    'color.background.accent.green.subtle.pressed': '--ds-background-accent-green-subtle-pressed',
    'color.background.accent.green.bolder': '--ds-background-accent-green-bolder',
    'color.background.accent.green.bolder.hovered': '--ds-background-accent-green-bolder-hovered',
    'color.background.accent.green.bolder.pressed': '--ds-background-accent-green-bolder-pressed',
    'color.background.accent.teal.subtlest': '--ds-background-accent-teal-subtlest',
    'color.background.accent.teal.subtlest.hovered': '--ds-background-accent-teal-subtlest-hovered',
    'color.background.accent.teal.subtlest.pressed': '--ds-background-accent-teal-subtlest-pressed',
    'color.background.accent.teal.subtler': '--ds-background-accent-teal-subtler',
    'color.background.accent.teal.subtler.hovered': '--ds-background-accent-teal-subtler-hovered',
    'color.background.accent.teal.subtler.pressed': '--ds-background-accent-teal-subtler-pressed',
    'color.background.accent.teal.subtle': '--ds-background-accent-teal-subtle',
    'color.background.accent.teal.subtle.hovered': '--ds-background-accent-teal-subtle-hovered',
    'color.background.accent.teal.subtle.pressed': '--ds-background-accent-teal-subtle-pressed',
    'color.background.accent.teal.bolder': '--ds-background-accent-teal-bolder',
    'color.background.accent.teal.bolder.hovered': '--ds-background-accent-teal-bolder-hovered',
    'color.background.accent.teal.bolder.pressed': '--ds-background-accent-teal-bolder-pressed',
    'color.background.accent.blue.subtlest': '--ds-background-accent-blue-subtlest',
    'color.background.accent.blue.subtlest.hovered': '--ds-background-accent-blue-subtlest-hovered',
    'color.background.accent.blue.subtlest.pressed': '--ds-background-accent-blue-subtlest-pressed',
    'color.background.accent.blue.subtler': '--ds-background-accent-blue-subtler',
    'color.background.accent.blue.subtler.hovered': '--ds-background-accent-blue-subtler-hovered',
    'color.background.accent.blue.subtler.pressed': '--ds-background-accent-blue-subtler-pressed',
    'color.background.accent.blue.subtle': '--ds-background-accent-blue-subtle',
    'color.background.accent.blue.subtle.hovered': '--ds-background-accent-blue-subtle-hovered',
    'color.background.accent.blue.subtle.pressed': '--ds-background-accent-blue-subtle-pressed',
    'color.background.accent.blue.bolder': '--ds-background-accent-blue-bolder',
    'color.background.accent.blue.bolder.hovered': '--ds-background-accent-blue-bolder-hovered',
    'color.background.accent.blue.bolder.pressed': '--ds-background-accent-blue-bolder-pressed',
    'color.background.accent.purple.subtlest': '--ds-background-accent-purple-subtlest',
    'color.background.accent.purple.subtlest.hovered': '--ds-background-accent-purple-subtlest-hovered',
    'color.background.accent.purple.subtlest.pressed': '--ds-background-accent-purple-subtlest-pressed',
    'color.background.accent.purple.subtler': '--ds-background-accent-purple-subtler',
    'color.background.accent.purple.subtler.hovered': '--ds-background-accent-purple-subtler-hovered',
    'color.background.accent.purple.subtler.pressed': '--ds-background-accent-purple-subtler-pressed',
    'color.background.accent.purple.subtle': '--ds-background-accent-purple-subtle',
    'color.background.accent.purple.subtle.hovered': '--ds-background-accent-purple-subtle-hovered',
    'color.background.accent.purple.subtle.pressed': '--ds-background-accent-purple-subtle-pressed',
    'color.background.accent.purple.bolder': '--ds-background-accent-purple-bolder',
    'color.background.accent.purple.bolder.hovered': '--ds-background-accent-purple-bolder-hovered',
    'color.background.accent.purple.bolder.pressed': '--ds-background-accent-purple-bolder-pressed',
    'color.background.accent.magenta.subtlest': '--ds-background-accent-magenta-subtlest',
    'color.background.accent.magenta.subtlest.hovered': '--ds-background-accent-magenta-subtlest-hovered',
    'color.background.accent.magenta.subtlest.pressed': '--ds-background-accent-magenta-subtlest-pressed',
    'color.background.accent.magenta.subtler': '--ds-background-accent-magenta-subtler',
    'color.background.accent.magenta.subtler.hovered': '--ds-background-accent-magenta-subtler-hovered',
    'color.background.accent.magenta.subtler.pressed': '--ds-background-accent-magenta-subtler-pressed',
    'color.background.accent.magenta.subtle': '--ds-background-accent-magenta-subtle',
    'color.background.accent.magenta.subtle.hovered': '--ds-background-accent-magenta-subtle-hovered',
    'color.background.accent.magenta.subtle.pressed': '--ds-background-accent-magenta-subtle-pressed',
    'color.background.accent.magenta.bolder': '--ds-background-accent-magenta-bolder',
    'color.background.accent.magenta.bolder.hovered': '--ds-background-accent-magenta-bolder-hovered',
    'color.background.accent.magenta.bolder.pressed': '--ds-background-accent-magenta-bolder-pressed',
    'color.background.accent.gray.subtlest': '--ds-background-accent-gray-subtlest',
    'color.background.accent.gray.subtlest.hovered': '--ds-background-accent-gray-subtlest-hovered',
    'color.background.accent.gray.subtlest.pressed': '--ds-background-accent-gray-subtlest-pressed',
    'color.background.accent.gray.subtler': '--ds-background-accent-gray-subtler',
    'color.background.accent.gray.subtler.hovered': '--ds-background-accent-gray-subtler-hovered',
    'color.background.accent.gray.subtler.pressed': '--ds-background-accent-gray-subtler-pressed',
    'color.background.accent.gray.subtle': '--ds-background-accent-gray-subtle',
    'color.background.accent.gray.subtle.hovered': '--ds-background-accent-gray-subtle-hovered',
    'color.background.accent.gray.subtle.pressed': '--ds-background-accent-gray-subtle-pressed',
    'color.background.accent.gray.bolder': '--ds-background-accent-gray-bolder',
    'color.background.accent.gray.bolder.hovered': '--ds-background-accent-gray-bolder-hovered',
    'color.background.accent.gray.bolder.pressed': '--ds-background-accent-gray-bolder-pressed',
    'color.background.disabled': '--ds-background-disabled',
    'color.background.input': '--ds-background-input',
    'color.background.input.hovered': '--ds-background-input-hovered',
    'color.background.input.pressed': '--ds-background-input-pressed',
    'color.background.inverse.subtle': '--ds-background-inverse-subtle',
    'color.background.inverse.subtle.hovered': '--ds-background-inverse-subtle-hovered',
    'color.background.inverse.subtle.pressed': '--ds-background-inverse-subtle-pressed',
    'color.background.neutral': '--ds-background-neutral',
    'color.background.neutral.hovered': '--ds-background-neutral-hovered',
    'color.background.neutral.pressed': '--ds-background-neutral-pressed',
    'color.background.neutral.subtle': '--ds-background-neutral-subtle',
    'color.background.neutral.subtle.hovered': '--ds-background-neutral-subtle-hovered',
    'color.background.neutral.subtle.pressed': '--ds-background-neutral-subtle-pressed',
    'color.background.neutral.bold': '--ds-background-neutral-bold',
    'color.background.neutral.bold.hovered': '--ds-background-neutral-bold-hovered',
    'color.background.neutral.bold.pressed': '--ds-background-neutral-bold-pressed',
    'color.background.selected': '--ds-background-selected',
    'color.background.selected.hovered': '--ds-background-selected-hovered',
    'color.background.selected.pressed': '--ds-background-selected-pressed',
    'color.background.selected.bold': '--ds-background-selected-bold',
    'color.background.selected.bold.hovered': '--ds-background-selected-bold-hovered',
    'color.background.selected.bold.pressed': '--ds-background-selected-bold-pressed',
    'color.background.brand.subtlest': '--ds-background-brand-subtlest',
    'color.background.brand.subtlest.hovered': '--ds-background-brand-subtlest-hovered',
    'color.background.brand.subtlest.pressed': '--ds-background-brand-subtlest-pressed',
    'color.background.brand.bold': '--ds-background-brand-bold',
    'color.background.brand.bold.hovered': '--ds-background-brand-bold-hovered',
    'color.background.brand.bold.pressed': '--ds-background-brand-bold-pressed',
    'color.background.brand.boldest': '--ds-background-brand-boldest',
    'color.background.brand.boldest.hovered': '--ds-background-brand-boldest-hovered',
    'color.background.brand.boldest.pressed': '--ds-background-brand-boldest-pressed',
    'color.background.danger': '--ds-background-danger',
    'color.background.danger.hovered': '--ds-background-danger-hovered',
    'color.background.danger.pressed': '--ds-background-danger-pressed',
    'color.background.danger.bold': '--ds-background-danger-bold',
    'color.background.danger.bold.hovered': '--ds-background-danger-bold-hovered',
    'color.background.danger.bold.pressed': '--ds-background-danger-bold-pressed',
    'color.background.warning': '--ds-background-warning',
    'color.background.warning.hovered': '--ds-background-warning-hovered',
    'color.background.warning.pressed': '--ds-background-warning-pressed',
    'color.background.warning.bold': '--ds-background-warning-bold',
    'color.background.warning.bold.hovered': '--ds-background-warning-bold-hovered',
    'color.background.warning.bold.pressed': '--ds-background-warning-bold-pressed',
    'color.background.success': '--ds-background-success',
    'color.background.success.hovered': '--ds-background-success-hovered',
    'color.background.success.pressed': '--ds-background-success-pressed',
    'color.background.success.bold': '--ds-background-success-bold',
    'color.background.success.bold.hovered': '--ds-background-success-bold-hovered',
    'color.background.success.bold.pressed': '--ds-background-success-bold-pressed',
    'color.background.discovery': '--ds-background-discovery',
    'color.background.discovery.hovered': '--ds-background-discovery-hovered',
    'color.background.discovery.pressed': '--ds-background-discovery-pressed',
    'color.background.discovery.bold': '--ds-background-discovery-bold',
    'color.background.discovery.bold.hovered': '--ds-background-discovery-bold-hovered',
    'color.background.discovery.bold.pressed': '--ds-background-discovery-bold-pressed',
    'color.background.information': '--ds-background-information',
    'color.background.information.hovered': '--ds-background-information-hovered',
    'color.background.information.pressed': '--ds-background-information-pressed',
    'color.background.information.bold': '--ds-background-information-bold',
    'color.background.information.bold.hovered': '--ds-background-information-bold-hovered',
    'color.background.information.bold.pressed': '--ds-background-information-bold-pressed',
    'color.blanket': '--ds-blanket',
    'color.blanket.selected': '--ds-blanket-selected',
    'color.blanket.danger': '--ds-blanket-danger',
    'color.interaction.hovered': '--ds-interaction-hovered',
    'color.interaction.pressed': '--ds-interaction-pressed',
    'color.skeleton': '--ds-skeleton',
    'color.skeleton.subtle': '--ds-skeleton-subtle',
    'color.chart.categorical.1': '--ds-chart-categorical-1',
    'color.chart.categorical.1.hovered': '--ds-chart-categorical-1-hovered',
    'color.chart.categorical.2': '--ds-chart-categorical-2',
    'color.chart.categorical.2.hovered': '--ds-chart-categorical-2-hovered',
    'color.chart.categorical.3': '--ds-chart-categorical-3',
    'color.chart.categorical.3.hovered': '--ds-chart-categorical-3-hovered',
    'color.chart.categorical.4': '--ds-chart-categorical-4',
    'color.chart.categorical.4.hovered': '--ds-chart-categorical-4-hovered',
    'color.chart.categorical.5': '--ds-chart-categorical-5',
    'color.chart.categorical.5.hovered': '--ds-chart-categorical-5-hovered',
    'color.chart.categorical.6': '--ds-chart-categorical-6',
    'color.chart.categorical.6.hovered': '--ds-chart-categorical-6-hovered',
    'color.chart.categorical.7': '--ds-chart-categorical-7',
    'color.chart.categorical.7.hovered': '--ds-chart-categorical-7-hovered',
    'color.chart.categorical.8': '--ds-chart-categorical-8',
    'color.chart.categorical.8.hovered': '--ds-chart-categorical-8-hovered',
    'color.chart.lime.bold': '--ds-chart-lime-bold',
    'color.chart.lime.bold.hovered': '--ds-chart-lime-bold-hovered',
    'color.chart.lime.bolder': '--ds-chart-lime-bolder',
    'color.chart.lime.bolder.hovered': '--ds-chart-lime-bolder-hovered',
    'color.chart.lime.boldest': '--ds-chart-lime-boldest',
    'color.chart.lime.boldest.hovered': '--ds-chart-lime-boldest-hovered',
    'color.chart.neutral': '--ds-chart-neutral',
    'color.chart.neutral.hovered': '--ds-chart-neutral-hovered',
    'color.chart.red.bold': '--ds-chart-red-bold',
    'color.chart.red.bold.hovered': '--ds-chart-red-bold-hovered',
    'color.chart.red.bolder': '--ds-chart-red-bolder',
    'color.chart.red.bolder.hovered': '--ds-chart-red-bolder-hovered',
    'color.chart.red.boldest': '--ds-chart-red-boldest',
    'color.chart.red.boldest.hovered': '--ds-chart-red-boldest-hovered',
    'color.chart.orange.bold': '--ds-chart-orange-bold',
    'color.chart.orange.bold.hovered': '--ds-chart-orange-bold-hovered',
    'color.chart.orange.bolder': '--ds-chart-orange-bolder',
    'color.chart.orange.bolder.hovered': '--ds-chart-orange-bolder-hovered',
    'color.chart.orange.boldest': '--ds-chart-orange-boldest',
    'color.chart.orange.boldest.hovered': '--ds-chart-orange-boldest-hovered',
    'color.chart.yellow.bold': '--ds-chart-yellow-bold',
    'color.chart.yellow.bold.hovered': '--ds-chart-yellow-bold-hovered',
    'color.chart.yellow.bolder': '--ds-chart-yellow-bolder',
    'color.chart.yellow.bolder.hovered': '--ds-chart-yellow-bolder-hovered',
    'color.chart.yellow.boldest': '--ds-chart-yellow-boldest',
    'color.chart.yellow.boldest.hovered': '--ds-chart-yellow-boldest-hovered',
    'color.chart.green.bold': '--ds-chart-green-bold',
    'color.chart.green.bold.hovered': '--ds-chart-green-bold-hovered',
    'color.chart.green.bolder': '--ds-chart-green-bolder',
    'color.chart.green.bolder.hovered': '--ds-chart-green-bolder-hovered',
    'color.chart.green.boldest': '--ds-chart-green-boldest',
    'color.chart.green.boldest.hovered': '--ds-chart-green-boldest-hovered',
    'color.chart.teal.bold': '--ds-chart-teal-bold',
    'color.chart.teal.bold.hovered': '--ds-chart-teal-bold-hovered',
    'color.chart.teal.bolder': '--ds-chart-teal-bolder',
    'color.chart.teal.bolder.hovered': '--ds-chart-teal-bolder-hovered',
    'color.chart.teal.boldest': '--ds-chart-teal-boldest',
    'color.chart.teal.boldest.hovered': '--ds-chart-teal-boldest-hovered',
    'color.chart.blue.bold': '--ds-chart-blue-bold',
    'color.chart.blue.bold.hovered': '--ds-chart-blue-bold-hovered',
    'color.chart.blue.bolder': '--ds-chart-blue-bolder',
    'color.chart.blue.bolder.hovered': '--ds-chart-blue-bolder-hovered',
    'color.chart.blue.boldest': '--ds-chart-blue-boldest',
    'color.chart.blue.boldest.hovered': '--ds-chart-blue-boldest-hovered',
    'color.chart.purple.bold': '--ds-chart-purple-bold',
    'color.chart.purple.bold.hovered': '--ds-chart-purple-bold-hovered',
    'color.chart.purple.bolder': '--ds-chart-purple-bolder',
    'color.chart.purple.bolder.hovered': '--ds-chart-purple-bolder-hovered',
    'color.chart.purple.boldest': '--ds-chart-purple-boldest',
    'color.chart.purple.boldest.hovered': '--ds-chart-purple-boldest-hovered',
    'color.chart.magenta.bold': '--ds-chart-magenta-bold',
    'color.chart.magenta.bold.hovered': '--ds-chart-magenta-bold-hovered',
    'color.chart.magenta.bolder': '--ds-chart-magenta-bolder',
    'color.chart.magenta.bolder.hovered': '--ds-chart-magenta-bolder-hovered',
    'color.chart.magenta.boldest': '--ds-chart-magenta-boldest',
    'color.chart.magenta.boldest.hovered': '--ds-chart-magenta-boldest-hovered',
    'color.chart.gray.bold': '--ds-chart-gray-bold',
    'color.chart.gray.bold.hovered': '--ds-chart-gray-bold-hovered',
    'color.chart.gray.bolder': '--ds-chart-gray-bolder',
    'color.chart.gray.bolder.hovered': '--ds-chart-gray-bolder-hovered',
    'color.chart.gray.boldest': '--ds-chart-gray-boldest',
    'color.chart.gray.boldest.hovered': '--ds-chart-gray-boldest-hovered',
    'color.chart.brand': '--ds-chart-brand',
    'color.chart.brand.hovered': '--ds-chart-brand-hovered',
    'color.chart.danger': '--ds-chart-danger',
    'color.chart.danger.hovered': '--ds-chart-danger-hovered',
    'color.chart.danger.bold': '--ds-chart-danger-bold',
    'color.chart.danger.bold.hovered': '--ds-chart-danger-bold-hovered',
    'color.chart.warning': '--ds-chart-warning',
    'color.chart.warning.hovered': '--ds-chart-warning-hovered',
    'color.chart.warning.bold': '--ds-chart-warning-bold',
    'color.chart.warning.bold.hovered': '--ds-chart-warning-bold-hovered',
    'color.chart.success': '--ds-chart-success',
    'color.chart.success.hovered': '--ds-chart-success-hovered',
    'color.chart.success.bold': '--ds-chart-success-bold',
    'color.chart.success.bold.hovered': '--ds-chart-success-bold-hovered',
    'color.chart.discovery': '--ds-chart-discovery',
    'color.chart.discovery.hovered': '--ds-chart-discovery-hovered',
    'color.chart.discovery.bold': '--ds-chart-discovery-bold',
    'color.chart.discovery.bold.hovered': '--ds-chart-discovery-bold-hovered',
    'color.chart.information': '--ds-chart-information',
    'color.chart.information.hovered': '--ds-chart-information-hovered',
    'color.chart.information.bold': '--ds-chart-information-bold',
    'color.chart.information.bold.hovered': '--ds-chart-information-bold-hovered',
    'elevation.surface': '--ds-surface',
    'elevation.surface.hovered': '--ds-surface-hovered',
    'elevation.surface.pressed': '--ds-surface-pressed',
    'elevation.surface.overlay': '--ds-surface-overlay',
    'elevation.surface.overlay.hovered': '--ds-surface-overlay-hovered',
    'elevation.surface.overlay.pressed': '--ds-surface-overlay-pressed',
    'elevation.surface.raised': '--ds-surface-raised',
    'elevation.surface.raised.hovered': '--ds-surface-raised-hovered',
    'elevation.surface.raised.pressed': '--ds-surface-raised-pressed',
    'elevation.surface.sunken': '--ds-surface-sunken',
    'elevation.shadow.overflow': '--ds-shadow-overflow',
    'elevation.shadow.overflow.perimeter': '--ds-shadow-overflow-perimeter',
    'elevation.shadow.overflow.spread': '--ds-shadow-overflow-spread',
    'elevation.shadow.overlay': '--ds-shadow-overlay',
    'elevation.shadow.raised': '--ds-shadow-raised',
    'opacity.disabled': '--ds-opacity-disabled',
    'opacity.loading': '--ds-opacity-loading',
    'utility.UNSAFE.textTransformUppercase': '--ds-UNSAFE-textTransformUppercase',
    'utility.UNSAFE.transparent': '--ds-UNSAFE-transparent',
    'utility.elevation.surface.current': '--ds-elevation-surface-current',
    'border.radius.050': '--ds-border-radius-050',
    'border.radius': '--ds-border-radius',
    'border.radius.100': '--ds-border-radius-100',
    'border.radius.200': '--ds-border-radius-200',
    'border.radius.300': '--ds-border-radius-300',
    'border.radius.400': '--ds-border-radius-400',
    'border.radius.circle': '--ds-border-radius-circle',
    'border.width': '--ds-border-width',
    'border.width.0': '--ds-border-width-0',
    'border.width.indicator': '--ds-border-width-indicator',
    'border.width.outline': '--ds-border-width-outline',
    'space.0': '--ds-space-0',
    'space.025': '--ds-space-025',
    'space.050': '--ds-space-050',
    'space.075': '--ds-space-075',
    'space.100': '--ds-space-100',
    'space.150': '--ds-space-150',
    'space.200': '--ds-space-200',
    'space.250': '--ds-space-250',
    'space.300': '--ds-space-300',
    'space.400': '--ds-space-400',
    'space.500': '--ds-space-500',
    'space.600': '--ds-space-600',
    'space.800': '--ds-space-800',
    'space.1000': '--ds-space-1000',
    'space.negative.025': '--ds-space-negative-025',
    'space.negative.050': '--ds-space-negative-050',
    'space.negative.075': '--ds-space-negative-075',
    'space.negative.100': '--ds-space-negative-100',
    'space.negative.150': '--ds-space-negative-150',
    'space.negative.200': '--ds-space-negative-200',
    'space.negative.250': '--ds-space-negative-250',
    'space.negative.300': '--ds-space-negative-300',
    'space.negative.400': '--ds-space-negative-400',
    'font.letterSpacing.0': '--ds-font-letterSpacing-0',
    'font.letterSpacing.100': '--ds-font-letterSpacing-100',
    'font.letterSpacing.200': '--ds-font-letterSpacing-200',
    'font.letterSpacing.300': '--ds-font-letterSpacing-300',
    'font.letterSpacing.400': '--ds-font-letterSpacing-400',
    'font.heading.xxlarge': '--ds-font-heading-xxlarge',
    'font.heading.xlarge': '--ds-font-heading-xlarge',
    'font.heading.large': '--ds-font-heading-large',
    'font.heading.medium': '--ds-font-heading-medium',
    'font.heading.small': '--ds-font-heading-small',
    'font.heading.xsmall': '--ds-font-heading-xsmall',
    'font.heading.xxsmall': '--ds-font-heading-xxsmall',
    'font.body.large': '--ds-font-body-large',
    'font.body': '--ds-font-body',
    'font.body.small': '--ds-font-body-small',
    'font.body.UNSAFE_small': '--ds-font-body-UNSAFE_small',
    'font.code': '--ds-font-code',
    'font.weight.regular': '--ds-font-weight-regular',
    'font.weight.medium': '--ds-font-weight-medium',
    'font.weight.semibold': '--ds-font-weight-semibold',
    'font.weight.bold': '--ds-font-weight-bold',
    'font.family.heading': '--ds-font-family-heading',
    'font.family.body': '--ds-font-family-body',
    'font.family.code': '--ds-font-family-code',
    'font.family.monospace': '--ds-font-family-monospace',
    'font.family.sans': '--ds-font-family-sans',
    'font.family.brand.heading': '--ds-font-family-brand-heading',
    'font.family.brand.body': '--ds-font-family-brand-body',
    'font.size.050': '--ds-font-size-050',
    'font.size.075': '--ds-font-size-075',
    'font.size.100': '--ds-font-size-100',
    'font.size.200': '--ds-font-size-200',
    'font.size.300': '--ds-font-size-300',
    'font.size.400': '--ds-font-size-400',
    'font.size.500': '--ds-font-size-500',
    'font.size.600': '--ds-font-size-600',
    'font.lineHeight.1': '--ds-font-lineHeight-1',
    'font.lineHeight.100': '--ds-font-lineHeight-100',
    'font.lineHeight.200': '--ds-font-lineHeight-200',
    'font.lineHeight.300': '--ds-font-lineHeight-300',
    'font.lineHeight.400': '--ds-font-lineHeight-400',
    'font.lineHeight.500': '--ds-font-lineHeight-500',
    'font.lineHeight.600': '--ds-font-lineHeight-600'
};
var $abc404e82cd59cca$export$2e2bcd8739ae039 = $abc404e82cd59cca$var$tokens;

});




parcelRegister("ebXHa", function(module, exports) {

$parcel$export(module.exports, "isNotAnApp", () => $a5506601f0164752$export$a44a3015a43016f2);
$parcel$export(module.exports, "isRemoteable", () => $a5506601f0164752$export$1212125aff0982f6);
$parcel$export(module.exports, "maybeDCCompatible", () => $a5506601f0164752$export$286882bf1ad23334);
$parcel$export(module.exports, "isServerSubscriptionApp", () => $a5506601f0164752$export$7b954b967a0acd47);
$parcel$export(module.exports, "toHAMSAppKey", () => $a5506601f0164752$export$1a939d84372ecb44);
$parcel$export(module.exports, "isServerAppEol", () => $a5506601f0164752$export$5c4f21be5f4f8fd0);
$parcel$export(module.exports, "isExcludedServerApp", () => $a5506601f0164752$export$b6c10f7b06e61d09);
$parcel$export(module.exports, "isServerAppEos", () => $a5506601f0164752$export$92a9fa5342d87a3f);

var $kafab = parcelRequire("kafab");

var $ammkg = parcelRequire("ammkg");
function $a5506601f0164752$export$a44a3015a43016f2(appDeployment) {
    return [
        (0, $kafab.AppDeployment).INSTRUCTIONAL,
        (0, $kafab.AppDeployment).WORKFLOW
    ].includes(appDeployment.__typename);
}
function $a5506601f0164752$export$1212125aff0982f6(appDeployment) {
    return [
        (0, $kafab.AppDeployment).CONNECT,
        (0, $kafab.AppDeployment).ECOSYSTEM_CLOUD
    ].includes(appDeployment.__typename);
}
function // TODO verify if default value needs to be passed.
$a5506601f0164752$export$286882bf1ad23334() {
    let productHostingOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let serverCompatibleProducts = arguments.length > 1 ? arguments[1] : undefined;
    const isDCCompatible = productHostingOptions.includes((0, $ammkg.AtlassianProductHostingType).DataCenter);
    const isServerCompatible = productHostingOptions.includes((0, $ammkg.AtlassianProductHostingType).Server);
    const isCompatibleWithSomeDCEnabledProduct = serverCompatibleProducts.some((compatibleProduct)=>{
        var _compatibleProduct$at;
        return (_compatibleProduct$at = compatibleProduct.atlassianProduct) === null || _compatibleProduct$at === void 0 ? void 0 : _compatibleProduct$at.hostingOptions.includes((0, $ammkg.AtlassianProductHostingType).DataCenter);
    });
    return !isDCCompatible && isServerCompatible && isCompatibleWithSomeDCEnabledProduct;
}
function $a5506601f0164752$export$7b954b967a0acd47(appKey) {
    return [
        'atlassian-jira-training'
    ].includes(appKey);
}
function $a5506601f0164752$export$1a939d84372ecb44(appKey, hosting) {
    if (hosting === (0, $ammkg.AtlassianProductHostingType).DataCenter) return "".concat(appKey, ".data-center");
    if (hosting === (0, $ammkg.AtlassianProductHostingType).Cloud) return "".concat(appKey, ".ondemand");
    return appKey;
}
const $a5506601f0164752$var$FECRU = 'fecru';
const $a5506601f0164752$var$BAMBOO = 'bamboo';
const $a5506601f0164752$var$CROWD = 'crowd';
const $a5506601f0164752$var$getServerEolStartDate = (compatibleProducts, showServerEolWarning)=>{
    let serverEolStartDate = showServerEolWarning ? 'Feb 15, 2023' : '';
    for (const product of compatibleProducts)if (product.id === $a5506601f0164752$var$BAMBOO || product.id === $a5506601f0164752$var$CROWD) {
        serverEolStartDate = 'November 19, 2023';
        return serverEolStartDate;
    }
    return serverEolStartDate;
};
const $a5506601f0164752$export$5c4f21be5f4f8fd0 = (isServerApp, compatibleProducts, featureFlags)=>{
    const { enableMpacServerEolWarning: enableMpacServerEolWarning } = featureFlags;
    if (isServerApp && enableMpacServerEolWarning) {
        const isExcludedApp = $a5506601f0164752$export$b6c10f7b06e61d09(compatibleProducts);
        const showInstallationTab = isExcludedApp !== null && isExcludedApp !== void 0 ? isExcludedApp : true;
        const showServerEolWarning = !isExcludedApp;
        const serverEolStartDate = $a5506601f0164752$var$getServerEolStartDate(compatibleProducts, showServerEolWarning);
        return {
            showInstallationTab: showInstallationTab,
            showServerEolWarning: showServerEolWarning,
            serverEolStartDate: serverEolStartDate
        };
    }
    return {
        showInstallationTab: true,
        showServerEolWarning: false,
        serverEolStartDate: ''
    };
};
const $a5506601f0164752$export$92a9fa5342d87a3f = (isServerApp, compatibleProducts)=>{
    if (isServerApp) {
        const exculdedParentProduct = [
            $a5506601f0164752$var$FECRU
        ];
        const isExcludedServerEOSApp = compatibleProducts === null || compatibleProducts === void 0 ? void 0 : compatibleProducts.some((product)=>exculdedParentProduct.includes(product.id));
        return !isExcludedServerEOSApp;
    }
    return false;
};
const $a5506601f0164752$export$b6c10f7b06e61d09 = (compatibleProducts)=>{
    // Project CareBear Feb 2023, clean on Feb 2024
    let excludedProductTypes = [
        $a5506601f0164752$var$BAMBOO,
        $a5506601f0164752$var$CROWD,
        $a5506601f0164752$var$FECRU
    ];
    // remove bamboo and crowd from excludedProductTypes
    excludedProductTypes = excludedProductTypes.filter((product)=>![
            $a5506601f0164752$var$BAMBOO,
            $a5506601f0164752$var$CROWD
        ].includes(product));
    return compatibleProducts === null || compatibleProducts === void 0 ? void 0 : compatibleProducts.reduce((showInstallationTab, product)=>{
        return showInstallationTab || excludedProductTypes.includes(product.id);
    }, false);
};

});

parcelRegister("c1ZLO", function(module, exports) {

$parcel$export(module.exports, "MAX_VISIBLE_TABS_CONFIG", () => $8c257e4a59d5c1e2$export$b0c19f7b2463ac49);
$parcel$export(module.exports, "AppListingTab", () => $8c257e4a59d5c1e2$export$e31e72f2e5150d46);
$parcel$export(module.exports, "CommunityTagForHostingType", () => $8c257e4a59d5c1e2$export$23ce376ec0b71571);
$parcel$export(module.exports, "FREE_APP_CTA_LABEL_PRIMARY", () => $8c257e4a59d5c1e2$export$2dfc14d138fd4edd);
$parcel$export(module.exports, "PAID_APP_CTA_LABEL_START_TRIAL", () => $8c257e4a59d5c1e2$export$6902c10944c3f4d7);
$parcel$export(module.exports, "TEST_ID", () => $8c257e4a59d5c1e2$export$a7bb072605d6094c);
$parcel$export(module.exports, "ELEMENT_ID", () => $8c257e4a59d5c1e2$export$e2459a55f364ff58);
$parcel$export(module.exports, "PER_USER_PRICING_FORMAT_MIN_FRACTION_DIGITS", () => $8c257e4a59d5c1e2$export$3dac34b00ae62570);

var $kafab = parcelRequire("kafab");

var $ammkg = parcelRequire("ammkg");
const $8c257e4a59d5c1e2$export$b0c19f7b2463ac49 = {
    xs: 2,
    sm: 4
};
const $8c257e4a59d5c1e2$export$e31e72f2e5150d46 = {
    Overview: 'overview',
    Reviews: 'reviews',
    Pricing: 'pricing',
    Support: 'support',
    Versions: 'versions',
    Installation: 'installation',
    PrivacyAndSecurity: 'privacy-and-security'
};
const $8c257e4a59d5c1e2$export$bff0990d64364b73 = Object.keys($8c257e4a59d5c1e2$export$e31e72f2e5150d46).map((key)=>$8c257e4a59d5c1e2$export$e31e72f2e5150d46[key]);
const $8c257e4a59d5c1e2$export$f3adfdcbb472d8e4 = $8c257e4a59d5c1e2$export$e31e72f2e5150d46.Overview;
const $8c257e4a59d5c1e2$export$23ce376ec0b71571 = {
    [(0, $ammkg.AtlassianProductHostingType).Cloud]: 'cloud',
    [(0, $ammkg.AtlassianProductHostingType).Server]: 'server',
    [(0, $ammkg.AtlassianProductHostingType).DataCenter]: 'data-center'
};
const $8c257e4a59d5c1e2$export$68af97a99c6c08b3 = {
    [(0, $kafab.CompatibleProductTypeValues).CLOUD_PRODUCT]: (0, $ammkg.AtlassianProductHostingType).Cloud,
    [(0, $kafab.CompatibleProductTypeValues).SERVER_PRODUCT]: (0, $ammkg.AtlassianProductHostingType).Server,
    [(0, $kafab.CompatibleProductTypeValues).DATACENTER_PRODUCT]: (0, $ammkg.AtlassianProductHostingType).DataCenter
};
const $8c257e4a59d5c1e2$export$2dfc14d138fd4edd = 'Get it now';
const $8c257e4a59d5c1e2$export$9bf49445298d7efc = 'Free app';
const $8c257e4a59d5c1e2$export$4e14849e4ef20a03 = 'Try it free';
const $8c257e4a59d5c1e2$export$6902c10944c3f4d7 = 'Start free trial';
const $8c257e4a59d5c1e2$export$deeed484a0411758 = 'Buy now';
const $8c257e4a59d5c1e2$export$d06c52010bd3decf = 'Subscribe Now';
const $8c257e4a59d5c1e2$export$6cf44fb8b34bc857 = 'Discover more';
const $8c257e4a59d5c1e2$export$c2c28f1f82398bba = 'Purchase';
const $8c257e4a59d5c1e2$export$a7bb072605d6094c = {
    APP_LISTING_TAB: (tabName)=>"app-listing__tab-".concat(tabName),
    // overview tab
    OVERVIEW_TAB_MORE_DETAILS_CONTENT: 'app-listing__more-details-content',
    OVERVIEW_TAB_YOUTUBE_IFRAME: 'app-listing__youtube-iframe',
    OVERVIEW_TAB_HERO_HIGHLIGHTS: 'hero-and-highlights-container',
    OVERVIEW_TAB_HERO_IMAGE: 'app-listing__hero-img',
    OVERVIEW_TAB_HIGHLIGHT_SUMMARY: 'app-listing__highlight-summary',
    OVERVIEW_TAB_HIGHLIGHT_IMAGE: 'app-listing__highlight-img',
    OVERVIEW_TAB_MEDIA_VIEWER: 'app-listing__media-viewer',
    OVERVIEW_TAB_RESOURCES: 'app-listing__overview__resources',
    OVERVIEW_TAB_PRIVACY_AND_SECURITY: 'app-listing__overview__privacy-security',
    OVERVIEW_TAB_INTEGRATION_DETAILS: 'app-listing__overview__integration-details',
    OVERVIEW_TAB_INTEGRATION_DETAILS_MODAL: 'app-listing__overview__integration-details--modal',
    PRIVACY_SECURITY: 'privacy-security',
    RESOURCE_LINKS: 'resource-links',
    INTEGRATION_DETAILS: 'integration-details',
    GALLERY: 'gallery',
    CERTIFICATION_SECTION: 'certification-section',
    CLOUD_FORTIFIED_INFO_MODAL: 'cloudfortified-info-modal',
    // overview tab -> Resources section -> cloud migration subsection
    CLOUD_MIGRATION_ALTERNATE_APP: 'cloud-migration__alternate-app',
    CLOUD_MIGRATION_MIGRATION_DOCUMENTATION: 'cloud-migration__migration-documentation',
    CLOUD_MIGRATION_FEATURE_DIFFERENCE: 'cloud-migration__feature-difference',
    // reviews tab
    REVIEWS_TAB_HEADING: 'reviews-tab__heading',
    REVIEWS_TAB_LOADING: 'reviews-tab__skeleton',
    REVIEWS_TAB_REVIEW_FORM_CHECKBOX: 'reviews-tab__review-form-checkbox',
    REVIEWS_TAB_REVIEW_FORM_TEXTAREA: 'reviews-tab__review-form-textarea',
    REVIEWS_TAB_USER_REVIEW: 'reviews-tab__user-review',
    REVIEWS_TAB_OWN_REVIEW: 'reviews-tab__own-review',
    REVIEWS_TAB_DELETE_REVIEW: 'reviews-tab__delete-review',
    REVIEWS_TAB_RESPOND_REVIEW: 'reviews-tab__respond-review',
    REVIEWS_TAB_FLAG_UNFLAG_REVIEW: 'reviews-tab__flag-unflag-review',
    REVIEWS_TAB_SIGN_IN_LINK: 'reviews-tab__sign-in-link',
    REVIEWS_TAB_WRITE_EDIT_REVIEW_BUTTON: 'reviews-tab__write-edit-review-button',
    REVIEWS_TAB_PUBLISH_REVIEW_BUTTON: 'reviews-tab__publish-review-button',
    REVIEWS_TAB_LOAD_MORE_LOADING: 'reviews-tab__load-more-skeleton',
    // support
    SUPPORT_TAB_SUPPORT_TAGLINE: 'app-listing__support-tagline',
    SUPPORT_TAB_EMAIL_ID: 'app-listing__support-link__email-id',
    SUPPORT_TAB_PHONE_NUMBER: 'app-listing__support-link__phone-number',
    SUPPORT_TAB_STATUS_PAGE_URL: 'app-listing__support-link__status-page-url',
    SUPPORT_TAB_SUPPORT_TIMINGS: 'app-listing__support-contact__availability-timings',
    // pricing
    PRICING_TAB_VIEW_ADDITIONAL_PRICING: 'app-listing__pricing-tab-view-additional-pricing',
    PRICING_TAB_INSTALL_CTA: 'app-listing__pricing-tab__install-cta',
    // installation
    INSTALLATION_TAB_STEP_SCREENSHOT: 'app-listing__installation-step-screenshot',
    // cta
    CTA_INSTALL_APP_BTN: 'app-listing__install-app-btn',
    // hosting selector
    HOSTING_SELECTOR_MODAL_REQUEST_APP: 'hosting-selector-modal__request-app-btn',
    HOSTING_SELECTOR_MODAL_COLUMN_CLOUD: 'hosting-selector-modal__column-cloud',
    HOSTING_SELECTOR_MODAL_COLUMN_SERVER: 'hosting-selector-modal__column-server',
    HOSTING_SELECTOR_MODAL_COLUMN_DATACENTER: 'hosting-selector-modal__column-datacenter',
    HOSTING_SELECTOR_MODAL_PRIMARY_COLUMN_CTA: 'hosting-selector-modal__primary-column-cta',
    /**
   * Hosting dropdown
   * This value is a prefix, the actual testId is created by the atlaskit dropdown component:-
   * - `${HOSTING_DROPDOWN}--trigger` (for the clickable trigger)
   * - `${HOSTING_DROPDOWN}--content` (for the options container)
   */ HOSTING_DROPDOWN: 'app-listing__hosting-dropdown',
    // request app
    REQUEST_APP_BTN: 'app-listing__request-app-btn',
    REQUEST_APP_MODAL_CLOSE_BTN: 'request-app-modal__close-modal-btn',
    REQUEST_APP_MODAL_SUBMIT_BTN: 'request-app-modal__submit-request-btn',
    // gallery media viewer
    MEDIA_VIEWER_FILE_NAME: 'media-viewer-file-name',
    MEDIA_VIEWER_CLOSE_BTN: 'media-viewer-close-button',
    MEDIA_VIEWER_IMAGE: 'media-viewer-image',
    // versions tab
    VERSION_SECTION: 'versions-section',
    RESOURCE_SECTION: 'resources-section'
};
const $8c257e4a59d5c1e2$export$e2459a55f364ff58 = {
    APP_LISTING_TABS: 'app-listing__tabs',
    CLOUD_MIGRATION_SECTION_LINKS: 'app-listing__cloud-migration-links',
    REVIEW_GUIDELINE_BANNER_AND_FORM: 'app-listing__review-guideline-banner-and-form'
};
const $8c257e4a59d5c1e2$export$3dac34b00ae62570 = 2;

});

parcelRegister("h6uOD", function(module, exports) {

$parcel$export(module.exports, "APP_HEADER_ORIGIN", () => $c73ae6895d9a4c28$export$d32fc29ad1b7fc58);
$parcel$export(module.exports, "makeSeeExistingQuestionsUrl", () => $c73ae6895d9a4c28$export$44d5398ba659399d);
$parcel$export(module.exports, "makeAskNewQuestionUrl", () => $c73ae6895d9a4c28$export$49d14ea959a409c7);
$parcel$export(module.exports, "getExistingCommunityQuestionsCount", () => $c73ae6895d9a4c28$export$7f69f4df9a8a9d09);
$parcel$export(module.exports, "valueForHosting", () => $c73ae6895d9a4c28$export$50fe971ec4ec2dec);
$parcel$export(module.exports, "getSelectedAppVersion", () => $c73ae6895d9a4c28$export$88dac8dff5f7f248);
$parcel$export(module.exports, "getSelectedAppVersionConnection", () => $c73ae6895d9a4c28$export$49c3ecaefe3884e5);
$parcel$export(module.exports, "makeAppHeaderProps", () => $c73ae6895d9a4c28$export$d588a44ae5c73e69);
$parcel$export(module.exports, "isRuByPartnerAppAccessDeniedError", () => $c73ae6895d9a4c28$export$989a8fca99ae1a75);

var $ammkg = parcelRequire("ammkg");

var $bTrQR = parcelRequire("bTrQR");
var $c9Mth = parcelRequire("c9Mth");

var $c1ZLO = parcelRequire("c1ZLO");
const $c73ae6895d9a4c28$export$cb5c403d4efbcd2d = 'atlassian-marketplace';
const $c73ae6895d9a4c28$export$d32fc29ad1b7fc58 = 'marketplace';
const $c73ae6895d9a4c28$export$957ec5fa69ccab9c = (appKey)=>"addon-".concat(appKey);
const $c73ae6895d9a4c28$export$44d5398ba659399d = (_ref)=>{
    let { atlassianCommunityBaseUrl: atlassianCommunityBaseUrl, appKey: appKey } = _ref;
    return "".concat(atlassianCommunityBaseUrl, "/t5/tag/").concat($c73ae6895d9a4c28$export$957ec5fa69ccab9c(appKey), "/tg-p/category-id/").concat($c73ae6895d9a4c28$export$cb5c403d4efbcd2d);
};
const $c73ae6895d9a4c28$export$49d14ea959a409c7 = (_ref2)=>{
    let { atlassianCommunityBaseUrl: atlassianCommunityBaseUrl, appKey: appKey, hosting: hosting } = _ref2;
    const pathname = "".concat(atlassianCommunityBaseUrl, "/t5/custom/page/page-id/create-post-step-1");
    const params = new URLSearchParams();
    params.append('add-tags', [
        $c73ae6895d9a4c28$export$cb5c403d4efbcd2d,
        $c73ae6895d9a4c28$export$957ec5fa69ccab9c(appKey),
        (0, $c1ZLO.CommunityTagForHostingType)[hosting]
    ].join(','));
    return "".concat(pathname, "?").concat(params.toString());
};
const $c73ae6895d9a4c28$export$4a1455b2afa8dbd4 = (_ref3)=>{
    let { mpacBaseUrl: mpacBaseUrl, appKey: appKey } = _ref3;
    return "".concat(mpacBaseUrl, "/rest/internal/community/tags/count?q=").concat($c73ae6895d9a4c28$export$957ec5fa69ccab9c(appKey));
};
const $c73ae6895d9a4c28$export$7f69f4df9a8a9d09 = async (_ref4)=>{
    let { mpacBaseUrl: mpacBaseUrl, appKey: appKey } = _ref4;
    try {
        const url = $c73ae6895d9a4c28$export$4a1455b2afa8dbd4({
            mpacBaseUrl: mpacBaseUrl,
            appKey: appKey
        });
        const response = await fetch(url, {
            credentials: 'same-origin'
        });
        if (response.ok) {
            const count = await response.json();
            if (typeof count === 'number') return count;
        }
    } catch (error) {
        (0, $bTrQR.default).error('AppListing', 'Error fetching count of existing questions on atlassian community', {
            error: error
        });
    }
    return 0;
};
const $c73ae6895d9a4c28$export$50fe971ec4ec2dec = (hosting)=>(hostingMap)=>{
        return hostingMap[hosting];
    };
const $c73ae6895d9a4c28$export$cd4bd0d91a5f2507 = (paymentModel)=>(paymentModelMap)=>{
        return paymentModelMap[paymentModel];
    };
const $c73ae6895d9a4c28$export$88c54d42f2bd4212 = (purchaseIntent)=>(purchaseIntentMap)=>{
        return purchaseIntentMap[purchaseIntent];
    };
function $c73ae6895d9a4c28$export$88dac8dff5f7f248(hosting, appDetails) {
    var _getSelectedAppVersio, _getSelectedAppVersio2;
    return (_getSelectedAppVersio = $c73ae6895d9a4c28$export$49c3ecaefe3884e5(hosting, appDetails).edges) === null || _getSelectedAppVersio === void 0 ? void 0 : (_getSelectedAppVersio2 = _getSelectedAppVersio[0]) === null || _getSelectedAppVersio2 === void 0 ? void 0 : _getSelectedAppVersio2.node;
}
function $c73ae6895d9a4c28$export$49c3ecaefe3884e5(hosting, appDetails) {
    return $c73ae6895d9a4c28$export$50fe971ec4ec2dec(hosting)({
        [(0, $ammkg.AtlassianProductHostingType).Cloud]: appDetails.cloudAppVersions,
        [(0, $ammkg.AtlassianProductHostingType).Server]: appDetails.serverAppVersions,
        [(0, $ammkg.AtlassianProductHostingType).DataCenter]: appDetails.dataCenterAppVersions
    });
}
const $c73ae6895d9a4c28$export$d588a44ae5c73e69 = (appListing, appDetailsFromSearchResponse)=>({
        name: appListing.name,
        key: appListing.appKey,
        ratings: {
            avgStars: appListing.reviewSummary.rating,
            numRatings: appListing.reviewSummary.count
        },
        createdAt: appListing.createdAt,
        distribution: {
            downloadCount: appListing.distribution.downloadCount,
            installationCount: appListing.distribution.installationCount,
            isPreinstalled: appListing.distribution.isPreinstalled,
            isPreinstalledInAnyHosting: appListing.distribution.isPreinstalledInAnyHosting,
            isLoading: appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : appDetailsFromSearchResponse.loading,
            isError: appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : appDetailsFromSearchResponse.error
        },
        compatibleProducts: appListing.compatibleProducts.map((p)=>p.name),
        origin: $c73ae6895d9a4c28$export$d32fc29ad1b7fc58,
        partner: {
            name: appListing.partner.name,
            link: (0, $c9Mth).validateSafeAbsoluteUrl(appListing.partner.url),
            partnerTierType: appListing.partner.partnerTierType
        }
    });
const $c73ae6895d9a4c28$export$989a8fca99ae1a75 = (error)=>{
    var _graphQLErrors$0$exte;
    const { graphQLErrors: graphQLErrors } = error;
    if (!graphQLErrors.length) return false;
    return ((_graphQLErrors$0$exte = graphQLErrors[0].extensions) === null || _graphQLErrors$0$exte === void 0 ? void 0 : _graphQLErrors$0$exte.errorType) === 'ruby_region_access_denied';
};

});

parcelRegister("5y7Bn", function(module, exports) {

$parcel$export(module.exports, "HostingSelectContainerV1", () => $40a6064ccbf41e02$export$72370481bc2d5353);
$parcel$export(module.exports, "HostingSelectContainerV2", () => $40a6064ccbf41e02$export$e4605f0871886e2c);
$parcel$export(module.exports, "ListingContainer", () => $40a6064ccbf41e02$export$6c5bd0c5e855317e);
$parcel$export(module.exports, "TabContentContainer", () => $40a6064ccbf41e02$export$3b6bf35c844279db);
$parcel$export(module.exports, "AnimationContainer", () => $40a6064ccbf41e02$export$557862fe160c66da);
/* AppListing.styles.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $lHkHI = parcelRequire("lHkHI");
const $40a6064ccbf41e02$var$_excluded = [
    "as",
    "style"
], $40a6064ccbf41e02$var$_excluded2 = [
    "as",
    "style"
], $40a6064ccbf41e02$var$_excluded3 = [
    "as",
    "style"
], $40a6064ccbf41e02$var$_excluded4 = [
    "as",
    "style"
], $40a6064ccbf41e02$var$_excluded5 = [
    "as",
    "style"
];
function $40a6064ccbf41e02$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $40a6064ccbf41e02$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $40a6064ccbf41e02$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $40a6064ccbf41e02$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $40a6064ccbf41e02$export$72370481bc2d5353 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $40a6064ccbf41e02$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $40a6064ccbf41e02$var$_objectSpread($40a6064ccbf41e02$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91ns9 _kqswh2mm _otyr12x7 _13wnstnw _1r6vze3t _hyzq11wp _dbjg12x7",
            __cmplp.className
        ])
    }));
});
const $40a6064ccbf41e02$export$e4605f0871886e2c = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $40a6064ccbf41e02$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $40a6064ccbf41e02$var$_objectSpread($40a6064ccbf41e02$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkgosd _otyr1eps",
            __cmplp.className
        ])
    }));
});
const $40a6064ccbf41e02$export$6c5bd0c5e855317e = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $40a6064ccbf41e02$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $40a6064ccbf41e02$var$_objectSpread($40a6064ccbf41e02$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1jfw",
            __cmplp.className
        ])
    }));
});
const $40a6064ccbf41e02$export$3b6bf35c844279db = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $40a6064ccbf41e02$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $40a6064ccbf41e02$var$_objectSpread($40a6064ccbf41e02$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _1yt41hdg _1tkebejm",
            __cmplp.className
        ])
    }));
});
const $40a6064ccbf41e02$export$557862fe160c66da = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $40a6064ccbf41e02$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $40a6064ccbf41e02$var$_objectSpread($40a6064ccbf41e02$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1reo15vq _18m915vq _kqswh2mm _c71lidpf _v5641cdp _awzo1ltq",
            __cmplp.className
        ])
    }));
});

});

parcelRegister("8dnmP", function(module, exports) {

$parcel$export(module.exports, "makePartner", () => $5fb1a9e12f28a6fb$export$4e86cdb9bfb37e34);
$parcel$export(module.exports, "makePrograms", () => $5fb1a9e12f28a6fb$export$75c05eeb38ce87e7);
$parcel$export(module.exports, "makeReviewSummary", () => $5fb1a9e12f28a6fb$export$b903bb79739c9fdc);
$parcel$export(module.exports, "makeDistribution", () => $5fb1a9e12f28a6fb$export$37b9fd23ea152d25);
$parcel$export(module.exports, "default", () => $5fb1a9e12f28a6fb$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $kafab = parcelRequire("kafab");
var $7ZOJD = parcelRequire("7ZOJD");

var $ammkg = parcelRequire("ammkg");

var $ebXHa = parcelRequire("ebXHa");

var $h6uOD = parcelRequire("h6uOD");
function $5fb1a9e12f28a6fb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $5fb1a9e12f28a6fb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $5fb1a9e12f28a6fb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $5fb1a9e12f28a6fb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $5fb1a9e12f28a6fb$var$makeWatcherInfo = (info)=>{
    var _info$isUserWatchingA, _info$watchersCount;
    return {
        isUserWatchingApp: (_info$isUserWatchingA = info === null || info === void 0 ? void 0 : info.isUserWatchingApp) !== null && _info$isUserWatchingA !== void 0 ? _info$isUserWatchingA : false,
        watchersCount: (_info$watchersCount = info === null || info === void 0 ? void 0 : info.watchersCount) !== null && _info$watchersCount !== void 0 ? _info$watchersCount : 0
    };
};
function $5fb1a9e12f28a6fb$export$39ae7d355c29b45f(highlight, makeImageLink) {
    const { croppedScreenshot: croppedScreenshot, title: title, summary: summary, screenshot: screenshot } = highlight;
    const croppedImage = croppedScreenshot.highResolution || croppedScreenshot.original;
    const image = screenshot.image.highResolution || screenshot.image.original;
    const caption = highlight.caption || screenshot.caption;
    return {
        title: title,
        caption: caption,
        summary: summary,
        croppedImage: {
            width: croppedImage.width,
            height: croppedImage.height,
            url: makeImageLink(croppedImage.id)
        },
        image: {
            width: image.width,
            height: image.height,
            url: makeImageLink(image.id)
        }
    };
}
function $5fb1a9e12f28a6fb$export$a8937c5bf2e03fcb(screenshot, makeImageLink) {
    const { caption: caption, image: image } = screenshot;
    const { id: id, width: width, height: height } = image.original;
    return {
        caption: caption,
        image: {
            url: makeImageLink(id),
            width: width,
            height: height
        }
    };
}
const $5fb1a9e12f28a6fb$var$makeHeroImage = (heroImage, makeImageLink)=>{
    const image = (heroImage === null || heroImage === void 0 ? void 0 : heroImage.highResolution) || (heroImage === null || heroImage === void 0 ? void 0 : heroImage.original);
    if (!image) return null;
    return {
        width: image.width,
        height: image.height,
        url: makeImageLink(image.id)
    };
};
const $5fb1a9e12f28a6fb$export$4e86cdb9bfb37e34 = (partner, detailsLink, makeImageLink)=>{
    var _partner$programs, _partner$support, _partner$support$cont, _partner$partnerTier;
    let logo;
    if (partner !== null && partner !== void 0 && partner.logo) {
        var _partner$logo$highRes;
        const highResImageUrl = (_partner$logo$highRes = partner.logo.highResolution) === null || _partner$logo$highRes === void 0 ? void 0 : _partner$logo$highRes.imageUrl;
        const originalImageUrl = partner.logo.original.imageUrl;
        if (highResImageUrl || originalImageUrl) logo = highResImageUrl || originalImageUrl;
        else if (makeImageLink) {
            var _partner$logo$highRes2;
            const highResImageId = (_partner$logo$highRes2 = partner.logo.highResolution) === null || _partner$logo$highRes2 === void 0 ? void 0 : _partner$logo$highRes2.id;
            const originalImageId = partner.logo.original.id;
            logo = makeImageLink(highResImageId || originalImageId);
        }
    } else logo = null;
    return {
        id: partner === null || partner === void 0 ? void 0 : partner.id,
        name: partner === null || partner === void 0 ? void 0 : partner.name,
        url: partner ? detailsLink.expand({
            id: partner.id,
            slug: partner.slug
        }) : null,
        programs: {
            isCloudAppSecuritySelfAssessmentDone: (partner === null || partner === void 0 ? void 0 : (_partner$programs = partner.programs) === null || _partner$programs === void 0 ? void 0 : _partner$programs.isCloudAppSecuritySelfAssessmentDone) || false
        },
        support: {
            url: partner === null || partner === void 0 ? void 0 : (_partner$support = partner.support) === null || _partner$support === void 0 ? void 0 : (_partner$support$cont = _partner$support.contactDetails) === null || _partner$support$cont === void 0 ? void 0 : _partner$support$cont.websiteUrl
        },
        partnerType: partner === null || partner === void 0 ? void 0 : partner.partnerType,
        partnerTierType: partner === null || partner === void 0 ? void 0 : (_partner$partnerTier = partner.partnerTier) === null || _partner$partnerTier === void 0 ? void 0 : _partner$partnerTier.type,
        logo: logo
    };
};
const $5fb1a9e12f28a6fb$export$75c05eeb38ce87e7 = (programs)=>{
    var _programs$cloudFortif, _programs$bugBountyPa, _programs$bugBountyPa2, _programs$bugBountyPa3, _programs$bugBountyPa4, _programs$bugBountyPa5, _programs$bugBountyPa6;
    return {
        cloudFortified: {
            isStatusApproved: (programs === null || programs === void 0 ? void 0 : (_programs$cloudFortif = programs.cloudFortified) === null || _programs$cloudFortif === void 0 ? void 0 : _programs$cloudFortif.programStatus) === (0, $ammkg.MarketplaceProgramStatus).Approved
        },
        bugBountyParticipant: {
            cloud: {
                status: programs === null || programs === void 0 ? void 0 : (_programs$bugBountyPa = programs.bugBountyParticipant) === null || _programs$bugBountyPa === void 0 ? void 0 : (_programs$bugBountyPa2 = _programs$bugBountyPa.cloud) === null || _programs$bugBountyPa2 === void 0 ? void 0 : _programs$bugBountyPa2.status
            },
            server: {
                status: programs === null || programs === void 0 ? void 0 : (_programs$bugBountyPa3 = programs.bugBountyParticipant) === null || _programs$bugBountyPa3 === void 0 ? void 0 : (_programs$bugBountyPa4 = _programs$bugBountyPa3.server) === null || _programs$bugBountyPa4 === void 0 ? void 0 : _programs$bugBountyPa4.status
            },
            dataCenter: {
                status: programs === null || programs === void 0 ? void 0 : (_programs$bugBountyPa5 = programs.bugBountyParticipant) === null || _programs$bugBountyPa5 === void 0 ? void 0 : (_programs$bugBountyPa6 = _programs$bugBountyPa5.dataCenter) === null || _programs$bugBountyPa6 === void 0 ? void 0 : _programs$bugBountyPa6.status
            }
        }
    };
};
const $5fb1a9e12f28a6fb$export$b903bb79739c9fdc = (summary)=>{
    var _summary$count, _summary$rating;
    return {
        count: (_summary$count = summary === null || summary === void 0 ? void 0 : summary.count) !== null && _summary$count !== void 0 ? _summary$count : 0,
        rating: (_summary$rating = summary === null || summary === void 0 ? void 0 : summary.rating) !== null && _summary$rating !== void 0 ? _summary$rating : 0
    };
};
const $5fb1a9e12f28a6fb$export$e36a0bc69d7dae53 = (_ref)=>{
    var _partner$support2, _partner$support2$con, _partner$support3, _partner$support3$con, _partner$support4, _partner$support4$con, _partner$support5;
    let { selectedAppVersion: selectedAppVersion, appDetails: appDetails } = _ref;
    const { wikiUrl: wikiUrl, forumsUrl: forumsUrl, partner: partner, issueTrackerUrl: issueTrackerUrl, supportTicketSystemUrl: supportTicketSystemUrl, statusPageUrl: statusPageUrl } = appDetails;
    const { documentationUrl: documentationUrl } = selectedAppVersion || {};
    const resources = {
        documentationUrl: documentationUrl,
        wikiUrl: wikiUrl,
        forumsUrl: forumsUrl
    };
    const isSupported = (selectedAppVersion === null || selectedAppVersion === void 0 ? void 0 : selectedAppVersion.isSupported) === true;
    return {
        isSupported: isSupported,
        isAtlassianCommunityEnabled: appDetails.isAtlassianCommunityEnabled || !isSupported,
        hasResources: Object.values(resources).some((url)=>!!url),
        resources: resources,
        contact: {
            emailId: partner === null || partner === void 0 ? void 0 : (_partner$support2 = partner.support) === null || _partner$support2 === void 0 ? void 0 : (_partner$support2$con = _partner$support2.contactDetails) === null || _partner$support2$con === void 0 ? void 0 : _partner$support2$con.emailId,
            websiteUrl: partner === null || partner === void 0 ? void 0 : (_partner$support3 = partner.support) === null || _partner$support3 === void 0 ? void 0 : (_partner$support3$con = _partner$support3.contactDetails) === null || _partner$support3$con === void 0 ? void 0 : _partner$support3$con.websiteUrl,
            phoneNumber: partner === null || partner === void 0 ? void 0 : (_partner$support4 = partner.support) === null || _partner$support4 === void 0 ? void 0 : (_partner$support4$con = _partner$support4.contactDetails) === null || _partner$support4$con === void 0 ? void 0 : _partner$support4$con.phoneNumber,
            issueTrackerUrl: // support requests
            issueTrackerUrl,
            supportTicketSystemUrl: supportTicketSystemUrl,
            statusPageUrl: statusPageUrl
        },
        availability: partner === null || partner === void 0 ? void 0 : (_partner$support5 = partner.support) === null || _partner$support5 === void 0 ? void 0 : _partner$support5.availability,
        partner: {
            name: partner === null || partner === void 0 ? void 0 : partner.name
        }
    };
};
const $5fb1a9e12f28a6fb$export$8fb9fc03d975b4ef = (deployment, hosting)=>{
    if (!deployment) return false;
    const cloudPreinstalled = hosting === (0, $ammkg.AtlassianProductHostingType).Cloud && deployment.__typename === (0, $kafab.AppDeployment).PLUGINS2;
    if (deployment.__typename === (0, $kafab.AppDeployment).INSTRUCTIONAL) return deployment.isBinaryUrlAvailable;
    else if (deployment.__typename === (0, $kafab.AppDeployment).WORKFLOW) return deployment.isWorkflowDataFileAvailable;
    else return !(0, $ebXHa).isRemoteable(deployment) && !cloudPreinstalled;
};
const $5fb1a9e12f28a6fb$var$makeInstallationInstructions = (_ref2)=>{
    var _selectedAppVersion$d;
    let { selectedAppVersion: selectedAppVersion, makeMediaImage: makeMediaImage } = _ref2;
    if (selectedAppVersion && selectedAppVersion.deployment.__typename === (0, $kafab.AppDeployment).INSTRUCTIONAL && (_selectedAppVersion$d = selectedAppVersion.deployment.instructions) !== null && _selectedAppVersion$d !== void 0 && _selectedAppVersion$d.length) {
        const { instructions: instructions } = selectedAppVersion.deployment;
        return instructions.map((_ref3)=>{
            var _screenshot$highResol;
            let { instruction: instruction, screenshot: screenshot } = _ref3;
            const screenshotImage = (_screenshot$highResol = screenshot === null || screenshot === void 0 ? void 0 : screenshot.highResolution) !== null && _screenshot$highResol !== void 0 ? _screenshot$highResol : screenshot === null || screenshot === void 0 ? void 0 : screenshot.original;
            return {
                instruction: instruction,
                screenshot: screenshotImage !== null && screenshotImage !== void 0 && screenshotImage.id ? {
                    url: makeMediaImage(screenshotImage.id),
                    width: screenshotImage.width,
                    height: screenshotImage.height
                } : null
            };
        });
    }
    return [];
};
const $5fb1a9e12f28a6fb$var$makeResourceLinks = (_ref4)=>{
    let { appDetails: appDetails, latestVersion: latestVersion, appVersionHistoryLink: appVersionHistoryLink, artifactDownloadLink: artifactDownloadLink, descriptorDownloadLink: descriptorDownloadLink, hosting: hosting } = _ref4;
    const { appId: appId, slug: slug } = appDetails;
    const { deployment: deployment, buildNumber: buildNumber, endUserLicenseAgreementUrl: endUserLicenseAgreementUrl, learnMoreUrl: learnMoreUrl, documentationUrl: documentationUrl, purchaseUrl: purchaseUrl } = latestVersion || {};
    return {
        endUserLicenseAgreementUrl: endUserLicenseAgreementUrl,
        learnMoreUrl: learnMoreUrl,
        documentationUrl: documentationUrl,
        purchaseUrl: purchaseUrl,
        versionHistoryUrl: appVersionHistoryLink.expand({
            appId: appId,
            appSlug: slug,
            hosting: (0, $7ZOJD.HostingTypeToFiltersQueryParam)[hosting]
        }),
        artifactDownloadUrl: $5fb1a9e12f28a6fb$export$8fb9fc03d975b4ef(deployment, hosting) ? artifactDownloadLink.expand({
            appId: appId,
            buildNumber: buildNumber
        }) : undefined,
        descriptorDownloadUrl: (deployment === null || deployment === void 0 ? void 0 : deployment.__typename) === (0, $kafab.AppDeployment).CONNECT ? descriptorDownloadLink.expand({
            appId: appId,
            buildNumber: buildNumber
        }) : undefined
    };
};
const $5fb1a9e12f28a6fb$var$makeAppScopes = (latestVersion)=>{
    if (latestVersion && latestVersion.deployment && (latestVersion.deployment.__typename === (0, $kafab.AppDeployment).CONNECT || latestVersion.deployment.__typename === (0, $kafab.AppDeployment).ECOSYSTEM_CLOUD)) return latestVersion.deployment.scopes;
    return [];
};
const $5fb1a9e12f28a6fb$export$37b9fd23ea152d25 = (appListingDistribution, appDataFromSearchDistribution, hosting)=>{
    var _ref5, _appDataFromSearchDis, _ref6, _appDataFromSearchDis2;
    const preInstalledInSelectedHosting = hosting === (0, $ammkg.AtlassianProductHostingType).Cloud ? appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.isPreinstalledInCloud : appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.isPreinstalledInServerDC;
    const downloadCount = (_ref5 = (_appDataFromSearchDis = appDataFromSearchDistribution === null || appDataFromSearchDistribution === void 0 ? void 0 : appDataFromSearchDistribution.downloads) !== null && _appDataFromSearchDis !== void 0 ? _appDataFromSearchDis : appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.downloadCount) !== null && _ref5 !== void 0 ? _ref5 : 0;
    const installationCount = (_ref6 = (_appDataFromSearchDis2 = appDataFromSearchDistribution === null || appDataFromSearchDistribution === void 0 ? void 0 : appDataFromSearchDistribution.activeInstalls) !== null && _appDataFromSearchDis2 !== void 0 ? _appDataFromSearchDis2 : appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.installationCount) !== null && _ref6 !== void 0 ? _ref6 : 0;
    return {
        downloadCount: downloadCount,
        installationCount: installationCount,
        isPreinstalled: preInstalledInSelectedHosting || false,
        isPreinstalledInAnyHosting: (appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.isPreinstalledInCloud) || (appListingDistribution === null || appListingDistribution === void 0 ? void 0 : appListingDistribution.isPreinstalledInServerDC) || false
    };
};
function $5fb1a9e12f28a6fb$export$2e2bcd8739ae039(args) {
    var _appDetails$serverApp, _appDetails$serverApp2, _appDetails$cloudAppV, _appDetails$cloudAppV2, _appDetails$dataCente, _appDetails$dataCente2, _appDetails$logo$high, _appDetails$logo$high2, _highlights$map, _screenshots$map, _appDetails$tagline, _appDetails$summary, _selectedAppVersionCo, _deployment$compatibl, _latestCloudAppVersio;
    const { appDetails: appDetails, appDataFromSearch: appDataFromSearch, mediaImageLink: mediaImageLink, partnerDetailsLink: partnerDetailsLink, hosting: hosting, appVersionHistoryLink: appVersionHistoryLink, artifactDownloadLink: artifactDownloadLink, descriptorDownloadLink: descriptorDownloadLink, appIconLink: appIconLink } = args;
    const selectedAppVersion = (0, $h6uOD.getSelectedAppVersion)(hosting, appDetails);
    const selectedAppVersionConnection = (0, $h6uOD.getSelectedAppVersionConnection)(hosting, appDetails);
    const latestServerAppVersion = (_appDetails$serverApp = appDetails.serverAppVersions.edges) === null || _appDetails$serverApp === void 0 ? void 0 : (_appDetails$serverApp2 = _appDetails$serverApp[0]) === null || _appDetails$serverApp2 === void 0 ? void 0 : _appDetails$serverApp2.node;
    const latestCloudAppVersion = (_appDetails$cloudAppV = appDetails.cloudAppVersions.edges) === null || _appDetails$cloudAppV === void 0 ? void 0 : (_appDetails$cloudAppV2 = _appDetails$cloudAppV[0]) === null || _appDetails$cloudAppV2 === void 0 ? void 0 : _appDetails$cloudAppV2.node;
    const latestDataCenterAppVersion = (_appDetails$dataCente = appDetails.dataCenterAppVersions.edges) === null || _appDetails$dataCente === void 0 ? void 0 : (_appDetails$dataCente2 = _appDetails$dataCente[0]) === null || _appDetails$dataCente2 === void 0 ? void 0 : _appDetails$dataCente2.node;
    // for all UX purposes, cloud only has 1 version from a user’s POV
    const totalVersionCount = Math.min(1, appDetails.cloudAppVersions.totalCount) + appDetails.serverAppVersions.totalCount + appDetails.dataCenterAppVersions.totalCount;
    const serverCompatibleProducts = (latestServerAppVersion === null || latestServerAppVersion === void 0 ? void 0 : latestServerAppVersion.deployment.compatibleProducts) || [];
    const cloudCompatibleProducts = (latestCloudAppVersion === null || latestCloudAppVersion === void 0 ? void 0 : latestCloudAppVersion.deployment.compatibleProducts) || [];
    const dataCenterCompatibleProducts = (latestDataCenterAppVersion === null || latestDataCenterAppVersion === void 0 ? void 0 : latestDataCenterAppVersion.deployment.compatibleProducts) || [];
    const makeMediaImage = (imageId)=>mediaImageLink.expand({
            imageId: imageId
        });
    const { name: name, appKey: appKey, appId: appId, slug: slug, privacyPolicyUrl: privacyPolicyUrl, partner: partner, programs: programs } = appDetails;
    const { youtubeId: youtubeId, highlights: highlights, screenshots: screenshots, moreDetails: moreDetails, heroImage: heroImage, deployment: deployment, releaseDate: releaseDate, releaseNotes: releaseNotes, releaseSummary: releaseSummary, releaseNotesUrl: releaseNotesUrl, version: version } = selectedAppVersion || {};
    const appScopes = $5fb1a9e12f28a6fb$var$makeAppScopes(selectedAppVersion);
    const logo = appDetails.logo ? makeMediaImage((_appDetails$logo$high = (_appDetails$logo$high2 = appDetails.logo.highResolution) === null || _appDetails$logo$high2 === void 0 ? void 0 : _appDetails$logo$high2.id) !== null && _appDetails$logo$high !== void 0 ? _appDetails$logo$high : appDetails.logo.original.id) : appIconLink.expand({
        appKey: appKey
    });
    return $5fb1a9e12f28a6fb$var$_objectSpread($5fb1a9e12f28a6fb$var$_objectSpread({
        appId: appId,
        appKey: appKey,
        slug: slug,
        heroImage: $5fb1a9e12f28a6fb$var$makeHeroImage(heroImage, makeMediaImage),
        logo: logo,
        highlights: (_highlights$map = highlights === null || highlights === void 0 ? void 0 : highlights.map((highlight)=>$5fb1a9e12f28a6fb$export$39ae7d355c29b45f(highlight, makeMediaImage))) !== null && _highlights$map !== void 0 ? _highlights$map : [],
        moreDetails: moreDetails,
        name: name,
        partner: $5fb1a9e12f28a6fb$export$4e86cdb9bfb37e34(partner, partnerDetailsLink, makeMediaImage),
        privacyPolicyUrl: privacyPolicyUrl,
        screenshots: (_screenshots$map = screenshots === null || screenshots === void 0 ? void 0 : screenshots.map((screenshot)=>$5fb1a9e12f28a6fb$export$a8937c5bf2e03fcb(screenshot, makeMediaImage))) !== null && _screenshots$map !== void 0 ? _screenshots$map : [],
        tagline: (_appDetails$tagline = appDetails.tagline) !== null && _appDetails$tagline !== void 0 ? _appDetails$tagline : '',
        // Tagline is mandatory in the app details form, but historically some apps don't have it
        summary: (_appDetails$summary = appDetails.summary) !== null && _appDetails$summary !== void 0 ? _appDetails$summary : '',
        youtubeId: // Summary is mandatory in the app details form, but historically some apps don't have it
        youtubeId,
        marketingLabels: appDetails.marketingLabels,
        categories: appDetails.categories.map((category)=>({
                name: category.name
            })),
        reviewSummary: $5fb1a9e12f28a6fb$export$b903bb79739c9fdc(appDetails.reviewSummary),
        watchersInfo: $5fb1a9e12f28a6fb$var$makeWatcherInfo(appDetails.watchersInfo),
        productHostingOptions: appDetails.productHostingOptions,
        appScopes: appScopes,
        listingStatus: appDetails.listingStatus,
        releaseDate: releaseDate,
        releaseNotes: releaseNotes,
        releaseSummary: releaseSummary,
        releaseNotesUrl: releaseNotesUrl,
        serverCompatibleProducts: serverCompatibleProducts,
        cloudCompatibleProducts: cloudCompatibleProducts,
        dataCenterCompatibleProducts: dataCenterCompatibleProducts,
        versionCount: (_selectedAppVersionCo = selectedAppVersionConnection.totalCount) !== null && _selectedAppVersionCo !== void 0 ? _selectedAppVersionCo : 0,
        totalVersionCount: totalVersionCount,
        version: version,
        hasDataCenterVersion: !!appDetails.dataCenterAppVersions.totalCount,
        compatibleProducts: (_deployment$compatibl = deployment === null || deployment === void 0 ? void 0 : deployment.compatibleProducts) !== null && _deployment$compatibl !== void 0 ? _deployment$compatibl : [],
        supportDetails: $5fb1a9e12f28a6fb$export$e36a0bc69d7dae53({
            appDetails: appDetails,
            selectedAppVersion: selectedAppVersion,
            hosting: hosting
        })
    }, $5fb1a9e12f28a6fb$var$makeResourceLinks({
        appDetails: appDetails,
        latestVersion: selectedAppVersion,
        appVersionHistoryLink: appVersionHistoryLink,
        artifactDownloadLink: artifactDownloadLink,
        descriptorDownloadLink: descriptorDownloadLink,
        hosting: hosting
    })), {}, {
        createdAt: new Date(appDetails.createdAt),
        distribution: $5fb1a9e12f28a6fb$export$37b9fd23ea152d25(appDetails.distribution, appDataFromSearch === null || appDataFromSearch === void 0 ? void 0 : appDataFromSearch.distribution, hosting),
        installationInstructions: $5fb1a9e12f28a6fb$var$makeInstallationInstructions({
            selectedAppVersion: selectedAppVersion,
            makeMediaImage: makeMediaImage
        }),
        deploymentType: selectedAppVersion === null || selectedAppVersion === void 0 ? void 0 : selectedAppVersion.deployment.__typename,
        paymentModel: selectedAppVersion === null || selectedAppVersion === void 0 ? void 0 : selectedAppVersion.paymentModel,
        programs: $5fb1a9e12f28a6fb$export$75c05eeb38ce87e7(programs),
        licenseType: latestCloudAppVersion === null || latestCloudAppVersion === void 0 ? void 0 : (_latestCloudAppVersio = latestCloudAppVersion.licenseType) === null || _latestCloudAppVersio === void 0 ? void 0 : _latestCloudAppVersio.name
    });
}

});
parcelRegister("7ZOJD", function(module, exports) {

$parcel$export(module.exports, "HostingDisplayName", () => $5d2595d855da188c$export$594f3b666f5ee104);
$parcel$export(module.exports, "HostingTypeToQueryParam", () => $5d2595d855da188c$export$6b3b6105dcf77d16);
$parcel$export(module.exports, "HostingTypeToFiltersQueryParam", () => $5d2595d855da188c$export$1c938211e26a3667);
$parcel$export(module.exports, "HostingQueryParamToHostingType", () => $5d2595d855da188c$export$da3fed25eda5c5c2);

var $ammkg = parcelRequire("ammkg");
const $5d2595d855da188c$export$594f3b666f5ee104 = Object.freeze({
    [(0, $ammkg.AtlassianProductHostingType).Cloud]: 'Cloud',
    [(0, $ammkg.AtlassianProductHostingType).Server]: 'Server',
    [(0, $ammkg.AtlassianProductHostingType).DataCenter]: 'Data Center'
});
const $5d2595d855da188c$export$6b3b6105dcf77d16 = Object.freeze({
    [(0, $ammkg.AtlassianProductHostingType).DataCenter]: 'datacenter',
    [(0, $ammkg.AtlassianProductHostingType).Cloud]: 'cloud',
    [(0, $ammkg.AtlassianProductHostingType).Server]: 'server'
});
const $5d2595d855da188c$export$1c938211e26a3667 = Object.freeze({
    [(0, $ammkg.AtlassianProductHostingType).DataCenter]: 'dataCenter',
    [(0, $ammkg.AtlassianProductHostingType).Cloud]: 'cloud',
    [(0, $ammkg.AtlassianProductHostingType).Server]: 'server'
});
const $5d2595d855da188c$export$da3fed25eda5c5c2 = {
    [$5d2595d855da188c$export$6b3b6105dcf77d16[(0, $ammkg.AtlassianProductHostingType).Cloud]]: (0, $ammkg.AtlassianProductHostingType).Cloud,
    [$5d2595d855da188c$export$6b3b6105dcf77d16[(0, $ammkg.AtlassianProductHostingType).Server]]: (0, $ammkg.AtlassianProductHostingType).Server,
    [$5d2595d855da188c$export$6b3b6105dcf77d16[(0, $ammkg.AtlassianProductHostingType).DataCenter]]: (0, $ammkg.AtlassianProductHostingType).DataCenter
};

});


parcelRegister("dcnzE", function(module, exports) {

$parcel$export(module.exports, "formatVersionRange", () => $99beaeabb1c23751$export$9d2d2deca7a4cd0);
$parcel$export(module.exports, "getProductCompatibilityList", () => $99beaeabb1c23751$export$c1f9a6c25dea3dd6);
$parcel$export(module.exports, "getProductCompatibilitySummary", () => $99beaeabb1c23751$export$9a4ae197e347adc4);
$parcel$export(module.exports, "compatibleWithCloudSupportedProduct", () => $99beaeabb1c23751$export$4ca9f18aa4cbe1cc);
$parcel$export(module.exports, "pickVersionInfo", () => $99beaeabb1c23751$export$d786902a366a68f1);
$parcel$export(module.exports, "getTrustTabPrecondition", () => $99beaeabb1c23751$export$f891133a3f5189cc);

var $kafab = parcelRequire("kafab");
var $7ZOJD = parcelRequire("7ZOJD");

var $ammkg = parcelRequire("ammkg");
const $99beaeabb1c23751$export$9d2d2deca7a4cd0 = (_ref)=>{
    let { minimumVersion: minimumVersion, maximumVersion: maximumVersion } = _ref;
    if (!(minimumVersion && maximumVersion)) return '';
    if (minimumVersion === maximumVersion) return minimumVersion;
    return "".concat(minimumVersion, " - ").concat(maximumVersion);
};
const $99beaeabb1c23751$export$c1f9a6c25dea3dd6 = (compatibilities)=>compatibilities.map((compatibility)=>{
        const { name: name } = compatibility;
        if (compatibility.__typename === (0, $kafab.CompatibleProductTypeValues).CLOUD_PRODUCT) return [
            name,
            (0, $7ZOJD.HostingDisplayName)[(0, $ammkg.AtlassianProductHostingType).Cloud]
        ].join(' ');
        if (compatibility.__typename === (0, $kafab.CompatibleProductTypeValues).SERVER_PRODUCT) {
            const { minimumVersion: minimumVersion, maximumVersion: maximumVersion } = compatibility;
            return [
                name,
                (0, $7ZOJD.HostingDisplayName)[(0, $ammkg.AtlassianProductHostingType).Server],
                $99beaeabb1c23751$export$9d2d2deca7a4cd0({
                    minimumVersion: minimumVersion,
                    maximumVersion: maximumVersion
                })
            ].join(' ');
        }
        if (compatibility.__typename === (0, $kafab.CompatibleProductTypeValues).DATACENTER_PRODUCT) {
            const { minimumVersion: minimumVersion, maximumVersion: maximumVersion } = compatibility;
            return [
                name,
                (0, $7ZOJD.HostingDisplayName)[(0, $ammkg.AtlassianProductHostingType).DataCenter],
                $99beaeabb1c23751$export$9d2d2deca7a4cd0({
                    minimumVersion: minimumVersion,
                    maximumVersion: maximumVersion
                })
            ].join(' ');
        }
        return null;
    }).filter(Boolean);
const $99beaeabb1c23751$export$9a4ae197e347adc4 = (compatibilities)=>$99beaeabb1c23751$export$c1f9a6c25dea3dd6(compatibilities).join(', ').trim();
const $99beaeabb1c23751$export$4ca9f18aa4cbe1cc = (compatibleProducts)=>compatibleProducts.some((product)=>{
        var _product$atlassianPro;
        return (_product$atlassianPro = product.atlassianProduct) === null || _product$atlassianPro === void 0 ? void 0 : _product$atlassianPro.hostingOptions.some((option)=>option === (0, $ammkg.AtlassianProductHostingType).Cloud);
    });
const $99beaeabb1c23751$export$d786902a366a68f1 = (_ref2)=>{
    let { compatibleProducts: compatibleProducts, licenseType: licenseType, paymentModel: paymentModel, releaseDate: releaseDate, releaseNotes: releaseNotes, releaseNotesUrl: releaseNotesUrl, releaseSummary: releaseSummary, version: version, versionCount: versionCount, versionHistoryUrl: versionHistoryUrl } = _ref2;
    return {
        compatibleProducts: compatibleProducts,
        licenseType: licenseType,
        paymentModel: paymentModel,
        releaseDate: releaseDate,
        releaseNotes: releaseNotes,
        releaseNotesUrl: releaseNotesUrl,
        releaseSummary: releaseSummary,
        version: version,
        versionCount: versionCount,
        versionHistoryUrl: versionHistoryUrl
    };
};
const $99beaeabb1c23751$export$f891133a3f5189cc = (selectedHosting, appListing)=>{
    var _appListing$partner;
    return selectedHosting === (0, $7ZOJD.HostingQueryParamToHostingType).cloud && (appListing.deploymentType === (0, $kafab.AppDeployment).ECOSYSTEM_CLOUD || appListing.deploymentType === (0, $kafab.AppDeployment).CONNECT || appListing.deploymentType === (0, $kafab.AppDeployment).INSTRUCTIONAL || appListing.deploymentType === (0, $kafab.AppDeployment).PLUGINS1 || appListing.deploymentType === (0, $kafab.AppDeployment).PLUGINS2) && ((_appListing$partner = appListing.partner) === null || _appListing$partner === void 0 ? void 0 : _appListing$partner.name) !== 'Atlassian';
};

});

parcelRegister("lC7IO", function(module, exports) {

$parcel$export(module.exports, "makeHeaderLozenges", () => $fbc322f58e607901$export$175956644ae58fd1);

var $gykb8 = parcelRequire("gykb8");

var $kafab = parcelRequire("kafab");
parcelRequire("eUqFw");

var $cmZSX = parcelRequire("cmZSX");

var $lHkHI = parcelRequire("lHkHI");
const $fbc322f58e607901$export$c9917a7c61ea175a = (_ref)=>{
    let { categories: categories, showAetherAppListingPage: showAetherAppListingPage } = _ref;
    if (categories.some((category)=>category.name === 'Mobile')) return [
        {
            label: 'Supports Mobile',
            tooltipContent: showAetherAppListingPage ? undefined : 'This app is optimized for mobile experience.'
        }
    ];
    return [];
};
const $fbc322f58e607901$export$48857ff0cf40a4ff = (_ref2)=>{
    let { marketingLabels: marketingLabels, showNewJiraSoftwareLabelFlag: showNewJiraSoftwareLabelFlag, showAetherAppListingPage: showAetherAppListingPage } = _ref2;
    const lozenges = [];
    if (marketingLabels.includes((0, $kafab.AppMarketingLabel).CompatibleWithJSM)) {
        const flavor = 'Jira Service Management';
        lozenges.push({
            label: flavor,
            tooltipContent: showAetherAppListingPage ? undefined : /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                children: [
                    "This app is compatible with ",
                    flavor,
                    "."
                ]
            })
        });
    }
    if (marketingLabels.includes((0, $kafab.AppMarketingLabel).CompatibleWithJSW)) {
        const flavor = showNewJiraSoftwareLabelFlag ? 'Jira' : 'Jira Software';
        lozenges.push({
            label: flavor,
            tooltipContent: showAetherAppListingPage ? undefined : /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                children: [
                    "This app is compatible with ",
                    flavor,
                    "."
                ]
            })
        });
    }
    return lozenges;
};
const $fbc322f58e607901$export$c48c08c6041b12bf = (_ref3)=>{
    let { supportDetails: supportDetails, partnerName: partnerName, supportLink: supportLink, isServerAppEos: isServerAppEos, showAetherAppListingPage: showAetherAppListingPage } = _ref3;
    const { issueTrackerUrl: issueTrackerUrl, supportTicketSystemUrl: supportTicketSystemUrl, emailId: emailId } = (supportDetails === null || supportDetails === void 0 ? void 0 : supportDetails.contact) || {};
    const hasOfficialSupport = supportDetails.isSupported && (issueTrackerUrl || supportTicketSystemUrl || emailId);
    if (isServerAppEos) return [];
    else if (showAetherAppListingPage ? hasOfficialSupport : supportDetails.isSupported) {
        if (!partnerName) return [];
        return [
            {
                label: showAetherAppListingPage ? 'Partner Supported' : 'Supported',
                appearance: showAetherAppListingPage ? 'success' : undefined,
                tooltipContent: showAetherAppListingPage ? undefined : /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                            children: [
                                partnerName,
                                " supports this app."
                            ]
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cmZSX.default), {
                                to: supportLink,
                                children: "Get support"
                            })
                        })
                    ]
                })
            }
        ];
    } else return [
        {
            label: 'Unsupported',
            tooltipContent: showAetherAppListingPage ? undefined : /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                children: "This app isn't formally supported"
            })
        }
    ];
};
const $fbc322f58e607901$export$2e93cbf081872614 = (_ref4)=>{
    let { cloudMigration: cloudMigration = {}, onMigrationLozengeClick: onMigrationLozengeClick, showCloudMigrationLozenge: showCloudMigrationLozenge, showAetherAppListingPage: showAetherAppListingPage } = _ref4;
    if (!showCloudMigrationLozenge) return [];
    const { featureDifferenceDocumentation: featureDifferenceDocumentation, migrationDocumentation: migrationDocumentation } = cloudMigration || {};
    const hasDocumentation = featureDifferenceDocumentation || migrationDocumentation;
    if (!hasDocumentation) return [];
    return [
        {
            label: 'Cloud Migration Assistance',
            appearance: 'inprogress',
            tooltipContent: showAetherAppListingPage ? undefined : /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                children: [
                    "This partner provides links to support your cloud migration journey. Scroll down to the",
                    ' ',
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                        onClick: onMigrationLozengeClick,
                        children: "Resources"
                    }),
                    " section for more details."
                ]
            })
        }
    ];
};
const $fbc322f58e607901$export$175956644ae58fd1 = (_ref5)=>{
    let { supportDetails: supportDetails, partnerName: partnerName, supportLink: supportLink, marketingLabels: marketingLabels, categories: categories, cloudMigration: cloudMigration, onMigrationLozengeClick: onMigrationLozengeClick, showCloudMigrationLozenge: showCloudMigrationLozenge, isServerAppEos: isServerAppEos, showNewJiraSoftwareLabelFlag: showNewJiraSoftwareLabelFlag, showAetherAppListingPage: showAetherAppListingPage } = _ref5;
    return [
        ...$fbc322f58e607901$export$c48c08c6041b12bf({
            supportDetails: supportDetails,
            partnerName: partnerName,
            supportLink: supportLink,
            isServerAppEos: isServerAppEos,
            showAetherAppListingPage: showAetherAppListingPage
        }),
        ...showAetherAppListingPage ? [] : $fbc322f58e607901$export$48857ff0cf40a4ff({
            marketingLabels: marketingLabels,
            showNewJiraSoftwareLabelFlag: showNewJiraSoftwareLabelFlag
        }),
        ...showAetherAppListingPage ? [] : $fbc322f58e607901$export$c9917a7c61ea175a({
            categories: categories
        }),
        ...$fbc322f58e607901$export$2e93cbf081872614({
            cloudMigration: cloudMigration,
            onMigrationLozengeClick: onMigrationLozengeClick,
            showCloudMigrationLozenge: showCloudMigrationLozenge,
            showAetherAppListingPage: showAetherAppListingPage
        })
    ].filter(Boolean);
};

});

parcelRegister("iXji1", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcccb339345fb42b$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $ZN2Lb = parcelRequire("ZN2Lb");
var $gTOQV = parcelRequire("gTOQV");
var $71CV8 = parcelRequire("71CV8");

var $drftW = parcelRequire("drftW");

var $eQeMb = parcelRequire("eQeMb");

var $j0gMm = parcelRequire("j0gMm");

var $7ZOJD = parcelRequire("7ZOJD");

var $ammkg = parcelRequire("ammkg");

var $bJ1lp = parcelRequire("bJ1lp");

var $eUqFw = parcelRequire("eUqFw");

var $c1ZLO = parcelRequire("c1ZLO");

var $3b5mb = parcelRequire("3b5mb");

var $fphkl = parcelRequire("fphkl");

var $dblLG = parcelRequire("dblLG");

var $lHkHI = parcelRequire("lHkHI");
const $dcccb339345fb42b$var$_excluded = [
    "triggerRef"
];
function $dcccb339345fb42b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dcccb339345fb42b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dcccb339345fb42b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dcccb339345fb42b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $dcccb339345fb42b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $dcccb339345fb42b$export$20ba91d7b3affc80 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $bJ1lp.default), {
    target: "ei9pr5n0",
    label: "HostingSelectIcon"
})({
    name: "18eau0h",
    styles: "height:18px;width:18px;"
});
const $dcccb339345fb42b$export$f9885a8ac96d941c = (0, $3UXZ8.default)("div", {
    target: "ei9pr5n1",
    label: "TriggerContent"
})("display:flex;align-items:center;", $dcccb339345fb42b$export$20ba91d7b3affc80, "{margin-right:var(--ds-space-075, 6px);}");
const $dcccb339345fb42b$export$7f20f48978e08a04 = (0, $3UXZ8.default)("div", {
    target: "ei9pr5n2",
    label: "SingleHostingDiv"
})({
    padding: "var(--ds-space-075, 6px)".concat(" ", "var(--ds-space-200, 16px)")
}, "");
const $dcccb339345fb42b$var$sortHostingTypes = (hostingTypes)=>[
        (0, $ammkg.AtlassianProductHostingType).Cloud,
        (0, $ammkg.AtlassianProductHostingType).Server,
        (0, $ammkg.AtlassianProductHostingType).DataCenter
    ].filter((orderedHostingType)=>hostingTypes.some((hostingType)=>hostingType === orderedHostingType));
const $dcccb339345fb42b$var$triggerButtonProps = {
    appearance: 'default',
    iconAfter: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($drftW))), {})
};
// eslint-disable-next-line max-lines-per-function
const $dcccb339345fb42b$var$HostingSelect = (props)=>{
    const [dataCenterCompatModalOpen, setDataCenterCompatModalOpen] = (0, $eUqFw.useState)(false);
    const [cloudCompatModalOpen, setCloudCompatModalOpen] = (0, $eUqFw.useState)(false);
    const appHasCloudHosting = props.productHostingOptions.includes((0, $ammkg.AtlassianProductHostingType).Cloud);
    const showFullDropdown = props.productHostingOptions.length > 1 || props.appCompatibleWithDcEnabledProduct || !appHasCloudHosting;
    const handleHostingOptionClick = (hostingOption, hostingOptionKind)=>{
        if (props.onHostingOptionClick) props.onHostingOptionClick(hostingOption, hostingOptionKind);
        if (hostingOptionKind === (0, $3b5mb.HostingOptionKind).NATIVE && props.onChange) props.onChange(hostingOption);
        if (hostingOptionKind === (0, $3b5mb.HostingOptionKind).INFORMATIONAL) {
            if (hostingOption === (0, $ammkg.AtlassianProductHostingType).Cloud) setCloudCompatModalOpen(true);
            else if (hostingOption === (0, $ammkg.AtlassianProductHostingType).DataCenter) setDataCenterCompatModalOpen(true);
        }
    };
    const handleOpenChange = (_ref)=>{
        let { isOpen: isOpen } = _ref;
        if (isOpen && props.onOpen) props.onOpen();
    };
    const handleMoreHostingOptionsItemClick = (hosting)=>handleHostingOptionClick(hosting, (0, $3b5mb.HostingOptionKind).INFORMATIONAL);
    const handleDataCenterCompatModalClose = ()=>setDataCenterCompatModalOpen(false);
    const handleCloudCompatModalClose = ()=>setCloudCompatModalOpen(false);
    const triggerContent = /*#__PURE__*/ (0, $lHkHI.jsxs)($dcccb339345fb42b$export$f9885a8ac96d941c, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($dcccb339345fb42b$export$20ba91d7b3affc80, {
                type: props.selected,
                primaryColor: (0, $j0gMm.B200)
            }),
            (0, $7ZOJD.HostingDisplayName)[props.selected]
        ]
    });
    if (!showFullDropdown) return /*#__PURE__*/ (0, $lHkHI.jsx)($dcccb339345fb42b$export$7f20f48978e08a04, {
        children: triggerContent
    });
    const possibleHostingTypes = $dcccb339345fb42b$var$sortHostingTypes(props.productHostingOptions);
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dblLG.default), {
                partnerSupportUrl: props.partnerSupportUrl,
                isOpen: dataCenterCompatModalOpen,
                onClose: handleDataCenterCompatModalClose,
                onContactPartnerClick: props.onContactPartnerClick
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fphkl.default), {
                isOpen: cloudCompatModalOpen,
                partnerSupportUrl: props.partnerSupportUrl,
                onClose: handleCloudCompatModalClose,
                onContactPartnerClick: props.onContactPartnerClick
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $ZN2Lb.default), {
                appearance: "default",
                trigger: (_ref2)=>{
                    let { triggerRef: triggerRef } = _ref2, triggerProps = (0, $bwPfh.default)(_ref2, $dcccb339345fb42b$var$_excluded);
                    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), $dcccb339345fb42b$var$_objectSpread($dcccb339345fb42b$var$_objectSpread($dcccb339345fb42b$var$_objectSpread({
                        ref: triggerRef
                    }, $dcccb339345fb42b$var$triggerButtonProps), triggerProps), {}, {
                        children: triggerContent
                    }));
                },
                onOpenChange: handleOpenChange,
                placement: "bottom-end",
                testId: (0, $c1ZLO.TEST_ID).HOSTING_DROPDOWN,
                children: [
                    !appHasCloudHosting && props.alternateCloudListingLink && /*#__PURE__*/ (0, $lHkHI.jsx)($dcccb339345fb42b$export$80a7df32907e00ee, {
                        hosting: (0, $ammkg.AtlassianProductHostingType).Cloud,
                        onClick: ()=>handleHostingOptionClick((0, $ammkg.AtlassianProductHostingType).Cloud, (0, $3b5mb.HostingOptionKind).ALTERNATE),
                        href: props.alternateCloudListingLink
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $71CV8.default), {
                        title: "Hosting Types",
                        children: possibleHostingTypes.map((hosting)=>/*#__PURE__*/ (0, $lHkHI.jsx)($dcccb339345fb42b$export$80a7df32907e00ee, {
                                hosting: hosting,
                                onClick: ()=>handleHostingOptionClick(hosting, (0, $3b5mb.HostingOptionKind).NATIVE)
                            }, hosting))
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($dcccb339345fb42b$export$8a5ef01824d589a0, {
                        alternateCloudListingLink: props.alternateCloudListingLink,
                        appCompatibleWithDcEnabledProduct: props.appCompatibleWithDcEnabledProduct,
                        appCompatibleWithCloudSupportedProduct: props.appCompatibleWithCloudSupportedProduct,
                        appHasCloudHostingOption: appHasCloudHosting,
                        partnerSupportUrl: props.partnerSupportUrl,
                        onItemClick: handleMoreHostingOptionsItemClick
                    })
                ]
            })
        ]
    });
};
const $dcccb339345fb42b$export$8a5ef01824d589a0 = (props)=>{
    const showDCCompatibility = props.appCompatibleWithDcEnabledProduct;
    const appHasCloudVariant = props.appHasCloudHostingOption || props.alternateCloudListingLink;
    const showCloudCompatibility = props.appCompatibleWithCloudSupportedProduct && !appHasCloudVariant;
    const showLookingForHelpSection = showDCCompatibility || showCloudCompatibility;
    if (!showLookingForHelpSection) return null;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $71CV8.default), {
        title: "Looking for?",
        children: [
            showDCCompatibility && /*#__PURE__*/ (0, $lHkHI.jsx)($dcccb339345fb42b$export$80a7df32907e00ee, {
                hosting: (0, $ammkg.AtlassianProductHostingType).DataCenter,
                onClick: ()=>props.onItemClick((0, $ammkg.AtlassianProductHostingType).DataCenter)
            }),
            showCloudCompatibility && /*#__PURE__*/ (0, $lHkHI.jsx)($dcccb339345fb42b$export$80a7df32907e00ee, {
                hosting: (0, $ammkg.AtlassianProductHostingType).Cloud,
                onClick: ()=>props.onItemClick((0, $ammkg.AtlassianProductHostingType).Cloud)
            })
        ]
    });
};
const $dcccb339345fb42b$export$80a7df32907e00ee = (_ref3)=>{
    let { href: href, hosting: hosting, onClick: onClick } = _ref3;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gTOQV.default), {
        elemAfter: href ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eQeMb))), {
            size: "small",
            primaryColor: (0, $j0gMm.N200)
        }) : null,
        elemBefore: /*#__PURE__*/ (0, $lHkHI.jsx)($dcccb339345fb42b$export$20ba91d7b3affc80, {
            type: hosting,
            primaryColor: (0, $j0gMm.B200)
        }),
        onClick: onClick,
        target: "_blank",
        href: href,
        children: (0, $7ZOJD.HostingDisplayName)[hosting]
    });
};
var $dcccb339345fb42b$export$2e2bcd8739ae039 = $dcccb339345fb42b$var$HostingSelect;

});
parcelRegister("bJ1lp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8894f0a337b65f97$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $ammkg = parcelRequire("ammkg");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $8894f0a337b65f97$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8894f0a337b65f97$var$CloudIconSVG = (primaryColor)=>/*#__PURE__*/ (0, $lHkHI.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "presentation",
        children: /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
            d: "M13.06 3.104c-2.956.102-5.454 2.076-6.252 4.834l-.027.096-.089.011C4.71 8.343 3.2 10.08 3.2 12.2l.009.208-.07.025A3.37 3.37 0 001 15.6C1 17.481 2.475 19 4.4 19h13.4c2.852 0 5.2-2.348 5.2-5.2l-.005-.23a5.204 5.204 0 00-2.881-4.403l-.151-.071-.027-.228A6.699 6.699 0 0013.3 3.1l-.24.004zM13.3 5.1c2.585 0 4.7 2.09 4.7 4.7a1 1 0 00.718.96A3.2 3.2 0 0121 13.8c0 1.748-1.452 3.2-3.2 3.2H4.4c-.807 0-1.4-.61-1.4-1.4 0-.743.525-1.328 1.26-1.394l.14-.006a1 1 0 00.949-1.316c-.09-.267-.149-.546-.149-.684 0-1.237.942-2.2 2.1-2.2h.3a1 1 0 00.99-.859C8.922 6.82 10.912 5.1 13.3 5.1z",
            fill: primaryColor
        })
    });
const $8894f0a337b65f97$var$ServerIconSVG = (primaryColor)=>/*#__PURE__*/ (0, $lHkHI.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "presentation",
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)("g", {
            fill: primaryColor,
            fillRule: "nonzero",
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
                    d: "M20 2H4a1 1 0 00-1 1v16a3 3 0 003 3h12a3 3 0 003-3V3a1 1 0 00-1-1zM5 4h14v15a1 1 0 01-1 1H6l-.117-.007A1 1 0 015 19V4z"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
                    d: "M12.1 9.5a1 1 0 01.117 1.993l-.117.007H12a1 1 0 01-.117-1.993L12 9.5h.1zM15 16a1 1 0 01.117 1.993L15 18H9a1 1 0 01-.117-1.993L9 16h6zM15 6a1 1 0 01.117 1.993L15 8H9a1 1 0 01-.117-1.993L9 6h6zM15 13a1 1 0 01.117 1.993L15 15H9a1 1 0 01-.117-1.993L9 13h6z"
                })
            ]
        })
    });
const $8894f0a337b65f97$var$DataCenterIconSVG = (primaryColor)=>/*#__PURE__*/ (0, $lHkHI.jsx)("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "presentation",
        children: /*#__PURE__*/ (0, $lHkHI.jsx)("g", {
            fill: "none",
            fillRule: "evenodd",
            children: /*#__PURE__*/ (0, $lHkHI.jsxs)("g", {
                fill: primaryColor,
                fillRule: "nonzero",
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
                        d: "M19 2H5a2 2 0 00-2 2v16a2 2 0 002 2h14a2 2 0 002-2V4a2 2 0 00-2-2zM5 4h14v16H5V4z"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
                        d: "M20 8a1 1 0 01.117 1.993L20 10H4a1 1 0 01-.117-1.993L4 8h16zM20 14a1 1 0 01.117 1.993L20 16H4a1 1 0 01-.117-1.993L4 14h16zM12 5a1 1 0 01.117 1.993L12 7H7a1 1 0 01-.117-1.993L7 5h5zM17 5a1 1 0 01.117 1.993L17 7h-.246a1 1 0 01-.117-1.993L16.754 5H17zM12 11a1 1 0 01.117 1.993L12 13H7a1 1 0 01-.117-1.993L7 11h5zM17 11a1 1 0 01.117 1.993L17 13h-.246a1 1 0 01-.117-1.993l.117-.007H17zM12 17a1 1 0 01.117 1.993L12 19H7a1 1 0 01-.117-1.993L7 17h5zM17 17a1 1 0 01.117 1.993L17 19h-.246a1 1 0 01-.117-1.993l.117-.007H17z"
                    })
                ]
            })
        })
    });
const $8894f0a337b65f97$var$hostingIconMap = {
    [(0, $ammkg.AtlassianProductHostingType).Cloud]: $8894f0a337b65f97$var$CloudIconSVG,
    [(0, $ammkg.AtlassianProductHostingType).Server]: $8894f0a337b65f97$var$ServerIconSVG,
    [(0, $ammkg.AtlassianProductHostingType).DataCenter]: $8894f0a337b65f97$var$DataCenterIconSVG
};
const $8894f0a337b65f97$var$IconContainer = (0, $3UXZ8.default)("span", {
    target: "e1qojvju0",
    label: "IconContainer"
})({
    name: "h2i1cl",
    styles: "display:inline-flex;width:24px;height:24px;align-items:center;justify-content:center;svg{width:100%;height:100%;}"
});
const $8894f0a337b65f97$var$HostingIcon = (props)=>{
    const hostingIcon = $8894f0a337b65f97$var$hostingIconMap[props.type];
    const primaryColor = props.primaryColor || (0, $j0gMm.N400);
    return /*#__PURE__*/ (0, $lHkHI.jsx)($8894f0a337b65f97$var$IconContainer, {
        className: props.className,
        children: hostingIcon(primaryColor)
    });
};
var $8894f0a337b65f97$export$2e2bcd8739ae039 = $8894f0a337b65f97$var$HostingIcon;

});

parcelRegister("3b5mb", function(module, exports) {

$parcel$export(module.exports, "HostingOptionKind", () => $25068de80dd9ec88$export$5c970e7fb75e8319);
$parcel$export(module.exports, "MediaViewerResource", () => $25068de80dd9ec88$export$39534e55dfd9f85b);
const $25068de80dd9ec88$export$ed22dc0af0ea3ca7 = Object.freeze({
    TRY: 'try',
    BUY: 'buy',
    GET: 'get'
});
const $25068de80dd9ec88$export$33374b49aa1282cd = Object.freeze({
    PRIMARY: 'primary',
    SECONDARY: 'secondary'
});
const $25068de80dd9ec88$export$5c970e7fb75e8319 = Object.freeze({
    // The hosting option is native to the listing
    // and clicking on it would just switch hosting types
    NATIVE: 'native',
    // The hosting option links to another listing
    ALTERNATE: 'alternate',
    // The hosting option is not officially supported, and
    // leads to informational content
    INFORMATIONAL: 'informational'
});
const $25068de80dd9ec88$export$39534e55dfd9f85b = Object.freeze({
    Highlight: 'Highlight image',
    Screenshot: 'Screenshot'
});

});

parcelRegister("fphkl", function(module, exports) {

$parcel$export(module.exports, "default", () => $b376a1a0ed44f7f3$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $l9NvU = parcelRequire("l9NvU");
var $jSigD = parcelRequire("jSigD");
var $fHOFY = parcelRequire("fHOFY");

var $ivTMz = parcelRequire("ivTMz");
var $j0gMm = parcelRequire("j0gMm");

var $l501X = parcelRequire("l501X");
parcelRequire("eUqFw");


var $ogjlV = parcelRequire("ogjlV");

var $lHkHI = parcelRequire("lHkHI");
function $b376a1a0ed44f7f3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b376a1a0ed44f7f3$var$CloudHero = (0, $3UXZ8.default)("div", {
    target: "ekstmfl0",
    label: "CloudHero"
})("background:", (0, $j0gMm).B300, ";border-radius:", (0, $ivTMz.borderRadius)(), "px ", (0, $ivTMz.borderRadius)(), "px 0 0;padding-top:10px;");
const $b376a1a0ed44f7f3$var$heroImgOffset = 55;
const $b376a1a0ed44f7f3$var$CloudHeroImg = (0, $3UXZ8.default)("img", {
    target: "ekstmfl1",
    label: "CloudHeroImg"
})("width:150px;width:clamp(200px,14vw,300px);position:relative;bottom:", -$b376a1a0ed44f7f3$var$heroImgOffset, "px;display:block;margin:auto;");
const $b376a1a0ed44f7f3$var$H3 = (0, $3UXZ8.default)("h3", {
    target: "ekstmfl2",
    label: "H3"
})({
    name: "1vlzvh1",
    styles: "text-align:center;margin-bottom:var(--ds-space-250, 20px);"
});
const $b376a1a0ed44f7f3$var$P = (0, $3UXZ8.default)("p", {
    target: "ekstmfl3",
    label: "P"
})({
    name: "15yy7hk",
    styles: "line-height:1.4;font-size:16px;margin-top:var(--ds-space-100, 8px);"
});
const $b376a1a0ed44f7f3$var$ModalContent = (0, $3UXZ8.default)("div", {
    target: "ekstmfl4",
    label: "ModalContent"
})("padding:", $b376a1a0ed44f7f3$var$heroImgOffset + 24, "px 30px var(--ds-space-025, 2px) 30px;");
const $b376a1a0ed44f7f3$var$CloudDescriptionContent = (0, $3UXZ8.default)("p", {
    target: "ekstmfl5",
    label: "CloudDescriptionContent"
})({
    name: "6xix1i",
    styles: "font-size:16px;"
});
const $b376a1a0ed44f7f3$var$CustomModalBody = (0, $3UXZ8.default)("div", {
    target: "ekstmfl6",
    label: "CustomModalBody"
})({
    name: "1v8x7dw",
    styles: "overflow:auto;"
});
function $b376a1a0ed44f7f3$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fHOFY.default), {
        children: props.isOpen && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $l9NvU.default), {
            onClose: props.onClose,
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsxs)($b376a1a0ed44f7f3$var$CustomModalBody, {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)($b376a1a0ed44f7f3$var$CloudHero, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)($b376a1a0ed44f7f3$var$CloudHeroImg, {
                                alt: "cloud computing icon",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ogjlV)))
                            })
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsxs)($b376a1a0ed44f7f3$var$ModalContent, {
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)($b376a1a0ed44f7f3$var$H3, {
                                    children: "Cloud availability"
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)($b376a1a0ed44f7f3$var$CloudDescriptionContent, {
                                    children: "A cloud version of this app is currently not available."
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsxs)($b376a1a0ed44f7f3$var$P, {
                                    children: [
                                        props.partnerSupportUrl ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                                            href: props.partnerSupportUrl,
                                            onClick: ()=>{
                                                var _props$onContactPartn;
                                                return (_props$onContactPartn = props.onContactPartnerClick) === null || _props$onContactPartn === void 0 ? void 0 : _props$onContactPartn.call(props, (0, $00af0a8f205121a0$export$971c039c64a0774e));
                                            },
                                            children: "Contact the vendor"
                                        }) : 'Contact the vendor',
                                        ' ',
                                        "to let them know that you are interested to try this app for cloud."
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jSigD.default), {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                        appearance: "primary",
                        onClick: props.onClose,
                        children: "Dismiss"
                    })
                })
            ]
        })
    });
}

});
// Analytics containers
const $00af0a8f205121a0$export$d1943c4b6964a710 = 'appListingPricingTab';
const $00af0a8f205121a0$export$54e648c99ac705c6 = 'siteSelector';
const $00af0a8f205121a0$export$e8385e875bfd6f8 = 'additionalPricingExample';
const $00af0a8f205121a0$export$bd7ed419728817da = 'contactAdmin';
const $00af0a8f205121a0$export$267249669a096d26 = 'installApp';
const $00af0a8f205121a0$export$dc7ae51982cae8d6 = 'inputUserCount';
const $00af0a8f205121a0$export$96ca82d45a7ad67c = 'reviewComplianceLink';
const $00af0a8f205121a0$export$711e210d7cf13991 = 'reviewComplianceModalCloseButton';
const $00af0a8f205121a0$export$787833f59855a68e = 'userProfilePage';
const $00af0a8f205121a0$export$aa74b9e21350016d = 'reviewComplianceModal';
const $00af0a8f205121a0$export$29cb5afd0489bc78 = 'artifactResourceLink';
const $00af0a8f205121a0$export$eaeed851e7a83564 = 'descriptorResourceLink';
const $00af0a8f205121a0$export$23ec5961b6e4e6bb = 'documentationResourceLink';
const $00af0a8f205121a0$export$bcd2429b485f23fe = 'eulaResourceLink';
const $00af0a8f205121a0$export$6c23c94d91724b84 = 'writeReviewButton';
const $00af0a8f205121a0$export$a0e6ba5ad7884ca5 = 'readMoreReviewButton';
const $00af0a8f205121a0$export$75b4ce23fab07064 = 'sortReviewButton';
const $00af0a8f205121a0$export$971c039c64a0774e = 'cloud';
const $00af0a8f205121a0$export$bfef0f1a8ee0c36e = 'dataCenter';

parcelRegister("ogjlV", function(module, exports) {
module.exports = new URL("cloud-graphic.d2d73239.svg", import.meta.url).toString();

});


parcelRegister("dblLG", function(module, exports) {

$parcel$export(module.exports, "default", () => $998d30268500d5dc$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $l9NvU = parcelRequire("l9NvU");
var $jSigD = parcelRequire("jSigD");
var $fHOFY = parcelRequire("fHOFY");

var $ivTMz = parcelRequire("ivTMz");
var $j0gMm = parcelRequire("j0gMm");

var $l501X = parcelRequire("l501X");
parcelRequire("eUqFw");


var $ufvfD = parcelRequire("ufvfD");

var $lHkHI = parcelRequire("lHkHI");
function $998d30268500d5dc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $998d30268500d5dc$var$DataCenterHero = (0, $3UXZ8.default)("div", {
    target: "e1tk11ic0",
    label: "DataCenterHero"
})("background:", (0, $j0gMm).B300, ";border-radius:", (0, $ivTMz.borderRadius)(), "px ", (0, $ivTMz.borderRadius)(), "px 0 0;");
const $998d30268500d5dc$var$heroImgOffset = 45;
const $998d30268500d5dc$var$DataCenterHeroImg = (0, $3UXZ8.default)("img", {
    target: "e1tk11ic1",
    label: "DataCenterHeroImg"
})("width:150px;width:clamp(100px,10vw,200px);position:relative;bottom:", -$998d30268500d5dc$var$heroImgOffset, "px;display:block;margin:auto;");
const $998d30268500d5dc$var$ModalContent = (0, $3UXZ8.default)("div", {
    target: "e1tk11ic2",
    label: "ModalContent"
})("padding:", $998d30268500d5dc$var$heroImgOffset + 2, "px var(--ds-space-250, 20px) var(--ds-space-025, 2px) var(--ds-space-250, 20px);");
const $998d30268500d5dc$var$H2 = (0, $3UXZ8.default)("h2", {
    target: "e1tk11ic3",
    label: "H2"
})({
    name: "xi606m",
    styles: "text-align:center;"
});
const $998d30268500d5dc$var$P = (0, $3UXZ8.default)("p", {
    target: "e1tk11ic4",
    label: "P"
})({
    name: "qvgfri",
    styles: "line-height:1.4;h3 ~ &{margin-top:var(--ds-space-100, 8px);}"
});
const $998d30268500d5dc$var$H3 = (0, $3UXZ8.default)("h3", {
    target: "e1tk11ic5",
    label: "H3"
})({
    name: "gx0lhm",
    styles: "margin-bottom:0;"
});
const $998d30268500d5dc$var$CustomModalBody = (0, $3UXZ8.default)("div", {
    target: "e1tk11ic6",
    label: "CustomModalBody"
})({
    name: "1v8x7dw",
    styles: "overflow:auto;"
});
function $998d30268500d5dc$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fHOFY.default), {
        children: props.isOpen && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $l9NvU.default), {
            onClose: props.onClose,
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsxs)($998d30268500d5dc$var$CustomModalBody, {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)($998d30268500d5dc$var$DataCenterHero, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)($998d30268500d5dc$var$DataCenterHeroImg, {
                                alt: "data center icon graphic",
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($ufvfD)))
                            })
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsxs)($998d30268500d5dc$var$ModalContent, {
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)($998d30268500d5dc$var$H2, {
                                    children: "Data Center compatibility"
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)($998d30268500d5dc$var$P, {
                                    children: "A Data Center approved version of this app is not currently available. Only apps meeting a set of performance requirements for large, clustered environments are approved for Data Center."
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)($998d30268500d5dc$var$H3, {
                                    children: "Trying server apps"
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsxs)($998d30268500d5dc$var$P, {
                                    children: [
                                        "While Server apps are built for single-server deployments, many customers successfully install them in Data Center environments. Atlassian recommends you",
                                        ' ',
                                        props.partnerSupportUrl ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                                            href: props.partnerSupportUrl,
                                            onClick: ()=>{
                                                var _props$onContactPartn;
                                                return (_props$onContactPartn = props.onContactPartnerClick) === null || _props$onContactPartn === void 0 ? void 0 : _props$onContactPartn.call(props, (0, $00af0a8f205121a0$export$bfef0f1a8ee0c36e));
                                            },
                                            children: "contact the vendor"
                                        }) : 'contact the vendor',
                                        ' ',
                                        "to determine compatibility at scale."
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jSigD.default), {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                        appearance: "primary",
                        onClick: props.onClose,
                        children: "Dismiss"
                    })
                })
            ]
        })
    });
}

});
parcelRegister("ufvfD", function(module, exports) {
module.exports = new URL("data-center-graphic.5467e80d.svg", import.meta.url).toString();

});



parcelRegister("jrrQv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e276238666cc4ebe$export$2e2bcd8739ae039);
/* HostingSelectV2.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $ZN2Lb = parcelRequire("ZN2Lb");
var $gTOQV = parcelRequire("gTOQV");
var $71CV8 = parcelRequire("71CV8");

var $drftW = parcelRequire("drftW");

var $eQeMb = parcelRequire("eQeMb");

var $j0gMm = parcelRequire("j0gMm");

var $cCrLo = parcelRequire("cCrLo");
var $eu8X4 = parcelRequire("eu8X4");

var $7ZOJD = parcelRequire("7ZOJD");

var $ammkg = parcelRequire("ammkg");

var $c1ZLO = parcelRequire("c1ZLO");

var $3b5mb = parcelRequire("3b5mb");

var $fphkl = parcelRequire("fphkl");

var $dblLG = parcelRequire("dblLG");

var $lHkHI = parcelRequire("lHkHI");
const $e276238666cc4ebe$var$_excluded = [
    "as",
    "style"
], $e276238666cc4ebe$var$_excluded2 = [
    "as",
    "style"
], $e276238666cc4ebe$var$_excluded3 = [
    "as",
    "style"
], $e276238666cc4ebe$var$_excluded4 = [
    "as",
    "style"
], $e276238666cc4ebe$var$_excluded5 = [
    "triggerRef"
];
function $e276238666cc4ebe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e276238666cc4ebe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e276238666cc4ebe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e276238666cc4ebe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e276238666cc4ebe$export$56e47eae26aece9e = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $e276238666cc4ebe$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $e276238666cc4ebe$var$_objectSpread($e276238666cc4ebe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1ns9 _18u0y2ex",
            __cmplp.className
        ])
    }));
});
const $e276238666cc4ebe$export$f9885a8ac96d941c = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $e276238666cc4ebe$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $e276238666cc4ebe$var$_objectSpread($e276238666cc4ebe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4cvr1h6o _1e0c1txw",
            __cmplp.className
        ])
    }));
});
const $e276238666cc4ebe$export$f5fd4444a5c30a63 = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $e276238666cc4ebe$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $e276238666cc4ebe$var$_objectSpread($e276238666cc4ebe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l _18u01eps",
            __cmplp.className
        ])
    }));
});
const $e276238666cc4ebe$export$6fc77960e7e15faf = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $e276238666cc4ebe$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $e276238666cc4ebe$var$_objectSpread($e276238666cc4ebe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1ul91lit",
            __cmplp.className
        ])
    }));
});
const $e276238666cc4ebe$var$sortHostingTypes = (hostingTypes)=>[
        (0, $ammkg.AtlassianProductHostingType).Cloud,
        (0, $ammkg.AtlassianProductHostingType).Server,
        (0, $ammkg.AtlassianProductHostingType).DataCenter
    ].filter((orderedHostingType)=>hostingTypes.some((hostingType)=>hostingType === orderedHostingType));
const $e276238666cc4ebe$var$triggerButtonProps = {
    appearance: 'subtle',
    iconAfter: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($drftW))), {})
};
// eslint-disable-next-line max-lines-per-function
const $e276238666cc4ebe$var$HostingSelectV2 = (props)=>{
    const [dataCenterCompatModalOpen, setDataCenterCompatModalOpen] = (0, $eUqFw.useState)(false);
    const [cloudCompatModalOpen, setCloudCompatModalOpen] = (0, $eUqFw.useState)(false);
    const appHasCloudHosting = props.productHostingOptions.includes((0, $ammkg.AtlassianProductHostingType).Cloud);
    const showFullDropdown = props.productHostingOptions.length > 1 || props.appCompatibleWithDcEnabledProduct || !appHasCloudHosting;
    const handleHostingOptionClick = (hostingOption, hostingOptionKind)=>{
        if (props.onHostingOptionClick) props.onHostingOptionClick(hostingOption, hostingOptionKind);
        if (hostingOptionKind === (0, $3b5mb.HostingOptionKind).NATIVE && props.onChange) props.onChange(hostingOption);
        if (hostingOptionKind === (0, $3b5mb.HostingOptionKind).INFORMATIONAL) {
            if (hostingOption === (0, $ammkg.AtlassianProductHostingType).Cloud) setCloudCompatModalOpen(true);
            else if (hostingOption === (0, $ammkg.AtlassianProductHostingType).DataCenter) setDataCenterCompatModalOpen(true);
        }
    };
    const handleOpenChange = (_ref5)=>{
        let { isOpen: isOpen } = _ref5;
        if (isOpen && props.onOpen) props.onOpen();
    };
    const handleMoreHostingOptionsItemClick = (hosting)=>handleHostingOptionClick(hosting, (0, $3b5mb.HostingOptionKind).INFORMATIONAL);
    const handleDataCenterCompatModalClose = ()=>setDataCenterCompatModalOpen(false);
    const handleCloudCompatModalClose = ()=>setCloudCompatModalOpen(false);
    if (!showFullDropdown) return /*#__PURE__*/ (0, $lHkHI.jsx)($e276238666cc4ebe$export$f5fd4444a5c30a63, {
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)($e276238666cc4ebe$export$f9885a8ac96d941c, {
            children: [
                "Showing details for ",
                (0, $7ZOJD.HostingDisplayName)[props.selected]
            ]
        })
    });
    const possibleHostingTypes = $e276238666cc4ebe$var$sortHostingTypes(props.productHostingOptions);
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dblLG.default), {
                partnerSupportUrl: props.partnerSupportUrl,
                isOpen: dataCenterCompatModalOpen,
                onClose: handleDataCenterCompatModalClose,
                onContactPartnerClick: props.onContactPartnerClick
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fphkl.default), {
                isOpen: cloudCompatModalOpen,
                partnerSupportUrl: props.partnerSupportUrl,
                onClose: handleCloudCompatModalClose,
                onContactPartnerClick: props.onContactPartnerClick
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $ZN2Lb.default), {
                appearance: "default",
                trigger: (_ref6)=>{
                    let { triggerRef: triggerRef } = _ref6, triggerProps = (0, $bwPfh.default)(_ref6, $e276238666cc4ebe$var$_excluded5);
                    return /*#__PURE__*/ (0, $lHkHI.jsx)($e276238666cc4ebe$export$56e47eae26aece9e, {
                        ref: triggerRef,
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eu8X4.Button), $e276238666cc4ebe$var$_objectSpread($e276238666cc4ebe$var$_objectSpread($e276238666cc4ebe$var$_objectSpread({}, $e276238666cc4ebe$var$triggerButtonProps), triggerProps), {}, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsxs)($e276238666cc4ebe$export$f9885a8ac96d941c, {
                                children: [
                                    "View for: ",
                                    (0, $7ZOJD.HostingDisplayName)[props.selected]
                                ]
                            })
                        }))
                    });
                },
                onOpenChange: handleOpenChange,
                placement: "bottom-start",
                testId: (0, $c1ZLO.TEST_ID).HOSTING_DROPDOWN,
                children: [
                    !appHasCloudHosting && props.alternateCloudListingLink && /*#__PURE__*/ (0, $lHkHI.jsx)($e276238666cc4ebe$export$80a7df32907e00ee, {
                        hosting: (0, $ammkg.AtlassianProductHostingType).Cloud,
                        onClick: ()=>handleHostingOptionClick((0, $ammkg.AtlassianProductHostingType).Cloud, (0, $3b5mb.HostingOptionKind).ALTERNATE),
                        href: props.alternateCloudListingLink
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $71CV8.default), {
                        title: "Hosting Types",
                        children: possibleHostingTypes.map((hosting)=>/*#__PURE__*/ (0, $lHkHI.jsx)($e276238666cc4ebe$export$80a7df32907e00ee, {
                                hosting: hosting,
                                onClick: ()=>handleHostingOptionClick(hosting, (0, $3b5mb.HostingOptionKind).NATIVE)
                            }, hosting))
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($e276238666cc4ebe$export$8a5ef01824d589a0, {
                        alternateCloudListingLink: props.alternateCloudListingLink,
                        appCompatibleWithDcEnabledProduct: props.appCompatibleWithDcEnabledProduct,
                        appCompatibleWithCloudSupportedProduct: props.appCompatibleWithCloudSupportedProduct,
                        appHasCloudHostingOption: appHasCloudHosting,
                        partnerSupportUrl: props.partnerSupportUrl,
                        onItemClick: handleMoreHostingOptionsItemClick
                    })
                ]
            })
        ]
    });
};
const $e276238666cc4ebe$export$8a5ef01824d589a0 = (props)=>{
    const showDCCompatibility = props.appCompatibleWithDcEnabledProduct;
    const appHasCloudVariant = props.appHasCloudHostingOption || props.alternateCloudListingLink;
    const showCloudCompatibility = props.appCompatibleWithCloudSupportedProduct && !appHasCloudVariant;
    const showLookingForHelpSection = showDCCompatibility || showCloudCompatibility;
    if (!showLookingForHelpSection) return null;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $71CV8.default), {
        title: "Looking for?",
        children: [
            showDCCompatibility && /*#__PURE__*/ (0, $lHkHI.jsx)($e276238666cc4ebe$export$80a7df32907e00ee, {
                hosting: (0, $ammkg.AtlassianProductHostingType).DataCenter,
                onClick: ()=>props.onItemClick((0, $ammkg.AtlassianProductHostingType).DataCenter)
            }),
            showCloudCompatibility && /*#__PURE__*/ (0, $lHkHI.jsx)($e276238666cc4ebe$export$80a7df32907e00ee, {
                hosting: (0, $ammkg.AtlassianProductHostingType).Cloud,
                onClick: ()=>props.onItemClick((0, $ammkg.AtlassianProductHostingType).Cloud)
            })
        ]
    });
};
const $e276238666cc4ebe$export$80a7df32907e00ee = (_ref7)=>{
    let { href: href, hosting: hosting, onClick: onClick } = _ref7;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gTOQV.default), {
        elemAfter: href ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eQeMb))), {
            size: "small",
            primaryColor: (0, $j0gMm.N200)
        }) : null,
        onClick: onClick,
        target: "_blank",
        href: href,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)($e276238666cc4ebe$export$6fc77960e7e15faf, {
            children: (0, $7ZOJD.HostingDisplayName)[hosting]
        })
    });
};
var $e276238666cc4ebe$export$2e2bcd8739ae039 = $e276238666cc4ebe$var$HostingSelectV2;

});

parcelRegister("9fHbR", function(module, exports) {

$parcel$export(module.exports, "makeAppListingTabs", () => $6bc7047c2ce9e07a$export$bb54bf31b6ebc48c);

var $5zQU9 = parcelRequire("5zQU9");

var $kafab = parcelRequire("kafab");
var $7ZOJD = parcelRequire("7ZOJD");

var $ammkg = parcelRequire("ammkg");
parcelRequire("eUqFw");

var $2qxdh = parcelRequire("2qxdh");

var $c1ZLO = parcelRequire("c1ZLO");

var $dcnzE = parcelRequire("dcnzE");

var $6hiDi = parcelRequire("6hiDi");

var $ar8rL = parcelRequire("ar8rL");

var $fVpR4 = parcelRequire("fVpR4");

var $hfUW3 = parcelRequire("hfUW3");

var $kgFvR = parcelRequire("kgFvR");

var $jMhus = parcelRequire("jMhus");

var $7yIhX = parcelRequire("7yIhX");

var $iXxcB = parcelRequire("iXxcB");

var $8STQH = parcelRequire("8STQH");

var $ch9vE = parcelRequire("ch9vE");

var $7lusI = parcelRequire("7lusI");

var $h8lfX = parcelRequire("h8lfX");

var $lHkHI = parcelRequire("lHkHI");
function $6bc7047c2ce9e07a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6bc7047c2ce9e07a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6bc7047c2ce9e07a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6bc7047c2ce9e07a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $6bc7047c2ce9e07a$export$bb54bf31b6ebc48c = (_ref)=>{
    let { appListing: /* eslint sort-keys: "error" */ appListing, selectedHosting: selectedHosting, showAetherAppListingPage: showAetherAppListingPage, showInstallationTab: showInstallationTab, serverEolStartDate: serverEolStartDate, showIntegrationsDetailsSection: showIntegrationsDetailsSection, showResourcesSection: showResourcesSection, showCertificationSection: showCertificationSection, showReviewsTab: showReviewsTab, showVersionsTab: showVersionsTab, showPricingTab: showPricingTab, mpacBaseUrl: mpacBaseUrl, mpacCdnBaseUrl: mpacCdnBaseUrl, atlassianCommunityBaseUrl: atlassianCommunityBaseUrl, user: user, loginHref: loginHref, onSupportLinkClick: onSupportLinkClick, onMediaViewerOpen: onMediaViewerOpen, onWatchAppToggle: onWatchAppToggle, onSeeMoreReviewsClick: onSeeMoreReviewsClick, onArtifactDownloadClick: onArtifactDownloadClick, cloudMigration: cloudMigration, onCloudMigrationResourceLinksClick: onCloudMigrationResourceLinksClick, onPricingCalculatorInstallCTAClick: onPricingCalculatorInstallCTAClick, showAppListingTrustTab: showAppListingTrustTab, appRating: appRating, showServerEolMessage: showServerEolMessage, feedbackCollectorApiKeys: feedbackCollectorApiKeys, feedbackGatewayBaseUrl: feedbackGatewayBaseUrl, isServerAppEos: isServerAppEos, onTabSelect: onTabSelect } = _ref;
    const tabs = [];
    const trustTabPrecondition = (0, $dcnzE.getTrustTabPrecondition)(selectedHosting, appListing);
    // Overview Tab
    tabs.push({
        label: 'Overview',
        content: showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2qxdh.LazySuspense), {
            fallback: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ar8rL.AppListingTabContentSkeleton), {}),
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jMhus.LazyOverviewTabV2), {
                appListing: appListing,
                hosting: selectedHosting,
                isServerAppEos: isServerAppEos,
                mpacBaseUrl: mpacBaseUrl,
                onArtifactDownloadClick: onArtifactDownloadClick,
                onMediaViewerOpen: onMediaViewerOpen,
                onTabSelect: onTabSelect,
                showIntegrationsDetailsSection: showIntegrationsDetailsSection,
                versionInfo: (0, $dcnzE.pickVersionInfo)(appListing)
            })
        }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2qxdh.LazySuspense), {
            fallback: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6hiDi.LoadingSuspenseSpinner), {}),
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jMhus.LazyOverviewTab), {
                mpacBaseUrl: mpacBaseUrl,
                appListing: appListing,
                cloudMigration: cloudMigration,
                showIntegrationsDetailsSection: showIntegrationsDetailsSection,
                showResourcesSection: showResourcesSection,
                showCertificationSection: showCertificationSection,
                userLoggedIn: user.isLoggedIn,
                loginHref: loginHref,
                hosting: selectedHosting,
                onMediaViewerOpen: onMediaViewerOpen,
                onWatchAppToggle: onWatchAppToggle,
                onArtifactDownloadClick: onArtifactDownloadClick,
                onCloudMigrationResourceLinksClick: onCloudMigrationResourceLinksClick,
                isServerAppEos: isServerAppEos
            })
        }),
        testId: (0, $c1ZLO.TEST_ID).APP_LISTING_TAB((0, $c1ZLO.AppListingTab).Overview),
        key: (0, $c1ZLO.AppListingTab).Overview
    });
    // Reviews Tab
    if (showReviewsTab) tabs.push({
        label: 'Reviews',
        key: (0, $c1ZLO.AppListingTab).Reviews,
        testId: (0, $c1ZLO.TEST_ID).APP_LISTING_TAB((0, $c1ZLO.AppListingTab).Reviews),
        content: showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2qxdh.LazySuspense), {
            fallback: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6hiDi.LoadingSuspenseSpinner), {}),
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8STQH.LazyReviewsTabV2), {
                appKey: appListing.appKey,
                mpacBaseUrl: mpacBaseUrl,
                hosting: selectedHosting,
                vendorName: appListing.partner.name,
                vendorLogo: appListing.partner.logo,
                onSeeMoreReviewsClick: onSeeMoreReviewsClick,
                user: user,
                loginHref: loginHref,
                appRating: appRating,
                cloudCompatibleProducts: appListing.cloudCompatibleProducts,
                appDeploymentType: appListing.deploymentType,
                productHostingOptions: appListing.productHostingOptions,
                isServerAppEos: isServerAppEos
            })
        }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2qxdh.LazySuspense), {
            fallback: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6hiDi.LoadingSuspenseSpinner), {}),
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8STQH.LazyReviewsTab), {
                appKey: appListing.appKey,
                mpacBaseUrl: mpacBaseUrl,
                hosting: selectedHosting,
                vendorName: appListing.partner.name,
                vendorLogo: appListing.partner.logo,
                onSeeMoreReviewsClick: onSeeMoreReviewsClick,
                user: user,
                loginHref: loginHref,
                appRating: appRating,
                cloudCompatibleProducts: appListing.cloudCompatibleProducts,
                appDeploymentType: appListing.deploymentType,
                productHostingOptions: appListing.productHostingOptions,
                isServerAppEos: isServerAppEos
            })
        })
    });
    // Pricing Tab
    if (showPricingTab && appListing.paymentModel && appListing.paymentModel !== (0, $ammkg.MarketplaceAppPaymentModel).Free && !isServerAppEos) tabs.push({
        label: 'Pricing',
        content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2qxdh.LazySuspense), {
            fallback: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6hiDi.LoadingSuspenseSpinner), {}),
            children: showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $iXxcB.default), {
                appId: appListing.appId,
                appKey: appListing.appKey,
                compatibleProducts: appListing.compatibleProducts,
                hasDataCenterVersion: appListing.hasDataCenterVersion,
                hosting: selectedHosting,
                learnMoreUrl: appListing.learnMoreUrl,
                marketingLabels: appListing.marketingLabels,
                partnerType: appListing.partner.partnerType,
                paymentModel: appListing.paymentModel,
                mpacBaseUrl: mpacBaseUrl,
                onPricingCalculatorInstallCTAClick: onPricingCalculatorInstallCTAClick,
                showServerEolMessage: showServerEolMessage,
                serverEolStartDate: serverEolStartDate
            }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7yIhX.default), {
                appId: appListing.appId,
                appKey: appListing.appKey,
                compatibleProducts: appListing.compatibleProducts,
                hasDataCenterVersion: appListing.hasDataCenterVersion,
                hosting: selectedHosting,
                learnMoreUrl: appListing.learnMoreUrl,
                marketingLabels: appListing.marketingLabels,
                partnerType: appListing.partner.partnerType,
                paymentModel: appListing.paymentModel,
                mpacBaseUrl: mpacBaseUrl,
                onPricingCalculatorInstallCTAClick: onPricingCalculatorInstallCTAClick,
                showServerEolMessage: showServerEolMessage,
                serverEolStartDate: serverEolStartDate
            })
        }),
        testId: (0, $c1ZLO.TEST_ID).APP_LISTING_TAB((0, $c1ZLO.AppListingTab).Pricing),
        key: (0, $c1ZLO.AppListingTab).Pricing
    });
    // Privacy and Security Tab
    if (showAppListingTrustTab && !isServerAppEos) {
        var _appListing$partner;
        const { emailId: emailId } = appListing.supportDetails.contact;
        tabs.push($6bc7047c2ce9e07a$var$_objectSpread({
            label: 'Privacy & Security',
            content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2qxdh.LazySuspense), {
                fallback: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6hiDi.LoadingSuspenseSpinner), {}),
                children: trustTabPrecondition ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fVpR4.LazyCustomerPrivacyAndSecurityTab), {
                    mpacBaseUrl: mpacBaseUrl,
                    mpacCdnBaseUrl: mpacCdnBaseUrl,
                    appKey: appListing.appKey,
                    appId: appListing.appId,
                    appName: appListing.name,
                    feedbackCollectorApiKeys: feedbackCollectorApiKeys,
                    feedbackGatewayBaseUrl: feedbackGatewayBaseUrl,
                    userId: user.userId,
                    supportEmailId: emailId
                }) : showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fVpR4.LazyPrivacySecurityDetailsNotAvailableBannerV2), {
                    isHostingCloud: selectedHosting === (0, $7ZOJD.HostingQueryParamToHostingType).cloud,
                    isWorkflowApp: appListing.deploymentType === (0, $kafab.AppDeployment).WORKFLOW,
                    appName: appListing.name,
                    appKey: appListing.appKey,
                    supportEmailId: emailId,
                    mpacBaseUrl: mpacBaseUrl,
                    partnerId: (_appListing$partner = appListing.partner) === null || _appListing$partner === void 0 ? void 0 : _appListing$partner.id
                }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fVpR4.LazyPrivacySecurityDetailsNotAvailableBanner), {
                    isHostingCloud: selectedHosting === (0, $7ZOJD.HostingQueryParamToHostingType).cloud
                })
            }),
            testId: (0, $c1ZLO.TEST_ID).APP_LISTING_TAB((0, $c1ZLO.AppListingTab).PrivacyAndSecurity),
            key: (0, $c1ZLO.AppListingTab).PrivacyAndSecurity
        }, !showAetherAppListingPage && {
            lozenge: {
                label: 'new',
                appearance: 'new'
            }
        }));
    }
    // Support Tab
    if (!isServerAppEos) tabs.push({
        label: 'Support',
        content: showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7lusI.SupportTab), {
            appKey: appListing.appKey,
            atlassianCommunityBaseUrl: atlassianCommunityBaseUrl,
            cloudMigrationInfo: cloudMigration,
            hosting: selectedHosting,
            mpacBaseUrl: mpacBaseUrl,
            onCloudMigrationResourceLinksClick: onCloudMigrationResourceLinksClick,
            onSupportLinkClick: onSupportLinkClick,
            supportDetails: appListing.supportDetails
        }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ch9vE.default), {
            supportDetails: appListing.supportDetails,
            mpacBaseUrl: mpacBaseUrl,
            atlassianCommunityBaseUrl: atlassianCommunityBaseUrl,
            hosting: selectedHosting,
            appKey: appListing.appKey,
            onSupportLinkClick: onSupportLinkClick,
            showServerEolMessage: showServerEolMessage
        }),
        testId: (0, $c1ZLO.TEST_ID).APP_LISTING_TAB((0, $c1ZLO.AppListingTab).Support),
        key: (0, $c1ZLO.AppListingTab).Support
    });
    // Versions Tab
    if (showVersionsTab && !showAetherAppListingPage) tabs.push({
        label: 'Versions',
        content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $h8lfX.default), {
            versionHistoryUrl: appListing.versionHistoryUrl,
            hosting: selectedHosting,
            releaseDate: appListing.releaseDate,
            releaseNotes: appListing.releaseNotes,
            releaseSummary: appListing.releaseSummary,
            releaseNotesUrl: appListing.releaseNotesUrl,
            version: appListing.version,
            versionCount: appListing.versionCount,
            productCompatibilities: appListing.compatibleProducts,
            paymentModel: appListing.paymentModel,
            licenseType: appListing.licenseType
        }),
        testId: (0, $c1ZLO.TEST_ID).APP_LISTING_TAB((0, $c1ZLO.AppListingTab).Versions),
        key: (0, $c1ZLO.AppListingTab).Versions
    });
    // Installation Tab
    if (showInstallationTab) tabs.push({
        label: 'Installation',
        content: showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2qxdh.LazySuspense), {
            fallback: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6hiDi.LoadingSuspenseSpinner), {}),
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kgFvR.default), {
                appName: appListing.name,
                compatibleProducts: appListing.compatibleProducts,
                deploymentType: appListing.deploymentType,
                documentationUrl: appListing.documentationUrl,
                hosting: selectedHosting,
                installationInstructions: appListing.installationInstructions,
                paymentModel: appListing.paymentModel,
                versionCount: appListing.versionCount,
                versionHistoryUrl: appListing.versionHistoryUrl
            })
        }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hfUW3.default), {
            appName: appListing.name,
            compatibleProducts: appListing.compatibleProducts,
            deploymentType: appListing.deploymentType,
            documentationUrl: appListing.documentationUrl,
            hosting: selectedHosting,
            installationInstructions: appListing.installationInstructions,
            paymentModel: appListing.paymentModel,
            versionCount: appListing.versionCount,
            versionHistoryUrl: appListing.versionHistoryUrl
        }),
        testId: (0, $c1ZLO.TEST_ID).APP_LISTING_TAB((0, $c1ZLO.AppListingTab).Installation),
        key: (0, $c1ZLO.AppListingTab).Installation
    });
    return tabs;
};

});
parcelRegister("6hiDi", function(module, exports) {

$parcel$export(module.exports, "LoadingSuspenseSpinner", () => $4922c8ac3191811c$export$f6fb32996edf5140);
/* LoadingSuspenseSpinner.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $hvCdF = parcelRequire("hvCdF");

var $lHkHI = parcelRequire("lHkHI");
const $4922c8ac3191811c$var$_excluded = [
    "as",
    "style"
];
function $4922c8ac3191811c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4922c8ac3191811c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4922c8ac3191811c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4922c8ac3191811c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4922c8ac3191811c$var$SpinnerContainer = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $4922c8ac3191811c$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $4922c8ac3191811c$var$_objectSpread($4922c8ac3191811c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_y3gn1h6o _1bsb1osq _19pkxy5q",
            __cmplp.className
        ])
    }));
});
const $4922c8ac3191811c$export$f6fb32996edf5140 = ()=>/*#__PURE__*/ (0, $lHkHI.jsx)($4922c8ac3191811c$var$SpinnerContainer, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hvCdF.default), {
            size: "large"
        })
    });

});

parcelRegister("ar8rL", function(module, exports) {

$parcel$export(module.exports, "AppListingTabContentSkeleton", () => $7992fa5974df6bbe$export$62cb035a8151585f);
$parcel$export(module.exports, "AppListingPageSkeleton", () => $7992fa5974df6bbe$export$70f2b981f250d0f6);
/* AppListingPageSkeleton.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $lMOk7 = parcelRequire("lMOk7");
var $bqcaO = parcelRequire("bqcaO");
var $cpR7D = parcelRequire("cpR7D");

var $ammkg = parcelRequire("ammkg");

var $lHkHI = parcelRequire("lHkHI");
const $7992fa5974df6bbe$var$_excluded = [
    "as",
    "style"
], $7992fa5974df6bbe$var$_excluded2 = [
    "as",
    "style"
], $7992fa5974df6bbe$var$_excluded3 = [
    "as",
    "style"
], $7992fa5974df6bbe$var$_excluded4 = [
    "as",
    "style"
], $7992fa5974df6bbe$var$_excluded5 = [
    "as",
    "style"
], $7992fa5974df6bbe$var$_excluded6 = [
    "as",
    "style"
], $7992fa5974df6bbe$var$_excluded7 = [
    "as",
    "style"
], $7992fa5974df6bbe$var$_excluded8 = [
    "as",
    "style"
], $7992fa5974df6bbe$var$_excluded9 = [
    "as",
    "style"
], $7992fa5974df6bbe$var$_excluded10 = [
    "as",
    "style"
], $7992fa5974df6bbe$var$_excluded11 = [
    "as",
    "style"
], $7992fa5974df6bbe$var$_excluded12 = [
    "as",
    "style"
], $7992fa5974df6bbe$var$_excluded13 = [
    "as",
    "style"
], $7992fa5974df6bbe$var$_excluded14 = [
    "as",
    "style"
], $7992fa5974df6bbe$var$_excluded15 = [
    "as",
    "style"
];
function $7992fa5974df6bbe$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7992fa5974df6bbe$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7992fa5974df6bbe$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7992fa5974df6bbe$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $7992fa5974df6bbe$var$Container = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $7992fa5974df6bbe$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkgosd",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$Flex = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $7992fa5974df6bbe$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$HeaderContainer = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $7992fa5974df6bbe$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _2lx21bp4 _1p57hiv4 _1inivrvc",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$AppIconMPAC = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = (0, $bqcaO.Stripe), style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $7992fa5974df6bbe$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1k7u _1bsb1k7u _1xlots0x _14b5ts0x",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$AppIconEMCEE = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = (0, $bqcaO.Stripe), style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $7992fa5974df6bbe$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i1k7u _1bsb1k7u _1xlo12bs _14b512bs",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$AppDetailsContainer = (0, $eUqFw.forwardRef)((_ref6, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref6, __cmplp = (0, $bwPfh.default)(_ref6, $7992fa5974df6bbe$var$_excluded6);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _18u01eps _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$AppDetailsRow = (0, $eUqFw.forwardRef)((_ref7, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref7, __cmplp = (0, $bwPfh.default)(_ref7, $7992fa5974df6bbe$var$_excluded7);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _16jlkb7n _1o9zkb7n _i0dlf1ug",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$CTAContainer = (0, $eUqFw.forwardRef)((_ref8, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref8, __cmplp = (0, $bwPfh.default)(_ref8, $7992fa5974df6bbe$var$_excluded8);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _gy1p1eps",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$CTAContainerEMCEE = (0, $eUqFw.forwardRef)((_ref9, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref9, __cmplp = (0, $bwPfh.default)(_ref9, $7992fa5974df6bbe$var$_excluded9);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$CTAButton = (0, $eUqFw.forwardRef)((_ref10, __cmplr)=>{
    let { as: C = (0, $bqcaO.Stripe), style: __cmpls } = _ref10, __cmplp = (0, $bwPfh.default)(_ref10, $7992fa5974df6bbe$var$_excluded10);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _b8yq19uw",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$TabsContainer = (0, $eUqFw.forwardRef)((_ref11, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref11, __cmplp = (0, $bwPfh.default)(_ref11, $7992fa5974df6bbe$var$_excluded11);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkhiv4",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$TabItemContainer = (0, $eUqFw.forwardRef)((_ref12, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref12, __cmplp = (0, $bwPfh.default)(_ref12, $7992fa5974df6bbe$var$_excluded12);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _gy1phiv4",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$TabSeparator = (0, $eUqFw.forwardRef)((_ref13, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref13, __cmplp = (0, $bwPfh.default)(_ref13, $7992fa5974df6bbe$var$_excluded13);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_4t3i133k _1bsb1osq _bfhkn5am _19pkoxav _tzy4105o",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$TabContentContainer = (0, $eUqFw.forwardRef)((_ref14, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref14, __cmplp = (0, $bwPfh.default)(_ref14, $7992fa5974df6bbe$var$_excluded14);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _otyrgosd",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$SocialSignals = (0, $eUqFw.forwardRef)((_ref15, __cmplr)=>{
    let { as: C = (0, $bqcaO.Stripe), style: __cmpls } = _ref15, __cmplp = (0, $bwPfh.default)(_ref15, $7992fa5974df6bbe$var$_excluded15);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $7992fa5974df6bbe$var$_objectSpread($7992fa5974df6bbe$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12fdmrr _1bsbn7od _4t3iqvp6 _1xlogad4",
            __cmplp.className
        ])
    }));
});
const $7992fa5974df6bbe$var$TabSkeleton = (_ref16)=>{
    let { tabCount: tabCount = 6 } = _ref16;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($7992fa5974df6bbe$var$TabsContainer, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($7992fa5974df6bbe$var$TabItemContainer, {
                children: new Array(tabCount).fill(/*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqcaO.Stripe), {
                    height: "1rem",
                    width: "4.375rem"
                }))
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($7992fa5974df6bbe$var$TabSeparator, {})
        ]
    });
};
const $7992fa5974df6bbe$var$HeaderInjectionMPAC = (_ref17)=>{
    let { selectedHosting: selectedHosting } = _ref17;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($7992fa5974df6bbe$var$CTAContainer, {
        children: [
            selectedHosting !== (0, $ammkg.AtlassianProductHostingType).Server && /*#__PURE__*/ (0, $lHkHI.jsx)($7992fa5974df6bbe$var$CTAButton, {
                width: "6.5rem",
                height: "2.5rem",
                borderRadius: "var(--ds-border-radius-200)"
            }),
            selectedHosting === (0, $ammkg.AtlassianProductHostingType).DataCenter && /*#__PURE__*/ (0, $lHkHI.jsx)($7992fa5974df6bbe$var$CTAButton, {
                width: "6.5rem",
                height: "2.5rem",
                borderRadius: "var(--ds-border-radius-200)"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqcaO.Stripe), {
                width: "2.5rem",
                height: "2.5rem",
                borderRadius: "var(--ds-border-radius-200)"
            })
        ]
    });
};
const $7992fa5974df6bbe$var$HeaderInjectionEMCEE = ()=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)($7992fa5974df6bbe$var$Flex, {
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)($7992fa5974df6bbe$var$CTAContainerEMCEE, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqcaO.Stripe), {
                    width: "6rem",
                    height: "2rem",
                    borderRadius: "var(--ds-border-radius-200)"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqcaO.Stripe), {
                    width: "5rem",
                    height: "0.875rem",
                    marginTop: "var(--ds-space-075)"
                })
            ]
        })
    });
};
const $7992fa5974df6bbe$export$62cb035a8151585f = ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)($7992fa5974df6bbe$var$TabContentContainer, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqcaO.Stripe), {
                maxWidth: "20.5626rem",
                height: "1rem",
                marginTop: "var(--ds-space-400)"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqcaO.Stripe), {
                maxWidth: "37.9375rem",
                height: "0.875rem",
                marginTop: "var(--ds-space-300)"
            })
        ]
    });
const $7992fa5974df6bbe$var$getTabCount = (_ref18)=>{
    let { isEMCEE: isEMCEE, isMobile: isMobile } = _ref18;
    if (isEMCEE) return 3;
    if (isMobile) return 4;
    return 6;
};
const $7992fa5974df6bbe$export$70f2b981f250d0f6 = (_ref19)=>{
    let { selectedHosting: selectedHosting, isEMCEE: isEMCEE = false } = _ref19;
    const { value: breakpoint } = (0, $cpR7D.useResponsiveBreakpoint)();
    const isMobile = breakpoint < (0, $lMOk7.breakpointValues).md;
    const AppIcon = isEMCEE ? $7992fa5974df6bbe$var$AppIconEMCEE : $7992fa5974df6bbe$var$AppIconMPAC;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($7992fa5974df6bbe$var$Container, {
        "data-testid": "app_listing_page_skeleton",
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($7992fa5974df6bbe$var$HeaderContainer, {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsxs)($7992fa5974df6bbe$var$AppDetailsRow, {
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsx)(AppIcon, {}),
                                    /*#__PURE__*/ (0, $lHkHI.jsxs)($7992fa5974df6bbe$var$AppDetailsContainer, {
                                        children: [
                                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqcaO.Stripe), {
                                                maxWidth: "25rem",
                                                height: "1rem"
                                            }),
                                            !isEMCEE && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqcaO.Stripe), {
                                                maxWidth: "13.3125rem",
                                                height: "0.875rem",
                                                marginTop: "var(--ds-space-300)"
                                            }),
                                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqcaO.Stripe), {
                                                maxWidth: "13.3125rem",
                                                height: "0.875rem",
                                                marginTop: "var(--ds-space-200)"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            isEMCEE ? /*#__PURE__*/ (0, $lHkHI.jsx)($7992fa5974df6bbe$var$HeaderInjectionEMCEE, {}) : /*#__PURE__*/ (0, $lHkHI.jsx)($7992fa5974df6bbe$var$HeaderInjectionMPAC, {
                                selectedHosting: selectedHosting
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($7992fa5974df6bbe$var$SocialSignals, {
                        marginTop: "var(--ds-space-300)"
                    }),
                    !isEMCEE && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqcaO.Stripe), {
                        width: "9.75rem",
                        height: "0.875rem",
                        marginTop: "var(--ds-space-250)"
                    }),
                    selectedHosting === (0, $ammkg.AtlassianProductHostingType).Server && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqcaO.Stripe), {
                        width: "100%",
                        height: "5rem",
                        marginTop: "var(--ds-space-250)"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($7992fa5974df6bbe$var$TabSkeleton, {
                tabCount: $7992fa5974df6bbe$var$getTabCount({
                    isEMCEE: isEMCEE,
                    isMobile: isMobile
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($7992fa5974df6bbe$export$62cb035a8151585f, {})
        ]
    });
};

});

parcelRegister("fVpR4", function(module, exports) {

$parcel$export(module.exports, "LazyCustomerPrivacyAndSecurityTab", () => $b9803c2bae46e7bb$export$f7d10e44d008adea);
$parcel$export(module.exports, "LazyPrivacySecurityDetailsNotAvailableBanner", () => $b9803c2bae46e7bb$export$ffd53fe0484912ab);
$parcel$export(module.exports, "LazyPrivacySecurityDetailsNotAvailableBannerV2", () => $b9803c2bae46e7bb$export$bf28c7b13a194a7a);

var $7Pfur = parcelRequire("7Pfur");

const $b9803c2bae46e7bb$export$f7d10e44d008adea = (0, $7Pfur.lazyForPaint)(()=>(parcelRequire("2fYBl")).then((module)=>{
        return module.CustomerPrivacyAndSecurityTab;
    }));

const $b9803c2bae46e7bb$export$ffd53fe0484912ab = (0, $7Pfur.lazyForPaint)(()=>(parcelRequire("2fYBl")).then((module)=>{
        return module.PrivacySecurityDetailsNotAvailableBanner;
    }));

const $b9803c2bae46e7bb$export$bf28c7b13a194a7a = (0, $7Pfur.lazyForPaint)(()=>(parcelRequire("2fYBl")).then((module)=>{
        return module.PrivacySecurityDetailsNotAvailableBannerV2;
    }));

});
parcelRegister("2fYBl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("54Oar").then(()=>parcelRequire('j7C78'));

});


parcelRegister("hfUW3", function(module, exports) {

$parcel$export(module.exports, "default", () => $c90000937653ea0f$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $jyCWD = parcelRequire("jyCWD");
parcelRequire("eUqFw");

var $fhWaL = parcelRequire("fhWaL");

var $8Lu20 = parcelRequire("8Lu20");

var $lHkHI = parcelRequire("lHkHI");
function $c90000937653ea0f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c90000937653ea0f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c90000937653ea0f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c90000937653ea0f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $c90000937653ea0f$var$InstallationTab = (props)=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fhWaL.SectionsWrapper), {
        "data-testid": "installation-section",
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fhWaL.default), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jyCWD.default), {
                    children: "Installation"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8Lu20.default), $c90000937653ea0f$var$_objectSpread({}, props))
            ]
        })
    });
};
var $c90000937653ea0f$export$2e2bcd8739ae039 = $c90000937653ea0f$var$InstallationTab;

});
parcelRegister("jyCWD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3cf66e68ff0c645$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $8gcXz = parcelRequire("8gcXz");
const $e3cf66e68ff0c645$var$SectionHeading = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H3), {
    target: "eivpbkp0",
    label: "SectionHeading"
})("padding-bottom:var(--ds-space-150, 12px);", (props)=>props.bottomBorder && "border-bottom: 1px solid ".concat("var(--ds-border, ".concat((0, $j0gMm.N40), ")"), ";"), " margin-bottom:var(--ds-space-300, 24px);");
$e3cf66e68ff0c645$var$SectionHeading.defaultProps = {
    bottomBorder: true
};
var $e3cf66e68ff0c645$export$2e2bcd8739ae039 = $e3cf66e68ff0c645$var$SectionHeading;

});

parcelRegister("fhWaL", function(module, exports) {

$parcel$export(module.exports, "SectionsWrapper", () => $b21591686c74f60a$export$4b48d205ff352c80);
$parcel$export(module.exports, "SectionSubHeading", () => $b21591686c74f60a$export$5b583ab20fb101c7);
$parcel$export(module.exports, "TwoColumns", () => $b21591686c74f60a$export$400aab69decaa6c5);
$parcel$export(module.exports, "default", () => $b21591686c74f60a$export$2e2bcd8739ae039);

var $jqNEH = parcelRequire("jqNEH");
parcelRequire("kuV1R");

var $3UXZ8 = parcelRequire("3UXZ8");

var $hvUUg = parcelRequire("hvUUg");
var $2mgTj = parcelRequire("2mgTj");
var $8gcXz = parcelRequire("8gcXz");

var $kO6Ah = parcelRequire("kO6Ah");
var $b21591686c74f60a$var$_templateObject, $b21591686c74f60a$var$_templateObject2, $b21591686c74f60a$var$_templateObject3, $b21591686c74f60a$var$_templateObject4;
function $b21591686c74f60a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b21591686c74f60a$export$4b48d205ff352c80 = (0, $3UXZ8.default)("section", {
    target: "e1b5x7t20",
    label: "SectionsWrapper"
})({
    name: "7lr9tq",
    styles: "margin:var(--ds-space-300, 24px) 0;width:100%;"
});
$b21591686c74f60a$export$4b48d205ff352c80.defaultProps = {};
const $b21591686c74f60a$var$Section = (0, $3UXZ8.default)("section", {
    target: "e1b5x7t21",
    label: "Section"
})((0, $hvUUg.baseMediumFontSize), " margin-bottom:var(--ds-space-400, 32px);width:100%;");
const $b21591686c74f60a$export$5b583ab20fb101c7 = (0, $8gcXz.H4);
const $b21591686c74f60a$export$400aab69decaa6c5 = (0, $3UXZ8.default)("div", {
    target: "e1b5x7t22",
    label: "TwoColumns"
})("display:flex;justify-content:space-between;", (0, $kO6Ah.mediaBreakpoints).largeDown($b21591686c74f60a$var$_templateObject || ($b21591686c74f60a$var$_templateObject = (0, $jqNEH.default)([
    "\n    flex-wrap: wrap;\n  "
]))), ";");
const $b21591686c74f60a$var$ColumnLeft = (0, $3UXZ8.default)("div", {
    target: "e1b5x7t23",
    label: "ColumnLeft"
})("flex:1 1 66.6%;min-width:350px;padding-right:", (0, $2mgTj).GutterSpacing.Comfortable, ";", (0, $kO6Ah.mediaBreakpoints).largeDown($b21591686c74f60a$var$_templateObject2 || ($b21591686c74f60a$var$_templateObject2 = (0, $jqNEH.default)([
    "\n    padding-right: ",
    ";\n    min-width: initial;\n  "
])), (0, $2mgTj).GutterSpacing.Cozy), ";");
const $b21591686c74f60a$var$ColumnRight = (0, $3UXZ8.default)("div", {
    target: "e1b5x7t24",
    label: "ColumnRight"
})({
    name: "107ixcs",
    styles: "flex:1 1 33%;"
});
const $b21591686c74f60a$var$ColumnEqualLeft = (0, $3UXZ8.default)("div", {
    target: "e1b5x7t25",
    label: "ColumnEqualLeft"
})("flex:1 1 50%;padding-right:", (0, $2mgTj).GutterSpacing.Comfortable, ";margin-bottom:1.5rem;", (0, $kO6Ah.mediaBreakpoints).smallDown($b21591686c74f60a$var$_templateObject3 || ($b21591686c74f60a$var$_templateObject3 = (0, $jqNEH.default)([
    "\n    min-width: initial;\n    flex: 1 1 100%;\n    margin-bottom: 12px;\n    padding-right: 0;\n  "
]))), "");
const $b21591686c74f60a$var$ColumnEqualRight = (0, $3UXZ8.default)("div", {
    target: "e1b5x7t26",
    label: "ColumnEqualRight"
})("flex:1 1 50%;margin-bottom:1.5rem;", (0, $kO6Ah.mediaBreakpoints).smallDown($b21591686c74f60a$var$_templateObject4 || ($b21591686c74f60a$var$_templateObject4 = (0, $jqNEH.default)([
    "\n    flex: 1 1 100%;\n  "
]))), "");
$b21591686c74f60a$export$400aab69decaa6c5.Left = $b21591686c74f60a$var$ColumnLeft;
$b21591686c74f60a$export$400aab69decaa6c5.Right = $b21591686c74f60a$var$ColumnRight;
$b21591686c74f60a$export$400aab69decaa6c5.ColumnEqualLeft = $b21591686c74f60a$var$ColumnEqualLeft;
$b21591686c74f60a$export$400aab69decaa6c5.ColumnEqualRight = $b21591686c74f60a$var$ColumnEqualRight;
var $b21591686c74f60a$export$2e2bcd8739ae039 = $b21591686c74f60a$var$Section;

});
parcelRegister("kuV1R", function(module, exports) {

var $3UXZ8 = parcelRequire("3UXZ8");
var $eec2d8c565606a5f$var$tags = [
    'a',
    'abbr',
    'address',
    'area',
    'article',
    'aside',
    'audio',
    'b',
    'base',
    'bdi',
    'bdo',
    'big',
    'blockquote',
    'body',
    'br',
    'button',
    'canvas',
    'caption',
    'cite',
    'code',
    'col',
    'colgroup',
    'data',
    'datalist',
    'dd',
    'del',
    'details',
    'dfn',
    'dialog',
    'div',
    'dl',
    'dt',
    'em',
    'embed',
    'fieldset',
    'figcaption',
    'figure',
    'footer',
    'form',
    'h1',
    'h2',
    'h3',
    'h4',
    'h5',
    'h6',
    'head',
    'header',
    'hgroup',
    'hr',
    'html',
    'i',
    'iframe',
    'img',
    'input',
    'ins',
    'kbd',
    'keygen',
    'label',
    'legend',
    'li',
    'link',
    'main',
    'map',
    'mark',
    'marquee',
    'menu',
    'menuitem',
    'meta',
    'meter',
    'nav',
    'noscript',
    'object',
    'ol',
    'optgroup',
    'option',
    'output',
    'p',
    'param',
    'picture',
    'pre',
    'progress',
    'q',
    'rp',
    'rt',
    'ruby',
    's',
    'samp',
    'script',
    'section',
    'select',
    'small',
    'source',
    'span',
    'strong',
    'style',
    'sub',
    'summary',
    'sup',
    'table',
    'tbody',
    'td',
    'textarea',
    'tfoot',
    'th',
    'thead',
    'time',
    'title',
    'tr',
    'track',
    'u',
    'ul',
    'var',
    'video',
    'wbr',
    'circle',
    'clipPath',
    'defs',
    'ellipse',
    'foreignObject',
    'g',
    'image',
    'line',
    'linearGradient',
    'mask',
    'path',
    'pattern',
    'polygon',
    'polyline',
    'radialGradient',
    'rect',
    'stop',
    'svg',
    'text',
    'tspan'
];
var $eec2d8c565606a5f$var$newStyled = (0, $3UXZ8.default).bind();
$eec2d8c565606a5f$var$tags.forEach(function(tagName) {
    $eec2d8c565606a5f$var$newStyled[tagName] = $eec2d8c565606a5f$var$newStyled(tagName);
});
var $eec2d8c565606a5f$export$2e2bcd8739ae039 = $eec2d8c565606a5f$var$newStyled;

});

parcelRegister("2mgTj", function(module, exports) {

$parcel$export(module.exports, "xSmall", () => $1b7abd0e8d374aa2$export$536558b44f02dd50);
$parcel$export(module.exports, "small", () => $1b7abd0e8d374aa2$export$3c17b0e969a90510);
$parcel$export(module.exports, "medium", () => $1b7abd0e8d374aa2$export$649ecc744817b5c7);
$parcel$export(module.exports, "large", () => $1b7abd0e8d374aa2$export$f09585a853dddd32);
$parcel$export(module.exports, "xLarge", () => $1b7abd0e8d374aa2$export$b8b05e49352704c3);
$parcel$export(module.exports, "GutterSpacingUnitless", () => $1b7abd0e8d374aa2$export$383d34ee85aa009a);
$parcel$export(module.exports, "GutterSpacing", () => $1b7abd0e8d374aa2$export$2e09b7cf0cfa5883);
$parcel$export(module.exports, "foldScreenClass", () => $1b7abd0e8d374aa2$export$e9e57b7d81bb8cb9);
$parcel$export(module.exports, "triFoldScreenClass", () => $1b7abd0e8d374aa2$export$4ffe57cae6eafacc);

var $ivTMz = parcelRequire("ivTMz");

var $gC8Po = parcelRequire("gC8Po");
const $1b7abd0e8d374aa2$var$GRID_SIZE = (0, $ivTMz.gridSize)();
const $1b7abd0e8d374aa2$var$toPixels = (value)=>"".concat(value, "px");
const $1b7abd0e8d374aa2$export$536558b44f02dd50 = 'xs';
const $1b7abd0e8d374aa2$export$3c17b0e969a90510 = 'sm';
const $1b7abd0e8d374aa2$export$649ecc744817b5c7 = 'md';
const $1b7abd0e8d374aa2$export$f09585a853dddd32 = 'lg';
const $1b7abd0e8d374aa2$export$b8b05e49352704c3 = 'xl';
const $1b7abd0e8d374aa2$export$383d34ee85aa009a = {
    Base: $1b7abd0e8d374aa2$var$GRID_SIZE * 2,
    Cozy: $1b7abd0e8d374aa2$var$GRID_SIZE * 2,
    Compact: $1b7abd0e8d374aa2$var$GRID_SIZE / 2,
    Comfortable: $1b7abd0e8d374aa2$var$GRID_SIZE * 5
};
const $1b7abd0e8d374aa2$export$2e09b7cf0cfa5883 = {
    Base: $1b7abd0e8d374aa2$var$toPixels($1b7abd0e8d374aa2$export$383d34ee85aa009a.Base),
    Cozy: $1b7abd0e8d374aa2$var$toPixels($1b7abd0e8d374aa2$export$383d34ee85aa009a.Cozy),
    Compact: $1b7abd0e8d374aa2$var$toPixels($1b7abd0e8d374aa2$export$383d34ee85aa009a.Compact),
    Comfortable: $1b7abd0e8d374aa2$var$toPixels($1b7abd0e8d374aa2$export$383d34ee85aa009a.Comfortable)
};
const $1b7abd0e8d374aa2$export$e9e57b7d81bb8cb9 = (sc)=>(xs, sm, md, lg, xl)=>{
        switch(sc){
            case 'xs':
                return xs;
            case 'sm':
                return sm;
            case 'md':
                return md;
            case 'lg':
                return lg;
            case 'xl':
                return xl;
            case 'xxl':
                return xl;
            default:
                throw (0, $gC8Po.default).unexpectedCase(sc);
        }
    };
const $1b7abd0e8d374aa2$export$4ffe57cae6eafacc = (sc)=>(sm, md, lg)=>$1b7abd0e8d374aa2$export$e9e57b7d81bb8cb9(sc)(sm, sm, md, lg, lg);

});


parcelRegister("8Lu20", function(module, exports) {

$parcel$export(module.exports, "default", () => $661a021d02adee53$export$2e2bcd8739ae039);

var $kafab = parcelRequire("kafab");

var $ammkg = parcelRequire("ammkg");

var $26RIP = parcelRequire("26RIP");
parcelRequire("eUqFw");

var $geqW0 = parcelRequire("geqW0");

var $2U0EV = parcelRequire("2U0EV");

var $kK50p = parcelRequire("kK50p");

var $2rVsk = parcelRequire("2rVsk");

var $creK8 = parcelRequire("creK8");

var $lHkHI = parcelRequire("lHkHI");
const $661a021d02adee53$var$InstallationSteps = (props)=>{
    const { appName: appName, compatibleProducts: compatibleProducts, deploymentType: deploymentType, documentationUrl: documentationUrl, hosting: hosting, installationInstructions: installationInstructions, paymentModel: paymentModel, versionHistoryUrl: versionHistoryUrl, versionCount: versionCount } = props;
    const productName = (0, $creK8.getCompatibleProductName)(compatibleProducts);
    if (deploymentType === (0, $kafab.AppDeployment).INSTRUCTIONAL) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kK50p.default), {
        instructions: installationInstructions,
        documentationUrl: documentationUrl,
        appName: appName
    });
    if (deploymentType === (0, $kafab.AppDeployment).WORKFLOW) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2U0EV.default), {
        appName: appName,
        documentationUrl: documentationUrl
    });
    if (hosting === (0, $ammkg.AtlassianProductHostingType).Server || hosting === (0, $ammkg.AtlassianProductHostingType).DataCenter) return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2rVsk.default), {
                appName: appName,
                compatibleProducts: compatibleProducts,
                deploymentType: deploymentType,
                paymentModel: paymentModel,
                productName: productName
            }),
            versionCount > 1 && /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                children: [
                    "To find older ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("em", {
                        children: appName
                    }),
                    " versions compatible with your instance, you can look through our",
                    ' ',
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $26RIP.default), {
                        href: versionHistoryUrl,
                        title: "".concat(appName, "'s version history"),
                        external: false,
                        children: "version history page"
                    }),
                    "."
                ]
            })
        ]
    });
    if (hosting === (0, $ammkg.AtlassianProductHostingType).Cloud) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $geqW0.default), {
        deploymentType: deploymentType,
        appName: appName,
        paymentModel: paymentModel,
        productName: productName
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2U0EV.default), {
        appName: appName,
        documentationUrl: documentationUrl
    });
};
var $661a021d02adee53$export$2e2bcd8739ae039 = $661a021d02adee53$var$InstallationSteps;

});
parcelRegister("26RIP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1895d05f40ede9b5$export$2e2bcd8739ae039);

var $gykb8 = parcelRequire("gykb8");
parcelRequire("eUqFw");

var $l501X = parcelRequire("l501X");

var $lHkHI = parcelRequire("lHkHI");
/**
 * Used to optionally link text to a URL.
 * Renders the children wrapped within an anchor tag if `href` is non-null; else renders the children as is;
 */ const $1895d05f40ede9b5$var$OptionalLink = (props)=>{
    const { href: href, children: children, title: title, external: external, onClick: onClick, className: className } = props;
    if (!href) return children;
    if (external) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
        href: href,
        title: title,
        onClick: onClick,
        className: className,
        "data-testid": props['data-testid'],
        children: children
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
        href: href,
        title: title,
        onClick: onClick,
        className: className,
        "data-testid": props['data-testid'],
        children: children
    });
};
var $1895d05f40ede9b5$export$2e2bcd8739ae039 = $1895d05f40ede9b5$var$OptionalLink;

});

parcelRegister("geqW0", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd12d8ccf7ba0a4d$export$2e2bcd8739ae039);

var $kafab = parcelRequire("kafab");

var $ammkg = parcelRequire("ammkg");
parcelRequire("eUqFw");

var $4NGQG = parcelRequire("4NGQG");

var $lHkHI = parcelRequire("lHkHI");
const $bd12d8ccf7ba0a4d$var$CloudAppInstallationSteps = (props)=>{
    const { appName: appName, deploymentType: deploymentType, paymentModel: paymentModel, productName: productName } = props;
    const isPaidViaAtlassian = paymentModel === (0, $ammkg.MarketplaceAppPaymentModel).PaidViaAtlassian;
    const isFree = paymentModel === (0, $ammkg.MarketplaceAppPaymentModel).Free;
    const isPreInstalled = deploymentType === (0, $kafab.AppDeployment).PLUGINS2 && !isPaidViaAtlassian;
    if (isPreInstalled) return /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
        children: "This app is preinstalled on your Cloud instance."
    });
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepsList), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Log into your ",
                    productName,
                    " instance."
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Click the ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: "Apps"
                    }),
                    " dropdown and choose ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: "Find new apps"
                    }),
                    ".",
                    ' ',
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepFootnote), {
                        children: [
                            "The ",
                            /*#__PURE__*/ (0, $lHkHI.jsx)("em", {
                                children: "Find new apps"
                            }),
                            " screen loads."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Search for ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: appName
                    }),
                    " and click on the app tile.",
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepFootnote), {
                        children: [
                            "The ",
                            /*#__PURE__*/ (0, $lHkHI.jsx)("em", {
                                children: "App Details"
                            }),
                            " screen loads."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Click ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: isFree ? 'Get app' : 'Try it free'
                    }),
                    " to start installing your app."
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "You're all set!",
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepFootnote), {
                        children: [
                            "Click ",
                            /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                                children: "Close"
                            }),
                            " in the ",
                            /*#__PURE__*/ (0, $lHkHI.jsx)("em", {
                                children: "Installed and ready to go"
                            }),
                            " dialog."
                        ]
                    })
                ]
            })
        ]
    });
};
var $bd12d8ccf7ba0a4d$export$2e2bcd8739ae039 = $bd12d8ccf7ba0a4d$var$CloudAppInstallationSteps;

});
parcelRegister("4NGQG", function(module, exports) {

$parcel$export(module.exports, "InstallationStepsList", () => $37ecf9e726658e18$export$9d8ed621c55afea3);
$parcel$export(module.exports, "InstallationStepItem", () => $37ecf9e726658e18$export$85a51427f04a1b9b);
$parcel$export(module.exports, "InstallationStepFootnote", () => $37ecf9e726658e18$export$e6c29a4cacd97243);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");
function $37ecf9e726658e18$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $37ecf9e726658e18$export$9d8ed621c55afea3 = (0, $3UXZ8.default)("ol", {
    target: "e1u27f0z0",
    label: "InstallationStepsList"
})({
    name: "1r4e5z9",
    styles: "margin-bottom:var(--ds-space-300, 24px);"
});
const $37ecf9e726658e18$export$85a51427f04a1b9b = (0, $3UXZ8.default)("li", {
    target: "e1u27f0z1",
    label: "InstallationStepItem"
})({
    name: "11x3y2b",
    styles: "margin:0 0 var(--ds-space-150, 12px);"
});
const $37ecf9e726658e18$export$e6c29a4cacd97243 = (0, $3UXZ8.default)("small", {
    target: "e1u27f0z2",
    label: "InstallationStepFootnote"
})("color:", (0, $j0gMm.N300), ";font-size:0.85em;display:block;margin-top:var(--ds-space-050, 4px);");

});


parcelRegister("2U0EV", function(module, exports) {

$parcel$export(module.exports, "default", () => $21d1529fa714a799$export$2e2bcd8739ae039);

var $26RIP = parcelRequire("26RIP");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $21d1529fa714a799$var$FallbackInstallationDocumentation = (props)=>{
    const { documentationUrl: documentationUrl, appName: appName } = props;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $26RIP.default), {
        href: documentationUrl,
        external: true,
        title: "View documentation for '".concat(appName, "'"),
        children: "See this app's documentation for more information."
    });
};
var $21d1529fa714a799$export$2e2bcd8739ae039 = $21d1529fa714a799$var$FallbackInstallationDocumentation;

});

parcelRegister("kK50p", function(module, exports) {

$parcel$export(module.exports, "default", () => $f19bfc8c040fc6e6$export$2e2bcd8739ae039);

var $3pDnW = parcelRequire("3pDnW");

var $hvzDU = parcelRequire("hvzDU");

var $eUqFw = parcelRequire("eUqFw");

var $c1ZLO = parcelRequire("c1ZLO");

var $1WLmt = parcelRequire("1WLmt");

var $2U0EV = parcelRequire("2U0EV");

var $4NGQG = parcelRequire("4NGQG");

var $3N7x5 = parcelRequire("3N7x5");

var $lHkHI = parcelRequire("lHkHI");
const $f19bfc8c040fc6e6$export$6235b8f4b788f758 = (instruction)=>instruction.screenshot ? {
        dataURI: instruction.screenshot.url,
        name: instruction.instruction
    } : null;
const $f19bfc8c040fc6e6$var$getMediaItems = (instructions)=>{
    return instructions.map((instruction)=>$f19bfc8c040fc6e6$export$6235b8f4b788f758(instruction)).filter((instruction)=>instruction !== null);
};
const $f19bfc8c040fc6e6$var$InstructionalAppInstallationSteps = (props)=>{
    const { instructions: instructions, appName: appName, documentationUrl: documentationUrl } = props;
    const [activeMedia, setActiveMedia] = (0, $eUqFw.useState)(null);
    const handleMediaViewerClose = (0, $eUqFw.useCallback)(()=>setActiveMedia(null), []);
    const handleMediaItemSelect = (0, $eUqFw.useCallback)((instruction)=>{
        setActiveMedia({
            dataURI: instruction.screenshot,
            name: instruction.instruction
        });
    }, []);
    if (!instructions.length) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2U0EV.default), {
        appName: appName,
        documentationUrl: documentationUrl
    });
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepsList), {
        children: [
            activeMedia && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3pDnW.MediaViewer), {
                mediaItems: $f19bfc8c040fc6e6$var$getMediaItems(instructions),
                selectedMediaItem: activeMedia,
                onClose: handleMediaViewerClose
            }),
            instructions.map((instruction, index)=>{
                const { instruction: content, screenshot: screenshot } = instruction;
                return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hvzDU.default), {
                            dangerousHtml: content
                        }),
                        screenshot && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3N7x5.InstallationScreenshotContainer), {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1WLmt.default), {
                                image: screenshot,
                                "data-testid": (0, $c1ZLO.TEST_ID).INSTALLATION_TAB_STEP_SCREENSHOT,
                                onClick: ()=>handleMediaItemSelect({
                                        instruction: content,
                                        screenshot: screenshot.url
                                    })
                            })
                        })
                    ]
                }, "".concat(content, "-").concat(index));
            })
        ]
    });
};
var $f19bfc8c040fc6e6$export$2e2bcd8739ae039 = $f19bfc8c040fc6e6$var$InstructionalAppInstallationSteps;

});
parcelRegister("3pDnW", function(module, exports) {

$parcel$export(module.exports, "MediaViewer", () => $27c241f1f450d626$export$fe6485e420d37282);

var $8cfd5 = parcelRequire("8cfd5");

var $fABry = parcelRequire("fABry");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $27c241f1f450d626$var$EXTERNAL_MEDIA_ITEM_TYPE = 'external-image';
const $27c241f1f450d626$export$fe6485e420d37282 = (props)=>{
    const { mediaItems: mediaItems, selectedMediaItem: selectedMediaItem, onClose: onClose, testId: testId } = props;
    const mediaViewerRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        const mediaViewerElement = mediaViewerRef.current;
        if (mediaViewerElement) (0, $fABry.disableBodyScroll)(mediaViewerElement);
        return ()=>{
            if (mediaViewerElement) (0, $fABry.enableBodyScroll)(mediaViewerElement);
        };
    }, []);
    // returns full set of media
    const toMediaItem = (media)=>({
            mediaItemType: $27c241f1f450d626$var$EXTERNAL_MEDIA_ITEM_TYPE,
            dataURI: media.dataURI,
            name: media.name
        });
    return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
        ref: mediaViewerRef,
        "data-testid": testId,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8cfd5.default), {
            selectedItem: toMediaItem(selectedMediaItem),
            items: mediaItems.map(toMediaItem),
            onClose: onClose
        })
    });
};

});
parcelRegister("8cfd5", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f7b3e239f9684b2$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $4kNM0 = parcelRequire("4kNM0");

const $5f7b3e239f9684b2$var$MediaViewer = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("hv1YZ")).then(({ MediaViewerWithErrorBoundary: MediaViewerWithErrorBoundary })=>({
            default: MediaViewerWithErrorBoundary
        })));
function $5f7b3e239f9684b2$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $4kNM0.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($5f7b3e239f9684b2$var$MediaViewer, props));
}

});
parcelRegister("4kNM0", function(module, exports) {

$parcel$export(module.exports, "headerAndSidebarBackgroundColor", () => $327fa39e0833d271$export$442b7be89436c101);
$parcel$export(module.exports, "default", () => $327fa39e0833d271$export$2e2bcd8739ae039);
/**
 * Module loaded synchronously.
 * Must minimise dependencies.
 * */ 
var $eUqFw = parcelRequire("eUqFw");

var $7gB3d = parcelRequire("7gB3d");

var $8a91X = parcelRequire("8a91X");
const $327fa39e0833d271$export$442b7be89436c101 = '#101214';
const $327fa39e0833d271$var$ModalSpinner = ()=>{
    const { colorMode: colorMode } = (0, $8a91X.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7gB3d.default), {
        blankedColor: $327fa39e0833d271$export$442b7be89436c101,
        invertSpinnerColor: colorMode !== 'dark'
    });
};
var $327fa39e0833d271$export$2e2bcd8739ae039 = $327fa39e0833d271$var$ModalSpinner;

});
parcelRegister("7gB3d", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c3f93f14c9b2546$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $56FC2 = parcelRequire("56FC2");

var $hvCdF = parcelRequire("hvCdF");

var $joBf7 = parcelRequire("joBf7");
function $2c3f93f14c9b2546$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2c3f93f14c9b2546$var$overlayZindex = (0, $56FC2.layers).modal() + 10;
const $2c3f93f14c9b2546$export$5b927fc1ef8c468b = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ephyozg1"
})({
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: $2c3f93f14c9b2546$var$overlayZindex
});
$2c3f93f14c9b2546$export$5b927fc1ef8c468b.displayName = 'Blanket';
const $2c3f93f14c9b2546$export$52b4dfd89a6b3a1b = /*#__PURE__*/ (0, $joBf7.default)("div", {
    target: "ephyozg0"
})({
    name: "1aslf6p",
    styles: "position:absolute;top:50%;left:50%;transform:translate(-50%, -50%)"
});
$2c3f93f14c9b2546$export$52b4dfd89a6b3a1b.displayName = 'SpinnerWrapper';
const $2c3f93f14c9b2546$var$defaultProps = {
    blankedColor: 'none',
    invertSpinnerColor: false
};
var $2c3f93f14c9b2546$export$2e2bcd8739ae039 = ({ blankedColor: blankedColor, invertSpinnerColor: invertSpinnerColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2c3f93f14c9b2546$export$5b927fc1ef8c468b, {
        style: {
            backgroundColor: blankedColor || $2c3f93f14c9b2546$var$defaultProps.blankedColor
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($2c3f93f14c9b2546$export$52b4dfd89a6b3a1b, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hvCdF.default), {
        size: "large",
        appearance: invertSpinnerColor || $2c3f93f14c9b2546$var$defaultProps.invertSpinnerColor ? 'invert' : 'inherit'
    })));

});


parcelRegister("hv1YZ", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = Promise.all([
    $d1Cng("h2MrD"),
    $d1Cng("bYT2S"),
    $d1Cng("5l7yU")
]).then(()=>parcelRequire('e3XO2'));

});


parcelRegister("fABry", function(module, exports) {

$parcel$export(module.exports, "disableBodyScroll", () => $b597434de2885809$export$24fdf68abf432c44);
$parcel$export(module.exports, "enableBodyScroll", () => $b597434de2885809$export$e5d0524c3725571e);
function $b597434de2885809$var$_toConsumableArray(arr) {
    if (Array.isArray(arr)) {
        for(var i = 0, arr2 = Array(arr.length); i < arr.length; i++)arr2[i] = arr[i];
        return arr2;
    } else return Array.from(arr);
}
// Older browsers don't support event options, feature detect it.
// Adopted and modified solution from Bohdan Didukh (2017)
// https://stackoverflow.com/questions/41594997/ios-10-safari-prevent-scrolling-behind-a-fixed-overlay-and-maintain-scroll-posi
var $b597434de2885809$var$hasPassiveEvents = false;
if (typeof window !== 'undefined') {
    var $b597434de2885809$var$passiveTestOptions = {
        get passive () {
            $b597434de2885809$var$hasPassiveEvents = true;
            return undefined;
        }
    };
    window.addEventListener('testPassive', null, $b597434de2885809$var$passiveTestOptions);
    window.removeEventListener('testPassive', null, $b597434de2885809$var$passiveTestOptions);
}
var $b597434de2885809$var$isIosDevice = typeof window !== 'undefined' && window.navigator && window.navigator.platform && (/iP(ad|hone|od)/.test(window.navigator.platform) || window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
var $b597434de2885809$var$locks = [];
var $b597434de2885809$var$documentListenerAdded = false;
var $b597434de2885809$var$initialClientY = -1;
var $b597434de2885809$var$previousBodyOverflowSetting = void 0;
var $b597434de2885809$var$previousBodyPaddingRight = void 0;
// returns true if `el` should be allowed to receive touchmove events.
var $b597434de2885809$var$allowTouchMove = function allowTouchMove(el) {
    return $b597434de2885809$var$locks.some(function(lock) {
        if (lock.options.allowTouchMove && lock.options.allowTouchMove(el)) return true;
        return false;
    });
};
var $b597434de2885809$var$preventDefault = function preventDefault(rawEvent) {
    var e = rawEvent || window.event;
    // For the case whereby consumers adds a touchmove event listener to document.
    // Recall that we do document.addEventListener('touchmove', preventDefault, { passive: false })
    // in disableBodyScroll - so if we provide this opportunity to allowTouchMove, then
    // the touchmove event on document will break.
    if ($b597434de2885809$var$allowTouchMove(e.target)) return true;
    // Do not prevent if the event has more than one touch (usually meaning this is a multi touch gesture like pinch to zoom).
    if (e.touches.length > 1) return true;
    if (e.preventDefault) e.preventDefault();
    return false;
};
var $b597434de2885809$var$setOverflowHidden = function setOverflowHidden(options) {
    // If previousBodyPaddingRight is already set, don't set it again.
    if ($b597434de2885809$var$previousBodyPaddingRight === undefined) {
        var _reserveScrollBarGap = !!options && options.reserveScrollBarGap === true;
        var scrollBarGap = window.innerWidth - document.documentElement.clientWidth;
        if (_reserveScrollBarGap && scrollBarGap > 0) {
            $b597434de2885809$var$previousBodyPaddingRight = document.body.style.paddingRight;
            document.body.style.paddingRight = scrollBarGap + 'px';
        }
    }
    // If previousBodyOverflowSetting is already set, don't set it again.
    if ($b597434de2885809$var$previousBodyOverflowSetting === undefined) {
        $b597434de2885809$var$previousBodyOverflowSetting = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
    }
};
var $b597434de2885809$var$restoreOverflowSetting = function restoreOverflowSetting() {
    if ($b597434de2885809$var$previousBodyPaddingRight !== undefined) {
        document.body.style.paddingRight = $b597434de2885809$var$previousBodyPaddingRight;
        // Restore previousBodyPaddingRight to undefined so setOverflowHidden knows it
        // can be set again.
        $b597434de2885809$var$previousBodyPaddingRight = undefined;
    }
    if ($b597434de2885809$var$previousBodyOverflowSetting !== undefined) {
        document.body.style.overflow = $b597434de2885809$var$previousBodyOverflowSetting;
        // Restore previousBodyOverflowSetting to undefined
        // so setOverflowHidden knows it can be set again.
        $b597434de2885809$var$previousBodyOverflowSetting = undefined;
    }
};
// https://developer.mozilla.org/en-US/docs/Web/API/Element/scrollHeight#Problems_and_solutions
var $b597434de2885809$var$isTargetElementTotallyScrolled = function isTargetElementTotallyScrolled(targetElement) {
    return targetElement ? targetElement.scrollHeight - targetElement.scrollTop <= targetElement.clientHeight : false;
};
var $b597434de2885809$var$handleScroll = function handleScroll(event, targetElement) {
    var clientY = event.targetTouches[0].clientY - $b597434de2885809$var$initialClientY;
    if ($b597434de2885809$var$allowTouchMove(event.target)) return false;
    if (targetElement && targetElement.scrollTop === 0 && clientY > 0) // element is at the top of its scroll.
    return $b597434de2885809$var$preventDefault(event);
    if ($b597434de2885809$var$isTargetElementTotallyScrolled(targetElement) && clientY < 0) // element is at the bottom of its scroll.
    return $b597434de2885809$var$preventDefault(event);
    event.stopPropagation();
    return true;
};
var $b597434de2885809$export$24fdf68abf432c44 = function disableBodyScroll(targetElement, options) {
    // targetElement must be provided
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error('disableBodyScroll unsuccessful - targetElement must be provided when calling disableBodyScroll on IOS devices.');
        return;
    }
    // disableBodyScroll must not have been called on this targetElement before
    if ($b597434de2885809$var$locks.some(function(lock) {
        return lock.targetElement === targetElement;
    })) return;
    var lock = {
        targetElement: targetElement,
        options: options || {}
    };
    $b597434de2885809$var$locks = [].concat($b597434de2885809$var$_toConsumableArray($b597434de2885809$var$locks), [
        lock
    ]);
    if ($b597434de2885809$var$isIosDevice) {
        targetElement.ontouchstart = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $b597434de2885809$var$initialClientY = event.targetTouches[0].clientY;
        };
        targetElement.ontouchmove = function(event) {
            if (event.targetTouches.length === 1) // detect single touch.
            $b597434de2885809$var$handleScroll(event, targetElement);
        };
        if (!$b597434de2885809$var$documentListenerAdded) {
            document.addEventListener('touchmove', $b597434de2885809$var$preventDefault, $b597434de2885809$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $b597434de2885809$var$documentListenerAdded = true;
        }
    } else $b597434de2885809$var$setOverflowHidden(options);
};
var $b597434de2885809$export$45a3ef215b2a5866 = function clearAllBodyScrollLocks() {
    if ($b597434de2885809$var$isIosDevice) {
        // Clear all locks ontouchstart/ontouchmove handlers, and the references.
        $b597434de2885809$var$locks.forEach(function(lock) {
            lock.targetElement.ontouchstart = null;
            lock.targetElement.ontouchmove = null;
        });
        if ($b597434de2885809$var$documentListenerAdded) {
            document.removeEventListener('touchmove', $b597434de2885809$var$preventDefault, $b597434de2885809$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $b597434de2885809$var$documentListenerAdded = false;
        }
        // Reset initial clientY.
        $b597434de2885809$var$initialClientY = -1;
    } else $b597434de2885809$var$restoreOverflowSetting();
    $b597434de2885809$var$locks = [];
};
var $b597434de2885809$export$e5d0524c3725571e = function enableBodyScroll(targetElement) {
    if (!targetElement) {
        // eslint-disable-next-line no-console
        console.error('enableBodyScroll unsuccessful - targetElement must be provided when calling enableBodyScroll on IOS devices.');
        return;
    }
    $b597434de2885809$var$locks = $b597434de2885809$var$locks.filter(function(lock) {
        return lock.targetElement !== targetElement;
    });
    if ($b597434de2885809$var$isIosDevice) {
        targetElement.ontouchstart = null;
        targetElement.ontouchmove = null;
        if ($b597434de2885809$var$documentListenerAdded && $b597434de2885809$var$locks.length === 0) {
            document.removeEventListener('touchmove', $b597434de2885809$var$preventDefault, $b597434de2885809$var$hasPassiveEvents ? {
                passive: false
            } : undefined);
            $b597434de2885809$var$documentListenerAdded = false;
        }
    } else if (!$b597434de2885809$var$locks.length) $b597434de2885809$var$restoreOverflowSetting();
};

});


parcelRegister("1WLmt", function(module, exports) {

$parcel$export(module.exports, "default", () => $16aff23d2c66feab$export$2e2bcd8739ae039);
/* Image.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $lHkHI = parcelRequire("lHkHI");
const $16aff23d2c66feab$var$_excluded = [
    "as",
    "style"
], $16aff23d2c66feab$var$_excluded2 = [
    "as",
    "style"
], $16aff23d2c66feab$var$_excluded3 = [
    "image"
];
function $16aff23d2c66feab$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $16aff23d2c66feab$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $16aff23d2c66feab$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $16aff23d2c66feab$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $16aff23d2c66feab$export$cc7b5f925acc71d3 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "img", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $16aff23d2c66feab$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $16aff23d2c66feab$var$_objectSpread($16aff23d2c66feab$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _v5641dkx",
            __cmplp.className
        ])
    }));
});
const $16aff23d2c66feab$export$9732fd1fdbb78e09 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $16aff23d2c66feab$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $16aff23d2c66feab$var$_objectSpread($16aff23d2c66feab$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq _19ith6cr _2rko1sit _1reo15vq _18m915vq _bfhkh27k _v564rca0 _njlp1rrk",
            __cmplp.className
        ])
    }));
});
const $16aff23d2c66feab$var$ImageContainer = (props)=>{
    const { image: image } = props, otherImageProps = (0, $bwPfh.default)(props, $16aff23d2c66feab$var$_excluded3);
    const imageElementRef = (0, $eUqFw.useRef)(null);
    const imageContainerRef = (0, $eUqFw.useRef)(null);
    // We use direct DOM manipulation to bypass react's
    // re-rendering, that can cause a delay in image load
    (0, $eUqFw.useLayoutEffect)(()=>{
        // Prepare the image for fading-in. We do this in
        // `useLayoutEffect` which is executed only on the client side.
        // This means images are still visible if JS does not load for
        // some reason after a server side render
        if (imageElementRef.current && !imageElementRef.current.complete) imageElementRef.current.style.opacity = 0;
    }, []);
    const handleLoad = ()=>{
        if (imageElementRef.current) imageElementRef.current.style.opacity = 1;
        if (imageContainerRef.current) imageContainerRef.current.style.backgroundColor = 'transparent';
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)($16aff23d2c66feab$export$9732fd1fdbb78e09, {
        ref: imageContainerRef,
        style: {
            aspectRatio: "".concat(image.width, "/").concat(image.height),
            cursor: otherImageProps.onClick ? 'pointer' : 'auto'
        },
        children: /*#__PURE__*/ (0, $lHkHI.jsx)($16aff23d2c66feab$export$cc7b5f925acc71d3, $16aff23d2c66feab$var$_objectSpread($16aff23d2c66feab$var$_objectSpread({}, otherImageProps), {}, {
            src: image.url,
            ref: imageElementRef,
            onLoad: handleLoad,
            alt: image.alt || ''
        }))
    });
};
var $16aff23d2c66feab$export$2e2bcd8739ae039 = $16aff23d2c66feab$var$ImageContainer;

});

parcelRegister("3N7x5", function(module, exports) {

$parcel$export(module.exports, "InstallationScreenshotContainer", () => $2c2bca866c1be66e$export$57ba450c221c564f);

var $3UXZ8 = parcelRequire("3UXZ8");
function $2c2bca866c1be66e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2c2bca866c1be66e$export$57ba450c221c564f = (0, $3UXZ8.default)("div", {
    target: "e1sjdc6r0",
    label: "InstallationScreenshotContainer"
})({
    name: "kvd2hi",
    styles: "max-width:300px;display:block;margin-top:10px;margin-bottom:10px;"
});

});


parcelRegister("2rVsk", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c8aabf1bb7bbb11$export$2e2bcd8739ae039);

var $kafab = parcelRequire("kafab");
var $i0EDR = parcelRequire("i0EDR");

var $ammkg = parcelRequire("ammkg");
parcelRequire("eUqFw");

var $creK8 = parcelRequire("creK8");

var $bZ8em = parcelRequire("bZ8em");

var $lHkHI = parcelRequire("lHkHI");
const $1c8aabf1bb7bbb11$var$ServerOrDatacenterInstallationSteps = (props)=>{
    const { deploymentType: deploymentType, compatibleProducts: compatibleProducts, appName: appName, productName: productName, paymentModel: paymentModel } = props;
    if (deploymentType === (0, $kafab.AppDeployment).PLUGINS1 && !(0, $creK8.isAppOnlyCompatibleWithProduct)(compatibleProducts, (0, $i0EDR.CompatibleProductId).Confluence)) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bZ8em.NonConfluenceOnlyPlugins1AppInstallationSteps), {
        appName: appName,
        productName: productName
    });
    else if (paymentModel === (0, $ammkg.MarketplaceAppPaymentModel).PaidViaAtlassian) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bZ8em.PaidViaAtlassianAppInstallationSteps), {
        appName: appName,
        productName: productName
    });
    else return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bZ8em.OtherServerOrDatacenterAppInstallationSteps), {
        appName: appName,
        productName: productName,
        deployable: false
    });
};
var $1c8aabf1bb7bbb11$export$2e2bcd8739ae039 = $1c8aabf1bb7bbb11$var$ServerOrDatacenterInstallationSteps;

});
parcelRegister("creK8", function(module, exports) {

$parcel$export(module.exports, "getCompatibleProductName", () => $90e37151aec20adc$export$841ae415b11e127);
$parcel$export(module.exports, "isAppOnlyCompatibleWithProduct", () => $90e37151aec20adc$export$35b2c93fb4ef6a37);
const $90e37151aec20adc$export$af5e6f9ea0347d23 = 'Atlassian application';
const $90e37151aec20adc$export$841ae415b11e127 = (compatibleProducts)=>{
    if (compatibleProducts.length === 1) {
        var _compatibleProducts$, _compatibleProducts$2;
        return (_compatibleProducts$ = (_compatibleProducts$2 = compatibleProducts[0].atlassianProduct) === null || _compatibleProducts$2 === void 0 ? void 0 : _compatibleProducts$2.name) !== null && _compatibleProducts$ !== void 0 ? _compatibleProducts$ : $90e37151aec20adc$export$af5e6f9ea0347d23;
    }
    return $90e37151aec20adc$export$af5e6f9ea0347d23;
};
const $90e37151aec20adc$export$35b2c93fb4ef6a37 = (compatibleProducts, product)=>compatibleProducts.length === 1 && compatibleProducts[0].id === product;

});

parcelRegister("bZ8em", function(module, exports) {

$parcel$export(module.exports, "NonConfluenceOnlyPlugins1AppInstallationSteps", () => $8b9bc6a03ea3592e$export$3c229ff6ebfad5a3);
$parcel$export(module.exports, "PaidViaAtlassianAppInstallationSteps", () => $8b9bc6a03ea3592e$export$87c6ff430be3078b);
$parcel$export(module.exports, "OtherServerOrDatacenterAppInstallationSteps", () => $8b9bc6a03ea3592e$export$39e1d2a61f0a621c);

var $l501X = parcelRequire("l501X");
parcelRequire("eUqFw");

var $4NGQG = parcelRequire("4NGQG");

var $lHkHI = parcelRequire("lHkHI");
const $8b9bc6a03ea3592e$export$3c229ff6ebfad5a3 = (_ref)=>{
    let { appName: appName, productName: productName } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepsList), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Download ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: appName
                    }),
                    ". ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4NGQG.InstallationStepFootnote), {
                        children: "The app is downloaded as a JAR file."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Shutdown your ",
                    productName,
                    " instance."
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Copy ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: appName
                    }),
                    " file into your ",
                    productName,
                    " installation directory under /WEB-INF/lib/.",
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepFootnote), {
                        children: [
                            "Apps using the Plugins 1 framework can't be installed in Universal Plugin Manager. See ",
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                                href: "https://confluence.atlassian.com/x/AwNTE#Installingadd-ons-installingversion1InstallingPlugins1typeadd-onsinJIRAandBamboo",
                                children: "our documentation"
                            }),
                            ' for more information.'
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Start your ",
                    appName,
                    " instance."
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4NGQG.InstallationStepItem), {
                children: "You're all set!"
            })
        ]
    });
};
const $8b9bc6a03ea3592e$export$87c6ff430be3078b = (_ref2)=>{
    let { appName: appName, productName: productName } = _ref2;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepsList), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Log into your ",
                    productName,
                    " instance as an admin."
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Click the admin dropdown and choose ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: "Atlassian Marketplace"
                    }),
                    ".",
                    ' ',
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepFootnote), {
                        children: [
                            "The ",
                            /*#__PURE__*/ (0, $lHkHI.jsx)("em", {
                                children: "Manage add-ons"
                            }),
                            " screen loads."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Click ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: "Find new apps"
                    }),
                    " or ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: "Find new add-ons"
                    }),
                    " from the left-hand side of the page."
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Locate ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: appName
                    }),
                    " via search.",
                    ' ',
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4NGQG.InstallationStepFootnote), {
                        children: "The appropriate app version appears in the search results."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Click ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: "Try free"
                    }),
                    " to begin a new trial or ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: "Buy now"
                    }),
                    " to purchase a license for ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: appName
                    }),
                    ".",
                    ' ',
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4NGQG.InstallationStepFootnote), {
                        children: "You're prompted to log into MyAtlassian. ".concat(appName, " begins to download.")
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Enter your information and click ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: "Generate license"
                    }),
                    " when redirected to MyAtlassian."
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Click ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: "Apply license"
                    }),
                    ".",
                    ' ',
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4NGQG.InstallationStepFootnote), {
                        children: "If you're using an older version of UPM, you can copy and paste the license into your ".concat(productName, " instance.")
                    })
                ]
            })
        ]
    });
};
const $8b9bc6a03ea3592e$export$39e1d2a61f0a621c = (_ref3)=>{
    let { appName: appName, productName: productName, deployable: deployable } = _ref3;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepsList), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Log into your ",
                    productName,
                    " instance as an admin."
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Click the admin dropdown and choose ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: "Add-ons"
                    }),
                    ".",
                    ' ',
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepFootnote), {
                        children: [
                            "The ",
                            /*#__PURE__*/ (0, $lHkHI.jsx)("em", {
                                children: "Manage add-ons"
                            }),
                            " screen loads."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Click ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: "Find new apps"
                    }),
                    " or ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: "Find new add-ons"
                    }),
                    " from the left-hand side of the page."
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Locate ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: appName
                    }),
                    " via search.",
                    ' ',
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepFootnote), {
                        children: [
                            "Results include app versions compatible with your ",
                            productName,
                            " instance."
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "Click ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                        children: "Install"
                    }),
                    " to download and install your app.",
                    ' ',
                    !deployable && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4NGQG.InstallationStepFootnote), {
                        children: "If your app cannot be installed directly into your application, you may be prompted to download."
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepItem), {
                children: [
                    "You're all set!",
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $4NGQG.InstallationStepFootnote), {
                        children: [
                            "Click ",
                            /*#__PURE__*/ (0, $lHkHI.jsx)("strong", {
                                children: "Close"
                            }),
                            " in the ",
                            /*#__PURE__*/ (0, $lHkHI.jsx)("em", {
                                children: "Installed and ready to go"
                            }),
                            " dialog."
                        ]
                    })
                ]
            })
        ]
    });
};

});




parcelRegister("kgFvR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ec1580d8a8ba66a5$export$2e2bcd8739ae039);

var $7Pfur = parcelRequire("7Pfur");

const $ec1580d8a8ba66a5$var$LasyInstallationTab = (0, $7Pfur.lazyForPaint)(()=>(parcelRequire("fvMct")).then((module)=>module.default));
var $ec1580d8a8ba66a5$export$2e2bcd8739ae039 = $ec1580d8a8ba66a5$var$LasyInstallationTab;

});
parcelRegister("fvMct", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("a24Mq").then(()=>parcelRequire('5Pn6U'));

});


parcelRegister("jMhus", function(module, exports) {

$parcel$export(module.exports, "LazyOverviewTab", () => $e660113a00d170df$export$e7b3385598f8b8ba);
$parcel$export(module.exports, "LazyOverviewTabV2", () => $e660113a00d170df$export$e64d94d37f20bcac);

var $7Pfur = parcelRequire("7Pfur");

const $e660113a00d170df$export$e7b3385598f8b8ba = (0, $7Pfur.lazyForPaint)(()=>(parcelRequire("4r4PU")).then((module)=>module.default));

const $e660113a00d170df$export$e64d94d37f20bcac = (0, $7Pfur.lazyForPaint)(()=>(parcelRequire("9Ihgo")).then((module)=>module.OverviewTab));

});
parcelRegister("4r4PU", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("6vExe").then(()=>parcelRequire('6SUy6'));

});

parcelRegister("9Ihgo", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("bZPP9").then(()=>parcelRequire('4qcnB'));

});


parcelRegister("7yIhX", function(module, exports) {

$parcel$export(module.exports, "default", () => $580e102c852fe83f$export$2e2bcd8739ae039);

var $7Pfur = parcelRequire("7Pfur");

const $580e102c852fe83f$var$LazyPricingTab = (0, $7Pfur.lazyForPaint)(()=>(parcelRequire("kPRhv")).then((module)=>module.default));
var $580e102c852fe83f$export$2e2bcd8739ae039 = $580e102c852fe83f$var$LazyPricingTab;

});
parcelRegister("kPRhv", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("9lghQ").then(()=>parcelRequire('aMSzK'));

});


parcelRegister("iXxcB", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcd77dfb3ded72ff$export$2e2bcd8739ae039);

var $7Pfur = parcelRequire("7Pfur");

const $dcd77dfb3ded72ff$var$LazyPricingTab = (0, $7Pfur.lazyForPaint)(()=>(parcelRequire("hDDzF")).then((module)=>module.default));
var $dcd77dfb3ded72ff$export$2e2bcd8739ae039 = $dcd77dfb3ded72ff$var$LazyPricingTab;

});
parcelRegister("hDDzF", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("I4Uk1").then(()=>parcelRequire('gVaoh'));

});


parcelRegister("8STQH", function(module, exports) {

$parcel$export(module.exports, "LazyReviewsTab", () => $677eb055eeda870d$export$77df3c707b65da22);
$parcel$export(module.exports, "LazyReviewsTabV2", () => $677eb055eeda870d$export$c71037ad0a89f4a2);

var $7Pfur = parcelRequire("7Pfur");

const $677eb055eeda870d$export$77df3c707b65da22 = (0, $7Pfur.lazyForPaint)(()=>(parcelRequire("flmzW")));

const $677eb055eeda870d$export$c71037ad0a89f4a2 = (0, $7Pfur.lazyForPaint)(()=>(parcelRequire("k5Lnl")));

});
parcelRegister("flmzW", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("b4ADY").then(()=>parcelRequire('fyeLT'));

});

parcelRegister("k5Lnl", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("avcXn").then(()=>parcelRequire('biE2W'));

});


parcelRegister("ch9vE", function(module, exports) {

$parcel$export(module.exports, "default", () => $8efe72f3c148a85b$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $8VfNq = parcelRequire("8VfNq");

var $l501X = parcelRequire("l501X");
parcelRequire("eUqFw");

var $7GAac = parcelRequire("7GAac");

var $fhWaL = parcelRequire("fhWaL");

var $4XIQ8 = parcelRequire("4XIQ8");

var $lz15j = parcelRequire("lz15j");

var $fxhN1 = parcelRequire("fxhN1");

var $lHkHI = parcelRequire("lHkHI");
function $8efe72f3c148a85b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8efe72f3c148a85b$var$ServerEolMessageContainer = (0, $3UXZ8.default)("div", {
    target: "eek94lw0",
    label: "ServerEolMessageContainer"
})({
    name: "8fkoyy",
    styles: "margin-bottom:2rem;"
});
const $8efe72f3c148a85b$var$SupportTab = (props)=>{
    const { supportDetails: supportDetails, atlassianCommunityBaseUrl: atlassianCommunityBaseUrl, mpacBaseUrl: mpacBaseUrl, hosting: hosting, appKey: appKey, onSupportLinkClick: onSupportLinkClick, showServerEolMessage: showServerEolMessage } = props;
    const communityQuestionLink = (0, $7GAac.useCommunityQuestionLink)({
        atlassianCommunityBaseUrl: atlassianCommunityBaseUrl,
        mpacBaseUrl: mpacBaseUrl,
        appKey: appKey,
        hosting: hosting
    });
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fhWaL.SectionsWrapper), {
        children: [
            showServerEolMessage && /*#__PURE__*/ (0, $lHkHI.jsx)($8efe72f3c148a85b$var$ServerEolMessageContainer, {
                "data-testid": "support-tab-server-eol-warning",
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8VfNq.default), {
                    appearance: "information",
                    children: /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                        children: [
                            "Support for server apps ends on February 15, 2024, but you can stay supported and benefit from continued innovation by",
                            ' ',
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                                href: "https://www.atlassian.com/migration/assess",
                                children: "migrating to our cloud or Data Center products."
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fhWaL.default), {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fxhN1.default), {
                    supportDetails: supportDetails
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fhWaL.TwoColumns), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fhWaL.TwoColumns).Left, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lz15j.default), {
                            supportDetails: supportDetails,
                            communityQuestionLink: communityQuestionLink,
                            onSupportLinkClick: onSupportLinkClick
                        })
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fhWaL.TwoColumns).Right, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4XIQ8.default), {
                            onSupportLinkClick: onSupportLinkClick,
                            supportDetails: supportDetails
                        })
                    })
                ]
            })
        ]
    });
};
var $8efe72f3c148a85b$export$2e2bcd8739ae039 = $8efe72f3c148a85b$var$SupportTab;

});
parcelRegister("7GAac", function(module, exports) {

$parcel$export(module.exports, "useCommunityQuestionLink", () => $598881f936c7acbb$export$cc9cf6843d505f7d);

var $9c9Gu = parcelRequire("9c9Gu");

var $eUqFw = parcelRequire("eUqFw");

var $h6uOD = parcelRequire("h6uOD");
const { usePromise: $598881f936c7acbb$var$usePromise } = (0, $9c9Gu);
const $598881f936c7acbb$export$cc9cf6843d505f7d = (options)=>{
    const { mpacBaseUrl: mpacBaseUrl, atlassianCommunityBaseUrl: atlassianCommunityBaseUrl, hosting: hosting, appKey: appKey } = options;
    const [communityLink, setCommunityLink] = (0, $eUqFw.useState)({
        url: (0, $h6uOD.makeAskNewQuestionUrl)({
            appKey: appKey,
            atlassianCommunityBaseUrl: atlassianCommunityBaseUrl,
            hosting: hosting
        }),
        type: 'new'
    });
    const { result: result, pending: pending } = $598881f936c7acbb$var$usePromise(()=>(0, $h6uOD.getExistingCommunityQuestionsCount)({
            mpacBaseUrl: mpacBaseUrl,
            appKey: appKey
        }));
    (0, $eUqFw.useEffect)(()=>{
        if (typeof result === 'number' && result > 0) setCommunityLink({
            url: (0, $h6uOD.makeSeeExistingQuestionsUrl)({
                appKey: appKey,
                atlassianCommunityBaseUrl: atlassianCommunityBaseUrl
            }),
            type: 'existing'
        });
    }, [
        result,
        pending
    ]);
    return communityLink;
};

});
parcelRegister("9c9Gu", function(module, exports) {

$parcel$export(module.exports, "useLocalStorage", () => (parcelRequire("7UjlI")).useLocalStorage);
$parcel$export(module.exports, "usePrevious", () => (parcelRequire("7UjlI")).usePrevious);
$parcel$export(module.exports, "usePromise", () => (parcelRequire("7UjlI")).usePromise);

var $7UjlI = parcelRequire("7UjlI");

});
parcelRegister("7UjlI", function(module, exports) {

$parcel$export(module.exports, "usePromise", () => $5c1cc5baa5827c56$export$dd6b79aaabe7bc37);
$parcel$export(module.exports, "usePrevious", () => $5c1cc5baa5827c56$export$5cae361ad82dce8b);
$parcel$export(module.exports, "useLocalStorage", () => $5c1cc5baa5827c56$export$86e2cef2561044ac);

var $eUqFw = parcelRequire("eUqFw");

var $ebb1z = parcelRequire("ebb1z");
function $5c1cc5baa5827c56$var$promiseReducer(_state, action) {
    switch(action.type){
        case 'pending':
            return {
                pending: true,
                result: null,
                error: null,
                refresh: null
            };
        case 'fulfilled':
            return {
                pending: false,
                result: action.payload,
                refresh: action.refresh
            };
        default:
            return {
                pending: false,
                error: action.payload,
                refresh: action.refresh
            };
    }
}
function $5c1cc5baa5827c56$export$dd6b79aaabe7bc37(promiseFn) {
    let memoizeOn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
    let runPromise = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    const initialState = {
        result: null,
        error: null,
        pending: true,
        refresh: null
    };
    const [state, dispatch] = (0, $eUqFw.useReducer)($5c1cc5baa5827c56$var$promiseReducer, initialState);
    const promiseExecuter = ()=>{
        dispatch({
            type: 'pending'
        });
        promiseFn().then((result)=>dispatch({
                type: 'fulfilled',
                payload: result,
                refresh: promiseExecuter
            })).catch((error)=>dispatch({
                type: 'error',
                payload: error,
                refresh: promiseExecuter
            }));
    };
    (0, $eUqFw.useEffect)(()=>{
        if (runPromise) promiseExecuter();
    }, memoizeOn);
    return state;
}
function $5c1cc5baa5827c56$export$5cae361ad82dce8b(value) {
    const ref = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}
function $5c1cc5baa5827c56$export$86e2cef2561044ac(key, defaultValue) {
    const isStorageSupported = (0, $ebb1z.getLocalStorageSupport)();
    const value = (0, $ebb1z.getFromStorage)(key);
    const [localState, updateLocalState] = (0, $eUqFw.useState)(value === null || value === undefined ? defaultValue : (0, $ebb1z.tryParse)(value));
    const onLocalStorageChange = (0, $eUqFw.useCallback)((event)=>{
        if ((0, $ebb1z.isTypeOfLocalStorageChanged)(event) && event.detail.key === key) updateLocalState(event.detail.value);
    }, [
        updateLocalState,
        key
    ]);
    (0, $eUqFw.useEffect)(()=>{
        if (!isStorageSupported) return;
        window.addEventListener((0, $ebb1z.LOCAL_STORAGE_CHANGE_EVENT_NAME), onLocalStorageChange);
        return ()=>{
            window.removeEventListener((0, $ebb1z.LOCAL_STORAGE_CHANGE_EVENT_NAME), onLocalStorageChange);
        };
    }, [
        onLocalStorageChange
    ]);
    const writeState = (0, $eUqFw.useCallback)((newValue)=>(0, $ebb1z.writeStorage)(key, newValue), [
        key
    ]);
    const deleteState = (0, $eUqFw.useCallback)(()=>(0, $ebb1z.deleteFromStorage)(key), [
        key
    ]);
    const state = localState !== null && localState !== void 0 ? localState : defaultValue;
    return {
        state: state,
        isLocalStorageSupported: isStorageSupported,
        writeState: writeState,
        deleteState: deleteState
    };
}

});



parcelRegister("4XIQ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $39cf7465bf1dd537$export$2e2bcd8739ae039);

var $2etWF = parcelRequire("2etWF");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $l501X = parcelRequire("l501X");
var $jyCWD = parcelRequire("jyCWD");

var $eo2d1 = parcelRequire("eo2d1");
parcelRequire("eUqFw");

var $c1ZLO = parcelRequire("c1ZLO");

var $fhWaL = parcelRequire("fhWaL");

var $2lsfU = parcelRequire("2lsfU");

var $fGPEd = parcelRequire("fGPEd");

var $7zGmA = parcelRequire("7zGmA");

var $lHkHI = parcelRequire("lHkHI");
const $39cf7465bf1dd537$export$e3b7bfac63d39e42 = (emailId)=>"mailto:".concat(emailId);
const $39cf7465bf1dd537$export$b87545e51662fdc2 = {
    emailId: 'app-listing__support-link__email-id',
    phoneNumber: 'app-listing__support-link__phone-number',
    statusPageUrl: 'app-listing__support-link__status-page-url',
    supportTimings: 'app-listing__support-contact__availability-timings'
};
const $39cf7465bf1dd537$export$5e3abdda20f68ac2 = (props)=>{
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const { supportTicketSystemUrl: supportTicketSystemUrl, issueTrackerUrl: issueTrackerUrl, websiteUrl: websiteUrl } = props;
    const onSupportRequestLinkClick = (supportResourcesLinkType, text)=>{
        props.onSupportLinkClick(supportResourcesLinkType);
        fireAnalyticsEvent({
            eventType: (0, $gaiog.LinkClickedEvent),
            actionSubjectId: (0, $gaiog.ANALYTICS_SUBJECT_ID_SUPPORT_TICKET_LINK),
            eventContainer: (0, $gaiog.EVENT_CONTAINER_SUPPORT_APPLISTING_TAB),
            attributes: {
                linkText: text
            }
        });
    };
    if (supportTicketSystemUrl) {
        const linkText = 'Submit a support request';
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2lsfU.ContactItem), {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                href: supportTicketSystemUrl,
                onClick: ()=>onSupportRequestLinkClick((0, $fGPEd.SupportResourcesLink).ISSUE_TRACKER, linkText),
                title: "Request support for app",
                children: linkText
            })
        });
    }
    if (issueTrackerUrl) {
        const linkText = 'Submit a support request';
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2lsfU.ContactItem), {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                href: issueTrackerUrl,
                onClick: ()=>onSupportRequestLinkClick((0, $fGPEd.SupportResourcesLink).ISSUE_TRACKER, linkText),
                title: "Request support for app",
                children: linkText
            })
        });
    }
    if (websiteUrl) {
        const linkText = 'Go to vendor support website';
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2lsfU.ContactItem), {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                href: websiteUrl,
                onClick: ()=>onSupportRequestLinkClick((0, $fGPEd.SupportResourcesLink).SUPPORT_WEBSITE, linkText),
                title: "Visit website for support",
                children: linkText
            })
        });
    }
    return null;
};
const $39cf7465bf1dd537$export$c8cf7da8f0dde8e4 = (props)=>{
    const { availability: availability } = props;
    if (!availability) return null;
    const availabilityType = (0, $7zGmA.getPartnerSupportAvailability)({
        availability: availability,
        localTime: Date.now()
    });
    if (availabilityType === (0, $fGPEd.SupportAvailability).Open) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2lsfU.ContactItem), {
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $2lsfU.SupportOpenIndicator), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2etWF))), {
                    label: "Support hours"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2lsfU.SupportOpenIndicatorLabel), {
                    children: "Open now"
                })
            ]
        })
    });
    else if (availabilityType === (0, $fGPEd.SupportAvailability).OnHoliday) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2lsfU.ContactItem), {
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $2lsfU.SupportOnHolidayIndicator), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2etWF))), {
                    label: "Support hours"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2lsfU.SupportOpenIndicatorLabel), {
                    title: "Support is currently unavailable due to a holiday",
                    children: "Closed for holiday"
                })
            ]
        })
    });
    return null;
};
const $39cf7465bf1dd537$var$SupportContact = (props)=>{
    const { supportDetails: supportDetails } = props;
    const { contact: { emailId: emailId, phoneNumber: phoneNumber, supportTicketSystemUrl: supportTicketSystemUrl, issueTrackerUrl: issueTrackerUrl, websiteUrl: websiteUrl, statusPageUrl: statusPageUrl }, isSupported: isSupported, availability: availability } = supportDetails;
    const hasIssueTrackingResources = issueTrackerUrl || statusPageUrl || supportTicketSystemUrl || websiteUrl;
    if (!isSupported && !hasIssueTrackingResources) return null;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fhWaL.default), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jyCWD.default), {
                children: "Contact"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $2lsfU.ContactDetailsList), {
                children: [
                    isSupported && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)($39cf7465bf1dd537$export$c8cf7da8f0dde8e4, {
                                availability: availability
                            }),
                            (availability === null || availability === void 0 ? void 0 : availability.daysOfWeek.length) && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2lsfU.ContactItem), {
                                "data-testid": (0, $c1ZLO.TEST_ID).SUPPORT_TAB_SUPPORT_TIMINGS,
                                children: (0, $eo2d1.humanizeSupportTimings)(availability)
                            }),
                            phoneNumber && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2lsfU.ContactItem), {
                                "data-testid": (0, $c1ZLO.TEST_ID).SUPPORT_TAB_PHONE_NUMBER,
                                children: phoneNumber
                            }),
                            emailId && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2lsfU.ContactItem), {
                                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                                    href: $39cf7465bf1dd537$export$e3b7bfac63d39e42(emailId),
                                    title: "Contact via email",
                                    "data-testid": (0, $c1ZLO.TEST_ID).SUPPORT_TAB_EMAIL_ID,
                                    onClick: ()=>props.onSupportLinkClick((0, $fGPEd.SupportResourcesLink).EMAIL),
                                    children: "Email vendor"
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($39cf7465bf1dd537$export$5e3abdda20f68ac2, {
                        supportTicketSystemUrl: supportTicketSystemUrl,
                        issueTrackerUrl: issueTrackerUrl,
                        websiteUrl: websiteUrl,
                        onSupportLinkClick: props.onSupportLinkClick
                    }),
                    statusPageUrl && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2lsfU.ContactItem), {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                            href: statusPageUrl,
                            title: "Visit status page",
                            "data-testid": (0, $c1ZLO.TEST_ID).SUPPORT_TAB_STATUS_PAGE_URL,
                            onClick: ()=>props.onSupportLinkClick((0, $fGPEd.SupportResourcesLink).STATUS_PAGE),
                            children: "Go to vendor status page"
                        })
                    })
                ]
            })
        ]
    });
};
var $39cf7465bf1dd537$export$2e2bcd8739ae039 = $39cf7465bf1dd537$var$SupportContact;

});
parcelRegister("2etWF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a041e1379c96a5d$var$_react = $1a041e1379c96a5d$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $1a041e1379c96a5d$var$_clock = $1a041e1379c96a5d$var$_interopRequireDefault((parcelRequire("5cmZs")));
function $1a041e1379c96a5d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1a041e1379c96a5d$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $1a041e1379c96a5d$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $1a041e1379c96a5d$var$_clock.default
    }));
$1a041e1379c96a5d$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $1a041e1379c96a5d$var$_default = module.exports.default = $1a041e1379c96a5d$var$EmojiFrequentIcon;

});

parcelRegister("eo2d1", function(module, exports) {

$parcel$export(module.exports, "humanizeSupportTimings", () => $a795053f23bbe2b1$export$c6397f68345a50f1);

var $4p54N = parcelRequire("4p54N");

var $76fzC = parcelRequire("76fzC");
const $a795053f23bbe2b1$export$e8e43b2df43cd63 = (daysOfWeek)=>$76fzC.toWeekdayRanges(daysOfWeek).join(', ');
const $a795053f23bbe2b1$export$942c95d97413d99a = (options)=>{
    const { isAvailable24Hours: isAvailable24Hours, startTime: startTime = null, endTime: endTime = null } = options;
    if (isAvailable24Hours || !startTime || !endTime || startTime === endTime) return '24hrs';
    return [
        $76fzC.to12HourFormat(startTime),
        $76fzC.to12HourFormat(endTime)
    ].join(' - ');
};
const $a795053f23bbe2b1$export$916086caedb57dc2 = (timezone)=>(0, $4p54N.default)(new Date(), 'zzz', {
        timeZone: timezone
    });
const $a795053f23bbe2b1$export$c6397f68345a50f1 = (availability)=>{
    const { daysOfWeek: daysOfWeek, startTime: startTime, endTime: endTime, isAvailable24Hours: isAvailable24Hours, timezone: timezone } = availability;
    if (!(daysOfWeek !== null && daysOfWeek !== void 0 && daysOfWeek.length)) return null;
    const supportDays = $a795053f23bbe2b1$export$e8e43b2df43cd63(daysOfWeek);
    const supportHours = $a795053f23bbe2b1$export$942c95d97413d99a({
        isAvailable24Hours: isAvailable24Hours,
        startTime: startTime,
        endTime: endTime
    });
    const supportTimezone = $a795053f23bbe2b1$export$916086caedb57dc2(timezone);
    return [
        supportDays,
        supportHours,
        supportTimezone
    ].join(' ');
};

});

parcelRegister("2lsfU", function(module, exports) {

$parcel$export(module.exports, "ResourceItem", () => $1b5375e9d739f27c$export$aae6af2b507cebbb);
$parcel$export(module.exports, "ContactDetailsList", () => $1b5375e9d739f27c$export$a5d79ce141e9e22e);
$parcel$export(module.exports, "ContactItem", () => $1b5375e9d739f27c$export$b660bf76b2637b21);
$parcel$export(module.exports, "SubtleTagline", () => $1b5375e9d739f27c$export$bf83f34f8708cc5e);
$parcel$export(module.exports, "SupportOpenIndicator", () => $1b5375e9d739f27c$export$27fc713da524c276);
$parcel$export(module.exports, "SupportOnHolidayIndicator", () => $1b5375e9d739f27c$export$fff6c844bb9b253);
$parcel$export(module.exports, "SupportOpenIndicatorLabel", () => $1b5375e9d739f27c$export$af1867d3fc38bbfd);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $8gcXz = parcelRequire("8gcXz");
function $1b5375e9d739f27c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1b5375e9d739f27c$export$aae6af2b507cebbb = (0, $3UXZ8.default)("div", {
    target: "ez4r31v0",
    label: "ResourceItem"
})({
    name: "ru4emr",
    styles: "margin-bottom:var(--ds-space-300, 24px);p{margin-top:var(--ds-space-050, 4px);}"
});
const $1b5375e9d739f27c$export$a5d79ce141e9e22e = (0, $3UXZ8.default)("ul", {
    target: "ez4r31v1",
    label: "ContactDetailsList"
})({
    name: "1rlp2f1",
    styles: "padding:0;margin:0 0 var(--ds-space-300, 24px);list-style:none;"
});
const $1b5375e9d739f27c$export$b660bf76b2637b21 = (0, $3UXZ8.default)("li", {
    target: "ez4r31v2",
    label: "ContactItem"
})({
    name: "11x3y2b",
    styles: "margin:0 0 var(--ds-space-150, 12px);"
});
const $1b5375e9d739f27c$export$bf83f34f8708cc5e = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H3), {
    target: "ez4r31v3",
    label: "SubtleTagline"
})("&&{color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N300), ")"), ";font-weight:400;", (props)=>props.centered ? "text-align: center;" : '', "}");
const $1b5375e9d739f27c$export$27fc713da524c276 = (0, $3UXZ8.default)("span", {
    target: "ez4r31v4",
    label: "SupportOpenIndicator"
})("display:inline-flex;align-items:center;color:", "var(--ds-text-success, ".concat((0, $j0gMm.G300), ")"), ";");
const $1b5375e9d739f27c$export$fff6c844bb9b253 = /*#__PURE__*/ (0, $3UXZ8.default)($1b5375e9d739f27c$export$27fc713da524c276, {
    target: "ez4r31v5",
    label: "SupportOnHolidayIndicator"
})("color:", "var(--ds-text-danger, ".concat((0, $j0gMm.R400), ")"), ";");
const $1b5375e9d739f27c$export$af1867d3fc38bbfd = (0, $3UXZ8.default)("span", {
    target: "ez4r31v6",
    label: "SupportOpenIndicatorLabel"
})({
    name: "9n3bbc",
    styles: "margin-left:3px;"
});
const $1b5375e9d739f27c$export$5fa391294d8903e = (0, $3UXZ8.default)("div", {
    target: "ez4r31v7",
    label: "SupportTabContent"
})({
    name: "8atqhb",
    styles: "width:100%;"
});

});

parcelRegister("fGPEd", function(module, exports) {

$parcel$export(module.exports, "SupportAvailability", () => $b6c2d76cbdd33892$export$c8cf7da8f0dde8e4);
$parcel$export(module.exports, "SupportResourcesLink", () => $b6c2d76cbdd33892$export$5d22490dd877ae53);
const $b6c2d76cbdd33892$export$c8cf7da8f0dde8e4 = Object.freeze({
    Open: 'open',
    Closed: 'closed',
    OnHoliday: 'on-holiday'
});
const $b6c2d76cbdd33892$export$5d22490dd877ae53 = Object.freeze({
    DOCUMENTATION: 'Documentation',
    WIKI: 'Wiki',
    COMMUNITY: 'Community',
    ATLASSIAN_COMMUNITY: 'Atlassian Community',
    EMAIL: 'Email',
    SUPPORT_WEBSITE: 'Support website',
    ISSUE_TRACKER: 'Issue tracker',
    STATUS_PAGE: 'Status Page'
});

});

parcelRegister("7zGmA", function(module, exports) {

$parcel$export(module.exports, "getPartnerSupportAvailability", () => $583ca9c39bdcf131$export$389f559a54721f3e);

var $ammkg = parcelRequire("ammkg");

var $bcchJ = parcelRequire("bcchJ");
var $dulT0 = parcelRequire("dulT0");
var $kWEgJ = parcelRequire("kWEgJ");
var $5YjhU = parcelRequire("5YjhU");
var $3xcI8 = parcelRequire("3xcI8");
var $4YEAP = parcelRequire("4YEAP");

var $bbmZl = parcelRequire("bbmZl");

var $fGPEd = parcelRequire("fGPEd");
const $583ca9c39bdcf131$export$61d6c348432b6a2a = (options)=>{
    if (!options.holidays.length) return false;
    const { holidays: holidays, date: date } = options;
    return holidays.some((holiday)=>{
        const holidayDate = (0, $3xcI8.default)(holiday.date);
        if (holiday.holidayFrequency === (0, $ammkg.MarketplacePartnerSupportHolidayFrequency).OneTime) return (0, $dulT0.default)(holidayDate, date);
        else if (holiday.holidayFrequency === (0, $ammkg.MarketplacePartnerSupportHolidayFrequency).Annual) {
            const holidayInCurrentYear = (0, $4YEAP.default)(holidayDate, date.getFullYear());
            return (0, $dulT0.default)(holidayInCurrentYear, date);
        }
        return false;
    });
};
const $583ca9c39bdcf131$export$389f559a54721f3e = (options)=>{
    const { localTime: localTime, availability: { timezoneOffset: timezoneOffset, startTime: startTime, endTime: endTime, isAvailable24Hours: isAvailable24Hours, daysOfWeek: daysOfWeek, holidays: holidays } } = options;
    /*
    NOTE: this date object has the partner's date & time values but the timezone would be incorrect
   - would be the local timezone - and hence should not be used for further _conversions_
  */ const currentTimeInPartnerTimezone = (0, $bbmZl.default)(localTime, timezoneOffset);
    if ($583ca9c39bdcf131$export$61d6c348432b6a2a({
        date: currentTimeInPartnerTimezone,
        holidays: holidays
    })) return (0, $fGPEd.SupportAvailability).OnHoliday;
    const currentDayOfWeek = (0, $bcchJ.default)(currentTimeInPartnerTimezone);
    const available24Hours = isAvailable24Hours || startTime === endTime;
    const open = daysOfWeek.some((day)=>{
        if (day !== currentDayOfWeek) return false;
        if (!startTime || !endTime || available24Hours) return true;
        // on the same day, now we check for time
        const startDateTime = (0, $5YjhU.default)(startTime, 'HH:mm', currentTimeInPartnerTimezone);
        const endDateTime = (0, $5YjhU.default)(endTime, 'HH:mm', currentTimeInPartnerTimezone);
        return (0, $kWEgJ.default)(currentTimeInPartnerTimezone, {
            start: startDateTime,
            end: endDateTime
        });
    });
    return open ? (0, $fGPEd.SupportAvailability).Open : (0, $fGPEd.SupportAvailability).Closed;
};

});


parcelRegister("lz15j", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb2db53e57371cc6$export$2e2bcd8739ae039);

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $l501X = parcelRequire("l501X");
var $jyCWD = parcelRequire("jyCWD");
parcelRequire("eUqFw");

var $fhWaL = parcelRequire("fhWaL");

var $2lsfU = parcelRequire("2lsfU");

var $fGPEd = parcelRequire("fGPEd");

var $lHkHI = parcelRequire("lHkHI");
const $fb2db53e57371cc6$var$SupportResources = (props)=>{
    const { supportDetails: { resources: resources, isAtlassianCommunityEnabled: isAtlassianCommunityEnabled }, communityQuestionLink: communityQuestionLink } = props;
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const atlassianCommunityResource = ()=>{
        if (!isAtlassianCommunityEnabled) return null;
        const linkText = communityQuestionLink.type === 'existing' ? 'See existing Q&A in Atlassian Community' : 'Ask a question in the Atlassian Community';
        return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $2lsfU.ResourceItem), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                    href: communityQuestionLink.url,
                    onClick: ()=>{
                        fireAnalyticsEvent({
                            eventType: (0, $gaiog.LinkClickedEvent),
                            actionSubjectId: (0, $gaiog.ANALYTICS_SUBJECT_ID_COMMUNITY_QUESTION_LINK),
                            eventContainer: (0, $gaiog.EVENT_CONTAINER_SUPPORT_APPLISTING_TAB),
                            attributes: {
                                linkText: linkText
                            }
                        });
                        props.onSupportLinkClick((0, $fGPEd.SupportResourcesLink).ATLASSIAN_COMMUNITY);
                    },
                    children: linkText
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                    children: "Atlassian-hosted discussions connect you to other customers who use this app."
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fhWaL.default), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jyCWD.default), {
                children: "Vendor support resources"
            }),
            resources.documentationUrl && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $2lsfU.ResourceItem), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                        href: resources.documentationUrl,
                        onClick: ()=>{
                            fireAnalyticsEvent({
                                eventType: (0, $gaiog.LinkClickedEvent),
                                actionSubjectId: (0, $gaiog.ANALYTICS_SUBJECT_ID_APP_DOCUMENTATION_LINK),
                                eventContainer: (0, $gaiog.EVENT_CONTAINER_SUPPORT_APPLISTING_TAB),
                                attributes: {
                                    linkText: 'Documentation'
                                }
                            });
                            props.onSupportLinkClick((0, $fGPEd.SupportResourcesLink).DOCUMENTATION);
                        },
                        title: "Documentation",
                        children: "Documentation"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                        children: "Find out how this app works"
                    })
                ]
            }),
            resources.wikiUrl && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $2lsfU.ResourceItem), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                        href: resources.wikiUrl,
                        onClick: ()=>props.onSupportLinkClick((0, $fGPEd.SupportResourcesLink).WIKI),
                        title: "Wiki",
                        children: "Wiki"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                        children: "Collaborative documentation platform hosted by this vendor."
                    })
                ]
            }),
            resources.forumsUrl && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $2lsfU.ResourceItem), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                        onClick: ()=>props.onSupportLinkClick((0, $fGPEd.SupportResourcesLink).COMMUNITY),
                        href: resources.forumsUrl,
                        title: "Community",
                        children: "Community"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                        children: "Community discussions connect you to the vendor and other customers who use this app."
                    })
                ]
            }),
            atlassianCommunityResource()
        ]
    });
};
var $fb2db53e57371cc6$export$2e2bcd8739ae039 = $fb2db53e57371cc6$var$SupportResources;

});

parcelRegister("fxhN1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4f7bcbd22ff6829$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("eUqFw");

var $2lsfU = parcelRequire("2lsfU");

var $lHkHI = parcelRequire("lHkHI");
function $b4f7bcbd22ff6829$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $b4f7bcbd22ff6829$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $b4f7bcbd22ff6829$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $b4f7bcbd22ff6829$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $b4f7bcbd22ff6829$var$SupportTagline = (props)=>{
    const { supportDetails: { isSupported: isSupported, hasResources: hasResources, partner: partner, contact: { issueTrackerUrl: issueTrackerUrl, statusPageUrl: statusPageUrl, supportTicketSystemUrl: supportTicketSystemUrl, websiteUrl: websiteUrl } } } = props;
    const taglineProps = {
        centered: true,
        as: 'h2'
    };
    const hasIssueTrackingResources = issueTrackerUrl || statusPageUrl || supportTicketSystemUrl || websiteUrl;
    if (partner.name && isSupported) return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $2lsfU.SubtleTagline), $b4f7bcbd22ff6829$var$_objectSpread($b4f7bcbd22ff6829$var$_objectSpread({}, taglineProps), {}, {
        children: [
            partner.name,
            " provides support for this app"
        ]
    }));
    if (hasResources || hasIssueTrackingResources) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2lsfU.SubtleTagline), $b4f7bcbd22ff6829$var$_objectSpread($b4f7bcbd22ff6829$var$_objectSpread({}, taglineProps), {}, {
        children: "Basic support resources are available for this app."
    }));
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2lsfU.SubtleTagline), $b4f7bcbd22ff6829$var$_objectSpread($b4f7bcbd22ff6829$var$_objectSpread({}, taglineProps), {}, {
        children: "Support is not available for this app."
    }));
};
var $b4f7bcbd22ff6829$export$2e2bcd8739ae039 = $b4f7bcbd22ff6829$var$SupportTagline;

});


parcelRegister("7lusI", function(module, exports) {

$parcel$export(module.exports, "SupportTab", () => $55921fbbe68a00b0$export$4e360c5fc698ca81);
parcelRequire("eUqFw");

var $7GAac = parcelRequire("7GAac");

var $5y7Bn = parcelRequire("5y7Bn");

var $fGPEd = parcelRequire("fGPEd");

var $8rN7p = parcelRequire("8rN7p");

var $hR35H = parcelRequire("hR35H");

var $jCyTh = parcelRequire("jCyTh");

var $iAvc4 = parcelRequire("iAvc4");

var $lHkHI = parcelRequire("lHkHI");
const $55921fbbe68a00b0$export$4e360c5fc698ca81 = (props)=>{
    const { supportDetails: supportDetails, atlassianCommunityBaseUrl: atlassianCommunityBaseUrl, mpacBaseUrl: mpacBaseUrl, hosting: hosting, appKey: appKey, onSupportLinkClick: onSupportLinkClick, cloudMigrationInfo: cloudMigrationInfo, onCloudMigrationResourceLinksClick: onCloudMigrationResourceLinksClick } = props;
    const atlassianCommunityUrl = (0, $7GAac.useCommunityQuestionLink)({
        atlassianCommunityBaseUrl: atlassianCommunityBaseUrl,
        mpacBaseUrl: mpacBaseUrl,
        appKey: appKey,
        hosting: hosting
    });
    const hasContact = supportDetails.isSupported && (supportDetails.availability || supportDetails.contact.emailId || supportDetails.contact.phoneNumber || supportDetails.contact.issueTrackerUrl || supportDetails.contact.supportTicketSystemUrl);
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $5y7Bn.TabContentContainer), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $iAvc4.SupportTagline), {
                supportDetails: supportDetails,
                atlassianCommunityUrl: atlassianCommunityUrl.url,
                onCommunityLinkClick: ()=>onSupportLinkClick((0, $fGPEd.SupportResourcesLink).ATLASSIAN_COMMUNITY)
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $8rN7p.Columns), {
                children: [
                    hasContact && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8rN7p.LeftColumn), {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hR35H.SupportContact), {
                            supportDetails: supportDetails,
                            onSupportLinkClick: onSupportLinkClick
                        })
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8rN7p.RightColumn), {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jCyTh.SupportResources), {
                            supportDetails: supportDetails,
                            onSupportLinkClick: onSupportLinkClick,
                            atlassianCommunityUrl: atlassianCommunityUrl.url,
                            cloudMigrationInfo: cloudMigrationInfo,
                            onCloudMigrationResourceLinksClick: onCloudMigrationResourceLinksClick
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("8rN7p", function(module, exports) {

$parcel$export(module.exports, "TaglineContainer", () => $6266f244105d622c$export$6ce1bfd74642caa7);
$parcel$export(module.exports, "Columns", () => $6266f244105d622c$export$f02cc02ad0e0bba3);
$parcel$export(module.exports, "LeftColumn", () => $6266f244105d622c$export$4cb61b3787083a8b);
$parcel$export(module.exports, "RightColumn", () => $6266f244105d622c$export$d274d05a02cf9d7c);
/* styles.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $lHkHI = parcelRequire("lHkHI");
const $6266f244105d622c$var$_excluded = [
    "as",
    "style"
], $6266f244105d622c$var$_excluded2 = [
    "as",
    "style"
], $6266f244105d622c$var$_excluded3 = [
    "as",
    "style"
], $6266f244105d622c$var$_excluded4 = [
    "as",
    "style"
];
function $6266f244105d622c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6266f244105d622c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6266f244105d622c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6266f244105d622c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $6266f244105d622c$export$6ce1bfd74642caa7 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $6266f244105d622c$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $6266f244105d622c$var$_objectSpread($6266f244105d622c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_otyrxy5q",
            __cmplp.className
        ])
    }));
});
const $6266f244105d622c$export$f02cc02ad0e0bba3 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $6266f244105d622c$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $6266f244105d622c$var$_objectSpread($6266f244105d622c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _4cvr1h6o _1bah1h6o _zulp1jfw _1inivrvc _1jsv1y6m _pdlmxy5q _45zz1g80",
            __cmplp.className
        ])
    }));
});
const $6266f244105d622c$export$4cb61b3787083a8b = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $6266f244105d622c$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $6266f244105d622c$var$_objectSpread($6266f244105d622c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq _10m4egat _1vdkkb7n _1wznf1ug _glten7od _1wzn9tnu",
            __cmplp.className
        ])
    }));
});
const $6266f244105d622c$export$d274d05a02cf9d7c = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $6266f244105d622c$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $6266f244105d622c$var$_objectSpread($6266f244105d622c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1osq _1bsb1osq _10m437uc _1vdkkb7n _1wznf1ug _glten7od _1wznlqvf",
            __cmplp.className
        ])
    }));
});

});

parcelRegister("hR35H", function(module, exports) {

$parcel$export(module.exports, "SupportContact", () => $035abd0b3b9eb081$export$3f0f0df419fc6a24);

var $5cJpv = parcelRequire("5cJpv");

var $cCrLo = parcelRequire("cCrLo");
parcelRequire("eUqFw");

var $cZHqq = parcelRequire("cZHqq");

var $gTtkF = parcelRequire("gTtkF");

var $fX7E3 = parcelRequire("fX7E3");

var $56tNd = parcelRequire("56tNd");

var $lHkHI = parcelRequire("lHkHI");
const $035abd0b3b9eb081$export$3f0f0df419fc6a24 = (props)=>{
    const { supportDetails: supportDetails, onSupportLinkClick: onSupportLinkClick } = props;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gTtkF.ContactCard), {
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $5cJpv.default), {
            space: "space.300",
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.H5), {
                    as: "h3",
                    children: "Contact"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $5cJpv.default), {
                    space: "space.200",
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cZHqq.CurrentSupportAvailability), {
                            availability: supportDetails.availability
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fX7E3.SupportContactDetails), {
                            supportDetails: supportDetails
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $56tNd.SupportRequest), {
                            supportDetails: supportDetails,
                            onSupportLinkClick: onSupportLinkClick
                        })
                    ]
                })
            ]
        })
    });
};

});
parcelRegister("cZHqq", function(module, exports) {

$parcel$export(module.exports, "CurrentSupportAvailability", () => $975cdddd7953949a$export$cf3b7558522aabcf);

var $j8E8v = parcelRequire("j8E8v");

var $lWrn5 = parcelRequire("lWrn5");
parcelRequire("eUqFw");

var $fGPEd = parcelRequire("fGPEd");

var $7zGmA = parcelRequire("7zGmA");

var $lHkHI = parcelRequire("lHkHI");
const $975cdddd7953949a$export$cf3b7558522aabcf = (_ref)=>{
    let { availability: availability } = _ref;
    if (!availability) return null;
    const availabilityType = (0, $7zGmA.getPartnerSupportAvailability)({
        availability: availability,
        localTime: Date.now()
    });
    const getLozenge = ()=>{
        if (availabilityType === (0, $fGPEd.SupportAvailability).Open) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j8E8v.default), {
            appearance: "success",
            children: "Open now"
        });
        if (availabilityType === (0, $fGPEd.SupportAvailability).OnHoliday) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j8E8v.default), {
            appearance: "default",
            children: "Closed (Holiday)"
        });
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j8E8v.default), {
            appearance: "default",
            children: "Closed"
        });
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lWrn5.default), {
                children: "Support availability:"
            }),
            getLozenge()
        ]
    });
};

});

parcelRegister("gTtkF", function(module, exports) {

$parcel$export(module.exports, "ContactCard", () => $c4c8892fe3917e5c$export$c9ce65124d222c64);
$parcel$export(module.exports, "ContactList", () => $c4c8892fe3917e5c$export$909c3b6a9e12845c);
$parcel$export(module.exports, "ContactItem", () => $c4c8892fe3917e5c$export$b660bf76b2637b21);
$parcel$export(module.exports, "ContactDetail", () => $c4c8892fe3917e5c$export$9189d760fc20e051);
$parcel$export(module.exports, "ContactLink", () => $c4c8892fe3917e5c$export$96c211badc9d5a98);
/* styles.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $cCrLo = parcelRequire("cCrLo");
var $ixQHh = parcelRequire("ixQHh");

var $lHkHI = parcelRequire("lHkHI");
const $c4c8892fe3917e5c$var$_excluded = [
    "as",
    "style"
], $c4c8892fe3917e5c$var$_excluded2 = [
    "as",
    "style"
], $c4c8892fe3917e5c$var$_excluded3 = [
    "as",
    "style"
], $c4c8892fe3917e5c$var$_excluded4 = [
    "as",
    "style"
], $c4c8892fe3917e5c$var$_excluded5 = [
    "as",
    "style"
];
function $c4c8892fe3917e5c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c4c8892fe3917e5c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c4c8892fe3917e5c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c4c8892fe3917e5c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $c4c8892fe3917e5c$export$c9ce65124d222c64 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "section", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $c4c8892fe3917e5c$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $c4c8892fe3917e5c$var$_objectSpread($c4c8892fe3917e5c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19it7v06 _2rko1crf _1yt4g30r",
            __cmplp.className
        ])
    }));
});
const $c4c8892fe3917e5c$export$909c3b6a9e12845c = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "ul", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $c4c8892fe3917e5c$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $c4c8892fe3917e5c$var$_objectSpread($c4c8892fe3917e5c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    }));
});
const $c4c8892fe3917e5c$export$b660bf76b2637b21 = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "li", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $c4c8892fe3917e5c$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $c4c8892fe3917e5c$var$_objectSpread($c4c8892fe3917e5c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _otyrxjmg _zulp1eps _isu41eps",
            __cmplp.className
        ])
    }));
});
const $c4c8892fe3917e5c$export$9189d760fc20e051 = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $c4c8892fe3917e5c$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $c4c8892fe3917e5c$var$_objectSpread($c4c8892fe3917e5c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    }));
});
const $c4c8892fe3917e5c$export$96c211badc9d5a98 = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = (0, $ixQHh.SubtleLink), style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $c4c8892fe3917e5c$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $c4c8892fe3917e5c$var$_objectSpread($c4c8892fe3917e5c$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48p1nn1 _vwz41j6v _1i4qfg65 _1yt445bk",
            __cmplp.className
        ])
    }));
});

});

parcelRegister("fX7E3", function(module, exports) {

$parcel$export(module.exports, "SupportContactDetails", () => $b9d24bd2e09216fb$export$bd88c5cab6aa96cc);

var $jOmvb = parcelRequire("jOmvb");

var $2etWF = parcelRequire("2etWF");

var $7KSNq = parcelRequire("7KSNq");

var $eo2d1 = parcelRequire("eo2d1");
parcelRequire("eUqFw");

var $fGPEd = parcelRequire("fGPEd");

var $7zGmA = parcelRequire("7zGmA");

var $gTtkF = parcelRequire("gTtkF");

var $lHkHI = parcelRequire("lHkHI");
const $b9d24bd2e09216fb$export$bd88c5cab6aa96cc = (props)=>{
    const { supportDetails: { availability: availability, contact: { emailId: emailId, phoneNumber: phoneNumber } } } = props;
    const supportTimings = availability && (0, $eo2d1.humanizeSupportTimings)(availability);
    const availabilityType = availability && (0, $7zGmA.getPartnerSupportAvailability)({
        availability: availability,
        localTime: Date.now()
    });
    const isClosed = availabilityType !== (0, $fGPEd.SupportAvailability).Open;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $gTtkF.ContactList), {
        children: [
            supportTimings && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $gTtkF.ContactItem), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($2etWF))), {
                        label: "Support Timings"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $gTtkF.ContactDetail), {
                        children: [
                            isClosed ? 'Open from ' : '',
                            supportTimings
                        ]
                    })
                ]
            }),
            emailId && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $gTtkF.ContactItem), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($jOmvb))), {
                        label: "Contact Email"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gTtkF.ContactDetail), {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gTtkF.ContactLink), {
                            href: "mailto:".concat(emailId),
                            size: "medium",
                            "aria-label": "Support contact email open in external email app",
                            children: emailId
                        })
                    })
                ]
            }),
            phoneNumber && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $gTtkF.ContactItem), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7KSNq))), {
                        label: "Contact phone"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gTtkF.ContactDetail), {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gTtkF.ContactLink), {
                            href: "tel:".concat(phoneNumber),
                            size: "medium",
                            "aria-label": "Support contact phone open in external caller",
                            children: phoneNumber
                        })
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("jOmvb", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6c424413b6af397$var$_react = $e6c424413b6af397$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $e6c424413b6af397$var$_email = $e6c424413b6af397$var$_interopRequireDefault((parcelRequire("aOniY")));
function $e6c424413b6af397$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e6c424413b6af397$var$EmailIcon = (props)=>/*#__PURE__*/ $e6c424413b6af397$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 7v10h14V7zm14-2c1.1 0 2 .9 2 2v10c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2z"/><path d="M5.498 6.5H3.124c.149.44.399.854.75 1.205l5.882 5.881a3.117 3.117 0 0 0 4.41 0l5.882-5.881c.35-.351.6-.765.749-1.205h-2.373l-5.672 5.672a1.12 1.12 0 0 1-1.583 0z"/></g></svg>`
    }, props, {
        newIcon: $e6c424413b6af397$var$_email.default
    }));
$e6c424413b6af397$var$EmailIcon.displayName = 'EmailIcon';
var $e6c424413b6af397$var$_default = module.exports.default = $e6c424413b6af397$var$EmailIcon;

});
parcelRegister("aOniY", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::01c9d10de58aecafc412cf2587bb6df9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7df0a6c580f88dcb$var$_react = $7df0a6c580f88dcb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $7df0a6c580f88dcb$var$_UNSAFE_baseNew = $7df0a6c580f88dcb$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $7df0a6c580f88dcb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Email".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for when an email-related things.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7df0a6c580f88dcb$var$EmailIcon = (props)=>/*#__PURE__*/ $7df0a6c580f88dcb$var$_react.default.createElement($7df0a6c580f88dcb$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M15.25 4.97V4c0-.69-.56-1.25-1.25-1.25H2C1.31 2.75.75 3.31.75 4v.97m14.5 0V12c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V4.97m14.5 0L8 8.986.75 4.971"/>`
    }, props));
$7df0a6c580f88dcb$var$EmailIcon.displayName = 'EmailIcon';
var $7df0a6c580f88dcb$var$_default = module.exports.default = $7df0a6c580f88dcb$var$EmailIcon;

});


parcelRegister("7KSNq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5a5755ae0abdc5d1$var$_react = $5a5755ae0abdc5d1$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $5a5755ae0abdc5d1$var$_deviceMobile = $5a5755ae0abdc5d1$var$_interopRequireDefault((parcelRequire("htXTL")));
function $5a5755ae0abdc5d1$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $5a5755ae0abdc5d1$var$MobileIcon = (props)=>/*#__PURE__*/ $5a5755ae0abdc5d1$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M7 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm10 2H7v13h10zm-3 15h-4v1h4z" clip-rule="evenodd"/></svg>`
    }, props, {
        newIcon: $5a5755ae0abdc5d1$var$_deviceMobile.default
    }));
$5a5755ae0abdc5d1$var$MobileIcon.displayName = 'MobileIcon';
var $5a5755ae0abdc5d1$var$_default = module.exports.default = $5a5755ae0abdc5d1$var$MobileIcon;

});
parcelRegister("htXTL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e0c4e8338c0100539dcdaebc964503c9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cba39bad48b64154$var$_react = $cba39bad48b64154$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $cba39bad48b64154$var$_UNSAFE_baseNew = $cba39bad48b64154$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $cba39bad48b64154$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "DeviceMobile".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: call, contact us.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cba39bad48b64154$var$DeviceMobileIcon = (props)=>/*#__PURE__*/ $cba39bad48b64154$var$_react.default.createElement($cba39bad48b64154$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M6 12.25h4m-5.5 3h7c.69 0 1.25-.56 1.25-1.25V2c0-.69-.56-1.25-1.25-1.25h-7c-.69 0-1.25.56-1.25 1.25v12c0 .69.56 1.25 1.25 1.25Z"/>`
    }, props));
$cba39bad48b64154$var$DeviceMobileIcon.displayName = 'DeviceMobileIcon';
var $cba39bad48b64154$var$_default = module.exports.default = $cba39bad48b64154$var$DeviceMobileIcon;

});



parcelRegister("56tNd", function(module, exports) {

$parcel$export(module.exports, "SupportRequest", () => $3b749f8a64feea7d$export$5e3abdda20f68ac2);
/* SupportRequest.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $1cSAP = parcelRequire("1cSAP");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $fGPEd = parcelRequire("fGPEd");

var $lHkHI = parcelRequire("lHkHI");
const $3b749f8a64feea7d$var$_excluded = [
    "as",
    "style"
];
function $3b749f8a64feea7d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3b749f8a64feea7d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3b749f8a64feea7d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3b749f8a64feea7d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $3b749f8a64feea7d$var$Container = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $3b749f8a64feea7d$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $3b749f8a64feea7d$var$_objectSpread($3b749f8a64feea7d$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1wybljao",
            __cmplp.className
        ])
    }));
});
const $3b749f8a64feea7d$var$getSupportRequestDetails = (supportDetails)=>{
    const { contact: { issueTrackerUrl: issueTrackerUrl, supportTicketSystemUrl: supportTicketSystemUrl, websiteUrl: websiteUrl } } = supportDetails;
    const commonAttributes = {
        target: '_blank',
        rel: 'external noopener noreferrer'
    };
    if (supportTicketSystemUrl) {
        const label = 'Submit support request';
        return {
            link: $3b749f8a64feea7d$var$_objectSpread({
                href: supportTicketSystemUrl,
                'aria-label': "".concat(label),
                children: label
            }, commonAttributes),
            analytics: {
                /* TODO: MC-5884 confirm the link type */ linkType: (0, $fGPEd.SupportResourcesLink).ISSUE_TRACKER,
                attributes: {
                    linkText: label
                }
            }
        };
    }
    if (issueTrackerUrl) {
        const label = 'Submit support request';
        return {
            link: $3b749f8a64feea7d$var$_objectSpread({
                href: issueTrackerUrl,
                'aria-label': "".concat(label),
                children: label
            }, commonAttributes),
            analytics: {
                linkType: (0, $fGPEd.SupportResourcesLink).ISSUE_TRACKER,
                attributes: {
                    linkText: label
                }
            }
        };
    }
    if (websiteUrl) {
        const label = 'Visit support website';
        return {
            link: $3b749f8a64feea7d$var$_objectSpread({
                href: websiteUrl,
                'aria-label': "".concat(label),
                children: label
            }, commonAttributes),
            analytics: {
                linkType: (0, $fGPEd.SupportResourcesLink).SUPPORT_WEBSITE,
                attributes: {
                    linkText: label
                }
            }
        };
    }
    return null;
};
const $3b749f8a64feea7d$export$5e3abdda20f68ac2 = (props)=>{
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const { onSupportLinkClick: onSupportLinkClick, supportDetails: supportDetails } = props;
    const request = $3b749f8a64feea7d$var$getSupportRequestDetails(supportDetails);
    if (!request) return null;
    const { link: link, analytics: analytics } = request;
    const onLinkClick = ()=>{
        onSupportLinkClick(analytics.linkType);
        fireAnalyticsEvent({
            eventType: (0, $gaiog.LinkClickedEvent),
            actionSubjectId: (0, $gaiog.ANALYTICS_SUBJECT_ID_SUPPORT_TICKET_LINK),
            eventContainer: (0, $gaiog.EVENT_CONTAINER_SUPPORT_APPLISTING_TAB),
            attribes: analytics.attributes
        });
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)($3b749f8a64feea7d$var$Container, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1cSAP.default), $3b749f8a64feea7d$var$_objectSpread($3b749f8a64feea7d$var$_objectSpread({}, link), {}, {
            onClick: onLinkClick
        }))
    });
};

});
parcelRegister("1cSAP", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e1142780bd77211$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $3puyA = parcelRequire("3puyA");

var $bnoZj = parcelRequire("bnoZj");

var $2RJuk = parcelRequire("2RJuk");
const $0e1142780bd77211$var$LinkButtonBase = ({ analyticsContext: analyticsContext, appearance: appearance, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, autoFocus: autoFocus, children: children, href: href, iconAfter: iconAfter, iconBefore: iconBefore, interactionName: interactionName, isDisabled: isDisabled, isSelected: isSelected, onClick: onClick, onClickCapture: onClickCapture, onKeyDownCapture: onKeyDownCapture, onKeyUpCapture: onKeyUpCapture, onMouseDownCapture: onMouseDownCapture, onMouseUpCapture: onMouseUpCapture, onPointerDownCapture: onPointerDownCapture, onPointerUpCapture: onPointerUpCapture, onTouchEndCapture: onTouchEndCapture, onTouchStartCapture: onTouchStartCapture, shouldFitContainer: shouldFitContainer, spacing: spacing, testId: testId, UNSAFE_iconAfter_size: UNSAFE_iconAfter_size, UNSAFE_iconBefore_size: UNSAFE_iconBefore_size, ...unsafeRest }, ref)=>{
    // @ts-expect-error
    const { className: _className, css: _css, as: _as, style: _style, ...saferRest } = unsafeRest;
    const rest = (0, $3puyA.getBooleanFF)('platform.design-system-team.remove-unsafe-spread-from-new-button_a2xhw') ? saferRest : unsafeRest;
    const baseProps = (0, $2RJuk.default)({
        analyticsContext: analyticsContext,
        appearance: appearance,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        autoFocus: autoFocus,
        buttonType: 'link',
        children: children,
        iconAfter: iconAfter,
        iconBefore: iconBefore,
        interactionName: interactionName,
        isDisabled: isDisabled,
        isSelected: isSelected,
        onClick: onClick,
        onClickCapture: onClickCapture,
        onKeyDownCapture: onKeyDownCapture,
        onKeyUpCapture: onKeyUpCapture,
        onMouseDownCapture: onMouseDownCapture,
        onMouseUpCapture: onMouseUpCapture,
        onPointerDownCapture: onPointerDownCapture,
        onPointerUpCapture: onPointerUpCapture,
        onTouchEndCapture: onTouchEndCapture,
        onTouchStartCapture: onTouchStartCapture,
        ref: ref,
        shouldFitContainer: shouldFitContainer,
        spacing: spacing,
        testId: testId,
        UNSAFE_iconAfter_size: UNSAFE_iconAfter_size,
        UNSAFE_iconBefore_size: UNSAFE_iconBefore_size
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $bnoZj.default), (0, $kU09D.default)({}, rest, {
        "aria-label": baseProps['aria-label'],
        "aria-labelledby": baseProps['aria-labelledby'],
        ref: baseProps.ref,
        xcss: baseProps.xcss,
        onClick: baseProps.onClick,
        onMouseDownCapture: baseProps.onMouseDownCapture,
        onMouseUpCapture: baseProps.onMouseUpCapture,
        onKeyDownCapture: baseProps.onKeyDownCapture,
        onKeyUpCapture: baseProps.onKeyUpCapture,
        onTouchStartCapture: baseProps.onTouchStartCapture,
        onTouchEndCapture: baseProps.onTouchEndCapture,
        onPointerDownCapture: baseProps.onPointerDownCapture,
        onPointerUpCapture: baseProps.onPointerUpCapture,
        onClickCapture: baseProps.onClickCapture,
        testId: testId,
        href: baseProps.isDisabled ? undefined : href,
        role: baseProps.isDisabled ? 'link' : undefined,
        "aria-disabled": baseProps.isDisabled === true ? true : undefined,
        analyticsContext: analyticsContext,
        interactionName: interactionName,
        componentName: "LinkButton"
    }), baseProps.children);
};
// Workarounds to support generic types with forwardRef + memo
const $0e1142780bd77211$var$WithRef = /*#__PURE__*/ (0, $eUqFw.forwardRef)($0e1142780bd77211$var$LinkButtonBase);
/**
 * __Link Button__
 *
 * Renders a link in the style of a button.
 *
 * - [Examples](https://atlassian.design/components/link-button/examples)
 * - [Code](https://atlassian.design/components/link-button/code)
 * - [Usage](https://atlassian.design/components/link-button/usage)
 */ const $0e1142780bd77211$var$LinkButton = /*#__PURE__*/ (0, $eUqFw.memo)($0e1142780bd77211$var$WithRef);
var $0e1142780bd77211$export$2e2bcd8739ae039 = $0e1142780bd77211$var$LinkButton;

});
parcelRegister("bnoZj", function(module, exports) {

$parcel$export(module.exports, "default", () => $848539c64ba313ae$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $tkrFt = parcelRequire("tkrFt");

var $8ynlC = parcelRequire("8ynlC");

var $2MblP = parcelRequire("2MblP");

var $aRjyS = parcelRequire("aRjyS");

var $eiQBT = parcelRequire("eiQBT");

var $7R4Cu = parcelRequire("7R4Cu");

var $lWrn5 = parcelRequire("lWrn5");

var $bHLFn = parcelRequire("bHLFn");

var $344PY = parcelRequire("344PY");
// TODO: duplicates FocusRing styles from `@atlaskit/focus-ring`.
const $848539c64ba313ae$var$focusRingStyles = (0, $byn9U.css)({
    '&:focus, &:focus-visible': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineColor: (0, $bHLFn.borderColorMap)['color.border.focused'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineOffset: (0, $bHLFn.positiveSpaceMap)['space.025'],
        outlineStyle: 'solid',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
        outlineWidth: (0, $bHLFn.borderWidthMap)['border.width.outline']
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:focus:not(:focus-visible)': {
        outline: 'none'
    },
    '@media screen and (forced-colors: active), screen and (-ms-high-contrast: active)': {
        '&:focus-visible': {
            outline: '1px solid'
        }
    }
});
const $848539c64ba313ae$var$baseStyles = (0, $byn9U.css)({
    boxSizing: 'border-box',
    textDecoration: 'underline'
});
const $848539c64ba313ae$var$IS_EXTERNAL_LINK_REGEX = /^(?:(http|https):\/\/)/;
const $848539c64ba313ae$var$IS_NON_HTTP_BASED = /^(((mailto|tel|sms):)|(#))/;
// Comma is added here to add a slight pause between announcing the anchor label and "opens in new window"
const $848539c64ba313ae$var$OPENS_NEW_WINDOW_LABEL = '(opens new window)';
/**
 * __Anchor__
 *
 * A primitive for building custom anchor links.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $848539c64ba313ae$var$AnchorNoRef = ({ href: href, children: children, backgroundColor: backgroundColor, newWindowLabel: newWindowLabel, padding: padding, paddingBlock: paddingBlock, paddingBlockStart: paddingBlockStart, paddingBlockEnd: paddingBlockEnd, paddingInline: paddingInline, paddingInlineStart: paddingInlineStart, paddingInlineEnd: paddingInlineEnd, onClick: providedOnClick = (0, $eiQBT.default), interactionName: interactionName, componentName: componentName, analyticsContext: analyticsContext, 'aria-label': ariaLabel, 'aria-labelledby': ariaLabelledBy, style: style, target: target, testId: testId, xcss: xcss, ...htmlAttributes }, ref)=>{
    const interactionContext = (0, $eUqFw.useContext)((0, $7R4Cu.default));
    const handleClick = (0, $eUqFw.useCallback)((e, analyticsEvent)=>{
        interactionContext && interactionContext.tracePress(interactionName, e.timeStamp);
        providedOnClick(e, analyticsEvent);
    }, [
        providedOnClick,
        interactionContext,
        interactionName
    ]);
    // TODO: Use React 18's useId() hook when we update.
    // eslint-disable-next-line @repo/internal/react/disallow-unstable-values
    const opensNewWindowLabelId = (0, $tkrFt.uid)({
        ariaLabelledBy: ariaLabelledBy
    });
    const onClick = (0, $2MblP.usePlatformLeafEventHandler)({
        fn: handleClick,
        action: 'clicked',
        componentName: componentName || 'Anchor',
        packageName: "@atlaskit/primitives",
        packageVersion: "11.1.2",
        analyticsData: analyticsContext,
        actionSubject: 'link'
    });
    // This is to remove className from safeHtmlAttributes
    // @ts-expect-error className doesn't exist in the prop definition but we want to ensure it cannot be applied even if types are bypassed
    const { className: _spreadClass, ...safeHtmlAttributes } = htmlAttributes;
    const resolvedStyles = (0, $344PY.parseXcss)(xcss);
    const RouterLink = (0, $aRjyS.default)();
    const isExternal = typeof href === 'string' && $848539c64ba313ae$var$IS_EXTERNAL_LINK_REGEX.test(href);
    const isNonHttpBased = typeof href === 'string' && $848539c64ba313ae$var$IS_NON_HTTP_BASED.test(href);
    /**
   * Renders a router link if:
   *
   * - a link component is set in the app provider
   * - it's not an external link (starting with `http://` or `https://`)
   * - it's not a non-HTTP-based link (e.g. emails, phone numbers, hash links etc.).
   */ const isRouterLink = RouterLink && !isExternal && !isNonHttpBased;
    const hrefObjectUsedWithoutRouterLink = RouterLink === undefined && typeof href === 'object';
    (0, $8ynlC.default)(!hrefObjectUsedWithoutRouterLink, `@atlaskit/primitives: Anchor primitive cannot pass an object to 'href' unless a router link is configured in the AppProvider`);
    const Component = isRouterLink ? RouterLink : 'a';
    return (0, $byn9U.jsx)(Component, (0, $kU09D.default)({
        style: style,
        ref: ref,
        className: resolvedStyles.static
    }, safeHtmlAttributes, {
        // @ts-expect-error
        href: !isRouterLink && typeof href !== 'string' ? undefined : href,
        target: target,
        onClick: onClick,
        "aria-label": ariaLabel && target === '_blank' && !ariaLabelledBy ? //`${ariaLabel} ${OPENS_NEW_WINDOW_LABEL}`
        `${ariaLabel} , ${newWindowLabel ? newWindowLabel : $848539c64ba313ae$var$OPENS_NEW_WINDOW_LABEL}` : ariaLabel,
        "aria-labelledby": ariaLabelledBy && target === '_blank' ? `${ariaLabelledBy} ${opensNewWindowLabelId}` : ariaLabelledBy,
        css: [
            $848539c64ba313ae$var$baseStyles,
            $848539c64ba313ae$var$focusRingStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor && (0, $bHLFn.backgroundColorStylesMap)[backgroundColor],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            padding && (0, $bHLFn.paddingStylesMap).padding[padding],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlock && (0, $bHLFn.paddingStylesMap).paddingBlock[paddingBlock],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockStart && (0, $bHLFn.paddingStylesMap).paddingBlockStart[paddingBlockStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingBlockEnd && (0, $bHLFn.paddingStylesMap).paddingBlockEnd[paddingBlockEnd],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInline && (0, $bHLFn.paddingStylesMap).paddingInline[paddingInline],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineStart && (0, $bHLFn.paddingStylesMap).paddingInlineStart[paddingInlineStart],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            paddingInlineEnd && (0, $bHLFn.paddingStylesMap).paddingInlineEnd[paddingInlineEnd],
            // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            resolvedStyles.emotion
        ],
        "data-testid": testId,
        "data-is-router-link": testId ? isRouterLink ? 'true' : 'false' : undefined
    }), children, target === '_blank' && (children && !ariaLabel && !ariaLabelledBy || ariaLabelledBy) && (0, $byn9U.jsx)((0, $lWrn5.default), {
        id: opensNewWindowLabelId
    }, `, ${newWindowLabel ? newWindowLabel : $848539c64ba313ae$var$OPENS_NEW_WINDOW_LABEL}`));
};
// Workarounds to support generic types with forwardRef
/**
 * __Anchor__
 *
 * Anchor is a primitive for building custom anchor links. It's a wrapper around the HTML `<a>` element that provides a consistent API for handling client-side routing and Atlassian Design System styling.
 *
 * - [Examples](https://atlassian.design/components/primitives/anchor/examples)
 * - [Code](https://atlassian.design/components/primitives/anchor/code)
 * - [Usage](https://atlassian.design/components/primitives/anchor/usage)
 */ const $848539c64ba313ae$var$Anchor = /*#__PURE__*/ (0, $eUqFw.forwardRef)($848539c64ba313ae$var$AnchorNoRef);
var $848539c64ba313ae$export$2e2bcd8739ae039 = $848539c64ba313ae$var$Anchor;

});




parcelRegister("jCyTh", function(module, exports) {

$parcel$export(module.exports, "SupportResources", () => $e48ca17cb0d26865$export$e47ff6b4e52f30f);
parcelRequire("eUqFw");

var $vTDTI = parcelRequire("vTDTI");

var $c9UN4 = parcelRequire("c9UN4");

var $eSWMG = parcelRequire("eSWMG");

var $lch1p = parcelRequire("lch1p");

var $lHkHI = parcelRequire("lHkHI");
const $e48ca17cb0d26865$export$e47ff6b4e52f30f = (props)=>{
    const { supportDetails: { resources: { documentationUrl: documentationUrl, forumsUrl: forumsUrl }, contact: { statusPageUrl: statusPageUrl, issueTrackerUrl: issueTrackerUrl } }, onSupportLinkClick: onSupportLinkClick, atlassianCommunityUrl: atlassianCommunityUrl, onCloudMigrationResourceLinksClick: onCloudMigrationResourceLinksClick, cloudMigrationInfo: cloudMigrationInfo } = props;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $vTDTI.Section).Heading, {
                as: "h5",
                children: "Help resources"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eSWMG.ResourceList), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $c9UN4.CloudMigrationResource), {
                        cloudMigrationInfo: cloudMigrationInfo,
                        onCloudMigrationResourceLinksClick: onCloudMigrationResourceLinksClick
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lch1p.DocumentationResource), {
                        documentationUrl: documentationUrl,
                        onSupportLinkClick: onSupportLinkClick
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lch1p.ForumsResource), {
                        forumsUrl: forumsUrl,
                        onSupportLinkClick: onSupportLinkClick
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lch1p.AtlassianCommunityResource), {
                        atlassianCommunityUrl: atlassianCommunityUrl,
                        onSupportLinkClick: onSupportLinkClick
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lch1p.StatusPageResource), {
                        statusPageUrl: statusPageUrl,
                        onSupportLinkClick: onSupportLinkClick
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lch1p.IssueTrackerResource), {
                        issueTrackerUrl: issueTrackerUrl,
                        onSupportLinkClick: onSupportLinkClick
                    })
                ]
            })
        ]
    });
};

});
parcelRegister("vTDTI", function(module, exports) {

$parcel$export(module.exports, "Section", () => $05fe0ecee7bb0455$export$6e2c8f0811a474ce);

var $8SCK2 = parcelRequire("8SCK2");

var $jeIX4 = parcelRequire("jeIX4");
const $05fe0ecee7bb0455$export$6e2c8f0811a474ce = (0, $jeIX4.Section);
$05fe0ecee7bb0455$export$6e2c8f0811a474ce.Heading = (0, $8SCK2.Heading);

});
parcelRegister("8SCK2", function(module, exports) {

$parcel$export(module.exports, "Heading", () => $67716b220465d2c7$export$a8a3e93435678ff9);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $cCrLo = parcelRequire("cCrLo");
parcelRequire("eUqFw");

var $jeIX4 = parcelRequire("jeIX4");

var $lHkHI = parcelRequire("lHkHI");
const $67716b220465d2c7$var$_excluded = [
    "children",
    "hideBorder"
];
function $67716b220465d2c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $67716b220465d2c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $67716b220465d2c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $67716b220465d2c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $67716b220465d2c7$export$a8a3e93435678ff9 = (props)=>{
    const { children: children, hideBorder: hideBorder = false } = props, otherProps = (0, $bwPfh.default)(props, $67716b220465d2c7$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jeIX4.HeadingWrapper), {
        $bottomBorder: !hideBorder,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.H4), $67716b220465d2c7$var$_objectSpread($67716b220465d2c7$var$_objectSpread({
            as: "h3"
        }, otherProps), {}, {
            children: children
        }))
    });
};

});
parcelRegister("jeIX4", function(module, exports) {

$parcel$export(module.exports, "HeadingWrapper", () => $e01231a12b45a094$export$d24ef46eae7cb522);
$parcel$export(module.exports, "Section", () => $e01231a12b45a094$export$6e2c8f0811a474ce);
/* styles.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $lHkHI = parcelRequire("lHkHI");
const $e01231a12b45a094$var$_excluded = [
    "as",
    "style"
], $e01231a12b45a094$var$_excluded2 = [
    "$bottomBorder"
], $e01231a12b45a094$var$_excluded3 = [
    "as",
    "style"
];
function $e01231a12b45a094$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $e01231a12b45a094$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $e01231a12b45a094$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $e01231a12b45a094$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $e01231a12b45a094$export$d24ef46eae7cb522 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $e01231a12b45a094$var$_excluded);
    const { $bottomBorder: $bottomBorder } = __cmplp, __cmpldp = (0, $bwPfh.default)(__cmplp, $e01231a12b45a094$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $e01231a12b45a094$var$_objectSpread($e01231a12b45a094$var$_objectSpread({}, __cmpldp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_18s813iz",
            __cmplp.$bottomBorder ? "_n3tdpxbi" : "_n3tdidpf",
            __cmplp.$bottomBorder ? "_n7zl7v06" : "_n7zlglyw",
            __cmplp.className
        ])
    }));
});
const $e01231a12b45a094$export$6e2c8f0811a474ce = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "section", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $e01231a12b45a094$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $e01231a12b45a094$var$_objectSpread($e01231a12b45a094$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    }));
});

});



parcelRegister("c9UN4", function(module, exports) {

$parcel$export(module.exports, "CloudMigrationResource", () => $8da260afc4a062e6$export$3d2dabf527c2d8d9);

var $ixQHh = parcelRequire("ixQHh");
var $cCrLo = parcelRequire("cCrLo");

var $9fEFB = parcelRequire("9fEFB");
parcelRequire("eUqFw");

var $eSWMG = parcelRequire("eSWMG");

var $lHkHI = parcelRequire("lHkHI");
const $8da260afc4a062e6$export$3d2dabf527c2d8d9 = (props)=>{
    const { cloudMigrationInfo: cloudMigrationInfo, onCloudMigrationResourceLinksClick: onCloudMigrationResourceLinksClick } = props;
    if (!cloudMigrationInfo || cloudMigrationInfo !== null && cloudMigrationInfo !== void 0 && cloudMigrationInfo.pending) return null;
    const { alternateCloudAppKey: alternateCloudAppKey, migrationDocumentation: migrationDocumentation, featureDifferenceDocumentation: featureDifferenceDocumentation } = cloudMigrationInfo;
    if (!migrationDocumentation && !featureDifferenceDocumentation) return null;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eSWMG.ResourceListItem), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.H6), {
                as: "h4",
                children: "Cloud migration"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eSWMG.ResourceSubTitle), {
                children: [
                    migrationDocumentation && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                        children: [
                            "Get to know the steps provided by the partner on",
                            ' ',
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ixQHh.ExternalLink), {
                                href: migrationDocumentation,
                                size: "medium",
                                onClick: ()=>{
                                    onCloudMigrationResourceLinksClick('how to migrate to cloud');
                                },
                                children: "how to migrate to cloud"
                            }),
                            ".",
                            ' '
                        ]
                    }),
                    featureDifferenceDocumentation && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                        children: [
                            "You can also check the",
                            ' ',
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ixQHh.ExternalLink), {
                                href: featureDifferenceDocumentation,
                                size: "medium",
                                onClick: ()=>{
                                    onCloudMigrationResourceLinksClick('feature parity');
                                },
                                children: "feature parity"
                            }),
                            ' ',
                            "for quick evaluation."
                        ]
                    })
                ]
            }),
            alternateCloudAppKey && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eSWMG.ResourceSubTitle), {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ixQHh.Link), {
                    target: "_blank",
                    "aria-label": "View the cloud variant of this app open in new window",
                    href: (0, $9fEFB.appDetailsLink)().expand({
                        appKey: alternateCloudAppKey
                    }),
                    size: "medium",
                    onClick: ()=>{
                        onCloudMigrationResourceLinksClick('View the cloud variant of this app');
                    },
                    children: "View the cloud variant of this app"
                })
            })
        ]
    });
};

});
parcelRegister("eSWMG", function(module, exports) {

$parcel$export(module.exports, "ResourceList", () => $ad63b521d61a42d8$export$4ba5ea103d06cb16);
$parcel$export(module.exports, "ResourceListItem", () => $ad63b521d61a42d8$export$267fd202b6e22077);
$parcel$export(module.exports, "ResourceSubTitle", () => $ad63b521d61a42d8$export$e5ebbb9efd3f9ce3);
/* styles.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $cCrLo = parcelRequire("cCrLo");

var $lHkHI = parcelRequire("lHkHI");
const $ad63b521d61a42d8$var$_excluded = [
    "as",
    "style"
], $ad63b521d61a42d8$var$_excluded2 = [
    "as",
    "style"
], $ad63b521d61a42d8$var$_excluded3 = [
    "as",
    "style"
];
function $ad63b521d61a42d8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ad63b521d61a42d8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ad63b521d61a42d8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ad63b521d61a42d8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $ad63b521d61a42d8$export$4ba5ea103d06cb16 = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "ul", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $ad63b521d61a42d8$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $ad63b521d61a42d8$var$_objectSpread($ad63b521d61a42d8$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulpxy5q _qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    }));
});
const $ad63b521d61a42d8$export$267fd202b6e22077 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "li", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $ad63b521d61a42d8$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $ad63b521d61a42d8$var$_objectSpread($ad63b521d61a42d8$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _zulp1eps",
            __cmplp.className
        ])
    }));
});
const $ad63b521d61a42d8$export$e5ebbb9efd3f9ce3 = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $ad63b521d61a42d8$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $ad63b521d61a42d8$var$_objectSpread($ad63b521d61a42d8$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf",
            __cmplp.className
        ])
    }));
});

});


parcelRegister("lch1p", function(module, exports) {

$parcel$export(module.exports, "DocumentationResource", () => $f6e7ec25d2516ecf$export$8cb32305ba0505db);
$parcel$export(module.exports, "ForumsResource", () => $f6e7ec25d2516ecf$export$bedbba3c1a3644a5);
$parcel$export(module.exports, "AtlassianCommunityResource", () => $f6e7ec25d2516ecf$export$a249f3b6eff2db26);
$parcel$export(module.exports, "StatusPageResource", () => $f6e7ec25d2516ecf$export$ded5df5d13415ae3);
$parcel$export(module.exports, "IssueTrackerResource", () => $f6e7ec25d2516ecf$export$14eb4232c5758d3d);

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $ixQHh = parcelRequire("ixQHh");
var $cCrLo = parcelRequire("cCrLo");
parcelRequire("eUqFw");

var $fGPEd = parcelRequire("fGPEd");

var $eSWMG = parcelRequire("eSWMG");

var $lHkHI = parcelRequire("lHkHI");
const $f6e7ec25d2516ecf$export$8cb32305ba0505db = (props)=>{
    const { documentationUrl: documentationUrl, onSupportLinkClick: onSupportLinkClick } = props;
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: documentationUrl && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eSWMG.ResourceListItem), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.H6), {
                    as: "h4",
                    children: "App documentation"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eSWMG.ResourceSubTitle), {
                    children: [
                        "Comprehensive set of documentation from the partner on",
                        ' ',
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ixQHh.ExternalLink), {
                            href: documentationUrl,
                            size: "medium",
                            onClick: ()=>{
                                fireAnalyticsEvent({
                                    eventType: (0, $gaiog.LinkClickedEvent),
                                    actionSubjectId: (0, $gaiog.ANALYTICS_SUBJECT_ID_APP_DOCUMENTATION_LINK),
                                    eventContainer: (0, $gaiog.EVENT_CONTAINER_SUPPORT_APPLISTING_TAB),
                                    attributes: {
                                        linkText: 'how this app works'
                                    }
                                });
                                onSupportLinkClick((0, $fGPEd.SupportResourcesLink).DOCUMENTATION);
                            },
                            children: "how this app works"
                        }),
                        "."
                    ]
                })
            ]
        })
    });
};
const $f6e7ec25d2516ecf$export$bedbba3c1a3644a5 = (props)=>{
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const { forumsUrl: forumsUrl, onSupportLinkClick: onSupportLinkClick } = props;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: forumsUrl && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eSWMG.ResourceListItem), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.H6), {
                    as: "h4",
                    children: "Forum"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eSWMG.ResourceSubTitle), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ixQHh.ExternalLink), {
                            href: forumsUrl,
                            size: "medium",
                            onClick: ()=>{
                                fireAnalyticsEvent({
                                    eventType: (0, $gaiog.LinkClickedEvent),
                                    actionSubjectId: (0, $gaiog.ANALYTICS_SUBJECT_ID_APP_FORUMS_LINK),
                                    eventContainer: (0, $gaiog.EVENT_CONTAINER_SUPPORT_APPLISTING_TAB),
                                    attributes: {
                                        linkText: 'Explore external community discussions'
                                    }
                                });
                                onSupportLinkClick((0, $fGPEd.SupportResourcesLink).COMMUNITY);
                            },
                            children: "Explore external community discussions"
                        }),
                        ' ',
                        "that connect you to the Marketplace partner and other customers who use this app."
                    ]
                })
            ]
        })
    });
};
const $f6e7ec25d2516ecf$export$a249f3b6eff2db26 = (props)=>{
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const { atlassianCommunityUrl: atlassianCommunityUrl, onSupportLinkClick: onSupportLinkClick } = props;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eSWMG.ResourceListItem), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.H6), {
                as: "h4",
                children: "Atlassian Community"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eSWMG.ResourceSubTitle), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ixQHh.ExternalLink), {
                        href: atlassianCommunityUrl,
                        size: "medium",
                        onClick: ()=>{
                            fireAnalyticsEvent({
                                eventType: (0, $gaiog.LinkClickedEvent),
                                actionSubjectId: (0, $gaiog.ANALYTICS_SUBJECT_ID_COMMUNITY_QUESTION_LINK),
                                eventContainer: (0, $gaiog.EVENT_CONTAINER_SUPPORT_APPLISTING_TAB),
                                attributes: {
                                    linkText: 'Engage with Atlassian-hosted discussions'
                                }
                            });
                            onSupportLinkClick((0, $fGPEd.SupportResourcesLink).ATLASSIAN_COMMUNITY);
                        },
                        children: "Engage with Atlassian-hosted discussions"
                    }),
                    ' ',
                    "where other customers discuss about apps."
                ]
            })
        ]
    });
};
const $f6e7ec25d2516ecf$export$ded5df5d13415ae3 = (props)=>{
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const { statusPageUrl: statusPageUrl, onSupportLinkClick: onSupportLinkClick } = props;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: statusPageUrl && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eSWMG.ResourceListItem), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.H6), {
                    as: "h4",
                    children: "Status page"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eSWMG.ResourceSubTitle), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ixQHh.ExternalLink), {
                            href: statusPageUrl,
                            size: "medium",
                            onClick: ()=>{
                                fireAnalyticsEvent({
                                    eventType: (0, $gaiog.LinkClickedEvent),
                                    actionSubjectId: (0, $gaiog.ANALYTICS_SUBJECT_ID_APP_STATUS_PAGE_LINK),
                                    eventContainer: (0, $gaiog.EVENT_CONTAINER_SUPPORT_APPLISTING_TAB),
                                    attributes: {
                                        linkText: 'Visit the partner status page'
                                    }
                                });
                                onSupportLinkClick((0, $fGPEd.SupportResourcesLink).STATUS_PAGE);
                            },
                            children: "Visit the partner status page"
                        }),
                        ' ',
                        "to get updates on incidents or uptime."
                    ]
                })
            ]
        })
    });
};
const $f6e7ec25d2516ecf$export$14eb4232c5758d3d = (props)=>{
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const { issueTrackerUrl: issueTrackerUrl, onSupportLinkClick: onSupportLinkClick } = props;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: issueTrackerUrl && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eSWMG.ResourceListItem), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.H6), {
                    as: "h4",
                    children: "Issue tracker"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eSWMG.ResourceSubTitle), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ixQHh.ExternalLink), {
                            href: issueTrackerUrl,
                            size: "medium",
                            onClick: ()=>{
                                fireAnalyticsEvent({
                                    eventType: (0, $gaiog.LinkClickedEvent),
                                    actionSubjectId: (0, $gaiog.ANALYTICS_SUBJECT_ID_APP_ISSUE_TRACKER_LINK),
                                    eventContainer: (0, $gaiog.EVENT_CONTAINER_SUPPORT_APPLISTING_TAB),
                                    attributes: {
                                        linkText: 'Visit the issue tracker page'
                                    }
                                });
                                onSupportLinkClick((0, $fGPEd.SupportResourcesLink).ISSUE_TRACKER);
                            },
                            children: "Visit the issue tracker page"
                        }),
                        ' ',
                        "to view existing bug reports and feature requests for this app."
                    ]
                })
            ]
        })
    });
};

});


parcelRegister("iAvc4", function(module, exports) {

$parcel$export(module.exports, "SupportTagline", () => $d883c930c27d28d3$export$7c02f2fa33013367);

var $cCrLo = parcelRequire("cCrLo");
var $ixQHh = parcelRequire("ixQHh");
parcelRequire("eUqFw");

var $c1ZLO = parcelRequire("c1ZLO");

var $8rN7p = parcelRequire("8rN7p");

var $lHkHI = parcelRequire("lHkHI");
const $d883c930c27d28d3$var$UnofficialSupport = (_ref)=>{
    let { supportDetails: supportDetails, atlassianCommunityUrl: atlassianCommunityUrl, onCommunityLinkClick: onCommunityLinkClick } = _ref;
    if (supportDetails.hasResources) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.BodyNormal), {
        children: "Below are the basic resources shared by the partner through which you can seek assistance in case of any need."
    });
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $cCrLo.BodyNormal), {
        children: [
            "If you have any concern or query,",
            ' ',
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ixQHh.ExternalLink), {
                href: atlassianCommunityUrl,
                size: "medium",
                onClick: onCommunityLinkClick,
                children: "engage with Atlassian Community"
            }),
            ' ',
            "where other customers discuss about apps."
        ]
    });
};
const $d883c930c27d28d3$export$7c02f2fa33013367 = (props)=>{
    const { supportDetails: { isSupported: isSupported, partner: { name: partnerName }, contact: { issueTrackerUrl: issueTrackerUrl, supportTicketSystemUrl: supportTicketSystemUrl, emailId: emailId } }, atlassianCommunityUrl: atlassianCommunityUrl, onCommunityLinkClick: onCommunityLinkClick } = props;
    const hasOfficialSupport = partnerName && isSupported && (issueTrackerUrl || supportTicketSystemUrl || emailId);
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $8rN7p.TaglineContainer), {
        "data-testid": (0, $c1ZLO.TEST_ID).SUPPORT_TAB_SUPPORT_TAGLINE,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.H4), {
                as: "h2",
                children: hasOfficialSupport ? "".concat(partnerName, " provides support for this version of the app") : "".concat(partnerName || 'The partner', " does not provide support for this version of the app")
            }),
            !hasOfficialSupport && /*#__PURE__*/ (0, $lHkHI.jsx)($d883c930c27d28d3$var$UnofficialSupport, {
                supportDetails: props.supportDetails,
                atlassianCommunityUrl: atlassianCommunityUrl,
                onCommunityLinkClick: onCommunityLinkClick
            })
        ]
    });
};

});


parcelRegister("h8lfX", function(module, exports) {

$parcel$export(module.exports, "default", () => $c793ac1afa24a579$export$2e2bcd8739ae039);

var $7ZOJD = parcelRequire("7ZOJD");

var $ammkg = parcelRequire("ammkg");

var $l501X = parcelRequire("l501X");
var $jyCWD = parcelRequire("jyCWD");
var $hvzDU = parcelRequire("hvzDU");

var $76fzC = parcelRequire("76fzC");
var $kVbx1 = parcelRequire("kVbx1");
parcelRequire("eUqFw");

var $c1ZLO = parcelRequire("c1ZLO");

var $fhWaL = parcelRequire("fhWaL");

var $689wy = parcelRequire("689wy");

var $lntG6 = parcelRequire("lntG6");

var $lHkHI = parcelRequire("lHkHI");
const $c793ac1afa24a579$export$f90411c24f6aebf8 = ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $689wy.BulletSpan), {
        children: "\u2022"
    });
// eslint-disable-next-line complexity, max-lines-per-function
const $c793ac1afa24a579$var$VersionsTab = (props)=>{
    const hasReleaseNotesUrl = !!props.releaseNotesUrl;
    const hasMultipleVersions = props.hosting !== (0, $ammkg.AtlassianProductHostingType).Cloud && props.versionCount > 1; // Cloud has only one semantic version
    const hasAdditionalResources = hasReleaseNotesUrl || hasMultipleVersions;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fhWaL.SectionsWrapper), {
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fhWaL.TwoColumns), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fhWaL.TwoColumns).Left, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fhWaL.default), {
                        "data-testid": (0, $c1ZLO.TEST_ID).VERSION_SECTION,
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jyCWD.default), {
                                children: "Versions"
                            }),
                            props.hosting !== (0, $ammkg.AtlassianProductHostingType).Cloud && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
                                        children: [
                                            "Version ",
                                            props.version
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsx)($c793ac1afa24a579$export$f90411c24f6aebf8, {})
                                ]
                            }),
                            (0, $lntG6.getCompatibleVersionsSummary)({
                                hosting: props.hosting,
                                productCompatibilities: props.productCompatibilities
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                                children: [
                                    "Released: ",
                                    (0, $76fzC).longDate(props.releaseDate)
                                ]
                            }),
                            props.releaseSummary && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fhWaL.SectionSubHeading), {
                                        children: "Summary"
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                                        children: props.releaseSummary
                                    })
                                ]
                            }),
                            props.releaseNotes && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fhWaL.SectionSubHeading), {
                                        children: "Details"
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $689wy.ReleaseNotesUGC), {
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hvzDU.default), {
                                            dangerousHtml: props.releaseNotes
                                        })
                                    })
                                ]
                            }),
                            props.hosting === (0, $ammkg.AtlassianProductHostingType).Cloud && props.paymentModel && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fhWaL.SectionSubHeading), {
                                        children: "Payment model"
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                                        children: (0, $kVbx1).mapPaymentModelToDisplayValue(props.paymentModel)
                                    })
                                ]
                            }),
                            props.hosting === (0, $ammkg.AtlassianProductHostingType).Cloud && props.licenseType && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fhWaL.SectionSubHeading), {
                                        children: "License type"
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                                        children: props.licenseType
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fhWaL.TwoColumns).Right, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fhWaL.default), {
                        "data-testid": (0, $c1ZLO.TEST_ID).RESOURCE_SECTION,
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jyCWD.default), {
                                children: "Resources"
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $689wy.ResourcesList), {
                                children: [
                                    props.releaseNotesUrl && /*#__PURE__*/ (0, $lHkHI.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                                            href: props.releaseNotesUrl,
                                            children: "See full release notes"
                                        })
                                    }),
                                    hasMultipleVersions && props.hosting !== (0, $ammkg.AtlassianProductHostingType).Cloud && /*#__PURE__*/ (0, $lHkHI.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $lHkHI.jsxs)("a", {
                                            href: props.versionHistoryUrl,
                                            children: [
                                                "See all ",
                                                props.versionCount,
                                                " ",
                                                (0, $7ZOJD.HostingDisplayName)[props.hosting],
                                                " versions"
                                            ]
                                        })
                                    }),
                                    !hasAdditionalResources && /*#__PURE__*/ (0, $lHkHI.jsx)("li", {
                                        children: "There are no additional resources."
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
var $c793ac1afa24a579$export$2e2bcd8739ae039 = $c793ac1afa24a579$var$VersionsTab;

});
parcelRegister("689wy", function(module, exports) {

$parcel$export(module.exports, "BulletSpan", () => $476ae0b659fb6651$export$ac4cb6f300525c47);
$parcel$export(module.exports, "ResourcesList", () => $476ae0b659fb6651$export$1d46354a0d938ffe);
$parcel$export(module.exports, "ReleaseNotesUGC", () => $476ae0b659fb6651$export$5c679566da12624a);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");
function $476ae0b659fb6651$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $476ae0b659fb6651$export$ac4cb6f300525c47 = (0, $3UXZ8.default)("span", {
    target: "e91czd70",
    label: "BulletSpan"
})("color:", (0, $j0gMm.N200), ";margin:0 3px;");
const $476ae0b659fb6651$export$1d46354a0d938ffe = (0, $3UXZ8.default)("ul", {
    target: "e91czd71",
    label: "ResourcesList"
})({
    name: "17mrx6g",
    styles: "padding:0;margin:0;list-style:none;"
});
const $476ae0b659fb6651$export$5c679566da12624a = (0, $3UXZ8.default)("div", {
    target: "e91czd72",
    label: "ReleaseNotesUGC"
})({
    name: "1wravb7",
    styles: "margin-top:var(--ds-space-150, 12px);"
});

});

parcelRegister("lntG6", function(module, exports) {

$parcel$export(module.exports, "getCompatibleVersionsSummary", () => $f902c46cb20dedfe$export$e4f7d186c323ccb0);

var $kafab = parcelRequire("kafab");
var $7ZOJD = parcelRequire("7ZOJD");

var $dcnzE = parcelRequire("dcnzE");
const $f902c46cb20dedfe$export$e4f7d186c323ccb0 = (props)=>{
    const { hosting: hosting, productCompatibilities: productCompatibilities } = props;
    if (productCompatibilities.length < 1) return '';
    const getCompatibilitySummary = (compatibility)=>{
        const productName = compatibility.atlassianProduct ? "".concat(compatibility.atlassianProduct.name, " ").concat((0, $7ZOJD.HostingDisplayName)[hosting]) : '';
        switch(compatibility.__typename){
            case (0, $kafab.CompatibleProductTypeValues).CLOUD_PRODUCT:
                return productName;
            case (0, $kafab.CompatibleProductTypeValues).SERVER_PRODUCT:
            case (0, $kafab.CompatibleProductTypeValues).DATACENTER_PRODUCT:
                {
                    const { minimumVersion: minimumVersion, maximumVersion: maximumVersion } = compatibility;
                    return "".concat(productName, " ").concat((0, $dcnzE.formatVersionRange)({
                        minimumVersion: minimumVersion,
                        maximumVersion: maximumVersion
                    }));
                }
        }
    };
    return productCompatibilities.map(getCompatibilitySummary).join(', ');
};

});



parcelRegister("cXrEd", function(module, exports) {

$parcel$export(module.exports, "default", () => $96f070fdea353aed$export$2e2bcd8739ae039);

var $c9Mth = parcelRequire("c9Mth");
parcelRequire("eUqFw");

var $dcnzE = parcelRequire("dcnzE");

var $6w79k = parcelRequire("6w79k");

var $lHkHI = parcelRequire("lHkHI");
const $96f070fdea353aed$var$ProductCompatibilitySummary = (props)=>{
    const { cloudCompatibleProducts: cloudCompatibleProducts, serverCompatibleProducts: serverCompatibleProducts, dataCenterCompatibleProducts: dataCenterCompatibleProducts, totalVersionCount: totalVersionCount, versionHistoryUrl: versionHistoryUrl } = props;
    const allCompatibilities = [
        ...cloudCompatibleProducts,
        ...serverCompatibleProducts,
        ...dataCenterCompatibleProducts
    ];
    const compatibleWithMultipleProducts = new Set(allCompatibilities.map((product)=>product.id)).size > 1;
    if (compatibleWithMultipleProducts) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6w79k.default), {
        compatibleProducts: allCompatibilities,
        totalVersionCount: totalVersionCount,
        versionHistoryUrl: versionHistoryUrl
    });
    const summary = (0, $dcnzE.getProductCompatibilitySummary)(allCompatibilities);
    const showMoreVersionsLink = totalVersionCount > 1;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            "for ",
            summary,
            showMoreVersionsLink && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    ' ',
                    /*#__PURE__*/ (0, $lHkHI.jsx)("a", {
                        href: (0, $c9Mth).removeQueryParamsFromUrl(versionHistoryUrl),
                        title: "View version history for more details",
                        children: "and more"
                    })
                ]
            })
        ]
    });
};
var $96f070fdea353aed$export$2e2bcd8739ae039 = $96f070fdea353aed$var$ProductCompatibilitySummary;

});
parcelRegister("6w79k", function(module, exports) {

$parcel$export(module.exports, "default", () => $4beb46f30e7b9118$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $4lmb9 = parcelRequire("4lmb9");
parcelRequire("eUqFw");

var $dcnzE = parcelRequire("dcnzE");

var $lHkHI = parcelRequire("lHkHI");
function $4beb46f30e7b9118$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4beb46f30e7b9118$export$9785331f8ce2e97a = (0, $3UXZ8.default)("ul", {
    target: "elrr1mw0",
    label: "CompatiblilityList"
})({
    name: "1rvtlej",
    styles: "list-style:none;padding:0;margin:0;"
});
const $4beb46f30e7b9118$var$MultipleProductCompatibilitySummary = (_ref)=>{
    let { compatibleProducts: compatibleProducts, totalVersionCount: totalVersionCount, versionHistoryUrl: versionHistoryUrl } = _ref;
    const tooltipContent = /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($4beb46f30e7b9118$export$9785331f8ce2e97a, {
                children: (0, $dcnzE.getProductCompatibilityList)(compatibleProducts).map((item)=>/*#__PURE__*/ (0, $lHkHI.jsx)("li", {
                        children: item
                    }, item))
            }),
            totalVersionCount > 1 && /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)("a", {
                    href: versionHistoryUrl,
                    children: "See more versions"
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            "for",
            ' ',
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4lmb9.default), {
                content: tooltipContent,
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                    appearance: "subtle-link",
                    spacing: "none",
                    children: "multiple products"
                })
            })
        ]
    });
};
var $4beb46f30e7b9118$export$2e2bcd8739ae039 = $4beb46f30e7b9118$var$MultipleProductCompatibilitySummary;

});


parcelRegister("jd8Av", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfc5e49102491b4f$export$2e2bcd8739ae039);
/* ProductCompatibilitySummaryV2.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $4lmb9 = parcelRequire("4lmb9");

var $dcnzE = parcelRequire("dcnzE");

var $lHkHI = parcelRequire("lHkHI");
const $dfc5e49102491b4f$var$_excluded = [
    "as",
    "style"
], $dfc5e49102491b4f$var$_excluded2 = [
    "as",
    "style"
], $dfc5e49102491b4f$var$_excluded3 = [
    "as",
    "style"
];
function $dfc5e49102491b4f$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $dfc5e49102491b4f$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $dfc5e49102491b4f$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $dfc5e49102491b4f$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $dfc5e49102491b4f$export$9785331f8ce2e97a = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "ul", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $dfc5e49102491b4f$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $dfc5e49102491b4f$var$_objectSpread($dfc5e49102491b4f$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _18s81dzv",
            __cmplp.className
        ])
    }));
});
const $dfc5e49102491b4f$export$bfa9f9e982a7d192 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $dfc5e49102491b4f$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $dfc5e49102491b4f$var$_objectSpread($dfc5e49102491b4f$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1k3w",
            __cmplp.className
        ])
    }));
});
const $dfc5e49102491b4f$export$4e9700cb5393317c = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "span", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $dfc5e49102491b4f$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $dfc5e49102491b4f$var$_objectSpread($dfc5e49102491b4f$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1k3w",
            __cmplp.className
        ])
    }));
});
const $dfc5e49102491b4f$export$de10d89a1be9079e = 3;
const $dfc5e49102491b4f$var$ProductCompatibilitySummaryV2 = (props)=>{
    const { cloudCompatibleProducts: cloudCompatibleProducts, serverCompatibleProducts: serverCompatibleProducts, dataCenterCompatibleProducts: dataCenterCompatibleProducts } = props;
    const allCompatibilities = [
        ...cloudCompatibleProducts,
        ...serverCompatibleProducts,
        ...dataCenterCompatibleProducts
    ];
    const compatibilityList = (0, $dcnzE.getProductCompatibilityList)(allCompatibilities);
    const compatibilityText = compatibilityList.slice(0, $dfc5e49102491b4f$export$de10d89a1be9079e).join(', ').trim();
    const tooltipContent = compatibilityList.length > $dfc5e49102491b4f$export$de10d89a1be9079e ? /*#__PURE__*/ (0, $lHkHI.jsx)($dfc5e49102491b4f$export$9785331f8ce2e97a, {
        children: compatibilityList.slice($dfc5e49102491b4f$export$de10d89a1be9079e).map((item)=>/*#__PURE__*/ (0, $lHkHI.jsx)("li", {
                children: item
            }, item))
    }) : null;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($dfc5e49102491b4f$export$bfa9f9e982a7d192, {
                children: "works with"
            }),
            " ".concat(compatibilityText),
            !!tooltipContent && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    " ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4lmb9.default), {
                        content: tooltipContent,
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)($dfc5e49102491b4f$export$4e9700cb5393317c, {
                            children: "and more"
                        })
                    })
                ]
            })
        ]
    });
};
var $dfc5e49102491b4f$export$2e2bcd8739ae039 = $dfc5e49102491b4f$var$ProductCompatibilitySummaryV2;

});

parcelRegister("aTte8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7ee5b64eea7e3888$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $jwyfr = parcelRequire("jwyfr");

var $5Okns = parcelRequire("5Okns");
parcelRequire("eUqFw");

var $fYIBx = parcelRequire("fYIBx");

var $lHkHI = parcelRequire("lHkHI");
function $7ee5b64eea7e3888$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7ee5b64eea7e3888$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7ee5b64eea7e3888$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7ee5b64eea7e3888$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $7ee5b64eea7e3888$export$3c661642f371863 = 'Add-ons';
const $7ee5b64eea7e3888$var$AppStructuredData = (props)=>{
    const { name: name, icon: image, description: description, review: { rating: ratingValue, count: reviewCount }, partner: { name: partnerName, url: partnerUrl }, createdAt: createdAt, compatibleProducts: compatibleProducts } = props;
    const app = {
        '@context': 'https://schema.org/',
        '@type': 'SoftwareApplication',
        name: name,
        image: image,
        description: description,
        dateCreated: (0, $5Okns.default)(createdAt),
        applicationCategory: $7ee5b64eea7e3888$export$3c661642f371863,
        applicationSuite: compatibleProducts.map((product)=>product.name).join(', ')
    };
    if (reviewCount > 0) app.aggregateRating = {
        '@type': 'AggregateRating',
        bestRating: (0, $jwyfr.TOTAL_STARS),
        ratingValue: ratingValue,
        reviewCount: reviewCount
    };
    if (partnerName) app.creator = $7ee5b64eea7e3888$var$_objectSpread({
        '@type': 'Organization',
        name: partnerName
    }, partnerUrl && {
        url: partnerUrl
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fYIBx.JsonLd), {
        item: app
    });
};
var $7ee5b64eea7e3888$export$2e2bcd8739ae039 = $7ee5b64eea7e3888$var$AppStructuredData;

});
parcelRegister("fYIBx", function(module, exports) {
"use strict";
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.jsonLdScriptProps = module.exports.JsonLd = module.exports.helmetJsonLdProp = void 0;

var $iyuWv = parcelRequire("iyuWv");
Object.defineProperty(module.exports, "helmetJsonLdProp", {
    enumerable: true,
    get: function() {
        return $iyuWv.helmetJsonLdProp;
    }
});
Object.defineProperty(module.exports, "JsonLd", {
    enumerable: true,
    get: function() {
        return $iyuWv.JsonLd;
    }
});
Object.defineProperty(module.exports, "jsonLdScriptProps", {
    enumerable: true,
    get: function() {
        return $iyuWv.jsonLdScriptProps;
    }
});

});
parcelRegister("iyuWv", function(module, exports) {
"use strict";
/**
 * Copyright 2021 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */ var $d823678785b5161a$var$__assign = module.exports && module.exports.__assign || function() {
    $d823678785b5161a$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $d823678785b5161a$var$__assign.apply(this, arguments);
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.helmetJsonLdProp = module.exports.jsonLdScriptProps = module.exports.JsonLd = void 0;

var $eUqFw = parcelRequire("eUqFw");
function $d823678785b5161a$var$JsonLd(props) {
    return $eUqFw.createElement("script", $d823678785b5161a$var$__assign({}, $d823678785b5161a$var$jsonLdScriptProps(props.item, props)));
}
module.exports.JsonLd = $d823678785b5161a$var$JsonLd;
function $d823678785b5161a$var$jsonLdScriptProps(item, options) {
    if (options === void 0) options = {};
    return {
        type: "application/ld+json",
        dangerouslySetInnerHTML: {
            __html: JSON.stringify(item, $d823678785b5161a$var$safeJsonLdReplacer, options.space)
        }
    };
}
module.exports.jsonLdScriptProps = $d823678785b5161a$var$jsonLdScriptProps;
function $d823678785b5161a$var$helmetJsonLdProp(item, options) {
    if (options === void 0) options = {};
    return {
        type: "application/ld+json",
        innerHTML: JSON.stringify(item, $d823678785b5161a$var$safeJsonLdReplacer, options.space)
    };
}
module.exports.helmetJsonLdProp = $d823678785b5161a$var$helmetJsonLdProp;
var $d823678785b5161a$var$ESCAPE_ENTITIES = Object.freeze({
    "&": "&amp;",
    "<": "&lt;",
    ">": "&gt;",
    '"': "&quot;",
    "'": "&apos;"
});
var $d823678785b5161a$var$ESCAPE_REGEX = new RegExp("[" + Object.keys($d823678785b5161a$var$ESCAPE_ENTITIES).join("") + "]", "g");
var $d823678785b5161a$var$ESCAPE_REPLACER = function(t) {
    return $d823678785b5161a$var$ESCAPE_ENTITIES[t];
};
/**
 * A replacer for JSON.stringify to strip JSON-LD of illegal HTML entities
 * per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
 */ var $d823678785b5161a$var$safeJsonLdReplacer = function() {
    // Replace per https://www.w3.org/TR/json-ld11/#restrictions-for-contents-of-json-ld-script-elements
    // Solution from https://stackoverflow.com/a/5499821/864313
    return function(_, value) {
        switch(typeof value){
            case "object":
                // Omit null values.
                if (value === null) return undefined;
                return value; // JSON.stringify will recursively call replacer.
            case "number":
            case "boolean":
            case "bigint":
                return value; // These values are not risky.
            case "string":
                return value.replace($d823678785b5161a$var$ESCAPE_REGEX, $d823678785b5161a$var$ESCAPE_REPLACER);
            default:
                // We shouldn't expect other types.
                $d823678785b5161a$var$isNever(value);
                // JSON.stringify will remove this element.
                return undefined;
        }
    };
}();
// Utility: Assert never
function $d823678785b5161a$var$isNever(_) {}

});



parcelRegister("5V6US", function(module, exports) {

$parcel$export(module.exports, "default", () => $44f7a417c61d0d24$export$2e2bcd8739ae039);
/* AppListingV2.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");


var $cSibF = parcelRequire("cSibF");

var $c1ZLO = parcelRequire("c1ZLO");

var $gaE0h = parcelRequire("gaE0h");

var $lHkHI = parcelRequire("lHkHI");
const $44f7a417c61d0d24$var$_excluded = [
    "as",
    "style"
];
function $44f7a417c61d0d24$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $44f7a417c61d0d24$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $44f7a417c61d0d24$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $44f7a417c61d0d24$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $44f7a417c61d0d24$var$BrandFontWrapper = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $44f7a417c61d0d24$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $44f7a417c61d0d24$var$_objectSpread($44f7a417c61d0d24$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_ect41sdi",
            __cmplp.className
        ])
    }));
});
const $44f7a417c61d0d24$var$AppListingV2 = (props)=>{
    const { appHeaderDetails: appHeaderDetails, appRatingLink: appRatingLink, appIconLink: appIconLink, bottomSeparator: bottomSeparator, headerInjection: headerInjection, hostingSelect: hostingSelect, afterHeader: afterHeader, isAppCloudFortified: isAppCloudFortified, showStaffPickBadge: showStaffPickBadge, showInstallationCount: showInstallationCount, openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab, bugBountyParticipant: bugBountyParticipant, compatibilitySummary: compatibilitySummary, lozenges: lozenges, selectedTab: selectedTab, onTabChange: onTabChange, tabsData: tabsData } = props;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($44f7a417c61d0d24$var$BrandFontWrapper, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gaE0h.ListingHeader), {
                appHeaderDetails: appHeaderDetails,
                appRatingLink: appRatingLink,
                appIconLink: appIconLink,
                bottomSeparator: bottomSeparator,
                headerInjection: headerInjection,
                isAppCloudFortified: isAppCloudFortified,
                showStaffPickBadge: showStaffPickBadge,
                showInstallationCount: showInstallationCount,
                openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
                bugBountyParticipant: bugBountyParticipant,
                compatibilitySummary: compatibilitySummary,
                lozenges: lozenges,
                showAetherAppListingPage: true,
                hostingSelect: hostingSelect
            }),
            afterHeader,
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cSibF.default), {
                id: (0, $c1ZLO.ELEMENT_ID).APP_LISTING_TABS,
                selected: selectedTab,
                maxVisibleTabs: (0, $c1ZLO.MAX_VISIBLE_TABS_CONFIG),
                onChange: onTabChange,
                tabs: tabsData,
                showAetherAppListingPage: true
            })
        ]
    });
};
var $44f7a417c61d0d24$export$2e2bcd8739ae039 = $44f7a417c61d0d24$var$AppListingV2;

});
parcelRegister("gaE0h", function(module, exports) {

$parcel$export(module.exports, "ListingHeader", () => $bc5c9c661c0d5aa9$export$57091a87aee54da5);

var $aosfp = parcelRequire("aosfp");
var $gJloE = parcelRequire("gJloE");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $bc5c9c661c0d5aa9$export$57091a87aee54da5 = (_ref)=>{
    let { appHeaderDetails: appHeaderDetails, appRatingLink: appRatingLink, appIconLink: appIconLink, bottomSeparator: bottomSeparator, headerInjection: headerInjection, isAppCloudFortified: isAppCloudFortified, showStaffPickBadge: showStaffPickBadge, showInstallationCount: showInstallationCount, openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab, bugBountyParticipant: bugBountyParticipant, compatibilitySummary: compatibilitySummary, lozenges: lozenges, showAetherAppListingPage: showAetherAppListingPage, hostingSelect: hostingSelect } = _ref;
    if (showAetherAppListingPage) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gJloE.default), {
        appHeaderDetails: appHeaderDetails,
        appRatingLink: appRatingLink,
        appIconLink: appIconLink,
        bottomSeparator: bottomSeparator,
        headerInjection: headerInjection,
        isAppCloudFortified: isAppCloudFortified,
        showStaffPickBadge: showStaffPickBadge,
        showInstallationCount: showInstallationCount,
        openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
        bugBountyParticipant: bugBountyParticipant,
        compatibilitySummary: compatibilitySummary,
        lozenges: lozenges,
        hostingSelect: hostingSelect
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
        className: "listing-header",
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aosfp.default), {
            appHeaderDetails: appHeaderDetails,
            appRatingLink: appRatingLink,
            appIconLink: appIconLink,
            bottomSeparator: bottomSeparator,
            headerInjection: headerInjection,
            isAppCloudFortified: isAppCloudFortified,
            showStaffPickBadge: showStaffPickBadge,
            showInstallationCount: showInstallationCount,
            openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
            bugBountyParticipant: bugBountyParticipant,
            compatibilitySummary: compatibilitySummary,
            lozenges: lozenges
        })
    });
};

});
parcelRegister("gJloE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2e17239ab6dcb63$export$2e2bcd8739ae039);

var $gwoWU = parcelRequire("gwoWU");

var $ammkg = parcelRequire("ammkg");

var $c0qPT = parcelRequire("c0qPT");
parcelRequire("eUqFw");

var $7BUhe = parcelRequire("7BUhe");

var $8xfj9 = parcelRequire("8xfj9");

var $iKF5E = parcelRequire("iKF5E");

var $lHuB6 = parcelRequire("lHuB6");

var $5jBev = parcelRequire("5jBev");

var $aFbzH = parcelRequire("aFbzH");

var $j7LzR = parcelRequire("j7LzR");

var $fm8vZ = parcelRequire("fm8vZ");

var $fmcsZ = parcelRequire("fmcsZ");

var $eoMJc = parcelRequire("eoMJc");

var $lHkHI = parcelRequire("lHkHI");
// eslint-disable-next-line max-lines-per-function, complexity
function $c2e17239ab6dcb63$var$AppHeaderV2(_ref) {
    var _appHeaderDetails$com;
    let { appHeaderDetails: appHeaderDetails, appIconLink: appIconLink, appIconSize: appIconSize = 'large', appRatingLink: appRatingLink, compatibilitySummary: compatibilitySummary = null, headerInjection: headerInjection, isAppCloudFortified: isAppCloudFortified = false, lozenges: lozenges = [], openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab = true, showInstallationCount: showInstallationCount = false, bugBountyParticipant: bugBountyParticipant = null, showStaffPickBadge: showStaffPickBadge = false, hostingSelect: hostingSelect } = _ref;
    const showNewAppMessage = $lHuB6.showNewAppMessage(appHeaderDetails);
    const showSecurityBadge = isAppCloudFortified || (0, $gwoWU.isBugBountyParticipant)((0, $ammkg.AtlassianProductHostingType).Cloud, bugBountyParticipant);
    const source = (0, $c0qPT.useSource)();
    const isMPAC = source === 'MPAC';
    const { tooltipMessage: installTooltipMessage, installCountMessage: installCountMessage, showDownloadIcon: showDownloadIcon, isLoading: isInstallMessageLoading, title: installCountTitle } = (0, $iKF5E.useInstallMessage)({
        distribution: appHeaderDetails.distribution,
        showNewAppMessage: showNewAppMessage,
        compatibleProducts: (_appHeaderDetails$com = appHeaderDetails.compatibleProducts) !== null && _appHeaderDetails$com !== void 0 ? _appHeaderDetails$com : [],
        showAetherAppListingPage: true
    });
    const HeaderContainer = isMPAC ? (0, $5jBev.HeaderContainerMPAC) : (0, $5jBev.HeaderContainerEMCEE);
    return /*#__PURE__*/ (0, $lHkHI.jsxs)(HeaderContainer, {
        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                style: {
                    width: '100%'
                },
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $5jBev.HeaderTopRowContainer), {
                        source: source,
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $5jBev.AppDetailsContainer), {
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5jBev.IconContainer), {
                                        "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_ICON,
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aFbzH.default), {
                                            showAetherAppListingPage: true,
                                            size: appIconSize,
                                            origin: appHeaderDetails.origin,
                                            icon: appHeaderDetails.icon,
                                            appKey: appHeaderDetails.key,
                                            appIconLink: appIconLink
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $5jBev.AppName), {
                                                "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_APP_NAME,
                                                children: [
                                                    appHeaderDetails.name,
                                                    " ",
                                                    showStaffPickBadge && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eoMJc.default), {})
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8xfj9.default), {
                                                showAetherAppListingPage: true,
                                                name: appHeaderDetails.partner.name,
                                                link: appHeaderDetails.partner.link,
                                                partnerTierType: appHeaderDetails.partner.partnerTierType
                                            }),
                                            compatibilitySummary && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5jBev.CompatibilitiesContainer), {
                                                "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_COMPATIBILITIES,
                                                children: compatibilitySummary
                                            })
                                        ]
                                    })
                                ]
                            }),
                            !!headerInjection && /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                                "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_INJECTION,
                                children: headerInjection
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $5jBev.TrustSignalsContainer), {
                        children: [
                            !showNewAppMessage && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5jBev.TrustSignalsItem), {
                                width: "13.75rem",
                                "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_RATINGS,
                                children: /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5jBev.SocialProofHeading), {
                                            children: "OVERALL RATINGS"
                                        }),
                                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fmcsZ.default), {
                                            appKey: appHeaderDetails.key,
                                            appRatingLink: appRatingLink,
                                            openMarketplaceLinksInNewTab: openMarketplaceLinksInNewTab,
                                            ratings: appHeaderDetails.ratings,
                                            showAetherAppListingPage: true
                                        })
                                    ]
                                })
                            }),
                            showInstallationCount && !!installCountMessage && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5jBev.TrustSignalsItem), {
                                minWidth: "7.5rem",
                                width: "unset",
                                "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_INSTALL_COUNT,
                                children: /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                                    role: "img",
                                    "aria-label": installTooltipMessage || '',
                                    children: [
                                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5jBev.SocialProofHeading), {
                                            children: installCountTitle || 'INSTALLS'
                                        }),
                                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $iKF5E.InstallCount), {
                                            showAetherAppListingPage: true,
                                            tooltipMessage: installTooltipMessage,
                                            installCountMessage: installCountMessage,
                                            showDownloadIcon: showDownloadIcon,
                                            isLoading: isInstallMessageLoading
                                        })
                                    ]
                                })
                            }),
                            !!lozenges.length && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5jBev.TrustSignalsItem), {
                                width: showSecurityBadge ? '13.75rem' : '12.5rem',
                                children: /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5jBev.SocialProofHeading), {
                                            children: "SUPPORT"
                                        }),
                                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fm8vZ.default), {
                                            lozenges: lozenges
                                        })
                                    ]
                                })
                            }),
                            showSecurityBadge && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5jBev.TrustSignalsItem), {
                                "data-testid": (0, $7BUhe.TEST_IDS).APP_HEADER_CERTIFICATION,
                                children: /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5jBev.SocialProofHeading), {
                                            children: "TRUST SIGNALS"
                                        }),
                                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j7LzR.default), {
                                            isAppCloudFortified: isAppCloudFortified,
                                            bugBountyParticipant: bugBountyParticipant,
                                            showAetherAppListingPage: true
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            }),
            hostingSelect
        ]
    });
}
$c2e17239ab6dcb63$var$AppHeaderV2.getAppIcon = (0, $aFbzH.getAppIcon);
var $c2e17239ab6dcb63$export$2e2bcd8739ae039 = $c2e17239ab6dcb63$var$AppHeaderV2;

});
parcelRegister("5jBev", function(module, exports) {

$parcel$export(module.exports, "AppName", () => $3deb9bcdfdd8b347$export$e3fa2c64115299cc);
$parcel$export(module.exports, "SocialProofHeading", () => $3deb9bcdfdd8b347$export$15bcf1470df66129);
$parcel$export(module.exports, "HeaderContainerMPAC", () => $3deb9bcdfdd8b347$export$c860b2851110d5a5);
$parcel$export(module.exports, "HeaderContainerEMCEE", () => $3deb9bcdfdd8b347$export$669bcbf436706327);
$parcel$export(module.exports, "IconContainer", () => $3deb9bcdfdd8b347$export$8f314e512d92575f);
$parcel$export(module.exports, "AppDetailsContainer", () => $3deb9bcdfdd8b347$export$66089487c21dd717);
$parcel$export(module.exports, "CompatibilitiesContainer", () => $3deb9bcdfdd8b347$export$a3e5b8c63bd057f3);
$parcel$export(module.exports, "TrustSignalsContainer", () => $3deb9bcdfdd8b347$export$4ce2a3945be9a02f);
$parcel$export(module.exports, "TrustSignalsItem", () => $3deb9bcdfdd8b347$export$bfe2a530fd35af80);
$parcel$export(module.exports, "HeaderTopRowContainer", () => $3deb9bcdfdd8b347$export$b411f40cee124e62);
/* AppHeaderV2.styles.ts generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");
var $9t7rW = parcelRequire("9t7rW");


var $cCrLo = parcelRequire("cCrLo");

var $lHkHI = parcelRequire("lHkHI");
const $3deb9bcdfdd8b347$var$_excluded = [
    "as",
    "style"
], $3deb9bcdfdd8b347$var$_excluded2 = [
    "as",
    "style"
], $3deb9bcdfdd8b347$var$_excluded3 = [
    "as",
    "style"
], $3deb9bcdfdd8b347$var$_excluded4 = [
    "as",
    "style"
], $3deb9bcdfdd8b347$var$_excluded5 = [
    "as",
    "style"
], $3deb9bcdfdd8b347$var$_excluded6 = [
    "as",
    "style"
], $3deb9bcdfdd8b347$var$_excluded7 = [
    "as",
    "style"
], $3deb9bcdfdd8b347$var$_excluded8 = [
    "as",
    "style"
], $3deb9bcdfdd8b347$var$_excluded9 = [
    "as",
    "style"
], $3deb9bcdfdd8b347$var$_excluded10 = [
    "minWidth"
], $3deb9bcdfdd8b347$var$_excluded11 = [
    "as",
    "style"
], $3deb9bcdfdd8b347$var$_excluded12 = [
    "source"
];
function $3deb9bcdfdd8b347$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $3deb9bcdfdd8b347$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $3deb9bcdfdd8b347$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $3deb9bcdfdd8b347$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $3deb9bcdfdd8b347$export$e3fa2c64115299cc = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = (0, $cCrLo.H3), style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $3deb9bcdfdd8b347$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $3deb9bcdfdd8b347$var$_objectSpread($3deb9bcdfdd8b347$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _otyr1b66",
            __cmplp.className
        ])
    }));
});
const $3deb9bcdfdd8b347$export$15bcf1470df66129 = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = (0, $cCrLo.EyebrowSmall), style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $3deb9bcdfdd8b347$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $3deb9bcdfdd8b347$var$_objectSpread($3deb9bcdfdd8b347$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_syaz1k3w _otyr1eps",
            __cmplp.className
        ])
    }));
});
const $3deb9bcdfdd8b347$export$c860b2851110d5a5 = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $3deb9bcdfdd8b347$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $3deb9bcdfdd8b347$var$_objectSpread($3deb9bcdfdd8b347$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    }));
});
const $3deb9bcdfdd8b347$export$669bcbf436706327 = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $3deb9bcdfdd8b347$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $3deb9bcdfdd8b347$var$_objectSpread($3deb9bcdfdd8b347$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _otyrgosd",
            __cmplp.className
        ])
    }));
});
const $3deb9bcdfdd8b347$export$8f314e512d92575f = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $3deb9bcdfdd8b347$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $3deb9bcdfdd8b347$var$_objectSpread($3deb9bcdfdd8b347$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxpxbi",
            __cmplp.className
        ])
    }));
});
const $3deb9bcdfdd8b347$export$66089487c21dd717 = (0, $eUqFw.forwardRef)((_ref6, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref6, __cmplp = (0, $bwPfh.default)(_ref6, $3deb9bcdfdd8b347$var$_excluded6);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $3deb9bcdfdd8b347$var$_objectSpread($3deb9bcdfdd8b347$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    }));
});
const $3deb9bcdfdd8b347$export$a3e5b8c63bd057f3 = (0, $eUqFw.forwardRef)((_ref7, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref7, __cmplp = (0, $bwPfh.default)(_ref7, $3deb9bcdfdd8b347$var$_excluded7);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $3deb9bcdfdd8b347$var$_objectSpread($3deb9bcdfdd8b347$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1fcb _vwz41k8s",
            __cmplp.className
        ])
    }));
});
const $3deb9bcdfdd8b347$export$4ce2a3945be9a02f = (0, $eUqFw.forwardRef)((_ref8, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref8, __cmplp = (0, $bwPfh.default)(_ref8, $3deb9bcdfdd8b347$var$_excluded8);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $3deb9bcdfdd8b347$var$_objectSpread($3deb9bcdfdd8b347$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pk1ejb _2rkoftgi _19it7v06 _1yt41xvq _1bsb1ns9 _1e0c1txw _zulphiv4 _1n261g80",
            __cmplp.className
        ])
    }));
});
const $3deb9bcdfdd8b347$export$bfe2a530fd35af80 = (0, $eUqFw.forwardRef)((_ref9, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref9, __cmplp = (0, $bwPfh.default)(_ref9, $3deb9bcdfdd8b347$var$_excluded9);
    const { minWidth: minWidth } = __cmplp, __cmpldp = (0, $bwPfh.default)(__cmplp, $3deb9bcdfdd8b347$var$_excluded10);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $3deb9bcdfdd8b347$var$_objectSpread($3deb9bcdfdd8b347$var$_objectSpread({}, __cmpldp), {}, {
        style: $3deb9bcdfdd8b347$var$_objectSpread($3deb9bcdfdd8b347$var$_objectSpread({}, __cmpls), {}, {
            "--_ba63p": (0, $9t7rW.default)(__cmplp.width || 'unset'),
            "--_zv6kmu": (0, $9t7rW.default)(__cmplp.minWidth || 'unset')
        }),
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bsb1j0z _1ul9s5dg",
            __cmplp.className
        ])
    }));
});
const $3deb9bcdfdd8b347$export$b411f40cee124e62 = (0, $eUqFw.forwardRef)((_ref10, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref10, __cmplp = (0, $bwPfh.default)(_ref10, $3deb9bcdfdd8b347$var$_excluded11);
    const { source: source } = __cmplp, __cmpldp = (0, $bwPfh.default)(__cmplp, $3deb9bcdfdd8b347$var$_excluded12);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $3deb9bcdfdd8b347$var$_objectSpread($3deb9bcdfdd8b347$var$_objectSpread({}, __cmpldp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _1bah1yb4 _2lx21bp4 _1p57hiv4 _1inivrvc",
            __cmplp.source === 'MPAC' ? "_1n261q9c" : "_1n261g80",
            __cmplp.className
        ])
    }));
});

});





parcelRegister("eQxeh", function(module, exports) {

$parcel$export(module.exports, "useAppListingByKey", () => $acefb2acf5899e02$export$3eb776272b17ef0);

var $bjdFb = parcelRequire("bjdFb");

var $ammkg = parcelRequire("ammkg");

var $hh2jg = parcelRequire("hh2jg");
var $acefb2acf5899e02$var$GetMarketplaceAppListingByKey = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "GetMarketplaceAppListingByKey"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "location"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "MarketplaceLocation"
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "visibility"
                        }
                    },
                    type: {
                        kind: "NamedType",
                        name: {
                            kind: "Name",
                            value: "MarketplaceAppVersionVisibility"
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceAppByKey"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "appKey"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "appKey"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppListingApp"
                                    },
                                    directives: []
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "PublicPrivateAppVersions"
                                    },
                                    directives: []
                                },
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AllServerDCAppVersionsCount"
                                    },
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "productHostingOptions"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "excludeHiddenIn"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "location"
                                                }
                                            }
                                        }
                                    ],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    alias: {
                                        kind: "Name",
                                        value: "cloudAppVersions"
                                    },
                                    name: {
                                        kind: "Name",
                                        value: "versions"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "productHostingOptions"
                                                        },
                                                        value: {
                                                            kind: "ListValue",
                                                            values: [
                                                                {
                                                                    kind: "EnumValue",
                                                                    value: "CLOUD"
                                                                }
                                                            ]
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "excludeHiddenIn"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "location"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "visibility"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "visibility"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "IntValue",
                                                value: "1"
                                            }
                                        }
                                    ],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AppListingAppVersionConnection"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    alias: {
                                        kind: "Name",
                                        value: "serverAppVersions"
                                    },
                                    name: {
                                        kind: "Name",
                                        value: "versions"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "productHostingOptions"
                                                        },
                                                        value: {
                                                            kind: "ListValue",
                                                            values: [
                                                                {
                                                                    kind: "EnumValue",
                                                                    value: "SERVER"
                                                                }
                                                            ]
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "excludeHiddenIn"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "location"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "visibility"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "visibility"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "IntValue",
                                                value: "1"
                                            }
                                        }
                                    ],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AppListingAppVersionConnection"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    alias: {
                                        kind: "Name",
                                        value: "dataCenterAppVersions"
                                    },
                                    name: {
                                        kind: "Name",
                                        value: "versions"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "filter"
                                            },
                                            value: {
                                                kind: "ObjectValue",
                                                fields: [
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "productHostingOptions"
                                                        },
                                                        value: {
                                                            kind: "ListValue",
                                                            values: [
                                                                {
                                                                    kind: "EnumValue",
                                                                    value: "DATA_CENTER"
                                                                }
                                                            ]
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "excludeHiddenIn"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "location"
                                                            }
                                                        }
                                                    },
                                                    {
                                                        kind: "ObjectField",
                                                        name: {
                                                            kind: "Name",
                                                            value: "visibility"
                                                        },
                                                        value: {
                                                            kind: "Variable",
                                                            name: {
                                                                kind: "Name",
                                                                value: "visibility"
                                                            }
                                                        }
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "first"
                                            },
                                            value: {
                                                kind: "IntValue",
                                                value: "1"
                                            }
                                        }
                                    ],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AppListingAppVersionConnection"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingApp"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceApp"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appId"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "entityStatus"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "slug"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "tagline"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "privacyPolicyUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "listingStatus"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketingLabels"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "googleAnalyticsId"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "googleAnalytics4Id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "summary"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "jsdWidgetKey"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "categories"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppListingCategory"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "wikiUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "forumsUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isAtlassianCommunityEnabled"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "issueTrackerUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "supportTicketSystemUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "statusPageUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "watchersInfo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppListingWatcherStatus"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "logo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MarketplaceAppListingImage"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "partner"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MarketplaceAppListingPartner"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "reviewSummary"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppListingReviewSummary"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "distribution"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppListingDistribution"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "programs"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppListingProgram"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PublicPrivateAppVersions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceApp"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "PublicPrivateCloudVersions"
                        },
                        directives: []
                    },
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "PublicPrivateServerVersions"
                        },
                        directives: []
                    },
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "PublicPrivateDataCenterVersions"
                        },
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AllServerDCAppVersionsCount"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceApp"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "allServerDCAppVersions"
                        },
                        name: {
                            kind: "Name",
                            value: "versions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "visibility"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "PUBLIC"
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "productHostingOptions"
                                            },
                                            value: {
                                                kind: "ListValue",
                                                values: [
                                                    {
                                                        kind: "EnumValue",
                                                        value: "SERVER"
                                                    },
                                                    {
                                                        kind: "EnumValue",
                                                        value: "DATA_CENTER"
                                                    }
                                                ]
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "totalCount"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingAppVersionConnection"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppVersionConnection"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "totalCount"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AppListingAppVersion"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingCategory"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppCategory"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingWatcherStatus"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppWatchersInfo"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isUserWatchingApp"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "watchersCount"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MarketplaceAppListingImage"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceListingImage"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "original"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "width"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "height"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "imageUrl"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "highResolution"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "width"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "height"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "imageUrl"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "MarketplaceAppListingPartner"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplacePartner"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "slug"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "partnerType"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "programs"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "isCloudAppSecuritySelfAssessmentDone"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "partnerTier"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "type"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "updatedDate"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "support"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "contactDetails"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "websiteUrl"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AppListingPartnerSupportContact"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "availability"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AppListingPartnerSupportAvailability"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "logo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MarketplaceAppListingImage"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingReviewSummary"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppReviewSummary"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "rating"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "count"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingDistribution"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppDistribution"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "downloadCount"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "installationCount"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isPreinstalledInServerDC"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isPreinstalledInCloud"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingProgram"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppPrograms"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "cloudFortified"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "programStatus"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "bugBountyParticipant"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "cloud"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "server"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "dataCenter"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PublicPrivateCloudVersions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceApp"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "publicCloudVersion"
                        },
                        name: {
                            kind: "Name",
                            value: "versions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "IntValue",
                                    value: "1"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "productHostingOptions"
                                            },
                                            value: {
                                                kind: "ListValue",
                                                values: [
                                                    {
                                                        kind: "EnumValue",
                                                        value: "CLOUD"
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "visibility"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "PUBLIC"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "VersionBuildNumber"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "privateCloudVersion"
                        },
                        name: {
                            kind: "Name",
                            value: "versions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "IntValue",
                                    value: "1"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "productHostingOptions"
                                            },
                                            value: {
                                                kind: "ListValue",
                                                values: [
                                                    {
                                                        kind: "EnumValue",
                                                        value: "CLOUD"
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "visibility"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "PRIVATE"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "VersionBuildNumber"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PublicPrivateServerVersions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceApp"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "publicServerVersion"
                        },
                        name: {
                            kind: "Name",
                            value: "versions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "IntValue",
                                    value: "1"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "productHostingOptions"
                                            },
                                            value: {
                                                kind: "ListValue",
                                                values: [
                                                    {
                                                        kind: "EnumValue",
                                                        value: "SERVER"
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "visibility"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "PUBLIC"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "VersionBuildNumber"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "privateServerVersion"
                        },
                        name: {
                            kind: "Name",
                            value: "versions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "IntValue",
                                    value: "1"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "productHostingOptions"
                                            },
                                            value: {
                                                kind: "ListValue",
                                                values: [
                                                    {
                                                        kind: "EnumValue",
                                                        value: "SERVER"
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "visibility"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "PRIVATE"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "VersionBuildNumber"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "PublicPrivateDataCenterVersions"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceApp"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "publicDataCenterVersion"
                        },
                        name: {
                            kind: "Name",
                            value: "versions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "IntValue",
                                    value: "1"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "productHostingOptions"
                                            },
                                            value: {
                                                kind: "ListValue",
                                                values: [
                                                    {
                                                        kind: "EnumValue",
                                                        value: "DATA_CENTER"
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "visibility"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "PUBLIC"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "VersionBuildNumber"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        alias: {
                            kind: "Name",
                            value: "privateDataCenterVersion"
                        },
                        name: {
                            kind: "Name",
                            value: "versions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "IntValue",
                                    value: "1"
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "productHostingOptions"
                                            },
                                            value: {
                                                kind: "ListValue",
                                                values: [
                                                    {
                                                        kind: "EnumValue",
                                                        value: "DATA_CENTER"
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "visibility"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "PRIVATE"
                                            }
                                        }
                                    ]
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "VersionBuildNumber"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingAppVersion"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppVersion"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "AppListingAllAppVersion"
                        },
                        directives: []
                    },
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "AppListingHostingSelectorAppVersion"
                        },
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingPartnerSupportContact"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplacePartnerSupportContact"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "emailId"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "phoneNumber"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "websiteUrl"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingPartnerSupportAvailability"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplacePartnerSupportAvailability"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "daysOfWeek"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isAvailable24Hours"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "startTime"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "endTime"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "timezone"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "timezoneOffset"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "holidays"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppListingPartnerSupportHolidays"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "VersionBuildNumber"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppVersionConnection"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "edges"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "node"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "buildNumber"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingAllAppVersion"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppVersion"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "buildNumber"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "youtubeId"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "moreDetails"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "paymentModel"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "learnMoreUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "endUserLicenseAgreementUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "purchaseUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isSupported"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "documentationUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "releaseDate"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "releaseNotes"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "releaseSummary"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "releaseNotesUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "version"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "licenseType"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "heroImage"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MarketplaceAppListingImage"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "highlights"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppListingHighlight"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "screenshots"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppListingScreenshot"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deployment"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppListingAppDeployment"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingHostingSelectorAppVersion"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppVersion"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "buildNumber"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "paymentModel"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "purchaseUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "learnMoreUrl"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deployment"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppListingAppDeployment"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingPartnerSupportHolidays"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplacePartnerSupportHoliday"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "holidayFrequency"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "date"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingHighlight"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceListingHighlight"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "title"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "caption"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "summary"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "croppedScreenshot"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MarketplaceAppListingImage"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "screenshot"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "image"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "MarketplaceAppListingImage"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "caption"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingScreenshot"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceListingScreenshot"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "caption"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "image"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "MarketplaceAppListingImage"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingAppDeployment"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppDeployment"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "__typename"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "compatibleProducts"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppListingCompatibleProduct"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "InlineFragment",
                        typeCondition: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "MarketplaceInstructionalAppDeployment"
                            }
                        },
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "instructions"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "instruction"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "screenshot"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "MarketplaceAppListingImage"
                                                            },
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "isBinaryUrlAvailable"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "InlineFragment",
                        typeCondition: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "MarketplaceWorkflowAppDeployment"
                            }
                        },
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "isWorkflowDataFileAvailable"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "ConnectAppScopes"
                        },
                        directives: []
                    },
                    {
                        kind: "FragmentSpread",
                        name: {
                            kind: "Name",
                            value: "EcosystemCloudAppDetails"
                        },
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingCompatibleProduct"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CompatibleAtlassianProduct"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "__typename"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "atlassianProduct"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hostingOptions"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "InlineFragment",
                        typeCondition: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CompatibleAtlassianServerProduct"
                            }
                        },
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "minimumVersion"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "maximumVersion"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "InlineFragment",
                        typeCondition: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "CompatibleAtlassianDataCenterProduct"
                            }
                        },
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "minimumVersion"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "maximumVersion"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "ConnectAppScopes"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceConnectAppDeployment"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "scopes"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "capability"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "EcosystemCloudAppDetails"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceCloudAppDeployment"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "cloudAppId"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "scopes"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "capability"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 8914,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nquery GetMarketplaceAppListingById(\n  $appId: ID!\n  $location: MarketplaceLocation\n  $visibility: MarketplaceAppVersionVisibility\n) {\n  marketplaceApp(appId: $appId) {\n    ...AppListingApp\n    ...PublicPrivateAppVersions\n    ...AllServerDCAppVersionsCount\n\n    productHostingOptions(excludeHiddenIn: $location)\n\n    cloudAppVersions: versions(\n      filter: {\n        productHostingOptions: [CLOUD]\n        excludeHiddenIn: $location\n        visibility: $visibility\n      }\n      first: 1\n    ) {\n      ...AppListingAppVersionConnection\n    }\n\n    serverAppVersions: versions(\n      filter: {\n        productHostingOptions: [SERVER]\n        excludeHiddenIn: $location\n        visibility: $visibility\n      }\n      first: 1\n    ) {\n      ...AppListingAppVersionConnection\n    }\n\n    dataCenterAppVersions: versions(\n      filter: {\n        productHostingOptions: [DATA_CENTER]\n        excludeHiddenIn: $location\n        visibility: $visibility\n      }\n      first: 1\n    ) {\n      ...AppListingAppVersionConnection\n    }\n  }\n}\n\nquery GetMarketplaceAppListingByKey(\n  $appKey: String!\n  $location: MarketplaceLocation\n  $visibility: MarketplaceAppVersionVisibility\n) {\n  marketplaceAppByKey(appKey: $appKey) {\n    ...AppListingApp\n    ...PublicPrivateAppVersions\n    ...AllServerDCAppVersionsCount\n\n    productHostingOptions(excludeHiddenIn: $location)\n\n    cloudAppVersions: versions(\n      filter: {\n        productHostingOptions: [CLOUD]\n        excludeHiddenIn: $location\n        visibility: $visibility\n      }\n      first: 1\n    ) {\n      ...AppListingAppVersionConnection\n    }\n\n    serverAppVersions: versions(\n      filter: {\n        productHostingOptions: [SERVER]\n        excludeHiddenIn: $location\n        visibility: $visibility\n      }\n      first: 1\n    ) {\n      ...AppListingAppVersionConnection\n    }\n\n    dataCenterAppVersions: versions(\n      filter: {\n        productHostingOptions: [DATA_CENTER]\n        excludeHiddenIn: $location\n        visibility: $visibility\n      }\n      first: 1\n    ) {\n      ...AppListingAppVersionConnection\n    }\n  }\n}\n\nfragment AllServerDCAppVersionsCount on MarketplaceApp {\n  allServerDCAppVersions: versions(\n    filter: { visibility: PUBLIC, productHostingOptions: [SERVER, DATA_CENTER] }\n  ) {\n    totalCount\n  }\n}\n\nfragment PublicPrivateAppVersions on MarketplaceApp {\n  ...PublicPrivateCloudVersions\n  ...PublicPrivateServerVersions\n  ...PublicPrivateDataCenterVersions\n}\n\nfragment PublicPrivateCloudVersions on MarketplaceApp {\n  publicCloudVersion: versions(\n    first: 1\n    filter: { productHostingOptions: [CLOUD], visibility: PUBLIC }\n  ) {\n    ...VersionBuildNumber\n  }\n\n  privateCloudVersion: versions(\n    first: 1\n    filter: { productHostingOptions: [CLOUD], visibility: PRIVATE }\n  ) {\n    ...VersionBuildNumber\n  }\n}\n\nfragment PublicPrivateServerVersions on MarketplaceApp {\n  publicServerVersion: versions(\n    first: 1\n    filter: { productHostingOptions: [SERVER], visibility: PUBLIC }\n  ) {\n    ...VersionBuildNumber\n  }\n\n  privateServerVersion: versions(\n    first: 1\n    filter: { productHostingOptions: [SERVER], visibility: PRIVATE }\n  ) {\n    ...VersionBuildNumber\n  }\n}\n\nfragment PublicPrivateDataCenterVersions on MarketplaceApp {\n  publicDataCenterVersion: versions(\n    first: 1\n    filter: { productHostingOptions: [DATA_CENTER], visibility: PUBLIC }\n  ) {\n    ...VersionBuildNumber\n  }\n\n  privateDataCenterVersion: versions(\n    first: 1\n    filter: { productHostingOptions: [DATA_CENTER], visibility: PRIVATE }\n  ) {\n    ...VersionBuildNumber\n  }\n}\n\nfragment VersionBuildNumber on MarketplaceAppVersionConnection {\n  edges {\n    node {\n      buildNumber\n    }\n  }\n}\n\nfragment MarketplaceAppListingPartner on MarketplacePartner {\n  name\n  id\n  slug\n  partnerType\n  programs {\n    isCloudAppSecuritySelfAssessmentDone\n  }\n  partnerTier {\n    type\n    updatedDate\n  }\n  support {\n    contactDetails {\n      websiteUrl\n      ...AppListingPartnerSupportContact\n    }\n\n    availability {\n      ...AppListingPartnerSupportAvailability\n    }\n  }\n  logo {\n    ...MarketplaceAppListingImage\n  }\n}\n\nfragment AppListingPartnerSupportContact on MarketplacePartnerSupportContact {\n  emailId\n  phoneNumber\n  websiteUrl\n}\n\nfragment AppListingPartnerSupportHolidays on MarketplacePartnerSupportHoliday {\n  holidayFrequency\n  date\n}\n\nfragment AppListingPartnerSupportAvailability on MarketplacePartnerSupportAvailability {\n  daysOfWeek\n  isAvailable24Hours\n  startTime\n  endTime\n  timezone\n  timezoneOffset\n  holidays {\n    ...AppListingPartnerSupportHolidays\n  }\n}\n\nfragment AppListingReviewSummary on MarketplaceAppReviewSummary {\n  rating\n  count\n}\n\nfragment AppListingApp on MarketplaceApp {\n  name\n  appKey\n  appId\n  entityStatus\n  slug\n  tagline\n  privacyPolicyUrl\n  listingStatus\n  createdAt\n  marketingLabels\n  googleAnalyticsId\n  googleAnalytics4Id\n  summary\n  jsdWidgetKey\n  categories {\n    ...AppListingCategory\n  }\n\n  # start: support tab only fields\n  wikiUrl\n  forumsUrl\n  isAtlassianCommunityEnabled\n  issueTrackerUrl\n  supportTicketSystemUrl\n  statusPageUrl\n  # end: support tab only fields\n  watchersInfo {\n    ...AppListingWatcherStatus\n  }\n  logo {\n    ...MarketplaceAppListingImage\n  }\n  partner {\n    ...MarketplaceAppListingPartner\n  }\n  reviewSummary {\n    ...AppListingReviewSummary\n  }\n  distribution {\n    ...AppListingDistribution\n  }\n  programs {\n    ...AppListingProgram\n  }\n}\n\nfragment AppListingCategory on MarketplaceAppCategory {\n  name\n}\n\nfragment AppListingWatcherStatus on MarketplaceAppWatchersInfo {\n  isUserWatchingApp\n  watchersCount\n}\nfragment AppListingDistribution on MarketplaceAppDistribution {\n  downloadCount\n  installationCount\n  isPreinstalledInServerDC\n  isPreinstalledInCloud\n}\n\nfragment MarketplaceAppListingImage on MarketplaceListingImage {\n  original {\n    id\n    width\n    height\n    imageUrl\n  }\n  highResolution {\n    id\n    width\n    height\n    imageUrl\n  }\n}\n\nfragment AppListingProgram on MarketplaceAppPrograms {\n  cloudFortified {\n    status\n    programStatus\n  }\n  bugBountyParticipant {\n    cloud {\n      status\n    }\n    server {\n      status\n    }\n    dataCenter {\n      status\n    }\n  }\n}\n\nfragment AppListingAppVersion on MarketplaceAppVersion {\n  ...AppListingAllAppVersion\n  ...AppListingHostingSelectorAppVersion\n}\n\nfragment AppListingAppVersionConnection on MarketplaceAppVersionConnection {\n  totalCount\n  edges {\n    node {\n      ...AppListingAppVersion\n    }\n  }\n}\n\nfragment AppListingAllAppVersion on MarketplaceAppVersion {\n  buildNumber\n  youtubeId\n  moreDetails\n  paymentModel\n  learnMoreUrl\n  endUserLicenseAgreementUrl\n  purchaseUrl\n\n  # support tab data\n  isSupported\n  documentationUrl\n\n  # versions tab\n  releaseDate\n  releaseNotes\n  releaseSummary\n  releaseNotesUrl\n  version\n  licenseType {\n    name\n  }\n\n  heroImage {\n    ...MarketplaceAppListingImage\n  }\n\n  highlights {\n    ...AppListingHighlight\n  }\n\n  screenshots {\n    ...AppListingScreenshot\n  }\n\n  deployment {\n    ...AppListingAppDeployment\n  }\n}\n\nfragment EcosystemCloudAppDetails on MarketplaceCloudAppDeployment {\n  cloudAppId\n  scopes {\n    id\n    capability\n  }\n}\n\nfragment ConnectAppScopes on MarketplaceConnectAppDeployment {\n  scopes {\n    id\n    capability\n  }\n}\n\nfragment AppListingHighlight on MarketplaceListingHighlight {\n  title\n  caption\n  summary\n\n  croppedScreenshot {\n    ...MarketplaceAppListingImage\n  }\n\n  screenshot {\n    image {\n      ...MarketplaceAppListingImage\n    }\n    caption\n  }\n}\n\nfragment AppListingScreenshot on MarketplaceListingScreenshot {\n  caption\n  image {\n    ...MarketplaceAppListingImage\n  }\n}\n\nfragment AppListingCompatibleProduct on CompatibleAtlassianProduct {\n  # These should be fixed when we migrate this GraphQL query to BFF in\n  # eslint-disable-next-line @graphql-eslint/no-deprecated\n  id\n  # eslint-disable-next-line @graphql-eslint/no-deprecated\n  name\n  __typename\n\n  atlassianProduct {\n    name\n    hostingOptions\n  }\n\n  ... on CompatibleAtlassianServerProduct {\n    minimumVersion\n    maximumVersion\n  }\n\n  ... on CompatibleAtlassianDataCenterProduct {\n    minimumVersion\n    maximumVersion\n  }\n}\n\nfragment AppListingAppDeployment on MarketplaceAppDeployment {\n  __typename\n  compatibleProducts {\n    ...AppListingCompatibleProduct\n  }\n\n  ... on MarketplaceInstructionalAppDeployment {\n    instructions {\n      instruction\n      screenshot {\n        ...MarketplaceAppListingImage\n      }\n    }\n    isBinaryUrlAvailable\n  }\n\n  ... on MarketplaceWorkflowAppDeployment {\n    isWorkflowDataFileAvailable\n  }\n\n  ...ConnectAppScopes\n  ...EcosystemCloudAppDetails\n}\n\nfragment AppListingHostingSelectorAppVersion on MarketplaceAppVersion {\n  buildNumber\n  paymentModel\n  purchaseUrl\n  learnMoreUrl\n  deployment {\n    ...AppListingAppDeployment\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
function $acefb2acf5899e02$export$3eb776272b17ef0(options) {
    const { appKey: appKey, location: location, showOnlyPublic: showOnlyPublic } = options;
    const visibility = showOnlyPublic ? (0, $ammkg.MarketplaceAppVersionVisibility).Public : null;
    const { data: data, error: error, loading: loading, networkStatus: networkStatus } = (0, $bjdFb.useQuery)($acefb2acf5899e02$var$GetMarketplaceAppListingByKey, {
        variables: {
            appKey: appKey,
            location: location,
            visibility: visibility
        }
    });
    (0, $hh2jg.useAppListingTelemetryTracking)(data, error, networkStatus);
    return {
        data: data === null || data === void 0 ? void 0 : data.marketplaceAppByKey,
        error: error,
        loading: loading
    };
}

});
parcelRegister("bjdFb", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $83bc114b9e32fb9d$export$dd0a697e1782aedd);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("4cpTA");
var $4FQap = parcelRequire("4FQap");

var $a1fq9 = parcelRequire("a1fq9");

var $kc5Xp = parcelRequire("kc5Xp");

var $hr8gD = parcelRequire("hr8gD");

var $bSld1 = parcelRequire("bSld1");
var $cTbVl = parcelRequire("cTbVl");
var $kIFyK = parcelRequire("kIFyK");
var $18jmh = parcelRequire("18jmh");
var $5nAjP = parcelRequire("5nAjP");

var $ktrpW = parcelRequire("ktrpW");

var $3HKMg = parcelRequire("3HKMg");

var $cPsoH = parcelRequire("cPsoH");

var $9cZSb = parcelRequire("9cZSb");

var $3p7NC = parcelRequire("3p7NC");

var $fHgsu = parcelRequire("fHgsu");
var $83bc114b9e32fb9d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $83bc114b9e32fb9d$export$dd0a697e1782aedd(query, options) {
    if (options === void 0) options = Object.create(null);
    return (0, $fHgsu.wrapHook)("useQuery", $83bc114b9e32fb9d$var$_useQuery, (0, $3p7NC.useApolloClient)(options && options.client))(query, options);
}
function $83bc114b9e32fb9d$var$_useQuery(query, options) {
    return $83bc114b9e32fb9d$export$6342ea8c555e49e5((0, $3p7NC.useApolloClient)(options.client), query).useQuery(options);
}
function $83bc114b9e32fb9d$export$6342ea8c555e49e5(client, query) {
    var stateRef = $a1fq9.useRef();
    if (!stateRef.current || client !== stateRef.current.client || query !== stateRef.current.query) stateRef.current = new $83bc114b9e32fb9d$var$InternalState(client, query, stateRef.current);
    var state = stateRef.current;
    // By default, InternalState.prototype.forceUpdate is an empty function, but
    // we replace it here (before anyone has had a chance to see this state yet)
    // with a function that unconditionally forces an update, using the latest
    // setTick function. Updating this state by calling state.forceUpdate is the
    // only way we trigger React component updates (no other useState calls within
    // the InternalState class).
    state.forceUpdateState = $a1fq9.useReducer(function(tick) {
        return tick + 1;
    }, 0)[1];
    return state;
}
var $83bc114b9e32fb9d$var$InternalState = /** @class */ function() {
    function InternalState(client, query, previous) {
        var _this = this;
        this.client = client;
        this.query = query;
        /**
         * Will be overwritten by the `useSyncExternalStore` "force update" method
         * whenever it is available and reset to `forceUpdateState` when it isn't.
         */ this.forceUpdate = function() {
            return _this.forceUpdateState();
        };
        this.ssrDisabledResult = (0, $18jmh.maybeDeepFreeze)({
            loading: true,
            data: void 0,
            error: void 0,
            networkStatus: (0, $cPsoH.NetworkStatus).loading
        });
        this.skipStandbyResult = (0, $18jmh.maybeDeepFreeze)({
            loading: false,
            data: void 0,
            error: void 0,
            networkStatus: (0, $cPsoH.NetworkStatus).ready
        });
        // This cache allows the referential stability of this.result (as returned by
        // getCurrentResult) to translate into referential stability of the resulting
        // QueryResult object returned by toQueryResult.
        this.toQueryResultCache = new ((0, $bSld1.canUseWeakMap) ? WeakMap : Map)();
        (0, $9cZSb.verifyDocumentType)(query, (0, $9cZSb.DocumentType).Query);
        // Reuse previousData from previous InternalState (if any) to provide
        // continuity of previousData even if/when the query or client changes.
        var previousResult = previous && previous.result;
        var previousData = previousResult && previousResult.data;
        if (previousData) this.previousData = previousData;
    }
    /**
     * Forces an update using local component state.
     * As this is not batched with `useSyncExternalStore` updates,
     * this is only used as a fallback if the `useSyncExternalStore` "force update"
     * method is not registered at the moment.
     * See https://github.com/facebook/react/issues/25191
     *  */ InternalState.prototype.forceUpdateState = function() {
        // Replaced (in useInternalState) with a method that triggers an update.
        globalThis.__DEV__ !== false && (0, $4FQap.invariant).warn(51);
    };
    InternalState.prototype.executeQuery = function(options) {
        var _this = this;
        var _a;
        if (options.query) Object.assign(this, {
            query: options.query
        });
        this.watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        var concast = this.observable.reobserveAsConcast(this.getObsQueryOptions());
        // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
        // but save the current data as this.previousData, just like setResult
        // usually does.
        this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
        this.result = void 0;
        this.forceUpdate();
        return new Promise(function(resolve) {
            var result;
            // Subscribe to the concast independently of the ObservableQuery in case
            // the component gets unmounted before the promise resolves. This prevents
            // the concast from terminating early and resolving with `undefined` when
            // there are no more subscribers for the concast.
            concast.subscribe({
                next: function(value) {
                    result = value;
                },
                error: function() {
                    resolve(_this.toQueryResult(_this.observable.getCurrentResult()));
                },
                complete: function() {
                    resolve(_this.toQueryResult(result));
                }
            });
        });
    };
    // Methods beginning with use- should be called according to the standard
    // rules of React hooks: only at the top level of the calling function, and
    // without any dynamic conditional logic.
    InternalState.prototype.useQuery = function(options) {
        var _this = this;
        // The renderPromises field gets initialized here in the useQuery method, at
        // the beginning of everything (for a given component rendering, at least),
        // so we can safely use this.renderPromises in other/later InternalState
        // methods without worrying it might be uninitialized. Even after
        // initialization, this.renderPromises is usually undefined (unless SSR is
        // happening), but that's fine as long as it has been initialized that way,
        // rather than left uninitialized.
        this.renderPromises = $a1fq9.useContext((0, $ktrpW.getApolloContext)()).renderPromises;
        this.useOptions(options);
        var obsQuery = this.useObservableQuery();
        var result = (0, $kc5Xp.useSyncExternalStore)($a1fq9.useCallback(function(handleStoreChange) {
            if (_this.renderPromises) return function() {};
            _this.forceUpdate = handleStoreChange;
            var onNext = function() {
                var previousResult = _this.result;
                // We use `getCurrentResult()` instead of the onNext argument because
                // the values differ slightly. Specifically, loading results will have
                // an empty object for data instead of `undefined` for some reason.
                var result = obsQuery.getCurrentResult();
                // Make sure we're not attempting to re-render similar results
                if (previousResult && previousResult.loading === result.loading && previousResult.networkStatus === result.networkStatus && (0, $hr8gD.equal)(previousResult.data, result.data)) return;
                _this.setResult(result);
            };
            var onError = function(error) {
                subscription.unsubscribe();
                subscription = obsQuery.resubscribeAfterError(onNext, onError);
                if (!$83bc114b9e32fb9d$var$hasOwnProperty.call(error, "graphQLErrors")) // The error is not a GraphQL error
                throw error;
                var previousResult = _this.result;
                if (!previousResult || previousResult && previousResult.loading || !(0, $hr8gD.equal)(error, previousResult.error)) _this.setResult({
                    data: previousResult && previousResult.data,
                    error: error,
                    loading: false,
                    networkStatus: (0, $cPsoH.NetworkStatus).error
                });
            };
            var subscription = obsQuery.subscribe(onNext, onError);
            // Do the "unsubscribe" with a short delay.
            // This way, an existing subscription can be reused without an additional
            // request if "unsubscribe"  and "resubscribe" to the same ObservableQuery
            // happen in very fast succession.
            return function() {
                setTimeout(function() {
                    return subscription.unsubscribe();
                });
                _this.forceUpdate = function() {
                    return _this.forceUpdateState();
                };
            };
        }, [
            // We memoize the subscribe function using useCallback and the following
            // dependency keys, because the subscribe function reference is all that
            // useSyncExternalStore uses internally as a dependency key for the
            // useEffect ultimately responsible for the subscription, so we are
            // effectively passing this dependency array to that useEffect buried
            // inside useSyncExternalStore, as desired.
            obsQuery,
            this.renderPromises,
            this.client.disableNetworkFetches
        ]), function() {
            return _this.getCurrentResult();
        }, function() {
            return _this.getCurrentResult();
        });
        // TODO Remove this method when we remove support for options.partialRefetch.
        this.unsafeHandlePartialRefetch(result);
        return this.toQueryResult(result);
    };
    InternalState.prototype.useOptions = function(options) {
        var _a;
        var watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = options);
        // Update this.watchQueryOptions, but only when they have changed, which
        // allows us to depend on the referential stability of
        // this.watchQueryOptions elsewhere.
        var currentWatchQueryOptions = this.watchQueryOptions;
        if (!(0, $hr8gD.equal)(watchQueryOptions, currentWatchQueryOptions)) {
            this.watchQueryOptions = watchQueryOptions;
            if (currentWatchQueryOptions && this.observable) {
                // Though it might be tempting to postpone this reobserve call to the
                // useEffect block, we need getCurrentResult to return an appropriate
                // loading:true result synchronously (later within the same call to
                // useQuery). Since we already have this.observable here (not true for
                // the very first call to useQuery), we are not initiating any new
                // subscriptions, though it does feel less than ideal that reobserve
                // (potentially) kicks off a network request (for example, when the
                // variables have changed), which is technically a side-effect.
                this.observable.reobserve(this.getObsQueryOptions());
                // Make sure getCurrentResult returns a fresh ApolloQueryResult<TData>,
                // but save the current data as this.previousData, just like setResult
                // usually does.
                this.previousData = ((_a = this.result) === null || _a === void 0 ? void 0 : _a.data) || this.previousData;
                this.result = void 0;
            }
        }
        // Make sure state.onCompleted and state.onError always reflect the latest
        // options.onCompleted and options.onError callbacks provided to useQuery,
        // since those functions are often recreated every time useQuery is called.
        // Like the forceUpdate method, the versions of these methods inherited from
        // InternalState.prototype are empty no-ops, but we can override them on the
        // base state object (without modifying the prototype).
        this.onCompleted = options.onCompleted || InternalState.prototype.onCompleted;
        this.onError = options.onError || InternalState.prototype.onError;
        if ((this.renderPromises || this.client.disableNetworkFetches) && this.queryHookOptions.ssr === false && !this.queryHookOptions.skip) // If SSR has been explicitly disabled, and this function has been called
        // on the server side, return the default loading state.
        this.result = this.ssrDisabledResult;
        else if (this.queryHookOptions.skip || this.watchQueryOptions.fetchPolicy === "standby") // When skipping a query (ie. we're not querying for data but still want to
        // render children), make sure the `data` is cleared out and `loading` is
        // set to `false` (since we aren't loading anything).
        //
        // NOTE: We no longer think this is the correct behavior. Skipping should
        // not automatically set `data` to `undefined`, but instead leave the
        // previous data in place. In other words, skipping should not mandate that
        // previously received data is all of a sudden removed. Unfortunately,
        // changing this is breaking, so we'll have to wait until Apollo Client 4.0
        // to address this.
        this.result = this.skipStandbyResult;
        else if (this.result === this.ssrDisabledResult || this.result === this.skipStandbyResult) this.result = void 0;
    };
    InternalState.prototype.getObsQueryOptions = function() {
        var toMerge = [];
        var globalDefaults = this.client.defaultOptions.watchQuery;
        if (globalDefaults) toMerge.push(globalDefaults);
        if (this.queryHookOptions.defaultOptions) toMerge.push(this.queryHookOptions.defaultOptions);
        // We use compact rather than mergeOptions for this part of the merge,
        // because we want watchQueryOptions.variables (if defined) to replace
        // this.observable.options.variables whole. This replacement allows
        // removing variables by removing them from the variables input to
        // useQuery. If the variables were always merged together (rather than
        // replaced), there would be no way to remove existing variables.
        // However, the variables from options.defaultOptions and globalDefaults
        // (if provided) should be merged, to ensure individual defaulted
        // variables always have values, if not otherwise defined in
        // observable.options or watchQueryOptions.
        toMerge.push((0, $cTbVl.compact)(this.observable && this.observable.options, this.watchQueryOptions));
        return toMerge.reduce((0, $5nAjP.mergeOptions));
    };
    // A function to massage options before passing them to ObservableQuery.
    InternalState.prototype.createWatchQueryOptions = function(_a) {
        var _b;
        if (_a === void 0) _a = {};
        var skip = _a.skip, ssr = _a.ssr, onCompleted = _a.onCompleted, onError = _a.onError, defaultOptions = _a.defaultOptions, // The above options are useQuery-specific, so this ...otherOptions spread
        // makes otherOptions almost a WatchQueryOptions object, except for the
        // query property that we add below.
        otherOptions = (0, $fKE23.__rest)(_a, [
            "skip",
            "ssr",
            "onCompleted",
            "onError",
            "defaultOptions"
        ]);
        // This Object.assign is safe because otherOptions is a fresh ...rest object
        // that did not exist until just now, so modifications are still allowed.
        var watchQueryOptions = Object.assign(otherOptions, {
            query: this.query
        });
        if (this.renderPromises && (watchQueryOptions.fetchPolicy === "network-only" || watchQueryOptions.fetchPolicy === "cache-and-network")) // this behavior was added to react-apollo without explanation in this PR
        // https://github.com/apollographql/react-apollo/pull/1579
        watchQueryOptions.fetchPolicy = "cache-first";
        if (!watchQueryOptions.variables) watchQueryOptions.variables = {};
        if (skip) {
            var _c = watchQueryOptions.fetchPolicy, fetchPolicy = _c === void 0 ? this.getDefaultFetchPolicy() : _c, _d = watchQueryOptions.initialFetchPolicy, initialFetchPolicy = _d === void 0 ? fetchPolicy : _d;
            // When skipping, we set watchQueryOptions.fetchPolicy initially to
            // "standby", but we also need/want to preserve the initial non-standby
            // fetchPolicy that would have been used if not skipping.
            Object.assign(watchQueryOptions, {
                initialFetchPolicy: initialFetchPolicy,
                fetchPolicy: "standby"
            });
        } else if (!watchQueryOptions.fetchPolicy) watchQueryOptions.fetchPolicy = ((_b = this.observable) === null || _b === void 0 ? void 0 : _b.options.initialFetchPolicy) || this.getDefaultFetchPolicy();
        return watchQueryOptions;
    };
    InternalState.prototype.getDefaultFetchPolicy = function() {
        var _a, _b;
        return ((_a = this.queryHookOptions.defaultOptions) === null || _a === void 0 ? void 0 : _a.fetchPolicy) || ((_b = this.client.defaultOptions.watchQuery) === null || _b === void 0 ? void 0 : _b.fetchPolicy) || "cache-first";
    };
    // Defining these methods as no-ops on the prototype allows us to call
    // state.onCompleted and/or state.onError without worrying about whether a
    // callback was provided.
    InternalState.prototype.onCompleted = function(data) {};
    InternalState.prototype.onError = function(error) {};
    InternalState.prototype.useObservableQuery = function() {
        // See if there is an existing observable that was used to fetch the same
        // data and if so, use it instead since it will contain the proper queryId
        // to fetch the result set. This is used during SSR.
        var obsQuery = this.observable = this.renderPromises && this.renderPromises.getSSRObservable(this.watchQueryOptions) || this.observable || // Reuse this.observable if possible (and not SSR)
        this.client.watchQuery(this.getObsQueryOptions());
        this.obsQueryFields = $a1fq9.useMemo(function() {
            return {
                refetch: obsQuery.refetch.bind(obsQuery),
                reobserve: obsQuery.reobserve.bind(obsQuery),
                fetchMore: obsQuery.fetchMore.bind(obsQuery),
                updateQuery: obsQuery.updateQuery.bind(obsQuery),
                startPolling: obsQuery.startPolling.bind(obsQuery),
                stopPolling: obsQuery.stopPolling.bind(obsQuery),
                subscribeToMore: obsQuery.subscribeToMore.bind(obsQuery)
            };
        }, [
            obsQuery
        ]);
        var ssrAllowed = !(this.queryHookOptions.ssr === false || this.queryHookOptions.skip);
        if (this.renderPromises && ssrAllowed) {
            this.renderPromises.registerSSRObservable(obsQuery);
            if (obsQuery.getCurrentResult().loading) // TODO: This is a legacy API which could probably be cleaned up
            this.renderPromises.addObservableQueryPromise(obsQuery);
        }
        return obsQuery;
    };
    InternalState.prototype.setResult = function(nextResult) {
        var previousResult = this.result;
        if (previousResult && previousResult.data) this.previousData = previousResult.data;
        this.result = nextResult;
        // Calling state.setResult always triggers an update, though some call sites
        // perform additional equality checks before committing to an update.
        this.forceUpdate();
        this.handleErrorOrCompleted(nextResult, previousResult);
    };
    InternalState.prototype.handleErrorOrCompleted = function(result, previousResult) {
        var _this = this;
        if (!result.loading) {
            var error_1 = this.toApolloError(result);
            // wait a tick in case we are in the middle of rendering a component
            Promise.resolve().then(function() {
                if (error_1) _this.onError(error_1);
                else if (result.data && (previousResult === null || previousResult === void 0 ? void 0 : previousResult.networkStatus) !== result.networkStatus && result.networkStatus === (0, $cPsoH.NetworkStatus).ready) _this.onCompleted(result.data);
            }).catch(function(error) {
                globalThis.__DEV__ !== false && (0, $4FQap.invariant).warn(error);
            });
        }
    };
    InternalState.prototype.toApolloError = function(result) {
        return (0, $kIFyK.isNonEmptyArray)(result.errors) ? new (0, $3HKMg.ApolloError)({
            graphQLErrors: result.errors
        }) : result.error;
    };
    InternalState.prototype.getCurrentResult = function() {
        // Using this.result as a cache ensures getCurrentResult continues returning
        // the same (===) result object, unless state.setResult has been called, or
        // we're doing server rendering and therefore override the result below.
        if (!this.result) this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult());
        return this.result;
    };
    InternalState.prototype.toQueryResult = function(result) {
        var queryResult = this.toQueryResultCache.get(result);
        if (queryResult) return queryResult;
        var data = result.data, partial = result.partial, resultWithoutPartial = (0, $fKE23.__rest)(result, [
            "data",
            "partial"
        ]);
        this.toQueryResultCache.set(result, queryResult = (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({
            data: data
        }, resultWithoutPartial), this.obsQueryFields), {
            client: this.client,
            observable: this.observable,
            variables: this.observable.variables,
            called: !this.queryHookOptions.skip,
            previousData: this.previousData
        }));
        if (!queryResult.error && (0, $kIFyK.isNonEmptyArray)(result.errors)) // Until a set naming convention for networkError and graphQLErrors is
        // decided upon, we map errors (graphQLErrors) to the error options.
        // TODO: Is it possible for both result.error and result.errors to be
        // defined here?
        queryResult.error = new (0, $3HKMg.ApolloError)({
            graphQLErrors: result.errors
        });
        return queryResult;
    };
    InternalState.prototype.unsafeHandlePartialRefetch = function(result) {
        // WARNING: SIDE-EFFECTS IN THE RENDER FUNCTION
        //
        // TODO: This code should be removed when the partialRefetch option is
        // removed. I was unable to get this hook to behave reasonably in certain
        // edge cases when this block was put in an effect.
        if (result.partial && this.queryHookOptions.partialRefetch && !result.loading && (!result.data || Object.keys(result.data).length === 0) && this.observable.options.fetchPolicy !== "cache-only") {
            Object.assign(result, {
                loading: true,
                networkStatus: (0, $cPsoH.NetworkStatus).refetch
            });
            this.observable.refetch();
        }
    };
    return InternalState;
}();

});
parcelRegister("kc5Xp", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $eb398c98a5cd84ea$export$306c0aa65ff9ec16);
parcelRequire("4cpTA");
var $4FQap = parcelRequire("4FQap");

var $a1fq9 = parcelRequire("a1fq9");

var $bSld1 = parcelRequire("bSld1");
var $eb398c98a5cd84ea$var$didWarnUncachedGetSnapshot = false;
// Prevent webpack from complaining about our feature detection of the
// useSyncExternalStore property of the React namespace, which is expected not
// to exist when using React 17 and earlier, and that's fine.
var $eb398c98a5cd84ea$var$uSESKey = "useSyncExternalStore";
var $eb398c98a5cd84ea$var$realHook = $a1fq9[$eb398c98a5cd84ea$var$uSESKey];
var $eb398c98a5cd84ea$export$306c0aa65ff9ec16 = $eb398c98a5cd84ea$var$realHook || function(subscribe, getSnapshot, getServerSnapshot) {
    // Read the current snapshot from the store on every render. Again, this
    // breaks the rules of React, and only works here because of specific
    // implementation details, most importantly that updates are
    // always synchronous.
    var value = getSnapshot();
    if (// DEVIATION: Using __DEV__
    globalThis.__DEV__ !== false && !$eb398c98a5cd84ea$var$didWarnUncachedGetSnapshot && // DEVIATION: Not using Object.is because we know our snapshots will never
    // be exotic primitive values like NaN, which is !== itself.
    value !== getSnapshot()) {
        $eb398c98a5cd84ea$var$didWarnUncachedGetSnapshot = true;
        // DEVIATION: Using invariant.error instead of console.error directly.
        globalThis.__DEV__ !== false && (0, $4FQap.invariant).error(58);
    }
    // Because updates are synchronous, we don't queue them. Instead we force a
    // re-render whenever the subscribed state changes by updating an some
    // arbitrary useState hook. Then, during render, we call getSnapshot to read
    // the current value.
    //
    // Because we don't actually use the state returned by the useState hook, we
    // can save a bit of memory by storing other stuff in that slot.
    //
    // To implement the early bailout, we need to track some things on a mutable
    // object. Usually, we would put that in a useRef hook, but we can stash it in
    // our useState hook instead.
    //
    // To force a re-render, we call forceUpdate({inst}). That works because the
    // new object always fails an equality check.
    var _a = $a1fq9.useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _a[0].inst, forceUpdate = _a[1];
    // Track the latest getSnapshot function with a ref. This needs to be updated
    // in the layout phase so we can access it during the tearing check that
    // happens on subscribe.
    if (0, $bSld1.canUseLayoutEffect) // DEVIATION: We avoid calling useLayoutEffect when !canUseLayoutEffect,
    // which may seem like a conditional hook, but this code ends up behaving
    // unconditionally (one way or the other) because canUseLayoutEffect is
    // constant.
    $a1fq9.useLayoutEffect(function() {
        Object.assign(inst, {
            value: value,
            getSnapshot: getSnapshot
        });
        // Whenever getSnapshot or subscribe changes, we need to check in the
        // commit phase if there was an interleaved mutation. In concurrent mode
        // this can happen all the time, but even in synchronous mode, an earlier
        // effect may have mutated the store.
        if ($eb398c98a5cd84ea$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    else Object.assign(inst, {
        value: value,
        getSnapshot: getSnapshot
    });
    $a1fq9.useEffect(function() {
        // Check for changes right before subscribing. Subsequent changes will be
        // detected in the subscription handler.
        if ($eb398c98a5cd84ea$var$checkIfSnapshotChanged(inst)) // Force a re-render.
        forceUpdate({
            inst: inst
        });
        // Subscribe to the store and return a clean-up function.
        return subscribe(function handleStoreChange() {
            // TODO: Because there is no cross-renderer API for batching updates, it's
            // up to the consumer of this library to wrap their subscription event
            // with unstable_batchedUpdates. Should we try to detect when this isn't
            // the case and print a warning in development?
            // The store changed. Check if the snapshot changed since the last time we
            // read from the store.
            if ($eb398c98a5cd84ea$var$checkIfSnapshotChanged(inst)) // Force a re-render.
            forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    return value;
};
function $eb398c98a5cd84ea$var$checkIfSnapshotChanged(_a) {
    var value = _a.value, getSnapshot = _a.getSnapshot;
    try {
        return value !== getSnapshot();
    } catch (_b) {
        return true;
    }
}

});

parcelRegister("cTbVl", function(module, exports) {

$parcel$export(module.exports, "compact", () => $9623def0b2db4ff3$export$8e16b83750b44988);
/**
 * Merges the provided objects shallowly and removes
 * all properties with an `undefined` value
 */ function $9623def0b2db4ff3$export$8e16b83750b44988() {
    var objects = [];
    for(var _i = 0; _i < arguments.length; _i++)objects[_i] = arguments[_i];
    var result = Object.create(null);
    objects.forEach(function(obj) {
        if (!obj) return;
        Object.keys(obj).forEach(function(key) {
            var value = obj[key];
            if (value !== void 0) result[key] = value;
        });
    });
    return result;
}

});

parcelRegister("kIFyK", function(module, exports) {

$parcel$export(module.exports, "isNonEmptyArray", () => $f1582792dcd63f7b$export$d307f5934e447d0e);
// A version of Array.isArray that works better with readonly arrays.
var $f1582792dcd63f7b$export$43bee75e5e14138e = Array.isArray;
function $f1582792dcd63f7b$export$d307f5934e447d0e(value) {
    return Array.isArray(value) && value.length > 0;
}

});

parcelRegister("18jmh", function(module, exports) {

$parcel$export(module.exports, "maybeDeepFreeze", () => $0d358dfb8fe6c71c$export$7f9c177735b71f18);

var $i8DcM = parcelRequire("i8DcM");
function $0d358dfb8fe6c71c$var$deepFreeze(value) {
    var workSet = new Set([
        value
    ]);
    workSet.forEach(function(obj) {
        if ((0, $i8DcM.isNonNullObject)(obj) && $0d358dfb8fe6c71c$var$shallowFreeze(obj) === obj) Object.getOwnPropertyNames(obj).forEach(function(name) {
            if ((0, $i8DcM.isNonNullObject)(obj[name])) workSet.add(obj[name]);
        });
    });
    return value;
}
function $0d358dfb8fe6c71c$var$shallowFreeze(obj) {
    if (globalThis.__DEV__ !== false && !Object.isFrozen(obj)) try {
        Object.freeze(obj);
    } catch (e) {
        // Some types like Uint8Array and Node.js's Buffer cannot be frozen, but
        // they all throw a TypeError when you try, so we re-throw any exceptions
        // that are not TypeErrors, since that would be unexpected.
        if (e instanceof TypeError) return null;
        throw e;
    }
    return obj;
}
function $0d358dfb8fe6c71c$export$7f9c177735b71f18(obj) {
    if (globalThis.__DEV__ !== false) $0d358dfb8fe6c71c$var$deepFreeze(obj);
    return obj;
}

});
parcelRegister("i8DcM", function(module, exports) {

$parcel$export(module.exports, "isNonNullObject", () => $d34762a60f77bf91$export$417207af72fad9c9);
function $d34762a60f77bf91$export$417207af72fad9c9(obj) {
    return obj !== null && typeof obj === "object";
}
function $d34762a60f77bf91$export$53b83ca8eaab0383(obj) {
    return obj !== null && typeof obj === "object" && (Object.getPrototypeOf(obj) === Object.prototype || Object.getPrototypeOf(obj) === null);
}

});


parcelRegister("5nAjP", function(module, exports) {

$parcel$export(module.exports, "mergeOptions", () => $3eab45e5a98f1a7b$export$235b7fc70b9fc359);

var $fKE23 = parcelRequire("fKE23");

var $cTbVl = parcelRequire("cTbVl");
function $3eab45e5a98f1a7b$export$235b7fc70b9fc359(defaults, options) {
    return (0, $cTbVl.compact)(defaults, options, options.variables && {
        variables: (0, $cTbVl.compact)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, defaults && defaults.variables), options.variables))
    });
}

});

parcelRegister("3HKMg", function(module, exports) {

$parcel$export(module.exports, "ApolloError", () => $2b29ac45cd9f9ebd$export$26a337512320b8c6);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("4cpTA");

var $i8DcM = parcelRequire("i8DcM");
var $2b29ac45cd9f9ebd$export$4995664c1b49842e = Symbol();
function $2b29ac45cd9f9ebd$export$345f95cc6b6b9b0b(result) {
    if (result.extensions) return Array.isArray(result.extensions[$2b29ac45cd9f9ebd$export$4995664c1b49842e]);
    return false;
}
function $2b29ac45cd9f9ebd$export$17f5e6bd290bb15d(err) {
    return err.hasOwnProperty("graphQLErrors");
}
// Sets the error message on this error according to the
// the GraphQL and network errors that are present.
// If the error message has already been set through the
// constructor or otherwise, this function is a nop.
var $2b29ac45cd9f9ebd$var$generateErrorMessage = function(err) {
    var errors = (0, $fKE23.__spreadArray)((0, $fKE23.__spreadArray)((0, $fKE23.__spreadArray)([], err.graphQLErrors, true), err.clientErrors, true), err.protocolErrors, true);
    if (err.networkError) errors.push(err.networkError);
    return errors// The rest of the code sometimes unsafely types non-Error objects as GraphQLErrors
    .map(function(err) {
        return (0, $i8DcM.isNonNullObject)(err) && err.message || "Error message not found.";
    }).join("\n");
};
var $2b29ac45cd9f9ebd$export$26a337512320b8c6 = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ApolloError, _super);
    // Constructs an instance of ApolloError given a GraphQLError
    // or a network error. Note that one of these has to be a valid
    // value or the constructed error will be meaningless.
    function ApolloError(_a) {
        var graphQLErrors = _a.graphQLErrors, protocolErrors = _a.protocolErrors, clientErrors = _a.clientErrors, networkError = _a.networkError, errorMessage = _a.errorMessage, extraInfo = _a.extraInfo;
        var _this = _super.call(this, errorMessage) || this;
        _this.name = "ApolloError";
        _this.graphQLErrors = graphQLErrors || [];
        _this.protocolErrors = protocolErrors || [];
        _this.clientErrors = clientErrors || [];
        _this.networkError = networkError || null;
        _this.message = errorMessage || $2b29ac45cd9f9ebd$var$generateErrorMessage(_this);
        _this.extraInfo = extraInfo;
        // We're not using `Object.setPrototypeOf` here as it isn't fully
        // supported on Android (see issue #3236).
        _this.__proto__ = ApolloError.prototype;
        return _this;
    }
    return ApolloError;
}(Error);

});

parcelRegister("cPsoH", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $957046988d3f3664$export$bd096ddbd246c79c);
/**
 * The current status of a query’s execution in our system.
 */ var $957046988d3f3664$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    /**
     * The query has never been run before and the query is now currently running. A query will still
     * have this network status even if a partial data result was returned from the cache, but a
     * query was dispatched anyway.
     */ NetworkStatus[NetworkStatus["loading"] = 1] = "loading";
    /**
     * If `setVariables` was called and a query was fired because of that then the network status
     * will be `setVariables` until the result of that query comes back.
     */ NetworkStatus[NetworkStatus["setVariables"] = 2] = "setVariables";
    /**
     * Indicates that `fetchMore` was called on this query and that the query created is currently in
     * flight.
     */ NetworkStatus[NetworkStatus["fetchMore"] = 3] = "fetchMore";
    /**
     * Similar to the `setVariables` network status. It means that `refetch` was called on a query
     * and the refetch request is currently in flight.
     */ NetworkStatus[NetworkStatus["refetch"] = 4] = "refetch";
    /**
     * Indicates that a polling query is currently in flight. So for example if you are polling a
     * query every 10 seconds then the network status will switch to `poll` every 10 seconds whenever
     * a poll request has been sent but not resolved.
     */ NetworkStatus[NetworkStatus["poll"] = 6] = "poll";
    /**
     * No request is in flight for this query, and no errors happened. Everything is OK.
     */ NetworkStatus[NetworkStatus["ready"] = 7] = "ready";
    /**
     * No request is in flight for this query, but one or more errors were detected.
     */ NetworkStatus[NetworkStatus["error"] = 8] = "error";
})($957046988d3f3664$export$bd096ddbd246c79c || ($957046988d3f3664$export$bd096ddbd246c79c = {}));
function $957046988d3f3664$export$37509604341a3464(networkStatus) {
    return networkStatus ? networkStatus < 7 : false;
}
function $957046988d3f3664$export$427e8a52ef0f96e2(networkStatus) {
    return networkStatus === 7 || networkStatus === 8;
}

});

parcelRegister("9cZSb", function(module, exports) {

$parcel$export(module.exports, "DocumentType", () => $6b453ab7b629bf9f$export$d1d99cf900472499);
$parcel$export(module.exports, "verifyDocumentType", () => $6b453ab7b629bf9f$export$6dfb8732f737404c);
parcelRequire("4cpTA");
var $4FQap = parcelRequire("4FQap");

var $fsBda = parcelRequire("fsBda");
var $jtMJf = parcelRequire("jtMJf");

var $aIUZj = parcelRequire("aIUZj");
var $6b453ab7b629bf9f$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($6b453ab7b629bf9f$export$d1d99cf900472499 || ($6b453ab7b629bf9f$export$d1d99cf900472499 = {}));
var $6b453ab7b629bf9f$var$cache;
function $6b453ab7b629bf9f$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $6b453ab7b629bf9f$export$d1d99cf900472499.Query:
            name = "Query";
            break;
        case $6b453ab7b629bf9f$export$d1d99cf900472499.Mutation:
            name = "Mutation";
            break;
        case $6b453ab7b629bf9f$export$d1d99cf900472499.Subscription:
            name = "Subscription";
            break;
    }
    return name;
}
function $6b453ab7b629bf9f$export$8f49e4af10703ce3(document) {
    if (!$6b453ab7b629bf9f$var$cache) $6b453ab7b629bf9f$var$cache = new (0, $fsBda.AutoCleanedWeakCache)((0, $jtMJf.cacheSizes).parser || 1000 /* defaultCacheSizes.parser */ );
    var cached = $6b453ab7b629bf9f$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $4FQap.invariant)(!!document && !!document.kind, 59, document);
    var fragments = [];
    var queries = [];
    var mutations = [];
    var subscriptions = [];
    for(var _i = 0, _a = document.definitions; _i < _a.length; _i++){
        var x = _a[_i];
        if (x.kind === "FragmentDefinition") {
            fragments.push(x);
            continue;
        }
        if (x.kind === "OperationDefinition") switch(x.operation){
            case "query":
                queries.push(x);
                break;
            case "mutation":
                mutations.push(x);
                break;
            case "subscription":
                subscriptions.push(x);
                break;
        }
    }
    (0, $4FQap.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 60);
    (0, $4FQap.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 61, document, queries.length, subscriptions.length, mutations.length);
    type = queries.length ? $6b453ab7b629bf9f$export$d1d99cf900472499.Query : $6b453ab7b629bf9f$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $6b453ab7b629bf9f$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $4FQap.invariant)(definitions.length === 1, 62, document, definitions.length);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === "Name") name = definition.name.value;
    else name = "data"; // fallback to using data if no name
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $6b453ab7b629bf9f$var$cache.set(document, payload);
    return payload;
}
$6b453ab7b629bf9f$export$8f49e4af10703ce3.resetCache = function() {
    $6b453ab7b629bf9f$var$cache = undefined;
};
if (globalThis.__DEV__ !== false) (0, $aIUZj.registerGlobalCache)("parser", function() {
    return $6b453ab7b629bf9f$var$cache ? $6b453ab7b629bf9f$var$cache.size : 0;
});
function $6b453ab7b629bf9f$export$6dfb8732f737404c(document, type) {
    var operation = $6b453ab7b629bf9f$export$8f49e4af10703ce3(document);
    var requiredOperationName = $6b453ab7b629bf9f$export$5db520940cf00715(type);
    var usedOperationName = $6b453ab7b629bf9f$export$5db520940cf00715(operation.type);
    (0, $4FQap.invariant)(operation.type === type, 63, requiredOperationName, requiredOperationName, usedOperationName);
}

});
parcelRegister("fsBda", function(module, exports) {

$parcel$export(module.exports, "AutoCleanedWeakCache", () => $b41655f4f9071a69$export$8dbad6f439bb2331);

var $16Gah = parcelRequire("16Gah");
var $kIv0I = parcelRequire("kIv0I");
var $b41655f4f9071a69$var$scheduledCleanup = new WeakSet();
function $b41655f4f9071a69$var$schedule(cache) {
    if (!$b41655f4f9071a69$var$scheduledCleanup.has(cache)) {
        $b41655f4f9071a69$var$scheduledCleanup.add(cache);
        setTimeout(function() {
            cache.clean();
            $b41655f4f9071a69$var$scheduledCleanup.delete(cache);
        }, 100);
    }
}
var $b41655f4f9071a69$export$8dbad6f439bb2331 = function(max, dispose) {
    /*
    Some builds of `WeakCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $kIv0I.WeakCache)(max, dispose);
    cache.set = function(key, value) {
        $b41655f4f9071a69$var$schedule(this);
        return (0, $kIv0I.WeakCache).prototype.set.call(this, key, value);
    };
    return cache;
};
var $b41655f4f9071a69$export$5b4f745137d91413 = function(max, dispose) {
    /*
    Some builds of `StrongCache` are function prototypes, some are classes.
    This library still builds with an ES5 target, so we can't extend the
    real classes.
    Instead, we have to use this workaround until we switch to a newer build
    target.
    */ var cache = new (0, $16Gah.StrongCache)(max, dispose);
    cache.set = function(key, value) {
        $b41655f4f9071a69$var$schedule(this);
        return (0, $16Gah.StrongCache).prototype.set.call(this, key, value);
    };
    return cache;
};

});

parcelRegister("jtMJf", function(module, exports) {

$parcel$export(module.exports, "cacheSizes", () => $e2e6864630c8e0ea$export$f29926b23b28936b);

var $fKE23 = parcelRequire("fKE23");
parcelRequire("4cpTA");
var $8Pk3B = parcelRequire("8Pk3B");
var $e2e6864630c8e0ea$var$cacheSizeSymbol = Symbol.for("apollo.cacheSize");
var $e2e6864630c8e0ea$export$f29926b23b28936b = (0, $fKE23.__assign)({}, (0, $8Pk3B.default)[$e2e6864630c8e0ea$var$cacheSizeSymbol]);

});

parcelRegister("aIUZj", function(module, exports) {

$parcel$export(module.exports, "registerGlobalCache", () => $7cea38115e5e3413$export$a8fcd406d9e37621);

var $fKE23 = parcelRequire("fKE23");

var $jtMJf = parcelRequire("jtMJf");
var $7cea38115e5e3413$var$globalCaches = {};
function $7cea38115e5e3413$export$a8fcd406d9e37621(name, getSize) {
    $7cea38115e5e3413$var$globalCaches[name] = getSize;
}
var $7cea38115e5e3413$export$dfdba94ce46d2ea5 = globalThis.__DEV__ !== false ? $7cea38115e5e3413$var$_getApolloClientMemoryInternals : undefined;
var $7cea38115e5e3413$export$e95a5a2210e62466 = globalThis.__DEV__ !== false ? $7cea38115e5e3413$var$_getInMemoryCacheMemoryInternals : undefined;
var $7cea38115e5e3413$export$e7ed438e82606689 = globalThis.__DEV__ !== false ? $7cea38115e5e3413$var$_getApolloCacheMemoryInternals : undefined;
function $7cea38115e5e3413$var$getCurrentCacheSizes() {
    // `defaultCacheSizes` is a `const enum` that will be inlined during build, so we have to reconstruct it's shape here
    var defaults = {
        parser: 1000 /* defaultCacheSizes["parser"] */ ,
        canonicalStringify: 1000 /* defaultCacheSizes["canonicalStringify"] */ ,
        print: 2000 /* defaultCacheSizes["print"] */ ,
        "documentTransform.cache": 2000 /* defaultCacheSizes["documentTransform.cache"] */ ,
        "queryManager.getDocumentInfo": 2000 /* defaultCacheSizes["queryManager.getDocumentInfo"] */ ,
        "PersistedQueryLink.persistedQueryHashes": 2000 /* defaultCacheSizes["PersistedQueryLink.persistedQueryHashes"] */ ,
        "fragmentRegistry.transform": 2000 /* defaultCacheSizes["fragmentRegistry.transform"] */ ,
        "fragmentRegistry.lookup": 1000 /* defaultCacheSizes["fragmentRegistry.lookup"] */ ,
        "fragmentRegistry.findFragmentSpreads": 4000 /* defaultCacheSizes["fragmentRegistry.findFragmentSpreads"] */ ,
        "cache.fragmentQueryDocuments": 1000 /* defaultCacheSizes["cache.fragmentQueryDocuments"] */ ,
        "removeTypenameFromVariables.getVariableDefinitions": 2000 /* defaultCacheSizes["removeTypenameFromVariables.getVariableDefinitions"] */ ,
        "inMemoryCache.maybeBroadcastWatch": 5000 /* defaultCacheSizes["inMemoryCache.maybeBroadcastWatch"] */ ,
        "inMemoryCache.executeSelectionSet": 50000 /* defaultCacheSizes["inMemoryCache.executeSelectionSet"] */ ,
        "inMemoryCache.executeSubSelectedArray": 10000 /* defaultCacheSizes["inMemoryCache.executeSubSelectedArray"] */ 
    };
    return Object.fromEntries(Object.entries(defaults).map(function(_a) {
        var k = _a[0], v = _a[1];
        return [
            k,
            (0, $jtMJf.cacheSizes)[k] || v
        ];
    }));
}
function $7cea38115e5e3413$var$_getApolloClientMemoryInternals() {
    var _a, _b, _c, _d, _e;
    if (!(globalThis.__DEV__ !== false)) throw new Error("only supported in development mode");
    return {
        limits: $7cea38115e5e3413$var$getCurrentCacheSizes(),
        sizes: (0, $fKE23.__assign)({
            print: (_a = $7cea38115e5e3413$var$globalCaches.print) === null || _a === void 0 ? void 0 : _a.call($7cea38115e5e3413$var$globalCaches),
            parser: (_b = $7cea38115e5e3413$var$globalCaches.parser) === null || _b === void 0 ? void 0 : _b.call($7cea38115e5e3413$var$globalCaches),
            canonicalStringify: (_c = $7cea38115e5e3413$var$globalCaches.canonicalStringify) === null || _c === void 0 ? void 0 : _c.call($7cea38115e5e3413$var$globalCaches),
            links: $7cea38115e5e3413$var$linkInfo(this.link),
            queryManager: {
                getDocumentInfo: this["queryManager"]["transformCache"].size,
                documentTransforms: $7cea38115e5e3413$var$transformInfo(this["queryManager"].documentTransform)
            }
        }, (_e = (_d = this.cache).getMemoryInternals) === null || _e === void 0 ? void 0 : _e.call(_d))
    };
}
function $7cea38115e5e3413$var$_getApolloCacheMemoryInternals() {
    return {
        cache: {
            fragmentQueryDocuments: $7cea38115e5e3413$var$getWrapperInformation(this["getFragmentDoc"])
        }
    };
}
function $7cea38115e5e3413$var$_getInMemoryCacheMemoryInternals() {
    var fragments = this.config.fragments;
    return (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $7cea38115e5e3413$var$_getApolloCacheMemoryInternals.apply(this)), {
        addTypenameDocumentTransform: $7cea38115e5e3413$var$transformInfo(this["addTypenameTransform"]),
        inMemoryCache: {
            executeSelectionSet: $7cea38115e5e3413$var$getWrapperInformation(this["storeReader"]["executeSelectionSet"]),
            executeSubSelectedArray: $7cea38115e5e3413$var$getWrapperInformation(this["storeReader"]["executeSubSelectedArray"]),
            maybeBroadcastWatch: $7cea38115e5e3413$var$getWrapperInformation(this["maybeBroadcastWatch"])
        },
        fragmentRegistry: {
            findFragmentSpreads: $7cea38115e5e3413$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.findFragmentSpreads),
            lookup: $7cea38115e5e3413$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.lookup),
            transform: $7cea38115e5e3413$var$getWrapperInformation(fragments === null || fragments === void 0 ? void 0 : fragments.transform)
        }
    });
}
function $7cea38115e5e3413$var$isWrapper(f) {
    return !!f && "dirtyKey" in f;
}
function $7cea38115e5e3413$var$getWrapperInformation(f) {
    return $7cea38115e5e3413$var$isWrapper(f) ? f.size : undefined;
}
function $7cea38115e5e3413$var$isDefined(value) {
    return value != null;
}
function $7cea38115e5e3413$var$transformInfo(transform) {
    return $7cea38115e5e3413$var$recurseTransformInfo(transform).map(function(cache) {
        return {
            cache: cache
        };
    });
}
function $7cea38115e5e3413$var$recurseTransformInfo(transform) {
    return transform ? (0, $fKE23.__spreadArray)((0, $fKE23.__spreadArray)([
        $7cea38115e5e3413$var$getWrapperInformation(transform === null || transform === void 0 ? void 0 : transform["performWork"])
    ], $7cea38115e5e3413$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["left"]), true), $7cea38115e5e3413$var$recurseTransformInfo(transform === null || transform === void 0 ? void 0 : transform["right"]), true).filter($7cea38115e5e3413$var$isDefined) : [];
}
function $7cea38115e5e3413$var$linkInfo(link) {
    var _a;
    return link ? (0, $fKE23.__spreadArray)((0, $fKE23.__spreadArray)([
        (_a = link === null || link === void 0 ? void 0 : link.getMemoryInternals) === null || _a === void 0 ? void 0 : _a.call(link)
    ], $7cea38115e5e3413$var$linkInfo(link === null || link === void 0 ? void 0 : link.left), true), $7cea38115e5e3413$var$linkInfo(link === null || link === void 0 ? void 0 : link.right), true).filter($7cea38115e5e3413$var$isDefined) : [];
}

});


parcelRegister("3p7NC", function(module, exports) {

$parcel$export(module.exports, "useApolloClient", () => $27a9c1b04be3621b$export$eb9a56e7a29e494);
parcelRequire("4cpTA");
var $4FQap = parcelRequire("4FQap");

var $a1fq9 = parcelRequire("a1fq9");

var $ktrpW = parcelRequire("ktrpW");
function $27a9c1b04be3621b$export$eb9a56e7a29e494(override) {
    var context = $a1fq9.useContext((0, $ktrpW.getApolloContext)());
    var client = override || context.client;
    (0, $4FQap.invariant)(!!client, 49);
    return client;
}

});

parcelRegister("fHgsu", function(module, exports) {

$parcel$export(module.exports, "wrapHook", () => $b6d7a37bcaa9685c$export$7f12579c79e39619);
var $b6d7a37bcaa9685c$var$wrapperSymbol = Symbol.for("apollo.hook.wrappers");
function $b6d7a37bcaa9685c$export$7f12579c79e39619(hookName, useHook, clientOrObsQuery) {
    var queryManager = clientOrObsQuery["queryManager"];
    var wrappers = queryManager && queryManager[$b6d7a37bcaa9685c$var$wrapperSymbol];
    var wrapper = wrappers && wrappers[hookName];
    return wrapper ? wrapper(useHook) : useHook;
}

});


parcelRegister("hh2jg", function(module, exports) {

$parcel$export(module.exports, "useAppListingTelemetryTracking", () => $c935d0e04fcef048$export$126c0076ddb12370);

var $fUOHe = parcelRequire("fUOHe");

var $eUqFw = parcelRequire("eUqFw");

var $jICRJ = parcelRequire("jICRJ");

var $h6uOD = parcelRequire("h6uOD");
/* When the status is 401, we redirect to login instead [MC-1770, MC-2339] */ const $c935d0e04fcef048$var$isAuthError = (error)=>{
    return error.networkError && 'statusCode' in error.networkError && error.networkError.statusCode === 401;
};
const $c935d0e04fcef048$export$126c0076ddb12370 = (_data, error, networkStatus)=>{
    const [fetching, setFetching] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        /**
     * When the page is SSR'd or the GraphQL result is served from cache,
     * the `networkStatus` and `data` field will both be immediately populated with `7` and
     * the cached data respectively. Since the task never gets started, the end becomes a no-op;
     * consequently the main app listing task never ends and we lose the metric.
     *
     * To counter this case we immediately start and end the task to track the metric for SLO.
     * But the caveat is that in these cases the "duration" of the task will be 0/negligible and
     * should be ignored.
     */ const startImmediatelyIfNotStarted = ()=>{
            if (!fetching) (0, $jICRJ.AppListingTask).start();
        };
        const handleNetworkStatusLoading = ()=>{
            setFetching(true);
            (0, $jICRJ.AppListingTask).start();
        };
        const handleNetworkStatusReady = ()=>{
            startImmediatelyIfNotStarted();
            (0, $jICRJ.AppListingTask).succeeded();
            setFetching(false);
        };
        const handleNetworkStatusError = ()=>{
            startImmediatelyIfNotStarted();
            if ($c935d0e04fcef048$var$isAuthError(error) || (0, $h6uOD.isRuByPartnerAppAccessDeniedError)(error)) {
                (0, $fUOHe.default).setUFOInteractionError({
                    name: (0, $jICRJ.viewAppDetailsTask),
                    errorMessage: error === null || error === void 0 ? void 0 : error.message
                });
                (0, $jICRJ.AppListingTask).abort();
            } else {
                (0, $fUOHe.default).setUFOInteractionError({
                    name: (0, $jICRJ.viewAppDetailsTask),
                    errorMessage: error === null || error === void 0 ? void 0 : error.message
                });
                (0, $jICRJ.AppListingTask).failed(error);
                setFetching(false);
            }
        };
        if (networkStatus === 1) handleNetworkStatusLoading();
        else if (networkStatus === 7) handleNetworkStatusReady();
        else if (networkStatus === 8) handleNetworkStatusError();
    }, [
        networkStatus
    ]);
};

});
parcelRegister("jICRJ", function(module, exports) {

$parcel$export(module.exports, "viewAppDetailsTask", () => $e5b046469b7f610a$export$caa82e45bc907d19);
$parcel$export(module.exports, "AppListingTask", () => $e5b046469b7f610a$export$a748921f7ae927dd);

var $fUOHe = parcelRequire("fUOHe");
const $e5b046469b7f610a$export$caa82e45bc907d19 = 'view-app-details';
const $e5b046469b7f610a$export$a748921f7ae927dd = (0, $fUOHe.default).createGenericTask($e5b046469b7f610a$export$caa82e45bc907d19);

});



parcelRegister("9e16A", function(module, exports) {

$parcel$export(module.exports, "useGetAppDetailsFromSearch", () => $6b76475531771fe7$export$702f0d5605b87956);

var $9l6Pq = parcelRequire("9l6Pq");

var $bTrQR = parcelRequire("bTrQR");
var $fBO3c = parcelRequire("fBO3c");

var $6BoHr = parcelRequire("6BoHr");

var $eUqFw = parcelRequire("eUqFw");
const $6b76475531771fe7$export$702f0d5605b87956 = (_ref)=>{
    let { appId: appId, appKey: appKey, algoliaConfig: algoliaConfig } = _ref;
    const [appData, setAppData] = (0, $eUqFw.useState)(null);
    const [appDataStatus, setAppDataStatus] = (0, $eUqFw.useState)('idle');
    const { environment: algoliaEnvironment, applicationId: applicationId, apiKey: apiKey } = algoliaConfig;
    const searchClient = (0, (/*@__PURE__*/$parcel$interopDefault($6BoHr)))(applicationId, apiKey);
    const { enableAlgoliaCallOnAppListingAndDialogs: enableAlgoliaCallOnAppListingAndDialogs } = (0, $9l6Pq.useStatsig)();
    const isAlgoliaSearchEnabled = enableAlgoliaCallOnAppListingAndDialogs();
    const shouldFetchAppData = isAlgoliaSearchEnabled && (appId || appKey);
    (0, $eUqFw.useEffect)(()=>{
        async function getAppData() {
            try {
                if (!shouldFetchAppData) return;
                const indexName = (0, $fBO3c.resolveAlgoliaSearchIndex)(algoliaEnvironment, true);
                const searchParams = {};
                if (appKey) searchParams.facetFilters = [
                    "addonKey:".concat(appKey)
                ];
                if (appId) searchParams.numericFilters = "addonId=".concat(appId);
                setAppDataStatus('loading');
                const response = await searchClient.search([
                    {
                        indexName: indexName,
                        params: searchParams
                    }
                ]);
                const { hits: hits } = response.results[0];
                if (hits && hits.length > 0) {
                    setAppData(hits[0]);
                    setAppDataStatus('resolved');
                } else {
                    setAppDataStatus('rejected');
                    (0, $bTrQR.default).error('useGetAppDetailsFromSearch', "Empty results from algolia for ".concat(appId || appKey));
                }
            } catch (error) {
                setAppDataStatus('rejected');
                (0, $bTrQR.default).error('useGetAppDetailsFromSearch', "Failed to fetch app data from algolia for ".concat(appId || appKey), {
                    error: error
                });
            }
        }
        getAppData();
    }, [
        algoliaEnvironment,
        appId,
        appKey
    ]);
    const loading = appDataStatus === 'loading';
    const error = appDataStatus === 'rejected';
    return {
        loading: loading,
        error: error,
        appData: appData
    };
};

});

parcelRegister("ecc6Y", function(module, exports) {

$parcel$export(module.exports, "NotFound", () => $a55b94c28d674809$export$271f9f08425019c7);
/* NotFound.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $dWuJB = parcelRequire("dWuJB");

var $4UyA8 = parcelRequire("4UyA8");

var $bp2pr = parcelRequire("bp2pr");

var $smDGQ = parcelRequire("smDGQ");

var $lHkHI = parcelRequire("lHkHI");
const $a55b94c28d674809$var$_excluded = [
    "as",
    "style"
];
function $a55b94c28d674809$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $a55b94c28d674809$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $a55b94c28d674809$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $a55b94c28d674809$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $a55b94c28d674809$var$NotFoundWrapper = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $a55b94c28d674809$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $a55b94c28d674809$var$_objectSpread($a55b94c28d674809$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _2lx21bp4 _1tke1kw7",
            __cmplp.className
        ])
    }));
});
const $a55b94c28d674809$export$271f9f08425019c7 = ()=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)($a55b94c28d674809$var$NotFoundWrapper, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dWuJB.ErrorTemplate), {
            heading: (0, $4UyA8.locale).notFound.heading,
            image: (0, (/*@__PURE__*/$parcel$interopDefault($smDGQ))),
            children: /*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
                children: [
                    (0, $4UyA8.locale).notFound.pageNotExist,
                    " ",
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bp2pr.RedirectLink), {
                        href: "/",
                        children: (0, $4UyA8.locale).homePage
                    })
                ]
            })
        })
    });
};

});
parcelRegister("smDGQ", function(module, exports) {
module.exports = new URL("NotFound.4cf1886c.svg", import.meta.url).toString();

});


parcelRegister("3lzNh", function(module, exports) {

$parcel$export(module.exports, "HomePageTask", () => $26ff192e44e083b7$export$44d1267b1bc214e1);
$parcel$export(module.exports, "SearchPageTask", () => $26ff192e44e083b7$export$731695bdd8573f3a);
$parcel$export(module.exports, "AppListingPageTask", () => $26ff192e44e083b7$export$e0d6864f92f9de60);
$parcel$export(module.exports, "AppInstallTask", () => $26ff192e44e083b7$export$6d832d173539f446);
$parcel$export(module.exports, "AppInstallFailurePartner", () => $26ff192e44e083b7$export$c6bdfae761cfbf22);
$parcel$export(module.exports, "AppInstallFailureDownstream", () => $26ff192e44e083b7$export$7a10bd00860704ee);
$parcel$export(module.exports, "AppInstallFailureCustomer", () => $26ff192e44e083b7$export$d73f016983077cf7);
$parcel$export(module.exports, "AppInstallFailureMarketplace", () => $26ff192e44e083b7$export$12cd11034dad8cd7);
$parcel$export(module.exports, "RequestAppTask", () => $26ff192e44e083b7$export$f8c9ca65d68ce04f);

var $4fL5K = parcelRequire("4fL5K");

var $jICRJ = parcelRequire("jICRJ");

var $fUOHe = parcelRequire("fUOHe");
const $26ff192e44e083b7$export$44d1267b1bc214e1 = (0, $fUOHe.default).createPageViewTask('view-home-page').dependsOn([
    (0, $4fL5K).SearchTask
]);
const $26ff192e44e083b7$export$731695bdd8573f3a = (0, $fUOHe.default).createPageViewTask('view-search-results-page').dependsOn([
    (0, $4fL5K).SearchTask
]);
const $26ff192e44e083b7$export$e0d6864f92f9de60 = (0, $fUOHe.default).createPageViewTask('view-app-listing-page').dependsOn([
    (0, $jICRJ).AppListingTask
]);
const $26ff192e44e083b7$export$6d832d173539f446 = (0, $fUOHe.default).createGenericTask('install-app');
const $26ff192e44e083b7$export$c6bdfae761cfbf22 = (0, $fUOHe.default).createGenericTask('install-app-failure-partner');
const $26ff192e44e083b7$export$7a10bd00860704ee = (0, $fUOHe.default).createGenericTask('install-app-failure-atlassian-downstream');
const $26ff192e44e083b7$export$d73f016983077cf7 = (0, $fUOHe.default).createGenericTask('install-app-failure-customer');
const $26ff192e44e083b7$export$12cd11034dad8cd7 = (0, $fUOHe.default).createGenericTask('install-app-failure-atlassian-marketplace');
const $26ff192e44e083b7$export$f8c9ca65d68ce04f = (0, $fUOHe.default).createGenericTask('request-app');

});

parcelRegister("1nC6Q", function(module, exports) {

$parcel$export(module.exports, "MARKETPLACE_APP_KEY", () => $10158028182bca28$export$bf8edad33d1c3842);
$parcel$export(module.exports, "INSTALLABLE_APP_IDENTIFIER", () => $10158028182bca28$export$65075d6de7e54bf9);
$parcel$export(module.exports, "makeMarketplaceAppKeyIdentifier", () => $10158028182bca28$export$d4e80722d8a07d64);
$parcel$export(module.exports, "makeInstallableAppKeyIdentifier", () => $10158028182bca28$export$91c937ccaec5627);
$parcel$export(module.exports, "AppInstallLocation", () => $10158028182bca28$export$b323075bcb76de30);

var $gIQkA = parcelRequire("gIQkA");
const $10158028182bca28$export$bf8edad33d1c3842 = 'MARKETPLACE_APP_KEY';
const $10158028182bca28$export$65075d6de7e54bf9 = 'INSTALLABLE_APP_IDENTIFIER';
const $10158028182bca28$export$d4e80722d8a07d64 = (appKey)=>({
        type: $10158028182bca28$export$bf8edad33d1c3842,
        keyForInstall: appKey
    });
const $10158028182bca28$export$91c937ccaec5627 = (installableId)=>({
        type: $10158028182bca28$export$65075d6de7e54bf9,
        keyForInstall: installableId
    });
const $10158028182bca28$export$b323075bcb76de30 = Object.freeze({
    EmbeddedMarketplaceAppListing: (0, $gIQkA.ANALYTICS_SCREEN_APP_LISTING).name,
    EmbeddedMarketplaceManageAppRequests: (0, $gIQkA.ANALYTICS_SCREEN_MANAGE_APP_REQUESTS).name
});

});

parcelRegister("hdXYz", function(module, exports) {

$parcel$export(module.exports, "getAppInstallConfigForEnv", () => $c8a22c837d65b323$export$7d6ff3253552718a);
$parcel$export(module.exports, "default", () => $c8a22c837d65b323$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $eWXWl = parcelRequire("eWXWl");

var $gEwvS = parcelRequire("gEwvS");

var $l9NvU = parcelRequire("l9NvU");
var $5o6SH = parcelRequire("5o6SH");
var $492R6 = parcelRequire("492R6");
var $gxv5e = parcelRequire("gxv5e");

var $j0gMm = parcelRequire("j0gMm");

var $kU8RF = parcelRequire("kU8RF");

var $9e16A = parcelRequire("9e16A");

var $inwKI = parcelRequire("inwKI");

var $beqRW = parcelRequire("beqRW");
var $5s4ZL = parcelRequire("5s4ZL");
parcelRequire("eUqFw");

var $i7RVQ = parcelRequire("i7RVQ");

var $4s0An = parcelRequire("4s0An");

var $k5vUT = parcelRequire("k5vUT");

var $iEgm6 = parcelRequire("iEgm6");

var $2FaVi = parcelRequire("2FaVi");

var $2dt3P = parcelRequire("2dt3P");

var $05YC4 = parcelRequire("05YC4");

var $eJGKo = parcelRequire("eJGKo");

var $g9u53 = parcelRequire("g9u53");

var $iEdQ1 = parcelRequire("iEdQ1");

var $lHkHI = parcelRequire("lHkHI");
function $c8a22c837d65b323$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c8a22c837d65b323$export$7326e6d938a8137b = (0, $3UXZ8.default)("img", {
    target: "ea12xvj0",
    label: "ErrorImage"
})({
    name: "k9yj44",
    styles: "margin:auto;margin-top:var(--ds-space-500, 40px);margin-bottom:50px;width:125px;height:105px;"
});
const $c8a22c837d65b323$var$FallbackUIContentWrapper = (0, $3UXZ8.default)("div", {
    target: "ea12xvj1",
    label: "FallbackUIContentWrapper"
})({
    name: "1ydity8",
    styles: "max-width:650px;min-height:300px;margin:auto;display:flex;flex-direction:column;align-items:center;"
});
const $c8a22c837d65b323$var$DialogContentWrapper = (0, $3UXZ8.default)("div", {
    target: "ea12xvj2",
    label: "DialogContentWrapper"
})({
    name: "1t9oc18",
    styles: "max-width:650px;min-height:300px;margin:auto;"
});
const $c8a22c837d65b323$var$FallbackUIContent = (0, $3UXZ8.default)("div", {
    target: "ea12xvj3",
    label: "FallbackUIContent"
})({
    name: "u4p24i",
    styles: "display:flex;flex-direction:row;align-items:center;"
});
function $c8a22c837d65b323$var$foldPromiseState(promiseState, onError, onPending, onResultRetrieved) {
    const { pending: pending, error: error, result: result } = promiseState;
    if (error) return onError();
    if (pending) return onPending();
    return onResultRetrieved(result);
}
const $c8a22c837d65b323$export$7d6ff3253552718a = (environment)=>{
    const applicationConfig = (0, $iEgm6.getApplicationConfigForEnv)(environment);
    const appInstallConfig = {
        adminHubBaseUrl: applicationConfig.adminHubBaseUrl,
        mpacBaseUrl: applicationConfig.mpacBaseUrl,
        mpacCdnBaseUrl: applicationConfig.mpacCdnBaseUrl,
        macBaseUrl: applicationConfig.macBaseUrl,
        wacBaseUrl: applicationConfig.wacBaseUrl,
        atlassianCommunityBaseUrl: applicationConfig.atlassianCommunityBaseUrl,
        graphQLGatewayUrl: applicationConfig.graphQLGatewayUrl,
        sentryConfig: applicationConfig.sentry,
        analytics: applicationConfig.analytics,
        environment: environment,
        algoliaConfig: applicationConfig.algolia
    };
    return appInstallConfig;
};
const $c8a22c837d65b323$var$resolveDialog = (_ref)=>{
    let { mpacBaseUrl: mpacBaseUrl, appInstallBaseData: appInstallBaseData, links: links, onInstallClick: onInstallClick, onClose: onClose, onRendered: onRendered, featureFlags: featureFlags, isInstallInProgress: isInstallInProgress, appDetailsFromSearchResponse: appDetailsFromSearchResponse } = _ref;
    const { hostData: hostData, installMode: installMode, scopesLookup: scopesLookup, forgeAppEgressAddresses: forgeAppEgressAddresses } = appInstallBaseData;
    const { hostInfo: hostInfo, hostConfig: hostConfig, hostLicense: hostLicense } = hostData;
    if (![
        (0, $4s0An.INSTALLABLE_APP_DEFAULT_INSTALL_MODE),
        (0, $k5vUT.INSTRUCTIONAL_INSTALL_MODE)
    ].includes(installMode.type)) throw new Error("AppInstallDialog: Unhandled installMode received ".concat(installMode.type));
    const { content: content, footerLeft: footerLeft, footerCenter: footerCenter, footerRight: footerRight, errorDetails: errorDetails, privacyInformation: privacyInformation } = installMode.type === (0, $k5vUT.INSTRUCTIONAL_INSTALL_MODE) ? (0, $g9u53.default)({
        closeInstallDialog: onClose,
        appDetailsFromSearchResponse: appDetailsFromSearchResponse,
        instructionalInstallMode: installMode,
        links: links,
        onRendered: onRendered
    }) : (0, $eJGKo.default)({
        closeInstallDialog: onClose,
        context: hostInfo.globalContext,
        defaultInstallMode: installMode,
        hostConfig: hostConfig,
        appDetailsFromSearchResponse: appDetailsFromSearchResponse,
        hostPricing: {
            pending: false,
            result: hostLicense,
            error: null
        },
        installApp: onInstallClick,
        hostInfo: hostInfo,
        links: links,
        mpacBaseUrl: mpacBaseUrl,
        scopesLookup: scopesLookup,
        onRendered: onRendered,
        featureFlags: featureFlags,
        isInstallInProgress: isInstallInProgress,
        forgeAppEgressAddresses: forgeAppEgressAddresses
    });
    const modalDialogContent = /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2dt3P.default), {
        installMode: installMode,
        content: content,
        errorDetails: errorDetails
    });
    const modalDialogFooter = /*#__PURE__*/ (0, $lHkHI.jsx)((0, $05YC4.default), {
        footerLeft: footerLeft,
        footerCenter: footerCenter,
        footerRight: footerRight,
        privacyInformation: privacyInformation
    });
    const getModalDialogHeading = ()=>installMode.type === (0, $k5vUT.INSTRUCTIONAL_INSTALL_MODE) ? 'Installation instructions' : "Add to ".concat(hostConfig.installationLocation);
    return {
        modalDialogHeading: getModalDialogHeading(),
        modalDialogContent: modalDialogContent,
        modalDialogFooter: modalDialogFooter
    };
};
function $c8a22c837d65b323$var$AppInstallDialog(_ref2) {
    let { onClose: onClose, appInstallConfig: appInstallConfig, onInstallClick: _onInstallClick, baseData: baseData, appKey: appKey, onRendered: onRendered, isInstallInProgress: isInstallInProgress } = _ref2;
    const featureFlags = (0, $inwKI.useFeatureFlags)();
    const links = (0, $iEdQ1.useLinkTemplates)({
        adminHubBaseUrl: appInstallConfig.adminHubBaseUrl,
        mpacBaseUrl: appInstallConfig.mpacBaseUrl,
        mpacCdnBaseUrl: appInstallConfig.mpacCdnBaseUrl,
        macBaseUrl: appInstallConfig.macBaseUrl,
        wacBaseUrl: appInstallConfig.wacBaseUrl,
        atlassianCommunityBaseUrl: appInstallConfig.atlassianCommunityBaseUrl
    });
    const appDetailsFromSearchResponse = (0, $9e16A.useGetAppDetailsFromSearch)({
        algoliaConfig: appInstallConfig.algoliaConfig,
        appKey: appKey
    });
    const { modalDialogHeading: modalDialogHeading, modalDialogContent: modalDialogContent, modalDialogFooter: modalDialogFooter } = $c8a22c837d65b323$var$foldPromiseState(baseData, ()=>{
        const content = /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2FaVi.default), {
            icon: "error",
            children: "We ran into a little trouble"
        });
        return {
            modalDialogHeading: 'Error',
            modalDialogContent: content,
            modalDialogFooter: null
        };
    }, ()=>({
            modalDialogHeading: 'Loading...',
            modalDialogContent: null,
            modalDialogFooter: null
        }), (result)=>{
        return $c8a22c837d65b323$var$resolveDialog({
            mpacBaseUrl: appInstallConfig.mpacBaseUrl,
            appInstallBaseData: result,
            links: links,
            onInstallClick: ()=>_onInstallClick(result.appIdentifier),
            onClose: onClose,
            onRendered: onRendered,
            featureFlags: featureFlags,
            isInstallInProgress: isInstallInProgress,
            appDetailsFromSearchResponse: appDetailsFromSearchResponse
        });
    });
    const fallbackUI = /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $l9NvU.default), {
        width: "large",
        onClose: onClose,
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $492R6.default), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gxv5e.default), {
                        children: "Error in App Installation"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                        onClick: onClose,
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($eWXWl))), {
                            label: "Close"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5o6SH.default), {
                children: /*#__PURE__*/ (0, $lHkHI.jsxs)($c8a22c837d65b323$var$FallbackUIContentWrapper, {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)($c8a22c837d65b323$export$7326e6d938a8137b, {
                            alt: "Error",
                            src: (0, (/*@__PURE__*/$parcel$interopDefault($5s4ZL)))
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsxs)($c8a22c837d65b323$var$FallbackUIContent, {
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gEwvS))), {
                                    primaryColor: "var(--ds-icon-danger, ".concat((0, $j0gMm.R400), ")")
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                                    children: "Try again later."
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $beqRW.default), {
        boundaryName: "marketplaceAppInstallDialog",
        fallback: fallbackUI,
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $l9NvU.default), {
            width: "large",
            onClose: onClose,
            testId: (0, $i7RVQ.SELECTORS).TEST_ID_APP_INSTALL_DIALOG,
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $492R6.default), {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gxv5e.default), {
                        children: modalDialogHeading
                    })
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5o6SH.default), {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)($c8a22c837d65b323$var$DialogContentWrapper, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kU8RF.default), {
                            active: baseData.pending,
                            delay: 1000,
                            size: 50,
                            children: modalDialogContent
                        })
                    })
                }),
                modalDialogFooter
            ]
        })
    });
}
var $c8a22c837d65b323$export$2e2bcd8739ae039 = $c8a22c837d65b323$var$AppInstallDialog;

});
parcelRegister("5s4ZL", function(module, exports) {
module.exports = new URL("Tools.65e8a1d6.svg", import.meta.url).toString();

});

parcelRegister("i7RVQ", function(module, exports) {

$parcel$export(module.exports, "SELECTORS", () => $d322b73872530a73$export$6d10441bd0a505b0);
/**
 * DOM Selectors which are used either in pollinators or other scripts
 * outside this repo and should be updated/cleaned up in those consumers
 * before changing here.
 * Ex – `INPUT_NAME_<..>`, `TEST_ID_<..>`, `ID_<...>`, `CLASSNAME_<...>`
 */ const $d322b73872530a73$export$6d10441bd0a505b0 = Object.freeze({
    /** Name of the app install dialog in emcee, used in pollinators */ TEST_ID_APP_INSTALL_DIALOG: 'marketplace-app-install-dialog',
    TEST_ID_CMT_SECTION_MESSAGE: 'marketplace-app-cmt-section-message'
});

});

parcelRegister("2FaVi", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f07e23c3e013e3f$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $3XolV = parcelRequire("3XolV");

var $79jgo = parcelRequire("79jgo");

var $gEwvS = parcelRequire("gEwvS");

var $j0gMm = parcelRequire("j0gMm");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $1f07e23c3e013e3f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1f07e23c3e013e3f$var$BannerAndIconContainer = (0, $3UXZ8.default)("div", {
    target: "e34h9jk0",
    label: "BannerAndIconContainer"
})({
    name: "1uuw7ai",
    styles: "display:flex;margin:10px 0;"
});
const $1f07e23c3e013e3f$var$IconContainer = (0, $3UXZ8.default)("div", {
    target: "e34h9jk1",
    label: "IconContainer"
})("color:", (props)=>props.color, ";flex:0;min-width:32px;");
const $1f07e23c3e013e3f$var$TextContainer = (0, $3UXZ8.default)("div", {
    target: "e34h9jk2",
    label: "TextContainer"
})({
    name: "bbvf7x",
    styles: "flex:1 0 0;padding-top:3px;"
});
class $1f07e23c3e013e3f$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        let Icon;
        let iconColor;
        switch(this.props.icon){
            case 'error':
                Icon = (0, (/*@__PURE__*/$parcel$interopDefault($gEwvS)));
                iconColor = (0, $j0gMm.R300);
                break;
            case 'warning':
                Icon = (0, (/*@__PURE__*/$parcel$interopDefault($79jgo)));
                iconColor = (0, $j0gMm.Y500);
                break;
            case 'success':
                Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3XolV)));
                iconColor = (0, $j0gMm.G300);
                break;
            default:
                console.error("Unknown Icon '".concat(this.props.icon, "', must be error, warning, success. Defaulting to success."));
                Icon = (0, (/*@__PURE__*/$parcel$interopDefault($3XolV)));
                iconColor = (0, $j0gMm.G300);
        }
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($1f07e23c3e013e3f$var$BannerAndIconContainer, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($1f07e23c3e013e3f$var$IconContainer, {
                    color: iconColor,
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)(Icon, {
                        size: "medium",
                        label: this.props.icon
                    })
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($1f07e23c3e013e3f$var$TextContainer, {
                    children: this.props.children
                })
            ]
        });
    }
}

});
parcelRegister("79jgo", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $534850f6eb1eb918$var$_react = $534850f6eb1eb918$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $534850f6eb1eb918$var$_warning = $534850f6eb1eb918$var$_interopRequireDefault((parcelRequire("ftRrI")));
function $534850f6eb1eb918$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $534850f6eb1eb918$var$EditorWarningIcon = (props)=>/*#__PURE__*/ $534850f6eb1eb918$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m13.31 5.343 7.359 13.17A1 1 0 0 1 19.796 20H4.204a1 1 0 0 1-.873-1.488l7.36-13.169a1.5 1.5 0 0 1 2.618 0M12 8.5a1.09 1.09 0 0 0-1.081 1.239l.513 3.766a.573.573 0 0 0 1.136 0l.513-3.766A1.09 1.09 0 0 0 12 8.5m0 8.63a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25"/></svg>`
    }, props, {
        newIcon: $534850f6eb1eb918$var$_warning.default
    }));
$534850f6eb1eb918$var$EditorWarningIcon.displayName = 'EditorWarningIcon';
var $534850f6eb1eb918$var$_default = module.exports.default = $534850f6eb1eb918$var$EditorWarningIcon;

});


parcelRegister("2dt3P", function(module, exports) {

$parcel$export(module.exports, "default", () => $19d3568c2a1cb723$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $kU8RF = parcelRequire("kU8RF");
parcelRequire("eUqFw");

var $i7hUf = parcelRequire("i7hUf");

var $2FaVi = parcelRequire("2FaVi");

var $jooEA = parcelRequire("jooEA");

var $lHkHI = parcelRequire("lHkHI");
function $19d3568c2a1cb723$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $19d3568c2a1cb723$export$f1b333dd56782094 = (0, $3UXZ8.default)("div", {
    target: "ex6c2xf0",
    label: "ErrorHeading"
})({
    name: "in3yi3",
    styles: "font-weight:bold;"
});
const $19d3568c2a1cb723$export$f57711b96c55e5ec = (0, $3UXZ8.default)("div", {
    target: "ex6c2xf1",
    label: "ErrorSubdescription"
})("color:", (0, $j0gMm.N80), ";");
function $19d3568c2a1cb723$export$2e2bcd8739ae039(_ref) {
    let { installMode: installMode, errorDetails: errorDetails, content: content } = _ref;
    /*
   * Need to display the SpinnerMask here rather than in the individual install dialogs' content
   * so that we can ensure that we end the spinner animation cleanly.
   */ return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $kU8RF.default), {
        active: (0, $i7hUf.foldInstallMode)(installMode)((determiningInstallMode)=>!determiningInstallMode.error, ()=>false, ()=>false, ()=>false, ()=>false, ()=>false),
        delay: 1000,
        size: 50,
        children: [
            errorDetails.map((ec)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
                (0, $lHkHI.jsx)((0, $2FaVi.default), {
                    icon: "error",
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jooEA.default), {
                        errorDetails: ec
                    })
                })).orNull(),
            content
        ]
    });
}

});
parcelRegister("jooEA", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1e361ec2421ea2e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $e1e361ec2421ea2e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e1e361ec2421ea2e$export$f1b333dd56782094 = (0, $3UXZ8.default)("div", {
    target: "e1lynmon0",
    label: "ErrorHeading"
})({
    name: "in3yi3",
    styles: "font-weight:bold;"
});
const $e1e361ec2421ea2e$export$f57711b96c55e5ec = (0, $3UXZ8.default)("div", {
    target: "e1lynmon1",
    label: "ErrorSubdescription"
})("color:", (0, $j0gMm.N80), ";");
class $e1e361ec2421ea2e$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($e1e361ec2421ea2e$export$f1b333dd56782094, {
                        children: this.props.errorDetails.translation.title
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                        children: this.props.errorDetails.translation.description
                    }),
                    this.props.errorDetails.translation.showTID ? /*#__PURE__*/ (0, $lHkHI.jsxs)($e1e361ec2421ea2e$export$f57711b96c55e5ec, {
                        children: [
                            "TID: ",
                            this.props.errorDetails.tid,
                            ", Type: ",
                            this.props.errorDetails.type
                        ]
                    }) : null
                ]
            }));
    }
}

});


parcelRegister("05YC4", function(module, exports) {

$parcel$export(module.exports, "default", () => $0004a30948cdcacf$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $0004a30948cdcacf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0004a30948cdcacf$export$651095642c93be3d = (0, $3UXZ8.default)("div", {
    target: "e8pyone0",
    label: "FooterContainer"
})("border-top:2px solid ", "var(--ds-border, ".concat((0, $j0gMm.N30), ")"), ";display:flex;padding:25px var(--ds-space-250, 20px);align-items:center;");
const $0004a30948cdcacf$export$ebe8d15c5d116a5d = (0, $3UXZ8.default)("div", {
    target: "e8pyone1",
    label: "FooterCenterContainer"
})({
    name: "ydhtu0",
    styles: "display:flex;flex:1 0 auto;margin:0 var(--ds-space-200, 16px);"
});
const $0004a30948cdcacf$export$ffda048559b3b0a4 = (0, $3UXZ8.default)("div", {
    target: "e8pyone2",
    label: "FooterItemInner"
})({
    name: "1d3j0nz",
    styles: "flex:1;margin:auto 0;"
});
function $0004a30948cdcacf$export$2e2bcd8739ae039(_ref) {
    let { footerLeft: footerLeft, footerCenter: footerCenter, footerRight: footerRight, privacyInformation: privacyInformation } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            privacyInformation,
            /*#__PURE__*/ (0, $lHkHI.jsxs)($0004a30948cdcacf$export$651095642c93be3d, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)($0004a30948cdcacf$export$ffda048559b3b0a4, {
                            children: footerLeft
                        })
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($0004a30948cdcacf$export$ebe8d15c5d116a5d, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)($0004a30948cdcacf$export$ffda048559b3b0a4, {
                            children: footerCenter
                        })
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)($0004a30948cdcacf$export$ffda048559b3b0a4, {
                            children: footerRight
                        })
                    })
                ]
            })
        ]
    });
}

});

parcelRegister("eJGKo", function(module, exports) {

$parcel$export(module.exports, "default", () => $aba66d62ff33ccf7$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
parcelRequire("eUqFw");

var $gIQkA = parcelRequire("gIQkA");

var $9eIgo = parcelRequire("9eIgo");

var $hsaiM = parcelRequire("hsaiM");

var $dvM4B = parcelRequire("dvM4B");

var $1BmPt = parcelRequire("1BmPt");

var $jnM8o = parcelRequire("jnM8o");

var $2bemU = parcelRequire("2bemU");

var $lgdWX = parcelRequire("lgdWX");

var $8vnXh = parcelRequire("8vnXh");

var $4LsDF = parcelRequire("4LsDF");

var $lHkHI = parcelRequire("lHkHI");
const $aba66d62ff33ccf7$var$resolveDialogDefault = // eslint-disable-next-line max-lines-per-function
(_ref)=>{
    let { closeInstallDialog: closeInstallDialog, context: context, defaultInstallMode: defaultInstallMode, hostConfig: hostConfig, appDetailsFromSearchResponse: appDetailsFromSearchResponse, hostInfo: hostInfo, hostPricing: hostPricing, installApp: installApp, links: links, scopesLookup: scopesLookup, mpacBaseUrl: mpacBaseUrl, onRendered: onRendered, featureFlags: featureFlags, isInstallInProgress: isInstallInProgress, forgeAppEgressAddresses: forgeAppEgressAddresses } = _ref;
    return {
        analyticsSourceModal: defaultInstallMode.installPermission.fold(()=>(0, $gIQkA.ANALYTICS_MODAL_NO_INSTALL_PERMISSION), ()=>(0, $gIQkA.ANALYTICS_MODAL_INSTALL)),
        content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4LsDF.default), {
            hostPricing: hostPricing,
            installableApp: defaultInstallMode.installableApp,
            installedApp: defaultInstallMode.installedApp,
            links: links,
            appDetailsFromSearchResponse: appDetailsFromSearchResponse,
            scopesLookup: scopesLookup,
            mpacBaseUrl: mpacBaseUrl,
            onRendered: onRendered,
            forgeAppEgressAddresses: forgeAppEgressAddresses
        }),
        heading: "Add to ".concat(hostConfig.installationLocation),
        footerLeft: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jnM8o.default), {
            context: context,
            marketplaceAppDetails: defaultInstallMode.installableApp.marketplaceAppDetails,
            links: links
        }),
        footerCenter: defaultInstallMode.installedApp.fold(()=>defaultInstallMode.installPermission.fold(()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $1BmPt.default), {}), ()=>null), ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $2bemU.default), {
                hostConfig: hostConfig
            })),
        privacyInformation: defaultInstallMode.installedApp.fold(()=>defaultInstallMode.installPermission.fold(()=>null, ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $8vnXh.default), {
                    context: context,
                    installableAppId: defaultInstallMode.installableAppId,
                    links: links,
                    marketplaceAppDetails: defaultInstallMode.installableApp.marketplaceAppDetails
                })), ()=>null),
        footerRight: defaultInstallMode.installPermission.fold((_)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $dvM4B.default), {
                onClick: closeInstallDialog
            }), (_)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $lgdWX.default), {
                closeInstallDialog: closeInstallDialog,
                context: context,
                hostConfig: hostConfig,
                installableAppInstallMode: defaultInstallMode,
                installApp: installApp,
                hostInfo: hostInfo,
                mpacBaseUrl: mpacBaseUrl,
                isInstallInProgress: isInstallInProgress
            })),
        preventDialogClosing: (0, $9eIgo.isInstallStatusLoading)(defaultInstallMode.status),
        errorDetails: (0, $9eIgo.foldInstallStatus)(defaultInstallMode.status, ()=>(0, $bWAru.Option).empty(), ()=>(0, $bWAru.Option).empty(), (complete)=>complete.result.fold((error)=>(0, $bWAru.Option).some((0, $hsaiM.getErrorDetails)(error, hostConfig, {
                    showCustomBackendErrorsFromUpm: featureFlags.showCustomBackendErrorsFromUpm
                })), ()=>(0, $bWAru.Option).empty()))
    };
};
var $aba66d62ff33ccf7$export$2e2bcd8739ae039 = $aba66d62ff33ccf7$var$resolveDialogDefault;

});
parcelRegister("dvM4B", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d6375f87d7adde2$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $eamSf = parcelRequire("eamSf");

var $lHkHI = parcelRequire("lHkHI");
class $9d6375f87d7adde2$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $eamSf.SecondaryCTAWithAnalytics), {
                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_INSTALL_CLOSE),
                isDisabled: false,
                onClick: this.props.onClick,
                children: "Close"
            }));
    }
}

});
parcelRegister("eamSf", function(module, exports) {

$parcel$export(module.exports, "default", () => $a503be23a84b5dbc$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SecondaryCTAWithAnalytics", () => $a503be23a84b5dbc$export$56331e51db449374);

var $5zQU9 = parcelRequire("5zQU9");

var $9oiuL = parcelRequire("9oiuL");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
class $a503be23a84b5dbc$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                isDisabled: this.props.isDisabled,
                appearance: "subtle-link",
                onClick: this.props.onClick,
                children: this.props.children
            }));
    }
}
(0, $5zQU9.default)($a503be23a84b5dbc$export$2e2bcd8739ae039, "defaultProps", {
    isDisabled: false
});
class $a503be23a84b5dbc$export$e784f0e8b7a89e69 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onClick", ()=>{
            this.props.fireAnalyticsEvent({
                eventType: (0, $gaiog.ButtonClickedEvent),
                actionSubjectId: this.props.actionSubjectId
            });
            this.props.onClick();
        });
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)($a503be23a84b5dbc$export$2e2bcd8739ae039, {
                isDisabled: this.props.isDisabled,
                onClick: this.onClick,
                children: this.props.children
            }));
    }
}
const $a503be23a84b5dbc$export$56331e51db449374 = (0, $9osuT.withAnalytics)($a503be23a84b5dbc$export$e784f0e8b7a89e69);

});


parcelRegister("1BmPt", function(module, exports) {

$parcel$export(module.exports, "default", () => $12aaf48f770e385c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $eUqFw = parcelRequire("eUqFw");

var $60WbV = parcelRequire("60WbV");

var $lHkHI = parcelRequire("lHkHI");
function $12aaf48f770e385c$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $12aaf48f770e385c$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $60WbV.default), {
    target: "eku53uu0",
    label: "Container"
})({
    name: "xi606m",
    styles: "text-align:center;"
});
class $12aaf48f770e385c$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)($12aaf48f770e385c$export$42a852a2b6b56249, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $60WbV.BoldHeader), {
                        children: "Want this app?"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                        children: "Please contact your site administrator."
                    })
                ]
            }));
    }
}

});
parcelRegister("60WbV", function(module, exports) {

$parcel$export(module.exports, "BoldHeader", () => $460fe1c3fe98c862$export$3b6bea7d20e57bcc);
$parcel$export(module.exports, "default", () => $460fe1c3fe98c862$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");
function $460fe1c3fe98c862$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $460fe1c3fe98c862$export$3b6bea7d20e57bcc = (0, $3UXZ8.default)("div", {
    target: "exk6e660",
    label: "BoldHeader"
})({
    name: "in3yi3",
    styles: "font-weight:bold;"
});
var $460fe1c3fe98c862$export$2e2bcd8739ae039 = (0, $3UXZ8.default)("div", {
    target: "exk6e661"
})({
    name: "hhlnwx",
    styles: "font-size:11px;line-height:1.2;margin-left:auto;text-align:right;"
});

});


parcelRegister("jnM8o", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c580cb71eac65f$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $l501X = parcelRequire("l501X");

var $eUqFw = parcelRequire("eUqFw");

var $8KCrk = parcelRequire("8KCrk");

var $7Uh51 = parcelRequire("7Uh51");

var $ifMZN = parcelRequire("ifMZN");

var $lHkHI = parcelRequire("lHkHI");
const $e1c580cb71eac65f$export$d3c6d76fe0bcbd = /*#__PURE__*/ (0, $3UXZ8.default)((0, $l501X.default), {
    target: "e1e9elcm0",
    label: "AppDetailsExternalLink"
})("font-weight:400;font-size:14px;color:", "var(--ds-link, ".concat((0, $j0gMm.B400), ")"), ";");
class $e1c580cb71eac65f$export$67af75784bc0a345 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onClick", ()=>{
            this.props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstallableAppIdentifier)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_VIEW_APP_DETAILS), (0, $ifMZN.makeInstallableAppByKeyIdentifier)({
                key: this.props.marketplaceAppDetails.key
            })).toObject());
        });
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)($e1c580cb71eac65f$export$d3c6d76fe0bcbd, {
                href: this.props.links.appDetails.expand({
                    appKey: this.props.marketplaceAppDetails.key
                }),
                onClick: this.onClick,
                children: "App Info"
            }));
    }
}
var $e1c580cb71eac65f$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($e1c580cb71eac65f$export$67af75784bc0a345);

});
parcelRegister("8KCrk", function(module, exports) {

$parcel$export(module.exports, "makeAnalyticsForInstallableAppIdentifier", () => $65f06fecbeee8532$export$e8a3862ff6e101fd);
$parcel$export(module.exports, "makeAnalyticsForInstalledApp", () => $65f06fecbeee8532$export$33836459a61b055c);

var $5zQU9 = parcelRequire("5zQU9");

var $dKnCb = parcelRequire("dKnCb");

var $lQqqi = parcelRequire("lQqqi");

var $ifMZN = parcelRequire("ifMZN");

var $iEgm6 = parcelRequire("iEgm6");

var $7Uh51 = parcelRequire("7Uh51");
function $65f06fecbeee8532$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $65f06fecbeee8532$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $65f06fecbeee8532$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $65f06fecbeee8532$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $65f06fecbeee8532$export$e8a3862ff6e101fd(eventType, actionSubjectId, installableAppId, extraAttributes) {
    return (0, $dKnCb.makeAnalyticsData)({
        eventType: eventType,
        actionSubjectId: actionSubjectId,
        objectType: 'app',
        objectId: (0, $ifMZN.foldInstallableAppIdentifier)(installableAppId)((installableAppByKeyId)=>installableAppByKeyId.key, (installableAppByUrlId)=>installableAppByUrlId.url, (installableAppByARI)=>installableAppByARI.appKey),
        attributes: extraAttributes,
        category: (0, $7Uh51.ANALYTICS_CATEGORY_NAVIGATION)
    });
}
function $65f06fecbeee8532$export$33836459a61b055c(eventType, actionSubjectId, installedApp, extraAttributes) {
    return (0, $lQqqi.foldAuthType)(installedApp.authType)((_)=>(0, $dKnCb.makeAnalyticsData)({
            eventType: eventType,
            actionSubjectId: actionSubjectId,
            objectType: 'token',
            attributes: $65f06fecbeee8532$var$_objectSpread($65f06fecbeee8532$var$_objectSpread({}, extraAttributes), {}, {
                authType: 'token'
            }),
            category: (0, $7Uh51.ANALYTICS_CATEGORY_NAVIGATION)
        }), (_)=>(0, $dKnCb.makeAnalyticsData)({
            eventType: eventType,
            actionSubjectId: actionSubjectId,
            objectType: 'app',
            objectId: installedApp.details.key,
            attributes: $65f06fecbeee8532$var$_objectSpread($65f06fecbeee8532$var$_objectSpread({}, extraAttributes), {}, {
                name: (0, $iEgm6.resolveFieldWithFallback)((add)=>add.name, installedApp.marketplaceAppDetails, installedApp.details),
                oauthClientId: installedApp.details.metadata.oauthClientId,
                authType: '2LO'
            }),
            category: (0, $7Uh51.ANALYTICS_CATEGORY_NAVIGATION)
        }), (_)=>(0, $dKnCb.makeAnalyticsData)({
            eventType: eventType,
            actionSubjectId: actionSubjectId,
            objectType: 'app',
            objectId: installedApp.details.key,
            attributes: $65f06fecbeee8532$var$_objectSpread($65f06fecbeee8532$var$_objectSpread({}, extraAttributes), {}, {
                name: (0, $iEgm6.resolveFieldWithFallback)((add)=>add.name, installedApp.marketplaceAppDetails, installedApp.details),
                oauthClientId: installedApp.details.metadata.oauthClientId,
                authType: '3LO'
            }),
            category: (0, $7Uh51.ANALYTICS_CATEGORY_NAVIGATION)
        }));
}

});
parcelRegister("dKnCb", function(module, exports) {

$parcel$export(module.exports, "makeAnalyticsData", () => $a021e3a4fe2b65f6$export$4481143bd398ebbf);

var $g5DHJ = parcelRequire("g5DHJ");

var $gaiog = parcelRequire("gaiog");
const $a021e3a4fe2b65f6$var$defaultAnalyticsDataProps = {
    eventType: (0, $gaiog.ButtonClickedEvent),
    actionSubjectId: '',
    attributes: undefined,
    category: undefined,
    containerId: undefined,
    containerType: undefined,
    objectId: undefined,
    objectType: undefined,
    tags: undefined
};
const $a021e3a4fe2b65f6$var$defaultAnalyticsData = (0, $g5DHJ.Record)($a021e3a4fe2b65f6$var$defaultAnalyticsDataProps);
const $a021e3a4fe2b65f6$export$4481143bd398ebbf = (a)=>$a021e3a4fe2b65f6$var$defaultAnalyticsData(a);

});



parcelRegister("2bemU", function(module, exports) {

$parcel$export(module.exports, "default", () => $1967c128e47ba144$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $60WbV = parcelRequire("60WbV");

var $lHkHI = parcelRequire("lHkHI");
class $1967c128e47ba144$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $60WbV.default), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $60WbV.BoldHeader), {
                    children: "We're seeing double!"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                    children: [
                        "This app is already added to ",
                        this.props.hostConfig.installationLocation,
                        "."
                    ]
                })
            ]
        });
    }
}

});

parcelRegister("lgdWX", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7a5e9bdf7a06a8c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $buxnS = parcelRequire("buxnS");

var $g01ln = parcelRequire("g01ln");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
parcelRequire("eUqFw");

var $8KCrk = parcelRequire("8KCrk");

var $7Uh51 = parcelRequire("7Uh51");

var $2BZA2 = parcelRequire("2BZA2");

var $9eIgo = parcelRequire("9eIgo");

var $f6zt8 = parcelRequire("f6zt8");

var $9KoF2 = parcelRequire("9KoF2");

var $lHkHI = parcelRequire("lHkHI");
function $f7a5e9bdf7a06a8c$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f7a5e9bdf7a06a8c$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f7a5e9bdf7a06a8c$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f7a5e9bdf7a06a8c$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f7a5e9bdf7a06a8c$var$MANUAL_URL_PRIMARY_CTA_LABEL = 'Get it now';
const $f7a5e9bdf7a06a8c$var$FREE_PRIMARY_CTA_LABEL = 'Get it now';
const $f7a5e9bdf7a06a8c$var$PAID_PRIMARY_CTA_LABEL = 'Start free trial';
const $f7a5e9bdf7a06a8c$var$ADD_TO_SANDBOX_CTA_LABEL = 'Add to sandbox';
const $f7a5e9bdf7a06a8c$var$CLOUD_MIGRATION_TRIAL_CTA_LABEL = 'Activate trial';
const $f7a5e9bdf7a06a8c$export$7afaf246bc005f03 = (props)=>{
    const installApp = (installableApp, installableAppId, label, relayState)=>()=>{
            const ecosystemCloudAppId = installableApp.marketplaceAppDetails.ecosystemCloudAppId;
            const installAppArgs = {
                context: props.context,
                hostConfig: props.hostConfig,
                hostInfo: props.hostInfo,
                installableApp: installableApp,
                installableAppId: installableAppId,
                relayState: relayState
            };
            props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstallableAppIdentifier)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_INSTALL), installableAppId, $f7a5e9bdf7a06a8c$var$_objectSpread($f7a5e9bdf7a06a8c$var$_objectSpread({
                label: label
            }, ecosystemCloudAppId && {
                isEcosystemCloudApp: true,
                ecosystemCloudAppId: ecosystemCloudAppId
            }), {}, {
                hasCloudFortifiedBadge: (0, $f6zt8.isInstallableAppCloudFortified)(installableApp)
            })).toObject());
            props.installApp(installAppArgs);
        };
    const onClickAlreadyInstalledCTA = (installableAppId, label, url)=>()=>{
            props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstallableAppIdentifier)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_ALREADY_INSTALLED_CTA), installableAppId, {
                label: label
            }).toObject());
            (0, $g01ln).openPage(url, '_top');
        };
    const resolveAlreadyInstalledPrimaryCTALink = (installedApp)=>{
        let ctaLink;
        if (installedApp.getStartedUrl) ctaLink = {
            label: 'Get started',
            url: installedApp.getStartedUrl
        };
        else if (installedApp.configureUrl) ctaLink = {
            label: 'Configure',
            url: installedApp.configureUrl
        };
        else if (installedApp.manageAppUrl) ctaLink = {
            label: 'Manage app',
            url: installedApp.manageAppUrl
        };
        return (0, $bWAru.Option).of(ctaLink);
    };
    const resolveDefaultPrimaryCTAText = (defaultInstallMode)=>{
        if (defaultInstallMode.installableApp.eligibleForFreeOnSandbox) return $f7a5e9bdf7a06a8c$var$ADD_TO_SANDBOX_CTA_LABEL;
        if ((0, $buxnS.isFreeApp)(defaultInstallMode.installableApp.marketplaceAppDetails.paymentModel)) return $f7a5e9bdf7a06a8c$var$FREE_PRIMARY_CTA_LABEL;
        if (defaultInstallMode.installableApp.cloudMigrationTrial.isEligible) return $f7a5e9bdf7a06a8c$var$CLOUD_MIGRATION_TRIAL_CTA_LABEL;
        return $f7a5e9bdf7a06a8c$var$PAID_PRIMARY_CTA_LABEL;
    };
    const resolveConfirmCancelForAppByKey = (installableAppDefault, isPrimaryDisabled, isInstallInProgress)=>{
        const primaryCTALabel = resolveDefaultPrimaryCTAText(installableAppDefault);
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9KoF2.default), {
            closeInstallDialog: props.closeInstallDialog,
            isLoading: isInstallInProgress(),
            isPrimaryDisabled: isPrimaryDisabled,
            onPrimaryCTAClick: installApp(installableAppDefault.installableApp, installableAppDefault.installableAppId, primaryCTALabel, installableAppDefault.relayState),
            primaryCTALabel: primaryCTALabel,
            primaryButtonId: "install-app-dialog__install-confirm-btn" // used in pollinator test
        });
    };
    const resolveConfirmCancelForAppByUrl = (installableAppByManualUrl, isPrimaryDisabled)=>installableAppByManualUrl.installableApp.flatMap((ia)=>ia.toOption()).map((ia)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
            (0, $lHkHI.jsx)((0, $9KoF2.default), {
                closeInstallDialog: props.closeInstallDialog,
                isLoading: (0, $9eIgo.isInstallStatusLoading)(installableAppByManualUrl.status),
                isPrimaryDisabled: isPrimaryDisabled,
                onPrimaryCTAClick: installApp(ia, installableAppByManualUrl.installableAppByUrlId, $f7a5e9bdf7a06a8c$var$MANUAL_URL_PRIMARY_CTA_LABEL),
                primaryCTALabel: $f7a5e9bdf7a06a8c$var$MANUAL_URL_PRIMARY_CTA_LABEL
            }));
    return (0, $2BZA2.foldInstallInstallableAppInstallMode)(props.installableAppInstallMode)((installableAppDefault)=>installableAppDefault.installedApp.fold(()=>resolveConfirmCancelForAppByKey(installableAppDefault, false, props.isInstallInProgress), (ia)=>resolveAlreadyInstalledPrimaryCTALink(ia).map((cta)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
                (0, $lHkHI.jsx)((0, $9KoF2.default), {
                    closeInstallDialog: props.closeInstallDialog,
                    isLoading: false,
                    isPrimaryDisabled: false,
                    onPrimaryCTAClick: onClickAlreadyInstalledCTA(installableAppDefault.installableAppId, cta.label, cta.url),
                    primaryCTALabel: cta.label
                })).getOrElseL(()=>resolveConfirmCancelForAppByKey(installableAppDefault, true, props.isInstallInProgress))), (installableAppByManualUrl)=>installableAppByManualUrl.installableAppByManualUrl.flatMap((iabmu)=>iabmu.installedApp.fold(()=>resolveConfirmCancelForAppByUrl(iabmu, false), (ia)=>resolveAlreadyInstalledPrimaryCTALink(ia).map((cta)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
                    (0, $lHkHI.jsx)((0, $9KoF2.default), {
                        closeInstallDialog: props.closeInstallDialog,
                        isLoading: false,
                        isPrimaryDisabled: false,
                        onPrimaryCTAClick: onClickAlreadyInstalledCTA(iabmu.installableAppByUrlId, cta.label, cta.url),
                        primaryCTALabel: cta.label
                    })).orElseL(()=>resolveConfirmCancelForAppByUrl(iabmu, true)))).getOrElseL(()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $9KoF2.default), {
                closeInstallDialog: props.closeInstallDialog,
                isLoading: false,
                isPrimaryDisabled: true,
                primaryCTALabel: $f7a5e9bdf7a06a8c$var$MANUAL_URL_PRIMARY_CTA_LABEL
            })));
};
var $f7a5e9bdf7a06a8c$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($f7a5e9bdf7a06a8c$export$7afaf246bc005f03);

});
parcelRegister("buxnS", function(module, exports) {

$parcel$export(module.exports, "FREE_PRICING", () => $85dc64769961e885$export$16444ae3d9981448);
$parcel$export(module.exports, "PAID_PRICING", () => $85dc64769961e885$export$4ef8826da1f1ebe6);
$parcel$export(module.exports, "isFreeApp", () => $85dc64769961e885$export$58b14254be35765b);
$parcel$export(module.exports, "foldPaymentModel", () => $85dc64769961e885$export$78cb43db1b1a42b1);

var $gC8Po = parcelRequire("gC8Po");
const $85dc64769961e885$export$16444ae3d9981448 = 'FREE';
const $85dc64769961e885$export$4ef8826da1f1ebe6 = 'PAID';
const $85dc64769961e885$export$58b14254be35765b = (p)=>p === 'free';
const $85dc64769961e885$export$78cb43db1b1a42b1 = (p)=>(free, atlassian, vendor)=>{
        switch(p){
            case 'atlassian':
                return atlassian();
            case 'free':
                return free();
            case 'vendor':
                return vendor();
            default:
                throw (0, $gC8Po.default).unexpectedCase(p);
        }
    };

});

parcelRegister("2BZA2", function(module, exports) {

$parcel$export(module.exports, "foldInstallInstallableAppInstallMode", () => $1e6ece0c6760f697$export$3594cec58e92bc36);

var $249j9 = parcelRequire("249j9");

var $4s0An = parcelRequire("4s0An");
function $1e6ece0c6760f697$export$3594cec58e92bc36(installableAppInstallMode) {
    return function foldInstallInstallableAppInstallModeInner(installableAppDefault, installableAppByManualUrl) {
        switch(installableAppInstallMode.type){
            case 0, $4s0An.INSTALLABLE_APP_DEFAULT_INSTALL_MODE:
                return installableAppDefault(installableAppInstallMode);
            case 0, $249j9.INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE:
                return installableAppByManualUrl(installableAppInstallMode);
            default:
                // Flow compile-time validation that we've handled every discover item
                // prettier-ignore
                installableAppInstallMode;
                return undefined;
        }
    };
}

});

parcelRegister("f6zt8", function(module, exports) {

$parcel$export(module.exports, "isInstallableAppCloudFortified", () => $aff2edf57b11cb5e$export$91ec17b5900e958f);

var $kafab = parcelRequire("kafab");
const $aff2edf57b11cb5e$export$91ec17b5900e958f = (installableApp)=>installableApp.marketplaceAppDetails.getIn([
        'programs',
        'cloudFortified',
        'status'
    ]) === (0, $kafab.CloudFortifiedStatusValues).Approved;

});

parcelRegister("9KoF2", function(module, exports) {

$parcel$export(module.exports, "default", () => $718b8a15a62c51ee$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $9goJJ = parcelRequire("9goJJ");

var $bPByu = parcelRequire("bPByu");

var $eUqFw = parcelRequire("eUqFw");

var $h6MeC = parcelRequire("h6MeC");

var $lHkHI = parcelRequire("lHkHI");
class $718b8a15a62c51ee$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)((0, $9goJJ.default), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bPByu.default), {
                        isLoading: this.props.isLoading,
                        isDisabled: this.props.isPrimaryDisabled,
                        onClick: this.props.onPrimaryCTAClick,
                        buttonId: this.props.primaryButtonId,
                        children: this.props.primaryCTALabel
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $h6MeC.default), {
                        isDisabled: this.props.isLoading,
                        onClick: this.props.closeInstallDialog,
                        children: "Cancel"
                    })
                ]
            }));
    }
}
(0, $5zQU9.default)($718b8a15a62c51ee$export$2e2bcd8739ae039, "defaultProps", {
    isPrimaryDisabled: false
});

});
parcelRegister("9goJJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be8cbd7a5aa8b5f$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 */ /** @jsx jsx */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
const $6be8cbd7a5aa8b5f$var$buttonGroupStyles = (0, $byn9U.css)({
    display: 'inline-flex',
    gap: "var(--ds-space-050, 4px)",
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '> *': {
        flex: '1 0 auto'
    }
});
function $6be8cbd7a5aa8b5f$export$2e2bcd8739ae039({ appearance: appearance, children: children, testId: testId, label: label, titleId: titleId }) {
    return (0, $byn9U.jsx)("div", {
        css: $6be8cbd7a5aa8b5f$var$buttonGroupStyles,
        "data-testid": testId,
        role: "group",
        "aria-label": label,
        "aria-labelledby": titleId
    }, (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.map((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Children.toArray(children), (child, idx)=>{
        if (!child) return null;
        return (0, $byn9U.jsx)((0, $eUqFw.Fragment), {
            key: idx
        }, appearance ? /*#__PURE__*/ // eslint-disable-next-line @repo/internal/react/no-clone-element
        (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).cloneElement(child, {
            appearance: appearance
        }) : child);
    }));
}

});

parcelRegister("bPByu", function(module, exports) {

$parcel$export(module.exports, "default", () => $02390ed1d3838c59$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $cQKn6 = parcelRequire("cQKn6");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $02390ed1d3838c59$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $02390ed1d3838c59$export$1efc9061e8e8902f = (0, $3UXZ8.default)("div", {
    target: "eewegni0",
    label: "PrimaryCTAContainer"
})({
    name: "17gow3k",
    styles: "min-width:106px;"
});
class $02390ed1d3838c59$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)($02390ed1d3838c59$export$1efc9061e8e8902f, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cQKn6.default), {
                    appearance: "primary",
                    href: this.props.href,
                    isLoading: this.props.isLoading,
                    isDisabled: this.props.isDisabled,
                    onClick: this.props.onClick,
                    shouldFitContainer: true,
                    id: this.props.buttonId,
                    testId: this.props.testId,
                    children: this.props.children
                })
            }));
    }
}
(0, $5zQU9.default)($02390ed1d3838c59$export$2e2bcd8739ae039, "propTypes", {
    children: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node.isRequired,
    href: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    isLoading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func
});
(0, $5zQU9.default)($02390ed1d3838c59$export$2e2bcd8739ae039, "defaultProps", {
    isDisabled: false,
    isLoading: false
});

});
parcelRegister("cQKn6", function(module, exports) {

$parcel$export(module.exports, "default", () => $95ae4fc9520c42ab$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $9oiuL = parcelRequire("9oiuL");

var $5nZDj = parcelRequire("5nZDj");
/**
 * __Loading button__
 *
 * CAUTION: Legacy loading buttons will soon be deprecated. Please use the new Button components from `@atlaskit/button/new` with the `isLoading` prop.
 *
 * A small wrapper around Button that allows you to show an @atlaskit/spinner as an overlay on the button when you set an isLoading prop to true.
 *
 * - [Examples](https://atlassian.design/components/button/examples#loading-button)
 */ const $95ae4fc9520c42ab$var$LoadingButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef(function LoadingButton({ appearance: appearance, isDisabled: isDisabled, isSelected: isSelected, isLoading: isLoading = false, spacing: spacing, ...rest }, ref) {
    // Button already has React.memo, so just leaning on that
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $9oiuL.default), (0, $kU09D.default)({}, rest, {
        ref: ref,
        appearance: appearance,
        "aria-disabled": isLoading || undefined,
        isDisabled: isDisabled,
        isSelected: isSelected,
        overlay: isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5nZDj.default), {
            spacing: spacing,
            appearance: appearance,
            isDisabled: isDisabled,
            isSelected: isSelected
        }) : null,
        spacing: spacing
    }));
});
// Tools including enzyme rely on components having a display name
$95ae4fc9520c42ab$var$LoadingButton.displayName = 'LoadingButton';
var $95ae4fc9520c42ab$export$2e2bcd8739ae039 = $95ae4fc9520c42ab$var$LoadingButton;

});


parcelRegister("h6MeC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c74869a01a50e9b4$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $eamSf = parcelRequire("eamSf");

var $lHkHI = parcelRequire("lHkHI");
function $c74869a01a50e9b4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c74869a01a50e9b4$export$2fa8dd9cd9f42da9 = (0, $3UXZ8.default)("div", {
    target: "e16wejgc0",
    label: "CancelButtonContainer"
})({
    name: "vxcmzt",
    styles: "display:inline-flex;"
});
class $c74869a01a50e9b4$export$bf56b42dddb5cdfe extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)($c74869a01a50e9b4$export$2fa8dd9cd9f42da9, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eamSf.SecondaryCTAWithAnalytics), {
                    actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_INSTALL_CANCEL),
                    isDisabled: this.props.isDisabled,
                    onClick: this.props.onClick,
                    children: "Cancel"
                })
            }));
    }
}
var $c74869a01a50e9b4$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($c74869a01a50e9b4$export$bf56b42dddb5cdfe);

});



parcelRegister("8vnXh", function(module, exports) {

$parcel$export(module.exports, "default", () => $6313ccf24adc6de1$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $l501X = parcelRequire("l501X");

var $eUqFw = parcelRequire("eUqFw");

var $8KCrk = parcelRequire("8KCrk");

var $7Uh51 = parcelRequire("7Uh51");

var $lHkHI = parcelRequire("lHkHI");
const $6313ccf24adc6de1$export$42a852a2b6b56249 = (0, $3UXZ8.default)("div", {
    target: "ed46tot0",
    label: "Container"
})("background-color:", "var(--ds-background-accent-gray-subtlest, ".concat((0, $j0gMm.N20), ")"), ";padding:10px var(--ds-space-250, 20px);font-size:11px;line-height:1.5;");
const $6313ccf24adc6de1$var$manageLogAccessLink = 'https://support.atlassian.com/security-and-access-policies/docs/manage-your-users-third-party-apps';
class $6313ccf24adc6de1$export$c559aa613c1114c extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "privacyPolicyAnalytics", ()=>this.fireLinkUIAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_PRIVACY_POLICY)));
        (0, $5zQU9.default)(this, "eulaAnalytics", ()=>this.fireLinkUIAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_TERMS_OF_USE)));
        (0, $5zQU9.default)(this, "manageLogAccessAnalytics", ()=>this.fireLinkUIAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_LOG_ACCESS)));
        (0, $5zQU9.default)(this, "marketplaceTermsOfUseAnalytics", ()=>this.fireLinkUIAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_MARKETPLACE_TERMS_OF_USE)));
        (0, $5zQU9.default)(this, "fireLinkUIAnalyticsEvent", (actionSubjectId)=>this.props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstallableAppIdentifier)((0, $gaiog.ButtonClickedEvent), actionSubjectId, this.props.installableAppId).toObject()));
        (0, $5zQU9.default)(this, "marketplaceTermsOfUse", (appName, links)=>/*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsxs)("li", {
                        children: [
                            "permit Atlassian to share anonymized data with ",
                            appName
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)("li", {
                        children: [
                            "agree to Atlassian Marketplace's",
                            ' ',
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                                href: links.marketplaceTermsOfUse.expand({}),
                                onClick: this.marketplaceTermsOfUseAnalytics,
                                children: "terms of use"
                            })
                        ]
                    })
                ]
            }));
        (0, $5zQU9.default)(this, "vendorTermsOfUse", (vendorName, eula, privacyPolicy)=>/*#__PURE__*/ (0, $lHkHI.jsxs)("li", {
                children: [
                    "agree to ",
                    vendorName,
                    "'s",
                    ' ',
                    eula ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                        href: eula,
                        onClick: this.eulaAnalytics,
                        children: "terms of use"
                    }) : null,
                    eula && privacyPolicy ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
                        children: " and "
                    }) : null,
                    privacyPolicy ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                        href: privacyPolicy,
                        onClick: this.privacyPolicyAnalytics,
                        children: "privacy policy"
                    }) : null
                ]
            }));
        (0, $5zQU9.default)(this, "forgeManageLogAccess", (vendorName, links)=>/*#__PURE__*/ (0, $lHkHI.jsxs)("li", {
                children: [
                    "agree to enabling ",
                    vendorName,
                    "'s access to log data for this app. You can",
                    ' ',
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                        href: $6313ccf24adc6de1$var$manageLogAccessLink,
                        onClick: this.manageLogAccessAnalytics,
                        children: "disable this access, or download logs"
                    }),
                    ' ',
                    "at any time, from",
                    ' ',
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                        href: links.adminHub.expand({}),
                        children: "admin.atlassian.com"
                    })
                ]
            }));
        (0, $5zQU9.default)(this, "termsOfUseMsg", (links, marketplaceAppDetails)=>{
            const { eula: eula, isConnectApp: isConnectApp, name: appName, privacyPolicy: privacyPolicy, vendor: { name: vendorName } } = marketplaceAppDetails;
            const marketplaceTermsOfUsePolicy = this.marketplaceTermsOfUse(appName, links);
            const vendorTermsOfUsePolicy = this.vendorTermsOfUse(vendorName, eula, privacyPolicy);
            const forgeManageLogAccessPolicy = this.forgeManageLogAccess(vendorName, links);
            return /*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
                children: [
                    "By installing this app, you:",
                    /*#__PURE__*/ (0, $lHkHI.jsxs)("ul", {
                        children: [
                            marketplaceTermsOfUsePolicy,
                            eula || privacyPolicy ? vendorTermsOfUsePolicy : null,
                            isConnectApp ? null : forgeManageLogAccessPolicy
                        ]
                    })
                ]
            });
        });
    }
    render() {
        const { marketplaceAppDetails: marketplaceAppDetails } = this.props;
        const { eula: eula, privacyPolicy: privacyPolicy, vendor: { name: vendorName, vendorType: vendorType } } = marketplaceAppDetails;
        const termsOfUseMsg = this.termsOfUseMsg(this.props.links, marketplaceAppDetails);
        if (vendorType === 'internal') return null;
        if (!vendorName) return /*#__PURE__*/ (0, $lHkHI.jsx)($6313ccf24adc6de1$export$42a852a2b6b56249, {
            children: "This third party vendor has not provided a privacy policy or terms of use. Atlassian's Privacy Policy is not applicable to the use of this app."
        });
        if (privacyPolicy && eula) return /*#__PURE__*/ (0, $lHkHI.jsx)($6313ccf24adc6de1$export$42a852a2b6b56249, {
            children: termsOfUseMsg
        });
        else if (privacyPolicy && !eula) return /*#__PURE__*/ (0, $lHkHI.jsxs)($6313ccf24adc6de1$export$42a852a2b6b56249, {
            children: [
                termsOfUseMsg,
                /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                    children: [
                        vendorName,
                        " has not provided any terms of use explaining your rights to use the app or how ",
                        vendorName,
                        " may restrict your use of the app. By installing this app, you acknowledge and agree that ",
                        vendorName,
                        " may restrict or prohibit your use of the app at any time."
                    ]
                })
            ]
        });
        else if (eula && !privacyPolicy) return /*#__PURE__*/ (0, $lHkHI.jsxs)($6313ccf24adc6de1$export$42a852a2b6b56249, {
            children: [
                termsOfUseMsg,
                /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                    children: [
                        vendorName,
                        " has not provided a privacy policy explaining how this app will use your data. By installing this app, you acknowledge and agree this app may have unrestricted use of your data. If you do not agree, you should not install this app."
                    ]
                })
            ]
        });
        else return /*#__PURE__*/ (0, $lHkHI.jsxs)($6313ccf24adc6de1$export$42a852a2b6b56249, {
            children: [
                termsOfUseMsg,
                /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                    children: [
                        "This vendor has not provided terms of use or a privacy policy explaining how they will use your data. By installing this app, you acknowledge and agree this app may have unrestricted use of your data and/or ",
                        vendorName,
                        " may restrict or prohibit your use of the app at any time. If you do not agree, you should not install this app."
                    ]
                })
            ]
        });
    }
}
var $6313ccf24adc6de1$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($6313ccf24adc6de1$export$c559aa613c1114c);

});

parcelRegister("4LsDF", function(module, exports) {

$parcel$export(module.exports, "default", () => $3781c4452577a9ec$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $abBcx = parcelRequire("abBcx");

var $izRAm = parcelRequire("izRAm");

var $lHkHI = parcelRequire("lHkHI");
function $3781c4452577a9ec$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3781c4452577a9ec$export$9fea3e4644be20cb = (0, $3UXZ8.default)("div", {
    target: "e1ojqmi90",
    label: "ScopesDiv"
})({
    name: "493ori",
    styles: "margin-top:25px;"
});
const $3781c4452577a9ec$var$DialogDefaultContent = (props)=>{
    const { hostPricing: hostPricing, installableApp: installableApp, mpacBaseUrl: mpacBaseUrl, links: links, installedApp: installedApp, scopesLookup: scopesLookup, onRendered: onRendered, forgeAppEgressAddresses: forgeAppEgressAddresses, appDetailsFromSearchResponse: appDetailsFromSearchResponse } = props;
    (0, $eUqFw.useEffect)(()=>{
        if (typeof onRendered === 'function') onRendered();
    }, []);
    return /*#__PURE__*/ (0, $lHkHI.jsx)($3781c4452577a9ec$export$9fea3e4644be20cb, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $izRAm.default), {
            appDetailsHeaderInjection: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $abBcx.default), {
                hostPricing: hostPricing,
                appKey: installableApp.details.key,
                links: links,
                installedApp: installedApp,
                paymentModel: installableApp.marketplaceAppDetails.paymentModel,
                mpacBaseUrl: mpacBaseUrl,
                eligibleForFreeOnSandbox: installableApp.eligibleForFreeOnSandbox,
                cloudMigrationTrial: installableApp.cloudMigrationTrial,
                showAetherAppListingPage: false
            }),
            installableApp: (0, $bWAru.Option).some((0, $bWAru.Either).right(installableApp)),
            links: links,
            appDetailsFromSearchResponse: appDetailsFromSearchResponse,
            scopesLookup: scopesLookup,
            forgeAppEgressAddresses: forgeAppEgressAddresses
        })
    });
};
var $3781c4452577a9ec$export$2e2bcd8739ae039 = $3781c4452577a9ec$var$DialogDefaultContent;

});
parcelRegister("abBcx", function(module, exports) {

$parcel$export(module.exports, "default", () => $76a7c9df086ff06a$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $3JHWU = parcelRequire("3JHWU");
var $buxnS = parcelRequire("buxnS");

var $9l6Pq = parcelRequire("9l6Pq");

var $jlbX6 = parcelRequire("jlbX6");

var $bqcaO = parcelRequire("bqcaO");

var $9c9Gu = parcelRequire("9c9Gu");
parcelRequire("eUqFw");

var $3pGnh = parcelRequire("3pGnh");

var $3DsUo = parcelRequire("3DsUo");

var $j5L3j = parcelRequire("j5L3j");

var $9ePvD = parcelRequire("9ePvD");

var $lHkHI = parcelRequire("lHkHI");
function $76a7c9df086ff06a$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $76a7c9df086ff06a$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $76a7c9df086ff06a$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $76a7c9df086ff06a$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $76a7c9df086ff06a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $76a7c9df086ff06a$export$52e284bf30d0364a = (0, $3UXZ8.default)("span", {
    target: "e1ppm99b0",
    label: "LoadingText"
})({
    name: "odz94x",
    styles: "margin-top:5px;"
});
function $76a7c9df086ff06a$var$usePricing(props) {
    const { result: result } = props.hostPricing;
    const billingCurrency = result ? result.billingCurrency || (0, $jlbX6.DEFAULT_CURRENCY_CODE) : undefined;
    const fetchAppPricing = async ()=>{
        if ((0, $buxnS.isFreeApp)(props.paymentModel) || props.paymentModel === (0, $j5L3j.AppListingPaymentModel).PAID_VIA_PARTNER) return (0, $3pGnh.makeAppPricingFromMarketplaceAppData)(props.paymentModel);
        else if (billingCurrency) {
            const marketplaceAppPricing = await (0, $3DsUo.reflect)((0, $3JHWU.getMarketplaceAppPricing)(props.mpacBaseUrl, props.appKey, billingCurrency));
            return (0, $3pGnh.makeAppPricingFromMarketplaceAppData)(props.paymentModel, marketplaceAppPricing);
        }
    };
    return (0, $9c9Gu).usePromise(fetchAppPricing, [
        props.hostPricing,
        props.mpacBaseUrl,
        props.paymentModel
    ], !!billingCurrency);
}
function $76a7c9df086ff06a$export$2e2bcd8739ae039(props) {
    const { enableAetherAppListingPage: enableAetherAppListingPage } = (0, $9l6Pq.useStatsig)();
    const showAetherAppListingPage = enableAetherAppListingPage();
    const { result: result } = $76a7c9df086ff06a$var$usePricing({
        hostPricing: props.hostPricing,
        mpacBaseUrl: props.mpacBaseUrl,
        paymentModel: props.paymentModel,
        appKey: props.appKey
    });
    if (!result) return showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqcaO.Stripe), {
        width: "5rem",
        height: "0.875rem",
        marginTop: "var(--ds-space-075)"
    }) : /*#__PURE__*/ (0, $lHkHI.jsx)($76a7c9df086ff06a$export$52e284bf30d0364a, {
        children: "Loading price..."
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9ePvD.Pricing), $76a7c9df086ff06a$var$_objectSpread($76a7c9df086ff06a$var$_objectSpread({}, props), {}, {
        appPricing: result
    }));
}

});
parcelRegister("3JHWU", function(module, exports) {

$parcel$export(module.exports, "getMarketplaceAppPricing", () => $2b87aa71ffdb6665$export$3638efcc7a4cba3a);

var $dO8LH = parcelRequire("dO8LH");

var $5MLUk = parcelRequire("5MLUk");
const $2b87aa71ffdb6665$export$5741cde02fa8bdb2 = function getRawMarketplaceAppPricing(mpacBaseUrl, appKey) {
    let currencyCode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'USD';
    let hostingType = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'cloud';
    return (0, $dO8LH.fetchOk)("".concat(mpacBaseUrl, "/rest/2/addons/").concat(appKey, "/pricing/").concat(hostingType, "/live?currencyCode=").concat(currencyCode)).then((response)=>response.json());
};
const $2b87aa71ffdb6665$export$3638efcc7a4cba3a = (mpacBaseUrl, appKey, currencyCode)=>$2b87aa71ffdb6665$export$5741cde02fa8bdb2(mpacBaseUrl, appKey, currencyCode).then((0, $5MLUk.makeMarketplaceAppPricingFromRawAppPricing));

});
parcelRegister("5MLUk", function(module, exports) {

$parcel$export(module.exports, "makeMarketplaceAppPricingFromRawAppPricing", () => $01164cc9c614298b$export$d18a011bd791d92e);

var $g5DHJ = parcelRequire("g5DHJ");
const $01164cc9c614298b$export$a7f1631fa3f7ab30 = (marketplaceAppPricingItem)=>marketplaceAppPricingItem;
const $01164cc9c614298b$export$6885271f60b909fb = (marketplaceAppPricingItem)=>marketplaceAppPricingItem;
const $01164cc9c614298b$export$d710e3c1fca1c8f8 = (0, $g5DHJ.Record)({
    items: [],
    perUnitItems: undefined
});
const $01164cc9c614298b$var$formatAppPricingItem = (items)=>items.map((appPricingItem)=>({
            monthsValid: appPricingItem.monthsValid,
            unitCount: appPricingItem.unitCount,
            amount: appPricingItem.localCurrencyAmount,
            currencyCode: appPricingItem.localCurrency
        }));
const $01164cc9c614298b$export$d18a011bd791d92e = (rawMarketplaceAppPricing)=>$01164cc9c614298b$export$d710e3c1fca1c8f8({
        items: $01164cc9c614298b$var$formatAppPricingItem(rawMarketplaceAppPricing.items),
        perUnitItems: $01164cc9c614298b$var$formatAppPricingItem(rawMarketplaceAppPricing.perUnitItems || [])
    });

});


parcelRegister("jlbX6", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_CURRENCY_CODE", () => $e1493ff2bb363f90$export$c852e1f5bb177898);
$parcel$export(module.exports, "formatPrice", () => $e1493ff2bb363f90$export$c86caf1be068fb8d);
$parcel$export(module.exports, "makePricingExplanationForUninstalled", () => $e1493ff2bb363f90$export$ff597d64488abe76);
$parcel$export(module.exports, "makePricingExplanationForEvaluation", () => $e1493ff2bb363f90$export$3b2cde94409ad0b9);
$parcel$export(module.exports, "makePricingExplanationForSubscription", () => $e1493ff2bb363f90$export$1a0388b7db68f038);

var $76fzC = parcelRequire("76fzC");

var $6wqPF = parcelRequire("6wqPF");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $5eIIT = parcelRequire("5eIIT");

var $8CEbA = parcelRequire("8CEbA");
const $e1493ff2bb363f90$export$c852e1f5bb177898 = 'USD';
const $e1493ff2bb363f90$var$USD_LOCALE = 'en-us';
const $e1493ff2bb363f90$export$c86caf1be068fb8d = function formatPrice(amount, currencyCode) {
    let minimumFractionDigits = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
    const currencyDisplayFormat = currencyCode === 'USD' ? 'code' : 'symbol';
    return amount.toLocaleString($e1493ff2bb363f90$var$USD_LOCALE, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: minimumFractionDigits,
        currencyDisplay: currencyDisplayFormat,
        maximumFractionDigits: 2
    });
};
const $e1493ff2bb363f90$var$getSubscriptionText = (appPricing, currentUsers, estimate, subscriptionPeriod)=>{
    const userRange = (0, $5eIIT.default)(appPricing, currentUsers).fold((error)=>{
        console.error('Error when resolving app pricing tiers', error);
        return '';
    }, (tiers)=>{
        const lowerBound = tiers.lower.map((t)=>t.unitCount + 1).getOrElse(1);
        const upperBound = (0, $bWAru.Option).some(tiers.upper.unitCount).filter((u)=>u !== Number.POSITIVE_INFINITY);
        return " of ".concat(lowerBound.toString()).concat(upperBound.map((ub)=>"-".concat(ub)).getOrElse('+'), " users");
    });
    // Licensed users can be 0 when the
    // instance is under evaluation
    if (currentUsers) {
        const formattedPrice = $e1493ff2bb363f90$export$c86caf1be068fb8d(estimate.amount / currentUsers, estimate.currencyCode);
        return (0, $8CEbA.foldSubscriptionPeriod)(subscriptionPeriod, ()=>"monthly plan".concat(userRange, " at ").concat(formattedPrice, " per user/month"), ()=>"annual plan".concat(userRange, " at ").concat(formattedPrice, " per user/year"));
    } else return (0, $8CEbA.foldSubscriptionPeriod)(subscriptionPeriod, ()=>"monthly plan".concat(userRange), ()=>"annual plan".concat(userRange));
};
const $e1493ff2bb363f90$export$ff597d64488abe76 = function makePricingExplanationForUninstalled(appPricing, currentUsers, estimate, subscriptionPeriod, cloudMigrationTrial) {
    let showAetherAppListingPage = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
    const subscriptionText = $e1493ff2bb363f90$var$getSubscriptionText(appPricing, currentUsers, estimate, subscriptionPeriod);
    if (cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.isEligible && cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.btfSenEndDate) {
        const expiry = showAetherAppListingPage ? (0, $76fzC).formatDateObject(cloudMigrationTrial.btfSenEndDate, 'MMM dd, yyyy') : (0, $76fzC).longDate(cloudMigrationTrial.btfSenEndDate);
        return "If you proceed, your Cloud Migration Trial starts today and will end on ".concat(expiry, ". ") + "Post which, this estimate will be valid, which is customized for your ".concat(subscriptionText, ".");
    } else {
        const expiry = showAetherAppListingPage ? (0, $76fzC).formatDateObject((0, $6wqPF.default)(Date.now(), 30), 'MMM dd, yyyy') : (0, $76fzC).longDate((0, $6wqPF.default)(Date.now(), 30));
        return "If you proceed, your free trial starts today and will end on ".concat(expiry, ".\n    This estimate is customized for your ").concat(subscriptionText, ".");
    }
};
const $e1493ff2bb363f90$export$3b2cde94409ad0b9 = (appPricing, currentUsers, estimate, subscriptionPeriod, trialEndDate)=>{
    const subscriptionText = $e1493ff2bb363f90$var$getSubscriptionText(appPricing, currentUsers, estimate, subscriptionPeriod);
    return "This estimate is customized for your ".concat(subscriptionText, ". Your free trial will end on ").concat(trialEndDate, ".");
};
const $e1493ff2bb363f90$export$1a0388b7db68f038 = (appPricing, currentUsers, estimate, subscriptionPeriod)=>{
    const subscriptionText = $e1493ff2bb363f90$var$getSubscriptionText(appPricing, currentUsers, estimate, subscriptionPeriod);
    return "This estimate is customized for your ".concat(subscriptionText);
};

});
parcelRegister("5eIIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $3d00f3a085af4896$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
const $3d00f3a085af4896$var$findBetweenTiers = (pricingItems, numUsers)=>pricingItems.reduce((foundBetweenTiers, pricingItem, index, iter)=>foundBetweenTiers.orElseL(()=>pricingItem.unitCount >= numUsers ? (0, $bWAru.Option).some({
                lower: (0, $bWAru.Option).of(index === 0 ? null : iter.get(index - 1)),
                upper: pricingItem
            }) : (0, $bWAru.Option).empty()), (0, $bWAru.Option).empty()).map((0, $bWAru.Either).right).getOrElse((0, $bWAru.Either).left('Number of users does not fall between any tiers'));
var $3d00f3a085af4896$export$2e2bcd8739ae039 = $3d00f3a085af4896$var$findBetweenTiers;

});

parcelRegister("8CEbA", function(module, exports) {

$parcel$export(module.exports, "foldSubscriptionPeriod", () => $64710b7025d67455$export$98e46c241cb63383);

var $gC8Po = parcelRequire("gC8Po");
function $64710b7025d67455$export$98e46c241cb63383(subscriptionPeriod, monthly, annual) {
    switch(subscriptionPeriod){
        case 'monthly':
            return monthly();
        case 'annual':
            return annual();
        default:
            throw (0, $gC8Po.default).unexpectedCase(subscriptionPeriod);
    }
}

});


parcelRegister("3pGnh", function(module, exports) {

$parcel$export(module.exports, "foldAppPricing", () => $27c49397666be7f2$export$bb612f7936b8d5cb);
$parcel$export(module.exports, "makeAppPricingFromMarketplaceAppData", () => $27c49397666be7f2$export$1390d9b85b4d7a68);

var $buxnS = parcelRequire("buxnS");

parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
const $27c49397666be7f2$export$1cd676682f55cf4f = 'FREE';
const $27c49397666be7f2$var$PAID_PRICING_TYPE = 'PAID';
const $27c49397666be7f2$export$83f7c2f33b89d1b4 = (0, $g5DHJ.Record)({
    type: $27c49397666be7f2$export$1cd676682f55cf4f
});
const $27c49397666be7f2$export$a7f097d1d985d3f1 = (0, $g5DHJ.Record)({
    amount: 0,
    currencyCode: '',
    unitCount: 0,
    type: (0, $09427d726d6fc2a7$export$b3cd817f06e4fc99)
});
const $27c49397666be7f2$export$355e61c6f0a18c9d = (0, $g5DHJ.Record)({
    type: $27c49397666be7f2$var$PAID_PRICING_TYPE,
    annual: (0, $g5DHJ.List)(),
    monthly: (0, $g5DHJ.List)()
});
function $27c49397666be7f2$export$bb612f7936b8d5cb(appPricing) {
    return function foldAppPricingInner(free, paid) {
        switch(appPricing.type){
            case $27c49397666be7f2$export$1cd676682f55cf4f:
                return free(appPricing);
            case $27c49397666be7f2$var$PAID_PRICING_TYPE:
                return paid(appPricing);
            default:
                // Flow compile-time validation that we've handled every pricing type
                // prettier-ignore
                appPricing;
                return undefined;
        }
    };
}
const $27c49397666be7f2$var$parseUnitCount = (unitCount)=>unitCount === -1 ? Number.POSITIVE_INFINITY : unitCount;
const $27c49397666be7f2$var$makeFlatRatePricingItemFromMarketplaceAppFlatRatePricingItem = (flatRateItem)=>$27c49397666be7f2$export$a7f097d1d985d3f1({
        amount: flatRateItem.amount,
        currencyCode: flatRateItem.currencyCode,
        unitCount: $27c49397666be7f2$var$parseUnitCount(flatRateItem.unitCount),
        type: (0, $09427d726d6fc2a7$export$d43def0adf0a1960)
    });
const $27c49397666be7f2$var$resolveMonthlyItems = (flatRateItems, perUnitItems)=>flatRateItems.filter((i)=>i.monthsValid === 1).map($27c49397666be7f2$var$makeFlatRatePricingItemFromMarketplaceAppFlatRatePricingItem).concat(perUnitItems.filter((i)=>i.monthsValid === 1).map((perUnitItem)=>$27c49397666be7f2$export$a7f097d1d985d3f1({
            amount: perUnitItem.amount,
            currencyCode: perUnitItem.currencyCode,
            unitCount: $27c49397666be7f2$var$parseUnitCount(perUnitItem.unitCount),
            type: (0, $09427d726d6fc2a7$export$b3cd817f06e4fc99)
        })));
const $27c49397666be7f2$var$resolveAnnualItems = (flatRateItems)=>flatRateItems.filter((i)=>i.monthsValid === 12).map($27c49397666be7f2$var$makeFlatRatePricingItemFromMarketplaceAppFlatRatePricingItem);
const $27c49397666be7f2$export$1390d9b85b4d7a68 = (paymentModel, marketplaceAppPricing)=>(0, $bWAru.Option).of(paymentModel).map((pm)=>(0, $buxnS.foldPaymentModel)(pm)(()=>(0, $bWAru.Either).right($27c49397666be7f2$export$83f7c2f33b89d1b4()), ()=>{
            if (!marketplaceAppPricing) return (0, $bWAru.Either).left('marketplaceAppPricing must be supplied for paid apps');
            return marketplaceAppPricing.fold((marketplaceAppPricingErrorResponse)=>(0, $bWAru.Either).left("Error while resolving pricing for paid app: ".concat(marketplaceAppPricingErrorResponse)), (marketplaceAppPricingRes)=>{
                const flatRateItems = (0, $g5DHJ.List)(marketplaceAppPricingRes.items);
                return (0, $bWAru.Either).right($27c49397666be7f2$export$355e61c6f0a18c9d({
                    annual: $27c49397666be7f2$var$resolveAnnualItems(flatRateItems),
                    monthly: $27c49397666be7f2$var$resolveMonthlyItems(flatRateItems, (0, $bWAru.Option).of(marketplaceAppPricingRes.perUnitItems).map((0, $g5DHJ.List)).getOrElse((0, $g5DHJ.List)()))
                }));
            });
        }, ()=>(0, $bWAru.Either).left((0, $09427d726d6fc2a7$export$817d7ae484ee652b)))).getOrElse((0, $bWAru.Either).left('paymentModel or parent data items not present'));

});
const $09427d726d6fc2a7$export$d43def0adf0a1960 = 'FLAT_RATE';
const $09427d726d6fc2a7$export$b3cd817f06e4fc99 = 'PER_UNIT';
const $09427d726d6fc2a7$export$817d7ae484ee652b = 'Paid via Vendor pricing is not supported'; // Infinite unit count should be represented by Infinity


parcelRegister("j5L3j", function(module, exports) {

$parcel$export(module.exports, "fetchMarketplaceAppData", () => $de62fb8e83260f76$export$f22bb6e36e44df10);
$parcel$export(module.exports, "getAppDeploymentType", () => $de62fb8e83260f76$export$38246f684b6faaa);
$parcel$export(module.exports, "getInstallableAddon", () => $de62fb8e83260f76$export$38c692b915985870);
$parcel$export(module.exports, "AppListingPaymentModel", () => $de62fb8e83260f76$export$f5314416ada80b0f);
$parcel$export(module.exports, "mapAppListingPaymentModel", () => $de62fb8e83260f76$export$8f4d2fa3ad726412);

var $ly50n = parcelRequire("ly50n");

var $4gzHi = parcelRequire("4gzHi");

var $kafab = parcelRequire("kafab");

var $ammkg = parcelRequire("ammkg");

var $ifMZN = parcelRequire("ifMZN");

var $55gtq = parcelRequire("55gtq");

var $3DsUo = parcelRequire("3DsUo");
const $de62fb8e83260f76$var$makeCloudMigrationTrialFromNonInstallableApp = (upmAvailableApp)=>{
    return {
        isEligible: Boolean(upmAvailableApp.cmtEligible),
        btfSenEndDate: upmAvailableApp.btfSenEndDate ? new Date(upmAvailableApp.btfSenEndDate) : undefined
    };
};
// TODO add types
const $de62fb8e83260f76$var$getInstallableIdentifier = (appKey, deploymentType, marketplaceApp)=>{
    if (marketplaceApp !== null && marketplaceApp !== void 0 && marketplaceApp.cloudAppVersions && deploymentType === (0, $kafab.AppDeployment).ECOSYSTEM_CLOUD) {
        var _marketplaceApp$cloud, _marketplaceApp$cloud2, _marketplaceApp$cloud3;
        const appDeployment = (_marketplaceApp$cloud = marketplaceApp.cloudAppVersions.edges) === null || _marketplaceApp$cloud === void 0 ? void 0 : (_marketplaceApp$cloud2 = _marketplaceApp$cloud[0]) === null || _marketplaceApp$cloud2 === void 0 ? void 0 : (_marketplaceApp$cloud3 = _marketplaceApp$cloud2.node) === null || _marketplaceApp$cloud3 === void 0 ? void 0 : _marketplaceApp$cloud3.deployment;
        const ari = appDeployment === null || appDeployment === void 0 ? void 0 : appDeployment.cloudAppId;
        return (0, $ifMZN.makeInstallableAppByAriIdentifier)({
            ari: (0, $ly50n.makeAppKey)(ari),
            appKey: (0, $ly50n.makeAppKey)(appKey || '')
        });
    } else return (0, $ifMZN.makeInstallableAppByKeyIdentifier)({
        key: (0, $ly50n.makeAppKey)(appKey)
    });
};
async function $de62fb8e83260f76$export$f22bb6e36e44df10(_ref) {
    let { appKey: appKey, fetchInstalledApp: fetchInstalledApp, contextId: contextId, deploymentType: deploymentType, marketplaceApp: marketplaceApp, flags: flags, hostCmtEnabled: hostCmtEnabled } = _ref;
    const installableAddonPromise = (0, $55gtq.default)().getInstallableAddon({
        addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)($de62fb8e83260f76$var$getInstallableIdentifier(appKey, deploymentType, marketplaceApp)),
        hostCmtEnabled: hostCmtEnabled
    });
    const permissionCheckPromise = ()=>(0, $3DsUo.reflect)(installableAddonPromise.then((ia)=>(0, $55gtq.default)().hasInstallPermission({
                addon: ia
            })));
    const installedAppPromise = ()=>(0, $55gtq.default)().getInstalledAddon({
            contextId: contextId,
            addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)($de62fb8e83260f76$var$getInstallableIdentifier(appKey, deploymentType, marketplaceApp)),
            flags: flags
        }).then((installedAddonResult)=>{
            return installedAddonResult.status === 'NOT_FOUND' ? null : installedAddonResult;
        })// eslint-disable-next-line promise/no-return-wrap
        .catch(()=>Promise.resolve(null));
    const sandboxEligibilityPromise = installableAddonPromise.then((installableAddon)=>installableAddon.eligibleForFreeOnSandbox).catch(()=>false);
    const cloudMigrationTrialPromise = installableAddonPromise.then((installableAddon)=>installableAddon.cloudMigrationTrial)// Incase app is non-installable but still eligible for cloudMigrationTrial
    .catch(function() {
        let { upmAvailableApp: upmAvailableApp } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if (upmAvailableApp) return $de62fb8e83260f76$var$makeCloudMigrationTrialFromNonInstallableApp(upmAvailableApp);
        return {
            isEligible: false
        };
    });
    const [eligibleForFreeOnSandbox, installPermission, installedAddon, cloudMigrationTrial] = await Promise.all([
        sandboxEligibilityPromise,
        permissionCheckPromise(),
        fetchInstalledApp ? installedAppPromise() : null,
        cloudMigrationTrialPromise
    ]);
    return {
        installedApp: installedAddon ? (0, $4gzHi.makeInstalledAppFromSPIInstalledApp)(installedAddon) : undefined,
        installPermission: installPermission,
        eligibleForFreeOnSandbox: eligibleForFreeOnSandbox,
        cloudMigrationTrial: cloudMigrationTrial
    };
}
const $de62fb8e83260f76$export$38246f684b6faaa = (appListing)=>{
    var _appListing$cloudAppV, _appListing$cloudAppV2;
    const appVersion = (_appListing$cloudAppV = appListing.cloudAppVersions.edges) === null || _appListing$cloudAppV === void 0 ? void 0 : (_appListing$cloudAppV2 = _appListing$cloudAppV[0]) === null || _appListing$cloudAppV2 === void 0 ? void 0 : _appListing$cloudAppV2.node;
    return appVersion === null || appVersion === void 0 ? void 0 : appVersion.deployment.__typename;
};
const $de62fb8e83260f76$export$38c692b915985870 = (appDeployment, appKey)=>{
    if (appDeployment !== null && appDeployment !== void 0 && appDeployment.cloudAppId) return (0, $ifMZN.makeInstallableAppByAriIdentifier)({
        ari: (0, $ly50n.makeAppKey)(appDeployment.cloudAppId || ''),
        appKey: (0, $ly50n.makeAppKey)(appKey || '')
    });
    else return (0, $ifMZN.makeInstallableAppByKeyIdentifier)({
        key: (0, $ly50n.makeAppKey)(appKey || '')
    });
};
const $de62fb8e83260f76$export$f5314416ada80b0f = {
    [(0, $ammkg.MarketplaceAppPaymentModel).Free]: 'free',
    [(0, $ammkg.MarketplaceAppPaymentModel).PaidViaAtlassian]: 'atlassian',
    [(0, $ammkg.MarketplaceAppPaymentModel).PaidViaPartner]: 'vendor'
};
const $de62fb8e83260f76$export$8f4d2fa3ad726412 = (paymentModel)=>paymentModel ? $de62fb8e83260f76$export$f5314416ada80b0f[paymentModel] : undefined;

});

parcelRegister("9ePvD", function(module, exports) {

$parcel$export(module.exports, "Pricing", () => $6b9d6086e24a99a3$export$bc75f5ddb26aac73);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
parcelRequire("eUqFw");

var $3pGnh = parcelRequire("3pGnh");

var $bwqfS = parcelRequire("bwqfS");

var $lHkHI = parcelRequire("lHkHI");
function $6b9d6086e24a99a3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6b9d6086e24a99a3$var$FreePricingNew = (0, $3UXZ8.default)("div", {
    target: "eyastdp0",
    label: "FreePricingNew"
})("color:", "var(--ds-text-subtlest, ".concat((0, $j0gMm.N400), ")"), ";");
const $6b9d6086e24a99a3$export$7e910a136527e839 = (0, $3UXZ8.default)("div", {
    target: "eyastdp1",
    label: "FreePricing"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N400), ")"), ";text-transform:uppercase;");
const $6b9d6086e24a99a3$export$4faac3888fb5e689 = (0, $3UXZ8.default)("div", {
    target: "eyastdp2",
    label: "PricingContainer"
})({
    name: "8xl60i",
    styles: "margin-top:auto;"
});
const $6b9d6086e24a99a3$export$bc75f5ddb26aac73 = (_ref)=>{
    let { hostPricing: hostPricing, appPricing: appPricing, installedApp: installedApp, links: links, appKey: appKey, hideTryFreeHeading: hideTryFreeHeading, className: className, isInstallButtonVisible: isInstallButtonVisible, eligibleForFreeOnSandbox: eligibleForFreeOnSandbox, cloudMigrationTrial: cloudMigrationTrial, showAetherAppListingPage: showAetherAppListingPage } = _ref;
    const renderPaidPricingContent = (paidAppPricing, paidPaymentModel)=>{
        const { pending: pending, result: result } = hostPricing;
        if (pending) return 'Loading price...';
        if (result) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bwqfS.default), {
            hideTryFreeHeading: hideTryFreeHeading,
            appKey: appKey,
            hostPricing: result,
            paidPaymentModel: paidPaymentModel,
            links: links,
            paidAppPricing: paidAppPricing,
            isInstallButtonVisible: isInstallButtonVisible,
            eligibleForFreeOnSandbox: eligibleForFreeOnSandbox,
            cloudMigrationTrial: cloudMigrationTrial,
            showAetherAppListingPage: showAetherAppListingPage
        });
        return null;
    };
    const renderFreeOrPaidPricingContent = ()=>appPricing.fold((err)=>{
            if (err === (0, $09427d726d6fc2a7$export$817d7ae484ee652b)) return null;
            return 'Unknown price';
        }, (pricing)=>(0, $3pGnh.foldAppPricing)(pricing)(()=>showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)($6b9d6086e24a99a3$var$FreePricingNew, {
                    children: "Free"
                }) : /*#__PURE__*/ (0, $lHkHI.jsx)($6b9d6086e24a99a3$export$7e910a136527e839, {
                    children: "Free"
                }), (p)=>renderPaidPricingContent(p, installedApp.flatMap((ia)=>ia.paymentModel.fold((_)=>(0, $bWAru.Option).empty(), (m)=>(0, $bWAru.Option).some(m)))) || 'Unknown price'));
    return /*#__PURE__*/ (0, $lHkHI.jsx)($6b9d6086e24a99a3$export$4faac3888fb5e689, {
        className: className,
        children: renderFreeOrPaidPricingContent()
    });
};
var $6b9d6086e24a99a3$export$2e2bcd8739ae039 = $6b9d6086e24a99a3$export$bc75f5ddb26aac73;

});
parcelRegister("bwqfS", function(module, exports) {

$parcel$export(module.exports, "default", () => $86370c8f43fb08da$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $lTojc = parcelRequire("lTojc");

var $4JJMG = parcelRequire("4JJMG");

var $j0gMm = parcelRequire("j0gMm");

var $oXxJm = parcelRequire("oXxJm");
var $8CEbA = parcelRequire("8CEbA");
var $jlbX6 = parcelRequire("jlbX6");

var $4lmb9 = parcelRequire("4lmb9");

var $76fzC = parcelRequire("76fzC");
parcelRequire("eUqFw");

var $7zfnY = parcelRequire("7zfnY");

var $lHkHI = parcelRequire("lHkHI");
function $86370c8f43fb08da$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $86370c8f43fb08da$export$35e29d8d331f85bd = 'Get started';
const $86370c8f43fb08da$export$580ff1957ec26b68 = 'Try free';
const $86370c8f43fb08da$export$c192f14007e5a4b4 = (0, $3UXZ8.default)("div", {
    target: "e12z2c0d0",
    label: "PaidPricingContainer"
})({
    name: "xi606m",
    styles: "text-align:center;"
});
const $86370c8f43fb08da$export$1d76000680ea0e29 = (0, $3UXZ8.default)("div", {
    target: "e12z2c0d1",
    label: "PriceHeading"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N700), ")"), ";font-weight:700;text-transform:uppercase;text-align:center;");
const $86370c8f43fb08da$export$541d39676097f853 = (0, $3UXZ8.default)("div", {
    target: "e12z2c0d2",
    label: "EstimateContainer"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N400), ")"), ";display:flex;align-items:center;&:hover{background-color:", (props)=>props.hoverable ? "var(--ds-background-neutral-subtle-hovered, ".concat((0, $j0gMm.N30), ")") : 'auto', ";cursor:", (props)=>props.hoverable ? 'pointer' : 'auto', ";}");
const $86370c8f43fb08da$export$fae8a6d44ed6841a = (0, $3UXZ8.default)("div", {
    target: "e12z2c0d3",
    label: "EstimateText"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N400), ")"), ";font-size:16px;font-weight:600;line-height:24px;");
const $86370c8f43fb08da$export$4181d0431eaf95d5 = (0, $3UXZ8.default)("p", {
    target: "e12z2c0d4",
    label: "PricingSubtext"
})("margin-top:0;font-size:12px;text-align:center;color:", "var(--ds-text-accent-teal-bolder, ".concat((0, $j0gMm.N500), ")"), ";");
const $86370c8f43fb08da$export$48450bd55c69ef28 = (0, $3UXZ8.default)("div", {
    target: "e12z2c0d5",
    label: "PricingSubtextContainer"
})("color:var(--ds-text-subtlest);text-align:center;font-size:12px;font-weight:400;line-height:18px;display:flex;padding-left:var(--ds-space-050, 4px);justify-content:center;align-items:center;&:hover{background-color:", (props)=>props.hoverable ? "var(--ds-surface-hovered)" : 'auto', ";cursor:", (props)=>props.hoverable ? 'pointer' : 'auto', ";border-radius:3px;}");
$86370c8f43fb08da$export$2e2bcd8739ae039.defaultProps = {
    hideTryFreeHeading: false
};
function $86370c8f43fb08da$var$getPriceHeading(hideTryFreeHeading, eligibleForFreeOnSandbox) {
    if (hideTryFreeHeading) return null;
    if (eligibleForFreeOnSandbox) return /*#__PURE__*/ (0, $lHkHI.jsx)($86370c8f43fb08da$export$1d76000680ea0e29, {
        children: $86370c8f43fb08da$export$35e29d8d331f85bd
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)($86370c8f43fb08da$export$1d76000680ea0e29, {
        children: $86370c8f43fb08da$export$580ff1957ec26b68
    });
}
const $86370c8f43fb08da$var$resolvePricingSubtext = (eligibleForFreeOnSandbox, cloudMigrationTrial)=>{
    if (eligibleForFreeOnSandbox) return 'already purchased';
    const duration = cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.isEligible && cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.btfSenEndDate ? (0, $76fzC).differenceInDaysOrMonths(cloudMigrationTrial.btfSenEndDate, new Date()) : '30-day';
    return "after ".concat(duration, " trial");
};
const $86370c8f43fb08da$var$resolvePricingSubtextNew = (eligibleForFreeOnSandbox, cloudMigrationTrial)=>{
    if (eligibleForFreeOnSandbox) return 'App purchased';
    const duration = cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.isEligible && cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.btfSenEndDate ? (0, $76fzC).differenceInDaysOrMonths(cloudMigrationTrial.btfSenEndDate, new Date(), {
        pluralizeUnits: false,
        countUnitSeparator: '-'
    }) : '30-day';
    return "Estimate after ".concat(duration, " free trial");
};
function $86370c8f43fb08da$export$2e2bcd8739ae039(props) {
    const resolveBillingPeriodUnit = ()=>(0, $8CEbA.foldSubscriptionPeriod)(props.hostPricing.subscriptionPeriod, ()=>'month', ()=>'year');
    const resolvePricingItems = ()=>(0, $8CEbA.foldSubscriptionPeriod)(props.hostPricing.subscriptionPeriod, ()=>props.paidAppPricing.monthly, ()=>props.paidAppPricing.annual);
    const resolveEstimateContainer = (estimate)=>{
        const amount = props.eligibleForFreeOnSandbox ? 0 : estimate.amount;
        const formattedPrice = (0, $jlbX6.formatPrice)(amount, estimate.currencyCode);
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($86370c8f43fb08da$export$541d39676097f853, {
            hoverable: true,
            children: [
                "Estimated ",
                formattedPrice,
                " / ",
                resolveBillingPeriodUnit(),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($lTojc))), {
                    label: "Editor Info Icon"
                })
            ]
        });
    };
    const resolveEstimateContainerNew = (estimate)=>{
        const amount = props.eligibleForFreeOnSandbox ? 0 : estimate.amount;
        const formattedPrice = (0, $jlbX6.formatPrice)(amount, estimate.currencyCode);
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($86370c8f43fb08da$export$fae8a6d44ed6841a, {
            children: [
                formattedPrice,
                " / ",
                resolveBillingPeriodUnit()
            ]
        });
    };
    const resolvePricingExplanation = (estimate)=>props.paidPaymentModel.fold(()=>(0, $jlbX6.makePricingExplanationForUninstalled)(resolvePricingItems(), props.hostPricing.currentLicensedUsers, estimate, props.hostPricing.subscriptionPeriod, props.cloudMigrationTrial, props.showAetherAppListingPage), (pm)=>pm.licenseType.fold((evaluation)=>(0, $jlbX6.makePricingExplanationForEvaluation)(resolvePricingItems(), props.hostPricing.currentLicensedUsers, estimate, props.hostPricing.subscriptionPeriod, (0, $76fzC).longDate(evaluation.expiry)), ()=>(0, $jlbX6.makePricingExplanationForSubscription)(resolvePricingItems(), props.hostPricing.currentLicensedUsers, estimate, props.hostPricing.subscriptionPeriod)));
    if (props.showAetherAppListingPage) return /*#__PURE__*/ (0, $lHkHI.jsx)($86370c8f43fb08da$export$c192f14007e5a4b4, {
        children: (0, $oXxJm.default)(resolvePricingItems(), props.hostPricing.currentLicensedUsers).fold((error)=>{
            console.error('Error when resolving price', error);
            return 'Unknown price';
        }, (estimate)=>/*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    resolveEstimateContainerNew(estimate),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4lmb9.default), {
                        content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7zfnY.default), {
                            appKey: props.appKey,
                            links: props.links,
                            description: resolvePricingExplanation(estimate),
                            isInstallButtonVisible: props.isInstallButtonVisible,
                            eligibleForFreeOnSandbox: props.eligibleForFreeOnSandbox,
                            cloudMigrationTrial: props.cloudMigrationTrial,
                            showAetherAppListingPage: props.showAetherAppListingPage
                        }),
                        children: /*#__PURE__*/ (0, $lHkHI.jsxs)($86370c8f43fb08da$export$48450bd55c69ef28, {
                            hoverable: true,
                            children: [
                                $86370c8f43fb08da$var$resolvePricingSubtextNew(props.eligibleForFreeOnSandbox, props.cloudMigrationTrial),
                                /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4JJMG))), {
                                    label: "Editor Info Panel"
                                })
                            ]
                        })
                    })
                ]
            }))
    });
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($86370c8f43fb08da$export$c192f14007e5a4b4, {
        children: [
            $86370c8f43fb08da$var$getPriceHeading(props.hideTryFreeHeading, props.eligibleForFreeOnSandbox),
            (0, $oXxJm.default)(resolvePricingItems(), props.hostPricing.currentLicensedUsers).fold((error)=>{
                console.error('Error when resolving price', error);
                return 'Unknown price';
            }, (estimate)=>/*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4lmb9.default), {
                            content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7zfnY.default), {
                                appKey: props.appKey,
                                links: props.links,
                                description: resolvePricingExplanation(estimate),
                                isInstallButtonVisible: props.isInstallButtonVisible,
                                eligibleForFreeOnSandbox: props.eligibleForFreeOnSandbox,
                                cloudMigrationTrial: props.cloudMigrationTrial,
                                showAetherAppListingPage: props.showAetherAppListingPage
                            }),
                            children: resolveEstimateContainer(estimate)
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)($86370c8f43fb08da$export$4181d0431eaf95d5, {
                            children: $86370c8f43fb08da$var$resolvePricingSubtext(props.eligibleForFreeOnSandbox, props.cloudMigrationTrial)
                        })
                    ]
                }))
        ]
    });
}

});
parcelRegister("lTojc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ff019739e714b4ed$var$_react = $ff019739e714b4ed$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $ff019739e714b4ed$var$_information = $ff019739e714b4ed$var$_interopRequireDefault((parcelRequire("4To0r")));
function $ff019739e714b4ed$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ff019739e714b4ed$var$EditorInfoIcon = (props)=>/*#__PURE__*/ $ff019739e714b4ed$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m0-8.5a1 1 0 0 0-1 1V15a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1m0-1.125a1.375 1.375 0 1 0 0-2.75 1.375 1.375 0 0 0 0 2.75"/></svg>`
    }, props, {
        newIcon: $ff019739e714b4ed$var$_information.default
    }));
$ff019739e714b4ed$var$EditorInfoIcon.displayName = 'EditorInfoIcon';
var $ff019739e714b4ed$var$_default = module.exports.default = $ff019739e714b4ed$var$EditorInfoIcon;

});

parcelRegister("4JJMG", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $372ee13589302974$var$_react = $372ee13589302974$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $372ee13589302974$var$_information = $372ee13589302974$var$_interopRequireDefault((parcelRequire("4To0r")));
function $372ee13589302974$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $372ee13589302974$var$EditorPanelIcon = (props)=>/*#__PURE__*/ $372ee13589302974$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 19a7 7 0 1 1 0-14 7 7 0 0 1 0 14m0-1.5a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11m0-6a1 1 0 0 1 1 1v2a1 1 0 0 1-2 0v-2a1 1 0 0 1 1-1m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2"/></svg>`
    }, props, {
        newIcon: $372ee13589302974$var$_information.default
    }));
$372ee13589302974$var$EditorPanelIcon.displayName = 'EditorPanelIcon';
var $372ee13589302974$var$_default = module.exports.default = $372ee13589302974$var$EditorPanelIcon;

});

parcelRegister("oXxJm", function(module, exports) {

$parcel$export(module.exports, "default", () => $04b06e035f9c18ff$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $4Gi93 = parcelRequire("4Gi93");
const $04b06e035f9c18ff$var$validatePricingItems = (pricingItems)=>{
    const sortedPricingItems = pricingItems.sort((a, b)=>a.unitCount - b.unitCount);
    return (0, $bWAru.Option).of(sortedPricingItems.find((pi, index, iter)=>(0, $4Gi93.foldPricingItem)(pi)(()=>(0, $bWAru.Option).of(index === 0 ? null : iter.get(index - 1)).filter((previous)=>(0, $4Gi93.foldPricingItem)(previous)(()=>false, ()=>true)).getOrElse(false), ()=>false))).map(()=>(0, $bWAru.Either).left('flatRate pricing items can only be the first pricing items')).getOrElseL(()=>(0, $bWAru.Either).right(sortedPricingItems));
};
const $04b06e035f9c18ff$var$separateFlatRateAndPerUnitPricingItems = (pricingItems)=>pricingItems.reduce((_ref, pi)=>{
        let { flatRatePricingItems: flatRatePricingItems, perUnitPricingItems: perUnitPricingItems } = _ref;
        return (0, $4Gi93.foldPricingItem)(pi)((frpi)=>({
                flatRatePricingItems: flatRatePricingItems.push(frpi),
                perUnitPricingItems: perUnitPricingItems
            }), (pupi)=>({
                flatRatePricingItems: flatRatePricingItems,
                perUnitPricingItems: perUnitPricingItems.push(pupi)
            }));
    }, {
        flatRatePricingItems: (0, $g5DHJ.List)(),
        perUnitPricingItems: (0, $g5DHJ.List)()
    });
const $04b06e035f9c18ff$var$calculatePerUnitPrice = (perUnitPricingItems, activeUsers)=>{
    const { amount: amount, usersRemaining: usersRemaining, currencyCode: currencyCode } = perUnitPricingItems.reduce((calculationReduction, perUnitPricingItem)=>{
        const numberOfUsersToChargeAtThisTier = Math.min(calculationReduction.usersRemaining, perUnitPricingItem.unitCount - calculationReduction.previousPricingItemUnitCount);
        return {
            amount: calculationReduction.amount + numberOfUsersToChargeAtThisTier * perUnitPricingItem.amount,
            usersRemaining: calculationReduction.usersRemaining - numberOfUsersToChargeAtThisTier,
            previousPricingItemUnitCount: perUnitPricingItem.unitCount,
            currencyCode: perUnitPricingItem.currencyCode // assuming all items in perUnitPricingItems belong to the same currency
        };
    }, {
        amount: 0,
        usersRemaining: activeUsers,
        previousPricingItemUnitCount: 0,
        currencyCode: ''
    });
    return usersRemaining === 0 ? (0, $bWAru.Either).right({
        amount: amount,
        currencyCode: currencyCode
    }) : (0, $bWAru.Either).left('Available pricing items do not cover all users');
};
const $04b06e035f9c18ff$var$maybeResolveFlatRatePrice = (flatRatePricingItems, activeUsers)=>(0, $bWAru.Option).of(flatRatePricingItems.find((frpi)=>activeUsers <= frpi.unitCount)).map((frpi)=>({
            amount: frpi.amount,
            currencyCode: frpi.currencyCode
        }));
const $04b06e035f9c18ff$var$calculatePrice = (pricingItems, activeUsers)=>$04b06e035f9c18ff$var$validatePricingItems(pricingItems).map($04b06e035f9c18ff$var$separateFlatRateAndPerUnitPricingItems).flatMap((_ref2)=>{
        let { flatRatePricingItems: flatRatePricingItems, perUnitPricingItems: perUnitPricingItems } = _ref2;
        return $04b06e035f9c18ff$var$maybeResolveFlatRatePrice(flatRatePricingItems, activeUsers).map((0, $bWAru.Either).right).getOrElseL(()=>$04b06e035f9c18ff$var$calculatePerUnitPrice(perUnitPricingItems, activeUsers));
    });
var $04b06e035f9c18ff$export$2e2bcd8739ae039 = $04b06e035f9c18ff$var$calculatePrice;

});
parcelRegister("4Gi93", function(module, exports) {

$parcel$export(module.exports, "foldPricingItem", () => $368928e024abd711$export$df84ac95c7bd261b);

function $368928e024abd711$export$df84ac95c7bd261b(pricingItem) {
    return function(flatRate, perUnit) {
        switch(pricingItem.type){
            case 0, $09427d726d6fc2a7$export$d43def0adf0a1960:
                return flatRate(pricingItem);
            case 0, $09427d726d6fc2a7$export$b3cd817f06e4fc99:
                return perUnit(pricingItem);
            default:
                pricingItem;
                return undefined;
        }
    };
}

});


parcelRegister("7zfnY", function(module, exports) {

$parcel$export(module.exports, "default", () => $5827bc8bf7d4581f$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $l501X = parcelRequire("l501X");

var $76fzC = parcelRequire("76fzC");
parcelRequire("eUqFw");

var $8KCrk = parcelRequire("8KCrk");

var $7Uh51 = parcelRequire("7Uh51");

var $ifMZN = parcelRequire("ifMZN");

var $lHkHI = parcelRequire("lHkHI");
function $5827bc8bf7d4581f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $5827bc8bf7d4581f$export$285a930307c7132d = 'This app is already purchased and will continue to be available for free inside your sandbox.';
const $5827bc8bf7d4581f$export$216064ea367d152 = 'This app has already been purchased and will be available for free in your sandbox.';
const $5827bc8bf7d4581f$export$3123dc9700d49eab = 'Learn more about apps for sandboxes';
const $5827bc8bf7d4581f$export$6551ef972be47cd3 = 'How to manage sandboxes';
const $5827bc8bf7d4581f$export$d3a47fef8188b771 = (0, $3UXZ8.default)("div", {
    target: "e1yr7p260",
    label: "PricingContentContainer"
})({
    name: "1gnrs3k",
    styles: "text-align:left;max-width:205px;"
});
const $5827bc8bf7d4581f$export$e2969d46f73410b = (0, $3UXZ8.default)("p", {
    target: "e1yr7p261",
    label: "ContentHeading"
})({
    name: "v3rw8h",
    styles: "font-size:16px;font-weight:700;margin:5px auto;"
});
$5827bc8bf7d4581f$export$2e2bcd8739ae039.defaultProps = {
    isInstallButtonVisible: true
};
const $5827bc8bf7d4581f$var$getDialogDescriptionNew = (shouldShowRequestAppContent, eligibleForFreeOnSandbox, defaultDescription, cloudMigrationTrial)=>{
    if (eligibleForFreeOnSandbox) return /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
        children: $5827bc8bf7d4581f$export$216064ea367d152
    });
    if (shouldShowRequestAppContent) {
        const duration = cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.isEligible && cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.btfSenEndDate ? (0, $76fzC).differenceInDaysOrMonths(cloudMigrationTrial.btfSenEndDate, new Date(), {
            pluralizeUnits: false,
            countUnitSeparator: '-'
        }) : '30-day';
        return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
            children: /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                children: [
                    "This app may require an approval from your admin. Your ",
                    duration,
                    " free trial will start after approval."
                ]
            })
        });
    }
    return /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
        children: defaultDescription
    });
};
const $5827bc8bf7d4581f$var$getDialogDescription = (shouldShowRequestAppContent, eligibleForFreeOnSandbox, defaultDescription, cloudMigrationTrial)=>{
    if (eligibleForFreeOnSandbox) return /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
        children: $5827bc8bf7d4581f$export$285a930307c7132d
    });
    if (shouldShowRequestAppContent) {
        const duration = cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.isEligible && cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.btfSenEndDate ? (0, $76fzC).differenceInDaysOrMonths(cloudMigrationTrial.btfSenEndDate, new Date()) : '30-day';
        return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                    children: "This app may require an approval from your admin."
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                    children: [
                        "Your ",
                        duration,
                        " free trial will start after approval is received."
                    ]
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
        children: defaultDescription
    });
};
function $5827bc8bf7d4581f$export$2e2bcd8739ae039(props) {
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const onClick = ()=>{
        fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstallableAppIdentifier)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_VIEW_APP_PRICING_DETAILS), (0, $ifMZN.makeInstallableAppByKeyIdentifier)({
            key: props.appKey
        })).toObject());
    };
    const getExternalLink = (shouldShowRequestAppContent, eligibleForFreeOnSandbox)=>{
        if (eligibleForFreeOnSandbox) return props.showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
            href: "https://support.atlassian.com/organization-administration/docs/manage-apps-for-sandboxes",
            children: $5827bc8bf7d4581f$export$6551ef972be47cd3
        }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
            href: "https://support.atlassian.com/organization-administration/docs/manage-product-sandboxes#Managesandboxes-AddMarketplaceandAtlassianappstoasandbox",
            children: $5827bc8bf7d4581f$export$3123dc9700d49eab
        });
        let externalLinkText = 'See details';
        if (shouldShowRequestAppContent) externalLinkText = 'Learn more';
        if (props.showAetherAppListingPage) externalLinkText = 'Explore pricing options';
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
            href: props.links.appPricingDetails.expand({
                appKey: props.appKey
            }),
            onClick: onClick,
            children: externalLinkText
        });
    };
    const shouldShowRequestAppContent = !props.isInstallButtonVisible;
    const description = props.showAetherAppListingPage ? $5827bc8bf7d4581f$var$getDialogDescriptionNew(shouldShowRequestAppContent, props.eligibleForFreeOnSandbox, props.description, props.cloudMigrationTrial) : $5827bc8bf7d4581f$var$getDialogDescription(shouldShowRequestAppContent, props.eligibleForFreeOnSandbox, props.description, props.cloudMigrationTrial);
    const externalLink = getExternalLink(shouldShowRequestAppContent, props.eligibleForFreeOnSandbox);
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($5827bc8bf7d4581f$export$d3a47fef8188b771, {
        children: [
            !props.showAetherAppListingPage && /*#__PURE__*/ (0, $lHkHI.jsx)($5827bc8bf7d4581f$export$e2969d46f73410b, {
                children: "Pricing"
            }),
            description,
            externalLink
        ]
    });
}

});




parcelRegister("izRAm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8650fdb8b1dedd8$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $kU8RF = parcelRequire("kU8RF");

var $aosfp = parcelRequire("aosfp");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
parcelRequire("eUqFw");

var $uNPxB = parcelRequire("uNPxB");

var $gXQsH = parcelRequire("gXQsH");

var $gwMyJ = parcelRequire("gwMyJ");

var $f6zt8 = parcelRequire("f6zt8");

var $lmAeL = parcelRequire("lmAeL");

var $lHkHI = parcelRequire("lHkHI");
function $d8650fdb8b1dedd8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d8650fdb8b1dedd8$export$796495a5fccbbe02 = (0, $3UXZ8.default)("div", {
    target: "e15727g30",
    label: "DialogInstallAppWithScopesContainer"
})({
    name: "1cc80k8",
    styles: "min-height:75px;overflow-x:hidden;"
});
const $d8650fdb8b1dedd8$export$7b8a8064734ade6e = (0, $3UXZ8.default)("div", {
    target: "e15727g31",
    label: "ScopesContainer"
})({
    name: "gt4wuf",
    styles: "margin-top:var(--ds-space-250, 20px);"
});
const $d8650fdb8b1dedd8$export$fb8c45af2ca86cd5 = (0, $3UXZ8.default)("div", {
    target: "e15727g32",
    label: "ForgeAppEgressAddressesContainer"
})({
    name: "gt4wuf",
    styles: "margin-top:var(--ds-space-250, 20px);"
});
const $d8650fdb8b1dedd8$var$DialogInstallAppWithScopes = (props)=>{
    const resolveScopesDescription = (appDetails)=>"".concat(appDetails.name, " will perform the following actions:");
    return /*#__PURE__*/ (0, $lHkHI.jsx)($d8650fdb8b1dedd8$export$796495a5fccbbe02, {
        children: (0, $bWAru.Option).map2(props.installableApp, props.scopesLookup, (bria, scopesLookup)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $kU8RF.default), {
                active: false,
                delay: 1000,
                size: 50,
                children: bria.map((installableApp)=>{
                    var _installableApp$marke;
                    return(/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
                    (0, $lHkHI.jsxs)((0, $gXQsH.default), {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aosfp.default), {
                                appHeaderDetails: (0, $uNPxB.makeAppHeaderDetails)(installableApp.marketplaceAppDetails, props.appDetailsFromSearchResponse),
                                headerInjection: props.appDetailsHeaderInjection,
                                appRatingLink: props.links.appRating,
                                appIconLink: props.links.appIcon,
                                isAppCloudFortified: (0, $f6zt8.isInstallableAppCloudFortified)(installableApp),
                                bugBountyParticipant: (_installableApp$marke = installableApp.marketplaceAppDetails.programs) === null || _installableApp$marke === void 0 ? void 0 : _installableApp$marke.bugBountyParticipant,
                                appIconSize: "small",
                                showInstallationCount: true
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)($d8650fdb8b1dedd8$export$7b8a8064734ade6e, {
                                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gwMyJ.default), {
                                    appScopes: installableApp.scopes,
                                    description: resolveScopesDescription(installableApp.marketplaceAppDetails),
                                    links: props.links,
                                    scopesLookup: scopesLookup
                                })
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)($d8650fdb8b1dedd8$export$fb8c45af2ca86cd5, {
                                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lmAeL.ForgeAppEgressAddresses), {
                                    forgeAppEgressAddresses: props.forgeAppEgressAddresses,
                                    appName: installableApp.marketplaceAppDetails.name
                                })
                            })
                        ]
                    }));
                }).toOption().orNull()
            })).getOrElseL(()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $kU8RF.default), {
                active: true,
                delay: 1000,
                size: 50,
                children: null
            }))
    });
};
var $d8650fdb8b1dedd8$export$2e2bcd8739ae039 = $d8650fdb8b1dedd8$var$DialogInstallAppWithScopes;

});
parcelRegister("uNPxB", function(module, exports) {

$parcel$export(module.exports, "makeAppHeaderDetails", () => $05c974b7aa139e15$export$8d625da576760458);
const $05c974b7aa139e15$export$8d625da576760458 = (app, appDetailsFromSearchResponse)=>{
    var _appDetailsFromSearch, _ref, _appDetailsFromSearch2, _ref2, _appDetailsFromSearch3, _app$vendor$partnerTi, _app$distribution$isP, _app$distribution, _app$distribution$isP2, _app$distribution2;
    const appDetailsFromSearchDistribution = appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : (_appDetailsFromSearch = appDetailsFromSearchResponse.appData) === null || _appDetailsFromSearch === void 0 ? void 0 : _appDetailsFromSearch.distribution;
    const appDistribution = app === null || app === void 0 ? void 0 : app.distribution;
    const downloadCount = (_ref = (_appDetailsFromSearch2 = appDetailsFromSearchDistribution === null || appDetailsFromSearchDistribution === void 0 ? void 0 : appDetailsFromSearchDistribution.downloads) !== null && _appDetailsFromSearch2 !== void 0 ? _appDetailsFromSearch2 : appDistribution === null || appDistribution === void 0 ? void 0 : appDistribution.downloadCount) !== null && _ref !== void 0 ? _ref : 0;
    const installationCount = (_ref2 = (_appDetailsFromSearch3 = appDetailsFromSearchDistribution === null || appDetailsFromSearchDistribution === void 0 ? void 0 : appDetailsFromSearchDistribution.activeInstalls) !== null && _appDetailsFromSearch3 !== void 0 ? _appDetailsFromSearch3 : appDistribution === null || appDistribution === void 0 ? void 0 : appDistribution.installationCount) !== null && _ref2 !== void 0 ? _ref2 : 0;
    return {
        name: app.name,
        key: app.key,
        icon: app.icon,
        ratings: app.ratings,
        origin: app.origin,
        partner: {
            name: app.vendor.name,
            link: app.vendor.link,
            partnerTierType: (_app$vendor$partnerTi = app.vendor.partnerTier) === null || _app$vendor$partnerTi === void 0 ? void 0 : _app$vendor$partnerTi.type
        },
        distribution: {
            downloadCount: downloadCount,
            installationCount: installationCount,
            isPreinstalled: (_app$distribution$isP = app === null || app === void 0 ? void 0 : (_app$distribution = app.distribution) === null || _app$distribution === void 0 ? void 0 : _app$distribution.isPreinstalled) !== null && _app$distribution$isP !== void 0 ? _app$distribution$isP : false,
            isPreinstalledInAnyHosting: (_app$distribution$isP2 = app === null || app === void 0 ? void 0 : (_app$distribution2 = app.distribution) === null || _app$distribution2 === void 0 ? void 0 : _app$distribution2.isPreinstalledInAnyHosting) !== null && _app$distribution$isP2 !== void 0 ? _app$distribution$isP2 : false,
            isLoading: appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : appDetailsFromSearchResponse.loading,
            isError: appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : appDetailsFromSearchResponse.error
        }
    };
};

});

parcelRegister("gXQsH", function(module, exports) {

$parcel$export(module.exports, "default", () => $c59ad9de30190103$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $c59ad9de30190103$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c59ad9de30190103$var$FADE_HEIGHT = '30px';
const $c59ad9de30190103$var$ChildrenWrapDiv = (0, $3UXZ8.default)("div", {
    target: "eh4c6380",
    label: "ChildrenWrapDiv"
})("overflow:hidden;padding-bottom:", $c59ad9de30190103$var$FADE_HEIGHT, ";");
const $c59ad9de30190103$var$RelativeDiv = (0, $3UXZ8.default)("div", {
    target: "eh4c6381",
    label: "RelativeDiv"
})({
    name: "n27z15",
    styles: "position:relative;height:0;"
});
const $c59ad9de30190103$var$FadeDiv = (0, $3UXZ8.default)("div", {
    target: "eh4c6382",
    label: "FadeDiv"
})("height:", $c59ad9de30190103$var$FADE_HEIGHT, ";background:linear-gradient( to bottom,var(--ds-background-neutral-subtle, rgba(255, 255, 255, 0)),var(--ds-surface-overlay, rgba(255, 255, 255, 1)) );position:absolute;bottom:0;left:0;right:0;");
class $c59ad9de30190103$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($c59ad9de30190103$var$ChildrenWrapDiv, {
                    children: this.props.children
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($c59ad9de30190103$var$RelativeDiv, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)($c59ad9de30190103$var$FadeDiv, {})
                })
            ]
        });
    }
}

});

parcelRegister("gwMyJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0854d5ba8170c73$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $j0gMm = parcelRequire("j0gMm");

var $8kbfx = parcelRequire("8kbfx");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $c0854d5ba8170c73$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c0854d5ba8170c73$export$31dea26885d599bc = (0, $3UXZ8.default)("div", {
    target: "e14kt8w70",
    label: "DescriptionContainer"
})("font-weight:400;font-size:14px;color:", "var(--ds-text, ".concat((0, $j0gMm.N800), ")"), ";");
const $c0854d5ba8170c73$export$3f4e9180815b917 = (0, $3UXZ8.default)("ul", {
    target: "e14kt8w71",
    label: "ScopesUl"
})("font-weight:400;font-size:14px;line-height:20px;color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N500), ")"), ";margin:0;padding-left:1.5em;");
const $c0854d5ba8170c73$export$f5342fb93e025bb6 = (0, $3UXZ8.default)("li", {
    target: "e14kt8w72",
    label: "ScopeLi"
})({
    name: "19f8am9",
    styles: "& + &{margin-top:var(--ds-space-050, 4px);}"
});
const $c0854d5ba8170c73$export$211593c580c85cd0 = (0, $3UXZ8.default)("div", {
    target: "e14kt8w73",
    label: "ScopesSection"
})({
    name: "mb6my3",
    styles: "& + &{margin-top:13px;}"
});
const $c0854d5ba8170c73$export$3e4b7f4c4f001e89 = (0, $3UXZ8.default)("div", {
    target: "e14kt8w74",
    label: "ExpandAllDetailsSection"
})({
    name: "18c6pm0",
    styles: "& + &{margin-top:var(--ds-space-075, 6px);}"
});
const $c0854d5ba8170c73$var$Scopes = (props)=>{
    const [showAllScopes, setShowAllScopes] = (0, $eUqFw.useState)(false);
    const initialScopesSize = 4;
    const translateScope = (_ref)=>{
        let { scopesLookup: scopesLookup, scope: scope } = _ref;
        const description = (0, $bWAru.Option).of(scopesLookup.getIn([
            (0, $8kbfx.makeScopeKey)(scope.toUpperCase()),
            'description'
        ])).orElseL(()=>{
            const scopeSplit = scope.split(':');
            const scopeHalfKey = scopeSplit[scopeSplit.length - 1];
            return (0, $bWAru.Option).of(scopesLookup.getIn([
                (0, $8kbfx.makeScopeKey)(scopeHalfKey.toUpperCase()),
                'description'
            ]));
        }).getOrElse(scope);
        return description;
    };
    const handleExpandAllScopes = ()=>{
        setShowAllScopes(true);
    };
    const scopesList = showAllScopes ? props.appScopes : props.appScopes.slice(0, initialScopesSize);
    const renderNoScopes = ()=>/*#__PURE__*/ (0, $lHkHI.jsx)($c0854d5ba8170c73$export$211593c580c85cd0, {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)($c0854d5ba8170c73$export$31dea26885d599bc, {
                children: "This app does not require additional permissions."
            })
        });
    const renderScopes = ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($c0854d5ba8170c73$export$211593c580c85cd0, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)($c0854d5ba8170c73$export$31dea26885d599bc, {
                        children: props.description
                    })
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($c0854d5ba8170c73$export$211593c580c85cd0, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)($c0854d5ba8170c73$export$3f4e9180815b917, {
                        children: props.scopesLookup.fold((_)=>scopesList.map((s)=>/*#__PURE__*/ (0, $lHkHI.jsx)($c0854d5ba8170c73$export$f5342fb93e025bb6, {
                                    children: s
                                }, s)), (scopesLookup)=>scopesList.map((s)=>/*#__PURE__*/ (0, $lHkHI.jsx)($c0854d5ba8170c73$export$f5342fb93e025bb6, {
                                    children: translateScope({
                                        scopesLookup: scopesLookup,
                                        scope: s
                                    })
                                }, s)))
                    })
                }),
                props.appScopes.size > initialScopesSize && !showAllScopes ? /*#__PURE__*/ (0, $lHkHI.jsx)($c0854d5ba8170c73$export$3e4b7f4c4f001e89, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                        appearance: "link",
                        onClick: handleExpandAllScopes,
                        children: "Expand all details"
                    })
                }) : null
            ]
        });
    return props.appScopes.size > 0 ? renderScopes() : renderNoScopes();
};
var $c0854d5ba8170c73$export$2e2bcd8739ae039 = $c0854d5ba8170c73$var$Scopes;

});

parcelRegister("lmAeL", function(module, exports) {

$parcel$export(module.exports, "ForgeAppEgressAddresses", () => $f8d7c2fda63fa6b3$export$8478d8cd465f84f2);

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $j0gMm = parcelRequire("j0gMm");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $f8d7c2fda63fa6b3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f8d7c2fda63fa6b3$export$c2f7404bc8662f3f = (0, $3UXZ8.default)("ul", {
    target: "eswv1f60",
    label: "EgressUl"
})("font-weight:400;font-size:14px;line-height:20px;color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N500), ")"), ";margin:0;padding-left:1.5em;");
const $f8d7c2fda63fa6b3$export$ea8a946be4c79376 = (0, $3UXZ8.default)("li", {
    target: "eswv1f61",
    label: "EgressLi"
})({
    name: "188h8i6",
    styles: "margin-top:var(--ds-space-050, 4px);"
});
const $f8d7c2fda63fa6b3$export$9772332eaabfd9c6 = (0, $3UXZ8.default)("div", {
    target: "eswv1f62",
    label: "EgressAddresesSection"
})({
    name: "mb6my3",
    styles: "& + &{margin-top:13px;}"
});
const $f8d7c2fda63fa6b3$export$3e4b7f4c4f001e89 = (0, $3UXZ8.default)("div", {
    target: "eswv1f63",
    label: "ExpandAllDetailsSection"
})({
    name: "2cpdjg",
    styles: "margin-top:var(--ds-space-075, 6px);"
});
const $f8d7c2fda63fa6b3$export$31dea26885d599bc = (0, $3UXZ8.default)("div", {
    target: "eswv1f64",
    label: "DescriptionContainer"
})("font-weight:400;font-size:14px;color:", "var(--ds-text, ".concat((0, $j0gMm.N800), ")"), ";");
const $f8d7c2fda63fa6b3$export$8478d8cd465f84f2 = (props)=>{
    const { forgeAppEgressAddresses: forgeAppEgressAddresses, appName: appName } = props;
    const resolveScopesDescription = "".concat(appName, " can send data to the following domains:");
    const [showAllEgressAddresses, setShowAllEgressAddresses] = (0, $eUqFw.useState)(false);
    const egressAddressesDescription = (address)=>{
        const prefix = '*.';
        if (address.startsWith(prefix)) return "Only subdomains of ".concat(address.slice(prefix.length));
        else return address;
    };
    const egressAddressesList = showAllEgressAddresses ? forgeAppEgressAddresses : forgeAppEgressAddresses === null || forgeAppEgressAddresses === void 0 ? void 0 : forgeAppEgressAddresses.slice(0, 4);
    const handleshowAllDetailsClick = ()=>{
        setShowAllEgressAddresses(true);
    };
    const showExpandAllDetailsButton = !showAllEgressAddresses && forgeAppEgressAddresses && forgeAppEgressAddresses.length > 4;
    const renderEgressAddresses = egressAddressesList && (egressAddressesList === null || egressAddressesList === void 0 ? void 0 : egressAddressesList.length) > 0 ? /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($f8d7c2fda63fa6b3$export$9772332eaabfd9c6, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)($f8d7c2fda63fa6b3$export$31dea26885d599bc, {
                    children: resolveScopesDescription
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($f8d7c2fda63fa6b3$export$9772332eaabfd9c6, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)($f8d7c2fda63fa6b3$export$c2f7404bc8662f3f, {
                    children: egressAddressesList.map((addresses)=>{
                        return /*#__PURE__*/ (0, $lHkHI.jsx)($f8d7c2fda63fa6b3$export$ea8a946be4c79376, {
                            children: egressAddressesDescription(addresses)
                        }, addresses);
                    })
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($f8d7c2fda63fa6b3$export$3e4b7f4c4f001e89, {
                children: showExpandAllDetailsButton ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                    appearance: "link",
                    onClick: handleshowAllDetailsClick,
                    children: "Expand all details"
                }) : null
            })
        ]
    }) : null;
    return renderEgressAddresses;
};

});




parcelRegister("g9u53", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc24d1fb7efa5532$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
parcelRequire("eUqFw");

var $gIQkA = parcelRequire("gIQkA");

var $jnM8o = parcelRequire("jnM8o");

var $joPUX = parcelRequire("joPUX");

var $2fW4H = parcelRequire("2fW4H");

var $lHkHI = parcelRequire("lHkHI");
const $bc24d1fb7efa5532$var$resolveDialogInstructional = (_ref)=>{
    let { closeInstallDialog: closeInstallDialog, instructionalInstallMode: instructionalInstallMode, links: links, appDetailsFromSearchResponse: appDetailsFromSearchResponse, onRendered: onRendered } = _ref;
    return {
        analyticsSourceModal: (0, $gIQkA.ANALYTICS_MODAL_INSTRUCTIONAL),
        content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $joPUX.default), {
            appDetailsFromSearchResponse: appDetailsFromSearchResponse,
            instructionalApp: instructionalInstallMode.instructionalApp,
            links: links,
            onRendered: onRendered
        }),
        heading: 'Installation instructions',
        footerLeft: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jnM8o.default), {
            marketplaceAppDetails: instructionalInstallMode.instructionalApp.details,
            links: links
        }),
        footerRight: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2fW4H.default), {
            closeInstallDialog: closeInstallDialog,
            instructionalApp: instructionalInstallMode.instructionalApp
        }),
        preventDialogClosing: false,
        errorDetails: (0, $bWAru.Option).empty()
    };
};
var $bc24d1fb7efa5532$export$2e2bcd8739ae039 = $bc24d1fb7efa5532$var$resolveDialogInstructional;

});
parcelRegister("joPUX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1f887f6569c2219$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $gGAJ8 = parcelRequire("gGAJ8");

var $aosfp = parcelRequire("aosfp");
var $hvzDU = parcelRequire("hvzDU");

var $eUqFw = parcelRequire("eUqFw");

var $uNPxB = parcelRequire("uNPxB");

var $lHkHI = parcelRequire("lHkHI");
function $e1f887f6569c2219$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e1f887f6569c2219$export$a2bb30aefb2a488 = (0, $3UXZ8.default)("div", {
    target: "e1x90ej00",
    label: "DialogInstructionalContainer"
})({
    name: "ymy1qt",
    styles: "min-height:75px;"
});
const $e1f887f6569c2219$export$1859a226b0527ca7 = (0, $3UXZ8.default)("li", {
    target: "e1x90ej01",
    label: "DialogInstructionalListItem"
})({
    name: "19f8am9",
    styles: "& + &{margin-top:var(--ds-space-050, 4px);}"
});
const $e1f887f6569c2219$export$38996a7777891d07 = (0, $3UXZ8.default)("img", {
    target: "e1x90ej02",
    label: "DialogInstructionalListItemImage"
})({
    name: "gt8gvs",
    styles: "margin:10px 0;max-width:100%;"
});
const $e1f887f6569c2219$export$d031efc798646aff = (0, $3UXZ8.default)("div", {
    target: "e1x90ej03",
    label: "NoInstructionsDiv"
})({
    name: "1q7njkh",
    styles: "margin-top:10px;"
});
const $e1f887f6569c2219$var$DialogInstructionalContent = (props)=>{
    const { instructionalApp: instructionalApp, links: links, onRendered: onRendered, appDetailsFromSearchResponse: appDetailsFromSearchResponse } = props;
    (0, $eUqFw.useEffect)(()=>{
        if (typeof onRendered === 'function') onRendered();
    }, []);
    const getNoInstructionsText = ()=>{
        const vendorName = instructionalApp.details.vendor.name;
        return vendorName ? instructionalApp.learnMoreLink ? /*#__PURE__*/ (0, $lHkHI.jsxs)($e1f887f6569c2219$export$d031efc798646aff, {
            children: [
                "We don't have instructions for this app. Please view information on ",
                vendorName,
                "'s website, or go to\xA0",
                /*#__PURE__*/ (0, $lHkHI.jsx)("a", {
                    href: instructionalApp.learnMoreLink,
                    target: "_blank",
                    rel: "noreferrer",
                    children: instructionalApp.learnMoreLink
                })
            ]
        }) : /*#__PURE__*/ (0, $lHkHI.jsxs)($e1f887f6569c2219$export$d031efc798646aff, {
            children: [
                "We don't have instructions for this app. Please view information on ",
                vendorName,
                "'s website."
            ]
        }) : instructionalApp.learnMoreLink ? /*#__PURE__*/ (0, $lHkHI.jsxs)($e1f887f6569c2219$export$d031efc798646aff, {
            children: [
                "We don't have instructions for this app. Go to",
                ' ',
                /*#__PURE__*/ (0, $lHkHI.jsx)("a", {
                    href: instructionalApp.learnMoreLink,
                    target: "_blank",
                    rel: "noreferrer",
                    children: instructionalApp.learnMoreLink
                })
            ]
        }) : /*#__PURE__*/ (0, $lHkHI.jsx)($e1f887f6569c2219$export$d031efc798646aff, {
            children: "We don't have instructions for this app."
        });
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($e1f887f6569c2219$export$a2bb30aefb2a488, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aosfp.default), {
                appHeaderDetails: (0, $uNPxB.makeAppHeaderDetails)(instructionalApp.details, appDetailsFromSearchResponse),
                appRatingLink: links.appRating,
                appIconLink: links.appIcon,
                appIconSize: "small",
                showInstallationCount: true
            }),
            (0, $gGAJ8.nonEmptyList)(instructionalApp.steps).fold((_)=>getNoInstructionsText(), (_)=>/*#__PURE__*/ (0, $lHkHI.jsx)("ol", {
                    children: instructionalApp.steps.map((step, i)=>/*#__PURE__*/ (0, $lHkHI.jsxs)($e1f887f6569c2219$export$1859a226b0527ca7, {
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hvzDU.default), {
                                    dangerousHtml: step.bodyHTML
                                }),
                                step.image && /*#__PURE__*/ (0, $lHkHI.jsx)($e1f887f6569c2219$export$38996a7777891d07, {
                                    alt: "",
                                    draggable: false,
                                    src: step.image
                                })
                            ]
                        }, i))
                }))
        ]
    });
};
var $e1f887f6569c2219$export$2e2bcd8739ae039 = $e1f887f6569c2219$var$DialogInstructionalContent;

});
parcelRegister("gGAJ8", function(module, exports) {

$parcel$export(module.exports, "nonEmptyList", () => $c25d0ed258f4bcc9$export$889482be59f95193);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");
const $c25d0ed258f4bcc9$export$889482be59f95193 = (l)=>l.isEmpty() ? (0, $bWAru.Option).empty() : (0, $bWAru.Option).some(l);
const $c25d0ed258f4bcc9$export$59e6ab3685971b90 = (e)=>(0, $g5DHJ.List)([
        e
    ]);
const $c25d0ed258f4bcc9$export$47be768bb1d48251 = (l)=>(0, $bWAru.Option).of(l.get(0)).getOrElseL(()=>{
        throw new Error("Illegal state - shouldn't have a NonEmptyList without an item");
    });

});


parcelRegister("2fW4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a4a07ebc6ca515d$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $9goJJ = parcelRequire("9goJJ");

var $gGAJ8 = parcelRequire("gGAJ8");
var $bPByu = parcelRequire("bPByu");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $g01ln = parcelRequire("g01ln");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $h6MeC = parcelRequire("h6MeC");

var $lHkHI = parcelRequire("lHkHI");
class $1a4a07ebc6ca515d$export$c9ec999db8681a6a extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onClickLearnMore", (learnMoreLink)=>()=>{
                this.props.fireAnalyticsEvent({
                    eventType: (0, $gaiog.ButtonClickedEvent),
                    actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_LEARN_MORE),
                    objectType: 'key',
                    objectId: this.props.instructionalApp.details.key
                });
                (0, $g01ln).openPage(learnMoreLink, "".concat(this.props.instructionalApp.details.key, "-learnMore"));
            });
        (0, $5zQU9.default)(this, "render", ()=>(0, $bWAru.Option).map2((0, $gGAJ8.nonEmptyList)(this.props.instructionalApp.steps), (0, $bWAru.Option).of(this.props.instructionalApp.learnMoreLink), (_, learnMoreLink)=>/*#__PURE__*/ (0, $lHkHI.jsxs)((0, $9goJJ.default), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bPByu.default), {
                            onClick: this.onClickLearnMore(learnMoreLink),
                            children: "Learn more"
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $h6MeC.default), {
                            isDisabled: false,
                            onClick: this.props.closeInstallDialog,
                            children: "Cancel"
                        })
                    ]
                })).getOrElseL(()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $bPByu.default), {
                    onClick: this.props.closeInstallDialog,
                    children: "Done"
                })));
    }
}
var $1a4a07ebc6ca515d$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($1a4a07ebc6ca515d$export$c9ec999db8681a6a);

});


parcelRegister("iEdQ1", function(module, exports) {

$parcel$export(module.exports, "useLinkTemplates", () => $d936b25c153c9eb8$export$afba633b8038bced);

var $9fEFB = parcelRequire("9fEFB");

var $eUqFw = parcelRequire("eUqFw");
const $d936b25c153c9eb8$export$afba633b8038bced = (_ref)=>{
    let { adminHubBaseUrl: adminHubBaseUrl, mpacBaseUrl: mpacBaseUrl, mpacCdnBaseUrl: mpacCdnBaseUrl, macBaseUrl: macBaseUrl, wacBaseUrl: wacBaseUrl, atlassianCommunityBaseUrl: atlassianCommunityBaseUrl } = _ref;
    return (0, $eUqFw.useMemo)(()=>(0, $9fEFB.linkTemplates)({
            adminHubBaseUrl: adminHubBaseUrl,
            mpacBaseUrl: mpacBaseUrl,
            mpacCdnBaseUrl: mpacCdnBaseUrl,
            macBaseUrl: macBaseUrl,
            wacBaseUrl: wacBaseUrl,
            atlassianCommunityBaseUrl: atlassianCommunityBaseUrl
        }), [
        adminHubBaseUrl,
        mpacBaseUrl,
        mpacCdnBaseUrl,
        macBaseUrl,
        wacBaseUrl,
        atlassianCommunityBaseUrl
    ]);
};

});


parcelRegister("5E4rM", function(module, exports) {

$parcel$export(module.exports, "InstallationLockProvider", () => $41c4234a416d1aa9$export$bdeb2e34b6f84425);
$parcel$export(module.exports, "useInstallationLock", () => $41c4234a416d1aa9$export$9f39065591191e00);

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $41c4234a416d1aa9$var$InstallContext = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createContext(null);
function $41c4234a416d1aa9$export$bdeb2e34b6f84425(props) {
    function installationReducer(state, action) {
        switch(action.type){
            case 'set_install_in_progress':
                return {
                    installationInProgressAppKey: action.payload.appKey
                };
            case 'clear_install_in_progress':
                return {
                    installationInProgressAppKey: null
                };
            case 'installation_success':
                if (props.onInstallSuccess) props.onInstallSuccess({
                    installedApp: action.payload.installedApp,
                    enableDeprecatedInstallationsGQL: action.payload.enableDeprecatedInstallationsGQL
                });
                return {
                    installationInProgressAppKey: null
                };
            default:
                return state;
        }
    }
    const [installationState, dispatch] = (0, $eUqFw.useReducer)((0, $eUqFw.useMemo)(()=>installationReducer, [
        props.onInstallSuccess
    ]), {
        installationInProgressAppKey: null
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)($41c4234a416d1aa9$var$InstallContext.Provider, {
        value: {
            installationState: installationState,
            dispatch: dispatch
        },
        children: props.children
    });
}
function $41c4234a416d1aa9$export$9f39065591191e00() {
    const contextValue = (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).useContext($41c4234a416d1aa9$var$InstallContext);
    if (!contextValue) throw new Error('useInstallationLock must be used from within InstallationLockProvider');
    return contextValue;
}

});

parcelRegister("lOrRB", function(module, exports) {

$parcel$export(module.exports, "useMarketplaceAppInstall", () => $fe13e1977550ee54$export$691faccdcdea5ad7);

var $5zQU9 = parcelRequire("5zQU9");

var $e3rcq = parcelRequire("e3rcq");

var $dKnCb = parcelRequire("dKnCb");
var $f2QOW = parcelRequire("f2QOW");
var $9osuT = parcelRequire("9osuT");

var $jaVVd = parcelRequire("jaVVd");
var $buxnS = parcelRequire("buxnS");

var $inwKI = parcelRequire("inwKI");

var $fUOHe = parcelRequire("fUOHe");

var $cVLrH = parcelRequire("cVLrH");
var $iyohm = parcelRequire("iyohm");

var $6LpFI = parcelRequire("6LpFI");

var $ighTk = parcelRequire("ighTk");
var $1S6Gv = parcelRequire("1S6Gv");
var $bTrQR = parcelRequire("bTrQR");

var $eUqFw = parcelRequire("eUqFw");

var $iUPNF = parcelRequire("iUPNF");

var $7YbkQ = parcelRequire("7YbkQ");

var $7Uh51 = parcelRequire("7Uh51");

var $5JCOp = parcelRequire("5JCOp");

var $ifMZN = parcelRequire("ifMZN");

var $55gtq = parcelRequire("55gtq");

var $3lzNh = parcelRequire("3lzNh");

var $9IC13 = parcelRequire("9IC13");

var $hdXYz = parcelRequire("hdXYz");

var $2FnMA = parcelRequire("2FnMA");

var $5E4rM = parcelRequire("5E4rM");

var $1nC6Q = parcelRequire("1nC6Q");

var $8pHa5 = parcelRequire("8pHa5");

var $atCSv = parcelRequire("atCSv");

var $jKojs = parcelRequire("jKojs");

var $kNokf = parcelRequire("kNokf");

var $2bHSm = parcelRequire("2bHSm");

var $lHkHI = parcelRequire("lHkHI");
function $fe13e1977550ee54$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $fe13e1977550ee54$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $fe13e1977550ee54$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $fe13e1977550ee54$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $fe13e1977550ee54$var$APP_INSTALLER_STATES = {
    INITIALIZED: 'INITIALIZED',
    DETERMINING: 'DETERMINING',
    AWAITING_USER_CONFIRMATION: 'AWAITING_USER_CONFIRMATION',
    INSTALL_IN_PROGRESS: 'INSTALL_IN_PROGRESS',
    INSTALL_SUCCESS: 'INSTALL_SUCCESS',
    INSTALL_FAILED: 'INSTALL_FAILED',
    INSTALL_DISMISSED: 'INSTALL_DISMISSED'
};
function $fe13e1977550ee54$export$691faccdcdea5ad7(spi, appInstallConfig, installLocation, vendorSupportTicketUrl) {
    const [installIdentifier, setInstallIdentifier] = (0, $eUqFw.useState)(null);
    const [appInstallerState, setAppInstallerState] = (0, $eUqFw.useState)($fe13e1977550ee54$var$APP_INSTALLER_STATES.INITIALIZED);
    const { installationState: installationState, dispatch: installationStateDispatch } = (0, $5E4rM.useInstallationLock)();
    const featureFlags = (0, $inwKI.useFeatureFlags)();
    const { hostInfo: hostInfo, hostConfig: hostConfig } = (0, $2bHSm.useHostData)();
    const currentUser = (0, $kNokf.useCurrentUser)();
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const installFeedbackConfigRef = (0, $eUqFw.useRef)();
    (0, $eUqFw.useEffect)(()=>{
        if (hostInfo && currentUser !== null && currentUser !== void 0 && currentUser.atlassianAccountId) {
            (0, $7YbkQ.default).init(appInstallConfig, hostConfig, hostInfo);
            (0, $5JCOp.initializeBackends)(hostInfo, (0, $iyohm.makeUserId)(currentUser.atlassianAccountId));
        }
    }, [
        hostInfo,
        currentUser
    ]);
    (0, $eUqFw.useEffect)(()=>{
        const isDev = appInstallConfig.environment === 'local' || appInstallConfig.environment === 'dev';
        const releaseVersion = "EMCEE_NATIVE_".concat((0, $iUPNF.default)).concat(isDev ? '-dev' : '');
        (0, $1S6Gv.initSentry)($fe13e1977550ee54$var$_objectSpread($fe13e1977550ee54$var$_objectSpread({}, appInstallConfig.sentryConfig), {}, {
            releaseVersion: releaseVersion,
            setupGlobalListeners: false
        }));
    }, [
        appInstallConfig
    ]);
    (0, $eUqFw.useMemo)(()=>(0, $55gtq.initSPI)(spi), [
        spi
    ]);
    (0, $eUqFw.useEffect)(()=>{
        var _getSentryClient;
        if (installIdentifier === null) return;
        (_getSentryClient = (0, $ighTk.default)()) === null || _getSentryClient === void 0 || _getSentryClient.setTag('installLocation', installLocation);
        return ()=>{
            var _getSentryClient2;
            (_getSentryClient2 = (0, $ighTk.default)()) === null || _getSentryClient2 === void 0 || _getSentryClient2.setTag('installLocation', undefined);
        };
    }, [
        installLocation,
        installIdentifier
    ]);
    const baseData = (0, $jKojs.useAppInstallBaseData)(appInstallConfig.mpacBaseUrl, appInstallConfig.graphQLGatewayUrl, appInstallConfig.environment, installIdentifier, hostInfo);
    const { fireEvent: fireEvent, analyticsContext: analyticsContext } = (0, $atCSv.useAppInstallAnalytics)({
        baseData: baseData,
        installLocation: installLocation
    });
    const handleInstallDialogRendered = ()=>{
        setAppInstallerState($fe13e1977550ee54$var$APP_INSTALLER_STATES.AWAITING_USER_CONFIRMATION);
        fireEvent.viewedScreen.awaitingUserConfirmation();
    };
    const handleAppInstallDialogClose = ()=>setAppInstallerState($fe13e1977550ee54$var$APP_INSTALLER_STATES.INSTALL_DISMISSED);
    const dismissInstallErrorFlag = (appIdentifier)=>setTimeout(()=>{
            var _installFeedbackConfi;
            return (_installFeedbackConfi = installFeedbackConfigRef.current) === null || _installFeedbackConfi === void 0 ? void 0 : _installFeedbackConfi.flags.dismiss((0, $2FnMA.appInstallFlagKeys).installError(appIdentifier));
        }, 0);
    const showAppInstallInProgressStatus = (appIdentifier, appName)=>{
        var _installFeedbackConfi2;
        (_installFeedbackConfi2 = installFeedbackConfigRef.current) === null || _installFeedbackConfi2 === void 0 || _installFeedbackConfi2.flags.show((0, $2FnMA.getInstallInProgressFlagProps)(appIdentifier, appName, (flagId)=>{
            var _installFeedbackConfi3;
            return (_installFeedbackConfi3 = installFeedbackConfigRef.current) === null || _installFeedbackConfi3 === void 0 ? void 0 : _installFeedbackConfi3.flags.dismiss(flagId);
        }));
    };
    const showAppInstallSuccessStatus = (appIdentifier, appName, installedAddon)=>{
        var _installFeedbackConfi4, _installFeedbackConfi5, _installFeedbackConfi6;
        (_installFeedbackConfi4 = installFeedbackConfigRef.current) === null || _installFeedbackConfi4 === void 0 || _installFeedbackConfi4.flags.show((0, $2FnMA.getInstallSuccessFlagProps)(appIdentifier, appName, installedAddon));
        (_installFeedbackConfi5 = installFeedbackConfigRef.current) === null || _installFeedbackConfi5 === void 0 || _installFeedbackConfi5.flags.dismiss((0, $2FnMA.appInstallFlagKeys).noSimultaneousInstalls());
        (_installFeedbackConfi6 = installFeedbackConfigRef.current) === null || _installFeedbackConfi6 === void 0 || _installFeedbackConfi6.flags.dismiss((0, $2FnMA.appInstallFlagKeys).inProgress(appIdentifier));
    };
    const showAppInstallFailureStatus = (_ref)=>{
        var _installFeedbackConfi7, _installFeedbackConfi9, _installFeedbackConfi10;
        let { appIdentifier: appIdentifier, installError: installError, appName: appName } = _ref;
        (_installFeedbackConfi7 = installFeedbackConfigRef.current) === null || _installFeedbackConfi7 === void 0 || _installFeedbackConfi7.flags.show((0, $2FnMA.getInstallErrorFlagProps)({
            appIdentifier: appIdentifier,
            hostConfig: hostConfig,
            installError: installError,
            featureFlags: featureFlags,
            appName: appName,
            onDismiss: ()=>{
                var _installFeedbackConfi8;
                return (_installFeedbackConfi8 = installFeedbackConfigRef.current) === null || _installFeedbackConfi8 === void 0 ? void 0 : _installFeedbackConfi8.flags.dismiss((0, $2FnMA.appInstallFlagKeys).installError(appIdentifier));
            },
            vendorSupportTicketUrl: vendorSupportTicketUrl
        }));
        (_installFeedbackConfi9 = installFeedbackConfigRef.current) === null || _installFeedbackConfi9 === void 0 || _installFeedbackConfi9.flags.dismiss((0, $2FnMA.appInstallFlagKeys).noSimultaneousInstalls());
        (_installFeedbackConfi10 = installFeedbackConfigRef.current) === null || _installFeedbackConfi10 === void 0 || _installFeedbackConfi10.flags.dismiss((0, $2FnMA.appInstallFlagKeys).inProgress(appIdentifier));
    };
    const showSimultaneousInstallAttemptedErrorStatus = ()=>{
        var _installFeedbackConfi11;
        (_installFeedbackConfi11 = installFeedbackConfigRef.current) === null || _installFeedbackConfi11 === void 0 || _installFeedbackConfi11.flags.show((0, $2FnMA.getSimultaneousInstallErrorFlagProps)());
    };
    const showAppInstallationBlockageErrorStatus = (appIdentifier)=>{
        var _installFeedbackConfi12;
        (_installFeedbackConfi12 = installFeedbackConfigRef.current) === null || _installFeedbackConfi12 === void 0 || _installFeedbackConfi12.flags.show((0, $2FnMA.getCCPBillingSystemErrorFlag)(appIdentifier));
    };
    const installInProgress = ()=>installationState.installationInProgressAppKey !== null;
    const isAppInstallationSupported = (installMode)=>(0, $buxnS.isFreeApp)(installMode.installableApp.marketplaceAppDetails.paymentModel) || baseData.result.hostData.hostLicense.billingSystem === (0, $cVLrH.BillingSystem).HAMS || baseData.result.hostData.hostLicense.billingSystem === (0, $cVLrH.BillingSystem).CCP;
    const allowRequestFromRegion = async ()=>{
        try {
            const geoDetails = await (0, $jaVVd.getCurrentGeoIPRegion)(appInstallConfig.mpacBaseUrl);
            const { countryCode: countryCode } = geoDetails;
            if ((0, $e3rcq.isCountryBlacklisted)(countryCode)) {
                fireAnalyticsEvent((0, $dKnCb.makeAnalyticsData)({
                    eventType: (0, $7Uh51.AppInstallBlockedForRussianUserEvent),
                    actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_RUSSIAN_USER_BLOCKED)
                }).toObject());
                (0, $bTrQR.default).info('useMarketplaceInstallApp', 'Prevented app install for Russia');
                return false;
            } else return true;
        } catch (error) {
            (0, $bTrQR.default).error('useMarketplaceAppInstall', "Failed to retrieve geoIP", {
                error: error
            });
            return true;
        }
    };
    const handleAppInstallClick = async (installableAppIdentifier)=>{
        var _installFeedbackConfi14, _installFeedbackConfi15, _installFeedbackConfi16;
        const { appIdentifier: appIdentifier, installMode: installMode, hostData: hostData } = baseData.result;
        if (!(0, $9IC13.installableAppIdentifiersAreEqual)(installMode.installableAppId, installableAppIdentifier)) {
            (0, $bTrQR.default).error('useMarketplaceAppInstall', 'App requested to be installed differs from installMode data');
            return;
        }
        if (!isAppInstallationSupported(installMode)) {
            setAppInstallerState($fe13e1977550ee54$var$APP_INSTALLER_STATES.INSTALL_FAILED);
            showAppInstallationBlockageErrorStatus(appIdentifier);
            return;
        }
        const appKey = (0, $8pHa5.getAppKeyFromInstallableAppIdentifier)(appIdentifier);
        const appName = installMode.installableApp.details.name;
        installationStateDispatch({
            type: 'set_install_in_progress',
            payload: {
                appKey: appKey
            }
        });
        setAppInstallerState($fe13e1977550ee54$var$APP_INSTALLER_STATES.INSTALL_IN_PROGRESS);
        if (featureFlags.disableAppInstall) {
            const allowRegionRequest = await allowRequestFromRegion();
            if (!allowRegionRequest) {
                var _installFeedbackConfi13;
                handleAppInstallDialogClose();
                installationStateDispatch({
                    type: 'clear_install_in_progress'
                });
                (_installFeedbackConfi13 = installFeedbackConfigRef.current) === null || _installFeedbackConfi13 === void 0 || _installFeedbackConfi13.flags.show((0, $e3rcq.flagConfigForRussianUsers));
                return;
            }
        }
        if (!((_installFeedbackConfi14 = installFeedbackConfigRef.current) !== null && _installFeedbackConfi14 !== void 0 && _installFeedbackConfi14.suppressProgressFlag)) showAppInstallInProgressStatus(appKey, appName);
        dismissInstallErrorFlag(appKey);
        (0, $3lzNh.AppInstallTask).start();
        (_installFeedbackConfi15 = installFeedbackConfigRef.current) === null || _installFeedbackConfi15 === void 0 || (_installFeedbackConfi16 = _installFeedbackConfi15.onInstallStarted) === null || _installFeedbackConfi16 === void 0 || _installFeedbackConfi16.call(_installFeedbackConfi15, {
            appKey: appKey,
            appName: appName
        });
        (0, $55gtq.default)().installAddon({
            identifier: (0, $ifMZN.toSPIInstallableAddonIdentifier)(appIdentifier),
            paymentModel: installMode.installableApp.marketplaceAppDetails.paymentModel
        }, {
            contextId: hostData.hostInfo.globalContext.workspaceAri,
            billing: {
                system: baseData.result.hostData.hostLicense.billingSystem
            },
            productName: baseData.result.hostData.hostInfo.product,
            cmtEligible: installMode.installableApp.cloudMigrationTrial.isEligible
        }, {
            retryForLicenseDetails: featureFlags.enableRetryForLicenseDetailsPostInstallation,
            /* Flag passed to trigger the app subscribe flow instead of the app install flow for paid Forge apps which are installed
      on HAMS sites but are unsubscribed.
      A separate flag is not passed for CCP since the endpoint called for install and subscribe are the same in the case of CCP sites.
      */ enableReactivateForgeAppFromEmcee: featureFlags.enableReactivateForgeAppFromEmceeForHAMS && baseData.result.hostData.hostLicense.billingSystem === (0, $cVLrH.BillingSystem).HAMS,
            enableDeprecatedInstallationsGQL: featureFlags.enableDeprecatedInstallationsGQL
        }).then((installedApp)=>{
            var _installFeedbackConfi17, _installFeedbackConfi18;
            showAppInstallSuccessStatus(appKey, appName, installedApp);
            (0, $3lzNh.AppInstallTask).succeeded();
            installationStateDispatch({
                type: 'installation_success',
                payload: {
                    installedApp: installedApp,
                    enableDeprecatedInstallationsGQL: featureFlags.enableDeprecatedInstallationsGQL
                }
            });
            setAppInstallerState($fe13e1977550ee54$var$APP_INSTALLER_STATES.INSTALL_SUCCESS);
            fireEvent.installSucceeded(appKey);
            (_installFeedbackConfi17 = installFeedbackConfigRef.current) === null || _installFeedbackConfi17 === void 0 || (_installFeedbackConfi18 = _installFeedbackConfi17.onInstallSuccess) === null || _installFeedbackConfi18 === void 0 || _installFeedbackConfi18.call(_installFeedbackConfi17, installedApp);
        }).catch((error)=>{
            var _installFeedbackConfi19, _installFeedbackConfi20;
            (0, $bTrQR.default).error('useMarketplaceAppInstall', "Failed to install the App", {
                error: error,
                tags: {
                    installLocation: installLocation
                }
            });
            showAppInstallFailureStatus({
                appIdentifier: appKey,
                installError: error,
                appName: appName
            });
            // Add error log to get the stack trace for the app install error code 12
            if (error.code === '12') (0, $bTrQR.default).error('useMarketplaceAppInstall', "App install failed for app ".concat(appKey, " with error code ").concat(error.code));
            (0, $9IC13.trackAppInstallTelemetryTaskError)(error);
            installationStateDispatch({
                type: 'clear_install_in_progress'
            });
            setAppInstallerState($fe13e1977550ee54$var$APP_INSTALLER_STATES.INSTALL_FAILED);
            fireEvent.installFailed(appKey, error);
            (_installFeedbackConfi19 = installFeedbackConfigRef.current) === null || _installFeedbackConfi19 === void 0 || (_installFeedbackConfi20 = _installFeedbackConfi19.onInstallFailure) === null || _installFeedbackConfi20 === void 0 || _installFeedbackConfi20.call(_installFeedbackConfi19, {
                appKey: appKey,
                appName: appName
            });
        }).finally(()=>setInstallIdentifier(null));
    };
    const onInstallClick = (installableAppIdentifier)=>{
        (0, $fUOHe.default).traceUFOPress('install-app');
        handleAppInstallClick(installableAppIdentifier);
    };
    const getInstallerElement = ()=>{
        var _installFeedbackConfi21, _installFeedbackConfi22;
        const showAppInstallDialog = appInstallerState === $fe13e1977550ee54$var$APP_INSTALLER_STATES.DETERMINING || appInstallerState === $fe13e1977550ee54$var$APP_INSTALLER_STATES.AWAITING_USER_CONFIRMATION || appInstallerState === $fe13e1977550ee54$var$APP_INSTALLER_STATES.INSTALL_IN_PROGRESS && ((_installFeedbackConfi21 = installFeedbackConfigRef.current) === null || _installFeedbackConfi21 === void 0 ? void 0 : _installFeedbackConfi21.suppressProgressFlag);
        const appKey = (0, $8pHa5.getAppKeyFromInstallIdentifier)(installIdentifier);
        return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
            id: "marketplace-app-installer-root",
            children: showAppInstallDialog && ((_installFeedbackConfi22 = installFeedbackConfigRef.current) === null || _installFeedbackConfi22 === void 0 ? void 0 : _installFeedbackConfi22.flags) && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6LpFI.FlagsImplementationProvider), {
                value: {
                    showFlag: installFeedbackConfigRef.current.flags.show,
                    dismissFlag: installFeedbackConfigRef.current.flags.dismiss
                },
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $f2QOW.default), $fe13e1977550ee54$var$_objectSpread($fe13e1977550ee54$var$_objectSpread({}, analyticsContext), {}, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hdXYz.default), {
                        appInstallConfig: appInstallConfig,
                        appKey: appKey,
                        onClose: handleAppInstallDialogClose,
                        onRendered: handleInstallDialogRendered,
                        onInstallClick: onInstallClick,
                        baseData: baseData,
                        isInstallInProgress: installInProgress
                    })
                }))
            })
        });
    };
    const handleAppInstallStart = (appKey, installFeedbackConfig)=>{
        installFeedbackConfigRef.current = installFeedbackConfig;
        if (installInProgress()) {
            showSimultaneousInstallAttemptedErrorStatus();
            return;
        }
        if (typeof appKey === 'string') setInstallIdentifier((0, $1nC6Q.makeMarketplaceAppKeyIdentifier)(appKey));
        else setInstallIdentifier((0, $1nC6Q.makeInstallableAppKeyIdentifier)(appKey));
        setAppInstallerState($fe13e1977550ee54$var$APP_INSTALLER_STATES.DETERMINING);
        fireEvent.viewedScreen.determining();
    };
    return {
        installerElement: getInstallerElement(),
        installApp: handleAppInstallStart,
        installAppByInstallableIdentifier: handleAppInstallStart
    };
}

});
parcelRegister("e3rcq", function(module, exports) {

$parcel$export(module.exports, "flagConfigForRussianUsers", () => $a3b671ba29ce97fb$export$dec00d1652aa41c7);
$parcel$export(module.exports, "isCountryBlacklisted", () => $a3b671ba29ce97fb$export$1eed75c8ca844d5f);

var $bm7IM = parcelRequire("bm7IM");
const $a3b671ba29ce97fb$var$RUSSIA_ISO_CODE = 'RU';
const $a3b671ba29ce97fb$var$BELARUS_ISO_CODE = 'BY';
const $a3b671ba29ce97fb$var$BLACKLISTED_COUNTRIES = [
    $a3b671ba29ce97fb$var$RUSSIA_ISO_CODE,
    $a3b671ba29ce97fb$var$BELARUS_ISO_CODE
];
const $a3b671ba29ce97fb$var$MESSAGE_TITLE = "We stand with Ukraine";
const $a3b671ba29ce97fb$var$MESSAGE_DESCRIPTION = 'We have a commitment to our customers to provide a trusted service. Hence, we are pausing the sale of all new software to Russia and Belarus.';
const $a3b671ba29ce97fb$var$MESSAGE_LINK = 'https://www.atlassian.com/blog/announcements/atlassian-stands-with-ukraine';
const $a3b671ba29ce97fb$export$dec00d1652aa41c7 = {
    id: 'marketplace-app-install-blocked-region-denied-service',
    title: $a3b671ba29ce97fb$var$MESSAGE_TITLE,
    description: $a3b671ba29ce97fb$var$MESSAGE_DESCRIPTION,
    type: (0, $bm7IM.FLAG_TYPE_ERROR),
    isAutoDismiss: true,
    actions: [
        {
            content: 'Read the public blog',
            href: $a3b671ba29ce97fb$var$MESSAGE_LINK,
            target: '_blank'
        }
    ]
};
const $a3b671ba29ce97fb$export$1eed75c8ca844d5f = (countryCode)=>$a3b671ba29ce97fb$var$BLACKLISTED_COUNTRIES.some((blacklistedCountry)=>blacklistedCountry === countryCode);

});
parcelRegister("bm7IM", function(module, exports) {

$parcel$export(module.exports, "FLAG_TYPE_SUCCESS", () => $8447bd1290229122$export$1d0740fae54799e6);
$parcel$export(module.exports, "FLAG_TYPE_ERROR", () => $8447bd1290229122$export$b0516b50882e8fbc);
$parcel$export(module.exports, "FLAG_TYPE_INFO", () => $8447bd1290229122$export$f1471fc4e853391b);
$parcel$export(module.exports, "FLAG_TYPE_WARNING", () => $8447bd1290229122$export$3e8caae81220a92d);
const $8447bd1290229122$export$1d0740fae54799e6 = 'success';
const $8447bd1290229122$export$b0516b50882e8fbc = 'error';
const $8447bd1290229122$export$f1471fc4e853391b = 'info';
const $8447bd1290229122$export$3e8caae81220a92d = 'warning';
let $8447bd1290229122$export$ef846fa6d1318a9b = /*#__PURE__*/ function(TilesVariation) {
    TilesVariation["LARGE"] = "LARGE";
    TilesVariation["SMALL"] = "SMALL";
    return TilesVariation;
}({});
let $8447bd1290229122$export$581091871f506bfa = /*#__PURE__*/ function(HighlightedSectionVariation) {
    HighlightedSectionVariation["PROMINENT"] = "PROMINENT";
    return HighlightedSectionVariation;
}({});
let $8447bd1290229122$export$34b2fc32d759efd8 = /*#__PURE__*/ function(ProductMarketingGroupType) {
    ProductMarketingGroupType["COLLECTION"] = "COLLECTION";
    ProductMarketingGroupType["CATEGORY"] = "CATEGORY";
    return ProductMarketingGroupType;
}({});

});


parcelRegister("jaVVd", function(module, exports) {

$parcel$export(module.exports, "getCurrentGeoIPRegion", () => $df5be18c127b9147$export$c2d4a31573de5dfc);

var $dO8LH = parcelRequire("dO8LH");
const $df5be18c127b9147$export$c2d4a31573de5dfc = (mpacBaseUrl)=>(0, $dO8LH.fetchOk)("".concat(mpacBaseUrl, "/rest/2/geoip")).then((response)=>response.json());

});

parcelRegister("9IC13", function(module, exports) {

$parcel$export(module.exports, "installableAppIdentifiersAreEqual", () => $7135b64fd823227a$export$a6ebc066f4a547c0);
$parcel$export(module.exports, "trackAppInstallTelemetryTaskError", () => $7135b64fd823227a$export$1525d8981e97c316);

var $fUOHe = parcelRequire("fUOHe");

var $jM4Wc = parcelRequire("jM4Wc");

var $ifMZN = parcelRequire("ifMZN");

var $3lzNh = parcelRequire("3lzNh");
const $7135b64fd823227a$export$a6ebc066f4a547c0 = (a, b)=>(0, $ifMZN.foldInstallableAppIdentifier)(a)((installableAppByKeyId)=>installableAppByKeyId.equals(b), (installableAppByUrlId)=>installableAppByUrlId.equals(b), ()=>true);
const $7135b64fd823227a$export$1525d8981e97c316 = (error)=>{
    (0, $fUOHe.default).setUFOInteractionError({
        name: 'install-app-failed',
        errorMessage: error.code
    }, 'install-app');
    if ((0, $jM4Wc.AppInstallationPartnerErrorCodeOwnership)[error.code]) {
        (0, $3lzNh.AppInstallFailurePartner).start();
        (0, $3lzNh.AppInstallFailurePartner).failed(error, error.code); // Additional event to track errors due to partners
        (0, $3lzNh.AppInstallTask).abort(); // AppInstall Task is aborted here as failure due to an error code where the partner is responsible should not be counted in our app installation metric
    } else if ((0, $jM4Wc.AppInstallCustomerErrorCodeOwnership)[error.code]) {
        (0, $3lzNh.AppInstallFailureCustomer).start();
        (0, $3lzNh.AppInstallFailureCustomer).failed(error, error.code); // Additional event to track errors due to customers
        (0, $3lzNh.AppInstallTask).abort(); // AppInstall Task is aborted here as failure due to an error code where the customer/user is responsible should not be counted in our app installation metric
    } else {
        var _AppInstallAtlassianE;
        (0, $3lzNh.AppInstallTask).failed(error, error.code);
        if (((_AppInstallAtlassianE = (0, $jM4Wc.AppInstallAtlassianErrorCodeOwnership)[error.code]) === null || _AppInstallAtlassianE === void 0 ? void 0 : _AppInstallAtlassianE.primaryOwner) === (0, $jM4Wc.Owners).Downstream) {
            (0, $3lzNh.AppInstallFailureDownstream).start();
            (0, $3lzNh.AppInstallFailureDownstream).failed(error, error.code); // Additional event to track errors due to downstream services
        } else {
            (0, $3lzNh.AppInstallFailureMarketplace).start();
            (0, $3lzNh.AppInstallFailureMarketplace).failed(error, error.code); // Additional event to track errors due to marketplace services
        }
    }
};

});
parcelRegister("jM4Wc", function(module, exports) {

$parcel$export(module.exports, "Owners", () => $e656548815279dad$export$be90eba74a871053);
$parcel$export(module.exports, "AppInstallAtlassianErrorCodeOwnership", () => $e656548815279dad$export$c0e5898acf0cbfed);
$parcel$export(module.exports, "AppInstallationPartnerErrorCodeOwnership", () => $e656548815279dad$export$645b42a0bfb4f809);
$parcel$export(module.exports, "AppInstallCustomerErrorCodeOwnership", () => $e656548815279dad$export$9ce45f8f6d9e94e7);
/** These are the list of error codes which could lead to the failure of installing an app.
 * They are divided into 3 categories as per their owners: Atlassian, Partner & Customer
 * Also there is information added about the services for each of the error codes.
 */ var $e656548815279dad$export$be90eba74a871053 = /*#__PURE__*/ function(Owners) {
    Owners[Owners["Downstream"] = 0] = "Downstream";
    Owners[Owners["Marketplace"] = 1] = "Marketplace";
    Owners[Owners["Partner"] = 2] = "Partner";
    Owners[Owners["Customer"] = 3] = "Customer";
    return Owners;
}($e656548815279dad$export$be90eba74a871053 || {});
var $e656548815279dad$var$Services = /*#__PURE__*/ function(Services) {
    Services[Services["UPM"] = 0] = "UPM";
    Services[Services["COFS"] = 1] = "COFS";
    Services[Services["TCS"] = 2] = "TCS";
    Services[Services["Connect"] = 3] = "Connect";
    Services[Services["CAAS"] = 4] = "CAAS";
    Services[Services["AppCatalog"] = 5] = "AppCatalog";
    Services[Services["BAG"] = 6] = "BAG";
    Services[Services["Demand"] = 7] = "Demand";
    Services[Services["CCP"] = 8] = "CCP";
    Services[Services["Marketplace"] = 9] = "Marketplace";
    return Services;
}($e656548815279dad$var$Services || {});
const $e656548815279dad$export$c0e5898acf0cbfed = {
    'upm.plugin.error.install.error': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.UPM
        ]
    },
    'upm.plugin.error.timeout.license.change': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        otherOwners: [
            $e656548815279dad$export$be90eba74a871053.Customer
        ],
        services: [
            $e656548815279dad$var$Services.COFS,
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    'upm.error.invalid.token ': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    UPMTokenFetchError: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    UPMInstallPostError: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.UPM
        ]
    },
    FetchAddonInternalError: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.TCS,
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    AppProvisioningError: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.CCP
        ]
    },
    Undefined: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    FetchError: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    GraphQLFetchError: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    'unexpected.exception': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    '12': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    APP_REACTIVATION_NOT_SUPPORTED: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.CCP,
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    AppInstallationTaskFailedError: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.CAAS
        ]
    },
    'EcosystemCloudInstallPollFailure-unknown.error.code': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.CAAS
        ]
    },
    EcosystemCloudAppFetchFailed: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.CAAS
        ]
    },
    'cofs.billingApi.exception': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.BAG
        ]
    },
    'connect.install.error.conflicting.macro.alias': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        otherOwners: [
            $e656548815279dad$export$be90eba74a871053.Partner
        ],
        services: [
            $e656548815279dad$var$Services.Connect,
            $e656548815279dad$var$Services.CAAS,
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    'connect.install.error.dependencies.failed': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.Connect,
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    'connect.install.error.duplicate.macro.keys': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    /** Errors thrown via Store BFF flow */ InvalidInstallationTargetInfo: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    UnknownErrorInMarketplaceStoreAppInstall: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    UNSUPPORTED_BILLING_SYSTEM: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    APP_ALREADY_PROVISIONED: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.COFS,
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    PAYMENT_MODEL_NOT_FOUND: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.AppCatalog
        ]
    },
    INCOMPATIBLE_PRODUCT: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.AppCatalog,
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    FREE_APPS_PROVISIONING_NOT_SUPPORTED: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    TRANSACTION_ACCOUNT_ID_NOT_FOUND: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.CCP
        ]
    },
    CCP_ENTITLEMENT_RELATIONSHIP_NOT_FOUND: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.CCP
        ]
    },
    NO_RESOURCE_PACKAGE_FOUND: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Downstream,
        services: [
            $e656548815279dad$var$Services.COFS
        ]
    },
    PAYMENT_MODEL_NOT_SUPPORTED_FOR_INSTALLATION: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Marketplace,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    }
};
const $e656548815279dad$export$645b42a0bfb4f809 = {
    /* The following category of errors are only fixable by the partner */ 'connect.install.error.remote.host.bad.response': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.400': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.401': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.402': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.403': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.404': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.500': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.501': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.502': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.response.503': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.bad.domain': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.timeout': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.host.ssl': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.unknown.module': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.remote.descriptor.validation': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.deprecated.context.iframe.url': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.auth.with.no.installed.callback': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.page.with.invalid.condition': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.page.with.invalid.property': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.webhook.with.invalid.condition': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.missing.scope': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.no.modules': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.base_url.invalid_host': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.base_url.no_tls': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.location': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.location.mobile': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.platform.mobile': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.condition.parameters': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.missing.url': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.region.unsupported': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        otherOwners: [
            $e656548815279dad$export$be90eba74a871053.Marketplace
        ],
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.data.resident.validation.failed': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.blueprint.description.too_long': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.url.and.target.dialog.key': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.target.dialog.key': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.cacheable.iframe.url': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.webitem.dialogmodule.cacheable': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.webitem.pagecontext.cacheable': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.webhooks.url-params.deprecated': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.missing.dialogmodule.item.options': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.dialogoptions.dimension': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.invalid.dialogoptions.dimensions': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.dependencies.disabled': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.dependencies.multilevel.failed': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.marketplace.no.public.versions': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.i18n.disabled': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.i18n.download.malformed': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.i18n.download.value.long': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.duplicate.module.keys': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.entity_properties.modules.disabled': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        otherOwners: [
            $e656548815279dad$export$be90eba74a871053.Marketplace
        ],
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.user.provisioning': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.jira.issue.alpha': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        otherOwners: [
            $e656548815279dad$export$be90eba74a871053.Marketplace
        ],
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.remote.upm.install.exception': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'upm.pluginInstall.error.response.exception': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        otherOwners: [
            $e656548815279dad$export$be90eba74a871053.Marketplace
        ],
        services: [
            $e656548815279dad$var$Services.UPM
        ]
    },
    'upm.pluginInstall.error.install.failed': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.UPM
        ]
    },
    'upm.pluginInstall.error.unknown.plugin.type': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.UPM
        ]
    },
    'upm.pluginInstall.error.ssl': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.UPM
        ]
    },
    'connect.install.error.not.email.approved': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Partner,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    }
};
const $e656548815279dad$export$9ce45f8f6d9e94e7 = {
    /** This error is when the user has failed to update payment details in their instance */ 'connect.remote.upm.install.payment.failure.exception': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Customer,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    /** This error is when installation for the same forge app is already in progress - [MC-2837] */ TASK_ALREADY_EXISTS: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Customer,
        services: [
            $e656548815279dad$var$Services.Marketplace
        ]
    },
    /** Ignore erros specific to forge apps when install fails due to customer account pending renewal */ 'EcosystemCloudInstallPollFailure-account.pending.renewal': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Customer,
        services: [
            $e656548815279dad$var$Services.CAAS
        ]
    },
    'connect.install.error.addon.admin.permission': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Customer,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.locked': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Customer,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    'connect.install.error.nodefaultgroup': {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Customer,
        services: [
            $e656548815279dad$var$Services.Connect
        ]
    },
    /** This can occur if the parent product does not have an active license.*/ NO_CCP_ENTITLEMENT_FOR_PRODUCT: {
        primaryOwner: $e656548815279dad$export$be90eba74a871053.Customer,
        services: [
            $e656548815279dad$var$Services.CCP
        ]
    }
};

});


parcelRegister("2FnMA", function(module, exports) {

$parcel$export(module.exports, "appInstallFlagKeys", () => $1f11dbd45093130c$export$84cd79558c737149);
$parcel$export(module.exports, "getInstallInProgressFlagProps", () => $1f11dbd45093130c$export$e0fa3d2a18e86367);
$parcel$export(module.exports, "INSTALL_SUCCESS_ACTION_CONTENT", () => $1f11dbd45093130c$export$6c588cb5c24e1f0d);
$parcel$export(module.exports, "getInstallSuccessFlagProps", () => $1f11dbd45093130c$export$445af327658688bc);
$parcel$export(module.exports, "getInstallErrorFlagProps", () => $1f11dbd45093130c$export$f6d7483e1ee8fccd);
$parcel$export(module.exports, "getSimultaneousInstallErrorFlagProps", () => $1f11dbd45093130c$export$b685409e9c4361f8);
$parcel$export(module.exports, "getCCPBillingSystemErrorFlag", () => $1f11dbd45093130c$export$54717cf88fca095b);

var $bm7IM = parcelRequire("bm7IM");

var $c9Mth = parcelRequire("c9Mth");

var $jM4Wc = parcelRequire("jM4Wc");

var $hsaiM = parcelRequire("hsaiM");

var $gISS4 = parcelRequire("gISS4");
const $1f11dbd45093130c$export$84cd79558c737149 = {
    inProgress: (appIdentifier)=>"".concat(appIdentifier, "-app-install-in-progress"),
    installSuccess: (appIdentifier)=>"".concat(appIdentifier, "-app-install-success"),
    installError: (appIdentifier)=>"".concat(appIdentifier, "-app-install-error"),
    noSimultaneousInstalls: ()=>'no-simultaneous-installs-allowed'
};
function $1f11dbd45093130c$export$e0fa3d2a18e86367(appIdentifier, appName, onDismiss) {
    return {
        id: $1f11dbd45093130c$export$84cd79558c737149.inProgress(appIdentifier),
        type: (0, $bm7IM.FLAG_TYPE_INFO),
        title: "Adding ".concat(appName, "..."),
        description: "We'll tell you when your app has been added.",
        isAutoDismiss: false,
        actions: [
            {
                content: 'Close',
                onClick: ()=>onDismiss($1f11dbd45093130c$export$84cd79558c737149.inProgress(appIdentifier))
            }
        ]
    };
}
const $1f11dbd45093130c$export$6c588cb5c24e1f0d = Object.freeze({
    getStarted: 'Get started',
    configure: 'Configure',
    manageApp: 'Manage app'
});
function $1f11dbd45093130c$export$445af327658688bc(appIdentifier, appName, installedApp) {
    return {
        id: $1f11dbd45093130c$export$84cd79558c737149.installSuccess(appIdentifier),
        type: (0, $bm7IM.FLAG_TYPE_SUCCESS),
        title: "".concat(appName, " installed successfully"),
        description: 'Your app has been added to your instance and is ready for use.',
        isAutoDismiss: false,
        actions: [
            {
                content: $1f11dbd45093130c$export$6c588cb5c24e1f0d.getStarted,
                href: installedApp.getStartedUrl,
                target: '_blank'
            },
            {
                content: $1f11dbd45093130c$export$6c588cb5c24e1f0d.configure,
                href: installedApp.configureUrl,
                target: '_blank'
            },
            {
                content: $1f11dbd45093130c$export$6c588cb5c24e1f0d.manageApp,
                href: installedApp.manageAppUrl,
                target: '_blank'
            }
        ].filter((action)=>!!action.href)
    };
}
function $1f11dbd45093130c$export$f6d7483e1ee8fccd(_ref) {
    let { appIdentifier: appIdentifier, hostConfig: hostConfig, installError: installError, featureFlags: featureFlags, appName: appName, onDismiss: onDismiss, vendorSupportTicketUrl: vendorSupportTicketUrl } = _ref;
    const { showCustomBackendErrorsFromUpm: showCustomBackendErrorsFromUpm } = featureFlags;
    /**
   * Some of the UPM errors mappings are defined by 'message' ex: 'PaymentFailure'
   * while some of them through 'code' ex: 'connect.install.error.nodefaultgroup'.
   * These error mappings are in the hostConfig file.
   *
   * Some others which are not static are defined as separate functions:
   * ex: getCustomErrorDetails or getPartnerErrorDetails
   *
   * These should be unified through a single flow & the mappings should ideally be through 'code'
   * but should still have access to 'message' to handle complex usecases.
   */ let errorDetails;
    if ((0, $jM4Wc.AppInstallationPartnerErrorCodeOwnership)[installError.code]) errorDetails = $1f11dbd45093130c$var$getPartnerErrorDetails(appName, onDismiss, vendorSupportTicketUrl);
    else errorDetails = $1f11dbd45093130c$export$3dc00266b5fd0cd7({
        errorCode: installError.code,
        errorMessage: installError.message,
        appName: appName,
        onDismiss: onDismiss
    });
    if (!errorDetails) {
        var _hostConfig$errors$ge, _errorDetails$transla;
        errorDetails = (0, $hsaiM.getErrorDetails)(installError.message, hostConfig, {
            showCustomBackendErrorsFromUpm: showCustomBackendErrorsFromUpm
        });
        if (errorDetails.translation.description === ((_hostConfig$errors$ge = hostConfig.errors.get('default')) === null || _hostConfig$errors$ge === void 0 ? void 0 : _hostConfig$errors$ge.description)) errorDetails = (0, $hsaiM.getErrorDetails)(installError.code, hostConfig, {
            showCustomBackendErrorsFromUpm: showCustomBackendErrorsFromUpm
        });
        if (((_errorDetails$transla = errorDetails.translation.actions) === null || _errorDetails$transla === void 0 ? void 0 : _errorDetails$transla.length) > 0) errorDetails.actions = errorDetails.translation.actions;
        else if (onDismiss) errorDetails.actions = [
            {
                content: 'Got it',
                onClick: onDismiss
            }
        ];
    }
    return {
        id: $1f11dbd45093130c$export$84cd79558c737149.installError(appIdentifier),
        type: (0, $bm7IM.FLAG_TYPE_ERROR),
        title: errorDetails.title || errorDetails.translation.title,
        description: errorDetails.description || errorDetails.translation.description,
        isAutoDismiss: false,
        actions: errorDetails.actions
    };
}
function $1f11dbd45093130c$var$getConflictingAppNameFromErrorMessage() {
    let errorMessage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    // Expected errorMessage format - appKey for the app we're trying to install,appKey of the Conflicting app:Conflicting App Name:macro key
    if (typeof errorMessage !== 'string') return null;
    const splitOnComma = errorMessage.split(',');
    if (splitOnComma.length < 2) return null;
    const splitOnColon = splitOnComma[1].split(':');
    if (splitOnColon.length < 2) return null;
    return splitOnColon[1].trim();
}
const $1f11dbd45093130c$export$3dc00266b5fd0cd7 = (_ref2)=>{
    let { errorCode: errorCode, errorMessage: errorMessage, appName: appName, onDismiss: onDismiss } = _ref2;
    switch(errorCode){
        case (0, $gISS4.ERROR_CODE).FETCH_ADDON_INTERNAL_ERROR:
            return {
                title: "Fetching details for ".concat(appName),
                description: "Your app installation is in progress. It may take some time to initiate the subscription. We\u2019ll update you once it\u2019s done.",
                actions: [
                    {
                        content: 'Got it',
                        onClick: onDismiss
                    }
                ]
            };
        case (0, $gISS4.ERROR_CODE).TICKET:
            {
                const ticketNumber = (0, $c9Mth).getSupportTicketNumber(errorMessage);
                return {
                    title: 'Sorry, installation failed',
                    description: "We are unable to process your app request. A support ticket ".concat(ticketNumber, " has been created for you. We are working on it to resolve the issue at the earliest")
                };
            }
        case (0, $gISS4.ERROR_CODE).APP_REACTIVATION_NOT_SUPPORTED:
            return {
                title: "Unable to install ".concat(appName),
                description: "Unfortunately, we\u2019re unable to process your request. Please contact support to install the app.",
                actions: [
                    {
                        content: 'Contact support',
                        href: 'https://www.atlassian.com/company/contact/purchasing-licensing#/',
                        target: '_blank'
                    }
                ]
            };
        case (0, $gISS4.ERROR_CODE).UPM_PLUGIN_ERROR_TIMEOUT_LICENSE_CHANGE:
        case (0, $gISS4.ERROR_CODE).ECOSYSTEM_ACCOUNT_PENDING_RENEWAL:
        case (0, $gISS4.ERROR_CODE).CONNECT_PAYMENT_FAILURE_EXCEPTION:
            return {
                title: "Unable to install ".concat(appName),
                description: 'Please reconfirm your payment details and license status, and try again to install the app.',
                actions: [
                    {
                        content: 'Got it',
                        onClick: onDismiss
                    }
                ]
            };
        case (0, $gISS4.ERROR_CODE).CONNECT_INSTALL_ERROR_CONFLICTING_MACRO_ALIAS:
            return {
                title: "Unable to install ".concat(appName),
                description: "Unfortunately, we\u2019re unable to process your request due to a technical error.",
                actions: [
                    {
                        content: 'Got it',
                        onClick: onDismiss
                    }
                ]
            };
        case (0, $gISS4.ERROR_CODE).CONNECT_INSTALL_ERROR_DEPENDENCIES_FAILED:
            return {
                title: "Unable to install ".concat(appName),
                description: "Unfortunately, we\u2019re not able to process your request due to an unexpected error. Please retry again in some time.",
                actions: [
                    {
                        content: 'Got it',
                        onClick: onDismiss
                    }
                ]
            };
        case (0, $gISS4.ERROR_CODE).ECOSYSTEM_APP_DEACTIVATED:
        case (0, $gISS4.ERROR_CODE).UPM_INSTALL_POST_ERROR:
            return {
                title: "Unable to install ".concat(appName),
                description: "Unfortunately, we\u2019re not able to process your request due to an unexpected error. Please retry again in some time.",
                actions: [
                    {
                        content: 'Got it',
                        onClick: onDismiss
                    }
                ]
            };
        case (0, $gISS4.ERROR_CODE).ECOSYSTEM_APP_INSTALL_INPROGRESS:
        case (0, $gISS4.ERROR_CODE).CONNECT_INSTALL_ERROR_LOCKED:
            return {
                title: "Unable to install ".concat(appName),
                description: 'An installation is already in progress, and we cannot initiate a new one. Please try again in some time.',
                actions: [
                    {
                        content: 'Got it',
                        onClick: onDismiss
                    }
                ]
            };
        case (0, $gISS4.ERROR_CODE).CONNECT_DUPLICATE_MACRO_KEYS_EXCEPTION:
            return {
                title: "Unable to install ".concat(appName),
                description: "Your instance has ".concat($1f11dbd45093130c$var$getConflictingAppNameFromErrorMessage(errorMessage) || 'an app', " from the same partner that does not allow installation of ").concat(appName, " due to technical constraints."),
                actions: [
                    {
                        content: 'Learn more about the issue',
                        href: 'https://support.atlassian.com/confluence-cloud/docs/what-are-macros/#Conflicts-between-two-macros',
                        target: '_blank'
                    }
                ]
            };
    }
};
const $1f11dbd45093130c$var$getPartnerErrorDetails = (appName, onDismiss, vendorSupportTicketUrl)=>{
    if (vendorSupportTicketUrl) return {
        title: "Unable to install ".concat(appName),
        description: "Unfortunately, we\u2019re facing a technical issue with the partner. You can contact the partner to know more about the issue.",
        actions: [
            {
                content: 'Contact partner',
                href: vendorSupportTicketUrl,
                target: '_blank'
            }
        ]
    };
    else return {
        title: "Unable to install ".concat(appName),
        description: "Unfortunately, we\u2019re facing a technical issue with the partner. Please try again in some time.",
        actions: [
            {
                content: 'Got it',
                onClick: onDismiss
            }
        ]
    };
};
function $1f11dbd45093130c$export$b685409e9c4361f8() {
    return {
        id: $1f11dbd45093130c$export$84cd79558c737149.noSimultaneousInstalls(),
        type: (0, $bm7IM.FLAG_TYPE_INFO),
        title: 'Hold on!',
        description: 'Another installation is still in progress. Try again when it is complete.',
        isAutoDismiss: true
    };
}
function $1f11dbd45093130c$export$54717cf88fca095b(appIdentifier) {
    return {
        id: $1f11dbd45093130c$export$84cd79558c737149.installError(appIdentifier),
        type: (0, $bm7IM.FLAG_TYPE_ERROR),
        title: 'App installation failed',
        description: 'We are unable to process your request for app installation. Please contact the support team to understand the issue.',
        isAutoDismiss: false,
        actions: [
            {
                content: 'Contact support',
                href: 'https://www.atlassian.com/company/contact/purchasing-licensing',
                target: '_blank'
            }
        ]
    };
}

});
parcelRegister("gISS4", function(module, exports) {

$parcel$export(module.exports, "ERROR_CODE", () => $c2cb51a5accfc27a$export$fe20a4d016ee5cf3);
const $c2cb51a5accfc27a$export$fe20a4d016ee5cf3 = {
    TICKET: 'TICKET',
    APP_REACTIVATION_NOT_SUPPORTED: 'APP_REACTIVATION_NOT_SUPPORTED',
    FETCH_ADDON_INTERNAL_ERROR: 'FetchAddonInternalError',
    UPM_PLUGIN_ERROR_TIMEOUT_LICENSE_CHANGE: 'upm.plugin.error.timeout.license.change',
    CONNECT_INSTALL_ERROR_CONFLICTING_MACRO_ALIAS: 'connect.install.error.conflicting.macro.alias',
    CONNECT_INSTALL_ERROR_DEPENDENCIES_FAILED: 'connect.install.error.dependencies.failed',
    UPM_INSTALL_POST_ERROR: 'UPMInstallPostError',
    ECOSYSTEM_APP_DEACTIVATED: 'EcosystemCloudInstallPollFailure-app.deactivated',
    ECOSYSTEM_APP_INSTALL_INPROGRESS: 'EcosystemCloudInstallPollFailure-app.install.inprogress',
    ECOSYSTEM_APP_MISCONFIGURED: 'EcosystemCloudInstallPollFailure-app.misconfigured',
    ECOSYSTEM_ACCOUNT_PENDING_RENEWAL: 'EcosystemCloudInstallPollFailure-account.pending.renewal',
    CONNECT_INSTALL_ERROR_LOCKED: 'connect.install.error.locked',
    CONNECT_PAYMENT_FAILURE_EXCEPTION: 'connect.remote.upm.install.payment.failure.exception',
    CONNECT_DUPLICATE_MACRO_KEYS_EXCEPTION: 'connect.install.error.duplicate.macro.keys'
};

});


parcelRegister("8pHa5", function(module, exports) {

$parcel$export(module.exports, "getAppKeyFromInstallableAppIdentifier", () => $620223875cc040a2$export$328ad57b4962acc0);
$parcel$export(module.exports, "getAppKeyFromInstallIdentifier", () => $620223875cc040a2$export$3ab9bb8addbb8706);

var $ifMZN = parcelRequire("ifMZN");

var $1nC6Q = parcelRequire("1nC6Q");
const $620223875cc040a2$export$328ad57b4962acc0 = (installableAppIdentifier)=>(0, $ifMZN.foldInstallableAppIdentifier)(installableAppIdentifier)((key)=>key.key, (url)=>url.key, (ari)=>ari.appKey);
const $620223875cc040a2$export$3ab9bb8addbb8706 = (installIdentifier)=>{
    if (installIdentifier === null) return;
    if (installIdentifier.type === (0, $1nC6Q.MARKETPLACE_APP_KEY)) return installIdentifier.keyForInstall;
    return $620223875cc040a2$export$328ad57b4962acc0(installIdentifier.keyForInstall);
};

});

parcelRegister("atCSv", function(module, exports) {

$parcel$export(module.exports, "useAppInstallAnalytics", () => $7a0ac538078d83eb$export$8f4dddb2fd24bb4a);

var $5zQU9 = parcelRequire("5zQU9");

var $9osuT = parcelRequire("9osuT");

var $inwKI = parcelRequire("inwKI");

var $7IZKi = parcelRequire("7IZKi");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $gIQkA = parcelRequire("gIQkA");

var $i7hUf = parcelRequire("i7hUf");

var $k5vUT = parcelRequire("k5vUT");

var $8AJas = parcelRequire("8AJas");
function $7a0ac538078d83eb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $7a0ac538078d83eb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $7a0ac538078d83eb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $7a0ac538078d83eb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $7a0ac538078d83eb$export$b9fc5729d4f12057 = (installMode)=>{
    const noop = ()=>null;
    return (0, $i7hUf.foldInstallMode)(installMode)(/* determining */ noop, /* appSpecificPassword */ noop, (instructionalMode)=>instructionalMode.getIn([
            'instructionalApp',
            'details'
        ]), (installableMode)=>installableMode.getIn([
            'installableApp',
            'marketplaceAppDetails'
        ]), /* manualUrl */ noop, /* upgrade */ noop);
};
const $7a0ac538078d83eb$var$makeAnalyticsContextAttributes = (_ref)=>{
    let { baseData: baseData, installLocation: installLocation } = _ref;
    const attributes = {
        installLocation: installLocation,
        category: (0, $7Uh51.ANALYTICS_CATEGORY_MARKETPLACE_APP_INSTALL)
    };
    if (!baseData.result) return attributes;
    const appDetails = $7a0ac538078d83eb$export$b9fc5729d4f12057(baseData.result.installMode);
    if (!appDetails) return attributes;
    const { key: appKey, paymentModel: paymentModel, ecosystemCloudAppId: ecosystemCloudAppId, programs: programs } = appDetails;
    return $7a0ac538078d83eb$var$_objectSpread($7a0ac538078d83eb$var$_objectSpread($7a0ac538078d83eb$var$_objectSpread({}, attributes), {}, {
        appKey: appKey,
        paymentModel: paymentModel,
        programs: programs,
        isEcosystemCloudApp: !!ecosystemCloudAppId
    }, ecosystemCloudAppId && {
        ecosystemCloudAppId: ecosystemCloudAppId
    }), {}, {
        installPoweredByStoreBFF: (0, $8AJas.shouldInstallWithStoreBff)(baseData)
    });
};
const $7a0ac538078d83eb$var$makeAnalyticsContextProperties = (_ref2)=>{
    let { currentScreen: currentScreen } = _ref2;
    return $7a0ac538078d83eb$var$_objectSpread({}, currentScreen && {
        source: currentScreen.name
    });
};
const $7a0ac538078d83eb$export$8f4dddb2fd24bb4a = (_ref3)=>{
    let { baseData: baseData, installLocation: installLocation } = _ref3;
    const fireEvent = (0, $9osuT.useAnalyticsEvents)();
    const featureFlags = (0, $inwKI.useFeatureFlags)();
    const [currentScreen, setCurrentScreen] = (0, $eUqFw.useState)(null);
    const analyticsContext = (0, $eUqFw.useMemo)(()=>({
            properties: $7a0ac538078d83eb$var$makeAnalyticsContextProperties({
                currentScreen: currentScreen
            }),
            attributes: $7a0ac538078d83eb$var$makeAnalyticsContextAttributes({
                baseData: baseData,
                installLocation: installLocation,
                featureFlags: featureFlags
            })
        }), [
        baseData.pending,
        currentScreen,
        installLocation
    ]);
    const fireScreenEvent = function fireScreenEvent(eventType) {
        let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return fireEvent((0, (/*@__PURE__*/$parcel$interopDefault($7IZKi)))([
            {
                eventType: eventType
            },
            {
                attributes: analyticsContext.attributes
            },
            payload
        ]));
    };
    const fireTrackEvent = function fireTrackEvent(eventType) {
        let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return fireEvent((0, (/*@__PURE__*/$parcel$interopDefault($7IZKi)))([
            {
                eventType: eventType
            },
            {
                source: currentScreen,
                attributes: analyticsContext.attributes
            },
            payload
        ]));
    };
    return {
        fireEvent: {
            viewedScreen: {
                determining: ()=>{
                    fireScreenEvent((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_INSTALL_DETERMINING));
                    setCurrentScreen((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_INSTALL_DETERMINING));
                },
                awaitingUserConfirmation: ()=>{
                    if (baseData.result && baseData.result.installMode.type === (0, $k5vUT.INSTRUCTIONAL_INSTALL_MODE)) {
                        fireScreenEvent((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_INSTRUCTIONAL_APP_INSTALL));
                        setCurrentScreen((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_INSTRUCTIONAL_APP_INSTALL));
                    } else {
                        fireScreenEvent((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_INSTALL));
                        setCurrentScreen((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_INSTALL));
                    }
                }
            },
            installSucceeded: (appKey)=>{
                fireTrackEvent((0, $7Uh51.AppInstalledEvent), {
                    actionSubjectId: appKey
                });
                setCurrentScreen(null);
            },
            installFailed: (appKey, error)=>{
                fireTrackEvent((0, $7Uh51.AppInstallFailedEvent), {
                    actionSubjectId: appKey,
                    attributes: {
                        errorCode: error.code,
                        error: error.message,
                        source: error.source
                    }
                });
                setCurrentScreen(null);
            }
        },
        analyticsContext: analyticsContext
    };
};

});
parcelRegister("8AJas", function(module, exports) {

$parcel$export(module.exports, "getInstallableApp", () => $6414b8e60e40d158$export$82293f81cf93861c);
$parcel$export(module.exports, "shouldInstallWithStoreBff", () => $6414b8e60e40d158$export$373abea2041a5c7a);

var $buxnS = parcelRequire("buxnS");
var $ly50n = parcelRequire("ly50n");

var $9D4R7 = parcelRequire("9D4R7");

var $kafab = parcelRequire("kafab");
var $cVLrH = parcelRequire("cVLrH");
var $i0EDR = parcelRequire("i0EDR");

var $ifMZN = parcelRequire("ifMZN");
var $6414b8e60e40d158$var$MarketplaceAppInstallGetAppByKey = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "MarketplaceAppInstallGetAppByKey"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceAppByKey"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "appKey"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "appKey"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "InstallableAppDetails"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "InstallableAppDetails"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceApp"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "versions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "productHostingOptions"
                                            },
                                            value: {
                                                kind: "ListValue",
                                                values: [
                                                    {
                                                        kind: "EnumValue",
                                                        value: "CLOUD"
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "visibility"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "PUBLIC"
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "excludeHiddenIn"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "IN_PRODUCT"
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "IntValue",
                                    value: "1"
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "LatestAppVersion"
                                                            },
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "LatestAppVersion"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppVersion"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deployment"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "__typename"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                        kind: "NamedType",
                                        name: {
                                            kind: "Name",
                                            value: "MarketplaceCloudAppDeployment"
                                        }
                                    },
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "cloudAppId"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 753,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nfragment LatestAppVersion on MarketplaceAppVersion {\n  deployment {\n    __typename\n    ... on MarketplaceCloudAppDeployment {\n      cloudAppId\n    }\n  }\n}\n\nfragment InstallableAppDetails on MarketplaceApp {\n  appKey\n  versions(\n    filter: { productHostingOptions: [CLOUD], visibility: PUBLIC, excludeHiddenIn: IN_PRODUCT }\n    first: 1\n  ) {\n    edges {\n      node {\n        ...LatestAppVersion\n      }\n    }\n  }\n}\n\nquery MarketplaceAppInstallGetAppByKey($appKey: String!) {\n  marketplaceAppByKey(appKey: $appKey) {\n    ...InstallableAppDetails\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
const $6414b8e60e40d158$export$f705667fe848e5ae = async (gatewayUrl, appKey)=>{
    const { errors: errors, data: data } = await (0, $9D4R7.graphQLRequest)(gatewayUrl, {
        query: $6414b8e60e40d158$var$MarketplaceAppInstallGetAppByKey,
        variables: {
            appKey: appKey
        }
    });
    if (errors !== null && errors !== void 0 && errors.length) throw errors;
    if (!(data !== null && data !== void 0 && data.marketplaceAppByKey)) throw new Error("Unable to fetch app with key \"".concat(appKey, "\"'"));
    return data.marketplaceAppByKey;
};
const $6414b8e60e40d158$var$getLatestAppVersion = (appDetails)=>{
    var _appDetails$versions$, _appDetails$versions$2;
    return appDetails === null || appDetails === void 0 ? void 0 : (_appDetails$versions$ = appDetails.versions.edges) === null || _appDetails$versions$ === void 0 ? void 0 : (_appDetails$versions$2 = _appDetails$versions$[0]) === null || _appDetails$versions$2 === void 0 ? void 0 : _appDetails$versions$2.node;
};
const $6414b8e60e40d158$var$getInstallableAppIdentifier = (latestVersion, appKey)=>{
    const { deployment: appDeployment } = latestVersion;
    const deploymentType = appDeployment.__typename;
    if (deploymentType === (0, $kafab.AppDeployment).ECOSYSTEM_CLOUD && typeof appDeployment.cloudAppId === 'string') return (0, $ifMZN.makeInstallableAppByAriIdentifier)({
        ari: (0, $ly50n.makeAppKey)(appDeployment.cloudAppId || ''),
        appKey: (0, $ly50n.makeAppKey)(appKey)
    });
    else if (deploymentType === (0, $kafab.AppDeployment).CONNECT || deploymentType === (0, $kafab.AppDeployment).INSTRUCTIONAL) return (0, $ifMZN.makeInstallableAppByKeyIdentifier)({
        key: (0, $ly50n.makeAppKey)(appKey)
    });
    else throw new Error("Installation of app with deployment type ".concat(deploymentType || 'UNKNOWN_DEPLOYMENT_TYPE', " not supported"));
};
const $6414b8e60e40d158$export$82293f81cf93861c = async (gatewayUrl, appKey)=>{
    try {
        const marketplaceApp = await $6414b8e60e40d158$export$f705667fe848e5ae(gatewayUrl, appKey);
        const latestVersion = $6414b8e60e40d158$var$getLatestAppVersion(marketplaceApp);
        if (latestVersion) return $6414b8e60e40d158$var$getInstallableAppIdentifier(latestVersion, appKey);
        else throw new Error('Unable to build appIdentifier, latestVersion of marketplace app not found');
    } catch (error) {
        throw new Error('AppInstallDialog Failed in getInstallableApp ' + error);
    }
};
const $6414b8e60e40d158$export$373abea2041a5c7a = (baseData)=>{
    // Some apps like instructional apps are not installable via marketplace
    if (!baseData.result.installMode.installableApp) return false;
    const isCompassApp = baseData.result.hostData.hostInfo.product === (0, $i0EDR.CompatibleProductId).COMPASS;
    return (!(0, $buxnS.isFreeApp)(baseData.result.installMode.installableApp.marketplaceAppDetails.paymentModel) || isCompassApp) && baseData.result.hostData.hostLicense.billingSystem === (0, $cVLrH.BillingSystem).CCP;
};

});


parcelRegister("jKojs", function(module, exports) {

$parcel$export(module.exports, "getHostConfig", () => $e6052c394d8c4017$export$48cf5e71cc7508ae);
$parcel$export(module.exports, "useAppInstallBaseData", () => $e6052c394d8c4017$export$94285004c428f0ec);

var $kIWPJ = parcelRequire("kIWPJ");
var $7xC2S = parcelRequire("7xC2S");

var $inwKI = parcelRequire("inwKI");

var $cVLrH = parcelRequire("cVLrH");

var $9c9Gu = parcelRequire("9c9Gu");
var $bTrQR = parcelRequire("bTrQR");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $7Qsmx = parcelRequire("7Qsmx");

var $ifMZN = parcelRequire("ifMZN");

var $55gtq = parcelRequire("55gtq");

var $jiykS = parcelRequire("jiykS");

var $1nC6Q = parcelRequire("1nC6Q");

var $8AJas = parcelRequire("8AJas");

var $uz0Wp = parcelRequire("uz0Wp");
const { usePromise: $e6052c394d8c4017$var$usePromise } = (0, $9c9Gu);
function $e6052c394d8c4017$export$48cf5e71cc7508ae(product) {
    const hostConfig = (0, $7Qsmx.appConfig).get(product);
    if (!hostConfig) throw new Error('Host product configuration is not defined for ' + product);
    return hostConfig;
}
async function $e6052c394d8c4017$var$getHostData(hostInfo, hostPricing) {
    try {
        const hostLicense = await (hostPricing ? Promise.resolve(hostPricing) : (0, $55gtq.default)().getHostPricingInfo());
        return {
            hostInfo: hostInfo,
            hostLicense: hostLicense,
            hostConfig: $e6052c394d8c4017$export$48cf5e71cc7508ae(hostInfo.product)
        };
    } catch (error) {
        throw new Error('Error building host data ' + error);
    }
}
const $e6052c394d8c4017$var$getAllScopes = async (graphQLGatewayUrl)=>{
    return (0, $kIWPJ.getScopesLookup)(graphQLGatewayUrl).then((scopesLookup)=>(0, $bWAru.Option).some((0, $bWAru.Either).right(scopesLookup)), (error)=>(0, $bWAru.Option).some((0, $bWAru.Either).left(error.status.toString())));
};
function $e6052c394d8c4017$export$94285004c428f0ec(mpacBaseUrl, graphQLGatewayUrl, environment, installIdentifier, hostInfo) {
    const { enableReactivateForgeAppFromEmcee: enableReactivateForgeAppFromEmcee, enableReactivateForgeAppFromEmceeForHAMS: enableReactivateForgeAppFromEmceeForHAMS, enableDeprecatedInstallationsGQL: enableDeprecatedInstallationsGQL } = (0, $inwKI.useFeatureFlags)();
    const emceeAppInstallCache = (0, $jiykS.useEmceeAppInstallCache)();
    const getFromEmceeCache = async (cache)=>{
        if (!cache.result) throw new Error('Cached data from EMCEE is falsy');
        if (!hostInfo) throw new Error('hostInfo from useMarketplaceAppInstall is null/undefined');
        const { hostLicense: hostLicense, scopesLookup: scopesLookup } = cache.result;
        return Promise.all([
            Promise.resolve($e6052c394d8c4017$var$getHostData(hostInfo, hostLicense)),
            Promise.resolve(scopesLookup),
            installIdentifier !== null && installIdentifier.type === (0, $1nC6Q.INSTALLABLE_APP_IDENTIFIER) && Promise.resolve(installIdentifier.keyForInstall)
        ]);
    };
    const getFromNetwork = async ()=>{
        if (!hostInfo) throw new Error('hostInfo from useMarketplaceAppInstall is null/undefined');
        return Promise.all([
            $e6052c394d8c4017$var$getHostData(hostInfo),
            $e6052c394d8c4017$var$getAllScopes(graphQLGatewayUrl),
            installIdentifier !== null && installIdentifier.type === (0, $1nC6Q.MARKETPLACE_APP_KEY) && (0, $8AJas.getInstallableApp)(graphQLGatewayUrl, installIdentifier.keyForInstall)
        ]);
    };
    const baseAppInstallPromise = async ()=>{
        const [hostData, scopesLookup, appIdentifier] = emceeAppInstallCache !== null ? await getFromEmceeCache(emceeAppInstallCache) : await getFromNetwork();
        const shouldEnableReactivateForgeAppFromEmcee = enableReactivateForgeAppFromEmcee && hostData.hostLicense.billingSystem === (0, $cVLrH.BillingSystem).CCP || enableReactivateForgeAppFromEmceeForHAMS && hostData.hostLicense.billingSystem === (0, $cVLrH.BillingSystem).HAMS;
        const installMode = await (0, $uz0Wp.getAppInstallMode)({
            mpacBaseUrl: mpacBaseUrl,
            hostInfo: hostData.hostInfo,
            appIdentifier: appIdentifier,
            flags: {
                enableReactivateForgeAppFromEmcee: shouldEnableReactivateForgeAppFromEmcee,
                enableDeprecatedInstallationsGQL: enableDeprecatedInstallationsGQL
            },
            hostCmtEnabled: hostData.hostLicense.hostCmtEnabled
        });
        const envForForgeAppEgressAddresses = environment === 'prod' ? 'production' : 'staging';
        const forgeAppEgressAddresses = appIdentifier.type === (0, $ifMZN.ARI_TYPE) ? await (0, $7xC2S.latestEgress)(graphQLGatewayUrl, appIdentifier.ari, envForForgeAppEgressAddresses) : null;
        return {
            hostData: hostData,
            appIdentifier: appIdentifier,
            scopesLookup: scopesLookup,
            installMode: installMode,
            forgeAppEgressAddresses: forgeAppEgressAddresses
        };
    };
    const runPromise = hostInfo !== null && installIdentifier !== null && (!emceeAppInstallCache || !emceeAppInstallCache.pending);
    const baseAppInstallPromiseDependencies = emceeAppInstallCache ? [
        installIdentifier,
        hostInfo,
        emceeAppInstallCache.pending
    ] : [
        installIdentifier,
        hostInfo
    ];
    const { pending: pending, result: result, error: error } = $e6052c394d8c4017$var$usePromise(baseAppInstallPromise, baseAppInstallPromiseDependencies, runPromise);
    if (error) (0, $bTrQR.default).error('AppInstallDialog', 'Failed to build appInstallBaseData', {
        error: error
    });
    return {
        pending: pending,
        error: error,
        result: result
    };
}

});
parcelRegister("7xC2S", function(module, exports) {

$parcel$export(module.exports, "latestEgress", () => $57d9207e1c35db8e$export$a419bd25832d0522);

var $9D4R7 = parcelRequire("9D4R7");

var $bTrQR = parcelRequire("bTrQR");
var $57d9207e1c35db8e$var$ForgeLatestEgress = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "ForgeLatestEgress"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "ID"
                            }
                        }
                    },
                    directives: []
                },
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "type"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "app"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "id"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "appKey"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "environmentByKey"
                                    },
                                    arguments: [
                                        {
                                            kind: "Argument",
                                            name: {
                                                kind: "Name",
                                                value: "key"
                                            },
                                            value: {
                                                kind: "Variable",
                                                name: {
                                                    kind: "Name",
                                                    value: "type"
                                                }
                                            }
                                        }
                                    ],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "id"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "versions"
                                                },
                                                arguments: [
                                                    {
                                                        kind: "Argument",
                                                        name: {
                                                            kind: "Name",
                                                            value: "first"
                                                        },
                                                        value: {
                                                            kind: "IntValue",
                                                            value: "1"
                                                        }
                                                    }
                                                ],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "Field",
                                                            name: {
                                                                kind: "Name",
                                                                value: "nodes"
                                                            },
                                                            arguments: [],
                                                            directives: [],
                                                            selectionSet: {
                                                                kind: "SelectionSet",
                                                                selections: [
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "id"
                                                                        },
                                                                        arguments: [],
                                                                        directives: []
                                                                    },
                                                                    {
                                                                        kind: "Field",
                                                                        name: {
                                                                            kind: "Name",
                                                                            value: "permissions"
                                                                        },
                                                                        arguments: [],
                                                                        directives: [],
                                                                        selectionSet: {
                                                                            kind: "SelectionSet",
                                                                            selections: [
                                                                                {
                                                                                    kind: "Field",
                                                                                    name: {
                                                                                        kind: "Name",
                                                                                        value: "egress"
                                                                                    },
                                                                                    arguments: [],
                                                                                    directives: [],
                                                                                    selectionSet: {
                                                                                        kind: "SelectionSet",
                                                                                        selections: [
                                                                                            {
                                                                                                kind: "Field",
                                                                                                name: {
                                                                                                    kind: "Name",
                                                                                                    value: "addresses"
                                                                                                },
                                                                                                arguments: [],
                                                                                                directives: []
                                                                                            }
                                                                                        ]
                                                                                    }
                                                                                }
                                                                            ]
                                                                        }
                                                                    }
                                                                ]
                                                            }
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 510,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nquery ForgeLatestEgress($appKey: ID!, $type: String!) {\n  app(id: $appKey) {\n    id\n    environmentByKey(key: $type) {\n      id\n      versions(first: 1) {\n        nodes {\n          id\n          permissions {\n            egress {\n              addresses\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
const $57d9207e1c35db8e$export$d18b215c4b4270c9 = (forgeEgressAddresses)=>{
    const flattenedForgeEgressAddresses = forgeEgressAddresses === null || forgeEgressAddresses === void 0 ? void 0 : forgeEgressAddresses.flatMap((item)=>item.addresses || []);
    return [
        ...new Set(flattenedForgeEgressAddresses)
    ];
};
const $57d9207e1c35db8e$export$a419bd25832d0522 = async (gqlGatewayUrl, appKey, environment)=>{
    try {
        var _data$app, _data$app$environment, _data$app$environment2, _data$app$environment3, _data$app$environment4, _data$app$environment5, _data$app$environment6;
        const type = environment;
        const variables = {
            appKey: appKey,
            type: type
        };
        const { data: data, errors: errors } = await (0, $9D4R7.graphQLRequest)(gqlGatewayUrl, {
            query: $57d9207e1c35db8e$var$ForgeLatestEgress,
            variables: variables
        });
        if (errors !== null && errors !== void 0 && errors.length) throw new Error(errors[0].message);
        const forgeEgressAddresses = data === null || data === void 0 ? void 0 : (_data$app = data.app) === null || _data$app === void 0 ? void 0 : (_data$app$environment = _data$app.environmentByKey) === null || _data$app$environment === void 0 ? void 0 : (_data$app$environment2 = _data$app$environment.versions) === null || _data$app$environment2 === void 0 ? void 0 : (_data$app$environment3 = _data$app$environment2.nodes) === null || _data$app$environment3 === void 0 ? void 0 : (_data$app$environment4 = _data$app$environment3[0]) === null || _data$app$environment4 === void 0 ? void 0 : (_data$app$environment5 = _data$app$environment4.permissions) === null || _data$app$environment5 === void 0 ? void 0 : (_data$app$environment6 = _data$app$environment5[0]) === null || _data$app$environment6 === void 0 ? void 0 : _data$app$environment6.egress;
        return $57d9207e1c35db8e$export$d18b215c4b4270c9(forgeEgressAddresses);
    } catch (error) {
        (0, $bTrQR.default).error('mpac-api-client/LatestEgress', "Failed to retrieve latest forge app egress", {
            error: error,
            extraInfo: {
                userAgent: navigator.userAgent
            }
        });
    }
};

});

parcelRegister("uz0Wp", function(module, exports) {

$parcel$export(module.exports, "getAppInstallMode", () => $05bdf68b11690c97$export$a01ee00d42c710f4);

var $bTrQR = parcelRequire("bTrQR");

var $6BOFf = parcelRequire("6BOFf");
const $05bdf68b11690c97$export$a01ee00d42c710f4 = async (_ref)=>{
    let { mpacBaseUrl: mpacBaseUrl, appIdentifier: appIdentifier, hostInfo: hostInfo, flags: flags, hostCmtEnabled: hostCmtEnabled } = _ref;
    try {
        const installMode = await (0, $6BOFf.getInstallMode)({
            mpacBaseUrl: mpacBaseUrl,
            installableAppId: appIdentifier,
            context: hostInfo.globalContext,
            flags: flags,
            hostCmtEnabled: hostCmtEnabled
        });
        const appInstallMode = installMode.fold((error)=>{
            console.error("Either the SPI's getInstallableAddon returned an error or invalid shape, or MPAC returned an invalid instructional listing: ", error);
        }, (im)=>im);
        return appInstallMode;
    } catch (error) {
        (0, $bTrQR.default).error('AppInstallDialog/getAppInstallMode', 'Failed with', {
            error: error
        });
    }
};

});


parcelRegister("kNokf", function(module, exports) {

$parcel$export(module.exports, "useCurrentUser", () => $f23b40c72d560532$export$3901076af3749fa9);

var $eUqFw = parcelRequire("eUqFw");

var $55gtq = parcelRequire("55gtq");
const $f23b40c72d560532$export$3901076af3749fa9 = ()=>{
    const [currentUser, setCurrentUser] = (0, $eUqFw.useState)(null);
    (0, $eUqFw.useEffect)(()=>{
        async function fetchCurrentUser() {
            const currentUserResponse = await (0, $55gtq.default)().getCurrentUser();
            setCurrentUser(currentUserResponse);
        }
        fetchCurrentUser();
    }, []);
    return currentUser;
};

});

parcelRegister("2bHSm", function(module, exports) {

$parcel$export(module.exports, "useHostData", () => $197ea4af1fc468eb$export$5fa3181982e114cc);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $55gtq = parcelRequire("55gtq");

var $jKojs = parcelRequire("jKojs");
function $197ea4af1fc468eb$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $197ea4af1fc468eb$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $197ea4af1fc468eb$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $197ea4af1fc468eb$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $197ea4af1fc468eb$export$5fa3181982e114cc = ()=>{
    const [hostBaseData, setHostBaseData] = (0, $eUqFw.useState)({
        hostInfo: null,
        hostConfig: null
    });
    (0, $eUqFw.useEffect)(()=>{
        async function fetchHostInfo() {
            const hostInfo = await (0, $55gtq.default)().getHostInfo();
            setHostBaseData({
                hostInfo: hostInfo,
                hostConfig: (0, $jKojs.getHostConfig)(hostInfo.product)
            });
        }
        fetchHostInfo();
    }, []);
    return $197ea4af1fc468eb$var$_objectSpread({}, hostBaseData);
};

});


parcelRegister("7p31F", function(module, exports) {

$parcel$export(module.exports, "default", () => $563d3710116b4b5b$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $cQKn6 = parcelRequire("cQKn6");

var $3XolV = parcelRequire("3XolV");

var $7ygmI = parcelRequire("7ygmI");

var $j0gMm = parcelRequire("j0gMm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $buxnS = parcelRequire("buxnS");
var $ly50n = parcelRequire("ly50n");

var $9l6Pq = parcelRequire("9l6Pq");

var $cCrLo = parcelRequire("cCrLo");

var $edD3H = parcelRequire("edD3H");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
parcelRequire("eUqFw");

var $abBcx = parcelRequire("abBcx");

var $338xH = parcelRequire("338xH");

var $fZ3KT = parcelRequire("fZ3KT");

var $lpVYJ = parcelRequire("lpVYJ");

var $lHkHI = parcelRequire("lHkHI");
function $563d3710116b4b5b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $563d3710116b4b5b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $563d3710116b4b5b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $563d3710116b4b5b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $563d3710116b4b5b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $563d3710116b4b5b$export$22d7f11e7dcd0a91 = (0, $3UXZ8.default)("div", {
    target: "ewztsws0",
    label: "HeaderInjectionContainer"
})({
    name: "70qvj9",
    styles: "display:flex;align-items:center;"
});
const $563d3710116b4b5b$var$InstallButtonPricingContainer = (0, $3UXZ8.default)("div", {
    target: "ewztsws1",
    label: "InstallButtonPricingContainer"
})({
    name: "1vr2anf",
    styles: "display:flex;align-items:center;flex-direction:column;"
});
const $563d3710116b4b5b$export$707453251eb22278 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $abBcx.default), {
    target: "ewztsws2",
    label: "PricingStyled"
})({
    name: "odz94x",
    styles: "margin-top:5px;"
});
const $563d3710116b4b5b$var$AddedContentWrapper = (0, $3UXZ8.default)("div", {
    target: "ewztsws3",
    label: "AddedContentWrapper"
})({
    name: "gxx421",
    styles: "display:flex;align-items:center;margin-right:var(--ds-space-150, 20px);"
});
const $563d3710116b4b5b$var$AddedContent = /*#__PURE__*/ (0, $3UXZ8.default)((0, $cCrLo.BodyNormal), {
    target: "ewztsws4",
    label: "AddedContent"
})({
    name: "1rtlx0a",
    styles: "margin-top:0;color:var(--ds-text-subtle);"
});
const $563d3710116b4b5b$var$IconWrapper = (0, $3UXZ8.default)("div", {
    target: "ewztsws5",
    label: "IconWrapper"
})({
    name: "1cxifx3",
    styles: "margin-right:var(--ds-space-050);display:flex;align-items:center;"
});
const $563d3710116b4b5b$var$appListingCTA = (isFree, eligibleForFreeOnSandbox, cloudMigrationTrial, showAetherAppListingPage)=>{
    if (eligibleForFreeOnSandbox) return {
        label: 'Add to sandbox',
        appearance: 'primary'
    };
    if (cloudMigrationTrial !== null && cloudMigrationTrial !== void 0 && cloudMigrationTrial.isEligible) return {
        label: 'Activate trial',
        appearance: showAetherAppListingPage ? 'primary' : 'warning'
    };
    if (isFree) return {
        label: 'Get it now',
        appearance: showAetherAppListingPage ? 'primary' : 'warning'
    };
    return {
        label: 'Try it free',
        appearance: showAetherAppListingPage ? 'primary' : 'warning'
    };
};
const $563d3710116b4b5b$export$b8b2ed6a50ce602d = (props)=>{
    const { enableAetherAppListingPage: enableAetherAppListingPage } = (0, $9l6Pq.useStatsig)();
    const showAetherAppListingPage = enableAetherAppListingPage();
    const { label: label, appearance: appearance } = $563d3710116b4b5b$var$appListingCTA(props.isFree, props.eligibleForFreeOnSandbox, props.cloudMigrationTrial, showAetherAppListingPage);
    const { ecosystemCloudAppId: ecosystemCloudAppId } = props;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $edD3H.default), {
        name: "install-app",
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cQKn6.default), {
            appearance: appearance,
            onClick: ()=>{
                props.fireAnalyticsEvent({
                    attributes: $563d3710116b4b5b$var$_objectSpread({
                        label: label
                    }, ecosystemCloudAppId && {
                        isEcosystemCloudApp: true,
                        ecosystemCloudAppId: ecosystemCloudAppId
                    }),
                    eventType: (0, $gaiog.ButtonClickedEvent),
                    actionSubjectId: 'install',
                    objectType: 'app',
                    objectId: props.appKey
                });
                props.onClickHandler();
            },
            isLoading: props.isLoading,
            testId: "app-listing__install-app-btn",
            children: label
        })
    });
};
const $563d3710116b4b5b$export$9f8965e842050973 = (0, $9osuT.withAnalytics)($563d3710116b4b5b$export$b8b2ed6a50ce602d);
const $563d3710116b4b5b$export$568b6c7550dcce07 = ()=>/*#__PURE__*/ // Hiding tooltip because of incorrect date for connect apps: https://ecosystem.atlassian.net/browse/MC-6172
    // <Tooltip
    //   content={`This app was added on ${DateUtils.longDate(props.installedApp.get('installTime'))}`}
    // >
    (0, $lHkHI.jsxs)((0, $338xH.IconContainer), {
        "data-testid": "app-installed",
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $338xH.Icon), {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3XolV))), {
                    size: "small",
                    primaryColor: "var(--ds-icon, ".concat((0, $j0gMm.N500), ")")
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $338xH.Label), {
                children: "Added"
            })
        ]
    });
const $563d3710116b4b5b$export$c63605c9ee04cbc2 = ()=>{
    // Hiding tooltip because of incorrect date for connect apps: https://ecosystem.atlassian.net/browse/MC-6172
    // const installTime = props.installedApp.get('installTime', null);
    return(/*#__PURE__*/ // <Tooltip
    //   content={
    //     installTime
    //       ? `This app was added on ${DateUtils.longDate(installTime, 'MMM dd, yyyy')}`
    //       : null
    //   }
    // >
    (0, $lHkHI.jsxs)($563d3710116b4b5b$var$AddedContentWrapper, {
        "data-testid": "app-installed-v2",
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($563d3710116b4b5b$var$IconWrapper, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ygmI))), {
                    label: "",
                    size: "small",
                    primaryColor: "var(--ds-icon)"
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($563d3710116b4b5b$var$AddedContent, {
                children: "Added"
            })
        ]
    }));
};
const $563d3710116b4b5b$export$1c65950d0ead610d = (props)=>{
    const { enableAetherAppListingPage: enableAetherAppListingPage } = (0, $9l6Pq.useStatsig)();
    const showAetherAppListingPage = enableAetherAppListingPage();
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)($563d3710116b4b5b$export$c63605c9ee04cbc2, {}) : /*#__PURE__*/ (0, $lHkHI.jsx)($563d3710116b4b5b$export$568b6c7550dcce07, {}),
            props.hasInstallPermission && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lpVYJ.default), {
                installedApp: props.installedApp
            })
        ]
    });
};
const $563d3710116b4b5b$var$renderRequestApp = (props)=>{
    if (!props.featureFlags.getFlag('request-app', false)) return null;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fZ3KT.default), $563d3710116b4b5b$var$_objectSpread($563d3710116b4b5b$var$_objectSpread({
        appKey: props.appKey,
        appName: props.appName
    }, props.ecosystemCloudAppId && {
        ecosystemCloudAppId: props.ecosystemCloudAppId
    }), {}, {
        isRequestDialogOpen: props.isRequestDialogOpen,
        appListingCTA: $563d3710116b4b5b$var$appListingCTA(props.isFreeApp, false, props.cloudMigrationTrial).label
    }));
};
const $563d3710116b4b5b$var$HeaderInjection = (props)=>{
    const { enableAetherAppListingPage: enableAetherAppListingPage } = (0, $9l6Pq.useStatsig)();
    const showAetherAppListingPage = enableAetherAppListingPage();
    return /*#__PURE__*/ (0, $lHkHI.jsx)($563d3710116b4b5b$export$22d7f11e7dcd0a91, {
        children: props.installedApp ? /*#__PURE__*/ (0, $lHkHI.jsx)($563d3710116b4b5b$export$1c65950d0ead610d, {
            installedApp: props.installedApp,
            hasInstallPermission: props.hasInstallPermission
        }) : /*#__PURE__*/ (0, $lHkHI.jsxs)($563d3710116b4b5b$var$InstallButtonPricingContainer, {
            children: [
                props.hasInstallPermission ? /*#__PURE__*/ (0, $lHkHI.jsx)($563d3710116b4b5b$export$9f8965e842050973, {
                    appKey: props.appKey,
                    ecosystemCloudAppId: props.ecosystemCloudAppId,
                    onClickHandler: props.onInstallClick,
                    isLoading: props.appKey === props.installationInProgressAppKey,
                    isFree: (0, $buxnS.isFreeApp)(props.paymentModel),
                    eligibleForFreeOnSandbox: props.eligibleForFreeOnSandbox,
                    cloudMigrationTrial: props.cloudMigrationTrial
                }) : $563d3710116b4b5b$var$renderRequestApp({
                    appKey: props.appKey,
                    appName: props.appName,
                    ecosystemCloudAppId: props.ecosystemCloudAppId,
                    featureFlags: props.featureFlags,
                    isRequestDialogOpen: props.isRequestDialogOpen,
                    isFreeApp: (0, $buxnS.isFreeApp)(props.paymentModel),
                    cloudMigrationTrial: props.cloudMigrationTrial
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($563d3710116b4b5b$export$707453251eb22278, {
                    hostPricing: props.hostPricing,
                    installedApp: (0, $bWAru.Option).of(props.installedApp),
                    links: props.links,
                    hideTryFreeHeading: true,
                    paymentModel: props.paymentModel,
                    mpacBaseUrl: props.mpacBaseUrl,
                    appKey: (0, $ly50n.makeAppKey)(props.appKey),
                    isInstallButtonVisible: props.hasInstallPermission,
                    eligibleForFreeOnSandbox: props.eligibleForFreeOnSandbox,
                    cloudMigrationTrial: props.cloudMigrationTrial,
                    showAetherAppListingPage: showAetherAppListingPage
                })
            ]
        })
    });
};
var $563d3710116b4b5b$export$2e2bcd8739ae039 = $563d3710116b4b5b$var$HeaderInjection;

});
parcelRegister("7ygmI", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $57f86735e9275b54$var$_react = $57f86735e9275b54$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $57f86735e9275b54$var$_checkCircle = $57f86735e9275b54$var$_interopRequireDefault((parcelRequire("g79oa")));
function $57f86735e9275b54$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $57f86735e9275b54$var$CheckCircleOutlineIcon = (props)=>/*#__PURE__*/ $57f86735e9275b54$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M12 20a8 8 0 1 0 0-16 8 8 0 0 0 0 16m0 2C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10"/><path d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $57f86735e9275b54$var$_checkCircle.default
    }));
$57f86735e9275b54$var$CheckCircleOutlineIcon.displayName = 'CheckCircleOutlineIcon';
var $57f86735e9275b54$var$_default = module.exports.default = $57f86735e9275b54$var$CheckCircleOutlineIcon;

});
parcelRegister("g79oa", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::33c5439f087752870260bcf48e3a4598>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bbb49538da8ce79b$var$_react = $bbb49538da8ce79b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $bbb49538da8ce79b$var$_UNSAFE_baseNew = $bbb49538da8ce79b$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $bbb49538da8ce79b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "CheckCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: completed items, productivity emoji category. Completed task issue status in JSM Calendar view.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bbb49538da8ce79b$var$CheckCircleIcon = (props)=>/*#__PURE__*/ $bbb49538da8ce79b$var$_react.default.createElement($bbb49538da8ce79b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="m4.25 8 2.5 3 5-6M8 .75a7.25 7.25 0 1 0 0 14.5A7.25 7.25 0 0 0 8 .75Z"/>`
    }, props));
$bbb49538da8ce79b$var$CheckCircleIcon.displayName = 'CheckCircleIcon';
var $bbb49538da8ce79b$var$_default = module.exports.default = $bbb49538da8ce79b$var$CheckCircleIcon;

});


parcelRegister("338xH", function(module, exports) {

$parcel$export(module.exports, "Label", () => $238847471c084f9f$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Icon", () => $238847471c084f9f$export$f04a61298a47a40f);
$parcel$export(module.exports, "IconContainer", () => $238847471c084f9f$export$8f314e512d92575f);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");
function $238847471c084f9f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $238847471c084f9f$export$b04be29aa201d4f5 = (0, $3UXZ8.default)("span", {
    target: "ejzzgi70",
    label: "Label"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N500), ")"), ";margin-left:3px;");
const $238847471c084f9f$export$f04a61298a47a40f = (0, $3UXZ8.default)("span", {
    target: "ejzzgi71",
    label: "Icon"
})({
    name: "uk6cul",
    styles: "vertical-align:middle;"
});
const $238847471c084f9f$export$8f314e512d92575f = (0, $3UXZ8.default)("div", {
    target: "ejzzgi72",
    label: "IconContainer"
})({
    name: "16a3h1l",
    styles: "margin-right:var(--ds-space-250, 20px);"
});

});

parcelRegister("fZ3KT", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba2f7744d6caa3ab$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $cuo8k = parcelRequire("cuo8k");

var $9l6Pq = parcelRequire("9l6Pq");

var $bqcaO = parcelRequire("bqcaO");

var $bTrQR = parcelRequire("bTrQR");

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("jJs3W");
var $6N2vY = parcelRequire("6N2vY");
var $cU4FA = parcelRequire("cU4FA");

var $8bwkw = parcelRequire("8bwkw");

var $gRo3n = parcelRequire("gRo3n");

var $bSQ4o = parcelRequire("bSQ4o");

var $55gtq = parcelRequire("55gtq");

var $ldheR = parcelRequire("ldheR");

var $fgjQk = parcelRequire("fgjQk");

var $c5q0o = parcelRequire("c5q0o");

var $lHkHI = parcelRequire("lHkHI");
function $ba2f7744d6caa3ab$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $ba2f7744d6caa3ab$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $ba2f7744d6caa3ab$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $ba2f7744d6caa3ab$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $ba2f7744d6caa3ab$export$2e2bcd8739ae039(props) {
    const hostInfo = (0, $cU4FA.useSelector)((state)=>state.configuration.hostInfo.fold(()=>{
        /* hostInfo does not exist */ }, (hostInfoRes)=>hostInfoRes.fold(()=>{
            /* getting hostInfo had errors */ }, (hi)=>hi)));
    const hostConfig = (0, $cU4FA.useSelector)((state)=>state.configuration.hostConfig.fold(()=>{
        /* hostConfig does not exist */ }, (hostConfigRes)=>hostConfigRes.fold(()=>{
            /* getting hostConfig had errors */ }, (hc)=>hc)));
    const cloudId = (0, $bSQ4o.getCloudIdFromHostInfo)(hostInfo);
    const [isAppRequestStatusInProgress, setAppRequestStatusInProgress] = (0, $eUqFw.useState)(true);
    const [appRequestStatusResponse, setAppRequestStatusResponse] = (0, $eUqFw.useState)(null);
    const { enableAetherAppListingPage: enableAetherAppListingPage } = (0, $9l6Pq.useStatsig)();
    const dispatch = (0, $6N2vY.useDispatch)();
    const showAetherAppListingPage = enableAetherAppListingPage();
    (0, $eUqFw.useEffect)(()=>{
        if (hostConfig) (0, $55gtq.default)().getCurrentUser().then((currentUser)=>{
            const { atlassianAccountId: userId } = currentUser;
            if (userId && cloudId && hostInfo) (0, $gRo3n.getAppRequestedStatus)({
                cloudId: cloudId,
                productName: hostInfo.product,
                appKey: props.appKey,
                userId: userId
            }).then((response)=>{
                setAppRequestStatusResponse(response);
            }).catch((error)=>{
                (0, $bTrQR.default).error('RequestAppContainer', "Failed to retrieve app requested status", {
                    error: error
                });
            }).finally((_)=>setAppRequestStatusInProgress(false));
        }).catch(console.error.bind(console));
    }, []);
    const onRequestSubmit = ()=>setAppRequestStatusResponse({
            status: (0, $cuo8k.RequestStatus).OPEN,
            requestedDate: new Date().toString()
        });
    if (!hostInfo || !hostConfig || !cloudId) return 'Something went wrong';
    if (isAppRequestStatusInProgress) return showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bqcaO.Stripe), {
        width: "6rem",
        height: "2rem",
        borderRadius: "var(--ds-border-radius-200)"
    }) : 'Loading...';
    if (appRequestStatusResponse) {
        if (showAetherAppListingPage) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ldheR.AppRequestStatusTooltipV2), {
            appRequestStatus: appRequestStatusResponse
        });
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fgjQk.default), {
            appRequestStatus: appRequestStatusResponse
        });
    }
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $c5q0o.default), $ba2f7744d6caa3ab$var$_objectSpread($ba2f7744d6caa3ab$var$_objectSpread({}, props), {}, {
        productName: hostInfo.product,
        cloudId: cloudId,
        addFlag: (flag)=>dispatch((0, $8bwkw.addFlag)({
                flag: flag
            })),
        onRequestSubmit: onRequestSubmit
    }));
}

});
parcelRegister("ldheR", function(module, exports) {

$parcel$export(module.exports, "AppRequestStatusTooltipV2", () => $f7182f1c5b6459db$export$e01961f2392ff4d);
/* AppRequestStatusTooltipV2.tsx generated by @compiled/babel-plugin v0.29.1 */ 
var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $eUqFw = parcelRequire("eUqFw");

var $7JEyt = parcelRequire("7JEyt");

var $7ygmI = parcelRequire("7ygmI");

var $d8i0J = parcelRequire("d8i0J");

var $cuo8k = parcelRequire("cuo8k");

var $cCrLo = parcelRequire("cCrLo");

var $4lmb9 = parcelRequire("4lmb9");

var $76fzC = parcelRequire("76fzC");

var $lHkHI = parcelRequire("lHkHI");
const $f7182f1c5b6459db$var$_excluded = [
    "as",
    "style"
], $f7182f1c5b6459db$var$_excluded2 = [
    "as",
    "style"
], $f7182f1c5b6459db$var$_excluded3 = [
    "as",
    "style"
], $f7182f1c5b6459db$var$_excluded4 = [
    "as",
    "style"
], $f7182f1c5b6459db$var$_excluded5 = [
    "as",
    "style"
];
function $f7182f1c5b6459db$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f7182f1c5b6459db$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f7182f1c5b6459db$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f7182f1c5b6459db$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f7182f1c5b6459db$var$TooltipContainer = (0, $eUqFw.forwardRef)((_ref, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref, __cmplp = (0, $bwPfh.default)(_ref, $f7182f1c5b6459db$var$_excluded);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $f7182f1c5b6459db$var$_objectSpread($f7182f1c5b6459db$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_p12f10yc",
            __cmplp.className
        ])
    }));
});
const $f7182f1c5b6459db$var$Container = (0, $eUqFw.forwardRef)((_ref2, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref2, __cmplp = (0, $bwPfh.default)(_ref2, $f7182f1c5b6459db$var$_excluded2);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $f7182f1c5b6459db$var$_objectSpread($f7182f1c5b6459db$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    }));
});
const $f7182f1c5b6459db$var$IconWrapper = (0, $eUqFw.forwardRef)((_ref3, __cmplr)=>{
    let { as: C = "div", style: __cmpls } = _ref3, __cmplp = (0, $bwPfh.default)(_ref3, $f7182f1c5b6459db$var$_excluded3);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $f7182f1c5b6459db$var$_objectSpread($f7182f1c5b6459db$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_2hwxh461 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    }));
});
const $f7182f1c5b6459db$var$Content = (0, $eUqFw.forwardRef)((_ref4, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodyNormal), style: __cmpls } = _ref4, __cmplp = (0, $bwPfh.default)(_ref4, $f7182f1c5b6459db$var$_excluded4);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $f7182f1c5b6459db$var$_objectSpread($f7182f1c5b6459db$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_19pkidpf _syaz1k3w",
            __cmplp.className
        ])
    }));
});
const $f7182f1c5b6459db$var$TooltipRejectedTitle = (0, $eUqFw.forwardRef)((_ref5, __cmplr)=>{
    let { as: C = (0, $cCrLo.BodySmall), style: __cmpls } = _ref5, __cmplp = (0, $bwPfh.default)(_ref5, $f7182f1c5b6459db$var$_excluded5);
    return /*#__PURE__*/ (0, $lHkHI.jsx)(C, $f7182f1c5b6459db$var$_objectSpread($f7182f1c5b6459db$var$_objectSpread({}, __cmplp), {}, {
        style: __cmpls,
        ref: __cmplr,
        className: (0, $7JEyt.default)([
            "_k48pni7l",
            __cmplp.className
        ])
    }));
});
const $f7182f1c5b6459db$export$e01961f2392ff4d = (props)=>{
    let label;
    let icon;
    let tooltipContent;
    const response = props.appRequestStatus;
    if (response.status === (0, $cuo8k.RequestStatus).OPEN) {
        label = 'App requested';
        icon = /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7ygmI))), {
            label: "",
            size: "small",
            primaryColor: "var(--ds-icon)"
        });
        tooltipContent = /*#__PURE__*/ (0, $lHkHI.jsx)($f7182f1c5b6459db$var$TooltipContainer, {
            children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $cCrLo.BodySmall), {
                children: [
                    "You requested for the app on ",
                    (0, $76fzC).longDate(response.requestedDate, 'MMM dd, yyyy')
                ]
            })
        });
    } else if (response.status === (0, $cuo8k.RequestStatus).REJECTED) {
        label = 'App request rejected';
        icon = /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d8i0J))), {
            size: "small",
            label: ""
        });
        tooltipContent = /*#__PURE__*/ (0, $lHkHI.jsxs)($f7182f1c5b6459db$var$TooltipContainer, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsxs)($f7182f1c5b6459db$var$TooltipRejectedTitle, {
                    children: [
                        "Reason for rejection as on ",
                        (0, $76fzC).longDate(response.rejectedDate, 'MMM dd, yyyy'),
                        ":"
                    ]
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.BodySmall), {
                    children: "\"".concat(response.rejectComment, "\"")
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4lmb9.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)($f7182f1c5b6459db$var$Container, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($f7182f1c5b6459db$var$IconWrapper, {
                    children: icon
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($f7182f1c5b6459db$var$Content, {
                    children: label
                })
            ]
        })
    });
};

});

parcelRegister("fgjQk", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1c7be0b26272a0a$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $3XolV = parcelRequire("3XolV");

var $d8i0J = parcelRequire("d8i0J");

var $j0gMm = parcelRequire("j0gMm");

var $cuo8k = parcelRequire("cuo8k");

var $4lmb9 = parcelRequire("4lmb9");

var $76fzC = parcelRequire("76fzC");
parcelRequire("eUqFw");

var $338xH = parcelRequire("338xH");

var $lHkHI = parcelRequire("lHkHI");
function $b1c7be0b26272a0a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b1c7be0b26272a0a$export$55a395b84e9cdaf9 = (0, $3UXZ8.default)("div", {
    target: "e1rst1ul0",
    label: "AppRequestTooltip"
})({
    name: "zeck81",
    styles: "max-width:205px;"
});
const $b1c7be0b26272a0a$export$6ee7e903a59a6372 = (0, $3UXZ8.default)("div", {
    target: "e1rst1ul1",
    label: "GreyText"
})("color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N200), ")"), ";");
const $b1c7be0b26272a0a$export$4d299b491347818a = (0, $3UXZ8.default)("p", {
    target: "e1rst1ul2",
    label: "Comment"
})({
    name: "mt0sfa",
    styles: "word-wrap:break-word;overflow-y:scroll;max-height:380px;"
});
function $b1c7be0b26272a0a$var$AppRequestStatusTooltip(props) {
    let label = null;
    let icon = null;
    let tooltipContent = null;
    const response = props.appRequestStatus;
    if (response.status === (0, $cuo8k.RequestStatus).OPEN) {
        label = 'App requested';
        icon = /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3XolV))), {
            size: "small",
            primaryColor: "var(--ds-icon, ".concat((0, $j0gMm.N500), ")")
        });
        tooltipContent = /*#__PURE__*/ (0, $lHkHI.jsxs)($b1c7be0b26272a0a$export$55a395b84e9cdaf9, {
            children: [
                "You requested this app on ",
                (0, $76fzC).longDate(response.requestedDate)
            ]
        });
    } else if (props.appRequestStatus.status === (0, $cuo8k.RequestStatus).REJECTED) {
        label = 'App request reviewed and rejected';
        icon = /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d8i0J))), {
            size: "small",
            primaryColor: "var(--ds-icon-warning, ".concat((0, $j0gMm.Y300), ")")
        });
        tooltipContent = /*#__PURE__*/ (0, $lHkHI.jsxs)($b1c7be0b26272a0a$export$55a395b84e9cdaf9, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($b1c7be0b26272a0a$export$4d299b491347818a, {
                    children: "\"".concat(response.rejectComment, "\"")
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($b1c7be0b26272a0a$export$6ee7e903a59a6372, {
                    children: (0, $76fzC).longDate(response.rejectedDate)
                })
            ]
        });
    }
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4lmb9.default), {
        content: tooltipContent,
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $338xH.IconContainer), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $338xH.Icon), {
                    children: icon
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $338xH.Label), {
                    children: label
                })
            ]
        })
    });
}
var $b1c7be0b26272a0a$export$2e2bcd8739ae039 = $b1c7be0b26272a0a$var$AppRequestStatusTooltip;

});

parcelRegister("c5q0o", function(module, exports) {

$parcel$export(module.exports, "default", () => $8cca1fc26e15718e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $b720H = parcelRequire("b720H");
var $6UJyW = parcelRequire("6UJyW");

var $j0gMm = parcelRequire("j0gMm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $c1ZLO = parcelRequire("c1ZLO");

var $inwKI = parcelRequire("inwKI");
var $9l6Pq = parcelRequire("9l6Pq");

var $bm7IM = parcelRequire("bm7IM");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $55gtq = parcelRequire("55gtq");

var $g0BUg = parcelRequire("g0BUg");

var $jHg79 = parcelRequire("jHg79");

var $hdXYz = parcelRequire("hdXYz");

var $9n12n = parcelRequire("9n12n");

var $hsvfa = parcelRequire("hsvfa");

var $lHkHI = parcelRequire("lHkHI");
function $8cca1fc26e15718e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8cca1fc26e15718e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8cca1fc26e15718e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8cca1fc26e15718e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8cca1fc26e15718e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8cca1fc26e15718e$export$b6d9565de1e068cf = (0, $3UXZ8.default)("div", {
    target: "eneggz80",
    label: "DialogContent"
})({
    name: "16b2ug3",
    styles: "margin:15px 0;"
});
const $8cca1fc26e15718e$export$8d13340382210b65 = (0, $3UXZ8.default)("p", {
    target: "eneggz81",
    label: "Hint"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N400), ")"), ";font-size:12px;margin-top:var(--ds-space-250, 20px);white-space:pre-line;");
const $8cca1fc26e15718e$export$a06f1c675e846f6f = (0, $3UXZ8.default)("div", {
    target: "eneggz82",
    label: "Footer"
})({
    name: "a1l08t",
    styles: "text-align:right;margin:var(--ds-space-250, 20px) 0;"
});
const $8cca1fc26e15718e$export$8b7b7cdfb85d78c5 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $9oiuL.default), {
    target: "eneggz83",
    label: "SubmitButton"
})({
    name: "1y6ic72",
    styles: "margin-left:10px;"
});
const $8cca1fc26e15718e$export$1096d917d06c29e2 = (props)=>{
    const { enableAetherAppListingPage: enableAetherAppListingPage } = (0, $9l6Pq.useStatsig)();
    const buttonAppearance = enableAetherAppListingPage() ? 'primary' : 'warning';
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
        testId: (0, $c1ZLO.TEST_ID).REQUEST_APP_BTN,
        appearance: buttonAppearance,
        onClick: props.onClick,
        children: props.label
    });
};
function $8cca1fc26e15718e$export$2e2bcd8739ae039(props) {
    const [isDialogOpen, setDialogOpenFlag] = (0, $eUqFw.useState)(props.isRequestDialogOpen);
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const { enableInContextAppRequest: enableInContextAppRequest } = (0, $inwKI.useFeatureFlags)();
    const environment = (0, $jHg79.useEnvironment)();
    const appRequestConfig = (0, $hdXYz.getAppInstallConfigForEnv)(environment);
    const ecosystemCloudAppId = props.ecosystemCloudAppId;
    const { flags: flags, addFlag: addFlag, dismissFlag: dismissFlag } = (0, $g0BUg.useAtlaskitFlags)();
    const handleShowFlag = (flag)=>addFlag({
            id: flag.id,
            type: (0, $bm7IM.FLAG_TYPE_SUCCESS),
            title: flag.title,
            description: flag.description,
            actions: flag.actions,
            isAutoDismiss: flag.isAutoDismiss
        });
    const handleDismissFlag = (id)=>dismissFlag(id);
    (0, $eUqFw.useEffect)(()=>{
        fireAnalyticsEvent({
            attributes: $8cca1fc26e15718e$var$_objectSpread({}, ecosystemCloudAppId && {
                isEcosystemCloudApp: true,
                ecosystemCloudAppId: ecosystemCloudAppId
            }),
            eventType: (0, $7Uh51.AppRequestButtonViewed),
            objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_LISTING),
            objectId: props.appKey
        });
    }, []);
    const toggleDialog = ()=>{
        setDialogOpenFlag(!isDialogOpen);
    };
    const onRequestAppButtonClick = ()=>{
        handleAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_REQUEST_APP));
        toggleDialog();
    };
    const handleAnalyticsEvent = (actionSubjectId)=>fireAnalyticsEvent({
            attributes: $8cca1fc26e15718e$var$_objectSpread({}, ecosystemCloudAppId && {
                isEcosystemCloudApp: true,
                ecosystemCloudAppId: ecosystemCloudAppId
            }),
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: actionSubjectId,
            objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_LISTING),
            objectId: props.appKey
        });
    const flagApiHandler = {
        show: handleShowFlag,
        dismiss: handleDismissFlag
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6UJyW.default), {
                onDismissed: dismissFlag,
                children: flags.map((flag)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $b720H.default), $8cca1fc26e15718e$var$_objectSpread({}, flag), flag.id))
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($8cca1fc26e15718e$export$1096d917d06c29e2, {
                onClick: onRequestAppButtonClick,
                label: props.appListingCTA
            }),
            isDialogOpen && (enableInContextAppRequest ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9n12n.default), {
                config: appRequestConfig,
                appKey: props.appKey,
                spi: (0, $55gtq.default)(),
                onClose: toggleDialog,
                requestLocation: "emcee",
                flags: flagApiHandler
            }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hsvfa.default), $8cca1fc26e15718e$var$_objectSpread($8cca1fc26e15718e$var$_objectSpread({}, props), {}, {
                closeModal: toggleDialog
            })))
        ]
    });
}

});
parcelRegister("g0BUg", function(module, exports) {

$parcel$export(module.exports, "useAtlaskitFlags", () => $ba7a0cd8240de2e7$export$4a8e8d22ffd7d48);

var $3XolV = parcelRequire("3XolV");

var $gEwvS = parcelRequire("gEwvS");

var $58ZVT = parcelRequire("58ZVT");

var $d8i0J = parcelRequire("d8i0J");

var $j0gMm = parcelRequire("j0gMm");

var $bm7IM = parcelRequire("bm7IM");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $ba7a0cd8240de2e7$export$4a8e8d22ffd7d48() {
    const [flags, setFlags] = (0, $eUqFw.useState)([]);
    const addFlag = (flag)=>{
        setFlags((current)=>[
                {
                    id: flag.id,
                    title: flag.title,
                    description: flag.description,
                    appearance: 'normal',
                    icon: $ba7a0cd8240de2e7$export$d8025e3540a58fd2(flag.type),
                    actions: flag.actions,
                    isAutoDismiss: flag.isAutoDismiss
                },
                ...current
            ]);
    };
    const dismissFlag = (0, $eUqFw.useCallback)((id)=>{
        setFlags((current)=>current.filter((flag)=>flag.id !== id));
    }, [
        setFlags
    ]);
    return {
        flags: flags,
        addFlag: addFlag,
        dismissFlag: dismissFlag
    };
}
const $ba7a0cd8240de2e7$export$d8025e3540a58fd2 = (flagType)=>{
    switch(flagType){
        case 0, $bm7IM.FLAG_TYPE_INFO:
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($58ZVT))), {
                size: "medium",
                primaryColor: (0, $j0gMm.P400)
            });
        case 0, $bm7IM.FLAG_TYPE_SUCCESS:
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3XolV))), {
                label: "",
                size: "medium",
                primaryColor: (0, $j0gMm.G400)
            });
        case 0, $bm7IM.FLAG_TYPE_WARNING:
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d8i0J))), {
                size: "medium",
                primaryColor: (0, $j0gMm.Y400)
            });
        default:
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gEwvS))), {
                label: "",
                size: "medium",
                primaryColor: (0, $j0gMm.R400)
            });
    }
};

});

parcelRegister("9n12n", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d27110e3ddf1d2e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $f2QOW = parcelRequire("f2QOW");

var $9e16A = parcelRequire("9e16A");

var $iyohm = parcelRequire("iyohm");

var $beqRW = parcelRequire("beqRW");

var $ighTk = parcelRequire("ighTk");
var $1S6Gv = parcelRequire("1S6Gv");

var $eUqFw = parcelRequire("eUqFw");

var $iUPNF = parcelRequire("iUPNF");

var $7YbkQ = parcelRequire("7YbkQ");

var $5JCOp = parcelRequire("5JCOp");

var $55gtq = parcelRequire("55gtq");

var $kNokf = parcelRequire("kNokf");

var $2bHSm = parcelRequire("2bHSm");

var $iEdQ1 = parcelRequire("iEdQ1");

var $7opvN = parcelRequire("7opvN");

var $gkhxl = parcelRequire("gkhxl");

var $la8zm = parcelRequire("la8zm");

var $5rzWv = parcelRequire("5rzWv");

var $lHkHI = parcelRequire("lHkHI");
function $6d27110e3ddf1d2e$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6d27110e3ddf1d2e$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6d27110e3ddf1d2e$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6d27110e3ddf1d2e$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6d27110e3ddf1d2e$export$27e646996cbebe98(props) {
    (0, $eUqFw.useMemo)(()=>(0, $55gtq.initSPI)(props.spi), [
        props.spi
    ]);
    const { hostInfo: hostInfo, hostConfig: hostConfig } = (0, $2bHSm.useHostData)();
    const currentUser = (0, $kNokf.useCurrentUser)();
    const appRequestBaseData = (0, $5rzWv.useAppRequestBaseData)(props.config, hostInfo, currentUser, props.appKey);
    const appDetailsFromSearchResponse = (0, $9e16A.useGetAppDetailsFromSearch)({
        appKey: props.appKey,
        algoliaConfig: props.config.algoliaConfig
    });
    const { fireEvent: fireEvent, analyticsContext: analyticsContext } = (0, $la8zm.useAppRequestAnalytics)({
        baseData: appRequestBaseData,
        requestLocation: props.requestLocation
    });
    const links = (0, $iEdQ1.useLinkTemplates)({
        adminHubBaseUrl: props.config.adminHubBaseUrl,
        mpacBaseUrl: props.config.mpacBaseUrl,
        mpacCdnBaseUrl: props.config.mpacCdnBaseUrl,
        macBaseUrl: props.config.macBaseUrl,
        wacBaseUrl: props.config.wacBaseUrl,
        atlassianCommunityBaseUrl: props.config.atlassianCommunityBaseUrl
    });
    (0, $eUqFw.useEffect)(()=>{
        if (hostInfo && currentUser !== null && currentUser !== void 0 && currentUser.atlassianAccountId) {
            (0, $7YbkQ.default).init(props.config, hostConfig, hostInfo);
            (0, $5JCOp.initializeBackends)(hostInfo, (0, $iyohm.makeUserId)(currentUser.atlassianAccountId));
        }
    }, [
        hostInfo,
        currentUser
    ]);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $f2QOW.default), $6d27110e3ddf1d2e$var$_objectSpread($6d27110e3ddf1d2e$var$_objectSpread({}, analyticsContext), {}, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $7opvN.default), $6d27110e3ddf1d2e$var$_objectSpread($6d27110e3ddf1d2e$var$_objectSpread({}, props), {}, {
            hostInfo: hostInfo,
            hostConfig: hostConfig,
            links: links,
            currentUser: currentUser,
            appRequestBaseData: appRequestBaseData,
            appDetailsFromSearchResponse: appDetailsFromSearchResponse,
            fireEvent: fireEvent
        }))
    }));
}
function $6d27110e3ddf1d2e$export$2e2bcd8739ae039(props) {
    var _getSentryClient;
    const appConfig = props.config;
    const sentryConfig = appConfig.sentryConfig;
    const isDev = appConfig.environment === 'local' || appConfig.environment === 'dev';
    const releaseVersion = "EMCEE_NATIVE_".concat((0, $iUPNF.default)).concat(isDev ? '-dev' : '');
    (0, $1S6Gv.initSentry)($6d27110e3ddf1d2e$var$_objectSpread($6d27110e3ddf1d2e$var$_objectSpread({}, sentryConfig), {}, {
        releaseVersion: releaseVersion,
        setupGlobalListeners: false
    }));
    (_getSentryClient = (0, $ighTk.default)()) === null || _getSentryClient === void 0 || _getSentryClient.setTag('requestLocation', props.requestLocation);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $beqRW.default), {
        boundaryName: "marketplaceAppRequestDialog",
        fallback: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gkhxl.AppRequestDialogModalError), {
            onClose: props.onClose
        }),
        children: /*#__PURE__*/ (0, $lHkHI.jsx)($6d27110e3ddf1d2e$export$27e646996cbebe98, $6d27110e3ddf1d2e$var$_objectSpread({}, props))
    });
}

});
parcelRegister("7opvN", function(module, exports) {

$parcel$export(module.exports, "default", () => $561e906580fef01f$export$2e2bcd8739ae039);

var $l9NvU = parcelRequire("l9NvU");
var $5o6SH = parcelRequire("5o6SH");
var $jSigD = parcelRequire("jSigD");
var $492R6 = parcelRequire("492R6");
var $gxv5e = parcelRequire("gxv5e");
var $fHOFY = parcelRequire("fHOFY");

var $kU8RF = parcelRequire("kU8RF");

var $eUqFw = parcelRequire("eUqFw");

var $5kxcx = parcelRequire("5kxcx");

var $7Q8wd = parcelRequire("7Q8wd");

var $5OHDR = parcelRequire("5OHDR");

var $fh2YX = parcelRequire("fh2YX");

var $ce0TX = parcelRequire("ce0TX");

var $B8Ddx = parcelRequire("B8Ddx");

var $5ZqYC = parcelRequire("5ZqYC");

var $2iapx = parcelRequire("2iapx");

var $3ySzw = parcelRequire("3ySzw");

var $lHkHI = parcelRequire("lHkHI");
const $561e906580fef01f$export$3e30ede4df572a0e = (props)=>{
    const dialogType = (0, $5OHDR.getDialogState)(props.appRequestBaseData);
    switch(dialogType){
        case (0, $7Q8wd.DialogState).REQUESTABLE:
            return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3ySzw.AppRequestDialogModalRequestable), {
                    onClose: props.onClose,
                    appKey: props.appKey,
                    appName: props.appRequestBaseData.result.appDetails.name,
                    flags: props.flags,
                    onRequestSuccess: props.onRequestSuccess,
                    onRequestFailure: props.onRequestFailure,
                    hostInfo: (0, $5kxcx.makeHostInfo)(props.hostInfo),
                    fireEvent: props.fireEvent,
                    links: props.links
                })
            });
        case (0, $7Q8wd.DialogState).LOADING:
            return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kU8RF.default), {
                        active: true,
                        delay: 200,
                        size: 50
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jSigD.default), {})
                ]
            });
        case (0, $7Q8wd.DialogState).INSTALLED:
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $B8Ddx.AppRequestDialogModalInstalled), {});
        case (0, $7Q8wd.DialogState).REJECTED:
            {
                var _result$appRequestSta;
                const { result: result } = props.appRequestBaseData;
                const rejectComment = (_result$appRequestSta = result.appRequestStatus) === null || _result$appRequestSta === void 0 ? void 0 : _result$appRequestSta.rejectComment;
                return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5ZqYC.AppRequestDialogModalRejected), {
                    rejectComment: rejectComment
                });
            }
        case (0, $7Q8wd.DialogState).REQUESTED:
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2iapx.AppRequestDialogModalRequested), {});
        default:
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5o6SH.default), {
                children: "Error"
            });
    }
};
function $561e906580fef01f$export$2e2bcd8739ae039(props) {
    (0, $eUqFw.useEffect)(()=>{
        props.fireEvent.viewedAppRequestModalScreen();
    }, []);
    const dialogType = (0, $5OHDR.getDialogState)(props.appRequestBaseData);
    const modalTitle = dialogType === (0, $7Q8wd.DialogState).LOADING ? 'Loading...' : 'Request App';
    const showAppRequestDialogFooter = dialogType === (0, $7Q8wd.DialogState).INSTALLED || dialogType === (0, $7Q8wd.DialogState).REJECTED || dialogType === (0, $7Q8wd.DialogState).REQUESTED;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fHOFY.default), {
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $l9NvU.default), {
            width: "large",
            onClose: props.onClose,
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $492R6.default), {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gxv5e.default), {
                        children: modalTitle
                    })
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $5o6SH.default), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ce0TX.default), {
                            baseDataResult: props.appRequestBaseData.result,
                            appDetailsFromSearchResponse: props.appDetailsFromSearchResponse,
                            links: props.links,
                            config: props.config,
                            appKey: props.appKey,
                            dialogType: dialogType
                        }),
                        $561e906580fef01f$export$3e30ede4df572a0e(props),
                        showAppRequestDialogFooter && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fh2YX.AppRequestDialogFooter), {
                            onClose: props.onClose,
                            links: props.links,
                            appKey: props.appKey
                        })
                    ]
                })
            ]
        })
    });
}

});
parcelRegister("7Q8wd", function(module, exports) {

$parcel$export(module.exports, "DialogState", () => $5b53ff56a3e61415$export$7eb25b1263d43612);
const $5b53ff56a3e61415$export$7eb25b1263d43612 = Object.freeze({
    LOADING: 'LOADING',
    INSTALLED: 'INSTALLED',
    REQUESTED: 'REQUESTED',
    REJECTED: 'REJECTED',
    REQUESTABLE: 'REQUESTABLE',
    ERROR: 'ERROR'
});

});

parcelRegister("5OHDR", function(module, exports) {

$parcel$export(module.exports, "getDialogState", () => $43c3799eda5af136$export$d6b7ed941e5e5b8a);

var $cuo8k = parcelRequire("cuo8k");

var $7Q8wd = parcelRequire("7Q8wd");
function $43c3799eda5af136$export$d6b7ed941e5e5b8a(appRequestBaseData) {
    var _result$appRequestSta, _result$appRequestSta2;
    const { pending: pending, result: result } = appRequestBaseData;
    if (pending) return (0, $7Q8wd.DialogState).LOADING;
    else if (result.appInstallStatus.installationId) return (0, $7Q8wd.DialogState).INSTALLED;
    else if (((_result$appRequestSta = result.appRequestStatus) === null || _result$appRequestSta === void 0 ? void 0 : _result$appRequestSta.status) === (0, $cuo8k.RequestStatus).REJECTED) return (0, $7Q8wd.DialogState).REJECTED;
    else if (((_result$appRequestSta2 = result.appRequestStatus) === null || _result$appRequestSta2 === void 0 ? void 0 : _result$appRequestSta2.status) === (0, $cuo8k.RequestStatus).OPEN) return (0, $7Q8wd.DialogState).REQUESTED;
    else if (!result.appRequestStatus && result.appInstallStatus.status === 'NOT_FOUND') return (0, $7Q8wd.DialogState).REQUESTABLE;
    return (0, $7Q8wd.DialogState).ERROR;
}

});

parcelRegister("fh2YX", function(module, exports) {

$parcel$export(module.exports, "AppRequestDialogFooter", () => $b1eac1c48e332286$export$2f5209dfce17657a);

var $9oiuL = parcelRequire("9oiuL");

var $gykb8 = parcelRequire("gykb8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");
parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $1rGPx = parcelRequire("1rGPx");

var $lHkHI = parcelRequire("lHkHI");
const $b1eac1c48e332286$export$2f5209dfce17657a = (props)=>{
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const handleViewAppDetailsClick = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.LinkClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_VIEW_APP_DETAILS),
            objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_LISTING),
            objectId: props.appKey
        });
        window.open(props.links.appDetails.expand({
            appKey: props.appKey
        }));
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $1rGPx.FooterContainer), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                onClick: handleViewAppDetailsClick,
                children: "View app details"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                appearance: "primary",
                onClick: props.onClose,
                children: "Got it"
            })
        ]
    });
};

});
parcelRegister("1rGPx", function(module, exports) {

$parcel$export(module.exports, "AppRequestStatus", () => $10d98948c4564a59$export$bcc6ea89bba34380);
$parcel$export(module.exports, "AppRequestModalBodyWrapper", () => $10d98948c4564a59$export$738ff1d76774c610);
$parcel$export(module.exports, "AppRequestModalBodyImage", () => $10d98948c4564a59$export$da641d623bce8f5b);
$parcel$export(module.exports, "AppRequestCloseButtonWrapper", () => $10d98948c4564a59$export$fe24fdf11e82dd72);
$parcel$export(module.exports, "AppRequestStatusContent", () => $10d98948c4564a59$export$2e2a56d3fc95aae8);
$parcel$export(module.exports, "FooterContainer", () => $10d98948c4564a59$export$651095642c93be3d);
$parcel$export(module.exports, "RequestableFooterContainer", () => $10d98948c4564a59$export$c1b9dfa185223546);
$parcel$export(module.exports, "RequestableFooterRightContainer", () => $10d98948c4564a59$export$f6a57766fbf42784);

var $3UXZ8 = parcelRequire("3UXZ8");

var $62cXe = parcelRequire("62cXe");

var $8gcXz = parcelRequire("8gcXz");
function $10d98948c4564a59$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $10d98948c4564a59$export$bcc6ea89bba34380 = (0, $3UXZ8.default)("h1", {
    target: "e1asaowm0",
    label: "AppRequestStatus"
})((0, $8gcXz.baseHeadingsCss), " font-size:20px;line-height:", (0, $62cXe.headingSizes).h100.lineHeight / (0, $62cXe.headingSizes).h100.size, ";margin:0 0 15px;");
const $10d98948c4564a59$export$738ff1d76774c610 = (0, $3UXZ8.default)("div", {
    target: "e1asaowm1",
    label: "AppRequestModalBodyWrapper"
})({
    name: "1ioqdc2",
    styles: "max-width:650px;margin:auto;display:flex;flex-direction:column;align-items:center;"
});
const $10d98948c4564a59$export$da641d623bce8f5b = (0, $3UXZ8.default)("img", {
    target: "e1asaowm2",
    label: "AppRequestModalBodyImage"
})({
    name: "1jydukm",
    styles: "margin:auto;margin-top:var(--ds-space-300, 24px);margin-bottom:30px;width:236px;height:212px;"
});
const $10d98948c4564a59$export$fe24fdf11e82dd72 = (0, $3UXZ8.default)("div", {
    target: "e1asaowm3",
    label: "AppRequestCloseButtonWrapper"
})({
    name: "odpfs2",
    styles: "display:flex;margin:15px;flex-direction:column;align-items:center;justify-content:center;"
});
const $10d98948c4564a59$export$2e2a56d3fc95aae8 = (0, $3UXZ8.default)("span", {
    target: "e1asaowm4",
    label: "AppRequestStatusContent"
})({
    name: "1trmeks",
    styles: "display:table-cell;vertical-align:middle;text-align:center;max-width:350px;"
});
const $10d98948c4564a59$export$651095642c93be3d = (0, $3UXZ8.default)("div", {
    target: "e1asaowm5",
    label: "FooterContainer"
})({
    name: "1wx3ipz",
    styles: "display:flex;padding:25px 0px;justify-content:space-between;"
});
const $10d98948c4564a59$export$c1b9dfa185223546 = (0, $3UXZ8.default)("div", {
    target: "e1asaowm6",
    label: "RequestableFooterContainer"
})({
    name: "1wx3ipz",
    styles: "display:flex;padding:25px 0px;justify-content:space-between;"
});
const $10d98948c4564a59$export$f6a57766fbf42784 = (0, $3UXZ8.default)("div", {
    target: "e1asaowm7",
    label: "RequestableFooterRightContainer"
})({
    name: "1tkdocb",
    styles: "display:flex:justify-content:space-between;"
});

});


parcelRegister("ce0TX", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e677ddc69aa040b$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $ly50n = parcelRequire("ly50n");

var $8dnmP = parcelRequire("8dnmP");

var $ammkg = parcelRequire("ammkg");

var $aosfp = parcelRequire("aosfp");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
parcelRequire("eUqFw");

var $abBcx = parcelRequire("abBcx");

var $7Q8wd = parcelRequire("7Q8wd");

var $j4jdu = parcelRequire("j4jdu");

var $lHkHI = parcelRequire("lHkHI");
function $8e677ddc69aa040b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8e677ddc69aa040b$var$AppDialogPricingStyled = /*#__PURE__*/ (0, $3UXZ8.default)((0, $abBcx.default), {
    target: "e17lqsz00",
    label: "AppDialogPricingStyled"
})({
    name: "1wgjut3",
    styles: "margin-bottom:10px;margin-top:33px;"
});
const $8e677ddc69aa040b$var$ContentWrapper = (0, $3UXZ8.default)("div", {
    target: "e17lqsz01",
    label: "ContentWrapper"
})({
    name: "xi606m",
    styles: "text-align:center;"
});
function $8e677ddc69aa040b$export$2e2bcd8739ae039(props) {
    const paymentModelOption = ()=>{
        var _props$baseDataResult, _props$baseDataResult2, _props$baseDataResult3;
        const paymentModel = (_props$baseDataResult = props.baseDataResult.appDetails.versions.edges) === null || _props$baseDataResult === void 0 ? void 0 : (_props$baseDataResult2 = _props$baseDataResult[0]) === null || _props$baseDataResult2 === void 0 ? void 0 : (_props$baseDataResult3 = _props$baseDataResult2.node) === null || _props$baseDataResult3 === void 0 ? void 0 : _props$baseDataResult3.paymentModel;
        return (0, $bWAru.Option).of(paymentModel).map((mpm)=>(0, $j4jdu.foldMarketplaceAppPaymentModel)(mpm)(()=>'free', ()=>'atlassian', ()=>'vendor'));
    };
    const getPrograms = ()=>(0, $8dnmP.makePrograms)(props.baseDataResult.appDetails.programs);
    const isAppCloudFortified = ()=>{
        var _props$baseDataResult4, _props$baseDataResult5;
        return ((_props$baseDataResult4 = props.baseDataResult.appDetails.programs) === null || _props$baseDataResult4 === void 0 ? void 0 : (_props$baseDataResult5 = _props$baseDataResult4.cloudFortified) === null || _props$baseDataResult5 === void 0 ? void 0 : _props$baseDataResult5.programStatus) === (0, $ammkg.MarketplaceProgramStatus).Approved;
    };
    return props.dialogType !== (0, $7Q8wd.DialogState).LOADING ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aosfp.default), {
        appHeaderDetails: (0, $j4jdu.makeRequestAppHeaderProps)(props.baseDataResult.appDetails, props.appDetailsFromSearchResponse, props.links.partnerDetails),
        headerInjection: /*#__PURE__*/ (0, $lHkHI.jsxs)($8e677ddc69aa040b$var$ContentWrapper, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)("br", {}),
                /*#__PURE__*/ (0, $lHkHI.jsx)($8e677ddc69aa040b$var$AppDialogPricingStyled, {
                    hostPricing: {
                        pending: false,
                        result: props.baseDataResult.hostPricing,
                        error: null
                    },
                    appKey: (0, $ly50n.makeAppKey)(props.appKey),
                    links: props.links,
                    hideTryFreeHeading: true,
                    installedApp: (0, $bWAru.Option).none(),
                    paymentModel: paymentModelOption().getOrElse(undefined),
                    mpacBaseUrl: props.config.mpacBaseUrl,
                    eligibleForFreeOnSandbox: false
                })
            ]
        }),
        appRatingLink: props.links.appRating,
        appIconLink: props.links.appIcon,
        isAppCloudFortified: isAppCloudFortified(),
        bugBountyParticipant: getPrograms().bugBountyParticipant,
        showInstallationCount: true,
        appIconSize: "small"
    }) : null;
}

});
parcelRegister("j4jdu", function(module, exports) {

$parcel$export(module.exports, "getAppHeaderDetails", () => $de1d4c0af1aa6f25$export$3624fb652f7fc3fe);
$parcel$export(module.exports, "makeRequestAppHeaderProps", () => $de1d4c0af1aa6f25$export$f3b480a8af5e709f);
$parcel$export(module.exports, "foldMarketplaceAppPaymentModel", () => $de1d4c0af1aa6f25$export$5ab3a34513547cf6);

var $h6uOD = parcelRequire("h6uOD");
var $8dnmP = parcelRequire("8dnmP");

var $9D4R7 = parcelRequire("9D4R7");

var $ammkg = parcelRequire("ammkg");

var $gC8Po = parcelRequire("gC8Po");
var $c9Mth = parcelRequire("c9Mth");
var $de1d4c0af1aa6f25$var$MarketplaceAppRequestGetAppByKey = {
    kind: "Document",
    definitions: [
        {
            kind: "OperationDefinition",
            operation: "query",
            name: {
                kind: "Name",
                value: "MarketplaceAppRequestGetAppByKey"
            },
            variableDefinitions: [
                {
                    kind: "VariableDefinition",
                    variable: {
                        kind: "Variable",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        }
                    },
                    type: {
                        kind: "NonNullType",
                        type: {
                            kind: "NamedType",
                            name: {
                                kind: "Name",
                                value: "String"
                            }
                        }
                    },
                    directives: []
                }
            ],
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "marketplaceAppByKey"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "appKey"
                                },
                                value: {
                                    kind: "Variable",
                                    name: {
                                        kind: "Name",
                                        value: "appKey"
                                    }
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "RequestAppHeaderDetails"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "RequestAppHeaderDetails"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceApp"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "appKey"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "createdAt"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "versions"
                        },
                        arguments: [
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "filter"
                                },
                                value: {
                                    kind: "ObjectValue",
                                    fields: [
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "productHostingOptions"
                                            },
                                            value: {
                                                kind: "ListValue",
                                                values: [
                                                    {
                                                        kind: "EnumValue",
                                                        value: "CLOUD"
                                                    }
                                                ]
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "visibility"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "PUBLIC"
                                            }
                                        },
                                        {
                                            kind: "ObjectField",
                                            name: {
                                                kind: "Name",
                                                value: "excludeHiddenIn"
                                            },
                                            value: {
                                                kind: "EnumValue",
                                                value: "IN_PRODUCT"
                                            }
                                        }
                                    ]
                                }
                            },
                            {
                                kind: "Argument",
                                name: {
                                    kind: "Name",
                                    value: "first"
                                },
                                value: {
                                    kind: "IntValue",
                                    value: "1"
                                }
                            }
                        ],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "edges"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "node"
                                                },
                                                arguments: [],
                                                directives: [],
                                                selectionSet: {
                                                    kind: "SelectionSet",
                                                    selections: [
                                                        {
                                                            kind: "FragmentSpread",
                                                            name: {
                                                                kind: "Name",
                                                                value: "AppVersion"
                                                            },
                                                            directives: []
                                                        }
                                                    ]
                                                }
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "partner"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppPartner"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "reviewSummary"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppReviewSummary"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "distribution"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppDistribution"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "programs"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppProgram"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppVersion"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppVersion"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "paymentModel"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "deployment"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "__typename"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "compatibleProducts"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AppCompatibleProduct"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "InlineFragment",
                                    typeCondition: {
                                        kind: "NamedType",
                                        name: {
                                            kind: "Name",
                                            value: "MarketplaceCloudAppDeployment"
                                        }
                                    },
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "cloudAppId"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppPartner"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplacePartner"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "slug"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "partnerType"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "programs"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "isCloudAppSecuritySelfAssessmentDone"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "partnerTier"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "type"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "updatedDate"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "support"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "contactDetails"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "websiteUrl"
                                                },
                                                arguments: [],
                                                directives: []
                                            },
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AppPartnerSupportContact"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "availability"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "FragmentSpread",
                                                name: {
                                                    kind: "Name",
                                                    value: "AppPartnerSupportAvailability"
                                                },
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "logo"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppListingImage"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppReviewSummary"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppReviewSummary"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "rating"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "count"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppDistribution"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppDistribution"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "downloadCount"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "installationCount"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isPreinstalledInServerDC"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isPreinstalledInCloud"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppProgram"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceAppPrograms"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "cloudFortified"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "status"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "programStatus"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "bugBountyParticipant"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "cloud"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "server"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "dataCenter"
                                    },
                                    arguments: [],
                                    directives: [],
                                    selectionSet: {
                                        kind: "SelectionSet",
                                        selections: [
                                            {
                                                kind: "Field",
                                                name: {
                                                    kind: "Name",
                                                    value: "status"
                                                },
                                                arguments: [],
                                                directives: []
                                            }
                                        ]
                                    }
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppCompatibleProduct"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "CompatibleAtlassianProduct"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "id"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "name"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "__typename"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "atlassianProduct"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "name"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "hostingOptions"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppPartnerSupportContact"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplacePartnerSupportContact"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "emailId"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "phoneNumber"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "websiteUrl"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppPartnerSupportAvailability"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplacePartnerSupportAvailability"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "daysOfWeek"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "isAvailable24Hours"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "startTime"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "endTime"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "timezone"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "timezoneOffset"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "holidays"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "FragmentSpread",
                                    name: {
                                        kind: "Name",
                                        value: "AppPartnerSupportHolidays"
                                    },
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppListingImage"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplaceListingImage"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "original"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "width"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "height"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "highResolution"
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: {
                            kind: "SelectionSet",
                            selections: [
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "id"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "width"
                                    },
                                    arguments: [],
                                    directives: []
                                },
                                {
                                    kind: "Field",
                                    name: {
                                        kind: "Name",
                                        value: "height"
                                    },
                                    arguments: [],
                                    directives: []
                                }
                            ]
                        }
                    }
                ]
            }
        },
        {
            kind: "FragmentDefinition",
            name: {
                kind: "Name",
                value: "AppPartnerSupportHolidays"
            },
            typeCondition: {
                kind: "NamedType",
                name: {
                    kind: "Name",
                    value: "MarketplacePartnerSupportHoliday"
                }
            },
            directives: [],
            selectionSet: {
                kind: "SelectionSet",
                selections: [
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "holidayFrequency"
                        },
                        arguments: [],
                        directives: []
                    },
                    {
                        kind: "Field",
                        name: {
                            kind: "Name",
                            value: "date"
                        },
                        arguments: [],
                        directives: []
                    }
                ]
            }
        }
    ],
    loc: {
        start: 0,
        end: 2760,
        source: {
            body: "# If you are making any change here\n# Do thoroughly read our graphql contribution guidelines\n# https://bitbucket.org/atlassian-marketplace/marketplace-frontend/src/master/docs/working-with-graphql.md\n\nfragment AppCompatibleProduct on CompatibleAtlassianProduct {\n  # These should be fixed when we migrate this GraphQL query to BFF in Mosaic\n  # eslint-disable-next-line @graphql-eslint/no-deprecated\n  id\n  # eslint-disable-next-line @graphql-eslint/no-deprecated\n  name\n  __typename\n\n  atlassianProduct {\n    name\n    hostingOptions\n  }\n}\n\nfragment AppVersion on MarketplaceAppVersion {\n  paymentModel\n  deployment {\n    __typename\n    compatibleProducts {\n      ...AppCompatibleProduct\n    }\n    ... on MarketplaceCloudAppDeployment {\n      cloudAppId\n    }\n  }\n}\n\nfragment AppPartnerSupportContact on MarketplacePartnerSupportContact {\n  emailId\n  phoneNumber\n  websiteUrl\n}\n\nfragment AppPartner on MarketplacePartner {\n  name\n  id\n  slug\n  partnerType\n  programs {\n    isCloudAppSecuritySelfAssessmentDone\n  }\n  partnerTier {\n    type\n    updatedDate\n  }\n  support {\n    contactDetails {\n      websiteUrl\n      ...AppPartnerSupportContact\n    }\n\n    availability {\n      ...AppPartnerSupportAvailability\n    }\n  }\n  logo {\n    ...AppListingImage\n  }\n}\n\nfragment AppListingImage on MarketplaceListingImage {\n  original {\n    id\n    width\n    height\n  }\n  highResolution {\n    id\n    width\n    height\n  }\n}\n\nfragment AppPartnerSupportAvailability on MarketplacePartnerSupportAvailability {\n  daysOfWeek\n  isAvailable24Hours\n  startTime\n  endTime\n  timezone\n  timezoneOffset\n  holidays {\n    ...AppPartnerSupportHolidays\n  }\n}\n\nfragment AppPartnerSupportHolidays on MarketplacePartnerSupportHoliday {\n  holidayFrequency\n  date\n}\n\nfragment AppReviewSummary on MarketplaceAppReviewSummary {\n  rating\n  count\n}\n\nfragment AppDistribution on MarketplaceAppDistribution {\n  downloadCount\n  installationCount\n  isPreinstalledInServerDC\n  isPreinstalledInCloud\n}\n\nfragment AppProgram on MarketplaceAppPrograms {\n  cloudFortified {\n    status\n    programStatus\n  }\n  bugBountyParticipant {\n    cloud {\n      status\n    }\n    server {\n      status\n    }\n    dataCenter {\n      status\n    }\n  }\n}\n\nfragment RequestAppHeaderDetails on MarketplaceApp {\n  name\n  appKey\n  createdAt\n  versions(\n    filter: { productHostingOptions: [CLOUD], visibility: PUBLIC, excludeHiddenIn: IN_PRODUCT }\n    first: 1\n  ) {\n    edges {\n      node {\n        ...AppVersion\n      }\n    }\n  }\n  partner {\n    ...AppPartner\n  }\n  reviewSummary {\n    ...AppReviewSummary\n  }\n  distribution {\n    ...AppDistribution\n  }\n  programs {\n    ...AppProgram\n  }\n}\n\nquery MarketplaceAppRequestGetAppByKey($appKey: String!) {\n  marketplaceAppByKey(appKey: $appKey) {\n    ...RequestAppHeaderDetails\n  }\n}\n",
            name: "GraphQL request",
            locationOffset: {
                line: 1,
                column: 1
            }
        }
    }
};
const $de1d4c0af1aa6f25$export$3624fb652f7fc3fe = async (gatewayUrl, appKey)=>{
    const { errors: errors, data: data } = await (0, $9D4R7.graphQLRequest)(gatewayUrl, {
        query: $de1d4c0af1aa6f25$var$MarketplaceAppRequestGetAppByKey,
        variables: {
            appKey: appKey
        }
    });
    if (errors !== null && errors !== void 0 && errors.length) throw errors;
    if (!(data !== null && data !== void 0 && data.marketplaceAppByKey)) throw new Error("Unable to fetch app with key \"".concat(appKey, "\"'"));
    return data.marketplaceAppByKey;
};
const $de1d4c0af1aa6f25$export$f3b480a8af5e709f = (app, appDetailsFromSearchResponse, partnerDetailsLink)=>{
    var _appDetailsFromSearch, _app$versions$edges, _app$versions$edges$, _app$versions$edges$$;
    const reviewSummary = (0, $8dnmP.makeReviewSummary)(app.reviewSummary);
    const partner = (0, $8dnmP.makePartner)(app.partner, partnerDetailsLink);
    const distribution = (0, $8dnmP.makeDistribution)(app.distribution, appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : (_appDetailsFromSearch = appDetailsFromSearchResponse.appData) === null || _appDetailsFromSearch === void 0 ? void 0 : _appDetailsFromSearch.distribution, (0, $ammkg.AtlassianProductHostingType).Cloud);
    return {
        name: app.name,
        key: app.appKey,
        ratings: {
            avgStars: reviewSummary.rating,
            numRatings: reviewSummary.count
        },
        createdAt: new Date(app.createdAt),
        distribution: {
            downloadCount: distribution.downloadCount,
            installationCount: distribution.installationCount,
            isPreinstalled: distribution.isPreinstalled,
            isPreinstalledInAnyHosting: distribution.isPreinstalledInAnyHosting,
            isLoading: appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : appDetailsFromSearchResponse.loading,
            isError: appDetailsFromSearchResponse === null || appDetailsFromSearchResponse === void 0 ? void 0 : appDetailsFromSearchResponse.error
        },
        compatibleProducts: (_app$versions$edges = app.versions.edges) === null || _app$versions$edges === void 0 ? void 0 : (_app$versions$edges$ = _app$versions$edges[0]) === null || _app$versions$edges$ === void 0 ? void 0 : (_app$versions$edges$$ = _app$versions$edges$.node) === null || _app$versions$edges$$ === void 0 ? void 0 : _app$versions$edges$$.deployment.compatibleProducts.map((p)=>p.name),
        origin: (0, $h6uOD.APP_HEADER_ORIGIN),
        partner: {
            name: partner.name,
            link: (0, $c9Mth).validateSafeAbsoluteUrl(partner.url),
            partnerTierType: partner.partnerTierType
        }
    };
};
const $de1d4c0af1aa6f25$export$5ab3a34513547cf6 = (p)=>(free, atlassian, vendor)=>{
        switch(p){
            case 'PAID_VIA_ATLASSIAN':
                return atlassian();
            case 'FREE':
                return free();
            case 'PAID_VIA_PARTNER':
                return vendor();
            default:
                throw (0, $gC8Po.default).unexpectedCase(p);
        }
    };

});


parcelRegister("B8Ddx", function(module, exports) {

$parcel$export(module.exports, "AppRequestDialogModalInstalled", () => $06fa26dc13691949$export$b6daa97a2872916d);

var $fHOFY = parcelRequire("fHOFY");

var $8VfNq = parcelRequire("8VfNq");
parcelRequire("eUqFw");

var $lUBwM = parcelRequire("lUBwM");

var $lHkHI = parcelRequire("lHkHI");
const $06fa26dc13691949$export$b6daa97a2872916d = ()=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fHOFY.default), {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8VfNq.default), {
            appearance: "success",
            children: /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                children: (0, $lUBwM.INSTALLED_STATE_CONTENT)
            })
        })
    });
};

});
parcelRegister("lUBwM", function(module, exports) {

$parcel$export(module.exports, "TEST_ID", () => $ff3bf02adea2a033$export$a7bb072605d6094c);
$parcel$export(module.exports, "INSTALLED_STATE_CONTENT", () => $ff3bf02adea2a033$export$efbc7d7b1bfbdf27);
$parcel$export(module.exports, "REJECTED_STATUS_CONTENT", () => $ff3bf02adea2a033$export$aad92321a6b7d7a4);
$parcel$export(module.exports, "REQUESTED_STATE_CONTENT", () => $ff3bf02adea2a033$export$fcbf3e5843cb17d8);
const $ff3bf02adea2a033$export$a7bb072605d6094c = {
    APP_REQUEST_BTN: 'request-app__request-app-btn',
    APP_REQUEST_MODAL_CLOSE_BTN: 'request-app__close-modal-btn',
    APP_REQUEST_MODAL_SUBMIT_BTN: 'request-app-modal__submit-request-btn'
};
const $ff3bf02adea2a033$export$efbc7d7b1bfbdf27 = 'This app is already installed on your instance.';
const $ff3bf02adea2a033$export$aad92321a6b7d7a4 = 'Your app request was rejected since';
const $ff3bf02adea2a033$export$fcbf3e5843cb17d8 = 'Your app request is currently under review. Please reach out to your site admin for more details';

});


parcelRegister("5ZqYC", function(module, exports) {

$parcel$export(module.exports, "AppRequestDialogModalRejected", () => $45c79343ef866d88$export$832cc6248c8d9fd4);

var $fHOFY = parcelRequire("fHOFY");

var $8VfNq = parcelRequire("8VfNq");
parcelRequire("eUqFw");

var $lUBwM = parcelRequire("lUBwM");

var $lHkHI = parcelRequire("lHkHI");
const $45c79343ef866d88$export$832cc6248c8d9fd4 = (props)=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fHOFY.default), {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8VfNq.default), {
            appearance: "error",
            children: /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                children: [
                    (0, $lUBwM.REJECTED_STATUS_CONTENT),
                    " ",
                    props.rejectComment
                ]
            })
        })
    });
};

});

parcelRegister("2iapx", function(module, exports) {

$parcel$export(module.exports, "AppRequestDialogModalRequested", () => $1ab55697e310b4c1$export$8e617ba1a6e4873);

var $fHOFY = parcelRequire("fHOFY");

var $8VfNq = parcelRequire("8VfNq");
parcelRequire("eUqFw");

var $lUBwM = parcelRequire("lUBwM");

var $lHkHI = parcelRequire("lHkHI");
const $1ab55697e310b4c1$export$8e617ba1a6e4873 = ()=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fHOFY.default), {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8VfNq.default), {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                children: (0, $lUBwM.REQUESTED_STATE_CONTENT)
            })
        })
    });
};

});

parcelRegister("3ySzw", function(module, exports) {

$parcel$export(module.exports, "AppRequestDialogModalRequestable", () => $297ee0ec942a8e95$export$b437be0c1df1c50d);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $cQKn6 = parcelRequire("cQKn6");

var $9oiuL = parcelRequire("9oiuL");

var $gxv5e = parcelRequire("gxv5e");

var $8VfNq = parcelRequire("8VfNq");

var $2ruhQ = parcelRequire("2ruhQ");

var $j0gMm = parcelRequire("j0gMm");

var $gykb8 = parcelRequire("gykb8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $bm7IM = parcelRequire("bm7IM");

var $bTrQR = parcelRequire("bTrQR");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $gRo3n = parcelRequire("gRo3n");

var $bSQ4o = parcelRequire("bSQ4o");

var $3lzNh = parcelRequire("3lzNh");

var $lUBwM = parcelRequire("lUBwM");

var $1rGPx = parcelRequire("1rGPx");

var $lHkHI = parcelRequire("lHkHI");
function $297ee0ec942a8e95$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $297ee0ec942a8e95$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $297ee0ec942a8e95$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $297ee0ec942a8e95$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $297ee0ec942a8e95$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $297ee0ec942a8e95$export$8b7b7cdfb85d78c5 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $cQKn6.default), {
    target: "ebig46w0",
    label: "SubmitButton"
})({
    name: "j6808u",
    styles: "margin-left:10px;margin-right:10px;"
});
const $297ee0ec942a8e95$export$fbe0381af1a2ee78 = (0, $3UXZ8.default)("p", {
    target: "ebig46w1",
    label: "InstructionText"
})("color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N200), ")"), ";margin-bottom:var(--ds-space-100, 8px);");
const $297ee0ec942a8e95$export$585a3b23e887288b = (0, $3UXZ8.default)("div", {
    target: "ebig46w2",
    label: "TitleWrapper"
})({
    name: "1k7usd8",
    styles: "margin-top:var(--ds-space-300, 24px);"
});
const $297ee0ec942a8e95$export$7e367b5ecaaba455 = 'Close';
const $297ee0ec942a8e95$export$370735d8e3124931 = 'Request';
const $297ee0ec942a8e95$export$8d13340382210b65 = (0, $3UXZ8.default)("p", {
    target: "ebig46w3",
    label: "Hint"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N400), ")"), ";font-size:12px;margin-top:var(--ds-space-250, 20px);white-space:pre-line;");
const $297ee0ec942a8e95$var$DEFAULT_COMMENT = "Hi, I'd like to try this app. I think it could be really useful to the team.\n\nThanks!";
const $297ee0ec942a8e95$export$da23b793d992ac4f = {
    description: 'We have sent your app request to your admin. Your work here is done!',
    title: 'App requested',
    type: (0, $bm7IM.FLAG_TYPE_SUCCESS),
    isAutoDismiss: true
};
const $297ee0ec942a8e95$var$requestAppFailureFlag = {
    description: 'It might just be a hiccup. Try again in a bit.',
    title: "We ran into some trouble!",
    type: (0, $bm7IM.FLAG_TYPE_ERROR),
    isAutoDismiss: true
};
const $297ee0ec942a8e95$export$b437be0c1df1c50d = (props)=>{
    const TITLE = 'Want this app? Let your admin know why';
    const [comment, setComment] = (0, $eUqFw.useState)($297ee0ec942a8e95$var$DEFAULT_COMMENT);
    const [isRequestingApp, setRequestingAppFlag] = (0, $eUqFw.useState)(false);
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const handleViewAppDetailsClick = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.LinkClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_VIEW_APP_DETAILS),
            objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_LISTING),
            objectId: props.appKey
        });
        window.open(props.links.appDetails.expand({
            appKey: props.appKey
        }));
    };
    const handleAnalyticsButtonClickEvent = (actionSubjectId)=>fireAnalyticsEvent({
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: actionSubjectId,
            objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_LISTING),
            objectId: props.appKey
        });
    const handleChangeBody = (event)=>{
        setComment(event.target.value.trim());
    };
    const handleSubmitAppRequest = async ()=>{
        const { appKey: appKey, hostInfo: hostInfo, fireEvent: fireEvent, appName: appName } = props;
        const productName = hostInfo.product;
        const cloudId = (0, $bSQ4o.getCloudIdFromHostInfo)(hostInfo);
        setRequestingAppFlag(true);
        handleAnalyticsButtonClickEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_REQUEST_APP_SUBMITTED));
        (0, $3lzNh.RequestAppTask).start();
        const appDetails = {
            appName: appName,
            appKey: appKey,
            productName: productName,
            comment: comment
        };
        try {
            var _props$onRequestSucce;
            await (0, $gRo3n.requestApp)({
                productName: productName,
                cloudId: cloudId,
                appKey: appKey,
                comment: comment
            });
            props.onClose();
            props.flags.show($297ee0ec942a8e95$var$_objectSpread($297ee0ec942a8e95$var$_objectSpread({}, $297ee0ec942a8e95$export$da23b793d992ac4f), {}, {
                id: "".concat(appKey, "-app-request-success")
            }));
            fireEvent.requestSucceeded(appKey);
            (0, $3lzNh.RequestAppTask).succeeded();
            (_props$onRequestSucce = props.onRequestSuccess) === null || _props$onRequestSucce === void 0 || _props$onRequestSucce.call(props, appDetails);
        } catch (error) {
            var _props$onRequestFailu;
            props.onClose();
            props.flags.show($297ee0ec942a8e95$var$_objectSpread($297ee0ec942a8e95$var$_objectSpread({}, $297ee0ec942a8e95$var$requestAppFailureFlag), {}, {
                id: "".concat(appKey, "-app-request-error")
            }));
            (0, $bTrQR.default).error('AppRequestDialogModalRequestable', error);
            fireEvent.requestFailed(appKey, error);
            (0, $3lzNh.RequestAppTask).failed(error, error.code || error.status);
            (_props$onRequestFailu = props.onRequestFailure) === null || _props$onRequestFailu === void 0 || _props$onRequestFailu.call(props, appDetails);
        } finally{
            setRequestingAppFlag(false);
        }
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8VfNq.default), {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                    children: "Only product and site admin can install apps. You'll need to request your admin to install this app"
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($297ee0ec942a8e95$export$585a3b23e887288b, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gxv5e.default), {
                    children: TITLE
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($297ee0ec942a8e95$export$fbe0381af1a2ee78, {
                children: "Describe the problem you are trying to solve, how many team members would use and benefit from this app, etc."
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2ruhQ.default), {
                placeholder: "Type your reasons in here",
                resize: "auto",
                minimumRows: 5,
                onChange: handleChangeBody,
                defaultValue: comment
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $1rGPx.RequestableFooterContainer), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                        onClick: handleViewAppDetailsClick,
                        children: "View app details"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $1rGPx.RequestableFooterRightContainer), {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)($297ee0ec942a8e95$export$8b7b7cdfb85d78c5, {
                                testId: (0, $lUBwM.TEST_ID).APP_REQUEST_MODAL_SUBMIT_BTN,
                                appearance: "primary",
                                onClick: handleSubmitAppRequest,
                                isLoading: isRequestingApp,
                                isDisabled: comment.length === 0,
                                children: $297ee0ec942a8e95$export$370735d8e3124931
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                                testId: (0, $lUBwM.TEST_ID).APP_REQUEST_MODAL_CLOSE_BTN,
                                appearance: "subtle",
                                onClick: ()=>{
                                    props.onClose();
                                    handleAnalyticsButtonClickEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_REQUEST_APP_CANCELED));
                                },
                                children: $297ee0ec942a8e95$export$7e367b5ecaaba455
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

});


parcelRegister("gkhxl", function(module, exports) {

$parcel$export(module.exports, "AppRequestDialogModalError", () => $be2c1e05320e1702$export$84f78231ae342d01);

var $9oiuL = parcelRequire("9oiuL");

var $l9NvU = parcelRequire("l9NvU");
var $5o6SH = parcelRequire("5o6SH");
var $fHOFY = parcelRequire("fHOFY");
parcelRequire("eUqFw");

var $1rGPx = parcelRequire("1rGPx");

var $jgKfD = parcelRequire("jgKfD");

var $lHkHI = parcelRequire("lHkHI");
const $be2c1e05320e1702$export$84f78231ae342d01 = (props)=>{
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fHOFY.default), {
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $l9NvU.default), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5o6SH.default), {
                    children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $1rGPx.AppRequestModalBodyWrapper), {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1rGPx.AppRequestModalBodyImage), {
                                src: (0, (/*@__PURE__*/$parcel$interopDefault($jgKfD)))
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1rGPx.AppRequestStatus), {
                                children: "Error"
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1rGPx.AppRequestStatusContent), {
                                children: "We ran into a little trouble and could not load the details."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1rGPx.AppRequestCloseButtonWrapper), {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                        appearance: "primary",
                        onClick: props.onClose,
                        children: "Got it."
                    })
                })
            ]
        })
    });
};

});
parcelRegister("jgKfD", function(module, exports) {
module.exports = new URL("app-request-error-state.94b90979.png", import.meta.url).toString();

});


parcelRegister("la8zm", function(module, exports) {

$parcel$export(module.exports, "useAppRequestAnalytics", () => $f6812dd1c4ef78c7$export$ccc2ed26eb7d6418);

var $5zQU9 = parcelRequire("5zQU9");

var $9osuT = parcelRequire("9osuT");

var $kafab = parcelRequire("kafab");

var $7IZKi = parcelRequire("7IZKi");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $gIQkA = parcelRequire("gIQkA");

var $j4jdu = parcelRequire("j4jdu");
function $f6812dd1c4ef78c7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f6812dd1c4ef78c7$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f6812dd1c4ef78c7$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f6812dd1c4ef78c7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f6812dd1c4ef78c7$var$makeAnalyticsContextProperties = (_ref)=>{
    let { currentScreen: currentScreen } = _ref;
    return $f6812dd1c4ef78c7$var$_objectSpread({}, currentScreen && {
        source: currentScreen.name
    });
};
const $f6812dd1c4ef78c7$var$makeAnalyticsContextAttributes = (_ref2)=>{
    var _appDetails$versions$, _appDetails$versions$2, _appDetails$versions$3, _appDetails$versions$4, _appDetails$versions$5, _appDetails$versions$6;
    let { baseData: baseData, requestLocation: requestLocation } = _ref2;
    const attributes = {
        requestLocation: requestLocation,
        category: (0, $7Uh51.ANALYTICS_CATEGORY_MARKETPLACE_APP_REQUEST)
    };
    if (!baseData.result || !baseData.result.appDetails) return attributes;
    const appDetails = baseData.result.appDetails;
    const appKey = appDetails.appKey;
    const programs = appDetails.programs;
    let paymentModel = (_appDetails$versions$ = appDetails.versions.edges) === null || _appDetails$versions$ === void 0 ? void 0 : (_appDetails$versions$2 = _appDetails$versions$[0]) === null || _appDetails$versions$2 === void 0 ? void 0 : (_appDetails$versions$3 = _appDetails$versions$2.node) === null || _appDetails$versions$3 === void 0 ? void 0 : _appDetails$versions$3.paymentModel;
    paymentModel = paymentModel && (0, $j4jdu.foldMarketplaceAppPaymentModel)(paymentModel)(()=>'free', ()=>'atlassian', ()=>'vendor');
    const isEcosystemCloudApp = ((_appDetails$versions$4 = appDetails.versions.edges) === null || _appDetails$versions$4 === void 0 ? void 0 : (_appDetails$versions$5 = _appDetails$versions$4[0]) === null || _appDetails$versions$5 === void 0 ? void 0 : (_appDetails$versions$6 = _appDetails$versions$5.node) === null || _appDetails$versions$6 === void 0 ? void 0 : _appDetails$versions$6.deployment.__typename) === (0, $kafab.AppDeployment).ECOSYSTEM_CLOUD;
    let cloudAppDeployment;
    if (isEcosystemCloudApp) {
        var _appDetails$versions$7, _appDetails$versions$8, _appDetails$versions$9;
        cloudAppDeployment = (_appDetails$versions$7 = appDetails.versions.edges) === null || _appDetails$versions$7 === void 0 ? void 0 : (_appDetails$versions$8 = _appDetails$versions$7[0]) === null || _appDetails$versions$8 === void 0 ? void 0 : (_appDetails$versions$9 = _appDetails$versions$8.node) === null || _appDetails$versions$9 === void 0 ? void 0 : _appDetails$versions$9.deployment;
    }
    return $f6812dd1c4ef78c7$var$_objectSpread($f6812dd1c4ef78c7$var$_objectSpread({}, attributes), {}, {
        appKey: appKey,
        paymentModel: paymentModel,
        programs: programs,
        isEcosystemCloudApp: !!isEcosystemCloudApp
    }, cloudAppDeployment && {
        ecosystemCloudAppId: cloudAppDeployment.cloudAppId
    });
};
const $f6812dd1c4ef78c7$export$ccc2ed26eb7d6418 = (_ref3)=>{
    let { baseData: baseData, requestLocation: requestLocation } = _ref3;
    const fireEvent = (0, $9osuT.useAnalyticsEvents)();
    const [currentScreen, setCurrentScreen] = (0, $eUqFw.useState)(null);
    const analyticsContext = (0, $eUqFw.useMemo)(()=>({
            properties: $f6812dd1c4ef78c7$var$makeAnalyticsContextProperties({
                currentScreen: currentScreen
            }),
            attributes: $f6812dd1c4ef78c7$var$makeAnalyticsContextAttributes({
                baseData: baseData,
                requestLocation: requestLocation
            })
        }), [
        baseData.pending,
        currentScreen,
        requestLocation
    ]);
    const fireScreenEvent = function fireScreenEvent(eventType) {
        let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return fireEvent((0, (/*@__PURE__*/$parcel$interopDefault($7IZKi)))([
            {
                eventType: eventType
            },
            {
                attributes: analyticsContext.attributes
            },
            payload
        ]));
    };
    const fireTrackEvent = function fireTrackEvent(eventType) {
        let payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        return fireEvent((0, (/*@__PURE__*/$parcel$interopDefault($7IZKi)))([
            {
                eventType: eventType
            },
            {
                source: currentScreen,
                attributes: analyticsContext.attributes
            },
            payload
        ]));
    };
    return {
        fireEvent: {
            viewedAppRequestModalScreen: ()=>{
                fireScreenEvent((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_APP_REQUEST));
                setCurrentScreen((0, $gIQkA.ANALYTICS_MODAL_STANDALONE_APP_REQUEST));
            },
            requestSucceeded: (appKey)=>{
                fireTrackEvent((0, $7Uh51.AppRequestedEvent), {
                    actionSubjectId: appKey
                });
                setCurrentScreen(null);
            },
            requestFailed: (appKey, error)=>{
                fireTrackEvent((0, $7Uh51.AppRequestFailedEvent), {
                    actionSubjectId: appKey,
                    attributes: {
                        errorCode: error.code,
                        error: error.message,
                        source: error.source
                    }
                });
                setCurrentScreen(null);
            }
        },
        analyticsContext: analyticsContext
    };
};

});

parcelRegister("5rzWv", function(module, exports) {

$parcel$export(module.exports, "useAppRequestBaseData", () => $3f6b5ad992545f29$export$4f3746fa72dd6449);

var $9c9Gu = parcelRequire("9c9Gu");
var $bTrQR = parcelRequire("bTrQR");

var $ifMZN = parcelRequire("ifMZN");

var $gRo3n = parcelRequire("gRo3n");

var $bSQ4o = parcelRequire("bSQ4o");

var $55gtq = parcelRequire("55gtq");

var $8AJas = parcelRequire("8AJas");

var $j4jdu = parcelRequire("j4jdu");
function $3f6b5ad992545f29$export$4f3746fa72dd6449(config, hostInfo, user, appKey) {
    const { usePromise: usePromise } = (0, $9c9Gu);
    const productName = hostInfo === null || hostInfo === void 0 ? void 0 : hostInfo.product;
    const cloudId = productName && (0, $bSQ4o.getCloudIdFromHostInfo)(hostInfo);
    const userId = user === null || user === void 0 ? void 0 : user.atlassianAccountId;
    const runPromise = !!(cloudId && userId);
    const { result: result, error: error, pending: pending } = usePromise(async ()=>{
        const hostPricingPromise = (0, $55gtq.default)().getHostPricingInfo();
        const appRequestStatusParams = {
            cloudId: cloudId,
            productName: productName,
            appKey: appKey,
            userId: userId
        };
        const appRequestStatusPromise = (0, $gRo3n.getAppRequestedStatus)(appRequestStatusParams).catch((error_)=>{
            if (error_.status !== 404) console.log('failed to fetch app request status');
            return null;
        });
        const appDetailsPromise = (0, $j4jdu.getAppHeaderDetails)(config.graphQLGatewayUrl, appKey);
        const identifier = await (0, $8AJas.getInstallableApp)(config.graphQLGatewayUrl, appKey);
        const appInstallStatusPromise = (0, $55gtq.default)().getInstalledAddon({
            contextId: hostInfo === null || hostInfo === void 0 ? void 0 : hostInfo.globalContext.id,
            addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)(identifier)
        });
        const [hostPricing, appInstallStatus, appRequestStatus, appDetails] = await Promise.all([
            hostPricingPromise,
            appInstallStatusPromise,
            appRequestStatusPromise,
            appDetailsPromise
        ]);
        return {
            hostPricing: hostPricing,
            appInstallStatus: appInstallStatus,
            appRequestStatus: appRequestStatus,
            appDetails: appDetails
        };
    }, [
        runPromise
    ], runPromise);
    if (error) (0, $bTrQR.default).error('useAppRequestBaseData', "Failed to retrieve app request base data", {
        error: error
    });
    return {
        pending: pending,
        error: error,
        result: result
    };
}

});


parcelRegister("hsvfa", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb5d498a86d953fa$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $cQKn6 = parcelRequire("cQKn6");

var $9oiuL = parcelRequire("9oiuL");

var $2ruhQ = parcelRequire("2ruhQ");

var $j0gMm = parcelRequire("j0gMm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $c1ZLO = parcelRequire("c1ZLO");

var $bTrQR = parcelRequire("bTrQR");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $gIQkA = parcelRequire("gIQkA");

var $jC5dB = parcelRequire("jC5dB");

var $gRo3n = parcelRequire("gRo3n");

var $3lzNh = parcelRequire("3lzNh");

var $3kdNe = parcelRequire("3kdNe");

var $lHkHI = parcelRequire("lHkHI");
function $cb5d498a86d953fa$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $cb5d498a86d953fa$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $cb5d498a86d953fa$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $cb5d498a86d953fa$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $cb5d498a86d953fa$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $cb5d498a86d953fa$export$b6d9565de1e068cf = (0, $3UXZ8.default)("div", {
    target: "ew864hm0",
    label: "DialogContent"
})({
    name: "16b2ug3",
    styles: "margin:15px 0;"
});
const $cb5d498a86d953fa$export$8d13340382210b65 = (0, $3UXZ8.default)("p", {
    target: "ew864hm1",
    label: "Hint"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N400), ")"), ";font-size:12px;margin-top:var(--ds-space-250, 20px);white-space:pre-line;");
const $cb5d498a86d953fa$export$8b7b7cdfb85d78c5 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $cQKn6.default), {
    target: "ew864hm2",
    label: "SubmitButton"
})({
    name: "1y6ic72",
    styles: "margin-left:10px;"
});
// eslint-disable-next-line max-lines-per-function -- Fix me
function $cb5d498a86d953fa$var$RequestAppModal(props) {
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const defaultComment = "Hi, I'd like to try this app. I think it could be really useful to the team.\n\nThanks!";
    const [comment, setComment] = (0, $eUqFw.useState)(defaultComment);
    const [isRequestingApp, setRequestingAppFlag] = (0, $eUqFw.useState)(false);
    const ecosystemCloudAppId = props.ecosystemCloudAppId;
    const onChange = (event)=>{
        setComment(event.target.value.trim());
    };
    const onRequestApp = ()=>{
        const { appKey: appKey, productName: productName, cloudId: cloudId, addFlag: addFlag } = props;
        setRequestingAppFlag(true);
        handleAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_REQUEST_APP_SUBMITTED));
        (0, $3lzNh.RequestAppTask).start();
        (0, $gRo3n.requestApp)({
            productName: productName,
            cloudId: cloudId,
            appKey: appKey,
            comment: comment
        }).then((_)=>{
            props.closeModal();
            props.onRequestSubmit();
            addFlag($cb5d498a86d953fa$var$requestAppSuccessFlag);
            fireAnalyticsEvent({
                eventType: (0, $7Uh51.AppRequestedEvent),
                actionSubjectId: props.appKey
            });
            (0, $3lzNh.RequestAppTask).succeeded();
        }).catch((error)=>{
            addFlag($cb5d498a86d953fa$var$requestAppFailureFlag);
            fireAnalyticsEvent({
                eventType: (0, $7Uh51.AppRequestFailedEvent),
                actionSubjectId: props.appKey,
                attributes: {
                    error: error
                }
            });
            (0, $bTrQR.default).error('RequestAppModal', "Failed to create new App request", {
                error: error
            });
            (0, $3lzNh.RequestAppTask).failed(error, error.code || error.status);
        }).finally((_)=>setRequestingAppFlag(false));
    };
    const body = ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                    children: "This app will require an approval from your admin. Let them know how this app can be useful for you."
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2ruhQ.default), {
                    placeholder: "Type your reasons in here",
                    resize: "auto",
                    minimumRows: 5,
                    onChange: onChange,
                    defaultValue: comment
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)($cb5d498a86d953fa$export$8d13340382210b65, {
                    children: [
                        "Not too sure about what to type? Here are a few pointers to get you started:",
                        '\n',
                        "\u2022 Tell your admin more about the problem you are trying to solve with this app.",
                        '\n',
                        "\u2022 How many team members do you think would potentially use and benefit from using this app?",
                        '\n',
                        "\u2022 Talk about any similar apps you may have considered or tried earlier."
                    ]
                })
            ]
        });
    const footer = ()=>{
        return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                    testId: (0, $c1ZLO.TEST_ID).REQUEST_APP_MODAL_CLOSE_BTN,
                    appearance: "subtle",
                    onClick: ()=>{
                        props.closeModal();
                        handleAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_REQUEST_APP_CANCELED));
                    },
                    children: "Cancel"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($cb5d498a86d953fa$export$8b7b7cdfb85d78c5, {
                    testId: (0, $c1ZLO.TEST_ID).REQUEST_APP_MODAL_SUBMIT_BTN,
                    appearance: "primary",
                    onClick: onRequestApp,
                    isLoading: isRequestingApp,
                    isDisabled: comment.length === 0,
                    children: "Submit request"
                })
            ]
        });
    };
    const handleAnalyticsEvent = (actionSubjectId)=>fireAnalyticsEvent({
            attributes: $cb5d498a86d953fa$var$_objectSpread({}, ecosystemCloudAppId && {
                isEcosystemCloudApp: true,
                ecosystemCloudAppId: ecosystemCloudAppId
            }),
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: actionSubjectId,
            objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_LISTING),
            objectId: props.appKey
        });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3kdNe.default), {
        analyticsName: (0, $gIQkA.ANALYTICS_MODAL_REQUEST_APP),
        width: "medium",
        heading: "Request to install",
        onClose: props.closeModal,
        footer: footer(),
        children: body()
    });
}
const $cb5d498a86d953fa$var$requestAppSuccessFlag = (0, $jC5dB.makeFlag)({
    autoDismiss: true,
    appearance: (0, $jC5dB.SUCCESS_APPEARANCE),
    description: (0, $jC5dB.makeFlagDescription)({
        primary: 'We have sent your app request to your admin. Your work here is done!'
    }),
    title: 'App requested'
});
const $cb5d498a86d953fa$var$requestAppFailureFlag = (0, $jC5dB.makeFlag)({
    autoDismiss: true,
    appearance: (0, $jC5dB.ERROR_APPEARANCE),
    description: (0, $jC5dB.makeFlagDescription)({
        primary: 'It might just be a hiccup. Try again in a bit.'
    }),
    title: 'We ran into a little trouble'
});
var $cb5d498a86d953fa$export$2e2bcd8739ae039 = $cb5d498a86d953fa$var$RequestAppModal;

});
parcelRegister("3kdNe", function(module, exports) {

$parcel$export(module.exports, "default", () => $26bdf05b539ef845$export$2e2bcd8739ae039);
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");

var $c6kEN = parcelRequire("c6kEN");

var $2LQsG = parcelRequire("2LQsG");
const $26bdf05b539ef845$var$mapDispatchToProps = (dispatch)=>{
    return {
        onAnalyticsModalOpen: (source)=>dispatch((0, $c6kEN.onModalOpened)(source)),
        onAnalyticsModalClose: (source)=>dispatch((0, $c6kEN.onModalClosed)(source))
    };
};
var $26bdf05b539ef845$export$2e2bcd8739ae039 = (0, $94zHK.default)(null, $26bdf05b539ef845$var$mapDispatchToProps)((0, $2LQsG.default));

});
parcelRegister("2LQsG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2048aa562a1eddda$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $l9NvU = parcelRequire("l9NvU");
var $5o6SH = parcelRequire("5o6SH");
var $jSigD = parcelRequire("jSigD");
var $492R6 = parcelRequire("492R6");
var $gxv5e = parcelRequire("gxv5e");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $2048aa562a1eddda$var$_excluded = [
    "analyticsName",
    "onAnalyticsModalOpen",
    "onAnalyticsModalClose",
    "children",
    "heading",
    "header",
    "footer",
    "customFooter"
];
function $2048aa562a1eddda$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $2048aa562a1eddda$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $2048aa562a1eddda$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $2048aa562a1eddda$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
class $2048aa562a1eddda$export$2e2bcd8739ae039 extends $eUqFw.Component {
    componentDidMount() {
        this.props.onAnalyticsModalOpen(this.props.analyticsName);
    }
    componentDidUpdate(prevProps) {
        if (prevProps.analyticsName !== this.props.analyticsName) {
            this.props.onAnalyticsModalClose(prevProps.analyticsName);
            this.props.onAnalyticsModalOpen(this.props.analyticsName);
        }
    }
    componentWillUnmount() {
        this.props.onAnalyticsModalClose(this.props.analyticsName);
    }
    render() {
        const _this$props = this.props, { analyticsName: analyticsName, onAnalyticsModalOpen: onAnalyticsModalOpen, onAnalyticsModalClose: onAnalyticsModalClose, children: children, heading: heading, header: header, footer: footer, customFooter: customFooter } = _this$props, modalProps = (0, $bwPfh.default)(_this$props, $2048aa562a1eddda$var$_excluded);
        return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $l9NvU.default), $2048aa562a1eddda$var$_objectSpread($2048aa562a1eddda$var$_objectSpread({}, modalProps), {}, {
            children: [
                heading && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $492R6.default), {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gxv5e.default), {
                        children: heading
                    })
                }),
                header && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $492R6.default), {
                    children: header
                }),
                children && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5o6SH.default), {
                    children: children
                }),
                footer && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jSigD.default), {
                    children: footer
                }),
                customFooter && customFooter
            ]
        }));
    }
}

});





parcelRegister("lpVYJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f978e8175d954b24$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $ZN2Lb = parcelRequire("ZN2Lb");
var $gTOQV = parcelRequire("gTOQV");
var $71CV8 = parcelRequire("71CV8");

var $gXXkA = parcelRequire("gXXkA");

var $9l6Pq = parcelRequire("9l6Pq");

var $cCrLo = parcelRequire("cCrLo");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
const $f978e8175d954b24$var$_excluded = [
    "triggerRef"
];
function $f978e8175d954b24$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f978e8175d954b24$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f978e8175d954b24$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f978e8175d954b24$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $f978e8175d954b24$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f978e8175d954b24$export$1ff8b6bdb11c2a95 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $9oiuL.default), {
    target: "e8xveme0",
    label: "MoreIconContainer"
})({
    name: "o5uqvq",
    styles: "margin-left:5px;"
});
const $f978e8175d954b24$var$getInstalledActions = (installedApp)=>{
    const installedActions = [];
    // Should follow following order to prioritise primary installed action
    if (installedApp.getStartedUrl) installedActions.push({
        label: 'Get Started',
        url: installedApp.getStartedUrl
    });
    if (installedApp.configureUrl) installedActions.push({
        label: 'Configure',
        url: installedApp.configureUrl
    });
    if (installedApp.manageAppUrl) installedActions.push({
        label: 'Manage app',
        url: installedApp.manageAppUrl
    });
    return installedActions;
};
const $f978e8175d954b24$export$63f714caa0e25866 = (props)=>{
    const { enableAetherAppListingPage: enableAetherAppListingPage } = (0, $9l6Pq.useStatsig)();
    const showAetherAppListingPage = enableAetherAppListingPage();
    return props.installedActions.length > 0 && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ZN2Lb.default), {
        placement: "bottom-end",
        isOpen: props.isMeatBallDropdownMenuOpen,
        onOpenChange: props.onChange,
        trigger: (_ref)=>{
            let { triggerRef: triggerRef } = _ref, triggerProps = (0, $bwPfh.default)(_ref, $f978e8175d954b24$var$_excluded);
            return /*#__PURE__*/ (0, $lHkHI.jsx)($f978e8175d954b24$export$1ff8b6bdb11c2a95, $f978e8175d954b24$var$_objectSpread($f978e8175d954b24$var$_objectSpread({
                ref: triggerRef
            }, triggerProps), {}, {
                isSelected: props.isMeatBallDropdownMenuOpen,
                iconAfter: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gXXkA))), {
                    primaryColor: "var(--ds-icon)",
                    label: "More Icon"
                })
            }));
        },
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $71CV8.default), {
            children: props.installedActions.map((installedAction)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $gTOQV.default), {
                    href: installedAction.url,
                    target: "_top",
                    children: showAetherAppListingPage ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cCrLo.BodySmall), {
                        children: installedAction.label
                    }) : installedAction.label
                }, installedAction.url))
        })
    });
};
class $f978e8175d954b24$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            isMeatBallDropdownMenuOpen: false
        });
        (0, $5zQU9.default)(this, "onChange", ()=>{
            this.setState((_ref2)=>{
                let { isMeatBallDropdownMenuOpen: isMeatBallDropdownMenuOpen } = _ref2;
                return {
                    isMeatBallDropdownMenuOpen: !isMeatBallDropdownMenuOpen
                };
            });
        });
        (0, $5zQU9.default)(this, "render", ()=>{
            const installedActions = $f978e8175d954b24$var$getInstalledActions(this.props.installedApp);
            return installedActions.length > 0 && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                        href: installedActions[0].url,
                        target: "_top",
                        children: installedActions[0].label
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($f978e8175d954b24$export$63f714caa0e25866, {
                        installedActions: installedActions.slice(1),
                        onChange: this.onChange,
                        isMeatBallDropdownMenuOpen: this.state.isMeatBallDropdownMenuOpen
                    })
                ]
            });
        });
    }
}

});


parcelRegister("aV0yp", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f2fa843d6e36043$export$2e2bcd8739ae039);

var $aPDTM = parcelRequire("aPDTM");
parcelRequire("eUqFw");

var $bPtM5 = parcelRequire("bPtM5");

var $jwE5W = parcelRequire("jwE5W");

var $9uUsh = parcelRequire("9uUsh");

var $lHkHI = parcelRequire("lHkHI");
const $7f2fa843d6e36043$var$NotFound = (props)=>{
    const { discoverHome: discoverHome } = (0, $jwE5W.default)();
    const homeLink = discoverHome.getRelative();
    const hideGoBackLink = !!(0, $bPtM5.isEmceeConnect)();
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aPDTM.default), {
        homeLink: homeLink,
        heading: "Looks like you took a wrong turn",
        image: (0, (/*@__PURE__*/$parcel$interopDefault($9uUsh))),
        primaryMessage: "This page does not exist",
        statusCode: 404,
        history: props.history,
        hideGoBackLink: hideGoBackLink
    });
};
var $7f2fa843d6e36043$export$2e2bcd8739ae039 = $7f2fa843d6e36043$var$NotFound;

});
parcelRegister("aPDTM", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e2d9dd8a05cb416$export$2e2bcd8739ae039);

var $62cXe = parcelRequire("62cXe");

var $2mgTj = parcelRequire("2mgTj");
var $gykb8 = parcelRequire("gykb8");

var $9rIMC = parcelRequire("9rIMC");

var $eUqFw = parcelRequire("eUqFw");

var $3dvqV = parcelRequire("3dvqV");

var $769iy = parcelRequire("769iy");

var $lHkHI = parcelRequire("lHkHI");
function $7e2d9dd8a05cb416$export$2e2bcd8739ae039(props) {
    const onClickBack = (event)=>{
        event.preventDefault();
        if (props.history) props.history.goBack();
        else window.history.back();
    };
    const onSearchForApps = (event)=>{
        if (props.history) (0, $9rIMC).maybeOpenInNewTab(event, ()=>{
            var _props$history;
            (_props$history = props.history) === null || _props$history === void 0 || _props$history.push({
                pathname: props.homeLink
            });
        });
    };
    const getErrorCodeText = ()=>{
        const { statusCode: statusCode } = props;
        if (statusCode === 404) return 'if you think this page should be here';
        return "if this problem doesn't resolve itself";
    };
    const renderNotFound = (sc)=>{
        const errorCodeText = getErrorCodeText();
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $769iy.ErrorView), {
            padding: (0, $2mgTj).triFoldScreenClass(sc)('50px 25px', '80px 40px', '100px 50px'),
            children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $769iy.ErrorViewInner), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $769iy.ErrorViewImage), {
                        src: props.image,
                        alt: "photo depicting an error"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $769iy.Text), {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $769iy.Heading), {
                                mixin: (0, $62cXe).h800,
                                children: props.heading
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $769iy.MoreInfo), {
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
                                        children: [
                                            props.primaryMessage,
                                            ". You can",
                                            ' ',
                                            !props.hideGoBackLink ? /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $769iy.GoBackLink), {
                                                        onClick: onClickBack,
                                                        children: "go back"
                                                    }),
                                                    ",",
                                                    ' '
                                                ]
                                            }) : null
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                                        href: props.homeLink,
                                        onClick: onSearchForApps,
                                        "data-testid": "search-for-apps",
                                        children: "search for apps"
                                    }),
                                    ",",
                                    /*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
                                        children: [
                                            " or ",
                                            errorCodeText,
                                            ", feel free to "
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                                        href: "http://go.atlassian.com/marketplace-support",
                                        rel: "noopener noreferrer",
                                        target: "_blank",
                                        children: "contact our support team"
                                    }),
                                    "."
                                ]
                            })
                        ]
                    })
                ]
            })
        });
    };
    (0, $eUqFw.useEffect)(()=>{
        // SEO4Ajax sets onCaptureReady on window - when SEO4Ajax is rendering this error page, we can execute it
        // with a status code so that we can override the standard 200 with a more appropriate status code for it to cache
        // (or not cache, if a 5xx) and later return to bots
        if (window.onCaptureReady) window.onCaptureReady(props.statusCode);
    }, []);
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3dvqV.ScreenClassRender), {
        render: renderNotFound,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)("span", {})
    });
}

});
parcelRegister("769iy", function(module, exports) {

$parcel$export(module.exports, "ErrorView", () => $52b04e5d17740370$export$8c68b6013ae44ca6);
$parcel$export(module.exports, "ErrorViewInner", () => $52b04e5d17740370$export$ebb2cb6de4a13a5f);
$parcel$export(module.exports, "ErrorViewImage", () => $52b04e5d17740370$export$ee242488893edc6d);
$parcel$export(module.exports, "Text", () => $52b04e5d17740370$export$5f1af8db9871e1d6);
$parcel$export(module.exports, "Heading", () => $52b04e5d17740370$export$a8a3e93435678ff9);
$parcel$export(module.exports, "MoreInfo", () => $52b04e5d17740370$export$11b712ecf57ff440);
$parcel$export(module.exports, "GoBackLink", () => $52b04e5d17740370$export$19bacdf5def21da4);

var $3UXZ8 = parcelRequire("3UXZ8");

var $8gcXz = parcelRequire("8gcXz");
var $gykb8 = parcelRequire("gykb8");
function $52b04e5d17740370$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $52b04e5d17740370$export$8c68b6013ae44ca6 = (0, $3UXZ8.default)("div", {
    target: "e1l3ciwt0",
    label: "ErrorView"
})("align-items:center;display:flex;flex-direction:column;height:100%;padding:", (props)=>props.padding, ";");
const $52b04e5d17740370$export$ebb2cb6de4a13a5f = (0, $3UXZ8.default)("div", {
    target: "e1l3ciwt1",
    label: "ErrorViewInner"
})({
    name: "1evkcm",
    styles: "margin:auto;max-width:31.25rem;"
});
const $52b04e5d17740370$export$ee242488893edc6d = (0, $3UXZ8.default)("img", {
    target: "e1l3ciwt2",
    label: "ErrorViewImage"
})({
    name: "1dzzqf7",
    styles: "display:flex;flex-direction:column;margin:auto;width:15.625rem;height:13.125rem;"
});
const $52b04e5d17740370$export$5f1af8db9871e1d6 = (0, $3UXZ8.default)("div", {
    target: "e1l3ciwt3",
    label: "Text"
})({
    name: "3vt49z",
    styles: "margin-top:var(--ds-space-500, 40px);text-align:center;"
});
const $52b04e5d17740370$export$a8a3e93435678ff9 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H1), {
    target: "e1l3ciwt4",
    label: "Heading"
})((props)=>props.mixin(), ";");
const $52b04e5d17740370$export$11b712ecf57ff440 = (0, $3UXZ8.default)("div", {
    target: "e1l3ciwt5",
    label: "MoreInfo"
})({
    name: "1wsccn1",
    styles: "line-height:24px;"
});
const $52b04e5d17740370$export$19bacdf5def21da4 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $gykb8.default), {
    target: "e1l3ciwt6",
    label: "GoBackLink"
})({
    name: "4g6ai3",
    styles: "cursor:pointer;"
});

});


parcelRegister("9uUsh", function(module, exports) {
module.exports = new URL("ErrorWindow.150cf151.svg", import.meta.url).toString();

});


parcelRegister("euYek", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8e2967b27ad08ba$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $8VfNq = parcelRequire("8VfNq");

var $l501X = parcelRequire("l501X");
parcelRequire("eUqFw");

var $i7RVQ = parcelRequire("i7RVQ");

var $lHkHI = parcelRequire("lHkHI");
function $a8e2967b27ad08ba$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $a8e2967b27ad08ba$var$ConnectAppContainer = (0, $3UXZ8.default)("div", {
    target: "ezlmlj90",
    label: "ConnectAppContainer"
})({
    name: "1r4e5z9",
    styles: "margin-bottom:var(--ds-space-300, 24px);"
});
const $a8e2967b27ad08ba$var$EcosystemAppContainer = (0, $3UXZ8.default)("div", {
    target: "ezlmlj91",
    label: "EcosystemAppContainer"
})({
    name: "10a5dh0",
    styles: "margin-top:var(--ds-space-negative-300, -24px);margin-bottom:var(--ds-space-200, 16px);"
});
const $a8e2967b27ad08ba$var$LinksContainer = (0, $3UXZ8.default)("div", {
    target: "ezlmlj92",
    label: "LinksContainer"
})({
    name: "1qpaaev",
    styles: "margin-top:var(--ds-space-200, 16px);"
});
const $a8e2967b27ad08ba$var$Dot = (0, $3UXZ8.default)("span", {
    target: "ezlmlj93",
    label: "Dot"
})({
    name: "16qwn2f",
    styles: "margin-left:var(--ds-space-100, 8px);margin-right:var(--ds-space-100, 8px);"
});
const $a8e2967b27ad08ba$export$983cc23b96ea108d = 'https://www.atlassian.com/company/contact/purchasing-licensing#';
const $a8e2967b27ad08ba$export$997e23a0aec74966 = 'https://support.atlassian.com/migration/docs/cloud-migration-trials-for-server-and-data-center-customers/#Activate-Cloud-migration-trials-for-Marketplace-apps';
const $a8e2967b27ad08ba$var$CloudMigrationTrialMessage = (_ref)=>{
    let { isEcosystemCloudApp: isEcosystemCloudApp = false } = _ref;
    // For a forge app, marketplace cannot activate CMT, customer has to reach out to support for activation
    if (isEcosystemCloudApp) return /*#__PURE__*/ (0, $lHkHI.jsx)($a8e2967b27ad08ba$var$EcosystemAppContainer, {
        "data-testid": (0, $i7RVQ.SELECTORS).TEST_ID_CMT_SECTION_MESSAGE,
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $8VfNq.default), {
            children: [
                "This app may be eligible for free Cloud Migration Trial. You can avail of this offer if you have an active Server/Data Center license for this app by reaching out to the support team.",
                /*#__PURE__*/ (0, $lHkHI.jsxs)($a8e2967b27ad08ba$var$LinksContainer, {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                            href: $a8e2967b27ad08ba$export$997e23a0aec74966,
                            children: "Learn more about the offer"
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)($a8e2967b27ad08ba$var$Dot, {
                            children: "\xB7"
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                            href: $a8e2967b27ad08ba$export$983cc23b96ea108d,
                            children: "Contact support"
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)($a8e2967b27ad08ba$var$ConnectAppContainer, {
        "data-testid": (0, $i7RVQ.SELECTORS).TEST_ID_CMT_SECTION_MESSAGE,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8VfNq.default), {
            children: "Experience cloud for this app with a free Cloud Migration Trial available for a limited time."
        })
    });
};
var $a8e2967b27ad08ba$export$2e2bcd8739ae039 = $a8e2967b27ad08ba$var$CloudMigrationTrialMessage;

});

parcelRegister("5C3fV", function(module, exports) {

$parcel$export(module.exports, "useMarketplaceAppDetails", () => $416306e642ddc87c$export$16765c64bf452185);
$parcel$export(module.exports, "useInstallPermission", () => $416306e642ddc87c$export$9d4a50490d2b8ed8);

var $9osuT = parcelRequire("9osuT");

var $9c9Gu = parcelRequire("9c9Gu");
var $bTrQR = parcelRequire("bTrQR");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $j5L3j = parcelRequire("j5L3j");
const { usePromise: $416306e642ddc87c$var$usePromise } = (0, $9c9Gu);
const $416306e642ddc87c$export$16765c64bf452185 = (_ref)=>{
    let { appKey: appKey, fetchInstalledApp: fetchInstalledApp, contextId: contextId, deploymentType: deploymentType, marketplaceApp: marketplaceApp, flags: flags, hostCmtEnabled: hostCmtEnabled } = _ref;
    const appPromiseFn = ()=>(0, $j5L3j.fetchMarketplaceAppData)({
            appKey: appKey,
            fetchInstalledApp: fetchInstalledApp,
            contextId: contextId,
            deploymentType: deploymentType,
            marketplaceApp: marketplaceApp,
            flags: flags,
            hostCmtEnabled: hostCmtEnabled
        });
    const { result: result, error: error, pending: pending } = $416306e642ddc87c$var$usePromise(appPromiseFn, [
        appKey,
        contextId,
        deploymentType,
        marketplaceApp
    ], !!deploymentType);
    (0, $eUqFw.useEffect)(()=>{
        if (error) (0, $bTrQR.default).error('DiscoverAppDetails', "failed to retrieve app listing details", {
            extraInfo: {
                appKey: appKey
            },
            error: error
        });
    }, [
        error
    ]);
    return {
        result: result,
        error: error,
        pending: pending
    };
};
const $416306e642ddc87c$export$9d4a50490d2b8ed8 = (_ref2)=>{
    let { appKey: appKey, isPermissionCheckNeeded: isPermissionCheckNeeded, installPermissionResult: installPermissionResult } = _ref2;
    const installPermission = installPermissionResult ? installPermissionResult.fold(()=>false, (permissionCheck)=>permissionCheck.allowed) : false;
    const hasInstallPermission = !isPermissionCheckNeeded || installPermission;
    const permissionMessage = installPermissionResult === null || installPermissionResult === void 0 ? void 0 : installPermissionResult.fold((error)=>error, (permissionCheck)=>permissionCheck.message || null);
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    (0, $eUqFw.useEffect)(()=>{
        if (!permissionMessage) return;
        (0, $bTrQR.default).error('DiscoverAppDetails', "install permission returned error: ".concat(permissionMessage), {
            tags: {
                errorType: 'installPermissionError'
            },
            extraInfo: {
                appKey: appKey
            }
        });
        fireAnalyticsEvent({
            eventType: (0, $7Uh51.AppInstallPermissionEvaluationFailed),
            actionSubjectId: appKey,
            attributes: {
                error: permissionMessage
            }
        });
    }, [
        permissionMessage
    ]);
    return hasInstallPermission;
};

});



parcelRegister("dGXGE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f7d7f359126ae82$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j8E8v = parcelRequire("j8E8v");

var $8SD4O = parcelRequire("8SD4O");
var $lwEMm = parcelRequire("lwEMm");
var $b5Eig = parcelRequire("b5Eig");

var $9osuT = parcelRequire("9osuT");

var $fUOHe = parcelRequire("fUOHe");

var $c9Mth = parcelRequire("c9Mth");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $3dvqV = parcelRequire("3dvqV");

var $bSQ4o = parcelRequire("bSQ4o");

var $3lzNh = parcelRequire("3lzNh");

var $1dP61 = parcelRequire("1dP61");

var $i0SXo = parcelRequire("i0SXo");

var $15DZ6 = parcelRequire("15DZ6");

var $jHg79 = parcelRequire("jHg79");

var $jwE5W = parcelRequire("jwE5W");

var $eSXUA = parcelRequire("eSXUA");

var $lSDU4 = parcelRequire("lSDU4");

var $lHkHI = parcelRequire("lHkHI");
function $9f7d7f359126ae82$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $9f7d7f359126ae82$var$AddonDiscoveryContainer = (0, $3UXZ8.default)("div", {
    target: "enu5tae0",
    label: "AddonDiscoveryContainer"
})({
    name: "1a0fdmf",
    styles: "margin-left:-10px;"
});
const $9f7d7f359126ae82$var$baseHiddenFilters = (0, $g5DHJ.Map)({
    hosting: true,
    product: true
});
const $9f7d7f359126ae82$var$baseFilters = (0, $g5DHJ.Map)({
    hosting: 'cloud'
});
class $9f7d7f359126ae82$export$ee473020d6e3066a extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            searchTransitionStarted: null
        });
        (0, $5zQU9.default)(this, "transitionStarted", ()=>{
            this.setState({
                searchTransitionStarted: Date.now()
            });
        });
        (0, $5zQU9.default)(this, "transitionCompleted", ()=>{
            const end = Date.now();
            this.props.onRendered();
            if (this.state.searchTransitionStarted != null) {
                const searchTransitionStarted = this.state.searchTransitionStarted;
                this.setState({
                    searchTransitionStarted: null
                });
                const duration = end - searchTransitionStarted;
                (0, $fUOHe.default).fireSearchTiming(duration);
            }
        });
        (0, $5zQU9.default)(this, "filtersContext", (0, $g5DHJ.Map)());
        (0, $5zQU9.default)(this, "getHitContextObject", (hitGroup)=>({
                hitImageHrefResolver: (_ref)=>{
                    let { hit: hit } = _ref;
                    const imageId = hit.getIn([
                        'logo',
                        'highRes'
                    ]) || hit.getIn([
                        'logo',
                        'image'
                    ]);
                    return this.props.links.mediaFile.expand({
                        imageId: imageId
                    });
                },
                hitHrefResolver: (_ref2)=>{
                    let { hit: hit } = _ref2;
                    return this.props.emceeLinks.appListing.getAbsolute({
                        appKey: hit.get('addonKey')
                    });
                },
                onHitClick: (_ref3)=>{
                    let { hit: hit } = _ref3;
                    return this.props.history.push({
                        pathname: this.props.emceeLinks.appListing.getRelative({
                            appKey: hit.get('addonKey')
                        })
                    });
                },
                hitGroup: hitGroup
            }));
        (0, $5zQU9.default)(this, "hitContext", (0, $g5DHJ.Map)(this.getHitContextObject(this.props.perspectiveKey)));
        (0, $5zQU9.default)(this, "overrideLargeHitRightContent", ()=>{
            const installedAppsMap = (0, $i0SXo.default)(this.props.locallyInstalledApps, this.props.globallyInstalledApps);
            // eslint-disable-next-line react/display-name
            return (addonKey)=>installedAppsMap.has(addonKey) ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j8E8v.default), {
                    isBold: true,
                    children: "Added"
                }) : undefined;
        });
        (0, $5zQU9.default)(this, "applyOverrides", new (0, $b5Eig.default)({
            types: (0, $g5DHJ.Set)([
                (0, $lwEMm.default).disjunctive('hidden')
            ]),
            apply: (params)=>params.addDisjunctiveFacetRefinement('hidden', 'hiddenInSite')
        }));
        (0, $5zQU9.default)(this, "resolveFeaturedContentOverride", ()=>this.props.hostConfig.addonDiscovery.featuredContentOverride.map((fco)=>fco({
                    openAppSpecificPasswordDialog: ()=>{
                        this.props.openAppSpecificPasswordDialog({
                            name: null
                        });
                    }
                })).orUndefined());
        (0, $5zQU9.default)(this, "updateFilters", (newFilters)=>{
            const searchQuery = (0, $c9Mth).resolveSearchFromImmutableQuery(this.omitHiddenFilters(newFilters));
            this.props.history.push({
                pathname: searchQuery ? this.props.emceeLinks.search.getRelative() : this.props.emceeLinks.discoverHome.getRelative(),
                search: searchQuery
            });
        });
        (0, $5zQU9.default)(this, "omitHiddenFilters", (query)=>this.resolveHiddenFilters().reduce((newQuery, hf, hiddenFilterKey)=>(0, $bWAru.Option).of(query.get(hiddenFilterKey)).map((queryValue)=>(0, $1dP61.foldHiddenFiltersValue)(hf)((booleanHiddenFiltersValue)=>booleanHiddenFiltersValue ? newQuery.delete(hiddenFilterKey) : newQuery, (setHiddenFiltersValue)=>(0, $c9Mth).foldImmutableQueryValue(queryValue)((stringQueryValue)=>setHiddenFiltersValue.includes(stringQueryValue) ? newQuery.delete(hiddenFilterKey) : newQuery, (setQueryValue)=>(0, $bWAru.Option).some(setQueryValue.subtract(setHiddenFiltersValue)).filter((nfv)=>nfv.size !== 0).flatMap((nfv)=>nfv.size === 1 ? (0, $bWAru.Option).of(nfv.first()) : (0, $bWAru.Option).some(nfv)).map((nfv)=>newQuery.set(hiddenFilterKey, nfv)).getOrElse(newQuery.delete(hiddenFilterKey))))).getOrElse(newQuery), query));
        (0, $5zQU9.default)(this, "resolveFiltersFromLocation", ()=>this.omitHiddenFilters((0, $c9Mth).resolveImmutableQuery(this.props.location.search)));
        (0, $5zQU9.default)(this, "resolveHiddenFilters", ()=>$9f7d7f359126ae82$var$baseHiddenFilters.mergeDeep(this.props.hostConfig.addonDiscovery.hiddenFilters));
        (0, $5zQU9.default)(this, "getCloudId", ()=>(0, $bSQ4o.getCloudIdFromHostInfo)(this.props.hostInfo) || '');
        (0, $5zQU9.default)(this, "getRecommendationsPanel", (sc)=>{
            const cloudId = this.getCloudId();
            if (this.props.location.pathname === this.props.emceeLinks.discoverHome.getRelative() && cloudId) {
                var _this$props$hostInfo;
                return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eSXUA.default), {
                    product: ((_this$props$hostInfo = this.props.hostInfo) === null || _this$props$hostInfo === void 0 ? void 0 : _this$props$hostInfo.product) || '',
                    algoliaClient: this.props.algoliaClient,
                    debug: false,
                    environment: this.props.bootstrapConfig.algolia.environment,
                    screenClass: sc === 'xl' || sc === 'lg' ? 'md' : sc,
                    getHitContext: this.getHitContextObject,
                    cloudId: cloudId
                });
            }
            return null;
        });
        (0, $5zQU9.default)(this, "renderInner", (sc)=>/*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lSDU4.default), {
                        history: this.props.history,
                        hostConfig: this.props.hostConfig
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($9f7d7f359126ae82$var$AddonDiscoveryContainer, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8SD4O.default), {
                            product: this.props.hostConfig.name,
                            algoliaClient: this.props.algoliaClient,
                            applyOverrides: this.applyOverrides,
                            featuredContentOverride: this.resolveFeaturedContentOverride(),
                            debug: false,
                            environment: this.props.bootstrapConfig.algolia.environment,
                            filters: this.resolveFiltersFromLocation().mergeDeep($9f7d7f359126ae82$var$baseFilters.set('product', this.props.hostConfig.addonDiscovery.productKey)),
                            filtersContext: this.filtersContext,
                            hideHeading: true,
                            hiddenFilters: this.resolveHiddenFilters(),
                            hitContext: this.hitContext,
                            perspective: this.props.perspectiveKey,
                            stateChangeRequested: this.stateChangeRequested,
                            screenClass: sc === 'xl' || sc === 'lg' ? 'md' : sc,
                            transitions: (0, $g5DHJ.fromJS)({
                                transitionStarted: this.transitionStarted,
                                transitionCompleted: this.transitionCompleted
                            }),
                            recommendationsPanel: this.getRecommendationsPanel(sc),
                            overrideLargeHitRightContent: this.overrideLargeHitRightContent(),
                            showBrowseHeading: this.props.location.pathname === this.props.emceeLinks.discoverHome.getRelative()
                        })
                    })
                ]
            }));
        (0, $5zQU9.default)(this, "stateChangeRequested", (_ref4)=>{
            let { filters: filters } = _ref4;
            this.updateFilters(filters || this.resolveFiltersFromLocation());
        });
    }
    componentDidMount() {
        var _resolveCurrentRoute;
        const currentRoute = (0, $c9Mth).joinPathNames([
            this.props.mountPath,
            ((_resolveCurrentRoute = (0, $15DZ6.resolveCurrentRoute)(this.props.location.pathname, this.props.mountPath)) === null || _resolveCurrentRoute === void 0 ? void 0 : _resolveCurrentRoute.path) || ''
        ]);
        if (currentRoute === this.props.emceeLinks.discoverHome.getRelative()) (0, $3lzNh.HomePageTask).start();
        else if (currentRoute === this.props.emceeLinks.search.getRelative()) (0, $3lzNh.SearchPageTask).start();
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3dvqV.ScreenClassRender), {
            render: this.renderInner,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)("span", {})
        });
    }
}
const $9f7d7f359126ae82$var$DiscoverInnerWithEmceeLinks = (0, $jwE5W.withEmceeLinks)($9f7d7f359126ae82$export$ee473020d6e3066a);
const $9f7d7f359126ae82$var$DiscoverInnerWithAppContext = (0, $jHg79.withMountPath)($9f7d7f359126ae82$var$DiscoverInnerWithEmceeLinks);
var $9f7d7f359126ae82$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($9f7d7f359126ae82$var$DiscoverInnerWithAppContext);

});
parcelRegister("1dP61", function(module, exports) {

$parcel$export(module.exports, "foldHiddenFiltersValue", () => $0e3ea3f31aa348a3$export$badebe6c2c8c0f29);

var $g5DHJ = parcelRequire("g5DHJ");
function $0e3ea3f31aa348a3$export$badebe6c2c8c0f29(hfv) {
    return function(boolean, set) {
        if (typeof hfv === 'boolean') return boolean(hfv);
        else if ((0, $g5DHJ.Set).isSet(hfv)) return set(hfv);
        else throw new TypeError("foldHiddenFiltersValue is not comprehensive in HiddenFiltersValue: ".concat(JSON.stringify(hfv)));
    };
}

});

parcelRegister("eSXUA", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad6495091c67ce4d$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $1zZny = parcelRequire("1zZny");
var $62VCw = parcelRequire("62VCw");
parcelRequire("eUqFw");

var $hHeeE = parcelRequire("hHeeE");

var $lHkHI = parcelRequire("lHkHI");
function $ad6495091c67ce4d$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ad6495091c67ce4d$var$RecommendationsPanelContainer = (0, $3UXZ8.default)("div", {
    target: "ej09nly0",
    label: "RecommendationsPanelContainer"
})({
    name: "mgww5h",
    styles: "margin:0 0 10px;"
});
const $ad6495091c67ce4d$var$RecommendationsPanel = (props)=>{
    var _fetchRecommendedApps;
    const { algoliaClient: algoliaClient, environment: environment, cloudId: cloudId, getHitContext: getHitContext, product: product = '', containerClassName: containerClassName, screenClass: screenClass } = props;
    const { fetchRecommendedAppsPending: fetchRecommendedAppsPending, fetchRecommendedAppsError: fetchRecommendedAppsError, fetchRecommendedAppsResult: fetchRecommendedAppsResult } = (0, $hHeeE.useRecommendations)(algoliaClient, environment, cloudId, product);
    const show = !fetchRecommendedAppsPending && !fetchRecommendedAppsError;
    const hitContext = getHitContext((_fetchRecommendedApps = fetchRecommendedAppsResult === null || fetchRecommendedAppsResult === void 0 ? void 0 : fetchRecommendedAppsResult.hitsType) !== null && _fetchRecommendedApps !== void 0 ? _fetchRecommendedApps : (0, $1zZny.HitsType).recommendedApps);
    return show ? /*#__PURE__*/ (0, $lHkHI.jsx)($ad6495091c67ce4d$var$RecommendationsPanelContainer, {
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $62VCw.default), {
            loading: fetchRecommendedAppsPending,
            recommendationsResult: fetchRecommendedAppsResult || {},
            hitContext: hitContext,
            product: product.charAt(0).toUpperCase() + product.slice(1),
            containerClassName: containerClassName,
            screenClass: screenClass
        })
    }) : null;
};
$ad6495091c67ce4d$var$RecommendationsPanel.defaultProps = {
    containerClassName: '',
    screenClass: 'md'
};
var $ad6495091c67ce4d$export$2e2bcd8739ae039 = $ad6495091c67ce4d$var$RecommendationsPanel;

});
parcelRegister("hHeeE", function(module, exports) {

$parcel$export(module.exports, "useRecommendations", () => $ce217ead873a1944$export$9e04cd9a8ab60f8e);

var $bavaN = parcelRequire("bavaN");
var $1zZny = parcelRequire("1zZny");
var $8HDz3 = parcelRequire("8HDz3");

var $9c9Gu = parcelRequire("9c9Gu");

var $2bvQn = parcelRequire("2bvQn");

var $kYF1M = parcelRequire("kYF1M");
// types
const $ce217ead873a1944$var$getRecommendedAppKeys = (cloudId, hostProduct)=>{
    return (0, $2bvQn.getAppRecommendations)(cloudId, hostProduct).then((_ref)=>{
        let { appRecommendations: appRecommendations } = _ref;
        return appRecommendations.map((appRecommendation)=>appRecommendation.appKey);
    });
};
async function $ce217ead873a1944$var$getRecommendedAppsDetails(algoliaClient, environment, cloudId, hostProduct) {
    let recommendedAppKeys = await $ce217ead873a1944$var$getRecommendedAppKeys(cloudId, hostProduct);
    let hitsType = (0, $1zZny.HitsType).recommendedApps;
    if (!recommendedAppKeys.length) {
        if (hostProduct === 'jira') recommendedAppKeys = (0, $kYF1M.default).jira.sort(()=>0.5 - Math.random()).slice(0, 3);
        else if (hostProduct === 'confluence') recommendedAppKeys = (0, $kYF1M.default).confluence.sort(()=>0.5 - Math.random()).slice(0, 3);
        hitsType = (0, $1zZny.HitsType).newAndNoteworthyApps;
    }
    return (0, $bavaN.getAppDetailsByAppKeys)(algoliaClient, environment, recommendedAppKeys).then((_ref2)=>{
        let { content: content = {} } = _ref2;
        return {
            hits: (0, $8HDz3.resolveHits)((content.hits || []).sort((a, b)=>recommendedAppKeys.indexOf(a.addonKey) > recommendedAppKeys.indexOf(b.addonKey) ? 1 : -1)),
            numberOfHits: content.nbHits || 0,
            hitsType: hitsType
        };
    });
}
const $ce217ead873a1944$export$9e04cd9a8ab60f8e = (algoliaClient, environment, cloudId, hostProduct)=>{
    const fetchRecommendedAppsPromise = ()=>$ce217ead873a1944$var$getRecommendedAppsDetails(algoliaClient, environment, cloudId, hostProduct);
    const { result: result, error: error, pending: pending } = (0, $9c9Gu).usePromise(fetchRecommendedAppsPromise, [
        cloudId,
        hostProduct
    ]);
    return {
        fetchRecommendedAppsPending: pending,
        fetchRecommendedAppsError: error,
        fetchRecommendedAppsResult: result
    };
};

});
parcelRegister("2bvQn", function(module, exports) {

$parcel$export(module.exports, "getAppRecommendations", () => $19754f6127ba4f32$export$fb45af1210c15045);

var $kt9Cs = parcelRequire("kt9Cs");

var $55gtq = parcelRequire("55gtq");
const $19754f6127ba4f32$var$demandServicePath = '/internal/demand/app-recommendations';
const $19754f6127ba4f32$var$RECOMMENDED_APPS_LIMIT = 3;
function $19754f6127ba4f32$export$fb45af1210c15045(cloudId, product) {
    const recommendationsUrl = "".concat($19754f6127ba4f32$var$demandServicePath, "?").concat((0, (/*@__PURE__*/$parcel$interopDefault($kt9Cs))).stringify({
        cloudId: cloudId,
        product: product,
        limit: $19754f6127ba4f32$var$RECOMMENDED_APPS_LIMIT
    }));
    return (0, $55gtq.default)().fetchOk(recommendationsUrl, {
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json'
        }
    }).catch((error)=>{
        console.error('Failed to fetch app recommendations due to', error);
        return {
            appRecommendations: []
        };
    });
}

});

parcelRegister("kYF1M", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4593c78efd050f5$export$2e2bcd8739ae039);
const $f4593c78efd050f5$var$newAndNoteworthyApps = {
    jira: [
        'com.inooster.synergy',
        'io.revyz.jira-app.br.app',
        'io.curiouslab.jira.shapeupboard',
        'visier-jira-analytics',
        'move-organize',
        'hu.frontside.timesloth',
        'com.kobiktech.jira.zohoconnector',
        'com.fixsian.jira.apps.eltj',
        'phantom.automata.smart.custom.fields',
        'de.clicksports.jira.plugins.lexoffice',
        'com.k10.cvss',
        'com.nesb.jira.plugins.worklogreport',
        'net.interestingprojects.jai',
        'forge.app.rebug',
        'io.gitprotect.jira-v1',
        'InQuestPro-jira-addon',
        'issue-health-monitor-qa-for-jira',
        'de.tenics.jira.plugins.DoD4Jira'
    ],
    confluence: [
        'rewind-backups-confluence',
        'keem.confluence.cloud.googlechat',
        'com.bev.confluence.plugins.lorem'
    ]
};
var $f4593c78efd050f5$export$2e2bcd8739ae039 = $f4593c78efd050f5$var$newAndNoteworthyApps;

});



parcelRegister("lSDU4", function(module, exports) {

$parcel$export(module.exports, "default", () => $fedd9813f64291b6$export$2e2bcd8739ae039);
parcelRequire("eUqFw");

var $fgDSb = parcelRequire("fgDSb");

var $c2OMJ = parcelRequire("c2OMJ");

var $jwE5W = parcelRequire("jwE5W");

var $lHkHI = parcelRequire("lHkHI");
const $fedd9813f64291b6$var$DiscoverHeader = (props)=>{
    const { manageHome: manageHome } = (0, $jwE5W.default)();
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $c2OMJ.NavigationHeaderContainer), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $c2OMJ.NavigationHeaderInnerHeading), {
                children: [
                    "Discover apps and integrations for ",
                    props.hostConfig.name
                ]
            }),
            props.hostConfig.supportsManage ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fgDSb.default), {
                history: props.history,
                href: manageHome.getRelative(),
                label: "Manage apps"
            }) : null
        ]
    });
};
var $fedd9813f64291b6$export$2e2bcd8739ae039 = $fedd9813f64291b6$var$DiscoverHeader;

});
parcelRegister("fgDSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1d7479440994149$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $gykb8 = parcelRequire("gykb8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $lHkHI = parcelRequire("lHkHI");
class $b1d7479440994149$export$5fded1d2a9af62c0 extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "switchView", (e)=>{
            e.preventDefault();
            this.props.fireAnalyticsEvent({
                eventType: (0, $gaiog.ButtonClickedEvent),
                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_NAV_BAR_VIEW_SWITCHER),
                attributes: {
                    label: this.props.label
                }
            });
            this.props.history.push({
                pathname: this.props.href
            });
        });
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                href: this.props.href,
                onClick: this.switchView,
                children: this.props.label
            }));
    }
}
var $b1d7479440994149$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($b1d7479440994149$export$5fded1d2a9af62c0);

});

parcelRegister("c2OMJ", function(module, exports) {

$parcel$export(module.exports, "NavigationHeaderContainer", () => $8c4d10c9668a6f96$export$e25447ea7341f440);
$parcel$export(module.exports, "NavigationHeaderInnerHeading", () => $8c4d10c9668a6f96$export$9c5cc97bccb85d8);

var $3UXZ8 = parcelRequire("3UXZ8");

var $8gcXz = parcelRequire("8gcXz");
function $8c4d10c9668a6f96$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8c4d10c9668a6f96$export$e25447ea7341f440 = (0, $3UXZ8.default)("div", {
    target: "e41xp3y0",
    label: "NavigationHeaderContainer"
})({
    name: "b2qzs2",
    styles: "margin-top:var(--ds-space-100, 8px);margin-bottom:var(--ds-space-200, 16px);padding:var(--ds-space-100, 8px) 0;"
});
const $8c4d10c9668a6f96$export$9c5cc97bccb85d8 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H1), {
    target: "e41xp3y1",
    label: "NavigationHeaderInnerHeading"
})((0, $8gcXz.h2Css), " margin:0;");

});





parcelRegister("iGb88", function(module, exports) {

$parcel$export(module.exports, "EmceeInstallationLock", () => $d994c877c6bac36b$export$bea9693d9e4c0025);
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");

var $6Xsph = parcelRequire("6Xsph");

var $5E4rM = parcelRequire("5E4rM");
const $d994c877c6bac36b$var$mapStateToProps = (state)=>({
        hostInfo: state.configuration.hostInfo,
        hostConfig: state.configuration.hostConfig
    });
const $d994c877c6bac36b$var$mapDispatchToProps = (dispatch, ownProps)=>({
        onInstallSuccess: (_ref)=>{
            let { installedApp: installedApp, enableDeprecatedInstallationsGQL: enableDeprecatedInstallationsGQL } = _ref;
            (0, $6Xsph.updateInstalledAppsPostInstall)(dispatch, ownProps.hostInfo.globalContext, ownProps.hostConfig, enableDeprecatedInstallationsGQL);
            (0, $6Xsph.updateAllRequestStatusesPostInstall)({
                hostInfo: ownProps.hostInfo,
                appKey: installedApp.details.key,
                appName: installedApp.details.name
            });
        }
    });
const $d994c877c6bac36b$export$bea9693d9e4c0025 = (0, $94zHK.default)($d994c877c6bac36b$var$mapStateToProps, $d994c877c6bac36b$var$mapDispatchToProps)((0, $5E4rM.InstallationLockProvider));

});

parcelRegister("8au7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f269ea58a5385ff$export$2e2bcd8739ae039);
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");

var $8bwkw = parcelRequire("8bwkw");

var $jGjaE = parcelRequire("jGjaE");
const $5f269ea58a5385ff$var$mapStateToProps = (state)=>({
        flags: state.flags.flags
    });
const $5f269ea58a5385ff$var$mapDispatchToProps = (dispatch)=>({
        doRemoveFlag: (key)=>dispatch((0, $8bwkw.removeFlag)(key))
    });
var $5f269ea58a5385ff$export$2e2bcd8739ae039 = (0, $94zHK.default)($5f269ea58a5385ff$var$mapStateToProps, $5f269ea58a5385ff$var$mapDispatchToProps)((0, $jGjaE.default));

});
parcelRegister("jGjaE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e540cf782a6a3e0c$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $6UJyW = parcelRequire("6UJyW");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $bPtM5 = parcelRequire("bPtM5");

var $4JqQE = parcelRequire("4JqQE");

var $fHnih = parcelRequire("fHnih");

var $lHkHI = parcelRequire("lHkHI");
class $e540cf782a6a3e0c$var$Flags extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "flagDismissed", (flagId)=>{
            this.props.doRemoveFlag(flagId);
        });
        (0, $5zQU9.default)(this, "onAction", (action, flag)=>{
            this.props.fireAnalyticsEvent({
                eventType: (0, $gaiog.ButtonClickedEvent),
                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_FLAG_ACTION),
                attributes: {
                    flagTitle: flag.title,
                    flagType: flag.appearance,
                    actionKey: action.key
                }
            });
            action.callback();
        });
    }
    shouldComponentUpdate(nextProps) {
        return !this.props.flags.equals(nextProps.flags);
    }
    render() {
        // Temporary workaround for previous atlaskit flags
        // not unmounting when replaced with other flags
        // https://ecosystem.atlassian.net/browse/AK-6218
        if (!this.props.flags.size) return null;
        return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
            children: (0, $bPtM5.isEmceeConnect)() ? this.props.flags.map((flag)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $fHnih.default), {
                    flag: flag,
                    onAction: this.onAction,
                    onDismissed: this.flagDismissed
                }, flag.key)) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6UJyW.default), {
                onDismissed: this.flagDismissed,
                children: this.props.flags.map((flag)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $4JqQE.default), {
                        flag: flag,
                        onAction: this.onAction,
                        onDismissed: this.flagDismissed
                    }, flag.key))
            })
        });
    }
}
var $e540cf782a6a3e0c$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($e540cf782a6a3e0c$var$Flags);

});
parcelRegister("4JqQE", function(module, exports) {

$parcel$export(module.exports, "default", () => $372030e47a03163b$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $b720H = parcelRequire("b720H");
var $gU1bO = parcelRequire("gU1bO");

var $3XolV = parcelRequire("3XolV");

var $gEwvS = parcelRequire("gEwvS");

var $58ZVT = parcelRequire("58ZVT");

var $d8i0J = parcelRequire("d8i0J");

var $j0gMm = parcelRequire("j0gMm");

var $hvzDU = parcelRequire("hvzDU");

var $eUqFw = parcelRequire("eUqFw");

var $jC5dB = parcelRequire("jC5dB");

var $lHkHI = parcelRequire("lHkHI");
function $372030e47a03163b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $372030e47a03163b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $372030e47a03163b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $372030e47a03163b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $372030e47a03163b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $372030e47a03163b$export$cabe3e82f82bbb5c = (0, $3UXZ8.default)("div", {
    target: "e76or9a0",
    label: "SubDescription"
})({
    name: "yz950y",
    styles: "margin-top:10px;opacity:0.6;"
});
const $372030e47a03163b$var$successProps = {
    icon: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($3XolV))), {
        label: "",
        size: "medium",
        primaryColor: (0, $j0gMm.G400)
    }),
    appearance: 'normal'
};
const $372030e47a03163b$var$errorProps = {
    icon: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gEwvS))), {
        label: "",
        size: "medium",
        primaryColor: (0, $j0gMm.R400)
    }),
    appearance: 'normal'
};
const $372030e47a03163b$var$infoProps = {
    icon: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($58ZVT))), {
        size: "medium",
        primaryColor: (0, $j0gMm.P400)
    }),
    appearance: 'normal'
};
const $372030e47a03163b$var$warningProps = {
    icon: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d8i0J))), {
        size: "medium",
        primaryColor: (0, $j0gMm.Y400)
    }),
    appearance: 'normal'
};
class $372030e47a03163b$export$2e2bcd8739ae039 extends $eUqFw.PureComponent {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "flagDismissed", ()=>{
            this.props.onDismissed(this.props.flag.key);
        });
    }
    render() {
        const { icon: icon, appearance: appearance } = (0, $jC5dB.foldAppearance)(this.props.flag.appearance, ()=>$372030e47a03163b$var$successProps, ()=>$372030e47a03163b$var$errorProps, ()=>$372030e47a03163b$var$infoProps, ()=>$372030e47a03163b$var$warningProps);
        const description = this.props.flag.description;
        const desc = description ? /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hvzDU.default), {
                    dangerousHtml: description.primary
                }),
                description.secondary && /*#__PURE__*/ (0, $lHkHI.jsx)($372030e47a03163b$export$cabe3e82f82bbb5c, {
                    children: description.secondary
                }, description.secondary)
            ]
        }) : undefined;
        const FlagComponent = this.props.flag.autoDismiss ? (0, $b720H.default) : (0, $gU1bO.default);
        const actions = this.props.flag.actions.map((a)=>$372030e47a03163b$var$_objectSpread($372030e47a03163b$var$_objectSpread({
                content: a.displayText,
                onClick: ()=>this.props.onAction(a, this.props.flag)
            }, a.href && {
                href: a.href
            }), a.target && {
                target: a.target
            }));
        return /*#__PURE__*/ (0, $lHkHI.jsx)(FlagComponent, {
            actions: actions.toArray(),
            appearance: appearance,
            description: desc,
            icon: icon,
            id: this.props.flag.key,
            isDismissAllowed: true,
            onDismissed: this.flagDismissed,
            title: this.props.flag.title
        }, this.props.flag.key);
    }
}

});

parcelRegister("fHnih", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6dcf0d2a37b6b9d$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $59eie = parcelRequire("59eie");
class $b6dcf0d2a37b6b9d$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "processAction", (event)=>{
            (0, $bWAru.Option).of(this.props.flag.actions.find((action)=>action.id === event.actionIdentifier)).forEach((action)=>this.props.onAction(action, this.props.flag));
        });
        (0, $5zQU9.default)(this, "processClose", (event)=>{
            if (this.state.apFlag && this.state.apFlag._id === event.flagIdentifier) {
                this.setState({
                    apFlag: null
                });
                this.props.onDismissed(this.props.flag.key);
            }
        });
    }
    componentDidMount() {
        this.setState({
            apFlag: (0, $59eie.default).createFlag(this.props.flag)
        });
        (0, $59eie.default).addFlagEventListeners(this.processAction, this.processClose);
    }
    componentWillUnmount() {
        if (this.state.apFlag) this.state.apFlag.close();
        (0, $59eie.default).removeFlagEventListeners(this.processAction, this.processClose);
    }
    render() {
        return null;
    }
}

});
parcelRegister("59eie", function(module, exports) {

$parcel$export(module.exports, "default", () => $3bf8e1566d068b5b$export$2e2bcd8739ae039);
/* global AP */ parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $jC5dB = parcelRequire("jC5dB");
var $3bf8e1566d068b5b$export$2e2bcd8739ae039 = {
    addFlagEventListeners: (onAction, onClose)=>(0, $bWAru.Option).of(AP.events).forEach((e)=>{
            e.on('flag.action', onAction);
            e.on('flag.close', onClose);
        }),
    createFlag: (flag)=>{
        var _AP$flag, _flag$description$pri, _flag$description, _flag$description$sec, _flag$description2;
        return (_AP$flag = AP.flag) === null || _AP$flag === void 0 ? void 0 : _AP$flag.create({
            actions: flag.actions.reduce((acc, a)=>acc.set(a.id, a.displayText), (0, $g5DHJ.Map)()).toObject(),
            body: "".concat((_flag$description$pri = (_flag$description = flag.description) === null || _flag$description === void 0 ? void 0 : _flag$description.primary) !== null && _flag$description$pri !== void 0 ? _flag$description$pri : '').concat((_flag$description$sec = (_flag$description2 = flag.description) === null || _flag$description2 === void 0 ? void 0 : _flag$description2.secondary) !== null && _flag$description$sec !== void 0 ? _flag$description$sec : ''),
            close: flag.autoDismiss ? 'auto' : 'manual',
            title: flag.title,
            type: (0, $jC5dB.foldAppearance)(flag.appearance, ()=>'success', ()=>'error', ()=>'info', ()=>'info')
        });
    },
    removeFlagEventListeners: (onAction, onClose)=>(0, $bWAru.Option).of(AP.events).forEach((e)=>{
            e.off('flag.action', onAction);
            e.off('flag.close', onClose);
        })
};

});




parcelRegister("be8uv", function(module, exports) {

$parcel$export(module.exports, "default", () => $82c796a6ff291e2d$export$2e2bcd8739ae039);
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");

var $c8I9K = parcelRequire("c8I9K");

var $dSumc = parcelRequire("dSumc");

var $i0k4A = parcelRequire("i0k4A");

var $7jp5q = parcelRequire("7jp5q");

var $5Wf8D = parcelRequire("5Wf8D");

var $fdxoX = parcelRequire("fdxoX");
const $82c796a6ff291e2d$var$mapStateToProps = (state)=>({
        hostPricing: state.hostPricing.hostPricing,
        installMode: state.installation.installMode,
        scopesLookup: state.scopes.scopesLookup
    });
const $82c796a6ff291e2d$var$mapDispatchToProps = (dispatch, ownProps)=>({
        clearInstallableAppByManualUrl: ()=>dispatch((0, $7jp5q.clearInstallableAppByManualUrl)()),
        closeInstallDialog: ()=>dispatch((0, $dSumc.clearInstallMode)()),
        fetchInstallableAppByManualUrl: (_ref)=>{
            let { context: context, installableAppByUrlId: installableAppByUrlId } = _ref;
            return dispatch((0, $7jp5q.doFetchInstallableAppByManualUrl)({
                context: context,
                installableAppByUrlId: installableAppByUrlId,
                mpacBaseUrl: ownProps.bootstrapConfig.mpacBaseUrl
            }));
        },
        generateAppSpecificPassword: (_ref2)=>{
            let { name: name, context: context, hostConfig: hostConfig } = _ref2;
            return dispatch((0, $i0k4A.doGenerateAppSpecificPassword)({
                name: name,
                context: context,
                hostConfig: hostConfig
            }));
        },
        installApp: (_ref3, featureFlags, locale)=>{
            let { context: context, hostConfig: hostConfig, hostInfo: hostInfo, installableApp: installableApp, installableAppId: installableAppId, relayState: relayState } = _ref3;
            return dispatch((0, $c8I9K.doInstallApp)({
                context: context,
                hostConfig: hostConfig,
                hostInfo: hostInfo,
                mpacBaseUrl: ownProps.bootstrapConfig.mpacBaseUrl,
                installableApp: installableApp,
                installableAppId: installableAppId,
                relayState: relayState,
                featureFlags: featureFlags,
                locale: locale
            }));
        },
        openManualUrlInstallDialog: ()=>dispatch((0, $7jp5q.doStartInstallableAppByManualUrlInstallMode)()),
        openAppSpecificPasswordDialog: (_ref4)=>{
            let { name: name } = _ref4;
            return dispatch((0, $i0k4A.doStartAppSpecificPasswordInstallMode)({
                name: name
            }));
        },
        setAppSpecificPasswordName: (_ref5)=>{
            let { name: name } = _ref5;
            return dispatch((0, $i0k4A.setAppSpecificPasswordName)({
                name: name
            }));
        },
        upgradeApp: (_ref6)=>{
            let { context: context, hostConfig: hostConfig, installedApp: installedApp, installableAppByKeyId: installableAppByKeyId, installableAppToUpgradeTo: installableAppToUpgradeTo } = _ref6;
            return dispatch((0, $5Wf8D.doUpgradeApp)({
                context: context,
                hostConfig: hostConfig,
                installedApp: installedApp,
                installableAppByKeyId: installableAppByKeyId,
                installableAppToUpgradeTo: installableAppToUpgradeTo
            }));
        }
    });
var $82c796a6ff291e2d$export$2e2bcd8739ae039 = (0, $94zHK.default)($82c796a6ff291e2d$var$mapStateToProps, $82c796a6ff291e2d$var$mapDispatchToProps)((0, $fdxoX.default));

});
parcelRegister("c8I9K", function(module, exports) {

$parcel$export(module.exports, "START_INSTALL_APP", () => $8d687be8d53d51e7$export$1208477c88486c9e);
$parcel$export(module.exports, "FINISH_INSTALL_APP", () => $8d687be8d53d51e7$export$c6fd92aac15dfad3);
$parcel$export(module.exports, "INSTALL_APP_ERROR", () => $8d687be8d53d51e7$export$c491e6af05dcd5ec);
$parcel$export(module.exports, "doInstallApp", () => $8d687be8d53d51e7$export$a23e0fb000ae422a);
/* eslint-disable max-lines-per-function */ 
var $bTrQR = parcelRequire("bTrQR");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $jC5dB = parcelRequire("jC5dB");

var $ifMZN = parcelRequire("ifMZN");

var $55gtq = parcelRequire("55gtq");

var $3lzNh = parcelRequire("3lzNh");

var $9IC13 = parcelRequire("9IC13");

var $bPtM5 = parcelRequire("bPtM5");

var $8bwkw = parcelRequire("8bwkw");

var $dSumc = parcelRequire("dSumc");

var $6Xsph = parcelRequire("6Xsph");
const $8d687be8d53d51e7$export$1208477c88486c9e = 'INSTALLATION_START_INSTALL_APP';
const $8d687be8d53d51e7$export$c6fd92aac15dfad3 = 'INSTALLATION_FINISH_INSTALL_APP';
const $8d687be8d53d51e7$export$c491e6af05dcd5ec = 'INSTALLATION_INSTALL_APP_ERROR';
const $8d687be8d53d51e7$var$startInstallApp = (_ref)=>{
    let { installableAppId: installableAppId } = _ref;
    return {
        type: $8d687be8d53d51e7$export$1208477c88486c9e,
        installableAppId: installableAppId
    };
};
const $8d687be8d53d51e7$var$finishInstallApp = (_ref2)=>{
    let { context: context, installableAppId: installableAppId, suppressResultFlag: suppressResultFlag, featureFlags: featureFlags, appDetails: appDetails } = _ref2;
    return {
        type: $8d687be8d53d51e7$export$c6fd92aac15dfad3,
        context: context,
        installableAppId: installableAppId,
        suppressResultFlag: suppressResultFlag,
        featureFlags: featureFlags,
        appDetails: appDetails
    };
};
const $8d687be8d53d51e7$var$installAppError = (_ref3)=>{
    let { context: context, error: error, installableAppId: installableAppId } = _ref3;
    return {
        type: $8d687be8d53d51e7$export$c491e6af05dcd5ec,
        context: context,
        error: error,
        installableAppId: installableAppId
    };
};
const $8d687be8d53d51e7$export$a23e0fb000ae422a = (_ref4)=>{
    let { context: context, hostConfig: hostConfig, hostInfo: hostInfo, mpacBaseUrl: mpacBaseUrl, installableApp: installableApp, installableAppId: installableAppId, relayState: relayState, suppressProgressFlag: suppressProgressFlag = false, suppressResultFlag: suppressResultFlag = false, featureFlags: featureFlags, locale: locale } = _ref4;
    return (dispatch)=>{
        const appIdentifier = (0, $ifMZN.foldInstallableAppIdentifier)(installableAppId)((key)=>key.key, (url)=>url.url, (ari)=>ari.appKey);
        const loadingFlagKey = "".concat(appIdentifier, "-app-install-in-progress");
        dispatch($8d687be8d53d51e7$var$startInstallApp({
            installableAppId: installableAppId
        }));
        if (!suppressProgressFlag) dispatch((0, $8bwkw.addFlag)({
            flag: (0, $jC5dB.makeFlag)({
                key: loadingFlagKey,
                appearance: (0, $jC5dB.INFO_APPEARANCE),
                autoDismiss: false,
                title: "Adding ".concat(installableApp.details.name, "..."),
                description: (0, $jC5dB.makeFlagDescription)({
                    primary: "We'll tell you when your app has been added."
                }),
                actions: (0, $g5DHJ.List)([
                    (0, $jC5dB.makeFlagAction)({
                        callback: ()=>{
                            dispatch((0, $8bwkw.removeFlag)(loadingFlagKey));
                        },
                        displayText: 'Close',
                        id: "".concat(appIdentifier, "-close")
                    })
                ])
            })
        }));
        (0, $3lzNh.AppInstallTask).start();
        return (0, $55gtq.default)()/**
     * The signature of installAddon has been changed. We will not be making a
     * change here since we are replacing this flow with the standalone app installation
     * flow
     */ .installAddon({
            addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)(installableAppId),
            contextId: context.id,
            relayState: relayState
        }).then((installedAddon)=>{
            const key = "".concat(appIdentifier, "-app-install-success");
            const actions = (0, $g5DHJ.List)([
                {
                    displayText: 'Get started',
                    url: installedAddon.getStartedUrl,
                    key: 'getStarted'
                },
                {
                    displayText: 'Configure',
                    url: installedAddon.configureUrl,
                    removeIfActionCountAbove: 2,
                    key: 'config'
                },
                {
                    displayText: 'Manage app',
                    url: installedAddon.manageAppUrl,
                    key: 'manageApp'
                }
            ]).filter((action)=>!!action.url).reduce((newList, action, _, currentList)=>action.removeIfActionCountAbove && currentList.size > action.removeIfActionCountAbove ? newList : newList.push(action), (0, $g5DHJ.List)()).map((action)=>(0, $jC5dB.makeFlagAction)({
                    callback: ()=>{
                        (0, $bPtM5.navigateToProductUrl)({
                            url: action.url,
                            isRelativeUrl: !!action.relative
                        });
                    },
                    displayText: action.displayText,
                    id: "".concat(appIdentifier, "-").concat(action.displayText.replace(/\s/g, '-')),
                    key: action.key
                }));
            dispatch((0, $8bwkw.removeFlag)((0, $dSumc.NO_SIMULTANEOUS_INSTALLS_FLAG_KEY)));
            dispatch((0, $8bwkw.removeFlag)(loadingFlagKey));
            if (!suppressResultFlag) dispatch((0, $8bwkw.addFlag)({
                flag: (0, $jC5dB.makeFlag)({
                    key: key,
                    autoDismiss: false,
                    appearance: (0, $jC5dB.SUCCESS_APPEARANCE),
                    title: 'Success',
                    description: (0, $jC5dB.makeFlagDescription)({
                        primary: "".concat(installableApp.details.name, " was added.")
                    }),
                    actions: actions
                })
            }));
            dispatch($8d687be8d53d51e7$var$finishInstallApp({
                context: context,
                installableAppId: installableAppId,
                suppressResultFlag: suppressResultFlag,
                featureFlags: featureFlags,
                appDetails: installableApp.marketplaceAppDetails
            }));
            (0, $6Xsph.updateInstalledAppsPostInstall)(dispatch, context, hostConfig, featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.enableDeprecatedInstallationsGQL);
            (0, $6Xsph.updateAllRequestStatusesPostInstall)({
                hostInfo: hostInfo,
                appKey: installableApp.details.key,
                appName: installableApp.details.name
            });
            (0, $3lzNh.AppInstallTask).succeeded();
            return (0, $bWAru.Either).right(installedAddon);
        }, (error)=>{
            (0, $bTrQR.default).error('InstallApp', 'Failed to install the app', {
                error: error
            });
            (0, $9IC13.trackAppInstallTelemetryTaskError)(error);
            const key = "".concat(appIdentifier, "-app-install-error");
            if (!suppressResultFlag) dispatch((0, $8bwkw.addCaasErrorFlag)({
                featureFlags: featureFlags,
                hostConfig: hostConfig,
                message: error.message,
                key: key,
                actions: (0, $g5DHJ.List)([
                    (0, $jC5dB.makeFlagAction)({
                        callback: ()=>{
                            dispatch($8d687be8d53d51e7$export$a23e0fb000ae422a({
                                context: context,
                                hostConfig: hostConfig,
                                hostInfo: hostInfo,
                                mpacBaseUrl: mpacBaseUrl,
                                installableApp: installableApp,
                                installableAppId: installableAppId,
                                relayState: relayState,
                                suppressProgressFlag: suppressProgressFlag,
                                suppressResultFlag: suppressResultFlag,
                                featureFlags: featureFlags,
                                locale: locale
                            }));
                            dispatch((0, $8bwkw.removeFlag)(key));
                        },
                        displayText: 'Try again',
                        id: "".concat(appIdentifier, "-try-again")
                    })
                ])
            }));
            dispatch((0, $8bwkw.removeFlag)((0, $dSumc.NO_SIMULTANEOUS_INSTALLS_FLAG_KEY)));
            dispatch((0, $8bwkw.removeFlag)(loadingFlagKey));
            dispatch($8d687be8d53d51e7$var$installAppError({
                context: context,
                error: error,
                installableAppId: installableAppId
            }));
            return (0, $bWAru.Either).left(error);
        });
    };
};

});

parcelRegister("7jp5q", function(module, exports) {

$parcel$export(module.exports, "START_FETCH_INSTALLABLE_APP_BY_MANUAL_URL", () => $552dc462c047d564$export$5aa3a6fa9e85b5dd);
$parcel$export(module.exports, "FINISH_FETCH_INSTALLABLE_APP_BY_MANUAL_URL", () => $552dc462c047d564$export$b8dea6be4ae8c8e);
$parcel$export(module.exports, "FETCH_INSTALLABLE_APP_BY_MANUAL_URL_ERROR", () => $552dc462c047d564$export$e9b743130c28f01b);
$parcel$export(module.exports, "CLEAR_INSTALLABLE_APP_BY_MANUAL_URL", () => $552dc462c047d564$export$e31a48e8cbadae5a);
$parcel$export(module.exports, "doStartInstallableAppByManualUrlInstallMode", () => $552dc462c047d564$export$a7dfeb066ef014fe);
$parcel$export(module.exports, "clearInstallableAppByManualUrl", () => $552dc462c047d564$export$93d56265591a0434);
$parcel$export(module.exports, "doFetchInstallableAppByManualUrl", () => $552dc462c047d564$export$fca922431d303d09);

var $ly50n = parcelRequire("ly50n");

var $4gzHi = parcelRequire("4gzHi");

var $hCQtM = parcelRequire("hCQtM");

var $ifMZN = parcelRequire("ifMZN");

var $249j9 = parcelRequire("249j9");

var $55gtq = parcelRequire("55gtq");

var $3DsUo = parcelRequire("3DsUo");

var $hsaiM = parcelRequire("hsaiM");

var $38gnU = parcelRequire("38gnU");

var $dSumc = parcelRequire("dSumc");

var $6BOFf = parcelRequire("6BOFf");
const $552dc462c047d564$export$5aa3a6fa9e85b5dd = 'INSTALLATION_START_FETCH_INSTALLABLE_APP_BY_MANUAL_URL';
const $552dc462c047d564$export$b8dea6be4ae8c8e = 'INSTALLATION_FINISH_FETCH_INSTALLABLE_APP_BY_MANUAL_URL';
const $552dc462c047d564$export$e9b743130c28f01b = 'INSTALLATION_FETCH_INSTALLABLE_APP_BY_MANUAL_URL_ERROR';
const $552dc462c047d564$export$e31a48e8cbadae5a = 'INSTALLATION_CLEAR_INSTALLABLE_APP_BY_MANUAL_URL';
const $552dc462c047d564$export$a7dfeb066ef014fe = ()=>(dispatch)=>{
        dispatch((0, $dSumc.doSetInstallMode)({
            installMode: (0, $249j9.makeInstallableAppByManualUrlInstallMode)()
        }));
    };
const $552dc462c047d564$var$startFetchInstallableAppByManualUrl = (_ref)=>{
    let { installableAppByUrlId: installableAppByUrlId, retrievalId: retrievalId } = _ref;
    return {
        type: $552dc462c047d564$export$5aa3a6fa9e85b5dd,
        installableAppByUrlId: installableAppByUrlId,
        retrievalId: retrievalId
    };
};
const $552dc462c047d564$var$finishFetchInstallableAppByManualUrl = (_ref2)=>{
    let { installableApp: installableApp, installedApp: installedApp, retrievalId: retrievalId } = _ref2;
    return {
        type: $552dc462c047d564$export$b8dea6be4ae8c8e,
        installableApp: installableApp,
        installedApp: installedApp,
        retrievalId: retrievalId
    };
};
const $552dc462c047d564$var$fetchInstallableAppByManualUrlError = (_ref3)=>{
    let { error: error, installableAppByUrlId: installableAppByUrlId, retrievalId: retrievalId } = _ref3;
    return {
        type: $552dc462c047d564$export$e9b743130c28f01b,
        error: error,
        installableAppByUrlId: installableAppByUrlId,
        retrievalId: retrievalId
    };
};
const $552dc462c047d564$export$93d56265591a0434 = ()=>({
        type: $552dc462c047d564$export$e31a48e8cbadae5a
    });
const $552dc462c047d564$export$fca922431d303d09 = (_ref4)=>{
    let { context: context, installableAppByUrlId: installableAppByUrlId, mpacBaseUrl: mpacBaseUrl } = _ref4;
    return (dispatch)=>{
        const retrievalId = (0, $hsaiM.getRequestId)();
        dispatch($552dc462c047d564$var$startFetchInstallableAppByManualUrl({
            retrievalId: retrievalId,
            installableAppByUrlId: installableAppByUrlId
        }));
        (0, $38gnU.retrieveAppDataByUrl)({
            installableAppByUrlId: installableAppByUrlId,
            mpacBaseUrl: mpacBaseUrl
        }).then((_ref5)=>{
            let { installableAddon: installableAddon, marketplaceApp: marketplaceApp } = _ref5;
            installableAddon.swap().map((error)=>{
                console.error("The SPI's getInstallableAddon returned an error or invalid shape", error);
                return error;
            }).swap().map((installableAddonRes)=>(0, $hCQtM.makeInstallableAppFromSPIInstallableAddonAndMarketplaceAppData)(installableAddonRes, marketplaceApp, mpacBaseUrl)).fold((error)=>{
                dispatch($552dc462c047d564$var$fetchInstallableAppByManualUrlError({
                    error: error,
                    installableAppByUrlId: installableAppByUrlId,
                    retrievalId: retrievalId
                }));
            }, (installableApp)=>{
                (0, $3DsUo.reflect)((0, $55gtq.default)().getInstalledAddon({
                    contextId: context.id,
                    addon: (0, $ifMZN.toSPIInstallableAddonIdentifier)((0, $ifMZN.makeInstallableAppByKeyIdentifier)({
                        key: (0, $ly50n.makeAppKey)(installableApp.details.key)
                    }))
                }).then((installedAddonResult)=>(0, $6BOFf.parseInstalledAddonResult)(installedAddonResult))).then((installedAddon)=>{
                    dispatch($552dc462c047d564$var$finishFetchInstallableAppByManualUrl({
                        installableApp: installableApp,
                        installedApp: installedAddon.toOption().map((0, $4gzHi.makeInstalledAppFromSPIInstalledApp)),
                        retrievalId: retrievalId
                    }));
                }).catch(console.error.bind(console));
            });
        }).catch(console.error.bind(console));
    };
};

});

parcelRegister("5Wf8D", function(module, exports) {

$parcel$export(module.exports, "FINISH_FETCH_INSTALLABLE_APP_FOR_UPGRADE", () => $452e1ca8b331a846$export$b1f627bbac165450);
$parcel$export(module.exports, "FETCH_INSTALLABLE_APP_FOR_UPGRADE_ERROR", () => $452e1ca8b331a846$export$c995913192e40cd3);
$parcel$export(module.exports, "START_UPGRADE_APP", () => $452e1ca8b331a846$export$8ee6261faa346b72);
$parcel$export(module.exports, "FINISH_UPGRADE_APP", () => $452e1ca8b331a846$export$11377298a23160d);
$parcel$export(module.exports, "UPGRADE_APP_ERROR", () => $452e1ca8b331a846$export$5470762c8587f846);
$parcel$export(module.exports, "doInitiateUpgradeInstallModeForInstalledApp", () => $452e1ca8b331a846$export$f96ec2a0a6bd1c07);
$parcel$export(module.exports, "doUpgradeApp", () => $452e1ca8b331a846$export$55d200859d7f91b9);

var $hCQtM = parcelRequire("hCQtM");

var $ifMZN = parcelRequire("ifMZN");

var $gR0l9 = parcelRequire("gR0l9");

var $55gtq = parcelRequire("55gtq");

var $38gnU = parcelRequire("38gnU");

var $dSumc = parcelRequire("dSumc");

var $6Xsph = parcelRequire("6Xsph");
const $452e1ca8b331a846$export$b1f627bbac165450 = 'INSTALLATION_FINISH_FETCH_INSTALLABLE_APP_FOR_UPGRADE';
const $452e1ca8b331a846$export$c995913192e40cd3 = 'INSTALLATION_FETCH_INSTALLABLE_APP_FOR_UPGRADE_ERROR';
const $452e1ca8b331a846$export$8ee6261faa346b72 = 'INSTALLATION_START_UPGRADE_APP';
const $452e1ca8b331a846$export$11377298a23160d = 'INSTALLATION_FINISH_UPGRADE_APP';
const $452e1ca8b331a846$export$5470762c8587f846 = 'INSTALLATION_UPGRADE_APP_ERROR';
const $452e1ca8b331a846$var$finishFetchInstallableAppForUpgrade = (_ref)=>{
    let { installableAppByKeyId: installableAppByKeyId, installableAppToUpgradeTo: installableAppToUpgradeTo } = _ref;
    return {
        type: $452e1ca8b331a846$export$b1f627bbac165450,
        installableAppByKeyId: installableAppByKeyId,
        installableAppToUpgradeTo: installableAppToUpgradeTo
    };
};
const $452e1ca8b331a846$var$fetchInstallableAppForUpgradeError = (_ref2)=>{
    let { error: error, installableAppByKeyId: installableAppByKeyId } = _ref2;
    return {
        type: $452e1ca8b331a846$export$c995913192e40cd3,
        error: error,
        installableAppByKeyId: installableAppByKeyId
    };
};
const $452e1ca8b331a846$var$startUpgradeApp = (_ref3)=>{
    let { installableAppByKeyId: installableAppByKeyId } = _ref3;
    return {
        type: $452e1ca8b331a846$export$8ee6261faa346b72,
        installableAppByKeyId: installableAppByKeyId
    };
};
const $452e1ca8b331a846$var$finishUpgradeApp = (_ref4)=>{
    let { context: context, installableAppByKeyId: installableAppByKeyId } = _ref4;
    return {
        type: $452e1ca8b331a846$export$11377298a23160d,
        context: context,
        installableAppByKeyId: installableAppByKeyId
    };
};
const $452e1ca8b331a846$var$upgradeAppError = (_ref5)=>{
    let { context: context, error: error, installableAppByKeyId: installableAppByKeyId } = _ref5;
    return {
        type: $452e1ca8b331a846$export$5470762c8587f846,
        context: context,
        installableAppByKeyId: installableAppByKeyId,
        error: error
    };
};
const $452e1ca8b331a846$export$f96ec2a0a6bd1c07 = (_ref6)=>{
    let { mpacBaseUrl: mpacBaseUrl, installedApp: installedApp } = _ref6;
    return (dispatch)=>{
        const installableAppByKeyId = (0, $ifMZN.makeInstallableAppByKeyIdentifier)({
            key: installedApp.details.key
        });
        dispatch((0, $dSumc.doSetInstallMode)({
            installMode: (0, $gR0l9.makeInstallableAppUpgradeInstallMode)({
                installedApp: installedApp,
                installableAppByKeyId: installableAppByKeyId
            })
        }));
        (0, $38gnU.retrieveAppDataByKey)({
            installableAppByKeyId: installableAppByKeyId,
            mpacBaseUrl: mpacBaseUrl
        }).then((_ref7)=>{
            let { installableAddon: installableAddon, marketplaceApp: marketplaceApp } = _ref7;
            installableAddon.map((installableAppToUpgradeTo)=>(0, $hCQtM.makeInstallableAppFromSPIInstallableAddonAndMarketplaceAppData)(installableAppToUpgradeTo, marketplaceApp, mpacBaseUrl)).fold((error)=>{
                dispatch($452e1ca8b331a846$var$fetchInstallableAppForUpgradeError({
                    error: error,
                    installableAppByKeyId: installableAppByKeyId
                }));
            }, (installableAppToUpgradeTo)=>{
                dispatch($452e1ca8b331a846$var$finishFetchInstallableAppForUpgrade({
                    installableAppToUpgradeTo: installableAppToUpgradeTo,
                    installableAppByKeyId: installableAppByKeyId
                }));
            });
        }).catch(console.error.bind(console));
    };
};
const $452e1ca8b331a846$export$55d200859d7f91b9 = (_ref8)=>{
    let { context: context, hostConfig: hostConfig, installedApp: installedApp, installableAppByKeyId: installableAppByKeyId, installableAppToUpgradeTo: installableAppToUpgradeTo } = _ref8;
    return (dispatch)=>{
        let newVersion;
        dispatch($452e1ca8b331a846$var$startUpgradeApp({
            installableAppByKeyId: installableAppByKeyId
        }));
        if (installableAppToUpgradeTo.details.version) {
            newVersion = installableAppToUpgradeTo.details.version;
            return (0, $55gtq.default)().upgradeAddon({
                addon: installedApp._original,
                contextId: context.id,
                newVersion: newVersion
            }).then(()=>{
                dispatch($452e1ca8b331a846$var$finishUpgradeApp({
                    context: context,
                    installableAppByKeyId: installableAppByKeyId
                }));
                (0, $6Xsph.updateInstalledAppsPostInstall)(dispatch, context, hostConfig);
            }, (error)=>{
                $452e1ca8b331a846$var$handleError(dispatch, context, installableAppByKeyId, 'upgradeAddon could not be executed as there was no version on the installableApp', error);
            });
        } else {
            $452e1ca8b331a846$var$handleError(dispatch, context, installableAppByKeyId, 'upgradeAddon could not be executed as there was no version on the installableApp');
            return Promise.resolve();
        }
    };
};
function $452e1ca8b331a846$var$handleError(dispatch, context, installableAppByKeyId, contextualError, specificError) {
    console.error(contextualError, specificError);
    dispatch($452e1ca8b331a846$var$upgradeAppError({
        context: context,
        error: specificError || contextualError,
        installableAppByKeyId: installableAppByKeyId
    }));
}

});

parcelRegister("fdxoX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b141fac87bd94f07$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $gaiog = parcelRequire("gaiog");
var $f2QOW = parcelRequire("f2QOW");
var $9osuT = parcelRequire("9osuT");

var $inwKI = parcelRequire("inwKI");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $i7hUf = parcelRequire("i7hUf");

var $9eIgo = parcelRequire("9eIgo");

var $3kdNe = parcelRequire("3kdNe");

var $fx09t = parcelRequire("fx09t");

var $2dt3P = parcelRequire("2dt3P");

var $05YC4 = parcelRequire("05YC4");

var $lHkHI = parcelRequire("lHkHI");
function $b141fac87bd94f07$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b141fac87bd94f07$export$a7ca541beb62abf6 = (0, $3UXZ8.default)("div", {
    target: "e147aph70",
    label: "InnerDialog"
})({
    name: "1t9oc18",
    styles: "max-width:650px;min-height:300px;margin:auto;"
});
function $b141fac87bd94f07$var$footerInDialogRenderer(footerLeft, footerCenter, footerRight, privacyInformation) {
    const fn = ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $05YC4.default), {
            footerLeft: footerLeft,
            footerCenter: footerCenter,
            footerRight: footerRight,
            privacyInformation: privacyInformation
        });
    fn.displayName = 'ManagedDialogFooter';
    return fn;
}
const $b141fac87bd94f07$var$getAnalyticsContextAttributes = (installMode)=>{
    const appDetails = (0, $i7hUf.foldInstallMode)(installMode)(()=>null, ()=>null, (im)=>im.instructionalApp.details, (im)=>im.installableApp.marketplaceAppDetails, ()=>null, ()=>null);
    if (!appDetails) return null;
    else return {
        appKey: appDetails.key,
        category: (0, $7Uh51.ANALYTICS_CATEGORY_INSTALL),
        programs: appDetails.programs,
        isEcosystemCloudApp: !appDetails.isConnectApp,
        paymentModel: appDetails.paymentModel
    };
};
function $b141fac87bd94f07$export$7680d479f2e500aa(props) {
    const featureFlags = (0, $inwKI.useFeatureFlags)();
    const intlLanguage = navigator.language || 'en-us';
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const onDialogCloseRequested = (0, $eUqFw.useCallback)((preventDialogClosing)=>()=>{
            if (!preventDialogClosing) {
                fireAnalyticsEvent({
                    eventType: (0, $gaiog.ButtonClickedEvent),
                    actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_INSTALL_CANCEL)
                });
                props.closeInstallDialog();
            }
        }, []);
    const installApp = (0, $eUqFw.useCallback)((args)=>props.installApp(args, featureFlags, intlLanguage), []);
    return props.installMode.flatMap((installMode)=>{
        const { analyticsSourceModal: analyticsSourceModal, content: content, heading: heading, footerLeft: footerLeft, footerCenter: footerCenter, footerRight: footerRight, preventDialogClosing: preventDialogClosing, errorDetails: errorDetails, privacyInformation: privacyInformation } = (0, $fx09t.default)(installMode, {
            closeInstallDialog: props.closeInstallDialog,
            hostConfig: props.hostConfig,
            hostInfo: props.hostInfo,
            hostPricing: props.hostPricing,
            context: props.context,
            generateAppSpecificPassword: props.generateAppSpecificPassword,
            openManualUrlInstallDialog: props.openManualUrlInstallDialog,
            openAppSpecificPasswordDialog: props.openAppSpecificPasswordDialog,
            setAppSpecificPasswordName: props.setAppSpecificPasswordName,
            links: props.links,
            installApp: installApp,
            scopesLookup: props.scopesLookup,
            clearInstallableAppByManualUrl: props.clearInstallableAppByManualUrl,
            fetchInstallableAppByManualUrl: props.fetchInstallableAppByManualUrl,
            upgradeApp: props.upgradeApp,
            mpacBaseUrl: props.bootstrapConfig.mpacBaseUrl
        }, featureFlags);
        return (0, $i7hUf.foldInstallMode)(installMode)(()=>(0, $bWAru.Option).some(), ()=>(0, $bWAru.Option).some(), ()=>(0, $bWAru.Option).some(), (defaultInstallMode)=>(0, $9eIgo.foldInstallStatus)(defaultInstallMode.status, ()=>(0, $bWAru.Option).some(), ()=>(0, $bWAru.Option).empty(), ()=>(0, $bWAru.Option).empty()), (installableAppByManualUrlInstallMode)=>installableAppByManualUrlInstallMode.installableAppByManualUrl.map((iabmu)=>(0, $9eIgo.foldInstallStatus)(iabmu.status, ()=>(0, $bWAru.Option).some(), ()=>(0, $bWAru.Option).empty(), ()=>(0, $bWAru.Option).empty())).getOrElseL(()=>(0, $bWAru.Option).some()), ()=>(0, $bWAru.Option).some()).map(()=>{
            var _getAnalyticsContextA;
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $f2QOW.default), {
                attributes: (_getAnalyticsContextA = $b141fac87bd94f07$var$getAnalyticsContextAttributes(installMode)) !== null && _getAnalyticsContextA !== void 0 ? _getAnalyticsContextA : {},
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3kdNe.default), {
                    analyticsName: analyticsSourceModal,
                    width: "large",
                    onClose: onDialogCloseRequested(preventDialogClosing),
                    heading: heading,
                    customFooter: $b141fac87bd94f07$var$footerInDialogRenderer(footerLeft, footerCenter, footerRight, privacyInformation)(),
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)($b141fac87bd94f07$export$a7ca541beb62abf6, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2dt3P.default), {
                            installMode: installMode,
                            content: content,
                            errorDetails: errorDetails
                        })
                    })
                })
            }, "install-dialog");
        });
    }).orNull();
}
var $b141fac87bd94f07$export$2e2bcd8739ae039 = $b141fac87bd94f07$export$7680d479f2e500aa;

});
parcelRegister("fx09t", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4ea0e4098ab12a3$export$2e2bcd8739ae039);

var $i7hUf = parcelRequire("i7hUf");

var $9eIgo = parcelRequire("9eIgo");

var $2DefO = parcelRequire("2DefO");

var $eJGKo = parcelRequire("eJGKo");

var $6Xpkk = parcelRequire("6Xpkk");

var $AM6UE = parcelRequire("AM6UE");

var $g9u53 = parcelRequire("g9u53");

var $kZJEl = parcelRequire("kZJEl");
function $b4ea0e4098ab12a3$export$2e2bcd8739ae039(installMode, config, featureFlags) {
    return (0, $i7hUf.foldInstallMode)(installMode)((determiningInstallMode)=>(0, $6Xpkk.default)({
            closeInstallDialog: config.closeInstallDialog,
            determiningInstallMode: determiningInstallMode,
            hostConfig: config.hostConfig,
            featureFlags: featureFlags
        }), (appSpecificPasswordInstallMode)=>(0, $2DefO.default)({
            appSpecificPasswordInstallMode: appSpecificPasswordInstallMode,
            closeInstallDialog: config.closeInstallDialog,
            context: config.context,
            generateAppSpecificPassword: config.generateAppSpecificPassword,
            hostConfig: config.hostConfig,
            hostPricing: config.hostPricing,
            openManualUrlInstallDialog: config.openManualUrlInstallDialog,
            openAppSpecificPasswordDialog: config.openAppSpecificPasswordDialog,
            setAppSpecificPasswordName: config.setAppSpecificPasswordName
        }), (instructionalInstallMode)=>(0, $g9u53.default)({
            closeInstallDialog: config.closeInstallDialog,
            instructionalInstallMode: instructionalInstallMode,
            links: config.links
        }), (defaultInstallMode)=>(0, $eJGKo.default)({
            closeInstallDialog: config.closeInstallDialog,
            context: config.context,
            defaultInstallMode: defaultInstallMode,
            hostConfig: config.hostConfig,
            hostPricing: config.hostPricing,
            installApp: config.installApp,
            hostInfo: config.hostInfo,
            links: config.links,
            scopesLookup: config.scopesLookup,
            mpacBaseUrl: config.mpacBaseUrl,
            featureFlags: featureFlags,
            isInstallInProgress: ()=>(0, $9eIgo.isInstallStatusLoading)(defaultInstallMode.status)
        }), (installableAppByManualUrlInstallMode)=>(0, $AM6UE.default)({
            clearInstallableAppByManualUrl: config.clearInstallableAppByManualUrl,
            closeInstallDialog: config.closeInstallDialog,
            context: config.context,
            fetchInstallableAppByManualUrl: config.fetchInstallableAppByManualUrl,
            hostConfig: config.hostConfig,
            installableAppByManualUrlInstallMode: installableAppByManualUrlInstallMode,
            installApp: config.installApp,
            hostInfo: config.hostInfo,
            links: config.links,
            openManualUrlInstallDialog: config.openManualUrlInstallDialog,
            openAppSpecificPasswordDialog: config.openAppSpecificPasswordDialog,
            scopesLookup: config.scopesLookup,
            featureFlags: featureFlags
        }), (upgradeInstallMode)=>(0, $kZJEl.default)({
            closeInstallDialog: config.closeInstallDialog,
            context: config.context,
            hostConfig: config.hostConfig,
            hostPricing: config.hostPricing,
            links: config.links,
            scopesLookup: config.scopesLookup,
            upgradeApp: config.upgradeApp,
            upgradeInstallMode: upgradeInstallMode,
            featureFlags: featureFlags
        }));
}

});
parcelRegister("2DefO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1eaa47ddab19e625$export$2e2bcd8739ae039);

var $9eIgo = parcelRequire("9eIgo");

var $9ViOY = parcelRequire("9ViOY");

var $6OdBU = parcelRequire("6OdBU");
const $1eaa47ddab19e625$var$resolveDialogAppSpecificPassword = (_ref)=>{
    let { appSpecificPasswordInstallMode: appSpecificPasswordInstallMode, closeInstallDialog: closeInstallDialog, context: context, generateAppSpecificPassword: generateAppSpecificPassword, hostConfig: hostConfig, openManualUrlInstallDialog: openManualUrlInstallDialog, openAppSpecificPasswordDialog: openAppSpecificPasswordDialog, setAppSpecificPasswordName: setAppSpecificPasswordName } = _ref;
    const createAppSpecificPassword = ()=>(0, $9ViOY.default)({
            appSpecificPasswordInstallMode: appSpecificPasswordInstallMode,
            closeInstallDialog: closeInstallDialog,
            context: context,
            generateAppSpecificPassword: generateAppSpecificPassword,
            hostConfig: hostConfig,
            openManualUrlInstallDialog: openManualUrlInstallDialog,
            openAppSpecificPasswordDialog: openAppSpecificPasswordDialog,
            setAppSpecificPasswordName: setAppSpecificPasswordName
        });
    const showAppSpecificPassword = (name, installStatus)=>(0, $6OdBU.default)({
            name: name,
            closeInstallDialog: closeInstallDialog,
            context: context,
            hostConfig: hostConfig,
            installStatus: installStatus
        });
    return appSpecificPasswordInstallMode.appSpecificPassword.map((asp)=>(0, $9eIgo.foldInstallStatus)(asp.status, createAppSpecificPassword, (inProgress)=>showAppSpecificPassword(asp.name, inProgress), (complete)=>showAppSpecificPassword(asp.name, complete))).getOrElseL(createAppSpecificPassword);
};
var $1eaa47ddab19e625$export$2e2bcd8739ae039 = $1eaa47ddab19e625$var$resolveDialogAppSpecificPassword;

});
parcelRegister("9ViOY", function(module, exports) {

$parcel$export(module.exports, "default", () => $73980969ddac5242$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
parcelRequire("eUqFw");

var $gIQkA = parcelRequire("gIQkA");

var $jbxVX = parcelRequire("jbxVX");

var $2wL2q = parcelRequire("2wL2q");

var $cXOS6 = parcelRequire("cXOS6");

var $lHkHI = parcelRequire("lHkHI");
const $73980969ddac5242$var$resolveDialogCreateAppSpecificPassword = (_ref)=>{
    var _appSpecificPasswordI;
    let { appSpecificPasswordInstallMode: appSpecificPasswordInstallMode, closeInstallDialog: closeInstallDialog, context: context, generateAppSpecificPassword: generateAppSpecificPassword, hostConfig: hostConfig, openManualUrlInstallDialog: openManualUrlInstallDialog, openAppSpecificPasswordDialog: openAppSpecificPasswordDialog, setAppSpecificPasswordName: setAppSpecificPasswordName } = _ref;
    return {
        analyticsSourceModal: (0, $gIQkA.ANALYTICS_MODAL_CREATE_TOKEN),
        content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jbxVX.default), {
            installMode: appSpecificPasswordInstallMode,
            openManualUrlInstallDialog: openManualUrlInstallDialog,
            openAppSpecificPasswordDialog: openAppSpecificPasswordDialog,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2wL2q.default), {
                appSpecificPasswordInstallMode: appSpecificPasswordInstallMode,
                hostConfig: hostConfig,
                setAppSpecificPasswordName: setAppSpecificPasswordName
            })
        }),
        heading: 'Custom app',
        footerRight: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cXOS6.default), {
            closeInstallDialog: closeInstallDialog,
            context: context,
            generateAppSpecificPassword: generateAppSpecificPassword,
            hostConfig: hostConfig,
            name: (_appSpecificPasswordI = appSpecificPasswordInstallMode.appSpecificPassword) === null || _appSpecificPasswordI === void 0 ? void 0 : _appSpecificPasswordI.name
        }),
        preventDialogClosing: false,
        errorDetails: (0, $bWAru.Option).empty()
    };
};
var $73980969ddac5242$export$2e2bcd8739ae039 = $73980969ddac5242$var$resolveDialogCreateAppSpecificPassword;

});
parcelRegister("jbxVX", function(module, exports) {

$parcel$export(module.exports, "default", () => $df795dec78e646d5$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $7zMlx = parcelRequire("7zMlx");
var $hp0RB = parcelRequire("hp0RB");
var $bQ6DK = parcelRequire("bQ6DK");
var $gtpta = parcelRequire("gtpta");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $9Qzgt = parcelRequire("9Qzgt");

var $249j9 = parcelRequire("249j9");

var $lHkHI = parcelRequire("lHkHI");
function $df795dec78e646d5$export$d753870dc154ad6d(installMode) {
    return function foldCustomInstallModeInner(installableAppByManualUrl, appSpecificPassword) {
        switch(installMode.type){
            case 0, $249j9.INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE:
                return installableAppByManualUrl(installMode);
            case 0, $9Qzgt.APP_SPECIFIC_PASSWORD_INSTALL_MODE:
                return appSpecificPassword(installMode);
            default:
                // Flow compile-time validation that we've handled every custom dialog install mode
                // prettier-ignore
                installMode;
                return undefined;
        }
    };
}
class $df795dec78e646d5$var$DialogCustomContainer extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onSelectTokenTab", ()=>{
            this.props.openAppSpecificPasswordDialog({
                name: null
            });
        });
        (0, $5zQU9.default)(this, "onSelectURLTab", ()=>{
            this.props.openManualUrlInstallDialog();
        });
        (0, $5zQU9.default)(this, "onChangeTab", (selectedTabIndex)=>{
            const selectedTab = this.getTabs()[selectedTabIndex];
            if (selectedTab.installModeType === (0, $9Qzgt.APP_SPECIFIC_PASSWORD_INSTALL_MODE)) this.onSelectTokenTab();
            else if (selectedTab.installModeType === (0, $249j9.INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE)) this.onSelectURLTab();
            else console.error('Unknown install mode', selectedTab.installModeType);
        });
        (0, $5zQU9.default)(this, "getTabs", ()=>{
            const installMode = $df795dec78e646d5$export$d753870dc154ad6d(this.props.installMode)((0, $bWAru.Either).right, (0, $bWAru.Either).left);
            return [
                {
                    label: 'API tokens',
                    installModeType: (0, $9Qzgt.APP_SPECIFIC_PASSWORD_INSTALL_MODE),
                    content: installMode.swap().map(()=>this.props.children).toOption().orNull()
                },
                {
                    label: 'Installation URL',
                    installModeType: (0, $249j9.INSTALLABLE_APP_BY_MANUAL_URL_INSTALL_MODE),
                    content: installMode.map(()=>this.props.children).toOption().orNull()
                }
            ];
        });
        (0, $5zQU9.default)(this, "getSelectedTabIndex", ()=>this.getTabs().findIndex((tab)=>this.props.installMode.type === tab.installModeType));
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
            children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $7zMlx.default), {
                id: "install-custom-dialog",
                onChange: this.onChangeTab,
                selected: this.getSelectedTabIndex(),
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bQ6DK.default), {
                        children: this.getTabs().map((tab)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $hp0RB.default), {
                                children: tab.label
                            }, tab.label))
                    }),
                    this.getTabs().map((tab)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $gtpta.default), {
                            children: tab.content
                        }, tab.label))
                ]
            })
        });
    }
}
var $df795dec78e646d5$export$2e2bcd8739ae039 = $df795dec78e646d5$var$DialogCustomContainer;

});
parcelRegister("hp0RB", function(module, exports) {

$parcel$export(module.exports, "default", () => $612170d553324518$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $jljCj = parcelRequire("jljCj");

var $ixqNN = parcelRequire("ixqNN");

var $ewzHc = parcelRequire("ewzHc");
/**
 * __Tab__
 *
 * Tab represents an indivudal Tab displayed in a TabList.
 *
 * - [Examples](https://atlassian.design/components/tabs/examples)
 * - [Code](https://atlassian.design/components/tabs/code)
 * - [Usage](https://atlassian.design/components/tabs/usage)
 */ const $612170d553324518$var$Tab = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function Tab({ children: children, testId: testId }, ref) {
    const { onClick: onClick, id: id, 'aria-controls': ariaControls, 'aria-posinset': ariaPosinset, 'aria-selected': ariaSelected, 'aria-setsize': ariaSetsize, onKeyDown: onKeyDown, role: role, tabIndex: tabIndex } = (0, $ewzHc.useTab)();
    return /*#__PURE__*/ (0, $byn9U.jsx)((0, $jljCj.default), {
        isInset: true
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "data-testid": testId,
        onClick: onClick,
        id: id,
        "aria-controls": ariaControls,
        "aria-posinset": ariaPosinset,
        "aria-selected": ariaSelected,
        "aria-setsize": ariaSetsize,
        onKeyDown: onKeyDown,
        role: role,
        tabIndex: tabIndex,
        ref: ref
    }, /*#__PURE__*/ (0, $byn9U.jsx)((0, $ixqNN.default), {
        weight: "medium",
        color: "inherit",
        maxLines: 1
    }, children)));
});
var $612170d553324518$export$2e2bcd8739ae039 = $612170d553324518$var$Tab;

});


parcelRegister("2wL2q", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d730eb567cc4fcf$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $1Tfhj = parcelRequire("1Tfhj");

var $cjFit = parcelRequire("cjFit");

var $eUqFw = parcelRequire("eUqFw");

var $9eIgo = parcelRequire("9eIgo");

var $lHkHI = parcelRequire("lHkHI");
function $1d730eb567cc4fcf$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1d730eb567cc4fcf$export$a67c0bc59081311a = (0, $3UXZ8.default)("div", {
    target: "e1nctgrn0",
    label: "HelpText"
})({
    name: "gt4wuf",
    styles: "margin-top:var(--ds-space-250, 20px);"
});
const $1d730eb567cc4fcf$export$49d0608fcfcceae6 = (0, $3UXZ8.default)("div", {
    target: "e1nctgrn1",
    label: "NameInputContainer"
})({
    name: "k0ewhs",
    styles: "width:250px;margin-bottom:100px;"
});
class $1d730eb567cc4fcf$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onNameChange", (e)=>{
            this.props.setAppSpecificPasswordName({
                name: (0, $cjFit.nonEmptyString)(e.target.value)
            });
        });
    }
    render() {
        const { disabled: disabled, name: name } = this.props.appSpecificPasswordInstallMode.appSpecificPassword ? {
            disabled: (0, $9eIgo.isInstallStatusLoading)(this.props.appSpecificPasswordInstallMode.appSpecificPassword.status),
            name: this.props.appSpecificPasswordInstallMode.appSpecificPassword.name
        } : {
            disabled: false,
            name: ''
        };
        return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($1d730eb567cc4fcf$export$a67c0bc59081311a, {
                    children: this.props.hostConfig.token.explanation
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($1d730eb567cc4fcf$export$49d0608fcfcceae6, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1Tfhj.default), {
                        isDisabled: disabled,
                        placeholder: "Specify a token name",
                        maxLength: 40,
                        onChange: this.onNameChange,
                        value: name
                    })
                })
            ]
        });
    }
}

});

parcelRegister("cXOS6", function(module, exports) {

$parcel$export(module.exports, "default", () => $970274c51fd8f839$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $gaiog = parcelRequire("gaiog");
var $dKnCb = parcelRequire("dKnCb");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $9KoF2 = parcelRequire("9KoF2");

var $lHkHI = parcelRequire("lHkHI");
const $970274c51fd8f839$var$PRIMARY_CTA_LABEL = 'Create';
class $970274c51fd8f839$export$72b1d16b4c2e29fa extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "generateAppSpecificPassword", (name)=>()=>{
                this.props.fireAnalyticsEvent((0, $dKnCb.makeAnalyticsData)({
                    eventType: (0, $gaiog.ButtonClickedEvent),
                    actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_CREATE_TOKEN),
                    attributes: {
                        label: $970274c51fd8f839$var$PRIMARY_CTA_LABEL
                    },
                    category: (0, $7Uh51.ANALYTICS_CATEGORY_NAVIGATION)
                }).toObject());
                this.props.generateAppSpecificPassword({
                    name: name,
                    context: this.props.context,
                    hostConfig: this.props.hostConfig
                });
            });
        (0, $5zQU9.default)(this, "render", ()=>this.props.name ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9KoF2.default), {
                closeInstallDialog: this.props.closeInstallDialog,
                isLoading: false,
                isPrimaryDisabled: false,
                onPrimaryCTAClick: this.generateAppSpecificPassword(this.props.name),
                primaryCTALabel: $970274c51fd8f839$var$PRIMARY_CTA_LABEL
            }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9KoF2.default), {
                closeInstallDialog: this.props.closeInstallDialog,
                isLoading: false,
                isPrimaryDisabled: true,
                primaryCTALabel: $970274c51fd8f839$var$PRIMARY_CTA_LABEL
            }));
    }
}
var $970274c51fd8f839$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($970274c51fd8f839$export$72b1d16b4c2e29fa);

});


parcelRegister("6OdBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f51f858ae1f84dd$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
parcelRequire("eUqFw");

var $gIQkA = parcelRequire("gIQkA");

var $hsaiM = parcelRequire("hsaiM");

var $ikdWI = parcelRequire("ikdWI");

var $ckRaV = parcelRequire("ckRaV");

var $3BnoT = parcelRequire("3BnoT");

var $lHkHI = parcelRequire("lHkHI");
const $4f51f858ae1f84dd$var$resolveDialogShowAppSpecificPassword = (_ref)=>{
    let { closeInstallDialog: closeInstallDialog, context: context, hostConfig: hostConfig, installStatus: installStatus, name: name, featureFlags: featureFlags } = _ref;
    return {
        analyticsSourceModal: (0, $gIQkA.ANALYTICS_MODAL_SHOW_TOKEN),
        content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ikdWI.default), {
            context: context,
            installStatus: installStatus,
            tokenConfig: hostConfig.token
        }),
        heading: "".concat(name, " token"),
        footerRight: (0, $3BnoT.default)(installStatus, ()=>null, ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $ckRaV.default), {
                closeInstallDialog: closeInstallDialog
            })),
        preventDialogClosing: (0, $3BnoT.default)(installStatus, ()=>true, ()=>false),
        errorDetails: (0, $3BnoT.default)(installStatus, ()=>(0, $bWAru.Option).empty(), (complete)=>complete.result.fold((error)=>(0, $bWAru.Option).some((0, $hsaiM.getErrorDetails)(error, hostConfig, {
                    showCustomBackendErrorsFromUpm: featureFlags === null || featureFlags === void 0 ? void 0 : featureFlags.showCustomBackendErrorsFromUpm
                })), ()=>(0, $bWAru.Option).empty()))
    };
};
var $4f51f858ae1f84dd$export$2e2bcd8739ae039 = $4f51f858ae1f84dd$var$resolveDialogShowAppSpecificPassword;

});
parcelRegister("ikdWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $d574e9a7b8e985bc$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $fyH4h = parcelRequire("fyH4h");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $2FaVi = parcelRequire("2FaVi");

var $lKk1f = parcelRequire("lKk1f");

var $3BnoT = parcelRequire("3BnoT");

var $lHkHI = parcelRequire("lHkHI");
function $d574e9a7b8e985bc$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $d574e9a7b8e985bc$export$4feccd40fedfe86c = (0, $3UXZ8.default)("div", {
    target: "e17iii600",
    label: "DialogShowAppSpecificPasswordContentContainer"
})({
    name: "1eixulq",
    styles: "max-width:600px;margin:auto;min-height:440px;"
});
const $d574e9a7b8e985bc$export$de975f278a3f0d93 = (0, $3UXZ8.default)("div", {
    target: "e17iii601",
    label: "TokenDialogCodeBlockContainer"
})({
    name: "633qqp",
    styles: "margin-top:initial;& + &{margin-top:var(--ds-space-250, 20px);}"
});
const $d574e9a7b8e985bc$export$564caafa12e62608 = (0, $3UXZ8.default)("span", {
    target: "e17iii602",
    label: "TokenDialogCodeBlockLabel"
})("color:", (0, $j0gMm.N200), ";font-size:14px;font-weight:", (props)=>props.bold ? 'bold' : 'normal', ";line-height:1.33;margin-bottom:10px;");
const $d574e9a7b8e985bc$export$af7e35dad972057e = (0, $3UXZ8.default)("span", {
    target: "e17iii603",
    label: "TokenDialogTokenWarning"
})("color:", (0, $j0gMm.N200), ";");
class $d574e9a7b8e985bc$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "renderLoading", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $fyH4h.default), {
                loading: true,
                dataError: false,
                dataErrorMessages: (0, $g5DHJ.List)(),
                children: null
            }));
        (0, $5zQU9.default)(this, "renderComplete", (complete)=>complete.result.fold(()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $fyH4h.default), {
                    loading: false,
                    dataError: false,
                    dataErrorMessages: (0, $g5DHJ.List)(),
                    children: null
                }), (generatedAppSpecificPassword)=>{
                const exampleEndpoint = this.props.tokenConfig.exampleEndpoint(this.props.context);
                return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $fyH4h.default), {
                    loading: false,
                    dataError: false,
                    dataErrorMessages: (0, $g5DHJ.List)(),
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)($d574e9a7b8e985bc$export$de975f278a3f0d93, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lKk1f.default), {
                                label: /*#__PURE__*/ (0, $lHkHI.jsxs)($d574e9a7b8e985bc$export$564caafa12e62608, {
                                    children: [
                                        /*#__PURE__*/ (0, $lHkHI.jsx)($d574e9a7b8e985bc$export$564caafa12e62608, {
                                            bold: true,
                                            children: "Copy the access token"
                                        }),
                                        /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                                            children: " and keep it in a safe place"
                                        })
                                    ]
                                }),
                                copyMessage: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2FaVi.default), {
                                    icon: "warning",
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)($d574e9a7b8e985bc$export$af7e35dad972057e, {
                                        children: "This token will not be visible again once you close this dialog"
                                    })
                                }),
                                text: generatedAppSpecificPassword
                            })
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)($d574e9a7b8e985bc$export$de975f278a3f0d93, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lKk1f.default), {
                                label: /*#__PURE__*/ (0, $lHkHI.jsxs)($d574e9a7b8e985bc$export$564caafa12e62608, {
                                    children: [
                                        /*#__PURE__*/ (0, $lHkHI.jsx)($d574e9a7b8e985bc$export$564caafa12e62608, {
                                            bold: true,
                                            children: "Use this REST API"
                                        }),
                                        /*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
                                            children: [
                                                " to ",
                                                this.props.tokenConfig.endpointVerb
                                            ]
                                        })
                                    ]
                                }),
                                text: exampleEndpoint
                            })
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)($d574e9a7b8e985bc$export$de975f278a3f0d93, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lKk1f.default), {
                                label: /*#__PURE__*/ (0, $lHkHI.jsxs)($d574e9a7b8e985bc$export$564caafa12e62608, {
                                    children: [
                                        /*#__PURE__*/ (0, $lHkHI.jsx)($d574e9a7b8e985bc$export$564caafa12e62608, {
                                            bold: true,
                                            children: "Optional: Developing an app?"
                                        }),
                                        /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                                            children: " Copy the sample cURL request"
                                        })
                                    ]
                                }),
                                language: "shell",
                                text: this.generateCurlMarkup(generatedAppSpecificPassword, exampleEndpoint)
                            })
                        })
                    ]
                });
            }));
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)($d574e9a7b8e985bc$export$4feccd40fedfe86c, {
                children: (0, $3BnoT.default)(this.props.installStatus, this.renderLoading, this.renderComplete)
            }));
    }
    generateCurlMarkup(generatedAppSpecificPassword, exampleEndpoint) {
        const exampleBodyText = JSON.stringify(this.props.tokenConfig.exampleBody).replace(/\\/g, '\\').replace(/'/g, "\\'");
        return "curl -X POST \\\n  -H 'Content-Type: application/json' \\\n  -H 'Authorization: Bearer ".concat(generatedAppSpecificPassword, "' \\\n  -d '").concat(exampleBodyText, "' \\\n  --url '").concat(exampleEndpoint, "'");
    }
}

});
parcelRegister("lKk1f", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd4d6c40d3159599$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $eRsJy = parcelRequire("eRsJy");

var $bVL5h = parcelRequire("bVL5h");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $fd4d6c40d3159599$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $fd4d6c40d3159599$var$CodeBlockContainer = (0, $3UXZ8.default)("div", {
    target: "e75usw40",
    label: "CodeBlockContainer"
})({
    name: "1r2f04i",
    styles: "margin-bottom:10px;"
});
const $fd4d6c40d3159599$var$CodeBlockFooter = (0, $3UXZ8.default)("div", {
    target: "e75usw41",
    label: "CodeBlockFooter"
})({
    name: "k008qs",
    styles: "display:flex;"
});
const $fd4d6c40d3159599$var$CopyMessageContainer = (0, $3UXZ8.default)("div", {
    target: "e75usw42",
    label: "CopyMessageContainer"
})({
    name: "11qjisw",
    styles: "flex:1 1 auto;"
});
const $fd4d6c40d3159599$var$CopyButtonContainer = (0, $3UXZ8.default)("div", {
    target: "e75usw43",
    label: "CopyButtonContainer"
})({
    name: "losqtr",
    styles: "flex:0 0 auto;margin:auto;"
});
class $fd4d6c40d3159599$var$CodeBlock extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "tooltipTimeoutId", undefined);
        (0, $5zQU9.default)(this, "state", {
            tooltipVisible: false
        });
        (0, $5zQU9.default)(this, "copyValue", ()=>{
            const { text: text } = this.props;
            return (0, (/*@__PURE__*/$parcel$interopDefault($bVL5h))).copy(text).then(()=>{
                if (this.tooltipTimeoutId) clearTimeout(this.tooltipTimeoutId);
                this.tooltipTimeoutId = setTimeout(()=>this.setState({
                        tooltipVisible: false
                    }), 2500);
                this.setState({
                    tooltipVisible: true
                });
            });
        });
    }
    componentWillUnmount() {
        if (this.tooltipTimeoutId) clearTimeout(this.tooltipTimeoutId);
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
            children: [
                this.props.label ? /*#__PURE__*/ (0, $lHkHI.jsx)($fd4d6c40d3159599$var$CodeBlockContainer, {
                    children: this.props.label
                }) : null,
                /*#__PURE__*/ (0, $lHkHI.jsx)("textarea", {
                    children: this.props.text
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)($fd4d6c40d3159599$var$CodeBlockFooter, {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)($fd4d6c40d3159599$var$CopyMessageContainer, {
                            children: this.props.copyMessage
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)($fd4d6c40d3159599$var$CopyButtonContainer, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eRsJy.default), {
                                content: "Copied",
                                isOpen: this.state.tooltipVisible,
                                position: "right middle",
                                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                                    onClick: this.copyValue,
                                    appearance: "link",
                                    children: "Copy"
                                })
                            })
                        })
                    ]
                })
            ]
        });
    }
}
var $fd4d6c40d3159599$export$2e2bcd8739ae039 = $fd4d6c40d3159599$var$CodeBlock;

});
parcelRegister("bVL5h", function(module, exports) {
//  Import support https://stackoverflow.com/questions/13673346/supporting-both-commonjs-and-amd
(function(name, definition) {
    module.exports = definition();
})("clipboard", function() {
    if (typeof document === 'undefined' || !document.addEventListener) return null;
    var clipboard = {};
    clipboard.copy = function() {
        var _intercept = false;
        var _data = null; // Map from data type (e.g. "text/html") to value.
        var _bogusSelection = false;
        function cleanup() {
            _intercept = false;
            _data = null;
            if (_bogusSelection) window.getSelection().removeAllRanges();
            _bogusSelection = false;
        }
        document.addEventListener("copy", function(e) {
            if (_intercept) {
                for(var key in _data)e.clipboardData.setData(key, _data[key]);
                e.preventDefault();
            }
        });
        // Workaround for Safari: https://bugs.webkit.org/show_bug.cgi?id=156529
        function bogusSelect() {
            var sel = document.getSelection();
            // If "nothing" is selected...
            if (!document.queryCommandEnabled("copy") && sel.isCollapsed) {
                // ... temporarily select the entire body.
                //
                // We select the entire body because:
                // - it's guaranteed to exist,
                // - it works (unlike, say, document.head, or phantom element that is
                //   not inserted into the DOM),
                // - it doesn't seem to flicker (due to the synchronous copy event), and
                // - it avoids modifying the DOM (can trigger mutation observers).
                //
                // Because we can't do proper feature detection (we already checked
                // document.queryCommandEnabled("copy") , which actually gives a false
                // negative for Blink when nothing is selected) and UA sniffing is not
                // reliable (a lot of UA strings contain "Safari"), this will also
                // happen for some browsers other than Safari. :-()
                var range = document.createRange();
                range.selectNodeContents(document.body);
                sel.removeAllRanges();
                sel.addRange(range);
                _bogusSelection = true;
            }
        }
        return function(data) {
            return new Promise(function(resolve, reject) {
                _intercept = true;
                if (typeof data === "string") _data = {
                    "text/plain": data
                };
                else if (data instanceof Node) _data = {
                    "text/html": new XMLSerializer().serializeToString(data)
                };
                else if (data instanceof Object) _data = data;
                else reject("Invalid data type. Must be string, DOM node, or an object mapping MIME types to strings.");
                function triggerCopy(tryBogusSelect) {
                    try {
                        if (document.execCommand("copy")) {
                            // document.execCommand is synchronous: http://www.w3.org/TR/2015/WD-clipboard-apis-20150421/#integration-with-rich-text-editing-apis
                            // So we can call resolve() back here.
                            cleanup();
                            resolve();
                        } else if (!tryBogusSelect) {
                            bogusSelect();
                            triggerCopy(true);
                        } else {
                            cleanup();
                            throw new Error("Unable to copy. Perhaps it's not available in your browser?");
                        }
                    } catch (e) {
                        cleanup();
                        reject(e);
                    }
                }
                triggerCopy(false);
            });
        };
    }();
    clipboard.paste = function() {
        var _intercept = false;
        var _resolve;
        var _dataType;
        document.addEventListener("paste", function(e) {
            if (_intercept) {
                _intercept = false;
                e.preventDefault();
                var resolve = _resolve;
                _resolve = null;
                resolve(e.clipboardData.getData(_dataType));
            }
        });
        return function(dataType) {
            return new Promise(function(resolve, reject) {
                _intercept = true;
                _resolve = resolve;
                _dataType = dataType || "text/plain";
                try {
                    if (!document.execCommand("paste")) {
                        _intercept = false;
                        reject(new Error("Unable to paste. Pasting only works in Internet Explorer at the moment."));
                    }
                } catch (e) {
                    _intercept = false;
                    reject(new Error(e));
                }
            });
        };
    }();
    // Handle IE behaviour.
    if (typeof ClipboardEvent === "undefined" && typeof window.clipboardData !== "undefined" && typeof window.clipboardData.setData !== "undefined") {
        /*! promise-polyfill 2.0.1 */ (function(a) {
            function b(a, b) {
                return function() {
                    a.apply(b, arguments);
                };
            }
            function c(a) {
                if ("object" != typeof this) throw new TypeError("Promises must be constructed via new");
                if ("function" != typeof a) throw new TypeError("not a function");
                this._state = null, this._value = null, this._deferreds = [], i(a, b(e, this), b(f, this));
            }
            function d(a) {
                var b = this;
                return null === this._state ? void this._deferreds.push(a) : void j(function() {
                    var c = b._state ? a.onFulfilled : a.onRejected;
                    if (null === c) return void (b._state ? a.resolve : a.reject)(b._value);
                    var d;
                    try {
                        d = c(b._value);
                    } catch (e) {
                        return void a.reject(e);
                    }
                    a.resolve(d);
                });
            }
            function e(a) {
                try {
                    if (a === this) throw new TypeError("A promise cannot be resolved with itself.");
                    if (a && ("object" == typeof a || "function" == typeof a)) {
                        var c = a.then;
                        if ("function" == typeof c) return void i(b(c, a), b(e, this), b(f, this));
                    }
                    this._state = !0, this._value = a, g.call(this);
                } catch (d) {
                    f.call(this, d);
                }
            }
            function f(a) {
                this._state = !1, this._value = a, g.call(this);
            }
            function g() {
                for(var a = 0, b = this._deferreds.length; b > a; a++)d.call(this, this._deferreds[a]);
                this._deferreds = null;
            }
            function h(a, b, c, d) {
                this.onFulfilled = "function" == typeof a ? a : null, this.onRejected = "function" == typeof b ? b : null, this.resolve = c, this.reject = d;
            }
            function i(a, b, c) {
                var d = !1;
                try {
                    a(function(a) {
                        d || (d = !0, b(a));
                    }, function(a) {
                        d || (d = !0, c(a));
                    });
                } catch (e) {
                    if (d) return;
                    d = !0, c(e);
                }
            }
            var j = c.immediateFn || "function" == typeof setImmediate && setImmediate || function(a) {
                setTimeout(a, 1);
            }, k = Array.isArray || function(a) {
                return "[object Array]" === Object.prototype.toString.call(a);
            };
            c.prototype["catch"] = function(a) {
                return this.then(null, a);
            }, c.prototype.then = function(a, b) {
                var e = this;
                return new c(function(c, f) {
                    d.call(e, new h(a, b, c, f));
                });
            }, c.all = function() {
                var a = Array.prototype.slice.call(1 === arguments.length && k(arguments[0]) ? arguments[0] : arguments);
                return new c(function(b, c) {
                    function d(f, g) {
                        try {
                            if (g && ("object" == typeof g || "function" == typeof g)) {
                                var h = g.then;
                                if ("function" == typeof h) return void h.call(g, function(a) {
                                    d(f, a);
                                }, c);
                            }
                            a[f] = g, 0 === --e && b(a);
                        } catch (i) {
                            c(i);
                        }
                    }
                    if (0 === a.length) return b([]);
                    for(var e = a.length, f = 0; f < a.length; f++)d(f, a[f]);
                });
            }, c.resolve = function(a) {
                return a && "object" == typeof a && a.constructor === c ? a : new c(function(b) {
                    b(a);
                });
            }, c.reject = function(a) {
                return new c(function(b, c) {
                    c(a);
                });
            }, c.race = function(a) {
                return new c(function(b, c) {
                    for(var d = 0, e = a.length; e > d; d++)a[d].then(b, c);
                });
            }, (0, module.exports) ? module.exports = c : a.Promise || (a.Promise = c);
        })(this);
        clipboard.copy = function(data) {
            return new Promise(function(resolve, reject) {
                // IE supports string and URL types: https://msdn.microsoft.com/en-us/library/ms536744(v=vs.85).aspx
                // We only support the string type for now.
                if (typeof data !== "string" && !("text/plain" in data)) throw new Error("You must provide a text/plain type.");
                var strData = typeof data === "string" ? data : data["text/plain"];
                var copySucceeded = window.clipboardData.setData("Text", strData);
                if (copySucceeded) resolve();
                else reject(new Error("Copying was rejected."));
            });
        };
        clipboard.paste = function() {
            return new Promise(function(resolve, reject) {
                var strData = window.clipboardData.getData("Text");
                if (strData) resolve(strData);
                else // The user rejected the paste request.
                reject(new Error("Pasting was rejected."));
            });
        };
    }
    return clipboard;
});

});


parcelRegister("3BnoT", function(module, exports) {

$parcel$export(module.exports, "default", () => $29f6faa1928355fb$export$2e2bcd8739ae039);

var $9eIgo = parcelRequire("9eIgo");
function $29f6faa1928355fb$export$2e2bcd8739ae039(installStatus, inProgress, complete) {
    switch(installStatus.type){
        case 0, $9eIgo.IN_PROGRESS_INSTALL_STATUS:
            return inProgress(installStatus);
        case 0, $9eIgo.COMPLETE_INSTALL_STATUS:
            return complete(installStatus);
        default:
            // Flow compile-time validation that we've handled every show app specific password install status
            // prettier-ignore
            installStatus;
            return undefined;
    }
}

});


parcelRegister("ckRaV", function(module, exports) {

$parcel$export(module.exports, "default", () => $8fb099ce1913925d$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bPByu = parcelRequire("bPByu");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $lHkHI = parcelRequire("lHkHI");
const $8fb099ce1913925d$var$PRIMARY_CTA_LABEL = 'Done';
class $8fb099ce1913925d$export$396aa35708c4c1c4 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "closeInstallDialog", ()=>{
            this.props.fireAnalyticsEvent({
                eventType: (0, $gaiog.ButtonClickedEvent),
                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_TOKEN_DONE),
                attributes: {
                    label: $8fb099ce1913925d$var$PRIMARY_CTA_LABEL
                }
            });
            this.props.closeInstallDialog();
        });
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $bPByu.default), {
                onClick: this.closeInstallDialog,
                children: $8fb099ce1913925d$var$PRIMARY_CTA_LABEL
            }));
    }
}
var $8fb099ce1913925d$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($8fb099ce1913925d$export$396aa35708c4c1c4);

});



parcelRegister("6Xpkk", function(module, exports) {

$parcel$export(module.exports, "default", () => $510be62644b0f66e$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
parcelRequire("eUqFw");

var $gIQkA = parcelRequire("gIQkA");

var $hsaiM = parcelRequire("hsaiM");

var $h6MeC = parcelRequire("h6MeC");

var $lHkHI = parcelRequire("lHkHI");
const $510be62644b0f66e$var$resolveDialogDetermining = (_ref)=>{
    let { closeInstallDialog: closeInstallDialog, determiningInstallMode: determiningInstallMode, hostConfig: hostConfig, featureFlags: featureFlags } = _ref;
    return {
        analyticsSourceModal: (0, $gIQkA.ANALYTICS_MODAL_DETERMINING),
        content: null,
        heading: determiningInstallMode.error ? 'Error' : 'Loading...',
        footerRight: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $h6MeC.default), {
            isDisabled: false,
            onClick: closeInstallDialog,
            children: "Cancel"
        }),
        preventDialogClosing: false,
        errorDetails: determiningInstallMode.error ? (0, $bWAru.Option).some((0, $hsaiM.getErrorDetails)(determiningInstallMode.error, hostConfig, {
            showCustomBackendErrorsFromUpm: featureFlags.showCustomBackendErrorsFromUpm
        })) : (0, $bWAru.Option).none()
    };
};
var $510be62644b0f66e$export$2e2bcd8739ae039 = $510be62644b0f66e$var$resolveDialogDetermining;

});

parcelRegister("AM6UE", function(module, exports) {

$parcel$export(module.exports, "default", () => $06e8aea66286374a$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
parcelRequire("eUqFw");

var $gIQkA = parcelRequire("gIQkA");

var $9eIgo = parcelRequire("9eIgo");

var $hsaiM = parcelRequire("hsaiM");

var $jbxVX = parcelRequire("jbxVX");

var $jnM8o = parcelRequire("jnM8o");

var $2bemU = parcelRequire("2bemU");

var $lgdWX = parcelRequire("lgdWX");

var $dQ55f = parcelRequire("dQ55f");

var $659YR = parcelRequire("659YR");

var $lHkHI = parcelRequire("lHkHI");
const $06e8aea66286374a$var$resolveDialogInstallByManualUrl = (_ref)=>{
    let { clearInstallableAppByManualUrl: clearInstallableAppByManualUrl, closeInstallDialog: closeInstallDialog, context: context, fetchInstallableAppByManualUrl: fetchInstallableAppByManualUrl, hostConfig: hostConfig, hostInfo: hostInfo, installableAppByManualUrlInstallMode: installableAppByManualUrlInstallMode, installApp: installApp, links: links, openManualUrlInstallDialog: openManualUrlInstallDialog, openAppSpecificPasswordDialog: openAppSpecificPasswordDialog, scopesLookup: scopesLookup, featureFlags: featureFlags } = _ref;
    const fetchInstallableAppErrorDetails = installableAppByManualUrlInstallMode.installableAppByManualUrl.flatMap((iabmu)=>iabmu.installableApp.flatMap((ia)=>ia.swap().map((error)=>(0, $hsaiM.getErrorDetails)(error, hostConfig, {
                    showCustomBackendErrorsFromUpm: featureFlags.showCustomBackendErrorsFromUpm
                })).toOption()));
    return {
        analyticsSourceModal: (0, $gIQkA.ANALYTICS_MODAL_CUSTOM_INSTALL),
        content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jbxVX.default), {
            installMode: installableAppByManualUrlInstallMode,
            openManualUrlInstallDialog: openManualUrlInstallDialog,
            openAppSpecificPasswordDialog: openAppSpecificPasswordDialog,
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $659YR.default), {
                context: context,
                clearInstallableAppByManualUrl: clearInstallableAppByManualUrl,
                fetchInstallableAppByManualUrl: fetchInstallableAppByManualUrl,
                fetchInstallableAppErrorDetails: fetchInstallableAppErrorDetails,
                hostConfig: hostConfig,
                installableAppByManualUrlInstallMode: installableAppByManualUrlInstallMode,
                links: links,
                scopesLookup: scopesLookup
            })
        }),
        heading: 'Custom app',
        footerLeft: installableAppByManualUrlInstallMode.installableAppByManualUrl.flatMap((iabmu)=>iabmu.installableApp).flatMap((ia)=>ia.toOption()).map((installableApp)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
            (0, $lHkHI.jsx)((0, $jnM8o.default), {
                context: context,
                links: links,
                marketplaceAppDetails: installableApp.marketplaceAppDetails
            })).getOrElse(),
        footerCenter: installableAppByManualUrlInstallMode.installableAppByManualUrl.flatMap((iabmu)=>iabmu.installableApp.flatMap((ia)=>ia.toOption()).map((ia)=>// eslint-disable-next-line react/jsx-key
                iabmu.installedApp.fold(()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $dQ55f.default), {
                        context: context,
                        installableAppId: iabmu.installableAppByUrlId,
                        marketplaceAppDetails: ia.marketplaceAppDetails
                    }), ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $2bemU.default), {
                        hostConfig: hostConfig
                    })))).getOrElse(),
        footerRight: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lgdWX.default), {
            closeInstallDialog: closeInstallDialog,
            context: context,
            hostConfig: hostConfig,
            installApp: installApp,
            hostInfo: hostInfo,
            installableAppInstallMode: installableAppByManualUrlInstallMode,
            mpacBaseUrl: "mpacBaseUrl",
            isInstallInProgress: ()=>false // TODO: Delete unused DialogInstallByManualUrl
        }),
        preventDialogClosing: installableAppByManualUrlInstallMode.installableAppByManualUrl.exists((iabmu)=>(0, $9eIgo.isInstallStatusLoading)(iabmu.status)),
        errorDetails: installableAppByManualUrlInstallMode.installableAppByManualUrl.flatMap((iabmu)=>(0, $9eIgo.foldInstallStatus)(iabmu.status, ()=>(0, $bWAru.Option).empty(), ()=>(0, $bWAru.Option).empty(), (complete)=>complete.result.fold((error)=>(0, $bWAru.Option).some((0, $hsaiM.getErrorDetails)(error, hostConfig, {
                        showCustomBackendErrorsFromUpm: featureFlags.showCustomBackendErrorsFromUpm
                    })), ()=>(0, $bWAru.Option).empty()))).orElseL(()=>fetchInstallableAppErrorDetails.filter((ed)=>!ed.translation.validationError))
    };
};
var $06e8aea66286374a$export$2e2bcd8739ae039 = $06e8aea66286374a$var$resolveDialogInstallByManualUrl;

});
parcelRegister("dQ55f", function(module, exports) {

$parcel$export(module.exports, "default", () => $a134132f9584d8e1$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $l501X = parcelRequire("l501X");

var $eUqFw = parcelRequire("eUqFw");

var $8KCrk = parcelRequire("8KCrk");

var $7Uh51 = parcelRequire("7Uh51");

var $lHkHI = parcelRequire("lHkHI");
const $a134132f9584d8e1$export$42a852a2b6b56249 = (0, $3UXZ8.default)("div", {
    target: "e6rd3vp0",
    label: "Container"
})("background-color:", "var(--ds-background-accent-gray-subtlest, ".concat((0, $j0gMm.N20), ")"), ";padding:10px var(--ds-space-250, 20px);font-size:11px;line-height:1.5;");
const $a134132f9584d8e1$var$marketplaceTermsOfUseLink = 'https://www.atlassian.com/licensing/marketplace/termsofuse/';
class $a134132f9584d8e1$export$c2889cb37ee850c1 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "privacyPolicyAnalytics", ()=>this.fireLinkUIAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_PRIVACY_POLICY)));
        (0, $5zQU9.default)(this, "eulaAnalytics", ()=>this.fireLinkUIAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_TERMS_OF_USE)));
        (0, $5zQU9.default)(this, "marketplaceTermsOfUseAnalytics", ()=>this.fireLinkUIAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_MARKETPLACE_TERMS_OF_USE)));
        (0, $5zQU9.default)(this, "fireLinkUIAnalyticsEvent", (actionSubjectId)=>this.props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstallableAppIdentifier)((0, $gaiog.ButtonClickedEvent), actionSubjectId, this.props.installableAppId).toObject()));
        (0, $5zQU9.default)(this, "marketplaceTermsOfUseMsg", (appName)=>/*#__PURE__*/ (0, $lHkHI.jsxs)("span", {
                children: [
                    "By installing this app, you permit Atlassian to share anonymized data with ",
                    appName,
                    ". You agree to Atlassian Marketplace's",
                    ' ',
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                        href: $a134132f9584d8e1$var$marketplaceTermsOfUseLink,
                        onClick: this.marketplaceTermsOfUseAnalytics,
                        children: "terms of use"
                    })
                ]
            }));
    }
    render() {
        const { marketplaceAppDetails: marketplaceAppDetails } = this.props;
        const appName = marketplaceAppDetails.name;
        const marketplaceTermsOfUseMsg = this.marketplaceTermsOfUseMsg(appName);
        const vendorType = marketplaceAppDetails.vendor.vendorType;
        const vendorName = marketplaceAppDetails.vendor.name;
        const privacyPolicy = marketplaceAppDetails.privacyPolicy;
        const eula = marketplaceAppDetails.eula;
        if (vendorType === 'internal') return null;
        if (!vendorName) return /*#__PURE__*/ (0, $lHkHI.jsx)($a134132f9584d8e1$export$42a852a2b6b56249, {
            children: "This third party vendor has not provided a privacy policy or terms of use. Atlassian's Privacy Policy is not applicable to the use of this app."
        });
        if (privacyPolicy && eula) return /*#__PURE__*/ (0, $lHkHI.jsxs)($a134132f9584d8e1$export$42a852a2b6b56249, {
            children: [
                marketplaceTermsOfUseMsg,
                " and ",
                vendorName,
                "'s",
                ' ',
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                    href: privacyPolicy,
                    onClick: this.privacyPolicyAnalytics,
                    children: "privacy policy"
                }),
                ' ',
                "and",
                ' ',
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                    href: eula,
                    onClick: this.eulaAnalytics,
                    children: "terms of use"
                }),
                "."
            ]
        });
        else if (privacyPolicy && !eula) return /*#__PURE__*/ (0, $lHkHI.jsxs)($a134132f9584d8e1$export$42a852a2b6b56249, {
            children: [
                marketplaceTermsOfUseMsg,
                " and ",
                vendorName,
                "'s",
                ' ',
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                    href: privacyPolicy,
                    onClick: this.privacyPolicyAnalytics,
                    children: "privacy policy"
                }),
                ". ",
                vendorName,
                " has not provided any terms of use explaining your rights to use the app or how ",
                vendorName,
                " may restrict your use of the app. By installing this app, you acknowledge and agree that ",
                vendorName,
                " may restrict or prohibit your use of the app at any time."
            ]
        });
        else if (eula && !privacyPolicy) return /*#__PURE__*/ (0, $lHkHI.jsxs)($a134132f9584d8e1$export$42a852a2b6b56249, {
            children: [
                marketplaceTermsOfUseMsg,
                " and ",
                vendorName,
                "'s",
                ' ',
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l501X.default), {
                    href: eula,
                    onClick: this.eulaAnalytics,
                    children: "terms of use"
                }),
                ". ",
                vendorName,
                " has not provided a privacy policy explaining how this app will use your data. By installing this app, you acknowledge and agree this app may have unrestricted use of your data. If you do not agree, you should not install this app."
            ]
        });
        else return /*#__PURE__*/ (0, $lHkHI.jsxs)($a134132f9584d8e1$export$42a852a2b6b56249, {
            children: [
                marketplaceTermsOfUseMsg,
                ". This vendor has not provided terms of use or a privacy policy explaining how they will use your data. By installing this app, you acknowledge and agree this app may have unrestricted use of your data and/or ",
                vendorName,
                " may restrict or prohibit your use of the app at any time. If you do not agree, you should not install this app."
            ]
        });
    }
}
var $a134132f9584d8e1$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($a134132f9584d8e1$export$c2889cb37ee850c1);

});

parcelRegister("659YR", function(module, exports) {

$parcel$export(module.exports, "default", () => $46daf3a017acbb52$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $jGAG9 = parcelRequire("jGAG9");

var $1Tfhj = parcelRequire("1Tfhj");

var $gykb8 = parcelRequire("gykb8");
var $cjFit = parcelRequire("cjFit");

var $dxIU5 = parcelRequire("dxIU5");

var $eUqFw = parcelRequire("eUqFw");

var $ifMZN = parcelRequire("ifMZN");

var $9eIgo = parcelRequire("9eIgo");

var $izRAm = parcelRequire("izRAm");

var $jooEA = parcelRequire("jooEA");

var $lHkHI = parcelRequire("lHkHI");
function $46daf3a017acbb52$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $46daf3a017acbb52$export$9fea3e4644be20cb = (0, $3UXZ8.default)("div", {
    target: "ehc9x320",
    label: "ScopesDiv"
})({
    name: "493ori",
    styles: "margin-top:25px;"
});
const $46daf3a017acbb52$export$a67c0bc59081311a = (0, $3UXZ8.default)("div", {
    target: "ehc9x321",
    label: "HelpText"
})({
    name: "gt4wuf",
    styles: "margin-top:var(--ds-space-250, 20px);"
});
const $46daf3a017acbb52$export$4dbdf9a797880594 = (0, $3UXZ8.default)("div", {
    target: "ehc9x322",
    label: "InstallUrlInputContainer"
})({
    name: "qxh7fn",
    styles: "width:500px;"
});
class $46daf3a017acbb52$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            url: null
        });
        (0, $5zQU9.default)(this, "onRequestNewUrl", (0, (/*@__PURE__*/$parcel$interopDefault($dxIU5)))((url)=>{
            if (url) this.props.fetchInstallableAppByManualUrl({
                context: this.props.context,
                installableAppByUrlId: (0, $ifMZN.makeInstallableAppByUrlIdentifier)({
                    url: url
                })
            });
            else this.props.clearInstallableAppByManualUrl();
        }, 500));
        (0, $5zQU9.default)(this, "onUrlChange", (e)=>{
            const url = (0, $cjFit.nonEmptyString)(e.target.value);
            this.setState({
                url: url
            });
            this.onRequestNewUrl(url);
        });
        (0, $5zQU9.default)(this, "render", ()=>{
            const isInstallationUrlInvalid = this.props.fetchInstallableAppErrorDetails.exists((ed)=>!!ed.translation.validationError);
            return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($46daf3a017acbb52$export$a67c0bc59081311a, {
                        children: [
                            "Paste the installation URL created via",
                            ' ',
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                                href: "https://developer.atlassian.com/apps",
                                rel: "noopener noreferrer",
                                target: "_blank",
                                children: "developer.atlassian.com/apps"
                            }),
                            ". This method allows you to develop and test apps before publishing them, or release an app privately to your organization."
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($46daf3a017acbb52$export$4dbdf9a797880594, {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1Tfhj.default), {
                                isDisabled: this.props.installableAppByManualUrlInstallMode.installableAppByManualUrl.exists((iabmu)=>(0, $9eIgo.isInstallStatusLoading)(iabmu.status)),
                                placeholder: "Installation URL",
                                isInvalid: isInstallationUrlInvalid,
                                onChange: this.onUrlChange,
                                value: this.state.url || ''
                            }),
                            this.props.fetchInstallableAppErrorDetails.map((ed)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
                                (0, $lHkHI.jsx)((0, $jGAG9.ErrorMessage), {
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jooEA.default), {
                                        errorDetails: ed
                                    })
                                })).orNull()
                        ]
                    }),
                    this.props.installableAppByManualUrlInstallMode.installableAppByManualUrl.map((iabmu)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
                        (0, $lHkHI.jsx)($46daf3a017acbb52$export$9fea3e4644be20cb, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $izRAm.default), {
                                installableApp: iabmu.installableApp,
                                links: this.props.links,
                                scopesLookup: this.props.scopesLookup
                            })
                        })).orNull()
                ]
            });
        });
    }
}

});
parcelRegister("jGAG9", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $53eb0482a10e7274$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $53eb0482a10e7274$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $53eb0482a10e7274$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $53eb0482a10e7274$export$ec445f12f63100a5);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $e9tYd = parcelRequire("e9tYd");

var $kxdTJ = parcelRequire("kxdTJ");


var $474Xg = parcelRequire("474Xg");
function $53eb0482a10e7274$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $53eb0482a10e7274$var$messageStyles = {
    name: "drnq1s",
    styles: "display:flex;justify-content:baseline;gap:var(--ds-space-075, 6px);font:var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif);margin-block-start:var(--ds-space-050, 4px)"
};
const $53eb0482a10e7274$var$messageAppearanceStyles = {
    default: /*#__PURE__*/ (0, $byn9U.css)({
        color: `var(--ds-text-subtlest, ${(0, $ab6d6432a4c55680$export$f563ee71e9ee74cd)})`
    }),
    error: {
        name: "g75jq6",
        styles: "color:var(--ds-text-danger, #AE2A19)"
    },
    valid: {
        name: "118r6eb",
        styles: "color:var(--ds-text-success, #216E4E)"
    }
};
const $53eb0482a10e7274$var$iconWrapperStyles = {
    name: "x5c876",
    styles: "display:flex;height:16px;align-items:center"
};
const $53eb0482a10e7274$var$IconWrapper = ({ children: children })=>{
    return /*#__PURE__*/ (0, $byn9U.jsx)("span", {
        css: $53eb0482a10e7274$var$iconWrapperStyles
    }, children);
};
const $53eb0482a10e7274$var$messageIcons = {
    error: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($e9tYd))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $byn9U.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kxdTJ))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success"
    })
};
const $53eb0482a10e7274$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $53eb0482a10e7274$var$messageIcons[appearance];
    const messageRef = (0, $eUqFw.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $eUqFw.useState)(false);
    const { isWrapper: isWrapper } = (0, $eUqFw.useContext)($53eb0482a10e7274$export$579aef2c392a54d4);
    (0, $eUqFw.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $byn9U.jsx)("span", null, children);
    return /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        css: [
            $53eb0482a10e7274$var$messageStyles,
            $53eb0482a10e7274$var$messageAppearanceStyles[appearance]
        ],
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined
    }, icon && /*#__PURE__*/ (0, $byn9U.jsx)($53eb0482a10e7274$var$IconWrapper, null, icon), content);
};
const $53eb0482a10e7274$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $474Xg.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($53eb0482a10e7274$var$Message, {
            fieldId: fieldId ? `${fieldId}-helper` : undefined,
            testId: testId
        }, children));
const $53eb0482a10e7274$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $474Xg.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($53eb0482a10e7274$var$Message, {
            appearance: "error",
            fieldId: fieldId ? `${fieldId}-error` : undefined,
            testId: testId
        }, children));
const $53eb0482a10e7274$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $byn9U.jsx)((0, $474Xg.FieldId).Consumer, null, (fieldId)=>/*#__PURE__*/ (0, $byn9U.jsx)($53eb0482a10e7274$var$Message, {
            appearance: "valid",
            fieldId: fieldId ? `${fieldId}-valid` : undefined,
            testId: testId
        }, children));
const $53eb0482a10e7274$export$579aef2c392a54d4 = /*#__PURE__*/ (0, $eUqFw.createContext)({
    isWrapper: false
});
const $53eb0482a10e7274$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $byn9U.jsx)($53eb0482a10e7274$export$579aef2c392a54d4.Provider, {
        value: contextValue
    }, /*#__PURE__*/ (0, $byn9U.jsx)("div", {
        "aria-live": "polite",
        "data-testid": "message-wrapper"
    }, children));
};

});
parcelRegister("e9tYd", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f0499610e65a8e7f9250a345ef46c32f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a4d9276f30c46060$var$_react = $a4d9276f30c46060$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $a4d9276f30c46060$var$_error = $a4d9276f30c46060$var$_interopRequireDefault((parcelRequire("eL70m")));

var $a4d9276f30c46060$var$_error2 = $a4d9276f30c46060$var$_interopRequireDefault((parcelRequire("gEwvS")));
function $a4d9276f30c46060$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a4d9276f30c46060$var$ErrorIcon = (props)=>/*#__PURE__*/ $a4d9276f30c46060$var$_react.default.createElement($a4d9276f30c46060$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $a4d9276f30c46060$var$_error2.default
    }, props));
$a4d9276f30c46060$var$ErrorIcon.Name = 'ErrorIconMigration';
var $a4d9276f30c46060$var$_default = module.exports.default = $a4d9276f30c46060$var$ErrorIcon;

});
parcelRegister("eL70m", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::fbdb3f80d4bcdf634ad3eb6ad4125bf1>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $abeae37fddc1fb9b$var$_react = $abeae37fddc1fb9b$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $abeae37fddc1fb9b$var$_UNSAFE_baseNew = $abeae37fddc1fb9b$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $abeae37fddc1fb9b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $abeae37fddc1fb9b$var$ErrorIcon = (props)=>/*#__PURE__*/ $abeae37fddc1fb9b$var$_react.default.createElement($abeae37fddc1fb9b$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$abeae37fddc1fb9b$var$ErrorIcon.displayName = 'ErrorIcon';
var $abeae37fddc1fb9b$var$_default = module.exports.default = $abeae37fddc1fb9b$var$ErrorIcon;

});


parcelRegister("kxdTJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c91b2071a3b78298cdb1ab35dcf13197>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef31ab91bc0836e7$var$_react = $ef31ab91bc0836e7$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $ef31ab91bc0836e7$var$_success = $ef31ab91bc0836e7$var$_interopRequireDefault((parcelRequire("jM363")));

var $ef31ab91bc0836e7$var$_success2 = $ef31ab91bc0836e7$var$_interopRequireDefault((parcelRequire("3uFOc")));
function $ef31ab91bc0836e7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef31ab91bc0836e7$var$SuccessIcon = (props)=>/*#__PURE__*/ $ef31ab91bc0836e7$var$_react.default.createElement($ef31ab91bc0836e7$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $ef31ab91bc0836e7$var$_success2.default
    }, props));
$ef31ab91bc0836e7$var$SuccessIcon.Name = 'SuccessIconMigration';
var $ef31ab91bc0836e7$var$_default = module.exports.default = $ef31ab91bc0836e7$var$SuccessIcon;

});
parcelRegister("jM363", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f46e0408994ee0eebe07fdde2651636>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e654e6edc400bd89$var$_react = $e654e6edc400bd89$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $e654e6edc400bd89$var$_UNSAFE_baseNew = $e654e6edc400bd89$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $e654e6edc400bd89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "Success".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e654e6edc400bd89$var$SuccessIcon = (props)=>/*#__PURE__*/ $e654e6edc400bd89$var$_react.default.createElement($e654e6edc400bd89$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$e654e6edc400bd89$var$SuccessIcon.displayName = 'SuccessIcon';
var $e654e6edc400bd89$var$_default = module.exports.default = $e654e6edc400bd89$var$SuccessIcon;

});

parcelRegister("3uFOc", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $28b49ac5064cf535$var$_react = $28b49ac5064cf535$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $28b49ac5064cf535$var$_success = $28b49ac5064cf535$var$_interopRequireDefault((parcelRequire("iMOte")));
function $28b49ac5064cf535$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $28b49ac5064cf535$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $28b49ac5064cf535$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $28b49ac5064cf535$var$_success.default
    }));
$28b49ac5064cf535$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $28b49ac5064cf535$var$_default = module.exports.default = $28b49ac5064cf535$var$EditorSuccessIcon;

});





parcelRegister("kZJEl", function(module, exports) {

$parcel$export(module.exports, "default", () => $f48cea3834e343e4$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
parcelRequire("eUqFw");

var $gIQkA = parcelRequire("gIQkA");

var $9eIgo = parcelRequire("9eIgo");

var $hsaiM = parcelRequire("hsaiM");

var $jnM8o = parcelRequire("jnM8o");

var $dQ55f = parcelRequire("dQ55f");

var $gqV0E = parcelRequire("gqV0E");

var $djGZ2 = parcelRequire("djGZ2");

var $lHkHI = parcelRequire("lHkHI");
const $f48cea3834e343e4$var$resolveDialogUpgrade = (_ref)=>{
    let { closeInstallDialog: closeInstallDialog, context: context, hostConfig: hostConfig, links: links, scopesLookup: scopesLookup, upgradeApp: upgradeApp, upgradeInstallMode: upgradeInstallMode, featureFlags: featureFlags } = _ref;
    return {
        analyticsSourceModal: (0, $gIQkA.ANALYTICS_MODAL_UPGRADE),
        content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gqV0E.default), {
            installableAppToUpgradeTo: upgradeInstallMode.installableAppToUpgradeTo,
            links: links,
            scopesLookup: scopesLookup
        }),
        heading: 'App update',
        footerLeft: upgradeInstallMode.installableAppToUpgradeTo.flatMap((ia)=>ia.toOption()).map((installableAp)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
            (0, $lHkHI.jsx)((0, $jnM8o.default), {
                context: context,
                links: links,
                marketplaceAppDetails: installableAp.marketplaceAppDetails
            })).getOrElse(),
        footerCenter: upgradeInstallMode.installableAppToUpgradeTo.flatMap((ia)=>ia.toOption()).map((ia)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
            (0, $lHkHI.jsx)((0, $dQ55f.default), {
                context: context,
                installableAppId: upgradeInstallMode.installableAppByKeyId,
                marketplaceAppDetails: ia.marketplaceAppDetails
            })).getOrElse(),
        footerRight: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $djGZ2.default), {
            closeInstallDialog: closeInstallDialog,
            context: context,
            hostConfig: hostConfig,
            upgradeApp: upgradeApp,
            upgradeInstallMode: upgradeInstallMode
        }),
        preventDialogClosing: (0, $9eIgo.isInstallStatusLoading)(upgradeInstallMode.status),
        errorDetails: (0, $9eIgo.foldInstallStatus)(upgradeInstallMode.status, ()=>(0, $bWAru.Option).empty(), ()=>(0, $bWAru.Option).empty(), (complete)=>complete.result.fold((error)=>(0, $bWAru.Option).some((0, $hsaiM.getErrorDetails)(error, hostConfig, {
                    showCustomBackendErrorsFromUpm: featureFlags.showCustomBackendErrorsFromUpm
                })), ()=>(0, $bWAru.Option).empty()))
    };
};
var $f48cea3834e343e4$export$2e2bcd8739ae039 = $f48cea3834e343e4$var$resolveDialogUpgrade;

});
parcelRegister("gqV0E", function(module, exports) {

$parcel$export(module.exports, "default", () => $bf6b4bf77213f98e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $eUqFw = parcelRequire("eUqFw");

var $izRAm = parcelRequire("izRAm");

var $lHkHI = parcelRequire("lHkHI");
function $bf6b4bf77213f98e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $bf6b4bf77213f98e$export$9fea3e4644be20cb = (0, $3UXZ8.default)("div", {
    target: "ewnvbv0",
    label: "ScopesDiv"
})({
    name: "493ori",
    styles: "margin-top:25px;"
});
class $bf6b4bf77213f98e$var$DialogUpgradeContent extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)($bf6b4bf77213f98e$export$9fea3e4644be20cb, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $izRAm.default), {
                    installableApp: this.props.installableAppToUpgradeTo,
                    links: this.props.links,
                    scopesLookup: this.props.scopesLookup
                })
            }));
    }
}
var $bf6b4bf77213f98e$export$2e2bcd8739ae039 = $bf6b4bf77213f98e$var$DialogUpgradeContent;

});

parcelRegister("djGZ2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b1e64543a366f64$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $8KCrk = parcelRequire("8KCrk");

var $7Uh51 = parcelRequire("7Uh51");

var $9eIgo = parcelRequire("9eIgo");

var $9KoF2 = parcelRequire("9KoF2");

var $lHkHI = parcelRequire("lHkHI");
const $9b1e64543a366f64$var$PRIMARY_CTA_LABEL = 'Upgrade';
class $9b1e64543a366f64$export$dffb9b206ada07dc extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "upgradeApp", (installableAppToUpgradeTo)=>()=>{
                this.props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstallableAppIdentifier)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_UPGRADE), this.props.upgradeInstallMode.installableAppByKeyId, {
                    label: $9b1e64543a366f64$var$PRIMARY_CTA_LABEL
                }).toObject());
                this.props.upgradeApp({
                    context: this.props.context,
                    hostConfig: this.props.hostConfig,
                    installedApp: this.props.upgradeInstallMode.installedApp,
                    installableAppByKeyId: this.props.upgradeInstallMode.installableAppByKeyId,
                    installableAppToUpgradeTo: installableAppToUpgradeTo
                });
            });
        (0, $5zQU9.default)(this, "render", ()=>this.props.upgradeInstallMode.installableAppToUpgradeTo.flatMap((ia)=>ia.toOption()).map((ia)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
                (0, $lHkHI.jsx)((0, $9KoF2.default), {
                    closeInstallDialog: this.props.closeInstallDialog,
                    isLoading: (0, $9eIgo.isInstallStatusLoading)(this.props.upgradeInstallMode.status),
                    isPrimaryDisabled: false,
                    onPrimaryCTAClick: this.upgradeApp(ia),
                    primaryCTALabel: $9b1e64543a366f64$var$PRIMARY_CTA_LABEL
                })).getOrElseL(()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $9KoF2.default), {
                    closeInstallDialog: this.props.closeInstallDialog,
                    isLoading: false,
                    isPrimaryDisabled: true,
                    primaryCTALabel: $9b1e64543a366f64$var$PRIMARY_CTA_LABEL
                })));
    }
}
var $9b1e64543a366f64$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($9b1e64543a366f64$export$dffb9b206ada07dc);

});





parcelRegister("lmbZg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8c4f375e3d58242$export$2e2bcd8739ae039);

var $6LpFI = parcelRequire("6LpFI");
var $4iWU0 = parcelRequire("4iWU0");

var $c9Mth = parcelRequire("c9Mth");
parcelRequire("eUqFw");
parcelRequire("jJs3W");
var $6N2vY = parcelRequire("6N2vY");

var $e8LPn = parcelRequire("e8LPn");

var $8bwkw = parcelRequire("8bwkw");

var $40nqT = parcelRequire("40nqT");

var $jC5dB = parcelRequire("jC5dB");

var $bSQ4o = parcelRequire("bSQ4o");

var $jHg79 = parcelRequire("jHg79");

var $eCRRn = parcelRequire("eCRRn");

var $kQ9fC = parcelRequire("kQ9fC");

var $4mQRQ = parcelRequire("4mQRQ");

var $lHkHI = parcelRequire("lHkHI");
const $f8c4f375e3d58242$var$ManageRoutes = (props)=>{
    const mountPath = (0, $jHg79.useMountPath)();
    const dispatch = (0, $6N2vY.useDispatch)();
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $e8LPn.default), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4iWU0.RouteWithContext), {
                exact: true,
                path: (0, $c9Mth).joinPathNames([
                    mountPath,
                    (0, $40nqT.manageRoute).path
                ]),
                render: (routeProps)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $kQ9fC.default), {
                        bootstrapConfig: props.bootstrapConfig,
                        currentUserId: props.currentUserId,
                        history: routeProps.history,
                        hostConfig: props.hostConfig,
                        links: props.links,
                        onRendered: props.onRendered,
                        selectedContext: props.selectedContext,
                        mountPath: mountPath
                    })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4iWU0.RouteWithContext), {
                exact: true,
                path: (0, $c9Mth).joinPathNames([
                    mountPath,
                    (0, $40nqT.manageAppRequestsRoute).path
                ]),
                render: (routeProps)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $6LpFI.FlagsImplementationProvider), {
                        value: {
                            showFlag: (flag)=>dispatch((0, $8bwkw.addFlag)({
                                    flag: (0, $jC5dB.makeEmceeFlag)(flag)
                                })),
                            dismissFlag: (key)=>dispatch((0, $8bwkw.removeFlag)(key))
                        },
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eCRRn.default), {
                            bootstrapConfig: props.bootstrapConfig,
                            algoliaClient: props.algoliaClient,
                            currentUserId: props.currentUserId,
                            history: routeProps.history,
                            location: routeProps.location,
                            hostInfo: props.hostInfo,
                            onRendered: props.onRendered
                        })
                    })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4iWU0.RouteWithContext), {
                exact: true,
                path: (0, $c9Mth).joinPathNames([
                    mountPath,
                    (0, $40nqT.managePromotionsRoute).path
                ]),
                render: (routeProps)=>{
                    var _getCloudIdFromHostIn;
                    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4mQRQ.default), {
                        productName: props.hostInfo.product,
                        cloudId: (_getCloudIdFromHostIn = (0, $bSQ4o.getCloudIdFromHostInfo)(props.hostInfo)) !== null && _getCloudIdFromHostIn !== void 0 ? _getCloudIdFromHostIn : '',
                        links: props.links,
                        history: routeProps.history,
                        hostPricing: props.hostPricing
                    });
                }
            })
        ]
    });
};
var $f8c4f375e3d58242$export$2e2bcd8739ae039 = $f8c4f375e3d58242$var$ManageRoutes;

});
parcelRegister("eCRRn", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa5e64bd13ac8726$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $irI9N = parcelRequire("irI9N");

var $dzIcn = parcelRequire("dzIcn");

var $1Tfhj = parcelRequire("1Tfhj");

var $8gcXz = parcelRequire("8gcXz");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $inwKI = parcelRequire("inwKI");

var $eEKFN = parcelRequire("eEKFN");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $bSQ4o = parcelRequire("bSQ4o");

var $jwE5W = parcelRequire("jwE5W");

var $lkKLg = parcelRequire("lkKLg");

var $hVwsq = parcelRequire("hVwsq");

var $7FJt7 = parcelRequire("7FJt7");

var $g19Hk = parcelRequire("g19Hk");

var $lHkHI = parcelRequire("lHkHI");
function $aa5e64bd13ac8726$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $aa5e64bd13ac8726$export$5523b16adee8048 = (0, $3UXZ8.default)("h3", {
    target: "eehf0700",
    label: "H1"
})((0, $8gcXz.h3Css), " margin-top:0;margin-bottom:0;");
const $aa5e64bd13ac8726$export$92a576f896a9bf72 = (0, $3UXZ8.default)("div", {
    target: "eehf0701",
    label: "Filters"
})({
    name: "zhlw5s",
    styles: "display:flex;margin-top:30px;margin-bottom:var(--ds-space-250, 20px);"
});
const $aa5e64bd13ac8726$export$58f903f55606e69d = /*#__PURE__*/ (0, $3UXZ8.default)((0, $dzIcn.default), {
    target: "eehf0702",
    label: "SingleSelect"
})({
    name: "mah6u9",
    styles: "width:160px;margin-left:15px;"
});
const $aa5e64bd13ac8726$export$2a511c47e1cb5779 = (0, $3UXZ8.default)("div", {
    target: "eehf0703",
    label: "EmptyStateContainer"
})({
    name: "1srm8qi",
    styles: "margin-top:15%;"
});
const $aa5e64bd13ac8726$export$a7907bb86a15af4e = (0, $3UXZ8.default)("img", {
    target: "eehf0704",
    label: "EmptyStateImage"
})({
    name: "1hskriy",
    styles: "width:250px;"
});
const $aa5e64bd13ac8726$export$950242e4fbe1eaff = (0, $3UXZ8.default)("h3", {
    target: "eehf0705",
    label: "EmptyStateText"
})((0, $8gcXz.h3Css), " margin-bottom:0;");
const $aa5e64bd13ac8726$export$8b251419efc915eb = (props)=>{
    return props.showManageAppRequestAlternativeLayout ? /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($aa5e64bd13ac8726$export$5523b16adee8048, {
                children: "App requests"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                children: "You can view and manage details of all app requests"
            })
        ]
    }) : /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($aa5e64bd13ac8726$export$5523b16adee8048, {
                children: "Manage app requests"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                children: "This is a list of apps requested by users including the number of requests per app."
            })
        ]
    });
};
const $aa5e64bd13ac8726$export$fddf379e22a74b00 = ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)($aa5e64bd13ac8726$export$2a511c47e1cb5779, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($aa5e64bd13ac8726$export$a7907bb86a15af4e, {
                alt: "Empty state",
                src: (0, (/*@__PURE__*/$parcel$interopDefault($g19Hk)))
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($aa5e64bd13ac8726$export$950242e4fbe1eaff, {
                children: "No app requests. Enjoy your day!"
            })
        ]
    });
const $aa5e64bd13ac8726$export$f91572503fe5561e = ()=>/*#__PURE__*/ (0, $lHkHI.jsx)("div", {
        children: "We didn\u2019t find any matching results. "
    });
const $aa5e64bd13ac8726$export$9b0c59c3cc920d57 = (props)=>{
    var _getCloudIdFromHostIn;
    const { manageAppRequests: manageAppRequests, appListing: appListing } = (0, $jwE5W.default)();
    const pageSize = 10;
    const appRequestDefaultParams = {
        productName: props.hostInfo.product,
        cloudId: (_getCloudIdFromHostIn = (0, $bSQ4o.getCloudIdFromHostInfo)(props.hostInfo)) !== null && _getCloudIdFromHostIn !== void 0 ? _getCloudIdFromHostIn : '',
        userId: props.currentUserId
    };
    const { appRequestsPending: appRequestsPending, appRequestsError: appRequestsError, appRequestsResult: appRequestsResult } = (0, $hVwsq.useAppRequests)(props.bootstrapConfig, props.algoliaClient, appRequestDefaultParams);
    const { showManageAppRequestAlternativeLayout: showManageAppRequestAlternativeLayout, showTrustSignalsInManageAppRequests: showTrustSignalsInManageAppRequests } = (0, $inwKI.useFeatureFlags)();
    const defaultFilterOption = showTrustSignalsInManageAppRequests ? (0, $lkKLg.default)[1] : (0, $lkKLg.default)[0];
    const [searchText, setSearchText] = (0, $eUqFw.useState)('');
    const [filterOption, setFilterOption] = (0, $eUqFw.useState)(defaultFilterOption);
    const [rejectedKeys, setRejectedKeys] = (0, $eUqFw.useState)([]);
    const [rejectReason, setRejectReason] = (0, $eUqFw.useState)('');
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const layout = showManageAppRequestAlternativeLayout ? 'Alternative' : 'Original';
    const onSearch = (event)=>{
        const search = event.target.value.trim();
        setSearchText(search);
    };
    const onSearchBlur = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.SearchSubmittedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS_SEARCH),
            attributes: {
                filterValue: searchText
            }
        });
    };
    const onFilterOptionChange = (option)=>{
        setFilterOption(option);
        fireAnalyticsEvent({
            eventType: (0, $gaiog.FilterClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS_FILTER),
            attributes: {
                filterValue: option.value
            }
        });
    };
    const onBreadcrumbsItemClick = (e)=>{
        e.preventDefault();
        props.history.push({
            pathname: manageAppRequests.getRelative()
        });
    };
    const onSort = (data, event)=>{
        if (event) fireAnalyticsEvent({
            eventType: (0, $7Uh51.DynamicTableSorted),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS_TABLE)
        });
    };
    const onSetPage = (page, event)=>{
        if (event) fireAnalyticsEvent({
            eventType: (0, $7Uh51.DynamicTablePageChanged),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS_TABLE),
            attributes: {
                page: page
            }
        });
    };
    const isFilterApplied = ()=>!!searchText || filterOption.value !== 'ALL';
    const onReject = (appKey, rejectComment)=>{
        setRejectedKeys([
            appKey,
            ...rejectedKeys
        ]);
        if (rejectComment) setRejectReason(rejectComment);
    };
    const searchFieldDescriptionId = 'manage-app-requests__app-search-description';
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $eEKFN.default), {
        actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS),
        onClick: onBreadcrumbsItemClick,
        href: manageAppRequests.getRelative(),
        text: showManageAppRequestAlternativeLayout ? 'App requests' : 'Manage app requests',
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($aa5e64bd13ac8726$export$8b251419efc915eb, {
                showManageAppRequestAlternativeLayout: showManageAppRequestAlternativeLayout
            }),
            appRequestsError && /*#__PURE__*/ // TODO: Add the commonized error page from MC-463
            (0, $lHkHI.jsx)("div", {
                children: "We ran into a little trouble. It might just be a hiccup. Try again in a bit."
            }),
            !appRequestsError && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($aa5e64bd13ac8726$export$92a576f896a9bf72, {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                                hidden: true,
                                id: searchFieldDescriptionId,
                                children: "The table will be filtered below as you type into the field"
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1Tfhj.default), {
                                placeholder: "Search for apps",
                                "aria-describedby": searchFieldDescriptionId,
                                "aria-label": "Search for requested apps",
                                width: "large",
                                onChange: onSearch,
                                onBlur: onSearchBlur
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)($aa5e64bd13ac8726$export$58f903f55606e69d, {
                                options: (0, $lkKLg.default),
                                onChange: onFilterOptionChange,
                                defaultValue: defaultFilterOption
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $irI9N.default), {
                        head: (0, $7FJt7.AppRequestTable)[layout].head,
                        rows: appRequestsResult && (0, $7FJt7.AppRequestTable)[layout].getRows({
                            appRequests: appRequestsResult,
                            getAppListingLink: appListing.getAbsolute,
                            filter: {
                                bySearch: searchText,
                                byStatus: filterOption
                            },
                            appRequestDefaultParams: appRequestDefaultParams,
                            onReject: onReject,
                            rejectedKeys: rejectedKeys,
                            rejectComment: rejectReason,
                            showTrustSignalsInManageAppRequests: showTrustSignalsInManageAppRequests
                        }),
                        rowsPerPage: appRequestsResult && appRequestsResult.length > pageSize ? pageSize : Number.POSITIVE_INFINITY,
                        defaultPage: 1,
                        loadingSpinnerSize: "large",
                        isLoading: appRequestsPending,
                        emptyView: isFilterApplied() ? /*#__PURE__*/ (0, $lHkHI.jsx)($aa5e64bd13ac8726$export$f91572503fe5561e, {}) : /*#__PURE__*/ (0, $lHkHI.jsx)($aa5e64bd13ac8726$export$fddf379e22a74b00, {}),
                        isFixedSize: true,
                        onSetPage: onSetPage,
                        onSort: onSort
                    })
                ]
            })
        ]
    });
};
var $aa5e64bd13ac8726$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).memo($aa5e64bd13ac8726$export$9b0c59c3cc920d57);

});
parcelRegister("irI9N", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6dd003f586aa780$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $eiQBT = parcelRequire("eiQBT");

var $iigy9 = parcelRequire("iigy9");

var $1qkuo = parcelRequire("1qkuo");
class $d6dd003f586aa780$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "state", {
            page: this.props.defaultPage,
            sortKey: this.props.defaultSortKey,
            sortOrder: this.props.defaultSortOrder,
            rows: this.props.rows
        });
        (0, $5zQU9.default)(this, "onSetPageHandler", (page, analyticsEvent)=>{
            const { onSetPage: onSetPage } = this.props;
            if (onSetPage) {
                onSetPage(page, analyticsEvent);
                this.setState({
                    page: page
                });
            }
        });
        (0, $5zQU9.default)(this, "onSortHandler", ({ key: key, item: item, sortOrder: sortOrder }, analyticsEvent)=>{
            const { onSort: onSort } = this.props;
            if (onSort) {
                onSort({
                    key: key,
                    item: item,
                    sortOrder: sortOrder
                }, analyticsEvent);
                this.setState({
                    sortKey: key,
                    sortOrder: sortOrder
                });
            }
        });
        (0, $5zQU9.default)(this, "onRankEndIfExistsHandler", (params)=>{
            if (this.props.onRankEnd) this.props.onRankEnd(params);
        });
        (0, $5zQU9.default)(this, "onRankEndHandler", (params)=>{
            const { destination: destination } = params;
            const { rows: rows, page: page } = this.state;
            const { rowsPerPage: rowsPerPage } = this.props;
            if (!destination || !rows) {
                this.onRankEndIfExistsHandler(params);
                return;
            }
            const reordered = (0, $iigy9.reorderRows)(params, rows, page, rowsPerPage);
            this.setState({
                rows: reordered
            });
            this.onRankEndIfExistsHandler(params);
        });
    }
    UNSAFE_componentWillReceiveProps(newProps) {
        const sortKey = newProps.sortKey || this.state.sortKey;
        const sortOrder = newProps.sortOrder || this.state.sortOrder;
        const page = newProps.page || this.state.page;
        this.setState({
            page: page,
            sortKey: sortKey,
            sortOrder: sortOrder,
            rows: newProps.rows
        });
    }
    render() {
        const { page: page, sortKey: sortKey, sortOrder: sortOrder, rows: rows } = this.state;
        const { caption: caption, emptyView: emptyView, head: head, highlightedRowIndex: highlightedRowIndex, loadingSpinnerSize: loadingSpinnerSize, isLoading: isLoading, loadingLabel: loadingLabel, isFixedSize: isFixedSize, isRankable: isRankable, isRankingDisabled: isRankingDisabled, rowsPerPage: rowsPerPage, paginationi18n: paginationi18n, onRankStart: onRankStart, onPageRowsUpdate: onPageRowsUpdate, testId: testId, label: label } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1qkuo.default), {
            paginationi18n: paginationi18n,
            caption: caption,
            emptyView: emptyView,
            head: head,
            highlightedRowIndex: highlightedRowIndex,
            loadingSpinnerSize: loadingSpinnerSize,
            isLoading: isLoading,
            loadingLabel: loadingLabel,
            isFixedSize: isFixedSize,
            onSetPage: this.onSetPageHandler,
            onSort: this.onSortHandler,
            page: page,
            rows: rows,
            rowsPerPage: rowsPerPage,
            sortKey: sortKey,
            sortOrder: sortOrder,
            isRankable: isRankable,
            isRankingDisabled: isRankingDisabled,
            onRankEnd: this.onRankEndHandler,
            onRankStart: onRankStart,
            onPageRowsUpdate: onPageRowsUpdate,
            testId: testId,
            label: label
        });
    }
}
(0, $5zQU9.default)($d6dd003f586aa780$export$2e2bcd8739ae039, "defaultProps", {
    defaultPage: 1,
    isLoading: false,
    isFixedSize: false,
    isRankable: false,
    onSetPage: (0, $eiQBT.default),
    onSort: (0, $eiQBT.default),
    rowsPerPage: Infinity
});

});
parcelRegister("iigy9", function(module, exports) {

$parcel$export(module.exports, "getPageRows", () => $d516bedd5adc18e5$export$3987dc24b734dcab);
$parcel$export(module.exports, "assertIsSortable", () => $d516bedd5adc18e5$export$5eb35a4771ec4090);
$parcel$export(module.exports, "validateSortKey", () => $d516bedd5adc18e5$export$9133f5a8bfe8a200);
$parcel$export(module.exports, "inlineStylesIfRanking", () => $d516bedd5adc18e5$export$a601f1775e10043f);
$parcel$export(module.exports, "reorderRows", () => $d516bedd5adc18e5$export$c476bbe5da59992d);
const $d516bedd5adc18e5$export$3987dc24b734dcab = (allRows, pageNumber, rowsPerPage)=>{
    if (!pageNumber || !rowsPerPage || !allRows.length) return [];
    return allRows.slice((pageNumber - 1) * rowsPerPage, pageNumber * rowsPerPage);
};
const $d516bedd5adc18e5$export$5eb35a4771ec4090 = (head)=>{
    if (!head || !head.cells) return;
    head.cells.forEach((cell)=>{
        if (cell.isSortable && !cell.key) try {
            throw Error("isSortable can't be set to true, if the 'key' prop is missing.");
        } catch (e) {
            // eslint-disable-next-line no-console
            console.error(e);
        }
    });
};
const $d516bedd5adc18e5$export$9133f5a8bfe8a200 = (sortKey, head)=>{
    if (!sortKey) return;
    const headHasKey = head && head.cells.map((cell)=>cell.key).includes(sortKey);
    if (!headHasKey) try {
        throw Error(`Cell with ${sortKey} key not found in head.`);
    } catch (e) {
        // eslint-disable-next-line no-console
        console.error(e);
    }
};
const $d516bedd5adc18e5$export$a601f1775e10043f = (isRanking, width, height)=>{
    if (!isRanking) return {};
    if (height) return {
        width: width,
        height: height
    };
    return {
        width: width
    };
};
const $d516bedd5adc18e5$export$92bcb1ed38b134a1 = (index, page, rowsPerPage)=>{
    const itemOnPreviousPages = rowsPerPage && isFinite(rowsPerPage) ? (page - 1) * rowsPerPage : 0;
    return index + itemOnPreviousPages;
};
const $d516bedd5adc18e5$export$c476bbe5da59992d = (rankEnd, rows, page = 1, rowsPerPage)=>{
    const { destination: destination, sourceIndex: sourceIndex } = rankEnd;
    if (!destination) return rows;
    const fromIndex = $d516bedd5adc18e5$export$92bcb1ed38b134a1(sourceIndex, page, rowsPerPage);
    const toIndex = $d516bedd5adc18e5$export$92bcb1ed38b134a1(destination.index, page, rowsPerPage);
    const reordered = rows.slice();
    const [removed] = reordered.splice(fromIndex, 1);
    reordered.splice(toIndex, 0, removed);
    return reordered;
};

});

parcelRegister("1qkuo", function(module, exports) {

$parcel$export(module.exports, "default", () => $10981ce25c3dda50$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $lzpNt = parcelRequire("lzpNt");
var $dki1H = parcelRequire("dki1H");
var $dY3D1 = parcelRequire("dY3D1");

var $eiQBT = parcelRequire("eiQBT");


var $iigy9 = parcelRequire("iigy9");

var $5QYJl = parcelRequire("5QYJl");

var $1ZQ3v = parcelRequire("1ZQ3v");

var $6Gqwq = parcelRequire("6Gqwq");

var $eC0Xf = parcelRequire("eC0Xf");

var $k5Zey = parcelRequire("k5Zey");

var $i6VR9 = parcelRequire("i6VR9");

var $2CQqO = parcelRequire("2CQqO");

var $7m5wg = parcelRequire("7m5wg");
const $10981ce25c3dda50$var$packageName = "@atlaskit/dynamic-table";
const $10981ce25c3dda50$var$packageVersion = "14.20.3";
function $10981ce25c3dda50$var$toggleSortOrder(currentSortOrder) {
    switch(currentSortOrder){
        case 0, $7722a284baab0b09$export$b6abcf7fa1d94f65:
            return 0, $7722a284baab0b09$export$1dee026a19752d6b;
        case 0, $7722a284baab0b09$export$1dee026a19752d6b:
            return 0, $7722a284baab0b09$export$b6abcf7fa1d94f65;
        default:
            return currentSortOrder;
    }
}
const $10981ce25c3dda50$export$613134f68684a686 = ({ caption: caption, head: head, highlightedRowIndex: highlightedRowIndex, rows: rows, sortKey: sortKey, sortOrder: sortOrder, loadingLabel: loadingLabel, onPageRowsUpdate: onPageRowsUpdate, testId: testId, totalRows: passedDownTotalRows, label: label, isLoading: isLoading = false, isFixedSize: isFixedSize = false, rowsPerPage: rowsPerPage = Infinity, onSetPage: onSetPage = (0, $eiQBT.default), onSort: onSort = (0, $eiQBT.default), page: page = 1, emptyView: emptyView, isRankable: isRankable = false, isRankingDisabled: isRankingDisabled = false, onRankStart: onRankStart = (0, $eiQBT.default), onRankEnd: onRankEnd = (0, $eiQBT.default), loadingSpinnerSize: loadingSpinnerSize, paginationi18n: paginationi18n = {
    prev: 'Previous',
    next: 'Next',
    label: 'Pagination',
    pageLabel: 'Page'
} })=>{
    const [isRanking, setIsRanking] = (0, $eUqFw.useState)(false);
    const tableBodyRef = (0, $eUqFw.useRef)(null);
    (0, $eUqFw.useEffect)(()=>{
        (0, $iigy9.validateSortKey)(sortKey, head);
        (0, $iigy9.assertIsSortable)(head);
    }, [
        sortKey,
        head
    ]);
    const onSortHandler = (item)=>()=>{
            const { key: key } = item;
            if (!key) return;
            if (onSort && isRankable && key === sortKey && sortOrder === (0, $7722a284baab0b09$export$b6abcf7fa1d94f65)) {
                onSort({
                    key: null,
                    sortOrder: null,
                    item: item
                });
                return;
            }
            const sortOrderFormatted = key !== sortKey ? (0, $7722a284baab0b09$export$1dee026a19752d6b) : $10981ce25c3dda50$var$toggleSortOrder(sortOrder);
            if (onSort) onSort({
                key: key,
                item: item,
                sortOrder: sortOrderFormatted
            });
        };
    const onSetPageHandler = (page, event)=>{
        onSetPage(page, event);
    };
    const onRankStartHandler = (params)=>{
        setIsRanking(true);
        onRankStart(params);
    };
    const onRankEndHandler = (params)=>{
        setIsRanking(false);
        onRankEnd(params);
    };
    const getSpinnerSize = ()=>{
        if (loadingSpinnerSize) return loadingSpinnerSize;
        return (0, $iigy9.getPageRows)(rows || [], page, rowsPerPage).length > 2 ? (0, $7722a284baab0b09$export$7b93a10c0fefe3e3) : (0, $7722a284baab0b09$export$71dd4c8ecd45e95f);
    };
    const renderEmptyBody = ()=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZQ3v.EmptyViewWithFixedHeight), {
            testId: testId
        });
        return emptyView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1ZQ3v.EmptyViewContainer), {
            testId: testId
        }, emptyView);
    };
    const rowsLength = rows && rows.length;
    let totalPages;
    // set a flag to denote the dynamic table might get only one page of data
    // for paginated data
    let isTotalPagesControlledExternally = false;
    if (passedDownTotalRows && Number.isInteger(passedDownTotalRows) && rowsPerPage && rowsLength && rowsLength <= passedDownTotalRows) {
        /**
     * If total number of rows / records have been passed down as prop
     * Then table is being fed paginated data from server or other sources
     * In this case, we want to respect information passed down by server or external source
     * Rather than relying on our computation based on number of rows
     */ totalPages = Math.ceil(passedDownTotalRows / rowsPerPage);
        isTotalPagesControlledExternally = true;
    } else totalPages = rowsLength && rowsPerPage ? Math.ceil(rowsLength / rowsPerPage) : 0;
    totalPages = totalPages < 1 ? 1 : totalPages;
    const getPageNumber = page > totalPages ? totalPages : page; // page! required, because typescript can't yet see defaultProps to know that this won't be undefined
    const rowsExist = !!rowsLength;
    const spinnerSize = getSpinnerSize();
    const emptyBody = renderEmptyBody();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $i6VR9.default), {
        isLoading: isLoading && rowsExist,
        spinnerSize: spinnerSize,
        targetRef: ()=>tableBodyRef.current,
        testId: testId,
        loadingLabel: loadingLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5QYJl.Table), {
        isFixedSize: isFixedSize,
        "aria-label": label,
        hasDataRow: rowsExist,
        testId: testId,
        isLoading: isLoading
    }, !!caption && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5QYJl.Caption), null, caption), head && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7m5wg.default), {
        head: head,
        onSort: onSortHandler,
        sortKey: sortKey,
        sortOrder: sortOrder,
        isRanking: isRanking,
        isRankable: isRankable,
        testId: testId
    }), rowsExist && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10981ce25c3dda50$var$TableBody, {
        ref: tableBodyRef,
        highlightedRowIndex: highlightedRowIndex,
        rows: rows,
        head: head,
        sortKey: sortKey,
        sortOrder: sortOrder,
        rowsPerPage: rowsPerPage,
        page: getPageNumber,
        isFixedSize: isFixedSize || false,
        onPageRowsUpdate: onPageRowsUpdate,
        isTotalPagesControlledExternally: isTotalPagesControlledExternally,
        testId: testId,
        isRankable: isRankable,
        isRanking: isRanking,
        onRankStart: onRankStartHandler,
        onRankEnd: onRankEndHandler,
        isRankingDisabled: isRankingDisabled || isLoading || false
    }))), totalPages <= 1 ? null : /*#__PURE__*/ // only show pagination if there's MORE than 1 page
    (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $5QYJl.PaginationWrapper), {
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $2CQqO.default), {
        value: getPageNumber,
        onChange: onSetPageHandler,
        total: totalPages,
        i18n: paginationi18n,
        isDisabled: isLoading,
        testId: testId
    })), !rowsExist && emptyBody && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $k5Zey.default), {
        isLoading: isLoading,
        spinnerSize: (0, $7722a284baab0b09$export$7b93a10c0fefe3e3),
        testId: testId,
        loadingLabel: loadingLabel
    }, emptyBody));
};

const $10981ce25c3dda50$var$RankableTableBody = /*#__PURE__*/ (0, $eUqFw.lazy)(()=>(parcelRequire("kBJ8Z")));
const $10981ce25c3dda50$var$TableBody = /*#__PURE__*/ (0, $eUqFw.forwardRef)(function TableBody({ isRankable: isRankable = false, isRanking: isRanking, onRankStart: onRankStart, onRankEnd: onRankEnd, isRankingDisabled: isRankingDisabled, ...bodyProps }, ref) {
    const canRank = isRankable && !bodyProps.sortKey;
    /**
   * React 16 does not support SSR for lazy components,
   * so we avoid rendering the `Suspense` on the server.
   */ const [canRenderRankable, setCanRenderRankable] = (0, $eUqFw.useState)(false);
    (0, $eUqFw.useEffect)(()=>{
        if (canRank) setCanRenderRankable(true);
    }, [
        canRank
    ]);
    const nonRankableBody = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $6Gqwq.default), (0, $kU09D.default)({
        ref: ref
    }, bodyProps));
    return canRank && canRenderRankable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eC0Xf.ErrorBoundary), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $eUqFw.Suspense), {
        fallback: nonRankableBody
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($10981ce25c3dda50$var$RankableTableBody, (0, $kU09D.default)({
        ref: ref
    }, bodyProps, {
        isRanking: isRanking,
        onRankStart: onRankStart,
        onRankEnd: onRankEnd,
        isRankingDisabled: isRankingDisabled
    })))) : nonRankableBody;
});
const $10981ce25c3dda50$var$createAndFireEventOnAtlaskit = (0, $lzpNt.default)('atlaskit');
/**
 * __Dynamic table stateless__
 *
 * A stateless table that requires consumers to manage the sorting, drag and drop, and pagination.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/dynamic-table)
 * - [Code](https://bitbucket.org/atlassian/atlassian-frontend/packages/design-system/dynamic-table)
 */ const $10981ce25c3dda50$var$DynamicTableStateless = (0, $dki1H.default)({
    componentName: 'dynamicTable',
    packageName: $10981ce25c3dda50$var$packageName,
    packageVersion: $10981ce25c3dda50$var$packageVersion
})((0, $dY3D1.default)({
    onSort: $10981ce25c3dda50$var$createAndFireEventOnAtlaskit({
        action: 'sorted',
        actionSubject: 'dynamicTable',
        attributes: {
            componentName: 'dynamicTable',
            packageName: $10981ce25c3dda50$var$packageName,
            packageVersion: $10981ce25c3dda50$var$packageVersion
        }
    }),
    onRankEnd: $10981ce25c3dda50$var$createAndFireEventOnAtlaskit({
        action: 'ranked',
        actionSubject: 'dynamicTable',
        attributes: {
            componentName: 'dynamicTable',
            packageName: $10981ce25c3dda50$var$packageName,
            packageVersion: $10981ce25c3dda50$var$packageVersion
        }
    })
})($10981ce25c3dda50$export$613134f68684a686));
var $10981ce25c3dda50$export$2e2bcd8739ae039 = $10981ce25c3dda50$var$DynamicTableStateless;

});
const $7722a284baab0b09$export$1dee026a19752d6b = 'ASC';
const $7722a284baab0b09$export$b6abcf7fa1d94f65 = 'DESC';
const $7722a284baab0b09$export$71dd4c8ecd45e95f = 'small';
const $7722a284baab0b09$export$7b93a10c0fefe3e3 = 'large';
const $7722a284baab0b09$export$3843c586a90b9cbf = 0.22;

parcelRegister("5QYJl", function(module, exports) {

$parcel$export(module.exports, "tableRowCSSVars", () => $4430eae161794057$export$3b9ea2c10c245fdb);
$parcel$export(module.exports, "Table", () => $4430eae161794057$export$54ec01a60f47d33d);
$parcel$export(module.exports, "Caption", () => $4430eae161794057$export$32fbfacc5d962e0c);
$parcel$export(module.exports, "PaginationWrapper", () => $4430eae161794057$export$3e5e12dc01f20a43);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $8RtNA = parcelRequire("8RtNA");
const $4430eae161794057$export$3b9ea2c10c245fdb = {
    CSS_VAR_HOVER_BACKGROUND: '--local-dynamic-table-hover-bg',
    CSS_VAR_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-highlighted-bg',
    CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND: '--local-dynamic-table-hover-highlighted-bg',
    CSS_VAR_ROW_FOCUS_OUTLINE: '--local-dynamic-table-row-focus-outline'
};
const $4430eae161794057$var$fixedSizeTableStyles = (0, $byn9U.css)({
    tableLayout: 'fixed'
});
const $4430eae161794057$var$tableStyles = (0, $byn9U.css)({
    width: '100%',
    borderCollapse: 'separate',
    borderSpacing: '0px'
});
const $4430eae161794057$var$bodyBorder = (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $8RtNA.tableBorder).borderColor}`
});
const $4430eae161794057$export$54ec01a60f47d33d = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isFixedSize: isFixedSize, hasDataRow: hasDataRow, children: children, testId: testId, isLoading: isLoading, ...rest }, ref)=>{
    return (0, $byn9U.jsx)("table", (0, $kU09D.default)({
        inert: isLoading ? '' : undefined,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$4430eae161794057$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_BACKGROUND]: (0, $8RtNA.row).hoverBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$4430eae161794057$export$3b9ea2c10c245fdb.CSS_VAR_HIGHLIGHTED_BACKGROUND]: (0, $8RtNA.row).highlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$4430eae161794057$export$3b9ea2c10c245fdb.CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND]: (0, $8RtNA.row).hoverHighlightedBackground,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            [$4430eae161794057$export$3b9ea2c10c245fdb.CSS_VAR_ROW_FOCUS_OUTLINE]: (0, $8RtNA.row).focusOutline
        },
        css: [
            $4430eae161794057$var$tableStyles,
            isFixedSize && $4430eae161794057$var$fixedSizeTableStyles,
            hasDataRow && $4430eae161794057$var$bodyBorder
        ],
        ref: ref
    }, rest, {
        "data-testid": testId && `${testId}--table`
    }), children);
});
const $4430eae161794057$var$captionStyles = (0, $byn9U.css)({
    font: "var(--ds-font-heading-medium, normal 500 20px/24px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    marginBlockEnd: "var(--ds-space-100, 8px)",
    marginBlockStart: "var(--ds-space-300, 24px)",
    willChange: 'transform'
});
const $4430eae161794057$export$32fbfacc5d962e0c = ({ children: children })=>(0, $byn9U.jsx)("caption", {
        css: $4430eae161794057$var$captionStyles
    }, children);
const $4430eae161794057$var$paginationWrapperStyles = (0, $byn9U.css)({
    display: 'flex',
    justifyContent: 'center'
});
const $4430eae161794057$export$3e5e12dc01f20a43 = ({ children: children, testId: testId })=>(0, $byn9U.jsx)("div", {
        css: $4430eae161794057$var$paginationWrapperStyles,
        "data-testid": testId && `${testId}--pagination--container`
    }, children);

});
parcelRegister("8RtNA", function(module, exports) {

$parcel$export(module.exports, "MSThemeColors", () => $673a636127a24a04$export$34af08ce45c78352);
$parcel$export(module.exports, "arrow", () => $673a636127a24a04$export$f2120bbfa5450bd2);
$parcel$export(module.exports, "row", () => $673a636127a24a04$export$120ff0929b202a6d);
$parcel$export(module.exports, "head", () => $673a636127a24a04$export$5fd5031fecdacec3);
$parcel$export(module.exports, "tableBorder", () => $673a636127a24a04$export$38d703b73e2cf64d);

const $673a636127a24a04$export$34af08ce45c78352 = {
    Background: 'Canvas',
    Text: 'CanvasText',
    SelectedBackground: 'Highlight',
    SelectedText: 'HighlightText'
};
const $673a636127a24a04$export$f2120bbfa5450bd2 = {
    defaultColor: `var(--ds-icon-disabled, ${$ab6d6432a4c55680$export$1ce2d1575d444ceb})`,
    selectedColor: `var(--ds-icon-subtle, ${$ab6d6432a4c55680$export$e2ef2124cf4024b1})`
};
const $673a636127a24a04$export$120ff0929b202a6d = {
    focusOutline: `var(--ds-border-focused, ${$ab6d6432a4c55680$export$ecfc1dff386a3e7a})`,
    highlightedBackground: `var(--ds-background-selected, ${$ab6d6432a4c55680$export$226de0355ed012f8})`,
    hoverBackground: `var(--ds-background-neutral-subtle-hovered, ${$ab6d6432a4c55680$export$e655ef011c4aa1a2})`,
    hoverHighlightedBackground: `var(--ds-background-selected-hovered, ${$ab6d6432a4c55680$export$8c13c2ee36917869})`
};
const $673a636127a24a04$export$5fd5031fecdacec3 = {
    textColor: `var(--ds-text-subtlest, ${$ab6d6432a4c55680$export$e2ef2124cf4024b1})`
};
const $673a636127a24a04$export$38d703b73e2cf64d = {
    borderColor: `var(--ds-border, ${$ab6d6432a4c55680$export$1ce2d1575d444ceb})`
};

});


parcelRegister("1ZQ3v", function(module, exports) {

$parcel$export(module.exports, "EmptyViewWithFixedHeight", () => $1743de1e9ad70040$export$8f45b9407d4090d7);
$parcel$export(module.exports, "EmptyViewContainer", () => $1743de1e9ad70040$export$381ea436de119582);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $1743de1e9ad70040$var$fixedHeightStyles = (0, $byn9U.css)({
    height: '9rem'
});
const $1743de1e9ad70040$export$8f45b9407d4090d7 = ({ children: children, testId: testId })=>(0, $byn9U.jsx)("div", {
        css: $1743de1e9ad70040$var$fixedHeightStyles,
        "data-testid": testId && `${testId}--empty-view-with-fixed-height`
    }, children);
const $1743de1e9ad70040$var$emptyViewContainerStyles = (0, $byn9U.css)({
    width: '50%',
    margin: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-space
    padding: '10px',
    textAlign: 'center'
});
const $1743de1e9ad70040$export$381ea436de119582 = (props)=>{
    const { children: children, testId: testId } = props;
    return (0, $byn9U.jsx)("div", {
        css: $1743de1e9ad70040$var$emptyViewContainerStyles,
        "data-testid": testId && `${testId}--empty-view-container`
    }, children);
};

});

parcelRegister("6Gqwq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ddb3d06ab3e6323$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $dy1We = parcelRequire("dy1We");

var $gHpGd = parcelRequire("gHpGd");
class $4ddb3d06ab3e6323$var$BodyComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { pageRows: pageRows, head: head, isFixedSize: isFixedSize, highlightedRowIndex: highlightedRowIndex, testId: testId, forwardedRef: forwardedRef } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tbody", {
            "data-testid": testId && `${testId}--body`,
            ref: forwardedRef
        }, pageRows.map((row, rowIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $gHpGd.default), {
                head: head,
                isFixedSize: isFixedSize,
                key: row.key || rowIndex,
                row: row,
                isHighlighted: row.isHighlighted || !!highlightedRowIndex && (typeof highlightedRowIndex === 'number' ? highlightedRowIndex === rowIndex : highlightedRowIndex.indexOf(rowIndex) > -1),
                testId: testId
            })));
    }
}
const $4ddb3d06ab3e6323$var$Body = (0, $dy1We.default)(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($4ddb3d06ab3e6323$var$BodyComponent, (0, $kU09D.default)({}, props, {
        forwardedRef: ref
    }));
}));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4ddb3d06ab3e6323$export$2e2bcd8739ae039 = $4ddb3d06ab3e6323$var$Body;

});
parcelRegister("dy1We", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dcff43d27fc49c7$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");


var $iigy9 = parcelRequire("iigy9");
const $9dcff43d27fc49c7$var$getSortingCellValue = (cells, head, sortKey)=>{
    for(let i = 0; i < cells.length; i++){
        var _head$cells$i;
        if (head.cells[i] && ((_head$cells$i = head.cells[i]) === null || _head$cells$i === void 0 ? void 0 : _head$cells$i.key) === sortKey) {
            var _cells$i;
            return (_cells$i = cells[i]) === null || _cells$i === void 0 ? void 0 : _cells$i.key;
        }
    }
    return undefined;
};
// sort all rows based on sort key and order
const $9dcff43d27fc49c7$var$getSortedRows = (head, rows, sortKey, sortOrder)=>{
    if (!sortKey || !head) return rows;
    if (!rows) return [];
    const modifier = sortOrder === (0, $7722a284baab0b09$export$1dee026a19752d6b) ? 1 : -1;
    // Re-initialising an I18n Collator on every sort is performance intensive, thus constructed outside
    const collator = new Intl.Collator(undefined, {
        numeric: true,
        sensitivity: 'accent'
    });
    // Get copy of rows to avoid sorting prop in place
    const sortableRows = Array.from(rows);
    // Reorder rows in table based on sorting cell value
    // Algorithm will sort numerics or strings, but not both
    return sortableRows.sort((a, b)=>{
        const valA = $9dcff43d27fc49c7$var$getSortingCellValue(a.cells, head, sortKey);
        const valB = $9dcff43d27fc49c7$var$getSortingCellValue(b.cells, head, sortKey);
        if (valA === undefined || valB === undefined) return modifier;
        if (typeof valA !== typeof valB) {
            // numbers are always grouped higher in the sort
            if (typeof valA === 'number') return -1;
            if (typeof valB === 'number') return 1;
            // strings are grouped next
            if (typeof valA === 'string') return -1;
            if (typeof valB === 'string') return 1;
        }
        if (typeof valA === 'string' && typeof valB === 'string') return modifier * collator.compare(valA, valB);
        if (!valA && valA !== 0 || valA < valB) return -modifier;
        if (!valB && valB !== 0 || valA > valB) return modifier;
        if (valA === valB) return 0;
        return 1;
    });
};
function $9dcff43d27fc49c7$export$2e2bcd8739ae039(WrappedComponent) {
    class WithSortedPageRows extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        constructor(...args){
            super(...args);
            (0, $5zQU9.default)(this, "state", {
                pageRows: []
            });
        }
        static getDerivedStateFromProps(props, state) {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, page: page, rowsPerPage: rowsPerPage, isTotalPagesControlledExternally: isTotalPagesControlledExternally } = props;
            (0, $iigy9.validateSortKey)(sortKey, head);
            let sortedRows;
            let pageRows;
            if (isTotalPagesControlledExternally) {
                sortedRows = rows;
                pageRows = rows;
            } else {
                sortedRows = $9dcff43d27fc49c7$var$getSortedRows(head, rows, sortKey, sortOrder) || [];
                pageRows = (0, $iigy9.getPageRows)(sortedRows, page, rowsPerPage);
            }
            return {
                ...state,
                pageRows: pageRows
            };
        }
        componentDidMount() {
            this.props.onPageRowsUpdate && this.props.onPageRowsUpdate(this.state.pageRows);
        }
        componentDidUpdate(_prevProps, prevState) {
            if (this.props.onPageRowsUpdate && this.state.pageRows !== prevState.pageRows) this.props.onPageRowsUpdate(this.state.pageRows);
        }
        render() {
            const { rows: rows, head: head, sortKey: sortKey, sortOrder: sortOrder, rowsPerPage: rowsPerPage, page: page, forwardedRef: forwardedRef, ...restProps } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, (0, $kU09D.default)({
                pageRows: this.state.pageRows,
                head: head
            }, restProps, {
                ref: forwardedRef
            }));
        }
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).forwardRef((props, ref)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WithSortedPageRows, (0, $kU09D.default)({}, props, {
            forwardedRef: ref
        }));
    });
}

});

parcelRegister("gHpGd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c28494fc72f4e58a$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $aTMJs = parcelRequire("aTMJs");

var $iMufr = parcelRequire("iMufr");
const $c28494fc72f4e58a$var$Row = ({ row: row, head: head, testId: testId, isFixedSize: isFixedSize, isHighlighted: isHighlighted })=>{
    const { cells: cells, ...restRowProps } = row;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $iMufr.TableBodyRow), (0, $kU09D.default)({}, restRowProps, {
        isHighlighted: isHighlighted
    }, isHighlighted ? {
        'data-ts--dynamic-table--table-row--highlighted': true
    } : null, {
        testId: row.testId || testId && `${testId}--row-${restRowProps.key}`
    }), cells.map((cell, cellIndex)=>{
        const { content: content, testId: cellTestId, ...restCellProps } = cell;
        const { shouldTruncate: shouldTruncate, width: width } = (head || {
            cells: []
        }).cells[cellIndex] || {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $aTMJs.TableBodyCell), (0, $kU09D.default)({
            "data-testid": cellTestId || testId && `${testId}--cell-${cellIndex}`
        }, restCellProps, {
            isFixedSize: isFixedSize,
            key: cellIndex // eslint-disable-line react/no-array-index-key
            ,
            shouldTruncate: shouldTruncate,
            width: width
        }), content);
    }));
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c28494fc72f4e58a$export$2e2bcd8739ae039 = $c28494fc72f4e58a$var$Row;

});
parcelRegister("aTMJs", function(module, exports) {

$parcel$export(module.exports, "TableBodyCell", () => $7ef4d7a440a17abb$export$948e91fcef170792);

var $kU09D = parcelRequire("kU09D");

var $byn9U = parcelRequire("byn9U");

var $7tD15 = parcelRequire("7tD15");
const $7ef4d7a440a17abb$export$948e91fcef170792 = ({ width: width, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, innerRef: innerRef, ...props })=>(0, $byn9U.jsx)("td", (0, $kU09D.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $7tD15.getTruncationStyleVars)({
            width: width
        }),
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $7tD15.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $7tD15.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            isFixedSize && (0, $7tD15.overflowTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            (0, $7tD15.cellStyles)
        ],
        ref: innerRef
    }, props));

});
parcelRegister("7tD15", function(module, exports) {

$parcel$export(module.exports, "truncationWidthStyles", () => $571981b9b2cae329$export$708a733455f59a29);
$parcel$export(module.exports, "fixedSizeTruncateStyles", () => $571981b9b2cae329$export$616c93ee022c8812);
$parcel$export(module.exports, "overflowTruncateStyles", () => $571981b9b2cae329$export$7f2cd17defa265d8);
$parcel$export(module.exports, "getTruncationStyleVars", () => $571981b9b2cae329$export$5e6497a652ae30b5);
$parcel$export(module.exports, "cellStyles", () => $571981b9b2cae329$export$f7913df521f684e2);
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $571981b9b2cae329$var$CSS_VAR_WIDTH = '--local-dynamic-table-width';
const $571981b9b2cae329$export$708a733455f59a29 = (0, $byn9U.css)({
    width: `var(${$571981b9b2cae329$var$CSS_VAR_WIDTH})`
});
const $571981b9b2cae329$export$616c93ee022c8812 = (0, $byn9U.css)({
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});
const $571981b9b2cae329$export$7f2cd17defa265d8 = (0, $byn9U.css)({
    overflow: 'hidden'
});
const $571981b9b2cae329$export$5e6497a652ae30b5 = ({ width: width })=>typeof width !== 'undefined' ? {
        [$571981b9b2cae329$var$CSS_VAR_WIDTH]: `${width}%`
    } : undefined;
const $571981b9b2cae329$export$f7913df521f684e2 = (0, $byn9U.css)({
    padding: `${"var(--ds-space-050, 4px)"} ${"var(--ds-space-100, 8px)"}`,
    border: 'none',
    textAlign: 'left',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:first-of-type': {
        paddingInlineStart: "var(--ds-space-0, 0px)"
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '&:last-child': {
        paddingInlineEnd: "var(--ds-space-0, 0px)"
    }
});

});


parcelRegister("iMufr", function(module, exports) {

$parcel$export(module.exports, "TableBodyRow", () => $dac42c501ffe95f6$export$45f39d9c38b886d5);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");

var $5QYJl = parcelRequire("5QYJl");
const $dac42c501ffe95f6$var$rowStyles = (0, $byn9U.css)({
    backgroundColor: "var(--ds-background-neutral-subtle, transparent)",
    '&:focus-visible': {
        outline: `2px solid ${`var(--ds-border-focused, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $5QYJl.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`}`,
        outlineOffset: `-2px`
    }
});
const $dac42c501ffe95f6$var$rowBackgroundStyles = (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-subtle-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $5QYJl.tableRowCSSVars).CSS_VAR_HOVER_BACKGROUND})`})`
    }
});
const $dac42c501ffe95f6$var$rowHighlightedBackgroundStyles = (0, $byn9U.css)({
    backgroundColor: `var(--ds-background-selected, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    `var(${(0, $5QYJl.tableRowCSSVars).CSS_VAR_HIGHLIGHTED_BACKGROUND})`})`,
    '&:hover': {
        backgroundColor: `var(--ds-background-selected-hovered, ${// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        `var(${(0, $5QYJl.tableRowCSSVars).CSS_VAR_HOVER_HIGHLIGHTED_BACKGROUND})`})`
    }
});
const $dac42c501ffe95f6$export$45f39d9c38b886d5 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ isHighlighted: isHighlighted, children: children, style: style, testId: testId, ...rest }, ref)=>{
    return (0, $byn9U.jsx)("tr", (0, $kU09D.default)({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: style,
        css: [
            $dac42c501ffe95f6$var$rowStyles,
            isHighlighted ? $dac42c501ffe95f6$var$rowHighlightedBackgroundStyles : $dac42c501ffe95f6$var$rowBackgroundStyles
        ]
    }, rest, {
        ref: ref,
        "data-testid": testId
    }), children);
});

});



parcelRegister("eC0Xf", function(module, exports) {

$parcel$export(module.exports, "ErrorBoundary", () => $aa355adc905528d5$export$e926676385687eaf);

var $eUqFw = parcelRequire("eUqFw");
class $aa355adc905528d5$export$e926676385687eaf extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(props){
        super(props);
        this.state = {
            hasError: false
        };
    }
    static getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    }
    render() {
        if (this.state.hasError) // You can render any custom fallback UI
        return this.props.fallback;
        return this.props.children;
    }
}

});

parcelRegister("k5Zey", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea13c6025abee9b3$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $hvCdF = parcelRequire("hvCdF");


var $j8nog = parcelRequire("j8nog");
class $ea13c6025abee9b3$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, contentsOpacity: contentsOpacity, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j8nog.Container), {
            testId: testId
        }, !isLoading ? children : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j8nog.ContentsContainer), {
            contentsOpacity: contentsOpacity,
            testId: testId
        }, children), isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $j8nog.SpinnerContainer), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hvCdF.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        })));
    }
}
(0, $5zQU9.default)($ea13c6025abee9b3$export$2e2bcd8739ae039, "defaultProps", {
    isLoading: true,
    spinnerSize: (0, $7722a284baab0b09$export$7b93a10c0fefe3e3),
    contentsOpacity: (0, $7722a284baab0b09$export$3843c586a90b9cbf),
    loadingLabel: 'Loading table'
});

});
parcelRegister("j8nog", function(module, exports) {

$parcel$export(module.exports, "Container", () => $dee0e88678dae941$export$42a852a2b6b56249);
$parcel$export(module.exports, "ContentsContainer", () => $dee0e88678dae941$export$67c29eae8ae2137a);
$parcel$export(module.exports, "SpinnerContainer", () => $dee0e88678dae941$export$a5e06607a5ac6158);
/* eslint-disable @repo/internal/react/require-jsdoc */ /**
 * @jsxRuntime classic
 * @jsx jsx
 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $byn9U = parcelRequire("byn9U");
const $dee0e88678dae941$export$c335a80381ec61f5 = '--contents-opacity';
const $dee0e88678dae941$var$containerStyles = (0, $byn9U.css)({
    position: 'relative'
});
const $dee0e88678dae941$export$42a852a2b6b56249 = ({ children: children, testId: testId })=>(0, $byn9U.jsx)("div", {
        css: $dee0e88678dae941$var$containerStyles,
        "data-testid": testId && `${testId}--container`
    }, children);
const $dee0e88678dae941$var$contentsContainerStyles = (0, $byn9U.css)({
    opacity: `var(${$dee0e88678dae941$export$c335a80381ec61f5})`,
    pointerEvents: 'none'
});
const $dee0e88678dae941$export$67c29eae8ae2137a = ({ children: children, contentsOpacity: contentsOpacity, testId: testId })=>(0, $byn9U.jsx)("div", {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            [$dee0e88678dae941$export$c335a80381ec61f5]: contentsOpacity
        },
        css: [
            $dee0e88678dae941$var$contentsContainerStyles
        ],
        "data-testid": testId && `${testId}--contents--container`
    }, children);
const $dee0e88678dae941$var$spinnerContainerStyles = (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    inset: 0,
    alignItems: 'center',
    justifyContent: 'center'
});
const $dee0e88678dae941$export$a5e06607a5ac6158 = ({ children: children, testId: testId })=>(0, $byn9U.jsx)("div", {
        css: $dee0e88678dae941$var$spinnerContainerStyles,
        "data-testid": testId && `${testId}--spinner--container`
    }, children);

});


parcelRegister("i6VR9", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2f5aa9a93f2b1ce$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $hvCdF = parcelRequire("hvCdF");


var $fusPJ = parcelRequire("fusPJ");
class $d2f5aa9a93f2b1ce$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "spinnerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef());
        (0, $5zQU9.default)(this, "containerRef", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createRef());
        (0, $5zQU9.default)(this, "componentDidMount", ()=>{
            if (this.props.isLoading && this.hasTargetNode()) {
                this.attachListeners();
                this.updateTargetAppearance();
                this.updateSpinnerPosition();
            }
        });
        (0, $5zQU9.default)(this, "UNSAFE_componentWillReceiveProps", (nextProps)=>{
            if (!nextProps.isLoading || !this.hasTargetNode(nextProps)) this.detachListeners();
            else if (!this.props.isLoading) this.attachListeners();
        });
        (0, $5zQU9.default)(this, "componentDidUpdate", ()=>{
            if (this.hasTargetNode()) {
                this.updateTargetAppearance();
                if (this.props.isLoading) this.updateSpinnerPosition();
            }
        });
        (0, $5zQU9.default)(this, "componentWillUnmount", ()=>{
            this.detachListeners();
        });
        (0, $5zQU9.default)(this, "getTargetNode", (nextProps = this.props)=>{
            const { targetRef: targetRef } = nextProps;
            const target = targetRef === null || targetRef === void 0 ? void 0 : targetRef();
            return target || this.containerRef.current;
        });
        (0, $5zQU9.default)(this, "hasTargetNode", (nextProps)=>!!this.getTargetNode(nextProps));
        (0, $5zQU9.default)(this, "isVerticallyVisible", (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            if (bottom <= 0) return false;
            return top < viewportHeight;
        });
        (0, $5zQU9.default)(this, "isFullyVerticallyVisible", (elementRect, viewportHeight)=>{
            const { top: top, bottom: bottom } = elementRect;
            return top >= 0 && bottom <= viewportHeight;
        });
        (0, $5zQU9.default)(this, "handleResize", ()=>{
            this.updateSpinnerPosition();
        });
        (0, $5zQU9.default)(this, "handleScroll", ()=>{
            this.updateSpinnerPosition();
        });
        (0, $5zQU9.default)(this, "translateSpinner", (spinnerNode, transformY, isFixed)=>{
            spinnerNode.style.position = isFixed ? 'fixed' : '';
            spinnerNode.style.transform = transformY !== 0 ? `translate3d(0, ${transformY}px, 0)` : '';
        });
        (0, $5zQU9.default)(this, "updateTargetAppearance", ()=>{
            const targetNode = this.getTargetNode();
            const { isLoading: isLoading, contentsOpacity: contentsOpacity } = this.props;
            if (targetNode && targetNode.style && typeof targetNode.style === 'object') {
                targetNode.style.pointerEvents = isLoading ? 'none' : '';
                targetNode.style.opacity = isLoading ? contentsOpacity.toString() : '';
            }
        });
    }
    attachListeners() {
        window.addEventListener('scroll', this.handleScroll);
        window.addEventListener('resize', this.handleResize);
    }
    detachListeners() {
        window.removeEventListener('scroll', this.handleScroll);
        window.removeEventListener('resize', this.handleResize);
    }
    updateSpinnerPosition() {
        var _this$spinnerRef, _this$containerRef;
        const viewportHeight = window.innerHeight;
        const targetNode = this.getTargetNode();
        const spinnerNode = (_this$spinnerRef = this.spinnerRef) === null || _this$spinnerRef === void 0 ? void 0 : _this$spinnerRef.current;
        if (!targetNode || typeof targetNode.getBoundingClientRect !== 'function' || !spinnerNode) return;
        const targetRect = targetNode.getBoundingClientRect();
        const spinnerRect = spinnerNode.getBoundingClientRect();
        const spinnerHeight = spinnerRect.height;
        const isInViewport = this.isVerticallyVisible(targetRect, viewportHeight);
        const { top: top, bottom: bottom, height: height } = targetRect;
        if (isInViewport) {
            // The spinner may follow the element only if there is enough space:
            // Let's say the element can fit at least three spinners (vertically)
            const canFollow = height >= spinnerHeight * 3;
            if (canFollow && !this.isFullyVerticallyVisible(targetRect, viewportHeight)) {
                if (top >= 0) {
                    // Only the head of the element is visible
                    const viewportSpaceTakenByElement = viewportHeight - top;
                    const diff = viewportSpaceTakenByElement / 2 + top - spinnerHeight / 2;
                    const y = viewportSpaceTakenByElement < spinnerHeight * 3 ? top + spinnerHeight : diff;
                    this.translateSpinner(spinnerNode, y, true);
                } else if (top < 0 && bottom > viewportHeight) {
                    // The element takes all viewport, nor its head nor tail are visible
                    const y = viewportHeight / 2 - spinnerHeight / 2;
                    this.translateSpinner(spinnerNode, y, true);
                } else {
                    // Only the tail of the element is visible
                    const diff = bottom / 2 - spinnerHeight / 2;
                    const y = diff < spinnerHeight ? diff - (spinnerHeight - diff) : diff;
                    this.translateSpinner(spinnerNode, y, true);
                }
                return;
            }
        } else {
            // If both the element and the spinner are off screen - quit
            if (!this.isVerticallyVisible(spinnerRect, viewportHeight)) return;
        }
        // Three options here:
        // 1) the element is fully visible
        // 2) the element is too small for the spinner to follow
        // 3) the spinner might still be visible while the element isn't
        const containerNode = (_this$containerRef = this.containerRef) === null || _this$containerRef === void 0 ? void 0 : _this$containerRef.current;
        if (containerNode && typeof containerNode.getBoundingClientRect === 'function') {
            const thisTop = containerNode.getBoundingClientRect().top;
            const y = (top - thisTop) / 2;
            this.translateSpinner(spinnerNode, y, false);
        }
    }
    render() {
        const { children: children, isLoading: isLoading, spinnerSize: spinnerSize, testId: testId, loadingLabel: loadingLabel } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fusPJ.Container), {
            testId: testId && `${testId}--loading--container--advanced`,
            ref: this.containerRef
        }, children, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fusPJ.SpinnerBackdrop), {
            testId: testId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $fusPJ.SpinnerContainer), {
            ref: this.spinnerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $hvCdF.default), {
            size: spinnerSize,
            testId: testId && `${testId}--loadingSpinner`,
            label: loadingLabel
        }))));
    }
}
(0, $5zQU9.default)($d2f5aa9a93f2b1ce$export$2e2bcd8739ae039, "defaultProps", {
    isLoading: true,
    spinnerSize: (0, $7722a284baab0b09$export$7b93a10c0fefe3e3),
    contentsOpacity: `var(--ds-opacity-loading, ${`${(0, $7722a284baab0b09$export$3843c586a90b9cbf)}`})`,
    loadingLabel: 'Loading table'
});

});
parcelRegister("fusPJ", function(module, exports) {

$parcel$export(module.exports, "Container", () => $b4700613075c9019$export$42a852a2b6b56249);
$parcel$export(module.exports, "SpinnerBackdrop", () => $b4700613075c9019$export$aa207050321b0c53);
$parcel$export(module.exports, "SpinnerContainer", () => $b4700613075c9019$export$a5e06607a5ac6158);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");
const $b4700613075c9019$var$containerStyles = (0, $byn9U.css)({
    position: 'relative',
    marginBlockEnd: "var(--ds-space-300, 24px)"
});
const $b4700613075c9019$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $eUqFw.forwardRef)((props, ref)=>{
    const { children: children, testId: testId, ...rest } = props;
    return(// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    (0, $byn9U.jsx)("div", (0, $kU09D.default)({
        css: $b4700613075c9019$var$containerStyles
    }, rest, {
        "data-testid": testId,
        ref: ref
    }), children));
});
const $b4700613075c9019$var$spinnerBackdropStyles = (0, $byn9U.css)({
    display: 'flex',
    position: 'absolute',
    inset: 0,
    alignItems: 'center',
    justifyContent: 'center',
    pointerEvents: 'none'
});
const $b4700613075c9019$export$aa207050321b0c53 = ({ children: children, testId: testId })=>(0, $byn9U.jsx)("div", {
        css: $b4700613075c9019$var$spinnerBackdropStyles,
        "data-testid": testId && `${testId}--spinner-backdrop`
    }, children);
const $b4700613075c9019$var$spinnerContainerStyles = (0, $byn9U.css)({
    position: 'relative',
    // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
    insetBlockStart: 0
});
const $b4700613075c9019$export$a5e06607a5ac6158 = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ children: children }, ref)=>(0, $byn9U.jsx)("div", {
        css: $b4700613075c9019$var$spinnerContainerStyles,
        ref: ref
    }, children));

});


parcelRegister("2CQqO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1e97cd269ea406cc$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");

var $7slOM = parcelRequire("7slOM");
class $1e97cd269ea406cc$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(...args){
        super(...args);
        (0, $5zQU9.default)(this, "onChange", (_event, newValue, analyticsEvent)=>{
            this.props.onChange(newValue, analyticsEvent);
        });
    }
    render() {
        const { total: total, value: value = 1, i18n: i18n, testId: testId, isDisabled: isDisabled } = this.props;
        const pages = [
            ...Array(total)
        ].map((_, index)=>index + 1);
        // Pagination accepts array now thus selectedIndex starts with 0
        // So, we are substracting value by one thus not breaking dynamic table
        const selectedIndex = value - 1;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $7slOM.default), {
            selectedIndex: selectedIndex,
            isDisabled: isDisabled,
            label: i18n === null || i18n === void 0 ? void 0 : i18n.label,
            nextLabel: i18n === null || i18n === void 0 ? void 0 : i18n.next,
            previousLabel: i18n === null || i18n === void 0 ? void 0 : i18n.prev,
            pageLabel: i18n === null || i18n === void 0 ? void 0 : i18n.pageLabel,
            onChange: this.onChange,
            pages: pages,
            testId: testId && `${testId}--pagination`
        });
    }
}

});
parcelRegister("7slOM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ee48eb29fe1474e$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $2MblP = parcelRequire("2MblP");

var $hRu1S = parcelRequire("hRu1S");

var $2khQ8 = parcelRequire("2khQ8");

var $4syZl = parcelRequire("4syZl");

var $99Msg = parcelRequire("99Msg");

var $1QWP9 = parcelRequire("1QWP9");
var $c6J9g = parcelRequire("c6J9g");
var $gv7Ek = parcelRequire("gv7Ek");

var $c1WJv = parcelRequire("c1WJv");

var $cZhA3 = parcelRequire("cZhA3");

var $hgv5D = parcelRequire("hgv5D");

var $gsl6D = parcelRequire("gsl6D");

var $8b9AR = parcelRequire("8b9AR");
const $8ee48eb29fe1474e$var$analyticsAttributes = {
    componentName: 'pagination',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $8ee48eb29fe1474e$var$paginationMenuStyles = (0, $gv7Ek.xcss)({
    padding: 'space.0',
    margin: 'space.0'
});
const $8ee48eb29fe1474e$var$paginationMenuItemStyles = (0, $gv7Ek.xcss)({
    marginBlockStart: 'space.0'
});
const $8ee48eb29fe1474e$var$navigatorIconWrapperStyles = (0, $gv7Ek.xcss)({
    paddingInline: 'space.075'
});
function $8ee48eb29fe1474e$var$NavigatorIcon({ chevronDirection: chevronDirection }) {
    const Chevron = chevronDirection === 'left' ? (0, (/*@__PURE__*/$parcel$interopDefault($4syZl))) : (0, (/*@__PURE__*/$parcel$interopDefault($99Msg)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QWP9.default), {
        as: "span",
        xcss: $8ee48eb29fe1474e$var$navigatorIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(Chevron, {
        label: "",
        LEGACY_margin: `0 ${"var(--ds-space-negative-075, -6px)"}`,
        color: "currentColor"
    }));
}
function $8ee48eb29fe1474e$var$InnerPagination({ components: components = (0, $gsl6D.emptyObject), defaultSelectedIndex: defaultSelectedIndex = 0, selectedIndex: selectedIndex, label: label = 'pagination', pageLabel: pageLabel = 'page', previousLabel: previousLabel = 'previous', nextLabel: nextLabel = 'next', style: style = (0, $gsl6D.emptyObject), max: max = 7, onChange: onChange = (0, $hRu1S.default), pages: pages, getPageLabel: getPageLabel, renderEllipsis: renderEllipsis = (0, $hgv5D.default), analyticsContext: analyticsContext, testId: testId, isDisabled: isDisabled }, ref) {
    const [selectedIndexValue, setSelectedIndexValue] = (0, $2khQ8.default)(selectedIndex, ()=>defaultSelectedIndex || 0);
    const onChangeWithAnalytics = (0, $2MblP.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            const { event: event, selectedPageIndex: selectedPageIndex } = value;
            if (selectedIndex === undefined) setSelectedIndexValue(selectedPageIndex);
            if (onChange) onChange(event, pages[selectedPageIndex], analyticsEvent);
        },
        action: 'changed',
        actionSubject: 'pageNumber',
        analyticsData: analyticsContext,
        ...$8ee48eb29fe1474e$var$analyticsAttributes
    });
    const transform = (page, currPageIndex, testId)=>{
        const selectedPage = pages[selectedIndexValue];
        const pageIndexLabel = `${pageLabel} ${getPageLabel ? getPageLabel(page, currPageIndex) : page}`;
        const isCurrentPage = page === selectedPage;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c6J9g.default), {
            as: "li",
            xcss: $8ee48eb29fe1474e$var$paginationMenuItemStyles,
            key: `page-${getPageLabel ? getPageLabel(page, currPageIndex) : currPageIndex}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $cZhA3.default), {
            component: components.Page,
            onClick: (event)=>onChangeWithAnalytics({
                    event: event,
                    selectedPageIndex: currPageIndex
                }),
            "aria-current": isCurrentPage ? 'page' : undefined,
            "aria-label": pageIndexLabel,
            isSelected: isCurrentPage,
            isDisabled: isDisabled,
            page: page,
            testId: testId && `${testId}--${isCurrentPage ? 'current-' : ''}page-${currPageIndex}`
        }, getPageLabel ? getPageLabel(page, currPageIndex) : page));
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QWP9.default), {
        testId: testId,
        style: style,
        ref: ref,
        "aria-label": label,
        as: "nav"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c6J9g.default), {
        space: "space.0",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c1WJv.default), {
        key: "left-navigator",
        component: components.Previous,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue - 1
            }),
        isDisabled: isDisabled || selectedIndexValue === 0,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8ee48eb29fe1474e$var$NavigatorIcon, {
            chevronDirection: "left"
        }),
        "aria-label": previousLabel,
        testId: testId && `${testId}--left-navigator`
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c6J9g.default), {
        space: "space.0",
        alignBlock: "baseline",
        as: "ul",
        xcss: $8ee48eb29fe1474e$var$paginationMenuStyles
    }, (0, $8b9AR.default)(pages, selectedIndexValue, {
        max: max,
        ellipsis: renderEllipsis,
        transform: transform
    }, testId)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $c1WJv.default), {
        key: "right-navigator",
        component: components.Next,
        onClick: (event)=>onChangeWithAnalytics({
                event: event,
                selectedPageIndex: selectedIndexValue + 1
            }),
        isDisabled: isDisabled || selectedIndexValue === pages.length - 1,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement($8ee48eb29fe1474e$var$NavigatorIcon, {
            chevronDirection: "right"
        }),
        "aria-label": nextLabel,
        testId: testId && `${testId}--right-navigator`
    }))));
}
/**
 * __Pagination__
 *
 * Pagination allows you to divide large amounts of content into smaller chunks across multiple pages.
 *
 * - [Examples](https://atlassian.design/components/pagination/examples)
 * - [Code](https://atlassian.design/components/pagination/code)
 * - [Usage](https://atlassian.design/components/pagination/usage)
 */ const $8ee48eb29fe1474e$var$Pagination = /*#__PURE__*/ (0, $eUqFw.memo)(/*#__PURE__*/ (0, $eUqFw.forwardRef)($8ee48eb29fe1474e$var$InnerPagination));
var $8ee48eb29fe1474e$export$2e2bcd8739ae039 = $8ee48eb29fe1474e$var$Pagination;

});
parcelRegister("4syZl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::17932ebf54d3f380634494a3a0e710ce>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $33f4eaede87f0392$var$_react = $33f4eaede87f0392$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $33f4eaede87f0392$var$_chevronLeft = $33f4eaede87f0392$var$_interopRequireDefault((parcelRequire("gfOy5")));

var $33f4eaede87f0392$var$_chevronLeftLarge = $33f4eaede87f0392$var$_interopRequireDefault((parcelRequire("dTA28")));
function $33f4eaede87f0392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $33f4eaede87f0392$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $33f4eaede87f0392$var$_react.default.createElement($33f4eaede87f0392$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $33f4eaede87f0392$var$_chevronLeftLarge.default
    }, props));
$33f4eaede87f0392$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $33f4eaede87f0392$var$_default = module.exports.default = $33f4eaede87f0392$var$ChevronLeftIcon;

});
parcelRegister("gfOy5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::53517bd082840f7b30aeaa6b952f5491>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bd5541fc28ba8605$var$_react = $bd5541fc28ba8605$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $bd5541fc28ba8605$var$_UNSAFE_baseNew = $bd5541fc28ba8605$var$_interopRequireDefault((parcelRequire("dJmwA")));
function $bd5541fc28ba8605$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 * Please reach out in #icon-contributions before using these in production.
 *
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bd5541fc28ba8605$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $bd5541fc28ba8605$var$_react.default.createElement($bd5541fc28ba8605$var$_UNSAFE_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path stroke="currentcolor" stroke-linejoin="round" stroke-width="1.5" d="M7.5 10.5 3 6l4.5-4.5"/>`,
        type: 'utility'
    }, props));
$bd5541fc28ba8605$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $bd5541fc28ba8605$var$_default = module.exports.default = $bd5541fc28ba8605$var$ChevronLeftIcon;

});

parcelRegister("dTA28", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a1dc5ce714d33e80$var$_react = $a1dc5ce714d33e80$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $a1dc5ce714d33e80$var$_chevronLeft = $a1dc5ce714d33e80$var$_interopRequireDefault((parcelRequire("gfOy5")));
function $a1dc5ce714d33e80$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a1dc5ce714d33e80$var$ChevronLeftLargeIcon = (props)=>/*#__PURE__*/ $a1dc5ce714d33e80$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m9.005 10.995 4.593-4.593a.99.99 0 1 1 1.4 1.4l-3.9 3.9 3.9 3.9a.99.99 0 0 1-1.4 1.4L9.005 12.41a1 1 0 0 1 0-1.414"/></svg>`
    }, props, {
        newIcon: $a1dc5ce714d33e80$var$_chevronLeft.default,
        iconType: "utility"
    }));
$a1dc5ce714d33e80$var$ChevronLeftLargeIcon.displayName = 'ChevronLeftLargeIcon';
var $a1dc5ce714d33e80$var$_default = module.exports.default = $a1dc5ce714d33e80$var$ChevronLeftLargeIcon;

});


parcelRegister("99Msg", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1ef383524276f158d595d267ad16f45a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6aaa8a6efb1ca2ae$var$_react = $6aaa8a6efb1ca2ae$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $6aaa8a6efb1ca2ae$var$_chevronRight = $6aaa8a6efb1ca2ae$var$_interopRequireDefault((parcelRequire("5pjc5")));

var $6aaa8a6efb1ca2ae$var$_chevronRightLarge = $6aaa8a6efb1ca2ae$var$_interopRequireDefault((parcelRequire("hlCy5")));
function $6aaa8a6efb1ca2ae$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * ⚠️ EXPERIMENTAL ⚠️ - New icons are in alpha - and subject to change or removal in future minor or patch releases.
 *
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6aaa8a6efb1ca2ae$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $6aaa8a6efb1ca2ae$var$_react.default.createElement($6aaa8a6efb1ca2ae$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $6aaa8a6efb1ca2ae$var$_chevronRightLarge.default
    }, props));
$6aaa8a6efb1ca2ae$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $6aaa8a6efb1ca2ae$var$_default = module.exports.default = $6aaa8a6efb1ca2ae$var$ChevronRightIcon;

});
parcelRegister("hlCy5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ca124cd787e2ecfb$var$_react = $ca124cd787e2ecfb$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $ca124cd787e2ecfb$var$_chevronRight = $ca124cd787e2ecfb$var$_interopRequireDefault((parcelRequire("5pjc5")));
function $ca124cd787e2ecfb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $ca124cd787e2ecfb$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $ca124cd787e2ecfb$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $ca124cd787e2ecfb$var$_chevronRight.default,
        iconType: "utility"
    }));
$ca124cd787e2ecfb$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $ca124cd787e2ecfb$var$_default = module.exports.default = $ca124cd787e2ecfb$var$ChevronRightLargeIcon;

});


parcelRegister("c1WJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $84ce945067b08452$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8fGGK = parcelRequire("8fGGK");
function $84ce945067b08452$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fGGK.default), {
        "aria-label": props['aria-label'],
        isDisabled: props.isDisabled,
        iconBefore: props.iconBefore,
        testId: props.testId,
        onClick: props.onClick,
        component: props.component,
        appearance: "subtle"
    });
}

});

parcelRegister("cZhA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb4b4a36635e0146$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $8fGGK = parcelRequire("8fGGK");
function $cb4b4a36635e0146$export$2e2bcd8739ae039(props) {
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8fGGK.default), {
        ...props,
        appearance: "subtle"
    });
}

});

parcelRegister("hgv5D", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ce6ee3ae330d9f8$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $1QWP9 = parcelRequire("1QWP9");
var $ixqNN = parcelRequire("ixqNN");
var $gv7Ek = parcelRequire("gv7Ek");

var $lWrn5 = parcelRequire("lWrn5");
const $6ce6ee3ae330d9f8$var$containerStyles = (0, $gv7Ek.xcss)({
    display: 'flex',
    position: 'relative'
});
function $6ce6ee3ae330d9f8$export$2e2bcd8739ae039({ key: key, testId: testId, from: from, to: to }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $1QWP9.default), {
        as: "li",
        testId: testId,
        key: key,
        xcss: $6ce6ee3ae330d9f8$var$containerStyles,
        paddingInline: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $ixqNN.default), {
        testId: testId && `${testId}-text`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lWrn5.default), null, "Skipped pages from ", from, " to ", to), "\u2026"));
}

});

parcelRegister("gsl6D", function(module, exports) {

$parcel$export(module.exports, "emptyObject", () => $d5d819e3c8995b9e$export$3f860eba1218f8d3);
const $d5d819e3c8995b9e$export$3f860eba1218f8d3 = {};

});

parcelRegister("8b9AR", function(module, exports) {

$parcel$export(module.exports, "default", () => $30c1a279efc64250$export$2e2bcd8739ae039);

var $5iWql = parcelRequire("5iWql");
// TODO: comma needed after generic declaration below, or the .tsx file thinks
// it is a JSX element. Tidy up in a future refactor.
const $30c1a279efc64250$var$collapseRange = (pages, current, { max: max, ellipsis: ellipsis, transform: transform }, testId)=>{
    const total = pages.length;
    // only need ellipsis if we have more pages than we can display
    const needEllipsis = total > max;
    // show start ellipsis if the current page is further away than max - 4 from the first page
    const hasStartEllipsis = needEllipsis && max - 4 < current;
    // show end ellipsis if the current page is further than total - max + 3 from the last page
    const hasEndEllipsis = needEllipsis && current < total - max + 3;
    const getPageComponents = (0, $5iWql.default)((startIndex = 0, lastIndex = total)=>{
        return pages.slice(startIndex, lastIndex).map((page, index)=>transform(page, startIndex + index, testId));
    });
    if (!needEllipsis) return getPageComponents(0, total);
    if (hasStartEllipsis && !hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, 1),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: 2,
                to: total - pageCount
            }),
            ...getPageComponents(total - pageCount)
        ];
    }
    if (!hasStartEllipsis && hasEndEllipsis) {
        const pageCount = max - 2;
        return [
            ...getPageComponents(0, pageCount),
            ellipsis({
                key: 'ellipsis-1',
                testId: testId && `${testId}-ellipsis`,
                from: pageCount + 1,
                to: total - 1
            }),
            ...getPageComponents(total - 1)
        ];
    }
    // we have both start and end ellipsis
    const pageCount = max - 4;
    return [
        ...getPageComponents(0, 1),
        ellipsis({
            key: 'ellipsis-1',
            testId: testId && `${testId}-ellipsis`,
            from: 2,
            to: current - Math.floor(pageCount / 2)
        }),
        ...getPageComponents(current - Math.floor(pageCount / 2), current + pageCount - 1),
        ellipsis({
            key: 'ellipsis-2',
            testId: testId && `${testId}-ellipsis`,
            from: current + 3,
            to: total - 1
        }),
        ...getPageComponents(total - 1)
    ];
};
var $30c1a279efc64250$export$2e2bcd8739ae039 = $30c1a279efc64250$var$collapseRange;

});



parcelRegister("7m5wg", function(module, exports) {

$parcel$export(module.exports, "default", () => $55aede84dac80b17$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $iigy9 = parcelRequire("iigy9");

var $dnjdP = parcelRequire("dnjdP");

var $9kNG3 = parcelRequire("9kNG3");

var $8mSJI = parcelRequire("8mSJI");
class $55aede84dac80b17$var$TableHead extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    UNSAFE_componentWillMount() {
        (0, $iigy9.validateSortKey)(this.props.sortKey, this.props.head);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.sortKey !== nextProps.sortKey || this.props.head !== nextProps.head) (0, $iigy9.validateSortKey)(nextProps.sortKey, nextProps.head);
    }
    render() {
        const { head: head, sortKey: sortKey, sortOrder: sortOrder, isFixedSize: isFixedSize, onSort: onSort, isRanking: isRanking, isRankable: isRankable, testId: testId } = this.props;
        if (!head) return null;
        const HeadCellComponent = isRankable ? (0, $9kNG3.default) : (0, $8mSJI.default);
        // TODO: Remove `rest` props and use only what is explicitly in the API.
        // Some tests use this to pass in onClick and other stuff within the `head`
        // variable here, but considering it's not in the API, it should probably
        // be removed.
        const { cells: cells, ...rest } = head;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnjdP.Head), (0, $kU09D.default)({}, rest, {
            isRanking: isRanking,
            testId: testId && `${testId}--head`
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("tr", null, cells.map((cell, index)=>{
            const { colSpan: colSpan, content: content, isSortable: isSortable, key: key, shouldTruncate: shouldTruncate, testId: cellTestId, width: width, // TODO: Remove `rest` props and use only what is explicitly in
            // the API.
            ...restCellProps } = cell;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(HeadCellComponent, (0, $kU09D.default)({
                colSpan: colSpan,
                content: content,
                isFixedSize: isFixedSize,
                isSortable: !!isSortable,
                isRanking: isRanking,
                key: key || index,
                onClick: isSortable ? onSort(cell) : undefined,
                testId: cellTestId || testId,
                shouldTruncate: shouldTruncate,
                sortOrder: key === sortKey ? sortOrder : undefined,
                width: width
            }, restCellProps));
        })));
    }
}
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$55aede84dac80b17$export$2e2bcd8739ae039 = $55aede84dac80b17$var$TableHead;

});
parcelRegister("dnjdP", function(module, exports) {

$parcel$export(module.exports, "Head", () => $9bcc556d0d90c1d5$export$e93312b7773dfcac);
$parcel$export(module.exports, "HeadCell", () => $9bcc556d0d90c1d5$export$4e8024263ace498b);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $byn9U = parcelRequire("byn9U");



var $8RtNA = parcelRequire("8RtNA");

var $7tD15 = parcelRequire("7tD15");
const $9bcc556d0d90c1d5$var$CSS_VAR_TEXT_COLOR = '--local-dynamic-table-text-color';
const $9bcc556d0d90c1d5$var$rankingStyles = (0, $byn9U.css)({
    display: 'block'
});
const $9bcc556d0d90c1d5$var$headStyles = (0, $byn9U.css)({
    borderBlockEnd: `none`
});
const $9bcc556d0d90c1d5$export$e93312b7773dfcac = ({ isRanking: isRanking, testId: testId, ...props })=>{
    return (0, $byn9U.jsx)("thead", (0, $kU09D.default)({
        css: [
            $9bcc556d0d90c1d5$var$headStyles,
            isRanking && $9bcc556d0d90c1d5$var$rankingStyles
        ],
        "data-testid": testId
    }, props));
};
const $9bcc556d0d90c1d5$var$headCellBaseStyles = (0, $byn9U.css)({
    boxSizing: 'border-box',
    position: 'relative',
    border: 'none',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderBlockEnd: `2px solid ${(0, $8RtNA.tableBorder).borderColor}`,
    color: `var(--ds-text-subtlest, ${`var(${$9bcc556d0d90c1d5$var$CSS_VAR_TEXT_COLOR})`})`,
    font: "var(--ds-font-heading-xxsmall, normal 600 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, system-ui, \"Helvetica Neue\", sans-serif)",
    textAlign: 'left',
    verticalAlign: 'top',
    '&:focus-visible': {
        outline: `solid 2px ${`var(--ds-border-focused, ${(0, $ab6d6432a4c55680$export$ecfc1dff386a3e7a)})`}`
    }
});
const $9bcc556d0d90c1d5$var$onClickStyles = (0, $byn9U.css)({
    '&:hover': {
        backgroundColor: `var(--ds-background-neutral-hovered, ${(0, $ab6d6432a4c55680$export$920c0d5c49070351)})`,
        cursor: 'pointer'
    }
});
const $9bcc556d0d90c1d5$var$baseStyles = (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        padding: "var(--ds-space-0, 0)",
        position: 'relative',
        appearance: 'none',
        background: 'none',
        border: 'none',
        color: 'inherit',
        cursor: 'inherit',
        fontSize: 'inherit',
        fontWeight: 'inherit',
        '&::before, &::after': {
            display: 'block',
            width: 0,
            height: 0,
            position: 'absolute',
            border: '3px solid transparent',
            content: '""',
            insetInlineEnd: "var(--ds-space-negative-100, -8px)"
        },
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $8RtNA.arrow).defaultColor}`,
            insetBlockEnd: "var(--ds-space-100, 8px)"
        },
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $8RtNA.arrow).defaultColor}`,
            insetBlockEnd: 0
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before, &::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                border: `3px solid ${(0, $8RtNA.MSThemeColors).Background}`
            },
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $8RtNA.MSThemeColors).Text}`
            },
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $8RtNA.MSThemeColors).Text}`
            }
        }
    }
});
const $9bcc556d0d90c1d5$var$ascendingStyles = (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::before': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockEnd: `3px solid ${(0, $8RtNA.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::before': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockEnd: `3px solid ${(0, $8RtNA.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $9bcc556d0d90c1d5$var$descendingStyles = (0, $byn9U.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& > button': {
        '&::after': {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            borderBlockStart: `3px solid ${(0, $8RtNA.arrow).selectedColor}`
        }
    },
    '@media (forced-colors: active)': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '& > button': {
            '&::after': {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
                borderBlockStart: `3px solid ${(0, $8RtNA.MSThemeColors).SelectedBackground}`
            }
        }
    }
});
const $9bcc556d0d90c1d5$export$4e8024263ace498b = /*#__PURE__*/ (0, $eUqFw.forwardRef)(({ width: width, children: children, isSortable: isSortable, sortOrder: sortOrder, isFixedSize: isFixedSize, shouldTruncate: shouldTruncate, onClick: onClick, style: style, testId: testId, ...rest }, ref)=>{
    const mergedStyles = {
        ...style,
        ...width && (0, $7tD15.getTruncationStyleVars)({
            width: width
        }),
        [$9bcc556d0d90c1d5$var$CSS_VAR_TEXT_COLOR]: (0, $8RtNA.head).textColor
    };
    const isASC = sortOrder === (0, $7722a284baab0b09$export$1dee026a19752d6b);
    const isDESC = sortOrder === (0, $7722a284baab0b09$export$b6abcf7fa1d94f65);
    const getFormattedSortOrder = ()=>{
        if (isASC) return 'ascending';
        else if (isDESC) return 'descending';
    };
    // If there is no content in the cell, it should be rendered as an empty `td`, not a `th`.
    // https://dequeuniversity.com/rules/axe/4.7/empty-table-header
    const Component = children ? 'th' : 'td';
    return (0, $byn9U.jsx)(Component, (0, $kU09D.default)({
        "aria-sort": getFormattedSortOrder(),
        style: mergedStyles,
        css: [
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7tD15.cellStyles),
            $9bcc556d0d90c1d5$var$headCellBaseStyles,
            onClick && $9bcc556d0d90c1d5$var$onClickStyles,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            (0, $7tD15.truncationWidthStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && shouldTruncate && (0, $7tD15.fixedSizeTruncateStyles),
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            isFixedSize && (0, $7tD15.overflowTruncateStyles),
            isSortable && $9bcc556d0d90c1d5$var$baseStyles,
            isASC && $9bcc556d0d90c1d5$var$ascendingStyles,
            isDESC && $9bcc556d0d90c1d5$var$descendingStyles
        ],
        onClick: onClick,
        ref: ref,
        "data-testid": testId
    }, rest), children);
});

});

parcelRegister("9kNG3", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cbc843469d05c34$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $79qKc = parcelRequire("79qKc");

var $iigy9 = parcelRequire("iigy9");

var $8mSJI = parcelRequire("8mSJI");
class $6cbc843469d05c34$var$RankableTableHeadCellComponent extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    render() {
        const { isRanking: isRanking, refHeight: refHeight, refWidth: refWidth, ...restProps } = this.props;
        const inlineStyles = (0, $iigy9.inlineStylesIfRanking)(isRanking, refWidth);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $8mSJI.default), (0, $kU09D.default)({
            inlineStyles: inlineStyles
        }, restProps));
    }
}
const $6cbc843469d05c34$var$RankableTableHeadCell = (0, $79qKc.default)($6cbc843469d05c34$var$RankableTableHeadCellComponent);
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$6cbc843469d05c34$export$2e2bcd8739ae039 = $6cbc843469d05c34$var$RankableTableHeadCell;

});
parcelRegister("79qKc", function(module, exports) {

$parcel$export(module.exports, "default", () => $534e1e7b55018cfd$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $5zQU9 = parcelRequire("5zQU9");

var $eUqFw = parcelRequire("eUqFw");
function $534e1e7b55018cfd$export$2e2bcd8739ae039(WrappedComponent) {
    return class WithDimensions extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
        constructor(...args){
            super(...args);
            (0, $5zQU9.default)(this, "state", {
                refWidth: 0,
                refHeight: 0
            });
            (0, $5zQU9.default)(this, "innerRef", (ref)=>{
                if (ref && !this.props.isRanking) this.ref = ref;
            });
            (0, $5zQU9.default)(this, "updateDimensions", ()=>{
                if (!this.ref) return;
                const clientRect = this.ref.getBoundingClientRect();
                const { width: width } = clientRect;
                const { height: height } = clientRect;
                if (width !== this.state.refWidth || height !== this.state.refHeight) this.setState({
                    refWidth: width,
                    refHeight: height
                });
            });
        }
        UNSAFE_componentWillReceiveProps(nextProps) {
            const wasRanking = this.props.isRanking;
            const willRanking = nextProps.isRanking;
            if (willRanking && !wasRanking) this.updateDimensions();
        }
        render() {
            const { refWidth: refWidth, refHeight: refHeight } = this.state;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement(WrappedComponent, (0, $kU09D.default)({
                refWidth: refWidth,
                refHeight: refHeight,
                innerRef: this.innerRef
            }, this.props));
        }
    };
}

});

parcelRegister("8mSJI", function(module, exports) {

$parcel$export(module.exports, "default", () => $617ad649faaab95c$export$2e2bcd8739ae039);

var $kU09D = parcelRequire("kU09D");

var $eUqFw = parcelRequire("eUqFw");

var $dnjdP = parcelRequire("dnjdP");
const $617ad649faaab95c$var$TableHeadCell = ({ content: content, inlineStyles: inlineStyles, testId: testId, isRanking: isRanking, innerRef: innerRef, isSortable: isSortable, onClick: onClick, ...rest })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $dnjdP.HeadCell), (0, $kU09D.default)({
        style: inlineStyles,
        testId: testId && `${testId}--head--cell`,
        ref: typeof innerRef !== 'string' ? innerRef : null // string refs must be discarded as LegacyRefs are not compatible with FC forwardRefs
    }, rest, {
        onClick: onClick,
        isSortable: isSortable
    }), isSortable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement("button", {
        type: "button",
        "aria-roledescription": "Sort button"
    }, content) : content);
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$617ad649faaab95c$export$2e2bcd8739ae039 = $617ad649faaab95c$var$TableHeadCell;

});



parcelRegister("kBJ8Z", function(module, exports) {

var $d1Cng = parcelRequire("d1Cng");
module.exports = $d1Cng("i5BiE").then(()=>parcelRequire('cnPhA'));

});



parcelRegister("lkKLg", function(module, exports) {

$parcel$export(module.exports, "default", () => $f87fbd0e3d44be98$export$2e2bcd8739ae039);

var $cuo8k = parcelRequire("cuo8k");
const $f87fbd0e3d44be98$var$FILTER_OPTIONS = [
    {
        label: 'All requests',
        value: 'ALL'
    },
    {
        label: 'Open requests',
        value: (0, $cuo8k.RequestStatus).OPEN
    },
    {
        label: 'Installed requests',
        value: (0, $cuo8k.RequestStatus).INSTALLED
    },
    {
        label: 'Rejected requests',
        value: (0, $cuo8k.RequestStatus).REJECTED
    }
];
var $f87fbd0e3d44be98$export$2e2bcd8739ae039 = $f87fbd0e3d44be98$var$FILTER_OPTIONS;

});

parcelRegister("hVwsq", function(module, exports) {

$parcel$export(module.exports, "useAppRequests", () => $d0d0efeae9243d3d$export$274092d74e5a802a);
$parcel$export(module.exports, "useAppRequestComments", () => $d0d0efeae9243d3d$export$c8a5f12554b3f7ea);

var $5zQU9 = parcelRequire("5zQU9");

var $bavaN = parcelRequire("bavaN");

var $buxnS = parcelRequire("buxnS");

var $9c9Gu = parcelRequire("9c9Gu");
var $bTrQR = parcelRequire("bTrQR");

var $eUqFw = parcelRequire("eUqFw");

var $cMIj9 = parcelRequire("cMIj9");

var $gRo3n = parcelRequire("gRo3n");
function $d0d0efeae9243d3d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d0d0efeae9243d3d$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d0d0efeae9243d3d$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d0d0efeae9243d3d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $d0d0efeae9243d3d$export$274092d74e5a802a = (bootstrapConfig, algoliaClient, appRequestDefaultParams)=>{
    if (!appRequestDefaultParams.cloudId) return {
        appRequestsError: "Couldn't fetch cloud id  from Host info",
        appRequestsPending: false,
        appRequestsResult: null
    };
    const appRequestPromise = async ()=>{
        const appRequestsRes = await (0, $gRo3n.getAppRequests)(appRequestDefaultParams.productName, appRequestDefaultParams.cloudId);
        const appRequestsWithoutAppDetails = appRequestsRes.allAppRequestDetails;
        const appDetails = await (0, $bavaN.getAppDetailsByAppKeys)(algoliaClient, bootstrapConfig.algolia.environment, appRequestsWithoutAppDetails.map((appRequest)=>appRequest.appKey));
        const appDetailsMap = appDetails.content.hits.reduce((result, hit)=>{
            result[hit.addonKey] = {
                logo: "".concat(bootstrapConfig.mpacCdnBaseUrl, "/files/").concat(hit.logo.image),
                name: hit.name,
                priceType: hit.version.paid ? (0, $buxnS.PAID_PRICING) : (0, $buxnS.FREE_PRICING),
                appKey: hit.addonKey,
                ratings: {
                    avgStars: hit.ratings.avgStars,
                    numRatings: hit.ratings.numRatings
                },
                activeInstalls: hit.distribution.activeInstalls,
                downloads: hit.distribution.downloads
            };
            return result;
        }, {});
        const appRequests = appRequestsWithoutAppDetails.filter((appRequestWithoutAppDetails)=>{
            const hasAlgoliaReturnedDetails = !!appDetailsMap[appRequestWithoutAppDetails.appKey];
            if (!hasAlgoliaReturnedDetails) (0, $bTrQR.default).error('ManageAppRequests/hooks', "Algolia returned no result for AppKey: ".concat(appRequestWithoutAppDetails.appKey));
            return hasAlgoliaReturnedDetails;
        }).map((appRequestWithoutAppDetails)=>$d0d0efeae9243d3d$var$_objectSpread($d0d0efeae9243d3d$var$_objectSpread({}, appRequestWithoutAppDetails), {}, {
                appDetails: appDetailsMap[appRequestWithoutAppDetails.appKey]
            }));
        return appRequests;
    };
    const { result: result, error: error, pending: pending } = (0, $9c9Gu).usePromise(appRequestPromise);
    if (error) (0, $bTrQR.default).error('ManageAppRequests/hooks', "Failed to retrieve App requests", {
        error: error
    });
    return {
        appRequestsPending: pending,
        appRequestsError: error,
        appRequestsResult: result
    };
};
const $d0d0efeae9243d3d$export$13c84d35c39aa649 = (mountPath)=>{
    const [emceeBaseUrl, setEmceeBaseUrl] = (0, $eUqFw.useState)('');
    (0, $eUqFw.useEffect)(()=>{
        (0, $cMIj9.getEmceeLocation)((_ref)=>{
            let { baseURL: baseURL } = _ref;
            return setEmceeBaseUrl(baseURL);
        }, mountPath);
    }, []);
    return emceeBaseUrl;
};
const $d0d0efeae9243d3d$export$c8a5f12554b3f7ea = (appRequestCommentsParams)=>{
    var _result$appRequestDet;
    const { result: result, error: error, pending: pending } = (0, $9c9Gu).usePromise(()=>(0, $gRo3n.getAppRequestComments)(appRequestCommentsParams));
    if (error) (0, $bTrQR.default).error('ManageAppRequests/hooks', "Failed to retrieve App request comments", {
        error: error
    });
    return {
        pending: pending,
        error: error,
        comments: (_result$appRequestDet = result === null || result === void 0 ? void 0 : result.appRequestDetails) !== null && _result$appRequestDet !== void 0 ? _result$appRequestDet : []
    };
};

});

parcelRegister("7FJt7", function(module, exports) {

$parcel$export(module.exports, "AppRequestTable", () => $595fa1e3008d7fdd$export$31664a29d9c8bee0);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j8E8v = parcelRequire("j8E8v");

var $gykb8 = parcelRequire("gykb8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $buxnS = parcelRequire("buxnS");
var $cuo8k = parcelRequire("cuo8k");

var $8U0Ec = parcelRequire("8U0Ec");

var $76fzC = parcelRequire("76fzC");

var $EN9B6 = parcelRequire("EN9B6");

var $kociE = parcelRequire("kociE");
parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $jvfLT = parcelRequire("jvfLT");

var $bgtBL = parcelRequire("bgtBL");

var $dxvng = parcelRequire("dxvng");

var $iFcgt = parcelRequire("iFcgt");

var $2uIYU = parcelRequire("2uIYU");

var $4g4re = parcelRequire("4g4re");

var $lHkHI = parcelRequire("lHkHI");
function $595fa1e3008d7fdd$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $595fa1e3008d7fdd$var$NameWrapper = (0, $3UXZ8.default)("span", {
    target: "ewup3x80",
    label: "NameWrapper"
})({
    name: "70qvj9",
    styles: "display:flex;align-items:center;"
});
const $595fa1e3008d7fdd$var$AvatarWrapper = (0, $3UXZ8.default)("div", {
    target: "ewup3x81",
    label: "AvatarWrapper"
})("width:32px;height:32px;margin-right:", (props)=>props.isAlternativeLayout ? 0 : 12, "px;");
const $595fa1e3008d7fdd$var$Avatar = (0, $3UXZ8.default)("img", {
    target: "ewup3x82",
    label: "Avatar"
})({
    name: "uwwqev",
    styles: "width:100%;height:100%;"
});
const $595fa1e3008d7fdd$var$statusAppearance = {
    [(0, $cuo8k.RequestStatus).OPEN]: 'inprogress',
    [(0, $cuo8k.RequestStatus).REJECTED]: 'removed',
    [(0, $cuo8k.RequestStatus).INSTALLED]: 'success'
};
const $595fa1e3008d7fdd$var$priceAppearance = {
    [(0, $buxnS.FREE_PRICING)]: 'success',
    [(0, $buxnS.PAID_PRICING)]: 'default'
};
const $595fa1e3008d7fdd$export$592001b458791d7f = Object.freeze({
    [(0, $cuo8k.RequestStatus).OPEN]: 'inprogress',
    [(0, $cuo8k.RequestStatus).REJECTED]: 'removed',
    [(0, $cuo8k.RequestStatus).INSTALLED]: 'success'
});
const $595fa1e3008d7fdd$var$AnalyticsLink = (0, $9osuT.withAnalytics)((props)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
        href: props.href,
        target: "_blank",
        onClick: ()=>{
            props.fireAnalyticsEvent({
                eventType: (0, $gaiog.LinkClickedEvent),
                actionSubjectId: props.actionSubjectId,
                objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_REQUESTS),
                objectId: props.appKey
            });
        },
        children: props.text
    }));
const $595fa1e3008d7fdd$var$getCurrentRequestStatus = (givenStatus, appKey, rejectedKeys)=>rejectedKeys.includes(appKey) ? (0, $cuo8k.RequestStatus).REJECTED : givenStatus;
const $595fa1e3008d7fdd$export$5fd5031fecdacec3 = {
    cells: [
        {
            key: 'appDetails',
            content: 'App details',
            isSortable: true,
            width: 39
        },
        {
            key: 'requestCount',
            content: 'No. of requests',
            shouldTruncate: true,
            isSortable: true,
            width: 12
        },
        {
            key: 'requestDate',
            content: 'Date of request',
            shouldTruncate: true,
            isSortable: true,
            width: 14
        },
        {
            key: 'cost',
            content: 'Cost',
            isSortable: true,
            shouldTruncate: true,
            width: 8
        },
        {
            key: 'status',
            content: 'Status',
            shouldTruncate: true,
            width: 10
        },
        {
            key: 'more',
            content: 'More',
            shouldTruncate: true,
            width: 12
        },
        {
            key: 'droplist',
            width: 5
        }
    ]
};
const $595fa1e3008d7fdd$export$419ef4df16caa8ff = {
    cells: [
        {
            key: 'appDetails',
            content: 'App',
            isSortable: true,
            width: 39
        },
        {
            key: 'type',
            content: 'Type',
            isSortable: true,
            shouldTruncate: true,
            width: 8
        },
        {
            key: 'requestCount',
            content: 'Request count',
            shouldTruncate: true,
            isSortable: true,
            width: 12
        },
        {
            key: 'requestDate',
            content: 'Requested date',
            shouldTruncate: true,
            isSortable: true,
            width: 14
        },
        {
            key: 'status',
            content: 'Status',
            shouldTruncate: true,
            width: 12
        },
        {
            key: 'droplist',
            content: 'Actions',
            width: 5
        }
    ]
};
const $595fa1e3008d7fdd$export$a53d0e649387d13c = (appRequest, searchText)=>searchText.length === 0 || appRequest.appDetails.name.toLowerCase().includes(searchText.toLowerCase());
const $595fa1e3008d7fdd$export$422b458f5f3e92c9 = (status, filterOption)=>filterOption.value === 'ALL' || filterOption.value === status;
const $595fa1e3008d7fdd$export$ba72dc2d10ce40e5 = (appRequests, filter, rejectedKeys)=>{
    return appRequests.filter((appRequest)=>$595fa1e3008d7fdd$export$a53d0e649387d13c(appRequest, filter.bySearch)).filter((appRequest)=>$595fa1e3008d7fdd$export$422b458f5f3e92c9($595fa1e3008d7fdd$var$getCurrentRequestStatus(appRequest.status, appRequest.appDetails.appKey, rejectedKeys), filter.byStatus));
};
const $595fa1e3008d7fdd$export$31664a29d9c8bee0 = {
    Original: {
        head: $595fa1e3008d7fdd$export$5fd5031fecdacec3,
        getRows: (_ref)=>{
            let { appRequests: appRequests, getAppListingLink: getAppListingLink, filter: filter, appRequestDefaultParams: appRequestDefaultParams, onReject: onReject, rejectedKeys: rejectedKeys } = _ref;
            const filteredRows = $595fa1e3008d7fdd$export$ba72dc2d10ce40e5(appRequests, filter, rejectedKeys);
            return filteredRows.map((appRequest)=>{
                const appDetailsLink = getAppListingLink({
                    appKey: appRequest.appDetails.appKey
                });
                const status = $595fa1e3008d7fdd$var$getCurrentRequestStatus(appRequest.status, appRequest.appDetails.appKey, rejectedKeys);
                return {
                    key: "row-".concat(appRequest.appDetails.appKey),
                    cells: [
                        {
                            key: appRequest.appDetails.appKey,
                            content: /*#__PURE__*/ (0, $lHkHI.jsxs)($595fa1e3008d7fdd$var$NameWrapper, {
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsx)($595fa1e3008d7fdd$var$AvatarWrapper, {
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8U0Ec.default), {
                                            children: /*#__PURE__*/ (0, $lHkHI.jsx)($595fa1e3008d7fdd$var$Avatar, {
                                                alt: "",
                                                src: appRequest.appDetails.logo
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsx)($595fa1e3008d7fdd$var$AnalyticsLink, {
                                        href: appDetailsLink,
                                        text: appRequest.appDetails.name,
                                        actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_VIEW_APP_DETAILS),
                                        appKey: appRequest.appDetails.appKey
                                    })
                                ]
                            })
                        },
                        {
                            key: appRequest.requestCount,
                            content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $iFcgt.default), {
                                appKey: appRequest.appDetails.appKey,
                                appName: appRequest.appDetails.name,
                                cloudId: appRequestDefaultParams.cloudId,
                                productName: appRequestDefaultParams.productName,
                                appDetailsLink: appDetailsLink,
                                requestCount: appRequest.requestCount
                            })
                        },
                        {
                            key: appRequest.lastRequestedDate,
                            content: (0, $76fzC).longDate(appRequest.lastRequestedDate)
                        },
                        {
                            key: appRequest.appDetails.priceType,
                            content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j8E8v.default), {
                                appearance: $595fa1e3008d7fdd$var$priceAppearance[appRequest.appDetails.priceType],
                                children: appRequest.appDetails.priceType
                            })
                        },
                        {
                            key: status,
                            content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j8E8v.default), {
                                appearance: $595fa1e3008d7fdd$var$statusAppearance[status],
                                children: status
                            })
                        },
                        {
                            content: /*#__PURE__*/ (0, $lHkHI.jsx)($595fa1e3008d7fdd$var$AnalyticsLink, {
                                href: appDetailsLink,
                                text: "View details",
                                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_VIEW_APP_DETAILS),
                                appKey: appRequest.appDetails.appKey
                            })
                        },
                        {
                            content: status === (0, $cuo8k.RequestStatus).OPEN && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bgtBL.default), {
                                appRequest: appRequest,
                                appRequestDefaultParams: appRequestDefaultParams,
                                onReject: onReject
                            })
                        }
                    ]
                };
            });
        }
    },
    Alternative: {
        head: $595fa1e3008d7fdd$export$419ef4df16caa8ff,
        // eslint-disable-next-line max-lines-per-function
        getRows: (_ref2)=>{
            let { appRequests: appRequests, getAppListingLink: getAppListingLink, filter: filter, appRequestDefaultParams: appRequestDefaultParams, onReject: onReject, rejectedKeys: rejectedKeys, rejectComment: rejectComment, showTrustSignalsInManageAppRequests: showTrustSignalsInManageAppRequests } = _ref2;
            const filteredRows = $595fa1e3008d7fdd$export$ba72dc2d10ce40e5(appRequests, filter, rejectedKeys);
            // eslint-disable-next-line max-lines-per-function
            return filteredRows.map((appRequest)=>{
                const appDetailsLink = getAppListingLink({
                    appKey: appRequest.appDetails.appKey
                });
                const status = $595fa1e3008d7fdd$var$getCurrentRequestStatus(appRequest.status, appRequest.appDetails.appKey, rejectedKeys);
                return {
                    key: "row-".concat(appRequest.appDetails.appKey),
                    cells: [
                        {
                            key: appRequest.appDetails.name,
                            content: showTrustSignalsInManageAppRequests ? /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $jvfLT.AppContainer), {
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsx)($595fa1e3008d7fdd$var$AvatarWrapper, {
                                        isAlternativeLayout: true,
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8U0Ec.default), {
                                            children: /*#__PURE__*/ (0, $lHkHI.jsx)($595fa1e3008d7fdd$var$Avatar, {
                                                alt: "",
                                                src: appRequest.appDetails.logo
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $lHkHI.jsx)($595fa1e3008d7fdd$var$AnalyticsLink, {
                                                href: appDetailsLink,
                                                text: appRequest.appDetails.name,
                                                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_VIEW_APP_DETAILS),
                                                appKey: appRequest.appDetails.appKey
                                            }),
                                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4g4re.default), {
                                                ratings: appRequest.appDetails.ratings,
                                                activeInstalls: appRequest.appDetails.activeInstalls,
                                                downloads: appRequest.appDetails.downloads
                                            })
                                        ]
                                    })
                                ]
                            }) : /*#__PURE__*/ (0, $lHkHI.jsxs)($595fa1e3008d7fdd$var$NameWrapper, {
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsx)($595fa1e3008d7fdd$var$AvatarWrapper, {
                                        isAlternativeLayout: true,
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8U0Ec.default), {
                                            children: /*#__PURE__*/ (0, $lHkHI.jsx)($595fa1e3008d7fdd$var$Avatar, {
                                                alt: "",
                                                src: appRequest.appDetails.logo
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsx)($595fa1e3008d7fdd$var$AnalyticsLink, {
                                        href: appDetailsLink,
                                        text: appRequest.appDetails.name,
                                        actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_VIEW_APP_DETAILS),
                                        appKey: appRequest.appDetails.appKey
                                    })
                                ]
                            })
                        },
                        {
                            key: appRequest.appDetails.priceType,
                            content: /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                                children: (0, (/*@__PURE__*/$parcel$interopDefault($kociE)))(appRequest.appDetails.priceType.toLowerCase())
                            })
                        },
                        {
                            key: appRequest.requestCount,
                            content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $iFcgt.default), {
                                appKey: appRequest.appDetails.appKey,
                                appName: appRequest.appDetails.name,
                                cloudId: appRequestDefaultParams.cloudId,
                                productName: appRequestDefaultParams.productName,
                                appDetailsLink: appDetailsLink,
                                requestCount: appRequest.requestCount
                            })
                        },
                        {
                            key: appRequest.lastRequestedDate,
                            content: (0, $EN9B6.default)(new Date(appRequest.lastRequestedDate), 'MMM d, yyyy')
                        },
                        {
                            key: status,
                            content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2uIYU.default), {
                                status: status,
                                appKey: appRequest.appDetails.appKey,
                                appRequestDefaultParams: appRequestDefaultParams,
                                rejectComment: rejectComment
                            })
                        },
                        {
                            content: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $dxvng.default), {
                                appKey: appRequest.appDetails.appKey,
                                appRequest: appRequest,
                                appRequestDefaultParams: appRequestDefaultParams,
                                onReject: onReject,
                                isActionsDisabled: status !== (0, $cuo8k.RequestStatus).OPEN
                            })
                        }
                    ]
                };
            });
        }
    }
};

});
parcelRegister("jvfLT", function(module, exports) {

$parcel$export(module.exports, "AppContainer", () => $e32d2573633295b1$export$7469f2cda7546515);

var $3UXZ8 = parcelRequire("3UXZ8");
function $e32d2573633295b1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $e32d2573633295b1$export$7469f2cda7546515 = (0, $3UXZ8.default)("div", {
    target: "e1trnyb00",
    label: "AppContainer"
})({
    name: "1tbkufa",
    styles: "display:grid;font-size:14px;grid-gap:5px;grid-template-columns:0.13fr 1fr;padding:7px 0 7px 0;"
});

});

parcelRegister("bgtBL", function(module, exports) {

$parcel$export(module.exports, "default", () => $833827def9ea0cd1$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $9oiuL = parcelRequire("9oiuL");

var $ZN2Lb = parcelRequire("ZN2Lb");
var $gTOQV = parcelRequire("gTOQV");
var $71CV8 = parcelRequire("71CV8");

var $gXXkA = parcelRequire("gXXkA");

var $j0gMm = parcelRequire("j0gMm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $hgNMk = parcelRequire("hgNMk");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $6gSbx = parcelRequire("6gSbx");

var $lHkHI = parcelRequire("lHkHI");
const $833827def9ea0cd1$var$_excluded = [
    "triggerRef"
];
function $833827def9ea0cd1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $833827def9ea0cd1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $833827def9ea0cd1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $833827def9ea0cd1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $833827def9ea0cd1$var$AppRequestActions(props) {
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const [isActionsOpen, setActionOpenFlag] = (0, $eUqFw.useState)(false);
    const [isRejectRequestModalOpen, setRejectRequestModalOpen] = (0, $eUqFw.useState)(false);
    const onRejectClick = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.MenuItemClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_REJECT_REQUEST),
            objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_REQUESTS),
            objectId: props.appRequest.appDetails.appKey
        });
        setRejectRequestModalOpen(true);
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            isRejectRequestModalOpen && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6gSbx.default), {
                appKey: props.appRequest.appDetails.appKey,
                appName: props.appRequest.appDetails.name,
                appRequestDefaultParams: props.appRequestDefaultParams,
                closeModal: ()=>setRejectRequestModalOpen(false),
                requestCount: props.appRequest.requestCount,
                onReject: props.onReject
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ZN2Lb.default), {
                isOpen: isActionsOpen,
                onOpenChange: ()=>setActionOpenFlag(!isActionsOpen),
                trigger: (_ref)=>{
                    let { triggerRef: triggerRef } = _ref, triggerProps = (0, $bwPfh.default)(_ref, $833827def9ea0cd1$var$_excluded);
                    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), $833827def9ea0cd1$var$_objectSpread($833827def9ea0cd1$var$_objectSpread({
                        ref: triggerRef
                    }, triggerProps), {}, {
                        appearance: "subtle",
                        isSelected: isActionsOpen,
                        iconAfter: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gXXkA))), {
                            label: "App request actions",
                            primaryColor: isActionsOpen ? "var(--ds-icon-selected, ".concat((0, $j0gMm.N0), ")") : "var(--ds-icon, ".concat((0, $j0gMm.N400), ")")
                        })
                    }));
                },
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $71CV8.default), {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gTOQV.default), {
                        onClick: onRejectClick,
                        children: "Reject ".concat((0, $hgNMk.pluralize)('request', props.appRequest.requestCount))
                    })
                })
            })
        ]
    });
}
var $833827def9ea0cd1$export$2e2bcd8739ae039 = $833827def9ea0cd1$var$AppRequestActions;

});
parcelRegister("6gSbx", function(module, exports) {

$parcel$export(module.exports, "default", () => $490e44b6ffb8dad1$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $cQKn6 = parcelRequire("cQKn6");

var $9oiuL = parcelRequire("9oiuL");

var $2ruhQ = parcelRequire("2ruhQ");

var $j0gMm = parcelRequire("j0gMm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $cuo8k = parcelRequire("cuo8k");

var $inwKI = parcelRequire("inwKI");

var $bTrQR = parcelRequire("bTrQR");
var $hgNMk = parcelRequire("hgNMk");

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("jJs3W");
var $6N2vY = parcelRequire("6N2vY");

var $8bwkw = parcelRequire("8bwkw");

var $7Uh51 = parcelRequire("7Uh51");

var $gIQkA = parcelRequire("gIQkA");

var $jC5dB = parcelRequire("jC5dB");

var $gRo3n = parcelRequire("gRo3n");

var $3kdNe = parcelRequire("3kdNe");

var $lHkHI = parcelRequire("lHkHI");
function $490e44b6ffb8dad1$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $490e44b6ffb8dad1$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $490e44b6ffb8dad1$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $490e44b6ffb8dad1$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $490e44b6ffb8dad1$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $490e44b6ffb8dad1$export$8d13340382210b65 = (0, $3UXZ8.default)("p", {
    target: "e1mh5mxb0",
    label: "Hint"
})("color:", "var(--ds-text, ".concat((0, $j0gMm.N400), ")"), ";font-size:12px;margin-top:var(--ds-space-250, 20px);white-space:pre-line;");
const $490e44b6ffb8dad1$export$8b7b7cdfb85d78c5 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $cQKn6.default), {
    target: "e1mh5mxb1",
    label: "SubmitButton"
})({
    name: "1y6ic72",
    styles: "margin-left:10px;"
});
const $490e44b6ffb8dad1$export$666b01c2fa831af7 = (0, $3UXZ8.default)("ul", {
    target: "e1mh5mxb2",
    label: "HintList"
})({
    name: "y8aj3r",
    styles: "padding:0;"
});
const $490e44b6ffb8dad1$export$58157fc0778186c6 = (0, $3UXZ8.default)("li", {
    target: "e1mh5mxb3",
    label: "HintListItem"
})({
    name: "19miuh6",
    styles: "&::before{content:'- ';}list-style-type:none;"
});
const $490e44b6ffb8dad1$export$b3a86b94c892198a = (0, $3UXZ8.default)("p", {
    target: "e1mh5mxb4",
    label: "HeaderSubText"
})("margin:3px 0 0;color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N400), ")"), ";font-size:12px;");
const $490e44b6ffb8dad1$export$cc5e069d64fda823 = (0, $3UXZ8.default)("h4", {
    target: "e1mh5mxb5",
    label: "H4"
})({
    name: "181892j",
    styles: "margin:0;font-size:20px;font-weight:500;"
});
function $490e44b6ffb8dad1$export$effb033888371e3c(props) {
    const [isRejectingApp, setRejectingAppFlag] = (0, $eUqFw.useState)(false);
    const [rejectComment, setRejectComment] = (0, $eUqFw.useState)('');
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const { showManageAppRequestAlternativeLayout: showManageAppRequestAlternativeLayout } = (0, $inwKI.useFeatureFlags)();
    const onChange = (event)=>{
        setRejectComment(event.target.value.trim());
    };
    const onCancelClick = ()=>{
        handleAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_REJECT_REQUEST_CANCEL));
        props.closeModal();
    };
    const onRejectClick = ()=>{
        handleAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_REJECT_REQUEST_SUBMIT), showManageAppRequestAlternativeLayout ? rejectComment : null);
        setRejectingAppFlag(true);
        (0, $gRo3n.changeAppRequestStatus)($490e44b6ffb8dad1$var$_objectSpread($490e44b6ffb8dad1$var$_objectSpread({}, props.appRequestDefaultParams), {}, {
            appKey: props.appKey,
            status: (0, $cuo8k.RequestStatus).REJECTED,
            comment: rejectComment,
            appName: props.appName
        })).then((_)=>{
            props.closeModal();
            props.onReject(props.appKey, showManageAppRequestAlternativeLayout ? rejectComment : null);
            props.addFlag($490e44b6ffb8dad1$export$e2a0dfa7230acd92(props.appName, props.requestCount));
        }).catch((error)=>{
            props.addFlag($490e44b6ffb8dad1$export$20a481698615bfb0);
            (0, $bTrQR.default).error('RejectRequestModal', "Failed to update the app request status to rejected", {
                error: error
            });
        }).finally((_)=>setRejectingAppFlag(false));
    };
    const body = ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2ruhQ.default), {
                    placeholder: showManageAppRequestAlternativeLayout ? 'Enter your rejection reasons here' : 'Enter your reasons here',
                    resize: "auto",
                    minimumRows: 5,
                    onChange: onChange
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($490e44b6ffb8dad1$export$8d13340382210b65, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsxs)($490e44b6ffb8dad1$export$666b01c2fa831af7, {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)($490e44b6ffb8dad1$export$58157fc0778186c6, {
                                children: "Rejecting an app request will block all further requests for this app."
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)($490e44b6ffb8dad1$export$58157fc0778186c6, {
                                children: "The ".concat((0, $hgNMk.pluralize)('requester', props.requestCount), " will be notified that their app request has been rejected.")
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)($490e44b6ffb8dad1$export$58157fc0778186c6, {
                                children: "Your comment will also be visible to all logged-in users of this instance."
                            })
                        ]
                    })
                })
            ]
        });
    const footer = ()=>{
        return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                    appearance: "subtle",
                    onClick: onCancelClick,
                    testId: "reject-app-dialog__close-btn",
                    children: showManageAppRequestAlternativeLayout ? 'Close' : 'Cancel'
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($490e44b6ffb8dad1$export$8b7b7cdfb85d78c5, {
                    testId: "reject-app-dialog__submit-btn",
                    appearance: "primary",
                    onClick: onRejectClick,
                    isLoading: isRejectingApp,
                    isDisabled: rejectComment.length === 0,
                    children: "Reject app"
                })
            ]
        });
    };
    const handleAnalyticsEvent = (actionSubjectId, rejectReason)=>fireAnalyticsEvent({
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: actionSubjectId,
            objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_REQUESTS),
            objectId: props.appKey,
            attributes: $490e44b6ffb8dad1$var$_objectSpread({}, rejectReason && {
                rejectReason: rejectReason
            })
        });
    const header = ()=>{
        return showManageAppRequestAlternativeLayout ? /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($490e44b6ffb8dad1$export$cc5e069d64fda823, {
                    children: "Rejection reason for ".concat(props.appName)
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($490e44b6ffb8dad1$export$b3a86b94c892198a, {
                    children: "Let the ".concat((0, $hgNMk.pluralize)('requester', props.requestCount), " know why you opted to reject")
                })
            ]
        }) : /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($490e44b6ffb8dad1$export$cc5e069d64fda823, {
                    children: "Reject ".concat((0, $hgNMk.pluralize)('request', props.requestCount), " for ").concat(props.appName, "?")
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($490e44b6ffb8dad1$export$b3a86b94c892198a, {
                    children: "Let the ".concat((0, $hgNMk.pluralize)('requester', props.requestCount), " know why this request has been rejected")
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3kdNe.default), {
        analyticsName: (0, $gIQkA.ANALYTICS_MODAL_REJECT_REQUEST),
        width: "medium",
        header: header(),
        onClose: ()=>props.closeModal(),
        footer: footer(),
        children: body()
    });
}
const $490e44b6ffb8dad1$export$e2a0dfa7230acd92 = (appName, requestCount)=>(0, $jC5dB.makeFlag)({
        autoDismiss: true,
        appearance: (0, $jC5dB.SUCCESS_APPEARANCE),
        description: (0, $jC5dB.makeFlagDescription)({
            primary: "You have rejected all ".concat((0, $hgNMk.pluralize)('request', requestCount), " for ").concat(appName)
        }),
        title: 'App rejected'
    });
const $490e44b6ffb8dad1$export$20a481698615bfb0 = (0, $jC5dB.makeFlag)({
    autoDismiss: true,
    appearance: (0, $jC5dB.ERROR_APPEARANCE),
    description: (0, $jC5dB.makeFlagDescription)({
        primary: 'It might just be a hiccup. Try again in a bit.'
    }),
    title: 'We ran into a little trouble'
});
function $490e44b6ffb8dad1$export$2e2bcd8739ae039(props) {
    const dispatch = (0, $6N2vY.useDispatch)();
    return /*#__PURE__*/ (0, $lHkHI.jsx)($490e44b6ffb8dad1$export$effb033888371e3c, $490e44b6ffb8dad1$var$_objectSpread($490e44b6ffb8dad1$var$_objectSpread({}, props), {}, {
        addFlag: (flag)=>dispatch((0, $8bwkw.addFlag)({
                flag: flag
            }))
    }));
}

});


parcelRegister("dxvng", function(module, exports) {

$parcel$export(module.exports, "default", () => $9db6b1b0623f4138$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $bwPfh = parcelRequire("bwPfh");

var $9oiuL = parcelRequire("9oiuL");

var $ZN2Lb = parcelRequire("ZN2Lb");
var $gTOQV = parcelRequire("gTOQV");
var $71CV8 = parcelRequire("71CV8");

var $gXXkA = parcelRequire("gXXkA");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $6LpFI = parcelRequire("6LpFI");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $55gtq = parcelRequire("55gtq");

var $jHg79 = parcelRequire("jHg79");

var $1nC6Q = parcelRequire("1nC6Q");
var $hdXYz = parcelRequire("hdXYz");
var $lOrRB = parcelRequire("lOrRB");

var $6gSbx = parcelRequire("6gSbx");

var $lHkHI = parcelRequire("lHkHI");
const $9db6b1b0623f4138$var$_excluded = [
    "triggerRef"
];
function $9db6b1b0623f4138$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9db6b1b0623f4138$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9db6b1b0623f4138$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9db6b1b0623f4138$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $9db6b1b0623f4138$var$AppRequestActionsAlternateLayout(props) {
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const [isActionsOpen, setIsActionOpen] = (0, $eUqFw.useState)(false);
    const [isRejectRequestModalOpen, setIsRejectRequestModalOpen] = (0, $eUqFw.useState)(false);
    const environment = (0, $jHg79.useEnvironment)();
    const { installerElement: installerElement, installApp: installApp } = (0, $lOrRB.useMarketplaceAppInstall)((0, $55gtq.default)(), (0, $hdXYz.getAppInstallConfigForEnv)(environment), (0, $1nC6Q.AppInstallLocation).EmbeddedMarketplaceManageAppRequests);
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $6LpFI.useFlagsImplementation)();
    const onRejectClick = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.MenuItemClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_REJECT_REQUEST),
            objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_REQUESTS),
            objectId: props.appRequest.appDetails.appKey
        });
        setIsRejectRequestModalOpen(true);
    };
    const onApproveInstallClick = ()=>{
        if (props.appKey) installApp(props.appKey, {
            flags: {
                show: (flag)=>showFlag(flag),
                dismiss: (id)=>dismissFlag(id)
            }
        });
        fireAnalyticsEvent({
            eventType: (0, $gaiog.MenuItemClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_APPROVE_REQUEST),
            objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_REQUESTS),
            objectId: props.appRequest.appDetails.appKey
        });
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            isRejectRequestModalOpen && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6gSbx.default), {
                appKey: props.appRequest.appDetails.appKey,
                appName: props.appRequest.appDetails.name,
                appRequestDefaultParams: props.appRequestDefaultParams,
                closeModal: ()=>setIsRejectRequestModalOpen(false),
                requestCount: props.appRequest.requestCount,
                onReject: props.onReject
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ZN2Lb.default), {
                isOpen: isActionsOpen,
                onOpenChange: ()=>setIsActionOpen(!isActionsOpen),
                trigger: (_ref)=>{
                    let { triggerRef: triggerRef } = _ref, triggerProps = (0, $bwPfh.default)(_ref, $9db6b1b0623f4138$var$_excluded);
                    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), $9db6b1b0623f4138$var$_objectSpread($9db6b1b0623f4138$var$_objectSpread({
                        ref: triggerRef
                    }, triggerProps), {}, {
                        isSelected: isActionsOpen,
                        iconAfter: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gXXkA))), {
                            testId: "app-request__actions-icon",
                            label: "App request actions"
                        }),
                        isDisabled: props.isActionsDisabled
                    }));
                },
                children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $71CV8.default), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gTOQV.default), {
                            onClick: onApproveInstallClick,
                            testId: "app-request__approve-and-install",
                            children: "Approve and install"
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gTOQV.default), {
                            onClick: onRejectClick,
                            testId: "app-request__reject",
                            children: "Reject"
                        })
                    ]
                })
            }),
            installerElement
        ]
    });
}
var $9db6b1b0623f4138$export$2e2bcd8739ae039 = $9db6b1b0623f4138$var$AppRequestActionsAlternateLayout;

});

parcelRegister("iFcgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d96591d3bc3e0c05$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $9oiuL = parcelRequire("9oiuL");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $inwKI = parcelRequire("inwKI");

var $hgNMk = parcelRequire("hgNMk");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $cpC4Z = parcelRequire("cpC4Z");

var $lHkHI = parcelRequire("lHkHI");
function $d96591d3bc3e0c05$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $d96591d3bc3e0c05$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $d96591d3bc3e0c05$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $d96591d3bc3e0c05$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $d96591d3bc3e0c05$export$2e2bcd8739ae039(props) {
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const [isModalOpen, setModalOpenFlag] = (0, $eUqFw.useState)(false);
    const { showManageAppRequestAlternativeLayout: showManageAppRequestAlternativeLayout } = (0, $inwKI.useFeatureFlags)();
    const onRequestCountClick = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.LinkClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_APP_REQUEST_COUNT),
            objectType: (0, $7Uh51.ANALYTICS_OBJECT_TYPE_APP_REQUESTS),
            objectId: props.appKey
        });
        setModalOpenFlag(true);
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                onClick: onRequestCountClick,
                appearance: "link",
                children: showManageAppRequestAlternativeLayout ? props.requestCount : (0, $hgNMk.pluralize)('request', props.requestCount, true)
            }),
            isModalOpen && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cpC4Z.default), $d96591d3bc3e0c05$var$_objectSpread($d96591d3bc3e0c05$var$_objectSpread({}, props), {}, {
                onClose: ()=>setModalOpenFlag(false)
            }))
        ]
    });
}

});
parcelRegister("cpC4Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $90955b9bdbfc740f$export$2e2bcd8739ae039);

var $9oiuL = parcelRequire("9oiuL");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $inwKI = parcelRequire("inwKI");

var $hgNMk = parcelRequire("hgNMk");
parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $gIQkA = parcelRequire("gIQkA");

var $3kdNe = parcelRequire("3kdNe");

var $hVwsq = parcelRequire("hVwsq");

var $6xlEw = parcelRequire("6xlEw");

var $lHkHI = parcelRequire("lHkHI");
const $90955b9bdbfc740f$var$AppRequestCommentsModal = (props)=>{
    const { comments: comments, error: error, pending: pending } = (0, $hVwsq.useAppRequestComments)({
        productName: props.productName,
        cloudId: props.cloudId,
        appKey: props.appKey
    });
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const { showManageAppRequestAlternativeLayout: showManageAppRequestAlternativeLayout } = (0, $inwKI.useFeatureFlags)();
    const handleAnalyticsEvent = (actionSubjectId)=>fireAnalyticsEvent({
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: actionSubjectId,
            objectType: (0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_APP_REQUESTS),
            objectId: props.appKey
        });
    const onCancelClick = ()=>{
        props.onClose();
        handleAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_APP_REQUEST_COMMENTS_CANCEL));
    };
    const onViewAppDetailsClick = ()=>{
        handleAnalyticsEvent((0, $7Uh51.ANALYTICS_SUBJECT_ID_APP_REQUEST_COMMENTS_VIEW_APP_DETAILS));
    };
    const footer = ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                    appearance: "subtle",
                    onClick: onCancelClick,
                    children: showManageAppRequestAlternativeLayout ? 'Close' : 'Cancel'
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                    appearance: "primary",
                    href: props.appDetailsLink,
                    onClick: onViewAppDetailsClick,
                    target: "_blank",
                    children: "View app details"
                })
            ]
        });
    const commentsText = !pending && !error ? " - ".concat((0, $hgNMk.pluralize)(showManageAppRequestAlternativeLayout ? 'request' : 'comment', comments.length, true)) : '';
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3kdNe.default), {
        analyticsName: (0, $gIQkA.ANALYTICS_MODAL_APP_REQUEST_COMMENTS_MODAL),
        onClose: props.onClose,
        heading: "".concat(props.appName).concat(commentsText),
        footer: footer(),
        shouldScrollInViewport: false,
        width: 800,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6xlEw.default), {
            comments: comments,
            error: error,
            pending: pending
        })
    });
};
var $90955b9bdbfc740f$export$2e2bcd8739ae039 = $90955b9bdbfc740f$var$AppRequestCommentsModal;

});
parcelRegister("6xlEw", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c269ee06d14ad8a$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $5E0SL = parcelRequire("5E0SL");

var $irI9N = parcelRequire("irI9N");

var $j0gMm = parcelRequire("j0gMm");

var $kU8RF = parcelRequire("kU8RF");

var $inwKI = parcelRequire("inwKI");

var $76fzC = parcelRequire("76fzC");

var $EN9B6 = parcelRequire("EN9B6");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $4c269ee06d14ad8a$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $4c269ee06d14ad8a$export$a7868e2cf169ebc7 = (0, $3UXZ8.default)("div", {
    target: "e19axoid0",
    label: "AvatarNameWrapper"
})("margin-top:", (props)=>props.showAppRequestsActions ? "10px" : "", ";display:flex;align-items:center;");
const $4c269ee06d14ad8a$export$1e571b4093daf94a = (0, $3UXZ8.default)("div", {
    target: "e19axoid1",
    label: "CommentWrapper"
})({
    name: "116thbk",
    styles: "margin:15px 0px;"
});
const $4c269ee06d14ad8a$export$832a7489c3aab434 = (0, $3UXZ8.default)("div", {
    target: "e19axoid2",
    label: "NameTimeContainer"
})({
    name: "1y6ic72",
    styles: "margin-left:10px;"
});
const $4c269ee06d14ad8a$export$45df02f361199409 = (0, $3UXZ8.default)("span", {
    target: "e19axoid3",
    label: "NameWrapper"
})({
    name: "cfdsre",
    styles: "margin-left:var(--ds-space-200, 16px);"
});
const $4c269ee06d14ad8a$export$6ee7e903a59a6372 = (0, $3UXZ8.default)("span", {
    target: "e19axoid4",
    label: "GreyText"
})("color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N200), ")"), ";font-size:11px;");
const $4c269ee06d14ad8a$export$7c3018f441722857 = (0, $3UXZ8.default)("div", {
    target: "e19axoid5",
    label: "TextWrapper"
})("margin-left:18px;border-bottom:1px solid ", "var(--ds-border-disabled, ".concat((0, $j0gMm.N20), ")"), ";padding:15px var(--ds-space-250, 20px);text-align:justify;");
const $4c269ee06d14ad8a$export$2dd197b55cf13440 = (appRequestComments)=>{
    return appRequestComments.map((appRequestComment)=>({
            key: "row-".concat(appRequestComment.user.id),
            cells: [
                {
                    key: appRequestComment.user.avatarUrl,
                    content: /*#__PURE__*/ (0, $lHkHI.jsxs)($4c269ee06d14ad8a$export$a7868e2cf169ebc7, {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5E0SL.default), {
                                name: appRequestComment.user.name,
                                size: "small",
                                appearance: "square",
                                src: appRequestComment.user.avatarUrl
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)($4c269ee06d14ad8a$export$45df02f361199409, {
                                children: appRequestComment.user.name
                            })
                        ]
                    }),
                    colSpan: 3
                },
                {
                    key: appRequestComment.comment,
                    content: appRequestComment.comment,
                    colSpan: 8
                },
                {
                    key: appRequestComment.requestedDate,
                    content: (0, $76fzC).longDate(appRequestComment.requestedDate),
                    colSpan: 2
                }
            ]
        }));
};
const $4c269ee06d14ad8a$export$434c217d363ea16 = (props)=>{
    const appRequestComments = props.appRequestComments;
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $lHkHI.Fragment), {
        children: appRequestComments.map((appRequestComment, i)=>/*#__PURE__*/ (0, $lHkHI.jsxs)($4c269ee06d14ad8a$export$1e571b4093daf94a, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($4c269ee06d14ad8a$export$a7868e2cf169ebc7, {
                        showManageAppRequestAlternativeLayout: true,
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5E0SL.default), {
                                name: appRequestComment.user.name,
                                size: "small",
                                appearance: "square",
                                src: appRequestComment.user.avatarUrl
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsxs)($4c269ee06d14ad8a$export$832a7489c3aab434, {
                                children: [
                                    appRequestComment.user.name,
                                    ' ',
                                    /*#__PURE__*/ (0, $lHkHI.jsxs)($4c269ee06d14ad8a$export$6ee7e903a59a6372, {
                                        children: [
                                            "on ",
                                            (0, $EN9B6.default)(new Date(appRequestComment.requestedDate), 'MMM d, yyyy')
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($4c269ee06d14ad8a$export$7c3018f441722857, {
                        children: appRequestComment.comment
                    })
                ]
            }, i))
    });
};
const $4c269ee06d14ad8a$var$AppRequestCommentsTable = (props)=>{
    const { showManageAppRequestAlternativeLayout: showManageAppRequestAlternativeLayout } = (0, $inwKI.useFeatureFlags)();
    if (props.error) // TODO: Add the commonized error page from MC-543
    return /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
        children: "We ran into a little trouble. It might just be a hiccup. Try again in a bit."
    });
    return !showManageAppRequestAlternativeLayout ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $irI9N.default), {
        rows: $4c269ee06d14ad8a$export$2dd197b55cf13440(props.comments),
        isFixedSize: true,
        isLoading: props.pending,
        loadingSpinnerSize: "large"
    }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kU8RF.default), {
        active: props.pending,
        children: /*#__PURE__*/ (0, $lHkHI.jsx)($4c269ee06d14ad8a$export$434c217d363ea16, {
            appRequestComments: props.comments
        })
    });
};
var $4c269ee06d14ad8a$export$2e2bcd8739ae039 = $4c269ee06d14ad8a$var$AppRequestCommentsTable;

});



parcelRegister("2uIYU", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d114675895d6835$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $58ZVT = parcelRequire("58ZVT");

var $j8E8v = parcelRequire("j8E8v");

var $j0gMm = parcelRequire("j0gMm");

var $l2WWm = parcelRequire("l2WWm");

var $cuo8k = parcelRequire("cuo8k");

var $bTrQR = parcelRequire("bTrQR");

var $eUqFw = parcelRequire("eUqFw");

var $gRo3n = parcelRequire("gRo3n");

var $lHkHI = parcelRequire("lHkHI");
function $1d114675895d6835$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1d114675895d6835$export$de4073b352073c99 = (0, $3UXZ8.default)("div", {
    target: "e140ccq20",
    label: "AppRequestStatusWrapper"
})({
    name: "70qvj9",
    styles: "display:flex;align-items:center;"
});
const $1d114675895d6835$export$e13a8cbe8fa393d4 = (0, $3UXZ8.default)("div", {
    target: "e140ccq21",
    label: "ReasonIconContainer"
})({
    name: "xbm4ck",
    styles: "margin-left:var(--ds-space-100, 8px);"
});
const $1d114675895d6835$export$592001b458791d7f = Object.freeze({
    [(0, $cuo8k.RequestStatus).OPEN]: 'inprogress',
    [(0, $cuo8k.RequestStatus).REJECTED]: 'removed',
    [(0, $cuo8k.RequestStatus).INSTALLED]: 'success'
});
function $1d114675895d6835$export$2e2bcd8739ae039(props) {
    const [appRequestRejectComment, setAppRequestRejectComment] = (0, $eUqFw.useState)('');
    const { status: status, appKey: appKey, appRequestDefaultParams: { userId: userId, cloudId: cloudId, productName: productName } } = props;
    const getRejectReason = async ()=>{
        try {
            const response = await (0, $gRo3n.getAppRequestedStatus)({
                cloudId: cloudId,
                productName: productName,
                appKey: appKey,
                userId: userId
            });
            if (response.status === (0, $cuo8k.RequestStatus).REJECTED && response.rejectComment) setAppRequestRejectComment(response.rejectComment);
        } catch (error) {
            (0, $bTrQR.default).error('AppReqeustStatus', "Failed to retrieve app requested status", {
                error: error
            });
        }
    };
    (0, $eUqFw.useEffect)(()=>{
        getRejectReason();
    }, [
        status
    ]);
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($1d114675895d6835$export$de4073b352073c99, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j8E8v.default), {
                appearance: $1d114675895d6835$export$592001b458791d7f[status],
                children: status
            }),
            status === 'REJECTED' && /*#__PURE__*/ (0, $lHkHI.jsx)($1d114675895d6835$export$e13a8cbe8fa393d4, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $l2WWm.default), {
                    content: "Reason for rejection: ".concat(appRequestRejectComment),
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($58ZVT))), {
                        size: "small",
                        primaryColor: "var(--ds-icon-subtle, ".concat((0, $j0gMm.N300), ")"),
                        label: "App request rejection reason info icon"
                    })
                })
            })
        ]
    });
}

});

parcelRegister("4g4re", function(module, exports) {

$parcel$export(module.exports, "default", () => $319c196176741598$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $k8FfC = parcelRequire("k8FfC");
var $KC0XU = parcelRequire("KC0XU");

var $4KYol = parcelRequire("4KYol");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $319c196176741598$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $319c196176741598$export$f1b2403b48c4c324 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $k8FfC.default), {
    target: "e5ciau20",
    label: "DotSeparator"
})({
    name: "s03i8n",
    styles: "margin:0 10px 0 10px;"
});
const $319c196176741598$export$fb72ab3fd3339c03 = (0, $3UXZ8.default)("div", {
    target: "e5ciau21",
    label: "TrustSignalContainer"
})({
    name: "ut2ow9",
    styles: "display:flex;align-items:center;padding-top:var(--ds-space-100, 8px);"
});
function $319c196176741598$export$2e2bcd8739ae039(props) {
    const { ratings: ratings, activeInstalls: activeInstalls, downloads: downloads } = props;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($319c196176741598$export$fb72ab3fd3339c03, {
        children: [
            ratings.numRatings > 0 && /*#__PURE__*/ (0, $lHkHI.jsx)("span", {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $KC0XU.default), {
                    ratings: ratings
                })
            }),
            ratings.numRatings > 0 && (activeInstalls > 0 || downloads > 0) && /*#__PURE__*/ (0, $lHkHI.jsx)($319c196176741598$export$f1b2403b48c4c324, {}),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4KYol.default), {
                activeInstalls: activeInstalls,
                downloads: downloads,
                showDownloadIcon: true
            })
        ]
    });
}

});
parcelRegister("k8FfC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea948d8d468393aa$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $ibjku = parcelRequire("ibjku");
const $ea948d8d468393aa$export$885d2afc6779d22e = /*#__PURE__*/ (0, $ibjku.css)("border-radius:50%;background-color:", "var(--ds-border, ".concat((0, $j0gMm.N60), ")"), ";height:4px;width:4px;;label:dotSeparatorCss;");
var $ea948d8d468393aa$export$2e2bcd8739ae039 = (0, $3UXZ8.default)("div", {
    target: "e1gb23850"
})($ea948d8d468393aa$export$885d2afc6779d22e, "");

});

parcelRegister("4KYol", function(module, exports) {

$parcel$export(module.exports, "default", () => $376a4dd0caceec94$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $f7YGc = parcelRequire("f7YGc");

var $hgNMk = parcelRequire("hgNMk");
parcelRequire("eUqFw");

var $bZbjp = parcelRequire("bZbjp");

var $lHkHI = parcelRequire("lHkHI");
const $376a4dd0caceec94$export$83a341453e49cfdc = (0, $3UXZ8.default)("span", {
    target: "e1srjxai0",
    label: "Installs"
})("color:", "var(--ds-text-subtle, ".concat((0, $j0gMm.N100), ")"), ";font-size:12px;");
const $376a4dd0caceec94$var$ActiveInstallsAndDownloads = (props)=>{
    const { activeInstalls: activeInstalls, downloads: downloads } = props;
    if (!activeInstalls && !downloads) return null;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($376a4dd0caceec94$export$83a341453e49cfdc, {
        children: [
            props.showDownloadIcon && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bZbjp.DownloadIcon), {
                primaryColor: "var(--ds-icon-subtle, ".concat((0, $j0gMm.N500), ")"),
                size: "small"
            }),
            activeInstalls ? "".concat((0, $f7YGc).shortFormat(activeInstalls), " ").concat((0, $hgNMk.pluralize)('install', activeInstalls)) : "".concat((0, $f7YGc).shortFormat(downloads), " ").concat((0, $hgNMk.pluralize)('download', downloads))
        ]
    });
};
var $376a4dd0caceec94$export$2e2bcd8739ae039 = $376a4dd0caceec94$var$ActiveInstallsAndDownloads;

});



parcelRegister("g19Hk", function(module, exports) {
module.exports = new URL("app-requests-empty-state.0e3171a7.svg", import.meta.url).toString();

});


parcelRegister("kQ9fC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2bfd70529c3474e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $eEKFN = parcelRequire("eEKFN");

var $4iWU0 = parcelRequire("4iWU0");

var $c9Mth = parcelRequire("c9Mth");

var $eUqFw = parcelRequire("eUqFw");

var $e8LPn = parcelRequire("e8LPn");

var $7Uh51 = parcelRequire("7Uh51");

var $40nqT = parcelRequire("40nqT");

var $9LNXV = parcelRequire("9LNXV");

var $cY537 = parcelRequire("cY537");

var $lHkHI = parcelRequire("lHkHI");
class $f2bfd70529c3474e$var$ManageAppsRoutes extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onBreadcrumbsItemClick", (e)=>{
            e.preventDefault();
            this.props.history.push({
                pathname: (0, $40nqT.manageRoute).path
            });
        });
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $eEKFN.default), {
                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE),
                onClick: this.onBreadcrumbsItemClick,
                href: (0, $40nqT.manageRoute).path,
                text: "Manage apps",
                children: /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $e8LPn.default), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4iWU0.RouteWithContext), {
                            exact: true,
                            path: (0, $c9Mth).joinPathNames([
                                this.props.mountPath,
                                (0, $40nqT.manageRoute).path
                            ]),
                            render: (routeProps)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $cY537.default), {
                                    bootstrapConfig: this.props.bootstrapConfig,
                                    currentUserId: this.props.currentUserId,
                                    history: routeProps.history,
                                    hostConfig: this.props.hostConfig,
                                    links: this.props.links,
                                    onRendered: this.props.onRendered,
                                    selectedContext: this.props.selectedContext
                                })
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4iWU0.RouteWithContext), {
                            exact: true,
                            path: (0, $c9Mth).joinPathNames([
                                this.props.mountPath,
                                (0, $40nqT.manageAppDetailsRoute).path
                            ]),
                            render: (routeProps)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $9LNXV.default), {
                                    bootstrapConfig: this.props.bootstrapConfig,
                                    currentUserId: this.props.currentUserId,
                                    history: routeProps.history,
                                    hostConfig: this.props.hostConfig,
                                    links: this.props.links,
                                    location: routeProps.location,
                                    match: routeProps.match,
                                    onRendered: this.props.onRendered,
                                    selectedContext: this.props.selectedContext
                                })
                        })
                    ]
                })
            }));
    }
}
var $f2bfd70529c3474e$export$2e2bcd8739ae039 = $f2bfd70529c3474e$var$ManageAppsRoutes;

});
parcelRegister("9LNXV", function(module, exports) {

$parcel$export(module.exports, "default", () => $71cf42fa72ca3f68$export$2e2bcd8739ae039);

var $7hgtR = parcelRequire("7hgtR");

var $c9Mth = parcelRequire("c9Mth");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");

var $5Wf8D = parcelRequire("5Wf8D");

var $hNyxl = parcelRequire("hNyxl");

var $lfDOB = parcelRequire("lfDOB");
function $71cf42fa72ca3f68$var$getAppDetails(key, installedAppsResult) {
    return installedAppsResult.map((r)=>r.flatMap((iar)=>(0, $bWAru.Option).of(iar.installedApps.find((ia)=>ia.details.key === key)).fold((_)=>(0, $bWAru.Either).left((0, $7hgtR.makeDataErrorMessages)([
                    'Unable to find app'
                ])), (a)=>(0, $bWAru.Either).right(a)))).getOrElseL(()=>(0, $bWAru.Either).left((0, $7hgtR.makeDataErrorMessages)([
            'Installed apps have not been initialized'
        ])));
}
const $71cf42fa72ca3f68$var$mapStateToProps = (state, ownProps)=>{
    const global = (0, $c9Mth).resolveImmutableQuery(ownProps.location.search).get('global', 'false') === 'true';
    return {
        appData: $71cf42fa72ca3f68$var$getAppDetails(ownProps.match.params.appKey || '', global ? state.installedApps.globallyInstalledApps.result : state.installedApps.locallyInstalledApps.result),
        currentUserId: state.users.currentUserId,
        global: global,
        scopesLookup: state.scopes.scopesLookup,
        uninstallingAppFromSite: state.installedApps.uninstallingAppFromSite
    };
};
const $71cf42fa72ca3f68$var$mapDispatchToProps = (dispatch, ownProps)=>({
        closeSiteUninstallDialog: (_ref)=>{
            let { installedApp: installedApp } = _ref;
            return dispatch((0, $hNyxl.closeSiteUninstallDialog)({
                installedApp: installedApp
            }));
        },
        fetchMarketplaceAppDetails: (_ref2)=>{
            let { appKey: appKey, isGlobalContext: isGlobalContext } = _ref2;
            return dispatch((0, $hNyxl.doFetchMarketplaceAppDetails)({
                mpacBaseUrl: ownProps.bootstrapConfig.mpacBaseUrl,
                appKey: appKey,
                isGlobalContext: isGlobalContext
            }));
        },
        openSiteUninstallDialog: (_ref3)=>{
            let { installedApp: installedApp } = _ref3;
            return dispatch((0, $hNyxl.openSiteUninstallDialog)({
                installedApp: installedApp
            }));
        },
        openUpgradeAppDialog: (_ref4)=>{
            let { installedApp: installedApp } = _ref4;
            return dispatch((0, $5Wf8D.doInitiateUpgradeInstallModeForInstalledApp)({
                mpacBaseUrl: ownProps.bootstrapConfig.mpacBaseUrl,
                installedApp: installedApp
            }));
        },
        revokeUserGrantGlobally: (_ref5)=>{
            let { hostConfig: hostConfig, installedApp: installedApp, userGrant: userGrant } = _ref5;
            return dispatch((0, $hNyxl.doRevokeUserGrantGlobally)({
                hostConfig: hostConfig,
                installedApp: installedApp,
                userGrant: userGrant
            }));
        },
        uninstallAppFromSite: (_ref6)=>{
            let { installedApp: installedApp, hostConfig: hostConfig, context: context } = _ref6;
            return dispatch((0, $hNyxl.doUninstallAppFromSite)({
                installedApp: installedApp,
                hostConfig: hostConfig,
                context: context
            }));
        },
        uninstallAppFromLocalContext: (_ref7)=>{
            let { context: context, installedApp: installedApp, hostConfig: hostConfig } = _ref7;
            return dispatch((0, $hNyxl.doUninstallAppFromLocalContext)({
                context: context,
                installedApp: installedApp,
                hostConfig: hostConfig
            }));
        }
    });
var $71cf42fa72ca3f68$export$2e2bcd8739ae039 = (0, $94zHK.default)($71cf42fa72ca3f68$var$mapStateToProps, $71cf42fa72ca3f68$var$mapDispatchToProps)((0, $lfDOB.default));

});
parcelRegister("lfDOB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f789e22955f12116$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $8nyhD = parcelRequire("8nyhD");

var $j0gMm = parcelRequire("j0gMm");

var $fyH4h = parcelRequire("fyH4h");

var $eEKFN = parcelRequire("eEKFN");

var $lQqqi = parcelRequire("lQqqi");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $iEgm6 = parcelRequire("iEgm6");

var $jwE5W = parcelRequire("jwE5W");

var $31jw4 = parcelRequire("31jw4");

var $bVwBD = parcelRequire("bVwBD");

var $1YBZM = parcelRequire("1YBZM");

var $2JvTO = parcelRequire("2JvTO");

var $lHkHI = parcelRequire("lHkHI");
function $f789e22955f12116$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f789e22955f12116$export$b4d76ceb8b1a880f = (0, $3UXZ8.default)("div", {
    target: "ewlxqmy0",
    label: "ManageAppDetailsContainer"
})({
    name: "ud5h78",
    styles: "margin-bottom:var(--ds-space-250, 20px);"
});
const $f789e22955f12116$export$cc55614734af2d87 = (0, $3UXZ8.default)("div", {
    target: "ewlxqmy1",
    label: "GridContainer"
})({
    name: "1lpk7ao",
    styles: "display:grid;margin-left:auto;margin-right:auto;grid-template-columns:48px 1fr;grid-template-rows:max-content 1fr max-content;grid-gap:10px 27px;height:calc(100vh - 80px);"
});
const $f789e22955f12116$export$714c9fe7373c9e3a = (0, $3UXZ8.default)("div", {
    target: "ewlxqmy2",
    label: "BackButtonContainerDiv"
})({
    name: "1vfuc40",
    styles: "grid-column:1/2;grid-row:1/2;"
});
const $f789e22955f12116$export$e0d897ee21382f67 = (0, $3UXZ8.default)("button", {
    target: "ewlxqmy3",
    label: "BackButton"
})({
    name: "a8ycbt",
    styles: "cursor:pointer;background:none;border:none;padding:0;"
});
const $f789e22955f12116$export$66089487c21dd717 = (0, $3UXZ8.default)("div", {
    target: "ewlxqmy4",
    label: "AppDetailsContainer"
})({
    name: "3xoqkk",
    styles: "grid-column:2 / 3;grid-row:1 / 2;"
});
const $f789e22955f12116$export$2cdaa5417dec6e5a = (0, $3UXZ8.default)("div", {
    target: "ewlxqmy5",
    label: "FooterDiv"
})({
    name: "yajoys",
    styles: "grid-column:2 / 3;grid-row:3 / 4;"
});
class $f789e22955f12116$export$48b318c691998e44 extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "triggerSiteWideUninstall", (app)=>()=>{
                this.props.openSiteUninstallDialog({
                    installedApp: app
                });
            });
        (0, $5zQU9.default)(this, "replaceWithManageInstalledApps", ()=>{
            this.props.history.replace({
                pathname: this.props.emceeLinks.manageHome.getRelative()
            });
        });
        (0, $5zQU9.default)(this, "onClickManageBreadcrumb", (e)=>{
            (0, $iEgm6.preventDefault)(e);
            this.props.history.push({
                pathname: this.props.emceeLinks.manageHome.getRelative()
            });
        });
        (0, $5zQU9.default)(this, "onClickBack", ()=>{
            this.props.history.goBack();
        });
        (0, $5zQU9.default)(this, "uninstallAppFromSite", (_ref)=>{
            let { hostConfig: hostConfig, installedApp: installedApp, context: context } = _ref;
            this.props.uninstallAppFromSite({
                hostConfig: hostConfig,
                installedApp: installedApp,
                context: context
            }).then(this.replaceWithManageInstalledApps).catch(console.error.bind(console));
        });
        (0, $5zQU9.default)(this, "render", ()=>this.props.scopesLookup.map((scopesLookup)=>this.props.appData.fold((errs)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $fyH4h.default), {
                        loading: false,
                        dataError: true,
                        dataErrorMessages: errs.map((0, $g5DHJ.Map)),
                        children: null
                    }), (app)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $fyH4h.default), {
                        loading: false,
                        dataError: false,
                        dataErrorMessages: (0, $g5DHJ.List)(),
                        children: this.renderAppDetails(app, this.props.hostConfig, this.props.selectedContext, scopesLookup)
                    }))).getOrElseL(()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $fyH4h.default), {
                    loading: true,
                    dataError: false,
                    dataErrorMessages: (0, $g5DHJ.List)(),
                    children: null
                })));
        (0, $5zQU9.default)(this, "renderSiteWideUninstall", (hostConfig, selectedContext, appToBeUninstalled)=>{
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2JvTO.default), {
                closeSiteUninstallDialog: this.props.closeSiteUninstallDialog,
                context: selectedContext,
                hostConfig: hostConfig,
                installedApp: appToBeUninstalled,
                uninstallAppFromSite: this.uninstallAppFromSite
            });
        });
        (0, $5zQU9.default)(this, "resolveManageAppDetailsHref", (installedApp)=>this.props.emceeLinks.manageAppDetails.getRelative({
                appKey: installedApp.details.key
            }));
        (0, $5zQU9.default)(this, "onBreadcrumbsItemClick", (installedApp)=>(e)=>{
                (0, $iEgm6.preventDefault)(e);
                this.props.history.push({
                    pathname: this.resolveManageAppDetailsHref(installedApp)
                });
            });
        (0, $5zQU9.default)(this, "renderAppDetails", (app, hostConfig, selectedContext, scopesLookup)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $eEKFN.default), {
                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_APP_NAME),
                href: this.resolveManageAppDetailsHref(app),
                onClick: this.onBreadcrumbsItemClick(app),
                text: app.details.name,
                children: /*#__PURE__*/ (0, $lHkHI.jsx)($f789e22955f12116$export$b4d76ceb8b1a880f, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsxs)($f789e22955f12116$export$cc55614734af2d87, {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)($f789e22955f12116$export$714c9fe7373c9e3a, {
                                children: /*#__PURE__*/ (0, $lHkHI.jsx)($f789e22955f12116$export$e0d897ee21382f67, {
                                    onClick: this.onClickBack,
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($8nyhD))), {
                                        label: "Back to manage all apps",
                                        size: "xlarge",
                                        primaryColor: (0, $j0gMm.N40)
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)($f789e22955f12116$export$66089487c21dd717, {
                                children: (0, $lQqqi.foldAuthType)(app.authType)(()=>null, ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $bVwBD.default), {
                                        afterUninstall: this.replaceWithManageInstalledApps,
                                        global: this.props.global,
                                        hostConfig: hostConfig,
                                        installedApp: app,
                                        links: this.props.links,
                                        openUpgradeAppDialog: this.props.openUpgradeAppDialog,
                                        selectedContext: selectedContext,
                                        scopesLookup: scopesLookup,
                                        uninstallAppFromLocalContext: this.props.uninstallAppFromLocalContext
                                    }), (threeLeggedAuthType)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $1YBZM.default), {
                                        currentUserId: this.props.currentUserId,
                                        hostConfig: hostConfig,
                                        installedApp: app,
                                        links: this.props.links,
                                        revokeUserGrantGlobally: this.props.revokeUserGrantGlobally,
                                        scopesLookup: scopesLookup,
                                        selectedContext: selectedContext,
                                        threeLeggedAuthType: threeLeggedAuthType
                                    }))
                            }),
                            (0, $lQqqi.foldAuthType)(app.authType)(()=>null, ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)($f789e22955f12116$export$2cdaa5417dec6e5a, {
                                    children: [
                                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $31jw4.default), {
                                            app: app,
                                            onClickRemove: this.triggerSiteWideUninstall(app)
                                        }),
                                        this.props.uninstallingAppFromSite.map((appToBeUninstalled)=>this.renderSiteWideUninstall(hostConfig, selectedContext, appToBeUninstalled)).orNull()
                                    ]
                                }), ()=>null)
                        ]
                    })
                })
            }));
    }
    componentDidMount() {
        this.props.appData.toOption().map((app)=>app.details.key).map((appKey)=>this.props.fetchMarketplaceAppDetails({
                appKey: appKey,
                isGlobalContext: this.props.global
            })).getOrElse(Promise.resolve()).then(this.props.onRendered).catch(console.error.bind(console));
    }
    componentDidUpdate(prevProps) {
        if (prevProps.appData.isRight() && this.props.appData.isLeft()) this.replaceWithManageInstalledApps();
    }
}
var $f789e22955f12116$export$2e2bcd8739ae039 = (0, $jwE5W.withEmceeLinks)($f789e22955f12116$export$48b318c691998e44);

});
parcelRegister("8nyhD", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $619b10af9dd09f5f$var$_react = $619b10af9dd09f5f$var$_interopRequireDefault((parcelRequire("eUqFw")));

var $koHMs = parcelRequire("koHMs");

var $619b10af9dd09f5f$var$_chevronLeft = $619b10af9dd09f5f$var$_interopRequireDefault((parcelRequire("gfOy5")));
function $619b10af9dd09f5f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $619b10af9dd09f5f$var$ChevronLeftCircleIcon = (props)=>/*#__PURE__*/ $619b10af9dd09f5f$var$_react.default.createElement($koHMs.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></g></svg>`
    }, props, {
        newIcon: $619b10af9dd09f5f$var$_chevronLeft.default,
        iconType: "utility"
    }));
$619b10af9dd09f5f$var$ChevronLeftCircleIcon.displayName = 'ChevronLeftCircleIcon';
var $619b10af9dd09f5f$var$_default = module.exports.default = $619b10af9dd09f5f$var$ChevronLeftCircleIcon;

});

parcelRegister("31jw4", function(module, exports) {

$parcel$export(module.exports, "default", () => $23309a98af546b4c$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $gykb8 = parcelRequire("gykb8");

var $eUqFw = parcelRequire("eUqFw");

var $iEgm6 = parcelRequire("iEgm6");

var $lHkHI = parcelRequire("lHkHI");
const $23309a98af546b4c$export$1a41245a71c4f61b = (0, $3UXZ8.default)("footer", {
    target: "e16xbh8a0",
    label: "ContainerFooter"
})("height:50px;border-top:2px solid ", (0, $j0gMm.N30), ";padding-top:11px;margin:var(--ds-space-100, 8px) auto var(--ds-space-200, 16px);font-size:14px;color:", (0, $j0gMm.N500), ";");
class $23309a98af546b4c$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($23309a98af546b4c$export$1a41245a71c4f61b, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                    onClick: this.props.onClickRemove,
                    children: "Remove"
                }),
                "\xA0",
                (0, $iEgm6.resolveFieldWithFallback)((add)=>add.name, this.props.app.marketplaceAppDetails, this.props.app.details),
                "\xA0 from entire site"
            ]
        });
    }
}

});

parcelRegister("bVwBD", function(module, exports) {

$parcel$export(module.exports, "default", () => $8aee4f7542674c46$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $aosfp = parcelRequire("aosfp");

var $eUqFw = parcelRequire("eUqFw");

var $uNPxB = parcelRequire("uNPxB");

var $gwMyJ = parcelRequire("gwMyJ");

var $5p4oz = parcelRequire("5p4oz");

var $gRt9U = parcelRequire("gRt9U");

var $lHkHI = parcelRequire("lHkHI");
function $8aee4f7542674c46$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8aee4f7542674c46$export$c9a97dee88dfb113 = (0, $3UXZ8.default)("div", {
    target: "e1rt7p6s0",
    label: "UninstallControlsContainer"
})({
    name: "1178ru4",
    styles: "margin-top:27px;"
});
class $8aee4f7542674c46$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "triggerUninstall", ()=>{
            this.props.uninstallAppFromLocalContext({
                context: this.props.selectedContext,
                installedApp: this.props.installedApp,
                hostConfig: this.props.hostConfig
            }).then(this.props.afterUninstall).catch(console.error.bind(console));
        });
        (0, $5zQU9.default)(this, "resolveScopesDescription", (appDetails)=>"".concat(appDetails.name, " can perform the following actions:"));
        (0, $5zQU9.default)(this, "getRemoveButtonText", (contextType)=>"Remove app from ".concat(contextType));
        (0, $5zQU9.default)(this, "render", ()=>{
            var _this$props$installed, _this$props$installed2;
            return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $aosfp.default), {
                appHeaderDetails: (0, $uNPxB.makeAppHeaderDetails)((_this$props$installed = this.props.installedApp.marketplaceAppDetails) !== null && _this$props$installed !== void 0 ? _this$props$installed : this.props.installedApp.details),
                appRatingLink: this.props.links.appRating,
                appIconLink: this.props.links.appIcon,
                appIconSize: "small",
                children: [
                    this.props.installedApp.upgradeAvailable ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gRt9U.default), {
                        installedApp: this.props.installedApp,
                        openUpgradeAppDialog: this.props.openUpgradeAppDialog
                    }) : null,
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gwMyJ.default), {
                        appScopes: this.props.installedApp.scopes,
                        description: this.resolveScopesDescription((_this$props$installed2 = this.props.installedApp.marketplaceAppDetails) !== null && _this$props$installed2 !== void 0 ? _this$props$installed2 : this.props.installedApp.details),
                        links: this.props.links,
                        scopesLookup: this.props.scopesLookup
                    }),
                    !this.props.global ? /*#__PURE__*/ (0, $lHkHI.jsx)($8aee4f7542674c46$export$c9a97dee88dfb113, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5p4oz.default), {
                            buttonText: this.getRemoveButtonText(this.props.hostConfig.contextType),
                            confirmText: "Yes, remove",
                            showSpinner: this.props.installedApp.uninstallInProgress,
                            onClickConfirm: this.triggerUninstall
                        })
                    }) : null
                ]
            });
        });
    }
}

});
parcelRegister("5p4oz", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ef2b25fbf954f59$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $cQKn6 = parcelRequire("cQKn6");

var $9oiuL = parcelRequire("9oiuL");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $3ef2b25fbf954f59$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3ef2b25fbf954f59$var$ContainerDiv = (0, $3UXZ8.default)("div", {
    target: "e1izsb6b0",
    label: "ContainerDiv"
})({
    name: "n947sy",
    styles: "height:32px;display:flex;align-items:center;"
});
class $3ef2b25fbf954f59$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            showConfirm: false
        });
        (0, $5zQU9.default)(this, "showConfirm", ()=>{
            this.setState({
                showConfirm: true
            });
        });
        (0, $5zQU9.default)(this, "hideConfirm", ()=>{
            this.setState({
                showConfirm: false
            });
        });
        (0, $5zQU9.default)(this, "renderButton", ()=>{
            return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                spacing: "compact",
                onClick: this.showConfirm,
                children: this.props.buttonText
            });
        });
        (0, $5zQU9.default)(this, "renderConfirm", ()=>{
            return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cQKn6.default), {
                        isLoading: this.props.showSpinner,
                        isSelected: !this.props.showSpinner,
                        onClick: this.props.onClickConfirm,
                        spacing: "compact",
                        children: this.props.confirmText
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                        appearance: "subtle-link",
                        isDisabled: this.props.showSpinner,
                        spacing: "compact",
                        onClick: this.hideConfirm,
                        children: this.props.cancelText
                    })
                ]
            });
        });
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)($3ef2b25fbf954f59$var$ContainerDiv, {
            children: this.state.showConfirm ? this.renderConfirm() : this.renderButton()
        });
    }
}
(0, $5zQU9.default)($3ef2b25fbf954f59$export$2e2bcd8739ae039, "defaultProps", {
    cancelText: 'Cancel'
});

});

parcelRegister("gRt9U", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46836e80ad6923b$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $d8i0J = parcelRequire("d8i0J");

var $ivTMz = parcelRequire("ivTMz");

var $j0gMm = parcelRequire("j0gMm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $8KCrk = parcelRequire("8KCrk");

var $7Uh51 = parcelRequire("7Uh51");

var $lHkHI = parcelRequire("lHkHI");
function $c46836e80ad6923b$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $c46836e80ad6923b$var$ShadowCard = (0, $3UXZ8.default)("div", {
    target: "ex2doi20",
    label: "ShadowCard"
})("display:flex;flex-direction:row;border:solid ", (0, $j0gMm.N40), " 1px;box-shadow:4px 12px 10px -3px ", (0, $j0gMm.N900), ";border-radius:", (0, $ivTMz.borderRadius)(), "px;margin-bottom:var(--ds-space-300, 24px);");
const $c46836e80ad6923b$var$GlyphContainer = (0, $3UXZ8.default)("div", {
    target: "ex2doi21",
    label: "GlyphContainer"
})({
    name: "vv8bx2",
    styles: "padding:var(--ds-space-150, 12px) var(--ds-space-100, 8px) 0 var(--ds-space-150, 12px);"
});
const $c46836e80ad6923b$var$TextContainer = (0, $3UXZ8.default)("div", {
    target: "ex2doi22",
    label: "TextContainer"
})({
    name: "12m2sj9",
    styles: "display:flex;flex-direction:column;padding:var(--ds-space-200, 16px) 0;"
});
const $c46836e80ad6923b$var$HeaderContainer = (0, $3UXZ8.default)("div", {
    target: "ex2doi23",
    label: "HeaderContainer"
})({
    name: "rvt6z8",
    styles: "font-weight:600;padding-bottom:var(--ds-space-050, 4px);"
});
const $c46836e80ad6923b$var$UPGRADE_CTA_LABEL = 'View changes';
class $c46836e80ad6923b$var$AppUpgradeCard extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "triggerUpgrade", ()=>{
            this.props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstalledApp)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_UPGRADE), this.props.installedApp, {
                label: $c46836e80ad6923b$var$UPGRADE_CTA_LABEL
            }).toObject());
            this.props.openUpgradeAppDialog({
                installedApp: this.props.installedApp
            });
        });
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($c46836e80ad6923b$var$ShadowCard, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($c46836e80ad6923b$var$GlyphContainer, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d8i0J))), {
                        label: "Update available",
                        primaryColor: "orange"
                    })
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)($c46836e80ad6923b$var$TextContainer, {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)($c46836e80ad6923b$var$HeaderContainer, {
                            children: "App update avaliable"
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                            children: "This app has changed access permissions."
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                                appearance: "link",
                                spacing: "none",
                                onClick: this.triggerUpgrade,
                                children: $c46836e80ad6923b$var$UPGRADE_CTA_LABEL
                            })
                        })
                    ]
                })
            ]
        });
    }
}
var $c46836e80ad6923b$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($c46836e80ad6923b$var$AppUpgradeCard);

});


parcelRegister("1YBZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $1708de212ec2da32$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $ivTMz = parcelRequire("ivTMz");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $aosfp = parcelRequire("aosfp");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $8KCrk = parcelRequire("8KCrk");

var $7Uh51 = parcelRequire("7Uh51");

var $uNPxB = parcelRequire("uNPxB");

var $iEgm6 = parcelRequire("iEgm6");

var $6JEuS = parcelRequire("6JEuS");

var $lHkHI = parcelRequire("lHkHI");
function $1708de212ec2da32$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $1708de212ec2da32$export$2ce7b3cf715afcb2 = (0, $3UXZ8.default)("h4", {
    target: "e1pepccw0",
    label: "UserGrantsHeading"
})({
    name: "grv1g",
    styles: "font-size:16px;margin:var(--ds-space-100, 8px);"
});
const $1708de212ec2da32$export$31dea26885d599bc = (0, $3UXZ8.default)("div", {
    target: "e1pepccw1",
    label: "DescriptionContainer"
})({
    name: "1x2fu93",
    styles: "font-size:16px;line-height:1.75;"
});
const $1708de212ec2da32$export$36cda206289cc7be = (0, $3UXZ8.default)("div", {
    target: "e1pepccw2",
    label: "UserGrants"
})({
    name: "gt4wuf",
    styles: "margin-top:var(--ds-space-250, 20px);"
});
const $1708de212ec2da32$export$74b3b4fb3f2c9f32 = (0, $3UXZ8.default)("div", {
    target: "e1pepccw3",
    label: "MyUserGrantContainer"
})("padding:var(--ds-space-100, 8px) var(--ds-space-200, 16px);box-shadow:rgba(9,30,66,0.28) 0 4px 8px -2px,rgba(9,30,66,0.3) 0 0 1px;border-radius:", (0, $ivTMz.borderRadius)(), "px;margin-bottom:var(--ds-space-200, 16px);");
const $1708de212ec2da32$export$b1622a3baa37d45b = (0, $3UXZ8.default)("div", {
    target: "e1pepccw4",
    label: "UserGrantContainer"
})({
    name: "e2bj0c",
    styles: "margin-bottom:var(--ds-space-200, 16px);"
});
class $1708de212ec2da32$var$Manage3LOAppDetails extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "revokeUserGrant", (_ref)=>{
            let { userGrant: userGrant } = _ref;
            this.props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstalledApp)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_REVOKE_USER_GRANT), this.props.installedApp, {
                userGrant: userGrant.user.atlassianAccountId
            }).toObject());
            this.props.revokeUserGrantGlobally({
                hostConfig: this.props.hostConfig,
                installedApp: this.props.installedApp,
                userGrant: userGrant
            });
        });
        (0, $5zQU9.default)(this, "render", ()=>{
            var _this$props$installed;
            const appName = (0, $iEgm6.resolveFieldWithFallback)((add)=>add.name, this.props.installedApp.marketplaceAppDetails, this.props.installedApp.details);
            const grantsWithoutMe = this.props.threeLeggedAuthType.grants.filterNot((g)=>g.user.atlassianAccountId === this.props.currentUserId);
            return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $aosfp.default), {
                        appHeaderDetails: (0, $uNPxB.makeAppHeaderDetails)((_this$props$installed = this.props.installedApp.marketplaceAppDetails) !== null && _this$props$installed !== void 0 ? _this$props$installed : this.props.installedApp.details),
                        appRatingLink: this.props.links.appRating,
                        appIconLink: this.props.links.appIcon,
                        appIconSize: "small"
                    }),
                    (0, $bWAru.Option).of(this.props.threeLeggedAuthType.grants.find((g)=>g.user.atlassianAccountId === this.props.currentUserId)).map((g)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
                        (0, $lHkHI.jsxs)($1708de212ec2da32$export$74b3b4fb3f2c9f32, {
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)($1708de212ec2da32$export$2ce7b3cf715afcb2, {
                                    children: "Your account"
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6JEuS.default), {
                                    collapsible: false,
                                    installedApp: this.props.installedApp,
                                    links: this.props.links,
                                    revokeUserGrant: this.revokeUserGrant,
                                    scopesDescription: "".concat(appName, " can perform the following actions on your behalf:"),
                                    scopesLookup: this.props.scopesLookup,
                                    userGrant: g
                                })
                            ]
                        })).getOrElse(null),
                    grantsWithoutMe.size > 0 ? /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)($1708de212ec2da32$export$2ce7b3cf715afcb2, {
                                children: "All accounts connected to this app"
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)($1708de212ec2da32$export$31dea26885d599bc, {
                                children: "This app can perform actions on behalf of people listed below. See individual permissions for more details."
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)($1708de212ec2da32$export$36cda206289cc7be, {
                                children: grantsWithoutMe.map((g)=>/*#__PURE__*/ (0, $lHkHI.jsx)($1708de212ec2da32$export$b1622a3baa37d45b, {
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6JEuS.default), {
                                            collapsible: true,
                                            installedApp: this.props.installedApp,
                                            links: this.props.links,
                                            revokeUserGrant: this.revokeUserGrant,
                                            scopesDescription: "".concat(appName, " can perform the following actions on behalf of this user:"),
                                            scopesLookup: this.props.scopesLookup,
                                            selectedContext: this.props.selectedContext,
                                            userGrant: g
                                        })
                                    }, g.user.atlassianAccountId))
                            })
                        ]
                    }) : null
                ]
            });
        });
    }
}
var $1708de212ec2da32$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($1708de212ec2da32$var$Manage3LOAppDetails);

});
parcelRegister("6JEuS", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e765be2f459f146$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $j0gMm = parcelRequire("j0gMm");

var $3AQ5s = parcelRequire("3AQ5s");

var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $8KCrk = parcelRequire("8KCrk");

var $7Uh51 = parcelRequire("7Uh51");

var $iEgm6 = parcelRequire("iEgm6");

var $lc34Y = parcelRequire("lc34Y");

var $9dw1G = parcelRequire("9dw1G");

var $lHkHI = parcelRequire("lHkHI");
class $4e765be2f459f146$var$UserGrant extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            isExpanded: false
        });
        (0, $5zQU9.default)(this, "toggleIsExpanded", ()=>{
            this.props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstalledApp)(this.state.isExpanded ? (0, $7Uh51.ExpandableSectionCollapsedEvent) : (0, $7Uh51.ExpandableSectionExpandedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_USER_GRANT_DETAILS), this.props.installedApp, {
                userGrant: this.props.userGrant.user.atlassianAccountId
            }).toObject());
            this.setState((_ref)=>{
                let { isExpanded: isExpanded } = _ref;
                return {
                    isExpanded: !isExpanded
                };
            });
        });
        (0, $5zQU9.default)(this, "renderHeading", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $9dw1G.default), {
                userGrant: this.props.userGrant
            }));
        (0, $5zQU9.default)(this, "renderContent", ()=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $lc34Y.default), {
                appName: (0, $iEgm6.resolveFieldWithFallback)((add)=>add.name, this.props.installedApp.marketplaceAppDetails, this.props.installedApp.details),
                links: this.props.links,
                revokeUserGrant: this.props.revokeUserGrant,
                scopesDescription: this.props.scopesDescription,
                scopesLookup: this.props.scopesLookup,
                userGrant: this.props.userGrant
            }));
        (0, $5zQU9.default)(this, "render", ()=>this.props.collapsible ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3AQ5s.default), {
                heading: this.renderHeading(),
                content: this.renderContent(),
                expandCollapsePrimaryColor: (0, $j0gMm.N500),
                expandCollapseSize: "large",
                hideHeadingWhenExpanded: false,
                isExpanded: this.state.isExpanded,
                onClick: this.toggleIsExpanded
            }) : /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    this.renderHeading(),
                    this.renderContent()
                ]
            }));
    }
}
var $4e765be2f459f146$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($4e765be2f459f146$var$UserGrant);

});
parcelRegister("3AQ5s", function(module, exports) {

$parcel$export(module.exports, "default", () => $29dd2345f1c93fe5$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $drftW = parcelRequire("drftW");

var $kXZN1 = parcelRequire("kXZN1");

var $j0gMm = parcelRequire("j0gMm");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $hheqg = parcelRequire("hheqg");

var $lHkHI = parcelRequire("lHkHI");
function $29dd2345f1c93fe5$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $29dd2345f1c93fe5$export$9204afa15bdaec56 = (0, $3UXZ8.default)("button", {
    target: "e1g9y9vf0",
    label: "HeadingContainer"
})("all:unset;cursor:pointer;display:flex;flex-direction:row;&:hover{background-color:", (0, $j0gMm.N20), ";}");
const $29dd2345f1c93fe5$export$a8a3e93435678ff9 = (0, $3UXZ8.default)("div", {
    target: "e1g9y9vf1",
    label: "Heading"
})({
    name: "50wo8p",
    styles: "align-items:center;display:flex;flex:1 0 auto;"
});
const $29dd2345f1c93fe5$export$78dd1174fafb3f75 = (0, $3UXZ8.default)("div", {
    target: "e1g9y9vf2",
    label: "ExpandCollapse"
})({
    name: "o6s3kp",
    styles: "align-items:center;display:flex;flex:0 0 auto;"
});
class $29dd2345f1c93fe5$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    render() {
        const { chevronClassName: chevronClassName, className: className, content: content, expandCollapseSize: expandCollapseSize, expandCollapsePrimaryColor: expandCollapsePrimaryColor, heading: heading, hideHeadingWhenExpanded: hideHeadingWhenExpanded, isExpanded: isExpanded } = this.props;
        return /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
            className: className,
            children: [
                !(isExpanded && hideHeadingWhenExpanded) ? /*#__PURE__*/ (0, $lHkHI.jsxs)($29dd2345f1c93fe5$export$9204afa15bdaec56, {
                    onClick: this.props.onClick,
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)($29dd2345f1c93fe5$export$a8a3e93435678ff9, {
                            children: heading
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)($29dd2345f1c93fe5$export$78dd1174fafb3f75, {
                            className: chevronClassName,
                            children: isExpanded ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($drftW))), {
                                label: "Collapse",
                                primaryColor: expandCollapsePrimaryColor,
                                size: expandCollapseSize
                            }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kXZN1))), {
                                label: "Expand",
                                primaryColor: expandCollapsePrimaryColor,
                                size: expandCollapseSize
                            })
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hheqg.Collapse), {
                    isOpened: isExpanded,
                    children: content
                })
            ]
        });
    }
}
(0, $5zQU9.default)($29dd2345f1c93fe5$export$2e2bcd8739ae039, "propTypes", {
    chevronClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    content: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node.isRequired,
    expandCollapsePrimaryColor: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    expandCollapseSize: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        'small',
        'medium',
        'large',
        'xlarge'
    ]),
    heading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node.isRequired,
    hideHeadingWhenExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    isExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool.isRequired,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).func.isRequired
});
(0, $5zQU9.default)($29dd2345f1c93fe5$export$2e2bcd8739ae039, "defaultProps", {
    expandCollapseSize: 'large'
});

});

parcelRegister("lc34Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6dd1b6ef91ab616$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $eUqFw = parcelRequire("eUqFw");

var $gwMyJ = parcelRequire("gwMyJ");

var $5p4oz = parcelRequire("5p4oz");

var $lHkHI = parcelRequire("lHkHI");
function $f6dd1b6ef91ab616$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f6dd1b6ef91ab616$export$7b8a8064734ade6e = (0, $3UXZ8.default)("div", {
    target: "eewncyy0",
    label: "ScopesContainer"
})({
    name: "1l2lmwm",
    styles: "margin:10px 0 0 58px;"
});
const $f6dd1b6ef91ab616$export$26dc13194381b87f = (0, $3UXZ8.default)("div", {
    target: "eewncyy1",
    label: "DisconnectButtonContainer"
})({
    name: "1sszdw9",
    styles: "margin-top:var(--ds-space-250, 20px);display:flex;flex-direction:row-reverse;"
});
class $f6dd1b6ef91ab616$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onDisconnectClick", ()=>{
            this.props.revokeUserGrant({
                userGrant: this.props.userGrant
            });
        });
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($f6dd1b6ef91ab616$export$7b8a8064734ade6e, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gwMyJ.default), {
                            appScopes: this.props.userGrant.scopes,
                            description: this.props.scopesDescription,
                            links: this.props.links,
                            scopesLookup: this.props.scopesLookup
                        })
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($f6dd1b6ef91ab616$export$26dc13194381b87f, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5p4oz.default), {
                            buttonText: "Disconnect",
                            confirmText: "Yes, disconnect",
                            onClickConfirm: this.onDisconnectClick,
                            showSpinner: this.props.userGrant.revokeInProgress
                        })
                    })
                ]
            }));
    }
}

});

parcelRegister("9dw1G", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b5e2bacef873663$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $5E0SL = parcelRequire("5E0SL");

var $bo7IP = parcelRequire("bo7IP");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $6b5e2bacef873663$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6b5e2bacef873663$export$16027874f8b9782a = (0, $3UXZ8.default)("div", {
    target: "eyer4j70",
    label: "UserGrantHeadingContainer"
})({
    name: "17v59ee",
    styles: "align-items:center;display:flex;padding:5px;"
});
const $6b5e2bacef873663$export$4a948f04408ff1a = (0, $3UXZ8.default)("div", {
    target: "eyer4j71",
    label: "UserGrantDescription"
})({
    name: "1hk41jd",
    styles: "margin-left:7px;"
});
const $6b5e2bacef873663$export$72674c6c713c7cf0 = (0, $3UXZ8.default)("span", {
    target: "eyer4j72",
    label: "UserGrantUserName"
})({
    name: "1vg6q84",
    styles: "font-weight:700;"
});
class $6b5e2bacef873663$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)($6b5e2bacef873663$export$16027874f8b9782a, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $5E0SL.default // eslint-disable-line react/jsx-key
                    ), {
                        src: this.props.userGrant.user.avatarUrl,
                        label: "Grant for ".concat(this.props.userGrant.user.name),
                        size: "large"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($6b5e2bacef873663$export$4a948f04408ff1a, {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)($6b5e2bacef873663$export$72674c6c713c7cf0, {
                                children: this.props.userGrant.user.name
                            }),
                            " added",
                            ' ',
                            (0, $bo7IP.default)(this.props.userGrant.time, {
                                addSuffix: true
                            })
                        ]
                    })
                ]
            }));
    }
}

});



parcelRegister("2JvTO", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fd887408e853894$export$2e2bcd8739ae039);

var $i8JB4 = parcelRequire("i8JB4");
var $1fd887408e853894$export$2e2bcd8739ae039 = (0, $i8JB4.default);

});
parcelRegister("i8JB4", function(module, exports) {

$parcel$export(module.exports, "default", () => $d34c57f452655a79$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $9goJJ = parcelRequire("9goJJ");

var $1Tfhj = parcelRequire("1Tfhj");

var $bPByu = parcelRequire("bPByu");

var $eUqFw = parcelRequire("eUqFw");

var $gIQkA = parcelRequire("gIQkA");

var $iEgm6 = parcelRequire("iEgm6");

var $2FaVi = parcelRequire("2FaVi");

var $3kdNe = parcelRequire("3kdNe");

var $eamSf = parcelRequire("eamSf");

var $lHkHI = parcelRequire("lHkHI");
class $d34c57f452655a79$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            canUninstall: false
        });
        (0, $5zQU9.default)(this, "updateCanInstall", (e)=>{
            this.setState({
                canUninstall: e.currentTarget.value === this.resolveName()
            });
        });
        (0, $5zQU9.default)(this, "uninstallAppFromSite", ()=>{
            this.props.uninstallAppFromSite({
                installedApp: this.props.installedApp,
                hostConfig: this.props.hostConfig,
                context: this.props.context
            });
        });
        (0, $5zQU9.default)(this, "onCloseDialog", ()=>{
            if (!this.props.installedApp.uninstallInProgress) this.props.closeSiteUninstallDialog({
                installedApp: this.props.installedApp
            });
        });
        (0, $5zQU9.default)(this, "renderUninstallConfirmationFooter", ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)((0, $9goJJ.default), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bPByu.default), {
                        isLoading: this.props.installedApp.uninstallInProgress,
                        appearance: "danger",
                        isDisabled: !this.state.canUninstall,
                        onClick: this.uninstallAppFromSite,
                        children: "Remove app"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eamSf.default), {
                        appearance: "subtle-link",
                        isDisabled: this.props.installedApp.uninstallInProgress,
                        onClick: this.onCloseDialog,
                        children: "Cancel"
                    })
                ]
            }));
        (0, $5zQU9.default)(this, "resolveName", ()=>(0, $iEgm6.resolveFieldWithFallback)((add)=>add.name, this.props.installedApp.marketplaceAppDetails, this.props.installedApp.details));
    }
    render() {
        const appName = this.resolveName();
        return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $3kdNe.default), {
            analyticsName: (0, $gIQkA.ANALYTICS_MODAL_UNINSTALL_SITE),
            width: "medium",
            onClose: this.onCloseDialog,
            heading: this.props.hostConfig.removeFromSite.actionSummary(appName),
            footer: this.renderUninstallConfirmationFooter(),
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $2FaVi.default), {
                    icon: "error",
                    children: this.props.hostConfig.removeFromSite.confirmation(appName)
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1Tfhj.default), {
                    autoFocus: true,
                    isDisabled: this.props.installedApp.uninstallInProgress,
                    label: "To permanently remove this app, type: ".concat(appName),
                    onChange: this.updateCanInstall,
                    value: ""
                })
            ]
        });
    }
}

});




parcelRegister("cY537", function(module, exports) {

$parcel$export(module.exports, "default", () => $970f015047100f21$export$2e2bcd8739ae039);

var $30dkn = parcelRequire("30dkn");
var $970f015047100f21$export$2e2bcd8739ae039 = (0, $30dkn.default);

});
parcelRegister("30dkn", function(module, exports) {

$parcel$export(module.exports, "default", () => $22fbb5cd55d85281$export$2e2bcd8739ae039);
parcelRequire("jJs3W");
var $94zHK = parcelRequire("94zHK");

var $i0k4A = parcelRequire("i0k4A");

var $7jp5q = parcelRequire("7jp5q");

var $5Wf8D = parcelRequire("5Wf8D");

var $hNyxl = parcelRequire("hNyxl");

var $27sEB = parcelRequire("27sEB");
const $22fbb5cd55d85281$var$mapStateToProps = (state)=>({
        currentUserId: state.users.currentUserId,
        locallyInstalledApps: state.installedApps.locallyInstalledApps,
        globallyInstalledApps: state.installedApps.globallyInstalledApps
    });
const $22fbb5cd55d85281$var$mapDispatchToProps = (dispatch, ownProps)=>({
        openManualUrlInstallDialog: ()=>dispatch((0, $7jp5q.doStartInstallableAppByManualUrlInstallMode)()),
        openUpgradeAppDialog: (_ref)=>{
            let { installedApp: installedApp } = _ref;
            return dispatch((0, $5Wf8D.doInitiateUpgradeInstallModeForInstalledApp)({
                mpacBaseUrl: ownProps.bootstrapConfig.mpacBaseUrl,
                installedApp: installedApp
            }));
        },
        regenerateAppSpecificPassword: (_ref2)=>{
            let { context: context, installedApp: installedApp } = _ref2;
            return dispatch((0, $i0k4A.doRegenerateAppSpecificPassword)({
                context: context,
                installedApp: installedApp
            }));
        },
        retrieveMoreGloballyInstalledApps: (_ref3)=>{
            let { context: context, hostConfig: hostConfig, search: search, offset: offset } = _ref3;
            return dispatch((0, $hNyxl.doRetrieveMoreGloballyInstalledApps)({
                context: context,
                hostConfig: hostConfig,
                search: search,
                offset: offset
            }));
        },
        retrieveMoreLocallyInstalledApps: (_ref4)=>{
            let { context: context, hostConfig: hostConfig, search: search, offset: offset } = _ref4;
            return dispatch((0, $hNyxl.doRetrieveMoreLocallyInstalledApps)({
                context: context,
                hostConfig: hostConfig,
                search: search,
                offset: offset
            }));
        },
        revokeUserGrantGlobally: (_ref5)=>{
            let { hostConfig: hostConfig, installedApp: installedApp, userGrant: userGrant } = _ref5;
            return dispatch((0, $hNyxl.doRevokeUserGrantGlobally)({
                hostConfig: hostConfig,
                installedApp: installedApp,
                userGrant: userGrant
            }));
        },
        uninstallAppFromLocalContext: (_ref6)=>{
            let { context: context, installedApp: installedApp, hostConfig: hostConfig } = _ref6;
            return dispatch((0, $hNyxl.doUninstallAppFromLocalContext)({
                context: context,
                installedApp: installedApp,
                hostConfig: hostConfig
            }));
        }
    });
var $22fbb5cd55d85281$export$2e2bcd8739ae039 = (0, $94zHK.default)($22fbb5cd55d85281$var$mapStateToProps, $22fbb5cd55d85281$var$mapDispatchToProps)((0, $27sEB.default));

});
parcelRegister("27sEB", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b2764b71d5506f$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $kU8RF = parcelRequire("kU8RF");

var $f2QOW = parcelRequire("f2QOW");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $eUqFw = parcelRequire("eUqFw");

var $9EWTa = parcelRequire("9EWTa");

var $bzu0a = parcelRequire("bzu0a");

var $ivcsi = parcelRequire("ivcsi");

var $lHkHI = parcelRequire("lHkHI");
function $18b2764b71d5506f$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $18b2764b71d5506f$export$7e7b111da66d0a45 = (0, $3UXZ8.default)("div", {
    target: "eq0jljg0",
    label: "InstalledAppsSectionContainer"
})({
    name: "7hghil",
    styles: "& + &{margin-top:30px;}"
});
class $18b2764b71d5506f$export$2e2bcd8739ae039 extends (0, $eUqFw.Component) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $bzu0a.default), {
                        history: this.props.history,
                        openManualUrlInstallDialog: this.props.openManualUrlInstallDialog
                    }),
                    (0, $bWAru.Option).map2(this.props.locallyInstalledApps.result, this.props.globallyInstalledApps.result, (lias, gias)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $kU8RF.default), {
                            active: false,
                            delay: 1000,
                            size: 50,
                            children: (0, $bWAru.Either).map2(lias, gias, (locallyInstalledAppsResult, globallyInstalledAppsResult)=>locallyInstalledAppsResult.totalCount || globallyInstalledAppsResult.totalCount ? /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                                    children: [
                                        locallyInstalledAppsResult.totalCount ? /*#__PURE__*/ (0, $lHkHI.jsx)($18b2764b71d5506f$export$7e7b111da66d0a45, {
                                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $f2QOW.default), {
                                                attributes: {
                                                    section: 'local'
                                                },
                                                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9EWTa.default), {
                                                    currentUserId: this.props.currentUserId,
                                                    global: false,
                                                    headingText: this.props.hostConfig.installedApps.locallyInstalledApps.sectionHeading,
                                                    history: this.props.history,
                                                    hostConfig: this.props.hostConfig,
                                                    initializeCollapsed: false,
                                                    installedAppsResult: locallyInstalledAppsResult,
                                                    links: this.props.links,
                                                    onLoadMore: this.props.retrieveMoreLocallyInstalledApps,
                                                    openUpgradeAppDialog: this.props.openUpgradeAppDialog,
                                                    regenerateAppSpecificPassword: this.props.regenerateAppSpecificPassword,
                                                    revokeUserGrantGlobally: this.props.revokeUserGrantGlobally,
                                                    selectedContext: this.props.selectedContext,
                                                    uninstallAppFromLocalContext: this.props.uninstallAppFromLocalContext
                                                })
                                            })
                                        }) : null,
                                        globallyInstalledAppsResult.totalCount ? /*#__PURE__*/ (0, $lHkHI.jsx)($18b2764b71d5506f$export$7e7b111da66d0a45, {
                                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $f2QOW.default), {
                                                attributes: {
                                                    section: 'global'
                                                },
                                                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9EWTa.default), {
                                                    currentUserId: this.props.currentUserId,
                                                    description: this.props.hostConfig.installedApps.globallyInstalledApps.sectionDescription,
                                                    global: true,
                                                    headingText: this.props.hostConfig.installedApps.globallyInstalledApps.sectionHeading,
                                                    history: this.props.history,
                                                    hostConfig: this.props.hostConfig,
                                                    initializeCollapsed: true,
                                                    installedAppsResult: globallyInstalledAppsResult,
                                                    links: this.props.links,
                                                    onLoadMore: this.props.retrieveMoreGloballyInstalledApps,
                                                    openUpgradeAppDialog: this.props.openUpgradeAppDialog,
                                                    regenerateAppSpecificPassword: this.props.regenerateAppSpecificPassword,
                                                    revokeUserGrantGlobally: this.props.revokeUserGrantGlobally,
                                                    selectedContext: this.props.selectedContext,
                                                    uninstallAppFromLocalContext: this.props.uninstallAppFromLocalContext
                                                })
                                            })
                                        }) : null
                                    ]
                                }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ivcsi.default), {
                                    history: this.props.history
                                })).getOrElse(null)
                        })).getOrElse(/*#__PURE__*/ (0, $lHkHI.jsx)((0, $kU8RF.default), {
                        active: true,
                        delay: 1000,
                        size: 50,
                        children: null
                    }))
                ]
            }));
    }
    componentDidUpdate(prevProps) {
        if ([
            prevProps.locallyInstalledApps.result.isEmpty(),
            prevProps.globallyInstalledApps.result.isEmpty()
        ].includes(true)) (0, $bWAru.Option).map2(this.props.locallyInstalledApps.result, this.props.globallyInstalledApps.result, this.props.onRendered);
    }
}

});
parcelRegister("9EWTa", function(module, exports) {

$parcel$export(module.exports, "default", () => $70858793131672d8$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $cjFit = parcelRequire("cjFit");
var $gS1Ox = parcelRequire("gS1Ox");
var $czlCy = parcelRequire("czlCy");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $foExo = parcelRequire("foExo");

var $lHkHI = parcelRequire("lHkHI");
function $70858793131672d8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $70858793131672d8$export$8926bd5fcf15b88b = 'iconContainer';
const $70858793131672d8$export$455e128cfc47a8c4 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $gS1Ox.default), {
    target: "e1l9hnyb0",
    label: "ExpandableSectionStatefulStyled"
})(".", $70858793131672d8$export$8926bd5fcf15b88b, "{margin-right:var(--ds-space-250, 20px);}");
const $70858793131672d8$export$9204afa15bdaec56 = (0, $3UXZ8.default)("div", {
    target: "e1l9hnyb1",
    label: "HeadingContainer"
})({
    name: "199jgwe",
    styles: "font-size:14px;margin:21px 10px;"
});
const $70858793131672d8$export$a8a3e93435678ff9 = (0, $3UXZ8.default)("div", {
    target: "e1l9hnyb2",
    label: "Heading"
})("color:", (0, $j0gMm.N800), ";font-weight:bold;");
const $70858793131672d8$export$393edc798c47379d = (0, $3UXZ8.default)("div", {
    target: "e1l9hnyb3",
    label: "Description"
})("color:", (0, $j0gMm.N300), ";margin-top:5px;");
const $70858793131672d8$var$PaginationContainer = (0, $3UXZ8.default)("div", {
    target: "e1l9hnyb4",
    label: "PaginationContainer"
})({
    name: "kfzi1",
    styles: "margin:25px auto;"
});
class $70858793131672d8$var$InstalledAppsSection extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "onLoadMoreFactory", (nextOffset)=>()=>{
                this.props.fireAnalyticsEvent({
                    eventType: (0, $gaiog.ButtonClickedEvent),
                    actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_MORE_RESULTS)
                });
                this.props.onLoadMore({
                    hostConfig: this.props.hostConfig,
                    context: this.props.selectedContext,
                    search: (0, $cjFit.emptyString),
                    offset: nextOffset
                });
            });
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsx)($70858793131672d8$export$455e128cfc47a8c4, {
            chevronClassName: $70858793131672d8$export$8926bd5fcf15b88b,
            content: /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
                        children: this.props.installedAppsResult.installedApps.map((ia)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $foExo.default), {
                                currentUserId: this.props.currentUserId,
                                global: this.props.global,
                                history: this.props.history,
                                hostConfig: this.props.hostConfig,
                                installedApp: ia,
                                links: this.props.links,
                                regenerateAppSpecificPassword: this.props.regenerateAppSpecificPassword,
                                revokeUserGrantGlobally: this.props.revokeUserGrantGlobally,
                                selectedContext: this.props.selectedContext,
                                uninstallAppFromLocalContext: this.props.uninstallAppFromLocalContext,
                                openUpgradeAppDialog: this.props.openUpgradeAppDialog
                            }, ia.details.key))
                    }),
                    this.props.installedAppsResult.nextOffset.map((nextOffset)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
                        (0, $lHkHI.jsx)($70858793131672d8$var$PaginationContainer, {
                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $czlCy.default), {
                                appearance: "secondary",
                                loadingMoreResults: this.props.installedAppsResult.loadingMoreResults,
                                moreResultsDataError: false,
                                moreResultsDataErrorMessages: (0, $g5DHJ.List)(),
                                onLoadMoreResultsClick: this.onLoadMoreFactory(nextOffset)
                            })
                        })).orNull()
                ]
            }),
            heading: /*#__PURE__*/ (0, $lHkHI.jsxs)($70858793131672d8$export$9204afa15bdaec56, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($70858793131672d8$export$a8a3e93435678ff9, {
                        children: [
                            this.props.headingText,
                            " (",
                            this.props.installedAppsResult.totalCount,
                            ")"
                        ]
                    }),
                    this.props.description ? /*#__PURE__*/ (0, $lHkHI.jsx)($70858793131672d8$export$393edc798c47379d, {
                        children: this.props.description
                    }) : null
                ]
            }),
            expandCollapsePrimaryColor: (0, $j0gMm.N500),
            hideHeadingWhenExpanded: false,
            initializeCollapsed: this.props.initializeCollapsed
        });
    }
}
var $70858793131672d8$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($70858793131672d8$var$InstalledAppsSection);

});
parcelRegister("gS1Ox", function(module, exports) {

$parcel$export(module.exports, "default", () => $c48318be7363af00$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3AQ5s = parcelRequire("3AQ5s");

var $1Qivz = parcelRequire("1Qivz");

var $eUqFw = parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
class $c48318be7363af00$export$2e2bcd8739ae039 extends (0, $eUqFw.PureComponent) {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            isExpanded: !this.props.initializeCollapsed
        });
        (0, $5zQU9.default)(this, "toggle", ()=>{
            this.setState((_ref)=>{
                let { isExpanded: isExpanded } = _ref;
                return {
                    isExpanded: !isExpanded
                };
            });
        });
    }
    render() {
        const { isExpanded: isExpanded } = this.state;
        const { chevronClassName: chevronClassName, className: className, content: content, expandCollapsePrimaryColor: expandCollapsePrimaryColor, expandCollapseSize: expandCollapseSize, heading: heading, hideHeadingWhenExpanded: hideHeadingWhenExpanded } = this.props;
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3AQ5s.default), {
            chevronClassName: chevronClassName,
            className: className,
            content: content,
            expandCollapsePrimaryColor: expandCollapsePrimaryColor,
            expandCollapseSize: expandCollapseSize,
            heading: heading,
            hideHeadingWhenExpanded: hideHeadingWhenExpanded,
            isExpanded: isExpanded,
            onClick: this.toggle
        });
    }
}
(0, $5zQU9.default)($c48318be7363af00$export$2e2bcd8739ae039, "propTypes", {
    chevronClassName: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    className: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    content: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node.isRequired,
    expandCollapsePrimaryColor: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).string,
    expandCollapseSize: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).oneOf([
        'small',
        'medium',
        'large',
        'xlarge'
    ]),
    heading: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).node.isRequired,
    hideHeadingWhenExpanded: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool,
    initializeCollapsed: (0, (/*@__PURE__*/$parcel$interopDefault($1Qivz))).bool
});
(0, $5zQU9.default)($c48318be7363af00$export$2e2bcd8739ae039, "defaultProps", {
    expandCollapseSize: 'large',
    hideHeadingWhenExpanded: false,
    initializeCollapsed: true
});

});

parcelRegister("foExo", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3588ad7f04e67bd$export$2e2bcd8739ae039);

var $1zGxe = parcelRequire("1zGxe");
var $b3588ad7f04e67bd$export$2e2bcd8739ae039 = (0, $1zGxe.default);

});
parcelRegister("1zGxe", function(module, exports) {

$parcel$export(module.exports, "default", () => $125a0de322ab5fc8$export$2e2bcd8739ae039);

var $bwPfh = parcelRequire("bwPfh");

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $cQKn6 = parcelRequire("cQKn6");

var $9oiuL = parcelRequire("9oiuL");

var $ZN2Lb = parcelRequire("ZN2Lb");
var $gTOQV = parcelRequire("gTOQV");
var $71CV8 = parcelRequire("71CV8");

var $gXXkA = parcelRequire("gXXkA");

var $d8i0J = parcelRequire("d8i0J");

var $ivTMz = parcelRequire("ivTMz");

var $j0gMm = parcelRequire("j0gMm");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $lQqqi = parcelRequire("lQqqi");

var $aosfp = parcelRequire("aosfp");

var $c9Mth = parcelRequire("c9Mth");
var $g01ln = parcelRequire("g01ln");

var $bo7IP = parcelRequire("bo7IP");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $eUqFw = parcelRequire("eUqFw");

var $8KCrk = parcelRequire("8KCrk");

var $7Uh51 = parcelRequire("7Uh51");

var $iEgm6 = parcelRequire("iEgm6");

var $jwE5W = parcelRequire("jwE5W");

var $lHkHI = parcelRequire("lHkHI");
const $125a0de322ab5fc8$var$_excluded = [
    "triggerRef"
];
function $125a0de322ab5fc8$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $125a0de322ab5fc8$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $125a0de322ab5fc8$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $125a0de322ab5fc8$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $125a0de322ab5fc8$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $125a0de322ab5fc8$var$InstalledAppContainer = (0, $3UXZ8.default)("div", {
    target: "e1mpaigu0",
    label: "InstalledAppContainer"
})("align-items:center;display:flex;margin:auto;padding:var(--ds-space-150, 12px) var(--ds-space-100, 8px);width:100%;&:hover{background-color:", (0, $j0gMm.N20), ";}");
const $125a0de322ab5fc8$var$InstalledAppIconContainer = (0, $3UXZ8.default)("div", {
    target: "e1mpaigu1",
    label: "InstalledAppIconContainer"
})("border-radius:", (0, $ivTMz.borderRadius)(), "px;height:24px;margin-right:var(--ds-space-100, 8px);width:24px;");
const $125a0de322ab5fc8$var$InstalledAppRightAction = (0, $3UXZ8.default)("div", {
    target: "e1mpaigu2",
    label: "InstalledAppRightAction"
})({
    name: "mnj692",
    styles: "display:inline-block;margin:auto;min-width:32px;padding-left:var(--ds-space-200, 16px);padding-right:var(--ds-space-100, 8px);vertical-align:top;"
});
const $125a0de322ab5fc8$var$MainLinkInstalledAppRightAction = (0, $3UXZ8.default)("div", {
    target: "e1mpaigu3",
    label: "MainLinkInstalledAppRightAction"
})({
    name: "x6mdg1",
    styles: "display:inline-block;margin:auto;min-width:48px;padding-left:var(--ds-space-200, 16px);"
});
const $125a0de322ab5fc8$var$InstalledAppAction = (0, $3UXZ8.default)("div", {
    target: "e1mpaigu4",
    label: "InstalledAppAction"
})("transition:opacity 0.3s linear 0s;transition-delay:", (props)=>props.shown ? '0.4s' : 'initial', ";width:50%;display:table-cell;opacity:", (props)=>props.shown ? '1' : '0', ";vertical-align:middle;");
const $125a0de322ab5fc8$var$InstalledAppActions = (0, $3UXZ8.default)("div", {
    target: "e1mpaigu5",
    label: "InstalledAppActions"
})({
    name: "1ee4fl1",
    styles: "overflow:hidden;flex:1 1 auto;"
});
const $125a0de322ab5fc8$var$InstalledAppActionsContainer = (0, $3UXZ8.default)("div", {
    target: "e1mpaigu6",
    label: "InstalledAppActionsContainer"
})("transition:margin-left 0s linear 0.35s;display:table;margin-left:", (props)=>props.showConfirm ? '-100%' : 'initial', ";text-align:right;width:200%;");
const $125a0de322ab5fc8$export$2cc4b3d24590276b = (0, $3UXZ8.default)("div", {
    target: "e1mpaigu7",
    label: "InstalledAppMainActions"
})({
    name: "70qvj9",
    styles: "display:flex;align-items:center;"
});
const $125a0de322ab5fc8$var$InstalledAppDetails = (0, $3UXZ8.default)("div", {
    target: "e1mpaigu8",
    label: "InstalledAppDetails"
})({
    name: "1vou5f1",
    styles: "flex:6;"
});
const $125a0de322ab5fc8$var$InstalledAppName = (0, $3UXZ8.default)("div", {
    target: "e1mpaigu9",
    label: "InstalledAppName"
})({
    name: "1vg6q84",
    styles: "font-weight:700;"
});
const $125a0de322ab5fc8$var$InstalledAppInstallDate = (0, $3UXZ8.default)("div", {
    target: "e1mpaigu10",
    label: "InstalledAppInstallDate"
})("font-size:90%;color:", (0, $j0gMm.N300), ";");
const $125a0de322ab5fc8$var$makeAction = (0, $g5DHJ.Record)({
    getDisplayName: ()=>'',
    getConfirmText: ()=>'',
    isInProgress: undefined,
    icon: undefined,
    isVisible: ()=>true,
    key: '',
    launchedInstantly: false,
    onClick: ()=>{
    /* empty action, do nothing by default */ },
    silenceAnalytics: false
});
const $125a0de322ab5fc8$var$makeAppActions = (0, $g5DHJ.Record)({
    authType: '',
    // Once CAAS-1087 is fixed, remove appFilter property
    appFilter: ()=>true,
    secondaryLabel: ()=>'',
    mainActions: (0, $g5DHJ.List)(),
    otherActions: (0, $g5DHJ.List)()
});
const $125a0de322ab5fc8$var$menuButtonProps = {
    appearance: 'subtle',
    iconBefore: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($gXXkA))), {
        label: "More"
    }),
    type: 'button',
    spacing: 'default',
    shouldFitContainer: false,
    isSelected: false,
    isLoading: false,
    isDisabled: false,
    autoFocus: false
};
const $125a0de322ab5fc8$var$installTimeLabel = (installedApp)=>(0, $bo7IP.default)(installedApp.installTime, {
        addSuffix: true
    });
const $125a0de322ab5fc8$var$installUserLabel = (installedApp)=>installedApp.installUser ? "by ".concat(installedApp.installUser.name) : '';
// Order is important until CAAS-1087 is fixed
const $125a0de322ab5fc8$var$actions = (0, $g5DHJ.List)([
    $125a0de322ab5fc8$var$makeAppActions({
        authType: 'ASP',
        // Once CAAS-1087 is fixed, remove appFilter property
        appFilter: (installedApp)=>installedApp.details.origin === 'token',
        secondaryLabel: (installedApp)=>"Created ".concat($125a0de322ab5fc8$var$installTimeLabel(installedApp), " ").concat($125a0de322ab5fc8$var$installUserLabel(installedApp)),
        otherActions: (0, $g5DHJ.List)([
            $125a0de322ab5fc8$var$makeAction({
                getDisplayName: ()=>'Regenerate',
                getConfirmText: ()=>'Yes, regenerate',
                key: 'regenerate',
                onClick: (props)=>props.regenerateAppSpecificPassword({
                        installedApp: props.installedApp,
                        context: props.selectedContext
                    })
            }),
            $125a0de322ab5fc8$var$makeAction({
                getDisplayName: ()=>'Remove',
                getConfirmText: ()=>'Yes, remove',
                isInProgress: (props)=>props.installedApp.uninstallInProgress,
                key: 'remove',
                onClick: (props)=>{
                    props.uninstallAppFromLocalContext({
                        context: props.selectedContext,
                        installedApp: props.installedApp,
                        hostConfig: props.hostConfig
                    });
                }
            })
        ])
    }),
    $125a0de322ab5fc8$var$makeAppActions({
        authType: '2LO',
        // Once CAAS-1087 is fixed, remove appFilter property
        appFilter: (installedApp)=>installedApp.authType.type === '2LO',
        secondaryLabel: (installedApp)=>"Added ".concat($125a0de322ab5fc8$var$installTimeLabel(installedApp), " ").concat($125a0de322ab5fc8$var$installUserLabel(installedApp)),
        mainActions: (0, $g5DHJ.List)([
            $125a0de322ab5fc8$var$makeAction({
                getDisplayName: ()=>'Update available',
                icon: /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($d8i0J))), {
                    label: "Update available",
                    primaryColor: "orange"
                }),
                isVisible: (props)=>props.installedApp.upgradeAvailable,
                key: 'upgradeAvailable',
                launchedInstantly: true,
                onClick: (props)=>props.openUpgradeAppDialog({
                        installedApp: props.installedApp
                    })
            }),
            $125a0de322ab5fc8$var$makeAction({
                getDisplayName: ()=>'Configure',
                isVisible: (props)=>props.installedApp.configureUrl !== undefined,
                key: 'configure',
                launchedInstantly: true,
                onClick: (props)=>{
                    props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstalledApp)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_CONFIGURE), props.installedApp).toObject());
                    if (props.installedApp.configureUrl) (0, $g01ln).openPage(props.installedApp.configureUrl, (0, $g01ln).TOP_WINDOW);
                },
                silenceAnalytics: true
            })
        ]),
        otherActions: (0, $g5DHJ.List)([
            $125a0de322ab5fc8$var$makeAction({
                getDisplayName: ()=>'View permissions',
                key: 'viewPermissions',
                launchedInstantly: true,
                onClick: (props)=>{
                    props.history.push({
                        pathname: props.emceeLinks.manageAppDetails.getRelative(props.installedApp.details.key),
                        search: (0, $c9Mth).resolveSearchFromImmutableQuery((0, $g5DHJ.Map)({
                            global: props.global
                        }))
                    });
                }
            }),
            $125a0de322ab5fc8$var$makeAction({
                getDisplayName: (_ref)=>{
                    let { hostConfig: hostConfig } = _ref;
                    return "Remove app from ".concat(hostConfig.contextType);
                },
                getConfirmText: ()=>'Yes, remove',
                isVisible: (props)=>!props.global,
                isInProgress: (props)=>props.installedApp.uninstallInProgress,
                key: 'remove',
                onClick: (props)=>{
                    props.uninstallAppFromLocalContext({
                        context: props.selectedContext,
                        installedApp: props.installedApp,
                        hostConfig: props.hostConfig
                    });
                }
            })
        ])
    }),
    $125a0de322ab5fc8$var$makeAppActions({
        authType: '3LO',
        // Once CAAS-1087 is fixed, remove appFilter property
        appFilter: (installedApp)=>installedApp.authType.type === '3LO',
        secondaryLabel: (installedApp)=>"Added ".concat($125a0de322ab5fc8$var$installTimeLabel(installedApp), " ").concat($125a0de322ab5fc8$var$installUserLabel(installedApp)),
        otherActions: (0, $g5DHJ.List)([
            $125a0de322ab5fc8$var$makeAction({
                getDisplayName: ()=>'Manage connections',
                key: 'manageConnections',
                launchedInstantly: true,
                onClick: (props)=>{
                    props.history.push({
                        pathname: props.emceeLinks.manageAppDetails.getRelative(props.installedApp.details.key),
                        search: (0, $c9Mth).resolveSearchFromImmutableQuery((0, $g5DHJ.Map)({
                            global: props.global
                        }))
                    });
                }
            }),
            $125a0de322ab5fc8$var$makeAction({
                getDisplayName: ()=>'Remove my connection',
                getConfirmText: ()=>'Yes, disconnect',
                isVisible: (props)=>(0, $lQqqi.foldAuthType)(props.installedApp.authType)((_)=>false, (_)=>false, (threeLeggedAuthType)=>threeLeggedAuthType.grants.some((g)=>props.currentUserId === g.user.atlassianAccountId)),
                key: 'disconnect',
                onClick: (props)=>(0, $lQqqi.foldAuthType)(props.installedApp.authType)((_appSpecificAuth)=>{
                    /* do nothing */ }, (_twoLeggedAuth)=>{
                    /* do nothing */ }, (threeLeggedAuthType)=>(0, $bWAru.Option).of(threeLeggedAuthType.grants.find((g)=>props.currentUserId === g.user.atlassianAccountId)).forEach((userGrant)=>{
                            props.revokeUserGrantGlobally({
                                hostConfig: props.hostConfig,
                                installedApp: props.installedApp,
                                userGrant: userGrant
                            });
                        }))
            })
        ])
    })
]);
class $125a0de322ab5fc8$var$InstalledApp extends $eUqFw.PureComponent {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "state", {
            showConfirm: false,
            confirmAction: undefined
        });
        (0, $5zQU9.default)(this, "onActionFactory", (action)=>()=>{
                if (!action.silenceAnalytics) this.props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstalledApp)((0, $gaiog.MenuItemClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_APPS_ACTION), this.props.installedApp, {
                    action: action.getDisplayName(this.props)
                }).toObject());
                if (action.launchedInstantly) action.onClick(this.props);
                else this.setState({
                    showConfirm: true,
                    confirmAction: action
                });
            });
        (0, $5zQU9.default)(this, "onActionCancel", ()=>{
            const action = this.state.confirmAction;
            if (action && !action.silenceAnalytics && this.state.showConfirm) this.props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstalledApp)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_ACTION_CANCEL), this.props.installedApp, {
                action: action.getDisplayName(this.props)
            }).toObject());
            this.hideConfirm();
        });
        (0, $5zQU9.default)(this, "hideConfirm", ()=>{
            this.setState({
                showConfirm: false
            });
        });
        (0, $5zQU9.default)(this, "onConfirm", ()=>{
            if (this.state.confirmAction) {
                if (!this.state.confirmAction.isInProgress) this.hideConfirm();
                this.state.confirmAction.onClick(this.props);
                this.props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstalledApp)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_ACTION_CONFIRM), this.props.installedApp, this.state.confirmAction ? {
                    action: this.state.confirmAction.getDisplayName(this.props)
                } : undefined).toObject());
            }
        });
        (0, $5zQU9.default)(this, "onOpenChange", (_ref2)=>{
            let { isOpen: isOpen } = _ref2;
            if (isOpen) this.props.fireAnalyticsEvent((0, $8KCrk.makeAnalyticsForInstalledApp)((0, $gaiog.ButtonClickedEvent), (0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_MENU_OPEN), this.props.installedApp, this.props.selectedContext).toObject());
        });
    }
    // eslint-disable-next-line max-lines-per-function -- Fix me
    render() {
        const actionsForApp = $125a0de322ab5fc8$var$actions.find((v)=>v.appFilter(this.props.installedApp));
        // Once CAAS-1087 is fixed, replace above line with the following:
        // const actionsForApp: AppActions = actions.find(a => this.props.installedApp.authType.type === a.authType);
        const visibleMainLinks = actionsForApp.mainActions.filter((action)=>action.isVisible(this.props));
        const mainLink = (0, $bWAru.Option).of(visibleMainLinks.first()).map((action)=>/*#__PURE__*/ // eslint-disable-next-line react/jsx-key
            (0, $lHkHI.jsx)($125a0de322ab5fc8$var$MainLinkInstalledAppRightAction, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                    appearance: "subtle-link",
                    isDisabled: false,
                    onClick: this.onActionFactory(action),
                    children: /*#__PURE__*/ (0, $lHkHI.jsxs)($125a0de322ab5fc8$export$2cc4b3d24590276b, {
                        children: [
                            action.icon,
                            action.getDisplayName(this.props)
                        ]
                    })
                })
            })).orUndefined();
        const items = actionsForApp.otherActions.concat(visibleMainLinks.shift()).filter((action)=>action.isVisible(this.props)).map((action)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $gTOQV.default), {
                onClick: this.onActionFactory(action),
                children: action.getDisplayName(this.props)
            }, action.key));
        const actionInProgress = this.state.confirmAction && this.state.confirmAction.isInProgress ? this.state.confirmAction.isInProgress(this.props) : false;
        const appDetails = this.props.installedApp.details;
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($125a0de322ab5fc8$var$InstalledAppContainer, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($125a0de322ab5fc8$var$InstalledAppIconContainer, {
                    children: (0, $aosfp.default).getAppIcon(appDetails.origin, appDetails.key, appDetails.icon, this.props.links.appIcon)
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)($125a0de322ab5fc8$var$InstalledAppDetails, {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsx)($125a0de322ab5fc8$var$InstalledAppName, {
                            children: (0, $iEgm6.resolveFieldWithFallback)((add)=>add.name, this.props.installedApp.marketplaceAppDetails, appDetails)
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)($125a0de322ab5fc8$var$InstalledAppInstallDate, {
                            children: actionsForApp.secondaryLabel(this.props.installedApp)
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($125a0de322ab5fc8$var$InstalledAppActions, {
                    children: /*#__PURE__*/ (0, $lHkHI.jsxs)($125a0de322ab5fc8$var$InstalledAppActionsContainer, {
                        showConfirm: this.state.showConfirm,
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsxs)($125a0de322ab5fc8$var$InstalledAppAction, {
                                shown: !this.state.showConfirm,
                                "aria-hidden": this.state.showConfirm,
                                children: [
                                    mainLink,
                                    /*#__PURE__*/ (0, $lHkHI.jsx)($125a0de322ab5fc8$var$InstalledAppRightAction, {
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ZN2Lb.default), {
                                            onOpenChange: this.onOpenChange,
                                            placement: "bottom-end",
                                            trigger: (_ref3)=>{
                                                let { triggerRef: triggerRef } = _ref3, triggerProps = (0, $bwPfh.default)(_ref3, $125a0de322ab5fc8$var$_excluded);
                                                return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), $125a0de322ab5fc8$var$_objectSpread($125a0de322ab5fc8$var$_objectSpread($125a0de322ab5fc8$var$_objectSpread({}, triggerProps), $125a0de322ab5fc8$var$menuButtonProps), {}, {
                                                    ref: triggerRef
                                                }));
                                            },
                                            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $71CV8.default), {
                                                children: items
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsxs)($125a0de322ab5fc8$var$InstalledAppAction, {
                                shown: this.state.showConfirm,
                                "aria-hidden": !this.state.showConfirm,
                                children: [
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cQKn6.default), {
                                        isLoading: actionInProgress,
                                        onClick: this.onConfirm,
                                        spacing: "compact",
                                        children: this.state.confirmAction ? this.state.confirmAction.getConfirmText(this.props) : 'Confirm'
                                    }),
                                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                                        appearance: "subtle-link",
                                        isDisabled: actionInProgress,
                                        onClick: this.onActionCancel,
                                        spacing: "compact",
                                        children: "Cancel"
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        });
    }
}
const $125a0de322ab5fc8$var$InstalledAppWithEmceeLinks = (0, $jwE5W.withEmceeLinks)($125a0de322ab5fc8$var$InstalledApp);
var $125a0de322ab5fc8$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($125a0de322ab5fc8$var$InstalledAppWithEmceeLinks);

});



parcelRegister("bzu0a", function(module, exports) {

$parcel$export(module.exports, "default", () => $86ca3c513c36e357$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $gykb8 = parcelRequire("gykb8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $fgDSb = parcelRequire("fgDSb");

var $c2OMJ = parcelRequire("c2OMJ");

var $jwE5W = parcelRequire("jwE5W");

var $lHkHI = parcelRequire("lHkHI");
function $86ca3c513c36e357$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $86ca3c513c36e357$export$c155525872d7c03c = (0, $3UXZ8.default)("span", {
    target: "e1coktxb0",
    label: "NavigationHeaderSeparator"
})({
    name: "5npys1",
    styles: "padding:0 var(--ds-space-100, 8px);"
});
const $86ca3c513c36e357$export$1709c4e4c1735a00 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $c2OMJ.NavigationHeaderContainer), {
    target: "e1coktxb1",
    label: "ManageAppsHeaderContainer"
})("border-bottom:1px solid ", (0, $j0gMm.N40), ";");
class $86ca3c513c36e357$export$e93830c7fdc75fee extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).Component {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "openCustomDialog", ()=>{
            this.props.fireAnalyticsEvent({
                eventType: (0, $gaiog.ButtonClickedEvent),
                actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_NAV_BAR_CUSTOM_APP)
            });
            this.props.openManualUrlInstallDialog();
        });
        (0, $5zQU9.default)(this, "render", ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)($86ca3c513c36e357$export$1709c4e4c1735a00, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $c2OMJ.NavigationHeaderInnerHeading), {
                        children: "Manage apps"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                                onClick: this.openCustomDialog,
                                children: "Add custom app"
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)($86ca3c513c36e357$export$c155525872d7c03c, {
                                children: "|"
                            }),
                            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $fgDSb.default), {
                                history: this.props.history,
                                href: this.props.emceeLinks.discoverHome.getRelative(),
                                label: "Marketplace apps"
                            })
                        ]
                    })
                ]
            }));
    }
}
const $86ca3c513c36e357$var$ManageAppsHeaderWithLinks = (0, $jwE5W.withEmceeLinks)($86ca3c513c36e357$export$e93830c7fdc75fee);
var $86ca3c513c36e357$export$2e2bcd8739ae039 = (0, $9osuT.withAnalytics)($86ca3c513c36e357$var$ManageAppsHeaderWithLinks);

});

parcelRegister("ivcsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d784c8a0dcdc3a62$export$2e2bcd8739ae039);

var $2QLOh = parcelRequire("2QLOh");
var $d784c8a0dcdc3a62$export$2e2bcd8739ae039 = (0, $2QLOh.default);

});
parcelRegister("2QLOh", function(module, exports) {

$parcel$export(module.exports, "default", () => $2135862dcf69f80e$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $gykb8 = parcelRequire("gykb8");

var $eUqFw = parcelRequire("eUqFw");

var $jwE5W = parcelRequire("jwE5W");

var $cSqFM = parcelRequire("cSqFM");

var $lHkHI = parcelRequire("lHkHI");
function $2135862dcf69f80e$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $2135862dcf69f80e$var$NoAppsContainer = (0, $3UXZ8.default)("div", {
    target: "e1bof78a0",
    label: "NoAppsContainer"
})({
    name: "1m2bp42",
    styles: "text-align:center;margin:auto;max-width:400px;padding-top:15px;"
});
const $2135862dcf69f80e$var$NoAppsImage = (0, $3UXZ8.default)("img", {
    target: "e1bof78a1",
    label: "NoAppsImage"
})({
    name: "1hbd3g7",
    styles: "height:250px;"
});
const $2135862dcf69f80e$var$NoAppsPrimaryLine = (0, $3UXZ8.default)("div", {
    target: "e1bof78a2",
    label: "NoAppsPrimaryLine"
})({
    name: "12p9jvg",
    styles: "font-size:110%;padding:15px 0;"
});
class $2135862dcf69f80e$var$NoApps extends (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).PureComponent {
    constructor(){
        super(...arguments);
        (0, $5zQU9.default)(this, "goToDiscover", ()=>{
            this.props.history.push({
                pathname: this.props.emceeLinks.discoverHome.getRelative()
            });
        });
    }
    render() {
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($2135862dcf69f80e$var$NoAppsContainer, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($2135862dcf69f80e$var$NoAppsImage, {
                    alt: "no apps",
                    draggable: false,
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($cSqFM)))
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)($2135862dcf69f80e$var$NoAppsPrimaryLine, {
                    children: "Connect all the pieces"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                    children: [
                        "Add your team's apps to keep work moving or just make it a little more fun!",
                        ' ',
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                            onClick: this.goToDiscover,
                            children: "Marketplace apps"
                        })
                    ]
                })
            ]
        });
    }
}
var $2135862dcf69f80e$export$2e2bcd8739ae039 = (0, $jwE5W.withEmceeLinks)($2135862dcf69f80e$var$NoApps);

});
parcelRegister("cSqFM", function(module, exports) {
module.exports = new URL("integration-puzzle.9fe08f02.svg", import.meta.url).toString();

});







parcelRegister("4mQRQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $32e239dc6670dbf3$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $15t1P = parcelRequire("15t1P");

var $ivTMz = parcelRequire("ivTMz");

var $j0gMm = parcelRequire("j0gMm");

var $hvUUg = parcelRequire("hvUUg");
var $8gcXz = parcelRequire("8gcXz");
var $kU8RF = parcelRequire("kU8RF");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $inwKI = parcelRequire("inwKI");

var $eEKFN = parcelRequire("eEKFN");

var $cVLrH = parcelRequire("cVLrH");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $jwE5W = parcelRequire("jwE5W");

var $cUrdu = parcelRequire("cUrdu");

var $287P0 = parcelRequire("287P0");

var $hHzyI = parcelRequire("hHzyI");

var $lHkHI = parcelRequire("lHkHI");
function $32e239dc6670dbf3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $32e239dc6670dbf3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $32e239dc6670dbf3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $32e239dc6670dbf3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $32e239dc6670dbf3$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $32e239dc6670dbf3$export$6e2c8f0811a474ce = (0, $3UXZ8.default)("section", {
    target: "eerked60",
    label: "Section"
})({
    name: "gg4vpm",
    styles: "display:flex;justify-content:space-between;"
});
const $32e239dc6670dbf3$export$b2e8c83a20ef76d8 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $9oiuL.default), {
    target: "eerked61",
    label: "ApplyPromotionsBtn"
})({
    name: "46b038",
    styles: "margin-top:30px;"
});
const $32e239dc6670dbf3$export$48664059f755e770 = (0, $3UXZ8.default)("div", {
    target: "eerked62",
    label: "Documentation"
})("background-color:", "var(--ds-background-neutral, ".concat((0, $j0gMm.N20), ")"), ";padding:var(--ds-space-200, 16px);margin-top:var(--ds-space-300, 24px);border-radius:", (0, $ivTMz.borderRadius)(), "px;min-width:278px;visibility:hidden;");
const $32e239dc6670dbf3$export$6cbdc4d25d2f5b34 = (0, $3UXZ8.default)("div", {
    target: "eerked63",
    label: "AppliedPromotionsWrapper"
})({
    name: "1esrqbb",
    styles: "min-width:612px;"
});
const $32e239dc6670dbf3$export$a8a3e93435678ff9 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $8gcXz.H3), {
    target: "eerked64",
    label: "Heading"
})({
    name: "e2bj0c",
    styles: "margin-bottom:var(--ds-space-200, 16px);"
});
const $32e239dc6670dbf3$var$RedirectToBACView = ()=>{
    const primaryAction = /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
        appearance: "link",
        href: "https://billing-and-subscriptions.atlassian.net/wiki/spaces/NBASMC/pages/15663105/Apply+a+promo+code",
        children: "Learn how to redeem a promo code"
    });
    const EmptyStateprops = {
        header: 'Promo code redemption has a new home!',
        description: "We have streamlined all admin functions related to promo code redemption to Administration. You can now redeem a promo code from the billing section in Administration.",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hHzyI))),
        primaryAction: primaryAction
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)($32e239dc6670dbf3$export$6e2c8f0811a474ce, {
        children: /*#__PURE__*/ (0, $lHkHI.jsxs)($32e239dc6670dbf3$export$6cbdc4d25d2f5b34, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)($32e239dc6670dbf3$export$a8a3e93435678ff9, {
                    children: "Promotions"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $15t1P.default), $32e239dc6670dbf3$var$_objectSpread({}, EmptyStateprops))
            ]
        })
    });
};
const $32e239dc6670dbf3$var$ManagePromotions = (props)=>{
    const [newPromotionRedeemedName, setNewPromotionRedeemedName] = (0, $eUqFw.useState)('');
    const [isApplyPromotionModalOpen, setApplyPromotionModalOpenFlag] = (0, $eUqFw.useState)(false);
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const { managePromotions: managePromotions } = (0, $jwE5W.default)();
    const { enableBacRedirectionForCcpPromotions: enableBacRedirectionForCcpPromotions } = (0, $inwKI.useFeatureFlags)();
    const toggleApplyPromotionModal = (promotionName)=>{
        if (!isApplyPromotionModalOpen) fireAnalyticsEvent({
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_APPLY_PROMOTION)
        });
        setApplyPromotionModalOpenFlag(!isApplyPromotionModalOpen);
        if (typeof promotionName === 'string') setNewPromotionRedeemedName(promotionName);
    };
    const onBreadcrumbsItemClick = (e)=>{
        e.preventDefault();
        props.history.push({
            pathname: managePromotions.getRelative()
        });
    };
    const { pending: pending, error: error, result: result } = props.hostPricing;
    if (pending) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kU8RF.default), {
        active: true,
        delay: 750
    });
    if (error) return /*#__PURE__*/ (0, $lHkHI.jsx)($32e239dc6670dbf3$export$6e2c8f0811a474ce, {
        children: "We ran into a little trouble. It might just be a hiccup. Try again in a bit."
    });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eEKFN.default), {
        actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_APP_PROMOTIONS),
        onClick: onBreadcrumbsItemClick,
        href: managePromotions.getRelative(),
        text: "Manage app promotions",
        children: enableBacRedirectionForCcpPromotions && (result === null || result === void 0 ? void 0 : result.billingSystem) === (0, $cVLrH.BillingSystem).CCP ? /*#__PURE__*/ (0, $lHkHI.jsx)($32e239dc6670dbf3$var$RedirectToBACView, {}) : /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsxs)($32e239dc6670dbf3$export$6e2c8f0811a474ce, {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsxs)($32e239dc6670dbf3$export$6cbdc4d25d2f5b34, {
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)($32e239dc6670dbf3$export$a8a3e93435678ff9, {
                                    children: "Promotions"
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                                    children: "Get discounts for installed apps by using promotion codes."
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $cUrdu.default), {
                                    productName: props.productName,
                                    cloudId: props.cloudId,
                                    toggleApplyPromotionModal: toggleApplyPromotionModal,
                                    appIcon: props.links.appIcon,
                                    newPromotionRedeemedName: newPromotionRedeemedName
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)($32e239dc6670dbf3$export$b2e8c83a20ef76d8, {
                                    appearance: "primary",
                                    onClick: toggleApplyPromotionModal,
                                    children: "Apply promotion code"
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsxs)($32e239dc6670dbf3$export$48664059f755e770, {
                                    children: [
                                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $hvUUg.BoldText), {
                                            children: "Need help with Promotions?"
                                        }),
                                        /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                                            children: "FAQ"
                                        }),
                                        /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                                            children: "Documentation"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                isApplyPromotionModalOpen && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $287P0.default), {
                    productName: props.productName,
                    cloudId: props.cloudId,
                    onCloseModal: toggleApplyPromotionModal,
                    appIcon: props.links.appIcon
                })
            ]
        })
    });
};
var $32e239dc6670dbf3$export$2e2bcd8739ae039 = $32e239dc6670dbf3$var$ManagePromotions;

});
parcelRegister("cUrdu", function(module, exports) {

$parcel$export(module.exports, "default", () => $965fd3ab210c7cf6$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");

var $kU8RF = parcelRequire("kU8RF");

var $eUqFw = parcelRequire("eUqFw");

var $eMTCG = parcelRequire("eMTCG");

var $eaLS7 = parcelRequire("eaLS7");

var $9k5Ky = parcelRequire("9k5Ky");

var $6MAoi = parcelRequire("6MAoi");

var $lHkHI = parcelRequire("lHkHI");
function $965fd3ab210c7cf6$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $965fd3ab210c7cf6$export$6e2c8f0811a474ce = (0, $3UXZ8.default)("section", {
    target: "etv16r20",
    label: "Section"
})({
    name: "1f2khbb",
    styles: "margin-top:var(--ds-space-500, 40px);"
});
const $965fd3ab210c7cf6$export$6ba7dff125b299e8 = (0, $3UXZ8.default)("div", {
    target: "etv16r21",
    label: "Promotions"
})("margin-top:var(--ds-space-250, 20px);background-color:", "var(--ds-background-neutral, ".concat((0, $j0gMm.N20), ")"), ";padding:var(--ds-space-200, 16px);");
const $965fd3ab210c7cf6$var$AppliedPromotions = (props)=>{
    const [filters, onChangeFilters] = (0, $eUqFw.useState)([]);
    const { appliedPromotions: appliedPromotions, pending: pending, error: error } = (0, $eaLS7.useAppliedPromotions)(props.productName, props.cloudId, props.newPromotionRedeemedName);
    if (pending) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kU8RF.default), {
        active: true,
        delay: 750
    });
    if (error) // TODO: Add the commonized error page
    return /*#__PURE__*/ (0, $lHkHI.jsx)($965fd3ab210c7cf6$export$6e2c8f0811a474ce, {
        children: "We ran into a little trouble. It might just be a hiccup. Try again in a bit."
    });
    if (appliedPromotions.length === 0) return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $6MAoi.default), {
        onApplyPromotionsBtnClick: props.toggleApplyPromotionModal
    });
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($965fd3ab210c7cf6$export$6e2c8f0811a474ce, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $eMTCG.default), {
                filters: filters,
                onChange: onChangeFilters
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($965fd3ab210c7cf6$export$6ba7dff125b299e8, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9k5Ky.default), {
                    appliedPromotions: appliedPromotions,
                    appIcon: props.appIcon,
                    filters: filters
                })
            })
        ]
    });
};
var $965fd3ab210c7cf6$export$2e2bcd8739ae039 = $965fd3ab210c7cf6$var$AppliedPromotions;

});
parcelRegister("eMTCG", function(module, exports) {

$parcel$export(module.exports, "AppliedPromotionsFiltersMap", () => $ac40b1eaeadc6351$export$f2a452042689023a);
$parcel$export(module.exports, "default", () => $ac40b1eaeadc6351$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $jbfSh = parcelRequire("jbfSh");

var $dzIcn = parcelRequire("dzIcn");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");
parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $dYvkz = parcelRequire("dYvkz");

var $lHkHI = parcelRequire("lHkHI");
function $ac40b1eaeadc6351$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $ac40b1eaeadc6351$var$Layout = (0, $3UXZ8.default)("div", {
    target: "e12qjmdq0",
    label: "Layout"
})({
    name: "1rl1xr4",
    styles: "display:flex;align-items:center;margin-bottom:var(--ds-space-300, 24px);"
});
const $ac40b1eaeadc6351$export$d8d76cebceb779d8 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $dzIcn.default), {
    target: "e12qjmdq1",
    label: "StatusDropdown"
})({
    name: "1hso954",
    styles: "width:100px;margin-right:13px;"
});
const $ac40b1eaeadc6351$export$f2a452042689023a = Object.freeze({
    STATUS: 'STATUS',
    BILLING_CYCLE: 'BILLING_CYCLE'
});
const $ac40b1eaeadc6351$var$AppliedPromotionsFilters = (_ref)=>{
    let { filters: filters, onChange: onChange } = _ref;
    const onChangeFilter = (type, value)=>{
        filters = filters.filter((item)=>item.type !== type);
        if (value) filters = [
            ...filters,
            {
                type: type,
                value: value
            }
        ];
        onChange(filters);
        handleAnalyticsEvent({
            filterType: type,
            filterValue: value
        });
    };
    const statusOptions = [
        {
            label: 'ALL',
            value: ''
        },
        {
            label: 'Active',
            value: (0, $dYvkz.AppliedPromotionStatus).ACTIVE
        },
        {
            label: 'Inactive',
            value: (0, $dYvkz.AppliedPromotionStatus).INACTIVE
        }
    ];
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const handleAnalyticsEvent = (attributes)=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.FilterClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_MANAGE_APP_PROMOTIONS_FILTER),
            attributes: attributes
        });
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($ac40b1eaeadc6351$var$Layout, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($ac40b1eaeadc6351$export$d8d76cebceb779d8, {
                defaultValue: statusOptions[0],
                onChange: (e)=>onChangeFilter($ac40b1eaeadc6351$export$f2a452042689023a.STATUS, e.value),
                options: statusOptions
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jbfSh.default), {
                label: "Valid for next billing cycle",
                onChange: (e)=>onChangeFilter($ac40b1eaeadc6351$export$f2a452042689023a.BILLING_CYCLE, e.target.checked)
            })
        ]
    });
};
var $ac40b1eaeadc6351$export$2e2bcd8739ae039 = $ac40b1eaeadc6351$var$AppliedPromotionsFilters;

});
parcelRegister("dYvkz", function(module, exports) {

$parcel$export(module.exports, "ValidateErrorCode", () => $a2c92e9576fa76f3$export$cab5ff5234380ec3);
$parcel$export(module.exports, "AppliedPromotionStatus", () => $a2c92e9576fa76f3$export$a03883bf05aebf69);
$parcel$export(module.exports, "ValidationResult", () => $a2c92e9576fa76f3$export$f9bf9a3c544b4010);
$parcel$export(module.exports, "disableReasonCodeMap", () => $a2c92e9576fa76f3$export$b99da47fd4b305b8);
const $a2c92e9576fa76f3$export$1783f060ab27316b = Object.freeze({
    APP_NOT_ACTIVE: 'APP_NOT_ACTIVE',
    MISMATCHED_SUBSCRIPTION_TYPE: 'MISMATCHED_SUBSCRIPTION_TYPE'
});
const $a2c92e9576fa76f3$export$cab5ff5234380ec3 = Object.freeze({
    INVALID_PROMO_CODE: 'INVALID_PROMO_CODE',
    PROMO_EXPIRED: 'PROMO_EXPIRED',
    MISSING_APPS: 'MISSING_APPS',
    INVALID_SUBSCRIPTION_TYPE: 'INVALID_SUBSCRIPTION_TYPE',
    EXHAUSTED_USES: 'EXHAUSTED_USES',
    PROMO_ACTIVE: 'PROMO_ACTIVE',
    PROMO_NOT_STARTED: 'PROMO_NOT_STARTED',
    PROMO_ENDED: 'PROMO_ENDED',
    USED_PROMO: 'USED_PROMO',
    INVALID_CLOUD_ID: 'INVALID_CLOUD_ID',
    INVALID_HOSTING_TYPE: 'INVALID_HOSTING_TYPE'
});
const $a2c92e9576fa76f3$export$a03883bf05aebf69 = Object.freeze({
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE'
});
const $a2c92e9576fa76f3$export$f9bf9a3c544b4010 = Object.freeze({
    FAILURE: 'FAILURE',
    SUCCESS: 'SUCCESS'
});
const $a2c92e9576fa76f3$export$b99da47fd4b305b8 = {
    [$a2c92e9576fa76f3$export$1783f060ab27316b.MISMATCHED_SUBSCRIPTION_TYPE]: 'due to change in billing cycle',
    [$a2c92e9576fa76f3$export$1783f060ab27316b.APP_NOT_ACTIVE]: 'since one of the eligible app is uninstalled'
};

});


parcelRegister("eaLS7", function(module, exports) {

$parcel$export(module.exports, "useAppliedPromotions", () => $a517223afb884a02$export$f077cc3e9aefdb01);

var $9c9Gu = parcelRequire("9c9Gu");
var $bTrQR = parcelRequire("bTrQR");

var $9I68n = parcelRequire("9I68n");
const $a517223afb884a02$export$f077cc3e9aefdb01 = (productName, cloudId, newPromotionRedeemedName)=>{
    const { result: result, error: error, pending: pending } = (0, $9c9Gu).usePromise(()=>(0, $9I68n.getAppliedPromotions)(productName, cloudId), [
        newPromotionRedeemedName
    ]);
    if (error) (0, $bTrQR.default).error('PromotionsList/hooks', "Failed to retrieve Promotions List", {
        error: error
    });
    return {
        pending: pending,
        error: error,
        appliedPromotions: result || []
    };
};

});
parcelRegister("9I68n", function(module, exports) {

$parcel$export(module.exports, "validatePromoCode", () => $711cfb3e78eadb33$export$31b9840c58db81e1);
$parcel$export(module.exports, "redeemPromoCode", () => $711cfb3e78eadb33$export$1adc54e7cdfb0cb8);
$parcel$export(module.exports, "getAppliedPromotions", () => $711cfb3e78eadb33$export$62de3fe78f917010);

var $55gtq = parcelRequire("55gtq");
const $711cfb3e78eadb33$export$31b9840c58db81e1 = (promotionCode, cloudId)=>(0, $55gtq.default)().fetchOk("/catalog/promotions/code/".concat(promotionCode, "/validate/").concat(cloudId));
const $711cfb3e78eadb33$export$1adc54e7cdfb0cb8 = (promotionCode, cloudId)=>(0, $55gtq.default)().fetchOk("/catalog/promotions/code/".concat(promotionCode, "/redeem/").concat(cloudId), {
        method: 'POST'
    });
const $711cfb3e78eadb33$export$62de3fe78f917010 = (productName, cloudId)=>(0, $55gtq.default)().fetchOk("/catalog/promotions/view?cloudId=".concat(cloudId, "&atlassianProductName=").concat(productName));

});


parcelRegister("9k5Ky", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c9a711b414be9e5$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");
parcelRequire("eUqFw");

var $dYvkz = parcelRequire("dYvkz");

var $9jRpr = parcelRequire("9jRpr");

var $bhteu = parcelRequire("bhteu");

var $lHkHI = parcelRequire("lHkHI");
const $6c9a711b414be9e5$export$8b251419efc915eb = (0, $3UXZ8.default)("p", {
    target: "e1jdnocu0",
    label: "Header"
})("text-transform:uppercase;margin-bottom:var(--ds-space-200, 16px);color:", "var(--ds-text, ".concat((0, $j0gMm.N300), ")"), ";font-size:12px;");
const $6c9a711b414be9e5$var$PromotionCardsList = (props)=>{
    const filteredPromotions = (0, $9jRpr.applyFilters)(props.appliedPromotions, props.filters);
    const activePromotions = filteredPromotions.filter((promotion)=>promotion.status === (0, $dYvkz.AppliedPromotionStatus).ACTIVE);
    const inactivePromotions = filteredPromotions.filter((promotion)=>promotion.status === (0, $dYvkz.AppliedPromotionStatus).INACTIVE);
    if (activePromotions.length + inactivePromotions.length === 0) return /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
        children: "No results found"
    });
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            activePromotions.length > 0 && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($6c9a711b414be9e5$export$8b251419efc915eb, {
                        children: "Active Promotions"
                    }),
                    activePromotions.map((promotion)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $bhteu.default), {
                            appliedPromotionDetails: promotion,
                            appIcon: props.appIcon
                        }, promotion.promotionId))
                ]
            }),
            inactivePromotions.length > 0 && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($6c9a711b414be9e5$export$8b251419efc915eb, {
                        children: "Inactive Promotions"
                    }),
                    inactivePromotions.map((promotion)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $bhteu.default), {
                            appliedPromotionDetails: promotion,
                            appIcon: props.appIcon
                        }, promotion.promotionId))
                ]
            })
        ]
    });
};
var $6c9a711b414be9e5$export$2e2bcd8739ae039 = $6c9a711b414be9e5$var$PromotionCardsList;

});
parcelRegister("9jRpr", function(module, exports) {

$parcel$export(module.exports, "applyFilters", () => $6c8f5168e2b0d747$export$47150c42ed89d097);

var $dYvkz = parcelRequire("dYvkz");

var $eMTCG = parcelRequire("eMTCG");
const $6c8f5168e2b0d747$var$applyBillingFilter = (promotions)=>promotions.filter((promotion)=>promotion.status === (0, $dYvkz.AppliedPromotionStatus).ACTIVE && promotion.totalBillingCycles - promotion.completedBillingCycles > 0);
const $6c8f5168e2b0d747$var$applyStatusFilter = (promotions, value)=>promotions.filter((promotion)=>promotion.status === value);
const $6c8f5168e2b0d747$export$47150c42ed89d097 = (promotions, filters)=>{
    if (filters.length === 0) return promotions;
    filters.forEach((filterBy)=>{
        if (filterBy.type === (0, $eMTCG.AppliedPromotionsFiltersMap).BILLING_CYCLE) promotions = $6c8f5168e2b0d747$var$applyBillingFilter(promotions);
        if (filterBy.type === (0, $eMTCG.AppliedPromotionsFiltersMap).STATUS) promotions = $6c8f5168e2b0d747$var$applyStatusFilter(promotions, filterBy.value);
    });
    return promotions;
};

});

parcelRegister("bhteu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8367f544af788b18$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $drftW = parcelRequire("drftW");

var $kXZN1 = parcelRequire("kXZN1");

var $j8E8v = parcelRequire("j8E8v");

var $j0gMm = parcelRequire("j0gMm");
var $62HOr = parcelRequire("62HOr");
var $62cXe = parcelRequire("62cXe");

var $hvUUg = parcelRequire("hvUUg");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $76fzC = parcelRequire("76fzC");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $dYvkz = parcelRequire("dYvkz");

var $4POl9 = parcelRequire("4POl9");

var $lHkHI = parcelRequire("lHkHI");
function $8367f544af788b18$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $8367f544af788b18$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $8367f544af788b18$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $8367f544af788b18$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $8367f544af788b18$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $8367f544af788b18$var$DetailsWrapper = (0, $3UXZ8.default)("div", {
    target: "ealardr0",
    label: "DetailsWrapper"
})({
    name: "gg4vpm",
    styles: "display:flex;justify-content:space-between;"
});
const $8367f544af788b18$var$Card = (0, $3UXZ8.default)("div", {
    target: "ealardr1",
    label: "Card"
})((0, $62HOr).e100, " border-radius:var(--ds-border-radius-100, 3px);padding:var(--ds-space-200, 16px);margin-bottom:var(--ds-space-200, 16px);background-color:", "var(--ds-surface, ".concat((0, $j0gMm).N0, ")"), ";");
const $8367f544af788b18$var$ContentWrapper = (0, $3UXZ8.default)("div", {
    target: "ealardr2",
    label: "ContentWrapper"
})({
    name: "1v7zxsc",
    styles: "margin-top:var(--ds-space-100, 8px);display:flex;"
});
const $8367f544af788b18$export$ed2f355b1f18fea8 = (0, $3UXZ8.default)("div", {
    target: "ealardr3",
    label: "InUseText"
})("color:", "var(--ds-text-subtlest, ".concat((0, $j0gMm).N100, ")"), ";");
const $8367f544af788b18$export$a8a3e93435678ff9 = (0, $3UXZ8.default)("p", {
    target: "ealardr4",
    label: "Heading"
})((props)=>props.mixin(), ";margin-top:0;");
const $8367f544af788b18$var$LastBilledText = (0, $3UXZ8.default)("p", {
    target: "ealardr5",
    label: "LastBilledText"
})({
    name: "9e9owo",
    styles: "font-size:11px;"
});
const $8367f544af788b18$export$5f734e3a73651e57 = (0, $3UXZ8.default)("div", {
    target: "ealardr6",
    label: "ButtonText"
})("margin:5px var(--ds-space-100, 8px) 5px var(--ds-space-200, 16px);color:", "var(--ds-text-subtlest, ".concat((0, $j0gMm).N100, ")"), ";");
const $8367f544af788b18$export$c13b3fa3cc30c63e = (0, $3UXZ8.default)("div", {
    target: "ealardr7",
    label: "EndingMessage"
})({
    name: "1c1dpee",
    styles: "display:flex;margin-top:14px;align-items:center;"
});
const $8367f544af788b18$var$LozengeWrapper = (0, $3UXZ8.default)("div", {
    target: "ealardr8",
    label: "LozengeWrapper"
})({
    name: "1ww2aq1",
    styles: "margin-right:var(--ds-space-100, 8px);"
});
const $8367f544af788b18$export$3d8562bfec40fcd5 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $hvUUg.BoldText), {
    target: "ealardr9",
    label: "BillingCyclesValue"
})({
    name: "z0txda",
    styles: "margin-left:var(--ds-space-050, 4px);"
});
const $8367f544af788b18$export$be4572fe9364214c = (0, $3UXZ8.default)("button", {
    target: "ealardr10",
    label: "AppsInPromotionWrapper"
})("display:flex;align-items:center;color:", "var(--ds-text-subtle, ".concat((0, $j0gMm).N200, ")"), ";cursor:pointer;margin-top:18px;background:none;border:none;");
const $8367f544af788b18$export$497c103e9d36d1e4 = (0, $3UXZ8.default)("div", {
    target: "ealardr11",
    label: "AppsInPromotion"
})({
    name: "lvyu5j",
    styles: "margin-right:10px;"
});
const $8367f544af788b18$var$PromotionBasicsDetails = (props)=>/*#__PURE__*/ (0, $lHkHI.jsxs)($8367f544af788b18$var$DetailsWrapper, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($8367f544af788b18$export$a8a3e93435678ff9, {
                        mixin: (0, $62cXe).h500,
                        children: props.promotionName
                    }),
                    props.status === (0, $dYvkz.AppliedPromotionStatus).ACTIVE ? /*#__PURE__*/ (0, $lHkHI.jsx)($8367f544af788b18$var$ContentWrapper, {
                        "data-testid": "redemptionDate",
                        children: props.trialEndDate ? /*#__PURE__*/ (0, $lHkHI.jsxs)($8367f544af788b18$export$ed2f355b1f18fea8, {
                            children: [
                                "Applied on ",
                                (0, $76fzC).longDate(props.redemptionDate)
                            ]
                        }) : /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)($8367f544af788b18$var$LozengeWrapper, {
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j8E8v.default), {
                                        appearance: "success",
                                        children: "Active"
                                    })
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsxs)($8367f544af788b18$export$ed2f355b1f18fea8, {
                                    children: [
                                        "In use from ",
                                        (0, $76fzC).longDate(props.redemptionDate)
                                    ]
                                })
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $lHkHI.jsx)($8367f544af788b18$var$ContentWrapper, {
                        "data-testid": "usedDates",
                        children: props.disabledReasonCode ? /*#__PURE__*/ (0, $lHkHI.jsxs)($8367f544af788b18$export$ed2f355b1f18fea8, {
                            children: [
                                "Applied on ",
                                (0, $76fzC).longDate(props.redemptionDate)
                            ]
                        }) : /*#__PURE__*/ (0, $lHkHI.jsxs)($8367f544af788b18$export$ed2f355b1f18fea8, {
                            children: [
                                "Used between ",
                                (0, $76fzC).longDate(props.redemptionDate),
                                " and",
                                ' ',
                                (0, $76fzC).longDate(props.expiryDate)
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($8367f544af788b18$export$a8a3e93435678ff9, {
                        mixin: (0, $62cXe).h500,
                        children: [
                            props.discountPercentage,
                            "% Discount"
                        ]
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($8367f544af788b18$var$ContentWrapper, {
                        "data-testid": "billingCycles",
                        children: [
                            "Billing cycles remaining:",
                            props.trialEndDate ? /*#__PURE__*/ (0, $lHkHI.jsx)($8367f544af788b18$export$3d8562bfec40fcd5, {
                                children: props.totalBillingCycles
                            }) : /*#__PURE__*/ (0, $lHkHI.jsxs)($8367f544af788b18$export$3d8562bfec40fcd5, {
                                children: [
                                    props.totalBillingCycles - props.completedBillingCycles,
                                    "/",
                                    props.totalBillingCycles
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
const $8367f544af788b18$export$7733b790a957e76b = (props)=>{
    const [showBundledApps, setShowBundledApps] = (0, $eUqFw.useState)(false);
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const onAppsInPromotionClick = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_TOGGLE_APPS_IN_PROMOTION),
            attributes: {
                showBundledApps: showBundledApps
            }
        });
        setShowBundledApps(!showBundledApps);
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            props.appliedPromotionDetails.trialEndDate ? /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                "data-testid": "trialEndDate",
                children: [
                    "Will be active after all app trial ends from",
                    ' ',
                    (0, $76fzC).longDate(props.appliedPromotionDetails.trialEndDate)
                ]
            }) : props.appliedPromotionDetails.lastBilledDate && /*#__PURE__*/ (0, $lHkHI.jsx)($8367f544af788b18$var$LastBilledText, {
                "data-testid": "lastDate",
                children: /*#__PURE__*/ (0, $lHkHI.jsxs)("b", {
                    children: [
                        "Last billed ",
                        (0, $76fzC).longDate(props.appliedPromotionDetails.lastBilledDate)
                    ]
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)($8367f544af788b18$export$be4572fe9364214c, {
                onClick: onAppsInPromotionClick,
                children: [
                    !showBundledApps && /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($kXZN1))), {
                        label: "Chevron right collapsed"
                    }),
                    showBundledApps && /*#__PURE__*/ (0, $lHkHI.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($drftW))), {
                        label: "Chevron down expanded"
                    }),
                    "Apps in this promotion"
                ]
            }),
            showBundledApps && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4POl9.default), {
                appIcon: props.appIcon,
                promoSubscriptionType: props.appliedPromotionDetails.promoSubscriptionType,
                promoDiscountPercentage: props.appliedPromotionDetails.discountPercentage,
                installedApps: props.appliedPromotionDetails.eligibleApps
            })
        ]
    });
};
const $8367f544af788b18$var$PromotionEndMessage = (props)=>/*#__PURE__*/ (0, $lHkHI.jsx)($8367f544af788b18$export$c13b3fa3cc30c63e, {
        children: props.disabledReasonCode ? /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
            children: [
                "Ended on ",
                (0, $76fzC).longDate(props.expiryDate),
                ' ',
                props.disabledReasonCode && (0, $dYvkz.disableReasonCodeMap)[props.disabledReasonCode]
            ]
        }) : /*#__PURE__*/ (0, $lHkHI.jsx)("div", {
            children: "Ended successfully"
        })
    });
function $8367f544af788b18$export$2e2bcd8739ae039(props) {
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($8367f544af788b18$var$Card, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($8367f544af788b18$var$PromotionBasicsDetails, {
                promotionName: props.appliedPromotionDetails.promotionName,
                discountPercentage: props.appliedPromotionDetails.discountPercentage,
                status: props.appliedPromotionDetails.status,
                totalBillingCycles: props.appliedPromotionDetails.totalBillingCycles,
                completedBillingCycles: props.appliedPromotionDetails.completedBillingCycles,
                redemptionDate: props.appliedPromotionDetails.redemptionDate,
                expiryDate: props.appliedPromotionDetails.expiryDate,
                trialEndDate: props.appliedPromotionDetails.trialEndDate,
                disabledReasonCode: props.appliedPromotionDetails.disabledReasonCode
            }),
            props.appliedPromotionDetails.status === (0, $dYvkz.AppliedPromotionStatus).ACTIVE ? /*#__PURE__*/ (0, $lHkHI.jsx)($8367f544af788b18$export$7733b790a957e76b, $8367f544af788b18$var$_objectSpread({}, props)) : /*#__PURE__*/ (0, $lHkHI.jsx)($8367f544af788b18$var$PromotionEndMessage, {
                expiryDate: props.appliedPromotionDetails.expiryDate,
                disabledReasonCode: props.appliedPromotionDetails.disabledReasonCode
            })
        ]
    });
}

});
parcelRegister("4POl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $3852f95750bacc36$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j8E8v = parcelRequire("j8E8v");

var $j0gMm = parcelRequire("j0gMm");

var $l2iVc = parcelRequire("l2iVc");

var $jmBhA = parcelRequire("jmBhA");

var $8U0Ec = parcelRequire("8U0Ec");

var $jdjb1 = parcelRequire("jdjb1");
parcelRequire("eUqFw");

var $lHkHI = parcelRequire("lHkHI");
function $3852f95750bacc36$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $3852f95750bacc36$export$8ca51d1b2ee047ce = (0, $3UXZ8.default)("li", {
    target: "e1hjvijr0",
    label: "AppsList"
})({
    name: "1496fpj",
    styles: "margin-bottom:22px;&:last-of-type{margin-bottom:0;}"
});
const $3852f95750bacc36$export$86fbec116b87613f = (0, $3UXZ8.default)("div", {
    target: "e1hjvijr1",
    label: "App"
})({
    name: "70qvj9",
    styles: "display:flex;align-items:center;"
});
const $3852f95750bacc36$export$ad632fed13b68969 = (0, $3UXZ8.default)("div", {
    target: "e1hjvijr2",
    label: "AppDetails"
})({
    name: "1cyiv6",
    styles: "display:flex;flex-direction:column;width:440px;"
});
const $3852f95750bacc36$export$be7cb2ddae9a2e8d = (0, $3UXZ8.default)("div", {
    target: "e1hjvijr3",
    label: "AppIconContainer"
})({
    name: "1gnf8un",
    styles: "height:32px;width:32px;margin-right:14px;"
});
const $3852f95750bacc36$export$5153830bdfb71453 = (0, $3UXZ8.default)("img", {
    target: "e1hjvijr4",
    label: "AppIcon"
})({
    name: "v2kfba",
    styles: "height:100%;width:100%;"
});
const $3852f95750bacc36$export$e3fa2c64115299cc = (0, $3UXZ8.default)("div", {
    target: "e1hjvijr5",
    label: "AppName"
})((0, $jdjb1.ellipsis), " margin-bottom:var(--ds-space-025, 2px);");
const $3852f95750bacc36$export$a944f81681c0f282 = (0, $3UXZ8.default)("div", {
    target: "e1hjvijr6",
    label: "AppPricing"
})({
    name: "70qvj9",
    styles: "display:flex;align-items:center;"
});
const $3852f95750bacc36$export$3b0a315d38f23755 = (0, $3UXZ8.default)("del", {
    target: "e1hjvijr7",
    label: "OldPrice"
})("color:", "var(--ds-text-subtlest, ".concat((0, $j0gMm.N200), ")"), ";");
const $3852f95750bacc36$export$d1efad70098794d = (0, $3UXZ8.default)("b", {
    target: "e1hjvijr8",
    label: "PriceSaveMessage"
})("color:", "var(--ds-text-accent-green, ".concat((0, $j0gMm.G400), ")"), ";margin:0;font-size:11px;margin-left:var(--ds-space-300, 24px);");
const $3852f95750bacc36$export$54c2e3dc7acea9f5 = (0, $3UXZ8.default)("ul", {
    target: "e1hjvijr9",
    label: "List"
})({
    name: "1lwrckp",
    styles: "list-style:none;padding:0;"
});
const $3852f95750bacc36$export$69f5b7c221a8c1ce = (0, $3UXZ8.default)("div", {
    target: "e1hjvijr10",
    label: "StyledLozengeWrapper"
})({
    name: "tlcjsa",
    styles: "margin-left:50px;"
});
const $3852f95750bacc36$export$30fcf6671ea42637 = (0, $3UXZ8.default)("p", {
    target: "e1hjvijr11",
    label: "AppDiscount"
})({
    name: "1ww2aq1",
    styles: "margin-right:var(--ds-space-100, 8px);"
});
const $3852f95750bacc36$export$17d680238e50603e = (0, $3UXZ8.default)("hr", {
    target: "e1hjvijr12",
    label: "Line"
})("margin-top:var(--ds-space-200, 16px);margin-bottom:18px;border:1px solid ", "var(--ds-border, ".concat((0, $j0gMm.N50), ")"), ";");
const $3852f95750bacc36$export$f092418aab543e8d = {
    [(0, $l2iVc.SubscriptionType).MONTHLY]: 'MONTHLY',
    [(0, $l2iVc.SubscriptionType).ANNUAL]: 'ANNUALLY'
};
const $3852f95750bacc36$export$28602c2ac5f515df = {
    [(0, $l2iVc.SubscriptionType).MONTHLY]: 'month',
    [(0, $l2iVc.SubscriptionType).ANNUAL]: 'year'
};
const $3852f95750bacc36$export$8bc74549b2705d25 = (app, promoSubscriptionType)=>{
    return app.listPrice > app.discountAmount ? /*#__PURE__*/ (0, $lHkHI.jsxs)($3852f95750bacc36$export$a944f81681c0f282, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsxs)($3852f95750bacc36$export$30fcf6671ea42637, {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)($3852f95750bacc36$export$3b0a315d38f23755, {
                        children: (0, $jmBhA.formatPrice)(app.listPrice, app.currency)
                    }),
                    ' ',
                    (0, $jmBhA.formatPrice)(app.listPrice - app.discountAmount, app.currency),
                    " per",
                    ' ',
                    $3852f95750bacc36$export$28602c2ac5f515df[promoSubscriptionType]
                ]
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)($3852f95750bacc36$export$d1efad70098794d, {
                children: [
                    "SAVE ",
                    (0, $jmBhA.formatPrice)(app.discountAmount, app.currency),
                    ' ',
                    $3852f95750bacc36$export$f092418aab543e8d[promoSubscriptionType]
                ]
            })
        ]
    }) : /*#__PURE__*/ (0, $lHkHI.jsxs)($3852f95750bacc36$export$a944f81681c0f282, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($3852f95750bacc36$export$30fcf6671ea42637, {
                children: /*#__PURE__*/ (0, $lHkHI.jsx)($3852f95750bacc36$export$3b0a315d38f23755, {
                    children: (0, $jmBhA.formatPrice)(app.listPrice, app.currency)
                })
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($3852f95750bacc36$export$d1efad70098794d, {
                children: "FREE"
            })
        ]
    });
};
const $3852f95750bacc36$var$PromotionBundledApps = (props)=>{
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($3852f95750bacc36$export$17d680238e50603e, {}),
            /*#__PURE__*/ (0, $lHkHI.jsx)($3852f95750bacc36$export$54c2e3dc7acea9f5, {
                children: props.installedApps.map((app)=>/*#__PURE__*/ (0, $lHkHI.jsx)($3852f95750bacc36$export$8ca51d1b2ee047ce, {
                        children: /*#__PURE__*/ (0, $lHkHI.jsxs)($3852f95750bacc36$export$86fbec116b87613f, {
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)($3852f95750bacc36$export$be7cb2ddae9a2e8d, {
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $8U0Ec.default), {
                                        children: /*#__PURE__*/ (0, $lHkHI.jsx)($3852f95750bacc36$export$5153830bdfb71453, {
                                            alt: "".concat(app.appName, " app logo"),
                                            src: props.appIcon.expand({
                                                appKey: app.appKey
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsxs)($3852f95750bacc36$export$ad632fed13b68969, {
                                    children: [
                                        /*#__PURE__*/ (0, $lHkHI.jsx)($3852f95750bacc36$export$e3fa2c64115299cc, {
                                            children: app.appName
                                        }),
                                        $3852f95750bacc36$export$8bc74549b2705d25(app, props.promoSubscriptionType)
                                    ]
                                }),
                                app.isEvaluation && /*#__PURE__*/ (0, $lHkHI.jsx)($3852f95750bacc36$export$69f5b7c221a8c1ce, {
                                    children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $j8E8v.default), {
                                        appearance: "inprogress",
                                        children: "In Trial"
                                    })
                                })
                            ]
                        })
                    }, app.appName))
            })
        ]
    });
};
var $3852f95750bacc36$export$2e2bcd8739ae039 = $3852f95750bacc36$var$PromotionBundledApps;

});
parcelRegister("l2iVc", function(module, exports) {

$parcel$export(module.exports, "SubscriptionType", () => $f508764e44de45a7$export$60341e7d25c98210);
const $f508764e44de45a7$export$87648a698dd35629 = Object.freeze({
    ACTIVE: 'ACTIVE',
    EXPIRED: 'EXPIRED',
    ENDED_EARLY: 'ENDED_EARLY'
});
const $f508764e44de45a7$export$66f6714c2dd417b7 = Object.freeze({
    SINGLE_USE_PROMOTION: 'SINGLE_USE_PROMOTION',
    SHARED_PROMOTION: 'SHARED_PROMOTION'
});
const $f508764e44de45a7$export$c20edc3521983dfc = Object.freeze({
    FLAT_DISCOUNT: 'FLAT_DISCOUNT',
    TIERED_DISCOUNT: 'TIERED_DISCOUNT'
});
const $f508764e44de45a7$export$60341e7d25c98210 = Object.freeze({
    MONTHLY: 'MONTHLY',
    ANNUAL: 'ANNUAL'
});
const $f508764e44de45a7$export$b4c7d647f8c39cc4 = Object.freeze({
    CREATION_DATE: 'creationDate',
    START_DATE: 'startDate',
    EXPIRATION_DATE: 'endDate'
});

});

parcelRegister("jmBhA", function(module, exports) {

$parcel$export(module.exports, "formatPrice", () => $e18cfdf165d7b480$export$c86caf1be068fb8d);
const $e18cfdf165d7b480$export$5f357db3d940e166 = Object.freeze({
    USD: 'USD',
    JPY: 'JPY'
});
const $e18cfdf165d7b480$export$e5dcecbf3c8fc59c = Object.freeze({
    USD: 'en-us',
    JPY: 'ja-jp'
});
const $e18cfdf165d7b480$export$c86caf1be068fb8d = (amount, currencyCode)=>{
    const currencyDisplayFormat = currencyCode === 'USD' ? 'code' : 'symbol';
    return amount.toLocaleString($e18cfdf165d7b480$export$e5dcecbf3c8fc59c[currencyCode], {
        style: 'currency',
        currency: $e18cfdf165d7b480$export$5f357db3d940e166[currencyCode],
        currencyDisplay: currencyDisplayFormat
    });
};

});




parcelRegister("6MAoi", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f037441e0ebb9b3$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $9oiuL = parcelRequire("9oiuL");

var $15t1P = parcelRequire("15t1P");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");
parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $hHzyI = parcelRequire("hHzyI");

var $lHkHI = parcelRequire("lHkHI");
function $4f037441e0ebb9b3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $4f037441e0ebb9b3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $4f037441e0ebb9b3$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $4f037441e0ebb9b3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $4f037441e0ebb9b3$var$PromotionsEmptyView = (props)=>{
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const onPrimaryActionClick = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_EMPTY_VIEW_APPLY_PROMOTION)
        });
        props.onApplyPromotionsBtnClick();
    };
    const primaryAction = /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
        appearance: "primary",
        onClick: onPrimaryActionClick,
        children: "Apply promotion codes"
    });
    const EmptyStateprops = {
        header: 'No promotions applied yet',
        description: "Got a promotion code from a Marketplace partner? Apply it here to get discounts on installed apps.",
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($hHzyI))),
        primaryAction: primaryAction
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $15t1P.default), $4f037441e0ebb9b3$var$_objectSpread({}, EmptyStateprops));
};
var $4f037441e0ebb9b3$export$2e2bcd8739ae039 = $4f037441e0ebb9b3$var$PromotionsEmptyView;

});
parcelRegister("hHzyI", function(module, exports) {
module.exports = new URL("promotions-empty-view.d8dca90e.svg", import.meta.url).toString();

});



parcelRegister("287P0", function(module, exports) {

$parcel$export(module.exports, "default", () => $18d26557dc27c79a$export$2e2bcd8739ae039);

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");

var $eUqFw = parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $gIQkA = parcelRequire("gIQkA");

var $3kdNe = parcelRequire("3kdNe");

var $kJWRn = parcelRequire("kJWRn");

var $9zwUk = parcelRequire("9zwUk");

var $lHkHI = parcelRequire("lHkHI");
const $18d26557dc27c79a$var$ApplyPromotionModal = (props)=>{
    const [appliedPromotionDetails, setAppliedPromotionDetails] = (0, $eUqFw.useState)();
    const onAppliedPromotionDetails = (details)=>{
        setAppliedPromotionDetails(details);
    };
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const onCloseModal = ()=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.ButtonClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_CANCEL_APPLY_PROMOTION_MODAL)
        });
        props.onCloseModal();
    };
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $3kdNe.default), {
        width: "large",
        analyticsName: (0, $gIQkA.ANALYTICS_MODAL_APPLY_PROMOTIONS),
        heading: appliedPromotionDetails ? 'Promotion Applied Successfully' : 'Apply Promotion Code',
        onClose: onCloseModal,
        children: appliedPromotionDetails ? /*#__PURE__*/ (0, $lHkHI.jsx)((0, $kJWRn.default), {
            appliedPromotionDetails: appliedPromotionDetails,
            onCloseModal: (promotionName)=>props.onCloseModal(promotionName)
        }) : /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9zwUk.default), {
            onAppliedPromotionDetails: onAppliedPromotionDetails,
            productName: props.productName,
            cloudId: props.cloudId,
            onCloseModal: onCloseModal,
            appIcon: props.appIcon
        })
    });
};
var $18d26557dc27c79a$export$2e2bcd8739ae039 = $18d26557dc27c79a$var$ApplyPromotionModal;

});
parcelRegister("kJWRn", function(module, exports) {

$parcel$export(module.exports, "default", () => $f195aaf5b7ce71ff$export$2e2bcd8739ae039);

var $3UXZ8 = parcelRequire("3UXZ8");

var $j0gMm = parcelRequire("j0gMm");
parcelRequire("eUqFw");

var $9zwUk = parcelRequire("9zwUk");

var $hSV2X = parcelRequire("hSV2X");

var $lHkHI = parcelRequire("lHkHI");
function $f195aaf5b7ce71ff$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $f195aaf5b7ce71ff$export$154d21c28336e20d = (0, $3UXZ8.default)("div", {
    target: "ecmrlts0",
    label: "SuccessViewDiv"
})({
    name: "dvxtzn",
    styles: "display:flex;flex-direction:column;align-items:center;"
});
const $f195aaf5b7ce71ff$export$711aebb5ceb5cb9a = (0, $3UXZ8.default)("p", {
    target: "ecmrlts1",
    label: "GreenParagraph"
})("color:", "var(--ds-text-accent-green, ".concat((0, $j0gMm.G400), ")"), ";");
const $f195aaf5b7ce71ff$export$abaa98e58387a6d4 = (0, $3UXZ8.default)("span", {
    target: "ecmrlts2",
    label: "StyledGreenSpan"
})("color:", "var(--ds-text-accent-green, ".concat((0, $j0gMm.G400), ")"), ";font-size:11px;font-weight:bold;margin:0;");
const $f195aaf5b7ce71ff$var$ApplyPromotionSuccessView = (props)=>{
    const body = ()=>{
        return /*#__PURE__*/ (0, $lHkHI.jsxs)($f195aaf5b7ce71ff$export$154d21c28336e20d, {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)("img", {
                    alt: "shopping cart success",
                    src: (0, (/*@__PURE__*/$parcel$interopDefault($hSV2X)))
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                    children: [
                        props.appliedPromotionDetails.promotionName,
                        " successfully applied"
                    ]
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)($f195aaf5b7ce71ff$export$711aebb5ceb5cb9a, {
                    children: [
                        "You've saved",
                        ' ',
                        /*#__PURE__*/ (0, $lHkHI.jsxs)($f195aaf5b7ce71ff$export$abaa98e58387a6d4, {
                            children: [
                                props.appliedPromotionDetails.amountSaved,
                                " "
                            ]
                        }),
                        "for ",
                        props.appliedPromotionDetails.totalBillingCycles,
                        " billing",
                        ' ',
                        props.appliedPromotionDetails.totalBillingCycles > 1 ? 'cycles' : 'cycle'
                    ]
                })
            ]
        });
    };
    const footer = ()=>{
        return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9zwUk.Footer), {
            children: /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9zwUk.SubmitButton), {
                appearance: "primary",
                onClick: ()=>props.onCloseModal(props.appliedPromotionDetails.promotionName),
                children: "Done"
            })
        });
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            body(),
            footer()
        ]
    });
};
var $f195aaf5b7ce71ff$export$2e2bcd8739ae039 = $f195aaf5b7ce71ff$var$ApplyPromotionSuccessView;

});
parcelRegister("9zwUk", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $6f80e8ae8ec28bae$export$a06f1c675e846f6f);
$parcel$export(module.exports, "SubmitButton", () => $6f80e8ae8ec28bae$export$8b7b7cdfb85d78c5);
$parcel$export(module.exports, "default", () => $6f80e8ae8ec28bae$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $9oiuL = parcelRequire("9oiuL");

var $1Tfhj = parcelRequire("1Tfhj");

var $9osuT = parcelRequire("9osuT");

var $jmBhA = parcelRequire("jmBhA");

var $bTrQR = parcelRequire("bTrQR");

var $eUqFw = parcelRequire("eUqFw");
parcelRequire("jJs3W");
var $6N2vY = parcelRequire("6N2vY");

var $8bwkw = parcelRequire("8bwkw");

var $7Uh51 = parcelRequire("7Uh51");

var $jC5dB = parcelRequire("jC5dB");

var $9I68n = parcelRequire("9I68n");

var $dYvkz = parcelRequire("dYvkz");

var $1ad0x = parcelRequire("1ad0x");

var $lHkHI = parcelRequire("lHkHI");
function $6f80e8ae8ec28bae$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $6f80e8ae8ec28bae$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $6f80e8ae8ec28bae$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $6f80e8ae8ec28bae$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $6f80e8ae8ec28bae$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $6f80e8ae8ec28bae$export$fe33dccc027f2ed = (0, $3UXZ8.default)("div", {
    target: "e1f75etc0",
    label: "Styleddiv"
})({
    name: "1fyrh79",
    styles: "display:flex;align-items:center;margin-top:var(--ds-space-250, 20px);"
});
const $6f80e8ae8ec28bae$export$2d5d2ba3c7c8c40b = /*#__PURE__*/ (0, $3UXZ8.default)((0, $9oiuL.default), {
    target: "e1f75etc1",
    label: "StyledButton"
})({
    name: "ewzqda",
    styles: "margin-left:var(--ds-space-250, 20px);height:32px;width:67px;"
});
const $6f80e8ae8ec28bae$export$a06f1c675e846f6f = (0, $3UXZ8.default)("div", {
    target: "e1f75etc2",
    label: "Footer"
})({
    name: "a1l08t",
    styles: "text-align:right;margin:var(--ds-space-250, 20px) 0;"
});
const $6f80e8ae8ec28bae$export$8b7b7cdfb85d78c5 = /*#__PURE__*/ (0, $3UXZ8.default)((0, $9oiuL.default), {
    target: "e1f75etc3",
    label: "SubmitButton"
})({
    name: "1y6ic72",
    styles: "margin-left:10px;"
});
const $6f80e8ae8ec28bae$var$footer = (onCloseModal, handleRedeemPromoCode, disableSubmitButton)=>/*#__PURE__*/ (0, $lHkHI.jsxs)($6f80e8ae8ec28bae$export$a06f1c675e846f6f, {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $9oiuL.default), {
                testid: "partner-promotion-modal__cancel-button",
                appearance: "subtle",
                onClick: onCloseModal,
                children: "Cancel"
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)($6f80e8ae8ec28bae$export$8b7b7cdfb85d78c5, {
                isDisabled: disableSubmitButton,
                appearance: "primary",
                onClick: handleRedeemPromoCode,
                children: "Apply promotion code"
            })
        ]
    });
const $6f80e8ae8ec28bae$export$20ea8751c206b4f3 = (props)=>{
    const [promotionCode, setPromotionCode] = (0, $eUqFw.useState)('');
    const handlePromotionCodeChange = (_ref)=>{
        let { target: { value: value } } = _ref;
        setPromotionCode(value);
    };
    const [validation, setValidationStatus] = (0, $eUqFw.useState)({});
    const [savePricingClicked, toggleValidationInProgress] = (0, $eUqFw.useState)(false);
    const [disableSubmitButton, toggleSubmitButton] = (0, $eUqFw.useState)(true);
    const handleValidatePromoCode = async ()=>{
        var _validation$installed;
        toggleValidationInProgress(true);
        try {
            const response = await (0, $9I68n.validatePromoCode)(promotionCode.toUpperCase(), props.cloudId);
            setValidationStatus(response);
            if (response.validationResult === (0, $dYvkz.ValidationResult).SUCCESS) toggleSubmitButton(false);
        } catch (error) {
            setValidationStatus(error);
        }
        toggleValidationInProgress(false);
        handleAnalyticsEvent((0, $7Uh51.AppPromotionValidated), {
            totalBundledApps: (_validation$installed = validation.installedApps) === null || _validation$installed === void 0 ? void 0 : _validation$installed.length,
            result: validation.validationResult
        });
    };
    const handleRedeemPromoCode = async ()=>{
        try {
            const response = await (0, $9I68n.redeemPromoCode)(promotionCode.toUpperCase(), props.cloudId);
            let currencyCode = 'USD';
            if (response.validationResult === (0, $dYvkz.ValidationResult).SUCCESS) {
                var _response$installedAp;
                const getAmountSaved = (installedApps)=>installedApps.reduce((amount, app)=>{
                        currencyCode = app.currency;
                        return amount + app.discountAmount;
                    }, 0);
                props.onAppliedPromotionDetails({
                    totalBillingCycles: response.totalBillingCycles,
                    amountSaved: (0, $jmBhA.formatPrice)(response.installedApps && response.installedApps.length > 0 ? getAmountSaved(response.installedApps) : 0, currencyCode),
                    promoSubscriptionType: response.promoSubscriptionType,
                    promotionName: response.promotionName
                });
                handleAnalyticsEvent((0, $7Uh51.AppPromotionRedeemed), {
                    totalAppsBundled: (_response$installedAp = response.installedApps) === null || _response$installedAp === void 0 ? void 0 : _response$installedAp.length
                });
            }
        } catch (error) {
            fireAnalyticsEvent((0, $7Uh51.AppPromotionRedeemFailedEvent));
            props.addFlag($6f80e8ae8ec28bae$var$redeemFailedFlag());
            (0, $bTrQR.default).error('ManagePromotions', "Failed to redeem Promotion", {
                error: error
            });
        }
    };
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const handleAnalyticsEvent = function handleAnalyticsEvent(eventType) {
        let attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        fireAnalyticsEvent({
            eventType: eventType,
            attributes: $6f80e8ae8ec28bae$var$_objectSpread($6f80e8ae8ec28bae$var$_objectSpread({}, attributes), {}, {
                promotionCode: promotionCode
            })
        });
    };
    const body = ()=>{
        return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                    children: "Enter a promotion code to validate and apply to your installed applications"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $lHkHI.jsxs)($6f80e8ae8ec28bae$export$fe33dccc027f2ed, {
                            children: [
                                /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1Tfhj.default), {
                                    onChange: handlePromotionCodeChange,
                                    width: 200
                                }),
                                /*#__PURE__*/ (0, $lHkHI.jsx)($6f80e8ae8ec28bae$export$2d5d2ba3c7c8c40b, {
                                    testid: "partner-promotion-modal__validate-button",
                                    isLoading: savePricingClicked,
                                    onClick: promotionCode && handleValidatePromoCode,
                                    children: "Check"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $lHkHI.jsx)((0, $1ad0x.default), {
                            response: validation,
                            productName: props.productName,
                            appIcon: props.appIcon
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            body(),
            $6f80e8ae8ec28bae$var$footer(props.onCloseModal, handleRedeemPromoCode, disableSubmitButton)
        ]
    });
};
const $6f80e8ae8ec28bae$var$redeemFailedFlag = ()=>(0, $jC5dB.makeFlag)({
        autoDismiss: true,
        title: "Uh-oh! couldn't apply the promotion",
        description: (0, $jC5dB.makeFlagDescription)({
            primary: "We're running into some difficulties redeeming the promotion code right now. Try again after sometime."
        }),
        appearance: (0, $jC5dB.ERROR_APPEARANCE)
    });
function $6f80e8ae8ec28bae$export$2e2bcd8739ae039(props) {
    const dispatch = (0, $6N2vY.useDispatch)();
    return /*#__PURE__*/ (0, $lHkHI.jsx)($6f80e8ae8ec28bae$export$20ea8751c206b4f3, $6f80e8ae8ec28bae$var$_objectSpread($6f80e8ae8ec28bae$var$_objectSpread({}, props), {}, {
        addFlag: (flag)=>dispatch((0, $8bwkw.addFlag)({
                flag: flag
            }))
    }));
}

});
parcelRegister("1ad0x", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d90d0a86babf9a4$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $3UXZ8 = parcelRequire("3UXZ8");

var $jGAG9 = parcelRequire("jGAG9");

var $ilkNu = parcelRequire("ilkNu");

var $j0gMm = parcelRequire("j0gMm");

var $hvUUg = parcelRequire("hvUUg");
var $gykb8 = parcelRequire("gykb8");

var $gaiog = parcelRequire("gaiog");
var $9osuT = parcelRequire("9osuT");
parcelRequire("eUqFw");

var $7Uh51 = parcelRequire("7Uh51");

var $dYvkz = parcelRequire("dYvkz");

var $jwE5W = parcelRequire("jwE5W");

var $4POl9 = parcelRequire("4POl9");

var $lHkHI = parcelRequire("lHkHI");
function $0d90d0a86babf9a4$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $0d90d0a86babf9a4$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $0d90d0a86babf9a4$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $0d90d0a86babf9a4$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $0d90d0a86babf9a4$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $0d90d0a86babf9a4$export$3a537a9c7bb7a2df = /*#__PURE__*/ (0, $3UXZ8.default)((0, $hvUUg.BoldText), {
    target: "e1cus1to0",
    label: "PromotionName"
})({
    name: "9n3bbc",
    styles: "margin-left:3px;"
});
const $0d90d0a86babf9a4$export$caf7239c478a21db = (0, $3UXZ8.default)("div", {
    target: "e1cus1to1",
    label: "PromotionNameWrapper"
})({
    name: "1qpaaev",
    styles: "margin-top:var(--ds-space-200, 16px);"
});
const $0d90d0a86babf9a4$export$8fbe3c7d0ed2c683 = (0, $3UXZ8.default)("div", {
    target: "e1cus1to2",
    label: "HelperMessage"
})("background:", "var(--ds-background-neutral, ".concat((0, $j0gMm.N20), ")"), ";padding:var(--ds-space-200, 16px) var(--ds-space-300, 24px);margin-top:56px;font-size:11px;");
const $0d90d0a86babf9a4$export$8cf58230e4c14fb2 = (props)=>{
    const PercentageGlyph = ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)("svg", {
            width: "12",
            height: "12",
            viewBox: "0 0 12 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
                    fillRule: "evenodd",
                    clipRule: "evenodd",
                    d: "M7.71024 0.781025C7.62251 0.665404 7.46883 0.621616 7.33324 0.673604L6.30514 1.06777C6.11332 1.14131 5.9032 1.15271 5.70454 1.10034L4.50152 0.783249C4.3721 0.749137 4.23495 0.797423 4.15555 0.905055L3.46712 1.83827C3.3506 1.99622 3.1892 2.1155 3.00392 2.18062L1.79396 2.60585C1.66334 2.65176 1.57594 2.77501 1.57594 2.91332V4.20562C1.57594 4.38355 1.52734 4.5581 1.43537 4.71048L0.699512 5.92964C0.627403 6.04911 0.639407 6.20118 0.729369 6.30788L1.49876 7.22047C1.6474 7.39677 1.72891 7.61985 1.72891 7.85033V9.09967C1.72891 9.23461 1.81216 9.35561 1.93829 9.40396L3.00738 9.81384C3.19739 9.88669 3.35995 10.0169 3.47244 10.1863L4.14693 11.2022C4.22953 11.3266 4.3862 11.3791 4.52719 11.3295L5.66658 10.9291C5.87688 10.8552 6.10614 10.8552 6.31643 10.9291L7.45582 11.3295C7.59681 11.3791 7.75349 11.3266 7.83609 11.2022L8.50495 10.1948C8.62265 10.0175 8.79501 9.88341 8.9959 9.81281L10.1891 9.39348C10.3197 9.34757 10.4071 9.22432 10.4071 9.08601V7.80892C10.4071 7.61669 10.4638 7.42871 10.5702 7.2685L11.293 6.17981C11.3655 6.07063 11.3655 5.92871 11.293 5.81953L10.5548 4.70775C10.463 4.56935 10.4079 4.40984 10.3948 4.24429L10.2875 2.88721C10.2776 2.76199 10.1966 2.65358 10.0791 2.60857L8.9547 2.17746C8.78429 2.11213 8.63556 2.00051 8.5253 1.8552L7.71024 0.781025ZM7.09936 0.065008C7.50616 -0.0909549 7.96719 0.0404073 8.23038 0.387272L9.04544 1.46145C9.08219 1.50988 9.13177 1.54709 9.18858 1.56887L10.313 1.99997C10.6653 2.13502 10.9085 2.46022 10.9381 2.83591L11.0454 4.19298C11.0498 4.24817 11.0681 4.30133 11.0988 4.34747L11.8369 5.45924C12.0544 5.78679 12.0544 6.21255 11.8369 6.54009L11.1141 7.62878C11.0786 7.68219 11.0597 7.74484 11.0597 7.80892V9.08601C11.0597 9.50094 10.7975 9.8707 10.4057 10.0084L9.21252 10.4277C9.14555 10.4513 9.0881 10.496 9.04887 10.5551L8.38 11.5625C8.13219 11.9358 7.66218 12.0931 7.23921 11.9445L6.09982 11.544C6.02972 11.5194 5.9533 11.5194 5.8832 11.544L4.74381 11.9445C4.32084 12.0931 3.85083 11.9358 3.60301 11.5625L2.92852 10.5466C2.89103 10.4901 2.83684 10.4467 2.7735 10.4224L1.70442 10.0126C1.32602 9.86749 1.07626 9.50451 1.07626 9.09967V7.85033C1.07626 7.7735 1.04909 7.69915 0.999544 7.64038L0.230152 6.72779C-0.0397364 6.40767 -0.0757458 5.95148 0.140581 5.59307L0.876437 4.37391C0.907094 4.32311 0.923295 4.26493 0.923295 4.20562V2.91332C0.923295 2.49839 1.18547 2.12864 1.57734 1.99092L2.7873 1.56569C2.84906 1.54398 2.90286 1.50422 2.9417 1.45157L3.63013 0.518355C3.86833 0.19546 4.27979 0.0505994 4.66805 0.152938L5.87106 0.470032C5.93728 0.487486 6.00732 0.483687 6.07126 0.459174L7.09936 0.065008Z",
                    fill: "currentColor"
                }),
                /*#__PURE__*/ (0, $lHkHI.jsx)("path", {
                    d: "M4.20351 5.82851C4.96141 5.82851 5.40702 5.308 5.40702 4.41224C5.40702 3.53665 4.95088 3 4.20351 3C3.45965 3 3 3.54069 3 4.41224C3 5.30397 3.44562 5.82851 4.20351 5.82851ZM4.72281 8.93544L8.08772 3.11298H7.27719L3.91228 8.93544H4.72281ZM4.20351 5.12643C3.94737 5.12643 3.8 4.86819 3.8 4.41628C3.8 3.97646 3.95088 3.70612 4.20351 3.70612C4.45263 3.70612 4.60351 3.97646 4.60351 4.41628C4.60351 4.86416 4.45965 5.12643 4.20351 5.12643ZM7.79649 9C8.55439 9 9 8.47949 9 7.58373C9 6.70814 8.54386 6.17149 7.79649 6.17149C7.05263 6.17149 6.59299 6.71217 6.59299 7.58373C6.59299 8.47545 7.04211 9 7.79649 9ZM7.79649 8.29792C7.54035 8.29792 7.39649 8.03968 7.39649 7.58776C7.39649 7.14795 7.54386 6.87761 7.79649 6.87761C8.04912 6.87761 8.2 7.14795 8.2 7.58776C8.2 8.03564 8.05263 8.29792 7.79649 8.29792Z",
                    fill: "currentColor"
                })
            ]
        });
    return /*#__PURE__*/ (0, $lHkHI.jsx)((0, $ilkNu.Icon), $0d90d0a86babf9a4$var$_objectSpread({
        glyph: PercentageGlyph,
        primaryColor: "var(--ds-icon, #172B4D)"
    }, props));
};
const $0d90d0a86babf9a4$var$ActivePromotionExist = ()=>/*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jGAG9.ErrorMessage), {
                children: "This code is valid, but you cannot apply over an active promotion."
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                children: "Try again after the current active promotion ends."
            })
        ]
    });
const $0d90d0a86babf9a4$export$104c060a80e3a6e2 = (props)=>{
    const { appListing: appListing } = (0, $jwE5W.default)();
    const fireAnalyticsEvent = (0, $9osuT.useAnalyticsEvents)();
    const onMissingAppsClick = (appKey)=>{
        fireAnalyticsEvent({
            eventType: (0, $gaiog.LinkClickedEvent),
            actionSubjectId: (0, $7Uh51.ANALYTICS_SUBJECT_ID_MISSING_INSTALLED_APPS),
            attributes: {
                appKey: appKey
            }
        });
    };
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jGAG9.ErrorMessage), {
                children: "This code is valid, but you don\u2019t have the required app."
            }),
            /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                children: [
                    props.missingApps.map((app)=>/*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                            href: "".concat(appListing.getAbsolute({
                                appKey: app.appKey
                            }), "?source=promotions"),
                            target: "_blank",
                            onClick: ()=>onMissingAppsClick(app.appKey),
                            children: app.appName
                        }, app.appKey)).reduce((prev, curr)=>[
                            prev,
                            ', ',
                            curr
                        ]),
                    ' ',
                    "is missing. Try again after installing all required apps."
                ]
            })
        ]
    });
};
const $0d90d0a86babf9a4$export$a670cb14d2ec8c3 = ()=>/*#__PURE__*/ (0, $lHkHI.jsx)("p", {
        children: "Try again with a different code or contact partner support for more details."
    });
const $0d90d0a86babf9a4$export$db380d45c76ed106 = (_ref)=>{
    let { promotionName: promotionName } = _ref;
    return /*#__PURE__*/ (0, $lHkHI.jsxs)($0d90d0a86babf9a4$export$8fbe3c7d0ed2c683, {
        children: [
            "By Applying this promotion, you permit Atlassian to share anonymized data with paste clip for Confluence. You agree to Atlassian Marketplace's",
            ' ',
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                href: "/terms-of-use",
                target: "_blank",
                children: "terms of use"
            }),
            ' ',
            "and ",
            promotionName,
            "'s",
            ' ',
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                href: "/privacy-policy",
                target: "_blank",
                children: "privacy policy"
            }),
            ' ',
            "and",
            ' ',
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $gykb8.default), {
                href: "/terms-of-use",
                target: "_blank",
                children: "terms of use"
            })
        ]
    });
};
const $0d90d0a86babf9a4$var$ValidationMessages = (props)=>{
    return /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)($0d90d0a86babf9a4$export$5fd19fc2aa57453b, {
                response: props.response
            }),
            props.response.errorCode === (0, $dYvkz.ValidateErrorCode).PROMO_ACTIVE && $0d90d0a86babf9a4$var$ActivePromotionExist(),
            props.response.validationResult === (0, $dYvkz.ValidationResult).SUCCESS && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jGAG9.ValidMessage), {
                        children: "Valid Promotion Code"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)($0d90d0a86babf9a4$export$caf7239c478a21db, {
                        children: [
                            /*#__PURE__*/ (0, $lHkHI.jsx)($0d90d0a86babf9a4$export$8cf58230e4c14fb2, {
                                label: "percentage"
                            }),
                            ' ',
                            /*#__PURE__*/ (0, $lHkHI.jsx)($0d90d0a86babf9a4$export$3a537a9c7bb7a2df, {
                                children: props.response.promotionName
                            }),
                            " at",
                            ' ',
                            props.response.promoDiscountPercentage,
                            "% discount is available for following app"
                        ]
                    }),
                    props.response.installedApps && props.response.promoDiscountPercentage && /*#__PURE__*/ (0, $lHkHI.jsx)((0, $4POl9.default), {
                        promoSubscriptionType: props.response.promoSubscriptionType,
                        installedApps: props.response.installedApps,
                        appIcon: props.appIcon,
                        promoDiscountPercentage: props.response.promoDiscountPercentage
                    })
                ]
            }),
            props.response.errorCode === (0, $dYvkz.ValidateErrorCode).PROMO_EXPIRED && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jGAG9.ErrorMessage), {
                        children: "This promotion code has expired"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($0d90d0a86babf9a4$export$a670cb14d2ec8c3, {})
                ]
            }),
            props.response.errorCode === (0, $dYvkz.ValidateErrorCode).MISSING_APPS && props.response.missingApps && /*#__PURE__*/ (0, $lHkHI.jsx)($0d90d0a86babf9a4$export$104c060a80e3a6e2, {
                missingApps: props.response.missingApps
            }),
            props.response.errorCode === (0, $dYvkz.ValidateErrorCode).INVALID_SUBSCRIPTION_TYPE && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jGAG9.ErrorMessage), {
                        children: "This code is valid, but can\u2019t be applied to your site."
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsxs)("p", {
                        children: [
                            "This promotions is valid only for ",
                            props.productName,
                            " with",
                            ' ',
                            props.response.promoSubscriptionType,
                            " . Try again with a different code or contact partner support for more details."
                        ]
                    })
                ]
            }),
            props.response.errorCode === (0, $dYvkz.ValidateErrorCode).EXHAUSTED_USES && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jGAG9.ErrorMessage), {
                        children: "This promotion code has reached its usage limit"
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)($0d90d0a86babf9a4$export$a670cb14d2ec8c3, {})
                ]
            }),
            props.response.errorCode === (0, $dYvkz.ValidateErrorCode).PROMO_NOT_STARTED && /*#__PURE__*/ (0, $lHkHI.jsxs)((0, $lHkHI.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jGAG9.ErrorMessage), {
                        children: "This code is valid, but can\u2019t be applied yet."
                    }),
                    /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                        children: "Try again with a different code or contact partner support for more details."
                    })
                ]
            })
        ]
    });
};
const $0d90d0a86babf9a4$export$5fd19fc2aa57453b = (_ref2)=>{
    let { response: response } = _ref2;
    return (response.errorCode === (0, $dYvkz.ValidateErrorCode).INVALID_PROMO_CODE || response.errorCode === (0, $dYvkz.ValidateErrorCode).PROMO_ENDED || response.errorCode === (0, $dYvkz.ValidateErrorCode).USED_PROMO || response.errorCode === (0, $dYvkz.ValidateErrorCode).INVALID_HOSTING_TYPE) && /*#__PURE__*/ (0, $lHkHI.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $lHkHI.jsx)((0, $jGAG9.ErrorMessage), {
                children: "Invalid promotion code."
            }),
            /*#__PURE__*/ (0, $lHkHI.jsx)("p", {
                children: "This promotion is not a valid code. Try again with a different code or contact partner support for more details."
            })
        ]
    });
};
var $0d90d0a86babf9a4$export$2e2bcd8739ae039 = $0d90d0a86babf9a4$var$ValidationMessages;

});


parcelRegister("hSV2X", function(module, exports) {
module.exports = new URL("shopping_cart_success.e784a9e2.svg", import.meta.url).toString();

});







parcelRegister("jdziS", function(module, exports) {

$parcel$export(module.exports, "createReduxStore", () => $dfda9dc5dd378877$export$4fb431e0c06c30d1);

var $g5DHJ = parcelRequire("g5DHJ");

var $4QJdp = parcelRequire("4QJdp");

var $kJX7t = parcelRequire("kJX7t");

var $lgmMZ = parcelRequire("lgmMZ");
var $6iOIH = parcelRequire("6iOIH");

var $eYijg = parcelRequire("eYijg");

var $heESp = parcelRequire("heESp");
const $dfda9dc5dd378877$var$isDev = false;
const $dfda9dc5dd378877$export$4fb431e0c06c30d1 = ()=>{
    const middleware = [
        (0, $lgmMZ.default),
        (0, $6iOIH.default),
        (0, $kJX7t.default),
        (0, $eYijg.default)
    ];
    if ($dfda9dc5dd378877$var$isDev && window.__REDUX_DEVTOOLS_EXTENSION__) {
        const reduxDevtools = window.__REDUX_DEVTOOLS_EXTENSION__({
            serialize: {
                immutable: (0, $g5DHJ.default)
            }
        });
        return (0, $4QJdp.createStore)((0, $heESp.default), (0, $4QJdp.compose)((0, $4QJdp.applyMiddleware)(...middleware), reduxDevtools));
    } else return (0, $4QJdp.createStore)((0, $heESp.default), (0, $4QJdp.applyMiddleware)(...middleware));
};

});
parcelRegister("kJX7t", function(module, exports) {

$parcel$export(module.exports, "default", () => $f195de875366c1cf$export$2e2bcd8739ae039);
function $f195de875366c1cf$var$createThunkMiddleware(extraArgument) {
    return function(_ref) {
        var dispatch = _ref.dispatch, getState = _ref.getState;
        return function(next) {
            return function(action) {
                if (typeof action === 'function') return action(dispatch, getState, extraArgument);
                return next(action);
            };
        };
    };
}
var $f195de875366c1cf$var$thunk = $f195de875366c1cf$var$createThunkMiddleware();
$f195de875366c1cf$var$thunk.withExtraArgument = $f195de875366c1cf$var$createThunkMiddleware;
var $f195de875366c1cf$export$2e2bcd8739ae039 = $f195de875366c1cf$var$thunk;

});

parcelRegister("lgmMZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f7acc50b00ebab17$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $2vzCR = parcelRequire("2vzCR");

var $dNp25 = parcelRequire("dNp25");

var $c6kEN = parcelRequire("c6kEN");

var $iIG3b = parcelRequire("iIG3b");

var $a5uQr = parcelRequire("a5uQr");

var $cMIj9 = parcelRequire("cMIj9");

var $bPtM5 = parcelRequire("bPtM5");

var $efw6o = parcelRequire("efw6o");

var $5JCOp = parcelRequire("5JCOp");
function $f7acc50b00ebab17$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f7acc50b00ebab17$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f7acc50b00ebab17$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f7acc50b00ebab17$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f7acc50b00ebab17$var$isPageView = (action)=>action.type === (0, $c6kEN.ANALYTICS_SEND_PAGE_VIEW);
const $f7acc50b00ebab17$var$sendPageView = (_, __, store)=>{
    const state = store.getState();
    const currentScreen = state.analytics.modalStack.last() || state.analytics.currentScreen;
    const lastScreenEvent = state.analytics.lastScreenEvent;
    const analyticsAttributes = state.analytics.attributes;
    if (currentScreen && lastScreenEvent !== currentScreen) {
        const source = (0, $efw6o.getAnalyticsSourceParam)();
        const emceeVariant = (0, $bPtM5.isEmceeConnect)() ? (0, $iIG3b.EmceeVariant).Connect : (0, $iIG3b.EmceeVariant).Native;
        const featureFlags = state.configuration.featureFlags.fold(()=>{
        /* feature flags don't exist */ }, (featureFlagsRes)=>featureFlagsRes.fold(()=>{
            /* fetching feature flags had errors */ }, (ff)=>ff.getAllFlags().toJS()));
        const launchDarklyUserKey = (0, $a5uQr.selectLaunchDarklyUserKey)(state.configuration);
        (0, $cMIj9.getExtensionIDFromURL)((extensionID)=>{
            var _window, _document;
            const pageAttributes = (0, $efw6o.getPageAttributes)((_window = window) === null || _window === void 0 ? void 0 : _window.location.href, (_document = document) === null || _document === void 0 ? void 0 : _document.referrer);
            (0, $5JCOp.sendPageViewEvent)((0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))(currentScreen, {
                attributes: $f7acc50b00ebab17$var$_objectSpread($f7acc50b00ebab17$var$_objectSpread({}, (0, $efw6o.getAnalyticsRouteParams)(analyticsAttributes)), {}, {
                    featureFlags: featureFlags,
                    launchDarklyUserKey: launchDarklyUserKey,
                    source: source,
                    extensionID: extensionID,
                    emceeVariant: emceeVariant
                }, pageAttributes)
            }));
            store.dispatch({
                type: (0, $c6kEN.ANALYTICS_DONE_PAGE_VIEW),
                source: currentScreen
            });
        });
    }
};
const $f7acc50b00ebab17$var$screenViewMiddleware = (0, (/*@__PURE__*/$parcel$interopDefault($dNp25)))($f7acc50b00ebab17$var$isPageView, $f7acc50b00ebab17$var$sendPageView);
var $f7acc50b00ebab17$export$2e2bcd8739ae039 = $f7acc50b00ebab17$var$screenViewMiddleware;

});
parcelRegister("dNp25", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $a0b344e886b727e7$var$isFunction = function isFunction(x) {
    return typeof x === 'function';
};
module.exports.default = function(selector, callback) {
    return function(store) {
        return function(next) {
            return function(action) {
                var returnValue = next(action);
                if (!$a0b344e886b727e7$var$isFunction(selector)) return returnValue;
                var selected = selector(action);
                if (!selected) return returnValue;
                callback(selected, action, store);
                return returnValue;
            };
        };
    };
};
module.exports = module.exports['default'];

});


parcelRegister("6iOIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $496bc46eecb93df5$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $dNp25 = parcelRequire("dNp25");

var $iIG3b = parcelRequire("iIG3b");

var $bPtM5 = parcelRequire("bPtM5");

var $15DZ6 = parcelRequire("15DZ6");

var $7Uh51 = parcelRequire("7Uh51");

var $5JCOp = parcelRequire("5JCOp");

var $gJEvT = parcelRequire("gJEvT");

var $yNFJK = parcelRequire("yNFJK");

var $f1Ju8 = parcelRequire("f1Ju8");

var $gIsAL = parcelRequire("gIsAL");

var $7Fi5A = parcelRequire("7Fi5A");

var $cttF9 = parcelRequire("cttF9");
function $496bc46eecb93df5$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $496bc46eecb93df5$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $496bc46eecb93df5$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $496bc46eecb93df5$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $496bc46eecb93df5$var$ANALYTICS_MAPPERS = (0, $g5DHJ.List)([
    (0, $gJEvT.default),
    (0, $yNFJK.default),
    (0, $f1Ju8.default),
    (0, $gIsAL.default),
    (0, $7Fi5A.default),
    (0, $cttF9.default)
]);
function $496bc46eecb93df5$var$actionToAnalyticsPayloads(action) {
    return $496bc46eecb93df5$var$ANALYTICS_MAPPERS.map((fn)=>fn(action)).filter(Boolean); // Yes it's weird, but this gives us ?T => T
}
function $496bc46eecb93df5$var$sendTrackingEvents(payloads, action, store) {
    const state = store.getState();
    const currentScreen = (0, $bWAru.Option).of(state.analytics.modalStack.last()).getOrElse(state.analytics.currentScreen);
    payloads.map((p)=>{
        return {
            action: p.eventType.action,
            actionSubject: p.eventType.actionSubject,
            actionSubjectId: p.actionSubjectId,
            attributes: $496bc46eecb93df5$var$_objectSpread($496bc46eecb93df5$var$_objectSpread({}, p.attributes), {}, {
                source: (0, $15DZ6.getUrlParams)().source,
                emceeVariant: (0, $bPtM5.isEmceeConnect)() ? (0, $iIG3b.EmceeVariant).Connect : (0, $iIG3b.EmceeVariant).Native
            }),
            category: (0, $bWAru.Option).of(p.category).getOrElse((0, $7Uh51.ANALYTICS_CATEGORY_NAVIGATION)),
            containerId: p.containerId,
            containerType: p.containerType,
            objectId: p.objectId,
            objectType: p.objectType,
            source: currentScreen.name,
            tags: (0, $bWAru.Option).of(p.tags).getOrElse((0, $g5DHJ.Set)()).add('emcee').toArray()
        };
    }).forEach((p)=>(0, $5JCOp.sendEvent)(p));
}
const $496bc46eecb93df5$var$analyticsMiddleware = (0, (/*@__PURE__*/$parcel$interopDefault($dNp25)))((action)=>$496bc46eecb93df5$var$actionToAnalyticsPayloads(action), $496bc46eecb93df5$var$sendTrackingEvents);
var $496bc46eecb93df5$export$2e2bcd8739ae039 = $496bc46eecb93df5$var$analyticsMiddleware;

});
parcelRegister("gJEvT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2f0466c6c017bd5$export$2e2bcd8739ae039);

var $dKnCb = parcelRequire("dKnCb");

var $i0k4A = parcelRequire("i0k4A");

var $7Uh51 = parcelRequire("7Uh51");
function $c2f0466c6c017bd5$export$2e2bcd8739ae039(action) {
    switch(action.type){
        case 0, $i0k4A.FINISH_GENERATE_APP_SPECIFIC_PASSWORD:
        case 0, $i0k4A.START_REGENERATE_APP_SPECIFIC_PASSWORD:
            return (0, $dKnCb.makeAnalyticsData)({
                eventType: action.type === (0, $i0k4A.FINISH_GENERATE_APP_SPECIFIC_PASSWORD) ? (0, $7Uh51.TokenGeneratedEvent) : (0, $7Uh51.TokenRegeneratedEvent),
                category: (0, $7Uh51.ANALYTICS_CATEGORY_TOKENS),
                actionSubjectId: 'token',
                containerType: 'context',
                containerId: action.context.id
            });
        case 0, $i0k4A.GENERATE_APP_SPECIFIC_PASSWORD_ERROR:
        case 0, $i0k4A.REGENERATE_APP_SPECIFIC_PASSWORD_ERROR:
            return (0, $dKnCb.makeAnalyticsData)({
                eventType: action.type === (0, $i0k4A.GENERATE_APP_SPECIFIC_PASSWORD_ERROR) ? (0, $7Uh51.TokenGenerateFailedEvent) : (0, $7Uh51.TokenRegenerateFailedEvent),
                category: (0, $7Uh51.ANALYTICS_CATEGORY_TOKENS),
                actionSubjectId: 'token',
                containerType: 'context',
                containerId: action.context.id,
                attributes: {
                    error: action.error
                }
            });
    }
}

});

parcelRegister("yNFJK", function(module, exports) {

$parcel$export(module.exports, "default", () => $0689b4f32be063ee$export$2e2bcd8739ae039);

var $dKnCb = parcelRequire("dKnCb");

var $6BOFf = parcelRequire("6BOFf");

var $ifMZN = parcelRequire("ifMZN");

var $7Uh51 = parcelRequire("7Uh51");
function $0689b4f32be063ee$export$2e2bcd8739ae039(action) {
    switch(action.type){
        case 0, $6BOFf.DETERMINING_INSTALL_MODE_ERROR:
            return (0, $dKnCb.makeAnalyticsData)({
                eventType: (0, $7Uh51.FetchAppDetailsFailedEvent),
                category: (0, $7Uh51.ANALYTICS_CATEGORY_INSTALL),
                actionSubjectId: (0, $ifMZN.foldInstallableAppIdentifier)(action.installableAppId)((installableAppByKeyId)=>installableAppByKeyId.key, (installableAppByUrlId)=>installableAppByUrlId.url, (installableAppByARI)=>installableAppByARI.ari),
                attributes: {
                    error: action.error
                }
            });
    }
}

});

parcelRegister("f1Ju8", function(module, exports) {

$parcel$export(module.exports, "default", () => $af0a3b68cf813515$export$2e2bcd8739ae039);

var $dKnCb = parcelRequire("dKnCb");

var $7jp5q = parcelRequire("7jp5q");

var $7Uh51 = parcelRequire("7Uh51");
function $af0a3b68cf813515$export$2e2bcd8739ae039(action) {
    switch(action.type){
        case 0, $7jp5q.FETCH_INSTALLABLE_APP_BY_MANUAL_URL_ERROR:
            return (0, $dKnCb.makeAnalyticsData)({
                eventType: (0, $7Uh51.FetchAppDetailsFailedEvent),
                category: (0, $7Uh51.ANALYTICS_CATEGORY_INSTALL),
                actionSubjectId: action.installableAppByUrlId.url,
                attributes: {
                    error: action.error
                }
            });
    }
}

});

parcelRegister("gIsAL", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2b6ef2bb2aa7717$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $dKnCb = parcelRequire("dKnCb");

var $c8I9K = parcelRequire("c8I9K");

var $ifMZN = parcelRequire("ifMZN");

var $7Uh51 = parcelRequire("7Uh51");
function $c2b6ef2bb2aa7717$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $c2b6ef2bb2aa7717$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $c2b6ef2bb2aa7717$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $c2b6ef2bb2aa7717$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $c2b6ef2bb2aa7717$export$2e2bcd8739ae039(action) {
    switch(action.type){
        case 0, $c8I9K.FINISH_INSTALL_APP:
            return (0, $dKnCb.makeAnalyticsData)({
                eventType: (0, $7Uh51.AppInstalledEvent),
                category: (0, $7Uh51.ANALYTICS_CATEGORY_INSTALL),
                actionSubjectId: (0, $ifMZN.foldInstallableAppIdentifier)(action.installableAppId)((installableAppByKeyId)=>installableAppByKeyId.key, (installableAppByUrlId)=>installableAppByUrlId.url, (installableAppByARI)=>installableAppByARI.appKey),
                containerType: 'context',
                containerId: action.context.id,
                attributes: $c2b6ef2bb2aa7717$var$_objectSpread({
                    suppressResultFlag: action.suppressResultFlag,
                    featureFlags: action.featureFlags,
                    appKey: action.appDetails.key,
                    programs: action.appDetails.programs,
                    paymentModel: action.appDetails.paymentModel
                }, action.installableAppId.type === (0, $ifMZN.ARI_TYPE) && {
                    isEcosystemCloudApp: true,
                    ecosystemCloudAppId: action.installableAppId.ari
                })
            });
        case 0, $c8I9K.INSTALL_APP_ERROR:
            return (0, $dKnCb.makeAnalyticsData)({
                eventType: (0, $7Uh51.AppInstallFailedEvent),
                category: (0, $7Uh51.ANALYTICS_CATEGORY_INSTALL),
                actionSubjectId: (0, $ifMZN.foldInstallableAppIdentifier)(action.installableAppId)((installableAppByKeyId)=>installableAppByKeyId.key, (installableAppByUrlId)=>installableAppByUrlId.url, (installableAppByARI)=>installableAppByARI.ari),
                containerType: 'context',
                containerId: action.context.id,
                attributes: {
                    errorCode: action.error.code,
                    error: action.error.message,
                    source: action.error.source
                }
            });
    }
}

});

parcelRegister("7Fi5A", function(module, exports) {

$parcel$export(module.exports, "default", () => $594a64e1db6e101b$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $dKnCb = parcelRequire("dKnCb");

var $lQqqi = parcelRequire("lQqqi");

var $hNyxl = parcelRequire("hNyxl");

var $iEgm6 = parcelRequire("iEgm6");

var $7Uh51 = parcelRequire("7Uh51");
function $594a64e1db6e101b$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $594a64e1db6e101b$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $594a64e1db6e101b$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $594a64e1db6e101b$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $594a64e1db6e101b$var$createUninstallEvent = (appEventType, tokenEventType, installedApp, context, removedFrom, extraAttributes)=>(0, $lQqqi.foldAuthType)(installedApp.authType)((_)=>(0, $dKnCb.makeAnalyticsData)({
            eventType: tokenEventType,
            actionSubjectId: 'token',
            attributes: $594a64e1db6e101b$var$_objectSpread($594a64e1db6e101b$var$_objectSpread({}, extraAttributes), {}, {
                authType: 'token',
                removedFrom: removedFrom
            }),
            category: (0, $7Uh51.ANALYTICS_CATEGORY_UNINSTALL)
        }), (_)=>(0, $dKnCb.makeAnalyticsData)({
            eventType: appEventType,
            actionSubjectId: installedApp.details.key,
            attributes: $594a64e1db6e101b$var$_objectSpread($594a64e1db6e101b$var$_objectSpread({}, extraAttributes), {}, {
                name: installedApp.details.name,
                authType: '2LO',
                removedFrom: removedFrom,
                oauthClientId: installedApp.details.metadata.oauthClientId
            }),
            category: (0, $7Uh51.ANALYTICS_CATEGORY_UNINSTALL)
        }), (_)=>(0, $dKnCb.makeAnalyticsData)({
            eventType: appEventType,
            actionSubjectId: installedApp.details.key,
            attributes: $594a64e1db6e101b$var$_objectSpread($594a64e1db6e101b$var$_objectSpread({}, extraAttributes), {}, {
                name: installedApp.details.name,
                authType: '3LO',
                removedFrom: removedFrom,
                oauthClientId: installedApp.details.metadata.oauthClientId
            }),
            category: (0, $7Uh51.ANALYTICS_CATEGORY_UNINSTALL)
        })).set('containerType', 'context').set('containerId', context.id);
function $594a64e1db6e101b$export$2e2bcd8739ae039(action) {
    switch(action.type){
        case 0, $hNyxl.FINISH_UNINSTALL_APP_FROM_LOCAL_CONTEXT:
            return $594a64e1db6e101b$var$createUninstallEvent((0, $7Uh51.AppRemovedEvent), (0, $7Uh51.TokenRemovedEvent), action.installedApp, action.context, 'context');
        case 0, $hNyxl.UNINSTALL_APP_FROM_LOCAL_CONTEXT_ERROR:
            return $594a64e1db6e101b$var$createUninstallEvent((0, $7Uh51.AppRemoveFailedEvent), (0, $7Uh51.TokenRemoveFailedEvent), action.installedApp, action.context, 'context', {
                error: action.message
            });
        case 0, $hNyxl.FINISH_UNINSTALL_APP_FROM_SITE:
            return $594a64e1db6e101b$var$createUninstallEvent((0, $7Uh51.AppRemovedEvent), (0, $7Uh51.TokenRemovedEvent), action.installedApp, action.context, 'site');
        case 0, $hNyxl.UNINSTALL_APP_FROM_SITE_ERROR:
            return $594a64e1db6e101b$var$createUninstallEvent((0, $7Uh51.AppRemoveFailedEvent), (0, $7Uh51.TokenRemoveFailedEvent), action.installedApp, action.context, 'site', {
                error: action.message
            });
        case 0, $hNyxl.FINISH_REVOKE_USER_GRANT_GLOBALLY:
            return (0, $dKnCb.makeAnalyticsData)({
                eventType: (0, $7Uh51.UserGrantRemovedEvent),
                objectType: 'app',
                objectId: action.installedApp.details.key,
                actionSubjectId: action.userGrant.user.atlassianAccountId,
                attributes: {
                    name: (0, $iEgm6.resolveFieldWithFallback)((add)=>add.name, action.installedApp.marketplaceAppDetails, action.installedApp.details)
                },
                category: (0, $7Uh51.ANALYTICS_CATEGORY_NAVIGATION)
            });
        case 0, $hNyxl.REVOKE_USER_GRANT_GLOBALLY_ERROR:
            return (0, $dKnCb.makeAnalyticsData)({
                eventType: (0, $7Uh51.UserGrantRemoveFailedEvent),
                objectType: 'app',
                objectId: action.installedApp.details.key,
                actionSubjectId: action.userGrant.user.atlassianAccountId,
                attributes: {
                    name: (0, $iEgm6.resolveFieldWithFallback)((add)=>add.name, action.installedApp.marketplaceAppDetails, action.installedApp.details),
                    error: action.message
                },
                category: (0, $7Uh51.ANALYTICS_CATEGORY_NAVIGATION)
            });
    }
}

});

parcelRegister("cttF9", function(module, exports) {

$parcel$export(module.exports, "default", () => $914f33e08508fe84$export$2e2bcd8739ae039);

var $dKnCb = parcelRequire("dKnCb");

var $5Wf8D = parcelRequire("5Wf8D");

var $7Uh51 = parcelRequire("7Uh51");
function $914f33e08508fe84$export$2e2bcd8739ae039(action) {
    switch(action.type){
        case 0, $5Wf8D.FINISH_UPGRADE_APP:
            return (0, $dKnCb.makeAnalyticsData)({
                eventType: (0, $7Uh51.AppUpgradedEvent),
                category: (0, $7Uh51.ANALYTICS_CATEGORY_INSTALL),
                actionSubjectId: action.installableAppByKeyId.key,
                containerType: 'context',
                containerId: action.context.id
            });
        case 0, $5Wf8D.UPGRADE_APP_ERROR:
            return (0, $dKnCb.makeAnalyticsData)({
                eventType: (0, $7Uh51.AppUpgradeFailedEvent),
                category: (0, $7Uh51.ANALYTICS_CATEGORY_INSTALL),
                actionSubjectId: action.installableAppByKeyId.key,
                containerType: 'context',
                containerId: action.context.id,
                attributes: {
                    error: action.error
                }
            });
        case 0, $5Wf8D.FETCH_INSTALLABLE_APP_FOR_UPGRADE_ERROR:
            return (0, $dKnCb.makeAnalyticsData)({
                eventType: (0, $7Uh51.FetchAppDetailsFailedEvent),
                category: (0, $7Uh51.ANALYTICS_CATEGORY_INSTALL),
                actionSubjectId: action.installableAppByKeyId.key,
                attributes: {
                    error: action.error
                }
            });
    }
}

});


parcelRegister("eYijg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae64df37d8a4f407$export$2e2bcd8739ae039);

var $ighTk = parcelRequire("ighTk");

var $dNp25 = parcelRequire("dNp25");

var $j2ea9 = parcelRequire("j2ea9");
const $ae64df37d8a4f407$var$isHostInfoOrFeatureFlagsReceived = (action)=>action.type === (0, $j2ea9.RECEIVE_HOST_INFO) || action.type === (0, $j2ea9.RECEIVE_FEATURE_FLAGS);
const $ae64df37d8a4f407$var$setSentryScope = (_, action)=>{
    switch(action.type){
        case 0, $j2ea9.RECEIVE_HOST_INFO:
            {
                var _getSentryClient;
                const hostInfo = action.hostInfo;
                (_getSentryClient = (0, $ighTk.default)()) === null || _getSentryClient === void 0 || _getSentryClient.configureScope((scope)=>{
                    scope.setTag('product', hostInfo.product);
                    scope.setTag('contextId', hostInfo.globalContext.id);
                });
                break;
            }
        case 0, $j2ea9.RECEIVE_FEATURE_FLAGS:
            {
                var _getSentryClient2;
                const featureFlags = action.featureFlags.getAllFlags().toJS();
                (_getSentryClient2 = (0, $ighTk.default)()) === null || _getSentryClient2 === void 0 || _getSentryClient2.configureScope((scope)=>{
                    Object.entries(featureFlags).forEach((_ref)=>{
                        let [flagName, flagValue] = _ref;
                        return scope.setTag("ff-".concat(flagName), flagValue);
                    });
                });
                break;
            }
    }
};
const $ae64df37d8a4f407$var$SentryMiddleware = (0, (/*@__PURE__*/$parcel$interopDefault($dNp25)))($ae64df37d8a4f407$var$isHostInfoOrFeatureFlagsReceived, $ae64df37d8a4f407$var$setSentryScope);
var $ae64df37d8a4f407$export$2e2bcd8739ae039 = $ae64df37d8a4f407$var$SentryMiddleware;

});

parcelRegister("heESp", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c373b413ac851d$export$2e2bcd8739ae039);

var $4QJdp = parcelRequire("4QJdp");

var $R13JE = parcelRequire("R13JE");

var $a5uQr = parcelRequire("a5uQr");

var $fZybR = parcelRequire("fZybR");

var $fqCTF = parcelRequire("fqCTF");

var $3NPOw = parcelRequire("3NPOw");

var $98Oy1 = parcelRequire("98Oy1");

var $ao3gL = parcelRequire("ao3gL");

var $g5DMG = parcelRequire("g5DMG");

var $kHlNc = parcelRequire("kHlNc");
var $c8c373b413ac851d$export$2e2bcd8739ae039 = (0, $4QJdp.combineReducers)({
    analytics: (0, $R13JE.default),
    configuration: (0, $a5uQr.default),
    contexts: (0, $fZybR.default),
    flags: (0, $fqCTF.default),
    hostPricing: (0, $3NPOw.default),
    installation: (0, $98Oy1.default),
    installedApps: (0, $ao3gL.default),
    scopes: (0, $g5DMG.default),
    users: (0, $kHlNc.default)
});

});
parcelRegister("R13JE", function(module, exports) {

$parcel$export(module.exports, "default", () => $09f5c5b24f2df4da$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $c6kEN = parcelRequire("c6kEN");

var $gIQkA = parcelRequire("gIQkA");
const $09f5c5b24f2df4da$export$d347ff7483745ee6 = (0, $g5DHJ.Record)({
    analyticsLoadResult: (0, $bWAru.Option).none(),
    currentScreen: (0, $gIQkA.ANALYTICS_SCREEN_DISCOVER),
    modalStack: (0, $g5DHJ.List)(),
    lastScreenEvent: undefined,
    attributes: {
        mountPath: ''
    }
});
function $09f5c5b24f2df4da$export$2e2bcd8739ae039() {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $09f5c5b24f2df4da$export$d347ff7483745ee6();
    let action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $c6kEN.ANALYTICS_LOADED_SUCCESS:
            return state.set('analyticsLoadResult', (0, $bWAru.Option).some((0, $bWAru.Either).right()));
        case 0, $c6kEN.ANALYTICS_LOADED_ERROR:
            return state.set('analyticsLoadResult', (0, $bWAru.Option).some((0, $bWAru.Either).left(action.dataErrorMessages)));
        case 0, $c6kEN.ANALYTICS_MODAL_OPENED:
            {
                const modal = action.modal;
                return state.update('modalStack', (ss)=>ss.filterNot((s)=>s === modal).push(modal));
            }
        case 0, $c6kEN.ANALYTICS_MODAL_CLOSED:
            {
                const modal = action.modal;
                return state.update('modalStack', (ss)=>ss.filterNot((s)=>s === modal));
            }
        case 0, $c6kEN.ANALYTICS_SCREEN_CHANGED:
            return state.set('currentScreen', action.screen).set('attributes', action.attributes);
        case 0, $c6kEN.ANALYTICS_SEND_PAGE_VIEW:
            return state;
        // This redux action is all side-effect. See analytics/middleware/ScreenView.js
        case 0, $c6kEN.ANALYTICS_DONE_PAGE_VIEW:
            return state.set('lastScreenEvent', action.source);
        default:
            // Flow compile-time validation that we've handled every action
            // prettier-ignore
            action;
            return state;
    }
}

});

parcelRegister("fZybR", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba4712fab6febf99$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $j8dgx = parcelRequire("j8dgx");
const $ba4712fab6febf99$export$b2269fbab1d528d1 = (0, $g5DHJ.Record)({
    contexts: (0, $g5DHJ.List)(),
    dataError: false,
    dataErrorMessages: (0, $g5DHJ.List)(),
    initialized: false,
    isContextsLoading: false,
    pendingContextSearchId: undefined,
    selectedContext: (0, $bWAru.Option).none()
});
function $ba4712fab6febf99$export$2e2bcd8739ae039() {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $ba4712fab6febf99$export$b2269fbab1d528d1();
    let action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $j8dgx.FETCH_CONTEXTS:
            return state.set('pendingContextSearchId', action.contextSearchId).set('isContextsLoading', true);
        case 0, $j8dgx.RECEIVE_CONTEXTS:
            {
                const contextSearchId = action.contextSearchId;
                return state.pendingContextSearchId === contextSearchId ? state.set('contexts', action.contexts).set('isContextsLoading', false).set('dataError', false).set('dataErrorMessages', (0, $g5DHJ.List)()).set('initialized', true).delete('pendingContextSearchId') : state;
            }
        case 0, $j8dgx.RECEIVE_DATA_ERROR:
            return state.set('initialized', true).set('dataError', true).set('dataErrorMessages', action.dataErrorMessages);
        case 0, $j8dgx.CHANGE_CONTEXT:
            return state.set('selectedContext', (0, $bWAru.Option).some(action.selectedContext));
        default:
            // Flow compile-time validation that we've handled every action
            // prettier-ignore
            action;
            return state;
    }
}

});

parcelRegister("fqCTF", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3b774d52fc0807c$export$2e2bcd8739ae039);

var $g5DHJ = parcelRequire("g5DHJ");

var $8bwkw = parcelRequire("8bwkw");
const $b3b774d52fc0807c$export$d4a960d6beb0e77f = (0, $g5DHJ.Record)({
    flags: (0, $g5DHJ.List)()
});
function $b3b774d52fc0807c$export$2e2bcd8739ae039() {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $b3b774d52fc0807c$export$d4a960d6beb0e77f();
    let action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $8bwkw.ADD_FLAG:
            {
                const { flag: flag } = action;
                // New flags must be added to the beginning to be animated correctly
                return state.update('flags', (flags)=>{
                    const index = flags.findIndex((f)=>f.key === flag.key);
                    return index === -1 ? flags.unshift(flag) : flags.set(index, flag);
                });
            }
        case 0, $8bwkw.REMOVE_FLAG:
            {
                const { key: key } = action;
                return state.update('flags', (flags)=>flags.filterNot((f)=>f.key === key));
            }
        default:
            // Flow compile-time validation that we've handled every action
            // prettier-ignore
            action;
            return state;
    }
}

});

parcelRegister("3NPOw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c4e23dab6972d51$export$2e2bcd8739ae039);

var $7hvno = parcelRequire("7hvno");
const $2c4e23dab6972d51$export$842bbe80512eede5 = (_ref)=>{
    let { pending: pending, error: error, result: result } = _ref;
    return {
        hostPricing: {
            pending: pending,
            error: error,
            result: result
        }
    };
};
function $2c4e23dab6972d51$export$2e2bcd8739ae039() {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $2c4e23dab6972d51$export$842bbe80512eede5({
        pending: true,
        error: null,
        result: null
    });
    let action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $7hvno.FETCH_HOST_PRICING:
            return $2c4e23dab6972d51$export$842bbe80512eede5({
                pending: true,
                error: null,
                result: null
            });
        case 0, $7hvno.RECEIVE_HOST_PRICING:
            return $2c4e23dab6972d51$export$842bbe80512eede5({
                pending: false,
                error: null,
                result: action.hostPricing
            });
        case 0, $7hvno.RECEIVE_HOST_PRICING_ERROR:
            return $2c4e23dab6972d51$export$842bbe80512eede5({
                pending: false,
                error: action.error,
                result: null
            });
        default:
            // Flow compile-time validation that we've handled every action
            // prettier-ignore
            action;
            return state;
    }
}

});

parcelRegister("98Oy1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a7c121ff9410ada$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $c8I9K = parcelRequire("c8I9K");

var $dSumc = parcelRequire("dSumc");

var $i0k4A = parcelRequire("i0k4A");

var $6BOFf = parcelRequire("6BOFf");

var $7jp5q = parcelRequire("7jp5q");

var $5Wf8D = parcelRequire("5Wf8D");

var $jNrNi = parcelRequire("jNrNi");

var $dj3AB = parcelRequire("dj3AB");

var $1f7zg = parcelRequire("1f7zg");

var $ghbrX = parcelRequire("ghbrX");

var $30d6B = parcelRequire("30d6B");
const $6a7c121ff9410ada$export$e1680d6fc22ce58 = (0, $g5DHJ.Record)({
    installMode: (0, $bWAru.Option).none()
});
function $6a7c121ff9410ada$export$2e2bcd8739ae039() {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $6a7c121ff9410ada$export$e1680d6fc22ce58();
    let action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $i0k4A.SET_APP_SPECIFIC_PASSWORD_NAME:
        case 0, $i0k4A.START_GENERATE_APP_SPECIFIC_PASSWORD:
        case 0, $i0k4A.START_REGENERATE_APP_SPECIFIC_PASSWORD:
        case 0, $i0k4A.FINISH_GENERATE_APP_SPECIFIC_PASSWORD:
        case 0, $i0k4A.FINISH_REGENERATE_APP_SPECIFIC_PASSWORD:
        case 0, $i0k4A.GENERATE_APP_SPECIFIC_PASSWORD_ERROR:
        case 0, $i0k4A.REGENERATE_APP_SPECIFIC_PASSWORD_ERROR:
            return (0, $dj3AB.default)(state, action);
        case 0, $6BOFf.FINISH_DETERMINING_INSTALL_MODE:
        case 0, $6BOFf.DETERMINING_INSTALL_MODE_ERROR:
            return (0, $1f7zg.default)(state, action);
        case 0, $7jp5q.START_FETCH_INSTALLABLE_APP_BY_MANUAL_URL:
        case 0, $7jp5q.FINISH_FETCH_INSTALLABLE_APP_BY_MANUAL_URL:
        case 0, $7jp5q.FETCH_INSTALLABLE_APP_BY_MANUAL_URL_ERROR:
        case 0, $7jp5q.CLEAR_INSTALLABLE_APP_BY_MANUAL_URL:
            return (0, $ghbrX.default)(state, action);
        case 0, $c8I9K.START_INSTALL_APP:
        case 0, $c8I9K.FINISH_INSTALL_APP:
        case 0, $c8I9K.INSTALL_APP_ERROR:
            return (0, $jNrNi.default)(state, action);
        case 0, $5Wf8D.FINISH_FETCH_INSTALLABLE_APP_FOR_UPGRADE:
        case 0, $5Wf8D.FETCH_INSTALLABLE_APP_FOR_UPGRADE_ERROR:
        case 0, $5Wf8D.START_UPGRADE_APP:
        case 0, $5Wf8D.FINISH_UPGRADE_APP:
        case 0, $5Wf8D.UPGRADE_APP_ERROR:
            return (0, $30d6B.default)(state, action);
        case 0, $dSumc.SET_INSTALL_MODE:
            return state.set('installMode', (0, $bWAru.Option).some(action.installMode));
        case 0, $dSumc.CLEAR_INSTALL_MODE:
            return state.set('installMode', (0, $bWAru.Option).empty());
        default:
            // Flow compile-time validation that we've handled every action
            // prettier-ignore
            action;
            return state;
    }
}

});
parcelRegister("jNrNi", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6982740e88422ed$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $c8I9K = parcelRequire("c8I9K");

var $i7hUf = parcelRequire("i7hUf");

var $9eIgo = parcelRequire("9eIgo");

var $9IC13 = parcelRequire("9IC13");

var $8tfDH = parcelRequire("8tfDH");
const $e6982740e88422ed$var$installAppReducer = (state, action)=>{
    switch(action.type){
        case 0, $c8I9K.START_INSTALL_APP:
            {
                const installableAppId = action.installableAppId;
                return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((value)=>value, (value)=>value, (value)=>value, (installableAppDefault)=>(0, $9IC13.installableAppIdentifiersAreEqual)(installableAppDefault.installableAppId, installableAppId) ? installableAppDefault.set('status', (0, $9eIgo.makeInProgressInstallStatus)()) : installableAppDefault, (installableAppByManualUrl)=>installableAppByManualUrl.update('installableAppByManualUrl', (oiabmu)=>oiabmu.map((iabmu)=>(0, $9IC13.installableAppIdentifiersAreEqual)(iabmu.installableAppByUrlId, installableAppId) ? iabmu.set('status', (0, $9eIgo.makeInProgressInstallStatus)()) : iabmu)), (value)=>value));
            }
        case 0, $c8I9K.FINISH_INSTALL_APP:
            {
                const installableAppId = action.installableAppId;
                return (0, $8tfDH.flatMapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((0, $bWAru.Option).some, (0, $bWAru.Option).some, (0, $bWAru.Option).some, (installableAppDefault)=>(0, $9IC13.installableAppIdentifiersAreEqual)(installableAppDefault.installableAppId, installableAppId) ? (0, $bWAru.Option).none() : (0, $bWAru.Option).some(installableAppDefault), (installableAppByManualUrl)=>installableAppByManualUrl.installableAppByManualUrl.exists((iabmu)=>(0, $9IC13.installableAppIdentifiersAreEqual)(iabmu.installableAppByUrlId, installableAppId)) ? (0, $bWAru.Option).none() : (0, $bWAru.Option).some(installableAppByManualUrl), (0, $bWAru.Option).some));
            }
        case 0, $c8I9K.INSTALL_APP_ERROR:
            {
                const installableAppId = action.installableAppId;
                const error = action.error;
                return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((value)=>value, (value)=>value, (value)=>value, (installableAppDefault)=>(0, $9IC13.installableAppIdentifiersAreEqual)(installableAppDefault.installableAppId, installableAppId) ? installableAppDefault.set('status', (0, $9eIgo.makeCompleteInstallStatus)({
                            result: (0, $bWAru.Either).left(error.message)
                        })) : installableAppDefault, (installableAppByManualUrl)=>installableAppByManualUrl.update('installableAppByManualUrl', (oiabmu)=>oiabmu.map((iabmu)=>(0, $9IC13.installableAppIdentifiersAreEqual)(iabmu.installableAppByUrlId, installableAppId) ? iabmu.set('status', (0, $9eIgo.makeCompleteInstallStatus)({
                                    result: (0, $bWAru.Either).left(error.message)
                                })) : iabmu)), (value)=>value));
            }
        default:
            // Flow compile-time validation that we've handled every action
            // prettier-ignore
            action;
            return state;
    }
};
var $e6982740e88422ed$export$2e2bcd8739ae039 = $e6982740e88422ed$var$installAppReducer;

});
parcelRegister("8tfDH", function(module, exports) {

$parcel$export(module.exports, "mapInstallMode", () => $62ad29d36e28aed8$export$c932eb05cbc25088);
$parcel$export(module.exports, "flatMapInstallMode", () => $62ad29d36e28aed8$export$53d3b2d8ca6bc558);
const $62ad29d36e28aed8$export$c932eb05cbc25088 = (state, updater)=>state.update('installMode', (installMode)=>installMode.map(updater));
const $62ad29d36e28aed8$export$53d3b2d8ca6bc558 = (state, updater)=>state.update('installMode', (installMode)=>installMode.flatMap(updater));

});


parcelRegister("dj3AB", function(module, exports) {

$parcel$export(module.exports, "default", () => $027fff506e83eafb$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $i0k4A = parcelRequire("i0k4A");

var $9Qzgt = parcelRequire("9Qzgt");

var $i7hUf = parcelRequire("i7hUf");

var $9eIgo = parcelRequire("9eIgo");

var $8tfDH = parcelRequire("8tfDH");
const $027fff506e83eafb$var$appSpecificPasswordReducer = (state, action)=>{
    switch(action.type){
        case 0, $i0k4A.SET_APP_SPECIFIC_PASSWORD_NAME:
            {
                const name = action.name;
                return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((value)=>value, (asp)=>asp.set('appSpecificPassword', name ? (0, $9Qzgt.makeAppSpecificPassword)({
                            name: name
                        }) : null), (value)=>value, (value)=>value, (value)=>value, (value)=>value));
            }
        case 0, $i0k4A.START_GENERATE_APP_SPECIFIC_PASSWORD:
            return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((value)=>value, (asp)=>asp.update('appSpecificPassword', (oast)=>oast.map((ast)=>ast.set('status', (0, $9eIgo.makeInProgressInstallStatus)()))), (value)=>value, (value)=>value, (value)=>value, (value)=>value));
        case 0, $i0k4A.START_REGENERATE_APP_SPECIFIC_PASSWORD:
            return state.set('installMode', (0, $bWAru.Option).some((0, $9Qzgt.makeAppSpecificPasswordInstallMode)({
                appSpecificPassword: (0, $bWAru.Option).some((0, $9Qzgt.makeAppSpecificPassword)({
                    name: action.name,
                    status: (0, $9eIgo.makeInProgressInstallStatus)()
                }))
            })));
        case 0, $i0k4A.FINISH_GENERATE_APP_SPECIFIC_PASSWORD:
        case 0, $i0k4A.FINISH_REGENERATE_APP_SPECIFIC_PASSWORD:
            {
                const generatedAppSpecificPassword = action.generatedAppSpecificPassword;
                return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((value)=>value, (asp)=>asp.update('appSpecificPassword', (oast)=>oast.map((ast)=>ast.set('status', (0, $9eIgo.makeCompleteInstallStatus)({
                                    result: (0, $bWAru.Either).right(generatedAppSpecificPassword)
                                })))), (value)=>value, (value)=>value, (value)=>value, (value)=>value));
            }
        case 0, $i0k4A.GENERATE_APP_SPECIFIC_PASSWORD_ERROR:
        case 0, $i0k4A.REGENERATE_APP_SPECIFIC_PASSWORD_ERROR:
            {
                const error = action.error;
                return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((value)=>value, (asp)=>asp.update('appSpecificPassword', (oast)=>oast.map((ast)=>ast.set('status', (0, $9eIgo.makeCompleteInstallStatus)({
                                    result: (0, $bWAru.Either).left(error)
                                })))), (value)=>value, (value)=>value, (value)=>value, (value)=>value));
            }
        default:
            // Flow compile-time validation that we've handled every action
            // prettier-ignore
            action;
            return state;
    }
};
var $027fff506e83eafb$export$2e2bcd8739ae039 = $027fff506e83eafb$var$appSpecificPasswordReducer;

});

parcelRegister("1f7zg", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e7d0ff1728381c6$export$2e2bcd8739ae039);

var $6BOFf = parcelRequire("6BOFf");

var $i7hUf = parcelRequire("i7hUf");

var $8tfDH = parcelRequire("8tfDH");
const $0e7d0ff1728381c6$var$determiningInstallModeReducer = (state, action)=>{
    switch(action.type){
        case 0, $6BOFf.FINISH_DETERMINING_INSTALL_MODE:
            {
                const retrievalId = action.retrievalId;
                const installMode = action.installMode;
                return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((determining)=>determining.retrievalId === retrievalId ? installMode : determining, (value)=>value, (value)=>value, (value)=>value, (value)=>value, (value)=>value));
            }
        case 0, $6BOFf.DETERMINING_INSTALL_MODE_ERROR:
            {
                const retrievalId = action.retrievalId;
                const error = action.error;
                return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((determining)=>determining.retrievalId === retrievalId ? determining.set('error', error) : determining, (value)=>value, (value)=>value, (value)=>value, (value)=>value, (value)=>value));
            }
        default:
            // Flow compile-time validation that we've handled every action
            // prettier-ignore
            action;
            return state;
    }
};
var $0e7d0ff1728381c6$export$2e2bcd8739ae039 = $0e7d0ff1728381c6$var$determiningInstallModeReducer;

});

parcelRegister("ghbrX", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd971d9146613ee2$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $7jp5q = parcelRequire("7jp5q");

var $249j9 = parcelRequire("249j9");

var $i7hUf = parcelRequire("i7hUf");

var $8tfDH = parcelRequire("8tfDH");
const $bd971d9146613ee2$var$installableAppByManualUrlReducer = (state, action)=>{
    switch(action.type){
        case 0, $7jp5q.START_FETCH_INSTALLABLE_APP_BY_MANUAL_URL:
            {
                const installableAppByUrlId = action.installableAppByUrlId;
                const retrievalId = action.retrievalId;
                return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((value)=>value, (value)=>value, (value)=>value, (value)=>value, (installableAppByManualUrl)=>installableAppByManualUrl.set('installableAppByManualUrl', (0, $bWAru.Option).some((0, $249j9.makeInstallableAppByManualUrl)({
                            installableAppByUrlId: installableAppByUrlId,
                            retrievalId: retrievalId
                        }))), (value)=>value));
            }
        case 0, $7jp5q.FINISH_FETCH_INSTALLABLE_APP_BY_MANUAL_URL:
            {
                const retrievalId = action.retrievalId;
                const installableApp = action.installableApp;
                const installedApp = action.installedApp;
                return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((value)=>value, (value)=>value, (value)=>value, (value)=>value, (installableAppByManualUrl)=>installableAppByManualUrl.update('installableAppByManualUrl', (installableAppByManualUrlOld)=>installableAppByManualUrlOld.map((iabmu)=>iabmu.retrievalId === retrievalId ? iabmu.set('installableApp', (0, $bWAru.Option).some((0, $bWAru.Either).right(installableApp))).set('installedApp', installedApp) : iabmu)), (value)=>value));
            }
        case 0, $7jp5q.FETCH_INSTALLABLE_APP_BY_MANUAL_URL_ERROR:
            {
                const retrievalId = action.retrievalId;
                const error = action.error;
                return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((value)=>value, (value)=>value, (value)=>value, (value)=>value, (installableAppByManualUrl)=>installableAppByManualUrl.update('installableAppByManualUrl', (installableAppByManualUrlOld)=>installableAppByManualUrlOld.map((iabmu)=>iabmu.retrievalId === retrievalId ? iabmu.set('installableApp', (0, $bWAru.Option).some((0, $bWAru.Either).left(error))) : iabmu)), (value)=>value));
            }
        case 0, $7jp5q.CLEAR_INSTALLABLE_APP_BY_MANUAL_URL:
            return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((value)=>value, (value)=>value, (value)=>value, (value)=>value, (installableAppByManualUrl)=>installableAppByManualUrl.set('installableAppByManualUrl', (0, $bWAru.Option).empty()), (value)=>value));
        default:
            // Flow compile-time validation that we've handled every action
            // prettier-ignore
            action;
            return state;
    }
};
var $bd971d9146613ee2$export$2e2bcd8739ae039 = $bd971d9146613ee2$var$installableAppByManualUrlReducer;

});

parcelRegister("30d6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $22fb89a8939385ca$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $5Wf8D = parcelRequire("5Wf8D");

var $i7hUf = parcelRequire("i7hUf");

var $9eIgo = parcelRequire("9eIgo");

var $8tfDH = parcelRequire("8tfDH");
// eslint-disable-next-line max-lines-per-function -- Fix me
const $22fb89a8939385ca$var$upgradeAppReducer = (state, action)=>{
    switch(action.type){
        case 0, $5Wf8D.FINISH_FETCH_INSTALLABLE_APP_FOR_UPGRADE:
            {
                const installableAppByKeyId = action.installableAppByKeyId;
                const installableAppToUpgradeTo = action.installableAppToUpgradeTo;
                return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((value)=>value, (value)=>value, (value)=>value, (value)=>value, (value)=>value, (installableAppUpgrade)=>installableAppUpgrade.installableAppByKeyId.equals(installableAppByKeyId) ? installableAppUpgrade.set('installableAppToUpgradeTo', (0, $bWAru.Option).some((0, $bWAru.Either).right(installableAppToUpgradeTo))) : installableAppUpgrade));
            }
        case 0, $5Wf8D.FETCH_INSTALLABLE_APP_FOR_UPGRADE_ERROR:
            {
                const installableAppByKeyId = action.installableAppByKeyId;
                const error = action.error;
                return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((value)=>value, (value)=>value, (value)=>value, (value)=>value, (value)=>value, (installableAppUpgrade)=>installableAppUpgrade.installableAppByKeyId.equals(installableAppByKeyId) ? installableAppUpgrade.set('installableAppToUpgradeTo', (0, $bWAru.Option).some((0, $bWAru.Either).left(error))) : installableAppUpgrade));
            }
        case 0, $5Wf8D.START_UPGRADE_APP:
            {
                const installableAppByKeyId = action.installableAppByKeyId;
                return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((value)=>value, (value)=>value, (value)=>value, (value)=>value, (value)=>value, (installableAppUpgrade)=>installableAppUpgrade.installableAppByKeyId.equals(installableAppByKeyId) ? installableAppUpgrade.set('status', (0, $9eIgo.makeInProgressInstallStatus)()) : installableAppUpgrade));
            }
        case 0, $5Wf8D.FINISH_UPGRADE_APP:
            {
                const installableAppByKeyId = action.installableAppByKeyId;
                return (0, $8tfDH.flatMapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((0, $bWAru.Option).some, (0, $bWAru.Option).some, (0, $bWAru.Option).some, (0, $bWAru.Option).some, (0, $bWAru.Option).some, (installableAppUpgrade)=>installableAppUpgrade.installableAppByKeyId.equals(installableAppByKeyId) ? (0, $bWAru.Option).none() : (0, $bWAru.Option).some(installableAppUpgrade)));
            }
        case 0, $5Wf8D.UPGRADE_APP_ERROR:
            {
                const installableAppByKeyId = action.installableAppByKeyId;
                const error = action.error;
                return (0, $8tfDH.mapInstallMode)(state, (currentInstallMode)=>(0, $i7hUf.foldInstallMode)(currentInstallMode)((value)=>value, (value)=>value, (value)=>value, (value)=>value, (value)=>value, (installableAppUpgrade)=>installableAppUpgrade.installableAppByKeyId.equals(installableAppByKeyId) ? installableAppUpgrade.set('status', (0, $9eIgo.makeCompleteInstallStatus)({
                            result: (0, $bWAru.Either).left(error)
                        })) : installableAppUpgrade));
            }
        default:
            // Flow compile-time validation that we've handled every action
            // prettier-ignore
            action;
            return state;
    }
};
var $22fb89a8939385ca$export$2e2bcd8739ae039 = $22fb89a8939385ca$var$upgradeAppReducer;

});


parcelRegister("ao3gL", function(module, exports) {

$parcel$export(module.exports, "default", () => $78feae81a1c0aa46$export$2e2bcd8739ae039);

var $cjFit = parcelRequire("cjFit");

var $lQqqi = parcelRequire("lQqqi");
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $hNyxl = parcelRequire("hNyxl");
const $78feae81a1c0aa46$export$a7c9f9dc267febcf = (0, $g5DHJ.Record)({
    installedApps: (0, $g5DHJ.List)(),
    loadingMoreResults: false,
    totalCount: 0,
    nextOffset: (0, $bWAru.Option).empty()
});
const $78feae81a1c0aa46$export$49bc83ef7641a6fb = (0, $g5DHJ.Record)({
    result: (0, $bWAru.Option).empty(),
    requestId: undefined
});
const $78feae81a1c0aa46$export$c9c50a3b1b3d9b5d = (0, $g5DHJ.Record)({
    currentSearch: (0, $cjFit.emptyString),
    locallyInstalledApps: $78feae81a1c0aa46$export$49bc83ef7641a6fb(),
    globallyInstalledApps: $78feae81a1c0aa46$export$49bc83ef7641a6fb(),
    uninstallingAppFromSite: (0, $bWAru.Option).none()
});
const $78feae81a1c0aa46$var$updateRevokeInProgressState = (state, appKey, userGrant, revokeInProgress)=>state.updateIn([
        'globallyInstalledApps',
        'result'
    ], (rr)=>rr.map((r)=>r.map((iar)=>iar.update('installedApps', (gias)=>gias.map((gia)=>gia.details.key === appKey ? gia.update('authType', (authType)=>(0, $lQqqi.foldAuthType)(authType)((value)=>value, (value)=>value, (threeLeggedAuthType)=>threeLeggedAuthType.update('grants', (gs)=>gs.map((g)=>g.user.atlassianAccountId === userGrant.user.atlassianAccountId ? g.set('revokeInProgress', revokeInProgress) : g)))) : gia)))));
const $78feae81a1c0aa46$var$receiveFreshInstalledApps = (contextInstalledApps, requestId, installedAppsPage)=>contextInstalledApps.requestId === requestId ? contextInstalledApps.delete('requestId').set('result', (0, $bWAru.Option).some((0, $bWAru.Either).right($78feae81a1c0aa46$export$a7c9f9dc267febcf({
        installedApps: installedAppsPage.values,
        totalCount: installedAppsPage.totalCount,
        nextOffset: installedAppsPage.nextOffset
    })))) : contextInstalledApps;
const $78feae81a1c0aa46$var$receiveFreshInstalledAppsError = (contextInstalledApps, requestId, dataErrorMessages)=>contextInstalledApps.requestId === requestId ? contextInstalledApps.delete('requestId').set('result', (0, $bWAru.Option).some((0, $bWAru.Either).left(dataErrorMessages))) : contextInstalledApps;
const $78feae81a1c0aa46$var$fetchMoreInstalledApps = (contextInstalledApps, requestId)=>contextInstalledApps.set('requestId', requestId).update('result', (rr)=>rr.map((r)=>r.map((res)=>res.set('loadingMoreResults', true))));
const $78feae81a1c0aa46$var$receiveMoreInstalledApps = (contextInstalledApps, requestId, installedAppsPage)=>contextInstalledApps.requestId === requestId ? contextInstalledApps.delete('requestId').update('result', (rr)=>rr.map((r)=>r.map((iar)=>iar.update('installedApps', (ias)=>ias.concat(installedAppsPage.values)).set('nextOffset', installedAppsPage.nextOffset).set('loadingMoreResults', false)))) : contextInstalledApps;
const $78feae81a1c0aa46$var$receiveMoreInstalledAppsError = (contextInstalledApps, requestId)=>contextInstalledApps.requestId === requestId ? contextInstalledApps.delete('requestId').update('result', (rr)=>rr.map((r)=>r.map((iar)=>iar.set('loadingMoreResults', false)))) : contextInstalledApps;
function $78feae81a1c0aa46$export$2e2bcd8739ae039() {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $78feae81a1c0aa46$export$c9c50a3b1b3d9b5d();
    let action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $hNyxl.FETCH_FRESH_INSTALLED_APPS:
            return state.set('currentSearch', action.search).set('locallyInstalledApps', $78feae81a1c0aa46$export$49bc83ef7641a6fb({
                requestId: action.requestId
            })).set('globallyInstalledApps', $78feae81a1c0aa46$export$49bc83ef7641a6fb({
                requestId: action.requestId
            }));
        case 0, $hNyxl.RECEIVE_FRESH_INSTALLED_APPS:
            {
                const requestId = action.requestId;
                const locallyInstalledAppsPage = action.locallyInstalledAppsPage;
                const globallyInstalledAppsPage = action.globallyInstalledAppsPage;
                return state.update('locallyInstalledApps', (lias)=>$78feae81a1c0aa46$var$receiveFreshInstalledApps(lias, requestId, locallyInstalledAppsPage)).update('globallyInstalledApps', (gias)=>$78feae81a1c0aa46$var$receiveFreshInstalledApps(gias, requestId, globallyInstalledAppsPage));
            }
        case 0, $hNyxl.RECEIVE_FRESH_INSTALLED_APPS_ERROR:
            {
                const requestId = action.requestId;
                const dataErrorMessages = action.dataErrorMessages;
                return state.update('locallyInstalledApps', (lias)=>$78feae81a1c0aa46$var$receiveFreshInstalledAppsError(lias, requestId, dataErrorMessages)).update('globallyInstalledApps', (gias)=>$78feae81a1c0aa46$var$receiveFreshInstalledAppsError(gias, requestId, dataErrorMessages));
            }
        case 0, $hNyxl.FETCH_MORE_GLOBALLY_INSTALLED_APPS:
            {
                const requestId = action.requestId;
                return state.update('globallyInstalledApps', (gias)=>$78feae81a1c0aa46$var$fetchMoreInstalledApps(gias, requestId));
            }
        case 0, $hNyxl.RECEIVE_MORE_GLOBALLY_INSTALLED_APPS:
            {
                const requestId = action.requestId;
                const globallyInstalledAppsPage = action.globallyInstalledAppsPage;
                return state.update('globallyInstalledApps', (gias)=>$78feae81a1c0aa46$var$receiveMoreInstalledApps(gias, requestId, globallyInstalledAppsPage));
            }
        case 0, $hNyxl.RECEIVE_MORE_GLOBALLY_INSTALLED_APPS_ERROR:
            {
                const requestId = action.requestId;
                return state.update('globallyInstalledApps', (gias)=>$78feae81a1c0aa46$var$receiveMoreInstalledAppsError(gias, requestId));
            }
        case 0, $hNyxl.FETCH_MORE_LOCALLY_INSTALLED_APPS:
            {
                const requestId = action.requestId;
                return state.update('locallyInstalledApps', (lias)=>$78feae81a1c0aa46$var$fetchMoreInstalledApps(lias, requestId));
            }
        case 0, $hNyxl.RECEIVE_MORE_LOCALLY_INSTALLED_APPS:
            {
                const requestId = action.requestId;
                const locallyInstalledAppsPage = action.locallyInstalledAppsPage;
                return state.update('locallyInstalledApps', (gias)=>$78feae81a1c0aa46$var$receiveMoreInstalledApps(gias, requestId, locallyInstalledAppsPage));
            }
        case 0, $hNyxl.RECEIVE_MORE_LOCALLY_INSTALLED_APPS_ERROR:
            {
                const requestId = action.requestId;
                return state.update('locallyInstalledApps', (lias)=>$78feae81a1c0aa46$var$receiveMoreInstalledAppsError(lias, requestId));
            }
        case 0, $hNyxl.OPEN_SITE_UNINSTALL_DIALOG:
            return state.set('uninstallingAppFromSite', (0, $bWAru.Option).some(action.installedApp));
        case 0, $hNyxl.CLOSE_SITE_UNINSTALL_DIALOG:
            return state.set('uninstallingAppFromSite', (0, $bWAru.Option).none());
        case 0, $hNyxl.START_UNINSTALL_APP_FROM_LOCAL_CONTEXT:
            {
                const appKey = action.installedApp.details.key;
                return state.updateIn([
                    'locallyInstalledApps',
                    'result'
                ], (rr)=>rr.map((r)=>r.map((iar)=>iar.update('installedApps', (ias)=>ias.map((lia)=>lia.details.key === appKey ? lia.set('uninstallInProgress', true) : lia)))));
            }
        case 0, $hNyxl.FINISH_UNINSTALL_APP_FROM_LOCAL_CONTEXT:
            {
                const appKey = action.installedApp.details.key;
                return state.updateIn([
                    'locallyInstalledApps',
                    'result'
                ], (rr)=>rr.map((r)=>r.map((iar)=>iar.update('installedApps', (ias)=>ias.filter((ia)=>ia.details.key !== appKey)).update('totalCount', (tc)=>tc - 1))));
            }
        case 0, $hNyxl.UNINSTALL_APP_FROM_LOCAL_CONTEXT_ERROR:
            {
                const appKey = action.installedApp.details.key;
                return state.updateIn([
                    'locallyInstalledApps',
                    'result'
                ], (rr)=>rr.map((r)=>r.map((iar)=>iar.update('installedApps', (ias)=>ias.map((lia)=>lia.details.key === appKey ? lia.set('uninstallInProgress', false) : lia)))));
            }
        case 0, $hNyxl.START_UNINSTALL_APP_FROM_SITE:
            return state.update('uninstallingAppFromSite', (uia)=>uia.map((ia)=>ia.set('uninstallInProgress', true)));
        case 0, $hNyxl.FINISH_UNINSTALL_APP_FROM_SITE:
            {
                const appKey = action.installedApp.details.key;
                return state.updateIn([
                    'locallyInstalledApps',
                    'result'
                ], (rr)=>rr.map((r)=>r.map((iar)=>iar.update('installedApps', (ias)=>ias.filter((ia)=>ia.details.key !== appKey))))).updateIn([
                    'globallyInstalledApps',
                    'result'
                ], (rr)=>rr.map((r)=>r.map((iar)=>iar.update('installedApps', (ias)=>ias.filter((ia)=>ia.details.key !== appKey))))).set('uninstallingAppFromSite', (0, $bWAru.Option).none());
            }
        case 0, $hNyxl.UNINSTALL_APP_FROM_SITE_ERROR:
            return state.update('uninstallingAppFromSite', (uia)=>uia.map((ia)=>ia.set('uninstallInProgress', false)));
        case 0, $hNyxl.START_REVOKE_USER_GRANT_GLOBALLY:
            return $78feae81a1c0aa46$var$updateRevokeInProgressState(state, action.installedApp.details.key, action.userGrant, true);
        case 0, $hNyxl.FINISH_REVOKE_USER_GRANT_GLOBALLY:
            {
                const appKey = action.installedApp.details.key;
                const userGrant = action.userGrant;
                return state.updateIn([
                    'globallyInstalledApps',
                    'result'
                ], (rr)=>rr.map((r)=>r.map((iar)=>iar.update('installedApps', (gias)=>gias.map((gia)=>gia.details.key === appKey ? gia.update('authType', (authType)=>(0, $lQqqi.foldAuthType)(authType)((value)=>value, (value)=>value, (threeLeggedAuthType)=>threeLeggedAuthType.update('grants', (gs)=>gs.filter((g)=>g.user.atlassianAccountId !== userGrant.user.atlassianAccountId)))) : gia).filter((ia)=>(0, $lQqqi.foldAuthType)(ia.authType)(()=>true, ()=>true, (threeLeggedAuthType)=>threeLeggedAuthType.grants.size > 0))))));
            }
        case 0, $hNyxl.REVOKE_USER_GRANT_GLOBALLY_ERROR:
            return $78feae81a1c0aa46$var$updateRevokeInProgressState(state, action.installedApp.details.key, action.userGrant, false);
        case 0, $hNyxl.FINISH_FETCH_MARKETPLACE_APP_DETAILS:
            {
                const marketplaceAppDetails = action.marketplaceAppDetails;
                const appKey = marketplaceAppDetails.key;
                const updateContextName = action.isGlobalContext ? 'globallyInstalledApps' : 'locallyInstalledApps';
                return state.updateIn([
                    updateContextName,
                    'result'
                ], (rr)=>rr.map((r)=>r.map((iar)=>iar.update('installedApps', (ias)=>ias.map((ia)=>ia.details.key === appKey ? ia.set('marketplaceAppDetails', marketplaceAppDetails) : ia)))));
            }
        default:
            // Flow compile-time validation that we've handled every action
            // prettier-ignore
            action;
            return state;
    }
}

});

parcelRegister("g5DMG", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb6bf948f5dccfe0$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $ae44r = parcelRequire("ae44r");
const $bb6bf948f5dccfe0$export$455364dff60a60b = (0, $g5DHJ.Record)({
    scopesLookup: (0, $bWAru.Option).none()
});
function $bb6bf948f5dccfe0$export$2e2bcd8739ae039() {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $bb6bf948f5dccfe0$export$455364dff60a60b();
    let action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $ae44r.FETCH_SCOPES_LOOKUP:
            return state.set('scopesLookup', (0, $bWAru.Option).none());
        case 0, $ae44r.RECEIVE_SCOPES_LOOKUP:
            return state.set('scopesLookup', (0, $bWAru.Option).some((0, $bWAru.Either).right(action.scopesLookup)));
        case 0, $ae44r.RECEIVE_SCOPES_LOOKUP_ERROR:
            return state.set('scopesLookup', (0, $bWAru.Option).some((0, $bWAru.Either).left(action.dataErrorMessages)));
        default:
            // Flow compile-time validation that we've handled every action
            // prettier-ignore
            action;
            return state;
    }
}

});

parcelRegister("kHlNc", function(module, exports) {

$parcel$export(module.exports, "default", () => $f118ba547b594a98$export$2e2bcd8739ae039);
parcelRequire("5jwNO");
var $bWAru = parcelRequire("bWAru");

var $g5DHJ = parcelRequire("g5DHJ");

var $G8Qov = parcelRequire("G8Qov");
const $f118ba547b594a98$export$1fed3fbebabf78bc = (0, $g5DHJ.Record)({
    currentUserId: (0, $bWAru.Option).none()
});
function $f118ba547b594a98$export$2e2bcd8739ae039() {
    let state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $f118ba547b594a98$export$1fed3fbebabf78bc();
    let action = arguments.length > 1 ? arguments[1] : undefined;
    switch(action.type){
        case 0, $G8Qov.FETCH_CURRENT_USER_ID:
            return state.set('currentUserId', (0, $bWAru.Option).none());
        case 0, $G8Qov.RECEIVE_CURRENT_USER_ID:
            return state.set('currentUserId', (0, $bWAru.Option).some((0, $bWAru.Either).right(action.currentUserId)));
        case 0, $G8Qov.RECEIVE_CURRENT_USER_ID_ERROR:
            return state.set('currentUserId', (0, $bWAru.Option).some((0, $bWAru.Either).left(action.dataErrorMessages)));
        default:
            // Flow compile-time validation that we've handled every action
            // prettier-ignore
            action;
            return state;
    }
}

});



parcelRegister("iBvuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8b41da213a14334$export$2e2bcd8739ae039);

var $d4c1w = parcelRequire("d4c1w");
var $l4K9h = parcelRequire("l4K9h");
var $lGnVE = parcelRequire("lGnVE");
var $euans = parcelRequire("euans");
var $fUOHe = parcelRequire("fUOHe");
var $3GX6H = parcelRequire("3GX6H");
var $kCL8m = parcelRequire("kCL8m");

var $1Novb = parcelRequire("1Novb");

var $66CK0 = parcelRequire("66CK0");

var $72LB9 = parcelRequire("72LB9");
const { getNetworkRequestTimes: $d8b41da213a14334$var$getNetworkRequestTimes, waitForTimeToInteractive: $d8b41da213a14334$var$waitForTimeToInteractive, PageVisibilityObserver: $d8b41da213a14334$var$PageVisibilityObserver } = (0, $kCL8m);
// Start listening for page visibility change so we can
// differentiate foreground events from background events later
$d8b41da213a14334$var$PageVisibilityObserver.start();
async function $d8b41da213a14334$var$initEmceeTelemetry(config, SPI, emceeVersion, onRouteTransitionEnd) {
    let subProduct;
    try {
        const hostInfo = await SPI.getHostInfo();
        subProduct = hostInfo.subproduct || hostInfo.product;
    } catch (error) {
        subProduct = 'SUBPRODUCT_UNKNOWN';
        console.error('Error fetching product for telemetry', error);
    }
    const metalBackend = (0, $l4K9h.default)({
        env: config.env,
        id: config.id,
        version: emceeVersion,
        synthetic: (0, $1Novb).isSynthetic(),
        subProduct: subProduct
    });
    const sentryBackend = (0, $euans.default)();
    const logBackend = (0, $d4c1w.default)({
        enabled: false
    });
    const reactUFOBackend = (0, $lGnVE.default)();
    const routeTransitionBackend = (0, $72LB9.default)({
        onRouteTransitionEnd: onRouteTransitionEnd
    });
    (0, $3GX6H.default)([
        metalBackend,
        sentryBackend,
        logBackend,
        routeTransitionBackend,
        reactUFOBackend
    ]);
}
var $d8b41da213a14334$export$2e2bcd8739ae039 = (_ref)=>{
    let { emceeContainer: emceeContainer, config: config, SPI: SPI, emceeVersion: emceeVersion, onRouteTransitionEnd: onRouteTransitionEnd } = _ref;
    if (!emceeContainer) console.error('Did not find the root container, complete telemetry will not be sent');
    $d8b41da213a14334$var$initEmceeTelemetry(config, SPI, emceeVersion, onRouteTransitionEnd);
    (0, $66CK0.getFCP)((_ref2)=>{
        let { value: value } = _ref2;
        return (0, $fUOHe.default).timeToFirstPaint(value);
    });
    (0, $66CK0.getLCP)((_ref3)=>{
        let { value: value } = _ref3;
        return (0, $fUOHe.default).timeToLargestContentfulPaint(value);
    });
    (0, $66CK0.getTTFB)((_ref4)=>{
        let { value: value } = _ref4;
        return (0, $fUOHe.default).timeToFirstByte(value);
    });
    (0, $66CK0.getFID)((_ref5)=>{
        let { value: value } = _ref5;
        return (0, $fUOHe.default).firstInputDelay(value);
    });
    // Measured only when page is hidden / unloaded
    (0, $66CK0.getCLS)((_ref6)=>{
        let { value: value } = _ref6;
        return (0, $fUOHe.default).cumulativeLayoutShift(value);
    });
    if ('Promise' in window && 'PerformanceObserver' in window && 'PerformanceLongTaskTiming' in window && 'PerformancePaintTiming' in window && emceeContainer) $d8b41da213a14334$var$waitForTimeToInteractive(emceeContainer).then((tti)=>{
        (0, $fUOHe.default).timeToInteractive(tti);
        const requestTransferTimes = $d8b41da213a14334$var$getNetworkRequestTimes([
            /marketplace.*atlassian.com/,
            /atlastunnel.com/,
            /algolianet.com/
        ], []);
        requestTransferTimes.forEach((requestGroup)=>(0, $fUOHe.default).resourceDownloadTime(requestGroup.type, requestGroup.duration));
    }).catch(console.error.bind(console));
};

});
parcelRegister("d4c1w", function(module, exports) {

$parcel$export(module.exports, "default", () => $9834f9b7a60e91df$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $6bWmm = parcelRequire("6bWmm");
function $9834f9b7a60e91df$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $9834f9b7a60e91df$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $9834f9b7a60e91df$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $9834f9b7a60e91df$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $9834f9b7a60e91df$var$createListener = (_ref)=>{
    let { enabled: enabled } = _ref;
    return (event, getContext)=>{
        if (!enabled) return;
        const logEvent = (title)=>{
            console.groupCollapsed("%c Fired telemetry event: ".concat(title), 'color: teal');
            Object.entries($9834f9b7a60e91df$var$_objectSpread($9834f9b7a60e91df$var$_objectSpread({}, event), getContext())).sort((entryA, entryB)=>entryA[0].localeCompare(entryB[0])).forEach((entry)=>console.log(entry[0], ':', entry[1]));
            console.groupEnd();
        };
        switch(event.type){
            case (0, $6bWmm.Events).LABEL_PAGE_VIEW_TASK:
            case (0, $6bWmm.Events).LABEL_GENERIC_TASK:
                logEvent([
                    event.task,
                    event.taskId
                ].filter((t)=>!!t).join(','));
                break;
            default:
                logEvent(event.type);
        }
    };
};
var $9834f9b7a60e91df$export$2e2bcd8739ae039 = $9834f9b7a60e91df$var$createListener;

});

parcelRegister("l4K9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $f57dc4de41818ecc$export$2e2bcd8739ae039);

var $5zQU9 = parcelRequire("5zQU9");

var $4mxnU = parcelRequire("4mxnU");
var $cn8fk = parcelRequire("cn8fk");

var $6bWmm = parcelRequire("6bWmm");

var $3V6tX = parcelRequire("3V6tX");
function $f57dc4de41818ecc$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $f57dc4de41818ecc$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $f57dc4de41818ecc$var$ownKeys(Object(t), !0).forEach(function(r) {
            (0, $5zQU9.default)(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $f57dc4de41818ecc$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
const $f57dc4de41818ecc$var$REQUEST_RESOURCE_TYPES = new Set([
    'fetch',
    'xmlhttprequest',
    'beacon',
    'other'
]);
/* disabling the (complexity, max-lines-per-function) rules since splitting this function is unlikely to improve the readability */ const $f57dc4de41818ecc$var$createListener = // eslint-disable-next-line complexity, max-lines-per-function
(metalClient)=>(event, getContext)=>{
        const context = getContext();
        const commonTags = {
            page: context.page,
            isInitial: context.isInitialRender,
            isActiveTab: !context.hasDocumentBeenHidden
        };
        switch(event.type){
            case (0, $6bWmm.Events).LABEL_FIRST_INPUT_DELAY:
                metalClient.metric.submit($f57dc4de41818ecc$var$_objectSpread({
                    name: (0, $4mxnU.catalog).performance.FIRST_INPUT_DELAY,
                    value: event.duration
                }, commonTags));
                break;
            case (0, $6bWmm.Events).LABEL_TIME_TO_FIRST_BYTE:
                metalClient.metric.submit($f57dc4de41818ecc$var$_objectSpread({
                    name: (0, $4mxnU.catalog).performance.TIME_TO_FIRST_BYTE,
                    value: event.duration
                }, commonTags));
                break;
            case (0, $6bWmm.Events).LABEL_TIME_TO_FIRST_CONTENTFUL_PAINT:
                metalClient.metric.submit($f57dc4de41818ecc$var$_objectSpread({
                    name: (0, $4mxnU.catalog).performance.FIRST_CONTENTFUL_PAINT,
                    value: event.duration
                }, commonTags));
                break;
            case (0, $6bWmm.Events).LABEL_TIME_TO_FIRST_MEANINGFUL_PAINT:
                metalClient.metric.submit($f57dc4de41818ecc$var$_objectSpread({
                    name: (0, $4mxnU.catalog).performance.FIRST_MEANINGFUL_PAINT,
                    value: event.endTime - context.pageNavigationStart
                }, commonTags));
                break;
            case (0, $6bWmm.Events).LABEL_TIME_TO_INTERACTIVE:
                metalClient.metric.submit($f57dc4de41818ecc$var$_objectSpread({
                    name: (0, $4mxnU.catalog).performance.TIME_TO_INTERACTIVE,
                    value: event.duration
                }, commonTags));
                break;
            // Note: Metal does not directly support sending
            // of LCP, so we use report it as a task duration instead
            case (0, $6bWmm.Events).LABEL_TIME_TO_LARGEST_CONTENTFUL_PAINT:
                metalClient.metric.submit($f57dc4de41818ecc$var$_objectSpread({
                    name: (0, $4mxnU.catalog).userInteraction.TASK_DURATION,
                    task: (0, $6bWmm.Events).LABEL_TIME_TO_LARGEST_CONTENTFUL_PAINT,
                    value: event.duration
                }, commonTags));
                break;
            // Note: Metal does not directly support sending
            // of CLS, so we use report it as a task duration instead
            case (0, $6bWmm.Events).LABEL_CUMULATIVE_LAYOUT_SHIFT:
                metalClient.metric.submit($f57dc4de41818ecc$var$_objectSpread({
                    name: (0, $4mxnU.catalog).userInteraction.TASK_DURATION,
                    task: (0, $6bWmm.Events).LABEL_CUMULATIVE_LAYOUT_SHIFT,
                    value: event.shift
                }, commonTags));
                break;
            case (0, $6bWmm.Events).LABEL_RESOURCE_DOWNLOAD_TIME_SUM:
                metalClient.metric.submit($f57dc4de41818ecc$var$_objectSpread({
                    name: $f57dc4de41818ecc$var$REQUEST_RESOURCE_TYPES.has(event.resourceType) ? (0, $4mxnU.catalog).performance.REQUEST_TIMING : (0, $4mxnU.catalog).performance.RESOURCE_TIMING,
                    type: event.resourceType,
                    value: event.duration
                }, commonTags));
                break;
            case (0, $6bWmm.Events).LABEL_PAGE_VIEW_TASK:
            case (0, $6bWmm.Events).LABEL_GENERIC_TASK:
                if ((0, $3V6tX.isIgnorableGenericTaskSLOEvent)(event)) break;
                metalClient.metric.submit($f57dc4de41818ecc$var$_objectSpread({
                    name: event.successful ? (0, $4mxnU.catalog).userInteraction.TASK_SUCCESS : (0, $4mxnU.catalog).userInteraction.TASK_FAILURE,
                    task: event.task,
                    taskId: event.taskId,
                    value: 1
                }, commonTags));
                metalClient.metric.submit($f57dc4de41818ecc$var$_objectSpread({
                    name: (0, $4mxnU.catalog).userInteraction.TASK_DURATION,
                    task: event.task,
                    taskId: event.taskId,
                    value: event.duration
                }, commonTags));
                break;
            // TODO: Remove this once we start to measure these
            // using more generic task events
            case (0, $6bWmm.Events).LABEL_ALGOLIA_SEARCH_TIMING:
                metalClient.metric.submit($f57dc4de41818ecc$var$_objectSpread({
                    name: (0, $4mxnU.catalog).userInteraction.TASK_DURATION,
                    task: (0, $6bWmm.Events).LABEL_ALGOLIA_SEARCH_TIMING,
                    value: event.duration
                }, commonTags));
                break;
            case (0, $6bWmm.Events).LABEL_COMPONENT_ERROR_BOUNDARY:
                return metalClient.error.submit($f57dc4de41818ecc$var$_objectSpread($f57dc4de41818ecc$var$_objectSpread({}, commonTags), {}, {
                    name: (0, $4mxnU.catalog).error.COMPONENT_BOUNDARY,
                    component: event.componentName
                }));
        }
    };
const $f57dc4de41818ecc$var$metalBackend = (metalConfig)=>{
    var _metalConfig$subProdu;
    const productInfo = {
        metalId: metalConfig.id,
        version: metalConfig.version,
        env: metalConfig.env
    };
    const settings = {
        meta: {
            subproduct: (_metalConfig$subProdu = metalConfig.subProduct) === null || _metalConfig$subProdu === void 0 ? void 0 : _metalConfig$subProdu.toLowerCase(),
            synthetic: metalConfig.synthetic
        },
        metrics: {
            sampleRate: 1,
            maxBufferSize: 20,
            flushInterval: metalConfig.flushInteval || 3000
        }
    };
    const metalClient = new (0, $cn8fk.default)({
        productInfo: productInfo,
        settings: settings
    });
    return $f57dc4de41818ecc$var$createListener(metalClient);
};
var $f57dc4de41818ecc$export$2e2bcd8739ae039 = $f57dc4de41818ecc$var$metalBackend;

});
parcelRegister("4mxnU", function(module, exports) {

$parcel$export(module.exports, "catalog", () => $32d31cfbcc4359e5$export$b42865bafc072eab);

var $hulbh = parcelRequire("hulbh");
var $32d31cfbcc4359e5$export$b42865bafc072eab = {
    error: (0, $hulbh.ErrorMetricName),
    performance: (0, $hulbh.PerformanceMetricName),
    userInteraction: (0, $hulbh.UserInteractionMetricName)
};

});
parcelRegister("hulbh", function(module, exports) {

$parcel$export(module.exports, "ErrorMetricName", () => $cbb5ab13e57b8c69$export$6b0bf32d577cea1d);
$parcel$export(module.exports, "PerformanceMetricName", () => $cbb5ab13e57b8c69$export$fbc4403eaefe0e15);
$parcel$export(module.exports, "UserInteractionMetricName", () => $cbb5ab13e57b8c69$export$856052a067eed71b);
var $cbb5ab13e57b8c69$export$6b0bf32d577cea1d;
(function(ErrorMetricName) {
    /** Page level */ ErrorMetricName["UNCAUGHT"] = "fe.error.uncaught";
    ErrorMetricName["REQUEST"] = "fe.error.request";
    ErrorMetricName["API"] = "fe.error.api";
    ErrorMetricName["GRAPHQL"] = "fe.error.graphql";
    ErrorMetricName["VALIDATION"] = "fe.error.validation";
    ErrorMetricName["INPUT"] = "fe.error.input";
    ErrorMetricName["UNHANDLED_PROMISE_REJECTION"] = "fe.error.unhandledrejection";
    /** Component level */ ErrorMetricName["COMPONENT"] = "fe.error.component";
    ErrorMetricName["COMPONENT_BOUNDARY"] = "fe.error.component.boundary";
    ErrorMetricName["COMPONENT_GRAPHQL"] = "fe.error.component.graphql";
    ErrorMetricName["COMPONENT_API"] = "fe.error.component.api";
})($cbb5ab13e57b8c69$export$6b0bf32d577cea1d || ($cbb5ab13e57b8c69$export$6b0bf32d577cea1d = {}));
var $cbb5ab13e57b8c69$export$fbc4403eaefe0e15;
(function(PerformanceMetricName) {
    /** Page level */ PerformanceMetricName["APDEX"] = "fe.perf.apdex";
    PerformanceMetricName["SPEED_INDEX"] = "fe.perf.speedindex";
    PerformanceMetricName["TIME_TO_INTERACTIVE"] = "fe.perf.time_to_interactive";
    PerformanceMetricName["TIME_TO_INTERACTIVE_SLO"] = "fe.perf.time_to_interactive.slo";
    PerformanceMetricName["TIME_TO_FIRST_BYTE"] = "fe.perf.time_to_first_byte";
    PerformanceMetricName["FIRST_PAINT"] = "fe.perf.first_paint";
    PerformanceMetricName["FIRST_CONTENTFUL_PAINT"] = "fe.perf.first_contentful_paint";
    PerformanceMetricName["FIRST_MEANINGFUL_PAINT"] = "fe.perf.first_meaningful_paint";
    PerformanceMetricName["FIRST_MEANINGFUL_PAINT_SLO"] = "fe.perf.first_meaningful_paint.slo";
    PerformanceMetricName["FIRST_INPUT_DELAY"] = "fe.perf.first_input_delay";
    PerformanceMetricName["REQUEST_TIMING"] = "fe.perf.request_timing";
    PerformanceMetricName["REQUEST_TIMING_SLO"] = "fe.perf.request_timing.slo";
    PerformanceMetricName["RESOURCE_TIMING"] = "fe.perf.resource_timing";
    PerformanceMetricName["CACHE_HITS"] = "fe.perf.cache_hits";
    /** Component level */ PerformanceMetricName["COMPONENT_PREVIEW"] = "fe.perf.component.time_to_preview";
    PerformanceMetricName["COMPONENT_INTERACTIVE"] = "fe.perf.component.time_to_interactive";
    PerformanceMetricName["COMPONENT_READY"] = "fe.perf.component.time_to_ready";
    PerformanceMetricName["COMPONENT_READY_SLO"] = "fe.perf.component.time_to_ready.slo";
    PerformanceMetricName["COMPONENT_REQUEST_TIMING"] = "fe.perf.component.request_timing";
})($cbb5ab13e57b8c69$export$fbc4403eaefe0e15 || ($cbb5ab13e57b8c69$export$fbc4403eaefe0e15 = {}));
var $cbb5ab13e57b8c69$export$856052a067eed71b;
(function(UserInteractionMetricName) {
    UserInteractionMetricName["TASK_SUCCESS"] = "fe.user.task.success";
    UserInteractionMetricName["TASK_FAILURE"] = "fe.user.task.failure";
    UserInteractionMetricName["TASK_DURATION"] = "fe.user.task.duration";
    UserInteractionMetricName["TASK_TIME_TO_FEEDBACK"] = "fe.user.task.time_to_feedback";
    UserInteractionMetricName["TASK_TIME_TO_FEEDBACK_SLO"] = "fe.user.task.time_to_feedback.slo";
    UserInteractionMetricName["TASK_TIME_TO_COMPLETE"] = "fe.user.task.time_to_complete";
    UserInteractionMetricName["TASK_TIME_TO_COMPLETE_SLO"] = "fe.user.task.time_to_complete.slo";
})($cbb5ab13e57b8c69$export$856052a067eed71b || ($cbb5ab13e57b8c69$export$856052a067eed71b = {}));

});


parcelRegister("cn8fk", function(module, exports) {

$parcel$export(module.exports, "default", () => $901e079008fe1263$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $2vzCR = parcelRequire("2vzCR");

var $jPyA3 = parcelRequire("jPyA3");

var $j4bCr = parcelRequire("j4bCr");

var $3QDdw = parcelRequire("3QDdw");

var $hHgJZ = parcelRequire("hHgJZ");

var $laIsC = parcelRequire("laIsC");

var $eiRXx = parcelRequire("eiRXx");

var $cJKi6 = parcelRequire("cJKi6");

var $hO1PY = parcelRequire("hO1PY");

var $ej2zW = parcelRequire("ej2zW");

var $991KK = parcelRequire("991KK");

var $ePwZC = parcelRequire("ePwZC");


var $901e079008fe1263$var$defaultSettings = {
    getPage: function() {
        return '';
    },
    metrics: {
        flushInterval: 1000,
        maxBufferSize: 10,
        sampleRate: 1,
        bufferType: (0, $hO1PY.CoreType).METRIC
    }
};
var $901e079008fe1263$var$MetalClient = /** @class */ function() {
    function MetalClient(_a) {
        var _this = this;
        var productInfo = _a.productInfo, _b = _a.settings, settings = _b === void 0 ? $901e079008fe1263$var$defaultSettings : _b, _c = _a.plugins, plugins = _c === void 0 ? [] : _c, _d = _a.forceXHR, forceXHR = _d === void 0 ? false : _d;
        /**
         * Internal hooks being used by Metal and responding to certain MetalEvents
         */ this.hooks = (0, $ePwZC.getDefaultHooks)();
        (0, $ePwZC.validateProductInfo)(productInfo);
        var mergedSettings = (0, (/*@__PURE__*/$parcel$interopDefault($2vzCR)))($901e079008fe1263$var$defaultSettings, settings, {
            metrics: {
                meta: settings.meta
            }
        });
        this.productInfo = productInfo;
        var version = productInfo.version, metalId = productInfo.metalId, env = productInfo.env;
        this.meta = (0, $fKE23.__assign)((0, $fKE23.__assign)((0, $fKE23.__assign)({}, settings.meta), {
            version: version,
            env: env
        }), (0, $laIsC.default)());
        this.sender = new (0, $jPyA3.default)({
            url: (0, $991KK.default).api[env],
            metalId: metalId,
            meta: this.meta,
            synthetic: settings.synthetic,
            forceXHR: forceXHR
        });
        this.pageVisibility = new (0, $eiRXx.default)();
        this.pageTracker = new (0, $cJKi6.default)(mergedSettings.getPage);
        // create the unified hook
        var hook = this.onSend.bind(this);
        this.metric = new (0, $j4bCr.default)({
            sender: this.sender,
            settings: mergedSettings.metrics,
            hook: hook,
            pageVisibility: this.pageVisibility
        });
        this.error = new (0, $3QDdw.default)({
            hook: hook
        });
        this.updateSettings = this.updateSettings.bind(this);
        /**
         * Plugins are installed if an array is passed to Metal,
         * else by default we instantiate the default set of plugins.
         */ var defaultPlugins = [
            new (0, $hHgJZ.default)()
        ];
        this.plugins = (0, $fKE23.__spread)(defaultPlugins, plugins);
        this.plugins.forEach(function(plugin) {
            return plugin.install(_this);
        });
    }
    /**
     * Merges an object of new settings with the current settings.
     * @param newSettings The new settings object
     */ MetalClient.prototype.updateSettings = function(newSettings) {
        if (newSettings.meta) {
            this.meta = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.meta), newSettings.meta);
            this.sender.updateMeta(this.meta);
        }
        if (newSettings.metrics) this.metric.updateSettings(newSettings.metrics);
    };
    Object.defineProperty(MetalClient.prototype, "initialPage", {
        get: function() {
            return this.pageTracker.initialPage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MetalClient.prototype, "currentPage", {
        get: function() {
            return this.pageTracker.page;
        },
        enumerable: false,
        configurable: true
    });
    // public interface to add a hook
    MetalClient.prototype.addEventHook = function(type, callback) {
        if (!(0, $ej2zW.isType)((0, $hO1PY.CoreType), type)) throw new Error("Invalid hook, must be a CoreType [" + (0, $ej2zW.objectValues)((0, $hO1PY.CoreType)) + "]");
        this.hooks[type].push(callback);
    };
    MetalClient.prototype.destroy = function() {
        // Destroy plugins
        this.plugins.forEach(function(plugin) {
            return plugin.destroy && plugin.destroy();
        });
    };
    // internal hook
    MetalClient.prototype.onSend = function(_a) {
        var _this = this;
        var type = _a.type, data = _a.data;
        this.hooks[type].forEach(function(callback) {
            return callback(data, _this.meta);
        });
    };
    return MetalClient;
}();
var $901e079008fe1263$export$2e2bcd8739ae039 = $901e079008fe1263$var$MetalClient;

});
parcelRegister("jPyA3", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6fd9ab9978facb6$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $ej2zW = parcelRequire("ej2zW");

var $4wBHG = parcelRequire("4wBHG");

var $ju3TI = parcelRequire("ju3TI");
var $e6fd9ab9978facb6$var$promisifiedBeacon = function(url, blob) {
    return new Promise(function(resolve, reject) {
        try {
            var status_1 = navigator.sendBeacon(url, blob);
            if (status_1) resolve(status_1);
            else reject(status_1);
        } catch (e) {
            console.warn('MetalSender: sendBeacon failure');
        }
    });
};
var $e6fd9ab9978facb6$var$promisifiedXHR = function(url, body) {
    return new Promise(function(resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', url);
        xhr.setRequestHeader('Content-Type', 'text/plain');
        xhr.send(body);
        xhr.onerror = reject;
        xhr.onload = resolve;
        xhr.ontimeout = resolve;
    });
};
/**
 * Responsible for sending metric, log.. etc payloads
 * Configured by MetalClient directly
 */ var $e6fd9ab9978facb6$var$Sender = /** @class */ function() {
    function Sender(_a) {
        var url = _a.url, meta = _a.meta, metalId = _a.metalId, synthetic = _a.synthetic, _b = _a.forceXHR, forceXHR = _b === void 0 ? false : _b;
        /**
         * Time between network retries
         */ this.retryInterval = 30000;
        /**
         * buffer to hold things that fail due to network connectivity
         */ this.buffer = [];
        /**
         * Favor using XHR over Beacon API
         */ this.forceXHR = false;
        this.url = url;
        this.meta = meta;
        this.metalId = metalId;
        this.forceXHR = forceXHR;
        this.network = new (0, $ju3TI.default)({
            onOnlineCallback: this.restartSending.bind(this)
        });
        this.sendData = this.sendData.bind(this);
        this.synthetic = synthetic;
    }
    Sender.prototype.updateMeta = function(meta) {
        this.meta = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.meta), meta);
    };
    Sender.prototype.restartSending = function() {
        var _this = this;
        this.buffer.forEach(function(payload) {
            return _this.sendData(payload);
        });
        this.buffer = [];
    };
    Sender.prototype.sendBeacon = function(blob) {
        return $e6fd9ab9978facb6$var$promisifiedBeacon(this.url, blob);
    };
    Sender.prototype.sendXHR = function(type, data, retries) {
        var _this = this;
        if (retries === void 0) retries = 1;
        return $e6fd9ab9978facb6$var$promisifiedXHR(this.url, data).catch(function() {
            if (retries < 3) {
                var retryIn = retries * _this.retryInterval;
                console.warn("MetalSender: Receiver not responding, will retry in " + Math.floor(retryIn / 1000) + "s");
                setTimeout(function() {
                    return _this.sendXHR(type, data, retries + 1);
                }, retryIn);
            } else console.warn("MetalSender: Max retries reached, payload (" + type + ") failed to send");
        });
    };
    Sender.prototype.sendData = function(_a) {
        var type = _a.type, data = _a.data;
        if (this.network.status === (0, $4wBHG.NetworkStatus).OFFLINE) {
            this.buffer.push({
                type: type,
                data: data
            });
            return Promise.resolve(null);
        }
        var metalId = this.metalId;
        var meta = (0, $ej2zW.objectValuesToString)(this.meta);
        var body = (0, $fKE23.__assign)({
            type: type,
            meta: meta,
            metalId: metalId,
            data: data
        }, this.synthetic !== undefined ? {
            synthetic: String(this.synthetic)
        } : {});
        if (!navigator.sendBeacon || this.forceXHR) return this.sendXHR(type, JSON.stringify(body));
        var headers = {
            type: 'application/json'
        };
        var blob = new Blob([
            JSON.stringify(body)
        ], headers);
        return this.sendBeacon(blob);
    };
    /**
     * This is the public facing API for the sender; although this function
     * is intended for internal consumption by the MetalCore Classes.
     *
     * @param buffer {T[]}    An array of payload body type
     * @param type   {T}      A type of MetalCore eg, 'log', 'metric', etc...
     * @param meta   {object} Any additional meta info for this payload (global meta info)
     */ Sender.prototype.send = function(buffer, type) {
        if (buffer === void 0) buffer = [];
        if (buffer.length < 1) return;
        this.sendData({
            type: type,
            data: buffer
        }).catch(function(e) {
            // Catch rejection or any potential exceptions surfaced from promise.
            // e.g. Safari AdBlock is blocking access to metal and incurs a
            // promise rejection in promisifiedBeacon
            console.warn('MetalSender: sendData failure:', e);
        });
    };
    return Sender;
}();
var $e6fd9ab9978facb6$export$2e2bcd8739ae039 = $e6fd9ab9978facb6$var$Sender;

});
parcelRegister("ej2zW", function(module, exports) {

$parcel$export(module.exports, "objectKeys", () => $a6a4d716fd8fe6e7$export$259b4dd69e654a7a);
$parcel$export(module.exports, "objectValues", () => $a6a4d716fd8fe6e7$export$ad1854f4a08c15f8);
$parcel$export(module.exports, "objectValuesToString", () => $a6a4d716fd8fe6e7$export$fbac6108fb7c1c58);
$parcel$export(module.exports, "isType", () => $a6a4d716fd8fe6e7$export$26b9f946b448f23e);
$parcel$export(module.exports, "hasKey", () => $a6a4d716fd8fe6e7$export$94df19ecb868bc1a);

var $czx3b = parcelRequire("czx3b");
var $a6a4d716fd8fe6e7$export$259b4dd69e654a7a = function(object) {
    return Object.keys(object);
};
var $a6a4d716fd8fe6e7$export$ad1854f4a08c15f8 = function(object) {
    return $a6a4d716fd8fe6e7$export$259b4dd69e654a7a(object).map(function(key) {
        return object[key];
    });
};
var $a6a4d716fd8fe6e7$export$fbac6108fb7c1c58 = function(object) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($czx3b)))(object, function(value) {
        return String(value);
    });
};
var $a6a4d716fd8fe6e7$export$26b9f946b448f23e = function(type, value) {
    return $a6a4d716fd8fe6e7$export$ad1854f4a08c15f8(type).indexOf(value) > -1;
};
var $a6a4d716fd8fe6e7$export$94df19ecb868bc1a = function(type, value) {
    return $a6a4d716fd8fe6e7$export$259b4dd69e654a7a(type).indexOf(value) > -1;
};

});
parcelRegister("czx3b", function(module, exports) {

var $3pSMu = parcelRequire("3pSMu");

var $piimr = parcelRequire("piimr");

var $7qARj = parcelRequire("7qARj");
/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */ function $9272640aa667e27d$var$mapValues(object, iteratee) {
    var result = {};
    iteratee = $7qARj(iteratee, 3);
    $piimr(object, function(value, key, object) {
        $3pSMu(result, key, iteratee(value, key, object));
    });
    return result;
}
module.exports = $9272640aa667e27d$var$mapValues;

});


parcelRegister("4wBHG", function(module, exports) {

$parcel$export(module.exports, "NetworkStatus", () => $34b765b87f972a16$export$bd096ddbd246c79c);
var $34b765b87f972a16$export$bd096ddbd246c79c;
(function(NetworkStatus) {
    NetworkStatus[NetworkStatus["OFFLINE"] = 0] = "OFFLINE";
    NetworkStatus[NetworkStatus["ONLINE"] = 1] = "ONLINE";
})($34b765b87f972a16$export$bd096ddbd246c79c || ($34b765b87f972a16$export$bd096ddbd246c79c = {}));

});

parcelRegister("ju3TI", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2f3d7aa92c32525$export$2e2bcd8739ae039);

var $4wBHG = parcelRequire("4wBHG");
var $e2f3d7aa92c32525$var$Network = /** @class */ function() {
    function Network(_a) {
        var _this = this;
        var onOnlineCallback = _a.onOnlineCallback;
        this.networkStatus = (0, $4wBHG.NetworkStatus).ONLINE;
        window.addEventListener('offline', function() {
            _this.networkStatus = (0, $4wBHG.NetworkStatus).OFFLINE;
        });
        window.addEventListener('online', function() {
            _this.networkStatus = (0, $4wBHG.NetworkStatus).ONLINE;
            onOnlineCallback();
        });
    }
    Object.defineProperty(Network.prototype, "status", {
        get: function() {
            // if ('onLine' in navigator) {
            //   return navigator.onLine ? NetworkStatus.ONLINE : NetworkStatus.OFFLINE;
            // }
            return this.networkStatus;
        },
        enumerable: false,
        configurable: true
    });
    return Network;
}();
var $e2f3d7aa92c32525$export$2e2bcd8739ae039 = $e2f3d7aa92c32525$var$Network;

});


parcelRegister("j4bCr", function(module, exports) {

$parcel$export(module.exports, "default", () => $de1767585c42dcdd$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $5kYaZ = parcelRequire("5kYaZ");

var $dy74A = parcelRequire("dy74A");

var $hO1PY = parcelRequire("hO1PY");

var $ej2zW = parcelRequire("ej2zW");

var $a5JuA = parcelRequire("a5JuA");

var $kKafq = parcelRequire("kKafq");
var $de1767585c42dcdd$var$defaultSettings = {
    sampleRate: 1,
    maxBufferSize: 10,
    flushInterval: 1000
};
/**
 * Used by MetalClient to send Metrics
 *
 * Can be instantiated seperatedly if you also provide an instance of MetalSender.
 * Includes the following public methods.
 *
 * @method increment
 * @method decrement
 * @method timing
 * @method gauge
 *
 * @see Sender
 * @see MetalClient
 */ var $de1767585c42dcdd$var$assertHasValue = function(metric) {
    if (metric.value === undefined) throw new Error("Missing value for metric " + metric.name);
    if (typeof metric.value !== 'number') throw new Error("Value for metric " + metric.name + " is of type " + typeof metric.value + " and not a number");
};
// Note: we are allowing values of 0 to be submitted
// Reference: https://github.com/brightcove/hot-shots/blob/master/lib/statsFunctions.js#L110
var $de1767585c42dcdd$var$valueOrDefault = function(metric, defaultValue) {
    return metric.value === undefined || typeof metric.value !== 'number' ? defaultValue : metric.value;
};
var $de1767585c42dcdd$var$MetricModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(MetricModel, _super);
    function MetricModel(_a) {
        var sender = _a.sender, _b = _a.settings, settings = _b === void 0 ? $de1767585c42dcdd$var$defaultSettings : _b, hook = _a.hook, pageVisibility = _a.pageVisibility;
        var _this = _super.call(this, {
            hook: hook
        }) || this;
        _this.sampleRate = settings.sampleRate;
        _this.queue = new (0, $dy74A.default)(settings, sender.send.bind(sender));
        _this.pageVisibility = pageVisibility;
        return _this;
    }
    MetricModel.prototype.updateSettings = function(newSettings) {
        this.queue.updateSettings(newSettings);
    };
    MetricModel.prototype.increment = function(metric) {
        metric.value = $de1767585c42dcdd$var$valueOrDefault(metric, 1);
        this.queue.enqueue(this.constructMetric(metric, (0, $kKafq.PayloadType).INCREMENT));
    };
    MetricModel.prototype.decrement = function(metric) {
        metric.value = $de1767585c42dcdd$var$valueOrDefault(metric, -1);
        this.queue.enqueue(this.constructMetric(metric, (0, $kKafq.PayloadType).DECREMENT));
    };
    MetricModel.prototype.timing = function(metric) {
        $de1767585c42dcdd$var$assertHasValue(metric);
        this.queue.enqueue(this.constructMetric(metric, (0, $kKafq.PayloadType).TIMING));
    };
    MetricModel.prototype.gauge = function(metric) {
        $de1767585c42dcdd$var$assertHasValue(metric);
        this.queue.enqueue(this.constructMetric(metric, (0, $kKafq.PayloadType).GAUGE));
    };
    /**
     * Called by user directly as a manual entrypoint
     *
     * @param {UserMetric} metric The metadata required to send a configured metric
     */ MetricModel.prototype.submit = function(metric) {
        if (!(0, $ej2zW.hasKey)((0, $a5JuA.allowedMetricTypeMap), metric.name)) throw new Error('Invalid Metric provided to Metal');
        var tags = [];
        (0, $ej2zW.objectKeys)((0, $a5JuA.allowedTagsMap)).forEach(function(key) {
            if ((0, $ej2zW.hasKey)(metric, key)) {
                var metricObj = metric;
                if (key === 'histogramBuckets') {
                    var isBucketFormatRegex = /^([\d+]_?)*\d+$/;
                    if (metric.histogramBuckets && !isBucketFormatRegex.test(metric.histogramBuckets) || !metric.histogramBuckets) throw new Error('Invalid Metric value: histogramBuckets');
                }
                tags.push((0, $a5JuA.allowedTagsMap)[key] + ":" + metricObj[key]);
            }
        });
        var required = (0, $a5JuA.metricAttributeRequirementsMap)[metric.name].required;
        required.forEach(function(key) {
            if (!(0, $ej2zW.hasKey)(metric, key)) throw new Error("Required metric attribute " + key + " is missing");
        });
        var name = metric.name, value = metric.value;
        var method = (0, $a5JuA.allowedMetricTypeMap)[name];
        this[method]({
            name: name,
            value: value,
            tags: tags
        });
    };
    MetricModel.prototype.constructMetric = function(_a, type) {
        var name = _a.name, value = _a.value, _b = _a.tags, tags = _b === void 0 ? [] : _b;
        var data = {
            type: type,
            name: name,
            tags: tags,
            value: value,
            sampleRate: this.sampleRate
        };
        // hook call to MetalClient callbacks
        this.hook({
            type: (0, $hO1PY.CoreType).METRIC,
            data: data
        });
        return data;
    };
    return MetricModel;
}((0, $5kYaZ.default));
var $de1767585c42dcdd$export$2e2bcd8739ae039 = $de1767585c42dcdd$var$MetricModel;

});
parcelRegister("5kYaZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e2d7fbfce7218c5$export$2e2bcd8739ae039);

var $3e2d7fbfce7218c5$var$Hookable = /** @class */ function() {
    function Hookable(_a) {
        var hook = _a.hook;
        this.hook = hook;
    }
    return Hookable;
}();
var $3e2d7fbfce7218c5$export$2e2bcd8739ae039 = $3e2d7fbfce7218c5$var$Hookable;

});

parcelRegister("dy74A", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dd3efe16996a0cb$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");
var $9dd3efe16996a0cb$var$Queue = /** @class */ function() {
    function Queue(settings, callback) {
        var _this = this;
        this.buffer = [];
        this.settings = settings;
        this.callback = callback;
        this.intervalHandle = setInterval(this.flush.bind(this), this.settings.flushInterval);
        window.addEventListener('beforeunload', function() {
            if (_this.intervalHandle) clearInterval(_this.intervalHandle);
        });
    }
    Queue.prototype.flush = function() {
        this.callback(this.buffer, this.settings.bufferType);
        // TODO: there is potential data loss here if the send call fails
        // FIX ME Probably handle in sender tho.
        this.buffer = [];
    };
    Queue.prototype.enqueue = function(payload) {
        this.buffer.push(payload);
        var maxBufferSize = this.settings.maxBufferSize;
        if (maxBufferSize > 0 && this.buffer.length >= maxBufferSize) this.flush();
    };
    Queue.prototype.updateSettings = function(newSettings) {
        this.settings = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, this.settings), newSettings);
        if (newSettings.flushInterval) {
            clearInterval(this.intervalHandle);
            this.intervalHandle = setInterval(this.flush.bind(this), newSettings.flushInterval);
        }
    };
    return Queue;
}();
var $9dd3efe16996a0cb$export$2e2bcd8739ae039 = $9dd3efe16996a0cb$var$Queue;

});

parcelRegister("hO1PY", function(module, exports) {

$parcel$export(module.exports, "CoreType", () => $cf6888065c950b25$export$6b816263e18b80f1);
/**
 * Parts of the MetalCore
 */ 

var $cf6888065c950b25$export$6b816263e18b80f1;
(function(CoreType) {
    CoreType["METRIC"] = "metric";
    CoreType["ERROR"] = "error";
})($cf6888065c950b25$export$6b816263e18b80f1 || ($cf6888065c950b25$export$6b816263e18b80f1 = {}));

});

parcelRegister("a5JuA", function(module, exports) {

$parcel$export(module.exports, "allowedMetricTypeMap", () => $758da8d98f5b5543$export$51f1d0967a29b999);
$parcel$export(module.exports, "allowedTagsMap", () => $758da8d98f5b5543$export$6bb99562353b405);
$parcel$export(module.exports, "metricAttributeRequirementsMap", () => $758da8d98f5b5543$export$476fa67b19c4e3b3);

var $fKE23 = parcelRequire("fKE23");

var $hulbh = parcelRequire("hulbh");

var $kKafq = parcelRequire("kKafq");
var $758da8d98f5b5543$var$_a, $758da8d98f5b5543$var$_b;
var $758da8d98f5b5543$export$51f1d0967a29b999 = ($758da8d98f5b5543$var$_a = {}, $758da8d98f5b5543$var$_a[(0, $hulbh.ErrorMetricName).UNCAUGHT] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.ErrorMetricName).REQUEST] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.ErrorMetricName).API] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.ErrorMetricName).GRAPHQL] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.ErrorMetricName).VALIDATION] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.ErrorMetricName).INPUT] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.ErrorMetricName).UNHANDLED_PROMISE_REJECTION] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.ErrorMetricName).COMPONENT] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.ErrorMetricName).COMPONENT_BOUNDARY] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.ErrorMetricName).COMPONENT_GRAPHQL] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.ErrorMetricName).COMPONENT_API] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).APDEX] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).SPEED_INDEX] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).TIME_TO_INTERACTIVE] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).TIME_TO_INTERACTIVE_SLO] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).TIME_TO_FIRST_BYTE] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).FIRST_PAINT] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).FIRST_CONTENTFUL_PAINT] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).FIRST_MEANINGFUL_PAINT] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).FIRST_MEANINGFUL_PAINT_SLO] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).FIRST_INPUT_DELAY] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).REQUEST_TIMING] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).REQUEST_TIMING_SLO] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).RESOURCE_TIMING] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).CACHE_HITS] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).COMPONENT_PREVIEW] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).COMPONENT_INTERACTIVE] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).COMPONENT_READY] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).COMPONENT_READY_SLO] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.PerformanceMetricName).COMPONENT_REQUEST_TIMING] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.UserInteractionMetricName).TASK_SUCCESS] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.UserInteractionMetricName).TASK_FAILURE] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.UserInteractionMetricName).TASK_DURATION] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.UserInteractionMetricName).TASK_TIME_TO_FEEDBACK] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.UserInteractionMetricName).TASK_TIME_TO_FEEDBACK_SLO] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a[(0, $hulbh.UserInteractionMetricName).TASK_TIME_TO_COMPLETE] = (0, $kKafq.PayloadType).TIMING, $758da8d98f5b5543$var$_a[(0, $hulbh.UserInteractionMetricName).TASK_TIME_TO_COMPLETE_SLO] = (0, $kKafq.PayloadType).INCREMENT, $758da8d98f5b5543$var$_a);
var $758da8d98f5b5543$export$6bb99562353b405 = {
    component: 'component',
    isActiveTab: 'active_tab',
    isInitial: 'initial_load',
    isSSR: 'ssr',
    page: 'page',
    success: 'success',
    task: 'task',
    taskId: 'task_id',
    type: 'type',
    histogramBuckets: 'gsd_histogram'
};
var $758da8d98f5b5543$var$alwaysRequired = [
    'page'
];
var $758da8d98f5b5543$var$alwaysOptional = [
    'isSSR',
    'isActiveTab'
];
var $758da8d98f5b5543$var$timersAlwaysOptional = [
    'histogramBuckets'
];
var $758da8d98f5b5543$var$defaultRequirements = {
    required: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysRequired),
    optional: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysOptional)
};
var $758da8d98f5b5543$var$defaultPerfRequirements = {
    required: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysRequired),
    optional: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysOptional, $758da8d98f5b5543$var$timersAlwaysOptional)
};
var $758da8d98f5b5543$var$defaultSLORequirements = {
    required: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysRequired, [
        'success'
    ]),
    optional: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysOptional)
};
var $758da8d98f5b5543$var$defaultComponentRequirements = {
    required: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysRequired, [
        'component'
    ]),
    optional: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysOptional)
};
var $758da8d98f5b5543$var$defaultComponentPerfRequirements = {
    required: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysRequired, [
        'component'
    ]),
    optional: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysOptional, $758da8d98f5b5543$var$timersAlwaysOptional)
};
var $758da8d98f5b5543$var$defaultTaskRequirements = {
    required: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysRequired, [
        'task'
    ]),
    optional: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysOptional, [
        'taskId'
    ])
};
var $758da8d98f5b5543$var$defaultTaskPerfRequirements = {
    required: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysRequired, [
        'task'
    ]),
    optional: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysOptional, $758da8d98f5b5543$var$timersAlwaysOptional, [
        'taskId'
    ])
};
var $758da8d98f5b5543$export$476fa67b19c4e3b3 = ($758da8d98f5b5543$var$_b = {}, // Errors
$758da8d98f5b5543$var$_b[(0, $hulbh.ErrorMetricName).UNCAUGHT] = $758da8d98f5b5543$var$defaultRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.ErrorMetricName).REQUEST] = $758da8d98f5b5543$var$defaultRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.ErrorMetricName).API] = $758da8d98f5b5543$var$defaultRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.ErrorMetricName).GRAPHQL] = $758da8d98f5b5543$var$defaultRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.ErrorMetricName).VALIDATION] = $758da8d98f5b5543$var$defaultRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.ErrorMetricName).INPUT] = $758da8d98f5b5543$var$defaultRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.ErrorMetricName).UNHANDLED_PROMISE_REJECTION] = $758da8d98f5b5543$var$defaultRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.ErrorMetricName).COMPONENT] = $758da8d98f5b5543$var$defaultComponentRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.ErrorMetricName).COMPONENT_BOUNDARY] = $758da8d98f5b5543$var$defaultComponentRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.ErrorMetricName).COMPONENT_GRAPHQL] = $758da8d98f5b5543$var$defaultComponentRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.ErrorMetricName).COMPONENT_API] = $758da8d98f5b5543$var$defaultComponentRequirements, // Page Performance
$758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).APDEX] = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $758da8d98f5b5543$var$defaultRequirements), {
    optional: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysOptional, $758da8d98f5b5543$var$timersAlwaysOptional, [
        'isInitial'
    ])
}), $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).SPEED_INDEX] = $758da8d98f5b5543$var$defaultPerfRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).TIME_TO_INTERACTIVE] = $758da8d98f5b5543$var$defaultPerfRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).TIME_TO_INTERACTIVE_SLO] = $758da8d98f5b5543$var$defaultSLORequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).TIME_TO_FIRST_BYTE] = $758da8d98f5b5543$var$defaultPerfRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).FIRST_PAINT] = $758da8d98f5b5543$var$defaultPerfRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).FIRST_CONTENTFUL_PAINT] = $758da8d98f5b5543$var$defaultPerfRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).FIRST_MEANINGFUL_PAINT] = $758da8d98f5b5543$var$defaultPerfRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).FIRST_MEANINGFUL_PAINT_SLO] = $758da8d98f5b5543$var$defaultSLORequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).FIRST_INPUT_DELAY] = $758da8d98f5b5543$var$defaultPerfRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).REQUEST_TIMING] = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $758da8d98f5b5543$var$defaultPerfRequirements), {
    optional: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysOptional, $758da8d98f5b5543$var$timersAlwaysOptional, [
        'type'
    ])
}), $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).REQUEST_TIMING_SLO] = {
    required: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysRequired, [
        'success'
    ]),
    optional: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysOptional, [
        'type'
    ])
}, $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).RESOURCE_TIMING] = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $758da8d98f5b5543$var$defaultPerfRequirements), {
    optional: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysOptional, $758da8d98f5b5543$var$timersAlwaysOptional, [
        'type'
    ])
}), $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).CACHE_HITS] = $758da8d98f5b5543$var$defaultRequirements, // Component Performance
$758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).COMPONENT_PREVIEW] = $758da8d98f5b5543$var$defaultComponentPerfRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).COMPONENT_INTERACTIVE] = $758da8d98f5b5543$var$defaultComponentPerfRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).COMPONENT_REQUEST_TIMING] = $758da8d98f5b5543$var$defaultComponentPerfRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).COMPONENT_READY] = $758da8d98f5b5543$var$defaultComponentPerfRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.PerformanceMetricName).COMPONENT_READY_SLO] = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $758da8d98f5b5543$var$defaultRequirements), {
    required: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysRequired, [
        'component',
        'success'
    ])
}), // User Interaction (Tasks)
$758da8d98f5b5543$var$_b[(0, $hulbh.UserInteractionMetricName).TASK_SUCCESS] = $758da8d98f5b5543$var$defaultTaskRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.UserInteractionMetricName).TASK_FAILURE] = $758da8d98f5b5543$var$defaultTaskRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.UserInteractionMetricName).TASK_DURATION] = $758da8d98f5b5543$var$defaultTaskPerfRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.UserInteractionMetricName).TASK_TIME_TO_FEEDBACK] = $758da8d98f5b5543$var$defaultTaskPerfRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.UserInteractionMetricName).TASK_TIME_TO_FEEDBACK_SLO] = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $758da8d98f5b5543$var$defaultTaskRequirements), {
    required: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysRequired, [
        'task',
        'success'
    ])
}), $758da8d98f5b5543$var$_b[(0, $hulbh.UserInteractionMetricName).TASK_TIME_TO_COMPLETE] = $758da8d98f5b5543$var$defaultTaskPerfRequirements, $758da8d98f5b5543$var$_b[(0, $hulbh.UserInteractionMetricName).TASK_TIME_TO_COMPLETE_SLO] = (0, $fKE23.__assign)((0, $fKE23.__assign)({}, $758da8d98f5b5543$var$defaultTaskRequirements), {
    required: (0, $fKE23.__spread)($758da8d98f5b5543$var$alwaysRequired, [
        'task',
        'success'
    ])
}), $758da8d98f5b5543$var$_b);

});
parcelRegister("kKafq", function(module, exports) {

$parcel$export(module.exports, "PayloadType", () => $f1a00d8bdb3ecb69$export$3a0d79760672f45c);
var $f1a00d8bdb3ecb69$export$3a0d79760672f45c;
(function(PayloadType) {
    PayloadType["TIMING"] = "timing";
    PayloadType["GAUGE"] = "gauge";
    PayloadType["INCREMENT"] = "increment";
    PayloadType["DECREMENT"] = "decrement";
})($f1a00d8bdb3ecb69$export$3a0d79760672f45c || ($f1a00d8bdb3ecb69$export$3a0d79760672f45c = {}));

});



parcelRegister("3QDdw", function(module, exports) {

$parcel$export(module.exports, "default", () => $2cd4a624941a16e5$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $5kYaZ = parcelRequire("5kYaZ");

var $hO1PY = parcelRequire("hO1PY");

/**
 * Used from instances of MetalClient to submit errors.
 * - Sends a metric based on the scope of error
 * - Can/Will also be responsible for RavenJS in future.
 *
 * @method submit
 *
 */ var $2cd4a624941a16e5$var$ErrorModel = /** @class */ function(_super) {
    (0, $fKE23.__extends)(ErrorModel, _super);
    function ErrorModel(_a) {
        var hook = _a.hook;
        return _super.call(this, {
            hook: hook
        }) || this;
    }
    ErrorModel.prototype.submit = function(error) {
        this.hook({
            type: (0, $hO1PY.CoreType).ERROR,
            data: error
        });
    };
    return ErrorModel;
}((0, $5kYaZ.default));
var $2cd4a624941a16e5$export$2e2bcd8739ae039 = $2cd4a624941a16e5$var$ErrorModel;

});

parcelRegister("hHgJZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce237030915e6162$export$2e2bcd8739ae039);

var $fKE23 = parcelRequire("fKE23");

var $hO1PY = parcelRequire("hO1PY");
/**
 * ErrorsPlugin automatically hooks into
 * a call to MetalClient.error.submit() and counts it as metric error count
 */ var $ce237030915e6162$var$ErrorsPlugin = /** @class */ function() {
    function ErrorsPlugin() {}
    ErrorsPlugin.prototype.install = function(client) {
        // Listen to error events from MetalClient
        client.addEventHook((0, $hO1PY.CoreType).ERROR, function(_a) {
            var page = _a.page, component = _a.component, name = _a.name;
            client.metric.submit((0, $fKE23.__assign)({
                name: name,
                value: 1,
                page: page
            }, component ? {
                component: component
            } : {}));
        });
    };
    return ErrorsPlugin;
}();
var $ce237030915e6162$export$2e2bcd8739ae039 = $ce237030915e6162$var$ErrorsPlugin;

});

parcelRegister("laIsC", function(module, exports) {

$parcel$export(module.exports, "default", () => $f69d05129499fc90$export$2e2bcd8739ae039);

var $ijj2z = parcelRequire("ijj2z");

var $gYbDn = parcelRequire("gYbDn");
function $f69d05129499fc90$export$2e2bcd8739ae039(_a) {
    var _b = (_a === void 0 ? {} : _a).userAgentString, userAgentString = _b === void 0 ? window.navigator.userAgent : _b;
    var rawBrowserInfo = (0, (/*@__PURE__*/$parcel$interopDefault($ijj2z))).getParser(userAgentString);
    var os = (0, $gYbDn.default).os[rawBrowserInfo.getOSName()] || 'other';
    var platform = (0, $gYbDn.default).platform[rawBrowserInfo.getPlatformType()] || 'other';
    var browser = (0, $gYbDn.default).browser[rawBrowserInfo.getBrowserName()] || 'other';
    return {
        os: os,
        platform: platform,
        browser: browser
    };
}

});
parcelRegister("ijj2z", function(module, exports) {
!function(e, t) {
    module.exports = t();
}(module.exports, function() {
    return function(e) {
        var t = {};
        function r(n) {
            if (t[n]) return t[n].exports;
            var i = t[n] = {
                i: n,
                l: !1,
                exports: {}
            };
            return e[n].call(i.exports, i, i.exports, r), i.l = !0, i.exports;
        }
        return r.m = e, r.c = t, r.d = function(e, t, n) {
            r.o(e, t) || Object.defineProperty(e, t, {
                enumerable: !0,
                get: n
            });
        }, r.r = function(e) {
            "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(e, "__esModule", {
                value: !0
            });
        }, r.t = function(e, t) {
            if (1 & t && (e = r(e)), 8 & t) return e;
            if (4 & t && "object" == typeof e && e && e.__esModule) return e;
            var n = Object.create(null);
            if (r.r(n), Object.defineProperty(n, "default", {
                enumerable: !0,
                value: e
            }), 2 & t && "string" != typeof e) for(var i in e)r.d(n, i, (function(t) {
                return e[t];
            }).bind(null, i));
            return n;
        }, r.n = function(e) {
            var t = e && e.__esModule ? function() {
                return e.default;
            } : function() {
                return e;
            };
            return r.d(t, "a", t), t;
        }, r.o = function(e, t) {
            return Object.prototype.hasOwnProperty.call(e, t);
        }, r.p = "", r(r.s = 90);
    }({
        17: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = r(18), i = function() {
                function e() {}
                return e.getFirstMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 0 && r[1] || "";
                }, e.getSecondMatch = function(e, t) {
                    var r = t.match(e);
                    return r && r.length > 1 && r[2] || "";
                }, e.matchAndReturnConst = function(e, t, r) {
                    if (e.test(t)) return r;
                }, e.getWindowsVersionName = function(e) {
                    switch(e){
                        case "NT":
                            return "NT";
                        case "XP":
                            return "XP";
                        case "NT 5.0":
                            return "2000";
                        case "NT 5.1":
                            return "XP";
                        case "NT 5.2":
                            return "2003";
                        case "NT 6.0":
                            return "Vista";
                        case "NT 6.1":
                            return "7";
                        case "NT 6.2":
                            return "8";
                        case "NT 6.3":
                            return "8.1";
                        case "NT 10.0":
                            return "10";
                        default:
                            return;
                    }
                }, e.getMacOSVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), 10 === t[0]) switch(t[1]){
                        case 5:
                            return "Leopard";
                        case 6:
                            return "Snow Leopard";
                        case 7:
                            return "Lion";
                        case 8:
                            return "Mountain Lion";
                        case 9:
                            return "Mavericks";
                        case 10:
                            return "Yosemite";
                        case 11:
                            return "El Capitan";
                        case 12:
                            return "Sierra";
                        case 13:
                            return "High Sierra";
                        case 14:
                            return "Mojave";
                        case 15:
                            return "Catalina";
                        default:
                            return;
                    }
                }, e.getAndroidVersionName = function(e) {
                    var t = e.split(".").splice(0, 2).map(function(e) {
                        return parseInt(e, 10) || 0;
                    });
                    if (t.push(0), !(1 === t[0] && t[1] < 5)) return 1 === t[0] && t[1] < 6 ? "Cupcake" : 1 === t[0] && t[1] >= 6 ? "Donut" : 2 === t[0] && t[1] < 2 ? "Eclair" : 2 === t[0] && 2 === t[1] ? "Froyo" : 2 === t[0] && t[1] > 2 ? "Gingerbread" : 3 === t[0] ? "Honeycomb" : 4 === t[0] && t[1] < 1 ? "Ice Cream Sandwich" : 4 === t[0] && t[1] < 4 ? "Jelly Bean" : 4 === t[0] && t[1] >= 4 ? "KitKat" : 5 === t[0] ? "Lollipop" : 6 === t[0] ? "Marshmallow" : 7 === t[0] ? "Nougat" : 8 === t[0] ? "Oreo" : 9 === t[0] ? "Pie" : void 0;
                }, e.getVersionPrecision = function(e) {
                    return e.split(".").length;
                }, e.compareVersions = function(t, r, n) {
                    void 0 === n && (n = !1);
                    var i = e.getVersionPrecision(t), s = e.getVersionPrecision(r), a = Math.max(i, s), o = 0, u = e.map([
                        t,
                        r
                    ], function(t) {
                        var r = a - e.getVersionPrecision(t), n = t + new Array(r + 1).join(".0");
                        return e.map(n.split("."), function(e) {
                            return new Array(20 - e.length).join("0") + e;
                        }).reverse();
                    });
                    for(n && (o = a - Math.min(i, s)), a -= 1; a >= o;){
                        if (u[0][a] > u[1][a]) return 1;
                        if (u[0][a] === u[1][a]) {
                            if (a === o) return 0;
                            a -= 1;
                        } else if (u[0][a] < u[1][a]) return -1;
                    }
                }, e.map = function(e, t) {
                    var r, n = [];
                    if (Array.prototype.map) return Array.prototype.map.call(e, t);
                    for(r = 0; r < e.length; r += 1)n.push(t(e[r]));
                    return n;
                }, e.find = function(e, t) {
                    var r, n;
                    if (Array.prototype.find) return Array.prototype.find.call(e, t);
                    for(r = 0, n = e.length; r < n; r += 1){
                        var i = e[r];
                        if (t(i, r)) return i;
                    }
                }, e.assign = function(e) {
                    for(var t, r, n = e, i = arguments.length, s = new Array(i > 1 ? i - 1 : 0), a = 1; a < i; a++)s[a - 1] = arguments[a];
                    if (Object.assign) return Object.assign.apply(Object, [
                        e
                    ].concat(s));
                    var o = function() {
                        var e = s[t];
                        "object" == typeof e && null !== e && Object.keys(e).forEach(function(t) {
                            n[t] = e[t];
                        });
                    };
                    for(t = 0, r = s.length; t < r; t += 1)o();
                    return e;
                }, e.getBrowserAlias = function(e) {
                    return n.BROWSER_ALIASES_MAP[e];
                }, e.getBrowserTypeByAlias = function(e) {
                    return n.BROWSER_MAP[e] || "";
                }, e;
            }();
            t.default = i, e.exports = t.default;
        },
        18: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.ENGINE_MAP = t.OS_MAP = t.PLATFORMS_MAP = t.BROWSER_MAP = t.BROWSER_ALIASES_MAP = void 0;
            t.BROWSER_ALIASES_MAP = {
                "Amazon Silk": "amazon_silk",
                "Android Browser": "android",
                Bada: "bada",
                BlackBerry: "blackberry",
                Chrome: "chrome",
                Chromium: "chromium",
                Electron: "electron",
                Epiphany: "epiphany",
                Firefox: "firefox",
                Focus: "focus",
                Generic: "generic",
                "Google Search": "google_search",
                Googlebot: "googlebot",
                "Internet Explorer": "ie",
                "K-Meleon": "k_meleon",
                Maxthon: "maxthon",
                "Microsoft Edge": "edge",
                "MZ Browser": "mz",
                "NAVER Whale Browser": "naver",
                Opera: "opera",
                "Opera Coast": "opera_coast",
                PhantomJS: "phantomjs",
                Puffin: "puffin",
                QupZilla: "qupzilla",
                QQ: "qq",
                QQLite: "qqlite",
                Safari: "safari",
                Sailfish: "sailfish",
                "Samsung Internet for Android": "samsung_internet",
                SeaMonkey: "seamonkey",
                Sleipnir: "sleipnir",
                Swing: "swing",
                Tizen: "tizen",
                "UC Browser": "uc",
                Vivaldi: "vivaldi",
                "WebOS Browser": "webos",
                WeChat: "wechat",
                "Yandex Browser": "yandex",
                Roku: "roku"
            };
            t.BROWSER_MAP = {
                amazon_silk: "Amazon Silk",
                android: "Android Browser",
                bada: "Bada",
                blackberry: "BlackBerry",
                chrome: "Chrome",
                chromium: "Chromium",
                electron: "Electron",
                epiphany: "Epiphany",
                firefox: "Firefox",
                focus: "Focus",
                generic: "Generic",
                googlebot: "Googlebot",
                google_search: "Google Search",
                ie: "Internet Explorer",
                k_meleon: "K-Meleon",
                maxthon: "Maxthon",
                edge: "Microsoft Edge",
                mz: "MZ Browser",
                naver: "NAVER Whale Browser",
                opera: "Opera",
                opera_coast: "Opera Coast",
                phantomjs: "PhantomJS",
                puffin: "Puffin",
                qupzilla: "QupZilla",
                qq: "QQ Browser",
                qqlite: "QQ Browser Lite",
                safari: "Safari",
                sailfish: "Sailfish",
                samsung_internet: "Samsung Internet for Android",
                seamonkey: "SeaMonkey",
                sleipnir: "Sleipnir",
                swing: "Swing",
                tizen: "Tizen",
                uc: "UC Browser",
                vivaldi: "Vivaldi",
                webos: "WebOS Browser",
                wechat: "WeChat",
                yandex: "Yandex Browser"
            };
            t.PLATFORMS_MAP = {
                tablet: "tablet",
                mobile: "mobile",
                desktop: "desktop",
                tv: "tv"
            };
            t.OS_MAP = {
                WindowsPhone: "Windows Phone",
                Windows: "Windows",
                MacOS: "macOS",
                iOS: "iOS",
                Android: "Android",
                WebOS: "WebOS",
                BlackBerry: "BlackBerry",
                Bada: "Bada",
                Tizen: "Tizen",
                Linux: "Linux",
                ChromeOS: "Chrome OS",
                PlayStation4: "PlayStation 4",
                Roku: "Roku"
            };
            t.ENGINE_MAP = {
                EdgeHTML: "EdgeHTML",
                Blink: "Blink",
                Trident: "Trident",
                Presto: "Presto",
                Gecko: "Gecko",
                WebKit: "WebKit"
            };
        },
        90: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(91)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            function a(e, t) {
                for(var r = 0; r < t.length; r++){
                    var n = t[r];
                    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(e, n.key, n);
                }
            }
            var o = function() {
                function e() {}
                var t, r, n;
                return e.getParser = function(e, t) {
                    if (void 0 === t && (t = !1), "string" != typeof e) throw new Error("UserAgent should be a string");
                    return new i.default(e, t);
                }, e.parse = function(e) {
                    return new i.default(e).getResult();
                }, t = e, n = [
                    {
                        key: "BROWSER_MAP",
                        get: function() {
                            return s.BROWSER_MAP;
                        }
                    },
                    {
                        key: "ENGINE_MAP",
                        get: function() {
                            return s.ENGINE_MAP;
                        }
                    },
                    {
                        key: "OS_MAP",
                        get: function() {
                            return s.OS_MAP;
                        }
                    },
                    {
                        key: "PLATFORMS_MAP",
                        get: function() {
                            return s.PLATFORMS_MAP;
                        }
                    }
                ], r = null, n && a(t, n), e;
            }();
            t.default = o, e.exports = t.default;
        },
        91: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n = u(r(92)), i = u(r(93)), s = u(r(94)), a = u(r(95)), o = u(r(17));
            function u(e) {
                return e && e.__esModule ? e : {
                    default: e
                };
            }
            var d = function() {
                function e(e, t) {
                    if (void 0 === t && (t = !1), null == e || "" === e) throw new Error("UserAgent parameter can't be empty");
                    this._ua = e, this.parsedResult = {}, !0 !== t && this.parse();
                }
                var t = e.prototype;
                return t.getUA = function() {
                    return this._ua;
                }, t.test = function(e) {
                    return e.test(this._ua);
                }, t.parseBrowser = function() {
                    var e = this;
                    this.parsedResult.browser = {};
                    var t = o.default.find(n.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.browser = t.describe(this.getUA())), this.parsedResult.browser;
                }, t.getBrowser = function() {
                    return this.parsedResult.browser ? this.parsedResult.browser : this.parseBrowser();
                }, t.getBrowserName = function(e) {
                    return e ? String(this.getBrowser().name).toLowerCase() || "" : this.getBrowser().name || "";
                }, t.getBrowserVersion = function() {
                    return this.getBrowser().version;
                }, t.getOS = function() {
                    return this.parsedResult.os ? this.parsedResult.os : this.parseOS();
                }, t.parseOS = function() {
                    var e = this;
                    this.parsedResult.os = {};
                    var t = o.default.find(i.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.os = t.describe(this.getUA())), this.parsedResult.os;
                }, t.getOSName = function(e) {
                    var t = this.getOS().name;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.getOSVersion = function() {
                    return this.getOS().version;
                }, t.getPlatform = function() {
                    return this.parsedResult.platform ? this.parsedResult.platform : this.parsePlatform();
                }, t.getPlatformType = function(e) {
                    void 0 === e && (e = !1);
                    var t = this.getPlatform().type;
                    return e ? String(t).toLowerCase() || "" : t || "";
                }, t.parsePlatform = function() {
                    var e = this;
                    this.parsedResult.platform = {};
                    var t = o.default.find(s.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.platform = t.describe(this.getUA())), this.parsedResult.platform;
                }, t.getEngine = function() {
                    return this.parsedResult.engine ? this.parsedResult.engine : this.parseEngine();
                }, t.getEngineName = function(e) {
                    return e ? String(this.getEngine().name).toLowerCase() || "" : this.getEngine().name || "";
                }, t.parseEngine = function() {
                    var e = this;
                    this.parsedResult.engine = {};
                    var t = o.default.find(a.default, function(t) {
                        if ("function" == typeof t.test) return t.test(e);
                        if (t.test instanceof Array) return t.test.some(function(t) {
                            return e.test(t);
                        });
                        throw new Error("Browser's test function is not valid");
                    });
                    return t && (this.parsedResult.engine = t.describe(this.getUA())), this.parsedResult.engine;
                }, t.parse = function() {
                    return this.parseBrowser(), this.parseOS(), this.parsePlatform(), this.parseEngine(), this;
                }, t.getResult = function() {
                    return o.default.assign({}, this.parsedResult);
                }, t.satisfies = function(e) {
                    var t = this, r = {}, n = 0, i = {}, s = 0;
                    if (Object.keys(e).forEach(function(t) {
                        var a = e[t];
                        "string" == typeof a ? (i[t] = a, s += 1) : "object" == typeof a && (r[t] = a, n += 1);
                    }), n > 0) {
                        var a = Object.keys(r), u = o.default.find(a, function(e) {
                            return t.isOS(e);
                        });
                        if (u) {
                            var d = this.satisfies(r[u]);
                            if (void 0 !== d) return d;
                        }
                        var c = o.default.find(a, function(e) {
                            return t.isPlatform(e);
                        });
                        if (c) {
                            var f = this.satisfies(r[c]);
                            if (void 0 !== f) return f;
                        }
                    }
                    if (s > 0) {
                        var l = Object.keys(i), h = o.default.find(l, function(e) {
                            return t.isBrowser(e, !0);
                        });
                        if (void 0 !== h) return this.compareVersion(i[h]);
                    }
                }, t.isBrowser = function(e, t) {
                    void 0 === t && (t = !1);
                    var r = this.getBrowserName().toLowerCase(), n = e.toLowerCase(), i = o.default.getBrowserTypeByAlias(n);
                    return t && i && (n = i.toLowerCase()), n === r;
                }, t.compareVersion = function(e) {
                    var t = [
                        0
                    ], r = e, n = !1, i = this.getBrowserVersion();
                    if ("string" == typeof i) return ">" === e[0] || "<" === e[0] ? (r = e.substr(1), "=" === e[1] ? (n = !0, r = e.substr(2)) : t = [], ">" === e[0] ? t.push(1) : t.push(-1)) : "=" === e[0] ? r = e.substr(1) : "~" === e[0] && (n = !0, r = e.substr(1)), t.indexOf(o.default.compareVersions(i, r, n)) > -1;
                }, t.isOS = function(e) {
                    return this.getOSName(!0) === String(e).toLowerCase();
                }, t.isPlatform = function(e) {
                    return this.getPlatformType(!0) === String(e).toLowerCase();
                }, t.isEngine = function(e) {
                    return this.getEngineName(!0) === String(e).toLowerCase();
                }, t.is = function(e, t) {
                    return void 0 === t && (t = !1), this.isBrowser(e, t) || this.isOS(e) || this.isPlatform(e);
                }, t.some = function(e) {
                    var t = this;
                    return void 0 === e && (e = []), e.some(function(e) {
                        return t.is(e);
                    });
                }, e;
            }();
            t.default = d, e.exports = t.default;
        },
        92: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            };
            var s = /version\/(\d+(\.?_?\d+)+)/i, a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Googlebot"
                        }, r = i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opera/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opr\/|opios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera"
                        }, r = i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /SamsungBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Samsung Internet for Android"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Whale/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "NAVER Whale Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MZBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "MZ Browser"
                        }, r = i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /focus/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Focus"
                        }, r = i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /swing/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Swing"
                        }, r = i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /coast/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Coast"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /opt\/\d+(?:.?_?\d+)+/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Opera Touch"
                        }, r = i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /yabrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Yandex Browser"
                        }, r = i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /ucbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "UC Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /Maxthon|mxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Maxthon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /epiphany/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Epiphany"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /puffin/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Puffin"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sleipnir/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sleipnir"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /k-meleon/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "K-Meleon"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /micromessenger/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WeChat"
                        }, r = i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qqbrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: /qqbrowserlite/i.test(e) ? "QQ Browser Lite" : "QQ Browser"
                        }, r = i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /msie|trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Internet Explorer"
                        }, r = i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /\sedg\//i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /edg([ea]|ios)/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Microsoft Edge"
                        }, r = i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /vivaldi/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Vivaldi"
                        }, r = i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /seamonkey/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SeaMonkey"
                        }, r = i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /sailfish/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Sailfish"
                        }, r = i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Amazon Silk"
                        }, r = i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /phantom/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PhantomJS"
                        }, r = i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /slimerjs/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "SlimerJS"
                        }, r = i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "BlackBerry"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "WebOS Browser"
                        }, r = i.default.getFirstMatch(s, e) || i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Bada"
                        }, r = i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Tizen"
                        }, r = i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /qupzilla/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "QupZilla"
                        }, r = i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /firefox|iceweasel|fxios/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Firefox"
                        }, r = i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /electron/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Electron"
                        }, r = i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /MiuiBrowser/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Miui"
                        }, r = i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chromium/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chromium"
                        }, r = i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i, e) || i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /chrome|crios|crmo/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Chrome"
                        }, r = i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /GSA/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Google Search"
                        }, r = i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = {
                            name: "Android Browser"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /playstation 4/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "PlayStation 4"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /safari|applewebkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: "Safari"
                        }, r = i.default.getFirstMatch(s, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /.*/i
                    ],
                    describe: function(e) {
                        var t = -1 !== e.search("\\(") ? /^(.*)\/(.*)[ \t]\((.*)/ : /^(.*)\/(.*) /;
                        return {
                            name: i.default.getFirstMatch(t, e),
                            version: i.default.getSecondMatch(t, e)
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        93: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /Roku\/DVP/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i, e);
                        return {
                            name: s.OS_MAP.Roku,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows phone/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.WindowsPhone,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /windows /i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i, e), r = i.default.getWindowsVersionName(t);
                        return {
                            name: s.OS_MAP.Windows,
                            version: t,
                            versionName: r
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.OS_MAP.iOS
                        }, r = i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /macintosh/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i, e).replace(/[_\s]/g, "."), r = i.default.getMacOSVersionName(t), n = {
                            name: s.OS_MAP.MacOS,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(ipod|iphone|ipad)/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i, e).replace(/[_\s]/g, ".");
                        return {
                            name: s.OS_MAP.iOS,
                            version: t
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = !e.test(/like android/i), r = e.test(/android/i);
                        return t && r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i, e), r = i.default.getAndroidVersionName(t), n = {
                            name: s.OS_MAP.Android,
                            version: t
                        };
                        return r && (n.versionName = r), n;
                    }
                },
                {
                    test: [
                        /(web|hpw)[o0]s/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i, e), r = {
                            name: s.OS_MAP.WebOS
                        };
                        return t && t.length && (r.version = t), r;
                    }
                },
                {
                    test: [
                        /blackberry|\bbb\d+/i,
                        /rim\stablet/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i, e) || i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i, e) || i.default.getFirstMatch(/\bbb(\d+)/i, e);
                        return {
                            name: s.OS_MAP.BlackBerry,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /bada/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Bada,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /tizen/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.Tizen,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /linux/i
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.Linux
                        };
                    }
                },
                {
                    test: [
                        /CrOS/
                    ],
                    describe: function() {
                        return {
                            name: s.OS_MAP.ChromeOS
                        };
                    }
                },
                {
                    test: [
                        /PlayStation 4/
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i, e);
                        return {
                            name: s.OS_MAP.PlayStation4,
                            version: t
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        94: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: [
                        /googlebot/i
                    ],
                    describe: function() {
                        return {
                            type: "bot",
                            vendor: "Google"
                        };
                    }
                },
                {
                    test: [
                        /huawei/i
                    ],
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(can-l01)/i, e) && "Nova", r = {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Huawei"
                        };
                        return t && (r.model = t), r;
                    }
                },
                {
                    test: [
                        /nexus\s*(?:7|8|9|10).*/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /ipad/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /Macintosh(.*?) FxiOS(.*?)\//
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Apple",
                            model: "iPad"
                        };
                    }
                },
                {
                    test: [
                        /kftt build/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon",
                            model: "Kindle Fire HD 7"
                        };
                    }
                },
                {
                    test: [
                        /silk/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet,
                            vendor: "Amazon"
                        };
                    }
                },
                {
                    test: [
                        /tablet(?! pc)/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/ipod|iphone/i), r = e.test(/like (ipod|iphone)/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = i.default.getFirstMatch(/(ipod|iphone)/i, e);
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Apple",
                            model: t
                        };
                    }
                },
                {
                    test: [
                        /nexus\s*[0-6].*/i,
                        /galaxy nexus/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Nexus"
                        };
                    }
                },
                {
                    test: [
                        /[^-]mobi/i
                    ],
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "blackberry" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "BlackBerry"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "bada" === e.getBrowserName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows phone" === e.getBrowserName();
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile,
                            vendor: "Microsoft"
                        };
                    }
                },
                {
                    test: function(e) {
                        var t = Number(String(e.getOSVersion()).split(".")[0]);
                        return "android" === e.getOSName(!0) && t >= 3;
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tablet
                        };
                    }
                },
                {
                    test: function(e) {
                        return "android" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.mobile
                        };
                    }
                },
                {
                    test: function(e) {
                        return "macos" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop,
                            vendor: "Apple"
                        };
                    }
                },
                {
                    test: function(e) {
                        return "windows" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "linux" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.desktop
                        };
                    }
                },
                {
                    test: function(e) {
                        return "playstation 4" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                },
                {
                    test: function(e) {
                        return "roku" === e.getOSName(!0);
                    },
                    describe: function() {
                        return {
                            type: s.PLATFORMS_MAP.tv
                        };
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        },
        95: function(e, t, r) {
            "use strict";
            t.__esModule = !0, t.default = void 0;
            var n, i = (n = r(17)) && n.__esModule ? n : {
                default: n
            }, s = r(18);
            var a = [
                {
                    test: function(e) {
                        return "microsoft edge" === e.getBrowserName(!0);
                    },
                    describe: function(e) {
                        if (/\sedg\//i.test(e)) return {
                            name: s.ENGINE_MAP.Blink
                        };
                        var t = i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i, e);
                        return {
                            name: s.ENGINE_MAP.EdgeHTML,
                            version: t
                        };
                    }
                },
                {
                    test: [
                        /trident/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Trident
                        }, r = i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        return e.test(/presto/i);
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Presto
                        }, r = i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: function(e) {
                        var t = e.test(/gecko/i), r = e.test(/like gecko/i);
                        return t && !r;
                    },
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.Gecko
                        }, r = i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                },
                {
                    test: [
                        /(apple)?webkit\/537\.36/i
                    ],
                    describe: function() {
                        return {
                            name: s.ENGINE_MAP.Blink
                        };
                    }
                },
                {
                    test: [
                        /(apple)?webkit/i
                    ],
                    describe: function(e) {
                        var t = {
                            name: s.ENGINE_MAP.WebKit
                        }, r = i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i, e);
                        return r && (t.version = r), t;
                    }
                }
            ];
            t.default = a, e.exports = t.default;
        }
    });
});

});

parcelRegister("gYbDn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5ab463e3adc66d0$export$2e2bcd8739ae039);

var $ijj2z = parcelRequire("ijj2z");
var $c5ab463e3adc66d0$var$_a, $c5ab463e3adc66d0$var$_b, $c5ab463e3adc66d0$var$_c;
var $c5ab463e3adc66d0$var$BROWSER_MAP = (0, (/*@__PURE__*/$parcel$interopDefault($ijj2z))).BROWSER_MAP, $c5ab463e3adc66d0$var$OS_MAP = (0, (/*@__PURE__*/$parcel$interopDefault($ijj2z))).OS_MAP, $c5ab463e3adc66d0$var$PLATFORMS_MAP = (0, (/*@__PURE__*/$parcel$interopDefault($ijj2z))).PLATFORMS_MAP;
// Whitelists loosely against constant values from 'bowser' ~ 2.5.2
// https://github.com/lancedikson/bowser/blob/master/src/constants.js
var $c5ab463e3adc66d0$var$browser = ($c5ab463e3adc66d0$var$_a = {}, $c5ab463e3adc66d0$var$_a[$c5ab463e3adc66d0$var$BROWSER_MAP.chrome] = 'chrome', $c5ab463e3adc66d0$var$_a[$c5ab463e3adc66d0$var$BROWSER_MAP.chromium] = 'chromium', $c5ab463e3adc66d0$var$_a[$c5ab463e3adc66d0$var$BROWSER_MAP.safari] = 'safari', $c5ab463e3adc66d0$var$_a[$c5ab463e3adc66d0$var$BROWSER_MAP.firefox] = 'firefox', $c5ab463e3adc66d0$var$_a[$c5ab463e3adc66d0$var$BROWSER_MAP.edge] = 'edge', $c5ab463e3adc66d0$var$_a[$c5ab463e3adc66d0$var$BROWSER_MAP.ie] = 'ie', $c5ab463e3adc66d0$var$_a);
var $c5ab463e3adc66d0$var$platform = ($c5ab463e3adc66d0$var$_b = {}, $c5ab463e3adc66d0$var$_b[$c5ab463e3adc66d0$var$PLATFORMS_MAP.desktop] = 'desktop', $c5ab463e3adc66d0$var$_b[$c5ab463e3adc66d0$var$PLATFORMS_MAP.mobile] = 'mobile', $c5ab463e3adc66d0$var$_b);
var $c5ab463e3adc66d0$var$os = ($c5ab463e3adc66d0$var$_c = {}, $c5ab463e3adc66d0$var$_c[$c5ab463e3adc66d0$var$OS_MAP.MacOS] = 'macos', $c5ab463e3adc66d0$var$_c[$c5ab463e3adc66d0$var$OS_MAP.Linux] = 'linux', $c5ab463e3adc66d0$var$_c[$c5ab463e3adc66d0$var$OS_MAP.Windows] = 'windows', $c5ab463e3adc66d0$var$_c[$c5ab463e3adc66d0$var$OS_MAP.iOS] = 'ios', $c5ab463e3adc66d0$var$_c[$c5ab463e3adc66d0$var$OS_MAP.Android] = 'android', $c5ab463e3adc66d0$var$_c);
var $c5ab463e3adc66d0$var$whitelists = {
    browser: $c5ab463e3adc66d0$var$browser,
    os: $c5ab463e3adc66d0$var$os,
    platform: $c5ab463e3adc66d0$var$platform
};
var $c5ab463e3adc66d0$export$2e2bcd8739ae039 = $c5ab463e3adc66d0$var$whitelists;

});


parcelRegister("eiRXx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69c9a537d7e3fa3$export$2e2bcd8739ae039);

var $lCXmz = parcelRequire("lCXmz");
var $a69c9a537d7e3fa3$var$PageVisibility = /** @class */ function() {
    function PageVisibility() {
        var _this = this;
        this.callbacks = new Map();
        this.lastHiddenAt = 0;
        this.bindEventListeners = function() {
            document.addEventListener(_this.visibilityChange, _this.handleVisibilityChange, false);
        };
        this.handleVisibilityChange = function() {
            var isHidden = document[_this.hidden];
            _this.documentHiddenInfo.isHidden = isHidden;
            if (isHidden) _this.lastHiddenAt = performance.now();
            if (!_this.wasPreviouslyHidden) _this.wasPreviouslyHidden = isHidden;
            _this.callbacks.forEach(function(callbackFn) {
                return callbackFn(isHidden);
            });
        };
        this.documentHiddenInfo = (0, $lCXmz.getDocumentHiddenValues)();
        this.wasPreviouslyHidden = this.documentHiddenInfo.isHidden;
        if (typeof document.addEventListener !== 'undefined' && this.hidden !== undefined) this.bindEventListeners();
    }
    PageVisibility.prototype.addCallback = function(name, fn) {
        if (typeof name !== 'string') throw new Error('Invalid name, must be string');
        if (typeof fn !== 'function') throw new Error('Invalid callback, must be function');
        this.callbacks.set(name, fn);
    };
    PageVisibility.prototype.removeCallback = function(name) {
        if (this.callbacks.has(name)) this.callbacks.delete(name);
    };
    Object.defineProperty(PageVisibility.prototype, "isHidden", {
        get: function() {
            return this.documentHiddenInfo.isHidden;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageVisibility.prototype, "hidden", {
        get: function() {
            return this.documentHiddenInfo.hidden;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageVisibility.prototype, "visibilityChange", {
        get: function() {
            return this.documentHiddenInfo.visibilityChange;
        },
        enumerable: false,
        configurable: true
    });
    return PageVisibility;
}();
var $a69c9a537d7e3fa3$export$2e2bcd8739ae039 = $a69c9a537d7e3fa3$var$PageVisibility;

});
parcelRegister("lCXmz", function(module, exports) {

$parcel$export(module.exports, "getDocumentHiddenValues", () => $fbeb31d24c6d1b9e$export$bc6b8fc5a64fb2d);
var $fbeb31d24c6d1b9e$export$bc6b8fc5a64fb2d = function() {
    var doc = document;
    var hiddenInfo = {
        isHidden: false,
        hidden: 'undefined',
        visibilityChange: 'undefined'
    };
    if (typeof doc.hidden !== 'undefined') {
        // Opera 12.10 and Firefox 18 and later support
        hiddenInfo.isHidden = doc.hidden;
        hiddenInfo.hidden = 'hidden';
        hiddenInfo.visibilityChange = 'visibilitychange';
    } else if (typeof doc.msHidden !== 'undefined') {
        hiddenInfo.isHidden = doc.msHidden;
        hiddenInfo.hidden = 'msHidden';
        hiddenInfo.visibilityChange = 'msvisibilitychange';
    } else if (typeof doc.webkitHidden !== 'undefined') {
        hiddenInfo.isHidden = doc.webkitHidden;
        hiddenInfo.hidden = 'webkitHidden';
        hiddenInfo.visibilityChange = 'webkitvisibilitychange';
    }
    return hiddenInfo;
};

});


parcelRegister("cJKi6", function(module, exports) {

$parcel$export(module.exports, "default", () => $945d986f2258461d$export$2e2bcd8739ae039);
var $945d986f2258461d$var$defaultGetPageFn = function() {
    return '';
};
var $945d986f2258461d$var$PageTracker = /** @class */ function() {
    function PageTracker(getPage) {
        if (getPage === void 0) getPage = $945d986f2258461d$var$defaultGetPageFn;
        this.initialPage = '';
        this.initialPage = getPage();
        this.getPage = getPage;
    }
    Object.defineProperty(PageTracker.prototype, "page", {
        get: function() {
            if (this.getPage) {
                var page = this.getPage();
                if (!this.initialPage) this.initialPage = page;
                return page;
            }
            return '';
        },
        enumerable: false,
        configurable: true
    });
    return PageTracker;
}();
var $945d986f2258461d$export$2e2bcd8739ae039 = $945d986f2258461d$var$PageTracker;

});

parcelRegister("991KK", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a865073c2b3acd7$export$2e2bcd8739ae039);
var $6a865073c2b3acd7$var$config = {
    api: {
        local: 'https://api.stg.atlassian.com/metal/ingest',
        dev: 'https://api.stg.atlassian.com/metal/ingest',
        staging: 'https://api.stg.atlassian.com/metal/ingest',
        prod: 'https://api.atlassian.com/metal/ingest'
    }
};
var $6a865073c2b3acd7$export$2e2bcd8739ae039 = $6a865073c2b3acd7$var$config;

});

parcelRegister("ePwZC", function(module, exports) {

$parcel$export(module.exports, "validateProductInfo", () => $acbf6bced4896a99$export$fd35ff7210c560be);
$parcel$export(module.exports, "getDefaultHooks", () => $acbf6bced4896a99$export$ba41f44c61addf37);

var $hO1PY = parcelRequire("hO1PY");

var $ej2zW = parcelRequire("ej2zW");

var $5q3On = parcelRequire("5q3On");
var $acbf6bced4896a99$export$fd35ff7210c560be = function(productInfo) {
    if (!productInfo.metalId) throw new Error('Missing metalId');
    if (!productInfo) throw new Error('Missing productInfo');
    if (!productInfo.env) throw new Error('Missing productInfo.env');
    if (!productInfo.version) throw new Error('Missing productInfo.version');
    if (!(0, $ej2zW.isType)((0, $5q3On.envTypes), productInfo.env)) throw new Error("Invalid productInfo.env '" + productInfo.env + "', must be an envType: [" + (0, $ej2zW.objectValues)((0, $5q3On.envTypes)) + "]");
};
var $acbf6bced4896a99$export$ba41f44c61addf37 = function() {
    var _a;
    return _a = {}, _a[(0, $hO1PY.CoreType).METRIC] = [], _a[(0, $hO1PY.CoreType).ERROR] = [], _a;
};

});
parcelRegister("5q3On", function(module, exports) {

$parcel$export(module.exports, "envTypes", () => $3f22565574528cfb$export$a9d74288f660fcc0);
var $3f22565574528cfb$export$a9d74288f660fcc0 = {
    LOCAL: 'local',
    DEV: 'dev',
    STAGING: 'staging',
    PROD: 'prod'
};

});



parcelRegister("3V6tX", function(module, exports) {

$parcel$export(module.exports, "isIgnorableGenericTaskSLOEvent", () => $2dabb92d9b58de3f$export$872208bd637c55d);

var $hgNMk = parcelRequire("hgNMk");
const $2dabb92d9b58de3f$var$CLIENT_SIDE_NETWORK_ERROR_CHROME = 'Failed to fetch';
const $2dabb92d9b58de3f$var$CLIENT_SIDE_NETWORK_ERROR_FIREFOX = 'NetworkError when attempting to fetch resource.';
const $2dabb92d9b58de3f$var$CLIENT_SIDE_NETWORK_ERROR_OTHER = 'Network request failed';
const $2dabb92d9b58de3f$var$CLIENT_CONNECTION_ERROR = 'Connection error';
/**
 * These errors will be thrown by `fetch`, in the following cases (non-exclusively):
 *
 * 1. When the user is offline / has a network fluctuation
 * 2. When the browser cancels the request to due to navigation, or user action
 * 3. Browser throws a CORS error, etc.
 *
 * @see https://fetch.spec.whatwg.org/#fetch-api - for exhaustive list of cases
 *
 * We have no easy way of identifying or categorizing which of these types of errors are actually
 * causing this to be thrown, or how to address them, hence they will be ignored from being
 * counted as "bad" events for SLOs, and tracked separately.
 */ const $2dabb92d9b58de3f$var$CLIENT_SIDE_NETWORK_ERRORS = [
    $2dabb92d9b58de3f$var$CLIENT_SIDE_NETWORK_ERROR_CHROME,
    $2dabb92d9b58de3f$var$CLIENT_SIDE_NETWORK_ERROR_FIREFOX,
    $2dabb92d9b58de3f$var$CLIENT_SIDE_NETWORK_ERROR_OTHER
];
const $2dabb92d9b58de3f$var$isClientSideNetworkError = function isClientSideNetworkError() {
    let message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    return $2dabb92d9b58de3f$var$CLIENT_SIDE_NETWORK_ERRORS.some((errorMessage)=>message.includes(errorMessage));
};
const $2dabb92d9b58de3f$var$isIgnorableApolloError = (cause)=>{
    if (cause && typeof cause === 'object' && 'networkError' in cause) {
        var _apolloError$networkE;
        const apolloError = cause;
        return $2dabb92d9b58de3f$var$isClientSideNetworkError(apolloError.message) || $2dabb92d9b58de3f$var$isClientSideNetworkError((_apolloError$networkE = apolloError.networkError) === null || _apolloError$networkE === void 0 ? void 0 : _apolloError$networkE.message);
    }
    return false;
};
const $2dabb92d9b58de3f$export$1cdb516a6bbae32b = (error)=>{
    var _parsedError;
    if (error !== null && error !== void 0 && error.name && [
        'AlgoliaSearchUnparsableJSONError',
        'AlgoliaSearchRequestTimeoutError'
    ].includes(error.name)) return true;
    let parsedError = error; // default value of data
    // if error is a string then try to parse it and create an object
    if (typeof error === 'string') {
        const errorParsed = (0, $hgNMk.tryParseJSON)(error);
        if (errorParsed.success) parsedError = errorParsed.result;
    }
    // check if its a connection error
    if ((_parsedError = parsedError) !== null && _parsedError !== void 0 && _parsedError.message && typeof parsedError.message === 'string' && parsedError.message.includes($2dabb92d9b58de3f$var$CLIENT_CONNECTION_ERROR)) return true;
    return false;
};
const $2dabb92d9b58de3f$var$isIgnoreableError = (cause)=>$2dabb92d9b58de3f$var$isIgnorableApolloError(cause) || $2dabb92d9b58de3f$export$1cdb516a6bbae32b(cause);
const $2dabb92d9b58de3f$export$872208bd637c55d = (event)=>{
    var _cause$cause;
    const { cause: cause, successful: successful } = event;
    const nestedCause = (_cause$cause = cause === null || cause === void 0 ? void 0 : cause.cause) !== null && _cause$cause !== void 0 ? _cause$cause : null;
    if (!successful && ($2dabb92d9b58de3f$var$isIgnoreableError(cause) || $2dabb92d9b58de3f$var$isIgnoreableError(nestedCause))) return true;
    return false;
};

});


parcelRegister("lGnVE", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc9014f866dbd8a4$export$2e2bcd8739ae039);

var $ftN2R = parcelRequire("ftN2R");

var $dCBMq = parcelRequire("dCBMq");

var $1zOvh = parcelRequire("1zOvh");

var $evCQP = parcelRequire("evCQP");

var $6bWmm = parcelRequire("6bWmm");
const $fc9014f866dbd8a4$var$createListener = ()=>(event, getContext)=>{
        switch(event.type){
            case (0, $6bWmm.Events).LABEL_TRACE_UFO_PAGE_LOAD:
                {
                    const { isInitialRender: isInitialRender } = getContext();
                    const ufoName = event.routeName.toLowerCase();
                    if (isInitialRender) (0, $dCBMq.default)(ufoName, event.routeName);
                    else (0, $evCQP.default)(ufoName, event.routeName);
                    break;
                }
            case (0, $6bWmm.Events).LABEL_UFO_INTERACTION_ERROR:
                {
                    const { page: page } = getContext();
                    const interactionName = event.interactionName || page.toLowerCase();
                    (0, $ftN2R.setInteractionError)(interactionName, event.error);
                    break;
                }
            case (0, $6bWmm.Events).LABEL_TRACE_UFO_PRESS:
                {
                    const interactionName = event.interactionName;
                    (0, $1zOvh.default)(interactionName);
                    break;
                }
        }
    };
var $fc9014f866dbd8a4$export$2e2bcd8739ae039 = $fc9014f866dbd8a4$var$createListener;

});
parcelRegister("1zOvh", function(module, exports) {

$parcel$export(module.exports, "default", () => $12603c460b8fdb0b$export$2e2bcd8739ae039);

var $e5USB = parcelRequire("e5USB");
var $12603c460b8fdb0b$export$2e2bcd8739ae039 = (0, $e5USB.default);

});

parcelRegister("evCQP", function(module, exports) {

$parcel$export(module.exports, "default", () => $a90218ee9946e65e$export$2e2bcd8739ae039);

var $QIOxA = parcelRequire("QIOxA");
var $a90218ee9946e65e$export$2e2bcd8739ae039 = (0, $QIOxA.default);

});


parcelRegister("euans", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8bbeac74ce2524a$export$2e2bcd8739ae039);
/*
 This backend logs a sentry event for every task failure
 */ 
var $ighTk = parcelRequire("ighTk");

var $6bWmm = parcelRequire("6bWmm");

var $b2h5A = parcelRequire("b2h5A");

var $3V6tX = parcelRequire("3V6tX");
/**
 * Serializes primitive objects or Error instances
 */ function $a8bbeac74ce2524a$var$stringifyError(error) {
    if (error && typeof error === 'object') {
        const errorObject = {};
        Object.getOwnPropertyNames(error).forEach((key)=>{
            errorObject[key] = typeof error[key] === 'object' ? $a8bbeac74ce2524a$var$stringifyError(error[key]) : error[key];
        });
        return JSON.stringify(errorObject);
    }
    return JSON.stringify(error);
}
const $a8bbeac74ce2524a$var$isAppErrorWithRequestId = (cause)=>{
    var _meta;
    return ((_meta = cause.meta) === null || _meta === void 0 ? void 0 : _meta.requestId) !== undefined;
};
const $a8bbeac74ce2524a$var$createListener = ()=>(event, getContext)=>{
        switch(event.type){
            case (0, $6bWmm.Events).LABEL_PAGE_VIEW_TASK:
            case (0, $6bWmm.Events).LABEL_GENERIC_TASK:
                if (!event.successful) {
                    var _getSentryClient;
                    const context = getContext();
                    const ignorable = (0, $3V6tX.isIgnorableGenericTaskSLOEvent)(event);
                    const level = ignorable ? 'warning' : 'error';
                    const messagePrefix = ignorable ? 'Telemetry task warning' : 'Telemetry task failed';
                    const networkStatus = (0, $b2h5A.getCurrentNetworkStatus)();
                    (_getSentryClient = (0, $ighTk.default)()) === null || _getSentryClient === void 0 || _getSentryClient.withScope((scope)=>{
                        var _getSentryClient2;
                        scope.setLevel(level);
                        scope.setTag('page', context.page);
                        scope.setTag('task', event.task);
                        scope.setTag('taskId', event.taskId);
                        scope.setExtra('networkStatus', networkStatus);
                        const { cause: cause } = event;
                        if (cause) {
                            scope.setExtra('cause', $a8bbeac74ce2524a$var$stringifyError(cause));
                            if (event.task.startsWith('install-app') && $a8bbeac74ce2524a$var$isAppErrorWithRequestId(cause)) {
                                var _cause$meta;
                                scope.setTag('requestId', (_cause$meta = cause.meta) === null || _cause$meta === void 0 ? void 0 : _cause$meta.requestId);
                            }
                        }
                        (_getSentryClient2 = (0, $ighTk.default)()) === null || _getSentryClient2 === void 0 || _getSentryClient2.captureMessage("".concat(messagePrefix, ": ").concat([
                            event.task,
                            event.taskId
                        ].filter((a)=>!!a).join(',')));
                    });
                }
        }
    };
var $a8bbeac74ce2524a$export$2e2bcd8739ae039 = $a8bbeac74ce2524a$var$createListener;

});
parcelRegister("b2h5A", function(module, exports) {

$parcel$export(module.exports, "getCurrentNetworkStatus", () => $808d232d714a0319$export$d4a06315c0be6264);
const $808d232d714a0319$export$d4a06315c0be6264 = ()=>{
    if (typeof window.navigator.onLine === 'boolean') return {
        type: 'supported',
        online: window.navigator.onLine
    };
    return {
        type: 'unsupported'
    };
};
const $808d232d714a0319$export$c8ff4cdc8ff8425e = (online)=>{
    if (online) return {
        type: 'info',
        category: 'network',
        level: 'info',
        message: 'Network status online'
    };
    return {
        type: 'info',
        category: 'network',
        level: 'warning',
        message: 'Network status offline'
    };
};

});


parcelRegister("3GX6H", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b0324c662b6e4fd$export$2e2bcd8739ae039);

var $fUOHe = parcelRequire("fUOHe");

var $kCL8m = parcelRequire("kCL8m");
const $2b0324c662b6e4fd$var$wait = (duration)=>new Promise((resolve)=>setTimeout(resolve, duration));
function $2b0324c662b6e4fd$export$2e2bcd8739ae039(backends) {
    const getContext = ()=>({
            page: (0, $fUOHe.default).activePageName || 'PAGE_UNKNOWN',
            pageNavigationStart: (0, $fUOHe.default).pageNavigationStartTime,
            isInitialRender: (0, $fUOHe.default).isInitialRender,
            hasDocumentBeenHidden: (0, $kCL8m.PageVisibilityObserver).hasDocumentBeenHidden
        });
    /**
   * We encourage early initialization of telemetry, so listeners can listen to and
   * forward events even if a fatal crash occurs in the application early on.
   * However, it might be possible that such events are fired even before a page navigation
   * occurs or a page name is available.
   *
   * Here we wait for a small amount of time before setting subscribers to give a chance to the
   * application to set a page name using `Telemetry.setPage`.
   *
   * This should be immune to page crashes as we've already put it on the micro-task queue.
   */ Promise.race([
        $2b0324c662b6e4fd$var$wait(4000),
        (0, $fUOHe.default).isPageReady
    ]).then(()=>{
        (0, $fUOHe.default).messageQueue.setSubscriber((event)=>{
            backends.forEach((backend)=>backend(event, getContext));
        });
    }).catch(()=>{
    /* ignore this failure since we can't act on it anyway */ });
}

});

parcelRegister("72LB9", function(module, exports) {

$parcel$export(module.exports, "default", () => $520da4528b461f7a$export$2e2bcd8739ae039);

var $6bWmm = parcelRequire("6bWmm");
const $520da4528b461f7a$var$createListener = (_ref)=>{
    let { onRouteTransitionEnd: onRouteTransitionEnd } = _ref;
    return (event)=>{
        switch(event.type){
            case (0, $6bWmm.Events).LABEL_PAGE_VIEW_TASK:
                if (onRouteTransitionEnd) onRouteTransitionEnd();
                break;
        }
    };
};
var $520da4528b461f7a$export$2e2bcd8739ae039 = $520da4528b461f7a$var$createListener;

});



parcelRegister("fWkFY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b42223e83f1ce9c0$export$2e2bcd8739ae039);

var $eUqFw = parcelRequire("eUqFw");

var $3da0c = parcelRequire("3da0c");

var $lPArN = parcelRequire("lPArN");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b42223e83f1ce9c0$export$2e2bcd8739ae039 = ()=>{
    const { href: href = null } = (0, $3da0c.default)() || {};
    if (href && !href.includes('login.jsp')) {
        const encodedRedirectUrl = encodeURIComponent(href);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($eUqFw))).createElement((0, $lPArN.default), {
            url: `/login.jsp?os_destination=${encodedRedirectUrl}`
        });
    }
    return null;
};

});
parcelRegister("3da0c", function(module, exports) {

$parcel$export(module.exports, "default", () => $156a3428b96ddf9e$export$2e2bcd8739ae039);
/**
 * Wrap window.location so that it's testable.
 */ // eslint-disable-next-line jira/import/no-anonymous-default-export
var $156a3428b96ddf9e$export$2e2bcd8739ae039 = ()=>{
    if (typeof window !== 'undefined') return window.location;
    return undefined;
};

});

parcelRegister("lPArN", function(module, exports) {

$parcel$export(module.exports, "default", () => $84dddb8b24cbf4df$export$2e2bcd8739ae039);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$84dddb8b24cbf4df$export$2e2bcd8739ae039 = ({ url: url })=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.assign(url);
    return null;
};

});


parcelRegister("51ACp", function(module, exports) {

$parcel$export(module.exports, "HistoryAdapter", () => $7c9b058abf515682$export$d852f51b8427aefc);

var $eUqFw = parcelRequire("eUqFw");

var $lB25E = parcelRequire("lB25E");

var $dsNuc = parcelRequire("dsNuc");
// eslint-disable-next-line jira/react/no-class-components
class $7c9b058abf515682$var$HistoryAdapterComponent extends (0, $eUqFw.Component) {
    constructor(props){
        super(props);
        this.compatibleHistory = (0, $dsNuc.createReactRouterCompatibleHistory)(props.history);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.children !== this.props.children;
    }
    componentWillUnmount() {
        this.compatibleHistory.destroy && this.compatibleHistory.destroy();
    }
    render() {
        const { children: children } = this.props;
        return children(this.compatibleHistory);
    }
}
const $7c9b058abf515682$export$d852f51b8427aefc = (0, $lB25E.withRouter)($7c9b058abf515682$var$HistoryAdapterComponent);

});
parcelRegister("dsNuc", function(module, exports) {

$parcel$export(module.exports, "createReactRouterCompatibleHistory", () => $03e13d3d865e0b52$export$2df73cd79c2401bf);

var $6l6Xk = parcelRequire("6l6Xk");
const $03e13d3d865e0b52$export$2df73cd79c2401bf = (history)=>{
    let cleaned = false;
    let listeners = [];
    // @ts-expect-error - TS2304 - Cannot find name 'HistoryAction'.
    const listen = (callback)=>{
        if (cleaned) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const unsubscribe = (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(history.listen(callback));
        const listener = {
            unsubscribe: unsubscribe
        };
        listeners.push(listener);
        return (0, (/*@__PURE__*/$parcel$interopDefault($6l6Xk)))(()=>{
            listener.unsubscribe();
        });
    };
    const cleanup = ()=>{
        listeners.forEach(({ unsubscribe: unsubscribe })=>{
            unsubscribe();
        });
        cleaned = true;
        listeners = [];
    };
    return {
        get length () {
            return history.length;
        },
        get location () {
            return history.location;
        },
        get action () {
            return history.action;
        },
        get index () {
            return history.index;
        },
        get entries () {
            return history.entries;
        },
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        push: (path, state)=>history.push(path, state),
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        replace: (path, state)=>history.replace(path, state),
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        go: (n)=>history.go(n),
        goBack: ()=>history.goBack(),
        goForward: ()=>history.goForward(),
        // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
        createHref: (...args)=>history.createHref(...args),
        // Memory only
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        canGo: (n)=>{
            if (history.canGo) return history.canGo(n);
            return true;
        },
        listen: listen,
        // @ts-expect-error - TS7006 - Parameter 'blocker' implicitly has an 'any' type.
        block: (blocker)=>history.block(blocker),
        destroy: cleanup
    };
};

});


parcelRegister("eAV6h", function(module, exports) {

$parcel$export(module.exports, "emceePageLoad", () => $d1eaa51ee0db4300$export$1d745d5d3c2fff45);

var $1yUUI = parcelRequire("1yUUI");
const $d1eaa51ee0db4300$export$1d745d5d3c2fff45 = (0, $1yUUI.metrics).pageLoad({
    key: 'embedded-marketplace'
});

});



//# sourceMappingURL=async-marketplace.a1ffab4e.js.map
